
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5fe6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5fe6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.1";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");


/**
 * Default implementation of insertion factory. Inserts styles only once per renderer and performs
 * insertion immediately after styles computation.
 *
 * @internal
 */ const $7b009f341ccf321a$export$3509cd6597590fb4 = ()=>{
    const insertionCache = {};
    return function insertStyles(renderer, cssRules) {
        if (insertionCache[renderer.id] === undefined) {
            renderer.insertCSSRules(cssRules);
            insertionCache[renderer.id] = true;
        }
    };
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


/**
 * Takes an array of [keyValue1, keyValue2] pairs and creates an object of {keyValue1: keyValue2, keyValue2: keyValue1}
 * @param {Array} array the array of pairs
 * @return {Object} the {key, value} pair object
 */ function $8124ab978dad7f97$export$2d1720544b23b823(array) {
    return array.reduce(function(obj, _ref) {
        var prop1 = _ref[0], prop2 = _ref[1];
        obj[prop1] = prop2;
        obj[prop2] = prop1;
        return obj;
    }, {});
}
function $8124ab978dad7f97$export$7ccc53e8f1e7dfc5(val) {
    return typeof val === 'boolean';
}
function $8124ab978dad7f97$export$ae1af26003f05816(val) {
    return typeof val === 'function';
}
function $8124ab978dad7f97$export$9e5f44173e64f162(val) {
    return typeof val === 'number';
}
function $8124ab978dad7f97$export$43caf9889c228507(val) {
    return val === null || typeof val === 'undefined';
}
function $8124ab978dad7f97$export$2408f22a0fab9ae5(val) {
    return val && typeof val === 'object';
}
function $8124ab978dad7f97$export$625550452a3fa3ec(val) {
    return typeof val === 'string';
}
function $8124ab978dad7f97$export$953cecd6e717a553(inclusive, inclusee) {
    return inclusive.indexOf(inclusee) !== -1;
}
/**
 * Flip the sign of a CSS value, possibly with a unit.
 *
 * We can't just negate the value with unary minus due to the units.
 *
 * @private
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example -77%)
 */ function $8124ab978dad7f97$export$342063e11d6c3cad(value) {
    if (parseFloat(value) === 0) // Don't mangle zeroes
    return value;
    if (value[0] === '-') return value.slice(1);
    return "-" + value;
}
function $8124ab978dad7f97$export$35e795649ee09318(match, prefix, offset, suffix) {
    return prefix + $8124ab978dad7f97$export$342063e11d6c3cad(offset) + suffix;
}
/**
 * Takes a percentage for background position and inverts it.
 * This was copied and modified from CSSJanus:
 * https://github.com/cssjanus/cssjanus/blob/4245f834365f6cfb0239191a151432fb85abab23/src/cssjanus.js#L152-L175
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example 23%)
 */ function $8124ab978dad7f97$export$dda1d9f60106f0e9(value) {
    var idx = value.indexOf('.');
    if (idx === -1) value = 100 - parseFloat(value) + "%";
    else {
        // Two off, one for the "%" at the end, one for the dot itself
        var len = value.length - idx - 2;
        value = 100 - parseFloat(value);
        value = value.toFixed(len) + "%";
    }
    return value;
}
/**
 * This takes a list of CSS values and converts it to an array
 * @param {String} value - something like `1px`, `1px 2em`, or `3pt rgb(150, 230, 550) 40px calc(100% - 5px)`
 * @return {Array} the split values (for example: `['3pt', 'rgb(150, 230, 550)', '40px', 'calc(100% - 5px)']`)
 */ function $8124ab978dad7f97$export$3b14a55fb2447963(value) {
    return value.replace(/ +/g, ' ') // remove all extraneous spaces
    .split(' ').map(function(i) {
        return i.trim();
    }) // get rid of extra space before/after each item
    .filter(Boolean) // get rid of empty strings
    // join items which are within parenthese
    // luckily `calc (100% - 5px)` is invalid syntax and it must be `calc(100% - 5px)`, otherwise this would be even more complex
    .reduce(function(_ref2, item) {
        var list = _ref2.list, state = _ref2.state;
        var openParansCount = (item.match(/\(/g) || []).length;
        var closedParansCount = (item.match(/\)/g) || []).length;
        if (state.parensDepth > 0) list[list.length - 1] = list[list.length - 1] + " " + item;
        else list.push(item);
        state.parensDepth += openParansCount - closedParansCount;
        return {
            list: list,
            state: state
        };
    }, {
        list: [],
        state: {
            parensDepth: 0
        }
    }).list;
}
/**
 * This is intended for properties that are `top right bottom left` and will switch them to `top left bottom right`
 * @param {String} value - `1px 2px 3px 4px` for example, but also handles cases where there are too few/too many and
 * simply returns the value in those cases (which is the correct behavior)
 * @return {String} the result - `1px 4px 3px 2px` for example.
 */ function $8124ab978dad7f97$export$882b5998b3b9117c(value) {
    var splitValues = $8124ab978dad7f97$export$3b14a55fb2447963(value);
    if (splitValues.length <= 3 || splitValues.length > 4) return value;
    var top = splitValues[0], right = splitValues[1], bottom = splitValues[2], left = splitValues[3];
    return [
        top,
        left,
        bottom,
        right
    ].join(' ');
}
/**
 *
 * @param {String|Number|Object} value css property value to test
 * @returns If the css property value can(should?) have an RTL equivalent
 */ function $8124ab978dad7f97$export$23f2a1d2818174ef(value) {
    return !$8124ab978dad7f97$export$7ccc53e8f1e7dfc5(value) && !$8124ab978dad7f97$export$43caf9889c228507(value);
}
/**
 * Splits a shadow style into its separate shadows using the comma delimiter, but creating an exception
 * for comma separated values in parentheses often used for rgba colours.
 * @param {String} value
 * @returns {Array} array of all box shadow values in the string
 */ function $8124ab978dad7f97$export$efccba1c4a2ef57b(value) {
    var shadows = [];
    var start = 0;
    var end = 0;
    var rgba = false;
    while(end < value.length){
        if (!rgba && value[end] === ',') {
            shadows.push(value.substring(start, end).trim());
            end++;
            start = end;
        } else if (value[end] === "(") {
            rgba = true;
            end++;
        } else if (value[end] === ')') {
            rgba = false;
            end++;
        } else end++;
    }
    // push the last shadow value if there is one
    // istanbul ignore next
    if (start != end) shadows.push(value.substring(start, end + 1));
    return shadows;
}
// some values require a little fudging, that fudging goes here.
var $8124ab978dad7f97$export$ffb5f4729a158638 = {
    padding: function padding(_ref) {
        var value = _ref.value;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        return $8124ab978dad7f97$export$882b5998b3b9117c(value);
    },
    textShadow: function textShadow(_ref2) {
        var value = _ref2.value;
        var flippedShadows = $8124ab978dad7f97$export$efccba1c4a2ef57b(value).map(function(shadow) {
            // intentionally leaving off the `g` flag here because we only want to change the first number (which is the offset-x)
            return shadow.replace(/(^|\s)(-*)([.|\d]+)/, function(match, whiteSpace, negative, number) {
                if (number === '0') return match;
                var doubleNegative = negative === '' ? '-' : '';
                return "" + whiteSpace + doubleNegative + number;
            });
        });
        return flippedShadows.join(',');
    },
    borderColor: function borderColor(_ref3) {
        var value = _ref3.value;
        return $8124ab978dad7f97$export$882b5998b3b9117c(value);
    },
    borderRadius: function borderRadius(_ref4) {
        var value = _ref4.value;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        if ($8124ab978dad7f97$export$953cecd6e717a553(value, '/')) {
            var _value$split = value.split('/'), radius1 = _value$split[0], radius2 = _value$split[1];
            var convertedRadius1 = $8124ab978dad7f97$export$ffb5f4729a158638.borderRadius({
                value: radius1.trim()
            });
            var convertedRadius2 = $8124ab978dad7f97$export$ffb5f4729a158638.borderRadius({
                value: radius2.trim()
            });
            return convertedRadius1 + " / " + convertedRadius2;
        }
        var splitValues = $8124ab978dad7f97$export$3b14a55fb2447963(value);
        switch(splitValues.length){
            case 2:
                return splitValues.reverse().join(' ');
            case 4:
                var topLeft = splitValues[0], topRight = splitValues[1], bottomRight = splitValues[2], bottomLeft = splitValues[3];
                return [
                    topRight,
                    topLeft,
                    bottomLeft,
                    bottomRight
                ].join(' ');
            default:
                return value;
        }
    },
    background: function background(_ref5) {
        var value = _ref5.value, valuesToConvert = _ref5.valuesToConvert, isRtl = _ref5.isRtl, bgImgDirectionRegex = _ref5.bgImgDirectionRegex, bgPosDirectionRegex = _ref5.bgPosDirectionRegex;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        // Yeah, this is in need of a refactor 🙃...
        // but this property is a tough cookie 🍪
        // get the backgroundPosition out of the string by removing everything that couldn't be the backgroundPosition value
        var backgroundPositionValue = value.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g, '').trim();
        // replace that backgroundPosition value with the converted version
        value = value.replace(backgroundPositionValue, $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition({
            value: backgroundPositionValue,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        }));
        // do the backgroundImage value replacing on the whole value (because why not?)
        return $8124ab978dad7f97$export$ffb5f4729a158638.backgroundImage({
            value: value,
            valuesToConvert: valuesToConvert,
            bgImgDirectionRegex: bgImgDirectionRegex
        });
    },
    backgroundImage: function backgroundImage(_ref6) {
        var value = _ref6.value, valuesToConvert = _ref6.valuesToConvert, bgImgDirectionRegex = _ref6.bgImgDirectionRegex;
        if (!$8124ab978dad7f97$export$953cecd6e717a553(value, 'url(') && !$8124ab978dad7f97$export$953cecd6e717a553(value, 'linear-gradient(')) return value;
        return value.replace(bgImgDirectionRegex, function(match, g1, group2) {
            return match.replace(group2, valuesToConvert[group2]);
        });
    },
    backgroundPosition: function backgroundPosition(_ref7) {
        var value = _ref7.value, valuesToConvert = _ref7.valuesToConvert, isRtl = _ref7.isRtl, bgPosDirectionRegex = _ref7.bgPosDirectionRegex;
        return value// intentionally only grabbing the first instance of this because that represents `left`
        .replace(isRtl ? /^((-|\d|\.)+%)/ : null, function(match, group) {
            return $8124ab978dad7f97$export$dda1d9f60106f0e9(group);
        }).replace(bgPosDirectionRegex, function(match) {
            return valuesToConvert[match];
        });
    },
    backgroundPositionX: function backgroundPositionX(_ref8) {
        var value = _ref8.value, valuesToConvert = _ref8.valuesToConvert, isRtl = _ref8.isRtl, bgPosDirectionRegex = _ref8.bgPosDirectionRegex;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        return $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition({
            value: value,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        });
    },
    transition: function transition(_ref9) {
        var value = _ref9.value, propertiesToConvert = _ref9.propertiesToConvert;
        return value.split(/,\s*/g).map(function(transition) {
            var values = transition.split(' ');
            // Property is always defined first
            values[0] = propertiesToConvert[values[0]] || values[0];
            return values.join(' ');
        }).join(', ');
    },
    transitionProperty: function transitionProperty(_ref10) {
        var value = _ref10.value, propertiesToConvert = _ref10.propertiesToConvert;
        return value.split(/,\s*/g).map(function(prop) {
            return propertiesToConvert[prop] || prop;
        }).join(', ');
    },
    transform: function transform(_ref11) {
        var value = _ref11.value;
        // This was copied and modified from CSSJanus:
        // https://github.com/cssjanus/cssjanus/blob/4a40f001b1ba35567112d8b8e1d9d95eda4234c3/src/cssjanus.js#L152-L153
        var nonAsciiPattern = "[^\\u0020-\\u007e]";
        var escapePattern = "(?:(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)|\\\\[^\\r\\n\\f0-9a-f])";
        var signedQuantPattern = "((?:-?" + ("(?:[0-9]*\\.[0-9]+|[0-9]+)(?:\\s*(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)|" + ("-?" + ("(?:[_a-z]|" + nonAsciiPattern + "|" + escapePattern + ")") + ("(?:[_a-z0-9-]|" + nonAsciiPattern + "|" + escapePattern + ")") + "*") + ")?") + ")|(?:inherit|auto))";
        var translateXRegExp = new RegExp("(translateX\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", 'gi');
        var translateRegExp = new RegExp("(translate\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,1}\\s*\\))", 'gi');
        var translate3dRegExp = new RegExp("(translate3d\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,2}\\s*\\))", 'gi');
        var rotateRegExp = new RegExp("(rotate[ZY]?\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", 'gi');
        return value.replace(translateXRegExp, $8124ab978dad7f97$export$35e795649ee09318).replace(translateRegExp, $8124ab978dad7f97$export$35e795649ee09318).replace(translate3dRegExp, $8124ab978dad7f97$export$35e795649ee09318).replace(rotateRegExp, $8124ab978dad7f97$export$35e795649ee09318);
    }
};
$8124ab978dad7f97$export$ffb5f4729a158638.objectPosition = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition;
$8124ab978dad7f97$export$ffb5f4729a158638.margin = $8124ab978dad7f97$export$ffb5f4729a158638.padding;
$8124ab978dad7f97$export$ffb5f4729a158638.borderWidth = $8124ab978dad7f97$export$ffb5f4729a158638.padding;
$8124ab978dad7f97$export$ffb5f4729a158638.boxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.mozBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.MozBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.borderStyle = $8124ab978dad7f97$export$ffb5f4729a158638.borderColor;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
// kebab-case versions
$8124ab978dad7f97$export$ffb5f4729a158638['text-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['border-color'] = $8124ab978dad7f97$export$ffb5f4729a158638.borderColor;
$8124ab978dad7f97$export$ffb5f4729a158638['border-radius'] = $8124ab978dad7f97$export$ffb5f4729a158638.borderRadius;
$8124ab978dad7f97$export$ffb5f4729a158638['background-image'] = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundImage;
$8124ab978dad7f97$export$ffb5f4729a158638['background-position'] = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition;
$8124ab978dad7f97$export$ffb5f4729a158638['background-position-x'] = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPositionX;
$8124ab978dad7f97$export$ffb5f4729a158638['object-position'] = $8124ab978dad7f97$export$ffb5f4729a158638.objectPosition;
$8124ab978dad7f97$export$ffb5f4729a158638['border-width'] = $8124ab978dad7f97$export$ffb5f4729a158638.padding;
$8124ab978dad7f97$export$ffb5f4729a158638['box-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-box-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-box-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['border-style'] = $8124ab978dad7f97$export$ffb5f4729a158638.borderColor;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transform'] = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transform'] = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638['transform-origin'] = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transform-origin'] = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transform-origin'] = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transition'] = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transition'] = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638['transition-property'] = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transition-property'] = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transition-property'] = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
// this will be an object of properties that map to their corresponding rtl property (their doppelganger)
var $8124ab978dad7f97$export$407448d2b89b1813 = $8124ab978dad7f97$export$2d1720544b23b823([
    [
        'paddingLeft',
        'paddingRight'
    ],
    [
        'marginLeft',
        'marginRight'
    ],
    [
        'left',
        'right'
    ],
    [
        'borderLeft',
        'borderRight'
    ],
    [
        'borderLeftColor',
        'borderRightColor'
    ],
    [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    [
        'borderTopLeftRadius',
        'borderTopRightRadius'
    ],
    [
        'borderBottomLeftRadius',
        'borderBottomRightRadius'
    ],
    // kebab-case versions
    [
        'padding-left',
        'padding-right'
    ],
    [
        'margin-left',
        'margin-right'
    ],
    [
        'border-left',
        'border-right'
    ],
    [
        'border-left-color',
        'border-right-color'
    ],
    [
        'border-left-style',
        'border-right-style'
    ],
    [
        'border-left-width',
        'border-right-width'
    ],
    [
        'border-top-left-radius',
        'border-top-right-radius'
    ],
    [
        'border-bottom-left-radius',
        'border-bottom-right-radius'
    ]
]);
var $8124ab978dad7f97$export$8b22cf2602fb60ce = [
    'content'
];
// this is the same as the propertiesToConvert except for values
var $8124ab978dad7f97$export$90a7f3efeed30595 = $8124ab978dad7f97$export$2d1720544b23b823([
    [
        'ltr',
        'rtl'
    ],
    [
        'left',
        'right'
    ],
    [
        'w-resize',
        'e-resize'
    ],
    [
        'sw-resize',
        'se-resize'
    ],
    [
        'nw-resize',
        'ne-resize'
    ]
]);
// Sorry for the regex 😞, but basically thisis used to replace _every_ instance of
// `ltr`, `rtl`, `right`, and `left` in `backgroundimage` with the corresponding opposite.
// A situation we're accepting here:
// url('/left/right/rtl/ltr.png') will be changed to url('/right/left/ltr/rtl.png')
// Definite trade-offs here, but I think it's a good call.
var $8124ab978dad7f97$var$bgImgDirectionRegex = new RegExp('(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)', 'g');
var $8124ab978dad7f97$var$bgPosDirectionRegex = new RegExp('(left)|(right)');
/**
 * converts properties and values in the CSS in JS object to their corresponding RTL values
 * @param {Object} object the CSS in JS object
 * @return {Object} the RTL converted object
 */ function $8124ab978dad7f97$export$db3b6bfb95261072(object) {
    return Object.keys(object).reduce(function(newObj, originalKey) {
        var originalValue = object[originalKey];
        if ($8124ab978dad7f97$export$625550452a3fa3ec(originalValue)) // you're welcome to later code 😺
        originalValue = originalValue.trim();
        // Some properties should never be transformed
        if ($8124ab978dad7f97$export$953cecd6e717a553($8124ab978dad7f97$export$8b22cf2602fb60ce, originalKey)) {
            newObj[originalKey] = originalValue;
            return newObj;
        }
        var _convertProperty = $8124ab978dad7f97$export$4368d992c4eafac0(originalKey, originalValue), key = _convertProperty.key, value = _convertProperty.value;
        newObj[key] = value;
        return newObj;
    }, Array.isArray(object) ? [] : {});
}
/**
 * Converts a property and its value to the corresponding RTL key and value
 * @param {String} originalKey the original property key
 * @param {Number|String|Object} originalValue the original css property value
 * @return {Object} the new {key, value} pair
 */ function $8124ab978dad7f97$export$4368d992c4eafac0(originalKey, originalValue) {
    var isNoFlip = /\/\*\s?@noflip\s?\*\//.test(originalValue);
    var key = isNoFlip ? originalKey : $8124ab978dad7f97$export$39b482c5e57630a8(originalKey);
    var value = isNoFlip ? originalValue : $8124ab978dad7f97$export$f1e1789686576879(key, originalValue);
    return {
        key: key,
        value: value
    };
}
/**
 * This gets the RTL version of the given property if it has a corresponding RTL property
 * @param {String} property the name of the property
 * @return {String} the name of the RTL property
 */ function $8124ab978dad7f97$export$39b482c5e57630a8(property) {
    return $8124ab978dad7f97$export$407448d2b89b1813[property] || property;
}
/**
 * This converts the given value to the RTL version of that value based on the key
 * @param {String} key this is the key (note: this should be the RTL version of the originalKey)
 * @param {String|Number|Object} originalValue the original css property value. If it's an object, then we'll convert that as well
 * @return {String|Number|Object} the converted value
 */ function $8124ab978dad7f97$export$f1e1789686576879(key, originalValue) {
    if (!$8124ab978dad7f97$export$23f2a1d2818174ef(originalValue)) return originalValue;
    if ($8124ab978dad7f97$export$2408f22a0fab9ae5(originalValue)) return $8124ab978dad7f97$export$db3b6bfb95261072(originalValue); // recursion 🌀
    var isNum = $8124ab978dad7f97$export$9e5f44173e64f162(originalValue);
    var isFunc = $8124ab978dad7f97$export$ae1af26003f05816(originalValue);
    var importantlessValue = isNum || isFunc ? originalValue : originalValue.replace(/ !important.*?$/, '');
    var isImportant = !isNum && importantlessValue.length !== originalValue.length;
    var valueConverter = $8124ab978dad7f97$export$ffb5f4729a158638[key];
    var newValue;
    if (valueConverter) newValue = valueConverter({
        value: importantlessValue,
        valuesToConvert: $8124ab978dad7f97$export$90a7f3efeed30595,
        propertiesToConvert: $8124ab978dad7f97$export$407448d2b89b1813,
        isRtl: true,
        bgImgDirectionRegex: $8124ab978dad7f97$var$bgImgDirectionRegex,
        bgPosDirectionRegex: $8124ab978dad7f97$var$bgPosDirectionRegex
    });
    else newValue = $8124ab978dad7f97$export$90a7f3efeed30595[importantlessValue] || importantlessValue;
    if (isImportant) return newValue + " !important";
    return newValue;
}




// ----
// Heads up!
// These constants are global and will be shared between Griffel instances.
// Any change in them should happen only in a MAJOR version. If it happens,
// please change "__NAMESPACE_PREFIX__" to include a version.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d87c946ff7108f65$var$__GLOBAL__ = typeof window === 'undefined' ? $parcel$global : window;
const $d87c946ff7108f65$var$__NAMESPACE_PREFIX__ = '@griffel/';
function $d87c946ff7108f65$var$getGlobalVar(name, defaultValue) {
    if (!$d87c946ff7108f65$var$__GLOBAL__[Symbol.for($d87c946ff7108f65$var$__NAMESPACE_PREFIX__ + name)]) $d87c946ff7108f65$var$__GLOBAL__[Symbol.for($d87c946ff7108f65$var$__NAMESPACE_PREFIX__ + name)] = defaultValue;
    return $d87c946ff7108f65$var$__GLOBAL__[Symbol.for($d87c946ff7108f65$var$__NAMESPACE_PREFIX__ + name)];
}
const $d87c946ff7108f65$export$ce70c9e4412946f3 = /*#__PURE__*/ $d87c946ff7108f65$var$getGlobalVar('DEBUG_RESET_CLASSES', {});
const $d87c946ff7108f65$export$ac80cc81fdb4fb5a = /*#__PURE__*/ $d87c946ff7108f65$var$getGlobalVar('DEFINITION_LOOKUP_TABLE', {});
const $d87c946ff7108f65$export$1c1323cd9bbf9636 = 'data-make-styles-bucket';
const $d87c946ff7108f65$export$4942e61c5aa6baa3 = 'data-priority';
const $d87c946ff7108f65$export$5cce92c11780587a = 'data-container';
const $d87c946ff7108f65$export$fdd4f86041cc97c0 = 'f';
const $d87c946ff7108f65$export$a884bacb1a8eabe4 = 'r';
const $d87c946ff7108f65$export$92d383cc43013b89 = 7;
const $d87c946ff7108f65$export$ed60e64637dbffef = '___';
const $d87c946ff7108f65$export$99329b40e7077cf7 = '_';
const $d87c946ff7108f65$export$dcee98f0f975aca0 = $d87c946ff7108f65$export$ed60e64637dbffef.length + $d87c946ff7108f65$export$92d383cc43013b89;
const $d87c946ff7108f65$export$ac331484967b91fa = 0;
const $d87c946ff7108f65$export$d20107152a904e34 = 1;
const $d87c946ff7108f65$export$77c0d61648307b86 = {
    all: 1,
    borderColor: 1,
    borderStyle: 1,
    borderWidth: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockStart: 1,
    borderInline: 1,
    borderInlineEnd: 1,
    borderInlineStart: 1
};
const $d87c946ff7108f65$export$4a991c87e640ef77 = 'DO_NOT_USE_DIRECTLY: @griffel/reset-value';


var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';
var $e853ac0080e24cb4$export$d773506282b3cfe6 = '@layer';
var $e853ac0080e24cb4$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $5e4f012072913cb4$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern);
    });
}



var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$590e8b2c435046d9(root) {
    while(root.root)root = $f4f4fca9115ed8bd$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(root, root.siblings);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}


function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var parens = 0;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) parens++, characters += '(';
            else characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // )
        case 41:
            parens--, characters += ')';
            break;
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            if (parens > 0) {
                characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
                break;
            }
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) && (0, $5e4f012072913cb4$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            if (parens > 0 && character) {
                characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
                break;
            }
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length || variable === 0)) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    if (parens > 0) break;
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$6aad947bda0f3f46:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return '';
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            if (!(0, $5e4f012072913cb4$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // mask-composite
        case 4855:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /space-between/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, 'span') ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $5e4f012072913cb4$export$e6e34fd1f2686227)(element, {
                                props: (0, $5e4f012072913cb4$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $5e4f012072913cb4$export$e6e34fd1f2686227)(element, {
                                props: (0, $5e4f012072913cb4$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}



const $ab718c29fba37d65$export$4b797d4a552868c4 = (element)=>{
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            if (typeof element.props === 'string') return;
            element.props = element.props.map((value)=>{
                // Avoids calling tokenize() on every string
                if (value.indexOf(':global(') === -1) return value;
                return (0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value).reduce((acc, value, index, children)=>{
                    if (value === '') return acc;
                    if (value === ':' && children[index + 1] === 'global') {
                        const selector = // An inner part of ":global()"
                        children[index + 2].slice(1, -1) + // A separator between selectors i.e. "body .class"
                        ' ';
                        acc.unshift(selector);
                        children[index + 1] = '';
                        children[index + 2] = '';
                        return acc;
                    }
                    acc.push(value);
                    return acc;
                }, []).join('');
            });
    }
};


/* eslint-disable no-fallthrough */ 
function $95951d7d1e57fc59$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // backface-visibility, column, box-decoration-break
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // backdrop-filter, background-clip: text
        case 4215:
            // Additional check on "backdrop-(f)ilter" to prevent conflict with "background-clip"
            // https://github.com/thysultan/stylis/issues/292
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 9) === 102) return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
            // background-clip: text
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1) === 116) return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
            break;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, hyphens
        case 5349:
        case 4246:
        case 6968:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // cursor
        // @ts-expect-error fall through is intentional here
        case 6187:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /grab/)) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            // eslint-disable-next-line no-useless-concat
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (f)ill-available
                // @ts-expect-error fall through is intentional here
                case 102:
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) === 108) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, // eslint-disable-next-line no-useless-concat, eqeqeq
                    '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $95951d7d1e57fc59$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
    }
    return value;
}
function $95951d7d1e57fc59$export$b37893ebcaedd06f(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = $95951d7d1e57fc59$export$82e9f45cca5ba907(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            [
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
    return undefined;
}



function $f5be9cb06692ef1d$export$300e9014dd2d454e(element) {
    switch(element.type){
        case '@container':
        case 0, $e853ac0080e24cb4$export$500415a86c544f73:
        case 0, $e853ac0080e24cb4$export$9447a5efea57e862:
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            return true;
    }
    return false;
}


const $94374a8228902c10$export$6b44e6671983a6cc = (element)=>{
    if ((0, $f5be9cb06692ef1d$export$300e9014dd2d454e)(element) && Array.isArray(element.children)) element.children.sort((a, b)=>a.props[0] > b.props[0] ? 1 : -1);
};


// eslint-disable-next-line @typescript-eslint/no-empty-function
function $3274d05cc9c47b0d$var$noop() {}
function $3274d05cc9c47b0d$export$82c0c9be22f7de4(cssRules, sortClassesInAtRules) {
    const rules = [];
    (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(cssRules), (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)([
        (0, $ab718c29fba37d65$export$4b797d4a552868c4),
        sortClassesInAtRules ? (0, $94374a8228902c10$export$6b44e6671983a6cc) : $3274d05cc9c47b0d$var$noop,
        (0, $95951d7d1e57fc59$export$b37893ebcaedd06f),
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        // 💡 we are using `.insertRule()` API for DOM operations, which does not support
        // insertion of multiple CSS rules in a single call. `rulesheet` plugin extracts
        // individual rules to be used with this API
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)((rule)=>rules.push(rule))
    ]));
    return rules;
}


const $b1f9beea3a5efc9d$var$uppercasePattern = /[A-Z]/g;
const $b1f9beea3a5efc9d$var$msPattern = /^ms-/;
const $b1f9beea3a5efc9d$var$cache = {};
function $b1f9beea3a5efc9d$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $b1f9beea3a5efc9d$export$b018cf9acdc350de(name) {
    if (Object.prototype.hasOwnProperty.call($b1f9beea3a5efc9d$var$cache, name)) return $b1f9beea3a5efc9d$var$cache[name];
    if (name.substr(0, 2) === '--') return name;
    const hName = name.replace($b1f9beea3a5efc9d$var$uppercasePattern, $b1f9beea3a5efc9d$var$toHyphenLower);
    return $b1f9beea3a5efc9d$var$cache[name] = $b1f9beea3a5efc9d$var$msPattern.test(hName) ? '-' + hName : hName;
}


function $ccf6acadf2e791ca$export$bdc4d18748ef5f7c(nestedProperty) {
    if (nestedProperty.charAt(0) === '&') return nestedProperty.slice(1);
    return nestedProperty;
}


const $30e93e010d2d8154$var$PSEUDO_SELECTOR_REGEX = /,( *[^ &])/g;
function $30e93e010d2d8154$export$db1b8f954c59ac44(pseudoSelector) {
    return '&' + (0, $ccf6acadf2e791ca$export$bdc4d18748ef5f7c)(// Regex there replaces a comma, spaces and an ampersand if it's present with comma and an ampersand.
    // This allows to normalize input, see examples in JSDoc.
    pseudoSelector.replace($30e93e010d2d8154$var$PSEUDO_SELECTOR_REGEX, ',&$1'));
}
function $30e93e010d2d8154$var$createCSSDeclaration(cssDeclaration, pseudos) {
    return pseudos.reduceRight((acc, selector)=>`${$30e93e010d2d8154$export$db1b8f954c59ac44(selector)} { ${acc} }`, cssDeclaration);
}
function $30e93e010d2d8154$export$33a9e446f13f0fb6(options, atRules) {
    const { className: className, selectors: selectors, property: property, rtlClassName: rtlClassName, rtlProperty: rtlProperty, rtlValue: rtlValue, value: value } = options;
    const { container: container, layer: layer, media: media, scope: scope, supports: supports } = atRules;
    const classNameSelector = `.${className}`;
    const cssDeclaration = Array.isArray(value) ? `${value.map((v)=>`${(0, $b1f9beea3a5efc9d$export$b018cf9acdc350de)(property)}: ${v}`).join(';')};` : `${(0, $b1f9beea3a5efc9d$export$b018cf9acdc350de)(property)}: ${value};`;
    // Under @scope, the rule body is anchored on :scope (the spec-defined
    // alias for the scope root set via the (.className) prelude). @scope
    // wraps innermost so outer at-rules (@media, @supports, etc.) compose
    // around it. Separate blocks for LTR and RTL because the prelude
    // references the direction-specific atomic class.
    const ltrBody = $30e93e010d2d8154$var$createCSSDeclaration(cssDeclaration, selectors);
    let cssRule = scope ? `@scope (${classNameSelector}) ${scope} { :scope{${ltrBody}} }` : `${classNameSelector}{${ltrBody}}`;
    if (rtlProperty && rtlClassName) {
        const rtlClassNameSelector = `.${rtlClassName}`;
        const rtlCSSDeclaration = Array.isArray(rtlValue) ? `${rtlValue.map((v)=>`${(0, $b1f9beea3a5efc9d$export$b018cf9acdc350de)(rtlProperty)}: ${v}`).join(';')};` : `${(0, $b1f9beea3a5efc9d$export$b018cf9acdc350de)(rtlProperty)}: ${rtlValue};`;
        const rtlBody = $30e93e010d2d8154$var$createCSSDeclaration(rtlCSSDeclaration, selectors);
        cssRule += scope ? `@scope (${rtlClassNameSelector}) ${scope} { :scope{${rtlBody}} }` : `${rtlClassNameSelector}{${rtlBody}}`;
    }
    if (media) cssRule = `@media ${media} { ${cssRule} }`;
    if (layer) cssRule = `@layer ${layer} { ${cssRule} }`;
    if (supports) cssRule = `@supports ${supports} { ${cssRule} }`;
    if (container) cssRule = `@container ${container} { ${cssRule} }`;
    return (0, $3274d05cc9c47b0d$export$82c0c9be22f7de4)(cssRule, true);
}





function $8421d54b625326b7$export$38e49227307c669b(style) {
    let css = '';
    // eslint-disable-next-line guard-for-in
    for(const property in style){
        const value = style[property];
        if (typeof value === 'string' || typeof value === 'number') {
            css += (0, $b1f9beea3a5efc9d$export$b018cf9acdc350de)(property) + ':' + value + ';';
            continue;
        }
        if (Array.isArray(value)) for (const arrValue of value)css += (0, $b1f9beea3a5efc9d$export$b018cf9acdc350de)(property) + ':' + arrValue + ';';
    }
    return css;
}


function $a8e2796ee9b0db17$export$f063294709aee23a(keyframeObject) {
    let css = '';
    // eslint-disable-next-line guard-for-in
    for(const percentage in keyframeObject)css += `${percentage}{${(0, $8421d54b625326b7$export$38e49227307c669b)(keyframeObject[percentage])}}`;
    return css;
}
function $a8e2796ee9b0db17$export$50cb7050c6244400(keyframeName, keyframeCSS) {
    const cssRule = `@keyframes ${keyframeName} {${keyframeCSS}}`;
    const rules = [];
    (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(cssRule), (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)([
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        (0, $95951d7d1e57fc59$export$b37893ebcaedd06f),
        // 💡 we are using `.insertRule()` API for DOM operations, which does not support
        // insertion of multiple CSS rules in a single call. `rulesheet` plugin extracts
        // individual rules to be used with this API
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)((rule)=>rules.push(rule))
    ]));
    return rules;
}


/**
 * Maps the long pseudo name to the short pseudo name. Pseudos that match here will be ordered, everything else will
 * make their way to default style bucket. We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const $e6973270afa688ac$var$pseudosMap = {
    // :focus-within
    'us-w': 'w',
    // :focus-visible
    'us-v': 'i',
    // :link
    nk: 'l',
    // :visited
    si: 'v',
    // :focus
    cu: 'f',
    // :hover
    ve: 'h',
    // :active
    ti: 'a'
};
function $e6973270afa688ac$export$d90f6836ea1aee93(selectors, atRules) {
    if (atRules.media) return 'm';
    // We are grouping all the at-rules like @supports etc. under `t` bucket.
    if (atRules.layer || atRules.supports) return 't';
    if (atRules.container) return 'x';
    if (selectors.length > 0) {
        const normalizedPseudo = selectors[0].trim();
        if (normalizedPseudo.charCodeAt(0) === 58 /* ":" */ ) // We send through a subset of the string instead of the full pseudo name.
        // For example:
        // - `"focus-visible"` name would instead of `"us-v"`.
        // - `"focus"` name would instead of `"us"`.
        // Return a mapped pseudo else default bucket.
        return $e6973270afa688ac$var$pseudosMap[normalizedPseudo.slice(4, 8)] || $e6973270afa688ac$var$pseudosMap[normalizedPseudo.slice(3, 5)] || 'd';
    }
    // Return default bucket
    return 'd';
}


const $81b2d8d736993385$export$648f2124b45d7105 = {
    animation: [
        -1,
        [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimeline',
            'animationTimingFunction'
        ]
    ],
    animationRange: [
        -1,
        [
            'animationRangeEnd',
            'animationRangeStart'
        ]
    ],
    background: [
        -2,
        [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPosition',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ]
    ],
    backgroundPosition: [
        -1,
        [
            'backgroundPositionX',
            'backgroundPositionY'
        ]
    ],
    border: [
        -2,
        [
            'borderBottom',
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderLeft',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRight',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTop',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ]
    ],
    borderBottom: [
        -1,
        [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ]
    ],
    borderImage: [
        -1,
        [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ]
    ],
    borderLeft: [
        -1,
        [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ]
    ],
    borderRadius: [
        -1,
        [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ]
    ],
    borderRight: [
        -1,
        [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ]
    ],
    borderTop: [
        -1,
        [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ]
    ],
    caret: [
        -1,
        [
            'caretColor',
            'caretShape'
        ]
    ],
    columnRule: [
        -1,
        [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ]
    ],
    columns: [
        -1,
        [
            'columnCount',
            'columnWidth'
        ]
    ],
    containIntrinsicSize: [
        -1,
        [
            'containIntrinsicHeight',
            'containIntrinsicWidth'
        ]
    ],
    container: [
        -1,
        [
            'containerName',
            'containerType'
        ]
    ],
    flex: [
        -1,
        [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ]
    ],
    flexFlow: [
        -1,
        [
            'flexDirection',
            'flexWrap'
        ]
    ],
    font: [
        -1,
        [
            'fontFamily',
            'fontSize',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontWeight',
            'lineHeight'
        ]
    ],
    gap: [
        -1,
        [
            'columnGap',
            'rowGap'
        ]
    ],
    grid: [
        -1,
        [
            'columnGap',
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridColumnGap',
            'gridRowGap',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows',
            'rowGap'
        ]
    ],
    gridArea: [
        -1,
        [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ]
    ],
    gridColumn: [
        -1,
        [
            'gridColumnEnd',
            'gridColumnStart'
        ]
    ],
    gridRow: [
        -1,
        [
            'gridRowEnd',
            'gridRowStart'
        ]
    ],
    gridTemplate: [
        -1,
        [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ]
    ],
    inset: [
        -1,
        [
            'bottom',
            'left',
            'right',
            'top'
        ]
    ],
    insetBlock: [
        -1,
        [
            'insetBlockEnd',
            'insetBlockStart'
        ]
    ],
    insetInline: [
        -1,
        [
            'insetInlineEnd',
            'insetInlineStart'
        ]
    ],
    listStyle: [
        -1,
        [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ]
    ],
    margin: [
        -1,
        [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ]
    ],
    marginBlock: [
        -1,
        [
            'marginBlockEnd',
            'marginBlockStart'
        ]
    ],
    marginInline: [
        -1,
        [
            'marginInlineEnd',
            'marginInlineStart'
        ]
    ],
    mask: [
        -1,
        [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPosition',
            'maskRepeat',
            'maskSize'
        ]
    ],
    maskBorder: [
        -1,
        [
            'maskBorderMode',
            'maskBorderOutset',
            'maskBorderRepeat',
            'maskBorderSlice',
            'maskBorderSource',
            'maskBorderWidth'
        ]
    ],
    offset: [
        -1,
        [
            'offsetAnchor',
            'offsetDistance',
            'offsetPath',
            'offsetPosition',
            'offsetRotate'
        ]
    ],
    outline: [
        -1,
        [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ]
    ],
    overflow: [
        -1,
        [
            'overflowX',
            'overflowY'
        ]
    ],
    overscrollBehavior: [
        -1,
        [
            'overscrollBehaviorX',
            'overscrollBehaviorY'
        ]
    ],
    padding: [
        -1,
        [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ]
    ],
    paddingBlock: [
        -1,
        [
            'paddingBlockEnd',
            'paddingBlockStart'
        ]
    ],
    paddingInline: [
        -1,
        [
            'paddingInlineEnd',
            'paddingInlineStart'
        ]
    ],
    placeContent: [
        -1,
        [
            'alignContent',
            'justifyContent'
        ]
    ],
    placeItems: [
        -1,
        [
            'alignItems',
            'justifyItems'
        ]
    ],
    placeSelf: [
        -1,
        [
            'alignSelf',
            'justifySelf'
        ]
    ],
    positionTry: [
        -1,
        [
            'positionTryFallbacks',
            'positionTryOrder'
        ]
    ],
    scrollMargin: [
        -1,
        [
            'scrollMarginBottom',
            'scrollMarginLeft',
            'scrollMarginRight',
            'scrollMarginTop'
        ]
    ],
    scrollMarginBlock: [
        -1,
        [
            'scrollMarginBlockEnd',
            'scrollMarginBlockStart'
        ]
    ],
    scrollMarginInline: [
        -1,
        [
            'scrollMarginInlineEnd',
            'scrollMarginInlineStart'
        ]
    ],
    scrollPadding: [
        -1,
        [
            'scrollPaddingBottom',
            'scrollPaddingLeft',
            'scrollPaddingRight',
            'scrollPaddingTop'
        ]
    ],
    scrollPaddingBlock: [
        -1,
        [
            'scrollPaddingBlockEnd',
            'scrollPaddingBlockStart'
        ]
    ],
    scrollPaddingInline: [
        -1,
        [
            'scrollPaddingInlineEnd',
            'scrollPaddingInlineStart'
        ]
    ],
    scrollTimeline: [
        -1,
        [
            'scrollTimelineAxis',
            'scrollTimelineName'
        ]
    ],
    textDecoration: [
        -1,
        [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle',
            'textDecorationThickness'
        ]
    ],
    textEmphasis: [
        -1,
        [
            'textEmphasisColor',
            'textEmphasisStyle'
        ]
    ],
    textWrap: [
        -1,
        [
            'textWrapMode',
            'textWrapStyle'
        ]
    ],
    transition: [
        -1,
        [
            'transitionBehavior',
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ]
    ],
    viewTimeline: [
        -1,
        [
            'viewTimelineAxis',
            'viewTimelineName'
        ]
    ]
};


function $f4014991232ded57$export$9f1ed25614266b04(currentMediaQuery, nestedMediaQuery) {
    if (currentMediaQuery.length === 0) return nestedMediaQuery;
    return `${currentMediaQuery} and ${nestedMediaQuery}`;
}





function $1b65a33a52d2d337$var$addAtRulePrefix(atRule, prefix) {
    return atRule ? prefix + atRule : atRule;
}
function $1b65a33a52d2d337$export$c315e960bf1b31dd(atRules) {
    return $1b65a33a52d2d337$var$addAtRulePrefix(atRules.container, 'c') + $1b65a33a52d2d337$var$addAtRulePrefix(atRules.media, 'm') + $1b65a33a52d2d337$var$addAtRulePrefix(atRules.layer, 'l') + $1b65a33a52d2d337$var$addAtRulePrefix(atRules.supports, 's') + $1b65a33a52d2d337$var$addAtRulePrefix(atRules.scope, 'o');
}
function $1b65a33a52d2d337$export$d78eef92bb01743f(selector, property, atRules) {
    // uniq key based on property & selector, used for merging later
    const computedKey = selector + $1b65a33a52d2d337$export$c315e960bf1b31dd(atRules) + property;
    // "key" can be really long as it includes selectors, we use hashes to reduce sizes of keys
    // ".foo :hover" => "abcd"
    const hashedKey = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(computedKey);
    // As these hashes are used as object keys in build output we should avoid having numbers as a first character to
    // avoid having quotes:
    // {
    //   "1abc": {}, // we don't want this
    //   Aabc: {}, // no quotes
    // }
    const firstCharCode = hashedKey.charCodeAt(0);
    const startsWithNumber = firstCharCode >= 48 && firstCharCode <= 57;
    if (startsWithNumber) return String.fromCharCode(firstCharCode + 17) + hashedKey.slice(1);
    return hashedKey;
}


function $425ea0b822f1c27f$export$2868bfa6c4652df6({ property: property, selector: selector, salt: salt, value: value }, atRules) {
    return (0, $d87c946ff7108f65$export$fdd4f86041cc97c0) + (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(salt + selector + (0, $1b65a33a52d2d337$export$c315e960bf1b31dd)(atRules) + property + // Trimming of value is required to generate consistent hashes
    value.trim());
}



function $6b26a6574dda74e0$export$7648458cb39ca9d9(property) {
    return property.substring(0, 10) === '@container';
}


function $8f1c934dabdd3b98$export$1f8685537590b231(property) {
    return property.substr(0, 6) === '@layer';
}


function $c42ef86ad857e046$export$685119d24577daa(property) {
    return property.substr(0, 6) === '@media';
}


const $7a378c0026b5bfa4$var$regex = /^(:|\[|>|&)/;
function $7a378c0026b5bfa4$export$6ec9da58e818601b(property) {
    return $7a378c0026b5bfa4$var$regex.test(property);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $967afb231003f134$export$a6cdc56e425d0d0a(val) {
    // eslint-disable-next-line eqeqeq
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
}



function $179d1b9c79eefc24$export$6bdeee5c8de376c6(value) {
    return value === (0, $d87c946ff7108f65$export$4a991c87e640ef77);
}


function $fdf405321e696258$export$31b6219c13fdca00(property) {
    return property.substring(0, 6) === '@scope';
}


function $b2d9aadbe50063bd$export$f6f4ace31eaf7c98(property) {
    return property.substr(0, 9) === '@supports';
}



/**
 * Trims selectors to generate consistent hashes.
 */ function $ad38e12d2e4692bf$export$5ba174c10f60bb93(selector) {
    return selector.replace(/>\s+/g, '>');
}



function $105b23be86b134e8$export$58da9968c3170cb1(...args) {}


function $ba3e0354dc80242c$export$b0df042dbc0a42f9(property, value) {
    const message = /*#__PURE__*/ (()=>{
        const ruleText = JSON.stringify(value, null, 2);
        const message = [
            "@griffel/react: A rule was not resolved to CSS properly. Please check your `makeStyles` or `makeResetStyles` calls for following:",
            ' '.repeat(2) + 'makeStyles({',
            ' '.repeat(4) + `[slot]: {`,
            ' '.repeat(6) + `"${property}": ${ruleText.split('\n').map((l, n)=>' '.repeat(n === 0 ? 0 : 6) + l).join('\n')}`,
            ' '.repeat(4) + '}',
            ' '.repeat(2) + `})`,
            ''
        ];
        if (property.indexOf('&') === -1) {
            message.push(`It looks that you're are using a nested selector, but it is missing an ampersand placeholder where the generated class name should be injected.`);
            message.push(`Try to update a property to include it i.e "${property}" => "&${property}".`);
        } else {
            message.push('');
            message.push("If it's not obvious what triggers a problem, please report an issue at https://github.com/microsoft/griffel/issues");
        }
        return message.join('\n');
    })();
    (0, $105b23be86b134e8$export$58da9968c3170cb1)(message);
}



function $e467c37031cf2d03$export$e9954ed78017002c(property, value) {
    const message = /*#__PURE__*/ (()=>[
            `@griffel/react: You are using unsupported shorthand CSS property "${property}". ` + `Please check your "makeStyles" calls, there *should not* be following:`,
            ' '.repeat(2) + `makeStyles({`,
            ' '.repeat(4) + `[slot]: { ${property}: "${value}" }`,
            ' '.repeat(2) + `})`,
            '',
            'Learn why CSS shorthands are not supported: https://aka.ms/griffel-css-shorthands'
        ].join('\n'))();
    (0, $105b23be86b134e8$export$58da9968c3170cb1)(message);
}


function $87f678006051c6c0$var$getShorthandDefinition(property) {
    return (0, $81b2d8d736993385$export$648f2124b45d7105)[property];
}
function $87f678006051c6c0$var$computePropertyPriority(shorthand) {
    var _a;
    return (_a = shorthand === null || shorthand === void 0 ? void 0 : shorthand[0]) !== null && _a !== void 0 ? _a : 0;
}
function $87f678006051c6c0$var$pushToClassesMap(classesMap, propertyKey, ltrClassname, rtlClassname) {
    classesMap[propertyKey] = rtlClassname ? [
        ltrClassname,
        rtlClassname
    ] : ltrClassname;
}
function $87f678006051c6c0$var$createBucketEntry(cssRule, metadata) {
    if (metadata.length > 0) return [
        cssRule,
        Object.fromEntries(metadata)
    ];
    return cssRule;
}
function $87f678006051c6c0$var$pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, media, container, priority) {
    var _a;
    const metadata = [];
    if (priority !== 0) metadata.push([
        'p',
        priority
    ]);
    if (styleBucketName === 'm' && media) metadata.push([
        'm',
        media
    ]);
    if (styleBucketName === 'x' && container) metadata.push([
        'x',
        container
    ]);
    (_a = cssRulesByBucket[styleBucketName]) !== null && _a !== void 0 ? _a : cssRulesByBucket[styleBucketName] = [];
    if (ltrCSS) cssRulesByBucket[styleBucketName].push($87f678006051c6c0$var$createBucketEntry(ltrCSS, metadata));
    if (rtlCSS) cssRulesByBucket[styleBucketName].push($87f678006051c6c0$var$createBucketEntry(rtlCSS, metadata));
}
function $87f678006051c6c0$export$15fe91a57d59741(styles, classNameHashSalt = '', selectors = [], atRules = {
    container: '',
    layer: '',
    media: '',
    supports: '',
    scope: ''
}, cssClassesMap = {}, cssRulesByBucket = {}, rtlValue) {
    // eslint-disable-next-line guard-for-in
    for(const property in styles){
        // eslint-disable-next-line no-prototype-builtins
        if ((0, $d87c946ff7108f65$export$77c0d61648307b86).hasOwnProperty(property)) {
            (0, $e467c37031cf2d03$export$e9954ed78017002c)(property, styles[property]);
            continue;
        }
        const value = styles[property];
        // eslint-disable-next-line eqeqeq
        if (value == null) continue;
        if ((0, $179d1b9c79eefc24$export$6bdeee5c8de376c6)(value)) {
            const selector = (0, $ad38e12d2e4692bf$export$5ba174c10f60bb93)(selectors.join(''));
            // uniq key based on a hash of property & selector, used for merging later
            const key = (0, $1b65a33a52d2d337$export$d78eef92bb01743f)(selector, property, atRules);
            $87f678006051c6c0$var$pushToClassesMap(cssClassesMap, key, 0, undefined);
            continue;
        }
        if (typeof value === 'string' || typeof value === 'number') {
            const selector = (0, $ad38e12d2e4692bf$export$5ba174c10f60bb93)(selectors.join(''));
            const shorthand = $87f678006051c6c0$var$getShorthandDefinition(property);
            if (shorthand) {
                const shorthandProperties = shorthand[1];
                const shorthandResetStyles = Object.fromEntries(shorthandProperties.map((property)=>[
                        property,
                        (0, $d87c946ff7108f65$export$4a991c87e640ef77)
                    ]));
                $87f678006051c6c0$export$15fe91a57d59741(shorthandResetStyles, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket);
            }
            // uniq key based on a hash of property & selector, used for merging later
            const key = (0, $1b65a33a52d2d337$export$d78eef92bb01743f)(selector, property, atRules);
            const className = (0, $425ea0b822f1c27f$export$2868bfa6c4652df6)({
                value: value.toString(),
                salt: classNameHashSalt,
                selector: selector,
                property: property
            }, atRules);
            const rtlDefinition = rtlValue && {
                key: property,
                value: rtlValue
            } || (0, $8124ab978dad7f97$export$4368d992c4eafac0)(property, value);
            const flippedInRtl = rtlDefinition.key !== property || rtlDefinition.value !== value;
            const rtlClassName = flippedInRtl ? (0, $425ea0b822f1c27f$export$2868bfa6c4652df6)({
                value: rtlDefinition.value.toString(),
                property: rtlDefinition.key,
                salt: classNameHashSalt,
                selector: selector
            }, atRules) : undefined;
            const rtlCompileOptions = flippedInRtl ? {
                rtlClassName: rtlClassName,
                rtlProperty: rtlDefinition.key,
                rtlValue: rtlDefinition.value
            } : undefined;
            const styleBucketName = (0, $e6973270afa688ac$export$d90f6836ea1aee93)(selectors, atRules);
            const [ltrCSS, rtlCSS] = (0, $30e93e010d2d8154$export$33a9e446f13f0fb6)({
                className: className,
                selectors: selectors,
                property: property,
                value: value,
                ...rtlCompileOptions
            }, atRules);
            $87f678006051c6c0$var$pushToClassesMap(cssClassesMap, key, className, rtlClassName);
            $87f678006051c6c0$var$pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, atRules.media, atRules.container, $87f678006051c6c0$var$computePropertyPriority(shorthand));
        } else if (property === 'animationName') {
            const animationNameValue = Array.isArray(value) ? value : [
                value
            ];
            const animationNames = [];
            const rtlAnimationNames = [];
            for (const keyframeObject of animationNameValue){
                const keyframeCSS = (0, $a8e2796ee9b0db17$export$f063294709aee23a)(keyframeObject);
                const rtlKeyframeCSS = (0, $a8e2796ee9b0db17$export$f063294709aee23a)((0, $8124ab978dad7f97$export$db3b6bfb95261072)(keyframeObject));
                const animationName = (0, $d87c946ff7108f65$export$fdd4f86041cc97c0) + (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(keyframeCSS);
                let rtlAnimationName;
                const keyframeRules = (0, $a8e2796ee9b0db17$export$50cb7050c6244400)(animationName, keyframeCSS);
                let rtlKeyframeRules = [];
                if (keyframeCSS === rtlKeyframeCSS) // If CSS for LTR & RTL are same we will re-use animationName from LTR to avoid duplication of rules in output
                rtlAnimationName = animationName;
                else {
                    rtlAnimationName = (0, $d87c946ff7108f65$export$fdd4f86041cc97c0) + (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(rtlKeyframeCSS);
                    rtlKeyframeRules = (0, $a8e2796ee9b0db17$export$50cb7050c6244400)(rtlAnimationName, rtlKeyframeCSS);
                }
                for(let i = 0; i < keyframeRules.length; i++)$87f678006051c6c0$var$pushToCSSRules(cssRulesByBucket, // keyframes styles should be inserted into own bucket
                'k', keyframeRules[i], rtlKeyframeRules[i], atRules.media, atRules.container, // keyframes always have default priority
                0);
                animationNames.push(animationName);
                rtlAnimationNames.push(rtlAnimationName);
            }
            $87f678006051c6c0$export$15fe91a57d59741({
                animationName: animationNames.join(', ')
            }, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket, rtlAnimationNames.join(', '));
        } else if (Array.isArray(value)) {
            // not animationName property but array in the value => fallback values
            if (value.length === 0) continue;
            const selector = (0, $ad38e12d2e4692bf$export$5ba174c10f60bb93)(selectors.join(''));
            const shorthand = $87f678006051c6c0$var$getShorthandDefinition(property);
            if (shorthand) {
                const shorthandProperties = shorthand[1];
                const shorthandResetStyles = Object.fromEntries(shorthandProperties.map((property)=>[
                        property,
                        (0, $d87c946ff7108f65$export$4a991c87e640ef77)
                    ]));
                $87f678006051c6c0$export$15fe91a57d59741(shorthandResetStyles, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket);
            }
            const key = (0, $1b65a33a52d2d337$export$d78eef92bb01743f)(selector, property, atRules);
            const className = (0, $425ea0b822f1c27f$export$2868bfa6c4652df6)({
                value: value.map((v)=>(v !== null && v !== void 0 ? v : '').toString()).join(';'),
                salt: classNameHashSalt,
                selector: selector,
                property: property
            }, atRules);
            const rtlDefinitions = value.map((v)=>(0, $8124ab978dad7f97$export$4368d992c4eafac0)(property, v));
            const rtlPropertyConsistent = !rtlDefinitions.some((v)=>v.key !== rtlDefinitions[0].key);
            if (!rtlPropertyConsistent) continue;
            const flippedInRtl = rtlDefinitions[0].key !== property || rtlDefinitions.some((v, i)=>v.value !== value[i]);
            const rtlClassName = flippedInRtl ? (0, $425ea0b822f1c27f$export$2868bfa6c4652df6)({
                value: rtlDefinitions.map((v)=>{
                    var _a;
                    return ((_a = v === null || v === void 0 ? void 0 : v.value) !== null && _a !== void 0 ? _a : '').toString();
                }).join(';'),
                salt: classNameHashSalt,
                property: rtlDefinitions[0].key,
                selector: selector
            }, atRules) : undefined;
            const rtlCompileOptions = flippedInRtl ? {
                rtlClassName: rtlClassName,
                rtlProperty: rtlDefinitions[0].key,
                rtlValue: rtlDefinitions.map((d)=>d.value)
            } : undefined;
            const styleBucketName = (0, $e6973270afa688ac$export$d90f6836ea1aee93)(selectors, atRules);
            const [ltrCSS, rtlCSS] = (0, $30e93e010d2d8154$export$33a9e446f13f0fb6)({
                className: className,
                selectors: selectors,
                property: property,
                value: value,
                ...rtlCompileOptions
            }, atRules);
            $87f678006051c6c0$var$pushToClassesMap(cssClassesMap, key, className, rtlClassName);
            $87f678006051c6c0$var$pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, atRules.media, atRules.container, $87f678006051c6c0$var$computePropertyPriority(shorthand));
        } else if ((0, $967afb231003f134$export$a6cdc56e425d0d0a)(value)) {
            if ((0, $7a378c0026b5bfa4$export$6ec9da58e818601b)(property)) $87f678006051c6c0$export$15fe91a57d59741(value, classNameHashSalt, selectors.concat((0, $ccf6acadf2e791ca$export$bdc4d18748ef5f7c)(property)), atRules, cssClassesMap, cssRulesByBucket);
            else if ((0, $c42ef86ad857e046$export$685119d24577daa)(property)) {
                const combinedMediaQuery = (0, $f4014991232ded57$export$9f1ed25614266b04)(atRules.media, property.slice(6).trim());
                $87f678006051c6c0$export$15fe91a57d59741(value, classNameHashSalt, selectors, {
                    ...atRules,
                    media: combinedMediaQuery
                }, cssClassesMap, cssRulesByBucket);
            } else if ((0, $8f1c934dabdd3b98$export$1f8685537590b231)(property)) {
                const combinedLayerQuery = (atRules.layer ? `${atRules.layer}.` : '') + property.slice(6).trim();
                $87f678006051c6c0$export$15fe91a57d59741(value, classNameHashSalt, selectors, {
                    ...atRules,
                    layer: combinedLayerQuery
                }, cssClassesMap, cssRulesByBucket);
            } else if ((0, $b2d9aadbe50063bd$export$f6f4ace31eaf7c98)(property)) {
                const combinedSupportQuery = (0, $f4014991232ded57$export$9f1ed25614266b04)(atRules.supports, property.slice(9).trim());
                $87f678006051c6c0$export$15fe91a57d59741(value, classNameHashSalt, selectors, {
                    ...atRules,
                    supports: combinedSupportQuery
                }, cssClassesMap, cssRulesByBucket);
            } else if ((0, $6b26a6574dda74e0$export$7648458cb39ca9d9)(property)) {
                // TODO implement nested container queries if needed
                // The only way to target multiple containers is to nest container queries
                // https://developer.mozilla.org/en-US/docs/Web/CSS/@container#nested_container_queries
                const containerQuery = property.slice(10).trim();
                $87f678006051c6c0$export$15fe91a57d59741(value, classNameHashSalt, selectors, {
                    ...atRules,
                    container: containerQuery
                }, cssClassesMap, cssRulesByBucket);
            } else if ((0, $fdf405321e696258$export$31b6219c13fdca00)(property)) {
                if (atRules.scope) continue;
                const scopeQuery = property.slice(6).trim();
                if (scopeQuery === '' || !scopeQuery.startsWith('to ')) continue;
                $87f678006051c6c0$export$15fe91a57d59741(value, classNameHashSalt, selectors, {
                    ...atRules,
                    scope: scopeQuery
                }, cssClassesMap, cssRulesByBucket);
            } else (0, $ba3e0354dc80242c$export$b0df042dbc0a42f9)(property, value);
        }
    }
    return [
        cssClassesMap,
        cssRulesByBucket
    ];
}


function $b8afcb533befa0ff$export$14fa50cbb6831b64(stylesBySlots, classNameHashSalt = '') {
    const classesMapBySlot = {};
    const cssRules = {};
    // eslint-disable-next-line guard-for-in
    for(const slotName in stylesBySlots){
        const slotStyles = stylesBySlots[slotName];
        const [cssClassMap, cssRulesByBucket] = (0, $87f678006051c6c0$export$15fe91a57d59741)(slotStyles, classNameHashSalt);
        classesMapBySlot[slotName] = cssClassMap;
        Object.keys(cssRulesByBucket).forEach((styleBucketName)=>{
            cssRules[styleBucketName] = (cssRules[styleBucketName] || []).concat(cssRulesByBucket[styleBucketName]);
        });
    }
    return [
        classesMapBySlot,
        cssRules
    ];
}





function $efbdbe9951925f14$var$padEndHash(value) {
    const hashLength = value.length;
    if (hashLength === (0, $d87c946ff7108f65$export$92d383cc43013b89)) return value;
    for(let i = hashLength; i < (0, $d87c946ff7108f65$export$92d383cc43013b89); i++)value += '0';
    return value;
}
function $efbdbe9951925f14$export$714355b806f78694(classes, dir, sequenceIds = []) {
    return (0, $d87c946ff7108f65$export$ed60e64637dbffef) + $efbdbe9951925f14$var$padEndHash((0, $3629985b3ecf741f$export$2e2bcd8739ae039)(classes + dir));
}


function $b4a9599cfb094ec5$export$9398e6bbc32c24c4(classMap, dir) {
    // - `classString` is a string of classnames separated by a space, used to output classes
    // - `hashString` is a string of classnames separated by a space, used to generate a hash
    //
    // `hashString` is needed to handle `null` values in a class map as they don't produce any classes.
    let classString = '';
    let hashString = '';
    // eslint-disable-next-line guard-for-in
    for(const propertyHash in classMap){
        const classNameMapping = classMap[propertyHash];
        if (classNameMapping === 0) {
            hashString += propertyHash + ' ';
            continue;
        }
        const hasRTLClassName = Array.isArray(classNameMapping);
        const className = dir === 'rtl' ? (hasRTLClassName ? classNameMapping[1] : classNameMapping) + ' ' : (hasRTLClassName ? classNameMapping[0] : classNameMapping) + ' ';
        classString += className;
        hashString += className;
    }
    return [
        classString.slice(0, -1),
        hashString.slice(0, -1)
    ];
}
function $b4a9599cfb094ec5$export$af9182572a187ed1(classesMapBySlot, dir) {
    const classNamesForSlots = {};
    // eslint-disable-next-line guard-for-in
    for(const slotName in classesMapBySlot){
        const [slotClasses, slotClassesHash] = $b4a9599cfb094ec5$export$9398e6bbc32c24c4(classesMapBySlot[slotName], dir);
        // Handles a case when there are no classes in a set i.e. "makeStyles({ root: {} })"
        if (slotClassesHash === '') {
            classNamesForSlots[slotName] = '';
            continue;
        }
        const sequenceHash = (0, $efbdbe9951925f14$export$714355b806f78694)(slotClassesHash, dir);
        const resultSlotClasses = sequenceHash + (slotClasses === '' ? '' : ' ' + slotClasses);
        (0, $d87c946ff7108f65$export$ac80cc81fdb4fb5a)[sequenceHash] = [
            classesMapBySlot[slotName],
            dir
        ];
        classNamesForSlots[slotName] = resultSlotClasses;
    }
    return classNamesForSlots;
}


function $8cc73517c8473942$export$b35517af9e0a5689(stylesBySlots, factory = (0, $7b009f341ccf321a$export$3509cd6597590fb4)) {
    const insertStyles = factory();
    let classesMapBySlot = null;
    let cssRules = null;
    let ltrClassNamesForSlots = null;
    let rtlClassNamesForSlots = null;
    let sourceURL;
    let classNameHashSalt;
    function computeClasses(options) {
        const { dir: dir, renderer: renderer } = options;
        if (classesMapBySlot === null) [classesMapBySlot, cssRules] = (0, $b8afcb533befa0ff$export$14fa50cbb6831b64)(stylesBySlots, renderer.classNameHashSalt);
        const isLTR = dir === 'ltr';
        if (isLTR) {
            if (ltrClassNamesForSlots === null) ltrClassNamesForSlots = (0, $b4a9599cfb094ec5$export$af9182572a187ed1)(classesMapBySlot, dir);
        } else if (rtlClassNamesForSlots === null) rtlClassNamesForSlots = (0, $b4a9599cfb094ec5$export$af9182572a187ed1)(classesMapBySlot, dir);
        insertStyles(renderer, cssRules);
        const classNamesForSlots = isLTR ? ltrClassNamesForSlots : rtlClassNamesForSlots;
        return classNamesForSlots;
    }
    return computeClasses;
}


/**
 * Verifies if an application can use DOM.
 *
 * @internal
 */ function $a44c240e359d136e$export$71594e8a50f746f4() {
    return typeof window !== 'undefined' && !!(window.document && window.document.createElement);
}



var $acw62 = parcelRequire("acw62");
'use client';
const $7b262a7fc95a2421$export$aaabe4eda9ed9969 = // @ts-expect-error Hack to make sure that `useInsertionEffect` will not cause bundling issues in older React versions
// eslint-disable-next-line no-useless-concat
(0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"] ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useInsertionEffect"] : undefined;


'use client';
const $b16bdb5b36b8736b$export$3509cd6597590fb4 = ()=>{
    const insertionCache = {};
    return function insert(renderer, cssRules) {
        // Even if `useInsertionEffect` is available, we can use it on a client only as it will not be executed in SSR
        if ((0, $7b262a7fc95a2421$export$aaabe4eda9ed9969) && (0, $a44c240e359d136e$export$71594e8a50f746f4)()) {
            // eslint-disable-next-line react-x/rules-of-hooks
            (0, $7b262a7fc95a2421$export$aaabe4eda9ed9969)(()=>{
                renderer.insertCSSRules(cssRules);
            }, [
                renderer,
                cssRules
            ]);
            return;
        }
        if (insertionCache[renderer.id] === undefined) {
            renderer.insertCSSRules(cssRules);
            insertionCache[renderer.id] = true;
        }
    };
};




/**
 * @internal
 *
 * @param entry - CSS bucket entry that can be either a string or an array
 * @returns An array where the first element is the CSS rule
 */ function $636b889faccd6d17$export$8863dfbe2e97628a(entry) {
    if (!Array.isArray(entry)) return [
        entry
    ];
    return entry;
}




function $edc9544db415cabb$export$3bcd7718a96ff8b9(styleElement, bucketName, priority, elementAttributes) {
    // no CSSStyleSheet in SSR, just append rules here for server render
    const __cssRulesForSSR = [];
    elementAttributes[0, $d87c946ff7108f65$export$1c1323cd9bbf9636] = bucketName;
    elementAttributes[0, $d87c946ff7108f65$export$4942e61c5aa6baa3] = String(priority);
    if (styleElement) // eslint-disable-next-line guard-for-in
    for(const attrName in elementAttributes)styleElement.setAttribute(attrName, elementAttributes[attrName]);
    function insertRule(rule) {
        if (styleElement === null || styleElement === void 0 ? void 0 : styleElement.sheet) return styleElement.sheet.insertRule(rule, styleElement.sheet.cssRules.length);
        return __cssRulesForSSR.push(rule);
    }
    return {
        elementAttributes: elementAttributes,
        insertRule: insertRule,
        element: styleElement,
        bucketName: bucketName,
        cssRules () {
            if (styleElement === null || styleElement === void 0 ? void 0 : styleElement.sheet) return Array.from(styleElement.sheet.cssRules).map((cssRule)=>cssRule.cssText);
            return __cssRulesForSSR;
        }
    };
}
function $edc9544db415cabb$export$996b7b13aed2e98a(element) {
    const elementAttributes = Array.from(element.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {});
    const stylesheet = $edc9544db415cabb$export$3bcd7718a96ff8b9(element, elementAttributes[0, $d87c946ff7108f65$export$1c1323cd9bbf9636], Number(elementAttributes[0, $d87c946ff7108f65$export$4942e61c5aa6baa3]), elementAttributes);
    return stylesheet;
}


const $c62c027531dcee7a$export$8394bdfbee416ca4 = [
    // reset styles
    'r',
    // catch-all
    'd',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at rules for reset styles
    's',
    // keyframes
    'k',
    // at-rules
    't',
    // @media rules
    'm',
    // @container rules (legacy/shared)
    'c',
    // @container rules (sorted)
    'x'
];
// avoid repeatedly calling `indexOf` to determine order during new insertions
const $c62c027531dcee7a$var$styleBucketOrderingMap = /*#__PURE__*/ $c62c027531dcee7a$export$8394bdfbee416ca4.reduce((acc, cur, j)=>{
    acc[cur] = j;
    return acc;
}, {});
function $c62c027531dcee7a$export$5faf1243ae91fdea(bucketName, mediaValue, priority) {
    if (bucketName === 'm' || bucketName === 'x') return bucketName + mediaValue + priority;
    return bucketName + priority;
}
function $c62c027531dcee7a$export$d4a5a0a0c43c23d0(styleEl) {
    var _a;
    const bucketName = styleEl.getAttribute((0, $d87c946ff7108f65$export$1c1323cd9bbf9636));
    const priority = (_a = styleEl.getAttribute((0, $d87c946ff7108f65$export$4942e61c5aa6baa3))) !== null && _a !== void 0 ? _a : '0';
    const container = styleEl.getAttribute((0, $d87c946ff7108f65$export$5cce92c11780587a));
    return $c62c027531dcee7a$export$5faf1243ae91fdea(bucketName, container !== null && container !== void 0 ? container : styleEl.media || '0', priority);
}
function $c62c027531dcee7a$export$bf774c2f1a190afe(bucketName, targetDocument, insertionPoint, renderer, metadata = {}) {
    var _a, _b;
    const isMediaBucket = bucketName === 'm';
    const isContainerBucket = bucketName === 'x';
    const media = metadata['m'];
    const container = metadata['x'];
    const priority = (_a = metadata['p']) !== null && _a !== void 0 ? _a : 0;
    const stylesheetKey = $c62c027531dcee7a$export$5faf1243ae91fdea(bucketName, (_b = container !== null && container !== void 0 ? container : media) !== null && _b !== void 0 ? _b : '0', priority);
    if (!renderer.stylesheets[stylesheetKey]) {
        const tag = targetDocument && targetDocument.createElement('style');
        const stylesheet = (0, $edc9544db415cabb$export$3bcd7718a96ff8b9)(tag, bucketName, priority, {
            ...renderer.styleElementAttributes,
            ...isMediaBucket && {
                media: media
            },
            ...isContainerBucket && {
                [(0, $d87c946ff7108f65$export$5cce92c11780587a)]: container
            }
        });
        renderer.stylesheets[stylesheetKey] = stylesheet;
        if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.head) && tag) targetDocument.head.insertBefore(tag, $c62c027531dcee7a$var$findInsertionPoint(targetDocument, insertionPoint, bucketName, renderer, metadata));
    }
    return renderer.stylesheets[stylesheetKey];
}
function $c62c027531dcee7a$export$69242f2c69e0cde(elementA, bucketNameB, metadataB) {
    // The bucket name is the key; only "@media" / "@container" buckets append a condition, each from the
    // field that matches its bucket (mirroring "getStyleSheetKey").
    const elementBucketA = elementA.getAttribute((0, $d87c946ff7108f65$export$1c1323cd9bbf9636));
    const isSameBucket = elementBucketA === bucketNameB;
    if (isSameBucket) {
        if (bucketNameB === 'm') return metadataB['m'] === elementA.media;
        if (bucketNameB === 'x') return metadataB['x'] === elementA.getAttribute((0, $d87c946ff7108f65$export$5cce92c11780587a));
        return true;
    }
    return false;
}
/**
 * Finds an element before which the new bucket style element should be inserted following the bucket sort order.
 *
 * @param targetDocument - A document
 * @param insertionPoint - An element that will be used as an initial insertion point
 * @param targetBucket - The bucket that should be inserted to DOM
 * @param renderer - Griffel renderer
 * @param metadata - metadata for CSS rule
 * @returns - Smallest style element with greater sort order than the current bucket
 */ function $c62c027531dcee7a$var$findInsertionPoint(targetDocument, insertionPoint, targetBucket, renderer, metadata = {}) {
    var _a, _b, _c;
    const targetOrder = $c62c027531dcee7a$var$styleBucketOrderingMap[targetBucket];
    const media = (_a = metadata['m']) !== null && _a !== void 0 ? _a : '';
    const container = (_b = metadata['x']) !== null && _b !== void 0 ? _b : '';
    const priority = (_c = metadata['p']) !== null && _c !== void 0 ? _c : 0;
    // Similar to javascript sort comparators where
    // a positive value is increasing sort order
    // a negative value is decreasing sort order
    let comparer = (el)=>targetOrder - $c62c027531dcee7a$var$styleBucketOrderingMap[el.getAttribute((0, $d87c946ff7108f65$export$1c1323cd9bbf9636))];
    let styleElements = targetDocument.head.querySelectorAll(`[${(0, $d87c946ff7108f65$export$1c1323cd9bbf9636)}]`);
    // "@media" and "@container" rules are split into per-condition sheets that must be ordered by
    // their condition (ascending min-width) rather than plain insertion order.
    if (targetBucket === 'm' || targetBucket === 'x') {
        const conditionElements = targetDocument.head.querySelectorAll(`[${(0, $d87c946ff7108f65$export$1c1323cd9bbf9636)}="${targetBucket}"]`);
        // only reduce the scope of the search and change comparer
        // if there are other buckets of the same kind already on the page
        if (conditionElements.length) {
            styleElements = conditionElements;
            comparer = targetBucket === 'm' ? (el)=>renderer.compareMediaQueries(media, el.media) : (el)=>{
                var _a;
                return renderer.compareContainerQueries(container, (_a = el.getAttribute((0, $d87c946ff7108f65$export$5cce92c11780587a))) !== null && _a !== void 0 ? _a : '');
            };
        }
    }
    const comparerWithPriority = (el)=>{
        if ($c62c027531dcee7a$export$69242f2c69e0cde(el, targetBucket, metadata)) return priority - Number(el.getAttribute((0, $d87c946ff7108f65$export$4942e61c5aa6baa3)));
        return comparer(el);
    };
    const length = styleElements.length;
    let index = length - 1;
    while(index >= 0){
        const styleElement = styleElements.item(index);
        if (comparerWithPriority(styleElement) > 0) return styleElement.nextSibling;
        index--;
    }
    if (length > 0) return styleElements.item(0);
    return insertionPoint ? insertionPoint.nextSibling : null;
}


/**
 * Suffixes to be ignored in case of error
 */ const $88050bb557bba702$var$ignoreSuffixes = /*#__PURE__*/ [
    '-moz-placeholder',
    '-moz-focus-inner',
    '-moz-focusring',
    '-ms-input-placeholder',
    '-moz-read-write',
    '-moz-read-only'
].join('|');
const $88050bb557bba702$var$ignoreSuffixesRegex = /*#__PURE__*/ new RegExp(`:(${$88050bb557bba702$var$ignoreSuffixes})`);
function $88050bb557bba702$export$eeb35b988e7e9e06(sheet, ruleCSS) {
    try {
        sheet.insertRule(ruleCSS);
    } catch (e) {}
}


let $f6efb73ebd6dc152$var$lastIndex = 0;
const $f6efb73ebd6dc152$export$642fd54c606e54c9 = (a, b)=>a < b ? -1 : a > b ? 1 : 0;
function $f6efb73ebd6dc152$export$9fc2f00d85486f7e(targetDocument = typeof document === 'undefined' ? undefined : document, options = {}) {
    const { classNameHashSalt: classNameHashSalt, unstable_filterCSSRule: unstable_filterCSSRule, insertionPoint: insertionPoint, styleElementAttributes: styleElementAttributes, compareMediaQueries: compareMediaQueries = $f6efb73ebd6dc152$export$642fd54c606e54c9, compareContainerQueries: // Container queries default to the same comparator as media queries; pass `compareCSSQueries`
    // from `@griffel/sort-css-queries` for numeric min-width / max-width ordering.
    compareContainerQueries = compareMediaQueries } = options;
    const renderer = {
        classNameHashSalt: classNameHashSalt,
        insertionCache: {},
        stylesheets: {},
        styleElementAttributes: Object.freeze(styleElementAttributes),
        compareMediaQueries: compareMediaQueries,
        compareContainerQueries: compareContainerQueries,
        id: `d${$f6efb73ebd6dc152$var$lastIndex++}`,
        insertCSSRules (cssRules) {
            // eslint-disable-next-line guard-for-in
            for(const styleBucketName in cssRules){
                const cssRulesForBucket = cssRules[styleBucketName];
                // This is a hot path in rendering styles: ".length" is cached in "l" var to avoid accesses the property
                for(let i = 0, l = cssRulesForBucket.length; i < l; i++){
                    const [ruleCSS, metadata] = (0, $636b889faccd6d17$export$8863dfbe2e97628a)(cssRulesForBucket[i]);
                    const sheet = (0, $c62c027531dcee7a$export$bf774c2f1a190afe)(styleBucketName, targetDocument, insertionPoint || null, renderer, metadata);
                    if (renderer.insertionCache[ruleCSS]) continue;
                    renderer.insertionCache[ruleCSS] = styleBucketName;
                    if (unstable_filterCSSRule) {
                        if (unstable_filterCSSRule(ruleCSS)) (0, $88050bb557bba702$export$eeb35b988e7e9e06)(sheet, ruleCSS);
                    } else (0, $88050bb557bba702$export$eeb35b988e7e9e06)(sheet, ruleCSS);
                }
            }
        }
    };
    return renderer;
}




function $d66a73c3dc097fdc$export$8f0b8bbd64b65ffc(cssText, callback) {
    (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(cssText), (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)([
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        // 💡 the same extraction used when these rules were created: `rulesheet` reports every
        // top-level rule, which is exactly the granularity `insertionCache` is keyed at
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)(callback)
    ]));
}



function $c6f261599f1c0d0e$export$ff47709f7ae6a457(renderer, target = typeof document === 'undefined' ? undefined : document) {
    if (target) {
        const styleElements = target.querySelectorAll('[data-make-styles-bucket]');
        // Griffel emits each CSS rule into the document exactly once. In development we track
        // the rules seen while rehydrating, so we can warn if the same rule appears in more than
        // one server-rendered <style> element — a strong signal that styles were flushed into the
        // HTML multiple times (see the warning emitted after the loop).
        const seenRules = new Set();
        let duplicateRuleCount = 0;
        const cacheRule = (cssRule, bucketName)=>{
            renderer.insertionCache[cssRule] = bucketName;
        };
        styleElements.forEach((styleElement)=>{
            const bucketName = styleElement.dataset['makeStylesBucket'];
            const stylesheetKey = (0, $c62c027531dcee7a$export$d4a5a0a0c43c23d0)(styleElement);
            // 👇 If some elements are not created yet, we will register them in renderer
            if (!renderer.stylesheets[stylesheetKey]) renderer.stylesheets[stylesheetKey] = (0, $edc9544db415cabb$export$996b7b13aed2e98a)(styleElement);
            // A bucket's text content is exactly its rules concatenated (`cssRules.join('')`), so
            // splitting it back apart structurally recovers the same strings `insertCSSRules()` uses as
            // cache keys — for every at-rule, including ones added to CSS after this code was written.
            (0, $d66a73c3dc097fdc$export$8f0b8bbd64b65ffc)(styleElement.textContent, (cssRule)=>cacheRule(cssRule, bucketName));
        });
    }
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * @private
 */ const $5c71fabe713d2fee$var$RendererContext = /*#__PURE__*/ (0, $acw62.createContext)(/*#__PURE__*/ (0, $f6efb73ebd6dc152$export$9fc2f00d85486f7e)());
const $5c71fabe713d2fee$export$e785a56df110cbc9 = ({ children: children, renderer: renderer, targetDocument: targetDocument })=>{
    // "rehydrateCache()" can't be called in effects as it needs to be called before any component will be rendered to
    // avoid double insertion of classes — useMemo runs synchronously before render, useEffect would be too late.
    // eslint-disable-next-line react-x/use-memo, react-hooks/void-use-memo
    (0, $acw62.useMemo)(()=>{
        if ((0, $a44c240e359d136e$export$71594e8a50f746f4)()) (0, $c6f261599f1c0d0e$export$ff47709f7ae6a457)(renderer, targetDocument);
    }, [
        renderer,
        targetDocument
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($5c71fabe713d2fee$var$RendererContext.Provider, {
        value: renderer,
        children: children
    });
};
function $5c71fabe713d2fee$export$e0259e2a2ab69ea() {
    return (0, $acw62.useContext)($5c71fabe713d2fee$var$RendererContext);
}




var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @private
 */ const $1351c645e9f8e168$var$TextDirectionContext = /*#__PURE__*/ (0, $acw62.createContext)('ltr');
const $1351c645e9f8e168$export$c244dbe07f501bcc = ({ children: children, dir: dir })=>{
    return (0, $7b02d682eb115277$exports.jsx)($1351c645e9f8e168$var$TextDirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $1351c645e9f8e168$export$cf24a79f32f45545() {
    return (0, $acw62.useContext)($1351c645e9f8e168$var$TextDirectionContext);
}



'use client';
function $f2434d6396bd7f83$export$b35517af9e0a5689(stylesBySlots) {
    const getStyles = (0, $8cc73517c8473942$export$b35517af9e0a5689)(stylesBySlots, (0, $b16bdb5b36b8736b$export$3509cd6597590fb4));
    return function useClasses() {
        const dir = (0, $1351c645e9f8e168$export$cf24a79f32f45545)();
        const renderer = (0, $5c71fabe713d2fee$export$e0259e2a2ab69ea)();
        return getStyles({
            dir: dir,
            renderer: renderer
        });
    };
}


var $acw62 = parcelRequire("acw62");
/**
 * Internal reference for the render function
 *
 * @internal
 */ const $a9190614d56c943f$export$2eb147a2bf7697ad = Symbol.for('fui.slotRenderFunction');
const $a9190614d56c943f$export$b8c826907bbed9b7 = Symbol.for('fui.slotElementType');
const $a9190614d56c943f$export$fcc89f7e5475925d = Symbol.for('fui.slotClassNameProp');


function $bf74bb91b065b58d$export$8a437e4937654fbf(element) {
    return Boolean(element === null || element === void 0 ? void 0 : element.hasOwnProperty((0, $a9190614d56c943f$export$b8c826907bbed9b7)));
}



function $a8c7357f7e7cd153$export$5ce282bb9581ca36(type, props) {
    return {
        ...props,
        [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: type
    };
}


function $fccc86cb852ed0d5$export$6c4ce7fc9b1c0ed1(type) {}


function $35e0eb7c96e5d540$export$477dc0b5171b4779(runtime, slotRuntime) {
    return function jsx(type, overrideProps, key, source, self) {
        // TODO:
        // this is for backwards compatibility with getSlotsNext
        // it should be removed once getSlotsNext is obsolete
        if ((0, $bf74bb91b065b58d$export$8a437e4937654fbf)(overrideProps)) return slotRuntime((0, $a8c7357f7e7cd153$export$5ce282bb9581ca36)(type, overrideProps), null, key, source, self);
        if ((0, $bf74bb91b065b58d$export$8a437e4937654fbf)(type)) return slotRuntime(type, overrideProps, key, source, self);
        (0, $fccc86cb852ed0d5$export$6c4ce7fc9b1c0ed1)(type);
        return runtime(type, overrideProps, key, source, self);
    };
}



var $acw62 = parcelRequire("acw62");

function $761c0cc80080c285$export$8d5482c1ab8d280c(type) {
    const { as: as, [(0, $a9190614d56c943f$export$fcc89f7e5475925d)]: _classNameProp, [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: baseElementType, [(0, $a9190614d56c943f$export$2eb147a2bf7697ad)]: renderFunction, ...propsWithoutMetadata } = type;
    const props = propsWithoutMetadata;
    const elementType = typeof baseElementType === 'string' ? as !== null && as !== void 0 ? as : baseElementType : baseElementType;
    if (typeof elementType !== 'string' && as) props.as = as;
    return {
        elementType: elementType,
        props: props,
        renderFunction: renderFunction
    };
}



const $d655fc3c2eeb66d8$export$269330a1f1074312 = $7b02d682eb115277$exports;


const $b8c355fc1cc218b9$export$60ed89c671fedc50 = (type, overrideProps, key)=>{
    const { elementType: elementType, renderFunction: renderFunction, props: slotProps } = (0, $761c0cc80080c285$export$8d5482c1ab8d280c)(type);
    const props = {
        ...slotProps,
        ...overrideProps
    };
    if (renderFunction) return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx($acw62.Fragment, {
        children: renderFunction(elementType, props)
    }, key);
    return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx(elementType, props, key);
};



var $acw62 = parcelRequire("acw62");


const $c87a8fa0f2955fd3$export$6110acb8e9c03b3a = (type, overrideProps, key)=>{
    const { elementType: elementType, renderFunction: renderFunction, props: slotProps } = (0, $761c0cc80080c285$export$8d5482c1ab8d280c)(type);
    const props = {
        ...slotProps,
        ...overrideProps
    };
    if (renderFunction) /**
     * In static runtime then children is an array and this array won't be keyed.
     * We should wrap children by a static fragment
     * as there's no way to know if renderFunction will render statically or dynamically
     */ return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx($acw62.Fragment, {
        children: renderFunction(elementType, {
            ...props,
            children: (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsxs($acw62.Fragment, {
                children: props.children
            }, undefined)
        })
    }, key);
    return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsxs(elementType, props, key);
};




var $acw62 = parcelRequire("acw62");
const $505f9e7ea0e895ad$export$34b9dba7ce09269b = (0, $35e0eb7c96e5d540$export$477dc0b5171b4779)((0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx, (0, $b8c355fc1cc218b9$export$60ed89c671fedc50));
const $505f9e7ea0e895ad$export$25062201e9e25d76 = (0, $35e0eb7c96e5d540$export$477dc0b5171b4779)((0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsxs, (0, $c87a8fa0f2955fd3$export$6110acb8e9c03b3a));





function $637c7ee6d96c4982$export$9b4ff06cafef0276(state) {}


const $995145210e0678db$export$70445376982a3a8b = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};


var $fcf7ddccaab7fd8f$exports = {};

$parcel$export($fcf7ddccaab7fd8f$exports, "always", () => $fcf7ddccaab7fd8f$export$ba9e5d519bc326ca);
$parcel$export($fcf7ddccaab7fd8f$exports, "resolveShorthand", () => $fcf7ddccaab7fd8f$export$cf82748705625c0e);
$parcel$export($fcf7ddccaab7fd8f$exports, "optional", () => $fcf7ddccaab7fd8f$export$516e28dec6a4b6d4);

var $acw62 = parcelRequire("acw62");

function $fcf7ddccaab7fd8f$export$ba9e5d519bc326ca(value, options) {
    const { defaultProps: defaultProps, elementType: elementType } = options;
    const props = $fcf7ddccaab7fd8f$export$cf82748705625c0e(value);
    /**
   * Casting is required here as SlotComponentType is a function, not an object.
   * Although SlotComponentType has a function signature, it is still just an object.
   * This is required to make a slot callable (JSX compatible), this is the exact same approach
   * that is used on `@types/react` components
   */ const propsWithMetadata = {
        ...defaultProps,
        ...props,
        [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: elementType,
        [(0, $a9190614d56c943f$export$fcc89f7e5475925d)]: (props === null || props === void 0 ? void 0 : props.className) || (defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.className)
    };
    if (props && typeof props.children === 'function') {
        propsWithMetadata[0, $a9190614d56c943f$export$2eb147a2bf7697ad] = props.children;
        propsWithMetadata.children = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.children;
    }
    return propsWithMetadata;
}
function $fcf7ddccaab7fd8f$export$516e28dec6a4b6d4(value, options) {
    if (value === null || value === undefined && !options.renderByDefault) return undefined;
    return $fcf7ddccaab7fd8f$export$ba9e5d519bc326ca(value, options);
}
function $fcf7ddccaab7fd8f$export$cf82748705625c0e(value) {
    if (typeof value === 'string' || typeof value === 'number' || $fcf7ddccaab7fd8f$var$isIterable(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $acw62.isValidElement(value)) return {
        children: value
    };
    value && typeof value;
    return value;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fcf7ddccaab7fd8f$var$isIterable = (value)=>typeof value === 'object' && value !== null && Symbol.iterator in value;

const $70949e6a28333d2f$var$toObjectMap = (...items)=>{
    const result = {};
    for (const item of items){
        const keys = Array.isArray(item) ? item : Object.keys(item);
        for (const key of keys)result[key] = 1;
    }
    return result;
};
const $70949e6a28333d2f$export$32eff4db2feb903 = $70949e6a28333d2f$var$toObjectMap([
    'onAuxClick',
    'onAnimationEnd',
    'onAnimationStart',
    'onCopy',
    'onCut',
    'onPaste',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onInput',
    'onSubmit',
    'onLoad',
    'onError',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyUp',
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onScroll',
    'onWheel',
    'onPointerCancel',
    'onPointerDown',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerMove',
    'onPointerOut',
    'onPointerOver',
    'onPointerUp',
    'onGotPointerCapture',
    'onLostPointerCapture'
]);
const $70949e6a28333d2f$export$7256d73338e409fd = $70949e6a28333d2f$var$toObjectMap([
    'accessKey',
    'children',
    'className',
    'contentEditable',
    'dir',
    'draggable',
    'hidden',
    'htmlFor',
    'id',
    'lang',
    'popover',
    'focusgroup',
    'focusgroupstart',
    'ref',
    'role',
    'style',
    'tabIndex',
    'title',
    'translate',
    'spellCheck',
    'name'
]);
const $70949e6a28333d2f$export$cd32fb67764fc900 = $70949e6a28333d2f$var$toObjectMap([
    'itemID',
    'itemProp',
    'itemRef',
    'itemScope',
    'itemType'
]);
const $70949e6a28333d2f$export$e4936fed10ab2c40 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$7256d73338e409fd, $70949e6a28333d2f$export$32eff4db2feb903, $70949e6a28333d2f$export$cd32fb67764fc900);
const $70949e6a28333d2f$export$ec8d81a3d8f61d0f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'form'
]);
const $70949e6a28333d2f$export$55af9cf105a52547 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'height',
    'loop',
    'muted',
    'preload',
    'src',
    'width'
]);
const $70949e6a28333d2f$export$cd2126b486be823e = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$55af9cf105a52547, [
    'poster'
]);
const $70949e6a28333d2f$export$9e755727cea4fd1f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'start'
]);
const $70949e6a28333d2f$export$8703767c2ecb797b = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'value'
]);
const $70949e6a28333d2f$export$bd4643a0b4568ed8 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'download',
    'href',
    'hrefLang',
    'media',
    'referrerPolicy',
    'rel',
    'target',
    'type'
]);
const $70949e6a28333d2f$export$1fc5e2c7479ee57 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'dateTime'
]);
const $70949e6a28333d2f$export$4fd534fb1e82b8b4 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'popoverTarget',
    'popoverTargetAction',
    'type',
    'value'
]);
const $70949e6a28333d2f$export$33c6815a27d08ce5 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$4fd534fb1e82b8b4, [
    'accept',
    'alt',
    'autoCorrect',
    'autoCapitalize',
    'autoComplete',
    'checked',
    'dirname',
    'form',
    'height',
    'inputMode',
    'list',
    'max',
    'maxLength',
    'min',
    'minLength',
    'multiple',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'src',
    'step',
    'size',
    'type',
    'value',
    'width'
]);
const $70949e6a28333d2f$export$699534499318873d = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$4fd534fb1e82b8b4, [
    'autoCapitalize',
    'cols',
    'dirname',
    'form',
    'maxLength',
    'placeholder',
    'readOnly',
    'required',
    'rows',
    'wrap'
]);
const $70949e6a28333d2f$export$9475341421ea2846 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$4fd534fb1e82b8b4, [
    'form',
    'multiple',
    'required'
]);
const $70949e6a28333d2f$export$9004c3828878727f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'selected',
    'value'
]);
const $70949e6a28333d2f$export$2f53f8cf7eb86ae5 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'cellPadding',
    'cellSpacing'
]);
const $70949e6a28333d2f$export$3ab2f4f445c2eb24 = $70949e6a28333d2f$export$e4936fed10ab2c40;
const $70949e6a28333d2f$export$2b115a026f474c83 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'colSpan',
    'rowSpan',
    'scope'
]);
const $70949e6a28333d2f$export$b5d753b2279d22cc = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'colSpan',
    'headers',
    'rowSpan',
    'scope'
]);
const $70949e6a28333d2f$export$d526cc4b9c261b42 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'span'
]);
const $70949e6a28333d2f$export$e487baa138d06e98 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'span'
]);
const $70949e6a28333d2f$export$52193885890f710e = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'disabled',
    'form'
]);
const $70949e6a28333d2f$export$477a3a6d251d97a7 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'acceptCharset',
    'action',
    'encType',
    'encType',
    'method',
    'noValidate',
    'target'
]);
const $70949e6a28333d2f$export$727a7f82229b450f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'allow',
    'allowFullScreen',
    'allowPaymentRequest',
    'allowTransparency',
    'csp',
    'height',
    'importance',
    'referrerPolicy',
    'sandbox',
    'src',
    'srcDoc',
    'width'
]);
const $70949e6a28333d2f$export$91f8cc2b546c057d = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'alt',
    'crossOrigin',
    'height',
    'loading',
    'src',
    'srcSet',
    'useMap',
    'width'
]);
const $70949e6a28333d2f$export$88fc3d496ec6e608 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'open',
    'onCancel',
    'onClose'
]);
const $70949e6a28333d2f$export$eb42a981869108f0 = $70949e6a28333d2f$export$e4936fed10ab2c40;
function $70949e6a28333d2f$export$26fba481281db559(props, allowedPropNames, excludedPropNames) {
    // It'd be great to properly type this while allowing 'aria-` and 'data-' attributes like TypeScript does for
    // JSX attributes, but that ability is hardcoded into the TS compiler with no analog in TypeScript typings.
    // Then we'd be able to enforce props extends native props (including aria- and data- attributes), and then
    // return native props.
    // We should be able to do this once this PR is merged: https://github.com/microsoft/TypeScript/pull/26797
    const isArray = Array.isArray(allowedPropNames);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    const keys = Object.keys(props);
    for (const key of keys){
        const isNativeProp = !isArray && Object.prototype.hasOwnProperty.call(allowedPropNames, key) || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf('data-') === 0 || key.indexOf('aria-') === 0;
        if (key !== '__proto__' && isNativeProp && (!excludedPropNames || (excludedPropNames === null || excludedPropNames === void 0 ? void 0 : excludedPropNames.indexOf(key)) === -1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result[key] = props[key];
    }
    return result;
}


const $f5c0cec12bf016e1$var$nativeElementMap = {
    label: (0, $70949e6a28333d2f$export$ec8d81a3d8f61d0f),
    audio: (0, $70949e6a28333d2f$export$55af9cf105a52547),
    video: (0, $70949e6a28333d2f$export$cd2126b486be823e),
    ol: (0, $70949e6a28333d2f$export$9e755727cea4fd1f),
    li: (0, $70949e6a28333d2f$export$8703767c2ecb797b),
    a: (0, $70949e6a28333d2f$export$bd4643a0b4568ed8),
    button: (0, $70949e6a28333d2f$export$4fd534fb1e82b8b4),
    input: (0, $70949e6a28333d2f$export$33c6815a27d08ce5),
    textarea: (0, $70949e6a28333d2f$export$699534499318873d),
    select: (0, $70949e6a28333d2f$export$9475341421ea2846),
    option: (0, $70949e6a28333d2f$export$9004c3828878727f),
    table: (0, $70949e6a28333d2f$export$2f53f8cf7eb86ae5),
    tr: (0, $70949e6a28333d2f$export$3ab2f4f445c2eb24),
    th: (0, $70949e6a28333d2f$export$2b115a026f474c83),
    td: (0, $70949e6a28333d2f$export$b5d753b2279d22cc),
    colGroup: (0, $70949e6a28333d2f$export$d526cc4b9c261b42),
    col: (0, $70949e6a28333d2f$export$e487baa138d06e98),
    fieldset: (0, $70949e6a28333d2f$export$52193885890f710e),
    form: (0, $70949e6a28333d2f$export$477a3a6d251d97a7),
    iframe: (0, $70949e6a28333d2f$export$727a7f82229b450f),
    img: (0, $70949e6a28333d2f$export$91f8cc2b546c057d),
    time: (0, $70949e6a28333d2f$export$1fc5e2c7479ee57),
    dialog: (0, $70949e6a28333d2f$export$88fc3d496ec6e608)
};
function $f5c0cec12bf016e1$export$eca624771caa6078(tagName, props, excludedPropNames) {
    const allowedPropNames = tagName && Object.prototype.hasOwnProperty.call($f5c0cec12bf016e1$var$nativeElementMap, tagName) ? $f5c0cec12bf016e1$var$nativeElementMap[tagName] : (0, $70949e6a28333d2f$export$e4936fed10ab2c40);
    allowedPropNames.as = 1;
    return (0, $70949e6a28333d2f$export$26fba481281db559)(props, allowedPropNames, excludedPropNames);
}
const $f5c0cec12bf016e1$export$199c93d3d8d08c56 = ({ primarySlotTagName: primarySlotTagName, props: props, excludedPropNames: excludedPropNames })=>{
    return {
        root: {
            style: props.style,
            className: props.className
        },
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        primary: $f5c0cec12bf016e1$export$eca624771caa6078(primarySlotTagName, props, [
            ...excludedPropNames || [],
            'style',
            'className'
        ])
    };
};


const $3cf8e596657ab4e0$export$c8517108b1b59810 = (tagName, props, excludedPropNames)=>{
    var _props_as;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return (0, $f5c0cec12bf016e1$export$eca624771caa6078)((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : tagName, props, excludedPropNames);
};


'use client';
const $9e411e4e93d009d7$export$e95ea34197117eb = (props, ref)=>{
    const { bordered: bordered = false, block: block = false, fit: fit = 'default', shadow: shadow = false, shape: shape = 'square', ...imageProps } = props;
    const state = $9e411e4e93d009d7$export$c9a6af79cf78f184(imageProps, ref);
    return {
        bordered: bordered,
        block: block,
        fit: fit,
        shadow: shadow,
        shape: shape,
        ...state
    };
};
const $9e411e4e93d009d7$export$c9a6af79cf78f184 = (props, ref)=>{
    return {
        components: {
            root: 'img'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('img', {
            ref: ref,
            ...props
        }), {
            elementType: 'img'
        })
    };
};





function $e4c89be7ff026cfe$export$c5d3a2c2e0d67663(classesMapBySlot, cssRules, factory = (0, $7b009f341ccf321a$export$3509cd6597590fb4)) {
    const insertStyles = factory();
    let ltrClassNamesForSlots = null;
    let rtlClassNamesForSlots = null;
    let sourceURL;
    function computeClasses(options) {
        const { dir: dir, renderer: renderer } = options;
        const isLTR = dir === 'ltr';
        if (isLTR) {
            if (ltrClassNamesForSlots === null) ltrClassNamesForSlots = (0, $b4a9599cfb094ec5$export$af9182572a187ed1)(classesMapBySlot, dir);
        } else if (rtlClassNamesForSlots === null) rtlClassNamesForSlots = (0, $b4a9599cfb094ec5$export$af9182572a187ed1)(classesMapBySlot, dir);
        insertStyles(renderer, cssRules);
        const classNamesForSlots = isLTR ? ltrClassNamesForSlots : rtlClassNamesForSlots;
        return classNamesForSlots;
    }
    return computeClasses;
}





'use client';
function $9438d9671fa9d7d9$export$c5d3a2c2e0d67663(classesMapBySlot, cssRules) {
    const getStyles = (0, $e4c89be7ff026cfe$export$c5d3a2c2e0d67663)(classesMapBySlot, cssRules, (0, $b16bdb5b36b8736b$export$3509cd6597590fb4));
    return function useClasses() {
        const dir = (0, $1351c645e9f8e168$export$cf24a79f32f45545)();
        const renderer = (0, $5c71fabe713d2fee$export$e0259e2a2ab69ea)();
        return getStyles({
            dir: dir,
            renderer: renderer
        });
    };
}




const $00898283de415a49$export$18cfd45882d1eee = {};
function $00898283de415a49$export$3d46f4579dba46e5() {
    // arguments are parsed manually to avoid double loops as TS & Babel transforms rest via an additional loop
    // @see https://babeljs.io/docs/en/babel-plugin-transform-parameters
    /* eslint-disable prefer-rest-params */ let dir = null;
    let resultClassName = '';
    // Is used as a cache key to avoid object merging
    let sequenceMatch = '';
    const sequencesIds = new Array(arguments.length);
    let containsResetClassName = '';
    for(let i = 0; i < arguments.length; i++){
        const className = arguments[i];
        if (typeof className === 'string' && className !== '') {
            // All classes generated by `makeStyles()` are prefixed by a sequence hash, this allows to identify class sets
            // without parsing each className in a string
            const sequenceIndex = className.indexOf((0, $d87c946ff7108f65$export$ed60e64637dbffef));
            if (sequenceIndex === -1) {
                var entry;
                resultClassName += className + ' ';
            } else {
                const sequenceId = className.substr(sequenceIndex, (0, $d87c946ff7108f65$export$dcee98f0f975aca0));
                // Handles a case with mixed classnames, i.e. "ui-button ATOMIC_CLASSES"
                if (sequenceIndex > 0) resultClassName += className.slice(0, sequenceIndex);
                sequenceMatch += sequenceId;
                sequencesIds[i] = sequenceId;
            }
        }
    }
    // .slice() there allows to avoid trailing space for non-atomic classes
    // "ui-button ui-flex " => "ui-button ui-flex"
    if (sequenceMatch === '') return resultClassName.slice(0, -1);
    // It's safe to reuse results to avoid continuous merging as results are stable
    // "__seq1 ... __seq2 ..." => "__seq12 ..."
    const mergeClassesResult = $00898283de415a49$export$18cfd45882d1eee[sequenceMatch];
    if (mergeClassesResult !== undefined) return resultClassName + mergeClassesResult;
    const sequenceMappings = [];
    for(let i = 0; i < arguments.length; i++){
        const sequenceId = sequencesIds[i];
        if (sequenceId) {
            const sequenceMapping = (0, $d87c946ff7108f65$export$ac80cc81fdb4fb5a)[sequenceId];
            if (sequenceMapping) {
                sequenceMappings.push(sequenceMapping[0, $d87c946ff7108f65$export$ac331484967b91fa]);
                dir = sequenceMapping[0, $d87c946ff7108f65$export$d20107152a904e34];
            }
        }
    }
    // eslint-disable-next-line prefer-spread
    const resultClassesMap = Object.assign.apply(Object, // .assign() mutates the first object, we can't mutate mappings as it will produce invalid results later
    [
        {}
    ].concat(sequenceMappings));
    const [atomicClasses, classesMapHash] = (0, $b4a9599cfb094ec5$export$9398e6bbc32c24c4)(resultClassesMap, dir);
    // Each merge of classes generates a new sequence of atomic classes that needs to be registered
    const newSequenceHash = (0, $efbdbe9951925f14$export$714355b806f78694)(classesMapHash, dir, sequencesIds);
    const newClassName = newSequenceHash + ' ' + atomicClasses;
    $00898283de415a49$export$18cfd45882d1eee[sequenceMatch] = newClassName;
    (0, $d87c946ff7108f65$export$ac80cc81fdb4fb5a)[newSequenceHash] = [
        resultClassesMap,
        dir
    ];
    return resultClassName + newClassName;
}



'use client';
const $2cddb43132fbefae$export$23c54454bbeeabd4 = {
    root: 'fui-Image'
};
const $2cddb43132fbefae$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ],
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f1fabniw",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f14t3ns0"
    },
    bordered: {
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ]
    },
    circular: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f44lkw9"
    },
    rounded: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5"
    },
    square: {},
    shadow: {
        E5pizo: "f1whvlc6"
    },
    center: {
        st4lth: "f1plgu50",
        Ermj5k: "f14xojzb"
    },
    contain: {
        st4lth: "f1kle4es",
        Ermj5k: "f14xojzb"
    },
    "default": {},
    cover: {
        st4lth: "f1ps3kmd",
        Ermj5k: "f14xojzb"
    },
    none: {
        st4lth: "f1plgu50",
        Ermj5k: [
            "f13uwng7",
            "fjmyj0p"
        ]
    },
    fitFill: {
        Bqenvij: "f1l02sjl",
        a9b677: "fly5x3f"
    },
    block: {
        a9b677: "fly5x3f"
    }
}, {
    d: [
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}",
        [
            ".f1fabniw{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f14t3ns0{display:inline-block;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".f192inf7{border-top-width:var(--strokeWidthThin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        [
            ".f44lkw9{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f1whvlc6{box-shadow:var(--shadow4);}",
        ".f1plgu50{object-fit:none;}",
        ".f14xojzb{object-position:center;}",
        ".f1kle4es{object-fit:contain;}",
        ".f1ps3kmd{object-fit:cover;}",
        ".f13uwng7{object-position:left top;}",
        ".fjmyj0p{object-position:right top;}",
        ".f1l02sjl{height:100%;}",
        ".fly5x3f{width:100%;}"
    ]
});
const $2cddb43132fbefae$export$ad2d1362731f4225 = (state)=>{
    const styles = $2cddb43132fbefae$var$useStyles();
    const { height: height, width: width } = state.root;
    // eslint-disable-next-line eqeqeq
    const hasExplicitSize = height != null || width != null;
    const shouldApplyFitFill = state.fit !== 'default' && !hasExplicitSize;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($2cddb43132fbefae$export$23c54454bbeeabd4.root, styles.base, state.block && styles.block, state.bordered && styles.bordered, state.shadow && styles.shadow, styles[state.fit], shouldApplyFitFill && styles.fitFill, styles[state.shape], state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
const $df848b23091d7919$export$d1a6d8b46a5f8f83 = $acw62.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $df848b23091d7919$var$noop = ()=>{};
const $df848b23091d7919$export$f7e4b0d3f201e8be = $df848b23091d7919$export$d1a6d8b46a5f8f83.Provider;
const $df848b23091d7919$export$cf90cf4172902307 = (hook)=>{
    var _React_useContext;
    var _React_useContext_hook;
    return (_React_useContext_hook = (_React_useContext = $acw62.useContext($df848b23091d7919$export$d1a6d8b46a5f8f83)) === null || _React_useContext === void 0 ? void 0 : _React_useContext[hook]) !== null && _React_useContext_hook !== void 0 ? _React_useContext_hook : $df848b23091d7919$var$noop;
};


'use client';
const $d7c88be82614dab2$export$3e431a229df88919 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $9e411e4e93d009d7$export$e95ea34197117eb)(props, ref);
    (0, $2cddb43132fbefae$export$ad2d1362731f4225)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useImageStyles_unstable')(state);
    return (0, $995145210e0678db$export$70445376982a3a8b)(state);
});
$d7c88be82614dab2$export$3e431a229df88919.displayName = 'Image';


var $acw62 = parcelRequire("acw62");



const $e4ac2781c39ddd17$export$6b933eea0405bd18 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};


const $38bf99cb9f5ed2d0$export$546b1a6a3828c8cc = (props, ref)=>{
    const { wrap: wrap, truncate: truncate, block: block, italic: italic, underline: underline, strikethrough: strikethrough, size: size, font: font, weight: weight, align: align } = props;
    const state = {
        align: align !== null && align !== void 0 ? align : 'start',
        block: block !== null && block !== void 0 ? block : false,
        font: font !== null && font !== void 0 ? font : 'base',
        italic: italic !== null && italic !== void 0 ? italic : false,
        size: size !== null && size !== void 0 ? size : 300,
        strikethrough: strikethrough !== null && strikethrough !== void 0 ? strikethrough : false,
        truncate: truncate !== null && truncate !== void 0 ? truncate : false,
        underline: underline !== null && underline !== void 0 ? underline : false,
        weight: weight !== null && weight !== void 0 ? weight : 'regular',
        wrap: wrap !== null && wrap !== void 0 ? wrap : true,
        components: {
            root: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('span', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLHeadingElement & HTMLPreElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'span'
        })
    };
    return state;
};



'use client';
const $2d424633ffda5f6a$export$c2a588b7cc722032 = {
    root: 'fui-Text'
};
/**
 * Styles for the root slot
 */ const $2d424633ffda5f6a$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi",
        Bhrd7zp: "figsok6",
        fsow6f: "fpgzoln",
        mc9l5x: "f1w7gpdv",
        Huce71: "f6juhto",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg",
        ygn44y: "f2jf649"
    },
    nowrap: {
        Huce71: "fz5stix",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp"
    },
    truncate: {
        ygn44y: "f1cmbuwj"
    },
    block: {
        mc9l5x: "ftgm304"
    },
    italic: {
        B80ckks: "f1j4dglz"
    },
    underline: {
        w71qe1: "f13mvf36"
    },
    strikethrough: {
        w71qe1: "fv5q2k7"
    },
    strikethroughUnderline: {
        w71qe1: "f1drk4o6"
    },
    base100: {
        Be2twd7: "f13mqy1h",
        Bg96gwp: "fcpl73t"
    },
    base200: {
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm"
    },
    base400: {
        Be2twd7: "fod5ikn",
        Bg96gwp: "faaz57k"
    },
    base500: {
        Be2twd7: "f1pp30po",
        Bg96gwp: "f106mvju"
    },
    base600: {
        Be2twd7: "f1x0m3f5",
        Bg96gwp: "fb86gi6"
    },
    hero700: {
        Be2twd7: "fojgt09",
        Bg96gwp: "fcen8rp"
    },
    hero800: {
        Be2twd7: "fccw675",
        Bg96gwp: "f1ebx5kk"
    },
    hero900: {
        Be2twd7: "f15afnhw",
        Bg96gwp: "fr3w3wp"
    },
    hero1000: {
        Be2twd7: "fpyltcb",
        Bg96gwp: "f1ivgwrt"
    },
    monospace: {
        Bahqtrf: "f1fedwem"
    },
    numeric: {
        Bahqtrf: "f1uq0ln5"
    },
    weightMedium: {
        Bhrd7zp: "fdj6btp"
    },
    weightSemibold: {
        Bhrd7zp: "fl43uef"
    },
    weightBold: {
        Bhrd7zp: "flh3ekv"
    },
    alignCenter: {
        fsow6f: "f17mccla"
    },
    alignEnd: {
        fsow6f: "f12ymhq5"
    },
    alignJustify: {
        fsow6f: "f1j59e10"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fpgzoln{text-align:start;}",
        ".f1w7gpdv{display:inline;}",
        ".f6juhto{white-space:normal;}",
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        ".f2jf649{text-overflow:clip;}",
        ".fz5stix{white-space:nowrap;}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f1cmbuwj{text-overflow:ellipsis;}",
        ".ftgm304{display:block;}",
        ".f1j4dglz{font-style:italic;}",
        ".f13mvf36{text-decoration-line:underline;}",
        ".fv5q2k7{text-decoration-line:line-through;}",
        ".f1drk4o6{text-decoration-line:line-through underline;}",
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".fcpl73t{line-height:var(--lineHeightBase100);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}",
        ".f1x0m3f5{font-size:var(--fontSizeBase600);}",
        ".fb86gi6{line-height:var(--lineHeightBase600);}",
        ".fojgt09{font-size:var(--fontSizeHero700);}",
        ".fcen8rp{line-height:var(--lineHeightHero700);}",
        ".fccw675{font-size:var(--fontSizeHero800);}",
        ".f1ebx5kk{line-height:var(--lineHeightHero800);}",
        ".f15afnhw{font-size:var(--fontSizeHero900);}",
        ".fr3w3wp{line-height:var(--lineHeightHero900);}",
        ".fpyltcb{font-size:var(--fontSizeHero1000);}",
        ".f1ivgwrt{line-height:var(--lineHeightHero1000);}",
        ".f1fedwem{font-family:var(--fontFamilyMonospace);}",
        ".f1uq0ln5{font-family:var(--fontFamilyNumeric);}",
        ".fdj6btp{font-weight:var(--fontWeightMedium);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".flh3ekv{font-weight:var(--fontWeightBold);}",
        ".f17mccla{text-align:center;}",
        ".f12ymhq5{text-align:end;}",
        ".f1j59e10{text-align:justify;}"
    ]
});
const $2d424633ffda5f6a$export$d3aa483101121c70 = (state)=>{
    const styles = $2d424633ffda5f6a$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($2d424633ffda5f6a$export$c2a588b7cc722032.root, styles.root, state.wrap === false && styles.nowrap, state.truncate && styles.truncate, state.block && styles.block, state.italic && styles.italic, state.underline && styles.underline, state.strikethrough && styles.strikethrough, state.underline && state.strikethrough && styles.strikethroughUnderline, state.size === 100 && styles.base100, state.size === 200 && styles.base200, state.size === 400 && styles.base400, state.size === 500 && styles.base500, state.size === 600 && styles.base600, state.size === 700 && styles.hero700, state.size === 800 && styles.hero800, state.size === 900 && styles.hero900, state.size === 1000 && styles.hero1000, state.font === 'monospace' && styles.monospace, state.font === 'numeric' && styles.numeric, state.weight === 'medium' && styles.weightMedium, state.weight === 'semibold' && styles.weightSemibold, state.weight === 'bold' && styles.weightBold, state.align === 'center' && styles.alignCenter, state.align === 'end' && styles.alignEnd, state.align === 'justify' && styles.alignJustify, state.root.className);
    return state;
};


'use client';
function $b47caaa3576ee3da$export$b956d067c5bcf6b(options) {
    const { useStyles: useStyles, className: className, displayName: displayName } = options;
    const Wrapper = $acw62.forwardRef((props, ref)=>{
        const styles = useStyles();
        const state = (0, $38bf99cb9f5ed2d0$export$546b1a6a3828c8cc)(props, ref);
        (0, $2d424633ffda5f6a$export$d3aa483101121c70)(state);
        state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(className, state.root.className, styles.root, props.className);
        return (0, $e4ac2781c39ddd17$export$6b933eea0405bd18)(state);
    });
    Wrapper.displayName = displayName;
    return Wrapper;
}




'use client';
const $fcc201212d40967b$export$218c5832a5641360 = {
    root: 'fui-Title1'
};
const $fcc201212d40967b$export$17c6fbbc07dbd034 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fccw675",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1ebx5kk"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fccw675{font-size:var(--fontSizeHero800);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1ebx5kk{line-height:var(--lineHeightHero800);}"
    ]
});


'use client';
const $a8d3149b36fa86e7$export$b430003809b2cf7e = (0, $b47caaa3576ee3da$export$b956d067c5bcf6b)({
    useStyles: (0, $fcc201212d40967b$export$17c6fbbc07dbd034),
    className: (0, $fcc201212d40967b$export$218c5832a5641360).root,
    displayName: 'Title1'
});




'use client';
const $ecff98f03534e656$export$4033d342b0a0b8b8 = {
    root: 'fui-Body1'
};
const $ecff98f03534e656$export$ec1bd3d1a71231a7 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});


'use client';
const $278cdfe713a36b98$export$f4e011ec931200f4 = (0, $b47caaa3576ee3da$export$b956d067c5bcf6b)({
    useStyles: (0, $ecff98f03534e656$export$ec1bd3d1a71231a7),
    className: (0, $ecff98f03534e656$export$4033d342b0a0b8b8).root,
    displayName: 'Body1'
});


const $6b931413d2d51fae$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    pageContainer: {
        padding: "5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }
});
function $6b931413d2d51fae$export$f55a69b19f0fc324() {
    const styles = $6b931413d2d51fae$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: styles.pageContainer,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7c88be82614dab2$export$3e431a229df88919), {
                    src: "/images/webfail.svg",
                    alt: "404 icon",
                    style: {
                        maxWidth: "80px",
                        width: "100%"
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8d3149b36fa86e7$export$b430003809b2cf7e), {
                    children: "404: No Such Page"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $278cdfe713a36b98$export$f4e011ec931200f4), {
                    children: "We couldn't find the page you're looking for."
                })
            ]
        })
    });
}


/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ const $b5ad043d24ba28db$export$e4c89085febbc618 = {
    '2': '#050505',
    '4': '#0a0a0a',
    '6': '#0f0f0f',
    '8': '#141414',
    '10': '#1a1a1a',
    '12': '#1f1f1f',
    '14': '#242424',
    '16': '#292929',
    '18': '#2e2e2e',
    '20': '#333333',
    '22': '#383838',
    '24': '#3d3d3d',
    '26': '#424242',
    '28': '#474747',
    '30': '#4d4d4d',
    '32': '#525252',
    '34': '#575757',
    '36': '#5c5c5c',
    '38': '#616161',
    '40': '#666666',
    '42': '#6b6b6b',
    '44': '#707070',
    '46': '#757575',
    '48': '#7a7a7a',
    '50': '#808080',
    '52': '#858585',
    '54': '#8a8a8a',
    '56': '#8f8f8f',
    '58': '#949494',
    '60': '#999999',
    '62': '#9e9e9e',
    '64': '#a3a3a3',
    '66': '#a8a8a8',
    '68': '#adadad',
    '70': '#b3b3b3',
    '72': '#b8b8b8',
    '74': '#bdbdbd',
    '76': '#c2c2c2',
    '78': '#c7c7c7',
    '80': '#cccccc',
    '82': '#d1d1d1',
    '84': '#d6d6d6',
    '86': '#dbdbdb',
    '88': '#e0e0e0',
    '90': '#e6e6e6',
    '92': '#ebebeb',
    '94': '#f0f0f0',
    '96': '#f5f5f5',
    '98': '#fafafa',
    '99': '#fcfcfc'
};
const $b5ad043d24ba28db$export$2c27d7ccbdcc7b47 = {
    '5': 'rgba(255, 255, 255, 0.05)',
    '10': 'rgba(255, 255, 255, 0.1)',
    '20': 'rgba(255, 255, 255, 0.2)',
    '30': 'rgba(255, 255, 255, 0.3)',
    '40': 'rgba(255, 255, 255, 0.4)',
    '50': 'rgba(255, 255, 255, 0.5)',
    '60': 'rgba(255, 255, 255, 0.6)',
    '70': 'rgba(255, 255, 255, 0.7)',
    '80': 'rgba(255, 255, 255, 0.8)',
    '90': 'rgba(255, 255, 255, 0.9)'
};
const $b5ad043d24ba28db$export$8f3334164e0b2b5c = {
    '5': 'rgba(0, 0, 0, 0.05)',
    '10': 'rgba(0, 0, 0, 0.1)',
    '20': 'rgba(0, 0, 0, 0.2)',
    '30': 'rgba(0, 0, 0, 0.3)',
    '40': 'rgba(0, 0, 0, 0.4)',
    '50': 'rgba(0, 0, 0, 0.5)',
    '60': 'rgba(0, 0, 0, 0.6)',
    '70': 'rgba(0, 0, 0, 0.7)',
    '80': 'rgba(0, 0, 0, 0.8)',
    '90': 'rgba(0, 0, 0, 0.9)'
};
const $b5ad043d24ba28db$export$dbc00436b8ca4a1e = {
    '5': 'rgba(26, 26, 26, 0.05)',
    '10': 'rgba(26, 26, 26, 0.1)',
    '20': 'rgba(26, 26, 26, 0.2)',
    '30': 'rgba(26, 26, 26, 0.3)',
    '40': 'rgba(26, 26, 26, 0.4)',
    '50': 'rgba(26, 26, 26, 0.5)',
    '60': 'rgba(26, 26, 26, 0.6)',
    '70': 'rgba(26, 26, 26, 0.7)',
    '80': 'rgba(26, 26, 26, 0.8)',
    '90': 'rgba(26, 26, 26, 0.9)'
};
const $b5ad043d24ba28db$export$bf06a928c351ccfc = {
    '5': 'rgba(31, 31, 31, 0.05)',
    '10': 'rgba(31, 31, 31, 0.1)',
    '20': 'rgba(31, 31, 31, 0.2)',
    '30': 'rgba(31, 31, 31, 0.3)',
    '40': 'rgba(31, 31, 31, 0.4)',
    '50': 'rgba(31, 31, 31, 0.5)',
    '60': 'rgba(31, 31, 31, 0.6)',
    '70': 'rgba(31, 31, 31, 0.7)',
    '80': 'rgba(31, 31, 31, 0.8)',
    '90': 'rgba(31, 31, 31, 0.9)'
};
const $b5ad043d24ba28db$export$f146536593fee9ff = {
    '5': 'rgba(36, 36, 36, 0.05)',
    '10': 'rgba(36, 36, 36, 0.1)',
    '20': 'rgba(36, 36, 36, 0.2)',
    '30': 'rgba(36, 36, 36, 0.3)',
    '40': 'rgba(36, 36, 36, 0.4)',
    '50': 'rgba(36, 36, 36, 0.5)',
    '60': 'rgba(36, 36, 36, 0.6)',
    '70': 'rgba(36, 36, 36, 0.7)',
    '80': 'rgba(36, 36, 36, 0.8)',
    '90': 'rgba(36, 36, 36, 0.9)'
};
const $b5ad043d24ba28db$export$8fa4e5556fd77a60 = '#ffffff';
const $b5ad043d24ba28db$export$c073df10e766abfa = '#000000';
const $b5ad043d24ba28db$export$81de8a918392ac60 = '#ffff00';
const $b5ad043d24ba28db$export$2956f0c7e40f8adb = '#1aebff';
const $b5ad043d24ba28db$export$a98a110048f844c7 = '#3ff23f';
const $b5ad043d24ba28db$export$69ed68f0b7cf93f9 = '#000000';
const $b5ad043d24ba28db$export$5a5eaf27ddfba503 = '#ffffff';
const $b5ad043d24ba28db$export$a3d9060cec6dc0b6 = '#000000';
const $b5ad043d24ba28db$export$8c7cfe6119da801 = '#000000';
const $b5ad043d24ba28db$export$bf0b4078ca5e8271 = '#ffffff';
const $b5ad043d24ba28db$export$76a6bc0ea014735a = {
    shade50: '#130204',
    shade40: '#230308',
    shade30: '#420610',
    shade20: '#590815',
    shade10: '#690a19',
    primary: '#750b1c',
    tint10: '#861b2c',
    tint20: '#962f3f',
    tint30: '#ac4f5e',
    tint40: '#d69ca5',
    tint50: '#e9c7cd',
    tint60: '#f9f0f2'
};
const $b5ad043d24ba28db$export$a0627fd18a354ecb = {
    shade50: '#1a0607',
    shade40: '#310b0d',
    shade30: '#5c1519',
    shade20: '#7d1d21',
    shade10: '#942228',
    primary: '#a4262c',
    tint10: '#af393e',
    tint20: '#ba4d52',
    tint30: '#c86c70',
    tint40: '#e4afb2',
    tint50: '#f0d3d4',
    tint60: '#fbf4f4'
};
const $b5ad043d24ba28db$export$94cf3141ea3c5416 = {
    shade50: '#200205',
    shade40: '#3b0509',
    shade30: '#6e0811',
    shade20: '#960b18',
    shade10: '#b10e1c',
    primary: '#c50f1f',
    tint10: '#cc2635',
    tint20: '#d33f4c',
    tint30: '#dc626d',
    tint40: '#eeacb2',
    tint50: '#f6d1d5',
    tint60: '#fdf3f4'
};
const $b5ad043d24ba28db$export$a90204d1394caf30 = {
    shade50: '#210809',
    shade40: '#3f1011',
    shade30: '#751d1f',
    shade20: '#9f282b',
    shade10: '#bc2f32',
    primary: '#d13438',
    tint10: '#d7494c',
    tint20: '#dc5e62',
    tint30: '#e37d80',
    tint40: '#f1bbbc',
    tint50: '#f8dadb',
    tint60: '#fdf6f6'
};
const $b5ad043d24ba28db$export$4a29193d55cdecba = {
    shade50: '#230900',
    shade40: '#411200',
    shade30: '#7a2101',
    shade20: '#a62d01',
    shade10: '#c43501',
    primary: '#da3b01',
    tint10: '#de501c',
    tint20: '#e36537',
    tint30: '#e9835e',
    tint40: '#f4bfab',
    tint50: '#f9dcd1',
    tint60: '#fdf6f3'
};
const $b5ad043d24ba28db$export$7ce8b36d0b00eddb = {
    shade50: '#1b0a01',
    shade40: '#321303',
    shade30: '#5e2405',
    shade20: '#7f3107',
    shade10: '#963a08',
    primary: '#a74109',
    tint10: '#b2521e',
    tint20: '#bc6535',
    tint30: '#ca8057',
    tint40: '#e5bba4',
    tint50: '#f1d9cc',
    tint60: '#fbf5f2'
};
const $b5ad043d24ba28db$export$978fe4ac22d00df0 = {
    shade50: '#200d03',
    shade40: '#3d1805',
    shade30: '#712d09',
    shade20: '#9a3d0c',
    shade10: '#b6480e',
    primary: '#ca5010',
    tint10: '#d06228',
    tint20: '#d77440',
    tint30: '#df8e64',
    tint40: '#efc4ad',
    tint50: '#f7dfd2',
    tint60: '#fdf7f4'
};
const $b5ad043d24ba28db$export$ad766f34ace1cafd = {
    shade50: '#271002',
    shade40: '#4a1e04',
    shade30: '#8a3707',
    shade20: '#bc4b09',
    shade10: '#de590b',
    primary: '#f7630c',
    tint10: '#f87528',
    tint20: '#f98845',
    tint30: '#faa06b',
    tint40: '#fdcfb4',
    tint50: '#fee5d7',
    tint60: '#fff9f5'
};
const $b5ad043d24ba28db$export$c96cfe71516d2e98 = {
    shade50: '#291600',
    shade40: '#4d2a00',
    shade30: '#8f4e00',
    shade20: '#c26a00',
    shade10: '#e67e00',
    primary: '#ff8c00',
    tint10: '#ff9a1f',
    tint20: '#ffa83d',
    tint30: '#ffba66',
    tint40: '#ffddb3',
    tint50: '#ffedd6',
    tint60: '#fffaf5'
};
const $b5ad043d24ba28db$export$b8872f2e62a1cb31 = {
    shade50: '#251a00',
    shade40: '#463100',
    shade30: '#835b00',
    shade20: '#b27c00',
    shade10: '#d39300',
    primary: '#eaa300',
    tint10: '#edad1c',
    tint20: '#efb839',
    tint30: '#f2c661',
    tint40: '#f9e2ae',
    tint50: '#fcefd3',
    tint60: '#fefbf4'
};
const $b5ad043d24ba28db$export$594c5a8758200c32 = {
    shade50: '#282400',
    shade40: '#4c4400',
    shade30: '#817400',
    shade20: '#c0ad00',
    shade10: '#e4cc00',
    primary: '#fde300',
    tint10: '#fde61e',
    tint20: '#fdea3d',
    tint30: '#feee66',
    tint40: '#fef7b2',
    tint50: '#fffad6',
    tint60: '#fffef5'
};
const $b5ad043d24ba28db$export$c24201f7fe3571d8 = {
    shade50: '#1f1900',
    shade40: '#3a2f00',
    shade30: '#6c5700',
    shade20: '#937700',
    shade10: '#ae8c00',
    primary: '#c19c00',
    tint10: '#c8a718',
    tint20: '#d0b232',
    tint30: '#dac157',
    tint40: '#ecdfa5',
    tint50: '#f5eece',
    tint60: '#fdfbf2'
};
const $b5ad043d24ba28db$export$32afe192cbc0ce8f = {
    shade50: '#181202',
    shade40: '#2e2103',
    shade30: '#553e06',
    shade20: '#745408',
    shade10: '#89640a',
    primary: '#986f0b',
    tint10: '#a47d1e',
    tint20: '#b18c34',
    tint30: '#c1a256',
    tint40: '#e0cea2',
    tint50: '#efe4cb',
    tint60: '#fbf8f2'
};
const $b5ad043d24ba28db$export$b6e6178d3f565007 = {
    shade50: '#170e07',
    shade40: '#2b1a0e',
    shade30: '#50301a',
    shade20: '#6c4123',
    shade10: '#804d29',
    primary: '#8e562e',
    tint10: '#9c663f',
    tint20: '#a97652',
    tint30: '#bb8f6f',
    tint40: '#ddc3b0',
    tint50: '#edded3',
    tint60: '#faf7f4'
};
const $b5ad043d24ba28db$export$7faf1229eaed2d5a = {
    shade50: '#0c0704',
    shade40: '#170c08',
    shade30: '#2b1710',
    shade20: '#3a1f15',
    shade10: '#452519',
    primary: '#4d291c',
    tint10: '#623a2b',
    tint20: '#784d3e',
    tint30: '#946b5c',
    tint40: '#caada3',
    tint50: '#e3d2cb',
    tint60: '#f8f3f2'
};
const $b5ad043d24ba28db$export$221d31baf2636aad = {
    shade50: '#121b06',
    shade40: '#23330b',
    shade30: '#405f14',
    shade20: '#57811b',
    shade10: '#689920',
    primary: '#73aa24',
    tint10: '#81b437',
    tint20: '#90be4c',
    tint30: '#a4cc6c',
    tint40: '#cfe5af',
    tint50: '#e5f1d3',
    tint60: '#f8fcf4'
};
const $b5ad043d24ba28db$export$237f8a8a93370cbc = {
    shade50: '#0c1501',
    shade40: '#162702',
    shade30: '#294903',
    shade20: '#376304',
    shade10: '#427505',
    primary: '#498205',
    tint10: '#599116',
    tint20: '#6ba02b',
    tint30: '#85b44c',
    tint40: '#bdd99b',
    tint50: '#dbebc7',
    tint60: '#f6faf0'
};
const $b5ad043d24ba28db$export$462b2ea9f2b19f0a = {
    shade50: '#002111',
    shade40: '#003d20',
    shade30: '#00723b',
    shade20: '#009b51',
    shade10: '#00b85f',
    primary: '#00cc6a',
    tint10: '#19d279',
    tint20: '#34d889',
    tint30: '#5ae0a0',
    tint40: '#a8f0cd',
    tint50: '#cff7e4',
    tint60: '#f3fdf8'
};
const $b5ad043d24ba28db$export$559a8c00376dc936 = {
    shade50: '#031a02',
    shade40: '#063004',
    shade30: '#0b5a08',
    shade20: '#0e7a0b',
    shade10: '#11910d',
    primary: '#13a10e',
    tint10: '#27ac22',
    tint20: '#3db838',
    tint30: '#5ec75a',
    tint40: '#a7e3a5',
    tint50: '#cef0cd',
    tint60: '#f2fbf2'
};
const $b5ad043d24ba28db$export$955a2ebd2fb142ae = {
    shade50: '#031403',
    shade40: '#052505',
    shade30: '#094509',
    shade20: '#0c5e0c',
    shade10: '#0e700e',
    primary: '#107c10',
    tint10: '#218c21',
    tint20: '#359b35',
    tint30: '#54b054',
    tint40: '#9fd89f',
    tint50: '#c9eac9',
    tint60: '#f1faf1'
};
const $b5ad043d24ba28db$export$430774e3f59aae50 = {
    shade50: '#021102',
    shade40: '#032003',
    shade30: '#063b06',
    shade20: '#085108',
    shade10: '#0a5f0a',
    primary: '#0b6a0b',
    tint10: '#1a7c1a',
    tint20: '#2d8e2d',
    tint30: '#4da64d',
    tint40: '#9ad29a',
    tint50: '#c6e7c6',
    tint60: '#f0f9f0'
};
const $b5ad043d24ba28db$export$6d8f981b04aed00b = {
    shade50: '#001d1f',
    shade40: '#00373a',
    shade30: '#00666d',
    shade20: '#008b94',
    shade10: '#00a5af',
    primary: '#00b7c3',
    tint10: '#18bfca',
    tint20: '#32c8d1',
    tint30: '#58d3db',
    tint40: '#a6e9ed',
    tint50: '#cef3f5',
    tint60: '#f2fcfd'
};
const $b5ad043d24ba28db$export$8bf7dff220b82b4a = {
    shade50: '#001516',
    shade40: '#012728',
    shade30: '#02494c',
    shade20: '#026467',
    shade10: '#037679',
    primary: '#038387',
    tint10: '#159195',
    tint20: '#2aa0a4',
    tint30: '#4cb4b7',
    tint40: '#9bd9db',
    tint50: '#c7ebec',
    tint60: '#f0fafa'
};
const $b5ad043d24ba28db$export$26f90d83836189f4 = {
    shade50: '#001010',
    shade40: '#001f1f',
    shade30: '#003939',
    shade20: '#004e4e',
    shade10: '#005c5c',
    primary: '#006666',
    tint10: '#0e7878',
    tint20: '#218b8b',
    tint30: '#41a3a3',
    tint40: '#92d1d1',
    tint50: '#c2e7e7',
    tint60: '#eff9f9'
};
const $b5ad043d24ba28db$export$7474046f446842ee = {
    shade50: '#00181e',
    shade40: '#002e38',
    shade30: '#005669',
    shade20: '#00748f',
    shade10: '#008aa9',
    primary: '#0099bc',
    tint10: '#18a4c4',
    tint20: '#31afcc',
    tint30: '#56bfd7',
    tint40: '#a4deeb',
    tint50: '#cdedf4',
    tint60: '#f2fafc'
};
const $b5ad043d24ba28db$export$1b2526e493adfe9 = {
    shade50: '#000f12',
    shade40: '#001b22',
    shade30: '#00333f',
    shade20: '#004555',
    shade10: '#005265',
    primary: '#005b70',
    tint10: '#0f6c81',
    tint20: '#237d92',
    tint30: '#4496a9',
    tint40: '#94c8d4',
    tint50: '#c3e1e8',
    tint60: '#eff7f9'
};
const $b5ad043d24ba28db$export$7b0d29b70b435c21 = {
    shade50: '#091823',
    shade40: '#112d42',
    shade30: '#20547c',
    shade20: '#2c72a8',
    shade10: '#3487c7',
    primary: '#3a96dd',
    tint10: '#4fa1e1',
    tint20: '#65ade5',
    tint30: '#83bdeb',
    tint40: '#bfddf5',
    tint50: '#dcedfa',
    tint60: '#f6fafe'
};
const $b5ad043d24ba28db$export$2aa0182783e7e9de = {
    shade50: '#001322',
    shade40: '#002440',
    shade30: '#004377',
    shade20: '#005ba1',
    shade10: '#006cbf',
    primary: '#0078d4',
    tint10: '#1a86d9',
    tint20: '#3595de',
    tint30: '#5caae5',
    tint40: '#a9d3f2',
    tint50: '#d0e7f8',
    tint60: '#f3f9fd'
};
const $b5ad043d24ba28db$export$2ad0c329ccd958f8 = {
    shade50: '#000c16',
    shade40: '#00172a',
    shade30: '#002c4e',
    shade20: '#003b6a',
    shade10: '#00467e',
    primary: '#004e8c',
    tint10: '#125e9a',
    tint20: '#286fa8',
    tint30: '#4a89ba',
    tint40: '#9abfdc',
    tint50: '#c7dced',
    tint60: '#f0f6fa'
};
const $b5ad043d24ba28db$export$4b45ecf3922b2c9e = {
    shade50: '#000910',
    shade40: '#00111f',
    shade30: '#002039',
    shade20: '#002b4e',
    shade10: '#00335c',
    primary: '#003966',
    tint10: '#0e4a78',
    tint20: '#215c8b',
    tint30: '#4178a3',
    tint40: '#92b5d1',
    tint50: '#c2d6e7',
    tint60: '#eff4f9'
};
const $b5ad043d24ba28db$export$795f8b146347687c = {
    shade50: '#0d1126',
    shade40: '#182047',
    shade30: '#2c3c85',
    shade20: '#3c51b4',
    shade10: '#4760d5',
    primary: '#4f6bed',
    tint10: '#637cef',
    tint20: '#778df1',
    tint30: '#93a4f4',
    tint40: '#c8d1fa',
    tint50: '#e1e6fc',
    tint60: '#f7f9fe'
};
const $b5ad043d24ba28db$export$54a390250b5a3226 = {
    shade50: '#00061d',
    shade40: '#000c36',
    shade30: '#001665',
    shade20: '#001e89',
    shade10: '#0023a2',
    primary: '#0027b4',
    tint10: '#173bbd',
    tint20: '#3050c6',
    tint30: '#546fd2',
    tint40: '#a3b2e8',
    tint50: '#ccd5f3',
    tint60: '#f2f4fc'
};
const $b5ad043d24ba28db$export$6733231e677ed539 = {
    shade50: '#120f25',
    shade40: '#221d46',
    shade30: '#3f3682',
    shade20: '#5649b0',
    shade10: '#6656d1',
    primary: '#7160e8',
    tint10: '#8172eb',
    tint20: '#9184ee',
    tint30: '#a79cf1',
    tint40: '#d2ccf8',
    tint50: '#e7e4fb',
    tint60: '#f9f8fe'
};
const $b5ad043d24ba28db$export$e13cce2a2d16a9d4 = {
    shade50: '#0f0717',
    shade40: '#1c0e2b',
    shade30: '#341a51',
    shade20: '#46236e',
    shade10: '#532982',
    primary: '#5c2e91',
    tint10: '#6b3f9e',
    tint20: '#7c52ab',
    tint30: '#9470bd',
    tint40: '#c6b1de',
    tint50: '#e0d3ed',
    tint60: '#f7f4fb'
};
const $b5ad043d24ba28db$export$531848508337a8f0 = {
    shade50: '#0a0411',
    shade40: '#130820',
    shade30: '#240f3c',
    shade20: '#311552',
    shade10: '#3a1861',
    primary: '#401b6c',
    tint10: '#512b7e',
    tint20: '#633e8f',
    tint30: '#7e5ca7',
    tint40: '#b9a3d3',
    tint50: '#d8cce7',
    tint60: '#f5f2f9'
};
const $b5ad043d24ba28db$export$18ae87cb0ad417dd = {
    shade50: '#16101d',
    shade40: '#281e37',
    shade30: '#4c3867',
    shade20: '#674c8c',
    shade10: '#795aa6',
    primary: '#8764b8',
    tint10: '#9373c0',
    tint20: '#a083c9',
    tint30: '#b29ad4',
    tint40: '#d7caea',
    tint50: '#e9e2f4',
    tint60: '#f9f8fc'
};
const $b5ad043d24ba28db$export$e790e457d5be15f9 = {
    shade50: '#160418',
    shade40: '#29072e',
    shade30: '#4c0d55',
    shade20: '#671174',
    shade10: '#7a1589',
    primary: '#881798',
    tint10: '#952aa4',
    tint20: '#a33fb1',
    tint30: '#b55fc1',
    tint40: '#d9a7e0',
    tint50: '#eaceef',
    tint60: '#faf2fb'
};
const $b5ad043d24ba28db$export$aa5190c8aa93b338 = {
    shade50: '#1f091d',
    shade40: '#3a1136',
    shade30: '#6d2064',
    shade20: '#932b88',
    shade10: '#af33a1',
    primary: '#c239b3',
    tint10: '#c94cbc',
    tint20: '#d161c4',
    tint30: '#da7ed0',
    tint40: '#edbbe7',
    tint50: '#f5daf2',
    tint60: '#fdf5fc'
};
const $b5ad043d24ba28db$export$b6ee5bb1c79d6ef5 = {
    shade50: '#1c0b1f',
    shade40: '#35153a',
    shade30: '#63276d',
    shade20: '#863593',
    shade10: '#9f3faf',
    primary: '#b146c2',
    tint10: '#ba58c9',
    tint20: '#c36bd1',
    tint30: '#cf87da',
    tint40: '#e6bfed',
    tint50: '#f2dcf5',
    tint60: '#fcf6fd'
};
const $b5ad043d24ba28db$export$47853bc718611763 = {
    shade50: '#24091b',
    shade40: '#441232',
    shade30: '#80215d',
    shade20: '#ad2d7e',
    shade10: '#cd3595',
    primary: '#e43ba6',
    tint10: '#e750b0',
    tint20: '#ea66ba',
    tint30: '#ef85c8',
    tint40: '#f7c0e3',
    tint50: '#fbddf0',
    tint60: '#fef6fb'
};
const $b5ad043d24ba28db$export$9e214c7c54526b7e = {
    shade50: '#240016',
    shade40: '#44002a',
    shade30: '#7f004e',
    shade20: '#ad006a',
    shade10: '#cc007e',
    primary: '#e3008c',
    tint10: '#e61c99',
    tint20: '#ea38a6',
    tint30: '#ee5fb7',
    tint40: '#f7adda',
    tint50: '#fbd2eb',
    tint60: '#fef4fa'
};
const $b5ad043d24ba28db$export$2a9ca2e383622e18 = {
    shade50: '#1f0013',
    shade40: '#390024',
    shade30: '#6b0043',
    shade20: '#91005a',
    shade10: '#ac006b',
    primary: '#bf0077',
    tint10: '#c71885',
    tint20: '#ce3293',
    tint30: '#d957a8',
    tint40: '#eca5d1',
    tint50: '#f5cee6',
    tint60: '#fcf2f9'
};
const $b5ad043d24ba28db$export$7e2f956ffaea92f4 = {
    shade50: '#13000c',
    shade40: '#240017',
    shade30: '#43002b',
    shade20: '#5a003b',
    shade10: '#6b0045',
    primary: '#77004d',
    tint10: '#87105d',
    tint20: '#98246f',
    tint30: '#ad4589',
    tint40: '#d696c0',
    tint50: '#e9c4dc',
    tint60: '#faf0f6'
};
const $b5ad043d24ba28db$export$67f6b138820ffeff = {
    shade50: '#141313',
    shade40: '#252323',
    shade30: '#444241',
    shade20: '#5d5958',
    shade10: '#6e6968',
    primary: '#7a7574',
    tint10: '#8a8584',
    tint20: '#9a9594',
    tint30: '#afabaa',
    tint40: '#d7d4d4',
    tint50: '#eae8e8',
    tint60: '#faf9f9'
};
const $b5ad043d24ba28db$export$b1b33eef2ea56364 = {
    shade50: '#0f0e0e',
    shade40: '#1c1b1a',
    shade30: '#343231',
    shade20: '#474443',
    shade10: '#54514f',
    primary: '#5d5a58',
    tint10: '#706d6b',
    tint20: '#84817e',
    tint30: '#9e9b99',
    tint40: '#cecccb',
    tint50: '#e5e4e3',
    tint60: '#f8f8f8'
};
const $b5ad043d24ba28db$export$2cf0ade8bd62135d = {
    shade50: '#151818',
    shade40: '#282d2e',
    shade30: '#4a5356',
    shade20: '#657174',
    shade10: '#78868a',
    primary: '#859599',
    tint10: '#92a1a5',
    tint20: '#a0aeb1',
    tint30: '#b3bfc2',
    tint40: '#d8dfe0',
    tint50: '#eaeeef',
    tint60: '#fafbfb'
};
const $b5ad043d24ba28db$export$6bdaf02d1a16321f = {
    shade50: '#111314',
    shade40: '#1f2426',
    shade30: '#3b4447',
    shade20: '#505c60',
    shade10: '#5f6d71',
    primary: '#69797e',
    tint10: '#79898d',
    tint20: '#89989d',
    tint30: '#a0adb2',
    tint40: '#cdd6d8',
    tint50: '#e4e9ea',
    tint60: '#f8f9fa'
};
const $b5ad043d24ba28db$export$2e2992790a6f69a8 = {
    shade50: '#090a0b',
    shade40: '#111315',
    shade30: '#202427',
    shade20: '#2b3135',
    shade10: '#333a3f',
    primary: '#394146',
    tint10: '#4d565c',
    tint20: '#626c72',
    tint30: '#808a90',
    tint40: '#bcc3c7',
    tint50: '#dbdfe1',
    tint60: '#f6f7f8'
};
const $b5ad043d24ba28db$export$c8b8418aada2724d = {
    shade50: '#090909',
    shade40: '#111111',
    shade30: '#202020',
    shade20: '#2b2b2b',
    shade10: '#333333',
    primary: '#393939',
    tint10: '#515151',
    tint20: '#686868',
    tint30: '#888888',
    tint40: '#c4c4c4',
    tint50: '#dfdfdf',
    tint60: '#f7f7f7'
};


const $63dac749da2ca71c$export$4c0b5edd4f42c93 = {
    red: $b5ad043d24ba28db$export$a90204d1394caf30,
    green: $b5ad043d24ba28db$export$955a2ebd2fb142ae,
    darkOrange: $b5ad043d24ba28db$export$4a29193d55cdecba,
    yellow: $b5ad043d24ba28db$export$594c5a8758200c32,
    berry: $b5ad043d24ba28db$export$aa5190c8aa93b338,
    lightGreen: $b5ad043d24ba28db$export$559a8c00376dc936,
    marigold: $b5ad043d24ba28db$export$b8872f2e62a1cb31
};
const $63dac749da2ca71c$export$dcab5894597dfcba = {
    darkRed: $b5ad043d24ba28db$export$76a6bc0ea014735a,
    cranberry: $b5ad043d24ba28db$export$94cf3141ea3c5416,
    pumpkin: $b5ad043d24ba28db$export$978fe4ac22d00df0,
    peach: $b5ad043d24ba28db$export$c96cfe71516d2e98,
    gold: $b5ad043d24ba28db$export$c24201f7fe3571d8,
    brass: $b5ad043d24ba28db$export$32afe192cbc0ce8f,
    brown: $b5ad043d24ba28db$export$b6e6178d3f565007,
    forest: $b5ad043d24ba28db$export$237f8a8a93370cbc,
    seafoam: $b5ad043d24ba28db$export$462b2ea9f2b19f0a,
    darkGreen: $b5ad043d24ba28db$export$430774e3f59aae50,
    lightTeal: $b5ad043d24ba28db$export$6d8f981b04aed00b,
    teal: $b5ad043d24ba28db$export$8bf7dff220b82b4a,
    steel: $b5ad043d24ba28db$export$1b2526e493adfe9,
    blue: $b5ad043d24ba28db$export$2aa0182783e7e9de,
    royalBlue: $b5ad043d24ba28db$export$2ad0c329ccd958f8,
    cornflower: $b5ad043d24ba28db$export$795f8b146347687c,
    navy: $b5ad043d24ba28db$export$54a390250b5a3226,
    lavender: $b5ad043d24ba28db$export$6733231e677ed539,
    purple: $b5ad043d24ba28db$export$e13cce2a2d16a9d4,
    grape: $b5ad043d24ba28db$export$e790e457d5be15f9,
    lilac: $b5ad043d24ba28db$export$b6ee5bb1c79d6ef5,
    pink: $b5ad043d24ba28db$export$47853bc718611763,
    magenta: $b5ad043d24ba28db$export$2a9ca2e383622e18,
    plum: $b5ad043d24ba28db$export$7e2f956ffaea92f4,
    beige: $b5ad043d24ba28db$export$67f6b138820ffeff,
    mink: $b5ad043d24ba28db$export$b1b33eef2ea56364,
    platinum: $b5ad043d24ba28db$export$6bdaf02d1a16321f,
    anchor: $b5ad043d24ba28db$export$2e2992790a6f69a8
};
const $63dac749da2ca71c$export$1e10db4a50d6990f = {
    cranberry: $b5ad043d24ba28db$export$94cf3141ea3c5416,
    green: $b5ad043d24ba28db$export$955a2ebd2fb142ae,
    orange: $b5ad043d24ba28db$export$ad766f34ace1cafd
};


/* Names of colors used in shared color palette alias tokens for status. */ const $645e5d53bca43f72$export$64b4612230bf8b2e = [
    'red',
    'green',
    'darkOrange',
    'yellow',
    'berry',
    'lightGreen',
    'marigold'
];
const $645e5d53bca43f72$export$426ec1c4cd4b768b = [
    'darkRed',
    'cranberry',
    'pumpkin',
    'peach',
    'gold',
    'brass',
    'brown',
    'forest',
    'seafoam',
    'darkGreen',
    'lightTeal',
    'teal',
    'steel',
    'blue',
    'royalBlue',
    'cornflower',
    'navy',
    'lavender',
    'purple',
    'grape',
    'lilac',
    'pink',
    'magenta',
    'plum',
    'beige',
    'mink',
    'platinum',
    'anchor'
];
const $645e5d53bca43f72$export$e8a467959e154e9f = [
    'cranberry',
    'green',
    'orange'
];
const $645e5d53bca43f72$export$40d9527c4c20ee9 = [
    'burgundy',
    'bronze',
    'orange',
    'darkBrown',
    'lime',
    'darkTeal',
    'cyan',
    'lightBlue',
    'darkBlue',
    'darkPurple',
    'orchid',
    'hotPink',
    'silver',
    'charcoal'
];


const $7c62b853e5b72fe4$export$f03eacea8b051531 = {
    success: 'green',
    warning: 'orange',
    danger: 'cranberry'
};


const $ef31f20e44253014$var$statusColorPaletteTokens = (0, $645e5d53bca43f72$export$64b4612230bf8b2e).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint60,
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint40,
        [`colorPalette${color}Background3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Foreground1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade10,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade30,
        [`colorPalette${color}Foreground3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Border1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint40,
        [`colorPalette${color}Border2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
// one-off patch for yellow
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteYellowForeground1 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).yellow.shade30;
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteRedForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.tint20;
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteGreenForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.tint20;
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteYellowForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).yellow.tint40;
const $ef31f20e44253014$var$personaColorPaletteTokens = (0, $645e5d53bca43f72$export$426ec1c4cd4b768b).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].tint40,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].shade30,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].primary
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
const $ef31f20e44253014$export$d72a599962b8f734 = {
    ...$ef31f20e44253014$var$statusColorPaletteTokens,
    ...$ef31f20e44253014$var$personaColorPaletteTokens
};
const $ef31f20e44253014$export$3557c617aeef1561 = Object.entries((0, $7c62b853e5b72fe4$export$f03eacea8b051531)).reduce((acc, [statusColor, sharedColor])=>{
    const color = statusColor.slice(0, 1).toUpperCase() + statusColor.slice(1);
    // TODO: double check the mapping with design
    const statusColorTokens = {
        [`colorStatus${color}Background1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint60,
        [`colorStatus${color}Background2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint40,
        [`colorStatus${color}Background3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Foreground1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade10,
        [`colorStatus${color}Foreground2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade30,
        [`colorStatus${color}Foreground3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}ForegroundInverted`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint30,
        [`colorStatus${color}BorderActive`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Border1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint40,
        [`colorStatus${color}Border2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary
    };
    return Object.assign(acc, statusColorTokens);
}, {});
// one-off overrides for colorStatus tokens
$ef31f20e44253014$export$3557c617aeef1561.colorStatusDangerBackground3Hover = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade10;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusDangerBackground3Pressed = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade20;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusWarningForeground1 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusWarningForeground3 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusWarningBorder2 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;


/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ 
const $8229bf3c6591f767$export$ad9a05e30090f047 = (brand)=>({
        colorNeutralForeground1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground2Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2BrandHover: brand[80],
        colorNeutralForeground2BrandPressed: brand[70],
        colorNeutralForeground2BrandSelected: brand[80],
        colorNeutralForeground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[38],
        colorNeutralForeground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground3BrandHover: brand[80],
        colorNeutralForeground3BrandPressed: brand[70],
        colorNeutralForeground3BrandSelected: brand[80],
        colorNeutralForeground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[44],
        colorNeutralForeground5: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[38],
        colorNeutralForeground5Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground5Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground5Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[74],
        colorNeutralForegroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorBrandForegroundLink: brand[70],
        colorBrandForegroundLinkHover: brand[60],
        colorBrandForegroundLinkPressed: brand[40],
        colorBrandForegroundLinkSelected: brand[70],
        colorNeutralForeground2Link: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground2LinkHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2LinkPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2LinkSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorCompoundBrandForeground1: brand[80],
        colorCompoundBrandForeground1Hover: brand[70],
        colorCompoundBrandForeground1Pressed: brand[60],
        colorBrandForeground1: brand[80],
        colorBrandForeground2: brand[70],
        colorBrandForeground2Hover: brand[60],
        colorBrandForeground2Pressed: brand[30],
        colorNeutralForeground1Static: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundStaticInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInverted2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundOnBrand: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLink: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandForegroundInverted: brand[100],
        colorBrandForegroundInvertedHover: brand[110],
        colorBrandForegroundInvertedPressed: brand[100],
        colorBrandForegroundOnLight: brand[80],
        colorBrandForegroundOnLightHover: brand[70],
        colorBrandForegroundOnLightPressed: brand[50],
        colorBrandForegroundOnLightSelected: brand[60],
        colorNeutralBackground1: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackground1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralBackground1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralBackground2Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackground2Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[86],
        colorNeutralBackground2Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[90],
        colorNeutralBackground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralBackground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralBackground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackground4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralBackground4Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground4Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackground5: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground5Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground5Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackground5Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralBackground6: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[90],
        colorNeutralBackground7: '#00000000',
        colorNeutralBackground7Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground7Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralBackground7Selected: '#00000000',
        colorNeutralBackground8: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[99],
        colorNeutralBackgroundInverted: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorNeutralBackgroundStatic: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralBackgroundAlpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[50],
        colorNeutralBackgroundAlpha2: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[80],
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorSubtleBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorSubtleBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorSubtleBackgroundLightAlphaHover: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[70],
        colorSubtleBackgroundLightAlphaPressed: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[50],
        colorSubtleBackgroundLightAlphaSelected: 'transparent',
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[10],
        colorSubtleBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[30],
        colorSubtleBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[20],
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: 'transparent',
        colorTransparentBackgroundPressed: 'transparent',
        colorTransparentBackgroundSelected: 'transparent',
        colorNeutralBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackgroundDisabled2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackgroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStencil1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[90],
        colorNeutralStencil2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralStencil1Alpha: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[10],
        colorNeutralStencil2Alpha: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[5],
        colorBackgroundOverlay: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[40],
        colorScrollbarOverlay: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[50],
        colorBrandBackground: brand[80],
        colorBrandBackgroundHover: brand[70],
        colorBrandBackgroundPressed: brand[40],
        colorBrandBackgroundSelected: brand[60],
        colorCompoundBrandBackground: brand[80],
        colorCompoundBrandBackgroundHover: brand[70],
        colorCompoundBrandBackgroundPressed: brand[60],
        colorBrandBackgroundStatic: brand[80],
        colorBrandBackground2: brand[160],
        colorBrandBackground2Hover: brand[150],
        colorBrandBackground2Pressed: brand[130],
        colorBrandBackground3Static: brand[60],
        colorBrandBackground4Static: brand[40],
        colorBrandBackgroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandBackgroundInvertedHover: brand[160],
        colorBrandBackgroundInvertedPressed: brand[140],
        colorBrandBackgroundInvertedSelected: brand[150],
        colorNeutralCardBackground: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralCardBackgroundHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralCardBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralCardBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralCardBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralStrokeAccessible: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[38],
        colorNeutralStrokeAccessibleHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[34],
        colorNeutralStrokeAccessiblePressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[30],
        colorNeutralStrokeAccessibleSelected: brand[80],
        colorNeutralStroke1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[82],
        colorNeutralStroke1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[78],
        colorNeutralStroke1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[70],
        colorNeutralStroke1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[74],
        colorNeutralStroke2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStroke3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralStroke4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralStroke4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStroke4Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralStroke4Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralStrokeSubtle: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStrokeOnBrand: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandStroke1: brand[80],
        colorBrandStroke2: brand[140],
        colorBrandStroke2Hover: brand[120],
        colorBrandStroke2Pressed: brand[80],
        colorBrandStroke2Contrast: brand[140],
        colorCompoundBrandStroke: brand[80],
        colorCompoundBrandStrokeHover: brand[70],
        colorCompoundBrandStrokePressed: brand[60],
        colorNeutralStrokeDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStrokeDisabled2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralStrokeInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorTransparentStroke: 'transparent',
        colorTransparentStrokeInteractive: 'transparent',
        colorTransparentStrokeDisabled: 'transparent',
        colorNeutralStrokeAlpha: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[5],
        colorNeutralStrokeAlpha2: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[20],
        colorStrokeFocus1: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorStrokeFocus2: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.06)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.07)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.20)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.24)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });


const $ce6bdb492800e603$export$7a57f79000377ca2 = {
    borderRadiusNone: '0',
    borderRadiusSmall: '2px',
    borderRadiusMedium: '4px',
    borderRadiusLarge: '6px',
    borderRadiusXLarge: '8px',
    borderRadius2XLarge: '12px',
    borderRadius3XLarge: '16px',
    borderRadius4XLarge: '24px',
    borderRadius5XLarge: '32px',
    borderRadius6XLarge: '40px',
    borderRadiusCircular: '10000px'
};

const $acaa7b1cbd308031$export$67baea80019ff381 = {
    fontSizeBase100: '10px',
    fontSizeBase200: '12px',
    fontSizeBase300: '14px',
    fontSizeBase400: '16px',
    fontSizeBase500: '20px',
    fontSizeBase600: '24px',
    fontSizeHero700: '28px',
    fontSizeHero800: '32px',
    fontSizeHero900: '40px',
    fontSizeHero1000: '68px'
};
const $acaa7b1cbd308031$export$e646ed6b629bf51e = {
    lineHeightBase100: '14px',
    lineHeightBase200: '16px',
    lineHeightBase300: '20px',
    lineHeightBase400: '22px',
    lineHeightBase500: '28px',
    lineHeightBase600: '32px',
    lineHeightHero700: '36px',
    lineHeightHero800: '40px',
    lineHeightHero900: '52px',
    lineHeightHero1000: '92px'
};
const $acaa7b1cbd308031$export$59230918eb9bd861 = {
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemibold: 600,
    fontWeightBold: 700
};
const $acaa7b1cbd308031$export$709a39c897136e8 = {
    fontFamilyBase: "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
    fontFamilyMonospace: "Consolas, 'Courier New', Courier, monospace",
    fontFamilyNumeric: "Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"
};

const $69e80ab434f476c6$export$fe6cfaf27a046d4c = {
    strokeWidthThin: '1px',
    strokeWidthThick: '2px',
    strokeWidthThicker: '3px',
    strokeWidthThickest: '4px'
};


function $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f(ambientColor, keyColor, tokenSuffix = '') {
    return {
        [`shadow2${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 1px 2px ${keyColor}`,
        [`shadow4${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 2px 4px ${keyColor}`,
        [`shadow8${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 4px 8px ${keyColor}`,
        [`shadow16${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 8px 16px ${keyColor}`,
        [`shadow28${tokenSuffix}`]: `0 0 8px ${ambientColor}, 0 14px 28px ${keyColor}`,
        [`shadow64${tokenSuffix}`]: `0 0 8px ${ambientColor}, 0 32px 64px ${keyColor}`
    };
}


const $1ac2042b55cb6fc4$export$38b928a7167ce124 = {
    durationUltraFast: '50ms',
    durationFaster: '100ms',
    durationFast: '150ms',
    durationNormal: '200ms',
    durationGentle: '250ms',
    durationSlow: '300ms',
    durationSlower: '400ms',
    durationUltraSlow: '500ms'
};


const $a38b2c50157e284b$export$6894093bf294bea5 = {
    curveAccelerateMax: 'cubic-bezier(0.9,0.1,1,0.2)',
    curveAccelerateMid: 'cubic-bezier(1,0,1,1)',
    curveAccelerateMin: 'cubic-bezier(0.8,0,0.78,1)',
    curveDecelerateMax: 'cubic-bezier(0.1,0.9,0.2,1)',
    curveDecelerateMid: 'cubic-bezier(0,0,0,1)',
    curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
    curveEasyEaseMax: 'cubic-bezier(0.8,0,0.2,1)',
    curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
    curveLinear: 'cubic-bezier(0,0,1,1)'
};


// Intentionally not exported! Use horizontalSpacings and verticalSpacings instead.
const $d15e16efc3c976b1$var$spacings = {
    none: '0',
    xxs: '2px',
    xs: '4px',
    sNudge: '6px',
    s: '8px',
    mNudge: '10px',
    m: '12px',
    l: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px'
};
const $d15e16efc3c976b1$export$a4db2e0274ce31ed = {
    spacingHorizontalNone: $d15e16efc3c976b1$var$spacings.none,
    spacingHorizontalXXS: $d15e16efc3c976b1$var$spacings.xxs,
    spacingHorizontalXS: $d15e16efc3c976b1$var$spacings.xs,
    spacingHorizontalSNudge: $d15e16efc3c976b1$var$spacings.sNudge,
    spacingHorizontalS: $d15e16efc3c976b1$var$spacings.s,
    spacingHorizontalMNudge: $d15e16efc3c976b1$var$spacings.mNudge,
    spacingHorizontalM: $d15e16efc3c976b1$var$spacings.m,
    spacingHorizontalL: $d15e16efc3c976b1$var$spacings.l,
    spacingHorizontalXL: $d15e16efc3c976b1$var$spacings.xl,
    spacingHorizontalXXL: $d15e16efc3c976b1$var$spacings.xxl,
    spacingHorizontalXXXL: $d15e16efc3c976b1$var$spacings.xxxl
};
const $d15e16efc3c976b1$export$9f57b7461d659f60 = {
    spacingVerticalNone: $d15e16efc3c976b1$var$spacings.none,
    spacingVerticalXXS: $d15e16efc3c976b1$var$spacings.xxs,
    spacingVerticalXS: $d15e16efc3c976b1$var$spacings.xs,
    spacingVerticalSNudge: $d15e16efc3c976b1$var$spacings.sNudge,
    spacingVerticalS: $d15e16efc3c976b1$var$spacings.s,
    spacingVerticalMNudge: $d15e16efc3c976b1$var$spacings.mNudge,
    spacingVerticalM: $d15e16efc3c976b1$var$spacings.m,
    spacingVerticalL: $d15e16efc3c976b1$var$spacings.l,
    spacingVerticalXL: $d15e16efc3c976b1$var$spacings.xl,
    spacingVerticalXXL: $d15e16efc3c976b1$var$spacings.xxl,
    spacingVerticalXXXL: $d15e16efc3c976b1$var$spacings.xxxl
};


const $e46fa2d032c035de$export$433454ecdac7def9 = (brand)=>{
    const colorTokens = (0, $8229bf3c6591f767$export$ad9a05e30090f047)(brand);
    return {
        ...(0, $ce6bdb492800e603$export$7a57f79000377ca2),
        ...(0, $acaa7b1cbd308031$export$67baea80019ff381),
        ...(0, $acaa7b1cbd308031$export$e646ed6b629bf51e),
        ...(0, $acaa7b1cbd308031$export$709a39c897136e8),
        ...(0, $acaa7b1cbd308031$export$59230918eb9bd861),
        ...(0, $69e80ab434f476c6$export$fe6cfaf27a046d4c),
        ...(0, $d15e16efc3c976b1$export$a4db2e0274ce31ed),
        ...(0, $d15e16efc3c976b1$export$9f57b7461d659f60),
        ...(0, $1ac2042b55cb6fc4$export$38b928a7167ce124),
        ...(0, $a38b2c50157e284b$export$6894093bf294bea5),
        ...colorTokens,
        ...(0, $ef31f20e44253014$export$d72a599962b8f734),
        ...(0, $ef31f20e44253014$export$3557c617aeef1561),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, 'Brand')
    };
};

/* color palette used in both darkTheme and teamsDarkTheme */ 


const $1e4b4c09e9bf881e$var$statusColorPaletteTokens = (0, $645e5d53bca43f72$export$64b4612230bf8b2e).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade40,
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade30,
        [`colorPalette${color}Background3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Foreground1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint30,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint40,
        [`colorPalette${color}Foreground3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint20,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint30,
        [`colorPalette${color}Border1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Border2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint20
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
// one-off patches
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteRedForeground3 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteRedBorder2 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteGreenForeground3 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.tint40;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteGreenBorder2 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.tint40;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteDarkOrangeForeground3 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).darkOrange.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteDarkOrangeBorder2 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).darkOrange.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteRedForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.primary;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteGreenForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.primary;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteYellowForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).yellow.shade30;
const $1e4b4c09e9bf881e$var$personaColorPaletteTokens = (0, $645e5d53bca43f72$export$426ec1c4cd4b768b).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].shade30,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].tint40,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].tint30
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
// one-off patches
$1e4b4c09e9bf881e$var$personaColorPaletteTokens.colorPaletteDarkRedBackground2 = (0, $63dac749da2ca71c$export$dcab5894597dfcba).darkRed.shade20;
$1e4b4c09e9bf881e$var$personaColorPaletteTokens.colorPalettePlumBackground2 = (0, $63dac749da2ca71c$export$dcab5894597dfcba).plum.shade20;
const $1e4b4c09e9bf881e$export$d72a599962b8f734 = {
    ...$1e4b4c09e9bf881e$var$statusColorPaletteTokens,
    ...$1e4b4c09e9bf881e$var$personaColorPaletteTokens
};
const $1e4b4c09e9bf881e$export$3557c617aeef1561 = Object.entries((0, $7c62b853e5b72fe4$export$f03eacea8b051531)).reduce((acc, [statusColor, sharedColor])=>{
    const color = statusColor.slice(0, 1).toUpperCase() + statusColor.slice(1);
    // TODO: double check the mapping with design - see the one-off patches above
    const statusColorTokens = {
        [`colorStatus${color}Background1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade40,
        [`colorStatus${color}Background2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade30,
        [`colorStatus${color}Background3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Foreground1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint30,
        [`colorStatus${color}Foreground2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint40,
        [`colorStatus${color}Foreground3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint20,
        [`colorStatus${color}BorderActive`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint30,
        [`colorStatus${color}ForegroundInverted`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade10,
        [`colorStatus${color}Border1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Border2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint20
    };
    return Object.assign(acc, statusColorTokens);
}, {});
// one-off overrides for colorStatus tokens
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerBackground3Hover = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade10;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerBackground3Pressed = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade20;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerForeground3 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].tint40;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerBorder2 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].tint30;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusSuccessForeground3 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).success].tint40;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusSuccessBorder2 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).success].tint40;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusWarningForegroundInverted = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;


/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ 
const $cfd91c97cbdedd72$export$ad9a05e30090f047 = (brand)=>({
        colorNeutralForeground1: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground1Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground1Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground1Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground2Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2BrandHover: brand[100],
        colorNeutralForeground2BrandPressed: brand[90],
        colorNeutralForeground2BrandSelected: brand[100],
        colorNeutralForeground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[68],
        colorNeutralForeground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground3BrandHover: brand[100],
        colorNeutralForeground3BrandPressed: brand[90],
        colorNeutralForeground3BrandSelected: brand[100],
        colorNeutralForeground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[60],
        colorNeutralForeground5: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[68],
        colorNeutralForeground5Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground5Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground5Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[36],
        colorNeutralForegroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorBrandForegroundLink: brand[100],
        colorBrandForegroundLinkHover: brand[110],
        colorBrandForegroundLinkPressed: brand[90],
        colorBrandForegroundLinkSelected: brand[100],
        colorNeutralForeground2Link: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground2LinkHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2LinkPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2LinkSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorCompoundBrandForeground1: brand[100],
        colorCompoundBrandForeground1Hover: brand[110],
        colorCompoundBrandForeground1Pressed: brand[90],
        colorBrandForeground1: brand[100],
        colorBrandForeground2: brand[110],
        colorBrandForeground2Hover: brand[130],
        colorBrandForeground2Pressed: brand[160],
        colorNeutralForeground1Static: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundStaticInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInverted: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInvertedHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInvertedPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInvertedSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInverted2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundOnBrand: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLink: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandForegroundInverted: brand[80],
        colorBrandForegroundInvertedHover: brand[70],
        colorBrandForegroundInvertedPressed: brand[60],
        colorBrandForegroundOnLight: brand[80],
        colorBrandForegroundOnLightHover: brand[70],
        colorBrandForegroundOnLightPressed: brand[50],
        colorBrandForegroundOnLightSelected: brand[60],
        colorNeutralBackground1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackground1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralBackground1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackground1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorNeutralBackground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackground2Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralBackground2Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackground2Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorNeutralBackground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralBackground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralBackground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralBackground4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackground4Pressed: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorNeutralBackground4Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[10],
        colorNeutralBackground5: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorNeutralBackground5Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackground5Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[2],
        colorNeutralBackground5Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[6],
        colorNeutralBackground6: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralBackground7: '#00000000',
        colorNeutralBackground7Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[10],
        colorNeutralBackground7Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralBackground7Selected: '#00000000',
        colorNeutralBackground8: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackgroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackgroundStatic: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralBackgroundAlpha: (0, $b5ad043d24ba28db$export$dbc00436b8ca4a1e)[50],
        colorNeutralBackgroundAlpha2: (0, $b5ad043d24ba28db$export$bf06a928c351ccfc)[70],
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorSubtleBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorSubtleBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorSubtleBackgroundLightAlphaHover: (0, $b5ad043d24ba28db$export$f146536593fee9ff)[80],
        colorSubtleBackgroundLightAlphaPressed: (0, $b5ad043d24ba28db$export$f146536593fee9ff)[50],
        colorSubtleBackgroundLightAlphaSelected: 'transparent',
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[10],
        colorSubtleBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[30],
        colorSubtleBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[20],
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: 'transparent',
        colorTransparentBackgroundPressed: 'transparent',
        colorTransparentBackgroundSelected: 'transparent',
        colorNeutralBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackgroundDisabled2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackgroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStencil1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[34],
        colorNeutralStencil2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralStencil1Alpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStencil2Alpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[5],
        colorBackgroundOverlay: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[50],
        colorScrollbarOverlay: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[60],
        colorBrandBackground: brand[70],
        colorBrandBackgroundHover: brand[80],
        colorBrandBackgroundPressed: brand[40],
        colorBrandBackgroundSelected: brand[60],
        colorCompoundBrandBackground: brand[100],
        colorCompoundBrandBackgroundHover: brand[110],
        colorCompoundBrandBackgroundPressed: brand[90],
        colorBrandBackgroundStatic: brand[80],
        colorBrandBackground2: brand[20],
        colorBrandBackground2Hover: brand[40],
        colorBrandBackground2Pressed: brand[10],
        colorBrandBackground3Static: brand[60],
        colorBrandBackground4Static: brand[40],
        colorBrandBackgroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandBackgroundInvertedHover: brand[160],
        colorBrandBackgroundInvertedPressed: brand[140],
        colorBrandBackgroundInvertedSelected: brand[150],
        colorNeutralCardBackground: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralCardBackgroundHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralCardBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorNeutralCardBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorNeutralCardBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralStrokeAccessible: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[68],
        colorNeutralStrokeAccessibleHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[74],
        colorNeutralStrokeAccessiblePressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[70],
        colorNeutralStrokeAccessibleSelected: brand[100],
        colorNeutralStroke1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[40],
        colorNeutralStroke1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[46],
        colorNeutralStroke1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[42],
        colorNeutralStroke1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[44],
        colorNeutralStroke2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[32],
        colorNeutralStroke3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStroke4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStroke4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorNeutralStroke4Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralStroke4Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStrokeSubtle: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralStrokeOnBrand: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralStrokeOnBrand2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandStroke1: brand[100],
        colorBrandStroke2: brand[50],
        colorBrandStroke2Hover: brand[50],
        colorBrandStroke2Pressed: brand[30],
        colorBrandStroke2Contrast: brand[50],
        colorCompoundBrandStroke: brand[100],
        colorCompoundBrandStrokeHover: brand[110],
        colorCompoundBrandStrokePressed: brand[90],
        colorNeutralStrokeDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralStrokeDisabled2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStrokeInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorTransparentStroke: 'transparent',
        colorTransparentStrokeInteractive: 'transparent',
        colorTransparentStrokeDisabled: 'transparent',
        colorNeutralStrokeAlpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStrokeAlpha2: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[20],
        colorStrokeFocus1: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorStrokeFocus2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.24)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.28)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.40)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.48)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });







const $3b5403a30a78663f$export$ac47085da93aabfb = (brand)=>{
    const colorTokens = (0, $cfd91c97cbdedd72$export$ad9a05e30090f047)(brand);
    return {
        ...(0, $ce6bdb492800e603$export$7a57f79000377ca2),
        ...(0, $acaa7b1cbd308031$export$67baea80019ff381),
        ...(0, $acaa7b1cbd308031$export$e646ed6b629bf51e),
        ...(0, $acaa7b1cbd308031$export$709a39c897136e8),
        ...(0, $acaa7b1cbd308031$export$59230918eb9bd861),
        ...(0, $69e80ab434f476c6$export$fe6cfaf27a046d4c),
        ...(0, $d15e16efc3c976b1$export$a4db2e0274ce31ed),
        ...(0, $d15e16efc3c976b1$export$9f57b7461d659f60),
        ...(0, $1ac2042b55cb6fc4$export$38b928a7167ce124),
        ...(0, $a38b2c50157e284b$export$6894093bf294bea5),
        ...colorTokens,
        ...(0, $1e4b4c09e9bf881e$export$d72a599962b8f734),
        ...(0, $1e4b4c09e9bf881e$export$3557c617aeef1561),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, 'Brand')
    };
};


var $acw62 = parcelRequire("acw62");

'use client';
function $993af50b96092e61$export$71594e8a50f746f4() {
    return /* eslint-disable @nx/workspace-no-restricted-globals -- expected ignore ( SSR friendly acquisition of globals )*/ typeof window !== 'undefined' && !!(window.document && // eslint-disable-next-line @typescript-eslint/no-deprecated
    window.document.createElement);
}




var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @internal
 */ const $8221ac192738ccc4$var$ProviderContext = $acw62.createContext(undefined);
const $8221ac192738ccc4$var$providerContextDefaultValue = {
    // eslint-disable-next-line @nx/workspace-no-restricted-globals -- expected ignore ( SSR friendly acquisition of globals )
    targetDocument: typeof document === 'object' ? document : undefined,
    dir: 'ltr'
};
const $8221ac192738ccc4$export$2881499e37b75b9a = $8221ac192738ccc4$var$ProviderContext.Provider;
function $8221ac192738ccc4$export$6ab36604f9d4fd68() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($8221ac192738ccc4$var$ProviderContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $8221ac192738ccc4$var$providerContextDefaultValue;
}


var $acw62 = parcelRequire("acw62");
'use client';
const $7474d1e11e05d082$export$2c657da244d00bd6 = $acw62.createContext(undefined);
const $7474d1e11e05d082$export$d8964aec282183a3 = $7474d1e11e05d082$export$2c657da244d00bd6.Provider;


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * Used to provide a CSS class that applies theme css variables
 *
 * Useful for elements in the React tree (can read context) but not in the DOM Tree. E.g. Portals
 *
 * @internal
 */ const $74a09e92d7894ea3$var$ThemeClassNameContext = $acw62.createContext(undefined);
const $74a09e92d7894ea3$var$themeClassNameContextDefaultVaue = '';
const $74a09e92d7894ea3$export$1d607f3624b112f5 = $74a09e92d7894ea3$var$ThemeClassNameContext.Provider;
function $74a09e92d7894ea3$export$4996399749b19890() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($74a09e92d7894ea3$var$ThemeClassNameContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $74a09e92d7894ea3$var$themeClassNameContextDefaultVaue;
}


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * Context shared by all of the tooltips in the app
 *
 * @internal
 */ const $90b5c6c5b9aab897$var$TooltipVisibilityContext = $acw62.createContext(undefined);
const $90b5c6c5b9aab897$var$tooltipVisibilityContextDefaultValue = {};
const $90b5c6c5b9aab897$export$6e323c529a2fe2d3 = $90b5c6c5b9aab897$var$TooltipVisibilityContext.Provider;
function $90b5c6c5b9aab897$export$d047e971555191a() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($90b5c6c5b9aab897$var$TooltipVisibilityContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $90b5c6c5b9aab897$var$tooltipVisibilityContextDefaultValue;
}


var $acw62 = parcelRequire("acw62");
'use client';
const $dcb30b81376c0f2d$export$1570cf9bb03c301f = $acw62.createContext(undefined);
const $dcb30b81376c0f2d$export$1008c3d7ef9225de = $dcb30b81376c0f2d$export$1570cf9bb03c301f.Provider;
function $dcb30b81376c0f2d$export$ab0d8295b09da679() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($dcb30b81376c0f2d$export$1570cf9bb03c301f)) !== null && _React_useContext !== void 0 ? _React_useContext : {};
}



var $acw62 = parcelRequire("acw62");
const $29e9ce9867929ff7$var$IconDirectionContext = $acw62.createContext(undefined);
const $29e9ce9867929ff7$var$IconDirectionContextDefaultValue = {};
const $29e9ce9867929ff7$export$6bba08bb4157cc42 = $29e9ce9867929ff7$var$IconDirectionContext.Provider;
const $29e9ce9867929ff7$export$6bed2dfdd7bea160 = ()=>{
    const context = $acw62.useContext($29e9ce9867929ff7$var$IconDirectionContext);
    return context !== null && context !== void 0 ? context : $29e9ce9867929ff7$var$IconDirectionContextDefaultValue;
};


'use client';
const $0b70550ea98bf3a8$export$2b3628d62f894ece = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    // Typescript (vscode) incorrectly references the FluentProviderProps.customStyleHooks_unstable
    // instead of FluentProviderContextValues.customStyleHooks_unstable and thinks it is
    // Partial<CustomStyleHooksContextValue>, so it needs to be cast to Required<CustomStyleHooksContextValue>
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $8221ac192738ccc4$export$2881499e37b75b9a), {
        value: contextValues.provider,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $7474d1e11e05d082$export$d8964aec282183a3), {
            value: contextValues.theme,
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $74a09e92d7894ea3$export$1d607f3624b112f5), {
                value: contextValues.themeClassName,
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $df848b23091d7919$export$f7e4b0d3f201e8be), {
                    value: contextValues.customStyleHooks_unstable,
                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $90b5c6c5b9aab897$export$6e323c529a2fe2d3), {
                        value: contextValues.tooltip,
                        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $1351c645e9f8e168$export$c244dbe07f501bcc), {
                            dir: contextValues.textDirection,
                            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $29e9ce9867929ff7$export$6bba08bb4157cc42), {
                                value: contextValues.iconDirection,
                                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $dcb30b81376c0f2d$export$1008c3d7ef9225de), {
                                    value: contextValues.overrides_unstable,
                                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
                                        children: [
                                            (0, $993af50b96092e61$export$71594e8a50f746f4)() ? null : /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)("style", {
                                                // Using dangerous HTML because react can escape characters
                                                // which can lead to invalid CSS.
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML: {
                                                    __html: state.serverStyleProps.cssRule
                                                },
                                                ...state.serverStyleProps.attributes
                                            }),
                                            state.root.children
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");

/**
 * Verifies if a given node is an HTMLElement,
 * this method works seamlessly with frames and elements from different documents
 *
 * This is preferred over simply using `instanceof`.
 * Since `instanceof` might be problematic while operating with [multiple realms](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/instanceof#instanceof_and_multiple_realms)
 *
 * @example
 * ```ts
 * isHTMLElement(event.target) && event.target.focus()
 * isHTMLElement(event.target, {constructorName: 'HTMLInputElement'}) && event.target.value // some value
 * ```
 *
 */ function $d23f05efbdb19e52$export$1b3bfaa9684536aa(element, options) {
    var _typedElement_ownerDocument;
    const typedElement = element;
    var _options_constructorName;
    return Boolean((typedElement === null || typedElement === void 0 ? void 0 : (_typedElement_ownerDocument = typedElement.ownerDocument) === null || _typedElement_ownerDocument === void 0 ? void 0 : _typedElement_ownerDocument.defaultView) && typedElement instanceof typedElement.ownerDocument.defaultView[(_options_constructorName = options === null || options === void 0 ? void 0 : options.constructorName) !== null && _options_constructorName !== void 0 ? _options_constructorName : 'HTMLElement']);
}


//#region src/dom.mts
/*!
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT License.
*/ const $134104a7b4fa5d8e$var$addEventListener = (target, type, handler)=>{
    target.addEventListener(type, handler, true);
};
const $134104a7b4fa5d8e$var$removeEventListener = (target, type, handler)=>{
    target.removeEventListener(type, handler, true);
};
//#endregion
//#region src/FocusEvent.mts
/*!
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT License.
*/ const $134104a7b4fa5d8e$export$5644ea5c8a31b6ce = "keyborg:focusin";
const $134104a7b4fa5d8e$export$caa225efd612bb56 = "keyborg:focusout";
const $134104a7b4fa5d8e$var$FOCUS_IN_HANDLER = 0;
const $134104a7b4fa5d8e$var$FOCUS_OUT_HANDLER = 1;
const $134104a7b4fa5d8e$var$SHADOW_TARGETS = 2;
const $134104a7b4fa5d8e$var$LAST_FOCUSED_PROGRAMMATICALLY = 3;
/**
* Guarantees that the native `focus` will be used
*/ function $134104a7b4fa5d8e$export$cf4c60ff2c946f35(element) {
    const focus = element.focus;
    if (focus.__keyborgNativeFocus) focus.__keyborgNativeFocus.call(element);
    else element.focus();
}
/**
* Overrides the native `focus` and setups the keyborg focus event
*/ function $134104a7b4fa5d8e$var$setupFocusEvent(win) {
    const kwin = win;
    const doc = kwin.document;
    const proto = kwin.HTMLElement.prototype;
    const origFocusDescriptor = Object.getOwnPropertyDescriptor(proto, "focus");
    if (origFocusDescriptor?.value?.__keyborgNativeFocus) return;
    focus.__keyborgNativeFocus = callNativeFocus;
    focus.__keyborgFocusDescriptor = origFocusDescriptor;
    Object.defineProperty(proto, "focus", {
        configurable: origFocusDescriptor?.configurable ?? true,
        enumerable: origFocusDescriptor?.enumerable ?? false,
        writable: true,
        value: focus
    });
    const shadowTargets = /* @__PURE__ */ new Set();
    const focusOutHandler = (e)=>{
        const target = e.target;
        if (!target) return;
        const event = new CustomEvent($134104a7b4fa5d8e$export$caa225efd612bb56, {
            cancelable: true,
            bubbles: true,
            composed: true,
            detail: {
                originalEvent: e
            }
        });
        target.dispatchEvent(event);
    };
    const focusInHandler = (e)=>{
        const target = e.target;
        if (!target) return;
        let node = e.composedPath()[0];
        const currentShadows = /* @__PURE__ */ new Set();
        while(node)if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            currentShadows.add(node);
            node = node.host;
        } else node = node.parentNode;
        for (const shadowRootWeakRef of shadowTargets){
            const shadowRoot = shadowRootWeakRef.deref();
            if (!shadowRoot || !currentShadows.has(shadowRoot)) {
                shadowTargets.delete(shadowRootWeakRef);
                if (shadowRoot) {
                    $134104a7b4fa5d8e$var$removeEventListener(shadowRoot, "focusin", focusInHandler);
                    $134104a7b4fa5d8e$var$removeEventListener(shadowRoot, "focusout", focusOutHandler);
                }
            }
        }
        onFocusIn(target, e.relatedTarget || void 0);
    };
    const onFocusIn = (target, relatedTarget, originalEvent)=>{
        const shadowRoot = target.shadowRoot;
        if (shadowRoot) {
            /**
			* https://bugs.chromium.org/p/chromium/issues/detail?id=1512028
			* focusin events don't bubble up through an open shadow root once focus is inside
			* once focus moves into a shadow root - we drop the same focusin handler there
			* keyborg's custom event will still bubble up since it is composed
			* event handlers should be cleaned up once focus leaves the shadow root.
			*
			* When a focusin event is dispatched from a shadow root, its target is the shadow root parent.
			* Each shadow root encounter requires a new capture listener.
			* Why capture? - we want to follow the focus event in order or descending nested shadow roots
			* When there are no more shadow root targets - dispatch the keyborg:focusin event
			*
			* 1. no focus event
			* > document - capture listener ✅
			*   > shadow root 1
			*     > shadow root 2
			*       > shadow root 3
			*         > focused element
			*
			* 2. focus event received by document listener
			* > document - capture listener ✅ (focus event here)
			*   > shadow root 1 - capture listener ✅
			*     > shadow root 2
			*       > shadow root 3
			*         > focused element
			*
			* 3. focus event received by root l1 listener
			* > document - capture listener ✅
			*   > shadow root 1 - capture listener ✅ (focus event here)
			*     > shadow root 2 - capture listener ✅
			*       > shadow root 3
			*         > focused element
			*
			* 4. focus event received by root l2 listener
			* > document - capture listener ✅
			*   > shadow root 1 - capture listener ✅
			*     > shadow root 2 - capture listener ✅ (focus event here)
			*       > shadow root 3 - capture listener ✅
			*         > focused element
			*
			* 5. focus event received by root l3 listener, no more shadow root targets
			* > document - capture listener ✅
			*   > shadow root 1 - capture listener ✅
			*     > shadow root 2 - capture listener ✅
			*       > shadow root 3 - capture listener ✅ (focus event here)
			*         > focused element ✅ (no shadow root - dispatch keyborg event)
			*/ for (const shadowRootWeakRef of shadowTargets)if (shadowRootWeakRef.deref() === shadowRoot) return;
            $134104a7b4fa5d8e$var$addEventListener(shadowRoot, "focusin", focusInHandler);
            $134104a7b4fa5d8e$var$addEventListener(shadowRoot, "focusout", focusOutHandler);
            shadowTargets.add(new WeakRef(shadowRoot));
            return;
        }
        const details = {
            relatedTarget: relatedTarget,
            originalEvent: originalEvent
        };
        const event = new CustomEvent($134104a7b4fa5d8e$export$5644ea5c8a31b6ce, {
            cancelable: true,
            bubbles: true,
            composed: true,
            detail: details
        });
        details.isFocusedProgrammatically = target === data[$134104a7b4fa5d8e$var$LAST_FOCUSED_PROGRAMMATICALLY]?.deref();
        data[$134104a7b4fa5d8e$var$LAST_FOCUSED_PROGRAMMATICALLY] = void 0;
        target.dispatchEvent(event);
    };
    const data = [
        focusInHandler,
        focusOutHandler,
        shadowTargets
    ];
    kwin.__keyborgData = data;
    $134104a7b4fa5d8e$var$addEventListener(doc, "focusin", focusInHandler);
    $134104a7b4fa5d8e$var$addEventListener(doc, "focusout", focusOutHandler);
    function focus() {
        const d = kwin.__keyborgData;
        if (d) d[$134104a7b4fa5d8e$var$LAST_FOCUSED_PROGRAMMATICALLY] = new WeakRef(this);
        return callNativeFocus.apply(this, arguments);
    }
    function callNativeFocus() {
        const originalFocus = origFocusDescriptor?.get ? origFocusDescriptor.get.call(this) : origFocusDescriptor?.value;
        if (typeof originalFocus !== "function") throw new TypeError("HTMLElement.prototype.focus is not callable");
        return originalFocus.apply(this, arguments);
    }
    let activeElement = doc.activeElement;
    while(activeElement && activeElement.shadowRoot){
        onFocusIn(activeElement);
        activeElement = activeElement.shadowRoot.activeElement;
    }
}
/**
* Removes keyborg event listeners and custom focus override
* @param win The window that stores keyborg focus events
*/ function $134104a7b4fa5d8e$var$disposeFocusEvent(win) {
    const kwin = win;
    const proto = kwin.HTMLElement.prototype;
    const focus = Object.getOwnPropertyDescriptor(proto, "focus")?.value;
    const origFocusDescriptor = focus?.__keyborgFocusDescriptor;
    const data = kwin.__keyborgData;
    if (data) {
        const doc = kwin.document;
        $134104a7b4fa5d8e$var$removeEventListener(doc, "focusin", data[$134104a7b4fa5d8e$var$FOCUS_IN_HANDLER]);
        $134104a7b4fa5d8e$var$removeEventListener(doc, "focusout", data[$134104a7b4fa5d8e$var$FOCUS_OUT_HANDLER]);
        for (const shadowRootWeakRef of data[$134104a7b4fa5d8e$var$SHADOW_TARGETS]){
            const shadowRoot = shadowRootWeakRef.deref();
            if (shadowRoot) {
                $134104a7b4fa5d8e$var$removeEventListener(shadowRoot, "focusin", data[$134104a7b4fa5d8e$var$FOCUS_IN_HANDLER]);
                $134104a7b4fa5d8e$var$removeEventListener(shadowRoot, "focusout", data[$134104a7b4fa5d8e$var$FOCUS_OUT_HANDLER]);
            }
        }
        data[$134104a7b4fa5d8e$var$SHADOW_TARGETS].clear();
        delete kwin.__keyborgData;
    }
    if (focus?.__keyborgNativeFocus) {
        if (origFocusDescriptor) Object.defineProperty(proto, "focus", origFocusDescriptor);
        else delete proto.focus;
    }
}
/**
* @param win The window that stores keyborg focus events
* @returns The last element focused with element.focus()
*/ function $134104a7b4fa5d8e$export$6975ba4e8ed68cc8(win) {
    const data = win.__keyborgData;
    return data ? data[$134104a7b4fa5d8e$var$LAST_FOCUSED_PROGRAMMATICALLY]?.deref() || null : void 0;
}
//#endregion
//#region src/Keyborg.mts
/*!
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT License.
*/ let $134104a7b4fa5d8e$var$_lastId = 0;
function $134104a7b4fa5d8e$var$createKeyborgCore(targetWindow) {
    let currentTargetWindow = targetWindow;
    let isNavigating = false;
    let isMouseOrTouchUsedTimer;
    const broadcast = ()=>{
        const refs = currentTargetWindow?.__keyborg?.refs;
        if (refs) for (const id of Object.keys(refs))refs[id]._cb.forEach((cb)=>cb(isNavigating));
    };
    const setNavigating = (val1)=>{
        if (isNavigating !== val1) {
            isNavigating = val1;
            broadcast();
        }
    };
    const shouldTrigger = (e)=>{
        if (e.key === "Tab") return true;
        const active = currentTargetWindow?.document.activeElement;
        return !(active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable));
    };
    const onFocusIn = (e)=>{
        if (isMouseOrTouchUsedTimer) return;
        if (isNavigating) return;
        const details = e.detail;
        if (!details.relatedTarget) return;
        if (details.isFocusedProgrammatically || details.isFocusedProgrammatically === void 0) return;
        setNavigating(true);
    };
    const onMouseOrTouch = ()=>{
        if (currentTargetWindow) {
            if (isMouseOrTouchUsedTimer) currentTargetWindow.clearTimeout(isMouseOrTouchUsedTimer);
            isMouseOrTouchUsedTimer = currentTargetWindow.setTimeout(()=>{
                isMouseOrTouchUsedTimer = void 0;
            }, 1e3);
        }
        setNavigating(false);
    };
    const onMouseDown = (e)=>{
        if (e.buttons === 0 || e.clientX === 0 && e.clientY === 0 && e.screenX === 0 && e.screenY === 0) return;
        onMouseOrTouch();
    };
    const onKeyDown = (e)=>{
        if (!isNavigating && shouldTrigger(e)) setNavigating(true);
    };
    const targetDocument = targetWindow.document;
    $134104a7b4fa5d8e$var$addEventListener(targetDocument, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce, onFocusIn);
    $134104a7b4fa5d8e$var$addEventListener(targetDocument, "mousedown", onMouseDown);
    $134104a7b4fa5d8e$var$addEventListener(targetWindow, "keydown", onKeyDown);
    $134104a7b4fa5d8e$var$addEventListener(targetDocument, "touchstart", onMouseOrTouch);
    $134104a7b4fa5d8e$var$addEventListener(targetDocument, "touchend", onMouseOrTouch);
    $134104a7b4fa5d8e$var$addEventListener(targetDocument, "touchcancel", onMouseOrTouch);
    $134104a7b4fa5d8e$var$setupFocusEvent(targetWindow);
    const dispose = ()=>{
        if (!currentTargetWindow) return;
        if (isMouseOrTouchUsedTimer) {
            currentTargetWindow.clearTimeout(isMouseOrTouchUsedTimer);
            isMouseOrTouchUsedTimer = void 0;
        }
        $134104a7b4fa5d8e$var$disposeFocusEvent(currentTargetWindow);
        const targetDocument = currentTargetWindow.document;
        $134104a7b4fa5d8e$var$removeEventListener(targetDocument, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce, onFocusIn);
        $134104a7b4fa5d8e$var$removeEventListener(targetDocument, "mousedown", onMouseDown);
        $134104a7b4fa5d8e$var$removeEventListener(currentTargetWindow, "keydown", onKeyDown);
        $134104a7b4fa5d8e$var$removeEventListener(targetDocument, "touchstart", onMouseOrTouch);
        $134104a7b4fa5d8e$var$removeEventListener(targetDocument, "touchend", onMouseOrTouch);
        $134104a7b4fa5d8e$var$removeEventListener(targetDocument, "touchcancel", onMouseOrTouch);
        currentTargetWindow = void 0;
    };
    return {
        dispose: dispose,
        get isNavigatingWithKeyboard () {
            return isNavigating;
        },
        set isNavigatingWithKeyboard (val){
            setNavigating(val);
        }
    };
}
function $134104a7b4fa5d8e$export$9ccd7417191c0e4b(win) {
    const kwin = win;
    const id = "k" + ++$134104a7b4fa5d8e$var$_lastId;
    let localWin = kwin;
    let core;
    const callbacks = [];
    const existing = kwin.__keyborg;
    if (existing) core = existing.core;
    else core = $134104a7b4fa5d8e$var$createKeyborgCore(kwin);
    const instance = {
        isNavigatingWithKeyboard () {
            return !!core?.isNavigatingWithKeyboard;
        },
        subscribe (callback) {
            callbacks.push(callback);
        },
        unsubscribe (callback) {
            const index = callbacks.indexOf(callback);
            if (index >= 0) callbacks.splice(index, 1);
        },
        setVal (val1) {
            if (core) core.isNavigatingWithKeyboard = val1;
        },
        _cb: callbacks,
        dispose () {
            const wkb = localWin?.__keyborg;
            if (wkb?.refs[id]) {
                delete wkb.refs[id];
                if (Object.keys(wkb.refs).length === 0) {
                    wkb.core.dispose();
                    delete localWin.__keyborg;
                }
            }
            callbacks.length = 0;
            core = void 0;
            localWin = void 0;
        }
    };
    if (existing) existing.refs[id] = instance;
    else kwin.__keyborg = {
        core: core,
        refs: {
            [id]: instance
        }
    };
    return instance;
}
function $134104a7b4fa5d8e$export$6c71cf8529293a97(instance) {
    instance.dispose();
}
//#endregion
//#region src/index.mts
/*!
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT License.
*/ const $134104a7b4fa5d8e$export$83d89fbfd8236492 = "3.498.0";


const $adb94d615d1e4f94$export$49535e94ddbaa254 = 'data-keyboard-nav';
const $adb94d615d1e4f94$export$981d564957a4672d = `:global([${$adb94d615d1e4f94$export$49535e94ddbaa254}])`;
const $adb94d615d1e4f94$export$2c9da02e018cbe1c = 'data-fui-focus-visible';
const $adb94d615d1e4f94$export$922950948586e05d = 'data-fui-focus-within';
const $adb94d615d1e4f94$export$ba43bf67f3d48107 = {
    style: {},
    selector: 'focus',
    customizeSelector: (selector)=>selector
};


function $a223f8a765b4d651$export$56707be742262038(scope, targetWindow) {
    if ($a223f8a765b4d651$var$alreadyInScope(scope)) // Focus visible polyfill already applied at this scope
    return ()=>undefined;
    const state = {
        current: undefined
    };
    const keyborg = (0, $134104a7b4fa5d8e$export$9ccd7417191c0e4b)(targetWindow);
    function registerElementIfNavigating(el) {
        if (keyborg.isNavigatingWithKeyboard() && (0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(el)) {
            state.current = el;
            el.setAttribute((0, $adb94d615d1e4f94$export$2c9da02e018cbe1c), '');
        }
    }
    function disposeCurrentElement() {
        if (state.current) {
            state.current.removeAttribute((0, $adb94d615d1e4f94$export$2c9da02e018cbe1c));
            state.current = undefined;
        }
    }
    // When navigation mode changes remove the focus-visible selector
    keyborg.subscribe((isNavigatingWithKeyboard)=>{
        if (!isNavigatingWithKeyboard) disposeCurrentElement();
        else registerElementIfNavigating(targetWindow.document.activeElement);
    });
    // Keyborg's focusin event is delegated so it's only registered once on the window
    // and contains metadata about the focus event
    const keyborgListener = (e)=>{
        disposeCurrentElement();
        const target = e.composedPath()[0];
        registerElementIfNavigating(target);
    };
    // Make sure that when focus leaves the scope, the focus visible class is removed
    const blurListener = (e)=>{
        if (!e.relatedTarget || (0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.relatedTarget) && !scope.contains(e.relatedTarget)) disposeCurrentElement();
    };
    scope.addEventListener((0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), keyborgListener);
    scope.addEventListener('focusout', blurListener);
    scope.focusVisible = true;
    if (scope.contains(targetWindow.document.activeElement)) registerElementIfNavigating(targetWindow.document.activeElement);
    // Return disposer
    return ()=>{
        disposeCurrentElement();
        scope.removeEventListener((0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), keyborgListener);
        scope.removeEventListener('focusout', blurListener);
        scope.focusVisible = undefined;
        (0, $134104a7b4fa5d8e$export$6c71cf8529293a97)(keyborg);
    };
}
function $a223f8a765b4d651$var$alreadyInScope(el) {
    if (!el) return false;
    if (el.focusVisible) return true;
    return $a223f8a765b4d651$var$alreadyInScope(el === null || el === void 0 ? void 0 : el.parentElement);
}


'use client';
function $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6(options = {}) {
    const contextValue = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const scopeRef = $acw62.useRef(null);
    var _options_targetDocument;
    const targetDocument = (_options_targetDocument = options.targetDocument) !== null && _options_targetDocument !== void 0 ? _options_targetDocument : contextValue.targetDocument;
    $acw62.useEffect(()=>{
        if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) && scopeRef.current) return (0, $a223f8a765b4d651$export$56707be742262038)(scopeRef.current, targetDocument.defaultView);
    }, [
        scopeRef,
        targetDocument
    ]);
    return scopeRef;
}




var $acw62 = parcelRequire("acw62");
'use client';
function $de7d48ea62179626$export$9cf7d991616612b3(...refs) {
    const mergedCallback = $acw62.useCallback((value)=>{
        // Update the "current" prop hanging on the function.
        // eslint-disable-next-line react-hooks/immutability
        mergedCallback.current = value;
        for (const ref of refs){
            typeof ref;
            if (typeof ref === 'function') ref(value);
            else if (ref) // eslint-disable-next-line react-hooks/immutability
            ref.current = value;
        }
    }, [
        ...refs
    ]);
    return mergedCallback;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

'use client';
const $4e48a6f126575b5a$export$700979bc83e7db82 = (0, $993af50b96092e61$export$71594e8a50f746f4)() ? $acw62.useLayoutEffect : $acw62.useEffect;


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

'use client';
const $fecc0f8e699705f8$export$8d77aa623242822f = {
    current: 0
};
const $fecc0f8e699705f8$export$8452e4682414c100 = /*#__PURE__*/ $acw62.createContext(undefined);
function $fecc0f8e699705f8$export$6b1c54dc4befcda() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($fecc0f8e699705f8$export$8452e4682414c100)) !== null && _React_useContext !== void 0 ? _React_useContext : $fecc0f8e699705f8$export$8d77aa623242822f;
}
const $fecc0f8e699705f8$export$9f8ac96af4b1b2ae = (props)=>{
    const [value] = $acw62.useState(()=>({
            current: 0
        }));
    return /*#__PURE__*/ $acw62.createElement($fecc0f8e699705f8$export$8452e4682414c100.Provider, {
        value: value
    }, props.children);
};
function $fecc0f8e699705f8$export$535bd6ca7f90a273() {
    const isInSSRContext = $fecc0f8e699705f8$export$6b1c54dc4befcda() !== $fecc0f8e699705f8$export$8d77aa623242822f;
    const [isSSR, setIsSSR] = $acw62.useState(isInSSRContext);
    // If on the client, and the component was initially server rendered, then schedule a layout effect to update the
    // component after hydration.
    if ((0, $993af50b96092e61$export$71594e8a50f746f4)() && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe because the condition never changes after
    // mounting.
    // eslint-disable-next-line
    $acw62.useLayoutEffect(()=>{
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsSSR(false);
    }, []);
    return isSSR;
}


'use client';
const $0200d30cfa270435$var$IdPrefixContext = $acw62.createContext(undefined);
const $0200d30cfa270435$export$1ac15c72ae97b87 = $0200d30cfa270435$var$IdPrefixContext.Provider;
function $0200d30cfa270435$var$useIdPrefix() {
    return $acw62.useContext($0200d30cfa270435$var$IdPrefixContext) || '';
}
function $0200d30cfa270435$export$e3990a4b0f37142e() {
    (0, $fecc0f8e699705f8$export$8d77aa623242822f).current = 0;
}
function $0200d30cfa270435$export$f680877a34711e37(prefix = 'fui-', providedId) {
    const contextValue = (0, $fecc0f8e699705f8$export$6b1c54dc4befcda)();
    const idPrefix = $0200d30cfa270435$var$useIdPrefix();
    // Checking if useId is available on React, if it is, we use it to generate the id. String concatenation is used to
    // prevent bundlers from complaining with older versions of React.
    const _useId = $acw62.useId;
    if (_useId) {
        const generatedId = _useId();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const escapedId = $acw62.useMemo(()=>generatedId.replace(/:/g, ''), [
            generatedId
        ]);
        return providedId || `${idPrefix}${prefix}${escapedId}`;
    }
    // Hooks appear to be running conditionally, but they will always run in the same order since it's based on
    // the version of React being used. This is safe to ignore.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $acw62.useMemo(()=>{
        if (providedId) return providedId;
        // eslint-disable-next-line react-hooks/immutability
        return `${idPrefix}${prefix}${++contextValue.current}`;
    }, [
        idPrefix,
        prefix,
        providedId,
        contextValue
    ]);
}



var $acw62 = parcelRequire("acw62");
const $f935f7668bf32111$var$CSS_ESCAPE_MAP = {
    '\\': '\\5C ',
    '<': '\\3C ',
    '>': '\\3E ',
    '{': '\\7B ',
    '}': '\\7D ',
    ';': '\\3B '
};
const $f935f7668bf32111$var$CSS_ESCAPE_PATTERN = /[\\<>{};]/g;
function $f935f7668bf32111$var$escapeCharacter(character) {
    return `\\${character.charCodeAt(0).toString(16).toUpperCase()} `;
}
function $f935f7668bf32111$var$escapeSelector(value) {
    // Consume whole backslash runs so escaping preserves their parity and does not retry overlapping suffixes.
    return value.replace(/\\+[<{}]?|[<{}]/g, (match)=>{
        const character = match[match.length - 1];
        if (!'<{}'.includes(character)) return match;
        const backslashes = match.length - 1;
        return match.slice(0, backslashes - backslashes % 2) + $f935f7668bf32111$var$escapeCharacter(character);
    });
}
/**
 * Escapes characters that could end the declaration, the rule or the surrounding <style> tag.
 *
 * Backslashes are escaped too, so a value cannot escape the declaration separator that follows it.
 * Other characters, including quotes and parentheses, are kept as-is: theme values legitimately contain quoted
 * font families and nested CSS functions such as `oklch(from var(--token) l c h / 0.5)`.
 */ function $f935f7668bf32111$var$escapeThemeText(value) {
    return value.replace($f935f7668bf32111$var$CSS_ESCAPE_PATTERN, (match)=>$f935f7668bf32111$var$CSS_ESCAPE_MAP[match]);
}
function $f935f7668bf32111$export$2e5ce34465bca14b(selector, theme) {
    const escapedSelector = $f935f7668bf32111$var$escapeSelector(selector);
    if (theme) {
        const cssVarsAsString = Object.keys(theme).reduce((cssVarRule, cssVar)=>{
            const tokenValue = theme[cssVar];
            // Skip unset values (e.g. `undefined` from a nested provider) so they don't shadow inherited tokens.
            if (typeof tokenValue !== 'string' && (typeof tokenValue !== 'number' || !Number.isFinite(tokenValue))) return cssVarRule;
            return `${cssVarRule}--${$f935f7668bf32111$var$escapeThemeText(cssVar)}: ${$f935f7668bf32111$var$escapeThemeText(String(tokenValue))}; `;
        }, '');
        return `${escapedSelector} { ${cssVarsAsString} }`;
    }
    return `${escapedSelector} {}`;
}





'use client';
const $77cae713233baa8d$export$88dac45d8d60a317 = {
    root: 'fui-FluentProvider'
};
const $77cae713233baa8d$var$useStyles = /*#__PURE__*/ (0, $e4c89be7ff026cfe$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const $77cae713233baa8d$export$8f3c5aad0b161134 = (state)=>{
    const renderer = (0, $5c71fabe713d2fee$export$e0259e2a2ab69ea)();
    const styles = $77cae713233baa8d$var$useStyles({
        dir: state.dir,
        renderer: renderer
    });
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($77cae713233baa8d$export$88dac45d8d60a317.root, state.themeClassName, styles.root, state.root.className);
    return state;
};


'use client';
// String concatenation is used to prevent bundlers to complain with older versions of React
const $aeb2dd938b583a17$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : (0, $4e48a6f126575b5a$export$700979bc83e7db82);
const $aeb2dd938b583a17$var$createStyleTag = (target, elementAttributes)=>{
    // Document might exist but not be ready yet (e.g. during SSR)
    // In that case, we should not create a style tag
    if (!(target === null || target === void 0 ? void 0 : target.head)) return undefined;
    const tag = target.createElement('style');
    Object.keys(elementAttributes).forEach((attrName)=>{
        tag.setAttribute(attrName, elementAttributes[attrName]);
    });
    target.head.appendChild(tag);
    return tag;
};
const $aeb2dd938b583a17$var$insertSheet = (tag, rule)=>{
    const sheet = tag.sheet;
    if (sheet) {
        if (sheet.cssRules.length > 0) sheet.deleteRule(0);
        sheet.insertRule(rule, 0);
    }
};
const $aeb2dd938b583a17$export$bd71951f577fe049 = (options)=>{
    const { targetDocument: targetDocument, theme: theme, rendererAttributes: rendererAttributes } = options;
    const styleTag = $acw62.useRef(undefined);
    const styleTagId = (0, $0200d30cfa270435$export$f680877a34711e37)((0, $77cae713233baa8d$export$88dac45d8d60a317).root);
    const styleElementAttributes = rendererAttributes;
    const rule = $acw62.useMemo(()=>(0, $f935f7668bf32111$export$2e5ce34465bca14b)(`.${styleTagId}`, theme), [
        theme,
        styleTagId
    ]);
    var _ref, _styleElement_textContent;
    $aeb2dd938b583a17$var$useHandleSSRStyleElements(targetDocument, styleTagId);
    $aeb2dd938b583a17$var$useInsertionEffect(()=>{
        // The style element could already have been created during SSR - no need to recreate it
        const ssrStyleElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.getElementById(styleTagId);
        if (ssrStyleElement) styleTag.current = ssrStyleElement;
        else {
            styleTag.current = $aeb2dd938b583a17$var$createStyleTag(targetDocument, {
                ...styleElementAttributes,
                id: styleTagId
            });
            if (styleTag.current) $aeb2dd938b583a17$var$insertSheet(styleTag.current, rule);
        }
        return ()=>{
            var _styleTag_current;
            (_styleTag_current = styleTag.current) === null || _styleTag_current === void 0 || _styleTag_current.remove();
        };
    }, [
        styleTagId,
        targetDocument,
        rule,
        styleElementAttributes
    ]);
    return {
        styleTagId: styleTagId,
        rule: rule
    };
};
function $aeb2dd938b583a17$var$useHandleSSRStyleElements(targetDocument, styleTagId) {
    // Using a state factory so that this logic only runs once per render
    // Each FluentProvider can create its own style element during SSR as a slot
    // Moves all theme style elements to document head during render to avoid hydration errors.
    // Should be strict mode safe since the logic is idempotent.
    $acw62.useState(()=>{
        if (!targetDocument) return;
        const themeStyleElement = targetDocument.getElementById(styleTagId);
        if (themeStyleElement) targetDocument.head.append(themeStyleElement);
    });
}


'use client';
// Meomizing empty objects to avoid unnecessary rerenders.
const $30ce64e1230177d0$var$DEFAULT_STYLE_HOOKS = {};
const $30ce64e1230177d0$var$DEFAULT_RENDERER_ATTRIBUTES = {};
const $30ce64e1230177d0$export$b5989e5d4d3841f = (props, ref)=>{
    var _renderer_styleElementAttributes;
    const parentContext = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const parentTheme = $30ce64e1230177d0$var$useTheme();
    const parentOverrides = (0, $dcb30b81376c0f2d$export$ab0d8295b09da679)();
    const parentCustomStyleHooks = $acw62.useContext((0, $df848b23091d7919$export$d1a6d8b46a5f8f83)) || $30ce64e1230177d0$var$DEFAULT_STYLE_HOOKS;
    /**
   * TODO: add merge functions to "dir" merge,
   * nesting providers with the same "dir" should not add additional attributes to DOM
   * see https://github.com/microsoft/fluentui/blob/0dc74a19f3aa5a058224c20505016fbdb84db172/packages/fluentui/react-northstar/src/utils/mergeProviderContexts.ts#L89-L93
   */ const { applyStylesToPortals: applyStylesToPortals = true, customStyleHooks_unstable: customStyleHooks_unstable, dir: dir = parentContext.dir, targetDocument: targetDocument = parentContext.targetDocument, theme: theme, overrides_unstable: overrides = {} } = props;
    const mergedTheme = $30ce64e1230177d0$var$shallowMerge(parentTheme, theme);
    const mergedOverrides = $30ce64e1230177d0$var$shallowMerge(parentOverrides, overrides);
    const mergedCustomStyleHooks = $30ce64e1230177d0$var$shallowMerge(parentCustomStyleHooks, customStyleHooks_unstable);
    const renderer = (0, $5c71fabe713d2fee$export$e0259e2a2ab69ea)();
    const { styleTagId: styleTagId, rule: rule } = (0, $aeb2dd938b583a17$export$bd71951f577fe049)({
        theme: mergedTheme,
        targetDocument: targetDocument,
        rendererAttributes: (_renderer_styleElementAttributes = renderer.styleElementAttributes) !== null && _renderer_styleElementAttributes !== void 0 ? _renderer_styleElementAttributes : $30ce64e1230177d0$var$DEFAULT_RENDERER_ATTRIBUTES
    });
    return {
        applyStylesToPortals: applyStylesToPortals,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        customStyleHooks_unstable: mergedCustomStyleHooks,
        dir: dir,
        targetDocument: targetDocument,
        theme: mergedTheme,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        overrides_unstable: mergedOverrides,
        themeClassName: styleTagId,
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ...props,
            dir: dir,
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, (0, $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6)({
                targetDocument: targetDocument
            }))
        }), {
            elementType: 'div'
        }),
        serverStyleProps: {
            cssRule: rule,
            attributes: {
                ...renderer.styleElementAttributes,
                id: styleTagId
            }
        }
    };
};
function $30ce64e1230177d0$var$shallowMerge(a, b) {
    // Merge impacts perf: we should like to avoid it if it's possible
    if (a && b) return {
        ...a,
        ...b
    };
    if (a) return a;
    return b;
}
function $30ce64e1230177d0$var$useTheme() {
    return $acw62.useContext((0, $7474d1e11e05d082$export$2c657da244d00bd6));
}




var $acw62 = parcelRequire("acw62");
'use client';
function $8f4deae75ca2d733$export$9e2edf0dbc0fca14(state) {
    const { applyStylesToPortals: applyStylesToPortals, customStyleHooks_unstable: customStyleHooks_unstable, dir: dir, root: root, targetDocument: targetDocument, theme: theme, themeClassName: themeClassName, overrides_unstable: overrides_unstable } = state;
    const provider = $acw62.useMemo(()=>({
            dir: dir,
            targetDocument: targetDocument
        }), [
        dir,
        targetDocument
    ]);
    // "Tooltip" component mutates an object in this context, instance should be stable
    const [tooltip] = $acw62.useState(()=>({}));
    const iconDirection = $acw62.useMemo(()=>({
            textDirection: dir
        }), [
        dir
    ]);
    return {
        customStyleHooks_unstable: // eslint-disable-next-line @typescript-eslint/naming-convention
        customStyleHooks_unstable,
        overrides_unstable: // eslint-disable-next-line @typescript-eslint/naming-convention
        overrides_unstable,
        provider: provider,
        textDirection: dir,
        iconDirection: iconDirection,
        tooltip: tooltip,
        theme: theme,
        themeClassName: applyStylesToPortals ? root.className : themeClassName
    };
}


'use client';
const $edc7f381b74604ab$export$a2fd5c9263a86adf = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $30ce64e1230177d0$export$b5989e5d4d3841f)(props, ref);
    (0, $77cae713233baa8d$export$8f3c5aad0b161134)(state);
    const contextValues = (0, $8f4deae75ca2d733$export$9e2edf0dbc0fca14)(state);
    return (0, $0b70550ea98bf3a8$export$2b3628d62f894ece)(state, contextValues);
});
$edc7f381b74604ab$export$a2fd5c9263a86adf.displayName = 'FluentProvider';


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $ee8fa670c1d03165$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $ee8fa670c1d03165$export$825a82322d91916e = /^[\\/]{2}/;
function $ee8fa670c1d03165$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $2ce80a7c58bedbaf$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $2ce80a7c58bedbaf$var$PopStateEventType = "popstate";
function $2ce80a7c58bedbaf$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $2ce80a7c58bedbaf$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $2ce80a7c58bedbaf$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $2ce80a7c58bedbaf$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $2ce80a7c58bedbaf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $2ce80a7c58bedbaf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $2ce80a7c58bedbaf$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $2ce80a7c58bedbaf$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    }
    return $2ce80a7c58bedbaf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $2ce80a7c58bedbaf$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $2ce80a7c58bedbaf$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $2ce80a7c58bedbaf$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $2ce80a7c58bedbaf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $2ce80a7c58bedbaf$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $2ce80a7c58bedbaf$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $2ce80a7c58bedbaf$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $2ce80a7c58bedbaf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $2ce80a7c58bedbaf$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $2ce80a7c58bedbaf$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $2ce80a7c58bedbaf$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $2ce80a7c58bedbaf$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $2ce80a7c58bedbaf$var$isLocation(to) ? to : $2ce80a7c58bedbaf$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $2ce80a7c58bedbaf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $2ce80a7c58bedbaf$var$isLocation(to) ? to : $2ce80a7c58bedbaf$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $2ce80a7c58bedbaf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $2ce80a7c58bedbaf$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($2ce80a7c58bedbaf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($2ce80a7c58bedbaf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $2ce80a7c58bedbaf$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $2ce80a7c58bedbaf$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $ee8fa670c1d03165$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $edf931d6dcac43ec$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $edf931d6dcac43ec$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
var $edf931d6dcac43ec$export$96cecaff35fb119d = class extends Error {
};
const $edf931d6dcac43ec$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children",
    "unstable_validateParams"
]);
function $edf931d6dcac43ec$export$3e22299e33adeed1(key) {
    return $edf931d6dcac43ec$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $edf931d6dcac43ec$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children",
    "unstable_validateParams"
]);
function $edf931d6dcac43ec$export$a89d811eaa209e85(key) {
    return $edf931d6dcac43ec$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $edf931d6dcac43ec$var$isIndexRoute(route) {
    return route.index === true;
}
function $edf931d6dcac43ec$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $acw62.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $edf931d6dcac43ec$export$87cb1a9238dc3fba(routes, mapRouteProperties = $edf931d6dcac43ec$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($edf931d6dcac43ec$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $edf931d6dcac43ec$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $edf931d6dcac43ec$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $edf931d6dcac43ec$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $edf931d6dcac43ec$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $edf931d6dcac43ec$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $edf931d6dcac43ec$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $edf931d6dcac43ec$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $edf931d6dcac43ec$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $edf931d6dcac43ec$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $edf931d6dcac43ec$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $edf931d6dcac43ec$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $edf931d6dcac43ec$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $edf931d6dcac43ec$export$e486c0390e42ccf6(routes) {
    let branches = $edf931d6dcac43ec$var$flattenRoutes(routes);
    $edf931d6dcac43ec$var$rankRouteBranches(branches);
    return branches;
}
function $edf931d6dcac43ec$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $edf931d6dcac43ec$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $edf931d6dcac43ec$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $edf931d6dcac43ec$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $edf931d6dcac43ec$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $edf931d6dcac43ec$export$82472424e06ad5c9(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $edf931d6dcac43ec$export$82472424e06ad5c9(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $edf931d6dcac43ec$export$82472424e06ad5c9(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $edf931d6dcac43ec$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $edf931d6dcac43ec$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $edf931d6dcac43ec$var$paramRe = /^:[\w-]+$/;
const $edf931d6dcac43ec$var$partialParamRe = /^:[\w-]+/;
const $edf931d6dcac43ec$var$partialDynamicSegmentValue = 3.5;
const $edf931d6dcac43ec$var$dynamicSegmentValue = 3;
const $edf931d6dcac43ec$var$indexRouteValue = 2;
const $edf931d6dcac43ec$var$emptySegmentValue = 1;
const $edf931d6dcac43ec$var$staticSegmentValue = 10;
const $edf931d6dcac43ec$var$splatPenalty = -2;
const $edf931d6dcac43ec$var$isSplat = (s)=>s === "*";
function $edf931d6dcac43ec$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($edf931d6dcac43ec$var$isSplat)) initialScore += $edf931d6dcac43ec$var$splatPenalty;
    if (index) initialScore += $edf931d6dcac43ec$var$indexRouteValue;
    return segments.filter((s)=>!$edf931d6dcac43ec$var$isSplat(s)).reduce((score, segment)=>score + ($edf931d6dcac43ec$var$paramRe.test(segment) ? $edf931d6dcac43ec$var$dynamicSegmentValue : $edf931d6dcac43ec$var$partialParamRe.test(segment) ? $edf931d6dcac43ec$var$partialDynamicSegmentValue : segment === "" ? $edf931d6dcac43ec$var$emptySegmentValue : $edf931d6dcac43ec$var$staticSegmentValue), initialScore);
}
function $edf931d6dcac43ec$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $edf931d6dcac43ec$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $edf931d6dcac43ec$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $edf931d6dcac43ec$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $edf931d6dcac43ec$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $edf931d6dcac43ec$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $edf931d6dcac43ec$export$a5c6d149b50c1d86($edf931d6dcac43ec$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $edf931d6dcac43ec$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $edf931d6dcac43ec$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $edf931d6dcac43ec$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$edf931d6dcac43ec$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $edf931d6dcac43ec$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $edf931d6dcac43ec$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $edf931d6dcac43ec$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $edf931d6dcac43ec$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $edf931d6dcac43ec$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $edf931d6dcac43ec$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $edf931d6dcac43ec$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $edf931d6dcac43ec$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $edf931d6dcac43ec$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/((?:[^/?()[\]*^\\]|\\.)+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $edf931d6dcac43ec$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $edf931d6dcac43ec$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $edf931d6dcac43ec$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $edf931d6dcac43ec$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $edf931d6dcac43ec$export$a1cbf2de32a9fd1 = (url)=>(0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $edf931d6dcac43ec$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $edf931d6dcac43ec$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $edf931d6dcac43ec$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $edf931d6dcac43ec$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $edf931d6dcac43ec$var$normalizeSearch(search),
        hash: $edf931d6dcac43ec$var$normalizeHash(hash)
    };
}
function $edf931d6dcac43ec$var$resolvePathname(relativePath, fromPathname) {
    let segments = $edf931d6dcac43ec$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $edf931d6dcac43ec$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $edf931d6dcac43ec$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $edf931d6dcac43ec$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $edf931d6dcac43ec$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $edf931d6dcac43ec$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $edf931d6dcac43ec$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $edf931d6dcac43ec$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $edf931d6dcac43ec$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $edf931d6dcac43ec$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $edf931d6dcac43ec$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $edf931d6dcac43ec$export$86d9a7913e44197e = (paths)=>$edf931d6dcac43ec$export$f857a07c5bd323b8(paths.join("/"));
function $edf931d6dcac43ec$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $edf931d6dcac43ec$export$a5c6d149b50c1d86 = (pathname)=>$edf931d6dcac43ec$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $edf931d6dcac43ec$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $edf931d6dcac43ec$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $edf931d6dcac43ec$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $edf931d6dcac43ec$export$4051a07651545597(data, init) {
    return new $edf931d6dcac43ec$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $edf931d6dcac43ec$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $edf931d6dcac43ec$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $edf931d6dcac43ec$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $edf931d6dcac43ec$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $edf931d6dcac43ec$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $edf931d6dcac43ec$export$d738435097971c09(matches) {
    return $edf931d6dcac43ec$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $edf931d6dcac43ec$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $edf931d6dcac43ec$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $edf931d6dcac43ec$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($edf931d6dcac43ec$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $ee8fa670c1d03165$export$825a82322d91916e).test(to) ? new URL((0, $ee8fa670c1d03165$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $edf931d6dcac43ec$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region lib/router/instrumentation.ts
const $bb1de4858130979b$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $bb1de4858130979b$export$b1aab28b8e9d7d25 = (0, $edf931d6dcac43ec$export$fd42f52fd3ae1109)();
let $bb1de4858130979b$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $bb1de4858130979b$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.loader, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.action, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.middleware, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $bb1de4858130979b$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $bb1de4858130979b$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to) : ".",
                ...$bb1de4858130979b$var$getRouterInfo(router, opts ?? {})
            };
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $bb1de4858130979b$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$bb1de4858130979b$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $bb1de4858130979b$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.request, {
            request: $bb1de4858130979b$var$getReadonlyRequest(request),
            context: $bb1de4858130979b$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($bb1de4858130979b$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $bb1de4858130979b$var$getUninstrumentedHandler(handler) {
    return handler[$bb1de4858130979b$var$UninstrumentedSymbol] ?? handler;
}
function $bb1de4858130979b$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$bb1de4858130979b$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($bb1de4858130979b$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $bb1de4858130979b$export$5579798e35f5560e(router) {
    let receiver = $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.get(router);
    $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $bb1de4858130979b$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $bb1de4858130979b$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $bb1de4858130979b$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $bb1de4858130979b$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $bb1de4858130979b$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $bb1de4858130979b$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $bb1de4858130979b$var$getReadonlyContext(context)
    };
}
function $bb1de4858130979b$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $bb1de4858130979b$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $bb1de4858130979b$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/matcher.ts
var $6069f2a71d2ba88b$export$92541312f2982378 = class {
    #routes = [];
    #branches = [];
    #basename;
    #matchCost = 0;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        this.#routes = routes;
        this.#branches = (0, $edf931d6dcac43ec$export$e486c0390e42ccf6)(routes);
        this.#matchCost = this.#branches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    }
    get matchCost() {
        return this.#matchCost;
    }
    match(locationArg, allowPartial = false) {
        return (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(this.#routes, locationArg, this.#basename, allowPartial, this.#branches);
    }
};


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * Split a route pattern into protocol, hostname, port, pathname, and search
 * spans delimited as `protocol://hostname:port/pathname?search`.
 *
 * Delimiters are not included in the spans with the exception of the leading `/` for pathname.
 * Spans are [begin (inclusive), end (exclusive)].
 *
 * @param source the route pattern string to split
 * @returns an object containing spans for each URL component
 */ function $344366481ada1aed$export$65980d18b75784e2(source) {
    let result = {
        protocol: null,
        hostname: null,
        port: null,
        pathname: null,
        search: null
    };
    let questionMarkIndex = source.indexOf('?');
    if (questionMarkIndex !== -1) {
        result.search = $344366481ada1aed$var$span(questionMarkIndex + 1, source.length);
        source = source.slice(0, questionMarkIndex);
    }
    let solidusIndex = source.indexOf('://');
    if (solidusIndex === -1) {
        result.pathname = $344366481ada1aed$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    let slashIndex = source.indexOf('/');
    if (slashIndex === solidusIndex + 1) slashIndex = source.indexOf('/', solidusIndex + 3);
    if (slashIndex === -1) {
        result.protocol = $344366481ada1aed$var$span(0, solidusIndex);
        let host = $344366481ada1aed$var$span(solidusIndex + 3, source.length);
        if (host) {
            let { hostname: hostname, port: port } = $344366481ada1aed$var$hostSpans(source, host);
            result.hostname = hostname;
            result.port = port;
        }
        return result;
    }
    if (slashIndex < solidusIndex) {
        result.pathname = $344366481ada1aed$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    result.protocol = $344366481ada1aed$var$span(0, solidusIndex);
    let host = $344366481ada1aed$var$span(solidusIndex + 3, slashIndex);
    if (host) {
        let { hostname: hostname, port: port } = $344366481ada1aed$var$hostSpans(source, host);
        result.hostname = hostname;
        result.port = port;
    }
    result.pathname = $344366481ada1aed$var$pathnameSpan(source, slashIndex, source.length);
    return result;
}
function $344366481ada1aed$var$span(start, end) {
    if (start === end) return null;
    return [
        start,
        end
    ];
}
function $344366481ada1aed$var$hostSpans(source, host) {
    let lastColonIndex = source.slice(0, host[1]).lastIndexOf(':');
    if (lastColonIndex === -1 || lastColonIndex < host[0]) return {
        hostname: host,
        port: null
    };
    if (source.slice(lastColonIndex + 1, host[1]).match(/^\d+$/)) return {
        hostname: $344366481ada1aed$var$span(host[0], lastColonIndex),
        port: $344366481ada1aed$var$span(lastColonIndex + 1, host[1])
    };
    return {
        hostname: host,
        port: null
    };
}
function $344366481ada1aed$var$pathnameSpan(source, begin, end) {
    if (source[begin] === '/') begin += 1;
    return $344366481ada1aed$var$span(begin, end);
}



const $460a28c920c4dfda$var$IDENTIFIER_RE = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
function $460a28c920c4dfda$export$e26190e3669abbfe(source) {
    let spans = (0, $344366481ada1aed$export$65980d18b75784e2)(source);
    return new (0, $0d4f95eb196de161$export$2917961db0dd6e8b)({
        protocol: $460a28c920c4dfda$var$parseProtocol(source, spans.protocol),
        hostname: $460a28c920c4dfda$var$parseHostname(source, spans.hostname),
        port: spans.port ? source.slice(...spans.port) : null,
        pathname: spans.pathname ? $460a28c920c4dfda$export$6681bda78b6b4cbd(source, {
            span: spans.pathname,
            type: 'pathname'
        }) : $460a28c920c4dfda$export$6681bda78b6b4cbd('', {
            span: [
                0,
                0
            ],
            type: 'pathname'
        }),
        search: spans.search ? $460a28c920c4dfda$var$parseSearch(source.slice(...spans.search)) : new Map()
    });
}
function $460a28c920c4dfda$export$6681bda78b6b4cbd(source, options) {
    let span = options.span ?? [
        0,
        source.length
    ];
    let separator = options.type === 'hostname' ? '.' : '/';
    let tokens = [];
    let optionals = new Map();
    let appendText = (text)=>{
        let currentToken = tokens.at(-1);
        if (currentToken?.type === 'text') currentToken.text += text;
        else tokens.push({
            type: 'text',
            text: text
        });
    };
    let i = span[0];
    let optionalStack = [];
    while(i < span[1]){
        let char = source[i];
        if (char === '(') {
            optionalStack.push(tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ')') {
            let begin = optionalStack.pop();
            if (begin === undefined) throw new $460a28c920c4dfda$export$f9c837a54db411d('unmatched )', source, i);
            optionals.set(begin, tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ':') {
            i += 1;
            let name = $460a28c920c4dfda$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            if (!name) throw new $460a28c920c4dfda$export$f9c837a54db411d('missing variable name', source, i - 1);
            tokens.push({
                type: ':',
                name: name
            });
            i += name.length;
            continue;
        }
        if (char === '*') {
            i += 1;
            let name = $460a28c920c4dfda$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            tokens.push({
                type: '*',
                name: name ?? '*'
            });
            i += name?.length ?? 0;
            continue;
        }
        if (char === separator) {
            tokens.push({
                type: 'separator'
            });
            i += 1;
            continue;
        }
        if (char === '\\') {
            if (i + 1 === span[1]) throw new $460a28c920c4dfda$export$f9c837a54db411d('dangling escape', source, i);
            let text = source.slice(i + 1, i + 2);
            appendText(text);
            i += 2;
            continue;
        }
        appendText(char);
        i += 1;
    }
    if (optionalStack.length > 0) throw new $460a28c920c4dfda$export$f9c837a54db411d('unmatched (', source, optionalStack.at(-1));
    return {
        tokens: tokens,
        optionals: optionals,
        type: options.type
    };
}
function $460a28c920c4dfda$var$parseProtocol(source, span) {
    if (!span) return null;
    let protocol = source.slice(...span);
    if (protocol === '' || protocol === 'http' || protocol === 'https' || protocol === 'http(s)') return protocol === '' ? null : protocol;
    throw new $460a28c920c4dfda$export$f9c837a54db411d('invalid protocol', source, span[0]);
}
function $460a28c920c4dfda$var$parseHostname(source, span) {
    if (!span) return null;
    let part = $460a28c920c4dfda$export$6681bda78b6b4cbd(source, {
        span: span,
        type: 'hostname'
    });
    if ($460a28c920c4dfda$var$isNamelessWildcard(part)) return null;
    return part;
}
function $460a28c920c4dfda$var$isNamelessWildcard(part) {
    if (part.tokens.length !== 1) return false;
    let token = part.tokens[0];
    if (token.type !== '*') return false;
    return token.name === '*';
}
function $460a28c920c4dfda$var$parseSearch(source) {
    let constraints = new Map();
    let searchParams = new URLSearchParams(source);
    for (let [key, value] of searchParams){
        let requiredValues = constraints.get(key);
        if (!requiredValues) {
            requiredValues = new Set();
            constraints.set(key, requiredValues);
        }
        if (value === '') continue;
        requiredValues.add(value);
    }
    return constraints;
}
class $460a28c920c4dfda$export$f9c837a54db411d extends Error {
    /** The parse failure category. */ type;
    /** Original pattern source being parsed. */ source;
    /** Character index where parsing failed. */ index;
    constructor(type, source, index){
        let underline = ' '.repeat(index) + '^';
        let message = `${type}\n\n${source}\n${underline}`;
        super(message);
        this.name = 'ParseError';
        this.type = type;
        this.source = source;
        this.index = index;
    }
}


/**
 * An internal error that should never happen.
 *
 * @param value Typed as `never` to ensure exhaustiveness for discriminated unions.
 */ function $153a5362d6eec09c$export$565e9d9bd6b6e0d4(value) {
    let message = value === undefined ? 'Unreachable' : `Unreachable: ${value}`;
    throw new Error(message);
}


function $5d9d1b69d16348c5$export$f54f830b0caf58b(pattern) {
    let protocol = $5d9d1b69d16348c5$export$f5782abab8870711(pattern);
    let hostname = $5d9d1b69d16348c5$export$191bef10f978d68f(pattern);
    let port = $5d9d1b69d16348c5$export$776a5d5828862b2f(pattern);
    let pathname = $5d9d1b69d16348c5$export$a2dfe5fa28b7cbe3(pattern);
    let search = $5d9d1b69d16348c5$export$3ba2b473bde2deb8(pattern);
    let result = '';
    if (protocol || hostname || port) result += `${protocol}://${hostname}${port === '' ? '' : `:${port}`}`;
    result += '/' + pathname;
    if (search) result += `?${search}`;
    return result;
}
function $5d9d1b69d16348c5$export$161f896add7aeb90(pattern) {
    return {
        protocol: $5d9d1b69d16348c5$export$f5782abab8870711(pattern),
        hostname: $5d9d1b69d16348c5$export$191bef10f978d68f(pattern),
        port: $5d9d1b69d16348c5$export$776a5d5828862b2f(pattern),
        pathname: $5d9d1b69d16348c5$export$a2dfe5fa28b7cbe3(pattern),
        search: $5d9d1b69d16348c5$export$3ba2b473bde2deb8(pattern)
    };
}
function $5d9d1b69d16348c5$export$f5782abab8870711(pattern) {
    return pattern.protocol ?? '';
}
function $5d9d1b69d16348c5$export$191bef10f978d68f(pattern) {
    return pattern.hostname ? $5d9d1b69d16348c5$export$4d98ccdba8645223(pattern.hostname) : '';
}
function $5d9d1b69d16348c5$export$776a5d5828862b2f(pattern) {
    return pattern.port ?? '';
}
function $5d9d1b69d16348c5$export$a2dfe5fa28b7cbe3(pattern) {
    return $5d9d1b69d16348c5$export$4d98ccdba8645223(pattern.pathname);
}
function $5d9d1b69d16348c5$export$3ba2b473bde2deb8(pattern) {
    if (pattern.search.size === 0) return '';
    let searchParams = new URLSearchParams();
    for (let [key, constraint] of pattern.search){
        if (constraint.size === 0) searchParams.append(key, '');
        else for (let value of constraint)searchParams.append(key, value);
    }
    return searchParams.toString();
}
function $5d9d1b69d16348c5$var$escapeText(text) {
    return text.replaceAll(/[:*()\\]/g, '\\$&');
}
function $5d9d1b69d16348c5$export$4d98ccdba8645223(part) {
    let separator = part.type === 'hostname' ? '.' : '/';
    let result = '';
    for (let token of part.tokens){
        if (token.type === '(' || token.type === ')') {
            result += token.type;
            continue;
        }
        if (token.type === 'text') {
            result += $5d9d1b69d16348c5$var$escapeText(token.text);
            continue;
        }
        if (token.type === ':' || token.type === '*') {
            let name = token.name === '*' ? '' : token.name;
            result += `${token.type}${name}`;
            continue;
        }
        if (token.type === 'separator') {
            result += separator;
            continue;
        }
        (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}


class $0d4f95eb196de161$export$2917961db0dd6e8b {
    protocol;
    hostname;
    port;
    pathname;
    search;
    /**
     * Create a new `RoutePattern` by parsing a source string.
     *
     * @param source The route pattern source string.
     * @returns The parsed route pattern.
     */ static parse(source) {
        return (0, $460a28c920c4dfda$export$e26190e3669abbfe)(source);
    }
    /**
     * Create a new `RoutePattern` from parsed parts of a route pattern.
     *
     * Useful for efficiently deriving new patterns from already parsed patterns.
     * Unless you know what you are doing, you probably want `RoutePattern.parse`.
     *
     * @param parsed Parsed route pattern parts.
     */ constructor(parsed){
        this.protocol = parsed.protocol;
        this.hostname = parsed.hostname;
        this.port = parsed.port;
        this.pathname = parsed.pathname;
        this.search = parsed.search;
    }
    /** Normalized string representation of this pattern */ get source() {
        return (0, $5d9d1b69d16348c5$export$f54f830b0caf58b)(this);
    }
    /**
     * Returns a string representing this route pattern.
     *
     * @returns The same normalized pattern string as `RoutePattern.source`.
     */ toString() {
        return this.source;
    }
    /**
     * Returns a JSON-serializable object containing each serialized part of this route pattern.
     *
     * @returns The serialized protocol, hostname, port, pathname, and search.
     */ toJSON() {
        return (0, $5d9d1b69d16348c5$export$161f896add7aeb90)(this);
    }
}



// Adapted from https://github.com/mathiasbynens/punycode.js/blob/9e1b2cda98d215d3a73fcbfe93c62e021f4ba768/punycode.js
/** Highest positive signed 32-bit float value */ const $99cf089510b52c01$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $99cf089510b52c01$var$base = 36;
const $99cf089510b52c01$var$tMin = 1;
const $99cf089510b52c01$var$tMax = 26;
const $99cf089510b52c01$var$skew = 38;
const $99cf089510b52c01$var$damp = 700;
const $99cf089510b52c01$var$initialBias = 72;
const $99cf089510b52c01$var$initialN = 128; // 0x80
const $99cf089510b52c01$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $99cf089510b52c01$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $99cf089510b52c01$var$errors = {
    overflow: 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
const $99cf089510b52c01$var$baseMinusTMin = $99cf089510b52c01$var$base - $99cf089510b52c01$var$tMin;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @param type The error type.
 */ function $99cf089510b52c01$var$error(type) {
    throw new RangeError($99cf089510b52c01$var$errors[type]);
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @param domain The domain name or email address.
 * @param callback The function that gets called for every character.
 * @returns A new string of characters returned by the callback function.
 */ function $99cf089510b52c01$var$mapDomain(domain, callback) {
    let parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    domain = domain.replace($99cf089510b52c01$var$regexSeparators, '.');
    let labels = domain.split('.');
    let encoded = labels.map(callback).join('.');
    return result + encoded;
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @param codePoint The basic numeric code point value.
 * @returns The numeric value of a basic code point in the range `0` to
 * `base - 1`, or `base` if the code point does not represent a value.
 */ function $99cf089510b52c01$var$basicToDigit(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3a) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5b) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7b) return codePoint - 0x61;
    return $99cf089510b52c01$var$base;
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @param delta The current delta.
 * @param numPoints The number of code points handled.
 * @param firstTime Whether this is the first adaptation.
 * @returns The adapted bias.
 */ function $99cf089510b52c01$var$adapt(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? Math.floor(delta / $99cf089510b52c01$var$damp) : delta >> 1;
    delta += Math.floor(delta / numPoints);
    for(; delta > $99cf089510b52c01$var$baseMinusTMin * $99cf089510b52c01$var$tMax >> 1; k += $99cf089510b52c01$var$base)delta = Math.floor(delta / $99cf089510b52c01$var$baseMinusTMin);
    return Math.floor(k + ($99cf089510b52c01$var$baseMinusTMin + 1) * delta / (delta + $99cf089510b52c01$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @param input The Punycode string of ASCII-only symbols.
 * @returns The resulting string of Unicode symbols.
 */ function $99cf089510b52c01$var$decode(input) {
    // Don't use UCS-2.
    let output = [];
    let inputLength = input.length;
    let i = 0;
    let n = $99cf089510b52c01$var$initialN;
    let bias = $99cf089510b52c01$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($99cf089510b52c01$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $99cf089510b52c01$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength /* no final expression */ ;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $99cf089510b52c01$var$base /* no condition */ ;; k += $99cf089510b52c01$var$base){
            if (index >= inputLength) $99cf089510b52c01$var$error('invalid-input');
            let digit = $99cf089510b52c01$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $99cf089510b52c01$var$base) $99cf089510b52c01$var$error('invalid-input');
            if (digit > Math.floor(($99cf089510b52c01$var$maxInt - i) / w)) $99cf089510b52c01$var$error('overflow');
            i += digit * w;
            let t = k <= bias ? $99cf089510b52c01$var$tMin : k >= bias + $99cf089510b52c01$var$tMax ? $99cf089510b52c01$var$tMax : k - bias;
            if (digit < t) break;
            let baseMinusT = $99cf089510b52c01$var$base - t;
            if (w > Math.floor($99cf089510b52c01$var$maxInt / baseMinusT)) $99cf089510b52c01$var$error('overflow');
            w *= baseMinusT;
        }
        let out = output.length + 1;
        bias = $99cf089510b52c01$var$adapt(i - oldi, out, oldi === 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (Math.floor(i / out) > $99cf089510b52c01$var$maxInt - n) $99cf089510b52c01$var$error('overflow');
        n += Math.floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
}
const $99cf089510b52c01$export$110c810e8727e62b = function(input) {
    // Optimization: skip if no punycode markers found
    if (!input.includes('xn--')) return input;
    return $99cf089510b52c01$var$mapDomain(input, function(string) {
        return string.startsWith('xn--') ? $99cf089510b52c01$var$decode(string.slice(4).toLowerCase()) : string;
    });
};





function $141bb69856e07f84$export$4e7f196112fea3c5(text) {
    return text.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}
function $141bb69856e07f84$export$238374f1b270e387(tokens, options) {
    let result = '';
    for (let token of tokens){
        if (token.type === 'text') {
            result += $141bb69856e07f84$export$4e7f196112fea3c5(token.text);
            continue;
        }
        if (token.type === ':') {
            result += `([^${options.separator}]+?)`;
            continue;
        }
        if (token.type === '*') {
            result += `(.*)`;
            continue;
        }
        if (token.type === '(') {
            result += '(?:';
            continue;
        }
        if (token.type === ')') {
            result += ')?';
            continue;
        }
        if (token.type === 'separator') {
            result += $141bb69856e07f84$export$4e7f196112fea3c5(options.separator);
            continue;
        }
        (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
    }
    let flags = 'd';
    if (options.ignoreCase) flags += 'i';
    return new RegExp(`^${result}$`, flags);
}



function $36c37f2dc102fab2$export$9ac16898ad61bc17(pattern) {
    let result = [];
    for (let protocol of $36c37f2dc102fab2$var$generateProtocolVariants(pattern.protocol)){
        let port = $36c37f2dc102fab2$var$normalizePort(protocol, pattern.port);
        for (let hostname of $36c37f2dc102fab2$var$generateHostnameVariants(pattern.hostname))for (let pathname of $36c37f2dc102fab2$var$generatePathnameVariants(pattern.pathname))result.push({
            protocol: protocol,
            hostname: hostname,
            port: port,
            pathname: pathname
        });
    }
    return result;
}
function $36c37f2dc102fab2$var$generateProtocolVariants(protocol) {
    if (protocol === null || protocol === 'http(s)') return [
        'http',
        'https'
    ];
    return [
        protocol
    ];
}
function $36c37f2dc102fab2$var$normalizePort(protocol, port) {
    if (port === null) return '';
    if (protocol === 'http' && port === '80') return '';
    if (protocol === 'https' && port === '443') return '';
    return port;
}
function $36c37f2dc102fab2$var$toParams(tokens) {
    let params = [];
    for (let token of tokens)if (token.type === ':' || token.type === '*') params.push(token);
    return params;
}
function $36c37f2dc102fab2$var$generateHostnameVariants(hostname) {
    let result = [];
    if (hostname === null) return [
        {
            type: 'any'
        }
    ];
    for (let variant of $36c37f2dc102fab2$export$57a1d23d0b7a46c(hostname)){
        let params = $36c37f2dc102fab2$var$toParams(variant);
        if (params.length > 0) result.push({
            type: 'dynamic',
            params: params,
            regexp: (0, $141bb69856e07f84$export$238374f1b270e387)(variant, {
                separator: '.',
                ignoreCase: false
            })
        });
        else result.push({
            type: 'static',
            value: $36c37f2dc102fab2$var$stringifyStatic(variant, '.')
        });
    }
    return result;
}
function $36c37f2dc102fab2$var$stringifyStatic(variant, separator) {
    let result = '';
    for (let token of variant){
        if (token.type === 'text') result += token.text;
        else if (token.type === 'separator') result += separator;
        else throw new Error(`expected static part variant, got token type '${token.type}'`);
    }
    return result;
}
function $36c37f2dc102fab2$var$generatePathnameVariants(pathname, options) {
    let result = [];
    let ignoreCase = options?.ignoreCase ?? false;
    for (let tokens of $36c37f2dc102fab2$export$57a1d23d0b7a46c(pathname)){
        let variant = [];
        let key = '';
        let reSource = '';
        let reFlags = ignoreCase ? 'di' : 'd';
        let type = 'static';
        let params = [];
        for (let token of tokens){
            if (token.type === 'separator') {
                if (type === 'static') {
                    variant.push({
                        type: 'static',
                        key: ignoreCase ? key.toLowerCase() : key
                    });
                    key = '';
                    reSource = '';
                    continue;
                }
                if (type === 'variable') {
                    variant.push({
                        type: 'variable',
                        key: key,
                        regexp: new RegExp(`^${reSource}$`, reFlags),
                        params: params
                    });
                    key = '';
                    reSource = '';
                    params = [];
                    type = 'static';
                    continue;
                }
                if (type === 'wildcard') {
                    key += '/';
                    reSource += (0, $141bb69856e07f84$export$4e7f196112fea3c5)('/');
                    continue;
                }
                (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(type);
            }
            if (token.type === 'text') {
                // Encode to comply with URL pathname normalization in trie matcher
                let text = encodeURIComponent(token.text);
                key += text;
                reSource += (0, $141bb69856e07f84$export$4e7f196112fea3c5)(text);
                continue;
            }
            if (token.type === ':') {
                key += '{:}';
                reSource += `([^/]+)`;
                params.push(token);
                if (type === 'static') type = 'variable';
                continue;
            }
            if (token.type === '*') {
                key += '{*}';
                reSource += `(.*)`;
                params.push(token);
                type = 'wildcard';
                continue;
            }
            (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
        }
        if (type === 'static') variant.push({
            type: 'static',
            key: ignoreCase ? key.toLowerCase() : key
        });
        if (type === 'variable' || type === 'wildcard') variant.push({
            type: type,
            key: key,
            regexp: new RegExp(`^${reSource}$`, reFlags),
            params: params
        });
        result.push(variant);
    }
    return result;
}
function $36c37f2dc102fab2$export$57a1d23d0b7a46c(part) {
    let result = [];
    let stack = [
        {
            index: 0,
            tokens: []
        }
    ];
    while(stack.length > 0){
        let { index: index, tokens: tokens } = stack.pop();
        if (index === part.tokens.length) {
            result.push(tokens);
            continue;
        }
        let token = part.tokens[index];
        if (token.type === '(') {
            stack.push({
                index: index + 1,
                tokens: tokens
            }, {
                index: part.optionals.get(index) + 1,
                tokens: tokens.slice()
            });
            continue;
        }
        if (token.type === ')') {
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        if (token.type === ':' || token.type === '*' || token.type === 'text' || token.type === 'separator') {
            tokens.push(token);
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}



class $60ae74f014ccd001$export$73571c50d0f2507e {
    ignoreCase;
    #root;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#root = {
            http: $60ae74f014ccd001$var$createHostnameNode(),
            https: $60ae74f014ccd001$var$createHostnameNode()
        };
    }
    insert(pattern, data) {
        for (let variant of (0, $36c37f2dc102fab2$export$9ac16898ad61bc17)(pattern)){
            let hostnameNode = this.#root[variant.protocol];
            let portNode;
            if (variant.hostname.type === 'any') portNode = hostnameNode.any;
            else if (variant.hostname.type === 'static') {
                let key = variant.hostname.value.toLowerCase();
                let existing = hostnameNode.static.get(key);
                if (existing === undefined) {
                    existing = new Map();
                    hostnameNode.static.set(key, existing);
                }
                portNode = existing;
            } else {
                portNode = new Map();
                hostnameNode.dynamic.push({
                    regexp: variant.hostname.regexp,
                    params: variant.hostname.params,
                    portNode: portNode
                });
            }
            let pathnameRoot = portNode.get(variant.port);
            if (pathnameRoot === undefined) {
                pathnameRoot = $60ae74f014ccd001$var$createPathnameNode();
                portNode.set(variant.port, pathnameRoot);
            }
            let pathnameNode = pathnameRoot;
            for (let segment of variant.pathname){
                if (segment.type === 'static') {
                    let key = this.ignoreCase ? segment.key.toLowerCase() : segment.key;
                    let next = pathnameNode.static.get(key);
                    if (next === undefined) {
                        next = $60ae74f014ccd001$var$createPathnameNode();
                        pathnameNode.static.set(key, next);
                    }
                    pathnameNode = next;
                    continue;
                }
                if (segment.type === 'variable') {
                    let next = pathnameNode.variable.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $60ae74f014ccd001$var$createPathnameNode()
                        };
                        pathnameNode.variable.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                if (segment.type === 'wildcard') {
                    let next = pathnameNode.wildcard.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $60ae74f014ccd001$var$createPathnameNode()
                        };
                        pathnameNode.wildcard.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(segment);
            }
            let requiredParams = [];
            for (let segment of variant.pathname){
                if (segment.type === 'variable' || segment.type === 'wildcard') for (let param of segment.params)requiredParams.push(param);
            }
            let undefinedParams = [];
            for (let param of pattern.pathname.tokens){
                if (param.type !== ':' && param.type !== '*') continue;
                if (requiredParams.some((p)=>p.name === param.name)) continue;
                if (undefinedParams.some((p)=>p.name === param.name)) continue;
                undefinedParams.push(param);
            }
            pathnameNode.values.push({
                pattern: pattern,
                data: data,
                requiredParams: requiredParams,
                undefinedParams: undefinedParams
            });
        }
    }
    search(url) {
        let protocol = url.protocol.slice(0, -1);
        if (protocol !== 'http' && protocol !== 'https') return [];
        let hostnameNode = this.#root[protocol];
        let decodedHostname = (0, $99cf089510b52c01$export$110c810e8727e62b)(url.hostname);
        let origins = [];
        // any hostname (no port allowed -- empty-port key)
        let anyPathname = hostnameNode.any.get('');
        if (anyPathname) origins.push({
            hostnameMatch: [
                {
                    type: '*',
                    name: '*',
                    value: decodedHostname,
                    begin: 0,
                    end: decodedHostname.length
                }
            ],
            pathnameNode: anyPathname
        });
        // static hostname
        let staticPort = hostnameNode.static.get(decodedHostname.toLowerCase());
        if (staticPort) {
            let next = staticPort.get(url.port);
            if (next) origins.push({
                hostnameMatch: [],
                pathnameNode: next
            });
        }
        // dynamic hostnames
        for (let entry of hostnameNode.dynamic){
            let m = entry.regexp.exec(decodedHostname);
            if (!m) continue;
            let next = entry.portNode.get(url.port);
            if (!next) continue;
            let hostnameMatch = [];
            for(let i = 0; i < entry.params.length; i++){
                let param = entry.params[i];
                let span = m.indices?.[i + 1];
                if (span === undefined) continue;
                hostnameMatch.push({
                    type: param.type,
                    name: param.name,
                    value: m[i + 1],
                    begin: span[0],
                    end: span[1]
                });
            }
            origins.push({
                hostnameMatch: hostnameMatch,
                pathnameNode: next
            });
        }
        let results = [];
        let urlSegments = $60ae74f014ccd001$var$normalizePathname(url.pathname);
        if (urlSegments === null) return results;
        for (let origin of origins){
            let stack = [
                {
                    segmentIndex: 0,
                    pathnameNode: origin.pathnameNode,
                    charOffset: 0,
                    captures: []
                }
            ];
            while(stack.length > 0){
                let current = stack.pop();
                if (current.segmentIndex === urlSegments.length) {
                    for (let value of current.pathnameNode.values){
                        if (!$60ae74f014ccd001$var$matchSearch(url.searchParams, value.pattern.search)) continue;
                        let pathnameMatch = [];
                        for(let i = 0; i < value.requiredParams.length; i++){
                            let param = value.requiredParams[i];
                            let cap = current.captures[i];
                            pathnameMatch.push({
                                type: param.type,
                                name: param.name,
                                value: $60ae74f014ccd001$var$fastDecodeURIComponent(cap.value),
                                begin: cap.begin,
                                end: cap.end
                            });
                        }
                        let params = {};
                        for (let token of value.pattern.hostname?.tokens ?? [])if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let token of value.pattern.pathname.tokens)if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let p of origin.hostnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        for (let p of pathnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        results.push({
                            url: url,
                            pattern: value.pattern,
                            data: value.data,
                            params: params,
                            paramsMeta: {
                                hostname: origin.hostnameMatch,
                                pathname: pathnameMatch
                            }
                        });
                    }
                    continue;
                }
                let urlSegment = urlSegments[current.segmentIndex];
                let staticKey = this.ignoreCase ? urlSegment.toLowerCase() : urlSegment;
                let nextStatic = current.pathnameNode.static.get(staticKey);
                if (nextStatic) stack.push({
                    segmentIndex: current.segmentIndex + 1,
                    pathnameNode: nextStatic,
                    charOffset: current.charOffset + urlSegment.length + 1,
                    captures: current.captures
                });
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.variable.values()){
                    let m = regexp.exec(urlSegment);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)();
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: current.segmentIndex + 1,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + m.index + m[0].length + 1,
                        captures: captures
                    });
                }
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.wildcard.values()){
                    let remaining = urlSegments.slice(current.segmentIndex).join('/');
                    let m = regexp.exec(remaining);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) continue;
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: urlSegments.length,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + remaining.length,
                        captures: captures
                    });
                }
            }
        }
        return results;
    }
}
// Pathname codec ----------------------------------------------------------------------------------
// Pathname matching uses canonical percent-encoded text. URL pathnames are split on structural
// "/" before normalization so encoded slashes like "%2F" remain data within a segment instead of
// becoming separators. Pattern static text is encoded the same way when variants are generated.
function $60ae74f014ccd001$var$normalizePathname(pathname) {
    let segments = [];
    for (let segment of pathname.slice(1).split('/')){
        let normalized = $60ae74f014ccd001$var$normalizePathnameText(segment);
        if (normalized === null) return null;
        segments.push(normalized);
    }
    return segments;
}
function $60ae74f014ccd001$var$normalizePathnameText(text) {
    let decoded = $60ae74f014ccd001$var$safeDecodeURIComponent(text);
    return decoded === null ? null : encodeURIComponent(decoded);
}
function $60ae74f014ccd001$var$fastDecodeURIComponent(text) {
    return text.includes('%') ? decodeURIComponent(text) : text;
}
function $60ae74f014ccd001$var$safeDecodeURIComponent(text) {
    try {
        return $60ae74f014ccd001$var$fastDecodeURIComponent(text);
    } catch (error) {
        if (error instanceof URIError) return null;
        throw error;
    }
}
// Search ------------------------------------------------------------------------------------------
function $60ae74f014ccd001$var$matchSearch(params, constraints) {
    for (let [name, requiredValues] of constraints){
        if (requiredValues.size === 0) {
            if (!params.has(name)) return false;
            continue;
        }
        let values = params.getAll(name);
        for (let requiredValue of requiredValues){
            if (!values.includes(requiredValue)) return false;
        }
    }
    return true;
}
function $60ae74f014ccd001$var$createHostnameNode() {
    return {
        static: new Map(),
        dynamic: [],
        any: new Map()
    };
}
function $60ae74f014ccd001$var$createPathnameNode() {
    return {
        static: new Map(),
        variable: new Map(),
        wildcard: new Map(),
        values: []
    };
}



function $9fb36bacaef2a008$export$9b050841a3a1b328(a, b) {
    return $9fb36bacaef2a008$export$398604a469f7de9a(a, b) === -1;
}
function $9fb36bacaef2a008$export$f517ea36c68d4644(a, b) {
    return $9fb36bacaef2a008$export$398604a469f7de9a(a, b) === 1;
}
function $9fb36bacaef2a008$export$411ce8e5a71e3069(a, b) {
    return $9fb36bacaef2a008$export$398604a469f7de9a(a, b) === 0;
}
const $9fb36bacaef2a008$export$fcb633242ef15540 = (a, b)=>$9fb36bacaef2a008$export$398604a469f7de9a(a, b);
const $9fb36bacaef2a008$export$4fa3190a997c3d8f = (a, b)=>$9fb36bacaef2a008$export$398604a469f7de9a(a, b) * -1;
function $9fb36bacaef2a008$export$398604a469f7de9a(a, b) {
    if (a.url.href !== b.url.href) throw new Error(`Cannot compare matches for different URLs: ${a.url.href} vs ${b.url.href}`);
    let hostname = (0, $99cf089510b52c01$export$110c810e8727e62b)(a.url.hostname);
    let hostnameResult = $9fb36bacaef2a008$var$compareHostname(hostname, a.paramsMeta.hostname, b.paramsMeta.hostname);
    if (hostnameResult !== 0) return hostnameResult;
    let pathnameResult = $9fb36bacaef2a008$var$comparePathname(a.paramsMeta.pathname, b.paramsMeta.pathname);
    if (pathnameResult !== 0) return pathnameResult;
    let searchResult = $9fb36bacaef2a008$var$compareSearch(a.pattern.search, b.pattern.search);
    if (searchResult !== 0) return searchResult;
    return 0;
}
function $9fb36bacaef2a008$var$compareHostname(hostname, a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    // Encoding of hostname chars: 0 = static, 1 = variable (:), 2 = wildcard (*)
    // Note: `Int8Array` defaults to 0 for all indices not explicitly set.
    let aEncoding = new Int8Array(hostname.length);
    for (let range of a)aEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    let bEncoding = new Int8Array(hostname.length);
    for (let range of b)bEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    // Build segments right-to-left: desc order by begin
    let segments = [];
    let end = hostname.length;
    for(let i = hostname.length - 1; i >= 0; i--)if (hostname[i] === '.') {
        segments.push({
            begin: i + 1,
            end: end
        });
        end = i;
    }
    segments.push({
        begin: 0,
        end: end
    }); // leftmost segment
    for (let segment of segments)for(let j = segment.begin; j < segment.end; j++){
        if (aEncoding[j] < bEncoding[j]) return 1; // a is more specific
        if (aEncoding[j] > bEncoding[j]) return -1; // b is more specific
    }
    return 0;
}
function $9fb36bacaef2a008$var$comparePathname(a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    let i = 0;
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < a.length || bIndex < b.length){
        let aRange = a[aIndex];
        let bRange = b[bIndex];
        if (aRange === undefined) return 1; // a is fully static from here
        if (bRange === undefined) return -1; // b is fully static from here
        // Skip to the minimum begin of the two current ranges
        i = Math.min(aRange.begin, bRange.begin);
        if (i < aRange.begin) return 1; // a has static content at i
        if (i < bRange.begin) return -1; // b has static content at i
        if (aRange.type === ':' && bRange.type === '*') return 1; // a is more specific
        if (aRange.type === '*' && bRange.type === ':') return -1; // b is more specific
        let minEnd = Math.min(aRange.end, bRange.end);
        i = minEnd;
        // Advance range indices if we've reached their ends
        if (i >= aRange.end) aIndex += 1;
        if (i >= bRange.end) bIndex += 1;
    }
    return 0;
}
function $9fb36bacaef2a008$var$compareSearch(a, b) {
    let aSpecificity = $9fb36bacaef2a008$var$searchSpecificity(a);
    let bSpecificity = $9fb36bacaef2a008$var$searchSpecificity(b);
    if (aSpecificity.keyValue > bSpecificity.keyValue) return 1;
    if (aSpecificity.keyValue < bSpecificity.keyValue) return -1;
    if (aSpecificity.key > bSpecificity.key) return 1;
    if (aSpecificity.key < bSpecificity.key) return -1;
    return 0;
}
function $9fb36bacaef2a008$var$searchSpecificity(constraints) {
    let specificity = {
        key: 0,
        keyValue: 0
    };
    for (let constraint of constraints.values()){
        if (constraint.size === 0) {
            specificity.key += 1;
            continue;
        }
        specificity.keyValue += constraint.size;
    }
    return specificity;
}


function $5eb3501f92234bfb$export$1d94974cf1366deb(pattern, options) {
    pattern = typeof pattern === 'string' ? (0, $0d4f95eb196de161$export$2917961db0dd6e8b).parse(pattern) : pattern;
    let matcher = $5eb3501f92234bfb$export$cf760d085d57ec27(options);
    matcher.add(pattern, undefined);
    return {
        match (url) {
            return matcher.match(url);
        }
    };
}
function $5eb3501f92234bfb$export$cf760d085d57ec27(options) {
    return new $5eb3501f92234bfb$var$TrieMatcher(options);
}
class $5eb3501f92234bfb$var$TrieMatcher {
    ignoreCase;
    #trie;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#trie = new (0, $60ae74f014ccd001$export$73571c50d0f2507e)({
            ignoreCase: this.ignoreCase
        });
    }
    add(pattern, data) {
        pattern = typeof pattern === 'string' ? (0, $460a28c920c4dfda$export$e26190e3669abbfe)(pattern) : pattern;
        this.#trie.insert(pattern, data);
    }
    match(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let best = null;
        for (let match of this.#trie.search(parsedUrl))if (best === null || $9fb36bacaef2a008$export$f517ea36c68d4644(match, best)) best = match;
        return best;
    }
    matchAll(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let matches = [];
        for (let match of this.#trie.search(parsedUrl))matches.push(match);
        return matches.sort($9fb36bacaef2a008$export$4fa3190a997c3d8f);
    }
}







//#region lib/router/matcher-route-pattern.ts
var $6c7b288f30438a50$export$9f42f7e9b7c469cc = class {
    #state;
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        let branches = $6c7b288f30438a50$var$flattenRoutes(routes);
        let matcher = (0, $5eb3501f92234bfb$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        let partialMatcher = (0, $5eb3501f92234bfb$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        for (let branch of branches){
            let routePattern = $6c7b288f30438a50$var$convertReactRouterPathToRoutePattern(branch.path);
            $6c7b288f30438a50$var$validateRoutePatternSplat(branch.path, routePattern);
            routePattern = $6c7b288f30438a50$var$addOptionalTrailingSlash(routePattern);
            matcher.add(routePattern, branch);
            if (!branch.routesMeta[branch.routesMeta.length - 1].route.index) partialMatcher.add(routePattern === "/" ? `/*__rr_partial` : `${routePattern}(/*__rr_partial)`, branch);
        }
        this.#state = {
            branches: branches,
            matcher: matcher,
            partialMatcher: partialMatcher
        };
        return branches;
    }
    match(locationArg, allowPartial = false) {
        let pathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)((typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", this.#basename);
        if (pathname == null) return null;
        let decoded = (0, $edf931d6dcac43ec$export$cd27bea214d030c2)(pathname);
        let url = new URL("http://reactrouter.local");
        url.pathname = pathname.endsWith("/") ? pathname : `${pathname}/`;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(this.#state, "Route pattern routes must be initialized before matching.");
        let matches = this.#state.matcher.matchAll(url);
        if (allowPartial) matches.push(...this.#state.partialMatcher.matchAll(url));
        for (let match of $6c7b288f30438a50$var$prioritizeValidatedMatches(matches)){
            let routeMatches = $6c7b288f30438a50$var$convertRoutePatternMatchToRouteMatches(match, decoded, allowPartial);
            if (routeMatches && $6c7b288f30438a50$var$validateRouteMatchParams(routeMatches)) return routeMatches;
        }
        return null;
    }
};
function $6c7b288f30438a50$var$validateRoutePatternSplat(routePath, routePattern) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($6c7b288f30438a50$var$getRoutePatternSplatIndexes(routePattern).length <= 1 && $6c7b288f30438a50$var$isTerminalRoutePatternSplat(routePattern), `Route path "${routePath}" is not supported with \`future.unstable_routePatternMatching\` because React Router only supports a single splat at the end of a route path.`);
}
function $6c7b288f30438a50$var$getRoutePatternSplatIndexes(routePattern) {
    let splatIndexes = [];
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char === "*") splatIndexes.push(i);
    }
    return splatIndexes;
}
function $6c7b288f30438a50$var$isTerminalRoutePatternSplat(routePattern) {
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char !== "*") continue;
        let suffix = routePattern.slice(i + 1);
        return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(suffix) || suffix === "";
    }
    return true;
}
function $6c7b288f30438a50$var$addOptionalTrailingSlash(routePattern) {
    return routePattern === "/" ? routePattern : `${routePattern.replace(/\/+$/, "")}(/)`;
}
function $6c7b288f30438a50$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    routes.forEach((route, index)=>{
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.caseSensitive !== true, "`caseSensitive` routes are not supported with `future.unstable_routePatternMatching`.");
        let meta = {
            relativePath: route.path || "",
            caseSensitive: false,
            childrenIndex: index,
            route: route
        };
        let absolutePath;
        if (meta.relativePath.startsWith("/")) {
            absolutePath = meta.relativePath;
            let parentPathMatch = (0, $edf931d6dcac43ec$export$82472424e06ad5c9)(parentPath).find((path)=>meta.relativePath.startsWith(path));
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(parentPathMatch != null, `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPathMatch.length);
        }
        let routesMeta = parentsMeta.concat(meta);
        let path = absolutePath ?? (meta.relativePath ? (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            parentPath,
            meta.relativePath
        ]) : parentPath);
        if (route.children && route.children.length > 0) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $6c7b288f30438a50$var$flattenRoutes(route.children, branches, routesMeta, path);
            if (route.children?.some((child)=>child.index)) return;
        }
        if (route.path != null || route.index) branches.push({
            path: path,
            score: 0,
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $6c7b288f30438a50$var$convertReactRouterPathToRoutePattern(path) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) path = path.replace(/\*$/, "/*");
    path = path.replace(/^\/*/, "/");
    if (path === "") return "/";
    let segments = path.split("/");
    let pattern = segments.shift() || "";
    for(let i = 0; i < segments.length;){
        let optionalRun = [];
        while(i < segments.length && $6c7b288f30438a50$var$isOptionalRouteSegment(segments[i])){
            optionalRun.push($6c7b288f30438a50$var$convertRouteSegment(segments[i].slice(0, -1)));
            i++;
        }
        if (optionalRun.length > 0) {
            let nested = optionalRun.reduceRight((child, segment)=>`/${segment}${child ? `(${child})` : ""}`, "");
            pattern += `(${nested})`;
            continue;
        }
        pattern += `/${$6c7b288f30438a50$var$convertRouteSegment(segments[i])}`;
        i++;
    }
    return pattern || "/";
}
function $6c7b288f30438a50$var$isOptionalRouteSegment(segment) {
    return segment.endsWith("?");
}
function $6c7b288f30438a50$var$convertRouteSegment(segment) {
    if (segment === "*") return "*__rr_splat";
    let paramMatch = segment.match(/^:([\w-]+)(\?)?(.*)$/);
    if (paramMatch) {
        let [, paramName, optional, suffix] = paramMatch;
        let converted = `:${paramName}${$6c7b288f30438a50$var$escapeRoutePatternLiteral(suffix)}`;
        return optional ? `(:${paramName})${$6c7b288f30438a50$var$escapeRoutePatternLiteral(suffix)}` : converted;
    }
    return $6c7b288f30438a50$var$escapeRoutePatternLiteral(segment);
}
function $6c7b288f30438a50$var$escapeRoutePatternLiteral(value) {
    return value.replace(/[\\():*]/g, "\\$&");
}
function $6c7b288f30438a50$var$validateRouteMatchParams(matches) {
    return matches.every(({ route: route, params: params })=>route.unstable_validateParams == null || Object.keys(route.unstable_validateParams).length === 0 || Object.entries(route.unstable_validateParams).every(([param, re])=>params[param] != null ? new RegExp(re.source, re.flags).test(params[param]) : true));
}
function $6c7b288f30438a50$var$prioritizeValidatedMatches(matches) {
    return matches.sort((a, b)=>{
        let specificity = (0, $9fb36bacaef2a008$export$4fa3190a997c3d8f)(a, b);
        if (specificity !== 0) return specificity;
        return Number($6c7b288f30438a50$var$hasParamValidators(b)) - Number($6c7b288f30438a50$var$hasParamValidators(a));
    });
}
function $6c7b288f30438a50$var$hasParamValidators(match) {
    return match.data.routesMeta.some((meta)=>meta.route.unstable_validateParams != null && Object.keys(meta.route.unstable_validateParams).length > 0);
}
function $6c7b288f30438a50$var$convertRoutePatternMatchToRouteMatches(match, pathname, allowPartial) {
    let result = $6c7b288f30438a50$var$matchRoutePatternBranch(match.data, pathname, allowPartial, 0, "/", {});
    if (result == null) return null;
    for (let routeMatch of result.matches)routeMatch.params = result.params;
    return result.matches;
}
function $6c7b288f30438a50$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex, matchedPathname, matchedParams) {
    let meta = branch.routesMeta[metaIndex];
    let end = metaIndex === branch.routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    for (let relativePath of (0, $edf931d6dcac43ec$export$82472424e06ad5c9)(meta.relativePath)){
        let pattern = {
            path: relativePath,
            caseSensitive: false,
            end: end
        };
        let pathMatch = (0, $edf931d6dcac43ec$export$81336c211d5ff295)(pattern, remainingPathname);
        if (!pathMatch && end && allowPartial && !meta.route.index) pathMatch = (0, $edf931d6dcac43ec$export$81336c211d5ff295)({
            ...pattern,
            end: false
        }, remainingPathname);
        if (!pathMatch) continue;
        let params = {
            ...matchedParams,
            ...pathMatch.params
        };
        let routeMatch = {
            params: params,
            pathname: (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathname
            ]),
            pathnameBase: (0, $edf931d6dcac43ec$export$a5c6d149b50c1d86)((0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathnameBase
            ])),
            route: meta.route
        };
        let nextMatchedPathname = pathMatch.pathnameBase === "/" ? matchedPathname : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            matchedPathname,
            pathMatch.pathnameBase
        ]);
        if (end) return {
            matches: [
                routeMatch
            ],
            params: params
        };
        let childResult = $6c7b288f30438a50$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex + 1, nextMatchedPathname, params);
        if (childResult) return {
            matches: [
                routeMatch,
                ...childResult.matches
            ],
            params: childResult.params
        };
    }
    return null;
}


//#region lib/router/matcher-route-pattern.preload.ts
let $bb354d9dd1aa514b$var$RoutePatternMatcher;
function $bb354d9dd1aa514b$export$45cda2a841115322() {
    return $bb354d9dd1aa514b$var$RoutePatternMatcher;
}
/**
* Initialize the route-pattern matcher before creating a Data Router or static
* handler with `future.unstable_routePatternMatching` enabled. Import from
* `react-router/route-pattern` and call this once during application startup.
* Server and browser applications must each preload their own matcher.
*
* The matcher is statically imported by this module. Tree-shaking bundlers can
* remove it from applications that do not use this function. Initialization is
* synchronous, and repeated calls are safe.
*
* @public
* @category Data Routers
* @mode data
* @returns {void}
*/ function $bb354d9dd1aa514b$export$c6cb8c636109e21b() {
    $bb354d9dd1aa514b$var$RoutePatternMatcher = (0, $6c7b288f30438a50$export$9f42f7e9b7c469cc);
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $7ab28948be9dda45$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $7ab28948be9dda45$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $7ab28948be9dda45$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $7ab28948be9dda45$var$DEFAULT_NAVIGATION_URL;
    }
}
function $7ab28948be9dda45$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $7ab28948be9dda45$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $7ab28948be9dda45$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$7ab28948be9dda45$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$7ab28948be9dda45$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$7ab28948be9dda45$var$isExplicitUrl(original, originalUrl) || !$7ab28948be9dda45$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}


//#region lib/router/router.ts
const $27ddc9c887d48115$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $27ddc9c887d48115$var$validMutationMethods = new Set($27ddc9c887d48115$var$validMutationMethodsArr);
const $27ddc9c887d48115$var$validRequestMethodsArr = [
    "GET",
    ...$27ddc9c887d48115$var$validMutationMethodsArr
];
const $27ddc9c887d48115$var$validRequestMethods = new Set($27ddc9c887d48115$var$validRequestMethodsArr);
const $27ddc9c887d48115$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $27ddc9c887d48115$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $27ddc9c887d48115$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $27ddc9c887d48115$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $27ddc9c887d48115$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $27ddc9c887d48115$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $27ddc9c887d48115$export$5e64b3b9d7e2ec36(future, basename) {
    if (future.unstable_routePatternMatching) {
        let RoutePatternMatcher = (0, $bb354d9dd1aa514b$export$45cda2a841115322)();
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(RoutePatternMatcher, "You must call unstable_preloadRoutePattern() from \"react-router/route-pattern\" before enabling future.unstable_routePatternMatching.");
        return new RoutePatternMatcher(basename);
    }
    return new (0, $6069f2a71d2ba88b$export$92541312f2982378)(basename);
}
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $27ddc9c887d48115$var$DataRoutes = class {
    #routes;
    #hmrRoutes;
    #matcher;
    constructor(routes, matcher){
        this.#routes = routes;
        this.#matcher = matcher;
        this.#matcher.update(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        if (!this.#hmrRoutes) this.#matcher.update(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#matcher.update(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#hmrRoutes = void 0;
            this.#matcher.update(this.#routes);
        }
    }
};
const $27ddc9c887d48115$export$f1f19d63f0eb8dcb = /* @__PURE__ */ new WeakMap();
/**
* Create a router and listen to history POP navigations
*/ function $27ddc9c887d48115$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $bb1de4858130979b$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let future = {
        ...init.future
    };
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataRouteMatcher = $27ddc9c887d48115$export$5e64b3b9d7e2ec36(future, basename);
    let manifest = {};
    let dataRoutes = new $27ddc9c887d48115$var$DataRoutes((0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest), dataRouteMatcher);
    let dataStrategyImpl = init.dataStrategy || $27ddc9c887d48115$var$defaultDataStrategyWithMiddleware;
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = dataRouteMatcher.match(init.history.location);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $27ddc9c887d48115$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateDelta = 0;
    let pendingDiscoveryCancellation;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $27ddc9c887d48115$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            if (future.unstable_customRouteDiscovery) pendingPopstateDelta += delta || 0;
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $27ddc9c887d48115$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$27ddc9c887d48115$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        let newErrors = newState.errors ?? null;
        let cachedErrors = newErrors ? $27ddc9c887d48115$export$f1f19d63f0eb8dcb.get(newErrors) : void 0;
        if (cachedErrors !== void 0) newErrors = cachedErrors;
        if (newState.errors !== void 0 || newState.initialized) {
            if (state.errors) $27ddc9c887d48115$export$f1f19d63f0eb8dcb.delete(state.errors);
            if (newState.errors) $27ddc9c887d48115$export$f1f19d63f0eb8dcb.set(newState.errors, newErrors);
        }
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newErrors,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $27ddc9c887d48115$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $27ddc9c887d48115$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $27ddc9c887d48115$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $27ddc9c887d48115$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        resetPendingNavigation();
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    function resetPendingNavigation() {
        pendingPopstateDelta = 0;
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = fetchReloadIds.size > 0;
    }
    async function navigate(to, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $27ddc9c887d48115$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $bb1de4858130979b$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $27ddc9c887d48115$var$normalizeNavigateOptions(false, $27ddc9c887d48115$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $ee8fa670c1d03165$export$825a82322d91916e).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(typeof opts.mask === "string" ? opts.mask : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(opts.mask), (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        let currentPath = state.location.pathname + state.location.search;
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod) && (submission.formAction === currentPath || nextLocation.pathname + nextLocation.search === currentPath)) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $27ddc9c887d48115$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (pendingDiscoveryCancellation) return pendingDiscoveryCancellation.then(revalidate);
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $27ddc9c887d48115$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true,
                dataStrategyInitiator: "revalidation"
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            dataStrategyInitiator: "revalidation",
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : dataRouteMatcher.match(location);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $27ddc9c887d48115$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $27ddc9c887d48115$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $27ddc9c887d48115$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $27ddc9c887d48115$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let dataStrategyInitiator = opts?.initialHydration ? "initialization" : opts?.dataStrategyInitiator ?? "navigation";
        let scopedContext = init.getContext ? await init.getContext() : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $27ddc9c887d48115$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $27ddc9c887d48115$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, dataStrategyInitiator, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($27ddc9c887d48115$var$isErrorResult(result) && (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $27ddc9c887d48115$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, dataStrategyInitiator, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    function cancelDiscoveryNavigation() {
        let cancellation = $27ddc9c887d48115$var$createDeferred();
        pendingDiscoveryCancellation = cancellation.promise;
        let delta = pendingPopstateDelta;
        let popstateNavigationDfd = pendingPopstateNavigationDfd;
        pendingPopstateNavigationDfd = null;
        pendingNavigationController?.abort();
        pendingNavigationController = null;
        resetPendingNavigation();
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
        let blockers = new Map(state.blockers);
        blockers.forEach((blocker, key)=>{
            if (blocker.state === "proceeding") blockers.set(key, $27ddc9c887d48115$export$386d57f03f0b2883);
        });
        let fetchers = new Map(state.fetchers);
        let didUpdateFetchers = markFetchRedirectsDone(fetchers);
        fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "loading" && !fetchControllers.has(key)) {
                fetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(fetcher.data));
                didUpdateFetchers = true;
            }
        });
        cancelledFetcherLoads.clear();
        updateState({
            navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            blockers: blockers,
            ...didUpdateFetchers ? {
                fetchers: fetchers
            } : {}
        });
        function finishCancellation() {
            pendingDiscoveryCancellation = void 0;
            popstateNavigationDfd?.resolve();
            cancellation.resolve();
        }
        if (delta) {
            unblockBlockerHistoryUpdate = finishCancellation;
            init.history.go(-delta);
        } else finishCancellation();
        return cancellation.promise;
    }
    async function handleAction(request, dataStrategyInitiator, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        if (!future.unstable_customRouteDiscovery) interruptActiveLoads();
        updateState({
            navigation: $27ddc9c887d48115$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (future.unstable_customRouteDiscovery && request.signal.aborted || discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "cancelled") {
                await cancelDiscoveryNavigation();
                return {
                    shortCircuited: true
                };
            } else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $27ddc9c887d48115$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        if (future.unstable_customRouteDiscovery) interruptActiveLoads();
        let result;
        let actionMatch = $27ddc9c887d48115$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null, dataStrategyInitiator, historyAction);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $27ddc9c887d48115$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, dataStrategyInitiator, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, dataStrategyInitiator, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $27ddc9c887d48115$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (future.unstable_customRouteDiscovery && request.signal.aborted || discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "cancelled") {
                await cancelDiscoveryNavigation();
                return {
                    shortCircuited: true
                };
            } else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $27ddc9c887d48115$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else {
                matches = discoverResult.matches;
                if (initialHydration && !request.signal.aborted) updateState({
                    matches: matches
                });
            }
        }
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $27ddc9c887d48115$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>{
                if (fetchControllers.get(rf.key) === rf.controller) abortFetcher(rf.key);
            });
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext, dataStrategyInitiator, historyAction);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.get(rf.key) === rf.controller) fetchControllers.delete(rf.key);
        });
        let redirect = $27ddc9c887d48115$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, dataStrategyInitiator, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $27ddc9c887d48115$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, dataStrategyInitiator, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) {
            let newClientErrors = errors ?? null;
            errors = {
                ...state.errors,
                ...errors
            };
            $27ddc9c887d48115$export$f1f19d63f0eb8dcb.set(errors, newClientErrors);
        }
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$27ddc9c887d48115$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $27ddc9c887d48115$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        if (pendingDiscoveryCancellation) await pendingDiscoveryCancellation;
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $bb1de4858130979b$export$5579798e35f5560e)(router);
        let normalizedPath = $27ddc9c887d48115$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = dataRouteMatcher.match(normalizedPath);
        let fogOfWar = checkFogOfWar(matches, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($27ddc9c887d48115$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $27ddc9c887d48115$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        let loadMatch = {
            routeId: routeId,
            path: path,
            isDiscovering: fogOfWar.active
        };
        fetchLoadMatches.set(key, loadMatch);
        await handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        if (!future.unstable_customRouteDiscovery) interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        if (future.unstable_customRouteDiscovery) fetchControllers.set(key, abortController);
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (future.unstable_customRouteDiscovery && fetchRequest.signal.aborted || discoverResult.type === "aborted") return;
            else if (discoverResult.type === "cancelled") {
                fetchControllers.delete(key);
                fetchLoadMatches.delete(key);
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(existingFetcher?.data), {
                    flushSync: flushSync
                });
                return;
            } else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $27ddc9c887d48115$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        if (future.unstable_customRouteDiscovery) interruptActiveLoads();
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key, "fetcher");
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($27ddc9c887d48115$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                return;
            }
            if ($27ddc9c887d48115$var$isRedirectResult(actionResult)) {
                isRevalidationRequired = true;
                actionResult = {
                    type: "data",
                    data: void 0
                };
            }
        } else {
            if ($27ddc9c887d48115$var$isRedirectResult(actionResult)) {
                if (pendingNavigationLoadId > originatingLoadId) {
                    isRevalidationRequired = true;
                    actionResult = {
                        type: "data",
                        data: void 0
                    };
                } else {
                    fetchControllers.delete(key);
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $27ddc9c887d48115$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, "fetcher", {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($27ddc9c887d48115$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        isRevalidationRequired = true;
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? dataRouteMatcher.match(state.navigation.location) : state.matches;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $27ddc9c887d48115$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $27ddc9c887d48115$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $27ddc9c887d48115$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>{
                if (fetchControllers.get(rf.key) === rf.controller) abortFetcher(rf.key);
            });
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext, "fetcher");
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>{
            if (fetchControllers.get(r.key) === r.controller) fetchControllers.delete(r.key);
        });
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $27ddc9c887d48115$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, "fetcher", {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $27ddc9c887d48115$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, "fetcher", {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            markFetchRedirectsDone(finalFetchers);
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $27ddc9c887d48115$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = fetchReloadIds.size > 0;
        }
    }
    async function handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission) {
        let { routeId: routeId, path: path } = loadMatch;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        if (future.unstable_customRouteDiscovery) fetchControllers.set(key, abortController);
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, path, abortController.signal);
        if (loadMatch.isDiscovering) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (future.unstable_customRouteDiscovery && fetchRequest.signal.aborted || discoverResult.type === "aborted") return;
            else if (discoverResult.type === "cancelled") {
                fetchControllers.delete(key);
                fetchLoadMatches.delete(key);
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(existingFetcher?.data), {
                    flushSync: flushSync
                });
                return;
            } else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                loadMatch.isDiscovering = false;
            }
        }
        let match = $27ddc9c887d48115$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key, "fetcher");
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
            return;
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, "fetcher", {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, dataStrategyInitiator, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $27ddc9c887d48115$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $2ce80a7c58bedbaf$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $27ddc9c887d48115$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($27ddc9c887d48115$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $27ddc9c887d48115$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0,
            dataStrategyInitiator: dataStrategyInitiator
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $27ddc9c887d48115$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0,
            dataStrategyInitiator: dataStrategyInitiator
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey, initiator, navigationType = null) {
        let results;
        let dataResults = {};
        try {
            results = await $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, initiator, scopedContext, false, navigationType);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$27ddc9c887d48115$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($27ddc9c887d48115$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext, initiator, navigationType = null) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null, initiator, navigationType);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key, initiator, navigationType))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $27ddc9c887d48115$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((loadMatch, key)=>{
            if (future.unstable_customRouteDiscovery && loadMatch.isDiscovering) return;
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $27ddc9c887d48115$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        fetchLoadMatches.delete(key);
        cancelledFetcherLoads.delete(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $27ddc9c887d48115$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $27ddc9c887d48115$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $27ddc9c887d48115$export$386d57f03f0b2883;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $27ddc9c887d48115$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $edf931d6dcac43ec$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                if (future.unstable_customRouteDiscovery) {
                    if (signal.aborted) return {
                        type: "aborted"
                    };
                    if (e instanceof (0, $edf931d6dcac43ec$export$96cecaff35fb119d)) return {
                        type: "cancelled"
                    };
                }
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = dataRouteMatcher.match(pathname);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = dataRouteMatcher.match(pathname, true);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = dataRouteMatcher.match(pathname, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        match (locationArg) {
            return dataRouteMatcher.match(locationArg);
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $bb1de4858130979b$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $27ddc9c887d48115$export$3336b097a6fbc59a(routes, opts) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    let dataRouteMatcher = $27ddc9c887d48115$export$5e64b3b9d7e2ec36({
        ...opts?.future
    }, basename);
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $bb1de4858130979b$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    dataRouteMatcher.update(dataRoutes);
    let match = (locationArg)=>dataRouteMatcher.match(locationArg);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $27ddc9c887d48115$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        if (!$27ddc9c887d48115$var$isValidMethod(method) && method !== "HEAD") {
            let error = $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(requestContext instanceof (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $27ddc9c887d48115$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result,
                            _match: match
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($27ddc9c887d48115$export$6e80290866a84dd4(error)) return error;
                    if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(error.status, error.statusText, await $27ddc9c887d48115$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(error)) error = $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $27ddc9c887d48115$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $27ddc9c887d48115$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $27ddc9c887d48115$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {},
                            _match: match
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($27ddc9c887d48115$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result,
            _match: match
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $27ddc9c887d48115$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        if (!$27ddc9c887d48115$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $27ddc9c887d48115$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $27ddc9c887d48115$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $27ddc9c887d48115$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(requestContext instanceof (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $27ddc9c887d48115$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($27ddc9c887d48115$var$dataWithResponseInitToResponse(error));
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($27ddc9c887d48115$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $27ddc9c887d48115$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($27ddc9c887d48115$var$isDataStrategyResult(e) && $27ddc9c887d48115$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($27ddc9c887d48115$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($27ddc9c887d48115$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($27ddc9c887d48115$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($27ddc9c887d48115$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $27ddc9c887d48115$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $edf931d6dcac43ec$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategy || $27ddc9c887d48115$var$defaultDataStrategy, request, location, matches, null, "static", requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($27ddc9c887d48115$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result.result)) throw $27ddc9c887d48115$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        get _matchCost () {
            return dataRouteMatcher instanceof (0, $6069f2a71d2ba88b$export$92541312f2982378) ? dataRouteMatcher.matchCost : void 0;
        },
        match: match,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $27ddc9c887d48115$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $27ddc9c887d48115$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $27ddc9c887d48115$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $27ddc9c887d48115$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to ? to : ".", (0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(contextualMatches), (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $27ddc9c887d48115$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $edf931d6dcac43ec$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
}
function $27ddc9c887d48115$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$27ddc9c887d48115$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$27ddc9c887d48115$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $27ddc9c887d48115$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $27ddc9c887d48115$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $27ddc9c887d48115$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$27ddc9c887d48115$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$27ddc9c887d48115$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $27ddc9c887d48115$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $27ddc9c887d48115$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $27ddc9c887d48115$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $27ddc9c887d48115$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $edf931d6dcac43ec$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $27ddc9c887d48115$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($27ddc9c887d48115$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($27ddc9c887d48115$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $27ddc9c887d48115$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key) || f.isDiscovering) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = dataRouteMatcher.match(f.path);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $27ddc9c887d48115$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($27ddc9c887d48115$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $27ddc9c887d48115$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $27ddc9c887d48115$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $27ddc9c887d48115$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $27ddc9c887d48115$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$27ddc9c887d48115$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $27ddc9c887d48115$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$27ddc9c887d48115$var$isSameRoute(aChild, bChild))) ?? false;
}
const $27ddc9c887d48115$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $27ddc9c887d48115$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $27ddc9c887d48115$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $27ddc9c887d48115$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $edf931d6dcac43ec$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    propertyPromise.catch(()=>{
        if (cache[key] === propertyPromise) delete cache[key];
    });
    return propertyPromise;
};
const $27ddc9c887d48115$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $27ddc9c887d48115$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $27ddc9c887d48115$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $edf931d6dcac43ec$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $27ddc9c887d48115$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{
            if ($27ddc9c887d48115$var$lazyRouteFunctionCache.get(routeToUpdate) === lazyRoutePromise) $27ddc9c887d48115$var$lazyRouteFunctionCache.delete(routeToUpdate);
        });
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $27ddc9c887d48115$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $27ddc9c887d48115$var$isNonNullable(value) {
    return value !== void 0;
}
function $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $27ddc9c887d48115$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($27ddc9c887d48115$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $27ddc9c887d48115$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $27ddc9c887d48115$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $27ddc9c887d48115$var$defaultDataStrategy(args);
    return $27ddc9c887d48115$var$runClientMiddlewarePipeline(args, ()=>$27ddc9c887d48115$var$defaultDataStrategy(args));
}
function $27ddc9c887d48115$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, processResult, $27ddc9c887d48115$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $27ddc9c887d48115$export$e0163cfdf7bc9cfa(result) ? $27ddc9c887d48115$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $27ddc9c887d48115$var$runClientMiddlewarePipeline(args, handler) {
    return $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($27ddc9c887d48115$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $27ddc9c887d48115$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$27ddc9c887d48115$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $27ddc9c887d48115$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $27ddc9c887d48115$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $27ddc9c887d48115$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $27ddc9c887d48115$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $27ddc9c887d48115$var$loadLazyRoute(match.route, $27ddc9c887d48115$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $27ddc9c887d48115$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $27ddc9c887d48115$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $27ddc9c887d48115$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$27ddc9c887d48115$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($27ddc9c887d48115$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $27ddc9c887d48115$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $edf931d6dcac43ec$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, initiator, scopedContext, isStaticHandler, navigationType = null) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches,
        unstable_initiator: initiator,
        unstable_navigationType: initiator === "navigation" ? navigationType : null
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $27ddc9c887d48115$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $27ddc9c887d48115$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $27ddc9c887d48115$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $27ddc9c887d48115$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else {
                    await lazyRoutePromise;
                    return {
                        type: "data",
                        result: void 0
                    };
                }
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $27ddc9c887d48115$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $27ddc9c887d48115$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $27ddc9c887d48115$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $27ddc9c887d48115$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $27ddc9c887d48115$export$961a3ef7a4da3a39(location) {
    try {
        return $27ddc9c887d48115$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $27ddc9c887d48115$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $ee8fa670c1d03165$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $ee8fa670c1d03165$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($27ddc9c887d48115$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $edf931d6dcac43ec$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($27ddc9c887d48115$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $27ddc9c887d48115$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($27ddc9c887d48115$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $27ddc9c887d48115$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $27ddc9c887d48115$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!$27ddc9c887d48115$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $27ddc9c887d48115$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $27ddc9c887d48115$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, routeId: routeId, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(state.matches, routeId);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($27ddc9c887d48115$var$isRedirectResult(result)) (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $27ddc9c887d48115$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $27ddc9c887d48115$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $27ddc9c887d48115$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    let preservedCount = 0;
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) {
            mergedLoaderData[id] = loaderData[id];
            preservedCount++;
        }
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return Object.keys(newLoaderData).length === 0 && preservedCount === Object.keys(loaderData).length ? loaderData : mergedLoaderData;
}
function $27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $27ddc9c887d48115$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $27ddc9c887d48115$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $27ddc9c887d48115$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $27ddc9c887d48115$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($27ddc9c887d48115$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $27ddc9c887d48115$var$stripHashFromPath(path) {
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $27ddc9c887d48115$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $27ddc9c887d48115$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $27ddc9c887d48115$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $27ddc9c887d48115$var$isDataStrategyResult(value));
}
function $27ddc9c887d48115$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $27ddc9c887d48115$var$isRedirectDataStrategyResult(result) {
    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result.result) && $27ddc9c887d48115$var$redirectStatusCodes.has(result.result.status);
}
function $27ddc9c887d48115$var$isErrorResult(result) {
    return result.type === "error";
}
function $27ddc9c887d48115$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $27ddc9c887d48115$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $27ddc9c887d48115$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $27ddc9c887d48115$export$794b2760043cf8cd(statusCode) {
    return $27ddc9c887d48115$var$redirectStatusCodes.has(statusCode);
}
function $27ddc9c887d48115$export$6e80290866a84dd4(result) {
    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result) && $27ddc9c887d48115$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $27ddc9c887d48115$var$isValidMethod(method) {
    return $27ddc9c887d48115$var$validRequestMethods.has(method.toUpperCase());
}
function $27ddc9c887d48115$export$cbae47800eb95bc3(method) {
    return $27ddc9c887d48115$var$validMutationMethods.has(method.toUpperCase());
}
function $27ddc9c887d48115$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $27ddc9c887d48115$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $27ddc9c887d48115$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $edf931d6dcac43ec$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $27ddc9c887d48115$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $edf931d6dcac43ec$export$d738435097971c09)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $27ddc9c887d48115$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $27ddc9c887d48115$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $27ddc9c887d48115$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $27ddc9c887d48115$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $27ddc9c887d48115$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $27ddc9c887d48115$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $27ddc9c887d48115$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $27ddc9c887d48115$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
//#region lib/context.ts
const $52882ad28a21bc0a$export$2eeee58951ff3c1c = $acw62.createContext(null);
$52882ad28a21bc0a$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $52882ad28a21bc0a$export$315e3ffb01f217 = $acw62.createContext(null);
$52882ad28a21bc0a$export$315e3ffb01f217.displayName = "DataRouterState";
const $52882ad28a21bc0a$export$19d7395466bdeac8 = $acw62.createContext(null);
$52882ad28a21bc0a$export$19d7395466bdeac8.displayName = "DataRouterData";
const $52882ad28a21bc0a$export$2473c5952c6a10d1 = $acw62.createContext(null);
$52882ad28a21bc0a$export$2473c5952c6a10d1.displayName = "DataRouterNavigation";
const $52882ad28a21bc0a$export$717f757c655223f1 = $acw62.createContext(false);
function $52882ad28a21bc0a$export$6e1eeb090b3ec35b() {
    return $acw62.useContext($52882ad28a21bc0a$export$717f757c655223f1);
}
const $52882ad28a21bc0a$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$52882ad28a21bc0a$export$3681f408decb40d1.displayName = "ViewTransition";
const $52882ad28a21bc0a$export$cb3f1df1bef00a39 = $acw62.createContext(null);
$52882ad28a21bc0a$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $52882ad28a21bc0a$export$804c460aade54ac8 = $acw62.createContext(null);
$52882ad28a21bc0a$export$804c460aade54ac8.displayName = "Await";
const $52882ad28a21bc0a$export$2666c20e15407622 = (props)=>$acw62.createElement($52882ad28a21bc0a$export$804c460aade54ac8.Provider, props);
const $52882ad28a21bc0a$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$52882ad28a21bc0a$export$3044ab7fdabeaee6.displayName = "Navigation";
const $52882ad28a21bc0a$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$52882ad28a21bc0a$export$e6a44b110a0c44d3.displayName = "Location";
const $52882ad28a21bc0a$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$52882ad28a21bc0a$export$aac280ed165a4397.displayName = "Route";
const $52882ad28a21bc0a$export$efd71bfc7ccfba1 = $acw62.createContext(false);
$52882ad28a21bc0a$export$efd71bfc7ccfba1.displayName = "IsDataRoute";
const $52882ad28a21bc0a$export$92d0be8f6ef5c7bf = $acw62.createContext(void 0);
$52882ad28a21bc0a$export$92d0be8f6ef5c7bf.displayName = "RouteId";
const $52882ad28a21bc0a$export$af8bd2647fea9c11 = $acw62.createContext(null);
$52882ad28a21bc0a$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $b9584a574d863128$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $b9584a574d863128$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $b9584a574d863128$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $b9584a574d863128$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$b9584a574d863128$var$ERROR_DIGEST_BASE}:${$b9584a574d863128$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $b9584a574d863128$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$b9584a574d863128$var$ERROR_DIGEST_BASE}:${$b9584a574d863128$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $acw62 = parcelRequire("acw62");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $baf2581b6f4e4c0a$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $baf2581b6f4e4c0a$export$9c954a9d03d32f4a() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $baf2581b6f4e4c0a$export$45d76561a5302f2b() {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $baf2581b6f4e4c0a$export$1b3f31771c5d07c() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $baf2581b6f4e4c0a$export$6c330e8992e8a295(pattern) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$81336c211d5ff295)(pattern, (0, $edf931d6dcac43ec$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $baf2581b6f4e4c0a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: **Deprecated.** Use React's [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component instead. See the [migration guide](../../how-to/view-transitions).
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $baf2581b6f4e4c0a$export$9770f232ac06a008() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$efd71bfc7ccfba1)) ? $baf2581b6f4e4c0a$var$useNavigateStable() : $baf2581b6f4e4c0a$var$useNavigateUnstable();
}
function $baf2581b6f4e4c0a$var$useNavigateUnstable() {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $acw62.useRef(false);
    $acw62.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $acw62.useCallback((to, options = {})=>{
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(activeRef.current, $baf2581b6f4e4c0a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $7ab28948be9dda45$export$1da545bc000055cf)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $baf2581b6f4e4c0a$var$OutletContext = $acw62.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $baf2581b6f4e4c0a$export$4138103a3ae699cc() {
    return $acw62.useContext($baf2581b6f4e4c0a$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $baf2581b6f4e4c0a$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397)).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches));
    return $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $baf2581b6f4e4c0a$export$5d3fca4a98652595(routes, locationArg) {
    return $baf2581b6f4e4c0a$export$f7ce0646a48561fb(routes, locationArg);
}
function $baf2581b6f4e4c0a$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches;
    if (dataRouterOpts) {
        if (dataRouterOpts.state.matches.length) matches = dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
                route: dataRouterOpts.manifest[m.route.id] || m.route
            }));
        else matches = dataRouterOpts.router.match(dataRouterOpts.state.location);
    } else matches = (0, $edf931d6dcac43ec$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $baf2581b6f4e4c0a$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $baf2581b6f4e4c0a$var$DefaultErrorComponent() {
    let error = $baf2581b6f4e4c0a$export$ed527bf60f6e05f2();
    let message = (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $baf2581b6f4e4c0a$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$DefaultErrorComponent, null);
var $baf2581b6f4e4c0a$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $52882ad28a21bc0a$export$717f757c655223f1);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $b9584a574d863128$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$efd71bfc7ccfba1).Provider, {
            value: this.props.routeContext.isDataRoute
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$92d0be8f6ef5c7bf).Provider, {
            value: this.props.routeContext.matches[this.props.routeContext.matches.length - 1]?.route.id
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })))) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $baf2581b6f4e4c0a$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $baf2581b6f4e4c0a$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $b9584a574d863128$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $baf2581b6f4e4c0a$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $edf931d6dcac43ec$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(redirect.location, target, (0, $7ab28948be9dda45$export$1da545bc000055cf)(navigator), "allow-explicit");
            if ((0, $27ddc9c887d48115$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $edf931d6dcac43ec$export$4e09c449d6c407f7) && !$baf2581b6f4e4c0a$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $baf2581b6f4e4c0a$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $baf2581b6f4e4c0a$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$efd71bfc7ccfba1).Provider, {
        value: routeContext.isDataRoute
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$92d0be8f6ef5c7bf).Provider, {
        value: match.route.id
    }, children)));
}
function $baf2581b6f4e4c0a$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $baf2581b6f4e4c0a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $baf2581b6f4e4c0a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $baf2581b6f4e4c0a$export$ae09415e57d46628(hookName) {
    let ctx = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(ctx, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $baf2581b6f4e4c0a$export$f93124018767f269(hookName) {
    let state = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return state;
}
function $baf2581b6f4e4c0a$export$c6e4e4d7047d4ffe(hookName) {
    let fetchers = $acw62.useContext((0, $52882ad28a21bc0a$export$cb3f1df1bef00a39));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetchers, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return fetchers;
}
function $baf2581b6f4e4c0a$export$798168c290ba5b3d(hookName) {
    let data = $acw62.useContext((0, $52882ad28a21bc0a$export$19d7395466bdeac8));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(data, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return data;
}
function $baf2581b6f4e4c0a$var$useDataRouterNavigation(hookName) {
    let navigation = $acw62.useContext((0, $52882ad28a21bc0a$export$2473c5952c6a10d1));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(navigation, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return navigation;
}
function $baf2581b6f4e4c0a$export$501a3f562d56eac6(hookName) {
    let routeId = $acw62.useContext((0, $52882ad28a21bc0a$export$92d0be8f6ef5c7bf));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeId, `${hookName} can only be used on routes that contain a unique "id"`);
    return routeId;
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $baf2581b6f4e4c0a$export$d0fd4b7106de2769() {
    let { navigation: navigation } = $baf2581b6f4e4c0a$var$useDataRouterNavigation("useNavigation");
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = navigation;
        return rest;
    }, [
        navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $baf2581b6f4e4c0a$export$600dc272ed516c15() {
    let dataRouterContext = $baf2581b6f4e4c0a$export$ae09415e57d46628("useRevalidator");
    let { revalidation: revalidation } = $baf2581b6f4e4c0a$var$useDataRouterNavigation("useRevalidator");
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: revalidation
        }), [
        revalidate,
        revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $baf2581b6f4e4c0a$export$2378eb7f5ff86053() {
    let { matches: matches } = $baf2581b6f4e4c0a$export$f93124018767f269("useMatches");
    let { loaderData: loaderData } = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useMatches");
    return $acw62.useMemo(()=>matches.map((m)=>(0, $edf931d6dcac43ec$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $baf2581b6f4e4c0a$export$1448a5050d252c4d() {
    let data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useLoaderData");
    let routeId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useLoaderData");
    return data.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $baf2581b6f4e4c0a$export$fd5d37484eab868d(routeId) {
    return $baf2581b6f4e4c0a$export$798168c290ba5b3d("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $baf2581b6f4e4c0a$export$fdc00f3f26066d5e() {
    let data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useActionData");
    let routeId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useActionData");
    return data.actionData ? data.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $baf2581b6f4e4c0a$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext((0, $52882ad28a21bc0a$export$af8bd2647fea9c11));
    let data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useRouteError");
    let routeId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useRouteError");
    if (error !== void 0) return error;
    return data.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $baf2581b6f4e4c0a$export$78a72ddb39bdd145() {
    let value = $acw62.useContext((0, $52882ad28a21bc0a$export$804c460aade54ac8));
    return value && "status" in value && !("_tracked" in value) ? value.status === "fulfilled" ? value.value : void 0 : value?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $baf2581b6f4e4c0a$export$17f53340677d5831() {
    let value = $acw62.useContext((0, $52882ad28a21bc0a$export$804c460aade54ac8));
    return value && "status" in value && !("_tracked" in value) ? value.status === "rejected" ? value.reason : void 0 : value?._error;
}
let $baf2581b6f4e4c0a$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $baf2581b6f4e4c0a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $baf2581b6f4e4c0a$export$ae09415e57d46628("useBlocker");
    let state = $baf2581b6f4e4c0a$export$f93124018767f269("useBlocker");
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$baf2581b6f4e4c0a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $27ddc9c887d48115$export$386d57f03f0b2883);
}
function $baf2581b6f4e4c0a$var$useNavigateStable() {
    let { router: router } = $baf2581b6f4e4c0a$export$ae09415e57d46628("useNavigate");
    let id = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useNavigate");
    let activeRef = $acw62.useRef(false);
    $acw62.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $acw62.useCallback(async (to, options = {})=>{
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(activeRef.current, $baf2581b6f4e4c0a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $baf2581b6f4e4c0a$var$alreadyWarned = {};
function $baf2581b6f4e4c0a$var$warningOnce(key, cond, message) {
    if (!cond && !$baf2581b6f4e4c0a$var$alreadyWarned[key]) {
        $baf2581b6f4e4c0a$var$alreadyWarned[key] = true;
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, message);
    }
}
function $baf2581b6f4e4c0a$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $baf2581b6f4e4c0a$export$f93124018767f269("useRoute");
    const data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: data.loaderData[id],
        actionData: data.actionData?.[id]
    };
}
function $baf2581b6f4e4c0a$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $baf2581b6f4e4c0a$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches } = $baf2581b6f4e4c0a$export$f93124018767f269("unstable_useRouterState");
    let { navigation: navigation } = $baf2581b6f4e4c0a$var$useDataRouterNavigation("unstable_useRouterState");
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$baf2581b6f4e4c0a$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$baf2581b6f4e4c0a$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $c6f8fc82db0f6244$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $c6f8fc82db0f6244$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $c6f8fc82db0f6244$export$4cf11838cdc2a8a8(html) {
    return html.replace($c6f8fc82db0f6244$var$ESCAPE_REGEX, (match)=>$c6f8fc82db0f6244$var$ESCAPE_LOOKUP[match]);
}
function $c6f8fc82db0f6244$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $f6e8c7ac4ab8992c$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $b7db53197255e154$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $b7db53197255e154$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $b7db53197255e154$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $bb47af95f14cb967$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $bb47af95f14cb967$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $bb47af95f14cb967$export$442b9e023f41af00(matches, manifest));
}
function $bb47af95f14cb967$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $bb47af95f14cb967$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $bb47af95f14cb967$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($bb47af95f14cb967$var$prefetchStyleLink));
}
async function $bb47af95f14cb967$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$bb47af95f14cb967$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$bb47af95f14cb967$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$bb47af95f14cb967$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($bb47af95f14cb967$var$prefetchStyleLink));
}
async function $bb47af95f14cb967$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $bb47af95f14cb967$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $bb47af95f14cb967$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $bb47af95f14cb967$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $bb47af95f14cb967$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $b7db53197255e154$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($bb47af95f14cb967$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $bb47af95f14cb967$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $bb47af95f14cb967$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $bb47af95f14cb967$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $bb47af95f14cb967$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $bb47af95f14cb967$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $bb47af95f14cb967$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$bb47af95f14cb967$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($bb47af95f14cb967$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $bb47af95f14cb967$var$_isPreloadSupported;
function $bb47af95f14cb967$var$isPreloadSupported() {
    if ($bb47af95f14cb967$var$_isPreloadSupported !== void 0) return $bb47af95f14cb967$var$_isPreloadSupported;
    let el = document.createElement("link");
    $bb47af95f14cb967$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $bb47af95f14cb967$var$_isPreloadSupported;
}



/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $bb1d86855daf76fc$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $bb1d86855daf76fc$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $fe0f2fac6e7ce220$var$TIME_LIMIT_MS = 1;
const $fe0f2fac6e7ce220$var$getNow = ()=>Date.now();
const $fe0f2fac6e7ce220$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $fe0f2fac6e7ce220$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $fe0f2fac6e7ce220$var$stringify.call(this, stack);
    return index;
}
async function $fe0f2fac6e7ce220$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $fe0f2fac6e7ce220$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $fe0f2fac6e7ce220$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $fe0f2fac6e7ce220$var$TIME_LIMIT_MS) {
            await $fe0f2fac6e7ce220$var$yieldToMain();
            lastYieldTime = $fe0f2fac6e7ce220$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($fe0f2fac6e7ce220$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $fe0f2fac6e7ce220$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fe0f2fac6e7ce220$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fe0f2fac6e7ce220$var$objectProtoNames;
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $f0a2a611d7bf4aef$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $f0a2a611d7bf4aef$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $f0a2a611d7bf4aef$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $f0a2a611d7bf4aef$var$hydrate.call(this, startIndex);
}
function $f0a2a611d7bf4aef$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        $f0a2a611d7bf4aef$var$validateIndex(index, values.length);
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        $f0a2a611d7bf4aef$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $bb1d86855daf76fc$export$85f6557964517f1a)();
                            const promise = d.promise;
                            promise.status = "pending";
                            promise.then((value)=>{
                                promise.status = "fulfilled";
                                promise.value = value;
                            }, (reason)=>{
                                promise.status = "rejected";
                                promise.reason = reason;
                            });
                            deferred[b] = d;
                            set(hydrated[index] = promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $f0a2a611d7bf4aef$var$globalObj && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(errorType) && errorType in $f0a2a611d7bf4aef$var$globalObj && typeof $f0a2a611d7bf4aef$var$globalObj[errorType] === "function" ? new $f0a2a611d7bf4aef$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        $f0a2a611d7bf4aef$var$validateIndex(b, values.length);
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $f0a2a611d7bf4aef$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $7dbb8f88df69b2a1$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $bb1d86855daf76fc$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $bb1d86855daf76fc$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $7dbb8f88df69b2a1$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $7dbb8f88df69b2a1$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $7dbb8f88df69b2a1$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, line)
    };
}
async function $7dbb8f88df69b2a1$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $7dbb8f88df69b2a1$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $0f7c5b1be99998e3$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/single-fetch.tsx
const $45db1c6124c1e415$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $45db1c6124c1e415$var$SingleFetchNoResultError = class extends Error {
};
const $45db1c6124c1e415$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $45db1c6124c1e415$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($45db1c6124c1e415$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $45db1c6124c1e415$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, fetchImplementation = (request)=>fetch(request), isApiOnly = false, serverOrigin, isSpaMode = false) {
    let dataStrategy = $45db1c6124c1e415$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $45db1c6124c1e415$var$fetchAndDecodeViaTurboStream(fetchImplementation, serverOrigin), ssr, void 0, isApiOnly, isSpaMode);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $45db1c6124c1e415$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true, isApiOnly = false, isSpaMode = false) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $45db1c6124c1e415$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $45db1c6124c1e415$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $45db1c6124c1e415$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $45db1c6124c1e415$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut, isApiOnly, isSpaMode);
    };
}
async function $45db1c6124c1e415$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $27ddc9c887d48115$export$3f1eb41d9a6a6a27)(result.result) || (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.result) || (0, $27ddc9c887d48115$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $edf931d6dcac43ec$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $45db1c6124c1e415$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map(async (m)=>{
        let routeId = m.route.id;
        results[routeId] = await m.resolve(async (handler)=>{
            let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return hasClientLoader ? handler(async ()=>{
                let { data: data } = await fetchAndDecode(args, [
                    routeId
                ]);
                return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
            }) : handler();
        });
    }));
    return results;
}
async function $45db1c6124c1e415$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true, isApiOnly = false, isSpaMode = false) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$45db1c6124c1e415$var$createDeferred());
    let singleFetchDfd = $45db1c6124c1e415$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $45db1c6124c1e415$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" && !isApiOnly && !isSpaMode || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $45db1c6124c1e415$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $45db1c6124c1e415$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $45db1c6124c1e415$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $45db1c6124c1e415$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $45db1c6124c1e415$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $45db1c6124c1e415$export$7b977381851b2c(reqUrl, extension, serverOrigin) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, serverOrigin ?? (typeof window === "undefined" ? "server://singlefetch/" : window.location.origin)) : new URL(reqUrl);
    if (serverOrigin && url.origin !== serverOrigin) url = new URL(url.pathname + url.search + url.hash, serverOrigin);
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
function $45db1c6124c1e415$var$fetchAndDecodeViaTurboStream(fetchImplementation, serverOrigin) {
    return async (args, targetRoutes)=>{
        let { request: request } = args;
        let url = $45db1c6124c1e415$export$7b977381851b2c(request.url, "data", serverOrigin);
        if (request.method === "GET") {
            url = $45db1c6124c1e415$export$425969b7f98e2c9c(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let req = new Request(url, await (0, $0f7c5b1be99998e3$export$a30aa2a0fce6c468)(request));
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(args.unstable_initiator !== "static", "Static data strategy initiator used for a client data request");
        let fetchContext;
        if (args.unstable_initiator === "navigation") {
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(args.unstable_navigationType !== null, "Missing navigation type for a navigation data request");
            fetchContext = {
                type: "navigation",
                fetcherKey: args.fetcherKey,
                navigationType: args.unstable_navigationType
            };
        } else fetchContext = {
            type: args.unstable_initiator,
            fetcherKey: args.fetcherKey,
            navigationType: null
        };
        let res = await fetchImplementation(req, fetchContext);
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
        if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
            status: 202,
            data: {
                redirect: {
                    redirect: res.headers.get("X-Remix-Redirect"),
                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                    replace: res.headers.get("X-Remix-Replace") === "true"
                }
            }
        };
        if ($45db1c6124c1e415$export$e35ccdcde387134d.has(res.status)) {
            let routes = {};
            if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                data: void 0
            };
            return {
                status: res.status,
                data: {
                    routes: routes
                }
            };
        }
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(res.body, "No response body to decode");
        try {
            let decoded = await $45db1c6124c1e415$export$4023ad4ecd4126a2(res.body, window);
            let data;
            if (request.method === "GET") {
                let typed = decoded.value;
                if ($45db1c6124c1e415$export$60644022b8b46aaa in typed) data = {
                    redirect: typed[$45db1c6124c1e415$export$60644022b8b46aaa]
                };
                else data = {
                    routes: typed
                };
            } else {
                let typed = decoded.value;
                let routeId = targetRoutes?.[0];
                (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
                if ("redirect" in typed) data = {
                    redirect: typed
                };
                else data = {
                    routes: {
                        [routeId]: typed
                    }
                };
            }
            return {
                status: res.status,
                data: data
            };
        } catch (cause) {
            throw new Error("Unable to decode turbo-stream response", {
                cause: cause
            });
        }
    };
}
function $45db1c6124c1e415$export$4023ad4ecd4126a2(body, global) {
    return (0, $7dbb8f88df69b2a1$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$45db1c6124c1e415$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $45db1c6124c1e415$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $edf931d6dcac43ec$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $45db1c6124c1e415$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $45db1c6124c1e415$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $9cdee517b2ac63e9$var$alreadyWarned = {};
function $9cdee517b2ac63e9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$9cdee517b2ac63e9$var$alreadyWarned[message]) {
        $9cdee517b2ac63e9$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/errorBoundaries.tsx
var $75aa75cf49dc6413$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $75aa75cf49dc6413$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $edf931d6dcac43ec$export$972111febbeef05b)(error)) return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $75aa75cf49dc6413$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement((0, $baf242efa2d54ba7$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/fallback.tsx
function $a7f36f18f4887f62$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $acw62.createElement((0, $75aa75cf49dc6413$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/routes.tsx
function $aa520e004fa2ab60$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $a7f36f18f4887f62$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement((0, $75aa75cf49dc6413$export$20b33acd14692c9), {
            error: (0, $baf2581b6f4e4c0a$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $aa520e004fa2ab60$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $aa520e004fa2ab60$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $aa520e004fa2ab60$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $aa520e004fa2ab60$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $aa520e004fa2ab60$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), needsRevalidation, isApiOnly = false) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $bb47af95f14cb967$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $aa520e004fa2ab60$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $aa520e004fa2ab60$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode, isApiOnly);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode && !isApiOnly) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode && !isApiOnly) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $aa520e004fa2ab60$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $aa520e004fa2ab60$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation, isApiOnly);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $aa520e004fa2ab60$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $aa520e004fa2ab60$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $edf931d6dcac43ec$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $aa520e004fa2ab60$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $aa520e004fa2ab60$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $b7db53197255e154$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $bb47af95f14cb967$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $bb47af95f14cb967$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $aa520e004fa2ab60$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode, isApiOnly = false) {
    return isSpaMode && routeId !== "root" || isApiOnly && isSpaMode && hasLoader || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/fog-of-war.ts
const $a41fcd44fe4543d6$var$nextPaths = /* @__PURE__ */ new Set();
const $a41fcd44fe4543d6$var$discoveredPathsMaxSize = 1e3;
const $a41fcd44fe4543d6$var$discoveredPaths = /* @__PURE__ */ new Set();
const $a41fcd44fe4543d6$export$b5915cf27fa06b9f = 7680;
function $a41fcd44fe4543d6$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr;
}
const $a41fcd44fe4543d6$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
const $a41fcd44fe4543d6$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $a41fcd44fe4543d6$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    return Math.max(segmentCount - 1, 0) * pathname.length + 1 > 7680 || segmentCount > $a41fcd44fe4543d6$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $a41fcd44fe4543d6$var$MANIFEST_MATCH_COST_LIMIT;
}
function $a41fcd44fe4543d6$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = router.match(path);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $a41fcd44fe4543d6$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    if (!$a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($a41fcd44fe4543d6$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal, fetchImplementation, serverOrigin, isApiOnly);
    };
}
function $a41fcd44fe4543d6$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    $acw62.useEffect(()=>{
        if (!$a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$a41fcd44fe4543d6$var$discoveredPaths.has(pathname)) $a41fcd44fe4543d6$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($a41fcd44fe4543d6$var$nextPaths.keys()).filter((path)=>{
                if ($a41fcd44fe4543d6$var$discoveredPaths.has(path)) {
                    $a41fcd44fe4543d6$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes, void 0, fetchImplementation, serverOrigin, isApiOnly);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $a41fcd44fe4543d6$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery,
        fetchImplementation,
        serverOrigin,
        isApiOnly
    ]);
}
function $a41fcd44fe4543d6$export$251abd15fde24921(paths) {
    return paths.slice().sort().map((path)=>path.replace(/,/g, "%2C")).join(",");
}
function $a41fcd44fe4543d6$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
const $a41fcd44fe4543d6$var$MANIFEST_RELOAD_TIMEOUT = 5e3;
let $a41fcd44fe4543d6$var$pendingManifestReload;
async function $a41fcd44fe4543d6$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if ($a41fcd44fe4543d6$var$pendingManifestReload) return $a41fcd44fe4543d6$var$pendingManifestReload;
    if (!needsReload) {
        try {
            sessionStorage.removeItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    let alreadyReloaded = false;
    try {
        alreadyReloaded = sessionStorage.getItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY) === version;
        if (!alreadyReloaded) sessionStorage.setItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    if (alreadyReloaded) throw new Error("Unable to discover routes due to manifest version mismatch.");
    let rejectReload;
    let reloadPromise = new Promise((_, reject)=>{
        rejectReload = reject;
    });
    $a41fcd44fe4543d6$var$pendingManifestReload = reloadPromise;
    let failReload = ()=>{
        clearTimeout(timeout);
        window.removeEventListener("pageshow", onPageShow);
        $a41fcd44fe4543d6$var$pendingManifestReload = void 0;
        rejectReload(/* @__PURE__ */ new Error("Unable to discover routes due to manifest version mismatch."));
    };
    let timeout = setTimeout(failReload, $a41fcd44fe4543d6$var$MANIFEST_RELOAD_TIMEOUT);
    let onPageShow = (event)=>{
        if (event.persisted) failReload();
    };
    window.addEventListener("pageshow", onPageShow);
    try {
        window.location.href = errorReloadPath;
        console.warn("Detected manifest version mismatch, reloading...");
    } catch  {
        failReload();
    }
    return reloadPromise;
}
async function $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal, fetchImplementation = (request)=>fetch(request), serverOrigin, isApiOnly = false) {
    paths = $a41fcd44fe4543d6$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", $a41fcd44fe4543d6$export$251abd15fde24921(paths));
    searchParams.set("version", manifest.version);
    let url = new URL($a41fcd44fe4543d6$export$bcb79c3deff01d56(manifestPath, basename), serverOrigin ?? window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $a41fcd44fe4543d6$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetchImplementation(new Request(url, {
            signal: signal
        }), {
            type: "manifest"
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $a41fcd44fe4543d6$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$a41fcd44fe4543d6$var$addToFifoQueue(p, $a41fcd44fe4543d6$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $aa520e004fa2ab60$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId, void 0, void 0, isApiOnly)));
}
function $a41fcd44fe4543d6$var$addToFifoQueue(path, queue) {
    if (queue.size >= $a41fcd44fe4543d6$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $a41fcd44fe4543d6$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/components.tsx
const $baf242efa2d54ba7$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$baf242efa2d54ba7$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $baf242efa2d54ba7$export$17134ff624fc6bc2() {
    let context = $acw62.useContext($baf242efa2d54ba7$export$208d6a3bc3aa62bd);
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $baf242efa2d54ba7$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($baf242efa2d54ba7$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $baf242efa2d54ba7$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $baf242efa2d54ba7$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $baf242efa2d54ba7$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $baf242efa2d54ba7$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $baf242efa2d54ba7$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $baf242efa2d54ba7$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $baf242efa2d54ba7$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$baf242efa2d54ba7$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $baf242efa2d54ba7$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $baf242efa2d54ba7$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("Links");
    let { errors: errors } = (0, $baf2581b6f4e4c0a$export$798168c290ba5b3d)("Links");
    let matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$baf242efa2d54ba7$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$baf242efa2d54ba7$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $bb47af95f14cb967$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $baf242efa2d54ba7$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("PrefetchPageLinks");
    let matches = $acw62.useMemo(()=>router.match(page), [
        router,
        router.routes,
        page
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $baf242efa2d54ba7$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        (0, $bb47af95f14cb967$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $baf242efa2d54ba7$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let { unstable_apiServerOrigin: unstable_apiServerOrigin } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $45db1c6124c1e415$export$7b977381851b2c)(page, "rsc", unstable_apiServerOrigin);
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            unstable_apiServerOrigin ? url.toString() : url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches,
        unstable_apiServerOrigin
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $baf242efa2d54ba7$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules, unstable_apiServerOrigin: unstable_apiServerOrigin } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { matches: matches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("PrefetchPageLinks");
    let { loaderData: loaderData } = (0, $baf2581b6f4e4c0a$export$798168c290ba5b3d)("PrefetchPageLinks");
    let newMatchesForData = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $45db1c6124c1e415$export$7b977381851b2c)(page, "data", unstable_apiServerOrigin);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            unstable_apiServerOrigin ? url.toString() : url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules,
        unstable_apiServerOrigin
    ]);
    let moduleHrefs = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $baf242efa2d54ba7$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $baf242efa2d54ba7$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("Meta");
    let { errors: errors, loaderData: loaderData } = (0, $baf2581b6f4e4c0a$export$798168c290ba5b3d)("Meta");
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let _matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$baf242efa2d54ba7$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $baf242efa2d54ba7$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $baf242efa2d54ba7$var$isHydrated = false;
function $baf242efa2d54ba7$export$3be068dde909e563() {
    $baf242efa2d54ba7$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $baf242efa2d54ba7$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("Scripts");
    let { matches: routerMatches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("Scripts");
    let isRSCRouterContext = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $a41fcd44fe4543d6$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $baf242efa2d54ba7$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $a41fcd44fe4543d6$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $baf242efa2d54ba7$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $bb47af95f14cb967$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $baf242efa2d54ba7$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $baf242efa2d54ba7$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/await.ts
function $bb15c7b02d4929bd$export$7c2250e1d8e9bb1b(promise) {
    if (promise.status === "fulfilled") return {
        status: "fulfilled",
        value: promise.value
    };
    if (promise.status === "rejected") return {
        status: "rejected",
        reason: promise.reason
    };
}
let $bb15c7b02d4929bd$var$awaitPromises = /* @__PURE__ */ new WeakMap();
function $bb15c7b02d4929bd$export$be7e832cbe7a26ed(source, onError) {
    let cached = $bb15c7b02d4929bd$var$awaitPromises.get(source);
    if (!cached) {
        cached = {
            promise: Promise.resolve(source).then((value)=>settle({
                    status: "fulfilled",
                    value: value
                }), (reason)=>{
                let result = settle({
                    status: "rejected",
                    reason: reason
                });
                try {
                    cached.onError(reason);
                } catch (error) {
                    console.error("<Await> caught the following error in onError", error);
                }
                return result;
            }),
            onError: onError
        };
        $bb15c7b02d4929bd$var$awaitPromises.set(source, cached);
    } else cached.onError = onError;
    function settle(result) {
        Object.assign(cached.promise, {
            status: "fulfilled",
            value: result
        });
        return result;
    }
    let result = $bb15c7b02d4929bd$export$7c2250e1d8e9bb1b(source);
    if (result) settle(result);
    return cached.promise;
}






var $acw62 = parcelRequire("acw62");
//#region lib/components.tsx
const $1b6caee6a6f10651$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $1b6caee6a6f10651$export$f30f7e456d254e83(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $1b6caee6a6f10651$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $1b6caee6a6f10651$var$handleSkippedViewTransition(transition, document) {
    transition.ready.catch((reason)=>{
        if (!(document.visibilityState === "hidden" || typeof reason === "object" && reason !== null && "name" in reason && reason.name === "AbortError")) throw reason;
    });
}
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $1b6caee6a6f10651$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = (0, $acw62.useOptimistic)(_state);
    let lastState = $acw62.useRef(state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let handledErrors = $acw62.useRef(/* @__PURE__ */ new WeakSet());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        lastState.current = newState;
        if (newErrors && newState.errors && (0, $27ddc9c887d48115$export$f1f19d63f0eb8dcb).has(newState.errors)) {
            if (handledErrors.current.has(newState.errors)) newErrors = null;
            else handledErrors.current.add(newState.errors);
        }
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$1b6caee6a6f10651$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            $1b6caee6a6f10651$var$handleSkippedViewTransition(t, router.window.document);
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useLayoutEffect(()=>{
        let errors = router.state.errors;
        let newErrors = errors ? (0, $27ddc9c887d48115$export$f1f19d63f0eb8dcb).get(errors) : null;
        if (lastState.current !== router.state || errors && newErrors && !handledErrors.current.has(errors)) setState(router.state, {
            deletedFetchers: [],
            flushSync: false,
            newErrors: newErrors ?? null
        });
    }, [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1b6caee6a6f10651$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$1b6caee6a6f10651$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            $1b6caee6a6f10651$var$handleSkippedViewTransition(transition, router.window.document);
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    let dataRouterState = $acw62.useMemo(()=>({
            historyAction: state.historyAction,
            location: state.location,
            matches: state.matches,
            initialized: state.initialized,
            renderFallback: state.renderFallback,
            restoreScrollPosition: state.restoreScrollPosition,
            preventScrollReset: state.preventScrollReset,
            blockers: state.blockers
        }), [
        state.historyAction,
        state.location,
        state.matches,
        state.initialized,
        state.renderFallback,
        state.restoreScrollPosition,
        state.preventScrollReset,
        state.blockers
    ]);
    let dataRouterNavigation = $acw62.useMemo(()=>({
            navigation: state.navigation,
            revalidation: state.revalidation
        }), [
        state.navigation,
        state.revalidation
    ]);
    let dataRouterData = $acw62.useMemo(()=>({
            loaderData: state.loaderData,
            actionData: state.actionData,
            errors: state.errors
        }), [
        state.loaderData,
        state.actionData,
        state.errors
    ]);
    let fetchersContext = $acw62.useMemo(()=>({
            fetchers: state.fetchers,
            fetcherData: fetcherData.current
        }), [
        state.fetchers
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$315e3ffb01f217).Provider, {
        value: dataRouterState
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$2473c5952c6a10d1).Provider, {
        value: dataRouterNavigation
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$19d7395466bdeac8).Provider, {
        value: dataRouterData
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$cb3f1df1bef00a39).Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        state: state,
        isStatic: false,
        onError: onError
    })))))))), null);
}
function $1b6caee6a6f10651$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $1b6caee6a6f10651$var$MemoizedDataRoutes = $acw62.memo($1b6caee6a6f10651$export$699f06c8afb533c9);
function $1b6caee6a6f10651$export$699f06c8afb533c9({ routes: routes, manifest: manifest, state: state, isStatic: isStatic, onError: onError }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(dataRouterContext, "You must render this element inside a <DataRouterContext.Provider> element");
    let discoveryRuntime = $acw62.useContext((0, $baf242efa2d54ba7$export$208d6a3bc3aa62bd))?.routeDiscoveryRuntime;
    $acw62.useEffect(()=>{
        if (state.initialized) discoveryRuntime?.markReady();
    }, [
        state.initialized,
        discoveryRuntime
    ]);
    return (0, $baf2581b6f4e4c0a$export$f7ce0646a48561fb)(routes, void 0, {
        router: dataRouterContext.router,
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $1b6caee6a6f10651$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $1b6caee6a6f10651$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)((0, $baf2581b6f4e4c0a$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, (0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $7ab28948be9dda45$export$1da545bc000055cf)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $1b6caee6a6f10651$export$910ae8079b2c2852(props) {
    return (0, $baf2581b6f4e4c0a$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $1b6caee6a6f10651$export$e7b0ac011bb776c6(props) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $1b6caee6a6f10651$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!(0, $baf2581b6f4e4c0a$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $1b6caee6a6f10651$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $baf2581b6f4e4c0a$export$5d3fca4a98652595)($1b6caee6a6f10651$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* Pass `unstable_promise` instead of `resolve` to opt into React's
* [`use()`](https://react.dev/reference/react/use) implementation. With
* `unstable_promise`, `errorElement` handles promise rejections, while errors
* thrown by children bubble to the nearest React error boundary.
*
* In React Server Components, `resolve` already has this error-handling behavior:
* `errorElement` handles only input rejections, while child render errors
* propagate to the surrounding error boundary. Both props accept promise-like
* values without modifying the source promise. Both props treat a falsy
* `errorElement` as absent and propagate the rejection. Pass an empty fragment
* to handle a rejection without rendering any content.
*
* <docs-warning>The `unstable_promise` prop is experimental and may change in
* minor or patch releases.</docs-warning>
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @param props.unstable_promise A promise (or value) to read using React's `use()`
* API in client components. Accepts promise-like values without modifying the
* source promise. Pass exactly one of `unstable_promise` or `resolve`.
* @returns React element for the rendered awaited value
*/ function $1b6caee6a6f10651$export$6ddabde395c8c576(props) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)("resolve" in props !== "unstable_promise" in props, "<Await> requires exactly one of `resolve` or `unstable_promise`");
    let { children: children, errorElement: errorElement } = props;
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    if ("unstable_promise" in props) return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$AwaitPromise, {
        value: props.unstable_promise,
        errorElement: errorElement,
        onError: onError
    }, children);
    return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$AwaitErrorBoundary, {
        resolve: props.resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$ResolveAwait, null, children));
}
function $1b6caee6a6f10651$var$AwaitPromise({ value: value, children: children, errorElement: errorElement, onError: onError }) {
    let result = value != null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function" ? $acw62.use((0, $bb15c7b02d4929bd$export$be7e832cbe7a26ed)(value, onError)) : {
        status: "fulfilled",
        value: value
    };
    if (result.status === "rejected" && !errorElement) throw result.reason;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
        value: result
    }, result.status === "rejected" ? errorElement : /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$ResolveAwait, null, children));
}
var $1b6caee6a6f10651$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            let result = (0, $bb15c7b02d4929bd$export$7c2250e1d8e9bb1b)(resolve);
            if (result) {
                promise = resolve;
                if (result.status === "fulfilled") {
                    status = 1;
                    Object.defineProperty(resolve, "_data", {
                        get: ()=>result.value
                    });
                } else {
                    status = 2;
                    Object.defineProperty(resolve, "_error", {
                        get: ()=>result.reason
                    });
                    Promise.resolve(resolve).catch((reason)=>{
                        try {
                            this.props.onError?.(reason);
                        } catch (error) {
                            console.error("<Await> caught the following error in onError", error);
                        }
                    });
                }
            } else promise = Promise.resolve(resolve).then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $1b6caee6a6f10651$var$ResolveAwait({ children: children }) {
    let data = (0, $baf2581b6f4e4c0a$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $1b6caee6a6f10651$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $1b6caee6a6f10651$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(element.type === $1b6caee6a6f10651$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $1b6caee6a6f10651$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $1b6caee6a6f10651$export$9b5b6d122dea0c88 = $1b6caee6a6f10651$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $1b6caee6a6f10651$export$daf73786167a7f72(matches) {
    return (0, $baf2581b6f4e4c0a$export$569816e95a012c39)(matches);
}
function $1b6caee6a6f10651$var$useRouteComponentProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)(),
        matches: (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)()
    };
}
function $1b6caee6a6f10651$export$6c4f3826290c37af({ children: children }) {
    const props = $1b6caee6a6f10651$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $1b6caee6a6f10651$var$useRouteComponentProps();
        return $acw62.createElement(Component, props);
    };
}
function $1b6caee6a6f10651$var$useHydrateFallbackProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)()
    };
}
function $1b6caee6a6f10651$export$f8cff34f39c1932a({ children: children }) {
    const props = $1b6caee6a6f10651$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $1b6caee6a6f10651$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $1b6caee6a6f10651$var$useErrorBoundaryProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)(),
        error: (0, $baf2581b6f4e4c0a$export$ed527bf60f6e05f2)()
    };
}
function $1b6caee6a6f10651$export$e5afde5c4b6d747b({ children: children }) {
    const props = $1b6caee6a6f10651$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $1b6caee6a6f10651$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.5.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $89bbb3f5cea75f10$var$defaultEncType = "application/x-www-form-urlencoded";
function $89bbb3f5cea75f10$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $89bbb3f5cea75f10$var$isButtonElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $89bbb3f5cea75f10$var$isFormElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $89bbb3f5cea75f10$var$isInputElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $89bbb3f5cea75f10$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $89bbb3f5cea75f10$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$89bbb3f5cea75f10$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $89bbb3f5cea75f10$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = null;
function $89bbb3f5cea75f10$var$isFormDataSubmitterSupported() {
    if ($89bbb3f5cea75f10$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = false;
    } catch  {
        $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = true;
    }
    return $89bbb3f5cea75f10$var$_formDataSupportsSubmitter;
}
const $89bbb3f5cea75f10$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $89bbb3f5cea75f10$var$getFormEncType(encType) {
    if (encType != null && !$89bbb3f5cea75f10$var$supportedFormEncTypes.has(encType)) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$89bbb3f5cea75f10$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $89bbb3f5cea75f10$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($89bbb3f5cea75f10$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $89bbb3f5cea75f10$var$getFormEncType(target.getAttribute("enctype")) || $89bbb3f5cea75f10$var$defaultEncType;
        formData = new FormData(target);
    } else if ($89bbb3f5cea75f10$var$isButtonElement(target) || $89bbb3f5cea75f10$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $89bbb3f5cea75f10$var$getFormEncType(target.getAttribute("formenctype")) || $89bbb3f5cea75f10$var$getFormEncType(form.getAttribute("enctype")) || $89bbb3f5cea75f10$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$89bbb3f5cea75f10$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($89bbb3f5cea75f10$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $89bbb3f5cea75f10$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/lib.tsx
const $5cec2af50e95548c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5cec2af50e95548c$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5cec2af50e95548c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5cec2af50e95548c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5cec2af50e95548c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5cec2af50e95548c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5cec2af50e95548c$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5cec2af50e95548c$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5cec2af50e95548c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $5cec2af50e95548c$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $5cec2af50e95548c$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $5cec2af50e95548c$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$5cec2af50e95548c$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $5cec2af50e95548c$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $edf931d6dcac43ec$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $baf2581b6f4e4c0a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $baf242efa2d54ba7$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $5cec2af50e95548c$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $baf242efa2d54ba7$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement((0, $baf242efa2d54ba7$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$5cec2af50e95548c$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $5cec2af50e95548c$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let routerNavigation = $acw62.useContext((0, $52882ad28a21bc0a$export$2473c5952c6a10d1));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let isTransitioning = routerNavigation != null && $5cec2af50e95548c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerNavigation?.navigation.location ? routerNavigation.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($5cec2af50e95548c$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5cec2af50e95548c$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $5cec2af50e95548c$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let submit = $5cec2af50e95548c$export$47c85c6e3a081d3();
    let formAction = $5cec2af50e95548c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5cec2af50e95548c$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $5cec2af50e95548c$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext((0, $baf242efa2d54ba7$export$208d6a3bc3aa62bd));
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let matches = (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)();
    $5cec2af50e95548c$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$5cec2af50e95548c$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition **Deprecated.** Use React's
* [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component
* instead. See the [migration guide](../../how-to/view-transitions).
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $5cec2af50e95548c$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ((0, $89bbb3f5cea75f10$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(location) === (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $5cec2af50e95548c$export$f1a78c17382fe22a(defaultInit) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $acw62.useRef((0, $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>(0, $89bbb3f5cea75f10$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    return [
        searchParams,
        $acw62.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $5cec2af50e95548c$var$fetcherId = 0;
let $5cec2af50e95548c$var$getUniqueFetcherId = ()=>`__${String(++$5cec2af50e95548c$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* The `viewTransition` submission option is deprecated. Use React's
* [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition) component
* instead. See the [migration guide](../../how-to/view-transitions).
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $5cec2af50e95548c$export$47c85c6e3a081d3() {
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useSubmit");
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $baf2581b6f4e4c0a$export$501a3f562d56eac6)("useSubmit");
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $89bbb3f5cea75f10$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $5cec2af50e95548c$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $5cec2af50e95548c$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let routeContext = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $5cec2af50e95548c$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useFetcher");
    let fetchersContext = (0, $baf2581b6f4e4c0a$export$c6e4e4d7047d4ffe)("useFetcher");
    let routeId = (0, $baf2581b6f4e4c0a$export$501a3f562d56eac6)("useFetcher");
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5cec2af50e95548c$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($5cec2af50e95548c$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = fetchersContext.fetchers.get(fetcherKey) || (0, $27ddc9c887d48115$export$52eace9c284d3585);
    let data = fetchersContext.fetcherData.get(fetcherKey);
    return $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $5cec2af50e95548c$export$fa996778a3a31087() {
    let { fetchers: fetchers } = (0, $baf2581b6f4e4c0a$export$c6e4e4d7047d4ffe)("useFetchers");
    return $acw62.useMemo(()=>Array.from(fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        fetchers
    ]);
}
const $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $5cec2af50e95548c$var$savedScrollPositions = {};
function $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $5cec2af50e95548c$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("useScrollRestoration");
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let matches = (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)();
    let navigation = (0, $baf2581b6f4e4c0a$export$d0fd4b7106de2769)();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5cec2af50e95548c$var$usePageShow($acw62.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $5cec2af50e95548c$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5cec2af50e95548c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5cec2af50e95548c$var$savedScrollPositions));
        } catch (error) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5cec2af50e95548c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5cec2af50e95548c$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $5cec2af50e95548c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5cec2af50e95548c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5cec2af50e95548c$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $5cec2af50e95548c$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $baf2581b6f4e4c0a$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* **Deprecated.** Use React's [`<ViewTransition>`](https://react.dev/reference/react/ViewTransition)
* component to style transitions instead. This hook only tracks React Router's
* legacy view transitions, not transitions started by React. See the
* [migration guide](../../how-to/view-transitions).
*
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*
* @deprecated Use React's `<ViewTransition>` component instead.
*/ function $5cec2af50e95548c$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext((0, $52882ad28a21bc0a$export$3681f408decb40d1));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useViewTransitionState");
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $edf931d6dcac43ec$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $edf931d6dcac43ec$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




const $4e9eda319b2a962b$export$6ad93df59e712c43 = {
    // Color tokens
    colorNeutralForeground1: 'var(--colorNeutralForeground1)',
    colorNeutralForeground1Hover: 'var(--colorNeutralForeground1Hover)',
    colorNeutralForeground1Pressed: 'var(--colorNeutralForeground1Pressed)',
    colorNeutralForeground1Selected: 'var(--colorNeutralForeground1Selected)',
    colorNeutralForeground2: 'var(--colorNeutralForeground2)',
    colorNeutralForeground2Hover: 'var(--colorNeutralForeground2Hover)',
    colorNeutralForeground2Pressed: 'var(--colorNeutralForeground2Pressed)',
    colorNeutralForeground2Selected: 'var(--colorNeutralForeground2Selected)',
    colorNeutralForeground2BrandHover: 'var(--colorNeutralForeground2BrandHover)',
    colorNeutralForeground2BrandPressed: 'var(--colorNeutralForeground2BrandPressed)',
    colorNeutralForeground2BrandSelected: 'var(--colorNeutralForeground2BrandSelected)',
    colorNeutralForeground3: 'var(--colorNeutralForeground3)',
    colorNeutralForeground3Hover: 'var(--colorNeutralForeground3Hover)',
    colorNeutralForeground3Pressed: 'var(--colorNeutralForeground3Pressed)',
    colorNeutralForeground3Selected: 'var(--colorNeutralForeground3Selected)',
    colorNeutralForeground3BrandHover: 'var(--colorNeutralForeground3BrandHover)',
    colorNeutralForeground3BrandPressed: 'var(--colorNeutralForeground3BrandPressed)',
    colorNeutralForeground3BrandSelected: 'var(--colorNeutralForeground3BrandSelected)',
    colorNeutralForeground4: 'var(--colorNeutralForeground4)',
    colorNeutralForeground5: 'var(--colorNeutralForeground5)',
    colorNeutralForeground5Hover: 'var(--colorNeutralForeground5Hover)',
    colorNeutralForeground5Pressed: 'var(--colorNeutralForeground5Pressed)',
    colorNeutralForeground5Selected: 'var(--colorNeutralForeground5Selected)',
    colorNeutralForegroundDisabled: 'var(--colorNeutralForegroundDisabled)',
    colorBrandForegroundLink: 'var(--colorBrandForegroundLink)',
    colorBrandForegroundLinkHover: 'var(--colorBrandForegroundLinkHover)',
    colorBrandForegroundLinkPressed: 'var(--colorBrandForegroundLinkPressed)',
    colorBrandForegroundLinkSelected: 'var(--colorBrandForegroundLinkSelected)',
    colorNeutralForeground2Link: 'var(--colorNeutralForeground2Link)',
    colorNeutralForeground2LinkHover: 'var(--colorNeutralForeground2LinkHover)',
    colorNeutralForeground2LinkPressed: 'var(--colorNeutralForeground2LinkPressed)',
    colorNeutralForeground2LinkSelected: 'var(--colorNeutralForeground2LinkSelected)',
    colorCompoundBrandForeground1: 'var(--colorCompoundBrandForeground1)',
    colorCompoundBrandForeground1Hover: 'var(--colorCompoundBrandForeground1Hover)',
    colorCompoundBrandForeground1Pressed: 'var(--colorCompoundBrandForeground1Pressed)',
    colorNeutralForegroundOnBrand: 'var(--colorNeutralForegroundOnBrand)',
    colorNeutralForegroundInverted: 'var(--colorNeutralForegroundInverted)',
    colorNeutralForegroundInvertedHover: 'var(--colorNeutralForegroundInvertedHover)',
    colorNeutralForegroundInvertedPressed: 'var(--colorNeutralForegroundInvertedPressed)',
    colorNeutralForegroundInvertedSelected: 'var(--colorNeutralForegroundInvertedSelected)',
    colorNeutralForegroundInverted2: 'var(--colorNeutralForegroundInverted2)',
    colorNeutralForegroundStaticInverted: 'var(--colorNeutralForegroundStaticInverted)',
    colorNeutralForegroundInvertedLink: 'var(--colorNeutralForegroundInvertedLink)',
    colorNeutralForegroundInvertedLinkHover: 'var(--colorNeutralForegroundInvertedLinkHover)',
    colorNeutralForegroundInvertedLinkPressed: 'var(--colorNeutralForegroundInvertedLinkPressed)',
    colorNeutralForegroundInvertedLinkSelected: 'var(--colorNeutralForegroundInvertedLinkSelected)',
    colorNeutralForegroundInvertedDisabled: 'var(--colorNeutralForegroundInvertedDisabled)',
    colorBrandForeground1: 'var(--colorBrandForeground1)',
    colorBrandForeground2: 'var(--colorBrandForeground2)',
    colorBrandForeground2Hover: 'var(--colorBrandForeground2Hover)',
    colorBrandForeground2Pressed: 'var(--colorBrandForeground2Pressed)',
    colorNeutralForeground1Static: 'var(--colorNeutralForeground1Static)',
    colorBrandForegroundInverted: 'var(--colorBrandForegroundInverted)',
    colorBrandForegroundInvertedHover: 'var(--colorBrandForegroundInvertedHover)',
    colorBrandForegroundInvertedPressed: 'var(--colorBrandForegroundInvertedPressed)',
    colorBrandForegroundOnLight: 'var(--colorBrandForegroundOnLight)',
    colorBrandForegroundOnLightHover: 'var(--colorBrandForegroundOnLightHover)',
    colorBrandForegroundOnLightPressed: 'var(--colorBrandForegroundOnLightPressed)',
    colorBrandForegroundOnLightSelected: 'var(--colorBrandForegroundOnLightSelected)',
    colorNeutralBackground1: 'var(--colorNeutralBackground1)',
    colorNeutralBackground1Hover: 'var(--colorNeutralBackground1Hover)',
    colorNeutralBackground1Pressed: 'var(--colorNeutralBackground1Pressed)',
    colorNeutralBackground1Selected: 'var(--colorNeutralBackground1Selected)',
    colorNeutralBackground2: 'var(--colorNeutralBackground2)',
    colorNeutralBackground2Hover: 'var(--colorNeutralBackground2Hover)',
    colorNeutralBackground2Pressed: 'var(--colorNeutralBackground2Pressed)',
    colorNeutralBackground2Selected: 'var(--colorNeutralBackground2Selected)',
    colorNeutralBackground3: 'var(--colorNeutralBackground3)',
    colorNeutralBackground3Hover: 'var(--colorNeutralBackground3Hover)',
    colorNeutralBackground3Pressed: 'var(--colorNeutralBackground3Pressed)',
    colorNeutralBackground3Selected: 'var(--colorNeutralBackground3Selected)',
    colorNeutralBackground4: 'var(--colorNeutralBackground4)',
    colorNeutralBackground4Hover: 'var(--colorNeutralBackground4Hover)',
    colorNeutralBackground4Pressed: 'var(--colorNeutralBackground4Pressed)',
    colorNeutralBackground4Selected: 'var(--colorNeutralBackground4Selected)',
    colorNeutralBackground5: 'var(--colorNeutralBackground5)',
    colorNeutralBackground5Hover: 'var(--colorNeutralBackground5Hover)',
    colorNeutralBackground5Pressed: 'var(--colorNeutralBackground5Pressed)',
    colorNeutralBackground5Selected: 'var(--colorNeutralBackground5Selected)',
    colorNeutralBackground6: 'var(--colorNeutralBackground6)',
    colorNeutralBackground7: 'var(--colorNeutralBackground7)',
    colorNeutralBackground7Hover: 'var(--colorNeutralBackground7Hover)',
    colorNeutralBackground7Pressed: 'var(--colorNeutralBackground7Pressed)',
    colorNeutralBackground7Selected: 'var(--colorNeutralBackground7Selected)',
    colorNeutralBackground8: 'var(--colorNeutralBackground8)',
    colorNeutralBackgroundInverted: 'var(--colorNeutralBackgroundInverted)',
    colorNeutralBackgroundInvertedHover: 'var(--colorNeutralBackgroundInvertedHover)',
    colorNeutralBackgroundInvertedPressed: 'var(--colorNeutralBackgroundInvertedPressed)',
    colorNeutralBackgroundInvertedSelected: 'var(--colorNeutralBackgroundInvertedSelected)',
    colorNeutralBackgroundStatic: 'var(--colorNeutralBackgroundStatic)',
    colorNeutralBackgroundAlpha: 'var(--colorNeutralBackgroundAlpha)',
    colorNeutralBackgroundAlpha2: 'var(--colorNeutralBackgroundAlpha2)',
    colorSubtleBackground: 'var(--colorSubtleBackground)',
    colorSubtleBackgroundHover: 'var(--colorSubtleBackgroundHover)',
    colorSubtleBackgroundPressed: 'var(--colorSubtleBackgroundPressed)',
    colorSubtleBackgroundSelected: 'var(--colorSubtleBackgroundSelected)',
    colorSubtleBackgroundLightAlphaHover: 'var(--colorSubtleBackgroundLightAlphaHover)',
    colorSubtleBackgroundLightAlphaPressed: 'var(--colorSubtleBackgroundLightAlphaPressed)',
    colorSubtleBackgroundLightAlphaSelected: 'var(--colorSubtleBackgroundLightAlphaSelected)',
    colorSubtleBackgroundInverted: 'var(--colorSubtleBackgroundInverted)',
    colorSubtleBackgroundInvertedHover: 'var(--colorSubtleBackgroundInvertedHover)',
    colorSubtleBackgroundInvertedPressed: 'var(--colorSubtleBackgroundInvertedPressed)',
    colorSubtleBackgroundInvertedSelected: 'var(--colorSubtleBackgroundInvertedSelected)',
    colorTransparentBackground: 'var(--colorTransparentBackground)',
    colorTransparentBackgroundHover: 'var(--colorTransparentBackgroundHover)',
    colorTransparentBackgroundPressed: 'var(--colorTransparentBackgroundPressed)',
    colorTransparentBackgroundSelected: 'var(--colorTransparentBackgroundSelected)',
    colorNeutralBackgroundDisabled: 'var(--colorNeutralBackgroundDisabled)',
    colorNeutralBackgroundDisabled2: 'var(--colorNeutralBackgroundDisabled2)',
    colorNeutralBackgroundInvertedDisabled: 'var(--colorNeutralBackgroundInvertedDisabled)',
    colorNeutralStencil1: 'var(--colorNeutralStencil1)',
    colorNeutralStencil2: 'var(--colorNeutralStencil2)',
    colorNeutralStencil1Alpha: 'var(--colorNeutralStencil1Alpha)',
    colorNeutralStencil2Alpha: 'var(--colorNeutralStencil2Alpha)',
    colorBackgroundOverlay: 'var(--colorBackgroundOverlay)',
    colorScrollbarOverlay: 'var(--colorScrollbarOverlay)',
    colorBrandBackground: 'var(--colorBrandBackground)',
    colorBrandBackgroundHover: 'var(--colorBrandBackgroundHover)',
    colorBrandBackgroundPressed: 'var(--colorBrandBackgroundPressed)',
    colorBrandBackgroundSelected: 'var(--colorBrandBackgroundSelected)',
    colorCompoundBrandBackground: 'var(--colorCompoundBrandBackground)',
    colorCompoundBrandBackgroundHover: 'var(--colorCompoundBrandBackgroundHover)',
    colorCompoundBrandBackgroundPressed: 'var(--colorCompoundBrandBackgroundPressed)',
    colorBrandBackgroundStatic: 'var(--colorBrandBackgroundStatic)',
    colorBrandBackground2: 'var(--colorBrandBackground2)',
    colorBrandBackground2Hover: 'var(--colorBrandBackground2Hover)',
    colorBrandBackground2Pressed: 'var(--colorBrandBackground2Pressed)',
    colorBrandBackground3Static: 'var(--colorBrandBackground3Static)',
    colorBrandBackground4Static: 'var(--colorBrandBackground4Static)',
    colorBrandBackgroundInverted: 'var(--colorBrandBackgroundInverted)',
    colorBrandBackgroundInvertedHover: 'var(--colorBrandBackgroundInvertedHover)',
    colorBrandBackgroundInvertedPressed: 'var(--colorBrandBackgroundInvertedPressed)',
    colorBrandBackgroundInvertedSelected: 'var(--colorBrandBackgroundInvertedSelected)',
    colorNeutralCardBackground: 'var(--colorNeutralCardBackground)',
    colorNeutralCardBackgroundHover: 'var(--colorNeutralCardBackgroundHover)',
    colorNeutralCardBackgroundPressed: 'var(--colorNeutralCardBackgroundPressed)',
    colorNeutralCardBackgroundSelected: 'var(--colorNeutralCardBackgroundSelected)',
    colorNeutralCardBackgroundDisabled: 'var(--colorNeutralCardBackgroundDisabled)',
    colorNeutralStrokeAccessible: 'var(--colorNeutralStrokeAccessible)',
    colorNeutralStrokeAccessibleHover: 'var(--colorNeutralStrokeAccessibleHover)',
    colorNeutralStrokeAccessiblePressed: 'var(--colorNeutralStrokeAccessiblePressed)',
    colorNeutralStrokeAccessibleSelected: 'var(--colorNeutralStrokeAccessibleSelected)',
    colorNeutralStroke1: 'var(--colorNeutralStroke1)',
    colorNeutralStroke1Hover: 'var(--colorNeutralStroke1Hover)',
    colorNeutralStroke1Pressed: 'var(--colorNeutralStroke1Pressed)',
    colorNeutralStroke1Selected: 'var(--colorNeutralStroke1Selected)',
    colorNeutralStroke2: 'var(--colorNeutralStroke2)',
    colorNeutralStroke3: 'var(--colorNeutralStroke3)',
    colorNeutralStroke4: 'var(--colorNeutralStroke4)',
    colorNeutralStroke4Hover: 'var(--colorNeutralStroke4Hover)',
    colorNeutralStroke4Pressed: 'var(--colorNeutralStroke4Pressed)',
    colorNeutralStroke4Selected: 'var(--colorNeutralStroke4Selected)',
    colorNeutralStrokeSubtle: 'var(--colorNeutralStrokeSubtle)',
    colorNeutralStrokeOnBrand: 'var(--colorNeutralStrokeOnBrand)',
    colorNeutralStrokeOnBrand2: 'var(--colorNeutralStrokeOnBrand2)',
    colorNeutralStrokeOnBrand2Hover: 'var(--colorNeutralStrokeOnBrand2Hover)',
    colorNeutralStrokeOnBrand2Pressed: 'var(--colorNeutralStrokeOnBrand2Pressed)',
    colorNeutralStrokeOnBrand2Selected: 'var(--colorNeutralStrokeOnBrand2Selected)',
    colorBrandStroke1: 'var(--colorBrandStroke1)',
    colorBrandStroke2: 'var(--colorBrandStroke2)',
    colorBrandStroke2Hover: 'var(--colorBrandStroke2Hover)',
    colorBrandStroke2Pressed: 'var(--colorBrandStroke2Pressed)',
    colorBrandStroke2Contrast: 'var(--colorBrandStroke2Contrast)',
    colorCompoundBrandStroke: 'var(--colorCompoundBrandStroke)',
    colorCompoundBrandStrokeHover: 'var(--colorCompoundBrandStrokeHover)',
    colorCompoundBrandStrokePressed: 'var(--colorCompoundBrandStrokePressed)',
    colorNeutralStrokeDisabled: 'var(--colorNeutralStrokeDisabled)',
    colorNeutralStrokeDisabled2: 'var(--colorNeutralStrokeDisabled2)',
    colorNeutralStrokeInvertedDisabled: 'var(--colorNeutralStrokeInvertedDisabled)',
    colorTransparentStroke: 'var(--colorTransparentStroke)',
    colorTransparentStrokeInteractive: 'var(--colorTransparentStrokeInteractive)',
    colorTransparentStrokeDisabled: 'var(--colorTransparentStrokeDisabled)',
    colorNeutralStrokeAlpha: 'var(--colorNeutralStrokeAlpha)',
    colorNeutralStrokeAlpha2: 'var(--colorNeutralStrokeAlpha2)',
    colorStrokeFocus1: 'var(--colorStrokeFocus1)',
    colorStrokeFocus2: 'var(--colorStrokeFocus2)',
    colorNeutralShadowAmbient: 'var(--colorNeutralShadowAmbient)',
    colorNeutralShadowKey: 'var(--colorNeutralShadowKey)',
    colorNeutralShadowAmbientLighter: 'var(--colorNeutralShadowAmbientLighter)',
    colorNeutralShadowKeyLighter: 'var(--colorNeutralShadowKeyLighter)',
    colorNeutralShadowAmbientDarker: 'var(--colorNeutralShadowAmbientDarker)',
    colorNeutralShadowKeyDarker: 'var(--colorNeutralShadowKeyDarker)',
    colorBrandShadowAmbient: 'var(--colorBrandShadowAmbient)',
    colorBrandShadowKey: 'var(--colorBrandShadowKey)',
    // Color palette tokens
    // Color palette red tokens
    colorPaletteRedBackground1: 'var(--colorPaletteRedBackground1)',
    colorPaletteRedBackground2: 'var(--colorPaletteRedBackground2)',
    colorPaletteRedBackground3: 'var(--colorPaletteRedBackground3)',
    colorPaletteRedBorderActive: 'var(--colorPaletteRedBorderActive)',
    colorPaletteRedBorder1: 'var(--colorPaletteRedBorder1)',
    colorPaletteRedBorder2: 'var(--colorPaletteRedBorder2)',
    colorPaletteRedForeground1: 'var(--colorPaletteRedForeground1)',
    colorPaletteRedForeground2: 'var(--colorPaletteRedForeground2)',
    colorPaletteRedForeground3: 'var(--colorPaletteRedForeground3)',
    colorPaletteRedForegroundInverted: 'var(--colorPaletteRedForegroundInverted)',
    // Color palette green tokens
    colorPaletteGreenBackground1: 'var(--colorPaletteGreenBackground1)',
    colorPaletteGreenBackground2: 'var(--colorPaletteGreenBackground2)',
    colorPaletteGreenBackground3: 'var(--colorPaletteGreenBackground3)',
    colorPaletteGreenBorderActive: 'var(--colorPaletteGreenBorderActive)',
    colorPaletteGreenBorder1: 'var(--colorPaletteGreenBorder1)',
    colorPaletteGreenBorder2: 'var(--colorPaletteGreenBorder2)',
    colorPaletteGreenForeground1: 'var(--colorPaletteGreenForeground1)',
    colorPaletteGreenForeground2: 'var(--colorPaletteGreenForeground2)',
    colorPaletteGreenForeground3: 'var(--colorPaletteGreenForeground3)',
    colorPaletteGreenForegroundInverted: 'var(--colorPaletteGreenForegroundInverted)',
    // Color palette dark orange tokens
    colorPaletteDarkOrangeBackground1: 'var(--colorPaletteDarkOrangeBackground1)',
    colorPaletteDarkOrangeBackground2: 'var(--colorPaletteDarkOrangeBackground2)',
    colorPaletteDarkOrangeBackground3: 'var(--colorPaletteDarkOrangeBackground3)',
    colorPaletteDarkOrangeBorderActive: 'var(--colorPaletteDarkOrangeBorderActive)',
    colorPaletteDarkOrangeBorder1: 'var(--colorPaletteDarkOrangeBorder1)',
    colorPaletteDarkOrangeBorder2: 'var(--colorPaletteDarkOrangeBorder2)',
    colorPaletteDarkOrangeForeground1: 'var(--colorPaletteDarkOrangeForeground1)',
    colorPaletteDarkOrangeForeground2: 'var(--colorPaletteDarkOrangeForeground2)',
    colorPaletteDarkOrangeForeground3: 'var(--colorPaletteDarkOrangeForeground3)',
    // Color palette yellow tokens
    colorPaletteYellowBackground1: 'var(--colorPaletteYellowBackground1)',
    colorPaletteYellowBackground2: 'var(--colorPaletteYellowBackground2)',
    colorPaletteYellowBackground3: 'var(--colorPaletteYellowBackground3)',
    colorPaletteYellowBorderActive: 'var(--colorPaletteYellowBorderActive)',
    colorPaletteYellowBorder1: 'var(--colorPaletteYellowBorder1)',
    colorPaletteYellowBorder2: 'var(--colorPaletteYellowBorder2)',
    colorPaletteYellowForeground1: 'var(--colorPaletteYellowForeground1)',
    colorPaletteYellowForeground2: 'var(--colorPaletteYellowForeground2)',
    colorPaletteYellowForeground3: 'var(--colorPaletteYellowForeground3)',
    colorPaletteYellowForegroundInverted: 'var(--colorPaletteYellowForegroundInverted)',
    // Color palette berry tokens
    colorPaletteBerryBackground1: 'var(--colorPaletteBerryBackground1)',
    colorPaletteBerryBackground2: 'var(--colorPaletteBerryBackground2)',
    colorPaletteBerryBackground3: 'var(--colorPaletteBerryBackground3)',
    colorPaletteBerryBorderActive: 'var(--colorPaletteBerryBorderActive)',
    colorPaletteBerryBorder1: 'var(--colorPaletteBerryBorder1)',
    colorPaletteBerryBorder2: 'var(--colorPaletteBerryBorder2)',
    colorPaletteBerryForeground1: 'var(--colorPaletteBerryForeground1)',
    colorPaletteBerryForeground2: 'var(--colorPaletteBerryForeground2)',
    colorPaletteBerryForeground3: 'var(--colorPaletteBerryForeground3)',
    // Color palette marigold tokens
    colorPaletteMarigoldBackground1: 'var(--colorPaletteMarigoldBackground1)',
    colorPaletteMarigoldBackground2: 'var(--colorPaletteMarigoldBackground2)',
    colorPaletteMarigoldBackground3: 'var(--colorPaletteMarigoldBackground3)',
    colorPaletteMarigoldBorderActive: 'var(--colorPaletteMarigoldBorderActive)',
    colorPaletteMarigoldBorder1: 'var(--colorPaletteMarigoldBorder1)',
    colorPaletteMarigoldBorder2: 'var(--colorPaletteMarigoldBorder2)',
    colorPaletteMarigoldForeground1: 'var(--colorPaletteMarigoldForeground1)',
    colorPaletteMarigoldForeground2: 'var(--colorPaletteMarigoldForeground2)',
    colorPaletteMarigoldForeground3: 'var(--colorPaletteMarigoldForeground3)',
    // Color palette light green tokens
    colorPaletteLightGreenBackground1: 'var(--colorPaletteLightGreenBackground1)',
    colorPaletteLightGreenBackground2: 'var(--colorPaletteLightGreenBackground2)',
    colorPaletteLightGreenBackground3: 'var(--colorPaletteLightGreenBackground3)',
    colorPaletteLightGreenBorderActive: 'var(--colorPaletteLightGreenBorderActive)',
    colorPaletteLightGreenBorder1: 'var(--colorPaletteLightGreenBorder1)',
    colorPaletteLightGreenBorder2: 'var(--colorPaletteLightGreenBorder2)',
    colorPaletteLightGreenForeground1: 'var(--colorPaletteLightGreenForeground1)',
    colorPaletteLightGreenForeground2: 'var(--colorPaletteLightGreenForeground2)',
    colorPaletteLightGreenForeground3: 'var(--colorPaletteLightGreenForeground3)',
    // Color palette anchor tokens
    colorPaletteAnchorBackground2: 'var(--colorPaletteAnchorBackground2)',
    colorPaletteAnchorBorderActive: 'var(--colorPaletteAnchorBorderActive)',
    colorPaletteAnchorForeground2: 'var(--colorPaletteAnchorForeground2)',
    // Color palette beige tokens
    colorPaletteBeigeBackground2: 'var(--colorPaletteBeigeBackground2)',
    colorPaletteBeigeBorderActive: 'var(--colorPaletteBeigeBorderActive)',
    colorPaletteBeigeForeground2: 'var(--colorPaletteBeigeForeground2)',
    // Color palette blue tokens
    colorPaletteBlueBackground2: 'var(--colorPaletteBlueBackground2)',
    colorPaletteBlueBorderActive: 'var(--colorPaletteBlueBorderActive)',
    colorPaletteBlueForeground2: 'var(--colorPaletteBlueForeground2)',
    // Color palette brass tokens
    colorPaletteBrassBackground2: 'var(--colorPaletteBrassBackground2)',
    colorPaletteBrassBorderActive: 'var(--colorPaletteBrassBorderActive)',
    colorPaletteBrassForeground2: 'var(--colorPaletteBrassForeground2)',
    // Color palette brown tokens
    colorPaletteBrownBackground2: 'var(--colorPaletteBrownBackground2)',
    colorPaletteBrownBorderActive: 'var(--colorPaletteBrownBorderActive)',
    colorPaletteBrownForeground2: 'var(--colorPaletteBrownForeground2)',
    // Color palette cornflower tokens
    colorPaletteCornflowerBackground2: 'var(--colorPaletteCornflowerBackground2)',
    colorPaletteCornflowerBorderActive: 'var(--colorPaletteCornflowerBorderActive)',
    colorPaletteCornflowerForeground2: 'var(--colorPaletteCornflowerForeground2)',
    // Color palette cranberry tokens
    colorPaletteCranberryBackground2: 'var(--colorPaletteCranberryBackground2)',
    colorPaletteCranberryBorderActive: 'var(--colorPaletteCranberryBorderActive)',
    colorPaletteCranberryForeground2: 'var(--colorPaletteCranberryForeground2)',
    // Color palette dark green tokens
    colorPaletteDarkGreenBackground2: 'var(--colorPaletteDarkGreenBackground2)',
    colorPaletteDarkGreenBorderActive: 'var(--colorPaletteDarkGreenBorderActive)',
    colorPaletteDarkGreenForeground2: 'var(--colorPaletteDarkGreenForeground2)',
    // Color palette dark red tokens
    colorPaletteDarkRedBackground2: 'var(--colorPaletteDarkRedBackground2)',
    colorPaletteDarkRedBorderActive: 'var(--colorPaletteDarkRedBorderActive)',
    colorPaletteDarkRedForeground2: 'var(--colorPaletteDarkRedForeground2)',
    // Color palette forest tokens
    colorPaletteForestBackground2: 'var(--colorPaletteForestBackground2)',
    colorPaletteForestBorderActive: 'var(--colorPaletteForestBorderActive)',
    colorPaletteForestForeground2: 'var(--colorPaletteForestForeground2)',
    // Color palette gold tokens
    colorPaletteGoldBackground2: 'var(--colorPaletteGoldBackground2)',
    colorPaletteGoldBorderActive: 'var(--colorPaletteGoldBorderActive)',
    colorPaletteGoldForeground2: 'var(--colorPaletteGoldForeground2)',
    // Color palette grape tokens
    colorPaletteGrapeBackground2: 'var(--colorPaletteGrapeBackground2)',
    colorPaletteGrapeBorderActive: 'var(--colorPaletteGrapeBorderActive)',
    colorPaletteGrapeForeground2: 'var(--colorPaletteGrapeForeground2)',
    // Color palette lavender tokens
    colorPaletteLavenderBackground2: 'var(--colorPaletteLavenderBackground2)',
    colorPaletteLavenderBorderActive: 'var(--colorPaletteLavenderBorderActive)',
    colorPaletteLavenderForeground2: 'var(--colorPaletteLavenderForeground2)',
    // Color palette light teal tokens
    colorPaletteLightTealBackground2: 'var(--colorPaletteLightTealBackground2)',
    colorPaletteLightTealBorderActive: 'var(--colorPaletteLightTealBorderActive)',
    colorPaletteLightTealForeground2: 'var(--colorPaletteLightTealForeground2)',
    // Color palette lilac tokens
    colorPaletteLilacBackground2: 'var(--colorPaletteLilacBackground2)',
    colorPaletteLilacBorderActive: 'var(--colorPaletteLilacBorderActive)',
    colorPaletteLilacForeground2: 'var(--colorPaletteLilacForeground2)',
    // Color palette magenta tokens
    colorPaletteMagentaBackground2: 'var(--colorPaletteMagentaBackground2)',
    colorPaletteMagentaBorderActive: 'var(--colorPaletteMagentaBorderActive)',
    colorPaletteMagentaForeground2: 'var(--colorPaletteMagentaForeground2)',
    // Color palette mink tokens
    colorPaletteMinkBackground2: 'var(--colorPaletteMinkBackground2)',
    colorPaletteMinkBorderActive: 'var(--colorPaletteMinkBorderActive)',
    colorPaletteMinkForeground2: 'var(--colorPaletteMinkForeground2)',
    // Color palette navy tokens
    colorPaletteNavyBackground2: 'var(--colorPaletteNavyBackground2)',
    colorPaletteNavyBorderActive: 'var(--colorPaletteNavyBorderActive)',
    colorPaletteNavyForeground2: 'var(--colorPaletteNavyForeground2)',
    // Color palette peach tokens
    colorPalettePeachBackground2: 'var(--colorPalettePeachBackground2)',
    colorPalettePeachBorderActive: 'var(--colorPalettePeachBorderActive)',
    colorPalettePeachForeground2: 'var(--colorPalettePeachForeground2)',
    // Color palette pink tokens
    colorPalettePinkBackground2: 'var(--colorPalettePinkBackground2)',
    colorPalettePinkBorderActive: 'var(--colorPalettePinkBorderActive)',
    colorPalettePinkForeground2: 'var(--colorPalettePinkForeground2)',
    // Color palette platinum tokens
    colorPalettePlatinumBackground2: 'var(--colorPalettePlatinumBackground2)',
    colorPalettePlatinumBorderActive: 'var(--colorPalettePlatinumBorderActive)',
    colorPalettePlatinumForeground2: 'var(--colorPalettePlatinumForeground2)',
    // Color palette plum tokens
    colorPalettePlumBackground2: 'var(--colorPalettePlumBackground2)',
    colorPalettePlumBorderActive: 'var(--colorPalettePlumBorderActive)',
    colorPalettePlumForeground2: 'var(--colorPalettePlumForeground2)',
    // Color palette pumpkin tokens
    colorPalettePumpkinBackground2: 'var(--colorPalettePumpkinBackground2)',
    colorPalettePumpkinBorderActive: 'var(--colorPalettePumpkinBorderActive)',
    colorPalettePumpkinForeground2: 'var(--colorPalettePumpkinForeground2)',
    // Color palette purple tokens
    colorPalettePurpleBackground2: 'var(--colorPalettePurpleBackground2)',
    colorPalettePurpleBorderActive: 'var(--colorPalettePurpleBorderActive)',
    colorPalettePurpleForeground2: 'var(--colorPalettePurpleForeground2)',
    // Color palette royal blue tokens
    colorPaletteRoyalBlueBackground2: 'var(--colorPaletteRoyalBlueBackground2)',
    colorPaletteRoyalBlueBorderActive: 'var(--colorPaletteRoyalBlueBorderActive)',
    colorPaletteRoyalBlueForeground2: 'var(--colorPaletteRoyalBlueForeground2)',
    // Color palette seafoam tokens
    colorPaletteSeafoamBackground2: 'var(--colorPaletteSeafoamBackground2)',
    colorPaletteSeafoamBorderActive: 'var(--colorPaletteSeafoamBorderActive)',
    colorPaletteSeafoamForeground2: 'var(--colorPaletteSeafoamForeground2)',
    // Color palette steel tokens
    colorPaletteSteelBackground2: 'var(--colorPaletteSteelBackground2)',
    colorPaletteSteelBorderActive: 'var(--colorPaletteSteelBorderActive)',
    colorPaletteSteelForeground2: 'var(--colorPaletteSteelForeground2)',
    // Color palette teal tokens
    colorPaletteTealBackground2: 'var(--colorPaletteTealBackground2)',
    colorPaletteTealBorderActive: 'var(--colorPaletteTealBorderActive)',
    colorPaletteTealForeground2: 'var(--colorPaletteTealForeground2)',
    // Color status success tokens
    colorStatusSuccessBackground1: 'var(--colorStatusSuccessBackground1)',
    colorStatusSuccessBackground2: 'var(--colorStatusSuccessBackground2)',
    colorStatusSuccessBackground3: 'var(--colorStatusSuccessBackground3)',
    colorStatusSuccessForeground1: 'var(--colorStatusSuccessForeground1)',
    colorStatusSuccessForeground2: 'var(--colorStatusSuccessForeground2)',
    colorStatusSuccessForeground3: 'var(--colorStatusSuccessForeground3)',
    colorStatusSuccessForegroundInverted: 'var(--colorStatusSuccessForegroundInverted)',
    colorStatusSuccessBorderActive: 'var(--colorStatusSuccessBorderActive)',
    colorStatusSuccessBorder1: 'var(--colorStatusSuccessBorder1)',
    colorStatusSuccessBorder2: 'var(--colorStatusSuccessBorder2)',
    // Color status warning tokens
    colorStatusWarningBackground1: 'var(--colorStatusWarningBackground1)',
    colorStatusWarningBackground2: 'var(--colorStatusWarningBackground2)',
    colorStatusWarningBackground3: 'var(--colorStatusWarningBackground3)',
    colorStatusWarningForeground1: 'var(--colorStatusWarningForeground1)',
    colorStatusWarningForeground2: 'var(--colorStatusWarningForeground2)',
    colorStatusWarningForeground3: 'var(--colorStatusWarningForeground3)',
    colorStatusWarningForegroundInverted: 'var(--colorStatusWarningForegroundInverted)',
    colorStatusWarningBorderActive: 'var(--colorStatusWarningBorderActive)',
    colorStatusWarningBorder1: 'var(--colorStatusWarningBorder1)',
    colorStatusWarningBorder2: 'var(--colorStatusWarningBorder2)',
    // Color status danger tokens
    colorStatusDangerBackground1: 'var(--colorStatusDangerBackground1)',
    colorStatusDangerBackground2: 'var(--colorStatusDangerBackground2)',
    colorStatusDangerBackground3: 'var(--colorStatusDangerBackground3)',
    colorStatusDangerBackground3Hover: 'var(--colorStatusDangerBackground3Hover)',
    colorStatusDangerBackground3Pressed: 'var(--colorStatusDangerBackground3Pressed)',
    colorStatusDangerForeground1: 'var(--colorStatusDangerForeground1)',
    colorStatusDangerForeground2: 'var(--colorStatusDangerForeground2)',
    colorStatusDangerForeground3: 'var(--colorStatusDangerForeground3)',
    colorStatusDangerForegroundInverted: 'var(--colorStatusDangerForegroundInverted)',
    colorStatusDangerBorderActive: 'var(--colorStatusDangerBorderActive)',
    colorStatusDangerBorder1: 'var(--colorStatusDangerBorder1)',
    colorStatusDangerBorder2: 'var(--colorStatusDangerBorder2)',
    // Border radius tokens
    borderRadiusNone: 'var(--borderRadiusNone)',
    borderRadiusSmall: 'var(--borderRadiusSmall)',
    borderRadiusMedium: 'var(--borderRadiusMedium)',
    borderRadiusLarge: 'var(--borderRadiusLarge)',
    borderRadiusXLarge: 'var(--borderRadiusXLarge)',
    borderRadius2XLarge: 'var(--borderRadius2XLarge)',
    borderRadius3XLarge: 'var(--borderRadius3XLarge)',
    borderRadius4XLarge: 'var(--borderRadius4XLarge)',
    borderRadius5XLarge: 'var(--borderRadius5XLarge)',
    borderRadius6XLarge: 'var(--borderRadius6XLarge)',
    borderRadiusCircular: 'var(--borderRadiusCircular)',
    // Font family tokens
    fontFamilyBase: 'var(--fontFamilyBase)',
    fontFamilyMonospace: 'var(--fontFamilyMonospace)',
    fontFamilyNumeric: 'var(--fontFamilyNumeric)',
    // Font size tokens
    fontSizeBase100: 'var(--fontSizeBase100)',
    fontSizeBase200: 'var(--fontSizeBase200)',
    fontSizeBase300: 'var(--fontSizeBase300)',
    fontSizeBase400: 'var(--fontSizeBase400)',
    fontSizeBase500: 'var(--fontSizeBase500)',
    fontSizeBase600: 'var(--fontSizeBase600)',
    fontSizeHero700: 'var(--fontSizeHero700)',
    fontSizeHero800: 'var(--fontSizeHero800)',
    fontSizeHero900: 'var(--fontSizeHero900)',
    fontSizeHero1000: 'var(--fontSizeHero1000)',
    // Font weight tokens
    fontWeightRegular: 'var(--fontWeightRegular)',
    fontWeightMedium: 'var(--fontWeightMedium)',
    fontWeightSemibold: 'var(--fontWeightSemibold)',
    fontWeightBold: 'var(--fontWeightBold)',
    // Line height tokens
    lineHeightBase100: 'var(--lineHeightBase100)',
    lineHeightBase200: 'var(--lineHeightBase200)',
    lineHeightBase300: 'var(--lineHeightBase300)',
    lineHeightBase400: 'var(--lineHeightBase400)',
    lineHeightBase500: 'var(--lineHeightBase500)',
    lineHeightBase600: 'var(--lineHeightBase600)',
    lineHeightHero700: 'var(--lineHeightHero700)',
    lineHeightHero800: 'var(--lineHeightHero800)',
    lineHeightHero900: 'var(--lineHeightHero900)',
    lineHeightHero1000: 'var(--lineHeightHero1000)',
    // Shadow tokens
    shadow2: 'var(--shadow2)',
    shadow4: 'var(--shadow4)',
    shadow8: 'var(--shadow8)',
    shadow16: 'var(--shadow16)',
    shadow28: 'var(--shadow28)',
    shadow64: 'var(--shadow64)',
    // Shadow brand tokens
    shadow2Brand: 'var(--shadow2Brand)',
    shadow4Brand: 'var(--shadow4Brand)',
    shadow8Brand: 'var(--shadow8Brand)',
    shadow16Brand: 'var(--shadow16Brand)',
    shadow28Brand: 'var(--shadow28Brand)',
    shadow64Brand: 'var(--shadow64Brand)',
    // Stroke width tokens
    strokeWidthThin: 'var(--strokeWidthThin)',
    strokeWidthThick: 'var(--strokeWidthThick)',
    strokeWidthThicker: 'var(--strokeWidthThicker)',
    strokeWidthThickest: 'var(--strokeWidthThickest)',
    // Spacings
    spacingHorizontalNone: 'var(--spacingHorizontalNone)',
    spacingHorizontalXXS: 'var(--spacingHorizontalXXS)',
    spacingHorizontalXS: 'var(--spacingHorizontalXS)',
    spacingHorizontalSNudge: 'var(--spacingHorizontalSNudge)',
    spacingHorizontalS: 'var(--spacingHorizontalS)',
    spacingHorizontalMNudge: 'var(--spacingHorizontalMNudge)',
    spacingHorizontalM: 'var(--spacingHorizontalM)',
    spacingHorizontalL: 'var(--spacingHorizontalL)',
    spacingHorizontalXL: 'var(--spacingHorizontalXL)',
    spacingHorizontalXXL: 'var(--spacingHorizontalXXL)',
    spacingHorizontalXXXL: 'var(--spacingHorizontalXXXL)',
    spacingVerticalNone: 'var(--spacingVerticalNone)',
    spacingVerticalXXS: 'var(--spacingVerticalXXS)',
    spacingVerticalXS: 'var(--spacingVerticalXS)',
    spacingVerticalSNudge: 'var(--spacingVerticalSNudge)',
    spacingVerticalS: 'var(--spacingVerticalS)',
    spacingVerticalMNudge: 'var(--spacingVerticalMNudge)',
    spacingVerticalM: 'var(--spacingVerticalM)',
    spacingVerticalL: 'var(--spacingVerticalL)',
    spacingVerticalXL: 'var(--spacingVerticalXL)',
    spacingVerticalXXL: 'var(--spacingVerticalXXL)',
    spacingVerticalXXXL: 'var(--spacingVerticalXXXL)',
    // Durations
    durationUltraFast: 'var(--durationUltraFast)',
    durationFaster: 'var(--durationFaster)',
    durationFast: 'var(--durationFast)',
    durationNormal: 'var(--durationNormal)',
    durationGentle: 'var(--durationGentle)',
    durationSlow: 'var(--durationSlow)',
    durationSlower: 'var(--durationSlower)',
    durationUltraSlow: 'var(--durationUltraSlow)',
    // Curves
    curveAccelerateMax: 'var(--curveAccelerateMax)',
    curveAccelerateMid: 'var(--curveAccelerateMid)',
    curveAccelerateMin: 'var(--curveAccelerateMin)',
    curveDecelerateMax: 'var(--curveDecelerateMax)',
    curveDecelerateMid: 'var(--curveDecelerateMid)',
    curveDecelerateMin: 'var(--curveDecelerateMin)',
    curveEasyEaseMax: 'var(--curveEasyEaseMax)',
    curveEasyEase: 'var(--curveEasyEase)',
    curveLinear: 'var(--curveLinear)',
    /**
   * ZIndexes
   * Special case where the tokens contain default values
   * ZIndexes are not mandatory, so they are not included in the theme, but can be used as tokens with default values
   */ /**
   * Elevation 0
   * Can be used for background elements, like surfaces
   */ zIndexBackground: 'var(--zIndexBackground, 0)',
    /**
   * Elevation 2
   * Can be used content that is on top of the background, like cards
   */ zIndexContent: 'var(--zIndexContent, 1)',
    /**
   * Elevation 4
   * Can be used for overlays, like the backdrop of a modal
   */ zIndexOverlay: 'var(--zIndexOverlay, 1000)',
    /**
   * Elevation 8
   * Can be used for popups, like modals and drawers
   */ zIndexPopup: 'var(--zIndexPopup, 2000)',
    /**
   * Elevation 16
   * Can be used for messages, like snackbars and toasts
   */ zIndexMessages: 'var(--zIndexMessages, 3000)',
    /**
   * Elevation 28
   * Can be used for floating elements, like dropdowns
   */ zIndexFloating: 'var(--zIndexFloating, 4000)',
    /**
   * Elevation 64
   * Can be used for high priority floating elements, like tooltips
   */ zIndexPriority: 'var(--zIndexPriority, 5000)',
    /**
   * Special elevation
   * Can be used for elements that need to be above everything else, like debug overlays
   */ zIndexDebug: 'var(--zIndexDebug, 6000)'
};


var $acw62 = parcelRequire("acw62");

'use client';
const $7892eaa0711e2be0$export$1c4bfbcf3850ba52 = (props, ref)=>{
    const { shape: shape = 'circular', size: size = 'medium', appearance: appearance = 'filled', color: color = 'brand', ...badgeProps } = props;
    const state = $7892eaa0711e2be0$export$7acc7342958ebb87(badgeProps, ref);
    return {
        ...state,
        shape: shape,
        size: size,
        appearance: appearance,
        color: color
    };
};
const $7892eaa0711e2be0$export$7acc7342958ebb87 = (props, ref)=>{
    const { iconPosition: iconPosition = 'before' } = props;
    return {
        iconPosition: iconPosition,
        components: {
            root: 'div',
            icon: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        icon: (0, $fcf7ddccaab7fd8f$exports).optional(props.icon, {
            elementType: 'span'
        })
    };
};



var $acw62 = parcelRequire("acw62");


function $58f08a451f51e5ff$export$7e3b04e77a0827f2(ltrClassName, rtlClassName, cssRules, factory = (0, $7b009f341ccf321a$export$3509cd6597590fb4)) {
    const insertStyles = factory();
    function computeClassName(options) {
        const { dir: dir, renderer: renderer } = options;
        const className = dir === 'ltr' ? ltrClassName : rtlClassName || ltrClassName;
        insertStyles(renderer, Array.isArray(cssRules) ? {
            r: cssRules
        } : cssRules);
        return className;
    }
    return computeClassName;
}





'use client';
function $edc64c21f394d20d$export$7e3b04e77a0827f2(ltrClassName, rtlClassName, cssRules) {
    const getStyles = (0, $58f08a451f51e5ff$export$7e3b04e77a0827f2)(ltrClassName, rtlClassName, cssRules, (0, $b16bdb5b36b8736b$export$3509cd6597590fb4));
    return function useClasses() {
        const dir = (0, $1351c645e9f8e168$export$cf24a79f32f45545)();
        const renderer = (0, $5c71fabe713d2fee$export$e0259e2a2ab69ea)();
        return getStyles({
            dir: dir,
            renderer: renderer
        });
    };
}



'use client';
const $09a60c0c323f2773$export$3b209f953c0ecbad = {
    root: 'fui-Badge',
    icon: 'fui-Badge__icon'
};
// The text content of the badge has additional horizontal padding, but there is no `text` slot to add that padding to.
// Instead, add extra padding to the root, and a negative margin on the icon to "remove" the extra padding on the icon.
const $09a60c0c323f2773$var$textPadding = (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalXXS;
const $09a60c0c323f2773$var$useRootClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1iycov", "r115jdol", [
    ".r1iycov{display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;position:relative;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase200);height:20px;min-width:20px;padding:0 calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));border-radius:var(--borderRadiusCircular);border-color:var(--colorTransparentStroke);}",
    ".r1iycov::after{content:\"\";position:absolute;top:0;left:0;bottom:0;right:0;border-style:solid;border-color:inherit;border-width:var(--strokeWidthThin);border-radius:inherit;}",
    ".r115jdol{display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;position:relative;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase200);height:20px;min-width:20px;padding:0 calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));border-radius:var(--borderRadiusCircular);border-color:var(--colorTransparentStroke);}",
    ".r115jdol::after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-style:solid;border-color:inherit;border-width:var(--strokeWidthThin);border-radius:inherit;}"
]);
const $09a60c0c323f2773$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    fontSmallToTiny: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f13mqy1h",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fcpl73t"
    },
    tiny: {
        a9b677: "f16dn6v3",
        Bqenvij: "f3mu39s",
        Be2twd7: "f130uwy9",
        Bg96gwp: "fod1mrr",
        Bf4jedk: "f18p0k4z",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f19jm9xf"
    },
    "extra-small": {
        a9b677: "fpd43o0",
        Bqenvij: "f30q22z",
        Be2twd7: "f1tccstq",
        Bg96gwp: "f1y3arg5",
        Bf4jedk: "f18p0k4z",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f19jm9xf"
    },
    small: {
        Bf4jedk: "fq2vo04",
        Bqenvij: "fd461yt",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fupdldz"
    },
    medium: {},
    large: {
        Bf4jedk: "f17fgpbq",
        Bqenvij: "frvgh55",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1996nqw"
    },
    "extra-large": {
        Bf4jedk: "fwbmr0d",
        Bqenvij: "f1d2rq10",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fty64o7"
    },
    square: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f1fabniw"
    },
    rounded: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5"
    },
    roundedSmallToTiny: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "fq9zq91"
    },
    circular: {},
    borderGhost: {
        ap17g6: "f10ludwy"
    },
    filled: {},
    "filled-brand": {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk"
    },
    "filled-danger": {
        De3pzq: "fdl5y0r",
        sj55zd: "f1phragk"
    },
    "filled-important": {
        De3pzq: "f1c73kur",
        sj55zd: "fr0bkrk"
    },
    "filled-informative": {
        De3pzq: "f3vzo32",
        sj55zd: "f11d4kpn"
    },
    "filled-severe": {
        De3pzq: "f1s438gw",
        sj55zd: "f1phragk"
    },
    "filled-subtle": {
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5"
    },
    "filled-success": {
        De3pzq: "flxk52p",
        sj55zd: "f1phragk"
    },
    "filled-warning": {
        De3pzq: "ffq97bm",
        sj55zd: "ff5vbop"
    },
    ghost: {},
    "ghost-brand": {
        sj55zd: "f16muhyy"
    },
    "ghost-danger": {
        sj55zd: "f1whyuy6"
    },
    "ghost-important": {
        sj55zd: "f19n0e5"
    },
    "ghost-informative": {
        sj55zd: "f11d4kpn"
    },
    "ghost-severe": {
        sj55zd: "f1l8vj45"
    },
    "ghost-subtle": {
        sj55zd: "fonrgv7"
    },
    "ghost-success": {
        sj55zd: "f1m7fhi8"
    },
    "ghost-warning": {
        sj55zd: "fpti2h4"
    },
    outline: {
        g2u3we: "f23ftbb",
        h3c5rm: [
            "f1gkuv52",
            "f1p1bl80"
        ],
        B9xav0g: "fioka3i",
        zhjwy3: [
            "f1p1bl80",
            "f1gkuv52"
        ]
    },
    "outline-brand": {
        sj55zd: "f16muhyy"
    },
    "outline-danger": {
        sj55zd: "f1whyuy6",
        g2u3we: "fyqpifd",
        h3c5rm: [
            "f3ukxca",
            "f1k7dugc"
        ],
        B9xav0g: "f1njxb2b",
        zhjwy3: [
            "f1k7dugc",
            "f3ukxca"
        ]
    },
    "outline-important": {
        sj55zd: "f11d4kpn",
        g2u3we: "fq0vr37",
        h3c5rm: [
            "f1byw159",
            "f11cr0be"
        ],
        B9xav0g: "f1c1zstj",
        zhjwy3: [
            "f11cr0be",
            "f1byw159"
        ]
    },
    "outline-informative": {
        sj55zd: "f11d4kpn",
        g2u3we: "f68mrw8",
        h3c5rm: [
            "f7pw515",
            "fw35ms5"
        ],
        B9xav0g: "frpde29",
        zhjwy3: [
            "fw35ms5",
            "f7pw515"
        ]
    },
    "outline-severe": {
        sj55zd: "f1l8vj45"
    },
    "outline-subtle": {
        sj55zd: "fonrgv7"
    },
    "outline-success": {
        sj55zd: "f1m7fhi8",
        g2u3we: "f1mmhl11",
        h3c5rm: [
            "f1tjpp2f",
            "f1ocn5n7"
        ],
        B9xav0g: "f1gjv25d",
        zhjwy3: [
            "f1ocn5n7",
            "f1tjpp2f"
        ]
    },
    "outline-warning": {
        sj55zd: "fpti2h4"
    },
    tint: {},
    "tint-brand": {
        De3pzq: "f16xkysk",
        sj55zd: "faj9fo0",
        g2u3we: "f161y7kd",
        h3c5rm: [
            "f1c8dzaj",
            "f1sl6hi9"
        ],
        B9xav0g: "f1619yhw",
        zhjwy3: [
            "f1sl6hi9",
            "f1c8dzaj"
        ]
    },
    "tint-danger": {
        De3pzq: "ff0poqj",
        sj55zd: "f1hcrxcs",
        g2u3we: "f1oqjm8o",
        h3c5rm: [
            "fkgrb8g",
            "frb5wm0"
        ],
        B9xav0g: "f1iai1ph",
        zhjwy3: [
            "frb5wm0",
            "fkgrb8g"
        ]
    },
    "tint-important": {
        De3pzq: "f945g0u",
        sj55zd: "fr0bkrk",
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ]
    },
    "tint-informative": {
        De3pzq: "f1ctqxl6",
        sj55zd: "f11d4kpn",
        g2u3we: "f68mrw8",
        h3c5rm: [
            "f7pw515",
            "fw35ms5"
        ],
        B9xav0g: "frpde29",
        zhjwy3: [
            "fw35ms5",
            "f7pw515"
        ]
    },
    "tint-severe": {
        De3pzq: "f1xzsg4",
        sj55zd: "f1k5f75o",
        g2u3we: "fxy9dsj",
        h3c5rm: [
            "f54u6j2",
            "fcm23ze"
        ],
        B9xav0g: "f4vf0uq",
        zhjwy3: [
            "fcm23ze",
            "f54u6j2"
        ]
    },
    "tint-subtle": {
        De3pzq: "fxugw4r",
        sj55zd: "f11d4kpn",
        g2u3we: "f68mrw8",
        h3c5rm: [
            "f7pw515",
            "fw35ms5"
        ],
        B9xav0g: "frpde29",
        zhjwy3: [
            "fw35ms5",
            "f7pw515"
        ]
    },
    "tint-success": {
        De3pzq: "f2vsrz6",
        sj55zd: "ffmvakt",
        g2u3we: "fdmic9h",
        h3c5rm: [
            "f196y6m",
            "fetptd8"
        ],
        B9xav0g: "f1pev5xq",
        zhjwy3: [
            "fetptd8",
            "f196y6m"
        ]
    },
    "tint-warning": {
        De3pzq: "f10s6hli",
        sj55zd: "f42v8de",
        g2u3we: "fn9i3n",
        h3c5rm: [
            "f1aw8cx4",
            "f51if14"
        ],
        B9xav0g: "fvq8iai",
        zhjwy3: [
            "f51if14",
            "f1aw8cx4"
        ]
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fcpl73t{line-height:var(--lineHeightBase100);}",
        ".f16dn6v3{width:6px;}",
        ".f3mu39s{height:6px;}",
        ".f130uwy9{font-size:4px;}",
        ".fod1mrr{line-height:4px;}",
        ".f18p0k4z{min-width:unset;}",
        [
            ".f19jm9xf{padding:unset;}",
            {
                p: -1
            }
        ],
        ".fpd43o0{width:10px;}",
        ".f30q22z{height:10px;}",
        ".f1tccstq{font-size:6px;}",
        ".f1y3arg5{line-height:6px;}",
        [
            ".f19jm9xf{padding:unset;}",
            {
                p: -1
            }
        ],
        ".fq2vo04{min-width:16px;}",
        ".fd461yt{height:16px;}",
        [
            ".fupdldz{padding:0 calc(var(--spacingHorizontalXXS) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        ".f17fgpbq{min-width:24px;}",
        ".frvgh55{height:24px;}",
        [
            ".f1996nqw{padding:0 calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        ".fwbmr0d{min-width:32px;}",
        ".f1d2rq10{height:32px;}",
        [
            ".fty64o7{padding:0 calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        [
            ".f1fabniw{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".fq9zq91{border-radius:var(--borderRadiusSmall);}",
            {
                p: -1
            }
        ],
        ".f10ludwy::after{display:none;}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".fdl5y0r{background-color:var(--colorPaletteRedBackground3);}",
        ".f1c73kur{background-color:var(--colorNeutralForeground1);}",
        ".fr0bkrk{color:var(--colorNeutralBackground1);}",
        ".f3vzo32{background-color:var(--colorNeutralBackground5);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f1s438gw{background-color:var(--colorPaletteDarkOrangeBackground3);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".flxk52p{background-color:var(--colorPaletteGreenBackground3);}",
        ".ffq97bm{background-color:var(--colorPaletteYellowBackground3);}",
        ".ff5vbop{color:var(--colorNeutralForeground1Static);}",
        ".f16muhyy{color:var(--colorBrandForeground1);}",
        ".f1whyuy6{color:var(--colorPaletteRedForeground3);}",
        ".f1l8vj45{color:var(--colorPaletteDarkOrangeForeground3);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".f1m7fhi8{color:var(--colorPaletteGreenForeground3);}",
        ".fpti2h4{color:var(--colorPaletteYellowForeground2);}",
        ".f23ftbb{border-top-color:currentColor;}",
        ".f1gkuv52{border-right-color:currentColor;}",
        ".f1p1bl80{border-left-color:currentColor;}",
        ".fioka3i{border-bottom-color:currentColor;}",
        ".fyqpifd{border-top-color:var(--colorPaletteRedBorder2);}",
        ".f3ukxca{border-right-color:var(--colorPaletteRedBorder2);}",
        ".f1k7dugc{border-left-color:var(--colorPaletteRedBorder2);}",
        ".f1njxb2b{border-bottom-color:var(--colorPaletteRedBorder2);}",
        ".fq0vr37{border-top-color:var(--colorNeutralStrokeAccessible);}",
        ".f1byw159{border-right-color:var(--colorNeutralStrokeAccessible);}",
        ".f11cr0be{border-left-color:var(--colorNeutralStrokeAccessible);}",
        ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        ".f68mrw8{border-top-color:var(--colorNeutralStroke2);}",
        ".f7pw515{border-right-color:var(--colorNeutralStroke2);}",
        ".fw35ms5{border-left-color:var(--colorNeutralStroke2);}",
        ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}",
        ".f1mmhl11{border-top-color:var(--colorPaletteGreenBorder2);}",
        ".f1tjpp2f{border-right-color:var(--colorPaletteGreenBorder2);}",
        ".f1ocn5n7{border-left-color:var(--colorPaletteGreenBorder2);}",
        ".f1gjv25d{border-bottom-color:var(--colorPaletteGreenBorder2);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        ".faj9fo0{color:var(--colorBrandForeground2);}",
        ".f161y7kd{border-top-color:var(--colorBrandStroke2);}",
        ".f1c8dzaj{border-right-color:var(--colorBrandStroke2);}",
        ".f1sl6hi9{border-left-color:var(--colorBrandStroke2);}",
        ".f1619yhw{border-bottom-color:var(--colorBrandStroke2);}",
        ".ff0poqj{background-color:var(--colorPaletteRedBackground1);}",
        ".f1hcrxcs{color:var(--colorPaletteRedForeground1);}",
        ".f1oqjm8o{border-top-color:var(--colorPaletteRedBorder1);}",
        ".fkgrb8g{border-right-color:var(--colorPaletteRedBorder1);}",
        ".frb5wm0{border-left-color:var(--colorPaletteRedBorder1);}",
        ".f1iai1ph{border-bottom-color:var(--colorPaletteRedBorder1);}",
        ".f945g0u{background-color:var(--colorNeutralForeground3);}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".f1ctqxl6{background-color:var(--colorNeutralBackground4);}",
        ".f1xzsg4{background-color:var(--colorPaletteDarkOrangeBackground1);}",
        ".f1k5f75o{color:var(--colorPaletteDarkOrangeForeground1);}",
        ".fxy9dsj{border-top-color:var(--colorPaletteDarkOrangeBorder1);}",
        ".f54u6j2{border-right-color:var(--colorPaletteDarkOrangeBorder1);}",
        ".fcm23ze{border-left-color:var(--colorPaletteDarkOrangeBorder1);}",
        ".f4vf0uq{border-bottom-color:var(--colorPaletteDarkOrangeBorder1);}",
        ".f2vsrz6{background-color:var(--colorPaletteGreenBackground1);}",
        ".ffmvakt{color:var(--colorPaletteGreenForeground1);}",
        ".fdmic9h{border-top-color:var(--colorPaletteGreenBorder1);}",
        ".f196y6m{border-right-color:var(--colorPaletteGreenBorder1);}",
        ".fetptd8{border-left-color:var(--colorPaletteGreenBorder1);}",
        ".f1pev5xq{border-bottom-color:var(--colorPaletteGreenBorder1);}",
        ".f10s6hli{background-color:var(--colorPaletteYellowBackground1);}",
        ".f42v8de{color:var(--colorPaletteYellowForeground1);}",
        ".fn9i3n{border-top-color:var(--colorPaletteYellowBorder1);}",
        ".f1aw8cx4{border-right-color:var(--colorPaletteYellowBorder1);}",
        ".f51if14{border-left-color:var(--colorPaletteYellowBorder1);}",
        ".fvq8iai{border-bottom-color:var(--colorPaletteYellowBorder1);}"
    ]
});
const $09a60c0c323f2773$var$useIconRootClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rttl5z0", null, [
    ".rttl5z0{display:flex;line-height:1;margin:0 calc(-1 * var(--spacingHorizontalXXS));font-size:12px;}"
]);
const $09a60c0c323f2773$var$useIconStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    beforeText: {
        t21cq0: [
            "f1t8l4o1",
            "f11juvx6"
        ]
    },
    afterText: {
        Frg6f3: [
            "f11juvx6",
            "f1t8l4o1"
        ]
    },
    beforeTextXL: {
        t21cq0: [
            "f1rs9grm",
            "f1kwmkpi"
        ]
    },
    afterTextXL: {
        Frg6f3: [
            "f1kwmkpi",
            "f1rs9grm"
        ]
    },
    tiny: {
        Be2twd7: "f1tccstq"
    },
    "extra-small": {
        Be2twd7: "fnmn6fi"
    },
    small: {
        Be2twd7: "f1ugzwwg"
    },
    medium: {},
    large: {
        Be2twd7: "f4ybsrx"
    },
    "extra-large": {
        Be2twd7: "fe5j1ua"
    }
}, {
    d: [
        ".f1t8l4o1{margin-right:calc(var(--spacingHorizontalXXS) + var(--spacingHorizontalXXS));}",
        ".f11juvx6{margin-left:calc(var(--spacingHorizontalXXS) + var(--spacingHorizontalXXS));}",
        ".f1rs9grm{margin-right:calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));}",
        ".f1kwmkpi{margin-left:calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));}",
        ".f1tccstq{font-size:6px;}",
        ".fnmn6fi{font-size:10px;}",
        ".f1ugzwwg{font-size:12px;}",
        ".f4ybsrx{font-size:16px;}",
        ".fe5j1ua{font-size:20px;}"
    ]
});
const $09a60c0c323f2773$export$1edbb628d2e17616 = (state)=>{
    const rootClassName = $09a60c0c323f2773$var$useRootClassName();
    const rootStyles = $09a60c0c323f2773$var$useRootStyles();
    const smallToTiny = state.size === 'small' || state.size === 'extra-small' || state.size === 'tiny';
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($09a60c0c323f2773$export$3b209f953c0ecbad.root, rootClassName, smallToTiny && rootStyles.fontSmallToTiny, rootStyles[state.size], rootStyles[state.shape], state.shape === 'rounded' && smallToTiny && rootStyles.roundedSmallToTiny, state.appearance === 'ghost' && rootStyles.borderGhost, rootStyles[state.appearance], rootStyles[`${state.appearance}-${state.color}`], state.root.className);
    const iconRootClassName = $09a60c0c323f2773$var$useIconRootClassName();
    const iconStyles = $09a60c0c323f2773$var$useIconStyles();
    if (state.icon) {
        let iconPositionClass;
        // Handle the edge case where children is 0 (a falsy value that should still render text and have margin)
        if ($acw62.Children.toArray(state.root.children).length > 0) {
            if (state.size === 'extra-large') iconPositionClass = state.iconPosition === 'after' ? iconStyles.afterTextXL : iconStyles.beforeTextXL;
            else iconPositionClass = state.iconPosition === 'after' ? iconStyles.afterText : iconStyles.beforeText;
        }
        // eslint-disable-next-line react-hooks/immutability
        state.icon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($09a60c0c323f2773$export$3b209f953c0ecbad.icon, iconRootClassName, iconPositionClass, iconStyles[state.size], state.icon.className);
    }
    return state;
};





const $92ebd6e2d9285e1a$export$29a61d2f0c4be9e = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.iconPosition === 'before' && state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            state.root.children,
            state.iconPosition === 'after' && state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {})
        ]
    });
};


'use client';
const $70f11c27d39d4df1$export$37acb3580601e69a = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $7892eaa0711e2be0$export$1c4bfbcf3850ba52)(props, ref);
    (0, $09a60c0c323f2773$export$1edbb628d2e17616)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useBadgeStyles_unstable')(state);
    return (0, $92ebd6e2d9285e1a$export$29a61d2f0c4be9e)(state);
});
$70f11c27d39d4df1$export$37acb3580601e69a.displayName = 'Badge';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $9521bdea52bd87ae$export$adc464bf5eb3c05c(setTimer, cancelTimer) {
    const id = $acw62.useRef(undefined);
    const set = $acw62.useCallback((fn, delay)=>{
        if (id.current !== undefined) cancelTimer(id.current);
        id.current = setTimer(fn, delay);
        return id.current;
    }, [
        cancelTimer,
        setTimer
    ]);
    const cancel = $acw62.useCallback(()=>{
        if (id.current !== undefined) {
            cancelTimer(id.current);
            id.current = undefined;
        }
    }, [
        cancelTimer
    ]);
    // Clean up the timeout when the component is unloaded
    $acw62.useEffect(()=>cancel, [
        cancel
    ]);
    return [
        set,
        cancel
    ];
}



'use client';
const $bf7615d1d68d35d9$var$setTimeoutNoop = (_callback)=>-1;
const $bf7615d1d68d35d9$var$clearTimeoutNoop = (_handle)=>undefined;
function $bf7615d1d68d35d9$export$d8e6abf214c9ec0f() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const setTimerFn = win ? win.setTimeout : $bf7615d1d68d35d9$var$setTimeoutNoop;
    const clearTimerFn = win ? win.clearTimeout : $bf7615d1d68d35d9$var$clearTimeoutNoop;
    return (0, $9521bdea52bd87ae$export$adc464bf5eb3c05c)(setTimerFn, clearTimerFn);
}


var $acw62 = parcelRequire("acw62");

'use client';
const $7d6a37de2d9c3d24$export$ee5b5d04074a389e = (fn)=>{
    const callbackRef = $acw62.useRef(()=>{
        throw new Error('Cannot call an event handler while rendering');
    });
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        callbackRef.current = fn;
    }, [
        fn
    ]);
    return $acw62.useCallback((...args)=>{
        const callback = callbackRef.current;
        return callback(...args);
    }, [
        callbackRef
    ]);
};


var $acw62 = parcelRequire("acw62");


'use client';
const $090a6633426263f1$var$DEFAULT_CONTAINS = (parent, child)=>!!(parent === null || parent === void 0 ? void 0 : parent.contains(child));
const $090a6633426263f1$export$9afc64c180e82dc4 = (options)=>{
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const { refs: refs, callback: callback, element: element, disabled: disabled, disabledFocusOnIframe: disabledFocusOnIframe, contains: contains = $090a6633426263f1$var$DEFAULT_CONTAINS } = options;
    const timeoutId = $acw62.useRef(undefined);
    $090a6633426263f1$var$useIFrameFocus({
        element: element,
        disabled: disabledFocusOnIframe || disabled,
        callback: callback,
        refs: refs,
        contains: contains
    });
    const isMouseDownInsideRef = $acw62.useRef(false);
    const listener = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        if (isMouseDownInsideRef.current) {
            isMouseDownInsideRef.current = false;
            return;
        }
        const target = ev.composedPath()[0];
        const isOutside = refs.every((ref)=>!contains(ref.current || null, target));
        if (isOutside && !disabled) callback(ev);
    });
    const handleMouseDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        // Selecting text from inside to outside will rigger click event.
        // In this case click event target is outside but mouse down event target is inside.
        // And this click event should be considered as inside click.
        isMouseDownInsideRef.current = refs.some((ref)=>contains(ref.current || null, ev.target));
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        // Store the current event to avoid triggering handlers immediately
        // Note this depends on a deprecated but extremely well supported quirk of the web platform
        // https://github.com/facebook/react/issues/20074
        let currentEvent = $090a6633426263f1$var$getWindowEvent(win);
        const conditionalHandler = (event)=>{
            // Skip if this event is the same as the one running when we added the handlers
            if (event === currentEvent) {
                currentEvent = undefined;
                return;
            }
            listener(event);
        };
        // use capture phase because React can update DOM before the event bubbles to the document
        element === null || element === void 0 || element.addEventListener('click', conditionalHandler, true);
        element === null || element === void 0 || element.addEventListener('touchstart', conditionalHandler, true);
        element === null || element === void 0 || element.addEventListener('contextmenu', conditionalHandler, true);
        element === null || element === void 0 || element.addEventListener('mousedown', handleMouseDown, true);
        // Garbage collect this event after it's no longer useful to avoid memory leaks
        timeoutId.current = win === null || win === void 0 ? void 0 : win.setTimeout(()=>{
            currentEvent = undefined;
        }, 1);
        return ()=>{
            element === null || element === void 0 || element.removeEventListener('click', conditionalHandler, true);
            element === null || element === void 0 || element.removeEventListener('touchstart', conditionalHandler, true);
            element === null || element === void 0 || element.removeEventListener('contextmenu', conditionalHandler, true);
            element === null || element === void 0 || element.removeEventListener('mousedown', handleMouseDown, true);
            win === null || win === void 0 || win.clearTimeout(timeoutId.current);
            currentEvent = undefined;
        };
    }, [
        listener,
        element,
        disabled,
        handleMouseDown,
        win
    ]);
};
const $090a6633426263f1$var$getWindowEvent = (target)=>{
    if (target) {
        var _target_ownerDocument_defaultView, _target_ownerDocument;
        if (typeof target.window === 'object' && target.window === target) // eslint-disable-next-line @typescript-eslint/no-deprecated
        return target.event;
        var _target_ownerDocument_defaultView_event;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        return (_target_ownerDocument_defaultView_event = (_target_ownerDocument = target.ownerDocument) === null || _target_ownerDocument === void 0 ? void 0 : (_target_ownerDocument_defaultView = _target_ownerDocument.defaultView) === null || _target_ownerDocument_defaultView === void 0 ? void 0 : _target_ownerDocument_defaultView.event) !== null && _target_ownerDocument_defaultView_event !== void 0 ? _target_ownerDocument_defaultView_event : undefined;
    }
    return undefined;
};
const $090a6633426263f1$var$FUI_FRAME_EVENT = 'fuiframefocus';
/**
 * Since click events do not propagate past iframes, we use focus to detect if a
 * click has happened inside an iframe, since the only ways of focusing inside an
 * iframe are:
 *   - clicking inside
 *   - tabbing inside
 *
 * Polls the value of `document.activeElement`. If it is an iframe, then dispatch
 * a custom DOM event. When the custom event is received call the provided callback
 */ const $090a6633426263f1$var$useIFrameFocus = (options)=>{
    const { disabled: disabled, element: targetDocument, callback: callback, contains: contains = $090a6633426263f1$var$DEFAULT_CONTAINS, pollDuration: pollDuration = 100, refs: refs } = options;
    const timeoutRef = $acw62.useRef(undefined);
    const listener = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        const isOutside = refs.every((ref)=>!contains(ref.current || null, e.target));
        if (isOutside && !disabled) callback(e);
    });
    // Adds listener to the custom iframe focus event
    $acw62.useEffect(()=>{
        if (disabled) return;
        targetDocument === null || targetDocument === void 0 || targetDocument.addEventListener($090a6633426263f1$var$FUI_FRAME_EVENT, listener, true);
        return ()=>{
            targetDocument === null || targetDocument === void 0 || targetDocument.removeEventListener($090a6633426263f1$var$FUI_FRAME_EVENT, listener, true);
        };
    }, [
        targetDocument,
        disabled,
        listener
    ]);
    // Starts polling for the active element
    $acw62.useEffect(()=>{
        var _targetDocument_defaultView;
        if (disabled) return;
        timeoutRef.current = targetDocument === null || targetDocument === void 0 ? void 0 : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.setInterval(()=>{
            const activeElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.activeElement;
            if ((activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) === 'IFRAME' || (activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) === 'WEBVIEW') {
                const event = new CustomEvent($090a6633426263f1$var$FUI_FRAME_EVENT, {
                    bubbles: true
                });
                activeElement.dispatchEvent(event);
            }
        }, pollDuration);
        return ()=>{
            var _targetDocument_defaultView;
            targetDocument === null || targetDocument === void 0 || (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 || _targetDocument_defaultView.clearInterval(timeoutRef.current);
        };
    }, [
        targetDocument,
        disabled,
        pollDuration
    ]);
};

/**
 * Determines whether or not an element has the virtual hierarchy extension.
 * @internal
 */ function $cd9f9b76846385e4$export$405b1af69064399d(element) {
    return element && !!element._virtual;
}


/**
 * Gets the virtual parent given the child element, if it exists.
 * @internal
 */ function $a84b79cd75c90fa5$var$getVirtualParent(child) {
    return (0, $cd9f9b76846385e4$export$405b1af69064399d)(child) ? child._virtual.parent || null : null;
}
function $a84b79cd75c90fa5$export$58081aedf094d85b(child, options = {}) {
    if (!child) return null;
    if (!options.skipVirtual) {
        const virtualParent = $a84b79cd75c90fa5$var$getVirtualParent(child);
        if (virtualParent) return virtualParent;
    }
    const parent = child.parentNode;
    // Node.DOCUMENT_FRAGMENT_NODE = 11
    if (parent && parent.nodeType === 11) return parent.host;
    return parent;
}


function $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd(parent, child) {
    if (!parent || !child) return false;
    if (parent === child) return true;
    else {
        // Tracks references of nodes that have been visited to prevent infinite loops
        const set = new WeakSet();
        while(child){
            const nextParent = (0, $a84b79cd75c90fa5$export$58081aedf094d85b)(child, {
                skipVirtual: set.has(child)
            });
            set.add(child);
            if (nextParent === parent) return true;
            child = nextParent;
        }
    }
    return false;
}


var $acw62 = parcelRequire("acw62");

'use client';
const $8748bb6e2a770b32$export$ee62ea5c36ea709a = (options)=>{
    const { refs: refs, callback: callback, element: element, disabled: disabled, contains: containsProp } = options;
    const listener = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        const contains = containsProp || ((parent, child)=>!!(parent === null || parent === void 0 ? void 0 : parent.contains(child)));
        const target = ev.composedPath()[0];
        const isOutside = refs.every((ref)=>!contains(ref.current || null, target));
        if (isOutside && !disabled) callback(ev);
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        element === null || element === void 0 || element.addEventListener('wheel', listener);
        element === null || element === void 0 || element.addEventListener('touchmove', listener);
        return ()=>{
            element === null || element === void 0 || element.removeEventListener('wheel', listener);
            element === null || element === void 0 || element.removeEventListener('touchmove', listener);
        };
    }, [
        listener,
        element,
        disabled
    ]);
};


var $acw62 = parcelRequire("acw62");
'use client';
function $18a7d7467c2b10b3$var$isFactoryDispatch(newState) {
    return typeof newState === 'function';
}
const $18a7d7467c2b10b3$export$6f32135080cb4c3 = (options)=>{
    'use no memo'; // justified: compiler would optimize useControllableState — manual opt-out to preserve runtime behavior
    const [internalState, setInternalState] = $acw62.useState(()=>{
        if (options.defaultState === undefined) return options.initialState;
        return $18a7d7467c2b10b3$var$isInitializer(options.defaultState) ? options.defaultState() : options.defaultState;
    });
    // Heads up!
    // This part is specific for controlled mode and mocks behavior of React dispatcher function.
    const stateValueRef = $acw62.useRef(options.state);
    $acw62.useEffect(()=>{
        stateValueRef.current = options.state;
    }, [
        options.state
    ]);
    const setControlledState = $acw62.useCallback((newState)=>{
        if ($18a7d7467c2b10b3$var$isFactoryDispatch(newState)) newState(stateValueRef.current);
    }, []);
    return $18a7d7467c2b10b3$var$useIsControlled(options.state) ? [
        options.state,
        setControlledState
    ] : [
        internalState,
        setInternalState
    ];
};
function $18a7d7467c2b10b3$var$isInitializer(value) {
    return typeof value === 'function';
}
/**
 * Helper hook to handle previous comparison of controlled/uncontrolled
 * Prints an error when isControlled value switches between subsequent renders
 * @returns - whether the value is controlled
 */ const $18a7d7467c2b10b3$var$useIsControlled = (controlledValue)=>{
    const [isControlled] = $acw62.useState(()=>controlledValue !== undefined);
    return isControlled;
};




var $acw62 = parcelRequire("acw62");
/**
 * Creates a virtual element based on the position of a click event
 * Can be used as a target for popper in scenarios such as context menus
 */ function $6f0b845df0e5db1c$export$f818735569cff5ae(nativeEvent) {
    const left = nativeEvent.clientX;
    const top = nativeEvent.clientY;
    const right = left + 1;
    const bottom = top + 1;
    function getBoundingClientRect() {
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom,
            x: left,
            y: top,
            height: 1,
            width: 1
        };
    }
    return {
        getBoundingClientRect: getBoundingClientRect
    };
}


'use client';
const $638f597d0f0765e2$export$5f3472545b83f7fe = (initialState)=>{
    const [virtualElement, setVirtualElement] = $acw62.useState(initialState);
    const setVirtualMouseTarget = (event)=>{
        if (event === undefined || event === null) {
            setVirtualElement(undefined);
            return;
        }
        let mouseevent;
        if (!(event instanceof MouseEvent)) mouseevent = event.nativeEvent;
        else mouseevent = event;
        MouseEvent;
        const contextTarget = (0, $6f0b845df0e5db1c$export$f818735569cff5ae)(mouseevent);
        setVirtualElement(contextTarget);
    };
    return [
        virtualElement,
        setVirtualMouseTarget
    ];
};

// Look up table for shorthand to avoid parsing strings
const $ab5990c77a5c99b2$var$shorthandLookup = {
    above: {
        position: 'above',
        align: 'center'
    },
    'above-start': {
        position: 'above',
        align: 'start'
    },
    'above-end': {
        position: 'above',
        align: 'end'
    },
    below: {
        position: 'below',
        align: 'center'
    },
    'below-start': {
        position: 'below',
        align: 'start'
    },
    'below-end': {
        position: 'below',
        align: 'end'
    },
    before: {
        position: 'before',
        align: 'center'
    },
    'before-top': {
        position: 'before',
        align: 'top'
    },
    'before-bottom': {
        position: 'before',
        align: 'bottom'
    },
    after: {
        position: 'after',
        align: 'center'
    },
    'after-top': {
        position: 'after',
        align: 'top'
    },
    'after-bottom': {
        position: 'after',
        align: 'bottom'
    }
};
function $ab5990c77a5c99b2$export$c06895f23267d8a3(shorthand) {
    if (shorthand === undefined || shorthand === null) return {};
    if (typeof shorthand === 'string') return $ab5990c77a5c99b2$var$shorthandLookup[shorthand];
    return shorthand;
}


var $acw62 = parcelRequire("acw62");

const $1bc41beff6061826$export$18f93cc75fae324c = 'data-popper-is-intersecting';
const $1bc41beff6061826$export$db3793a183377cb7 = 'data-popper-escaped';
const $1bc41beff6061826$export$63274a89f08cfb16 = 'data-popper-reference-hidden';
const $1bc41beff6061826$export$b301c2866e7d3d24 = 'data-popper-placement';
const $1bc41beff6061826$export$f663401a4492542c = 'fui-positioningend';
const $1bc41beff6061826$export$d8cee2f3784ae17a = '--fui-positioning-slide-direction-x';
const $1bc41beff6061826$export$9cbb0ef067e89ae6 = '--fui-positioning-slide-direction-y';


'use client';
const $a9f840906894d8a8$var$registeredProperties = new WeakMap();
const $a9f840906894d8a8$var$slideDirectionProperties = [
    (0, $1bc41beff6061826$export$d8cee2f3784ae17a),
    (0, $1bc41beff6061826$export$9cbb0ef067e89ae6)
];
function $a9f840906894d8a8$export$38e73b6ffbca39a6(placement) {
    const side = placement.split('-')[0];
    // Default to sliding down from the top side
    let x = 0;
    let y = 1;
    if (side === 'right') {
        x = -1;
        y = 0;
    } else if (side === 'bottom') {
        x = 0;
        y = -1;
    } else if (side === 'left') {
        x = 1;
        y = 0;
    }
    return {
        x: x,
        y: y
    };
}
function $a9f840906894d8a8$export$8ac94e7c1d8a7c08(options) {
    const { targetDocument: targetDocument, onPositioningEnd: onPositioningEnd } = options;
    const handlePositionEnd = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        onPositioningEnd === null || onPositioningEnd === void 0 || onPositioningEnd(e);
        const element = e.target;
        const placement = e.detail.placement;
        if (!(0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(element)) return;
        const { x: x, y: y } = $a9f840906894d8a8$export$38e73b6ffbca39a6(placement);
        element.style.setProperty((0, $1bc41beff6061826$export$d8cee2f3784ae17a), `${x}px`);
        element.style.setProperty((0, $1bc41beff6061826$export$9cbb0ef067e89ae6), `${y}px`);
    });
    $acw62.useEffect(()=>{
        var _targetDocument_defaultView;
        const css = targetDocument === null || targetDocument === void 0 ? void 0 : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.CSS;
        if (!targetDocument || !(css === null || css === void 0 ? void 0 : css.registerProperty)) return;
        let properties = $a9f840906894d8a8$var$registeredProperties.get(targetDocument);
        if (!properties) {
            properties = new Set();
            $a9f840906894d8a8$var$registeredProperties.set(targetDocument, properties);
        }
        for (const name of $a9f840906894d8a8$var$slideDirectionProperties){
            if (properties.has(name)) continue;
            try {
                css.registerProperty({
                    name: name,
                    syntax: '<length>',
                    inherits: false,
                    initialValue: '0px'
                });
                properties.add(name);
            } catch (error) {
                if (error && typeof error === 'object' && 'name' in error && error.name === 'InvalidModificationError') properties.add(name);
            }
        }
    }, [
        targetDocument
    ]);
    return handlePositionEnd;
}

'use client';
function $4f638fdc3c53bf8c$export$fef5d4d23735b493(userOffset, arrowHeight) {
    if (typeof userOffset === 'number') return $4f638fdc3c53bf8c$var$addArrowOffset(userOffset, arrowHeight);
    if (typeof userOffset === 'object' && userOffset !== null) return $4f638fdc3c53bf8c$var$addArrowOffset(userOffset, arrowHeight);
    if (typeof userOffset === 'function') return (offsetParams)=>{
        const offset = userOffset(offsetParams);
        return $4f638fdc3c53bf8c$var$addArrowOffset(offset, arrowHeight);
    };
    return {
        mainAxis: arrowHeight
    };
}
const $4f638fdc3c53bf8c$var$addArrowOffset = (offset, arrowHeight)=>{
    if (typeof offset === 'number') return {
        mainAxis: offset + arrowHeight
    };
    var _offset_mainAxis;
    return {
        ...offset,
        mainAxis: ((_offset_mainAxis = offset.mainAxis) !== null && _offset_mainAxis !== void 0 ? _offset_mainAxis : 0) + arrowHeight
    };
};



var $acw62 = parcelRequire("acw62");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $204931a4986f463b$var$lrPlacement = [
    'left',
    'right'
];
const $204931a4986f463b$var$rlPlacement = [
    'right',
    'left'
];
const $204931a4986f463b$var$tbPlacement = [
    'top',
    'bottom'
];
const $204931a4986f463b$var$btPlacement = [
    'bottom',
    'top'
];
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $204931a4986f463b$var$rlPlacement : $204931a4986f463b$var$lrPlacement;
            return isStart ? $204931a4986f463b$var$lrPlacement : $204931a4986f463b$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $204931a4986f463b$var$tbPlacement : $204931a4986f463b$var$btPlacement;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    const side = $204931a4986f463b$export$3c915306cb7fc97a(placement);
    return $204931a4986f463b$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $9dccb9a8753b0e86$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $9dccb9a8753b0e86$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $9dccb9a8753b0e86$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $204931a4986f463b$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $204931a4986f463b$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9dccb9a8753b0e86$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $9dccb9a8753b0e86$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9dccb9a8753b0e86$var$originSides.has((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $204931a4986f463b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $204931a4986f463b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c51400d9a81fca36$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    if (!$c51400d9a81fca36$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $c51400d9a81fca36$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $c51400d9a81fca36$var$containRe = /paint|layout|strict|content/;
const $c51400d9a81fca36$var$isNotNone = (value)=>!!value && value !== 'none';
let $c51400d9a81fca36$var$isWebKitValue;
function $c51400d9a81fca36$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $c51400d9a81fca36$export$45a5e7f76e0caa8d(elementOrCss) ? $c51400d9a81fca36$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $c51400d9a81fca36$var$isNotNone(css.transform) || $c51400d9a81fca36$var$isNotNone(css.translate) || $c51400d9a81fca36$var$isNotNone(css.scale) || $c51400d9a81fca36$var$isNotNone(css.rotate) || $c51400d9a81fca36$var$isNotNone(css.perspective) || !$c51400d9a81fca36$export$78551043582a6a98() && ($c51400d9a81fca36$var$isNotNone(css.backdropFilter) || $c51400d9a81fca36$var$isNotNone(css.filter)) || $c51400d9a81fca36$var$willChangeRe.test(css.willChange || '') || $c51400d9a81fca36$var$containRe.test(css.contain || '');
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c51400d9a81fca36$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if ($c51400d9a81fca36$var$isWebKitValue == null) $c51400d9a81fca36$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $c51400d9a81fca36$var$isWebKitValue;
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c51400d9a81fca36$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c51400d9a81fca36$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bede215d88ec3aee$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $bede215d88ec3aee$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(html) {
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $bede215d88ec3aee$var$SCROLLBAR_MAX = 25;
function $bede215d88ec3aee$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $c51400d9a81fca36$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $bede215d88ec3aee$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $bede215d88ec3aee$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $bede215d88ec3aee$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $bede215d88ec3aee$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, top);
        right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'static';
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c51400d9a81fca36$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ((0, $c51400d9a81fca36$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === 'rtl';
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
function $bede215d88ec3aee$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$bede215d88ec3aee$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && !$bede215d88ec3aee$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$bede215d88ec3aee$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



/**
 * Promise microtask debouncer used by Popper.js v2
 * This is no longer exported in Floating UI (Popper.js v3)
 * https://github.com/floating-ui/floating-ui/blob/v2.x/src/utils/debounce.js
 * @param fn function that will be debounced
 */ function $bcc8133f5ab99157$export$61fc7d43ac8f84b0(fn) {
    let pending;
    return ()=>{
        if (!pending) pending = new Promise((resolve)=>{
            Promise.resolve().then(()=>{
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

/**
 * Writes all DOM element updates after position is computed
 */ function $7a07c92faae73d90$export$711a2b3ae6af6e60(options) {
    const { arrow: arrow, middlewareData: middlewareData } = options;
    if (!middlewareData.arrow || !arrow) return;
    const { x: arrowX, y: arrowY } = middlewareData.arrow;
    Object.assign(arrow.style, {
        left: arrowX !== null && arrowX !== undefined ? `${arrowX}px` : '',
        top: arrowY !== null && arrowY !== undefined ? `${arrowY}px` : ''
    });
}


function $ec7dd1615eef7a1d$export$d75dade18d09f343(options) {
    var _middlewareData_hide, _middlewareData_hide1, _container_ownerDocument_defaultView;
    const { container: container, placement: placement, middlewareData: middlewareData, strategy: strategy, lowPPI: lowPPI, coordinates: coordinates, useTransform: useTransform = true } = options;
    if (!container) return;
    container.setAttribute((0, $1bc41beff6061826$export$b301c2866e7d3d24), placement);
    container.removeAttribute((0, $1bc41beff6061826$export$18f93cc75fae324c));
    if (middlewareData.intersectionObserver.intersecting) container.setAttribute((0, $1bc41beff6061826$export$18f93cc75fae324c), '');
    container.removeAttribute((0, $1bc41beff6061826$export$db3793a183377cb7));
    if ((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.escaped) container.setAttribute((0, $1bc41beff6061826$export$db3793a183377cb7), '');
    container.removeAttribute((0, $1bc41beff6061826$export$63274a89f08cfb16));
    if ((_middlewareData_hide1 = middlewareData.hide) === null || _middlewareData_hide1 === void 0 ? void 0 : _middlewareData_hide1.referenceHidden) container.setAttribute((0, $1bc41beff6061826$export$63274a89f08cfb16), '');
    // Round so that the coordinates land on device pixels.
    // This prevents blurriness in cases where the browser doesn't apply pixel snapping, such as when other effects like
    // `backdrop-filter: blur()` are applied to the container, and the browser is zoomed in.
    // See https://github.com/microsoft/fluentui/issues/26764 for more info.
    const devicePixelRatio = ((_container_ownerDocument_defaultView = container.ownerDocument.defaultView) === null || _container_ownerDocument_defaultView === void 0 ? void 0 : _container_ownerDocument_defaultView.devicePixelRatio) || 1;
    const x = Math.round(coordinates.x * devicePixelRatio) / devicePixelRatio;
    const y = Math.round(coordinates.y * devicePixelRatio) / devicePixelRatio;
    Object.assign(container.style, {
        position: strategy
    });
    if (useTransform) {
        Object.assign(container.style, {
            transform: lowPPI ? `translate(${x}px, ${y}px)` : `translate3d(${x}px, ${y}px, 0)`
        });
        return;
    }
    Object.assign(container.style, {
        left: `${x}px`,
        top: `${y}px`
    });
}


/**
 * Returns the parent node or the host of the node argument.
 * @param node - DOM node.
 * @returns - parent DOM node.
 */ 'use client';
const $e515cff1a47b86b6$export$4e12058fc4d51d56 = (node)=>{
    if (node.nodeName === 'HTML') return node;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return node.parentNode || node.host;
};
const $e515cff1a47b86b6$export$e1697824cae8c971 = (node)=>{
    var _node_ownerDocument;
    if (node.nodeType !== 1) return {};
    const targetWindow = (_node_ownerDocument = node.ownerDocument) === null || _node_ownerDocument === void 0 ? void 0 : _node_ownerDocument.defaultView;
    if (targetWindow) return targetWindow.getComputedStyle(node, null);
    return {};
};
const $e515cff1a47b86b6$export$cfa2225e87938781 = (node)=>{
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    const parentNode = node && $e515cff1a47b86b6$export$4e12058fc4d51d56(node);
    // eslint-disable-next-line
    if (!parentNode) return document.body;
    switch(parentNode.nodeName){
        case 'HTML':
        case 'BODY':
            return parentNode.ownerDocument.body;
        case '#document':
            return parentNode.body;
    }
    // If any of the overflow props is defined for the node then we return it as the parent
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = $e515cff1a47b86b6$export$e1697824cae8c971(parentNode);
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return parentNode;
    return $e515cff1a47b86b6$export$cfa2225e87938781(parentNode);
};
const $e515cff1a47b86b6$export$4cb81e0871943e44 = (node)=>{
    var _scrollParentElement_ownerDocument;
    const scrollParentElement = $e515cff1a47b86b6$export$cfa2225e87938781(node);
    return scrollParentElement ? scrollParentElement !== ((_scrollParentElement_ownerDocument = scrollParentElement.ownerDocument) === null || _scrollParentElement_ownerDocument === void 0 ? void 0 : _scrollParentElement_ownerDocument.body) : false;
};


function $fd919ccf2ea75239$export$a3eb7ad9381d72(node) {
    const scrollParents = [];
    let cur = node;
    while(cur){
        const scrollParent = (0, $e515cff1a47b86b6$export$cfa2225e87938781)(cur);
        if (node.ownerDocument.body === scrollParent) {
            scrollParents.push(scrollParent);
            break;
        }
        if (scrollParent.nodeName === 'BODY' && scrollParent !== node.ownerDocument.body) break;
        scrollParents.push(scrollParent);
        cur = scrollParent;
    }
    return scrollParents;
}



function $6d24f1ed2c4b15f4$export$1c0b3b43c08b019d(targetWindow, callback) {
    return new targetWindow.ResizeObserver(callback);
}


function $10f45662864422ce$var$isLayoutViewportUnavailable(container) {
    const { clientWidth: clientWidth, clientHeight: clientHeight } = container.ownerDocument.documentElement;
    return clientWidth === 0 && clientHeight === 0;
}
function $10f45662864422ce$export$3b0153980f731a95(options) {
    let isDestroyed = false;
    const { container: container, target: target, arrow: arrow, strategy: strategy, middleware: middleware, placement: placement, useTransform: useTransform = true, disableUpdateOnResize: disableUpdateOnResize = false } = options;
    const targetWindow = container.ownerDocument.defaultView;
    if (!target || !container || !targetWindow) return {
        updatePosition: ()=>undefined,
        dispose: ()=>undefined
    };
    // When the dimensions of the target or the container change - trigger a position update
    const resizeObserver = disableUpdateOnResize ? null : (0, $6d24f1ed2c4b15f4$export$1c0b3b43c08b019d)(targetWindow, (entries)=>{
        // If content rect dimensions to go 0 -> very likely that `display: none` is being used to hide the element
        // In this case don't update and let users update imperatively
        const shouldUpdateOnResize = entries.every((entry)=>{
            return entry.contentRect.width > 0 && entry.contentRect.height > 0;
        });
        if (shouldUpdateOnResize) updatePosition();
    });
    let isFirstUpdate = true;
    const scrollParents = new Set();
    // When the container is first resolved, set position `fixed` to avoid scroll jumps.
    // Without this scroll jumps can occur when the element is rendered initially and receives focus
    Object.assign(container.style, {
        position: 'fixed',
        left: 0,
        top: 0,
        margin: 0
    });
    const forceUpdate = ()=>{
        // debounced update can still occur afterwards
        // early return to avoid memory leaks
        if (isDestroyed) return;
        if (isFirstUpdate) {
            (0, $fd919ccf2ea75239$export$a3eb7ad9381d72)(container).forEach((scrollParent)=>scrollParents.add(scrollParent));
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(target)) (0, $fd919ccf2ea75239$export$a3eb7ad9381d72)(target).forEach((scrollParent)=>scrollParents.add(scrollParent));
            scrollParents.forEach((scrollParent)=>{
                scrollParent.addEventListener('scroll', updatePosition, {
                    passive: true
                });
            });
            resizeObserver === null || resizeObserver === void 0 || resizeObserver.observe(container);
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(target)) resizeObserver === null || resizeObserver === void 0 || resizeObserver.observe(target);
            isFirstUpdate = false;
        }
        Object.assign(container.style, {
            position: strategy
        });
        (0, $bede215d88ec3aee$export$48a53dcb22e581d0)(target, container, {
            placement: placement,
            middleware: middleware,
            strategy: strategy
        }).then(({ x: x, y: y, middlewareData: middlewareData, placement: computedPlacement })=>{
            var _positioningMiddlewareData_hide, _positioningMiddlewareData_hide1;
            // Promise can still resolve after destruction
            // early return to avoid applying outdated position
            if (isDestroyed) return;
            const positioningMiddlewareData = $10f45662864422ce$var$isLayoutViewportUnavailable(container) ? {
                ...middlewareData,
                hide: {
                    ...middlewareData.hide,
                    escaped: false,
                    referenceHidden: false
                }
            } : middlewareData;
            (0, $7a07c92faae73d90$export$711a2b3ae6af6e60)({
                arrow: arrow,
                middlewareData: positioningMiddlewareData
            });
            (0, $ec7dd1615eef7a1d$export$d75dade18d09f343)({
                container: container,
                middlewareData: positioningMiddlewareData,
                placement: computedPlacement,
                coordinates: {
                    x: x,
                    y: y
                },
                lowPPI: ((targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.devicePixelRatio) || 1) <= 1,
                strategy: strategy,
                useTransform: useTransform
            });
            var _positioningMiddlewareData_hide_escaped, _positioningMiddlewareData_hide_referenceHidden;
            container.dispatchEvent(new CustomEvent((0, $1bc41beff6061826$export$f663401a4492542c), {
                detail: {
                    // Cast from Floating UI's Placement to the Fluent-owned PositioningPlacement.
                    // These are equivalent string unions; the cast avoids leaking @floating-ui/dom
                    // types into the public API surface.
                    placement: computedPlacement,
                    escaped: (_positioningMiddlewareData_hide_escaped = (_positioningMiddlewareData_hide = positioningMiddlewareData.hide) === null || _positioningMiddlewareData_hide === void 0 ? void 0 : _positioningMiddlewareData_hide.escaped) !== null && _positioningMiddlewareData_hide_escaped !== void 0 ? _positioningMiddlewareData_hide_escaped : false,
                    referenceHidden: (_positioningMiddlewareData_hide_referenceHidden = (_positioningMiddlewareData_hide1 = positioningMiddlewareData.hide) === null || _positioningMiddlewareData_hide1 === void 0 ? void 0 : _positioningMiddlewareData_hide1.referenceHidden) !== null && _positioningMiddlewareData_hide_referenceHidden !== void 0 ? _positioningMiddlewareData_hide_referenceHidden : false
                }
            }));
        }).catch((err)=>{});
    };
    const updatePosition = (0, $bcc8133f5ab99157$export$61fc7d43ac8f84b0)(()=>forceUpdate());
    const dispose = ()=>{
        isDestroyed = true;
        if (targetWindow) {
            targetWindow.removeEventListener('scroll', updatePosition);
            targetWindow.removeEventListener('resize', updatePosition);
        }
        scrollParents.forEach((scrollParent)=>{
            scrollParent.removeEventListener('scroll', updatePosition);
        });
        scrollParents.clear();
        resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
    };
    if (targetWindow) {
        targetWindow.addEventListener('scroll', updatePosition, {
            passive: true
        });
        targetWindow.addEventListener('resize', updatePosition);
    }
    // Update the position on initialization
    updatePosition();
    return {
        updatePosition: updatePosition,
        dispose: dispose
    };
}


/**
 * @internal
 */ const $4cfb19e78b5b89ef$var$CONTROLLER = '__FUIDT_CONTROLLER__';
/**
 * @internal
 */ const $4cfb19e78b5b89ef$var$ELEMENT_METADATA = '__FUIDT_ELEMENT_METADATA__';
/**
 * @internal
 */ const $4cfb19e78b5b89ef$var$HTML_ELEMENT_REFERENCE = '__FUIDT_HTML_ELEMENT_REFERENCE__';
/**
 * @internal
 */ const $4cfb19e78b5b89ef$var$SERIALIZED_DATA_CHANGE = '__FUIDT_SERIALIZED_DATA_CHANGE__';
/**
 * Verifies if a given node is an HTMLElement,
 * this method works seamlessly with frames and elements from different documents
 *
 * This is preferred over simply using `instanceof`.
 * Since `instanceof` might be problematic while operating with [multiple realms](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/instanceof#instanceof_and_multiple_realms)
 *
 * @example
 * ```ts
 * isHTMLElement(event.target) && event.target.focus()
 * isHTMLElement(event.target, {constructorName: 'HTMLInputElement'}) && event.target.value // some value
 * ```
 *
 */ function $4cfb19e78b5b89ef$var$isHTMLElement(element, options) {
    var _typedElement$ownerDo, _options$constructorN;
    const typedElement = element;
    return Boolean((typedElement == null || (_typedElement$ownerDo = typedElement.ownerDocument) == null ? void 0 : _typedElement$ownerDo.defaultView) && typedElement instanceof typedElement.ownerDocument.defaultView[_options$constructorN = void 0, 'HTMLElement']);
}
/**
 * @internal
 */ const $4cfb19e78b5b89ef$var$isHTMLElementWithMetadata = (element)=>Boolean($4cfb19e78b5b89ef$var$isHTMLElement(element) && $4cfb19e78b5b89ef$var$ELEMENT_METADATA in element && element.parentElement !== null);
const $4cfb19e78b5b89ef$var$createController = (defaultView)=>{
    let selectedElement = null;
    const observer = new MutationObserver((mutations)=>{
        if (!selectedElement) return;
        for (const mutation of mutations)if (mutation.type === 'childList' && Array.from(mutation.removedNodes).includes(selectedElement)) controller.withdraw();
    });
    const controller = {
        get selectedElement () {
            return selectedElement;
        },
        select: (nextSelectedElement)=>{
            if ($4cfb19e78b5b89ef$var$isHTMLElementWithMetadata(nextSelectedElement)) {
                selectedElement = nextSelectedElement;
                observer.observe(nextSelectedElement.parentElement, {
                    childList: true,
                    subtree: false
                });
            }
            if (selectedElement && nextSelectedElement) {
                const metadata = selectedElement[$4cfb19e78b5b89ef$var$ELEMENT_METADATA];
                if (metadata.references.has(nextSelectedElement)) return selectedElement;
            }
            controller.withdraw();
            return selectedElement;
        },
        withdraw: ()=>{
            selectedElement = null;
            observer.disconnect();
            defaultView.postMessage($4cfb19e78b5b89ef$var$SERIALIZED_DATA_CHANGE);
        }
    };
    return controller;
};
const $4cfb19e78b5b89ef$var$injectController = (_ref)=>{
    let { defaultView: defaultView } = _ref;
    if (!defaultView) return;
    if (!defaultView[$4cfb19e78b5b89ef$var$CONTROLLER]) defaultView[$4cfb19e78b5b89ef$var$CONTROLLER] = $4cfb19e78b5b89ef$var$createController(defaultView);
};
const $4cfb19e78b5b89ef$var$getController = (targetDocument)=>{
    var _targetDocument$defau, _targetDocument$defau2;
    $4cfb19e78b5b89ef$var$injectController(targetDocument);
    return (_targetDocument$defau = (_targetDocument$defau2 = targetDocument.defaultView) == null ? void 0 : _targetDocument$defau2[$4cfb19e78b5b89ef$var$CONTROLLER]) != null ? _targetDocument$defau : null;
};
const $4cfb19e78b5b89ef$var$serialize = (data, references)=>{
    const serializedData = JSON.parse(JSON.stringify(data, (_, value)=>{
        if ($4cfb19e78b5b89ef$var$isHTMLElement(value)) return references.add(value);
        if (typeof value === 'object' && value && Object.getPrototypeOf(value) !== Object.prototype && Object.getPrototypeOf(value) !== Array.prototype) {
            if ('toString' in value) return value.toString();
            return undefined;
        }
        return value;
    }));
    return serializedData;
};
let $4cfb19e78b5b89ef$var$counter = 0;
const $4cfb19e78b5b89ef$var$generateReferenceId = ()=>$4cfb19e78b5b89ef$var$HTML_ELEMENT_REFERENCE + ":" + $4cfb19e78b5b89ef$var$counter++;
const $4cfb19e78b5b89ef$var$createReferences = ()=>{
    const map = new Map();
    const weakMap = new WeakMap();
    const references = {
        add: (element)=>{
            if (weakMap.has(element)) return weakMap.get(element);
            const id = $4cfb19e78b5b89ef$var$generateReferenceId();
            map.set(id, element);
            weakMap.set(element, id);
            return id;
        },
        get: (id)=>{
            const element = map.get(id);
            if (element && weakMap.has(element)) return element;
        },
        has: (element)=>{
            return weakMap.has(element);
        }
    };
    return references;
};
/**
 * devtools middleware
 * @public
 */ const $4cfb19e78b5b89ef$export$6922d3b3a607469e = function(targetDocument, middlewareDataCallback) {
    if (targetDocument === void 0) targetDocument = document;
    if (middlewareDataCallback === void 0) middlewareDataCallback = $4cfb19e78b5b89ef$var$floatingUIMiddlewareDataCallback;
    return {
        name: '@floating-ui/devtools',
        fn: (state)=>{
            const { [$4cfb19e78b5b89ef$var$ELEMENT_METADATA]: metadata } = $4cfb19e78b5b89ef$var$isHTMLElementWithMetadata(state.elements.floating) ? state.elements.floating : Object.assign(state.elements.floating, {
                [$4cfb19e78b5b89ef$var$ELEMENT_METADATA]: {
                    references: $4cfb19e78b5b89ef$var$createReferences(),
                    serializedData: []
                }
            });
            const serializedData = $4cfb19e78b5b89ef$var$serialize(middlewareDataCallback(state), metadata.references);
            metadata.serializedData.unshift(serializedData);
            const controller = $4cfb19e78b5b89ef$var$getController(targetDocument);
            if (metadata.serializedData.length > 1 && state.elements.floating === (controller == null ? void 0 : controller.selectedElement)) {
                var _targetDocument$defau;
                (_targetDocument$defau = targetDocument.defaultView) == null || _targetDocument$defau.postMessage($4cfb19e78b5b89ef$var$SERIALIZED_DATA_CHANGE);
            }
            return {};
        }
    };
};
const $4cfb19e78b5b89ef$var$floatingUIMiddlewareDataCallback = (state)=>({
        ...state,
        type: 'FloatingUIMiddleware'
    });





var $acw62 = parcelRequire("acw62");
/**
 * Parses Floating UI placement and returns the different components
 * @param placement - the floating ui placement (i.e. bottom-start)
 *
 * @returns side and alignment components of the placement
 */ function $5d7daea11695cb50$export$84066e57d1671351(placement) {
    const tokens = placement.split('-');
    return {
        side: tokens[0],
        alignment: tokens[1]
    };
}


function $f21d8008604c3594$export$bc121fb05ccba5fd() {
    return {
        name: 'coverTarget',
        fn: (middlewareArguments)=>{
            const { placement: placement, rects: rects, x: x, y: y } = middlewareArguments;
            const basePlacement = (0, $5d7daea11695cb50$export$84066e57d1671351)(placement).side;
            const newCoords = {
                x: x,
                y: y
            };
            switch(basePlacement){
                case 'bottom':
                    newCoords.y -= rects.reference.height;
                    break;
                case 'top':
                    newCoords.y += rects.reference.height;
                    break;
                case 'left':
                    newCoords.x += rects.reference.width;
                    break;
                case 'right':
                    newCoords.x -= rects.reference.width;
                    break;
            }
            return newCoords;
        }
    };
}



function $9784e2fc818dfbcc$export$c9eba72a6709d7a3(element, boundary) {
    if (boundary === 'window') return element === null || element === void 0 ? void 0 : element.ownerDocument.documentElement;
    if (boundary === 'clippingParents') return 'clippingAncestors';
    if (boundary === 'scrollParent') {
        let boundariesNode = (0, $e515cff1a47b86b6$export$cfa2225e87938781)(element);
        if (boundariesNode.nodeName === 'BODY') boundariesNode = element === null || element === void 0 ? void 0 : element.ownerDocument.documentElement;
        return boundariesNode;
    }
    return boundary;
}

const $7940a40b7ec26b4c$var$getPositionMap = (rtl)=>({
        above: 'top',
        below: 'bottom',
        before: rtl ? 'right' : 'left',
        after: rtl ? 'left' : 'right'
    });
// Floating UI automatically flips alignment
// https://github.com/floating-ui/floating-ui/issues/1563
const $7940a40b7ec26b4c$var$getAlignmentMap = ()=>({
        start: 'start',
        end: 'end',
        top: 'start',
        bottom: 'end',
        center: undefined
    });
const $7940a40b7ec26b4c$var$shouldAlignToCenter = (p, a)=>{
    const positionedVertically = p === 'above' || p === 'below';
    const alignedVertically = a === 'top' || a === 'bottom';
    return positionedVertically && alignedVertically || !positionedVertically && !alignedVertically;
};
const $7940a40b7ec26b4c$export$70b0694e84cc93ec = (align, position, rtl)=>{
    const alignment = $7940a40b7ec26b4c$var$shouldAlignToCenter(position, align) ? 'center' : align;
    const computedPosition = position && $7940a40b7ec26b4c$var$getPositionMap(rtl)[position];
    const computedAlignment = alignment && $7940a40b7ec26b4c$var$getAlignmentMap()[alignment];
    if (computedPosition && computedAlignment) return `${computedPosition}-${computedAlignment}`;
    return computedPosition;
};


function $0a76753505471a91$export$8a83211c878a3f1f(options) {
    const { hasScrollableElement: hasScrollableElement, flipBoundary: flipBoundary, container: container, fallbackPositions: fallbackPositions = [], isRtl: isRtl } = options;
    const fallbackPlacements = fallbackPositions.reduce((acc, shorthand)=>{
        const { position: position, align: align } = (0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(shorthand);
        const placement = (0, $7940a40b7ec26b4c$export$70b0694e84cc93ec)(align, position, isRtl);
        if (placement) acc.push(placement);
        return acc;
    }, []);
    return (0, $bede215d88ec3aee$export$8a83211c878a3f1f)({
        ...hasScrollableElement && {
            boundary: 'clippingAncestors'
        },
        ...flipBoundary && {
            altBoundary: true,
            boundary: (0, $9784e2fc818dfbcc$export$c9eba72a6709d7a3)(container, flipBoundary)
        },
        fallbackStrategy: 'bestFit',
        ...fallbackPlacements.length && {
            fallbackPlacements: fallbackPlacements
        }
    });
}


function $3d42e14dbd78712d$export$4fbe37c24af0fe3() {
    return {
        name: 'intersectionObserver',
        fn: async (middlewareArguments)=>{
            const floatingRect = middlewareArguments.rects.floating;
            const altOverflow = await (0, $bede215d88ec3aee$export$37b6bde19b108ecc)(middlewareArguments, {
                altBoundary: true
            });
            const isIntersectingTop = altOverflow.top < floatingRect.height && altOverflow.top > 0;
            const isIntersectingBottom = altOverflow.bottom < floatingRect.height && altOverflow.bottom > 0;
            const isIntersecting = isIntersectingTop || isIntersectingBottom;
            return {
                data: {
                    intersecting: isIntersecting
                }
            };
        }
    };
}

const $42ed931fb16d27cb$export$7e23759dcf6b2f2b = '--fui-match-target-size';
function $42ed931fb16d27cb$export$76bfd61eff29b426() {
    return {
        name: 'matchTargetSize',
        fn: async (middlewareArguments)=>{
            const { rects: { reference: referenceRect, floating: floatingRect }, elements: { floating: floatingElement }, middlewareData: { matchTargetSize: { matchTargetSizeAttempt: matchTargetSizeAttempt = false } = {} } } = middlewareArguments;
            if (referenceRect.width === floatingRect.width || matchTargetSizeAttempt) return {};
            const { width: width } = referenceRect;
            floatingElement.style.setProperty($42ed931fb16d27cb$export$7e23759dcf6b2f2b, `${width}px`);
            if (!floatingElement.style.width) floatingElement.style.width = `var(${$42ed931fb16d27cb$export$7e23759dcf6b2f2b})`;
            return {
                data: {
                    matchTargetSizeAttempt: true
                },
                reset: {
                    rects: true
                }
            };
        }
    };
}



function $418961ea2f17ecf4$export$b2df6fd8f0508393(padding, isRtl) {
    if (typeof padding === 'number') return padding;
    const { start: start, end: end, ...verticalPadding } = padding;
    const paddingObject = verticalPadding;
    const left = isRtl ? 'end' : 'start';
    const right = isRtl ? 'start' : 'end';
    // assign properties explicitly since undefined values are actually handled by floating UI
    // TODO create floating UI issue
    if (padding[left]) paddingObject.left = padding[left];
    if (padding[right]) paddingObject.right = padding[right];
    return paddingObject;
}


const $c2da2e5908a16b1f$export$7cafc617ede8cfa1 = (autoSize)=>({
        name: 'resetMaxSize',
        fn ({ middlewareData: middlewareData, elements: elements }) {
            var _middlewareData_resetMaxSize;
            if ((_middlewareData_resetMaxSize = middlewareData.resetMaxSize) === null || _middlewareData_resetMaxSize === void 0 ? void 0 : _middlewareData_resetMaxSize.maxSizeAlreadyReset) return {};
            const { applyMaxWidth: applyMaxWidth, applyMaxHeight: applyMaxHeight } = autoSize;
            if (applyMaxWidth) {
                elements.floating.style.removeProperty('box-sizing');
                elements.floating.style.removeProperty('max-width');
                elements.floating.style.removeProperty('width');
            }
            if (applyMaxHeight) {
                elements.floating.style.removeProperty('box-sizing');
                elements.floating.style.removeProperty('max-height');
                elements.floating.style.removeProperty('height');
            }
            return {
                data: {
                    maxSizeAlreadyReset: true
                },
                reset: {
                    rects: true
                }
            };
        }
    });
function $c2da2e5908a16b1f$export$e121b7707a6fdbfa(autoSize, options) {
    const { container: container, overflowBoundary: overflowBoundary, overflowBoundaryPadding: overflowBoundaryPadding, isRtl: isRtl } = options;
    return (0, $bede215d88ec3aee$export$346677f925de839c)({
        ...overflowBoundaryPadding && {
            padding: (0, $418961ea2f17ecf4$export$b2df6fd8f0508393)(overflowBoundaryPadding, isRtl)
        },
        ...overflowBoundary && {
            altBoundary: true,
            boundary: (0, $9784e2fc818dfbcc$export$c9eba72a6709d7a3)(container, overflowBoundary)
        },
        apply ({ availableHeight: availableHeight, availableWidth: availableWidth, elements: elements, rects: rects }) {
            const applyMaxSizeStyles = (apply, dimension, availableSize)=>{
                if (!apply) return;
                elements.floating.style.setProperty('box-sizing', 'border-box');
                elements.floating.style.setProperty(`max-${dimension}`, `${availableSize}px`);
                if (rects.floating[dimension] > availableSize) {
                    elements.floating.style.setProperty(dimension, `${availableSize}px`);
                    const axis = dimension === 'width' ? 'x' : 'y';
                    if (!elements.floating.style.getPropertyValue(`overflow-${axis}`)) elements.floating.style.setProperty(`overflow-${axis}`, 'auto');
                }
            };
            const { applyMaxWidth: applyMaxWidth, applyMaxHeight: applyMaxHeight } = autoSize;
            applyMaxSizeStyles(applyMaxWidth, 'width', availableWidth);
            applyMaxSizeStyles(applyMaxHeight, 'height', availableHeight);
        }
    });
}



const $c239dfc32dd96645$var$getPositionMap = ()=>({
        top: 'above',
        bottom: 'below',
        right: 'after',
        left: 'before'
    });
// Floating UI automatically flips alignment
// https://github.com/floating-ui/floating-ui/issues/1563
const $c239dfc32dd96645$var$getAlignmentMap = (position)=>{
    if (position === 'above' || position === 'below') return {
        start: 'start',
        end: 'end'
    };
    return {
        start: 'top',
        end: 'bottom'
    };
};
const $c239dfc32dd96645$export$90406cf3e6e1d68c = (placement)=>{
    const { side: side, alignment: floatingUIAlignment } = (0, $5d7daea11695cb50$export$84066e57d1671351)(placement);
    const position = $c239dfc32dd96645$var$getPositionMap()[side];
    const alignment = floatingUIAlignment && $c239dfc32dd96645$var$getAlignmentMap(position)[floatingUIAlignment];
    return {
        position: position,
        alignment: alignment
    };
};


function $efd287bc14f882e0$export$1f06a4ae906dbabc(rawOffset) {
    if (!rawOffset) return rawOffset;
    if (typeof rawOffset === 'number' || typeof rawOffset === 'object') return rawOffset;
    return ({ rects: { floating: floating, reference: reference }, placement: placement })=>{
        const { position: position, alignment: alignment } = (0, $c239dfc32dd96645$export$90406cf3e6e1d68c)(placement);
        return rawOffset({
            positionedRect: floating,
            targetRect: reference,
            position: position,
            alignment: alignment
        });
    };
}


function $1d6a29ef94a430aa$export$cc800923e997bb8(offsetValue) {
    const floatingUIOffset = (0, $efd287bc14f882e0$export$1f06a4ae906dbabc)(offsetValue);
    return (0, $bede215d88ec3aee$export$cc800923e997bb8)(floatingUIOffset);
}



function $592f66020b8c60c7$export$fba63a578e423eb(options) {
    const { hasScrollableElement: hasScrollableElement, shiftToCoverTarget: shiftToCoverTarget, disableTether: disableTether, overflowBoundary: overflowBoundary, container: container, overflowBoundaryPadding: overflowBoundaryPadding, isRtl: isRtl } = options;
    return (0, $bede215d88ec3aee$export$fba63a578e423eb)({
        ...hasScrollableElement && {
            boundary: 'clippingAncestors'
        },
        ...shiftToCoverTarget && {
            crossAxis: true,
            limiter: (0, $bede215d88ec3aee$export$7bf07e38f3dc4b69)({
                crossAxis: true,
                mainAxis: false
            })
        },
        ...disableTether && {
            crossAxis: disableTether === 'all',
            limiter: (0, $bede215d88ec3aee$export$7bf07e38f3dc4b69)({
                crossAxis: disableTether !== 'all',
                mainAxis: false
            })
        },
        ...overflowBoundaryPadding && {
            padding: (0, $418961ea2f17ecf4$export$b2df6fd8f0508393)(overflowBoundaryPadding, isRtl)
        },
        ...overflowBoundary && {
            altBoundary: true,
            boundary: (0, $9784e2fc818dfbcc$export$c9eba72a6709d7a3)(container, overflowBoundary)
        }
    });
}


/**
 * AutoSizes contains many options from historic implementation.
 * Now options 'always'/'height-always'/'width-always' are obsolete.
 * This function maps them to true/'height'/'width'
 */ const $b5626e25a174fab6$export$df3e4d039c7bd0e9 = (autoSize)=>{
    switch(autoSize){
        case 'always':
        case true:
            return {
                applyMaxWidth: true,
                applyMaxHeight: true
            };
        case 'width-always':
        case 'width':
            return {
                applyMaxWidth: true,
                applyMaxHeight: false
            };
        case 'height-always':
        case 'height':
            return {
                applyMaxWidth: false,
                applyMaxHeight: true
            };
        default:
            return false;
    }
};




var $acw62 = parcelRequire("acw62");
'use client';
// ---
const $4811ac60e3af8c67$var$DEFAULT_CONFIGURATION = ({ options: options })=>{
    return options;
};
// ---
const $4811ac60e3af8c67$var$PositioningConfigurationContext = $acw62.createContext(undefined);
const $4811ac60e3af8c67$export$48c0b97fe1a4961b = $4811ac60e3af8c67$var$PositioningConfigurationContext.Provider;
const $4811ac60e3af8c67$export$a9c86432286e6813 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($4811ac60e3af8c67$var$PositioningConfigurationContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $4811ac60e3af8c67$var$DEFAULT_CONFIGURATION;
};


'use client';
/**
 * This is redundant and exists only to manage React dependencies properly & avoid leaking individual options to the
 * scope of `usePositioningOptions`.
 *
 * @internal
 */ function $55ce4aaa90243706$var$usePositioningConfigFn(configFn, options) {
    const { align: align, arrowPadding: arrowPadding, autoSize: autoSize, coverTarget: coverTarget, disableUpdateOnResize: disableUpdateOnResize, flipBoundary: flipBoundary, offset: offset, overflowBoundary: overflowBoundary, pinned: pinned, position: position, unstable_disableTether: unstable_disableTether, strategy: strategy, overflowBoundaryPadding: overflowBoundaryPadding, fallbackPositions: fallbackPositions, useTransform: useTransform, matchTargetSize: matchTargetSize, shiftToCoverTarget: shiftToCoverTarget } = options;
    return $acw62.useCallback((container, arrow)=>{
        return configFn({
            container: container,
            arrow: arrow,
            options: {
                autoSize: autoSize,
                disableUpdateOnResize: disableUpdateOnResize,
                matchTargetSize: matchTargetSize,
                offset: offset,
                strategy: strategy,
                coverTarget: coverTarget,
                flipBoundary: flipBoundary,
                overflowBoundary: overflowBoundary,
                useTransform: useTransform,
                overflowBoundaryPadding: overflowBoundaryPadding,
                pinned: pinned,
                arrowPadding: arrowPadding,
                align: align,
                fallbackPositions: fallbackPositions,
                shiftToCoverTarget: shiftToCoverTarget,
                position: position,
                unstable_disableTether: // eslint-disable-next-line @typescript-eslint/naming-convention
                unstable_disableTether
            }
        });
    }, [
        autoSize,
        disableUpdateOnResize,
        matchTargetSize,
        offset,
        strategy,
        coverTarget,
        flipBoundary,
        overflowBoundary,
        useTransform,
        overflowBoundaryPadding,
        pinned,
        arrowPadding,
        align,
        fallbackPositions,
        shiftToCoverTarget,
        position,
        unstable_disableTether,
        configFn
    ]);
}
function $55ce4aaa90243706$export$820081cf79526185(options) {
    const { dir: dir, targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const isRtl = dir === 'rtl';
    const configFn = $55ce4aaa90243706$var$usePositioningConfigFn((0, $4811ac60e3af8c67$export$a9c86432286e6813)(), options);
    const { positionFixed: positionFixed } = options;
    return $acw62.useCallback((container, arrow)=>{
        const hasScrollableElement = (0, $e515cff1a47b86b6$export$4cb81e0871943e44)(container);
        const optionsAfterEnhancement = configFn(container, arrow);
        const { autoSize: autoSize, disableUpdateOnResize: disableUpdateOnResize, matchTargetSize: matchTargetSize, offset: offset, coverTarget: coverTarget, flipBoundary: flipBoundary, overflowBoundary: overflowBoundary, useTransform: useTransform, overflowBoundaryPadding: overflowBoundaryPadding, pinned: pinned, position: position, arrowPadding: arrowPadding, strategy: strategy, align: align, fallbackPositions: fallbackPositions, shiftToCoverTarget: shiftToCoverTarget, unstable_disableTether: unstable_disableTether } = optionsAfterEnhancement;
        const normalizedAutoSize = (0, $b5626e25a174fab6$export$df3e4d039c7bd0e9)(autoSize);
        const middleware = [
            normalizedAutoSize && (0, $c2da2e5908a16b1f$export$7cafc617ede8cfa1)(normalizedAutoSize),
            matchTargetSize && (0, $42ed931fb16d27cb$export$76bfd61eff29b426)(),
            offset && (0, $1d6a29ef94a430aa$export$cc800923e997bb8)(offset),
            coverTarget && (0, $f21d8008604c3594$export$bc121fb05ccba5fd)(),
            !pinned && (0, $0a76753505471a91$export$8a83211c878a3f1f)({
                container: container,
                flipBoundary: flipBoundary,
                hasScrollableElement: hasScrollableElement,
                isRtl: isRtl,
                fallbackPositions: fallbackPositions
            }),
            (0, $592f66020b8c60c7$export$fba63a578e423eb)({
                container: container,
                hasScrollableElement: hasScrollableElement,
                overflowBoundary: overflowBoundary,
                disableTether: unstable_disableTether,
                overflowBoundaryPadding: overflowBoundaryPadding,
                isRtl: isRtl,
                shiftToCoverTarget: shiftToCoverTarget
            }),
            normalizedAutoSize && (0, $c2da2e5908a16b1f$export$e121b7707a6fdbfa)(normalizedAutoSize, {
                container: container,
                overflowBoundary: overflowBoundary,
                overflowBoundaryPadding: overflowBoundaryPadding,
                isRtl: isRtl
            }),
            (0, $3d42e14dbd78712d$export$4fbe37c24af0fe3)(),
            arrow && (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            (0, $bede215d88ec3aee$export$fe8985bb6374093c)({
                strategy: 'referenceHidden'
            }),
            (0, $bede215d88ec3aee$export$fe8985bb6374093c)({
                strategy: 'escaped'
            }),
            false
        ].filter(Boolean);
        const placement = (0, $7940a40b7ec26b4c$export$70b0694e84cc93ec)(align, position, isRtl);
        return {
            placement: placement,
            middleware: middleware,
            strategy: (strategy !== null && strategy !== void 0 ? strategy : positionFixed) ? 'fixed' : 'absolute',
            disableUpdateOnResize: disableUpdateOnResize,
            useTransform: useTransform
        };
    }, [
        configFn,
        isRtl,
        targetDocument,
        positionFixed
    ]);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $73ed5348e2751387$export$25bec8c6f54ee79a(initialValue, callback, skipInitialResolve) {
    const isFirst = $acw62.useRef(true);
    const [ref] = $acw62.useState(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        if (skipInitialResolve && isFirst.current) return;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        isFirst.current = false;
    }, []);
    // update callback
    ref.callback = callback;
    return ref.facade;
}


'use client';
function $52c6e5e426b327c0$export$76e597284ffc020(options) {
    const managerRef = $acw62.useRef(null);
    const targetRef = $acw62.useRef(null);
    const overrideTargetRef = $acw62.useRef(null);
    const containerRef = $acw62.useRef(null);
    const arrowRef = $acw62.useRef(null);
    const { enabled: enabled = true } = options;
    const resolvePositioningOptions = (0, $55ce4aaa90243706$export$820081cf79526185)(options);
    const updatePositionManager = $acw62.useCallback(()=>{
        if (managerRef.current) managerRef.current.dispose();
        managerRef.current = null;
        var _overrideTargetRef_current;
        const target = (_overrideTargetRef_current = overrideTargetRef.current) !== null && _overrideTargetRef_current !== void 0 ? _overrideTargetRef_current : targetRef.current;
        if (enabled && (0, $993af50b96092e61$export$71594e8a50f746f4)() && target && containerRef.current) managerRef.current = (0, $10f45662864422ce$export$3b0153980f731a95)({
            container: containerRef.current,
            target: target,
            arrow: arrowRef.current,
            ...resolvePositioningOptions(containerRef.current, arrowRef.current)
        });
    }, [
        enabled,
        resolvePositioningOptions
    ]);
    const setOverrideTarget = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((target)=>{
        overrideTargetRef.current = target;
        updatePositionManager();
    });
    $acw62.useImperativeHandle(options.positioningRef, ()=>({
            updatePosition: ()=>{
                var _managerRef_current;
                return (_managerRef_current = managerRef.current) === null || _managerRef_current === void 0 ? void 0 : _managerRef_current.updatePosition();
            },
            setTarget: (target)=>{
                options.target;
                setOverrideTarget(target);
            }
        }), [
        options.target,
        setOverrideTarget
    ]);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        var _options_target;
        setOverrideTarget((_options_target = options.target) !== null && _options_target !== void 0 ? _options_target : null);
    }, [
        options.target,
        setOverrideTarget
    ]);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        updatePositionManager();
    }, [
        updatePositionManager
    ]);
    var _contentNode_ownerDocument;
    const setTarget = (0, $73ed5348e2751387$export$25bec8c6f54ee79a)(null, (target)=>{
        if (targetRef.current !== target) {
            targetRef.current = target;
            updatePositionManager();
        }
    });
    const onPositioningEnd = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        var _options_onPositioningEnd;
        return (_options_onPositioningEnd = options.onPositioningEnd) === null || _options_onPositioningEnd === void 0 ? void 0 : _options_onPositioningEnd.call(options, e);
    });
    const setContainer = (0, $73ed5348e2751387$export$25bec8c6f54ee79a)(null, (container)=>{
        if (containerRef.current !== container) {
            var _containerRef_current;
            (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 || _containerRef_current.removeEventListener((0, $1bc41beff6061826$export$f663401a4492542c), onPositioningEnd);
            container === null || container === void 0 || container.addEventListener((0, $1bc41beff6061826$export$f663401a4492542c), onPositioningEnd);
            containerRef.current = container;
            updatePositionManager();
        }
    });
    const setArrow = (0, $73ed5348e2751387$export$25bec8c6f54ee79a)(null, (arrow)=>{
        if (arrowRef.current !== arrow) {
            arrowRef.current = arrow;
            updatePositionManager();
        }
    });
    // Let users use callback refs so they feel like 'normal' DOM refs
    return {
        targetRef: setTarget,
        containerRef: setContainer,
        arrowRef: setArrow
    };
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $43f171f5f7088580$export$a1195ad1c253d145 = "data-tabster";
const $43f171f5f7088580$export$22865d31b7a9c589 = "data-tabster-dummy";
const $43f171f5f7088580$export$9352ce9777935162 = `:is(${[
    "a[href]",
    "button",
    "input",
    "select",
    "textarea",
    "*[tabindex]",
    "*[contenteditable]",
    "details > summary",
    "audio[controls]",
    "video[controls]"
].join(", ")}):not(:disabled)`;
const $43f171f5f7088580$export$ef584e37c331a849 = {
    EscapeGroupper: 1,
    Restorer: 2,
    Deloser: 3
};
const $43f171f5f7088580$export$4c90aef933fea154 = {
    Any: 0,
    Accessible: 1,
    Focusable: 2
};
const $43f171f5f7088580$export$4f32fe00a6fbdffb = {
    Waiting: 0,
    Succeeded: 1,
    Canceled: 2,
    TimedOut: 3
};
const $43f171f5f7088580$export$a4de902e8828c943 = {
    CanceledFocusChange: 1,
    TimeoutElementNotInDOM: 2,
    TimeoutElementNotAccessible: 3,
    TimeoutElementNotFocusable: 4,
    TimeoutElementNotReady: 5,
    SupersededByNewRequest: 6,
    FocusCallFailed: 7
};
const $43f171f5f7088580$export$469ba0ed3bc01311 = {
    History: 0,
    DeloserDefault: 1,
    RootDefault: 2,
    DeloserFirst: 3,
    RootFirst: 4
};
const $43f171f5f7088580$export$5b8aeea6fc4d16f4 = {
    /**
     * If the focus is lost, the focus will be restored automatically using all available focus history.
     * This is the default strategy.
     */ Auto: 0,
    /**
     * If the focus is lost from this Deloser instance, the focus will not be restored automatically.
     * The application might listen to the event and restore the focus manually.
     * But if it is lost from another Deloser instance, the history of this Deloser could be used finding
     * the element to focus.
     */ Manual: 1
};
const $43f171f5f7088580$export$878d96173d57e644 = {
    Invisible: 0,
    PartiallyVisible: 1,
    Visible: 2
};
const $43f171f5f7088580$export$86e1fd7e23a4fab4 = {
    Source: 0,
    Target: 1
};
const $43f171f5f7088580$export$7c43ed5d018e9c17 = {
    Both: 0,
    Vertical: 1,
    Horizontal: 2,
    Grid: 3,
    GridLinear: 4
};
const $43f171f5f7088580$export$cb3e5a20e92ebf87 = {
    ArrowUp: 1,
    ArrowDown: 2,
    ArrowLeft: 3,
    ArrowRight: 4,
    PageUp: 5,
    PageDown: 6,
    Home: 7,
    End: 8
};
const $43f171f5f7088580$export$7ee1c0e36fdd1f6d = {
    Unlimited: 0,
    Limited: 1,
    LimitedTrapFocus: 2
};
const $43f171f5f7088580$export$16ef694586cb4846 = {
    Enter: 1,
    Escape: 2
};
const $43f171f5f7088580$export$982c91672ba981ed = {
    Auto: 0,
    Inside: 1,
    Outside: 2
};


function $cac64caf55b8b085$export$18eb7fa290c97ad6(tabster, element) {
    return tabster.storageEntry(element)?.tabster;
}
function $cac64caf55b8b085$export$5a2a13bd8eff0b2c(tabster, element, dispose) {
    const newAttrValue = dispose || tabster._noop ? undefined : element.getAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145));
    let entry = tabster.storageEntry(element);
    let newAttr;
    if (newAttrValue) {
        if (newAttrValue !== entry?.attr?.string) try {
            const newValue = JSON.parse(newAttrValue);
            if (typeof newValue !== "object") throw new Error(`Value is not a JSON object, got '${newAttrValue}'.`);
            newAttr = {
                string: newAttrValue,
                object: newValue
            };
        } catch (e) {}
        else return;
    } else if (!entry) return;
    if (!entry) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entry = tabster.storageEntry(element, true);
    if (!entry.tabster) entry.tabster = {};
    const tabsterOnElement = entry.tabster || {};
    const oldTabsterProps = entry.attr?.object || {};
    const newTabsterProps = newAttr?.object || {};
    for (const key of Object.keys(oldTabsterProps))if (!newTabsterProps[key]) {
        if (key === "root") {
            const root = tabsterOnElement[key];
            if (root) tabster.root.onRoot(root, true);
        }
        switch(key){
            case "deloser":
            case "root":
            case "groupper":
            case "modalizer":
            case "restorer":
            case "mover":
                // eslint-disable-next-line no-case-declarations
                const part = tabsterOnElement[key];
                if (part) {
                    part.dispose();
                    delete tabsterOnElement[key];
                }
                break;
            case "observed":
                delete tabsterOnElement[key];
                if (tabster.observedElement) tabster.observedElement.onObservedElementUpdate(element);
                break;
            case "focusable":
            case "outline":
            case "uncontrolled":
            case "sys":
                delete tabsterOnElement[key];
                break;
        }
    }
    for (const key of Object.keys(newTabsterProps)){
        const sys = newTabsterProps.sys;
        switch(key){
            case "root":
                if (tabsterOnElement.root) tabsterOnElement.root.setProps(newTabsterProps.root);
                else tabsterOnElement.root = tabster.root.createRoot(element, newTabsterProps.root, sys);
                tabster.root.onRoot(tabsterOnElement.root);
                break;
            case "focusable":
                tabsterOnElement.focusable = newTabsterProps.focusable;
                break;
            case "observed":
                if (tabster.observedElement) {
                    tabsterOnElement.observed = newTabsterProps.observed;
                    tabster.observedElement.onObservedElementUpdate(element);
                }
                break;
            case "uncontrolled":
                tabsterOnElement.uncontrolled = newTabsterProps.uncontrolled;
                break;
            case "outline":
                if (tabster.outline) tabsterOnElement.outline = newTabsterProps.outline;
                break;
            case "sys":
                tabsterOnElement.sys = newTabsterProps.sys;
                break;
            default:
                {
                    const handler = tabster.attrHandlers.get(key);
                    if (handler) tabsterOnElement[key] = handler(element, tabsterOnElement[key], newTabsterProps[key], oldTabsterProps?.[key], sys);
                }
        }
    }
    if (newAttr) entry.attr = newAttr;
    else {
        if (Object.keys(tabsterOnElement).length === 0) {
            delete entry.tabster;
            delete entry.attr;
        }
        tabster.storageEntry(element, false);
    }
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Events sent by Tabster.
 */ const $b6b59d8a07a2383a$export$ae0b8c64bcbb585d = "tabster:focusin";
const $b6b59d8a07a2383a$export$f9101ff89ea52cc1 = "tabster:focusout";
const $b6b59d8a07a2383a$export$80541a59aecfcfb5 = "tabster:movefocus";
const $b6b59d8a07a2383a$export$7478210b325f123a = "tabster:deloser:focus-lost";
const $b6b59d8a07a2383a$export$87ff539c9b9c8c83 = "tabster:deloser:restore-focus";
const $b6b59d8a07a2383a$export$4c6486520efccc97 = "tabster:modalizer:active";
const $b6b59d8a07a2383a$export$b7bdb381786195e3 = "tabster:modalizer:inactive";
const $b6b59d8a07a2383a$export$f92ec62f67d1a1fb = "tabster:modalizer:focusin";
const $b6b59d8a07a2383a$export$7d57d7582dee5261 = "tabster:modalizer:focusout";
const $b6b59d8a07a2383a$export$1ec4dd77f5612bf6 = "tabster:mover:state";
const $b6b59d8a07a2383a$export$3a927ee2f95ddfa = "tabster:mover:movefocus";
const $b6b59d8a07a2383a$export$f538b9d389680b27 = "tabster:mover:memorized-element";
const $b6b59d8a07a2383a$export$7e4efd5c8bf2a678 = "tabster:groupper:movefocus";
const $b6b59d8a07a2383a$export$3d63c9b40c6a05c3 = "tabster:restorer:restore-focus";
const $b6b59d8a07a2383a$export$2e2b4254629c7d58 = "tabster:root:focus";
const $b6b59d8a07a2383a$export$88131e0157680e6a = "tabster:root:blur";
// Node.js environments do not have CustomEvent and it is needed for the events to be
// evaluated. It doesn't matter if it works or not in Node.js environment.
// So, we just need to make sure that it doesn't throw undefined reference.
const $b6b59d8a07a2383a$var$CustomEvent_ = typeof CustomEvent !== "undefined" ? CustomEvent : function() {
/* no-op */ };
class $b6b59d8a07a2383a$export$208738e9f5d41bd1 extends $b6b59d8a07a2383a$var$CustomEvent_ {
    constructor(type, detail){
        super(type, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
        this.details = detail;
    }
}
class $b6b59d8a07a2383a$export$2409322399d631d9 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$ae0b8c64bcbb585d, detail);
    }
}
class $b6b59d8a07a2383a$export$731508468a1b9ed2 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$f9101ff89ea52cc1, detail);
    }
}
class $b6b59d8a07a2383a$export$94e7298c3ba0dcfc extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$80541a59aecfcfb5, detail);
    }
}
class $b6b59d8a07a2383a$export$4237cba23bf0663d extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$1ec4dd77f5612bf6, detail);
    }
}
class $b6b59d8a07a2383a$export$6f00fc054b25f3c9 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$3a927ee2f95ddfa, detail);
    }
}
class $b6b59d8a07a2383a$export$bb8a944455e0ecdf extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$f538b9d389680b27, detail);
    }
}
class $b6b59d8a07a2383a$export$e6a82560201109 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$7e4efd5c8bf2a678, detail);
    }
}
class $b6b59d8a07a2383a$export$c375a7c49fb7a7ca extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$4c6486520efccc97, detail);
    }
}
class $b6b59d8a07a2383a$export$2ee7f26c7f1dcf9c extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$b7bdb381786195e3, detail);
    }
}
class $b6b59d8a07a2383a$export$4dbd4cf004af5f30 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$7478210b325f123a, detail);
    }
}
class $b6b59d8a07a2383a$export$553c0cff9981e8af extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(){
        super($b6b59d8a07a2383a$export$87ff539c9b9c8c83);
    }
}
class $b6b59d8a07a2383a$export$39f4c1150b8485d9 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(){
        super($b6b59d8a07a2383a$export$3d63c9b40c6a05c3);
    }
}
class $b6b59d8a07a2383a$export$8606e9d746120bb0 extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$2e2b4254629c7d58, detail);
    }
}
class $b6b59d8a07a2383a$export$4122e0ec6dadc59a extends $b6b59d8a07a2383a$export$208738e9f5d41bd1 {
    constructor(detail){
        super($b6b59d8a07a2383a$export$88131e0157680e6a, detail);
    }
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1f57f26a88fe463d$var$_createMutationObserver = (callback)=>new MutationObserver(callback);
const $1f57f26a88fe463d$var$_createTreeWalker = (doc, root, whatToShow, filter)=>doc.createTreeWalker(root, whatToShow, filter);
const $1f57f26a88fe463d$var$_getParentNode = (node)=>node ? node.parentNode : null;
const $1f57f26a88fe463d$var$_getParentElement = (element)=>element ? element.parentElement : null;
const $1f57f26a88fe463d$var$_nodeContains = (parent, child)=>!!(child && parent?.contains(child));
const $1f57f26a88fe463d$var$_getActiveElement = (doc)=>doc.activeElement;
const $1f57f26a88fe463d$var$_querySelector = (element, selector)=>element.querySelector(selector);
const $1f57f26a88fe463d$var$_querySelectorAll = (element, selector)=>Array.prototype.slice.call(element.querySelectorAll(selector), 0);
const $1f57f26a88fe463d$var$_getElementById = (doc, id)=>doc.getElementById(id);
const $1f57f26a88fe463d$var$_getFirstChild = (node)=>node?.firstChild || null;
const $1f57f26a88fe463d$var$_getLastChild = (node)=>node?.lastChild || null;
const $1f57f26a88fe463d$var$_getNextSibling = (node)=>node?.nextSibling || null;
const $1f57f26a88fe463d$var$_getPreviousSibling = (node)=>node?.previousSibling || null;
const $1f57f26a88fe463d$var$_getFirstElementChild = (element)=>element?.firstElementChild || null;
const $1f57f26a88fe463d$var$_getLastElementChild = (element)=>element?.lastElementChild || null;
const $1f57f26a88fe463d$var$_getNextElementSibling = (element)=>element?.nextElementSibling || null;
const $1f57f26a88fe463d$var$_getPreviousElementSibling = (element)=>element?.previousElementSibling || null;
const $1f57f26a88fe463d$var$_appendChild = (parent, child)=>parent.appendChild(child);
const $1f57f26a88fe463d$var$_insertBefore = (parent, child, referenceChild)=>parent.insertBefore(child, referenceChild);
const $1f57f26a88fe463d$var$_getSelection = (ref)=>ref.ownerDocument?.getSelection() || null;
const $1f57f26a88fe463d$var$_getElementsByName = (referenceElement, name)=>referenceElement.ownerDocument.getElementsByName(name);
const $1f57f26a88fe463d$export$df3a06d6289f983e = {
    createMutationObserver: $1f57f26a88fe463d$var$_createMutationObserver,
    createTreeWalker: $1f57f26a88fe463d$var$_createTreeWalker,
    getParentNode: $1f57f26a88fe463d$var$_getParentNode,
    getParentElement: $1f57f26a88fe463d$var$_getParentElement,
    nodeContains: $1f57f26a88fe463d$var$_nodeContains,
    getActiveElement: $1f57f26a88fe463d$var$_getActiveElement,
    querySelector: $1f57f26a88fe463d$var$_querySelector,
    querySelectorAll: $1f57f26a88fe463d$var$_querySelectorAll,
    getElementById: $1f57f26a88fe463d$var$_getElementById,
    getFirstChild: $1f57f26a88fe463d$var$_getFirstChild,
    getLastChild: $1f57f26a88fe463d$var$_getLastChild,
    getNextSibling: $1f57f26a88fe463d$var$_getNextSibling,
    getPreviousSibling: $1f57f26a88fe463d$var$_getPreviousSibling,
    getFirstElementChild: $1f57f26a88fe463d$var$_getFirstElementChild,
    getLastElementChild: $1f57f26a88fe463d$var$_getLastElementChild,
    getNextElementSibling: $1f57f26a88fe463d$var$_getNextElementSibling,
    getPreviousElementSibling: $1f57f26a88fe463d$var$_getPreviousElementSibling,
    appendChild: $1f57f26a88fe463d$var$_appendChild,
    insertBefore: $1f57f26a88fe463d$var$_insertBefore,
    getSelection: $1f57f26a88fe463d$var$_getSelection,
    getElementsByName: $1f57f26a88fe463d$var$_getElementsByName
};
function $1f57f26a88fe463d$export$2818ed6e0a6311a1(domapi) {
    for (const key of Object.keys(domapi))$1f57f26a88fe463d$export$df3a06d6289f983e[key] = domapi[key];
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 

let $8031a5e97995bd92$var$_uidCounter = 0;
function $8031a5e97995bd92$export$4f20612bacd919f5(getWindow) {
    const win = getWindow();
    return win.__tabsterInstanceContext ??= {
        elementByUId: {},
        containerBoundingRectCache: {},
        lastContainerBoundingRectCacheId: 0
    };
}
function $8031a5e97995bd92$export$f0e20bb2ca318fc2(win) {
    const w = win;
    const ctx = w.__tabsterInstanceContext;
    if (ctx) {
        ctx.elementByUId = {};
        ctx.containerBoundingRectCache = {};
        if (ctx.containerBoundingRectCacheTimer) win.clearTimeout(ctx.containerBoundingRectCacheTimer);
        delete w.__tabsterInstanceContext;
    }
}
function $8031a5e97995bd92$export$8f73bd2b229b91a3(element) {
    return !!element.querySelector((0, $43f171f5f7088580$export$9352ce9777935162));
}
class $8031a5e97995bd92$export$e61d664de92eea96 {
    constructor(element, data){
        this._ref = new WeakRef(element);
        this._data = data;
    }
    get() {
        const ref = this._ref;
        let element;
        if (ref) {
            element = ref.deref();
            if (!element) delete this._ref;
        }
        return element;
    }
    getData() {
        return this._data;
    }
}
function $8031a5e97995bd92$export$6d51b6a3304b27f5(doc, root, acceptNode) {
    if (root.nodeType !== Node.ELEMENT_NODE) return undefined;
    return (0, $1f57f26a88fe463d$export$df3a06d6289f983e).createTreeWalker(doc, root, NodeFilter.SHOW_ELEMENT, {
        acceptNode: acceptNode
    });
}
function $8031a5e97995bd92$export$c381147bfed79d9f(getWindow, element) {
    let cacheId = element.__tabsterCacheId;
    const context = $8031a5e97995bd92$export$4f20612bacd919f5(getWindow);
    const cached = cacheId ? context.containerBoundingRectCache[cacheId] : undefined;
    if (cached) return cached.rect;
    const scrollingElement = element.ownerDocument && element.ownerDocument.documentElement;
    if (!scrollingElement) return new DOMRect();
    // A bounding rect of the top-level element contains the whole page regardless of the
    // scrollbar. So, we improvise a little and limiting the final result...
    let left = 0;
    let top = 0;
    let right = scrollingElement.clientWidth;
    let bottom = scrollingElement.clientHeight;
    if (element !== scrollingElement) {
        const r = element.getBoundingClientRect();
        left = Math.max(left, r.left);
        top = Math.max(top, r.top);
        right = Math.min(right, r.right);
        bottom = Math.min(bottom, r.bottom);
    }
    const rect = new DOMRect(left < right ? left : -1, top < bottom ? top : -1, left < right ? right - left : 0, top < bottom ? bottom - top : 0);
    if (!cacheId) {
        cacheId = "r-" + ++context.lastContainerBoundingRectCacheId;
        element.__tabsterCacheId = cacheId;
    }
    context.containerBoundingRectCache[cacheId] = {
        rect: rect,
        element: element
    };
    if (!context.containerBoundingRectCacheTimer) context.containerBoundingRectCacheTimer = window.setTimeout(()=>{
        context.containerBoundingRectCacheTimer = undefined;
        for (const cId of Object.keys(context.containerBoundingRectCache))delete context.containerBoundingRectCache[cId].element.__tabsterCacheId;
        context.containerBoundingRectCache = {};
    }, 50);
    return rect;
}
function $8031a5e97995bd92$export$11e0e62ee78050d6(getWindow, element, tolerance) {
    const container = $8031a5e97995bd92$export$320287ee38b8cccd(element);
    if (!container) return false;
    const containerRect = $8031a5e97995bd92$export$c381147bfed79d9f(getWindow, container);
    const elementRect = element.getBoundingClientRect();
    const intersectionTolerance = elementRect.height * (1 - tolerance);
    const topIntersection = Math.max(0, containerRect.top - elementRect.top);
    const bottomIntersection = Math.max(0, elementRect.bottom - containerRect.bottom);
    const totalIntersection = topIntersection + bottomIntersection;
    return totalIntersection === 0 || totalIntersection <= intersectionTolerance;
}
function $8031a5e97995bd92$export$b9dc8b6556026098(getWindow, element, gap = 0) {
    const container = $8031a5e97995bd92$export$320287ee38b8cccd(element);
    if (container) {
        const containerRect = $8031a5e97995bd92$export$c381147bfed79d9f(getWindow, container);
        const elementRect = element.getBoundingClientRect();
        if (elementRect.left > containerRect.right || elementRect.top > containerRect.bottom || elementRect.bottom < containerRect.top || elementRect.right < containerRect.left) return (0, $43f171f5f7088580$export$878d96173d57e644).Invisible;
        if (elementRect.top + gap >= containerRect.top && elementRect.top <= containerRect.bottom && elementRect.bottom >= containerRect.top && elementRect.bottom - gap <= containerRect.bottom && elementRect.left + gap >= containerRect.left && elementRect.left <= containerRect.right && elementRect.right >= containerRect.left && elementRect.right - gap <= containerRect.right) return (0, $43f171f5f7088580$export$878d96173d57e644).Visible;
        return (0, $43f171f5f7088580$export$878d96173d57e644).PartiallyVisible;
    }
    return (0, $43f171f5f7088580$export$878d96173d57e644).Invisible;
}
function $8031a5e97995bd92$export$53a0910f038337bd(getWindow, element, alignToTop) {
    // Built-in DOM's scrollIntoView() is cool, but when we have nested containers,
    // it scrolls all of them, not just the deepest one. So, trying to work it around.
    const container = $8031a5e97995bd92$export$320287ee38b8cccd(element);
    if (container) {
        const containerRect = $8031a5e97995bd92$export$c381147bfed79d9f(getWindow, container);
        const elementRect = element.getBoundingClientRect();
        if (alignToTop) container.scrollTop += elementRect.top - containerRect.top;
        else container.scrollTop += elementRect.bottom - containerRect.bottom;
    }
}
function $8031a5e97995bd92$export$320287ee38b8cccd(element) {
    const doc = element.ownerDocument;
    if (doc) {
        for(let el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(element); el; el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(el)){
            if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) return el;
        }
        return doc.documentElement;
    }
    return null;
}
function $8031a5e97995bd92$export$30a4f5bb6cec3104(element) {
    element.__shouldIgnoreFocus = true;
}
function $8031a5e97995bd92$export$4a2e08217cea38f4(element) {
    return !!element.__shouldIgnoreFocus;
}
function $8031a5e97995bd92$export$403aca071c43b511(wnd) {
    const rnd = new Uint32Array(4);
    wnd.crypto.getRandomValues(rnd);
    return Array.from(rnd, (n)=>n.toString(36)).join("") + "|" + (++$8031a5e97995bd92$var$_uidCounter).toString(36) + "|" + Date.now().toString(36);
}
function $8031a5e97995bd92$export$2dc82a3fd984deae(getWindow, element) {
    const context = $8031a5e97995bd92$export$4f20612bacd919f5(getWindow);
    const uid = element.__tabsterElementUID ??= $8031a5e97995bd92$export$403aca071c43b511(getWindow());
    if (!context.elementByUId[uid] && $8031a5e97995bd92$export$b9e78d52333734f8(element.ownerDocument, element)) context.elementByUId[uid] = new $8031a5e97995bd92$export$e61d664de92eea96(element);
    return uid;
}
function $8031a5e97995bd92$export$8f49953d3f4e07e0(context, uid) {
    return context.elementByUId[uid];
}
function $8031a5e97995bd92$export$cca35b41445262e(win) {
    return win.__tabsterCrossOriginWindowUID ??= $8031a5e97995bd92$export$403aca071c43b511(win);
}
function $8031a5e97995bd92$export$7093c63335353a70(getWindow, parent) {
    const cache = $8031a5e97995bd92$export$4f20612bacd919f5(getWindow).elementByUId;
    for (const key of Object.keys(cache)){
        const el = cache[key]?.get();
        // When `parent` is given, only entries inside it are pruned; otherwise
        // the entire cache is cleared.
        if (parent && el && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(parent, el)) continue;
        delete cache[key];
    }
}
function $8031a5e97995bd92$export$b9e78d52333734f8(doc, element) {
    return (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(doc?.body, element);
}
function $8031a5e97995bd92$export$b06a2f5618961e1e(element, selector) {
    return typeof element.matches === "function" && element.matches(selector);
}
let $8031a5e97995bd92$var$_lastTabsterPartId = 0;
class $8031a5e97995bd92$export$512356fecf866417 {
    constructor(tabster, element, props){
        this._tabster = tabster;
        this._element = new $8031a5e97995bd92$export$e61d664de92eea96(element);
        this._props = {
            ...props
        };
        this.id = "i" + ++$8031a5e97995bd92$var$_lastTabsterPartId;
    }
    getElement() {
        return this._element.get();
    }
    getProps() {
        return this._props;
    }
    setProps(props) {
        this._props = {
            ...props
        };
    }
}
function $8031a5e97995bd92$export$98420b9ec3fd7e2c(container) {
    let lastChild = null;
    for(let i = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getLastElementChild(container); i; i = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getLastElementChild(i))lastChild = i;
    return lastChild || undefined;
}
function $8031a5e97995bd92$export$b7afccb7bf36a427(from, prev) {
    let cur = from;
    let adjacent = null;
    while(cur && !adjacent){
        adjacent = prev ? (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getPreviousElementSibling(cur) : (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextElementSibling(cur);
        cur = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(cur);
    }
    return adjacent || undefined;
}
function $8031a5e97995bd92$export$4a7138b8b618a0c9(tabster, element, name, value // Restore original value when undefined.
) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entry = tabster.storageEntry(element, true);
    let ret = false;
    if (!entry.aug) {
        if (value === undefined) return ret;
        entry.aug = {};
    }
    if (value === undefined) {
        if (name in entry.aug) {
            const origVal = entry.aug[name];
            delete entry.aug[name];
            if (origVal === null) element.removeAttribute(name);
            else element.setAttribute(name, origVal);
            ret = true;
        }
    } else {
        let origValue;
        if (!(name in entry.aug)) origValue = element.getAttribute(name);
        if (origValue !== undefined && origValue !== value) {
            entry.aug[name] = origValue;
            if (value === null) element.removeAttribute(name);
            else element.setAttribute(name, value);
            ret = true;
        }
    }
    if (value === undefined && Object.keys(entry.aug).length === 0) {
        delete entry.aug;
        tabster.storageEntry(element, false);
    }
    return ret;
}
function $8031a5e97995bd92$export$512ff019bf2399e3(element) {
    // `getAttribute` already returns null when the attribute is absent —
    // no need for a separate `hasAttribute` probe.
    const rawAttribute = element.getAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145));
    if (rawAttribute === null) return null;
    try {
        return JSON.parse(rawAttribute);
    } catch  {
        console.error("Tabster: failed to parse attribute", rawAttribute);
        return {};
    }
}
function $8031a5e97995bd92$export$d4a89a85d6c8d4c5(element) {
    const elementDocument = element.ownerDocument;
    const computedStyle = elementDocument.defaultView?.getComputedStyle(element);
    // offsetParent is null for elements with display:none, display:fixed and for <body>.
    if (element.offsetParent === null && elementDocument.body !== element && computedStyle?.position !== "fixed") return true;
    // For our purposes of looking for focusable elements, visibility:hidden has the same
    // effect as display:none.
    if (computedStyle?.visibility === "hidden") return true;
    // if an element has display: fixed, we need to check if it is also hidden with CSS,
    // or within a parent hidden with CSS
    if (computedStyle?.position === "fixed") {
        if (computedStyle.display === "none") return true;
        if (element.parentElement?.offsetParent === null && elementDocument.body !== element.parentElement) return true;
    }
    return false;
}
function $8031a5e97995bd92$export$fb52e7e103ecac84(element) {
    return element.tagName === "INPUT" && !!element.name && element.type === "radio";
}
function $8031a5e97995bd92$export$973f3e797b900544(element) {
    if (!$8031a5e97995bd92$export$fb52e7e103ecac84(element)) return;
    const name = element.name;
    const radioButtons = [];
    let checked;
    for (const el of (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getElementsByName(element, name))if ($8031a5e97995bd92$export$fb52e7e103ecac84(el)) {
        const input = el;
        radioButtons.push(input);
        if (input.checked) checked = input;
    }
    return {
        name: name,
        buttons: new Set(radioButtons),
        checked: checked
    };
}
function $8031a5e97995bd92$export$f03a6b845d3fb58b(target, type, handler, options) {
    target?.addEventListener(type, handler, options);
}
function $8031a5e97995bd92$export$b03e9483f936dccb(target, type, handler, options) {
    target?.removeEventListener(type, handler, options);
}
function $8031a5e97995bd92$export$716a11175c03fb4e(target, event) {
    return !!target && target.dispatchEvent(event);
} /**
 * If the passed element is Tabster dummy input, returns the container element this dummy input belongs to.
 * @param element Element to check for being dummy input.
 * @returns Dummy input container element (if the passed element is a dummy input) or null.
 */ 


const $f8063a7f7d87cb7c$var$_updateDummyInputsTimeout = 100;
class $f8063a7f7d87cb7c$export$98321245064bc252 {
    constructor(getWindow, isOutside, props, element, fixedTarget){
        this._focusIn = (e)=>{
            if (this._fixedTarget) {
                const target = this._fixedTarget.get();
                if (target) (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(target);
                return;
            }
            const input = this.input;
            if (this.onFocusIn && input) {
                const relatedTarget = e.relatedTarget;
                this.onFocusIn(this, this._isBackward(true, input, relatedTarget), relatedTarget);
            }
        };
        this._focusOut = (e)=>{
            if (this._fixedTarget) return;
            this.useDefaultAction = false;
            const input = this.input;
            if (this.onFocusOut && input) {
                const relatedTarget = e.relatedTarget;
                this.onFocusOut(this, this._isBackward(false, input, relatedTarget), relatedTarget);
            }
        };
        const win = getWindow();
        const input = win.document.createElement("i");
        input.tabIndex = 0;
        input.setAttribute("role", "none");
        input.setAttribute((0, $43f171f5f7088580$export$22865d31b7a9c589), "");
        input.setAttribute("aria-hidden", "true");
        const style = input.style;
        style.position = "fixed";
        style.width = style.height = "1px";
        style.opacity = "0.001";
        style.zIndex = "-1";
        style.setProperty("content-visibility", "hidden");
        (0, $8031a5e97995bd92$export$30a4f5bb6cec3104)(input);
        this.input = input;
        this.isFirst = props.isFirst;
        this.isOutside = isOutside;
        this._isPhantom = props.isPhantom ?? false;
        this._fixedTarget = fixedTarget;
        (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(input, "focusin", this._focusIn);
        (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(input, "focusout", this._focusOut);
        input.__tabsterDummyContainer = element;
        if (this._isPhantom) {
            this._disposeTimer = win.setTimeout(()=>{
                delete this._disposeTimer;
                this.dispose();
            }, 0);
            this._clearDisposeTimeout = ()=>{
                if (this._disposeTimer) {
                    win.clearTimeout(this._disposeTimer);
                    delete this._disposeTimer;
                }
                delete this._clearDisposeTimeout;
            };
        }
    }
    dispose() {
        if (this._clearDisposeTimeout) this._clearDisposeTimeout();
        const input = this.input;
        if (!input) return;
        delete this._fixedTarget;
        delete this.onFocusIn;
        delete this.onFocusOut;
        delete this.input;
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(input, "focusin", this._focusIn);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(input, "focusout", this._focusOut);
        delete input.__tabsterDummyContainer;
        (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentNode(input)?.removeChild(input);
    }
    setTopLeft(top, left) {
        const style = this.input?.style;
        if (style) {
            style.top = `${top}px`;
            style.left = `${left}px`;
        }
    }
    _isBackward(isIn, current, previous) {
        return isIn && !previous ? !this.isFirst : !!(previous && current.compareDocumentPosition(previous) & Node.DOCUMENT_POSITION_FOLLOWING);
    }
}
const $f8063a7f7d87cb7c$export$96ba7a05d53985a3 = {
    Root: 1,
    Modalizer: 2,
    Mover: 3,
    Groupper: 4
};
class $f8063a7f7d87cb7c$export$2b3665f1498b1a50 {
    constructor(tabster, element, priority, sys, outsideByDefault, callForDefaultAction){
        this._element = element;
        this._instance = new $f8063a7f7d87cb7c$var$DummyInputManagerCore(tabster, element, this, priority, sys, outsideByDefault, callForDefaultAction);
    }
    _setHandlers(onFocusIn, onFocusOut) {
        this._onFocusIn = onFocusIn;
        this._onFocusOut = onFocusOut;
    }
    moveOut(backwards) {
        this._instance?.moveOut(backwards);
    }
    moveOutWithDefaultAction(backwards, relatedEvent) {
        this._instance?.moveOutWithDefaultAction(backwards, relatedEvent);
    }
    getHandler(isIn) {
        return isIn ? this._onFocusIn : this._onFocusOut;
    }
    setTabbable(tabbable) {
        this._instance?.setTabbable(this, tabbable);
    }
    dispose() {
        if (this._instance) {
            this._instance.dispose(this);
            delete this._instance;
        }
        delete this._onFocusIn;
        delete this._onFocusOut;
    }
    static moveWithPhantomDummy(tabster, element, moveOutOfElement, isBackward, relatedEvent // The event that triggered the move.
    ) {
        // Phantom dummy is a hack to use browser's default action to move
        // focus from a specific point in the application to the next/previous
        // element. Default action is needed because next focusable element
        // is not always available to focus directly (for example, next focusable
        // is inside isolated iframe) or for uncontrolled areas we want to make
        // sure that something that controls it takes care of the focusing.
        // It works in a way that during the Tab key handling, we create a dummy
        // input element, place it to the specific place in the DOM and focus it,
        // then the default action of the Tab press will move focus from our dummy
        // input. And we remove it from the DOM right after that.
        const dummy = new $f8063a7f7d87cb7c$export$98321245064bc252(tabster.getWindow, true, {
            isPhantom: true,
            isFirst: true
        });
        const input = dummy.input;
        if (input) {
            let parent;
            let insertBefore;
            // Let's say we have a following DOM structure:
            // <div>
            //   <button>Button1</button>
            //   <div id="uncontrolled" data-tabster={uncontrolled: {}}>
            //     <button>Button2</button>
            //     <button>Button3</button>
            //   </div>
            //   <button>Button4</button>
            // </div>
            //
            // We pass the "uncontrolled" div as the element to move to or out of.
            //
            // When we pass moveOutOfElement=true and isBackward=false,
            // the phantom dummy input will be inserted before Button4.
            //
            // When we pass moveOutOfElement=true and isBackward=true, there are
            // two cases. If the uncontrolled element is focusable (has tabindex=0),
            // the phantom dummy input will be inserted after Button1. If the
            // uncontrolled element is not focusable, the phantom dummy input will be
            // inserted before Button2.
            //
            // When we pass moveOutOfElement=false and isBackward=false, the
            // phantom dummy input will be inserted after Button1.
            //
            // When we pass moveOutOfElement=false and isBackward=true, the phantom
            // dummy input will be inserted before Button4.
            //
            // And we have a corner case for <body> and we make sure that the inserted
            // dummy is inserted properly when there are existing permanent dummies.
            if (element.tagName === "BODY") {
                // We cannot insert elements outside of BODY.
                parent = element;
                insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstElementChild(element) : null;
            } else {
                if (moveOutOfElement && (!isBackward || isBackward && !tabster.focusable.isFocusable(element, false, true, true))) {
                    parent = element;
                    insertBefore = isBackward ? element.firstElementChild : null;
                } else {
                    parent = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(element);
                    insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? element : (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextElementSibling(element);
                }
                let potentialDummy;
                let dummyFor;
                do {
                    // This is a safety pillow for the cases when someone, combines
                    // groupper with uncontrolled on the same node. Which is technically
                    // not correct, but moving into the container element via its dummy
                    // input would produce a correct behaviour in uncontrolled mode.
                    potentialDummy = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getPreviousElementSibling(insertBefore) : insertBefore;
                    dummyFor = $f8063a7f7d87cb7c$export$6c7070ee46ec4271(potentialDummy);
                    if (dummyFor === element) insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? potentialDummy : (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextElementSibling(potentialDummy);
                    else dummyFor = null;
                }while (dummyFor);
            }
            if (parent && (0, $8031a5e97995bd92$export$716a11175c03fb4e)(parent, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                by: "root",
                owner: parent,
                next: null,
                relatedEvent: relatedEvent
            }))) {
                (0, $1f57f26a88fe463d$export$df3a06d6289f983e).insertBefore(parent, input, insertBefore);
                (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(input);
            }
        }
    }
    static addPhantomDummyWithTarget(tabster, sourceElement, isBackward, targetElement) {
        const dummy = new $f8063a7f7d87cb7c$export$98321245064bc252(tabster.getWindow, true, {
            isPhantom: true,
            isFirst: true
        }, undefined, new (0, $8031a5e97995bd92$export$e61d664de92eea96)(targetElement));
        const input = dummy.input;
        if (input) {
            let dummyParent;
            let insertBefore;
            if ((0, $8031a5e97995bd92$export$8f73bd2b229b91a3)(sourceElement) && !isBackward) {
                dummyParent = sourceElement;
                insertBefore = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstElementChild(sourceElement);
            } else {
                dummyParent = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(sourceElement);
                insertBefore = isBackward ? sourceElement : (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextElementSibling(sourceElement);
            }
            if (dummyParent) (0, $1f57f26a88fe463d$export$df3a06d6289f983e).insertBefore(dummyParent, input, insertBefore);
        }
    }
}
function $f8063a7f7d87cb7c$var$setDummyInputDebugValue(dummy, wrappers) {
    const what = {
        1: "Root",
        2: "Modalizer",
        3: "Mover",
        4: "Groupper"
    };
    dummy.input?.setAttribute((0, $43f171f5f7088580$export$22865d31b7a9c589), [
        `isFirst=${dummy.isFirst}`,
        `isOutside=${dummy.isOutside}`,
        ...wrappers.map((w)=>`(${what[w.priority]}, tabbable=${w.tabbable})`)
    ].join(", "));
}
class $f8063a7f7d87cb7c$export$9c4205b1985bc82 {
    constructor(win){
        this._updateQueue = new Set();
        this._lastUpdateQueueTime = 0;
        this._changedParents = new WeakSet();
        this._dummyElements = [];
        this._dummyCallbacks = new WeakMap();
        this._domChanged = (parent)=>{
            if (this._changedParents.has(parent)) return;
            this._changedParents.add(parent);
            if (this._updateDummyInputsTimer) return;
            this._updateDummyInputsTimer = this._win?.().setTimeout(()=>{
                delete this._updateDummyInputsTimer;
                for (const ref of this._dummyElements){
                    const dummyElement = ref.get();
                    if (dummyElement) {
                        const callback = this._dummyCallbacks.get(dummyElement);
                        if (callback) {
                            const dummyParent = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentNode(dummyElement);
                            if (!dummyParent || this._changedParents.has(dummyParent)) callback();
                        }
                    }
                }
                this._changedParents = new WeakSet();
            }, $f8063a7f7d87cb7c$var$_updateDummyInputsTimeout);
        };
        this._win = win;
    }
    add(dummy, callback) {
        if (!this._dummyCallbacks.has(dummy) && this._win) {
            this._dummyElements.push(new (0, $8031a5e97995bd92$export$e61d664de92eea96)(dummy));
            this._dummyCallbacks.set(dummy, callback);
            this.domChanged = this._domChanged;
        }
    }
    remove(dummy) {
        this._dummyElements = this._dummyElements.filter((ref)=>{
            const element = ref.get();
            return element && element !== dummy;
        });
        this._dummyCallbacks.delete(dummy);
        if (this._dummyElements.length === 0) delete this.domChanged;
    }
    dispose() {
        const win = this._win?.();
        if (this._updateTimer) {
            win?.clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        if (this._updateDummyInputsTimer) {
            win?.clearTimeout(this._updateDummyInputsTimer);
            delete this._updateDummyInputsTimer;
        }
        this._changedParents = new WeakSet();
        this._dummyCallbacks = new WeakMap();
        this._dummyElements = [];
        this._updateQueue.clear();
        delete this.domChanged;
        delete this._win;
    }
    updatePositions(compute) {
        if (!this._win) // As this is a public method, we make sure that it has no effect when
        // called after dispose().
        return;
        this._updateQueue.add(compute);
        this._lastUpdateQueueTime = Date.now();
        this._scheduledUpdatePositions();
    }
    _scheduledUpdatePositions() {
        if (this._updateTimer) return;
        this._updateTimer = this._win?.().setTimeout(()=>{
            delete this._updateTimer;
            // updatePositions() might be called quite a lot during the scrolling.
            // So, instead of clearing the timeout and scheduling a new one, we
            // check if enough time has passed since the last updatePositions() call
            // and only schedule a new one if not.
            // At maximum, we will update dummy inputs positions
            // _updateDummyInputsTimeout * 2 after the last updatePositions() call.
            if (this._lastUpdateQueueTime + $f8063a7f7d87cb7c$var$_updateDummyInputsTimeout <= Date.now()) {
                // A cache for current bulk of updates to reduce getComputedStyle() calls.
                const scrollTopLeftCache = new Map();
                const setTopLeftCallbacks = [];
                for (const compute of this._updateQueue)setTopLeftCallbacks.push(compute(scrollTopLeftCache));
                this._updateQueue.clear();
                // We're splitting the computation of offsets and setting them to avoid extra
                // reflows.
                for (const setTopLeft of setTopLeftCallbacks)setTopLeft();
                // Explicitly clear to not hold references till the next garbage collection.
                scrollTopLeftCache.clear();
            } else this._scheduledUpdatePositions();
        }, $f8063a7f7d87cb7c$var$_updateDummyInputsTimeout);
    }
}
/**
 * Parent class that encapsulates the behaviour of dummy inputs (focus sentinels)
 */ class $f8063a7f7d87cb7c$var$DummyInputManagerCore {
    constructor(tabster, element, manager, priority, sys, outsideByDefault, callForDefaultAction){
        this._wrappers = [];
        this._isOutside = false;
        this._transformElements = new Set();
        this._onFocusIn = (dummyInput, isBackward, relatedTarget)=>{
            this._onFocus(true, dummyInput, isBackward, relatedTarget);
        };
        this._onFocusOut = (dummyInput, isBackward, relatedTarget)=>{
            this._onFocus(false, dummyInput, isBackward, relatedTarget);
        };
        this.moveOut = (backwards)=>{
            const first = this._firstDummy;
            const last = this._lastDummy;
            if (first && last) {
                // For the sake of performance optimization, the dummy input
                // position in the DOM updates asynchronously from the DOM change.
                // Calling _ensurePosition() to make sure the position is correct.
                this._ensurePosition();
                const firstInput = first.input;
                const lastInput = last.input;
                const element = this._element?.get();
                if (firstInput && lastInput && element) {
                    let toFocus;
                    if (backwards) {
                        firstInput.tabIndex = 0;
                        toFocus = firstInput;
                    } else {
                        lastInput.tabIndex = 0;
                        toFocus = lastInput;
                    }
                    if (toFocus) (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(toFocus);
                }
            }
        };
        /**
         * Prepares to move focus out of the given element by focusing
         * one of the dummy inputs and setting the `useDefaultAction` flag
         * @param backwards focus moving to an element behind the given element
         */ this.moveOutWithDefaultAction = (backwards, relatedEvent)=>{
            const first = this._firstDummy;
            const last = this._lastDummy;
            if (first && last) {
                // For the sake of performance optimization, the dummy input
                // position in the DOM updates asynchronously from the DOM change.
                // Calling _ensurePosition() to make sure the position is correct.
                this._ensurePosition();
                const firstInput = first.input;
                const lastInput = last.input;
                const element = this._element?.get();
                if (firstInput && lastInput && element) {
                    let toFocus;
                    if (backwards) {
                        if (!first.isOutside && this._tabster.focusable.isFocusable(element, true, true, true)) toFocus = element;
                        else {
                            first.useDefaultAction = true;
                            firstInput.tabIndex = 0;
                            toFocus = firstInput;
                        }
                    } else {
                        last.useDefaultAction = true;
                        lastInput.tabIndex = 0;
                        toFocus = lastInput;
                    }
                    if (toFocus && (0, $8031a5e97995bd92$export$716a11175c03fb4e)(element, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                        by: "root",
                        owner: element,
                        next: null,
                        relatedEvent: relatedEvent
                    }))) (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(toFocus);
                }
            }
        };
        this.setTabbable = (manager, tabbable)=>{
            for (const w of this._wrappers)if (w.manager === manager) {
                w.tabbable = tabbable;
                break;
            }
            const wrapper = this._getCurrent();
            if (wrapper) {
                const tabIndex = wrapper.tabbable ? 0 : -1;
                let input = this._firstDummy?.input;
                if (input) input.tabIndex = tabIndex;
                input = this._lastDummy?.input;
                if (input) input.tabIndex = tabIndex;
            }
        };
        /**
         * Adds dummy inputs as the first and last child of the given element
         * Called each time the children under the element is mutated
         */ this._addDummyInputs = ()=>{
            if (this._addTimer) return;
            this._addTimer = this._getWindow().setTimeout(()=>{
                delete this._addTimer;
                this._ensurePosition();
                this._addTransformOffsets();
            }, 0);
        };
        this._addTransformOffsets = ()=>{
            this._tabster._dummyObserver.updatePositions(this._computeTransformOffsets);
        };
        this._computeTransformOffsets = (scrollTopLeftCache)=>{
            const from = this._firstDummy?.input || this._lastDummy?.input;
            const transformElements = this._transformElements;
            const newTransformElements = new Set();
            let scrollTop = 0;
            let scrollLeft = 0;
            const win = this._getWindow();
            for(let element = from; element && element.nodeType === Node.ELEMENT_NODE; element = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(element)){
                let scrollTopLeft = scrollTopLeftCache.get(element);
                // getComputedStyle() and element.scrollLeft/Top() cause style recalculation,
                // so we cache the result across all elements in the current bulk.
                if (scrollTopLeft === undefined) {
                    const transform = win.getComputedStyle(element).transform;
                    if (transform && transform !== "none") scrollTopLeft = {
                        scrollTop: element.scrollTop,
                        scrollLeft: element.scrollLeft
                    };
                    scrollTopLeftCache.set(element, scrollTopLeft || null);
                }
                if (scrollTopLeft) {
                    newTransformElements.add(element);
                    if (!transformElements.has(element)) (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(element, "scroll", this._addTransformOffsets);
                    scrollTop += scrollTopLeft.scrollTop;
                    scrollLeft += scrollTopLeft.scrollLeft;
                }
            }
            for (const el of transformElements)if (!newTransformElements.has(el)) (0, $8031a5e97995bd92$export$b03e9483f936dccb)(el, "scroll", this._addTransformOffsets);
            this._transformElements = newTransformElements;
            return ()=>{
                this._firstDummy?.setTopLeft(scrollTop, scrollLeft);
                this._lastDummy?.setTopLeft(scrollTop, scrollLeft);
            };
        };
        const el = element.get();
        if (!el) throw new Error("No element");
        this._tabster = tabster;
        this._getWindow = tabster.getWindow;
        this._callForDefaultAction = callForDefaultAction;
        const instance = el.__tabsterDummy;
        (instance || this)._wrappers.push({
            manager: manager,
            priority: priority,
            tabbable: true
        });
        if (instance) return instance;
        el.__tabsterDummy = this;
        // Some elements allow only specific types of direct descendants and we need to
        // put our dummy inputs inside or outside of the element accordingly.
        const forcedDummyPosition = sys?.dummyInputsPosition;
        const tagName = el.tagName;
        this._isOutside = !forcedDummyPosition ? (outsideByDefault || tagName === "UL" || tagName === "OL" || tagName === "TABLE") && !(tagName === "LI" || tagName === "TD" || tagName === "TH") : forcedDummyPosition === (0, $43f171f5f7088580$export$982c91672ba981ed).Outside;
        this._firstDummy = new $f8063a7f7d87cb7c$export$98321245064bc252(this._getWindow, this._isOutside, {
            isFirst: true
        }, element);
        this._lastDummy = new $f8063a7f7d87cb7c$export$98321245064bc252(this._getWindow, this._isOutside, {
            isFirst: false
        }, element);
        // We will be checking dummy input parents to see if their child list have changed.
        // So, it is enough to have just one of the inputs observed, because
        // both dummy inputs always have the same parent.
        const dummyElement = this._firstDummy.input;
        dummyElement && tabster._dummyObserver.add(dummyElement, this._addDummyInputs);
        this._firstDummy.onFocusIn = this._onFocusIn;
        this._firstDummy.onFocusOut = this._onFocusOut;
        this._lastDummy.onFocusIn = this._onFocusIn;
        this._lastDummy.onFocusOut = this._onFocusOut;
        this._element = element;
        this._addDummyInputs();
    }
    dispose(manager, force) {
        const wrappers = this._wrappers = this._wrappers.filter((w)=>w.manager !== manager && !force);
        if (wrappers.length === 0) {
            delete (this._element?.get()).__tabsterDummy;
            for (const el of this._transformElements)(0, $8031a5e97995bd92$export$b03e9483f936dccb)(el, "scroll", this._addTransformOffsets);
            this._transformElements.clear();
            const win = this._getWindow();
            if (this._addTimer) {
                win.clearTimeout(this._addTimer);
                delete this._addTimer;
            }
            const dummyElement = this._firstDummy?.input;
            dummyElement && this._tabster._dummyObserver.remove(dummyElement);
            this._firstDummy?.dispose();
            this._lastDummy?.dispose();
        }
    }
    _onFocus(isIn, dummyInput, isBackward, relatedTarget) {
        const wrapper = this._getCurrent();
        if (wrapper && (!dummyInput.useDefaultAction || this._callForDefaultAction)) wrapper.manager.getHandler(isIn)?.(dummyInput, isBackward, relatedTarget);
    }
    _getCurrent() {
        this._wrappers.sort((a, b)=>{
            if (a.tabbable !== b.tabbable) return a.tabbable ? -1 : 1;
            return a.priority - b.priority;
        });
        return this._wrappers[0];
    }
    _ensurePosition() {
        const element = this._element?.get();
        const firstDummyInput = this._firstDummy?.input;
        const lastDummyInput = this._lastDummy?.input;
        if (!element || !firstDummyInput || !lastDummyInput) return;
        if (this._isOutside) {
            const elementParent = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentNode(element);
            if (elementParent) {
                const nextSibling = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextSibling(element);
                if (nextSibling !== lastDummyInput) (0, $1f57f26a88fe463d$export$df3a06d6289f983e).insertBefore(elementParent, lastDummyInput, nextSibling);
                if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).getPreviousElementSibling(element) !== firstDummyInput) (0, $1f57f26a88fe463d$export$df3a06d6289f983e).insertBefore(elementParent, firstDummyInput, element);
            }
        } else {
            if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).getLastElementChild(element) !== lastDummyInput) (0, $1f57f26a88fe463d$export$df3a06d6289f983e).appendChild(element, lastDummyInput);
            const firstElementChild = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstElementChild(element);
            if (firstElementChild && firstElementChild !== firstDummyInput && firstElementChild.parentNode) (0, $1f57f26a88fe463d$export$df3a06d6289f983e).insertBefore(firstElementChild.parentNode, firstDummyInput, firstElementChild);
        }
    }
}
function $f8063a7f7d87cb7c$export$6c7070ee46ec4271(element) {
    return element?.__tabsterDummyContainer?.get() || null;
}



/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
function $89b61763407325c5$export$374a8d854973d904(props, plain) {
    const attr = JSON.stringify(props);
    if (plain === true) return attr;
    return {
        [(0, $43f171f5f7088580$export$a1195ad1c253d145)]: attr
    };
}
function $89b61763407325c5$export$4e343f66f0caa3b1(props, newProps) {
    for (const key of Object.keys(newProps)){
        const value = newProps[key];
        if (value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        props[key] = value;
        else delete props[key];
    }
}
function $89b61763407325c5$export$ab3e73b3b3dbdbbc(element, newProps, update) {
    let props;
    if (update) {
        const attr = element.getAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145));
        if (attr) try {
            props = JSON.parse(attr);
        } catch (e) {}
    }
    if (!props) props = {};
    $89b61763407325c5$export$4e343f66f0caa3b1(props, newProps);
    if (Object.keys(props).length > 0) element.setAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145), $89b61763407325c5$export$374a8d854973d904(props, true));
    else element.removeAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145));
}


function $7fd0b2ef4cf9c004$var$_setInformativeStyle(weakElement, remove, id) {}
class $7fd0b2ef4cf9c004$var$RootDummyManager extends (0, $f8063a7f7d87cb7c$export$2b3665f1498b1a50) {
    constructor(tabster, element, setFocused, sys){
        super(tabster, element, (0, $f8063a7f7d87cb7c$export$96ba7a05d53985a3).Root, sys, undefined, true);
        this._onDummyInputFocus = (dummyInput)=>{
            if (dummyInput.useDefaultAction) // When we've reached the last focusable element, we want to let the browser
            // to move the focus outside of the page. In order to do that we're synchronously
            // calling focus() of the dummy input from the Tab key handler and allowing
            // the default action to move the focus out.
            this._setFocused(false);
            else {
                // The only way a dummy input gets focused is during the keyboard navigation.
                this._tabster.keyboardNavigation.setNavigatingWithKeyboard(true);
                const element = this._element.get();
                if (element) {
                    this._setFocused(true);
                    const toFocus = this._tabster.focusedElement.getFirstOrLastTabbable(dummyInput.isFirst, {
                        container: element,
                        ignoreAccessibility: true
                    });
                    if (toFocus) {
                        (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(toFocus);
                        return;
                    }
                }
                dummyInput.input?.blur();
            }
        };
        this._setHandlers(this._onDummyInputFocus);
        this._tabster = tabster;
        this._setFocused = setFocused;
    }
}
class $7fd0b2ef4cf9c004$export$be92b6f5f03c0fe9 extends (0, $8031a5e97995bd92$export$512356fecf866417) {
    constructor(tabster, element, onDispose, props, sys){
        super(tabster, element, props);
        this._isFocused = false;
        this._setFocused = (hasFocused)=>{
            if (this._setFocusedTimer) {
                this._tabster.getWindow().clearTimeout(this._setFocusedTimer);
                delete this._setFocusedTimer;
            }
            if (this._isFocused === hasFocused) return;
            const element = this._element.get();
            if (element) {
                if (hasFocused) {
                    this._isFocused = true;
                    this._dummyManager?.setTabbable(false);
                    (0, $8031a5e97995bd92$export$716a11175c03fb4e)(element, new (0, $b6b59d8a07a2383a$export$8606e9d746120bb0)({
                        element: element
                    }));
                } else this._setFocusedTimer = this._tabster.getWindow().setTimeout(()=>{
                    delete this._setFocusedTimer;
                    this._isFocused = false;
                    this._dummyManager?.setTabbable(true);
                    (0, $8031a5e97995bd92$export$716a11175c03fb4e)(element, new (0, $b6b59d8a07a2383a$export$4122e0ec6dadc59a)({
                        element: element
                    }));
                }, 0);
            }
        };
        this._onFocusIn = (event)=>{
            const getParent = this._tabster.getParent;
            const rootElement = this._element.get();
            let curElement = event.composedPath()[0];
            do {
                if (curElement === rootElement) {
                    this._setFocused(true);
                    return;
                }
                curElement = curElement && getParent(curElement);
            }while (curElement);
        };
        this._onFocusOut = ()=>{
            this._setFocused(false);
        };
        this._onDispose = onDispose;
        const win = tabster.getWindow;
        this.uid = (0, $8031a5e97995bd92$export$2dc82a3fd984deae)(win, element);
        this._sys = sys;
        if (tabster.controlTab || tabster.rootDummyInputs) this.addDummyInputs();
        const w = win();
        const doc = w.document;
        (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(doc, (0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), this._onFocusIn);
        (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(doc, (0, $134104a7b4fa5d8e$export$caa225efd612bb56), this._onFocusOut);
        this._add();
    }
    addDummyInputs() {
        if (!this._dummyManager) this._dummyManager = new $7fd0b2ef4cf9c004$var$RootDummyManager(this._tabster, this._element, this._setFocused, this._sys);
    }
    dispose() {
        this._onDispose(this);
        const win = this._tabster.getWindow();
        const doc = win.document;
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(doc, (0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), this._onFocusIn);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(doc, (0, $134104a7b4fa5d8e$export$caa225efd612bb56), this._onFocusOut);
        if (this._setFocusedTimer) {
            win.clearTimeout(this._setFocusedTimer);
            delete this._setFocusedTimer;
        }
        this._dummyManager?.dispose();
        this._remove();
    }
    moveOutWithDefaultAction(isBackward, relatedEvent) {
        const dummyManager = this._dummyManager;
        if (dummyManager) dummyManager.moveOutWithDefaultAction(isBackward, relatedEvent);
        else {
            const el = this.getElement();
            if (el) $7fd0b2ef4cf9c004$var$RootDummyManager.moveWithPhantomDummy(this._tabster, el, true, isBackward, relatedEvent);
        }
    }
    _add() {}
    _remove() {}
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $7fd0b2ef4cf9c004$var$validateRootProps(props) {
// TODO: Implement validation.
}
class $7fd0b2ef4cf9c004$export$21337b879fb836da {
    constructor(tabster, autoRoot){
        this._autoRootWaiting = false;
        this._roots = {};
        this._forceDummy = false;
        this.rootById = {};
        this._autoRootCreate = ()=>{
            const doc = this._win().document;
            const body = doc.body;
            if (body) {
                this._autoRootUnwait(doc);
                const props = this._autoRoot;
                if (props) {
                    (0, $89b61763407325c5$export$ab3e73b3b3dbdbbc)(body, {
                        root: props
                    }, true);
                    (0, $cac64caf55b8b085$export$5a2a13bd8eff0b2c)(this._tabster, body);
                    return (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, body)?.root;
                }
            } else if (!this._autoRootWaiting) {
                this._autoRootWaiting = true;
                (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(doc, "readystatechange", this._autoRootCreate);
            }
            return undefined;
        };
        this._onRootDispose = (root)=>{
            delete this._roots[root.id];
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        this._autoRoot = autoRoot;
        tabster.queueInit(()=>{
            if (this._autoRoot) this._autoRootCreate();
        });
    }
    _autoRootUnwait(doc) {
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(doc, "readystatechange", this._autoRootCreate);
        this._autoRootWaiting = false;
    }
    dispose() {
        const win = this._win();
        this._autoRootUnwait(win.document);
        delete this._autoRoot;
        Object.keys(this._roots).forEach((rootId)=>{
            if (this._roots[rootId]) {
                this._roots[rootId].dispose();
                delete this._roots[rootId];
            }
        });
        this.rootById = {};
    }
    createRoot(element, props, sys) {
        const newRoot = new $7fd0b2ef4cf9c004$export$be92b6f5f03c0fe9(this._tabster, element, this._onRootDispose, props, sys);
        this._roots[newRoot.id] = newRoot;
        if (this._forceDummy) newRoot.addDummyInputs();
        return newRoot;
    }
    addDummyInputs() {
        this._forceDummy = true;
        const roots = this._roots;
        for (const id of Object.keys(roots))roots[id].addDummyInputs();
    }
    static getRootByUId(getWindow, id) {
        const tabster = getWindow().__tabsterInstance;
        return tabster && tabster.root.rootById[id];
    }
    /**
     * Fetches the tabster context for an element walking up its ancestors
     *
     * @param tabster Tabster instance
     * @param element The element the tabster context should represent
     * @param options Additional options
     * @returns undefined if the element is not a child of a tabster root, otherwise all applicable tabster behaviours and configurations
     */ static getTabsterContext(tabster, element, options = {}) {
        if (!element.ownerDocument) return undefined;
        const { checkRtl: checkRtl, referenceElement: referenceElement } = options;
        const getParent = tabster.getParent;
        // Normally, the initialization starts on the next tick after the tabster
        // instance creation. However, if the application starts using it before
        // the next tick, we need to make sure the initialization is done.
        tabster.drainInitQueue();
        let root;
        let modalizer;
        let groupper;
        let mover;
        let excludedFromMover = false;
        let groupperBeforeMover;
        let modalizerInGroupper;
        let dirRightToLeft;
        let uncontrolled;
        let curElement = referenceElement || element;
        const ignoreKeydown = {};
        while(curElement && (!root || checkRtl)){
            const tabsterOnElement = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, curElement);
            if (checkRtl && dirRightToLeft === undefined) {
                const dir = curElement.dir;
                if (dir) dirRightToLeft = dir.toLowerCase() === "rtl";
            }
            if (!tabsterOnElement) {
                curElement = getParent(curElement);
                continue;
            }
            const tagName = curElement.tagName;
            if ((tabsterOnElement.uncontrolled || tagName === "IFRAME" || tagName === "WEBVIEW") && tabster.focusable.isVisible(curElement)) uncontrolled = curElement;
            if (!mover && tabsterOnElement.focusable?.excludeFromMover && !groupper) excludedFromMover = true;
            const curModalizer = tabsterOnElement.modalizer;
            const curGroupper = tabsterOnElement.groupper;
            const curMover = tabsterOnElement.mover;
            if (!modalizer && curModalizer) modalizer = curModalizer;
            if (!groupper && curGroupper && (!modalizer || curModalizer)) {
                if (modalizer) {
                    // Modalizer dominates the groupper when they are on the same node and the groupper is active.
                    if (!curGroupper.isActive() && curGroupper.getProps().tabbability && modalizer.userId !== tabster.modalizer?.activeId) {
                        modalizer = undefined;
                        groupper = curGroupper;
                    }
                    modalizerInGroupper = curGroupper;
                } else groupper = curGroupper;
            }
            if (!mover && curMover && (!modalizer || curModalizer) && (!curGroupper || curElement !== element) && curElement.contains(element) // Mover makes sense only for really inside elements, not for virutal out of the DOM order children.
            ) {
                mover = curMover;
                groupperBeforeMover = !!groupper && groupper !== curGroupper;
            }
            if (tabsterOnElement.root) root = tabsterOnElement.root;
            if (tabsterOnElement.focusable?.ignoreKeydown) Object.assign(ignoreKeydown, tabsterOnElement.focusable.ignoreKeydown);
            curElement = getParent(curElement);
        }
        // No root element could be found, try to get an auto root
        if (!root) {
            const rootAPI = tabster.root;
            const autoRoot = rootAPI._autoRoot;
            if (autoRoot) {
                if (element.ownerDocument?.body) root = rootAPI._autoRootCreate();
            }
        }
        if (groupper && !mover) groupperBeforeMover = true;
        const shouldIgnoreKeydown = (event)=>!!ignoreKeydown[event.key];
        return root ? {
            root: root,
            modalizer: modalizer,
            groupper: groupper,
            mover: mover,
            groupperBeforeMover: groupperBeforeMover,
            modalizerInGroupper: modalizerInGroupper,
            rtl: checkRtl ? !!dirRightToLeft : undefined,
            uncontrolled: uncontrolled,
            excludedFromMover: excludedFromMover,
            ignoreKeydown: shouldIgnoreKeydown
        } : undefined;
    }
    static getRoot(tabster, element) {
        const getParent = tabster.getParent;
        for(let el = element; el; el = getParent(el)){
            const root = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, el)?.root;
            if (root) return root;
        }
        return undefined;
    }
    onRoot(root, removed) {
        if (removed) delete this.rootById[root.uid];
        else this.rootById[root.uid] = root;
    }
}






class $bfdc7e60be74e4a7$export$793cfd8049a0ffa1 {
    constructor(tabster){
        this._tabster = tabster;
    }
    dispose() {
    /**/ }
    getProps(element) {
        const tabsterOnElement = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, element);
        return tabsterOnElement && tabsterOnElement.focusable || {};
    }
    isFocusable(el, includeProgrammaticallyFocusable, noVisibleCheck, noAccessibleCheck) {
        if ((0, $8031a5e97995bd92$export$b06a2f5618961e1e)(el, (0, $43f171f5f7088580$export$9352ce9777935162)) && (includeProgrammaticallyFocusable || el.tabIndex !== -1)) return (noVisibleCheck || this.isVisible(el)) && (noAccessibleCheck || this.isAccessible(el));
        return false;
    }
    isVisible(el) {
        if (!el.ownerDocument || el.nodeType !== Node.ELEMENT_NODE) return false;
        if ((0, $8031a5e97995bd92$export$d4a89a85d6c8d4c5)(el)) return false;
        const rect = el.ownerDocument.body.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) // This might happen, for example, if our <body> is in hidden <iframe>.
        return false;
        return true;
    }
    isAccessible(el) {
        for(let e = el; e; e = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(e)){
            const tabsterOnElement = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, e);
            if (this._isHidden(e)) return false;
            const ignoreDisabled = tabsterOnElement?.focusable?.ignoreAriaDisabled;
            if (!ignoreDisabled && this._isDisabled(e)) return false;
        }
        return true;
    }
    _isDisabled(el) {
        return el.hasAttribute("disabled");
    }
    _isHidden(el) {
        const attrVal = el.getAttribute("aria-hidden");
        if (attrVal && attrVal.toLowerCase() === "true") {
            if (!this._tabster.modalizer?.isAugmented(el)) return true;
        }
        return false;
    }
    findFirst(options, out) {
        return this.findElement({
            ...options
        }, out);
    }
    findLast(options, out) {
        return this.findElement({
            isBackward: true,
            ...options
        }, out);
    }
    findNext(options, out) {
        return this.findElement({
            ...options
        }, out);
    }
    findPrev(options, out) {
        return this.findElement({
            ...options,
            isBackward: true
        }, out);
    }
    findDefault(options, out) {
        return this.findElement({
            ...options,
            acceptCondition: (el)=>this.isFocusable(el, options.includeProgrammaticallyFocusable) && !!this.getProps(el).isDefault
        }, out) || null;
    }
    findAll(options) {
        return this._findElements(true, options) || [];
    }
    findElement(options, out) {
        const found = this._findElements(false, options, out);
        return found ? found[0] : found;
    }
    _findElements(isFindAll, options, out) {
        const { container: container, currentElement: currentElement = null, includeProgrammaticallyFocusable: includeProgrammaticallyFocusable, useActiveModalizer: useActiveModalizer, ignoreAccessibility: ignoreAccessibility, modalizerId: modalizerId, isBackward: isBackward, onElement: onElement } = options;
        if (!out) out = {};
        const elements = [];
        let { acceptCondition: acceptCondition } = options;
        const hasCustomCondition = !!acceptCondition;
        if (!container) return null;
        if (!acceptCondition) acceptCondition = (el)=>this.isFocusable(el, includeProgrammaticallyFocusable, false, ignoreAccessibility);
        const acceptElementState = {
            container: container,
            modalizerUserId: modalizerId === undefined && useActiveModalizer ? this._tabster.modalizer?.activeId : modalizerId || (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, container)?.modalizer?.userId,
            from: currentElement || container,
            isBackward: isBackward,
            isFindAll: isFindAll,
            acceptCondition: acceptCondition,
            hasCustomCondition: hasCustomCondition,
            includeProgrammaticallyFocusable: includeProgrammaticallyFocusable,
            ignoreAccessibility: ignoreAccessibility,
            cachedGrouppers: {},
            cachedRadioGroups: {}
        };
        const walker = (0, $8031a5e97995bd92$export$6d51b6a3304b27f5)(container.ownerDocument, container, (node)=>this._acceptElement(node, acceptElementState));
        if (!walker) return null;
        const prepareForNextElement = (shouldContinueIfNotFound)=>{
            const foundElement = acceptElementState.foundElement ?? acceptElementState.foundBackward;
            if (foundElement) elements.push(foundElement);
            if (isFindAll) {
                if (foundElement) {
                    acceptElementState.found = false;
                    delete acceptElementState.foundElement;
                    delete acceptElementState.foundBackward;
                    delete acceptElementState.fromCtx;
                    acceptElementState.from = foundElement;
                    if (onElement && !onElement(foundElement)) return false;
                }
                return !!(foundElement || shouldContinueIfNotFound);
            } else {
                if (foundElement && out) out.uncontrolled = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, foundElement)?.uncontrolled;
                return !!(shouldContinueIfNotFound && !foundElement);
            }
        };
        if (!currentElement) out.outOfDOMOrder = true;
        if (currentElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, currentElement)) walker.currentNode = currentElement;
        else if (isBackward) {
            const lastChild = (0, $8031a5e97995bd92$export$98420b9ec3fd7e2c)(container);
            if (!lastChild) return null;
            if (this._acceptElement(lastChild, acceptElementState) === NodeFilter.FILTER_ACCEPT && !prepareForNextElement(true)) {
                if (acceptElementState.skippedFocusable) out.outOfDOMOrder = true;
                return elements;
            }
            walker.currentNode = lastChild;
        }
        do if (isBackward) walker.previousNode();
        else walker.nextNode();
        while (prepareForNextElement());
        if (acceptElementState.skippedFocusable) out.outOfDOMOrder = true;
        return elements.length ? elements : null;
    }
    _acceptElement(element, state) {
        if (state.found) return NodeFilter.FILTER_ACCEPT;
        const foundBackward = state.foundBackward;
        if (foundBackward && (element === foundBackward || !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(foundBackward, element))) {
            state.found = true;
            state.foundElement = foundBackward;
            return NodeFilter.FILTER_ACCEPT;
        }
        const container = state.container;
        if (element === container) return NodeFilter.FILTER_SKIP;
        if (!(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, element)) return NodeFilter.FILTER_REJECT;
        if ((0, $f8063a7f7d87cb7c$export$6c7070ee46ec4271)(element)) return NodeFilter.FILTER_REJECT;
        if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(state.rejectElementsFrom, element)) return NodeFilter.FILTER_REJECT;
        const ctx = state.currentCtx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, element);
        // Tabster is opt in, if it is not managed, don't try and get do anything special
        if (!ctx) return NodeFilter.FILTER_SKIP;
        if ((0, $8031a5e97995bd92$export$4a2e08217cea38f4)(element)) {
            if (this.isFocusable(element, undefined, true, true)) state.skippedFocusable = true;
            return NodeFilter.FILTER_SKIP;
        }
        // We assume iframes are focusable because native tab behaviour would tab inside.
        // But we do it only during the standard search when there is no custom accept
        // element condition.
        if (!state.hasCustomCondition && (element.tagName === "IFRAME" || element.tagName === "WEBVIEW")) {
            if (this.isVisible(element) && ctx.modalizer?.userId === this._tabster.modalizer?.activeId) {
                state.found = true;
                state.rejectElementsFrom = state.foundElement = element;
                return NodeFilter.FILTER_ACCEPT;
            } else return NodeFilter.FILTER_REJECT;
        }
        if (!state.ignoreAccessibility && !this.isAccessible(element)) {
            if (this.isFocusable(element, false, true, true)) state.skippedFocusable = true;
            return NodeFilter.FILTER_REJECT;
        }
        let result;
        let fromCtx = state.fromCtx;
        if (!fromCtx) fromCtx = state.fromCtx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, state.from);
        const fromMover = fromCtx?.mover;
        let groupper = ctx.groupper;
        let mover = ctx.mover;
        result = this._tabster.modalizer?.acceptElement(element, state);
        if (result !== undefined) state.skippedFocusable = true;
        if (result === undefined && (groupper || mover || fromMover)) {
            const groupperElement = groupper?.getElement();
            const fromMoverElement = fromMover?.getElement();
            let moverElement = mover?.getElement();
            if (moverElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(fromMoverElement, moverElement) && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, fromMoverElement) && (!groupperElement || !mover || (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(fromMoverElement, groupperElement))) {
                mover = fromMover;
                moverElement = fromMoverElement;
            }
            if (groupperElement) {
                if (groupperElement === container || !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, groupperElement)) groupper = undefined;
                else if (!(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(groupperElement, element)) // _acceptElement() callback is called during the tree walking.
                // Given the potentiality of virtual parents (driven by the custom getParent() function),
                // we need to make sure that the groupper from the current element's context is not,
                // portaling us out of the DOM order.
                return NodeFilter.FILTER_REJECT;
            }
            if (moverElement) {
                if (!(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, moverElement)) mover = undefined;
                else if (!(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(moverElement, element)) // _acceptElement() callback is called during the tree walking.
                // Given the potentiality of virtual parents (driven by the custom getParent() function),
                // we need to make sure that the mover from the current element's context is not,
                // portaling us out of the DOM order.
                return NodeFilter.FILTER_REJECT;
            }
            if (groupper && mover) {
                if (moverElement && groupperElement && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(groupperElement, moverElement)) mover = undefined;
                else groupper = undefined;
            }
            if (groupper) result = groupper.acceptElement(element, state);
            if (mover) result = mover.acceptElement(element, state);
        }
        if (result === undefined) {
            result = state.acceptCondition(element) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            if (result === NodeFilter.FILTER_SKIP && this.isFocusable(element, false, true, true)) state.skippedFocusable = true;
        }
        if (result === NodeFilter.FILTER_ACCEPT && !state.found) {
            if (!state.isFindAll && (0, $8031a5e97995bd92$export$fb52e7e103ecac84)(element) && !element.checked) {
                // We need to mimic the browser's behaviour to skip unchecked radio buttons.
                const radioGroupName = element.name;
                let radioGroup = state.cachedRadioGroups[radioGroupName];
                if (!radioGroup) {
                    radioGroup = (0, $8031a5e97995bd92$export$973f3e797b900544)(element);
                    if (radioGroup) state.cachedRadioGroups[radioGroupName] = radioGroup;
                }
                if (radioGroup?.checked && radioGroup.checked !== element) // Currently found element is a radio button in a group that has another radio button checked.
                return NodeFilter.FILTER_SKIP;
            }
            if (state.isBackward) {
                // When TreeWalker goes backwards, it visits the container first,
                // then it goes inside. So, if the container is accepted, we remember it,
                // but allowing the TreeWalker to check inside.
                state.foundBackward = element;
                result = NodeFilter.FILTER_SKIP;
            } else {
                state.found = true;
                state.foundElement = element;
            }
        }
        return result;
    }
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26 = {
    Tab: "Tab",
    Enter: "Enter",
    Escape: "Escape",
    Space: " ",
    PageUp: "PageUp",
    PageDown: "PageDown",
    End: "End",
    Home: "Home",
    ArrowLeft: "ArrowLeft",
    ArrowUp: "ArrowUp",
    ArrowRight: "ArrowRight",
    ArrowDown: "ArrowDown"
};









/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $fd60216fc956f36d$export$d26086b469ecdbcc {
    constructor(){
        this._callbacks = [];
    }
    dispose() {
        this._callbacks = [];
        delete this._val;
    }
    subscribe(callback) {
        const callbacks = this._callbacks;
        const index = callbacks.indexOf(callback);
        if (index < 0) callbacks.push(callback);
    }
    subscribeFirst(callback) {
        const callbacks = this._callbacks;
        const index = callbacks.indexOf(callback);
        if (index >= 0) callbacks.splice(index, 1);
        callbacks.unshift(callback);
    }
    unsubscribe(callback) {
        const index = this._callbacks.indexOf(callback);
        if (index >= 0) this._callbacks.splice(index, 1);
    }
    setVal(val, detail) {
        if (this._val === val) return;
        this._val = val;
        this._callCallbacks(val, detail);
    }
    getVal() {
        return this._val;
    }
    trigger(val, detail) {
        this._callCallbacks(val, detail);
    }
    _callCallbacks(val, detail) {
        this._callbacks.forEach((callback)=>callback(val, detail));
    }
}


function $018eb0b75e35c758$var$getUncontrolledCompletelyContainer(tabster, element) {
    const getParent = tabster.getParent;
    let el = element;
    do {
        const uncontrolledOnElement = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, el)?.uncontrolled;
        if (uncontrolledOnElement && tabster.uncontrolled.isUncontrolledCompletely(el, !!uncontrolledOnElement.completely)) return el;
        el = getParent(el);
    }while (el);
    return undefined;
}
const $018eb0b75e35c758$var$AsyncFocusIntentPriorityBySource = {
    [(0, $43f171f5f7088580$export$ef584e37c331a849).Restorer]: 0,
    [(0, $43f171f5f7088580$export$ef584e37c331a849).Deloser]: 1,
    [(0, $43f171f5f7088580$export$ef584e37c331a849).EscapeGroupper]: 2
};
class $018eb0b75e35c758$export$406337e29e552119 extends (0, $fd60216fc956f36d$export$d26086b469ecdbcc) {
    static{
        this.isTabbing = false;
    }
    constructor(tabster, getWindow){
        super();
        this._init = ()=>{
            const win = this._win();
            const doc = win.document;
            // Add these event listeners as capture - we want Tabster to run before user event handlers
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(doc, (0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), this._onFocusIn, true);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(doc, (0, $134104a7b4fa5d8e$export$caa225efd612bb56), this._onFocusOut, true);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, "keydown", this._onKeyDown, true);
            const activeElement = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getActiveElement(doc);
            if (activeElement && activeElement !== doc.body) this._setFocusedElement(activeElement);
            this.subscribe(this._onChanged);
        };
        this._onFocusIn = (e)=>{
            const target = e.composedPath()[0];
            if (target) this._setFocusedElement(target, e.detail.relatedTarget, e.detail.isFocusedProgrammatically);
        };
        this._onFocusOut = (e)=>{
            this._setFocusedElement(undefined, e.detail?.originalEvent.relatedTarget);
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._validateFocusedElement = (element)=>{
        // TODO: Make sure this is not needed anymore and write tests.
        };
        this._onKeyDown = (event)=>{
            if (event.key !== (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Tab || event.ctrlKey) return;
            const currentElement = this.getVal();
            if (!currentElement || !currentElement.ownerDocument || currentElement.contentEditable === "true") return;
            const tabster = this._tabster;
            const controlTab = tabster.controlTab;
            const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, currentElement);
            if (!ctx || ctx.ignoreKeydown(event)) return;
            const isBackward = event.shiftKey;
            const next = $018eb0b75e35c758$export$406337e29e552119.findNextTabbable(tabster, ctx, undefined, currentElement, undefined, isBackward, true);
            const rootElement = ctx.root.getElement();
            if (!rootElement) return;
            const nextElement = next?.element;
            const uncontrolledCompletelyContainer = $018eb0b75e35c758$var$getUncontrolledCompletelyContainer(tabster, currentElement);
            if (nextElement) {
                const nextUncontrolled = next.uncontrolled;
                if (ctx.uncontrolled || (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(nextUncontrolled, currentElement)) {
                    if (!next.outOfDOMOrder && nextUncontrolled === ctx.uncontrolled || uncontrolledCompletelyContainer && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(uncontrolledCompletelyContainer, nextElement)) // Nothing to do, everything will be done by the browser or something
                    // that controls the uncontrolled area.
                    return;
                    // We are in uncontrolled area. We allow whatever controls it to move
                    // focus, but we add a phantom dummy to make sure the focus is moved
                    // to the correct place if the uncontrolled area allows default action.
                    // We only need that in the controlled mode, because in uncontrolled
                    // mode we have dummy inputs around everything that redirects focus.
                    (0, $f8063a7f7d87cb7c$export$2b3665f1498b1a50).addPhantomDummyWithTarget(tabster, currentElement, isBackward, nextElement);
                    return;
                }
                if (nextUncontrolled && tabster.focusable.isVisible(nextUncontrolled) || nextElement.tagName === "IFRAME" && tabster.focusable.isVisible(nextElement)) {
                    // For iframes and uncontrolled areas we always want to use default action to
                    // move focus into.
                    if ((0, $8031a5e97995bd92$export$716a11175c03fb4e)(rootElement, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                        by: "root",
                        owner: rootElement,
                        next: nextElement,
                        relatedEvent: event
                    }))) (0, $f8063a7f7d87cb7c$export$2b3665f1498b1a50).moveWithPhantomDummy(tabster, nextUncontrolled ?? nextElement, false, isBackward, event);
                    return;
                }
                if (controlTab || next?.outOfDOMOrder) {
                    if ((0, $8031a5e97995bd92$export$716a11175c03fb4e)(rootElement, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                        by: "root",
                        owner: rootElement,
                        next: nextElement,
                        relatedEvent: event
                    }))) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(nextElement);
                    }
                }
            } else if (!uncontrolledCompletelyContainer && (0, $8031a5e97995bd92$export$716a11175c03fb4e)(rootElement, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                by: "root",
                owner: rootElement,
                next: null,
                relatedEvent: event
            }))) ctx.root.moveOutWithDefaultAction(isBackward, event);
        };
        this._onChanged = (element, detail)=>{
            if (element) (0, $8031a5e97995bd92$export$716a11175c03fb4e)(element, new (0, $b6b59d8a07a2383a$export$2409322399d631d9)(detail));
            else {
                const last = this._lastVal?.get();
                if (last) {
                    const d = {
                        ...detail
                    };
                    const lastCtx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, last);
                    const modalizerId = lastCtx?.modalizer?.userId;
                    if (modalizerId) d.modalizerId = modalizerId;
                    (0, $8031a5e97995bd92$export$716a11175c03fb4e)(last, new (0, $b6b59d8a07a2383a$export$731508468a1b9ed2)(d));
                }
            }
        };
        this._tabster = tabster;
        this._win = getWindow;
        tabster.queueInit(this._init);
    }
    dispose() {
        super.dispose();
        const win = this._win();
        const doc = win.document;
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(doc, (0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), this._onFocusIn, true);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(doc, (0, $134104a7b4fa5d8e$export$caa225efd612bb56), this._onFocusOut, true);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, "keydown", this._onKeyDown, true);
        this.unsubscribe(this._onChanged);
        const asyncFocus = this._asyncFocus;
        if (asyncFocus) {
            win.clearTimeout(asyncFocus.timeout);
            delete this._asyncFocus;
        }
        delete $018eb0b75e35c758$export$406337e29e552119._lastResetElement;
        delete this._nextVal;
        delete this._lastVal;
    }
    static forgetMemorized(instance, parent) {
        let wel = $018eb0b75e35c758$export$406337e29e552119._lastResetElement;
        let el = wel && wel.get();
        if (el && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(parent, el)) delete $018eb0b75e35c758$export$406337e29e552119._lastResetElement;
        el = instance._nextVal?.element?.get();
        if (el && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(parent, el)) delete instance._nextVal;
        wel = instance._lastVal;
        el = wel && wel.get();
        if (el && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(parent, el)) delete instance._lastVal;
    }
    getFocusedElement() {
        return this.getVal();
    }
    getLastFocusedElement() {
        let el = this._lastVal?.get();
        if (!el || el && !(0, $8031a5e97995bd92$export$b9e78d52333734f8)(el.ownerDocument, el)) this._lastVal = el = undefined;
        return el;
    }
    focus(element, noFocusedProgrammaticallyFlag, noAccessibleCheck, focusOptions) {
        if (!this._tabster.focusable.isFocusable(element, noFocusedProgrammaticallyFlag, false, noAccessibleCheck)) return false;
        const options = typeof focusOptions === "boolean" ? {
            preventScroll: focusOptions
        } : focusOptions;
        element.focus(options);
        return true;
    }
    focusDefault(container) {
        const el = this._tabster.focusable.findDefault({
            container: container
        });
        if (el) {
            this._tabster.focusedElement.focus(el);
            return true;
        }
        return false;
    }
    getFirstOrLastTabbable(isFirst, props) {
        const { container: container, ignoreAccessibility: ignoreAccessibility } = props;
        let toFocus;
        if (container) {
            const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, container);
            if (ctx) toFocus = $018eb0b75e35c758$export$406337e29e552119.findNextTabbable(this._tabster, ctx, container, undefined, undefined, !isFirst, ignoreAccessibility)?.element;
        }
        if (toFocus && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, toFocus)) toFocus = undefined;
        return toFocus || undefined;
    }
    _focusFirstOrLast(isFirst, props) {
        const toFocus = this.getFirstOrLastTabbable(isFirst, props);
        if (toFocus) {
            this.focus(toFocus, false, true);
            return true;
        }
        return false;
    }
    focusFirst(props) {
        return this._focusFirstOrLast(true, props);
    }
    focusLast(props) {
        return this._focusFirstOrLast(false, props);
    }
    resetFocus(container) {
        if (!this._tabster.focusable.isVisible(container)) return false;
        if (!this._tabster.focusable.isFocusable(container, true, true, true)) {
            const prevTabIndex = container.getAttribute("tabindex");
            const prevAriaHidden = container.getAttribute("aria-hidden");
            container.tabIndex = -1;
            container.setAttribute("aria-hidden", "true");
            $018eb0b75e35c758$export$406337e29e552119._lastResetElement = new (0, $8031a5e97995bd92$export$e61d664de92eea96)(container);
            this.focus(container, true, true);
            this._setOrRemoveAttribute(container, "tabindex", prevTabIndex);
            this._setOrRemoveAttribute(container, "aria-hidden", prevAriaHidden);
        } else this.focus(container);
        return true;
    }
    requestAsyncFocus(source, callback, delay) {
        const win = this._tabster.getWindow();
        const currentAsyncFocus = this._asyncFocus;
        if (currentAsyncFocus) {
            if ($018eb0b75e35c758$var$AsyncFocusIntentPriorityBySource[source] > $018eb0b75e35c758$var$AsyncFocusIntentPriorityBySource[currentAsyncFocus.source]) // Previously registered intent has higher priority.
            return;
            // New intent has higher priority.
            win.clearTimeout(currentAsyncFocus.timeout);
        }
        this._asyncFocus = {
            source: source,
            callback: callback,
            timeout: win.setTimeout(()=>{
                this._asyncFocus = undefined;
                callback();
            }, delay)
        };
    }
    cancelAsyncFocus(source) {
        const asyncFocus = this._asyncFocus;
        if (asyncFocus?.source === source) {
            this._tabster.getWindow().clearTimeout(asyncFocus.timeout);
            this._asyncFocus = undefined;
        }
    }
    _setOrRemoveAttribute(element, name, value) {
        if (value === null) element.removeAttribute(name);
        else element.setAttribute(name, value);
    }
    _setFocusedElement(element, relatedTarget, isFocusedProgrammatically) {
        if (this._tabster._noop) return;
        const detail = {
            relatedTarget: relatedTarget
        };
        if (element) {
            const lastResetElement = $018eb0b75e35c758$export$406337e29e552119._lastResetElement?.get();
            $018eb0b75e35c758$export$406337e29e552119._lastResetElement = undefined;
            if (lastResetElement === element || (0, $8031a5e97995bd92$export$4a2e08217cea38f4)(element)) return;
            detail.isFocusedProgrammatically = isFocusedProgrammatically;
            const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, element);
            const modalizerId = ctx?.modalizer?.userId;
            if (modalizerId) detail.modalizerId = modalizerId;
        }
        const nextVal = this._nextVal = {
            element: element ? new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element) : undefined,
            detail: detail
        };
        if (element && element !== this._val) this._validateFocusedElement(element);
        // _validateFocusedElement() might cause the refocus which will trigger
        // another call to this function. Making sure that the value is correct.
        if (this._nextVal === nextVal) this.setVal(element, detail);
        this._nextVal = undefined;
    }
    setVal(val, detail) {
        super.setVal(val, detail);
        if (val) this._lastVal = new (0, $8031a5e97995bd92$export$e61d664de92eea96)(val);
    }
    static findNextTabbable(tabster, ctx, container, currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const actualContainer = container || ctx.root.getElement();
        if (!actualContainer) return null;
        let next = null;
        const isTabbingTimer = $018eb0b75e35c758$export$406337e29e552119._isTabbingTimer;
        const win = tabster.getWindow();
        if (isTabbingTimer) win.clearTimeout(isTabbingTimer);
        $018eb0b75e35c758$export$406337e29e552119.isTabbing = true;
        $018eb0b75e35c758$export$406337e29e552119._isTabbingTimer = win.setTimeout(()=>{
            delete $018eb0b75e35c758$export$406337e29e552119._isTabbingTimer;
            $018eb0b75e35c758$export$406337e29e552119.isTabbing = false;
        }, 0);
        const modalizer = ctx.modalizer;
        const groupper = ctx.groupper;
        const mover = ctx.mover;
        const callFindNext = (what)=>{
            next = what.findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility);
            if (currentElement && !next?.element) {
                const parentElement = what !== modalizer && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(what.getElement());
                if (parentElement) {
                    const parentCtx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, currentElement, {
                        referenceElement: parentElement
                    });
                    if (parentCtx) {
                        const currentScopeElement = what.getElement();
                        const newCurrent = isBackward ? currentScopeElement : currentScopeElement && (0, $8031a5e97995bd92$export$98420b9ec3fd7e2c)(currentScopeElement) || currentScopeElement;
                        if (newCurrent) {
                            next = $018eb0b75e35c758$export$406337e29e552119.findNextTabbable(tabster, parentCtx, container, newCurrent, parentElement, isBackward, ignoreAccessibility);
                            if (next) next.outOfDOMOrder = true;
                        }
                    }
                }
            }
        };
        if (groupper && mover) callFindNext(ctx.groupperBeforeMover ? groupper : mover);
        else if (groupper) callFindNext(groupper);
        else if (mover) callFindNext(mover);
        else if (modalizer) callFindNext(modalizer);
        else {
            const findProps = {
                container: actualContainer,
                currentElement: currentElement,
                referenceElement: referenceElement,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            const nextElement = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            next = {
                element: nextElement,
                outOfDOMOrder: findPropsOut.outOfDOMOrder,
                uncontrolled: findPropsOut.uncontrolled
            };
        }
        return next;
    }
}



/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 

class $aba4af735104c34b$export$86d38b407cbe7828 extends (0, $fd60216fc956f36d$export$d26086b469ecdbcc) {
    constructor(getWindow){
        super();
        this._onChange = (isNavigatingWithKeyboard)=>{
            this.setVal(isNavigatingWithKeyboard, undefined);
        };
        this._keyborg = (0, $134104a7b4fa5d8e$export$9ccd7417191c0e4b)(getWindow());
        this._keyborg.subscribe(this._onChange);
    }
    dispose() {
        super.dispose();
        if (this._keyborg) {
            this._keyborg.unsubscribe(this._onChange);
            (0, $134104a7b4fa5d8e$export$6c71cf8529293a97)(this._keyborg);
            delete this._keyborg;
        }
    }
    setNavigatingWithKeyboard(isNavigatingWithKeyboard) {
        this._keyborg?.setVal(isNavigatingWithKeyboard);
    }
    isNavigatingWithKeyboard() {
        return !!this._keyborg?.isNavigatingWithKeyboard();
    }
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 



function $7709e12a1e72c316$export$46debc62fc90cfe5(doc, tabster, updateTabsterByAttribute, syncState) {
    if (typeof MutationObserver === "undefined") return ()=>{
    /* Noop */ };
    const getWindow = tabster.getWindow;
    let elementByUId;
    const onMutation = (mutations)=>{
        const removedNodes = new Set();
        for (const mutation of mutations){
            const target = mutation.target;
            const removed = mutation.removedNodes;
            const added = mutation.addedNodes;
            if (mutation.type === "attributes") {
                if (mutation.attributeName === (0, $43f171f5f7088580$export$a1195ad1c253d145)) // removedNodes helps to make sure we are not recreating things
                // for the removed elements.
                // For some reason, if we do removeChild() and setAttribute() on the
                // removed child in the same tick, both the child removal and the attribute
                // change will be present in the mutation records. And the attribute change
                // will follow the child removal.
                // So, we remember the removed nodes and ignore attribute changes for them.
                {
                    if (!removedNodes.has(target)) updateTabsterByAttribute(tabster, target);
                }
            } else {
                for (const removedNode of removed){
                    removedNodes.add(removedNode);
                    updateTabsterElements(removedNode, true);
                    tabster._dummyObserver.domChanged?.(target);
                }
                for (const addedNode of added){
                    updateTabsterElements(addedNode);
                    tabster._dummyObserver.domChanged?.(target);
                }
            }
        }
        removedNodes.clear();
        tabster.modalizer?.hiddenUpdate();
    };
    function updateTabsterElements(node, removed) {
        if (!elementByUId) elementByUId = (0, $8031a5e97995bd92$export$4f20612bacd919f5)(getWindow).elementByUId;
        processNode(node, removed);
        const walker = (0, $8031a5e97995bd92$export$6d51b6a3304b27f5)(doc, node, (element)=>{
            return processNode(element, removed);
        });
        if (walker) {
            while(walker.nextNode());
        }
    }
    function processNode(element, removed) {
        if (!element.getAttribute) // It might actually be a text node.
        return NodeFilter.FILTER_SKIP;
        const uid = element.__tabsterElementUID;
        if (uid && elementByUId) {
            if (removed) delete elementByUId[uid];
            else elementByUId[uid] ??= new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element);
        }
        if ((0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, element) || element.hasAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145))) updateTabsterByAttribute(tabster, element, removed);
        return NodeFilter.FILTER_SKIP;
    }
    const observer = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).createMutationObserver(onMutation);
    if (syncState) updateTabsterElements(getWindow().document.body);
    observer.observe(doc, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            (0, $43f171f5f7088580$export$a1195ad1c253d145)
        ]
    });
    return ()=>{
        observer.disconnect();
    };
}




/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Allows default or user focus behaviour on the DOM subtree
 * i.e. Tabster will not control focus events within an uncontrolled area
 */ class $13f4cfeb1a9f8b41$export$5693b0af634a52fb {
    constructor(isUncontrolledCompletely){
        this._isUncontrolledCompletely = isUncontrolledCompletely;
    }
    isUncontrolledCompletely(element, completely) {
        const isUncontrolledCompletely = this._isUncontrolledCompletely?.(element, completely);
        // If isUncontrolledCompletely callback is not defined or returns undefined, then the default
        // behaviour is to return the uncontrolled.completely value from the element.
        return isUncontrolledCompletely === undefined ? completely : isUncontrolledCompletely;
    }
}





var $05bd70c3eacbf176$exports = {};

$parcel$export($05bd70c3eacbf176$exports, "createTreeWalker", () => $e66bad0553baf608$export$4d0f8be8b12a7ef6);
$parcel$export($05bd70c3eacbf176$exports, "createMutationObserver", () => $e683fd2482bc64d9$export$d05aea450390219c);
$parcel$export($05bd70c3eacbf176$exports, "appendChild", () => $870a49196029521c$export$1b8e57c9ea42f1d2);
$parcel$export($05bd70c3eacbf176$exports, "getActiveElement", () => $870a49196029521c$export$cd4e5573fbe2b576);
$parcel$export($05bd70c3eacbf176$exports, "getFirstChild", () => $870a49196029521c$export$9948b6d0956761ed);
$parcel$export($05bd70c3eacbf176$exports, "getFirstElementChild", () => $870a49196029521c$export$d8382c15efe200bb);
$parcel$export($05bd70c3eacbf176$exports, "getLastChild", () => $870a49196029521c$export$98420b9ec3fd7e2c);
$parcel$export($05bd70c3eacbf176$exports, "getLastElementChild", () => $870a49196029521c$export$b622caebfaf6a187);
$parcel$export($05bd70c3eacbf176$exports, "getNextElementSibling", () => $870a49196029521c$export$dc2a8b6e54b2e90d);
$parcel$export($05bd70c3eacbf176$exports, "getNextSibling", () => $870a49196029521c$export$9d0a8f860b10b329);
$parcel$export($05bd70c3eacbf176$exports, "getParentElement", () => $870a49196029521c$export$169e5491001d3ed6);
$parcel$export($05bd70c3eacbf176$exports, "getParentNode", () => $870a49196029521c$export$4e12058fc4d51d56);
$parcel$export($05bd70c3eacbf176$exports, "getPreviousElementSibling", () => $870a49196029521c$export$32e63ef90faf99a8);
$parcel$export($05bd70c3eacbf176$exports, "getPreviousSibling", () => $870a49196029521c$export$9cde4a31f3f732e7);
$parcel$export($05bd70c3eacbf176$exports, "getSelection", () => $870a49196029521c$export$ca798a7e6e94638c);
$parcel$export($05bd70c3eacbf176$exports, "getElementsByName", () => $870a49196029521c$export$f8e1cf257389aaf6);
$parcel$export($05bd70c3eacbf176$exports, "insertBefore", () => $870a49196029521c$export$86b68c7dbeb53c22);
$parcel$export($05bd70c3eacbf176$exports, "nodeContains", () => $870a49196029521c$export$4282f70798064fe0);
$parcel$export($05bd70c3eacbf176$exports, "getElementById", () => $569f8ea64cee07ca$export$83595b84fc78b9b4);
$parcel$export($05bd70c3eacbf176$exports, "querySelector", () => $569f8ea64cee07ca$export$78fb49a702cc1f2);
$parcel$export($05bd70c3eacbf176$exports, "querySelectorAll", () => $569f8ea64cee07ca$export$2e83b5c43fb7af7b);
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // TODO: The functions below do not consider Shadow DOM slots yet. We will be adding
// support for slots as the need arises.
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $870a49196029521c$export$cd4e5573fbe2b576(doc) {
    let activeElement = doc.activeElement;
    while(activeElement?.shadowRoot?.activeElement)activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
}
function $870a49196029521c$export$4282f70798064fe0(node, otherNode) {
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode){
        if (currentNode === node) return true;
        if (typeof currentNode.assignedElements !== "function" && currentNode.assignedSlot?.parentNode) // Element is slotted
        currentNode = currentNode.assignedSlot?.parentNode;
        else if (currentNode.nodeType === document.DOCUMENT_FRAGMENT_NODE) // Element is in shadow root
        currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
function $870a49196029521c$export$4e12058fc4d51d56(node) {
    if (!node) return null;
    if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && node.host) return node.host;
    return node.parentNode;
}
function $870a49196029521c$export$169e5491001d3ed6(element) {
    for(let parentNode = $870a49196029521c$export$4e12058fc4d51d56(element); parentNode; parentNode = $870a49196029521c$export$4e12058fc4d51d56(parentNode)){
        if (parentNode.nodeType === Node.ELEMENT_NODE) return parentNode;
    }
    return null;
}
function $870a49196029521c$export$9948b6d0956761ed(node) {
    if (!node) return null;
    if (node.shadowRoot) {
        const child = $870a49196029521c$export$9948b6d0956761ed(node.shadowRoot);
        if (child) return child;
    // If the attached shadowRoot has no children, just try ordinary children,
    // that might come after.
    }
    return node.firstChild;
}
function $870a49196029521c$export$98420b9ec3fd7e2c(node) {
    if (!node) return null;
    if (!node.lastChild && node.shadowRoot) return $870a49196029521c$export$98420b9ec3fd7e2c(node.shadowRoot);
    return node.lastChild;
}
function $870a49196029521c$export$9d0a8f860b10b329(node) {
    return node?.nextSibling || null;
}
function $870a49196029521c$export$9cde4a31f3f732e7(node) {
    if (!node) return null;
    let sibling = node.previousSibling;
    if (!sibling && node.parentElement?.shadowRoot) sibling = $870a49196029521c$export$98420b9ec3fd7e2c(node.parentElement.shadowRoot);
    return sibling;
}
function $870a49196029521c$export$d8382c15efe200bb(element) {
    let child = $870a49196029521c$export$9948b6d0956761ed(element);
    while(child && child.nodeType !== Node.ELEMENT_NODE)child = $870a49196029521c$export$9d0a8f860b10b329(child);
    return child;
}
function $870a49196029521c$export$b622caebfaf6a187(element) {
    let child = $870a49196029521c$export$98420b9ec3fd7e2c(element);
    while(child && child.nodeType !== Node.ELEMENT_NODE)child = $870a49196029521c$export$9cde4a31f3f732e7(child);
    return child;
}
function $870a49196029521c$export$dc2a8b6e54b2e90d(element) {
    let sibling = $870a49196029521c$export$9d0a8f860b10b329(element);
    while(sibling && sibling.nodeType !== Node.ELEMENT_NODE)sibling = $870a49196029521c$export$9d0a8f860b10b329(sibling);
    return sibling;
}
function $870a49196029521c$export$32e63ef90faf99a8(element) {
    let sibling = $870a49196029521c$export$9cde4a31f3f732e7(element);
    while(sibling && sibling.nodeType !== Node.ELEMENT_NODE)sibling = $870a49196029521c$export$9cde4a31f3f732e7(sibling);
    return sibling;
}
function $870a49196029521c$export$1b8e57c9ea42f1d2(parent, child) {
    const shadowRoot = parent.shadowRoot;
    return shadowRoot ? shadowRoot.appendChild(child) : parent.appendChild(child);
}
function $870a49196029521c$export$86b68c7dbeb53c22(parent, child, referenceChild) {
    const shadowRoot = parent.shadowRoot;
    return shadowRoot ? shadowRoot.insertBefore(child, referenceChild) : parent.insertBefore(child, referenceChild);
}
function $870a49196029521c$export$ca798a7e6e94638c(ref) {
    const win = ref.ownerDocument?.defaultView;
    if (!win) return null;
    for(let el = ref; el; el = el.parentNode)if (el.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        const tmp = el;
        // ShadowRoot.getSelection() exists only in Chrome.
        if (tmp.getSelection) return tmp.getSelection() || null;
        break;
    }
    return win.getSelection() || null;
}
function $870a49196029521c$export$f8e1cf257389aaf6(referenceElement, name) {
    for(let el = referenceElement; el; el = el.parentNode){
        if (el.nodeType === Node.DOCUMENT_FRAGMENT_NODE) // Shadow root doesn't have getElementsByName()...
        return el.querySelectorAll(`[name=${name}]`);
    }
    return referenceElement.ownerDocument.getElementsByName(name);
}


function $e66bad0553baf608$var$getLastChild(container) {
    let lastChild = null;
    for(let i = (0, $870a49196029521c$export$b622caebfaf6a187)(container); i; i = (0, $870a49196029521c$export$b622caebfaf6a187)(i))lastChild = i;
    return lastChild || undefined;
}
class $e66bad0553baf608$export$63eb3ababa9c55c4 {
    constructor(doc, root, whatToShow, filter){
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = (node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                const shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    if (typeof this.filter === "function") return this.filter(node);
                    else if (this.filter?.acceptNode) return this.filter.acceptNode(node);
                    else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter ?? null;
        this.whatToShow = whatToShow ?? NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        const shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
    get currentNode() {
        return this._currentNode;
    }
    set currentNode(node) {
        if (!(0, $870a49196029521c$export$4282f70798064fe0)(this.root, node)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
        const walkers = [];
        let curNode = node;
        let currentWalkerCurrentNode = node;
        this._currentNode = node;
        while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            const shadowRoot = curNode;
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            walkers.push(walker);
            walker.currentNode = currentWalkerCurrentNode;
            this._currentSetFor.add(walker);
            curNode = currentWalkerCurrentNode = shadowRoot.host;
        } else curNode = curNode.parentNode;
        const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
            acceptNode: this._acceptNode
        });
        walkers.push(walker);
        walker.currentNode = currentWalkerCurrentNode;
        this._currentSetFor.add(walker);
        this._walkerStack = walkers;
    }
    firstChild() {
        return null;
    }
    lastChild() {
        return null;
    }
    nextNode() {
        const nextNode = this._walkerStack[0].nextNode();
        if (nextNode) {
            const shadowRoot = nextNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === "function") nodeResult = this.filter(nextNode);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) return nextNode;
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                return this.nextNode();
            }
            return nextNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                return this.nextNode();
            } else return null;
        }
    }
    previousNode() {
        const currentWalker = this._walkerStack[0];
        if (currentWalker.currentNode === currentWalker.root) {
            if (this._currentSetFor.has(currentWalker)) {
                this._currentSetFor.delete(currentWalker);
                if (this._walkerStack.length > 1) {
                    this._walkerStack.shift();
                    return this.previousNode();
                } else return null;
            }
            const lastChild = $e66bad0553baf608$var$getLastChild(currentWalker.root);
            if (lastChild) {
                currentWalker.currentNode = lastChild;
                let nodeResult;
                if (typeof this.filter === "function") nodeResult = this.filter(lastChild);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(lastChild);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) return lastChild;
            }
        }
        const previousNode = currentWalker.previousNode();
        if (previousNode) {
            const shadowRoot = previousNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === "function") nodeResult = this.filter(previousNode);
                else if (this.filter?.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) return previousNode;
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                return this.previousNode();
            }
            return previousNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                return this.previousNode();
            } else return null;
        }
    }
    nextSibling() {
        return null;
    }
    previousSibling() {
        return null;
    }
    parentNode() {
        return null;
    }
}
function $e66bad0553baf608$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
    return new $e66bad0553baf608$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
class $e683fd2482bc64d9$export$305ceb9a8f6a3b62 {
    static{
        this._shadowObservers = new Set();
    }
    static _overrideAttachShadow(win) {
        const origAttachShadow = win.Element.prototype.attachShadow;
        if (origAttachShadow.__origAttachShadow) return;
        Element.prototype.attachShadow = function(options) {
            const shadowRoot = origAttachShadow.call(this, options);
            for (const shadowObserver of $e683fd2482bc64d9$export$305ceb9a8f6a3b62._shadowObservers)shadowObserver._addSubObserver(shadowRoot);
            return shadowRoot;
        };
        Element.prototype.attachShadow.__origAttachShadow = origAttachShadow;
    }
    constructor(callback){
        this._isObserving = false;
        this._callbackWrapper = (mutations, observer)=>{
            for (const mutation of mutations)if (mutation.type === "childList") {
                const removed = mutation.removedNodes;
                const added = mutation.addedNodes;
                for(let i = 0; i < removed.length; i++)this._walkShadows(removed[i], true);
                for(let i = 0; i < added.length; i++)this._walkShadows(added[i]);
            }
            this._callback(mutations, observer);
        };
        this._callback = callback;
        this._observer = new MutationObserver(this._callbackWrapper);
        this._subObservers = new Map();
    }
    _addSubObserver(shadowRoot) {
        if (!this._options || !this._callback || this._subObservers.has(shadowRoot)) return;
        if (this._options.subtree && (0, $870a49196029521c$export$4282f70798064fe0)(this._root, shadowRoot)) {
            const subObserver = new MutationObserver(this._callbackWrapper);
            this._subObservers.set(shadowRoot, subObserver);
            if (this._isObserving) subObserver.observe(shadowRoot, this._options);
            this._walkShadows(shadowRoot);
        }
    }
    disconnect() {
        this._isObserving = false;
        delete this._options;
        $e683fd2482bc64d9$export$305ceb9a8f6a3b62._shadowObservers.delete(this);
        for (const subObserver of this._subObservers.values())subObserver.disconnect();
        this._subObservers.clear();
        this._observer.disconnect();
    }
    observe(target, options) {
        const doc = target.nodeType === Node.DOCUMENT_NODE ? target : target.ownerDocument;
        const win = doc?.defaultView;
        if (!doc || !win) return;
        $e683fd2482bc64d9$export$305ceb9a8f6a3b62._overrideAttachShadow(win);
        $e683fd2482bc64d9$export$305ceb9a8f6a3b62._shadowObservers.add(this);
        this._root = target;
        this._options = options;
        this._isObserving = true;
        this._observer.observe(target, options);
        this._walkShadows(target);
    }
    _walkShadows(target, remove) {
        const doc = target.nodeType === Node.DOCUMENT_NODE ? target : target.ownerDocument;
        if (!doc) return;
        if (target === doc) target = doc.body;
        else {
            const shadowRoot = target.shadowRoot;
            if (shadowRoot) {
                this._addSubObserver(shadowRoot);
                return;
            }
        }
        const walker = doc.createTreeWalker(target, NodeFilter.SHOW_ELEMENT, {
            acceptNode: (node)=>{
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (remove) {
                        const subObserver = this._subObservers.get(node);
                        if (subObserver) {
                            subObserver.disconnect();
                            this._subObservers.delete(node);
                        }
                    } else {
                        const shadowRoot = node.shadowRoot;
                        if (shadowRoot) this._addSubObserver(shadowRoot);
                    }
                }
                return NodeFilter.FILTER_SKIP;
            }
        });
        walker.nextNode();
    }
    takeRecords() {
        const records = this._observer.takeRecords();
        for (const subObserver of this._subObservers.values())records.push(...subObserver.takeRecords());
        return records;
    }
}
function $e683fd2482bc64d9$export$d05aea450390219c(callback) {
    return new $e683fd2482bc64d9$export$305ceb9a8f6a3b62(callback);
}



/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $569f8ea64cee07ca$var$shadowQuerySelector(node, selector, all) {
    // TODO: This is probably slow. Optimize to use each shadowRoot's querySelector/querySelectorAll
    //       instead of walking the tree.
    const elements = [];
    walk(node, selector);
    return elements;
    function walk(from, selector) {
        let el = null;
        const walker = document.createTreeWalker(from, NodeFilter.SHOW_ELEMENT, {
            acceptNode: (n)=>{
                if (n.nodeType === Node.ELEMENT_NODE) {
                    if (n.matches(selector)) {
                        el = n;
                        elements.push(el);
                        return all ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                    }
                    const shadowRoot = n.shadowRoot;
                    if (shadowRoot) {
                        walk(shadowRoot, selector);
                        return !all && elements.length ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                    }
                }
                return NodeFilter.FILTER_SKIP;
            }
        });
        walker.nextNode();
    }
}
function $569f8ea64cee07ca$export$2e83b5c43fb7af7b(node, selector) {
    return $569f8ea64cee07ca$var$shadowQuerySelector(node, selector, true);
}
function $569f8ea64cee07ca$export$78fb49a702cc1f2(node, selector) {
    return $569f8ea64cee07ca$var$shadowQuerySelector(node, selector, false)[0] || null;
}
function $569f8ea64cee07ca$export$83595b84fc78b9b4(doc, id) {
    return $569f8ea64cee07ca$export$78fb49a702cc1f2(doc, "#" + id);
}












class $5c45acfaa2a9d64f$var$Tabster {
    constructor(tabster){
        this.keyboardNavigation = tabster.keyboardNavigation;
        this.focusedElement = tabster.focusedElement;
        this.focusable = tabster.focusable;
        this.root = tabster.root;
        this.uncontrolled = tabster.uncontrolled;
        this.core = tabster;
    }
}
/**
 * Extends Window to include an internal Tabster instance.
 */ class $5c45acfaa2a9d64f$var$TabsterCore {
    constructor(win, props){
        this._forgetMemorizedElements = [];
        this._wrappers = new Set();
        this._initQueue = [];
        this._version = "8.8.1";
        this._noop = false;
        // Variance gap: per-key handler types are contravariant in their
        // parameters, so a fully-typed Map<K, TabsterAttrHandler<K>> can't unify
        // them. Cast a plain Map to the typed view; the override on `set` keeps
        // registration type-safe per key, while `get` falls back to the Map's
        // value type (the type-erased shape).
        this.attrHandlers = new Map();
        this.getWindow = ()=>{
            if (!this._win) throw new Error("Using disposed Tabster.");
            return this._win;
        };
        this._storage = new WeakMap();
        this._win = win;
        const getWindow = this.getWindow;
        if (props?.DOMAPI) (0, $1f57f26a88fe463d$export$2818ed6e0a6311a1)({
            ...props.DOMAPI
        });
        this.keyboardNavigation = new (0, $aba4af735104c34b$export$86d38b407cbe7828)(getWindow);
        this.focusedElement = new (0, $018eb0b75e35c758$export$406337e29e552119)(this, getWindow);
        this.focusable = new (0, $bfdc7e60be74e4a7$export$793cfd8049a0ffa1)(this);
        this.root = new (0, $7fd0b2ef4cf9c004$export$21337b879fb836da)(this, props?.autoRoot);
        this.uncontrolled = new (0, $13f4cfeb1a9f8b41$export$5693b0af634a52fb)(// TODO: Remove checkUncontrolledTrappingFocus in the next major version.
        props?.checkUncontrolledCompletely || props?.checkUncontrolledTrappingFocus);
        this.controlTab = props?.controlTab ?? true;
        this.rootDummyInputs = !!props?.rootDummyInputs;
        this._dummyObserver = new (0, $f8063a7f7d87cb7c$export$9c4205b1985bc82)(getWindow);
        this.getParent = props?.getParent ?? (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentNode;
        this.internal = {
            stopObserver: ()=>{
                if (this._unobserve) {
                    this._unobserve();
                    delete this._unobserve;
                }
            },
            resumeObserver: (syncState)=>{
                if (!this._unobserve) {
                    const doc = getWindow().document;
                    this._unobserve = (0, $7709e12a1e72c316$export$46debc62fc90cfe5)(doc, this, (0, $cac64caf55b8b085$export$5a2a13bd8eff0b2c), syncState);
                }
            }
        };
        // Gives a tick to the host app to initialize other tabster
        // APIs before tabster starts observing attributes.
        this.queueInit(()=>{
            this.internal.resumeObserver(true);
        });
    }
    /**
     * Merges external props with the current props. Not all
     * props can/should be mergeable, so let's add more as we move on.
     * @param props Tabster props
     */ _mergeProps(props) {
        if (!props) return;
        this.getParent = props.getParent ?? this.getParent;
    }
    createTabster(noRefCount, props) {
        const wrapper = new $5c45acfaa2a9d64f$var$Tabster(this);
        if (!noRefCount) this._wrappers.add(wrapper);
        this._mergeProps(props);
        return wrapper;
    }
    disposeTabster(wrapper, allInstances) {
        if (allInstances) this._wrappers.clear();
        else this._wrappers.delete(wrapper);
        if (this._wrappers.size === 0) this.dispose();
    }
    dispose() {
        this.internal.stopObserver();
        const win = this._win;
        win?.clearTimeout(this._initTimer);
        delete this._initTimer;
        this._initQueue = [];
        this._forgetMemorizedElements = [];
        if (win && this._forgetMemorizedTimer) {
            win.clearTimeout(this._forgetMemorizedTimer);
            delete this._forgetMemorizedTimer;
        }
        this.outline?.dispose();
        this.crossOrigin?.dispose();
        this.deloser?.dispose();
        this.groupper?.dispose();
        this.mover?.dispose();
        this.modalizer?.dispose();
        this.observedElement?.dispose();
        this.restorer?.dispose();
        this.keyboardNavigation.dispose();
        this.focusable.dispose();
        this.focusedElement.dispose();
        this.root.dispose();
        this._dummyObserver.dispose();
        // Drop handler closures — they capture the API instances we just
        // disposed, and any post-dispose updateTabsterByAttribute call would
        // otherwise dispatch to those zombies.
        this.attrHandlers.clear();
        (0, $8031a5e97995bd92$export$7093c63335353a70)(this.getWindow);
        this._storage = new WeakMap();
        this._wrappers.clear();
        if (win) {
            (0, $8031a5e97995bd92$export$f0e20bb2ca318fc2)(win);
            delete win.__tabsterInstance;
            delete this._win;
        }
    }
    storageEntry(element, addremove) {
        const storage = this._storage;
        let entry = storage.get(element);
        if (entry) {
            if (addremove === false && Object.keys(entry).length === 0) storage.delete(element);
        } else if (addremove === true) {
            entry = {};
            storage.set(element, entry);
        }
        return entry;
    }
    forceCleanup() {
        if (!this._win) return;
        this._forgetMemorizedElements.push(this._win.document.body);
        if (this._forgetMemorizedTimer) return;
        this._forgetMemorizedTimer = this._win.setTimeout(()=>{
            delete this._forgetMemorizedTimer;
            for(let el = this._forgetMemorizedElements.shift(); el; el = this._forgetMemorizedElements.shift()){
                (0, $8031a5e97995bd92$export$7093c63335353a70)(this.getWindow, el);
                (0, $018eb0b75e35c758$export$406337e29e552119).forgetMemorized(this.focusedElement, el);
            }
        }, 0);
    }
    queueInit(callback) {
        if (!this._win) return;
        this._initQueue.push(callback);
        if (!this._initTimer) this._initTimer = this._win?.setTimeout(()=>{
            delete this._initTimer;
            this.drainInitQueue();
        }, 0);
    }
    drainInitQueue() {
        if (!this._win) return;
        const queue = this._initQueue;
        // Resetting the queue before calling the callbacks to avoid recursion.
        this._initQueue = [];
        queue.forEach((callback)=>callback());
    }
}
function $5c45acfaa2a9d64f$export$23e58ab32962d3d5(tabster) {
    // The only legit case for calling this method is when you've completely removed
    // the application DOM and not going to add the new one for a while.
    const tabsterCore = tabster.core;
    tabsterCore.forceCleanup();
}
function $5c45acfaa2a9d64f$export$456f6b7a70dafcba(win, props) {
    let tabster = $5c45acfaa2a9d64f$export$4d6975053f458ea5(win);
    if (tabster) return tabster.createTabster(false, props);
    tabster = new $5c45acfaa2a9d64f$var$TabsterCore(win, props);
    win.__tabsterInstance = tabster;
    return tabster.createTabster();
}
function $5c45acfaa2a9d64f$export$ada8b61eee6ee48a(win) {
    const tabster = $5c45acfaa2a9d64f$export$4d6975053f458ea5(win);
    return tabster ? tabster.createTabster(true) : null;
}
function $5c45acfaa2a9d64f$export$b3b3c8193388a30() {
    return $05bd70c3eacbf176$exports;
}
function $5c45acfaa2a9d64f$export$32586705faae7c2d(tabster) {
    const tabsterCore = tabster.core;
    return tabsterCore.internal;
}
function $5c45acfaa2a9d64f$export$baba89a9d6c164be(tabster, allInstances) {
    tabster.core.disposeTabster(tabster, allInstances);
}
function $5c45acfaa2a9d64f$export$4d6975053f458ea5(win) {
    return win.__tabsterInstance;
}
function $5c45acfaa2a9d64f$export$f5e4f944136f94a1(tabster, noop) {
    const core = tabster.core;
    if (core._noop !== noop) {
        core._noop = noop;
        const processNode = (node)=>{
            const element = node;
            if (!element.getAttribute) return NodeFilter.FILTER_SKIP;
            if ((0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(core, element) || element.hasAttribute((0, $43f171f5f7088580$export$a1195ad1c253d145))) (0, $cac64caf55b8b085$export$5a2a13bd8eff0b2c)(core, element);
            return NodeFilter.FILTER_SKIP;
        };
        const doc = core.getWindow().document;
        const body = doc.body;
        processNode(body);
        const walker = (0, $8031a5e97995bd92$export$6d51b6a3304b27f5)(doc, body, processNode);
        if (walker) {
            while(walker.nextNode());
        }
    }
}
function $5c45acfaa2a9d64f$export$429d1a71f461eaed(tabster) {
    return tabster._noop;
}




'use client';
const $b04ae062f6cbb081$var$DEFAULT_FACTORY = (tabster)=>{
    return tabster;
};
function $b04ae062f6cbb081$export$4da13d8c35aea7a4(targetDocument) {
    const defaultView = (targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) || undefined;
    const shadowDOMAPI = defaultView === null || defaultView === void 0 ? void 0 : defaultView.__tabsterShadowDOMAPI;
    if (defaultView) return (0, $5c45acfaa2a9d64f$export$456f6b7a70dafcba)(defaultView, {
        autoRoot: {},
        controlTab: false,
        getParent: $a84b79cd75c90fa5$export$58081aedf094d85b,
        // The non-undefined return value of checkUncontrolledCompletely() dominates the value that the element might
        // have in its `uncontrolled: { completely: true }` part of the tabster attribute. We must make sure to return
        // undefined if we want the value from tabster attribute to be respected.
        checkUncontrolledCompletely: (element)=>{
            var _element_firstElementChild;
            return ((_element_firstElementChild = element.firstElementChild) === null || _element_firstElementChild === void 0 ? void 0 : _element_firstElementChild.hasAttribute('data-is-focus-trap-zone-bumper')) === true || undefined;
        },
        DOMAPI: shadowDOMAPI
    });
}
function $b04ae062f6cbb081$export$f3f635a6897e7f0c(factory = $b04ae062f6cbb081$var$DEFAULT_FACTORY) {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const factoryResultRef = $acw62.useRef(null);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        const tabster = $b04ae062f6cbb081$export$4da13d8c35aea7a4(targetDocument);
        if (tabster) {
            factoryResultRef.current = factory(tabster);
            return ()=>{
                (0, $5c45acfaa2a9d64f$export$baba89a9d6c164be)(tabster);
                factoryResultRef.current = null;
            };
        }
    }, [
        targetDocument,
        factory
    ]);
    return factoryResultRef;
}


'use client';
const $708e79e1f2ab4237$export$2b0519dd5d2bc6d4 = ()=>{
    const tabsterRef = (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    // Narrow props for now and let need dictate additional props in the future
    const findAllFocusable = $acw62.useCallback((container, acceptCondition)=>{
        var _tabsterRef_current;
        return container && ((_tabsterRef_current = tabsterRef.current) === null || _tabsterRef_current === void 0 ? void 0 : _tabsterRef_current.focusable.findAll({
            container: container,
            acceptCondition: acceptCondition
        })) || [];
    }, [
        tabsterRef
    ]);
    const findFirstFocusable = $acw62.useCallback((container)=>{
        var _tabsterRef_current;
        return container && ((_tabsterRef_current = tabsterRef.current) === null || _tabsterRef_current === void 0 ? void 0 : _tabsterRef_current.focusable.findFirst({
            container: container
        }));
    }, [
        tabsterRef
    ]);
    const findLastFocusable = $acw62.useCallback((container)=>{
        var _tabsterRef_current;
        return container && ((_tabsterRef_current = tabsterRef.current) === null || _tabsterRef_current === void 0 ? void 0 : _tabsterRef_current.focusable.findLast({
            container: container
        }));
    }, [
        tabsterRef
    ]);
    const findNextFocusable = $acw62.useCallback((currentElement, options = {})=>{
        if (!tabsterRef.current || !targetDocument || !currentElement) return null;
        const { container: container = targetDocument.body } = options;
        return tabsterRef.current.focusable.findNext({
            currentElement: currentElement,
            container: container
        });
    }, [
        tabsterRef,
        targetDocument
    ]);
    const findPrevFocusable = $acw62.useCallback((currentElement, options = {})=>{
        if (!tabsterRef.current || !targetDocument || !currentElement) return null;
        const { container: container = targetDocument.body } = options;
        return tabsterRef.current.focusable.findPrev({
            currentElement: currentElement,
            container: container
        });
    }, [
        tabsterRef,
        targetDocument
    ]);
    return {
        findAllFocusable: findAllFocusable,
        findFirstFocusable: findFirstFocusable,
        findLastFocusable: findLastFocusable,
        findNextFocusable: findNextFocusable,
        findPrevFocusable: findPrevFocusable
    };
};


var $acw62 = parcelRequire("acw62");
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 








let $932122096a928d01$var$_wasFocusedCounter = 0;
const $932122096a928d01$var$_ariaHidden = "aria-hidden";
function $932122096a928d01$var$_setInformativeStyle(weakElement, remove, internalId, userId, isActive, wasFocused) {}
/**
 * Manages the dummy inputs for the Modalizer.
 */ class $932122096a928d01$var$ModalizerDummyManager extends (0, $f8063a7f7d87cb7c$export$2b3665f1498b1a50) {
    constructor(element, tabster, sys){
        super(tabster, element, (0, $f8063a7f7d87cb7c$export$96ba7a05d53985a3).Modalizer, sys);
        this._setHandlers((dummyInput, isBackward)=>{
            const el = element.get();
            const container = el && (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getRoot(tabster, el)?.getElement();
            const input = dummyInput.input;
            let toFocus;
            if (container && input) {
                const dummyContainer = (0, $f8063a7f7d87cb7c$export$6c7070ee46ec4271)(input);
                const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, dummyContainer || input);
                if (ctx) toFocus = (0, $018eb0b75e35c758$export$406337e29e552119).findNextTabbable(tabster, ctx, container, input, undefined, isBackward, true)?.element;
                if (toFocus) (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(toFocus);
            }
        });
    }
}
class $932122096a928d01$export$c35100444860154f extends (0, $8031a5e97995bd92$export$512356fecf866417) {
    constructor(tabster, element, onDispose, props, sys, activeElements){
        super(tabster, element, props);
        this._wasFocused = 0;
        this.userId = props.id;
        this._onDispose = onDispose;
        this._activeElements = activeElements;
        if (!tabster.controlTab) this.dummyManager = new $932122096a928d01$var$ModalizerDummyManager(this._element, tabster, sys);
    }
    makeActive(isActive) {
        if (this._isActive !== isActive) {
            this._isActive = isActive;
            const element = this.getElement();
            if (element) {
                const activeElements = this._activeElements;
                const index = activeElements.map((e)=>e.get()).indexOf(element);
                if (isActive) {
                    if (index < 0) activeElements.push(new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element));
                } else if (index >= 0) activeElements.splice(index, 1);
            }
            this._dispatchEvent(isActive);
        }
    }
    focused(noIncrement) {
        if (!noIncrement) this._wasFocused = ++$932122096a928d01$var$_wasFocusedCounter;
        return this._wasFocused;
    }
    setProps(props) {
        if (props.id) this.userId = props.id;
        this._props = {
            ...props
        };
    }
    dispose() {
        this.makeActive(false);
        this._onDispose(this);
        this.dummyManager?.dispose();
        delete this.dummyManager;
        this._activeElements = [];
        this._remove();
    }
    isActive() {
        return !!this._isActive;
    }
    contains(element) {
        return (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(this.getElement(), element);
    }
    findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const modalizerElement = this.getElement();
        if (!modalizerElement) return null;
        const tabster = this._tabster;
        let next = null;
        let outOfDOMOrder = false;
        let uncontrolled;
        const container = currentElement && (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getRoot(tabster, currentElement)?.getElement();
        if (container) {
            const findProps = {
                container: container,
                currentElement: currentElement,
                referenceElement: referenceElement,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            next = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            if (!next && this._props.isTrapped && tabster.modalizer?.activeId) {
                next = tabster.focusable[isBackward ? "findLast" : "findFirst"]({
                    container: container,
                    ignoreAccessibility: ignoreAccessibility,
                    useActiveModalizer: true
                }, findPropsOut);
                if (next === null) next = currentElement;
                outOfDOMOrder = true;
            } else outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
            uncontrolled = findPropsOut.uncontrolled;
        }
        return {
            element: next,
            uncontrolled: uncontrolled,
            outOfDOMOrder: outOfDOMOrder
        };
    }
    _dispatchEvent(isActive, allElements) {
        const element = this.getElement();
        let defaultPrevented = false;
        if (element) {
            const elements = allElements ? this._activeElements.map((e)=>e.get()) : [
                element
            ];
            for (const el of elements)if (el) {
                const eventDetail = {
                    id: this.userId,
                    element: element
                };
                const event = isActive ? new (0, $b6b59d8a07a2383a$export$c375a7c49fb7a7ca)(eventDetail) : new (0, $b6b59d8a07a2383a$export$2ee7f26c7f1dcf9c)(eventDetail);
                (0, $8031a5e97995bd92$export$716a11175c03fb4e)(el, event);
                if (event.defaultPrevented) defaultPrevented = true;
            }
        }
        return defaultPrevented;
    }
    _remove() {}
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $932122096a928d01$var$validateModalizerProps(props) {
// TODO: Implement validation.
}
class $932122096a928d01$export$dbfa5a6b1ba57635 {
    constructor(tabster, // @deprecated use accessibleCheck.
    alwaysAccessibleSelector, accessibleCheck){
        this._onModalizerDispose = (modalizer)=>{
            const id = modalizer.id;
            const userId = modalizer.userId;
            const part = this._parts[userId];
            delete this._modalizers[id];
            if (part) {
                delete part[id];
                if (Object.keys(part).length === 0) {
                    delete this._parts[userId];
                    const activationHistory = this._activationHistory;
                    const cleanActivationHistory = [];
                    let prevHistoryItem;
                    // The history order is from most recent to oldest.
                    for(let i = activationHistory.length; i--;){
                        // Remove from activation history, making sure there are no duplicates
                        // for cases like [modal2, modal1, modal2, modal1]: just removing modal2
                        // will result in [modal1, modal1] and we want just [modal1]. Otherwise,
                        // there is a chance for this array to grow forever in a narrow case of
                        // a modalizer that stays in DOM forever and is being activated/deactivated
                        // switching between other modalizers that come and go.
                        const modalizerUserIdFromHistory = activationHistory[i];
                        if (modalizerUserIdFromHistory === userId) continue;
                        if (modalizerUserIdFromHistory !== prevHistoryItem) {
                            prevHistoryItem = modalizerUserIdFromHistory;
                            if (modalizerUserIdFromHistory || cleanActivationHistory.length > 0) cleanActivationHistory.unshift(modalizerUserIdFromHistory);
                        }
                    }
                    this._activationHistory = cleanActivationHistory;
                    if (this.activeId === userId) {
                        const prevActiveId = cleanActivationHistory[0];
                        const prevActive = prevActiveId ? Object.values(this._parts[prevActiveId])[0] : undefined;
                        this.setActive(prevActive);
                    }
                }
            }
        };
        this._onKeyDown = (event)=>{
            if (event.key !== (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Escape) return;
            const tabster = this._tabster;
            const element = tabster.focusedElement.getFocusedElement();
            if (element) {
                const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, element);
                const modalizer = ctx?.modalizer;
                if (ctx && !ctx.groupper && modalizer?.isActive() && !ctx.ignoreKeydown(event)) {
                    const activeId = modalizer.userId;
                    if (activeId) {
                        const part = this._parts[activeId];
                        if (part) {
                            const focusedSince = Object.keys(part).map((id)=>{
                                const m = part[id];
                                const el = m.getElement();
                                let groupper;
                                if (el) groupper = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, el)?.groupper;
                                return m && el && groupper ? {
                                    el: el,
                                    focusedSince: m.focused(true)
                                } : {
                                    focusedSince: 0
                                };
                            }).filter((f)=>f.focusedSince > 0).sort((a, b)=>a.focusedSince > b.focusedSince ? -1 : a.focusedSince < b.focusedSince ? 1 : 0);
                            if (focusedSince.length) {
                                const groupperElement = focusedSince[0].el;
                                if (groupperElement) tabster.groupper?.handleKeyPress(groupperElement, event, true);
                            }
                        }
                    }
                }
            }
        };
        /**
         * Subscribes to the focus state and handles modalizer related focus events
         * @param focusedElement - Element that is focused
         * @param detail - Additional data about the focus event
         */ this._onFocus = (focusedElement, detail)=>{
            const tabster = this._tabster;
            const ctx = focusedElement && (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, focusedElement);
            // Modalizer behaviour is opt in, only apply to elements that have a tabster context
            if (!ctx || !focusedElement) return;
            const augmentedMap = this._augMap;
            for(let e = focusedElement; e; e = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(e))// If the newly focused element is inside some of the hidden containers,
            // remove aria-hidden from those synchronously for the screen readers
            // to be able to read the element. The rest of aria-hiddens, will be removed
            // acynchronously for the sake of performance.
            if (augmentedMap.has(e)) {
                augmentedMap.delete(e);
                (0, $8031a5e97995bd92$export$4a7138b8b618a0c9)(tabster, e, $932122096a928d01$var$_ariaHidden);
            }
            let modalizer = ctx.modalizer;
            const tabsterOnFocusedElement = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, focusedElement);
            const modalizerOnFocusedElement = tabsterOnFocusedElement?.modalizer;
            if (modalizerOnFocusedElement) {
                modalizerOnFocusedElement.focused();
                if (modalizerOnFocusedElement.userId === this.activeId && tabsterOnFocusedElement.groupper) {
                    const parentElement = tabster.getParent(focusedElement);
                    const parentModalizer = parentElement && (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, parentElement)?.modalizer;
                    if (parentModalizer) modalizer = parentModalizer;
                    else {
                        this.setActive(undefined);
                        return;
                    }
                }
            }
            // An inactive groupper with the modalizer on the same node will not give the modalizer
            // in the context, yet we still want to track that the modalizer's container was focused.
            modalizer?.focused();
            if (modalizer?.userId === this.activeId) {
                this.currentIsOthersAccessible = modalizer?.getProps().isOthersAccessible;
                return;
            }
            // Developers calling `element.focus()` should change/deactivate active modalizer
            if (detail.isFocusedProgrammatically || this.currentIsOthersAccessible || modalizer?.getProps().isAlwaysAccessible) this.setActive(modalizer);
            else {
                // Focused outside of the active modalizer, try pull focus back to current modalizer
                const win = this._win();
                win.clearTimeout(this._restoreModalizerFocusTimer);
                // TODO some rendering frameworks (i.e. React) might async rerender the DOM so we need to wait for a duration
                // Figure out a better way of doing this rather than a 100ms timeout
                this._restoreModalizerFocusTimer = win.setTimeout(()=>this._restoreModalizerFocus(focusedElement), 100);
            }
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        this._modalizers = {};
        this._parts = {};
        this._augMap = new WeakMap();
        this._aug = [];
        this._alwaysAccessibleSelector = alwaysAccessibleSelector;
        this._accessibleCheck = accessibleCheck;
        this._activationHistory = [];
        this.activeElements = [];
        if (!tabster.controlTab) tabster.root.addDummyInputs();
        const win = this._win();
        (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, "keydown", this._onKeyDown, true);
        tabster.queueInit(()=>{
            this._tabster.focusedElement.subscribe(this._onFocus);
        });
    }
    dispose() {
        const win = this._win();
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, "keydown", this._onKeyDown, true);
        // Dispose all modalizers managed by the API
        Object.keys(this._modalizers).forEach((modalizerId)=>{
            if (this._modalizers[modalizerId]) {
                this._modalizers[modalizerId].dispose();
                delete this._modalizers[modalizerId];
            }
        });
        win.clearTimeout(this._restoreModalizerFocusTimer);
        win.clearTimeout(this._hiddenUpdateTimer);
        this._parts = {};
        delete this.activeId;
        this.activeElements = [];
        this._augMap = new WeakMap();
        this._aug = [];
        this._tabster.focusedElement.unsubscribe(this._onFocus);
    }
    createModalizer(element, props, sys) {
        const modalizer = new $932122096a928d01$export$c35100444860154f(this._tabster, element, this._onModalizerDispose, props, sys, this.activeElements);
        const id = modalizer.id;
        const userId = props.id;
        this._modalizers[id] = modalizer;
        let part = this._parts[userId];
        if (!part) part = this._parts[userId] = {};
        part[id] = modalizer;
        const focusedElement = this._tabster.focusedElement.getFocusedElement() ?? null;
        // Adding a modalizer which is already focused, activate it
        if (element !== focusedElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, focusedElement)) {
            if (userId !== this.activeId) this.setActive(modalizer);
            else modalizer.makeActive(true);
        }
        return modalizer;
    }
    isAugmented(element) {
        return this._augMap.has(element);
    }
    hiddenUpdate() {
        if (this._hiddenUpdateTimer) return;
        this._hiddenUpdateTimer = this._win().setTimeout(()=>{
            delete this._hiddenUpdateTimer;
            this._hiddenUpdate();
        }, 250);
    }
    setActive(modalizer) {
        const userId = modalizer?.userId;
        const activeId = this.activeId;
        if (activeId === userId) return;
        this.activeId = userId;
        if (activeId) {
            const part = this._parts[activeId];
            if (part) for (const id of Object.keys(part))part[id].makeActive(false);
        }
        if (userId) {
            const part = this._parts[userId];
            if (part) for (const id of Object.keys(part))part[id].makeActive(true);
        }
        this.currentIsOthersAccessible = modalizer?.getProps().isOthersAccessible;
        this.hiddenUpdate();
        const activationHistory = this._activationHistory;
        if (activationHistory[0] !== userId && (userId !== undefined || activationHistory.length > 0)) activationHistory.unshift(userId);
    }
    focus(elementFromModalizer, noFocusFirst, noFocusDefault) {
        const tabster = this._tabster;
        const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, elementFromModalizer);
        const modalizer = ctx?.modalizer;
        if (modalizer) {
            this.setActive(modalizer);
            const props = modalizer.getProps();
            const modalizerRoot = modalizer.getElement();
            if (modalizerRoot) {
                if (noFocusFirst === undefined) noFocusFirst = props.isNoFocusFirst;
                if (!noFocusFirst && tabster.keyboardNavigation.isNavigatingWithKeyboard() && tabster.focusedElement.focusFirst({
                    container: modalizerRoot
                })) return true;
                if (noFocusDefault === undefined) noFocusDefault = props.isNoFocusDefault;
                if (!noFocusDefault && tabster.focusedElement.focusDefault(modalizerRoot)) return true;
                tabster.focusedElement.resetFocus(modalizerRoot);
            }
        }
        return false;
    }
    activate(modalizerElementOrContainer) {
        const modalizerToActivate = modalizerElementOrContainer ? (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, modalizerElementOrContainer)?.modalizer : undefined;
        if (!modalizerElementOrContainer || modalizerToActivate) {
            this.setActive(modalizerToActivate);
            return true;
        }
        return false;
    }
    acceptElement(element, state) {
        const modalizerUserId = state.modalizerUserId;
        const currentModalizer = state.currentCtx?.modalizer;
        if (modalizerUserId) for (const e of this.activeElements){
            const el = e.get();
            if (el && ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, el) || el === element)) // We have a part of currently active modalizer somewhere deeper in the DOM,
            // skipping all other checks.
            return NodeFilter.FILTER_SKIP;
        }
        const ret = modalizerUserId === currentModalizer?.userId || !modalizerUserId && currentModalizer?.getProps().isAlwaysAccessible ? undefined : NodeFilter.FILTER_SKIP;
        if (ret !== undefined) state.skippedFocusable = true;
        return ret;
    }
    _hiddenUpdate() {
        const tabster = this._tabster;
        const body = tabster.getWindow().document.body;
        const activeId = this.activeId;
        const parts = this._parts;
        const visibleElements = [];
        const hiddenElements = [];
        const alwaysAccessibleSelector = this._alwaysAccessibleSelector;
        const alwaysAccessibleElements = alwaysAccessibleSelector ? Array.from((0, $1f57f26a88fe463d$export$df3a06d6289f983e).querySelectorAll(body, alwaysAccessibleSelector)) : [];
        const activeModalizerElements = [];
        for (const userId of Object.keys(parts)){
            const modalizerParts = parts[userId];
            for (const id of Object.keys(modalizerParts)){
                const modalizer = modalizerParts[id];
                const el = modalizer.getElement();
                const props = modalizer.getProps();
                const isAlwaysAccessible = props.isAlwaysAccessible;
                if (el) {
                    if (userId === activeId) {
                        activeModalizerElements.push(el);
                        if (!this.currentIsOthersAccessible) visibleElements.push(el);
                    } else if (isAlwaysAccessible) alwaysAccessibleElements.push(el);
                    else hiddenElements.push(el);
                }
            }
        }
        const augmentedMap = this._augMap;
        const allVisibleElements = visibleElements.length > 0 ? [
            ...visibleElements,
            ...alwaysAccessibleElements
        ] : undefined;
        const newAugmented = [];
        const newAugmentedMap = new WeakMap();
        const toggle = (element, hide)=>{
            const tagName = element.tagName;
            if (tagName === "SCRIPT" || tagName === "STYLE") return;
            let isAugmented = false;
            if (augmentedMap.has(element)) {
                if (hide) isAugmented = true;
                else {
                    augmentedMap.delete(element);
                    (0, $8031a5e97995bd92$export$4a7138b8b618a0c9)(tabster, element, $932122096a928d01$var$_ariaHidden);
                }
            } else if (hide && !this._accessibleCheck?.(element, activeModalizerElements) && (0, $8031a5e97995bd92$export$4a7138b8b618a0c9)(tabster, element, $932122096a928d01$var$_ariaHidden, "true")) {
                augmentedMap.set(element, true);
                isAugmented = true;
            }
            if (isAugmented) {
                newAugmented.push(new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element));
                newAugmentedMap.set(element, true);
            }
        };
        const walk = (element)=>{
            for(let el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstElementChild(element); el; el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextElementSibling(el)){
                let skip = false;
                let containsModalizer = false;
                let containedByModalizer = false;
                if (allVisibleElements) {
                    const elParent = tabster.getParent(el);
                    for (const c of allVisibleElements){
                        if (el === c) {
                            skip = true;
                            break;
                        }
                        if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(el, c)) {
                            containsModalizer = true;
                            break;
                        } else if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(c, elParent)) // tabster.getParent() could be provided by the application to
                        // handle, for example, virtual parents. Making sure, we are
                        // not setting aria-hidden on elements which are virtually
                        // inside modalizer.
                        containedByModalizer = true;
                    }
                    if (containsModalizer || el.__tabsterElementFlags?.noDirectAriaHidden) walk(el);
                    else if (!skip && !containedByModalizer) toggle(el, true);
                } else toggle(el, false);
            }
        };
        if (!allVisibleElements) alwaysAccessibleElements.forEach((e)=>toggle(e, false));
        hiddenElements.forEach((e)=>toggle(e, true));
        if (body) walk(body);
        this._aug?.map((e)=>e.get()).forEach((e)=>{
            if (e && !newAugmentedMap.get(e)) toggle(e, false);
        });
        this._aug = newAugmented;
        this._augMap = newAugmentedMap;
    }
    /**
     * Called when an element is focused outside of an active modalizer.
     * Attempts to pull focus back into the active modalizer
     * @param outsideElement - An element being focused outside of the modalizer
     */ _restoreModalizerFocus(outsideElement) {
        const ownerDocument = outsideElement?.ownerDocument;
        if (!outsideElement || !ownerDocument) return;
        const focusedElement = this._tabster.focusedElement.getFocusedElement();
        const focusedElementModalizer = focusedElement && (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, focusedElement)?.modalizer;
        if (!focusedElement || focusedElement && focusedElementModalizer?.userId === this.activeId) // If there is no currently focused element, or the currently focused element
        // is in the active modalizer, we don't need to do anything.
        return;
        const tabster = this._tabster;
        const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, outsideElement);
        const modalizer = ctx?.modalizer;
        const activeId = this.activeId;
        if (!modalizer && !activeId || modalizer && activeId === modalizer.userId) return;
        const container = ctx?.root.getElement();
        if (container) {
            let toFocus = tabster.focusable.findFirst({
                container: container,
                useActiveModalizer: true
            });
            if (toFocus) {
                if (outsideElement.compareDocumentPosition(toFocus) & document.DOCUMENT_POSITION_PRECEDING) {
                    toFocus = tabster.focusable.findLast({
                        container: container,
                        useActiveModalizer: true
                    });
                    if (!toFocus) // This only might mean that findFirst/findLast are buggy and inconsistent.
                    throw new Error("Something went wrong.");
                }
                tabster.focusedElement.focus(toFocus);
                return;
            }
        }
        // Current Modalizer doesn't seem to have focusable elements.
        // Blurring the currently focused element which is outside of the current Modalizer.
        outsideElement.blur();
    }
}


function $275ded970e260894$export$af216543e1ef674(tabster, // @deprecated use accessibleCheck.
alwaysAccessibleSelector, accessibleCheck) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.modalizer) {
        const api = new (0, $932122096a928d01$export$dbfa5a6b1ba57635)(tabsterCore, alwaysAccessibleSelector, accessibleCheck);
        tabsterCore.modalizer = api;
        tabsterCore.attrHandlers.set("modalizer", (element, existingModalizer, newProps, oldProps, sys)=>{
            if (existingModalizer) {
                if (newProps.id && oldProps?.id !== newProps.id) {
                    // Modalizer id is changed, given the modalizers have
                    // complex logic and could be composite, it is easier
                    // to recreate the Modalizer instance than to implement
                    // the id update.
                    existingModalizer.dispose();
                    return api.createModalizer(element, newProps, sys);
                }
                existingModalizer.setProps(newProps);
                return existingModalizer;
            }
            return api.createModalizer(element, newProps, sys);
        });
    }
    return tabsterCore.modalizer;
}




'use client';
function $90683aaf3b536711$export$7e2271c66fded443() {
    const modalizerRefAPI = (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)((0, $275ded970e260894$export$af216543e1ef674));
    const [setActivateModalTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    const activateModal = $acw62.useCallback((elementFromModal)=>{
        // We call the actual activation function on the next tick, because with the typical use case,
        // the hook will be called on the same tick when other Tabster attributes are being applied,
        // and on the current tick the element has just received the attributes, but Tabster has not
        // instantiated the Modalizer yet.
        setActivateModalTimeout(()=>{
            var _modalizerRefAPI_current;
            (_modalizerRefAPI_current = modalizerRefAPI.current) === null || _modalizerRefAPI_current === void 0 || _modalizerRefAPI_current.activate(elementFromModal);
        }, 0);
    }, [
        modalizerRefAPI,
        setActivateModalTimeout
    ]);
    return activateModal;
}





'use client';
const $b0397c93cedc8a09$export$785785b511aa51f7 = {
    root: 'fui-PopoverSurface'
};
const $b0397c93cedc8a09$export$a2b615cb523a0f18 = {
    small: 6,
    medium: 8,
    large: 8
};
/**
 * Styles for the root slot
 */ const $b0397c93cedc8a09$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f9ggezi",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Bhu2qc9: "fymb6k8"
    },
    inline: {
        Bj3rh1h: "f19g0ac"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    brand: {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk"
    },
    smallPadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1sy4kr4"
    },
    mediumPadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f4zyqsv"
    },
    largePadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fop8ug2"
    },
    smallArrow: {
        rhnwrx: "f1s3jn22",
        Bdy53xb: "fv40uqz"
    },
    mediumLargeArrow: {
        rhnwrx: "f1f72gjr",
        Bdy53xb: "f69yoe5"
    },
    arrow: {
        B7ck84d: "f1ewtqcl",
        qhf8xq: "f1euv43f",
        Bj3rh1h: "f1bsuimh",
        De3pzq: "f1u2r49w",
        B2eet1l: "fqhgnl",
        Beyfa6y: "f17bz04i",
        Bz10aip: "f36o3x3",
        Bqenvij: "fzofk8q",
        a9b677: "f1wbx1ie",
        Ftih45: "f1wl9k8s",
        Br0sdwz: "f1aocrix",
        cmx5o7: "f1ljr5q2",
        susq4k: 0,
        Biibvgv: 0,
        Bicfajf: 0,
        qehafq: 0,
        Brs5u8j: "f155f1qt",
        Ccq8qp: "f9mhzq7",
        Baz25je: "fr6rhvx",
        Bcgcnre: 0,
        Bqjgrrk: 0,
        qa3bma: 0,
        y0oebl: 0,
        Biqmznv: 0,
        Bm6vgfq: 0,
        Bbv0w2i: 0,
        uvfttm: 0,
        eqrjj: 0,
        Bk5zm6e: 0,
        m598lv: 0,
        B4f6apu: 0,
        ydt019: 0,
        Bq4z7u6: 0,
        Bdkvgpv: 0,
        B0qfbqy: 0,
        kj8mxx: "f1kc0wz4",
        r59vdv: "fgq90dz",
        Bkw5xw4: "fq0y47f",
        hl6cv3: "f1pwrbz6",
        aea9ga: "f1hxxcvm",
        yayu3t: "fw8rgyo",
        Bhsv975: "f1wnzycx",
        rhl9o9: "f1730wal",
        B7gxrvb: "f1fy4ixr",
        B6q6orb: "fobkauc",
        B0lu1f8: "f16bqv1l"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f9ggezi{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fymb6k8{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 8px 16px var(--colorNeutralShadowKey));}",
        ".f19g0ac{z-index:1;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        [
            ".f1sy4kr4{padding:12px;}",
            {
                p: -1
            }
        ],
        [
            ".f4zyqsv{padding:16px;}",
            {
                p: -1
            }
        ],
        [
            ".fop8ug2{padding:20px;}",
            {
                p: -1
            }
        ],
        ".f1s3jn22{--fui-positioning-arrow-height:8.484px;}",
        ".fv40uqz{--fui-positioning-arrow-offset:-4.242px;}",
        ".f1f72gjr{--fui-positioning-arrow-height:11.312px;}",
        ".f69yoe5{--fui-positioning-arrow-offset:-5.656px;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1euv43f{position:absolute;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fqhgnl{background-clip:content-box;}",
        ".f17bz04i{border-bottom-left-radius:var(--borderRadiusSmall) ;}",
        ".f36o3x3{transform:rotate(var(--fui-positioning-arrow-angle)) ;}",
        ".fzofk8q{height:var(--fui-positioning-arrow-height);}",
        ".f1wbx1ie{width:var(--fui-positioning-arrow-height);}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1aocrix::before{display:block;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        [
            ".f155f1qt::before{margin:-1px;}",
            {
                p: -1
            }
        ],
        ".f9mhzq7::before{width:100%;}",
        ".fr6rhvx::before{height:100%;}",
        [
            ".f1kc0wz4::before{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fgq90dz::before{border-bottom-left-radius:var(--borderRadiusSmall) ;}",
        ".fq0y47f::before{clip-path:polygon(0% 0%, 100% 100%, 0% 100%);}",
        "[data-popper-placement^=\"top\"] .f1pwrbz6{bottom:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"top\"] .f1hxxcvm{--fui-positioning-arrow-angle:-45deg;}",
        "[data-popper-placement^=\"right\"] .fw8rgyo{left:var(--fui-positioning-arrow-offset) ;}",
        "[data-popper-placement^=\"right\"] .f1wnzycx{--fui-positioning-arrow-angle:45deg;}",
        "[data-popper-placement^=\"bottom\"] .f1730wal{top:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"bottom\"] .f1fy4ixr{--fui-positioning-arrow-angle:135deg;}",
        "[data-popper-placement^=\"left\"] .fobkauc{right:var(--fui-positioning-arrow-offset) ;}",
        "[data-popper-placement^=\"left\"] .f16bqv1l{--fui-positioning-arrow-angle:225deg;}"
    ]
});
const $b0397c93cedc8a09$export$8e46f2e5324a79b8 = (state)=>{
    const styles = $b0397c93cedc8a09$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($b0397c93cedc8a09$export$785785b511aa51f7.root, styles.root, state.inline && styles.inline, state.size === 'small' && styles.smallPadding, state.size === 'medium' && styles.mediumPadding, state.size === 'large' && styles.largePadding, state.appearance === 'inverted' && styles.inverted, state.appearance === 'brand' && styles.brand, state.root.className);
    // eslint-disable-next-line react-hooks/immutability
    state.arrowClassName = (0, $00898283de415a49$export$3d46f4579dba46e5)(styles.arrow, state.size === 'small' ? styles.smallArrow : styles.mediumLargeArrow);
    return state;
};


/**
 * The default value of the tooltip's border radius (borderRadiusMedium).
 *
 * Unfortunately, Popper requires it to be specified as a variable instead of using CSS.
 * While we could use getComputedStyle, that adds a performance penalty for something that
 * will likely never change.
 *
 * @internal
 */ const $478fe93b25bc64cb$export$c3e7e32ff8175118 = 4;



var $acw62 = parcelRequire("acw62");

function $c44df703e8f8e21f$export$1834a16e35f276c5(motion, options) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const { as: as, children: children, ...rest } = motion !== null && motion !== void 0 ? motion : {};
    if (motion === null) {
        // Heads up!
        // Render function is used there to avoid rendering a motion component and handle unmounting logic
        const isUnmounted = !options.defaultProps.visible && options.defaultProps.unmountOnExit;
        const renderFn = (_, props)=>isUnmounted ? null : /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, props.children);
        /**
     * Casting is required here as SlotComponentType is a function, not an object.
     * Although SlotComponentType has a function signature, it is still just an object.
     * This is required to make a slot callable (JSX compatible), this is the exact same approach
     * that is used on `@types/react` components
     */ return {
            [(0, $a9190614d56c943f$export$2eb147a2bf7697ad)]: renderFn,
            [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: options.elementType
        };
    }
    /**
   * Casting is required here as SlotComponentType is a function, not an object.
   * Although SlotComponentType has a function signature, it is still just an object.
   * This is required to make a slot callable (JSX compatible), this is the exact same approach
   * that is used on `@types/react` components
   */ const propsWithMetadata = {
        ...options.defaultProps,
        ...rest,
        [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: options.elementType
    };
    if (typeof children === 'function') propsWithMetadata[0, $a9190614d56c943f$export$2eb147a2bf7697ad] = children;
    return propsWithMetadata;
}


// Copied from packages/tokens/src/global/durations.ts
// Values are numeric in milliseconds for ease of use in Web Animations API
// (rather than parsing '__ms')
const $a9dd808ce2ff0a37$export$38b928a7167ce124 = {
    durationUltraFast: 50,
    durationFaster: 100,
    durationFast: 150,
    durationNormal: 200,
    durationGentle: 250,
    durationSlow: 300,
    durationSlower: 400,
    durationUltraSlow: 500
};
const $a9dd808ce2ff0a37$export$6894093bf294bea5 = {
    curveAccelerateMax: 'cubic-bezier(0.9,0.1,1,0.2)',
    curveAccelerateMid: 'cubic-bezier(1,0,1,1)',
    curveAccelerateMin: 'cubic-bezier(0.8,0,0.78,1)',
    curveDecelerateMax: 'cubic-bezier(0.1,0.9,0.2,1)',
    curveDecelerateMid: 'cubic-bezier(0,0,0,1)',
    curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
    curveEasyEaseMax: 'cubic-bezier(0.8,0,0.2,1)',
    curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
    curveLinear: 'cubic-bezier(0,0,1,1)'
};
const $a9dd808ce2ff0a37$export$24b36403afffca36 = {
    ...$a9dd808ce2ff0a37$export$38b928a7167ce124,
    ...$a9dd808ce2ff0a37$export$6894093bf294bea5
}; /*
TODO: enforce naming conventions when TypeScript 4.4 features are supported in Fluent:

type DurationKey = `duration${Capitalize<string>}`;
type CurveKey = `curve${Capitalize<string>}`;
type CurveValue = `cubic-bezier(${number},${number},${number},${number})`;

type DurationTokens = Record<DurationKey, number>;
type CurveTokens = Record<CurveKey, CurveValue>;
*/ 


var $acw62 = parcelRequire("acw62");
'use client';
function $949974c661be515d$export$c3c1287055233f8d() {
    const isFirst = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirst.current) isFirst.current = false;
    }, []);
    // eslint-disable-next-line react-hooks/refs
    return isFirst.current;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $78d58227f0aa0a73$export$812dfa23d18e6d81 = $acw62.createContext(undefined);
const $78d58227f0aa0a73$export$67ca7631e583a58f = $78d58227f0aa0a73$export$812dfa23d18e6d81.Provider;
const $78d58227f0aa0a73$export$5bfaa3767a974d5 = ()=>$acw62.useContext($78d58227f0aa0a73$export$812dfa23d18e6d81);



var $acw62 = parcelRequire("acw62");
/**
 * Checks if the animation is running at the moment.
 */ function $265839c0cb798a52$export$6eca332e8811d22d(animation) {
    if (animation.playState === 'running') {
        var _animation_effect;
        // Heads up!
        //
        // There is an edge case where the animation is running, but the overall progress is 0 or 1. In this case, we
        // consider the animation to be not running. If it will be reversed it will flip from 1 to 0, and we will observe a
        // glitch.
        // "overallProgress" is not supported in all browsers, so we need to check if it exists.
        // We will fall back to the currentTime and duration if "overallProgress" is not supported.
        if (animation.overallProgress !== undefined) {
            var _animation_overallProgress;
            const overallProgress = (_animation_overallProgress = animation.overallProgress) !== null && _animation_overallProgress !== void 0 ? _animation_overallProgress : 0;
            return overallProgress > 0 && overallProgress < 1;
        }
        var _animation_currentTime;
        const currentTime = Number((_animation_currentTime = animation.currentTime) !== null && _animation_currentTime !== void 0 ? _animation_currentTime : 0);
        var _animation_effect_getTiming_duration;
        const totalTime = Number((_animation_effect_getTiming_duration = (_animation_effect = animation.effect) === null || _animation_effect === void 0 ? void 0 : _animation_effect.getTiming().duration) !== null && _animation_effect_getTiming_duration !== void 0 ? _animation_effect_getTiming_duration : 0);
        return currentTime > 0 && currentTime < totalTime;
    }
    return false;
}


'use client';
const $82feaafe3a438e6d$export$999a2a2cf78cf234 = {
    fill: 'forwards'
};
// A motion atom's default reduced motion is a simple 1 ms duration.
// But an atom can define a custom reduced motion, overriding keyframes and/or params like duration, easing, iterations, etc.
const $82feaafe3a438e6d$var$DEFAULT_REDUCED_MOTION_ATOM = {
    duration: 1
};
/**
 * Creates an animation handle that controls multiple animations.
 * Is used to avoid leaking "element" references from the hook.
 *
 * @param animations
 */ function $82feaafe3a438e6d$var$createHandle(animations) {
    return {
        set playbackRate (rate){
            animations.forEach((animation)=>{
                animation.playbackRate = rate;
            });
        },
        setMotionEndCallbacks (onfinish, oncancel) {
            // Heads up!
            // This could use "Animation:finished", but it's causing a memory leak in Chromium.
            // See: https://issues.chromium.org/u/2/issues/383016426
            const promises = animations.map((animation)=>{
                return new Promise((resolve, reject)=>{
                    animation.onfinish = ()=>resolve();
                    animation.oncancel = ()=>reject();
                });
            });
            Promise.all(promises).then(()=>{
                onfinish();
            }).catch(()=>{
                oncancel();
            });
        },
        isRunning () {
            return animations.some((animation)=>(0, $265839c0cb798a52$export$6eca332e8811d22d)(animation));
        },
        dispose: ()=>{
            animations.length = 0;
        },
        cancel: ()=>{
            animations.forEach((animation)=>{
                animation.cancel();
            });
        },
        pause: ()=>{
            animations.forEach((animation)=>{
                animation.pause();
            });
        },
        play: ()=>{
            animations.forEach((animation)=>{
                animation.play();
            });
        },
        finish: ()=>{
            animations.forEach((animation)=>{
                animation.finish();
            });
        },
        reverse: ()=>{
            // Heads up!
            //
            // This is used for the interruptible motion. If the animation is running, we need to reverse it.
            //
            // TODO: what do with animations that have "delay"?
            // TODO: what do with animations that have different "durations"?
            animations.forEach((animation)=>{
                animation.reverse();
            });
        }
    };
}
function $82feaafe3a438e6d$var$useAnimateAtomsInSupportedEnvironment() {
    var _window_Animation;
    // eslint-disable-next-line @nx/workspace-no-restricted-globals
    const SUPPORTS_PERSIST = typeof window !== 'undefined' && typeof ((_window_Animation = window.Animation) === null || _window_Animation === void 0 ? void 0 : _window_Animation.prototype.persist) === 'function';
    return $acw62.useCallback((element, value, options)=>{
        const atoms = Array.isArray(value) ? value : [
            value
        ];
        const { isReducedMotion: isReducedMotion } = options;
        const animations = atoms.map((motion)=>{
            // Grab the custom reduced motion definition if it exists, or fall back to the default reduced motion.
            const { keyframes: motionKeyframes, reducedMotion: reducedMotion = $82feaafe3a438e6d$var$DEFAULT_REDUCED_MOTION_ATOM, ...params } = motion;
            // Grab the reduced motion keyframes if they exist, or fall back to the regular keyframes.
            const { keyframes: reducedMotionKeyframes = motionKeyframes, ...reducedMotionParams } = reducedMotion;
            const animationKeyframes = isReducedMotion ? reducedMotionKeyframes : motionKeyframes;
            const animationParams = {
                ...$82feaafe3a438e6d$export$999a2a2cf78cf234,
                ...params,
                // Use reduced motion overrides (e.g. duration, easing) when reduced motion is enabled
                ...isReducedMotion && reducedMotionParams
            };
            try {
                // Firefox can throw an error when calling `element.animate()`.
                // See: https://github.com/microsoft/fluentui/issues/33902
                const animation = element.animate(animationKeyframes, animationParams);
                if (SUPPORTS_PERSIST) // Chromium browsers can return null when calling `element.animate()`.
                // See: https://github.com/microsoft/fluentui/issues/33902
                animation === null || animation === void 0 || animation.persist();
                else {
                    const resultKeyframe = animationKeyframes[animationKeyframes.length - 1];
                    var _element_style;
                    Object.assign((_element_style = element.style) !== null && _element_style !== void 0 ? _element_style : {}, resultKeyframe);
                }
                return animation;
            } catch (e) {
                return null;
            }
        }).filter((animation)=>!!animation);
        return $82feaafe3a438e6d$var$createHandle(animations);
    }, [
        SUPPORTS_PERSIST
    ]);
}
/**
 * In test environments, this hook is used to delay the execution of a callback until the next render. This is necessary
 * to ensure that the callback is not executed synchronously, which would cause the test to fail.
 *
 * @see https://github.com/microsoft/fluentui/issues/31701
 */ function $82feaafe3a438e6d$var$useAnimateAtomsInTestEnvironment() {
    const [count, setCount] = $acw62.useState(0);
    const callbackRef = $acw62.useRef(undefined);
    const realAnimateAtoms = $82feaafe3a438e6d$var$useAnimateAtomsInSupportedEnvironment();
    $acw62.useEffect(()=>{
        if (count > 0) {
            var _callbackRef_current;
            (_callbackRef_current = callbackRef.current) === null || _callbackRef_current === void 0 || _callbackRef_current.call(callbackRef);
        }
    }, [
        count
    ]);
    return $acw62.useCallback((element, value, options)=>{
        const ELEMENT_SUPPORTS_WEB_ANIMATIONS = typeof element.animate === 'function';
        // Heads up!
        // If the environment supports Web Animations API, we can use the native implementation.
        if (ELEMENT_SUPPORTS_WEB_ANIMATIONS) return realAnimateAtoms(element, value, options);
        return {
            setMotionEndCallbacks (onfinish) {
                callbackRef.current = onfinish;
                setCount((v)=>v + 1);
            },
            set playbackRate (rate){
            /* no-op */ },
            isRunning () {
                return false;
            },
            dispose () {
            /* no-op */ },
            cancel () {
            /* no-op */ },
            pause () {
            /* no-op */ },
            play () {
            /* no-op */ },
            finish () {
            /* no-op */ },
            reverse () {
            /* no-op */ }
        };
    }, [
        realAnimateAtoms
    ]);
}
function $82feaafe3a438e6d$export$93989c19398647ca() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $82feaafe3a438e6d$var$useAnimateAtomsInSupportedEnvironment();
}



var $acw62 = parcelRequire("acw62");
'use client';
function $e3f25356fa59d907$export$a38b9ad22b295ac4(imperativeRef) {
    const animationRef = $acw62.useRef(undefined);
    $acw62.useImperativeHandle(imperativeRef, ()=>({
            setPlayState: (state)=>{
                if (state === 'running') {
                    var _animationRef_current;
                    (_animationRef_current = animationRef.current) === null || _animationRef_current === void 0 || _animationRef_current.play();
                }
                if (state === 'paused') {
                    var _animationRef_current1;
                    (_animationRef_current1 = animationRef.current) === null || _animationRef_current1 === void 0 || _animationRef_current1.pause();
                }
            },
            setPlaybackRate: (rate)=>{
                if (animationRef.current) animationRef.current.playbackRate = rate;
            }
        }));
    return animationRef;
}



var $acw62 = parcelRequire("acw62");
'use client';
function $f910bf47b194652c$export$91db9bc4f8ac944a() {
    return $acw62.useReducer((x)=>x + 1, 0)[1];
}



var $acw62 = parcelRequire("acw62");
'use client';
function $30b9020f7ddef003$export$92e5afcdc0d187b6(visible = false, unmountOnExit = false) {
    const mountedRef = $acw62.useRef(unmountOnExit ? visible : true);
    const forceUpdate = (0, $f910bf47b194652c$export$91db9bc4f8ac944a)();
    const setMounted = $acw62.useCallback((newValue)=>{
        if (mountedRef.current !== newValue) {
            mountedRef.current = newValue;
            forceUpdate();
        }
    }, [
        forceUpdate
    ]);
    $acw62.useEffect(()=>{
        if (visible) mountedRef.current = visible;
    });
    // eslint-disable-next-line react-hooks/refs
    return [
        visible || mountedRef.current,
        setMounted
    ];
}





var $acw62 = parcelRequire("acw62");
'use client';
const $a6ea602503e7be50$var$REDUCED_MEDIA_QUERY = 'screen and (prefers-reduced-motion: reduce)';
function $a6ea602503e7be50$export$c537e63161742ce3() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    var _targetDocument_defaultView;
    const targetWindow = (_targetDocument_defaultView = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) !== null && _targetDocument_defaultView !== void 0 ? _targetDocument_defaultView : null;
    const queryValue = $acw62.useRef(false);
    const isEnabled = $acw62.useCallback(()=>queryValue.current, []);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        if (targetWindow === null || typeof targetWindow.matchMedia !== 'function') return;
        const queryMatch = targetWindow.matchMedia($a6ea602503e7be50$var$REDUCED_MEDIA_QUERY);
        if (queryMatch.matches) queryValue.current = true;
        const matchListener = (e)=>{
            queryValue.current = e.matches;
        };
        queryMatch.addEventListener('change', matchListener);
        return ()=>{
            queryMatch.removeEventListener('change', matchListener);
        };
    }, [
        targetWindow
    ]);
    return isEnabled;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $4967d38ee824a4c7$var$IS_REACT_19_OR_HIGHER = parseInt($acw62.version, 10) >= 19;
function $4967d38ee824a4c7$export$4554ac6b8c3e1a5d(element) {
    if (!element) return undefined;
    if ($4967d38ee824a4c7$var$IS_REACT_19_OR_HIGHER) return element.props.ref;
    return element.ref;
}


'use client';
const $00f5a53f1344b220$var$CHILD_ERROR_MESSAGE = [
    '@fluentui/react-motion: Invalid child element.',
    '\n',
    'Motion factories require a single child element to be passed. ',
    'That element element should support ref forwarding i.e. it should be either an intrinsic element (e.g. div) or a component that uses React.forwardRef().'
].join('');
function $00f5a53f1344b220$export$7dc11cdee8dc0d18(children, mounted = true) {
    const childRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{}, [
        mounted
    ]);
    try {
        const child = $acw62.Children.only(children);
        if ($acw62.isValidElement(child)) return [
            $acw62.cloneElement(child, {
                ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(childRef, (0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child))
            }),
            childRef
        ];
    } catch  {
    /* empty */ }
    throw new Error($00f5a53f1344b220$var$CHILD_ERROR_MESSAGE);
}



var $acw62 = parcelRequire("acw62");
'use client';
const $69721b48206ed2ce$var$MotionBehaviourContext = $acw62.createContext(undefined);
const $69721b48206ed2ce$export$3f59f148e5942239 = $69721b48206ed2ce$var$MotionBehaviourContext.Provider;
const $69721b48206ed2ce$export$6553b01af246e5fe = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($69721b48206ed2ce$var$MotionBehaviourContext)) !== null && _React_useContext !== void 0 ? _React_useContext : 'default';
};




var $acw62 = parcelRequire("acw62");





'use client';
const $963d4b42e27ff431$export$8a98be0d1dccdceb = Symbol('MOTION_DEFINITION');
function $963d4b42e27ff431$export$46b7e4b9dc6110c3(value) {
    const Atom = (props)=>{
        const { children: children, imperativeRef: imperativeRef, onMotionFinish: onMotionFinishProp, onMotionStart: onMotionStartProp, onMotionCancel: onMotionCancelProp, replayKey: replayKey, ..._rest } = props;
        const params = _rest;
        const [child, childRef] = (0, $00f5a53f1344b220$export$7dc11cdee8dc0d18)(children);
        const handleRef = (0, $e3f25356fa59d907$export$a38b9ad22b295ac4)(imperativeRef);
        const isInitialRender = $acw62.useRef(true);
        const skipMotions = (0, $69721b48206ed2ce$export$6553b01af246e5fe)() === 'skip';
        const optionsRef = $acw62.useRef({
            skipMotions: skipMotions,
            params: params
        });
        const animateAtoms = (0, $82feaafe3a438e6d$export$93989c19398647ca)();
        const isReducedMotion = (0, $a6ea602503e7be50$export$c537e63161742ce3)();
        const onMotionStart = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
            onMotionStartProp === null || onMotionStartProp === void 0 || onMotionStartProp(null);
        });
        const onMotionFinish = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
            onMotionFinishProp === null || onMotionFinishProp === void 0 || onMotionFinishProp(null);
        });
        const onMotionCancel = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
            onMotionCancelProp === null || onMotionCancelProp === void 0 || onMotionCancelProp(null);
        });
        // Stable callback (all deps are refs or useEventCallback) that activates a handle for a new playback cycle.
        //
        // TODO: consider moving the cancel+play+rewire sequence into a handle.replay() method on AnimationHandle,
        // keeping pure animation sequencing on the handle and React callbacks here in the component.
        const activateAnimationHandle = $acw62.useCallback((handle)=>{
            onMotionStart();
            handle.setMotionEndCallbacks(onMotionFinish, onMotionCancel);
            if (optionsRef.current.skipMotions) handle.finish();
        }, [
            onMotionStart,
            onMotionFinish,
            onMotionCancel
        ]);
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            // Heads up!
            // We store the params in a ref to avoid re-rendering the component when the params change.
            optionsRef.current = {
                skipMotions: skipMotions,
                params: params
            };
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            const element = childRef.current;
            if (element) {
                const atoms = typeof value === 'function' ? value({
                    element: element,
                    ...optionsRef.current.params
                }) : value;
                const handle = animateAtoms(element, atoms, {
                    isReducedMotion: isReducedMotion()
                });
                handleRef.current = handle;
                activateAnimationHandle(handle);
                return ()=>{
                    handle.cancel();
                };
            }
        }, [
            animateAtoms,
            childRef,
            handleRef,
            isReducedMotion,
            activateAnimationHandle
        ]);
        // Skips initial mount; on replayKey changes, reuses existing Animation objects via cancel+play
        // rather than recreating them, preserving DOM continuity.
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            if (isInitialRender.current) return;
            const handle = handleRef.current;
            if (handle) {
                handle.cancel();
                handle.play();
                activateAnimationHandle(handle);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- replayKey is intentionally the only trigger; other deps are stable refs/callbacks
        }, [
            replayKey
        ]);
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            isInitialRender.current = false;
            return ()=>{
                isInitialRender.current = true;
            };
        }, []);
        return child;
    };
    return Object.assign(Atom, {
        // Heads up!
        // Always normalize it to a function to simplify types
        [$963d4b42e27ff431$export$8a98be0d1dccdceb]: typeof value === 'function' ? value : ()=>value
    });
}


'use client';
const $a90210c34a8674c7$export$a121f71575b68679 = Symbol('PRESENCE_MOTION_DEFINITION');
const $a90210c34a8674c7$var$INTERRUPTABLE_MOTION_SYMBOL = Symbol.for('interruptablePresence');
function $a90210c34a8674c7$export$e943b41c81f8ae82(value) {
    return Object.assign((props)=>{
        const itemContext = $acw62.useContext((0, $78d58227f0aa0a73$export$812dfa23d18e6d81));
        const merged = {
            ...itemContext,
            ...props
        };
        const skipMotions = (0, $69721b48206ed2ce$export$6553b01af246e5fe)() === 'skip';
        const { appear: appear, children: children, imperativeRef: imperativeRef, onExit: onExit, onMotionFinish: onMotionFinish, onMotionStart: onMotionStart, onMotionCancel: onMotionCancel, visible: visible, unmountOnExit: unmountOnExit, ..._rest } = merged;
        const params = _rest;
        const [mounted, setMounted] = (0, $30b9020f7ddef003$export$92e5afcdc0d187b6)(visible, unmountOnExit);
        const [child, childRef] = (0, $00f5a53f1344b220$export$7dc11cdee8dc0d18)(children, mounted);
        const handleRef = (0, $e3f25356fa59d907$export$a38b9ad22b295ac4)(imperativeRef);
        const optionsRef = $acw62.useRef({
            appear: appear,
            params: params,
            skipMotions: skipMotions
        });
        const animateAtoms = (0, $82feaafe3a438e6d$export$93989c19398647ca)();
        const isFirstMount = (0, $949974c661be515d$export$c3c1287055233f8d)();
        const isReducedMotion = (0, $a6ea602503e7be50$export$c537e63161742ce3)();
        const handleMotionStart = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((direction)=>{
            onMotionStart === null || onMotionStart === void 0 || onMotionStart(null, {
                direction: direction
            });
        });
        const handleMotionFinish = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((direction)=>{
            onMotionFinish === null || onMotionFinish === void 0 || onMotionFinish(null, {
                direction: direction
            });
            if (direction === 'exit' && unmountOnExit) {
                setMounted(false);
                onExit === null || onExit === void 0 || onExit();
            }
        });
        const handleMotionCancel = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((direction)=>{
            onMotionCancel === null || onMotionCancel === void 0 || onMotionCancel(null, {
                direction: direction
            });
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            // Heads up!
            // We store the params in a ref to avoid re-rendering the component when the params change.
            optionsRef.current = {
                appear: appear,
                params: params,
                skipMotions: skipMotions
            };
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            const element = childRef.current;
            if (!element) return;
            let handle;
            function cleanup() {
                if (!handle) return;
                // Heads up!
                //
                // If the animation is interruptible & is running, we don't want to cancel it as it will be reversed in
                // the next effect.
                if (IS_EXPERIMENTAL_INTERRUPTIBLE_MOTION && handle.isRunning()) return;
                handle.cancel();
                handleRef.current = undefined;
            }
            const presenceMotion = typeof value === 'function' ? value({
                element: element,
                ...optionsRef.current.params
            }) : value;
            const IS_EXPERIMENTAL_INTERRUPTIBLE_MOTION = presenceMotion[$a90210c34a8674c7$var$INTERRUPTABLE_MOTION_SYMBOL];
            if (IS_EXPERIMENTAL_INTERRUPTIBLE_MOTION) {
                handle = handleRef.current;
                if (handle && handle.isRunning()) {
                    handle.reverse();
                    return cleanup;
                }
            }
            const atoms = visible ? presenceMotion.enter : presenceMotion.exit;
            const direction = visible ? 'enter' : 'exit';
            // Heads up!
            // Initial styles are applied when the component is mounted for the first time and "appear" is set to "false" (otherwise animations are triggered)
            const applyInitialStyles = !optionsRef.current.appear && isFirstMount;
            const skipAnimationByConfig = optionsRef.current.skipMotions;
            if (!applyInitialStyles) handleMotionStart(direction);
            handle = animateAtoms(element, atoms, {
                isReducedMotion: isReducedMotion()
            });
            if (applyInitialStyles) {
                // Heads up!
                // .finish() is used in this case to skip animation and apply animation styles immediately
                handle.finish();
                return cleanup;
            }
            handleRef.current = handle;
            handle.setMotionEndCallbacks(()=>handleMotionFinish(direction), ()=>handleMotionCancel(direction));
            if (skipAnimationByConfig) handle.finish();
            return cleanup;
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            animateAtoms,
            childRef,
            handleRef,
            isReducedMotion,
            handleMotionFinish,
            handleMotionStart,
            handleMotionCancel,
            visible
        ]);
        $acw62.useEffect(()=>{
            // Heads up!
            //
            // Dispose the handle when unmounting the component to clean up retained references. Doing it in a separate
            // effect to ensure that the component is unmounted.
            if (unmountOnExit && !mounted) {
                var _handleRef_current;
                (_handleRef_current = handleRef.current) === null || _handleRef_current === void 0 || _handleRef_current.dispose();
            }
        }, [
            handleRef,
            unmountOnExit,
            mounted
        ]);
        if (mounted) return child;
        return null;
    }, {
        // Heads up!
        // Always normalize it to a function to simplify types
        [$a90210c34a8674c7$export$a121f71575b68679]: typeof value === 'function' ? value : ()=>value
    }, {
        // Wrap `enter` in its own motion component as a static method, e.g. <Fade.In>
        In: (0, $963d4b42e27ff431$export$46b7e4b9dc6110c3)(// Otherwise, pass the `enter` motion object directly.
        typeof value === 'function' ? (...args)=>value(...args).enter : value.enter),
        // Wrap `exit` in its own motion component as a static method, e.g. <Fade.Out>
        Out: (0, $963d4b42e27ff431$export$46b7e4b9dc6110c3)(// Otherwise, pass the `exit` motion object directly.
        typeof value === 'function' ? (...args)=>value(...args).exit : value.exit)
    });
}



const $0dbab70b2cf389f1$export$22f96d8a4ace81f0 = ({ direction: direction, duration: duration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear, delay: delay = 0, outOpacity: outOpacity = 0, inOpacity: inOpacity = 1 })=>{
    const keyframes = [
        {
            opacity: outOpacity
        },
        {
            opacity: inOpacity
        }
    ];
    if (direction === 'exit') keyframes.reverse();
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay,
        // Applying opacity backwards and forwards in time is important
        // to avoid a bug where a delayed animation is not hidden when it should be.
        fill: 'both'
    };
};


const $0dd91e49840ce398$export$353ebd9eed5e1f73 = ({ direction: direction, duration: duration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear, delay: delay = 0, outX: outX = '0px', outY: outY = '0px', inX: inX = '0px', inY: inY = '0px' })=>{
    const keyframes = [
        {
            translate: `${outX} ${outY}`
        },
        {
            translate: `${inX} ${inY}`
        }
    ];
    if (direction === 'exit') keyframes.reverse();
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay
    };
};



// Shared timing constants for the enter animation.
const $bf3d2ea43c9b9f59$var$duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower;
const $bf3d2ea43c9b9f59$var$easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMid;
const $bf3d2ea43c9b9f59$export$b8b7538ff1048313 = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(({ distance: distance = 10 })=>({
        enter: [
            (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
                duration: $bf3d2ea43c9b9f59$var$duration,
                easing: $bf3d2ea43c9b9f59$var$easing,
                direction: 'enter'
            }),
            {
                // slideAtom produces translate keyframes from `outX`/`outY` → `0px`.
                // The `outX`/`outY` values read the positioning-provided CSS variables and scale
                // them by `distance` so the surface slides in from the correct direction.
                ...(0, $0dd91e49840ce398$export$353ebd9eed5e1f73)({
                    duration: $bf3d2ea43c9b9f59$var$duration,
                    easing: $bf3d2ea43c9b9f59$var$easing,
                    direction: 'enter',
                    outX: `calc(var(${(0, $1bc41beff6061826$export$d8cee2f3784ae17a)}, 0px) * ${distance})`,
                    outY: `calc(var(${(0, $1bc41beff6061826$export$9cbb0ef067e89ae6)}, 0px) * ${distance})`
                }),
                // 'accumulate' compositing adds this effect's transform on top of the element's
                // existing transform, preserving any transform applied by the positioning engine.
                composite: 'accumulate'
            }
        ],
        // No exit animation — the surface unmounts immediately on close.
        exit: []
    }));


'use client';
const $11d8a9d2f43b7db3$export$38ececae71530e62 = (props)=>{
    const [contextTarget, setContextTarget] = (0, $638f597d0f0765e2$export$5f3472545b83f7fe)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const positioning = (0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(props.positioning);
    const handlePositionEnd = (0, $a9f840906894d8a8$export$8ac94e7c1d8a7c08)({
        targetDocument: targetDocument,
        onPositioningEnd: positioning.onPositioningEnd
    });
    const initialState = {
        size: 'medium',
        contextTarget: contextTarget,
        setContextTarget: setContextTarget,
        ...props,
        positioning: {
            ...positioning,
            onPositioningEnd: handlePositionEnd
        }
    };
    const children = $acw62.Children.toArray(props.children);
    let popoverTrigger = undefined;
    let popoverSurface = undefined;
    if (children.length === 2) {
        popoverTrigger = children[0];
        popoverSurface = children[1];
    } else if (children.length === 1) popoverSurface = children[0];
    const [open, setOpenState] = $11d8a9d2f43b7db3$var$useOpenState(initialState);
    const [setOpenTimeout, clearOpenTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    const setOpen = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, shouldOpen)=>{
        clearOpenTimeout();
        if (!(e instanceof Event) && e.persist) // < React 17 still uses pooled synthetic events
        e.persist();
        if (e.type === 'mouseleave') {
            var _props_mouseLeaveDelay;
            // FIXME leaking Node timeout type
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setOpenTimeout(()=>{
                setOpenState(e, shouldOpen);
            }, (_props_mouseLeaveDelay = props.mouseLeaveDelay) !== null && _props_mouseLeaveDelay !== void 0 ? _props_mouseLeaveDelay : 500);
        } else setOpenState(e, shouldOpen);
    });
    const toggleOpen = $acw62.useCallback((e)=>{
        setOpen(e, !open);
    }, [
        setOpen,
        open
    ]);
    const positioningRefs = $11d8a9d2f43b7db3$var$usePopoverRefs(initialState);
    var _props_closeOnIframeFocus;
    (0, $090a6633426263f1$export$9afc64c180e82dc4)({
        contains: (0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd),
        element: targetDocument,
        callback: (ev)=>setOpen(ev, false),
        refs: [
            positioningRefs.triggerRef,
            positioningRefs.contentRef
        ],
        disabled: !open,
        disabledFocusOnIframe: !((_props_closeOnIframeFocus = props.closeOnIframeFocus) !== null && _props_closeOnIframeFocus !== void 0 ? _props_closeOnIframeFocus : true)
    });
    // only close on scroll for context, or when closeOnScroll is specified
    const closeOnScroll = initialState.openOnContext || initialState.closeOnScroll;
    (0, $8748bb6e2a770b32$export$ee62ea5c36ea709a)({
        contains: (0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd),
        element: targetDocument,
        callback: (ev)=>setOpen(ev, false),
        refs: [
            positioningRefs.triggerRef,
            positioningRefs.contentRef
        ],
        disabled: !open || !closeOnScroll
    });
    var _props_closeOnFocusOutside;
    // When trapFocus is enabled, dismiss the popover only on a genuine inside -> outside focus
    // transition. Focus that was never inside - e.g. a consumer keeping focus on an external element
    // via `unstable_disableAutoFocus` - must not dismiss it on an outside -> outside focus change.
    // Internal `closeOnFocusOutside` prop allows consumers to opt out during gradual rollout.
    const closeOnFocusOutside = (_props_closeOnFocusOutside = props.closeOnFocusOutside) !== null && _props_closeOnFocusOutside !== void 0 ? _props_closeOnFocusOutside : true;
    const focusWasInsideRef = $acw62.useRef(false);
    const closeOnFocusOutCallback = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        var _ev_composedPath_;
        const target = (_ev_composedPath_ = ev.composedPath()[0]) !== null && _ev_composedPath_ !== void 0 ? _ev_composedPath_ : ev.target;
        const contentElement = positioningRefs.contentRef.current;
        var _positioningRefs_triggerRef_current;
        const triggerElement = (_positioningRefs_triggerRef_current = positioningRefs.triggerRef.current) !== null && _positioningRefs_triggerRef_current !== void 0 ? _positioningRefs_triggerRef_current : null;
        if (!contentElement) return;
        const isInside = (0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd)(contentElement, target) || (0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd)(triggerElement, target);
        if (isInside) {
            focusWasInsideRef.current = true;
            return;
        }
        // Only dismiss if focus previously lived inside the popover.
        if (focusWasInsideRef.current) {
            focusWasInsideRef.current = false;
            setOpen(ev, false);
        }
    });
    $acw62.useEffect(()=>{
        if (!open || !props.trapFocus || !closeOnFocusOutside) return;
        focusWasInsideRef.current = false;
        targetDocument === null || targetDocument === void 0 || targetDocument.addEventListener('focusin', closeOnFocusOutCallback, true);
        return ()=>{
            targetDocument === null || targetDocument === void 0 || targetDocument.removeEventListener('focusin', closeOnFocusOutCallback, true);
        };
    }, [
        open,
        props.trapFocus,
        closeOnFocusOutside,
        targetDocument,
        closeOnFocusOutCallback
    ]);
    const { findFirstFocusable: findFirstFocusable } = (0, $708e79e1f2ab4237$export$2b0519dd5d2bc6d4)();
    const activateModal = (0, $90683aaf3b536711$export$7e2271c66fded443)();
    $acw62.useEffect(()=>{
        if (props.unstable_disableAutoFocus) return;
        const contentElement = positioningRefs.contentRef.current;
        if (open && contentElement) {
            var _contentElement_getAttribute;
            const shouldFocusContainer = !isNaN((_contentElement_getAttribute = contentElement.getAttribute('tabIndex')) !== null && _contentElement_getAttribute !== void 0 ? _contentElement_getAttribute : undefined);
            const firstFocusable = shouldFocusContainer ? contentElement : findFirstFocusable(contentElement);
            firstFocusable === null || firstFocusable === void 0 || firstFocusable.focus();
            if (shouldFocusContainer) // Modal activation happens automatically when something inside the modal is focused programmatically.
            // When the container is focused, we need to activate the modal manually.
            activateModal(contentElement);
        }
    }, [
        findFirstFocusable,
        activateModal,
        open,
        positioningRefs.contentRef,
        props.unstable_disableAutoFocus
    ]);
    var _props_inertTrapFocus, _props_inline;
    return {
        components: {
            surfaceMotion: (0, $bf3d2ea43c9b9f59$export$b8b7538ff1048313)
        },
        ...initialState,
        ...positioningRefs,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        inertTrapFocus: (_props_inertTrapFocus = props.inertTrapFocus) !== null && _props_inertTrapFocus !== void 0 ? _props_inertTrapFocus : props.legacyTrapFocus === undefined ? false : !props.legacyTrapFocus,
        popoverTrigger: popoverTrigger,
        popoverSurface: popoverSurface,
        open: open,
        setOpen: setOpen,
        toggleOpen: toggleOpen,
        setContextTarget: setContextTarget,
        contextTarget: contextTarget,
        inline: (_props_inline = props.inline) !== null && _props_inline !== void 0 ? _props_inline : false,
        surfaceMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(props.surfaceMotion, {
            elementType: (0, $bf3d2ea43c9b9f59$export$b8b7538ff1048313),
            defaultProps: {
                visible: open,
                appear: true,
                unmountOnExit: true
            }
        })
    };
};
/**
 * Creates and manages the Popover open state
 */ function $11d8a9d2f43b7db3$var$useOpenState(state) {
    const onOpenChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, data)=>{
        var _state_onOpenChange;
        return (_state_onOpenChange = state.onOpenChange) === null || _state_onOpenChange === void 0 ? void 0 : _state_onOpenChange.call(state, e, data);
    });
    const [open, setOpenState] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: state.open,
        defaultState: state.defaultOpen,
        initialState: false
    });
    // eslint-disable-next-line react-hooks/immutability
    state.open = open !== undefined ? open : state.open;
    const setContextTarget = state.setContextTarget;
    const setOpen = $acw62.useCallback((e, shouldOpen)=>{
        if (shouldOpen && e.type === 'contextmenu') setContextTarget(e);
        if (!shouldOpen) setContextTarget(undefined);
        setOpenState(shouldOpen);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(e, {
            open: shouldOpen
        });
    }, [
        setOpenState,
        onOpenChange,
        setContextTarget
    ]);
    return [
        open,
        setOpen
    ];
}
/**
 * Creates and sets the necessary trigger, target and content refs used by Popover
 */ function $11d8a9d2f43b7db3$var$usePopoverRefs(state) {
    const positioningOptions = {
        position: 'above',
        align: 'center',
        arrowPadding: 2 * (0, $478fe93b25bc64cb$export$c3e7e32ff8175118),
        target: state.openOnContext ? state.contextTarget : undefined,
        ...(0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(state.positioning)
    };
    // no reason to render arrow when covering the target
    if (positioningOptions.coverTarget) // eslint-disable-next-line react-hooks/immutability
    state.withArrow = false;
    if (state.withArrow) positioningOptions.offset = (0, $4f638fdc3c53bf8c$export$fef5d4d23735b493)(positioningOptions.offset, (0, $b0397c93cedc8a09$export$a2b615cb523a0f18)[state.size]);
    const { targetRef: triggerRef, containerRef: contentRef, arrowRef: arrowRef } = (0, $52c6e5e426b327c0$export$76e597284ffc020)(positioningOptions);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef,
        arrowRef: arrowRef
    };
}



var $acw62 = parcelRequire("acw62");
'use client';
function $f574099791038f00$export$b50bd3e44d6a4b6f(state) {
    const { appearance: appearance, arrowRef: arrowRef, contentRef: contentRef, inline: inline, mountNode: mountNode, open: open, openOnContext: openOnContext, openOnHover: openOnHover, setOpen: setOpen, size: size, toggleOpen: toggleOpen, trapFocus: trapFocus, triggerRef: triggerRef, withArrow: withArrow, inertTrapFocus: inertTrapFocus } = state;
    const popover = $acw62.useMemo(()=>({
            appearance: appearance,
            arrowRef: arrowRef,
            contentRef: contentRef,
            inline: inline,
            mountNode: mountNode,
            open: open,
            openOnContext: openOnContext,
            openOnHover: openOnHover,
            setOpen: setOpen,
            size: size,
            toggleOpen: toggleOpen,
            trapFocus: trapFocus,
            triggerRef: triggerRef,
            withArrow: withArrow,
            inertTrapFocus: inertTrapFocus
        }), [
        appearance,
        arrowRef,
        contentRef,
        inline,
        mountNode,
        open,
        openOnContext,
        openOnHover,
        setOpen,
        size,
        toggleOpen,
        trapFocus,
        triggerRef,
        withArrow,
        inertTrapFocus
    ]);
    return {
        popover: popover
    };
}



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $59b10a9d6ce22ca1$var$MotionRefForwarderContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $59b10a9d6ce22ca1$export$303310ce19d9244b() {
    return $acw62.useContext($59b10a9d6ce22ca1$var$MotionRefForwarderContext);
}
const $59b10a9d6ce22ca1$export$a606ed35b13f65f2 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($59b10a9d6ce22ca1$var$MotionRefForwarderContext.Provider, {
        value: ref
    }, props.children);
});
$59b10a9d6ce22ca1$export$a606ed35b13f65f2.displayName = 'MotionRefForwarder';
const $59b10a9d6ce22ca1$export$521eca9e79de5335 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($59b10a9d6ce22ca1$var$MotionRefForwarderContext.Provider, {
        value: undefined
    }, props.children);
};
$59b10a9d6ce22ca1$export$521eca9e79de5335.displayName = 'MotionRefForwarderReset';




var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
'use client';
const $b76441dd4bb0583c$var$createProvider = (Original)=>{
    const Provider = (props)=>{
        // Holds an actual "props.value"
        const valueRef = $acw62.useRef(props.value);
        // A stable object, is used to avoid context updates via mutation of its values.
        const contextValue = $acw62.useRef(null);
        if (!contextValue.current) contextValue.current = {
            value: valueRef,
            listeners: []
        };
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            valueRef.current = props.value;
            (0, $fO90s.unstable_runWithPriority)((0, $fO90s.unstable_NormalPriority), ()=>{
                contextValue.current.listeners.forEach((listener)=>{
                    listener(props.value);
                });
            });
        }, [
            props.value
        ]);
        return $acw62.createElement(Original, {
            value: contextValue.current
        }, props.children);
    };
    return Provider;
};
const $b76441dd4bb0583c$export$fd42f52fd3ae1109 = (defaultValue)=>{
    // eslint-disable-next-line @fluentui/no-context-default-value
    const context = $acw62.createContext({
        value: {
            current: defaultValue
        },
        listeners: [],
        isDefault: true
    });
    context.Provider = $b76441dd4bb0583c$var$createProvider(context.Provider);
    // We don't support Consumer API
    delete context.Consumer;
    return context;
};



var $acw62 = parcelRequire("acw62");
'use client';
const $6c13c651ac1cfc27$export$30b2013e16e635d0 = (context, selectorFn)=>{
    const contextValue = $acw62.useContext(context);
    const { value: valueRef, listeners: listeners } = contextValue;
    // Read valueRef during render and return selector(value) directly. This is analogous to `useSyncExternalStore`'s
    // `getSnapshot` and is the only way to select a slice from a shared ref-based store without re-rendering every
    // consumer on every provider update.
    // eslint-disable-next-line react-hooks/refs
    const valueAtRender = selectorFn(valueRef.current);
    const [, forceUpdate] = $acw62.useReducer((x)=>x + 1, 0);
    // Refs holding the current selector and the most-recently-returned slice.
    // Updated in a layout effect (ordering: children first, then provider) so
    // they are current by the time the provider's listener loop fires.
    const selectorFnRef = $acw62.useRef(selectorFn);
    const lastValueAtRender = $acw62.useRef(valueAtRender);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        selectorFnRef.current = selectorFn;
        lastValueAtRender.current = valueAtRender;
    });
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        const listener = (payload)=>{
            // Selectors can throw on transiently-inconsistent inputs (stale props vs. newer context value). Swallow so a
            // single consumer's throw doesn't abort the provider's `listeners.forEach`.
            try {
                const nextSelectedValue = selectorFnRef.current(payload);
                if (!Object.is(lastValueAtRender.current, nextSelectedValue)) forceUpdate();
            } catch  {
            // ignored (stale props or similar — heals on the next parent-driven render)
            }
        };
        listeners.push(listener);
        // Effect-fixup: catch updates that occurred between render and effect run (Relay's useFragmentInternal pattern).
        listener(valueRef.current);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    }, [
        listeners,
        valueRef
    ]);
    return valueAtRender;
};


'use client';
const $3280b7af847a1fa8$export$9b9a0cd73afb7ca4 = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $3280b7af847a1fa8$export$7ddc16c3f65b5c80 = {
    open: false,
    setOpen: ()=>null,
    toggleOpen: ()=>null,
    triggerRef: {
        current: null
    },
    contentRef: {
        current: null
    },
    arrowRef: {
        current: null
    },
    openOnContext: false,
    openOnHover: false,
    size: 'medium',
    trapFocus: false,
    inline: false
};
const $3280b7af847a1fa8$export$bf694c7c431c162a = $3280b7af847a1fa8$export$9b9a0cd73afb7ca4.Provider;
const $3280b7af847a1fa8$export$a3cbff38f7dd8303 = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($3280b7af847a1fa8$export$9b9a0cd73afb7ca4, (ctx = $3280b7af847a1fa8$export$7ddc16c3f65b5c80)=>selector(ctx));


const $111559e04c221f40$export$c1ed8784e14550ed = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    var _contextValues_popover;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $3280b7af847a1fa8$export$9b9a0cd73afb7ca4).Provider, {
        value: (_contextValues_popover = contextValues === null || contextValues === void 0 ? void 0 : contextValues.popover) !== null && _contextValues_popover !== void 0 ? _contextValues_popover : (0, $3280b7af847a1fa8$export$7ddc16c3f65b5c80),
        children: [
            state.popoverTrigger,
            state.popoverSurface && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.surfaceMotion, {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $59b10a9d6ce22ca1$export$a606ed35b13f65f2), {
                    children: state.popoverSurface
                })
            })
        ]
    });
};


'use client';
const $d4448b917a5b7f9a$export$5b6b19405a83ff9d = (props)=>{
    const state = (0, $11d8a9d2f43b7db3$export$38ececae71530e62)(props);
    const contextValues = (0, $f574099791038f00$export$b50bd3e44d6a4b6f)(state);
    return (0, $111559e04c221f40$export$c1ed8784e14550ed)(state, contextValues);
};
$d4448b917a5b7f9a$export$5b6b19405a83ff9d.displayName = 'Popover';


var $acw62 = parcelRequire("acw62");
/**
 * Checks if a given element is a FluentUI trigger (e.g. `MenuTrigger` or `Tooltip`).
 * See the {@link FluentTriggerComponent} type for more info.
 *
 * @internal
 */ function $e01252a5d7f1d946$export$ac003f2d3e294800(element) {
    return Boolean(element.type.isFluentTriggerComponent);
}


function $afe88029dd4784e4$export$8e7091920a6cd3c6(children) {
    if (!$acw62.isValidElement(children)) return null;
    return (0, $e01252a5d7f1d946$export$ac003f2d3e294800)(children) ? $afe88029dd4784e4$export$8e7091920a6cd3c6(// but for some reason it's failing on build
    children.props.children) : children;
}

/**
 * Combine two event callbacks into a single callback function that calls each one in order.
 *
 * Usage example:
 * ```ts
 * state.slot.onChange = mergeCallbacks(state.slot.onChange, ev => {
 *   // Handle onChange
 * });
 * ```
 *
 * The primary use is to avoid the need to capture an existing callback (`state.slot.onChange` in the example) to a
 * local variable before replacing with a new listener that calls the existing one. This helps avoid bugs like:
 * * Infinite recursion by calling the re-assigned state.slot.onChange if it's not captured to a local variable.
 * * Missing a call to the original onChange due to an early return or other conditional.
 *
 * If you need a callback that is stable between renders, wrap the result in {@link useEventCallback}.
 *
 * @internal
 * @param callback1 - The first callback to be called, or undefined
 * @param callback2 - The second callback to be called, or undefined
 *
 * @returns A function that that calls the provided functions in order
 */ function $5a086c5c32116b33$export$f05a241035b5c5eb(callback1, callback2) {
    return (...args)=>{
        callback1 === null || callback1 === void 0 || callback1(...args);
        callback2 === null || callback2 === void 0 || callback2(...args);
    };
}


var $acw62 = parcelRequire("acw62");

function $70e12b87c0533cc6$export$4ef26f87842d1b0(children, triggerChildProps) {
    if (typeof children === 'function') return children(triggerChildProps);
    else if (children) return $70e12b87c0533cc6$var$cloneTriggerTree(children, triggerChildProps);
    // Components in React should return either JSX elements or "null", otherwise React will throw:
    //   Nothing was returned from render.
    //   This usually means a return statement is missing. Or, to render nothing, return null.
    return children || null;
}
/**
 * Clones a React element tree, and applies the given props to the first grandchild that is not
 * a FluentTriggerComponent or React Fragment (the same element returned by {@link getTriggerChild}).
 */ function $70e12b87c0533cc6$var$cloneTriggerTree(child, triggerProps) {
    if (!$acw62.isValidElement(child) || child.type === $acw62.Fragment) throw new Error("A trigger element must be a single element for this component. Please ensure that you're not using React Fragments.");
    if ((0, $e01252a5d7f1d946$export$ac003f2d3e294800)(child)) {
        const grandchild = $70e12b87c0533cc6$var$cloneTriggerTree(child.props.children, triggerProps);
        return $acw62.cloneElement(child, undefined, grandchild);
    } else return $acw62.cloneElement(child, triggerProps);
}


/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 




class $33c29d032e30a372$var$Restorer extends (0, $8031a5e97995bd92$export$512356fecf866417) {
    constructor(tabster, element, props){
        super(tabster, element, props);
        this._hasFocus = false;
        this._onFocusOut = (e)=>{
            const element = this._element?.get();
            if (element && e.relatedTarget === null) (0, $8031a5e97995bd92$export$716a11175c03fb4e)(element, new (0, $b6b59d8a07a2383a$export$39f4c1150b8485d9)());
            if (element && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, e.relatedTarget)) this._hasFocus = false;
        };
        this._onFocusIn = ()=>{
            this._hasFocus = true;
        };
        if (this._props.type === (0, $43f171f5f7088580$export$86e1fd7e23a4fab4).Source) {
            const element = this._element?.get();
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(element, "focusout", this._onFocusOut);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(element, "focusin", this._onFocusIn);
            // set hasFocus when the instance is created, in case focus has already moved within it
            this._hasFocus = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, element && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getActiveElement(element.ownerDocument));
        }
    }
    dispose() {
        if (this._props.type === (0, $43f171f5f7088580$export$86e1fd7e23a4fab4).Source) {
            const element = this._element?.get();
            (0, $8031a5e97995bd92$export$b03e9483f936dccb)(element, "focusout", this._onFocusOut);
            (0, $8031a5e97995bd92$export$b03e9483f936dccb)(element, "focusin", this._onFocusIn);
            if (this._hasFocus) {
                const doc = this._tabster.getWindow().document;
                (0, $8031a5e97995bd92$export$716a11175c03fb4e)(doc.body, new (0, $b6b59d8a07a2383a$export$39f4c1150b8485d9)());
            }
        }
    }
}
class $33c29d032e30a372$var$History {
    static{
        this.DEPTH = 10;
    }
    constructor(getWindow){
        this._stack = [];
        this._getWindow = getWindow;
    }
    /**
     * Push a weak element to the top of the history stack.
     * If the stack is full, the bottom weak element is removed.
     * If the element is already at the top of the stack, it is not duplicated.
     */ push(element) {
        // Don't duplicate the top of history
        if (this._stack[this._stack.length - 1]?.get() === element) return;
        if (this._stack.length > $33c29d032e30a372$var$History.DEPTH) this._stack.shift();
        this._stack.push(new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element));
    }
    /**
     * Pop the first element from the history that satisfies the callback.
     * The history is searched from the top to the bottom (from the most recent to the least recent).
     *
     * If a weak reference to the element is broken,
     * or the element is no longer in the DOM,
     * the element is removed from the top of the stack while popping.
     *
     * If no matching element is found, undefined is returned.
     * If the stack is empty, undefined is returned.
     */ pop(filter = ()=>true) {
        const doc = this._getWindow().document;
        for(let index = this._stack.length - 1; index >= 0; index--){
            const maybeElement = this._stack.pop()?.get();
            if (maybeElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(doc.body, (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(maybeElement)) && filter(maybeElement)) return maybeElement;
        }
        return undefined;
    }
}
class $33c29d032e30a372$export$a77b3a3931a75480 {
    constructor(tabster){
        this._onRestoreFocus = (e)=>{
            this._focusedElementState.cancelAsyncFocus((0, $43f171f5f7088580$export$ef584e37c331a849).Restorer);
            // ShadowDOM will have shadowRoot as e.target.
            const source = e.composedPath()[0];
            if (source) {
                // source id must be recovered before source is removed from DOM
                // otherwise it'll be unreachable
                // (as tabster on element will not be available through getTabsterOnElement)
                const sourceId = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, source)?.restorer?.getProps().id;
                this._focusedElementState.requestAsyncFocus((0, $43f171f5f7088580$export$ef584e37c331a849).Restorer, ()=>this._restoreFocus(source, sourceId), 0);
            }
        };
        this._onFocusIn = (element)=>{
            if (!element) return;
            const tabsterAttribute = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, element);
            if (tabsterAttribute?.restorer?.getProps().type !== (0, $43f171f5f7088580$export$86e1fd7e23a4fab4).Target) return;
            this._history.push(element);
        };
        this._restoreFocus = (source, sourceId)=>{
            // don't restore focus if focus isn't lost to body
            const doc = this._getWindow().document;
            if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).getActiveElement(doc) !== doc.body) return;
            if (// clicking on any empty space focuses body - this is can be a false positive
            !this._keyboardNavState.isNavigatingWithKeyboard() && // Source no longer exists on DOM - always restore focus
            (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(doc.body, source)) return;
            const getId = (element)=>{
                const restorerProps = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, element)?.restorer?.getProps();
                // We return id or undefined if there is actual restorer on the element,
                // and null otherwise. To filter out elements that had restorers in their lifetime
                // but don't have them anymore.
                return restorerProps ? restorerProps.id : null;
            };
            // sourceId is undefined or string, if there is no Restorer on the target, the element will
            // be filtered out because getId() will return null.
            this._history.pop((target)=>sourceId === getId(target))?.focus();
        };
        this._tabster = tabster;
        this._getWindow = tabster.getWindow;
        (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(this._getWindow(), (0, $b6b59d8a07a2383a$export$3d63c9b40c6a05c3), this._onRestoreFocus);
        this._history = new $33c29d032e30a372$var$History(this._getWindow);
        this._keyboardNavState = tabster.keyboardNavigation;
        this._focusedElementState = tabster.focusedElement;
        this._focusedElementState.subscribe(this._onFocusIn);
    }
    dispose() {
        const win = this._getWindow();
        this._focusedElementState.unsubscribe(this._onFocusIn);
        this._focusedElementState.cancelAsyncFocus((0, $43f171f5f7088580$export$ef584e37c331a849).Restorer);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, (0, $b6b59d8a07a2383a$export$3d63c9b40c6a05c3), this._onRestoreFocus);
    }
    createRestorer(element, props) {
        const restorer = new $33c29d032e30a372$var$Restorer(this._tabster, element, props);
        // Focus might already be on a restorer target when it gets created so the focusin will not do anything
        if (props.type === (0, $43f171f5f7088580$export$86e1fd7e23a4fab4).Target && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getActiveElement(element.ownerDocument) === element) this._history.push(element);
        return restorer;
    }
}


function $5bd8a18ff3eaa62f$export$80ddb24d84708237(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.restorer) {
        const api = new (0, $33c29d032e30a372$export$a77b3a3931a75480)(tabsterCore);
        tabsterCore.restorer = api;
        tabsterCore.attrHandlers.set("restorer", (element, existingRestorer, newProps)=>{
            if (existingRestorer) {
                existingRestorer.setProps(newProps);
                return existingRestorer;
            }
            return api.createRestorer(element, newProps);
        });
    }
    return tabsterCore.restorer;
}






var $acw62 = parcelRequire("acw62");
'use client';
const $3cadb56bf5cf7176$export$52c56c2e556091a6 = (props)=>{
    // A tabster instance is not necessary to generate tabster attributes
    // but calling the hook will ensure that a tabster instance exists internally and avoids consumers doing the same
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)();
    const strAttr = (0, $89b61763407325c5$export$374a8d854973d904)(props, true);
    return $acw62.useMemo(()=>({
            [(0, $43f171f5f7088580$export$a1195ad1c253d145)]: strAttr
        }), [
        strAttr
    ]);
};



const $3d1133e4019f2495$export$e65b9c9ac3dcd53d = 'data-tabster-never-hide';
const $3d1133e4019f2495$var$DangerousNeverHiddenPropObject = {
    [$3d1133e4019f2495$export$e65b9c9ac3dcd53d]: ''
};
function $3d1133e4019f2495$export$42bbd7fc30f693c3() {
    return $3d1133e4019f2495$var$DangerousNeverHiddenPropObject;
}


'use client';
const $dc225fea5f0a0e8e$var$tabsterAccessibleCheck = (element)=>{
    return element.hasAttribute((0, $3d1133e4019f2495$export$e65b9c9ac3dcd53d));
};
function $dc225fea5f0a0e8e$var$initTabsterModules(tabster) {
    (0, $275ded970e260894$export$af216543e1ef674)(tabster, undefined, $dc225fea5f0a0e8e$var$tabsterAccessibleCheck);
    (0, $5bd8a18ff3eaa62f$export$80ddb24d84708237)(tabster);
}
const $dc225fea5f0a0e8e$export$8e5cbf21155fc1da = (options = {})=>{
    const { trapFocus: trapFocus, alwaysFocusable: alwaysFocusable, legacyTrapFocus: legacyTrapFocus } = options;
    // Initializes the modalizer and restorer APIs
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)($dc225fea5f0a0e8e$var$initTabsterModules);
    const id = (0, $0200d30cfa270435$export$f680877a34711e37)('modal-', options.id);
    const modalAttributes = (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        restorer: {
            type: (0, $43f171f5f7088580$export$86e1fd7e23a4fab4).Source
        },
        ...trapFocus && {
            modalizer: {
                id: id,
                isOthersAccessible: !trapFocus,
                isAlwaysAccessible: alwaysFocusable,
                isTrapped: legacyTrapFocus && trapFocus
            }
        }
    });
    const triggerAttributes = (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        restorer: {
            type: (0, $43f171f5f7088580$export$86e1fd7e23a4fab4).Target
        }
    });
    return {
        modalAttributes: modalAttributes,
        triggerAttributes: triggerAttributes
    };
};



const $c823d65ebf8ac0ff$export$25ba4469a069167 = 'Alt';
const $c823d65ebf8ac0ff$export$59af8b07a9eee9db = 'AltGraph';
const $c823d65ebf8ac0ff$export$de140f0a2ba89d59 = 'CapsLock';
const $c823d65ebf8ac0ff$export$7a7fa4424cb20976 = 'Control';
const $c823d65ebf8ac0ff$export$b076717d71a1a47f = 'Fn';
const $c823d65ebf8ac0ff$export$85f6e01fa084f0f6 = 'FnLock';
const $c823d65ebf8ac0ff$export$b08a9033b36413fb = 'Meta';
const $c823d65ebf8ac0ff$export$935daf61042b74de = 'NumLock';
const $c823d65ebf8ac0ff$export$43c4ad2b7f26555a = 'ScrollLock';
const $c823d65ebf8ac0ff$export$e6d3b4e5ac18cdaf = 'Shift';
const $c823d65ebf8ac0ff$export$3e25e887b7a5b37b = 'Symbol';
const $c823d65ebf8ac0ff$export$ff2e891f6682d840 = 'SymbolLock';
const $c823d65ebf8ac0ff$export$92ce8cce26bb97e1 = 'Hyper';
const $c823d65ebf8ac0ff$export$da846968fb7f9d62 = 'Super';
const $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a = 'Enter';
const $c823d65ebf8ac0ff$export$eef1e68107c58ef2 = ' ';
const $c823d65ebf8ac0ff$export$3e41faf802a29e71 = 'Tab';
const $c823d65ebf8ac0ff$export$1fa5a43af950a186 = 'ArrowDown';
const $c823d65ebf8ac0ff$export$e4c291d45fea4cd0 = 'ArrowLeft';
const $c823d65ebf8ac0ff$export$acad20503ad73ac1 = 'ArrowRight';
const $c823d65ebf8ac0ff$export$2624c5890f1bbcf7 = 'ArrowUp';
const $c823d65ebf8ac0ff$export$290d774e6bd35c9a = 'End';
const $c823d65ebf8ac0ff$export$b94310965bed44e6 = 'Home';
const $c823d65ebf8ac0ff$export$f3f5fc7dcaa52927 = 'PageDown';
const $c823d65ebf8ac0ff$export$f1f11e2fed2d2ae0 = 'PageUp';
const $c823d65ebf8ac0ff$export$e25335cbdf9a4ec4 = 'Backspace';
const $c823d65ebf8ac0ff$export$47d037774b685574 = 'Clear';
const $c823d65ebf8ac0ff$export$92ce62e1201c4fc0 = 'Copy';
const $c823d65ebf8ac0ff$export$65b53f7e8e8587 = 'CrSel';
const $c823d65ebf8ac0ff$export$e5934e6b116b2ede = 'Cut';
const $c823d65ebf8ac0ff$export$bfadae053a633538 = 'Delete';
const $c823d65ebf8ac0ff$export$8fd09476bf36ce41 = 'EraseEof';
const $c823d65ebf8ac0ff$export$f641b683dcc3ebbb = 'ExSel';
const $c823d65ebf8ac0ff$export$ff4c1a9d41c61c5b = 'Insert';
const $c823d65ebf8ac0ff$export$80c501ac3232bb66 = 'Paste';
const $c823d65ebf8ac0ff$export$c51819d211d1dad = 'Redo';
const $c823d65ebf8ac0ff$export$897c9ed706d8ea48 = 'Undo';
const $c823d65ebf8ac0ff$export$5e41db7437457e4f = 'Accept';
const $c823d65ebf8ac0ff$export$435aa52f9ca2e684 = 'Again';
const $c823d65ebf8ac0ff$export$e0f3a40f49e6b4ff = 'Attn';
const $c823d65ebf8ac0ff$export$848c9b7ead0df967 = 'Cancel';
const $c823d65ebf8ac0ff$export$8dc6765e8be191c7 = 'ContextMenu';
const $c823d65ebf8ac0ff$export$d244daf709653685 = 'Escape';
const $c823d65ebf8ac0ff$export$560e7ab682a21a3c = 'Execute';
const $c823d65ebf8ac0ff$export$294e5983706f3c8d = 'Find';
const $c823d65ebf8ac0ff$export$1be7516c0280bee8 = 'Help';
const $c823d65ebf8ac0ff$export$59704c468e1a1527 = 'Pause';
const $c823d65ebf8ac0ff$export$480db61f4dcd7727 = 'Play';
const $c823d65ebf8ac0ff$export$ab4150be7c673f50 = 'Props';
const $c823d65ebf8ac0ff$export$ef9b1a59e592288f = 'Select';
const $c823d65ebf8ac0ff$export$d13069184bfa0730 = 'ZoomIn';
const $c823d65ebf8ac0ff$export$adc4acb67269225 = 'ZoomOut';
const $c823d65ebf8ac0ff$export$1361e444dea2380e = 'BrightnessDown';
const $c823d65ebf8ac0ff$export$52c78b8b992a9d7b = 'BrightnessUp';
const $c823d65ebf8ac0ff$export$d4dc4917073a0ad9 = 'Eject';
const $c823d65ebf8ac0ff$export$c21a1ae6c09d0c57 = 'LogOff';
const $c823d65ebf8ac0ff$export$462bb9472183e274 = 'Power';
const $c823d65ebf8ac0ff$export$71987bfdb1faebb3 = 'PowerOff';
const $c823d65ebf8ac0ff$export$898492d04dfd3de8 = 'PrintScreen';
const $c823d65ebf8ac0ff$export$a419a54b514863c2 = 'Hibernate';
const $c823d65ebf8ac0ff$export$45b51bd799a30168 = 'Standby';
const $c823d65ebf8ac0ff$export$accb22b45fb25893 = 'WakeUp';
const $c823d65ebf8ac0ff$export$f4a731e02c2e22f6 = 'AllCandidates';
const $c823d65ebf8ac0ff$export$92278791597e195 = 'Alphanumeric';
const $c823d65ebf8ac0ff$export$20d4ca75cb144ab0 = 'CodeInput';
const $c823d65ebf8ac0ff$export$5a3a146e358e1bcf = 'Compose';
const $c823d65ebf8ac0ff$export$f4e2e0de8bec13cf = 'Convert';
const $c823d65ebf8ac0ff$export$d7c1bc91029ca3fc = 'Dead';
const $c823d65ebf8ac0ff$export$1a6ade3e5895c67 = 'FinalMode';
const $c823d65ebf8ac0ff$export$3a329d64ac7f1a51 = 'GroupFirst';
const $c823d65ebf8ac0ff$export$f775ac7670e6b750 = 'GroupLast';
const $c823d65ebf8ac0ff$export$e225a46cee3c4cbf = 'GroupNext';
const $c823d65ebf8ac0ff$export$346c400effc2098d = 'GroupPrevious';
const $c823d65ebf8ac0ff$export$d5d4baa34b8f359e = 'ModeChange';
const $c823d65ebf8ac0ff$export$aa9692744b99ab14 = 'NextCandidate';
const $c823d65ebf8ac0ff$export$ac3b287d18bbde8d = 'NonConvert';
const $c823d65ebf8ac0ff$export$f2b24c1f23968e85 = 'PreviousCandidate';
const $c823d65ebf8ac0ff$export$ddab65ae98aaa487 = 'Process';
const $c823d65ebf8ac0ff$export$a3eac4bc82a98f75 = 'SingleCandidate';
const $c823d65ebf8ac0ff$export$7fe3746ef513c197 = 'HangulMode';
const $c823d65ebf8ac0ff$export$cf6da7241d7db023 = 'HanjaMode';
const $c823d65ebf8ac0ff$export$8b68c9a12bd240a4 = 'JunjaMode';
const $c823d65ebf8ac0ff$export$9d3c4c35a5b6cb1a = 'Eisu';
const $c823d65ebf8ac0ff$export$ad60463326eb8d49 = 'Hankaku';
const $c823d65ebf8ac0ff$export$944438bf8b555670 = 'Hiragana';
const $c823d65ebf8ac0ff$export$e6702f8ed49de60b = 'HiraganaKatakana';
const $c823d65ebf8ac0ff$export$5f227dee8c8f89bd = 'KanaMode';
const $c823d65ebf8ac0ff$export$bc0d53240167fa99 = 'KanjiMode';
const $c823d65ebf8ac0ff$export$dd82d5fd5fe7d4fe = 'Katakana';
const $c823d65ebf8ac0ff$export$d85cc3e8bea4280c = 'Romaji';
const $c823d65ebf8ac0ff$export$c8b3f24ac2a372b7 = 'Zenkaku';
const $c823d65ebf8ac0ff$export$58cf8ce148011bd3 = 'ZenkakuHankaku';
const $c823d65ebf8ac0ff$export$189139d8e2521ccc = 'F1';
const $c823d65ebf8ac0ff$export$1e3ae41a03c26919 = 'F2';
const $c823d65ebf8ac0ff$export$635acc0d5908ed6d = 'F3';
const $c823d65ebf8ac0ff$export$1daa073286f9821f = 'F4';
const $c823d65ebf8ac0ff$export$1946172b343c019d = 'F5';
const $c823d65ebf8ac0ff$export$75fb47052abeaeb = 'F6';
const $c823d65ebf8ac0ff$export$cb2b09ce06c88edb = 'F7';
const $c823d65ebf8ac0ff$export$a364ba9f791bbf64 = 'F8';
const $c823d65ebf8ac0ff$export$8dc034ae6f0a8c86 = 'F9';
const $c823d65ebf8ac0ff$export$607ddfc630acfa0 = 'F10';
const $c823d65ebf8ac0ff$export$ccd0054ab4cc4a07 = 'F11';
const $c823d65ebf8ac0ff$export$c9226ba6c07c198e = 'F12';
const $c823d65ebf8ac0ff$export$5b2985c878b189d2 = 'Soft1';
const $c823d65ebf8ac0ff$export$47a30c2a117456eb = 'Soft2';
const $c823d65ebf8ac0ff$export$cbb7360f9ae873c1 = 'Soft3';
const $c823d65ebf8ac0ff$export$5dd66fbf7e8260e7 = 'Soft4';
const $c823d65ebf8ac0ff$export$edd78e781e0d91ff = 'ChannelDown';
const $c823d65ebf8ac0ff$export$f69d726584685fbc = 'ChannelUp';
const $c823d65ebf8ac0ff$export$f39c2d165cd861fe = 'Close';
const $c823d65ebf8ac0ff$export$c81fc8a9aa3cbfaf = 'MailForward';
const $c823d65ebf8ac0ff$export$1072dc4384cd4b49 = 'MailReply';
const $c823d65ebf8ac0ff$export$64e48c990591dd67 = 'MailSend';
const $c823d65ebf8ac0ff$export$edf5f293e15173a6 = 'MediaClose';
const $c823d65ebf8ac0ff$export$8f522530c3047c1 = 'MediaFastForward';
const $c823d65ebf8ac0ff$export$9b4e157ea6b03dc4 = 'MediaPause';
const $c823d65ebf8ac0ff$export$1e02dc8586261377 = 'MediaPlay';
const $c823d65ebf8ac0ff$export$3c4de6c4ec72c4a9 = 'MediaPlayPause';
const $c823d65ebf8ac0ff$export$ae0d6fe390a63c9b = 'MediaRecord';
const $c823d65ebf8ac0ff$export$106df2f4ddf898f5 = 'MediaRewind';
const $c823d65ebf8ac0ff$export$93f45f2572765c74 = 'MediaStop';
const $c823d65ebf8ac0ff$export$95f1ee4a29e0c422 = 'MediaTrackNext';
const $c823d65ebf8ac0ff$export$6e7bf1921fe33a28 = 'MediaTrackPrevious';
const $c823d65ebf8ac0ff$export$6fbbeb565555321b = 'New';
const $c823d65ebf8ac0ff$export$779aeef03935e9f3 = 'Open';
const $c823d65ebf8ac0ff$export$531cef85654f2406 = 'Print';
const $c823d65ebf8ac0ff$export$be11e187edb4cb0c = 'Save';
const $c823d65ebf8ac0ff$export$ce472e30b45fe044 = 'SpellCheck';
const $c823d65ebf8ac0ff$export$1c9f0644f2f359f7 = 'Key11';
const $c823d65ebf8ac0ff$export$10026628c273d8d9 = 'Key12';
const $c823d65ebf8ac0ff$export$8122d65462c044f9 = 'AudioBalanceLeft';
const $c823d65ebf8ac0ff$export$6da512133087dc19 = 'AudioBalanceRight';
const $c823d65ebf8ac0ff$export$483279f0eb3eb6c3 = 'AudioBassBoostDown';
const $c823d65ebf8ac0ff$export$dd0b45a57e31277c = 'AudioBassBoostToggle';
const $c823d65ebf8ac0ff$export$714e09e823f1100e = 'AudioBassBoostUp';
const $c823d65ebf8ac0ff$export$7546180a9f863cb2 = 'AudioFaderFront';
const $c823d65ebf8ac0ff$export$ad637d01b6d3b5b0 = 'AudioFaderRear';
const $c823d65ebf8ac0ff$export$632aa3a36fcce0d9 = 'AudioSurroundModeNext';
const $c823d65ebf8ac0ff$export$32462dede531b63a = 'AudioTrebleDown';
const $c823d65ebf8ac0ff$export$7c316c5a895eb62 = 'AudioTrebleUp';
const $c823d65ebf8ac0ff$export$73ba68778999bb0b = 'AudioVolumeDown';
const $c823d65ebf8ac0ff$export$2727396b9ea4f301 = 'AudioVolumeUp';
const $c823d65ebf8ac0ff$export$f1cc599231f0155f = 'AudioVolumeMute';
const $c823d65ebf8ac0ff$export$f7ba91b6392d3030 = 'MicrophoneToggle';
const $c823d65ebf8ac0ff$export$1a6f6715b16c7dac = 'MicrophoneVolumeDown';
const $c823d65ebf8ac0ff$export$edac5fcbe056b9dd = 'MicrophoneVolumeUp';
const $c823d65ebf8ac0ff$export$a85734c74c77229f = 'MicrophoneVolumeMute';
const $c823d65ebf8ac0ff$export$9b0f6845932a5311 = 'SpeechCorrectionList';
const $c823d65ebf8ac0ff$export$b2ea9c6dbc054596 = 'SpeechInputToggle';
const $c823d65ebf8ac0ff$export$fbf5eb6b5b5f796e = 'LaunchApplication1';
const $c823d65ebf8ac0ff$export$b0af841ea1ac8caa = 'LaunchApplication2';
const $c823d65ebf8ac0ff$export$ee1b38b1fd2fd6ee = 'LaunchCalendar';
const $c823d65ebf8ac0ff$export$f2c32a949fcd2577 = 'LaunchContacts';
const $c823d65ebf8ac0ff$export$8b4d07d8a62ed27d = 'LaunchMail';
const $c823d65ebf8ac0ff$export$8a9d2216beeea70d = 'LaunchMediaPlayer';
const $c823d65ebf8ac0ff$export$fc0f93baa0ed8d1e = 'LaunchMusicPlayer';
const $c823d65ebf8ac0ff$export$9fc5515b060d76e3 = 'LaunchPhone';
const $c823d65ebf8ac0ff$export$67cf4f9dab019464 = 'LaunchScreenSaver';
const $c823d65ebf8ac0ff$export$e45e736041b7f018 = 'LaunchSpreadsheet';
const $c823d65ebf8ac0ff$export$db793ade57fb0147 = 'LaunchWebBrowser';
const $c823d65ebf8ac0ff$export$ad042fb7176822eb = 'LaunchWebCam';
const $c823d65ebf8ac0ff$export$7d9d2a2b3d9d2ac6 = 'LaunchWordProcessor';
const $c823d65ebf8ac0ff$export$9383a2f3942b58dc = 'BrowserBack';
const $c823d65ebf8ac0ff$export$f6274726848eadf1 = 'BrowserFavorites';
const $c823d65ebf8ac0ff$export$fcc53b6d63518134 = 'BrowserForward';
const $c823d65ebf8ac0ff$export$4a475f075adf9434 = 'BrowserHome';
const $c823d65ebf8ac0ff$export$93523c070c325fbe = 'BrowserRefresh';
const $c823d65ebf8ac0ff$export$8c96437a8d9c2d7c = 'BrowserSearch';
const $c823d65ebf8ac0ff$export$cc42d7573a67ba70 = 'BrowserStop';
const $c823d65ebf8ac0ff$export$7a6c770856067f4 = 'AppSwitch';
const $c823d65ebf8ac0ff$export$e01e40655568efad = 'Call';
const $c823d65ebf8ac0ff$export$79f141de891a5fed = 'Camera';
const $c823d65ebf8ac0ff$export$f8793b8700b5ba17 = 'CameraFocus';
const $c823d65ebf8ac0ff$export$957e375d95a01391 = 'EndCall';
const $c823d65ebf8ac0ff$export$bbadff23f5cd28e2 = 'GoBack';
const $c823d65ebf8ac0ff$export$f271c87cf8064402 = 'GoHome';
const $c823d65ebf8ac0ff$export$669d837cde3081c0 = 'HeadsetHook';
const $c823d65ebf8ac0ff$export$9ac012462c421cb2 = 'LastNumberRedial';
const $c823d65ebf8ac0ff$export$14834abbfce3b8cd = 'Notification';
const $c823d65ebf8ac0ff$export$3046760ea9ca3af0 = 'MannerMode';
const $c823d65ebf8ac0ff$export$71f79e08c826dea6 = 'VoiceDial';
const $c823d65ebf8ac0ff$export$9e799ed47e538f9d = 'TV';
const $c823d65ebf8ac0ff$export$33e0cb2ba3e36b39 = 'TV3DMode';
const $c823d65ebf8ac0ff$export$bb4f7668fbcf057d = 'TVAntennaCable';
const $c823d65ebf8ac0ff$export$63219ff5d58c45a0 = 'TVAudioDescription';
const $c823d65ebf8ac0ff$export$80792179d8ffd87b = 'TVAudioDescriptionMixDown';
const $c823d65ebf8ac0ff$export$5f010be0cd6b0b = 'TVAudioDescriptionMixUp';
const $c823d65ebf8ac0ff$export$426bc8423e6463a0 = 'TVContentsMenu';
const $c823d65ebf8ac0ff$export$a32169e4018a2b38 = 'TVDataService';
const $c823d65ebf8ac0ff$export$ae9bbd79b65e7a97 = 'TVInput';
const $c823d65ebf8ac0ff$export$93fe7d4f0cc9dd81 = 'TVInputComponent1';
const $c823d65ebf8ac0ff$export$a68eb799b6a9424 = 'TVInputComponent2';
const $c823d65ebf8ac0ff$export$bde9e691d0b9763a = 'TVInputComposite1';
const $c823d65ebf8ac0ff$export$ee37f778b870c960 = 'TVInputComposite2';
const $c823d65ebf8ac0ff$export$57441ed7d940ad4a = 'TVInputHDMI1';
const $c823d65ebf8ac0ff$export$18f2cbc95c3f5d9e = 'TVInputHDMI2';
const $c823d65ebf8ac0ff$export$d59b33776600d743 = 'TVInputHDMI3';
const $c823d65ebf8ac0ff$export$cbaf98d010a337f8 = 'TVInputHDMI4';
const $c823d65ebf8ac0ff$export$43d009fc6a4abcc = 'TVInputVGA1';
const $c823d65ebf8ac0ff$export$5229da00664eabf3 = 'TVMediaContext';
const $c823d65ebf8ac0ff$export$41b7110227dfa031 = 'TVNetwork';
const $c823d65ebf8ac0ff$export$6d808ba490e74aa3 = 'TVNumberEntry';
const $c823d65ebf8ac0ff$export$caa626888309eac9 = 'TVPower';
const $c823d65ebf8ac0ff$export$465fb7cc725b756a = 'TVRadioService';
const $c823d65ebf8ac0ff$export$b012fab6006633c1 = 'TVSatellite';
const $c823d65ebf8ac0ff$export$652ec5c6f91c9d58 = 'TVSatelliteBS';
const $c823d65ebf8ac0ff$export$375e3750892b9a0d = 'TVSatelliteCS';
const $c823d65ebf8ac0ff$export$4082bee118d1265 = 'TVSatelliteToggle';
const $c823d65ebf8ac0ff$export$11d23f8a290bea2b = 'TVTerrestrialAnalog';
const $c823d65ebf8ac0ff$export$476a62c057a18f0d = 'TVTerrestrialDigital';
const $c823d65ebf8ac0ff$export$1bf89d9356f73f3 = 'TVTimer';
const $c823d65ebf8ac0ff$export$6bfa7bac815a7be2 = 'AVRInput';
const $c823d65ebf8ac0ff$export$291a3d36bd9f5546 = 'AVRPower';
const $c823d65ebf8ac0ff$export$d65c414782d498de = 'ColorF0Red';
const $c823d65ebf8ac0ff$export$2012685419373360 = 'ColorF1Green';
const $c823d65ebf8ac0ff$export$d287aa78274089c5 = 'ColorF2Yellow';
const $c823d65ebf8ac0ff$export$816e2f41a947f921 = 'ColorF3Blue';
const $c823d65ebf8ac0ff$export$6683adba19f75ed8 = 'ColorF4Grey';
const $c823d65ebf8ac0ff$export$31f0b6897f069965 = 'ColorF5Brown';
const $c823d65ebf8ac0ff$export$28a7e8424097b671 = 'ClosedCaptionToggle';
const $c823d65ebf8ac0ff$export$3fb4601d4ead3c62 = 'Dimmer';
const $c823d65ebf8ac0ff$export$719ea771b7828713 = 'DisplaySwap';
const $c823d65ebf8ac0ff$export$7b81c82872602fae = 'DVR';
const $c823d65ebf8ac0ff$export$6b467f3d80cc56bd = 'Exit';
const $c823d65ebf8ac0ff$export$96a657f4f48c50ca = 'FavoriteClear0';
const $c823d65ebf8ac0ff$export$c6fb7f02c9847a0d = 'FavoriteClear1';
const $c823d65ebf8ac0ff$export$4581aaa801b7ec9b = 'FavoriteClear2';
const $c823d65ebf8ac0ff$export$275386adfebc5a34 = 'FavoriteClear3';
const $c823d65ebf8ac0ff$export$61b6760a9dfd8707 = 'FavoriteRecall0';
const $c823d65ebf8ac0ff$export$da3457e02421bf54 = 'FavoriteRecall1';
const $c823d65ebf8ac0ff$export$a7e09d7128a01c9a = 'FavoriteRecall2';
const $c823d65ebf8ac0ff$export$5ee77092aab711bd = 'FavoriteRecall3';
const $c823d65ebf8ac0ff$export$cf26e14238406cee = 'FavoriteStore0';
const $c823d65ebf8ac0ff$export$e360b7bbb61b98be = 'FavoriteStore1';
const $c823d65ebf8ac0ff$export$f91c8b975d30e002 = 'FavoriteStore2';
const $c823d65ebf8ac0ff$export$a1ceb59d0b811ae1 = 'FavoriteStore3';
const $c823d65ebf8ac0ff$export$dd9cef36367ff841 = 'Guide';
const $c823d65ebf8ac0ff$export$7a182cb0eeb93ab4 = 'GuideNextDay';
const $c823d65ebf8ac0ff$export$622e3910f33c3413 = 'GuidePreviousDay';
const $c823d65ebf8ac0ff$export$c4868e4a24d48fad = 'Info';
const $c823d65ebf8ac0ff$export$933386c97295d716 = 'InstantReplay';
const $c823d65ebf8ac0ff$export$a6c7ac8248d6e38a = 'Link';
const $c823d65ebf8ac0ff$export$c629d7edb8f81150 = 'ListProgram';
const $c823d65ebf8ac0ff$export$187a27311c646af3 = 'LiveContent';
const $c823d65ebf8ac0ff$export$5b9db7ce80343746 = 'Lock';
const $c823d65ebf8ac0ff$export$1b05ff7bb714f205 = 'MediaApps';
const $c823d65ebf8ac0ff$export$6a1d69c1dfd7cee6 = 'MediaAudioTrack';
const $c823d65ebf8ac0ff$export$ea32a877d9a3c04b = 'MediaLast';
const $c823d65ebf8ac0ff$export$58c0dc6dee8229d6 = 'MediaSkipBackward';
const $c823d65ebf8ac0ff$export$f02af5448c28e643 = 'MediaSkipForward';
const $c823d65ebf8ac0ff$export$d93de6b744e7f775 = 'MediaStepBackward';
const $c823d65ebf8ac0ff$export$f195c508ba45e4d4 = 'MediaStepForward';
const $c823d65ebf8ac0ff$export$73b99fd9032b72a0 = 'MediaTopMenu';
const $c823d65ebf8ac0ff$export$6147da8f2d96a041 = 'NavigateIn';
const $c823d65ebf8ac0ff$export$5863dec6788ea825 = 'NavigateNext';
const $c823d65ebf8ac0ff$export$ca474796dcd7d2f0 = 'NavigateOut';
const $c823d65ebf8ac0ff$export$38470274bd182a0d = 'NavigatePrevious';
const $c823d65ebf8ac0ff$export$7752e86e50128cee = 'NextFavoriteChannel';
const $c823d65ebf8ac0ff$export$656a8f32548ff844 = 'NextUserProfile';
const $c823d65ebf8ac0ff$export$3d988c45712b99a8 = 'OnDemand';
const $c823d65ebf8ac0ff$export$3370ee24730992a3 = 'Pairing';
const $c823d65ebf8ac0ff$export$73145bfd3a66c33b = 'PinPDown';
const $c823d65ebf8ac0ff$export$53e49b189851b15c = 'PinPMove';
const $c823d65ebf8ac0ff$export$68cff71e428f1a5b = 'PinPToggle';
const $c823d65ebf8ac0ff$export$fe62d495f9003c3 = 'PinPUp';
const $c823d65ebf8ac0ff$export$c9e688c40e07f7ea = 'PlaySpeedDown';
const $c823d65ebf8ac0ff$export$9131444076d9b49c = 'PlaySpeedReset';
const $c823d65ebf8ac0ff$export$c637ceff9b8cf24b = 'PlaySpeedUp';
const $c823d65ebf8ac0ff$export$310aa7aef35aeb17 = 'RandomToggle';
const $c823d65ebf8ac0ff$export$816fbcb54c88008b = 'RcLowBattery';
const $c823d65ebf8ac0ff$export$9078327fd65a7e30 = 'RecordSpeedNext';
const $c823d65ebf8ac0ff$export$310f6f7a8361eb35 = 'RfBypass';
const $c823d65ebf8ac0ff$export$baf269e5522c7636 = 'ScanChannelsToggle';
const $c823d65ebf8ac0ff$export$6041af62c7dea690 = 'ScreenModeNext';
const $c823d65ebf8ac0ff$export$c72f6eaae7b9adff = 'Settings';
const $c823d65ebf8ac0ff$export$a8c15e166a71c22d = 'SplitScreenToggle';
const $c823d65ebf8ac0ff$export$6c74e90fec25fa17 = 'STBInput';
const $c823d65ebf8ac0ff$export$5eec06d46080e0c0 = 'STBPower';
const $c823d65ebf8ac0ff$export$cf345ef34cd72655 = 'Subtitle';
const $c823d65ebf8ac0ff$export$b61ce10a90716b81 = 'Teletext';
const $c823d65ebf8ac0ff$export$8e4bc819629db3b = 'VideoModeNext';
const $c823d65ebf8ac0ff$export$e2454f16675bb233 = 'Wink';
const $c823d65ebf8ac0ff$export$12f95e4a6c5dfacc = 'ZoomToggle';
const $c823d65ebf8ac0ff$export$94ccd17761f5db1a = 'MediaNextTrack';
const $c823d65ebf8ac0ff$export$42737eb19882d457 = 'MediaPreviousTrack';
const $c823d65ebf8ac0ff$export$b074e60c9656b373 = 'Unidentified';



'use client';
function $ce4d8d04d71d4d52$export$d4669238f28a66b8(type, props) {
    const { disabled: disabled, disabledFocusable: disabledFocusable = false, ['aria-disabled']: ariaDisabled, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...rest } = props !== null && props !== void 0 ? props : {};
    const normalizedARIADisabled = typeof ariaDisabled === 'string' ? ariaDisabled === 'true' : ariaDisabled;
    const isDisabled = disabled || disabledFocusable || normalizedARIADisabled;
    const handleClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        if (isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
        } else onClick === null || onClick === void 0 || onClick(ev);
    });
    const handleKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(ev);
        if (ev.isDefaultPrevented()) return;
        const key = ev.key;
        if (isDisabled && (key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a) || key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2))) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2)) {
            ev.preventDefault();
            return;
        } else if (key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a)) {
            ev.preventDefault();
            ev.currentTarget.click();
        }
    });
    const handleKeyUp = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(ev);
        if (ev.isDefaultPrevented()) return;
        const key = ev.key;
        if (isDisabled && (key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a) || key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2))) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2)) {
            ev.preventDefault();
            ev.currentTarget.click();
        }
    });
    // If a <button> tag is to be rendered we just need to set disabled and aria-disabled correctly
    if (type === 'button' || type === undefined) return {
        ...rest,
        disabled: disabled && !disabledFocusable,
        'aria-disabled': disabledFocusable ? true : normalizedARIADisabled,
        // onclick should still use internal handler to ensure prevention if disabled
        // if disabledFocusable then there's no requirement for handlers as those events should not be propagated
        onClick: disabledFocusable ? undefined : handleClick,
        onKeyUp: disabledFocusable ? undefined : onKeyUp,
        onKeyDown: disabledFocusable ? undefined : onKeyDown
    };
    else {
        // the role needs to be explicitly set if the href is undefined
        const isLink = !!rest.href;
        let roleOverride = isLink ? undefined : 'button';
        if (!roleOverride && isDisabled) // need to set role=link explicitly for disabled links
        roleOverride = 'link';
        const resultProps = {
            role: roleOverride,
            tabIndex: disabledFocusable || !isLink && !disabled ? 0 : undefined,
            ...rest,
            // If it's not a <button> than listeners are required even with disabledFocusable
            // Since you cannot assure the default behavior of the element
            // E.g: <a> will redirect on click
            onClick: handleClick,
            onKeyUp: handleKeyUp,
            onKeyDown: handleKeyDown,
            'aria-disabled': isDisabled
        };
        if (type === 'a' && isDisabled) resultProps.href = undefined;
        return resultProps;
    }
}



'use client';
const $38d496a21b835846$export$5c58cdff39feeb7a = (props)=>{
    const { children: children, disableButtonEnhancement: disableButtonEnhancement = false } = props;
    const child = (0, $afe88029dd4784e4$export$8e7091920a6cd3c6)(children);
    const open = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.open);
    const setOpen = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.setOpen);
    const toggleOpen = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.toggleOpen);
    const triggerRef = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.triggerRef);
    const openOnHover = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.openOnHover);
    const openOnContext = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.openOnContext);
    const { triggerAttributes: triggerAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)();
    const onContextMenu = (e)=>{
        if (openOnContext) {
            e.preventDefault();
            setOpen(e, true);
        }
    };
    const onClick = (e)=>{
        if (!openOnContext) toggleOpen(e);
    };
    const onKeyDown = (e)=>{
        if (e.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685) && open && !e.isDefaultPrevented()) {
            setOpen(e, false);
            // stop propagation to avoid conflicting with other elements that listen for `Escape`
            // e,g: Dialog, Popover, Menu and Tooltip
            e.preventDefault();
        }
    };
    const onMouseEnter = (e)=>{
        if (openOnHover) setOpen(e, true);
    };
    const onMouseLeave = (e)=>{
        if (openOnHover) setOpen(e, false);
    };
    const contextMenuProps = {
        ...triggerAttributes,
        'aria-expanded': `${open}`,
        ...child === null || child === void 0 ? void 0 : child.props,
        onMouseEnter: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onMouseEnter, onMouseEnter)),
        onMouseLeave: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onMouseLeave, onMouseLeave)),
        onContextMenu: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onContextMenu, onContextMenu)),
        ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(triggerRef, (0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child))
    };
    const triggerChildProps = {
        ...contextMenuProps,
        onClick: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onClick, onClick)),
        onKeyDown: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onKeyDown, onKeyDown))
    };
    const ariaButtonTriggerChildProps = (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)((child === null || child === void 0 ? void 0 : child.type) === 'button' || (child === null || child === void 0 ? void 0 : child.type) === 'a' ? child.type : 'div', triggerChildProps);
    return {
        children: (0, $70e12b87c0533cc6$export$4ef26f87842d1b0)(props.children, (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)((child === null || child === void 0 ? void 0 : child.type) === 'button' || (child === null || child === void 0 ? void 0 : child.type) === 'a' ? child.type : 'div', openOnContext ? contextMenuProps : disableButtonEnhancement ? triggerChildProps : ariaButtonTriggerChildProps))
    };
};


/**
 * Render the final JSX of PopoverTrigger
 */ const $93edac060093c7f7$export$4882b368480af20a = (state)=>{
    return state.children;
};


'use client';
const $f1d682872ff40f20$export$7dacb05d26466c3 = (props)=>{
    const state = (0, $38d496a21b835846$export$5c58cdff39feeb7a)(props);
    return (0, $93edac060093c7f7$export$4882b368480af20a)(state);
};
$f1d682872ff40f20$export$7dacb05d26466c3.displayName = 'PopoverTrigger';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
$f1d682872ff40f20$export$7dacb05d26466c3.isFluentTriggerComponent = true;


var $acw62 = parcelRequire("acw62");


const $6df4f37e48127749$export$fa847e2f8b096512 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const { iconOnly: iconOnly, iconPosition: iconPosition } = state;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            iconPosition !== 'after' && state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            !iconOnly && state.root.children,
            iconPosition === 'after' && state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {})
        ]
    });
};



var $acw62 = parcelRequire("acw62");
'use client';
const $dc087adc5dbcef9a$var$buttonContext = $acw62.createContext(undefined);
const $dc087adc5dbcef9a$var$buttonContextDefaultValue = {};
const $dc087adc5dbcef9a$export$e87f888e47863634 = $dc087adc5dbcef9a$var$buttonContext.Provider;
const $dc087adc5dbcef9a$export$d891409b33cf7746 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($dc087adc5dbcef9a$var$buttonContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $dc087adc5dbcef9a$var$buttonContextDefaultValue;
};




'use client';
const $8b87161d0930eae0$export$12d06f80de047e9c = (props, ref)=>{
    const { size: contextSize } = (0, $dc087adc5dbcef9a$export$d891409b33cf7746)();
    const { appearance: appearance = 'secondary', shape: shape = 'rounded', size: size = contextSize !== null && contextSize !== void 0 ? contextSize : 'medium', ...buttonProps } = props;
    const state = $8b87161d0930eae0$export$c7a7c16b2f498556(buttonProps, ref);
    return {
        appearance: appearance,
        shape: shape,
        size: size,
        ...state
    };
};
const $8b87161d0930eae0$export$c7a7c16b2f498556 = (props, ref)=>{
    var _props_disabled, _props_disabledFocusable;
    const { icon: icon, iconPosition: iconPosition = 'before', ...buttonProps } = props;
    const iconShorthand = (0, $fcf7ddccaab7fd8f$exports).optional(icon, {
        elementType: 'span'
    });
    return {
        disabled: (_props_disabled = props.disabled) !== null && _props_disabled !== void 0 ? _props_disabled : false,
        disabledFocusable: (_props_disabledFocusable = props.disabledFocusable) !== null && _props_disabledFocusable !== void 0 ? _props_disabledFocusable : false,
        iconPosition: iconPosition,
        iconOnly: Boolean((iconShorthand === null || iconShorthand === void 0 ? void 0 : iconShorthand.children) && !props.children),
        components: {
            root: 'button',
            icon: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)(buttonProps.as, buttonProps), {
            elementType: 'button',
            defaultProps: {
                ref: ref,
                type: props.as !== 'a' ? 'button' : undefined
            }
        }),
        icon: iconShorthand
    };
};






'use client';
const $fc006584baa1fb60$export$d740529b277354ec = {
    root: 'fui-Button',
    icon: 'fui-Button__icon'
};
const $fc006584baa1fb60$var$iconSpacingVar = '--fui-Button__icon--spacing';
const $fc006584baa1fb60$var$buttonSpacingSmall = '3px';
const $fc006584baa1fb60$var$buttonSpacingSmallWithIcon = '1px';
const $fc006584baa1fb60$var$buttonSpacingMedium = '5px';
const $fc006584baa1fb60$var$buttonSpacingLarge = '8px';
const $fc006584baa1fb60$var$buttonSpacingLargeWithIcon = '7px';
/* Firefox has box shadow sizing issue at some zoom levels
 * this will ensure the inset boxShadow is always uniform
 * without affecting other browser platforms
 */ const $fc006584baa1fb60$var$boxShadowStrokeWidthThinMoz = `calc(${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).strokeWidthThin} + 0.25px)`;
const $fc006584baa1fb60$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1f29ykk", null, {
    r: [
        ".r1f29ykk{align-items:center;box-sizing:border-box;display:inline-flex;justify-content:center;text-decoration-line:none;vertical-align:middle;margin:0;overflow:hidden;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);font-family:var(--fontFamilyBase);outline-style:none;padding:5px var(--spacingHorizontalM);min-width:96px;border-radius:var(--borderRadiusMedium);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);transition-duration:var(--durationFaster);transition-property:background,border,color;transition-timing-function:var(--curveEasyEase);}",
        ".r1f29ykk:hover{background-color:var(--colorNeutralBackground1Hover);border-color:var(--colorNeutralStroke1Hover);color:var(--colorNeutralForeground1Hover);cursor:pointer;}",
        ".r1f29ykk:hover:active,.r1f29ykk:active:focus-visible{background-color:var(--colorNeutralBackground1Pressed);border-color:var(--colorNeutralStroke1Pressed);color:var(--colorNeutralForeground1Pressed);outline-style:none;}",
        ".r1f29ykk[data-fui-focus-visible]{border-color:var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);border-width:1px;outline:var(--strokeWidthThick) solid var(--colorTransparentStroke);box-shadow:0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;z-index:1;}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.r1f29ykk{transition-duration:0.01ms;}}",
        "@media (forced-colors: active){.r1f29ykk:focus{border-color:ButtonText;}.r1f29ykk:hover{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}.r1f29ykk:hover:active,.r1f29ykk:active:focus-visible{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}}",
        "@supports (-moz-appearance:button){.r1f29ykk[data-fui-focus-visible]{box-shadow:0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"
    ]
});
const $fc006584baa1fb60$var$useIconBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rywnvv2", null, [
    ".rywnvv2{align-items:center;display:inline-flex;justify-content:center;font-size:20px;height:20px;width:20px;--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}"
]);
const $fc006584baa1fb60$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    outline: {
        De3pzq: "f1c21dwh",
        Jwef8y: "fjxutwb",
        Bpjbzib: "fkoldzo"
    },
    primary: {
        De3pzq: "ffp7eso",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "f1phragk",
        Jwef8y: "f15wkkf3",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f1rq72xc",
        Bpjbzib: "f1ksv2xa",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ],
        Brsut9c: "f1d6mv4x",
        By8wz76: "f1nz3ub2",
        Bcq6wej: "fag2qd2",
        Jcjdmf: [
            "fmvhcg7",
            "f14bpyus"
        ],
        sc4o1m: "f1o3dhpw",
        Bosien3: [
            "f14bpyus",
            "fmvhcg7"
        ],
        B7iucu3: "fqc85l4",
        B8gzw0y: "f1h3a8gf",
        Bbkh6qg: "fkiggi6",
        F230oe: "f8gmj8i",
        Bdw8ktp: [
            "f1ap8nzx",
            "fjag8bx"
        ],
        Bj1xduy: "f1igan7k",
        Bhh2cfd: [
            "fjag8bx",
            "f1ap8nzx"
        ],
        Bahaeuw: "f1v3eptx",
        Bv2bamp: "f1ysmecq",
        vxuvv6: "faulsx",
        Bli9q98: [
            "f79t15f",
            "f8qmx7k"
        ],
        Bx2tt8t: "fbtzoaq",
        yad0b3: [
            "f8qmx7k",
            "f79t15f"
        ],
        j2fop7: "fd4bjan"
    },
    secondary: {},
    subtle: {
        De3pzq: "fhovq9v",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "fkfq4zb",
        Jwef8y: "f1t94bn6",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "fnwyq0v",
        Bk3fhr4: "ft1hn21",
        Bmfj8id: "fuxngvv",
        Bbdnnc7: "fy5bs14",
        Bpjbzib: "f1q1yqic",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ],
        Brsut9c: "fwga7ee",
        Bqou3pl: "f1nhwcv0",
        Bsnehw8: "f1gm6xmp",
        wsxvnf: "f1xxsver",
        Bahaeuw: "f1v3eptx",
        Buhizc3: "fivsta0",
        j2fop7: "fd4bjan",
        Bqabnb4: "f3m6zum"
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "fkfq4zb",
        Jwef8y: "fjxutwb",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f139oj5f",
        Bk3fhr4: "ft1hn21",
        Bmfj8id: "fuxngvv",
        Bpjbzib: "fkoldzo",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ],
        Brsut9c: "f1l983o9",
        Bqou3pl: "f1nhwcv0",
        Bsnehw8: "f1gm6xmp",
        Bbkh6qg: "fxoo9op",
        Bahaeuw: "f1v3eptx",
        Bv2bamp: "f1i0gk12",
        j2fop7: "fd4bjan"
    },
    circular: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f44lkw9"
    },
    rounded: {},
    square: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f1fabniw"
    },
    small: {
        Bf4jedk: "fh7ncta",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fneth5b",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    smallWithIcon: {
        Byoj8tv: "f1brlhvm",
        z8tnut: "f1sl3k7w"
    },
    medium: {},
    large: {
        Bf4jedk: "f14es27b",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f4db1ww",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    largeWithIcon: {
        Byoj8tv: "fy7v416",
        z8tnut: "f1a1bwwz"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        [
            ".f44lkw9{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".f1fabniw{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        ".fh7ncta{min-width:64px;}",
        [
            ".fneth5b{padding:3px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f1brlhvm{padding-bottom:1px;}",
        ".f1sl3k7w{padding-top:1px;}",
        ".f14es27b{min-width:96px;}",
        [
            ".f4db1ww{padding:8px var(--spacingHorizontalL);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fy7v416{padding-bottom:7px;}",
        ".f1a1bwwz{padding-top:7px;}"
    ],
    h: [
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".fkoldzo:hover:active,.fkoldzo:active:focus-visible{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f15wkkf3:hover{background-color:var(--colorBrandBackgroundHover);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".f1rq72xc:hover{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1ksv2xa:hover:active,.f1ksv2xa:active:focus-visible{background-color:var(--colorBrandBackgroundPressed);}",
        ".fhvnf4x:hover:active,.fhvnf4x:active:focus-visible{border-top-color:transparent;}",
        ".fb6swo4:hover:active,.fb6swo4:active:focus-visible{border-right-color:transparent;}",
        ".f232fm2:hover:active,.f232fm2:active:focus-visible{border-left-color:transparent;}",
        ".f1klyf7k:hover:active,.f1klyf7k:active:focus-visible{border-bottom-color:transparent;}",
        ".f1d6mv4x:hover:active,.f1d6mv4x:active:focus-visible{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",
        ".ft1hn21:hover .fui-Icon-filled{display:inline;}",
        ".fuxngvv:hover .fui-Icon-regular{display:none;}",
        ".fy5bs14:hover .fui-Button__icon{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1q1yqic:hover:active,.f1q1yqic:active:focus-visible{background-color:var(--colorSubtleBackgroundPressed);}",
        ".fwga7ee:hover:active,.fwga7ee:active:focus-visible{color:var(--colorNeutralForeground2Pressed);}",
        ".f1nhwcv0:hover:active .fui-Icon-filled,.f1nhwcv0:active:focus-visible .fui-Icon-filled{display:inline;}",
        ".f1gm6xmp:hover:active .fui-Icon-regular,.f1gm6xmp:active:focus-visible .fui-Icon-regular{display:none;}",
        ".f1xxsver:hover:active .fui-Button__icon,.f1xxsver:active:focus-visible .fui-Button__icon{color:var(--colorNeutralForeground2BrandPressed);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1l983o9:hover:active,.f1l983o9:active:focus-visible{color:var(--colorNeutralForeground2BrandPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1nz3ub2{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fag2qd2{border-top-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14bpyus{border-left-color:HighlightText;}.fmvhcg7{border-right-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1o3dhpw{border-bottom-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fqc85l4{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1h3a8gf{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkiggi6:hover{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f8gmj8i:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ap8nzx:hover{border-right-color:Highlight;}.fjag8bx:hover{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1igan7k:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1v3eptx:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ysmecq:hover:active,.f1ysmecq:active:focus-visible{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.faulsx:hover:active,.faulsx:active:focus-visible{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f79t15f:hover:active,.f79t15f:active:focus-visible{border-right-color:Highlight;}.f8qmx7k:hover:active,.f8qmx7k:active:focus-visible{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbtzoaq:hover:active,.fbtzoaq:active:focus-visible{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fd4bjan:hover:active,.fd4bjan:active:focus-visible{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fivsta0:hover .fui-Button__icon{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3m6zum:hover:active .fui-Button__icon,.f3m6zum:active:focus-visible .fui-Button__icon{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fxoo9op:hover{background-color:var(--colorTransparentBackground);}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1i0gk12:hover:active,.f1i0gk12:active:focus-visible{background-color:var(--colorTransparentBackground);}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $fc006584baa1fb60$var$useRootDisabledStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        De3pzq: "f1bg9a2p",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr",
        Bfinmwp: "f15x8b5r",
        Jwef8y: "f1falr9n",
        Bgoe8wy: "f12mpcsy",
        Bwzppfd: [
            "f1gwvigk",
            "f18rmfxp"
        ],
        oetu4i: "f1jnshp0",
        gg5e9n: [
            "f18rmfxp",
            "f1gwvigk"
        ],
        Bi91k9c: "fvgxktp",
        eoavqd: "fphbwmw",
        Bk3fhr4: "f19vpps7",
        Bmfj8id: "fv5swzo",
        Bbdnnc7: "f1al02dq",
        Bpjbzib: "f1jct5ie",
        im15vp: "f13txml0",
        Hjvxdg: [
            "f1ncddno",
            "f1axfvow"
        ],
        Gpfmf1: "f1z04ada",
        ustxxc: [
            "f1axfvow",
            "f1ncddno"
        ],
        Brsut9c: "f1uhomfy",
        Bses4qk: "fy9mucy",
        Bqou3pl: "f1g9va8i",
        Bsnehw8: "fwgvudy",
        wsxvnf: "fom6jww"
    },
    highContrast: {
        By8wz76: "f14ptb23",
        Bcq6wej: "f9dbb4x",
        Jcjdmf: [
            "f3qs60o",
            "f5u9ap2"
        ],
        sc4o1m: "fwd1oij",
        Bosien3: [
            "f5u9ap2",
            "f3qs60o"
        ],
        B7iucu3: "f1cyfu5x",
        Grqk0h: "f127ot8j",
        h3ptyc: "f19etb0b",
        Buw724y: [
            "f4f984j",
            "fw441p0"
        ],
        Buk7464: "f3d22hf",
        Hwei09: [
            "fw441p0",
            "f4f984j"
        ],
        Bbkh6qg: "fj8k9ua",
        F230oe: "fifrq0d",
        Bdw8ktp: [
            "f196mwp7",
            "fnekfq"
        ],
        Bj1xduy: "f1l6uprw",
        Bhh2cfd: [
            "fnekfq",
            "f196mwp7"
        ],
        Bahaeuw: "fa9u7a5",
        Buhizc3: "f1m71e0y",
        Bv2bamp: "fw24f3",
        vxuvv6: "f1nznrny",
        Bli9q98: [
            "fq8nxuu",
            "f1ao3jkc"
        ],
        Bx2tt8t: "ftoixeo",
        yad0b3: [
            "f1ao3jkc",
            "fq8nxuu"
        ],
        j2fop7: "fpmuzpx",
        Bqabnb4: "f168odog"
    },
    outline: {
        De3pzq: "f1c21dwh",
        Jwef8y: "f9ql6rf",
        Bpjbzib: "f9r0db0"
    },
    primary: {
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ]
    },
    secondary: {},
    subtle: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "f9ql6rf",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bpjbzib: "f9r0db0",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ]
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "f9ql6rf",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bpjbzib: "f9r0db0",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ]
    }
}, {
    d: [
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f15x8b5r .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}"
    ],
    h: [
        ".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".fphbwmw:hover{cursor:not-allowed;}",
        ".f19vpps7:hover .fui-Icon-filled{display:none;}",
        ".fv5swzo:hover .fui-Icon-regular{display:inline;}",
        ".f1al02dq:hover .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".f1jct5ie:hover:active,.f1jct5ie:active:focus-visible{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f13txml0:hover:active,.f13txml0:active:focus-visible{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1ncddno:hover:active,.f1ncddno:active:focus-visible{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f1axfvow:hover:active,.f1axfvow:active:focus-visible{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1z04ada:hover:active,.f1z04ada:active:focus-visible{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1uhomfy:hover:active,.f1uhomfy:active:focus-visible{color:var(--colorNeutralForegroundDisabled);}",
        ".fy9mucy:hover:active,.fy9mucy:active:focus-visible{cursor:not-allowed;}",
        ".f1g9va8i:hover:active .fui-Icon-filled,.f1g9va8i:active:focus-visible .fui-Icon-filled{display:none;}",
        ".fwgvudy:hover:active .fui-Icon-regular,.fwgvudy:active:focus-visible .fui-Icon-regular{display:inline;}",
        ".fom6jww:hover:active .fui-Button__icon,.fom6jww:active:focus-visible .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}",
        ".f9r0db0:hover:active,.f9r0db0:active:focus-visible{background-color:var(--colorTransparentBackground);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".fhvnf4x:hover:active,.fhvnf4x:active:focus-visible{border-top-color:transparent;}",
        ".fb6swo4:hover:active,.fb6swo4:active:focus-visible{border-right-color:transparent;}",
        ".f232fm2:hover:active,.f232fm2:active:focus-visible{border-left-color:transparent;}",
        ".f1klyf7k:hover:active,.f1klyf7k:active:focus-visible{border-bottom-color:transparent;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f14ptb23{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9dbb4x{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3qs60o{border-right-color:GrayText;}.f5u9ap2{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fwd1oij{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cyfu5x{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f127ot8j .fui-Button__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f19etb0b:focus{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f4f984j:focus{border-right-color:GrayText;}.fw441p0:focus{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3d22hf:focus{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fj8k9ua:hover{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fifrq0d:hover{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f196mwp7:hover{border-right-color:GrayText;}.fnekfq:hover{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1l6uprw:hover{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fa9u7a5:hover{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1m71e0y:hover .fui-Button__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fw24f3:hover:active,.fw24f3:active:focus-visible{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1nznrny:hover:active,.f1nznrny:active:focus-visible{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ao3jkc:hover:active,.f1ao3jkc:active:focus-visible{border-left-color:GrayText;}.fq8nxuu:hover:active,.fq8nxuu:active:focus-visible{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.ftoixeo:hover:active,.ftoixeo:active:focus-visible{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fpmuzpx:hover:active,.fpmuzpx:active:focus-visible{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f168odog:hover:active .fui-Button__icon,.f168odog:active:focus-visible .fui-Button__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $fc006584baa1fb60$var$useRootFocusStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    circular: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f1062rbf"
    },
    rounded: {},
    square: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "fj0ryk1"
    },
    primary: {
        B8q5s1w: "f17t0x8g",
        Bci5o5g: [
            "f194v5ow",
            "fk7jm04"
        ],
        n8qw10: "f1qgg65p",
        Bdrgwmp: [
            "fk7jm04",
            "f194v5ow"
        ],
        j6ew2k: [
            "fhgccpy",
            "fjo7pq6"
        ],
        he4mth: "f32wu9k",
        Byr4aka: "fu5nqqq",
        lks7q5: [
            "f13prjl2",
            "f1nl83rv"
        ],
        Bnan3qt: "f1czftr5",
        k1dn9: [
            "f1nl83rv",
            "f13prjl2"
        ],
        Bqsb82s: [
            "fixhny3",
            "f18mfu3r"
        ],
        jg1oma: "feygou5"
    },
    small: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "fazmxh"
    },
    medium: {},
    large: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f1b6alqh"
    }
}, {
    d: [
        [
            ".f1062rbf[data-fui-focus-visible]{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".fj0ryk1[data-fui-focus-visible]{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        ".f17t0x8g[data-fui-focus-visible]{border-top-color:var(--colorStrokeFocus2);}",
        ".f194v5ow[data-fui-focus-visible]{border-right-color:var(--colorStrokeFocus2);}",
        ".fk7jm04[data-fui-focus-visible]{border-left-color:var(--colorStrokeFocus2);}",
        ".f1qgg65p[data-fui-focus-visible]{border-bottom-color:var(--colorStrokeFocus2);}",
        ".fhgccpy[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}",
        ".fjo7pq6[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}",
        ".f32wu9k[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;}",
        ".fu5nqqq[data-fui-focus-visible]:hover{border-top-color:var(--colorStrokeFocus2);}",
        ".f13prjl2[data-fui-focus-visible]:hover{border-right-color:var(--colorStrokeFocus2);}",
        ".f1nl83rv[data-fui-focus-visible]:hover{border-left-color:var(--colorStrokeFocus2);}",
        ".f1czftr5[data-fui-focus-visible]:hover{border-bottom-color:var(--colorStrokeFocus2);}",
        [
            ".fazmxh[data-fui-focus-visible]{border-radius:var(--borderRadiusSmall);}",
            {
                p: -1
            }
        ],
        [
            ".f1b6alqh[data-fui-focus-visible]{border-radius:var(--borderRadiusLarge);}",
            {
                p: -1
            }
        ]
    ],
    t: [
        "@supports (-moz-appearance:button){.f18mfu3r[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}.fixhny3[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}}",
        "@supports (-moz-appearance:button){.feygou5[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"
    ]
});
const $fc006584baa1fb60$var$useRootIconOnlyStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    small: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fu97m5z",
        Bf4jedk: "f17fgpbq",
        B2u0y6b: "f1jt17bm"
    },
    medium: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f18ktai2",
        Bf4jedk: "fwbmr0d",
        B2u0y6b: "f44c6la"
    },
    large: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1hbd1aw",
        Bf4jedk: "f12clzc2",
        B2u0y6b: "fjy1crr"
    }
}, {
    d: [
        [
            ".fu97m5z{padding:1px;}",
            {
                p: -1
            }
        ],
        ".f17fgpbq{min-width:24px;}",
        ".f1jt17bm{max-width:24px;}",
        [
            ".f18ktai2{padding:5px;}",
            {
                p: -1
            }
        ],
        ".fwbmr0d{min-width:32px;}",
        ".f44c6la{max-width:32px;}",
        [
            ".f1hbd1aw{padding:7px;}",
            {
                p: -1
            }
        ],
        ".f12clzc2{min-width:40px;}",
        ".fjy1crr{max-width:40px;}"
    ]
});
const $fc006584baa1fb60$var$useIconStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    small: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3",
        Bqrlyyl: "fbaiahx"
    },
    medium: {},
    large: {
        Be2twd7: "f1rt2boy",
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun",
        Bqrlyyl: "f1exjqw5"
    },
    before: {
        t21cq0: [
            "f1nizpg2",
            "f1a695kz"
        ]
    },
    after: {
        Frg6f3: [
            "f1a695kz",
            "f1nizpg2"
        ]
    }
}, {
    d: [
        ".fe5j1ua{font-size:20px;}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".fbaiahx{--fui-Button__icon--spacing:var(--spacingHorizontalXS);}",
        ".f1rt2boy{font-size:24px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".f1exjqw5{--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}",
        ".f1nizpg2{margin-right:var(--fui-Button__icon--spacing);}",
        ".f1a695kz{margin-left:var(--fui-Button__icon--spacing);}"
    ]
});
const $fc006584baa1fb60$export$4caadad6dc3cda7b = (state)=>{
    const rootBaseClassName = $fc006584baa1fb60$var$useRootBaseClassName();
    const iconBaseClassName = $fc006584baa1fb60$var$useIconBaseClassName();
    const rootStyles = $fc006584baa1fb60$var$useRootStyles();
    const rootDisabledStyles = $fc006584baa1fb60$var$useRootDisabledStyles();
    const rootFocusStyles = $fc006584baa1fb60$var$useRootFocusStyles();
    const rootIconOnlyStyles = $fc006584baa1fb60$var$useRootIconOnlyStyles();
    const iconStyles = $fc006584baa1fb60$var$useIconStyles();
    const { appearance: appearance, disabled: disabled, disabledFocusable: disabledFocusable, icon: icon, iconOnly: iconOnly, iconPosition: iconPosition, shape: shape, size: size } = state;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($fc006584baa1fb60$export$d740529b277354ec.root, rootBaseClassName, appearance && rootStyles[appearance], rootStyles[size], icon && size === 'small' && rootStyles.smallWithIcon, icon && size === 'large' && rootStyles.largeWithIcon, rootStyles[shape], // Disabled styles
    (disabled || disabledFocusable) && rootDisabledStyles.base, (disabled || disabledFocusable) && rootDisabledStyles.highContrast, appearance && (disabled || disabledFocusable) && rootDisabledStyles[appearance], // Focus styles
    appearance === 'primary' && rootFocusStyles.primary, rootFocusStyles[size], rootFocusStyles[shape], // Icon-only styles
    iconOnly && rootIconOnlyStyles[size], // User provided class name
    state.root.className);
    if (state.icon) // eslint-disable-next-line react-hooks/immutability
    state.icon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($fc006584baa1fb60$export$d740529b277354ec.icon, iconBaseClassName, !!state.root.children && iconStyles[iconPosition], iconStyles[size], state.icon.className);
    return state;
};



'use client';
const $4b2f31b5d520190a$export$353f5b6fc5456de1 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8b87161d0930eae0$export$12d06f80de047e9c)(props, ref);
    (0, $fc006584baa1fb60$export$4caadad6dc3cda7b)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useButtonStyles_unstable')(state);
    return (0, $6df4f37e48127749$export$fa847e2f8b096512)(state);
// Casting is required due to lack of distributive union to support unions on @types/react
});
$4b2f31b5d520190a$export$353f5b6fc5456de1.displayName = 'Button';


var $acw62 = parcelRequire("acw62");


const $84b411a0db8b75a6$export$5fd48491453f80f0 = (state)=>{
    const { presenceOnly: presenceOnly, textPosition: textPosition } = state;
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const coin = presenceOnly ? state.presence && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.presence, {}) : state.avatar && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.avatar, {});
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            (textPosition === 'after' || textPosition === 'below') && coin,
            state.primaryText && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.primaryText, {}),
            state.secondaryText && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.secondaryText, {}),
            state.tertiaryText && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.tertiaryText, {}),
            state.quaternaryText && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.quaternaryText, {}),
            textPosition === 'before' && coin
        ]
    });
};



var $acw62 = parcelRequire("acw62");


const $c8cab5512415dea6$export$cff486926637164d = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.initials && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.initials, {}),
            state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            state.image && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.image, {}),
            state.badge && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.badge, {}),
            state.activeAriaLabelElement
        ]
    });
};



var $acw62 = parcelRequire("acw62");

/**
 * Regular expression matching complete enclosures or an unmatched enclosure tail.
 */ const $bf4a6e1cd284fb53$var$UNWANTED_ENCLOSURES_REGEX = /[\(\[\{][^\)\]\}]*([\)\]\}]|$)/g;
/**
 * Regular expression matching special ASCII characters except space, plus some unicode special characters.
 * Applies after unwanted enclosures have been removed.
 * Note: the range starts at \uE000 (not \uD800) to avoid matching surrogate code units, which would break
 * supplementary Unicode characters (encoded as surrogate pairs in UTF-16) such as GB18030-2022 extension characters.
 */ const $bf4a6e1cd284fb53$var$UNWANTED_CHARS_REGEX = /[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uE000-\uFFFF]/g;
/**
 * Regular expression matching phone numbers. Applied after chars matching UNWANTED_CHARS_REGEX have been removed
 * and number has been trimmed for whitespaces
 */ const $bf4a6e1cd284fb53$var$PHONENUMBER_REGEX = /^(?:\d[\d\s]*\d|\d[\d\s]*(?:ext|x)\s*\d+)$/i;
/** Regular expression matching one or more spaces. */ const $bf4a6e1cd284fb53$var$MULTIPLE_WHITESPACES_REGEX = /\s+/g;
/**
 * Regular expression matching languages for which we currently don't support initials.
 * Arabic:   Arabic, Arabic Supplement, Arabic Extended-A.
 * Korean:   Hangul Jamo, Hangul Compatibility Jamo, Hangul Jamo Extended-A, Hangul Syllables, Hangul Jamo Extended-B.
 * Japanese: Hiragana, Katakana.
 * CJK:      CJK Unified Ideographs Extension A, CJK Unified Ideographs, CJK Compatibility Ideographs.
 * Note: Supplementary CJK characters (GB18030-2022 extension characters in Ext B-I) are intentionally not listed
 * here so they can be rendered as initials.
 */ const $bf4a6e1cd284fb53$var$UNSUPPORTED_TEXT_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/;
function $bf4a6e1cd284fb53$var$getFirstCodePoint(value) {
    if (!value) return '';
    const codePoint = value.codePointAt(0);
    return codePoint === undefined ? '' : String.fromCodePoint(codePoint);
}
function $bf4a6e1cd284fb53$var$getInitialsLatin(displayName, isRtl, firstInitialOnly) {
    let initials = '';
    const splits = displayName.split(' ');
    if (splits.length !== 0) // Use code point-aware helper to correctly handle supplementary characters (e.g. GB18030-2022 extension chars)
    // that are encoded as surrogate pairs; charAt(0) would only return half of such a character.
    initials += $bf4a6e1cd284fb53$var$getFirstCodePoint(splits[0]).toUpperCase();
    if (!firstInitialOnly) {
        if (splits.length === 2) initials += $bf4a6e1cd284fb53$var$getFirstCodePoint(splits[1]).toUpperCase();
        else if (splits.length === 3) initials += $bf4a6e1cd284fb53$var$getFirstCodePoint(splits[2]).toUpperCase();
    }
    if (isRtl && [
        ...initials
    ].length > 1) {
        const chars = [
            ...initials
        ];
        return chars[1] + chars[0];
    }
    return initials;
}
function $bf4a6e1cd284fb53$var$cleanupDisplayName(displayName) {
    displayName = displayName.replace($bf4a6e1cd284fb53$var$UNWANTED_ENCLOSURES_REGEX, (match, closing)=>closing ? '' : match);
    displayName = displayName.replace($bf4a6e1cd284fb53$var$UNWANTED_CHARS_REGEX, '');
    displayName = displayName.replace($bf4a6e1cd284fb53$var$MULTIPLE_WHITESPACES_REGEX, ' ');
    displayName = displayName.trim();
    return displayName;
}
function $bf4a6e1cd284fb53$export$de9bdbce6502b027(displayName, isRtl, options) {
    if (!displayName) return '';
    displayName = $bf4a6e1cd284fb53$var$cleanupDisplayName(displayName);
    // Check only the first code point against UNSUPPORTED_TEXT_REGEX so that names starting with a supported
    // character (e.g. GB18030-2022 extension characters) produce an initial even when the rest of the string
    // contains BMP CJK characters that would otherwise trigger the regex.
    const firstCodePoint = $bf4a6e1cd284fb53$var$getFirstCodePoint(displayName);
    if ($bf4a6e1cd284fb53$var$UNSUPPORTED_TEXT_REGEX.test(firstCodePoint) || !(options === null || options === void 0 ? void 0 : options.allowPhoneInitials) && $bf4a6e1cd284fb53$var$PHONENUMBER_REGEX.test(displayName)) return '';
    return $bf4a6e1cd284fb53$var$getInitialsLatin(displayName, isRtl, options === null || options === void 0 ? void 0 : options.firstInitialOnly);
}



var $acw62 = parcelRequire("acw62");



const $2c238c51189631dd$export$28e6b9b82ee883c = (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1w7gpdv",
        Bg96gwp: "fez10in"
    },
    rtl: {
        Bz10aip: "f13rod7r"
    }
}, {
    d: [
        ".f1w7gpdv{display:inline;}",
        ".fez10in{line-height:0;}",
        ".f13rod7r{transform:scaleX(-1);}"
    ]
});



const $3ca67d612ed7abba$export$538bd0cdf03fed48 = 'fui-Icon';
const $3ca67d612ed7abba$export$cc86ffec8c6eb24e = 'fui-Icon-filled';
const $3ca67d612ed7abba$export$f8a5601dfd94d0c1 = 'fui-Icon-regular';
const $3ca67d612ed7abba$export$600d83c6d1ab213f = 'fui-Icon-light';
const $3ca67d612ed7abba$export$ff76996064ccabf9 = 'fui-Icon-color';
const $3ca67d612ed7abba$export$8a40db2be112c945 = 'fui-Icon-font';
const $3ca67d612ed7abba$export$f78502fc5300f37 = 'data-fui-icon';


const $c04f6a00ff145b4d$export$439c65a9f9bee957 = (props, options)=>{
    const { filled: // remove unwanted props to be set on the svg/html element
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filled, idPrefix: // consumed by the icon factory to scope color-icon ids, never a DOM attribute
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    idPrefix, title: title, primaryFill: primaryFill = 'currentColor', ...rest } = props;
    const state = {
        ...rest,
        fill: primaryFill
    };
    const iconContext = (0, $29e9ce9867929ff7$export$6bed2dfdd7bea160)();
    const isRtlFlip = Boolean((options === null || options === void 0 ? void 0 : options.flipInRtl) && (iconContext === null || iconContext === void 0 ? void 0 : iconContext.textDirection) === 'rtl');
    if (title) state['aria-label'] = title;
    if (!state['aria-label'] && !state['aria-labelledby']) state['aria-hidden'] = true;
    else state['role'] = 'img';
    // Universal data attribute so any icon (SVG or font) can be targeted via `[data-fui-icon]`.
    state[0, $3ca67d612ed7abba$export$f78502fc5300f37] = '';
    return {
        state: state,
        isRtlFlip: isRtlFlip
    };
};


const $46caa65ac410bb30$export$8546d02a2c1ddd5 = (props, options)=>{
    const styles = (0, $2c238c51189631dd$export$28e6b9b82ee883c)();
    const { state: state, isRtlFlip: isRtlFlip } = (0, $c04f6a00ff145b4d$export$439c65a9f9bee957)(props, options);
    state.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(styles.root, isRtlFlip && styles.rtl, state.className);
    return state;
};



const $8329439bd3b4436f$export$eb68ef9436d8b207 = (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        B8gzw0y: "f1dd5bof"
    }
}, {
    m: [
        [
            "@media (forced-colors: active){.f1dd5bof{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});




var $acw62 = parcelRequire("acw62");
/** The literal prefix of an SVG `url(#…)` local reference. */ const $d9d42e5267a16cb7$var$URL_REF = 'url(#';
const $d9d42e5267a16cb7$export$c732ad817fc92b47 = (node, key, prefix)=>{
    const [tag, attrs, ...children] = node;
    let scoped = attrs;
    if (prefix && attrs) {
        const next = {};
        for(const attrName in attrs){
            const attrValue = attrs[attrName];
            if (typeof attrValue !== 'string') next[attrName] = attrValue; // style object — passthrough
            else if (attrName === 'id') next[attrName] = prefix + attrValue; // scope the id definition
            else {
                // Scope a `url(#…)` reference by splicing `prefix` in right after `url(#`.
                // A single indexOf locates it (-1 short-circuits with no allocation, e.g.
                // for long `d` paths); color-icon attributes carry at most one reference,
                // so no global replace is needed.
                const refAt = attrValue.indexOf($d9d42e5267a16cb7$var$URL_REF);
                next[attrName] = refAt < 0 ? attrValue : attrValue.slice(0, refAt + $d9d42e5267a16cb7$var$URL_REF.length) + prefix + attrValue.slice(refAt + $d9d42e5267a16cb7$var$URL_REF.length);
            }
        }
        scoped = next;
    }
    return $acw62.createElement(tag, {
        ...scoped,
        key: key
    }, ...children.map((child, idx)=>$d9d42e5267a16cb7$export$c732ad817fc92b47(child, idx, prefix)));
};
const $d9d42e5267a16cb7$export$6c8d7b490f1d7d8b = (width)=>width === '1em' ? '20' : width;
const $d9d42e5267a16cb7$export$78ee56799592994b = (pathsOrSvg, options, prefix)=>typeof pathsOrSvg !== 'string' && ((options === null || options === void 0 ? void 0 : options.color) || Array.isArray(pathsOrSvg[0])) ? pathsOrSvg.map((node, i)=>$d9d42e5267a16cb7$export$c732ad817fc92b47(node, i, prefix)) : undefined;
/** Shared mono-color resolver — calls no hooks and allocates nothing per component. */ const $d9d42e5267a16cb7$var$noColorChildren = ()=>undefined;
const $d9d42e5267a16cb7$export$da05628a48a4e871 = (pathsOrSvg, options)=>{
    const colorChildren = $d9d42e5267a16cb7$export$78ee56799592994b(pathsOrSvg, options);
    if (!colorChildren) return $d9d42e5267a16cb7$var$noColorChildren;
    return function useColorChildren(idPrefix) {
        return $acw62.useMemo(()=>idPrefix ? $d9d42e5267a16cb7$export$78ee56799592994b(pathsOrSvg, options, idPrefix) : colorChildren, [
            idPrefix
        ]);
    };
};
const $d9d42e5267a16cb7$export$c6552e90b624cba4 = (state, pathsOrSvg, colorChildren)=>{
    if (typeof pathsOrSvg === 'string') return $acw62.createElement('svg', {
        ...state,
        dangerouslySetInnerHTML: {
            __html: pathsOrSvg
        }
    });
    if (colorChildren) return $acw62.createElement('svg', state, ...colorChildren);
    return $acw62.createElement('svg', state, ...pathsOrSvg.map((d)=>$acw62.createElement('path', {
            d: d,
            fill: state.fill
        })));
};
const $d9d42e5267a16cb7$export$b88e3334bb1fbe7b = (state, iconId, spritePath)=>{
    const href = spritePath ? `${spritePath}#${iconId}` : `#${iconId}`;
    return $acw62.createElement('svg', state, $acw62.createElement('use', {
        href: href
    }));
};


const $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87 = (displayName, width, pathsOrSvg, options)=>{
    const viewBoxWidth = (0, $d9d42e5267a16cb7$export$6c8d7b490f1d7d8b)(width);
    // Resolve color children once per component: mono-color icons pay nothing,
    // color icons get per-instance memoized `idPrefix` scoping.
    const useColorChildren = (0, $d9d42e5267a16cb7$export$da05628a48a4e871)(pathsOrSvg, options);
    const Icon = $acw62.forwardRef((props, ref)=>{
        const styles = (0, $8329439bd3b4436f$export$eb68ef9436d8b207)();
        const iconState = (0, $46caa65ac410bb30$export$8546d02a2c1ddd5)(props, {
            flipInRtl: options === null || options === void 0 ? void 0 : options.flipInRtl
        });
        const colorChildren = useColorChildren(props.idPrefix);
        const state = {
            ...iconState,
            className: (0, $00898283de415a49$export$3d46f4579dba46e5)((0, $3ca67d612ed7abba$export$538bd0cdf03fed48), iconState.className, styles.root),
            ref: ref,
            width: width,
            height: width,
            viewBox: `0 0 ${viewBoxWidth} ${viewBoxWidth}`,
            xmlns: 'http://www.w3.org/2000/svg'
        };
        return (0, $d9d42e5267a16cb7$export$c6552e90b624cba4)(state, pathsOrSvg, colorChildren);
    });
    Icon.displayName = displayName;
    return Icon;
};


"use client";
const $bf8018481b255628$export$c94048897af30fcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MaximizeFilled', "1em", [
    "M3 5.25C3 4.01 4 3 5.25 3h9.5C15.99 3 17 4 17 5.25v9.5c0 1.24-1 2.25-2.25 2.25h-9.5C4.01 17 3 16 3 14.75zm2.25-.75a.75.75 0 0 0-.75.75v9.5c0 .41.34.75.75.75h9.5c.41 0 .75-.34.75-.75v-9.5a.75.75 0 0 0-.75-.75z"
]);
const $bf8018481b255628$export$9deda2fbed6d917b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MaximizeRegular', "1em", [
    "M3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
]);
const $bf8018481b255628$export$c3c41ad80ce0a18e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NextFilled', "1em", [
    "M3 4.25c0-1 1.12-1.6 1.95-1.04l8.5 5.71c.73.5.73 1.57 0 2.07l-8.5 5.8A1.25 1.25 0 0 1 3 15.75zm14-.75a.5.5 0 0 0-1 0v13a.5.5 0 1 0 1 0z"
]);
const $bf8018481b255628$export$131f899588e9df9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NextRegular', "1em", [
    "M17 3.5a.5.5 0 0 0-1 0v13a.5.5 0 1 0 1 0zM3 4.25c0-1 1.12-1.6 1.95-1.04l8.5 5.71c.73.5.73 1.57 0 2.07l-8.5 5.8A1.25 1.25 0 0 1 3 15.75zm1.39-.2a.25.25 0 0 0-.39.2v11.5c0 .2.23.32.4.2l8.49-5.78a.25.25 0 0 0 0-.42z"
]);
const $bf8018481b255628$export$c27885c30b958ea7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NextFrameFilled', "1em", [
    "M4.5 3c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5m5.45.21A1.25 1.25 0 0 0 8 4.25v11.5c0 1 1.12 1.6 1.95 1.04l8.5-5.8c.73-.5.73-1.58 0-2.07z"
]);
const $bf8018481b255628$export$ed4202a63196fabc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NextFrameRegular', "1em", [
    "M4.5 3c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5m5.45.21A1.25 1.25 0 0 0 8 4.25v11.5c0 1 1.12 1.6 1.95 1.04l8.5-5.8c.73-.5.73-1.58 0-2.07zM9 4.25c0-.2.22-.32.39-.2l8.5 5.7c.15.1.15.32 0 .42l-8.5 5.79c-.17.11-.39 0-.39-.2z"
]);
const $bf8018481b255628$export$3f021573c86a99cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle0Filled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6 0c0-1.07.15-1.97.49-2.6q.24-.44.6-.66.33-.23.91-.24.57.01.92.24t.6.67c.33.62.48 1.52.48 2.59s-.15 1.97-.49 2.6q-.24.44-.6.66-.33.23-.91.24-.57-.01-.92-.24a2 2 0 0 1-.6-.67A6 6 0 0 1 8 10m2-4.5q-.83 0-1.45.4-.6.39-.94 1.03A6.6 6.6 0 0 0 7 10c0 1.14.16 2.23.6 3.07q.34.64.95 1.04.62.39 1.45.39t1.45-.4q.6-.39.94-1.03c.45-.84.61-1.93.61-3.07a6.6 6.6 0 0 0-.6-3.07 3 3 0 0 0-.95-1.04Q10.83 5.5 10 5.5"
]);
const $bf8018481b255628$export$21debc6f69d5c001 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle0Regular', "1em", [
    "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-7 8a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-2-8c0-1.07.15-1.97.49-2.6q.24-.44.6-.66.33-.23.91-.24.57.01.92.24t.6.67c.33.62.48 1.52.48 2.59s-.15 1.97-.49 2.6q-.24.44-.6.66-.33.23-.91.24-.57-.01-.92-.24a2 2 0 0 1-.6-.67A6 6 0 0 1 8 10m2-4.5q-.83 0-1.45.4-.6.39-.94 1.03A6.6 6.6 0 0 0 7 10c0 1.14.16 2.23.6 3.07q.34.64.95 1.04.62.39 1.45.39t1.45-.4q.6-.39.94-1.03c.45-.84.61-1.93.61-3.07a6.6 6.6 0 0 0-.6-3.07 3 3 0 0 0-.95-1.04Q10.83 5.5 10 5.5"
]);
const $bf8018481b255628$export$c2938d2217521fc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle1Filled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-11.5v7a.5.5 0 0 1-1 0V8.48c-.38.48-.82.92-1.22 1.19a.5.5 0 1 1-.56-.84c.32-.2.71-.6 1.07-1.07.35-.47.62-.97.73-1.38a.5.5 0 0 1 .98.12"
]);
const $bf8018481b255628$export$cfd1b02d9c45930b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle1Regular', "1em", [
    "M11 6.5a.5.5 0 0 0-.98-.12c-.1.4-.38.91-.73 1.38-.36.47-.75.86-1.07 1.07a.5.5 0 0 0 .56.84c.4-.27.84-.7 1.22-1.2v5.03a.5.5 0 1 0 1 0zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $bf8018481b255628$export$ebe2190d0742e874 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle2Filled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6.4-2.7.1-.11q.1-.12.33-.29A2 2 0 0 1 10 6.5c.83 0 1.5.67 1.5 1.5 0 .46-.17.78-.47 1.06-.27.26-.61.47-1.03.72l-.27.17c-.5.32-1.07.7-1.5 1.26a3.6 3.6 0 0 0-.73 2.29c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H8.53q.13-.74.49-1.18c.32-.4.75-.71 1.25-1.02l.23-.15c.41-.25.87-.53 1.22-.87.45-.43.78-1 .78-1.78A2.5 2.5 0 0 0 10 5.5c-.76 0-1.36.3-1.76.6a4 4 0 0 0-.64.6.5.5 0 0 0 .8.6"
]);
const $bf8018481b255628$export$d785475d762808b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle2Regular', "1em", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.4 7.3a.5.5 0 0 1-.8-.6l.18-.2q.16-.18.46-.4c.4-.3 1-.6 1.76-.6A2.5 2.5 0 0 1 12.5 8c0 .79-.33 1.35-.78 1.78-.35.34-.8.62-1.22.87l-.23.15c-.5.3-.93.61-1.25 1.02q-.36.44-.49 1.18H12a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5c0-.98.28-1.72.73-2.29.43-.56 1-.94 1.5-1.26l.27-.17c.42-.25.76-.46 1.03-.72.3-.28.47-.6.47-1.06 0-.83-.67-1.5-1.5-1.5a2 2 0 0 0-1.17.4 3 3 0 0 0-.43.4"
]);
const $bf8018481b255628$export$880d559c54f828ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle3Filled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-1 8c0-.28.22-.5.5-.5h.5c1.02 0 1.75-.73 1.75-1.5S11.02 6.5 10 6.5a2.5 2.5 0 0 0-1.87.82.5.5 0 0 1-.76-.64v-.01l.02-.01.17-.18q.19-.18.52-.4c.44-.29 1.1-.58 1.92-.58 1.46 0 2.75 1.07 2.75 2.5a2.4 2.4 0 0 1-1.1 2 2.4 2.4 0 0 1 1.1 2c0 1.43-1.29 2.5-2.75 2.5a3.5 3.5 0 0 1-2.61-1.16l-.02-.01a.5.5 0 0 1 .76-.65l.02.02.1.09q.12.12.37.29c.33.21.8.42 1.38.42 1.02 0 1.75-.73 1.75-1.5s-.73-1.5-1.75-1.5h-.5A.5.5 0 0 1 9 10"
]);
const $bf8018481b255628$export$391c0cfe8053d79c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle3Regular', "1em", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16M7.43 7.38a.5.5 0 0 0 .7-.06l.11-.11q.13-.12.38-.29c.33-.21.8-.42 1.38-.42 1.02 0 1.75.73 1.75 1.5S11.02 9.5 10 9.5h-.5a.5.5 0 0 0 0 1h.5c1.02 0 1.75.73 1.75 1.5s-.73 1.5-1.75 1.5a2.5 2.5 0 0 1-1.87-.82.5.5 0 0 0-.76.64v.01l.02.01.17.18q.19.18.52.4c.44.29 1.1.58 1.92.58 1.46 0 2.75-1.07 2.75-2.5a2.4 2.4 0 0 0-1.1-2 2.4 2.4 0 0 0 1.1-2c0-1.43-1.29-2.5-2.75-2.5a3.5 3.5 0 0 0-2.61 1.16l-.02.01a.5.5 0 0 0 .06.71"
]);
const $bf8018481b255628$export$e89c40d431f0e456 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle4Filled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m10-3.7a.75.75 0 0 0-1.37-.41l-3.54 5.17a.6.6 0 0 0 .5.94h3.4v1.5a.5.5 0 0 0 1 0V12H13a.5.5 0 0 0 0-1h-1zm-1 .82V11H8.35z"
]);
const $bf8018481b255628$export$afaee0275c086825 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle4Regular', "1em", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16m2 4.3a.75.75 0 0 0-1.37-.41l-3.54 5.17a.6.6 0 0 0 .5.94h3.4v1.5a.5.5 0 0 0 1 0V12H13a.5.5 0 0 0 0-1h-1zm-1 .82V11H8.35z"
]);
const $bf8018481b255628$export$a0d85a9547f10658 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle5Filled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6.8-4a.5.5 0 0 0-.5.45L8 9.2a.5.5 0 0 0 .51.55h.07a38 38 0 0 1 1.8.02 1.87 1.87 0 1 1-1.93 2.7.5.5 0 1 0-.9.44 2.87 2.87 0 1 0 2.98-4.13 11 11 0 0 0-1.47-.04L9.25 7H12a.5.5 0 1 0 0-1z"
]);
const $bf8018481b255628$export$24a572fd0ba28401 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle5Regular', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0m5.3-3.55A.5.5 0 0 1 8.8 6H12a.5.5 0 1 1 0 1H9.25l-.2 1.74h.25c.42 0 .95 0 1.22.04a2.87 2.87 0 1 1-2.97 4.13.5.5 0 0 1 .9-.45 1.87 1.87 0 1 0 1.94-2.7 11 11 0 0 0-1.64-.02h-.17l-.05.01h-.02a.5.5 0 0 1-.5-.55z"
]);
const $bf8018481b255628$export$6acbbd59ed7b6041 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle6Filled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 7.5c1.2 0 2 .88 2 2s-.8 2-2 2a2 2 0 1 1 0-4m0 5a3.2 3.2 0 0 1-2.43-1.04C6.89 12.71 6.5 11.58 6.5 10c0-1.17.26-2.28.84-3.11A3.1 3.1 0 0 1 10 5.5c1.62 0 2.42 1.1 2.68 1.56a.5.5 0 0 1-.87.5A2 2 0 0 0 10 6.5c-.83 0-1.43.36-1.84.96a4.4 4.4 0 0 0-.66 2.38A3 3 0 0 1 10 8.5c1.8 0 3 1.36 3 3s-1.2 3-3 3"
]);
const $bf8018481b255628$export$f50b02f7d747f924 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle6Regular', "1em", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-.5a2 2 0 1 0 0 4c1.2 0 2-.88 2-2s-.8-2-2-2m0 5a3.2 3.2 0 0 1-2.43-1.04C6.89 12.71 6.5 11.58 6.5 10c0-1.17.26-2.28.84-3.11A3.1 3.1 0 0 1 10 5.5c1.62 0 2.42 1.1 2.68 1.56a.5.5 0 0 1-.87.5A2 2 0 0 0 10 6.5c-.83 0-1.43.36-1.84.96a4.4 4.4 0 0 0-.66 2.38A3 3 0 0 1 10 8.5c1.8 0 3 1.36 3 3s-1.2 3-3 3"
]);
const $bf8018481b255628$export$ee16302d4293698f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle7Filled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.5-4a.5.5 0 0 0 0 1h4.08q-.33.52-.74 1.34a20 20 0 0 0-1.83 5.58.5.5 0 1 0 .98.16 19 19 0 0 1 2.9-7.25V6.8h.01a.5.5 0 0 0-.4-.8z"
]);
const $bf8018481b255628$export$96e7be04912ded28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle7Regular', "1em", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16M7.5 6a.5.5 0 0 0 0 1h4.08q-.33.52-.74 1.34a20 20 0 0 0-1.83 5.58.5.5 0 1 0 .98.16 19 19 0 0 1 2.9-7.25V6.8h.01a.5.5 0 0 0-.4-.8z"
]);
const $bf8018481b255628$export$ab957099190db620 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle8Filled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 4.5c-.86 0-1.5.65-1.5 1.38s.64 1.37 1.5 1.37 1.5-.65 1.5-1.37S10.86 6.5 10 6.5m1.57 3.22c.7.47 1.18 1.25 1.18 2.15A2.7 2.7 0 0 1 10 14.5a2.7 2.7 0 0 1-2.75-2.62c0-.9.47-1.69 1.18-2.16a2.3 2.3 0 0 1-.93-1.85A2.44 2.44 0 0 1 10 5.5c1.35 0 2.5 1.03 2.5 2.38 0 .75-.37 1.41-.93 1.84m-1.57.53c-1 0-1.75.75-1.75 1.63S9.01 13.5 10 13.5c1 0 1.75-.75 1.75-1.62s-.76-1.63-1.75-1.63"
]);
const $bf8018481b255628$export$fcbbedbfcf76f83e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle8Regular', "1em", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-3.5c.86 0 1.5.65 1.5 1.38s-.64 1.37-1.5 1.37-1.5-.65-1.5-1.37S9.14 6.5 10 6.5m1.57 3.22c.56-.43.93-1.09.93-1.85A2.44 2.44 0 0 0 10 5.5a2.44 2.44 0 0 0-2.5 2.38c0 .75.37 1.41.93 1.84a2.6 2.6 0 0 0-1.18 2.15A2.7 2.7 0 0 0 10 14.5c1.5 0 2.75-1.15 2.75-2.62 0-.9-.47-1.69-1.18-2.16m-1.57.53c1 0 1.75.75 1.75 1.63S10.99 13.5 10 13.5c-1 0-1.75-.75-1.75-1.62s.76-1.63 1.75-1.63"
]);
const $bf8018481b255628$export$35747d03a521104 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle9Filled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 8.5c-1.2 0-2-.88-2-2s.8-2 2-2a2 2 0 1 1 0 4m2.5-.34A3 3 0 0 1 10 11.5c-1.8 0-3-1.36-3-3s1.2-3 3-3c.86 0 1.76.29 2.43 1.04S13.5 8.42 13.5 10a5.5 5.5 0 0 1-.84 3.11A3.1 3.1 0 0 1 10 14.5a3 3 0 0 1-2.68-1.56.5.5 0 1 1 .87-.5c.19.34.72 1.06 1.81 1.06.83 0 1.43-.36 1.84-.96q.6-.89.66-2.38"
]);
const $bf8018481b255628$export$f01085b9fbf4bc6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberCircle9Regular', "1em", [
    "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14m8-7a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8 .5a2 2 0 1 0 0-4c-1.2 0-2 .88-2 2s.8 2 2 2m0-5c.86 0 1.76.29 2.43 1.04S13.5 8.42 13.5 10a5.5 5.5 0 0 1-.84 3.11A3.1 3.1 0 0 1 10 14.5a3 3 0 0 1-2.68-1.56.5.5 0 1 1 .87-.5c.19.34.72 1.06 1.81 1.06.83 0 1.43-.36 1.84-.96q.6-.89.66-2.38A3 3 0 0 1 10 11.5c-1.8 0-3-1.36-3-3s1.2-3 3-3"
]);
const $bf8018481b255628$export$6faa3b8e0da1532e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberRowFilled', "1em", [
    "M4 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm1 3.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zM13 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm.5 3h2c.28 0 .5.22.5.5V10a.5.5 0 0 1-.5.5H14V13h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5V10c0-.28.22-.5.5-.5H15V7h-1.5a.5.5 0 0 1 0-1"
]);
const $bf8018481b255628$export$e9138d52abc16978 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberRowRegular', "1em", [
    "M5 6.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zM4 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM3 5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm10.5 1a.5.5 0 0 0 0 1H15v2.5h-1.5a.5.5 0 0 0-.5.5v3.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H14v-2.5h1.5a.5.5 0 0 0 .5-.5V6.5a.5.5 0 0 0-.5-.5zM13 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z"
]);
const $bf8018481b255628$export$9539c71b84d73450 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolFilled', "1em", [
    "M8.99 2.88a.75.75 0 0 0-1.48-.26L6.84 6.5H3.75a.75.75 0 0 0 0 1.5h2.83l-.68 4H2.75a.75.75 0 0 0 0 1.5h2.89L5 17.12a.75.75 0 1 0 1.48.26l.67-3.88h4.48L11 17.12a.75.75 0 1 0 1.48.26l.67-3.88h3.1a.75.75 0 0 0 0-1.5h-2.84l.69-4h3.14a.75.75 0 1 0 0-1.5h-2.88l.62-3.62a.75.75 0 0 0-1.48-.26l-.67 3.88H8.37zM8.1 8h4.47l-.68 4H7.42z"
]);
const $bf8018481b255628$export$c159f6f329aa6fce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolRegular', "1em", [
    "M8.99 2.6a.5.5 0 0 0-.98-.2L7.09 7H3.5a.5.5 0 1 0 0 1h3.39l-.8 4H2.5a.5.5 0 0 0 0 1h3.4L5 17.4a.5.5 0 1 0 .98.2l.92-4.6h5l-.9 4.4a.5.5 0 0 0 .98.2l.95-4.6h3.56a.5.5 0 0 0 0-1h-3.36l.82-4h3.54a.5.5 0 1 0 0-1h-3.33l.9-4.39a.5.5 0 1 0-.98-.2l-.95 4.6H8.11zM7.91 8h5.03l-.82 4h-5z"
]);
const $bf8018481b255628$export$c53d8f452aec3ff7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolDismissFilled', "1em", [
    "M8.99 2.88a.75.75 0 0 0-1.48-.26L6.84 6.5H3.75a.75.75 0 0 0 0 1.5h2.83l-.68 4H2.75a.75.75 0 0 0 0 1.5h2.89L5 17.12a.75.75 0 1 0 1.48.26l.67-3.88H9.1q.15-.8.51-1.5H7.42l.69-4h4.47l-.24 1.44q.75-.32 1.59-.41L14.11 8h3.14a.75.75 0 1 0 0-1.5h-2.88l.62-3.62a.75.75 0 0 0-1.48-.26l-.67 3.88H8.37zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bf8018481b255628$export$d90008673e5d4e88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolDismissRegular', "1em", [
    "M8.99 2.6a.5.5 0 0 0-.98-.2L7.09 7H3.5a.5.5 0 1 0 0 1h3.39l-.8 4H2.5a.5.5 0 0 0 0 1h3.4L5 17.4a.5.5 0 1 0 .98.2l.92-4.6h2.3q.15-.53.4-1H7.1l.8-4h5.03l-.27 1.31q.51-.17 1.08-.26L13.96 8h3.54a.5.5 0 1 0 0-1h-3.33l.9-4.39a.5.5 0 1 0-.98-.2l-.95 4.6H8.11zM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-2.65-1.15-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14a.5.5 0 0 1 .7.7"
]);
const $bf8018481b255628$export$3d81353d0af0894d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolSquareColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_number_symbol_square_20_color__a)",
            "d": "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_number_symbol_square_20_color__b)",
            "d": "M9.1 6.01a.5.5 0 0 1 .39.6L9.19 8h2.48L12 6.4a.5.5 0 0 1 .98.2l-.3 1.4h.81a.5.5 0 0 1 0 1h-1.02l-.43 2H13a.5.5 0 0 1 0 1h-1.17l-.34 1.6a.5.5 0 1 1-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 1 1-.98-.2l.3-1.4H6.5a.5.5 0 0 1 0-1h1.02l.43-2H7a.5.5 0 0 1 0-1h1.17l.34-1.6a.5.5 0 0 1 .6-.39M8.55 11h2.47l.43-2H8.98z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_number_symbol_square_20_color__a",
                "x1": "6.41",
                "x2": "14.09",
                "y1": "3",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".03",
                    "stopColor": "#e67eea"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#ad64d7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#794dc5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_number_symbol_square_20_color__b",
                "x1": "7.9",
                "x2": "13.96",
                "y1": "6.31",
                "y2": "16.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#f9dcfa"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$88fa65e6f113181d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolSquareFilled', "1em", [
    "m11.45 9-.43 2H8.55l.43-2zM5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm3.6 3.01a.5.5 0 0 1 .39.6L9.19 8h2.48L12 6.4a.5.5 0 0 1 .98.2l-.3 1.4h.81a.5.5 0 0 1 0 1h-1.02l-.43 2H13a.5.5 0 0 1 0 1h-1.17l-.34 1.6a.5.5 0 1 1-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 1 1-.98-.2l.3-1.4H6.5a.5.5 0 0 1 0-1h1.02l.43-2H7a.5.5 0 0 1 0-1h1.17l.34-1.6a.5.5 0 0 1 .6-.39"
]);
const $bf8018481b255628$export$b08e8bb756b786b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('NumberSymbolSquareRegular', "1em", [
    "M9.1 6.01a.5.5 0 0 1 .39.6L9.19 8h2.48L12 6.4a.5.5 0 0 1 .98.2l-.3 1.4h.81a.5.5 0 0 1 0 1h-1.02l-.43 2H13a.5.5 0 0 1 0 1h-1.17l-.34 1.6a.5.5 0 1 1-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 1 1-.98-.2l.3-1.4H6.5a.5.5 0 0 1 0-1h1.02l.43-2H7a.5.5 0 0 1 0-1h1.17l.34-1.6a.5.5 0 0 1 .6-.39M8.55 11h2.47l.43-2H8.98zM3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5zM5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5z"
]);
const $bf8018481b255628$export$60675ea33a70c497 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paint_brush_20_color__a)",
            "d": "M5 2.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5V10H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paint_brush_20_color__b)",
            "d": "M7 13a2 2 0 0 1-2-2v-1c0-.28.22-.5.5-.5H15V11a2 2 0 0 1-2 2h-1v3a2 2 0 1 1-4 0v-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paint_brush_20_color__c)",
            "d": "M5 9.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v.5H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paint_brush_20_color__d)",
            "d": "M10 4.5V2h1v2.5a.5.5 0 0 1-1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paint_brush_20_color__e)",
            "d": "M12 5.5V2h1v3.5a.5.5 0 0 1-1 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_paint_brush_20_color__a",
                "x1": "8",
                "x2": "13",
                "y1": "-.5",
                "y2": "12.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".09",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paint_brush_20_color__b",
                "x1": "5",
                "x2": "5.87",
                "y1": "6.5",
                "y2": "20.19",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ac80ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5750e2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paint_brush_20_color__c",
                "x1": "7.38",
                "x2": "7.45",
                "y1": "9.13",
                "y2": "10.26",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5750e2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paint_brush_20_color__d",
                "x1": "10",
                "x2": "13.29",
                "y1": ".89",
                "y2": "4.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paint_brush_20_color__e",
                "x1": "10",
                "x2": "13.29",
                "y1": ".89",
                "y2": "4.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$332785c75caecb92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushFilled', "1em", [
    "M10 4.5V2H5.5a.5.5 0 0 0-.5.5V9h10V2.5a.5.5 0 0 0-.5-.5H13v3.5a.5.5 0 0 1-1 0V2h-1v2.5a.5.5 0 0 1-1 0m5 5.5H5v1c0 1.1.9 2 2 2h1.5v3.5a1.5 1.5 0 1 0 3 0V13H13a2 2 0 0 0 2-2z"
]);
const $bf8018481b255628$export$6d6845930efec8bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushRegular', "1em", [
    "M5.5 2a.5.5 0 0 0-.5.5V11c0 1.1.9 2 2 2h1v3a2 2 0 1 0 4 0v-3h1a2 2 0 0 0 2-2V2.5a.5.5 0 0 0-.5-.5zm.5 8h8v1a1 1 0 0 1-1 1h-1.5a.5.5 0 0 0-.5.5V16a1 1 0 1 1-2 0v-3.5a.5.5 0 0 0-.5-.5H7a1 1 0 0 1-1-1zm8-1H6V3h4v1.5a.5.5 0 0 0 1 0V3h1v2.5a.5.5 0 0 0 1 0V3h1z"
]);
const $bf8018481b255628$export$d5cddd8cbb3a78f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushArrowDownFilled', "1em", [
    "M3.57 17.24A.5.5 0 0 0 4 18h1.7l.02-.03c.26-.54.55-1.14.79-1.71.3-.73.49-1.35.49-1.76a.5.5 0 0 1 1 0c0 .63-.27 1.41-.57 2.14q-.29.7-.61 1.36H8c.2-.39.43-.8.61-1.21Q9 15.97 9 15.5a.5.5 0 0 1 1 0c0 .53-.23 1.15-.48 1.7q-.18.4-.39.8h2.75l-.44-.44A1.5 1.5 0 0 1 13 15.1V13.5a1.5 1.5 0 0 1 2-1.41V11H5v.5a12.6 12.6 0 0 1-1.42 5.72zM5 10h10V9a2 2 0 0 0-2-2h-1V4a2 2 0 1 0-4 0v3H7a2 2 0 0 0-2 2zm10 3.5a.5.5 0 0 0-1 0v3.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L15 17.29z"
]);
const $bf8018481b255628$export$4b0deae39b8253c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushArrowDownRegular', "1em", [
    "M9 4v3.5a.5.5 0 0 1-.5.5H7a1 1 0 0 0-1 1v1h8V9a1 1 0 0 0-1-1h-1.5a.5.5 0 0 1-.5-.5V4a1 1 0 1 0-2 0m6 5v3.09a1.5 1.5 0 0 0-1 0V11H6v.5A14 14 0 0 1 4.8 17h1.37l.02-.04a17 17 0 0 0 .66-1.7A3 3 0 0 0 7 14.5a.5.5 0 0 1 1 0q-.02.5-.18 1.03A11 11 0 0 1 7.28 17h1.24l.18-.42c.17-.4.3-.83.3-1.08a.5.5 0 0 1 1 0c0 .47-.2 1.05-.37 1.46L9.6 17h1.48q.1.31.35.56l.44.44H4a.5.5 0 0 1-.43-.76l.01-.02.2-.38q.22-.42.5-1.2c.36-1.02.72-2.46.72-4.14V9c0-1.1.9-2 2-2h1V4a2 2 0 0 1 4 0v3h1a2 2 0 0 1 2 2m0 4.5a.5.5 0 0 0-1 0v3.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L15 17.29z"
]);
const $bf8018481b255628$export$1fc10689cf00d66a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushArrowUpFilled', "1em", [
    "M3.57 17.24A.5.5 0 0 0 4 18h1.7l.02-.03c.26-.54.55-1.14.79-1.71.3-.73.49-1.35.49-1.76a.5.5 0 0 1 1 0c0 .63-.27 1.41-.57 2.14q-.29.7-.61 1.36H8c.2-.39.43-.8.61-1.21Q9 15.97 9 15.5a.5.5 0 0 1 1 0c0 .53-.23 1.15-.48 1.7q-.18.4-.39.8H13v-1.09a1.5 1.5 0 0 1-1.56-2.47l2-2a1.5 1.5 0 0 1 1.56-.35V11H5v.5a12.6 12.6 0 0 1-1.42 5.72zM5 10h10V9a2 2 0 0 0-2-2h-1V4a2 2 0 1 0-4 0v3H7a2 2 0 0 0-2 2zm10 4.7v3.8a.5.5 0 0 1-1 0v-3.8l-1.15 1.15a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7z"
]);
const $bf8018481b255628$export$5781e0ed8b7d03f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushArrowUpRegular', "1em", [
    "M9 4v3.5a.5.5 0 0 1-.5.5H7a1 1 0 0 0-1 1v1h8V9a1 1 0 0 0-1-1h-1.5a.5.5 0 0 1-.5-.5V4a1 1 0 1 0-2 0m6 5v3.09a1.5 1.5 0 0 0-1 0V11H6v.5A14 14 0 0 1 4.8 17h1.37l.02-.04a17 17 0 0 0 .66-1.7A3 3 0 0 0 7 14.5a.5.5 0 0 1 1 0q-.02.5-.18 1.03A11 11 0 0 1 7.28 17h1.24l.18-.42c.17-.4.3-.83.3-1.08a.5.5 0 0 1 1 0c0 .47-.2 1.05-.37 1.46L9.6 17H13v1H4a.5.5 0 0 1-.43-.76l.01-.02.2-.38q.22-.42.5-1.2c.36-1.02.72-2.46.72-4.14V9c0-1.1.9-2 2-2h1V4a2 2 0 0 1 4 0v3h1a2 2 0 0 1 2 2m0 5.7v3.8a.5.5 0 0 1-1 0v-3.8l-1.15 1.15a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7z"
]);
const $bf8018481b255628$export$1072e2fc6284f586 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushSparkleFilled', "1em", [
    "m14.88 7.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0-.14.46.3.3 0 0 0 .14.11l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM10 2v2.5a.5.5 0 0 0 1 0V2h1v3.5a.5.5 0 0 0 1 0V2h1.5c.28 0 .5.22.5.5v3.6a1.4 1.4 0 0 0-1.86.85v.01l-.36 1.08a1.2 1.2 0 0 1-.74.76l-.61.2H5V2.5c0-.28.22-.5.5-.5zm.09 8H5v1c0 1.1.9 2 2 2h1.5v3.5a1.5 1.5 0 0 0 3 0V13h1.32l-.02-.04a1 1 0 0 0-.35-.53 1 1 0 0 0-.4-.24l-1.09-.35h-.01a1.4 1.4 0 0 1-.86-1.84"
]);
const $bf8018481b255628$export$900eb2ed5cb1a7c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushSparkleRegular', "1em", [
    "m14.88 7.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0-.14.46.3.3 0 0 0 .14.11l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM5 2.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v3.6a1.4 1.4 0 0 0-1-.02V3h-1v2.5a.5.5 0 0 1-1 0V3h-1v1.5a.5.5 0 0 1-1 0V3H6v6h5.42l-.46.15h-.01a1.4 1.4 0 0 0-.86.85H6v1a1 1 0 0 0 1 1h1.5c.28 0 .5.23.5.5V16a1 1 0 1 0 2 0v-3.5c0-.26.2-.47.46-.5l.58.2a1.2 1.2 0 0 1 .76.76l.02.04H12v3a2 2 0 1 1-4 0v-3H7a2 2 0 0 1-2-2z"
]);
const $bf8018481b255628$export$d991e99d62f1a09b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushSubtractFilled', "1em", [
    "M10 2v2.5a.5.5 0 0 0 1 0V2h1v3.5a.5.5 0 0 0 1 0V2h1.5c.28 0 .5.22.5.5V9H5V2.5c0-.28.22-.5.5-.5zM9 14.5c0-1.86.92-3.5 2.34-4.5H5v1c0 1.1.9 2 2 2h1v3a2 2 0 0 0 2.24 1.99A5.5 5.5 0 0 1 9 14.5m5.5 4.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $bf8018481b255628$export$84654a3e2e62422b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBrushSubtractRegular', "1em", [
    "M5.5 2a.5.5 0 0 0-.5.5V11c0 1.1.9 2 2 2h1v3A2 2 0 0 0 10.25 18a6 6 0 0 1-.7-1.1A1 1 0 0 1 9 16v-3.5a.5.5 0 0 0-.5-.5H7a1 1 0 0 1-1-1v-1h5.33A5.5 5.5 0 0 1 15 9.02V2.5a.5.5 0 0 0-.5-.5zM6 9V3h4v1.5a.5.5 0 0 0 1 0V3h1v2.5a.5.5 0 0 0 1 0V3h1v6zm8.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $bf8018481b255628$export$7fa032cecbe52a5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBucketFilled', "1em", [
    "M9 2.5a.5.5 0 0 0-1 0V4q-.31.1-.56.35L2.35 9.44a1.5 1.5 0 0 0 0 2.12L6.7 15.9a1.5 1.5 0 0 0 2.12 0l5.09-5.09a1.5 1.5 0 0 0 0-2.12L9.56 4.35A2 2 0 0 0 9 4zm4.27 7.5H3.2L8 5.2v1.3a.5.5 0 0 0 1 0V5.2l4.19 4.2a.5.5 0 0 1 .08.6m2.75 1.4a.6.6 0 0 0-1.04 0l-1.65 2.82a2.51 2.51 0 1 0 4.34 0z"
]);
const $bf8018481b255628$export$627dfdcb2c8d074a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBucketRegular', "1em", [
    "M9 2.5a.5.5 0 0 0-1 0V4q-.31.1-.56.35L2.35 9.44a1.5 1.5 0 0 0 0 2.12L6.7 15.9a1.5 1.5 0 0 0 2.12 0l5.09-5.09a1.5 1.5 0 0 0 0-2.12L9.56 4.35A2 2 0 0 0 9 4zM8 5.2v1.3a.5.5 0 0 0 1 0V5.2l4.19 4.2a.5.5 0 0 1 .08.6H3.2zm-.6 9.99L3.2 11h9.1l-4.2 4.19a.5.5 0 0 1-.7 0m8.62-3.8a.6.6 0 0 0-1.04 0l-1.65 2.83a2.51 2.51 0 1 0 4.34 0zm-1.82 3.34 1.3-2.24 1.3 2.24a1.51 1.51 0 1 1-2.6 0"
]);
const $bf8018481b255628$export$dfcbaa5febcf6ca8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBucketBrushFilled', "1em", [
    "M7.5 1c.28 0 .5.22.5.5v1.12q.41.12.73.44l2.97 2.97c.68.68.68 1.79 0 2.47l-.29.29-.12.12-3.84 3.83c-.68.69-1.79.69-2.47 0L2 9.77A1.75 1.75 0 0 1 2 7.3l4.24-4.24q.34-.33.75-.45V1.5c0-.28.22-.5.5-.5M7 3.72l-.04.04L2.72 8h8.06l.2-.2c.3-.3.3-.77 0-1.07L8.03 3.76 8 3.74V5.5a.5.5 0 0 1-1 0zm4.98 12.3q.45-.01.81-.19c.6-.27 1.12-.8 1.48-1.15l.03-.03a20 20 0 0 0 2.94-3.62 6 6 0 0 0 .68-1.47c.1-.39.16-.92-.2-1.28s-.9-.3-1.28-.2a6 6 0 0 0-1.47.68 20 20 0 0 0-3.62 2.94l-.03.03c-.36.36-.88.88-1.15 1.47q-.18.38-.2.81a2.3 2.3 0 0 0-1.85.66c-.26.25-.38.52-.46.76l-.07.26-.02.04-.06.22a1 1 0 0 1-.25.32c-.16.12-.42.26-.9.4a.5.5 0 0 0-.21.83 4.3 4.3 0 0 0 2.7 1.38 3.2 3.2 0 0 0 2.48-1c.5-.51.73-1.2.65-1.86m-3.15-.65a1.27 1.27 0 1 1 1.8 1.8 2.2 2.2 0 0 1-1.72.72 3 3 0 0 1-1.45-.57q.23-.12.4-.25.44-.35.57-.75l.11-.33.02-.06.05-.2q.06-.19.22-.36m2.15-1.23a1 1 0 0 1 .1-.52c.19-.42.58-.82.97-1.21a19 19 0 0 1 3.44-2.8q.75-.45 1.2-.57A1 1 0 0 1 17 9a1 1 0 0 1-.03.3q-.13.46-.57 1.21c-.6 1-1.58 2.22-2.8 3.44-.39.39-.8.78-1.2.97a1 1 0 0 1-.53.1 1 1 0 0 1-.55-.33 1 1 0 0 1-.33-.55"
]);
const $bf8018481b255628$export$99d77179f30dfef3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaintBucketBrushRegular', "1em", [
    "M7.5 1c.28 0 .5.22.5.5v1.12q.41.12.73.44l2.97 2.97c.68.68.68 1.79 0 2.47l-.29.29-.12.12-3.84 3.83c-.68.69-1.79.69-2.47 0L2 9.77A1.75 1.75 0 0 1 2 7.3l4.24-4.24q.34-.33.75-.45V1.5c0-.28.22-.5.5-.5M7 3.72l-.04.04L2.72 8h8.06l.2-.2c.3-.3.3-.77 0-1.07L8.03 3.76 8 3.74V5.5a.5.5 0 0 1-1 0zM9.78 9H2.66l.06.07 2.97 2.97c.29.29.76.29 1.06 0zm2.2 7.02q.45-.01.81-.19c.6-.27 1.12-.8 1.48-1.15l.03-.03a20 20 0 0 0 2.94-3.62 6 6 0 0 0 .68-1.47c.1-.39.16-.92-.2-1.28s-.9-.3-1.28-.2a6 6 0 0 0-1.47.68 20 20 0 0 0-3.62 2.94l-.03.03c-.36.36-.88.88-1.15 1.47q-.18.38-.2.81a2.3 2.3 0 0 0-1.85.66c-.26.25-.38.52-.46.76l-.07.26-.02.04-.06.22a1 1 0 0 1-.25.32c-.16.12-.42.26-.9.4a.5.5 0 0 0-.21.83 4.3 4.3 0 0 0 2.7 1.38 3.2 3.2 0 0 0 2.48-1c.5-.51.73-1.2.65-1.86m-3.15-.65a1.27 1.27 0 1 1 1.8 1.8 2.2 2.2 0 0 1-1.72.72 3 3 0 0 1-1.45-.57q.23-.12.4-.25.44-.35.57-.75l.11-.33.02-.06.05-.2q.06-.19.22-.36m2.15-1.23a1 1 0 0 1 .1-.52c.19-.42.58-.82.97-1.21a19 19 0 0 1 3.44-2.8q.75-.45 1.2-.57A1 1 0 0 1 17 9a1 1 0 0 1-.03.3q-.13.46-.57 1.21c-.6 1-1.58 2.22-2.8 3.44-.39.39-.8.78-1.2.97a1 1 0 0 1-.53.1 1 1 0 0 1-.55-.33 1 1 0 0 1-.33-.55"
]);
const $bf8018481b255628$export$f233e72856374e53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PairFilled', "1em", [
    "M12.25 2A1.75 1.75 0 0 1 13 5.33V7h1.67A1.75 1.75 0 1 1 17 9.33v5.34A1.75 1.75 0 1 1 14.67 17H9.33A1.75 1.75 0 1 1 7 14.67V13H5.33A1.75 1.75 0 1 1 3 10.67V5.33A1.75 1.75 0 1 1 5.33 3h5.34c.28-.6.88-1 1.58-1m.75 8.67A1.75 1.75 0 1 1 10.67 13H8.5v1.67q.56.27.83.83h5.34q.27-.56.83-.83V9.33a1.8 1.8 0 0 1-.83-.83H13zM5.33 4.5q-.27.56-.83.83v5.34q.56.27.83.83H7V9.33A1.75 1.75 0 1 1 9.33 7h2.17V5.33a1.8 1.8 0 0 1-.83-.83zm4 4q-.27.56-.83.83v2.17h2.17q.27-.56.83-.83V8.5z"
]);
const $bf8018481b255628$export$f0694f67c6ef7a26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PairRegular', "1em", [
    "M2 3.5c0 .65.42 1.2 1 1.41v6.18A1.5 1.5 0 1 0 4.91 13H7v2.09A1.5 1.5 0 1 0 8.91 17h6.18A1.5 1.5 0 1 0 17 15.09V8.9A1.5 1.5 0 1 0 15.09 7H13V4.91A1.5 1.5 0 1 0 11.09 3H4.9A1.5 1.5 0 0 0 2 3.5M8.91 16a1.5 1.5 0 0 0-.91-.91V13h3.09A1.5 1.5 0 1 0 13 11.09V8h2.09c.15.43.48.76.91.91v6.18a1.5 1.5 0 0 0-.91.91zM4 11.09V4.9c.43-.15.76-.48.91-.91h6.18c.15.43.48.76.91.91V7H8.91A1.5 1.5 0 1 0 7 8.91V12H4.91a1.5 1.5 0 0 0-.91-.91m8 0a1.5 1.5 0 0 0-.91.91H8V8.91c.43-.15.76-.48.91-.91H12z"
]);
const $bf8018481b255628$export$15b6011fff9e70ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PatchFilled', "1em", [
    "m8.27 3.06 1.02 1.03-5.2 5.2-1.03-1.02a2.5 2.5 0 0 1 0-3.54l1.67-1.67a2.5 2.5 0 0 1 3.54 0m3.46 13.88-1.02-1.03 5.2-5.2 1.03 1.02a2.5 2.5 0 0 1 0 3.54l-1.67 1.67a2.5 2.5 0 0 1-3.54 0m-8.67-5.2a2.5 2.5 0 0 0 0 3.53l1.67 1.67a2.5 2.5 0 0 0 3.54 0l8.67-8.67a2.5 2.5 0 0 0 0-3.54l-1.67-1.67a2.5 2.5 0 0 0-3.54 0zM10 8.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M8.5 10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m3.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M10.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
]);
const $bf8018481b255628$export$f3a9f73aabd73b4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PatchRegular', "1em", [
    "M10.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m4.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M10 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-6.94 2.77a2.5 2.5 0 0 1 0-3.54l8.67-8.67a2.5 2.5 0 0 1 3.54 0l1.67 1.67a2.5 2.5 0 0 1 0 3.54l-8.67 8.67a2.5 2.5 0 0 1-3.54 0zm.7-2.83a1.5 1.5 0 0 0 0 2.12l1.68 1.67a1.5 1.5 0 0 0 2.12 0l1.73-1.73-3.79-3.8zM13.8 10 10 6.2 6.2 10l3.8 3.8zm.71-.7 1.73-1.74a1.5 1.5 0 0 0 0-2.12l-1.67-1.67a1.5 1.5 0 0 0-2.12 0L10.7 5.5zm-3.8 6.61 1.03 1.03a2.5 2.5 0 0 0 3.54 0l1.67-1.67a2.5 2.5 0 0 0 0-3.54l-1.03-1.02-.7.7 1.02 1.03a1.5 1.5 0 0 1 0 2.12l-1.67 1.67a1.5 1.5 0 0 1-2.12 0l-1.03-1.02zM8.6 4.8 7.56 3.77a1.5 1.5 0 0 0-2.12 0L3.77 5.44a1.5 1.5 0 0 0 0 2.12L4.79 8.6l-.7.7-1.03-1.02a2.5 2.5 0 0 1 0-3.54l1.67-1.67a2.5 2.5 0 0 1 3.54 0L9.29 4.1z"
]);
const $bf8018481b255628$export$3193098d00182923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PatientColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_patient_20_color__a)",
            "d": "M4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8.5H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_patient_20_color__b)",
            "d": "M7 12.5V10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_patient_20_color__c)",
            "d": "M10 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_patient_20_color__d)",
            "d": "M4 12h12v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_patient_20_color__e)",
            "fillOpacity": ".7",
            "d": "M4 12h12v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_patient_20_color__f)",
            "d": "M6.5 14.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_patient_20_color__a",
                "x1": "8.29",
                "x2": "11.93",
                "y1": "2",
                "y2": "12.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_patient_20_color__b",
                "x1": "8.43",
                "x2": "9.7",
                "y1": "9.47",
                "y2": "12.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_patient_20_color__c",
                "x1": "8.95",
                "x2": "10.99",
                "y1": "4.53",
                "y2": "7.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_patient_20_color__d",
                "x1": "1",
                "x2": "17.94",
                "y1": ".01",
                "y2": "15.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_patient_20_color__e",
                "x1": "10",
                "x2": "11.49",
                "y1": "6.5",
                "y2": "20.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_patient_20_color__f",
                "x1": "7.54",
                "x2": "7.65",
                "y1": "14.58",
                "y2": "16.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$cc513a111b5f554f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PatientFilled', "1em", [
    "M10 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4M6.5 14.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm10-1H6a1 1 0 0 0-1 1v8h2v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2h2V4a1 1 0 0 0-1-1M5 13v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3z"
]);
const $bf8018481b255628$export$ba4d5eaa09622cf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PatientRegular', "1em", [
    "M10 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4M9 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2.5 8.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm10-1H6a1 1 0 0 0-1 1v8h2v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2h2V4a1 1 0 0 0-1-1m-2 7H8v2h4zm-7 3v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3z"
]);
const $bf8018481b255628$export$fe49cd8070df6a1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67.33.34a2 2 0 0 1 0 2.82l-.94.94a.5.5 0 0 1-.7-.7l.94-.94a1 1 0 0 0 0-1.42l-.34-.33-7.98 7.98q-.52.51-1.24.68l-3.92.87a.5.5 0 0 1-.6-.6l.88-3.95q.16-.68.66-1.2z"
]);
const $bf8018481b255628$export$145505ed86f9708f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.88q.72-.16 1.24-.67l7.98-7.98.34.33a1 1 0 0 1 0 1.42l-.94.94a.5.5 0 0 0 .7.7l.94-.94a2 2 0 0 0 0-2.82l-.33-.34.67-.67a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-9.36 9.35q-.31.31-.74.4l-3.16.71.7-3.18q.1-.41.4-.7z"
]);
const $bf8018481b255628$export$c26a72c781cbb7e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenDismissFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21L15 9.21A5.5 5.5 0 0 0 8.2 16l-.43.44q-.52.51-1.24.68l-3.92.87a.5.5 0 0 1-.6-.6l.88-3.95q.16-.68.66-1.2zM18 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bf8018481b255628$export$232d89446737f756 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenDismissRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16q-.17-.59-.2-1.21l-.95.94q-.31.31-.74.4l-3.16.71.7-3.18q.1-.41.4-.7l9.37-9.38a1.97 1.97 0 0 1 2.79 2.8L13.78 9q.63.03 1.22.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15M18 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bf8018481b255628$export$12d61748c39f485b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l5.4 5.4-4 4q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 0 0 .7-.71zm12.9 6.3-2.59 2.6-4.2-4.21 3.96-3.97a2.97 2.97 0 0 1 4.2 4.21l-.66.67.33.34a2 2 0 0 1 0 2.82l-.94.94a.5.5 0 0 1-.7-.7l.94-.94a1 1 0 0 0 0-1.42z"
]);
const $bf8018481b255628$export$7b83f2f8d4e08863 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l5.4 5.4-4 4q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 0 0 .7-.71zm8.2 9.6-3.99 3.98q-.31.31-.74.4l-3.16.71.7-3.18q.1-.41.4-.7l3.99-4zm5.37-5.38-3.96 3.97.7.7 2.59-2.58.34.33a1 1 0 0 1 0 1.42l-.94.94a.5.5 0 1 0 .7.7l.94-.94a2 2 0 0 0 0-2.82l-.33-.34.67-.67a2.97 2.97 0 0 0-4.21-4.2L8.96 6.83l.7.7 3.97-3.96a1.97 1.97 0 0 1 2.79 2.8"
]);
const $bf8018481b255628$export$3fc684eaf23691e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenProhibitedFilled', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l2.13-2.12a2.97 2.97 0 0 0 .05-4.15M9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $bf8018481b255628$export$6c3323c618921084 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenProhibitedRegular', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.2L15 9.22q-.59-.17-1.21-.2l2.63-2.64a1.97 1.97 0 0 0-2.8-2.8l-9.37 9.38q-.3.3-.38.7l-.71 3.2 3.16-.71q.43-.1.74-.41l.95-.95q.03.63.2 1.22l-.44.44q-.52.52-1.24.67L2.61 18a.5.5 0 0 1-.6-.6l.88-3.95q.16-.69.66-1.2zM9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $bf8018481b255628$export$36d61f440465b25a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenSparkleFilled', "1em", [
    "m4.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L4.9 6.72a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L1.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4L4.08.28a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM7.5 12q-.41 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a.6.6 0 0 0-.26-.31l-2.21 2.2q-.5.52-.66 1.2l-.88 3.95a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l7.98-7.98.34.33a1 1 0 0 1 0 1.42l-.94.94a.5.5 0 0 0 .7.7l.94-.94a2 2 0 0 0 0-2.82l-.33-.34.67-.67a2.97 2.97 0 0 0-4.21-4.2l-3.91 3.9q.03.06.09.11.1.1.23.14l.76.25q.43.15.67.5a1.3 1.3 0 0 1-.63 1.97l-.8.26a1 1 0 0 0-.21.14 1 1 0 0 0-.14.23l-.25.76q-.15.41-.48.65c-.22.16-.48.2-.75.21"
]);
const $bf8018481b255628$export$8e886f9332d42e4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenSparkleRegular', "1em", [
    "m4.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L4.9 6.72a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L1.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4L4.08.28a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.76 2.14.2.63-1.97 1.97q-.3.3-.38.7l-.71 3.2 3.16-.71q.43-.1.74-.41l9.36-9.36a1.97 1.97 0 0 0-2.8-2.79L9.98 7.24l-.64-.2a1 1 0 0 1-.23-.15L9 6.8l3.91-3.92a2.97 2.97 0 0 1 4.2 4.2l-.66.68.33.34a2 2 0 0 1 0 2.82l-.94.94a.5.5 0 0 1-.7-.7l.94-.94a1 1 0 0 0 0-1.42l-.34-.33-7.98 7.98q-.52.52-1.24.67L2.61 18a.5.5 0 0 1-.6-.6l.88-3.95q.16-.69.66-1.2l2.2-2.2a.6.6 0 0 1 .27.3"
]);
const $bf8018481b255628$export$384593dd2b9af419 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenSyncFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21L15 9.21A5.5 5.5 0 0 0 8.2 16l-.43.44q-.52.51-1.24.68l-3.92.87a.5.5 0 0 1-.6-.6l.88-3.95q.16-.68.66-1.2zM9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H14a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $bf8018481b255628$export$af435067fb8e09f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PenSyncRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.88q.72-.16 1.24-.67L8.2 16q-.17-.59-.2-1.22l-.95.95q-.31.31-.74.4l-3.16.71.7-3.18q.1-.41.4-.7l9.37-9.38a1.97 1.97 0 0 1 2.79 2.8L13.78 9q.63.03 1.22.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15M9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H14a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $bf8018481b255628$export$49a18c9d3ecac34d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PentagonFilled', "1em", [
    "M11.76 1.66a2.5 2.5 0 0 0-3.37-.01L2.82 6.7a2.5 2.5 0 0 0-.67 2.7l2.15 5.95A2.5 2.5 0 0 0 6.65 17h6.83a2.5 2.5 0 0 0 2.36-1.7l2.03-6.02a2.5 2.5 0 0 0-.68-2.64z"
]);
const $bf8018481b255628$export$f69500a09f637286 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PentagonRegular', "1em", [
    "M8.4 1.65a2.5 2.5 0 0 1 3.36 0l5.43 4.99c.73.67 1 1.7.68 2.64l-2.03 6.02a2.5 2.5 0 0 1-2.36 1.7H6.65c-1.05 0-2-.66-2.35-1.65L2.15 9.4a2.5 2.5 0 0 1 .67-2.7zm2.69.74a1.5 1.5 0 0 0-2.03 0L3.5 7.44a1.5 1.5 0 0 0-.4 1.62l2.15 5.95c.21.6.78.99 1.4.99h6.84a1.5 1.5 0 0 0 1.42-1.02l2.02-6.02a1.5 1.5 0 0 0-.4-1.58z"
]);
const $bf8018481b255628$export$f69a70051289eb1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_20_color__a)",
            "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_20_color__b)",
            "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_20_color__c)",
            "d": "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_20_color__a",
                "x1": "6.33",
                "x2": "8.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_20_color__b",
                "x1": "10",
                "x2": "13.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_20_color__c",
                "x1": "7.9",
                "x2": "11.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$482a8d6d84213ca8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
]);
const $bf8018481b255628$export$cfc2b730852a3cfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1c0 1.3-.62 2.28-1.67 2.95A8 8 0 0 1 10 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 4 13"
]);
const $bf8018481b255628$export$6dd5198e1566ee8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Person5Filled', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h7.59l-.07.25-.5 3A1.5 1.5 0 0 0 13.48 16a1.5 1.5 0 0 0-1.44 1.83Q11.06 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m11-2a.5.5 0 0 0-.5.42l-.5 3a.5.5 0 0 0 .57.58l.08-.02.21-.02 1.74-.2.02-.01a1.63 1.63 0 0 1 0 3.25q-.47 0-1-.23a1.6 1.6 0 0 1-.7-.54.5.5 0 0 0-.84.54c.26.41.7.71 1.13.91.45.2.96.32 1.41.32a2.63 2.63 0 1 0-.48-5.2l-1.04.12.32-1.92h3.08a.5.5 0 0 0 0-1z"
]);
const $bf8018481b255628$export$52a5b956390e2360 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Person5Regular', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 13a2 2 0 0 1 2-2h7.59l-.07.25-.12.75H5a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 10 17q1.17 0 2.18-.21a1.5 1.5 0 0 0-.14 1.04Q11.06 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m11-2a.5.5 0 0 0-.5.42l-.5 3a.5.5 0 0 0 .57.58l.08-.02.21-.02 1.74-.2.02-.01a1.63 1.63 0 0 1 0 3.25q-.47 0-1-.23a1.6 1.6 0 0 1-.7-.54.5.5 0 0 0-.84.54c.26.41.7.71 1.13.91.45.2.96.32 1.41.32a2.63 2.63 0 1 0-.48-5.2l-1.04.12.32-1.92h3.08a.5.5 0 0 0 0-1z"
]);
const $bf8018481b255628$export$59d2881308c1eb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Person6Filled', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h9.05A3.5 3.5 0 0 0 13 13.5v3q0 .56.16 1.06-1.45.45-3.16.44a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m12 .5a1.5 1.5 0 0 1 2.63-1 .5.5 0 0 0 .74-.65A2.5 2.5 0 0 0 14 13.5v3a2.5 2.5 0 1 0 1-2zm1.5 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $bf8018481b255628$export$c4fba823b3a98e7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Person6Regular', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 13a2 2 0 0 1 2-2h9.05q-.45.44-.71 1H5A1 1 0 0 0 4 13c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 10 17c1.1 0 2.13-.15 3-.43q0 .52.16 1Q11.71 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m12 .5a1.5 1.5 0 0 1 2.63-1 .5.5 0 0 0 .74-.65A2.5 2.5 0 0 0 14 13.5v3a2.5 2.5 0 1 0 1-2zm1.5 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $bf8018481b255628$export$2345c9c035ef1428 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAccountsFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18h.05a3 3 0 0 1-.05-.5v-4a2.5 2.5 0 0 1 2.04-2.46l.01-.04zm8 .5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5m1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5"
]);
const $bf8018481b255628$export$f53c14523959961f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAccountsRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18h.05a3 3 0 0 1-.05-.5V17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.5c.37-.5.91-.84 1.54-.96l.01-.04zm8 .5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5m1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5"
]);
const $bf8018481b255628$export$9a802110aa3c1c8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAddColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_add_20_color__a)",
            "d": "M4 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_add_20_color__b)",
            "d": "M4 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_add_20_color__c)",
            "fillOpacity": ".5",
            "d": "M4 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_add_20_color__d)",
            "d": "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_add_20_color__e)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_add_20_color__f)",
            "fillRule": "evenodd",
            "d": "M14.5 12c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_add_20_color__a",
                "x1": "5.33",
                "x2": "7.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_add_20_color__b",
                "x1": "9",
                "x2": "12.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_add_20_color__d",
                "x1": "6.9",
                "x2": "10.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_add_20_color__e",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_add_20_color__f",
                "x1": "12.94",
                "x2": "14.47",
                "y1": "12.51",
                "y2": "17.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_add_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 0 14.5)scale(7.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".42",
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$68faa1338aa349db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAddFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $bf8018481b255628$export$bb8a92be45a7126d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAddRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $bf8018481b255628$export$4c5a2d36ba26d332 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAlertFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.57 0 1.11-.05a1.5 1.5 0 0 1-.58-2.6l.97-.81V13q.02-1.1.53-2zm7.5 2a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L11.5 15zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $bf8018481b255628$export$1f97c2c6d7d3ba2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAlertRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.57 0 1.11-.05c-.5-.13-.86-.5-1.02-.95H9a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h6.63q.14-.54.4-1zm7.5 2a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L11.5 15zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $bf8018481b255628$export$b7ffecb78046c0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAlertOffFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.96 0 1.86-.14a1.5 1.5 0 0 1-.33-2.5l.97-.82V13q0-.18.02-.36l-.58-.58A1.5 1.5 0 0 1 10.5 11zm14.65 7.35L17.29 17H11.5a.5.5 0 0 1-.32-.88L12.5 15v-2a3 3 0 0 1 .08-.7l-.93-.95a.5.5 0 0 1 .7-.7l7 7a.5.5 0 0 1-.7.7m-.15-2.97-4.79-4.79q.77-.57 1.79-.59a3 3 0 0 1 3 3zm-3 3.62a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $bf8018481b255628$export$2e7b2912c2f98dcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAlertOffRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.96 0 1.86-.14a1.5 1.5 0 0 1-.79-.9q-.51.03-1.07.04a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h6.88a1.5 1.5 0 0 1-.38-1zm14.65 7.35L17.29 17H11.5a.5.5 0 0 1-.32-.88L12.5 15v-2a3 3 0 0 1 .08-.7l-.93-.95a.5.5 0 0 1 .7-.7l7 7a.5.5 0 0 1-.7.7m-.15-2.97-4.79-4.79q.77-.57 1.79-.59a3 3 0 0 1 3 3zm-3 3.62a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $bf8018481b255628$export$9fa493078deb885d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonArrowBackFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $bf8018481b255628$export$27a44cc4ea20da5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonArrowBackRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $bf8018481b255628$export$2febfbcb1cd09811 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonArrowLeftFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm15 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $bf8018481b255628$export$1b3d12fbd130f57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonArrowLeftRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm15 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $bf8018481b255628$export$25b4cba2990c7128 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonArrowRightFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm15 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $bf8018481b255628$export$22fc521189c5df7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonArrowRightRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm15 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $bf8018481b255628$export$d171a661e5019c71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAvailableColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_available_20_color__a)",
            "d": "M3 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_available_20_color__b)",
            "d": "M3 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_available_20_color__c)",
            "fillOpacity": ".5",
            "d": "M3 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_available_20_color__d)",
            "d": "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_available_20_color__e)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_available_20_color__f)",
            "fillRule": "evenodd",
            "d": "M16.85 12.65c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_available_20_color__a",
                "x1": "6.33",
                "x2": "8.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_available_20_color__b",
                "x1": "10",
                "x2": "13.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_available_20_color__d",
                "x1": "7.9",
                "x2": "11.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_available_20_color__e",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_available_20_color__f",
                "x1": "12.94",
                "x2": "13.95",
                "y1": "12.91",
                "y2": "17.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_available_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 -.5 15)scale(6.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".42",
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$dfb4cbfdc3eaa8cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAvailableFilled', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h6.26a5.5 5.5 0 0 0-.05 6.94Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bf8018481b255628$export$9032927bc9f16eda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonAvailableRegular', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 13a2 2 0 0 1 2-2h6.26q-.39.46-.66 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17l.6-.01q.25.51.61.95Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bf8018481b255628$export$af410a7d2bd523a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonBoardFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm4.75 3.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m1.75 4c0 .59-.15 2.5-3.5 2.5s-3.5-1.93-3.5-2.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1M5.76 16A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.24v6.74a3.5 3.5 0 0 1-3.5 3.5z"
]);
const $bf8018481b255628$export$1ee86943a2a66de1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonBoardRegular', "1em", [
    "M9 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2M6.5 9C5.67 9 5 9.67 5 10.5c0 .33.04 1.05.62 1.68.59.63 1.63 1.07 3.38 1.07s2.79-.43 3.37-1.06A2.4 2.4 0 0 0 13 10.5c0-.83-.67-1.5-1.5-1.5zM6 10.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5 0 .25-.03.66-.36 1-.32.35-1.04.75-2.64.75s-2.32-.4-2.64-.75a1.4 1.4 0 0 1-.36-1M3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm2 13a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.76A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $bf8018481b255628$export$7d7d144bcd6c535d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonBoardAddFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h3.02a6 6 0 0 1 .27-2.25h-.3c-3.35 0-3.49-1.93-3.49-2.5a1 1 0 0 1 1-1h5q.4.01.68.26A5.5 5.5 0 0 1 15 9.02V6a3 3 0 0 0-3-3zm4.75 3.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M5.76 16h3.45q.15.52.39 1H8a3 3 0 0 1-2.24-1M17 8v1.6q-.48-.24-1-.4V5.77A3 3 0 0 1 17 8m2 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bf8018481b255628$export$dc160773e518271a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonBoardAddRegular', "1em", [
    "M9 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2M6.5 9C5.67 9 5 9.67 5 10.5c0 .33.04 1.05.62 1.68.59.63 1.63 1.07 3.38 1.07h.14q.12-.53.35-1.01l-.5.01c-1.6 0-2.3-.4-2.63-.75a1.4 1.4 0 0 1-.36-1c0-.28.22-.5.5-.5h4.84q.53-.38 1.15-.62A1.5 1.5 0 0 0 11.5 9zM6 14h3.02a6 6 0 0 0 0 1H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3.02a6 6 0 0 0-1 0V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2m-.24 2h3.45q.15.52.39 1H8a3 3 0 0 1-2.24-1M17 8v1.6q-.48-.24-1-.4V5.77A3 3 0 0 1 17 8m2 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bf8018481b255628$export$b6c94962a978d2ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonBriefcaseFilled', "1em", [
    "M15.5 10c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h.5v-.5c0-.83.67-1.5 1.5-1.5zm-2 1a.5.5 0 0 0-.5.5v.5h3v-.5a.5.5 0 0 0-.5-.5zm-2.46.04A2.5 2.5 0 0 0 9 13.5v4q0 .26.05.5H9a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2h7.05zM9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $bf8018481b255628$export$275c28a5de0e5565 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonBriefcaseRegular', "1em", [
    "M15.5 10c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h.5v-.5c0-.83.67-1.5 1.5-1.5zm-2 1a.5.5 0 0 0-.5.5v.5h3v-.5a.5.5 0 0 0-.5-.5zm-2.46.04A2.5 2.5 0 0 0 9.5 12H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95 1 .64 2.4 1 4 1.05H9v.5q0 .26.05.5H9a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2h7.05zM9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bf8018481b255628$export$11ed06c6dfd4e888 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonCallFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q.54 0 1.06-.04a2.2 2.2 0 0 1 .51-1.98l.55-.6c.5-.57 1.28-.8 2-.63l.8.18q.55-.46.7-1.12l-.51-.5a1.9 1.9 0 0 1-.46-2.08l.08-.23zm10.58.58.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $bf8018481b255628$export$9d5eee9581acf00d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonCallRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q.54 0 1.06-.04a2 2 0 0 1 0-1Q10.54 17 10 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h9.52q-.01-.4.13-.77l.08-.23zm10.58.58.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $bf8018481b255628$export$5b73060047b0ea8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonChatFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a8.5 8.5 0 0 0 4 1.17l.36-1.2a5.5 5.5 0 0 1 .77-5.77zm14 3.5a4.5 4.5 0 0 1-6.68 3.94l-1.8.54a.4.4 0 0 1-.5-.5l.54-1.8A4.5 4.5 0 1 1 19 14.5M12.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5"
]);
const $bf8018481b255628$export$6900af6b82ea4ddf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonChatRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a8.5 8.5 0 0 0 4 1.17l.3-.98a8 8 0 0 1-3.76-1.04A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h4.6q.27-.54.66-1zm14 3.5a4.5 4.5 0 0 1-6.68 3.94l-1.8.54a.4.4 0 0 1-.5-.5l.54-1.8A4.5 4.5 0 1 1 19 14.5M12.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5"
]);
const $bf8018481b255628$export$d28b0ce052d7521c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonCircleFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M8 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5 3h5c.83 0 1.5.67 1.5 1.5 0 1.12-.46 2.01-1.21 2.61-.74.6-1.74.89-2.79.89a4.4 4.4 0 0 1-2.79-.89A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5"
]);
const $bf8018481b255628$export$1a0f9f2d7dc7e7e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonCircleRegular', "1em", [
    "M8 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5 3h5c.83 0 1.5.67 1.5 1.5 0 1.12-.46 2.01-1.21 2.61-.74.6-1.74.89-2.79.89a4.4 4.4 0 0 1-2.79-.89A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $bf8018481b255628$export$7c0d55bce5354dcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonCircleOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7L2.15 2.85a.5.5 0 0 1 0-.7M7.5 10c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.62.74.59 1.74.88 2.79.88s2.05-.29 2.79-.88l.32-.3L9.29 10zM10 2a8 8 0 0 1 6.62 12.5l-2.64-2.64.02-.36c0-.83-.67-1.5-1.5-1.5h-.38L10.9 8.78A2 2 0 1 0 8.22 6.1L5.5 3.38A8 8 0 0 1 10 2"
]);
const $bf8018481b255628$export$675800f615defa85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonCircleOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7L2.15 2.85a.5.5 0 0 1 0-.7M4.7 5.42a7 7 0 0 0 9.87 9.87l-1.47-1.47-.32.3c-.74.59-1.74.88-2.79.88a4.4 4.4 0 0 1-2.79-.88A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5h1.8zM10 2a8 8 0 0 1 6.62 12.5l-.73-.73A7 7 0 0 0 6.22 4.1l-.72-.72A8 8 0 0 1 10 2m2.5 8c.83 0 1.5.67 1.5 1.5q0 .18-.02.36L12.12 10zM10 5a2 2 0 0 1 .9 3.78L8.22 6.1A2 2 0 0 1 10 5"
]);
const $bf8018481b255628$export$ff022caff19fa62a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonClockFilled', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h6.26a5.5 5.5 0 0 0-.05 6.94Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $bf8018481b255628$export$14b9137cc3a3a15f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonClockRegular', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 13a2 2 0 0 1 2-2h6.26q-.39.46-.66 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17l.6-.01q.25.51.61.95Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $bf8018481b255628$export$de76c390b16a1dfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonDeleteFilled', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h6.26a5.5 5.5 0 0 0-.05 6.94Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bf8018481b255628$export$a22356b8c6885bd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonDeleteRegular', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 13a2 2 0 0 1 2-2h6.26q-.39.46-.66 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17l.6-.01q.25.51.61.95Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bf8018481b255628$export$73bb9fffa7b1ccfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonDesktopFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q.36 0 .72-.02A2 2 0 0 1 9 16v-4q0-.54.27-1zm5 1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-1h-2a1 1 0 0 1-1-1z"
]);
const $bf8018481b255628$export$8b61b606c165c9d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonDesktopRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q.36 0 .72-.02a2 2 0 0 1-1.47-1 7.6 7.6 0 0 1-3.58-1.03A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h4q0-.54.27-1zm5 1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-1h-2a1 1 0 0 1-1-1z"
]);
const $bf8018481b255628$export$6f0a1f1e7dea7d9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonEditFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a8.5 8.5 0 0 0 3.88 1.16q0-.15.05-.3l.37-1.5a3 3 0 0 1 .84-1.49L13.94 11zm5.98 4.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $bf8018481b255628$export$f89337428b41a8b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonEditRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a8.5 8.5 0 0 0 3.88 1.16q0-.15.05-.3l.17-.68a7.6 7.6 0 0 1-3.56-1.03A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h7.94l1-1zm5.98 4.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $bf8018481b255628$export$66339d6ef3f9baa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonErrorFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-4.24 1a5.5 5.5 0 0 0-.05 6.94Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2zm4.24 4.88a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.25m0-3.88a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5M9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $bf8018481b255628$export$e1ba15b618f51712 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonErrorRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-4.24 1q-.39.46-.66 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17l.6-.01q.25.51.61.95Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2zm4.24 4.88a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.25m0-3.88a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5M9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bf8018481b255628$export$607021f396cf7803 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonFeedbackColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_feedback_20_color__a)",
            "d": "M10.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_feedback_20_color__b)",
            "d": "M10.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_feedback_20_color__c)",
            "d": "M7 5.5A2.75 2.75 0 1 1 7 11a2.75 2.75 0 0 1 0-5.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_feedback_20_color__d)",
            "fillRule": "evenodd",
            "d": "M12 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2v1.23a.78.78 0 0 0 1.4.48L14.72 8H16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_feedback_20_color__a",
                "x1": "4.38",
                "x2": "6.62",
                "y1": "12.8",
                "y2": "18.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_feedback_20_color__b",
                "x1": "7",
                "x2": "10.16",
                "y1": "11.29",
                "y2": "21.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_feedback_20_color__c",
                "x1": "5.56",
                "x2": "8.36",
                "y1": "6.23",
                "y2": "10.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_feedback_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(49.6 4.58 8.6)scale(14.8043 26.6633)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fab500"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#fe8401"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$939da7042d9aadc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonFeedbackFilled', "1em", [
    "M10.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5zM7 5.5A2.75 2.75 0 1 1 7 11a2.75 2.75 0 0 1 0-5.5M16 2a2 2 0 0 1 2 1.85V6a2 2 0 0 1-1.85 2H14.5l-1.2 1.6a1 1 0 0 1-1.78-.38l-.01-.1V9l-.01-1.07-.08-.01a2 2 0 0 1-1.4-1.6l-.01-.17L10 6V4a2 2 0 0 1 1.85-2H16"
]);
const $bf8018481b255628$export$39efe5205b3a2237 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonFeedbackRegular', "1em", [
    "M10.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5zm0 1h-7a.5.5 0 0 0-.5.5v.5c0 1.44 1.43 3 4 3s4-1.56 4-3v-.5a.5.5 0 0 0-.5-.5M7 5.5A2.75 2.75 0 1 1 7 11a2.75 2.75 0 0 1 0-5.5M16 2a2 2 0 0 1 2 1.85V6a2 2 0 0 1-1.85 2H14.5l-1.2 1.6a1 1 0 0 1-1.78-.38l-.01-.1V9l-.01-1.07-.08-.01a2 2 0 0 1-1.4-1.6l-.01-.17L10 6V4a2 2 0 0 1 1.85-2H16M7 6.5A1.75 1.75 0 1 0 7 10a1.75 1.75 0 0 0 0-3.5M16 3h-4a1 1 0 0 0-1 .88V6a1 1 0 0 0 .88 1h.62v2L14 7h2a1 1 0 0 0 1-.88V4a1 1 0 0 0-.88-1z"
]);
const $bf8018481b255628$export$b4824da17a93310b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonGuestFilled', "1em", [
    "M17 10a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2zm-5.83 1a3 3 0 0 0-.17 1v5a3 3 0 0 0 .11.82Q10.1 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2zm3.33 1a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $bf8018481b255628$export$2eac4ab71627380d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonGuestRegular', "1em", [
    "M17 10a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2zm-5.83 1a3 3 0 0 0-.17 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17q1.06 0 2-.18V17a3 3 0 0 0 .11.82Q10.1 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2zm3.33 1a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bf8018481b255628$export$77af72e48bc685b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHeadHintFilled', "1em", [
    "M10.75 1.63c0-.3.27-.54.57-.47q.81.2 1.52.63c.26.16.29.52.07.74a.55.55 0 0 1-.67.07q-.5-.3-1.07-.45a.55.55 0 0 1-.42-.52M5.13 7.25c.25 0 .46.18.52.42q.16.57.45 1.08c.12.21.1.49-.07.66-.22.22-.58.2-.74-.07q-.43-.7-.63-1.52c-.08-.3.16-.57.47-.57m9.58-3.6c-.16-.25-.52-.28-.74-.06a.55.55 0 0 0-.07.66q.3.51.44 1.08c.07.24.28.42.53.42.3 0 .54-.27.47-.57a6 6 0 0 0-.63-1.52m.16 3.6c.3 0 .54.27.47.57a6 6 0 0 1-.63 1.52c-.16.26-.52.29-.74.07a.55.55 0 0 1-.07-.66q.3-.51.44-1.08a.55.55 0 0 1 .53-.42m-9.74-1.5c.25 0 .46-.18.52-.42q.16-.57.45-1.08a.55.55 0 0 0-.07-.66c-.22-.22-.58-.2-.74.07q-.43.7-.63 1.52c-.08.3.16.57.47.57m4.12-4.12c0 .25-.18.46-.42.52q-.57.16-1.08.45a.55.55 0 0 1-.66-.07c-.22-.22-.2-.58.07-.74q.7-.43 1.52-.63c.3-.07.57.16.57.47M5 11A2 2 0 0 0 3 13c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2zM10 9.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
]);
const $bf8018481b255628$export$6f3d2239f963915b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHeadHintRegular', "1em", [
    "M10.75 1.63c0-.3.27-.54.57-.47q.81.2 1.52.63c.26.16.29.52.07.74a.55.55 0 0 1-.67.07q-.5-.3-1.07-.45a.55.55 0 0 1-.42-.52M5.13 7.25c.25 0 .46.18.52.42q.16.57.45 1.08c.12.21.1.49-.07.66-.22.22-.58.2-.74-.07q-.43-.7-.63-1.52c-.08-.3.16-.57.47-.57m9.58-3.6c-.16-.25-.52-.28-.74-.06a.55.55 0 0 0-.07.66q.3.51.44 1.08c.07.24.28.42.53.42.3 0 .54-.27.47-.57a6 6 0 0 0-.63-1.52m.16 3.6c.3 0 .54.27.47.57a6 6 0 0 1-.63 1.52c-.16.26-.52.29-.74.07a.55.55 0 0 1-.07-.66q.3-.51.44-1.08a.55.55 0 0 1 .53-.42m-9.74-1.5c.25 0 .46-.18.52-.42q.16-.57.45-1.08a.55.55 0 0 0-.07-.66c-.22-.22-.58-.2-.74.07q-.43.7-.63 1.52c-.08.3.16.57.47.57m4.12-4.12c0 .25-.18.46-.42.52q-.57.16-1.08.45a.55.55 0 0 1-.66-.07c-.22-.22-.2-.58.07-.74q.7-.43 1.52-.63c.3-.07.57.16.57.47M5 11A2 2 0 0 0 3 13c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2zM4 13a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1c0 1.3-.62 2.28-1.67 2.95A8 8 0 0 1 10 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 4 13m4-6.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bf8018481b255628$export$bec3c84641c6008b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHeartColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_heart_20_color__a)",
            "d": "M14.5 13.5a2 2 0 0 0-2-2V11H4a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-.45-1.26 2 2 0 0 0-1.05 1.76"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_heart_20_color__b)",
            "d": "M14.5 13.5a2 2 0 0 0-2-2V11H4a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-.45-1.26 2 2 0 0 0-1.05 1.76"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_heart_20_color__c)",
            "fillOpacity": ".5",
            "d": "M14.5 13.5a2 2 0 0 0-2-2V11H4a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-.45-1.26 2 2 0 0 0-1.05 1.76"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_heart_20_color__d)",
            "d": "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_heart_20_color__e)",
            "d": "m14.5 12-.63-.49a2.4 2.4 0 0 0-3.24 3.5l3.5 3.83c.2.22.54.22.74 0l3.5-3.83a2.4 2.4 0 0 0-3.24-3.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_heart_20_color__a",
                "x1": "5.33",
                "x2": "7.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_heart_20_color__b",
                "x1": "9",
                "x2": "12.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_heart_20_color__d",
                "x1": "6.9",
                "x2": "10.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_heart_20_color__e",
                "x1": "11",
                "x2": "16.2",
                "y1": "11.5",
                "y2": "20.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_heart_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.6163 4.29618 -2.5808 3.37382 15 15.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$6dcbf57638a151da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHeartFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q1.44 0 2.72-.31l-1.83-2a3.4 3.4 0 0 1 .1-4.69zm10.5 1-.63-.49a2.4 2.4 0 0 0-3.24 3.5l3.5 3.83c.2.22.54.22.74 0l3.5-3.83a2.4 2.4 0 0 0-3.24-3.5z"
]);
const $bf8018481b255628$export$b6b362ead090f286 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHeartRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q1.44 0 2.72-.31l-.78-.86Q10.03 17 9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.3a3 3 0 0 1 .69-1zm10.5 1-.63-.49a2.4 2.4 0 0 0-3.24 3.5l3.5 3.83c.2.22.54.22.74 0l3.5-3.83a2.4 2.4 0 0 0-3.24-3.5z"
]);
const $bf8018481b255628$export$9b375eba8f2da794 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHomeFilled', "1em", [
    "M13.84 10.25a1 1 0 0 1 1.32 0l3.5 3.11a1 1 0 0 1 .34.75v4.4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-4.4a1 1 0 0 1 .34-.75zm-4.17 2.37a2 2 0 0 0-.67 1.5v3.84a8.5 8.5 0 0 1-3.87-1.16A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2h6.49zM10 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $bf8018481b255628$export$ff930dd58451adb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonHomeRegular', "1em", [
    "M13.84 10.25a1 1 0 0 1 1.32 0l3.5 3.11a1 1 0 0 1 .34.75v4.4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-4.4a1 1 0 0 1 .34-.75zM10.36 12H5.01A1 1 0 0 0 4 13c0 1.3.62 2.28 1.67 2.95.86.55 2.01.9 3.33 1v1.01a8.5 8.5 0 0 1-3.87-1.16A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2h6.49zM10 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bf8018481b255628$export$7c207696d7bb72e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonInfoFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm9.88 1.5a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0m1.12 4a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0zm-5-2a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m1 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0"
]);
const $bf8018481b255628$export$c7e7c7d56df5213e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonInfoRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm9.88 1.5a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0m1.12 4a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0zm-5-2a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m1 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0"
]);
const $bf8018481b255628$export$105dad358e8c694a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonKeyColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_key_20_color__a)",
            "d": "M15 11v3l-3.96 3.96Q10.53 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_key_20_color__b)",
            "d": "M15 11v3l-3.96 3.96Q10.53 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_key_20_color__c)",
            "fillOpacity": ".75",
            "d": "M15 11v3l-3.96 3.96Q10.53 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_key_20_color__d)",
            "fillOpacity": ".75",
            "d": "M15 11v3l-3.96 3.96Q10.53 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_key_20_color__e)",
            "d": "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_key_20_color__f)",
            "d": "M10.15 18.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_key_20_color__a",
                "x1": "6.33",
                "x2": "8.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_key_20_color__b",
                "x1": "10",
                "x2": "13.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_key_20_color__e",
                "x1": "7.9",
                "x2": "11.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_key_20_color__f",
                "x1": "19.01",
                "x2": "10.46",
                "y1": "19",
                "y2": "12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_key_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-59.93 24.03 -.59)scale(10.9772 6.09215)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_key_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -4 5.375 0 16.5 13.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$65975c316f84a505 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonKeyFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A8.5 8.5 0 0 0 9 17.96V17q.01-.63.44-1.06l2.58-2.58-.02-.42a3.7 3.7 0 0 1 .53-1.94zm5.15 7.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
]);
const $bf8018481b255628$export$aa1113c57b2de6a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonKeyRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A8.5 8.5 0 0 0 9 17.96v-1a7.4 7.4 0 0 1-3.33-1A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h7.11a4 4 0 0 1 .42-1zm5.15 7.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
]);
const $bf8018481b255628$export$1d1d8ce0871cde85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLightbulbFilled', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h6.54a4 4 0 0 0 .85 5.03l.33 1.66q-1.28.3-2.72.31a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m15 0a3 3 0 0 1-1.3 2.47l-.1.53h-3.2l-.1-.53A3 3 0 1 1 18 13m-4.4 4 .24 1.2c.1.46.5.8.98.8h.36a1 1 0 0 0 .98-.8l.24-1.2z"
]);
const $bf8018481b255628$export$59f33781ec819ac4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLightbulbRegular', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 13a2 2 0 0 1 2-2h6.54q-.27.46-.41 1H5A1 1 0 0 0 4 13c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 10 17q1.37 0 2.52-.3l.2.99q-1.28.3-2.72.31a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m15 0a3 3 0 0 1-1.3 2.47l-.1.53h-3.2l-.1-.53A3 3 0 1 1 18 13m-4.4 4 .24 1.2c.1.46.5.8.98.8h.36a1 1 0 0 0 .98-.8l.24-1.2z"
]);
const $bf8018481b255628$export$aebed09816be29ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLightningFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q.9 0 1.75-.12l.22-.88h-.47a1.5 1.5 0 0 1-1.38-2.08L11.75 11zm7.61 5c.33 0 .57.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-.4a.5.5 0 0 1-.48-.66l.56-1.68a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7z"
]);
const $bf8018481b255628$export$4dc694706bb83760 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLightningRegular', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 13a2 2 0 0 1 2-2h6.75l-.42 1H5.01A1 1 0 0 0 4 13c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 10 17h1.97l-.22.88Q10.9 18 10 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 13m9.61 3c.33 0 .57.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-.4a.5.5 0 0 1-.48-.66l.56-1.68a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7z"
]);
const $bf8018481b255628$export$52761b3865d6cafc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLinkFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a9 9 0 0 0 5.2 1.2 3.5 3.5 0 0 1 3.17-5H16a2 2 0 0 0-2-2zm8.5 3a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $bf8018481b255628$export$2e36987d92139eb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLinkRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a9 9 0 0 0 5.2 1.2 4 4 0 0 1-.3-1H9a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm8.5 3a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $bf8018481b255628$export$2cad6c82dc88ba32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLockFilled', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h8.67a3 3 0 0 0-.17 1v.06A2 2 0 0 0 11 14v3.84q-.96.16-2 .16a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m11.5 0v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm1-1v1h2v-1a1 1 0 1 0-2 0m1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $bf8018481b255628$export$c2281499b4be5b2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonLockRegular', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 13a2 2 0 0 1 2-2h8.67a3 3 0 0 0-.17 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17q1.06 0 2-.18v1.02q-.96.16-2 .16a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m11.5 0v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm1-1v1h2v-1a1 1 0 1 0-2 0m1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $bf8018481b255628$export$3c115fd808aea46b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonMailFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18v-5c0-1.1.9-2 2-2zm10.51 4.93-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3.05l4.25 2.48q.24.14.49.01"
]);
const $bf8018481b255628$export$14e092012b50ee02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonMailRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18v-1a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.27A2 2 0 0 1 11 11zm10.51 4.93-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3.05l4.25 2.48q.24.14.49.01"
]);
const $bf8018481b255628$export$acef695fcaf2a905 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonMoneyFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A8.5 8.5 0 0 0 9 17.96V14c0-1.1.9-2 2-2h5.73A2 2 0 0 0 15 11zm14 3.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5m-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5m0-3a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5zm-6.5-.5a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm3.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $bf8018481b255628$export$7e1556ec8f53a9a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonMoneyRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A8.5 8.5 0 0 0 9 17.96v-1a7.4 7.4 0 0 1-3.33-1A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h11.73A2 2 0 0 0 15 11zm14 3.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5m-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5m0-3a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5zm-6.5-.5a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm3.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $bf8018481b255628$export$80c80782b8197f01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonNoteFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8 1.1.69 2.5 1.07 4.03 1.17A3 3 0 0 1 9 17v-4c0-.77.29-1.47.76-2zm5 2c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
]);
const $bf8018481b255628$export$7947ef058f15276e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonNoteRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8 1.1.69 2.5 1.07 4.03 1.17A3 3 0 0 1 9 17v-.04a7.4 7.4 0 0 1-3.33-1A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h4.17a3 3 0 0 1 .6-1zm5 2c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
]);
const $bf8018481b255628$export$37ea81c192fb8071 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonPasskeyFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18a9 9 0 0 0 5.14-1.4v-2.22c-1.19-.65-2-1.92-2-3.38zm9 0a3 3 0 0 0 2 2.83v5.03q0 .16.1.27l.6.73c.16.2.46.2.63.03l1.54-1.57a.43.43 0 0 0-.02-.62l-1.35-1.2 1.35-1.18c.2-.17.2-.47 0-.64l-.94-.82A3 3 0 1 0 14 11m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $bf8018481b255628$export$fe1e0c9d68d17cb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonPasskeyRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18a9 9 0 0 0 5.14-1.4v-1.32q-.35.38-.81.67A8 8 0 0 1 10 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h8.27a4 4 0 0 1-.13-1zm9 0a3 3 0 0 0 1.92 2.8l.08.03v5.03q0 .16.1.27l.6.73c.16.2.46.2.63.03l1.54-1.57a.43.43 0 0 0-.02-.62l-1.35-1.2 1.35-1.18c.2-.17.2-.47 0-.64l-.94-.82A3 3 0 1 0 14 11m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $bf8018481b255628$export$53055dbc96a36f51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonPillFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m2.88 9-2.94 2.94a3.6 3.6 0 0 0-.75 4.03 8.6 8.6 0 0 1-4.06-1.17A4.4 4.4 0 0 1 3 13a2 2 0 0 1 2-2zm5.47-.35a2.6 2.6 0 0 0-3.7 0l-4 4a2.62 2.62 0 0 0 3.7 3.7l4-4a2.6 2.6 0 0 0 0-3.7m-3 .7a1.62 1.62 0 1 1 2.3 2.3L16 15.29 13.7 13zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0"
]);
const $bf8018481b255628$export$250adcfc636dfc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonPillRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m5.88 5H5A2 2 0 0 0 3 13c0 1.7.83 2.97 2.13 3.8 1.1.7 2.52 1.08 4.06 1.17a4 4 0 0 1-.28-1.02 7.4 7.4 0 0 1-3.24-1A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h6.88zm5.47-.35a2.6 2.6 0 0 0-3.7 0l-4 4a2.62 2.62 0 0 0 3.7 3.7l4-4a2.6 2.6 0 0 0 0-3.7m-3 .7a1.62 1.62 0 1 1 2.3 2.3L16 15.29 13.7 13zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0"
]);
const $bf8018481b255628$export$48b63a81b92dc344 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonProhibitedFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm6 3.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m2.4 2.8 4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-5.6 2.8m-.7-.7a3.5 3.5 0 0 1 4.9-4.9z"
]);
const $bf8018481b255628$export$201eca1f84b0d143 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonProhibitedRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm6 3.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m2.4 2.8 4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-5.6 2.8m-.7-.7a3.5 3.5 0 0 1 4.9-4.9z"
]);
const $bf8018481b255628$export$62d7adc4b7a4f2fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonQuestionMarkFilled', "1em", [
    "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.62-2a.62.62 0 1 1-1.24 0 .62.62 0 0 1 1.24 0m1.23-3.55c0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 0 1-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 1 1-1 0c-.01-1.13.8-1.95 1.85-1.95 1.03 0 1.85.85 1.85 1.95M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94z"
]);
const $bf8018481b255628$export$5361b96149363d92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonQuestionMarkRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm10.5 8a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.62-2a.62.62 0 1 0-1.24 0 .62.62 0 0 0 1.24 0m1.23-3.55c0-1.1-.82-1.95-1.85-1.95-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32"
]);
const $bf8018481b255628$export$67ced3dcd438f6b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonRibbonFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q1.6 0 3-.39v-1.96a4 4 0 0 1-.47-4.65zm11 5a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1q1.1-.02 2-.54v2.29c0 .2-.21.31-.38.21L16 18l-1.62.96a.25.25 0 0 1-.38-.21v-2.29q.9.52 2 .54"
]);
const $bf8018481b255628$export$4c758cb22c9bdfdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonRibbonRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18q1.6 0 3-.39v-1.04c-.87.28-1.9.43-3 .43a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h7.13q.14-.54.4-1zm11 5a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1q1.1-.02 2-.54v2.29c0 .2-.21.31-.38.21L16 18l-1.62.96a.25.25 0 0 1-.38-.21v-2.29q.9.52 2 .54"
]);
const $bf8018481b255628$export$7c7a6cac7a57553 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonRunningFilled', "1em", [
    "M11.5 4.5a2 2 0 1 1 2.61 1.9l1.6 1.6h1.79a1.5 1.5 0 0 1 0 3h-3.22c-.63 0-1.24-.25-1.68-.7l-.1-.1-1.04 1.05 1.4 1.4q.14.14.14.35v3.5a1.5 1.5 0 0 1-3 0v-1.8l-1.55-1.54-1 .75c-.5.38-1.13.59-1.76.59H2.5a1.5 1.5 0 0 1 0-3h4.25c1.24 0 2.25-1 2.25-2.25V8h1a.5.5 0 0 0 0-1H8.5a.5.5 0 0 0-.5.5v1.75a1.25 1.25 0 1 1-2.5 0V7A2.5 2.5 0 0 1 8 4.5z"
]);
const $bf8018481b255628$export$6075fc7ab411e3f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonRunningRegular', "1em", [
    "M13.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m1.33.62A2.5 2.5 0 1 0 11 4.5H8A2.5 2.5 0 0 0 5.5 7v1.75c0 .69.4 1.28.97 1.57L5.8 11H2.75a1.75 1.75 0 1 0 0 3.5h2.94c.63 0 1.25-.2 1.76-.59l1-.75L10 14.71v1.54a1.75 1.75 0 1 0 3.5 0V13a.5.5 0 0 0-.15-.35L11.71 11l.79-.8.1.1c.44.45 1.05.7 1.68.7h2.97a1.75 1.75 0 1 0 0-3.5h-1.54zm-1.05.36 1.37 1.37q.14.15.35.15h1.75a.75.75 0 0 1 0 1.5h-2.97q-.57-.01-.98-.4l-.45-.45a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 0 .7l1.85 1.86v3.04a.75.75 0 0 1-1.5 0V14.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.65-.05l-1.35 1.01q-.51.38-1.16.39H2.75a.75.75 0 0 1 0-1.5H6a.5.5 0 0 0 .35-.15l1.44-1.44C8.5 10.2 9 9.53 9 8.75V8h1a.5.5 0 0 0 0-1H8.5a.5.5 0 0 0-.5.5v1.25a.75.75 0 0 1-1.5 0V7c0-.83.67-1.5 1.5-1.5h3.2a2.5 2.5 0 0 0 2.58 1.48"
]);
const $bf8018481b255628$export$9782cd9540b2c7f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSearchFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m4.87 14.8a8.5 8.5 0 0 1-3.97 1.17 2 2 0 0 0-.34-.53l-2-2A4.5 4.5 0 0 0 8.24 11H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bf8018481b255628$export$41be2774f698fa0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSearchRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m7.87 10.8a8.5 8.5 0 0 1-3.97 1.17 2 2 0 0 0-.34-.53l-.44-.44a8 8 0 0 0 4.2-1.05A3.4 3.4 0 0 0 16 13a1 1 0 0 0-1-1H8.74q-.19-.54-.5-1H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bf8018481b255628$export$ebdcb8bc42340396 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSettingsFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm6.64 2.92a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $bf8018481b255628$export$808dea25831a3d47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSettingsRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm6.64 2.92a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $bf8018481b255628$export$711cb89a4783900d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonShieldFilled', "1em", [
    "M14.12 10.14c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.42.24.03.44.2.44.44v2.1c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.05V12c0-.23.2-.41.44-.44a5 5 0 0 0 2.68-1.42m-3.63.86q-.47.37-.49 1v2.1c0 1.66.79 2.82 1.67 3.6Q10.42 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2zM9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $bf8018481b255628$export$bc42215f0884b7c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonShieldRegular', "1em", [
    "M10.3 11q-.29.34-.3.81V12H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17q1.07 0 2-.18.38.45.8.8l.04.03Q10.51 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13a2 2 0 0 1 2-2zm3.82-1.04c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4M9 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bf8018481b255628$export$fcc9f56fab61a533 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSoundSpatialFilled', "1em", [
    "M2.87 9.17a.54.54 0 0 0 .02.72c.2.2.51.2.69-.02a6 6 0 0 0 0-7.74.47.47 0 0 0-.7-.02c-.19.2-.19.51-.01.73a5 5 0 0 1 0 6.33m-1.4-.7c.2.2.52.2.69-.02a4 4 0 0 0 0-4.9c-.17-.22-.5-.22-.69-.02-.2.19-.19.5-.03.73a3 3 0 0 1 0 3.48c-.16.23-.16.54.03.73M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2zm11.42-8.87a6 6 0 0 0 0 7.74c.18.22.5.21.7.02.19-.2.18-.51 0-.72a5 5 0 0 1 0-6.33.54.54 0 0 0 0-.73.47.47 0 0 0-.7.02m1.42 1.42c.17-.22.49-.22.69-.02.19.19.19.5.03.73a3 3 0 0 0 0 3.48c.16.23.16.54-.03.73-.2.2-.52.2-.69-.02a4 4 0 0 1 0-4.9"
]);
const $bf8018481b255628$export$1d543cb772057145 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSoundSpatialRegular', "1em", [
    "M2.87 9.17a.54.54 0 0 0 .02.72c.2.2.51.2.69-.02a6 6 0 0 0 0-7.74.47.47 0 0 0-.7-.02c-.19.2-.19.51-.01.73a5 5 0 0 1 0 6.33m-1.4-.7c.2.2.52.2.69-.02a4 4 0 0 0 0-4.9c-.17-.22-.5-.22-.69-.02-.2.19-.19.5-.03.73a3 3 0 0 1 0 3.48c-.16.23-.16.54.03.73M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1c0 1.3-.62 2.28-1.67 2.95A8 8 0 0 1 10 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 4 13M16.42 2.13a6 6 0 0 0 0 7.74c.18.22.5.21.7.02.19-.2.18-.51 0-.72a5 5 0 0 1 0-6.33.54.54 0 0 0 0-.73.47.47 0 0 0-.7.02m1.42 1.42c.17-.22.49-.22.69-.02.19.19.19.5.03.73a3 3 0 0 0 0 3.48c.16.23.16.54-.03.73-.2.2-.52.2-.69-.02a4 4 0 0 1 0-4.9"
]);
const $bf8018481b255628$export$5b35a43b02192a39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSquareFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm7-1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.74.6 1.74.89 2.79.89s2.05-.29 2.79-.89S14 12.61 14 11.5c0-.83-.67-1.5-1.5-1.5"
]);
const $bf8018481b255628$export$515bcf5cd388b0b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSquareRegular', "1em", [
    "M10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.74.6 1.74.89 2.79.89s2.05-.29 2.79-.89S14 12.61 14 11.5c0-.83-.67-1.5-1.5-1.5M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);
const $bf8018481b255628$export$5b161c648019c32c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSquareAddFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6a6 6 0 0 1-.58-2.09q-1.03-.19-1.8-.8A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5h3.84A5.5 5.5 0 0 1 17 9.6V6a3 3 0 0 0-3-3zm2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bf8018481b255628$export$514b6d92cff7cc2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSquareAddRegular', "1em", [
    "M8 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m1.02 7.91L9 14.5c0-1.86.92-3.5 2.34-4.5H7.5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.5.41 1.13.67 1.8.8M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6q-.48-.24-1-.4V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.2q.16.52.4 1H6a3 3 0 0 1-3-3zm16 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bf8018481b255628$export$3476d95200fbbb0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSquareCheckmarkFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6a5.5 5.5 0 0 0-5.66.4H7.5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.5.41 1.13.67 1.8.8q.1 1.13.59 2.09H6a3 3 0 0 1-3-3zm7-1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bf8018481b255628$export$f130519e03b7dcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSquareCheckmarkRegular', "1em", [
    "M10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-1 9.5q0 .21.02.41-1.03-.19-1.8-.8A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5h3.84A5.5 5.5 0 0 0 9 14.5M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6q-.24-.48-.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.2q.52.16 1 .4V6a3 3 0 0 0-3-3zm13 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bf8018481b255628$export$cc114b45f304a0f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonStarFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm15 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54z"
]);
const $bf8018481b255628$export$6d853b1beaf8921f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonStarRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm15 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54z"
]);
const $bf8018481b255628$export$41754f961a1d6dd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonStarburstColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_starburst_20_color__a)",
            "d": "m8.46 1.9.99.39q.54.21 1.1 0l.99-.4c1.2-.47 2.58.1 3.1 1.3l.42.97q.24.54.78.77l.98.43c1.19.52 1.76 1.89 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.39.99a2.4 2.4 0 0 1-1.28 3.1l-.98.43a1.5 1.5 0 0 0-.78.77l-.42.98a2.4 2.4 0 0 1-3.1 1.28l-1-.39a1.5 1.5 0 0 0-1.1 0l-.98.4a2.4 2.4 0 0 1-3.1-1.3l-.43-.97a1.5 1.5 0 0 0-.77-.77l-.98-.43a2.4 2.4 0 0 1-1.28-3.1l.38-.99a1.5 1.5 0 0 0 0-1.1l-.38-.99a2.4 2.4 0 0 1 1.28-3.1l.98-.43q.53-.24.77-.77l.43-.98a2.4 2.4 0 0 1 3.1-1.28"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_starburst_20_color__b)",
            "fillOpacity": ".7",
            "d": "m8.46 1.9.99.39q.54.21 1.1 0l.99-.4c1.2-.47 2.58.1 3.1 1.3l.42.97q.24.54.78.77l.98.43c1.19.52 1.76 1.89 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.39.99a2.4 2.4 0 0 1-1.28 3.1l-.98.43a1.5 1.5 0 0 0-.78.77l-.42.98a2.4 2.4 0 0 1-3.1 1.28l-1-.39a1.5 1.5 0 0 0-1.1 0l-.98.4a2.4 2.4 0 0 1-3.1-1.3l-.43-.97a1.5 1.5 0 0 0-.77-.77l-.98-.43a2.4 2.4 0 0 1-1.28-3.1l.38-.99a1.5 1.5 0 0 0 0-1.1l-.38-.99a2.4 2.4 0 0 1 1.28-3.1l.98-.43q.53-.24.77-.77l.43-.98a2.4 2.4 0 0 1 3.1-1.28"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_starburst_20_color__c)",
            "fillOpacity": ".9",
            "d": "M8 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5 3h5c.82 0 1.5.67 1.5 1.5 0 1.11-.47 2-1.22 2.61-.74.6-1.73.89-2.79.89a4.4 4.4 0 0 1-2.79-.89A3.3 3.3 0 0 1 6 11.5c0-.83.66-1.5 1.5-1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_starburst_20_color__a",
                "x1": "4.48",
                "x2": "12.75",
                "y1": ".81",
                "y2": "19.19",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1ec8b0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_starburst_20_color__b",
                "x1": "12.56",
                "x2": "15.84",
                "y1": "3.76",
                "y2": "20.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_starburst_20_color__c",
                "x1": "16",
                "x2": "-1.56",
                "y1": "23.57",
                "y2": "-2.19",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$1cf28e697281d0d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonStarburstFilled', "1em", [
    "m9.45 2.29-1-.4a2.4 2.4 0 0 0-3.1 1.3l-.42.97a1.5 1.5 0 0 1-.77.77l-.98.43a2.4 2.4 0 0 0-1.28 3.1l.38 1c.14.34.14.74 0 1.09l-.38.99a2.4 2.4 0 0 0 1.28 3.1l.98.43q.53.23.77.77l.43.98a2.4 2.4 0 0 0 3.1 1.28l.99-.39a1.5 1.5 0 0 1 1.1 0l.99.4c1.2.47 2.58-.1 3.1-1.3l.42-.97q.24-.54.78-.77l.98-.43a2.4 2.4 0 0 0 1.28-3.1l-.39-.99a1.5 1.5 0 0 1 0-1.1l.39-.99a2.4 2.4 0 0 0-1.28-3.1l-.98-.43a1.5 1.5 0 0 1-.78-.77l-.42-.98a2.4 2.4 0 0 0-3.1-1.28l-1 .39a1.5 1.5 0 0 1-1.1 0m.54 2.7a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.5 5c.83 0 1.5.68 1.5 1.5 0 1.12-.46 2.02-1.21 2.62-.74.6-1.73.89-2.79.89a4.4 4.4 0 0 1-2.79-.89A3.3 3.3 0 0 1 6 11.5c0-.83.66-1.5 1.5-1.5z"
]);
const $bf8018481b255628$export$7ad9b48ae4b5ac93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonStarburstRegular', "1em", [
    "m9.45 2.29-1-.4a2.4 2.4 0 0 0-3.1 1.3l-.42.97a1.5 1.5 0 0 1-.77.77l-.98.43a2.4 2.4 0 0 0-1.28 3.1l.38 1c.14.34.14.74 0 1.09l-.38.99a2.4 2.4 0 0 0 1.28 3.1l.98.43q.53.23.77.77l.43.98a2.4 2.4 0 0 0 3.1 1.28l.99-.39a1.5 1.5 0 0 1 1.1 0l.99.4c1.2.47 2.58-.1 3.1-1.3l.42-.97q.24-.54.78-.77l.98-.43a2.4 2.4 0 0 0 1.28-3.1l-.39-.99a1.5 1.5 0 0 1 0-1.1l.39-.99a2.4 2.4 0 0 0-1.28-3.1l-.98-.43a1.5 1.5 0 0 1-.78-.77l-.42-.98a2.4 2.4 0 0 0-3.1-1.28l-1 .39a1.5 1.5 0 0 1-1.1 0m1.46.93 1-.4c.7-.27 1.5.06 1.81.76l.43.98a2.5 2.5 0 0 0 1.3 1.3l.97.42c.7.3 1.03 1.1.75 1.82l-.39.98a2.5 2.5 0 0 0 0 1.84l.39.99c.28.7-.05 1.51-.75 1.81l-.98.43a2.5 2.5 0 0 0-1.3 1.3l-.42.97c-.3.7-1.1 1.03-1.82.75l-.99-.39a2.5 2.5 0 0 0-1.83 0l-.99.4a1.4 1.4 0 0 1-1.82-.76l-.42-.98a2.5 2.5 0 0 0-1.3-1.3l-.97-.42c-.7-.3-1.03-1.1-.75-1.81l.39-1a2.5 2.5 0 0 0 0-1.83l-.4-.98c-.27-.72.06-1.52.76-1.82l.97-.43a2.5 2.5 0 0 0 1.3-1.3l.42-.97c.3-.7 1.11-1.03 1.82-.75l1 .39a2.5 2.5 0 0 0 1.82 0M10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.11.45 2 1.2 2.61S8.95 15 10 15s2.04-.3 2.78-.89c.76-.6 1.22-1.5 1.22-2.61 0-.83-.68-1.5-1.5-1.5"
]);
const $bf8018481b255628$export$abd2b9ea6c9e0745 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSubtractFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a9 9 0 0 0 5.13 1.2 5.5 5.5 0 0 1 0-7zm14 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7 0c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $bf8018481b255628$export$5ca8ae7035cd9294 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSubtractRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8a9 9 0 0 0 5.13 1.2 6 6 0 0 1-.66-1 8 8 0 0 1-3.93-1.05A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h4.6q.27-.54.66-1zm14 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7 0c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $bf8018481b255628$export$27c293bdad216ab2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSupportFilled', "1em", [
    "M10 14.5a2 2 0 0 1-2-1.84 6 6 0 1 1 7.98-6.16c.02.28-.2.5-.48.5a.54.54 0 0 1-.52-.5 5 5 0 1 0-6.8 5.16A2 2 0 1 1 10 14.5M5 12h.1a7 7 0 0 0 2.03 1.39A3 3 0 0 0 12.96 12H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 10 19a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 14a2 2 0 0 1 2-2m9-5a4 4 0 0 1-1.87 3.39 3 3 0 0 0-4.26 0A4 4 0 0 1 6 7a4 4 0 1 1 8 0"
]);
const $bf8018481b255628$export$7f8048d152fedfd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSupportRegular', "1em", [
    "M10 14.5a2 2 0 0 1-2-1.84 6 6 0 1 1 7.98-6.16c.02.28-.2.5-.48.5a.54.54 0 0 1-.52-.5 5 5 0 1 0-6.8 5.16A2 2 0 1 1 10 14.5M5 12h.1q.58.58 1.3 1H5a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 10 18c1.74 0 3.26-.36 4.33-1.05A3.4 3.4 0 0 0 16 14a1 1 0 0 0-1-1h-2.04a3 3 0 0 0 0-1H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 10 19a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 3 14a2 2 0 0 1 2-2m9-5a4 4 0 0 1-1.87 3.39 3 3 0 0 0-.93-.64 3 3 0 1 0-2.4 0 3 3 0 0 0-.93.64A4 4 0 0 1 6 7a4 4 0 1 1 8 0"
]);
const $bf8018481b255628$export$76d410cfc2f310b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSwapFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.43 0 .85-.03l-1.41-1.4a1.5 1.5 0 0 1 0-2.13l2-2A1.5 1.5 0 0 1 12.9 14h1.18a1.5 1.5 0 0 1 1.65-1.98A2 2 0 0 0 14 11zm7.85 6.85a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7"
]);
const $bf8018481b255628$export$baeaf95f67d3145e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSwapRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.43 0 .85-.03L8.88 17a8 8 0 0 1-4.2-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h10a1 1 0 0 1 .67.25q.5-.33 1.07-.23A2 2 0 0 0 14 11zm7.85 6.85a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7"
]);
const $bf8018481b255628$export$da455f0f652ef2a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSyncFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06a5.5 5.5 0 0 1 .05-6.94zm6 3.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $bf8018481b255628$export$dc7ee91107b74945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonSyncRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q.62 0 1.21-.06A6 6 0 0 1 9.6 17L9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5.6q.27-.54.66-1zm6 3.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $bf8018481b255628$export$2848726647996829 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonTagFilled', "1em", [
    "M5 6a4 4 0 1 1 6.65 3h-.14c-.8 0-1.52.38-1.98.96Q9.27 10 9 10a4 4 0 0 1-4-4m4.05 5H4.01A2 2 0 0 0 2 13c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q1.2 0 2.31-.22l-1.6-1.63A2.5 2.5 0 0 1 9 14.4v-2.87q0-.27.05-.52m.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 0 0-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51zm2.75-.9a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $bf8018481b255628$export$f67765dd8ff22ffe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonTagRegular', "1em", [
    "M5 6a4 4 0 1 1 6.65 3h-.14c-.8 0-1.52.38-1.98.96Q9.27 10 9 10a4 4 0 0 1-4-4m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6m.05 8H4.01A2 2 0 0 0 2 13c0 1.7.83 2.97 2.14 3.8A9 9 0 0 0 9 18q1.2 0 2.31-.22l-.85-.87Q9.76 17 9 17a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h5v-.48q0-.27.05-.52m.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 0 0-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51zm2.75-.9a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $bf8018481b255628$export$a4bb1c72a581510a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonTentativeColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_tentative_20_color__a)",
            "d": "M11.67 11H4.01A2 2 0 0 0 2 13c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q1.26 0 2.4-.24a4.5 4.5 0 0 1 .27-6.76"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_tentative_20_color__b)",
            "d": "M11.67 11H4.01A2 2 0 0 0 2 13c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q1.26 0 2.4-.24a4.5 4.5 0 0 1 .27-6.76"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_tentative_20_color__c)",
            "fillOpacity": ".5",
            "d": "M11.67 11H4.01A2 2 0 0 0 2 13c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q1.26 0 2.4-.24a4.5 4.5 0 0 1 .27-6.76"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_tentative_20_color__d)",
            "d": "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_tentative_20_color__e)",
            "d": "M14.5 10h.28l-4.77 4.78-.01-.28a4.5 4.5 0 0 1 4.5-4.5m-3.52 7.3a5 5 0 0 1-.74-1.34l5.61-5.6.1-.12q.75.26 1.36.74zm7.78-4.26q-.27-.75-.74-1.35l-6.33 6.33q.61.48 1.37.74l.09-.11zm-4.54 5.95.28.01a4.5 4.5 0 0 0 4.5-4.78z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_tentative_20_color__a",
                "x1": "5.33",
                "x2": "7.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_tentative_20_color__b",
                "x1": "9",
                "x2": "12.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_tentative_20_color__d",
                "x1": "6.9",
                "x2": "10.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_tentative_20_color__e",
                "x1": "10",
                "x2": "19.75",
                "y1": "10.28",
                "y2": "19.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_tentative_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 7.5 -6 0 15 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".42",
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$c4a50408965b1753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonTentativeFilled', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h6.26a5.5 5.5 0 0 0-.05 6.94Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m12.5-3h.28l-4.77 4.78-.01-.28a4.5 4.5 0 0 1 4.5-4.5m-3.52 7.3a5 5 0 0 1-.74-1.34l5.61-5.6.1-.12q.75.26 1.36.74zm7.78-4.26q-.27-.75-.74-1.35l-6.33 6.33q.61.48 1.37.74l.09-.11zm-4.54 5.95.28.01a4.5 4.5 0 0 0 4.5-4.78z"
]);
const $bf8018481b255628$export$870a5528279372a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonTentativeRegular', "1em", [
    "M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 13a2 2 0 0 1 2-2h6.26q-.39.46-.66 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17l.6-.01q.25.51.61.95Q9.61 18 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m12.5-3h.28l-4.77 4.78-.01-.28a4.5 4.5 0 0 1 4.5-4.5m-3.52 7.3a5 5 0 0 1-.74-1.34l5.61-5.6.1-.12q.75.26 1.36.74zm7.78-4.26q-.27-.75-.74-1.35l-6.33 6.33q.61.48 1.37.74l.09-.11zm-4.54 5.95.28.01a4.5 4.5 0 0 0 4.5-4.78z"
]);
const $bf8018481b255628$export$95172abc7122d4c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonVoiceFilled', "1em", [
    "M17.13 1.06a.5.5 0 0 1 .68.2 10 10 0 0 1 0 9.48.5.5 0 1 1-.88-.48 9 9 0 0 0 0-8.52.5.5 0 0 1 .2-.68m-2.32 1.97a.5.5 0 0 1 .65.27 7 7 0 0 1 0 5.4.5.5 0 1 1-.92-.39 6 6 0 0 0 0-4.62.5.5 0 0 1 .27-.66M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13"
]);
const $bf8018481b255628$export$4ff232f92fa32da9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonVoiceRegular', "1em", [
    "M17.13 1.06a.5.5 0 0 1 .68.2 10 10 0 0 1 0 9.48.5.5 0 1 1-.88-.48 9 9 0 0 0 0-8.52.5.5 0 0 1 .2-.68m-2.32 1.97a.5.5 0 0 1 .65.27 7 7 0 0 1 0 5.4.5.5 0 1 1-.92-.39 6 6 0 0 0 0-4.62.5.5 0 0 1 .27-.66M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9 9 0 0 1 9 18a9 9 0 0 1-4.87-1.2A4.4 4.4 0 0 1 2 13m2-1a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8 8 0 0 0 9 17c1.74 0 3.26-.36 4.33-1.05A3.4 3.4 0 0 0 15 13a1 1 0 0 0-1-1z"
]);
const $bf8018481b255628$export$98da704320fe692d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWalkingFilled', "1em", [
    "M11 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-2.52.18c.26-.05.52.07.73.23a3 3 0 0 0 2.7.45 1 1 0 0 1 .52-.05c.46.11.89.37 1.2.75l1.26 1.5a.5.5 0 0 0 .23.16l1.02.34a1.25 1.25 0 0 1-.78 2.37l-1.5-.5q-.34-.1-.57-.38l-.49-.59a.5.5 0 0 0-.86.17l-.15.44a.5.5 0 0 0 .06.44l1.05 1.6q.3.46.37 1.03l.22 2.5a1.25 1.25 0 1 1-2.49.22l-.2-2.3a1 1 0 0 0-.09-.24l-.72-1.1a.5.5 0 0 0-.88.08L7.4 17.25a1.25 1.25 0 1 1-2.3-1L7.96 9.7a.5.5 0 0 0-.58-.69l-.12.03a.3.3 0 0 0-.17.15l-.5 1.13-.01.03-.45.94a1.25 1.25 0 0 1-2.26-1.08l.44-.92.5-1.12a2.8 2.8 0 0 1 1.87-1.56l1.73-.4q.04-.02.07-.03"
]);
const $bf8018481b255628$export$16c3857db64ef084 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWalkingRegular', "1em", [
    "M11.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4.5a2.5 2.5 0 1 1 4.04 1.97q.75.31 1.21 1l.53.8 1.49 1.06a1.75 1.75 0 1 1-2.04 2.84l-1.75-1.25-.09-.06-.01.04.94 1.43q.38.57.45 1.26l.22 2.5a1.75 1.75 0 0 1-3.48.32l-.21-2.31-.5-.75-1.43 3.55a1.75 1.75 0 0 1-3.24-1.3l1.34-3.35q-.36.01-.72-.13a1.75 1.75 0 0 1-.97-2.27l1.1-2.75c.2-.52.65-.91 1.2-1.05l1.54-.38q.3-.08.63-.08Q9 5.09 9 4.49m.32 2.02-2 .5a.8.8 0 0 0-.52.45l-1.1 2.75a.75.75 0 1 0 1.4.56l.86-2.16a.49.49 0 1 1 .9.36l-2.8 6.99a.75.75 0 1 0 1.39.56l1.42-3.55a1 1 0 0 1 1.77-.18l.6.9.04.12.22 2.5a.75.75 0 0 0 1.5-.14l-.23-2.5a2 2 0 0 0-.28-.8l-.93-1.4a1 1 0 0 1-.1-.9l.38-1.01a.42.42 0 0 1 .74-.09l.3.44q.07.11.18.19l1.75 1.25a.75.75 0 1 0 .88-1.22l-1.5-1.06a1 1 0 0 1-.24-.26l-.83-1.24a.8.8 0 0 0-.44-.3l-3-.76a1 1 0 0 0-.36 0"
]);
const $bf8018481b255628$export$e2ac1da0a8f3257d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWarningColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_warning_20_color__a)",
            "d": "M4 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_warning_20_color__b)",
            "d": "M4 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_warning_20_color__c)",
            "fillOpacity": ".75",
            "d": "M4 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 16 13a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_warning_20_color__d)",
            "d": "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_warning_20_color__e)",
            "d": "m13.6 10.55-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_person_warning_20_color__f)",
            "d": "M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_warning_20_color__a",
                "x1": "5.33",
                "x2": "7.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_warning_20_color__b",
                "x1": "9",
                "x2": "12.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_warning_20_color__d",
                "x1": "6.9",
                "x2": "10.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_warning_20_color__e",
                "x1": "11.41",
                "x2": "17.31",
                "y1": "8.59",
                "y2": "19.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_person_warning_20_color__f",
                "x1": "13.16",
                "x2": "16.37",
                "y1": "11.99",
                "y2": "17.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_person_warning_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-68.2 20.53 -.1)scale(10.7703 5.54765)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bf8018481b255628$export$efdab50ec6210316 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWarningFilled', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-5 9a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q0-.45.22-.9l3.05-6.1zm9.6-.45-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $bf8018481b255628$export$582694a3f860b2fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWarningRegular', "1em", [
    "M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 9 18q0-.45.22-.9l.05-.1H9a8 8 0 0 1-4.33-1.05A3.4 3.4 0 0 1 3 13a1 1 0 0 1 1-1h7.77l.5-1zm9.6-.45-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $bf8018481b255628$export$3837c3a838bc8af3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWrenchFilled', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m5.23 5H5A2 2 0 0 0 3 13c0 1.7.83 2.97 2.13 3.8q1.24.77 2.9 1.04a2.5 2.5 0 0 1 .7-2.12l2.32-2.32c-.16-.8-.1-1.63.18-2.4m4.66-1.98c.37.05.47.48.21.75l-.97.97a1.5 1.5 0 1 0 2.13 2.13l.97-.97c.27-.26.7-.16.75.2a3.5 3.5 0 0 1-4.68 3.73l-2.73 2.73a1.5 1.5 0 1 1-2.13-2.13l2.73-2.73a3.52 3.52 0 0 1 3.72-4.68"
]);
const $bf8018481b255628$export$6f46842a748aee41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PersonWrenchRegular', "1em", [
    "M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m5.23 5H5A2 2 0 0 0 3 13c0 1.7.83 2.97 2.13 3.8q1.24.77 2.9 1.04-.07-.5.06-1a7 7 0 0 1-2.42-.89A3.4 3.4 0 0 1 4 13a1 1 0 0 1 1-1h6q.05-.5.23-1M10 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6m5.9 6.02c.36.05.46.48.2.75l-.97.97a1.5 1.5 0 1 0 2.13 2.13l.97-.97c.27-.26.7-.16.75.2a3.5 3.5 0 0 1-4.68 3.73l-2.73 2.73a1.5 1.5 0 1 1-2.13-2.13l2.73-2.73a3.52 3.52 0 0 1 3.72-4.68"
]);
const $bf8018481b255628$export$1d8932ae7286d7f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SimFilled', "1em", [
    "M4 5a3 3 0 0 1 3-3h3.46a3 3 0 0 1 2.13.88l2.53 2.53A3 3 0 0 1 16 7.54V15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm3 5.5v.5h3V9H8.5C7.67 9 7 9.67 7 10.5M7 12v1.5c0 .83.67 1.5 1.5 1.5H10v-3zm4.5 3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5H11v6z"
]);
const $bf8018481b255628$export$9204b5f9d6a542fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SimRegular', "1em", [
    "M8.5 9h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 7 13.5v-3C7 9.67 7.67 9 8.5 9M8 10.5v.5h2v-1H8.5a.5.5 0 0 0-.5.5M8 12v1.5c0 .28.22.5.5.5H10v-2zm3.5 2a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H11v4zM7 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7.54a3 3 0 0 0-.88-2.13L12.6 2.88A3 3 0 0 0 10.46 2zM5 5c0-1.1.9-2 2-2h3.46a2 2 0 0 1 1.42.59l2.53 2.53A2 2 0 0 1 15 7.54V15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
]);
const $bf8018481b255628$export$66441e38ec5464d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TetrisAppFilled', "1em", [
    "M7 2.75c0-.41.34-.75.75-.75H11v4H7zM2.75 7a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75H6V7zM11 7H7v4h3.25c.41 0 .75-.34.75-.75zm4.25-5H12v4h3.25c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75M4 14.75c0-.41.34-.75.75-.75H8v4H4.75a.75.75 0 0 1-.75-.75zM13 18v-4H9v4zm5-4v3.25c0 .41-.34.75-.75.75H14v-4zm-3.25-5a.75.75 0 0 0-.75.75V13h4V9.75a.75.75 0 0 0-.75-.75z"
]);
const $bf8018481b255628$export$1d2d56e355b09a02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TetrisAppRegular', "1em", [
    "M7.25 2C6.56 2 6 2.56 6 3.25v2.5c0 .14-.11.25-.25.25h-2.5C2.56 6 2 6.56 2 7.25v2.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.14.11-.25.25-.25h2.5C14.44 7 15 6.44 15 5.75v-2.5C15 2.56 14.44 2 13.75 2zm6.5 4H11V3h2.75c.14 0 .25.11.25.25v2.5c0 .14-.11.25-.25.25m-3.72 1q-.03.12-.03.25v2.5q-.02.23-.25.25H7V7zM6 7v3H3.25A.25.25 0 0 1 3 9.75v-2.5c0-.14.11-.25.25-.25zm.97-1Q7 5.88 7 5.75v-2.5c0-.14.11-.25.25-.25H10v3zm7.28 3c-.69 0-1.25.56-1.25 1.25v2.5q-.02.23-.25.25h-6.5C5.56 13 5 13.56 5 14.25v2.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5C18 9.56 17.44 9 16.75 9zm-.28 4q.03-.12.03-.25v-2.5q.02-.23.25-.25h2.5q.23.02.25.25V13zm.03 1h3v2.75q-.02.23-.25.25H14zm-1 0v3h-3v-3zm-4 0v3H6.25a.25.25 0 0 1-.25-.25v-2.5c0-.14.11-.25.25-.25z"
]);
const $bf8018481b255628$export$592f066a7772276c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TvUsbFilled', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v1.27A2 2 0 0 0 17 7h-2a2 2 0 0 0-2 2v1.27A2 2 0 0 0 12 12v2.18a2 2 0 0 0 .18.82H4a2 2 0 0 1-2-2zm15 2a1 1 0 0 1 1 1v2a1 1 0 0 1 1 1v2.2a1 1 0 0 1-.2.6l-1.3 1.8V18a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.4l-1.31-1.84a1 1 0 0 1-.19-.58V12a1 1 0 0 1 1-1V9a1 1 0 0 1 1-1zm0 3V9h-2v2zm-3.5 5.91-.66-.91H5.5a.5.5 0 0 0 0 1h8zm-.31-2.15-.34.24Z"
]);
const $bf8018481b255628$export$84ba18f2613c6b83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TvUsbRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v1.27A2 2 0 0 0 17 7V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8v.18a2 2 0 0 0 .18.82H4a2 2 0 0 1-2-2zm11.5 10.92-.66-.92H5.5a.5.5 0 0 0 0 1h8zM14 9v2a1 1 0 0 0-1 1v2.18q0 .31.19.58l1.31 1.83V18a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.4l1.3-1.8a1 1 0 0 0 .2-.6V12a1 1 0 0 0-1-1V9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1m3 2h-2V9h2z"
]);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


"use client";
const $db6ad3fef28672ff$export$9fe5d8301c34c5e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth16Filled', "16", [
    "M7.41 1.08c.26-.13.56-.1.79.07l4 3a.75.75 0 0 1 .02 1.18L8.94 8l3.28 2.67a.75.75 0 0 1-.02 1.18l-4 3a.75.75 0 0 1-1.2-.6V9.58l-2.78 2.25a.75.75 0 0 1-.94-1.16L6.56 8 3.28 5.33a.75.75 0 1 1 .94-1.16L7 6.42V1.75c0-.28.16-.54.41-.67m1.09 8.5v3.17l2.03-1.52zm0-3.16 2.03-1.65L8.5 3.25z"
]);
const $db6ad3fef28672ff$export$6db889df46ae5d64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth16Regular', "16", [
    "M7.29 1.05a.5.5 0 0 1 .53.06l4 3.25a.5.5 0 0 1 0 .78L8.29 8l3.53 2.86a.5.5 0 0 1 0 .78l-4 3.25A.5.5 0 0 1 7 14.5V9.05l-3.18 2.59a.5.5 0 0 1-.64-.78L6.71 8 3.18 5.14a.5.5 0 1 1 .64-.78L7 6.95V1.5q.01-.31.29-.45m.71 8v4.4l2.7-2.2zm0-2.1 2.7-2.2L8 2.55z"
]);
const $db6ad3fef28672ff$export$15eaf7a6dbbe3a3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth20Filled', "20", [
    "M9.46 2.06c.28-.12.6-.05.82.16l4 4a.75.75 0 0 1-.06 1.11L10.94 10l3.28 2.67a.75.75 0 0 1 .06 1.11l-4 4A.75.75 0 0 1 9 17.25v-5.67l-2.78 2.25a.75.75 0 0 1-.94-1.16L8.56 10 5.28 7.33a.75.75 0 1 1 .94-1.16L9 8.42V2.75c0-.3.18-.58.46-.7m1.04 9.52v3.86l2.13-2.13zm0-3.16 2.13-1.73-2.13-2.13z"
]);
const $db6ad3fef28672ff$export$33e35b6c0ba3fb5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth20Regular', "20", [
    "M9.3 2.04a.5.5 0 0 1 .55.1l4 4a.5.5 0 0 1-.02.74L10.26 10l3.57 3.12a.5.5 0 0 1 .02.73l-4 4A.5.5 0 0 1 9 17.5v-6.4l-3.17 2.78a.5.5 0 0 1-.66-.76L8.74 10 5.17 6.88a.5.5 0 0 1 .66-.76L9 8.9V2.5q.01-.32.3-.46m.7 9.06v5.2l2.77-2.78zm0-2.2 2.77-2.42L10 3.7z"
]);
const $db6ad3fef28672ff$export$b9a24ab47ae8dcdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth24Filled', "24", [
    "M11.62 2.08a1 1 0 0 1 1.09.21l5 5a1 1 0 0 1-.09 1.5L13.6 12l4.02 3.22a1 1 0 0 1 .09 1.49l-5 5A1 1 0 0 1 11 21v-6.92l-3.38 2.7a1 1 0 1 1-1.24-1.56L10.4 12 6.38 8.78a1 1 0 0 1 1.24-1.56L11 9.92V3a1 1 0 0 1 .62-.92m1.38 12v4.5l2.5-2.5zm0-4.16 2.5-2-2.5-2.5z"
]);
const $db6ad3fef28672ff$export$cbd46669dea63ab8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth24Regular', "24", [
    "M11.46 2.06c.28-.12.6-.05.82.16l5 5a.75.75 0 0 1-.04 1.1L12.9 12l4.33 3.68a.75.75 0 0 1 .04 1.1l-5 5a.75.75 0 0 1-1.28-.53v-7.63l-3.76 3.2a.75.75 0 0 1-.98-1.14L10.6 12 6.26 8.32a.75.75 0 1 1 .98-1.14l3.76 3.2V2.75c0-.3.18-.58.46-.7m1.04 11.56v5.82l3.14-3.15zm0-3.24 3.14-2.67-3.14-3.15z"
]);
const $db6ad3fef28672ff$export$1fc804d7e0e1bdfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth28Filled', "28", [
    "M13.62 2.08a1 1 0 0 1 1.09.21l6 6a1 1 0 0 1-.07 1.48L15.56 14l5.08 4.23a1 1 0 0 1 .07 1.48l-6 6A1 1 0 0 1 13 25v-8.86l-4.36 3.63a1 1 0 1 1-1.28-1.54L12.44 14 7.36 9.77a1 1 0 1 1 1.28-1.54L13 11.87V3a1 1 0 0 1 .62-.92M15 16.14v6.45l3.52-3.52zm0-4.28 3.52-2.93L15 5.41z"
]);
const $db6ad3fef28672ff$export$30cac448529e5d92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth28Regular', "28", [
    "M13.46 2.06c.28-.12.6-.05.82.16l6 6a.75.75 0 0 1-.04 1.1L14.9 14l5.35 4.69a.75.75 0 0 1 .04 1.09l-6 6a.75.75 0 0 1-1.28-.53v-9.6l-4.76 4.16a.75.75 0 1 1-.98-1.12L12.6 14 7.26 9.31a.75.75 0 1 1 .98-1.12L13 12.35v-9.6c0-.3.18-.58.46-.7m1.04 13.6v7.78l4.15-4.15zm0-3.31 4.15-3.64-4.15-4.15z"
]);
const $db6ad3fef28672ff$export$45aa579f6423f5b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth32Filled', "32", [
    "M15.25 2.1c.46-.2.99-.1 1.35.23l7 6.5a1.25 1.25 0 0 1-.02 1.85L17.63 16l5.95 5.32a1.25 1.25 0 0 1 .02 1.85l-7 6.5a1.25 1.25 0 0 1-2.1-.92v-9.96l-4.92 4.4a1.25 1.25 0 1 1-1.66-1.87L13.87 16l-5.95-5.32a1.25 1.25 0 1 1 1.66-1.86l4.92 4.39V3.25c0-.5.3-.95.75-1.15M17 18.8v7.08l3.9-3.61zm0-5.6 3.9-3.47L17 6.12z"
]);
const $db6ad3fef28672ff$export$4acfbd4e1b10fd83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth32Regular', "32", [
    "M15.6 2.08a1 1 0 0 1 1.08.19l7 6.5a1 1 0 0 1 0 1.46L17.47 16l6.21 5.77a1 1 0 0 1 0 1.46l-7 6.5A1 1 0 0 1 15 29V18.3l-5.32 4.93a1 1 0 1 1-1.36-1.46L14.53 16l-6.21-5.77a1 1 0 0 1 1.36-1.46L15 13.7V3a1 1 0 0 1 .6-.92M17 18.3v8.42l4.53-4.21zm0-4.58 4.53-4.21L17 5.3z"
]);
const $db6ad3fef28672ff$export$2c57b64ea7d8da5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth48Filled', "48", [
    "M22.89 4.13a1.5 1.5 0 0 1 1.61.26l10 9a1.5 1.5 0 0 1 .03 2.2L25.68 24l8.85 8.41a1.5 1.5 0 0 1-.03 2.2l-10 9A1.5 1.5 0 0 1 22 42.5v-15l-7.47 7.09a1.5 1.5 0 1 1-2.06-2.18L21.32 24l-8.85-8.41a1.5 1.5 0 1 1 2.06-2.18l7.47 7.1V5.5c0-.6.35-1.13.89-1.37M25 27.49v11.64l6.3-5.66zm0-6.98 6.3-5.98L25 8.87z"
]);
const $db6ad3fef28672ff$export$6eaf1347c6bb5ba8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bluetooth48Regular', "48", [
    "M23.24 4.1c.45-.2.98-.1 1.35.22l10 9a1.25 1.25 0 0 1 .03 1.82L25.54 24l9.08 8.85a1.25 1.25 0 0 1-.03 1.83l-10 9a1.25 1.25 0 0 1-2.09-.93V26.96l-7.88 7.69a1.25 1.25 0 0 1-1.74-1.8L21.96 24l-9.08-8.85a1.25 1.25 0 0 1 1.74-1.8l7.88 7.69V5.25c0-.5.3-.94.74-1.14M25 26.97v12.98l6.92-6.23zm0-5.92 6.92-6.75L25 8.06z"
]);
const $db6ad3fef28672ff$export$82ae71654e7c965 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothConnected20Filled', "20", [
    "M10.28 2.22A.75.75 0 0 0 9 2.75v5.67L6.22 6.17a.75.75 0 1 0-.94 1.16L8.56 10l-3.28 2.67a.75.75 0 0 0 .94 1.16L9 11.58v5.67a.75.75 0 0 0 1.28.53l4-4a.75.75 0 0 0-.06-1.11L10.94 10l3.28-2.67a.75.75 0 0 0 .06-1.11zm.22 13.22v-3.86l2.13 1.73zm2.13-8.75L10.5 8.42V4.56zM4 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m13 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $db6ad3fef28672ff$export$c14997f0e6cbbb3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothConnected20Regular', "20", [
    "M9.3 2.04a.5.5 0 0 1 .55.1l4 4a.5.5 0 0 1-.02.74L10.26 10l3.57 3.12a.5.5 0 0 1 .02.73l-4 4A.5.5 0 0 1 9 17.5v-6.4l-3.17 2.78a.5.5 0 0 1-.66-.76L8.74 10 5.17 6.88a.5.5 0 0 1 .66-.76L9 8.9V2.5q.01-.32.3-.46m.7 9.06v5.2l2.77-2.78zm0-2.2 2.77-2.42L10 3.7zm7 1.1a1 1 0 1 1-2 0 1 1 0 0 1 2 0M3 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$25ef160e465bfce4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothConnected24Filled', "24", [
    "M11.62 2.08a1 1 0 0 1 1.09.21l5 5a1 1 0 0 1-.09 1.5L13.6 12l4.02 3.22a1 1 0 0 1 .09 1.49l-5 5A1 1 0 0 1 11 21v-6.92l-3.38 2.7a1 1 0 0 1-1.24-1.56L10.4 12 6.38 8.78a1 1 0 0 1 1.24-1.56L11 9.92V3a1 1 0 0 1 .62-.92m1.38 12v4.5l2.5-2.5zm0-4.16 2.5-2-2.5-2.5zM20 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$f5788922f9c3c193 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothConnected24Regular', "24", [
    "M11.46 2.06c.28-.12.6-.05.82.16l5 5a.75.75 0 0 1-.04 1.1L12.9 12l4.33 3.68a.75.75 0 0 1 .04 1.1l-5 5a.75.75 0 0 1-1.28-.53v-7.63l-3.76 3.2a.75.75 0 0 1-.98-1.14L10.6 12 6.26 8.32a.75.75 0 0 1 .98-1.14l3.76 3.2V2.75c0-.3.18-.58.46-.7m1.04 11.56v5.82l3.14-3.15zm0-3.24 3.14-2.67-3.14-3.15zM20 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$f50ab0547d8c9d76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothDisabled20Filled', "20", [
    "m13.68 14.38 3.47 3.47a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7l6.81 6.82-3.68 3a.75.75 0 0 0 .94 1.16L9 11.58v5.67a.75.75 0 0 0 1.28.53zm-1.21-1.2.15.14-2.12 2.12v-3.86zm1.75-5.85L11.6 9.47 10.53 8.4l2.1-1.7-2.13-2.14v3.82L9 6.88V2.75a.75.75 0 0 1 1.28-.53l4 4a.75.75 0 0 1-.06 1.11"
]);
const $db6ad3fef28672ff$export$189eede145eb1b3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothDisabled20Regular', "20", [
    "m13.5 14.2 3.65 3.65a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7L9 9.71v.06l-3.83 3.35a.5.5 0 0 0 .66.76L9 11.1v6.4a.5.5 0 0 0 .85.35zm.33-7.32-2.58 2.25-.7-.7 2.22-1.95L10 3.7v4.17l-1-1V2.5a.5.5 0 0 1 .85-.35l4 4a.5.5 0 0 1-.02.73M10 11.1l2.77 2.42L10 16.3z"
]);
const $db6ad3fef28672ff$export$7733322dd0a4b177 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothDisabled24Filled', "24", [
    "m16.68 17.74 4.04 4.04a.75.75 0 0 0 1.06-1.06L3.28 2.22a.75.75 0 1 0-1.06 1.06l8.48 8.48-4.32 3.46a1 1 0 1 0 1.24 1.56l3.38-2.7V21a1 1 0 0 0 1.7.7zm-3.58-3.58 2.16 2.16L13 18.6v-4.5zm4.52-5.38-3.14 2.52-1.42-1.43 2.44-1.95-2.5-2.5v4.4l-2-2V3a1 1 0 0 1 1.7-.7l5 5a1 1 0 0 1-.08 1.48"
]);
const $db6ad3fef28672ff$export$57cfbc2e68cbb098 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothDisabled24Regular', "24", [
    "m16.5 17.56 4.22 4.22a.75.75 0 0 0 1.06-1.06L3.28 2.22a.75.75 0 1 0-1.06 1.06l8.56 8.56-4.52 3.84a.75.75 0 1 0 .98 1.14l3.76-3.2v7.63a.75.75 0 0 0 1.28.53zm-3.6-3.6 2.54 2.54-2.94 2.94v-5.82zm4.34-5.64-3.1 2.64-1.07-1.07 2.57-2.18-3.14-3.15v4.76L11 7.82V2.75a.75.75 0 0 1 1.28-.53l5 5a.75.75 0 0 1-.04 1.1"
]);
const $db6ad3fef28672ff$export$1c6cd71c9eeeadea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothSearching20Filled', "20", [
    "M10.28 2.22A.75.75 0 0 0 9 2.75v5.67L6.22 6.17a.75.75 0 1 0-.94 1.16L8.56 10l-3.28 2.67a.75.75 0 0 0 .94 1.16L9 11.58v5.67a.75.75 0 0 0 1.28.53l4-4a.75.75 0 0 0-.06-1.11L10.94 10l3.28-2.67a.75.75 0 0 0 .06-1.11zm.22 13.22v-3.86l2.13 1.73zm2.13-8.75L10.5 8.42V4.56zm5.62-.01a.75.75 0 0 0-1.35.64 6.2 6.2 0 0 1 0 5.36.75.75 0 0 0 1.35.64 7.7 7.7 0 0 0 0-6.64m-3 1.13c.4-.14.82.07.96.46a5.2 5.2 0 0 1 0 3.46.75.75 0 0 1-1.42-.5 3.7 3.7 0 0 0 0-2.47.75.75 0 0 1 .46-.95"
]);
const $db6ad3fef28672ff$export$e63a9eb8133c57df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothSearching20Regular', "20", [
    "M9.85 2.15A.5.5 0 0 0 9 2.5v6.4L5.83 6.12a.5.5 0 1 0-.66.76L8.74 10l-3.57 3.12a.5.5 0 0 0 .66.76L9 11.1v6.4a.5.5 0 0 0 .85.35l4-4a.5.5 0 0 0-.02-.73L10.26 10l3.57-3.12a.5.5 0 0 0 .02-.73zM10 16.29V11.1l2.77 2.42zm2.77-9.81L10 8.9V3.7zm4.26.25a.5.5 0 1 0-.84.55 5 5 0 0 1 0 5.45.5.5 0 0 0 .84.54 6 6 0 0 0 0-6.54m-2.29 1.03a.5.5 0 0 1 .69.17 4 4 0 0 1 0 4.13.5.5 0 1 1-.86-.51 3 3 0 0 0 0-3.1.5.5 0 0 1 .17-.69"
]);
const $db6ad3fef28672ff$export$816c014088f4888d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothSearching24Filled', "24", [
    "M11.62 2.08a1 1 0 0 1 1.09.21l5 5a1 1 0 0 1-.09 1.5L13.6 12l4.02 3.22a1 1 0 0 1 .09 1.49l-5 5A1 1 0 0 1 11 21v-6.92l-3.38 2.7a1 1 0 0 1-1.24-1.56L10.4 12 6.38 8.78a1 1 0 0 1 1.24-1.56L11 9.92V3a1 1 0 0 1 .62-.92m1.38 12v4.5l2.5-2.5zm0-4.16 2.5-2-2.5-2.5zm5.5-.79a1 1 0 0 1 1.37.37c.44.76.63 1.63.63 2.5s-.2 1.74-.63 2.5a1 1 0 1 1-1.74-1q.36-.62.37-1.5 0-.88-.37-1.5a1 1 0 0 1 .37-1.37m3.29-2.08a1 1 0 0 0-1.58 1.24 6 6 0 0 1 0 7.42 1 1 0 0 0 1.58 1.24 8 8 0 0 0 0-9.9"
]);
const $db6ad3fef28672ff$export$3692c29f647110bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BluetoothSearching24Regular', "24", [
    "M11.46 2.06c.28-.12.6-.05.82.16l5 5a.75.75 0 0 1-.04 1.1L12.9 12l4.33 3.68a.75.75 0 0 1 .04 1.1l-5 5a.75.75 0 0 1-1.28-.53v-7.63l-3.76 3.2a.75.75 0 0 1-.98-1.14L10.6 12 6.26 8.32a.75.75 0 0 1 .98-1.14l3.76 3.2V2.75c0-.3.18-.58.46-.7m1.04 11.56v5.82l3.14-3.15zm0-3.24 3.14-2.67-3.14-3.15zm5.47-.8a.75.75 0 0 1 1.01.32 4.5 4.5 0 0 1 0 4.2.75.75 0 1 1-1.33-.7 3 3 0 0 0 0-2.8.75.75 0 0 1 .32-1.01M20.6 7.8a.75.75 0 1 0-1.2.9 5.5 5.5 0 0 1 0 6.6.75.75 0 1 0 1.2.9 7 7 0 0 0 0-8.4"
]);
const $db6ad3fef28672ff$export$da2f0aed8bfe04c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur16Filled', "16", [
    "M8 2a6 6 0 1 0 4.47 10H8v-1h5.2q.28-.48.46-1H8V9h5.92q.08-.5.08-1H8V7h5.92a6 6 0 0 0-.26-1H8V5h5.2q-.31-.55-.73-1H8V3h3.32c-.95-.63-2.1-1-3.32-1"
]);
const $db6ad3fef28672ff$export$b3afaecc97c1bdca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur16Regular', "16", [
    "M8 2a6 6 0 1 0 4.47 10H8v1A5 5 0 0 1 8 3h3.32c-.95-.63-2.1-1-3.32-1m0 2h4.47q.42.45.73 1H8zm5.66 2H8v1h5.92a6 6 0 0 0-.26-1M8 8h6q0 .5-.08 1H8zm5.66 2H8v1h5.2q.28-.48.46-1"
]);
const $db6ad3fef28672ff$export$8f9157424efde15a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur20Filled', "20", [
    "M10 2a8 8 0 1 0 5.3 14H10v-1h6.25a8 8 0 0 0 .68-1H10v-1h7.42q.2-.49.33-1H10v-1h7.94q.06-.5.06-1h-8V9h7.94q-.05-.5-.2-1H10V7h7.42q-.2-.52-.49-1H10V5h6.25q-.44-.55-.96-1H10V3h3.88A8 8 0 0 0 10 2"
]);
const $db6ad3fef28672ff$export$99be4b69a2358d04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur20Regular', "20", [
    "M10 2a8 8 0 1 0 5.3 14H10v1a7 7 0 1 1 0-14h3.88A8 8 0 0 0 10 2m0 2h5.3q.51.45.95 1H10zm6.93 2H10v1h7.42q-.2-.52-.49-1M10 8h7.75q.12.5.19 1H10zm8 2h-8v1h7.94q.06-.5.06-1m-8 2h7.75q-.14.51-.33 1H10zm6.93 2H10v1h6.25a8 8 0 0 0 .68-1"
]);
const $db6ad3fef28672ff$export$b8cb4cc688663398 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur24Filled', "24", [
    "M3 12a9 9 0 0 1 13.98-7.5H12v1h6.23q.7.68 1.25 1.5H12v1h8.06q.36.72.59 1.5H12v1h8.88q.12.73.12 1.5h-9v1h8.95a9 9 0 0 1-.3 1.5H12v1h8.3q-.34.8-.82 1.5H12v1h6.7A9 9 0 0 1 3 12"
]);
const $db6ad3fef28672ff$export$f1b9df90c86860a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur24Regular', "24", [
    "M3 12a9 9 0 0 1 13.98-7.5H12a7.5 7.5 0 1 0 0 15V18h6.7A9 9 0 0 1 3 12m15.23-6.5H12V7h7.48a9 9 0 0 0-1.25-1.5M12 8h8.06q.36.72.59 1.5H12zm8.88 2.5H12V12h9q0-.77-.12-1.5M12 13h8.95a9 9 0 0 1-.3 1.5H12zm8.3 2.5H12V17h7.48q.49-.7.81-1.5"
]);
const $db6ad3fef28672ff$export$4b71a9cd8b8f78ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur28Filled', "28", [
    "M3 14a11 11 0 0 1 16.55-9.5H14v1h6.98q.82.68 1.5 1.5H14v1h9.22q.47.72.82 1.5H14v1h10.43q.25.73.39 1.5H14v1h10.96a11 11 0 0 1 .03 1.5H14v1h10.9q-.11.77-.31 1.5H14v1h10.25q-.3.78-.72 1.5H14v1h8.88q-.6.81-1.33 1.5H14v1h6.33A11 11 0 0 1 3 14"
]);
const $db6ad3fef28672ff$export$34f62ac69c4abfd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Blur28Regular', "28", [
    "M3 14a11 11 0 0 1 16.55-9.5H14a9.5 9.5 0 1 0 0 19V23h6.33A11 11 0 0 1 3 14m17.98-8.5q.82.68 1.5 1.5H14V5.5zm3.06 4q-.34-.78-.82-1.5H14v1.5zm.4 1q.23.73.38 1.5H14v-1.5zM25 14q0-.5-.04-1H14v1.5h10.99zm-.1 1.5q-.11.77-.31 1.5H14v-1.5zm-1.37 4q.42-.72.72-1.5H14v1.5zm-.66 1q-.6.81-1.32 1.5H14v-1.5z"
]);
const $db6ad3fef28672ff$export$b7c736a2395dd371 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUi20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5zM9.5 6h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1m3 2h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1M5 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"
]);
const $db6ad3fef28672ff$export$42e8836ef01fb18f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUi20Regular', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5zM4.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm.5 3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"
]);
const $db6ad3fef28672ff$export$e69579acfef38228 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUi24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM5 7.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 7.75M6 13h7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1m-.25-3.5h10.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$28ba58d194e05f78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUi24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75zm1.5.5c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 7.75M6 13a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm-1-2.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$1a6c2ee7b58253a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiInfo16Filled', "16", [
    "M10.5 6a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 4a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 1 0v-1.5a.5.5 0 0 0-.5-.5m-2-9A2.5 2.5 0 0 1 11 3.5v1.52L10.5 5a5.5 5.5 0 0 0-5.48 6H3.5A2.5 2.5 0 0 1 1 8.5v-5A2.5 2.5 0 0 1 3.5 1zm2 7a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24m-7-3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0-2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$f0d9883a5a303360 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiInfo16Regular', "16", [
    "M10.5 6a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 3c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5m-2-9A2.5 2.5 0 0 1 11 3.5v1.52a6 6 0 0 0-1 0V3.5C10 2.67 9.33 2 8.5 2h-5C2.67 2 2 2.67 2 3.5v5c0 .83.67 1.5 1.5 1.5h1.52a6 6 0 0 0 0 1H3.5A2.5 2.5 0 0 1 1 8.5v-5A2.5 2.5 0 0 1 3.5 1zm2 7a.62.62 0 1 1 0 1.24.62.62 0 0 1 0-1.24m-5-2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm3-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$3efd1ec6f4a67a88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiInfo20Filled', "20", [
    "M13.5 8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5M11 2a3 3 0 0 1 3 3v2.02L13.5 7a6.5 6.5 0 0 0-6.48 7H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm2.5 8.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M4.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$4a48cafcd3237dfa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiInfo20Regular', "20", [
    "M13.5 8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 4c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5M11 2a3 3 0 0 1 3 3v2.02a7 7 0 0 0-1 0V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h2.02a7 7 0 0 0 0 1H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm2.5 8.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M7.5 8a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zM11 5a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$5b289188d165e612 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiInfo24Filled', "24", [
    "M16 9a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 6.75a.75.75 0 0 0-.75.75v2a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 0-.75-.75M13.75 2C15.55 2 17 3.46 17 5.25v2.81A8 8 0 0 0 8.06 17H5.25A3.25 3.25 0 0 1 2 13.75v-8.5C2 3.45 3.46 2 5.25 2zM16 12.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.75 9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm0-3.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$a2a33628ce58ce4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiInfo24Regular', "24", [
    "M16 9a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m0 5.25c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0v-2c0-.41.34-.75.75-.75M13.75 2C15.55 2 17 3.46 17 5.25v2.81a8 8 0 0 0-1.5-.04V5.25c0-.97-.78-1.75-1.75-1.75h-8.5c-.97 0-1.75.78-1.75 1.75v8.5c0 .97.78 1.75 1.75 1.75h2.77a8 8 0 0 0 .04 1.5H5.25A3.25 3.25 0 0 1 2 13.75v-8.5C2 3.45 3.46 2 5.25 2zM16 12.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M8.75 9a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zm4-3.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$1a4b18d351388459 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiPortraitFlip16Filled', "16", [
    "M3 3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v3h-.5a1.5 1.5 0 0 0-1.23 2.36C10.51 8.72 9.44 9 8 9s-2.5-.28-3.27-.64Q4.99 8 5 7.5C5 6.67 4.33 6 3.5 6H3zm5 9c2.15 0 3.79-.5 5-1.15V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2.15C4.21 11.51 5.85 12 8 12M6 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-.5 3c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.5.5m-4 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-.58q.25.23.58.48A8.8 8.8 0 0 0 8 11a8.8 8.8 0 0 0 5.43-1.6q.31-.25.57-.48v.58a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h1q-.27.3-.68.6A7.8 7.8 0 0 1 8 10c-2.4 0-3.91-.71-4.82-1.4q-.41-.3-.68-.6h1a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$e355fae5fe16b365 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiPortraitFlip16Regular', "16", [
    "M3 3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v3h-.5q-.26 0-.5.09V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3.09A2 2 0 0 0 3.5 6H3zm9 8.31q.54-.21 1-.46V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2.15q.45.25 1 .46V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zM1.5 7a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-.58q.25.23.58.48A8.8 8.8 0 0 0 8 11a8.8 8.8 0 0 0 5.43-1.6q.31-.25.57-.48v.58a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h1q-.27.3-.68.6A7.8 7.8 0 0 1 8 10c-2.4 0-3.91-.71-4.82-1.4q-.41-.3-.68-.6h1a.5.5 0 0 0 0-1zm4-2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5m.5 2a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$7781aaf98af86ba3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiPortraitFlip20Filled', "20", [
    "M4 4.5A2.5 2.5 0 0 1 6.5 2h7A2.5 2.5 0 0 1 16 4.5V8a1.5 1.5 0 0 0-.85 2.73A10 10 0 0 1 10 12c-2.4 0-4.05-.6-5.15-1.27A1.5 1.5 0 0 0 4 8zM10 15c2.54 0 4.51-.56 6-1.31v1.81a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5v-1.81c1.49.75 3.46 1.31 6 1.31M7.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM7 8.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5M1.5 9a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 1 0v-1q.4.43 1 .9c1.4 1.06 3.64 2.1 7 2.1s5.6-1.04 7-2.1q.6-.47 1-.9v1a.5.5 0 0 0 1 0V9.5a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0 0 1h1.55q-.4.5-1.17 1.1c-1.22.94-3.24 1.9-6.38 1.9s-5.16-.96-6.38-1.9q-.77-.6-1.17-1.1H4a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$606a3ba2a59ad113 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiPortraitFlip20Regular', "20", [
    "M6.5 2A2.5 2.5 0 0 0 4 4.5V8q.58.01 1 .38V4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5v3.88A1.5 1.5 0 0 1 16 8V4.5A2.5 2.5 0 0 0 13.5 2zM16 13.69q-.47.24-1 .44v1.37c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5v-1.37a11 11 0 0 1-1-.44v1.81A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM7 9.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M1.5 9a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 1 0v-1q.4.43 1 .9c1.4 1.06 3.64 2.1 7 2.1s5.6-1.04 7-2.1q.6-.47 1-.9v1a.5.5 0 0 0 1 0V9.5a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0 0 1h1.55q-.4.5-1.17 1.1c-1.22.94-3.24 1.9-6.38 1.9s-5.16-.96-6.38-1.9q-.77-.6-1.17-1.1H4a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$a85b4681f93d3a97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiPortraitFlip24Filled', "24", [
    "M4 4.75A2.75 2.75 0 0 1 6.75 2h10.5A2.75 2.75 0 0 1 20 4.75V10h-.75a1.75 1.75 0 0 0-1.14 3.08A12.5 12.5 0 0 1 12 14.5c-2.75 0-4.74-.67-6.1-1.42A1.75 1.75 0 0 0 4.74 10H4zM12 18c3.5 0 6.12-.9 8-1.97v3.22A2.75 2.75 0 0 1 17.25 22H6.75A2.75 2.75 0 0 1 4 19.25v-3.22A16 16 0 0 0 12 18M8.75 6a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM8 10.75c0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75M1.75 11a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-1.03q.48.44 1.14.9C5.38 15.82 8.09 17 12 17s6.62-1.18 8.36-2.38q.66-.46 1.14-.9v1.03a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h1.36q-.45.42-1.1.88c-1.5 1.05-3.92 2.12-7.51 2.12s-6-1.07-7.51-2.12q-.66-.46-1.1-.88h1.36a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$ae3192ab6a2a70c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CardUiPortraitFlip24Regular', "24", [
    "M4 4.75A2.75 2.75 0 0 1 6.75 2h10.5A2.75 2.75 0 0 1 20 4.75V10h-.75q-.4 0-.75.17V4.75c0-.69-.56-1.25-1.25-1.25H6.75c-.69 0-1.25.56-1.25 1.25v5.42Q5.15 10 4.75 10H4zm14.5 12.02q.82-.35 1.5-.74v3.22A2.75 2.75 0 0 1 17.25 22H6.75A2.75 2.75 0 0 1 4 19.25v-3.22q.68.39 1.5.74v2.48c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25zM1.75 11a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-1.03q.48.44 1.14.9C5.38 15.82 8.09 17 12 17s6.62-1.18 8.36-2.38q.66-.46 1.14-.9v1.03a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h1.36q-.45.42-1.1.88c-1.5 1.05-3.92 2.12-7.51 2.12s-6-1.07-7.51-2.12q-.66-.46-1.1-.88h1.36a.75.75 0 0 0 0-1.5zM8 6.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 8 6.75M8.75 10a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$cd7b08d2cf491292 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown12Filled', "12", [
    "M3.08 4.62A1 1 0 0 1 4 4h4a1 1 0 0 1 .7 1.7l-2 2a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1-.22-1.08"
]);
const $db6ad3fef28672ff$export$4f8db1377723adfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown12Regular', "12", [
    "M3.08 4.62A1 1 0 0 1 4 4h4a1 1 0 0 1 .7 1.7l-2 2a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1-.22-1.08M4 5l1.82 1.82c.1.1.26.1.36 0L8 5z"
]);
const $db6ad3fef28672ff$export$8b5d190dbcbbc0ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown16Filled', "16", [
    "M4.96 5a1 1 0 0 0-.82 1.57l2.63 3.79c.6.85 1.86.85 2.46 0l2.63-3.79A1 1 0 0 0 11.04 5z"
]);
const $db6ad3fef28672ff$export$e7baf2f17fc4573c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown16Regular', "16", [
    "M4.14 6.57A1 1 0 0 1 4.96 5h6.08a1 1 0 0 1 .82 1.57l-2.63 3.79a1.5 1.5 0 0 1-2.46 0zM4.96 6l2.63 3.78c.2.29.62.29.82 0L11.04 6z"
]);
const $db6ad3fef28672ff$export$b04dd799805fa0e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown20Filled', "20", [
    "M5.8 7a1 1 0 0 0-.78 1.63l3.81 4.72c.6.74 1.74.74 2.34 0l3.81-4.72A1 1 0 0 0 14.2 7z"
]);
const $db6ad3fef28672ff$export$84560850f6b1c65f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown20Regular', "20", [
    "M5.02 8.63A1 1 0 0 1 5.8 7h8.4a1 1 0 0 1 .78 1.63l-3.81 4.72a1.5 1.5 0 0 1-2.34 0zM14.2 8H5.8l3.81 4.72c.2.25.58.25.78 0z"
]);
const $db6ad3fef28672ff$export$fb7fd05e5f625bc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown24Filled', "24", [
    "M6.1 8a1.25 1.25 0 0 0-.94 2.07l5.52 6.31c.7.8 1.94.8 2.64 0l5.52-6.3c.7-.82.13-2.08-.94-2.08z"
]);
const $db6ad3fef28672ff$export$112a7ab0828b9f5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDown24Regular', "24", [
    "M5.16 10.07C4.46 9.27 5.03 8 6.1 8h11.8c1.07 0 1.65 1.26.94 2.07l-5.52 6.31c-.7.8-1.94.8-2.64 0zm1.5-.57 5.15 5.9c.1.11.28.11.38 0l5.16-5.9z"
]);
const $db6ad3fef28672ff$export$cbd29016dec29e85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight12Filled', "12", [
    "M9 3.96a1 1 0 0 0-1.7-.7L3.25 7.3A1 1 0 0 0 3.96 9H7.5C8.33 9 9 8.34 9 7.5z"
]);
const $db6ad3fef28672ff$export$46ae4efb23eda7a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight12Regular', "12", [
    "M7.3 3.26a1 1 0 0 1 1.7.7v3.55C9 8.33 8.33 9 7.5 9H3.96a1 1 0 0 1-.7-1.71zm.7.7L3.96 8.01H7.5a.5.5 0 0 0 .5-.5z"
]);
const $db6ad3fef28672ff$export$752e211a4c4a5bd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight16Filled', "16", [
    "M12 4.96a1 1 0 0 0-1.7-.71l-6.05 6.04a1 1 0 0 0 .7 1.71h5.55c.83 0 1.5-.67 1.5-1.5z"
]);
const $db6ad3fef28672ff$export$9f9595c1271589aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight16Regular', "16", [
    "M10.3 4.25a1 1 0 0 1 1.7.7v5.55c0 .83-.67 1.5-1.5 1.5H4.96a1 1 0 0 1-.71-1.7zm.7.7L4.96 11h5.54a.5.5 0 0 0 .5-.5z"
]);
const $db6ad3fef28672ff$export$f2dca91ea48a7420 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight20Filled', "20", [
    "M15 5.96a1 1 0 0 0-1.7-.71l-8.05 8.04a1 1 0 0 0 .7 1.71h7.55c.83 0 1.5-.67 1.5-1.5z"
]);
const $db6ad3fef28672ff$export$ff94504ffb1aa56e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight20Regular', "20", [
    "M13.3 5.25a1 1 0 0 1 1.7.7v7.55c0 .83-.67 1.5-1.5 1.5H5.96a1 1 0 0 1-.71-1.7zm.7.7L5.96 14h7.54a.5.5 0 0 0 .5-.5z"
]);
const $db6ad3fef28672ff$export$66d40a1fd7c1ac09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight24Filled', "24", [
    "M18 7.2a1.25 1.25 0 0 0-2.13-.88l-9.55 9.55c-.78.78-.23 2.13.89 2.13h9.04c.97 0 1.75-.78 1.75-1.75z"
]);
const $db6ad3fef28672ff$export$f0782a7abd8f2ab8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretDownRight24Regular', "24", [
    "m16.5 7.81-8.69 8.7h8.44q.23-.03.25-.26zm-.63-1.49a1.25 1.25 0 0 1 2.13.89v9.04c0 .97-.78 1.75-1.75 1.75H7.21a1.25 1.25 0 0 1-.89-2.13z"
]);
const $db6ad3fef28672ff$export$e1efde0928ad480c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft12Filled', "12", [
    "M6.3 3.28A1 1 0 0 1 8 4v4.02a1 1 0 0 1-1.7.7l-2.04-2a1 1 0 0 1 0-1.42z"
]);
const $db6ad3fef28672ff$export$e04dcedc60f55fa2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft12Regular', "12", [
    "M8 4a1 1 0 0 0-1.7-.72l-2.04 2a1 1 0 0 0 0 1.43l2.04 2a1 1 0 0 0 1.7-.7zM4.96 6 7 4v4z"
]);
const $db6ad3fef28672ff$export$845c9e50c6e99713 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft16Filled', "16", [
    "M9.43 11.84a1 1 0 0 0 1.57-.82V4.98a1 1 0 0 0-1.57-.82L5.64 6.78c-.85.59-.85 1.85 0 2.44z"
]);
const $db6ad3fef28672ff$export$9af90a60bf356f66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft16Regular', "16", [
    "M9.43 11.86a1 1 0 0 0 1.57-.82V4.96a1 1 0 0 0-1.57-.82L5.64 6.77a1.5 1.5 0 0 0 0 2.46zm.57-.82L6.22 8.41a.5.5 0 0 1 0-.82L10 4.96z"
]);
const $db6ad3fef28672ff$export$aba4765deb8c5d54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft20Filled', "20", [
    "M13 14.2a1 1 0 0 1-1.63.78l-4.72-3.81a1.5 1.5 0 0 1 0-2.34l4.72-3.81A1 1 0 0 1 13 5.8z"
]);
const $db6ad3fef28672ff$export$d0d63d99f13102ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft20Regular', "20", [
    "M11.37 14.98A1 1 0 0 0 13 14.2V5.8a1 1 0 0 0-1.63-.78L6.65 8.83a1.5 1.5 0 0 0 0 2.34zM12 5.8v8.4L7.28 10.4a.5.5 0 0 1 0-.78z"
]);
const $db6ad3fef28672ff$export$f33ce489979698c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft24Filled', "24", [
    "M15 17.9a1.25 1.25 0 0 1-2.07.94l-6.31-5.52c-.8-.7-.8-1.94 0-2.64l6.3-5.52c.82-.7 2.08-.13 2.08.94z"
]);
const $db6ad3fef28672ff$export$52bbe7d2a470d380 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretLeft24Regular', "24", [
    "M12.93 18.84c.8.7 2.07.13 2.07-.94V6.1a1.25 1.25 0 0 0-2.07-.94l-6.31 5.52c-.8.7-.8 1.94 0 2.64zm.57-1.5L7.6 12.2a.25.25 0 0 1 0-.38l5.9-5.16z"
]);
const $db6ad3fef28672ff$export$d004adf4f2456483 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight12Filled', "12", [
    "M5.7 3.28A1 1 0 0 0 4 4v4.02a1 1 0 0 0 1.7.7l2.04-2a1 1 0 0 0 0-1.42z"
]);
const $db6ad3fef28672ff$export$3ae40ec16ba8e36e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight12Regular', "12", [
    "M4 4a1 1 0 0 1 1.7-.72l2.04 2a1 1 0 0 1 0 1.43l-2.04 2a1 1 0 0 1-1.7-.7zm3.04 2L5 4v4z"
]);
const $db6ad3fef28672ff$export$c22cd7d761693a6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight16Filled', "16", [
    "M7.57 11.84A1 1 0 0 1 6 11.02V4.98a1 1 0 0 1 1.57-.82l3.79 2.62c.85.59.85 1.85 0 2.44z"
]);
const $db6ad3fef28672ff$export$3b2f8bd431cb7446 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight16Regular', "16", [
    "M7.57 11.84A1 1 0 0 1 6 11.02V4.98a1 1 0 0 1 1.57-.82l3.79 2.62c.85.59.85 1.85 0 2.44zM7 11.02l3.78-2.61a.5.5 0 0 0 0-.82L7 4.98z"
]);
const $db6ad3fef28672ff$export$d878b6d372fed0fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight20Filled', "20", [
    "M7 14.2a1 1 0 0 0 1.63.78l4.72-3.81a1.5 1.5 0 0 0 0-2.34L8.63 5.02A1 1 0 0 0 7 5.8z"
]);
const $db6ad3fef28672ff$export$5bcaa71a438f0f35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight20Regular', "20", [
    "M8.63 14.98A1 1 0 0 1 7 14.2V5.8a1 1 0 0 1 1.63-.78l4.72 3.81c.74.6.74 1.74 0 2.34zM8 5.8v8.4l4.72-3.81a.5.5 0 0 0 0-.78z"
]);
const $db6ad3fef28672ff$export$569347b9d3d748b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight24Filled', "24", [
    "M9 17.9a1.25 1.25 0 0 0 2.07.94l6.31-5.52c.8-.7.8-1.94 0-2.64l-6.3-5.52C10.25 4.46 9 5.03 9 6.1z"
]);
const $db6ad3fef28672ff$export$6788b1e86201b4e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretRight24Regular', "24", [
    "M11.07 18.84c-.8.7-2.07.13-2.07-.94V6.1a1.25 1.25 0 0 1 2.07-.94l6.31 5.52c.8.7.8 1.94 0 2.64zm-.57-1.5 5.9-5.15a.25.25 0 0 0 0-.38l-5.9-5.16z"
]);
const $db6ad3fef28672ff$export$dfd6be465ce5cb78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp12Filled', "12", [
    "M3.08 7.38A1 1 0 0 0 4 8h4a1 1 0 0 0 .7-1.7l-2-2a1 1 0 0 0-1.4 0l-2 2a1 1 0 0 0-.22 1.08"
]);
const $db6ad3fef28672ff$export$6050793d47739efc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp12Regular', "12", [
    "M3.08 7.38A1 1 0 0 0 4 8h4a1 1 0 0 0 .7-1.7l-2-2a1 1 0 0 0-1.4 0l-2 2a1 1 0 0 0-.22 1.08M4 7l1.82-1.82c.1-.1.26-.1.36 0L8 7z"
]);
const $db6ad3fef28672ff$export$24095110c2db058a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp16Filled', "16", [
    "M4.96 11a1 1 0 0 1-.82-1.57l2.63-3.79a1.5 1.5 0 0 1 2.46 0l2.63 3.79a1 1 0 0 1-.82 1.57z"
]);
const $db6ad3fef28672ff$export$1470c88dce86ffbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp16Regular', "16", [
    "M4.14 9.43A1 1 0 0 0 4.96 11h6.08a1 1 0 0 0 .82-1.57L9.23 5.64a1.5 1.5 0 0 0-2.46 0zm.82.57L7.59 6.2a.5.5 0 0 1 .82 0L11.04 10z"
]);
const $db6ad3fef28672ff$export$6748ce70c3bf38d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp20Filled', "20", [
    "M5.8 13.9a1 1 0 0 1-.78-1.62l3.81-4.72a1.5 1.5 0 0 1 2.34 0l3.81 4.72a1 1 0 0 1-.78 1.63z"
]);
const $db6ad3fef28672ff$export$35a264deaad84f54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp20Regular', "20", [
    "M5.02 12.28a1 1 0 0 0 .78 1.63h8.4a1 1 0 0 0 .78-1.63l-3.81-4.72a1.5 1.5 0 0 0-2.34 0zm9.18.63H5.8L9.6 8.19a.5.5 0 0 1 .78 0z"
]);
const $db6ad3fef28672ff$export$9849c59b3b2b049 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp24Filled', "24", [
    "M6.1 16.98a1.25 1.25 0 0 1-.94-2.07l5.52-6.31c.7-.8 1.94-.8 2.64 0l5.52 6.3c.7.82.13 2.08-.94 2.08z"
]);
const $db6ad3fef28672ff$export$23c70e2fb78fc93a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CaretUp24Regular', "24", [
    "M5.16 14.9c-.7.82-.13 2.08.94 2.08h11.8c1.07 0 1.65-1.26.94-2.07L13.32 8.6c-.7-.8-1.94-.8-2.64 0zm1.5.58 5.15-5.9c.1-.1.28-.1.38 0l5.16 5.9z"
]);
const $db6ad3fef28672ff$export$da2fd250b15d50b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cart16Filled', "16", [
    "M2.5 2a.5.5 0 0 0 0 1h.25a.5.5 0 0 1 .48.36L4.8 8.91A1.5 1.5 0 0 0 6.25 10h4.57a1.5 1.5 0 0 0 1.4-.94l1.47-3.69A1 1 0 0 0 12.76 4H4.45l-.26-.91A1.5 1.5 0 0 0 2.75 2zm4 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$e76552bec45e4d0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cart16Regular', "16", [
    "M2.5 2a.5.5 0 0 0 0 1h.25a.5.5 0 0 1 .48.36L4.8 8.91A1.5 1.5 0 0 0 6.25 10h4.57a1.5 1.5 0 0 0 1.4-.94l1.47-3.69A1 1 0 0 0 12.76 4H4.45l-.26-.91A1.5 1.5 0 0 0 2.75 2zm3.27 6.64L4.73 5h8.03L11.3 8.69a.5.5 0 0 1-.47.31H6.25a.5.5 0 0 1-.48-.36M6.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m4 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $db6ad3fef28672ff$export$494c1bb36691cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cart20Filled', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h.44c.72 0 1.14.47 1.38.94.17.32.29.72.39 1.06H16a1 1 0 0 1 .96 1.27l-1.5 5.28A2 2 0 0 1 13.55 13H8.46a2 2 0 0 1-1.93-1.47L5.9 9.17l-.01-.03-1.03-3.5-.1-.33a5 5 0 0 0-.32-.91c-.16-.31-.3-.4-.5-.4H3.5a.5.5 0 0 1-.5-.5M8.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$7dac0e74aed3ee1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cart20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h.44c.72 0 1.14.47 1.38.94.17.32.29.72.39 1.06H16a1 1 0 0 1 .96 1.27l-1.5 5.28A2 2 0 0 1 13.55 13H8.46a2 2 0 0 1-1.93-1.47L5.9 9.17l-.01-.03-1.03-3.5-.1-.33a5 5 0 0 0-.32-.91c-.16-.31-.3-.4-.5-.4H3.5a.5.5 0 0 1-.5-.5m3.84 5.37.66 2.4a1 1 0 0 0 .96.73h5.08a1 1 0 0 0 .96-.73L16 6H6zM10 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"
]);
const $db6ad3fef28672ff$export$bfc7c2bb8f65cad0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cart24Filled', "24", [
    "M2.5 4.25c0-.41.34-.75.75-.75h.56c.95 0 1.52.64 1.84 1.23.22.4.38.86.5 1.27h12.6c.83 0 1.43.8 1.2 1.6L18.12 14a2.75 2.75 0 0 1-2.64 2H9.53a2.75 2.75 0 0 1-2.65-2.02l-.76-2.78-1.26-4.24v-.01c-.16-.57-.3-1.1-.52-1.5C4.13 5.07 3.96 5 3.8 5h-.56a.75.75 0 0 1-.75-.75M9 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4m7 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $db6ad3fef28672ff$export$ad2d520e0a10d4b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cart24Regular', "24", [
    "M2.5 4.25c0-.41.34-.75.75-.75h.56c.95 0 1.52.64 1.84 1.23.22.4.38.86.5 1.27h12.6c.83 0 1.43.8 1.2 1.6L18.12 14a2.75 2.75 0 0 1-2.64 2H9.53a2.75 2.75 0 0 1-2.65-2.02l-.76-2.78-1.26-4.24v-.01c-.16-.57-.3-1.1-.52-1.5C4.13 5.07 3.96 5 3.8 5h-.56a.75.75 0 0 1-.75-.75m5.07 6.59.75 2.74c.15.54.65.92 1.21.92h5.95c.56 0 1.05-.37 1.2-.9l1.74-6.1H6.59l.97 3.29zM11 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1.5 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m8.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1.5 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"
]);
const $db6ad3fef28672ff$export$66b2343dde698b6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_16_color__a)",
            "d": "M3 2a2 2 0 0 0-2 2v5h.5c0 .82.4 1.54 1 2v1H13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_16_color__b)",
            "fillOpacity": ".9",
            "d": "M8.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_16_color__c)",
            "fillOpacity": ".9",
            "d": "M4.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_16_color__d)",
            "d": "M2 10.94v3.56a.5.5 0 0 0 .26.44.5.5 0 0 0 .52-.03L4 14.1l1.22.82a.5.5 0 0 0 .7-.16A1 1 0 0 0 6 14.5v-3.56q-.9.54-2 .56-1.1-.02-2-.56"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_16_color__e)",
            "d": "M7 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_16_color__a",
                "x1": "1.5",
                "x2": "7.95",
                "y1": "3.88",
                "y2": "13.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_16_color__b",
                "x1": "15.6",
                "x2": "11.22",
                "y1": "14.2",
                "y2": "1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_16_color__c",
                "x1": "15.6",
                "x2": "11.22",
                "y1": "14.2",
                "y2": "1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6.39258 -8.82955 0 4 10.31)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#163697"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(56.62 7.94 -18.6)scale(33.4905 28.6831)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$2e2bc96fe215b2e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate16Filled', "16", [
    "M3 2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6.62a3.97 3.97 0 0 0 0-6h4.88a.5.5 0 0 0 0-1H4c-1.2 0-2.27.54-3 1.38V4c0-1.1.9-2 2-2m6.5 7h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1M4 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-2 2.5v-2.06q.9.54 2 .56 1.1-.02 2-.56v2.06a.5.5 0 0 1-.26.44.5.5 0 0 1-.52-.02L4 14.1l-1.22.81A.5.5 0 0 1 2 14.5"
]);
const $db6ad3fef28672ff$export$8b4a58a7c8579e75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate16Regular', "16", [
    "M1 4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7v-.35a4 4 0 0 0 .46-.65H13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1.54q-.57.32-1 .81zm5.65 2c-.62-.55-1.41-.9-2.28-.98L4.5 5h7a.5.5 0 0 1 0 1zM8.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-5 3.44v2.06a.5.5 0 0 0 .26.44.5.5 0 0 0 .52-.03L4 14.1l1.22.82a.5.5 0 0 0 .7-.16A1 1 0 0 0 6 14.5v-2.06q-.9.54-2 .56-1.1-.02-2-.56"
]);
const $db6ad3fef28672ff$export$5ba24f39913f6338 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_20_color__a)",
            "d": "M2 5c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-.5-.06v-1.2a3 3 0 0 1-1-2.24H2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_20_color__b)",
            "fillOpacity": ".9",
            "d": "M5 6.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m5.5 3.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_20_color__c)",
            "d": "M3 13.74a4.5 4.5 0 0 0 5 0V18a.5.5 0 0 1-.8.4l-1.4-1.05a.5.5 0 0 0-.6 0L3.8 18.4A.5.5 0 0 1 3 18z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_20_color__d)",
            "d": "M5.5 15a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 7.5 -11.0369 0 5.5 13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#163697"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(56.62 8.75 -20.43)scale(39.0722 33.4636)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_20_color__a",
                "x1": "2.57",
                "x2": "10.44",
                "y1": "5.25",
                "y2": "16.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_20_color__b",
                "x1": "19.5",
                "x2": "14.03",
                "y1": "17.5",
                "y2": "1.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$5eb3b71e06e39181 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate20Filled', "20", [
    "M4 3a2 2 0 0 0-2 2v3.67a4.5 4.5 0 1 1 7 5.66V15h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm1.5 4a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1zm5.5 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 15a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m-2.5.24a4.5 4.5 0 0 0 5 0V18a.5.5 0 0 1-.8.4l-1.4-1.05a.5.5 0 0 0-.6 0L3.8 18.4A.5.5 0 0 1 3 18z"
]);
const $db6ad3fef28672ff$export$324c59b662f95d67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate20Regular', "20", [
    "M4 3a2 2 0 0 0-2 2v3.67q.43-.53 1-.91V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9.24l-.24.33V15h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm1 3.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m.5 8.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m-2.5.24a4.5 4.5 0 0 0 5 0V18a.5.5 0 0 1-.8.4l-1.4-1.05a.5.5 0 0 0-.6 0L3.8 18.4A.5.5 0 0 1 3 18zM10.5 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$18c3463a51b7cb69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_24_color__a)",
            "d": "M4.75 3A2.75 2.75 0 0 0 2 5.75V14h.5c0 .95.38 1.82 1 2.45V18h15.75A2.75 2.75 0 0 0 22 15.25v-9.5A2.75 2.75 0 0 0 19.25 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_24_color__b)",
            "fillOpacity": ".9",
            "d": "M6.75 7a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm6 5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_24_color__c)",
            "d": "M9 16a5 5 0 0 1-6 0v5.25c0 .57.6.92 1.09.67l.09-.06L6 20.6l1.82 1.27a.75.75 0 0 0 1.17-.5v-.11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_24_color__d)",
            "d": "M6 10a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 9.45684 -13.2458 0 6 15.06)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#163697"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(56.62 9.07 -23.2)scale(44.6612 38.2502)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_24_color__a",
                "x1": "2.71",
                "x2": "12.55",
                "y1": "5.81",
                "y2": "19.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_24_color__b",
                "x1": "23.4",
                "x2": "15.82",
                "y1": "21.95",
                "y2": ".87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$57e5e87407d5c139 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate24Filled', "24", [
    "M4.75 3A2.75 2.75 0 0 0 2 5.75V11a5 5 0 1 1 8 6v1h9.25A2.75 2.75 0 0 0 22 15.25v-9.5A2.75 2.75 0 0 0 19.25 3zm2 4h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5M12 12.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M6 10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m3 8a5 5 0 0 1-6 0v3.25c0 .57.6.92 1.09.67l.09-.06L6 20.6l1.82 1.27a.75.75 0 0 0 1.17-.5v-.11z"
]);
const $db6ad3fef28672ff$export$71b49abd196b9d9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate24Regular', "24", [
    "M2 5.75A2.75 2.75 0 0 1 4.75 3h14.5A2.75 2.75 0 0 1 22 5.75v9.5A2.75 2.75 0 0 1 19.25 18H10v-1l.33-.5h8.92c.69 0 1.25-.56 1.25-1.25v-9.5c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v3.92Q2.6 10.19 2 11zM6.75 7a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm6 5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM6 10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m3 8a5 5 0 0 1-6 0v3.25c0 .57.6.92 1.09.67l.09-.06L6 20.6l1.82 1.27a.75.75 0 0 0 1.17-.5v-.11z"
]);
const $db6ad3fef28672ff$export$3a93f2a00575d7da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_32_color__a)",
            "d": "M5.25 4A3.25 3.25 0 0 0 2 7.25V20h.52c.1.93.45 1.79.98 2.5V25h23.25c1.8 0 3.25-1.46 3.25-3.25V7.25C30 5.45 28.54 4 26.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_32_color__b)",
            "fillOpacity": ".9",
            "d": "M8 11a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m9 6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_32_color__c)",
            "d": "M12 21.86a7 7 0 0 1-9 0V29a1 1 0 0 0 1.53.85L7.5 28l2.97 1.85A1 1 0 0 0 12 29z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_certificate_32_color__d)",
            "d": "M13 19.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 11.421 -17.6871 0 7.5 22)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#163697"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_certificate_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(56.62 11.86 -32.46)scale(61.3992 52.5856)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_32_color__a",
                "x1": "3",
                "x2": "16.77",
                "y1": "7.94",
                "y2": "27.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_certificate_32_color__b",
                "x1": "31.2",
                "x2": "20.4",
                "y1": "30.7",
                "y2": "1.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$62fd5e60559b08a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate32Filled', "32", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v7.92a6.99 6.99 0 0 1 11.5 7.94V25h13.25c1.8 0 3.25-1.46 3.25-3.25V7.25C30 5.45 28.54 4 26.75 4zM9 10h14a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2m7 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-3 1.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-1 5.36a7 7 0 0 1-9 0V29a1 1 0 0 0 1.53.85L7.5 28l2.97 1.85A1 1 0 0 0 12 29z"
]);
const $db6ad3fef28672ff$export$8dd52ba5e2e86c4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Certificate32Regular', "32", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h21.5C28.55 4 30 5.46 30 7.25v14.5c0 1.8-1.46 3.25-3.25 3.25H13.5v-1.9l.06-.1h13.19c.69 0 1.25-.56 1.25-1.25V7.25C28 6.56 27.44 6 26.75 6H5.25C4.56 6 4 6.56 4 7.25v6.19a7 7 0 0 0-2 1.73zM13 19.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-1 5.36a7 7 0 0 1-9 0V29a1 1 0 0 0 1.53.85L7.5 28l2.97 1.85A1 1 0 0 0 12 29zM8 11a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m9 6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$6ad8537d97756e0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CertificateOff16Filled', "16", [
    "M6 14.5a.5.5 0 0 1-.26.44.5.5 0 0 1-.52-.02L4 14.1l-1.22.82A.5.5 0 0 1 2 14.5v-2.06q.9.54 2 .56 1.1-.02 2-.56zM1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7L11.29 12H6.62a4 4 0 0 0 1.37-3.3L4.29 5H4c-1.2 0-2.27.54-3 1.38V4a2 2 0 0 1 .74-1.55l-.6-.6a.5.5 0 0 1 0-.7M4 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6m9-4a2 2 0 0 1 2 2v6a2 2 0 0 1-1.1 1.78L8.12 6h3.38a.5.5 0 0 0 0-1H7.12l-3-3z"
]);
const $db6ad3fef28672ff$export$3decf4575169ce4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CertificateOff16Regular', "16", [
    "M6 14.5a.5.5 0 0 1-.26.44.5.5 0 0 1-.52-.02L4 14.1l-1.22.82A.5.5 0 0 1 2 14.5v-2.06q.9.54 2 .56 1.1-.02 2-.56zM1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7L11.29 12H7v-.35a4 4 0 0 0 .46-.65h2.83L2.46 3.16A1 1 0 0 0 2 4v1.54q-.57.33-1 .81V4a2 2 0 0 1 .74-1.55l-.6-.6a.5.5 0 0 1 0-.7M4 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6m9-4a2 2 0 0 1 2 2v6a2 2 0 0 1-1.1 1.78l-.79-.79A1 1 0 0 0 14 10V4a1 1 0 0 0-1-1H5.12l-1-1zm-1.5 3a.5.5 0 0 1 0 1H8.12l-1-1z"
]);
const $db6ad3fef28672ff$export$3e92289e0236fe66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CertificateOff20Filled', "20", [
    "M8 18a.5.5 0 0 1-.8.4l-1.4-1.05a.5.5 0 0 0-.6 0L3.8 18.4A.5.5 0 0 1 3 18v-2.76a4.5 4.5 0 0 0 5 0zM2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15H9v-.67a4.5 4.5 0 0 0 .91-3.71L6.38 7.09A4.5 4.5 0 0 0 2 8.67V5a2 2 0 0 1 .74-1.55l-.6-.6a.5.5 0 0 1 0-.7M5.5 8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M16 3a2 2 0 0 1 2 2v8a2 2 0 0 1-1.1 1.78L9.12 7h5.38a.5.5 0 0 0 0-1H8.12l-3-3z"
]);
const $db6ad3fef28672ff$export$f44f186537cfe9ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CertificateOff20Regular', "20", [
    "M8 18a.5.5 0 0 1-.8.4l-1.4-1.05a.5.5 0 0 0-.6 0L3.8 18.4A.5.5 0 0 1 3 18v-2.76a4.5 4.5 0 0 0 5 0zM2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15H9v-.67q.13-.16.24-.33h4.05L3.46 4.16A1 1 0 0 0 3 5v2.76q-.57.38-1 .91V5a2 2 0 0 1 .74-1.55l-.6-.6a.5.5 0 0 1 0-.7M5.5 8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M16 3a2 2 0 0 1 2 2v8a2 2 0 0 1-1.1 1.78l-.79-.79A1 1 0 0 0 17 13V5a1 1 0 0 0-1-1H6.12l-1-1zm-1.5 3a.5.5 0 0 1 0 1H9.12l-1-1z"
]);
const $db6ad3fef28672ff$export$9d112bfec26a80d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CertificateOff24Filled', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06L16.94 18H10v-1a5 5 0 0 0-8-6V5.75c0-.74.3-1.42.78-1.91l-.56-.56a.75.75 0 0 1 0-1.06M9 21.25v.1a.75.75 0 0 1-1.18.51L6 20.6l-1.82 1.27-.09.06A.75.75 0 0 1 3 21.25V18a5 5 0 0 0 6 0zM6 10a4 4 0 1 1 0 8 4 4 0 0 1 0-8m13.25-7A2.75 2.75 0 0 1 22 5.75v9.5c0 .97-.5 1.82-1.26 2.3L11.68 8.5h5.57a.75.75 0 0 0 0-1.5h-7.07l-4-4z"
]);
const $db6ad3fef28672ff$export$a41e84ea2bc39a03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CertificateOff24Regular', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06L16.94 18H10v-1q.18-.24.33-.5h5.11L3.84 4.9q-.33.34-.34.85v3.92Q2.61 10.19 2 11V5.75c0-.74.3-1.42.78-1.91l-.56-.56a.75.75 0 0 1 0-1.06M9 21.25v.1a.75.75 0 0 1-1.18.51L6 20.6l-1.82 1.27-.09.06A.75.75 0 0 1 3 21.25V18a5 5 0 0 0 6 0zM6 10a4 4 0 1 1 0 8 4 4 0 0 1 0-8m13.25-7A2.75 2.75 0 0 1 22 5.75v9.5c0 .97-.5 1.82-1.26 2.3l-1.12-1.1c.51-.17.88-.64.88-1.2v-9.5c0-.69-.56-1.25-1.25-1.25H7.68L6.18 3zm-2 4a.75.75 0 0 1 0 1.5h-5.57L10.18 7z"
]);
const $db6ad3fef28672ff$export$53bb351b64a1ed96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop16Filled', "16", [
    "M5 1.75a.75.75 0 0 0-1.5 0V3.5H1.75a.75.75 0 0 0 0 1.5H3.5v4.5a3 3 0 0 0 3 3H11v1.75a.75.75 0 0 0 1.5 0V12.5h1.75a.75.75 0 0 0 0-1.5H6.5A1.5 1.5 0 0 1 5 9.5zm6 4.75V10h1.5V6.5a3 3 0 0 0-3-3H6V5h3.5c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$c50364ce100a36ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop16Regular', "16", [
    "M5 1.5a.5.5 0 0 0-1 0V4H1.5a.5.5 0 0 0 0 1H4v4.5A2.5 2.5 0 0 0 6.5 12H11v2.5a.5.5 0 0 0 1 0V12h2.5a.5.5 0 0 0 0-1h-8A1.5 1.5 0 0 1 5 9.5zm6 5V10h1V6.5A2.5 2.5 0 0 0 9.5 4H6v1h3.5c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$37f64c5117c91ac7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop20Filled', "20", [
    "M6 2.75a.75.75 0 0 0-1.5 0V4.5H2.75a.75.75 0 0 0 0 1.5H4.5v6.75a2.75 2.75 0 0 0 2.75 2.75H14v1.75a.75.75 0 0 0 1.5 0V15.5h1.75a.75.75 0 0 0 0-1.5h-10C6.56 14 6 13.44 6 12.75zm8 4.5V13h1.5V7.25a2.75 2.75 0 0 0-2.75-2.75H7V6h5.75c.69 0 1.25.56 1.25 1.25"
]);
const $db6ad3fef28672ff$export$f3147452330f9074 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop20Regular', "20", [
    "M6 2.5a.5.5 0 0 0-1 0V5H2.5a.5.5 0 0 0 0 1H5v6.5A2.5 2.5 0 0 0 7.5 15H14v2.5a.5.5 0 0 0 1 0V15h2.5a.5.5 0 0 0 0-1h-10A1.5 1.5 0 0 1 6 12.5zm8 5V13h1V7.5A2.5 2.5 0 0 0 12.5 5H7v1h5.5c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$a6a8d31d8da46e72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop24Filled', "24", [
    "M7 15.5c0 .78.6 1.42 1.36 1.5H21a1 1 0 0 1 .12 2H19v2a1 1 0 0 1-2 .12V19H8.5A3.5 3.5 0 0 1 5 15.7V7H3a1 1 0 0 1-.12-2H5V3a1 1 0 0 1 2-.12V15.5M8 5h7.5A3.5 3.5 0 0 1 19 8.3V16h-2V8.5c0-.78-.6-1.42-1.36-1.5H8z"
]);
const $db6ad3fef28672ff$export$5c108d96f81aeff7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop24Regular', "24", [
    "M21.25 17a.75.75 0 0 1 .1 1.5H18.5v2.75a.75.75 0 0 1-1.5.1V18.5H8.75a3.25 3.25 0 0 1-3.24-3.07l-.01-.18V7H2.75a.75.75 0 0 1-.1-1.5H5.5V2.75a.75.75 0 0 1 1.5-.1v12.6c0 .92.7 1.67 1.6 1.74l.15.01zM8 5.5h7.25a3.25 3.25 0 0 1 3.24 3.07l.01.18V16H17V8.75c0-.92-.7-1.67-1.6-1.74L15.24 7H8z"
]);
const $db6ad3fef28672ff$export$e832c6764cad03dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop28Filled', "28", [
    "M8 3a1 1 0 0 0-2 0v3H3a1 1 0 0 0 0 2h3v9.75C6 20.1 7.9 22 10.25 22H20v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2H10.25C9.01 20 8 19 8 17.75zm12 7.25V19h2v-8.75C22 7.9 20.1 6 17.75 6H9v2h8.75C18.99 8 20 9 20 10.25"
]);
const $db6ad3fef28672ff$export$f0aafa76d2909a5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop28Regular', "28", [
    "M8 2.75a.75.75 0 0 0-1.5 0V6.5H2.75a.75.75 0 0 0 0 1.5H6.5v9.75a3.75 3.75 0 0 0 3.75 3.75H20v3.75a.75.75 0 0 0 1.5 0V21.5h3.75a.75.75 0 0 0 0-1.5h-15C9.01 20 8 19 8 17.75zm12 7.5V19h1.5v-8.75a3.75 3.75 0 0 0-3.75-3.75H9V8h8.75C18.99 8 20 9 20 10.25"
]);
const $db6ad3fef28672ff$export$e1cdfbf464015b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop32Filled', "32", [
    "M9 3.25a1.25 1.25 0 1 0-2.5 0V6.5H3.25a1.25 1.25 0 1 0 0 2.5H6.5v11.5a5 5 0 0 0 5 5H23v3.25a1.25 1.25 0 1 0 2.5 0V25.5h3.25a1.25 1.25 0 1 0 0-2.5H11.5A2.5 2.5 0 0 1 9 20.5zm14 8.25v10h2.5v-10a5 5 0 0 0-5-5h-10V9h10a2.5 2.5 0 0 1 2.5 2.5"
]);
const $db6ad3fef28672ff$export$4c71505f60a5619b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop32Light', "32", [
    "M8 2.5a.5.5 0 0 0-1 0V7H2.5a.5.5 0 0 0 0 1H7v12.5a4.5 4.5 0 0 0 4.5 4.5H24v4.5a.5.5 0 0 0 1 0V25h4.5a.5.5 0 0 0 0-1h-18A3.5 3.5 0 0 1 8 20.5zM20.5 8h-11V7h11a4.5 4.5 0 0 1 4.5 4.5v11h-1v-11A3.5 3.5 0 0 0 20.5 8"
]);
const $db6ad3fef28672ff$export$f5e3e0c24b8d16a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop32Regular', "32", [
    "M9 3a1 1 0 0 0-2 0v4H3a1 1 0 0 0 0 2h4v11.5a4.5 4.5 0 0 0 4.5 4.5H23v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2H11.5A2.5 2.5 0 0 1 9 20.5zm14 8.5v10h2v-10A4.5 4.5 0 0 0 20.5 7h-10v2h10a2.5 2.5 0 0 1 2.5 2.5"
]);
const $db6ad3fef28672ff$export$64e7516d3917ac3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop48Filled', "48", [
    "M14 5.5a1.5 1.5 0 0 0-3 0V11H5.5a1.5 1.5 0 0 0 0 3H11v16.25A6.75 6.75 0 0 0 17.75 37H34v5.5a1.5 1.5 0 0 0 3 0V37h5.5a1.5 1.5 0 0 0 0-3H17.75A3.75 3.75 0 0 1 14 30.25zm20 12.25V32h3V17.75A6.75 6.75 0 0 0 30.25 11H16v3h14.25A3.75 3.75 0 0 1 34 17.75"
]);
const $db6ad3fef28672ff$export$7b3bd20d24f36c2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crop48Regular', "48", [
    "M14 5.25a1.25 1.25 0 1 0-2.5 0v6.25H5.25a1.25 1.25 0 1 0 0 2.5h6.25v16.25c0 3.45 2.8 6.25 6.25 6.25H34v6.25a1.25 1.25 0 1 0 2.5 0V36.5h6.25a1.25 1.25 0 1 0 0-2.5h-25A3.75 3.75 0 0 1 14 30.25zm20 12.5V32h2.5V17.75c0-3.45-2.8-6.25-6.25-6.25H16V14h14.25A3.75 3.75 0 0 1 34 17.75"
]);
const $db6ad3fef28672ff$export$774f542de248f6ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropArrowRotate16Filled', "16", [
    "M8 2.5c-1.8 0-3.4.86-4.4 2.2a.75.75 0 0 1-1.2-.9 7 7 0 0 1 10.1-1.16v-.89a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h.41c-.9-.63-1.98-1-3.16-1m-3.16 10h.41a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-.89a6.97 6.97 0 0 0 10.1-1.16.75.75 0 1 0-1.2-.9 5.5 5.5 0 0 1-7.56 1.2M5.75 4c.41 0 .75.34.75.75v4c0 .41.34.75.75.75h4a.75.75 0 0 1 0 1.5H11v.25a.75.75 0 0 1-1.5 0V11H7.25C6.01 11 5 10 5 8.75V6.5h-.25a.75.75 0 0 1 0-1.5H5v-.25c0-.41.34-.75.75-.75M9.5 7.25V8.5H11V7.25C11 6.01 10 5 8.75 5H7.5v1.5h1.25c.41 0 .75.34.75.75"
]);
const $db6ad3fef28672ff$export$471723c2e7261042 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropArrowRotate16Regular', "16", [
    "M8 2a6 6 0 0 0-5.06 2.77.5.5 0 1 1-.84-.54A7 7 0 0 1 13 3.1V2a.5.5 0 0 1 1 0v2.5a.5.5 0 0 1-.5.5H11a.5.5 0 0 1 0-1h1.47C11.37 2.77 9.77 2 8 2M3.53 12H5a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 1 0v-1.1a6.98 6.98 0 0 0 10.9-1.13.5.5 0 1 0-.84-.54 6 6 0 0 1-9.53.77M5.5 3.5c.28 0 .5.22.5.5v5a1 1 0 0 0 1 1h5a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1H7a2 2 0 0 1-2-2V6H4a.5.5 0 0 1 0-1h1V4c0-.28.22-.5.5-.5M10 7v2h1V7a2 2 0 0 0-2-2H7v1h2a1 1 0 0 1 1 1"
]);
const $db6ad3fef28672ff$export$9bc284efc35f9dec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropArrowRotate20Filled', "20", [
    "M10 3a7 7 0 0 0-6.13 3.62.75.75 0 1 1-1.31-.73A8.5 8.5 0 0 1 16.5 4.52V3.25a.75.75 0 0 1 1.5 0v3c0 .41-.34.75-.75.75h-3a.75.75 0 0 1 0-1.5h1.11A7 7 0 0 0 10 3M3.5 16.75v-1.27a8.48 8.48 0 0 0 13.94-1.37.75.75 0 1 0-1.3-.73 7 7 0 0 1-11.5 1.12h1.11a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0M7 7H5.75a.75.75 0 0 0 0 1.5H7v2.25C7 11.99 8 13 9.25 13h2.25v1.25a.75.75 0 0 0 1.5 0V13h1.25a.75.75 0 0 0 0-1.5h-5a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 0-1.5 0zm4.5 3.5V9.25a.75.75 0 0 0-.75-.75H9.5V7h1.25C11.99 7 13 8 13 9.25v1.25z"
]);
const $db6ad3fef28672ff$export$eb749e3590ac02b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropArrowRotate20Regular', "20", [
    "M3.8 6.73A7 7 0 0 1 15.75 6H14a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.84a8 8 0 0 0-13.58.93.5.5 0 1 0 .89.46M6 14H4.25a7 7 0 0 0 11.94-.73.5.5 0 0 1 .89.46 8 8 0 0 1-13.58.94v1.83a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1m1.5-9c.28 0 .5.22.5.5V11a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V13H9a2 2 0 0 1-2-2V8H5.5a.5.5 0 0 1 0-1H7V5.5c0-.28.22-.5.5-.5m4.5 6V9a1 1 0 0 0-1-1H9V7h2a2 2 0 0 1 2 2v2z"
]);
const $db6ad3fef28672ff$export$d64c749a427376da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropArrowRotate24Filled', "24", [
    "M5.33 7.56A8 8 0 0 1 17.3 6H17a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v.85a10.01 10.01 0 0 0-15.33 1.6 1 1 0 1 0 1.66 1.1M5 19.16V20a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-.3a8.01 8.01 0 0 0 11.97-1.56 1 1 0 0 1 1.66 1.12A10.02 10.02 0 0 1 5 19.16M10 7a1 1 0 0 0-2 0v1H7a1 1 0 0 0 0 2h1v3a3 3 0 0 0 3 3h3v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-6a1 1 0 0 1-1-1zm4 3.88V13h2v-2.12C16 9.3 14.71 8 13.12 8H11v2h2.12c.49 0 .88.4.88.88"
]);
const $db6ad3fef28672ff$export$ee1d87a730fce78e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropArrowRotate24Regular', "24", [
    "M4.7 7.64A8.5 8.5 0 0 1 18.48 6.5h-1.73a.75.75 0 0 0 0 1.5h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-1.5 0v1.64A9.98 9.98 0 0 0 3.42 6.86a.75.75 0 0 0 1.28.78m-.2 10.98v1.63a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5H5.52a8.48 8.48 0 0 0 13.78-1.14.75.75 0 1 1 1.28.78A10 10 0 0 1 4.5 18.62m5-11.87a.75.75 0 0 0-1.5 0V8H6.75a.75.75 0 0 0 0 1.5H8v3.75A2.75 2.75 0 0 0 10.75 16h3.75v1.25a.75.75 0 0 0 1.5 0V16h1.25a.75.75 0 0 0 0-1.5h-6.5c-.69 0-1.25-.56-1.25-1.25zm5 4v2.75H16v-2.75A2.75 2.75 0 0 0 13.25 8H10.5v1.5h2.75c.69 0 1.25.56 1.25 1.25"
]);
const $db6ad3fef28672ff$export$c0323c60f0b8ff65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterim20Filled', "20", [
    "M7 4h3a2 2 0 0 0 1.77 1.99l.47 4.16A2 2 0 0 0 11 12H6a2 2 0 0 0-1.24-1.85L5.23 6A2 2 0 0 0 7 4m6.23 6.01-.47-4.16A2 2 0 1 0 10.26 3H6.74a2 2 0 1 0-2.5 2.85L3.78 10A2 2 0 1 0 5.73 13h5.54a2 2 0 1 0 1.96-2.99m.74-2.4A4.5 4.5 0 1 1 9.65 15h.85a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-.72A5.48 5.48 0 0 0 18.5 12a5.5 5.5 0 0 0-4.65-5.43z"
]);
const $db6ad3fef28672ff$export$fb05a81906972edf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterim20Regular', "20", [
    "M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2-1H7a2 2 0 0 1-1.77 1.99l-.47 4.16A2 2 0 0 1 6 12h5a2 2 0 0 1 1.24-1.85L11.77 6A2 2 0 0 1 10 4m1.27 9H5.73a2 2 0 1 1-1.96-2.99l.47-4.16A2 2 0 1 1 6.74 3h3.53a2 2 0 1 1 2.5 2.85l.46 4.16A2 2 0 1 1 11.27 13M3 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0m2-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1.97-4.4A4.5 4.5 0 1 1 9.65 15h.85a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-.72A5.48 5.48 0 0 0 18.5 12a5.5 5.5 0 0 0-4.65-5.43z"
]);
const $db6ad3fef28672ff$export$3c101a288175c399 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterim24Filled', "24", [
    "M16.67 9.1a6.5 6.5 0 1 1-5.17 11.52v.63c0 .38-.29.7-.65.74l-.1.01a.75.75 0 0 1-.75-.65v-2.6c0-.38.28-.7.64-.74h2.61a.75.75 0 0 1 .1 1.48l-.1.01h-.74a4.98 4.98 0 0 0 8-4 5 5 0 0 0-3.6-4.8zM14.5 3a2.5 2.5 0 0 1 .97 4.8l.82 5.32A2.5 2.5 0 1 1 13.5 17H6.5a2.5 2.5 0 1 1-2.78-3.88l.82-5.3A2.5 2.5 0 1 1 7.5 4h4.99c.46-.6 1.18-1 2-1m-2.5 2.5H8c0 1.2-.84 2.2-1.96 2.45l-.8 5.16A2.5 2.5 0 0 1 7 15.31l.01.19h6a2.5 2.5 0 0 1 1.76-2.39l-.8-5.16A2.5 2.5 0 0 1 12 5.67z"
]);
const $db6ad3fef28672ff$export$d604c967cf4032bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterim24Regular', "24", [
    "M16.67 9.1a6.5 6.5 0 1 1-5.17 11.52v.63c0 .38-.29.7-.65.74l-.1.01a.75.75 0 0 1-.75-.65v-2.6c0-.38.28-.7.64-.74h2.61a.75.75 0 0 1 .1 1.48l-.1.01h-.74a4.98 4.98 0 0 0 8-4 5 5 0 0 0-3.6-4.8zM14.5 3a2.5 2.5 0 0 1 .97 4.8l.82 5.32A2.5 2.5 0 1 1 13.5 17H6.5a2.5 2.5 0 1 1-2.78-3.88l.82-5.3A2.5 2.5 0 1 1 7.5 4h4.99c.46-.6 1.18-1 2-1M4.5 14.5h-.12a1 1 0 0 0 0 2h.12a1 1 0 0 0 1-.88v-.24a1 1 0 0 0-.52-.76l-.11-.05-.12-.04-.1-.02zm10.7.05-.06.02-.06.03-.1.05a1 1 0 0 0 .4 1.84l.12.01a1 1 0 0 0 .12-2h-.12l-.16.01zM11.98 5.5H8c0 1.2-.84 2.2-1.96 2.45l-.8 5.16A2.5 2.5 0 0 1 7 15.31l.01.19h6a2.5 2.5 0 0 1 1.76-2.39l-.8-5.16A2.5 2.5 0 0 1 12 5.67zm1.77.7.03.02.12.1.08.05.1.05.1.04.1.02.07.02h.25l.17-.04.12-.05.09-.04.1-.06.1-.1.08-.08a1 1 0 0 0-.3-1.5l-.1-.05-.15-.05-.08-.01-.15-.02-.12.01a1 1 0 0 0-.6 1.69M4.5 5.5a1 1 0 0 0 .22.63l.07.07.19.16.1.05.1.04.09.03.1.02h.13l.17-.01.07-.02.11-.03.06-.02.15-.09.08-.06.06-.05.08-.1.06-.08a1 1 0 0 0 .15-.42l.01-.12v-.12l-.03-.1-.01-.07a1 1 0 0 0-.84-.7h-.29l-.08.02-.09.03-.05.02-.1.05a1 1 0 0 0-.51.87"
]);
const $db6ad3fef28672ff$export$e8bcd50e5e17e047 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterimOff20Filled', "20", [
    "m3.02 3.73-.87-.88a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-1.2-1.2A5.5 5.5 0 0 1 9 15.78v.72a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.85a4.5 4.5 0 0 0 5.56.92l-1.94-1.94L13 14a2 2 0 0 1-1.73-1H5.73a2 2 0 1 1-1.96-2.99l.47-4.16a2 2 0 0 1-1.22-2.12m8 8L5.27 5.98h-.04l-.47 4.17A2 2 0 0 1 6 12h5q0-.14.02-.27m.75-5.74.46 4.12 2.63 2.63A2 2 0 0 0 13.23 10l-.47-4.16A2 2 0 1 0 10.26 3H6.74a2 2 0 0 0-2.47-.86l2.6 2.6A2 2 0 0 0 7 4h3a2 2 0 0 0 1.77 1.99m4.92 8.58.72.72a5.5 5.5 0 0 0-3.56-8.72l.12 1.03a4.5 4.5 0 0 1 2.72 6.97"
]);
const $db6ad3fef28672ff$export$bc439b28d95bd6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterimOff20Regular', "20", [
    "m3.02 3.73-.87-.88a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-1.2-1.2A5.5 5.5 0 0 1 9 15.78v.72a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.85a4.5 4.5 0 0 0 5.56.92l-1.94-1.94L13 14a2 2 0 0 1-1.73-1H5.73a2 2 0 1 1-1.96-2.99l.47-4.16a2 2 0 0 1-1.22-2.12m8 8L5.27 5.98h-.04l-.47 4.17A2 2 0 0 1 6 12h5q0-.14.02-.27m.75-5.74.46 4.12 2.63 2.63A2 2 0 0 0 13.23 10l-.47-4.16A2 2 0 1 0 10.26 3H6.74a2 2 0 0 0-2.47-.86l.87.87a1 1 0 0 1 .86.86l.87.87A2 2 0 0 0 7 4h3a2 2 0 0 0 1.77 1.99m4.92 8.58.72.72a5.5 5.5 0 0 0-3.56-8.72l.12 1.03a4.5 4.5 0 0 1 2.72 6.97M12 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-9 7a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $db6ad3fef28672ff$export$3806c53dd3301536 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterimOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l1.06 1.06a2.5 2.5 0 0 0 1.26 3.47l-.82 5.31A2.5 2.5 0 1 0 6.5 17h7a2.5 2.5 0 0 0 3.16.72l1.8 1.8a5 5 0 0 1-5.95-.02h.84a.75.75 0 0 0-.1-1.5h-2.6a.75.75 0 0 0-.65.75v2.6c.05.37.37.65.75.65h.1a.75.75 0 0 0 .65-.75v-.63a6.5 6.5 0 0 0 8.04-.02l1.18 1.18a.75.75 0 0 0 1.06-1.06zm10 12.13q-.27.51-.28 1.15H7v-.19a2.5 2.5 0 0 0-1.76-2.2l.8-5.16q.33-.08.62-.23zM7.19 4l1.5 1.5h3.3l.01.17a2.5 2.5 0 0 0 1.97 2.28l.52 3.35 1.8 1.8-.82-5.3A2.5 2.5 0 1 0 12.49 4zm13.07 13.07 1.16 1.16q.59-1.26.6-2.73a6.5 6.5 0 0 0-5.34-6.4l.25 1.6a5 5 0 0 1 3.33 6.37"
]);
const $db6ad3fef28672ff$export$8a3144302fd99c6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropInterimOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l1.06 1.06a2.5 2.5 0 0 0 1.26 3.47l-.82 5.31A2.5 2.5 0 1 0 6.5 17h7a2.5 2.5 0 0 0 3.16.72l1.8 1.8a5 5 0 0 1-5.95-.02h.84a.75.75 0 0 0-.1-1.5h-2.6a.75.75 0 0 0-.65.75v2.6c.05.37.37.65.75.65h.1a.75.75 0 0 0 .65-.75v-.63a6.5 6.5 0 0 0 8.04-.02l1.18 1.18a.75.75 0 0 0 1.06-1.06zm10 12.13q-.27.51-.28 1.15H7v-.19a2.5 2.5 0 0 0-1.76-2.2l.8-5.16q.33-.08.62-.23zm-8.78.15.16.01.08.02.13.04.1.05a1 1 0 0 1 .52.76l.01.12v.12a1 1 0 0 1-1 .88h-.12a1 1 0 0 1 0-2zM7.18 4l1.5 1.5h3.3l.01.17a2.5 2.5 0 0 0 1.97 2.28l.52 3.35 1.8 1.8-.82-5.3A2.5 2.5 0 1 0 12.5 4zm6.58 2.2a1 1 0 0 1 .61-1.69h.27l.08.02.15.05.1.06v-.01a1 1 0 0 1 .3 1.5l-.08.08-.1.1-.1.06-.09.04-.12.05-.17.04h-.25l-.08-.02-.09-.02-.1-.04-.1-.05-.08-.05-.12-.1zm6.5 10.87 1.15 1.16q.59-1.26.6-2.73a6.5 6.5 0 0 0-5.34-6.4l.25 1.6a5 5 0 0 1 3.33 6.37"
]);
const $db6ad3fef28672ff$export$e38743bc1dad3a71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropSparkle24Filled', "24", [
    "M8.36 17A1.5 1.5 0 0 1 7 15.5V2.88A1 1 0 0 0 5 3v2H2.88A1 1 0 0 0 3 7h2v8.7A3.5 3.5 0 0 0 8.5 19h4.68l-.14-.04a1.54 1.54 0 0 1-.96-1.96H8.36M19 13.24l-.07-.2v-.02a1.54 1.54 0 0 0-1.93-.96V8.5c0-.78-.6-1.42-1.36-1.5H8V5h7.5A3.5 3.5 0 0 1 19 8.3v4.95m4.21-.68.62.2a.24.24 0 0 1 0 .46l-.6.2a1.3 1.3 0 0 0-.8.8l-.2.6a.24.24 0 0 1-.37.13.2.2 0 0 1-.09-.12l-.2-.61a1.3 1.3 0 0 0-.8-.8l-.6-.2a.24.24 0 0 1 0-.46l.6-.2a1.3 1.3 0 0 0 .8-.8l.19-.6a.24.24 0 0 1 .46 0l.2.6a1.3 1.3 0 0 0 .8.8m-7.12 6.84a3 3 0 0 0-1.35-.95L13.36 18a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85"
]);
const $db6ad3fef28672ff$export$86bcad85de064b65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CropSparkle24Regular', "24", [
    "M8.75 18.5h3.62a1.5 1.5 0 0 1-.29-1.5H8.61C7.7 16.91 7 16.16 7 15.24V2.65a.75.75 0 0 0-1.5.1V5.5H2.65a.75.75 0 0 0 .1 1.5H5.5v8.43a3.25 3.25 0 0 0 3.25 3.07m9.61-6.22.14.11V8.57a3.25 3.25 0 0 0-3.25-3.07H8V7h7.39c.9.08 1.61.83 1.61 1.75v3.32a1.6 1.6 0 0 1 1.36.21m4.85.3.62.2a.24.24 0 0 1 0 .45l-.6.2a1.3 1.3 0 0 0-.8.8l-.2.6a.24.24 0 0 1-.37.13.2.2 0 0 1-.09-.12l-.2-.61a1.3 1.3 0 0 0-.8-.8l-.6-.2a.24.24 0 0 1 0-.46l.6-.2a1.3 1.3 0 0 0 .8-.8l.19-.6a.24.24 0 0 1 .46 0l.2.6a1.3 1.3 0 0 0 .8.8m-7.36 6.57a3 3 0 0 1 .69 1.11l.45 1.38a.54.54 0 0 0 1.02 0l.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03l-1.38-.45a2.8 2.8 0 0 1-1.8-1.8L18 13.36a.54.54 0 0 0-1.03 0l-.45 1.38-.01.03a2.8 2.8 0 0 1-1.76 1.77l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.64.21 1.11.69"
]);
const $db6ad3fef28672ff$export$a4e5857f9fbda6df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crown16Filled', "16", [
    "M10.4 5.72 8.76 3.65a1 1 0 1 0-1.52 0L5.6 5.72a.5.5 0 0 1-.6.14L2.48 4.68l.02-.18a1 1 0 1 0-.91 1l1.3 6.5c.12.58.63 1 1.22 1h7.78c.6 0 1.1-.42 1.22-1l1.3-6.5h.09a1 1 0 1 0-.98-.82L11 5.86a.5.5 0 0 1-.6-.14M8 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$c39ee0e7a4640544 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crown16Regular', "16", [
    "M8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2.4-4.28L8.76 3.65a1 1 0 1 0-1.52 0L5.6 5.72a.5.5 0 0 1-.6.14L2.48 4.68l.02-.18a1 1 0 1 0-.91 1l1.3 6.5c.12.58.63 1 1.22 1h7.78c.6 0 1.1-.42 1.22-1l1.3-6.5h.09a1 1 0 1 0-.98-.82L11 5.86a.5.5 0 0 1-.6-.14M8 4.3l1.62 2.04a1.5 1.5 0 0 0 1.81.42l1.88-.88-1.18 5.92a.25.25 0 0 1-.24.2H4.1a.25.25 0 0 1-.24-.2L2.69 5.88l1.88.88c.63.3 1.38.13 1.81-.42z"
]);
const $db6ad3fef28672ff$export$8b083ba21a5baf6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crown20Filled', "20", [
    "M8.74 5.31 6.6 8.05a.5.5 0 0 1-.62.14L3.86 7.12Q4 6.83 4 6.5a1.5 1.5 0 1 0-1.8 1.47L3.88 16c.12.58.63.99 1.22.99h9.78c.6 0 1.1-.41 1.22-1l1.7-8.03a1.5 1.5 0 1 0-1.67-.85L14 8.2a.5.5 0 0 1-.62-.14L11.26 5.3q.23-.35.24-.81a1.5 1.5 0 1 0-2.76.81M10 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $db6ad3fef28672ff$export$bb46dc724c5c3a11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crown20Regular', "20", [
    "M11.5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.74 5.31 6.6 8.05a.5.5 0 0 1-.62.14L3.86 7.12q.15-.29.14-.62a1.5 1.5 0 1 0-1.8 1.47L3.88 16c.12.58.63.99 1.22.99h9.78c.6 0 1.1-.41 1.22-1l1.7-8.03a1.5 1.5 0 1 0-1.67-.85L14 8.2a.5.5 0 0 1-.62-.14L11.26 5.3q.23-.35.24-.81a1.5 1.5 0 1 0-2.76.8m1.26 0 2.6 3.35a1.5 1.5 0 0 0 1.86.42l2.34-1.17-1.66 7.9a.25.25 0 0 1-.25.19H5.11a.25.25 0 0 1-.25-.2L3.2 7.91l2.34 1.17a1.5 1.5 0 0 0 1.86-.42z"
]);
const $db6ad3fef28672ff$export$1d5e3fa9b51b7735 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crown24Filled', "24", [
    "M14 5a2 2 0 0 1-.54 1.37l2.62 3.28c.07.1.2.12.3.07l2.66-1.33a2 2 0 1 1 2.4 1.56l-1.8 9.62A1.75 1.75 0 0 1 17.92 21H6.08c-.84 0-1.56-.6-1.72-1.43l-1.8-9.62a2 2 0 1 1 2.4-1.56l2.65 1.33c.1.05.24.02.3-.07l2.63-3.28A2 2 0 0 1 12 3a2 2 0 0 1 2 2m-2 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $db6ad3fef28672ff$export$28881e94729aa9e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Crown24Regular', "24", [
    "M12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-12a2 2 0 0 1-.54 1.37l2.62 3.28c.07.1.2.12.3.07l2.66-1.33a2 2 0 1 1 2.4 1.56l-1.8 9.62A1.75 1.75 0 0 1 17.92 21H6.08c-.84 0-1.56-.6-1.72-1.43l-1.8-9.62a2 2 0 1 1 2.4-1.56l2.65 1.33c.1.05.24.02.3-.07l2.63-3.28A2 2 0 0 1 12 3a2 2 0 0 1 2 2m-2 2h-.04L9.1 10.59c-.51.64-1.41.84-2.15.47l-2.81-1.4-.1.05 1.8 9.59q.06.18.25.2h11.84q.2-.02.25-.2l1.8-9.59-.1-.06-2.81 1.4c-.74.38-1.64.18-2.15-.46L12.04 7z"
]);
const $db6ad3fef28672ff$export$bfd437c4a6197418 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CrownSubtract20Filled', "20", [
    "M8.74 5.31 6.6 8.05a.5.5 0 0 1-.62.14L3.86 7.12Q4 6.83 4 6.5a1.5 1.5 0 1 0-1.8 1.47L3.88 16c.12.58.63.99 1.22.99H9.6q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 8.41-4.67l.4-1.86a1.5 1.5 0 1 0-1.67-.85L14 8.2a.5.5 0 0 1-.62-.14L11.26 5.3q.23-.35.24-.81a1.5 1.5 0 1 0-2.76.81M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$f28bf0dcc8dea2fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CrownSubtract20Regular', "20", [
    "M8.74 5.31 6.6 8.05a.5.5 0 0 1-.62.14L3.86 7.12q.15-.29.14-.62a1.5 1.5 0 1 0-1.8 1.47L3.88 16c.12.58.63.99 1.22.99H9.6q-.24-.48-.4-1H5.1a.25.25 0 0 1-.24-.2L3.2 7.91l2.34 1.17a1.5 1.5 0 0 0 1.86-.42L10 5.31l2.6 3.35q.27.34.65.48A6 6 0 0 1 14.62 9l2.18-1.09-.31 1.46q.48.2.92.46l.4-1.86a1.5 1.5 0 1 0-1.67-.85L14 8.2a.5.5 0 0 1-.62-.14L11.26 5.3q.23-.35.24-.81a1.5 1.5 0 1 0-2.76.8M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$537a59f33a94e731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CrownSubtract24Filled', "24", [
    "M13.46 6.37A2 2 0 0 0 12 3a2 2 0 0 0-1.46 3.37L7.92 9.65c-.07.1-.2.12-.3.07L4.95 8.39A2 2 0 0 0 3 6a2 2 0 0 0-.44 3.95l1.8 9.62c.16.83.88 1.43 1.72 1.43h5.94a6.5 6.5 0 0 1 9.03-8.95l.4-2.1a2 2 0 1 0-2.41-1.56l-2.65 1.33a.25.25 0 0 1-.3-.07zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9 0c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$d06b48e954bc1ad8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CrownSubtract24Regular', "24", [
    "M13.46 6.37A2 2 0 0 0 12 3a2 2 0 0 0-1.46 3.37L7.92 9.65c-.07.1-.2.12-.3.07L4.95 8.39A2 2 0 0 0 3 6a2 2 0 0 0-.44 3.95l1.8 9.62c.16.83.88 1.43 1.72 1.43h5.94q-.45-.7-.7-1.5H6.07a.25.25 0 0 1-.25-.2L4.03 9.7l.1-.06 2.81 1.4c.74.38 1.64.18 2.15-.46L11.96 7h.08l2.87 3.59q.4.49.98.61.6-.15 1.27-.2l2.71-1.35.1.06-.32 1.65q.75.27 1.4.7l.4-2.11a2 2 0 1 0-2.41-1.56l-2.65 1.33a.25.25 0 0 1-.3-.07zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9 0c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$4dcd9b5289f37e4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Frame16Filled', "16", [
    "M3.5 1c.28 0 .5.22.5.5V3h8V1.5a.5.5 0 0 1 1 0V3h1.5a.5.5 0 0 1 0 1H13v8h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V13H4v1.5a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H3V4H1.5a.5.5 0 0 1 0-1H3V1.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$d8cd7560863cbdfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Frame16Regular', "16", [
    "M4 1.5a.5.5 0 0 0-1 0V3H1.5a.5.5 0 0 0 0 1H3v8H1.5a.5.5 0 0 0 0 1H3v1.5a.5.5 0 0 0 1 0V13h8v1.5a.5.5 0 0 0 1 0V13h1.5a.5.5 0 0 0 0-1H13V4h1.5a.5.5 0 0 0 0-1H13V1.5a.5.5 0 0 0-1 0V3H4zM12 12H4V4h8z"
]);
const $db6ad3fef28672ff$export$e219bb7298f6be6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Frame20Filled', "20", [
    "M4.5 2c.28 0 .5.22.5.5V4h10V2.5a.5.5 0 0 1 1 0V4h1.5a.5.5 0 0 1 0 1H16v10h1.5a.5.5 0 0 1 0 1H16v1.5a.5.5 0 0 1-1 0V16H5v1.5a.5.5 0 0 1-1 0V16H2.5a.5.5 0 0 1 0-1H4V5H2.5a.5.5 0 0 1 0-1H4V2.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$3ebc39e46745aaef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Frame20Regular', "20", [
    "M5 2.5a.5.5 0 0 0-1 0V4H2.5a.5.5 0 0 0 0 1H4v10H2.5a.5.5 0 0 0 0 1H4v1.5a.5.5 0 0 0 1 0V16h10v1.5a.5.5 0 0 0 1 0V16h1.5a.5.5 0 0 0 0-1H16V5h1.5a.5.5 0 0 0 0-1H16V2.5a.5.5 0 0 0-1 0V4H5zM15 5v10H5V5z"
]);
const $db6ad3fef28672ff$export$771be7cbcfcf586d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Frame24Filled', "24", [
    "M5.25 2c.41 0 .75.34.75.75V4.5h12V2.75a.75.75 0 0 1 1.5 0V4.5h1.75a.75.75 0 0 1 0 1.5H19.5v12h1.75a.75.75 0 0 1 0 1.5H19.5v1.75a.75.75 0 0 1-1.5 0V19.5H6v1.75a.75.75 0 0 1-1.5 0V19.5H2.75a.75.75 0 0 1 0-1.5H4.5V6H2.75a.75.75 0 0 1 0-1.5H4.5V2.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$925e11e0c38e438e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Frame24Regular', "24", [
    "M6 2.75a.75.75 0 0 0-1.5 0V4.5H2.75a.75.75 0 0 0 0 1.5H4.5v12H2.75a.75.75 0 0 0 0 1.5H4.5v1.75a.75.75 0 0 0 1.5 0V19.5h12v1.75a.75.75 0 0 0 1.5 0V19.5h1.75a.75.75 0 0 0 0-1.5H19.5V6h1.75a.75.75 0 0 0 0-1.5H19.5V2.75a.75.75 0 0 0-1.5 0V4.5H6zM18 18H6V6h12z"
]);
const $db6ad3fef28672ff$export$cfd1a07e5664b14c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader16Filled', "16", [
    "M1 3.75C1 2.78 1.78 2 2.75 2H6c.79 0 1.5.33 2 .86.5-.53 1.21-.86 2-.86h3.25c.97 0 1.75.78 1.75 1.75V7.2a1.5 1.5 0 0 0-1.5 0V3.75a.25.25 0 0 0-.25-.25H10c-.69 0-1.25.56-1.25 1.25v3.38L7.88 9H7.5q-.13 0-.25.02V4.75c0-.69-.56-1.25-1.25-1.25H2.75a.25.25 0 0 0-.25.25v8.5c0 .14.11.25.25.25H6c0 .6.36 1.12.87 1.36Q6.45 14 6 14H2.75C1.78 14 1 13.22 1 12.25zm9.7 4.29q.29.14.3.46v6a.5.5 0 0 1-.85.35L8.29 13H7.5a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.95.16q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.15.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 1 1 .8-.6m-1.7 1.08a5.5 5.5 0 0 1 .55 2.22 5 5 0 0 1-.55 2.22.5.5 0 1 1-.9-.44l.08-.17.15-.4q.21-.63.22-1.21 0-.58-.22-1.22l-.23-.56a.5.5 0 1 1 .9-.44"
]);
const $db6ad3fef28672ff$export$8e1d34bc024f1e06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader16Regular', "16", [
    "M1 3.5C1 2.67 1.67 2 2.5 2H6c.82 0 1.54.4 2 1 .46-.6 1.18-1 2-1h3.5c.83 0 1.5.67 1.5 1.5v3.7a1.5 1.5 0 0 0-1-.18V3.5a.5.5 0 0 0-.5-.5H10c-.83 0-1.5.67-1.5 1.5v3.88L7.88 9H7.5V4.5C7.5 3.67 6.83 3 6 3H2.5a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5h3.58c.14.37.41.68.77.85Q6.45 14 6 14H2.5A1.5 1.5 0 0 1 1 12.5zm9.7 4.54q.29.14.3.46v6a.5.5 0 0 1-.85.35L8.29 13H7.5a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.95.16q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.15.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 1 1 .8-.6m-1.7 1.08a5.5 5.5 0 0 1 .55 2.22 5 5 0 0 1-.55 2.22.5.5 0 1 1-.9-.44l.08-.17.15-.4q.21-.63.22-1.21 0-.58-.22-1.22l-.23-.56a.5.5 0 1 1 .9-.44"
]);
const $db6ad3fef28672ff$export$12c6009a97a389be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader20Filled', "20", [
    "M18 4.75v5.45a1.5 1.5 0 0 0-1.5 0V4.75a.25.25 0 0 0-.25-.25H12c-.69 0-1.25.56-1.25 1.25V12h-.25c-.52 0-.98.27-1.25.67V5.75c0-.69-.56-1.25-1.25-1.25H3.75a.25.25 0 0 0-.25.25v10.5c0 .14.11.25.25.25H8c.4 0 .77-.2 1-.5v.5q.02.64.46 1.08Q8.82 17 8 17H3.75C2.78 17 2 16.22 2 15.25V4.75C2 3.78 2.78 3 3.75 3H8c.79 0 1.5.33 2 .86.5-.53 1.21-.86 2-.86h4.25c.97 0 1.75.78 1.75 1.75m.13 6.45q.2.24.45.87.39 1.03.4 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.84-.52l.11-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 1 1 .8-.6m-4.44-.16q.3.14.31.46v6a.5.5 0 0 1-.85.35L11.29 16h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.02 1.93q-.16-.46-.28-.7a.5.5 0 0 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.07.18a.5.5 0 0 0 .89.44 6 6 0 0 0 .55-2.22q0-.76-.27-1.53"
]);
const $db6ad3fef28672ff$export$96c4ac299d82c94c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader20Regular', "20", [
    "M18 4.5v5.7a1.5 1.5 0 0 0-1-.18V4.5a.5.5 0 0 0-.5-.5H12c-.83 0-1.5.67-1.5 1.5V12q-.58.01-1 .38V5.5C9.5 4.67 8.83 4 8 4H3.5a.5.5 0 0 0-.5.5v11c0 .28.22.5.5.5H8q.6-.02 1-.39.06.57.43.94-.62.43-1.43.45H3.5A1.5 1.5 0 0 1 2 15.5v-11C2 3.67 2.67 3 3.5 3H8c.82 0 1.54.4 2 1 .46-.6 1.18-1 2-1h4.5c.83 0 1.5.67 1.5 1.5m-4.3 6.54q.29.14.3.46v6a.5.5 0 0 1-.85.35L11.29 16h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m4.45.16q.19.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.26.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52A6 6 0 0 0 18 14.5a6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 0 1 .8-.6m-1.43 1.77q-.16-.46-.27-.7a.5.5 0 1 0-.9.45A5 5 0 0 1 16 14.5a4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44A5.5 5.5 0 0 0 17 14.5q0-.76-.28-1.53"
]);
const $db6ad3fef28672ff$export$e785d9575bfffa8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader24Filled', "24", [
    "M4 3a2 2 0 0 0-2 2v12.5c0 1.1.9 2 2 2h7.14A1 1 0 0 1 11 19v-1.5H4V5h6a1 1 0 0 1 1 1v10a1 1 0 0 1 1-1h1V6a1 1 0 0 1 1-1h6v7.17a1.75 1.75 0 0 1 2 .35V5a2 2 0 0 0-2-2h-6c-.77 0-1.47.29-2 .76A3 3 0 0 0 10 3zm17.23 10.17c.25.21.59.58.91 1.13.54.9.86 1.96.86 3.2s-.32 2.3-.86 3.2c-.32.55-.66.92-.91 1.13a.75.75 0 1 1-.96-1.16q.21-.15.59-.74c.4-.67.64-1.48.64-2.43q-.02-1.42-.64-2.43-.38-.59-.59-.74a.75.75 0 1 1 .96-1.16m-2.03 1.48q.3.21.67.75.62.88.63 2.1a3.7 3.7 0 0 1-1.3 2.85.75.75 0 0 1-.98-1.13l.08-.07q.1-.07.33-.38.36-.52.37-1.27a2.2 2.2 0 0 0-.7-1.65.75.75 0 0 1 .9-1.2m-2.69-.6c.3.1.49.39.49.7v5.5a.75.75 0 0 1-1.31.5L14.16 19h-1.41a.75.75 0 0 1-.75-.75v-1.5c0-.41.34-.75.75-.75h1.41l1.53-1.74c.2-.24.53-.32.82-.21"
]);
const $db6ad3fef28672ff$export$988f7f9ea65799a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader24Regular', "24", [
    "M11.13 19.5H3.75c-.97 0-1.75-.78-1.75-1.75v-13C2 3.78 2.78 3 3.75 3h6c.79 0 1.5.33 2 .86.5-.53 1.21-.86 2-.86h6c.97 0 1.75.78 1.75 1.75v7.42a1.8 1.8 0 0 0-1.5 0V4.75a.25.25 0 0 0-.25-.25h-6c-.69 0-1.25.56-1.25 1.25V15H12a1 1 0 0 0-1 1V5.75c0-.69-.56-1.25-1.25-1.25h-6a.25.25 0 0 0-.25.25v13c0 .14.11.25.25.25H11v1a1 1 0 0 0 .13.5m10.1-6.33c.25.21.59.58.91 1.13.54.9.86 1.96.86 3.2s-.32 2.3-.86 3.2c-.32.55-.66.92-.91 1.13a.75.75 0 1 1-.96-1.16q.21-.15.59-.74c.4-.67.64-1.48.64-2.43q-.02-1.42-.64-2.43-.38-.59-.59-.74a.75.75 0 1 1 .96-1.16m-2.03 1.48q.3.21.67.75.62.88.63 2.1a3.7 3.7 0 0 1-1.3 2.85.75.75 0 0 1-.98-1.13l.08-.07q.1-.07.33-.38.36-.52.37-1.27a2.2 2.2 0 0 0-.7-1.65.75.75 0 0 1 .9-1.2m-2.69-.6c.3.1.49.39.49.7v5.5a.75.75 0 0 1-1.31.5L14.16 19h-1.41a.75.75 0 0 1-.75-.75v-1.5c0-.41.34-.75.75-.75h1.41l1.53-1.74c.2-.24.53-.32.82-.21"
]);
const $db6ad3fef28672ff$export$75afdc14438df501 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader28Filled', "28", [
    "M11.5 4c.98 0 1.86.4 2.5 1.05A3.5 3.5 0 0 1 16.5 4H24a2 2 0 0 1 2 2v9.52l-.13-.11a1.8 1.8 0 0 0-1.87-.24V6h-7.5c-.83 0-1.5.67-1.5 1.5V17h-.25c-.97 0-1.75.78-1.75 1.75V7.5c0-.83-.67-1.5-1.5-1.5H4v16h7.5c.83 0 1.5-.67 1.5-1.5v1.75q.02.69.44 1.16-.84.57-1.94.59H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zM21 23.98l.02.02H21zm-1.49-7.93c.3.1.49.39.49.7v7.5a.75.75 0 0 1-1.31.5L17.16 23h-2.41a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75h2.41l1.53-1.74c.2-.24.53-.32.82-.21m6.63 1.25a5 5 0 0 0-.91-1.13.75.75 0 1 0-.96 1.16q.21.15.59.74c.4.67.64 1.48.64 2.43q-.02 1.42-.64 2.43-.38.59-.59.74a.75.75 0 1 0 .96 1.16c.25-.21.59-.58.91-1.13.54-.9.86-1.96.86-3.2s-.32-2.3-.86-3.2m-2.77 1.1q-.36-.53-.67-.75a.75.75 0 0 0-.9 1.2q.1.07.33.38.36.52.37 1.27a2.2 2.2 0 0 1-.7 1.65l-.08.07a.75.75 0 0 0 .98 1.13q.3-.21.67-.75.61-.88.63-2.1-.02-1.22-.63-2.1"
]);
const $db6ad3fef28672ff$export$186f7159f4d7b35f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader28Regular', "28", [
    "M11.5 4c1 0 1.9.46 2.5 1.17.6-.71 1.5-1.17 2.5-1.17h7.75c.97 0 1.75.78 1.75 1.75v9.77l-.13-.11c-.4-.33-.9-.46-1.37-.4V5.76a.25.25 0 0 0-.25-.25H16.5c-.97 0-1.75.78-1.75 1.75V17c-.64 0-1.2.34-1.5.85V7.25c0-.97-.78-1.75-1.75-1.75H3.75a.25.25 0 0 0-.25.25v16.5c0 .14.11.25.25.25h7.75c.64 0 1.2-.34 1.5-.85v.6q.01.66.41 1.13c-.53.39-1.2.62-1.91.62H3.75C2.78 24 2 23.22 2 22.25V5.75C2 4.78 2.78 4 3.75 4zM21 23.98l.02.02H21zm-1.49-7.93c.3.1.49.39.49.7v7.5a.75.75 0 0 1-1.31.5L17.16 23h-2.41a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75h2.41l1.53-1.74c.2-.24.53-.32.82-.21m6.63 1.25a5 5 0 0 0-.91-1.13.75.75 0 1 0-.96 1.16q.21.15.59.74c.4.67.64 1.48.64 2.43q-.02 1.42-.64 2.43-.38.59-.59.74a.75.75 0 1 0 .96 1.16c.25-.21.59-.58.91-1.13.54-.9.86-1.96.86-3.2s-.32-2.3-.86-3.2m-2.77 1.1q-.36-.53-.67-.75a.75.75 0 0 0-.9 1.2q.1.07.33.38.36.52.37 1.27a2.2 2.2 0 0 1-.7 1.65l-.08.07a.75.75 0 0 0 .98 1.13q.3-.21.67-.75.61-.88.63-2.1-.02-1.22-.63-2.1"
]);
const $db6ad3fef28672ff$export$5907363c68e62514 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader32Filled', "32", [
    "M26.8 17.05a1 1 0 0 1 .7.03c.13.08 3 1.86 3 6.39s-2.87 6.3-3 6.39a1 1 0 0 1-.5.14 1 1 0 0 1-.95-.75 1 1 0 0 1 .45-1.12c.09-.05 2-1.34 2-4.66 0-3.35-1.92-4.63-2-4.68a1 1 0 0 1 .3-1.74m-5.7.9a.75.75 0 0 1 .9.75v9.54a.8.8 0 0 1-.47.7.8.8 0 0 1-.82-.18L18 25.98h-1.25a1.25 1.25 0 0 1-1.25-1.26v-2.5a1.26 1.26 0 0 1 1.25-1.26H18l2.7-2.79q.16-.16.4-.21M12.5 4c1.39 0 2.63.6 3.5 1.54A4.7 4.7 0 0 1 19.5 4h7.75A2.75 2.75 0 0 1 30 6.75v10.63c-.8-1-1.56-1.49-1.7-1.58l-.11-.06-.11-.05a3 3 0 0 0-.58-.16V6.75a.25.25 0 0 0-.25-.25H19.5c-1.24 0-2.25 1-2.25 2.25v10.7h-.5c-.73 0-1.43.3-1.95.82l-.05.05V8.75c0-1.24-1-2.25-2.25-2.25H4.75a.25.25 0 0 0-.25.25v18.5c0 .14.11.25.25.25h7.75q.88-.02 1.5-.59a2.8 2.8 0 0 0 1.32 2.16c-.8.58-1.77.93-2.82.93H4.75A2.75 2.75 0 0 1 2 25.25V6.75A2.75 2.75 0 0 1 4.75 4zm11.93 15.46a1 1 0 0 1 .73.2 5 5 0 0 1 1.63 3.8 5 5 0 0 1-1.63 3.8 1 1 0 0 1-.62.23 1 1 0 0 1-.78-.38 1 1 0 0 1 .16-1.41 3 3 0 0 0 .87-2.23 3 3 0 0 0-.87-2.23 1 1 0 0 1 .51-1.78"
]);
const $db6ad3fef28672ff$export$2d47bcd4576f0310 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader32Light', "32", [
    "M26.8 17.05a1 1 0 0 1 .7.03c.13.08 3 1.86 3 6.39s-2.87 6.3-3 6.39a1 1 0 0 1-.5.14 1 1 0 0 1-.95-.75 1 1 0 0 1 .45-1.12c.09-.05 2-1.34 2-4.66 0-3.35-1.92-4.63-2-4.68a1 1 0 0 1 .3-1.74m-5.7.9a.75.75 0 0 1 .9.75v9.54a.8.8 0 0 1-.47.7.8.8 0 0 1-.82-.18L18 25.98h-1.25a1.25 1.25 0 0 1-1.25-1.26v-2.5a1.26 1.26 0 0 1 1.25-1.26H18l2.7-2.79q.16-.16.4-.21M12.74 4c1.39 0 2.6.76 3.25 1.88A3.8 3.8 0 0 1 19.25 4H28a2 2 0 0 1 2 2v11.38q-.54-.68-1-1.05V6a1 1 0 0 0-1-1h-8.75a2.75 2.75 0 0 0-2.75 2.75v11.26q-.54 0-1 .21V7.75A2.75 2.75 0 0 0 12.75 5H4a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h8.75c.68 0 1.3-.25 1.78-.66a3 3 0 0 0 .73.7c-.67.6-1.55.96-2.51.96H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm11.68 15.46a1 1 0 0 1 .73.2 5 5 0 0 1 1.63 3.8 5 5 0 0 1-1.63 3.8 1 1 0 0 1-.62.23 1 1 0 0 1-.78-.38 1 1 0 0 1 .16-1.41 3 3 0 0 0 .87-2.23 3 3 0 0 0-.87-2.23 1 1 0 0 1 .51-1.78"
]);
const $db6ad3fef28672ff$export$752c27eeff022ca1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader32Regular', "32", [
    "M26.8 17.05a1 1 0 0 1 .7.03c.13.08 3 1.86 3 6.39s-2.87 6.3-3 6.39a1 1 0 0 1-.5.14 1 1 0 0 1-.95-.75 1 1 0 0 1 .45-1.12c.09-.05 2-1.34 2-4.66 0-3.35-1.92-4.63-2-4.68a1 1 0 0 1 .3-1.74m-5.7.9a.75.75 0 0 1 .9.75v9.54a.8.8 0 0 1-.47.7.8.8 0 0 1-.82-.18L18 25.98h-1.25a1.25 1.25 0 0 1-1.25-1.26v-2.5a1.26 1.26 0 0 1 1.25-1.26H18l2.7-2.79q.16-.16.4-.21M12.72 4.02A4.5 4.5 0 0 1 16 5.67 4.5 4.5 0 0 1 19.5 4h8A2.5 2.5 0 0 1 30 6.5v10.88c-.8-1-1.56-1.49-1.7-1.58l-.11-.06-.11-.05-.08-.03V6.5a.5.5 0 0 0-.5-.5h-8A2.5 2.5 0 0 0 17 8.5v10.96h-.25c-.64 0-1.26.22-1.75.63V8.5a2.5 2.5 0 0 0-2.24-2.49L12.5 6h-8a.5.5 0 0 0-.5.5v19c0 .28.22.5.5.5h8c.6 0 1.16-.22 1.6-.58a2.8 2.8 0 0 0 1.17 1.62c-.76.6-1.72.96-2.77.96h-8A2.5 2.5 0 0 1 2 25.5v-19A2.5 2.5 0 0 1 4.5 4h8.23m11.7 15.45a1 1 0 0 1 .73.2 5 5 0 0 1 1.63 3.8 5 5 0 0 1-1.63 3.8 1 1 0 0 1-.62.23 1 1 0 0 1-.78-.38 1 1 0 0 1 .16-1.41 3 3 0 0 0 .87-2.23 3 3 0 0 0-.87-2.23 1 1 0 0 1 .51-1.78"
]);
const $db6ad3fef28672ff$export$eb6f7cd8155c9407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader48Filled', "48", [
    "M39.61 26.37c.49-.49 1.28-.5 1.77 0a12.13 12.13 0 0 1 0 17.27 1.25 1.25 0 0 1-1.76-1.78 9.63 9.63 0 0 0 0-13.72 1.25 1.25 0 0 1 0-1.77m-9.24 2.15a1.5 1.5 0 0 1 2.63.98v11a1.5 1.5 0 0 1-2.63.98l-3-3.48H24.5a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h2.86zm5.17.93c.44-.53 1.22-.6 1.76-.16a7.4 7.4 0 0 1 0 11.43 1.25 1.25 0 0 1-1.6-1.93 4.9 4.9 0 0 0 0-7.58 1.25 1.25 0 0 1-.16-1.76M19 8c2.01 0 3.8.91 5 2.35A6.5 6.5 0 0 1 29 8h11.5a3.5 3.5 0 0 1 3.5 3.5v14.8q-.57-.71-1.21-1.36c-.5-.5-1.14-.8-1.79-.9V11.5a.5.5 0 0 0-.5-.5H29a3.5 3.5 0 0 0-3.5 3.5V30h-1q-1.13.02-2 .63V14.5A3.5 3.5 0 0 0 19 11H7.5a.5.5 0 0 0-.5.5v25c0 .28.22.5.5.5H19q1.13-.02 2-.63v.13c0 1.06.47 2 1.21 2.65-.94.54-2.04.85-3.21.85H7.5A3.5 3.5 0 0 1 4 36.5v-25A3.5 3.5 0 0 1 7.5 8z"
]);
const $db6ad3fef28672ff$export$e37f221ddf4589bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImmersiveReader48Regular', "48", [
    "M39.61 26.37c.49-.49 1.28-.5 1.77 0a12.13 12.13 0 0 1 0 17.27 1.25 1.25 0 0 1-1.76-1.78 9.63 9.63 0 0 0 0-13.72 1.25 1.25 0 0 1 0-1.77m-9.24 2.15a1.5 1.5 0 0 1 2.63.98v11a1.5 1.5 0 0 1-2.63.98l-3-3.48H24.5a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h2.86zm5.17.93c.44-.53 1.22-.6 1.76-.16a7.4 7.4 0 0 1 0 11.43 1.25 1.25 0 0 1-1.6-1.93 4.9 4.9 0 0 0 0-7.58 1.25 1.25 0 0 1-.16-1.76M19 8c2.04 0 3.86.98 5 2.5A6.2 6.2 0 0 1 29 8h11.75C42.55 8 44 9.46 44 11.25v15.06q-.57-.72-1.21-1.37a3 3 0 0 0-1.29-.78V11.25a.75.75 0 0 0-.75-.75H29a3.75 3.75 0 0 0-3.75 3.75V30h-.75q-.97.01-1.75.47V14.25A3.75 3.75 0 0 0 19 10.5H7.25a.75.75 0 0 0-.75.75v25.5c0 .41.34.75.75.75H19q1.14-.02 2.02-.6c.1.89.53 1.67 1.17 2.23-.94.55-2.03.87-3.19.87H7.25A3.25 3.25 0 0 1 4 36.75v-25.5C4 9.45 5.46 8 7.25 8z"
]);
const $db6ad3fef28672ff$export$eab1580c3a00f04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment16Filled', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5V6h14v-.5A2.5 2.5 0 0 0 12.5 3zM15 7H1v3.5A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5zm-4.5 3h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$84e84a99fd2ae868 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment16Regular', "16", [
    "M10.5 10a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM14 6v-.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 4 2 4.67 2 5.5V6zM2 7v3.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7z"
]);
const $db6ad3fef28672ff$export$ebf8c238517b9795 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment20Filled', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75V8h16V6.75A2.75 2.75 0 0 0 15.25 4zM18 9H2v4.25A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25zm-4.5 4h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$622c948a4c9f6ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment20Regular', "20", [
    "M13.5 13a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM4.75 5C3.78 5 3 5.78 3 6.75V8h14V6.75C17 5.78 16.22 5 15.25 5zM17 9H3v4.25c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75z"
]);
const $db6ad3fef28672ff$export$c7942b64e5880d50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment24Filled', "24", [
    "M5.25 5A3.25 3.25 0 0 0 2 8.25V9.5h20V8.25C22 6.45 20.54 5 18.75 5zM22 11H2v4.75C2 17.55 3.46 19 5.25 19h13.5c1.8 0 3.25-1.46 3.25-3.25zm-6.25 3.5h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$3cebc7d0b5d8dba1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment24Regular', "24", [
    "M15.75 14.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM2 8.25C2 6.45 3.46 5 5.25 5h13.5C20.55 5 22 6.46 22 8.25v7.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 15.75zM20.5 9.5V8.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75V9.5zM3.5 11v4.75c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75V11z"
]);
const $db6ad3fef28672ff$export$fa9fb25d693aaf38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment28Filled', "28", [
    "M5.75 5A3.75 3.75 0 0 0 2 8.75v.75h24v-.75A3.75 3.75 0 0 0 22.25 5zM2 19.25V11h24v8.25A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25m16.25-2.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$9453e0cf3652a185 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment28Regular', "28", [
    "M18.25 16.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM2 8.75A3.75 3.75 0 0 1 5.75 5h16.5A3.75 3.75 0 0 1 26 8.75v10.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25zM5.75 6.5c-1.24 0-2.25 1-2.25 2.25v.75h21v-.75c0-1.24-1-2.25-2.25-2.25zM3.5 19.25c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V11h-21z"
]);
const $db6ad3fef28672ff$export$e7da82c773b87033 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment32Filled', "32", [
    "M6.5 5A4.5 4.5 0 0 0 2 9.5V11h28V9.5A4.5 4.5 0 0 0 25.5 5zM2 22.5V13h28v9.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 22.5M21 19a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$944cd112d3d35109 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment32Regular', "32", [
    "M2 9.5A4.5 4.5 0 0 1 6.5 5h19A4.5 4.5 0 0 1 30 9.5v13a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 22.5zM6.5 7A2.5 2.5 0 0 0 4 9.5V11h24V9.5A2.5 2.5 0 0 0 25.5 7zM4 22.5A2.5 2.5 0 0 0 6.5 25h19a2.5 2.5 0 0 0 2.5-2.5V13H4zM21 19h3a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2"
]);
const $db6ad3fef28672ff$export$34ab8d6224ff200a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment48Filled', "48", [
    "M10.25 9A6.25 6.25 0 0 0 4 15.25v3.25h40v-3.25C44 11.8 41.2 9 37.75 9zM4 32.75V21h40v11.75C44 36.2 41.2 39 37.75 39h-27.5A6.25 6.25 0 0 1 4 32.75m27.25-3.25a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $db6ad3fef28672ff$export$c20c674b07d38383 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Payment48Regular', "48", [
    "M4 15.25C4 11.8 6.8 9 10.25 9h27.5C41.2 9 44 11.8 44 15.25v17.5C44 36.2 41.2 39 37.75 39h-27.5A6.25 6.25 0 0 1 4 32.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v3.25h35v-3.25a3.75 3.75 0 0 0-3.75-3.75zM6.5 32.75a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75V21h-35zm24.75-3.25a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $db6ad3fef28672ff$export$8f750bd4d161250a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless16Filled', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m8.86-3.86a.5.5 0 0 0-.71 0c-.2.2-.2.5 0 .7a4.4 4.4 0 0 1 0 6.32c-.2.2-.2.5 0 .7s.52.19.71 0a5.35 5.35 0 0 0 0-7.72m-2.02 1c-.19-.19-.5-.19-.7 0-.19.2-.19.53 0 .72a3.07 3.07 0 0 1 0 4.27c-.19.2-.19.52 0 .72.2.2.51.2.7 0a4.1 4.1 0 0 0 0-5.7m-2.7 1.01a.56.56 0 0 0 0 .74c.55.61.55 1.6 0 2.22a.56.56 0 0 0 0 .74c.18.2.49.2.67 0a2.8 2.8 0 0 0 0-3.7.44.44 0 0 0-.67 0"
]);
const $db6ad3fef28672ff$export$8127857ef7f758fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1m1.86 3.14a.5.5 0 0 0-.71 0c-.2.2-.2.5 0 .7a4.4 4.4 0 0 1 0 6.32c-.2.2-.2.5 0 .7s.52.19.71 0a5.35 5.35 0 0 0 0-7.72m-2.02 1c-.19-.19-.5-.19-.7 0-.19.2-.19.53 0 .72a3.07 3.07 0 0 1 0 4.27c-.19.2-.19.52 0 .72.2.2.51.2.7 0a4.1 4.1 0 0 0 0-5.7m-2.7 1.01c.18-.2.49-.2.67 0a2.8 2.8 0 0 1 0 3.7c-.18.2-.49.2-.67 0a.56.56 0 0 1 0-.74c.55-.61.55-1.6 0-2.22a.56.56 0 0 1 0-.74"
]);
const $db6ad3fef28672ff$export$d60174779fce2a51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m7.36-3.86a.5.5 0 0 0-.71 0c-.2.2-.2.51 0 .7a4.4 4.4 0 0 1 0 6.32c-.2.2-.2.5 0 .7s.52.2.71 0a5.37 5.37 0 0 0 0-7.72m-3.22 1c-.19.2-.19.53 0 .72a3.07 3.07 0 0 1 0 4.27c-.19.2-.19.52 0 .72.2.2.51.2.7 0a4.1 4.1 0 0 0 0-5.7c-.19-.2-.5-.2-.7 0m5.74-2a.53.53 0 0 0-.73 0c-.2.2-.2.5 0 .7a5.7 5.7 0 0 1 0 8.33c-.2.19-.2.5 0 .69s.53.19.73 0a6.6 6.6 0 0 0 0-9.72"
]);
const $db6ad3fef28672ff$export$1c3baa424cf5e7a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless20Regular', "20", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-.64 4.14a.5.5 0 0 0-.71 0c-.2.2-.2.51 0 .7a4.4 4.4 0 0 1 0 6.32c-.2.2-.2.5 0 .7s.52.2.71 0a5.37 5.37 0 0 0 0-7.72m-3.22 1c.2-.19.51-.19.7 0a4.1 4.1 0 0 1 0 5.71c-.19.2-.5.2-.7 0a.5.5 0 0 1 0-.72 3.07 3.07 0 0 0 0-4.27.5.5 0 0 1 0-.71m5.74-2a.53.53 0 0 0-.73 0c-.2.2-.2.5 0 .7a5.7 5.7 0 0 1 0 8.33c-.2.19-.2.5 0 .69s.53.19.73 0a6.6 6.6 0 0 0 0-9.72"
]);
const $db6ad3fef28672ff$export$ccf95fb398fb51fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless24Filled', "24", [
    "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0m-7.66-5.8a.85.85 0 0 0-1.11 0c-.3.29-.3.74 0 1.01a6.32 6.32 0 0 1 0 9.58c-.3.27-.3.72 0 1s.8.28 1.11 0a7.65 7.65 0 0 0 0-11.58m-4.12 1.52a.77.77 0 0 0 0 1.07 4.6 4.6 0 0 1 0 6.42.77.77 0 0 0 0 1.07c.29.3.76.3 1.05 0a6.14 6.14 0 0 0 0-8.56.73.73 0 0 0-1.05 0M8.3 9.22a.8.8 0 0 0-1.08 0c-.3.28-.3.75 0 1.04 1 .96 1 2.52 0 3.48-.3.29-.3.76 0 1.04.3.3.78.3 1.08 0a3.84 3.84 0 0 0 0-5.56"
]);
const $db6ad3fef28672ff$export$1f11c5524c973fb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless24Regular', "24", [
    "M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m2.34 4.2a.85.85 0 0 0-1.11 0c-.3.29-.3.74 0 1.01a6.32 6.32 0 0 1 0 9.58c-.3.27-.3.72 0 1s.8.28 1.11 0a7.65 7.65 0 0 0 0-11.58m-4.12 1.52c.29-.3.76-.3 1.05 0a6.14 6.14 0 0 1 0 8.56c-.3.3-.76.3-1.05 0a.77.77 0 0 1 0-1.07 4.6 4.6 0 0 0 0-6.42.77.77 0 0 1 0-1.07M8.3 9.22a.8.8 0 0 0-1.08 0c-.3.28-.3.75 0 1.04 1 .96 1 2.52 0 3.48-.3.29-.3.76 0 1.04.3.3.78.3 1.08 0a3.84 3.84 0 0 0 0-5.56"
]);
const $db6ad3fef28672ff$export$197fe430b609bb23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless28Filled', "28", [
    "M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0m15.26-6.78a.73.73 0 0 0-1.04 0 .77.77 0 0 0 0 1.08 8.2 8.2 0 0 1 0 11.4.77.77 0 0 0 0 1.08c.29.3.76.3 1.04 0a9.76 9.76 0 0 0 0-13.56m-4.8 2c-.28.3-.28.77 0 1.06a5.27 5.27 0 0 1 0 7.44c-.28.29-.28.77 0 1.06.3.3.78.3 1.07 0a6.77 6.77 0 0 0 0-9.56.75.75 0 0 0-1.06 0m-2.66 2a.8.8 0 0 0-1.08 0c-.3.28-.3.75 0 1.04 1 .96 1 2.52 0 3.48-.3.29-.3.76 0 1.04.3.3.79.3 1.08 0a3.84 3.84 0 0 0 0-5.56"
]);
const $db6ad3fef28672ff$export$23d3f71fcea145d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless28Regular', "28", [
    "M3.5 14a10.5 10.5 0 1 1 21 0 10.5 10.5 0 0 1-21 0M14 2a12 12 0 1 0 0 24 12 12 0 0 0 0-24m3.26 5.22a.73.73 0 0 0-1.04 0 .77.77 0 0 0 0 1.08 8.2 8.2 0 0 1 0 11.4.77.77 0 0 0 0 1.08c.29.3.76.3 1.04 0a9.76 9.76 0 0 0 0-13.56m-4.8 2c.3-.3.78-.3 1.07 0a6.77 6.77 0 0 1 0 9.56c-.3.3-.77.3-1.06 0a.75.75 0 0 1 0-1.06 5.27 5.27 0 0 0 0-7.44.75.75 0 0 1 0-1.06m-2.66 2a.8.8 0 0 0-1.08 0c-.3.28-.3.75 0 1.04 1 .96 1 2.52 0 3.48-.3.29-.3.76 0 1.04.3.3.79.3 1.08 0a3.84 3.84 0 0 0 0-5.56"
]);
const $db6ad3fef28672ff$export$966ecbf395f40256 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0m17.73-7.71a1.03 1.03 0 0 0-1.43 0 .97.97 0 0 0 0 1.4 8.8 8.8 0 0 1 0 12.62.97.97 0 0 0 0 1.4c.4.39 1.03.39 1.43 0a10.73 10.73 0 0 0 0-15.42m-5.44 2c-.39.4-.39 1.04 0 1.44a6.14 6.14 0 0 1 0 8.55c-.39.4-.39 1.03 0 1.43s1.01.4 1.4 0a8.2 8.2 0 0 0 0-11.41.97.97 0 0 0-1.4 0m-2.67 2.02a.9.9 0 0 0-1.34 0 1.13 1.13 0 0 0 0 1.48 3.36 3.36 0 0 1 0 4.42 1.13 1.13 0 0 0 0 1.48c.37.41.97.41 1.34 0a5.6 5.6 0 0 0 0-7.38"
]);
const $db6ad3fef28672ff$export$4a8fcb884a05b577 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless32Regular', "32", [
    "M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28m3.73 6.29a1.03 1.03 0 0 0-1.43 0 .97.97 0 0 0 0 1.4 8.8 8.8 0 0 1 0 12.62.97.97 0 0 0 0 1.4c.4.39 1.03.39 1.43 0a10.73 10.73 0 0 0 0-15.42m-5.44 2a.97.97 0 0 1 1.4 0 8.2 8.2 0 0 1 0 11.42.97.97 0 0 1-1.4 0 1.03 1.03 0 0 1 0-1.43 6.14 6.14 0 0 0 0-8.55 1.03 1.03 0 0 1 0-1.43m-2.67 2.02a.9.9 0 0 0-1.34 0 1.13 1.13 0 0 0 0 1.48 3.36 3.36 0 0 1 0 4.42 1.13 1.13 0 0 0 0 1.48c.37.41.97.41 1.34 0a5.6 5.6 0 0 0 0-7.38"
]);
const $db6ad3fef28672ff$export$57e689a605ccfb09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless48Filled', "48", [
    "M24 44a20 20 0 1 0 0-40 20 20 0 0 0 0 40m5.14-31.64a16.36 16.36 0 0 1 0 23.27c-.49.49-1.28.49-1.77 0a1.24 1.24 0 0 1 0-1.76c5.5-5.45 5.5-14.3 0-19.74a1.24 1.24 0 0 1 0-1.77 1.26 1.26 0 0 1 1.77 0m-7.76 3c.5-.48 1.31-.48 1.82 0a11.73 11.73 0 0 1 0 17.28c-.5.48-1.32.48-1.82 0-.5-.47-.5-1.24 0-1.71a9.4 9.4 0 0 0 0-13.86c-.5-.47-.5-1.24 0-1.71m-5.51 3a1.26 1.26 0 0 1 1.77 0 7.9 7.9 0 0 1 0 11.27c-.49.5-1.28.5-1.77 0a1.24 1.24 0 0 1 0-1.76 5.45 5.45 0 0 0 0-7.75 1.24 1.24 0 0 1 0-1.76"
]);
const $db6ad3fef28672ff$export$9605c3bae9de8a3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PaymentWireless48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 1 35 0 17.5 17.5 0 0 1-35 0M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40m5.14 8.36a1.26 1.26 0 0 0-1.77 0 1.24 1.24 0 0 0 0 1.77c5.5 5.45 5.5 14.29 0 19.74a1.24 1.24 0 0 0 0 1.76c.49.49 1.28.49 1.77 0a16.36 16.36 0 0 0 0-23.27m-7.76 3c.5-.48 1.31-.48 1.82 0a11.73 11.73 0 0 1 0 17.28c-.5.48-1.32.48-1.82 0-.5-.47-.5-1.24 0-1.71a9.4 9.4 0 0 0 0-13.86c-.5-.47-.5-1.24 0-1.71m-5.51 3a1.26 1.26 0 0 1 1.77 0 7.9 7.9 0 0 1 0 11.27c-.49.5-1.28.5-1.77 0a1.24 1.24 0 0 1 0-1.76 5.45 5.45 0 0 0 0-7.75 1.24 1.24 0 0 1 0-1.76"
]);
const $db6ad3fef28672ff$export$9069a698dd310930 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Predictions20Filled', "20", [
    "M14.5 1c.28 0 .5.22.5.5 0 .46.07 1.22.47 1.84.38.6 1.08 1.14 2.53 1.14a.5.5 0 1 1 0 1 3.5 3.5 0 0 0-1.82.73A2.8 2.8 0 0 0 15 8.45a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5c0-.5-.16-1.26-.6-1.88-.44-.6-1.16-1.1-2.4-1.1a.5.5 0 0 1-.5-.5c0-.27.22-.5.5-.5.51 0 1.25 0 1.87-.36.57-.33 1.13-1 1.13-2.61 0-.28.22-.5.5-.5M6.15 12.17l-.94 3.4c-.17.61.08 1.34.74 1.63 1.64.73 4.65 1.35 7.97.01a1.43 1.43 0 0 0 .82-1.75l-.98-3.23a6.5 6.5 0 0 1-7.61-.06m6.77-9.84q-.06.32-.16.5a1 1 0 0 1-.4.42c-.34.2-.82.23-1.36.23a1.5 1.5 0 1 0 0 2.98c.91 0 1.34.35 1.58.7.3.4.42.95.42 1.3a1.5 1.5 0 0 0 1.61 1.48A5.5 5.5 0 0 1 4.5 6.96a5.48 5.48 0 0 1 8.42-4.63"
]);
const $db6ad3fef28672ff$export$17f91faba102ffa3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Predictions20Regular', "20", [
    "M14.5 1c.28 0 .5.22.5.5 0 .46.07 1.22.47 1.84.38.6 1.08 1.14 2.53 1.14a.5.5 0 1 1 0 1 3.5 3.5 0 0 0-1.82.73A2.8 2.8 0 0 0 15 8.45a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5c0-.5-.16-1.26-.6-1.88-.44-.6-1.16-1.1-2.4-1.1a.5.5 0 0 1-.5-.5c0-.27.22-.5.5-.5.51 0 1.25 0 1.87-.36.57-.33 1.13-1 1.13-2.61 0-.28.22-.5.5-.5m.04 2.73a3 3 0 0 1-1.33 1.33 3.5 3.5 0 0 1 1.33 1.48 4 4 0 0 1 1.52-1.44 3.2 3.2 0 0 1-1.52-1.37m-7.26 6.8A4.46 4.46 0 0 1 10 2.5q1.37.01 2.44.72a1 1 0 0 0 .32-.38q.1-.17.16-.5A5.5 5.5 0 0 0 4.5 6.96c0 1.67.75 3.16 1.93 4.16l-1.22 4.44c-.17.62.08 1.35.74 1.64 1.64.73 4.65 1.35 7.97.01a1.43 1.43 0 0 0 .82-1.75l-1.26-4.17-.03-.07q.68-.55 1.16-1.28a1.5 1.5 0 0 1-1.01-.3 4.5 4.5 0 0 1-6.32.89m5.3 1.26 1.2 3.96c.07.24-.05.46-.23.54a9.4 9.4 0 0 1-7.19 0c-.14-.06-.24-.24-.18-.47l1.12-4.1a5.5 5.5 0 0 0 5.28.07"
]);
const $db6ad3fef28672ff$export$5d437ef02d108100 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Predictions24Filled', "24", [
    "m16.68 14.93 1.29 3.85c.26.8-.08 1.67-.81 2.08Q15.1 22.01 12 22q-3.1 0-5.16-1.14a1.75 1.75 0 0 1-.8-2.08l1.28-3.85a7.7 7.7 0 0 0 9.36 0M12 2c1.34 0 2.58.39 3.63 1.06q-.12.46-.37.7-.37.4-1.32.47l-.22.02h-.38c-2.17.16-2.12 3.5.16 3.5q1.32.01 1.76.49.4.37.47 1.32l.02.22v.38c.1 1.32 1.36 1.81 2.34 1.5A6.75 6.75 0 1 1 12 2m6.25 0q0 1.71.78 2.47.7.71 2.21.78h.26c.96 0 1 1.38.12 1.5h-.12q-1.71 0-2.47.78-.71.7-.78 2.21V10c0 1-1.5 1-1.5 0q0-1.72-.78-2.47-.7-.71-2.21-.78h-.26c-.96 0-1-1.38-.12-1.5h.12q1.72 0 2.47-.78.77-.75.78-2.47c0-1 1.5-1 1.5 0"
]);
const $db6ad3fef28672ff$export$c853825b3a4a0c72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Predictions24Regular', "24", [
    "M12 2q1.75.02 3.19.8-.12.67-.43.96-.15.16-.43.28-1.07-.53-2.33-.54a5.25 5.25 0 0 0-.23 10.5H12q.96 0 2.14-.45c.91-.41 1.69-1.08 2.24-1.9.64.22 1.4.08 1.9-.4a7 7 0 0 1-1.93 2.67l1.62 4.86c.26.8-.08 1.67-.81 2.08Q15.1 22.01 12 22q-3.1 0-5.16-1.14a1.75 1.75 0 0 1-.8-2.08l1.61-4.86A6.74 6.74 0 0 1 12 2m3.06 12.8-.36.14h-.02q-1.1.49-2.35.55h-.09l-.24.01h-.33a7 7 0 0 1-2.35-.55l-.02-.01-.36-.15-1.48 4.46q-.06.2.11.3 1.69.95 4.43.95t4.43-.95q.16-.1.11-.3zm-3.37.7H12zm6.3-13.62L18 2q0 1.71.78 2.47.7.71 2.21.78h.26c.96 0 1 1.38.12 1.5h-.12q-1.71 0-2.47.78-.71.7-.78 2.21V10c0 1-1.5 1-1.5 0q0-1.72-.78-2.47-.7-.71-2.21-.78h-.26c-.96 0-1-1.38-.12-1.5h.12q1.72 0 2.47-.78.77-.75.78-2.47c0-.96 1.38-1 1.5-.12m-.74 3.07-.14.2a4 4 0 0 1-.9.85 4 4 0 0 1 1.04 1.05A4 4 0 0 1 18.3 6a4 4 0 0 1-.9-.84z"
]);
const $db6ad3fef28672ff$export$dcd64c9708e8c3d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium12Filled', "12", [
    "M3 1h1.05L3 4H1.2l1.35-2.72A.5.5 0 0 1 3 1M1.23 5l3.01 4.69L2.97 5zM4 5l1.53 5.65a.48.48 0 0 0 .92 0L8 5zm5.02 0L7.76 9.69 10.77 5zm1.78-1H9L7.96 1H9q.3 0 .45.28zM7.95 4h-3.9l1.06-3H6.9z"
]);
const $db6ad3fef28672ff$export$f6b6cdb002dd4377 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium12Regular', "12", [
    "M6.99 1H3a.5.5 0 0 0-.45.28l-1.5 3a.5.5 0 0 0 .05.52l4.5 6a.5.5 0 0 0 .58.17.5.5 0 0 0 .23-.18L10.9 4.8a.5.5 0 0 0 .05-.52l-1.5-3A.5.5 0 0 0 9 1H6.99m-.35 1 .67 2H4.69l.67-2zm1.72 2-.67-2h1l1 2zM7.31 5 6 8.92 4.7 5zm.14 2.74L8.36 5H9.5zm-2.9 0L2.5 5h1.14zM3.64 4H2.31l1-2h1z"
]);
const $db6ad3fef28672ff$export$17d8f08d87e8d924 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__a)",
            "d": "M6.62 2H3.5a.5.5 0 0 0-.45.28l-2 4h4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__b)",
            "d": "M10.44 6.28 9.38 2h3.12q.3 0 .45.28l2 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__c)",
            "d": "M6.01 2.38A.5.5 0 0 1 6.5 2h3a.5.5 0 0 1 .49.38l1 4 .01.12H5l.01-.12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__d)",
            "d": "M5.57 6H1.19l-.14.28a.5.5 0 0 0 .06.54l6.5 8a.5.5 0 0 0 .77 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__e)",
            "d": "M7.62 14.83 10.43 6h4.38l.14.28a.5.5 0 0 1-.06.54l-6.5 8a.5.5 0 0 1-.77 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__f)",
            "d": "m5.11 6-.1.38a1 1 0 0 0 .01.27l2.5 8a.5.5 0 0 0 .96 0l2.5-8a1 1 0 0 0 0-.27L10.9 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_16_color__g)",
            "fillOpacity": ".7",
            "d": "M3.5 2a.5.5 0 0 0-.45.28l-2 4a.5.5 0 0 0 .06.54l6.5 8a.5.5 0 0 0 .78 0l6.5-8a.5.5 0 0 0 .06-.54l-2-4A.5.5 0 0 0 12.5 2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__a",
                "x1": "5.83",
                "x2": "3.51",
                "y1": ".22",
                "y2": "5.76",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__b",
                "x1": "11.37",
                "x2": "14",
                "y1": "2",
                "y2": "8.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#102784"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__c",
                "x1": "8",
                "x2": "8",
                "y1": "2",
                "y2": "7.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#367af2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__d",
                "x1": "2.3",
                "x2": "7.82",
                "y1": "4.2",
                "y2": "14.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__e",
                "x1": "16.74",
                "x2": "8.52",
                "y1": "1.5",
                "y2": "13.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__f",
                "x1": "8",
                "x2": "8",
                "y1": "2.85",
                "y2": "15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2052cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_16_color__g",
                "x1": "-.42",
                "x2": "10.76",
                "y1": "-10.24",
                "y2": "16.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$23876184b91cca1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium16Filled', "16", [
    "M3.75 2a.8.8 0 0 0-.66.4l-2 3.75a.8.8 0 0 0 .07.81l6.25 8a.75.75 0 0 0 1.18 0l6.25-8a.8.8 0 0 0 .07-.81l-2-3.75a.8.8 0 0 0-.66-.4zm-.88 4L4.2 3.5h1.28L4.85 6zm.61 1.5h1.55l1.03 3.3zm3.12 0h2.8L8 11.99zm4.37 0h1.55l-2.58 3.3zM13.13 6h-1.98l-.63-2.5h1.28zM9.6 6H6.4l.62-2.5h1.96z"
]);
const $db6ad3fef28672ff$export$f6757842463ccf84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium16Regular', "16", [
    "M3.5 2a.5.5 0 0 0-.45.28l-2 4a.5.5 0 0 0 .06.54l6.5 8a.5.5 0 0 0 .78 0l6.5-8a.5.5 0 0 0 .06-.54l-2-4A.5.5 0 0 0 12.5 2zM2.3 6l1.5-3h2.06l-.75 3zm.25 1h2.58l1.62 5.16zm3.63 0h3.64L8 12.82zm4.69 0h2.58l-4.2 5.16zm2.82-1h-2.8l-.75-3h2.05zM9.86 6H6.14l.75-3h2.22z"
]);
const $db6ad3fef28672ff$export$287752680719c067 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__a)",
            "d": "M11.5 3a.5.5 0 0 0-.46.69l2 5a.5.5 0 0 0 .46.31h4a.5.5 0 0 0 .43-.76l-3-5A.5.5 0 0 0 14.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__b)",
            "d": "M5.5 3a.5.5 0 0 0-.43.24l-3 5A.5.5 0 0 0 2.5 9h4a.5.5 0 0 0 .46-.31l2-5A.5.5 0 0 0 8.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__c)",
            "d": "M8.5 3a.5.5 0 0 0-.46.31l-2 5A.5.5 0 0 0 6.5 9h7a.5.5 0 0 0 .46-.69l-2-5A.5.5 0 0 0 11.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__d)",
            "d": "M13.5 8a.5.5 0 0 0-.47.32l-3.5 9a.5.5 0 0 0 .85.5l7.5-9A.5.5 0 0 0 17.5 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__e)",
            "d": "M2.5 8a.5.5 0 0 0-.38.82l7.5 9a.5.5 0 0 0 .85-.5l-3.5-9A.5.5 0 0 0 6.5 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__f)",
            "d": "M6.16 8s-.22.39-.13.68l3.5 9a.5.5 0 0 0 .94 0l3.5-9c.12-.32-.13-.68-.13-.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_20_color__g)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M5.07 3.24A.5.5 0 0 1 5.5 3h9q.28.02.43.24l3 5a.5.5 0 0 1-.05.58l-7.5 9-.04.04a.5.5 0 0 1-.73-.04l-7.5-9a.5.5 0 0 1-.04-.58z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__a",
                "x1": "13.5",
                "x2": "17.5",
                "y1": "3",
                "y2": "12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#102784"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__b",
                "x1": "8",
                "x2": "4.5",
                "y1": ".5",
                "y2": "8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__c",
                "x1": "10",
                "x2": "10",
                "y1": "3",
                "y2": "10.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#367af2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__d",
                "x1": "20",
                "x2": "11",
                "y1": "3",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__e",
                "x1": "3.5",
                "x2": "9.5",
                "y1": "6",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__f",
                "x1": "10",
                "x2": "10",
                "y1": "4.5",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2052cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_20_color__g",
                "x1": ".38",
                "x2": "13.37",
                "y1": "-11.13",
                "y2": "19.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$1abb0832170564c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium20Filled', "20", [
    "M5.5 2.75a.8.8 0 0 0-.66.39l-2.75 5c-.15.27-.11.6.08.84l7.25 8.75a.75.75 0 0 0 1.16 0l7.25-8.75c.2-.24.23-.57.08-.84l-2.75-5a.8.8 0 0 0-.66-.39zM4.16 7.5l1.78-3.25h1.5L6.31 7.5zM6.14 9l1.93 4.75L4.14 9zM10 14.48 7.76 9h4.39zM7.89 7.5l1.14-3.25h1.95l1.2 3.25zm5.88 0-1.2-3.25h1.49l1.78 3.25zm0 1.5h2.1l-4.01 4.83z"
]);
const $db6ad3fef28672ff$export$c67950fd83a54d23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium20Regular', "20", [
    "M5.5 3a.5.5 0 0 0-.43.24l-3 5a.5.5 0 0 0 .05.58l7.5 9a.5.5 0 0 0 .76 0l7.5-9a.5.5 0 0 0 .05-.58l-3-5A.5.5 0 0 0 14.5 3zM3.38 8l2.4-4h1.98l-1.6 4zm2.78 1 2.26 5.83L3.57 9zM10 16.12 7.23 9h5.54zM7.24 8l1.6-4h2.32l1.6 4zm6.6 0-1.6-4h1.98l2.4 4zm0 1h2.6l-4.86 5.83z"
]);
const $db6ad3fef28672ff$export$48df10fd417a07b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium24Color', "24", [
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M18 3q.37.01.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1q0 .1-.02.2l-.02.06H15.5L13.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__a)",
            "d": "M18 3q.37.01.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1q0 .1-.02.2l-.02.06H15.5L13.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M2 9.84v-.16l.02-.08.02-.1.02-.05.03-.06 3.25-6a.8.8 0 0 1 .56-.38L6 3h4.5l-2.25 7H2.04z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__b)",
            "d": "M2 9.84v-.16l.02-.08.02-.1.02-.05.03-.06 3.25-6a.8.8 0 0 1 .56-.38L6 3h4.5l-2.25 7H2.04z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__c)",
            "d": "m21.96 9.51-.04-.09L21.7 9h-5.92L15 10.5l-3 7.69V21l.12-.01.08-.02.1-.03a1 1 0 0 0 .3-.23l9.23-10.49.04-.05.02-.03.03-.06.05-.13.03-.2v-.1l-.03-.1z"
        }
    ],
    [
        "path",
        {
            "fill": "#a9a9a9",
            "d": "M12 21h-.1l-.12-.03-.17-.08h-.01l-.13-.1-9.3-10.55-.02-.04-.04-.06a1 1 0 0 1-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06L2.3 9h6.04L9 10.5l3 7.69z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__d)",
            "d": "M12 21h-.1l-.12-.03-.17-.08h-.01l-.13-.1-9.3-10.55-.02-.04-.04-.06a1 1 0 0 1-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06L2.3 9h6.04L9 10.5l3 7.69z"
        }
    ],
    [
        "path",
        {
            "fill": "#7c7a7a",
            "d": "M9.29 3.52c.1-.3.38-.52.71-.52h4c.33 0 .61.21.71.52l1.92 5.98H7.37z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__e)",
            "d": "M9.29 3.52c.1-.3.38-.52.71-.52h4c.33 0 .61.21.71.52l1.92 5.98H7.37z"
        }
    ],
    [
        "path",
        {
            "fill": "#3f3f3f",
            "d": "m7.53 9-.24.77a.8.8 0 0 0 .01.5l4 10.25a.75.75 0 0 0 1.4 0l4-10.25a.8.8 0 0 0 .01-.5L16.47 9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__f)",
            "d": "m7.53 9-.24.77a.8.8 0 0 0 .01.5l4 10.25a.75.75 0 0 0 1.4 0l4-10.25a.8.8 0 0 0 .01-.5L16.47 9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_24_color__g)",
            "fillOpacity": ".7",
            "d": "M18 3q.38.01.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1q0 .1-.02.2l-.05.13-.03.06-.08.1.06-.07-.02.03-9.25 10.5a1 1 0 0 1-.3.24l-.1.03-.08.02L12 21h-.1l-.12-.03-.17-.08h-.01l-.13-.1-9.3-10.55-.02-.04-.04-.06a1 1 0 0 1-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06 3.25-6a.8.8 0 0 1 .56-.38L6 3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__a",
                "x1": "16.54",
                "x2": "21.09",
                "y1": "3",
                "y2": "13.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#102784"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__b",
                "x1": "9.29",
                "x2": "5.31",
                "y1": ".08",
                "y2": "8.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__c",
                "x1": "24.35",
                "x2": "13.46",
                "y1": "3",
                "y2": "19.6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__d",
                "x1": "3.76",
                "x2": "11.05",
                "y1": "6.6",
                "y2": "20.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__e",
                "x1": "12",
                "x2": "12",
                "y1": "3",
                "y2": "11.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#367af2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__f",
                "x1": "11.99",
                "x2": "11.99",
                "y1": "4.8",
                "y2": "21",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2052cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_24_color__g",
                "x1": "-.03",
                "x2": "15.12",
                "y1": "-13.95",
                "y2": "22.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$29b4e140643c0b9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium24Filled', "24", [
    "M18 3a1 1 0 0 1 .83.44l.06.11 3 6a1 1 0 0 1-.06 1.01l-.09.1-8.97 9.98a1 1 0 0 1-.89.35l-.1-.02a1 1 0 0 1-.54-.32l-8.98-9.98a1 1 0 0 1-.2-1l.05-.12 3-6a1 1 0 0 1 .77-.54L6 3zm-3.42 8H9.42L12 17.34zm4.17 0h-2.02l-1.66 4.09zM7.26 11H5.25l3.67 4.09zm1.36-6h-2l-2 4h2.7zm4.65 0h-2.54l-1.3 4h5.14zm4.11 0h-2l1.3 4h2.7z"
]);
const $db6ad3fef28672ff$export$b36986cf6fbad26e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium24Regular', "24", [
    "M18 3q.38.01.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1q0 .1-.02.2l-.05.13-.03.06-.08.1.06-.07-.02.03-9.25 10.5a1 1 0 0 1-.3.24l-.1.03-.08.02L12 21h-.1l-.12-.03-.17-.08h-.01l-.13-.1-9.3-10.55-.02-.04-.04-.06a1 1 0 0 1-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06 3.25-6a.8.8 0 0 1 .56-.38L6 3zm-3 7.5H9l3 7.69zm-7.61 0H4.4l5.35 6.07zm12.2 0H16.6l-2.37 6.07zm-10.62-6H6.44L4.01 9h3.52zm4.48 0h-2.9L9.1 9h5.79zm4.1 0h-2.52L16.47 9h3.52z"
]);
const $db6ad3fef28672ff$export$9dc217d21a46f0e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium28Color', "28", [
    [
        "path",
        {
            "fill": "#616161",
            "d": "M18.7 11.5h7.26a1 1 0 0 0 .04-.25v.06-.18l-.03-.08v-.04l-.05-.1-4-7.51-.06-.09a.8.8 0 0 0-.6-.31H16c.34 0 .64.23.72.56l2 7.5q.06.22-.01.44"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__a)",
            "d": "M18.7 11.5h7.26a1 1 0 0 0 .04-.25v.06-.18l-.03-.08v-.04l-.05-.1-4-7.51-.06-.09a.8.8 0 0 0-.6-.31H16c.34 0 .64.23.72.56l2 7.5q.06.22-.01.44"
        }
    ],
    [
        "path",
        {
            "fill": "#9f9f9f",
            "d": "M9.3 11.5a1 1 0 0 1-.02-.44l2-7.5A.75.75 0 0 1 12 3H6.65a.8.8 0 0 0-.56.4l-4 7.5-.03.05-.03.1-.01.04-.02.1v.13l.03.13.02.05z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__b)",
            "d": "M9.3 11.5a1 1 0 0 1-.02-.44l2-7.5A.75.75 0 0 1 12 3H6.65a.8.8 0 0 0-.56.4l-4 7.5-.03.05-.03.1-.01.04-.02.1v.13l.03.13.02.05z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M19.7 11.5q.08-.22.02-.44l-2-7.5A.75.75 0 0 0 17 3h-6a.75.75 0 0 0-.72.56l-2 7.5q-.06.22.01.44z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__c)",
            "d": "M19.7 11.5q.08-.22.02-.44l-2-7.5A.75.75 0 0 0 17 3h-6a.75.75 0 0 0-.72.56l-2 7.5q-.06.22.01.44z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__d)",
            "d": "M13.5 24.81a1 1 0 0 0 .2-.3l5-13q.1-.22.02-.45l-.01-.06h7.25v.01l.01.04.02.08.01.09v.1-.07q0 .15-.06.3l-.03.06-.04.06-.05.07L14.6 24.7a.7.7 0 0 1-.38.27l-.06.01-.1.02h-.16l-.08-.02-.1-.04h-.03a1 1 0 0 1-.2-.13"
        }
    ],
    [
        "path",
        {
            "fill": "#626262",
            "d": "M9.29 11H2.05l-.02.05-.01.04-.02.1v.13l.03.13.03.1.05.09.06.09 11.27 13.02a1 1 0 0 0 .25.18l.02.01.1.04.09.01.1.01h.06l.1-.02.06-.01q.15-.04.28-.16a1 1 0 0 1-.2-.3l-5-13a1 1 0 0 1-.02-.45z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__e)",
            "d": "M9.29 11H2.05l-.02.05-.01.04-.02.1v.13l.03.13.03.1.05.09.06.09 11.27 13.02a1 1 0 0 0 .25.18l.02.01.1.04.09.01.1.01h.06l.1-.02.06-.01q.15-.04.28-.16a1 1 0 0 1-.2-.3l-5-13a1 1 0 0 1-.02-.45z"
        }
    ],
    [
        "path",
        {
            "fill": "#aeaeae",
            "d": "M19.7 11H8.3l-.01.06a1 1 0 0 0 .02.46l5 13a.75.75 0 0 0 1.4 0l5-13q.1-.23.02-.46z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__f)",
            "d": "M19.7 11H8.3l-.01.06a1 1 0 0 0 .02.46l5 13a.75.75 0 0 0 1.4 0l5-13q.1-.23.02-.46z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_28_color__g)",
            "fillOpacity": ".7",
            "d": "M21.25 3c.24 0 .47.12.6.31l.06.09 4.01 7.51.04.1.01.04.02.08.01.09v.1-.07q0 .15-.06.3l-.03.06-.04.06-.05.07L14.6 24.7a.7.7 0 0 1-.38.27l-.06.01-.1.02h-.16l-.08-.02-.1-.04h-.03a1 1 0 0 1-.25-.19L2.17 11.73l-.06-.1-.05-.08-.03-.1-.03-.13v-.13l.02-.1v-.04l.04-.1.03-.05 4-7.5a.8.8 0 0 1 .56-.4h14.6"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__a",
                "x1": "19.57",
                "x2": "25.21",
                "y1": "3",
                "y2": "15.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#102784"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__b",
                "x1": "10.57",
                "x2": "5.64",
                "y1": "-.54",
                "y2": "10.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__c",
                "x1": "14",
                "x2": "14",
                "y1": "3",
                "y2": "13.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#367af2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__d",
                "x1": "28.94",
                "x2": "16.61",
                "y1": "4",
                "y2": "24.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__e",
                "x1": "4.21",
                "x2": "12.36",
                "y1": "8.2",
                "y2": "25.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__f",
                "x1": "13.99",
                "x2": "13.99",
                "y1": "6.1",
                "y2": "25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2052cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_28_color__g",
                "x1": "-.43",
                "x2": "18.33",
                "y1": "-17.72",
                "y2": "26.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$ab159935f464ef6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium28Filled', "28", [
    "M20.75 3c.3 0 .6.14.78.37l.07.11 4.25 7a1 1 0 0 1-.01 1.06l-.08.1-11 13a1 1 0 0 1-1.44.1l-.08-.1-11-13a1 1 0 0 1-.15-1.05l.06-.1 4.25-7A1 1 0 0 1 7.12 3L7.25 3zm-3.23 9h-7.04L14 20.67zm5.32 0h-3.17l-2.91 7.2zM8.33 12H5.16l6.08 7.2zm1.34-7H7.81l-3.03 5h3.46zm6.58 0h-4.5l-1.43 5h7.36zm3.94 0h-1.87l1.43 5h3.47z"
]);
const $db6ad3fef28672ff$export$58b1d0ef9fa80d21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium28Regular', "28", [
    "M21.25 3c.24 0 .47.12.6.31l.06.09 4.01 7.51.04.1.01.04.02.08.01.09v.1-.07q0 .15-.06.3l-.03.06-.04.06-.05.07L14.6 24.7a.7.7 0 0 1-.38.27l-.06.01-.1.02h-.16l-.08-.02-.1-.04h-.03a1 1 0 0 1-.25-.19L2.17 11.73l-.06-.1-.05-.08-.03-.1-.03-.13v-.13l.02-.1v-.04l.04-.1.03-.05 4-7.5a.8.8 0 0 1 .56-.4h14.6m-3.34 9h-7.82L14 22.16zm-9.42 0h-4.1l7.37 8.52zm15.12 0h-4.1l-3.27 8.51zM10.03 4.5H7.2l-3.2 6h4.42zm6.4 0h-4.85l-1.6 6h8.04zm4.37 0h-2.82l1.6 6H24z"
]);
const $db6ad3fef28672ff$export$fdf68bf1338a1dac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium32Color', "32", [
    [
        "path",
        {
            "fill": "#6d6d6d",
            "d": "M25.9 4.55A1 1 0 0 0 25 4h-6a1 1 0 0 0-.97 1.24l1.93 7.73-.16.53h10.07a1 1 0 0 0 .02-.95z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__a)",
            "d": "M25.9 4.55A1 1 0 0 0 25 4h-6a1 1 0 0 0-.97 1.24l1.93 7.73-.16.53h10.07a1 1 0 0 0 .02-.95z"
        }
    ],
    [
        "path",
        {
            "fill": "#e8e8e8",
            "d": "M6.1 4.55A1 1 0 0 1 7 4h6a1 1 0 0 1 .97 1.24l-1.93 7.73.16.53H2.13a1 1 0 0 1-.02-.95z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__b)",
            "d": "M6.1 4.55A1 1 0 0 1 7 4h6a1 1 0 0 1 .97 1.24l-1.93 7.73.16.53H2.13a1 1 0 0 1-.02-.95z"
        }
    ],
    [
        "path",
        {
            "fill": "#b6b6b6",
            "d": "M12.03 4.76A1 1 0 0 1 13 4h6a1 1 0 0 1 .97.76l2 8a1 1 0 0 1-.02.54l-.06.2H10.11l-.06-.2a1 1 0 0 1-.02-.54z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__c)",
            "d": "M12.03 4.76A1 1 0 0 1 13 4h6a1 1 0 0 1 .97.76l2 8a1 1 0 0 1-.02.54l-.06.2H10.11l-.06-.2a1 1 0 0 1-.02-.54z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__d)",
            "d": "m19.95 13-4.9 15.7a1 1 0 0 0 1.73.93l13-16A1 1 0 0 0 30 13z"
        }
    ],
    [
        "path",
        {
            "fill": "#cacaca",
            "d": "M2 13a1 1 0 0 0 .22.63l13 16a1 1 0 0 0 1.73-.93L12.05 13z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__e)",
            "d": "M2 13a1 1 0 0 0 .22.63l13 16a1 1 0 0 0 1.73-.93L12.05 13z"
        }
    ],
    [
        "path",
        {
            "fill": "#969696",
            "d": "M10 13q0 .15.05.3l5 16a1 1 0 0 0 1.9 0l5-16A1 1 0 0 0 22 13z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__f)",
            "d": "M10 13q0 .15.05.3l5 16a1 1 0 0 0 1.9 0l5-16A1 1 0 0 0 22 13z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_premium_32_color__g)",
            "fillOpacity": ".7",
            "d": "M7 4a1 1 0 0 0-.9.55l-4 8a1 1 0 0 0 .12 1.08l13 16a1 1 0 0 0 1.56 0l13-16a1 1 0 0 0 .11-1.08l-4-8A1 1 0 0 0 25 4z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__a",
                "x1": "22.29",
                "x2": "28.28",
                "y1": "4",
                "y2": "18.6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#102784"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__b",
                "x1": "12.29",
                "x2": "7.03",
                "y1": ".04",
                "y2": "12.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__c",
                "x1": "16",
                "x2": "16",
                "y1": "4",
                "y2": "15.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#367af2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__d",
                "x1": "33.53",
                "x2": "18.47",
                "y1": "4.5",
                "y2": "28.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__e",
                "x1": "4.65",
                "x2": "14.62",
                "y1": "9.6",
                "y2": "30.3",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__f",
                "x1": "15.99",
                "x2": "15.99",
                "y1": "7.05",
                "y2": "30",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2052cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_premium_32_color__g",
                "x1": "-.84",
                "x2": "21.53",
                "y1": "-20.48",
                "y2": "32.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$6e225c73587ac2d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium32Filled', "32", [
    "M7 4c-.48 0-.92.27-1.13.7l-3.75 7.76c-.2.43-.15.95.16 1.33l12.75 15.75a1.25 1.25 0 0 0 1.94 0l12.75-15.75c.3-.38.37-.9.16-1.33L26.13 4.7C25.92 4.27 25.48 4 25 4zm-1.64 7.5 2.42-5h3.7l-1.57 5zm.3 2.5h4.1l2.87 8.6zm6.74 0h7.2L16 24.8zm9.83 0h4.1l-6.96 8.6zm4.4-2.5H22.1l-1.56-5h3.69zm-7.16 0h-6.94l1.56-5h3.82z"
]);
const $db6ad3fef28672ff$export$3eb8ddcc4f971cc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Premium32Regular', "32", [
    "M7 4a1 1 0 0 0-.9.55l-4 8a1 1 0 0 0 .12 1.08l13 16a1 1 0 0 0 1.56 0l13-16a1 1 0 0 0 .11-1.08l-4-8A1 1 0 0 0 25 4zm-2.38 8 3-6h4.1l-1.5 6zm.48 2h5.17l3.22 10.33zm7.26 0h7.28L16 25.65zm9.38 0h5.16l-8.4 10.33zm5.64-2h-5.6l-1.5-6h4.1zm-7.66 0h-7.44l1.5-6h4.44z"
]);
const $db6ad3fef28672ff$export$8bf4b18fcf826e22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PremiumPerson16Filled', "16", [
    "M3.75 2a.8.8 0 0 0-.66.4l-2 3.75a.8.8 0 0 0 .07.81l4.93 6.32Q6 12.89 6 12.5c0-1 .6-1.87 1.45-2.27L6.6 7.5h.94q.16-.87.72-1.5H6.4l.62-2.5h1.96l.42 1.7a3 3 0 0 1 1.5-.17l-.38-1.53h1.28L13.13 6h-.4a3 3 0 0 1 .65 2.83l1.46-1.87a.8.8 0 0 0 .07-.81l-2-3.75a.8.8 0 0 0-.66-.4zm-.88 4L4.2 3.5h1.28L4.85 6zm.61 1.5h1.55l1.03 3.3zm9.02.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S7 13.75 7 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$5205d79808a42db9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PremiumPerson16Regular', "16", [
    "M3.5 2a.5.5 0 0 0-.45.28l-2 4a.5.5 0 0 0 .06.54l4.9 6.03L6 12.5q0-.54.2-1L2.56 7h2.58l1.29 4.11q.31-.46.8-.76L6.19 7h1.5a3 3 0 0 1 .58-1H6.14l.75-3h2.22l.53 2.12a3 3 0 0 1 1-.12l-.5-2h2.05l1.5 3h-.95a3 3 0 0 1 .59 1h.12l-.09.1a3 3 0 0 1 .08 1.5l1.45-1.78a.5.5 0 0 0 .06-.54l-2-4A.5.5 0 0 0 12.5 2zM2.3 6l1.5-3h2.06l-.75 3zm10.2 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S7 13.75 7 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$7f2f3513da6076d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PremiumPerson20Filled', "20", [
    "M5.5 2.75a.8.8 0 0 0-.66.39l-2.75 5c-.15.27-.11.6.08.84l7.25 8.75a.75.75 0 0 0 1.16 0l.48-.59a3 3 0 0 1-.06-.64c0-1.3 1-2.38 2.27-2.49a3 3 0 0 1 .17-4.19l.32-.82h4.05l.02-.02c.2-.24.23-.57.08-.84l-2.75-5a.8.8 0 0 0-.66-.39zM4.16 7.5l1.78-3.25h1.5L6.31 7.5zM6.14 9l1.93 4.75L4.14 9zM10 14.48 7.76 9h4.39zM7.89 7.5l1.14-3.25h1.95l1.2 3.25zm5.88 0-1.2-3.25h1.49l1.78 3.25zM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$ac60ebe01480af27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PremiumPerson20Regular', "20", [
    "M5.5 3a.5.5 0 0 0-.43.24l-3 5a.5.5 0 0 0 .05.58l7.49 9a.5.5 0 0 0 .86-.13L13.84 9h3.9l.14-.18a.5.5 0 0 0 .05-.58l-3-5A.5.5 0 0 0 14.5 3zm7.27 6L10 16.12 7.23 9zM3.38 8l2.4-4h1.98l-1.6 4zm2.78 1 2.26 5.83L3.57 9zm1.08-1 1.6-4h2.32l1.6 4zm6.6 0-1.6-4h1.98l2.4 4zm1.66 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5"
]);
const $db6ad3fef28672ff$export$d57845d4b60c8b16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PremiumPerson24Filled', "24", [
    "M18.83 3.44A1 1 0 0 0 18 3H5.88a1 1 0 0 0-.77.55l-3 6-.06.13a1 1 0 0 0 .2.99l8.99 9.98q.22.26.53.32l.11.02a1 1 0 0 0 .89-.35l.26-.29-.03-.48v-.1A2.77 2.77 0 0 1 15.77 17h.28a3.49 3.49 0 0 1 2.45-6c.85 0 1.62.3 2.23.8l1.01-1.13.09-.1a1 1 0 0 0 .06-1.02l-3-6zM9.43 11h5.15L12 17.34zm-4.18 0h2.01l1.66 4.09zm1.37-6h2l-1.3 4h-2.7zm4.1 0h2.55l1.3 4H9.43zm4.66 0h2l2 4h-2.7zM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $db6ad3fef28672ff$export$c8a04671f819f68d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PremiumPerson24Regular', "24", [
    "M18 3q.38.01.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1q0 .1-.02.2l-.05.13-.03.06-.04.06-.04.05.02-.03-1.27 1.45q-.65-.47-1.46-.62l.49-.55H16.6L12.7 20.52c-.12.3-.4.48-.7.48h-.1l-.1-.03h-.02l-.17-.08h-.01l-.13-.1-9.3-10.55-.02-.04-.04-.06a1 1 0 0 1-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06 3.25-6a.8.8 0 0 1 .56-.38L6 3zm-3 7.5H9l3 7.69zm-7.61 0H4.4l5.35 6.07zm1.58-6H6.44L4.01 9h3.52zm4.48 0h-2.9L9.1 9h5.79zm4.1 0h-2.52L16.47 9h3.52zm3.45 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $db6ad3fef28672ff$export$2336da4b9d112afc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable10Filled', "10", [
    "M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10m2.1-5.9L4.85 6.35a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 1.9-1.9a.5.5 0 0 1 .7.71"
]);
const $db6ad3fef28672ff$export$6135855172ba18a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable10Regular', "10", [
    "M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0M1 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0m6.1-1.6c.2.2.2.5 0 .7L4.85 6.35a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 1.9-1.9c.2-.19.5-.19.7 0"
]);
const $db6ad3fef28672ff$export$8409be9342c56497 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable12Filled', "12", [
    "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m2.53-6.72L5.78 8.03c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l.47.47 2.22-2.22a.75.75 0 0 1 1.06 1.06"
]);
const $db6ad3fef28672ff$export$cc7567a4085fcefc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable12Regular', "12", [
    "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0M1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m7.03-1.78c.3.3.3.77 0 1.06L5.78 8.03c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l.47.47 2.22-2.22c.3-.3.77-.3 1.06 0"
]);
const $db6ad3fef28672ff$export$dfc8de308d7a430 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable16Filled', "16", [
    "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m3.7-9.3-4 4a1 1 0 0 1-1.41 0l-2-2a1 1 0 1 1 1.42-1.4L7 8.58l3.3-3.3a1 1 0 0 1 1.4 1.42"
]);
const $db6ad3fef28672ff$export$ac85b31298a9aeab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable16Regular', "16", [
    "M11.7 6.7a1 1 0 0 0-1.4-1.4L7 8.58l-1.3-1.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
]);
const $db6ad3fef28672ff$export$7897d1c243dd316e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable20Filled', "20", [
    "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m4.2-11.8-4.5 4.5a1 1 0 0 1-1.4 0l-2-2a1 1 0 1 1 1.4-1.4L9 10.58l3.8-3.8a1 1 0 1 1 1.4 1.42"
]);
const $db6ad3fef28672ff$export$bbbdb8197498b6a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable20Regular', "20", [
    "M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m12.2-3.2a1 1 0 0 1 0 1.4l-4.5 4.5a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.4L9 10.58l3.8-3.8a1 1 0 0 1 1.4 0"
]);
const $db6ad3fef28672ff$export$35c55be728bb1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable24Filled', "24", [
    "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24m5.06-13.44-5.5 5.5a1.5 1.5 0 0 1-2.12 0l-2-2a1.5 1.5 0 0 1 2.12-2.12l.94.94 4.44-4.44a1.5 1.5 0 0 1 2.12 2.12"
]);
const $db6ad3fef28672ff$export$75dffe11e63a7ce9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAvailable24Regular', "24", [
    "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m14.06-3.56a1.5 1.5 0 0 1 0 2.12l-5.5 5.5a1.5 1.5 0 0 1-2.12 0l-2-2a1.5 1.5 0 0 1 2.12-2.12l.94.94 4.44-4.44a1.5 1.5 0 0 1 2.12 0"
]);
const $db6ad3fef28672ff$export$aa6c54fa4585e6ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway10Filled', "10", [
    "M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10m0-7v1.8l1.35 1.35a.5.5 0 1 1-.7.7l-1.5-1.5A.5.5 0 0 1 4 5V3a.5.5 0 0 1 1 0"
]);
const $db6ad3fef28672ff$export$fce5277afd3c0810 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway10Regular', "10", [
    "M5 4.8V3a.5.5 0 0 0-1 0v2q0 .2.15.35l1.5 1.5a.5.5 0 1 0 .7-.7zm5 .2A5 5 0 1 1 0 5a5 5 0 0 1 10 0M9 5a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
]);
const $db6ad3fef28672ff$export$105a31b1756bab6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway12Filled', "12", [
    "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m.5-8.75v2.4l1.49 1.28A.75.75 0 1 1 7 8.07l-1.75-1.5A.8.8 0 0 1 5 6V3.25a.75.75 0 0 1 1.5 0"
]);
const $db6ad3fef28672ff$export$7c44d63d26d809dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway12Regular', "12", [
    "M6.5 5.66V3.25a.75.75 0 0 0-1.5 0V6q.01.34.26.57l1.75 1.5A.75.75 0 1 0 8 6.93zM12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
]);
const $db6ad3fef28672ff$export$5b8c0195a650ffbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway16Filled', "16", [
    "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.5-11.5v3.02l2.12 1.7a1 1 0 1 1-1.24 1.56l-2.5-2A1 1 0 0 1 6.5 8V4.5a1 1 0 0 1 2 0"
]);
const $db6ad3fef28672ff$export$d63c0ab4b7a00bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway16Regular', "16", [
    "M8.5 7.52V4.5a1 1 0 1 0-2 0V8c0 .3.14.6.38.78l2.5 2a1 1 0 1 0 1.24-1.56zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
]);
const $db6ad3fef28672ff$export$8f329086e703aa76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway20Filled', "20", [
    "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m0-14V9.6l2.7 2.7a1 1 0 0 1-1.4 1.42l-3-3A1 1 0 0 1 8 10V6a1 1 0 1 1 2 0"
]);
const $db6ad3fef28672ff$export$b28855588e7af32c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway20Regular', "20", [
    "M10 9.59V6a1 1 0 1 0-2 0V10q0 .42.3.7l3 3a1 1 0 1 0 1.4-1.4zm-10 .4a10 10 0 1 1 20 0 10 10 0 0 1-20 0M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $db6ad3fef28672ff$export$3c3e61555517ed8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway24Filled', "24", [
    "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24m1-17.5v4.81l2.98 2.55a1.5 1.5 0 0 1-1.96 2.28l-3.5-3A1.5 1.5 0 0 1 10 12V6.5a1.5 1.5 0 0 1 3 0"
]);
const $db6ad3fef28672ff$export$8dc3f9e6f61de50e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceAway24Regular', "24", [
    "M13 11.31V6.5a1.5 1.5 0 0 0-3 0V12c0 .44.2.85.52 1.14l3.5 3a1.5 1.5 0 0 0 1.96-2.28zM0 12a12 12 0 1 1 24 0 12 12 0 0 1-24 0m12-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
]);
const $db6ad3fef28672ff$export$a69b5d009c0253ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBlocked10Regular', "10", [
    "M10 5A5 5 0 1 0 0 5a5 5 0 0 0 10 0M9 5a4 4 0 0 1-6.45 3.16l5.61-5.61C8.69 3.22 9 4.08 9 5M7.45 1.84 1.84 7.45a4 4 0 0 1 5.61-5.61"
]);
const $db6ad3fef28672ff$export$f829eda1dcedce36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBlocked12Regular', "12", [
    "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-1.5 0c0-.97-.3-1.87-.83-2.6L3.39 9.66A4.5 4.5 0 0 0 10.5 6M8.6 2.33a4.5 4.5 0 0 0-6.28 6.28z"
]);
const $db6ad3fef28672ff$export$ca62c5bc590bcb42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBlocked16Regular', "16", [
    "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-2 0c0-1.3-.41-2.5-1.1-3.48L4.51 12.9A6 6 0 0 0 14 8m-2.52-4.9a6 6 0 0 0-8.37 8.37z"
]);
const $db6ad3fef28672ff$export$5d07dc6457578eda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBlocked20Regular', "20", [
    "M20 10a10 10 0 1 0-20 0 10 10 0 0 0 20 0m-2 0a8 8 0 0 1-12.9 6.32L16.31 5.09A8 8 0 0 1 18 10m-3.1-6.32L3.69 14.91A8 8 0 0 1 14.91 3.68"
]);
const $db6ad3fef28672ff$export$944f07a4bcbf8c5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBlocked24Regular', "24", [
    "M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0m-3 0c0-1.94-.62-3.74-1.66-5.21L6.79 19.34A9 9 0 0 0 21 12m-3.79-7.34A9 9 0 0 0 4.66 17.21z"
]);
const $db6ad3fef28672ff$export$b328fef9411355f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBusy10Filled', "10", [
    "M10 5A5 5 0 1 1 0 5a5 5 0 0 1 10 0"
]);
const $db6ad3fef28672ff$export$d32c2187ad6354cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBusy12Filled', "12", [
    "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0"
]);
const $db6ad3fef28672ff$export$8b037ecb59de1869 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBusy16Filled', "16", [
    "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"
]);
const $db6ad3fef28672ff$export$db84f0dcfb050a9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBusy20Filled', "20", [
    "M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0"
]);
const $db6ad3fef28672ff$export$503eb59a654f8326 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceBusy24Filled', "24", [
    "M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0"
]);
const $db6ad3fef28672ff$export$c946be8577feeff1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd10Filled', "10", [
    "M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10M3.5 4.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$f551eb69a6c629f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd10Regular', "10", [
    "M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0M1 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0m2 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 3 5"
]);
const $db6ad3fef28672ff$export$60f4b61c2c9084f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd12Filled', "12", [
    "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12M3.75 5.25h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$d101e620c5b82561 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd12Regular', "12", [
    "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0M1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M3 6c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 3 6"
]);
const $db6ad3fef28672ff$export$ec749c1e92909664 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd16Filled', "16", [
    "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M5.25 7h5.5a1 1 0 1 1 0 2h-5.5a1 1 0 1 1 0-2"
]);
const $db6ad3fef28672ff$export$67c9d918ed9d3561 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd16Regular', "16", [
    "M5.25 7a1 1 0 0 0 0 2h5.5a1 1 0 1 0 0-2zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
]);
const $db6ad3fef28672ff$export$7d23d8e50558c288 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd20Filled', "20", [
    "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20M7 9h6a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2"
]);
const $db6ad3fef28672ff$export$f00a5de77036aa8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd20Regular', "20", [
    "M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m4 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$9d44dd48d712d1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd24Filled', "24", [
    "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24M7.5 10.5h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1 0-3"
]);
const $db6ad3fef28672ff$export$95c4303474f79ca3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceDnd24Regular', "24", [
    "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m3 0c0-.83.67-1.5 1.5-1.5h9a1.5 1.5 0 0 1 0 3h-9A1.5 1.5 0 0 1 6 12"
]);
const $db6ad3fef28672ff$export$9744a3328ec72bdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOffline10Regular', "10", [
    "M6.85 3.15c.2.2.2.5 0 .7L5.71 5l1.14 1.15a.5.5 0 1 1-.7.7L5 5.71 3.85 6.85a.5.5 0 1 1-.7-.7L4.29 5 3.15 3.85a.5.5 0 1 1 .7-.7L5 4.29l1.15-1.14c.2-.2.5-.2.7 0M0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5m5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
]);
const $db6ad3fef28672ff$export$1f35fc88cba9b7d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOffline12Regular', "12", [
    "M8.03 3.97c.3.3.3.77 0 1.06L7.06 6l.97.97a.75.75 0 0 1-1.06 1.06L6 7.06l-.97.97a.75.75 0 0 1-1.06-1.06L4.94 6l-.97-.97a.75.75 0 0 1 1.06-1.06l.97.97.97-.97c.3-.3.77-.3 1.06 0M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m6-4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
]);
const $db6ad3fef28672ff$export$863a902e5747c1fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOffline16Regular', "16", [
    "M10.7 5.3a1 1 0 0 1 0 1.4L9.42 8l1.3 1.3a1 1 0 0 1-1.42 1.4L8 9.42l-1.3 1.3a1 1 0 0 1-1.4-1.42L6.58 8l-1.3-1.3a1 1 0 0 1 1.42-1.4L8 6.58l1.3-1.3a1 1 0 0 1 1.4 0M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
]);
const $db6ad3fef28672ff$export$25d1da3d11922bca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOffline20Regular', "20", [
    "M13.7 6.3a1 1 0 0 1 0 1.4L11.42 10l2.3 2.3a1 1 0 0 1-1.42 1.4L10 11.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L8.58 10l-2.3-2.3a1 1 0 0 1 1.42-1.4L10 8.58l2.3-2.3a1 1 0 0 1 1.4 0M0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0m10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $db6ad3fef28672ff$export$7848b9e620f6ca4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOffline24Regular', "24", [
    "M16.06 7.94a1.5 1.5 0 0 1 0 2.12L14.12 12l1.94 1.94a1.5 1.5 0 0 1-2.12 2.12L12 14.12l-1.94 1.94a1.5 1.5 0 0 1-2.12-2.12L9.88 12l-1.94-1.94a1.5 1.5 0 1 1 2.12-2.12L12 9.88l1.94-1.94a1.5 1.5 0 0 1 2.12 0M0 12a12 12 0 1 1 24 0 12 12 0 0 1-24 0m12-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
]);
const $db6ad3fef28672ff$export$a0948e2f86247a28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOof10Regular', "10", [
    "M5.35 3.85a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7L4.7 5.5h1.8a.5.5 0 1 0 0-1H4.7zM5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0M1 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
]);
const $db6ad3fef28672ff$export$9328f59444fba2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOof12Regular', "12", [
    "M6.28 4.53a.75.75 0 0 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 0 0 1.06-1.06l-.72-.72h2.69a.75.75 0 1 0 0-1.5h-2.7zM6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0M1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0"
]);
const $db6ad3fef28672ff$export$71b298daaff0f2e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOof16Regular', "16", [
    "M8.2 6.2a1 1 0 1 0-1.4-1.4L4.3 7.3a1 1 0 0 0 0 1.4l2.5 2.5a1 1 0 0 0 1.4-1.4L7.42 9H11a1 1 0 1 0 0-2H7.41zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
]);
const $db6ad3fef28672ff$export$639bb6b78f006f01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOof20Regular', "20", [
    "M10.7 7.7A1 1 0 1 0 9.28 6.3l-3 3a1 1 0 0 0 0 1.41l3 3a1 1 0 1 0 1.42-1.41l-1.3-1.3H13a1 1 0 1 0 0-2H9.4zM10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
]);
const $db6ad3fef28672ff$export$e72806585170d402 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceOof24Regular', "24", [
    "M12.56 9.06a1.5 1.5 0 0 0-2.12-2.12l-4 4a1.5 1.5 0 0 0 0 2.12l4 4a1.5 1.5 0 0 0 2.12-2.12l-1.44-1.44h5.38a1.5 1.5 0 1 0 0-3h-5.38zM12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0"
]);
const $db6ad3fef28672ff$export$be0712a5eed66ee3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceTentative10Regular', "10", [
    "M10 5.06A5 5 0 0 1 5.07 10zm-.28-1.72A5 5 0 0 0 9 2L2 9q.6.46 1.34.72zM1 7.99Q.54 7.4.28 6.66L6.66.28Q7.38.53 8 1zM4.94 0A5 5 0 0 0 0 4.94z"
]);
const $db6ad3fef28672ff$export$b8c98470e3db3e60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceTentative12Regular', "12", [
    "M12 6.06A6 6 0 0 1 6.06 12zm-.35-2.09q-.3-.85-.84-1.56l-8.4 8.4q.71.53 1.56.84zM1.19 9.6Q.66 8.88.35 8.03L8.03.35q.85.3 1.56.84zM5.94 0A6 6 0 0 0 0 5.94z"
]);
const $db6ad3fef28672ff$export$f42713919c4d7d4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceTentative16Regular', "16", [
    "M16 8.1A8 8 0 0 1 8.1 16zm-.46-2.77A8 8 0 0 0 14.4 3.2L3.2 14.41q.97.72 2.12 1.13zM1.59 12.8a8 8 0 0 1-1.14-2.12L10.67.46q1.16.41 2.12 1.14zM7.91 0A8 8 0 0 0-.01 7.91z"
]);
const $db6ad3fef28672ff$export$53c83cd773d3857c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceTentative20Regular', "20", [
    "M8.95.05a9.96 9.96 0 0 0-8.9 8.9zM.19 11.95 11.95.2q1.21.24 2.35.78L.97 14.31a10 10 0 0 1-.78-2.36m1.99 4.29a10 10 0 0 0 1.58 1.58L17.81 3.76a10 10 0 0 0-1.58-1.58zM19.02 5.69 5.7 19.03q1.14.54 2.36.78L19.8 8.05q-.24-1.21-.79-2.36m.92 5.37-8.89 8.88a9.96 9.96 0 0 0 8.89-8.88"
]);
const $db6ad3fef28672ff$export$5e7b5b85c490830d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceTentative24Regular', "24", [
    "M11.68 0A12 12 0 0 0 0 11.68zM2.39 19.2Q1.26 17.68.64 15.87L15.88.64q1.8.62 3.3 1.75zM23.36 8.11 8.12 23.36q-1.81-.61-3.31-1.75l16.8-16.8q1.12 1.5 1.75 3.31m.63 4.2L12.32 24A12 12 0 0 0 24 12.33"
]);
const $db6ad3fef28672ff$export$bf953cd935f00b01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceUnknown10Regular', "10", [
    "M5 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5"
]);
const $db6ad3fef28672ff$export$2e7efe060a25b5a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceUnknown12Regular', "12", [
    "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6"
]);
const $db6ad3fef28672ff$export$6e01bade7e77dedc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceUnknown16Regular', "16", [
    "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"
]);
const $db6ad3fef28672ff$export$1afd02eef2d99a95 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceUnknown20Regular', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0"
]);
const $db6ad3fef28672ff$export$2609440067af8e2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenceUnknown24Regular', "24", [
    "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M0 12a12 12 0 1 1 24 0 12 12 0 0 1-24 0"
]);
const $db6ad3fef28672ff$export$23e9504474959e85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter16Filled', "16", [
    "M13.5 8a.5.5 0 0 1 .35.85L11 11.71v1.54c0 .97-.78 1.75-1.75 1.75h-2.5C5.78 15 5 14.22 5 13.25v-1.54L2.15 8.85A.5.5 0 0 1 2.5 8zM9.75 6c.7 0 1.3.4 1.58 1H4.67c.28-.6.88-1 1.58-1zM8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $db6ad3fef28672ff$export$d9acd908a0cb515e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter16Regular', "16", [
    "M13.5 8a.5.5 0 0 1 .35.85L11 11.71v1.54c0 .97-.78 1.75-1.75 1.75h-2.5C5.78 15 5 14.22 5 13.25v-1.54L2.15 8.85A.5.5 0 0 1 2.5 8zm-7.65 3.15q.15.14.15.35v1.75c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75V11.5a.5.5 0 0 1 .15-.35L12.29 9H3.71zM9.75 6c.7 0 1.3.4 1.58 1H4.67c.28-.6.88-1 1.58-1zM8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $db6ad3fef28672ff$export$54155029be649496 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter20Filled', "20", [
    "M12 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7 14.78v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 0 1 .15-.36l3.7-3.56a.5.5 0 0 0-.34-.86H3.49a.5.5 0 0 0-.35.86l3.7 3.56q.15.16.16.36M8.5 7C7.67 7 7 7.67 7 8.5V9h6v-.5c0-.83-.67-1.5-1.5-1.5z"
]);
const $db6ad3fef28672ff$export$3545a8a11102ec09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter20Regular', "20", [
    "M10 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2M8.5 8a.5.5 0 0 0-.5.5V9H7v-.5C7 7.67 7.67 7 8.5 7h3c.83 0 1.5.67 1.5 1.5V9h-1v-.5a.5.5 0 0 0-.5-.5zM7 14.78v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 0 1 .15-.36l3.7-3.56a.5.5 0 0 0-.34-.86H3.49a.5.5 0 0 0-.35.86l3.7 3.56q.15.16.16.36m1 1.72v-1.72c0-.4-.17-.8-.46-1.08L4.73 11h10.54l-2.81 2.7c-.3.29-.46.68-.46 1.08v1.72a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$11e123e97f837567 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter24Filled', "24", [
    "M20.25 12a.75.75 0 0 1 .51 1.3L16 17.72v2.03c0 1.24-1 2.25-2.25 2.25h-3.5C9.01 22 8 21 8 19.75v-2.03L3.24 13.3a.75.75 0 0 1 .51-1.3zm-6-3c1.16 0 2.11.88 2.24 2H7.52c.12-1.12 1.07-2 2.23-2zM12 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
]);
const $db6ad3fef28672ff$export$9ff2e69771a3bfbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter24Regular', "24", [
    "M20.25 12a.75.75 0 0 1 .51 1.3L16 17.72v2.03c0 1.24-1 2.25-2.25 2.25h-3.5C9.01 22 8 21 8 19.75v-2.03L3.24 13.3a.75.75 0 0 1 .51-1.3zM9.26 16.84q.23.22.24.55v2.36c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-2.36q0-.31.24-.55l3.6-3.34H5.66zm5-7.84c1.15 0 2.1.88 2.23 2h-1.53a.75.75 0 0 0-.7-.5h-4.5c-.34 0-.61.2-.71.5H7.52c.12-1.12 1.07-2 2.23-2zM12 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $db6ad3fef28672ff$export$e4c1ef43c80caec6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter28Filled', "28", [
    "M24.25 14a.75.75 0 0 1 .51 1.3L19 20.65v2.6A2.75 2.75 0 0 1 16.25 26h-4.5A2.75 2.75 0 0 1 9 23.25v-2.6L3.24 15.3a.75.75 0 0 1 .51-1.3zm-8-3.5c1.44 0 2.61 1.1 2.74 2.5H9.02c.12-1.4 1.3-2.5 2.73-2.5zM14 2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
]);
const $db6ad3fef28672ff$export$31ecb5466954c20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter28Regular', "28", [
    "M24.25 14a.75.75 0 0 1 .51 1.3L19 20.65v2.6A2.75 2.75 0 0 1 16.25 26h-4.5A2.75 2.75 0 0 1 9 23.25v-2.6L3.24 15.3a.75.75 0 0 1 .51-1.3zm-13.99 5.77q.23.22.24.55v3.06c.07.63.6 1.12 1.25 1.12h4.5c.69 0 1.25-.56 1.25-1.25v-2.93q0-.31.24-.55l4.6-4.27H5.66zm5.99-9.27c1.43 0 2.61 1.1 2.74 2.5h-1.52c-.11-.57-.62-1-1.22-1h-4.5c-.6 0-1.11.43-1.23 1h-1.5c.12-1.4 1.3-2.5 2.73-2.5zM14 2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $db6ad3fef28672ff$export$38858f8c411ed5d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter32Filled', "32", [
    "M27 16a1 1 0 0 1 .7 1.7L21 24.42v2.34c0 1.8-1.46 3.25-3.25 3.25h-3.5A3.25 3.25 0 0 1 11 26.75v-2.34l-6.7-6.7A1 1 0 0 1 5 16zm-8.75-5c1.8 0 3.25 1.46 3.25 3.25v.25h-11v-.25c0-1.8 1.46-3.25 3.25-3.25zM16 2a3.75 3.75 0 1 1 0 7.5A3.75 3.75 0 0 1 16 2"
]);
const $db6ad3fef28672ff$export$94df8466078ec554 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter32Light', "32", [
    "M26.97 16a1.03 1.03 0 0 1 .8 1.68l-.07.08-6.7 6.7v2.29c0 1.8-1.46 3.25-3.25 3.25h-3.5A3.25 3.25 0 0 1 11 26.75v-2.3l-6.7-6.7A1.03 1.03 0 0 1 5.03 16zM5.03 17a.03.03 0 0 0-.02.05l6.84 6.85q.15.14.15.35v2.5c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25v-2.5a.5.5 0 0 1 .15-.35l6.84-6.85.01-.02v-.02l-.03-.01zm13.22-6c1.8 0 3.25 1.46 3.25 3.25v.25h-1v-.25c0-1.24-1-2.25-2.25-2.25h-4.5c-1.24 0-2.25 1-2.25 2.25v.25h-1v-.25c0-1.8 1.46-3.25 3.25-3.25zM16 2a3.75 3.75 0 1 1 0 7.5A3.75 3.75 0 0 1 16 2m0 1a2.75 2.75 0 1 0 0 5.5A2.75 2.75 0 0 0 16 3"
]);
const $db6ad3fef28672ff$export$34f435cfb88900be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter32Regular', "32", [
    "M27 16a1 1 0 0 1 .7 1.7L21 24.42v2.34c0 1.8-1.46 3.25-3.25 3.25h-3.5A3.25 3.25 0 0 1 11 26.75v-2.34l-6.7-6.7A1 1 0 0 1 5 16zm-14.3 7.3a1 1 0 0 1 .3.7v2.75c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25V24a1 1 0 0 1 .3-.7l5.29-5.3H7.4zM18.26 11c1.8 0 3.25 1.46 3.25 3.25v.25h-2v-.25c0-.69-.56-1.25-1.25-1.25h-4.5c-.69 0-1.25.56-1.25 1.25v.25h-2v-.25c0-1.8 1.46-3.25 3.25-3.25zM16 2a3.75 3.75 0 1 1 0 7.5A3.75 3.75 0 0 1 16 2m0 2a1.75 1.75 0 1 0 0 3.5A1.75 1.75 0 0 0 16 4"
]);
const $db6ad3fef28672ff$export$44ee0a3261648b19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter48Filled', "48", [
    "M40.75 23a1.25 1.25 0 0 1 .88 2.13L31 35.77v3.98C31 42.1 29.1 44 26.75 44h-5.5A4.25 4.25 0 0 1 17 39.75v-3.98L6.37 25.13A1.25 1.25 0 0 1 7.25 23zm-13.5-7c2.35 0 4.25 1.9 4.25 4.25V21h-15v-.75c0-2.35 1.9-4.25 4.25-4.25zM24 4a5 5 0 1 1 0 10 5 5 0 0 1 0-10"
]);
const $db6ad3fef28672ff$export$dd77af8263b22b3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Presenter48Regular', "48", [
    "M40.75 23a1.25 1.25 0 0 1 .88 2.13L31 35.77v3.98C31 42.1 29.1 44 26.75 44h-5.5A4.25 4.25 0 0 1 17 39.75v-3.98L6.37 25.13A1.25 1.25 0 0 1 7.25 23zM19.13 34.37q.36.36.37.88v4.5c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75v-4.5q0-.52.37-.88l8.86-8.87H10.27zM27.25 16c2.35 0 4.25 1.9 4.25 4.25V21H29v-.75c0-.97-.78-1.75-1.75-1.75h-6.5c-.97 0-1.75.78-1.75 1.75V21h-2.5v-.75c0-2.35 1.9-4.25 4.25-4.25zM24 4a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $db6ad3fef28672ff$export$8909c17430f57713 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenterOff20Filled', "20", [
    "M7.15 7.85Q7 8.15 7 8.5V9h1.3l1 1H3.5a.5.5 0 0 0-.36.86l3.7 3.56q.15.16.16.36v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 0 1 .15-.36l.29-.27 3.7 3.7a.5.5 0 0 0 .71-.7l-10-10-5-5a.5.5 0 1 0-.7.7zm9.7 3.01-1.97 1.9L12.12 10h4.39a.5.5 0 0 1 .35.86M13 9h-1.88l-2-2h2.38c.83 0 1.5.67 1.5 1.5zm-3-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $db6ad3fef28672ff$export$a2d25ead3fac0c41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenterOff20Regular', "20", [
    "M7 8.5q0-.35.15-.65l-5-5a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-3.71-3.7-.29.27a.5.5 0 0 0-.15.36v1.72c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 7 16.5v-1.72a.5.5 0 0 0-.15-.36l-3.7-3.56a.5.5 0 0 1 .34-.86h5.8l-1-1H7zm3.3 2.5H4.72l2.81 2.7c.3.29.46.68.46 1.08v1.72c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-1.72c0-.4.17-.8.46-1.08l.27-.26zM12 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-.88 4h1.38c.28 0 .5.22.5.5V9h1v-.5c0-.83-.67-1.5-1.5-1.5H9.12zm4.76 4.76-.7-.7L15.26 11h-2.15l-1-1h4.39a.5.5 0 0 1 .35.86z"
]);
const $db6ad3fef28672ff$export$8c33d521bea0ab3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenterOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l5.85 5.86C7.44 9.4 7 10.02 7 10.75V12h3.94l1 1h-8.2c-.7 0-1.01.89-.46 1.33L8 18.11v1.64C8 21 9 22 10.25 22h3.5c1.24 0 2.25-1 2.25-2.25v-1.64l.58-.47 4.14 4.14a.75.75 0 0 0 1.06-1.06zM16.18 13l2.76 2.76 1.77-1.43a.75.75 0 0 0-.47-1.33zm-4-4 3 3H17v-1.39C16.92 9.7 16.16 9 15.24 9zM12 8a3 3 0 0 1-.98-.16L9.16 5.98A3 3 0 1 1 12 8"
]);
const $db6ad3fef28672ff$export$463d6bc7b0a37d51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PresenterOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l5.85 5.86C7.44 9.4 7 10.02 7 10.75V12h1.5v-1.31q.06-.17.25-.19h.69l2.5 2.5h-8.2c-.7 0-1.01.89-.46 1.33L8 18.11v1.64C8 21 9 22 10.25 22h3.5c1.24 0 2.25-1 2.25-2.25v-1.64l.58-.47 4.14 4.14a.75.75 0 0 0 1.06-1.06zm12.23 14.35-.73.6a.8.8 0 0 0-.28.58v2c0 .42-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75v-2q0-.36-.28-.59L5.89 14.5h7.55zM12 8a3 3 0 0 1-.98-.16L9.16 5.98A3 3 0 1 1 12 8m0-4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m8.24 9.5h-4.06l2.76 2.76 1.77-1.43a.75.75 0 0 0-.47-1.33m-6.56-2.5L12.18 9h3.06c.92 0 1.68.7 1.75 1.6V12h-1.5v-1.25a.25.25 0 0 0-.19-.24l-.06-.01z"
]);
const $db6ad3fef28672ff$export$adde661861462fc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink16Filled', "16", [
    "M4 5v1h8V5zm6 4v2h2V9zM1 4.75A2.75 2.75 0 0 1 3.75 2h8.5A2.75 2.75 0 0 1 15 4.75v6.5A2.75 2.75 0 0 1 12.25 14h-8.5A2.75 2.75 0 0 1 1 11.25zm2-.25v2c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5m6 4v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5m-5.5 0a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 11c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$1297fe71cba40a18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink16Regular', "16", [
    "M3 4.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zM4 5v1h8V5zm5.5 3a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm.5 3V9h2v2zM3 9c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 3 9m.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 1 0 0-1zM1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5zM3.5 3C2.67 3 2 3.67 2 4.5v7c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $db6ad3fef28672ff$export$734f3f61970edeb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink20Filled', "20", [
    "M5 6v2h10V6zm7 5v3h3v-3zM2 5.75A2.75 2.75 0 0 1 4.75 3h10.5A2.75 2.75 0 0 1 18 5.75v8.5A2.75 2.75 0 0 1 15.25 17H4.75A2.75 2.75 0 0 1 2 14.25zm2-.25v3c0 .27.22.5.5.5h11a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5m7 5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5m-6.5 0a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM4 14c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$79c420bcd32106b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink20Regular', "20", [
    "M4 5.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zM5 6v2h10V6zm6.5 4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5zm.5 4v-3h3v3zm-8-3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 4 11m.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM2 5.5A2.5 2.5 0 0 1 4.5 3h11A2.5 2.5 0 0 1 18 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5zM4.5 4C3.67 4 3 4.67 3 5.5v9c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5z"
]);
const $db6ad3fef28672ff$export$dda03e041a880b6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink24Filled', "24", [
    "M6.02 7v2h11.96V7zm8.96 6.48v3h3v-3zM2 5.75A2.75 2.75 0 0 1 4.75 3h14.5A2.75 2.75 0 0 1 22 5.75v12.5A2.75 2.75 0 0 1 19.25 21H4.75A2.75 2.75 0 0 1 2 18.25zm2.52.5v3.5c0 .41.34.75.75.75h13.46c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75H5.27a.75.75 0 0 0-.75.75m8.96 6.48v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75m-8.2-.23a.75.75 0 0 0 0 1.5h5.97a.75.75 0 0 0 0-1.5zm-.76 4.25c0 .41.34.75.75.75h5.98a.75.75 0 0 0 0-1.5H5.27a.75.75 0 0 0-.75.75"
]);
const $db6ad3fef28672ff$export$9dcd42218874da53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink24Regular', "24", [
    "M4.52 6.25c0-.41.34-.75.75-.75h13.46c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75H5.27a.75.75 0 0 1-.75-.75zm1.5.75v2h11.96V7zm8.21 4.98a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75zm.75 4.5v-3h3v3zM4.52 13.25c0-.41.34-.75.75-.75h5.98a.75.75 0 0 1 0 1.5H5.27a.75.75 0 0 1-.75-.75M5.27 16a.75.75 0 0 0 0 1.5h5.98a.75.75 0 0 0 0-1.5zM2 5.75A2.75 2.75 0 0 1 4.75 3h14.5A2.75 2.75 0 0 1 22 5.75v12.5A2.75 2.75 0 0 1 19.25 21H4.75A2.75 2.75 0 0 1 2 18.25zM4.75 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $db6ad3fef28672ff$export$ba43584df82699b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 19.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zm10.5-3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h5.5c.7 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zm5.25 3h-5V18h5zm-15.75-3a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zm.5-9.5C5.56 7 5 7.56 5 8.25v5.5c0 .69.56 1.25 1.25 1.25h15.5c.7 0 1.25-.56 1.25-1.25v-5.5C23 7.56 22.44 7 21.75 7zm15.25 6.5h-15v-5h15z"
]);
const $db6ad3fef28672ff$export$c6c68d9bad669fa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25zm7 14a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5zm9-3c.7 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25zm-5.25 3h5V18h-5zm-3.75-3a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5zm9-9.5c.7 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25H6.25C5.56 15 5 14.44 5 13.75v-5.5C5 7.56 5.56 7 6.25 7zM6.5 13.5h15v-5h-15z"
]);
const $db6ad3fef28672ff$export$dc7b123072164e78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink32Filled', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM7 22a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm11.5-4c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zm5.5 4h-5v-2h5zM7 18a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm.5-10C6.67 8 6 8.67 6 9.5v5c0 .83.67 1.5 1.5 1.5h17c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM24 14H8v-4h16z"
]);
const $db6ad3fef28672ff$export$9150243e9ecb11ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink32Light', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-19 1A3.5 3.5 0 0 0 3 8.5v15A3.5 3.5 0 0 0 6.5 27h19a3.5 3.5 0 0 0 3.5-3.5v-15A3.5 3.5 0 0 0 25.5 5zm8 18a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1zM25 19a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm-7 4h7v-3h-7zm-3.5-4a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1zM25 8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zM7 15h18V9H7z"
]);
const $db6ad3fef28672ff$export$39582f82afacc269 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviewLink32Regular', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-19 2A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6zM14 22a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm10.5-4c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5zM19 22h5v-2h-5zm-5-4a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM24.5 8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-17A1.5 1.5 0 0 1 6 14.5v-5C6 8.67 6.67 8 7.5 8zM8 14h16v-4H8z"
]);
const $db6ad3fef28672ff$export$4e526ee5600533e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous16Filled', "16", [
    "M14 3a1 1 0 0 0-1.58-.81l-7 4.96a1 1 0 0 0 0 1.63l7 5.03a1 1 0 0 0 1.58-.8zM2 2.5a.5.5 0 0 1 1 0v11a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$1c400ffec4de236b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous16Regular', "16", [
    "M2 2.5a.5.5 0 0 1 1 0v11a.5.5 0 0 1-1 0zM14 3a1 1 0 0 0-1.58-.81l-7 4.96a1 1 0 0 0 0 1.63l7 5.03a1 1 0 0 0 1.58-.8zM6 7.96 13 3v10z"
]);
const $db6ad3fef28672ff$export$a28220f7bd1500d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous20Filled', "20", [
    "M17 4.25c0-1-1.12-1.6-1.95-1.04l-8.5 5.71c-.73.5-.73 1.57 0 2.07l8.5 5.8c.83.56 1.95-.03 1.95-1.04zM3 3.5a.5.5 0 0 1 1 0v13a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$eba4d2c9bbb48f76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous20Regular', "20", [
    "M3 3.5a.5.5 0 0 1 1 0v13a.5.5 0 0 1-1 0zm14 .75c0-1-1.12-1.6-1.95-1.04l-8.5 5.71c-.73.5-.73 1.57 0 2.07l8.5 5.8c.83.56 1.95-.03 1.95-1.04zm-1.39-.2c.17-.12.39 0 .39.2v11.5c0 .2-.22.32-.4.2l-8.49-5.78a.25.25 0 0 1 0-.42z"
]);
const $db6ad3fef28672ff$export$348a947b394b303 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous24Filled', "24", [
    "M3 3.75a.75.75 0 0 1 1.5 0v16.5a.75.75 0 0 1-1.5 0zm18 1c0-1.4-1.58-2.24-2.74-1.44l-10.5 7.2a1.75 1.75 0 0 0 0 2.87l10.5 7.3c1.15.81 2.74-.02 2.74-1.43z"
]);
const $db6ad3fef28672ff$export$1937d49a2b8b0dc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous24Regular', "24", [
    "M21 4.75c0-1.4-1.58-2.24-2.74-1.44l-10.5 7.2a1.75 1.75 0 0 0 0 2.87l10.5 7.3c1.15.81 2.74-.02 2.74-1.43zm-1.9-.2c.17-.12.4 0 .4.2v14.5c0 .2-.23.32-.4.2l-10.5-7.3a.25.25 0 0 1 .01-.41zM3 3.75a.75.75 0 0 1 1.5 0v16.5a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$ab42a1970d620d90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous28Filled', "28", [
    "M4.5 3.75a.75.75 0 0 0-1.5 0v20.5a.75.75 0 0 0 1.5 0zM25 5.25a2.25 2.25 0 0 0-3.53-1.84l-12.5 8.68a2.25 2.25 0 0 0-.02 3.68l12.5 8.81A2.25 2.25 0 0 0 25 22.75z"
]);
const $db6ad3fef28672ff$export$d8bf1440ab8a7fcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous28Regular', "28", [
    "M4.5 3.75a.75.75 0 0 0-1.5 0v20.5a.75.75 0 0 0 1.5 0zM25 5.25a2.25 2.25 0 0 0-3.53-1.84l-12.5 8.68a2.25 2.25 0 0 0-.02 3.68l12.5 8.81A2.25 2.25 0 0 0 25 22.75zm-2.68-.61a.75.75 0 0 1 1.18.61v17.5c0 .6-.69.96-1.18.6l-12.5-8.8a.75.75 0 0 1 0-1.23z"
]);
const $db6ad3fef28672ff$export$b99c6eb1c41eb806 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous32Filled', "32", [
    "M6 5a1 1 0 0 0-2 0v22a1 1 0 1 0 2 0zm22 1.5c0-2-2.23-3.19-3.9-2.07l-14 9.43A2.5 2.5 0 0 0 10.1 18l14 9.56A2.5 2.5 0 0 0 28 25.5z"
]);
const $db6ad3fef28672ff$export$9702f453c1a1e10c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous32Regular', "32", [
    "M6 5a1 1 0 0 0-2 0v22a1 1 0 1 0 2 0zm22 1.5c0-2-2.23-3.19-3.9-2.07l-14 9.43A2.5 2.5 0 0 0 10.1 18l14 9.56A2.5 2.5 0 0 0 28 25.5zm-2.78-.41a.5.5 0 0 1 .78.41v19a.5.5 0 0 1-.78.4l-14-9.55a.5.5 0 0 1 0-.83z"
]);
const $db6ad3fef28672ff$export$5cf850e062b82caa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous48Filled', "48", [
    "M7.25 6c.69 0 1.25.56 1.25 1.25v33.5a1.25 1.25 0 1 1-2.5 0V7.25C6 6.56 6.56 6 7.25 6M42 9.26a3.25 3.25 0 0 0-5.09-2.68l-21.5 14.74a3.25 3.25 0 0 0 0 5.36l21.5 14.74A3.25 3.25 0 0 0 42 38.74z"
]);
const $db6ad3fef28672ff$export$6b88b7b479177ad4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Previous48Regular', "48", [
    "M8.5 7.25a1.25 1.25 0 1 0-2.5 0v33.5a1.25 1.25 0 1 0 2.5 0zm33.5 2a3.25 3.25 0 0 0-5.09-2.67l-21.5 14.74a3.25 3.25 0 0 0 0 5.36l21.5 14.74A3.25 3.25 0 0 0 42 38.74zm-3.67-.61a.75.75 0 0 1 1.17.62v29.48c0 .6-.68.96-1.17.62l-21.5-14.74a.75.75 0 0 1 0-1.24z"
]);
const $db6ad3fef28672ff$export$76927d6f77bc54fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviousFrame20Filled', "20", [
    "M15.5 3a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5m-5.45.21c.83-.55 1.95.04 1.95 1.04v11.5c0 1-1.12 1.6-1.95 1.04l-8.5-5.8a1.25 1.25 0 0 1 0-2.07z"
]);
const $db6ad3fef28672ff$export$92d371744225d2d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviousFrame20Regular', "20", [
    "M15.5 3a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5m-5.45.21c.83-.55 1.95.04 1.95 1.04v11.5c0 1-1.12 1.6-1.95 1.04l-8.5-5.8a1.25 1.25 0 0 1 0-2.07zM11 4.25c0-.2-.22-.32-.39-.2l-8.5 5.7a.25.25 0 0 0 0 .42l8.5 5.79c.17.11.39 0 .39-.2z"
]);
const $db6ad3fef28672ff$export$d7fd4e9e997f3960 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviousFrame24Filled', "24", [
    "M18.5 3.75a.75.75 0 0 1 1.5 0v16.5a.75.75 0 0 1-1.5 0zm-6.24-.44c1.16-.8 2.74.04 2.74 1.44v14.5a1.75 1.75 0 0 1-2.75 1.43l-10.5-7.3c-1-.7-1-2.19.01-2.88z"
]);
const $db6ad3fef28672ff$export$6b31a98c591f54a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PreviousFrame24Regular', "24", [
    "M18.5 3.75a.75.75 0 0 1 1.5 0v16.5a.75.75 0 0 1-1.5 0zm-6.24-.44c1.16-.8 2.74.04 2.74 1.44v14.5a1.75 1.75 0 0 1-2.75 1.43l-10.5-7.3c-1-.7-1-2.19.01-2.88zm1.24 1.44c0-.2-.22-.32-.4-.2L2.62 11.74a.25.25 0 0 0 0 .41l10.5 7.3c.16.12.39 0 .39-.2z"
]);
const $db6ad3fef28672ff$export$f5126a908ebaae80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatingMature16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zm3.92.74A.5.5 0 0 0 5 5.5v5a.5.5 0 1 0 1 0V7.24l1.58 2.53a.5.5 0 0 0 .84 0L10 7.24v3.26a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.92-.26L8 8.56z"
]);
const $db6ad3fef28672ff$export$36e656cda87cb536 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatingMature16Regular', "16", [
    "M5.92 5.24A.5.5 0 0 0 5 5.5v5a.5.5 0 1 0 1 0V7.24l1.58 2.53a.5.5 0 0 0 .84 0L10 7.24v3.26a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.92-.26L8 8.56zM4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5z"
]);
const $db6ad3fef28672ff$export$f2591bf47da5f16e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatingMature20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm4.92 1.24A.5.5 0 0 0 7 7.5v5a.5.5 0 1 0 1 0V9.24l1.58 2.53a.5.5 0 0 0 .84 0L12 9.24v3.26a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.92-.26L10 10.56z"
]);
const $db6ad3fef28672ff$export$41c23feb0619f5b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatingMature20Regular', "20", [
    "M7.92 7.24A.5.5 0 0 0 7 7.5v5a.5.5 0 1 0 1 0V9.24l1.58 2.53a.5.5 0 0 0 .84 0L12 9.24v3.26a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.92-.26L10 10.56zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);
const $db6ad3fef28672ff$export$b02345817eeaa8a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatingMature24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zm5.83 2.02a.75.75 0 0 0-1.33.48v6.5a.75.75 0 1 0 1.5 0v-4.43l2.42 2.91a.75.75 0 0 0 1.16 0l2.42-2.9v4.42a.75.75 0 1 0 1.5 0v-6.5a.75.75 0 0 0-1.33-.48L12 12.07z"
]);
const $db6ad3fef28672ff$export$13fd00a6b3114f01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatingMature24Regular', "24", [
    "M8.83 8.27a.75.75 0 0 0-1.33.48v6.5a.75.75 0 1 0 1.5 0v-4.43l2.42 2.91a.75.75 0 0 0 1.16 0l2.42-2.9v4.42a.75.75 0 1 0 1.5 0v-6.5a.75.75 0 0 0-1.33-.48L12 12.07zM6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $db6ad3fef28672ff$export$cdf106fb87ccedc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatioOneToOne20Filled', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM7 7.5v5a.5.5 0 0 1-1 0V8.3l-.28.15a.5.5 0 1 1-.44-.9l1-.5A.5.5 0 0 1 7 7.5m7 0v5a.5.5 0 1 1-1 0V8.3l-.28.15a.5.5 0 1 1-.44-.9l1-.5a.5.5 0 0 1 .72.45m-4 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9.5 12a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $db6ad3fef28672ff$export$c7c4440d297324d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatioOneToOne20Regular', "20", [
    "M6.76 7.07q.23.16.24.43v5a.5.5 0 0 1-1 0V8.3l-.28.15a.5.5 0 1 1-.44-.9l1-.5a.5.5 0 0 1 .48.02M14 7.5a.5.5 0 0 0-.72-.45l-1 .5a.5.5 0 1 0 .44.9L13 8.3v4.19a.5.5 0 0 0 1 0zm-4 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9.5 12a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5z"
]);
const $db6ad3fef28672ff$export$5eb92773d2f057a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatioOneToOne24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM8.5 8.75v6.5a.75.75 0 0 1-1.5 0v-5.1l-.33.22a.75.75 0 1 1-.84-1.24l1.5-1a.75.75 0 0 1 1.17.62m9 0v6.5a.75.75 0 1 1-1.5 0v-5.1l-.33.22a.75.75 0 1 1-.84-1.24l1.5-1a.75.75 0 0 1 1.17.62M13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$b3d0e250bd748d6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RatioOneToOne24Regular', "24", [
    "M8.5 8.75a.75.75 0 0 0-1.17-.62l-1.5 1a.75.75 0 1 0 .84 1.24l.33-.22v5.1a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.17-.62l-1.5 1a.75.75 0 1 0 .84 1.24l.33-.22v5.1a.75.75 0 1 0 1.5 0zM13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $db6ad3fef28672ff$export$4653a26c519adb4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text12Filled', "12", [
    "M2 2.75c0-.41.34-.75.75-.75h6c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V3.5H6.5v5h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5H5v-5H3.5v.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$72f97854abdaaa26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text12Regular', "12", [
    "M2 2.5c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5V4a.5.5 0 0 1-1 0V3H6v6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H5V3H3v1a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$db47a853309e7d37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text16Filled', "16", [
    "M2.5 2.75c0-.41.34-.75.75-.75h9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V3.5h-3v9h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H7v-9H4v.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$7824efa9c0e59462 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text16Regular', "16", [
    "M3 2.5c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V3H8v10h1a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1h1V3H4v1.5a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$5d81a438b41b7c75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text32Filled', "32", [
    "M6 5.25C6 4.56 6.56 4 7.25 4h17.5c.69 0 1.25.56 1.25 1.25v3.5a1.25 1.25 0 1 1-2.5 0V6.5h-6.25v19h1.5a1.25 1.25 0 1 1 0 2.5h-5.5a1.25 1.25 0 1 1 0-2.5h1.5v-19H8.5v2.25a1.25 1.25 0 1 1-2.5 0z"
]);
const $db6ad3fef28672ff$export$2cc5afe9751c8356 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text32Light', "32", [
    "M6 4.5c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V5h-8.5v22h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3V5H7v3.5a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$96fb16f6a92a28df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Text32Regular', "32", [
    "M6 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6h-7v20h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2V6H8v3a1 1 0 0 1-2 0z"
]);
const $db6ad3fef28672ff$export$7d581b21548f0f2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAbcUnderlineDouble32Filled', "32", [
    "M8.66 5.78a1.25 1.25 0 0 0-2.32 0l-3.25 8a1.25 1.25 0 0 0 2.32.94l.5-1.22H9.1l.5 1.22a1.25 1.25 0 0 0 2.3-.94zM7.5 9.58 8.08 11H6.92zM2.75 20.24c0-.69.56-1.25 1.25-1.25h24a1.25 1.25 0 1 1 0 2.5H4c-.69 0-1.25-.56-1.25-1.25m0 6c0-.69.56-1.25 1.25-1.25h24a1.25 1.25 0 1 1 0 2.5H4c-.69 0-1.25-.56-1.25-1.25M14.25 5C13.56 5 13 5.56 13 6.25v8c0 .69.56 1.25 1.25 1.25H17a3.25 3.25 0 0 0 2.28-5.57q.46-.74.47-1.68c0-1.8-1.46-3.25-3.25-3.25zm1.25 8v-1.5H17a.75.75 0 0 1 0 1.5zm1-4h-1V7.5h1a.75.75 0 0 1 0 1.5m7 1.25c0-1.13.29-1.82.6-2.2q.46-.55 1.2-.55c.56 0 1.02.24 1.35.85a1.25 1.25 0 1 0 2.2-1.2A3.9 3.9 0 0 0 25.3 5c-1.2 0-2.32.48-3.12 1.45a6 6 0 0 0-1.18 3.8c0 1.54.4 2.85 1.18 3.8.8.97 1.93 1.45 3.12 1.45 1.5 0 2.8-.76 3.55-2.16a1.25 1.25 0 0 0-2.2-1.2c-.33.62-.79.86-1.35.86q-.74 0-1.2-.55c-.31-.38-.6-1.07-.6-2.2"
]);
const $db6ad3fef28672ff$export$b37214607d3419c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAbcUnderlineDouble32Regular', "32", [
    "M7.5 5a1 1 0 0 1 .92.6l3.5 8a1 1 0 1 1-1.84.8l-.6-1.4H5.52l-.61 1.4a1 1 0 0 1-1.84-.8l3.5-8A1 1 0 0 1 7.5 5m1.1 6L7.5 8.5 6.4 11zM4 19a1 1 0 1 0 0 2h24a1 1 0 0 0 0-2zm0 6a1 1 0 1 0 0 2h24a1 1 0 0 0 0-2zm9-19a1 1 0 0 1 1-1h2.5a3 3 0 0 1 2.46 4.72A3 3 0 0 1 17 15h-3a1 1 0 0 1-1-1zm2 5v2h2a1 1 0 0 0 0-2zm0-2h1.5a1 1 0 0 0 0-2H15zm8 1c0-1.18.3-1.93.65-2.37Q24.17 7 24.98 7c.66 0 1.23.32 1.6 1.18a1 1 0 1 0 1.84-.8A3.7 3.7 0 0 0 24.98 5c-1.11 0-2.15.46-2.88 1.37-.73.9-1.1 2.14-1.1 3.63 0 1.5.37 2.74 1.1 3.63A3.6 3.6 0 0 0 24.98 15c1.53 0 2.78-.87 3.44-2.38a1 1 0 1 0-1.84-.8c-.37.86-.94 1.18-1.6 1.18q-.8 0-1.33-.63c-.36-.44-.65-1.2-.65-2.37"
]);
const $db6ad3fef28672ff$export$dbe04445ae9957f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAdd20Filled', "20", [
    "M3 3.75c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V4.5H9.5v7.7a5.5 5.5 0 0 0 .1 4.8H6.75a.75.75 0 0 1 0-1.5H8v-11H4.5v.75a.75.75 0 0 1-1.5 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $db6ad3fef28672ff$export$b689621fbd0e135a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAdd20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V4H9v12h.2q.16.52.4 1H6.5a.5.5 0 0 1 0-1H8V4H4v1.5a.5.5 0 0 1-1 0zm16 11a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $db6ad3fef28672ff$export$52c88b86649d69d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceAfter20Filled', "20", [
    "M3 5.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.75m0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9.75m9.03 6.03c.3-.3.3-.77 0-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 1 0 1.06 1.06l.97-.97.97.97c.3.3.77.3 1.06 0"
]);
const $db6ad3fef28672ff$export$7e3399a1976a07d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceAfter20Regular', "20", [
    "M3 5.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m5.15 5.15a.5.5 0 0 0 .7.7L10 14.21l1.15 1.14a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0z"
]);
const $db6ad3fef28672ff$export$b7ce8bfd4df1213d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceAfter24Filled', "24", [
    "M3 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m6.3 5.3a1 1 0 1 0 1.4 1.4l1.3-1.29 1.3 1.3a1 1 0 0 0 1.4-1.42l-2-2a1 1 0 0 0-1.4 0z"
]);
const $db6ad3fef28672ff$export$aa192f7357339b54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceAfter24Regular', "24", [
    "M3 6.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75m0 6c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75m6.47 5.47a.75.75 0 1 0 1.06 1.06L12 17.81l1.47 1.47a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0z"
]);
const $db6ad3fef28672ff$export$d3518e47dd4d2e73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceBefore20Filled', "20", [
    "M12.03 5.78a.75.75 0 0 0-1.06-1.06l-.97.97-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0zM3 10.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75m0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$b7d6b57842ead3ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceBefore20Regular', "20", [
    "M8.15 5.85a.5.5 0 1 1 .7-.7L10 6.29l1.15-1.14a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0zM3 10.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$6c24e0bf3d0f4a86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceBefore24Filled', "24", [
    "M9.3 6.2a1 1 0 0 1 1.4-1.4L12 6.08l1.3-1.3a1 1 0 1 1 1.4 1.42l-2 2a1 1 0 0 1-1.4 0zM3 12a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$703195e067fae553 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddSpaceBefore24Regular', "24", [
    "M9.47 6.28a.75.75 0 0 1 1.06-1.06L12 6.69l1.47-1.47a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0zM3 11.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75m0 6c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$635fb62e32edd929 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT20Filled', "20", [
    "M3 3.75c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V4.5H9.5v7.7a5.5 5.5 0 0 0 .1 4.8H6.75a.75.75 0 0 1 0-1.5H8v-11H4.5v.75a.75.75 0 0 1-1.5 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $db6ad3fef28672ff$export$7f5e5e8b6538c7ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V4H9v12h.2q.16.52.4 1H6.5a.5.5 0 0 1 0-1H8V4H4v1.5a.5.5 0 0 1-1 0zm16 11a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $db6ad3fef28672ff$export$11833e300eee9880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT24Filled', "24", [
    "M3.75 5a1 1 0 0 1 1-1h12.5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V6H12v8.03a6.5 6.5 0 0 0-.5 5.97H9a1 1 0 1 1 0-2h1V6H5.75v1a1 1 0 0 1-2 0zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $db6ad3fef28672ff$export$ea08609c16abb264 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT24Regular', "24", [
    "M4 4.75c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0V5.5h-4.75v8.97A6.5 6.5 0 0 0 11.5 20H8.75a.75.75 0 0 1 0-1.5h1.5v-13H5.5v1.25a.75.75 0 0 1-1.5 0zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $db6ad3fef28672ff$export$59eaaadab9a504e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT28Filled', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m0 2a.5.5 0 0 0-.5.5V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5a.5.5 0 0 0-.5-.5M21 4a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V6h-6v10.76a7.5 7.5 0 0 0-.13 7.24H11a1 1 0 1 1 0-2h1V6H6v2a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1z"
]);
const $db6ad3fef28672ff$export$75b138dc9943da52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT28Regular', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m0 2a.5.5 0 0 0-.5.5V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5a.5.5 0 0 0-.5-.5m.75-12c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0V5.5h-6.75v11.73a7.5 7.5 0 0 0 .12 6.77h-3.12a.75.75 0 0 1 0-1.5h1.5v-17H5.5v2.75a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75z"
]);
const $db6ad3fef28672ff$export$f964c9136a9db2dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT32Filled', "32", [
    "M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M22.75 4c.69 0 1.25.56 1.25 1.25v3.5a1.25 1.25 0 1 1-2.5 0V6.5h-6.25v11.92a9 9 0 0 0 .27 9.58h-4.27a1.25 1.25 0 1 1 0-2.5h1.5v-19H6.5v2.25a1.25 1.25 0 1 1-2.5 0v-3.5C4 4.56 4.56 4 5.25 4zm.5 13.5a.75.75 0 0 0-.75.75V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24v-3.75a.75.75 0 0 0-.75-.75"
]);
const $db6ad3fef28672ff$export$a9cb51c31107466d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT32Light', "32", [
    "M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M23.5 4c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V5h-8.5v15.04a9 9 0 0 0 0 5.92V27h.44q.25.52.58 1H10.5a.5.5 0 0 1 0-1h3V5H5v3.5a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5zm-.25 13.5a.75.75 0 0 0-.75.75V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24v-3.75a.75.75 0 0 0-.75-.75"
]);
const $db6ad3fef28672ff$export$b044cef324fb22c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAddT32Regular', "32", [
    "M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M23 4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6h-7v12.88a9 9 0 0 0 .52 9.12H11a1 1 0 1 1 0-2h2V6H6v3a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1zm.25 13.5a.75.75 0 0 0-.75.75V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24v-3.75a.75.75 0 0 0-.75-.75"
]);
const $db6ad3fef28672ff$export$3b69a74b37dbea6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenter16Filled', "16", [
    "M3 3.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 3.75m-2 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75m4 4c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$1fda56bcd61061ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenter16Regular', "16", [
    "M3 3.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m-2 4c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m4 4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$fe933079cc8db2e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenter20Filled', "20", [
    "M4 4.25c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 4.25m-2 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.25m4.75 4.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$bbca7ccb12e081fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenter20Regular', "20", [
    "M4 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m-2 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M6.5 14a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$9861b5e44eb76a6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenter24Filled', "24", [
    "M4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m2 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m-3-7a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$1ecb8263058a9391 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenter24Regular', "24", [
    "M4 5.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 5.75m2 13c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75M2.75 11.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$474c6a010e85f5b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate27016Filled', "16", [
    "M3.75 13a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 1.5 0v8.5c0 .41-.34.75-.75.75m4 2a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0v12.5c0 .41-.34.75-.75.75m4-4a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v4.5c0 .41-.34.75-.75.75"
]);
const $db6ad3fef28672ff$export$716b7ded82ad41e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate27016Regular', "16", [
    "M3.5 13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 1 0v9a.5.5 0 0 1-.5.5m4 2a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5m4-4a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5"
]);
const $db6ad3fef28672ff$export$3bcd19a8c3b842b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate27020Filled', "20", [
    "M4.25 16a.75.75 0 0 1-.75-.75V4.75a.75.75 0 0 1 1.5 0v10.5c0 .41-.34.75-.75.75m5 2a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m4.25-4.75a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$863e80e593a37490 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate27020Regular', "20", [
    "M4.5 16a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m5 2a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5m4.5-4.5a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0z"
]);
const $db6ad3fef28672ff$export$c8f5be635b1b6e96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate27024Filled', "24", [
    "M6 20a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v14a1 1 0 0 1-1 1m12-2a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1m-7 3a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0z"
]);
const $db6ad3fef28672ff$export$b4f7ec858bd87efc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate27024Regular', "24", [
    "M5.75 20a.75.75 0 0 1-.75-.75V4.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m13-2a.75.75 0 0 1-.75-.75V6.75a.75.75 0 0 1 1.5 0v10.5c0 .41-.34.75-.75.75m-7.25 3.25a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$d1306c118cd667a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate9016Filled', "16", [
    "M12.25 3c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m-4-2c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V1.75c0-.41.34-.75.75-.75m-4 4c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$ecc795d157e79f65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate9016Regular', "16", [
    "M12.5 3c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5m-4-2c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5m-4 4c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$3d0b4b6e4ed986c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate9020Filled', "20", [
    "M15.75 4c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75m-5-2c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M6.5 6.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$287b18d6840666be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate9020Regular', "20", [
    "M15.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5m-5-2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M6 6.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$b9ed7a4607be5fb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate9024Filled', "24", [
    "M18 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1M6 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m7-3a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$ae5fe3f1526ac3a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignCenterRotate9024Regular', "24", [
    "M18.25 4c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75m-13 2c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V6.75c0-.41.34-.75.75-.75m7.25-3.25a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$238397919b426362 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributed20Filled', "20", [
    "M4.78 6.28c.3-.3.3-.77 0-1.06L4.56 5h12.69a.75.75 0 0 0 0-1.5H4.56l.22-.22a.75.75 0 0 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06l1.5 1.5c.3.3.77.3 1.06 0M18 9.25c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1 0-1.5h14.5c.41 0 .75.34.75.75M2.75 13.5h12.69l-.22-.22a.75.75 0 1 1 1.06-1.06l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.22-.22H2.75a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$2d0202398d301afc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributed20Regular', "20", [
    "M4.35 5.65 3.71 5H17.5a.5.5 0 0 0 0-1H3.7l.65-.65a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7M2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 4.5h13.8l-.65-.65a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H2.5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$1ec0e269d4cd7b3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributed24Filled', "24", [
    "M4.3 3.3a1 1 0 0 1 1.4 1.4l-.29.3H21a1 1 0 1 1 0 2H5.41l.3.3a1 1 0 0 1-1.42 1.4l-2-2a1 1 0 0 1 0-1.4zM18.58 19l-.3.3a1 1 0 0 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4l-2-2a1 1 0 0 0-1.42 1.4l.3.3H3a1 1 0 1 0 0 2zM3 11a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$f7da09df80cb687f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributed24Regular', "24", [
    "m5.28 7.22-.72-.72h16.69a.75.75 0 0 0 0-1.5H4.56l.72-.72a.75.75 0 0 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 0 0 1.06-1.06M2.75 11.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zm0 8h16.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72H2.75a.75.75 0 0 0 0 1.5"
]);
const $db6ad3fef28672ff$export$c047012ab97e80a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedEvenly20Filled', "20", [
    "M2 3.5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.5m0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8.5m2.56 6.75h10.88l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72H4.56l.72-.72a.75.75 0 1 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 0 0 1.06-1.06z"
]);
const $db6ad3fef28672ff$export$e59caae87e882626 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedEvenly20Regular', "20", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M3.7 15h12.6l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.29 14H3.71l1.14-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7z"
]);
const $db6ad3fef28672ff$export$c094faa8c9e862d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedEvenly24Filled', "24", [
    "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m3.7 9.3a1 1 0 0 0-1.4 0l-2 2a1 1 0 0 0 0 1.4l2 2a1 1 0 0 0 1.4-1.4l-.29-.3H18.6l-.3.3a1 1 0 0 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4l-2-2a1 1 0 0 0-1.42 1.4l.3.3H5.4l.3-.3a1 1 0 0 0 0-1.4M3 11a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$26053d7174e6de65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedEvenly24Regular', "24", [
    "M2 5.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m3.28 14.47-.72-.72h14.88l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72H4.56l.72-.72a.75.75 0 1 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 0 0 1.06-1.06M2.75 11.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$b636bec2866f350a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedVertical20Filled', "20", [
    "M3.03 14.72a.75.75 0 0 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72V2.75a.75.75 0 0 0-1.5 0v12.69zM10 18a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m8.03-12.72c-.3.3-.77.3-1.06 0l-.72-.72v12.69a.75.75 0 0 1-1.5 0V4.56l-.72.72a.75.75 0 1 1-1.06-1.06l2-2c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06"
]);
const $db6ad3fef28672ff$export$f23d0514ba4d21a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedVertical20Regular', "20", [
    "M17.85 4.85a.5.5 0 0 1-.7 0L16 3.71V17.5a.5.5 0 1 1-1 0V3.7l-1.15 1.15a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7m-15 10.3a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 1 0-.7-.7L5 16.29V2.5a.5.5 0 0 0-1 0v13.8zM10 18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5"
]);
const $db6ad3fef28672ff$export$133734477473b7b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedVertical24Filled', "24", [
    "M19 5.41V21a1 1 0 1 1-2 0V5.41l-.3.3a1 1 0 1 1-1.4-1.42l2-2a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1-1.4 1.42zM5 18.6l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 1 0-1.4-1.42l-.3.3V3a1 1 0 1 0-2 0zM13 3a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$81567da83e829418 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignDistributedVertical24Regular', "24", [
    "m16.78 5.28.72-.72v16.69a.75.75 0 0 0 1.5 0V4.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06M6 19.44l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V2.75a.75.75 0 0 1 1.5 0zm6.5-16.69a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$a2a127d8c62bd847 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustify20Filled', "20", [
    "M2 4.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25m0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.25m.75 4.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$dc6f7622292f5ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustify20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$fc4ad95ef1e4e4e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustify24Filled', "24", [
    "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1-7a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$a1aa91861054c15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustify24Regular', "24", [
    "M2 5.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 13c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-7.25a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$44ce2cd77c5b53a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow20Filled', "20", [
    "M9 4.5c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 9 4.5m0 5c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 9 9.5m-6.25 4.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$24f6328118fcf2ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow20Regular', "20", [
    "M9 4.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5M2.5 14a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$f702f6ab62c666f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow24Filled', "24", [
    "M13 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1M2 18a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m12-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$bbcc7c0f9390cbdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow24Regular', "24", [
    "M13 5.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m-11 13c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m11.75-7.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$ca907a300ddb9d3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow9020Filled', "20", [
    "M15.5 9c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m-5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75M6.25 2.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$2d3879d2e52eea37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow9020Regular', "20", [
    "M15.5 9c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5m-5 0c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5M6 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$989d55cf7c07ac1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow9024Filled', "24", [
    "M18 13a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1M6 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m7 12a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$2d4926ff40d30803 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLow9024Regular', "24", [
    "M18.25 13c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m-13-11c.41 0 .75.34.75.75v18.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m7.25 11.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$3c364b69c90f379e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate27020Filled', "20", [
    "M4.5 11a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m4.25 6.25a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$e47ada3ea50a710e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate27020Regular', "20", [
    "M4.5 11a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m4.5 6.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z"
]);
const $db6ad3fef28672ff$export$f88acdd0f30b9a99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate27024Filled', "24", [
    "M6 11a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v7a1 1 0 0 1-1 1m12 11a1 1 0 0 1-1-1V3a1 1 0 1 1 2 0v18a1 1 0 0 1-1 1m-7-12a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0z"
]);
const $db6ad3fef28672ff$export$90bbbbeb7b34a34e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate27024Regular', "24", [
    "M5.75 11a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m13 11a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v18.5c0 .41-.34.75-.75.75M11.5 10.25a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$bdf3b8e27f061722 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate9020Filled', "20", [
    "M15.5 9c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m-5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75M6.25 2.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$1692a6de0525098c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate9020Regular', "20", [
    "M15.5 9c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5m-5 0c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5M6 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$463df38f1dd9b01b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate9024Filled', "24", [
    "M18 13a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1M6 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m7 12a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$1a2000fd4665a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyLowRotate9024Regular', "24", [
    "M18.25 13c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m-13-11c.41 0 .75.34.75.75v18.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m7.25 11.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$8fd6edb34408297b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate27020Filled', "20", [
    "M4.25 18a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m4.25-.75a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$6c7eeb9e465c3037 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate27020Regular', "20", [
    "M4.5 18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5m4.5-.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z"
]);
const $db6ad3fef28672ff$export$cd9516cff48c7a81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate27024Filled', "24", [
    "M6 22a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v18a1 1 0 0 1-1 1m12 0a1 1 0 0 1-1-1V3a1 1 0 1 1 2 0v18a1 1 0 0 1-1 1m-7-1a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0z"
]);
const $db6ad3fef28672ff$export$2563086f872d771 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate27024Regular', "24", [
    "M5.75 22a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v18.5c0 .41-.34.75-.75.75m13 0a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v18.5c0 .41-.34.75-.75.75m-7.25-.75a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$5977fa8cd26b274e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate9020Filled', "20", [
    "M15.75 2c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m-5 0c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m-4.25.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$cb1d19acd1ecfa5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate9020Regular', "20", [
    "M15.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5m-5 0c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M6 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$5f2540c5d3e8d8b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate9024Filled', "24", [
    "M18 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M6 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$32fb4e057992690d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignJustifyRotate9024Regular', "24", [
    "M18.25 2c.41 0 .75.34.75.75v18.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m-13 0c.41 0 .75.34.75.75v18.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m7.25.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$ee1524db5eefeaf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeft16Filled', "16", [
    "M1 3.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 1 3.75m0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75m0 4c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$eb10e6a57ac018da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeft16Regular', "16", [
    "M1 3.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$fba7a5199a3d9b35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeft20Filled', "20", [
    "M2 4.25c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25m0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.25m.75 4.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$c8cf64ba0e6f5353 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeft20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$5f0072e389172fce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeft24Filled', "24", [
    "M2 6a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1-7a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$e65bb4628ee19dc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeft24Regular', "24", [
    "M2 5.75c0-.41.34-.75.75-.75h15.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 13c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-7.25a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$12eb7327e05f8834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate27016Filled', "16", [
    "M3.75 15a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 1.5 0v8.5c0 .41-.34.75-.75.75m4 0a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0v12.5c0 .41-.34.75-.75.75m4 0a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v4.5c0 .41-.34.75-.75.75"
]);
const $db6ad3fef28672ff$export$ba32d29999b42816 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate27016Regular', "16", [
    "M3.5 15a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 1 0v9a.5.5 0 0 1-.5.5m4 0a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5m4 0a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5"
]);
const $db6ad3fef28672ff$export$1c66204421587182 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate27020Filled', "20", [
    "M4.25 18a.75.75 0 0 1-.75-.75V6.75a.75.75 0 0 1 1.5 0v10.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m4.25-.75a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$e6f66abcd343a39d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate27020Regular', "20", [
    "M4.5 18a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5m4.5-.5a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-1 0z"
]);
const $db6ad3fef28672ff$export$f50c15609030e3c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate27024Filled', "24", [
    "M6 22a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v15a1 1 0 0 1-1 1m12 0a1 1 0 0 1-1-1V10a1 1 0 1 1 2 0v11a1 1 0 0 1-1 1m-7-1a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0z"
]);
const $db6ad3fef28672ff$export$8e27597b2d23befd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate27024Regular', "24", [
    "M5.75 22a.75.75 0 0 1-.75-.75V5.75a.75.75 0 0 1 1.5 0v15.5c0 .41-.34.75-.75.75m13 0a.75.75 0 0 1-.75-.75v-10.5a.75.75 0 0 1 1.5 0v10.5c0 .41-.34.75-.75.75m-7.25-.75a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$d68e813d6d161d02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate9016Filled', "16", [
    "M12.25 1c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m-4 0c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V1.75c0-.41.34-.75.75-.75m-4 0c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$8e604368cc482378 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate9016Regular', "16", [
    "M12.5 1c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5m-4 0c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5m-4 0c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$978497e469cac13f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate9020Filled', "20", [
    "M15.75 2c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m-5 0c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m-4.25.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$3b9045d6416825 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate9020Regular', "20", [
    "M15.5 2c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5m-5 0c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M6 2.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$c4a36c332b45609a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate9024Filled', "24", [
    "M18 2a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M6 2a1 1 0 0 1 1 1v11a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$6cd297ff288c3127 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignLeftRotate9024Regular', "24", [
    "M18.25 2c.41 0 .75.34.75.75v15.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m-13 0c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m7.25.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$b319aad42c161b9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRight16Filled', "16", [
    "M5 3.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 3.75m-4 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 7.75m8 4c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$fcd30c52ad57fd34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRight16Regular', "16", [
    "M5 3.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m-4 4c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m8 4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$dff46f202e47355a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRight20Filled', "20", [
    "M6 4.25c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 4.25m-4 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.25m7.75 4.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$b828a73d3ff8e523 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRight20Regular', "20", [
    "M6 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m-4 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M9.5 14a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$50372885bd8b5da5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRight24Filled', "24", [
    "M5 6a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m4 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m-6-7a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$b85b49ac6e244916 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRight24Regular', "24", [
    "M5 5.75c0-.41.34-.75.75-.75h15.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 5.75m5 13c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5h-10.5a.75.75 0 0 1-.75-.75M2.75 11.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$b3cb149a353e891b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate27016Filled', "16", [
    "M3.75 11a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 1.5 0v8.5c0 .41-.34.75-.75.75m4 4a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0v12.5c0 .41-.34.75-.75.75m4-8a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v4.5c0 .41-.34.75-.75.75"
]);
const $db6ad3fef28672ff$export$266cb9fe5b64fd01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate27016Regular', "16", [
    "M3.5 11a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 1 0v9a.5.5 0 0 1-.5.5m4 4a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5m4-8a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5"
]);
const $db6ad3fef28672ff$export$6e6f5dd76da3c895 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate27020Filled', "20", [
    "M4.25 14a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v10.5c0 .41-.34.75-.75.75m5 4a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v14.5c0 .41-.34.75-.75.75m4.25-7.75a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$5bf78c0f05fff8fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate27020Regular', "20", [
    "M4.5 14a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m5 4a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5m4.5-7.5a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-1 0z"
]);
const $db6ad3fef28672ff$export$6d6566276981373e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate27024Filled', "24", [
    "M6 19a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v15a1 1 0 0 1-1 1m12-4a1 1 0 0 1-1-1V3a1 1 0 1 1 2 0v11a1 1 0 0 1-1 1m-7 6a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0z"
]);
const $db6ad3fef28672ff$export$a8416b09b5803db0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate27024Regular', "24", [
    "M5.75 19a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v15.5c0 .41-.34.75-.75.75m13-5a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.5 0v10.5c0 .41-.34.75-.75.75m-7.25 7.25a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$d3e27cab7266fbdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate9016Filled', "16", [
    "M12.25 5c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m-4-4c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V1.75c0-.41.34-.75.75-.75m-4 8c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$b926709f1ff35705 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate9016Regular', "16", [
    "M12.5 5c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5m-4-4c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5m-4 8c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$94da3f95d1dde82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate9020Filled', "20", [
    "M15.75 6c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V6.75c0-.41.34-.75.75-.75m-5-4c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M6.5 9.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$af704355a5e89685 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate9020Regular', "20", [
    "M15.5 6c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5m-5-4c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M6 9.5a.5.5 0 0 0-1 0v8a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$3b2019c376783af2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate9024Filled', "24", [
    "M18 5a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1M6 9a1 1 0 0 1 1 1v11a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1m7-6a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$af6b696e5e73e17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAlignRightRotate9024Regular', "24", [
    "M18.25 5c.41 0 .75.34.75.75v15.5a.75.75 0 0 1-1.5 0V5.75c0-.41.34-.75.75-.75m-13 5c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0v-10.5c0-.41.34-.75.75-.75m7.25-7.25a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$f22ab100fd85b484 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn16Filled', "16", [
    "M1 5.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m0-3c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5m8 3.25C9 4.78 9.78 4 10.75 4h1.5c.97 0 1.75.78 1.75 1.75V7H9zM9 8v3h5V8zm5 4H9v1.25c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75zM3 8.5a.5.5 0 0 0-1 0V10c0 1.1.9 2 2 2h1.3l-.65.65a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7l.64.65H4a1 1 0 0 1-1-1z"
]);
const $db6ad3fef28672ff$export$aec8df78db0ff1e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn16Regular', "16", [
    "M1 5.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m0-3c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5M10.75 4C9.78 4 9 4.78 9 5.75v7.5c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-7.5C14 4.78 13.22 4 12.25 4zM13 7h-3V5.75c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75zm-3 1h3v3h-3zm0 4h3v1.25c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1-.75-.75zM3 8.5a.5.5 0 0 0-1 0V10c0 1.1.9 2 2 2h1.3l-.65.65a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7l.64.65H4a1 1 0 0 1-1-1z"
]);
const $db6ad3fef28672ff$export$4b48ca406a63b512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn20Filled', "20", [
    "M2 6.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5m0-3c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M11 7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2h-6zm6 3h-6v3h6zm0 4h-6v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2zM4 9.5a.5.5 0 0 0-1 0v2A2.5 2.5 0 0 0 5.5 14h1.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L7.29 13H5.5A1.5 1.5 0 0 1 4 11.5z"
]);
const $db6ad3fef28672ff$export$cef237f61078d2e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn20Regular', "20", [
    "M2 6.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5m0-3c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M13 5a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm3 4h-4V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm-4 1h4v3h-4zm0 4h4v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM4 9.5a.5.5 0 0 0-1 0v2A2.5 2.5 0 0 0 5.5 14h1.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L7.29 13H5.5A1.5 1.5 0 0 1 4 11.5z"
]);
const $db6ad3fef28672ff$export$3def461231ee297b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn24Filled', "24", [
    "M2.75 2a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM13 6.25C13 5.01 14 4 15.25 4h3.5C19.99 4 21 5 21 6.25V9.5h-8zM13 11v4h8v-4zm8 5.5h-8v3.25c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25zM3.75 10c.41 0 .75.34.75.75v3c0 .69.56 1.25 1.25 1.25h2.69l-1.22-1.22a.75.75 0 1 1 1.06-1.06l2.5 2.5c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22H5.75A2.75 2.75 0 0 1 3 13.75v-3c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$c8050f53f84e7ecf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn24Regular', "24", [
    "M2 2.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 2 2.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 2 6.75M15.25 4C14.01 4 13 5 13 6.25v13.5c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25V6.25C21 5.01 20 4 18.75 4zm-.75 2.25c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75V9.5h-5zm0 4.75h5v4h-5zm5 5.5v3.25c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75V16.5zm-15-5.75a.75.75 0 0 0-1.5 0v3a2.75 2.75 0 0 0 2.75 2.75h2.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06L8.44 15H5.75c-.69 0-1.25-.56-1.25-1.25z"
]);
const $db6ad3fef28672ff$export$cd0fc7556e37009d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn28Filled', "28", [
    "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 4.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM16 7.75A2.75 2.75 0 0 1 18.75 5h3.5A2.75 2.75 0 0 1 25 7.75v3.75h-9zM16 13v5h9v-5zm9 6.5h-9v3.75A2.75 2.75 0 0 0 18.75 26h3.5A2.75 2.75 0 0 0 25 23.25zM3.75 12c.41 0 .75.34.75.75v3c0 1.24 1 2.25 2.25 2.25h3.69l-2.22-2.22a.75.75 0 1 1 1.06-1.06l3.5 3.5c.3.3.3.77 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06l2.22-2.22H6.75A3.75 3.75 0 0 1 3 15.75v-3c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$45db67fe6569b320 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn28Regular', "28", [
    "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 4.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm16-2.5A2.75 2.75 0 0 0 16 7.75v15.5A2.75 2.75 0 0 0 18.75 26h3.5A2.75 2.75 0 0 0 25 23.25V7.75A2.75 2.75 0 0 0 22.25 5zM17.5 7.75c0-.69.56-1.25 1.25-1.25h3.5c.69 0 1.25.56 1.25 1.25v3.75h-6zm0 5.25h6v5h-6zm6 6.5v3.75c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25V19.5zM3.75 12c.41 0 .75.34.75.75v3c0 1.24 1 2.25 2.25 2.25h3.69l-2.22-2.22a.75.75 0 1 1 1.06-1.06l3.5 3.5c.3.3.3.77 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06l2.22-2.22H6.75A3.75 3.75 0 0 1 3 15.75v-3c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$7e9892d744cb1c6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn32Filled', "32", [
    "M2 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m16-.75C18 6.45 19.46 5 21.25 5h4.5C27.55 5 29 6.46 29 8.25V13H18zM29 15H18v5h11zm0 7H18v4.75c0 1.8 1.46 3.25 3.25 3.25h4.5c1.8 0 3.25-1.46 3.25-3.25zM5 14a1 1 0 1 0-2 0v3.5A4.5 4.5 0 0 0 7.5 22h4.09l-2.3 2.3a1 1 0 1 0 1.42 1.4l4-4a1 1 0 0 0 0-1.4l-4-4a1 1 0 0 0-1.42 1.4l2.3 2.3H7.5A2.5 2.5 0 0 1 5 17.5z"
]);
const $db6ad3fef28672ff$export$117ca48f6cb288de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn32Regular', "32", [
    "M3 3a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zm0 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm18.25-3A3.25 3.25 0 0 0 18 8.25v18.5c0 1.8 1.46 3.25 3.25 3.25h4.5c1.8 0 3.25-1.46 3.25-3.25V8.25C29 6.45 27.54 5 25.75 5zM27 13h-7V8.25c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25zm-7 2h7v5h-7zm0 7h7v4.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25zM4 13a1 1 0 0 1 1 1v3.5A2.5 2.5 0 0 0 7.5 20h4.09l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3H7.5A4.5 4.5 0 0 1 3 17.5V14a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$ac3d310c16e4e9f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn48Filled', "48", [
    "M4 6.25C4 5.56 4.56 5 5.25 5h17.5a1.25 1.25 0 1 1 0 2.5H5.25C4.56 7.5 4 6.94 4 6.25m0 7.5c0-.69.56-1.25 1.25-1.25h12.5a1.25 1.25 0 1 1 0 2.5H5.25C4.56 15 4 14.44 4 13.75m23-1.5C27 9.9 28.9 8 31.25 8h6.5C40.1 8 42 9.9 42 12.25V19H27zm0 9.25v8h15v-8zM42 32H27v6.75C27 41.1 28.9 43 31.25 43h6.5C40.1 43 42 41.1 42 38.75zM8.5 21.25a1.25 1.25 0 1 0-2.5 0v4.5C6 29.2 8.8 32 12.25 32h5.48l-3.36 3.37a1.25 1.25 0 0 0 1.76 1.76l5.5-5.5c.5-.48.5-1.28 0-1.76l-5.5-5.5a1.25 1.25 0 0 0-1.76 1.76l3.36 3.37h-5.48a3.75 3.75 0 0 1-3.75-3.75z"
]);
const $db6ad3fef28672ff$export$9a35620be73986d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextArrowDownRightColumn48Regular', "48", [
    "M5.25 5a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zm0 7.5a1.25 1.25 0 1 0 0 2.5h12.5a1.25 1.25 0 1 0 0-2.5zm26-4.5A4.25 4.25 0 0 0 27 12.25v26.5C27 41.1 28.9 43 31.25 43h6.5C40.1 43 42 41.1 42 38.75v-26.5C42 9.9 40.1 8 37.75 8zm-1.75 4.25c0-.97.78-1.75 1.75-1.75h6.5c.97 0 1.75.78 1.75 1.75V19h-10zm0 9.25h10v8h-10zm0 10.5h10v6.75c0 .97-.78 1.75-1.75 1.75h-6.5c-.97 0-1.75-.78-1.75-1.75zm-21-10.75a1.25 1.25 0 1 0-2.5 0v4.5C6 29.2 8.8 32 12.25 32h5.48l-3.36 3.37a1.25 1.25 0 0 0 1.76 1.76l5.5-5.5c.5-.48.5-1.28 0-1.76l-5.5-5.5a1.25 1.25 0 0 0-1.76 1.76l3.36 3.37h-5.48a3.75 3.75 0 0 1-3.75-3.75z"
]);
const $db6ad3fef28672ff$export$42bf5ac2a425f737 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAsterisk16Filled', "16", [
    "M8 14.25a.75.75 0 0 1-.75-.75V9.81l-2.6 2.61a.75.75 0 0 1-1.07 0 .75.75 0 0 1 0-1.06l2.6-2.61H2.5a.75.75 0 0 1 0-1.5h3.69l-2.61-2.6a.75.75 0 0 1 .53-1.29q.31 0 .53.22l2.6 2.6V2.5a.75.75 0 0 1 1.5 0v3.69l2.62-2.61a.75.75 0 1 1 1.06 1.06L9.8 7.25h3.69a.75.75 0 0 1 0 1.5H9.8l2.6 2.6a.75.75 0 0 1-1.05 1.07l-2.61-2.6v3.68c0 .41-.34.75-.75.75"
]);
const $db6ad3fef28672ff$export$4c8b53d09bd8fd32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAsterisk16Regular', "16", [
    "M13.5 7.5H9.2l3.04-3.04a.5.5 0 0 0-.7-.7L8.5 6.79V2.5a.5.5 0 0 0-1 0v4.3L4.46 3.75a.5.5 0 0 0-.7.7L6.79 7.5H2.5a.5.5 0 0 0 0 1h4.3l-3.04 3.04a.5.5 0 0 0 .7.7L7.5 9.21v4.29a.5.5 0 0 0 1 0V9.2l3.04 3.04a.5.5 0 0 0 .7 0 .5.5 0 0 0 0-.7L9.22 8.5h4.3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$5ec70157fd497673 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAsterisk20Filled', "20", [
    "M10.6 2.5a.6.6 0 1 0-1.2 0v6.05L5.12 4.27a.6.6 0 1 0-.85.85L8.55 9.4H2.5a.6.6 0 1 0 0 1.2h6.05l-4.28 4.28a.6.6 0 0 0 .85.85l4.28-4.28v6.05a.6.6 0 1 0 1.2 0v-6.05l4.28 4.28a.6.6 0 0 0 .85-.85l-4.28-4.28h6.05a.6.6 0 1 0 0-1.2h-6.05l4.28-4.28a.6.6 0 0 0-.85-.85L10.6 8.55z"
]);
const $db6ad3fef28672ff$export$47f2e34fd2122b99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextAsterisk20Regular', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v6.3L5.05 4.33a.5.5 0 1 0-.7.71L8.78 9.5H2.5a.5.5 0 0 0 0 1h6.3l-4.46 4.45a.5.5 0 1 0 .71.7l4.45-4.44v6.29a.5.5 0 0 0 1 0v-6.3l4.45 4.46a.5.5 0 1 0 .7-.71l-4.44-4.45h6.29a.5.5 0 0 0 0-1h-6.3l4.46-4.45a.5.5 0 1 0-.71-.7L10.5 8.78z"
]);
const $db6ad3fef28672ff$export$819a3dfb3664b6f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBaseline20Filled', "20", [
    "M10.7 3.47a.75.75 0 0 0-1.4 0l-3.75 9.5a.75.75 0 0 0 1.4.56l1.2-3.03h3.7l1.2 3.03a.75.75 0 0 0 1.4-.56zM11.27 9H8.73L10 5.8z",
    "M2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$8f7615a844d26025 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBaseline20Regular', "20", [
    "M10.46 3.8a.5.5 0 0 0-.92 0l-4 9.5a.5.5 0 1 0 .92.4L8.02 10h3.96l1.56 3.7a.5.5 0 1 0 .92-.4zm1.1 5.2H8.44L10 5.29z",
    "M2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$56588e9635d1507c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold16Filled', "16", [
    "M4 3.3C4 2.6 4.6 2 5.3 2h3.3c2 0 3.5 1.7 3.5 3.5 0 .7-.2 1.4-.6 1.9.7.6 1.2 1.6 1.2 2.8 0 2.4-2 3.7-3.7 3.7H5.3c-.7.1-1.3-.5-1.3-1.2zm2.6 1.3v1.9h2a1 1 0 0 0 0-2h-2zm0 4.5v2.4H9c.6 0 1.2-.5 1.2-1.2S9.6 9.1 9 9.1z"
]);
const $db6ad3fef28672ff$export$65fd44a17c3b0b05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold16Regular', "16", [
    "M4 3.1C4 2.5 4.5 2 5.1 2h3c2.1 0 3.4 1.4 3.4 3.4 0 .9-.3 2-.7 2.6.8.6 1.4 1.2 1.4 2.5 0 2.7-2.1 3.5-3.6 3.5H5.1c-.6 0-1.1-.5-1.1-1.1zM6 9v3h2.4c.7 0 1.5-.5 1.5-1.5S9.1 9 8.4 9zm0-2h2.2c.9 0 1.5-.7 1.5-1.5S9.1 4 8.3 4H6z"
]);
const $db6ad3fef28672ff$export$e8a4aea315399091 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold20Filled', "20", [
    "M5 4.5C5 3.67 5.67 3 6.5 3h3.88a4.12 4.12 0 0 1 3.44 6.39 4.2 4.2 0 0 1 1.43 3.24A4.36 4.36 0 0 1 10.88 17H6.5A1.5 1.5 0 0 1 5 15.5zM8 6v2.25h2.38a1.13 1.13 0 0 0 0-2.25zm0 5.25V14h2.88c.7 0 1.37-.54 1.37-1.37s-.69-1.38-1.37-1.38z"
]);
const $db6ad3fef28672ff$export$52fc3fdaf26b7b94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold20Regular', "20", [
    "M5.5 4.25C5.5 3.56 6.06 3 6.75 3h3.5a4 4 0 0 1 3.17 6.44c.9.7 1.58 1.8 1.58 3.31A4.23 4.23 0 0 1 10.75 17h-4c-.69 0-1.25-.56-1.25-1.25zM8 11v3.5h2.75c.81 0 1.75-.62 1.75-1.75S11.56 11 10.75 11zm0-2.5h2.25a1.5 1.5 0 1 0 0-3H8z"
]);
const $db6ad3fef28672ff$export$99054c5f80f63f4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold24Filled', "24", [
    "M6 5.75C6 4.78 6.78 4 7.75 4h4.75a4.76 4.76 0 0 1 3.95 7.38A4.8 4.8 0 0 1 18 15c0 3.13-2.68 5-5 5H7.75C6.78 20 6 19.22 6 18.25zm3.5 7.75v3H13c.31 0 .71-.14 1.02-.42q.46-.39.48-1.08c0-.89-.75-1.5-1.5-1.5zm0-3.5h3c.71 0 1.25-.6 1.25-1.25 0-.66-.54-1.25-1.25-1.25h-3z"
]);
const $db6ad3fef28672ff$export$972f2883961327be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold24Regular', "24", [
    "M6.94 4.44A1.5 1.5 0 0 1 8 4h4.38a4.64 4.64 0 0 1 3.75 7.3A4.7 4.7 0 0 1 18 15.13c0 3.11-2.7 4.88-4.88 4.88H8a1.5 1.5 0 0 1-1.5-1.5v-13q0-.62.44-1.06m2.56 5.81h2.88c.9 0 1.62-.76 1.62-1.62S13.28 7 12.38 7H9.5zm0 3V17h3.62c.87 0 1.88-.75 1.88-1.88a1.9 1.9 0 0 0-1.88-1.87z"
]);
const $db6ad3fef28672ff$export$eff734bb87605270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold28Filled', "28", [
    "M15.75 4a5.75 5.75 0 0 1 4.5 9.32A5.99 5.99 0 0 1 16.5 24H8.75C7.78 24 7 23.22 7 22.25V5.75C7 4.78 7.78 4 8.75 4zM10.5 20.5h6a2.5 2.5 0 0 0 0-5h-6zm0-8.5h5.25a2.25 2.25 0 0 0 0-4.5H10.5z"
]);
const $db6ad3fef28672ff$export$79b5f559d44bb8f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBold28Regular', "28", [
    "M15.5 4a5.5 5.5 0 0 1 4.08 9.19A6 6 0 0 1 16 24H8.5A1.5 1.5 0 0 1 7 22.5v-17C7 4.67 7.67 4 8.5 4zM10 21h6a3 3 0 1 0 0-6h-6zm0-9h5.5a2.5 2.5 0 0 0 0-5H10z"
]);
const $db6ad3fef28672ff$export$c10be9ae339da06a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBoxSettings20Filled', "20", [
    "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1-.5-3.5H6.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75h2.9q.44-.85 1.13-1.5H6.7c-.4 0-.71-.34-.71-.75S6.32 9 6.7 9h7.65a5.6 5.6 0 0 1 2.65.6zM6 6.75c0-.41.32-.75.7-.75h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75m6.07 4.7a2 2 0 0 1-1.44 2.47l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.05a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$25013dd73f4b120e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBoxSettings20Regular', "20", [
    "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h2.7q.16-.52.4-1zm-1 4h3.7q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5m6.57-4.56a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$84983ca603f2b58b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBoxSettings24Filled', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h6.27a6.5 6.5 0 0 1-1-4H6.75a.75.75 0 0 1-.1-1.5h4.66c.3-.95.83-1.8 1.5-2.5H6.75a.75.75 0 0 1-.1-1.5h7.6q.24 0 .44.14a6.5 6.5 0 0 1 6.31.38zM17.25 7.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h10.6m-4.75 8.13.45.43a2 2 0 0 1 0 2.88l-.45.43q.31.86.85 1.57l.6-.18a2 2 0 0 1 2.52 1.45l.17.72a5 5 0 0 0 1.72 0l.17-.72a2 2 0 0 1 2.52-1.45l.6.18q.54-.71.85-1.57l-.45-.43a2 2 0 0 1 0-2.88l.45-.43q-.31-.87-.85-1.57l-.6.18a2 2 0 0 1-2.52-1.45l-.17-.72a5 5 0 0 0-1.72 0l-.17.72a2 2 0 0 1-2.52 1.45l-.6-.18q-.55.71-.85 1.57m5 3.37c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $db6ad3fef28672ff$export$85c272a47d021838 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBoxSettings24Regular', "24", [
    "M18.25 3A2.75 2.75 0 0 1 21 5.75v6.27q-.7-.45-1.5-.7V5.74c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h5.56q.27.8.71 1.5H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3zm-4 8.5q.24 0 .44.14-1.07.52-1.88 1.36H6.75a.75.75 0 0 1-.1-1.5h7.6m-7.5 4h4.56q-.22.72-.3 1.5H6.76a.75.75 0 0 1-.1-1.5zm10.5-8H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5m-4.75 8.13.45.43a2 2 0 0 1 0 2.88l-.45.43q.31.86.85 1.57l.6-.18a2 2 0 0 1 2.52 1.45l.17.72a5 5 0 0 0 1.72 0l.17-.72a2 2 0 0 1 2.52-1.45l.6.18q.54-.71.85-1.57l-.45-.43a2 2 0 0 1 0-2.88l.45-.43q-.31-.87-.85-1.57l-.6.18a2 2 0 0 1-2.52-1.45l-.17-.72a5 5 0 0 0-1.72 0l-.17.72a2 2 0 0 1-2.52 1.45l-.6-.18q-.55.71-.85 1.57m5 3.37c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $db6ad3fef28672ff$export$d1b6b948cce588b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList16Filled', "16", [
    "M2.25 5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m1.25 3a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5.75 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM5 8c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8m.75 3.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$535ee5cfd6d87207 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList16Regular', "16", [
    "M2 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5.5 3a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM5 8c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 5 8m.5 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$52cf3e47b4416407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList20Filled', "20", [
    "M3.25 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7 4.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 4.75M7.75 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zM4.5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M3.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $db6ad3fef28672ff$export$994f7e91686ad014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList20Regular', "20", [
    "M3 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm-2.5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$4e349aa285cd6852 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList24Filled', "24", [
    "M3.5 16.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21zm-4-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21zm-4-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21z"
]);
const $db6ad3fef28672ff$export$dc2af87572d952e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList24Regular', "24", [
    "M3.25 17.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5zm-3.5-7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5zm-3.5-7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5z"
]);
const $db6ad3fef28672ff$export$bb77f29a41789524 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList27024Filled', "24", [
    "M16.5 20.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.5-4V3a1 1 0 0 1 2-.12V16.5a1 1 0 0 1-2 .12zm-6.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.5-4V3a1 1 0 0 1 2-.12V16.5a1 1 0 0 1-2 .12zm-6.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.5-4V3a1 1 0 0 1 2-.12V16.5a1 1 0 0 1-2 .12z"
]);
const $db6ad3fef28672ff$export$aced64aee0064e0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList27024Regular', "24", [
    "M17.5 20.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m.5-3.5V2.75a.75.75 0 0 1 1.5-.1v14.6a.75.75 0 0 1-1.5.1zm-7 3.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m.5-3.5V2.75a.75.75 0 0 1 1.5-.1v14.6a.75.75 0 0 1-1.5.1zm-7 3.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m.5-3.5V2.75a.75.75 0 0 1 1.5-.1v14.6a.75.75 0 0 1-1.5.1z"
]);
const $db6ad3fef28672ff$export$7c92bb9fddc5c1d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList9020Filled', "20", [
    "M6 16.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M4.75 13a.75.75 0 0 1-.75-.75v-9.5a.75.75 0 0 1 1.5 0v9.5c0 .41-.34.75-.75.75M9 12.25a.75.75 0 0 0 1.5 0v-9.5a.75.75 0 0 0-1.5 0zm5 0a.75.75 0 0 0 1.5 0v-9.5a.75.75 0 0 0-1.5 0zM9.75 15.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M16 16.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
]);
const $db6ad3fef28672ff$export$c9597cbee8362b3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList9020Regular', "20", [
    "M5.5 17a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1-3a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m4.5-.5a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm.5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $db6ad3fef28672ff$export$cd0674aba3c3ed2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList9024Filled', "24", [
    "M7.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.5 4V21a1 1 0 0 1-2 .12V7.5a1 1 0 0 1 2-.12zm6.5-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.5 4V21a1 1 0 0 1-2 .12V7.5a1 1 0 0 1 2-.12zm6.5-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.5 4V21a1 1 0 0 1-2 .12V7.5a1 1 0 0 1 2-.12z"
]);
const $db6ad3fef28672ff$export$c293a6521b8ec819 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletList9024Regular', "24", [
    "M6.5 3.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M6 6.75v14.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1zm7-3.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-.5 3.5v14.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1zm7-3.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-.5 3.5v14.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1z"
]);
const $db6ad3fef28672ff$export$2b75fa39d3d3e744 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListAdd20Filled', "20", [
    "M3.25 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7 4.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 4.75M7.75 9a.75.75 0 0 0 0 1.5h5.46a5.5 5.5 0 0 1 4.39-.09.75.75 0 0 0-.35-1.41zm0 5h2.46q-.21.72-.21 1.5H7.75a.75.75 0 0 1 0-1.5M4.5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M3.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V15h-1.5a.5.5 0 0 0 0 1H15v1.5a.5.5 0 0 0 1 0V16h1.5a.5.5 0 0 0 0-1H16z"
]);
const $db6ad3fef28672ff$export$a62bf2113afc0d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListAdd20Regular', "20", [
    "M3 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4.02 5.5q.05-.51.19-1H6.5a.5.5 0 0 0 0 1zM4 14.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m17 5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V15h-1.5a.5.5 0 0 0 0 1H15v1.5a.5.5 0 0 0 1 0V16h1.5a.5.5 0 0 0 0-1H16z"
]);
const $db6ad3fef28672ff$export$72fea4ec94a94c62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListAdd24Filled', "24", [
    "M5 18a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m7.02-1H7.38a1 1 0 0 0 .12 2h4.67a7 7 0 0 1-.15-2m1.79-4H7.5a1 1 0 0 1-.12-2H18.5c-1.84 0-3.5.77-4.69 2M5 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0-6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m16-1H7.38a1 1 0 0 0 .12 2h13.62A1 1 0 0 0 21 5m3 12.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H18v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $db6ad3fef28672ff$export$bdbb4eeef66f52ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListAdd24Regular', "24", [
    "M4.5 18.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m7.52-.75H6.65a.75.75 0 0 0 .1 1.5h5.56a7 7 0 0 1-.3-1.5m1.79-5H6.75a.75.75 0 0 1-.1-1.5h9.34q-1.25.53-2.18 1.5m-9.31-.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m0-6.5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M21.25 5H6.65a.75.75 0 0 0 .1 1.5h14.6a.75.75 0 0 0-.1-1.5M24 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H18v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $db6ad3fef28672ff$export$8ec55b9e8de3c1c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListCheckmark20Filled', "20", [
    "M3.25 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7 4.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 4.75M7.75 9a.75.75 0 0 0 0 1.5h5.46a5.5 5.5 0 0 1 4.39-.09.75.75 0 0 0-.35-1.41zm0 5h2.46q-.21.72-.21 1.5H7.75a.75.75 0 0 1 0-1.5M4.5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M3.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$10459a0749441e4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListCheckmark20Regular', "20", [
    "M3 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4.02 5.5q.05-.51.19-1H6.5a.5.5 0 0 0 0 1zM4 14.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m17 5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.5.8-.65-.65a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7z"
]);
const $db6ad3fef28672ff$export$c20a5348e500cf2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListDismiss20Filled', "20", [
    "M3.25 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7 4.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 4.75M7.75 9a.75.75 0 0 0 0 1.5h5.46a5.5 5.5 0 0 1 4.39-.09.75.75 0 0 0-.35-1.41zm0 5h2.46q-.21.72-.21 1.5H7.75a.75.75 0 0 1 0-1.5M4.5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M3.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $db6ad3fef28672ff$export$a03200354c27a3c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListDismiss20Regular', "20", [
    "M3 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4.02 5.5q.05-.51.19-1H6.5a.5.5 0 0 0 0 1zM4 14.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m17 5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $db6ad3fef28672ff$export$883caa45341a2135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListEdit20Filled', "20", [
    "M16.81 10.55a1.87 1.87 0 1 1 2.64 2.64l-4.82 4.83a2 2 0 0 1-1.03.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02zM3.25 13.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m8.02 1.17a3 3 0 0 0-.6.83H7.76a.75.75 0 0 1 0-1.5h4.2zM3.25 8.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m14 .5q.15 0 .3.06-.82.16-1.45.78l-.66.66H7.75a.75.75 0 0 1 0-1.5zm-14-5.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m14 .5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$52ffd63594a6b7bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListEdit20Regular', "20", [
    "M16.81 10.55a1.87 1.87 0 1 1 2.64 2.64l-4.82 4.83a2 2 0 0 1-1.03.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02zM3 13.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m8.27 1.17q-.15.15-.28.33H6.5a.5.5 0 0 1 0-1h5.44zM3 8.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m14.5.5.19.04c-.58.09-1.14.35-1.59.8l-.16.16H6.5a.5.5 0 0 1 0-1zM3 3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m14.5.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$84dc31e468bb01a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr16Filled', "16", [
    "M2.25 5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m1.25 3a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5.75 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM5 8c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8m.75 3.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$f82dcc558093e5d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr16Regular', "16", [
    "M2 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5.5 3a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM5 8c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 5 8m.5 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$2364c2f0727b6a70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr20Filled', "20", [
    "M3.25 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7 4.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 4.75M7.75 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zM4.5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M3.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $db6ad3fef28672ff$export$8f132f322686b3e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr20Regular', "20", [
    "M3 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm-2.5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$4fdf1b254d51d952 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr24Filled', "24", [
    "M3.5 16.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21zm-4-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21zm-4-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21z"
]);
const $db6ad3fef28672ff$export$b529df5a7e0e5439 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr24Regular', "24", [
    "M3.25 17.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5zm-3.5-7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5zm-3.5-7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5z"
]);
const $db6ad3fef28672ff$export$880fbf900678f00c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr9020Filled', "20", [
    "M14 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M15.25 7c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M11 7.75a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0zm-5 0a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0zm4.25-3.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M4 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"
]);
const $db6ad3fef28672ff$export$205b2f533c26403 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr9020Regular', "20", [
    "M14.5 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 3c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5m-5 0c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5M6 6.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0zM5.5 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $db6ad3fef28672ff$export$9ff9c02195669d19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr9024Filled', "24", [
    "M7.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.5 4V21a1 1 0 0 1-2 .12V7.5a1 1 0 0 1 2-.12zm6.5-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.5 4V21a1 1 0 0 1-2 .12V7.5a1 1 0 0 1 2-.12zm6.5-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.5 4V21a1 1 0 0 1-2 .12V7.5a1 1 0 0 1 2-.12z"
]);
const $db6ad3fef28672ff$export$627796cefebcb49b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtr9024Regular', "24", [
    "M6.5 3.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M6 6.75v14.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1zm7-3.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-.5 3.5v14.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1zm7-3.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-.5 3.5v14.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1z"
]);
const $db6ad3fef28672ff$export$65d51b9f3e4f0a99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtrRotate27024Filled', "24", [
    "M16.5 20.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.5-4V3a1 1 0 0 1 2-.12V16.5a1 1 0 0 1-2 .12zm-6.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.5-4V3a1 1 0 0 1 2-.12V16.5a1 1 0 0 1-2 .12zm-6.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.5-4V3a1 1 0 0 1 2-.12V16.5a1 1 0 0 1-2 .12z"
]);
const $db6ad3fef28672ff$export$6a75fec3ce74e5a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListLtrRotate27024Regular', "24", [
    "M17.5 20.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m.5-3.5V2.75a.75.75 0 0 1 1.5-.1v14.6a.75.75 0 0 1-1.5.1zm-7 3.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m.5-3.5V2.75a.75.75 0 0 1 1.5-.1v14.6a.75.75 0 0 1-1.5.1zm-7 3.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m.5-3.5V2.75a.75.75 0 0 1 1.5-.1v14.6a.75.75 0 0 1-1.5.1z"
]);
const $db6ad3fef28672ff$export$37434ce9919d977a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl16Filled', "16", [
    "M13.75 5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m0 4.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m-1.25 3a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M10.25 3a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zM11 8a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5c.41 0 .75-.34.75-.75m-.75 3.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$f8e078f0e67dad2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl16Regular', "16", [
    "M14 4.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2M14 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-1 3.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0M10.5 3a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm.5 5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0 0 1h9A.5.5 0 0 0 11 8m-.5 4a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$bc0c9241eac721ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl20Filled', "20", [
    "M16.75 6a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M13 4.75a.75.75 0 0 0-.75-.75h-9.5a.75.75 0 0 0 0 1.5h9.5c.41 0 .75-.34.75-.75M12.25 9a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm3.25-4.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M16.75 16a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
]);
const $db6ad3fef28672ff$export$8b4824a2fce389b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl20Regular', "20", [
    "M17 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-3-1a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5m0 5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5m-.5 4.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm2.5.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$6261b2bedb35874f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl24Filled', "24", [
    "M20.5 16.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-4 .5H3a1 1 0 0 0-.12 2H16.5a1 1 0 0 0 .12-2zm4-6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-4 .5H3a1 1 0 0 0-.12 2H16.5a1 1 0 0 0 .12-2zm4-6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-4 .5H3a1 1 0 0 0-.12 2H16.5a1 1 0 0 0 .12-2z"
]);
const $db6ad3fef28672ff$export$d0935689c3b7da41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl24Regular', "24", [
    "M20.75 17.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-3.5.5H2.75a.75.75 0 0 0-.1 1.5h14.6a.75.75 0 0 0 .1-1.5zm3.5-7a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-3.5.5H2.75a.75.75 0 0 0-.1 1.5h14.6a.75.75 0 0 0 .1-1.5zm3.5-7a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-3.5.5H2.75a.75.75 0 0 0-.1 1.5h14.6a.75.75 0 0 0 .1-1.5z"
]);
const $db6ad3fef28672ff$export$a3905fd910b36b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl9020Filled', "20", [
    "M6 16.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M4.75 13a.75.75 0 0 1-.75-.75v-9.5a.75.75 0 0 1 1.5 0v9.5c0 .41-.34.75-.75.75M9 12.25a.75.75 0 0 0 1.5 0v-9.5a.75.75 0 0 0-1.5 0zm5 0a.75.75 0 0 0 1.5 0v-9.5a.75.75 0 0 0-1.5 0zM9.75 15.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M16 16.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
]);
const $db6ad3fef28672ff$export$3037a3a7f2f12216 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListRtl9020Regular', "20", [
    "M5.5 17a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1-3a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5m4.5-.5a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm.5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $db6ad3fef28672ff$export$82007d97669dfb12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_16_color__a)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_16_color__b)",
            "d": "M5.5 5A.75.75 0 1 0 4 5a.75.75 0 0 0 1.5 0m0 3A.75.75 0 1 0 4 8a.75.75 0 0 0 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6.5 5c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5M7 7.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zM6.5 11c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_16_color__a",
                "x1": "2.43",
                "x2": "10.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_16_color__b",
                "x1": "5.54",
                "x2": "10.8",
                "y1": "4.83",
                "y2": "18.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$62aa14de342554bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zm3.5.5A.75.75 0 1 0 4 5a.75.75 0 0 0 1.5 0m0 3A.75.75 0 1 0 4 8a.75.75 0 0 0 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6.5 5c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5M7 7.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zM6.5 11c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$d019f0db90e4a102 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare16Regular', "16", [
    "M5.5 5A.75.75 0 1 1 4 5a.75.75 0 0 1 1.5 0m0 3A.75.75 0 1 1 4 8a.75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6.5 5c0-.28.22-.5.5-.5h4.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M7 7.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zM6.5 11c0-.28.22-.5.5-.5h4.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5m-2-9A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5z"
]);
const $db6ad3fef28672ff$export$513111cd84eb7eed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_20_color__a)",
            "d": "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_20_color__b)",
            "d": "M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_20_color__a",
                "x1": "3.5",
                "x2": "13.16",
                "y1": "5.63",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_20_color__b",
                "x1": "7.54",
                "x2": "12.8",
                "y1": "7.08",
                "y2": "20.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$344564e06f158285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 13.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$320994b85ba14b96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare20Regular', "20", [
    "M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3M4 5.75v8.5c0 .97.78 1.75 1.75 1.75h8.5c.97 0 1.75-.78 1.75-1.75v-8.5C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75"
]);
const $db6ad3fef28672ff$export$95d5ba6e2cda6824 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_24_color__a)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_24_color__b)",
            "d": "M7.75 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 3.75a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5zm-.75 4.5c0 .41.34.75.75.75h5.5a.75.75 0 1 0 0-1.5h-5.5a.75.75 0 0 0-.75.75M8.75 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_24_color__a",
                "x1": "3.64",
                "x2": "16.07",
                "y1": "6.38",
                "y2": "19.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_24_color__b",
                "x1": "8.82",
                "x2": "15.19",
                "y1": "7.98",
                "y2": "25.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$1627260807c91df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zm4.75 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 3.75a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5zm-.75 4.5c0 .41.34.75.75.75h5.5a.75.75 0 1 0 0-1.5h-5.5a.75.75 0 0 0-.75.75M8.75 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$3a6dae0c05e1d7be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare24Regular', "24", [
    "M7.75 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 3.75a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5zm-.75 4.5c0-.41.34-.75.75-.75h5.5a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75M8.75 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $db6ad3fef28672ff$export$6f643f3c1cadd094 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_28_color__a)",
            "d": "M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_28_color__b)",
            "d": "M12 9.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m.75 4.25h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5M12 19.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M8.75 10.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M10 14.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.75 20.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_28_color__a",
                "x1": "3.79",
                "x2": "18.97",
                "y1": "7.13",
                "y2": "22.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_28_color__b",
                "x1": "10.1",
                "x2": "18.78",
                "y1": "8.96",
                "y2": "31.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$4ab894d5b7656e94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zM12 9.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m.75 4.25h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5M12 19.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M8.75 10.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M10 14.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.75 20.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
]);
const $db6ad3fef28672ff$export$82415cfa6956f57e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare28Regular', "28", [
    "M12 9.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m.75 4.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM12 19.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M8.75 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M10 14.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.75 20.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25zM6.75 4.5c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25h14.5c1.24 0 2.25-1 2.25-2.25V6.75c0-1.24-1-2.25-2.25-2.25z"
]);
const $db6ad3fef28672ff$export$aae814760418d6af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_32_color__a)",
            "d": "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_32_color__b)",
            "d": "M12 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-1.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 10.5a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-7a1 1 0 0 0-1 1m1 4.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1 6.5a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-7a1 1 0 0 0-1 1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_32_color__a",
                "x1": "3.93",
                "x2": "21.87",
                "y1": "7.88",
                "y2": "26.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_32_color__b",
                "x1": "11.69",
                "x2": "21.98",
                "y1": "10.08",
                "y2": "35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$bbf6cd0f276b8134 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare32Filled', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5zm9 3a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-1.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 10.5a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-7a1 1 0 0 0-1 1m1 4.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1 6.5a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-7a1 1 0 0 0-1 1"
]);
const $db6ad3fef28672ff$export$fbf80d4d981f1d19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare32Regular', "32", [
    "M12 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 10.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1 4.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1 6.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3zM5 7.5A2.5 2.5 0 0 1 7.5 5h17A2.5 2.5 0 0 1 27 7.5v17a2.5 2.5 0 0 1-2.5 2.5h-17A2.5 2.5 0 0 1 5 24.5z"
]);
const $db6ad3fef28672ff$export$b62ecfc27cea2657 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_48_color__a)",
            "d": "M12.25 6A6.25 6.25 0 0 0 6 12.25v23.5C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_48_color__b)",
            "d": "M17 15.75a2 2 0 1 0-4 0 2 2 0 0 0 4 0m0 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-18c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25m1.25 6.75a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM19 31.75c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_48_color__a",
                "x1": "7.29",
                "x2": "32.13",
                "y1": "12.75",
                "y2": "38.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_48_color__b",
                "x1": "17.23",
                "x2": "30.94",
                "y1": "15.29",
                "y2": "51.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$581af1e4364c241 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare48Filled', "48", [
    "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75zm11 3.5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m0 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-18c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25m1.25 6.75a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM19 31.75c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25"
]);
const $db6ad3fef28672ff$export$9b9b8af200b931b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquare48Regular', "48", [
    "M17 15.75a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-18c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25m1.25 6.75a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM19 31.75c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M12.25 6A6.25 6.25 0 0 0 6 12.25v23.5C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6zM8.5 12.25a3.75 3.75 0 0 1 3.75-3.75h23.5a3.75 3.75 0 0 1 3.75 3.75v23.5a3.75 3.75 0 0 1-3.75 3.75h-23.5a3.75 3.75 0 0 1-3.75-3.75z"
]);
const $db6ad3fef28672ff$export$d56b7e5ea3391d86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0-5A2.5 2.5 0 0 1 14 4.5v2.1q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-4.9 8H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm0 7a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H13a.5.5 0 0 0 0-1h-1V9.5a.5.5 0 0 0-.5-.5m-6.75 1.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M7 4.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$2119e380aeb222dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0-5A2.5 2.5 0 0 1 14 4.5v2.1q-.48-.24-1-.4V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h1.7q.15.52.4 1H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm0 7a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H13a.5.5 0 0 0 0-1h-1V9.5a.5.5 0 0 0-.5-.5m-6.75 1.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m6.75.25a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$9525f8480bb9e37b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock20Filled', "20", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v8.5A2.75 2.75 0 0 0 5.75 17H9.6a5.5 5.5 0 0 1 .66-6H9.5a.5.5 0 0 1 0-1h1.84A5.5 5.5 0 0 1 17 9.6V5.75A2.75 2.75 0 0 0 14.25 3zM7.5 7.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 9.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.5 8a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1zm5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.5-6.5a.5.5 0 0 1 1 0V14h1a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.5z"
]);
const $db6ad3fef28672ff$export$aa3bf3f5f98930d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock20Regular', "20", [
    "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.6q-.48-.24-1-.4V5.76C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h3.46q.15.52.39 1H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3m3.75 7h1.84q-.6.42-1.08 1H9.5a.5.5 0 0 1 0-1M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m10 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $db6ad3fef28672ff$export$a6e425c05fdc97ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-9C19.55 3 21 4.46 21 6.25v5.77a6.5 6.5 0 0 0-5.28-.77h-4.47a.75.75 0 0 0 0 1.5h1.82A6.5 6.5 0 0 0 12.02 21H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3zm-.25 11a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5H20a.5.5 0 0 0 0-1h-2v-2.5a.5.5 0 0 0-.5-.5m-9.75.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3.5.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$b3d788da48165b3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-9C19.55 3 21 4.46 21 6.25v5.77q-.7-.45-1.5-.7V6.24c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h5.06q.27.8.71 1.5H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3zm-.25 11a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5H20a.5.5 0 0 0 0-1h-2v-2.5a.5.5 0 0 0-.5-.5m-9.75.75a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3.75a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7.97.25q-1.52.44-2.65 1.5h-1.82a.75.75 0 0 1 0-1.5zm-7.97-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m9 .25a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$7e8d3d0ec21b5200 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock28Filled', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m.75-11A3.75 3.75 0 0 1 25 6.75v7.75a7.5 7.5 0 0 0-7.2-1h-5.05a.75.75 0 0 0 0 1.5h2.65a7.5 7.5 0 0 0-.9 10H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3zm-.75 13.5a.5.5 0 0 0-.5.5v3.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H21v-3a.5.5 0 0 0-.5-.5M8.75 18a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m4 .5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$aae16103258a5fe8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareClock28Regular', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m.75-11A3.75 3.75 0 0 1 25 6.75v7.75a8 8 0 0 0-1.5-.87V6.75c0-1.24-1-2.25-2.25-2.25H6.75c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25h6.88q.35.81.87 1.5H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3zm-.75 13.5a.5.5 0 0 0-.5.5v3.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H21v-3a.5.5 0 0 0-.5-.5M8.75 18a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m0-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m9.06.5a8 8 0 0 0-2.4 1.5h-2.66a.75.75 0 0 1 0-1.5zM8.75 8a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m11.5.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$82548960baea1f93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareEdit20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9c-.69.03-1.37.31-1.9.84L11.94 13H9.5a.5.5 0 0 0 0 1h1.44l-.67.67q-.61.63-.84 1.49l-.21.84H5.75A2.75 2.75 0 0 1 3 14.25zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm1.48 5.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $db6ad3fef28672ff$export$c350f57225c5c9a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareEdit20Regular', "20", [
    "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9q-.52.03-1 .23V5.75C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h3.72l-.04.16-.21.84H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3M9.5 13h2.44l-1 1H9.5a.5.5 0 0 1 0-1m-2-5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm1.48 5.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $db6ad3fef28672ff$export$a1c7699d227d49af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareEdit24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h4.92l.35-1.42q.25-.99.97-1.72l1.37-1.36h-2.61a.75.75 0 1 1 0-1.5h4.1l3.04-3.04a3.3 3.3 0 0 1 2.61-.95V6.25C21 4.45 19.54 3 17.75 3zm2.5 5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m1.75 0c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m0 3.75c0-.41.34-.75.75-.75h5.5a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m-2.75-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1 4.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m10.35-3.08-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $db6ad3fef28672ff$export$ebe0333276b91b1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareEdit24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v4.76a3 3 0 0 0-1.5.22V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h5.3l-.03.08-.35 1.42H6.25A3.25 3.25 0 0 1 3 17.75zM15.36 15l-1.5 1.5h-2.61a.75.75 0 1 1 0-1.5zM7.75 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM10.5 12c0-.41.34-.75.75-.75h5.5a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m-2.75 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 3.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2m11.35-4.08-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $db6ad3fef28672ff$export$32687e925c9f8c4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquarePerson20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.4a3 3 0 0 0-3.74.6H9.5a.5.5 0 0 0 0 1h3.17a3 3 0 0 0 0 2H9.5a.5.5 0 0 0 0 1h3.76l.01.01A2.5 2.5 0 0 0 11.04 17H5.75A2.75 2.75 0 0 1 3 14.25zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m8.5 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$cadd196876f74b4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquarePerson20Regular', "20", [
    "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.4q-.46-.26-1-.36V5.75C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h5.3a3 3 0 0 0-.01 1H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3m3.75 7h3.76a3 3 0 0 0-.59 1H9.5a.5.5 0 0 1 0-1m0 3h3.17a3 3 0 0 0 .6 1H9.5a.5.5 0 0 1 0-1m-2-5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm8 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $db6ad3fef28672ff$export$8530b2b51252d62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquarePerson32Filled', "32", [
    "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h10.71a5 5 0 0 1-.71-2.56 3.93 3.93 0 0 1 3.92-3.94H15a1 1 0 1 1 0-2h5.23a5 5 0 0 1 .19-3.5H15a1 1 0 1 1 0-2h7a5 5 0 0 1 7 1V7.5A4.5 4.5 0 0 0 24.5 3zm3 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 5.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3-10a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2zM28.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06A2.43 2.43 0 0 1 21.42 24h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $db6ad3fef28672ff$export$f0bc6dfc11d6613e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquarePerson32Regular', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5V16a5 5 0 0 0-2-1.58V7.5A2.5 2.5 0 0 0 24.5 5h-17A2.5 2.5 0 0 0 5 7.5v17A2.5 2.5 0 0 0 7.5 27h10.03q.12 1.06.68 2H7.5A4.5 4.5 0 0 1 3 24.5zm18.43 15a5 5 0 0 1-1.2-2H15a1 1 0 1 0 0 2zM22 15a5 5 0 0 0-1.58 2H15a1 1 0 1 1 0-2zm-10-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2-11a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1M28.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06A2.43 2.43 0 0 1 21.42 24h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $db6ad3fef28672ff$export$f8923061ee2c3430 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSearch20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-4.13l-1.56-1.56q.33-.67.41-1.44h4.53a.5.5 0 0 0 0-1H8.97A4.5 4.5 0 0 0 3 9.26zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-5 7q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $db6ad3fef28672ff$export$81c6cbf712a73464 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSearch20Regular', "20", [
    "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-4.13l-1-1h5.13c.97 0 1.75-.78 1.75-1.75v-8.5C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v3.28q-.52.05-1 .23V5.75A2.75 2.75 0 0 1 5.75 3M9.5 14a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1zm-2-6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2-.25a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-5 7q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $db6ad3fef28672ff$export$42b70b6bc1f700c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSettings20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.6a5.5 5.5 0 0 0-5.66.4H9.5a.5.5 0 0 0 0 1h.76a5.5 5.5 0 0 0-.66 6H5.75A2.75 2.75 0 0 1 3 14.25zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m3.07 3.94a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$a0d259e710b29bd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSettings20Regular', "20", [
    "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.6q-.48-.24-1-.4V5.76C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h3.46q.15.52.39 1H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3m3.75 7h1.84q-.6.42-1.08 1H9.5a.5.5 0 0 1 0-1M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m3.07 3.94a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$6336232a5a305c14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareShield20Filled', "20", [
    "M14.12 9.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4M14.25 3A2.75 2.75 0 0 1 17 5.75v4.44c-.49-.2-.92-.5-1.24-.78l-.19-.17-.11-.1a1.6 1.6 0 0 0-1.92 0l-.11.1a5 5 0 0 1-1.03.76H9.5a.5.5 0 0 0 0 1h.76q-.2.27-.25.66l-.01.15V13h-.5a.5.5 0 0 0 0 1h.5c.02 1.28.5 2.27 1.1 3H5.76A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3zm-7.5 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M9.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$c511d10f53062cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareShield20Regular', "20", [
    "M14.12 9.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4M14.25 3A2.75 2.75 0 0 1 17 5.75v4.44a4 4 0 0 1-1-.58V5.75C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h4.71q.27.56.65 1H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3zm-7.5 9.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M10 13.92V14h-.5a.5.5 0 0 1 0-1h.5zM6.75 9.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m5.65.5q-.43.25-.93.36l-.27.04c-.34.07-.7.28-.94.6H9.5a.5.5 0 0 1 0-1zM6.75 6.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m6.75.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$7b31315634431b79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareShield48Filled', "48", [
    "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v12.57q-1.12-.34-2.28-.96-1-.55-2.03-1.3c-1-.75-2.38-.75-3.38 0l-.06.04q-.23-.1-.5-.1h-13.5a1.25 1.25 0 1 0 0 2.5h9.09q-1.27.3-2.5.3A2.83 2.83 0 0 0 24 28.12v2.38h-3.75a1.25 1.25 0 1 0 0 2.5H24v.9q0 3.13 1.25 5.8.57 1.23 1.4 2.3h-14.4A6.25 6.25 0 0 1 6 35.75zm11 3.5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m0 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-18c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25m22.56 11.02a13 13 0 0 0 3.6.53c.47 0 .84.37.84.82v5.78c0 5.5-3.29 9.54-9.7 12.04a1 1 0 0 1-.6 0 18 18 0 0 1-6.78-4.34q-1.16-1.27-1.86-2.75A11.4 11.4 0 0 1 26 33.9v-5.77c0-.46.37-.83.83-.83q4.44 0 8.67-3.14c.3-.21.7-.21 1 0q1.13.85 2.28 1.46 1.38.75 2.78 1.15m-7.25-4.21.09.12Z"
]);
const $db6ad3fef28672ff$export$5db6234d305e941a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareShield48Regular', "48", [
    "M12.25 6A6.25 6.25 0 0 0 6 12.25v23.5C6 39.2 8.8 42 12.25 42h14.4a13 13 0 0 1-1.5-2.5h-12.9a3.75 3.75 0 0 1-3.75-3.75v-23.5a3.75 3.75 0 0 1 3.75-3.75h23.5a3.75 3.75 0 0 1 3.75 3.75v11.49l.22.12q1.16.6 2.28.96V12.25C42 8.8 39.2 6 35.75 6zM42 26.9q1.57.4 3.17.4c.46 0 .83.37.83.82v5.78c0 5.5-3.29 9.54-9.7 12.04a1 1 0 0 1-.6 0 18 18 0 0 1-6.78-4.34 11 11 0 0 1-1.86-2.75A11.4 11.4 0 0 1 26 33.9v-5.77c0-.46.37-.83.83-.83q4.44 0 8.67-3.14c.3-.21.7-.21 1 0a19 19 0 0 0 3 1.82 14 14 0 0 0 2.5.92M29.34 25c1.61-.4 3.25-1.17 4.9-2.4q-.22-.1-.49-.1h-13.5a1.25 1.25 0 1 0 0 2.5zM24 33v-2.5h-3.75a1.25 1.25 0 1 0 0 2.5zm-7-17.25a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-18c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $db6ad3fef28672ff$export$e4aff1a4ce3d2e9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__a)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__b)",
            "d": "M5.5 5A.75.75 0 1 0 4 5a.75.75 0 0 0 1.5 0m0 3A.75.75 0 1 0 4 8a.75.75 0 0 0 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6.5 5c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5M7 7.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zM6.5 11c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__c)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__d)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__e)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__f)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__g)",
            "d": "m15.78 8.21-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_16_color__h)",
            "d": "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -1.53125 0 13.5 9)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.5 -1.74793 0 10.5 4.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-3.5 0 0 -1.74793 10.5 4.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-2.5 0 0 -1.24852 13.5 9)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.38 11.56 -4.48)scale(28.6137 22.2808)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.2 14.06 -10.24)scale(30.098 23.4366)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".7",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__a",
                "x1": "2.43",
                "x2": "10.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_16_color__b",
                "x1": "5.54",
                "x2": "10.8",
                "y1": "4.83",
                "y2": "18.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$cbd436629a559463 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle16Filled', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48A1.3 1.3 0 0 1 10 8.5H7a.5.5 0 0 1 0-1h2.42q-.19-.22-.27-.45L8.8 5.96a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 6 3.5a1.4 1.4 0 0 1 .95-1.35L7.43 2H4.5A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.46-2.07q-.22.07-.46.07-.41 0-.74-.23M4.75 4.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0 3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M5.5 11A.75.75 0 1 1 4 11a.75.75 0 0 1 1.5 0m1.5.5a.5.5 0 0 1 0-1h4.5a.5.5 0 0 1 0 1z"
]);
const $db6ad3fef28672ff$export$220d5d11170a5fce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle16Regular', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM13.5 12q-.29 0-.55-.12A1.5 1.5 0 0 1 11.5 13h-7A1.5 1.5 0 0 1 3 11.5v-7C3 3.67 3.67 3 4.5 3h1.59a1.4 1.4 0 0 1 .86-.85L7.43 2H4.5A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.46-2.07q-.22.07-.46.07M9.67 7.74q-.15-.12-.25-.24H7a.5.5 0 0 0 0 1h3q0-.29.12-.55a1 1 0 0 1-.45-.2M4.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7 10.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$557bf235a2ffe126 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__a)",
            "d": "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__b)",
            "d": "M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__c)",
            "d": "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__d)",
            "d": "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__e)",
            "d": "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__f)",
            "d": "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v8.5A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__g)",
            "d": "m18.78 8.21-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_20_color__h)",
            "d": "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(.03125 3.75 -1.87278 .0156 16.47 9.44)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90.77 4.73 8.74)scale(4.65667 2.32559)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.40625 0 0 -2.20052 13.53 4.13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-3.1875 0 0 -1.59187 16.56 9.13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.38 13.06 -2.05)scale(28.6137 22.2808)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.2 15.56 -7.7)scale(30.098 23.4366)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".7",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__a",
                "x1": "3.5",
                "x2": "13.16",
                "y1": "5.63",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_20_color__b",
                "x1": "7.54",
                "x2": "12.8",
                "y1": "7.08",
                "y2": "20.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$c2e30b42158ab44b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle20Filled', "20", [
    "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48A1.31 1.31 0 0 1 13.1 8H9.5a.5.5 0 0 1 0-1h2.64l-.35-1.04a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 9 3.5q0-.27.09-.5H5.75A2.75 2.75 0 0 0 3 5.75v8.5A2.75 2.75 0 0 0 5.75 17h8.5A2.75 2.75 0 0 0 17 14.25v-2.33q-.24.09-.5.08-.41 0-.74-.23M7.5 7.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 9.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1z"
]);
const $db6ad3fef28672ff$export$ff8124cbe2941a74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle20Regular', "20", [
    "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM16 11.91q.24.09.5.09t.5-.08v2.33A2.75 2.75 0 0 1 14.25 17h-8.5A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3h3.34a1.4 1.4 0 0 0 0 1H5.75C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h8.5c.97 0 1.75-.78 1.75-1.75zM12.14 7l.01.05q.13.37.52.7.22.15.45.2L13.1 8H9.5a.5.5 0 0 1 0-1zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$6d799ec411aff3aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__a)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__b)",
            "d": "M7.75 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 3.75a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5zm-.75 4.5c0 .41.34.75.75.75h5.5a.75.75 0 1 0 0-1.5h-5.5a.75.75 0 0 0-.75.75M8.75 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__c)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__d)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__e)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__f)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__g)",
            "d": "m22.78 10.21-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_24_color__h)",
            "d": "M15.09 6.41a3 3 0 0 0-1.35-.95L12.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.09821 0 0 -2.04669 20.44 10.88)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-5.66518 0 0 -2.82925 16.54 4.45)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90.77 6.08 10.38)scale(5.98715 2.99004)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(86.15 4.13 16.5)scale(2.72936 1.36307)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.38 13.44 2.19)scale(28.6137 22.2808)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.2 19.57 -10.63)scale(38.6974 30.1328)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".7",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__a",
                "x1": "3.64",
                "x2": "16.07",
                "y1": "6.38",
                "y2": "19.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_24_color__b",
                "x1": "8.82",
                "x2": "15.19",
                "y1": "7.98",
                "y2": "25.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$bd897d81073e5488 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle24Filled', "24", [
    "M15.09 6.41a3 3 0 0 0-1.35-.95L12.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12.04 3h-5.8A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25v-3.82a1.3 1.3 0 0 1-1.29-.12q-.35-.25-.49-.65l-.24-.76a1 1 0 0 0-.14-.23 1 1 0 0 0-.22-.14l-.79-.25a1.3 1.3 0 0 1-.69-1.9q-.32.17-.68.17-.49 0-.89-.28-.4-.3-.57-.77h-3.75a.75.75 0 0 1 0-1.5h3.32a2 2 0 0 0-.27-.5l-.18-.1q-.3-.3-.72-.44L12 6q-.46-.2-.72-.64a1.6 1.6 0 0 1 0-1.8q.3-.39.77-.56m-3.3 5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.5 12c0-.41.34-.75.75-.75h5.5a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 4.5a.75.75 0 1 1 0-1.5h5.5a.75.75 0 1 1 0 1.5zM7.75 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1 4.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $db6ad3fef28672ff$export$1ab7eac142708368 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle24Regular', "24", [
    "M15.09 6.41a3 3 0 0 0-1.35-.95L12.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12.04 3h-5.8A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25v-3.82a1.3 1.3 0 0 1-1.5-.3v4.12c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75H11a1.6 1.6 0 0 1 .28-.93q.3-.4.77-.57m2.52 4.5h-3.32a.75.75 0 0 0 0 1.5H15l-.41-1.45zM7.75 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10.5 12c0-.41.34-.75.75-.75h5.5a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m0 3.75c0-.41.34-.75.75-.75h5.5a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75M7.75 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 3.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$6f042e141768d7ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__a)",
            "d": "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__b)",
            "d": "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__c)",
            "d": "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__d)",
            "d": "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__e)",
            "d": "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__f)",
            "d": "M12 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-1.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14 10.5a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-7a1 1 0 0 0-1 1m1 4.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1 6.5a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-7a1 1 0 0 0-1 1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__g)",
            "d": "m31.74 13.66-.92-.3a1.9 1.9 0 0 1-1.2-1.2l-.3-.92a.36.36 0 0 0-.68 0l-.3.92a1.9 1.9 0 0 1-1.18 1.2l-.92.3a.36.36 0 0 0 0 .68l.92.3a1.9 1.9 0 0 1 1.2 1.2l.3.92a.36.36 0 0 0 .68 0l.3-.92a1.9 1.9 0 0 1 1.2-1.2l.92-.3a.36.36 0 0 0 0-.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_bullet_list_square_sparkle_32_color__h)",
            "d": "M21.77 8.84a3.5 3.5 0 0 0-1.64-1.17l-1.69-.55a.67.67 0 0 1 0-1.25l1.69-.55a3.5 3.5 0 0 0 2.15-2.15l.01-.04.55-1.69a.67.67 0 0 1 1.25 0l.55 1.69a3.5 3.5 0 0 0 2.2 2.2l1.68.54h.04a.67.67 0 0 1 0 1.26l-1.69.55a3.5 3.5 0 0 0-2.2 2.2l-.54 1.68-.02.04a.66.66 0 0 1-1.24-.04l-.54-1.69a4 4 0 0 0-.56-1.03"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-3.5 0 0 -1.74793 29 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-7 0 0 -3.49587 23.5 7.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6 -2.99646 0 23.5 7.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4 -1.99764 0 29 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.38 17.2 6.89)scale(34.3364 26.737)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.2 24.74 -9.67)scale(47.2968 36.829)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".7",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__a",
                "x1": "3.93",
                "x2": "21.87",
                "y1": "7.88",
                "y2": "26.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_bullet_list_square_sparkle_32_color__f",
                "x1": "11.69",
                "x2": "21.98",
                "y1": "10.08",
                "y2": "35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$8c4f647c70e940b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle32Filled', "32", [
    "M21.49 8.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2l-.55-1.68a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M20.7 3H7.5A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-6.02q-.56-.02-1.04-.34a2 2 0 0 1-.69-.94l-.3-.91a.3.3 0 0 0-.09-.15l-.14-.1-1-.31a1.84 1.84 0 0 1-1.24-1.75q.01-.49.25-.9a2.16 2.16 0 0 1-3.3-1.08l-.16-.5H15a1 1 0 1 1 0-2h5.4q-.32-.3-.74-.44l-1.71-.56a2.2 2.2 0 0 1-1.45-2A2.2 2.2 0 0 1 18 4.44l1.64-.56q.44-.15.76-.48.18-.19.3-.4M10.5 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 5.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2-5.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1 6.5a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2z"
]);
const $db6ad3fef28672ff$export$45c8f6f6bbe3b93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareSparkle32Regular', "32", [
    "M21.49 8.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2l-.55-1.68a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M7.5 3h13.2q-.12.21-.3.4-.32.33-.76.48L18 4.44q-.52.17-.9.56H7.5A2.5 2.5 0 0 0 5 7.5v17A2.5 2.5 0 0 0 7.5 27h17a2.5 2.5 0 0 0 2.5-2.5v-8.12l.27.82a2 2 0 0 0 .69.94q.47.32 1.04.34v6.02a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3M15 9.5h5.4l.03.03q.01.05.08.11l.08.08q.2.26.31.58l.39 1.2H15a1 1 0 1 1 0-2M10.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2-5.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1 4.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$7e5f2ff01e39fa13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareToolbox20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.5q-.65-.48-1.5-.5h-2c-.82 0-1.54.4-2 1h-2a.5.5 0 0 0 0 1h1.55v.04A2.5 2.5 0 0 0 9 13.5V17H5.75A2.75 2.75 0 0 1 3 14.25zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m3 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$6f16558badcc62c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareToolbox20Regular', "20", [
    "M5.75 3h8.5A2.75 2.75 0 0 1 17 5.75V9.5q-.45-.33-1-.45v-3.3C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75H9v1H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3m3.75 7h2q-.33.45-.45 1H9.5a.5.5 0 0 1 0-1m-2-2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2.5 5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$be02e1537303edb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareWarning16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v4.02l-.7-1.41a2 2 0 0 0-3.59 0l-.2.39H7a.5.5 0 0 0 0 1h2.02l-1 2H7a.5.5 0 0 0 0 1h.52L6.27 14H4.5A2.5 2.5 0 0 1 2 11.5zm3.5.5A.75.75 0 1 0 4 5a.75.75 0 0 0 1.5 0m0 3A.75.75 0 1 0 4 8a.75.75 0 0 0 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6.5 5c0 .28.22.5.5.5h4.5a.5.5 0 0 0 0-1H7a.5.5 0 0 0-.5.5m4.1 2.55a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 15 16H8a1 1 0 0 1-.9-1.45zM12 9.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$6f438b1b71fa5c37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareWarning16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h1.77l.5-1H4.5A1.5 1.5 0 0 1 3 11.5v-7C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v2.17q.16.19.3.44l.7 1.41V4.5A2.5 2.5 0 0 0 11.5 2zM7 11.5h.52l.5-1H7a.5.5 0 0 0 0 1m2.02-3 .5-1H7a.5.5 0 0 0 0 1zM4.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7 4.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zm3.6 3.05a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 15 16H8a1 1 0 0 1-.9-1.45zM12 9.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$f891910ada8e38be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareWarning20Filled', "20", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v5.77l-.7-1.41a2 2 0 0 0-3.53-.11H9.5a.5.5 0 0 0 0 1h2.77l-1 2H9.5a.5.5 0 0 0 0 1h1.27l-1.5 3H5.75A2.75 2.75 0 0 1 3 14.25zM6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m4.6 3.05a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 18 19h-7a1 1 0 0 1-.9-1.45zM15 12.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$5a4ea2bde14bf094 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareWarning20Regular', "20", [
    "M6.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h2.77l.44-.9.06-.1zm0 3h1.77l-.5 1H9.5a.5.5 0 0 1 0-1m-3.75 3h4.02l-.5 1H5.75A2.75 2.75 0 0 1 3 14.25v-8.5A2.75 2.75 0 0 1 5.75 3h8.5A2.75 2.75 0 0 1 17 5.75v5.77l-.7-1.41a2 2 0 0 0-.3-.44V5.75C16 4.78 15.22 4 14.25 4h-8.5C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75m7.85-5.45a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 18 19h-7a1 1 0 0 1-.9-1.45zM15 12.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$871b00f51f9fe710 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareWarning24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v8.65l-1.26-2.52a2.5 2.5 0 0 0-3.34-1.13h-5.15a.75.75 0 1 0 0 1.5h3.83L13.96 15h-2.71a.75.75 0 1 0 0 1.5h1.96l-1.94 3.88q-.15.3-.22.62h-4.8A3.25 3.25 0 0 1 3 17.75zm4.75 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM8.75 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2m8.41-3.92a1.5 1.5 0 0 1 2.69 0l4 8c.5 1-.23 2.17-1.35 2.17h-8a1.5 1.5 0 0 1-1.34-2.17zM18 15.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$11350b2a6dc62bee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListSquareWarning24Regular', "24", [
    "M7.75 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-1.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 3.75a.75.75 0 1 0 0 1.5h3.83l.19-.37c.26-.53.67-.9 1.13-1.13zm0 3.75h2.7l-.74 1.5h-1.96a.75.75 0 1 1 0-1.5m-5 4.5h5.46l-.44.88q-.15.3-.22.62h-4.8A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v8.65l-1.26-2.52a3 3 0 0 0-.24-.39V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75m2.5-7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2m8.41-3.92a1.5 1.5 0 0 1 2.69 0l4 8c.5 1-.23 2.17-1.35 2.17h-8a1.5 1.5 0 0 1-1.34-2.17zM18 15.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$b88f85d10141a30e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListTree16Filled', "16", [
    "M2.25 5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.75 3a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5.75 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM5 8c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8m4.25 3.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$1c6259c08f50b5fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListTree16Regular', "16", [
    "M2 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5.5 3a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM5 8c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 5 8m4.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$3f9428f32bf34164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListTree20Filled', "20", [
    "M3.25 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7 4.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 4.75M7.75 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm4 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM4.5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M7.25 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $db6ad3fef28672ff$export$6413fac5eb915cdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListTree20Regular', "20", [
    "M3 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4.5 4.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm-2.5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$781e832fbd0d376 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListTree24Filled', "24", [
    "M7.5 16.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H11.5a1 1 0 0 1-.12-2zH21zm-8-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21zm-4-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4 .5H21a1 1 0 0 1 .12 2H7.5a1 1 0 0 1-.12-2zH21z"
]);
const $db6ad3fef28672ff$export$cd9374c6115454ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextBulletListTree24Regular', "24", [
    "M7.25 17.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h10.5a.75.75 0 0 1 .1 1.5h-10.6a.75.75 0 0 1-.1-1.5zh10.5zm-7.5-7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5zm-3.5-7a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.5.5h14.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh14.5z"
]);
const $db6ad3fef28672ff$export$ae51e52ec75bddab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseLowercase16Filled', "16", [
    "M9.75 2.25c.41 0 .75.34.75.75v4.3Q11 7 11.6 7c1.44 0 2.6 1.4 2.6 3.13 0 1.72-1.16 3.12-2.6 3.12q-.66 0-1.21-.36A.75.75 0 0 1 9 12.5V3c0-.41.34-.75.75-.75m1.85 9.5c.37 0 1.1-.46 1.1-1.62s-.73-1.63-1.1-1.63c-.36 0-1.1.46-1.1 1.63 0 1.16.74 1.62 1.1 1.62M7.13 8.87v3.8c-.04.09-.13.26-.2.32a.6.6 0 0 1-.35.17H6.5a.6.6 0 0 1-.61-.49q-.9.5-1.72.5c-1.3 0-2.3-.92-2.3-2.3q0-.91.6-1.54.6-.61 1.62-.74a5 5 0 0 1 1.78.1 1 1 0 0 0-.25-.58q-.23-.25-.82-.28-.94-.03-1.28.22a.63.63 0 0 1-.71-1.02 3 3 0 0 1 1.86-.45h.2q1.01.06 1.61.62.6.58.64 1.53zM3.39 10.2a1 1 0 0 0-.27.7q0 .51.3.77.26.26.75.27.62 0 1.6-.62l.1-.08v-1.23l-.1-.03a4 4 0 0 0-1.53-.13q-.59.09-.85.35"
]);
const $db6ad3fef28672ff$export$6db2eb85a121d348 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseLowercase16Regular', "16", [
    "M9.5 2.5c.28 0 .5.22.5.5v4.6q.64-.58 1.5-.6c1.38 0 2.5 1.34 2.5 3s-1.12 3-2.5 3q-.86-.02-1.5-.6v.1a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5m2 9.5c.67 0 1.5-.72 1.5-2s-.83-2-1.5-2-1.5.72-1.5 2 .83 2 1.5 2M7 8.7v3.81a.5.5 0 0 1-.43.49H6.5a.5.5 0 0 1-.5-.43v-.14Q5 13 4.17 13A2.1 2.1 0 0 1 2 10.83c0-1.15.8-2 2.1-2.16a5 5 0 0 1 1.9.14c0-.74-.37-1.1-1.2-1.14q-.94-.05-1.35.24a.5.5 0 0 1-.57-.82q.65-.45 1.79-.43h.19c1.3.07 2.08.83 2.14 2.04M5.8 9.82a4 4 0 0 0-1.57-.13c-.82.1-1.23.53-1.23 1.17 0 .73.47 1.16 1.17 1.16a3 3 0 0 0 1.66-.64l.17-.11v-1.4z"
]);
const $db6ad3fef28672ff$export$7a34de32a7ce9c6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseLowercase20Filled', "20", [
    "M11.75 3.25c.41 0 .75.34.75.75v4.66q.76-.64 1.75-.66c1.66 0 3 1.57 3 3.5s-1.34 3.5-3 3.5q-1-.02-1.75-.66v.16a.75.75 0 0 1-1.5 0V4c0-.41.33-.75.75-.75m2.5 10.25c.62 0 1.5-.67 1.5-2s-.88-2-1.5-2-1.5.67-1.5 2 .88 2 1.5 2m-8.6-4.56a3 3 0 0 0-1.07.23.75.75 0 0 1-.67-1.34 4 4 0 0 1 1.69-.4c.62-.02 1.34.08 1.98.4C9 8.54 9 9.95 9 10.46v4.04a.75.75 0 0 1-1.5.06c-.87.53-1.89.85-2.94.57a2.61 2.61 0 0 1-.73-4.75c.78-.52 1.7-.66 2.53-.61a6 6 0 0 1 1.1.16 1 1 0 0 0-.55-.76c-.35-.18-.8-.25-1.26-.23M7.5 11.5a5 5 0 0 0-1.22-.24c-.63-.03-1.2.09-1.62.36-.92.62-.64 1.8.28 2.06.75.2 1.67-.19 2.56-1z"
]);
const $db6ad3fef28672ff$export$a3d9ca67b540e75c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseLowercase20Regular', "20", [
    "M11.5 3.5c.28 0 .5.22.5.5v4.9c.53-.56 1.23-.9 2-.9 1.66 0 3 1.57 3 3.5S15.66 15 14 15c-.77 0-1.47-.34-2-.9v.4a.5.5 0 0 1-1 0V4c0-.28.22-.5.5-.5M14 14c.97 0 2-.97 2-2.5S14.97 9 14 9s-2 .97-2 2.5 1.03 2.5 2 2.5M5.9 8.69c-.5.02-.92.13-1.18.26a.5.5 0 1 1-.44-.9c.4-.2.98-.34 1.58-.36.6-.03 1.27.07 1.86.36C9 8.7 9 9.96 9 10.46v4.04a.5.5 0 0 1-1 0v-.41c-.91.66-2.01 1.1-3.13.8a2.36 2.36 0 0 1-.65-4.3c.72-.48 1.59-.61 2.38-.57q.75.04 1.4.25c-.02-.48-.12-1.02-.72-1.32-.4-.2-.9-.28-1.39-.26M8 11.33c-.4-.17-.92-.29-1.45-.32-.66-.03-1.3.09-1.77.4-1.12.75-.77 2.21.35 2.5.9.25 1.94-.24 2.87-1.12z"
]);
const $db6ad3fef28672ff$export$5a95ab1aec2d44b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseLowercase24Filled', "24", [
    "M15 4a1 1 0 1 0-2 0v15.25a1 1 0 0 0 2 .1c.61.41 1.34.65 2.11.65 2.27 0 4.11-2.07 4.11-4.62s-1.84-4.63-4.1-4.63q-1.18.02-2.12.66zm2.11 14c-.95 0-2.11-.95-2.11-2.62s1.16-2.63 2.11-2.63 2.11.95 2.11 2.63c0 1.67-1.16 2.62-2.1 2.62M11 19.26v-5.71a3.3 3.3 0 0 0-.98-2.34q-.92-.87-2.47-.95h-.3a4.7 4.7 0 0 0-2.83.68 1 1 0 1 0 1.15 1.64c.33-.23.93-.37 1.88-.32.59.03.96.17 1.19.4q.26.24.34.74a8 8 0 0 0-2.6-.13 4 4 0 0 0-2.47 1.14c-.6.61-.91 1.43-.91 2.35 0 2.1 1.53 3.5 3.5 3.5q1.2 0 2.54-.7c.13.4.5.7.96.7h.13a1 1 0 0 0 .87-1M5 16.8q0-.64.38-1 .38-.39 1.24-.51a6 6 0 0 1 2.26.18l.12.04v1.77l-.14.1q-1.44.93-2.36.92-.71-.01-1.09-.4A1.5 1.5 0 0 1 5 16.8"
]);
const $db6ad3fef28672ff$export$64b5ac6d95cad79e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseLowercase24Regular', "24", [
    "M13.75 3c.41 0 .75.34.75.75v8.24A3.7 3.7 0 0 1 17 11c2.2 0 4 2.01 4 4.5S19.2 20 17 20c-.95 0-1.82-.37-2.5-.99v.24a.75.75 0 0 1-1.5 0V3.75c0-.41.34-.75.75-.75m.75 12.5c0 1.83 1.28 3 2.5 3s2.5-1.17 2.5-3-1.28-3-2.5-3-2.5 1.17-2.5 3m-7-5 .29.01c1.96.1 3.12 1.23 3.2 3.05l.01.2v5.5c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1v-.1a5.6 5.6 0 0 1-2.75.85 3.13 3.13 0 0 1-3.25-3.25c0-1.72 1.19-3 3.16-3.24a8 8 0 0 1 2.84.2c-.01-1.1-.56-1.65-1.79-1.71q-1.44-.06-2.03.36a.75.75 0 1 1-.86-1.22 4.5 4.5 0 0 1 2.68-.65m2 4.82-.3-.09q-1.22-.33-2.36-.19C5.61 15.2 5 15.84 5 16.8c0 1.1.71 1.75 1.75 1.75q1.02 0 2.5-.97l.25-.17z"
]);
const $db6ad3fef28672ff$export$350439d3bbdc4293 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseTitle16Filled', "16", [
    "M5.7 2.74a.75.75 0 0 0-1.4 0l-3.5 9.5a.75.75 0 0 0 1.4.52l.93-2.51h3.74l.93 2.5a.75.75 0 1 0 1.4-.5zm.62 6.01H3.68L5 5.17zm4.18-6.5c.41 0 .75.34.75.75v4.3q.5-.3 1.1-.3c1.44 0 2.6 1.4 2.6 3.13 0 1.72-1.16 3.12-2.6 3.12q-.66 0-1.21-.36a.75.75 0 0 1-1.39-.39V3c0-.41.34-.75.75-.75m.75 7.88c0 1.16.74 1.62 1.1 1.62s1.1-.46 1.1-1.62-.73-1.63-1.1-1.63c-.36 0-1.1.46-1.1 1.63"
]);
const $db6ad3fef28672ff$export$ea330b5905eb35b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseTitle16Regular', "16", [
    "M5 2.5c.21 0 .4.13.47.33l3.5 9.5a.5.5 0 0 1-.94.34L7.05 10h-4.1l-.98 2.67a.5.5 0 0 1-.94-.34l3.5-9.5A.5.5 0 0 1 5 2.5m0 1.95L3.32 9h3.36zm5.5-1.95c.28 0 .5.22.5.5v4.6q.64-.58 1.5-.6c1.38 0 2.5 1.34 2.5 3s-1.12 3-2.5 3q-.86-.02-1.5-.6v.1a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5m2 9.5c.67 0 1.5-.72 1.5-2s-.83-2-1.5-2-1.5.72-1.5 2 .83 2 1.5 2"
]);
const $db6ad3fef28672ff$export$b6188af18086a7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseTitle20Filled', "20", [
    "M12.5 3.25c.41 0 .75.34.75.75v4.66Q14.01 8.02 15 8c1.66 0 3 1.57 3 3.5S16.66 15 15 15q-1-.02-1.75-.66v.16a.75.75 0 0 1-1.5 0V4c0-.41.34-.75.75-.75M15 13.5c.62 0 1.5-.67 1.5-2s-.88-2-1.5-2-1.5.67-1.5 2 .88 2 1.5 2M6.5 3.25c.31 0 .59.2.7.5l3.64 10.5a.75.75 0 1 1-1.41.5l-.78-2.25H4.06l-.86 2.27a.75.75 0 0 1-1.4-.54l3.98-10.5c.12-.3.4-.48.71-.48M4.62 11h3.5L6.45 6.2z"
]);
const $db6ad3fef28672ff$export$f8e8e41f0894bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseTitle20Regular', "20", [
    "M12.5 3.5c.28 0 .5.22.5.5v4.9c.53-.56 1.23-.9 2-.9 1.66 0 3 1.57 3 3.5S16.66 15 15 15c-.77 0-1.47-.34-2-.9v.4a.5.5 0 0 1-1 0V4c0-.28.22-.5.5-.5M15 14c.97 0 2-.97 2-2.5S15.97 9 15 9s-2 .97-2 2.5 1.03 2.5 2 2.5M6.96 3.84a.5.5 0 0 0-.94-.02L3.29 11h-.02v.05l-1.24 3.27a.5.5 0 0 0 .94.36L3.98 12h4.76l.92 2.66a.5.5 0 1 0 .95-.32zM4.36 11l2.1-5.54L8.4 11z"
]);
const $db6ad3fef28672ff$export$de6dd9f56c11b16e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseTitle24Filled', "24", [
    "M8.44 3.42a1 1 0 0 0-1.87-.03l-6 15.5a1 1 0 0 0 1.86.72L3.83 16h6.96l1.27 3.58a1 1 0 0 0 1.88-.66zM4.6 14l2.86-7.37L10.08 14zM16 3a1 1 0 0 1 1 1v7.62q.9-.61 2-.62c2.2 0 4 2.07 4 4.63 0 2.55-1.8 4.62-4 4.62q-1.14-.02-2.06-.66a1 1 0 0 1-1.94-.34V4a1 1 0 0 1 1-1m3 15.25c.84 0 2-.9 2-2.62 0-1.74-1.16-2.63-2-2.63s-2 .9-2 2.63 1.16 2.62 2 2.62"
]);
const $db6ad3fef28672ff$export$c44b014f460772bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseTitle24Regular', "24", [
    "M15.75 3a.75.75 0 0 0-.75.75v15.5a.75.75 0 0 0 1.5 0v-.24c.68.62 1.55.99 2.5.99 2.2 0 4-2.01 4-4.5S21.2 11 19 11c-.95 0-1.82.37-2.5.99V3.75a.75.75 0 0 0-.75-.75m.75 12.5c0-1.83 1.28-3 2.5-3s2.5 1.17 2.5 3-1.28 3-2.5 3-2.5-1.17-2.5-3M7.76 3c.31 0 .6.2.7.5l5.5 15.5a.75.75 0 1 1-1.42.5l-1.42-4H4.01l-1.56 4.02a.75.75 0 1 1-1.4-.54l6-15.5c.11-.3.4-.48.71-.48m-.04 2.9L4.59 14h6z"
]);
const $db6ad3fef28672ff$export$1dd697d6bddcfee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseUppercase16Filled', "16", [
    "M4.5 2.25c.31 0 .6.2.7.5l3.5 9.5a.75.75 0 0 1-1.4.5l-.93-2.5H2.63l-.93 2.5a.75.75 0 1 1-1.4-.5l3.5-9.5c.1-.3.39-.5.7-.5m0 2.92L3.18 8.75h2.64zm5.25-2.92A.75.75 0 0 0 9 3v9.5c0 .41.34.75.75.75h2.5a3.25 3.25 0 0 0 1.57-6.1 3 3 0 0 0-2.32-4.9zm3.25 3c0 .83-.67 1.5-1.5 1.5h-1v-3h1c.83 0 1.5.67 1.5 1.5m-.75 6.5H10.5v-3.5h1.75a1.75 1.75 0 1 1 0 3.5"
]);
const $db6ad3fef28672ff$export$7c801084dbe1737e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseUppercase16Regular', "16", [
    "M4.5 2.5c.21 0 .4.13.47.33l3.5 9.5a.5.5 0 0 1-.94.34L6.55 10h-4.1l-.98 2.67a.5.5 0 0 1-.94-.34l3.5-9.5a.5.5 0 0 1 .47-.33m0 1.95L2.82 9h3.36zm5-1.95A.5.5 0 0 0 9 3v9.5c0 .28.22.5.5.5H12a3 3 0 0 0 1.16-5.77 2.74 2.74 0 0 0-1.91-4.73zM13 5.25C13 6.22 12.22 7 11.25 7H10V3.5h1.25c.97 0 1.75.78 1.75 1.75M12 12h-2V8h2a2 2 0 1 1 0 4"
]);
const $db6ad3fef28672ff$export$e03b49d58c137a0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseUppercase20Filled', "20", [
    "M6.5 3.25c.31 0 .59.2.7.5l3.64 10.5a.75.75 0 1 1-1.41.5l-.78-2.25H4.06l-.86 2.27a.75.75 0 0 1-1.4-.54l3.98-10.5c.12-.3.4-.48.71-.48M4.62 11h3.5L6.45 6.2zM12 3.5a.75.75 0 0 0-.75.75V14.5c0 .41.34.75.75.75h2.75a3.5 3.5 0 0 0 1.71-6.55 3.12 3.12 0 0 0-2.34-5.2zm3.75 3.13c0 .9-.73 1.62-1.62 1.62h-1.38V5h1.38c.9 0 1.62.73 1.62 1.63m-1 7.12h-2v-4h2a2 2 0 1 1 0 4"
]);
const $db6ad3fef28672ff$export$313f5e8549a7439f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseUppercase20Regular', "20", [
    "M6.96 3.84a.5.5 0 0 0-.94-.02L3.29 11h-.02v.05l-1.24 3.27a.5.5 0 0 0 .94.36L3.98 12h4.76l.92 2.66a.5.5 0 1 0 .95-.32zM4.36 11l2.1-5.54L8.4 11zm7.14-7.25a.5.5 0 0 0-.5.5V14.5c0 .28.22.5.5.5h2.75a3.25 3.25 0 0 0 1.3-6.23 2.87 2.87 0 0 0-1.93-5.02zm4 2.88c0 1.03-.84 1.87-1.87 1.87H12V4.75h1.63c1.03 0 1.87.84 1.87 1.88M14.25 14H12V9.5h2.25a2.25 2.25 0 0 1 0 4.5"
]);
const $db6ad3fef28672ff$export$263c3ced5343414d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseUppercase24Filled', "24", [
    "M18 3h-3a1 1 0 0 0-1 1v15.25a1 1 0 0 0 1 1h3.88a4.87 4.87 0 0 0 2.43-9.1A4.74 4.74 0 0 0 18 3m0 7.5h-2V5h2a2.75 2.75 0 1 1 0 5.5m-2 7.75V12.5h2.88a2.88 2.88 0 0 1 0 5.75zM7.26 3a1 1 0 0 1 .93.66l5.5 15.25a1 1 0 0 1-1.88.68L10.51 16H3.8l-1.35 3.6a1 1 0 0 1-1.88-.7L6.31 3.65A1 1 0 0 1 7.26 3M4.55 14h5.24L7.23 6.89z"
]);
const $db6ad3fef28672ff$export$ed58df5a381e06d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCaseUppercase24Regular', "24", [
    "M7.7 3.5a.75.75 0 0 0-1.4-.02l-6 15.5a.75.75 0 1 0 1.4.54l1.56-4.02h7.11l1.42 4a.75.75 0 1 0 1.42-.5zM3.85 14l3.13-8.1L9.84 14zM14.75 3.25A.75.75 0 0 0 14 4v15.25c0 .41.34.75.75.75h4.13a4.63 4.63 0 0 0 2-8.8A4.5 4.5 0 0 0 18 3.26zM21 7.75a3 3 0 0 1-3 3h-2.5v-6H18a3 3 0 0 1 3 3M18.88 18.5H15.5v-6.25h3.38a3.12 3.12 0 1 1 0 6.25"
]);
const $db6ad3fef28672ff$export$e974be809cb5bc56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextChangeCase16Filled', "16", [
    "M11 2.25c.31 0 .6.2.7.5l3.5 9.5a.75.75 0 0 1-1.4.5l-.93-2.5H9.13l-.93 2.5a.75.75 0 1 1-1.4-.5l3.5-9.5c.1-.3.39-.5.7-.5m0 2.92L9.68 8.75h2.64zm-4.87 3.7v3.8c-.04.09-.13.26-.2.32a.6.6 0 0 1-.35.17H5.5a.6.6 0 0 1-.61-.49q-.9.5-1.72.5c-1.3 0-2.3-.92-2.3-2.3q0-.91.6-1.54.6-.61 1.62-.74a5 5 0 0 1 1.78.1 1 1 0 0 0-.25-.58q-.23-.25-.82-.28-.94-.03-1.28.22a.63.63 0 0 1-.71-1.02 3 3 0 0 1 1.86-.45h.2q1.01.06 1.61.62.6.58.64 1.53zM2.38 10.2a1 1 0 0 0-.27.7q0 .51.3.77.26.26.75.27.62 0 1.6-.62l.1-.08v-1.23l-.1-.03a4 4 0 0 0-1.53-.13q-.59.09-.85.35"
]);
const $db6ad3fef28672ff$export$1e175b8f104c3552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextChangeCase16Regular', "16", [
    "M11 2.5c.21 0 .4.13.47.33l3.5 9.5a.5.5 0 0 1-.94.34L13.05 10h-4.1l-.98 2.67a.5.5 0 0 1-.94-.34l3.5-9.5A.5.5 0 0 1 11 2.5m0 1.95L9.32 9h3.36zM6 8.7v3.81a.5.5 0 0 1-.43.49H5.5a.5.5 0 0 1-.5-.43v-.14Q4 13 3.17 13A2.1 2.1 0 0 1 1 10.83c0-1.15.8-2 2.1-2.16a5 5 0 0 1 1.9.14c0-.74-.37-1.1-1.2-1.14q-.94-.05-1.35.24a.5.5 0 0 1-.57-.82q.65-.45 1.79-.43h.19c1.3.07 2.08.83 2.14 2.04M4.8 9.82a4 4 0 0 0-1.57-.13c-.82.1-1.23.53-1.23 1.17 0 .73.47 1.16 1.17 1.16a3 3 0 0 0 1.66-.64l.17-.11v-1.4z"
]);
const $db6ad3fef28672ff$export$9d2dfbb240cfe3fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextChangeCase20Filled', "20", [
    "M13.5 3.25c.3 0 .59.2.7.5l3.64 10.5a.75.75 0 0 1-1.41.5l-.78-2.25h-4.59l-.86 2.27a.75.75 0 1 1-1.4-.54l3.98-10.5c.11-.3.4-.48.71-.48M11.62 11h3.5l-1.68-4.8zM4.9 8.94a3 3 0 0 0-1.07.23.75.75 0 0 1-.67-1.34 4 4 0 0 1 1.69-.4c.62-.02 1.34.08 1.98.4 1.42.71 1.42 2.12 1.42 2.63v4.04a.75.75 0 0 1-1.5.06c-.87.53-1.89.85-2.94.57a2.61 2.61 0 0 1-.73-4.75c.78-.52 1.7-.66 2.53-.61a6 6 0 0 1 1.1.16 1 1 0 0 0-.55-.76c-.35-.18-.8-.25-1.26-.23m1.85 2.56a5 5 0 0 0-1.22-.24c-.63-.03-1.2.09-1.62.36-.92.62-.64 1.8.28 2.06.75.2 1.67-.19 2.56-1z"
]);
const $db6ad3fef28672ff$export$14998c6bcf590052 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextChangeCase20Regular', "20", [
    "M13.5 3.5c.2 0 .39.14.46.34l3.65 10.5a.5.5 0 0 1-.95.32L15.74 12h-4.76l-1.01 2.68a.5.5 0 0 1-.93.01l.24-1.03 1-2.6V11h.01l2.73-7.18a.5.5 0 0 1 .47-.32m-.04 1.96L11.36 11h4.03zM4.9 8.7c-.48.02-.9.13-1.17.26a.5.5 0 0 1-.44-.9c.4-.2.98-.34 1.58-.36.6-.03 1.27.07 1.86.36C8 8.7 8 9.96 8 10.46v4.04a.5.5 0 0 1-1 0v-.41c-.91.66-2.01 1.1-3.13.8a2.36 2.36 0 0 1-.65-4.3c.72-.48 1.59-.61 2.38-.57q.75.04 1.4.25c-.02-.48-.12-1.02-.72-1.32-.4-.2-.9-.28-1.39-.26M7 11.33c-.4-.17-.92-.29-1.45-.32-.66-.03-1.3.09-1.77.4-1.12.75-.77 2.21.35 2.5.9.25 1.94-.24 2.87-1.12z"
]);
const $db6ad3fef28672ff$export$a3d19ed2bbfbde2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextChangeCase24Filled', "24", [
    "M16.51 2.75a1 1 0 0 1 .93.67l5.5 15.5a1 1 0 0 1-1.88.66L19.79 16h-6.96l-1.4 3.61a1 1 0 0 1-1.86-.72l6-15.5a1 1 0 0 1 .94-.64m-.05 3.88L13.6 14h5.48zM8.25 20.26a1 1 0 0 1-.96-.7q-1.33.7-2.54.7c-1.97 0-3.5-1.4-3.5-3.5 0-.92.32-1.74.91-2.35a4 4 0 0 1 2.47-1.14 8 8 0 0 1 2.6.13 1.2 1.2 0 0 0-.34-.75c-.23-.22-.6-.36-1.19-.4-.95-.04-1.55.1-1.88.33a1 1 0 1 1-1.15-1.64 4.7 4.7 0 0 1 2.83-.69l.3.01q1.55.08 2.47.95.9.87.98 2.33v5.72a1 1 0 0 1-.86 1h-.14m-3.38-4.97q-.86.12-1.24.5t-.38 1q.02.75.41 1.11.38.39 1.09.4.91.01 2.36-.92l.14-.1v-1.77l-.12-.04a6 6 0 0 0-2.26-.18"
]);
const $db6ad3fef28672ff$export$c2e36a96c3a306af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextChangeCase24Regular', "24", [
    "M16.51 3c.31 0 .6.2.7.5L22.7 19a.75.75 0 0 1-1.42.5l-1.42-4h-7.11l-1.56 4.02a.75.75 0 1 1-1.4-.54l6-15.5c.11-.3.4-.48.71-.48m-.04 2.9L13.34 14h6zM5.5 10.5l.29.01c1.96.1 3.12 1.23 3.2 3.05l.01.2v5.5c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1v-.1a5.6 5.6 0 0 1-2.75.85 3.13 3.13 0 0 1-3.25-3.25c0-1.72 1.19-3 3.16-3.24a8 8 0 0 1 2.84.2c-.01-1.1-.56-1.65-1.79-1.71q-1.44-.06-2.03.36a.75.75 0 1 1-.86-1.22 4.5 4.5 0 0 1 2.68-.65m2 4.82-.3-.09q-1.22-.33-2.36-.19C3.61 15.2 3 15.84 3 16.8c0 1.1.71 1.75 1.75 1.75q1.02 0 2.5-.97l.25-.17z"
]);
const $db6ad3fef28672ff$export$f83720ffbd3be75e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting16Filled', "16", [
    "M4.5 1c.2 0 .38.12.46.3l2.88 6.73-.75.76-.05-.1L6.31 7H2.7l-.73 1.7a.5.5 0 0 1-.92-.4l3-7A.5.5 0 0 1 4.5 1m1.38 5L4.5 2.77 3.12 6zm8.43.2V6c0-1.82-.95-3-2.42-3a2 2 0 0 0-1.82 1.02H10V1.5a.5.5 0 1 0-1 0v5.38l1-1v-.4c.15-1.03.76-1.65 1.67-1.65.86 0 1.43.53 1.62 1.44q.25.15.48.38zm-1.25.15a1.5 1.5 0 0 0-2.12 0l-4.59 4.59a1.5 1.5 0 0 0 0 2.12l1.59 1.59A1.5 1.5 0 0 0 9.5 15h3a.5.5 0 0 0 0-1h-1.8l3.95-3.94a1.5 1.5 0 0 0 0-2.12zM8 10.71 10.3 13l-.95.94a.5.5 0 0 1-.7 0l-1.59-1.59a.5.5 0 0 1 0-.7z"
]);
const $db6ad3fef28672ff$export$d822c24a3110d772 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting16Regular', "16", [
    "M4.5 1c.2 0 .38.12.46.3l2.88 6.73-.75.76-.05-.1L6.31 7H2.7l-.73 1.7a.5.5 0 0 1-.92-.4l3-7A.5.5 0 0 1 4.5 1m1.38 5L4.5 2.77 3.12 6zm8.43.2V6c0-1.82-.95-3-2.42-3a2 2 0 0 0-1.82 1.02H10V1.5a.5.5 0 1 0-1 0v5.38l1-1v-.4c.15-1.03.76-1.65 1.67-1.65.86 0 1.43.53 1.62 1.44q.25.15.48.38zM9.51 15a1.5 1.5 0 0 1-1.57-.35l-1.59-1.59a1.5 1.5 0 0 1 0-2.12l4.59-4.59a1.5 1.5 0 0 1 2.12 0l1.59 1.59a1.5 1.5 0 0 1 0 2.12l-3.29 3.29-.01.01-.64.64h1.79a.5.5 0 0 1 0 1zm.78-2L8 10.7l-.94.95a.5.5 0 0 0 0 .7l1.59 1.59c.2.2.5.2.7 0zm.71-.7 2.94-2.95a.5.5 0 0 0 0-.7l-1.59-1.59a.5.5 0 0 0-.7 0L8.7 10z"
]);
const $db6ad3fef28672ff$export$1d407d59ab0843f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting20Filled', "20", [
    "M6 2c.2 0 .4.13.47.32l3.5 8.95a.5.5 0 0 1-.94.37L8.01 9H4l-1.04 2.68a.5.5 0 1 1-.94-.36l3.5-9A.5.5 0 0 1 6 2m0 1.88L4.4 8H7.6zM11.5 2c.28 0 .5.22.5.5v3.52a2.5 2.5 0 0 1 2.26-1.3q1.33 0 2.15 1 .82.99.82 2.64l-.01.42-.05-.05a2.5 2.5 0 0 0-1.15-.65 3 3 0 0 0-.53-1.62q-.54-.7-1.48-.7-.9 0-1.47.72-.44.56-.54 1.37v1.03q.08.64.37 1.12L11 11.37V2.5c0-.28.22-.5.5-.5m4.97 7.44 2.1 2.1a1.5 1.5 0 0 1-.01 2.12l-3.6 3.6-4.21-4.22 3.6-3.6a1.5 1.5 0 0 1 2.12 0m-2.22 8.52-4.21-4.21-.6.6a1.5 1.5 0 0 0 0 2.12l2.1 2.1c.3.3.71.45 1.12.43h4.09a.5.5 0 1 0 0-1h-2.53z"
]);
const $db6ad3fef28672ff$export$1390a2da515c173b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting20Regular', "20", [
    "M6 2c.2 0 .4.13.47.32l3.5 8.95a.5.5 0 0 1-.94.37L8.01 9H4l-1.04 2.68a.5.5 0 1 1-.94-.36l3.5-9A.5.5 0 0 1 6 2m0 1.88L4.4 8H7.6zM11.5 2c.28 0 .5.22.5.5v3.52a2.5 2.5 0 0 1 2.26-1.3q1.33 0 2.15 1 .82.99.82 2.64l-.01.42-.05-.05a2.5 2.5 0 0 0-1.15-.65 3 3 0 0 0-.53-1.62q-.54-.7-1.48-.7-.9 0-1.47.72-.44.56-.54 1.37v1.03q.08.64.37 1.12L11 11.37V2.5c0-.28.22-.5.5-.5M9.44 16.47a1.5 1.5 0 0 1 0-2.13l4.9-4.9a1.5 1.5 0 0 1 2.13 0l2.1 2.1a1.5 1.5 0 0 1-.01 2.12L14.22 18h2.53a.5.5 0 1 1 0 1h-4.1a1.5 1.5 0 0 1-1.12-.44zm5.61-6.32-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 0 0 0-.7l-2.1-2.1a.5.5 0 0 0-.7 0m-1.5 7.1-2.8-2.8-.6.6a.5.5 0 0 0 0 .7l2.1 2.1c.19.2.5.2.7 0z"
]);
const $db6ad3fef28672ff$export$d5735439d84f6df1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting24Filled', "24", [
    "M2.76 14a1 1 0 0 1-.55-.18.6.6 0 0 1-.21-.46q0-.17.1-.41L6.01 2.7q.27-.7 1-.7.68-.01.95.7l3.94 10.24q.09.25.09.4 0 .3-.22.47a.8.8 0 0 1-.54.18q-.54 0-.75-.56l-1.08-2.92H4.58l-1.07 2.92q-.21.56-.75.56m2.26-4.73h3.96L7.03 3.9h-.06zm7.77 5.46 5.48 5.48 4.16-4.16c.76-.76.76-2 0-2.75l-2.72-2.73a1.95 1.95 0 0 0-2.76 0zm1.96-3.37L13 13.1V2.76q0-.33.2-.55.2-.2.5-.2.32 0 .5.2.21.2.21.55v4.07h.03a3 3 0 0 1 2.71-1.56q1.6 0 2.58 1.2.99 1.19.99 3.17l-.02.51-.29-.29a3 3 0 0 0-1.16-.71 3.3 3.3 0 0 0-.63-1.8 2.1 2.1 0 0 0-1.77-.84q-1.08 0-1.76.87a3.5 3.5 0 0 0-.69 2.26q0 1 .35 1.72m2.46 9.91-5.48-5.48-1.16 1.16c-.76.76-.76 2 0 2.76l2.72 2.72q.53.51 1.21.56V23H20a.75.75 0 1 0 0-1.5h-3.02z"
]);
const $db6ad3fef28672ff$export$c3eb0f7f9cc240c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting24Regular', "24", [
    "M2.21 13.82q.22.18.55.18.54 0 .75-.56l1.07-2.92h4.83l1.08 2.92q.21.56.75.56a.8.8 0 0 0 .54-.18.6.6 0 0 0 .22-.46q0-.17-.1-.41L7.98 2.7Q7.7 2 7.02 2q-.73 0-1 .71L2.09 12.95q-.09.25-.09.4 0 .29.21.47m6.77-4.55H5.02L6.97 3.9h.06zM13 13.1l1.75-1.75a4 4 0 0 1-.35-1.73q0-1.4.69-2.25a2.2 2.2 0 0 1 1.76-.87q1.13 0 1.77.84.54.7.63 1.8.66.21 1.16.71l.29.29.02-.52q0-1.97-.99-3.17a3.2 3.2 0 0 0-2.58-1.19q-.88 0-1.6.41-.7.42-1.1 1.15h-.04V2.75q0-.33-.2-.54a.7.7 0 0 0-.5-.21q-.31 0-.52.21a.8.8 0 0 0-.19.54zm3.98 8.39H20a.75.75 0 1 1 0 1.5h-5.5a2 2 0 0 1-1.2-.57l-2.73-2.72c-.76-.77-.76-2 0-2.76l6.38-6.38c.76-.76 2-.76 2.76 0l2.72 2.72c.76.77.76 2 0 2.76zm1.03-9.87-4.16 4.16 3.36 3.36 4.16-4.16a.45.45 0 0 0 0-.63l-2.72-2.73a.45.45 0 0 0-.64 0m-5.22 5.22-1.16 1.16a.45.45 0 0 0 0 .63l2.73 2.73c.17.17.46.17.63 0l1.16-1.16z"
]);
const $db6ad3fef28672ff$export$bed850e00576c0a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting32Filled', "32", [
    "m22.5 27.92-.09.08H27a1 1 0 1 1 0 2h-8.08a3.4 3.4 0 0 1-2.34-1l-2.57-2.58a3.4 3.4 0 0 1 0-4.84l1.08-1.08zM21.58 14a3.4 3.4 0 0 1 4.84 0L29 16.58a3.4 3.4 0 0 1 0 4.84L23.9 26.5 16.5 19.1zM8.5 2a1 1 0 0 1 .93.63l5.5 14a1 1 0 0 1-1.86.74L11.75 14h-6.5l-1.32 3.37a1 1 0 0 1-1.86-.74l5.5-14c.18-.36.5-.63.93-.63M18 2a1 1 0 0 1 1 1v5.1A4.7 4.7 0 0 1 22 7c2.87 0 5 2.58 5 5.5v.02a5 5 0 0 0-2.1-.93C24.54 10.03 23.3 9 22 9c-1.55 0-3 1.45-3 3.5q0 .9.34 1.62L17 16.46V3a1 1 0 0 1 1-1M6.04 12h4.92L8.5 5.73z"
]);
const $db6ad3fef28672ff$export$3d214940794f4cff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting32Light', "32", [
    "M18 2.5a.5.5 0 0 0-1 0v14.17l1.62-1.62A5.4 5.4 0 0 1 18 12.5C18 9.9 19.67 8 21.5 8c1.61 0 3.1 1.47 3.43 3.6q.54.11 1.05.37C25.76 9.27 23.93 7 21.5 7A4.2 4.2 0 0 0 18 9.04zm-8.56.15a1 1 0 0 0-1.88 0L2.03 17.32a.5.5 0 1 0 .94.36L4.73 13h7.54l1.76 4.68a.5.5 0 0 0 .94-.36zM11.89 12H5.11L8.5 3zm14.17 1.85a2.9 2.9 0 0 0-4.12 0l-8.09 8.1a2.9 2.9 0 0 0 0 4.1l3.1 3.1c.59.6 1.37.88 2.15.85h7.4a.5.5 0 1 0 0-1h-5.3l7.95-7.94a2.9 2.9 0 0 0 0-4.12zM19 29h-.04c-.47 0-.95-.2-1.31-.56l-3.1-3.09a1.9 1.9 0 0 1 0-2.7l1.7-1.7 5.8 5.8-1.7 1.7c-.35.34-.8.53-1.27.55zm3.65-14.44a1.9 1.9 0 0 1 2.7 0l3.1 3.09c.74.75.74 1.95 0 2.7l-5.7 5.7-5.8-5.8z"
]);
const $db6ad3fef28672ff$export$3c0a1eef4d9ea6e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextClearFormatting32Regular', "32", [
    "M21.58 14a3.4 3.4 0 0 1 4.84 0L29 16.58a3.4 3.4 0 0 1 0 4.84L22.4 28H27a1 1 0 1 1 0 2h-8.08a3.4 3.4 0 0 1-2.34-1L14 26.42a3.4 3.4 0 0 1 0-4.84zm-6.16 9a1.4 1.4 0 0 0 0 2L18 27.58c.55.56 1.45.56 2 0l1.09-1.08-4.59-4.59zM25 15.42a1.4 1.4 0 0 0-2 0L17.9 20.5l4.59 4.59L27.58 20c.56-.55.56-1.45 0-2zM8.5 2a1 1 0 0 1 .93.63l5.5 14a1 1 0 0 1-1.86.74L11.75 14h-6.5l-1.32 3.37a1 1 0 0 1-1.86-.74l5.5-14c.18-.36.5-.63.93-.63M18 2a1 1 0 0 1 1 1v5.1A4.7 4.7 0 0 1 22 7c2.87 0 5 2.58 5 5.5v.02a5 5 0 0 0-2.1-.93C24.54 10.03 23.3 9 22 9c-1.55 0-3 1.45-3 3.5q0 .9.34 1.62L17 16.46V3a1 1 0 0 1 1-1M6.04 12h4.92L8.5 5.73z"
]);
const $db6ad3fef28672ff$export$b58f40a9d3bacbdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse16Filled', "16", [
    "M13.25 12.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm-8.75-8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M3 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM13.25 9a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zm0-3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zm0-3.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$f16adfac24be9203 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse16Regular', "16", [
    "M13.5 13a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1zm-9-8.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M3 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM13.5 9a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0-3a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$323ed4913d9c246e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse20Filled', "20", [
    "M17.25 15a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zM4.5 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M2.75 9a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1zm14.5 2a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zm0-4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zm0-4a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$c81c091c17918ee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse20Regular', "20", [
    "M17.5 15a.5.5 0 0 1 0 1h-14a.5.5 0 0 1 0-1zm-13-9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M2.75 9a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1zm14.75 2a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-14a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$3d90b3edb84297b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse24Filled', "24", [
    "M21 18a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zM6.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM21 13a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$b4eba5b0bdb43347 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse24Regular', "24", [
    "M21.25 18a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5zM6.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm16.75 2a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm0-5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm0-5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$61c580f44f689dfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse28Filled', "28", [
    "M25 22a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM7.5 8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zM25 16a1 1 0 1 1 0 2h-9a1 1 0 1 1 0-2zm0-6a1 1 0 1 1 0 2h-9a1 1 0 1 1 0-2zm0-6a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$d0b2d796be019868 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse28Regular', "28", [
    "M25.25 22a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5zM7.5 8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm20.75 3a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0-6a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0-6a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$5f7fdab8971fea8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse32Filled', "32", [
    "M28.75 25a1.25 1.25 0 1 1 0 2.5H8.25a1.25 1.25 0 1 1 0-2.5zm-20-16a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m-3 6a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm23 3a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5zm0-7a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5zm0-7a1.25 1.25 0 1 1 0 2.5H8.25a1.25 1.25 0 1 1 0-2.5z"
]);
const $db6ad3fef28672ff$export$1920713721b5ffeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse32Light', "32", [
    "M29.5 26a.5.5 0 0 1 0 1h-22a.5.5 0 0 1 0-1zM8.75 9a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m-3 6a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm23.75 4a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm0-8a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm0-7a.5.5 0 0 1 0 1h-22a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$72a78dfb121d5d2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextCollapse32Regular', "32", [
    "M29 25a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zM8.75 9a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m-3 6a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM29 18a1 1 0 1 1 0 2H19a1 1 0 1 1 0-2zm0-7a1 1 0 1 1 0 2H19a1 1 0 1 1 0-2zm0-7a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$3a5bfb87e6b873a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColor16Filled', "16", [
    "M12.5 10c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5v-2c0-.83.67-1.5 1.5-1.5zM8 .5c.3 0 .57.18.69.45l3 7a.75.75 0 0 1-1.38.6L9.65 7h-3.3L5.7 8.55a.75.75 0 0 1-1.38-.6l3-7 .05-.1A.8.8 0 0 1 8 .5m-1 5h2L8 3.15z"
]);
const $db6ad3fef28672ff$export$88b48c3ac5153dcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColor16Regular', "16", [
    "M8.46 1.3a.5.5 0 0 0-.92 0l-3 7a.5.5 0 1 0 .92.4L6.19 7H9.8l.73 1.7a.5.5 0 1 0 .92-.4zM9.38 6H6.62L8 2.77zM3.5 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5zM3 11.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"
]);
const $db6ad3fef28672ff$export$aa16b20e5fcd0c62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColor20Filled', "20", [
    "M15.5 12c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 16.5v-3c0-.83.67-1.5 1.5-1.5zM10 1.5c.3 0 .58.19.7.47l3 7.5a.75.75 0 0 1-1.4.56L11.5 8h-3l-.8 2.03a.75.75 0 1 1-1.4-.56l3-7.5.05-.1A.8.8 0 0 1 10 1.5m-.9 5h1.8L10 4.27z"
]);
const $db6ad3fef28672ff$export$158f5c4c6f7494d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColor20Regular', "20", [
    "M10.46 2.31a.5.5 0 0 0-.92 0l-3 7.5a.5.5 0 1 0 .92.38L8.54 7.5h2.92l1.08 2.69a.5.5 0 1 0 .92-.38zM10 3.85l1.06 2.65H8.94zM4.5 12c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM4 13.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5z"
]);
const $db6ad3fef28672ff$export$ae0bb6c6fbf96ce9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColor24Filled', "24", [
    "M18.75 15c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25H5.25C4.01 22 3 21 3 19.75v-2.5C3 16.01 4 15 5.25 15zM12 1.5a1 1 0 0 1 .93.63l3.75 9.5a1 1 0 1 1-1.86.74L13.89 10H10.1l-.93 2.37a1 1 0 1 1-1.86-.74l3.75-9.5.07-.13a1 1 0 0 1 .86-.5M10.9 8h2.2L12 5.22z"
]);
const $db6ad3fef28672ff$export$5ab1b16b83af3ffe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColor24Regular', "24", [
    "M18.75 15c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25H5.25C4.01 22 3 21 3 19.75v-2.5C3 16.01 4 15 5.25 15zm-13.5 1.5a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75h13.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75zM12 2c.3 0 .58.19.7.47l3.75 9.5a.75.75 0 0 1-1.4.56l-1-2.53H9.94l-1 2.53a.75.75 0 1 1-1.39-.56l3.75-9.5.05-.1A.8.8 0 0 1 12 2m-1.46 6.5h2.92L12 4.8z"
]);
const $db6ad3fef28672ff$export$1c07c182d00820da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColorAccent16Filled', "16", [
    "M2.5 11.17c0-.37.25-.67.55-.67h9.9c.3 0 .55.3.55.67v2.66c0 .37-.25.67-.55.67h-9.9c-.3 0-.55-.3-.55-.67z"
]);
const $db6ad3fef28672ff$export$531808f13a6a6315 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColorAccent20Filled', "20", [
    "M3.5 13.13c0-.35.24-.63.54-.63h11.92c.3 0 .54.28.54.63v3.74c0 .35-.24.63-.54.63H4.04c-.3 0-.54-.28-.54-.62z"
]);
const $db6ad3fef28672ff$export$c8bce145734e4b92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColorAccent24Filled', "24", [
    "M18.75 15.75c.83 0 1.5.67 1.5 1.5v2.5c0 .83-.67 1.5-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-2.5c0-.83.67-1.5 1.5-1.5z"
]);
const $db6ad3fef28672ff$export$248dfdbe5bb45d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOne20Filled', "20", [
    "M15 5.75a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5c.41 0 .75-.34.75-.75"
]);
const $db6ad3fef28672ff$export$dfc64c1c085f7d84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOne20Regular', "20", [
    "M15 5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 .5-.5"
]);
const $db6ad3fef28672ff$export$bfdff021a73d9a73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOne24Filled', "24", [
    "M5 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$92a52e54048de26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOne24Regular', "24", [
    "M5 5.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 5.75m0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 9.75m0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75m0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$d032718ca8bb7d39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneNarrow20Filled', "20", [
    "M7.75 5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM7 11.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M7.75 14a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$b9400dbb5ebda5e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneNarrow20Regular', "20", [
    "M7.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM7 11.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$e96ca73d5daf2376 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneNarrow24Filled', "24", [
    "M9 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$de3e9b5cb6a82b8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneNarrow24Regular', "24", [
    "M8.75 5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM8 13.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75M8.75 17a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$37555ec467d4760b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneSemiNarrow20Filled', "20", [
    "M6.75 5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM6 11.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75M6.75 14a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$63c563454e79b3f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneSemiNarrow20Regular', "20", [
    "M6.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 11.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$7e651f6a1d858fc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneSemiNarrow24Filled', "24", [
    "M8 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$fb115d02275ec9bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneSemiNarrow24Regular', "24", [
    "M7.75 5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM7 13.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75M7.75 17a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$cbf18cedf7917652 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWide20Filled', "20", [
    "M3.75 5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zM3 11.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M3.75 14a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$d0af52ed3553fc69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWide20Regular', "20", [
    "M3.5 5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM3 11.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$ef471a10d2c8c41f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWide24Filled', "24", [
    "M4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$c785db5ebd26f10a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWide24Regular', "24", [
    "M3.75 5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM3 13.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M3.75 17a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$300224d4bdc2829a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWideLightning16Filled', "16", [
    "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h6.21l.24-.58A1.5 1.5 0 0 1 10.58 6zm0 3h5.58l-.62 1.5H2.75a.75.75 0 0 1 0-1.5m0 3h4.34a1.5 1.5 0 0 0 .3 1.5H2.74a.75.75 0 0 1 0-1.5m5.75 1.01h1.75l-.59 2.37c-.12.48.46.82.83.48l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.35a.5.5 0 0 0-.47-.66h-3.48a.5.5 0 0 0-.46.3l-2.08 5.02c-.14.33.1.7.46.7"
]);
const $db6ad3fef28672ff$export$c6dcae829c781c81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWideLightning16Regular', "16", [
    "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h6.67l.03-.08A1.5 1.5 0 0 1 10.58 6zm0 3h5.83l-.41 1H2.5a.5.5 0 0 1 0-1m0 3h4.59q-.17.53 0 1H2.5a.5.5 0 0 1 0-1m6 1.01h1.75l-.59 2.37c-.12.48.46.82.83.48l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.35a.5.5 0 0 0-.47-.66h-3.48a.5.5 0 0 0-.46.3l-2.08 5.02c-.14.33.1.7.46.7"
]);
const $db6ad3fef28672ff$export$6adcd8945d0e4104 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWideLightning20Filled', "20", [
    "M3 5.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.75m0 3c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 8.75M3.75 11a.75.75 0 0 0 0 1.5h7.8l.62-1.5zm7.17 3-.63 1.5H3.75a.75.75 0 0 1 0-1.5zm.58 3.01h1.75l-.59 2.37c-.12.48.46.82.83.48l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.35a.5.5 0 0 0-.47-.66h-3.48a.5.5 0 0 0-.46.3l-2.08 5.02c-.14.33.1.7.46.7"
]);
const $db6ad3fef28672ff$export$d18050800a339c80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWideLightning20Regular', "20", [
    "M3.5 5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 7h7l.42-1H3.5a.5.5 0 0 0 0 1m8.67-4-.42 1H3.5a.5.5 0 0 1 0-1zm-.67 6.01h1.75l-.59 2.37c-.12.48.46.82.83.48l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.35a.5.5 0 0 0-.47-.66h-3.48a.5.5 0 0 0-.46.3l-2.08 5.02c-.14.33.1.7.46.7"
]);
const $db6ad3fef28672ff$export$5aa302ab26f86df9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWideLightning24Filled', "24", [
    "M4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h9.4l.06-.14a1.5 1.5 0 0 1 1.36-.86H21a1 1 0 0 0-1-1zm0 4h8.45l-.95 2H4a1 1 0 1 1 0-2m0 4h6.55l-.4.86c-.19.38-.19.79-.06 1.14H4a1 1 0 1 1 0-2m10.81-6h6.32a.5.5 0 0 1 .44.75l-1.83 3.27h1.51c.64 0 .99.75.57 1.24l-6.4 7.48c-.53.61-1.5.05-1.25-.7l1.32-4H11.5a.5.5 0 0 1-.45-.73l3.31-7.02a.5.5 0 0 1 .45-.29"
]);
const $db6ad3fef28672ff$export$a51c6cd7106a19e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnOneWideLightning24Regular', "24", [
    "M3.75 5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h9.95c.28-.31.68-.5 1.12-.5h6.14a.75.75 0 0 0-.7-1zm8.7 4-.71 1.5H3.75a.75.75 0 0 1 0-1.5zm-1.9 4-.4.86q-.15.31-.15.64H3.75a.75.75 0 0 1 0-1.5zm4.26-6h6.32a.5.5 0 0 1 .44.75l-1.83 3.27h1.51c.64 0 .99.75.57 1.24l-6.4 7.48c-.53.61-1.5.05-1.25-.7l1.32-4H11.5a.5.5 0 0 1-.45-.73l3.31-7.02a.5.5 0 0 1 .45-.29"
]);
const $db6ad3fef28672ff$export$10d5e7c45f2b50ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnThree20Filled', "20", [
    "M12 5.75a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 0a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-10 0A.75.75 0 0 0 6.25 5h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 3a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 0a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-10 0A.75.75 0 0 0 6.25 8h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 3a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 0a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-10 0a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 3a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m5 0a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-10 0a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75"
]);
const $db6ad3fef28672ff$export$2ca4386e7ea8a21a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnThree20Regular', "20", [
    "M12 5.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-10 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-10 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-10 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m5 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-10 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5"
]);
const $db6ad3fef28672ff$export$be4f87dc6787b028 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnThree24Filled', "24", [
    "M3 6a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1m6.58 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M16 6a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M3 10a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1m6.58 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M16 10a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M3 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m6.58 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M16 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M3 18a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m6.58 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M16 18a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$bfd994087cc27e0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnThree24Regular', "24", [
    "M3 5.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 3 5.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m-13 4c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 3 9.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m-13 4c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m-13 4c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$fc4aef3024dce513 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwo20Filled', "20", [
    "M17 5.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m-8 0A.75.75 0 0 0 8.25 5h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m8 3a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m-8 0A.75.75 0 0 0 8.25 8h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m8 3a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m-8 0a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m8 3a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75m-8 0a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5c.41 0 .75-.34.75-.75"
]);
const $db6ad3fef28672ff$export$dbcb7f608315d04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwo20Regular', "20", [
    "M17 5.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-8 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m8 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-8 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m8 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-8 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m8 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-8 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5"
]);
const $db6ad3fef28672ff$export$6eefca64b0acbd5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwo24Filled', "24", [
    "M3 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1M13 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$e150e096d7afe82c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwo24Regular', "24", [
    "M3 5.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 3 5.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 3 9.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m10-12c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m0 4c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$c7404fdb81a9e886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoLeft20Filled', "20", [
    "M3 5.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 3 5.75m6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 9 5.75m-6 3c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 3 8.75m6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 9 8.75m-6 3c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m-6 3c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$5db68f2e8b30f739 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoLeft20Regular', "20", [
    "M3 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-6 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-6 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-6 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$6308ed220076cc99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoLeft24Filled', "24", [
    "M21 6a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h9a1 1 0 0 0 1-1M8 6a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1m13 4a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h9a1 1 0 0 0 1-1M8 10a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1m13 4a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h9a1 1 0 0 0 1-1M8 14a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1m13 4a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h9a1 1 0 0 0 1-1M8 18a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1"
]);
const $db6ad3fef28672ff$export$9494dd935ab69792 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoLeft24Regular', "24", [
    "M21 5.75a.75.75 0 0 0-.75-.75h-9.5a.75.75 0 0 0 0 1.5h9.5c.41 0 .75-.34.75-.75m-13 0A.75.75 0 0 0 7.25 5h-3.5a.75.75 0 0 0 0 1.5h3.5c.41 0 .75-.34.75-.75m13 4a.75.75 0 0 0-.75-.75h-9.5a.75.75 0 0 0 0 1.5h9.5c.41 0 .75-.34.75-.75m-13 0A.75.75 0 0 0 7.25 9h-3.5a.75.75 0 0 0 0 1.5h3.5c.41 0 .75-.34.75-.75m13 4a.75.75 0 0 0-.75-.75h-9.5a.75.75 0 0 0 0 1.5h9.5c.41 0 .75-.34.75-.75m-13 0a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0 0 1.5h3.5c.41 0 .75-.34.75-.75m13 4a.75.75 0 0 0-.75-.75h-9.5a.75.75 0 0 0 0 1.5h9.5c.41 0 .75-.34.75-.75m-13 0a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0 0 1.5h3.5c.41 0 .75-.34.75-.75"
]);
const $db6ad3fef28672ff$export$ca273b954bca33f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoRight20Filled', "20", [
    "M17 5.75a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-6 0a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5c.41 0 .75-.34.75-.75m6 3a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-6 0a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5c.41 0 .75-.34.75-.75m6 3a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-6 0a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5c.41 0 .75-.34.75-.75m6 3a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75m-6 0a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5c.41 0 .75-.34.75-.75"
]);
const $db6ad3fef28672ff$export$a7b59f99b427635c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoRight20Regular', "20", [
    "M17 5.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-6 0a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5m6 3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-6 0a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5m6 3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-6 0a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5m6 3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m-6 0a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5"
]);
const $db6ad3fef28672ff$export$e82e3cc0cec2f85b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoRight24Filled', "24", [
    "M3 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m13 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M3 10a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m13 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M3 14a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m13 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M3 18a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m13 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$27d083595bafbeb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnTwoRight24Regular', "24", [
    "M3 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3 5.75m13 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m-13 4c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3 9.75m13 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m-13 4c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75m13 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m-13 4c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75m13 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$256d5186582033e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnWide20Filled', "20", [
    "M3.75 5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zM3 11.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M3.75 14a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$d6d61e2c60882113 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnWide20Regular', "20", [
    "M3.5 5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM3 11.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$1eb5dbc316990c72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnWide24Filled', "24", [
    "M4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$5fcc154998597cd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextColumnWide24Regular', "24", [
    "M3.75 5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM3 13.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M3.75 17a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$2884387a63b199b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextContinuous20Filled', "20", [
    "M2 5.5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.5m0 9c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 14.5m2.78-5.03-1.5-1.5a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 1 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06M7 8.5c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 7 8.5m.75 2.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$293f2c0121a36f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextContinuous20Regular', "20", [
    "M2 5.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 9c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m1.35-6.35a.5.5 0 1 0-.7.7L3.79 10l-1.14 1.15a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zM7.5 8h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1m0 3a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$5675ea960167d2a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextContinuous24Filled', "24", [
    "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m5 4a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m12 5H4a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2M3.3 11.2a1 1 0 0 1 1.4-1.4l1.5 1.5a1 1 0 0 1 0 1.4l-1.5 1.5a1 1 0 0 1-1.4-1.4l.79-.8z"
]);
const $db6ad3fef28672ff$export$c9305135cf5228c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextContinuous24Regular', "24", [
    "M3.75 5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm5 4a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5zM8 13.75c0-.41.34-.75.75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75M3.75 17a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm-.53-5.97a.75.75 0 1 1 1.06-1.06l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 0 1-1.06-1.06l.97-.97z"
]);
const $db6ad3fef28672ff$export$960dfc2459b4f2ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity16Filled', "16", [
    "M8.5 1c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5M7 3H2.5a.5.5 0 0 0 0 1H7zm0 3H2.5a.5.5 0 0 0 0 1H7zm0 3H2.5a.5.5 0 0 0 0 1H7zm0 3H2.5a.5.5 0 0 0 0 1H7zm5.5 0H10V9h2.5a1.5 1.5 0 0 1 0 3m0-5H10V4h2.5a1.5 1.5 0 0 1 0 3"
]);
const $db6ad3fef28672ff$export$d5565fb256303701 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity16Regular', "16", [
    "M8.5 1c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5M7 3H2.5a.5.5 0 0 0 0 1H7zm0 3H2.5a.5.5 0 0 0 0 1H7zm0 3H2.5a.5.5 0 0 0 0 1H7zm0 3H2.5a.5.5 0 0 0 0 1H7zm5.5 0H10v-1h2.5a.5.5 0 1 0 0-1H10V9h2.5a1.5 1.5 0 1 1 0 3m0-5H10V6h2.5a.5.5 0 1 0 0-1H10V4h2.5a1.5 1.5 0 1 1 0 3"
]);
const $db6ad3fef28672ff$export$16e4da7c26c30543 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity20Filled', "20", [
    "M10.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M9 5H2.5a.5.5 0 0 0 0 1H9zm0 3H2.5a.5.5 0 0 0 0 1H9zm0 3H2.5a.5.5 0 0 0 0 1H9zm0 3H2.5a.5.5 0 0 0 0 1H9zm7.5 0H12v-3h4.5a1.5 1.5 0 0 1 0 3m0-5H12V6h4.5a1.5 1.5 0 0 1 0 3"
]);
const $db6ad3fef28672ff$export$c8e576b9f085c048 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity20Regular', "20", [
    "M10.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M9 5H2.5a.5.5 0 0 0 0 1H9zm0 3H2.5a.5.5 0 0 0 0 1H9zm0 3H2.5a.5.5 0 0 0 0 1H9zm0 3H2.5a.5.5 0 0 0 0 1H9zm7.5 0H12v-1h4.5a.5.5 0 0 0 0-1H12v-1h4.5a1.5 1.5 0 0 1 0 3m0-5H12V8h4.5a.5.5 0 0 0 0-1H12V6h4.5a1.5 1.5 0 0 1 0 3"
]);
const $db6ad3fef28672ff$export$c718d8ed7c484ebb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity24Filled', "24", [
    "M12.25 2c.41 0 .75.34.75.75v18.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M10 5H2.75a.75.75 0 0 0 0 1.5H10zm0 4H2.75a.75.75 0 0 0 0 1.5H10zm0 4H2.75a.75.75 0 0 0 0 1.5H10zm0 4H2.75a.75.75 0 0 0 0 1.5H10zm9.75 1H14.5v-4.5h5.25a2.25 2.25 0 0 1 0 4.5m0-7.5H14.5V6h5.25a2.25 2.25 0 0 1 0 4.5"
]);
const $db6ad3fef28672ff$export$59c15eaf704ada57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity24Regular', "24", [
    "M12.25 2c.41 0 .75.34.75.75v18.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M10 5H2.75a.75.75 0 0 0 0 1.5H10zm0 4H2.75a.75.75 0 0 0 0 1.5H10zm0 4H2.75a.75.75 0 0 0 0 1.5H10zm0 4H2.75a.75.75 0 0 0 0 1.5H10zm9.75 1H14.5v-1.5h5.25a.75.75 0 0 0 0-1.5H14.5v-1.5h5.25a2.25 2.25 0 0 1 0 4.5m0-7.5H14.5V9h5.25a.75.75 0 0 0 0-1.5H14.5V6h5.25a2.25 2.25 0 0 1 0 4.5"
]);
const $db6ad3fef28672ff$export$2dc969a97a449208 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity28Filled', "28", [
    "M14.25 2c.41 0 .75.34.75.75v22.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M12 5H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm10.5 0h-6v-5h6a2.5 2.5 0 0 1 0 5m0-9h-6V7h6a2.5 2.5 0 0 1 0 5"
]);
const $db6ad3fef28672ff$export$ba8f159dc8f643 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity28Regular', "28", [
    "M14.25 2c.41 0 .75.34.75.75v22.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M12 5H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm0 4H4a.75.75 0 0 0 0 1.5h8zm10.5 0h-6v-1.5h6a1 1 0 1 0 0-2h-6V16h6a2.5 2.5 0 0 1 0 5m0-9h-6v-1.5h6a1 1 0 1 0 0-2h-6V7h6a2.5 2.5 0 0 1 0 5"
]);
const $db6ad3fef28672ff$export$fafcd571c3c7df99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity32Filled', "32", [
    "M17 3a1 1 0 1 0-2 0v26a1 1 0 1 0 2 0zm2.5 5h6a2.5 2.5 0 0 1 0 5h-6zm6 11h-6v5h6a2.5 2.5 0 0 0 0-5M3 5a1 1 0 0 0 0 2h10.5V5zM2 26a1 1 0 0 1 1-1h10.5v2H3a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h10.5v-2zm-1-4a1 1 0 0 1 1-1h10.5v2H3a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h10.5v-2z"
]);
const $db6ad3fef28672ff$export$a091b629d8e25981 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity32Light', "32", [
    "M17 2.5a.5.5 0 0 0-1 0v27a.5.5 0 0 0 1 0zM18.5 8H26a2 2 0 1 1 0 4h-7.5v1H26a3 3 0 1 0 0-6h-7.5zM26 19h-7.5v-1H26a3 3 0 1 1 0 6h-7.5v-1H26a2 2 0 1 0 0-4M3.5 5a.5.5 0 0 0 0 1h11V5zM3 25.5c0-.28.22-.5.5-.5h11v1h-11a.5.5 0 0 1-.5-.5m.5-5.5a.5.5 0 0 0 0 1h11v-1zM3 15.5c0-.28.22-.5.5-.5h11v1h-11a.5.5 0 0 1-.5-.5m.5-5.5a.5.5 0 0 0 0 1h11v-1z"
]);
const $db6ad3fef28672ff$export$e2deddced52e4ee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDensity32Regular', "32", [
    "M17 3a1 1 0 1 0-2 0v26a1 1 0 1 0 2 0zm1.5 6h7a1.5 1.5 0 0 1 0 3h-7v2h7a3.5 3.5 0 1 0 0-7h-7zm7 11h-7v-2h7a3.5 3.5 0 1 1 0 7h-7v-2h7a1.5 1.5 0 0 0 0-3M3 5a1 1 0 0 0 0 2h10.5V5zM2 26a1 1 0 0 1 1-1h10.5v2H3a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h10.5v-2zm-1-4a1 1 0 0 1 1-1h10.5v2H3a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h10.5v-2z"
]);
const $db6ad3fef28672ff$export$ef5df986b343c16b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription16Filled', "16", [
    "M1.75 3a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zM1 9.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 9.75M1.75 12a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$6946df176d6a887f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription16Regular', "16", [
    "M1.5 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM1 9.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$389e283dea389a2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription20Filled', "20", [
    "M2.75 4.5a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 11.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$d6ef21a2d20907b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription20Regular', "20", [
    "M2.5 5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM2 11.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$f93cff4a17dae1e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription24Filled', "24", [
    "M3 17h12a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh12zm0-4h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18zm0-4h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18zm0-4h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$3038f976893d927f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription24Regular', "24", [
    "M2.75 17h12.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh12.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$967512ef6948693d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription28Filled', "28", [
    "M3 6a1 1 0 0 0 0 2h22a1 1 0 1 0 0-2zm0 15a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2zm-1-9a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$661e80a0d9854dfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription28Regular', "28", [
    "M2.75 6a.75.75 0 1 0 0 1.5h22.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5zM2 16.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M2.75 21a.75.75 0 0 0 0 1.5h15.5a.75.75 0 0 0 0-1.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$d240fa0d33539941 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription32Filled', "32", [
    "M3.25 6a1.25 1.25 0 1 0 0 2.5h25.5a1.25 1.25 0 1 0 0-2.5zm0 6a1.25 1.25 0 1 0 0 2.5h25.5a1.25 1.25 0 1 0 0-2.5zM2 19.25c0-.69.56-1.25 1.25-1.25h25.5a1.25 1.25 0 1 1 0 2.5H3.25c-.69 0-1.25-.56-1.25-1.25M3.25 24a1.25 1.25 0 1 0 0 2.5h16.5a1.25 1.25 0 1 0 0-2.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$e1fd3c60ab7d83e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescription32Regular', "32", [
    "M3 6a1 1 0 0 0 0 2h26a1 1 0 1 0 0-2zm0 6a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2zm-1 7a1 1 0 0 0 1 1h26a1 1 0 1 0 0-2H3a1 1 0 0 0-1 1m1 5a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$f4080d3608aeb7fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionLtr20Filled', "20", [
    "M2.75 4.5a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 11.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$9d59ed2e947ed42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionLtr20Regular', "20", [
    "M2.5 5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM2 11.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$55d35bba408c1cae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionLtr24Filled', "24", [
    "M3 17h12a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh12zm0-4h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18zm0-4h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18zm0-4h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18z"
]);
const $db6ad3fef28672ff$export$e5794e2380dc5178 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionLtr24Regular', "24", [
    "M2.75 17h12.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh12.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5z"
]);
const $db6ad3fef28672ff$export$aa0b0cebe449cede = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionRtl20Filled', "20", [
    "M17.25 4.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0 3a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm.75 3.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0 0 1.5h14.5c.41 0 .75-.34.75-.75m-.75 2.25a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$30e6172f3f2ad0e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionRtl20Regular', "20", [
    "M17.5 5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm.5 3.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0 0 1h15a.5.5 0 0 0 .5-.5m-.5 2.5a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$a375f4679226ae1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionRtl24Filled', "24", [
    "M21 17H9a1 1 0 0 0-.12 2H21a1 1 0 0 0 .12-2zH9zm0-4H3a1 1 0 0 0-.12 2H21a1 1 0 0 0 .12-2zH3zm0-4H3a1 1 0 0 0-.12 2H21a1 1 0 0 0 .12-2zH3zm0-4H3a1 1 0 0 0-.12 2H21a1 1 0 0 0 .12-2zH3z"
]);
const $db6ad3fef28672ff$export$2dbc490df3e1c850 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDescriptionRtl24Regular', "24", [
    "M21.25 17H8.75a.75.75 0 0 0-.1 1.5h12.6a.75.75 0 0 0 .1-1.5zH8.75zm0-4H2.75a.75.75 0 0 0-.1 1.5h18.6a.75.75 0 0 0 .1-1.5zH2.75zm0-4H2.75a.75.75 0 0 0-.1 1.5h18.6a.75.75 0 0 0 .1-1.5zH2.75zm0-4H2.75a.75.75 0 0 0-.1 1.5h18.6a.75.75 0 0 0 .1-1.5zH2.75z"
]);
const $db6ad3fef28672ff$export$67d14d3a5272fd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLeft16Filled', "16", [
    "M4.22 9.22a.75.75 0 1 1 1.06 1.06l-.72.72h8.69a.75.75 0 0 1 0 1.5H4.56l.72.72a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zM11 2c.31 0 .6.2.7.49l2.25 6a.75.75 0 0 1-1.4.52l-.57-1.51h-1.96l-.57 1.51a.75.75 0 0 1-1.4-.52l2.25-6 .05-.1A.8.8 0 0 1 11 2m-6.78.72a.75.75 0 1 1 1.06 1.06l-.72.72h2.69a.75.75 0 0 1 0 1.5H4.56l.72.72a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zM10.58 6h.84L11 4.89z"
]);
const $db6ad3fef28672ff$export$73b03451c7f0f9ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLeft16Regular', "16", [
    "M4.15 9.15a.5.5 0 1 1 .7.7L3.71 11h9.79a.5.5 0 0 1 0 1H3.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7zM11 2c.2 0 .4.13.47.32l2.5 6.5a.5.5 0 0 1-.94.36L12.2 7H9.8l-.83 2.18a.5.5 0 0 1-.94-.36l2.5-6.5.04-.07A.5.5 0 0 1 11 2M4.15 3.15a.5.5 0 1 1 .7.7L3.71 5H7.5a.5.5 0 0 1 0 1H3.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7zM10.19 6h1.62L11 3.9z"
]);
const $db6ad3fef28672ff$export$6a2545f32d36a7ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLeft20Filled', "20", [
    "M13.5 3c-.3 0-.58.19-.7.47l-3 7.5a.75.75 0 0 0 1.4.56L12 9.5h3l.8 2.03a.75.75 0 0 0 1.4-.56l-3-7.5a.8.8 0 0 0-.7-.47m0 2.77L14.4 8h-1.8zM5.22 4.22a.75.75 0 0 1 1.06 1.06L5.56 6h3.69a.75.75 0 0 1 0 1.5H5.56l.72.72a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zm0 7.5a.75.75 0 0 1 1.06 1.06l-.72.72h10.69a.75.75 0 0 1 0 1.5H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06z"
]);
const $db6ad3fef28672ff$export$bf2ca74471176e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLeft20Regular', "20", [
    "M13.5 3a.5.5 0 0 0-.47.32l-3 8a.5.5 0 0 0 .94.36l1-2.68h3.06l1 2.68a.5.5 0 0 0 .94-.36l-3-8A.5.5 0 0 0 13.5 3m0 1.92L14.65 8h-2.3zm-8.35-.77a.5.5 0 1 1 .7.7L4.71 6H9.5a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7zm0 8a.5.5 0 0 1 .7.7L4.71 14H16.5a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7z"
]);
const $db6ad3fef28672ff$export$221efc9f92cbdf71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLeft24Filled', "24", [
    "M16.25 3a1 1 0 0 0-.92.62l-3.75 9a1 1 0 1 0 1.84.76l1-2.38h3.66l1 2.38a1 1 0 0 0 1.84-.76l-3.75-9a1 1 0 0 0-.92-.62m0 3.6 1 2.4h-2zM6.71 5.3a1 1 0 0 0-1.42 0L3.37 7.22a1 1 0 0 0 0 1.55l1.92 1.93a1 1 0 0 0 1.42-1.42L6.4 9H11a1 1 0 0 0 0-2H6.41l.3-.3a1 1 0 0 0 0-1.4m-1.42 9a1 1 0 0 1 1.42 1.4l-.3.3H20a1 1 0 0 1 0 2H6.41l.3.3a1 1 0 1 1-1.42 1.4l-2-2a1 1 0 0 1 0-1.4z"
]);
const $db6ad3fef28672ff$export$c896daf0276bbc56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLeft24Regular', "24", [
    "m20.95 12.97-3.76-9.5a.75.75 0 0 0-1.34-.1l-.05.1-3.75 9.5a.75.75 0 0 0 1.35.65l.05-.1 1-2.52h4.1l1 2.52c.14.35.52.54.88.45l.1-.03a.75.75 0 0 0 .45-.87zM16.5 5.79l1.46 3.71h-2.92zM12 7.75c0 .41-.34.75-.75.75H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 1.06L5.56 7h5.69c.41 0 .75.34.75.75m9 9.5c0 .41-.34.75-.75.75H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 1.06l-.72.72h14.69c.41 0 .75.34.75.75"
]);
const $db6ad3fef28672ff$export$cc99907342f488c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLtr20Filled', "20", [
    "M6.5 3c.3 0 .58.19.7.47l3 7.5a.75.75 0 0 1-1.4.56L8 9.5H5l-.8 2.03a.75.75 0 0 1-1.4-.56l3-7.5A.8.8 0 0 1 6.5 3m0 2.77L5.6 8h1.8zm8.28-1.55a.75.75 0 1 0-1.06 1.06l.72.72h-3.69a.75.75 0 0 0 0 1.5h3.69l-.72.72a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06zm0 7.5a.75.75 0 1 0-1.06 1.06l.72.72H3.75a.75.75 0 0 0 0 1.5h10.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06z"
]);
const $db6ad3fef28672ff$export$ce36b3ba5c361b10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLtr20Regular', "20", [
    "M6.5 3c.2 0 .4.13.47.32l3 8a.5.5 0 0 1-.94.36L8.03 9H4.97l-1 2.68a.5.5 0 0 1-.94-.36l3-8A.5.5 0 0 1 6.5 3m0 1.92L5.35 8h2.3zm8.35-.77a.5.5 0 1 0-.7.7L15.29 6H10.5a.5.5 0 0 0 0 1h4.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zm0 8a.5.5 0 0 0-.7.7L15.29 14H3.5a.5.5 0 0 0 0 1h11.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7z"
]);
const $db6ad3fef28672ff$export$d95bb72bd713525c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLtr24Filled', "24", [
    "M7.75 3a1 1 0 0 1 .92.62l3.75 9a1 1 0 1 1-1.84.76l-1-2.38H5.92l-1 2.38a1 1 0 0 1-1.84-.76l3.75-9A1 1 0 0 1 7.75 3m0 3.6-1 2.4h2zm9.54-1.3a1 1 0 0 1 1.42 0l1.92 1.93a1 1 0 0 1 0 1.55l-1.92 1.93a1 1 0 0 1-1.42-1.42l.3-.29H13a1 1 0 0 1 0-2h4.59l-.3-.3a1 1 0 0 1 0-1.4m1.42 9a1 1 0 0 0-1.42 1.4l.3.3H4a1 1 0 1 0 0 2h13.59l-.3.3a1 1 0 0 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4z"
]);
const $db6ad3fef28672ff$export$3bbe00fbd88b287b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalLtr24Regular', "24", [
    "m3.05 12.97 3.76-9.5a.75.75 0 0 1 1.34-.1l.05.1 3.75 9.5a.75.75 0 0 1-1.35.65l-.05-.1-1-2.52h-4.1l-1 2.52a.75.75 0 0 1-.88.45l-.1-.03a.75.75 0 0 1-.45-.87zM7.5 5.79 6.04 9.5h2.92zM12 7.75c0 .41.34.75.75.75h5.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72h-5.69a.75.75 0 0 0-.75.75m-9 9.5c0 .41.34.75.75.75h14.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72H3.75a.75.75 0 0 0-.75.75"
]);
const $db6ad3fef28672ff$export$d73c0b904c60b2ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRight16Filled', "16", [
    "M10.72 9.22c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l.72-.72H2.75a.75.75 0 0 1 0-1.5h8.69l-.72-.72a.75.75 0 0 1 0-1.06M5 2c.31 0 .6.2.7.49l2.25 6a.75.75 0 0 1-1.4.52L5.98 7.5H4.02l-.57 1.51a.75.75 0 0 1-1.4-.52l2.25-6 .05-.1A.8.8 0 0 1 5 2m5.72.72c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l.72-.72H8.75a.75.75 0 0 1 0-1.5h2.69l-.72-.72a.75.75 0 0 1 0-1.06M4.58 6h.84L5 4.89z"
]);
const $db6ad3fef28672ff$export$c19a9f557b481246 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRight16Regular', "16", [
    "M11.15 9.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L12.29 12H2.5a.5.5 0 0 1 0-1h9.8l-1.15-1.15a.5.5 0 0 1 0-.7M5 2c.2 0 .4.13.47.32l2.5 6.5a.5.5 0 0 1-.94.36L6.2 7H3.8l-.83 2.18a.5.5 0 0 1-.94-.36l2.5-6.5.04-.07A.5.5 0 0 1 5 2m6.15 1.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L12.29 6H8.5a.5.5 0 0 1 0-1h3.8l-1.15-1.15a.5.5 0 0 1 0-.7M4.19 6H5.8L5 3.9z"
]);
const $db6ad3fef28672ff$export$f4cbf24f8f410735 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRight20Filled', "20", [
    "M6.5 3c.3 0 .58.19.7.47l3 7.5a.75.75 0 0 1-1.4.56L8 9.5H5l-.8 2.03a.75.75 0 0 1-1.4-.56l3-7.5A.8.8 0 0 1 6.5 3m0 2.77L5.6 8h1.8zm8.28-1.55a.75.75 0 1 0-1.06 1.06l.72.72h-3.69a.75.75 0 0 0 0 1.5h3.69l-.72.72a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06zm0 7.5a.75.75 0 1 0-1.06 1.06l.72.72H3.75a.75.75 0 0 0 0 1.5h10.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06z"
]);
const $db6ad3fef28672ff$export$8051ba9e67b560e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRight20Regular', "20", [
    "M6.5 3c.2 0 .4.13.47.32l3 8a.5.5 0 0 1-.94.36L8.03 9H4.97l-1 2.68a.5.5 0 0 1-.94-.36l3-8A.5.5 0 0 1 6.5 3m0 1.92L5.35 8h2.3zm8.35-.77a.5.5 0 1 0-.7.7L15.29 6H10.5a.5.5 0 0 0 0 1h4.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zm0 8a.5.5 0 0 0-.7.7L15.29 14H3.5a.5.5 0 0 0 0 1h11.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7z"
]);
const $db6ad3fef28672ff$export$437d7ad38ea0cd2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRight24Filled', "24", [
    "M7.75 3a1 1 0 0 1 .92.62l3.75 9a1 1 0 1 1-1.84.76l-1-2.38H5.92l-1 2.38a1 1 0 0 1-1.84-.76l3.75-9A1 1 0 0 1 7.75 3m0 3.6-1 2.4h2zm9.54-1.3a1 1 0 0 1 1.42 0l1.92 1.93a1 1 0 0 1 0 1.55l-1.92 1.93a1 1 0 0 1-1.42-1.42l.3-.29H13a1 1 0 0 1 0-2h4.59l-.3-.3a1 1 0 0 1 0-1.4m1.42 9a1 1 0 0 0-1.42 1.4l.3.3H4a1 1 0 1 0 0 2h13.59l-.3.3a1 1 0 0 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4z"
]);
const $db6ad3fef28672ff$export$90a249436905783f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRight24Regular', "24", [
    "m3.05 12.97 3.76-9.5a.75.75 0 0 1 1.34-.1l.05.1 3.75 9.5a.75.75 0 0 1-1.35.65l-.05-.1-1-2.52h-4.1l-1 2.52a.75.75 0 0 1-.88.45l-.1-.03a.75.75 0 0 1-.45-.87zM7.5 5.79 6.04 9.5h2.92zM12 7.75c0 .41.34.75.75.75h5.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72h-5.69a.75.75 0 0 0-.75.75m-9 9.5c0 .41.34.75.75.75h14.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72H3.75a.75.75 0 0 0-.75.75"
]);
const $db6ad3fef28672ff$export$ecb0d14bbf399370 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRtl20Filled', "20", [
    "M13.5 3c-.3 0-.58.19-.7.47l-3 7.5a.75.75 0 0 0 1.4.56L12 9.5h3l.8 2.03a.75.75 0 0 0 1.4-.56l-3-7.5a.8.8 0 0 0-.7-.47m0 2.77L14.4 8h-1.8zM5.22 4.22a.75.75 0 0 1 1.06 1.06L5.56 6h3.69a.75.75 0 0 1 0 1.5H5.56l.72.72a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zm0 7.5a.75.75 0 0 1 1.06 1.06l-.72.72h10.69a.75.75 0 0 1 0 1.5H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06z"
]);
const $db6ad3fef28672ff$export$53e0919f0984021c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRtl20Regular', "20", [
    "M13.5 3a.5.5 0 0 0-.47.32l-3 8a.5.5 0 0 0 .94.36l1-2.68h3.06l1 2.68a.5.5 0 0 0 .94-.36l-3-8A.5.5 0 0 0 13.5 3m0 1.92L14.65 8h-2.3zm-8.35-.77a.5.5 0 1 1 .7.7L4.71 6H9.5a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7zm0 8a.5.5 0 0 1 .7.7L4.71 14H16.5a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7z"
]);
const $db6ad3fef28672ff$export$e5fca1f7e4a746e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRtl24Filled', "24", [
    "M16.25 3a1 1 0 0 0-.92.62l-3.75 9a1 1 0 1 0 1.84.76l1-2.38h3.66l1 2.38a1 1 0 0 0 1.84-.76l-3.75-9a1 1 0 0 0-.92-.62m0 3.6 1 2.4h-2zM6.71 5.3a1 1 0 0 0-1.42 0L3.37 7.22a1 1 0 0 0 0 1.55l1.92 1.93a1 1 0 0 0 1.42-1.42L6.4 9H11a1 1 0 0 0 0-2H6.41l.3-.3a1 1 0 0 0 0-1.4m-1.42 9a1 1 0 0 1 1.42 1.4l-.3.3H20a1 1 0 0 1 0 2H6.41l.3.3a1 1 0 1 1-1.42 1.4l-2-2a1 1 0 0 1 0-1.4z"
]);
const $db6ad3fef28672ff$export$cb3b373552b0d49a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionHorizontalRtl24Regular', "24", [
    "m20.95 12.97-3.76-9.5a.75.75 0 0 0-1.34-.1l-.05.1-3.75 9.5a.75.75 0 0 0 1.35.65l.05-.1 1-2.52h4.1l1 2.52c.14.35.52.54.88.45l.1-.03a.75.75 0 0 0 .45-.87zM16.5 5.79l1.46 3.71h-2.92zM12 7.75c0 .41-.34.75-.75.75H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 1.06L5.56 7h5.69c.41 0 .75.34.75.75m9 9.5c0 .41-.34.75-.75.75H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 1.06l-.72.72h14.69c.41 0 .75.34.75.75"
]);
const $db6ad3fef28672ff$export$3377e76d08ba00ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate270Right16Filled', "16", [
    "M11.22 2.22c.3-.3.77-.3 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v8.69a.75.75 0 0 1-1.5 0V4.56l-.72.72a.75.75 0 0 1-1.06-1.06zM8.49 8.05A.75.75 0 0 1 9 9.45l-1.51.57v1.96l1.51.57a.75.75 0 0 1-.52 1.4l-6-2.25-.1-.05a.75.75 0 0 1 .1-1.35zM4.89 11l1.11.42v-.84zm-.17-8.78c.3-.3.77-.3 1.06 0l2 2a.75.75 0 1 1-1.06 1.06L6 4.56v2.69a.75.75 0 0 1-1.5 0V4.56l-.72.72a.75.75 0 0 1-1.06-1.06z"
]);
const $db6ad3fef28672ff$export$66a1e28ffea8f512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate270Right16Regular', "16", [
    "M8.82 8.03a.5.5 0 0 1 .36.94L7 9.8v2.4l2.18.83a.5.5 0 0 1-.36.94l-6.5-2.5-.07-.04a.5.5 0 0 1 .07-.9zm2.33-5.88c.2-.2.5-.2.7 0l2 2a.5.5 0 1 1-.7.7L12 3.71v9.79a.5.5 0 1 1-1 0V3.7L9.85 4.86a.5.5 0 0 1-.7-.7zM3.89 11l2.11.81v-1.62zm1.26-8.85c.2-.2.5-.2.7 0l2 2a.5.5 0 1 1-.7.7L6 3.71V7.5a.5.5 0 0 1-1 0V3.7L3.85 4.86a.5.5 0 0 1-.7-.7z"
]);
const $db6ad3fef28672ff$export$44bc3a3025146a1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate270Right20Filled', "20", [
    "M4.22 5.22a.75.75 0 0 0 1.06 1.06L6 5.56v3.69a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 0 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0zm7.5 0a.75.75 0 1 0 1.06 1.06l.72-.72v10.69a.75.75 0 1 0 1.5 0V5.56l.72.72a.75.75 0 0 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0zM3 13.5c0-.3.19-.58.47-.7l7.5-3a.75.75 0 1 1 .56 1.4L9.5 12v3l2.03.8a.75.75 0 0 1-.56 1.4l-7.5-3a.8.8 0 0 1-.47-.7m2.77 0 2.23.9v-1.8z"
]);
const $db6ad3fef28672ff$export$f2034e93ca716e70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate270Right20Regular', "20", [
    "M8.85 5.15a.5.5 0 1 1-.7.7L7 4.71V9.5a.5.5 0 0 1-1 0V4.7L4.85 5.86a.5.5 0 1 1-.7-.7l2-2c.2-.2.5-.2.7 0zm8 0a.5.5 0 1 1-.7.7L15 4.71V16.5a.5.5 0 0 1-1 0V4.7l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2c.2-.2.5-.2.7 0zM3 13.5c0-.2.13-.4.32-.47l8-3a.5.5 0 0 1 .36.94l-2.68 1v3.06l2.68 1a.5.5 0 0 1-.36.94l-8-3A.5.5 0 0 1 3 13.5m1.92 0L8 14.65v-2.3z"
]);
const $db6ad3fef28672ff$export$2aef13101e7cbc8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate270Right24Filled', "24", [
    "M19.7 5.3a1 1 0 1 1-1.4 1.4l-.3-.29V20a1 1 0 1 1-2 0V6.41l-.3.3a1 1 0 0 1-1.4-1.42l2-2a1 1 0 0 1 1.4 0zM3.63 17.16l9 3.75a1 1 0 1 0 .76-1.84l-2.38-1v-3.66l2.38-1a1 1 0 0 0-.76-1.84l-9 3.75a1 1 0 0 0 0 1.84m5.38.08-2.4-1 2.4-1zm1.7-10.54a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.4 0l-2 2a1 1 0 1 0 1.4 1.42l.3-.3V10a1 1 0 1 0 2 0V6.41l.3.3a1 1 0 0 0 1.4 0"
]);
const $db6ad3fef28672ff$export$65d300b25bf4c72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate270Right24Regular', "24", [
    "M5.22 5.22a.75.75 0 0 0 1.06 1.06L7 5.56v3.69a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0zm7.75 15.73-9.5-3.76a.75.75 0 0 1-.1-1.34l.1-.05 9.5-3.75a.75.75 0 0 1 .65 1.35l-.1.05-2.52 1v4.1l2.52 1c.35.14.54.52.45.88l-.03.1a.75.75 0 0 1-.87.45zM5.79 16.5l3.71 1.46v-2.92zm8.93-10.22a.75.75 0 0 1 0-1.06l2-2c.3-.3.77-.3 1.06 0l2 2a.75.75 0 0 1-1.06 1.06L18 5.56v14.69a.75.75 0 0 1-1.5 0V5.56l-.72.72c-.3.3-.77.3-1.06 0"
]);
const $db6ad3fef28672ff$export$c2b1a40d85071018 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate315Right16Filled', "16", [
    "M14.25 6c.42 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-.69l-6.22 6.22a.75.75 0 0 1-1.06-1.06l6.22-6.22h-.69a.75.75 0 0 1 0-1.5zM1.22 5.22a.8.8 0 0 1 .82-.16l6 2.5a.75.75 0 0 1-.58 1.38l-1.21-.5-1.82 1.8.51 1.22a.75.75 0 0 1-1.38.58l-2.5-6a.8.8 0 0 1 .16-.82m2.59 3.53.94-.94-1.6-.67zM9.25 1c.42 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-.7L6.78 5.29a.75.75 0 0 1-1.06-1.06L7.44 2.5h-.69a.75.75 0 1 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$81b5b537b8e8143e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate315Right16Regular', "16", [
    "M14.5 6c.28 0 .5.22.5.5V9a.5.5 0 0 1-1 0V7.7l-7.15 7.15a.5.5 0 0 1-.7-.7L13.29 7H12a.5.5 0 0 1 0-1zM1.15 5.15a.5.5 0 0 1 .56-.1l6.5 3a.5.5 0 0 1-.42.9l-1.95-.9-1.79 1.8.9 1.94a.5.5 0 1 1-.9.42l-3-6.5-.03-.07a.5.5 0 0 1 .13-.5M3.6 8.87l1.27-1.26-2.36-1.09zM9.5 1c.27 0 .5.22.5.5V4a.5.5 0 0 1-1 0V2.7L6.34 5.37a.5.5 0 0 1-.7-.71L8.3 2H7a.5.5 0 1 1 0-1z"
]);
const $db6ad3fef28672ff$export$ad9c8d72f9fdad80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate315Right20Filled', "20", [
    "M8 2.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-.69L8.28 6.78a.75.75 0 1 1-1.06-1.06L9.44 3.5h-.7A.75.75 0 0 1 8 2.75M3.09 6.58a.75.75 0 0 0-1.01 1l4 8a.75.75 0 0 0 1.34-.67l-1.09-2.18 1.9-1.9 2.18 1.1a.75.75 0 1 0 .68-1.35zm3.73 3.54-1.2 1.2-1.2-2.4zM14.75 8a.75.75 0 0 0 0 1.5h.69l-7.22 7.22a.75.75 0 1 0 1.06 1.06l7.22-7.22v.69a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75z"
]);
const $db6ad3fef28672ff$export$2f04a95224e140e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate315Right20Regular', "20", [
    "M8.5 2a.5.5 0 0 0 0 1h1.8L7.14 6.15a.5.5 0 1 0 .7.7L11 3.71V5.5a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5zM2.72 7.05a.5.5 0 0 0-.67.67l4 8a.5.5 0 1 0 .9-.45l-1.17-2.34 2.15-2.15 2.35 1.17a.5.5 0 1 0 .44-.9zM7 10.3 5.3 12 3.62 8.62zM14.5 8a.5.5 0 0 0 0 1h1.8l-8.15 8.15a.5.5 0 0 0 .7.7L17 9.71v1.79a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5z"
]);
const $db6ad3fef28672ff$export$f8930d01952e4754 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate315Right24Filled', "24", [
    "M11.5 2a1 1 0 1 0 0 2h.09L8.54 7.04a1 1 0 0 0 1.42 1.42L13 5.4v.09a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1zM3.43 7.6A1 1 0 0 0 2.1 8.93l4.5 9.5a1 1 0 1 0 1.8-.86l-1.14-2.41 2.4-2.4 2.41 1.14a1 1 0 1 0 .86-1.8zm4.3 4.25-1.38 1.39L5.1 10.6zM18.5 9a1 1 0 1 0 0 2h.09l-9.3 9.3a1 1 0 0 0 1.42 1.4L20 12.42v.09a1 1 0 1 0 2 0V10a1 1 0 0 0-1-1z"
]);
const $db6ad3fef28672ff$export$cbf667b626cb375e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate315Right24Regular', "24", [
    "M10.5 2.75c0 .41.34.75.75.75h1.19L8.22 7.72a.75.75 0 0 0 1.06 1.06l4.22-4.22v1.19a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75M3.07 8.07a.75.75 0 0 0-1 1l4.5 9.5a.75.75 0 0 0 1.36-.64L6.7 15.35l2.64-2.64 2.58 1.22a.75.75 0 0 0 .64-1.36zm4.84 3.96L6.03 13.9l-1.7-3.58zM18.25 9a.75.75 0 0 0 0 1.5h1.19L9.22 20.72a.75.75 0 1 0 1.06 1.06L20.5 11.56v1.19a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75z"
]);
const $db6ad3fef28672ff$export$4472122b26a068c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate45Right16Filled', "16", [
    "M1.22 6.22c.3-.3.77-.3 1.06 0l6.22 6.22v-.69a.75.75 0 0 1 1.5 0v2.5c0 .42-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h.7L1.21 7.28a.75.75 0 0 1 0-1.06m9.5-.5c.3-.3.77-.3 1.06 0l1.72 1.72v-.69a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h.7l-1.73-1.72a.75.75 0 0 1 0-1.06m-.76-4.66a.75.75 0 0 1 .98.98l-2.5 6a.75.75 0 0 1-1.38-.58l.5-1.22-1.8-1.8-1.22.5a.75.75 0 0 1-.58-1.38zM7.26 3.8l.93.94.67-1.6z"
]);
const $db6ad3fef28672ff$export$6d8c3edecdc064a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate45Right16Regular', "16", [
    "M1.15 6.15c.2-.2.5-.2.7 0L9 13.29V12a.5.5 0 0 1 1 0v2.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1 0-1h1.3L1.14 6.85a.5.5 0 0 1 0-.7m9.5-.5c.2-.2.5-.2.7 0L14 8.29V7a.5.5 0 0 1 1 0v2.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h1.3l-2.65-2.65a.5.5 0 0 1 0-.7m-.29-4.63a.5.5 0 0 1 .6.69l-3 6.5a.5.5 0 0 1-.91-.42l.9-1.95-1.8-1.79-1.94.9a.5.5 0 1 1-.42-.9l6.5-3zM7.13 3.6l1.26 1.26 1.09-2.35z"
]);
const $db6ad3fef28672ff$export$693bd385f94dff72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate45Right20Filled', "20", [
    "M17.25 8c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 1 1 0-1.5h.69l-2.22-2.22a.75.75 0 0 1 1.06-1.06l2.22 2.22v-.7c0-.4.34-.74.75-.74m-3.83-4.91a.75.75 0 0 0-1-1.01l-8 4a.75.75 0 1 0 .67 1.34l2.18-1.1 1.9 1.91-1.1 2.18a.75.75 0 1 0 1.35.68zM9.88 6.82l-1.2-1.2 2.4-1.2zM12 14.75a.75.75 0 0 0-1.5 0v.69L3.28 8.22a.75.75 0 1 0-1.06 1.06l7.22 7.22h-.69a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75z"
]);
const $db6ad3fef28672ff$export$9bbb0fd88b40186a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate45Right20Regular', "20", [
    "M18 8.5a.5.5 0 0 0-1 0v1.8l-3.15-3.15a.5.5 0 1 0-.7.7L16.29 11H14.5a.5.5 0 1 0 0 1h3a.5.5 0 0 0 .5-.5zm-5.05-5.78a.5.5 0 0 0-.67-.67l-8 4a.5.5 0 0 0 .45.9l2.34-1.18 2.15 2.16-1.17 2.35a.5.5 0 1 0 .9.44zM9.7 7 8 5.3l3.37-1.68zm2.3 7.5a.5.5 0 0 0-1 0v1.8L2.85 8.15a.5.5 0 1 0-.7.7L10.29 17H8.5a.5.5 0 1 0 0 1h3a.5.5 0 0 0 .5-.5z"
]);
const $db6ad3fef28672ff$export$f514bff969c3a5e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate45Right24Filled', "24", [
    "M22 11.5a1 1 0 1 0-2 0v.09l-3.04-3.05a1 1 0 1 0-1.42 1.42L18.6 13h-.09a1 1 0 1 0 0 2H21a1 1 0 0 0 1-1zm-5.6-8.07a1 1 0 0 0-1.33-1.33l-9.5 4.5a1 1 0 1 0 .86 1.8l2.41-1.14 2.4 2.4-1.14 2.41a1 1 0 1 0 1.8.86zm-4.25 4.3-1.39-1.38L13.4 5.1zM15 18.5a1 1 0 1 0-2 0v.09l-9.3-9.3a1 1 0 0 0-1.4 1.42L11.58 20h-.09a1 1 0 1 0 0 2H14a1 1 0 0 0 1-1z"
]);
const $db6ad3fef28672ff$export$ca22bf1247848ae3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate45Right24Regular', "24", [
    "M21.25 10.5a.75.75 0 0 0-.75.75v1.19l-4.22-4.22a.75.75 0 1 0-1.06 1.06l4.22 4.22h-1.19a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3a.75.75 0 0 0-.75-.75m-5.32-7.43a.75.75 0 0 0-1-1l-9.5 4.5a.75.75 0 1 0 .64 1.36L8.65 6.7l2.64 2.64-1.22 2.58a.75.75 0 0 0 1.36.64zm-3.96 4.84L10.1 6.03l3.58-1.7zM15 18.25a.75.75 0 0 0-1.5 0v1.19L3.28 9.22a.75.75 0 1 0-1.06 1.06L12.44 20.5h-1.19a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75z"
]);
const $db6ad3fef28672ff$export$83b0c5c21bcd0b92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Left16Filled', "16", [
    "M3.72 2.22c.3-.3.77-.3 1.06 0l2 2a.75.75 0 0 1-1.06 1.06L5 4.56v8.69a.75.75 0 0 1-1.5 0V4.56l-.72.72a.75.75 0 0 1-1.06-1.06zm2.83 6.27a.75.75 0 0 1 .96-.44l6 2.25.1.05a.75.75 0 0 1-.1 1.35l-6 2.25a.75.75 0 0 1-.52-1.4l1.51-.57v-1.96l-1.51-.57a.75.75 0 0 1-.44-.96M10 11.42l1.11-.42-1.11-.42zm.22-9.2c.3-.3.77-.3 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v2.69a.75.75 0 0 1-1.5 0V4.56l-.72.72a.75.75 0 0 1-1.06-1.06z"
]);
const $db6ad3fef28672ff$export$4c3b47f77f5aac2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Left16Regular', "16", [
    "M4.15 2.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L5 3.71v9.79a.5.5 0 0 1-1 0V3.7L2.85 4.86a.5.5 0 0 1-.7-.7zm2.38 6.17a.5.5 0 0 1 .65-.29l6.5 2.5.07.04a.5.5 0 0 1-.07.9l-6.5 2.5a.5.5 0 0 1-.36-.94L9 12.2V9.8l-2.18-.83a.5.5 0 0 1-.29-.65M10 11.81l2.1-.81-2.1-.81zm.15-9.66c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L11 3.71V7.5a.5.5 0 0 1-1 0V3.7L8.85 4.86a.5.5 0 0 1-.7-.7z"
]);
const $db6ad3fef28672ff$export$b09b7c379272cad9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Left20Filled', "20", [
    "M17 13.5c0 .3-.19.58-.47.7l-7.5 3a.75.75 0 0 1-.56-1.4l2.03-.8v-3l-2.03-.8a.75.75 0 0 1 .56-1.4l7.5 3c.28.12.47.4.47.7m-2.77 0L12 12.6v1.8zM5 16.25a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 0 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06L5 5.56zm8-7a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l.72-.72z"
]);
const $db6ad3fef28672ff$export$aeefc6c06701155c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Left20Regular', "20", [
    "M17 13.5c0 .2-.13.4-.32.47l-8 3a.5.5 0 1 1-.36-.94l2.68-1v-3.06l-2.68-1a.5.5 0 1 1 .36-.94l8 3c.2.07.32.26.32.47m-1.92 0L12 12.35v2.3zM5 16.5a.5.5 0 1 0 1 0V4.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 5.5 3a.5.5 0 0 0-.35.15l-2 2a.5.5 0 1 0 .7.7L5 4.71zm8-7a.5.5 0 0 0 1 0V4.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7L13 4.71z"
]);
const $db6ad3fef28672ff$export$fb77f81c2e1c3212 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Left24Filled', "24", [
    "m20.38 15.33-9-3.75a1 1 0 1 0-.76 1.84l2.38 1v3.66l-2.38 1a1 1 0 0 0 .76 1.84l9-3.75a1 1 0 0 0 0-1.84M15 15.25l2.4 1-2.4 1zM8 20a1 1 0 1 1-2 0V6.41l-.3.3a1 1 0 0 1-1.4-1.42l2-2a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1-1.4 1.42L8 6.4zm8-9a1 1 0 0 1-1-1V6.41l-.3.3a1 1 0 1 1-1.4-1.42l2-2a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1-1.4 1.42l-.3-.3V10a1 1 0 0 1-1 1"
]);
const $db6ad3fef28672ff$export$1d2c50218bd4bfa2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Left24Regular', "24", [
    "M6.75 21a.75.75 0 0 1-.75-.75V5.56l-.72.72a.75.75 0 0 1-1.06-1.06l2-2c.3-.3.77-.3 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-.72-.72v14.69c0 .41-.34.75-.75.75m4.28-.05 9.5-3.76a.75.75 0 0 0 .1-1.34l-.1-.05-9.5-3.75a.75.75 0 0 0-.65 1.35l.1.05 2.52 1v4.1l-2.52 1a.75.75 0 0 0-.45.88l.03.1c.14.35.51.54.87.45zm7.18-4.45-3.71 1.46v-2.92zm-2.71-5.25a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l.72-.72z"
]);
const $db6ad3fef28672ff$export$495536005c2c45ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Ltr20Filled', "20", [
    "M17 6.5c0-.3-.19-.58-.47-.7l-7.5-3a.75.75 0 0 0-.56 1.4l2.03.8v3l-2.03.8a.75.75 0 1 0 .56 1.4l7.5-3a.8.8 0 0 0 .47-.7m-2.77 0L12 7.4V5.6zM5 3.75a.75.75 0 0 1 1.5 0v10.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72zm8 7a.75.75 0 0 1 1.5 0v3.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72z"
]);
const $db6ad3fef28672ff$export$58a0e2f0ff6086b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Ltr20Regular', "20", [
    "M17 6.5a.5.5 0 0 0-.32-.47l-8-3a.5.5 0 1 0-.36.94l2.68 1v3.06l-2.68 1a.5.5 0 0 0 .36.94l8-3A.5.5 0 0 0 17 6.5m-1.92 0L12 7.65v-2.3zM5 3.5a.5.5 0 0 1 1 0v11.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.35.15.5.5 0 0 1-.35-.15l-2-2a.5.5 0 1 1 .7-.7L5 15.29zm8 7a.5.5 0 0 1 1 0v4.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L13 15.29z"
]);
const $db6ad3fef28672ff$export$ba33ca8ac97abe1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Ltr24Filled', "24", [
    "m20.38 8.67-9 3.75a1 1 0 1 1-.76-1.84l2.38-1V5.92l-2.38-1a1 1 0 0 1 .76-1.84l9 3.75a1 1 0 0 1 0 1.84M15 8.75l2.4-1-2.4-1zM8 4a1 1 0 0 0-2 0v13.59l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 0 0-1.4-1.42l-.3.3zm8 9a1 1 0 0 0-1 1v3.59l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 0 0-1.4-1.42l-.3.3V14a1 1 0 0 0-1-1"
]);
const $db6ad3fef28672ff$export$d4029fc86eb2435 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Ltr24Regular', "24", [
    "M6.75 3a.75.75 0 0 0-.75.75v14.69l-.72-.72a.75.75 0 0 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72V3.75A.75.75 0 0 0 6.75 3m4.28.05 9.5 3.76c.6.23.63 1.04.1 1.34l-.1.05-9.5 3.75a.75.75 0 0 1-.65-1.35l.1-.05 2.52-1v-4.1l-2.52-1a.75.75 0 0 1-.45-.88l.03-.1a.75.75 0 0 1 .87-.45zm7.18 4.45L14.5 6.04v2.92zm-2.71 5.25a.75.75 0 0 1 1.5 0v5.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72z"
]);
const $db6ad3fef28672ff$export$2964a55f36d5e804 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Right16Filled', "16", [
    "M4.25 2c.41 0 .75.34.75.75v8.69l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72V2.75c0-.41.34-.75.75-.75m6.5 6c.41 0 .75.34.75.75v2.69l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72V8.75c0-.41.34-.75.75-.75m-4.2-5.51a.75.75 0 0 1 .96-.44l6 2.25.1.05a.75.75 0 0 1-.1 1.35l-6 2.25A.75.75 0 0 1 7 6.55l1.51-.57V4.02l-1.51-.57a.75.75 0 0 1-.44-.96M10 5.42 11.11 5 10 4.58z"
]);
const $db6ad3fef28672ff$export$c57cc7e95d1c0b61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Right16Regular', "16", [
    "M4.5 2c.28 0 .5.22.5.5v9.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L4 12.29V2.5c0-.28.22-.5.5-.5m6 6c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L10 12.29V8.5c0-.28.22-.5.5-.5M6.53 2.32a.5.5 0 0 1 .65-.29l6.5 2.5.07.04a.5.5 0 0 1-.07.9l-6.5 2.5a.5.5 0 0 1-.36-.94L9 6.2V3.8l-2.18-.83a.5.5 0 0 1-.29-.65M10 5.81 12.1 5 10 4.19z"
]);
const $db6ad3fef28672ff$export$feb90d01ce364a32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Right20Filled', "20", [
    "M17 6.5c0-.3-.19-.58-.47-.7l-7.5-3a.75.75 0 0 0-.56 1.4l2.03.8v3l-2.03.8a.75.75 0 1 0 .56 1.4l7.5-3a.8.8 0 0 0 .47-.7m-2.77 0L12 7.4V5.6zM5 3.75a.75.75 0 0 1 1.5 0v10.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72zm8 7a.75.75 0 0 1 1.5 0v3.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72z"
]);
const $db6ad3fef28672ff$export$93884072e5ea2bde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Right20Regular', "20", [
    "M17 6.5a.5.5 0 0 0-.32-.47l-8-3a.5.5 0 1 0-.36.94l2.68 1v3.06l-2.68 1a.5.5 0 0 0 .36.94l8-3A.5.5 0 0 0 17 6.5m-1.92 0L12 7.65v-2.3zM5 3.5a.5.5 0 0 1 1 0v11.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.35.15.5.5 0 0 1-.35-.15l-2-2a.5.5 0 1 1 .7-.7L5 15.29zm8 7a.5.5 0 0 1 1 0v4.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L13 15.29z"
]);
const $db6ad3fef28672ff$export$946f2d21eca41149 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Right24Filled', "24", [
    "m20.38 8.67-9 3.75a1 1 0 1 1-.76-1.84l2.38-1V5.92l-2.38-1a1 1 0 0 1 .76-1.84l9 3.75a1 1 0 0 1 0 1.84M15 8.75l2.4-1-2.4-1zM8 4a1 1 0 0 0-2 0v13.59l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 0 0-1.4-1.42l-.3.3zm8 9a1 1 0 0 0-1 1v3.59l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 0 0-1.4-1.42l-.3.3V14a1 1 0 0 0-1-1"
]);
const $db6ad3fef28672ff$export$c31c412a049de496 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Right24Regular', "24", [
    "M6.75 3a.75.75 0 0 0-.75.75v14.69l-.72-.72a.75.75 0 0 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72V3.75A.75.75 0 0 0 6.75 3m4.28.05 9.5 3.76c.6.23.63 1.04.1 1.34l-.1.05-9.5 3.75a.75.75 0 0 1-.65-1.35l.1-.05 2.52-1v-4.1l-2.52-1a.75.75 0 0 1-.45-.88l.03-.1a.75.75 0 0 1 .87-.45zm7.18 4.45L14.5 6.04v2.92zm-2.71 5.25a.75.75 0 0 1 1.5 0v5.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72z"
]);
const $db6ad3fef28672ff$export$d628534f1fda4611 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Rtl20Filled', "20", [
    "M17 13.5c0 .3-.19.58-.47.7l-7.5 3a.75.75 0 0 1-.56-1.4l2.03-.8v-3l-2.03-.8a.75.75 0 0 1 .56-1.4l7.5 3c.28.12.47.4.47.7m-2.77 0L12 12.6v1.8zM5 16.25a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 0 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06L5 5.56zm8-7a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l.72-.72z"
]);
const $db6ad3fef28672ff$export$e081df1cc1c74b8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Rtl20Regular', "20", [
    "M17 13.5c0 .2-.13.4-.32.47l-8 3a.5.5 0 1 1-.36-.94l2.68-1v-3.06l-2.68-1a.5.5 0 1 1 .36-.94l8 3c.2.07.32.26.32.47m-1.92 0L12 12.35v2.3zM5 16.5a.5.5 0 1 0 1 0V4.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 5.5 3a.5.5 0 0 0-.35.15l-2 2a.5.5 0 1 0 .7.7L5 4.71zm8-7a.5.5 0 0 0 1 0V4.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7L13 4.71z"
]);
const $db6ad3fef28672ff$export$3a2c9b9dbbd27088 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Rtl24Filled', "24", [
    "m20.38 15.33-9-3.75a1 1 0 1 0-.76 1.84l2.38 1v3.66l-2.38 1a1 1 0 0 0 .76 1.84l9-3.75a1 1 0 0 0 0-1.84M15 15.25l2.4 1-2.4 1zM8 20a1 1 0 1 1-2 0V6.41l-.3.3a1 1 0 0 1-1.4-1.42l2-2a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1-1.4 1.42L8 6.4zm8-9a1 1 0 0 1-1-1V6.41l-.3.3a1 1 0 1 1-1.4-1.42l2-2a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1-1.4 1.42l-.3-.3V10a1 1 0 0 1-1 1"
]);
const $db6ad3fef28672ff$export$4a1122450d54c53d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionRotate90Rtl24Regular', "24", [
    "M6.75 21a.75.75 0 0 1-.75-.75V5.56l-.72.72a.75.75 0 0 1-1.06-1.06l2-2c.3-.3.77-.3 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-.72-.72v14.69c0 .41-.34.75-.75.75m4.28-.05 9.5-3.76a.75.75 0 0 0 .1-1.34l-.1-.05-9.5-3.75a.75.75 0 0 0-.65 1.35l.1.05 2.52 1v4.1l-2.52 1a.75.75 0 0 0-.45.88l.03.1c.14.35.51.54.87.45zm7.18-4.45-3.71 1.46v-2.92zm-2.71-5.25a.75.75 0 0 0 1.5 0V5.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l.72-.72z"
]);
const $db6ad3fef28672ff$export$2dbf6d25111fce08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionVertical16Filled', "16", [
    "M4.75 2c.41 0 .75.34.75.75v8.69l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V2.75c0-.41.34-.75.75-.75m6.5 7.5c.41 0 .75.34.75.75v1.19l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72v-1.19c0-.41.34-.75.75-.75m0-7.5c.31 0 .6.2.7.49l2.25 6a.75.75 0 0 1-1.4.52l-.57-1.51h-1.96L9.7 9.01a.75.75 0 0 1-1.4-.52l2.25-6 .05-.1a.8.8 0 0 1 .65-.39m-.42 4h.84l-.42-1.11z"
]);
const $db6ad3fef28672ff$export$9012ce9cb9b6e02f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionVertical16Regular', "16", [
    "M4.5 2c.28 0 .5.22.5.5v9.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L4 12.29V2.5c0-.28.22-.5.5-.5m6 7.5c.28 0 .5.22.5.5v2.3l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L10 12.29V10c0-.28.22-.5.5-.5m0-7.5c.2 0 .4.13.47.32l2.5 6.5a.5.5 0 0 1-.94.36L11.7 7H9.3l-.83 2.18a.5.5 0 0 1-.94-.36l2.5-6.5.04-.07A.5.5 0 0 1 10.5 2m-.81 4h1.62l-.81-2.1z"
]);
const $db6ad3fef28672ff$export$a61fe1620eb2156 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionVertical20Filled', "20", [
    "M5 3.75a.75.75 0 0 1 1.5 0v10.69l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72zm8 9a.75.75 0 0 1 1.5 0v1.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.76.76 0 0 1 0-1.07c.3-.3.77-.28 1.06.01l.72.72zM13.5 3c.3 0 .58.19.7.47l3 7.5a.75.75 0 0 1-1.4.56L15 9.5h-3l-.8 2.03a.75.75 0 0 1-1.4-.56l3-7.5a.8.8 0 0 1 .7-.47m0 2.77L12.6 8h1.8z"
]);
const $db6ad3fef28672ff$export$4eeb150de35edf5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionVertical20Regular', "20", [
    "M5 3.5a.5.5 0 0 1 1 0v11.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.35.15.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7L5 15.29zm8 9a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L13 15.29zm.5-9.5a.5.5 0 0 0-.47.32l-3 8a.5.5 0 0 0 .94.36l1-2.68h3.06l1 2.68a.5.5 0 0 0 .94-.36l-3-8A.5.5 0 0 0 13.5 3m0 1.92L14.65 8h-2.3z"
]);
const $db6ad3fef28672ff$export$534e7d3579c3f2ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionVertical24Filled', "24", [
    "M8 4a1 1 0 0 0-2 0v13.59l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 0 0-1.4-1.42l-.3.3zm9.17-.38a1 1 0 0 0-1.84 0l-3.75 9a1 1 0 1 0 1.84.76l1-2.38h3.66l1 2.38a1 1 0 0 0 1.84-.76zM17.25 9h-2l1-2.4zM16 14a1 1 0 0 0-1 1v2.59l-.3-.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l2-2a1 1 0 0 0-1.4-1.42l-.3.3V15a1 1 0 0 0-1-1"
]);
const $db6ad3fef28672ff$export$d6f449eaac85bd0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextDirectionVertical24Regular', "24", [
    "M6 3.75a.75.75 0 0 1 1.5 0v14.69l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72zm5.55 9.22 3.76-9.5a.75.75 0 0 1 1.34-.1l.05.1 3.75 9.5a.75.75 0 0 1-1.35.65l-.05-.1-1-2.52h-4.1l-1 2.52a.75.75 0 0 1-.88.45l-.1-.03a.75.75 0 0 1-.45-.87zM16 5.79 14.54 9.5h2.92zm.25 8.21a.75.75 0 0 0-.75.75v3.69l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72v-3.69a.75.75 0 0 0-.75-.75"
]);
const $db6ad3fef28672ff$export$7b90bf64a32c438f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_16_color__a)",
            "fillRule": "evenodd",
            "d": "M5 2c.21 0 .4.13.47.33l2.5 7a.5.5 0 0 1-.94.34L5 4 2.97 9.67a.5.5 0 0 1-.94-.34l2.5-7A.5.5 0 0 1 5 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_16_color__b)",
            "fillRule": "evenodd",
            "d": "M6.5 7h-3V6h3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_16_color__c)",
            "d": "m8.73 12.97 4.6-4.6-2.7-2.7-4.6 4.6L6 12.99z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_16_color__d)",
            "d": "M7.5 13.6q.75-.15 1.28-.67s-.91-.21-1.7-1c-.8-.8-1-1.71-1-1.71q-.54.54-.69 1.28l-.38 1.9a.5.5 0 0 0 .59.59z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_16_color__e)",
            "d": "M13.44 5.56a1.9 1.9 0 0 0-2.7 0L9.6 6.68l2.7 2.71 1.13-1.12c.75-.75.75-1.96 0-2.7"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_16_color__f)",
            "d": "m12.1 9.62.88-.89s-.92-.2-1.71-1c-.8-.8-1-1.7-1-1.7l-.89.88a3.9 3.9 0 0 0 2.71 2.7"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_16_color__a",
                "x1": "2",
                "x2": "4.32",
                "y1": "2.47",
                "y2": "11.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0057aa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_16_color__b",
                "x1": "2",
                "x2": "4.32",
                "y1": "2.47",
                "y2": "11.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0057aa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_16_color__c",
                "x1": "10.06",
                "x2": "11.18",
                "y1": "7.72",
                "y2": "10.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_16_color__d",
                "x1": "3.91",
                "x2": "6.98",
                "y1": "11.41",
                "y2": "14.46",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_16_color__e",
                "x1": "13.23",
                "x2": "11.87",
                "y1": "5.77",
                "y2": "7.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_16_color__f",
                "x1": "11.24",
                "x2": "8.7",
                "y1": "8.48",
                "y2": "7.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$70d17ceabde9aa28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle16Filled', "16", [
    "M5.47 2.33a.5.5 0 0 0-.94 0l-2.5 7a.5.5 0 1 0 .94.34L3.92 7h2.16l.47 1.33.78-.78zM5 4 5.72 6H4.28zm5.73 1.57a1.91 1.91 0 1 1 2.7 2.7l-4.65 4.67q-.54.52-1.28.68l-1.9.38A.5.5 0 0 1 5 13.4l.38-1.9q.16-.74.68-1.28z"
]);
const $db6ad3fef28672ff$export$bcdc3bc6052b9e3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle16Regular', "16", [
    "M5 2c.21 0 .4.13.47.33l1.86 5.22-.78.78L6.08 7H3.92l-.95 2.67a.5.5 0 0 1-.94-.34l2.5-7A.5.5 0 0 1 5 2m.72 4L5 3.99 4.28 6zm7.72-.44a1.9 1.9 0 0 0-2.7 0l-4.67 4.66q-.52.54-.68 1.28l-.38 1.9a.5.5 0 0 0 .59.6l1.9-.4q.75-.15 1.28-.67l4.66-4.66c.75-.75.75-1.96 0-2.7m-2 .7a.91.91 0 1 1 1.3 1.3l-4.67 4.66q-.31.31-.76.4l-1.17.24.23-1.17q.1-.44.41-.76z"
]);
const $db6ad3fef28672ff$export$b6454ecd1cd5d8d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__a)",
            "fillRule": "evenodd",
            "d": "M5.3 2.23c.12-.3.39-.47.66-.48h.08c.27.01.54.17.66.48l3.5 9.01.03.1v.02c.07.35-.11.7-.46.84h-.01l-.1.04h-.02a.75.75 0 0 1-.84-.47l-.98-2.52H4.18l-.98 2.52q-.12.27-.35.4a.8.8 0 0 1-.5.07l-.11-.03h-.01a.75.75 0 0 1-.47-.85v-.01l.04-.11zm-.75 5.5h2.9L6 4z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__b)",
            "d": "m10.3 16.94 5.58-5.61-3.2-3.21-5.6 5.61.53 2.69z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__c)",
            "d": "M9.87 17.17q.31-.12.55-.35s-.97.1-2.14-1.08c-1.17-1.16-1.08-2.13-1.08-2.13l-.1.12a2 2 0 0 0-.29.57l-.79 3.07-.01.08a.5.5 0 0 0 .62.53l3.08-.76z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__d)",
            "d": "M9.87 17.17q.31-.12.55-.35s-.97.1-2.14-1.08c-1.17-1.16-1.08-2.13-1.08-2.13l-.1.12a2 2 0 0 0-.29.57l-.79 3.07-.01.08a.5.5 0 0 0 .62.53l3.08-.76z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__e)",
            "d": "M9.87 17.17q.31-.12.55-.35s-.97.1-2.14-1.08c-1.17-1.16-1.08-2.13-1.08-2.13l-.1.12a2 2 0 0 0-.29.57l-.79 3.07-.01.08a.5.5 0 0 0 .62.53l3.08-.76z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__f)",
            "d": "M17.16 6.58a2.26 2.26 0 0 0-3.07.12l-1.57 1.57 3.2 3.21 1.57-1.56.12-.13c.73-.85.73-2.1 0-2.96l-.12-.13z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_20_color__g)",
            "d": "m15.35 11.86 1.24-1.24s-.96.1-2.14-1.07c-1.18-1.19-1.07-2.14-1.07-2.14l-1.24 1.24s-.08.98 1.09 2.15c1.17 1.16 2.12 1.06 2.12 1.06"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__a",
                "x1": "1.75",
                "x2": "4.6",
                "y1": "2.37",
                "y2": "13.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0057aa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__b",
                "x1": "9.51",
                "x2": "13.77",
                "y1": "10.25",
                "y2": "14.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__c",
                "x1": "5.9",
                "x2": "8.73",
                "y1": "14.7",
                "y2": "17.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__d",
                "x1": "8.72",
                "x2": "7.11",
                "y1": "16.25",
                "y2": "14.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ac80ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ceb0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__e",
                "x1": "5.37",
                "x2": "8.53",
                "y1": "14.83",
                "y2": "17.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__f",
                "x1": "16.82",
                "x2": "14.81",
                "y1": "7.17",
                "y2": "9.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_20_color__g",
                "x1": "14.45",
                "x2": "11.31",
                "y1": "10.46",
                "y2": "9.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$a2b3959e1c370bff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle20Filled', "20", [
    "M14.09 6.7a2.26 2.26 0 0 1 3.07-.12l.13.12.12.13c.73.85.73 2.1 0 2.96l-.12.13-6.87 6.9a2 2 0 0 1-.55.35l-.16.05-3.08.76a.5.5 0 0 1-.62-.53l.01-.08.8-3.07q.08-.31.28-.57l.1-.12zM6.42 2.23l.05.08 2.98 7.63-.77.78L8 9H4l-1.03 2.68a.5.5 0 0 1-.56.3l-.1-.02a.5.5 0 0 1-.3-.56l.02-.08 3.5-9a.5.5 0 0 1 .9-.1M6 3.87 4.4 8H7.6z"
]);
const $db6ad3fef28672ff$export$68ccf42e03d8e19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle20Regular', "20", [
    "M14.09 6.7a2.26 2.26 0 0 1 3.07-.12l.13.12.12.13c.73.85.73 2.1 0 2.96l-.12.13-6.87 6.9a2 2 0 0 1-.55.35l-.16.05-3.08.76a.5.5 0 0 1-.62-.53l.01-.08.8-3.07q.08-.31.28-.57l.1-.12zm2.5.7a1.26 1.26 0 0 0-1.7-.08l-.1.09-6.88 6.9-.1.15-.03.08-.58 2.27 2.27-.56.12-.05.05-.03.07-.06 6.87-6.9c.5-.5.5-1.3 0-1.8M6.41 2.24l.05.08 2.98 7.63-.77.78L8 9H4l-1.03 2.68a.5.5 0 0 1-.56.3l-.1-.02a.5.5 0 0 1-.3-.56l.02-.08 3.5-9a.5.5 0 0 1 .9-.1M6 3.87 4.4 8H7.6z"
]);
const $db6ad3fef28672ff$export$d176aa444d09eeec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_24_color__a)",
            "fillRule": "evenodd",
            "d": "m8.2 2.47-.05-.1A.7.7 0 0 0 7.41 2a.7.7 0 0 0-.56.36l-.05.1-3.25 8.25-.5 1.25-.03.1c-.09.35.1.73.45.87l.1.03c.36.1.74-.1.88-.45l.25-.64.74-1.88h4.12l.74 1.88.25.64c.14.35.52.54.88.45l.1-.03a.75.75 0 0 0 .45-.87l-.03-.1-.5-1.25zm.76 6.03L7.5 4.8 6.04 8.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_24_color__b)",
            "d": "m12.95 20.1 7.11-7.1-4.55-4.56-7.12 7.11.15 4.4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_24_color__c)",
            "d": "M12.95 20.1q-.41.41-.98.57l-4.61 1.3a.75.75 0 0 1-.92-.94l1.38-4.54q.17-.53.57-.94s.28 1.7 1.57 2.98a6 6 0 0 0 2.99 1.57"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_24_color__d)",
            "d": "M20.06 13a3.22 3.22 0 1 0-4.55-4.56l-2.17 2.16 4.56 4.55z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_text_edit_style_24_color__e)",
            "d": "m17.19 15.85 2.16-2.15s-1.7-.28-2.98-1.57c-1.28-1.28-1.57-2.98-1.57-2.98l-2.17 2.16s.28 1.7 1.57 2.98a6 6 0 0 0 2.99 1.56"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_24_color__a",
                "x1": "3",
                "x2": "5.96",
                "y1": "2.65",
                "y2": "14.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0057aa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_24_color__b",
                "x1": "14.55",
                "x2": "15.97",
                "y1": "11.68",
                "y2": "17.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_24_color__c",
                "x1": "5.46",
                "x2": "10.11",
                "y1": "17.35",
                "y2": "22.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_24_color__d",
                "x1": "19.4",
                "x2": "16.58",
                "y1": "9.09",
                "y2": "11.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_text_edit_style_24_color__e",
                "x1": "16.11",
                "x2": "11.36",
                "y1": "13.74",
                "y2": "11.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ]
    ]
], {
    color: true
});
const $db6ad3fef28672ff$export$ddc57ae8b7e65270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle24Filled', "24", [
    "M20.06 8.45a3.2 3.2 0 0 1 0 4.55l-7.11 7.1q-.41.41-.98.57l-4.61 1.3a.75.75 0 0 1-.92-.94l1.38-4.54q.17-.53.56-.93l7.13-7.12a3.2 3.2 0 0 1 4.55 0M8.16 2.37l.04.1 3.25 8.25-1.15 1.16L9.56 10H5.44l-1 2.52a.75.75 0 0 1-.87.45l-.1-.03a.75.75 0 0 1-.45-.87l.03-.1 3.76-9.5a.75.75 0 0 1 1.34-.1M7.5 4.79 6.04 8.5h2.92z"
]);
const $db6ad3fef28672ff$export$5d68260fd2514c74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle24Regular', "24", [
    "M20.06 8.45a3.2 3.2 0 0 1 0 4.55l-7.12 7.1q-.4.4-.94.57l-4.3 1.29a1 1 0 0 1-1.24-1.27l1.36-4.22q.17-.52.56-.9l7.13-7.13a3.2 3.2 0 0 1 4.55 0m-3.5 1.05-7.12 7.13a1 1 0 0 0-.19.3l-1.07 3.32 3.38-1.02q.18-.05.32-.18L19 11.94a1.72 1.72 0 1 0-2.43-2.44m-8.4-7.13.04.1 3.25 8.25-1.15 1.16L9.56 10H5.44l-1 2.52a.75.75 0 0 1-.87.45l-.1-.03a.75.75 0 0 1-.45-.87l.03-.1 3.76-9.5a.75.75 0 0 1 1.34-.1M7.5 4.79 6.04 8.5h2.92z"
]);
const $db6ad3fef28672ff$export$aa58173b93a5238f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle28Filled', "28", [
    "M21.07 9a3.93 3.93 0 0 1 2.78 6.71l-7.76 7.76q-.7.7-1.64.96l-5.5 1.54a.75.75 0 0 1-.92-.92l1.54-5.5q.26-.94.96-1.64l7.76-7.76A4 4 0 0 1 21.07 9M8.5 2c.3 0 .58.18.7.46l4.49 10.88-1.15 1.15-1.24-2.99H5.7l-1.26 3.04a.75.75 0 0 1-1.38-.58L7.8 2.46A.8.8 0 0 1 8.5 2m-2.18 8h4.36L8.5 4.71z"
]);
const $db6ad3fef28672ff$export$7835550bb9bb285b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle28Regular', "28", [
    "M21.07 9a3.93 3.93 0 0 1 2.78 6.71l-7.76 7.76q-.7.7-1.64.96l-5.5 1.54a.75.75 0 0 1-.92-.92l1.54-5.5q.26-.94.96-1.64l7.76-7.76A4 4 0 0 1 21.07 9m0 1.5c-.65 0-1.27.26-1.72.71l-7.76 7.76q-.42.43-.58.99l-1.18 4.2L14.04 23q.56-.16.99-.58l7.76-7.76a2.43 2.43 0 0 0-1.72-4.15M8.5 2c.3 0 .58.18.7.46l4.49 10.88-1.15 1.15-1.24-2.99H5.7l-1.26 3.04a.75.75 0 0 1-1.38-.58L7.8 2.46A.8.8 0 0 1 8.5 2m-2.18 8h4.36L8.5 4.71z"
]);
const $db6ad3fef28672ff$export$548dbc4d916dc1e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle32Filled', "32", [
    "M21.26 11.33a4.54 4.54 0 0 1 6.41 6.41l-9.41 9.42a4 4 0 0 1-1.73 1.02l-6.26 1.78a1 1 0 0 1-1.23-1.23l1.78-6.25a4 4 0 0 1 1.02-1.73zM9.5 2a1 1 0 0 1 .92.61l5.19 12.26-1.53 1.52L12.65 13h-6.3l-1.43 3.39a1 1 0 0 1-1.84-.78l5.5-13A1 1 0 0 1 9.5 2m-2.3 9h4.6L9.5 5.57z"
]);
const $db6ad3fef28672ff$export$598b445c73da483 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyle32Light', "32", [
    "M10.43 2.63a1 1 0 0 0-1.86 0L3.04 16.3a.5.5 0 0 0 .92.38L5.86 12h7.28l1.74 4.3.77-.77zm2.3 8.37H6.27L9.5 3zm15.09.18a4.04 4.04 0 0 0-5.71 0l-10.6 10.6q-.46.46-.63 1.08l-1.86 6.5a.5.5 0 0 0 .62.62l6.5-1.86q.61-.17 1.08-.63l10.6-10.6a4.04 4.04 0 0 0 0-5.7m-5 .7a3.04 3.04 0 1 1 4.29 4.3l-10.6 10.6q-.27.27-.65.38l-5.63 1.61 1.6-5.64q.12-.36.4-.64z"
]);
const $db6ad3fef28672ff$export$f92b40da55b5abfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterA28Filled', "28", [
    "M21.07 9a3.93 3.93 0 0 1 2.78 6.71l-7.76 7.76q-.7.7-1.64.96l-5.5 1.54a.75.75 0 0 1-.92-.92l1.54-5.5q.26-.94.96-1.64l7.76-7.76A4 4 0 0 1 21.07 9M8.5 2c.3 0 .58.18.7.46l4.49 10.88-1.15 1.15-1.24-2.99H5.7l-1.26 3.04a.75.75 0 0 1-1.38-.58L7.8 2.46A.8.8 0 0 1 8.5 2m-2.18 8h4.36L8.5 4.71z"
]);
const $db6ad3fef28672ff$export$7ea0ed6d63d21246 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterA28Regular', "28", [
    "M21.07 9a3.93 3.93 0 0 1 2.78 6.71l-7.76 7.76q-.7.7-1.64.96l-5.5 1.54a.75.75 0 0 1-.92-.92l1.54-5.5q.26-.94.96-1.64l7.76-7.76A4 4 0 0 1 21.07 9m0 1.5c-.65 0-1.27.26-1.72.71l-7.76 7.76q-.42.43-.58.99l-1.18 4.2L14.04 23q.56-.16.99-.58l7.76-7.76a2.43 2.43 0 0 0-1.72-4.15M8.5 2c.3 0 .58.18.7.46l4.49 10.88-1.15 1.15-1.24-2.99H5.7l-1.26 3.04a.75.75 0 0 1-1.38-.58L7.8 2.46A.8.8 0 0 1 8.5 2m-2.18 8h4.36L8.5 4.71z"
]);
const $db6ad3fef28672ff$export$50d1108358f97d03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterA32Filled', "32", [
    "M21.26 11.33a4.54 4.54 0 0 1 6.41 6.41l-9.41 9.42a4 4 0 0 1-1.73 1.02l-6.26 1.78a1 1 0 0 1-1.23-1.23l1.78-6.25a4 4 0 0 1 1.02-1.73zM9.5 2a1 1 0 0 1 .92.61l5.19 12.26-1.53 1.52L12.65 13h-6.3l-1.43 3.39a1 1 0 0 1-1.84-.78l5.5-13A1 1 0 0 1 9.5 2m-2.3 9h4.6L9.5 5.57z"
]);
const $db6ad3fef28672ff$export$af224c0d31617a04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterA32Regular', "32", [
    "M10.42 2.61a1 1 0 0 0-1.84 0l-5.5 13a1 1 0 1 0 1.84.78L6.36 13h6.29l1.43 3.39 1.53-1.52zM9.5 5.57 11.8 11H7.2zm18.17 5.76a4.54 4.54 0 0 0-6.41 0l-9.42 9.42a4 4 0 0 0-1.02 1.73l-1.78 6.25a1 1 0 0 0 1.23 1.23l6.26-1.78a4 4 0 0 0 1.73-1.02l9.41-9.42a4.54 4.54 0 0 0 0-6.41m-5 1.41a2.54 2.54 0 0 1 3.59 3.59l-9.42 9.42a2 2 0 0 1-.86.5l-4.53 1.3 1.3-4.52a2 2 0 0 1 .5-.87z"
]);
const $db6ad3fef28672ff$export$69e112e0237543b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterGa28Filled', "28", [
    "M21.07 9a3.93 3.93 0 0 1 2.78 6.71l-7.76 7.76q-.7.7-1.64.96l-5.5 1.54a.75.75 0 0 1-.92-.92l1.54-5.5q.26-.94.96-1.64l7.76-7.76A4 4 0 0 1 21.07 9m-7.82-6c.42 0 .75.34.75.75V7.5h1.75a.75.75 0 0 1 0 1.5H14v4.03l-1.5 1.5V3.75c0-.41.34-.75.75-.75m-3.5 1c.4 0 .73.32.75.72v.09a5 5 0 0 1-.06.96 9 9 0 0 1-.66 2.37c-.8 1.84-2.46 3.89-5.83 4.83a.75.75 0 0 1-.4-1.44c2.88-.8 4.22-2.51 4.86-3.99.32-.74.47-1.45.54-1.96V5.5h-5.2a.75.75 0 1 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$f792c384fbe97567 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterGa28Regular', "28", [
    "M21.07 9a3.93 3.93 0 0 1 2.78 6.71l-7.76 7.76q-.7.7-1.64.96l-5.5 1.54a.75.75 0 0 1-.92-.92l1.54-5.5q.26-.94.96-1.64l7.76-7.76A4 4 0 0 1 21.07 9m0 1.5c-.65 0-1.26.26-1.72.71l-7.76 7.76q-.42.43-.58.99l-1.18 4.2L14.04 23q.56-.16.99-.58l7.76-7.76a2.43 2.43 0 0 0-1.72-4.15M13.25 3c.41 0 .75.34.75.75V7.5h1.75a.75.75 0 0 1 0 1.5H14v4.03l-1.5 1.5V3.75c0-.41.34-.75.75-.75m-3.5 1c.4 0 .73.32.75.72v.09a5 5 0 0 1-.06.96 9 9 0 0 1-.66 2.37c-.8 1.84-2.46 3.89-5.83 4.83a.75.75 0 0 1-.4-1.44c2.88-.8 4.22-2.51 4.86-3.99a7 7 0 0 0 .54-1.96V5.5h-5.2a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$3a1b711c905d21f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterGa32Filled', "32", [
    "M15 3a1 1 0 0 1 1 1v4h2a1 1 0 1 1 0 2h-2v4.47l-2 2V4a1 1 0 0 1 1-1M4 15a1 1 0 0 1-.21-1.98c.24-.05 5.6-1.3 6.16-7.02H4a1 1 0 0 1-1-1 1 1 0 0 1 1-1h7a1 1 0 0 1 1 1c0 8.12-7.55 9.92-7.79 9.98Q4.11 15 4 15m23.67-3.67a4.54 4.54 0 0 0-6.41 0l-9.42 9.42a4 4 0 0 0-1.02 1.73l-1.78 6.25a1 1 0 0 0 1.23 1.23l6.26-1.78a4 4 0 0 0 1.73-1.02l9.41-9.42a4.54 4.54 0 0 0 0-6.41"
]);
const $db6ad3fef28672ff$export$ca3c792d7f1eb1eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEditStyleCharacterGa32Regular', "32", [
    "M16 4a1 1 0 1 0-2 0v12.47l2-2V10h2a1 1 0 1 0 0-2h-2zm11.67 7.33a4.54 4.54 0 0 0-6.41 0l-9.42 9.42a4 4 0 0 0-1.02 1.73l-1.78 6.25a1 1 0 0 0 1.23 1.23l6.26-1.78a4 4 0 0 0 1.73-1.02l9.41-9.42a4.54 4.54 0 0 0 0-6.41m-5 1.41a2.54 2.54 0 0 1 3.59 3.59l-9.42 9.42a2 2 0 0 1-.86.5l-4.53 1.3 1.3-4.52a2 2 0 0 1 .5-.87zM3.02 14.21A1 1 0 0 0 4 15q.1 0 .21-.02C4.45 14.92 12 13.12 12 5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1 1 1 0 0 0 1 1h5.95c-.56 5.72-5.92 6.97-6.16 7.02a1 1 0 0 0-.77 1.19"
]);
const $db6ad3fef28672ff$export$6e3277e74f5ae3c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffects20Filled', "20", [
    "M12.09 3.9a2.25 2.25 0 0 0-4.18 0L4.9 11.37l-.04.1-1.2 2.95a2.25 2.25 0 0 0 4.18 1.68l.64-1.59h3.04l.64 1.6a2.25 2.25 0 1 0 4.18-1.7l-1.2-2.95-.04-.1zm-1.4.57 3.04 7.48v.03l1.22 2.99a.75.75 0 0 1-1.4.56L12.54 13H7.47l-1.02 2.53a.75.75 0 0 1-1.4-.56l1.21-2.99.02-.03L9.3 4.47a.75.75 0 0 1 1.39 0m1.23 7.03H8.08L10 6.75z"
]);
const $db6ad3fef28672ff$export$d2a025bb2b2febf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffects20Regular', "20", [
    "M11.62 4.1a1.75 1.75 0 0 0-3.24 0l-3.02 7.46-.03.07-1.2 2.96a1.75 1.75 0 0 0 3.24 1.32L8.14 14h3.72l.77 1.9a1.75 1.75 0 0 0 3.24-1.3l-1.2-2.97-.03-.07zm-1.18 6.4L10 9.41l-.44 1.09zm.26-6.03 3.03 7.48v.03l1.22 2.99a.75.75 0 0 1-1.4.56L12.54 13H7.47l-1.02 2.53a.75.75 0 0 1-1.4-.56l1.21-2.99.02-.03L9.3 4.47a.75.75 0 0 1 1.39 0m1.22 7.03H8.08L10 6.75z"
]);
const $db6ad3fef28672ff$export$da5860575a4e762c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffects24Filled', "24", [
    "M14.76 3.82a3 3 0 0 0-5.52 0l-4.26 9.94-.05.12-1.69 3.94a3 3 0 0 0 5.52 2.36L9.69 18h4.62l.93 2.18a3 3 0 1 0 5.52-2.36l-1.69-3.94-.05-.12zm-1.84.79 4.28 9.98.01.04 1.71 3.98a1 1 0 1 1-1.84.78L15.63 16H8.37l-1.45 3.4a1 1 0 1 1-1.84-.8l1.7-3.97.02-.04 4.28-9.98a1 1 0 0 1 1.84 0M14.77 14H9.23L12 7.54z"
]);
const $db6ad3fef28672ff$export$59eaa71453a4de14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffects24Regular', "24", [
    "M14.3 4.02a2.5 2.5 0 0 0-4.6 0l-4.26 9.94-.05.1-1.69 3.96a2.5 2.5 0 1 0 4.6 1.96l1.06-2.48h5.28l1.06 2.48a2.5 2.5 0 0 0 4.6-1.96l-1.7-3.95-.04-.1zm-1.8 8.48-.5-1.15-.5 1.15zm.42-7.9 4.28 9.99.01.04 1.71 3.98a1 1 0 0 1-1.84.78L15.63 16H8.37l-1.45 3.4a1 1 0 1 1-1.84-.8l1.7-3.97.02-.04 4.28-9.98a1 1 0 0 1 1.84 0m1.85 9.4H9.23L12 7.54z"
]);
const $db6ad3fef28672ff$export$ce9170ab6e18e9b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffectsSparkle20Filled', "20", [
    "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-9.47-5.6c-.62.2-1.14.67-1.4 1.3L4.9 11.36l-.04.1-1.2 2.95a2.25 2.25 0 0 0 4.18 1.68l.64-1.59h3.04l.64 1.6a2.25 2.25 0 0 0 4.18-1.7l-1.2-2.95-.04-.1-.57-1.4-.64-.21q-.4-.15-.65-.48a1.3 1.3 0 0 1-.13-1.29c-.53-.11-.97-.43-1.34-.85l1.96 4.83v.03l1.22 2.99a.75.75 0 0 1-1.4.56L12.54 13H7.47l-1.02 2.53a.75.75 0 0 1-1.4-.56l1.21-2.99.02-.03L9.3 4.47l.02-.06-.07-.1A1.4 1.4 0 0 1 9 3.5a1.4 1.4 0 0 1 .31-.9M8.08 11.5h3.84L10 6.75z"
]);
const $db6ad3fef28672ff$export$4a95b20c6beb569d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffectsSparkle20Regular', "20", [
    "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM8.38 4.1q.2-.5.63-.78a1.5 1.5 0 0 0 .25 1l.07.1-.02.06-3.03 7.48-.02.03-1.2 2.99a.75.75 0 0 0 1.39.56L7.47 13h5.06l1.03 2.53a.75.75 0 0 0 1.39-.56l-1.21-2.99-.02-.03-1.95-4.83c.37.42.8.74 1.35.85a1.3 1.3 0 0 0 .77 1.77h.02l.73 1.82.03.07 1.2 2.96a1.75 1.75 0 0 1-3.24 1.32L11.86 14H8.14l-.77 1.9a1.75 1.75 0 1 1-3.24-1.3l1.2-2.97.03-.07zm3.54 7.41H8.08L10 6.75z"
]);
const $db6ad3fef28672ff$export$e1b469cb4c722e6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffectsSparkle24Filled', "24", [
    "M15.09 6.41a3 3 0 0 0-1.35-.95L12.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM13.6 2.47a3 3 0 0 0-4.37 1.35l-4.26 9.94-.05.12-1.69 3.94a3 3 0 0 0 5.52 2.36L9.69 18h4.62l.93 2.18a3 3 0 1 0 5.52-2.36l-1.69-3.94-.05-.12-.8-1.88-.15-.03-.24-.07c-.5-.18-.87-.7-.87-1.23q0-.35.18-.66-.32.15-.68.16-.36 0-.67-.16c-.3-.1-.58-.3-.83-.52l2.24 5.22.01.04 1.71 3.98a1 1 0 1 1-1.84.78L15.63 16H8.37l-1.45 3.4a1 1 0 1 1-1.84-.8l1.7-3.97.02-.04 4.22-9.85A1.54 1.54 0 0 1 12.05 3l1.34-.44zM9.23 14h5.54L12 7.54z"
]);
const $db6ad3fef28672ff$export$643537d3fdc2f40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextEffectsSparkle24Regular', "24", [
    "M14.85 6.15a3 3 0 0 1 .69 1.11l.45 1.38a.54.54 0 0 0 1.02 0l.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03l-1.38-.45a2.8 2.8 0 0 1-1.8-1.8L17 .36a.54.54 0 0 0-1.03 0l-.45 1.38-.01.03a2.8 2.8 0 0 1-1.76 1.77l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.64.21 1.11.69m7.17 3.81.76.25h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1M12 2.5q.51 0 .97.2l-.92.3a1.6 1.6 0 0 0-1.03 1.74L6.8 14.59l-.01.04-1.7 3.98a1 1 0 0 0 1.83.78L8.37 16h7.26l1.45 3.4a1 1 0 1 0 1.84-.8l-1.7-3.97-.02-.04-2.24-5.22q.38.35.83.52a1.5 1.5 0 0 0 1.07.1l.13.3q-.03.12-.03.26c0 .44.24.86.61 1.1l1 2.31q0 .06.04.1l1.69 3.96a2.5 2.5 0 0 1-4.6 1.96l-1.06-2.48H9.36L8.3 19.98a2.5 2.5 0 1 1-4.6-1.96l1.7-3.95q0-.06.04-.1L9.7 4.01A2.5 2.5 0 0 1 12 2.5M14.77 14H9.23L12 7.54z"
]);
const $db6ad3fef28672ff$export$dc8d7c9412bd31be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand16Filled', "16", [
    "M13.25 12.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm-8.75-8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1.5a.5.5 0 0 0-.5.5v1H3a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1H5v-1a.5.5 0 0 0-.5-.5m8.75 3a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zm0-3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zm0-3.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$f930e26c9c1d48c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand16Regular', "16", [
    "M13.5 13a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1zm-9-8.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1.5a.5.5 0 0 0-.5.5v1H3a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1H5v-1a.5.5 0 0 0-.5-.5m9 3a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0-3a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$12debec2972a151c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand20Filled', "20", [
    "M17.25 15a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zM4.5 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1.25a.5.5 0 0 0-.5.5V9H2.75a.5.5 0 0 0 0 1H4v1.25a.5.5 0 0 0 1 0V10h1.25a.5.5 0 0 0 0-1H5V7.75a.5.5 0 0 0-.5-.5M17.25 11a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zm0-4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zm0-4a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$88224852a9e5f2cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand20Regular', "20", [
    "M17.5 15a.5.5 0 0 1 0 1h-14a.5.5 0 0 1 0-1zm-13-9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1.25a.5.5 0 0 0-.5.5V9H2.75a.5.5 0 0 0 0 1H4v1.25a.5.5 0 0 0 1 0V10h1.25a.5.5 0 0 0 0-1H5V7.75a.5.5 0 0 0-.5-.5m13 3.75a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-14a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$8c69172c455c7b1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand24Filled', "24", [
    "M21 18a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zM6.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V11H4.5a.5.5 0 0 0 0 1H6v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H7V9.5a.5.5 0 0 0-.5-.5M21 13a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$856a50d3cbd1b72e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand24Regular', "24", [
    "M21.25 18a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5zM6.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V11H4.5a.5.5 0 0 0 0 1H6v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H7V9.5a.5.5 0 0 0-.5-.5m14.75 4a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm0-5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm0-5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$5c04fd721147b5d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand28Filled', "28", [
    "M25 22a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM7.5 8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a.5.5 0 0 0-.5.5V13H4.5a.5.5 0 0 0 0 1H7v2.5a.5.5 0 0 0 1 0V14h2.5a.5.5 0 0 0 0-1H8v-2.5a.5.5 0 0 0-.5-.5M25 16a1 1 0 1 1 0 2h-9a1 1 0 1 1 0-2zm0-6a1 1 0 1 1 0 2h-9a1 1 0 1 1 0-2zm0-6a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$e2e07a9cf908c293 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand28Regular', "28", [
    "M25.25 22a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5zM7.5 8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a.5.5 0 0 0-.5.5V13H4.5a.5.5 0 0 0 0 1H7v2.5a.5.5 0 0 0 1 0V14h2.5a.5.5 0 0 0 0-1H8v-2.5a.5.5 0 0 0-.5-.5m17.75 6a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0-6a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0-6a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$f7b9e42f4937f63b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand32Filled', "32", [
    "M28.75 25a1.25 1.25 0 1 1 0 2.5H8.25a1.25 1.25 0 1 1 0-2.5zm-20-16a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m0 3a.75.75 0 0 0-.75.75V15H5.75a.75.75 0 0 0 0 1.5H8v2.25a.75.75 0 0 0 1.5 0V16.5h2.25a.75.75 0 0 0 0-1.5H9.5v-2.25a.75.75 0 0 0-.75-.75m20 6a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5zm0-7a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5zm0-7a1.25 1.25 0 1 1 0 2.5H8.25a1.25 1.25 0 1 1 0-2.5z"
]);
const $db6ad3fef28672ff$export$40c1bbf97d0ad4aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand32Light', "32", [
    "M29.5 26a.5.5 0 0 1 0 1h-22a.5.5 0 0 1 0-1zM8.75 9a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m0 3a.75.75 0 0 0-.75.75V15H5.75a.75.75 0 0 0 0 1.5H8v2.25a.75.75 0 0 0 1.5 0V16.5h2.25a.75.75 0 0 0 0-1.5H9.5v-2.25a.75.75 0 0 0-.75-.75m20.75 7a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm0-8a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm0-7a.5.5 0 0 1 0 1h-22a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$d9c83b2c010ede47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextExpand32Regular', "32", [
    "M29 25a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zM8.75 9a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5m0 3a.75.75 0 0 0-.75.75V15H5.75a.75.75 0 0 0 0 1.5H8v2.25a.75.75 0 0 0 1.5 0V16.5h2.25a.75.75 0 0 0 0-1.5H9.5v-2.25a.75.75 0 0 0-.75-.75M29 18a1 1 0 1 1 0 2H19a1 1 0 1 1 0-2zm0-7a1 1 0 1 1 0 2H19a1 1 0 1 1 0-2zm0-7a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$af75d00ff437f86d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextField16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 12.5 2zM7 11h.5V5H5v.5a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0V5H8.5v6H9a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$5e406582d5b833e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextField16Regular', "16", [
    "M6.5 11.5c0-.28.22-.5.5-.5h.5V5H5v.5a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0V5H8.5v6H9a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5zM3.5 3C2.67 3 2 3.67 2 4.5v7c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $db6ad3fef28672ff$export$eee38ddd34829225 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextField20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm4-.5v1a.5.5 0 0 0 1 0V6h2.5v8H9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5V6H13v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5"
]);
const $db6ad3fef28672ff$export$2f8c221fae25505c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextField20Regular', "20", [
    "M10.5 6H13v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V6h2.5v8H9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5zM2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $db6ad3fef28672ff$export$8bf4b2574da99f91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextField24Filled', "24", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h12.5A3.75 3.75 0 0 1 22 6.75v10.5A3.75 3.75 0 0 1 18.25 21H5.75A3.75 3.75 0 0 1 2 17.25zm10.75.75h2.75v.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75v1.5a.75.75 0 1 0 1.5 0V7.5h2.75v9h-.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-.5z"
]);
const $db6ad3fef28672ff$export$a61859081e8f610c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextField24Regular', "24", [
    "M15.5 7.5h-2.75v9h.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h.5v-9H8.5v.75a.75.75 0 1 1-1.5 0v-1.5c0-.41.34-.75.75-.75h8.5c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0zM5.75 3A3.75 3.75 0 0 0 2 6.75v10.5A3.75 3.75 0 0 0 5.75 21h12.5A3.75 3.75 0 0 0 22 17.25V6.75A3.75 3.75 0 0 0 18.25 3zM3.5 6.75c0-1.24 1-2.25 2.25-2.25h12.5c1.24 0 2.25 1 2.25 2.25v10.5c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25z"
]);
const $db6ad3fef28672ff$export$f3a050bcdf75bc52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFirstLine20Filled', "20", [
    "M4.28 2.22a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 0 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06zM16.25 3.5h-7.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5m-12.5 10a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm12.5-3.5H3.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5"
]);
const $db6ad3fef28672ff$export$2302e6af60a3aeb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFirstLine20Regular', "20", [
    "M3.35 3.15a.5.5 0 1 0-.7.7L3.79 5 2.65 6.15a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zM7.5 4a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1zm-5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$dd9bef261c2b5b73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFirstLine24Filled', "24", [
    "M3.7 3.3a1 1 0 0 0-1.4 1.4L3.58 6l-1.3 1.3a1 1 0 0 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4zM10 5a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2zm11 12H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$2b13d51e8fceba7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFirstLine24Regular', "24", [
    "M3.78 3.22a.75.75 0 0 0-1.06 1.06l1.47 1.47-1.47 1.47a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06zM9.75 5a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5zm-7 13a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM2 12.25c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$10f6f2ae190e542c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFont16Filled', "16", [
    "M4.88 2.02c.3 0 .59.19.7.48l1.56 4.04-.8 2.07-.04-.07-.3-.79H3.76l-.3.79A.75.75 0 1 1 2.05 8l2.12-5.5a.8.8 0 0 1 .7-.48m-.54 4.23h1.08l-.54-1.4zm5.86-1.76a.75.75 0 0 0-1.4 0L5.73 12.5a.75.75 0 0 0 .02 1.5h1.5a.75.75 0 0 0 .09-1.5l.38-1h3.56l.38 1a.75.75 0 0 0 .1 1.5h1.5a.75.75 0 0 0 0-1.5l-.74-1.96-.05-.12zm.5 5.51H8.3l1.2-3.15z"
]);
const $db6ad3fef28672ff$export$14ecbe2a46ef233 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFont16Regular', "16", [
    "M4.75 2c.2 0 .4.13.47.32l1.73 4.61-.55 1.4-.3-.83H3.4l-.44 1.18a.5.5 0 0 1-.94-.36l2.25-6A.5.5 0 0 1 4.75 2m-.97 4.5h1.94l-.97-2.58zM6.7 10.3v.03L5.65 13H5.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.77l.78-2h3.98l.78 2h-.77a.5.5 0 1 0 0 1h2.01a.5.5 0 0 0 0-1h-.17L9.97 4.32a.5.5 0 0 0-.94 0zm4.4-.3H7.9l1.6-4.13z"
]);
const $db6ad3fef28672ff$export$852f198843945fb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFont20Filled', "20", [
    "M6 2c.31 0 .59.2.7.48l2.27 5.94.05.13.03.1-.79 2.12-.48-1.27H4.22l-.77 2.02a.75.75 0 0 1-1.4-.53l3.25-8.5A.8.8 0 0 1 6 2M4.8 8h2.4L6 4.85zm7.9-2.51a.75.75 0 0 0-1.4 0L7.2 16.5h-.44a.75.75 0 0 0 0 1.5h2.5a.75.75 0 1 0 0-1.5h-.47l.75-2h4.92l.75 2h-.46a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-.44zm1.2 7.5h-3.8L12 7.9z"
]);
const $db6ad3fef28672ff$export$98abade0b7362e60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFont20Regular', "20", [
    "M6 2c.2 0 .4.13.47.32L8.9 8.57v.02l.18.44-.53 1.4-.46-1.17H3.91l-.94 2.42a.5.5 0 1 1-.94-.36L3.1 8.59v-.02l2.43-6.25A.5.5 0 0 1 6 2M4.3 8.26h3.4L6 3.88zm8.17-2.94a.5.5 0 0 0-.94 0L7.15 17H6.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.28l1.13-3h5.37l1.15 3h-.37a.5.5 0 1 0 0 1h2a.5.5 0 1 0 0-1h-.56zM14.34 13H9.72l2.29-6.09z"
]);
const $db6ad3fef28672ff$export$311d4e8a119d7b84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFont24Filled', "24", [
    "M7 2a1 1 0 0 1 .94.66l2.88 7.92-1.1 2.8L9.2 12H4.79l-.85 2.34a1 1 0 0 1-1.88-.68l4-11A1 1 0 0 1 7 2m-1.48 8h2.96L7 5.93zm9.85-3.47a1 1 0 0 0-1.86 0l-5.36 13.5H8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2h-.7l.8-2.03h6.66l.8 2.02H18a1 1 0 0 0 0 2h3.01a1 1 0 0 0 0-2h-.3zm1.6 9.47H11.9l2.54-6.39z"
]);
const $db6ad3fef28672ff$export$bbff957d662b5446 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFont24Regular', "24", [
    "M7 2c.31 0 .6.2.7.49l2.96 7.98v.04l.23.6-.83 2.09-.62-1.7H4.56l-1.1 3.01a.75.75 0 0 1-1.42-.52l1.3-3.48v-.04L6.3 2.5c.1-.3.39-.49.7-.49m-1.88 8h3.76L7 4.91zm8.69-3.53a.75.75 0 0 1 1.4 0l5.55 14.03h.49a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h.4l-1.2-3h-6.9l-1.2 3h.4a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h.49zM17.36 16 14.5 8.79 11.64 16z"
]);
const $db6ad3fef28672ff$export$8aa5b40c9aa09206 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontInfo16Filled', "16", [
    "M5.7 1.74a.75.75 0 0 0-1.4 0l-3.5 9.5a.75.75 0 0 0 1.4.52l.93-2.51h2.01q.2-.8.6-1.5H3.68L5 4.17l1.11 3.01q.5-.65 1.18-1.14zm4.8 6.14a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24m0 5.12a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5m0-7a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
]);
const $db6ad3fef28672ff$export$278d9c92095131b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontInfo16Regular', "16", [
    "M5.47 1.83a.5.5 0 0 0-.94 0l-3.5 9.5a.5.5 0 0 0 .94.34L2.95 9h2.26q.15-.52.39-1H3.32L5 3.45l1.3 3.5q.35-.41.78-.76zm5.03 6.05a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24m0 5.12a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5m0-7a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
]);
const $db6ad3fef28672ff$export$1a8208e0bd695a94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontInfo20Filled', "20", [
    "M8.2 3.75a.75.75 0 0 0-1.42-.02L2.8 14.23a.75.75 0 1 0 1.4.54l.86-2.27H8.1q.15-.8.51-1.5H5.63l1.82-4.8 1.48 4.24q.48-.72 1.15-1.25zm5.3 7.13a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24m0 5.12a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5m0-7a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
]);
const $db6ad3fef28672ff$export$d255b27978fc95cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontInfo20Regular', "20", [
    "M7.96 3.84a.5.5 0 0 0-.94-.02L4.29 11h-.02v.05l-1.24 3.27a.5.5 0 0 0 .94.36L4.98 12h3.23q.15-.52.39-1H5.36l2.1-5.54 1.65 4.73q.34-.45.77-.83zm5.54 7.04a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24m0 5.12a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5m0-7a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
]);
const $db6ad3fef28672ff$export$94333a7b7e08766b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontInfo24Filled', "24", [
    "M9.51 1.75a1 1 0 0 1 .93.67l3.16 8.88a7 7 0 0 0-1.54 1.65l-2.6-7.32L6.6 13h5.42q-.59.91-.85 2H5.83l-1.4 3.61a1 1 0 0 1-1.86-.72l6-15.5a1 1 0 0 1 .94-.64M17 16v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0m1.25-2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M23 16.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-1 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
]);
const $db6ad3fef28672ff$export$a02667ea345dd324 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontInfo24Regular', "24", [
    "M9.51 2c.31 0 .6.2.7.5l3.18 8.97q-.66.53-1.16 1.22L9.47 4.91 6.34 13h5.68q-.45.7-.7 1.5H5.75L4.2 18.52a.75.75 0 1 1-1.4-.54l6-15.5c.11-.3.4-.48.71-.48M17 16v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0m1.25-2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M23 16.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-1 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
]);
const $db6ad3fef28672ff$export$14381576ef70511 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSize16Filled', "16", [
    "M10.5 1.75c.32 0 .6.2.7.5l4 11a.75.75 0 0 1-1.4.5L12.6 10.5H8.4L7.2 13.76a.75.75 0 0 1-1.4.03l-.54-1.29H2.73l-.54 1.29a.75.75 0 0 1-1.38-.58l2.5-6 .05-.1a.75.75 0 0 1 1.33.1l1.76 4.23 3.34-9.2c.11-.3.4-.49.71-.49M3.35 11h1.3L4 9.45zm5.58-2h3.14L10.5 4.7z"
]);
const $db6ad3fef28672ff$export$4aec9cf7d54e22a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSize16Regular', "16", [
    "M10.5 2c.21 0 .4.13.47.33l4 11a.5.5 0 1 1-.94.34L12.7 10H8.3l-1.33 3.67a.5.5 0 0 1-.93.02L5.34 12H2.66l-.7 1.7a.5.5 0 0 1-.93-.4l2.5-6a.5.5 0 0 1 .92 0l2 4.82 3.57-9.8.03-.06A.5.5 0 0 1 10.5 2m-7.42 9h1.84L4 8.8zm5.59-2h3.66L10.5 3.96z"
]);
const $db6ad3fef28672ff$export$c3a40a703a9ac638 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSize20Filled', "20", [
    "M13 3c.32 0 .6.2.7.5l4.26 12.25a.75.75 0 0 1-1.42.5l-1.3-3.75h-4.66L9.2 16.26a.75.75 0 0 1-1.4.01L6.92 14H4.26l-.8 2.25a.75.75 0 0 1-1.42-.5L4.8 8a.75.75 0 0 1 1.41-.02l2.28 5.9L12.3 3.48c.1-.3.39-.5.7-.49M4.8 12.5h1.55l-.8-2.1zm8.19-6.52L11.14 11h3.58z"
]);
const $db6ad3fef28672ff$export$db9db814ce21ffaf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSize20Regular', "20", [
    "M13 3.5c.2 0 .4.13.47.32l3 8v.02l1.5 3.98a.5.5 0 1 1-.94.36l-1.38-3.68h-5.3l-1.38 3.68a.5.5 0 0 1-.93 0L6.96 13.5H4.04l-1.08 2.69a.5.5 0 1 1-.92-.38l1.2-2.98v-.03l1.8-4.49a.5.5 0 0 1 .92 0l1.8 4.5v.02l.73 1.79 1.04-2.78v-.03l3-7.99A.5.5 0 0 1 13 3.5m-2.28 8h4.56L13 5.42zm-4.16 1L5.5 9.85 4.44 12.5z"
]);
const $db6ad3fef28672ff$export$9e4a3fd413f8b18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSize24Filled', "24", [
    "M15.5 3a1 1 0 0 1 .94.66l5.5 15a1 1 0 0 1-1.88.68l-1.4-3.84h-6.31l-1.41 3.84a1 1 0 0 1-1.87.02l-.73-1.86H4.66l-.73 1.86a1 1 0 1 1-1.86-.72l3.5-9 .06-.14a1 1 0 0 1 1.8.14l2.54 6.53 4.6-12.51.06-.15A1 1 0 0 1 15.5 3M5.43 15.5h2.14L6.5 12.76zm7.65-2h4.84L15.5 6.9z"
]);
const $db6ad3fef28672ff$export$19a071ff61a7b862 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSize24Regular', "24", [
    "M10.21 17.11 15.04 3.5a.75.75 0 0 1 1.37-.11l.05.1L21.96 19a.75.75 0 0 1-1.38.6l-.04-.1-1.6-4.5h-6.39l-1.58 4.45a.8.8 0 0 1-.35.45l-.1.05a.75.75 0 0 1-.92-.33l-.05-.1-1-2.52h-4.1l-1 2.52a.75.75 0 0 1-.88.45l-.1-.03a.75.75 0 0 1-.45-.87l.03-.1 3.76-9.5a.75.75 0 0 1 1.34-.1l.05.1zL15.04 3.5zm-3.7-5.32L5.03 15.5h2.92zM15.74 6l-2.67 7.51h5.33z"
]);
const $db6ad3fef28672ff$export$760f47f2ef4326bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSizeOff16Filled', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7L9.79 10.5H8.4L7.2 13.76a.75.75 0 0 1-1.4.03l-.54-1.29H2.73l-.54 1.29a.75.75 0 0 1-1.38-.58l2.5-6 .05-.1a.75.75 0 0 1 1.33.1l1.76 4.23L7.6 8.3 1.15 1.85a.5.5 0 0 1 0-.7m9.35.6c.32 0 .6.2.7.5l3.91 10.74L11.12 9h.95L10.5 4.7l-.98 2.7-1.17-1.17 1.44-3.99c.11-.3.4-.49.71-.49M3.35 11h1.3L4 9.45z"
]);
const $db6ad3fef28672ff$export$f058501d42661c82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSizeOff16Regular', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7L9.29 10h-.98l-1.34 3.67a.5.5 0 0 1-.93.02L5.34 12H2.66l-.7 1.7a.5.5 0 0 1-.93-.4l2.5-6a.5.5 0 0 1 .92 0l2 4.82L7.8 8.5 1.15 1.85a.5.5 0 0 1 0-.7M10.5 2c.21 0 .4.13.47.33l3.73 10.25-1.68-1.68-.32-.9h-.58l-1-1h1.21L10.5 3.96 9.32 7.2l-.78-.78 1.5-4.1.02-.06A.5.5 0 0 1 10.5 2m-7.42 9h1.84L4 8.8z"
]);
const $db6ad3fef28672ff$export$19a447b844e24bbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSizeOff20Filled', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-5.36-5.35h-1.2L9.2 16.26a.75.75 0 0 1-1.4.01L6.92 14H4.26l-.8 2.25a.75.75 0 1 1-1.42-.5L4.8 8a.75.75 0 0 1 1.41-.02l2.28 5.9 1.26-3.43-7.6-7.6a.5.5 0 0 1 0-.7M13 3c.31 0 .6.2.7.5l4.25 12.25.03.12-2.42-2.42-.33-.95h-.62l-1.5-1.5h1.6l-1.74-5.02-1.31 3.57-1.17-1.17 1.8-4.89c.1-.3.39-.5.7-.49m-8.22 9.5h1.55l-.8-2.1z"
]);
const $db6ad3fef28672ff$export$f3891c5e1fe1b3a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSizeOff20Regular', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-5.36-5.35h-1.44l-1.38 3.68a.5.5 0 0 1-.93 0L6.96 13.5H4.04l-1.08 2.69a.5.5 0 0 1-.92-.38l1.2-2.98v-.03l1.8-4.49a.5.5 0 0 1 .92 0l1.8 4.5v.02l.72 1.79 1.05-2.78v-.03l.43-1.14-7.81-7.82a.5.5 0 0 1 0-.7M13 3.5c.2 0 .4.13.47.32l3 8v.02l1.5 3.98v.03l-1.7-1.7-.62-1.65h-1.03l-1-1h1.66L13 5.42 11.51 9.4l-.77-.78 1.8-4.79A.5.5 0 0 1 13 3.5m-8.56 9h2.12L5.5 9.85z"
]);
const $db6ad3fef28672ff$export$58e96c492ff607ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSizeOff24Filled', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.28-6.28h-2.1l-1.4 3.84a1 1 0 0 1-1.87.02l-.73-1.86H4.66l-.73 1.86a1 1 0 0 1-1.86-.72l3.5-9 .06-.14a1 1 0 0 1 1.8.14l2.54 6.53 1.38-3.76-9.13-9.13a.75.75 0 0 1 0-1.06M15.5 3a1 1 0 0 1 .94.66l5.5 15 .04.13-5.3-5.29h1.24L15.5 6.9l-1.45 3.97-1.56-1.56 2.07-5.65.07-.15A1 1 0 0 1 15.5 3M5.43 15.5h2.14L6.5 12.76z"
]);
const $db6ad3fef28672ff$export$95535ff824434ab4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFontSizeOff24Regular', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06L13.94 15h-1.39l-1.58 4.45a.8.8 0 0 1-.35.45l-.1.05a.75.75 0 0 1-.92-.33l-.05-.1-1-2.52h-4.1l-1 2.52a.75.75 0 0 1-.88.45l-.1-.03a.75.75 0 0 1-.45-.87l.03-.1 3.76-9.5a.75.75 0 0 1 1.34-.1l.05.1 3.01 7.64 1.53-4.3-9.52-9.53a.75.75 0 0 1 0-1.06M15.04 3.5a.75.75 0 0 1 1.37-.11l.05.1 5.37 15.16-2.46-2.47-.42-1.18h-.77l-1.5-1.5h1.73L15.75 6l-1.72 4.84-1.18-1.17zm-10 12h2.92L6.5 11.8z"
]);
const $db6ad3fef28672ff$export$e0954baf471a3747 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFootnote20Filled', "20", [
    "M17.3 3c.4.03.7.35.7.75v5.5a.75.75 0 0 1-1.5 0V6.11l-.31.23a.75.75 0 0 1-.83-1.25 3 3 0 0 0 1.16-1.5.75.75 0 0 1 .79-.59m-7.1 12.07a.8.8 0 0 1-.2-.55V6.61q0-.33.21-.58a.8.8 0 0 1 .57-.24q.33 0 .56.24.22.25.22.58v2.35q.21-.22.48-.37.6-.35 1.33-.35 1.3 0 2.12.99.8.98.8 2.54t-.8 2.54q-.81.98-2.14.98-.75 0-1.34-.34a3 3 0 0 1-.5-.38.74.74 0 0 1-.77.72q-.31.01-.54-.22m1.8-1.76q.45.55 1.14.55.73 0 1.13-.53.42-.54.43-1.56 0-1.02-.43-1.56a1.3 1.3 0 0 0-1.13-.54q-.68 0-1.13.56-.46.56-.46 1.54t.46 1.54m-10.25 1.2q0 .33.24.54H2q.25.2.57.2a1 1 0 0 0 .5-.16q.2-.15.3-.43l.74-2.02h3.27l.76 2.02q.08.27.3.43.2.16.49.16.31 0 .57-.2a.7.7 0 0 0 .25-.53q0-.2-.09-.4L6.71 6.44a1 1 0 0 0-.36-.51 1 1 0 0 0-.59-.18q-.34 0-.6.18-.26.19-.38.51l-2.94 7.68q-.09.2-.09.4m5.13-3.3H4.62l1.13-3.1z"
]);
const $db6ad3fef28672ff$export$ac7c2dac6d2139 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFootnote20Regular', "20", [
    "M18 3.5a.5.5 0 0 0-1 0q0 .69-.3 1.17-.3.5-.99.97a.5.5 0 1 0 .58.83q.4-.28.71-.59V9.5a.5.5 0 0 0 1 0zm-7.5 11.54a.5.5 0 0 0 .36-.14.5.5 0 0 0 .15-.38v-.66h.02a2.3 2.3 0 0 0 2.07 1.18q1.2 0 1.95-.89.75-.9.74-2.38 0-1.5-.74-2.38-.74-.9-1.93-.9-.67 0-1.2.31-.53.32-.84.86h-.02V6.61q0-.25-.15-.41a.5.5 0 0 0-.38-.16.5.5 0 0 0-.38.16q-.15.15-.15.4v7.92q0 .23.13.38.14.15.36.14m3.72-1.56q-.5.63-1.33.63-.8 0-1.33-.64-.5-.65-.5-1.7t.5-1.7 1.33-.65q.84 0 1.33.64.48.63.48 1.7 0 1.1-.48 1.72M2.16 14.87q.16.13.41.13.4 0 .56-.42l.8-2.2h3.63l.81 2.2q.15.42.56.42a.6.6 0 0 0 .4-.13q.18-.15.17-.35a1 1 0 0 0-.07-.3l-2.95-7.7q-.2-.51-.72-.52-.54 0-.75.53l-2.94 7.68a1 1 0 0 0-.07.3q0 .22.16.36m5.07-3.42H4.27l1.46-4.02h.04z"
]);
const $db6ad3fef28672ff$export$9aa3481bb4dc7cf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFootnote24Filled', "24", [
    "m20.02 7.54-.22.16a1 1 0 1 1-1.1-1.67 3.3 3.3 0 0 0 1.35-1.74 1 1 0 0 1 1.97.21V11a1 1 0 1 1-2 0zM2.12 17.97H2.1q-.34-.31-.35-.78.01-.29.11-.54L5.3 7.69q.15-.42.51-.7.38-.25.83-.24a1.34 1.34 0 0 1 1.3.93l3.45 8.97q.1.26.11.54 0 .47-.37.78-.35.29-.8.28a1.14 1.14 0 0 1-1.12-.82L8.4 15.2H4.86l-.82 2.23q-.13.35-.42.6-.33.22-.7.22-.45 0-.8-.27m5.52-4.86-1.01-2.8-1.02 2.8zm4.11 4.04q0 .43.29.77v.01q.34.33.79.32a1.1 1.1 0 0 0 1.02-.67q.16.14.34.24.75.43 1.67.43 1.65 0 2.67-1.22.98-1.22.97-3.1.02-1.87-.97-3.1a3.3 3.3 0 0 0-2.65-1.22q-.9 0-1.64.43-.15.07-.25.16V7.91q0-.46-.32-.82-.33-.34-.8-.34t-.81.34q-.32.37-.31.82zm5.49-3.22q-.02 1.14-.47 1.7-.4.53-1.15.53a1.4 1.4 0 0 1-1.15-.56 2.6 2.6 0 0 1-.5-1.67q.02-1.08.5-1.66.45-.58 1.15-.57.76 0 1.15.54c.3.38.47.92.47 1.7"
]);
const $db6ad3fef28672ff$export$a354e263f1e70e98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextFootnote24Regular', "24", [
    "M20.5 7.26q-.3.27-.6.48a.75.75 0 0 1-.84-1.25 3.6 3.6 0 0 0 1.46-1.9.75.75 0 0 1 1.48.16v6.5a.75.75 0 0 1-1.5 0zm-8.28 10.5a1 1 0 0 1-.22-.61V7.9q0-.38.24-.64a.8.8 0 0 1 .63-.27q.37 0 .62.26.25.27.25.65v2.84q.27-.3.62-.5.7-.39 1.52-.39 1.5 0 2.46 1.14.91 1.13.91 2.93t-.91 2.94A3 3 0 0 1 15.86 18q-.85 0-1.54-.4-.36-.2-.64-.5v.05a.84.84 0 0 1-.85.85.8.8 0 0 1-.6-.24m4.75-1.98q.52-.65.52-1.85 0-1.19-.52-1.84a1.6 1.6 0 0 0-1.35-.64q-.82 0-1.35.66a3 3 0 0 0-.54 1.82q0 1.16.54 1.83.53.65 1.35.65a1.6 1.6 0 0 0 1.35-.63M2 17.18q0 .36.27.6.28.22.65.22.3 0 .55-.17.23-.2.33-.49l.88-2.39h3.88l.89 2.4q.1.3.33.48a1 1 0 0 0 .55.17q.37 0 .64-.22a.8.8 0 0 0 .28-.6q0-.2-.1-.44L7.71 7.77q-.14-.35-.41-.57Q7 7 6.64 7q-.39 0-.68.2t-.43.58L2.1 16.74q-.1.23-.1.45m4.63-7.6L8 13.36H5.25z"
]);
const $db6ad3fef28672ff$export$8c1807576afd1f28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowLeft20Filled', "20", [
    "M17.25 5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0 3a.75.75 0 0 1 0 1.5h-.46a5.5 5.5 0 0 0-4.58 0H2.75a.75.75 0 0 1 0-1.5zm-14.5 7.5h6.34a6 6 0 0 1-.07-1.5H2.75a.75.75 0 0 0 0 1.5m0-3h6.62a6 6 0 0 1 .89-1.5H2.75a.75.75 0 0 0 0 1.5m7.25 2a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m4.15-2.35a.5.5 0 0 1 .7.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35z"
]);
const $db6ad3fef28672ff$export$28322f0f3379d01f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowLeft20Regular', "20", [
    "M17.5 5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm-7.24 3q-.39.46-.66 1H2.5a.5.5 0 0 1 0-1zM9 14.5q0 .26.02.5H2.5a.5.5 0 0 1 0-1h6.52zm1 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m4.15-2.35a.5.5 0 0 1 .7.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35z"
]);
const $db6ad3fef28672ff$export$140d2a24d2ad308c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowLeft24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-.78 2.59-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .76-.63l-.05-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06M11.02 17H2.88A1 1 0 0 0 3 19h8.17a7 7 0 0 1-.15-2m.48-2H3a1 1 0 0 1-.12-2h9.93a7 7 0 0 0-1.31 2M3 11a1 1 0 0 1-.12-2H21a1 1 0 0 1 .12 2H3m18-6H2.88A1 1 0 0 0 3 7h18.12A1 1 0 0 0 21 5"
]);
const $db6ad3fef28672ff$export$48b72d4a5d3dffd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowLeft24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-.78 2.59-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .76-.63l-.05-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06M11.02 17H2.65a.75.75 0 0 0 .1 1.5h8.33a7 7 0 0 1-.06-1.5m.71-2.5H2.75a.75.75 0 0 1-.1-1.5H12.8q-.65.67-1.08 1.5M21.25 9H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m0-4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5"
]);
const $db6ad3fef28672ff$export$72196833c90f1e78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowRight20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7zM18 5.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h14.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h9.46a5.5 5.5 0 0 1 4.58 0h.46c.41 0 .75-.34.75-.75M9.1 15.5H2.74a.75.75 0 0 1 0-1.5h6.27a6 6 0 0 0 .07 1.5m.27-3H2.75a.75.75 0 0 1 0-1.5h7.5a6 6 0 0 0-.88 1.5"
]);
const $db6ad3fef28672ff$export$706eeb9dce82f835 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowRight20Regular', "20", [
    "M17.5 5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm-7.24 3q-.39.46-.66 1H2.5a.5.5 0 0 1 0-1zM9 14.5q0 .26.02.5H2.5a.5.5 0 0 1 0-1h6.52zm10 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $db6ad3fef28672ff$export$5e130448efd9885d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowRight24Filled', "24", [
    "M3 5h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zm0 6a1 1 0 0 1-.12-2H21a1 1 0 0 1 .12 2H3m0 4h8.5a7 7 0 0 1 1.31-2H2.88A1 1 0 0 0 3 15m0 2h8.02a7 7 0 0 0 .15 2H3a1 1 0 0 1-.12-2zm9 .5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m6.35 2.85-.07.06a.5.5 0 0 1-.64-.06l-.05-.07a.5.5 0 0 1 .05-.63L19.3 18H14.4a.5.5 0 0 1-.41-.5v-.09a.5.5 0 0 1 .5-.41h4.79l-1.65-1.65-.05-.07a.5.5 0 0 1 .76-.63l2.52 2.51.05.07.03.06.03.08.01.09v.1l-.02.1-.02.05-.04.08-.04.05z"
]);
const $db6ad3fef28672ff$export$af9762e3b487be8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarArrowRight24Regular', "24", [
    "M2.75 5h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zm18.5 4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m-18.5 5.5h8.98q.44-.83 1.08-1.5H2.65a.75.75 0 0 0 .1 1.5m0 2.5h8.27a7 7 0 0 0 .06 1.5H2.75a.75.75 0 0 1-.1-1.5zm9.25.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m6.35 2.85-.07.06a.5.5 0 0 1-.64-.06l-.05-.07a.5.5 0 0 1 .05-.63L19.3 18H14.4a.5.5 0 0 1-.41-.5v-.09a.5.5 0 0 1 .5-.41h4.79l-1.65-1.65-.05-.07a.5.5 0 0 1 .76-.63l2.52 2.51.05.07.03.06.03.08.01.09v.1l-.02.1-.02.05-.04.08-.04.05z"
]);
const $db6ad3fef28672ff$export$324a06043831ae79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarCheckmark20Filled', "20", [
    "M18 5.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0 0 1.5h14.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0 0 1.5h9.46a5.5 5.5 0 0 1 4.58 0h.46c.41 0 .75-.34.75-.75M9.02 14a6 6 0 0 0 .07 1.5H2.75a.75.75 0 0 1 0-1.5zm1.24-3a6 6 0 0 0-.89 1.5H2.75a.75.75 0 0 1 0-1.5zM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-2.5-2a.5.5 0 0 1 .75.66l-.06.06-3.51 3.65a.5.5 0 0 1-.67.02l-.07-.07-1.34-1.65a.5.5 0 0 1 .72-.7l.06.07 1 1.23z"
]);
const $db6ad3fef28672ff$export$a85fce46e3de4846 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarCheckmark20Regular', "20", [
    "M17.5 5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zM9 14.5q0-.26.02-.5H2.5a.5.5 0 0 0 0 1h6.52zm.6-2.5q.27-.54.66-1H2.5a.5.5 0 0 0 0 1zm4.9-2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-1.12 5.77-1-1.23-.06-.06a.5.5 0 0 0-.72.7l1.34 1.64.07.07c.2.16.48.15.67-.02l3.5-3.65.07-.06a.5.5 0 0 0-.75-.66z"
]);
const $db6ad3fef28672ff$export$66482bedebf26789 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarCheckmark24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m2.65 3.15-4.1 4.09-1.15-1.54a.5.5 0 0 0-.8.6l1.5 2a.5.5 0 0 0 .75.05l4.5-4.5a.5.5 0 0 0-.7-.7M11.02 17H2.88A1 1 0 0 0 3 19h8.17a7 7 0 0 1-.15-2m.48-2H3a1 1 0 0 1-.12-2h9.93a7 7 0 0 0-1.31 2M3 11a1 1 0 0 1-.12-2H21a1 1 0 0 1 .12 2H3m18-6H2.88A1 1 0 0 0 3 7h18.12A1 1 0 0 0 21 5"
]);
const $db6ad3fef28672ff$export$aca2ae729e00b889 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarCheckmark24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m2.65 3.15-4.1 4.09-1.15-1.54a.5.5 0 0 0-.8.6l1.5 2a.5.5 0 0 0 .75.05l4.5-4.5a.5.5 0 0 0-.7-.7M11.02 17H2.65a.75.75 0 0 0 .1 1.5h8.33a7 7 0 0 1-.06-1.5m.71-2.5H2.75a.75.75 0 0 1-.1-1.5H12.8q-.65.67-1.08 1.5M21.25 9H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m0-4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5"
]);
const $db6ad3fef28672ff$export$bbce504d59e18dcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarDismiss20Filled', "20", [
    "M18 5.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h14.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h9.46a5.5 5.5 0 0 1 4.58 0h.46c.41 0 .75-.34.75-.75M9.1 15.5H2.74a.75.75 0 0 1 0-1.5h6.27a6 6 0 0 0 .07 1.5m.27-3H2.75a.75.75 0 0 1 0-1.5h7.5a6 6 0 0 0-.88 1.5m9.63 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.5.7 1.15 1.15a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7z"
]);
const $db6ad3fef28672ff$export$81689d53595d7af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarDismiss20Regular', "20", [
    "M17.5 5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm-7.24 3q-.39.46-.66 1H2.5a.5.5 0 0 1 0-1zM9 14.5q0 .26.02.5H2.5a.5.5 0 0 1 0-1h6.52zm5.5 4.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.15-2.65-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14a.5.5 0 0 1 .7.7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7"
]);
const $db6ad3fef28672ff$export$55b6ea1d98cade12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarDismiss24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-2.48 3.02a.5.5 0 0 0 0 .71l1.77 1.77-1.76 1.77a.5.5 0 1 0 .7.7l1.77-1.76 1.77 1.77a.5.5 0 1 0 .7-.71l-1.76-1.77 1.77-1.77a.5.5 0 0 0-.7-.7l-1.78 1.76-1.77-1.77a.5.5 0 0 0-.7 0m-4 1.98H2.88A1 1 0 0 0 3 19h8.17a7 7 0 0 1-.15-2m.48-2H3a1 1 0 0 1-.12-2h9.93a7 7 0 0 0-1.31 2M3 11a1 1 0 0 1-.12-2H21a1 1 0 0 1 .12 2H3m18-6H2.88A1 1 0 0 0 3 7h18.12A1 1 0 0 0 21 5"
]);
const $db6ad3fef28672ff$export$9784b99505c9c2e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarDismiss24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-2.48 3.02a.5.5 0 0 0 0 .71l1.77 1.77-1.76 1.77a.5.5 0 1 0 .7.7l1.77-1.76 1.77 1.77a.5.5 0 1 0 .7-.71l-1.76-1.77 1.77-1.77a.5.5 0 0 0-.7-.7l-1.78 1.76-1.77-1.77a.5.5 0 0 0-.7 0m-4 1.98H2.65a.75.75 0 0 0 .1 1.5h8.33a7 7 0 0 1-.06-1.5m.71-2.5H2.75a.75.75 0 0 1-.1-1.5H12.8q-.65.67-1.08 1.5M21.25 9H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m0-4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5"
]);
const $db6ad3fef28672ff$export$4e332c29db036dc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarError20Filled', "20", [
    "M2.75 5a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h9.46a5.5 5.5 0 0 1 4.58 0h.46a.75.75 0 0 0 0-1.5zm0 3h7.5a6 6 0 0 0-.88 1.5H2.75a.75.75 0 0 1 0-1.5m0 3h6.27a6 6 0 0 0 .07 1.5H2.75a.75.75 0 0 1 0-1.5m16.25.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $db6ad3fef28672ff$export$7cb0c00c5bc54b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarError20Regular', "20", [
    "M2.5 5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM9 14.5q0-.26.02-.5H2.5a.5.5 0 0 0 0 1h6.52zm.6-2.5q.27-.54.66-1H2.5a.5.5 0 0 0 0 1zm9.4 2.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $db6ad3fef28672ff$export$c23385ef9bbca16c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning16Filled', "16", [
    "M1 3.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.75m0 3c0-.41.34-.75.75-.75h6.42l-.63 1.5H1.75A.75.75 0 0 1 1 6.75M6.09 12c.2.57.74 1 1.41 1h.47l-.12.5h-6.1a.75.75 0 0 1 0-1.5zm.83-3-.63 1.5H1.75a.75.75 0 0 1 0-1.5zm.58 3h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66H9.59a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $db6ad3fef28672ff$export$89701b1927843f9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning16Regular', "16", [
    "M1 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h6.67l-.42 1H1.5a.5.5 0 0 1-.5-.5M6.5 10h-5a.5.5 0 0 1 0-1h5.42zm-.41 2c.2.57.74 1 1.41 1h-6a.5.5 0 0 1 0-1zm1.41 0h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66H9.59a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $db6ad3fef28672ff$export$db445b0ab892fdbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning20Filled', "20", [
    "M2 5.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 3c0-.41.34-.75.75-.75h10.83c-.6 0-1.15.36-1.38.92l-.24.58H2.75A.75.75 0 0 1 2 8.75M10.09 14a1.5 1.5 0 0 0 .3 1.5H2.74a.75.75 0 0 1 0-1.5zm.62-1.5H2.75a.75.75 0 0 1 0-1.5h8.58zm.8 2.5h1.74l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $db6ad3fef28672ff$export$573c3d572267a704 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning20Regular', "20", [
    "M2 5.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h11.08c-.6 0-1.15.36-1.38.92l-.03.08H2.5a.5.5 0 0 1-.5-.5m8.09 5.5q-.17.53 0 1H2.5a.5.5 0 0 1 0-1zm.83-2H2.5a.5.5 0 0 1 0-1h8.83zm.58 3h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $db6ad3fef28672ff$export$66d4aab1afebe4a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning24Filled', "24", [
    "M12.55 17H2.88A1 1 0 0 0 3 19h9.08c-.12-.35-.12-.76.06-1.14zm.94-2H3a1 1 0 0 1-.12-2h11.55zM21 11h.12A1 1 0 0 0 21 9H2.88A1 1 0 0 0 3 11zm0-6H2.88A1 1 0 0 0 3 7h18.12A1 1 0 0 0 21 5m-4.68 7h4.82a.5.5 0 0 1 .44.75L19.75 16h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L16.5 19h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $db6ad3fef28672ff$export$775e5fceb29cf288 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning24Regular', "24", [
    "M12.55 17h-9.9a.75.75 0 0 0 .1 1.5H12q0-.32.14-.64zm1.17-2.5H2.75a.75.75 0 0 1-.1-1.5h11.78zM21.25 9H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m0-4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m-4.93 7h4.82a.5.5 0 0 1 .44.75L19.75 16h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L16.5 19h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $db6ad3fef28672ff$export$a5a870c025ab187a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning28Filled', "28", [
    "M2 7a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 15a1 1 0 0 1 1-1h11.09c-.35.96.36 2 1.41 2H3a1 1 0 0 1-1-1m14.45-6H3a1 1 0 1 0 0 2h12.5zM25 13a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm-6.18 1h6.33a.5.5 0 0 1 .43.75L23.75 18h1.52c.64 0 .98.75.56 1.24l-6.41 7.45c-.52.6-1.5.05-1.25-.7L19.5 22h-4a.5.5 0 0 1-.45-.71l3.31-7a.5.5 0 0 1 .46-.29"
]);
const $db6ad3fef28672ff$export$b5897e85646406e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning28Regular', "28", [
    "M2 6.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 6.75m0 5c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M2.75 16a.75.75 0 0 0 0 1.5h12.99l.7-1.5zm11.34 5c-.2.54-.06 1.1.3 1.5H2.74a.75.75 0 0 1 0-1.5zm4.73-7h6.33a.5.5 0 0 1 .43.75L23.75 18h1.52c.64 0 .98.75.56 1.24l-6.41 7.45c-.52.6-1.5.05-1.25-.7L19.5 22h-4a.5.5 0 0 1-.45-.71l3.31-7a.5.5 0 0 1 .46-.29"
]);
const $db6ad3fef28672ff$export$1af917057ab73131 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning32Filled', "32", [
    "M2 7.25C2 6.56 2.56 6 3.25 6h25.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 8.5 2 7.94 2 7.25m0 6c0-.69.56-1.25 1.25-1.25h25.5a1.25 1.25 0 0 1 1.21 1.55q-.22-.05-.47-.05h-8.37c-.8 0-1.54.38-2 1H3.25c-.69 0-1.25-.56-1.25-1.25M17.33 18H3.25a1.25 1.25 0 1 0 0 2.5h12.84zm-2.82 6a2.25 2.25 0 0 0 2.24 2.5H3.25a1.25 1.25 0 1 1 0-2.5zm6.61-9h8.38a.5.5 0 0 1 .43.76L26.75 21h2.49c.68 0 1 .82.52 1.29l-8.75 8.43c-.75.73-1.98-.06-1.63-1.05L21 25h-4.25a.75.75 0 0 1-.67-1.08l4.14-8.36a1 1 0 0 1 .9-.56"
]);
const $db6ad3fef28672ff$export$c14bb4eb0cf6d6d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarLightning32Regular', "32", [
    "M2 7a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h26a1 1 0 0 1 .85 1.53l-.36-.03h-8.37a2.5 2.5 0 0 0-1.5.5H3a1 1 0 0 1-1-1m15.33 5H3a1 1 0 1 0 0 2h13.34zm-2.82 6c-.09.77.24 1.53.83 2H3a1 1 0 1 1 0-2zm6.61-9h8.38a.5.5 0 0 1 .43.76L26.75 21h2.49c.68 0 1 .82.52 1.29l-8.75 8.43c-.75.73-1.98-.06-1.63-1.05L21 25h-4.25a.75.75 0 0 1-.67-1.08l4.14-8.36a1 1 0 0 1 .9-.56"
]);
const $db6ad3fef28672ff$export$8ea45f4bd85be10b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarSettings20Filled', "20", [
    "M18 5.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h14.5c.41 0 .75-.34.75-.75m0 3a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h9.46a5.5 5.5 0 0 1 4.58 0h.46c.41 0 .75-.34.75-.75M2.75 11h7.5a6 6 0 0 0-.88 1.5H2.75a.75.75 0 0 1 0-1.5m0 3h6.27a6 6 0 0 0 .07 1.5H2.75a.75.75 0 0 1 0-1.5m9.32-2.56a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$450a3c1ff2256672 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarSettings20Regular', "20", [
    "M18 5.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0 0 1h15a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0 0 1h15a.5.5 0 0 0 .5-.5m-9 6q0 .26.02.5H2.5a.5.5 0 0 1 0-1h6.52zm1.26-3.5q-.39.46-.66 1H2.5a.5.5 0 0 1 0-1zm1.8.44a2 2 0 0 1-1.42 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$b715a28767f7af22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarSettings24Filled', "24", [
    "M11.02 17H2.88A1 1 0 0 0 3 19h8.17a7 7 0 0 1-.15-2M21 11H3a1 1 0 0 1-.12-2H21a1 1 0 0 1 .12 2zM3 15h8.5a7 7 0 0 1 1.31-2H2.88A1 1 0 0 0 3 15M21 5H2.88A1 1 0 0 0 3 7h18.12A1 1 0 0 0 21 5m-6.72 8.98-.2-.7q.66-.56 1.48-.9l.5.52a2 2 0 0 0 2.9 0l.5-.52q.82.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.67.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.93l.19-.63a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8l.58-.15a2 2 0 0 0 1.44-2.5M17.5 19c.8 0 1.45-.67 1.45-1.5S18.3 16 17.5 16s-1.45.67-1.45 1.5.65 1.5 1.45 1.5"
]);
const $db6ad3fef28672ff$export$d5ff465b9905beed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarSettings24Regular', "24", [
    "M11.02 17H2.65a.75.75 0 0 0 .1 1.5h8.33a7 7 0 0 1-.06-1.5m-8.27-4h10.06q-.65.67-1.08 1.5H2.75a.75.75 0 0 1-.1-1.5zm18.5-4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m0-4H2.65a.75.75 0 0 0 .1 1.5h18.6a.75.75 0 0 0-.1-1.5m-6.97 8.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.63q.66.58 1.49.93l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.6-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $db6ad3fef28672ff$export$45aa24b55d532641 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarWand16Filled', "16", [
    "M2.75 2.5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm1.69 9.94.94-.94H2.75a.75.75 0 0 0 0 1.5h1.33q.12-.31.36-.56M2.75 8.5H6c0 .64.4 1.19.97 1.4l-.1.1H2.76a.75.75 0 0 1 0-1.5m0-3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM11 5.44a.5.5 0 0 0-1 0l-.09.73a2 2 0 0 1-1.74 1.74l-.73.1a.5.5 0 0 0 0 .99l.73.09a2 2 0 0 1 1.74 1.74l.1.73a.5.5 0 0 0 .99 0l.09-.73a2 2 0 0 1 1.74-1.74l.73-.1a.5.5 0 0 0 0-.99l-.73-.09a2 2 0 0 1-1.74-1.74zm-2.15 4.7c.2.2.2.52 0 .71l-3 3a.5.5 0 1 1-.7-.7l3-3c.2-.2.5-.2.7 0"
]);
const $db6ad3fef28672ff$export$a843f5cce2ccd366 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarWand16Regular', "16", [
    "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm1.94 9.44.44-.44H2.5a.5.5 0 0 0 0 1h1.58q.12-.31.36-.56M6.97 9.9A1.5 1.5 0 0 1 6.1 9H2.5a.5.5 0 0 0 0 1h4.38zM7.41 7l.27-.03A.5.5 0 0 0 7.5 6h-5a.5.5 0 0 0 0 1zm3.09-2a.5.5 0 0 1 .5.44l.09.73a2 2 0 0 0 1.74 1.74l.73.1a.5.5 0 0 1 0 .99l-.73.09a2 2 0 0 0-1.74 1.74l-.1.73a.5.5 0 0 1-.99 0l-.09-.73a2 2 0 0 0-1.74-1.74l-.73-.1a.5.5 0 0 1 0-.99l.73-.09a2 2 0 0 0 1.74-1.74l.1-.73A.5.5 0 0 1 10.5 5m0 2.47A3 3 0 0 1 9.47 8.5a3 3 0 0 1 1.03 1.03 3 3 0 0 1 1.03-1.03 3 3 0 0 1-1.03-1.03m-1.65 2.68c.2.2.2.5 0 .7l-3 3a.5.5 0 1 1-.7-.7l3-3c.2-.2.5-.2.7 0"
]);
const $db6ad3fef28672ff$export$5c0170d9f69da6a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarWand20Filled', "20", [
    "M2.75 4.5a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h6.63a1.5 1.5 0 0 1-.28-1.5zm0 3h6.63L7.88 15H2.75a.75.75 0 0 1 0-1.5M14.5 7.44a.5.5 0 0 0-1 0l-.1.79a2.5 2.5 0 0 1-2.17 2.18l-.8.1a.5.5 0 0 0 0 .99l.8.1a2.5 2.5 0 0 1 2.18 2.17l.1.8a.5.5 0 0 0 .99 0l.1-.8a2.5 2.5 0 0 1 2.17-2.18l.8-.1a.5.5 0 0 0 0-.99l-.8-.1a2.5 2.5 0 0 1-2.18-2.17zm-2.65 5.7c.2.2.2.52 0 .71l-4 4a.5.5 0 0 1-.7-.7l4-4c.2-.2.5-.2.7 0"
]);
const $db6ad3fef28672ff$export$15423dfbd172567e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarWand20Regular', "20", [
    "M2.5 5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h6.88a1.5 1.5 0 0 1-.37-.99V11zm0 3h6.38l-1 1H2.5a.5.5 0 0 1 0-1M14 7a.5.5 0 0 1 .5.44l.1.79a2.5 2.5 0 0 0 2.17 2.18l.8.1a.5.5 0 0 1 0 .99l-.8.1a2.5 2.5 0 0 0-2.18 2.17l-.1.8a.5.5 0 0 1-.99 0l-.1-.8a2.5 2.5 0 0 0-2.17-2.18l-.8-.1a.5.5 0 0 1 0-.99l.8-.1a2.5 2.5 0 0 0 2.18-2.17l.1-.8A.5.5 0 0 1 14 7m0 2.6a3.5 3.5 0 0 1-1.4 1.4q.9.5 1.4 1.4a3.5 3.5 0 0 1 1.4-1.4A3.5 3.5 0 0 1 14 9.6m-2.15 3.55c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7l4-4c.2-.2.5-.2.7 0"
]);
const $db6ad3fef28672ff$export$dbac895cb694d62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarWand24Filled', "24", [
    "M3 17h7.52l-2 2H3a1 1 0 0 1-.12-2zm0-2h7.85a1.75 1.75 0 0 1-.78-2H2.88A1 1 0 0 0 3 15m0-8h18.12A1 1 0 0 0 21 5H2.88A1 1 0 0 0 3 7m9.72 9.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06zM3 9h10a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zm13.5-1c.38 0 .7.28.74.66l.14 1.13a3.25 3.25 0 0 0 2.83 2.83l1.13.14a.75.75 0 0 1 0 1.48l-1.13.14a3.25 3.25 0 0 0-2.83 2.83l-.14 1.13a.75.75 0 0 1-1.48 0l-.14-1.13a3.25 3.25 0 0 0-2.83-2.83l-1.13-.14a.75.75 0 0 1 0-1.48l1.13-.14a3.25 3.25 0 0 0 2.83-2.83l.14-1.13A.75.75 0 0 1 16.5 8"
]);
const $db6ad3fef28672ff$export$8dddd4f81977d6e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextGrammarWand24Regular', "24", [
    "M2.75 17h7.78l-1.5 1.5H2.75a.75.75 0 0 1-.1-1.5zm0-2.5h7.56a1.7 1.7 0 0 1-.24-1.5H2.65a.75.75 0 0 0 .1 1.5m9.97 1.72a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06zM2.75 9h10.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zm0-4h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zM16.5 8c.38 0 .7.28.74.66l.14 1.13a3.25 3.25 0 0 0 2.83 2.83l1.13.14a.75.75 0 0 1 0 1.48l-1.13.14a3.25 3.25 0 0 0-2.83 2.83l-.14 1.13a.75.75 0 0 1-1.48 0l-.14-1.13a3.25 3.25 0 0 0-2.83-2.83l-1.13-.14a.75.75 0 0 1 0-1.48l1.13-.14a3.25 3.25 0 0 0 2.83-2.83l.14-1.13A.75.75 0 0 1 16.5 8m0 3.77a5 5 0 0 1-1.73 1.73 5 5 0 0 1 1.73 1.73 5 5 0 0 1 1.73-1.73 5 5 0 0 1-1.73-1.73"
]);
const $db6ad3fef28672ff$export$d66a3e1ef732d439 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHanging20Filled', "20", [
    "M3.75 3.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm5 10a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM8 9.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 8 9.25m-3.72 1.47a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 1 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06z"
]);
const $db6ad3fef28672ff$export$b6c04338e1620c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHanging20Regular', "20", [
    "M3.5 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm4 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM7 9.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m-2.15 2.15-1.5-1.5a.5.5 0 0 0-.7.7L3.79 12l-1.14 1.15a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$fc56658f85328f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHanging24Filled', "24", [
    "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm7 12a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2zm-1-5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m-4.3 1.3a1 1 0 0 0-1.4 1.4L4.58 16l-1.3 1.3a1 1 0 1 0 1.42 1.4l2-2a1 1 0 0 0 0-1.4z"
]);
const $db6ad3fef28672ff$export$453273a1b730562e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHanging24Regular', "24", [
    "M2.75 5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zm7 13a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5zM9 12.25c0-.41.34-.75.75-.75h11.5a.75.75 0 0 1 0 1.5H9.75a.75.75 0 0 1-.75-.75m-5.22.72a.75.75 0 0 0-1.06 1.06l1.47 1.47-1.47 1.47a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06z"
]);
const $db6ad3fef28672ff$export$9c11bdc44a1ffc1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader120Filled', "20", [
    "M9.25 4c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V10.5h-5v4.75a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 1.5 0V9h5V4.75c0-.41.34-.75.75-.75m7.11 0c.37.06.64.38.64.75v10.5a.75.75 0 0 1-1.5 0V7.46a10 10 0 0 1-1.81 1.65l-.07.04a.75.75 0 0 1-.8-1.27l.4-.28a8 8 0 0 0 2.3-3.01l.01-.06c.11-.35.46-.58.83-.52"
]);
const $db6ad3fef28672ff$export$e1e7228c2827a241 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader120Regular', "20", [
    "M16.55 4a.5.5 0 0 1 .45.5v11a.5.5 0 0 1-1 0V6.73a9 9 0 0 1-2.22 2.19.5.5 0 1 1-.56-.84 6.8 6.8 0 0 0 2.83-3.8.5.5 0 0 1 .5-.28M2.5 4c.28 0 .5.22.5.5V9h6V4.5a.5.5 0 1 1 1 0v11a.5.5 0 0 1-1 0V10H3v5.5a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$7bd410ffb98652bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader124Filled', "24", [
    "M20.18 5.02A1 1 0 0 1 21 6.03V18a1 1 0 1 1-2 0V9.61a6 6 0 0 1-2.18 1.34 1 1 0 0 1-.64-1.9c1.13-.37 2.19-1.33 2.86-3.34a1 1 0 0 1 1.14-.7M3 5a1 1 0 0 1 1 1v5h6V6a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0v-5H4v5a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$8f896d2d069d21d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader124Regular', "24", [
    "M19.59 5.08a.8.8 0 0 0-.8.08q-.19.15-.26.37a7.6 7.6 0 0 1-3.17 4.08.75.75 0 0 0 .78 1.28 9 9 0 0 0 2.36-2.14v9.5a.75.75 0 0 0 1.5 0V5.77a.8.8 0 0 0-.41-.69M3.5 5.75a.75.75 0 0 0-1.5 0v12.5a.75.75 0 0 0 1.5 0V12.5H10v5.75a.75.75 0 0 0 1.5 0V5.75a.75.75 0 0 0-1.5 0V11H3.5z"
]);
const $db6ad3fef28672ff$export$646de6592b8be830 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1Lines16Filled', "16", [
    "M1.75 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 1 1-1.5 0v-1.5h-2v1.5a.75.75 0 1 1-1.5 0v-4.5c0-.41.34-.75.75-.75M1 13.25c0-.42.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm7.67-7.48c.34.08.58.38.58.73v4.5a.75.75 0 1 1-1.5 0V4.58l-.16.09a.75.75 0 0 1-.68-1.34h.01l.07-.05a3 3 0 0 0 .43-.33q.24-.22.4-.54c.16-.3.51-.47.85-.39"
]);
const $db6ad3fef28672ff$export$a6fe6a6ce5e7ebd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1Lines16Regular', "16", [
    "M2 2.5a.5.5 0 1 0-1 0v5a.5.5 0 1 0 1 0v-2h3v2a.5.5 0 0 0 1 0v-5a.5.5 0 1 0-1 0v2H2zm-1 8c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5m9-11a.5.5 0 0 0-.95-.22 2.4 2.4 0 0 1-.93.97l-.07.04-.02.01a.5.5 0 0 0 .44.9h.01A3 3 0 0 0 9 3.84V7.5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$5cb7fee5d0713bef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1Lines20Filled', "20", [
    "M10 8.25c0 .41.34.75.75.75s.75-.34.75-.75v-5.5a.75.75 0 0 0-.58-.73.7.7 0 0 0-.84.39 3 3 0 0 1-1.17 1.17.74.74 0 0 0-.33 1c.19.38.64.53 1.01.34q.08-.03.41-.25zM2.75 2c.41 0 .75.34.75.75v2h2v-2a.75.75 0 1 1 1.5 0v5.5a.75.75 0 0 1-1.5 0v-2h-2v2a.75.75 0 0 1-1.5 0v-5.5c0-.41.34-.75.75-.75M2 16.25c0-.42.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$7f54daf47c5d8cf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1Lines20Regular', "20", [
    "M3 2.5a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0V6h3v2.5a.5.5 0 0 0 1 0v-6a.5.5 0 1 0-1 0V5H3zM10.61 2a.5.5 0 0 1 .39.49v6a.5.5 0 0 1-1 0V3.91a5 5 0 0 1-.76.53h-.01a.5.5 0 0 1-.45-.89l.12-.07a4 4 0 0 0 .86-.75q.16-.21.3-.45A.5.5 0 0 1 10.6 2M2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 1 1 0 1h-15a.5.5 0 0 1-.5-.5m.5-4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$61af2631b33d5d44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1Lines24Filled', "24", [
    "M3 2a1 1 0 0 1 1 1v2.5h3V3a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0V7.5H4V10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m0 17a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zm-1-4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m11-5a1 1 0 0 0 1 1 1 1 0 0 0 1-1V3a1 1 0 0 0-1.89-.46c-.5 1-1.53 1.55-1.56 1.56a1 1 0 0 0-.44 1.34 1 1 0 0 0 1.4.42q.15-.08.49-.3z"
]);
const $db6ad3fef28672ff$export$5d7d6238c10ee077 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1Lines24Regular', "24", [
    "M14.5 2.75a.75.75 0 0 0-1.42-.34A4 4 0 0 1 11.58 4l-.16.09a.75.75 0 0 0 .67 1.34l.02-.01.25-.15q.25-.15.6-.42L13 4.8v5.44a.75.75 0 0 0 1.5 0zM2.75 2c.41 0 .75.34.75.75V5.5h4V2.75a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0V7h-4v3.25a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m0 17a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM2 14.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$13682d3de5c66be0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1LinesCaret16Filled', "16", [
    "M1.75 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 1 1-1.5 0v-1.5h-2v1.5a.75.75 0 1 1-1.5 0v-4.5c0-.41.34-.75.75-.75m10.28 2.3a.5.5 0 0 1 .47-.3h2a.5.5 0 0 1 .35.85l-1 1a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1-.12-.54M1 13.26c0-.42.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm7.67-7.48c.34.08.58.38.58.73v4.5a.75.75 0 1 1-1.5 0V4.58l-.16.09a.75.75 0 0 1-.68-1.34h.01l.07-.05a3 3 0 0 0 .43-.33q.24-.22.4-.54c.16-.3.51-.47.85-.39"
]);
const $db6ad3fef28672ff$export$f229a48574e236d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1LinesCaret16Regular', "16", [
    "M2 2.5a.5.5 0 1 0-1 0v5a.5.5 0 1 0 1 0v-2h3v2a.5.5 0 0 0 1 0v-5a.5.5 0 1 0-1 0v2H2zm-1 8c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5m11.04-9.2a.5.5 0 0 1 .46-.3h2a.5.5 0 0 1 .36.85l-1 1a.5.5 0 0 1-.71 0l-1-1a.5.5 0 0 1-.11-.54M10 2.5a.5.5 0 0 0-.95-.22 2.4 2.4 0 0 1-.93.97l-.07.04-.02.01a.5.5 0 0 0 .44.9h.01A3 3 0 0 0 9 3.84V7.5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$ee309ba3e4ef6f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1LinesCaret20Filled', "20", [
    "M10 8.25c0 .41.34.75.75.75s.75-.34.75-.75v-5.5a.75.75 0 0 0-.58-.73.7.7 0 0 0-.84.39 3 3 0 0 1-1.17 1.17.74.74 0 0 0-.33 1c.19.38.64.53 1.01.34q.08-.03.41-.25zM2.75 2c.41 0 .75.34.75.75v2h2v-2a.75.75 0 1 1 1.5 0v5.5a.75.75 0 0 1-1.5 0v-2h-2v2a.75.75 0 0 1-1.5 0v-5.5c0-.41.34-.75.75-.75m11.3 2.46c.1-.28.35-.46.62-.46h2.66c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82M2 16.25c0-.42.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$55583dd6c89a7765 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1LinesCaret20Regular', "20", [
    "M3 2.5a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0V6h3v2.5a.5.5 0 0 0 1 0v-6a.5.5 0 1 0-1 0V5H3zM10.61 2a.5.5 0 0 1 .39.49v6a.5.5 0 0 1-1 0V3.91a5 5 0 0 1-.76.53h-.01a.5.5 0 0 1-.45-.89l.12-.07a4 4 0 0 0 .86-.75q.16-.21.3-.45A.5.5 0 0 1 10.6 2m3.44 2.45c.1-.28.35-.46.62-.46h2.66c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82M2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 1 1 0 1h-15a.5.5 0 0 1-.5-.5m.5-4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$8349dde9597d87af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1LinesCaret24Filled', "24", [
    "M3 2a1 1 0 0 1 1 1v2.5h3V3a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0V7.5H4V10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m14.56 3.46a.8.8 0 0 1 .69-.46h3a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5a.8.8 0 0 1-.16-.82M3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zm-1-4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m11-5a1 1 0 0 0 1 1 1 1 0 0 0 1-1V3a1 1 0 0 0-1.89-.46c-.5 1-1.53 1.55-1.56 1.56a1 1 0 0 0-.44 1.34 1 1 0 0 0 1.4.42q.15-.08.49-.3z"
]);
const $db6ad3fef28672ff$export$d0b40bb979389787 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader1LinesCaret24Regular', "24", [
    "M14.5 2.75a.75.75 0 0 0-1.42-.34A4 4 0 0 1 11.58 4l-.16.09a.75.75 0 0 0 .67 1.34l.02-.01.25-.15q.25-.15.6-.42L13 4.8v5.44a.75.75 0 0 0 1.5 0zM2.75 2c.41 0 .75.34.75.75V5.5h4V2.75a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0V7h-4v3.25a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m14.8 3.46a.8.8 0 0 1 .7-.46h3a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5a.8.8 0 0 1-.16-.82M2.76 19a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM2 14.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$752edb4d550cb5c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader220Filled', "20", [
    "M9.25 4c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V10.5h-5v4.75a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 1.5 0V9h5V4.75c0-.41.34-.75.75-.75m5.5-.5a3.75 3.75 0 0 1 3.75 3.75 3.8 3.8 0 0 1-1.14 2.6c-.62.67-1.43 1.27-2.16 1.81-.76.57-1.44 1.1-1.94 1.7q-.46.53-.65 1.14h5.14a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75c0-1.16.47-2.1 1.11-2.86.63-.74 1.45-1.37 2.19-1.93.77-.58 1.46-1.08 1.96-1.63.5-.53.74-1.02.74-1.58a2.25 2.25 0 0 0-4.47-.37l-.02.07a.75.75 0 0 1-1.46-.32l.03-.17a3.75 3.75 0 0 1 3.67-2.96"
]);
const $db6ad3fef28672ff$export$f4e86dd5ef781f7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader220Regular', "20", [
    "M9.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0V10H3v5.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 1 0V9h6V4.5c0-.28.22-.5.5-.5m5-.5A3.5 3.5 0 0 1 18 7c0 1.04-.45 1.84-1.07 2.51-.6.65-1.4 1.22-2.13 1.77-1.38 1.03-2.57 2.05-2.77 3.72h5.47a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5c0-2.52 1.7-3.9 3.2-5.03.77-.57 1.47-1.07 2-1.64.5-.55.8-1.12.8-1.83a2.5 2.5 0 0 0-4.97-.42l-.02.1a.5.5 0 0 1-.96-.26l.06-.3A3.5 3.5 0 0 1 14.5 3.5"
]);
const $db6ad3fef28672ff$export$42adf4a846a6fd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader224Filled', "24", [
    "M11 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-5H4v5a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0v5h6V6a1 1 0 0 1 1-1m6.75-.5C20.1 4.5 22 6.4 22 8.75v.23a4.6 4.6 0 0 1-1.27 2.83c-.68.77-1.58 1.45-2.36 2.07-1.33 1.04-2.34 1.95-2.72 3.12H21a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1c0-2.8 2.06-4.45 3.63-5.7.85-.66 1.57-1.21 2.1-1.82q.67-.73.76-1.5l.01-.23a2.25 2.25 0 0 0-4.44-.52 1 1 0 0 1-1.95-.46l.05-.17a4.25 4.25 0 0 1 4.09-3.1"
]);
const $db6ad3fef28672ff$export$5f5742e8a01fac25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader224Regular', "24", [
    "M10.75 5c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V12.5H3.5v5.75a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 1.5 0V11H10V5.75c0-.41.34-.75.75-.75m7-.5C20.1 4.5 22 6.4 22 8.75c0 1.3-.55 2.3-1.29 3.12-.72.79-1.67 1.44-2.52 2.05-1.56 1.11-2.8 2.09-3.11 3.58h6.17a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75c0-2.81 2.11-4.33 3.81-5.55.9-.64 1.7-1.2 2.3-1.85a3 3 0 0 0 .89-2.1 2.75 2.75 0 0 0-5.47-.4.75.75 0 0 1-1.49-.2 4.25 4.25 0 0 1 4.21-3.65"
]);
const $db6ad3fef28672ff$export$77509127928b1054 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2Lines16Filled', "16", [
    "M8.43 3.62c.14-.31.49-.43.7-.34.31.12.45.54.28.82q-.15.24-.49.53l-.4.35-.34.28C7.7 5.66 7 6.3 7 7.25c0 .41.34.75.75.75h2.75a.75.75 0 0 0 0-1.5H9.03l.12-.1.27-.23.5-.42c.27-.24.55-.52.76-.86a2.1 2.1 0 0 0-.99-3c-1.08-.44-2.21.2-2.62 1.12a.75.75 0 0 0 1.36.61M1.75 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-1.5h-2v1.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75M1 13.25c0-.42.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$329bfdee4aa66945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2Lines16Regular', "16", [
    "M7.96 3.54A.9.9 0 0 1 9 3.04c.46.13.7.8.4 1.27q-.2.32-.56.64l-.4.36-.37.31C7.6 6.06 7 6.66 7 7.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H8.17q.18-.3.58-.63l.31-.27.47-.41q.41-.36.73-.84c.61-.97.21-2.41-.95-2.77a1.9 1.9 0 0 0-2.27 1.04.5.5 0 1 0 .92.42M2 2.5a.5.5 0 1 0-1 0v5a.5.5 0 1 0 1 0v-2h3v2a.5.5 0 0 0 1 0v-5a.5.5 0 1 0-1 0v2H2zm-1 8c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$a9e205a52801b653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2Lines20Filled', "20", [
    "M10.6 3.3c-.42-.16-.97.08-1.17.5a.75.75 0 1 1-1.36-.63 2.47 2.47 0 0 1 3.06-1.27 2.33 2.33 0 0 1 1.17 3.42c-.26.4-.6.73-.94 1l-.97.8-.45.38h2.31a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 8 8.25c0-.55.22-1 .5-1.37.26-.36.61-.67.94-.93l.42-.34q.27-.2.53-.43.45-.36.65-.68c.25-.39.08-1-.44-1.2M2 16.25c0-.42.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm.75-8.75a.75.75 0 1 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-2h2v2a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 0 0-1.5 0v2h-2z"
]);
const $db6ad3fef28672ff$export$3f8aa370680b47d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2Lines20Regular', "20", [
    "M2.5 2c.28 0 .5.22.5.5V5h3V2.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0V6H3v2.5a.5.5 0 1 1-1 0v-6c0-.28.23-.5.5-.5m0 14a.5.5 0 1 0 0 1h15a.5.5 0 0 0 0-1zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m7.45-8.83c.25-.52.88-.78 1.4-.63.6.19.85.86.47 1.45q-.25.37-.68.73l-.33.29-.58.5C9.1 6.62 8.5 7.36 8.5 8.5c0 .28.22.5.5.5h3.5a.5.5 0 0 0 0-1H9.56c.13-.48.44-.87.85-1.25a14 14 0 0 1 .9-.78q.46-.4.85-.94c.7-1.08.3-2.55-1.03-2.95a2.2 2.2 0 0 0-2.58 1.16.5.5 0 1 0 .9.43"
]);
const $db6ad3fef28672ff$export$3008bf43c1209c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2Lines24Filled', "24", [
    "M14.2 3.8c-.43-.16-1.05.08-1.29.6a1 1 0 0 1-1.82-.82c.61-1.35 2.27-2.26 3.85-1.63a3.03 3.03 0 0 1 1.45 4.37c-.31.5-.74.93-1.14 1.29l-.77.63-.42.35q-.27.23-.45.41h2.64a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1c0-1.37 1.04-2.32 1.77-2.93l.52-.43.63-.53q.53-.46.78-.85c.3-.49.07-1.22-.5-1.45M4 3a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0V7.5h3V10a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0v2.5H4zM3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zm-1-4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$41c9d1a044823bac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2Lines24Regular', "24", [
    "M14.2 3.58c-.65-.25-1.46.11-1.77.77a.75.75 0 1 1-1.36-.63 2.95 2.95 0 0 1 3.67-1.54 2.83 2.83 0 0 1 1.4 4.12c-.32.49-.74.9-1.16 1.27l-.8.64-.46.37q-.6.48-.92.91v.01h3.45a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75c0-.65.26-1.2.6-1.65.32-.44.75-.83 1.17-1.17L13.3 7l.7-.57q.58-.48.87-.94c.42-.65.11-1.6-.67-1.9M3.5 2.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0V7h4v3.24a.75.75 0 0 0 1.5 0V2.75a.75.75 0 1 0-1.5 0V5.5h-4zm-1.5 17c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M2.75 14a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$1e7f1100de040b38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2LinesCaret16Filled', "16", [
    "M8.43 3.62c.14-.31.49-.43.7-.34.31.12.45.54.28.82q-.15.24-.49.53l-.4.35-.34.28C7.7 5.66 7 6.3 7 7.25c0 .41.34.75.75.75h2.75a.75.75 0 0 0 0-1.5H9.03l.12-.1.27-.23.5-.42c.27-.24.55-.52.76-.86a2.1 2.1 0 0 0-.99-3c-1.08-.44-2.21.2-2.62 1.12a.75.75 0 0 0 1.36.61M1.75 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-1.5h-2v1.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75m10.28 2.3a.5.5 0 0 1 .47-.3h2a.5.5 0 0 1 .35.85l-1 1a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1-.12-.54M1 13.26c0-.42.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$ab8a3bd0065f6fac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2LinesCaret16Regular', "16", [
    "M7.96 3.54A.9.9 0 0 1 9 3.04c.46.13.7.8.4 1.27q-.2.32-.56.64l-.4.36-.37.31C7.6 6.06 7 6.66 7 7.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H8.17q.18-.3.58-.63l.31-.27.47-.41q.41-.36.73-.84c.61-.97.21-2.41-.95-2.77a1.9 1.9 0 0 0-2.27 1.04.5.5 0 1 0 .92.42M2 2.5a.5.5 0 1 0-1 0v5a.5.5 0 1 0 1 0v-2h3v2a.5.5 0 0 0 1 0v-5a.5.5 0 1 0-1 0v2H2zm-1 8c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5m11.04-9.2a.5.5 0 0 1 .46-.3h2a.5.5 0 0 1 .36.85l-1 1a.5.5 0 0 1-.71 0l-1-1a.5.5 0 0 1-.11-.54"
]);
const $db6ad3fef28672ff$export$f4f1ca49902fa19c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2LinesCaret20Filled', "20", [
    "M10.6 3.3c-.42-.16-.97.08-1.17.5a.75.75 0 1 1-1.36-.63 2.47 2.47 0 0 1 3.06-1.27 2.33 2.33 0 0 1 1.17 3.42c-.26.4-.6.73-.94 1l-.97.8-.45.38h2.31a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 8 8.25c0-.55.22-1 .5-1.37.26-.36.61-.67.94-.93l.42-.34q.27-.2.53-.43.45-.36.65-.68c.25-.39.08-1-.44-1.2m3.45 1.16c.1-.28.35-.46.62-.46h2.66c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82M2 16.25c0-.42.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm.75-8.75a.75.75 0 1 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-2h2v2a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 0 0-1.5 0v2h-2z"
]);
const $db6ad3fef28672ff$export$5480484af9ff5757 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2LinesCaret20Regular', "20", [
    "M2.5 2c.28 0 .5.22.5.5V5h3V2.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0V6H3v2.5a.5.5 0 1 1-1 0v-6c0-.28.23-.5.5-.5m11.55 2.46c.1-.28.35-.46.62-.46h2.66c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82M2.5 16a.5.5 0 1 0 0 1h15a.5.5 0 0 0 0-1zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m7.45-8.83c.25-.52.88-.78 1.4-.63.6.19.85.86.47 1.45q-.25.37-.68.73l-.33.29-.58.5C9.1 6.62 8.5 7.36 8.5 8.5c0 .28.22.5.5.5h3.5a.5.5 0 0 0 0-1H9.56c.13-.48.44-.87.85-1.25a14 14 0 0 1 .9-.78q.46-.4.85-.94c.7-1.08.3-2.55-1.03-2.95a2.2 2.2 0 0 0-2.58 1.16.5.5 0 1 0 .9.43"
]);
const $db6ad3fef28672ff$export$7ebd37be618c157f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2LinesCaret24Filled', "24", [
    "M12.41 4.4c.24-.52.85-.76 1.29-.6.57.24.8.97.5 1.46q-.25.39-.78.85l-.64.53-.51.43c-.73.61-1.77 1.56-1.77 2.93a1 1 0 0 0 1 1h4.25a1 1 0 1 0 0-2h-2.64q.18-.19.45-.4l.42-.36.77-.63c.4-.36.83-.78 1.14-1.29 1-1.58.23-3.7-1.45-4.37-1.58-.63-3.24.28-3.85 1.63a1 1 0 1 0 1.82.83M3 2a1 1 0 0 1 1 1v2.5h3V3a1 1 0 0 1 2 0v7a1 1 0 1 1-2 0V7.5H4V10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m14.56 3.46a.8.8 0 0 1 .69-.46h3a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5a.8.8 0 0 1-.16-.82M2 20a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$3356a594ddaecc30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader2LinesCaret24Regular', "24", [
    "M11.93 4.35c.3-.66 1.12-1.02 1.77-.77.78.3 1.09 1.26.67 1.91q-.3.45-.87.94l-.7.57-.53.43c-.42.34-.85.73-1.18 1.17-.33.45-.59 1-.59 1.65 0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.46q.34-.44.93-.92l.47-.37.79-.64c.42-.37.84-.78 1.15-1.27.96-1.5.22-3.49-1.39-4.12a2.95 2.95 0 0 0-3.67 1.54.75.75 0 0 0 1.36.63M2.75 2c.41 0 .75.34.75.75V5.5h4V2.75a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0V7h-4v3.25a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m14.8 3.46a.8.8 0 0 1 .7-.46h3a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5a.8.8 0 0 1-.16-.82M2.76 19a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM2 14.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$16b5af259ca83e19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader320Filled', "20", [
    "M14.75 3.5c2.04 0 3.75 1.6 3.75 3.63 0 1.18-.58 2.21-1.47 2.87.89.66 1.47 1.7 1.47 2.88 0 2.03-1.71 3.62-3.75 3.62-1.61 0-3.2-1-3.71-2.51a.75.75 0 0 1 1.42-.48c.27.81 1.23 1.49 2.29 1.49 1.27 0 2.25-.98 2.25-2.12s-.98-2.13-2.25-2.13h-1a.75.75 0 0 1 0-1.5h1c1.27 0 2.25-.98 2.25-2.12S16.02 5 14.75 5c-1.06 0-2.02.68-2.29 1.49A.75.75 0 0 1 11.04 6a3.9 3.9 0 0 1 3.71-2.51m-5.5.5c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V10.5h-5v4.75a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 1.5 0V9h5V4.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$1e19db307df0217e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader320Regular', "20", [
    "M14.5 3.5a3.5 3.5 0 0 1 1.8 6.5 3.5 3.5 0 0 1-1.8 6.5c-1.4 0-2.8-.83-3.37-2.08l-.1-.25-.03-.1a.5.5 0 0 1 .93-.33l.04.1.07.17c.4.85 1.4 1.49 2.46 1.49a2.5 2.5 0 0 0 .25-4.99l-.25-.01h-1a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0 0-5c-1.05 0-2.06.64-2.46 1.5l-.07.17a.5.5 0 0 1-.94-.34l.1-.25A3.8 3.8 0 0 1 14.5 3.5m-5 .5c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0V10H3v5.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 1 0V9h6V4.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$e37d9348ac4c1a44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader324Filled', "24", [
    "M17.5 4.5c2.41 0 4.5 1.83 4.5 4.25 0 1.33-.63 2.48-1.6 3.25.97.77 1.6 1.92 1.6 3.25 0 2.42-2.09 4.25-4.5 4.25-1.75 0-3.69-.97-4.41-2.59a1 1 0 0 1 1.82-.82c.33.73 1.43 1.41 2.59 1.41 1.45 0 2.5-1.08 2.5-2.25S18.95 13 17.5 13H17a1 1 0 0 1 0-2h.5c1.45 0 2.5-1.08 2.5-2.25S18.95 6.5 17.5 6.5c-1.16 0-2.26.68-2.59 1.41a1 1 0 0 1-1.82-.82c.72-1.62 2.66-2.59 4.4-2.59M11 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-5H4v5a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0v5h6V6a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$1089ba22db958350 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader324Regular', "24", [
    "M17.75 4.5A4.2 4.2 0 0 1 22 8.63c0 1.4-.72 2.63-1.81 3.37A4 4 0 0 1 22 15.38c0 2.3-1.93 4.12-4.25 4.12-.85 0-1.71-.24-2.45-.65a4 4 0 0 1-1.73-1.79.75.75 0 0 1 1.36-.63q.31.65 1.1 1.1c.53.3 1.15.47 1.72.47 1.55 0 2.75-1.2 2.75-2.62s-1.2-2.63-2.75-2.63h-1a.75.75 0 0 1 0-1.5h1c1.55 0 2.75-1.2 2.75-2.62S19.3 6 17.75 6c-.57 0-1.19.17-1.71.46-.53.3-.92.7-1.1 1.1a.75.75 0 0 1-1.37-.62c.35-.77 1-1.38 1.73-1.79.74-.4 1.6-.65 2.45-.65m-7 .5c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V12.5H3.5v5.75a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 1.5 0V11H10V5.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$164f9aacfcf2903f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3Lines16Filled', "16", [
    "M8.3 3.64c.4-.42.78-.44 1.08-.34q.26.1.34.3.08.17-.04.37a.6.6 0 0 1-.35.23q-.22.05-.4.05h-.08a.75.75 0 0 0 0 1.5h.09q.17 0 .39.05.23.05.35.23.12.2.04.37a.5.5 0 0 1-.34.3c-.3.1-.68.08-1.09-.34a.75.75 0 1 0-1.08 1.03c.81.86 1.8 1.01 2.64.73C11 7.75 11.7 6.38 10.93 5.2l-.15-.2.15-.2c.77-1.18.07-2.55-1.08-2.92a2.5 2.5 0 0 0-2.64.73.75.75 0 1 0 1.08 1.03M1.74 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 1 1 1.5 0v4.5a.75.75 0 1 1-1.5 0v-1.5h-2v1.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75M1 13.25c0-.42.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$ffdfbf2b815a224c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3Lines16Regular', "16", [
    "M2 2.5a.5.5 0 1 0-1 0v5a.5.5 0 1 0 1 0v-2h3v2a.5.5 0 0 0 1 0v-5a.5.5 0 1 0-1 0v2H2zm-1 8c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5M9.39 3.05a1.6 1.6 0 0 0-1.53.41.5.5 0 0 1-.72-.69 2.6 2.6 0 0 1 2.54-.68c.54.17.97.54 1.18 1.02.22.49.19 1.06-.17 1.56q-.14.2-.3.33.16.14.3.33c.36.5.39 1.07.17 1.56-.2.48-.64.85-1.18 1.02-.8.24-1.89 0-2.54-.68a.5.5 0 1 1 .72-.7c.38.41 1.07.56 1.53.42a.9.9 0 0 0 .56-.46.6.6 0 0 0-.07-.58 1 1 0 0 0-.58-.35 3 3 0 0 0-.77-.06H8.5a.5.5 0 1 1 0-1h.26q.27 0 .54-.06a1 1 0 0 0 .58-.35q.2-.3.07-.58a.9.9 0 0 0-.56-.46"
]);
const $db6ad3fef28672ff$export$13ade19b4edb82f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3Lines20Filled', "20", [
    "M9.3 3.77c.52-.56 1.01-.59 1.42-.45.5.16.65.67.42 1.03a.8.8 0 0 1-.5.34q-.26.07-.5.06h-.09a.75.75 0 0 0 0 1.5h.1q.22 0 .5.06a.8.8 0 0 1 .49.34c.23.36.08.87-.42 1.03-.4.14-.9.1-1.42-.45a.75.75 0 0 0-1.1 1.03c.93.99 2.04 1.16 3 .85 1.28-.43 2.04-1.98 1.2-3.28l-.26-.33q.14-.14.26-.33c.84-1.3.08-2.85-1.2-3.28a2.8 2.8 0 0 0-3 .85.75.75 0 1 0 1.1 1.03M2 16.25c0-.42.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm.75-8.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-2h2v2a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 1 0-1.5 0v2h-2z"
]);
const $db6ad3fef28672ff$export$63206b9a5a29eeb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3Lines20Regular', "20", [
    "M2.5 2c.28 0 .5.22.5.5V5h3V2.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0V6H3v2.5a.5.5 0 1 1-1 0v-6c0-.28.23-.5.5-.5m0 14a.5.5 0 1 0 0 1h15a.5.5 0 0 0 0-1zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m8.73-9.44c-.56-.17-1.4.01-1.86.52a.5.5 0 0 1-.74-.68 3 3 0 0 1 2.9-.79c.6.19 1.09.62 1.32 1.16.24.56.2 1.2-.19 1.77q-.2.28-.43.46.24.18.43.46c.4.57.43 1.22.2 1.77-.24.54-.72.97-1.34 1.16-.9.29-2.15.01-2.89-.79a.5.5 0 0 1 .74-.68c.47.51 1.3.7 1.86.52.35-.1.6-.35.7-.6a.8.8 0 0 0-.09-.81c-.31-.45-.82-.52-1.38-.53h-.21a.5.5 0 1 1 0-1h.21c.56 0 1.07-.07 1.38-.53a.8.8 0 0 0 .1-.8c-.12-.26-.36-.5-.71-.6"
]);
const $db6ad3fef28672ff$export$6a37e42c0d060dd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3Lines24Filled', "24", [
    "M14.57 3.81a1.9 1.9 0 0 0-1.83.53 1 1 0 1 1-1.48-1.33 3.9 3.9 0 0 1 3.92-1.1c1.68.53 2.74 2.51 1.6 4.22q-.15.2-.3.37l.3.37c1.14 1.71.08 3.7-1.6 4.23a3.9 3.9 0 0 1-3.92-1.1 1 1 0 0 1 1.48-1.34c.47.52 1.31.7 1.83.53.32-.1.53-.31.62-.53a.7.7 0 0 0-.08-.67c-.28-.42-.74-.48-1.46-.49h-.14a1 1 0 0 1 0-2h.14c.72 0 1.18-.07 1.46-.49a.7.7 0 0 0 .08-.66 1 1 0 0 0-.62-.54M4 3a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0V7.5h3V10a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0v2.5H4zM3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zm-1-4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$1af3c03541832102 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3Lines24Regular', "24", [
    "M3.5 2.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0V7h4v3.24a.75.75 0 0 0 1.5 0V2.75a.75.75 0 1 0-1.5 0V5.5h-4zm-1.5 17c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M2.75 14a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM14.59 3.58c-.69-.2-1.72.01-2.3.61a.75.75 0 0 1-1.08-1.03A4 4 0 0 1 15 2.14c.82.25 1.47.8 1.79 1.52.32.74.27 1.6-.26 2.35q-.21.28-.45.5.24.2.45.49c.53.74.58 1.6.26 2.34a2.8 2.8 0 0 1-1.78 1.52c-1.2.36-2.83.02-3.81-1.02a.75.75 0 1 1 1.08-1.03c.58.6 1.61.82 2.3.62.42-.13.71-.4.83-.7a.9.9 0 0 0-.1-.86c-.4-.55-1.06-.61-1.84-.62h-.12a.75.75 0 0 1 0-1.5h.12c.78 0 1.45-.06 1.84-.61q.3-.46.1-.87a1.3 1.3 0 0 0-.83-.7"
]);
const $db6ad3fef28672ff$export$8b4ba92217f43bf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3LinesCaret16Filled', "16", [
    "M8.3 3.64c.4-.42.78-.44 1.08-.34q.26.1.34.3.08.17-.04.37a.6.6 0 0 1-.35.23q-.22.05-.4.05h-.08a.75.75 0 0 0 0 1.5h.09q.17 0 .39.05.23.05.35.23.12.2.04.37a.5.5 0 0 1-.34.3c-.3.1-.68.08-1.09-.34a.75.75 0 1 0-1.08 1.03c.81.86 1.8 1.01 2.64.73C11 7.75 11.7 6.38 10.93 5.2l-.15-.2.15-.2c.77-1.18.07-2.55-1.08-2.92a2.5 2.5 0 0 0-2.64.73.75.75 0 1 0 1.08 1.03M1.74 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 1 1 1.5 0v4.5a.75.75 0 1 1-1.5 0v-1.5h-2v1.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75m10.28 2.3a.5.5 0 0 1 .47-.3h2a.5.5 0 0 1 .35.85l-1 1a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1-.12-.54M1 13.26c0-.42.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$6830d3407e8be5fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3LinesCaret16Regular', "16", [
    "M2 2.5a.5.5 0 1 0-1 0v5a.5.5 0 1 0 1 0v-2h3v2a.5.5 0 0 0 1 0v-5a.5.5 0 1 0-1 0v2H2zm-1 8c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5m11.04-9.2a.5.5 0 0 1 .46-.3h2a.5.5 0 0 1 .36.85l-1 1a.5.5 0 0 1-.71 0l-1-1a.5.5 0 0 1-.11-.54M9.39 3.06a1.6 1.6 0 0 0-1.53.41.5.5 0 0 1-.72-.69 2.6 2.6 0 0 1 2.54-.68c.54.17.97.54 1.18 1.02.22.49.19 1.06-.17 1.56q-.14.2-.3.33.16.14.3.33c.36.5.39 1.07.17 1.56-.2.48-.64.85-1.18 1.02-.8.24-1.89 0-2.54-.68a.5.5 0 1 1 .72-.7c.38.41 1.07.56 1.53.42a.9.9 0 0 0 .56-.46.6.6 0 0 0-.07-.58 1 1 0 0 0-.58-.35 3 3 0 0 0-.77-.06H8.5a.5.5 0 1 1 0-1h.26q.27 0 .54-.06a1 1 0 0 0 .58-.35q.2-.3.07-.58a.9.9 0 0 0-.56-.46"
]);
const $db6ad3fef28672ff$export$24c40eda2dc06797 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3LinesCaret20Filled', "20", [
    "M9.3 3.77c.52-.56 1.01-.59 1.42-.45.5.16.65.67.42 1.03a.8.8 0 0 1-.5.34q-.26.07-.5.06h-.09a.75.75 0 0 0 0 1.5h.1q.22 0 .5.06a.8.8 0 0 1 .49.34c.23.36.08.87-.42 1.03-.4.14-.9.1-1.42-.45a.75.75 0 0 0-1.1 1.03c.93.99 2.04 1.16 3 .85 1.28-.43 2.04-1.98 1.2-3.28l-.26-.33q.14-.14.26-.33c.84-1.3.08-2.85-1.2-3.28a2.8 2.8 0 0 0-3 .85.75.75 0 1 0 1.1 1.03m4.75.7c.1-.29.35-.47.62-.47h2.66c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82M2 16.24c0-.42.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75-4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm.75-8.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-2h2v2a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 1 0-1.5 0v2h-2z"
]);
const $db6ad3fef28672ff$export$c76a345291db1758 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3LinesCaret20Regular', "20", [
    "M2.5 2c.28 0 .5.22.5.5V5h3V2.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0V6H3v2.5a.5.5 0 1 1-1 0v-6c0-.28.23-.5.5-.5m11.55 2.46c.1-.28.35-.46.62-.46h2.66c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82M2.5 16a.5.5 0 1 0 0 1h15a.5.5 0 0 0 0-1zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m8.73-9.44c-.56-.17-1.4.01-1.86.52a.5.5 0 0 1-.74-.68 3 3 0 0 1 2.9-.79c.6.19 1.09.62 1.32 1.16.24.56.2 1.2-.19 1.77q-.2.28-.43.46.24.18.43.46c.4.57.43 1.22.2 1.77-.24.54-.72.97-1.34 1.16-.9.29-2.15.01-2.89-.79a.5.5 0 0 1 .74-.68c.47.51 1.3.7 1.86.52.35-.1.6-.35.7-.6a.8.8 0 0 0-.09-.81c-.31-.45-.82-.52-1.38-.53h-.21a.5.5 0 1 1 0-1h.21c.56 0 1.07-.07 1.38-.53a.8.8 0 0 0 .1-.8c-.12-.26-.36-.5-.71-.6"
]);
const $db6ad3fef28672ff$export$d77cb33ea5f5b2fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3LinesCaret24Filled', "24", [
    "M12 4.34c.46-.51 1.3-.7 1.83-.53.31.1.52.32.62.54q.14.3-.08.66c-.28.42-.74.49-1.47.5h-.13a1 1 0 1 0 0 2h.13c.73 0 1.19.06 1.47.48q.22.35.08.67c-.1.22-.3.43-.62.53a1.9 1.9 0 0 1-1.84-.53A1 1 0 0 0 10.51 10c1 1.11 2.67 1.5 3.93 1.1 1.67-.54 2.74-2.52 1.59-4.23l-.3-.37q.15-.16.3-.37c1.15-1.7.08-3.69-1.6-4.22A3.9 3.9 0 0 0 10.52 3a1 1 0 0 0 1.48 1.33M3 2a1 1 0 0 1 1 1v2.5h3V3a1 1 0 0 1 2 0v7a1 1 0 1 1-2 0V7.5H4V10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m14.56 3.46a.8.8 0 0 1 .69-.46h3a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5a.8.8 0 0 1-.16-.82M2 20a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$2fd1c93c260d524a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader3LinesCaret24Regular', "24", [
    "M2.75 2c.41 0 .75.34.75.75V5.5h4V2.75a.75.75 0 1 1 1.5 0v7.5a.75.75 0 0 1-1.5 0V7h-4v3.25a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m14.8 3.46a.8.8 0 0 1 .7-.46h3a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5a.8.8 0 0 1-.16-.82M2.76 19a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM2 14.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m9.8-10.56c.57-.6 1.6-.82 2.29-.61.42.13.71.4.83.69q.2.4-.1.87c-.4.55-1.06.6-1.84.61h-.12a.75.75 0 0 0 0 1.5h.12c.78 0 1.45.07 1.84.62q.3.46.1.87a1.3 1.3 0 0 1-.83.69c-.69.2-1.72-.02-2.3-.62a.75.75 0 0 0-1.08 1.03 4 4 0 0 0 3.8 1.02 2.8 2.8 0 0 0 1.79-1.52c.32-.73.27-1.6-.26-2.34q-.21-.3-.45-.5.24-.2.45-.5c.53-.74.58-1.6.26-2.34a2.8 2.8 0 0 0-1.78-1.52 4 4 0 0 0-3.81 1.02.75.75 0 1 0 1.08 1.03"
]);
const $db6ad3fef28672ff$export$afbd7a1dc5b89cba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader420Filled', "20", [
    "M8.75 4c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V10.5H3v4.75a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 1.5 0V9h5V4.75c0-.41.34-.75.75-.75m7.03.33c.6-.63 1.72-.23 1.72.7V12h1.33a.75.75 0 0 1 0 1.5H17.5v1.75a.75.75 0 0 1-1.5 0V13.5h-4.53a1 1 0 0 1-.83-1.56l5.03-7.47zM12.41 12H16V6.66z"
]);
const $db6ad3fef28672ff$export$edbeb61874f29dbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader420Regular', "20", [
    "M15.71 4.23c.45-.47 1.3-.17 1.3.52V12h1.5a.5.5 0 0 1 0 1H17v2.5a.5.5 0 0 1-1 0V13h-4.32a1 1 0 0 1-.83-1.56l4.77-7.1zM9.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0V10H3v5.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 1 0V9h6V4.5c0-.28.22-.5.5-.5m2.19 8H16V5.58z"
]);
const $db6ad3fef28672ff$export$b06454115e4367f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader424Filled', "24", [
    "M11 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-5H4v5a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0v5h6V6a1 1 0 0 1 1-1m7.8.44c.73-.87 2.2-.37 2.2.81V14h1.1a1 1 0 0 1 0 2H21v2a1 1 0 0 1-2 0v-2h-4.74a1.5 1.5 0 0 1-1.22-2.36l5.7-8.1zM15.23 14H19V8.62z"
]);
const $db6ad3fef28672ff$export$10e40bd03c7828e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader424Regular', "24", [
    "M10.75 5c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V12.5H3.5v5.75a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 1.5 0V11H10V5.75c0-.41.34-.75.75-.75m8.55.3A1 1 0 0 1 21 6v8.5h1.25a.75.75 0 0 1 0 1.5H21v2.25a.75.75 0 0 1-1.5 0V16h-5.34a1.25 1.25 0 0 1-1.02-1.97l6.05-8.6zm-4.66 9.2h4.86V7.58z"
]);
const $db6ad3fef28672ff$export$ff62de7def93a5da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader4LinesCaret16Filled', "16", [
    "M14.25 12.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5zm0-3a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5zM1.75 2c.41 0 .75.34.75.75v1.5h2v-1.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-1.5h-2v1.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75m7.91.29a.75.75 0 0 1 1.34.46V5.5h.25a.75.75 0 0 1 0 1.5H11v.25a.75.75 0 0 1-1.5 0V7h-2a.75.75 0 0 1-.59-1.21zM14.5 4a.5.5 0 0 1 .35.85l-1 1a.5.5 0 0 1-.7 0l-1-1A.5.5 0 0 1 12.5 4zM9.04 5.5h.46v-.58z"
]);
const $db6ad3fef28672ff$export$b5b4372db2ff1903 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader4LinesCaret16Regular', "16", [
    "M14.5 13a.5.5 0 0 1 0 1h-13a.5.5 0 1 1 0-1zm0-3a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1zm-13-8c.28 0 .5.22.5.5v2h3v-2a.5.5 0 0 1 1 0v5a.5.5 0 1 1-1 0v-2H2v2a.5.5 0 0 1-1 0v-5c0-.28.23-.5.5-.5m8.6.2a.5.5 0 0 1 .9.3V6h.5l.1.01a.5.5 0 0 1 0 .98l-.1.01H11v.5a.5.5 0 0 1-1 0V7H7.5a.5.5 0 0 1-.4-.8zM14.5 4a.5.5 0 0 1 .36.85l-1 1a.5.5 0 0 1-.71 0l-1-1A.5.5 0 0 1 12.5 4zm-6 2H10V4z"
]);
const $db6ad3fef28672ff$export$469dc50f3ba63163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader4LinesCaret20Filled', "20", [
    "M17.25 15.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0-4a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm-6.08-9.22a.75.75 0 0 1 1.33.47V6a.75.75 0 0 1 0 1.5v.75a.75.75 0 0 1-1.5 0V7.5H8.5a.75.75 0 0 1-.58-1.22zM2.75 2c.41 0 .75.34.75.75v2h2v-2a.75.75 0 1 1 1.5 0v5.5a.75.75 0 0 1-1.5 0v-2h-2v2a.75.75 0 1 1-1.5 0v-5.5c0-.41.34-.75.75-.75m14.58 2c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82c.1-.28.35-.46.62-.46zm-7.25 2H11V4.86z"
]);
const $db6ad3fef28672ff$export$73ea771c2cda4e74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader4LinesCaret20Regular', "20", [
    "M17.5 16a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-15a.5.5 0 1 1 0-1zm-6.4-9.8a.5.5 0 0 1 .9.3V6h.5a.5.5 0 0 1 0 1H12v1.5a.5.5 0 0 1-1 0V7H8.5a.5.5 0 0 1-.4-.8zM2.5 2c.28 0 .5.22.5.5V5h3V2.5a.5.5 0 0 1 1 0v6a.5.5 0 1 1-1 0V6H3v2.5a.5.5 0 0 1-1 0v-6c0-.28.23-.5.5-.5m14.83 2c.27 0 .52.18.62.46s.05.6-.15.82l-1.33 1.5c-.26.3-.68.3-.94 0l-1.33-1.5a.8.8 0 0 1-.15-.82c.1-.28.35-.46.62-.46zM9.5 6H11V4z"
]);
const $db6ad3fef28672ff$export$b353cfdc8cb8d954 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader4LinesCaret24Filled', "24", [
    "M21 19a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zM3 2a1 1 0 0 1 1 1v2.5h3V3a1 1 0 0 1 2 0v7a1 1 0 0 1-2 0V7.5H4V10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m11.22.38A1 1 0 0 1 16 3v4a1 1 0 1 1 0 2v1a1 1 0 1 1-2 0V9h-3a1 1 0 0 1-.78-1.62zM21.25 5a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5A.75.75 0 0 1 18.25 5zm-8.17 2H14V5.85z"
]);
const $db6ad3fef28672ff$export$aedbec2747b140c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader4LinesCaret24Regular', "24", [
    "M21.25 19a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0-5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zM2.75 2c.41 0 .75.34.75.75V5.5h4V2.75a.75.75 0 0 1 1.5 0v7.5a.75.75 0 1 1-1.5 0V7h-4v3.25a.75.75 0 0 1-1.5 0v-7.5c0-.41.33-.75.75-.75m11.4.3a.75.75 0 0 1 1.35.45V7.5h.75a.75.75 0 0 1 0 1.5h-.75v1.25a.75.75 0 0 1-1.5 0V9h-3.25a.75.75 0 0 1-.6-1.2zm7.1 2.7a.75.75 0 0 1 .53 1.28l-1.5 1.5c-.3.3-.77.3-1.06 0l-1.5-1.5A.75.75 0 0 1 18.25 5zm-9.03 2.5H14V5.06z"
]);
const $db6ad3fef28672ff$export$f58039423ef6affe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader520Filled', "20", [
    "M17.33 4a.75.75 0 0 1 0 1.5h-4l-.25 2.49h.44c.64 0 1.45 0 1.82.05l.22.04a4.25 4.25 0 1 1-4.32 6.56l-.13-.2-.04-.06a.75.75 0 0 1 1.28-.78l.04.07.09.12a2.74 2.74 0 0 0 5-1.16 2.75 2.75 0 0 0-2.07-3.05l-.28-.05c-.23-.04-.92-.05-1.61-.04h-1.25a.75.75 0 0 1-.77-.82l.4-4a.75.75 0 0 1 .75-.67h4.68M9.25 4c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V10.5h-5v4.75a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 1.5 0V9h5V4.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$b95151aef748ca8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader520Regular', "20", [
    "M17.25 4a.5.5 0 0 1 0 1H13.1l-.3 2.99h.7c.65-.01 1.45 0 1.84.05l.22.04a4.25 4.25 0 1 1-4.5 6.3l-.03-.1a.5.5 0 0 1 .9-.4l.1.15a3.24 3.24 0 0 0 5.94-1.33 3.25 3.25 0 0 0-2.6-3.64l-.17-.03c-.3-.04-1.02-.05-1.7-.05l-.87.01h-.34l-.02.01a.5.5 0 0 1-.52-.44v-.11l.4-4a.5.5 0 0 1 .5-.45zM9.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0V10H3v5.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 1 0V9h6V4.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$3cdce36f24e15b7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader524Filled', "24", [
    "M20.1 5a1 1 0 0 1-.1 2h-4.1l-.3 2.99h.4c.76-.01 1.73 0 2.16.06l.24.04a4.75 4.75 0 1 1-5.21 6.66l-.12-.3-.03-.09a1 1 0 0 1 1.85-.72l.04.1.07.17a2.75 2.75 0 1 0 3.16-3.83l-.28-.05c-.26-.04-1.05-.05-1.88-.05l-1.03.01h-.45V12a1 1 0 0 1-1.02-1v-.1l.5-5a1 1 0 0 1 1-.9h5.1M11 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-5H4v5a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0v5h6V6a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$21eaa6e3730fdbbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader524Regular', "24", [
    "M10.75 5c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V12.5H3.5v5.75a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 1.5 0V11H10V5.75c0-.41.34-.75.75-.75m9.5 0a.75.75 0 0 1 0 1.5h-4.57l-.35 3.49.67-.01c.77 0 1.73 0 2.16.07l.24.04a4.75 4.75 0 1 1-5.36 6.3.75.75 0 0 1 1.4-.52 3.25 3.25 0 1 0 3.68-4.31l-.17-.03a21 21 0 0 0-1.95-.05l-1.04.01h-.44a.75.75 0 0 1-.77-.82l.5-5A.75.75 0 0 1 15 5z"
]);
const $db6ad3fef28672ff$export$2f38f55de822de2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader620Filled', "20", [
    "M14.5 3.5q1.42 0 2.41.67a4 4 0 0 1 1.43 1.78.75.75 0 0 1-1.37.6 2.6 2.6 0 0 0-.9-1.14A2.7 2.7 0 0 0 14.5 5q-.95.02-1.47.35-.53.3-.87.94a7 7 0 0 0-.64 2.93 4.24 4.24 0 0 1 7.23 3.03 4.25 4.25 0 0 1-4.47 4.24 3.85 3.85 0 0 1-3.44-2.07l-.06-.1q-.3-.56-.43-1.17C10.09 12.19 10 11.1 10 10c0-1.62.19-3.21.84-4.42A3.9 3.9 0 0 1 14.5 3.5M8.25 4c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V10.5h-5v4.75a.75.75 0 0 1-1.5 0V4.75a.75.75 0 0 1 1.5 0V9h5V4.75c0-.41.34-.75.75-.75m6.25 5.5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5"
]);
const $db6ad3fef28672ff$export$e618a889b950b294 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader620Regular', "20", [
    "M15 3.5c1.62 0 2.77.8 3.5 2.02l.14.25.03.1a.5.5 0 0 1-.86.45l-.06-.09-.1-.2A2.9 2.9 0 0 0 15 4.5c-1.22 0-2.06.56-2.63 1.51A8 8 0 0 0 11.5 10v.19A4 4 0 0 1 15 8c2.24 0 4 1.94 4 4.25s-1.76 4.25-4 4.25h-.22a3.9 3.9 0 0 1-3.27-2A9 9 0 0 1 10.5 10c0-1.7.3-3.3 1.01-4.5.73-1.22 1.89-2 3.49-2M8.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0V10H2v5.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 1 0V9h6V4.5c0-.28.22-.5.5-.5M15 9c-1.62 0-3 1.42-3 3.25 0 1.77 1.28 3.15 2.84 3.24l.16.01c1.62 0 3-1.42 3-3.25S16.62 9 15 9"
]);
const $db6ad3fef28672ff$export$bcd820c5369e15be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader624Filled', "24", [
    "M17.5 4.5c1.54 0 2.8.63 3.7 1.67l.18.21.05.08a1 1 0 0 1-1.56 1.24l-.07-.08-.1-.13a2.8 2.8 0 0 0-2.2-.99c-1.12 0-1.94.52-2.53 1.44a7 7 0 0 0-.91 2.94 4.98 4.98 0 0 1 8.44 3.62 5 5 0 0 1-5.5 4.97h-.01a4.8 4.8 0 0 1-3.8-2.44A10 10 0 0 1 12 12c0-1.91.4-3.75 1.28-5.13A4.9 4.9 0 0 1 17.5 4.5M10 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0v-5H3v5a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0v5h6V6a1 1 0 0 1 1-1m7.5 6.5a3 3 0 0 0-2.5 4.65l.03.05a3 3 0 0 0 2.3 1.3h.17a3 3 0 1 0 0-6"
]);
const $db6ad3fef28672ff$export$5a29b50400272df2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextHeader624Regular', "24", [
    "M18 4.5c1.76 0 3.11.8 4.03 2.08l.18.26.04.07a.75.75 0 0 1-1.26.8l-.05-.06-.12-.19A3.3 3.3 0 0 0 18 6c-1.3 0-2.27.6-2.93 1.63-.62.96-1 2.3-1.06 3.85a5 5 0 1 1 3.7 8.01h-.06a4.8 4.8 0 0 1-3.88-2.31A9.7 9.7 0 0 1 12.5 12c0-1.96.41-3.8 1.3-5.18A4.8 4.8 0 0 1 18 4.5m-7.75.5c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V12.5H3v5.75a.75.75 0 0 1-1.5 0V5.75a.75.75 0 0 1 1.5 0V11h6.5V5.75c0-.41.34-.75.75-.75M18 11a3.5 3.5 0 0 0-.18 7H18a3.5 3.5 0 1 0 0-7"
]);
const $db6ad3fef28672ff$export$f07f68e1fedde84e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecrease16Filled', "16", [
    "M5.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM2.72 5.72a.75.75 0 0 1 1.06 1.06l-.97.97.97.97a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$bb438f6b9cbd872e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecrease16Regular', "16", [
    "M11.5 3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zm3 4a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm-5 4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zM2.65 5.65a.5.5 0 0 1 .7.7L2.21 7.5l1.14 1.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$4178e4759e8cd80b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecrease20Filled', "20", [
    "M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 6 4.75M6.75 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm-3.28-2.22a.75.75 0 0 0 1.06-1.06l-.97-.97.97-.97a.75.75 0 0 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$ec881c45aedf6b0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecrease20Regular', "20", [
    "M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5M3.56 7.73a.5.5 0 0 1 .7.7L3.22 9.5l1.06 1.06a.5.5 0 1 1-.7.7l-1.42-1.4a.5.5 0 0 1 0-.71zM6.5 9a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1zM6 14.5c0-.28.22-.5.5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$962c6aec9b8d313f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecrease24Filled', "24", [
    "M9 16h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5zm-6.7-4.7 2-2a1 1 0 0 1 1.49 1.31l-.08.1L4.4 12l1.3 1.3a1 1 0 0 1-1.32 1.49l-.1-.08-2-2a1 1 0 0 1-.08-1.32zl2-2zM9 11h11.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh11.5zm0-5h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$940ee8c2eaf5c7d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecrease24Regular', "24", [
    "M17.75 16a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5zM2.72 11.22l2-2a.75.75 0 0 1 1.13.98l-.07.08-1.47 1.47 1.47 1.47a.75.75 0 0 1-.98 1.13l-.08-.07-2-2a.75.75 0 0 1-.07-.98zl2-2zM20.75 11a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1 0-1.5zm-3-5a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$3721c8c28c3ad1ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr16Filled', "16", [
    "M5.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM2.72 5.72a.75.75 0 0 1 1.06 1.06l-.97.97.97.97a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06z"
]);
const $db6ad3fef28672ff$export$e52b57ea4a0cf4a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr16Regular', "16", [
    "M11.5 3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zm3 4a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm-5 4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zM2.65 5.65a.5.5 0 0 1 .7.7L2.21 7.5l1.14 1.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7z"
]);
const $db6ad3fef28672ff$export$c64b660a50a980a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr20Filled', "20", [
    "M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 6 4.75M6.75 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm-3.28-2.22a.75.75 0 0 0 1.06-1.06l-.97-.97.97-.97a.75.75 0 0 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06z"
]);
const $db6ad3fef28672ff$export$f2010cb49acd220a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr20Regular', "20", [
    "M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5M3.56 7.73a.5.5 0 0 1 .7.7L3.22 9.5l1.06 1.06a.5.5 0 1 1-.7.7l-1.42-1.4a.5.5 0 0 1 0-.71zM6.5 9a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1zM6 14.5c0-.28.22-.5.5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$460a0da25651635c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr24Filled', "24", [
    "M9 16h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5zm-6.7-4.7 2-2a1 1 0 0 1 1.49 1.31l-.08.1L4.4 12l1.3 1.3a1 1 0 0 1-1.32 1.49l-.1-.08-2-2a1 1 0 0 1-.08-1.32zl2-2zM9 11h11.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh11.5zm0-5h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5z"
]);
const $db6ad3fef28672ff$export$d3135f6f09595 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr24Regular', "24", [
    "M17.75 16a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5zM2.72 11.22l2-2a.75.75 0 0 1 1.13.98l-.07.08-1.47 1.47 1.47 1.47a.75.75 0 0 1-.98 1.13l-.08-.07-2-2a.75.75 0 0 1-.07-.98zl2-2zM20.75 11a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1 0-1.5zm-3-5a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$8072d9d8b19a985a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr9020Filled', "20", [
    "M10.97 4.78a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 0 0 1.06 1.06l.97-.97zM6.25 7.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zM10 7c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$9c70055e18234359 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr9020Regular', "20", [
    "M11.15 4.85a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 1 0 .7.7L10 3.71zM6 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-5.5 0a.5.5 0 0 1 1 0v10a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$1da91a51c19a2e74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr9024Filled', "24", [
    "M8 9v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm4.7-6.7 2 2a1 1 0 0 1-1.31 1.49l-.1-.08L12 4.4l-1.3 1.3a1 1 0 0 1-1.49-1.32l.08-.1 2-2a1 1 0 0 1 1.32-.08zM13 9v11.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm5 0v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12z"
]);
const $db6ad3fef28672ff$export$58703d2ea86aec1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtr9024Regular', "24", [
    "M8 17.75a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0zm4.78-15.03 2 2a.75.75 0 0 1-.98 1.13l-.08-.07-1.47-1.47-1.47 1.47a.75.75 0 0 1-1.13-.98l.07-.08 2-2a.75.75 0 0 1 .98-.07zM13 20.75a.75.75 0 0 1-1.5 0v-12a.75.75 0 0 1 1.5 0zm5-3a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0z"
]);
const $db6ad3fef28672ff$export$dbbfe5b60925e53d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtrRotate27020Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M6.25 5.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-6.22 9.47a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.97.97z"
]);
const $db6ad3fef28672ff$export$f37f56bd81ac43a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtrRotate27020Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v10a.5.5 0 0 1-1 0v-10c0-.28.22-.5.5-.5M6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-6.15 9.65a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7L10 16.29z"
]);
const $db6ad3fef28672ff$export$136ff66809c4225f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtrRotate27024Filled', "24", [
    "M16 15V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-4.7 6.7-2-2a1 1 0 0 1 1.31-1.49l.1.08L12 19.6l1.3-1.3a1 1 0 0 1 1.49 1.32l-.08.1-2 2a1 1 0 0 1-1.32.08zM11 15V3.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-5 0V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12z"
]);
const $db6ad3fef28672ff$export$c32e7393854ed1f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseLtrRotate27024Regular', "24", [
    "M16 6.25a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0zm-4.78 15.03-2-2a.75.75 0 0 1 .98-1.13l.08.07 1.47 1.47 1.47-1.47a.75.75 0 0 1 1.13.98l-.07.08-2 2a.75.75 0 0 1-.98.07zM11 3.25a.75.75 0 0 1 1.5 0v12a.75.75 0 0 1-1.5 0zm-5 3a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$68289dc7c7f93de7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate27020Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M6.25 5.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-6.22 9.47a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.97.97z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$ac5f43cc0dee2557 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate27020Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v10a.5.5 0 0 1-1 0v-10c0-.28.22-.5.5-.5M6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-6.15 9.65a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7L10 16.29z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$5bcefa823c0c9a73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate27024Filled', "24", [
    "M16 15V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-4.7 6.7-2-2a1 1 0 0 1 1.31-1.49l.1.08L12 19.6l1.3-1.3a1 1 0 0 1 1.49 1.32l-.08.1-2 2a1 1 0 0 1-1.32.08zM11 15V3.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-5 0V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$731b32cb0585c8d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate27024Regular', "24", [
    "M16 6.25a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0zm-4.78 15.03-2-2a.75.75 0 0 1 .98-1.13l.08.07 1.47 1.47 1.47-1.47a.75.75 0 0 1 1.13.98l-.07.08-2 2a.75.75 0 0 1-.98.07zM11 3.25a.75.75 0 0 1 1.5 0v12a.75.75 0 0 1-1.5 0zm-5 3a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$33f7aedcb565bfd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate9020Filled', "20", [
    "M10.97 4.78a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 0 0 1.06 1.06l.97-.97zM6.25 7.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zM10 7c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$53d8b347ce78e59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate9020Regular', "20", [
    "M11.15 4.85a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 1 0 .7.7L10 3.71zM6 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-5.5 0a.5.5 0 0 1 1 0v10a.5.5 0 0 1-1 0z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$b24e8a6ee3ad1987 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate9024Filled', "24", [
    "M8 9v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm4.7-6.7 2 2a1 1 0 0 1-1.31 1.49l-.1-.08L12 4.4l-1.3 1.3a1 1 0 0 1-1.49-1.32l.08-.1 2-2a1 1 0 0 1 1.32-.08zM13 9v11.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm5 0v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$e53d7eba78c40b9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRotate9024Regular', "24", [
    "M8 17.75a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0zm4.78-15.03 2 2a.75.75 0 0 1-.98 1.13l-.08-.07-1.47-1.47-1.47 1.47a.75.75 0 0 1-1.13-.98l.07-.08 2-2a.75.75 0 0 1 .98-.07zM13 20.75a.75.75 0 0 1-1.5 0v-12a.75.75 0 0 1 1.5 0zm5-3a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$7dcb6a80cba9befd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl16Filled', "16", [
    "M4 3.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 4 3.75m8.22 1.97c.3-.3.77-.3 1.06 0l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06M1 7.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 1 7.75m5 4c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$c253ffe41c662c0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl16Regular', "16", [
    "M4 3.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8.65 2.15c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 0-.7M1 7.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m5 4c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$aa6c13af001cbe80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl20Filled', "20", [
    "M13.25 4a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zM14 9.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0 0 1.5h10.5c.41 0 .75-.34.75-.75m0 5a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0 0 1.5h5.5c.41 0 .75-.34.75-.75m1.22-7.03c.3-.3.77-.3 1.06 0l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
]);
const $db6ad3fef28672ff$export$e4e7929c27ceca14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl20Regular', "20", [
    "M5.5 4a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm-3 5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zM7 14.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m9.45-6.76a.5.5 0 1 0-.7.7L16.8 9.5l-1.06 1.06a.5.5 0 1 0 .7.71l1.42-1.41a.5.5 0 0 0 0-.7z"
]);
const $db6ad3fef28672ff$export$10650da3c75c8941 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl24Filled', "24", [
    "M5.5 7a1 1 0 0 0 1 1h8.62A1 1 0 0 0 15 6H6.38a1 1 0 0 0-.88 1m-2 6h11.62a1 1 0 0 0-.12-2H3.38a1 1 0 0 0 .12 2m2 4a1 1 0 0 0 1 1h8.62a1 1 0 0 0-.12-2H6.38a1 1 0 0 0-.88 1m14.11-2.21a1 1 0 0 1-1.32-1.5L19.6 12l-1.3-1.3-.08-.09a1 1 0 0 1 1.5-1.32l2 2 .08.1a1 1 0 0 1-.08 1.32l-2 2z"
]);
const $db6ad3fef28672ff$export$6a8b929e300e9954 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl24Regular', "24", [
    "M5.5 16.75c0-.41.34-.75.75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75m-3-5c0-.41.34-.75.75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75m3-5c0-.41.34-.75.75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75m13.7 2.4a.75.75 0 0 0-.98 1.13l1.47 1.47-1.47 1.47-.07.08a.75.75 0 0 0 1.13.98l2-2 .07-.08c.22-.3.2-.71-.07-.98l-2-2z"
]);
const $db6ad3fef28672ff$export$882efddd09d6d8dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl9020Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M6.25 5.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-6.22 9.47a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.97.97z"
]);
const $db6ad3fef28672ff$export$8aba70a06d71c76a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl9020Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v10a.5.5 0 0 1-1 0v-10c0-.28.22-.5.5-.5M6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-6.15 9.65a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7L10 16.29z"
]);
const $db6ad3fef28672ff$export$54d3ea95f9115849 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl9024Filled', "24", [
    "M17 5.5a1 1 0 0 0-1 1v8.62a1 1 0 0 0 2-.12V6.38a1 1 0 0 0-1-.88m-6-2v11.62a1 1 0 0 0 2-.12V3.38a1 1 0 0 0-2 .12m-4 2a1 1 0 0 0-1 1v8.62A1 1 0 0 0 8 15V6.38a1 1 0 0 0-1-.88m2.21 14.11a1 1 0 0 1 1.5-1.32L12 19.6l1.3-1.3.09-.08a1 1 0 0 1 1.32 1.5l-2 2-.1.08a1 1 0 0 1-1.32-.08l-2-2z"
]);
const $db6ad3fef28672ff$export$bc6ff55412e42eb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtl9024Regular', "24", [
    "M7.25 5.5c.41 0 .75.34.75.75v9a.75.75 0 0 1-1.5 0v-9c0-.41.34-.75.75-.75m5-3c.41 0 .75.34.75.75v12a.75.75 0 0 1-1.5 0v-12c0-.41.34-.75.75-.75m5 3c.41 0 .75.34.75.75v9a.75.75 0 0 1-1.5 0v-9c0-.41.34-.75.75-.75m-2.4 13.7a.75.75 0 0 0-1.13-.98l-1.47 1.47-1.47-1.47-.08-.07a.75.75 0 0 0-.98 1.13l2 2 .08.07c.3.22.71.2.98-.07l2-2z"
]);
const $db6ad3fef28672ff$export$ee5b3529bc1047c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtlRotate27020Filled', "20", [
    "M10.97 4.78a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 0 0 1.06 1.06l.97-.97zM6.25 7.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zM10 7c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$a10e4774af271ad7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtlRotate27020Regular', "20", [
    "M11.15 4.85a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 1 0 .7.7L10 3.71zM6 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-5.5 0a.5.5 0 0 1 1 0v10a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$a7c0b2afb49dc888 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtlRotate27024Filled', "24", [
    "M7 18.5a1 1 0 0 0 1-1V8.88A1 1 0 0 0 6 9v8.62a1 1 0 0 0 1 .88m6 2V8.88A1 1 0 0 0 11 9v11.62a1 1 0 0 0 2-.12m4-2a1 1 0 0 0 1-1V8.88A1 1 0 0 0 16 9v8.62a1 1 0 0 0 1 .88M14.79 4.39a1 1 0 0 1-1.5 1.32L12 4.4l-1.3 1.3-.09.08a1 1 0 0 1-1.32-1.5l2-2 .1-.08a1 1 0 0 1 1.32.08l2 2z"
]);
const $db6ad3fef28672ff$export$1b3b5323d8634173 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentDecreaseRtlRotate27024Regular', "24", [
    "M16.75 18.5a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 1.5 0v9c0 .41-.34.75-.75.75m-5 3a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 1.5 0v12c0 .41-.34.75-.75.75m-5-3a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 1.5 0v9c0 .41-.34.75-.75.75m2.4-13.7a.75.75 0 0 0 1.13.98l1.47-1.47 1.47 1.47.08.07a.75.75 0 0 0 .98-1.13l-2-2-.08-.07a.75.75 0 0 0-.98.07l-2 2z"
]);
const $db6ad3fef28672ff$export$b856b86c03bee4c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncrease16Filled', "16", [
    "M5.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM2.28 5.72a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 0 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$5c182b472a054d54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncrease16Regular', "16", [
    "M11.5 3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zm3 4a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm-5 4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zM1.85 5.65a.5.5 0 0 0-.7.7L2.29 7.5 1.15 8.65a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$1b578f83cfa02b93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncrease20Filled', "20", [
    "M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 6 4.75M6.75 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM3.03 7.72a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 1 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$9c2c5e73b721e02d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncrease20Regular', "20", [
    "M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zM2.85 7.73a.5.5 0 1 0-.7.7L3.2 9.5l-1.06 1.06a.5.5 0 1 0 .7.7l1.42-1.4a.5.5 0 0 0 0-.71z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$79e7b6fd26b8c4f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncrease24Filled', "24", [
    "M9 16h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5zM2.3 9.3A1 1 0 0 1 3.6 9.2l.1.08 2 2a1 1 0 0 1 .08 1.32l-.08.1-2 2a1 1 0 0 1-1.5-1.32l.08-.1L3.6 12l-1.3-1.3a1 1 0 0 1 0-1.4M9 11h11.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh11.5zm0-5h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$96af0bcd46f66e92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncrease24Regular', "24", [
    "M17.75 16a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5zM2.72 9.22a.75.75 0 0 1 .98-.07l.08.07 2 2c.27.27.3.68.07.98l-.07.08-2 2a.75.75 0 0 1-1.13-.98l.07-.08 1.47-1.47-1.47-1.47a.75.75 0 0 1 0-1.06M20.75 11a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1 0-1.5zm-3-5a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$b18a9e8c078849d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr16Filled', "16", [
    "M5.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM2.28 5.72a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 0 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06z"
]);
const $db6ad3fef28672ff$export$58bbe3ea3aa166da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr16Regular', "16", [
    "M11.5 3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zm3 4a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm-5 4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zM1.85 5.65a.5.5 0 0 0-.7.7L2.29 7.5 1.15 8.65a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7z"
]);
const $db6ad3fef28672ff$export$5e3be56d08343d6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr20Filled', "20", [
    "M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 6 4.75M6.75 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM3.03 7.72a.75.75 0 0 0-1.06 1.06l.97.97-.97.97a.75.75 0 1 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06z"
]);
const $db6ad3fef28672ff$export$e321b388dded6f72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr20Regular', "20", [
    "M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zM2.85 7.73a.5.5 0 1 0-.7.7L3.2 9.5l-1.06 1.06a.5.5 0 1 0 .7.7l1.42-1.4a.5.5 0 0 0 0-.71z"
]);
const $db6ad3fef28672ff$export$b1faddcfd601ee7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr24Filled', "24", [
    "M9 16h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5zM2.3 9.3A1 1 0 0 1 3.6 9.2l.1.08 2 2a1 1 0 0 1 .08 1.32l-.08.1-2 2a1 1 0 0 1-1.5-1.32l.08-.1L3.6 12l-1.3-1.3a1 1 0 0 1 0-1.4M9 11h11.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh11.5zm0-5h8.5a1 1 0 0 1 .12 2H9a1 1 0 0 1-.12-2zh8.5z"
]);
const $db6ad3fef28672ff$export$87a40aa650e189f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr24Regular', "24", [
    "M17.75 16a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5zM2.72 9.22a.75.75 0 0 1 .98-.07l.08.07 2 2c.27.27.3.68.07.98l-.07.08-2 2a.75.75 0 0 1-1.13-.98l.07-.08 1.47-1.47-1.47-1.47a.75.75 0 0 1 0-1.06M20.75 11a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1 0-1.5zm-3-5a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$d4db16784094ed50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr9020Filled', "20", [
    "M9.03 2.22a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 0 0-1.06-1.06l-.97.97zM6.25 7.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-6 9.5v-9.5a.75.75 0 0 1 1.5 0v9.5a.75.75 0 0 1-1.5 0"
]);
const $db6ad3fef28672ff$export$6bf11147c8676e62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr9020Regular', "20", [
    "M8.85 2.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7L10 3.79zM6 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-5.5 10v-10a.5.5 0 0 1 1 0v10a.5.5 0 0 1-1 0"
]);
const $db6ad3fef28672ff$export$5952e38341a006a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr9024Filled', "24", [
    "M8 9v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm6.7-6.7a1 1 0 0 1 .09 1.31l-.08.1-2 2a1 1 0 0 1-1.32.08l-.1-.08-2-2a1 1 0 0 1 1.32-1.5l.1.08L12 3.6l1.3-1.3a1 1 0 0 1 1.4 0M13 9v11.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm5 0v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12z"
]);
const $db6ad3fef28672ff$export$d4afd670eafbee72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtr9024Regular', "24", [
    "M8 17.75a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0zm6.78-15.03c.27.27.3.68.07.98l-.07.08-2 2a.75.75 0 0 1-.98.07l-.08-.07-2-2a.75.75 0 0 1 .98-1.13l.08.07 1.47 1.47 1.47-1.47c.3-.3.77-.3 1.06 0M13 20.75a.75.75 0 0 1-1.5 0v-12a.75.75 0 0 1 1.5 0zm5-3a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0z"
]);
const $db6ad3fef28672ff$export$3a3ba1680e2b2ee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtrRotate27020Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M6.25 5.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-4.28 12.03a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 1 0 1.06 1.06l.97-.97z"
]);
const $db6ad3fef28672ff$export$eba904bef2a3f15c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtrRotate27020Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v10a.5.5 0 0 1-1 0v-10c0-.28.22-.5.5-.5M6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-3.85 11.85a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 .7.7L10 16.21z"
]);
const $db6ad3fef28672ff$export$bbbee138cd56ffba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtrRotate27024Filled', "24", [
    "M16 15V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-6.7 6.7a1 1 0 0 1-.09-1.31l.08-.1 2-2a1 1 0 0 1 1.32-.08l.1.08 2 2a1 1 0 0 1-1.32 1.5l-.1-.08L12 20.4l-1.3 1.3a1 1 0 0 1-1.4 0M11 15V3.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-5 0V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12z"
]);
const $db6ad3fef28672ff$export$f5f1179787ae029b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseLtrRotate27024Regular', "24", [
    "M16 6.25a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0zM9.22 21.28a.75.75 0 0 1-.07-.98l.07-.08 2-2a.75.75 0 0 1 .98-.07l.08.07 2 2a.75.75 0 0 1-.98 1.13l-.08-.07-1.47-1.47-1.47 1.47c-.3.3-.77.3-1.06 0M11 3.25a.75.75 0 0 1 1.5 0v12a.75.75 0 0 1-1.5 0zm-5 3a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$ab33d1a69431d5c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate27020Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M6.25 5.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-4.28 12.03a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 1 0 1.06 1.06l.97-.97z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$a1f3c7a72eb12139 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate27020Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v10a.5.5 0 0 1-1 0v-10c0-.28.22-.5.5-.5M6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-3.85 11.85a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 .7.7L10 16.21z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$b44a97aabb691d7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate27024Filled', "24", [
    "M16 15V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-6.7 6.7a1 1 0 0 1-.09-1.31l.08-.1 2-2a1 1 0 0 1 1.32-.08l.1.08 2 2a1 1 0 0 1-1.32 1.5l-.1-.08L12 20.4l-1.3 1.3a1 1 0 0 1-1.4 0M11 15V3.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zm-5 0V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$7ad534367c98a861 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate27024Regular', "24", [
    "M16 6.25a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0zM9.22 21.28a.75.75 0 0 1-.07-.98l.07-.08 2-2a.75.75 0 0 1 .98-.07l.08.07 2 2a.75.75 0 0 1-.98 1.13l-.08-.07-1.47-1.47-1.47 1.47c-.3.3-.77.3-1.06 0M11 3.25a.75.75 0 0 1 1.5 0v12a.75.75 0 0 1-1.5 0zm-5 3a.75.75 0 0 1 1.5 0v9a.75.75 0 0 1-1.5 0z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$1042124d239a24f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate9020Filled', "20", [
    "M9.03 2.22a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 0 0-1.06-1.06l-.97.97zM6.25 7.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-6 9.5v-9.5a.75.75 0 0 1 1.5 0v9.5a.75.75 0 0 1-1.5 0"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$bf1f8bba59fa701c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate9020Regular', "20", [
    "M8.85 2.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7L10 3.79zM6 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-5.5 10v-10a.5.5 0 0 1 1 0v10a.5.5 0 0 1-1 0"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$9ee2d2ba0dc49579 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate9024Filled', "24", [
    "M8 9v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm6.7-6.7a1 1 0 0 1 .09 1.31l-.08.1-2 2a1 1 0 0 1-1.32.08l-.1-.08-2-2a1 1 0 0 1 1.32-1.5l.1.08L12 3.6l1.3-1.3a1 1 0 0 1 1.4 0M13 9v11.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zm5 0v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$a19d3ed69fe6d193 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRotate9024Regular', "24", [
    "M8 17.75a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0zm6.78-15.03c.27.27.3.68.07.98l-.07.08-2 2a.75.75 0 0 1-.98.07l-.08-.07-2-2a.75.75 0 0 1 .98-1.13l.08.07 1.47 1.47 1.47-1.47c.3-.3.77-.3 1.06 0M13 20.75a.75.75 0 0 1-1.5 0v-12a.75.75 0 0 1 1.5 0zm5-3a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0z"
], {
    flipInRtl: true
});
const $db6ad3fef28672ff$export$21ec1952342c8a5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl16Filled', "16", [
    "M4 3.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 4 3.75m10.78 1.97c.3.3.3.77 0 1.06l-.97.97.97.97a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06l1.5-1.5c.3-.3.77-.3 1.06 0M1 7.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 1 7.75m5 4c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$20026aa31b32a996 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl16Regular', "16", [
    "M4 3.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m10.85 2.15c.2.2.2.5 0 .7L13.71 7.5l1.14 1.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5c.2-.2.5-.2.7 0M1 7.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m5 4c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$5ab4ea3634873c6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl20Filled', "20", [
    "M14 4.75a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h7.5c.41 0 .75-.34.75-.75M13.25 9a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0 5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5zm3.72-6.28a.75.75 0 1 1 1.06 1.06l-.97.97.97.97a.75.75 0 1 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06z"
]);
const $db6ad3fef28672ff$export$225b5d0a5f7ffe4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl20Regular', "20", [
    "M5 4.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m-3 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5M7.5 14a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm10.37-6.26a.5.5 0 0 0-.71 0l-1.41 1.41a.5.5 0 0 0 0 .7l1.41 1.42a.5.5 0 1 0 .7-.7L16.82 9.5l1.06-1.06a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$ff3055581fea5bd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl24Filled', "24", [
    "M15 8H6.5a1 1 0 0 1-.12-2H15a1 1 0 0 1 .12 2zH6.5zm6.7 6.7a1 1 0 0 1-1.31.09l-.1-.08-2-2a1 1 0 0 1-.08-1.32l.08-.1 2-2a1 1 0 0 1 1.5 1.32l-.08.1L20.4 12l1.3 1.3a1 1 0 0 1 0 1.4M15 13H3.5a1 1 0 0 1-.12-2H15a1 1 0 0 1 .12 2zH3.5zm0 5H6.5a1 1 0 0 1-.12-2H15a1 1 0 0 1 .12 2zH6.5z"
]);
const $db6ad3fef28672ff$export$6d7b5a65d507135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl24Regular', "24", [
    "M6.25 16a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5zm15.03-6.78a.75.75 0 0 0-.98-.07l-.08.07-2 2a.75.75 0 0 0-.07.98l.07.08 2 2a.75.75 0 0 0 1.13-.98l-.07-.08-1.47-1.47 1.47-1.47c.3-.3.3-.77 0-1.06M3.25 11a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm3-5a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$2a6e854f7057ac57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl9020Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75M6.25 5.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-4.28 12.03a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 1 0 1.06 1.06l.97-.97z"
]);
const $db6ad3fef28672ff$export$e7ffd051d809e80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl9020Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v10a.5.5 0 0 1-1 0v-10c0-.28.22-.5.5-.5M6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-3.85 11.85a.5.5 0 0 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 .7.7L10 16.21z"
]);
const $db6ad3fef28672ff$export$532e57da614cbd0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl9024Filled', "24", [
    "M16 15V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zV6.5zm-6.7 6.7a1 1 0 0 1-.09-1.31l.08-.1 2-2a1 1 0 0 1 1.32-.08l.1.08 2 2a1 1 0 0 1-1.32 1.5l-.1-.08L12 20.4l-1.3 1.3a1 1 0 0 1-1.4 0M11 15V3.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zV3.5zm-5 0V6.5a1 1 0 0 1 2-.12V15a1 1 0 0 1-2 .12zV6.5z"
]);
const $db6ad3fef28672ff$export$4a1875043d8b2cf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtl9024Regular', "24", [
    "M8 6.25a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0zm6.78 15.03a.75.75 0 0 0 .07-.98l-.07-.08-2-2a.75.75 0 0 0-.98-.07l-.08.07-2 2a.75.75 0 0 0 .98 1.13l.08-.07 1.47-1.47 1.47 1.47c.3.3.77.3 1.06 0M13 3.25a.75.75 0 0 0-1.5 0v12a.75.75 0 0 0 1.5 0zm5 3a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$56a70e7a1ab04086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtlRotate27020Filled', "20", [
    "M9.03 2.22a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 0 0-1.06-1.06l-.97.97zM6.25 7.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm9 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-6 9.5v-9.5a.75.75 0 0 1 1.5 0v9.5a.75.75 0 0 1-1.5 0"
]);
const $db6ad3fef28672ff$export$414667d679fb775 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtlRotate27020Regular', "20", [
    "M8.85 2.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7L10 3.79zM6 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-5.5 10v-10a.5.5 0 0 1 1 0v10a.5.5 0 0 1-1 0"
]);
const $db6ad3fef28672ff$export$d6be602c0e5b7225 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtlRotate27024Filled', "24", [
    "M8 9v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zv8.5zm6.7-6.7a1 1 0 0 1 .09 1.31l-.08.1-2 2a1 1 0 0 1-1.32.08l-.1-.08-2-2a1 1 0 0 1 1.32-1.5l.1.08L12 3.6l1.3-1.3a1 1 0 0 1 1.4 0M13 9v11.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zv11.5zm5 0v8.5a1 1 0 0 1-2 .12V9a1 1 0 0 1 2-.12zv8.5z"
]);
const $db6ad3fef28672ff$export$1e293089ee9b7c50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextIndentIncreaseRtlRotate27024Regular', "24", [
    "M16 17.75a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-1.5 0zM9.22 2.72a.75.75 0 0 0-.07.98l.07.08 2 2c.27.27.68.3.98.07l.08-.07 2-2a.75.75 0 0 0-.98-1.13l-.08.07-1.47 1.47-1.47-1.47a.75.75 0 0 0-1.06 0M11 20.75a.75.75 0 0 0 1.5 0v-12a.75.75 0 0 0-1.5 0zm-5-3a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$1f97d437e98ee5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic16Filled', "16", [
    "M12.8 2H7a.75.75 0 0 0 0 1.5H9l-3.43 9H3.2a.75.75 0 0 0 0 1.5H9a.75.75 0 0 0 0-1.5H7.19l3.43-9h2.18a.75.75 0 0 0 0-1.5"
]);
const $db6ad3fef28672ff$export$6cb65f1d41a53ad7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic16Regular', "16", [
    "M13 2H7a.5.5 0 0 0 0 1h2.47L5.66 13H3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H6.73l3.81-10H13a.5.5 0 0 0 0-1"
]);
const $db6ad3fef28672ff$export$6ad1dba648867d99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic20Filled', "20", [
    "M8 3.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-3.23L8.59 15.5h2.66a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3.23L11.41 4H8.75A.75.75 0 0 1 8 3.25"
]);
const $db6ad3fef28672ff$export$5d3e805e1873350a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic20Regular', "20", [
    "M16 3a.5.5 0 0 1 0 1h-3.16L8.23 16h3.27a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h3.16l4.61-12H8.5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$2f52ef01e0725a2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic24Filled', "24", [
    "M19 4a1 1 0 1 1 0 2h-3.56l-4.55 12H14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3.75L13.3 6H10a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$541fa3242ed2d01b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic24Regular', "24", [
    "M18.75 4a.75.75 0 0 1 0 1.5h-3.48l-4.93 13h3.41a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.48l4.93-13h-3.41a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$51818dca55b727c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic28Filled', "28", [
    "M22 4a1 1 0 0 1 0 2h-3.8l-6.25 16.5H16a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h3.8L16.06 6H12a1 1 0 1 1 0-2z"
]);
const $db6ad3fef28672ff$export$e376d4bf9514ee32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextItalic28Regular', "28", [
    "M22.25 4a.75.75 0 0 1 0 1.5h-4.23l-6.43 17h4.66a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5h4.23l6.43-17h-4.66a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$bf97d7ca26da728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing16Filled', "16", [
    "M12.75 9c.41 0 .75.34.75.75v2.69l.22-.22a.75.75 0 0 1 1.06 1.06l-1.5 1.5c-.27.27-.7.3-1 .05l-.06-.05-1.5-1.5a.75.75 0 0 1 1.06-1.06l.22.22V9.75c0-.41.34-.75.75-.75m-6.5 2a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm3-4a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm3.03-5.83a.75.75 0 0 1 1 .05l1.5 1.5a.75.75 0 0 1-1.06 1.06l-.22-.22v2.69a.75.75 0 0 1-1.5 0V3.56l-.22.22a.75.75 0 1 1-1.06-1.06l1.5-1.5zM6.25 3a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$ea6cb6ad85c18e69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing16Regular', "16", [
    "M12.5 9c.28 0 .5.22.5.5v3.8l.65-.65a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l.65.64V9.5c0-.28.22-.5.5-.5m-6 2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm3-4a.5.5 0 0 1 0 1h-8a.5.5 0 1 1 0-1zm2.72-5.92a.5.5 0 0 1 .63.07l1.5 1.5a.5.5 0 0 1-.7.7L13 2.71V6.5a.5.5 0 1 1-1 0V2.7l-.65.65a.5.5 0 0 1-.7-.7l1.5-1.5zM6.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$f400e92180625753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing20Filled', "20", [
    "M15.25 11c.41 0 .75.34.75.75v3.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72v-3.69c0-.41.34-.75.75-.75m-7 3a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5zm3-5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zm3.47-6.78c.3-.3.77-.3 1.06 0l2 2a.75.75 0 1 1-1.06 1.06L16 4.56v3.69a.75.75 0 0 1-1.5 0V4.56l-.72.72a.75.75 0 0 1-1.06-1.06zM8.25 4a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$86af19e623d460a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing20Regular', "20", [
    "M15 3.7v4.8a.5.5 0 0 0 1 0V3.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7zM2 4.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zM15 16.3v-4.8a.5.5 0 0 1 1 0v4.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7z"
]);
const $db6ad3fef28672ff$export$1492791c7b83271b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing24Filled', "24", [
    "M19 13a1 1 0 0 1 1 1v4.59l.3-.3a1 1 0 1 1 1.4 1.42l-2 2a1 1 0 0 1-1.4 0l-2-2a1 1 0 1 1 1.4-1.42l.3.3V14a1 1 0 0 1 1-1m-9 4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm4-6a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm5-9a1 1 0 0 1 .7.3l2 2a1 1 0 1 1-1.4 1.4l-.3-.29V10a1 1 0 1 1-2 0V5.41l-.3.3a1 1 0 1 1-1.4-1.42l2-2A1 1 0 0 1 19 2m-9 3a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$3a29a402538c7b5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing24Regular', "24", [
    "M18.75 13c.41 0 .75.34.75.75v5.69l1.22-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-.95.1l-.11-.1-2.5-2.5a.75.75 0 1 1 1.06-1.06L18 19.44v-5.69c0-.41.34-.75.75-.75m-8.5 4a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm4-6a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm4.5-9q.31 0 .53.22l2.5 2.5a.75.75 0 1 1-1.06 1.06L19.5 4.56v5.69a.75.75 0 0 1-1.5 0V4.56l-1.22 1.22a.75.75 0 1 1-1.06-1.06l2.5-2.5.11-.1a1 1 0 0 1 .42-.12m-8.5 3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$1d5340ba0ce39fb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing32Filled', "32", [
    "M25.25 18c.69 0 1.25.56 1.25 1.25v5.48l.87-.86a1.25 1.25 0 0 1 1.76 1.76l-3 3c-.45.46-1.18.49-1.67.09l-.1-.09-3-3a1.25 1.25 0 0 1 1.77-1.76l.87.86v-5.48c0-.69.56-1.25 1.25-1.25m-11.5 6a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5zm5-9a1.25 1.25 0 1 1 0 2.5H4.25a1.25 1.25 0 1 1 0-2.5zm5.71-11.72c.5-.4 1.22-.37 1.67.09l3 3a1.25 1.25 0 1 1-1.76 1.76l-.87-.86v5.48a1.25 1.25 0 1 1-2.5 0V7.27l-.87.86a1.25 1.25 0 1 1-1.76-1.76l3-3zM13.75 6a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5z"
]);
const $db6ad3fef28672ff$export$de3a20d3ef7ecd24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextLineSpacing32Regular', "32", [
    "M25 18a1 1 0 0 1 1 1v6.59l1.3-1.3a1 1 0 1 1 1.4 1.42l-3 3a1 1 0 0 1-1.4 0l-3-3a1 1 0 1 1 1.4-1.42l1.3 1.3V19a1 1 0 0 1 1-1m-11 6a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2zm5-9a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2zm5.37-11.78a1 1 0 0 1 1.34.07l3 3a1 1 0 0 1-1.42 1.42L26 6.4V13a1 1 0 0 1-2 0V6.41l-1.3 1.3a1 1 0 0 1-1.4-1.42l3-3zM14 6a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$aadc0a257e580469 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcLowercaseLtr20Filled', "20", [
    "M3.1 3c.16 0 .3-.12.42-.23l.14-.12a1 1 0 0 1 .59-.15c.52 0 .75.32.75.5H4a1.5 1.5 0 1 0 0 3h.07q.55 0 .98-.27A.5.5 0 0 0 6 5.5V3c0-.93-.9-1.5-1.75-1.5-.42 0-.85.1-1.18.35q-.35.25-.5.66c-.08.26.15.49.43.49zM5 4v.12a.93.93 0 0 1-.93.88H4a.5.5 0 1 1 0-1zm3.75 0a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM3.5 7c.28 0 .5.22.5.5v.7q.41-.2.88-.2c1.07 0 1.87.94 1.87 2s-.8 2-1.87 2q-.52 0-.95-.24A.5.5 0 0 1 3 11.5v-4c0-.28.22-.5.5-.5m.76 3.77q.21.22.62.23c.44 0 .87-.4.87-1s-.43-1-.87-1a.9.9 0 0 0-.62.23C4.12 9.37 4 9.6 4 10s.12.63.26.77m-.76 4.98q.01-.6.3-.9c.19-.2.48-.35.95-.35s.75.15.94.34a.5.5 0 1 0 .72-.68q-.61-.65-1.66-.66-1.07.01-1.68.67c-.4.43-.57 1-.57 1.58s.18 1.15.57 1.58q.61.66 1.68.67 1.06 0 1.66-.66a.5.5 0 1 0-.72-.68q-.27.32-.94.34c-.47 0-.76-.15-.94-.35a1.3 1.3 0 0 1-.31-.9"
]);
const $db6ad3fef28672ff$export$fc2e057c433ac943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcLowercaseLtr20Regular', "20", [
    "M3.52 2.77c-.13.11-.26.23-.42.23H3c-.28 0-.51-.23-.42-.5q.15-.4.49-.65c.33-.25.76-.35 1.18-.35C5.1 1.5 6 2.07 6 3v2.5a.5.5 0 0 1-.95.23Q4.62 6 4.07 6H4a1.5 1.5 0 0 1 0-3h1c0-.18-.23-.5-.75-.5a1 1 0 0 0-.59.15zM5 4.12V4H4a.5.5 0 1 0 0 1h.07c.5 0 .9-.39.93-.88M8.5 4a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm-5 1.75q.01-.6.3-.9c.19-.2.48-.35.95-.35s.75.15.94.34a.5.5 0 1 0 .72-.68q-.61-.65-1.66-.66-1.07.01-1.68.67c-.4.43-.57 1-.57 1.58s.18 1.15.57 1.58q.61.66 1.68.67 1.06 0 1.66-.66a.5.5 0 1 0-.72-.68q-.27.32-.94.34c-.47 0-.76-.15-.94-.35a1.3 1.3 0 0 1-.31-.9M4 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .93.26q.43.24.94.24c1.08 0 1.88-.94 1.88-2s-.8-2-1.87-2Q4.4 8 4 8.2zM4 10c0-.4.12-.63.26-.77A.9.9 0 0 1 4.88 9c.44 0 .87.4.87 1s-.43 1-.87 1a.9.9 0 0 1-.62-.23C4.12 10.63 4 10.4 4 10"
]);
const $db6ad3fef28672ff$export$ef2c622b3a2ce465 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcLowercaseLtr24Filled', "24", [
    "M4.62 3.75c-.5 0-.75.15-.83.23a.75.75 0 1 1-1.14-.96c.48-.58 1.28-.77 1.97-.77.58 0 1.14.16 1.58.46.43.3.8.79.8 1.42v3.12a.75.75 0 0 1-1.33.47Q5.15 8 4.54 8h-.17a1.88 1.88 0 0 1 0-3.75H5.5v-.12l-.02-.05-.14-.13q-.23-.18-.72-.2m-.25 2a.37.37 0 1 0 0 .75h.17c.45 0 .84-.32.94-.75zM9 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1m0 6.5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1M9 19a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1M3.75 9c.41 0 .75.34.75.75v.64q.42-.14.88-.14a2.37 2.37 0 1 1 0 4.75 3 3 0 0 1-1.1-.23.75.75 0 0 1-1.28-.52v-4.5c0-.41.34-.75.75-.75m.75 3.63c0 .36.12.55.23.66q.2.2.64.21a.88.88 0 0 0 0-1.75q-.44.02-.64.2c-.11.12-.23.31-.23.68M4 19.25q.01-.6.3-.9c.17-.2.46-.35.95-.35.45 0 .73.14.9.3a.75.75 0 0 0 1.03-1.1q-.75-.69-1.93-.7a2.7 2.7 0 0 0-2.05.83 2.8 2.8 0 0 0-.7 1.92c0 .7.21 1.4.7 1.92q.76.82 2.05.83 1.18-.01 1.93-.7a.75.75 0 0 0-1.03-1.1c-.17.16-.45.3-.9.3-.49 0-.78-.16-.95-.34q-.29-.3-.3-.91"
]);
const $db6ad3fef28672ff$export$2360ddf641ab793d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcLowercaseLtr24Regular', "24", [
    "M4.62 3.75c-.5 0-.75.15-.83.23a.75.75 0 1 1-1.14-.96c.48-.58 1.28-.77 1.97-.77.58 0 1.14.16 1.58.46.43.3.8.79.8 1.42v3.12a.75.75 0 0 1-1.33.47Q5.15 8 4.54 8h-.17a1.88 1.88 0 0 1 0-3.75H5.5v-.12l-.02-.05-.14-.13q-.23-.18-.72-.2m-.25 2a.37.37 0 1 0 0 .75h.17c.45 0 .84-.32.94-.75zm4.63 0c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 9 5.75m0 6.5c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75m0 6.5c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75M3.75 9c.41 0 .75.34.75.75v.64q.42-.14.88-.14a2.37 2.37 0 1 1 0 4.75 3 3 0 0 1-1.1-.23.75.75 0 0 1-1.28-.52v-4.5c0-.41.34-.75.75-.75m.75 3.63c0 .36.12.55.23.66q.2.2.64.21a.88.88 0 0 0 0-1.75q-.44.02-.64.2c-.11.12-.23.31-.23.68M4 19.25q.01-.6.3-.9c.17-.2.46-.35.95-.35.45 0 .73.14.9.3a.75.75 0 0 0 1.03-1.1q-.75-.69-1.93-.7a2.7 2.7 0 0 0-2.05.83 2.8 2.8 0 0 0-.7 1.92c0 .7.21 1.4.7 1.92q.76.82 2.05.83 1.18-.01 1.93-.7a.75.75 0 0 0-1.03-1.1c-.17.16-.45.3-.9.3-.49 0-.78-.16-.95-.34q-.29-.3-.3-.91"
]);
const $db6ad3fef28672ff$export$8ec866ca0ef0c587 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcUppercaseLtr20Filled', "20", [
    "M4.96 1.3a.5.5 0 0 0-.92 0l-1.3 2.99-.02.02-.43.99a.5.5 0 1 0 .92.4l.3-.7H5.5l.3.7a.5.5 0 1 0 .92-.4l-.43-.99-.01-.02zM4.5 2.75 5.05 4h-1.1zM8.75 4a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM3 7.5c0-.28.22-.5.5-.5h1.25a1.5 1.5 0 0 1 1.23 2.36A1.5 1.5 0 0 1 5 12H3.5a.5.5 0 0 1-.5-.5zM4 9h.75a.5.5 0 1 0 0-1H4zm1.5 1.5A.5.5 0 0 0 5 10H4v1h1a.5.5 0 0 0 .5-.5m-2 5q0-.71.33-1.1.27-.38.92-.4a1.1 1.1 0 0 1 .95.43c.13.18.32.32.54.32.34 0 .6-.33.44-.63l-.23-.35a2.1 2.1 0 0 0-1.7-.77c-.72 0-1.3.29-1.7.77-.38.48-.55 1.1-.55 1.73s.17 1.25.55 1.73c.4.48.98.77 1.7.77a2.1 2.1 0 0 0 1.93-1.12c.16-.3-.1-.63-.44-.63-.22 0-.41.14-.54.32l-.03.03c-.19.24-.48.4-.92.4s-.73-.16-.92-.4q-.31-.39-.33-1.1"
]);
const $db6ad3fef28672ff$export$7c19d8cfefb77586 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcUppercaseLtr20Regular', "20", [
    "M4.96 1.3a.5.5 0 0 0-.92 0l-1.3 2.99-.02.02-.43.99a.5.5 0 1 0 .92.4l.3-.7H5.5l.3.7a.5.5 0 1 0 .92-.4l-.43-.99-.01-.02zM4.5 2.75 5.05 4h-1.1zM3 7.5c0-.28.22-.5.5-.5h1.25a1.5 1.5 0 0 1 1.23 2.36A1.5 1.5 0 0 1 5 12H3.5a.5.5 0 0 1-.5-.5zM4 9h.75a.5.5 0 1 0 0-1H4zm1.5 1.5A.5.5 0 0 0 5 10H4v1h1a.5.5 0 0 0 .5-.5m-2 5q0-.71.33-1.1.27-.38.92-.4a1.1 1.1 0 0 1 .95.43c.13.18.32.32.54.32.34 0 .6-.33.44-.63l-.23-.35a2.1 2.1 0 0 0-1.7-.77c-.72 0-1.3.29-1.7.77-.38.48-.55 1.1-.55 1.73s.17 1.25.55 1.73c.4.48.98.77 1.7.77a2.1 2.1 0 0 0 1.93-1.12c.16-.3-.1-.63-.44-.63-.22 0-.41.14-.54.32l-.03.03c-.19.24-.48.4-.92.4s-.73-.16-.92-.4q-.31-.39-.33-1.1M8.5 4a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$339c14ef25caa6c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcUppercaseLtr24Filled', "24", [
    "M5.69 2.45a.75.75 0 0 0-1.38 0L2.77 5.93l-.02.03-.44.99a.75.75 0 1 0 1.38.6L3.93 7h2.14l.24.55a.75.75 0 1 0 1.38-.6l-.44-.99-.02-.03zM5 4.6l.4.9h-.8zm5 .4a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm0 6.5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm0 6.5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM3.75 9h1.63a1.87 1.87 0 0 1 1.6 2.84A1.87 1.87 0 0 1 5.63 15H3.76a.75.75 0 0 1-.75-.75v-4.5c0-.41.34-.75.75-.75m.75 1.5v.75h.88a.38.38 0 0 0 0-.75zm0 2.25v.75h1.13a.38.38 0 0 0 0-.75zm-.17 5.13Q4.01 18.24 4 19q.02.75.33 1.12c.18.22.46.38.92.38s.74-.16.92-.39c.16-.2.37-.36.62-.36h.15c.51 0 .9.48.65.93q-.1.2-.26.38c-.48.6-1.2.94-2.08.94a2.6 2.6 0 0 1-2.08-.93A3.2 3.2 0 0 1 2.5 19c0-.75.2-1.5.67-2.07A2.6 2.6 0 0 1 5.25 16a2.6 2.6 0 0 1 2.34 1.32c.25.45-.14.93-.65.93h-.15c-.25 0-.46-.17-.62-.36-.18-.23-.46-.39-.92-.39s-.74.16-.92.38"
]);
const $db6ad3fef28672ff$export$c9fa9b8d170f5189 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListAbcUppercaseLtr24Regular', "24", [
    "M5.69 2.45a.75.75 0 0 0-1.38 0L2.77 5.93l-.02.03-.44.99a.75.75 0 1 0 1.38.6L3.93 7h2.14l.24.55a.75.75 0 1 0 1.38-.6l-.44-.99-.02-.03zM5 4.6l.4.9h-.8zm4.75.4a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 6.5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 6.5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm-6-9h1.63a1.87 1.87 0 0 1 1.6 2.84A1.87 1.87 0 0 1 5.63 15H3.76a.75.75 0 0 1-.75-.75v-4.5c0-.41.34-.75.75-.75m.75 1.5v.75h.88a.38.38 0 0 0 0-.75zm0 2.25v.75h1.13a.38.38 0 0 0 0-.75zm-.17 5.13Q4.01 18.24 4 19q.02.75.33 1.12c.18.22.46.38.92.38s.74-.16.92-.39c.16-.2.37-.36.62-.36h.15c.51 0 .9.48.65.93q-.1.2-.26.38c-.48.6-1.2.94-2.08.94a2.6 2.6 0 0 1-2.08-.93A3.2 3.2 0 0 1 2.5 19c0-.75.2-1.5.67-2.07A2.6 2.6 0 0 1 5.25 16a2.6 2.6 0 0 1 2.34 1.32c.25.45-.14.93-.65.93h-.15c-.25 0-.46-.17-.62-.36-.18-.23-.46-.39-.92-.39s-.74.16-.92.38"
]);
const $db6ad3fef28672ff$export$e8155da9a3fcb749 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralLowercase20Filled', "20", [
    "M5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.5 1c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5m0 6c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5M5 15a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0zm-.5-7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M8.75 4a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$4a6eeb7a96e75538 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralLowercase20Regular', "20", [
    "M4.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 .5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5m0 6c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5M5 15a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0zM8 4.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m-3-7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $db6ad3fef28672ff$export$7824a650cf8c856f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralLowercase24Filled', "24", [
    "M5.25 3.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 .5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M9 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1m0 6.5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1M9 19a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1m-3.75-1c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M6 11.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm-.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 9.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $db6ad3fef28672ff$export$b256d37845984dfc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralLowercase24Regular', "24", [
    "M5.25 3.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 4.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zM5.25 11c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m0 7c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M9 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 9 5.75m0 6.5c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75m0 6.5c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75M5.25 17.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 9.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $db6ad3fef28672ff$export$5a9f6e8068994c82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralUppercase20Filled', "20", [
    "M5 1.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zM8.75 4a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM4.5 7c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5m.5 6.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$7a5b5855750f3be7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralUppercase20Regular', "20", [
    "M5 1.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zm0 6a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zM4.5 13c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5m4-9a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$9dc0d254eaa8419 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralUppercase24Filled', "24", [
    "M6 2.75a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0zM10 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm0 6.5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm0 6.5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM5.25 9c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75M6 16.75a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$bc988d1e1ab03e7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextListRomanNumeralUppercase24Regular', "24", [
    "M6 2.75a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0zm0 7a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0zM5.25 16c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75m4.5-11a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 6.5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 6.5a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$3e93fcdd72a68808 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextMore20Filled', "20", [
    "M8.25 2c.3 0 .58.18.7.47L14.04 15a2.2 2.2 0 0 0-1.69-.17l-.95-2.34H5.08l-1.64 4.03a.75.75 0 1 1-1.39-.56l5.5-13.5a.8.8 0 0 1 .7-.47M13 15.75c.63 0 1.15.46 1.24 1.07l.01.18A1.25 1.25 0 1 1 13 15.75M5.7 11h5.1L8.25 4.74zm4.55 6a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M17 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $db6ad3fef28672ff$export$42dbf1e42c57732a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextMore20Regular', "20", [
    "M8 2c.2 0 .39.12.46.31l5.1 12.51a2 2 0 0 0-1.08 0L11.33 12H4.67l-1.7 4.19a.5.5 0 1 1-.93-.38l5.5-13.5A.5.5 0 0 1 8 2m5 13.75q.6.02.96.45a1.25 1.25 0 0 1-.96 2.05 1.25 1.25 0 1 1 0-2.5M5.08 11h5.84L8 3.83zm5.17 6a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M17 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $db6ad3fef28672ff$export$3eddf41340550e94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextMore24Filled', "24", [
    "M10.67 2.61a1 1 0 0 0-1.84 0l-6.75 16a1 1 0 0 0 1.84.78L5.77 15h7.96L15 18.05a2.5 2.5 0 0 1 2.49.95 1 1 0 0 0-.08-.39zM12.88 13H6.62l3.13-7.43zm-2.38 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $db6ad3fef28672ff$export$586adfab995aba20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextMore24Regular', "24", [
    "M9.75 2c.3 0 .57.18.7.46l6.96 16.43a2.5 2.5 0 0 0-2-.89l-1.49-3.5H5.58l-2.14 5.04a.75.75 0 0 1-1.38-.58l7-16.5A.8.8 0 0 1 9.75 2m3.53 11L9.75 4.67 6.22 13zM12 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$574086c2f6d07151 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberFormat20Filled', "20", [
    "M16.97 2.98q.78.38 1.17 1.46a.75.75 0 0 1-1.4.51c-.18-.47-.35-.59-.44-.63-.12-.06-.27-.07-.58-.07a.7.7 0 0 0-.5.17q-.18.15-.3.5a3 3 0 0 0-.17.88c0 .41 0 .9.16 1.3q.11.27.3.42.16.17.6.23c.08 0 .28 0 .48-.07a.8.8 0 0 0 .46-.45.75.75 0 0 1 1.37.61c-.63 1.42-2.03 1.45-2.48 1.4a2.6 2.6 0 0 1-1.4-.56c-.35-.3-.58-.68-.72-1.04-.27-.68-.27-1.43-.27-1.8v-.08l.03-.4c.03-.26.1-.61.23-.97.14-.36.35-.77.72-1.09q.56-.53 1.49-.55h.03c.28 0 .75 0 1.22.23M4.7 2.75c.31 0 .59.2.7.5l1.77 5a.75.75 0 0 1-1.42.5l-.09-.25h-2.1l-.11.27a.75.75 0 1 1-1.4-.54l1.94-5c.1-.3.4-.48.7-.48m-.04 2.9L4.14 7h1zm.64 5.1c.39.03.7.35.7.75v5a.75.75 0 0 1-1.5 0v-2.7l-.2.14a.75.75 0 1 1-.84-1.25c.56-.37.97-.96 1.05-1.35a.75.75 0 0 1 .79-.59m4.54 1.5c-.31 0-.59.29-.59.61a.75.75 0 1 1-1.5 0 2.12 2.12 0 0 1 3.89-1.17c.41.64.41 1.46-.05 2.24-.23.4-.55.69-.84.92l-.44.32-.06.05-.33.23q-.2.15-.35.3h1.62a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1-.75-.75c0-1.16.69-1.8 1.27-2.25L9.4 14l.06-.04.37-.28q.34-.26.48-.5c.21-.36.14-.57.08-.66a.6.6 0 0 0-.54-.26m4.88.37a1 1 0 0 1 .14-.23c.07-.06.2-.14.49-.14.49 0 .6.3.6.39q0 .26-.12.4c-.04.06-.19.21-.7.21a.75.75 0 0 0 0 1.5c.2 0 .45.03.64.11q.12.06.13.1.03.02.04.18c0 .33-.1.44-.15.49q-.12.1-.44.12-.38-.02-.44-.08c-.05-.03-.13-.1-.2-.31a.75.75 0 0 0-1.42.47 2 2 0 0 0 .81 1.1c.4.25.83.32 1.25.32.45 0 .98-.11 1.4-.48q.7-.59.7-1.63a1.8 1.8 0 0 0-.43-1.18c.36-.47.42-1 .42-1.32 0-.93-.8-1.89-2.1-1.89q-.93.02-1.47.52c-.34.3-.51.66-.6.93a.75.75 0 1 0 1.45.42M8 3.5v5a.75.75 0 0 0 .87.74v.01h1.63c.24 0 .73-.04 1.2-.3.52-.3.92-.87.92-1.7q0-.64-.28-1.12a2 2 0 0 0-.29-.35q.23-.41.24-1.02t-.25-1.08a1.7 1.7 0 0 0-.66-.67c-.46-.26-.95-.26-1.12-.26H8.75A.75.75 0 0 0 8 3.5m2.5 4.25h-1v-1h.94q.3-.01.51.08.07.03.1.08.06.04.07.33-.01.25-.06.3a.3.3 0 0 1-.12.1 1 1 0 0 1-.44.11m-.88-2.5H9.5v-1h.75q.25-.01.4.07l.08.08q.05.05.06.36 0 .26-.06.3a.3.3 0 0 1-.1.1 1 1 0 0 1-.35.09z"
]);
const $db6ad3fef28672ff$export$ee53635da1478bb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberFormat20Regular', "20", [
    "M4.94 3c.21 0 .4.14.47.33l1.77 5a.5.5 0 1 1-.94.34L6 8H3.73l-.26.68a.5.5 0 0 1-.94-.36l1.94-5A.5.5 0 0 1 4.94 3m-.82 4h1.53l-.73-2.06zM8.5 3H10c.17 0 .6 0 1.01.23q.34.17.56.57t.22.96q-.01.67-.32 1.08.24.15.4.42.25.4.25.98c0 .75-.35 1.23-.8 1.49-.4.24-.85.27-1.07.27H8.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5M10 4H9v1.5h1.02c.12 0 .33-.02.5-.12.12-.08.27-.22.27-.62q0-.37-.1-.48a.4.4 0 0 0-.17-.18q-.26-.12-.52-.1M9 6.5V8h1.25c.14 0 .38-.03.57-.14.15-.08.3-.23.3-.62a1 1 0 0 0-.08-.41l-.02-.05a.5.5 0 0 0-.2-.18c-.2-.1-.45-.1-.63-.1H9m8.4-1.97c-.24-.69-.6-1.1-1.05-1.33-.4-.2-.83-.2-1.1-.2h-.03c-.55 0-1 .19-1.33.49-.32.29-.52.65-.64.99A4 4 0 0 0 13 5.77v.06c0 .38 0 1.08.25 1.72.13.33.33.67.66.93q.48.41 1.25.5c.42.05 1.67.02 2.23-1.24a.5.5 0 1 0-.9-.4c-.3.64-.94.68-1.22.65a1.3 1.3 0 0 1-.73-.28 1.3 1.3 0 0 1-.36-.52A4 4 0 0 1 14 5.8V5.8l.02-.28q.04-.31.16-.68.14-.38.38-.6a1 1 0 0 1 .66-.23c.3 0 .5 0 .7.1.15.08.36.25.55.77a.5.5 0 0 0 .94-.34m-3.2 7.67a1 1 0 0 0-.22.35.5.5 0 0 1-.96-.28c.07-.23.22-.55.52-.82s.73-.45 1.3-.45c1.17 0 1.85.85 1.85 1.64a2 2 0 0 1-.52 1.33 2 2 0 0 1 .25.27q.27.37.27.9 0 .95-.6 1.44c-.37.32-.83.42-1.24.42-.4 0-.78-.06-1.11-.28a1.8 1.8 0 0 1-.72-.97.5.5 0 0 1 .95-.32q.08.2.15.3l.01.02.04.04.01.02.02.01a1 1 0 0 0 .2.12q.16.06.45.06.39 0 .6-.18c.12-.1.24-.29.24-.68a.5.5 0 0 0-.08-.32 1 1 0 0 0-.24-.18c-.23-.11-.53-.14-.75-.14a.5.5 0 1 1 0-1c.58 0 .8-.18.91-.3a1 1 0 0 0 .16-.56c0-.22-.22-.64-.84-.64-.35 0-.54.1-.65.2m-5.2.66c0-.44.37-.86.84-.86.33 0 .6.16.75.37.12.19.18.5-.07.92q-.19.31-.55.58-.17.15-.38.28l-.06.04-.36.26C8.61 14.88 8 15.46 8 16.5c0 .28.22.5.5.5h2.69a.5.5 0 1 0 0-1H9.1c.13-.28.36-.5.68-.75l.32-.23h.02l.06-.05.42-.31c.29-.23.58-.5.79-.86.41-.7.4-1.43.05-1.98A1.87 1.87 0 0 0 8 12.86a.5.5 0 1 0 1 0m-4.58.87q.3-.2.58-.47v3.24a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.98-.1 2.8 2.8 0 0 1-1.16 1.5.5.5 0 1 0 .56.83"
]);
const $db6ad3fef28672ff$export$64e291ca269ede7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberFormat24Filled', "24", [
    "M5.96 3.42a1 1 0 0 0-1.88-.03l-2.51 6.5a1 1 0 0 0 1.86.72l.22-.56H6.2l.19.53a1 1 0 1 0 1.89-.66zm-.48 4.63H4.42l.56-1.42zM9 3.75a1 1 0 0 1 1-1h2.19c.21 0 .85 0 1.45.33q.51.27.86.88.33.6.33 1.42-.01.79-.32 1.33.2.2.37.46.37.62.37 1.46 0 .8-.38 1.4c-.25.4-.58.67-.9.85-.63.33-1.3.37-1.6.37H10a1 1 0 0 1-1-1zM12.17 6c.13 0 .33-.03.46-.11q.08-.05.12-.12a1 1 0 0 0 .08-.4 1 1 0 0 0-.09-.46l-.08-.08a1 1 0 0 0-.5-.08H11V6zm0 2H11v1.25h1.38c.17 0 .44-.03.63-.14a.4.4 0 0 0 .17-.14c.02-.04.07-.14.07-.34q-.02-.37-.08-.42a.3.3 0 0 0-.13-.11 2 2 0 0 0-.66-.1zm8.47-4.95q1.03.5 1.55 1.92a1 1 0 1 1-1.88.68c-.22-.6-.45-.75-.55-.8-.16-.08-.35-.1-.76-.1a1 1 0 0 0-.64.22q-.23.2-.4.63a4 4 0 0 0-.21 1.14v.01c0 .53.01 1.16.21 1.67q.14.36.38.55.2.2.77.29c.12 0 .38 0 .63-.08.22-.09.44-.24.6-.58a1 1 0 1 1 1.82.82c-.84 1.85-2.68 1.89-3.27 1.82a3.4 3.4 0 0 1-1.83-.73 3.3 3.3 0 0 1-.96-1.36 6.4 6.4 0 0 1 0-4.25c.17-.47.46-1 .94-1.43a3 3 0 0 1 2-.72c.36 0 .99 0 1.6.3m-2.75 11.88a1 1 0 0 0-.18.28 1 1 0 0 1-1.92-.55c.1-.36.33-.84.77-1.23a2.9 2.9 0 0 1 1.94-.68c1.7 0 2.75 1.26 2.75 2.48 0 .42-.08 1.11-.54 1.72a2.2 2.2 0 0 1 .54 1.53q0 1.37-.9 2.15c-.57.47-1.26.62-1.85.62-.54 0-1.12-.09-1.63-.41a2.6 2.6 0 0 1-1.07-1.46 1 1 0 0 1 1.9-.62c.1.27.19.35.24.39.07.04.22.1.56.1q.43-.02.56-.15c.06-.05.19-.2.19-.62q-.01-.21-.05-.21a.4.4 0 0 0-.16-.12c-.24-.11-.57-.15-.83-.15a1 1 0 1 1 0-2c.67 0 .85-.2.9-.26a1 1 0 0 0 .14-.51c0-.09-.12-.48-.75-.48-.36 0-.53.1-.61.18m-7.14.6c0-.42.35-.78.74-.78.33 0 .57.16.68.32.08.12.17.37-.1.83q-.19.31-.62.66l-.48.35-.08.05-.48.35c-.76.57-1.66 1.42-1.66 2.94a1 1 0 0 0 1 1h3.45a1 1 0 0 0 0-2h-2l.42-.34.42-.31.08-.06q.28-.18.57-.41c.38-.3.8-.7 1.1-1.21.6-1.02.6-2.1.06-2.94a2.78 2.78 0 0 0-5.1 1.54 1 1 0 1 0 2 0m-5.73 1.26-.21.16a1 1 0 0 1-1.11-1.67 3.3 3.3 0 0 0 1.35-1.74 1 1 0 0 1 1.97.21v6.5a1 1 0 1 1-2 0z"
]);
const $db6ad3fef28672ff$export$89ec64e278038830 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberFormat24Regular', "24", [
    "M9.76 3za.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h2.63c.28 0 .9-.04 1.46-.34A2.2 2.2 0 0 0 15 8.63q0-.78-.34-1.33-.2-.33-.47-.54.38-.53.39-1.38 0-.76-.3-1.3-.31-.55-.76-.78C12.98 3 12.4 3 12.18 3H9.76m2.62 6.5H10.5V7.75h1.87c.25 0 .55.01.79.13q.15.05.22.2.1.12.12.55-.02.35-.11.48a1 1 0 0 1-.26.22c-.25.14-.57.17-.75.17M10.5 6.25V4.5h1.66q.35-.02.62.1.1.06.18.2.1.12.12.58-.02.38-.11.51a1 1 0 0 1-.2.21c-.2.12-.45.15-.6.15zM5.28 3c.31 0 .59.2.7.5l2.3 6.5a.75.75 0 1 1-1.41.5l-.34-.95h-2.7l-.38.97a.75.75 0 1 1-1.4-.54l2.52-6.5c.11-.3.4-.48.7-.48m-.04 2.9L4.4 8.06H6zm15.29-2.63q.93.43 1.43 1.79a.75.75 0 1 1-1.42.5c-.23-.64-.5-.85-.67-.94-.22-.1-.47-.12-.87-.12-.38 0-.62.12-.8.28q-.3.27-.47.73a4 4 0 0 0-.23 1.23v.01c0 .53 0 1.2.23 1.76q.15.4.45.65c.19.16.47.3.9.34.35.04 1.13-.02 1.49-.8a.75.75 0 0 1 1.36.62c-.77 1.7-2.46 1.74-3.01 1.68a3 3 0 0 1-1.7-.68 3 3 0 0 1-.89-1.26A6 6 0 0 1 16 6.78V6.7l.04-.51c.04-.32.12-.76.29-1.2.17-.45.43-.94.87-1.33.45-.4 1.05-.66 1.8-.66h.04c.36 0 .93 0 1.49.27m-3.56 11.87q.04-.18.25-.4c.13-.11.36-.24.78-.24.76 0 1 .5 1 .73 0 .24-.05.49-.19.66-.11.14-.38.36-1.1.36a.75.75 0 0 0 0 1.5c.27 0 .65.04.93.17q.2.1.27.2.07.08.09.36c0 .48-.15.7-.28.8q-.23.21-.72.22-.52-.01-.7-.14c-.1-.07-.23-.2-.34-.53a.75.75 0 1 0-1.42.47q.27.87.97 1.33c.45.28.98.37 1.49.37a2.6 2.6 0 0 0 1.69-.56q.8-.69.81-1.96a2 2 0 0 0-.63-1.52l.11-.14c.44-.55.52-1.19.52-1.6 0-1.07-.93-2.22-2.5-2.22a2.6 2.6 0 0 0-1.77.62c-.4.35-.6.78-.7 1.1a.75.75 0 0 0 1.44.42m-6.47.38c0-.53.44-1.02.99-1.02.4 0 .73.2.89.43.14.21.22.57-.1 1.1a3 3 0 0 1-.68.72l-.49.37-.07.05-.48.34C9.82 18.07 9 18.85 9 20.25c0 .41.34.75.75.75h3.45a.75.75 0 0 0 0-1.5H10.7q.24-.4.78-.8l.43-.3.08-.06q.27-.19.55-.41c.38-.3.76-.66 1.05-1.14.56-.95.55-1.92.06-2.67A2.53 2.53 0 0 0 9 15.52a.75.75 0 0 0 1.5 0m-5.58 1.22q.3-.21.6-.48v3.99a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.48-.16c-.13.58-.7 1.39-1.46 1.9a.75.75 0 0 0 .84 1.25"
]);
const $db6ad3fef28672ff$export$edf4b543ce8bc5ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr16Filled', "16", [
    "M3.68 1.01c.2.04.33.21.33.4v3.3c0 .22-.19.4-.42.4a.4.4 0 0 1-.43-.4V2.58q-.27.24-.67.44a.44.44 0 0 1-.57-.19.4.4 0 0 1 .2-.55A2.5 2.5 0 0 0 3.2 1.23c.1-.17.29-.26.48-.22M2.15 7.06a.4.4 0 0 1 0-.59h.01l.11-.1.28-.17c.24-.13.6-.26 1.03-.26h.01c.32 0 .67.09.95.29q.46.31.48.95c0 .45-.2.76-.48.99-.22.17-.5.3-.72.4l-.1.06q-.4.17-.61.39a1 1 0 0 0-.15.22H4.6c.23 0 .42.18.42.4s-.19.42-.42.42H2.46a.4.4 0 0 1-.43-.41q.02-.76.44-1.19c.26-.27.6-.44.87-.57l.12-.06q.34-.15.53-.3.18-.13.18-.35-.01-.21-.14-.3a1 1 0 0 0-.45-.12 1.3 1.3 0 0 0-.82.3.44.44 0 0 1-.6 0m.94 5.88c0-.23.2-.41.43-.41.3 0 .46-.08.54-.15a.3.3 0 0 0 .1-.25c0-.16-.15-.42-.64-.42-.35 0-.53.08-.62.13l-.07.07v-.02.02a.44.44 0 0 1-.57.16.4.4 0 0 1-.19-.55l.01-.02.09-.12q.09-.11.26-.22.35-.26 1.1-.28c.87 0 1.47.56 1.5 1.22q.01.46-.35.84c.24.23.36.54.34.84C5 14.44 4.4 15 3.52 15q-.74-.02-1.1-.28a1 1 0 0 1-.34-.34v-.01h-.01a.4.4 0 0 1 .2-.56c.2-.1.44-.03.55.16l.08.07c.09.05.27.14.62.14.49 0 .64-.27.65-.43a.3.3 0 0 0-.11-.25c-.08-.07-.25-.15-.54-.15a.4.4 0 0 1-.43-.4M7.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$c29e989162f71cb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr16Regular', "16", [
    "M3.68 1.01c.2.04.33.21.33.4v3.3c0 .22-.19.4-.42.4a.4.4 0 0 1-.43-.4V2.58q-.27.24-.67.44a.44.44 0 0 1-.57-.19.4.4 0 0 1 .2-.55A2.5 2.5 0 0 0 3.2 1.23c.1-.17.29-.26.48-.22M2.15 7.06a.4.4 0 0 1 0-.59h.01l.11-.1.28-.17c.24-.13.6-.26 1.03-.26h.01c.32 0 .67.09.95.29q.46.31.48.95c0 .45-.2.76-.48.99-.22.17-.5.3-.72.4l-.1.06q-.4.17-.61.39a1 1 0 0 0-.15.22H4.6c.23 0 .42.18.42.4s-.19.42-.42.42H2.46a.4.4 0 0 1-.43-.41q.02-.76.44-1.19c.26-.27.6-.44.87-.57l.12-.06q.34-.15.53-.3.18-.13.18-.35-.01-.21-.14-.3a1 1 0 0 0-.45-.12 1.3 1.3 0 0 0-.82.3.44.44 0 0 1-.6 0m.94 5.88c0-.23.2-.41.43-.41.3 0 .46-.08.54-.15a.3.3 0 0 0 .1-.25c0-.16-.15-.42-.64-.42-.35 0-.53.08-.62.13l-.07.07v-.02.02a.44.44 0 0 1-.57.16.4.4 0 0 1-.19-.55l.01-.02.09-.12q.09-.11.26-.22.35-.26 1.1-.28c.87 0 1.47.56 1.5 1.22q.01.46-.35.84c.24.23.36.54.34.84C5 14.44 4.4 15 3.52 15q-.74-.02-1.1-.28a1 1 0 0 1-.34-.34v-.01h-.01a.4.4 0 0 1 .2-.56c.2-.1.44-.03.55.16l.08.07c.09.05.27.14.62.14.49 0 .64-.27.65-.43a.3.3 0 0 0-.11-.25c-.08-.07-.25-.15-.54-.15a.4.4 0 0 1-.43-.4M7.5 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$c61d1718967fa951 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr20Filled', "20", [
    "M5 1.5a.5.5 0 0 0-.39-.49.5.5 0 0 0-.56.27l-.07.12-.25.35c-.22.28-.54.6-.95.8a.5.5 0 1 0 .44.9q.45-.23.78-.53V5.5a.5.5 0 0 0 1 0zM8.75 4a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM8 14.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m-5.35-7.1a.5.5 0 0 0 .7.7l.05-.04.2-.12C3.76 8.09 4 8 4.3 8q.35 0 .53.15.15.1.16.35a.5.5 0 0 1-.21.44q-.22.17-.62.35l-.14.08c-.32.15-.7.36-1 .7q-.51.51-.53 1.43c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1H3.59q.06-.16.17-.27.25-.25.71-.47l.13-.06c.26-.13.58-.29.83-.5.33-.27.57-.65.57-1.2 0-.5-.22-.9-.57-1.15A2 2 0 0 0 4.33 7h-.01a2.5 2.5 0 0 0-1.66.63zm.01-.02-.01.02s.1-.1.01-.02m1.09 7.87c0-.28.22-.5.5-.5.34 0 .53-.1.63-.18q.14-.14.13-.3c-.01-.2-.19-.52-.76-.52-.41 0-.63.1-.72.17l-.1.07a.5.5 0 0 1-.88-.46v-.01l.02-.02.1-.15q.1-.12.3-.27c.28-.18.7-.33 1.28-.33 1.03 0 1.73.67 1.76 1.48.01.37-.12.74-.4 1.02.28.28.41.65.4 1.02-.03.8-.73 1.48-1.76 1.48-.59 0-1-.15-1.28-.33a1.4 1.4 0 0 1-.4-.42l-.01-.01v-.01a.5.5 0 0 1 .87-.48l.1.08c.1.07.3.17.72.17.57 0 .75-.33.76-.52q0-.16-.13-.3c-.1-.08-.29-.18-.63-.18a.5.5 0 0 1-.5-.5m-.32-1.25.02-.03v.01z"
]);
const $db6ad3fef28672ff$export$d49ee57b4a1b838 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr20Regular', "20", [
    "M5 1.5a.5.5 0 0 0-.39-.49.5.5 0 0 0-.56.27l-.07.12-.25.35c-.22.28-.54.6-.95.8a.5.5 0 1 0 .44.9q.45-.23.78-.53V5.5a.5.5 0 0 0 1 0zM2.65 7.65a.5.5 0 0 0 .7.7l.05-.04.2-.12C3.76 8.09 4 8 4.3 8q.35 0 .53.15.15.1.16.35a.5.5 0 0 1-.21.44q-.22.17-.62.35l-.14.08c-.32.15-.7.36-1 .7q-.51.51-.53 1.43c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1H3.59q.06-.16.17-.27a2.4 2.4 0 0 1 .83-.53c.27-.13.59-.29.84-.5.33-.27.57-.65.57-1.2 0-.5-.22-.9-.57-1.15A2 2 0 0 0 4.33 7h-.01a2.5 2.5 0 0 0-1.66.63zm.01-.02-.01.02s.1-.1.01-.02M4.25 15a.5.5 0 1 0 0 1c.34 0 .53.1.63.18q.14.14.13.3c-.01.2-.19.52-.76.52-.41 0-.63-.1-.72-.17l-.1-.07a.5.5 0 0 0-.88.46v.01l.02.02.1.15q.1.12.3.27c.28.18.7.33 1.28.33 1.03 0 1.73-.67 1.76-1.48.01-.37-.12-.74-.4-1.02.28-.28.41-.65.4-1.02-.03-.8-.73-1.48-1.76-1.48-.59 0-1 .15-1.28.33a1.4 1.4 0 0 0-.4.42l-.01.01v.01a.5.5 0 0 0 .87.48l.1-.08c.1-.07.3-.17.72-.17.57 0 .75.33.76.52q0 .16-.13.3c-.1.08-.29.18-.63.18m-.82-.75.01-.02zM8.5 4a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1zM8 14.5c0-.28.22-.5.5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$aed23bc6a7af4282 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr24Filled', "24", [
    "M6 2.75a.75.75 0 0 0-1.43-.3l-.07.13q-.07.15-.24.38c-.22.32-.52.66-.9.9a.75.75 0 1 0 .79 1.28l.35-.25v2.36a.75.75 0 1 0 1.5 0zM19.5 18h-8.62a1 1 0 0 0 .12 2h8.62a1 1 0 0 0-.12-2m0-6.5h-8.62a1 1 0 0 0 .12 2h8.62a1 1 0 0 0-.12-2m0-6.5h-8.62A1 1 0 0 0 11 7h8.62a1 1 0 0 0-.12-2M5.15 10.52c-.3-.05-.68.07-.87.26a.75.75 0 0 1-1.06-1.06 2.6 2.6 0 0 1 2.2-.68c.39.07.8.26 1.1.6A2 2 0 0 1 7 11c0 .62-.27 1.08-.6 1.42-.28.28-.64.51-.91.69l-.08.05q-.3.2-.48.34h1.32a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75c0-1.31.98-1.95 1.58-2.34l.06-.04q.46-.28.68-.5.2-.2.18-.37c0-.22-.06-.32-.1-.36a.4.4 0 0 0-.25-.12M2.97 21.28s.1.08 0 0l.01.01.01.01.15.13q.15.11.4.24c.34.17.83.33 1.46.33.64 0 1.2-.18 1.6-.54s.61-.86.6-1.36q-.04-.64-.43-1.1.4-.46.43-1.1c.01-.5-.2-1-.6-1.36Q5.98 16 5 16a3.2 3.2 0 0 0-1.86.57L3 16.7l-.01.01-.01.01a.75.75 0 1 0 1.07 1.05l.17-.1c.16-.08.42-.17.79-.17.36 0 .54.1.6.16q.11.1.1.2t-.13.22c-.09.08-.26.17-.57.17a.75.75 0 0 0 0 1.5c.31 0 .48.1.57.17q.13.12.13.23.01.1-.1.19c-.06.06-.24.16-.6.16a2 2 0 0 1-.96-.27l-.02-.02a.75.75 0 0 0-1.05 1.07m0-4.56"
]);
const $db6ad3fef28672ff$export$e20f156f64334974 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr24Regular', "24", [
    "M6 2.75a.75.75 0 0 0-1.43-.3l-.07.13q-.07.15-.24.38c-.22.32-.52.66-.9.9a.75.75 0 1 0 .79 1.28l.35-.25v2.36a.75.75 0 1 0 1.5 0zm14.5 16a.75.75 0 0 0-.75-.75h-9a.75.75 0 0 0 0 1.5h9c.41 0 .75-.34.75-.75m0-6.5a.75.75 0 0 0-.75-.76h-9a.75.75 0 0 0 0 1.5h9c.41 0 .75-.33.75-.75m0-6.5a.75.75 0 0 0-.75-.75h-9a.75.75 0 0 0 0 1.5h9c.41 0 .75-.34.75-.75M5.15 10.52c-.3-.05-.68.07-.87.26a.75.75 0 0 1-1.06-1.06 2.6 2.6 0 0 1 2.2-.68c.39.07.8.26 1.1.6A2 2 0 0 1 7 11c0 .62-.27 1.08-.6 1.42-.28.28-.64.51-.91.69l-.08.05q-.3.2-.48.34h1.32a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75c0-1.31.98-1.95 1.58-2.34l.06-.04q.46-.28.68-.5.2-.2.18-.37c0-.22-.06-.32-.1-.36a.4.4 0 0 0-.25-.12M2.97 21.28s.1.08 0 0l.01.01.01.01.15.13q.15.11.4.24c.34.17.83.33 1.46.33.64 0 1.2-.18 1.6-.54s.61-.86.6-1.36q-.04-.64-.43-1.1.4-.46.43-1.1c.01-.5-.2-1-.6-1.36Q5.98 16 5 16a3.2 3.2 0 0 0-1.86.57L3 16.7l-.01.01-.01.01a.75.75 0 1 0 1.07 1.05l.17-.1c.16-.08.42-.17.79-.17.36 0 .54.1.6.16q.11.1.1.2t-.13.22c-.09.08-.26.17-.57.17a.75.75 0 0 0 0 1.5c.31 0 .48.1.57.17q.13.12.13.23.01.1-.1.19c-.06.06-.24.16-.6.16a2 2 0 0 1-.96-.27l-.02-.02a.75.75 0 0 0-1.05 1.07m0-4.56"
]);
const $db6ad3fef28672ff$export$d74b4eeb4811b110 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr28Filled', "28", [
    "M5.5 19c1.2 0 2.5.8 2.5 2.12a2 2 0 0 1-.59 1.38c.36.35.59.81.59 1.37C8 25.21 6.7 26 5.5 26a3.8 3.8 0 0 1-2.36-.81l-.2-.2A.75.75 0 0 1 4.06 24c.05.05.52.5 1.44.5.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62h-.25a.75.75 0 0 1 0-1.5h.25c.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62-.92 0-1.39.44-1.44.5a.75.75 0 0 1-1.12-1q.08-.1.2-.19.16-.16.49-.34A4 4 0 0 1 5.5 19M23 21a1 1 0 0 1 0 2H12a1 1 0 0 1 0-2zM5.5 10.5c1.27 0 2.5.9 2.5 2.25 0 .75-.37 1.28-.8 1.67-.4.35-.93.63-1.34.85q-.73.39-1.06.73h2.45a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75c0-1.61 1.3-2.34 2.13-2.79.48-.26.83-.45 1.08-.67.22-.2.29-.35.29-.54 0-.31-.34-.75-1-.75-.44 0-.86.17-1.17.48a.75.75 0 1 1-1.16-.96l.18-.19q.16-.16.45-.34c.39-.24.96-.5 1.7-.5M23 13a1 1 0 0 1 0 2H12a1 1 0 0 1 0-2zM5.92 2.02c.34.08.58.38.58.73v5.5a.75.75 0 0 1-1.5 0V4.98q-.38.37-.86.66a.75.75 0 0 1-.78-1.28c.5-.3.94-.78 1.25-1.21q.27-.35.47-.74c.15-.3.5-.47.84-.39M23 5a1 1 0 0 1 0 2H12a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$92886a0a28531294 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr28Regular', "28", [
    "M5.5 19c1.2 0 2.5.8 2.5 2.12a2 2 0 0 1-.59 1.38c.36.35.59.81.59 1.37C8 25.21 6.7 26 5.5 26a3.8 3.8 0 0 1-2.36-.81l-.2-.2A.75.75 0 0 1 4.06 24c.05.05.52.5 1.44.5.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62h-.25a.75.75 0 0 1 0-1.5h.25c.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62-.92 0-1.39.44-1.44.5a.75.75 0 0 1-1.12-1q.08-.1.2-.19.16-.16.49-.34A4 4 0 0 1 5.5 19m17.75 2a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1 0-1.5zM5.5 10.5c1.27 0 2.5.9 2.5 2.25 0 .75-.37 1.28-.8 1.67-.4.35-.93.63-1.34.85q-.73.39-1.06.73h2.45a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75c0-1.62 1.32-2.34 2.14-2.8.47-.25.82-.44 1.07-.66.22-.2.29-.35.29-.54 0-.31-.34-.75-1-.75-.44 0-.86.17-1.17.48a.75.75 0 1 1-1.16-.96l.18-.19q.16-.16.45-.34c.39-.24.96-.5 1.7-.5M23.25 13a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1 0-1.5zM5.92 2.02c.34.08.58.38.58.73v5.5a.75.75 0 0 1-1.5 0V4.98q-.38.37-.86.66a.75.75 0 0 1-.78-1.28c.5-.3.94-.78 1.25-1.21q.27-.35.47-.74c.15-.3.5-.47.84-.39M23.25 5a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$9dacac8e5b9ae510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr9020Filled', "20", [
    "M18.99 4.61a.5.5 0 0 1-.49.39h-4a.5.5 0 0 1 0-1h2.58q-.3-.33-.53-.78a.5.5 0 1 1 .9-.44 3 3 0 0 0 1.15 1.2l.12.07c.2.1.32.34.27.56m-7.34-1.96c.2-.2.5-.2.7 0h.01v.01l.11.12A2.4 2.4 0 0 1 13 4.32c0 .38-.1.79-.35 1.11A1.4 1.4 0 0 1 11.5 6a1.5 1.5 0 0 1-1.2-.57 4 4 0 0 1-.56-.96q-.23-.46-.47-.7A1 1 0 0 0 9 3.58V5.5a.5.5 0 1 1-1 0V3c0-.28.22-.5.5-.5.62 0 1.08.2 1.44.52a3 3 0 0 1 .77 1.15q.18.4.35.62a.5.5 0 0 0 .44.21q.26-.01.35-.16.14-.18.15-.53a1.5 1.5 0 0 0-.35-.95v-.01a.5.5 0 0 1 0-.7M5 4.25a.5.5 0 0 0-1 0c0 .34-.1.53-.18.63q-.14.14-.3.13C3.32 5 3 4.82 3 4.25c0-.41.1-.63.17-.72l.07-.1a.5.5 0 0 0-.46-.88h-.01l-.02.02-.15.1a1 1 0 0 0-.27.3c-.18.28-.33.7-.33 1.28 0 1.03.67 1.73 1.48 1.76.37.01.74-.12 1.02-.4.28.28.65.41 1.02.4C6.32 5.98 7 5.28 7 4.25c0-.59-.15-1-.33-1.28a1.4 1.4 0 0 0-.42-.4l-.01-.01h-.01a.5.5 0 0 0-.48.87l.08.1c.07.1.17.3.17.72 0 .57-.33.75-.52.76a.4.4 0 0 1-.3-.13C5.1 4.78 5 4.59 5 4.25m.75-.82.02.01zM5.25 8c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$21cac29fdbdeca17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr9020Regular', "20", [
    "M18.99 4.61a.5.5 0 0 1-.49.39h-4a.5.5 0 0 1 0-1h2.58q-.3-.33-.53-.78a.5.5 0 1 1 .9-.44 3 3 0 0 0 1.15 1.2l.12.07c.2.1.32.34.27.56m-7.34-1.96c.2-.2.5-.2.7 0h.01v.01l.11.12A2.4 2.4 0 0 1 13 4.32c0 .38-.1.79-.35 1.11A1.4 1.4 0 0 1 11.5 6a1.5 1.5 0 0 1-1.2-.57 4 4 0 0 1-.56-.96q-.23-.46-.47-.7A1 1 0 0 0 9 3.58V5.5a.5.5 0 1 1-1 0V3c0-.28.22-.5.5-.5.62 0 1.08.2 1.44.52a3 3 0 0 1 .77 1.15q.18.4.35.62a.5.5 0 0 0 .44.21q.26-.01.35-.16.14-.18.15-.53a1.5 1.5 0 0 0-.35-.95v-.01a.5.5 0 0 1 0-.7M4.5 3.75c.28 0 .5.22.5.5 0 .34.1.53.18.63q.14.14.3.13c.2-.01.52-.19.52-.76 0-.41-.1-.63-.17-.72l-.07-.1.02.02h-.01l-.01-.01h-.01a.5.5 0 0 1 .47-.89h.01l.02.02.15.1q.12.1.27.3c.18.28.33.7.33 1.28 0 1.03-.67 1.73-1.48 1.76-.37.01-.74-.12-1.02-.4-.28.28-.65.41-1.02.4C2.68 5.98 2 5.28 2 4.25c0-.59.15-1 .33-1.28a1.4 1.4 0 0 1 .42-.4l.01-.01h.01a.5.5 0 0 1 .48.87l-.08.1c-.07.1-.17.3-.17.72 0 .57.33.75.52.76q.16 0 .3-.13c.08-.1.18-.29.18-.63 0-.28.22-.5.5-.5M5.5 8c.28 0 .5.22.5.5v8a.5.5 0 1 1-1 0v-8c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v8a.5.5 0 1 1-1 0v-8c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v8a.5.5 0 1 1-1 0v-8c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$f476ae755a2b00e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr9024Filled', "24", [
    "M21.25 6a.75.75 0 0 0 .3-1.43l-.13-.07q-.15-.07-.38-.24a3 3 0 0 1-.9-.9.75.75 0 0 0-1.28.79l.25.35h-2.36a.75.75 0 0 0 0 1.5zM6 19.5v-8.62A1 1 0 0 0 4 11v8.62a1 1 0 0 0 2-.12m6.5 0v-8.62a1 1 0 0 0-2 .12v8.62a1 1 0 0 0 2-.12m6.5 0v-8.62a1 1 0 0 0-2 .12v8.62a1 1 0 0 0 2-.12M13.48 5.15c.05-.3-.07-.68-.26-.87a.75.75 0 1 1 1.06-1.06c.56.56.81 1.43.68 2.2-.07.39-.26.8-.6 1.1A2 2 0 0 1 13 7c-.62 0-1.08-.27-1.42-.6-.28-.28-.51-.64-.69-.91l-.05-.08q-.2-.3-.34-.48v1.32a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75 1.31 0 1.95.98 2.34 1.58l.04.06q.28.46.5.68.2.2.37.18c.22 0 .32-.06.36-.1q.08-.06.12-.25M2.72 2.97s-.08.1 0 0l-.01.01-.01.01-.13.15q-.11.15-.24.4C2.16 3.88 2 4.37 2 5c0 .64.18 1.2.54 1.6s.86.61 1.36.6q.64-.04 1.1-.43.46.4 1.1.43c.5.01 1-.2 1.36-.6Q8 5.98 8 5a3.2 3.2 0 0 0-.57-1.86L7.3 3l-.01-.01-.01-.01a.75.75 0 1 0-1.05 1.07l.1.17c.08.16.17.42.17.79 0 .36-.1.54-.16.6a.2.2 0 0 1-.2.1.3.3 0 0 1-.22-.13c-.08-.09-.17-.26-.17-.57a.75.75 0 0 0-1.5 0c0 .31-.1.48-.17.57a.3.3 0 0 1-.23.13.2.2 0 0 1-.19-.1c-.06-.06-.16-.24-.16-.6a2 2 0 0 1 .27-.96l.02-.02a.75.75 0 0 0-1.07-1.05m4.56 0s.17.2 0 0"
]);
const $db6ad3fef28672ff$export$dd5e3ed7b2056c31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtr9024Regular', "24", [
    "M21.25 6a.75.75 0 0 0 .3-1.43l-.13-.07q-.15-.07-.38-.24a3 3 0 0 1-.9-.9.75.75 0 0 0-1.28.79l.25.35h-2.36a.75.75 0 0 0 0 1.5zm-16 14.5c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-1.5 0v9c0 .41.34.75.75.75m6.5 0c.42 0 .76-.34.76-.75v-9a.75.75 0 1 0-1.5 0v9c0 .41.33.75.75.75m6.5 0c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-1.5 0v9c0 .41.34.75.75.75M13.48 5.15c.05-.3-.07-.68-.26-.87a.75.75 0 1 1 1.06-1.06c.56.56.81 1.43.68 2.2-.07.39-.26.8-.6 1.1A2 2 0 0 1 13 7c-.62 0-1.08-.27-1.42-.6-.28-.28-.51-.64-.69-.91l-.05-.08q-.2-.3-.34-.48v1.32a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75 1.31 0 1.95.98 2.34 1.58l.04.06q.28.46.5.68.2.2.37.18c.22 0 .32-.06.36-.1q.08-.06.12-.25M2.72 2.97s-.08.1 0 0l-.01.01-.01.01-.13.15q-.11.15-.24.4C2.16 3.88 2 4.37 2 5c0 .64.18 1.2.54 1.6s.86.61 1.36.6q.64-.04 1.1-.43.46.4 1.1.43c.5.01 1-.2 1.36-.6Q8 5.98 8 5a3.2 3.2 0 0 0-.57-1.86L7.3 3l-.01-.01-.01-.01a.75.75 0 1 0-1.05 1.07l.1.17c.08.16.17.42.17.79 0 .36-.1.54-.16.6a.2.2 0 0 1-.2.1.3.3 0 0 1-.22-.13c-.08-.09-.17-.26-.17-.57a.75.75 0 0 0-1.5 0c0 .31-.1.48-.17.57a.3.3 0 0 1-.23.13.2.2 0 0 1-.19-.1c-.06-.06-.16-.24-.16-.6a2 2 0 0 1 .27-.96l.02-.02a.75.75 0 0 0-1.07-1.05m4.56 0s.17.2 0 0"
]);
const $db6ad3fef28672ff$export$e44ed9444343af6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate27020Filled', "20", [
    "M4.75 11a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75M1.01 14.39A.5.5 0 0 1 1.5 14h4a.5.5 0 1 1 0 1H2.92q.3.33.53.78a.5.5 0 1 1-.9.44 3 3 0 0 0-1.15-1.2l-.12-.07a.5.5 0 0 1-.27-.56m7.34 1.96a.5.5 0 0 1-.7 0h-.01v-.01l-.11-.12-.22-.33a2.5 2.5 0 0 1-.31-1.2v-.02c0-.37.1-.78.35-1.1A1.4 1.4 0 0 1 8.5 13c.55 0 .93.24 1.2.57.21.25.37.57.5.83l.06.13q.23.46.47.7.11.12.27.18V13.5a.5.5 0 1 1 1 0V16a.5.5 0 0 1-.5.5q-.92-.02-1.44-.52a3 3 0 0 1-.77-1.15 3 3 0 0 0-.35-.62.5.5 0 0 0-.44-.21q-.26.01-.35.16a1 1 0 0 0-.15.53 1.5 1.5 0 0 0 .35.95v.01c.2.2.2.5 0 .7m6.65-1.6a.5.5 0 1 0 1 0c0-.34.1-.53.18-.63q.14-.14.3-.13c.2.01.52.19.52.76 0 .41-.1.63-.17.72l-.07.1a.5.5 0 0 0 .46.88h.01l.02-.02.04-.02.1-.08q.13-.1.28-.3c.18-.28.33-.7.33-1.28 0-1.03-.67-1.73-1.48-1.76-.37-.01-.74.12-1.02.4a1.4 1.4 0 0 0-1.02-.4c-.8.03-1.48.73-1.48 1.76 0 .59.15 1 .33 1.28a1.4 1.4 0 0 0 .42.4l.01.01h.01a.5.5 0 0 0 .48-.87l-.08-.1c-.07-.1-.17-.3-.17-.72 0-.57.33-.75.52-.76q.16 0 .3.13c.08.1.18.29.18.63m-.75.82-.02-.01z"
]);
const $db6ad3fef28672ff$export$76f6ecd5b2a1799a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate27020Regular', "20", [
    "M4.5 11a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m.5 3.75a.5.5 0 1 0 1 0c0-.34.1-.53.18-.63q.14-.14.3-.13c.2.01.52.19.52.76 0 .41-.1.63-.17.72l-.07.1a.5.5 0 0 0 .46.88h.01l.02-.02.04-.02.1-.08q.13-.1.28-.3c.18-.28.33-.7.33-1.28 0-1.03-.67-1.73-1.48-1.76-.37-.01-.74.12-1.02.4a1.4 1.4 0 0 0-1.02-.4c-.8.03-1.48.73-1.48 1.76 0 .59.15 1 .33 1.28a1.4 1.4 0 0 0 .42.4l.01.01h.01a.5.5 0 0 0 .48-.87l-.08-.1c-.07-.1-.17-.3-.17-.72 0-.57.33-.75.52-.76q.16 0 .3.13c.08.1.18.29.18.63m-6.65 1.6a.5.5 0 0 1-.7 0h-.01v-.01l-.11-.12-.22-.33a2.5 2.5 0 0 1-.31-1.2v-.02c0-.37.1-.78.35-1.1A1.4 1.4 0 0 1 8.5 13c.55 0 .93.24 1.2.57a4 4 0 0 1 .56.96q.23.46.47.7.11.12.27.18V13.5a.5.5 0 1 1 1 0V16a.5.5 0 0 1-.5.5q-.92-.02-1.44-.52a3 3 0 0 1-.77-1.15 3 3 0 0 0-.35-.62.5.5 0 0 0-.44-.21q-.26.01-.35.16a1 1 0 0 0-.15.53 1.5 1.5 0 0 0 .35.95v.01c.2.2.2.5 0 .7m-7.34-1.97A.5.5 0 0 1 1.5 14h4a.5.5 0 1 1 0 1H2.92q.3.33.53.78a.5.5 0 1 1-.9.44 3 3 0 0 0-1.15-1.2l-.12-.07a.5.5 0 0 1-.27-.56"
]);
const $db6ad3fef28672ff$export$8d15c8af7324f1fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate27024Filled', "24", [
    "M2.75 18a.75.75 0 0 0-.3 1.43l.13.07q.15.07.38.24c.32.22.66.52.9.9a.75.75 0 1 0 1.28-.79l-.25-.35h2.36a.75.75 0 0 0 0-1.5zM18 4.5v8.62a1 1 0 0 0 2-.12V4.38a1 1 0 0 0-2 .12m-6.5 0v8.62a1 1 0 0 0 2-.12V4.38a1 1 0 0 0-2 .12M5 4.5v8.62A1 1 0 0 0 7 13V4.38a1 1 0 0 0-2 .12m5.52 14.35c-.05.3.07.68.26.87a.75.75 0 0 1-1.06 1.06 2.6 2.6 0 0 1-.68-2.2c.07-.39.26-.8.6-1.1A2 2 0 0 1 11 17c.62 0 1.08.27 1.42.6.28.28.51.64.69.91l.05.08q.2.3.34.48v-1.32a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75-1.31 0-1.95-.98-2.34-1.58l-.04-.06a4 4 0 0 0-.5-.69q-.2-.18-.37-.17-.31.02-.36.1a.4.4 0 0 0-.12.25m10.76 2.18s.08-.1 0 0l.01-.01.01-.01.13-.15q.11-.15.24-.4c.17-.34.33-.83.33-1.46q0-.98-.54-1.6c-.36-.41-.86-.61-1.36-.6q-.64.04-1.1.43-.46-.4-1.1-.43c-.5-.01-1 .19-1.36.6S16 18.36 16 19a3.2 3.2 0 0 0 .57 1.86l.13.15.01.01.01.01a.75.75 0 1 0 1.05-1.07l-.1-.17a2 2 0 0 1-.17-.79c0-.36.1-.54.16-.6a.2.2 0 0 1 .2-.1q.1 0 .22.13c.08.09.17.26.17.57a.75.75 0 0 0 1.5 0c0-.31.1-.48.17-.57q.12-.13.23-.13.1-.01.19.1c.06.06.16.24.16.6a2 2 0 0 1-.27.96l-.02.02a.75.75 0 0 0 1.07 1.05m-4.56 0s-.17-.2 0 0"
]);
const $db6ad3fef28672ff$export$8fb586b6a9436da0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate27024Regular', "24", [
    "M2.75 18a.75.75 0 0 0-.3 1.43l.13.07q.15.07.38.24c.32.22.66.52.9.9a.75.75 0 1 0 1.28-.79l-.25-.35h2.36a.75.75 0 0 0 0-1.5zm16-14.5a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m-6.5 0a.75.75 0 0 0-.76.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m-6.5 0a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m4.77 15.35c-.05.3.07.68.26.87a.75.75 0 0 1-1.06 1.06 2.6 2.6 0 0 1-.68-2.2c.07-.39.26-.8.6-1.1A2 2 0 0 1 11 17c.62 0 1.08.27 1.42.6.28.28.51.64.69.91l.05.08q.2.3.34.48v-1.32a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75-1.31 0-1.95-.98-2.34-1.58l-.04-.06a4 4 0 0 0-.5-.69q-.2-.18-.37-.17-.31.02-.36.1a.4.4 0 0 0-.12.25m10.76 2.18s.08-.1 0 0l.01-.01.01-.01.13-.15q.11-.15.24-.4c.17-.34.33-.83.33-1.46q0-.98-.54-1.6c-.36-.41-.86-.61-1.36-.6q-.64.04-1.1.43-.46-.4-1.1-.43c-.5-.01-1 .19-1.36.6S16 18.36 16 19a3.2 3.2 0 0 0 .57 1.86l.13.15.01.01.01.01a.75.75 0 1 0 1.05-1.07l-.1-.17a2 2 0 0 1-.17-.79c0-.36.1-.54.16-.6a.2.2 0 0 1 .2-.1q.1 0 .22.13c.08.09.17.26.17.57a.75.75 0 0 0 1.5 0c0-.31.1-.48.17-.57q.12-.13.23-.13.1-.01.19.1c.06.06.16.24.16.6a2 2 0 0 1-.27.96l-.02.02a.75.75 0 0 0 1.07 1.05m-4.56 0s-.17-.2 0 0"
]);
const $db6ad3fef28672ff$export$d3c44729e2629788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate27028Filled', "28", [
    "M23.87 20c1.34 0 2.13 1.3 2.13 2.5a3.8 3.8 0 0 1-.81 2.36l-.2.2a.75.75 0 0 1-.99-1.12c.05-.05.5-.52.5-1.44 0-.73-.44-1-.63-1-.18 0-.62.27-.62 1v.25a.75.75 0 1 1-1.5 0v-.25c0-.73-.44-1-.63-1-.18 0-.62.27-.62 1 0 .92.44 1.38.5 1.44a.75.75 0 0 1-1 1.12q-.1-.09-.19-.2-.16-.16-.34-.49A4 4 0 0 1 19 22.5c0-1.2.8-2.5 2.12-2.5.56 0 1.03.23 1.38.59a2 2 0 0 1 1.37-.59m-7.12 0c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75-1.61 0-2.34-1.3-2.79-2.13-.26-.48-.45-.83-.67-1.08-.2-.22-.35-.29-.54-.29-.31 0-.75.34-.75 1 0 .44.17.86.48 1.17a.75.75 0 1 1-.96 1.16l-.19-.18q-.16-.16-.34-.45c-.24-.39-.5-.96-.5-1.7 0-1.27.91-2.5 2.26-2.5.75 0 1.28.37 1.67.8.35.4.63.93.85 1.34q.39.73.73 1.06v-2.45c0-.41.34-.75.75-.75m-8.5 1.5a.75.75 0 0 1 0 1.5H4.98q.37.38.66.86a.75.75 0 0 1-1.28.78c-.3-.5-.78-.94-1.21-1.25a5 5 0 0 0-.74-.47.75.75 0 0 1 .34-1.42zM6 4a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$a1dfb5c578510c40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate27028Regular', "28", [
    "M23.87 20c1.34 0 2.13 1.3 2.13 2.5a3.8 3.8 0 0 1-.81 2.36l-.2.2a.75.75 0 0 1-.99-1.12c.05-.05.5-.52.5-1.44 0-.73-.44-1-.63-1-.18 0-.62.27-.62 1v.25a.75.75 0 1 1-1.5 0v-.25c0-.73-.44-1-.63-1-.18 0-.62.27-.62 1 0 .92.44 1.38.5 1.44a.75.75 0 0 1-1 1.12q-.1-.09-.19-.2-.16-.16-.34-.49A4 4 0 0 1 19 22.5c0-1.2.8-2.5 2.12-2.5.56 0 1.03.23 1.38.59a2 2 0 0 1 1.37-.59m-7.12 0c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75-1.61 0-2.34-1.3-2.79-2.13-.26-.48-.45-.83-.67-1.08-.2-.22-.35-.29-.54-.29-.31 0-.75.34-.75 1 0 .44.17.86.48 1.17a.75.75 0 1 1-.96 1.16l-.19-.18q-.16-.16-.34-.45c-.24-.39-.5-.96-.5-1.7 0-1.27.91-2.5 2.26-2.5.75 0 1.28.37 1.67.8.35.4.63.93.85 1.34q.39.73.73 1.06v-2.45c0-.41.34-.75.75-.75m-8.5 1.5a.75.75 0 0 1 0 1.5H4.98q.37.38.66.86a.75.75 0 0 1-1.28.78c-.3-.5-.78-.94-1.21-1.25a5 5 0 0 0-.74-.47.75.75 0 0 1 .34-1.42zM5.75 4c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$1b0b94ad301bb58d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate9028Filled', "28", [
    "M6 11a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V12a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V12a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V12a1 1 0 0 1 1-1M6.94 3a.75.75 0 0 1 1.05-.06q.1.08.2.2.16.16.34.49c.24.43.47 1.05.47 1.87C9 6.7 8.2 8 6.88 8a2 2 0 0 1-1.38-.59A2 2 0 0 1 4.13 8C2.79 8 2 6.7 2 5.5a3.8 3.8 0 0 1 .81-2.36q.08-.1.2-.2A.75.75 0 0 1 4 4.06c-.05.05-.5.51-.5 1.44 0 .73.44 1 .63 1 .18 0 .62-.27.62-1v-.25a.75.75 0 0 1 1.5 0v.25c0 .73.44 1 .63 1 .18 0 .62-.27.62-1 0-.92-.44-1.38-.5-1.44a.75.75 0 0 1-.06-1.05m4.31 0c1.61 0 2.33 1.3 2.79 2.13.26.48.45.83.67 1.08.2.22.35.29.54.29.31 0 .75-.34.75-1 0-.44-.17-.86-.48-1.17a.75.75 0 1 1 .96-1.16l.19.18q.16.16.34.45c.24.39.49.96.49 1.7 0 1.27-.9 2.5-2.25 2.5-.75 0-1.28-.37-1.67-.8-.35-.4-.63-.93-.85-1.34q-.4-.73-.73-1.06v2.45a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75m11.36.1a.75.75 0 0 1 1.03.26c.3.5.78.94 1.21 1.25q.35.26.74.47a.75.75 0 0 1-.34 1.42h-5.5a.75.75 0 0 1 0-1.5h3.27a5 5 0 0 1-.66-.86.75.75 0 0 1 .25-1.03"
]);
const $db6ad3fef28672ff$export$664fab5bedda7e25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListLtrRotate9028Regular', "28", [
    "M6.25 11c.42 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0v-11.5c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0v-11.5c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0v-11.5c0-.41.34-.75.75-.75M6.94 3a.75.75 0 0 1 1.05-.06q.1.08.2.2.16.16.34.49c.24.43.47 1.05.47 1.87C9 6.7 8.2 8 6.88 8a2 2 0 0 1-1.38-.59A2 2 0 0 1 4.13 8C2.79 8 2 6.7 2 5.5a3.8 3.8 0 0 1 .81-2.36q.08-.1.2-.2A.75.75 0 0 1 4 4.06c-.05.05-.5.52-.5 1.44 0 .73.44 1 .63 1 .18 0 .62-.27.62-1v-.25a.75.75 0 0 1 1.5 0v.25c0 .73.44 1 .63 1 .18 0 .62-.27.62-1 0-.92-.45-1.39-.5-1.44a.75.75 0 0 1-.06-1.05m4.31 0c1.61 0 2.33 1.3 2.79 2.13.26.48.45.83.67 1.08.2.22.35.29.54.29.31 0 .75-.34.75-1 0-.44-.17-.86-.48-1.17a.75.75 0 1 1 .96-1.16l.19.18q.16.16.34.45c.24.39.49.96.49 1.7 0 1.27-.9 2.5-2.25 2.5-.75 0-1.28-.37-1.67-.8-.35-.4-.63-.93-.85-1.34q-.4-.73-.73-1.06v2.45a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75m11.36.1a.75.75 0 0 1 1.03.26c.3.5.78.94 1.21 1.25q.35.26.74.47a.75.75 0 0 1-.34 1.42h-5.5a.75.75 0 0 1 0-1.5h3.27a5 5 0 0 1-.66-.86.75.75 0 0 1 .25-1.03"
]);
const $db6ad3fef28672ff$export$8c31924cc696c198 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate27020Filled', "20", [
    "M4.75 11a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m5 0a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75M1.01 14.39A.5.5 0 0 1 1.5 14h4a.5.5 0 1 1 0 1H2.92q.3.33.53.78a.5.5 0 1 1-.9.44 3 3 0 0 0-1.15-1.2l-.12-.07a.5.5 0 0 1-.27-.56m7.34 1.96a.5.5 0 0 1-.7 0h-.01v-.01l-.11-.12-.22-.33a2.5 2.5 0 0 1-.31-1.2v-.02c0-.37.1-.78.35-1.1A1.4 1.4 0 0 1 8.5 13c.55 0 .93.24 1.2.57.21.25.37.57.5.83l.06.13q.23.46.47.7.11.12.27.18V13.5a.5.5 0 1 1 1 0V16a.5.5 0 0 1-.5.5q-.92-.02-1.44-.52a3 3 0 0 1-.77-1.15 3 3 0 0 0-.35-.62.5.5 0 0 0-.44-.21q-.26.01-.35.16a1 1 0 0 0-.15.53 1.5 1.5 0 0 0 .35.95v.01c.2.2.2.5 0 .7m6.65-1.6a.5.5 0 1 0 1 0c0-.34.1-.53.18-.63q.14-.14.3-.13c.2.01.52.19.52.76 0 .41-.1.63-.17.72l-.07.1a.5.5 0 0 0 .46.88h.01l.02-.02.04-.02.1-.08q.13-.1.28-.3c.18-.28.33-.7.33-1.28 0-1.03-.67-1.73-1.48-1.76-.37-.01-.74.12-1.02.4a1.4 1.4 0 0 0-1.02-.4c-.8.03-1.48.73-1.48 1.76 0 .59.15 1 .33 1.28a1.4 1.4 0 0 0 .42.4l.01.01h.01a.5.5 0 0 0 .48-.87l-.08-.1c-.07-.1-.17-.3-.17-.72 0-.57.33-.75.52-.76q.16 0 .3.13c.08.1.18.29.18.63m-.75.82-.02-.01z"
]);
const $db6ad3fef28672ff$export$cf3027746c0dfa89 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate27020Regular', "20", [
    "M4.5 11a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m5 0a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m.5 3.75a.5.5 0 1 0 1 0c0-.34.1-.53.18-.63q.14-.14.3-.13c.2.01.52.19.52.76 0 .41-.1.63-.17.72l-.07.1a.5.5 0 0 0 .46.88h.01l.02-.02.04-.02.1-.08q.13-.1.28-.3c.18-.28.33-.7.33-1.28 0-1.03-.67-1.73-1.48-1.76-.37-.01-.74.12-1.02.4a1.4 1.4 0 0 0-1.02-.4c-.8.03-1.48.73-1.48 1.76 0 .59.15 1 .33 1.28a1.4 1.4 0 0 0 .42.4l.01.01h.01a.5.5 0 0 0 .48-.87l-.08-.1c-.07-.1-.17-.3-.17-.72 0-.57.33-.75.52-.76q.16 0 .3.13c.08.1.18.29.18.63m-6.65 1.6a.5.5 0 0 1-.7 0h-.01v-.01l-.11-.12-.22-.33a2.5 2.5 0 0 1-.31-1.2v-.02c0-.37.1-.78.35-1.1A1.4 1.4 0 0 1 8.5 13c.55 0 .93.24 1.2.57a4 4 0 0 1 .56.96q.23.46.47.7.11.12.27.18V13.5a.5.5 0 1 1 1 0V16a.5.5 0 0 1-.5.5q-.92-.02-1.44-.52a3 3 0 0 1-.77-1.15 3 3 0 0 0-.35-.62.5.5 0 0 0-.44-.21q-.26.01-.35.16a1 1 0 0 0-.15.53 1.5 1.5 0 0 0 .35.95v.01c.2.2.2.5 0 .7m-7.34-1.97A.5.5 0 0 1 1.5 14h4a.5.5 0 1 1 0 1H2.92q.3.33.53.78a.5.5 0 1 1-.9.44 3 3 0 0 0-1.15-1.2l-.12-.07a.5.5 0 0 1-.27-.56"
]);
const $db6ad3fef28672ff$export$e6e288abe9b3de2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate27024Filled', "24", [
    "M2.75 18a.75.75 0 0 0-.3 1.43l.13.07q.15.08.38.24c.32.22.66.52.9.9a.75.75 0 0 0 1.28-.79l-.25-.35h2.36a.75.75 0 0 0 0-1.5zM18 4.5v8.62a1 1 0 0 0 2-.12V4.38a1 1 0 0 0-2 .12m-6.5 0v8.62a1 1 0 0 0 2-.12V4.38a1 1 0 0 0-2 .12M5 4.5v8.62A1 1 0 0 0 7 13V4.38a1 1 0 0 0-2 .12m5.52 14.35c-.05.3.07.68.26.87a.75.75 0 0 1-1.06 1.06 2.6 2.6 0 0 1-.68-2.2c.07-.39.26-.8.6-1.1A2 2 0 0 1 11 17c.62 0 1.08.27 1.42.6.28.28.51.64.69.91l.05.08q.2.3.34.48v-1.32a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75-1.31 0-1.95-.98-2.34-1.58l-.04-.06a4 4 0 0 0-.5-.68q-.2-.2-.37-.18-.31.02-.36.1a.4.4 0 0 0-.12.25m10.76 2.18s.08-.1 0 0l.01-.01.01-.01.13-.15q.11-.15.24-.4c.17-.34.33-.83.33-1.46q0-.98-.54-1.6c-.36-.4-.86-.61-1.36-.6q-.64.04-1.1.43-.46-.4-1.1-.43c-.5-.01-1 .2-1.36.6S16 18.36 16 19a3.2 3.2 0 0 0 .57 1.86l.13.15.01.01.01.01a.75.75 0 1 0 1.05-1.07l-.1-.17a2 2 0 0 1-.17-.79c0-.36.1-.54.16-.6a.2.2 0 0 1 .2-.1q.1 0 .22.13c.08.09.17.26.17.57a.75.75 0 0 0 1.5 0c0-.31.1-.48.17-.57q.12-.13.23-.13.1-.01.19.1c.06.06.16.24.16.6a2 2 0 0 1-.27.96l-.02.02a.75.75 0 0 0 1.07 1.05m-4.56 0s-.17-.2 0 0"
]);
const $db6ad3fef28672ff$export$b926a7fbfc580718 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate27024Regular', "24", [
    "M2.75 18a.75.75 0 0 0-.3 1.43l.13.07q.15.08.38.24c.32.22.66.52.9.9a.75.75 0 0 0 1.28-.79l-.25-.35h2.36a.75.75 0 0 0 0-1.5zm16-14.5a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m-6.5 0a.75.75 0 0 0-.76.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m-6.5 0a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m4.77 15.35c-.05.3.07.68.26.87a.75.75 0 0 1-1.06 1.06 2.6 2.6 0 0 1-.68-2.2c.07-.39.26-.8.6-1.1A2 2 0 0 1 11 17c.62 0 1.08.27 1.42.6.28.28.51.64.69.91l.05.08q.2.3.34.48v-1.32a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75-1.31 0-1.95-.98-2.34-1.58l-.04-.06a4 4 0 0 0-.5-.68q-.2-.2-.37-.18-.31.02-.36.1a.4.4 0 0 0-.12.25m10.76 2.18s.08-.1 0 0l.01-.01.01-.01.13-.15q.11-.15.24-.4c.17-.34.33-.83.33-1.46q0-.98-.54-1.6c-.36-.4-.86-.61-1.36-.6q-.64.04-1.1.43-.46-.4-1.1-.43c-.5-.01-1 .2-1.36.6S16 18.36 16 19a3.2 3.2 0 0 0 .57 1.86l.13.15.01.01.01.01a.75.75 0 1 0 1.05-1.07l-.1-.17a2 2 0 0 1-.17-.79c0-.36.1-.54.16-.6a.2.2 0 0 1 .2-.1q.1 0 .22.13c.08.09.17.26.17.57a.75.75 0 0 0 1.5 0c0-.31.1-.48.17-.57q.12-.13.23-.13.1-.01.19.1c.06.06.16.24.16.6a2 2 0 0 1-.27.96l-.02.02a.75.75 0 0 0 1.07 1.05m-4.56 0s-.17-.2 0 0"
]);
const $db6ad3fef28672ff$export$e666cb0af6b30920 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate9020Filled', "20", [
    "M18.99 4.61a.5.5 0 0 1-.49.39h-4a.5.5 0 0 1 0-1h2.58q-.3-.33-.53-.78a.5.5 0 1 1 .9-.44 3 3 0 0 0 1.15 1.2l.12.07c.2.1.32.34.27.56m-7.34-1.96c.2-.2.5-.2.7 0h.01v.01l.11.12A2.4 2.4 0 0 1 13 4.32c0 .38-.1.79-.35 1.11A1.4 1.4 0 0 1 11.5 6a1.5 1.5 0 0 1-1.2-.57 4 4 0 0 1-.56-.96q-.23-.46-.47-.7A1 1 0 0 0 9 3.58V5.5a.5.5 0 1 1-1 0V3c0-.28.22-.5.5-.5.62 0 1.08.2 1.44.52a3 3 0 0 1 .77 1.15q.18.4.35.62a.5.5 0 0 0 .44.21q.26-.01.35-.16.14-.18.15-.53a1.5 1.5 0 0 0-.35-.95v-.01a.5.5 0 0 1 0-.7M5 4.25a.5.5 0 0 0-1 0c0 .34-.1.53-.18.63q-.14.14-.3.13C3.32 5 3 4.82 3 4.25c0-.41.1-.63.17-.72l.07-.1a.5.5 0 0 0-.46-.88h-.01l-.02.02-.15.1a1 1 0 0 0-.27.3c-.18.28-.33.7-.33 1.28 0 1.03.67 1.73 1.48 1.76.37.01.74-.12 1.02-.4.28.28.65.41 1.02.4C6.32 5.98 7 5.28 7 4.25c0-.59-.15-1-.33-1.28a1.4 1.4 0 0 0-.42-.4l-.01-.01h-.01a.5.5 0 0 0-.48.87l.08.1c.07.1.17.3.17.72 0 .57-.33.75-.52.76a.4.4 0 0 1-.3-.13C5.1 4.78 5 4.59 5 4.25m.75-.82.02.01zM5.25 8c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$9ee6224dc0cf8654 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate9020Regular', "20", [
    "M18.99 4.61a.5.5 0 0 1-.49.39h-4a.5.5 0 0 1 0-1h2.58q-.3-.33-.53-.78a.5.5 0 1 1 .9-.44 3 3 0 0 0 1.15 1.2l.12.07c.2.1.32.34.27.56m-7.34-1.96c.2-.2.5-.2.7 0h.01v.01l.11.12A2.4 2.4 0 0 1 13 4.32c0 .38-.1.79-.35 1.11A1.4 1.4 0 0 1 11.5 6a1.5 1.5 0 0 1-1.2-.57 4 4 0 0 1-.56-.96q-.23-.46-.47-.7A1 1 0 0 0 9 3.58V5.5a.5.5 0 1 1-1 0V3c0-.28.22-.5.5-.5.62 0 1.08.2 1.44.52a3 3 0 0 1 .77 1.15q.18.4.35.62a.5.5 0 0 0 .44.21q.26-.01.35-.16.14-.18.15-.53a1.5 1.5 0 0 0-.35-.95v-.01a.5.5 0 0 1 0-.7M4.5 3.75c.28 0 .5.22.5.5 0 .34.1.53.18.63q.14.14.3.13c.2-.01.52-.19.52-.76 0-.41-.1-.63-.17-.72l-.07-.1.02.02h-.01l-.01-.01h-.01a.5.5 0 0 1 .47-.89h.01l.02.02.15.1q.12.1.27.3c.18.28.33.7.33 1.28 0 1.03-.67 1.73-1.48 1.76-.37.01-.74-.12-1.02-.4-.28.28-.65.41-1.02.4C2.68 5.98 2 5.28 2 4.25c0-.59.15-1 .33-1.28a1.4 1.4 0 0 1 .42-.4l.01-.01h.01a.5.5 0 0 1 .48.87l-.08.1c-.07.1-.17.3-.17.72 0 .57.33.75.52.76q.16 0 .3-.13c.08-.1.18-.29.18-.63 0-.28.22-.5.5-.5M5.5 8c.28 0 .5.22.5.5v8a.5.5 0 1 1-1 0v-8c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v8a.5.5 0 1 1-1 0v-8c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v8a.5.5 0 1 1-1 0v-8c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$92425991db0c974f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate9024Filled', "24", [
    "M21.25 6a.75.75 0 0 0 .3-1.43l-.13-.07q-.15-.07-.38-.24a3 3 0 0 1-.9-.9.75.75 0 0 0-1.28.79l.25.35h-2.36a.75.75 0 0 0 0 1.5zM6 19.5v-8.62A1 1 0 0 0 4 11v8.62a1 1 0 0 0 2-.12m6.5 0v-8.62a1 1 0 0 0-2 .12v8.62a1 1 0 0 0 2-.12m6.5 0v-8.62a1 1 0 0 0-2 .12v8.62a1 1 0 0 0 2-.12M13.48 5.15c.05-.3-.07-.68-.26-.87a.75.75 0 1 1 1.06-1.06c.56.56.81 1.43.68 2.2-.07.39-.26.8-.6 1.1A2 2 0 0 1 13 7c-.62 0-1.08-.27-1.42-.6-.28-.28-.51-.64-.69-.91l-.05-.08q-.2-.3-.34-.48v1.32a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75 1.31 0 1.95.98 2.34 1.58l.04.06q.28.46.5.68.2.2.37.18c.22 0 .32-.06.36-.1q.08-.06.12-.25M2.72 2.97s-.08.1 0 0l-.01.01-.01.01-.13.15q-.11.15-.24.4C2.16 3.88 2 4.37 2 5c0 .64.18 1.2.54 1.6s.86.61 1.36.6q.64-.04 1.1-.43.46.4 1.1.43c.5.01 1-.2 1.36-.6Q8 5.98 8 5a3.2 3.2 0 0 0-.57-1.86L7.3 3l-.01-.01-.01-.01a.75.75 0 1 0-1.05 1.07l.1.17c.08.16.17.42.17.79 0 .36-.1.54-.16.6a.2.2 0 0 1-.2.1.3.3 0 0 1-.22-.13c-.08-.09-.17-.26-.17-.57a.75.75 0 0 0-1.5 0c0 .31-.1.48-.17.57a.3.3 0 0 1-.23.13.2.2 0 0 1-.19-.1c-.06-.06-.16-.24-.16-.6a2 2 0 0 1 .27-.96l.02-.02a.75.75 0 0 0-1.07-1.05m4.56 0s.17.2 0 0"
]);
const $db6ad3fef28672ff$export$62a799de12a0d12c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRotate9024Regular', "24", [
    "M21.25 6a.75.75 0 0 0 .3-1.43l-.13-.07q-.15-.07-.38-.24a3 3 0 0 1-.9-.9.75.75 0 0 0-1.28.79l.25.35h-2.36a.75.75 0 0 0 0 1.5zm-16 14.5c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-1.5 0v9c0 .41.34.75.75.75m6.5 0c.42 0 .76-.34.76-.75v-9a.75.75 0 1 0-1.5 0v9c0 .41.33.75.75.75m6.5 0c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-1.5 0v9c0 .41.34.75.75.75M13.48 5.15c.05-.3-.07-.68-.26-.87a.75.75 0 1 1 1.06-1.06c.56.56.81 1.43.68 2.2-.07.39-.26.8-.6 1.1A2 2 0 0 1 13 7c-.62 0-1.08-.27-1.42-.6-.28-.28-.51-.64-.69-.91l-.05-.08q-.2-.3-.34-.48v1.32a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75 1.31 0 1.95.98 2.34 1.58l.04.06q.28.46.5.68.2.2.37.18c.22 0 .32-.06.36-.1q.08-.06.12-.25M2.72 2.97s-.08.1 0 0l-.01.01-.01.01-.13.15q-.11.15-.24.4C2.16 3.88 2 4.37 2 5c0 .64.18 1.2.54 1.6s.86.61 1.36.6q.64-.04 1.1-.43.46.4 1.1.43c.5.01 1-.2 1.36-.6Q8 5.98 8 5a3.2 3.2 0 0 0-.57-1.86L7.3 3l-.01-.01-.01-.01a.75.75 0 1 0-1.05 1.07l.1.17c.08.16.17.42.17.79 0 .36-.1.54-.16.6a.2.2 0 0 1-.2.1.3.3 0 0 1-.22-.13c-.08-.09-.17-.26-.17-.57a.75.75 0 0 0-1.5 0c0 .31-.1.48-.17.57a.3.3 0 0 1-.23.13.2.2 0 0 1-.19-.1c-.06-.06-.16-.24-.16-.6a2 2 0 0 1 .27-.96l.02-.02a.75.75 0 0 0-1.07-1.05m4.56 0s.17.2 0 0"
]);
const $db6ad3fef28672ff$export$a4bca3ac74099db0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl16Filled', "16", [
    "M12.68 1.01c.2.04.33.21.33.4v3.3c0 .22-.19.4-.42.4a.4.4 0 0 1-.43-.4V2.58q-.28.24-.67.44a.44.44 0 0 1-.57-.19.4.4 0 0 1 .2-.55 2.5 2.5 0 0 0 1.08-1.05c.1-.17.29-.26.48-.22m-1.53 6.05a.4.4 0 0 1 0-.59h.01l.11-.1.28-.17c.24-.13.6-.26 1.03-.26h.01c.32 0 .67.09.95.29q.46.31.48.95c0 .45-.2.76-.48.99-.22.17-.5.3-.72.4l-.1.06q-.4.17-.61.39a1 1 0 0 0-.15.22h1.64c.23 0 .42.18.42.4s-.19.42-.42.42h-2.14a.4.4 0 0 1-.43-.41q.02-.76.44-1.19c.26-.27.6-.44.87-.57l.12-.06q.34-.15.53-.3.18-.13.18-.35-.01-.21-.14-.3a1 1 0 0 0-.45-.12 1.3 1.3 0 0 0-.82.3.44.44 0 0 1-.6 0m.94 5.88c0-.23.2-.41.43-.41.3 0 .46-.08.54-.15a.3.3 0 0 0 .1-.25c0-.16-.15-.42-.64-.42-.35 0-.53.08-.62.13l-.07.07v-.02.02a.44.44 0 0 1-.57.16.4.4 0 0 1-.2-.55h.01l.01-.02.02-.03.07-.1q.09-.1.26-.21.35-.26 1.1-.28c.87 0 1.47.56 1.5 1.22q.01.46-.35.84c.24.23.36.54.34.84-.02.66-.62 1.22-1.5 1.22q-.74-.02-1.1-.28a1 1 0 0 1-.34-.34v-.01h-.01a.4.4 0 0 1 .2-.56c.2-.1.44-.03.55.16l.08.07c.09.05.27.14.62.14.49 0 .64-.27.65-.43a.3.3 0 0 0-.11-.25c-.08-.07-.25-.15-.54-.15a.4.4 0 0 1-.43-.4M2.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$3ade60ac9fa9ca77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl16Regular', "16", [
    "M12.68 1.01c.2.04.33.21.33.4v3.3c0 .22-.19.4-.42.4a.4.4 0 0 1-.43-.4V2.58q-.28.24-.67.44a.44.44 0 0 1-.57-.19.4.4 0 0 1 .2-.55 2.5 2.5 0 0 0 1.08-1.05c.1-.17.29-.26.48-.22m-1.53 6.05a.4.4 0 0 1 0-.59h.01l.11-.1.28-.17c.24-.13.6-.26 1.03-.26h.01c.32 0 .67.09.95.29q.46.31.48.95c0 .45-.2.76-.48.99-.22.17-.5.3-.72.4l-.1.06q-.4.17-.61.39a1 1 0 0 0-.15.22h1.64c.23 0 .42.18.42.4s-.19.42-.42.42h-2.14a.4.4 0 0 1-.43-.41q.02-.76.44-1.19c.26-.27.6-.44.87-.57l.12-.06q.34-.15.53-.3.18-.13.18-.35-.01-.21-.14-.3a1 1 0 0 0-.45-.12 1.3 1.3 0 0 0-.82.3.44.44 0 0 1-.6 0m.94 5.88c0-.23.2-.41.43-.41.3 0 .46-.08.54-.15a.3.3 0 0 0 .1-.25c0-.16-.15-.42-.64-.42-.35 0-.53.08-.62.13l-.07.07v-.02.02a.44.44 0 0 1-.57.16.4.4 0 0 1-.2-.55h.01l.01-.02.02-.03.07-.1q.09-.1.26-.21.35-.26 1.1-.28c.87 0 1.47.56 1.5 1.22q.01.46-.35.84c.24.23.36.54.34.84-.02.66-.62 1.22-1.5 1.22q-.74-.02-1.1-.28a1 1 0 0 1-.34-.34v-.01h-.01a.4.4 0 0 1 .2-.56c.2-.1.44-.03.55.16l.08.07c.09.05.27.14.62.14.49 0 .64-.27.65-.43a.3.3 0 0 0-.11-.25c-.08-.07-.25-.15-.54-.15a.4.4 0 0 1-.43-.4M2.5 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$8f50c9d6b96456db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl20Filled', "20", [
    "M17 1.5a.5.5 0 0 0-.39-.49.5.5 0 0 0-.56.27l-.07.12-.25.35c-.22.28-.54.6-.95.8a.5.5 0 1 0 .44.9q.45-.23.78-.53V5.5a.5.5 0 0 0 1 0zm-2.35 6.15a.5.5 0 0 0 .7.7l.05-.04.2-.12c.17-.1.41-.19.71-.19q.35 0 .53.15.16.1.16.35a.5.5 0 0 1-.21.44 3 3 0 0 1-.76.43c-.32.15-.7.36-1 .7q-.51.51-.53 1.43c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1h-1.91q.06-.16.17-.27a2.4 2.4 0 0 1 .83-.53c.27-.13.59-.29.84-.5.33-.27.57-.65.57-1.2 0-.5-.22-.9-.57-1.15a2 2 0 0 0-1.1-.35h-.01a2.5 2.5 0 0 0-1.66.63zm1.1 7.85c0-.28.22-.5.5-.5.34 0 .53-.1.63-.18q.14-.14.13-.3c-.01-.2-.19-.52-.76-.52-.41 0-.63.1-.72.17l-.1.07.02-.02v.01l-.01.01v.01a.5.5 0 0 1-.89-.47v-.01l.02-.02.02-.04.08-.1q.1-.13.3-.28c.28-.18.7-.33 1.28-.33 1.03 0 1.73.67 1.76 1.48.01.37-.12.74-.4 1.02.28.28.41.65.4 1.02-.03.8-.73 1.48-1.76 1.48-.59 0-1-.15-1.28-.33a1.4 1.4 0 0 1-.4-.42l-.01-.01v-.01a.5.5 0 0 1 .87-.48l.1.08c.1.07.3.17.72.17.57 0 .75-.33.76-.52q0-.16-.13-.3c-.1-.08-.29-.18-.63-.18a.5.5 0 0 1-.5-.5M3.75 4a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$e91a85481a30603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl20Regular', "20", [
    "M17 1.5a.5.5 0 0 0-.38-.49.5.5 0 0 0-.57.27l-.07.12-.25.35c-.22.28-.54.6-.95.8a.5.5 0 0 0 .44.9q.45-.23.78-.53V5.5a.5.5 0 1 0 1 0zm-2.35 6.15a.5.5 0 0 0 .7.7l.05-.04.2-.12c.17-.1.41-.19.71-.19q.35 0 .53.15.16.1.16.35a.5.5 0 0 1-.21.44q-.22.17-.62.35l-.14.08c-.32.15-.7.36-1 .7q-.51.51-.53 1.43c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1h-1.91q.06-.16.17-.27a2.4 2.4 0 0 1 .83-.53c.27-.13.59-.29.84-.5.33-.27.57-.65.57-1.2 0-.5-.22-.9-.57-1.15a2 2 0 0 0-1.1-.35h-.01a2.5 2.5 0 0 0-1.66.63zm1.1 7.85c0-.28.22-.5.5-.5.34 0 .53-.1.63-.18q.14-.14.13-.3c-.01-.2-.19-.52-.76-.52-.41 0-.63.1-.72.17l-.1.07.02-.02v.01l-.01.01v.01a.5.5 0 0 1-.89-.47v-.01h.01v-.02l.11-.15q.1-.12.3-.27c.28-.18.7-.33 1.28-.33 1.03 0 1.73.67 1.76 1.48.01.37-.12.74-.4 1.02.28.28.41.65.4 1.02-.03.8-.73 1.48-1.76 1.48-.59 0-1-.15-1.28-.33a1.4 1.4 0 0 1-.4-.42l-.01-.01v-.01a.5.5 0 0 1 .88-.48q.02.03.09.08c.1.07.3.17.72.17.57 0 .75-.33.76-.52q0-.16-.13-.3c-.1-.08-.29-.18-.63-.18a.5.5 0 0 1-.5-.5M3.5 4a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 5a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$2fd7193f0b059028 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl24Filled', "24", [
    "M20 2.75a.75.75 0 0 0-1.43-.3l-.07.13q-.08.15-.24.38c-.22.32-.52.66-.9.9a.75.75 0 0 0 .79 1.28l.35-.25v2.36a.75.75 0 0 0 1.5 0zM13 18H4.38a1 1 0 0 0 .12 2h8.62a1 1 0 0 0-.12-2m0-6.5H4.38a1 1 0 0 0 .12 2h8.62a1 1 0 0 0-.12-2M14 6a1 1 0 0 0-1-1H4.38a1 1 0 0 0 .12 2h8.62A1 1 0 0 0 14 6m5.15 4.52c-.3-.05-.68.07-.87.26a.75.75 0 0 1-1.06-1.06 2.6 2.6 0 0 1 2.2-.68c.39.07.8.26 1.1.6A2 2 0 0 1 21 11c0 .62-.27 1.08-.6 1.42-.28.28-.64.51-.91.69l-.08.05q-.3.2-.48.34h1.32a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75c0-1.31.98-1.95 1.58-2.34l.06-.04q.46-.28.68-.5.2-.2.18-.37-.02-.31-.1-.36a.4.4 0 0 0-.25-.12m-2.18 10.76s.1.08 0 0l.01.01.01.01.15.13q.15.11.4.24c.34.17.83.33 1.46.33q.98 0 1.6-.54c.4-.36.61-.86.6-1.36q-.04-.64-.43-1.1.4-.46.43-1.1c.01-.5-.2-1-.6-1.36S19.64 16 19 16a3.2 3.2 0 0 0-1.86.57l-.15.13-.01.01-.01.01a.75.75 0 1 0 1.07 1.05l.17-.1c.16-.08.42-.17.79-.17.36 0 .54.1.6.16q.11.1.1.2t-.13.22c-.09.08-.26.17-.57.17a.75.75 0 0 0 0 1.5c.31 0 .48.1.57.17q.13.12.13.23.01.1-.1.19c-.06.06-.24.16-.6.16a2 2 0 0 1-.96-.27l-.02-.02a.75.75 0 0 0-1.05 1.07m0-4.56s.2-.17 0 0"
]);
const $db6ad3fef28672ff$export$efe8a1499ce78cba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl24Regular', "24", [
    "M20 2.75a.75.75 0 0 0-1.43-.3l-.07.13q-.08.15-.24.38c-.22.32-.52.66-.9.9a.75.75 0 0 0 .79 1.28l.35-.25v2.36a.75.75 0 0 0 1.5 0zm-6 16a.75.75 0 0 0-.75-.75h-9a.75.75 0 0 0 0 1.5h9c.41 0 .75-.34.75-.75m0-6.5a.75.75 0 0 0-.75-.76h-9a.75.75 0 0 0 0 1.5h9c.41 0 .75-.33.75-.75m0-6.5a.75.75 0 0 0-.75-.75h-9a.75.75 0 1 0 0 1.5h9c.41 0 .75-.34.75-.75m5.15 4.77c-.3-.05-.68.07-.87.26a.75.75 0 0 1-1.06-1.06 2.6 2.6 0 0 1 2.2-.68c.39.07.8.26 1.1.6A2 2 0 0 1 21 11c0 .62-.27 1.08-.6 1.42-.28.28-.64.51-.91.69l-.08.05q-.3.2-.48.34h1.32a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75c0-1.31.98-1.95 1.58-2.34l.06-.04q.46-.28.68-.5.2-.2.18-.37-.02-.31-.1-.36a.4.4 0 0 0-.25-.12m-2.18 10.76s.1.08 0 0l.01.01.01.01.15.13q.15.11.4.24c.34.17.83.33 1.46.33q.98 0 1.6-.54c.4-.36.61-.86.6-1.36q-.04-.64-.43-1.1.4-.46.43-1.1c.01-.5-.2-1-.6-1.36S19.64 16 19 16a3.2 3.2 0 0 0-1.86.57l-.15.13-.01.01-.01.01a.75.75 0 1 0 1.07 1.05l.17-.1c.16-.08.42-.17.79-.17.36 0 .54.1.6.16q.11.1.1.2t-.13.22c-.09.08-.26.17-.57.17a.75.75 0 0 0 0 1.5c.31 0 .48.1.57.17q.13.12.13.23.01.1-.1.19c-.06.06-.24.16-.6.16a2 2 0 0 1-.96-.27l-.02-.02a.75.75 0 0 0-1.05 1.07m0-4.56s.2-.17 0 0"
]);
const $db6ad3fef28672ff$export$4a69c2871fcd7ec7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl28Filled', "28", [
    "M22.75 19c1.2 0 2.5.8 2.5 2.12a2 2 0 0 1-.59 1.38c.36.35.59.81.59 1.37 0 1.34-1.3 2.13-2.5 2.13a3.8 3.8 0 0 1-2.36-.81l-.2-.2A.75.75 0 0 1 21.3 24c.05.05.52.5 1.44.5.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62h-.25a.75.75 0 0 1 0-1.5h.25c.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62-.92 0-1.39.44-1.44.5a.75.75 0 0 1-1.12-1q.09-.1.2-.19.16-.16.49-.34a4 4 0 0 1 1.87-.47M16 21a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2zm6.75-10.5c1.27 0 2.5.9 2.5 2.25 0 .75-.37 1.28-.8 1.67-.4.35-.93.63-1.34.85q-.73.39-1.06.73h2.45a.75.75 0 0 1 0 1.5H21a.75.75 0 0 1-.75-.75c0-1.61 1.3-2.34 2.13-2.79.48-.26.83-.45 1.08-.67.22-.2.29-.35.29-.54 0-.31-.34-.75-1-.75-.44 0-.86.17-1.17.48a.75.75 0 1 1-1.16-.96l.18-.19q.16-.16.45-.34c.39-.24.96-.5 1.7-.5M16 13a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2zm7.17-10.98c.34.08.58.38.58.73v5.5a.75.75 0 0 1-1.5 0V4.98q-.38.37-.86.66a.75.75 0 0 1-.78-1.28c.5-.3.94-.78 1.25-1.21q.27-.35.47-.74c.15-.3.5-.47.84-.39M16 5a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2z"
]);
const $db6ad3fef28672ff$export$a3ef007dbc4b6857 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl28Regular', "28", [
    "M22.75 19c1.2 0 2.5.8 2.5 2.12a2 2 0 0 1-.59 1.38c.36.35.59.81.59 1.37 0 1.34-1.3 2.13-2.5 2.13a3.8 3.8 0 0 1-2.36-.81l-.2-.2A.75.75 0 0 1 21.3 24c.05.05.52.5 1.44.5.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62h-.25a.75.75 0 0 1 0-1.5h.25c.73 0 1-.44 1-.63 0-.18-.27-.62-1-.62-.92 0-1.39.44-1.44.5a.75.75 0 0 1-1.12-1q.09-.1.2-.19.16-.16.49-.34a4 4 0 0 1 1.87-.47m-6.5 2a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5zm6.5-10.5c1.27 0 2.5.9 2.5 2.25 0 .75-.37 1.28-.8 1.67-.4.35-.93.63-1.34.85q-.73.39-1.06.73h2.45a.75.75 0 0 1 0 1.5H21a.75.75 0 0 1-.75-.75c0-1.61 1.3-2.34 2.13-2.79.48-.26.83-.45 1.08-.67.22-.2.29-.35.29-.54 0-.31-.34-.75-1-.75-.44 0-.86.17-1.17.48a.75.75 0 1 1-1.16-.96l.18-.19q.16-.16.45-.34c.39-.24.96-.5 1.7-.5m-6.5 2.5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5zm6.92-10.98c.34.08.58.38.58.73v5.5a.75.75 0 0 1-1.5 0V4.98q-.38.37-.86.66a.75.75 0 0 1-.78-1.28c.5-.3.94-.78 1.25-1.21q.27-.35.47-.74c.15-.3.5-.47.84-.39M16.25 5a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$758c89ee50957560 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl9020Filled', "20", [
    "M4.25 2c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75M3.5 14.74c.28 0 .5.23.5.5 0 .35.1.54.18.63q.14.14.3.13c.2 0 .52-.19.52-.76 0-.4-.1-.62-.17-.72l-.07-.09.02.01h-.02v-.01h-.01a.5.5 0 0 1 .47-.88h.01l.02.01.15.1q.12.1.27.3c.18.29.33.7.33 1.28 0 1.03-.67 1.73-1.48 1.76-.37.01-.74-.12-1.02-.4-.28.28-.65.41-1.02.4-.8-.03-1.48-.73-1.48-1.76 0-.58.15-1 .33-1.27a1.4 1.4 0 0 1 .42-.4l.01-.02h.01a.5.5 0 0 1 .48.88l-.08.1c-.07.09-.17.3-.17.71 0 .57.33.75.52.76q.16.01.3-.13c.08-.1.18-.28.18-.63 0-.27.22-.5.5-.5m7.15-1.1c.2-.2.5-.2.7 0h.01v.02l.11.12A2.4 2.4 0 0 1 12 15.3v.01c0 .37-.1.78-.35 1.1a1.4 1.4 0 0 1-1.15.57 1.5 1.5 0 0 1-1.2-.57 4 4 0 0 1-.5-.83l-.06-.12q-.23-.47-.47-.72a1 1 0 0 0-.27-.17v1.91a.5.5 0 1 1-1 0V14c0-.27.22-.5.5-.5q.92.02 1.44.53a3 3 0 0 1 .77 1.15q.18.4.35.61a.5.5 0 0 0 .44.21q.26 0 .35-.16.14-.18.15-.52a1.5 1.5 0 0 0-.35-.96.5.5 0 0 1 0-.7m7.34 1.97a.5.5 0 0 1-.49.38h-4a.5.5 0 1 1 0-1h2.58q-.3-.32-.53-.77a.5.5 0 1 1 .9-.45 3 3 0 0 0 1.15 1.2l.12.08c.2.1.32.33.27.56"
]);
const $db6ad3fef28672ff$export$3c6b3192cfceb187 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl9020Regular', "20", [
    "M4.5 2c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0v-8c0-.28.22-.5.5-.5m-11 12.74c.28 0 .5.23.5.5 0 .35.1.54.18.63q.14.14.3.13c.2 0 .52-.19.52-.76 0-.4-.1-.62-.17-.72l-.07-.09.02.01h-.02v-.01h-.01a.5.5 0 0 1 .47-.88h.01l.02.01.15.1q.12.1.27.3c.18.29.33.7.33 1.28 0 1.03-.67 1.73-1.48 1.76-.37.01-.74-.12-1.02-.4-.28.28-.65.41-1.02.4-.8-.03-1.48-.73-1.48-1.76 0-.58.15-1 .33-1.27a1.4 1.4 0 0 1 .42-.4l.01-.02h.01a.5.5 0 0 1 .48.88l-.08.1c-.07.09-.17.3-.17.71 0 .57.33.75.52.76q.16.01.3-.13c.08-.1.18-.28.18-.63 0-.27.22-.5.5-.5m7.15-1.1c.2-.2.5-.2.7 0h.01v.02l.11.12A2.4 2.4 0 0 1 12 15.3v.01c0 .37-.1.78-.35 1.1a1.4 1.4 0 0 1-1.15.57 1.5 1.5 0 0 1-1.2-.57 4 4 0 0 1-.5-.83l-.06-.12q-.23-.47-.47-.72a1 1 0 0 0-.27-.17v1.91a.5.5 0 1 1-1 0V14c0-.27.22-.5.5-.5q.92.02 1.44.53a3 3 0 0 1 .77 1.15q.18.4.35.61a.5.5 0 0 0 .44.21q.26 0 .35-.16.14-.18.15-.52a1.5 1.5 0 0 0-.35-.96.5.5 0 0 1 0-.7m7.34 1.97a.5.5 0 0 1-.49.38h-4a.5.5 0 1 1 0-1h2.58q-.3-.32-.53-.77a.5.5 0 1 1 .9-.45 3 3 0 0 0 1.15 1.2l.12.08c.2.1.32.33.27.56"
]);
const $db6ad3fef28672ff$export$b4f0508fb804e742 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl9024Filled', "24", [
    "M21.25 20a.75.75 0 0 0 .3-1.43l-.13-.07q-.15-.08-.38-.24a3 3 0 0 1-.9-.9.75.75 0 1 0-1.28.79l.25.35h-2.36a.75.75 0 0 0 0 1.5zM6 13V4.38a1 1 0 0 0-2 .12v8.62A1 1 0 0 0 6 13m6.5 0V4.38a1 1 0 0 0-2 .12v8.62a1 1 0 0 0 2-.12m5.5 1a1 1 0 0 0 1-1V4.38a1 1 0 0 0-2 .12v8.62a1 1 0 0 0 1 .88m-4.52 5.15c.05-.3-.07-.68-.26-.87a.75.75 0 0 1 1.06-1.06c.56.56.81 1.43.68 2.2-.07.39-.26.8-.6 1.1A2 2 0 0 1 13 21c-.62 0-1.08-.27-1.42-.6a5 5 0 0 1-.69-.91l-.05-.08q-.2-.3-.34-.48v1.32a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75 1.31 0 1.95.98 2.34 1.58l.04.06q.28.46.5.68.2.2.37.18.31-.02.36-.1.08-.06.12-.25M2.72 16.97s-.08.1 0 0l-.01.01-.01.01-.13.15q-.11.15-.24.4c-.17.34-.33.83-.33 1.46q0 .98.54 1.6c.36.4.86.61 1.36.6q.64-.04 1.1-.43.46.4 1.1.43c.5.01 1-.2 1.36-.6S8 19.64 8 19a3.2 3.2 0 0 0-.57-1.86L7.3 17l-.01-.01-.01-.01a.75.75 0 1 0-1.05 1.07l.1.17c.08.16.17.42.17.79 0 .36-.1.54-.16.6a.2.2 0 0 1-.2.1.3.3 0 0 1-.22-.13c-.08-.09-.17-.26-.17-.57a.75.75 0 0 0-1.5 0c0 .31-.1.48-.17.57a.3.3 0 0 1-.23.13.2.2 0 0 1-.19-.1c-.06-.06-.16-.24-.16-.6a2 2 0 0 1 .27-.96l.02-.02a.75.75 0 0 0-1.07-1.05m4.56 0s.17.2 0 0"
]);
const $db6ad3fef28672ff$export$36c11b175f1ac425 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtl9024Regular', "24", [
    "M21.25 20a.75.75 0 0 0 .3-1.43l-.13-.07q-.15-.08-.38-.24a3 3 0 0 1-.9-.9.75.75 0 1 0-1.28.79l.25.35h-2.36a.75.75 0 0 0 0 1.5zm-16-6c.41 0 .75-.34.75-.75v-9a.75.75 0 1 0-1.5 0v9c0 .41.34.75.75.75m6.5 0c.42 0 .76-.34.76-.75v-9a.75.75 0 0 0-1.5 0v9c0 .41.33.75.75.75m6.5 0c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-1.5 0v9c0 .41.34.75.75.75m-4.77 5.15c.05-.3-.07-.68-.26-.87a.75.75 0 0 1 1.06-1.06c.56.56.81 1.43.68 2.2-.07.39-.26.8-.6 1.1A2 2 0 0 1 13 21c-.62 0-1.08-.27-1.42-.6a5 5 0 0 1-.69-.91l-.05-.08q-.2-.3-.34-.48v1.32a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75 1.31 0 1.95.98 2.34 1.58l.04.06q.28.46.5.68.2.2.37.18.31-.02.36-.1.08-.06.12-.25M2.72 16.97s-.08.1 0 0l-.01.01-.01.01-.13.15q-.11.15-.24.4c-.17.34-.33.83-.33 1.46q0 .98.54 1.6c.36.4.86.61 1.36.6q.64-.04 1.1-.43.46.4 1.1.43c.5.01 1-.2 1.36-.6S8 19.64 8 19a3.2 3.2 0 0 0-.57-1.86L7.3 17l-.01-.01-.01-.01a.75.75 0 1 0-1.05 1.07l.1.17c.08.16.17.42.17.79 0 .36-.1.54-.16.6a.2.2 0 0 1-.2.1.3.3 0 0 1-.22-.13c-.08-.09-.17-.26-.17-.57a.75.75 0 0 0-1.5 0c0 .31-.1.48-.17.57a.3.3 0 0 1-.23.13.2.2 0 0 1-.19-.1c-.06-.06-.16-.24-.16-.6a2 2 0 0 1 .27-.96l.02-.02a.75.75 0 0 0-1.07-1.05m4.56 0s.17.2 0 0"
]);
const $db6ad3fef28672ff$export$13eb33cccc6ad0dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate27020Filled', "20", [
    "M1.01 4.4A.5.5 0 0 1 1.5 4h4a.5.5 0 1 1 0 1H2.92q.3.33.53.78a.5.5 0 1 1-.9.45 3 3 0 0 0-1.15-1.2l-.12-.08A.5.5 0 0 1 1 4.4m7.34 1.96a.5.5 0 0 1-.7 0h-.01v-.02l-.11-.12-.22-.33A2.5 2.5 0 0 1 7 4.7c0-.38.1-.79.35-1.12a1.4 1.4 0 0 1 1.15-.56c.55 0 .93.24 1.2.57a4 4 0 0 1 .56.95q.23.46.47.72.11.1.27.17V3.5a.5.5 0 1 1 1 0V6a.5.5 0 0 1-.5.5q-.92-.02-1.44-.53a3 3 0 0 1-.77-1.14q-.18-.4-.35-.62A.5.5 0 0 0 8.5 4q-.26 0-.35.16a1 1 0 0 0-.15.52 1.5 1.5 0 0 0 .35.96c.2.2.2.51 0 .7M15 4.76a.5.5 0 0 0 1 0c0-.35.1-.54.18-.63q.14-.14.3-.13c.2 0 .52.19.52.76 0 .4-.1.62-.17.72l-.07.09a.5.5 0 0 0 .46.88h.01l.02-.01.15-.1q.12-.1.27-.3c.18-.29.33-.7.33-1.28 0-1.03-.67-1.73-1.48-1.76-.37-.01-.74.12-1.02.4a1.4 1.4 0 0 0-1.02-.4c-.8.03-1.48.73-1.48 1.76 0 .58.15 1 .33 1.27a1.4 1.4 0 0 0 .42.4l.01.02h.01a.5.5 0 0 0 .48-.88l-.08-.1c-.07-.09-.17-.3-.17-.71 0-.57.33-.75.52-.76q.16-.01.3.13c.08.1.18.28.18.63m-.75.81h-.02v-.01zM9.75 18a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m-5 0a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m9.25-.75a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-1.5 0z"
]);
const $db6ad3fef28672ff$export$6f29bffc3da5841d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate27020Regular', "20", [
    "M1.01 4.4A.5.5 0 0 1 1.5 4h4a.5.5 0 1 1 0 1H2.92q.3.33.53.78a.5.5 0 1 1-.9.45 3 3 0 0 0-1.15-1.2l-.12-.08A.5.5 0 0 1 1 4.4m7.34 1.96a.5.5 0 0 1-.7 0h-.01v-.02l-.11-.12-.22-.33A2.5 2.5 0 0 1 7 4.7c0-.38.1-.79.35-1.12a1.4 1.4 0 0 1 1.15-.56c.55 0 .93.24 1.2.57a4 4 0 0 1 .56.95q.23.46.47.72.11.1.27.17V3.5a.5.5 0 1 1 1 0V6a.5.5 0 0 1-.5.5q-.92-.02-1.44-.53a3 3 0 0 1-.77-1.14q-.18-.4-.35-.62A.5.5 0 0 0 8.5 4q-.26 0-.35.16a1 1 0 0 0-.15.52 1.5 1.5 0 0 0 .35.96c.2.2.2.51 0 .7M15 4.76a.5.5 0 0 0 1 0c0-.35.1-.54.18-.63q.14-.14.3-.13c.2 0 .52.19.52.76 0 .4-.1.62-.17.72l-.07.09a.5.5 0 0 0 .46.88h.01l.02-.01.15-.1q.12-.1.27-.3c.18-.29.33-.7.33-1.28 0-1.03-.67-1.73-1.48-1.76-.37-.01-.74.12-1.02.4a1.4 1.4 0 0 0-1.02-.4c-.8.03-1.48.73-1.48 1.76 0 .58.15 1 .33 1.27a1.4 1.4 0 0 0 .42.4l.01.02h.01a.5.5 0 0 0 .48-.88l-.08-.1c-.07-.09-.17-.3-.17-.71 0-.57.33-.75.52-.76q.16-.01.3.13c.08.1.18.28.18.63m-.75.81h-.02v-.01zM9.5 18a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m-5 0a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v8a.5.5 0 0 1-.5.5m9.5-.5a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-1 0z"
]);
const $db6ad3fef28672ff$export$9e7a2d39fef9f80c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate27024Filled', "24", [
    "M2.75 4a.75.75 0 0 0-.3 1.43l.13.07q.15.07.38.24c.32.22.66.52.9.9a.75.75 0 1 0 1.28-.79l-.25-.35h2.36a.75.75 0 1 0 0-1.5zM18 11v8.62a1 1 0 0 0 2-.12v-8.62a1 1 0 0 0-2 .12m-6.5 0v8.62a1 1 0 0 0 2-.12v-8.62a1 1 0 0 0-2 .12M6 10a1 1 0 0 0-1 1v8.62a1 1 0 0 0 2-.12v-8.62A1 1 0 0 0 6 10m4.52-5.15c-.05.3.07.68.26.87a.75.75 0 0 1-1.06 1.06 2.6 2.6 0 0 1-.68-2.2c.07-.39.26-.8.6-1.1A2 2 0 0 1 11 3c.62 0 1.08.27 1.42.6.28.28.51.64.69.91l.05.08q.2.3.34.48V3.75a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75-1.31 0-1.95-.98-2.34-1.58l-.04-.06a4 4 0 0 0-.5-.68q-.2-.2-.37-.18c-.22 0-.32.06-.36.1a.4.4 0 0 0-.12.25m10.76 2.18s.08-.1 0 0l.01-.01.01-.01.13-.15q.11-.15.24-.4c.17-.34.33-.83.33-1.46 0-.64-.18-1.2-.54-1.6s-.86-.61-1.36-.6q-.64.03-1.1.43-.46-.4-1.1-.43c-.5-.01-1 .2-1.36.6S16 4.36 16 5a3.2 3.2 0 0 0 .57 1.86l.13.15.01.01.01.01a.75.75 0 1 0 1.05-1.07l-.1-.17A2 2 0 0 1 17.5 5c0-.36.1-.54.16-.6a.2.2 0 0 1 .2-.1q.1 0 .22.13c.08.09.17.26.17.57a.75.75 0 0 0 1.5 0c0-.31.1-.48.17-.57q.12-.13.23-.13.1-.01.19.1c.06.06.16.24.16.6a2 2 0 0 1-.27.96l-.02.02a.75.75 0 0 0 1.07 1.05m-4.56 0"
]);
const $db6ad3fef28672ff$export$9db22a0173f50a15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate27024Regular', "24", [
    "M2.75 4a.75.75 0 0 0-.3 1.43l.13.07q.15.07.38.24c.32.22.66.52.9.9a.75.75 0 1 0 1.28-.79l-.25-.35h2.36a.75.75 0 1 0 0-1.5zm16 6a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m-6.5 0a.75.75 0 0 0-.76.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m-6.5 0a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-.75-.75m4.77-5.15c-.05.3.07.68.26.87a.75.75 0 0 1-1.06 1.06 2.6 2.6 0 0 1-.68-2.2c.07-.39.26-.8.6-1.1A2 2 0 0 1 11 3c.62 0 1.08.27 1.42.6.28.28.51.64.69.91l.05.08q.2.3.34.48V3.75a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75-1.31 0-1.95-.98-2.34-1.58l-.04-.06a4 4 0 0 0-.5-.68q-.2-.2-.37-.18c-.22 0-.32.06-.36.1a.4.4 0 0 0-.12.25m10.76 2.18s.08-.1 0 0l.01-.01.01-.01.13-.15q.11-.15.24-.4c.17-.34.33-.83.33-1.46 0-.64-.18-1.2-.54-1.6s-.86-.61-1.36-.6q-.64.03-1.1.43-.46-.4-1.1-.43c-.5-.01-1 .2-1.36.6S16 4.36 16 5a3.2 3.2 0 0 0 .57 1.86l.13.15.01.01.01.01a.75.75 0 1 0 1.05-1.07l-.1-.17A2 2 0 0 1 17.5 5c0-.36.1-.54.16-.6a.2.2 0 0 1 .2-.1q.1 0 .22.13c.08.09.17.26.17.57a.75.75 0 0 0 1.5 0c0-.31.1-.48.17-.57q.12-.13.23-.13.1-.01.19.1c.06.06.16.24.16.6a2 2 0 0 1-.27.96l-.02.02a.75.75 0 0 0 1.07 1.05m-4.56 0"
]);
const $db6ad3fef28672ff$export$7b5cefd82da58a11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate27028Filled', "28", [
    "M6 11a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V12a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V12a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 0 1-2 0V12a1 1 0 0 1 1-1m1.87-8.25c1.34 0 2.13 1.3 2.13 2.5a3.8 3.8 0 0 1-.81 2.36q-.09.1-.2.2A.75.75 0 0 1 24 6.7c.05-.05.5-.51.5-1.44 0-.73-.44-1-.63-1-.18 0-.62.27-.62 1v.25a.75.75 0 1 1-1.5 0v-.25c0-.73-.44-1-.63-1-.18 0-.62.27-.62 1 0 .92.44 1.38.5 1.44a.75.75 0 0 1-1 1.12q-.1-.08-.19-.2-.16-.16-.34-.49A4 4 0 0 1 19 5.25c0-1.2.8-2.5 2.12-2.5.56 0 1.03.23 1.38.59a2 2 0 0 1 1.37-.59m-7.12 0c.41 0 .75.34.75.75V7c0 .41-.34.75-.75.75-1.61 0-2.34-1.3-2.79-2.13-.26-.48-.45-.83-.67-1.08-.2-.22-.35-.29-.54-.29-.31 0-.75.34-.75 1 0 .44.17.86.48 1.17a.75.75 0 1 1-.96 1.16l-.19-.18a3 3 0 0 1-.83-2.15c0-1.27.9-2.5 2.25-2.5.75 0 1.28.37 1.67.8.35.4.63.93.85 1.34q.39.73.73 1.06V3.5c0-.41.34-.75.75-.75m-8.5 1.5a.75.75 0 0 1 0 1.5H4.98q.37.38.66.86a.75.75 0 0 1-1.28.78c-.3-.5-.78-.94-1.21-1.25a5 5 0 0 0-.74-.47.75.75 0 0 1 .34-1.42z"
]);
const $db6ad3fef28672ff$export$2e7f6f692862a131 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate27028Regular', "28", [
    "M5.75 11c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0v-11.5c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0v-11.5c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0v-11.5c0-.41.34-.75.75-.75m2.12-8.25c1.34 0 2.13 1.3 2.13 2.5a3.8 3.8 0 0 1-.81 2.36q-.09.1-.2.2A.75.75 0 0 1 24 6.7c.05-.05.5-.51.5-1.44 0-.73-.44-1-.63-1-.18 0-.62.27-.62 1v.25a.75.75 0 1 1-1.5 0v-.25c0-.73-.44-1-.63-1-.18 0-.62.27-.62 1 0 .92.44 1.38.5 1.44a.75.75 0 0 1-1 1.12q-.1-.08-.19-.2-.16-.16-.34-.49A4 4 0 0 1 19 5.25c0-1.2.8-2.5 2.12-2.5.56 0 1.03.23 1.38.59a2 2 0 0 1 1.37-.59m-7.12 0c.41 0 .75.34.75.75V7c0 .41-.34.75-.75.75-1.61 0-2.34-1.3-2.79-2.13-.26-.48-.45-.83-.67-1.08-.2-.22-.35-.29-.54-.29-.31 0-.75.34-.75 1 0 .44.17.86.48 1.17a.75.75 0 1 1-.96 1.16l-.19-.18a3 3 0 0 1-.83-2.15c0-1.27.9-2.5 2.25-2.5.75 0 1.28.37 1.67.8.35.4.63.93.85 1.34q.39.73.73 1.06V3.5c0-.41.34-.75.75-.75m-8.5 1.5a.75.75 0 0 1 0 1.5H4.98q.37.38.66.86a.75.75 0 0 1-1.28.78c-.3-.5-.78-.94-1.21-1.25a5 5 0 0 0-.74-.47.75.75 0 0 1 .34-1.42z"
]);
const $db6ad3fef28672ff$export$c6988b67e4d13305 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate9028Filled', "28", [
    "M6.94 20.26a.75.75 0 0 1 1.05-.07q.1.09.2.2.16.16.34.49c.24.43.47 1.05.47 1.87 0 1.2-.8 2.5-2.12 2.5a2 2 0 0 1-1.38-.59 2 2 0 0 1-1.37.59c-1.34 0-2.13-1.3-2.13-2.5a3.8 3.8 0 0 1 .81-2.36q.08-.1.2-.2A.75.75 0 0 1 4 21.3c-.05.05-.5.52-.5 1.44 0 .73.44 1 .63 1 .18 0 .62-.27.62-1v-.25a.75.75 0 0 1 1.5 0v.25c0 .73.44 1 .63 1 .18 0 .62-.27.62-1 0-.92-.44-1.39-.5-1.44a.75.75 0 0 1-.06-1.05m4.31-.01c1.61 0 2.33 1.3 2.79 2.13.26.48.45.83.67 1.08.2.22.35.29.54.29.31 0 .75-.34.75-1 0-.44-.17-.86-.48-1.17a.75.75 0 1 1 .96-1.16l.19.18q.16.16.34.45c.24.39.49.96.49 1.7 0 1.27-.9 2.5-2.25 2.5-.75 0-1.28-.37-1.67-.8-.35-.4-.63-.93-.85-1.34q-.4-.73-.73-1.06v2.45a.75.75 0 0 1-1.5 0V21c0-.41.34-.75.75-.75m11.36.1a.75.75 0 0 1 1.03.26c.3.5.78.94 1.21 1.25q.35.27.74.47a.75.75 0 0 1-.34 1.42h-5.5a.75.75 0 0 1 0-1.5h3.27a5 5 0 0 1-.66-.86.75.75 0 0 1 .25-1.03M6 4a1 1 0 0 1 1 1v11a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v11a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$c86c5979760f089 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextNumberListRtlRotate9028Regular', "28", [
    "M6.94 20.26a.75.75 0 0 1 1.05-.07q.1.09.2.2.16.16.34.49c.24.43.47 1.05.47 1.87 0 1.2-.8 2.5-2.12 2.5a2 2 0 0 1-1.38-.59 2 2 0 0 1-1.37.59c-1.34 0-2.13-1.3-2.13-2.5a3.8 3.8 0 0 1 .81-2.36q.08-.1.2-.2A.75.75 0 0 1 4 21.3c-.05.05-.5.52-.5 1.44 0 .73.44 1 .63 1 .18 0 .62-.27.62-1v-.25a.75.75 0 0 1 1.5 0v.25c0 .73.44 1 .63 1 .18 0 .62-.27.62-1 0-.92-.44-1.39-.5-1.44a.75.75 0 0 1-.06-1.05m4.31-.01c1.61 0 2.33 1.3 2.79 2.13.26.48.45.83.67 1.08.2.22.35.29.54.29.31 0 .75-.34.75-1 0-.44-.17-.86-.48-1.17a.75.75 0 1 1 .96-1.16l.19.18q.16.16.34.45c.24.39.49.96.49 1.7 0 1.27-.9 2.5-2.25 2.5-.75 0-1.28-.37-1.67-.8-.35-.4-.63-.93-.85-1.34q-.4-.73-.73-1.06v2.45a.75.75 0 0 1-1.5 0V21c0-.41.34-.75.75-.75m11.36.1a.75.75 0 0 1 1.03.26c.3.5.78.94 1.21 1.25q.35.27.74.47a.75.75 0 0 1-.34 1.42h-5.5a.75.75 0 0 1 0-1.5h3.27a5 5 0 0 1-.66-.86.75.75 0 0 1 .25-1.03M6.25 4c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75m8 0c.41 0 .75.34.75.75v11.5a.75.75 0 0 1-1.5 0V4.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$626e6008944ac16c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraph16Filled', "16", [
    "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m10 10a.5.5 0 0 1-1 0V11a3 3 0 1 1 0-6h3.5a.5.5 0 0 1 0 1H14v7.5a.5.5 0 0 1-1 0V6h-1zM2.5 6h5.04q-.27.47-.41 1H2.5a.5.5 0 0 1 0-1m5.04 4a4 4 0 0 1-.41-1H2.5a.5.5 0 0 0 0 1z"
]);
const $db6ad3fef28672ff$export$7e5d9b85575de823 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraph16Regular', "16", [
    "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm9 11a.5.5 0 0 0 .5-.5V6h1v7.5a.5.5 0 0 0 1 0V6h.5a.5.5 0 0 0 0-1H11a3 3 0 1 0 0 6v2.5c0 .28.22.5.5.5M10 6.27A2 2 0 0 1 11 6v4a2 2 0 0 1-2-2 2 2 0 0 1 1-1.73M7.54 6H2.5a.5.5 0 0 0 0 1h4.63q.14-.53.4-1m-.41 3q.14.53.4 1H2.5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$65e82f36bab86800 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraph20Filled', "20", [
    "M13.5 7a3.5 3.5 0 1 0 0 7h.5v3.5a.5.5 0 0 0 1 0V8h1v9.5a.5.5 0 0 0 1 0V8h.5a.5.5 0 0 0 0-1zm-11-2a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm6.76 4H2.5a.5.5 0 0 0 0 1h6.53q.05-.52.23-1m.5 4H2.5a.5.5 0 0 0 0 1h8.17a5 5 0 0 1-.91-1"
]);
const $db6ad3fef28672ff$export$e56267c85295dfd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraph20Regular', "20", [
    "M13.5 8a2.5 2.5 0 0 0 0 5h.5V8zm.5 6h-.5a3.5 3.5 0 1 1 0-7h4a.5.5 0 0 1 0 1H17v9.5a.5.5 0 0 1-1 0V8h-1v9.5a.5.5 0 0 1-1 0zM2.5 5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm6.76 4H2.5a.5.5 0 0 0 0 1h6.53q.05-.52.23-1m.5 4H2.5a.5.5 0 0 0 0 1h8.17a5 5 0 0 1-.91-1"
]);
const $db6ad3fef28672ff$export$7d4e6f872322e602 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraph24Filled', "24", [
    "M12.25 12.25C12.25 9.9 14.15 8 16.5 8h4.75a.75.75 0 0 1 0 1.5H21v11.75a.75.75 0 0 1-1.5 0V9.5h-1v11.75a.75.75 0 0 1-1.5 0V16.5h-.5a4.25 4.25 0 0 1-4.25-4.25M2 5.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 5c0-.41.34-.75.75-.75h9q-.33.7-.45 1.5H2.75a.75.75 0 0 1-.75-.75M2.75 15h9.28q.54.9 1.39 1.5H2.75a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$cc279c39321cc728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraph24Regular', "24", [
    "M16.5 8a4.25 4.25 0 0 0 0 8.5h.5v4.75a.75.75 0 0 0 1.5 0V9.5h1v11.75a.75.75 0 0 0 1.5 0V9.5h.25a.75.75 0 0 0 0-1.5zm0 1.5h.5V15h-.5a2.75 2.75 0 1 1 0-5.5M2.75 5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h8.55q.12-.8.46-1.5zm9.28 5H2.75a.75.75 0 0 0 0 1.5h10.67a5 5 0 0 1-1.4-1.5"
]);
const $db6ad3fef28672ff$export$92234be30161ee32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirection20Filled', "20", [
    "M11.5 3a4 4 0 1 0 0 8H13v6.5a.5.5 0 0 0 1 0V4h1v13.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1zM3.15 5.65c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L4.79 8 3.15 6.35a.5.5 0 0 1 0-.7m2.7 6a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L4.21 14l1.64-1.65a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$a3b2b979342b9cbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirection20Regular', "20", [
    "M11.5 3a4 4 0 1 0 0 8H13v6.5a.5.5 0 0 0 1 0V4h1v13.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1zM13 4v6h-1.5a3 3 0 0 1 0-6zM3.15 5.65c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L4.79 8 3.15 6.35a.5.5 0 0 1 0-.7m2.7 6a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L4.21 14l1.64-1.65a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$87bc5395877b9918 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirection24Filled', "24", [
    "M13.5 3a5.5 5.5 0 1 0 0 11H15v7.2c0 .45.34.8.75.8s.75-.35.75-.8V4.5H18v16.7c0 .45.34.8.75.8s.75-.35.75-.8V4.5h.67c.47-.06.83-.37.83-.75 0-.41-.43-.75-.95-.75zm-9.42 8.86a.67.67 0 0 1-.9-.99L4.9 9 3.18 7.13l-.06-.08a.67.67 0 0 1 1.03-.84L6.3 8.54l.06.08c.18.26.16.6-.06.84l-2.15 2.33zm1.32 8a.67.67 0 0 0 .9-.99L4.59 17l1.7-1.87.07-.08a.67.67 0 0 0-1.03-.84l-2.15 2.33-.06.08c-.18.26-.16.6.06.84l2.15 2.33z"
]);
const $db6ad3fef28672ff$export$d314f311f91f6a4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirection24Regular', "24", [
    "M13.5 3a5.5 5.5 0 1 0 0 11H15v7.2c0 .45.34.8.75.8s.75-.35.75-.8V4.5H18v16.7c0 .45.34.8.75.8s.75-.35.75-.8V4.5h.67c.47-.06.83-.37.83-.75 0-.41-.43-.75-.95-.75zm0 1.5H15v8h-1.5a4 4 0 0 1 0-8m-9.42 7.36a.67.67 0 0 1-.9-.99L4.9 9 3.18 7.13l-.06-.08a.67.67 0 0 1 1.03-.84L6.3 8.54l.06.08c.18.26.16.6-.06.84l-2.15 2.33zm1.32 8a.67.67 0 0 0 .9-.99L4.59 17l1.7-1.87.07-.08a.67.67 0 0 0-1.03-.84l-2.15 2.33-.06.08c-.18.26-.16.6.06.84l2.15 2.33z"
]);
const $db6ad3fef28672ff$export$1b24128b300a44de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionLeft16Filled', "16", [
    "M11 13.5V3h1v10.5a.5.5 0 0 0 1 0V3h.5a.5.5 0 0 0 0-1H9a3.5 3.5 0 1 0 0 7h1v4.5a.5.5 0 0 0 1 0M3.85 6.85a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7L2.71 8z"
]);
const $db6ad3fef28672ff$export$e977681cb3ba3a32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionLeft16Regular', "16", [
    "M9 3a2.5 2.5 0 0 0 0 5h1V3zm2 0v10.5a.5.5 0 0 1-1 0V9H9a3.5 3.5 0 1 1 0-7h4.5a.5.5 0 0 1 0 1H13v10.5a.5.5 0 0 1-1 0V3zM3.85 6.15c.2.2.2.5 0 .7L2.71 8l1.14 1.15a.5.5 0 1 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5c.2-.2.5-.2.7 0"
]);
const $db6ad3fef28672ff$export$ec639e8b406806dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionLeft20Filled', "20", [
    "M11.5 3a4 4 0 1 0 0 8H13v6.5a.5.5 0 0 0 1 0V4h1v13.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1zM5.15 7.65a.5.5 0 1 1 .7.7L4.21 10l1.64 1.65a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7z"
]);
const $db6ad3fef28672ff$export$8d5182180876de5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionLeft20Regular', "20", [
    "M11.5 3a4 4 0 1 0 0 8H13v6.5a.5.5 0 0 0 1 0V4h1v13.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1zM13 4v6h-1.5a3 3 0 0 1 0-6zM5.85 7.65a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L4.21 10l1.64-1.65a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$9574867411c19f56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionLeft24Filled', "24", [
    "M8 8.5A5.5 5.5 0 0 1 13.5 3h6.55c.52 0 .95.34.95.75 0 .38-.36.7-.83.74l-.12.01h-.55v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V4.5h-1.5v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V14h-1.5A5.5 5.5 0 0 1 8 8.5m-2.6 6.36a.67.67 0 0 0 .9-.99L4.59 12l1.7-1.87.07-.08a.67.67 0 0 0-1.03-.84l-2.15 2.33-.06.08c-.18.26-.16.6.06.84l2.15 2.33z"
]);
const $db6ad3fef28672ff$export$1367f73530bff42e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionLeft24Regular', "24", [
    "M8 8.5A5.5 5.5 0 0 1 13.5 3h6.55c.52 0 .95.34.95.75 0 .38-.36.7-.83.74l-.12.01h-.55v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V4.5h-1.5v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V14h-1.5A5.5 5.5 0 0 1 8 8.5m7-4h-1.5a4 4 0 0 0 0 8H15zM5.4 14.86a.67.67 0 0 0 .9-.99L4.59 12l1.7-1.87.07-.08a.67.67 0 0 0-1.03-.84l-2.15 2.33-.06.08c-.18.26-.16.6.06.84l2.15 2.33z"
]);
const $db6ad3fef28672ff$export$61f0c6cfa33030f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionRight16Filled', "16", [
    "M11 13.5V3h1v10.5a.5.5 0 0 0 1 0V3h.5a.5.5 0 0 0 0-1H9a3.5 3.5 0 1 0 0 7h1v4.5a.5.5 0 0 0 1 0M2.85 6.15a.5.5 0 1 0-.7.7L3.29 8 2.15 9.15a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7z"
]);
const $db6ad3fef28672ff$export$381bfbceff14b014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionRight16Regular', "16", [
    "M9 3a2.5 2.5 0 0 0 0 5h1V3zm2 0v10.5a.5.5 0 0 1-1 0V9H9a3.5 3.5 0 1 1 0-7h4.5a.5.5 0 0 1 0 1H13v10.5a.5.5 0 0 1-1 0V3zM2.15 6.15c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7L3.29 8 2.15 6.85a.5.5 0 0 1 0-.7"
]);
const $db6ad3fef28672ff$export$1fa7619a21c55bd8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionRight20Filled', "20", [
    "M11.5 3a4 4 0 1 0 0 8H13v6.5a.5.5 0 0 0 1 0V4h1v13.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1zM3.85 7.65a.5.5 0 1 0-.7.7L4.79 10l-1.64 1.65a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7z"
]);
const $db6ad3fef28672ff$export$1fb61666b7d79735 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionRight20Regular', "20", [
    "M11.5 3a4 4 0 1 0 0 8H13v6.5a.5.5 0 0 0 1 0V4h1v13.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1zM13 4v6h-1.5a3 3 0 0 1 0-6zM3.15 7.65c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L4.79 10 3.15 8.35a.5.5 0 0 1 0-.7"
]);
const $db6ad3fef28672ff$export$5e162cca7adcc508 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionRight24Filled', "24", [
    "M8 8.5A5.5 5.5 0 0 1 13.5 3h6.55c.52 0 .95.34.95.75 0 .38-.36.7-.83.74l-.12.01h-.55v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V4.5h-1.5v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V14h-1.5A5.5 5.5 0 0 1 8 8.5m-3.92 6.36a.67.67 0 0 1-.9-.99L4.9 12l-1.72-1.87-.06-.08a.67.67 0 0 1 1.03-.84l2.15 2.33.06.08c.18.26.16.6-.06.84l-2.15 2.33z"
]);
const $db6ad3fef28672ff$export$a531290f942b01b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextParagraphDirectionRight24Regular', "24", [
    "M8 8.5A5.5 5.5 0 0 1 13.5 3h6.55c.52 0 .95.34.95.75 0 .38-.36.7-.83.74l-.12.01h-.55v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V4.5h-1.5v16.7c0 .45-.34.8-.75.8a.77.77 0 0 1-.75-.8V14h-1.5A5.5 5.5 0 0 1 8 8.5m7-4h-1.5a4 4 0 0 0 0 8H15zM4.08 14.86a.67.67 0 0 1-.9-.99L4.9 12l-1.72-1.87-.06-.08a.67.67 0 0 1 1.03-.84l2.15 2.33.06.08c.18.26.16.6-.06.84l-2.15 2.33z"
]);
const $db6ad3fef28672ff$export$9f8550a62770716 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent16Filled', "16", [
    "M11.96 2.12c.35.23.44.7.2 1.04l-7.08 10.5a.75.75 0 0 1-1.24-.83l7.08-10.5a.75.75 0 0 1 1.04-.2M4.5 3.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M1.75 4.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0m8.5 6.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M11.5 8.5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5"
]);
const $db6ad3fef28672ff$export$caf2b43b78b94ebd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent16Regular', "16", [
    "M11.99 2.09a.5.5 0 0 1 .13.69l-7.41 11a.5.5 0 0 1-.83-.56l7.41-11a.5.5 0 0 1 .7-.13M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m8 7a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M11.5 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $db6ad3fef28672ff$export$209fb1250601f39c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent20Filled', "20", [
    "M14.64 3.13c.34.23.43.7.2 1.04L6.4 16.67a.75.75 0 1 1-1.25-.84l8.44-12.5a.75.75 0 0 1 1.04-.2M5.75 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M2.5 6.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m10 7.5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m1.75-3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5"
]);
const $db6ad3fef28672ff$export$4c750cfe9e6d1dd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent20Regular', "20", [
    "M14.66 3.09a.5.5 0 0 1 .14.69l-8.77 13a.5.5 0 1 1-.83-.56l8.77-13a.5.5 0 0 1 .7-.13M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4M3 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m9 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $db6ad3fef28672ff$export$2fbb1ac4b26d4bc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent24Filled', "24", [
    "M17.96 3.17a1 1 0 0 1 .27 1.39l-10.8 16a1 1 0 1 1-1.65-1.12l10.79-16a1 1 0 0 1 1.39-.27M6.5 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
]);
const $db6ad3fef28672ff$export$f04844dac366485b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent24Regular', "24", [
    "M17.98 3.13c.35.23.44.7.2 1.04L7.07 20.67a.75.75 0 1 1-1.25-.84l11.13-16.5a.75.75 0 0 1 1.04-.2M6.5 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.5 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0M15 17a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
]);
const $db6ad3fef28672ff$export$e0a14c5398cfd6c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent28Filled', "28", [
    "M21.3 3.17a1 1 0 0 1 .28 1.39l-13.5 20a1 1 0 1 1-1.65-1.12l13.49-20a1 1 0 0 1 1.39-.27M7.5 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0m15 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
]);
const $db6ad3fef28672ff$export$799c5fa81725175b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent28Regular', "28", [
    "M21.33 3.13c.35.23.44.7.2 1.04L7.72 24.67a.75.75 0 0 1-1.24-.84l13.82-20.5a.75.75 0 0 1 1.04-.2M7.5 4.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2.5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0M17 20a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
]);
const $db6ad3fef28672ff$export$7403e976a6ae6f78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent32Filled', "32", [
    "M24.63 3.21c.57.39.72 1.16.33 1.74L9.11 28.45a1.25 1.25 0 1 1-2.07-1.4l15.85-23.5a1.25 1.25 0 0 1 1.74-.34M8.5 5.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2.5 9a6 6 0 1 1 12 0 6 6 0 0 1-12 0M20 23a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
]);
const $db6ad3fef28672ff$export$141b0c17ac5f7193 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent32Regular', "32", [
    "M24.65 3.17a1 1 0 0 1 .27 1.39l-16.19 24a1 1 0 1 1-1.65-1.12l16.18-24a1 1 0 0 1 1.4-.27M9 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 9a6 6 0 1 1 12 0A6 6 0 0 1 3 9m16 14a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
]);
const $db6ad3fef28672ff$export$2ace96b7a2c680a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent48Filled', "48", [
    "M35.97 6.26c.68.46.87 1.4.4 2.08l-22.26 33a1.5 1.5 0 0 1-2.48-1.68l22.26-33a1.5 1.5 0 0 1 2.08-.4M13.5 9a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M5 14.5a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0m24 19a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m5.5-8.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
]);
const $db6ad3fef28672ff$export$d5e6384c27c1a6c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPercent48Regular', "48", [
    "M36 6.21c.57.39.72 1.17.34 1.74l-22.6 33.5a1.25 1.25 0 1 1-2.07-1.4l22.6-33.5A1.25 1.25 0 0 1 36 6.21M13.5 8.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8.5 6a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0m23.5 19a6 6 0 1 1 12 0 6 6 0 0 1-12 0m6-8.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
]);
const $db6ad3fef28672ff$export$b53f1fe52729043c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPeriodAsterisk20Filled', "20", [
    "M12.25 4.75a.75.75 0 0 0-1.5 0v1.86l-1.77-.58a.75.75 0 1 0-.46 1.43l1.77.58-1.1 1.5a.75.75 0 0 0 1.22.88l1.09-1.5 1.09 1.5a.75.75 0 1 0 1.21-.88l-1.09-1.5 1.77-.58a.75.75 0 1 0-.46-1.43l-1.77.58zM6.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$75220b6376d3576b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPeriodAsterisk20Regular', "20", [
    "M12 4.5a.5.5 0 0 0-1 0v2.46L8.65 6.2a.5.5 0 0 0-.3.95l2.34.76-1.45 2a.5.5 0 1 0 .8.59l1.46-2 1.45 2a.5.5 0 0 0 .8-.59l-1.44-2 2.34-.76a.5.5 0 0 0-.3-.95L12 6.96zM6 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $db6ad3fef28672ff$export$8e98db41b361cce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionBehind20Filled', "20", [
    "M2.75 3.5c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m5 5a2.25 2.25 0 0 1 4.5 0v5a.75.75 0 0 0 1.5 0v-5a3.75 3.75 0 1 0-7.5 0v5a.75.75 0 0 0 1.5 0zm8.75 1.75h-1.75v-1.5h1.75a.75.75 0 0 1 0 1.5m-13-1.5h1.75v1.5H3.5a.75.75 0 0 1 0-1.5m0 6a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm5.25-6h2.5v1.5h-2.5z"
]);
const $db6ad3fef28672ff$export$595243e21a4311f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionBehind20Regular', "20", [
    "M3.5 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm13 7h-2V9h2a.5.5 0 0 1 0 1m-13-1h2v1h-2a.5.5 0 0 1 0-1m5 0h3v1h-3zM3 15.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m4.5-7a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$5d3ddf02ed6af65a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionBehind24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm7 7.25q0-.13.03-.25h2.45l.02.25v1.75h-2.5zm3.49-.25.01.25v4.75a1 1 0 1 0 2 0v-5a4.25 4.25 0 0 0-8.5.25v4.75a1 1 0 1 0 2 0V11l.01-.25a2.25 2.25 0 0 1 4.48 0m6.01 2h-3v-2h3a1 1 0 1 1 0 2M6.75 11v-.25h-3a1 1 0 1 0 0 2h3zm-4 7.75a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$dc2a8901ba87943d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionBehind24Regular', "24", [
    "M3 4.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 4.75M9.5 11a2.5 2.5 0 0 1 5 0v4.75a.75.75 0 0 0 1.5 0V11a4 4 0 0 0-8 0v4.75a.75.75 0 0 0 1.5 0zm10.75 1.5H17V11h3.25a.75.75 0 0 1 0 1.5m-16.5 0H7V11H3.75a.75.75 0 0 0 0 1.5m0 5.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm6.75-7h3v1.5h-3z"
]);
const $db6ad3fef28672ff$export$b198d0e08070c248 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionFront20Filled', "20", [
    "M2.75 3.5c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75M10 6.25c-.98 0-1.81.63-2.12 1.5H6.33a3.75 3.75 0 0 1 7.35 0h-1.56A2.25 2.25 0 0 0 10 6.25m-3.75 5h1.5v2.25a.75.75 0 0 1-1.5 0zm7.5 0h-1.5v2.25a.75.75 0 0 0 1.5 0zM3.5 14.75a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm0-6a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$458011647cdb178 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionFront20Regular', "20", [
    "M3.5 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm3 8h1v2.5a.5.5 0 0 1-1 0zm7 0h-1v2.5a.5.5 0 0 0 1 0zm3-2a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1zM10 5a3.5 3.5 0 0 1 3.46 3h-1.01a2.5 2.5 0 0 0-4.9 0H6.54c.24-1.7 1.7-3 3.46-3M3.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$8b86a1979547e470 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionFront24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm8.25 5c-.78 0-1.47.4-1.87 1h-2.2a4.25 4.25 0 0 1 8.13 0h-2.19c-.4-.6-1.09-1-1.87-1m-8.25 2a1 1 0 1 0 0 2h16.5a1 1 0 1 0 0-2zm4 3h2v2a1 1 0 1 1-2 0zm8.5 0h-2v2a1 1 0 1 0 2 0zm-13.5 5a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$896648da2ab09dfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionFront24Regular', "24", [
    "M3.75 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM12 8.5A2.5 2.5 0 0 0 9.7 10H8.14a4 4 0 0 1 7.74 0H14.3A2.5 2.5 0 0 0 12 8.5m-4 5h1.5v2.25a.75.75 0 0 1-1.5 0zm8 0h-1.5v2.25a.75.75 0 0 0 1.5 0zm4.25-2.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zM3 18.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$2af33361d53adfa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionLine20Filled', "20", [
    "M3.5 2.75a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm0 12a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm7.25-2.25c0-.41.34-.75.75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m-6.5-4a2.25 2.25 0 0 1 4.5 0v5a.75.75 0 0 0 1.5 0v-5a3.75 3.75 0 1 0-7.5 0v5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$e6025d9296ae2fb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionLine20Regular', "20", [
    "M3.5 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 12a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm7.5-2.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-7-4a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$890b66a79d2bab4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionLine24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm3.25 5c-1.24 0-2.25 1-2.25 2.25v4.75a1 1 0 1 1-2 0V11a4.25 4.25 0 0 1 8.5 0v4.75a1 1 0 1 1-2 0V11c0-1.24-1-2.25-2.25-2.25m6.75 5.5a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2zm-10 3.5a1 1 0 1 0 0 2h16.5a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$a557e4931f01d480 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionLine24Regular', "24", [
    "M3.75 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM7 8.5A2.5 2.5 0 0 0 4.5 11v4.75a.75.75 0 0 1-1.5 0V11a4 4 0 1 1 8 0v4.75a.75.75 0 0 1-1.5 0V11A2.5 2.5 0 0 0 7 8.5m6.75 6a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm-10 3.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$4a71212d5605e4bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquare20Filled', "20", [
    "M2.75 3.5c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m0 12c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m.75-9.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm11.25.75c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M3.5 8.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm11.25.75c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M3.5 11.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm11.25.75c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75m-7-4a2.25 2.25 0 0 1 4.5 0v5a.75.75 0 0 0 1.5 0v-5a3.75 3.75 0 1 0-7.5 0v5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$680092283fa80c23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquare20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 12c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5M3.5 6a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm11.5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M3.5 9a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm11.5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M3.5 12a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm11.5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m-7.5-4a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$2ffbe21a7df0de82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquare24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm-1 4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1m14.5 0a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m-13.5 2.5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm13.5 1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m-13.5 2.5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm13.5 1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m-14.5 3.5a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1m7-7.75a2.25 2.25 0 0 1 4.5 0v4.75a1 1 0 1 0 2 0V11a4.25 4.25 0 0 0-8.5 0v4.75a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$10b625eab9772645 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquare24Regular', "24", [
    "M3.75 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM3 8.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 3 8.25m14.5 0c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M3.75 11a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm13.75.75c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M3.75 14.5a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm13.75.75c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M3 18.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M9.5 11a2.5 2.5 0 0 1 5 0v4.75a.75.75 0 0 0 1.5 0V11a4 4 0 0 0-8 0v4.75a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$bc15092db7a8d274 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareLeft16Filled', "16", [
    "M2.5 1.75a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zm7.5 2.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM9.25 7.5c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75M10 9.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM1.75 12.5c0-.41.34-.75.75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75M3.25 7a1.75 1.75 0 1 1 3.5 0v3.5a.75.75 0 0 0 1.5 0V7a3.25 3.25 0 1 0-6.5 0v3.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$d7c86fd9bf401450 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareLeft16Regular', "16", [
    "M2.5 2a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zM10 4.5a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1zm-.5 3c0-.28.22-.5.5-.5h3.5a.5.5 0 0 1 0 1H10a.5.5 0 0 1-.5-.5m.5 2a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1zm-8 3c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5M3 7a2 2 0 1 1 4 0v3.5a.5.5 0 0 0 1 0V7a3 3 0 0 0-6 0v3.5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$985d044fb01b7b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareLeft20Filled', "20", [
    "M3.5 2.75a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm8.5 3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm-.75 3.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM2.75 15.5c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m1.5-7a2.25 2.25 0 0 1 4.5 0v5a.75.75 0 0 0 1.5 0v-5a3.75 3.75 0 1 0-7.5 0v5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$e823ed47c8e7cc63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareLeft20Regular', "20", [
    "M3.5 3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM12 6a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zm-.5 3.5c0-.28.22-.5.5-.5h4.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5M12 12a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1zm-9 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m1-7a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$28aaa2ca46bbfa9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareLeft24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm9.5 3.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1-4.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-10.5 8a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1m2-7.75a2.25 2.25 0 0 1 4.5 0v4.75a1 1 0 1 0 2 0V11a4.25 4.25 0 0 0-8.5 0v4.75a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$a42db5174e69ee32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareLeft24Regular', "24", [
    "M3.75 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zm9.5 3.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zm-.75 7.75c0-.41.34-.75.75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75m.75-4.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zM3 18.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M4.5 11a2.5 2.5 0 0 1 5 0v4.75a.75.75 0 0 0 1.5 0V11a4 4 0 1 0-8 0v4.75a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$60659901e43de8a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareRight16Filled', "16", [
    "M13.5 1.75a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1 0-1.5zM6 4.25a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1 0-1.5zm.75 3.25A.75.75 0 0 0 6 6.75H2.5a.75.75 0 0 0 0 1.5H6c.41 0 .75-.34.75-.75M6 9.25a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1 0-1.5zm8.25 3.25a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0 0 1.5h11c.41 0 .75-.34.75-.75M12.75 7a1.75 1.75 0 1 0-3.5 0v3.5a.75.75 0 0 1-1.5 0V7a3.25 3.25 0 1 1 6.5 0v3.5a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$4338f78ce2942b44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareRight16Regular', "16", [
    "M13.5 2a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zM6 4.5a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1zm.5 3A.5.5 0 0 0 6 7H2.5a.5.5 0 0 0 0 1H6a.5.5 0 0 0 .5-.5m-.5 2a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1zm8 3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5M13 7a2 2 0 1 0-4 0v3.5a.5.5 0 0 1-1 0V7a3 3 0 0 1 6 0v3.5a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$a2f6f6ddfab94db7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareRight20Filled', "20", [
    "M16.5 2.75a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1 0-1.5zm-8.5 3a.75.75 0 0 1 0 1.5H3.5a.75.75 0 0 1 0-1.5zm.75 3.75A.75.75 0 0 0 8 8.75H3.5a.75.75 0 0 0 0 1.5H8c.41 0 .75-.34.75-.75M8 11.75a.75.75 0 0 1 0 1.5H3.5a.75.75 0 0 1 0-1.5zm9.25 3.75a.75.75 0 0 0-.75-.75h-13a.75.75 0 0 0 0 1.5h13c.41 0 .75-.34.75-.75m-1.5-7a2.25 2.25 0 0 0-4.5 0v5a.75.75 0 0 1-1.5 0v-5a3.75 3.75 0 1 1 7.5 0v5a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$647d0146ce35bee3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareRight20Regular', "20", [
    "M16.5 3a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1zM8 6a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1 0-1zm.5 3.5A.5.5 0 0 0 8 9H3.5a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5M8 12a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1 0-1zm9 3.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 .5-.5m-1-7a2.5 2.5 0 0 0-5 0v5a.5.5 0 0 1-1 0v-5a3.5 3.5 0 1 1 7 0v5a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$dec8bd57490992d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareRight24Filled', "24", [
    "M20.25 3.75a1 1 0 1 1 0 2H3.75a1 1 0 0 1 0-2zm-9.5 3.5a1 1 0 1 1 0 2h-7a1 1 0 0 1 0-2zm1 8a1 1 0 0 0-1-1h-7a1 1 0 1 0 0 2h7a1 1 0 0 0 1-1m-1-4.5a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2zm10.5 8a1 1 0 0 0-1-1H3.75a1 1 0 1 0 0 2h16.5a1 1 0 0 0 1-1m-2-7.75a2.25 2.25 0 0 0-4.5 0v4.75a1 1 0 1 1-2 0V11a4.25 4.25 0 0 1 8.5 0v4.75a1 1 0 1 1-2 0z"
]);
const $db6ad3fef28672ff$export$67c9d81a85437b06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionSquareRight24Regular', "24", [
    "M20.25 4a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zm-9.5 3.5a.75.75 0 0 1 0 1.5h-7a.75.75 0 1 1 0-1.5zm.75 7.75a.75.75 0 0 0-.75-.75h-7a.75.75 0 0 0 0 1.5h7c.41 0 .75-.34.75-.75M10.75 11a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5zM21 18.75a.75.75 0 0 0-.75-.75H3.75a.75.75 0 0 0 0 1.5h16.5c.41 0 .75-.34.75-.75M19.5 11a2.5 2.5 0 0 0-5 0v4.75a.75.75 0 0 1-1.5 0V11a4 4 0 0 1 8 0v4.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$51e7311ead2930f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionThrough20Filled', "20", [
    "M3.5 2.75a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zM7.75 8.5a2.25 2.25 0 0 1 4.5 0v5a.75.75 0 0 0 1.5 0v-5a3.75 3.75 0 1 0-7.5 0v5a.75.75 0 0 0 1.5 0zm-5 7c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m13.75-3.75h-1.75v1.5h1.75a.75.75 0 0 0 0-1.5m-13 0h1.75v1.5H3.5a.75.75 0 0 1 0-1.5m5.25-3h2.5v1.5h-2.5zm0 3h2.5v1.5h-2.5zm-3.5-3v1.5H3.5a.75.75 0 0 1 0-1.5zm11.25 0h-1.75v1.5h1.75a.75.75 0 0 0 0-1.5m-2.63-3q.49.68.71 1.5h1.92a.75.75 0 0 0 0-1.5zm-7.74 0q-.49.68-.71 1.5H3.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$5c0bed636c7aa599 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionThrough20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5M3.5 6h2.76q-.31.45-.5 1H3.5a.5.5 0 0 1 0-1m0 3h2v1h-2a.5.5 0 0 1 0-1m0 3h2v1h-2a.5.5 0 0 1 0-1m13 0h-2v1h2a.5.5 0 0 0 0-1m-8-3v1h3V9zm8 1h-2V9h2a.5.5 0 0 1 0 1m-8 2v1h3v-1zm8-5h-2.26q-.19-.55-.5-1h2.76a.5.5 0 0 1 0 1m-13 8h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1m4-6.5a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$d2bc4a734c79e024 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionThrough24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm12.12 5.5a4.27 4.27 0 0 0-5.87-2A4.3 4.3 0 0 0 7.75 11v4.75a1 1 0 0 0 1 1 1 1 0 0 0 1-1V11a2.3 2.3 0 0 1 .84-1.75 2.24 2.24 0 0 1 2.82 0 2.3 2.3 0 0 1 .84 1.75v4.75a1 1 0 0 0 1 1 1 1 0 0 0 1-1V11a4 4 0 0 0-.38-1.75m-12.12-2h4.58q-.87.84-1.28 2h-3.3a1 1 0 0 1 0-2m0 3.5h3v2h-3a1 1 0 1 1 0-2m0 3.5h3v1.5a2 2 0 0 0 .06.5H3.75a1 1 0 1 1 0-2m7 1.5a2 2 0 0 1-.06.5h2.62a2 2 0 0 1-.06-.5v-1.5h-2.5zm6.5 0a2 2 0 0 1-.06.5h3.06a1 1 0 1 0 0-2h-3zm3-3h-3v-2h3a1 1 0 1 1 0 2m-7-1.75v1.75h-2.5V11q0-.13.03-.25h2.45zm7-1.75h-3.3a5 5 0 0 0-1.28-2h4.58a1 1 0 1 1 0 2m-16.5 8.5h16.5a1 1 0 1 1 0 2H3.75a1 1 0 1 1 0-2"
]);
const $db6ad3fef28672ff$export$990d7ba73ebc1387 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionThrough24Regular', "24", [
    "M3.75 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM3 8.25c0-.41.34-.75.75-.75h4.68A5 5 0 0 0 7.42 9H3.75A.75.75 0 0 1 3 8.25M15.46 9a4 4 0 0 0-5.4-1.5A4 4 0 0 0 8 11v4.75a.75.75 0 1 0 1.5 0V11a2.5 2.5 0 1 1 5 0v4.75a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V11q-.01-1.1-.54-2M3.75 11H7v1.5H3.75a.75.75 0 0 1 0-1.5m0 3.5H7v1.25q0 .13.02.25H3.75a.75.75 0 0 1 0-1.5m9.75 1.25q0 .13.02.25h-3.04l.02-.25V14.5h3zm6.75-3.25H17V11h3.25a.75.75 0 0 1 0 1.5M17 15.75q0 .13-.02.25h3.27a.75.75 0 0 0 0-1.5H17zm-3.5-3.25h-3V11h3zm2.07-5A5 5 0 0 1 16.58 9h3.67a.75.75 0 0 0 0-1.5zM3.75 18a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$9ab5daf12e12a6bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTight20Filled', "20", [
    "M3.5 2.75a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm0 12a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5zm6.5-8.5c-1.24 0-2.25 1-2.25 2.25v5a.75.75 0 0 1-1.5 0v-5a3.75 3.75 0 1 1 7.5 0v5a.75.75 0 0 1-1.5 0v-5c0-1.24-1-2.25-2.25-2.25m-6.5 5.5h1.75v1.5H3.5a.75.75 0 0 1 0-1.5m13 1.5h-1.75v-1.5h1.75a.75.75 0 0 1 0 1.5m-1.75-4.5v1.5h1.75a.75.75 0 0 0 0-1.5zm-8.62-3q-.49.68-.71 1.5H3.5a.75.75 0 0 1 0-1.5zm10.37 1.5h-1.92a5 5 0 0 0-.7-1.5h2.62a.75.75 0 0 1 0 1.5M5.25 8.75v1.5H3.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$43f644157019920 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTight20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5M3.5 6h2.76q-.31.45-.5 1H3.5a.5.5 0 0 1 0-1m0 3h2v1h-2a.5.5 0 0 1 0-1m0 3h2v1h-2a.5.5 0 0 1 0-1m0 3h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1m13-2h-2v-1h2a.5.5 0 0 1 0 1m-2-4v1h2a.5.5 0 0 0 0-1zm-.76-3q.31.45.5 1h2.26a.5.5 0 0 0 0-1zM7.5 8.5a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$8a711d068eef1aa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTight24Filled', "24", [
    "M3.75 3.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zm12.12 5.5a4.27 4.27 0 0 0-5.87-2A4.3 4.3 0 0 0 7.75 11v4.75a1 1 0 0 0 1 1 1 1 0 0 0 1-1V11l.01-.25a2.25 2.25 0 0 1 4.49.25v4.75a1 1 0 1 0 2 0V11a4 4 0 0 0-.38-1.75m-12.12-2h4.58q-.87.84-1.28 2h-3.3a1 1 0 0 1 0-2m0 3.5h3v2h-3a1 1 0 1 1 0-2m0 3.5h3v1.5a2 2 0 0 0 .06.5H3.75a1 1 0 1 1 0-2m13.5 1.5a2 2 0 0 1-.06.5h3.06a1 1 0 1 0 0-2h-3zm3-3h-3v-2h3a1 1 0 1 1 0 2m0-3.5h-3.3a5 5 0 0 0-1.28-2h4.58a1 1 0 1 1 0 2m-16.5 8.5h16.5a1 1 0 1 1 0 2H3.75a1 1 0 1 1 0-2"
]);
const $db6ad3fef28672ff$export$65a9d60a88c49c71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTight24Regular', "24", [
    "M3.75 4a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5zM3 8.25c0-.41.34-.75.75-.75h4.68A5 5 0 0 0 7.42 9H3.75A.75.75 0 0 1 3 8.25M15.46 9a4 4 0 0 0-5.4-1.5A4 4 0 0 0 8 11v4.75a.75.75 0 1 0 1.5 0V11a2.5 2.5 0 1 1 5 0v4.75a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V11q-.01-1.1-.54-2M3.75 11H7v1.5H3.75a.75.75 0 0 1 0-1.5m0 3.5H7v1.25q0 .13.02.25H3.75a.75.75 0 0 1 0-1.5m16.5 1.5h-3.27l.02-.25V14.5h3.25a.75.75 0 0 1 0 1.5m0-3.5H17V11h3.25a.75.75 0 0 1 0 1.5m0-3.5h-3.67a5 5 0 0 0-1-1.5h4.67a.75.75 0 0 1 0 1.5m-16.5 9a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$d7a4067590491335 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTopBottom20Filled', "20", [
    "M2.75 3.5c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m0 12c0-.41.34-.75.75-.75h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75m5-7a2.25 2.25 0 0 1 4.5 0v5a.75.75 0 0 0 1.5 0v-5a3.75 3.75 0 1 0-7.5 0v5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$4bd0ff561ca4c02b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTopBottom20Regular', "20", [
    "M3 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0 12c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m4.5-7a2.5 2.5 0 0 1 5 0v5a.5.5 0 0 0 1 0v-5a3.5 3.5 0 1 0-7 0v5a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$3c840b0b756bd538 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTopBottom24Filled', "24", [
    "M2.75 4.75a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1m0 14a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1m7-7.75a2.25 2.25 0 0 1 4.5 0v4.75a1 1 0 1 0 2 0V11a4.25 4.25 0 0 0-8.5 0v4.75a1 1 0 1 0 2 0z"
]);
const $db6ad3fef28672ff$export$23700bb308f64c9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextPositionTopBottom24Regular', "24", [
    "M3 4.75c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 4.75m0 14c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M9.5 11a2.5 2.5 0 0 1 5 0v4.75a.75.75 0 0 0 1.5 0V11a4 4 0 0 0-8 0v4.75a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$6144c0d20cd3ec2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingTools20Filled', "20", [
    "M16.97 2.98q.78.38 1.17 1.46a.75.75 0 1 1-1.4.51c-.18-.47-.35-.59-.44-.63-.12-.06-.27-.07-.58-.07a.7.7 0 0 0-.5.17q-.18.15-.3.5a3 3 0 0 0-.17.88c0 .41 0 .9.16 1.3q.11.27.3.42.16.17.6.23c.08 0 .28 0 .48-.07a.8.8 0 0 0 .46-.45.75.75 0 0 1 1.37.61c-.63 1.42-2.03 1.45-2.48 1.4a2.6 2.6 0 0 1-1.4-.56c-.35-.3-.58-.68-.72-1.04a5 5 0 0 1-.27-1.8v-.08l.03-.4c.03-.26.1-.61.23-.97.14-.36.35-.77.72-1.09q.56-.53 1.49-.55h.03c.28 0 .75 0 1.22.23m-11.58.27A.75.75 0 0 0 4 3.23l-1.94 5a.75.75 0 1 0 1.4.54l.1-.27h2.11l.1.25a.75.75 0 0 0 1.4-.5zM5.13 7h-1l.53-1.34zM8 3.5v5a.75.75 0 0 0 .87.74v.01h1.63c.24 0 .73-.04 1.2-.3.52-.3.92-.87.92-1.7q0-.64-.28-1.12a2 2 0 0 0-.29-.35q.23-.41.24-1.02t-.25-1.08a1.7 1.7 0 0 0-.66-.67c-.46-.26-.95-.26-1.12-.26H8.75A.75.75 0 0 0 8 3.5m2.5 4.25h-1v-1h.94q.3-.01.51.08.07.03.1.08.06.04.07.33-.01.25-.06.3a.3.3 0 0 1-.12.1 1 1 0 0 1-.44.11m-.88-2.5H9.5v-1h.75q.25-.01.4.07l.08.08q.05.05.06.36 0 .26-.06.3a.3.3 0 0 1-.1.1 1 1 0 0 1-.35.09zm4.32 5.73a.75.75 0 0 0-1.16-.95l-3.56 4.35-1.69-1.68a.75.75 0 0 0-1.06 1.06l2.27 2.27a.75.75 0 0 0 1.11-.06z"
]);
const $db6ad3fef28672ff$export$f1f6a25661e13ddf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingTools20Regular', "20", [
    "M4.94 3c.21 0 .4.14.47.33l1.77 5a.5.5 0 0 1-.94.34l-.26-.73V8H3.73l-.26.68a.5.5 0 1 1-.94-.36l1.94-5A.5.5 0 0 1 4.94 3m-.02 1.94L4.12 7h1.53zm12.49-.41c-.25-.69-.6-1.1-1.06-1.33-.4-.2-.83-.2-1.1-.2h-.03c-.55 0-1 .19-1.33.49-.32.29-.52.65-.64.99A4 4 0 0 0 13 5.77v.05c0 .39 0 1.09.25 1.73.13.33.33.67.66.93q.48.41 1.25.5c.42.05 1.67.02 2.23-1.24a.5.5 0 1 0-.9-.4c-.3.64-.94.68-1.22.65a1.3 1.3 0 0 1-.73-.28 1.3 1.3 0 0 1-.36-.52A4 4 0 0 1 14 5.8V5.8l.02-.28q.04-.31.16-.68.14-.37.38-.6a1 1 0 0 1 .66-.23c.3 0 .5 0 .7.1.15.08.36.25.55.77a.5.5 0 1 0 .94-.34m-5.94 1.3q.31-.4.32-1.07 0-.57-.22-.96a1.4 1.4 0 0 0-.56-.57c-.4-.23-.84-.23-1-.23H8.5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1.75c.22 0 .66-.03 1.07-.27.45-.26.8-.74.8-1.49q0-.57-.25-.98a2 2 0 0 0-.4-.42m-.95-1.73q.1.06.18.18a1 1 0 0 1 .1.48c0 .4-.16.54-.28.62-.17.1-.38.12-.5.12H9V4h1q.26-.02.52.1M9.36 6.5h.83c.18 0 .43 0 .62.1q.14.07.2.18.1.12.1.46c0 .38-.14.54-.3.62-.18.11-.42.14-.56.14H9V6.5zm4.4 4.32a.5.5 0 1 0-.78-.64l-3.74 4.58-1.89-1.89a.5.5 0 0 0-.7.71l2.27 2.27a.5.5 0 0 0 .74-.03z"
]);
const $db6ad3fef28672ff$export$6467e0df11ad8d0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingTools24Filled', "24", [
    "M22.2 4.97a3.2 3.2 0 0 0-1.56-1.92c-.61-.3-1.24-.3-1.6-.3H19c-.8 0-1.47.28-1.96.72-.48.43-.77.96-.94 1.43a6 6 0 0 0-.35 1.8v.09c0 .5 0 1.47.35 2.36.19.48.49.97.96 1.36q.73.6 1.83.73c.6.07 2.43.03 3.27-1.82a1 1 0 0 0-1.82-.82c-.16.34-.38.5-.6.58-.25.09-.51.09-.63.08-.4-.05-.62-.17-.77-.3a1.3 1.3 0 0 1-.38-.54 5 5 0 0 1-.21-1.67l.03-.34q.04-.38.19-.8.16-.44.4-.64a1 1 0 0 1 .63-.22c.4 0 .6.02.76.1.1.05.33.2.55.8a1 1 0 1 0 1.88-.68M14.5 6.71q.31-.54.32-1.33 0-.8-.33-1.42-.35-.61-.86-.88a3 3 0 0 0-1.45-.33H10a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2.38c.3 0 .96-.04 1.58-.37a2.4 2.4 0 0 0 1.29-2.25q0-.84-.37-1.46-.16-.27-.37-.46m-1.85-1.88q.05.02.08.08a1 1 0 0 1 .09.47 1 1 0 0 1-.08.39.3.3 0 0 1-.12.12 1 1 0 0 1-.46.11H11V4.75h1.16q.34-.01.5.08M12.17 8h.2q.4-.02.67.1.1.04.13.1.06.06.08.43c0 .2-.05.3-.07.34a.4.4 0 0 1-.16.14c-.2.1-.47.14-.64.14H11V8zM5.03 2.75a1 1 0 0 1 .93.67l2.3 6.5a1 1 0 1 1-1.88.66l-.19-.53H3.65l-.22.56a1 1 0 1 1-1.86-.72l2.51-6.5a1 1 0 0 1 .95-.64m-.05 3.88-.56 1.42h1.06zm10.5 5.98-4.3 5.16-1.72-1.73a1 1 0 0 0-1.42 1.42l2.5 2.5a1 1 0 0 0 1.48-.07l5-6a1 1 0 0 0-1.54-1.28"
]);
const $db6ad3fef28672ff$export$dcf170a234afdbb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingTools24Regular', "24", [
    "M20.53 3.27q.93.43 1.43 1.79a.75.75 0 1 1-1.42.5c-.23-.64-.5-.85-.67-.94-.22-.1-.47-.12-.87-.12-.38 0-.62.12-.8.28q-.3.27-.47.73a4 4 0 0 0-.23 1.23v.01c0 .53 0 1.2.23 1.76q.15.4.45.65c.19.16.47.3.9.34.35.04 1.13-.02 1.49-.8a.75.75 0 1 1 1.36.62c-.77 1.7-2.46 1.74-3.01 1.68a3 3 0 0 1-1.7-.68 3 3 0 0 1-.89-1.26A6 6 0 0 1 16 6.78V6.7l.04-.51c.04-.32.12-.76.29-1.2.17-.45.43-.94.87-1.33.45-.4 1.05-.66 1.8-.66h.04c.36 0 .93 0 1.49.27M5.28 3c.31 0 .59.2.7.5l2.3 6.5a.75.75 0 0 1-1.41.5l-.34-.95h-2.7l-.38.97a.75.75 0 0 1-1.4-.54l2.52-6.5c.11-.3.4-.48.7-.48m-.04 2.9L4.4 8.06H6zm4.04 10.32 1.92 1.92 4.47-5.37a.75.75 0 1 1 1.16.96l-5 6a.75.75 0 0 1-1.11.05l-2.5-2.5a.75.75 0 1 1 1.06-1.06m5.3-10.84q-.02.86-.39 1.38.27.21.47.54.34.54.34 1.33 0 .74-.34 1.27t-.82.76a3 3 0 0 1-1.46.34H9.75a.75.75 0 0 1-.75-.75v-6.5c0-.41.34-.75.75-.75h2.43c.22 0 .8 0 1.34.3.29.16.57.41.76.78q.3.54.3 1.3m-2.42-.88H10.5v1.75h1.66c.15 0 .4-.03.6-.15a1 1 0 0 0 .2-.2q.1-.14.12-.52-.02-.47-.12-.59a.4.4 0 0 0-.18-.18q-.27-.13-.62-.11m.22 5c.18 0 .5-.03.75-.17q.17-.09.26-.22a1 1 0 0 0 .11-.48q-.02-.43-.12-.55a.5.5 0 0 0-.22-.2 2 2 0 0 0-.78-.13H10.5V9.5z"
]);
const $db6ad3fef28672ff$export$16cad184a0070048 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingToolsAbc16Filled', "16", [
    "M10.44 8.26a.75.75 0 0 1 1.13.98l-3.5 4a.75.75 0 0 1-1.04.1l-.06-.06-2-2-.05-.06a.75.75 0 0 1 1.05-1.05l.06.05 1.43 1.43zM2.75 2c.3 0 .57.18.69.45l1.75 4 .02.07a.75.75 0 0 1-1.36.6l-.04-.07L3.8 7H1.71l-.02.05a.75.75 0 0 1-1.38-.6l1.75-4 .05-.1A.8.8 0 0 1 2.75 2M8 2a1.75 1.75 0 0 1 1.54 2.57A1.74 1.74 0 0 1 8.25 7.5h-1.5A.75.75 0 0 1 6 6.75V2.67A.75.75 0 0 1 6.75 2zm5.19 0c.6 0 1.11.23 1.5.6l.15.18.04.06a.75.75 0 0 1-1.17.94l-.05-.06-.09-.1a.6.6 0 0 0-.38-.12q-.35.01-.51.26-.23.3-.24.99.02.68.24.99.17.26.5.26t.48-.22a.75.75 0 0 1 1.18.94c-.4.48-.96.78-1.65.78-.76 0-1.36-.36-1.74-.9a3.2 3.2 0 0 1-.51-1.85c0-.65.14-1.32.5-1.84.39-.55.99-.91 1.75-.91M7.5 6h.75a.25.25 0 0 0 0-.5H7.5zm-5.13-.5h.76l-.38-.88zM7.5 4H8a.25.25 0 0 0 0-.5h-.5z"
]);
const $db6ad3fef28672ff$export$5cf870932c09ffc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingToolsAbc16Regular', "16", [
    "M10.62 8.17a.5.5 0 1 1 .76.66l-3.5 4a.5.5 0 0 1-.73.02l-2-2-.07-.07a.5.5 0 0 1 .7-.7l.07.07 1.63 1.62zM3 2q.32.02.46.3l1.75 4 .03.1a.5.5 0 0 1-.9.39L4.3 6.7 4 6H2l-.3.7a.5.5 0 0 1-.92-.4l1.75-4 .04-.07A.5.5 0 0 1 3 2m4.75 0a1.5 1.5 0 0 1 1.23 2.36A1.5 1.5 0 0 1 8 7H6.5a.5.5 0 0 1-.5-.5v-4l.01-.1A.5.5 0 0 1 6.5 2zm4.75 0c.67 0 1.2.31 1.54.8q.1.16.19.34c.14.3-.12.61-.45.61-.23 0-.42-.16-.55-.35q0-.02-.02-.03A.8.8 0 0 0 12.5 3a.8.8 0 0 0-.71.37q-.28.38-.29 1.13.01.75.29 1.13.23.36.71.37.48-.01.71-.37l.02-.03c.13-.2.32-.35.55-.35.33 0 .59.31.45.61q-.09.18-.2.34c-.33.49-.86.8-1.53.8a1.8 1.8 0 0 1-1.54-.8 3 3 0 0 1-.46-1.7 3 3 0 0 1 .46-1.7c.34-.49.87-.8 1.54-.8M7 6h1a.5.5 0 0 0 0-1H7zM2.45 5h1.1L3 3.75zM7 4h.75a.5.5 0 0 0 0-1H7z"
]);
const $db6ad3fef28672ff$export$2f5d06cb18682ba4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingToolsGaNaDa16Filled', "16", [
    "M10.44 9.26a.75.75 0 0 1 1.12.98l-3.5 4a.75.75 0 0 1-1.03.1l-.06-.06-2-2-.05-.06a.75.75 0 0 1 1.05-1.05l.06.05 1.43 1.43zM4.25 1.5c.41 0 .75.34.75.75V3a.75.75 0 0 1 0 1.5v2.75a.75.75 0 0 1-1.5 0v-5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75V3a.75.75 0 0 1 0 1.5v2.75a.75.75 0 0 1-1.5 0v-5c0-.41.34-.75.75-.75m5 0c.41 0 .75.34.75.75V3a.75.75 0 1 1 0 1.5v2.75a.75.75 0 1 1-1.5 0v-5c0-.41.34-.75.75-.75M2.33 2c.37.04.67.36.67.75 0 1.03-.1 1.9-.39 2.6q-.4.97-1.3 1.45l-.26.14a.75.75 0 0 1-.6-1.38l.14-.06q.44-.25.64-.73.18-.43.25-1.27H.75a.75.75 0 0 1 0-1.5h1.58m5.13.03c.37.1.6.48.53.85l-.02.08-.66 2.3a.75.75 0 0 1 .12 1.47l-1 .25a.75.75 0 0 1-.9-.94l1-3.5.02-.07a.75.75 0 0 1 .9-.44M12.25 2a.75.75 0 0 1 .25 1.45v1.86a.75.75 0 0 1 .18 1.48l-.75.19a.75.75 0 0 1-.93-.73V2.67a.75.75 0 0 1 .75-.67z"
]);
const $db6ad3fef28672ff$export$2ee5d76116e5b22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingToolsGaNaDa16Regular', "16", [
    "M10.62 9.17a.5.5 0 0 1 .76.66l-3.5 4a.5.5 0 0 1-.73.02l-2-2-.07-.07a.5.5 0 0 1 .7-.7l.07.07 1.63 1.62zM4.5 1.5c.28 0 .5.22.5.5v1h.5a.5.5 0 0 1 0 1H5v3.5a.5.5 0 0 1-1 0V2c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v1h.5a.5.5 0 0 1 0 1H10v3.5a.5.5 0 0 1-1 0V2c0-.28.22-.5.5-.5m5 0c.28 0 .5.22.5.5v1h.5a.5.5 0 0 1 0 1H15v3.5a.5.5 0 0 1-1 0V2c0-.28.22-.5.5-.5m-6.86.52a.5.5 0 0 1 .34.62L7.2 5.38l.72-.12a.5.5 0 0 1 .16.98l-1.5.25a.5.5 0 0 1-.56-.63l1-3.5a.5.5 0 0 1 .62-.34M3.1 2.01c.23.05.4.25.4.49 0 1.03-.13 1.88-.5 2.56a3 3 0 0 1-1.54 1.3l-.3.11a.5.5 0 0 1-.32-.94l.24-.1c.52-.2.84-.49 1.04-.86q.3-.54.37-1.57H1a.5.5 0 0 1 0-1h2zM12.5 2a.5.5 0 0 1 0 1v2.4l.42-.06a.5.5 0 0 1 .16.99l-1 .16A.5.5 0 0 1 11.5 6V2.4A.5.5 0 0 1 12 2z"
]);
const $db6ad3fef28672ff$export$cdc32199eb2329b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingToolsZi16Filled', "16", [
    "M9.93 10.26a.75.75 0 0 1 1.14.98l-3 3.5a.75.75 0 0 1-1.1.04l-1.5-1.5-.05-.06a.75.75 0 0 1 1.06-1.05l.06.05.92.93zM6.86 4.01a.75.75 0 0 1 .46 1.23L6.24 6.5h2.09a.75.75 0 0 1 0 1.5H6v1.32C6 10.26 5.23 11 4.31 11c-.58 0-1.13-.3-1.42-.81l-.06-.1L2.8 10a.75.75 0 0 1 1.33-.66l.04.07.02.03q.05.05.12.05c.11 0 .19-.09.19-.18V8H1.75a.75.75 0 0 1 0-1.5H4.5l.01-.13A1 1 0 0 1 4.68 6l.44-.51H3.5a.75.75 0 0 1 0-1.5h3.35M12.5 1.5c.3 0 .58.18.7.46l2.5 6 .02.07a.75.75 0 0 1-1.38.58l-.03-.07L13.67 7h-2.34l-.64 1.54a.75.75 0 0 1-1.38-.58l2.5-6 .05-.1a.8.8 0 0 1 .64-.36m-.54 4h1.08l-.54-1.3zM5 .5c.41 0 .75.34.75.75v.25h2.58c.38.04.67.36.67.75v1a.75.75 0 0 1-1.5 0V3h-5v.25a.75.75 0 0 1-1.5 0V2.17a.75.75 0 0 1 .75-.67h2.5v-.25c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$78f15712ba1040f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextProofingToolsZi16Regular', "16", [
    "M10.62 10.17a.5.5 0 1 1 .76.66l-3.5 4a.5.5 0 0 1-.73.02l-2-2-.07-.07a.5.5 0 0 1 .7-.7l.07.07 1.63 1.62zM7 4a.5.5 0 0 1 .35.85L6.21 6H8.5a.5.5 0 0 1 0 1H6v1.57C6 9.37 5.35 10 4.56 10c-.46 0-.9-.23-1.16-.6l-.1-.18-.03-.1a.5.5 0 0 1 .87-.43l.06.09.03.04q.12.17.33.18c.25 0 .44-.2.44-.43V7H1.5a.5.5 0 0 1 0-1H5a.5.5 0 0 1 .15-.35L5.79 5H3.5a.5.5 0 0 1 0-1zm5-2c.2 0 .38.12.46.3l2.5 6 .03.1a.5.5 0 0 1-.9.38l-.05-.09-.7-1.69h-2.67l-.7 1.7a.5.5 0 0 1-.93-.4l2.5-6 .03-.06A.5.5 0 0 1 12 2m-.92 4h1.84L12 3.8zM5 1c.28 0 .5.22.5.5V2h3l.1.01c.23.05.4.25.4.49v1a.5.5 0 0 1-1 0V3H2v.5a.5.5 0 0 1-1 0v-1l.01-.1A.5.5 0 0 1 1.5 2h3v-.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$36ee0ca423345144 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote16Filled', "16", [
    "M9.65 11.15a7.3 7.3 0 0 0 2.24-4.36A2 2 0 1 1 13 5c0 2.6-.53 4.74-2.65 6.86a.5.5 0 0 1-.7-.7m-6 0a7.3 7.3 0 0 0 2.24-4.36A2 2 0 1 1 7 5c0 2.6-.53 4.74-2.65 6.86a.5.5 0 0 1-.7-.7"
]);
const $db6ad3fef28672ff$export$e4f616f99c9c0a2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote16Regular', "16", [
    "M11 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m.89 2.8a7.3 7.3 0 0 1-2.24 4.35.5.5 0 0 0 .7.7C12.47 9.73 13 7.6 13 5a2 2 0 1 0-1.11 1.8M5 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m.89 2.8a7.3 7.3 0 0 1-2.24 4.35.5.5 0 0 0 .7.7C6.47 9.73 7 7.6 7 5a2 2 0 1 0-1.11 1.8"
]);
const $db6ad3fef28672ff$export$3b69db4e3f8f9719 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote20Filled', "20", [
    "M9 6.5a2.5 2.5 0 1 0-1.17 2.12 9 9 0 0 1-.96 2.76 12 12 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A11 11 0 0 0 9 6.5m5.83 2.12q-.59.37-1.33.38A2.5 2.5 0 1 1 16 6.5c0 2.33-.52 4.04-1.25 5.37-.72 1.3-1.64 2.23-2.38 2.97l-.02.01a.5.5 0 0 1-.7-.7c.75-.76 1.57-1.59 2.22-2.77a9 9 0 0 0 .96-2.76"
]);
const $db6ad3fef28672ff$export$b30755e27b453a48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote20Regular', "20", [
    "M7.83 8.62a9 9 0 0 1-.96 2.76 12 12 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A11 11 0 0 0 9 6.5a2.5 2.5 0 1 0-1.17 2.12M8 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6.83 2.12a9 9 0 0 1-.96 2.76 12 12 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A11 11 0 0 0 16 6.5a2.5 2.5 0 1 0-1.17 2.12M13.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $db6ad3fef28672ff$export$eb4494194f6969dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote24Filled', "24", [
    "M8 5a3 3 0 0 1 3 3c0 2.93-1.06 5.38-2.11 7.08a16 16 0 0 1-2.11 2.7l-.01.01a.75.75 0 0 1-1.03-1.09l.03-.03a7 7 0 0 0 .54-.58c.35-.41.83-1.02 1.3-1.8.59-.95 1.17-2.14 1.53-3.51A3 3 0 0 1 5 8a3 3 0 0 1 3-3m8 0a3 3 0 0 1 3 3c0 2.93-1.06 5.38-2.11 7.08a16 16 0 0 1-2.11 2.7l-.01.01a.75.75 0 0 1-1.03-1.09l.03-.03a7 7 0 0 0 .54-.58c.35-.41.83-1.02 1.3-1.8.59-.95 1.17-2.14 1.53-3.51A3 3 0 0 1 13 8a3 3 0 0 1 3-3"
]);
const $db6ad3fef28672ff$export$e823352e8bf3232d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote24Regular', "24", [
    "M8 5a3 3 0 0 1 3 3c0 2.93-1.06 5.38-2.11 7.08a16 16 0 0 1-2.11 2.7l-.01.01a.75.75 0 0 1-1.03-1.09l.03-.03a7 7 0 0 0 .54-.58c.35-.41.83-1.02 1.3-1.8.59-.95 1.17-2.14 1.53-3.51A3 3 0 0 1 5 8a3 3 0 0 1 3-3m8 0a3 3 0 0 1 3 3c0 2.93-1.06 5.38-2.11 7.08a16 16 0 0 1-2.11 2.7l-.01.01a.75.75 0 0 1-1.03-1.09l.03-.03a7 7 0 0 0 .54-.58c.35-.41.83-1.02 1.3-1.8.59-.95 1.17-2.14 1.53-3.51A3 3 0 0 1 13 8a3 3 0 0 1 3-3M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m8 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $db6ad3fef28672ff$export$68b86e06f3685d58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote28Filled', "28", [
    "M8.75 5a3.75 3.75 0 0 1 3.75 3.75 16.4 16.4 0 0 1-5.03 11.87l-.25.21a.75.75 0 0 1-.94-1.17l.04-.03a6 6 0 0 0 .67-.64 14.83 14.83 0 0 0 3.67-7.02q-.85.52-1.91.53a3.75 3.75 0 1 1 0-7.5m10.5 0A3.75 3.75 0 0 1 23 8.75a16.4 16.4 0 0 1-5.03 11.87l-.25.21a.75.75 0 0 1-.94-1.17l.04-.03a6 6 0 0 0 .67-.64 14.83 14.83 0 0 0 3.67-7.02q-.85.52-1.91.53a3.75 3.75 0 1 1 0-7.5"
]);
const $db6ad3fef28672ff$export$bbc5a0ad21e920ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote28Regular', "28", [
    "M8.75 5a3.75 3.75 0 0 1 3.75 3.75 16.4 16.4 0 0 1-5.03 11.87l-.25.21a.75.75 0 0 1-.94-1.17l.04-.03a6 6 0 0 0 .67-.64 14.83 14.83 0 0 0 3.67-7.02q-.85.52-1.91.53a3.75 3.75 0 1 1 0-7.5m10.5 0A3.75 3.75 0 0 1 23 8.75a16.4 16.4 0 0 1-5.03 11.87l-.25.21a.75.75 0 0 1-.94-1.17l.04-.03a6 6 0 0 0 .67-.64 14.83 14.83 0 0 0 3.67-7.02q-.85.52-1.91.53a3.75 3.75 0 1 1 0-7.5M8.75 6.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m10.5 0a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5"
]);
const $db6ad3fef28672ff$export$c182d3f6775a2db9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote32Filled', "32", [
    "M9.5 5A4.5 4.5 0 0 1 14 9.5c0 5.45-1.56 9.27-3.16 11.73a15 15 0 0 1-2.96 3.36l-.23.17-.08.06h-.01v.01a1 1 0 0 1-1.12-1.66l.2-.15q.22-.15.6-.53c.52-.5 1.22-1.26 1.92-2.35 1-1.54 2.02-3.73 2.52-6.7q-.99.54-2.18.56a4.5 4.5 0 1 1 0-9m13 0A4.5 4.5 0 0 1 27 9.5c0 5.45-1.56 9.27-3.16 11.73a15 15 0 0 1-2.96 3.36l-.23.17-.08.06h-.01v.01a1 1 0 0 1-1.12-1.66l.2-.15q.22-.15.6-.53a13 13 0 0 0 1.92-2.35c1-1.54 2.02-3.73 2.52-6.7q-.98.54-2.18.56a4.5 4.5 0 1 1 0-9"
]);
const $db6ad3fef28672ff$export$96bf82e86c52ccee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuote32Regular', "32", [
    "M9.5 5A4.5 4.5 0 0 1 14 9.5c0 5.45-1.56 9.27-3.16 11.73a15 15 0 0 1-2.96 3.36l-.23.17-.08.06h-.01v.01a1 1 0 0 1-1.12-1.66l.2-.15q.22-.15.6-.53c.52-.5 1.22-1.26 1.92-2.35 1-1.54 2.02-3.73 2.52-6.7q-.99.54-2.18.56a4.5 4.5 0 1 1 0-9m13 0A4.5 4.5 0 0 1 27 9.5c0 5.45-1.56 9.27-3.16 11.73a15 15 0 0 1-2.96 3.36l-.23.17-.08.06h-.01v.01a1 1 0 0 1-1.12-1.66l.2-.15q.22-.15.6-.53a13 13 0 0 0 1.92-2.35c1-1.54 2.02-3.73 2.52-6.7q-.98.54-2.18.56a4.5 4.5 0 1 1 0-9m-13 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m13 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $db6ad3fef28672ff$export$ee7cea32e5212431 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening16Filled', "16", [
    "M6.35 4.85a7.3 7.3 0 0 0-2.24 4.36A2 2 0 1 1 3 11c0-2.6.53-4.74 2.65-6.86a.5.5 0 1 1 .7.7m6 0a7.3 7.3 0 0 0-2.24 4.36A2 2 0 1 1 9 11c0-2.6.53-4.74 2.65-6.86a.5.5 0 0 1 .7.7"
]);
const $db6ad3fef28672ff$export$4c076dfe89913a2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening16Regular', "16", [
    "M5 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-.89-2.8c.24-1.59.86-2.96 2.24-4.35a.5.5 0 1 0-.7-.7C3.53 6.27 3 8.4 3 11a2 2 0 1 0 1.11-1.8M11 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-.89-2.8c.24-1.59.86-2.96 2.24-4.35a.5.5 0 0 0-.7-.7C9.53 6.27 9 8.4 9 11a2 2 0 1 0 1.11-1.8"
]);
const $db6ad3fef28672ff$export$8ed23d07e63d5c5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening20Filled', "20", [
    "M11 13.5a2.5 2.5 0 1 0 1.17-2.12 9 9 0 0 1 .96-2.76 12 12 0 0 1 2.22-2.77.5.5 0 0 0-.7-.7h-.02c-.74.75-1.66 1.67-2.38 2.98A11 11 0 0 0 11 13.5m-5.83-2.12q.59-.37 1.33-.38A2.5 2.5 0 1 1 4 13.5c0-2.33.52-4.04 1.25-5.37a13 13 0 0 1 2.38-2.97l.02-.01a.5.5 0 1 1 .7.7c-.75.76-1.58 1.59-2.22 2.77a9 9 0 0 0-.96 2.76"
]);
const $db6ad3fef28672ff$export$9a73216cba868607 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening20Regular', "20", [
    "M12.17 11.38a9 9 0 0 1 .96-2.76 12 12 0 0 1 2.22-2.77.5.5 0 0 0-.7-.7h-.02c-.74.75-1.66 1.67-2.38 2.98A11 11 0 0 0 11 13.5a2.5 2.5 0 1 0 1.17-2.12M12 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.83-2.12a9 9 0 0 1 .96-2.76 12 12 0 0 1 2.22-2.77.5.5 0 1 0-.7-.7h-.02c-.74.75-1.66 1.67-2.38 2.98A11 11 0 0 0 4 13.5a2.5 2.5 0 1 0 1.17-2.12M6.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $db6ad3fef28672ff$export$99af5de2180e8aa3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening24Filled', "24", [
    "M16 19a3 3 0 0 1-3-3c0-2.93 1.07-5.38 2.11-7.08a16 16 0 0 1 2.11-2.7l.02-.01a.75.75 0 0 1 1.03 1.09l-.04.03a7 7 0 0 0-.53.58 14 14 0 0 0-1.3 1.8c-.6.95-1.17 2.14-1.53 3.51A3 3 0 0 1 19 16a3 3 0 0 1-3 3m-8 0a3 3 0 0 1-3-3c0-2.93 1.07-5.38 2.11-7.08a16 16 0 0 1 2.11-2.7l.02-.01a.75.75 0 0 1 1.03 1.09l-.04.03a7 7 0 0 0-.53.58 14 14 0 0 0-1.3 1.8c-.6.95-1.17 2.14-1.53 3.51A3 3 0 0 1 11 16a3 3 0 0 1-3 3"
]);
const $db6ad3fef28672ff$export$c451276c878c24f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening24Regular', "24", [
    "M16 19a3 3 0 0 1-3-3c0-2.93 1.07-5.38 2.11-7.08a16 16 0 0 1 2.11-2.7l.02-.01a.75.75 0 0 1 1.03 1.09l-.04.03a7 7 0 0 0-.53.58 14 14 0 0 0-1.3 1.8c-.6.95-1.17 2.14-1.53 3.51A3 3 0 0 1 19 16a3 3 0 0 1-3 3m-8 0a3 3 0 0 1-3-3c0-2.93 1.07-5.38 2.11-7.08a16 16 0 0 1 2.11-2.7l.02-.01a.75.75 0 0 1 1.03 1.09l-.04.03a7 7 0 0 0-.53.58 14 14 0 0 0-1.3 1.8c-.6.95-1.17 2.14-1.53 3.51A3 3 0 0 1 11 16a3 3 0 0 1-3 3m8-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-8 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$f46f39b582f2626c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening28Filled', "28", [
    "M19.25 23a3.75 3.75 0 0 1-3.75-3.75 16.4 16.4 0 0 1 5.04-11.87l.17-.15.07-.06a.75.75 0 1 1 .94 1.17l-.04.03a6 6 0 0 0-.66.64 14.83 14.83 0 0 0-3.67 7.02A3.75 3.75 0 1 1 19.25 23m-10.5 0A3.75 3.75 0 0 1 5 19.25a16.4 16.4 0 0 1 5.04-11.87l.17-.15.07-.06a.75.75 0 1 1 .94 1.17l-.04.03a6 6 0 0 0-.66.64 14.83 14.83 0 0 0-3.67 7.02A3.75 3.75 0 1 1 8.75 23"
]);
const $db6ad3fef28672ff$export$a1b89f8b9e909728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening28Regular', "28", [
    "M19.25 23a3.75 3.75 0 0 1-3.75-3.75 16.4 16.4 0 0 1 5.04-11.87l.17-.15.07-.06a.75.75 0 1 1 .94 1.17l-.04.03a6 6 0 0 0-.66.64 14.83 14.83 0 0 0-3.67 7.02A3.75 3.75 0 1 1 19.25 23m-10.5 0A3.75 3.75 0 0 1 5 19.25a16.4 16.4 0 0 1 5.04-11.87l.17-.15.07-.06a.75.75 0 1 1 .94 1.17l-.04.03a6 6 0 0 0-.66.64 14.83 14.83 0 0 0-3.67 7.02A3.75 3.75 0 1 1 8.75 23m10.5-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m-10.5 0a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
]);
const $db6ad3fef28672ff$export$9bc6592ffa1410ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening32Filled', "32", [
    "M22.5 27a4.5 4.5 0 0 1-4.5-4.5c0-5.45 1.56-9.27 3.16-11.73a15 15 0 0 1 2.96-3.36l.23-.17.08-.06h.01v-.01a1 1 0 0 1 1.12 1.66l-.2.15q-.22.15-.6.53a13 13 0 0 0-1.92 2.35c-1 1.54-2.02 3.73-2.52 6.7A4.5 4.5 0 1 1 22.5 27m-13 0A4.5 4.5 0 0 1 5 22.5c0-5.45 1.56-9.27 3.16-11.73a15 15 0 0 1 2.96-3.36l.23-.17.08-.06h.01v-.01a1 1 0 0 1 1.12 1.66l-.2.15q-.22.15-.6.53a13 13 0 0 0-1.92 2.35c-1 1.54-2.02 3.73-2.52 6.7A4.5 4.5 0 1 1 9.5 27"
]);
const $db6ad3fef28672ff$export$d3b49ac3e6d462d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextQuoteOpening32Regular', "32", [
    "M22.5 27a4.5 4.5 0 0 1-4.5-4.5c0-5.45 1.56-9.27 3.16-11.73a15 15 0 0 1 2.96-3.36l.23-.17.08-.06h.01v-.01a1 1 0 0 1 1.12 1.66l-.2.15q-.22.15-.6.53a13 13 0 0 0-1.92 2.35c-1 1.54-2.02 3.73-2.52 6.7A4.5 4.5 0 1 1 22.5 27m-13 0A4.5 4.5 0 0 1 5 22.5c0-5.45 1.56-9.27 3.16-11.73a15 15 0 0 1 2.96-3.36l.23-.17.08-.06h.01v-.01a1 1 0 0 1 1.12 1.66l-.2.15q-.22.15-.6.53a13 13 0 0 0-1.92 2.35c-1 1.54-2.02 3.73-2.52 6.7A4.5 4.5 0 1 1 9.5 27m13-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-13 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $db6ad3fef28672ff$export$da10523122668105 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortAscending16Filled', "16", [
    "M5.2 1.5a.75.75 0 0 0-1.4 0L1.8 7a.75.75 0 1 0 1.4.5L3.4 7H5.6l.19.5A.75.75 0 1 0 7.2 7zm-1.27 4 .57-1.56.57 1.56zM2 9.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 .6 1.21L4.27 13.5h1.97a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.6-1.21l2.57-3.29H2.75A.75.75 0 0 1 2 9.75M12.25 1c.41 0 .75.34.75.75v10.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V1.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$591ce69be9c8dc7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortAscending16Regular', "16", [
    "M5.46 1.3a.5.5 0 0 0-.92 0l-2.5 6a.5.5 0 0 0 .92.4l.7-1.7h2.67l.7 1.7a.5.5 0 1 0 .93-.4zM4.08 5 5 2.8 5.92 5zM2.5 9.5c0-.28.22-.5.5-.5h3.5a.5.5 0 0 1 .41.79L3.96 14H6.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.4-.79L5.53 10H3a.5.5 0 0 1-.5-.5m10-8.5c.28 0 .5.22.5.5v11.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L12 13.29V1.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$7e91d4fe27a98f3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortAscending20Filled', "20", [
    "M6.7 2.5a.75.75 0 0 0-1.4 0L3.03 9a.75.75 0 0 0 1.42.5l.34-1h2.4l.34 1A.75.75 0 0 0 8.96 9zM6 5.04 6.68 7H5.32zM4 11a.75.75 0 0 0 0 1.5h2.53l-3.14 4.3A.75.75 0 0 0 4 18h4a.75.75 0 0 0 0-1.5H5.47l3.14-4.3A.75.75 0 0 0 8 11zm10.25-9c.41 0 .75.34.75.75v12.57l1.45-1.58a.75.75 0 0 1 1.1 1.02l-2.75 3a.75.75 0 0 1-1.1 0l-2.75-3a.75.75 0 0 1 1.1-1.02l1.45 1.58V2.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$4e98afdc1b058983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortAscending20Regular', "20", [
    "M6.47 2.32a.5.5 0 0 0-.94 0l-2.75 7a.5.5 0 0 0 .94.36L4.38 8h3.24l.66 1.68a.5.5 0 0 0 .94-.36zM6 3.87 7.23 7H4.77zM4 11a.5.5 0 0 0 0 1h3.07l-3.49 5.22A.5.5 0 0 0 4 18h4a.5.5 0 0 0 0-1H4.93l3.49-5.22A.5.5 0 0 0 8 11zm10.5-9c.28 0 .5.22.5.5v13.8l2.15-2.15a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7L14 16.29V2.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$a4ff80cfd07a9df2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortAscending24Filled', "24", [
    "M7.98 2.67a1 1 0 0 0-1.9 0L3.3 10.74a1 1 0 1 0 1.89.66l.4-1.2h2.88l.41 1.2a1 1 0 0 0 1.9-.66zM6.29 8.21l.74-2.15.75 2.15zM3.75 14a1 1 0 0 1 1-1H10a1 1 0 0 1 .8 1.6L6.75 20H10a1 1 0 1 1 0 2H4.75a1 1 0 0 1-.8-1.6L8 15H4.75a1 1 0 0 1-1-1M17.5 2a1 1 0 0 1 1 1v15.59l1.8-1.8a1 1 0 0 1 1.4 1.42l-3.5 3.5a1 1 0 0 1-1.4 0l-3.5-3.5a1 1 0 0 1 1.4-1.42l1.8 1.8V3a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$6b27dd58d447c2e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortAscending24Regular', "24", [
    "M17.25 2c.41 0 .75.34.75.75v16.69l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.5 3.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V2.75c0-.41.34-.75.75-.75m-9.48.49a.75.75 0 0 0-1.4-.01l-3.32 8.5a.75.75 0 1 0 1.4.54l.79-2.02h3.55l.76 2.01a.75.75 0 0 0 1.4-.52zM5.82 8l1.23-3.15L8.23 8zM4 13.75c0-.41.34-.75.75-.75H9.5a.75.75 0 0 1 .63 1.15L6.11 20.5H9.5a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1-.63-1.15l4.02-6.35H4.75a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$3a704d4864fb7159 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortDescending16Filled', "16", [
    "M2 1.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 .6 1.21L4.27 5.5h1.97a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 0 1-.6-1.21L4.73 2.5H2.75A.75.75 0 0 1 2 1.75m3.2 6.74a.75.75 0 0 0-1.4 0l-2 5.5a.75.75 0 1 0 1.4.52L3.4 14H5.6l.19.5a.75.75 0 1 0 1.4-.5zM3.94 12.5l.57-1.56.57 1.56zM12.25 1c.41 0 .75.34.75.75v10.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V1.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$f61026ec94403d2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortDescending16Regular', "16", [
    "M2.5 1.5c0-.28.22-.5.5-.5h3.5a.5.5 0 0 1 .41.79L3.96 6H6.5a.5.5 0 1 1 0 1H3a.5.5 0 0 1-.41-.79L5.54 2H3a.5.5 0 0 1-.5-.5m2.96 6.8a.5.5 0 0 0-.92 0l-2.5 6a.5.5 0 1 0 .92.4l.7-1.7h2.67l.7 1.7a.5.5 0 0 0 .93-.4zM4.08 12 5 9.8l.92 2.2zM12.5 1c.28 0 .5.22.5.5v11.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L12 13.29V1.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$6ce0e9c2cabd213e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortDescending20Filled', "20", [
    "M4 2a.75.75 0 1 0 0 1.5h2.53L3.39 7.8A.75.75 0 0 0 4 9h4a.75.75 0 0 0 0-1.5H5.47l3.14-4.3A.75.75 0 0 0 8 2zm2.7 8.5a.75.75 0 0 0-1.4 0L3.03 17a.75.75 0 1 0 1.42.5l.34-1h2.4l.34 1a.75.75 0 1 0 1.42-.5zM6 13.04 6.68 15H5.32zM14.25 2c.41 0 .75.34.75.75v12.57l1.45-1.58a.75.75 0 0 1 1.1 1.02l-2.75 3a.75.75 0 0 1-1.1 0l-2.75-3a.75.75 0 0 1 1.1-1.02l1.45 1.58V2.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$80ab4d7f7215871d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortDescending20Regular', "20", [
    "M4 2a.5.5 0 0 0 0 1h3.07L3.58 8.22A.5.5 0 0 0 4 9h4a.5.5 0 1 0 0-1H4.93l3.49-5.22A.5.5 0 0 0 8 2zm2.47 8.32a.5.5 0 0 0-.94 0l-2.75 7a.5.5 0 1 0 .94.36L4.38 16h3.24l.66 1.68a.5.5 0 0 0 .94-.36zM6 11.87 7.23 15H4.77zM14.5 2c.28 0 .5.22.5.5v13.8l2.15-2.15a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7L14 16.29V2.5c0-.28.22-.5.5-.5"
]);
const $db6ad3fef28672ff$export$24a509b4811459df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortDescending24Filled', "24", [
    "M3.75 3a1 1 0 0 1 1-1H10a1 1 0 0 1 .8 1.6L6.75 9H10a1 1 0 1 1 0 2H4.75a1 1 0 0 1-.8-1.6L8 4H4.75a1 1 0 0 1-1-1m4.23 9.67a1 1 0 0 0-1.9 0L3.3 20.74a1 1 0 0 0 1.89.66l.4-1.2h2.88l.41 1.2a1 1 0 0 0 1.9-.66zm-1.69 5.54.74-2.15.75 2.15zM17.5 2a1 1 0 0 1 1 1v15.59l1.8-1.8a1 1 0 0 1 1.4 1.42l-3.5 3.5a1 1 0 0 1-1.4 0l-3.5-3.5a1 1 0 0 1 1.4-1.42l1.8 1.8V3a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$b21d4dba95b5c5f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSortDescending24Regular', "24", [
    "M4 2.75c0-.41.34-.75.75-.75H9.5a.75.75 0 0 1 .63 1.15L6.11 9.5H9.5a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1-.63-1.15L8.14 3.5H4.75A.75.75 0 0 1 4 2.75m2.37 9.73a.75.75 0 0 1 1.4 0l3.18 8.5a.75.75 0 0 1-1.4.53l-.76-2.01H5.24l-.8 2.02a.75.75 0 0 1-1.39-.54zM8.23 18l-1.18-3.15L5.82 18zm9.02-16c.41 0 .75.34.75.75v16.69l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.5 3.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V2.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$8d2947d6a603619d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextStrikethrough16Filled', "16", [
    "M5.55 5.3q0-.64.67-1.18a3 3 0 0 1 1.88-.57c1.12 0 2.04.52 2.36 1.05a.75.75 0 1 0 1.28-.8c-.68-1.07-2.16-1.75-3.64-1.75-1.05 0-2.03.32-2.78.87A3 3 0 0 0 4.05 5.3q.01.8.42 1.45H6.7c-.77-.36-1.14-.95-1.14-1.45M2 8.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5h-1.64q.34.6.34 1.3c0 .99-.53 1.82-1.28 2.37-.74.56-1.72.88-2.77.88-1.49 0-2.99-.68-3.66-1.89a.75.75 0 1 1 1.32-.72c.33.6 1.23 1.11 2.34 1.11.75 0 1.42-.23 1.87-.58s.68-.76.68-1.17c0-.44-.28-.94-.86-1.3H2.75A.75.75 0 0 1 2 8.75"
]);
const $db6ad3fef28672ff$export$f78fc24ebdca707 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextStrikethrough16Regular', "16", [
    "M5 5.1q.01-.84.84-1.46C6.39 3.25 7.19 3 8.1 3c1.3 0 2.38.56 2.76 1.24a.5.5 0 0 0 .88-.48C11.12 2.64 9.6 2 8.1 2c-1.09 0-2.1.3-2.84.83A2.8 2.8 0 0 0 4 5.1c0 .72.3 1.37.79 1.9H6.5C5.55 6.6 5 5.83 5 5.1M13.5 8a.5.5 0 0 1 0 1h-2.34c.52.5.84 1.15.84 1.9 0 .9-.51 1.69-1.26 2.23C10 13.67 9 14 7.9 14c-1.62 0-3-.65-3.72-1.72a.5.5 0 0 1 .84-.56C5.5 12.45 6.52 13 7.9 13c.9 0 1.7-.27 2.25-.68.56-.4.85-.92.85-1.42 0-.78-.63-1.53-1.78-1.9H2.5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$f7c25f62f1da4c70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextStrikethrough20Filled', "20", [
    "M6.25 3.7c1-.7 2.33-1.2 3.75-1.2a6.4 6.4 0 0 1 5.1 2.3.75.75 0 0 1-1.2.9A5 5 0 0 0 10 4c-1.08 0-2.12.38-2.88.92C6.33 5.5 6 6.1 6 6.5c0 .78.38 1.29 1.11 1.71q.27.15.59.29H5.16a3.2 3.2 0 0 1-.66-2c0-1.1.8-2.11 1.75-2.8M16.5 10a.75.75 0 0 1 0 1.5h-1.66c.4.52.66 1.18.66 2 0 1.36-.87 2.38-1.91 3.01a7 7 0 0 1-3.59.99 8 8 0 0 1-3-.5 5 5 0 0 1-2.12-1.83.75.75 0 1 1 1.24-.84c.43.65.9 1.05 1.48 1.3.6.25 1.35.37 2.4.37.97 0 2.02-.28 2.8-.76q1.2-.76 1.2-1.74c0-.78-.38-1.29-1.11-1.71a5 5 0 0 0-.59-.29H3.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$d7ed698df5be864 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextStrikethrough20Regular', "20", [
    "M6.53 4.03A6 6 0 0 1 10 3a6.2 6.2 0 0 1 4.9 2.2.5.5 0 0 1-.8.6A5.2 5.2 0 0 0 10 4c-1.15 0-2.18.35-2.9.85C6.36 5.35 6 5.98 6 6.5c0 .9.43 1.48 1.17 1.93q.54.32 1.25.57H6.23A3 3 0 0 1 5 6.5c0-.98.64-1.86 1.53-2.47M16.5 10a.5.5 0 0 1 0 1h-2.73A3 3 0 0 1 15 13.5c0 1.23-.72 2.12-1.68 2.68-.94.56-2.16.82-3.32.82a7 7 0 0 1-2.9-.48 4.6 4.6 0 0 1-2.02-1.74.5.5 0 0 1 .84-.56c.45.68.96 1.11 1.58 1.38.64.28 1.44.4 2.5.4 1.03 0 2.06-.24 2.82-.68.74-.44 1.18-1.05 1.18-1.82 0-.9-.43-1.48-1.17-1.93q-.54-.32-1.25-.57H3.5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$ceb9741ddb089089 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextStrikethrough24Filled', "24", [
    "M13.85 11.5h5.65a1 1 0 0 1 0 2h-2.39q1 1.16 1 2.68c0 2.93-3.28 4.92-7.03 4.48-2.33-.27-3.97-1.22-4.83-2.83-.26-.49-.2-1.01.25-1.33.46-.32 1.26-.1 1.52.39q.78 1.5 3.29 1.79c2.59.3 4.8-.91 4.8-2.5 0-1.1-.55-1.94-2.1-2.68H5a1 1 0 1 1 0-2h8.85M6.99 9.7l-.3-.51q-.47-.9-.44-1.84c.16-2.96 2.94-4.71 6.6-4.29q3.42.4 5.15 2.49a1 1 0 0 1-.15 1.4 1 1 0 0 1-1.4-.1q-1.2-1.5-3.82-1.8c-2.57-.3-4.38.72-4.38 2.32 0 .72.24 1.22.77 1.81q.33.39 1.26.82H7.2q-.16-.26-.2-.3"
]);
const $db6ad3fef28672ff$export$4e0e821de843d82b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextStrikethrough24Regular', "24", [
    "M4.75 12h14.5a.75.75 0 0 1 .1 1.5h-3.07q1.32 1.23 1.33 2.93c0 2.83-3.23 4.64-6.75 4.24q-3.38-.39-4.64-2.7a.75.75 0 0 1 1.33-.71c.57 1.06 1.7 1.7 3.48 1.92 2.74.31 5.08-1 5.08-2.75 0-1.17-.8-2.12-2.56-2.88l-.12-.05H4.75a.75.75 0 0 1-.74-.65l-.01-.1c0-.38.28-.7.65-.74zh14.5zm1.51-3.88c.15-2.83 2.82-4.47 6.32-4.06q3.3.38 4.99 2.41a.75.75 0 1 1-1.16.96q-1.26-1.56-4-1.88c-2.72-.31-4.65.8-4.65 2.57 0 .78.23 1.35.83 1.98l.13.14.25.24.03.02H7.08l-.02-.04c-.15-.2-.86-1.2-.8-2.34"
]);
const $db6ad3fef28672ff$export$84465bc5da5e2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSubscript16Filled', "16", [
    "M2 2.94A.75.75 0 0 1 3.06 3L6.5 6.87 9.94 3a.75.75 0 0 1 1.12 1L7.5 8l2.38 2.67q-.13.4-.13.83.02.73.49 1.21l-.2.39-.1-.1L6.5 9.13 3.06 13a.75.75 0 1 1-1.12-1L5.5 8 1.94 4A.75.75 0 0 1 2 2.94m10.25 8.56a.25.25 0 1 1 .5 0q0 .15-.03.2l-.09.12q-.05.07-.2.16l-.15.1h-.01l-.2.13a2.8 2.8 0 0 0-1.32 2.29c0 .41.34.75.75.75h2a.75.75 0 0 0 0-1.5h-.93a2 2 0 0 1 .45-.37c.18-.1.46-.29.67-.5.33-.32.56-.77.56-1.38a1.75 1.75 0 1 0-3.5 0 .75.75 0 0 0 1.5 0"
]);
const $db6ad3fef28672ff$export$6b834cc5497c81f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSubscript16Regular', "16", [
    "M2.17 3.13a.5.5 0 0 1 .7.04L6.5 7.25l3.63-4.08a.5.5 0 0 1 .74.66L7.17 8l2.85 3.2-.02.3c0 .47.22.9.56 1.17q-.1.15-.18.31a.5.5 0 0 1-.25-.15L6.5 8.75l-3.63 4.08a.5.5 0 1 1-.74-.66L5.83 8l-3.7-4.17a.5.5 0 0 1 .04-.7M12 11.5a.5.5 0 0 1 1 0q-.01.37-.19.5-.14.14-.35.26l-.24.15C11.36 13 11 13.77 11 14.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-1.4q.16-.39.68-.76l.13-.08c.17-.11.42-.27.6-.45.29-.29.49-.67.49-1.21a1.5 1.5 0 0 0-3 0 .5.5 0 0 0 1 0"
]);
const $db6ad3fef28672ff$export$ec5f9eb28be7175a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSubscript20Filled', "20", [
    "M13.78 4.99A.75.75 0 0 0 12.64 4L8.5 8.85 4.35 4A.75.75 0 1 0 3.22 5L7.52 10l-4.3 5.01a.75.75 0 0 0 1.13.98l4.15-4.84 3.85 4.5c.13-.55.38-.99.66-1.34q-.54-.37-.71-1.03L9.49 10zm1.55 7.26c-.3 0-.58.3-.58.61a.75.75 0 0 1-1.5 0 2.12 2.12 0 0 1 3.88-1.17c.42.64.42 1.46-.04 2.24-.23.4-.55.69-.84.92l-.44.32-.06.05-.33.23q-.2.15-.35.3h1.62a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1-.75-.75c0-1.16.69-1.8 1.27-2.25l.37-.26.06-.04.37-.28q.34-.27.48-.5c.21-.36.14-.57.08-.66a.6.6 0 0 0-.55-.26"
]);
const $db6ad3fef28672ff$export$9a7ffa7827d16aef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSubscript20Regular', "20", [
    "M13.54 4.12c.2.18.23.5.05.7L9.16 10l4.08 4.77q-.29.43-.42 1.04L8.5 10.77l-4.34 5.06a.5.5 0 1 1-.75-.66L7.84 10 3.41 4.83a.5.5 0 1 1 .75-.66L8.5 9.23l4.33-5.06a.5.5 0 0 1 .7-.05M15.58 12c-.46 0-.83.42-.83.86a.5.5 0 0 1-1 0 1.87 1.87 0 0 1 3.42-1.04c.36.55.37 1.27-.04 1.98q-.34.53-.79.86l-.42.3-.06.05-.34.24q-.49.34-.67.75h2.1a.5.5 0 1 1 0 1h-2.7a.5.5 0 0 1-.5-.5c0-1.04.6-1.62 1.17-2.05l.36-.26.06-.04.38-.28q.36-.27.55-.58c.25-.43.19-.73.07-.92a.9.9 0 0 0-.76-.37"
]);
const $db6ad3fef28672ff$export$9af0b646970d8055 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSubscript24Filled', "24", [
    "M16.76 5.65a1 1 0 0 0-1.52-1.3L10 10.46 4.76 4.35a1 1 0 1 0-1.52 1.3L8.68 12l-5.44 6.35a1 1 0 0 0 1.52 1.3L10 13.54l5.07 5.91c.15-.83.52-1.47.94-1.97L11.31 12zm1.98 9.1c-.4 0-.74.36-.74.77a1 1 0 1 1-2 0 2.78 2.78 0 0 1 5.1-1.54c.54.84.54 1.92-.06 2.94-.3.52-.72.9-1.1 1.2q-.3.24-.57.42l-.08.06-.83.65h2a1 1 0 0 1 0 2H17a1 1 0 0 1-1-1c0-1.52.9-2.37 1.66-2.94l.48-.35.08-.05.48-.35q.45-.35.62-.66c.27-.46.18-.71.1-.83a.8.8 0 0 0-.68-.32"
]);
const $db6ad3fef28672ff$export$b237a40e26fa7b42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSubscript24Regular', "24", [
    "M16.49 4.43c.31.27.35.74.08 1.06L10.99 12l5.03 5.87q-.47.6-.68 1.51L10 13.15 4.57 19.5a.75.75 0 0 1-1.14-.98L9.01 12 3.43 5.49a.75.75 0 0 1 1.14-.98L10 10.85l5.43-6.34a.75.75 0 0 1 1.06-.08m1.26 11.1c0-.54.44-1.03.99-1.03.4 0 .73.2.89.43.14.21.22.57-.1 1.1a3 3 0 0 1-.68.72l-.49.37-.07.05-.48.34c-.74.56-1.56 1.34-1.56 2.74 0 .41.34.75.75.75h3.45a.75.75 0 0 0 0-1.5h-2.51q.24-.4.78-.8l.43-.3.08-.06q.27-.19.55-.41c.38-.3.76-.66 1.05-1.14.56-.95.55-1.92.06-2.67a2.53 2.53 0 0 0-4.64 1.4.75.75 0 0 0 1.5 0"
]);
const $db6ad3fef28672ff$export$2cb8dc21632a1b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSuperscript16Filled', "16", [
    "M12.25 2.5a.25.25 0 1 1 .5 0q0 .15-.03.2l-.09.12q-.05.07-.2.16l-.15.1h-.01l-.2.13a2.8 2.8 0 0 0-1.32 2.29c0 .41.34.75.75.75h2a.75.75 0 0 0 0-1.5h-.93a2 2 0 0 1 .45-.37c.18-.1.46-.29.67-.5.33-.32.56-.77.56-1.38a1.75 1.75 0 1 0-3.5 0 .75.75 0 0 0 1.5 0m-2.01 1.21a3.5 3.5 0 0 0-.49 1.76L7.5 8l3.56 4a.75.75 0 0 1-1.12 1L6.5 9.13 3.06 13a.75.75 0 1 1-1.12-1L5.5 8 1.94 4a.75.75 0 1 1 1.12-1L6.5 6.87 9.85 3.1q.13.35.39.61"
]);
const $db6ad3fef28672ff$export$d483376380dd7c46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSuperscript16Regular', "16", [
    "M12 2.5a.5.5 0 0 1 1 0c0 .26-.08.4-.19.5q-.14.14-.35.26l-.24.15C11.36 4 11 4.77 11 5.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-1.4a1.8 1.8 0 0 1 .81-.84c.17-.11.42-.27.6-.45.29-.29.49-.67.49-1.21a1.5 1.5 0 0 0-3 0 .5.5 0 0 0 1 0m-2 2q0-.76.36-1.48a1 1 0 0 0-.23.15L6.5 7.25 2.87 3.17a.5.5 0 0 0-.74.66L5.83 8l-3.7 4.17a.5.5 0 0 0 .74.66L6.5 8.75l3.63 4.08a.5.5 0 1 0 .74-.66L7.17 8l2.86-3.22z"
]);
const $db6ad3fef28672ff$export$c7bfa590d2e7c259 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSuperscript20Filled', "20", [
    "M15.33 3.25c-.3 0-.58.29-.58.61a.75.75 0 0 1-1.5 0 2.12 2.12 0 0 1 3.88-1.17c.42.64.42 1.46-.04 2.24-.23.4-.55.69-.84.92l-.44.32-.06.05-.33.23q-.2.15-.35.3h1.62a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1-.75-.75c0-1.16.69-1.8 1.27-2.25L14.9 5l.06-.04.37-.28q.34-.26.48-.5c.21-.36.14-.57.08-.66a.6.6 0 0 0-.55-.26M9.5 10l2.85-3.33c.13-.56.39-1 .67-1.36a1.8 1.8 0 0 1-.68-.93L8.5 8.85 4.35 4A.75.75 0 1 0 3.22 5L7.52 10l-4.3 5.01a.75.75 0 1 0 1.13.98l4.15-4.84L12.64 16a.75.75 0 1 0 1.14-.98z"
]);
const $db6ad3fef28672ff$export$653e1da141f6ed24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSuperscript20Regular', "20", [
    "M15.58 3c-.46 0-.83.42-.83.86a.5.5 0 0 1-1 0 1.87 1.87 0 0 1 3.42-1.04c.36.55.37 1.27-.04 1.98q-.34.53-.79.86l-.42.3-.06.05-.34.24q-.49.34-.67.75h2.1a.5.5 0 1 1 0 1h-2.7a.5.5 0 0 1-.5-.5c0-1.04.6-1.62 1.17-2.05l.36-.26.06-.04.38-.28q.36-.28.55-.58c.25-.43.19-.73.07-.92a.9.9 0 0 0-.76-.37M12.8 4.22q.15.54.58.86L9.16 10l4.43 5.17a.5.5 0 1 1-.76.66L8.5 10.77l-4.34 5.06a.5.5 0 0 1-.75-.66L7.84 10 3.41 4.83a.5.5 0 1 1 .75-.66L8.5 9.23z"
]);
const $db6ad3fef28672ff$export$317effca519ceebe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSuperscript24Filled', "24", [
    "M18.74 3.75c-.4 0-.74.36-.74.77a1 1 0 1 1-2 0 2.78 2.78 0 0 1 5.1-1.54c.54.84.54 1.92-.06 2.94-.3.52-.72.9-1.1 1.2q-.3.24-.57.42l-.08.06-.42.3q-.24.19-.41.35h2a1 1 0 0 1 0 2H17a1 1 0 0 1-1-1c0-1.52.9-2.37 1.66-2.94l.48-.35.08-.05.48-.35q.45-.35.62-.66c.27-.46.18-.71.1-.83a.8.8 0 0 0-.68-.32M11.32 12l4.4-5.13q.2-.3.42-.54A2 2 0 0 1 15 4.63l-5 5.83-5.24-6.11a1 1 0 1 0-1.52 1.3L8.68 12l-5.44 6.35a1 1 0 0 0 1.52 1.3L10 13.54l5.24 6.11a1 1 0 0 0 1.52-1.3z"
]);
const $db6ad3fef28672ff$export$1ff4a792552d0111 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextSuperscript24Regular', "24", [
    "M18.74 3.5c-.55 0-.99.5-.99 1.02a.75.75 0 0 1-1.5 0 2.53 2.53 0 0 1 4.64-1.4c.49.75.5 1.72-.06 2.67-.29.48-.67.85-1.05 1.14q-.28.22-.55.41l-.08.06-.43.3q-.54.4-.78.8h2.51a.75.75 0 0 1 0 1.5H17a.75.75 0 0 1-.75-.75c0-1.4.82-2.18 1.56-2.74l.48-.34.07-.05.5-.37q.45-.35.68-.72c.3-.53.23-.89.09-1.1a1 1 0 0 0-.9-.43m-3.48 1.21c.06.56.38 1.04.85 1.32L10.99 12l5.58 6.51a.75.75 0 1 1-1.14.98L10 13.15 4.57 19.5a.75.75 0 0 1-1.14-.98L9.01 12 3.43 5.49a.75.75 0 1 1 1.14-.98L10 10.85z"
]);
const $db6ad3fef28672ff$export$44cc1e7334c43a43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT12Filled', "12", [
    "M2 2.75c0-.41.34-.75.75-.75h6c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V3.5H6.5v5h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5H5v-5H3.5v.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$b9e77fc602080bd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT12Regular', "12", [
    "M2 2.5c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5V4a.5.5 0 0 1-1 0V3H6v6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H5V3H3v1a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$50f5e001788fb7cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT16Filled', "16", [
    "M2.5 2.75c0-.41.34-.75.75-.75h9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V3.5h-3v9h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H7v-9H4v.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$be7de000c3a0680d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT16Regular', "16", [
    "M3 2.5c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V3H8v10h1a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1h1V3H4v1.5a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$a887b7f87af89ba6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT20Filled', "20", [
    "M4 3.75c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V4.5h-3.5v11h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H9v-11H5.5v.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$b55e341972ec275d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT20Regular', "20", [
    "M4 3.5c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V4h-4v12h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H9V4H5v1.5a.5.5 0 0 1-1 0z"
]);
const $db6ad3fef28672ff$export$3bad464e7c5e6088 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT24Filled', "24", [
    "M4.75 5a1 1 0 0 1 1-1h12.5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V6H13v12h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1V6H6.75v1a1 1 0 0 1-2 0z"
]);
const $db6ad3fef28672ff$export$8a52f564b6a949f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT24Regular', "24", [
    "M5 4.75c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0V5.5h-4.75v13h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-13H6.5v1.25a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$169337bcd9dc7a78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT28Filled', "28", [
    "M5 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V6h-6v16h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1V6H7v2a1 1 0 0 1-2 0z"
]);
const $db6ad3fef28672ff$export$dff486c7c2560c5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT28Regular', "28", [
    "M5 4.75c0-.41.34-.75.75-.75h16.5c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0V5.5h-6.75v17h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-17H6.5v2.75a.75.75 0 0 1-1.5 0z"
]);
const $db6ad3fef28672ff$export$f5a4c167526603b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT32Filled', "32", [
    "M6 5.25C6 4.56 6.56 4 7.25 4h17.5c.69 0 1.25.56 1.25 1.25v3.5a1.25 1.25 0 1 1-2.5 0V6.5h-6.25v19h1.5a1.25 1.25 0 1 1 0 2.5h-5.5a1.25 1.25 0 1 1 0-2.5h1.5v-19H8.5v2.25a1.25 1.25 0 1 1-2.5 0z"
]);
const $db6ad3fef28672ff$export$b8ec0301ca15e460 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT32Regular', "32", [
    "M6 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6h-7v20h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2V6H8v3a1 1 0 0 1-2 0z"
]);
const $db6ad3fef28672ff$export$25c09d2db8f5864f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT48Filled', "48", [
    "M10 9.5c0-.83.67-1.5 1.5-1.5h25c.83 0 1.5.67 1.5 1.5v4a1.5 1.5 0 0 1-3 0V11h-9.5v26h3a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1 0-3h3V11H13v2.5a1.5 1.5 0 0 1-3 0z"
]);
const $db6ad3fef28672ff$export$831d86b6c972302c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextT48Regular', "48", [
    "M10 9.25c0-.69.56-1.25 1.25-1.25h25.5c.69 0 1.25.56 1.25 1.25V14a1.25 1.25 0 1 1-2.5 0v-3.5H25.25v27h3.5a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5h3.5v-27H12.5V14a1.25 1.25 0 1 1-2.5 0z"
]);
const $db6ad3fef28672ff$export$e17be46f5a21d92b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextTTag16Filled', "16", [
    "M12 4.75v-1a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0V4.5h1.75v7H7A.75.75 0 0 0 7 13h2a.75.75 0 0 0 0-1.5h-.25v-7h1.75v.25a.75.75 0 0 0 1.5 0M4.25 6.69a.75.75 0 0 0-1.06.06L1.19 9a.75.75 0 0 0 0 1l2 2.25a.75.75 0 0 0 1.06.06.75.75 0 0 0 .06-1.06L2.75 9.5l1.56-1.75a.75.75 0 0 0-.06-1.06m8.56.06 2 2.25c.25.29.25.71 0 1l-2 2.25a.75.75 0 1 1-1.12-1l1.56-1.75-1.56-1.75a.75.75 0 1 1 1.12-1"
]);
const $db6ad3fef28672ff$export$ff022117a2e69b51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextTTag16Regular', "16", [
    "M4 3.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0V4H8.5v8H9a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1h.5V4H5v.5a.5.5 0 0 1-1 0zm.35 3.15c.2.2.2.5 0 .7L2.21 9.5l2.14 2.15a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5c.2-.2.5-.2.7 0m10.5 2.5-2.5-2.5a.5.5 0 0 0-.7.7l2.14 2.15-2.14 2.15a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$f07934f421eed027 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline16Filled', "16", [
    "M4 13.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75M4.75 2c.41 0 .75.34.75.75V8a2.5 2.5 0 1 0 5 0V2.75a.75.75 0 0 1 1.5 0V8a4 4 0 1 1-8 0V2.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$7fc00da0ddb54574 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline16Regular', "16", [
    "M4.5 2c.28 0 .5.22.5.5V8c0 1.62 1.38 3 3 3s3-1.38 3-3V2.5a.5.5 0 0 1 1 0V8c0 2.18-1.82 4-4 4s-4-1.82-4-4V2.5c0-.28.22-.5.5-.5M4 13.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$1d3837927272461 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline20Filled', "20", [
    "M6.5 3.75a.75.75 0 0 0-1.5 0V9c0 1.37.34 2.74 1.16 3.78A4.7 4.7 0 0 0 10 14.5c1.7 0 3-.65 3.84-1.72A6 6 0 0 0 15 9V3.75a.75.75 0 0 0-1.5 0V9a4.6 4.6 0 0 1-.84 2.85C12.13 12.53 11.3 13 10 13c-1.3 0-2.13-.47-2.66-1.15A4.6 4.6 0 0 1 6.5 9zM5.75 15.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$15df9aa5759fa328 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline20Regular', "20", [
    "M6 3.5a.5.5 0 0 0-1 0v6.45A5 5 0 0 0 10 15c2.77 0 5-2.26 5-5.05V3.5a.5.5 0 0 0-1 0v6.45C14 12.2 12.2 14 10 14s-4-1.8-4-4.05zm-1 13c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$e6fd8a9b94307c1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline24Filled', "24", [
    "M6 4.5a1 1 0 0 1 2 0v6c0 3.46 1.32 5 4.25 5s4.25-1.54 4.25-5v-6a1 1 0 1 1 2 0v6c0 4.54-2.18 7-6.25 7S6 15.04 6 10.5zM7 21a1 1 0 1 1 0-2h10.5a1 1 0 1 1 0 2z"
]);
const $db6ad3fef28672ff$export$223c53101c3f111e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline24Regular', "24", [
    "M6.75 19h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zh10.5zm10.5-15c.38 0 .7.28.74.65l.01.1v6c0 4.4-2.06 6.75-6 6.75-3.86 0-5.91-2.26-6-6.47V4.75a.75.75 0 0 1 1.5-.1v6.1C7.5 14.35 8.93 16 12 16c2.98 0 4.43-1.56 4.5-4.98V4.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$9fc8948f8304b2eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline28Filled', "28", [
    "M20 22a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zM19 4a1 1 0 0 1 1 1v9a6 6 0 0 1-12 0V5a1 1 0 0 1 2 0v9a4 4 0 0 0 8 0V5a1 1 0 0 1 1-1"
]);
const $db6ad3fef28672ff$export$b02e450516c5cbc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderline28Regular', "28", [
    "M20.25 22.5a.75.75 0 0 1 0 1.5H7.75a.75.75 0 0 1 0-1.5zm-1-18.5c.41 0 .75.34.75.75V14a6 6 0 0 1-12 0V4.75a.75.75 0 1 1 1.5 0V14a4.5 4.5 0 0 0 9 0V4.75c0-.41.34-.75.75-.75"
]);
const $db6ad3fef28672ff$export$c105a2985fa5a636 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineCharacterU16Filled', "16", [
    "M6 2.75a.75.75 0 0 0-1.5 0V7.5a3.5 3.5 0 1 0 7 0V2.75a.75.75 0 0 0-1.5 0V7.5a2 2 0 1 1-4 0zM4.75 12.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$7c2b7646152f62f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineCharacterU16Regular', "16", [
    "M5.5 2.5a.5.5 0 0 0-1 0v5a3.5 3.5 0 1 0 7 0v-5a.5.5 0 0 0-1 0v5a2.5 2.5 0 0 1-5 0zM4.5 13a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$93321cfb0f20acb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineCharacterU20Filled', "20", [
    "M7 3.75a.75.75 0 0 0-1.5 0V9.5a4.5 4.5 0 1 0 9 0V3.75a.75.75 0 0 0-1.5 0V9.5a3 3 0 1 1-6 0zM5.75 15.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$4d9c482ddbdbed0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineCharacterU20Regular', "20", [
    "M7 3.5a.5.5 0 0 0-1 0V10a4 4 0 0 0 8 0V3.5a.5.5 0 0 0-1 0V10a3 3 0 1 1-6 0zM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$3f77209a93d80fae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineCharacterU24Filled', "24", [
    "M9 5a1 1 0 0 0-2 0v6.5a5 5 0 0 0 10 0V5a1 1 0 1 0-2 0v6.5a3 3 0 1 1-6 0zM7 18a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$fa92b04a24c86e85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineCharacterU24Regular', "24", [
    "M8.5 4.75a.75.75 0 0 0-1.5 0V12a5 5 0 0 0 10 0V4.75a.75.75 0 0 0-1.5 0V12a3.5 3.5 0 1 1-7 0zM6.75 18.5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$a8fef09d8523a48f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineDouble20Filled', "20", [
    "M16.97 2.98q.78.38 1.17 1.46a.75.75 0 1 1-1.4.51c-.18-.47-.35-.59-.44-.63-.12-.06-.27-.07-.58-.07a.7.7 0 0 0-.5.17q-.18.15-.3.5a3 3 0 0 0-.17.88c0 .41 0 .9.16 1.3q.11.27.3.42.16.17.6.23c.08 0 .28 0 .48-.07a.8.8 0 0 0 .46-.45.75.75 0 0 1 1.37.61c-.63 1.42-2.03 1.45-2.48 1.4a2.6 2.6 0 0 1-1.4-.56c-.35-.3-.58-.68-.72-1.04a5 5 0 0 1-.27-1.8v-.08l.03-.4c.03-.26.1-.61.23-.97.14-.36.35-.77.72-1.09q.56-.53 1.49-.55h.03c.28 0 .75 0 1.22.23m-11.58.27A.75.75 0 0 0 4 3.23l-1.94 5a.75.75 0 1 0 1.4.54l.1-.27h2.11l.1.25a.75.75 0 0 0 1.4-.5zM5.13 7h-1l.53-1.34zM8 3.5v5c0 .41.34.75.75.75h1.75c.24 0 .73-.04 1.2-.3.52-.3.92-.87.92-1.7q0-.64-.28-1.12a2 2 0 0 0-.29-.35q.23-.41.24-1.02t-.25-1.08a1.7 1.7 0 0 0-.66-.67c-.46-.26-.95-.26-1.12-.26H8.75A.75.75 0 0 0 8 3.5m2.5 4.25h-1v-1h.94q.3-.01.51.08.07.03.1.08.06.04.07.33-.01.25-.06.3a.3.3 0 0 1-.12.1 1 1 0 0 1-.44.11m-.88-2.5H9.5v-1h.75q.25-.01.4.07l.08.08q.05.05.06.36 0 .26-.06.3a.3.3 0 0 1-.1.1 1 1 0 0 1-.35.09zm-8.12 7c0-.41.34-.75.75-.75h15.5a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1-.75-.75m.75 3.25a.75.75 0 0 0 0 1.5h15.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$c9099c0e5e72a181 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineDouble20Regular', "20", [
    "M4.94 3c.21 0 .4.14.47.33l1.77 5a.5.5 0 0 1-.94.34L6 8H3.73l-.26.68a.5.5 0 1 1-.94-.36l1.94-5A.5.5 0 0 1 4.94 3m-.02 1.94L4.12 7h1.53zm12.49-.41c-.25-.69-.6-1.1-1.06-1.33-.4-.2-.83-.2-1.1-.2h-.03c-.55 0-1 .19-1.33.49-.32.29-.52.65-.64.99A4 4 0 0 0 13 5.77v.05c0 .39 0 1.09.25 1.73.13.33.33.67.66.93q.48.41 1.25.5c.42.05 1.67.02 2.23-1.24a.5.5 0 1 0-.9-.4c-.3.64-.94.68-1.22.65a1.3 1.3 0 0 1-.73-.28 1.3 1.3 0 0 1-.36-.52A4 4 0 0 1 14 5.8V5.8l.02-.28q.04-.31.16-.68.14-.37.38-.6a1 1 0 0 1 .66-.23c.3 0 .5 0 .7.1.15.08.36.25.55.77a.5.5 0 1 0 .94-.34m-5.94 1.3q.31-.4.32-1.07 0-.57-.22-.96a1.4 1.4 0 0 0-.56-.57c-.4-.23-.84-.23-1-.23H8.5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1.75c.22 0 .66-.03 1.07-.27.45-.26.8-.74.8-1.49q0-.57-.25-.98a2 2 0 0 0-.4-.42m-.95-1.73q.1.06.18.18a1 1 0 0 1 .1.48c0 .4-.16.54-.28.62-.17.1-.38.12-.5.12H9V4h1q.26-.02.52.1M9.36 6.5h.83c.18 0 .43 0 .62.1q.14.07.2.18.1.12.1.46c0 .38-.14.54-.3.62-.18.11-.42.14-.56.14H9V6.5zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$698462f7cfb6a8b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineDouble24Filled', "24", [
    "M22.2 4.97a3.2 3.2 0 0 0-1.56-1.92c-.61-.3-1.24-.3-1.6-.3H19c-.8 0-1.47.28-1.96.72-.48.43-.77.96-.94 1.43a6 6 0 0 0-.35 1.8v.09c0 .5 0 1.47.35 2.36.19.48.49.97.96 1.36q.73.6 1.83.73c.6.07 2.43.03 3.27-1.82a1 1 0 0 0-1.82-.82c-.16.34-.38.5-.6.58-.25.09-.51.09-.63.08-.4-.05-.62-.17-.77-.3a1.3 1.3 0 0 1-.38-.54 5 5 0 0 1-.21-1.67l.03-.34q.04-.38.19-.8.16-.44.4-.64a1 1 0 0 1 .63-.22c.4 0 .6.02.76.1.1.05.33.2.55.8a1 1 0 1 0 1.88-.68M14.5 6.71q.31-.54.32-1.33 0-.8-.33-1.42-.35-.61-.86-.88a3 3 0 0 0-1.45-.33H10a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2.38c.3 0 .96-.04 1.58-.37a2.4 2.4 0 0 0 1.29-2.25q0-.84-.37-1.46-.16-.27-.37-.46m-1.85-1.88q.05.02.08.08a1 1 0 0 1 .09.47 1 1 0 0 1-.08.39.3.3 0 0 1-.12.12 1 1 0 0 1-.46.11H11V4.75h1.16q.34-.01.5.08M12.17 8h.2q.4-.02.67.1.1.04.13.1.06.06.08.43c0 .2-.05.3-.07.34a.4.4 0 0 1-.16.14c-.2.1-.47.14-.64.14H11V8zM5.03 2.75a1 1 0 0 1 .93.67l2.3 6.5a1 1 0 1 1-1.88.66l-.19-.53H3.65l-.22.56a1 1 0 1 1-1.86-.72l2.51-6.5a1 1 0 0 1 .95-.64m-.05 3.88-.56 1.42h1.06zM1.5 15a1 1 0 0 1 1-1h19a1 1 0 1 1 0 2h-19a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h19a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$3bb506d3d512e8a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextUnderlineDouble24Regular', "24", [
    "M20.53 3.27q.93.43 1.43 1.79a.75.75 0 1 1-1.42.5c-.23-.64-.5-.85-.67-.94-.22-.1-.47-.12-.87-.12-.38 0-.62.12-.8.28q-.3.27-.47.73a4 4 0 0 0-.23 1.23v.01c0 .53 0 1.2.23 1.76q.15.4.45.65c.19.16.47.3.9.34.35.04 1.13-.02 1.49-.8a.75.75 0 1 1 1.36.62c-.77 1.7-2.46 1.74-3.01 1.68a3 3 0 0 1-1.7-.68 3 3 0 0 1-.89-1.26A6 6 0 0 1 16 6.78V6.7l.04-.51c.04-.32.12-.76.29-1.2.17-.45.43-.94.87-1.33.45-.4 1.05-.66 1.8-.66h.04c.36 0 .93 0 1.49.27M5.28 3c.31 0 .59.2.7.5l2.3 6.5a.75.75 0 0 1-1.41.5l-.34-.95h-2.7l-.38.97a.75.75 0 0 1-1.4-.54l2.52-6.5c.11-.3.4-.48.7-.48m-.04 2.9L4.4 8.06H6zm9.34-.52q-.01.86-.39 1.38.27.21.47.54.34.54.34 1.33 0 .74-.34 1.27t-.82.76a3 3 0 0 1-1.46.34H9.75a.75.75 0 0 1-.75-.75v-6.5c0-.41.34-.75.75-.75h2.43c.22 0 .8 0 1.34.3.29.16.57.41.76.78q.3.54.3 1.3m-2.42-.88H10.5v1.75h1.66c.15 0 .4-.03.6-.15a1 1 0 0 0 .2-.2q.1-.14.12-.52-.02-.47-.12-.59a.4.4 0 0 0-.18-.18q-.27-.13-.62-.11m.22 5c.18 0 .5-.03.75-.17q.17-.09.26-.22a1 1 0 0 0 .11-.48q-.02-.43-.12-.55a.5.5 0 0 0-.22-.2 2 2 0 0 0-.78-.13H10.5V9.5zM2 15.25c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m.75 4.25a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$19e4d58c61992465 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWholeWord16Filled', "16", [
    "M11.5 5.75q-.67 0-1.25.35V2a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.42.34q.61.4 1.33.41c1.52 0 2.75-1.46 2.75-3.25 0-1.8-1.23-3.25-2.75-3.25m0 5c-.52 0-1.25-.6-1.25-1.75 0-1.14.73-1.75 1.25-1.75s1.25.6 1.25 1.75c0 1.14-.73 1.75-1.25 1.75M4.87 5.42h-.2a3.2 3.2 0 0 0-1.94.47.75.75 0 0 0-.18 1.04.75.75 0 0 0 1.04.19c.16-.11.5-.24 1.2-.2q.8.02.92.57-.83-.15-1.64-.07c-1.4.17-2.32 1.12-2.32 2.41 0 1.4 1.02 2.42 2.42 2.42q.77 0 1.65-.44c.12.26.38.44.7.44h.08a.75.75 0 0 0 .65-.74V7.69c-.07-1.35-.95-2.2-2.39-2.27m.85 3.64.03 1.08-.06.04c-1.45.95-2.44.66-2.44-.32q0-.8 1-.92.73-.09 1.47.12M1.5 15h13c.83 0 1.5-.67 1.5-1.5v-.75a.75.75 0 0 0-1.5 0v.75h-13v-.75a.75.75 0 0 0-1.5 0v.75c0 .83.67 1.5 1.5 1.5"
]);
const $db6ad3fef28672ff$export$6dfa29a585d1ba90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWholeWord16Regular', "16", [
    "M10 2a.5.5 0 0 0-1 0v9.5a.5.5 0 0 0 1 0v-.1q.64.59 1.5.6c1.38 0 2.5-1.34 2.5-3s-1.12-3-2.5-3q-.86.02-1.5.6zm3 7c0 1.28-.84 2-1.5 2S10 10.28 10 9s.84-2 1.5-2 1.5.72 1.5 2M7 7.83V7.7c-.06-1.21-.83-1.97-2.14-2.03h-.2a3 3 0 0 0-1.78.42.5.5 0 1 0 .57.82q.4-.3 1.36-.24c.82.04 1.18.4 1.19 1.14a5 5 0 0 0-1.9-.14C2.8 7.83 2 8.68 2 9.83c0 1.3.94 2.17 2.17 2.17Q5 12 6 11.43v.14a.5.5 0 0 0 .5.43h.07a.5.5 0 0 0 .43-.5zm-2.77.86a4 4 0 0 1 1.57.13l.2.06v1.39l-.17.11q-.98.64-1.66.64c-.7 0-1.17-.43-1.17-1.16 0-.63.4-1.07 1.23-1.17M16 13.5V13a.5.5 0 1 0-1 0v.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V13a.5.5 0 1 0-1 0v.5A1.5 1.5 0 0 0 1.5 15h13a1.5 1.5 0 0 0 1.5-1.5"
]);
const $db6ad3fef28672ff$export$26cae3b4ae66b928 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWholeWord20Filled', "20", [
    "M19 15.75v.5A1.75 1.75 0 0 1 17.25 18H2.75A1.75 1.75 0 0 1 1 16.25v-.5a.75.75 0 1 1 1.5 0v.5a.25.25 0 0 0 .25.25h14.5a.25.25 0 0 0 .25-.25v-.5a.75.75 0 1 1 1.5 0M3.83 10.38a4 4 0 0 1 2.53-.61q.56.03 1.1.16a1 1 0 0 0-.55-.76q-.6-.27-1.26-.23-.56 0-1.07.23a.75.75 0 1 1-.67-1.34q.8-.37 1.69-.4 1.05-.05 1.99.4A2.7 2.7 0 0 1 9 10.46v4.04a.75.75 0 1 1-1.5.06 3.7 3.7 0 0 1-2.94.56 2.61 2.61 0 0 1-.73-4.74m1.11 3.3a2.9 2.9 0 0 0 2.56-1V11.5a5 5 0 0 0-1.22-.23 2.7 2.7 0 0 0-1.62.36 1.11 1.11 0 0 0 .28 2.05m6.06.82V4a.75.75 0 1 1 1.5 0v4.66A2.7 2.7 0 0 1 14.25 8a3.3 3.3 0 0 1 3 3.5 3.3 3.3 0 0 1-3 3.5c-.64 0-1.26-.24-1.75-.66v.16a.75.75 0 1 1-1.5 0m1.75-3a1.8 1.8 0 0 0 1.5 2 1.8 1.8 0 0 0 1.5-2 1.8 1.8 0 0 0-1.5-2 1.8 1.8 0 0 0-1.5 2"
]);
const $db6ad3fef28672ff$export$ed004e0fd9dd97e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWholeWord20Regular', "20", [
    "M11.5 15a.5.5 0 0 0 .5-.5v-.4a2.8 2.8 0 0 0 2 .9 3.3 3.3 0 0 0 3-3.5A3.3 3.3 0 0 0 14 8a2.8 2.8 0 0 0-2 .9V4a.5.5 0 0 0-1 0v10.5a.5.5 0 0 0 .5.5M14 9a2.3 2.3 0 0 1 2 2.5 2.3 2.3 0 0 1-2 2.5 2.3 2.3 0 0 1-2-2.5A2.3 2.3 0 0 1 14 9m-9.13 5.88a3.7 3.7 0 0 0 3.13-.8v.42a.5.5 0 0 0 1 0v-4.04a2.5 2.5 0 0 0-1.28-2.4 4 4 0 0 0-1.86-.37q-.83.02-1.58.36a.5.5 0 0 0 .44.9q.56-.25 1.17-.26.72-.04 1.39.26A1.4 1.4 0 0 1 8 10.27a6 6 0 0 0-1.4-.25 4 4 0 0 0-2.37.56 2.36 2.36 0 0 0 .64 4.3m-.1-3.46a3 3 0 0 1 1.78-.4q.75.04 1.45.3v1.47a3.2 3.2 0 0 1-2.87 1.13 1.36 1.36 0 0 1-.35-2.5M19 16v.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 16.5V16a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 1 1 0"
]);
const $db6ad3fef28672ff$export$39e2e090fc55ef26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWordCount20Filled', "20", [
    "M2.98 14.54q-.4.41-.86.7a.5.5 0 1 1-.54-.83A3.3 3.3 0 0 0 3 12.62a.5.5 0 0 1 .99.11v5.77a.5.5 0 0 1-1 0zm4.6-1.3c-.62 0-1.09.53-1.09 1.06a.5.5 0 0 1-1 0 2.1 2.1 0 0 1 2.1-2.07c.72 0 1.42.33 1.81.91.41.61.43 1.41-.06 2.21-.24.4-.58.71-.91.97l-.5.35-.08.05-.4.28c-.43.32-.74.6-.88 1h2.6a.5.5 0 0 1 0 1H5.98a.5.5 0 0 1-.5-.5c0-1.17.7-1.82 1.37-2.3l.43-.3.07-.05.46-.33q.44-.32.67-.69c.31-.51.24-.89.08-1.13a1.2 1.2 0 0 0-.98-.47m4.48.25a1 1 0 0 0-.28.43.5.5 0 1 1-.96-.28c.08-.27.25-.62.6-.9.34-.3.83-.5 1.49-.5 1.32 0 2.1.93 2.1 1.8 0 .35-.06.87-.43 1.32l-.22.22q.2.15.34.35.3.4.31 1a2 2 0 0 1-.68 1.61c-.42.35-.95.46-1.42.46-.45 0-.89-.07-1.27-.3q-.57-.36-.81-1.09a.5.5 0 1 1 .95-.32q.16.43.39.55.21.16.74.16.5 0 .79-.23c.16-.14.31-.38.31-.84q-.01-.29-.11-.41a1 1 0 0 0-.32-.24c-.3-.13-.68-.16-.94-.16a.5.5 0 0 1 0-1c.71 0 1.02-.22 1.16-.4.16-.19.21-.45.21-.68 0-.28-.28-.8-1.1-.8-.44 0-.7.12-.85.25M2 9.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.25m0-5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25m14 10c0-.41.34-.75.75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$e75a0391b0213139 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWordCount20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M7.6 13c-.62 0-1.1.55-1.1 1.14a.5.5 0 0 1-1 0 2.14 2.14 0 0 1 3.91-1.2c.4.63.43 1.45-.05 2.27q-.4.6-.92 1l-.5.37-.07.05-.4.3c-.44.32-.76.64-.9 1.07h2.6a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5c0-1.2.7-1.87 1.36-2.38l.43-.3.07-.06q.25-.16.46-.34.45-.33.67-.72c.32-.54.25-.95.08-1.21A1.2 1.2 0 0 0 7.6 13m4.48.27a1 1 0 0 0-.29.46.5.5 0 1 1-.96-.28c.08-.26.25-.63.59-.93s.84-.52 1.5-.52c1.34 0 2.1.98 2.1 1.86 0 .36-.06.9-.43 1.36q-.1.13-.24.25a1.7 1.7 0 0 1 .67 1.4q-.01 1.09-.67 1.65c-.42.36-.95.48-1.43.48-.46 0-.9-.08-1.28-.32a2 2 0 0 1-.8-1.12.5.5 0 1 1 .95-.3q.15.46.4.58.22.16.73.16.5 0 .78-.24c.17-.14.32-.4.32-.9a.7.7 0 0 0-.12-.44 1 1 0 0 0-.31-.25c-.3-.14-.68-.17-.94-.17a.5.5 0 1 1 0-1c.7 0 1.01-.22 1.16-.4.16-.21.21-.49.21-.74 0-.32-.3-.86-1.1-.86-.43 0-.69.13-.84.27m-9.06 1.1a5 5 0 0 1-.85.73.5.5 0 1 1-.56-.83 3.5 3.5 0 0 0 1.42-1.88s.11-.39.46-.39c.5 0 .53.5.53.5v6a.5.5 0 0 1-1 0zm13 .13c0-.28.21-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$feb8a12d747c7d5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWordCount24Filled', "24", [
    "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m16 6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m-3.96-.87a1 1 0 0 0-.14.22 1 1 0 1 1-1.93-.52c.1-.33.3-.79.7-1.17.43-.4 1.04-.66 1.8-.66A2.44 2.44 0 0 1 17 17.36c0 .39-.07 1.02-.47 1.59l.1.12q.36.55.37 1.3c0 .83-.27 1.53-.81 2.02-.53.46-1.17.61-1.72.61-.5 0-1.03-.09-1.51-.4a2.5 2.5 0 0 1-.98-1.4 1 1 0 0 1 1.91-.59c.08.26.16.3.18.32.03.02.12.07.4.07q.32-.02.39-.1c.03-.03.14-.14.14-.54q-.02-.17-.03-.17 0-.01-.1-.07a2 2 0 0 0-.66-.12 1 1 0 1 1 0-2q.41-.02.54-.09a.4.4 0 0 0 .14-.1q.1-.13.11-.45a.4.4 0 0 0-.1-.21c-.07-.07-.19-.15-.43-.15-.28 0-.39.08-.43.13m-6.23.5q0-.24.18-.46.16-.18.34-.17c.23 0 .4.11.48.24.06.1.14.32-.09.73q-.15.28-.52.58l-.42.32-.06.05q-.2.15-.42.32C6.6 19.78 5.8 20.59 5.8 22a1 1 0 0 0 1 1h3.02a1 1 0 1 0 0-2H8.31l.23-.2.37-.27.07-.06q.24-.16.5-.39c.34-.28.72-.65 1-1.14.52-.95.52-1.96.03-2.75A2.6 2.6 0 0 0 8.33 15c-1.55 0-2.52 1.4-2.52 2.64a1 1 0 0 0 2 0m-5.26 1.39a1 1 0 0 1-1.13-1.66 3 3 0 0 0 1.15-1.56 1 1 0 0 1 1.98.2v6a1 1 0 1 1-2 0z"
]);
const $db6ad3fef28672ff$export$7ce828599d368f12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWordCount24Regular', "24", [
    "M2 5.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 6.5c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75m17 6.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m-16.58-.01q.3-.21.6-.48v3.99a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.48-.16c-.13.58-.7 1.39-1.46 1.9a.75.75 0 0 0 .84 1.25M8 17.52c0-.52.44-1.02.99-1.02.4 0 .73.2.89.43.13.21.22.57-.1 1.1a3 3 0 0 1-.68.72l-.49.37-.07.05-.48.34c-.74.56-1.56 1.34-1.56 2.74 0 .41.34.75.75.75h3.45a.75.75 0 0 0 0-1.5H8.2q.24-.4.78-.8l.43-.3.08-.06q.28-.19.55-.41c.38-.3.76-.66 1.05-1.14.56-.95.55-1.92.06-2.67a2.53 2.53 0 0 0-4.64 1.4.75.75 0 0 0 1.5 0m6.47-.38c.03-.11.1-.27.25-.4.13-.11.36-.24.78-.24.76 0 1 .5 1 .73 0 .24-.05.49-.19.66-.11.14-.38.36-1.1.36a.75.75 0 0 0 0 1.5c.27 0 .65.04.93.17q.2.1.27.2.07.08.09.36c0 .48-.15.7-.28.8q-.23.21-.72.22-.52-.01-.7-.14c-.1-.07-.23-.2-.34-.53a.75.75 0 0 0-1.42.47q.27.87.97 1.33c.45.28.98.37 1.49.37a2.6 2.6 0 0 0 1.69-.56q.8-.69.81-1.96a2 2 0 0 0-.63-1.52l.11-.14c.44-.55.52-1.19.52-1.6 0-1.07-.93-2.22-2.5-2.22a2.6 2.6 0 0 0-1.77.62c-.4.35-.61.78-.7 1.1a.75.75 0 1 0 1.44.42"
]);
const $db6ad3fef28672ff$export$3e4dbf534644d6ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrap16Filled', "16", [
    "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h9.5a1.25 1.25 0 1 1 0 2.5h-1.69l.22-.22a.75.75 0 1 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-.22-.22h1.69a2.75 2.75 0 1 0 0-5.5zM2 11.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$5c4fcd75dad0d1c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrap16Regular', "16", [
    "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h10a2.5 2.5 0 0 1 0 5H9.7l.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h2.79a1.5 1.5 0 0 0 0-3h-10a.5.5 0 0 1-.5-.5M6 11a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$e28624b3b02e5f2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrap20Filled', "20", [
    "M2 4.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25m0 5c0-.41.34-.75.75-.75h13a3.25 3.25 0 0 1 0 6.5h-3.4l.23.27a.75.75 0 0 1-1.16.96l-1.25-1.5a.75.75 0 0 1 0-.96l1.25-1.5a.75.75 0 0 1 1.16.96l-.23.27h3.4a1.75 1.75 0 1 0 0-3.5h-13A.75.75 0 0 1 2 9.25m0 5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$20c546b751830182 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrap20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5H16a3 3 0 1 1 0 6h-4.3l.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65H16a2 2 0 1 0 0-4H2.5a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$96df9c7e92737102 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrap24Filled', "24", [
    "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm12.41 0H19a2 2 0 1 0 0-4H3a1 1 0 1 1 0-2h16a4 4 0 0 1 0 8h-3.59l.3.3a1 1 0 0 1-1.42 1.4l-2-2a1 1 0 0 1 0-1.4l2-2a1 1 0 0 1 1.42 1.4z"
]);
const $db6ad3fef28672ff$export$73ca332feccc90d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrap24Regular', "24", [
    "M2.75 5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zm0 6.5a.75.75 0 0 0 0 1.5H19a2.5 2.5 0 0 1 0 5h-4.44l.72-.72a.75.75 0 1 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 1 0 1.06-1.06l-.72-.72H19a4 4 0 0 0 0-8zM2 18.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$1f2ab7f7b7c7101c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrapOff16Filled', "16", [
    "m11.8 12.5 2.35 2.35a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L2.39 3.1a.75.75 0 0 0 .36 1.41h1.04L6.3 7H2.75a.75.75 0 0 0 0 1.5h5.04l1.58 1.57-1.15 1.15c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-.22-.22zM9.11 7l1.5 1.5h1.63a1.25 1.25 0 0 1 .67 2.3L14 11.87A2.74 2.74 0 0 0 12.25 7zm-4-4 1.5 1.5h6.63a.75.75 0 0 0 0-1.5zM2 11.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$153b2761650c285b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrapOff16Regular', "16", [
    "M14.15 14.85 11.29 12H9.71l.64.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7L9.29 10l-2-2H2.5a.5.5 0 0 1 0-1h3.8l-3-3h-.8a.5.5 0 0 1-.18-.97L1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7M10.12 8l-1-1h3.38a2.5 2.5 0 0 1 1.27 4.65l-.74-.74A1.5 1.5 0 0 0 12.5 8zm-4-4-1-1h8.38a.5.5 0 0 1 0 1zM6 11a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$44fe383b78ec866e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrapOff20Filled', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15h-1.94l.23.27a.75.75 0 0 1-1.16.96l-1.25-1.5a.75.75 0 0 1 0-.96l1.25-1.5.07-.07L9.3 10H2.75a.75.75 0 0 1 0-1.5h5.04L4.3 5H2.75a.75.75 0 0 1 0-1.5h.04l-.64-.65a.5.5 0 0 1 0-.7m8.47 6.35h5.13a3.25 3.25 0 0 1 1.16 6.29l-1.29-1.29h.13a1.75 1.75 0 1 0 0-3.5h-3.63zM7.12 5l-1.5-1.5h11.63a.75.75 0 0 1 0 1.5zm-4.37 8.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$67f2a69cfa4cf33d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrapOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.29 4H2.5a.5.5 0 0 0 0 1h1.8l4 4H2.5a.5.5 0 0 0 0 1h6.8l2.52 2.53a1 1 0 0 0-.17.12l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65h2.58l2.86 2.85a.5.5 0 0 0 .7-.7zM13.3 14h-1.58l.64-.65a1 1 0 0 0 .12-.17zm-2.17-5 1 1H16a2 2 0 0 1 .12 4l.84.84A3 3 0 0 0 16 9zm-5-5 1 1H17.5a.5.5 0 0 0 0-1zM2 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$c1f1bc72b5b221b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrapOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06L3.94 5H3a1 1 0 0 0 0 2h2.94l4 4H3a1 1 0 1 0 0 2h8.94l2.32 2.32-1.97 1.97a1 1 0 0 0 0 1.42l2 2a1 1 0 0 0 1.42-1.42l-.3-.29h2.53l2.78 2.78a.75.75 0 0 0 1.06-1.06zM14.18 11H19a4 4 0 0 1 2.39 7.2l-1.45-1.44A2 2 0 0 0 19 13h-2.82zm-4-4-2-2H21a1 1 0 1 1 0 2zM2 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $db6ad3fef28672ff$export$51524c379aed9135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextWrapOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06L3.94 5H2.75a.75.75 0 0 0 0 1.5h2.69l5 5H2.75a.75.75 0 0 0 0 1.5h9.19l3.03 3.03a.8.8 0 0 0-.75.19l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 1 0 1.06-1.06l-.72-.72h3.88l2.28 2.28a.75.75 0 0 0 1.06-1.06zM16.94 18h-2.38l.72-.72c.2-.2.27-.5.19-.75zM19 11.5h-4.32l1.5 1.5H19a2.5 2.5 0 0 1 1.6 4.42l1.06 1.06A3.99 3.99 0 0 0 19 11.5M8.18 5l1.5 1.5h11.57a.75.75 0 0 0 0-1.5zM2 18.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75"
]);
const $db6ad3fef28672ff$export$7ae508c6f8878bcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m0 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0 2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$64c3c76916246a00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox16Regular', "16", [
    "M5.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm-1-8A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5z"
]);
const $db6ad3fef28672ff$export$96bae14548e1339e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox20Filled', "20", [
    "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5zm-11 1c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M6.5 9h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1M6 12.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$77b67d45f61d88f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox20Regular', "20", [
    "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9C4 4.67 4.67 4 5.5 4"
]);
const $db6ad3fef28672ff$export$50559ad1900409e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox24Filled', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zm-6.75 5.75a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h7.6m-7.5 4h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zm10.5-8a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h10.6"
]);
const $db6ad3fef28672ff$export$10c091c491fcbea1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox24Regular', "24", [
    "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3zm0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25m-4 7h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5m-7.5 4h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zm10.5-8H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5"
]);
const $db6ad3fef28672ff$export$d51ee66282aae017 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zm2 10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5M8 8.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H8.75A.75.75 0 0 1 8 8.75M8.75 18h10.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$d3e6df172d5db688 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zM4.5 6.75c0-1.24 1-2.25 2.25-2.25h14.5c1.24 0 2.25 1 2.25 2.25v14.5c0 1.24-1 2.25-2.25 2.25H6.75c-1.24 0-2.25-1-2.25-2.25zM8.75 13a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM8 8.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H8.75A.75.75 0 0 1 8 8.75M8.75 18a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$c56b7edd455f04ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox32Filled', "32", [
    "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3zM10 9h12a1 1 0 1 1 0 2H10a1 1 0 1 1 0-2m-1 7a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1 5h12a1 1 0 1 1 0 2H10a1 1 0 1 1 0-2"
]);
const $db6ad3fef28672ff$export$f8eb1ab25c684b7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox32Regular', "32", [
    "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3zM5 7.5A2.5 2.5 0 0 1 7.5 5h17A2.5 2.5 0 0 1 27 7.5v17a2.5 2.5 0 0 1-2.5 2.5h-17A2.5 2.5 0 0 1 5 24.5zM10 9a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"
]);
const $db6ad3fef28672ff$export$ee82dfd6b85070e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox48Filled', "48", [
    "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zm9.25 10.5a1.25 1.25 0 1 0 0 2.5h10.5a1.25 1.25 0 1 0 0-2.5zM14 31.75c0 .69.56 1.25 1.25 1.25h17.5a1.25 1.25 0 1 0 0-2.5h-17.5c-.69 0-1.25.56-1.25 1.25m1.25-17.25a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $db6ad3fef28672ff$export$bba22a9735674828 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Textbox48Regular', "48", [
    "M12.25 6A6.25 6.25 0 0 0 6 12.25v23.5C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6zM8.5 12.25a3.75 3.75 0 0 1 3.75-3.75h23.5a3.75 3.75 0 0 1 3.75 3.75v23.5a3.75 3.75 0 0 1-3.75 3.75h-23.5a3.75 3.75 0 0 1-3.75-3.75zm6.75 10.25a1.25 1.25 0 1 0 0 2.5h10.5a1.25 1.25 0 1 0 0-2.5zM14 31.75c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 1 1 0 2.5h-17.5c-.69 0-1.25-.56-1.25-1.25m1.25-17.25a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $db6ad3fef28672ff$export$85c12a32458588e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottom20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 7h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$31ee8dbbfc7577df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottom20Regular', "20", [
    "M13.5 10a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1m3.5 1.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5zM5.5 16h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5"
]);
const $db6ad3fef28672ff$export$88f06ccfdacd40fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottom24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 8.5h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m0 4h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$de7a07d112618659 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottom24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zm2.75 5.75a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$96dc8747b42c6493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomCenter16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m1 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$6769b20f9968f2ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomCenter16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$6e2f82cacb9c6d86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomCenter20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 7h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$f2fbfeff97051f49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomCenter20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zM6.5 10a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$1bf8a8f8338c9ee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomCenter24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 8.5h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m2 4h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$9b185a709e91b1d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomCenter24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zm2.75 5.75a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm2 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$51e255b7500d8646 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomLeft16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m0 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$ee714f5e5c8f680a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomLeft16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$f37e71489f5f0f2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomLeft20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 7h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$345c4e15c12a18dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomLeft20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zM6.5 10a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$f974bf72c87b658d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomLeft24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 8.5h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m0 4h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$2eea14ba56f8e2ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomLeft24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zm2.75 5.75a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$a0d616e96b4bd1fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRight16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm6 5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$d4d2b72f6826a7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRight16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM10.5 7a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$39e5bc266c264eea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRight20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm8 7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$47449f6e4a7c37fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRight20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zm9.5 4.5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$82167eb3855bb16f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRight24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm11 8.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$d41f03a770a29966 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRight24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zm12.25 5.75a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$3bf3d82ee1890610 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRotate9020Filled', "20", [
    "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5zm-7 1v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0m-3 0v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
]);
const $db6ad3fef28672ff$export$aaef4819a2029e0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRotate9020Regular', "20", [
    "M6.5 6a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5m2.5.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm-6 8A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5zm1 0v-9C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5"
]);
const $db6ad3fef28672ff$export$2161a79127370da0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRotate9024Filled', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zm-8.5 1.5v9.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0m-4 0v9.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0"
]);
const $db6ad3fef28672ff$export$895240eba8d25f4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignBottomRotate9024Regular', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zM18.25 4.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25zM12.5 7.25a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0zm-4 0a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$8466f4774b4f7cbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignCenter16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 4h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m1 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$e52603431ecae141 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignCenter16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM5.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$d8ae9f33a40a1493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignCenter20Filled', "20", [
    "M14.5 3A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm-8 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$99bfba967441b407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignCenter20Regular', "20", [
    "M14.5 3A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m1 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $db6ad3fef28672ff$export$7501b99497b6ee4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignCenter24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 6h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m2 4h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$1bf7171da92a9deb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignCenter24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM7.25 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm2 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$10dbcb3c7429815a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddle16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM5 6.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5.5 9h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$24dbe7196ab0ee15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddle16Regular', "16", [
    "M5 6.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5.5 9a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $db6ad3fef28672ff$export$421f302a5b2fb9c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddle20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$6fefebe67dfae6b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddle20Regular', "20", [
    "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm8-8A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5"
]);
const $db6ad3fef28672ff$export$4cc72f1f94b50838 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddle24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 6h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m0 4h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$4dc4e43ec26db81c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddle24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM7.25 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$eff38e75ee497124 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleLeft16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 4h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m0 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$1ad7577759f10730 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleLeft16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM5.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$9bfff2b5db4b1b65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleLeft20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$227ea79e96089bc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleLeft20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zM6.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$4da532b5d1abf6c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleLeft24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 6h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m0 4h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$e09aebbcb708a014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleLeft24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM7.25 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$51eb6ea5da7ce1f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRight16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm6 4a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$7584f012a31a1d35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRight16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM10.5 6a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$1069ecfa0d4ea214 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRight20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm8 5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$2c1aaedb3c1ccb5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRight20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zM13.5 8a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$2146d83ef13a5b20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRight24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm11 6a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$2f860542791c7d68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRight24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM16.75 9a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$61481562e213a674 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRotate9020Filled', "20", [
    "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5zm-5 1v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0m-3 0v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
]);
const $db6ad3fef28672ff$export$aef67e5ba472b116 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRotate9020Regular', "20", [
    "M11.5 6c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5M9 6.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm8 8a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5zm-1 0v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5"
]);
const $db6ad3fef28672ff$export$f81be825d59fcf1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRotate9024Filled', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zm-6 1.5v9.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0m-4 0v9.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0"
]);
const $db6ad3fef28672ff$export$92c5f37b04a3551d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignMiddleRotate9024Regular', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zM18.25 4.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25zM15 7.25a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0zm-4 0a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$500a2a90681f7518 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTop20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 3h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$d7d76eb6f0523f84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTop20Regular', "20", [
    "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M6.5 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm8-6A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5"
]);
const $db6ad3fef28672ff$export$9d51b574c756e5c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTop24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 4h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m0 4h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$e4b6f1f200347fd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTop24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM7.25 7a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$887c5d0bc5a60192 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopArrowClockwise20Filled', "20", [
    "M14.5 3A2.5 2.5 0 0 1 17 5.5v8.38l-.44-.44a1.5 1.5 0 1 0-2.12 2.12l.44.44h1.41l-1.14-1.15a.5.5 0 1 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 1 1-.7-.7L16.29 17H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm-8 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$81fd3598a31ded06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopArrowClockwise20Regular', "20", [
    "M14.5 3A2.5 2.5 0 0 1 17 5.5v7a.5.5 0 0 1-1 0v-7c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h10.8l-1.15-1.15a.5.5 0 1 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 1 1-.7-.7L16.29 17H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm-1 6a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$2a0f0265167d680d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopCenter16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m1 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$ad02b073b1b69795 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopCenter16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zm2.5.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$10ec4eb747b6ec1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopCenter20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 3h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$ed6e6b5897c73c51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopCenter20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zm2.5.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$e82989bc344869f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopCenter24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 4h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m2 4h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$875054e4f444ae46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopCenter24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM7.25 7a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm2 4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$b04699ba8995dccd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m0 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$af97bf49d75bce02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zm2.5.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$9eebbe5a35888bba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm1 3h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $db6ad3fef28672ff$export$a245a8a2c063da29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zm2.5.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$b52434cb7f49bc3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm1.5 4h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5m0 4h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5"
]);
const $db6ad3fef28672ff$export$a1d052c6603fbac5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM7.25 7a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $db6ad3fef28672ff$export$fbeb6af0b954ed2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopLeft32Light', "32", [
    "M23.5 10h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1m-15 6h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5zM7.5 4A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4z"
]);
const $db6ad3fef28672ff$export$dd307e7198f2c5ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRight16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm6 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$ac15737ef74565d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRight16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zm7.5.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$8859fffd46b624ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRight20Filled', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zm8 3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$59fcbbd7aaa9a48c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRight20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zm9.5.5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $db6ad3fef28672ff$export$5d7dbf3353b038b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRight24Filled', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zm11 4a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$dfd4c98a66cbe1f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRight24Regular', "24", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zM16.75 7a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z"
]);
const $db6ad3fef28672ff$export$210d40b7f35f068e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRotate9020Filled', "20", [
    "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5zm-3 1v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0m-3 0v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
]);
const $db6ad3fef28672ff$export$3769df0d17d79eee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRotate9020Regular', "20", [
    "M13.5 6c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m-2.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm6 8a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5zm-1 0v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5"
]);
const $db6ad3fef28672ff$export$7b6b084c9dd836c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRotate9024Filled', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zm-4 1.5v9.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0m-4 0v9.5a.75.75 0 0 1-1.5 0v-9.5a.75.75 0 0 1 1.5 0"
]);
const $db6ad3fef28672ff$export$922e272f945bf40b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxAlignTopRotate9024Regular', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25zM18.25 4.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25zM17 7.25a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0zm-4 0a.75.75 0 0 0-1.5 0v9.5a.75.75 0 0 0 1.5 0z"
]);
const $db6ad3fef28672ff$export$6b43dee607b1b65f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h2.1a5.5 5.5 0 0 1-.58-3H5.5a.5.5 0 0 1 0-1h.7q.25-.81.69-1.5H5.5a.5.5 0 0 1 0-1h2.23A5.5 5.5 0 0 1 14 6.6V4.5A2.5 2.5 0 0 0 11.5 2zm1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$7fb9e9d84d7a87d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark16Regular', "16", [
    "M5.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h1.39q.36-.55.84-1zm0 2.5h.7q-.13.48-.18 1H5.5a.5.5 0 0 1 0-1m-1 3h1.7q.16.52.4 1H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v2.1q-.48-.24-1-.4V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$a5e25445932cc938 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark20Filled', "20", [
    "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1-.4-4H6.5a.5.5 0 0 1 0-1h3.1A5.5 5.5 0 0 1 17 9.6zm-11 1c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M6.5 9h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$d314e19ef55e08d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark20Regular', "20", [
    "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h2.7q.16-.52.4-1zm-1 4h3.7q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$260a38f4ab19aeb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark24Filled', "24", [
    "M17.5 11c1.29 0 2.49.38 3.5 1.02V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h6.27a6.5 6.5 0 0 1-.94-4.5H6.65a.75.75 0 0 1 .1-1.5h4.75a6.5 6.5 0 0 1 1.85-2.5h-6.7a.75.75 0 0 1 .1-1.5h7.6c.29.05.52.25.61.51A7 7 0 0 1 17.5 11M6.75 8.5h-.1a.75.75 0 0 1 .1-1.5h10.6a.75.75 0 0 1-.1 1.5zm16.25 9a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$71e93b58444d11a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark24Regular', "24", [
    "M5.75 21h6.27q-.45-.7-.7-1.5H5.74c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v5.56q.8.27 1.5.71V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21m5.33-4.5q.12-.79.42-1.5H6.75a.75.75 0 0 0-.1 1.5h4.43m2.27-4a7 7 0 0 1 1.61-.99.8.8 0 0 0-.6-.5l-.11-.01h-7.5a.75.75 0 0 0-.1 1.5h6.7m-6.6-4h10.5a.75.75 0 0 0 .1-1.5H6.75a.75.75 0 0 0-.1 1.5zm16.25 9a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $db6ad3fef28672ff$export$e11d53b4beac1131 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h7.75a7.5 7.5 0 0 1-1.43-5.5H8.75a.75.75 0 0 1 0-1.5h4.68A7.5 7.5 0 0 1 25 14.5V6.75A3.75 3.75 0 0 0 21.25 3zm2 10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5M8 8.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H8.75A.75.75 0 0 1 8 8.75M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-3.35-2.85L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$152acfbf6fcc1bc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h7.75a8 8 0 0 1-.88-1.5H6.75c-1.24 0-2.25-1-2.25-2.25V6.75c0-1.24 1-2.25 2.25-2.25h14.5c1.24 0 2.25 1 2.25 2.25v6.87q.81.36 1.5.88V6.75A3.75 3.75 0 0 0 21.25 3zm6.32 16.5q.1-.78.36-1.5H8.75a.75.75 0 0 0 0 1.5zM8.75 13a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM8 8.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H8.75A.75.75 0 0 1 8 8.75M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-3.35-2.85L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 0 0-.7-.7"
]);
const $db6ad3fef28672ff$export$50bc68ccfb5fef7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark32Filled', "32", [
    "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h8.88a9 9 0 0 1-1.87-6H10a1 1 0 1 1 0-2h4.85a9 9 0 0 1 2.49-4.06A1 1 0 0 1 17 17h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 .89 1.47 8.96 8.96 0 0 1 11.11-.1V7.5A4.5 4.5 0 0 0 24.5 3zM10 9h12a1 1 0 1 1 0 2H10a1 1 0 1 1 0-2m13.5 7a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06"
]);
const $db6ad3fef28672ff$export$3052ef26f9193d77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark32Regular', "32", [
    "M7.5 3A4.5 4.5 0 0 0 3 7.5v17A4.5 4.5 0 0 0 7.5 29h8.88a9 9 0 0 1-1.17-2H7.5A2.5 2.5 0 0 1 5 24.5v-17A2.5 2.5 0 0 1 7.5 5h17A2.5 2.5 0 0 1 27 7.5v7.7a9 9 0 0 1 2 1.18V7.5A4.5 4.5 0 0 0 24.5 3zm7.01 20q.07-1.04.34-2H10a1 1 0 1 0 0 2zm2.83-6.06q.26-.24.55-.47A1 1 0 0 0 17 15h-7a1 1 0 1 0 0 2h7a1 1 0 0 0 .34-.06M10 9a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zm13.5 7a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06"
]);
const $db6ad3fef28672ff$export$bd351a71a5079122 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark48Filled', "48", [
    "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v12.04a13 13 0 0 0-19.2 6.46h-7.55a1.25 1.25 0 1 0 0 2.5h6.9a13 13 0 0 0 1.9 9H12a6 6 0 0 1-6-6zm9.25 10.5a1.25 1.25 0 1 0 0 2.5h10.5a1.25 1.25 0 1 0 0-2.5zm0-8a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-4.3-4.7a1 1 0 0 0-1.4 0L33 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l8-8a1 1 0 0 0 0-1.42"
]);
const $db6ad3fef28672ff$export$78af7e79812e058e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxCheckmark48Regular', "48", [
    "M12.25 6A6.25 6.25 0 0 0 6 12.25v23.5C6 39.2 8.8 42 12.25 42h11.8q-.75-1.17-1.25-2.5H12.25a3.75 3.75 0 0 1-3.75-3.75v-23.5a3.75 3.75 0 0 1 3.75-3.75h23.5a3.75 3.75 0 0 1 3.75 3.75V22.8q1.33.5 2.5 1.24V12.25C42 8.8 39.2 6 35.75 6zm9.9 27q.21-1.3.65-2.5h-7.55a1.25 1.25 0 1 0 0 2.5zm-6.9-10.5a1.25 1.25 0 1 0 0 2.5h10.5a1.25 1.25 0 1 0 0-2.5zm0-8a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-4.3-4.7a1 1 0 0 0-1.4 0L33 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l8-8a1 1 0 0 0 0-1.42"
]);
const $db6ad3fef28672ff$export$8010381549ac5c8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxMore20Filled', "20", [
    "M14.5 3A2.5 2.5 0 0 1 17 5.5v9l-.01.25c-.87 0-1.62.5-1.99 1.22a2.25 2.25 0 0 0-4 0A2.25 2.25 0 0 0 6.75 17H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zM9 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M14.25 17a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $db6ad3fef28672ff$export$4334fce214976dd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxMore20Regular', "20", [
    "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M6.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM6 12.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M14.5 3A2.5 2.5 0 0 1 17 5.5v9l-.01.25q-.6 0-1.09.29.1-.26.1-.54v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h1.48q-.23.46-.23 1H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zm-4.25 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $db6ad3fef28672ff$export$8b1fee74007cab33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxMore24Filled', "24", [
    "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.3a2.5 2.5 0 0 0-2.94 1.9q0 .05-.06.05a.1.1 0 0 1-.06-.05 2.5 2.5 0 0 0-4.88 0q0 .05-.06.05a.1.1 0 0 1-.06-.05A2.5 2.5 0 0 0 8.05 21h-2.3A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3zM15 12.25a.75.75 0 0 0-.75-.75h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0 .65-.75m2.25 3.25H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5M18 8.25a.75.75 0 0 0-.75-.75H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0 .65-.75M12 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$f2a73ee6ef190758 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxMore24Regular', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h2.3a2.5 2.5 0 0 1 .16-1.5H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.46a2.5 2.5 0 0 1 1.5-.16zM6.75 11.5h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zm10.5 4H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5m-10.5-8h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5zm5.25 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $db6ad3fef28672ff$export$3b07af2557b85d39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxRotate9020Filled', "20", [
    "M14.5 3A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3zM13 6.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-3 0a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zm-3 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0z"
]);
const $db6ad3fef28672ff$export$15754c0c555f0080 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxRotate9020Regular', "20", [
    "M13 6.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm-3 0a.5.5 0 1 0-1 0v4a.5.5 0 0 0 1 0zm-3 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm10 8a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5zm-1 0v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5"
]);
const $db6ad3fef28672ff$export$1c506dfab278f063 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxRotate9024Filled', "24", [
    "M18.25 21A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21zm-5.75-6.75a.75.75 0 0 1-1.5.1v-7.6a.75.75 0 0 1 1.5-.1v7.6m-4-7.5v10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1zm8 10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1v10.6"
]);
const $db6ad3fef28672ff$export$e83394ccbc369125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxRotate9024Regular', "24", [
    "M21 18.25A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75zm-1.5 0V5.75c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25m-7-4v-7.6a.75.75 0 0 0-1.5.1v7.6a.75.75 0 0 0 1.5-.1m-4-7.5v10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1zm8 10.5V6.65a.75.75 0 0 0-1.5.1v10.6a.75.75 0 0 0 1.5-.1"
]);
const $db6ad3fef28672ff$export$c704fc05a342ebb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxSettings20Filled', "20", [
    "M3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1-.4-4H6.5a.5.5 0 0 1 0-1h3.1A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5m3 1c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m4.64 4.42a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.34-.09a5 5 0 0 1-.01-1.01zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $db6ad3fef28672ff$export$be678da1d2c208ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxSettings20Regular', "20", [
    "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h2.7q.16-.52.4-1zm-1 4h3.7q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5m6.57-4.56a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $db6ad3fef28672ff$export$e57383af75f0d43f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxSettings24Filled', "24", [
    "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h6.27a6.5 6.5 0 0 1-1-4H6.75a.75.75 0 0 1-.1-1.5h4.66c.3-.95.83-1.8 1.5-2.5H6.75a.75.75 0 0 1-.1-1.5h7.6q.24 0 .44.14a6.5 6.5 0 0 1 6.31.38zM17.25 7.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h10.6m-4.75 8.13.45.43a2 2 0 0 1 0 2.88l-.45.43q.31.86.85 1.57l.6-.18a2 2 0 0 1 2.52 1.45l.17.72a5 5 0 0 0 1.72 0l.17-.72a2 2 0 0 1 2.52-1.45l.6.18q.54-.71.85-1.57l-.45-.43a2 2 0 0 1 0-2.88l.45-.43q-.31-.87-.85-1.57l-.6.18a2 2 0 0 1-2.52-1.45l-.17-.72a5 5 0 0 0-1.72 0l-.17.72a2 2 0 0 1-2.52 1.45l-.6-.18q-.55.71-.85 1.57m5 3.37c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $db6ad3fef28672ff$export$fea32e8220db2314 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TextboxSettings24Regular', "24", [
    "M18.25 3A2.75 2.75 0 0 1 21 5.75v6.27q-.7-.45-1.5-.7V5.74c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h5.56q.27.8.71 1.5H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3zm-4 8.5q.24 0 .44.14-1.07.52-1.88 1.36H6.75a.75.75 0 0 1-.1-1.5h7.6m-7.5 4h4.56q-.22.72-.3 1.5H6.76a.75.75 0 0 1-.1-1.5zm10.5-8H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5m-4.75 8.13.45.43a2 2 0 0 1 0 2.88l-.45.43q.31.86.85 1.57l.6-.18a2 2 0 0 1 2.52 1.45l.17.72a5 5 0 0 0 1.72 0l.17-.72a2 2 0 0 1 2.52-1.45l.6.18q.54-.71.85-1.57l-.45-.43a2 2 0 0 1 0-2.88l.45-.43q-.31-.87-.85-1.57l-.6.18a2 2 0 0 1-2.52-1.45l-.17-.72a5 5 0 0 0-1.72 0l-.17.72a2 2 0 0 1-2.52 1.45l-.6-.18q-.55.71-.85 1.57m5 3.37c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);


const $947d1bab282d8abd$export$e40bdb1c89d5deb1 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$fce5277afd3c0810),
    'extra-small': (0, $db6ad3fef28672ff$export$fce5277afd3c0810),
    small: (0, $db6ad3fef28672ff$export$7c44d63d26d809dd),
    medium: (0, $db6ad3fef28672ff$export$d63c0ab4b7a00bb),
    large: (0, $db6ad3fef28672ff$export$b28855588e7af32c),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$b28855588e7af32c)
};
const $947d1bab282d8abd$export$60124015b5483a81 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$aa6c54fa4585e6ae),
    'extra-small': (0, $db6ad3fef28672ff$export$aa6c54fa4585e6ae),
    small: (0, $db6ad3fef28672ff$export$105a31b1756bab6a),
    medium: (0, $db6ad3fef28672ff$export$5b8c0195a650ffbf),
    large: (0, $db6ad3fef28672ff$export$8f329086e703aa76),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$8f329086e703aa76)
};
const $947d1bab282d8abd$export$aa559fc4b5265ba8 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$6135855172ba18a7),
    'extra-small': (0, $db6ad3fef28672ff$export$6135855172ba18a7),
    small: (0, $db6ad3fef28672ff$export$cc7567a4085fcefc),
    medium: (0, $db6ad3fef28672ff$export$ac85b31298a9aeab),
    large: (0, $db6ad3fef28672ff$export$bbbdb8197498b6a6),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$bbbdb8197498b6a6)
};
const $947d1bab282d8abd$export$5296cbae4b288167 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$2336da4b9d112afc),
    'extra-small': (0, $db6ad3fef28672ff$export$2336da4b9d112afc),
    small: (0, $db6ad3fef28672ff$export$8409be9342c56497),
    medium: (0, $db6ad3fef28672ff$export$dfc8de308d7a430),
    large: (0, $db6ad3fef28672ff$export$7897d1c243dd316e),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$7897d1c243dd316e)
};
const $947d1bab282d8abd$export$7f74bf3a633028de = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$a69b5d009c0253ff),
    'extra-small': (0, $db6ad3fef28672ff$export$a69b5d009c0253ff),
    small: (0, $db6ad3fef28672ff$export$f829eda1dcedce36),
    medium: (0, $db6ad3fef28672ff$export$ca62c5bc590bcb42),
    large: (0, $db6ad3fef28672ff$export$5d07dc6457578eda),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$5d07dc6457578eda)
};
const $947d1bab282d8abd$export$7058d28bf8df32f1 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$b328fef9411355f7),
    'extra-small': (0, $db6ad3fef28672ff$export$b328fef9411355f7),
    small: (0, $db6ad3fef28672ff$export$d32c2187ad6354cb),
    medium: (0, $db6ad3fef28672ff$export$8b037ecb59de1869),
    large: (0, $db6ad3fef28672ff$export$db84f0dcfb050a9a),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$db84f0dcfb050a9a)
};
const $947d1bab282d8abd$export$6eadee939033149e = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$c946be8577feeff1),
    'extra-small': (0, $db6ad3fef28672ff$export$c946be8577feeff1),
    small: (0, $db6ad3fef28672ff$export$60f4b61c2c9084f5),
    medium: (0, $db6ad3fef28672ff$export$ec749c1e92909664),
    large: (0, $db6ad3fef28672ff$export$7d23d8e50558c288),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$7d23d8e50558c288)
};
const $947d1bab282d8abd$export$d9f214f06353190 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$f551eb69a6c629f2),
    'extra-small': (0, $db6ad3fef28672ff$export$f551eb69a6c629f2),
    small: (0, $db6ad3fef28672ff$export$d101e620c5b82561),
    medium: (0, $db6ad3fef28672ff$export$67c9d918ed9d3561),
    large: (0, $db6ad3fef28672ff$export$f00a5de77036aa8f),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$f00a5de77036aa8f)
};
const $947d1bab282d8abd$export$7d14d0788f8be15d = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$a0948e2f86247a28),
    'extra-small': (0, $db6ad3fef28672ff$export$a0948e2f86247a28),
    small: (0, $db6ad3fef28672ff$export$9328f59444fba2f),
    medium: (0, $db6ad3fef28672ff$export$71b298daaff0f2e1),
    large: (0, $db6ad3fef28672ff$export$639bb6b78f006f01),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$639bb6b78f006f01)
};
const $947d1bab282d8abd$export$6098567fb32cacb4 = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$9744a3328ec72bdc),
    'extra-small': (0, $db6ad3fef28672ff$export$9744a3328ec72bdc),
    small: (0, $db6ad3fef28672ff$export$1f35fc88cba9b7d8),
    medium: (0, $db6ad3fef28672ff$export$863a902e5747c1fe),
    large: (0, $db6ad3fef28672ff$export$25d1da3d11922bca),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$25d1da3d11922bca)
};
const $947d1bab282d8abd$export$2b189567f0ecfc0d = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: (0, $db6ad3fef28672ff$export$bf953cd935f00b01),
    'extra-small': (0, $db6ad3fef28672ff$export$bf953cd935f00b01),
    small: (0, $db6ad3fef28672ff$export$2e7efe060a25b5a5),
    medium: (0, $db6ad3fef28672ff$export$6e01bade7e77dedc),
    large: (0, $db6ad3fef28672ff$export$1afd02eef2d99a95),
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': (0, $db6ad3fef28672ff$export$1afd02eef2d99a95)
};



'use client';
const $ced3f4ad43083bc4$var$iconMap = (status, outOfOffice, size)=>{
    switch(status){
        case 'available':
            return outOfOffice ? (0, $947d1bab282d8abd$export$aa559fc4b5265ba8)[size] : (0, $947d1bab282d8abd$export$5296cbae4b288167)[size];
        case 'away':
            return outOfOffice ? (0, $947d1bab282d8abd$export$7d14d0788f8be15d)[size] : (0, $947d1bab282d8abd$export$60124015b5483a81)[size];
        case 'blocked':
            return (0, $947d1bab282d8abd$export$7f74bf3a633028de)[size];
        case 'busy':
            return outOfOffice ? (0, $947d1bab282d8abd$export$2b189567f0ecfc0d)[size] : (0, $947d1bab282d8abd$export$7058d28bf8df32f1)[size];
        case 'do-not-disturb':
            return outOfOffice ? (0, $947d1bab282d8abd$export$d9f214f06353190)[size] : (0, $947d1bab282d8abd$export$6eadee939033149e)[size];
        case 'offline':
            return outOfOffice ? (0, $947d1bab282d8abd$export$7d14d0788f8be15d)[size] : (0, $947d1bab282d8abd$export$6098567fb32cacb4)[size];
        case 'out-of-office':
            return (0, $947d1bab282d8abd$export$7d14d0788f8be15d)[size];
        case 'unknown':
            return (0, $947d1bab282d8abd$export$2b189567f0ecfc0d)[size];
    }
};
const $ced3f4ad43083bc4$export$2976aa13bcf2415 = {
    busy: 'busy',
    'out-of-office': 'out of office',
    away: 'away',
    available: 'available',
    offline: 'offline',
    'do-not-disturb': 'do not disturb',
    unknown: 'unknown',
    blocked: 'blocked'
};
const $ced3f4ad43083bc4$export$cb1e6cde372d5b25 = (props, ref)=>{
    const { size: size = 'medium', outOfOffice: outOfOffice = false, ...baseProps } = props;
    var _props_status;
    const status = (_props_status = props.status) !== null && _props_status !== void 0 ? _props_status : 'available';
    const IconElement = $ced3f4ad43083bc4$var$iconMap(status, outOfOffice, size);
    const state = {
        ...$ced3f4ad43083bc4$export$955cccfe6653be9a(baseProps, ref),
        appearance: 'filled',
        color: 'brand',
        shape: 'circular',
        size: size,
        outOfOffice: outOfOffice
    };
    if (state.icon) {
        var _state_icon;
        var _children;
        (_children = (_state_icon = state.icon).children) !== null && _children !== void 0 ? _children : _state_icon.children = /*#__PURE__*/ $acw62.createElement(IconElement, null);
    }
    return state;
};
const $ced3f4ad43083bc4$export$955cccfe6653be9a = (props, ref)=>{
    const { status: status = 'available', outOfOffice: outOfOffice = false } = props;
    const statusText = $ced3f4ad43083bc4$export$2976aa13bcf2415[status];
    const oofText = props.outOfOffice && props.status !== 'out-of-office' ? ` ${$ced3f4ad43083bc4$export$2976aa13bcf2415['out-of-office']}` : '';
    const state = {
        ...(0, $7892eaa0711e2be0$export$7acc7342958ebb87)({
            'aria-label': statusText + oofText,
            role: 'img',
            ...props,
            icon: (0, $fcf7ddccaab7fd8f$exports).optional(props.icon, {
                renderByDefault: true,
                elementType: 'span'
            })
        }, ref),
        status: status,
        outOfOffice: outOfOffice
    };
    return state;
};




'use client';
const $3658335cee3237f2$export$a66b6ec300221ca4 = {
    root: 'fui-PresenceBadge',
    icon: 'fui-PresenceBadge__icon'
};
const $3658335cee3237f2$var$getIsBusy = (status)=>{
    if (status === 'busy' || status === 'do-not-disturb' || status === 'blocked') return true;
    return false;
};
const $3658335cee3237f2$var$useRootClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r832ydo", null, [
    ".r832ydo{display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;border-radius:var(--borderRadiusCircular);background-color:var(--colorNeutralBackground1);padding:1px;background-clip:content-box;}"
]);
const $3658335cee3237f2$var$useIconClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r11ag4qr", null, [
    ".r11ag4qr{display:flex;margin:-1px;}"
]);
const $3658335cee3237f2$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    statusBusy: {
        sj55zd: "fvi85wt"
    },
    statusAway: {
        sj55zd: "f14k8a89"
    },
    statusAvailable: {
        sj55zd: "fqa5hgp"
    },
    statusOffline: {
        sj55zd: "f11d4kpn"
    },
    statusOutOfOffice: {
        sj55zd: "fdce8r3"
    },
    statusUnknown: {
        sj55zd: "f11d4kpn"
    },
    outOfOffice: {
        sj55zd: "fr0bkrk"
    },
    outOfOfficeAvailable: {
        sj55zd: "fqa5hgp"
    },
    outOfOfficeBusy: {
        sj55zd: "fvi85wt"
    },
    outOfOfficeUnknown: {
        sj55zd: "f11d4kpn"
    },
    tiny: {
        Bubjx69: "f9ikmtg",
        a9b677: "f16dn6v3",
        B2eet1l: "f1w2irj7",
        B5pe6w7: "fab5kbq",
        p4uzdd: "f1ms1d91"
    },
    large: {
        Bubjx69: "f9ikmtg",
        a9b677: "f64fuq3",
        B5pe6w7: "f1vfi1yj",
        p4uzdd: "f15s34gz"
    },
    extraLarge: {
        Bubjx69: "f9ikmtg",
        a9b677: "f1w9dchk",
        B5pe6w7: "f14efy9b",
        p4uzdd: "fhipgdu"
    }
}, {
    d: [
        ".fvi85wt{color:var(--colorPaletteRedBackground3);}",
        ".f14k8a89{color:var(--colorPaletteMarigoldBackground3);}",
        ".fqa5hgp{color:var(--colorPaletteLightGreenForeground3);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".fdce8r3{color:var(--colorPaletteBerryForeground3);}",
        ".fr0bkrk{color:var(--colorNeutralBackground1);}",
        ".f9ikmtg{aspect-ratio:1;}",
        ".f16dn6v3{width:6px;}",
        ".f1w2irj7{background-clip:unset;}",
        ".fab5kbq svg{width:6px!important;}",
        ".f1ms1d91 svg{height:6px!important;}",
        ".f64fuq3{width:20px;}",
        ".f1vfi1yj svg{width:20px!important;}",
        ".f15s34gz svg{height:20px!important;}",
        ".f1w9dchk{width:28px;}",
        ".f14efy9b svg{width:28px!important;}",
        ".fhipgdu svg{height:28px!important;}"
    ]
});
const $3658335cee3237f2$export$bba3bec91e749f7a = (state)=>{
    const rootClassName = $3658335cee3237f2$var$useRootClassName();
    const iconClassName = $3658335cee3237f2$var$useIconClassName();
    const styles = $3658335cee3237f2$var$useStyles();
    const isBusy = $3658335cee3237f2$var$getIsBusy(state.status);
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($3658335cee3237f2$export$a66b6ec300221ca4.root, rootClassName, isBusy && styles.statusBusy, state.status === 'away' && styles.statusAway, state.status === 'available' && styles.statusAvailable, state.status === 'offline' && styles.statusOffline, state.status === 'out-of-office' && styles.statusOutOfOffice, state.status === 'unknown' && styles.statusUnknown, state.outOfOffice && styles.outOfOffice, state.outOfOffice && state.status === 'available' && styles.outOfOfficeAvailable, state.outOfOffice && isBusy && styles.outOfOfficeBusy, state.outOfOffice && (state.status === 'out-of-office' || state.status === 'away' || state.status === 'offline') && styles.statusOutOfOffice, state.outOfOffice && state.status === 'unknown' && styles.outOfOfficeUnknown, state.size === 'tiny' && styles.tiny, state.size === 'large' && styles.large, state.size === 'extra-large' && styles.extraLarge, state.root.className);
    if (state.icon) // eslint-disable-next-line react-hooks/immutability
    state.icon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($3658335cee3237f2$export$a66b6ec300221ca4.icon, iconClassName, state.icon.className);
    return state;
};




'use client';
const $c703897f92f480c4$export$c661d384a5bd3b9c = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $ced3f4ad43083bc4$export$cb1e6cde372d5b25)(props, ref);
    (0, $3658335cee3237f2$export$bba3bec91e749f7a)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('usePresenceBadgeStyles_unstable')(state);
    return (0, $92ebd6e2d9285e1a$export$29a61d2f0c4be9e)(state);
});
$c703897f92f480c4$export$c661d384a5bd3b9c.displayName = 'PresenceBadge';




var $acw62 = parcelRequire("acw62");
'use client';
const $c9cefd0af318361c$var$avatarContext = $acw62.createContext(undefined);
const $c9cefd0af318361c$var$avatarContextDefaultValue = {};
const $c9cefd0af318361c$export$21632a70197ed7bc = $c9cefd0af318361c$var$avatarContext.Provider;
const $c9cefd0af318361c$export$b50b87a1c4086b23 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($c9cefd0af318361c$var$avatarContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $c9cefd0af318361c$var$avatarContextDefaultValue;
};


'use client';
const $32eab41e58faa2fe$export$2976aa13bcf2415 = {
    active: 'active',
    inactive: 'inactive'
};
const $32eab41e58faa2fe$export$9b5684be4f0794d0 = (props, ref)=>{
    const { dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const { shape: contextShape, size: contextSize } = (0, $c9cefd0af318361c$export$b50b87a1c4086b23)();
    const { size: size = contextSize !== null && contextSize !== void 0 ? contextSize : 32, shape: shape = contextShape !== null && contextShape !== void 0 ? contextShape : 'circular', activeAppearance: activeAppearance = 'ring', idForColor: idForColor, color: propColor = 'neutral', ...rest } = props;
    const state = $32eab41e58faa2fe$export$ae5597ab4883aa3c(rest, ref);
    var _ref;
    // Resolve 'colorful' to a specific color name
    const color = propColor === 'colorful' ? $32eab41e58faa2fe$var$avatarColors[$32eab41e58faa2fe$var$getHashCode((_ref = idForColor !== null && idForColor !== void 0 ? idForColor : props.name) !== null && _ref !== void 0 ? _ref : '') % $32eab41e58faa2fe$var$avatarColors.length] : propColor;
    if (state.initials) {
        var _state_initials;
        // eslint-disable-next-line react-hooks/immutability
        state.initials = (0, $fcf7ddccaab7fd8f$exports).optional(props.initials, {
            renderByDefault: true,
            defaultProps: {
                children: (0, $bf4a6e1cd284fb53$export$de9bdbce6502b027)(props.name, dir === 'rtl', {
                    firstInitialOnly: size <= 16
                }),
                id: (_state_initials = state.initials) === null || _state_initials === void 0 ? void 0 : _state_initials.id
            },
            elementType: 'span'
        });
    }
    if (state.icon && !state.icon.hasOwnProperty('children')) // eslint-disable-next-line react-hooks/immutability
    state.icon.children = /*#__PURE__*/ $acw62.createElement((0, $bf8018481b255628$export$cfc2b730852a3cfe), null);
    const badge = (0, $fcf7ddccaab7fd8f$exports).optional(props.badge, {
        defaultProps: {
            ...state.badge,
            size: $32eab41e58faa2fe$var$getBadgeSize(size)
        },
        elementType: (0, $c703897f92f480c4$export$c661d384a5bd3b9c)
    });
    return {
        ...state,
        size: size,
        shape: shape,
        activeAppearance: activeAppearance,
        color: color,
        badge: badge,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        components: {
            ...state.components,
            badge: (0, $c703897f92f480c4$export$c661d384a5bd3b9c)
        }
    };
};
const $32eab41e58faa2fe$export$ae5597ab4883aa3c = (props, ref)=>{
    const { dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const { name: name, image: imageProp, initials: initialsProp, badge: badge, active: active = 'unset', ...rest } = props;
    const baseId = (0, $0200d30cfa270435$export$f680877a34711e37)('avatar-');
    const root = (0, $fcf7ddccaab7fd8f$exports).always({
        role: 'img',
        id: baseId,
        ref: ref,
        ...rest
    }, {
        elementType: 'span'
    });
    const [imageHidden, setImageHidden] = $acw62.useState(undefined);
    let image = (0, $fcf7ddccaab7fd8f$exports).optional(imageProp, {
        defaultProps: {
            alt: '',
            role: 'presentation',
            'aria-hidden': true,
            hidden: imageHidden
        },
        elementType: 'img'
    });
    // Image shouldn't be rendered if its src is not set
    if (!(image === null || image === void 0 ? void 0 : image.src)) image = undefined;
    // Hide the image if it fails to load and restore it on a successful load
    if (image) {
        image.onError = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(image.onError, ()=>setImageHidden(true));
        image.onLoad = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(image.onLoad, ()=>setImageHidden(undefined));
    }
    // Resolve the initials slot, defaulted to getInitials
    let initials = (0, $fcf7ddccaab7fd8f$exports).optional(initialsProp, {
        renderByDefault: true,
        defaultProps: {
            children: (0, $bf4a6e1cd284fb53$export$de9bdbce6502b027)(name, dir === 'rtl'),
            id: baseId + '__initials'
        },
        elementType: 'span'
    });
    // Don't render the initials slot if it's empty
    if (!(initials === null || initials === void 0 ? void 0 : initials.children)) initials = undefined;
    // Render the icon slot *only if* there aren't any initials or image to display
    let icon = undefined;
    if (!initials && (!image || imageHidden)) icon = (0, $fcf7ddccaab7fd8f$exports).optional(props.icon, {
        renderByDefault: true,
        defaultProps: {
            'aria-hidden': true
        },
        elementType: 'span'
    });
    const badgeSlot = (0, $fcf7ddccaab7fd8f$exports).optional(badge, {
        defaultProps: {
            id: root.id + '__badge'
        },
        elementType: 'div'
    });
    let activeAriaLabelElement;
    // Resolve aria-label and/or aria-labelledby, including the badge, if not provided by the user
    const userProvidedAriaLabel = props['aria-label'] !== undefined;
    const userProvidedAriaLabelledby = props['aria-labelledby'] !== undefined;
    if (!userProvidedAriaLabel && !userProvidedAriaLabelledby) {
        if (name) {
            root['aria-label'] = name;
            if (badgeSlot) root['aria-labelledby'] = root.id + ' ' + badgeSlot.id;
        } else if (initials) // root's aria-label should be the name, but fall back to being labelledby the initials if name is missing
        root['aria-labelledby'] = initials.id + (badgeSlot ? ' ' + badgeSlot.id : '');
        if (active === 'active' || active === 'inactive') {
            const activeText = $32eab41e58faa2fe$export$2976aa13bcf2415[active];
            if (root['aria-labelledby']) {
                const activeId = root.id + '__active';
                root['aria-labelledby'] += ' ' + activeId;
                activeAriaLabelElement = /*#__PURE__*/ $acw62.createElement("span", {
                    hidden: true,
                    id: activeId
                }, activeText);
            } else if (root['aria-label']) root['aria-label'] += ' ' + activeText;
        }
    }
    return {
        active: active,
        activeAriaLabelElement: activeAriaLabelElement,
        components: {
            root: 'span',
            initials: 'span',
            icon: 'span',
            image: 'img',
            badge: 'div'
        },
        root: root,
        initials: initials,
        icon: icon,
        image: image,
        badge: badgeSlot
    };
};
const $32eab41e58faa2fe$var$getBadgeSize = (size)=>{
    if (size >= 96) return 'extra-large';
    else if (size >= 64) return 'large';
    else if (size >= 56) return 'medium';
    else if (size >= 40) return 'small';
    else if (size >= 28) return 'extra-small';
    else return 'tiny';
};
const $32eab41e58faa2fe$var$avatarColors = [
    'dark-red',
    'cranberry',
    'red',
    'pumpkin',
    'peach',
    'marigold',
    'gold',
    'brass',
    'brown',
    'forest',
    'seafoam',
    'dark-green',
    'light-teal',
    'teal',
    'steel',
    'blue',
    'royal-blue',
    'cornflower',
    'navy',
    'lavender',
    'purple',
    'grape',
    'lilac',
    'pink',
    'magenta',
    'plum',
    'beige',
    'mink',
    'platinum',
    'anchor'
];
const $32eab41e58faa2fe$var$getHashCode = (str)=>{
    let hashCode = 0;
    for(let len = str.length - 1; len >= 0; len--){
        const ch = str.charCodeAt(len);
        const shift = len % 8;
        hashCode ^= (ch << shift) + (ch >> 8 - shift); // eslint-disable-line no-bitwise
    }
    return hashCode;
};





'use client';
const $883f4c21165c3eb9$export$8ff71ec53d8ab195 = {
    root: 'fui-Avatar',
    image: 'fui-Avatar__image',
    initials: 'fui-Avatar__initials',
    icon: 'fui-Avatar__icon',
    badge: 'fui-Avatar__badge'
};
// CSS variables used internally in Avatar's styles
const $883f4c21165c3eb9$var$vars = {
    badgeRadius: '--fui-Avatar-badgeRadius',
    badgeGap: '--fui-Avatar-badgeGap',
    badgeAlign: '--fui-Avatar-badgeAlign',
    ringWidth: '--fui-Avatar-ringWidth'
};
const $883f4c21165c3eb9$var$useRootClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r81b29z", "r1aatmv", {
    r: [
        ".r81b29z{display:inline-block;flex-shrink:0;position:relative;vertical-align:middle;border-radius:var(--borderRadiusCircular);font-family:var(--fontFamilyBase);font-weight:var(--fontWeightSemibold);font-size:var(--fontSizeBase300);width:32px;height:32px;}",
        ".r81b29z::before,.r81b29z::after{position:absolute;top:0;left:0;bottom:0;right:0;z-index:-1;margin:calc(-2 * var(--fui-Avatar-ringWidth, 0px));border-radius:inherit;transition-property:margin,opacity;transition-timing-function:var(--curveEasyEaseMax),var(--curveLinear);transition-duration:var(--durationUltraSlow),var(--durationSlower);}",
        ".r81b29z::before{border-style:solid;border-width:var(--fui-Avatar-ringWidth);}",
        ".r1aatmv{display:inline-block;flex-shrink:0;position:relative;vertical-align:middle;border-radius:var(--borderRadiusCircular);font-family:var(--fontFamilyBase);font-weight:var(--fontWeightSemibold);font-size:var(--fontSizeBase300);width:32px;height:32px;}",
        ".r1aatmv::before,.r1aatmv::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;margin:calc(-2 * var(--fui-Avatar-ringWidth, 0px));border-radius:inherit;transition-property:margin,opacity;transition-timing-function:var(--curveEasyEaseMax),var(--curveLinear);transition-duration:var(--durationUltraSlow),var(--durationSlower);}",
        ".r1aatmv::before{border-style:solid;border-width:var(--fui-Avatar-ringWidth);}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.r81b29z::before,.r81b29z::after{transition-duration:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1aatmv::before,.r1aatmv::after{transition-duration:0.01ms;}}"
    ]
});
const $883f4c21165c3eb9$var$useImageClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r136dc0n", "rjly0nl", [
    ".r136dc0n{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;object-fit:cover;vertical-align:top;}",
    ".rjly0nl{position:absolute;top:0;right:0;width:100%;height:100%;border-radius:inherit;object-fit:cover;vertical-align:top;}"
]);
const $883f4c21165c3eb9$var$useIconInitialsClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rip04v", "r31uzil", [
    ".rip04v{position:absolute;box-sizing:border-box;top:0;left:0;width:100%;height:100%;line-height:1;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);display:flex;align-items:center;justify-content:center;vertical-align:center;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:inherit;}",
    ".r31uzil{position:absolute;box-sizing:border-box;top:0;right:0;width:100%;height:100%;line-height:1;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);display:flex;align-items:center;justify-content:center;vertical-align:center;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:inherit;}"
]);
/**
 * Helper to create a maskImage that punches out a circle larger than the badge by `badgeGap`.
 * This creates a transparent gap between the badge and Avatar.
 *
 * Used by the icon, initials, and image slots, as well as the ring ::before pseudo-element.
 */ const $883f4c21165c3eb9$var$badgeMask = (margin)=>{
    // Center the cutout at the badge's radius away from the edge.
    // The ring (::before) also has a 2 * ringWidth margin that also needs to be offset.
    const centerOffset = margin ? `calc(var(${$883f4c21165c3eb9$var$vars.badgeRadius}) + ${margin})` : `var(${$883f4c21165c3eb9$var$vars.badgeRadius})`;
    // radial-gradient does not have anti-aliasing, so the transparent and opaque gradient stops are offset by +/- 0.25px
    // to "fade" from transparent to opaque over a half-pixel and ease the transition.
    const innerRadius = `calc(var(${$883f4c21165c3eb9$var$vars.badgeRadius}) + var(${$883f4c21165c3eb9$var$vars.badgeGap}) - 0.25px)`;
    const outerRadius = `calc(var(${$883f4c21165c3eb9$var$vars.badgeRadius}) + var(${$883f4c21165c3eb9$var$vars.badgeGap}) + 0.25px)`;
    return `radial-gradient(circle at bottom ${centerOffset} var(${$883f4c21165c3eb9$var$vars.badgeAlign}) ${centerOffset}, ` + `transparent ${innerRadius}, white ${outerRadius})`;
};
const $883f4c21165c3eb9$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    textCaption2Strong: {
        Be2twd7: "f13mqy1h"
    },
    textCaption1Strong: {
        Be2twd7: "fy9rknc"
    },
    textSubtitle2: {
        Be2twd7: "fod5ikn"
    },
    textSubtitle1: {
        Be2twd7: "f1pp30po"
    },
    textTitle3: {
        Be2twd7: "f1x0m3f5"
    },
    squareSmall: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "fq9zq91"
    },
    squareMedium: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5"
    },
    squareLarge: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f1o0qvyv"
    },
    squareXLarge: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f1kijzfu"
    },
    activeOrInactive: {
        Bz10aip: "ftfx35i",
        Bmy1vo4: "fv0atk9",
        B3o57yi: "f1iry5bo",
        Bkqvd7p: "f15n41j8",
        Bg24rqe: "f9ttr0w"
    },
    ring: {
        Ftih45: "f1wl9k8s"
    },
    ringBadgeCutout: {
        f4a502: "fp2gujx"
    },
    ringThick: {
        of393c: "fq1w1vq"
    },
    ringThicker: {
        of393c: "fzg6ace"
    },
    ringThickest: {
        of393c: "f1nu8p71"
    },
    shadow: {
        Bsft5z2: "f13zj6fq"
    },
    shadow4: {
        Be6vj1x: "fcjn15l"
    },
    shadow8: {
        Be6vj1x: "f1tm8t9f"
    },
    shadow16: {
        Be6vj1x: "f1a1aohj"
    },
    shadow28: {
        Be6vj1x: "fond6v5"
    },
    inactive: {
        abs64n: "fp25eh",
        Bz10aip: "f1clczzi",
        Bkqvd7p: "f1l3s34x",
        Bfgortx: 0,
        Bnvr3x9: 0,
        b2tv09: 0,
        Bucmhp4: 0,
        iayac2: "flkahu5",
        b6ubon: "fw457kn",
        Bqinb2h: "f1wmllxl"
    },
    badge: {
        qhf8xq: "f1euv43f",
        B5kzvoi: "f1yab3r1",
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ]
    },
    badgeCutout: {
        btxmck: "f1eugkqs"
    },
    badgeAlign: {
        Dnlfbu: [
            "f1tlnv9o",
            "f1y9kyih"
        ]
    },
    tiny: {
        Bdjeniz: "f1uwoubl",
        niu6jh: "fid048z"
    },
    "extra-small": {
        Bdjeniz: "f13ar0e0",
        niu6jh: "fid048z"
    },
    small: {
        Bdjeniz: "fwwuruf",
        niu6jh: "fid048z"
    },
    medium: {
        Bdjeniz: "f1af27q5",
        niu6jh: "fid048z"
    },
    large: {
        Bdjeniz: "f18yy57a",
        niu6jh: "f924bxt"
    },
    "extra-large": {
        Bdjeniz: "f2jg042",
        niu6jh: "f924bxt"
    },
    icon12: {
        Be2twd7: "f1ugzwwg"
    },
    icon16: {
        Be2twd7: "f4ybsrx"
    },
    icon20: {
        Be2twd7: "fe5j1ua"
    },
    icon24: {
        Be2twd7: "f1rt2boy"
    },
    icon28: {
        Be2twd7: "f24l1pt"
    },
    icon32: {
        Be2twd7: "ffl51b"
    },
    icon48: {
        Be2twd7: "f18m8u13"
    }
}, {
    d: [
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f1x0m3f5{font-size:var(--fontSizeBase600);}",
        [
            ".fq9zq91{border-radius:var(--borderRadiusSmall);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f1o0qvyv{border-radius:var(--borderRadiusLarge);}",
            {
                p: -1
            }
        ],
        [
            ".f1kijzfu{border-radius:var(--borderRadiusXLarge);}",
            {
                p: -1
            }
        ],
        ".ftfx35i{transform:perspective(1px);}",
        ".fv0atk9{transition-property:transform,opacity;}",
        ".f1iry5bo{transition-duration:var(--durationUltraSlow),var(--durationFaster);}",
        ".f15n41j8{transition-timing-function:var(--curveEasyEaseMax),var(--curveLinear);}",
        ".f1wl9k8s::before{content:\"\";}",
        ".fp2gujx::before{-webkit-mask-image:radial-gradient(circle at bottom calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)) var(--fui-Avatar-badgeAlign) calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));mask-image:radial-gradient(circle at bottom calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)) var(--fui-Avatar-badgeAlign) calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));}",
        ".fq1w1vq{--fui-Avatar-ringWidth:var(--strokeWidthThick);}",
        ".fzg6ace{--fui-Avatar-ringWidth:var(--strokeWidthThicker);}",
        ".f1nu8p71{--fui-Avatar-ringWidth:var(--strokeWidthThickest);}",
        ".f13zj6fq::after{content:\"\";}",
        ".fcjn15l::after{box-shadow:var(--shadow4);}",
        ".f1tm8t9f::after{box-shadow:var(--shadow8);}",
        ".f1a1aohj::after{box-shadow:var(--shadow16);}",
        ".fond6v5::after{box-shadow:var(--shadow28);}",
        ".fp25eh{opacity:0.8;}",
        ".f1clczzi{transform:scale(0.875);}",
        ".f1l3s34x{transition-timing-function:var(--curveDecelerateMin),var(--curveLinear);}",
        [
            ".flkahu5::before,.flkahu5::after{margin:0;}",
            {
                p: -1
            }
        ],
        ".fw457kn::before,.fw457kn::after{opacity:0;}",
        ".f1wmllxl::before,.f1wmllxl::after{transition-timing-function:var(--curveDecelerateMin),var(--curveLinear);}",
        ".f1euv43f{position:absolute;}",
        ".f1yab3r1{bottom:0;}",
        ".f1e31b4d{right:0;}",
        ".f1vgc2s3{left:0;}",
        ".f1eugkqs{-webkit-mask-image:radial-gradient(circle at bottom var(--fui-Avatar-badgeRadius) var(--fui-Avatar-badgeAlign) var(--fui-Avatar-badgeRadius), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));mask-image:radial-gradient(circle at bottom var(--fui-Avatar-badgeRadius) var(--fui-Avatar-badgeAlign) var(--fui-Avatar-badgeRadius), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));}",
        ".f1tlnv9o{--fui-Avatar-badgeAlign:right;}",
        ".f1y9kyih{--fui-Avatar-badgeAlign:left;}",
        ".f1uwoubl{--fui-Avatar-badgeRadius:3px;}",
        ".fid048z{--fui-Avatar-badgeGap:var(--strokeWidthThin);}",
        ".f13ar0e0{--fui-Avatar-badgeRadius:5px;}",
        ".fwwuruf{--fui-Avatar-badgeRadius:6px;}",
        ".f1af27q5{--fui-Avatar-badgeRadius:8px;}",
        ".f18yy57a{--fui-Avatar-badgeRadius:10px;}",
        ".f924bxt{--fui-Avatar-badgeGap:var(--strokeWidthThick);}",
        ".f2jg042{--fui-Avatar-badgeRadius:14px;}",
        ".f1ugzwwg{font-size:12px;}",
        ".f4ybsrx{font-size:16px;}",
        ".fe5j1ua{font-size:20px;}",
        ".f1rt2boy{font-size:24px;}",
        ".f24l1pt{font-size:28px;}",
        ".ffl51b{font-size:32px;}",
        ".f18m8u13{font-size:48px;}"
    ],
    m: [
        [
            "@media screen and (prefers-reduced-motion: reduce){.f9ttr0w{transition-duration:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ]
    ]
});
const $883f4c21165c3eb9$export$a8a91f81c06ff989 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    "16": {
        a9b677: "fjw5fx7",
        Bqenvij: "fd461yt"
    },
    "20": {
        a9b677: "f64fuq3",
        Bqenvij: "fjamq6b"
    },
    "24": {
        a9b677: "fq4mcun",
        Bqenvij: "frvgh55"
    },
    "28": {
        a9b677: "f1w9dchk",
        Bqenvij: "fxldao9"
    },
    "32": {
        a9b677: "f1szoe96",
        Bqenvij: "f1d2rq10"
    },
    "36": {
        a9b677: "fpdz1er",
        Bqenvij: "f8ljn23"
    },
    "40": {
        a9b677: "feqmc2u",
        Bqenvij: "fbhnoac"
    },
    "48": {
        a9b677: "f124akge",
        Bqenvij: "ff2sm71"
    },
    "56": {
        a9b677: "f1u66zr1",
        Bqenvij: "fzki0ko"
    },
    "64": {
        a9b677: "fa9ln6p",
        Bqenvij: "f16k9i2m"
    },
    "72": {
        a9b677: "fhcae8x",
        Bqenvij: "f1shusfg"
    },
    "96": {
        a9b677: "f1kyr2gn",
        Bqenvij: "fypu0ge"
    },
    "120": {
        a9b677: "fwfqyga",
        Bqenvij: "fjr5b71"
    },
    "128": {
        a9b677: "f1iksgmy",
        Bqenvij: "fele2au"
    }
}, {
    d: [
        ".fjw5fx7{width:16px;}",
        ".fd461yt{height:16px;}",
        ".f64fuq3{width:20px;}",
        ".fjamq6b{height:20px;}",
        ".fq4mcun{width:24px;}",
        ".frvgh55{height:24px;}",
        ".f1w9dchk{width:28px;}",
        ".fxldao9{height:28px;}",
        ".f1szoe96{width:32px;}",
        ".f1d2rq10{height:32px;}",
        ".fpdz1er{width:36px;}",
        ".f8ljn23{height:36px;}",
        ".feqmc2u{width:40px;}",
        ".fbhnoac{height:40px;}",
        ".f124akge{width:48px;}",
        ".ff2sm71{height:48px;}",
        ".f1u66zr1{width:56px;}",
        ".fzki0ko{height:56px;}",
        ".fa9ln6p{width:64px;}",
        ".f16k9i2m{height:64px;}",
        ".fhcae8x{width:72px;}",
        ".f1shusfg{height:72px;}",
        ".f1kyr2gn{width:96px;}",
        ".fypu0ge{height:96px;}",
        ".fwfqyga{width:120px;}",
        ".fjr5b71{height:120px;}",
        ".f1iksgmy{width:128px;}",
        ".fele2au{height:128px;}"
    ]
});
const $883f4c21165c3eb9$var$useColorStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    neutral: {
        sj55zd: "f11d4kpn",
        De3pzq: "f18f03hv"
    },
    brand: {
        sj55zd: "fonrgv7",
        De3pzq: "f1blnnmj"
    },
    "dark-red": {
        sj55zd: "fqjd1y1",
        De3pzq: "f1vq2oo4"
    },
    cranberry: {
        sj55zd: "fg9gses",
        De3pzq: "f1lwxszt"
    },
    red: {
        sj55zd: "f23f7i0",
        De3pzq: "f1q9qhfq"
    },
    pumpkin: {
        sj55zd: "fjnan08",
        De3pzq: "fz91bi3"
    },
    peach: {
        sj55zd: "fknu15p",
        De3pzq: "f1b9nr51"
    },
    marigold: {
        sj55zd: "f9603vw",
        De3pzq: "f3z4w6d"
    },
    gold: {
        sj55zd: "fmq0uwp",
        De3pzq: "fg50kya"
    },
    brass: {
        sj55zd: "f28g5vo",
        De3pzq: "f4w2gd0"
    },
    brown: {
        sj55zd: "ftl572b",
        De3pzq: "f14wu1f4"
    },
    forest: {
        sj55zd: "f1gymlvd",
        De3pzq: "f19ut4y6"
    },
    seafoam: {
        sj55zd: "fnnb6wn",
        De3pzq: "f1n057jc"
    },
    "dark-green": {
        sj55zd: "ff58qw8",
        De3pzq: "f11t05wk"
    },
    "light-teal": {
        sj55zd: "f1up9qbj",
        De3pzq: "f42feg1"
    },
    teal: {
        sj55zd: "f135dsb4",
        De3pzq: "f6hvv1p"
    },
    steel: {
        sj55zd: "f151dlcp",
        De3pzq: "f1lnp8zf"
    },
    blue: {
        sj55zd: "f1rjv50u",
        De3pzq: "f1ggcpy6"
    },
    "royal-blue": {
        sj55zd: "f1emykk5",
        De3pzq: "f12rj61f"
    },
    cornflower: {
        sj55zd: "fqsigj7",
        De3pzq: "f8k7hur"
    },
    navy: {
        sj55zd: "f1nj97xi",
        De3pzq: "f19gw0ux"
    },
    lavender: {
        sj55zd: "fwctg0i",
        De3pzq: "ff379vm"
    },
    purple: {
        sj55zd: "fjrsgpu",
        De3pzq: "f1mzf1e1"
    },
    grape: {
        sj55zd: "f1fiiydq",
        De3pzq: "f1o4k8oy"
    },
    lilac: {
        sj55zd: "f1res9jt",
        De3pzq: "f1x6mz1o"
    },
    pink: {
        sj55zd: "fv3fbbi",
        De3pzq: "fydlv6t"
    },
    magenta: {
        sj55zd: "f1f1fwnz",
        De3pzq: "f4xb6j5"
    },
    plum: {
        sj55zd: "f8ptl6j",
        De3pzq: "fqo8e26"
    },
    beige: {
        sj55zd: "f1ntv3ld",
        De3pzq: "f101elhj"
    },
    mink: {
        sj55zd: "f1fscmp",
        De3pzq: "f13g8o5c"
    },
    platinum: {
        sj55zd: "f1dr00v2",
        De3pzq: "fkh7blw"
    },
    anchor: {
        sj55zd: "f1f3ti53",
        De3pzq: "fu4yj0j"
    }
}, {
    d: [
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f18f03hv{background-color:var(--colorNeutralBackground6);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".f1blnnmj{background-color:var(--colorBrandBackgroundStatic);}",
        ".fqjd1y1{color:var(--colorPaletteDarkRedForeground2);}",
        ".f1vq2oo4{background-color:var(--colorPaletteDarkRedBackground2);}",
        ".fg9gses{color:var(--colorPaletteCranberryForeground2);}",
        ".f1lwxszt{background-color:var(--colorPaletteCranberryBackground2);}",
        ".f23f7i0{color:var(--colorPaletteRedForeground2);}",
        ".f1q9qhfq{background-color:var(--colorPaletteRedBackground2);}",
        ".fjnan08{color:var(--colorPalettePumpkinForeground2);}",
        ".fz91bi3{background-color:var(--colorPalettePumpkinBackground2);}",
        ".fknu15p{color:var(--colorPalettePeachForeground2);}",
        ".f1b9nr51{background-color:var(--colorPalettePeachBackground2);}",
        ".f9603vw{color:var(--colorPaletteMarigoldForeground2);}",
        ".f3z4w6d{background-color:var(--colorPaletteMarigoldBackground2);}",
        ".fmq0uwp{color:var(--colorPaletteGoldForeground2);}",
        ".fg50kya{background-color:var(--colorPaletteGoldBackground2);}",
        ".f28g5vo{color:var(--colorPaletteBrassForeground2);}",
        ".f4w2gd0{background-color:var(--colorPaletteBrassBackground2);}",
        ".ftl572b{color:var(--colorPaletteBrownForeground2);}",
        ".f14wu1f4{background-color:var(--colorPaletteBrownBackground2);}",
        ".f1gymlvd{color:var(--colorPaletteForestForeground2);}",
        ".f19ut4y6{background-color:var(--colorPaletteForestBackground2);}",
        ".fnnb6wn{color:var(--colorPaletteSeafoamForeground2);}",
        ".f1n057jc{background-color:var(--colorPaletteSeafoamBackground2);}",
        ".ff58qw8{color:var(--colorPaletteDarkGreenForeground2);}",
        ".f11t05wk{background-color:var(--colorPaletteDarkGreenBackground2);}",
        ".f1up9qbj{color:var(--colorPaletteLightTealForeground2);}",
        ".f42feg1{background-color:var(--colorPaletteLightTealBackground2);}",
        ".f135dsb4{color:var(--colorPaletteTealForeground2);}",
        ".f6hvv1p{background-color:var(--colorPaletteTealBackground2);}",
        ".f151dlcp{color:var(--colorPaletteSteelForeground2);}",
        ".f1lnp8zf{background-color:var(--colorPaletteSteelBackground2);}",
        ".f1rjv50u{color:var(--colorPaletteBlueForeground2);}",
        ".f1ggcpy6{background-color:var(--colorPaletteBlueBackground2);}",
        ".f1emykk5{color:var(--colorPaletteRoyalBlueForeground2);}",
        ".f12rj61f{background-color:var(--colorPaletteRoyalBlueBackground2);}",
        ".fqsigj7{color:var(--colorPaletteCornflowerForeground2);}",
        ".f8k7hur{background-color:var(--colorPaletteCornflowerBackground2);}",
        ".f1nj97xi{color:var(--colorPaletteNavyForeground2);}",
        ".f19gw0ux{background-color:var(--colorPaletteNavyBackground2);}",
        ".fwctg0i{color:var(--colorPaletteLavenderForeground2);}",
        ".ff379vm{background-color:var(--colorPaletteLavenderBackground2);}",
        ".fjrsgpu{color:var(--colorPalettePurpleForeground2);}",
        ".f1mzf1e1{background-color:var(--colorPalettePurpleBackground2);}",
        ".f1fiiydq{color:var(--colorPaletteGrapeForeground2);}",
        ".f1o4k8oy{background-color:var(--colorPaletteGrapeBackground2);}",
        ".f1res9jt{color:var(--colorPaletteLilacForeground2);}",
        ".f1x6mz1o{background-color:var(--colorPaletteLilacBackground2);}",
        ".fv3fbbi{color:var(--colorPalettePinkForeground2);}",
        ".fydlv6t{background-color:var(--colorPalettePinkBackground2);}",
        ".f1f1fwnz{color:var(--colorPaletteMagentaForeground2);}",
        ".f4xb6j5{background-color:var(--colorPaletteMagentaBackground2);}",
        ".f8ptl6j{color:var(--colorPalettePlumForeground2);}",
        ".fqo8e26{background-color:var(--colorPalettePlumBackground2);}",
        ".f1ntv3ld{color:var(--colorPaletteBeigeForeground2);}",
        ".f101elhj{background-color:var(--colorPaletteBeigeBackground2);}",
        ".f1fscmp{color:var(--colorPaletteMinkForeground2);}",
        ".f13g8o5c{background-color:var(--colorPaletteMinkBackground2);}",
        ".f1dr00v2{color:var(--colorPalettePlatinumForeground2);}",
        ".fkh7blw{background-color:var(--colorPalettePlatinumBackground2);}",
        ".f1f3ti53{color:var(--colorPaletteAnchorForeground2);}",
        ".fu4yj0j{background-color:var(--colorPaletteAnchorBackground2);}"
    ]
});
const $883f4c21165c3eb9$var$useRingColorStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    neutral: {
        Bic5iru: "f1uuiafn"
    },
    brand: {
        Bic5iru: "f1uuiafn"
    },
    "dark-red": {
        Bic5iru: "f1t2x9on"
    },
    cranberry: {
        Bic5iru: "f1pvshc9"
    },
    red: {
        Bic5iru: "f1ectbk9"
    },
    pumpkin: {
        Bic5iru: "fvzpl0b"
    },
    peach: {
        Bic5iru: "fwj2kd7"
    },
    marigold: {
        Bic5iru: "fr120vy"
    },
    gold: {
        Bic5iru: "f8xmmar"
    },
    brass: {
        Bic5iru: "f1hbety2"
    },
    brown: {
        Bic5iru: "f1vg3s4g"
    },
    forest: {
        Bic5iru: "f1m3olm5"
    },
    seafoam: {
        Bic5iru: "f17xiqtr"
    },
    "dark-green": {
        Bic5iru: "fx32vyh"
    },
    "light-teal": {
        Bic5iru: "f1mkihwv"
    },
    teal: {
        Bic5iru: "fecnooh"
    },
    steel: {
        Bic5iru: "f15hfgzm"
    },
    blue: {
        Bic5iru: "fqproka"
    },
    "royal-blue": {
        Bic5iru: "f17v2w59"
    },
    cornflower: {
        Bic5iru: "fp0q1mo"
    },
    navy: {
        Bic5iru: "f1nlym55"
    },
    lavender: {
        Bic5iru: "f62vk8h"
    },
    purple: {
        Bic5iru: "f15zl69q"
    },
    grape: {
        Bic5iru: "f53w4j7"
    },
    lilac: {
        Bic5iru: "fu2771t"
    },
    pink: {
        Bic5iru: "fzflscs"
    },
    magenta: {
        Bic5iru: "fb6rmqc"
    },
    plum: {
        Bic5iru: "f1a4gm5b"
    },
    beige: {
        Bic5iru: "f1qpf9z1"
    },
    mink: {
        Bic5iru: "f1l7or83"
    },
    platinum: {
        Bic5iru: "fzrj0iu"
    },
    anchor: {
        Bic5iru: "f8oz6wf"
    }
}, {
    d: [
        ".f1uuiafn::before{color:var(--colorBrandStroke1);}",
        ".f1t2x9on::before{color:var(--colorPaletteDarkRedBorderActive);}",
        ".f1pvshc9::before{color:var(--colorPaletteCranberryBorderActive);}",
        ".f1ectbk9::before{color:var(--colorPaletteRedBorderActive);}",
        ".fvzpl0b::before{color:var(--colorPalettePumpkinBorderActive);}",
        ".fwj2kd7::before{color:var(--colorPalettePeachBorderActive);}",
        ".fr120vy::before{color:var(--colorPaletteMarigoldBorderActive);}",
        ".f8xmmar::before{color:var(--colorPaletteGoldBorderActive);}",
        ".f1hbety2::before{color:var(--colorPaletteBrassBorderActive);}",
        ".f1vg3s4g::before{color:var(--colorPaletteBrownBorderActive);}",
        ".f1m3olm5::before{color:var(--colorPaletteForestBorderActive);}",
        ".f17xiqtr::before{color:var(--colorPaletteSeafoamBorderActive);}",
        ".fx32vyh::before{color:var(--colorPaletteDarkGreenBorderActive);}",
        ".f1mkihwv::before{color:var(--colorPaletteLightTealBorderActive);}",
        ".fecnooh::before{color:var(--colorPaletteTealBorderActive);}",
        ".f15hfgzm::before{color:var(--colorPaletteSteelBorderActive);}",
        ".fqproka::before{color:var(--colorPaletteBlueBorderActive);}",
        ".f17v2w59::before{color:var(--colorPaletteRoyalBlueBorderActive);}",
        ".fp0q1mo::before{color:var(--colorPaletteCornflowerBorderActive);}",
        ".f1nlym55::before{color:var(--colorPaletteNavyBorderActive);}",
        ".f62vk8h::before{color:var(--colorPaletteLavenderBorderActive);}",
        ".f15zl69q::before{color:var(--colorPalettePurpleBorderActive);}",
        ".f53w4j7::before{color:var(--colorPaletteGrapeBorderActive);}",
        ".fu2771t::before{color:var(--colorPaletteLilacBorderActive);}",
        ".fzflscs::before{color:var(--colorPalettePinkBorderActive);}",
        ".fb6rmqc::before{color:var(--colorPaletteMagentaBorderActive);}",
        ".f1a4gm5b::before{color:var(--colorPalettePlumBorderActive);}",
        ".f1qpf9z1::before{color:var(--colorPaletteBeigeBorderActive);}",
        ".f1l7or83::before{color:var(--colorPaletteMinkBorderActive);}",
        ".fzrj0iu::before{color:var(--colorPalettePlatinumBorderActive);}",
        ".f8oz6wf::before{color:var(--colorPaletteAnchorBorderActive);}"
    ]
});
const $883f4c21165c3eb9$export$9bb93704eff7d3be = (state)=>{
    const { size: size, shape: shape, active: active, activeAppearance: activeAppearance, color: color } = state;
    const rootClassName = $883f4c21165c3eb9$var$useRootClassName();
    const imageClassName = $883f4c21165c3eb9$var$useImageClassName();
    const iconInitialsClassName = $883f4c21165c3eb9$var$useIconInitialsClassName();
    const styles = $883f4c21165c3eb9$var$useStyles();
    const sizeStyles = $883f4c21165c3eb9$export$a8a91f81c06ff989();
    const colorStyles = $883f4c21165c3eb9$var$useColorStyles();
    const ringColorStyles = $883f4c21165c3eb9$var$useRingColorStyles();
    const rootClasses = [
        rootClassName,
        size !== 32 && sizeStyles[size]
    ];
    if (state.badge) rootClasses.push(styles.badgeAlign, styles[state.badge.size || 'medium']);
    if (size <= 24) rootClasses.push(styles.textCaption2Strong);
    else if (size <= 28) rootClasses.push(styles.textCaption1Strong);
    else if (size <= 40) ;
    else if (size <= 56) rootClasses.push(styles.textSubtitle2);
    else if (size <= 96) rootClasses.push(styles.textSubtitle1);
    else rootClasses.push(styles.textTitle3);
    if (shape === 'square') {
        if (size <= 24) rootClasses.push(styles.squareSmall);
        else if (size <= 48) rootClasses.push(styles.squareMedium);
        else if (size <= 72) rootClasses.push(styles.squareLarge);
        else rootClasses.push(styles.squareXLarge);
    }
    if (active === 'active' || active === 'inactive') {
        rootClasses.push(styles.activeOrInactive);
        if (activeAppearance === 'ring' || activeAppearance === 'ring-shadow') {
            rootClasses.push(styles.ring, ringColorStyles[color]);
            if (state.badge) rootClasses.push(styles.ringBadgeCutout);
            if (size <= 48) rootClasses.push(styles.ringThick);
            else if (size <= 64) rootClasses.push(styles.ringThicker);
            else rootClasses.push(styles.ringThickest);
        }
        if (activeAppearance === 'shadow' || activeAppearance === 'ring-shadow') {
            rootClasses.push(styles.shadow);
            if (size <= 28) rootClasses.push(styles.shadow4);
            else if (size <= 48) rootClasses.push(styles.shadow8);
            else if (size <= 64) rootClasses.push(styles.shadow16);
            else rootClasses.push(styles.shadow28);
        }
        // Note: The inactive style overrides some of the activeAppearance styles and must be applied after them
        if (active === 'inactive') rootClasses.push(styles.inactive);
    }
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($883f4c21165c3eb9$export$8ff71ec53d8ab195.root, ...rootClasses, state.root.className);
    if (state.badge) // eslint-disable-next-line react-hooks/immutability
    state.badge.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($883f4c21165c3eb9$export$8ff71ec53d8ab195.badge, styles.badge, state.badge.className);
    if (state.image) // eslint-disable-next-line react-hooks/immutability
    state.image.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($883f4c21165c3eb9$export$8ff71ec53d8ab195.image, imageClassName, colorStyles[color], state.badge && styles.badgeCutout, state.image.className);
    if (state.initials) // eslint-disable-next-line react-hooks/immutability
    state.initials.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($883f4c21165c3eb9$export$8ff71ec53d8ab195.initials, iconInitialsClassName, colorStyles[color], state.badge && styles.badgeCutout, state.initials.className);
    if (state.icon) {
        let iconSizeClass;
        if (size <= 16) iconSizeClass = styles.icon12;
        else if (size <= 24) iconSizeClass = styles.icon16;
        else if (size <= 40) iconSizeClass = styles.icon20;
        else if (size <= 48) iconSizeClass = styles.icon24;
        else if (size <= 56) iconSizeClass = styles.icon28;
        else if (size <= 72) iconSizeClass = styles.icon32;
        else iconSizeClass = styles.icon48;
        // eslint-disable-next-line react-hooks/immutability
        state.icon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($883f4c21165c3eb9$export$8ff71ec53d8ab195.icon, iconInitialsClassName, iconSizeClass, colorStyles[color], state.badge && styles.badgeCutout, state.icon.className);
    }
    return state;
};


'use client';
const $f5cb7a3ee98d12a7$export$e2255cf6045e8d47 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $32eab41e58faa2fe$export$9b5684be4f0794d0)(props, ref);
    (0, $883f4c21165c3eb9$export$9bb93704eff7d3be)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useAvatarStyles_unstable')(state);
    return (0, $c8cab5512415dea6$export$cff486926637164d)(state);
});
$f5cb7a3ee98d12a7$export$e2255cf6045e8d47.displayName = 'Avatar';




'use client';
const $24c1263c48f9e850$export$90a89c9afeaf6dc7 = (props, ref)=>{
    const { avatar: avatar, presenceOnly: presenceOnly = false, size: size = 'medium', textAlignment: textAlignment = 'start', textPosition: textPosition = 'after', presence: presence, ...baseProps } = props;
    const state = $24c1263c48f9e850$export$7360cc125e9942eb(baseProps, ref);
    return {
        ...state,
        presenceOnly: presenceOnly,
        size: size,
        textAlignment: textAlignment,
        textPosition: textPosition,
        components: {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ...state.components,
            avatar: (0, $f5cb7a3ee98d12a7$export$e2255cf6045e8d47),
            presence: (0, $c703897f92f480c4$export$c661d384a5bd3b9c)
        },
        avatar: !presenceOnly ? (0, $fcf7ddccaab7fd8f$exports).optional(avatar, {
            renderByDefault: true,
            defaultProps: {
                name: props.name,
                badge: presence,
                size: $24c1263c48f9e850$var$avatarSizes[size]
            },
            elementType: (0, $f5cb7a3ee98d12a7$export$e2255cf6045e8d47)
        }) : undefined,
        presence: presenceOnly ? (0, $fcf7ddccaab7fd8f$exports).optional(presence, {
            defaultProps: {
                size: $24c1263c48f9e850$var$presenceSizes[size]
            },
            elementType: (0, $c703897f92f480c4$export$c661d384a5bd3b9c)
        }) : undefined
    };
};
const $24c1263c48f9e850$export$7360cc125e9942eb = (props, ref)=>{
    const { name: name, primaryText: primaryTextProp, secondaryText: secondaryTextProp, tertiaryText: tertiaryTextProp, quaternaryText: quaternaryTextProp, ...rest } = props;
    const primaryText = (0, $fcf7ddccaab7fd8f$exports).optional(primaryTextProp, {
        renderByDefault: true,
        defaultProps: {
            children: name
        },
        elementType: 'span'
    });
    const secondaryText = (0, $fcf7ddccaab7fd8f$exports).optional(secondaryTextProp, {
        elementType: 'span'
    });
    const tertiaryText = (0, $fcf7ddccaab7fd8f$exports).optional(tertiaryTextProp, {
        elementType: 'span'
    });
    const quaternaryText = (0, $fcf7ddccaab7fd8f$exports).optional(quaternaryTextProp, {
        elementType: 'span'
    });
    const numTextLines = [
        primaryText,
        secondaryText,
        tertiaryText,
        quaternaryText
    ].filter(Boolean).length;
    return {
        numTextLines: numTextLines,
        components: {
            root: 'div',
            primaryText: 'span',
            secondaryText: 'span',
            tertiaryText: 'span',
            quaternaryText: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: ref,
            ...rest
        }, {
            elementType: 'div'
        }),
        primaryText: primaryText,
        secondaryText: secondaryText,
        tertiaryText: tertiaryText,
        quaternaryText: quaternaryText
    };
};
const $24c1263c48f9e850$var$presenceSizes = {
    'extra-small': 'tiny',
    small: 'extra-small',
    medium: 'small',
    large: 'medium',
    'extra-large': 'large',
    huge: 'large'
};
const $24c1263c48f9e850$var$avatarSizes = {
    'extra-small': 20,
    small: 28,
    medium: 32,
    large: 36,
    'extra-large': 40,
    huge: 56
};




'use client';
const $f352fe4b53e2948a$export$824f7556a4b15a0f = {
    root: 'fui-Persona',
    avatar: 'fui-Persona__avatar',
    presence: 'fui-Persona__presence',
    primaryText: 'fui-Persona__primaryText',
    secondaryText: 'fui-Persona__secondaryText',
    tertiaryText: 'fui-Persona__tertiaryText',
    quaternaryText: 'fui-Persona__quaternaryText'
};
const $f352fe4b53e2948a$var$avatarSpacing = `--fui-Persona__avatar--spacing`;
const $f352fe4b53e2948a$var$useRootClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rlroi9i", null, [
    ".rlroi9i{display:inline-grid;grid-auto-rows:max-content;grid-auto-flow:column;justify-items:start;grid-template-columns:max-content [middle] auto;}"
]);
/**
 * Styles for the root slot
 */ const $f352fe4b53e2948a$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    beforeAfterCenter: {
        wkccdc: "f1iantul"
    },
    after: {},
    before: {
        B7hvi0a: "f1tll2w5",
        Budl1dq: "ffvkwdr"
    },
    below: {
        Bxotwcr: "f1nkeedh",
        B7hvi0a: "f1oiokrs",
        Budl1dq: "f1emgwh2"
    },
    media: {
        Ijaq50: "f1hek2iy"
    },
    mediaBeforeAfterCenter: {
        Ijaq50: "fa4dipu"
    },
    start: {
        qb2dma: "f9h729m"
    },
    center: {
        qb2dma: "f7nlbp4"
    },
    afterAlignToPrimary: {
        qb2dma: "f7nlbp4",
        Ijaq50: "f1rnkkuc",
        Bw0ie65: "f1warjpf"
    },
    beforeAlignToPrimary: {
        qb2dma: "f7nlbp4",
        Ijaq50: "f1rnkkuc",
        Br312pm: "fwu52yu"
    },
    secondLineSpacing: {
        B6of3ja: "f1ryq6si"
    },
    primary: {
        Ijaq50: "f1q3ipgb"
    },
    secondary: {
        Ijaq50: "f3drtdk"
    },
    tertiary: {
        Ijaq50: "fa1o6s1"
    },
    quaternary: {
        Ijaq50: "f1tuwaia"
    }
}, {
    d: [
        ".f1iantul{grid-template-rows:1fr [primary] max-content [secondary] max-content [tertiary] max-content [quaternary] max-content 1fr;}",
        ".f1tll2w5{justify-items:end;}",
        ".ffvkwdr{grid-template-columns:auto [middle] max-content;}",
        ".f1nkeedh{grid-auto-flow:unset;}",
        ".f1oiokrs{justify-items:center;}",
        ".f1emgwh2{grid-template-columns:unset;}",
        ".f1hek2iy{grid-row-start:span 5;}",
        ".fa4dipu{grid-row-start:span 6;}",
        ".f9h729m{align-self:start;}",
        ".f7nlbp4{align-self:center;}",
        ".f1rnkkuc{grid-row-start:unset;}",
        ".f1warjpf{grid-column-end:middle;}",
        ".fwu52yu{grid-column-start:middle;}",
        ".f1ryq6si{margin-top:-2px;}",
        ".f1q3ipgb{grid-row-start:primary;}",
        ".f3drtdk{grid-row-start:secondary;}",
        ".fa1o6s1{grid-row-start:tertiary;}",
        ".f1tuwaia{grid-row-start:quaternary;}"
    ]
});
const $f352fe4b53e2948a$var$useAvatarSpacingStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    "extra-small": {
        Bs1gm4r: "f1e48tse"
    },
    small: {
        Bs1gm4r: "f18q9vkd"
    },
    medium: {
        Bs1gm4r: "f18q9vkd"
    },
    large: {
        Bs1gm4r: "fx34bi6"
    },
    "extra-large": {
        Bs1gm4r: "fx34bi6"
    },
    huge: {
        Bs1gm4r: "f1o96qtm"
    },
    after: {
        t21cq0: [
            "f103ycu4",
            "f1tao51"
        ]
    },
    below: {
        jrapky: "fbo7acy"
    },
    before: {
        Frg6f3: [
            "f1tao51",
            "f103ycu4"
        ]
    }
}, {
    d: [
        ".f1e48tse{--fui-Persona__avatar--spacing:var(--spacingHorizontalSNudge);}",
        ".f18q9vkd{--fui-Persona__avatar--spacing:var(--spacingHorizontalS);}",
        ".fx34bi6{--fui-Persona__avatar--spacing:var(--spacingHorizontalMNudge);}",
        ".f1o96qtm{--fui-Persona__avatar--spacing:var(--spacingHorizontalM);}",
        ".f103ycu4{margin-right:var(--fui-Persona__avatar--spacing);}",
        ".f1tao51{margin-left:var(--fui-Persona__avatar--spacing);}",
        ".fbo7acy{margin-bottom:var(--fui-Persona__avatar--spacing);}"
    ]
});
const $f352fe4b53e2948a$var$usePresenceSpacingStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    small: {
        Bs1gm4r: "f1e48tse"
    }
}, {
    d: [
        ".f1e48tse{--fui-Persona__avatar--spacing:var(--spacingHorizontalSNudge);}"
    ]
});
const $f352fe4b53e2948a$export$82835d68be10bcc3 = (state)=>{
    const { presenceOnly: presenceOnly, size: size, textAlignment: textAlignment, textPosition: textPosition } = state;
    const alignToPrimary = presenceOnly && textAlignment === 'start' && size !== 'extra-large' && size !== 'huge';
    const alignBeforeAfterCenter = textPosition !== 'below' && textAlignment === 'center';
    const { primaryTextClassName: primaryTextClassName, optionalTextClassName: optionalTextClassName } = $f352fe4b53e2948a$var$useTextClassNames(state, alignToPrimary);
    const rootClassName = $f352fe4b53e2948a$var$useRootClassName();
    const styles = $f352fe4b53e2948a$var$useStyles();
    const avatarSpacingStyles = $f352fe4b53e2948a$var$useAvatarSpacingStyles();
    const presenceSpacingStyles = {
        ...avatarSpacingStyles,
        ...$f352fe4b53e2948a$var$usePresenceSpacingStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.root, rootClassName, alignBeforeAfterCenter && styles.beforeAfterCenter, styles[textPosition], state.root.className);
    if (state.avatar) // eslint-disable-next-line react-hooks/immutability
    state.avatar.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.avatar, textPosition !== 'below' && styles.media, alignBeforeAfterCenter && styles.mediaBeforeAfterCenter, styles[textAlignment], avatarSpacingStyles[size], avatarSpacingStyles[textPosition], state.avatar.className);
    if (state.presence) // eslint-disable-next-line react-hooks/immutability
    state.presence.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.presence, textPosition !== 'below' && styles.media, alignBeforeAfterCenter && styles.mediaBeforeAfterCenter, styles[textAlignment], presenceSpacingStyles[size], presenceSpacingStyles[textPosition], textPosition === 'after' && alignToPrimary && styles.afterAlignToPrimary, textPosition === 'before' && alignToPrimary && styles.beforeAlignToPrimary, state.presence.className);
    if (state.primaryText) // eslint-disable-next-line react-hooks/immutability
    state.primaryText.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.primaryText, alignBeforeAfterCenter && styles.primary, primaryTextClassName, state.primaryText.className);
    if (state.secondaryText) // eslint-disable-next-line react-hooks/immutability
    state.secondaryText.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.secondaryText, alignBeforeAfterCenter && styles.secondary, optionalTextClassName, styles.secondLineSpacing, state.secondaryText.className);
    if (state.tertiaryText) // eslint-disable-next-line react-hooks/immutability
    state.tertiaryText.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.tertiaryText, alignBeforeAfterCenter && styles.tertiary, optionalTextClassName, state.tertiaryText.className);
    if (state.quaternaryText) // eslint-disable-next-line react-hooks/immutability
    state.quaternaryText.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f352fe4b53e2948a$export$824f7556a4b15a0f.quaternaryText, alignBeforeAfterCenter && styles.quaternary, optionalTextClassName, state.quaternaryText.className);
    return state;
};
const $f352fe4b53e2948a$var$usePrimaryTextBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rvj41k9", null, [
    ".rvj41k9{display:block;color:var(--colorNeutralForeground1);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);}"
]);
const $f352fe4b53e2948a$var$useOptionalTextBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rp1pf9e", null, [
    ".rp1pf9e{display:block;color:var(--colorNeutralForeground2);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase200);}"
]);
const $f352fe4b53e2948a$var$useTextStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    beforeAlignToPrimary: {
        Bw0ie65: "f1warjpf"
    },
    afterAlignToPrimary: {
        Br312pm: "fwu52yu"
    },
    body1: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    caption1: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    subtitle2: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".f1warjpf{grid-column-end:middle;}",
        ".fwu52yu{grid-column-start:middle;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
});
const $f352fe4b53e2948a$var$useTextClassNames = (state, alignToPrimary)=>{
    const { presenceOnly: presenceOnly, size: size, textPosition: textPosition } = state;
    const primaryTextBaseClassName = $f352fe4b53e2948a$var$usePrimaryTextBaseClassName();
    const optionalTextBaseClassName = $f352fe4b53e2948a$var$useOptionalTextBaseClassName();
    const textStyles = $f352fe4b53e2948a$var$useTextStyles();
    let primaryTextSize;
    let alignToPrimaryClassName;
    if (presenceOnly) {
        if (size === 'extra-small') primaryTextSize = state.numTextLines <= 1 && textStyles.caption1;
        else if (size === 'extra-large' || size === 'huge') primaryTextSize = textStyles.subtitle2;
        if (alignToPrimary) {
            if (textPosition === 'before') alignToPrimaryClassName = textStyles.beforeAlignToPrimary;
            else if (textPosition === 'after') alignToPrimaryClassName = textStyles.afterAlignToPrimary;
        }
    } else {
        if (size === 'huge') primaryTextSize = textStyles.subtitle2;
        else if (size === 'extra-large') primaryTextSize = textStyles.subtitle2;
    }
    return {
        primaryTextClassName: (0, $00898283de415a49$export$3d46f4579dba46e5)(primaryTextBaseClassName, primaryTextSize, alignToPrimaryClassName),
        optionalTextClassName: (0, $00898283de415a49$export$3d46f4579dba46e5)(optionalTextBaseClassName, !presenceOnly && size === 'huge' && textStyles.body1, alignToPrimaryClassName)
    };
};



'use client';
const $cd0a80e701eedf7e$export$379de9fa197ff43a = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $24c1263c48f9e850$export$90a89c9afeaf6dc7)(props, ref);
    (0, $f352fe4b53e2948a$export$82835d68be10bcc3)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('usePersonaStyles_unstable')(state);
    return (0, $84b411a0db8b75a6$export$5fd48491453f80f0)(state);
});
$cd0a80e701eedf7e$export$379de9fa197ff43a.displayName = 'Persona';


var $acw62 = parcelRequire("acw62");




'use client';
const $6c8e51502d1b9754$export$439337d8d48a56fd = (props, ref)=>{
    const contentRef = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.contentRef);
    const openOnHover = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.openOnHover);
    const setOpen = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.setOpen);
    const mountNode = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.mountNode);
    const arrowRef = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.arrowRef);
    const size = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.size);
    const withArrow = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.withArrow);
    const appearance = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.appearance);
    const trapFocus = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.trapFocus);
    const inertTrapFocus = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.inertTrapFocus);
    const inline = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.inline);
    const motionForwardedRef = (0, $59b10a9d6ce22ca1$export$303310ce19d9244b)();
    const { modalAttributes: modalAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)({
        trapFocus: trapFocus,
        legacyTrapFocus: !inertTrapFocus,
        alwaysFocusable: !trapFocus
    });
    const state = {
        inline: inline,
        appearance: appearance,
        withArrow: withArrow,
        size: size,
        arrowRef: arrowRef,
        mountNode: mountNode,
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `contentRef` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, contentRef, motionForwardedRef),
            role: trapFocus ? 'dialog' : 'group',
            'aria-modal': trapFocus ? true : undefined,
            ...modalAttributes,
            ...props
        }), {
            elementType: 'div'
        })
    };
    const { onMouseEnter: onMouseEnterOriginal, onMouseLeave: onMouseLeaveOriginal, onKeyDown: onKeyDownOriginal } = state.root;
    state.root.onMouseEnter = (e)=>{
        if (openOnHover) setOpen(e, true);
        onMouseEnterOriginal === null || onMouseEnterOriginal === void 0 || onMouseEnterOriginal(e);
    };
    state.root.onMouseLeave = (e)=>{
        if (openOnHover) setOpen(e, false);
        onMouseLeaveOriginal === null || onMouseLeaveOriginal === void 0 || onMouseLeaveOriginal(e);
    };
    state.root.onKeyDown = (e)=>{
        var _contentRef_current;
        // only close if the event happened inside the current popover
        // If using a stack of inline popovers, the user should call `stopPropagation` to avoid dismissing the entire stack
        if (e.key === 'Escape' && ((_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.contains(e.target))) {
            e.preventDefault();
            setOpen(e, false);
        }
        onKeyDownOriginal === null || onKeyDownOriginal === void 0 || onKeyDownOriginal(e);
    };
    return state;
};




/**
 * Sets the virtual parent of an element.
 *
 * @internal
 * @param child - Theme element to set the virtual parent
 * @param parent - The virtual parent, use `undefined` to remove a virtual parent relationship
 */ function $a62d9fc7d6a8280d$export$9bba5276a9c4d47(child, parent) {
    if (!child) return;
    Object.assign(child, {
        _virtual: {
            parent: parent
        }
    });
}



var $acw62 = parcelRequire("acw62");

function $9ed5fe7220c8736b$export$7bd6d57efd912bd1(mountNode) {
    if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(mountNode)) return {
        element: mountNode
    };
    if (typeof mountNode === 'object') {
        if (mountNode === null) return {
            element: null
        };
        return mountNode;
    }
    return {};
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * Provides a mount node for portals to render into.
 *
 * @internal
 */ const $de8cc288a4bee6b5$var$PortalMountNodeContext = $acw62.createContext(undefined);
const $de8cc288a4bee6b5$export$16fe5a8de449eeb8 = $de8cc288a4bee6b5$var$PortalMountNodeContext.Provider;
function $de8cc288a4bee6b5$export$8c7eb8a8bdc26bd6() {
    return $acw62.useContext($de8cc288a4bee6b5$var$PortalMountNodeContext);
}





'use client';
const $e72daaf780566451$export$ec6dc86269acedaa = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        qhf8xq: "f1euv43f",
        Bhzewxz: "f15twtuk",
        oyh7mz: [
            "f1vgc2s3",
            "f1e31b4d"
        ],
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        Bj3rh1h: "f494woh"
    }
}, {
    d: [
        ".f1euv43f{position:absolute;}",
        ".f15twtuk{top:0;}",
        ".f1vgc2s3{left:0;}",
        ".f1e31b4d{right:0;}",
        ".f494woh{z-index:1000000;}"
    ]
});


'use client';
const $7c03bb17e4640573$var$useInsertionEffect = $acw62.useInsertionEffect;
/**
 * Legacy element factory for React 17 and below. It's not safe for concurrent rendering.
 *
 * Creates a new element on a "document.body" to mount portals.
 */ const $7c03bb17e4640573$var$useLegacyElementFactory = (options)=>{
    const { className: className, dir: dir, focusVisibleRef: focusVisibleRef, targetNode: targetNode } = options;
    const targetElement = $acw62.useMemo(()=>{
        if (targetNode === undefined || options.disabled) return null;
        const element = targetNode.ownerDocument.createElement('div');
        targetNode.appendChild(element);
        return element;
    }, [
        targetNode,
        options.disabled
    ]);
    // Heads up!
    // This useMemo() call is intentional for React 17 & below.
    //
    // We don't want to re-create the portal element when its attributes change. This also cannot not be done in an effect
    // because, changing the value of CSS variables after an initial mount will trigger interesting CSS side effects like
    // transitions.
    // eslint-disable-next-line react-hooks/void-use-memo
    $acw62.useMemo(()=>{
        if (!targetElement) return;
        // eslint-disable-next-line react-hooks/immutability
        targetElement.className = className;
        targetElement.setAttribute('dir', dir);
        targetElement.setAttribute('data-portal-node', 'true');
        // eslint-disable-next-line react-hooks/refs
        focusVisibleRef.current = targetElement;
    }, [
        className,
        dir,
        targetElement,
        focusVisibleRef
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            targetElement === null || targetElement === void 0 || targetElement.remove();
        };
    }, [
        targetElement
    ]);
    return targetElement;
};
const $7c03bb17e4640573$var$initializeElementFactory = ()=>{
    let currentElement = undefined;
    function get(targetRoot, forceCreation) {
        if (currentElement) return currentElement;
        if (forceCreation) {
            currentElement = targetRoot.ownerDocument.createElement('div');
            targetRoot.appendChild(currentElement);
        }
        return currentElement;
    }
    function dispose() {
        if (currentElement) {
            currentElement.remove();
            currentElement = undefined;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
};
/**
 * This is a modern element factory for React 18 and above. It is safe for concurrent rendering.
 *
 * It abuses the fact that React will mount DOM once (unlike hooks), so by using a proxy we can intercept:
 * - the `remove()` method (we call it in `useEffect()`) and remove the element only when the portal is unmounted
 * - all other methods (and properties) will be called by React once a portal is mounted
 */ const $7c03bb17e4640573$var$useModernElementFactory = (options)=>{
    'use no memo'; // justified: compiler would optimize dispose — manual opt-out to preserve runtime behavior
    const { className: className, dir: dir, focusVisibleRef: focusVisibleRef, targetNode: targetNode } = options;
    const [elementFactory] = $acw62.useState($7c03bb17e4640573$var$initializeElementFactory);
    const elementProxy = $acw62.useMemo(()=>{
        if (targetNode === undefined || options.disabled) return null;
        return new Proxy({}, {
            get (_, property) {
                // Heads up!
                // `createPortal()` performs a check for `nodeType` property to determine if the mount node is a valid DOM node
                // before mounting the portal. We hardcode the value to `Node.ELEMENT_NODE` to pass this check and avoid
                // premature node creation
                if (property === 'nodeType') // Can't use the `Node.ELEMENT_NODE` as it's a browser API and  not available in all environments, e.g SSR
                return 1; // `Node.ELEMENT_NODE`
                // Heads up!
                // We intercept the `remove()` method to remove the mount node only when portal has been unmounted already.
                if (property === 'remove') {
                    const targetElement = elementFactory.get(targetNode, false);
                    if (targetElement) {
                        // If the mountElement has children, the portal is still mounted, otherwise we can dispose of it
                        const portalHasNoChildren = targetElement.childNodes.length === 0;
                        if (portalHasNoChildren) elementFactory.dispose();
                    }
                    return ()=>{
                    // Always return a no-op function to avoid errors in the code
                    };
                }
                const targetElement = elementFactory.get(targetNode, true);
                const targetProperty = targetElement ? targetElement[property] : undefined;
                if (typeof targetProperty === 'function') return targetProperty.bind(targetElement);
                return targetProperty;
            },
            set (_, property, value) {
                const ignoredProperty = property === '_virtual' || property === 'focusVisible';
                // We should use the `elementFactory.get(targetNode, !ignoredProperty)`,
                // but TypeScript requires a literal `true` or `false` for the overload signature.
                // This workaround ensures the correct overload is called and avoids TypeScript errors.
                const targetElement = ignoredProperty ? elementFactory.get(targetNode, false) : elementFactory.get(targetNode, true);
                if (ignoredProperty && !targetElement) // We ignore the `_virtual` and `focusVisible` properties to avoid conflicts with the proxy
                return true;
                if (targetElement) {
                    Object.assign(targetElement, {
                        [property]: value
                    });
                    return true;
                }
                return false;
            }
        });
    }, [
        elementFactory,
        targetNode,
        options.disabled
    ]);
    $7c03bb17e4640573$var$useInsertionEffect(()=>{
        if (!elementProxy) return;
        const classesToApply = className.split(' ').filter(Boolean);
        elementProxy.classList.add(...classesToApply);
        elementProxy.setAttribute('dir', dir);
        elementProxy.setAttribute('data-portal-node', 'true');
        focusVisibleRef.current = elementProxy;
        return ()=>{
            elementProxy.classList.remove(...classesToApply);
            elementProxy.removeAttribute('dir');
        };
    }, [
        className,
        dir,
        elementProxy,
        focusVisibleRef
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            elementProxy === null || elementProxy === void 0 || elementProxy.remove();
        };
    }, [
        elementProxy
    ]);
    return elementProxy;
};
/**
 * Element factory based on the React version.
 *
 * React 17 and below:
 * - useLegacyElementFactory
 *
 * React 18 and above:
 * - useModernElementFactory
 */ const $7c03bb17e4640573$var$useElementFactory = $7c03bb17e4640573$var$useInsertionEffect ? $7c03bb17e4640573$var$useModernElementFactory : $7c03bb17e4640573$var$useLegacyElementFactory;
const $7c03bb17e4640573$export$8c7eb8a8bdc26bd6 = (options)=>{
    'use no memo'; // justified: compiler would optimize usePortalMountNode — manual opt-out to preserve runtime behavior
    const { targetDocument: targetDocument, dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const mountNode = (0, $de8cc288a4bee6b5$export$8c7eb8a8bdc26bd6)();
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const focusVisibleRef = (0, $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6)();
    const classes = (0, $e72daaf780566451$export$ec6dc86269acedaa)();
    const themeClassName = (0, $74a09e92d7894ea3$export$4996399749b19890)();
    const factoryOptions = {
        dir: dir,
        disabled: options.disabled,
        focusVisibleRef: focusVisibleRef,
        className: (0, $00898283de415a49$export$3d46f4579dba46e5)(themeClassName, classes.root, options.className),
        targetNode: mountNode !== null && mountNode !== void 0 ? mountNode : targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.body
    };
    return $7c03bb17e4640573$var$useElementFactory(factoryOptions);
};


'use client';
const $b67d1705a4bed2eb$export$bec3100fd3eeaea0 = (props)=>{
    const { element: element, className: className } = (0, $9ed5fe7220c8736b$export$7bd6d57efd912bd1)(props.mountNode);
    const virtualParentRootRef = $acw62.useRef(null);
    const fallbackElement = (0, $7c03bb17e4640573$export$8c7eb8a8bdc26bd6)({
        disabled: !!element,
        className: className
    });
    const mountNode = element !== null && element !== void 0 ? element : fallbackElement;
    const state = {
        children: props.children,
        mountNode: mountNode,
        virtualParentRootRef: virtualParentRootRef
    };
    $acw62.useEffect(()=>{
        if (!mountNode) return;
        const virtualParent = virtualParentRootRef.current;
        // By default, we create a mount node for portal on `document.body` (see usePortalMountNode()) and have following structure:
        //
        // <body>
        //   <!-- ⚛️ application root -->
        //   <div id="root">
        //     <!-- ⬇️ portal node rendered in a tree to anchor (virtual parent node) -->
        //     <span aria-hidden="true"></span>
        //   </div>
        //   <div id="portal-mount-node">
        //     <!-- 🧩portal content -->
        //   </div>
        // </body>
        //
        // To make sure that `.elementContains()` works correctly, we link a virtual parent to a portal node (a virtual parent node becomes a parent of mount node):
        //   virtual.contains(mountNode) === false
        //   (while we need ⬇️⬇️⬇️)
        //   elementsContains(virtualParent, mountNode) === true
        //   elementsContains(mountNode, virtualParent) === false
        //
        // For more details, check docs for virtual parent utils.
        //
        // However, if a user provides a custom mount node (via `props`) the structure could be different:
        //
        // <body>
        //   <!-- application root -->
        //   <div id="root">
        //     <div id="portal-mount-node">
        //       <!-- 🧩portal content -->
        //
        //       <span aria-hidden="true"></span>
        //     </div>
        //   </div>
        // </body>
        //
        // A mount node in this case contains portal's content and a virtual parent node. In this case nodes linking is redundant and the check below avoids it.
        //
        // Otherwise, there is a circular reference - both elements are parents of each other:
        //   elementsContains(mountNode, virtualParent) === true
        //   elementsContains(virtualParent, mountNode) === true
        const isVirtualParentInsideChild = mountNode.contains(virtualParent);
        if (virtualParent && !isVirtualParentInsideChild) {
            (0, $a62d9fc7d6a8280d$export$9bba5276a9c4d47)(mountNode, virtualParent);
            return ()=>{
                (0, $a62d9fc7d6a8280d$export$9bba5276a9c4d47)(mountNode, undefined);
            };
        }
    }, [
        virtualParentRootRef,
        mountNode
    ]);
    return state;
};



var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
const $8f16234fd734c188$export$a4ab4d705b845138 = (state)=>{
    return /*#__PURE__*/ $acw62.createElement("span", {
        hidden: true,
        ref: state.virtualParentRootRef
    }, state.mountNode && /*#__PURE__*/ $1u0KT.createPortal(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, state.children, /*#__PURE__*/ $acw62.createElement("span", {
        hidden: true
    })), state.mountNode));
};


'use client';
const $aa8a2d30f790b072$export$602eac185826482c = (props)=>{
    const state = (0, $b67d1705a4bed2eb$export$bec3100fd3eeaea0)(props);
    return (0, $8f16234fd734c188$export$a4ab4d705b845138)(state);
};
$aa8a2d30f790b072$export$602eac185826482c.displayName = 'Portal';


const $3381809413785a79$export$e181f1710656c571 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const surface = /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.withArrow && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)("div", {
                ref: state.arrowRef,
                className: state.arrowClassName
            }),
            state.root.children
        ]
    });
    if (state.inline) return surface;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $aa8a2d30f790b072$export$602eac185826482c), {
        mountNode: state.mountNode,
        children: surface
    });
};




'use client';
const $e8c10046741b8692$export$8b7437164e479115 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $6c8e51502d1b9754$export$439337d8d48a56fd)(props, ref);
    (0, $b0397c93cedc8a09$export$8e46f2e5324a79b8)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('usePopoverSurfaceStyles_unstable')(state);
    return (0, $3381809413785a79$export$e181f1710656c571)(state);
});
$e8c10046741b8692$export$8b7437164e479115.displayName = 'PopoverSurface';


var $acw62 = parcelRequire("acw62");


const $df65c35a44b0e9f1$export$a90cc53435b2dd3c = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
        children: state.root.children !== undefined && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.wrapper, {
            children: state.root.children
        })
    });
};



'use client';
const $6e21bbda1b6a6487$export$36b3c2d7e56dde7a = (props, ref)=>{
    const { alignContent: alignContent = 'center', appearance: appearance = 'default', inset: inset = false, ...rest } = props;
    const state = $6e21bbda1b6a6487$export$4dc9e8b25494327f(rest, ref);
    return {
        alignContent: alignContent,
        appearance: appearance,
        inset: inset,
        ...state
    };
};
const $6e21bbda1b6a6487$export$4dc9e8b25494327f = (props, ref)=>{
    const { vertical: vertical = false, wrapper: wrapper, ...rest } = props;
    const dividerId = (0, $0200d30cfa270435$export$f680877a34711e37)('divider-');
    return {
        vertical: vertical,
        components: {
            root: 'div',
            wrapper: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            role: 'separator',
            'aria-orientation': vertical ? 'vertical' : 'horizontal',
            'aria-labelledby': props.children ? dividerId : undefined,
            ref: ref,
            ...rest
        }, {
            elementType: 'div'
        }),
        wrapper: (0, $fcf7ddccaab7fd8f$exports).always(wrapper, {
            defaultProps: {
                id: dividerId,
                children: props.children
            },
            elementType: 'div'
        })
    };
};




'use client';
const $d104f2b5d2c209db$export$423b66acf854747e = {
    root: 'fui-Divider',
    wrapper: 'fui-Divider__wrapper'
};
const $d104f2b5d2c209db$var$contentSpacing = '12px';
const $d104f2b5d2c209db$var$insetSpacing = '12px';
const $d104f2b5d2c209db$var$maxStartEndLength = '8px';
const $d104f2b5d2c209db$var$minStartEndLength = '8px;';
const $d104f2b5d2c209db$var$useBaseStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Bt984gj: "f122n59",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq",
        Bh6795r: "fqerorx",
        qhf8xq: "f10pi13n",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        fsow6f: "f17mccla",
        Bcvre1j: "fyl8oag",
        Br0sdwz: "f16vkdww",
        Bn78ew0: "fhsnbul",
        li1rpt: "f1gw3sf2",
        ap17g6: "f1ly5f7u",
        B771hl4: "f1s3tz6t"
    },
    childless: {
        susq4k: "f1kyqvp9",
        Bicfajf: [
            "fzynn9s",
            "f1z0ukd1"
        ],
        jwcpgy: [
            "fekrn8e",
            "ftdg338"
        ],
        B4rk6o: "fesgyo"
    },
    start: {
        Bsft5z2: "f13zj6fq"
    },
    center: {
        Ftih45: "f1wl9k8s",
        Bsft5z2: "f13zj6fq"
    },
    end: {
        Ftih45: "f1wl9k8s"
    },
    brand: {
        sj55zd: "f16muhyy",
        Bq4z7u6: "fcbuu2a",
        Bk5zm6e: [
            "f1wdw2dr",
            "f1ttio3w"
        ],
        Bqjgrrk: "f1582fpk",
        Bm6vgfq: [
            "f1ttio3w",
            "f1wdw2dr"
        ],
        B0n5ga8: "f1ahrvm8",
        s924m2: [
            "f1cd3wbc",
            "f17hbk9y"
        ],
        B1q35kw: "fvrapl0",
        Gp14am: [
            "f17hbk9y",
            "f1cd3wbc"
        ]
    },
    "default": {
        sj55zd: "fkfq4zb",
        Bq4z7u6: "f1vccso1",
        Bk5zm6e: [
            "f1geml7w",
            "fjml6kk"
        ],
        Bqjgrrk: "f1r7kh1m",
        Bm6vgfq: [
            "fjml6kk",
            "f1geml7w"
        ],
        B0n5ga8: "f16j7guv",
        s924m2: [
            "fx01ahm",
            "fj1a37q"
        ],
        B1q35kw: "fl8d8yv",
        Gp14am: [
            "fj1a37q",
            "fx01ahm"
        ]
    },
    subtle: {
        sj55zd: "f11d4kpn",
        Bq4z7u6: "f5g06un",
        Bk5zm6e: [
            "f13sxdku",
            "f1n015lb"
        ],
        Bqjgrrk: "f1x6bl8t",
        Bm6vgfq: [
            "f1n015lb",
            "f13sxdku"
        ],
        B0n5ga8: "fvod1wy",
        s924m2: [
            "fwslg65",
            "flk0e17"
        ],
        B1q35kw: "f103fvts",
        Gp14am: [
            "flk0e17",
            "fwslg65"
        ]
    },
    strong: {
        sj55zd: "f19n0e5",
        Bq4z7u6: "f10tv6oz",
        Bk5zm6e: [
            "f16xp3sf",
            "f1seuxxq"
        ],
        Bqjgrrk: "fwrmqbx",
        Bm6vgfq: [
            "f1seuxxq",
            "f16xp3sf"
        ],
        B0n5ga8: "ft83z1f",
        s924m2: [
            "f1g4150c",
            "f192dr6e"
        ],
        B1q35kw: "f1qnawh6",
        Gp14am: [
            "f192dr6e",
            "f1g4150c"
        ]
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".fqerorx{flex-grow:1;}",
        ".f10pi13n{position:relative;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f17mccla{text-align:center;}",
        ".fyl8oag::before{box-sizing:border-box;}",
        ".f16vkdww::before{display:flex;}",
        ".fhsnbul::before{flex-grow:1;}",
        ".f1gw3sf2::after{box-sizing:border-box;}",
        ".f1ly5f7u::after{display:flex;}",
        ".f1s3tz6t::after{flex-grow:1;}",
        ".f1kyqvp9::before{margin-bottom:0;}",
        ".fzynn9s::before{margin-right:0;}",
        ".f1z0ukd1::before{margin-left:0;}",
        ".fekrn8e::after{margin-left:0;}",
        ".ftdg338::after{margin-right:0;}",
        ".fesgyo::after{margin-top:0;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f16muhyy{color:var(--colorBrandForeground1);}",
        ".fcbuu2a::before{border-top-color:var(--colorBrandStroke1);}",
        ".f1wdw2dr::before{border-right-color:var(--colorBrandStroke1);}",
        ".f1ttio3w::before{border-left-color:var(--colorBrandStroke1);}",
        ".f1582fpk::before{border-bottom-color:var(--colorBrandStroke1);}",
        ".f1ahrvm8::after{border-top-color:var(--colorBrandStroke1);}",
        ".f1cd3wbc::after{border-right-color:var(--colorBrandStroke1);}",
        ".f17hbk9y::after{border-left-color:var(--colorBrandStroke1);}",
        ".fvrapl0::after{border-bottom-color:var(--colorBrandStroke1);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f1vccso1::before{border-top-color:var(--colorNeutralStroke2);}",
        ".f1geml7w::before{border-right-color:var(--colorNeutralStroke2);}",
        ".fjml6kk::before{border-left-color:var(--colorNeutralStroke2);}",
        ".f1r7kh1m::before{border-bottom-color:var(--colorNeutralStroke2);}",
        ".f16j7guv::after{border-top-color:var(--colorNeutralStroke2);}",
        ".fx01ahm::after{border-right-color:var(--colorNeutralStroke2);}",
        ".fj1a37q::after{border-left-color:var(--colorNeutralStroke2);}",
        ".fl8d8yv::after{border-bottom-color:var(--colorNeutralStroke2);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f5g06un::before{border-top-color:var(--colorNeutralStroke3);}",
        ".f13sxdku::before{border-right-color:var(--colorNeutralStroke3);}",
        ".f1n015lb::before{border-left-color:var(--colorNeutralStroke3);}",
        ".f1x6bl8t::before{border-bottom-color:var(--colorNeutralStroke3);}",
        ".fvod1wy::after{border-top-color:var(--colorNeutralStroke3);}",
        ".fwslg65::after{border-right-color:var(--colorNeutralStroke3);}",
        ".flk0e17::after{border-left-color:var(--colorNeutralStroke3);}",
        ".f103fvts::after{border-bottom-color:var(--colorNeutralStroke3);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f10tv6oz::before{border-top-color:var(--colorNeutralStroke1);}",
        ".f16xp3sf::before{border-right-color:var(--colorNeutralStroke1);}",
        ".f1seuxxq::before{border-left-color:var(--colorNeutralStroke1);}",
        ".fwrmqbx::before{border-bottom-color:var(--colorNeutralStroke1);}",
        ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}",
        ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}",
        ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}",
        ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}"
    ]
});
const $d104f2b5d2c209db$var$useHorizontalStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        a9b677: "fly5x3f",
        Bdkvgpv: "f163fonl",
        B0qfbqy: "f51yk4v",
        pbipgd: "f13rof3u",
        Bm2nyyq: "f8rth92",
        xrcqlc: "f6czdpx",
        i5u598: "f1iyka9k"
    },
    inset: {
        uwmqm3: [
            "fjlbh76",
            "f11qrl6u"
        ],
        z189sj: [
            "f11qrl6u",
            "fjlbh76"
        ]
    },
    start: {
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        Ftih45: "f1wl9k8s",
        Bicfajf: [
            "f1ojjlep",
            "fk1kexq"
        ],
        Bxwl2t9: "f1he2m4d",
        jwcpgy: [
            "f12w1bnb",
            "f1558wlj"
        ]
    },
    center: {
        fsow6f: "f17mccla",
        Bicfajf: [
            "f1ojjlep",
            "fk1kexq"
        ],
        jwcpgy: [
            "f12w1bnb",
            "f1558wlj"
        ]
    },
    end: {
        fsow6f: [
            "fes3tcz",
            "f1o700av"
        ],
        Bicfajf: [
            "f1ojjlep",
            "fk1kexq"
        ],
        Bsft5z2: "f13zj6fq",
        jwcpgy: [
            "f12w1bnb",
            "f1558wlj"
        ],
        Iy66sp: "f1ayce8x"
    }
}, {
    d: [
        ".fly5x3f{width:100%;}",
        ".f163fonl::before{border-top-style:solid;}",
        ".f51yk4v::before{border-top-width:var(--strokeWidthThin);}",
        ".f13rof3u::before{min-width:8px;}",
        ".f8rth92::after{border-top-style:solid;}",
        ".f6czdpx::after{border-top-width:var(--strokeWidthThin);}",
        ".f1iyka9k::after{min-width:8px;}",
        ".fjlbh76{padding-left:12px;}",
        ".f11qrl6u{padding-right:12px;}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1ojjlep::before{margin-right:12px;}",
        ".fk1kexq::before{margin-left:12px;}",
        ".f1he2m4d::before{max-width:8px;}",
        ".f12w1bnb::after{margin-left:12px;}",
        ".f1558wlj::after{margin-right:12px;}",
        ".f17mccla{text-align:center;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1ayce8x::after{max-width:8px;}"
    ]
});
const $d104f2b5d2c209db$var$useVerticalStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Beiy3e4: "f1vx9l62",
        sshi5w: "f16gbxbe",
        m598lv: [
            "f1yq6w5o",
            "f1jpmc5p"
        ],
        B4f6apu: [
            "f9sc749",
            "f1x8pvcy"
        ],
        zkzzav: "fhkwbjy",
        Barhvk9: [
            "flthirb",
            "ftkbnf5"
        ],
        Ihftqj: [
            "f13hvwk3",
            "f1en4csx"
        ],
        Bde111x: "f19onpk6"
    },
    inset: {
        B6of3ja: "f1xdg43u",
        jrapky: "f1jlhsmd"
    },
    withChildren: {
        sshi5w: "f1tjaq3g"
    },
    start: {
        Ftih45: "f1wl9k8s",
        susq4k: "fg2pwug",
        Bbdr6tz: "fkjtzyi",
        B4rk6o: "f8vk40g"
    },
    center: {
        susq4k: "fg2pwug",
        B4rk6o: "f8vk40g"
    },
    end: {
        susq4k: "fg2pwug",
        Bsft5z2: "f13zj6fq",
        B4rk6o: "f8vk40g",
        gn64ia: "fqg5mu5"
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}",
        ".f16gbxbe{min-height:20px;}",
        ".f1yq6w5o::before{border-right-style:solid;}",
        ".f1jpmc5p::before{border-left-style:solid;}",
        ".f9sc749::before{border-right-width:var(--strokeWidthThin);}",
        ".f1x8pvcy::before{border-left-width:var(--strokeWidthThin);}",
        ".fhkwbjy::before{min-height:8px;}",
        ".flthirb::after{border-right-style:solid;}",
        ".ftkbnf5::after{border-left-style:solid;}",
        ".f13hvwk3::after{border-right-width:var(--strokeWidthThin);}",
        ".f1en4csx::after{border-left-width:var(--strokeWidthThin);}",
        ".f19onpk6::after{min-height:8px;}",
        ".f1xdg43u{margin-top:12px;}",
        ".f1jlhsmd{margin-bottom:12px;}",
        ".f1tjaq3g{min-height:84px;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".fg2pwug::before{margin-bottom:12px;}",
        ".fkjtzyi::before{max-height:8px;}",
        ".f8vk40g::after{margin-top:12px;}",
        ".f13zj6fq::after{content:\"\";}",
        ".fqg5mu5::after{max-height:8px;}"
    ]
});
const $d104f2b5d2c209db$export$63d391acf033ebc1 = (state)=>{
    const baseStyles = $d104f2b5d2c209db$var$useBaseStyles();
    const horizontalStyles = $d104f2b5d2c209db$var$useHorizontalStyles();
    const verticalStyles = $d104f2b5d2c209db$var$useVerticalStyles();
    const { alignContent: alignContent, appearance: appearance, inset: inset, vertical: vertical } = state;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($d104f2b5d2c209db$export$423b66acf854747e.root, // Base styles
    baseStyles.base, baseStyles[alignContent], appearance && baseStyles[appearance], // Horizontal styles
    !vertical && horizontalStyles.base, !vertical && inset && horizontalStyles.inset, !vertical && horizontalStyles[alignContent], // Vertical styles
    vertical && verticalStyles.base, vertical && inset && verticalStyles.inset, vertical && verticalStyles[alignContent], vertical && state.root.children !== undefined && verticalStyles.withChildren, // Childless styles
    state.root.children === undefined && baseStyles.childless, // User provided class name
    state.root.className);
    if (state.wrapper) // eslint-disable-next-line react-hooks/immutability
    state.wrapper.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($d104f2b5d2c209db$export$423b66acf854747e.wrapper, state.wrapper.className);
    return state;
};



'use client';
const $eff1c0331983e5b2$export$2e0a83ec2e27ecbb = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $6e21bbda1b6a6487$export$36b3c2d7e56dde7a)(props, ref);
    (0, $d104f2b5d2c209db$export$63d391acf033ebc1)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDividerStyles_unstable')(state);
    return (0, $df65c35a44b0e9f1$export$a90cc53435b2dd3c)(state);
});
$eff1c0331983e5b2$export$2e0a83ec2e27ecbb.displayName = 'Divider';


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $65acf7eb8449fd1a$export$94fbbc9036f68c2c = $acw62.createContext(undefined);
const $65acf7eb8449fd1a$export$4fb4a984b1762672 = $65acf7eb8449fd1a$export$94fbbc9036f68c2c.Provider;
function $65acf7eb8449fd1a$export$9d103812d8321e51() {
    return $acw62.useContext($65acf7eb8449fd1a$export$94fbbc9036f68c2c);
}



const $0a10c811c5084e5b$export$f68464052953e8a8 = (state)=>{
    const { disabled: disabled, disabledFocusable: disabledFocusable } = state;
    const { onClick: onClick, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = state.root;
    // Add href for anchor elements.
    if (state.root.as === 'a') {
        state.root.href = disabled ? undefined : state.root.href;
        // Add role="link" for disabled and disabledFocusable links.
        if (disabled || disabledFocusable) state.root.role = role || 'link';
    }
    // Add tabIndex=0 for anchor and span elements.
    if (state.root.as === 'a' || state.root.as === 'span') state.root.tabIndex = tabIndex !== null && tabIndex !== void 0 ? tabIndex : disabled && !disabledFocusable ? undefined : 0;
    // Disallow click event when component is disabled and eat events when disabledFocusable is set to true.
    state.root.onClick = (ev)=>{
        if (disabled || disabledFocusable) ev.preventDefault();
        else onClick === null || onClick === void 0 || onClick(ev);
    };
    // Disallow keydown event when component is disabled and eat events when disabledFocusable is set to true.
    state.root.onKeyDown = (ev)=>{
        const keyPressed = ev.key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a) || ev.key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2);
        if ((disabled || disabledFocusable) && keyPressed) {
            ev.preventDefault();
            ev.stopPropagation();
        } else {
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(ev);
            // if there is already onKeyDown provided - respect it
            if (state.root.as === 'span' && !!state.root.onClick && !onKeyDown && keyPressed) {
                ev.preventDefault();
                ev.currentTarget.click();
            }
        }
    };
    // Set the aria-disabled and disabled props correctly.
    state.disabled = disabled || disabledFocusable;
    state.root['aria-disabled'] = disabled || disabledFocusable || undefined;
    if (state.root.as === 'button') state.root.disabled = disabled && !disabledFocusable;
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
const $d885c66a25ccfad9$var$LinkContext = $acw62.createContext(undefined);
const $d885c66a25ccfad9$export$440a9a6dada8f587 = {
    inline: false
};
const $d885c66a25ccfad9$export$3011c5161706fe87 = $d885c66a25ccfad9$var$LinkContext.Provider;
const $d885c66a25ccfad9$export$ecd094d2cbf46630 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($d885c66a25ccfad9$var$LinkContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $d885c66a25ccfad9$export$440a9a6dada8f587;
};


'use client';
const $419dd73e1b33038f$export$dbcadc0de391eca2 = (props, ref)=>{
    const backgroundAppearance = (0, $65acf7eb8449fd1a$export$9d103812d8321e51)();
    const { inline: inlineContext } = (0, $d885c66a25ccfad9$export$ecd094d2cbf46630)();
    const { appearance: appearance = 'default', inline: inlineProp, ...baseProps } = props;
    const state = $419dd73e1b33038f$export$7a93228dfecbcfd(baseProps, ref);
    return {
        appearance: appearance,
        backgroundAppearance: backgroundAppearance,
        inline: inlineProp !== null && inlineProp !== void 0 ? inlineProp : !!inlineContext,
        ...state
    };
};
const $419dd73e1b33038f$export$7a93228dfecbcfd = (props, ref)=>{
    const { disabled: disabled = false, disabledFocusable: disabledFocusable = false } = props;
    const elementType = props.as || (props.href ? 'a' : 'button');
    // Casting is required here as `as` prop would break the union between `a`, `button` and `span` types
    const propsWithAssignedAs = {
        role: elementType === 'span' ? 'button' : undefined,
        type: elementType === 'button' ? 'button' : undefined,
        ...props,
        as: elementType
    };
    const state = {
        disabled: // Props passed at the top-level
        disabled,
        disabledFocusable: disabledFocusable,
        // Slots definition
        components: {
            root: elementType
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(elementType, {
            ref: ref,
            ...propsWithAssignedAs
        }), {
            elementType: elementType
        })
    };
    (0, $0a10c811c5084e5b$export$f68464052953e8a8)(state);
    return state;
};





'use client';
const $041d625be201243d$export$61d8bdb99b8ba3a1 = {
    root: 'fui-Link'
};
const $041d625be201243d$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    focusIndicator: {
        Bttzg6e: "fhgqx19",
        B3uz8dt: "f1olyrje",
        B6ihwck: "f1p93eir",
        g9k6zt: "f1nev41a"
    },
    root: {
        B486eqv: "f2hkw1w",
        De3pzq: "f3rmtva",
        B7ck84d: "f1ewtqcl",
        sj55zd: "fyind8e",
        Bceei9c: "f1k6fduh",
        mc9l5x: "f1w7gpdv",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1s184ao",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1mk8lai",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "fnbmjn9",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        w71qe1: "f1iuv45f",
        Bkioxbp: "f1cmlufx",
        ygn44y: "f9n3di6",
        famaaq: "f1ids18y",
        Bde5pd6: "f1tx3yz7",
        Bi91k9c: "f1deo86v",
        i089h6: "f1eh06m1",
        lj723h: "f1iescvh"
    },
    button: {
        icvyot: "f1ern45e",
        vrafjx: [
            "f1n71otn",
            "f1deefiw"
        ],
        oivjwe: "f1h8hb77",
        wvpqe5: [
            "f1deefiw",
            "f1n71otn"
        ]
    },
    href: {
        Be2twd7: "fjoy568"
    },
    subtle: {
        sj55zd: "f2yjg6r",
        Bde5pd6: "f1tx3yz7",
        Bi91k9c: "fj1cjhr",
        i089h6: "f1eh06m1",
        lj723h: "fhucn0c"
    },
    inline: {
        w71qe1: "f13mvf36"
    },
    disabled: {
        w71qe1: "f1iuv45f",
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr",
        Bde5pd6: "fbnuktb",
        Bi91k9c: "fvgxktp",
        i089h6: "fljg2da",
        lj723h: "f19wldhg",
        B7iucu3: "f1cyfu5x",
        Bahaeuw: "fa9u7a5",
        Boo3t63: "fji3q0k"
    },
    inverted: {
        sj55zd: "f1qz2gb0",
        Bi91k9c: "f1ujg2k6",
        lj723h: "f1ebemlp"
    },
    brand: {
        sj55zd: "f179xftw",
        Bi91k9c: "f1sk1dtk",
        lj723h: "f182g21t"
    }
}, {
    d: [
        ".fhgqx19[data-fui-focus-visible]{text-decoration-color:var(--colorStrokeFocus2);}",
        ".f1olyrje[data-fui-focus-visible]{text-decoration-line:underline;}",
        ".f1p93eir[data-fui-focus-visible]{text-decoration-style:double;}",
        ".f1nev41a[data-fui-focus-visible]{outline-style:none;}",
        ".f3rmtva{background-color:transparent;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".fyind8e{color:var(--colorBrandForegroundLink);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f1w7gpdv{display:inline;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        [
            ".f1s184ao{margin:0;}",
            {
                p: -1
            }
        ],
        [
            ".f1mk8lai{padding:0;}",
            {
                p: -1
            }
        ],
        [
            ".fnbmjn9{overflow:inherit;}",
            {
                p: -1
            }
        ],
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".f1iuv45f{text-decoration-line:none;}",
        ".f1cmlufx{text-decoration-thickness:var(--strokeWidthThin);}",
        ".f9n3di6{text-overflow:inherit;}",
        ".f1ids18y{-webkit-user-select:text;-moz-user-select:text;user-select:text;}",
        ".f1ern45e{border-top-style:none;}",
        ".f1n71otn{border-right-style:none;}",
        ".f1deefiw{border-left-style:none;}",
        ".f1h8hb77{border-bottom-style:none;}",
        ".fjoy568{font-size:inherit;}",
        ".f2yjg6r{color:var(--colorNeutralForeground2Link);}",
        ".f13mvf36{text-decoration-line:underline;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1qz2gb0{color:var(--colorBrandForegroundInverted);}",
        ".f179xftw{color:var(--colorNeutralForegroundInvertedLink);}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    h: [
        ".f1tx3yz7:hover{text-decoration-line:underline;}",
        ".f1deo86v:hover{color:var(--colorBrandForegroundLinkHover);}",
        ".fj1cjhr:hover{color:var(--colorNeutralForeground2LinkHover);}",
        ".fbnuktb:hover{text-decoration-line:none;}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".f1ujg2k6:hover{color:var(--colorBrandForegroundInverted);}",
        ".f1sk1dtk:hover{color:var(--colorNeutralForegroundInvertedLinkHover);}"
    ],
    a: [
        ".f1eh06m1:active{text-decoration-line:underline;}",
        ".f1iescvh:active{color:var(--colorBrandForegroundLinkPressed);}",
        ".fhucn0c:active{color:var(--colorNeutralForeground2LinkPressed);}",
        ".fljg2da:active{text-decoration-line:none;}",
        ".f19wldhg:active{color:var(--colorNeutralForegroundDisabled);}",
        ".f1ebemlp:active{color:var(--colorBrandForegroundInverted);}",
        ".f182g21t:active{color:var(--colorNeutralForegroundInvertedLinkPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1cyfu5x{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fa9u7a5:hover{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fji3q0k:active{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $041d625be201243d$export$9c8ebd73e4dfb44d = (state)=>{
    const styles = $041d625be201243d$var$useStyles();
    const { appearance: appearance, disabled: disabled, inline: inline, root: root, backgroundAppearance: backgroundAppearance } = state;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($041d625be201243d$export$61d8bdb99b8ba3a1.root, styles.root, styles.focusIndicator, root.as === 'a' && root.href && styles.href, root.as === 'button' && styles.button, appearance === 'subtle' && styles.subtle, backgroundAppearance === 'inverted' && styles.inverted, backgroundAppearance === 'brand' && styles.brand, inline && styles.inline, disabled && styles.disabled, state.root.className);
    return state;
};




const $fb08e4625bcb1ff6$export$2830cd05a899db93 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};



'use client';
const $a69bfcc549c3c80e$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $419dd73e1b33038f$export$dbcadc0de391eca2)(props, ref);
    (0, $041d625be201243d$export$9c8ebd73e4dfb44d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useLinkStyles_unstable')(state);
    return (0, $fb08e4625bcb1ff6$export$2830cd05a899db93)(state);
// Work around some small mismatches in inferred types which don't matter in practice
});
$a69bfcc549c3c80e$export$a6c7ac8248d6e38a.displayName = 'Link';



const $e1f3abcc13b7af52$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    header: {
        "padding": "0.5rem",
        "display": "flex",
        "alignItems": "center",
        "gap": "0.5rem",
        "borderBottom": "1px solid " + (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralStroke2,
        "height": "55px"
    },
    headerFlexBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.5rem",
        "width": "100%",
        "& div.header-item": {
            display: "flex",
            alignItems: "center",
            gap: "0.5rem"
        }
    },
    accountContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
    }
});
function $e1f3abcc13b7af52$export$2e2bcd8739ae039() {
    const styles = $e1f3abcc13b7af52$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "outer-template",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                    className: styles.header,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: styles.headerFlexBox,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/",
                                title: "Omnivend Home",
                                style: {
                                    "textDecoration": "none",
                                    "color": "inherit"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "header-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7c88be82614dab2$export$3e431a229df88919), {
                                            src: "/images/Omnivend_Logo.webp",
                                            alt: "Omnivend Logo",
                                            style: {
                                                "width": "100%",
                                                "maxWidth": "200px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70f11c27d39d4df1$export$37acb3580601e69a), {
                                            size: "extra-large",
                                            shape: "rounded",
                                            appearance: "filled",
                                            color: "brand",
                                            children: "ALPHA"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "header-item",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d4448b917a5b7f9a$export$5b6b19405a83ff9d), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1d682872ff40f20$export$7dacb05d26466c3), {
                                            disableButtonEnhancement: true,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd0a80e701eedf7e$export$379de9fa197ff43a), {
                                                    name: "John Doe",
                                                    secondaryText: "Store Owner",
                                                    avatar: {
                                                        color: "colorful"
                                                    },
                                                    textAlignment: "center"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8c10046741b8692$export$8b7437164e479115), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: styles.accountContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd0a80e701eedf7e$export$379de9fa197ff43a), {
                                                        name: "John Doe",
                                                        size: "huge",
                                                        secondaryText: "Store Owner",
                                                        tertiaryText: "Unnamed Store",
                                                        avatar: {
                                                            color: "colorful"
                                                        },
                                                        textAlignment: "center"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eff1c0331983e5b2$export$2e0a83ec2e27ecbb), {}),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "0.5rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a69bfcc549c3c80e$export$a6c7ac8248d6e38a), {
                                                                href: "/settings",
                                                                children: "Change store settings"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a69bfcc549c3c80e$export$a6c7ac8248d6e38a), {
                                                                href: "#",
                                                                children: "Manage another store"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a69bfcc549c3c80e$export$a6c7ac8248d6e38a), {
                                                                href: "#",
                                                                children: "Logout"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$910ae8079b2c2852), {})
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $f151dc37217d3a88$var$defaultContextValue = {
    scrollState: 'none',
    setScrollState: ()=>({})
};
const $f151dc37217d3a88$export$4a4bc24a327716ab = $acw62.createContext(undefined);
const $f151dc37217d3a88$export$f4880ee0de17c178 = $f151dc37217d3a88$export$4a4bc24a327716ab.Provider;
const $f151dc37217d3a88$export$6bc0175b947a255a = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($f151dc37217d3a88$export$4a4bc24a327716ab)) !== null && _React_useContext !== void 0 ? _React_useContext : $f151dc37217d3a88$var$defaultContextValue;
};
const $f151dc37217d3a88$export$eab75d93bceeb157 = ()=>{
    const [scrollState, setScrollState] = $acw62.useState('none');
    return {
        setScrollState: setScrollState,
        scrollState: scrollState
    };
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $43f01c3e5f4f08d3$export$ed40f17238e0af3f(context) {
    const contextValue = $acw62.useContext(context);
    return !contextValue.isDefault;
}






var $acw62 = parcelRequire("acw62");


'use client';
function $47d27724afc6da6d$export$d0f293dfa88e13b7(open, modalType) {
    const { findFirstFocusable: findFirstFocusable } = (0, $708e79e1f2ab4237$export$2b0519dd5d2bc6d4)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const dialogRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!open) return;
        const element = dialogRef.current && findFirstFocusable(dialogRef.current);
        if (element) element.focus();
        else {
            var _dialogRef_current;
            (_dialogRef_current = dialogRef.current) === null || _dialogRef_current === void 0 || _dialogRef_current.focus(); // https://github.com/microsoft/fluentui/issues/25150
        }
    }, [
        findFirstFocusable,
        open,
        modalType,
        targetDocument
    ]);
    return dialogRef;
}



'use client';
const $1df5e8bcad6e85cf$var$defaultContextValue = {
    open: false,
    inertTrapFocus: false,
    modalType: 'modal',
    isNestedDialog: false,
    unmountOnClose: true,
    dialogRef: {
        current: null
    },
    requestOpenChange () {
    /* noop */ }
};
const $1df5e8bcad6e85cf$export$8b93a07348a7730c = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $1df5e8bcad6e85cf$export$7ab5cfe96fae86d3 = $1df5e8bcad6e85cf$export$8b93a07348a7730c.Provider;
const $1df5e8bcad6e85cf$export$907394755222dc8e = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($1df5e8bcad6e85cf$export$8b93a07348a7730c, (ctx = $1df5e8bcad6e85cf$var$defaultContextValue)=>selector(ctx));



function $e67c3d746f23a482$export$c5514cb9a2262e43(presenceFn, variantParams) {
    const variantFn = (runtimeParams)=>presenceFn({
            ...variantParams,
            ...runtimeParams
        });
    return variantFn;
}
function $e67c3d746f23a482$export$2911c0c000be902b(component, variantParams) {
    const originalFn = component[0, $a90210c34a8674c7$export$a121f71575b68679];
    // The variant params become new defaults, but they can still be overridden by runtime params.
    const variantFn = $e67c3d746f23a482$export$c5514cb9a2262e43(originalFn, variantParams);
    return (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(variantFn);
}





const $9d936c159f9ee23b$export$9ef44f32700e8ee4 = ({ direction: direction, duration: duration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear, delay: delay = 0, outScale: outScale = 0.9, inScale: inScale = 1 })=>{
    const keyframes = [
        {
            scale: outScale
        },
        {
            scale: inScale
        }
    ];
    if (direction === 'exit') keyframes.reverse();
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay
    };
};


/**
 * Define a presence motion for scale in/out
 *
 * @param duration - Time (ms) for the enter transition (scale-in). Defaults to the `durationGentle` value (250 ms).
 * @param easing - Easing curve for the enter transition (scale-in). Defaults to the `curveDecelerateMax` value.
 * @param delay - Time (ms) to delay the enter transition. Defaults to 0.
 * @param exitDuration - Time (ms) for the exit transition (scale-out). Defaults to the `durationNormal` value (200 ms).
 * @param exitEasing - Easing curve for the exit transition (scale-out). Defaults to the `curveAccelerateMax` value.
 * @param exitDelay - Time (ms) to delay the exit transition. Defaults to the `delay` param for symmetry.
 * @param outScale - Scale for the out state (exited). Defaults to `0.9`.
 * @param inScale - Scale for the in state (entered). Defaults to `1`.
 * @param animateOpacity - Whether to animate the opacity. Defaults to `true`.
 */ const $f0c450e3c364eadd$var$scalePresenceFn = ({ duration: duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMax, delay: delay = 0, exitDuration: exitDuration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal, exitEasing: exitEasing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveAccelerateMax, exitDelay: exitDelay = delay, outScale: outScale = 0.9, inScale: inScale = 1, animateOpacity: animateOpacity = true })=>{
    const enterAtoms = [
        (0, $9d936c159f9ee23b$export$9ef44f32700e8ee4)({
            direction: 'enter',
            duration: duration,
            easing: easing,
            delay: delay,
            outScale: outScale,
            inScale: inScale
        })
    ];
    const exitAtoms = [
        (0, $9d936c159f9ee23b$export$9ef44f32700e8ee4)({
            direction: 'exit',
            duration: exitDuration,
            easing: exitEasing,
            delay: exitDelay,
            outScale: outScale,
            inScale: inScale
        })
    ];
    // Only add fade atoms if animateOpacity is true.
    if (animateOpacity) {
        enterAtoms.push((0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'enter',
            duration: duration,
            easing: easing,
            delay: delay
        }));
        exitAtoms.push((0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'exit',
            duration: exitDuration,
            easing: exitEasing,
            delay: exitDelay
        }));
    }
    return {
        enter: enterAtoms,
        exit: exitAtoms
    };
};
const $f0c450e3c364eadd$export$d60cfc58d3c358b6 = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)($f0c450e3c364eadd$var$scalePresenceFn);
const $f0c450e3c364eadd$export$4f87c7c81689dfda = (0, $e67c3d746f23a482$export$2911c0c000be902b)($f0c450e3c364eadd$export$d60cfc58d3c358b6, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal,
    exitDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationFast
});
const $f0c450e3c364eadd$export$f36d19a56ef9455c = (0, $e67c3d746f23a482$export$2911c0c000be902b)($f0c450e3c364eadd$export$d60cfc58d3c358b6, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlow,
    exitDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle
});


const $7eee099111577ca5$export$e4cdcfcd8eb9ef32 = (0, $e67c3d746f23a482$export$2911c0c000be902b)((0, $f0c450e3c364eadd$export$d60cfc58d3c358b6), {
    outScale: 0.85,
    easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMid,
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle,
    exitEasing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveAccelerateMin,
    exitDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle
});


'use client';
const $8ab8c0cd141e2cd6$export$f2800d8e1c3f3762 = (props)=>{
    const { children: children, modalType: modalType = 'modal', onOpenChange: onOpenChange, inertTrapFocus: inertTrapFocus = false, unmountOnClose: unmountOnClose = true } = props;
    const dialogTitleId = (0, $0200d30cfa270435$export$f680877a34711e37)('dialog-title-');
    const [trigger, content] = $8ab8c0cd141e2cd6$var$childrenToTriggerAndContent(children);
    const [open, setOpen] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.open,
        defaultState: props.defaultOpen,
        initialState: false
    });
    const requestOpenChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((data)=>{
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(data.event, data);
        // if user prevents default then do not change state value
        // otherwise updates state value and trigger reference to the element that caused the opening
        if (!data.event.isDefaultPrevented()) setOpen(data.open);
    });
    const dialogRef = (0, $47d27724afc6da6d$export$d0f293dfa88e13b7)(open, modalType);
    const { modalAttributes: modalAttributes, triggerAttributes: triggerAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)({
        trapFocus: modalType !== 'non-modal',
        legacyTrapFocus: !inertTrapFocus
    });
    const isNestedDialog = (0, $43f01c3e5f4f08d3$export$ed40f17238e0af3f)((0, $1df5e8bcad6e85cf$export$8b93a07348a7730c));
    return {
        components: {
            surfaceMotion: (0, $7eee099111577ca5$export$e4cdcfcd8eb9ef32)
        },
        inertTrapFocus: inertTrapFocus,
        open: open,
        modalType: modalType,
        content: content,
        trigger: trigger,
        requestOpenChange: requestOpenChange,
        dialogTitleId: dialogTitleId,
        isNestedDialog: isNestedDialog,
        unmountOnClose: unmountOnClose,
        dialogRef: dialogRef,
        modalAttributes: modalAttributes,
        triggerAttributes: triggerAttributes,
        surfaceMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(props.surfaceMotion, {
            elementType: (0, $7eee099111577ca5$export$e4cdcfcd8eb9ef32),
            defaultProps: {
                visible: open,
                appear: unmountOnClose,
                unmountOnExit: unmountOnClose
            }
        })
    };
};
/**
 * Extracts trigger and content from children
 */ function $8ab8c0cd141e2cd6$var$childrenToTriggerAndContent(children) {
    const childrenArray = $acw62.Children.toArray(children);
    switch(childrenArray.length){
        // case where there's a trigger followed by content
        case 2:
            return childrenArray;
        // case where there's only content
        case 1:
            return [
                undefined,
                childrenArray[0]
            ];
        // unknown case
        default:
            return [
                undefined,
                undefined
            ];
    }
}




parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $dfbb1f6223498329$var$defaultContextValue = false;
const $dfbb1f6223498329$export$ea577bedbf99c71d = $acw62.createContext(undefined);
const $dfbb1f6223498329$export$63e7a5d6b0cd8dfc = $dfbb1f6223498329$export$ea577bedbf99c71d.Provider;
const $dfbb1f6223498329$export$6e6c677beea48331 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($dfbb1f6223498329$export$ea577bedbf99c71d)) !== null && _React_useContext !== void 0 ? _React_useContext : $dfbb1f6223498329$var$defaultContextValue;
};


const $f8b896f57d82c2d1$export$94fd76a80f9e6817 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $1df5e8bcad6e85cf$export$7ab5cfe96fae86d3), {
        value: contextValues.dialog,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $dfbb1f6223498329$export$63e7a5d6b0cd8dfc), {
            value: contextValues.dialogSurface,
            children: [
                state.trigger,
                state.content && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.surfaceMotion, {
                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $59b10a9d6ce22ca1$export$a606ed35b13f65f2), {
                        children: state.content
                    })
                })
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");
'use client';
function $a61348354a9ebe01$export$a71b5c378a8f663e(state) {
    const { modalType: modalType, open: open, dialogRef: dialogRef, dialogTitleId: dialogTitleId, isNestedDialog: isNestedDialog, inertTrapFocus: inertTrapFocus, requestOpenChange: requestOpenChange, modalAttributes: modalAttributes, triggerAttributes: triggerAttributes, unmountOnClose: unmountOnClose } = state;
    const dialog = $acw62.useMemo(()=>({
            open: open,
            modalType: modalType,
            dialogRef: dialogRef,
            dialogTitleId: dialogTitleId,
            isNestedDialog: isNestedDialog,
            inertTrapFocus: inertTrapFocus,
            modalAttributes: modalAttributes,
            triggerAttributes: triggerAttributes,
            unmountOnClose: unmountOnClose,
            requestOpenChange: requestOpenChange
        }), [
        open,
        modalType,
        dialogRef,
        dialogTitleId,
        isNestedDialog,
        inertTrapFocus,
        modalAttributes,
        triggerAttributes,
        unmountOnClose,
        requestOpenChange
    ]);
    const dialogSurface = false;
    return {
        dialog: dialog,
        dialogSurface: dialogSurface
    };
}


'use client';
const $432da315193df471$export$3ddf2d174ce01153 = /*#__PURE__*/ $acw62.memo((props)=>{
    const state = (0, $8ab8c0cd141e2cd6$export$f2800d8e1c3f3762)(props);
    const contextValues = (0, $a61348354a9ebe01$export$a71b5c378a8f663e)(state);
    return (0, $f8b896f57d82c2d1$export$94fd76a80f9e6817)(state, contextValues);
});
$432da315193df471$export$3ddf2d174ce01153.displayName = 'Dialog';









'use client';
const $2c26846159a9e83a$export$50939d56ffc4fdaf = {
    drawerSizeVar: '--fui-Drawer--size'
};
const $2c26846159a9e83a$export$104a6f8f167450b = {
    overflow: 'hidden',
    width: `var(${$2c26846159a9e83a$export$50939d56ffc4fdaf.drawerSizeVar})`,
    maxWidth: '100vw',
    height: 'auto',
    maxHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralBackground1,
    color: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralForeground1
};
/**
 * Shared dynamic styles for the Drawer component
 */ const $2c26846159a9e83a$var$useDrawerStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    start: {
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        u1mtju: [
            "f1xteiwb",
            "fsqykmd"
        ],
        oyh7mz: [
            "f1vgc2s3",
            "f1e31b4d"
        ],
        j35jbq: [
            "fvfyk4",
            "frppm18"
        ]
    },
    end: {
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        B4g9neb: [
            "fsqykmd",
            "f1xteiwb"
        ],
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        oyh7mz: [
            "frppm18",
            "fvfyk4"
        ]
    },
    bottom: {
        B5kzvoi: "f1yab3r1",
        Bhzewxz: "f198g47y"
    },
    small: {
        Bjr0ffy: "f1exhnwo"
    },
    medium: {
        Bjr0ffy: "fqofjzu"
    },
    large: {
        Bjr0ffy: "fce6y3m"
    },
    full: {
        Bjr0ffy: "fsdmzs6"
    }
}, {
    d: [
        [
            ".f1xteiwb{border-right:var(--strokeWidthThin) solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        [
            ".fsqykmd{border-left:var(--strokeWidthThin) solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        ".f1vgc2s3{left:0;}",
        ".f1e31b4d{right:0;}",
        ".fvfyk4{right:auto;}",
        ".frppm18{left:auto;}",
        [
            ".fsqykmd{border-left:var(--strokeWidthThin) solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        [
            ".f1xteiwb{border-right:var(--strokeWidthThin) solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        ".f1yab3r1{bottom:0;}",
        ".f198g47y{top:auto;}",
        ".f1exhnwo{--fui-Drawer--size:320px;}",
        ".fqofjzu{--fui-Drawer--size:592px;}",
        ".fce6y3m{--fui-Drawer--size:940px;}",
        ".fsdmzs6{--fui-Drawer--size:100vw;}"
    ]
});
const $2c26846159a9e83a$export$c272631eea8b04b2 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    small: {
        Bjr0ffy: "f1exhnwo"
    },
    medium: {
        Bjr0ffy: "fqofjzu"
    },
    large: {
        Bjr0ffy: "fce6y3m"
    },
    full: {
        Bjr0ffy: "f1rat34m"
    }
}, {
    d: [
        ".f1exhnwo{--fui-Drawer--size:320px;}",
        ".fqofjzu{--fui-Drawer--size:592px;}",
        ".fce6y3m{--fui-Drawer--size:940px;}",
        ".f1rat34m{--fui-Drawer--size:100%;}"
    ]
});
const $2c26846159a9e83a$export$253cba95b8f9b540 = ({ position: position, size: size })=>{
    const baseStyles = $2c26846159a9e83a$var$useDrawerStyles();
    const bottomBaseStyles = $2c26846159a9e83a$export$c272631eea8b04b2();
    return (0, $00898283de415a49$export$3d46f4579dba46e5)(baseStyles[position], position === 'bottom' && bottomBaseStyles[size], position !== 'bottom' && baseStyles[size]);
};



const $8b4e2067ecab0c6a$var$durations = {
    small: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle,
    medium: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlow,
    large: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower,
    full: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationUltraSlow
};
function $8b4e2067ecab0c6a$export$8789a5b1c630ca06(position, sizeVar, dir) {
    const leftToRightTransform = `translate3d(var(${sizeVar}), 0, 0)`;
    const rightToLeftTransform = `translate3d(calc(var(${sizeVar}) * -1), 0, 0)`;
    const bottomToTopTransform = `translate3d(0, var(${sizeVar}), 0)`;
    if (position === 'start') return dir === 'ltr' ? rightToLeftTransform : leftToRightTransform;
    if (position === 'end') return dir === 'ltr' ? leftToRightTransform : rightToLeftTransform;
    if (position === 'bottom') return bottomToTopTransform;
    return 'translate3d(0, 0, 0)';
}
const $8b4e2067ecab0c6a$export$f86fde352714dc7a = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(({ position: position, size: size, dir: dir })=>{
    const keyframes = [
        {
            /**
       * TODO: Once the #31663 lands, we should update the RTL logic to use Motion APIs
       * The work will be done in the #32817
       */ transform: $8b4e2067ecab0c6a$export$8789a5b1c630ca06(position, (0, $2c26846159a9e83a$export$50939d56ffc4fdaf).drawerSizeVar, dir),
            opacity: 0
        },
        {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    ];
    const duration = $8b4e2067ecab0c6a$var$durations[size];
    return {
        enter: {
            keyframes: keyframes,
            duration: duration,
            easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMid
        },
        exit: {
            keyframes: [
                ...keyframes
            ].reverse(),
            duration: duration,
            easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveAccelerateMin
        }
    };
});
const $8b4e2067ecab0c6a$export$3706aa6b2a14c734 = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(({ position: position, size: size, dir: dir })=>{
    const keyframes = [
        {
            /**
       * TODO: Once the #31663 lands, we should update the RTL logic to use Motion APIs
       * The work will be done in the #32817
       */ transform: $8b4e2067ecab0c6a$export$8789a5b1c630ca06(position, (0, $2c26846159a9e83a$export$50939d56ffc4fdaf).drawerSizeVar, dir),
            boxShadow: `0px ${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorTransparentBackground}`,
            opacity: 0
        },
        {
            transform: 'translate3d(0, 0, 0)',
            boxShadow: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).shadow64,
            opacity: 1
        }
    ];
    const duration = $8b4e2067ecab0c6a$var$durations[size];
    return {
        enter: {
            keyframes: keyframes,
            duration: duration,
            easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMid
        },
        exit: {
            keyframes: [
                ...keyframes
            ].reverse(),
            duration: duration,
            easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveAccelerateMin
        }
    };
});
const $8b4e2067ecab0c6a$export$29e819c756a4928f = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(({ size: size })=>{
    const duration = $8b4e2067ecab0c6a$var$durations[size];
    const easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear;
    return {
        enter: (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'enter',
            duration: duration,
            easing: easing
        }),
        exit: (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'exit',
            duration: duration,
            easing: easing
        })
    };
});


function $2f378ce1c513fb1e$export$7ee1b750db140960(props) {
    const { open: open = false, size: size = 'small', position: position = 'start', unmountOnClose: unmountOnClose = true } = props;
    return {
        size: size,
        position: position,
        open: open,
        unmountOnClose: unmountOnClose
    };
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $d0895351777ecebe$export$1b77b191c557a246(shorthand) {
    return shorthand !== null && typeof shorthand === 'object' && !Array.isArray(shorthand) && !$acw62.isValidElement(shorthand);
}



var $acw62 = parcelRequire("acw62");
'use client';
const $8437f6f9e3d4e19d$export$f6c0b973170d8075 = $acw62.createContext(undefined);
const $8437f6f9e3d4e19d$export$4a03e186098d7552 = $8437f6f9e3d4e19d$export$f6c0b973170d8075.Provider;
const $8437f6f9e3d4e19d$export$eb243cc61b0c603d = ()=>{
    return $acw62.useContext($8437f6f9e3d4e19d$export$f6c0b973170d8075);
};



var $acw62 = parcelRequire("acw62");


'use client';
const $411b3368175ad511$export$b2684b2f85ffad11 = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r6pzz3z", null, [
    ".r6pzz3z{overflow-y:hidden;overflow-y:clip;scrollbar-gutter:stable;}"
]);
const $411b3368175ad511$export$89a84ea48b2421a6 = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r144vlu9", null, [
    ".r144vlu9{overflow-y:hidden;}"
]);


'use client';
function $55b8006a7a00ad22$export$e1d95e7d6867c884() {
    const htmlNoScrollStyles = (0, $411b3368175ad511$export$b2684b2f85ffad11)();
    const bodyNoScrollStyles = (0, $411b3368175ad511$export$89a84ea48b2421a6)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const disableBodyScroll = $acw62.useCallback(()=>{
        var _targetDocument_defaultView;
        if (!targetDocument) return;
        var _targetDocument_defaultView_innerHeight;
        const isHorizontalScrollbarVisible = // To properly compare the body clientHeight to the window innerHeight, manually round down the fractional value to match innerHeight's calculation.
        Math.floor(targetDocument.body.getBoundingClientRect().height) > ((_targetDocument_defaultView_innerHeight = (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.innerHeight) !== null && _targetDocument_defaultView_innerHeight !== void 0 ? _targetDocument_defaultView_innerHeight : 0);
        if (!isHorizontalScrollbarVisible) return;
        targetDocument.documentElement.classList.add(htmlNoScrollStyles);
        targetDocument.body.classList.add(bodyNoScrollStyles);
        return;
    }, [
        targetDocument,
        htmlNoScrollStyles,
        bodyNoScrollStyles
    ]);
    const enableBodyScroll = $acw62.useCallback(()=>{
        if (!targetDocument) return;
        targetDocument.documentElement.classList.remove(htmlNoScrollStyles);
        targetDocument.body.classList.remove(bodyNoScrollStyles);
    }, [
        targetDocument,
        htmlNoScrollStyles,
        bodyNoScrollStyles
    ]);
    return {
        disableBodyScroll: disableBodyScroll,
        enableBodyScroll: enableBodyScroll
    };
}




const $e354535bc8023a8f$export$982d379e3680c623 = ({ duration: duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveEasyEase, delay: delay = 0, exitDuration: exitDuration = duration, exitEasing: exitEasing = easing, exitDelay: exitDelay = delay, outOpacity: outOpacity = 0, inOpacity: inOpacity = 1 })=>{
    return {
        enter: (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'enter',
            duration: duration,
            easing: easing,
            delay: delay,
            outOpacity: outOpacity,
            inOpacity: inOpacity
        }),
        exit: (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'exit',
            duration: exitDuration,
            easing: exitEasing,
            delay: exitDelay,
            outOpacity: outOpacity,
            inOpacity: inOpacity
        })
    };
};
const $e354535bc8023a8f$export$c983850c6c9d8b0e = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)($e354535bc8023a8f$export$982d379e3680c623);
const $e354535bc8023a8f$export$aa352a7bdc8c037b = (0, $e67c3d746f23a482$export$2911c0c000be902b)($e354535bc8023a8f$export$c983850c6c9d8b0e, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationFast
});
const $e354535bc8023a8f$export$af499063868f6bf7 = (0, $e67c3d746f23a482$export$2911c0c000be902b)($e354535bc8023a8f$export$c983850c6c9d8b0e, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle
});


const $abbadddd1f7e274f$export$8ddeecc2d91e9cdd = (0, $e354535bc8023a8f$export$af499063868f6bf7);


'use client';
const $254eec9f6c345877$export$c76c7ec047fdba7d = (props, ref)=>{
    const contextRef = (0, $59b10a9d6ce22ca1$export$303310ce19d9244b)();
    const modalType = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.modalType);
    const isNestedDialog = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.isNestedDialog);
    const backdropOverride = (0, $8437f6f9e3d4e19d$export$eb243cc61b0c603d)();
    const treatBackdropAsNested = backdropOverride !== null && backdropOverride !== void 0 ? backdropOverride : isNestedDialog;
    const modalAttributes = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.modalAttributes);
    const dialogRef = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogRef);
    const requestOpenChange = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.requestOpenChange);
    const dialogTitleID = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogTitleId);
    const open = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.open);
    const unmountOnClose = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.unmountOnClose);
    const handledBackdropClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        if ((0, $d0895351777ecebe$export$1b77b191c557a246)(props.backdrop)) {
            var _props_backdrop_onClick, _props_backdrop;
            (_props_backdrop_onClick = (_props_backdrop = props.backdrop).onClick) === null || _props_backdrop_onClick === void 0 || _props_backdrop_onClick.call(_props_backdrop, event);
        }
        if (modalType === 'modal' && !event.isDefaultPrevented()) requestOpenChange({
            event: event,
            open: false,
            type: 'backdropClick'
        });
    });
    const handleKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        var _props_onKeyDown;
        (_props_onKeyDown = props.onKeyDown) === null || _props_onKeyDown === void 0 || _props_onKeyDown.call(props, event);
        if (event.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685) && !event.isDefaultPrevented()) {
            requestOpenChange({
                event: event,
                open: false,
                type: 'escapeKeyDown'
            });
            // stop propagation to avoid conflicting with other elements that listen for `Escape`
            // e,g: nested Dialog, Popover, Menu and Tooltip
            event.preventDefault();
        }
    });
    const backdrop = (0, $fcf7ddccaab7fd8f$exports).optional(props.backdrop, {
        renderByDefault: modalType !== 'non-modal',
        defaultProps: {
            'aria-hidden': 'true'
        },
        elementType: 'div'
    });
    const backdropAppearance = backdrop === null || backdrop === void 0 ? void 0 : backdrop.appearance;
    if (backdrop) {
        backdrop.onClick = handledBackdropClick;
        // remove backdrop.appearance so it is not passed to the DOM
        delete backdrop.appearance;
    }
    const { disableBodyScroll: disableBodyScroll, enableBodyScroll: enableBodyScroll } = (0, $55b8006a7a00ad22$export$e1d95e7d6867c884)();
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        if (!open) {
            enableBodyScroll();
            return;
        }
        if (isNestedDialog || modalType === 'non-modal') return;
        disableBodyScroll();
        return ()=>enableBodyScroll();
    }, [
        open,
        modalType,
        isNestedDialog,
        disableBodyScroll,
        enableBodyScroll
    ]);
    return {
        components: {
            backdrop: 'div',
            root: 'div',
            backdropMotion: (0, $abbadddd1f7e274f$export$8ddeecc2d91e9cdd)
        },
        open: open,
        backdrop: backdrop,
        isNestedDialog: isNestedDialog,
        treatBackdropAsNested: treatBackdropAsNested,
        backdropAppearance: backdropAppearance,
        unmountOnClose: unmountOnClose,
        mountNode: props.mountNode,
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            tabIndex: -1,
            role: modalType === 'alert' ? 'alertdialog' : 'dialog',
            'aria-modal': modalType !== 'non-modal',
            'aria-labelledby': props['aria-label'] ? undefined : dialogTitleID,
            'aria-hidden': !unmountOnClose && !open ? true : undefined,
            ...props,
            ...modalAttributes,
            onKeyDown: handleKeyDown,
            // FIXME:
            // `DialogSurfaceElement` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, contextRef, dialogRef)
        }), {
            elementType: 'div'
        }),
        backdropMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(props.backdropMotion, {
            elementType: (0, $abbadddd1f7e274f$export$8ddeecc2d91e9cdd),
            defaultProps: {
                appear: unmountOnClose,
                visible: open
            }
        }),
        // Deprecated properties
        transitionStatus: undefined
    };
};

function $dcf0dbbf13f87385$export$127901f2ae2690e3(state) {
    const dialogSurface = true;
    return {
        dialogSurface: dialogSurface
    };
}






const $408594075e348c01$export$621d9bedb04ddc81 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $aa8a2d30f790b072$export$602eac185826482c), {
        mountNode: state.mountNode,
        children: [
            state.backdrop && // TODO: state.backdropMotion is non nullable, but assertSlots asserts it as nullable
            // FIXME: this should be resolved by properly splitting props and state slots declaration
            state.backdropMotion && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.backdropMotion, {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.backdrop, {})
            }),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $59b10a9d6ce22ca1$export$521eca9e79de5335), {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $dfbb1f6223498329$export$63e7a5d6b0cd8dfc), {
                    value: contextValues.dialogSurface,
                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
                })
            })
        ]
    });
};




'use client';
/**
 * Styles for the backdrop slot
 */ const $317c7d63b9d2b5e1$var$useBackdropResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rl76ifk", null, [
    ".rl76ifk{inset:0px;position:fixed;background-color:var(--colorBackgroundOverlay);}"
]);
const $317c7d63b9d2b5e1$var$useBackdropStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    nested: {
        De3pzq: "f1c21dwh"
    },
    drawerHidden: {
        Bkecrkj: "f1aehjj5"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1aehjj5{pointer-events:none;}"
    ]
});
const $317c7d63b9d2b5e1$export$964edcfed325be1e = (state)=>{
    const { treatBackdropAsNested: treatBackdropAsNested, backdrop: backdrop, open: open, unmountOnClose: unmountOnClose } = state;
    const backdropResetStyles = $317c7d63b9d2b5e1$var$useBackdropResetStyles();
    const backdropStyles = $317c7d63b9d2b5e1$var$useBackdropStyles();
    const mountedAndClosed = !unmountOnClose && !open;
    if (backdrop) // eslint-disable-next-line react-hooks/immutability
    backdrop.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(backdropResetStyles, treatBackdropAsNested && backdropStyles.nested, mountedAndClosed && backdropStyles.drawerHidden, backdrop.className);
    return state;
};



'use client';
const $a2edebfeca3a62ff$export$4887cc20f02bdc14 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const dialogSurfaceState = (0, $254eec9f6c345877$export$c76c7ec047fdba7d)({
        ...props,
        /**
       * Drawer accepts a `div` or `aside` element type, but Dialog only accepts a `div` element type.
       * We need to cast the ref to a `div` element type to not break Dialog's ref type.
       *
       * FIXME: Evaluate the possibility to remove this cast when Dialog is refactored to accept `aside` elements.
       */ as: props.as
    }, ref);
    const dialogSurfaceContextValues = (0, $dcf0dbbf13f87385$export$127901f2ae2690e3)(dialogSurfaceState);
    (0, $317c7d63b9d2b5e1$export$964edcfed325be1e)(dialogSurfaceState);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useOverlayDrawerSurfaceStyles_unstable')(dialogSurfaceState);
    return (0, $408594075e348c01$export$621d9bedb04ddc81)(dialogSurfaceState, dialogSurfaceContextValues);
});
$a2edebfeca3a62ff$export$4887cc20f02bdc14.displayName = 'OverlayDrawerSurface';



var $acw62 = parcelRequire("acw62");
function $ef839eea42ee551b$export$ddc75e84e7722ad1(inputSlot, Component, params) {
    if (inputSlot === null) return null;
    return {
        ...inputSlot,
        children: (_, props)=>{
            if (inputSlot === null || inputSlot === void 0 ? void 0 : inputSlot.children) return inputSlot.children(Component, {
                ...props,
                ...params
            });
            return /*#__PURE__*/ $acw62.createElement(Component, {
                ...props,
                ...params
            }, props.children);
        }
    };
}


'use client';
const $8d3088165e0ea55b$var$STATIC_MOTION = {
    active: true,
    canRender: true,
    ref: /*#__PURE__*/ $acw62.createRef(),
    type: 'idle'
};
const $8d3088165e0ea55b$export$25c3d3cb7e558e00 = (props, ref)=>{
    const { open: open, size: size, position: position, unmountOnClose: unmountOnClose } = (0, $2f378ce1c513fb1e$export$7ee1b750db140960)(props);
    const { modalType: modalType = 'modal', inertTrapFocus: inertTrapFocus, onOpenChange: onOpenChange, backdropMotion: backdropMotion, surfaceMotion: surfaceMotion, mountNode: mountNode } = props;
    const { dir: dir, targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const { element: mountNodeElement } = (0, $9ed5fe7220c8736b$export$7bd6d57efd912bd1)(mountNode);
    const hasMountNodeElement = Boolean(mountNodeElement && (targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.body) !== mountNodeElement);
    const backdropProps = (0, $fcf7ddccaab7fd8f$exports).resolveShorthand(props.backdrop);
    const hasCustomBackdrop = modalType !== 'non-modal' && backdropProps !== null;
    const root = (0, $fcf7ddccaab7fd8f$exports).always({
        ...props,
        ref: ref,
        unmountOnClose: unmountOnClose,
        backdrop: hasCustomBackdrop ? {
            ...backdropProps
        } : null,
        backdropMotion: (0, $ef839eea42ee551b$export$ddc75e84e7722ad1)(backdropMotion, (0, $8b4e2067ecab0c6a$export$29e819c756a4928f), {
            size: size
        })
    }, {
        elementType: (0, $a2edebfeca3a62ff$export$4887cc20f02bdc14)
    });
    const dialog = (0, $fcf7ddccaab7fd8f$exports).always({
        open: open,
        onOpenChange: onOpenChange,
        inertTrapFocus: inertTrapFocus,
        modalType: modalType,
        unmountOnClose: unmountOnClose,
        surfaceMotion: (0, $ef839eea42ee551b$export$ddc75e84e7722ad1)(surfaceMotion, (0, $8b4e2067ecab0c6a$export$3706aa6b2a14c734), {
            position: position,
            size: size,
            dir: dir
        }),
        /**
       * children is not needed here because we construct the children in the render function,
       * but it's required by DialogProps
       */ children: null
    }, {
        elementType: (0, $432da315193df471$export$3ddf2d174ce01153)
    });
    return {
        components: {
            root: (0, $a2edebfeca3a62ff$export$4887cc20f02bdc14),
            dialog: (0, $432da315193df471$export$3ddf2d174ce01153)
        },
        root: root,
        dialog: dialog,
        open: open,
        size: size,
        position: position,
        hasMountNodeElement: hasMountNodeElement,
        unmountOnClose: unmountOnClose,
        mountNode: // Deprecated props
        mountNode,
        motion: $8d3088165e0ea55b$var$STATIC_MOTION
    };
};






const $c4489a45c044a9b8$export$97a49644da38d761 = (state, contextValue)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $f151dc37217d3a88$export$f4880ee0de17c178), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $8437f6f9e3d4e19d$export$4a03e186098d7552), {
            value: false,
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.dialog, {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
            })
        })
    });
};





'use client';
const $f14acdd1fe21a348$export$e96eb1711c9b834f = {
    root: 'fui-OverlayDrawer',
    backdrop: 'fui-OverlayDrawer__backdrop'
};
/**
 * Styles for the root slot
 */ const $f14acdd1fe21a348$var$useDrawerResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r7dfyj8", "rmx02j7", {
    r: [
        ".r7dfyj8{overflow:hidden;width:var(--fui-Drawer--size);max-width:100vw;height:auto;max-height:100vh;box-sizing:border-box;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);position:fixed;top:0;bottom:0;}",
        ".r7dfyj8:focus{outline-style:none;}",
        ".r7dfyj8:focus-visible{outline-style:none;}",
        ".r7dfyj8[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".r7dfyj8[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".rmx02j7{overflow:hidden;width:var(--fui-Drawer--size);max-width:100vw;height:auto;max-height:100vh;box-sizing:border-box;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);position:fixed;top:0;bottom:0;}",
        ".rmx02j7:focus{outline-style:none;}",
        ".rmx02j7:focus-visible{outline-style:none;}",
        ".rmx02j7[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".rmx02j7[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.r7dfyj8[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media (forced-colors: active){.rmx02j7[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"
    ]
});
const $f14acdd1fe21a348$var$useDrawerRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    start: {},
    end: {},
    bottom: {
        Bhzewxz: "f198g47y",
        Bqenvij: "fub80nq",
        a9b677: "fr97h3j"
    },
    absolute: {
        qhf8xq: "f1euv43f"
    }
}, {
    d: [
        ".f198g47y{top:auto;}",
        ".fub80nq{height:var(--fui-Drawer--size);}",
        ".fr97h3j{width:100vw;}",
        ".f1euv43f{position:absolute;}"
    ]
});
const $f14acdd1fe21a348$export$e11526656844613c = (state)=>{
    const baseClassNames = (0, $2c26846159a9e83a$export$253cba95b8f9b540)(state);
    const resetStyles = $f14acdd1fe21a348$var$useDrawerResetStyles();
    const rootStyles = $f14acdd1fe21a348$var$useDrawerRootStyles();
    const absoluteStyles = state.hasMountNodeElement && rootStyles.absolute;
    const backdrop = state.root.backdrop;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f14acdd1fe21a348$export$e96eb1711c9b834f.root, baseClassNames, resetStyles, rootStyles[state.position], absoluteStyles, state.root.className);
    if (backdrop) // eslint-disable-next-line react-hooks/immutability
    backdrop.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($f14acdd1fe21a348$export$e96eb1711c9b834f.backdrop, absoluteStyles, backdrop.className);
    return state;
};


'use client';
const $05d1da2f82493671$export$8bc848b90885ae31 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8d3088165e0ea55b$export$25c3d3cb7e558e00)(props, ref);
    const contextValue = (0, $f151dc37217d3a88$export$eab75d93bceeb157)();
    (0, $f14acdd1fe21a348$export$e11526656844613c)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerOverlayStyles_unstable')(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useOverlayDrawerStyles_unstable')(state);
    return (0, $c4489a45c044a9b8$export$97a49644da38d761)(state, contextValue);
});
$05d1da2f82493671$export$8bc848b90885ae31.displayName = 'OverlayDrawer';



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





'use client';
const $54a40fe70dcfe656$var$STATIC_MOTION = {
    active: true,
    canRender: true,
    ref: $acw62.createRef(),
    type: 'idle'
};
const $54a40fe70dcfe656$export$bd09785a1b96d936 = (props, ref)=>{
    const { size: size, position: position, open: open, unmountOnClose: unmountOnClose } = (0, $2f378ce1c513fb1e$export$7ee1b750db140960)(props);
    const { separator: separator = false, surfaceMotion: surfaceMotion, ...baseProps } = props;
    const { dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const [animationDirection, setAnimationDirection] = $acw62.useState(open ? 'enter' : 'exit');
    const baseState = $54a40fe70dcfe656$export$1ad00c54f6624da0(baseProps, ref);
    return {
        ...baseState,
        components: {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ...baseState.components,
            // casting from internal type that has required properties
            // to external type that only has optional properties
            // converting to unknown first as both Function component signatures are not compatible
            surfaceMotion: (0, $8b4e2067ecab0c6a$export$f86fde352714dc7a)
        },
        size: size,
        separator: separator,
        animationDirection: animationDirection,
        surfaceMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(surfaceMotion, {
            elementType: (0, $8b4e2067ecab0c6a$export$f86fde352714dc7a),
            defaultProps: {
                position: position,
                size: size,
                dir: dir,
                visible: open,
                appear: unmountOnClose,
                unmountOnExit: unmountOnClose,
                onMotionFinish: (_, { direction: direction })=>setAnimationDirection(direction),
                onMotionStart: (_, { direction: direction })=>{
                    if (direction === 'enter') setAnimationDirection('enter');
                }
            }
        }),
        // Deprecated props
        motion: $54a40fe70dcfe656$var$STATIC_MOTION
    };
};
const $54a40fe70dcfe656$export$1ad00c54f6624da0 = (props, ref)=>{
    const { position: position, open: open, unmountOnClose: unmountOnClose } = (0, $2f378ce1c513fb1e$export$7ee1b750db140960)(props);
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ...props,
            ref: ref,
            'aria-hidden': !unmountOnClose && !open ? true : undefined
        }), {
            elementType: 'div'
        }),
        open: open,
        position: position,
        unmountOnClose: unmountOnClose
    };
};





const $f702b8aec9be9669$export$bbe19ab9061e2637 = (state, contextValue)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $f151dc37217d3a88$export$f4880ee0de17c178), {
        value: contextValue,
        children: state.surfaceMotion ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.surfaceMotion, {
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
        }) : /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};





'use client';
const $992cee57d20c4ea0$export$ea90827df4c1766 = {
    root: 'fui-InlineDrawer'
};
const $992cee57d20c4ea0$var$useDrawerResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rkjj3x6", null, [
    ".rkjj3x6{overflow:hidden;width:var(--fui-Drawer--size);max-width:100vw;height:auto;max-height:100vh;box-sizing:border-box;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);position:relative;}"
]);
/**
 * Styles for the root slot
 */ const $992cee57d20c4ea0$var$borderValue = `1px solid ${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralBackground3}`;
const $992cee57d20c4ea0$var$useDrawerRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    separatorStart: {
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        u1mtju: [
            "f1cxmi7i",
            "f1j970fk"
        ]
    },
    separatorEnd: {
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        B4g9neb: [
            "f1j970fk",
            "f1cxmi7i"
        ]
    },
    separatorBottom: {
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        i8vvqc: "f1n3kblk"
    },
    start: {},
    end: {},
    bottom: {
        a9b677: "fly5x3f",
        Bqenvij: "fub80nq"
    },
    animationExitStart: {
        a9b677: "f3tsq5r",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh"
    },
    animationExitEnd: {
        a9b677: "f3tsq5r",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh"
    },
    animationExitBottom: {
        Bqenvij: "fniina8",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh"
    }
}, {
    d: [
        [
            ".f1cxmi7i{border-right:1px solid var(--colorNeutralBackground3);}",
            {
                p: -1
            }
        ],
        [
            ".f1j970fk{border-left:1px solid var(--colorNeutralBackground3);}",
            {
                p: -1
            }
        ],
        [
            ".f1j970fk{border-left:1px solid var(--colorNeutralBackground3);}",
            {
                p: -1
            }
        ],
        [
            ".f1cxmi7i{border-right:1px solid var(--colorNeutralBackground3);}",
            {
                p: -1
            }
        ],
        [
            ".f1n3kblk{border-top:1px solid var(--colorNeutralBackground3);}",
            {
                p: -1
            }
        ],
        ".fly5x3f{width:100%;}",
        ".fub80nq{height:var(--fui-Drawer--size);}",
        ".f3tsq5r{width:0;}",
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        ".fniina8{height:0;}",
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ]
    ]
});
function $992cee57d20c4ea0$var$getSeparatorClass(state, classNames) {
    if (!state.separator) return undefined;
    switch(state.position){
        case 'start':
            return classNames.separatorStart;
        case 'end':
            return classNames.separatorEnd;
        case 'bottom':
            return classNames.separatorBottom;
        default:
            return undefined;
    }
}
function $992cee57d20c4ea0$var$getAnimationExitClass(state, classNames) {
    switch(state.position){
        case 'start':
            return classNames.animationExitStart;
        case 'end':
            return classNames.animationExitEnd;
        case 'bottom':
            return classNames.animationExitBottom;
        default:
            return undefined;
    }
}
const $992cee57d20c4ea0$export$3736390deb6f3b31 = (state)=>{
    const resetStyles = $992cee57d20c4ea0$var$useDrawerResetStyles();
    const baseClassNames = (0, $2c26846159a9e83a$export$253cba95b8f9b540)(state);
    const rootStyles = $992cee57d20c4ea0$var$useDrawerRootStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($992cee57d20c4ea0$export$ea90827df4c1766.root, resetStyles, baseClassNames, $992cee57d20c4ea0$var$getSeparatorClass(state, rootStyles), rootStyles[state.position], state.animationDirection === 'exit' && $992cee57d20c4ea0$var$getAnimationExitClass(state, rootStyles), state.root.className);
    return state;
};


'use client';
const $7f5c3eca1ece0a2a$export$a9124355b59254a4 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $54a40fe70dcfe656$export$bd09785a1b96d936)(props, ref);
    const contextValue = (0, $f151dc37217d3a88$export$eab75d93bceeb157)();
    (0, $992cee57d20c4ea0$export$3736390deb6f3b31)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerInlineStyles_unstable')(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useInlineDrawerStyles_unstable')(state);
    return (0, $f702b8aec9be9669$export$bbe19ab9061e2637)(state, contextValue);
});
$7f5c3eca1ece0a2a$export$a9124355b59254a4.displayName = 'InlineDrawer';


const $43f0294078da267a$export$1fd3e68c43b9d88a = (props, ref)=>{
    // casting here to convert a union of functions to a single function with the union of parameters
    const elementType = props.type === 'inline' ? (0, $7f5c3eca1ece0a2a$export$a9124355b59254a4) : (0, $05d1da2f82493671$export$8bc848b90885ae31);
    const root = (0, $fcf7ddccaab7fd8f$exports).always({
        ref: ref,
        ...props
    }, {
        elementType: elementType
    });
    return {
        components: {
            root: elementType
        },
        root: root
    };
};





const $6b2795f90f8f805d$export$bcd8f8088f23b811 = (state, contextValue)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $f151dc37217d3a88$export$f4880ee0de17c178), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};



const $4f574cdd7dc11ade$export$308b4b1a3456f34e = {
    root: 'fui-Drawer'
};
const $4f574cdd7dc11ade$export$33806839174205d3 = (state)=>{
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($4f574cdd7dc11ade$export$308b4b1a3456f34e.root, state.root.className);
    return state;
};


'use client';
const $4edc29482f6892a4$export$4071300121a182f5 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $43f0294078da267a$export$1fd3e68c43b9d88a)(props, ref);
    const contextValue = (0, $f151dc37217d3a88$export$eab75d93bceeb157)();
    (0, $4f574cdd7dc11ade$export$33806839174205d3)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerStyles_unstable')(state);
    return (0, $6b2795f90f8f805d$export$bcd8f8088f23b811)(state, contextValue);
});
$4edc29482f6892a4$export$4071300121a182f5.displayName = 'Drawer';




var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Initial value for the uncontrolled case of the list of open indexes
 */ function $90536654b0524ae3$var$initializeUncontrolledOpenCategories({ defaultOpenCategories: defaultOpenCategories, multiple: multiple }) {
    if (defaultOpenCategories !== undefined) {
        if (Array.isArray(defaultOpenCategories)) return multiple ? defaultOpenCategories : [
            defaultOpenCategories[0]
        ];
        return [
            defaultOpenCategories
        ];
    }
    return undefined;
}
/**
 * Updates the list of open indexes based on an index that changes
 * @param value - the index that will change
 * @param previousOpenItems - list of current open indexes
 * @param multiple - if Nav supports open categories at the same time
 */ const $90536654b0524ae3$var$updateOpenCategories = (value, previousOpenItems, multiple)=>{
    if (multiple) {
        if (previousOpenItems.includes(value)) return previousOpenItems.filter((i)=>i !== value);
        else return [
            ...previousOpenItems,
            value
        ];
    }
    return previousOpenItems[0] === value ? [] : [
        value
    ];
};
const $90536654b0524ae3$export$b6c014fb65439660 = (props, ref)=>{
    const { density: density = 'medium' } = props;
    const state = $90536654b0524ae3$export$13eca55f93bfad1(props, ref);
    return {
        ...state,
        density: density,
        tabbable: false
    };
};
const $90536654b0524ae3$export$13eca55f93bfad1 = (props, ref)=>{
    const { onNavItemSelect: onNavItemSelect, onNavCategoryItemToggle: onNavCategoryItemToggle, multiple: multiple = true, openCategories: controlledOpenCategoryItems, selectedCategoryValue: controlledSelectedCategoryValue, selectedValue: controlledSelectedValue, defaultOpenCategories: defaultOpenCategories, defaultSelectedValue: defaultSelectedValue, defaultSelectedCategoryValue: defaultSelectedCategoryValue } = props;
    const innerRef = $acw62.useRef(null);
    const [openCategories, setOpenCategories] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: controlledOpenCategoryItems,
        defaultState: $90536654b0524ae3$var$initializeUncontrolledOpenCategories({
            defaultOpenCategories: defaultOpenCategories,
            multiple: multiple
        }),
        initialState: []
    });
    const [selectedCategoryValue, setSelectedCategoryValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: controlledSelectedCategoryValue,
        defaultState: defaultSelectedCategoryValue,
        initialState: undefined
    });
    const [selectedValue, setSelectedValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: controlledSelectedValue,
        defaultState: defaultSelectedValue,
        initialState: undefined
    });
    // considered usePrevious, but it is sensitive to re-renders
    // this could cause the previous to move to current in the case where the navItem list re-renders.
    // these refs avoid getRegisteredNavItems changing when selectedValue changes and causing
    // renders for navItems that have not changed.
    const currentSelectedValue = $acw62.useRef(undefined);
    const previousSelectedValue = $acw62.useRef(undefined);
    const currentSelectedCategoryValue = $acw62.useRef(undefined);
    const previousSelectedCategoryValue = $acw62.useRef(undefined);
    // eslint-disable-next-line react-hooks/refs
    if (currentSelectedValue.current !== selectedValue) {
        // eslint-disable-next-line react-hooks/refs
        previousSelectedValue.current = currentSelectedValue.current;
        // eslint-disable-next-line react-hooks/refs
        currentSelectedValue.current = selectedValue;
    }
    // eslint-disable-next-line react-hooks/refs
    if (currentSelectedCategoryValue.current !== selectedCategoryValue) {
        // eslint-disable-next-line react-hooks/refs
        previousSelectedCategoryValue.current = currentSelectedCategoryValue.current;
        // eslint-disable-next-line react-hooks/refs
        currentSelectedCategoryValue.current = selectedCategoryValue;
    }
    // used for NavItems and NavSubItems
    const onSelect = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event, data)=>{
        setSelectedValue(data.value);
        setSelectedCategoryValue(data.categoryValue ? data.categoryValue : '');
        onNavItemSelect === null || onNavItemSelect === void 0 || onNavItemSelect(event, data);
    });
    // used for NavCategoryItems
    const onRequestNavCategoryItemToggle = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event, data)=>{
        if (data.categoryValue !== undefined) {
            const nextOpenCategories = $90536654b0524ae3$var$updateOpenCategories(data.categoryValue, openCategories !== null && openCategories !== void 0 ? openCategories : [], multiple);
            onNavCategoryItemToggle === null || onNavCategoryItemToggle === void 0 || onNavCategoryItemToggle(event, data);
            setOpenCategories(nextOpenCategories);
        }
    });
    const registeredNavItems = $acw62.useRef({});
    const onRegister = $acw62.useCallback((data)=>{
        registeredNavItems.current[JSON.stringify(data.value)] = data;
    }, []);
    const onUnregister = $acw62.useCallback((data)=>{
        delete registeredNavItems.current[JSON.stringify(data.value)];
    }, []);
    const getRegisteredNavItems = $acw62.useCallback(()=>{
        return {
            selectedValue: currentSelectedValue.current,
            previousSelectedValue: previousSelectedValue.current,
            selectedCategoryValue: currentSelectedCategoryValue.current,
            previousSelectedCategoryValue: previousSelectedCategoryValue.current,
            registeredNavItems: registeredNavItems.current
        };
    }, []);
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, innerRef),
            ...props
        }), {
            elementType: 'div'
        }),
        openCategories: openCategories,
        selectedValue: selectedValue,
        selectedCategoryValue: selectedCategoryValue,
        onRegister: onRegister,
        onUnregister: onUnregister,
        onSelect: onSelect,
        getRegisteredNavItems: getRegisteredNavItems,
        onRequestNavCategoryItemToggle: onRequestNavCategoryItemToggle,
        multiple: multiple
    };
};


'use client';
const $8f19da9f67516250$export$b8d105b4c38fceed = (props, ref)=>{
    const { size: size, tabbable: tabbable = false } = props;
    const navState = (0, $90536654b0524ae3$export$b6c014fb65439660)(props, ref);
    return {
        ...navState,
        size: size,
        tabbable: tabbable,
        components: {
            // TODO: remove once React v18 slot API is modified
            // this is a problem with the lack of support for union types on React v18
            // ComponentState is using React.ComponentType which will try to infer propType
            // propTypes WeakValidator signature will break distributive unions making this type invalid
            root: (0, $4edc29482f6892a4$export$4071300121a182f5)
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: ref,
            role: 'navigation',
            ...props
        }, {
            // TODO: remove once React v18 slot API is modified
            // this is a problem with the lack of support for union types on React v18
            // ComponentState is using React.ComponentType which will try to infer propType
            // propTypes WeakValidator signature will break distributive unions making this type invalid
            elementType: (0, $4edc29482f6892a4$export$4071300121a182f5)
        })
    };
};





var $acw62 = parcelRequire("acw62");
'use client';
const $ee11a7d007e02639$var$navContextDefaultValue = {
    selectedValue: undefined,
    selectedCategoryValue: undefined,
    onRegister: ()=>{
    /* noop */ },
    onUnregister: ()=>{
    /* noop */ },
    onSelect: ()=>{
    /* noop */ },
    getRegisteredNavItems: ()=>{
        return {
            registeredNavItems: {}
        };
    },
    onRequestNavCategoryItemToggle () {
    /* noop */ },
    /**
   * The list of opened panels by index
   */ openCategories: [],
    /**
   * Indicates if Nav supports multiple open Categories at the same time.
   */ multiple: true,
    /**
   * Indicates the vertical density and density of the Nav.
   */ density: 'medium',
    /**
   * By default, the Nav is a single tab stop with only arrow key navigation
   */ tabbable: false
};
const $ee11a7d007e02639$var$NavContext = $acw62.createContext(undefined);
const $ee11a7d007e02639$export$8a69ede85730beda = $ee11a7d007e02639$var$NavContext.Provider;
const $ee11a7d007e02639$export$5ed88c9532b7cd46 = ()=>$acw62.useContext($ee11a7d007e02639$var$NavContext) || $ee11a7d007e02639$var$navContextDefaultValue;


const $11eb04beb8fee816$export$9fbc3e26400750c2 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $ee11a7d007e02639$export$8a69ede85730beda), {
        value: contextValues.nav,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};




'use client';
const $72883be64b12be7d$export$11c126eb9882fa52 = {
    root: 'fui-NavDrawer'
};
/**
 * Styles for the root slot
 */ const $72883be64b12be7d$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        De3pzq: "f1ctqxl6",
        Bt984gj: "f3gca8"
    },
    defaultWidth: {
        a9b677: "f12j6lm0"
    }
}, {
    d: [
        ".f1ctqxl6{background-color:var(--colorNeutralBackground4);}",
        ".f3gca8{align-items:unset;}",
        ".f12j6lm0{width:260px;}"
    ]
});
const $72883be64b12be7d$export$fc97b3d11c0b0238 = (state)=>{
    const { size: size } = state;
    const styles = $72883be64b12be7d$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($72883be64b12be7d$export$11c126eb9882fa52.root, styles.root, !size && styles.defaultWidth, state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $45eb7ca96b358a67$export$425d42b2907e2c19(state) {
    const { selectedValue: selectedValue, selectedCategoryValue: selectedCategoryValue, onRegister: onRegister, onUnregister: onUnregister, onSelect: onSelect, getRegisteredNavItems: getRegisteredNavItems, onRequestNavCategoryItemToggle: onRequestNavCategoryItemToggle, openCategories: openCategories, multiple: multiple, density: density, onNavItemSelect: onNavItemSelect, tabbable: tabbable } = state;
    const navContext = $acw62.useMemo(()=>({
            selectedValue: selectedValue,
            selectedCategoryValue: selectedCategoryValue,
            onSelect: onSelect,
            onRegister: onRegister,
            onUnregister: onUnregister,
            getRegisteredNavItems: getRegisteredNavItems,
            onRequestNavCategoryItemToggle: onRequestNavCategoryItemToggle,
            openCategories: openCategories,
            multiple: multiple,
            density: density,
            onNavItemSelect: onNavItemSelect,
            tabbable: tabbable
        }), [
        selectedValue,
        selectedCategoryValue,
        onSelect,
        onRegister,
        onUnregister,
        getRegisteredNavItems,
        onRequestNavCategoryItemToggle,
        openCategories,
        multiple,
        density,
        onNavItemSelect,
        tabbable
    ]);
    return {
        nav: navContext
    };
}


'use client';
const $76daa8b00e1f169e$export$7b98f7b2abd01120 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8f19da9f67516250$export$b8d105b4c38fceed)(props, ref);
    const contextValues = (0, $45eb7ca96b358a67$export$425d42b2907e2c19)(state);
    (0, $72883be64b12be7d$export$fc97b3d11c0b0238)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useNavDrawerStyles_unstable')(state);
    return (0, $11eb04beb8fee816$export$9fbc3e26400750c2)(state, contextValues);
});
$76daa8b00e1f169e$export$7b98f7b2abd01120.displayName = 'NavDrawer';


var $acw62 = parcelRequire("acw62");


const $e1fe6f2b1830352c$export$fe16988d8e0e4b7b = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};



/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 









const $c9be631229ea4e08$var$_inputSelector = [
    "input",
    "textarea",
    "*[contenteditable]"
].join(", ");
class $c9be631229ea4e08$var$MoverDummyManager extends (0, $f8063a7f7d87cb7c$export$2b3665f1498b1a50) {
    constructor(element, tabster, getMemorized, sys){
        super(tabster, element, (0, $f8063a7f7d87cb7c$export$96ba7a05d53985a3).Mover, sys);
        this._onFocusDummyInput = (dummyInput)=>{
            const container = this._element.get();
            const input = dummyInput.input;
            if (container && input) {
                const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, container);
                let toFocus;
                if (ctx) toFocus = (0, $018eb0b75e35c758$export$406337e29e552119).findNextTabbable(this._tabster, ctx, undefined, input, undefined, !dummyInput.isFirst, true)?.element;
                const memorized = this._getMemorized()?.get();
                if (memorized && this._tabster.focusable.isFocusable(memorized)) toFocus = memorized;
                if (toFocus) (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(toFocus);
            }
        };
        this._tabster = tabster;
        this._getMemorized = getMemorized;
        this._setHandlers(this._onFocusDummyInput);
    }
}
// TypeScript enums produce depressing JavaScript code, so, we're just using
// a few old style constants here.
const $c9be631229ea4e08$var$_moverUpdateAdd = 1;
const $c9be631229ea4e08$var$_moverUpdateAttr = 2;
const $c9be631229ea4e08$var$_moverUpdateRemove = 3;
class $c9be631229ea4e08$export$c252e6c2a70907cd extends (0, $8031a5e97995bd92$export$512356fecf866417) {
    constructor(tabster, element, onDispose, props, sys){
        super(tabster, element, props);
        this._visible = {};
        this._onIntersection = (entries)=>{
            for (const entry of entries){
                const el = entry.target;
                const id = (0, $8031a5e97995bd92$export$2dc82a3fd984deae)(this._win, el);
                let newVisibility;
                let fullyVisible = this._fullyVisible;
                if (entry.intersectionRatio >= 0.25) {
                    newVisibility = entry.intersectionRatio >= 0.75 ? (0, $43f171f5f7088580$export$878d96173d57e644).Visible : (0, $43f171f5f7088580$export$878d96173d57e644).PartiallyVisible;
                    if (newVisibility === (0, $43f171f5f7088580$export$878d96173d57e644).Visible) fullyVisible = id;
                } else newVisibility = (0, $43f171f5f7088580$export$878d96173d57e644).Invisible;
                if (this._visible[id] !== newVisibility) {
                    if (newVisibility === undefined) {
                        delete this._visible[id];
                        if (fullyVisible === id) delete this._fullyVisible;
                    } else {
                        this._visible[id] = newVisibility;
                        this._fullyVisible = fullyVisible;
                    }
                    const state = this.getState(el);
                    if (state) (0, $8031a5e97995bd92$export$716a11175c03fb4e)(el, new (0, $b6b59d8a07a2383a$export$4237cba23bf0663d)(state));
                }
            }
        };
        this._win = tabster.getWindow;
        this.visibilityTolerance = props.visibilityTolerance ?? 0.8;
        if (this._props.trackState || this._props.visibilityAware) {
            this._intersectionObserver = new IntersectionObserver(this._onIntersection, {
                threshold: [
                    0,
                    0.25,
                    0.5,
                    0.75,
                    1
                ]
            });
            this._observeState();
        }
        this._onDispose = onDispose;
        const getMemorized = ()=>props.memorizeCurrent ? this._current : undefined;
        if (!tabster.controlTab) this.dummyManager = new $c9be631229ea4e08$var$MoverDummyManager(this._element, tabster, getMemorized, sys);
    }
    dispose() {
        this._onDispose(this);
        if (this._intersectionObserver) {
            this._intersectionObserver.disconnect();
            delete this._intersectionObserver;
        }
        delete this._current;
        delete this._fullyVisible;
        delete this._allElements;
        delete this._updateQueue;
        if (this._unobserve) {
            this._unobserve();
            delete this._unobserve;
        }
        const win = this._win();
        if (this._setCurrentTimer) {
            win.clearTimeout(this._setCurrentTimer);
            delete this._setCurrentTimer;
        }
        if (this._updateTimer) {
            win.clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        this.dummyManager?.dispose();
        delete this.dummyManager;
    }
    setCurrent(element) {
        if (element) this._current = new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element);
        else this._current = undefined;
        if ((this._props.trackState || this._props.visibilityAware) && !this._setCurrentTimer) this._setCurrentTimer = this._win().setTimeout(()=>{
            delete this._setCurrentTimer;
            const changed = [];
            if (this._current !== this._prevCurrent) {
                changed.push(this._current);
                changed.push(this._prevCurrent);
                this._prevCurrent = this._current;
            }
            for (const weak of changed){
                const el = weak?.get();
                if (el && this._allElements?.get(el) === this) {
                    const props = this._props;
                    if (el && (props.visibilityAware !== undefined || props.trackState)) {
                        const state = this.getState(el);
                        if (state) (0, $8031a5e97995bd92$export$716a11175c03fb4e)(el, new (0, $b6b59d8a07a2383a$export$4237cba23bf0663d)(state));
                    }
                }
            }
        });
    }
    getCurrent() {
        return this._current?.get() || null;
    }
    findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const container = this.getElement();
        const currentIsDummy = container && (0, $f8063a7f7d87cb7c$export$6c7070ee46ec4271)(currentElement) === container;
        if (!container) return null;
        let next = null;
        let outOfDOMOrder = false;
        let uncontrolled;
        if (this._props.tabbable || currentIsDummy || currentElement && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(container, currentElement)) {
            const findProps = {
                currentElement: currentElement,
                referenceElement: referenceElement,
                container: container,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            next = this._tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
            uncontrolled = findPropsOut.uncontrolled;
        }
        return {
            element: next,
            uncontrolled: uncontrolled,
            outOfDOMOrder: outOfDOMOrder
        };
    }
    acceptElement(element, state) {
        if (!(0, $018eb0b75e35c758$export$406337e29e552119).isTabbing) return state.currentCtx?.excludedFromMover ? NodeFilter.FILTER_REJECT : undefined;
        const { memorizeCurrent: memorizeCurrent, visibilityAware: visibilityAware, hasDefault: hasDefault = true } = this._props;
        const moverElement = this.getElement();
        if (moverElement && (memorizeCurrent || visibilityAware || hasDefault) && (!(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(moverElement, state.from) || (0, $f8063a7f7d87cb7c$export$6c7070ee46ec4271)(state.from) === moverElement)) {
            let found;
            if (memorizeCurrent) {
                const current = this._current?.get();
                if (current && state.acceptCondition(current)) found = current;
            }
            if (!found && hasDefault) found = this._tabster.focusable.findDefault({
                container: moverElement,
                useActiveModalizer: true
            });
            if (!found && visibilityAware) found = this._tabster.focusable.findElement({
                container: moverElement,
                useActiveModalizer: true,
                isBackward: state.isBackward,
                acceptCondition: (el)=>{
                    const id = (0, $8031a5e97995bd92$export$2dc82a3fd984deae)(this._win, el);
                    const visibility = this._visible[id];
                    return moverElement !== el && !!this._allElements?.get(el) && state.acceptCondition(el) && (visibility === (0, $43f171f5f7088580$export$878d96173d57e644).Visible || visibility === (0, $43f171f5f7088580$export$878d96173d57e644).PartiallyVisible && (visibilityAware === (0, $43f171f5f7088580$export$878d96173d57e644).PartiallyVisible || !this._fullyVisible));
                }
            });
            if (found) {
                state.found = true;
                state.foundElement = found;
                state.rejectElementsFrom = moverElement;
                state.skippedFocusable = true;
                return NodeFilter.FILTER_ACCEPT;
            }
        }
        return undefined;
    }
    _observeState() {
        const element = this.getElement();
        if (this._unobserve || !element || typeof MutationObserver === "undefined") return;
        const win = this._win();
        const allElements = this._allElements = new WeakMap();
        const tabsterFocusable = this._tabster.focusable;
        let updateQueue = this._updateQueue = [];
        const observer = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).createMutationObserver((mutations)=>{
            for (const mutation of mutations){
                const target = mutation.target;
                const removed = mutation.removedNodes;
                const added = mutation.addedNodes;
                if (mutation.type === "attributes") {
                    if (mutation.attributeName === "tabindex") updateQueue.push({
                        element: target,
                        type: $c9be631229ea4e08$var$_moverUpdateAttr
                    });
                } else {
                    for(let i = 0; i < removed.length; i++)updateQueue.push({
                        element: removed[i],
                        type: $c9be631229ea4e08$var$_moverUpdateRemove
                    });
                    for(let i = 0; i < added.length; i++)updateQueue.push({
                        element: added[i],
                        type: $c9be631229ea4e08$var$_moverUpdateAdd
                    });
                }
            }
            requestUpdate();
        });
        const setElement = (element, remove)=>{
            const current = allElements.get(element);
            if (current && remove) {
                this._intersectionObserver?.unobserve(element);
                allElements.delete(element);
            }
            if (!current && !remove) {
                allElements.set(element, this);
                this._intersectionObserver?.observe(element);
            }
        };
        const updateElement = (element)=>{
            const isFocusable = tabsterFocusable.isFocusable(element);
            const current = allElements.get(element);
            if (current) {
                if (!isFocusable) setElement(element, true);
            } else if (isFocusable) setElement(element);
        };
        const addNewElements = (element)=>{
            const { mover: mover } = getMoverGroupper(element);
            if (mover && mover !== this) {
                if (mover.getElement() === element && tabsterFocusable.isFocusable(element)) setElement(element);
                else return;
            }
            const walker = (0, $8031a5e97995bd92$export$6d51b6a3304b27f5)(win.document, element, (node)=>{
                const { mover: mover, groupper: groupper } = getMoverGroupper(node);
                if (mover && mover !== this) return NodeFilter.FILTER_REJECT;
                const groupperFirstFocusable = groupper?.getFirst(true);
                if (groupper && groupper.getElement() !== node && groupperFirstFocusable && groupperFirstFocusable !== node) return NodeFilter.FILTER_REJECT;
                if (tabsterFocusable.isFocusable(node)) setElement(node);
                return NodeFilter.FILTER_SKIP;
            });
            if (walker) {
                walker.currentNode = element;
                while(walker.nextNode());
            }
        };
        const removeWalk = (element)=>{
            const current = allElements.get(element);
            if (current) setElement(element, true);
            for(let el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstElementChild(element); el; el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getNextElementSibling(el))removeWalk(el);
        };
        const requestUpdate = ()=>{
            if (!this._updateTimer && updateQueue.length) this._updateTimer = win.setTimeout(()=>{
                delete this._updateTimer;
                for (const { element: element, type: type } of updateQueue)switch(type){
                    case $c9be631229ea4e08$var$_moverUpdateAttr:
                        updateElement(element);
                        break;
                    case $c9be631229ea4e08$var$_moverUpdateAdd:
                        addNewElements(element);
                        break;
                    case $c9be631229ea4e08$var$_moverUpdateRemove:
                        removeWalk(element);
                        break;
                }
                updateQueue = this._updateQueue = [];
            }, 0);
        };
        const getMoverGroupper = (element)=>{
            const ret = {};
            for(let el = element; el; el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(el)){
                const toe = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, el);
                if (toe) {
                    if (toe.groupper && !ret.groupper) ret.groupper = toe.groupper;
                    if (toe.mover) {
                        ret.mover = toe.mover;
                        break;
                    }
                }
            }
            return ret;
        };
        updateQueue.push({
            element: element,
            type: $c9be631229ea4e08$var$_moverUpdateAdd
        });
        requestUpdate();
        observer.observe(element, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "tabindex"
            ]
        });
        this._unobserve = ()=>{
            observer.disconnect();
        };
    }
    getState(element) {
        const id = (0, $8031a5e97995bd92$export$2dc82a3fd984deae)(this._win, element);
        if (id in this._visible) {
            const visibility = this._visible[id] || (0, $43f171f5f7088580$export$878d96173d57e644).Invisible;
            const isCurrent = this._current ? this._current.get() === element : undefined;
            return {
                isCurrent: isCurrent,
                visibility: visibility
            };
        }
        return undefined;
    }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $c9be631229ea4e08$var$validateMoverProps(props) {
// TODO: Implement validation.
}
/**
 * Calculates distance between two rectangles.
 *
 * @param ax1 first rectangle left
 * @param ay1 first rectangle top
 * @param ax2 first rectangle right
 * @param ay2 first rectangle bottom
 * @param bx1 second rectangle left
 * @param by1 second rectangle top
 * @param bx2 second rectangle right
 * @param by2 second rectangle bottom
 * @returns number, shortest distance between the rectangles.
 */ function $c9be631229ea4e08$var$getDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
    const xDistance = ax2 < bx1 ? bx1 - ax2 : bx2 < ax1 ? ax1 - bx2 : 0;
    const yDistance = ay2 < by1 ? by1 - ay2 : by2 < ay1 ? ay1 - by2 : 0;
    return xDistance === 0 ? yDistance : yDistance === 0 ? xDistance : Math.sqrt(xDistance * xDistance + yDistance * yDistance);
}
class $c9be631229ea4e08$export$f6d69f9fcc42048c {
    constructor(tabster, getWindow){
        this._init = ()=>{
            const win = this._win();
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, "keydown", this._onKeyDown, true);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, (0, $b6b59d8a07a2383a$export$3a927ee2f95ddfa), this._onMoveFocus);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, (0, $b6b59d8a07a2383a$export$f538b9d389680b27), this._onMemorizedElement);
            this._tabster.focusedElement.subscribe(this._onFocus);
        };
        this._onMoverDispose = (mover)=>{
            delete this._movers[mover.id];
        };
        this._onFocus = (element)=>{
            // When something in the app gets focused, we are making sure that
            // the relevant context Mover is aware of it.
            // Looking for the relevant context Mover from the currently
            // focused element parent, not from the element itself, because the
            // Mover element itself cannot be its own current (but might be
            // current for its parent Mover).
            let currentFocusableElement = element;
            let deepestFocusableElement = element;
            for(let el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(element); el; el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(el)){
                // We go through all Movers up from the focused element and
                // set their current element to the deepest focusable of that
                // Mover.
                const mover = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, el)?.mover;
                if (mover) {
                    mover.setCurrent(deepestFocusableElement);
                    currentFocusableElement = undefined;
                }
                if (!currentFocusableElement && this._tabster.focusable.isFocusable(el)) currentFocusableElement = deepestFocusableElement = el;
            }
        };
        this._onKeyDown = async (event)=>{
            if (this._ignoredInputTimer) {
                this._win().clearTimeout(this._ignoredInputTimer);
                delete this._ignoredInputTimer;
            }
            this._ignoredInputResolve?.(false);
            // Give a chance to other listeners to handle the event (for example,
            // to scroll instead of moving focus).
            if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) return;
            const key = event.key;
            let moverKey;
            if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowDown) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowDown;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowRight) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowRight;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowUp) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowUp;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowLeft) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowLeft;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).PageDown) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).PageDown;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).PageUp) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).PageUp;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Home) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).Home;
            else if (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).End) moverKey = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).End;
            if (!moverKey) return;
            const focused = this._tabster.focusedElement.getFocusedElement();
            if (!focused || await this._isIgnoredInput(focused, key)) return;
            this._moveFocus(focused, moverKey, event);
        };
        this._onMoveFocus = (e)=>{
            const element = e.composedPath()[0];
            const key = e.detail?.key;
            if (element && key !== undefined && !e.defaultPrevented) {
                this._moveFocus(element, key);
                e.stopImmediatePropagation();
            }
        };
        this._onMemorizedElement = (e)=>{
            const target = e.composedPath()[0];
            let memorizedElement = e.detail?.memorizedElement;
            if (target) {
                const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, target);
                const mover = ctx?.mover;
                if (mover) {
                    if (memorizedElement && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(mover.getElement(), memorizedElement)) memorizedElement = undefined;
                    mover.setCurrent(memorizedElement);
                    e.stopImmediatePropagation();
                }
            }
        };
        this._tabster = tabster;
        this._win = getWindow;
        this._movers = {};
        tabster.queueInit(this._init);
    }
    dispose() {
        const win = this._win();
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        this._ignoredInputResolve?.(false);
        if (this._ignoredInputTimer) {
            win.clearTimeout(this._ignoredInputTimer);
            delete this._ignoredInputTimer;
        }
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, "keydown", this._onKeyDown, true);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, (0, $b6b59d8a07a2383a$export$3a927ee2f95ddfa), this._onMoveFocus);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, (0, $b6b59d8a07a2383a$export$f538b9d389680b27), this._onMemorizedElement);
        Object.keys(this._movers).forEach((moverId)=>{
            if (this._movers[moverId]) {
                this._movers[moverId].dispose();
                delete this._movers[moverId];
            }
        });
    }
    createMover(element, props, sys) {
        const newMover = new $c9be631229ea4e08$export$c252e6c2a70907cd(this._tabster, element, this._onMoverDispose, props, sys);
        this._movers[newMover.id] = newMover;
        return newMover;
    }
    moveFocus(fromElement, key) {
        return this._moveFocus(fromElement, key);
    }
    _moveFocus(fromElement, key, relatedEvent) {
        const tabster = this._tabster;
        const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, fromElement, {
            checkRtl: true
        });
        if (!ctx || !ctx.mover || ctx.excludedFromMover || relatedEvent && ctx.ignoreKeydown(relatedEvent)) return null;
        const mover = ctx.mover;
        const container = mover.getElement();
        if (ctx.groupperBeforeMover) {
            const groupper = ctx.groupper;
            if (groupper && !groupper.isActive(true)) // For the cases when we have Mover/Active Groupper/Inactive Groupper, we need to check
            // the grouppers between the current element and the current mover.
            for(let el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(groupper.getElement()); el && el !== container; el = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(el)){
                if ((0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, el)?.groupper?.isActive(true)) return null;
            }
            else return null;
        }
        if (!container) return null;
        const focusable = tabster.focusable;
        const moverProps = mover.getProps();
        const direction = moverProps.direction || (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Both;
        const isBoth = direction === (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Both;
        const isVertical = isBoth || direction === (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Vertical;
        const isHorizontal = isBoth || direction === (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Horizontal;
        const isGridLinear = direction === (0, $43f171f5f7088580$export$7c43ed5d018e9c17).GridLinear;
        const isGrid = isGridLinear || direction === (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Grid;
        const isCyclic = moverProps.cyclic;
        let next;
        let scrollIntoViewArg;
        let focusedElementRect;
        let focusedElementX1 = 0;
        let focusedElementX2 = 0;
        if (isGrid) {
            focusedElementRect = fromElement.getBoundingClientRect();
            focusedElementX1 = Math.ceil(focusedElementRect.left);
            focusedElementX2 = Math.floor(focusedElementRect.right);
        }
        if (ctx.rtl) {
            if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowRight) key = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowLeft;
            else if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowLeft) key = (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowRight;
        }
        if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowDown && isVertical || key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowRight && (isHorizontal || isGrid)) {
            next = focusable.findNext({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true
            });
            if (next && isGrid) {
                const nextElementX1 = Math.ceil(next.getBoundingClientRect().left);
                if (!isGridLinear && focusedElementX2 > nextElementX1) next = undefined;
            } else if (!next && isCyclic) next = focusable.findFirst({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowUp && isVertical || key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowLeft && (isHorizontal || isGrid)) {
            next = focusable.findPrev({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true
            });
            if (next && isGrid) {
                const nextElementX2 = Math.floor(next.getBoundingClientRect().right);
                if (!isGridLinear && nextElementX2 > focusedElementX1) next = undefined;
            } else if (!next && isCyclic) next = focusable.findLast({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).Home) {
            if (isGrid) focusable.findElement({
                container: container,
                currentElement: fromElement,
                useActiveModalizer: true,
                isBackward: true,
                acceptCondition: (el)=>{
                    if (!focusable.isFocusable(el)) return false;
                    const nextElementX1 = Math.ceil(el.getBoundingClientRect().left ?? 0);
                    if (el !== fromElement && focusedElementX1 <= nextElementX1) return true;
                    next = el;
                    return false;
                }
            });
            else next = focusable.findFirst({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).End) {
            if (isGrid) focusable.findElement({
                container: container,
                currentElement: fromElement,
                useActiveModalizer: true,
                acceptCondition: (el)=>{
                    if (!focusable.isFocusable(el)) return false;
                    const nextElementX1 = Math.ceil(el.getBoundingClientRect().left ?? 0);
                    if (el !== fromElement && focusedElementX1 >= nextElementX1) return true;
                    next = el;
                    return false;
                }
            });
            else next = focusable.findLast({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).PageUp) {
            focusable.findElement({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true,
                isBackward: true,
                acceptCondition: (el)=>{
                    if (!focusable.isFocusable(el)) return false;
                    if ((0, $8031a5e97995bd92$export$11e0e62ee78050d6)(this._win, el, mover.visibilityTolerance)) {
                        next = el;
                        return false;
                    }
                    return true;
                }
            });
            // will be on the first column move forward and preserve previous column
            if (isGrid && next) {
                const firstColumnX1 = Math.ceil(next.getBoundingClientRect().left);
                focusable.findElement({
                    currentElement: next,
                    container: container,
                    useActiveModalizer: true,
                    acceptCondition: (el)=>{
                        if (!focusable.isFocusable(el)) return false;
                        const nextElementX1 = Math.ceil(el.getBoundingClientRect().left);
                        if (focusedElementX1 < nextElementX1 || firstColumnX1 >= nextElementX1) return true;
                        next = el;
                        return false;
                    }
                });
            }
            scrollIntoViewArg = false;
        } else if (key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).PageDown) {
            focusable.findElement({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true,
                acceptCondition: (el)=>{
                    if (!focusable.isFocusable(el)) return false;
                    if ((0, $8031a5e97995bd92$export$11e0e62ee78050d6)(this._win, el, mover.visibilityTolerance)) {
                        next = el;
                        return false;
                    }
                    return true;
                }
            });
            // will be on the last column move backwards and preserve previous column
            if (isGrid && next) {
                const lastColumnX1 = Math.ceil(next.getBoundingClientRect().left);
                focusable.findElement({
                    currentElement: next,
                    container: container,
                    useActiveModalizer: true,
                    isBackward: true,
                    acceptCondition: (el)=>{
                        if (!focusable.isFocusable(el)) return false;
                        const nextElementX1 = Math.ceil(el.getBoundingClientRect().left);
                        if (focusedElementX1 > nextElementX1 || lastColumnX1 <= nextElementX1) return true;
                        next = el;
                        return false;
                    }
                });
            }
            scrollIntoViewArg = true;
        } else if (isGrid) {
            const isBackward = key === (0, $43f171f5f7088580$export$cb3e5a20e92ebf87).ArrowUp;
            const ax1 = focusedElementX1;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const ay1 = Math.ceil(focusedElementRect.top);
            const ax2 = focusedElementX2;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const ay2 = Math.floor(focusedElementRect.bottom);
            let targetElement;
            let lastDistance;
            let lastIntersection = 0;
            focusable.findAll({
                container: container,
                currentElement: fromElement,
                isBackward: isBackward,
                onElement: (el)=>{
                    // Find element which has maximal intersection with the focused element horizontally,
                    // or the closest one.
                    const rect = el.getBoundingClientRect();
                    const bx1 = Math.ceil(rect.left);
                    const by1 = Math.ceil(rect.top);
                    const bx2 = Math.floor(rect.right);
                    const by2 = Math.floor(rect.bottom);
                    if (isBackward && ay1 < by2 || !isBackward && ay2 > by1) // Only consider elements which are below/above curretly focused.
                    return true;
                    const xIntersectionWidth = Math.ceil(Math.min(ax2, bx2)) - Math.floor(Math.max(ax1, bx1));
                    const minWidth = Math.ceil(Math.min(ax2 - ax1, bx2 - bx1));
                    if (xIntersectionWidth > 0 && minWidth >= xIntersectionWidth) {
                        // Element intersects with the focused element on X axis.
                        const intersection = xIntersectionWidth / minWidth;
                        if (intersection > lastIntersection) {
                            targetElement = el;
                            lastIntersection = intersection;
                        }
                    } else if (lastIntersection === 0) {
                        // If we didn't have intersection, try just the closest one.
                        const distance = $c9be631229ea4e08$var$getDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2);
                        if (lastDistance === undefined || distance < lastDistance) {
                            lastDistance = distance;
                            targetElement = el;
                        }
                    } else if (lastIntersection > 0) // Element doesn't intersect, but we had intersection already, stop search.
                    return false;
                    return true;
                }
            });
            next = targetElement;
        }
        if (next && (!relatedEvent || relatedEvent && (0, $8031a5e97995bd92$export$716a11175c03fb4e)(container, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
            by: "mover",
            owner: container,
            next: next,
            relatedEvent: relatedEvent
        })))) {
            if (scrollIntoViewArg !== undefined) (0, $8031a5e97995bd92$export$53a0910f038337bd)(this._win, next, scrollIntoViewArg);
            if (relatedEvent) {
                relatedEvent.preventDefault();
                relatedEvent.stopImmediatePropagation();
            }
            (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(next);
            return next;
        }
        return null;
    }
    async _isIgnoredInput(element, key) {
        if (element.getAttribute("aria-expanded") === "true" && (element.hasAttribute("aria-activedescendant") || element.getAttribute("role") === "combobox")) // It is likely a combobox with expanded options and arrow keys are
        // controlled by it.
        return true;
        if ((0, $8031a5e97995bd92$export$b06a2f5618961e1e)(element, $c9be631229ea4e08$var$_inputSelector)) {
            let selectionStart = 0;
            let selectionEnd = 0;
            let textLength = 0;
            let asyncRet;
            if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
                const type = element.type;
                const value = element.value;
                textLength = (value || "").length;
                if (type === "email" || type === "number") // For these types Chromium doesn't provide selectionStart and selectionEnd.
                // Hence the ugly workaround to find if the caret position is changed with
                // the keypress.
                // TODO: Have a look at range, week, time, time, date, datetime-local.
                {
                    if (textLength) {
                        const selection = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getSelection(element);
                        if (selection) {
                            const initialLength = selection.toString().length;
                            const isBackward = key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowLeft || key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowUp;
                            selection.modify("extend", isBackward ? "backward" : "forward", "character");
                            if (initialLength !== selection.toString().length) {
                                // The caret is moved, so, we're not on the edge of the value.
                                // Restore original selection.
                                selection.modify("extend", isBackward ? "forward" : "backward", "character");
                                return true;
                            } else textLength = 0;
                        }
                    }
                } else {
                    const selStart = element.selectionStart;
                    if (selStart === null) // Do not ignore not text editable inputs like checkboxes and radios (but ignore hidden).
                    return type === "hidden";
                    selectionStart = selStart || 0;
                    selectionEnd = element.selectionEnd || 0;
                }
            } else if (element.contentEditable === "true") asyncRet = new Promise((resolve)=>{
                this._ignoredInputResolve = (value)=>{
                    delete this._ignoredInputResolve;
                    resolve(value);
                };
                const win = this._win();
                if (this._ignoredInputTimer) win.clearTimeout(this._ignoredInputTimer);
                const { anchorNode: prevAnchorNode, focusNode: prevFocusNode, anchorOffset: prevAnchorOffset, focusOffset: prevFocusOffset } = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getSelection(element) || {};
                // Get selection gives incorrect value if we call it syncronously onKeyDown.
                this._ignoredInputTimer = win.setTimeout(()=>{
                    delete this._ignoredInputTimer;
                    const { anchorNode: anchorNode, focusNode: focusNode, anchorOffset: anchorOffset, focusOffset: focusOffset } = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getSelection(element) || {};
                    if (anchorNode !== prevAnchorNode || focusNode !== prevFocusNode || anchorOffset !== prevAnchorOffset || focusOffset !== prevFocusOffset) {
                        this._ignoredInputResolve?.(false);
                        return;
                    }
                    selectionStart = anchorOffset || 0;
                    selectionEnd = focusOffset || 0;
                    textLength = element.textContent?.length || 0;
                    if (anchorNode && focusNode) {
                        if ((0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, anchorNode) && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, focusNode)) {
                            if (anchorNode !== element) {
                                let anchorFound = false;
                                const addOffsets = (node)=>{
                                    if (node === anchorNode) anchorFound = true;
                                    else if (node === focusNode) return true;
                                    const nodeText = node.textContent;
                                    if (nodeText && !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstChild(node)) {
                                        const len = nodeText.length;
                                        if (anchorFound) {
                                            if (focusNode !== anchorNode) selectionEnd += len;
                                        } else {
                                            selectionStart += len;
                                            selectionEnd += len;
                                        }
                                    }
                                    let stop = false;
                                    for(let e = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getFirstChild(node); e && !stop; e = e.nextSibling)stop = addOffsets(e);
                                    return stop;
                                };
                                addOffsets(element);
                            }
                        }
                    }
                    this._ignoredInputResolve?.(true);
                }, 0);
            });
            if (asyncRet && !await asyncRet) return true;
            if (selectionStart !== selectionEnd) return true;
            if (selectionStart > 0 && (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowLeft || key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowUp || key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Home)) return true;
            if (selectionStart < textLength && (key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowRight || key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).ArrowDown || key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).End)) return true;
        }
        return false;
    }
}


function $5e5936366a8ce663$export$f38e08cc6ea819e7(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.mover) {
        const api = new (0, $c9be631229ea4e08$export$f6d69f9fcc42048c)(tabsterCore, tabsterCore.getWindow);
        tabsterCore.mover = api;
        tabsterCore.attrHandlers.set("mover", (element, existingMover, newProps, _oldProps, sys)=>{
            if (existingMover) {
                existingMover.setProps(newProps);
                return existingMover;
            }
            return api.createMover(element, newProps, sys);
        });
    }
    return tabsterCore.mover;
}




'use client';
const $d560ba8cc00a7511$export$ce58b15831f653b8 = (options = {})=>{
    const { circular: circular, axis: axis, memorizeCurrent: memorizeCurrent = true, tabbable: tabbable, ignoreDefaultKeydown: ignoreDefaultKeydown, unstable_hasDefault: unstable_hasDefault } = options;
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)((0, $5e5936366a8ce663$export$f38e08cc6ea819e7));
    return (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        mover: {
            cyclic: !!circular,
            direction: $d560ba8cc00a7511$var$axisToMoverDirection(axis !== null && axis !== void 0 ? axis : 'vertical'),
            memorizeCurrent: memorizeCurrent,
            tabbable: tabbable,
            hasDefault: unstable_hasDefault
        },
        ...ignoreDefaultKeydown && {
            focusable: {
                ignoreKeydown: ignoreDefaultKeydown
            }
        }
    });
};
function $d560ba8cc00a7511$var$axisToMoverDirection(axis) {
    switch(axis){
        case 'horizontal':
            return (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Horizontal;
        case 'grid':
            return (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Grid;
        case 'grid-linear':
            return (0, $43f171f5f7088580$export$7c43ed5d018e9c17).GridLinear;
        case 'both':
            return (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Both;
        case 'vertical':
        default:
            return (0, $43f171f5f7088580$export$7c43ed5d018e9c17).Vertical;
    }
}



var $acw62 = parcelRequire("acw62");


'use client';
const $b13e6753fef1f098$var$setAnimationFrameNoop = (callback)=>{
    callback(0);
    return 0;
};
const $b13e6753fef1f098$var$cancelAnimationFrameNoop = (handle)=>handle;
function $b13e6753fef1f098$export$641fa9c94086b46e() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const setAnimationFrame = win ? win.requestAnimationFrame : $b13e6753fef1f098$var$setAnimationFrameNoop;
    const clearAnimationFrame = win ? win.cancelAnimationFrame : $b13e6753fef1f098$var$cancelAnimationFrameNoop;
    return (0, $9521bdea52bd87ae$export$adc464bf5eb3c05c)(setAnimationFrame, clearAnimationFrame);
}




'use client';
/**
 * Get the current scroll state of the DrawerBody.
 *
 * @internal
 * @param element - HTMLElement to check scroll state of
 */ const $2abaef046fa13d36$var$getScrollState = ({ scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight })=>{
    if (scrollHeight <= clientHeight) return 'none';
    if (scrollTop === 0) return 'top';
    if (scrollTop + clientHeight === scrollHeight) return 'bottom';
    return 'middle';
};
const $2abaef046fa13d36$export$6a26f58f74b50a9d = (props, ref)=>{
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const { setScrollState: setScrollState } = (0, $f151dc37217d3a88$export$6bc0175b947a255a)();
    const scrollRef = $acw62.useRef(null);
    const mergedRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, scrollRef);
    const [setScrollAnimationFrame, cancelScrollAnimationFrame] = (0, $b13e6753fef1f098$export$641fa9c94086b46e)();
    const [setResizeAnimationFrame, cancelResizeAnimationFrame] = (0, $b13e6753fef1f098$export$641fa9c94086b46e)();
    const updateScrollState = $acw62.useCallback(()=>{
        if (!scrollRef.current) return;
        setScrollState($2abaef046fa13d36$var$getScrollState(scrollRef.current));
    }, [
        setScrollState
    ]);
    const onScroll = $acw62.useCallback(()=>{
        cancelScrollAnimationFrame();
        setScrollAnimationFrame(updateScrollState);
    }, [
        cancelScrollAnimationFrame,
        setScrollAnimationFrame,
        updateScrollState
    ]);
    // Update scroll state on children change
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(updateScrollState, [
        props.children,
        updateScrollState
    ]);
    // Update scroll state on mount and when resize occurs
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        if (!scrollRef.current || !(win === null || win === void 0 ? void 0 : win.ResizeObserver)) return;
        const observer = new win.ResizeObserver(()=>setResizeAnimationFrame(updateScrollState));
        observer.observe(scrollRef.current);
        return ()=>{
            observer.disconnect();
            cancelResizeAnimationFrame();
        };
    }, [
        setResizeAnimationFrame,
        cancelResizeAnimationFrame,
        updateScrollState,
        win
    ]);
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ref: mergedRef,
            ...props,
            // eslint-disable-next-line react-hooks/refs
            onScroll: (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(props.onScroll, onScroll)
        }), {
            elementType: 'div'
        })
    };
};



'use client';
const $11741ec483fc976a$export$27f9c1e7ef367229 = (props, ref)=>{
    const { tabbable: tabbable } = (0, $ee11a7d007e02639$export$5ed88c9532b7cd46)();
    const focusAttributes = (0, $d560ba8cc00a7511$export$ce58b15831f653b8)({
        axis: 'vertical',
        circular: true,
        tabbable: tabbable
    });
    return (0, $2abaef046fa13d36$export$6a26f58f74b50a9d)({
        ...focusAttributes,
        ...props
    }, ref);
};






'use client';
const $5587c668c918896f$export$e028efff16770a77 = {
    root: 'fui-DrawerBody'
};
/**
 * Styles for the root slot
 */ const $5587c668c918896f$var$useStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("ri6rvx7", null, [
    ".ri6rvx7{padding:0 var(--spacingHorizontalXXL);flex:1;align-self:stretch;position:relative;z-index:1;overflow:auto;}",
    ".ri6rvx7:last-child{padding-bottom:calc(var(--spacingHorizontalXXL) + 1px);}",
    ".ri6rvx7:first-child{padding-top:calc(var(--spacingHorizontalXXL) + 1px);}"
]);
const $5587c668c918896f$export$a8517da7716688b = (state)=>{
    const styles = $5587c668c918896f$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5587c668c918896f$export$e028efff16770a77.root, styles, state.root.className);
    return state;
};


'use client';
const $9171394945308ef5$export$bfc15ca739c18982 = {
    root: 'fui-NavDrawerBody'
};
/**
 * Styles for the root slot
 */ const $9171394945308ef5$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "fif7vu7",
            "f1htewbf"
        ],
        Bt984gj: "f3gca8",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Belr9w4: "f1j0q4x9"
    }
}, {
    d: [
        [
            ".fif7vu7{padding:0 var(--spacingHorizontalXS) 0 var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f1htewbf{padding:0 var(--spacingHorizontalMNudge) 0 var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".f3gca8{align-items:unset;}",
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f1j0q4x9{row-gap:var(--spacingVerticalXXS);}"
    ]
});
const $9171394945308ef5$export$116a26f492242054 = (state)=>{
    (0, $5587c668c918896f$export$a8517da7716688b)(state);
    const styles = $9171394945308ef5$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($9171394945308ef5$export$bfc15ca739c18982.root, styles.root, state.root.className);
    return state;
};


'use client';
const $bf547612cab457ee$export$f8e4c6ba6de2a0f2 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $11741ec483fc976a$export$27f9c1e7ef367229)(props, ref);
    (0, $9171394945308ef5$export$116a26f492242054)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useNavDrawerBodyStyles_unstable')(state);
    return (0, $e1fe6f2b1830352c$export$fe16988d8e0e4b7b)(state);
});
$bf547612cab457ee$export$f8e4c6ba6de2a0f2.displayName = 'NavDrawerBody';


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



'use client';
const $673c9e8e86f905f1$export$e88788ea83db6d1 = (props, ref)=>{
    const { density: density = 'medium' } = (0, $ee11a7d007e02639$export$5ed88c9532b7cd46)();
    const state = $673c9e8e86f905f1$export$85163a10f505d71e(props, ref);
    return {
        ...state,
        density: density
    };
};
const $673c9e8e86f905f1$export$85163a10f505d71e = (props, ref)=>{
    const { onClick: onClick, value: value, icon: icon, as: as, href: href } = props;
    const { selectedValue: selectedValue, onRegister: onRegister, onUnregister: onUnregister, onSelect: onSelect } = (0, $ee11a7d007e02639$export$5ed88c9532b7cd46)();
    const rootElementType = as || (href ? 'a' : 'button');
    const selected = selectedValue === value;
    const innerRef = $acw62.useRef(null);
    const onNavItemClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        onClick === null || onClick === void 0 || onClick(event);
        if (!event.defaultPrevented && (0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(event.target)) onSelect(event, {
            type: 'click',
            event: event,
            value: value
        });
    });
    const root = (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootElementType, (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)(rootElementType, {
        'aria-current': selected ? 'page' : 'false',
        ...props
    })), {
        elementType: rootElementType,
        defaultProps: {
            ref: ref,
            type: rootElementType
        }
    });
    root.onClick = onNavItemClick;
    $acw62.useEffect(()=>{
        onRegister({
            value: value,
            ref: innerRef
        });
        return ()=>{
            onUnregister({
                value: value,
                ref: innerRef
            });
        };
    }, [
        onRegister,
        onUnregister,
        innerRef,
        value
    ]);
    return {
        components: {
            root: rootElementType,
            icon: 'span'
        },
        root: root,
        icon: (0, $fcf7ddccaab7fd8f$exports).optional(icon, {
            elementType: 'span'
        }),
        selected: selected,
        value: value
    };
};




const $21e989ab934deca8$export$cf1a6c342845994b = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            state.root.children
        ]
    });
};






'use client';
const $cd463bb0a3b55c2e$export$fbd4eb69d6ce608c = {
    defaultDrawerWidth: 260,
    indicatorOffset: 16,
    indicatorWidth: 4,
    indicatorHeight: 20,
    backgroundColor: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralBackground4,
    backgroundColorHover: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralBackground4Hover,
    backgroundColorPressed: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralBackground4Pressed,
    animationTokens: {
        animationDuration: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).durationFaster,
        animationFillMode: 'both',
        animationTimingFunction: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).curveLinear
    },
    transitionTokens: {
        transitionDuration: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).durationFaster,
        transitionTimingFunction: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).curveLinear,
        transitionProperty: 'background'
    }
};
const $cd463bb0a3b55c2e$export$a813f16320989a0e = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rdi7s9k", "r94071", [
    ".rdi7s9k{display:flex;text-transform:none;position:relative;justify-content:start;align-items:flex-start;text-align:left;gap:var(--spacingVerticalL);padding:var(--spacingVerticalMNudge) var(--spacingHorizontalS) var(--spacingVerticalMNudge) var(--spacingHorizontalMNudge);background-color:var(--colorNeutralBackground4);border-radius:var(--borderRadiusMedium);color:var(--colorNeutralForeground2);text-decoration-line:none;border:none;box-sizing:border-box;cursor:pointer;transition-duration:var(--durationFaster);transition-timing-function:var(--curveLinear);transition-property:background;width:100%;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);}",
    ".rdi7s9k:hover{background-color:var(--colorNeutralBackground4Hover);}",
    ".rdi7s9k:focus-visible{outline:var(--strokeWidthThick) solid var(--colorStrokeFocus2);outline-offset:calc(var(--strokeWidthThick) * -1);}",
    ".r94071{display:flex;text-transform:none;position:relative;justify-content:start;align-items:flex-start;text-align:right;gap:var(--spacingVerticalL);padding:var(--spacingVerticalMNudge) var(--spacingHorizontalMNudge) var(--spacingVerticalMNudge) var(--spacingHorizontalS);background-color:var(--colorNeutralBackground4);border-radius:var(--borderRadiusMedium);color:var(--colorNeutralForeground2);text-decoration-line:none;border:none;box-sizing:border-box;cursor:pointer;transition-duration:var(--durationFaster);transition-timing-function:var(--curveLinear);transition-property:background;width:100%;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);}",
    ".r94071:hover{background-color:var(--colorNeutralBackground4Hover);}",
    ".r94071:focus-visible{outline:var(--strokeWidthThick) solid var(--colorStrokeFocus2);outline-offset:calc(var(--strokeWidthThick) * -1);}"
]);
const $cd463bb0a3b55c2e$export$73019aca27f224f6 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f1434i56",
            "f1jkyjtc"
        ]
    }
}, {
    d: [
        [
            ".f1434i56{padding:var(--spacingVerticalXS) var(--spacingHorizontalS) var(--spacingVerticalXS) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f1jkyjtc{padding:var(--spacingVerticalXS) var(--spacingHorizontalMNudge) var(--spacingVerticalXS) var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ]
    ]
});
const $cd463bb0a3b55c2e$export$553104bab990213f = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    selected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const $cd463bb0a3b55c2e$export$3fefbabbc10ea59d = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        E3zdtr: "f1mdlcz9",
        xr36ep: "fpil94b",
        B67388b: "f90z1up",
        Bitv4sc: "f2ic3ny",
        Br128sd: "f1xz7mvd",
        rjyhj6: "f3i5gj0",
        Bjyk6c5: "fi4v1pz",
        Dlnsje: "f1tvrmnx",
        a2br6o: "f1p1ggug",
        d9w3h3: 0,
        B3778ie: 0,
        B4j8arr: 0,
        Bl18szs: 0,
        Blrzh8d: "f3b9emi",
        Bsft5z2: "f13zj6fq",
        vikyaa: 0,
        Brlscjf: 0,
        vvp1qr: 0,
        t65l24: "f1ak99p5",
        rc3c53: "fmnu42u"
    }
}, {
    d: [
        ".f1mdlcz9::after{position:absolute;}",
        ".fpil94b::after{animation-duration:var(--durationFaster);}",
        ".f90z1up::after{animation-fill-mode:both;}",
        ".f2ic3ny::after{animation-timing-function:var(--curveLinear);}",
        ".f1xz7mvd::after{animation-name:f1ayorr4;}",
        ".f3i5gj0::after{-webkit-margin-start:-16px;margin-inline-start:-16px;}",
        ".fi4v1pz::after{background-color:var(--colorCompoundBrandForeground1);}",
        ".f1tvrmnx::after{height:20px;}",
        ".f1p1ggug::after{width:4px;}",
        [
            ".f3b9emi::after{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f13zj6fq::after{content:\"\";}"
    ],
    k: [
        "@keyframes f1ayorr4{0%{background:transparent;}100%{background:var(--colorCompoundBrandForeground1);}}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1ak99p5::after{outline:solid 2px var(--colorTransparentStroke);}}",
            {
                p: -1,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fmnu42u::after{outline-offset:-2px;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $cd463bb0a3b55c2e$export$4ded664d7c29e665 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        mc9l5x: "f13qh94s",
        zoa1oz: "fngvled",
        sshi5w: "f16gbxbe",
        Bf4jedk: "f11u7vat",
        Bt984gj: "f1w4ww9t",
        Brf1p80: "f4d9j23",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        B9gejnh: 0,
        yr4pdu: 0,
        Bvkmzld: 0,
        mqdk8l: 0,
        Gbjhqp: "f1uiug86",
        obb2bi: "fwrh02z",
        D0sxk3: "f16u1re",
        Esdz9e: 0,
        Bqil8sh: 0,
        Bbom3er: 0,
        djjtid: 0,
        mz70lj: "f1jsjwoh",
        t6yez3: "f8bsbmo"
    },
    selected: {
        C9vb3z: "f5rs5gh",
        ux3ctl: "f1ioc1t6",
        Ba906uv: "fey0lwf",
        D0sxk3: "fxoiby5",
        hndn0g: "fnh0dvc",
        cw2nnk: "fp7jrvw",
        Bkztwl0: "fdt4y6x",
        H8nmoi: "fvl64og",
        ipgedg: "ffh1t26"
    }
}, {
    d: [
        ".f13qh94s{display:grid;}",
        ".fngvled{grid-template-areas:overlay-area;}",
        ".f16gbxbe{min-height:20px;}",
        ".f11u7vat{min-width:20px;}",
        ".f1w4ww9t{align-items:top;}",
        ".f4d9j23{justify-content:center;}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        [
            ".f1uiug86 .fui-Icon-filled{grid-area:overlay-area;}",
            {
                p: -1
            }
        ],
        ".fwrh02z .fui-Icon-filled{color:transparent;}",
        ".f16u1re .fui-Icon-filled{display:none;}",
        [
            ".f1jsjwoh .fui-Icon-regular{grid-area:overlay-area;}",
            {
                p: -1
            }
        ],
        ".f8bsbmo .fui-Icon-regular{display:inline;}",
        ".f5rs5gh .fui-Icon-filled{animation-duration:var(--durationFaster);}",
        ".f1ioc1t6 .fui-Icon-filled{animation-fill-mode:both;}",
        ".fey0lwf .fui-Icon-filled{animation-timing-function:var(--curveLinear);}",
        ".fxoiby5 .fui-Icon-filled{display:inline;}",
        ".fnh0dvc .fui-Icon-filled{animation-name:f9t3kp0;}",
        ".fp7jrvw .fui-Icon-regular{animation-duration:var(--durationFaster);}",
        ".fdt4y6x .fui-Icon-regular{animation-fill-mode:both;}",
        ".fvl64og .fui-Icon-regular{animation-timing-function:var(--curveLinear);}",
        ".ffh1t26 .fui-Icon-regular{animation-name:fvunsy5;}"
    ],
    k: [
        "@keyframes f9t3kp0{0%{opacity:0;color:transparent;}100%{opacity:1;color:var(--colorNeutralForeground2BrandSelected);}}",
        "@keyframes fvunsy5{0%{opacity:1;color:var(--colorNeutralForeground2);}100%{opacity:0;color:transparent;}}"
    ]
});


'use client';
const $50dd856c34c432c5$export$cb3bb5fd912d64f5 = {
    root: 'fui-NavItem',
    icon: 'fui-NavItem__icon'
};
const $50dd856c34c432c5$export$3ed7239a1f3aec21 = (state)=>{
    const rootDefaultClassName = (0, $cd463bb0a3b55c2e$export$a813f16320989a0e)();
    const smallStyles = (0, $cd463bb0a3b55c2e$export$73019aca27f224f6)();
    const contentStyles = (0, $cd463bb0a3b55c2e$export$553104bab990213f)();
    const indicatorStyles = (0, $cd463bb0a3b55c2e$export$3fefbabbc10ea59d)();
    const iconStyles = (0, $cd463bb0a3b55c2e$export$4ded664d7c29e665)();
    const { selected: selected, density: density } = state;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($50dd856c34c432c5$export$cb3bb5fd912d64f5.root, rootDefaultClassName, density === 'small' && smallStyles.root, selected && indicatorStyles.base, selected && contentStyles.selected, state.root.className);
    if (state.icon) // eslint-disable-next-line react-hooks/immutability
    state.icon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($50dd856c34c432c5$export$cb3bb5fd912d64f5.icon, iconStyles.base, selected && iconStyles.selected, state.icon.className);
    return state;
};


'use client';
const $5ba202ace73a9adb$export$e3925dbaeffcc83f = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $673c9e8e86f905f1$export$e88788ea83db6d1)(props, ref);
    (0, $50dd856c34c432c5$export$3ed7239a1f3aec21)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useNavItemStyles_unstable')(state);
    return (0, $21e989ab934deca8$export$cf1a6c342845994b)(state);
});
$5ba202ace73a9adb$export$e3925dbaeffcc83f.displayName = 'NavItem';



var $acw62 = parcelRequire("acw62");



const $1f8995744f4c8216$export$4ebf1d0fd5709b4f = (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "fjseox"
    },
    visible: {
        mc9l5x: "f1w7gpdv"
    }
}, {
    d: [
        ".fjseox{display:none;}",
        ".f1w7gpdv{display:inline;}"
    ]
});


const $544dcb7495d058dc$export$5c43b1785e5213ca = (FilledIcon, RegularIcon)=>{
    const Component = (props)=>{
        const { className: className, filled: filled, ...rest } = props;
        const styles = (0, $1f8995744f4c8216$export$4ebf1d0fd5709b4f)();
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement(FilledIcon, Object.assign({}, rest, {
            className: (0, $00898283de415a49$export$3d46f4579dba46e5)(styles.root, filled && styles.visible, (0, $3ca67d612ed7abba$export$cc86ffec8c6eb24e), className)
        })), $acw62.createElement(RegularIcon, Object.assign({}, rest, {
            className: (0, $00898283de415a49$export$3d46f4579dba46e5)(styles.root, !filled && styles.visible, (0, $3ca67d612ed7abba$export$f8a5601dfd94d0c1), className)
        })));
    };
    Component.displayName = 'CompoundIcon';
    return Component;
};


"use client";
const $82e7c60f6344ef74$export$d8cd72cbeb98615a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom16Filled', "16", [
    "M1.5 14a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1zm.5-3.75c0 .97.78 1.75 1.75 1.75h1.5C6.22 12 7 11.22 7 10.25v-6.5C7 2.78 6.22 2 5.25 2h-1.5C2.78 2 2 2.78 2 3.75zm7 0c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-4.5C14 4.78 13.22 4 12.25 4h-1.5C9.78 4 9 4.78 9 5.75z"
]);
const $82e7c60f6344ef74$export$3306a96ff9b61e23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom16Regular', "16", [
    "M1.5 14a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1zm.5-3.75c0 .97.78 1.75 1.75 1.75h1.5C6.22 12 7 11.22 7 10.25v-6.5C7 2.78 6.22 2 5.25 2h-1.5C2.78 2 2 2.78 2 3.75zm1.75.75a.75.75 0 0 1-.75-.75v-6.5c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75v6.5c0 .41-.34.75-.75.75zM9 10.25c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-4.5C14 4.78 13.22 4 12.25 4h-1.5C9.78 4 9 4.78 9 5.75zm1.75.75a.75.75 0 0 1-.75-.75v-4.5c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75v4.5c0 .41-.34.75-.75.75z"
]);
const $82e7c60f6344ef74$export$c767ac4226259ede = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom20Filled', "20", [
    "M2.5 17a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1zM4 13c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2zm7 0c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2z"
]);
const $82e7c60f6344ef74$export$2feb1d4042e9d53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom20Regular', "20", [
    "M2 16.5c0 .28.22.5.5.5h15a.5.5 0 0 0 0-1h-15a.5.5 0 0 0-.5.5m9-3.5c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2zm2 1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zm-7 1a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1z"
]);
const $82e7c60f6344ef74$export$21f399a918a63c8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom24Filled', "24", [
    "M2.75 21a.75.75 0 0 1 0-1.5h18.5a.75.75 0 0 1 0 1.5zM4 15.75C4 16.99 5 18 6.25 18h2.5C9.99 18 11 17 11 15.75V5.25C11 4.01 10 3 8.75 3h-2.5C5.01 3 4 4 4 5.25zm9 0c0 1.24 1 2.25 2.25 2.25h2.5c1.24 0 2.25-1 2.25-2.25v-7c0-1.24-1-2.25-2.25-2.25h-2.5c-1.24 0-2.25 1-2.25 2.25z"
]);
const $82e7c60f6344ef74$export$4c378f8f9bc15cd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom24Regular', "24", [
    "M2.75 21a.75.75 0 0 1 0-1.5h18.5a.75.75 0 0 1 0 1.5zM4 15.75C4 16.99 5 18 6.25 18h2.5C9.99 18 11 17 11 15.75V5.25C11 4.01 10 3 8.75 3h-2.5C5.01 3 4 4 4 5.25zm2.25.75a.75.75 0 0 1-.75-.75V5.25c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75v10.5c0 .41-.34.75-.75.75zm6.75-.75c0 1.24 1 2.25 2.25 2.25h2.5c1.24 0 2.25-1 2.25-2.25v-7c0-1.24-1-2.25-2.25-2.25h-2.5c-1.24 0-2.25 1-2.25 2.25zm2.25.75a.75.75 0 0 1-.75-.75v-7c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75v7c0 .41-.34.75-.75.75z"
]);
const $82e7c60f6344ef74$export$8bd5bf288945668d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom28Filled', "28", [
    "M2.75 25a.75.75 0 0 1 0-1.5h22.5a.75.75 0 0 1 0 1.5zM5 19.25A2.75 2.75 0 0 0 7.75 22h2.5A2.75 2.75 0 0 0 13 19.25V5.75A2.75 2.75 0 0 0 10.25 3h-2.5A2.75 2.75 0 0 0 5 5.75zm10 0A2.75 2.75 0 0 0 17.75 22h2.5A2.75 2.75 0 0 0 23 19.25v-8a2.75 2.75 0 0 0-2.75-2.75h-2.5A2.75 2.75 0 0 0 15 11.25z"
]);
const $82e7c60f6344ef74$export$10be44a78483613f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom28Regular', "28", [
    "M2.75 25a.75.75 0 0 1 0-1.5h22.5a.75.75 0 0 1 0 1.5zM5 19.25A2.75 2.75 0 0 0 7.75 22h2.5A2.75 2.75 0 0 0 13 19.25V5.75A2.75 2.75 0 0 0 10.25 3h-2.5A2.75 2.75 0 0 0 5 5.75zm2.75 1.25c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v13.5c0 .69-.56 1.25-1.25 1.25zM15 19.25A2.75 2.75 0 0 0 17.75 22h2.5A2.75 2.75 0 0 0 23 19.25v-8a2.75 2.75 0 0 0-2.75-2.75h-2.5A2.75 2.75 0 0 0 15 11.25zm2.75 1.25c-.69 0-1.25-.56-1.25-1.25v-8c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25z"
]);
const $82e7c60f6344ef74$export$c3062637826be9cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom32Filled', "32", [
    "M4 29a1 1 0 1 1 0-2h24a1 1 0 1 1 0 2zm1-7.5A3.5 3.5 0 0 0 8.5 25h3a3.5 3.5 0 0 0 3.5-3.5v-15A3.5 3.5 0 0 0 11.5 3h-3A3.5 3.5 0 0 0 5 6.5zm12 0a3.5 3.5 0 0 0 3.5 3.5h3a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 23.5 9h-3a3.5 3.5 0 0 0-3.5 3.5z"
]);
const $82e7c60f6344ef74$export$c32cdfa844c63131 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom32Regular', "32", [
    "M4 29a1 1 0 1 1 0-2h24a1 1 0 1 1 0 2zm1-7.5A3.5 3.5 0 0 0 8.5 25h3a3.5 3.5 0 0 0 3.5-3.5v-15A3.5 3.5 0 0 0 11.5 3h-3A3.5 3.5 0 0 0 5 6.5zM8.5 23A1.5 1.5 0 0 1 7 21.5v-15C7 5.67 7.67 5 8.5 5h3c.83 0 1.5.67 1.5 1.5v15c0 .83-.67 1.5-1.5 1.5zm8.5-1.5a3.5 3.5 0 0 0 3.5 3.5h3a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 23.5 9h-3a3.5 3.5 0 0 0-3.5 3.5zm3.5 1.5a1.5 1.5 0 0 1-1.5-1.5v-9c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5z"
]);
const $82e7c60f6344ef74$export$8e4584011bbc27af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom48Filled', "48", [
    "M5.25 41.5a1.25 1.25 0 1 1 0-2.5h37.5a1.25 1.25 0 1 1 0 2.5zM26 32.25c0 2.35 1.9 4.25 4.25 4.25h5.5c2.35 0 4.25-1.9 4.25-4.25v-15C40 14.9 38.1 13 35.75 13h-5.5A4.25 4.25 0 0 0 26 17.25zM12.25 36.5h5.5c2.35 0 4.25-1.9 4.25-4.25V10c0-2.35-1.9-4.25-4.25-4.25h-5.5A4.25 4.25 0 0 0 8 10v22.25c0 2.35 1.9 4.25 4.25 4.25"
]);
const $82e7c60f6344ef74$export$3302fa7554a5c2c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignBottom48Regular', "48", [
    "M5.25 41.5a1.25 1.25 0 1 1 0-2.5h37.5a1.25 1.25 0 1 1 0 2.5zM26 32.25c0 2.35 1.9 4.25 4.25 4.25h5.5c2.35 0 4.25-1.9 4.25-4.25v-15C40 14.9 38.1 13 35.75 13h-5.5A4.25 4.25 0 0 0 26 17.25zM30.25 34c-.97 0-1.75-.78-1.75-1.75v-15c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v15c0 .97-.78 1.75-1.75 1.75zm-18 2.5h5.5c2.35 0 4.25-1.9 4.25-4.25V10c0-2.35-1.9-4.25-4.25-4.25h-5.5A4.25 4.25 0 0 0 8 10v22.25c0 2.35 1.9 4.25 4.25 4.25m5.5-2.5h-5.5c-.97 0-1.75-.78-1.75-1.75V10c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v22.25c0 .97-.78 1.75-1.75 1.75"
]);
const $82e7c60f6344ef74$export$51294b1bc7089a81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal16Filled', "16", [
    "M15 7.5a.5.5 0 0 1-.5.5H14v1.25c0 .97-.78 1.75-1.75 1.75h-1.5C9.78 11 9 10.22 9 9.25V8H7v2.25C7 11.22 6.22 12 5.25 12h-1.5C2.78 12 2 11.22 2 10.25V8h-.5a.5.5 0 0 1 0-1H2V4.75C2 3.78 2.78 3 3.75 3h1.5C6.22 3 7 3.78 7 4.75V7h2V5.75C9 4.78 9.78 4 10.75 4h1.5c.97 0 1.75.78 1.75 1.75V7h.5c.28 0 .5.22.5.5"
]);
const $82e7c60f6344ef74$export$ba866f72d587f19d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal16Regular', "16", [
    "M15 7.5a.5.5 0 0 1-.5.5H14v1.25c0 .97-.78 1.75-1.75 1.75h-1.5C9.78 11 9 10.22 9 9.25V8H7v2.25C7 11.22 6.22 12 5.25 12h-1.5C2.78 12 2 11.22 2 10.25V8h-.5a.5.5 0 0 1 0-1H2V4.75C2 3.78 2.78 3 3.75 3h1.5C6.22 3 7 3.78 7 4.75V7h2V5.75C9 4.78 9.78 4 10.75 4h1.5c.97 0 1.75.78 1.75 1.75V7h.5c.28 0 .5.22.5.5M3 10.25c0 .41.34.75.75.75h1.5c.41 0 .75-.34.75-.75v-5.5A.75.75 0 0 0 5.25 4h-1.5a.75.75 0 0 0-.75.75zm7-1c0 .41.34.75.75.75h1.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75z"
]);
const $82e7c60f6344ef74$export$a6ea6823e689ec57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal20Filled', "20", [
    "M18 9.5a.5.5 0 0 1-.5.5H16v2a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-2H9v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4H2.5a.5.5 0 0 1 0-1H4V5c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v4h2V7c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v2h1.5c.28 0 .5.22.5.5"
]);
const $82e7c60f6344ef74$export$892d9d1568cf7206 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal20Regular', "20", [
    "M18 9.5a.5.5 0 0 1-.5.5H16v2a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-2H9v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4H2.5a.5.5 0 0 1 0-1H4V5c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v4h2V7c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v2h1.5c.28 0 .5.22.5.5M5 14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1zm7-2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1z"
]);
const $82e7c60f6344ef74$export$5f96456cccef4fa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal24Filled', "24", [
    "M21.25 12.75a.75.75 0 0 0 0-1.5H20v-2.5c0-1.24-1-2.25-2.25-2.25h-2.5c-1.24 0-2.25 1-2.25 2.25v2.5h-2v-4.5c0-1.24-1-2.25-2.25-2.25h-2.5C5.01 4.5 4 5.5 4 6.75v4.5H2.75a.75.75 0 0 0 0 1.5H4v4.5c0 1.24 1 2.25 2.25 2.25h2.5c1.24 0 2.25-1 2.25-2.25v-4.5h2v2.5c0 1.24 1 2.25 2.25 2.25h2.5c1.24 0 2.25-1 2.25-2.25v-2.5z"
]);
const $82e7c60f6344ef74$export$8ae10471e4700271 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal24Regular', "24", [
    "M21.25 12.75a.75.75 0 0 0 0-1.5H20v-2.5c0-1.24-1-2.25-2.25-2.25h-2.5c-1.24 0-2.25 1-2.25 2.25v2.5h-2v-4.5c0-1.24-1-2.25-2.25-2.25h-2.5C5.01 4.5 4 5.5 4 6.75v4.5H2.75a.75.75 0 0 0 0 1.5H4v4.5c0 1.24 1 2.25 2.25 2.25h2.5c1.24 0 2.25-1 2.25-2.25v-4.5h2v2.5c0 1.24 1 2.25 2.25 2.25h2.5c1.24 0 2.25-1 2.25-2.25v-2.5zm-2.75-4v6.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1-.75-.75v-6.5c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75m-9-2v10.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1-.75-.75V6.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75"
]);
const $82e7c60f6344ef74$export$a883b01adede0807 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal28Filled', "28", [
    "M26 13.75c0 .41-.34.75-.75.75H23V18a2.75 2.75 0 0 1-2.75 2.75h-2.5A2.75 2.75 0 0 1 15 18v-3.5h-2v6.25a2.75 2.75 0 0 1-2.75 2.75h-2.5A2.75 2.75 0 0 1 5 20.75V14.5H2.75a.75.75 0 0 1 0-1.5H5V7.25A2.75 2.75 0 0 1 7.75 4.5h2.5A2.75 2.75 0 0 1 13 7.25V13h2v-3a2.75 2.75 0 0 1 2.75-2.75h2.5A2.75 2.75 0 0 1 23 10v3h2.25c.41 0 .75.34.75.75"
]);
const $82e7c60f6344ef74$export$8d822cb7aeed4d1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal28Regular', "28", [
    "M26 13.75c0 .41-.34.75-.75.75H23V18a2.75 2.75 0 0 1-2.75 2.75h-2.5A2.75 2.75 0 0 1 15 18v-3.5h-2v6.25a2.75 2.75 0 0 1-2.75 2.75h-2.5A2.75 2.75 0 0 1 5 20.75V14.5H2.75a.75.75 0 0 1 0-1.5H5V7.25A2.75 2.75 0 0 1 7.75 4.5h2.5A2.75 2.75 0 0 1 13 7.25V13h2v-3a2.75 2.75 0 0 1 2.75-2.75h2.5A2.75 2.75 0 0 1 23 10v3h2.25c.41 0 .75.34.75.75M21.5 10c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25zM10.25 6h-2.5c-.69 0-1.25.56-1.25 1.25v13.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V7.25c0-.69-.56-1.25-1.25-1.25"
]);
const $82e7c60f6344ef74$export$67fa78be1a40dcb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal32Filled', "32", [
    "M30 16a1 1 0 0 1-1 1h-2v3.5a3.5 3.5 0 0 1-3.5 3.5h-3a3.5 3.5 0 0 1-3.5-3.5V17h-2v6.5a3.5 3.5 0 0 1-3.5 3.5h-3A3.5 3.5 0 0 1 5 23.5V17H3a1 1 0 1 1 0-2h2V8.5A3.5 3.5 0 0 1 8.5 5h3A3.5 3.5 0 0 1 15 8.5V15h2v-3.5A3.5 3.5 0 0 1 20.5 8h3a3.5 3.5 0 0 1 3.5 3.5V15h2a1 1 0 0 1 1 1"
]);
const $82e7c60f6344ef74$export$a6ec6a1891a03733 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal32Regular', "32", [
    "M30 16a1 1 0 0 1-1 1h-2v3.5a3.5 3.5 0 0 1-3.5 3.5h-3a3.5 3.5 0 0 1-3.5-3.5V17h-2v6.5a3.5 3.5 0 0 1-3.5 3.5h-3A3.5 3.5 0 0 1 5 23.5V17H3a1 1 0 1 1 0-2h2V8.5A3.5 3.5 0 0 1 8.5 5h3A3.5 3.5 0 0 1 15 8.5V15h2v-3.5A3.5 3.5 0 0 1 20.5 8h3a3.5 3.5 0 0 1 3.5 3.5V15h2a1 1 0 0 1 1 1m-5-4.5c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5zM11.5 7h-3C7.67 7 7 7.67 7 8.5v15c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5"
]);
const $82e7c60f6344ef74$export$9abde8b9650b3abf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal48Filled', "48", [
    "M44 24.25c0 .69-.56 1.25-1.25 1.25H40v6.25C40 34.1 38.1 36 35.75 36h-5.5A4.25 4.25 0 0 1 26 31.75V25.5h-4v10.25C22 38.1 20.1 40 17.75 40h-5.5A4.25 4.25 0 0 1 8 35.75V25.5H5.25a1.25 1.25 0 1 1 0-2.5H8V12.25C8 9.9 9.9 8 12.25 8h5.5C20.1 8 22 9.9 22 12.25V23h4v-6.75C26 13.9 27.9 12 30.25 12h5.5C38.1 12 40 13.9 40 16.25V23h2.75c.69 0 1.25.56 1.25 1.25"
]);
const $82e7c60f6344ef74$export$8dc70cac290d8aa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterHorizontal48Regular', "48", [
    "M44 24.25c0 .69-.56 1.25-1.25 1.25H40v6.25C40 34.1 38.1 36 35.75 36h-5.5A4.25 4.25 0 0 1 26 31.75V25.5h-4v10.25C22 38.1 20.1 40 17.75 40h-5.5A4.25 4.25 0 0 1 8 35.75V25.5H5.25a1.25 1.25 0 1 1 0-2.5H8V12.25C8 9.9 9.9 8 12.25 8h5.5C20.1 8 22 9.9 22 12.25V23h4v-6.75C26 13.9 27.9 12 30.25 12h5.5C38.1 12 40 13.9 40 16.25V23h2.75c.69 0 1.25.56 1.25 1.25m-6.5-8c0-.97-.78-1.75-1.75-1.75h-5.5c-.97 0-1.75.78-1.75 1.75v15.5c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75zM17.75 10.5h-5.5c-.97 0-1.75.78-1.75 1.75v23.5c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75v-23.5c0-.97-.78-1.75-1.75-1.75"
]);
const $82e7c60f6344ef74$export$399137708e0801d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical16Filled', "16", [
    "M8.5 15a.5.5 0 0 1-.5-.5V14H6.75C5.78 14 5 13.22 5 12.25v-1.5C5 9.78 5.78 9 6.75 9H8V7H5.75C4.78 7 4 6.22 4 5.25v-1.5C4 2.78 4.78 2 5.75 2H8v-.5a.5.5 0 0 1 1 0V2h2.25c.97 0 1.75.78 1.75 1.75v1.5C13 6.22 12.22 7 11.25 7H9v2h1.25c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75H9v.5a.5.5 0 0 1-.5.5"
]);
const $82e7c60f6344ef74$export$e4a7f2507a1072c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical16Regular', "16", [
    "M8.5 15a.5.5 0 0 1-.5-.5V14H6.75C5.78 14 5 13.22 5 12.25v-1.5C5 9.78 5.78 9 6.75 9H8V7H5.75C4.78 7 4 6.22 4 5.25v-1.5C4 2.78 4.78 2 5.75 2H8v-.5a.5.5 0 0 1 1 0V2h2.25c.97 0 1.75.78 1.75 1.75v1.5C13 6.22 12.22 7 11.25 7H9v2h1.25c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75H9v.5a.5.5 0 0 1-.5.5M5.75 3a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75zm1 7a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$9acb437de44d5c2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical20Filled', "20", [
    "M10.5 18a.5.5 0 0 1-.5-.5V16H8a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2h2V9H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4V2.5a.5.5 0 0 1 1 0V4h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4v2h2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-2v1.5a.5.5 0 0 1-.5.5"
]);
const $82e7c60f6344ef74$export$b70b62bf6f75f843 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical20Regular', "20", [
    "M10.5 18a.5.5 0 0 1-.5-.5V16H8a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2h2V9H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4V2.5a.5.5 0 0 1 1 0V4h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4v2h2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-2v1.5a.5.5 0 0 1-.5.5M6 5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm2 7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$7a0af17dcee06e6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical24Filled', "24", [
    "M11.25 21.25a.75.75 0 0 0 1.5 0V20h2.5c1.24 0 2.25-1 2.25-2.25v-2.5c0-1.24-1-2.25-2.25-2.25h-2.5v-2h4.5c1.24 0 2.25-1 2.25-2.25v-2.5c0-1.24-1-2.25-2.25-2.25h-4.5V2.75a.75.75 0 0 0-1.5 0V4h-4.5C5.51 4 4.5 5 4.5 6.25v2.5c0 1.24 1 2.25 2.25 2.25h4.5v2h-2.5c-1.24 0-2.25 1-2.25 2.25v2.5c0 1.24 1 2.25 2.25 2.25h2.5z"
]);
const $82e7c60f6344ef74$export$db3cc809ba0adbb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical24Regular', "24", [
    "M11.25 21.25V20h-2.5c-1.24 0-2.25-1-2.25-2.25v-2.5c0-1.24 1-2.25 2.25-2.25h2.5v-2h-4.5C5.51 11 4.5 10 4.5 8.75v-2.5C4.5 5.01 5.5 4 6.75 4h4.5V2.75a.75.75 0 0 1 1.5 0V4h4.5c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25h-4.5v2h2.5c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25h-2.5v1.25a.75.75 0 0 1-1.5 0m4-2.75c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75zm2-9c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75z"
]);
const $82e7c60f6344ef74$export$df813ca19930978a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical28Filled', "28", [
    "M14.25 26a.75.75 0 0 1-.75-.75V23H10a2.75 2.75 0 0 1-2.75-2.75v-2.5A2.75 2.75 0 0 1 10 15h3.5v-2H7.25a2.75 2.75 0 0 1-2.75-2.75v-2.5A2.75 2.75 0 0 1 7.25 5h6.25V2.75a.75.75 0 0 1 1.5 0V5h5.75a2.75 2.75 0 0 1 2.75 2.75v2.5A2.75 2.75 0 0 1 20.75 13H15v2h3a2.75 2.75 0 0 1 2.75 2.75v2.5A2.75 2.75 0 0 1 18 23h-3v2.25c0 .41-.34.75-.75.75"
]);
const $82e7c60f6344ef74$export$42bc5bbfbbd8a5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical28Regular', "28", [
    "M14.25 26a.75.75 0 0 1-.75-.75V23H10a2.75 2.75 0 0 1-2.75-2.75v-2.5A2.75 2.75 0 0 1 10 15h3.5v-2H7.25a2.75 2.75 0 0 1-2.75-2.75v-2.5A2.75 2.75 0 0 1 7.25 5h6.25V2.75a.75.75 0 0 1 1.5 0V5h5.75a2.75 2.75 0 0 1 2.75 2.75v2.5A2.75 2.75 0 0 1 20.75 13H15v2h3a2.75 2.75 0 0 1 2.75 2.75v2.5A2.75 2.75 0 0 1 18 23h-3v2.25c0 .41-.34.75-.75.75M18 21.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-8c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25zm4-11.25v-2.5c0-.69-.56-1.25-1.25-1.25H7.25C6.56 6.5 6 7.06 6 7.75v2.5c0 .69.56 1.25 1.25 1.25h13.5c.69 0 1.25-.56 1.25-1.25"
]);
const $82e7c60f6344ef74$export$59b7ab4f2200f445 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical32Filled', "32", [
    "M16 30a1 1 0 0 1-1-1v-2h-3.5A3.5 3.5 0 0 1 8 23.5v-3a3.5 3.5 0 0 1 3.5-3.5H15v-2H8.5A3.5 3.5 0 0 1 5 11.5v-3A3.5 3.5 0 0 1 8.5 5H15V3a1 1 0 1 1 2 0v2h6.5A3.5 3.5 0 0 1 27 8.5v3a3.5 3.5 0 0 1-3.5 3.5H17v2h3.5a3.5 3.5 0 0 1 3.5 3.5v3a3.5 3.5 0 0 1-3.5 3.5H17v2a1 1 0 0 1-1 1"
]);
const $82e7c60f6344ef74$export$cdded72025699209 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical32Regular', "32", [
    "M16 30a1 1 0 0 1-1-1v-2h-3.5A3.5 3.5 0 0 1 8 23.5v-3a3.5 3.5 0 0 1 3.5-3.5H15v-2H8.5A3.5 3.5 0 0 1 5 11.5v-3A3.5 3.5 0 0 1 8.5 5H15V3a1 1 0 1 1 2 0v2h6.5A3.5 3.5 0 0 1 27 8.5v3a3.5 3.5 0 0 1-3.5 3.5H17v2h3.5a3.5 3.5 0 0 1 3.5 3.5v3a3.5 3.5 0 0 1-3.5 3.5H17v2a1 1 0 0 1-1 1m4.5-5c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5zM25 11.5v-3c0-.83-.67-1.5-1.5-1.5h-15C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5"
]);
const $82e7c60f6344ef74$export$6e6789177f493a53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical48Filled', "48", [
    "M23.75 44c-.69 0-1.25-.56-1.25-1.25V40h-6.25A4.25 4.25 0 0 1 12 35.75v-5.5C12 27.9 13.9 26 16.25 26h6.25v-4H12.25A4.25 4.25 0 0 1 8 17.75v-5.5C8 9.9 9.9 8 12.25 8H22.5V5.25a1.25 1.25 0 1 1 2.5 0V8h10.75C38.1 8 40 9.9 40 12.25v5.5C40 20.1 38.1 22 35.75 22H25v4h6.75C34.1 26 36 27.9 36 30.25v5.5C36 38.1 34.1 40 31.75 40H25v2.75c0 .69-.56 1.25-1.25 1.25"
]);
const $82e7c60f6344ef74$export$617ca23229f13912 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignCenterVertical48Regular', "48", [
    "M23.75 44c-.69 0-1.25-.56-1.25-1.25V40h-6.25A4.25 4.25 0 0 1 12 35.75v-5.5C12 27.9 13.9 26 16.25 26h6.25v-4H12.25A4.25 4.25 0 0 1 8 17.75v-5.5C8 9.9 9.9 8 12.25 8H22.5V5.25a1.25 1.25 0 1 1 2.5 0V8h10.75C38.1 8 40 9.9 40 12.25v5.5C40 20.1 38.1 22 35.75 22H25v4h6.75C34.1 26 36 27.9 36 30.25v5.5C36 38.1 34.1 40 31.75 40H25v2.75c0 .69-.56 1.25-1.25 1.25m8-6.5c.97 0 1.75-.78 1.75-1.75v-5.5c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75zm5.75-19.75v-5.5c0-.97-.78-1.75-1.75-1.75h-23.5c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h23.5c.97 0 1.75-.78 1.75-1.75"
]);
const $82e7c60f6344ef74$export$6dab5b1a444d235 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeBottom16Filled', "16", [
    "M14.5 15a.5.5 0 0 0 0-1h-13a.5.5 0 0 0 0 1zm0-7a.5.5 0 0 0 0-1h-13a.5.5 0 0 0 0 1zM3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 4.5zM6.5 9C5.67 9 5 9.67 5 10.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5z"
]);
const $82e7c60f6344ef74$export$8e9e67a880ee7385 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeBottom16Regular', "16", [
    "M14.5 15a.5.5 0 0 0 0-1h-13a.5.5 0 0 0 0 1zm0-7a.5.5 0 0 0 0-1h-13a.5.5 0 0 0 0 1zM3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 4.5zM4.5 3a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2 6C5.67 9 5 9.67 5 10.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5zM6 10.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
]);
const $82e7c60f6344ef74$export$de90eda6d9a8be85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeLeft16Filled', "16", [
    "M1 14.5a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-1 0zm7 0a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-1 0zM4.5 13A1.5 1.5 0 0 1 3 11.5v-7C3 3.67 3.67 3 4.5 3h1C6.33 3 7 3.67 7 4.5v7c0 .83-.67 1.5-1.5 1.5zM10 9.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5z"
]);
const $82e7c60f6344ef74$export$a7538a33d47e1c15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeLeft16Regular', "16", [
    "M1 14.5a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-1 0zm7 0a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-1 0zM4.5 13A1.5 1.5 0 0 1 3 11.5v-7C3 3.67 3.67 3 4.5 3h1C6.33 3 7 3.67 7 4.5v7c0 .83-.67 1.5-1.5 1.5zM4 11.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm6-2c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5zm1.5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5z"
]);
const $82e7c60f6344ef74$export$67e0ce8799860a82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeRight16Filled', "16", [
    "M15 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm-7 0a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zM3.5 13A1.5 1.5 0 0 1 2 11.5v-7C2 3.67 2.67 3 3.5 3h1C5.33 3 6 3.67 6 4.5v7c0 .83-.67 1.5-1.5 1.5zM9 9.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1C9.67 5 9 5.67 9 6.5z"
]);
const $82e7c60f6344ef74$export$87eb7d933a3c0f8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeRight16Regular', "16", [
    "M15 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm-7 0a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zM3.5 13A1.5 1.5 0 0 1 2 11.5v-7C2 3.67 2.67 3 3.5 3h1C5.33 3 6 3.67 6 4.5v7c0 .83-.67 1.5-1.5 1.5zM3 11.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm6-2c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1C9.67 5 9 5.67 9 6.5zm1.5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5z"
]);
const $82e7c60f6344ef74$export$c56b55eb5d3217f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeTop16Filled', "16", [
    "M1.5 1a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 7a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm8 6c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5zm2-7c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v1C3 6.33 3.67 7 4.5 7z"
]);
const $82e7c60f6344ef74$export$6153b7ac5ea029e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignDistributeTop16Regular', "16", [
    "M1.5 1a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0 7a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm8 6c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5zm.5-1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5zM11.5 7c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v1C3 6.33 3.67 7 4.5 7zm.5-1.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5z"
]);
const $82e7c60f6344ef74$export$e4f80e460bc4bf03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignEndHorizontal20Filled', "20", [
    "M16 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M10 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$88cdba6d4f3fff6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignEndHorizontal20Regular', "20", [
    "M16.5 18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5",
    "M10 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM9 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$7c307cf1055b698e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignEndVertical20Filled', "20", [
    "M4 10c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
    "M2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $82e7c60f6344ef74$export$8248b481b3ee704b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignEndVertical20Regular', "20", [
    "M6 8a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z",
    "M2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $82e7c60f6344ef74$export$2bfe34c5eaca0c29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft16Filled', "16", [
    "M2 1.5a.5.5 0 0 1 1 0v13a.5.5 0 0 1-1 0zm3.75.5C4.78 2 4 2.78 4 3.75v1.5C4 6.22 4.78 7 5.75 7h6.5C13.22 7 14 6.22 14 5.25v-1.5C14 2.78 13.22 2 12.25 2zm0 7C4.78 9 4 9.78 4 10.75v1.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-1.5C12 9.78 11.22 9 10.25 9z"
]);
const $82e7c60f6344ef74$export$26602d4584fd62f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft16Regular', "16", [
    "M2 1.5a.5.5 0 0 1 1 0v13a.5.5 0 0 1-1 0zm3.75.5C4.78 2 4 2.78 4 3.75v1.5C4 6.22 4.78 7 5.75 7h6.5C13.22 7 14 6.22 14 5.25v-1.5C14 2.78 13.22 2 12.25 2zM5 3.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v1.5c0 .41-.34.75-.75.75h-6.5A.75.75 0 0 1 5 5.25zM5.75 9C4.78 9 4 9.78 4 10.75v1.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-1.5C12 9.78 11.22 9 10.25 9zM5 10.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v1.5c0 .41-.34.75-.75.75h-4.5a.75.75 0 0 1-.75-.75z"
]);
const $82e7c60f6344ef74$export$5a272690995b6b4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft20Filled', "20", [
    "M3.5 2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-.5-.5M7 11a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2zM5 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
]);
const $82e7c60f6344ef74$export$440c45431faecad9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft20Regular', "20", [
    "M3.5 2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-.5-.5M7 11a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM5 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$246038dc02d0d525 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft24Filled', "24", [
    "M3 2.75a.75.75 0 0 1 1.5 0v18.5a.75.75 0 0 1-1.5 0zM8.25 4C7.01 4 6 5 6 6.25v2.5C6 9.99 7 11 8.25 11h10.5C19.99 11 21 10 21 8.75v-2.5C21 5.01 20 4 18.75 4zm0 9C7.01 13 6 14 6 15.25v2.5C6 18.99 7 20 8.25 20h7c1.24 0 2.25-1 2.25-2.25v-2.5c0-1.24-1-2.25-2.25-2.25z"
]);
const $82e7c60f6344ef74$export$67747226f3c3e007 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft24Regular', "24", [
    "M3 2.75a.75.75 0 0 1 1.5 0v18.5a.75.75 0 0 1-1.5 0zM8.25 4C7.01 4 6 5 6 6.25v2.5C6 9.99 7 11 8.25 11h10.5C19.99 11 21 10 21 8.75v-2.5C21 5.01 20 4 18.75 4zM7.5 6.25c0-.41.34-.75.75-.75h10.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75H8.25a.75.75 0 0 1-.75-.75zM8.25 13C7.01 13 6 14 6 15.25v2.5C6 18.99 7 20 8.25 20h7c1.24 0 2.25-1 2.25-2.25v-2.5c0-1.24-1-2.25-2.25-2.25zm-.75 2.25c0-.41.34-.75.75-.75h7c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7a.75.75 0 0 1-.75-.75z"
]);
const $82e7c60f6344ef74$export$9ff4f883b560d5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft28Filled', "28", [
    "M3 2.75a.75.75 0 0 1 1.5 0v22.5a.75.75 0 0 1-1.5 0zM8.75 5A2.75 2.75 0 0 0 6 7.75v2.5A2.75 2.75 0 0 0 8.75 13h13.5A2.75 2.75 0 0 0 25 10.25v-2.5A2.75 2.75 0 0 0 22.25 5zm0 10A2.75 2.75 0 0 0 6 17.75v2.5A2.75 2.75 0 0 0 8.75 23h8a2.75 2.75 0 0 0 2.75-2.75v-2.5A2.75 2.75 0 0 0 16.75 15z"
]);
const $82e7c60f6344ef74$export$da8af68b45848dc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft28Regular', "28", [
    "M3 2.75a.75.75 0 0 1 1.5 0v22.5a.75.75 0 0 1-1.5 0zM8.75 5A2.75 2.75 0 0 0 6 7.75v2.5A2.75 2.75 0 0 0 8.75 13h13.5A2.75 2.75 0 0 0 25 10.25v-2.5A2.75 2.75 0 0 0 22.25 5zM7.5 7.75c0-.69.56-1.25 1.25-1.25h13.5c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25H8.75c-.69 0-1.25-.56-1.25-1.25zM8.75 15A2.75 2.75 0 0 0 6 17.75v2.5A2.75 2.75 0 0 0 8.75 23h8a2.75 2.75 0 0 0 2.75-2.75v-2.5A2.75 2.75 0 0 0 16.75 15zM7.5 17.75c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-8c-.69 0-1.25-.56-1.25-1.25z"
]);
const $82e7c60f6344ef74$export$c67f968def492d5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft32Filled', "32", [
    "M3 4a1 1 0 0 1 2 0v24a1 1 0 1 1-2 0zm7.5 1A3.5 3.5 0 0 0 7 8.5v3a3.5 3.5 0 0 0 3.5 3.5h15a3.5 3.5 0 0 0 3.5-3.5v-3A3.5 3.5 0 0 0 25.5 5zm0 12A3.5 3.5 0 0 0 7 20.5v3a3.5 3.5 0 0 0 3.5 3.5h9a3.5 3.5 0 0 0 3.5-3.5v-3a3.5 3.5 0 0 0-3.5-3.5z"
]);
const $82e7c60f6344ef74$export$b0419b3722bc02bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft32Regular', "32", [
    "M3 4a1 1 0 0 1 2 0v24a1 1 0 1 1-2 0zm7.5 1A3.5 3.5 0 0 0 7 8.5v3a3.5 3.5 0 0 0 3.5 3.5h15a3.5 3.5 0 0 0 3.5-3.5v-3A3.5 3.5 0 0 0 25.5 5zM9 8.5c0-.83.67-1.5 1.5-1.5h15c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-15A1.5 1.5 0 0 1 9 11.5zm1.5 8.5A3.5 3.5 0 0 0 7 20.5v3a3.5 3.5 0 0 0 3.5 3.5h9a3.5 3.5 0 0 0 3.5-3.5v-3a3.5 3.5 0 0 0-3.5-3.5zM9 20.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 9 23.5z"
]);
const $82e7c60f6344ef74$export$35f1169593b4ccff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft48Filled', "48", [
    "M6.5 5.25a1.25 1.25 0 1 1 2.5 0v37.5a1.25 1.25 0 1 1-2.5 0zM15.75 26a4.25 4.25 0 0 0-4.25 4.25v5.5c0 2.35 1.9 4.25 4.25 4.25h15C33.1 40 35 38.1 35 35.75v-5.5C35 27.9 33.1 26 30.75 26zM11.5 12.25v5.5c0 2.35 1.9 4.25 4.25 4.25H38c2.35 0 4.25-1.9 4.25-4.25v-5.5C42.25 9.9 40.35 8 38 8H15.75a4.25 4.25 0 0 0-4.25 4.25"
]);
const $82e7c60f6344ef74$export$13533abe32979f67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignLeft48Regular', "48", [
    "M6.5 5.25a1.25 1.25 0 1 1 2.5 0v37.5a1.25 1.25 0 1 1-2.5 0zM15.75 26a4.25 4.25 0 0 0-4.25 4.25v5.5c0 2.35 1.9 4.25 4.25 4.25h15C33.1 40 35 38.1 35 35.75v-5.5C35 27.9 33.1 26 30.75 26zM14 30.25c0-.97.78-1.75 1.75-1.75h15c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75h-15c-.97 0-1.75-.78-1.75-1.75zm-2.5-18v5.5c0 2.35 1.9 4.25 4.25 4.25H38c2.35 0 4.25-1.9 4.25-4.25v-5.5C42.25 9.9 40.35 8 38 8H15.75a4.25 4.25 0 0 0-4.25 4.25m2.5 5.5v-5.5c0-.97.78-1.75 1.75-1.75H38c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75H15.75c-.97 0-1.75-.78-1.75-1.75"
]);
const $82e7c60f6344ef74$export$244d1b027814596f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight16Filled', "16", [
    "M14 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm-3.75.5c.97 0 1.75.78 1.75 1.75v1.5C12 6.22 11.22 7 10.25 7h-6.5C2.78 7 2 6.22 2 5.25v-1.5C2 2.78 2.78 2 3.75 2zm0 7c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 14 4 13.22 4 12.25v-1.5C4 9.78 4.78 9 5.75 9z"
]);
const $82e7c60f6344ef74$export$d13390915361f015 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight16Regular', "16", [
    "M14 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm-3.75.5c.97 0 1.75.78 1.75 1.75v1.5C12 6.22 11.22 7 10.25 7h-6.5C2.78 7 2 6.22 2 5.25v-1.5C2 2.78 2.78 2 3.75 2zM11 3.75a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75zM10.25 9c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 14 4 13.22 4 12.25v-1.5C4 9.78 4.78 9 5.75 9zm.75 1.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75z"
]);
const $82e7c60f6344ef74$export$6ea21438b201e76e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight20Filled', "20", [
    "M16.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M13 11a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2zm2-5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2z"
]);
const $82e7c60f6344ef74$export$4e3c738ac2961e20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight20Regular', "20", [
    "M16.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5M13 11a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2zm1 2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zm1-7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2zm-2-1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $82e7c60f6344ef74$export$7bdee7179d42f3dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight24Filled', "24", [
    "M21 2.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0zM15.75 4C16.99 4 18 5 18 6.25v2.5C18 9.99 17 11 15.75 11H5.25C4.01 11 3 10 3 8.75v-2.5C3 5.01 4 4 5.25 4zm0 9c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25h-7c-1.24 0-2.25-1-2.25-2.25v-2.5c0-1.24 1-2.25 2.25-2.25z"
]);
const $82e7c60f6344ef74$export$b72b0bd81de2cb0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight24Regular', "24", [
    "M21 2.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0zM15.75 4C16.99 4 18 5 18 6.25v2.5C18 9.99 17 11 15.75 11H5.25C4.01 11 3 10 3 8.75v-2.5C3 5.01 4 4 5.25 4zm.75 2.25a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75zM15.75 13c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25h-7c-1.24 0-2.25-1-2.25-2.25v-2.5c0-1.24 1-2.25 2.25-2.25zm.75 2.25a.75.75 0 0 0-.75-.75h-7a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75h7c.41 0 .75-.34.75-.75z"
]);
const $82e7c60f6344ef74$export$df6652a602c13169 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight28Filled', "28", [
    "M25 2.75a.75.75 0 0 0-1.5 0v22.5a.75.75 0 0 0 1.5 0zM19.25 5A2.75 2.75 0 0 1 22 7.75v2.5A2.75 2.75 0 0 1 19.25 13H5.75A2.75 2.75 0 0 1 3 10.25v-2.5A2.75 2.75 0 0 1 5.75 5zm0 10A2.75 2.75 0 0 1 22 17.75v2.5A2.75 2.75 0 0 1 19.25 23h-8a2.75 2.75 0 0 1-2.75-2.75v-2.5A2.75 2.75 0 0 1 11.25 15z"
]);
const $82e7c60f6344ef74$export$95a208e02717cac0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight28Regular', "28", [
    "M25 2.75a.75.75 0 0 0-1.5 0v22.5a.75.75 0 0 0 1.5 0zM19.25 5A2.75 2.75 0 0 1 22 7.75v2.5A2.75 2.75 0 0 1 19.25 13H5.75A2.75 2.75 0 0 1 3 10.25v-2.5A2.75 2.75 0 0 1 5.75 5zm1.25 2.75c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h13.5c.69 0 1.25-.56 1.25-1.25zM19.25 15A2.75 2.75 0 0 1 22 17.75v2.5A2.75 2.75 0 0 1 19.25 23h-8a2.75 2.75 0 0 1-2.75-2.75v-2.5A2.75 2.75 0 0 1 11.25 15zm1.25 2.75c0-.69-.56-1.25-1.25-1.25h-8c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25z"
]);
const $82e7c60f6344ef74$export$3a8b2d1bb6c718aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight32Filled', "32", [
    "M29 4a1 1 0 1 0-2 0v24a1 1 0 1 0 2 0zm-7.5 1A3.5 3.5 0 0 1 25 8.5v3a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 3 11.5v-3A3.5 3.5 0 0 1 6.5 5zm0 12a3.5 3.5 0 0 1 3.5 3.5v3a3.5 3.5 0 0 1-3.5 3.5h-9A3.5 3.5 0 0 1 9 23.5v-3a3.5 3.5 0 0 1 3.5-3.5z"
]);
const $82e7c60f6344ef74$export$9b42f61c5e7334b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight32Regular', "32", [
    "M29 4a1 1 0 1 0-2 0v24a1 1 0 1 0 2 0zm-7.5 1A3.5 3.5 0 0 1 25 8.5v3a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 3 11.5v-3A3.5 3.5 0 0 1 6.5 5zM23 8.5c0-.83-.67-1.5-1.5-1.5h-15C5.67 7 5 7.67 5 8.5v3c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5zM21.5 17a3.5 3.5 0 0 1 3.5 3.5v3a3.5 3.5 0 0 1-3.5 3.5h-9A3.5 3.5 0 0 1 9 23.5v-3a3.5 3.5 0 0 1 3.5-3.5zm1.5 3.5c0-.83-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5z"
]);
const $82e7c60f6344ef74$export$321ecab6df399d51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight48Filled', "48", [
    "M41.5 5.25a1.25 1.25 0 1 0-2.5 0v37.5a1.25 1.25 0 1 0 2.5 0zM32.25 26c2.35 0 4.25 1.9 4.25 4.25v5.5c0 2.35-1.9 4.25-4.25 4.25h-15A4.25 4.25 0 0 1 13 35.75v-5.5C13 27.9 14.9 26 17.25 26zm4.25-13.75v5.5c0 2.35-1.9 4.25-4.25 4.25H10a4.25 4.25 0 0 1-4.25-4.25v-5.5C5.75 9.9 7.65 8 10 8h22.25c2.35 0 4.25 1.9 4.25 4.25"
]);
const $82e7c60f6344ef74$export$2b4cacfa00b3037d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignRight48Regular', "48", [
    "M41.5 5.25a1.25 1.25 0 1 0-2.5 0v37.5a1.25 1.25 0 1 0 2.5 0zM32.25 26c2.35 0 4.25 1.9 4.25 4.25v5.5c0 2.35-1.9 4.25-4.25 4.25h-15A4.25 4.25 0 0 1 13 35.75v-5.5C13 27.9 14.9 26 17.25 26zM34 30.25c0-.97-.78-1.75-1.75-1.75h-15c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h15c.97 0 1.75-.78 1.75-1.75zm2.5-18v5.5c0 2.35-1.9 4.25-4.25 4.25H10a4.25 4.25 0 0 1-4.25-4.25v-5.5C5.75 9.9 7.65 8 10 8h22.25c2.35 0 4.25 1.9 4.25 4.25m-2.5 5.5v-5.5c0-.97-.78-1.75-1.75-1.75H10c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h22.25c.97 0 1.75-.78 1.75-1.75"
]);
const $82e7c60f6344ef74$export$4988c41c6ff913d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceAroundHorizontal20Filled', "20", [
    "M6 4a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 7a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$a574755ab790598b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceAroundHorizontal20Regular', "20", [
    "M6 4a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM5 6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm1 5a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$83ef754d237bea94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceAroundVertical20Filled', "20", [
    "M7.5 16c.83 0 1.5-.67 1.5-1.5v-9C9 4.67 8.33 4 7.5 4h-2C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5zm7 0c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5z"
]);
const $82e7c60f6344ef74$export$78c4e5162035d646 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceAroundVertical20Regular', "20", [
    "M6 4h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2M5 6v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m8-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$5e903f4d3c260cf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceBetweenHorizontal20Filled', "20", [
    "M6 1a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm0 13a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$9897df015121f774 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceBetweenHorizontal20Regular', "20", [
    "M6 1a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM5 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm1 11a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$81f587b8dcebe106 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceBetweenVertical20Filled', "20", [
    "M3 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
    "M16 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$eae2529358cf08d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceBetweenVertical20Regular', "20", [
    "M3 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM2 6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z",
    "M16 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$8f04320acee3211c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyHorizontal20Filled', "20", [
    "M4 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2z",
    "M10 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2z",
    "M16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2z"
]);
const $82e7c60f6344ef74$export$c25fd2312030c2d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyHorizontal20Regular', "20", [
    "M3 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm7 2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1zm7 2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1z"
]);
const $82e7c60f6344ef74$export$7f276f9fbd75f50f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyHorizontal24Filled', "24", [
    "M2 17.5A2.5 2.5 0 0 0 4.5 20h1A2.5 2.5 0 0 0 8 17.5v-11A2.5 2.5 0 0 0 5.5 4h-1A2.5 2.5 0 0 0 2 6.5zm7 0a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 12.5 4h-1A2.5 2.5 0 0 0 9 6.5zm7 0a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 19.5 4h-1A2.5 2.5 0 0 0 16 6.5z"
]);
const $82e7c60f6344ef74$export$f08309696134480e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyHorizontal24Regular', "24", [
    "M3.5 17.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zm1 2.5A2.5 2.5 0 0 1 2 17.5v-11A2.5 2.5 0 0 1 4.5 4h1A2.5 2.5 0 0 1 8 6.5v11A2.5 2.5 0 0 1 5.5 20zm6-2.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zm1 2.5A2.5 2.5 0 0 1 9 17.5v-11A2.5 2.5 0 0 1 11.5 4h1A2.5 2.5 0 0 1 15 6.5v11a2.5 2.5 0 0 1-2.5 2.5zm7-1.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1zm-2.5-1a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 19.5 4h-1A2.5 2.5 0 0 0 16 6.5z"
]);
const $82e7c60f6344ef74$export$4eda60b45bc3c7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyVertical20Filled', "20", [
    "M6 1a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z",
    "M6 13a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z",
    "M6 7a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$4016b9158592219 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyVertical20Regular', "20", [
    "M4 3c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
    "M4 15c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z",
    "M6 7a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 9a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$a87e9402223f913c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyVertical24Filled', "24", [
    "M6.5 2A2.5 2.5 0 0 0 4 4.5v1A2.5 2.5 0 0 0 6.5 8h11A2.5 2.5 0 0 0 20 5.5v-1A2.5 2.5 0 0 0 17.5 2zm0 7A2.5 2.5 0 0 0 4 11.5v1A2.5 2.5 0 0 0 6.5 15h11a2.5 2.5 0 0 0 2.5-2.5v-1A2.5 2.5 0 0 0 17.5 9zm0 7A2.5 2.5 0 0 0 4 18.5v1A2.5 2.5 0 0 0 6.5 22h11a2.5 2.5 0 0 0 2.5-2.5v-1a2.5 2.5 0 0 0-2.5-2.5z"
]);
const $82e7c60f6344ef74$export$a1cfa186ce0c279f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceEvenlyVertical24Regular', "24", [
    "M6.5 3.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM4 4.5A2.5 2.5 0 0 1 6.5 2h11A2.5 2.5 0 0 1 20 4.5v1A2.5 2.5 0 0 1 17.5 8h-11A2.5 2.5 0 0 1 4 5.5zm2.5 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-2.5 1A2.5 2.5 0 0 1 6.5 9h11a2.5 2.5 0 0 1 2.5 2.5v1a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 12.5zm1.5 7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1zm1-2.5A2.5 2.5 0 0 0 4 18.5v1A2.5 2.5 0 0 0 6.5 22h11a2.5 2.5 0 0 0 2.5-2.5v-1a2.5 2.5 0 0 0-2.5-2.5z"
]);
const $82e7c60f6344ef74$export$25bb51744da917e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceFitVertical20Filled', "20", [
    "M6 1a2 2 0 0 0-2 2v4.5c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z",
    "M6 10.5a2 2 0 0 0-2 2V17c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-4.5a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$2e6170349c89e084 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignSpaceFitVertical20Regular', "20", [
    "M6 1a2 2 0 0 0-2 2v4.5c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM5 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z",
    "M6 10.5a2 2 0 0 0-2 2V17c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-4.5a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$229aad5e8aca2c3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStartHorizontal20Filled', "20", [
    "M3 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M8 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$53ff24f1d3534c0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStartHorizontal20Regular', "20", [
    "M3.5 18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5",
    "M8 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM7 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$69bdf8ddd77aa1fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStartVertical20Filled', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    "M6 6a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$56e0ed9c0260a607 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStartVertical20Regular', "20", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5",
    "M6 6a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM5 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$8529ddf2f712dc96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStraighten20Filled', "20", [
    "M5.35 4.52A3 3 0 0 0 3.07 8.1l.1.4h13l-.7-3.15a3 3 0 0 0-3.57-2.28zm-.82 10.13-.7-3.15h13.01l.1.4a3 3 0 0 1-2.29 3.58L8.1 16.93a3 3 0 0 1-3.57-2.28M1 10c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 10m5 0c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 6 10m5.5-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm4.5.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"
]);
const $82e7c60f6344ef74$export$469f09d643a320ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStraighten20Regular', "20", [
    "M3.07 8.1a3 3 0 0 1 2.28-3.58l6.55-1.45a3 3 0 0 1 3.58 2.28l.7 3.15h-1.03l-.65-2.93a2 2 0 0 0-2.38-1.52L5.57 5.5a2 2 0 0 0-1.52 2.38l.13.62H3.16zm12.75 3.4h1.02l.09.4a3 3 0 0 1-2.28 3.58L8.1 16.93a3 3 0 0 1-3.58-2.28l-.7-3.15h1.03l.65 2.93a2 2 0 0 0 2.39 1.52l6.54-1.45a2 2 0 0 0 1.52-2.38zM1 10c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 10m5 0c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 6 10m5.5-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm4.5.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"
]);
const $82e7c60f6344ef74$export$9ca3c205e2b02cc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStraighten24Filled', "24", [
    "M5.55 5.16a3.25 3.25 0 0 0-2.47 3.88l.27 1.21h16.53l-1.04-4.7a3.25 3.25 0 0 0-3.88-2.47zm-.38 13.3-1.05-4.71h16.54l.27 1.21a3.25 3.25 0 0 1-2.47 3.88l-9.42 2.08a3.25 3.25 0 0 1-3.87-2.47M1 12c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 1 12m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 7 12m6.75-.75a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM19 12c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 19 12"
]);
const $82e7c60f6344ef74$export$8d2768f2cb3c666b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStraighten24Regular', "24", [
    "M3.08 9.04a3.25 3.25 0 0 1 2.47-3.88l9.41-2.08a3.25 3.25 0 0 1 3.88 2.47l1.04 4.7h-1.54l-.97-4.38a1.75 1.75 0 0 0-2.08-1.33L5.87 6.63a1.75 1.75 0 0 0-1.33 2.09l.34 1.53H3.35zm16.04 4.71h1.54l.26 1.21a3.25 3.25 0 0 1-2.47 3.88l-9.4 2.08a3.25 3.25 0 0 1-3.89-2.47l-1.04-4.7h1.54l.97 4.38c.2.94 1.14 1.54 2.09 1.33l9.41-2.09a1.75 1.75 0 0 0 1.33-2.09zM1 12c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 1 12m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 7 12m6.75-.75a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM19 12c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 19 12"
]);
const $82e7c60f6344ef74$export$70fca494f5c63fd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchHorizontal16Filled', "16", [
    "M3 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm11 0a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm-10 3C4 3.67 4.67 3 5.5 3h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 5.5zm0 6C4 9.67 4.67 9 5.5 9h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5z"
]);
const $82e7c60f6344ef74$export$ff0b632b4a5a5861 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchHorizontal16Regular', "16", [
    "M3 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm11 0a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zm-10 3C4 3.67 4.67 3 5.5 3h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 5.5zM5.5 4a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 5C4.67 9 4 9.67 4 10.5v1c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5zM5 10.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"
]);
const $82e7c60f6344ef74$export$93d32007881cb701 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchHorizontal20Filled', "20", [
    "M3 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M16 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M13 16a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2z",
    "M15 7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2z"
]);
const $82e7c60f6344ef74$export$db309c2eb7bc9343 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchHorizontal20Regular', "20", [
    "M3 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M16 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M13 16a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2zm1-2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z",
    "M15 7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2zm-2 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1z"
]);
const $82e7c60f6344ef74$export$842de4b26d480cbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchVertical16Filled', "16", [
    "M1.5 13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0-11a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm3 10A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4h1C6.33 4 7 4.67 7 5.5v5c0 .83-.67 1.5-1.5 1.5zM9 10.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1C9.67 4 9 4.67 9 5.5z"
]);
const $82e7c60f6344ef74$export$83147056fa26c0d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchVertical16Regular', "16", [
    "M1.5 13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm0-11a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm3 10A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4h1C6.33 4 7 4.67 7 5.5v5c0 .83-.67 1.5-1.5 1.5zM4 10.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm5 0c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1C9.67 4 9 4.67 9 5.5zm1.5.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5z"
]);
const $82e7c60f6344ef74$export$ead2b847cae0287e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchVertical20Filled', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    "M2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    "M4 13c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z",
    "M13 15a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2z"
]);
const $82e7c60f6344ef74$export$3f5802b49bbd7c12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignStretchVertical20Regular', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    "M2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    "M4 13c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2zm2 1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1z",
    "M13 15h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2m-1-2V7a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1"
]);
const $82e7c60f6344ef74$export$9e4dd615fe400806 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop16Filled', "16", [
    "M1.5 2a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM2 5.75C2 4.78 2.78 4 3.75 4h1.5C6.22 4 7 4.78 7 5.75v6.5C7 13.22 6.22 14 5.25 14h-1.5C2.78 14 2 13.22 2 12.25zm7 0C9 4.78 9.78 4 10.75 4h1.5c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75h-1.5C9.78 12 9 11.22 9 10.25z"
]);
const $82e7c60f6344ef74$export$a691d967a8819c84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop16Regular', "16", [
    "M1.5 2a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM2 5.75C2 4.78 2.78 4 3.75 4h1.5C6.22 4 7 4.78 7 5.75v6.5C7 13.22 6.22 14 5.25 14h-1.5C2.78 14 2 13.22 2 12.25zM3.75 5a.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h1.5c.41 0 .75-.34.75-.75v-6.5A.75.75 0 0 0 5.25 5zM9 5.75C9 4.78 9.78 4 10.75 4h1.5c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75h-1.5C9.78 12 9 11.22 9 10.25zM10.75 5a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h1.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$5a739632db159607 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop20Filled', "20", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M11 7c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zM6 5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"
]);
const $82e7c60f6344ef74$export$6fbc3d2d597cde07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop20Regular', "20", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M11 7c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM6 5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM5 7a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $82e7c60f6344ef74$export$e80cb6ba0aa9ab39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop24Filled', "24", [
    "M2.75 3a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM4 8.25C4 7.01 5 6 6.25 6h2.5C9.99 6 11 7 11 8.25v10.5C11 19.99 10 21 8.75 21h-2.5C5.01 21 4 20 4 18.75zm9 0C13 7.01 14 6 15.25 6h2.5C18.99 6 20 7 20 8.25v7c0 1.24-1 2.25-2.25 2.25h-2.5c-1.24 0-2.25-1-2.25-2.25z"
]);
const $82e7c60f6344ef74$export$fd0f9c0bf4c6b6f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop24Regular', "24", [
    "M2.75 3a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM4 8.25C4 7.01 5 6 6.25 6h2.5C9.99 6 11 7 11 8.25v10.5C11 19.99 10 21 8.75 21h-2.5C5.01 21 4 20 4 18.75zm2.25-.75a.75.75 0 0 0-.75.75v10.5c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75V8.25a.75.75 0 0 0-.75-.75zm6.75.75C13 7.01 14 6 15.25 6h2.5C18.99 6 20 7 20 8.25v7c0 1.24-1 2.25-2.25 2.25h-2.5c-1.24 0-2.25-1-2.25-2.25zm2.25-.75a.75.75 0 0 0-.75.75v7c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75v-7a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$e8930cca77c40053 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop28Filled', "28", [
    "M2.75 3a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5zM5 8.75A2.75 2.75 0 0 1 7.75 6h2.5A2.75 2.75 0 0 1 13 8.75v13.5A2.75 2.75 0 0 1 10.25 25h-2.5A2.75 2.75 0 0 1 5 22.25zm10 0A2.75 2.75 0 0 1 17.75 6h2.5A2.75 2.75 0 0 1 23 8.75v8a2.75 2.75 0 0 1-2.75 2.75h-2.5A2.75 2.75 0 0 1 15 16.75z"
]);
const $82e7c60f6344ef74$export$7512686e3449f5b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop28Regular', "28", [
    "M2.75 3a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5zM5 8.75A2.75 2.75 0 0 1 7.75 6h2.5A2.75 2.75 0 0 1 13 8.75v13.5A2.75 2.75 0 0 1 10.25 25h-2.5A2.75 2.75 0 0 1 5 22.25zM7.75 7.5c-.69 0-1.25.56-1.25 1.25v13.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V8.75c0-.69-.56-1.25-1.25-1.25zM15 8.75A2.75 2.75 0 0 1 17.75 6h2.5A2.75 2.75 0 0 1 23 8.75v8a2.75 2.75 0 0 1-2.75 2.75h-2.5A2.75 2.75 0 0 1 15 16.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25v-8c0-.69-.56-1.25-1.25-1.25z"
]);
const $82e7c60f6344ef74$export$d10a3b109e45e523 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop32Filled', "32", [
    "M4 3a1 1 0 0 0 0 2h24a1 1 0 1 0 0-2zm1 7.5A3.5 3.5 0 0 1 8.5 7h3a3.5 3.5 0 0 1 3.5 3.5v15a3.5 3.5 0 0 1-3.5 3.5h-3A3.5 3.5 0 0 1 5 25.5zm12 0A3.5 3.5 0 0 1 20.5 7h3a3.5 3.5 0 0 1 3.5 3.5v9a3.5 3.5 0 0 1-3.5 3.5h-3a3.5 3.5 0 0 1-3.5-3.5z"
]);
const $82e7c60f6344ef74$export$b3eded9a76a0a9bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop32Regular', "32", [
    "M4 3a1 1 0 0 0 0 2h24a1 1 0 1 0 0-2zm1 7.5A3.5 3.5 0 0 1 8.5 7h3a3.5 3.5 0 0 1 3.5 3.5v15a3.5 3.5 0 0 1-3.5 3.5h-3A3.5 3.5 0 0 1 5 25.5zM8.5 9C7.67 9 7 9.67 7 10.5v15c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zm8.5 1.5A3.5 3.5 0 0 1 20.5 7h3a3.5 3.5 0 0 1 3.5 3.5v9a3.5 3.5 0 0 1-3.5 3.5h-3a3.5 3.5 0 0 1-3.5-3.5zM20.5 9c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5z"
]);
const $82e7c60f6344ef74$export$a34b3faa6a541677 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop48Filled', "48", [
    "M5.25 6.5a1.25 1.25 0 1 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5zM26 15.75c0-2.35 1.9-4.25 4.25-4.25h5.5c2.35 0 4.25 1.9 4.25 4.25v15C40 33.1 38.1 35 35.75 35h-5.5A4.25 4.25 0 0 1 26 30.75zM12.25 11.5h5.5c2.35 0 4.25 1.9 4.25 4.25V38c0 2.35-1.9 4.25-4.25 4.25h-5.5A4.25 4.25 0 0 1 8 38V15.75c0-2.35 1.9-4.25 4.25-4.25"
]);
const $82e7c60f6344ef74$export$468b7523b34c9b74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlignTop48Regular', "48", [
    "M5.25 6.5a1.25 1.25 0 1 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5zM26 15.75c0-2.35 1.9-4.25 4.25-4.25h5.5c2.35 0 4.25 1.9 4.25 4.25v15C40 33.1 38.1 35 35.75 35h-5.5A4.25 4.25 0 0 1 26 30.75zM30.25 14c-.97 0-1.75.78-1.75 1.75v15c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75v-15c0-.97-.78-1.75-1.75-1.75zm-18-2.5h5.5c2.35 0 4.25 1.9 4.25 4.25V38c0 2.35-1.9 4.25-4.25 4.25h-5.5A4.25 4.25 0 0 1 8 38V15.75c0-2.35 1.9-4.25 4.25-4.25m5.5 2.5h-5.5c-.97 0-1.75.78-1.75 1.75V38c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75V15.75c0-.97-.78-1.75-1.75-1.75"
]);
const $82e7c60f6344ef74$export$c80d994a35568dea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Badge20Filled', "20", [
    "M16 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1a3 3 0 0 0 1-.17V15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8.17A3 3 0 0 0 16 7"
]);
const $82e7c60f6344ef74$export$767df271785627e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Badge20Regular', "20", [
    "M16 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1 9V6.83A3 3 0 0 1 16 7v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a3 3 0 0 1 .17-1H5a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2"
]);
const $82e7c60f6344ef74$export$54590cb6429b0b00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Badge24Filled', "24", [
    "M16 4.5a3.5 3.5 0 0 0 5 3.16v10.59A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h10.59Q16 3.69 16 4.5M19.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $82e7c60f6344ef74$export$17bcf5576185bf5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Badge24Regular', "24", [
    "M16.34 3Q16 3.68 16 4.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .7.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V8q.82 0 1.5-.34v10.59A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3zm3.16-1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $82e7c60f6344ef74$export$e1675937ef7460b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_16_color__a)",
            "d": "m14 10-3-1-3 1-1 2 1 2h3.5a2.5 2.5 0 0 0 2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_16_color__b)",
            "d": "M8 2 7 6l1 4h6V4.5A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_16_color__c)",
            "d": "M8 14V6L5 5 2 6v5.5A2.5 2.5 0 0 0 4.5 14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_16_color__d)",
            "d": "M8 2v4H2V4.5A2.5 2.5 0 0 1 4.5 2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_16_color__a",
                "x1": "4.67",
                "x2": "8.33",
                "y1": "7.18",
                "y2": "15.78",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#52d17c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_16_color__b",
                "x1": "8.4",
                "x2": "13.08",
                "y1": "2.89",
                "y2": "9.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#309c61"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_16_color__c",
                "x1": "2.86",
                "x2": "8.01",
                "y1": "6.42",
                "y2": "11.17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1a7f7c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_16_color__d",
                "x1": "2.86",
                "x2": "4.43",
                "y1": "2.8",
                "y2": "6.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#64de89"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$9529cd554ae00654 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board16Filled', "16", [
    "M7.5 2v3H2v-.5A2.5 2.5 0 0 1 4.5 2zm1 0v8H14V4.5A2.5 2.5 0 0 0 11.5 2zm5.5 9H8.5v3h3a2.5 2.5 0 0 0 2.5-2.5zm-6.5 3V6H2v5.5A2.5 2.5 0 0 0 4.5 14z"
]);
const $82e7c60f6344ef74$export$4591718f507b2ba7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5V5h4.5V3zm4 0v7H13V4.5c0-.83-.67-1.5-1.5-1.5zm4.5 8H8.5v2h3c.83 0 1.5-.67 1.5-1.5zm-5.5 2V6H3v5.5c0 .83.67 1.5 1.5 1.5z"
]);
const $82e7c60f6344ef74$export$54616c15db60758e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_20_color__a)",
            "d": "m17 12-3.5-.5-3.5.5-.5 2.5.5 2.5h4a3 3 0 0 0 3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_20_color__b)",
            "d": "m10 3-.5 4.5.5 4.5h7V6a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_20_color__c)",
            "d": "M10 17V8l-3.5-.5L3 8v6a3 3 0 0 0 3 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_20_color__d)",
            "d": "M10 3v5H3V6a3 3 0 0 1 3-3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_20_color__a",
                "x1": "7",
                "x2": "11.1",
                "y1": "9.5",
                "y2": "18.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#52d17c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_20_color__b",
                "x1": "11",
                "x2": "16.33",
                "y1": "4",
                "y2": "10.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#309c61"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_20_color__c",
                "x1": "4",
                "x2": "9.46",
                "y1": "9",
                "y2": "14.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1a7f7c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_20_color__d",
                "x1": "4",
                "x2": "6.07",
                "y1": "4",
                "y2": "9.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#64de89"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$2a550ac5e65e6f4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board20Filled', "20", [
    "M9.5 3v4H3V6a3 3 0 0 1 3-3zm1 0v9H17V6a3 3 0 0 0-3-3zM17 13h-6.5v4H14a3 3 0 0 0 3-3zm-7.5 4V8H3v6a3 3 0 0 0 3 3z"
]);
const $82e7c60f6344ef74$export$c6fd3b7d9df8dbd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v1.06L9.5 7V4zm4.5 0v8H16V6a2 2 0 0 0-2-2zm5.5 9h-5.5v3H14a2 2 0 0 0 2-2zm-6.5 3V8L4 8.06V14c0 1.1.9 2 2 2z"
]);
const $82e7c60f6344ef74$export$750175f055a13272 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_24_color__a)",
            "d": "m12 15 4.5-1 4.5 1v2.75c0 1.8-1.45 3.25-3.25 3.25H12l-1-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_24_color__b)",
            "d": "M17.75 3A3.25 3.25 0 0 1 21 6.07V15h-9l-1-6 1-6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_24_color__c)",
            "d": "M12 9v12H6.25a3.25 3.25 0 0 1-3.24-3.06L3 17.75V9l4.5-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_24_color__d)",
            "d": "M12 3v6H3V6.25C3 4.45 4.46 3 6.25 3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_24_color__a",
                "x1": "7.67",
                "x2": "12.72",
                "y1": "11.45",
                "y2": "23.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#52d17c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_24_color__b",
                "x1": "13",
                "x2": "20.1",
                "y1": "4.33",
                "y2": "13.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#309c61"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_24_color__c",
                "x1": "4.29",
                "x2": "11.75",
                "y1": "10.05",
                "y2": "17.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1a7f7c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_24_color__d",
                "x1": "4.29",
                "x2": "6.65",
                "y1": "4.2",
                "y2": "10.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#64de89"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$811150cca86cad6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board24Filled', "24", [
    "M11.5 21H6.25A3.25 3.25 0 0 1 3 17.75V9.5h8.5zm9.5-3.25c0 1.8-1.46 3.25-3.25 3.25H13v-5h8zM17.75 3C19.55 3 21 4.46 21 6.25v8.25h-8V3zM11.5 8H3V6.25C3 4.45 4.46 3 6.25 3h5.25z"
]);
const $82e7c60f6344ef74$export$7c55890f7c3f493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board24Regular', "24", [
    "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3zM4.5 17.75c0 .97.78 1.75 1.75 1.75h5.25v-10h-7zM13 16v3.5h4.75c.97 0 1.75-.78 1.75-1.75V16zm0-1.5h6.5V6.25c0-.97-.78-1.75-1.75-1.75H13zm-6.75-10c-.97 0-1.75.78-1.75 1.75V8h7V4.5z"
]);
const $82e7c60f6344ef74$export$5445ba4a01c7c0ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_28_color__a)",
            "d": "m25 18-5.5-1-5.5 1-1 3.5 1 3.5h7.25A3.75 3.75 0 0 0 25 21.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_28_color__b)",
            "d": "m14 3-1 7.5 1 7.5h11V6.75A3.75 3.75 0 0 0 21.25 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_28_color__c)",
            "d": "M14 25V11l-5.5-1L3 11v10.25A3.75 3.75 0 0 0 6.75 25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_board_28_color__d)",
            "d": "M14 3v8H3V6.75A3.75 3.75 0 0 1 6.75 3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_28_color__a",
                "x1": "9",
                "x2": "14.58",
                "y1": "14.09",
                "y2": "28.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#52d17c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_28_color__b",
                "x1": "15.4",
                "x2": "24.36",
                "y1": "4.67",
                "y2": "15.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#309c61"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_28_color__c",
                "x1": "4.57",
                "x2": "13.19",
                "y1": "12.37",
                "y2": "21.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1a7f7c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_board_28_color__d",
                "x1": "4.57",
                "x2": "7.93",
                "y1": "4.6",
                "y2": "12.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b0f098"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#64de89"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$cc7c3c0577bf56f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board28Filled', "28", [
    "M13.5 3v6.5H3V6.75A3.75 3.75 0 0 1 6.75 3zM15 3v13.5h10V6.75A3.75 3.75 0 0 0 21.25 3zm10 15H15v7h6.25A3.75 3.75 0 0 0 25 21.25zm-11.5 7V11H3v10.25A3.75 3.75 0 0 0 6.75 25z"
]);
const $82e7c60f6344ef74$export$a04f3b782c2a61b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zM4.5 6.75c0-1.24 1-2.25 2.25-2.25h6.75v5h-9zm0 4.25h9v12.5H6.75c-1.24 0-2.25-1-2.25-2.25zM15 23.5V18h8.5v3.25c0 1.24-1 2.25-2.25 2.25zm8.5-7H15v-12h6.25c1.24 0 2.25 1 2.25 2.25z"
]);
const $82e7c60f6344ef74$export$9558376df2bebd4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board32Filled', "32", [
    "M15 29H7.5A4.5 4.5 0 0 1 3 24.5V12h12zm14-4.5a4.5 4.5 0 0 1-4.5 4.5H17v-7h12zM24.5 3A4.5 4.5 0 0 1 29 7.5V20H17V3zM15 10H3V7.5A4.5 4.5 0 0 1 7.5 3H15z"
]);
const $82e7c60f6344ef74$export$ebf3cc2737cf5d8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board32Regular', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zM5 24.5A2.5 2.5 0 0 0 7.5 27H15V12H5zM17 22v5h7.5a2.5 2.5 0 0 0 2.5-2.5V22zm0-2h10V7.5A2.5 2.5 0 0 0 24.5 5H17zM7.5 5A2.5 2.5 0 0 0 5 7.5V10h10V5z"
]);
const $82e7c60f6344ef74$export$2e99d449b0075f23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board48Filled', "48", [
    "M23 42H12.25A6.25 6.25 0 0 1 6 35.75V19.5h17zm19-6.25C42 39.2 39.2 42 35.75 42H25.5V31H42zM35.75 6C39.2 6 42 8.8 42 12.25V28.5H25.5V6zM23 17H6v-4.75C6 8.8 8.8 6 12.25 6H23z"
]);
const $82e7c60f6344ef74$export$a4be33d2996303d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Board48Regular', "48", [
    "M35.75 6C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6zM8.5 35.75a3.75 3.75 0 0 0 3.75 3.75H23v-20H8.5zm17-4.75v8.5h10.25a3.75 3.75 0 0 0 3.75-3.75V31zm0-2.5h14V12.25a3.75 3.75 0 0 0-3.75-3.75H25.5zm-13.25-20a3.75 3.75 0 0 0-3.75 3.75V17H23V8.5z"
]);
const $82e7c60f6344ef74$export$c76dbf3743d0a1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardGames20Filled', "20", [
    "M15.95 5.5a3 3 0 0 1 .98.18 2.5 2.5 0 1 1-2.29 4.42l.45 1.86c.2.78-.4 1.54-1.21 1.54h-.76c-.81 0-1.41-.76-1.22-1.55l.45-1.85a2.5 2.5 0 0 1-1.41.4 2 2 0 0 0-.7-1.07 4 4 0 0 0-.4-3.64 2.5 2.5 0 0 1 1.2-.29 2.5 2.5 0 0 1 2.46-3 2.5 2.5 0 0 1 2.45 3M6.5 5a3 3 0 0 0-2.24 5H4a1 1 0 1 0 0 2h.52a5.8 5.8 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.8 5.8 0 0 1 8.48 12H9a1 1 0 1 0 0-2h-.26A3 3 0 0 0 6.5 5"
]);
const $82e7c60f6344ef74$export$c3284d5729a0e8e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardGames20Regular', "20", [
    "M13.5 3a2 2 0 0 0-1.96 2.4.5.5 0 0 1-.54.6 2 2 0 0 0-.92.22 4 4 0 0 0-.55-.83q.45-.26.97-.35V5a3 3 0 1 1 6 0v.04a3 3 0 1 1-1.14 5.9l.22.9a1.75 1.75 0 0 1-1.7 2.16h-.76a1.75 1.75 0 0 1-1.7-2.16l.45-1.86a.5.5 0 1 1 .97.24l-.45 1.85c-.12.47.24.93.73.93h.76c.49 0 .84-.45.73-.93l-.45-1.85a.5.5 0 0 1 .76-.54q.47.31 1.08.32a2 2 0 1 0-.04-4 .5.5 0 0 1-.5-.6q.04-.2.04-.4a2 2 0 0 0-2-2m-9 5a2 2 0 1 1 3.6 1.2.5.5 0 0 0 .4.8H9a.5.5 0 0 1 0 1H7.9a.5.5 0 0 0-.5.56 6.9 6.9 0 0 0 2.34 4.5q.26.24.26.49c0 .25-.2.45-.45.45h-6.1a.45.45 0 0 1-.45-.45q0-.25.26-.49a6.9 6.9 0 0 0 2.34-4.5.5.5 0 0 0-.5-.56H4a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .4-.8q-.39-.51-.4-1.2m2-3a3 3 0 0 0-2.82 4.03A1.5 1.5 0 0 0 4 12h.52a5.8 5.8 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.8 5.8 0 0 1 8.48 12H9a1.5 1.5 0 0 0 .32-2.97A3 3 0 0 0 6.5 5"
]);
const $82e7c60f6344ef74$export$f62fcf108b0f8bc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardHeart16Filled', "16", [
    "M7.5 2v3H2v-.5A2.5 2.5 0 0 1 4.5 2zm1 0v4c.7-.01 1.4.18 2 .57a3.6 3.6 0 0 1 3.5-.2V4.5A2.5 2.5 0 0 0 11.5 2zm-1 4v.16q-.81.25-1.46.9a3.6 3.6 0 0 0 0 5.05l1.46 1.47V14h-3A2.5 2.5 0 0 1 2 11.5V6zm-.75 5.41 3.43 3.46c.18.17.46.17.64 0l3.43-3.46A2.6 2.6 0 0 0 14 7.54a2.55 2.55 0 0 0-3.38.22l-.12.12-.12-.12a2.54 2.54 0 0 0-3.63 0c-1 1-1 2.64 0 3.65"
]);
const $82e7c60f6344ef74$export$2f8645d06b3ecf52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardHeart16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v1.86a4 4 0 0 0-1-.32V4.5c0-.83-.67-1.5-1.5-1.5h-3v3q-.5 0-1 .16V6H3v5.5c0 .83.67 1.5 1.5 1.5h2.42l1 1H4.5A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5V5h4.5V3zM13 7.06a2.5 2.5 0 0 1 1.25.7c1 1 1 2.64 0 3.65l-3.43 3.46a.45.45 0 0 1-.64 0L6.75 11.4a2.6 2.6 0 0 1 1.75-4.4c.68-.03 1.36.23 1.88.75l.12.12.12-.12a2.6 2.6 0 0 1 2.38-.7"
]);
const $82e7c60f6344ef74$export$54d941b53e5f5e8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardHeart20Filled', "20", [
    "M9.5 7V3H6a3 3 0 0 0-3 3v1zm1.25 8.41 3.43 3.46c.18.17.46.17.64 0l3.43-3.46A2.6 2.6 0 0 0 17 11.06a2.6 2.6 0 0 0-2.38.7l-.12.12-.12-.12-.08-.08a2.55 2.55 0 0 0-3.76.32 2.6 2.6 0 0 0 .21 3.41M9.5 17v-1.58a3.6 3.6 0 0 1 0-3.67V8H3v6a3 3 0 0 0 3 3zm5-6.43a3.6 3.6 0 0 1 2.5-.53V6a3 3 0 0 0-3-3h-3.5v7.66a3.55 3.55 0 0 1 4-.09"
]);
const $82e7c60f6344ef74$export$bb682ba7ad7bdf30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardHeart20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.92l-.88-.89-.1-.11H6a2 2 0 0 1-2-2V8.06L9.5 8v3.75a4 4 0 0 1 1-1.09V4H14a2 2 0 0 1 2 2v4.03q.5-.06 1 .01V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h3.5v3L4 7.06zm13 5.06q.7.16 1.25.7c1 1 1 2.64 0 3.65l-3.43 3.46a.45.45 0 0 1-.64 0l-3.43-3.46a2.6 2.6 0 0 1-.21-3.41q.09-.13.21-.24c1-1.01 2.63-1.01 3.63 0l.12.12.12-.12a2.6 2.6 0 0 1 2.38-.7"
]);
const $82e7c60f6344ef74$export$6a0aeed53a5c043e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardHeart24Filled', "24", [
    "M11.5 21v-1.93l-.2-.2a4.7 4.7 0 0 1 .2-6.7V9.5H3v8.44A3.25 3.25 0 0 0 6.26 21zm10-15.25v5.73a4.4 4.4 0 0 0-4.5.3 4.4 4.4 0 0 0-4-.52V2.5h5.25a3.25 3.25 0 0 1 3.25 3.06zm-10 11.73a3.7 3.7 0 0 1 .52-4.42q.45-.45.98-.71a3.4 3.4 0 0 1 3.96.7l.04.05.04-.04.2-.2a3.4 3.4 0 0 1 4.74.2 3.7 3.7 0 0 1 0 5.11l-4.45 4.6a.74.74 0 0 1-1.06 0l-4.45-4.6q-.3-.32-.52-.69m0-9.48V2.5H6.25A3.25 3.25 0 0 0 3 5.75V8z"
]);
const $82e7c60f6344ef74$export$821978d370731322 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardHeart24Regular', "24", [
    "M21.5 5.56a3.25 3.25 0 0 0-3.25-3.06h-12A3.25 3.25 0 0 0 3 5.75v12.19A3.25 3.25 0 0 0 6.26 21h7.12l-1.45-1.5H6.24c-.91 0-1.66-.7-1.74-1.59l-.01-.16V9.5h7v2.67q.68-.62 1.5-.9V4h5.25c.91 0 1.66.7 1.74 1.59l.01.16v5.28q.79.08 1.5.45V5.56M6.25 4h5.25v4h-7V5.75c0-.92.7-1.67 1.6-1.75zm15.73 9.06a3.7 3.7 0 0 1 0 5.11l-4.45 4.6a.74.74 0 0 1-1.06 0l-4.45-4.6q-.3-.31-.52-.69a3.7 3.7 0 0 1 .52-4.42q.45-.45.98-.71a3.4 3.4 0 0 1 3.96.7l.04.05.04-.04a3.4 3.4 0 0 1 4.94 0"
]);
const $82e7c60f6344ef74$export$35d8a7af371b220a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5V7h7V2zm5.5 8h4V6h-4zm4 1h-4v3h1.5a2.5 2.5 0 0 0 2.5-2.5zm0-6.5V5h-4V2h1.5A2.5 2.5 0 0 1 14 4.5M9 8H2v3.5A2.5 2.5 0 0 0 4.5 14H9z"
]);
const $82e7c60f6344ef74$export$ecdb5f56dab013ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5V7h6V3zM3 8v3.5c0 .83.67 1.5 1.5 1.5H9V8zm7 1h3V7h-3zm3 1h-3v3h1.5c.83 0 1.5-.67 1.5-1.5zm0-5.5c0-.83-.67-1.5-1.5-1.5H10v3h3z"
]);
const $82e7c60f6344ef74$export$7c6bbad5fc2e708c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v3h8V3zm5 7H3v4a3 3 0 0 0 3 3h5zm3 7h-2v-4h5v1a3 3 0 0 1-3 3m3-5h-5V8h5zm0-5h-5V3h2a3 3 0 0 1 3 3z"
]);
const $82e7c60f6344ef74$export$1cd9c4e18a9e58bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm1 4v4c0 1.1.9 2 2 2h5v-6zm7-1V4H6a2 2 0 0 0-2 2v3zm1 7h2a2 2 0 0 0 2-2v-1h-4zm4-9V6a2 2 0 0 0-2-2h-2v3zm0 1h-4v4h4z"
]);
const $82e7c60f6344ef74$export$25f5ede10f47eee1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25V11h11V3zM3 17.75V12.5h11V21H6.25A3.25 3.25 0 0 1 3 17.75M15.5 16v5h2.25c1.8 0 3.25-1.46 3.25-3.25V16zm5.5-1.5v-5h-5.5v5zM21 8h-5.5V3h2.25C19.55 3 21 4.46 21 6.25z"
]);
const $82e7c60f6344ef74$export$3f3b54bd64af938f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zm1.5 6.25v5.25c0 .97.78 1.75 1.75 1.75H14v-7zM14 11V4.5H6.25c-.97 0-1.75.78-1.75 1.75V11zm5.5-1.5h-4v5h4zm0 6.5h-4v3.5h2.25c.97 0 1.75-.78 1.75-1.75zm0-8V6.25c0-.97-.78-1.75-1.75-1.75H15.5V8z"
]);
const $82e7c60f6344ef74$export$3eef731a15b86a2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75V13h13V3zM16 14.5H3v6.75A3.75 3.75 0 0 0 6.75 25H16zM21.25 25H17.5v-7H25v3.25A3.75 3.75 0 0 1 21.25 25M25 16.5h-7.5v-5H25zM17.5 3v7H25V6.75A3.75 3.75 0 0 0 21.25 3z"
]);
const $82e7c60f6344ef74$export$4890d59fac2c22c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit28Regular', "28", [
    "M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25zm1.5 7.75v6.75c0 1.24 1 2.25 2.25 2.25H16v-9zM16 13V4.5H6.75c-1.24 0-2.25 1-2.25 2.25V13zm5.25 10.5c1.24 0 2.25-1 2.25-2.25V18h-6v5.5zm2.25-7v-5h-6v5zm-6-12V10h6V6.75c0-1.24-1-2.25-2.25-2.25z"
]);
const $82e7c60f6344ef74$export$75be8fabfd48a7bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit48Filled', "48", [
    "M11.25 6A5.25 5.25 0 0 0 6 11.25V23h21V6zM27 25.5H6v11.25C6 39.65 8.35 42 11.25 42H27zM36.75 42H29.5V31.5H42v5.25c0 2.9-2.35 5.25-5.25 5.25M42 19.5V29H29.5v-9.5zm0-2.5H29.5V6h7.25C39.65 6 42 8.35 42 11.25z"
]);
const $82e7c60f6344ef74$export$7b7a2203c6afb584 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoardSplit48Regular', "48", [
    "M6 11.25C6 8.35 8.35 6 11.25 6h25.5C39.65 6 42 8.35 42 11.25v25.5c0 2.9-2.35 5.25-5.25 5.25h-25.5A5.25 5.25 0 0 1 6 36.75zM39.5 29v-9.5h-10V29zm-10 2.5v8h7.25a2.75 2.75 0 0 0 2.75-2.75V31.5zm-2.5-6H8.5v11.25a2.75 2.75 0 0 0 2.75 2.75H27zm0-2.5V8.5H11.25a2.75 2.75 0 0 0-2.75 2.75V23zm12.5-6v-5.75a2.75 2.75 0 0 0-2.75-2.75H29.5V17z"
]);
const $82e7c60f6344ef74$export$13935aaee182ce8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase12Filled', "12", [
    "M6.75 1C7.44 1 8 1.56 8 2.25V3h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1v-.75C4 1.56 4.56 1 5.25 1zm-1.5 1a.25.25 0 0 0-.25.25V3h2v-.75A.25.25 0 0 0 6.75 2z"
]);
const $82e7c60f6344ef74$export$f535d6e14638c4c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase12Regular', "12", [
    "M6.75 1C7.44 1 8 1.56 8 2.25V3h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h1v-.75C4 1.56 4.56 1 5.25 1zM3 4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm2.25-2a.25.25 0 0 0-.25.25V3h2v-.75A.25.25 0 0 0 6.75 2z"
]);
const $82e7c60f6344ef74$export$5d47a605969ca14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_16_color__a)",
            "d": "M2 7h12v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_16_color__b)",
            "d": "M2 7h12v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_16_color__c)",
            "fillRule": "evenodd",
            "d": "M9.5 2c.83 0 1.5.67 1.5 1.5V5h1c.5 0 .97.19 1.32.5H2.68Q3.22 5.02 4 5h1V3.5C5 2.67 5.67 2 6.5 2zm-3 1a.5.5 0 0 0-.5.5V5h4V3.5a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_16_color__d)",
            "d": "M2 7c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v1.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 2 8.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_16_color__e)",
            "d": "M8.5 7.5h-1A.5.5 0 0 0 7 8v2.01c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_16_color__a",
                "x1": "2.43",
                "x2": "6.72",
                "y1": "8.31",
                "y2": "20.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_16_color__c",
                "x1": "2.2",
                "x2": "2.79",
                "y1": "2.35",
                "y2": "6.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#163697"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_16_color__d",
                "x1": "3.2",
                "x2": "8.66",
                "y1": "5.21",
                "y2": "11.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#80f1e6"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#40c4f5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#00a2fa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_16_color__e",
                "x1": "8",
                "x2": "8",
                "y1": "7.5",
                "y2": "9.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b8f5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#7cecff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_briefcase_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 7 -13.3758 0 8 7)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#194694"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#367af2",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$2d3dc198f3c94ee8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase16Filled', "16", [
    "M15 11.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5V8.95A3.5 3.5 0 0 0 3.5 10H7v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V10h3.5c.98 0 1.86-.4 2.5-1.05zM9.25 1c.97 0 1.75.78 1.75 1.75V4h1.5a2.5 2.5 0 0 1 0 5H9v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V9H3.5a2.5 2.5 0 0 1 0-5H5V2.75C5 1.78 5.78 1 6.75 1zm-2.5 1a.75.75 0 0 0-.75.75V4h4V2.75A.75.75 0 0 0 9.25 2z"
]);
const $82e7c60f6344ef74$export$32498c7222cc7e22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase16Regular', "16", [
    "M9.25 1c.97 0 1.75.78 1.75 1.75V4h1.5A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-5A2.5 2.5 0 0 1 3.5 4H5V2.75C5 1.78 5.78 1 6.75 1zM14 9.5q-.64.48-1.5.5H9v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10H3.5q-.85-.02-1.5-.5v2c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zM3.5 5C2.67 5 2 5.67 2 6.5v1C2 8.33 2.67 9 3.5 9H7v-.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V9h3.5c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5zm3.25-3a.75.75 0 0 0-.75.75V4h4V2.75A.75.75 0 0 0 9.25 2z"
]);
const $82e7c60f6344ef74$export$dde09b917057911d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_20_color__a)",
            "fillRule": "evenodd",
            "d": "M11.25 2c.97 0 1.75.78 1.75 1.75V5l-3 1.5L7 5V3.75C7 2.78 7.78 2 8.75 2zm-2.5 1a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_20_color__b)",
            "d": "M3 8h14v5.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_20_color__c)",
            "d": "M3 8h14v5.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_20_color__d)",
            "d": "M3 7.5A2.5 2.5 0 0 1 5.5 5h9A2.5 2.5 0 0 1 17 7.5v2c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 9.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_20_color__e)",
            "d": "M10.5 9h-1a.5.5 0 0 0-.5.5v2.01c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V9.5a.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_20_color__a",
                "x1": "6.73",
                "x2": "8.31",
                "y1": "2.45",
                "y2": "7.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#163697"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_20_color__b",
                "x1": "3.5",
                "x2": "8.32",
                "y1": "9.5",
                "y2": "23.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_20_color__d",
                "x1": "4.4",
                "x2": "10.98",
                "y1": "5.25",
                "y2": "13.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#80f1e6"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#40c4f5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#00a2fa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_20_color__e",
                "x1": "10",
                "x2": "10",
                "y1": "9",
                "y2": "11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b8f5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#7cecff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_briefcase_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 8 -15.6051 0 10 8)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#194694"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#367af2",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$9eee08ba540ebe6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase20Filled', "20", [
    "M18 14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3.36c.73.83 1.8 1.36 3 1.36h4v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V12h4c1.2 0 2.27-.53 3-1.36zM11.25 2c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 1 1 0 6h-4v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.5H5a3 3 0 0 1 0-6h2V3.75C7 2.78 7.78 2 8.75 2zm-2.5 1a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$9a7b8992a827e8c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase20Regular', "20", [
    "M11.25 2c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-2.85V8a3 3 0 0 1 3-3h2V3.75C7 2.78 7.78 2 8.75 2zM17 11.23c-.53.48-1.23.77-2 .77h-4v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V12H5c-.77 0-1.47-.3-2-.77V14l.01.2A2 2 0 0 0 5 16h10a2 2 0 0 0 2-2zM5 6a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h4v-.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v.5h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm3.75-3a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$b8f8643a987f4f7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_24_color__a)",
            "fillRule": "evenodd",
            "d": "M13.75 2C14.99 2 16 3 16 4.25V6l-4 2.31L8 6V4.25C8 3.01 9 2 10.25 2zm-3.5 1.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_24_color__b)",
            "d": "M3 11h18v5.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 16.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_24_color__c)",
            "d": "M3 11h18v5.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 16.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_24_color__d)",
            "d": "M3 9.25C3 7.45 4.46 6 6.25 6h11.5C19.55 6 21 7.46 21 9.25v3c0 .97-.78 1.75-1.75 1.75H4.75C3.78 14 3 13.22 3 12.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_24_color__e)",
            "d": "M13 11h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_24_color__a",
                "x1": "7.64",
                "x2": "9.95",
                "y1": "2.63",
                "y2": "9.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#163697"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_24_color__b",
                "x1": "3.64",
                "x2": "8.5",
                "y1": "12.69",
                "y2": "29.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_24_color__d",
                "x1": "4.8",
                "x2": "13.62",
                "y1": "6.33",
                "y2": "16.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#80f1e6"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#40c4f5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#00a2fa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_24_color__e",
                "x1": "12",
                "x2": "12",
                "y1": "11",
                "y2": "15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b8f5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#7cecff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_briefcase_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 9 -20.0637 0 12 11)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#194694"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#367af2",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$475e3627fe2e564d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase24Filled', "24", [
    "M22 17.75c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 17.75v-5.04c.85.8 2 1.29 3.25 1.29H10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h4.75c1.26 0 2.4-.5 3.25-1.29zM13.75 2C14.99 2 16 3 16 4.25V6h2.92a3.25 3.25 0 0 1-.17 6.5H14V12a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.5H5.25a3.25 3.25 0 0 1 0-6.5H8V4.25C8 3.01 9 2 10.25 2zm-3.5 1.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$1cbbda980f3c876d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25V6h2.75C20.55 6 22 7.46 22 9.25v8.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 17.75v-8.5C2 7.45 3.46 6 5.25 6H8V4.25C8 3.01 9 2 10.25 2zm6.75 11.49q-.76.5-1.75.51H14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1H5.25q-.97-.02-1.75-.51v4.26c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75zM5.25 7.5c-.97 0-1.75.78-1.75 1.75v1.5c0 .97.78 1.75 1.75 1.75H10V12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h4.75c.97 0 1.75-.78 1.75-1.75v-1.5c0-.97-.78-1.75-1.75-1.75zm5-4a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$c3b6a1810f5e615b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_28_color__a)",
            "fillRule": "evenodd",
            "d": "M16.75 2.5c1.24 0 2.25 1 2.25 2.25V7l-5 3-5-3V4.75c0-1.24 1-2.25 2.25-2.25zM11.25 4a.75.75 0 0 0-.75.75V7h7V4.75a.75.75 0 0 0-.75-.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_28_color__b)",
            "d": "M3 13h22v7.25A3.75 3.75 0 0 1 21.25 24H6.75A3.75 3.75 0 0 1 3 20.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_28_color__c)",
            "d": "M3 13h22v7.25A3.75 3.75 0 0 1 21.25 24H6.75A3.75 3.75 0 0 1 3 20.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_28_color__d)",
            "d": "M3 10.75A3.75 3.75 0 0 1 6.75 7h14.5A3.75 3.75 0 0 1 25 10.75v4c0 1.24-1 2.25-2.25 2.25H5.25C4.01 17 3 16 3 14.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_28_color__e)",
            "d": "M15.25 13.52h-2.51c-.7 0-1.26.55-1.26 1.24v2.5c0 .68.57 1.24 1.26 1.24h2.5c.7 0 1.26-.56 1.26-1.25v-2.49c0-.69-.56-1.24-1.25-1.24"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_28_color__a",
                "x1": "8.54",
                "x2": "11.18",
                "y1": "3.25",
                "y2": "11.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#163697"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_28_color__b",
                "x1": "3.79",
                "x2": "9.73",
                "y1": "15.06",
                "y2": "35.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_28_color__d",
                "x1": "5.2",
                "x2": "16.26",
                "y1": "7.42",
                "y2": "19.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#80f1e6"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#40c4f5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#00a2fa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_28_color__e",
                "x1": "13.99",
                "x2": "13.99",
                "y1": "13.52",
                "y2": "18.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b8f5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#7cecff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_briefcase_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 11 -24.5223 0 14 13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#194694"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#367af2",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$8f53ae5fb07d2d96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase28Filled', "28", [
    "M26 21.25A3.75 3.75 0 0 1 22.25 25H5.75A3.75 3.75 0 0 1 2 21.25v-6.83A5.2 5.2 0 0 0 5.75 16h5.75v.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h5.75c1.47 0 2.8-.6 3.75-1.58zM16.25 2.5c1.24 0 2.25 1 2.25 2.25V7h3.75a3.75 3.75 0 0 1 0 7.5H16.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5H5.75a3.75 3.75 0 1 1 0-7.5H9.5V4.75c0-1.24 1-2.25 2.25-2.25zM11.75 4a.75.75 0 0 0-.75.75V7h6V4.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$28e31529472fb1f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase28Regular', "28", [
    "M16.25 2.5c1.24 0 2.25 1 2.25 2.25V7h3.75A3.75 3.75 0 0 1 26 10.75v10.5A3.75 3.75 0 0 1 22.25 25H5.75A3.75 3.75 0 0 1 2 21.25v-10.5A3.75 3.75 0 0 1 5.75 7H9.5V4.75c0-1.24 1-2.25 2.25-2.25zm8.25 12.75c-.63.47-1.4.75-2.25.75H16.5v.5c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5V16H5.75c-.84 0-1.62-.28-2.25-.75v6c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25zM5.75 8.5c-1.24 0-2.25 1-2.25 2.25v1.5c0 1.24 1.01 2.25 2.25 2.25h5.75c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5h5.75c1.24 0 2.25-1 2.25-2.25v-1.5c0-1.24-1-2.25-2.25-2.25zm6-4.5a.75.75 0 0 0-.75.75V7h6V4.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$17a0e3a90cb126b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_32_color__a)",
            "fillRule": "evenodd",
            "d": "M19 3a3 3 0 0 1 3 3v2h.31L16 10.5 9.79 8H10V6a3 3 0 0 1 3-3zm-6 2a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_32_color__b)",
            "d": "M3 14h26v9.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 23.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_32_color__c)",
            "d": "M3 14h26v9.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 23.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_32_color__d)",
            "d": "M3 12.5A4.5 4.5 0 0 1 7.5 8h17a4.5 4.5 0 0 1 4.5 4.5V16a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_32_color__e)",
            "d": "M17.5 15h-3c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_32_color__a",
                "x1": "9.22",
                "x2": "11.41",
                "y1": "3.75",
                "y2": "12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#163697"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_32_color__b",
                "x1": "3.93",
                "x2": "11.97",
                "y1": "16.63",
                "y2": "42.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_32_color__d",
                "x1": "5.6",
                "x2": "17.64",
                "y1": "8.46",
                "y2": "22.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#80f1e6"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#40c4f5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#00a2fa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_32_color__e",
                "x1": "16",
                "x2": "16",
                "y1": "15",
                "y2": "21",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b8f5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#7cecff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_briefcase_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 14 -28.981 0 16 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#194694"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#367af2",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$92ab0a68e57883ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase32Filled', "32", [
    "M30 23.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-6.31A6.5 6.5 0 0 0 6.5 19H13v.5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5V19h6.5c1.75 0 3.33-.7 4.5-1.81zM19 3a3 3 0 0 1 3 3v2h3.5a4.5 4.5 0 0 1 0 9H19v-.5c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5v.5H6.5a4.5 4.5 0 1 1 0-9H10V6a3 3 0 0 1 3-3zm-6 2a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$4dd17f59af7f681 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase32Regular', "32", [
    "M19 3a3 3 0 0 1 3 3v2h3.5a4.5 4.5 0 0 1 4.5 4.5v11a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-11A4.5 4.5 0 0 1 6.5 8H10V6a3 3 0 0 1 3-3zm9 15.24c-.72.48-1.57.76-2.5.76H19v.5c0 .83-.67 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V19H6.5q-1.4-.02-2.5-.76v5.26A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5zM6.5 10A2.5 2.5 0 0 0 4 12.5v2A2.5 2.5 0 0 0 6.5 17H13v-.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v.5h6.5a2.5 2.5 0 0 0 2.5-2.5v-2a2.5 2.5 0 0 0-2.5-2.5zM13 5a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$943757fe55042dfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_48_color__a)",
            "fillRule": "evenodd",
            "d": "M27.75 4C30.1 4 32 5.9 32 8.25V12h.63l-8.13 4.7-8.59-4.7H16V8.25C16 5.9 17.9 4 20.25 4zm-7.5 2.5c-.97 0-1.75.78-1.75 1.75V12h11V8.25c0-.97-.78-1.75-1.75-1.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_48_color__b)",
            "d": "M6 21h36v12.75C42 37.2 39.2 40 35.75 40h-23.5A6.25 6.25 0 0 1 6 33.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_48_color__c)",
            "d": "M6 21h36v12.75C42 37.2 39.2 40 35.75 40h-23.5A6.25 6.25 0 0 1 6 33.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_48_color__d)",
            "d": "M6 18.25C6 14.8 8.8 12 12.25 12h23.5C39.2 12 42 14.8 42 18.25v6A3.75 3.75 0 0 1 38.25 28H9.75A3.75 3.75 0 0 1 6 24.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_briefcase_48_color__e)",
            "d": "M26 23h-4a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_48_color__a",
                "x1": "15.16",
                "x2": "19.67",
                "y1": "5.27",
                "y2": "18.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#163697"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_48_color__b",
                "x1": "7.29",
                "x2": "18.02",
                "y1": "24.56",
                "y2": "59.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_48_color__d",
                "x1": "9.6",
                "x2": "27.25",
                "y1": "12.66",
                "y2": "32.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#80f1e6"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#40c4f5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#00a2fa"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_briefcase_48_color__e",
                "x1": "24",
                "x2": "24",
                "y1": "23",
                "y2": "31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b8f5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#7cecff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_briefcase_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 19 -40.1275 0 24 21)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#194694"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#367af2",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$263cc866f9471cea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase48Filled', "48", [
    "M44 34.75C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75V23.37A8.7 8.7 0 0 0 10.25 26H20v1c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1h9.75c2.45 0 4.66-1 6.25-2.63zM27.75 4C30.1 4 32 5.9 32 8.25V11h5.75a6.25 6.25 0 1 1 0 12.5H28V23a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.5h-9.75a6.25 6.25 0 1 1 0-12.5H16V8.25C16 5.9 17.9 4 20.25 4zm-7.5 2.5c-.97 0-1.75.78-1.75 1.75V11h11V8.25c0-.97-.78-1.75-1.75-1.75z"
]);
const $82e7c60f6344ef74$export$5c2a8bc2b0a688fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Briefcase48Regular', "48", [
    "M27.75 4C30.1 4 32 5.9 32 8.25V11h5.75C41.2 11 44 13.8 44 17.25v17.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-17.5C4 13.8 6.8 11 10.25 11H16V8.25C16 5.9 17.9 4 20.25 4zM41.5 24.75A6.2 6.2 0 0 1 37.75 26H28v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h-9.75c-1.4 0-2.7-.47-3.75-1.25v10a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75zM10.25 13.5a3.75 3.75 0 0 0-3.75 3.75v2.5a3.75 3.75 0 0 0 3.75 3.75H20V23c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v.5h9.75a3.75 3.75 0 0 0 3.75-3.75v-2.5a3.75 3.75 0 0 0-3.75-3.75zm10-7c-.97 0-1.75.78-1.75 1.75V11h11V8.25c0-.97-.78-1.75-1.75-1.75z"
]);
const $82e7c60f6344ef74$export$5b97b0887e76d416 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical16Filled', "16", [
    "M9.25 1c.97 0 1.75.78 1.75 1.75V4h1.5A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-5A2.5 2.5 0 0 1 3.5 4H5V2.75C5 1.78 5.78 1 6.75 1zM8 6.5a.5.5 0 0 0-.5.5v1.5H6a.5.5 0 0 0 0 1h1.5V11a.5.5 0 0 0 1 0V9.5H10a.5.5 0 0 0 0-1H8.5V7a.5.5 0 0 0-.5-.5M6.75 2a.75.75 0 0 0-.75.75V4h4V2.75A.75.75 0 0 0 9.25 2z"
]);
const $82e7c60f6344ef74$export$ad85acc614c3a91d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical16Regular', "16", [
    "M9.25 1c.97 0 1.75.78 1.75 1.75V4h1.5A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-5A2.5 2.5 0 0 1 3.5 4H5V2.75C5 1.78 5.78 1 6.75 1zM3.5 5C2.67 5 2 5.67 2 6.5v5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM8 6.5c.28 0 .5.22.5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7c0-.28.22-.5.5-.5M6.75 2a.75.75 0 0 0-.75.75V4h4V2.75A.75.75 0 0 0 9.25 2z"
]);
const $82e7c60f6344ef74$export$99494121b8c113bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical20Filled', "20", [
    "M11.25 2c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h2V3.75C7 2.78 7.78 2 8.75 2zM10 8a.5.5 0 0 0-.5.5v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2A.5.5 0 0 0 10 8M8.75 3a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$b2af10af78c8546e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical20Regular', "20", [
    "M11.25 2c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-2.85V8a3 3 0 0 1 3-3h2V3.75C7 2.78 7.78 2 8.75 2zM5 6a2 2 0 0 0-2 2v6l.01.2A2 2 0 0 0 5 16h10a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm5 2c.27 0 .5.23.5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2c0-.27.22-.5.5-.5M8.75 3a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$2be2d0bd881c175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25V6h2.75C20.55 6 22 7.46 22 9.25v8.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 17.75v-8.5C2 7.45 3.46 6 5.25 6H8V4.25C8 3.01 9 2 10.25 2zM12 9.75c-.39 0-.7.3-.75.67v2.08h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2.08a.75.75 0 0 0 0-1.5h-2.08v-2.08a.75.75 0 0 0-.75-.67M10.25 3.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$e1a2572a4706919c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25V6h2.75C20.55 6 22 7.46 22 9.25v8.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 17.75v-8.5C2 7.45 3.46 6 5.25 6H8V4.25C8 3.01 9 2 10.25 2zm-8.5 5.5c-.97 0-1.75.78-1.75 1.75v8.5c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-8.5c0-.97-.78-1.75-1.75-1.75zM12 9.75c.39 0 .7.3.75.67v2.08h2.08a.75.75 0 0 1 0 1.5h-2.08v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2.08a.75.75 0 0 1 .75-.67M10.25 3.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$944f5e93997f26d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical32Filled', "32", [
    "M19 3a3 3 0 0 1 3 3v2h3.5a4.5 4.5 0 0 1 4.5 4.5v11a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-11A4.5 4.5 0 0 1 6.5 8H10V6a3 3 0 0 1 3-3zm-3 10a1 1 0 0 0-1 1v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3v-3a1 1 0 0 0-1-1m-3-8a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$574e31826365b5ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseMedical32Regular', "32", [
    "M19 3a3 3 0 0 1 3 3v2h3.5a4.5 4.5 0 0 1 4.5 4.5v11a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-11A4.5 4.5 0 0 1 6.5 8H10V6a3 3 0 0 1 3-3zM6.5 10A2.5 2.5 0 0 0 4 12.5v11A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5v-11a2.5 2.5 0 0 0-2.5-2.5zm9.5 3a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1m-3-8a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$5ad324f08d9fc613 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff16Filled', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13 .07.07a.5.5 0 0 1-.7.7l-.07-.07-.96-.95q-.33.1-.69.1h-9A2.5 2.5 0 0 1 1 11.5V8.95A3.5 3.5 0 0 0 3.5 10H7v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V10h.3L7.32 8.03A.5.5 0 0 0 7 8.5V9H3.5a2.5 2.5 0 0 1-.2-4.99L1.15 1.85a.5.5 0 0 1 0-.7M15 11.5q-.01.6-.26 1.11L12.12 10h.38c.98 0 1.86-.4 2.5-1.05zM9.25 1c.97 0 1.75.78 1.75 1.75V4h1.5a2.5 2.5 0 0 1 0 5h-1.38l-5-5H10V2.75A.75.75 0 0 0 9.25 2h-2.5a.75.75 0 0 0-.75.75v1.13l-1-1v-.13C5 1.78 5.78 1 6.75 1z"
]);
const $82e7c60f6344ef74$export$465ef2b850c491ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff16Regular', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13 .07.07a.5.5 0 0 1-.7.7l-.07-.07-.96-.95q-.33.1-.69.1h-9A2.5 2.5 0 0 1 1 11.5v-5a2.5 2.5 0 0 1 2.3-2.49L1.15 1.85a.5.5 0 0 1 0-.7M2 11.5c0 .83.67 1.5 1.5 1.5h8.8l-3-3H9v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10H3.5q-.85-.02-1.5-.5zM9.25 1c.97 0 1.75.78 1.75 1.75V4h1.5A2.5 2.5 0 0 1 15 6.5v5q-.01.6-.26 1.11l-.78-.77q.04-.16.04-.34v-2q-.64.48-1.5.5h-.38l-1-1h1.38c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5H7.12l-1-1H10V2.75A.75.75 0 0 0 9.25 2h-2.5a.75.75 0 0 0-.75.75v1.13l-1-1v-.13C5 1.78 5.78 1 6.75 1zM3.5 5C2.67 5 2 5.67 2 6.5v1C2 8.33 2.67 9 3.5 9H7v-.5c0-.21.14-.4.33-.47L4.29 5z"
]);
const $82e7c60f6344ef74$export$87ff29dcd64321c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff20Filled', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-1.06-1.06q-.5.2-1.09.21H5a3 3 0 0 1-3-3v-3.36c.73.83 1.8 1.36 3 1.36h4v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V12h.3l-1.97-1.97a.5.5 0 0 0-.33.47v.5H5a3 3 0 0 1-.64-5.93L2.15 2.85a.5.5 0 0 1 0-.7M18 14q-.01.82-.4 1.48L14.12 12H15c1.2 0 2.27-.53 3-1.36zM11.25 2c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 1 1 0 6h-1.88L7 4.88V3.75C7 2.78 7.78 2 8.75 2zm-2.5 1a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$89992f1b27643140 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff20Regular', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-1.06-1.06q-.5.2-1.09.21H5a3 3 0 0 1-3-2.85V8a3 3 0 0 1 2.36-2.93L2.15 2.85a.5.5 0 0 1 0-.7M3 14l.01.2A2 2 0 0 0 5 16h10q.14 0 .27-.02L11.3 12H11v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V12H5c-.77 0-1.47-.3-2-.77zm8.25-12c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 0 1 3 3v6q-.01.82-.4 1.48l-.74-.74A2 2 0 0 0 17 14v-2.77c-.53.48-1.23.77-2 .77h-.88l-1-1H15a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8.12L7 4.88V3.75C7 2.78 7.78 2 8.75 2zM5 6a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h4v-.5c0-.21.14-.4.33-.47L5.29 6zm3.75-3a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$66e4686148724f18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff24Filled', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-.95-.95q-.48.16-1.02.17H5.25A3.25 3.25 0 0 1 2 17.75v-5.04c.85.8 2 1.29 3.25 1.29H10a1 1 0 0 0 1 1h2a1 1 0 0 0 .67-.26l-3.4-3.42A1 1 0 0 0 10 12v.5H5.25a3.25 3.25 0 0 1-.3-6.48L2.23 3.28a.75.75 0 0 1 0-1.06M22 17.75q0 .49-.14.93L17.18 14h1.57c1.26 0 2.4-.5 3.25-1.29zM13.75 2C14.99 2 16 3 16 4.25V6h2.92a3.25 3.25 0 0 1-.17 6.5h-3.07L8 4.82v-.57C8 3.01 9 2 10.25 2zm-3.5 1.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$34cd80d2eaeea687 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff24Regular', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-.95-.95q-.48.16-1.02.17H5.25A3.25 3.25 0 0 1 2 17.75v-8.5c0-1.7 1.3-3.09 2.95-3.24L2.22 3.28a.75.75 0 0 1 0-1.06M3.5 17.75c0 .97.78 1.75 1.75 1.75h13.19l-4.77-4.76A1 1 0 0 1 13 15h-2a1 1 0 0 1-1-1H5.25q-.97-.02-1.75-.51zM13.75 2C14.99 2 16 3 16 4.25V6h2.75C20.55 6 22 7.46 22 9.25v8.5q0 .49-.14.93l-1.36-1.36v-3.83q-.76.5-1.75.51h-1.57l-1.5-1.5h3.07c.97 0 1.75-.78 1.75-1.75v-1.5c0-.97-.78-1.75-1.75-1.75h-8.07L8 4.82v-.57C8 3.01 9 2 10.25 2zm-8.5 5.5c-.97 0-1.75.78-1.75 1.75v1.5c0 .97.78 1.75 1.75 1.75H10V12q.01-.4.26-.68L6.44 7.5zm5-4a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$159d1f813a066944 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff28Filled', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06l-1.06-1.06q-.65.27-1.41.28H5.75A3.75 3.75 0 0 1 2 21.25v-6.83A5.2 5.2 0 0 0 5.75 16h5.75v.5c0 .83.67 1.5 1.5 1.5h2c.53 0 .99-.27 1.26-.68l-4.08-4.08a1.5 1.5 0 0 0-.68 1.26H5.75a3.75 3.75 0 0 1 0-7.5h.19L2.22 3.28a.75.75 0 0 1 0-1.06M26 21.25q0 .7-.24 1.33L19.18 16h3.07c1.47 0 2.8-.6 3.75-1.58zM16.25 2.5c1.24 0 2.25 1 2.25 2.25V7h3.75a3.75 3.75 0 0 1 0 7.5h-4.57L9.5 6.32V4.75c0-1.24 1-2.25 2.25-2.25zM11.75 4a.75.75 0 0 0-.75.75V7h6V4.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$74d72436daf6bb94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff28Regular', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06l-1.06-1.06q-.66.27-1.4.28H5.75A3.75 3.75 0 0 1 2 21.25v-10.5A3.75 3.75 0 0 1 5.75 7h.19L2.22 3.28a.75.75 0 0 1 0-1.06M3.5 21.25c0 1.24 1.01 2.25 2.25 2.25h16.68l-6.17-6.18A1.5 1.5 0 0 1 15 18h-2a1.5 1.5 0 0 1-1.5-1.5V16H5.75c-.84 0-1.62-.28-2.25-.75zM16.25 2.5c1.24 0 2.25 1 2.25 2.25V7h3.75A3.75 3.75 0 0 1 26 10.75v10.5q0 .7-.24 1.33L24.5 21.3v-6.06c-.63.47-1.4.75-2.25.75h-3.07l-1.5-1.5h4.57c1.24 0 2.25-1 2.25-2.25v-1.5c0-1.24-1-2.25-2.25-2.25H11.68L9.5 6.32V4.75c0-1.24 1-2.25 2.25-2.25zm-10.5 6c-1.24 0-2.25 1-2.25 2.25v1.5c0 1.24 1.01 2.25 2.25 2.25h5.75c0-.53.27-.99.68-1.26L7.44 8.5zm6-4.5a.75.75 0 0 0-.75.75V7h6V4.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$69c965c043a46bb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff32Filled', "32", [
    "M2.07 2.3a1 1 0 0 1 1.42 0l26 26a1 1 0 0 1-1.42 1.4l-1.78-1.77q-.38.07-.79.07h-19A4.5 4.5 0 0 1 2 23.5v-6.31A6.5 6.5 0 0 0 6.5 19H13v.5c0 .83.67 1.5 1.5 1.5h3c.5 0 .96-.25 1.23-.64l-5.1-5.09A1.5 1.5 0 0 0 13 16.5v.5H6.5a4.5 4.5 0 0 1-.23-9h.1l-4.3-4.3a1 1 0 0 1 0-1.4M30 23.5c0 .9-.27 1.75-.73 2.45L22.32 19h3.18c1.75 0 3.33-.7 4.5-1.81zM19 3a3 3 0 0 1 3 3v2h3.5a4.5 4.5 0 0 1 0 9h-5.18L10 6.68V6a3 3 0 0 1 3-3zm-6 2a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$4f705f7488408c77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff32Regular', "32", [
    "M2.07 2.3a1 1 0 0 1 1.42 0l26 26a1 1 0 0 1-1.42 1.4l-1.78-1.77q-.38.07-.79.07h-19A4.5 4.5 0 0 1 2 23.5v-11A4.5 4.5 0 0 1 6.37 8l-4.3-4.3a1 1 0 0 1 0-1.4M4 23.5A2.5 2.5 0 0 0 6.5 26h17.87l-5.64-5.64a1.5 1.5 0 0 1-1.23.64h-3a1.5 1.5 0 0 1-1.5-1.5V19H6.5q-1.4-.02-2.5-.76zM19 3a3 3 0 0 1 3 3v2h3.5a4.5 4.5 0 0 1 4.5 4.5v11c0 .9-.27 1.75-.73 2.45l-1.47-1.47q.2-.45.2-.98v-5.26q-1.1.74-2.5.76h-3.18l-2-2h5.18a2.5 2.5 0 0 0 2.5-2.5v-2a2.5 2.5 0 0 0-2.5-2.5H13.32L10 6.68V6a3 3 0 0 1 3-3zM6.5 10A2.5 2.5 0 0 0 4 12.5v2A2.5 2.5 0 0 0 6.5 17H13v-.5c0-.5.25-.96.64-1.23L8.37 10zM13 5a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1z"
]);
const $82e7c60f6344ef74$export$e210ceae68e3a13e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff48Filled', "48", [
    "M3.9 4.37a1.25 1.25 0 0 1 1.77 0l37.5 37.5a1.25 1.25 0 0 1-1.77 1.76l-2.7-2.7q-.47.06-.95.07h-27.5A6.25 6.25 0 0 1 4 34.75V23.37A8.7 8.7 0 0 0 10.25 26H20v1c0 1.1.9 2 2 2h4a2 2 0 0 0 .65-.11l-6.54-6.54A2 2 0 0 0 20 23v.5h-9.75a6.25 6.25 0 0 1-1.34-12.35L3.9 6.13a1.25 1.25 0 0 1 0-1.76M44 34.75c0 1.44-.49 2.76-1.3 3.82L30.13 26h7.62c2.45 0 4.66-1 6.25-2.63zM27.75 4C30.1 4 32 5.9 32 8.25V11h5.75a6.25 6.25 0 0 1 0 12.5H28V23a2 2 0 0 0-2-2h-.87l-10-10H16V8.25C16 5.9 17.9 4 20.25 4zm-7.5 2.5c-.97 0-1.75.78-1.75 1.75V11h11V8.25c0-.97-.78-1.75-1.75-1.75z"
]);
const $82e7c60f6344ef74$export$b068d1d7da6f3326 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseOff48Regular', "48", [
    "M3.9 4.37a1.25 1.25 0 0 1 1.77 0l37.5 37.5a1.25 1.25 0 0 1-1.77 1.76l-2.7-2.7q-.47.06-.95.07h-27.5A6.25 6.25 0 0 1 4 34.75v-17.5c0-3 2.1-5.5 4.9-6.1l-5-5.02a1.25 1.25 0 0 1 0-1.76M27.75 4C30.1 4 32 5.9 32 8.25V11h5.75C41.2 11 44 13.8 44 17.25v17.5c0 1.44-.49 2.76-1.3 3.82l-1.8-1.8q.59-.88.6-2.02v-10A6.2 6.2 0 0 1 37.75 26h-7.62l-2.5-2.5h10.12a3.75 3.75 0 0 0 3.75-3.75v-2.5a3.75 3.75 0 0 0-3.75-3.75H17.63l-2.5-2.5H16V8.25C16 5.9 17.9 4 20.25 4zM6.5 34.75a3.75 3.75 0 0 0 3.75 3.75h26.01l-9.6-9.61A2 2 0 0 1 26 29h-4a2 2 0 0 1-2-2v-1h-9.75c-1.4 0-2.7-.47-3.75-1.25zm3.75-21.25a3.75 3.75 0 0 0-3.75 3.75v2.5a3.75 3.75 0 0 0 3.75 3.75H20V23a2 2 0 0 1 .1-.65l-8.84-8.85zm10-7c-.97 0-1.75.78-1.75 1.75V11h11V8.25c0-.97-.78-1.75-1.75-1.75z"
]);
const $82e7c60f6344ef74$export$c23b3859b773fc0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcasePerson24Filled', "24", [
    "M21.23 17c.98 0 1.77.8 1.77 1.77v.1c0 1.56-1.29 3.13-4.5 3.13S14 20.44 14 18.88v-.1c0-.99.8-1.78 1.77-1.78zM2 12.71c.85.8 2 1.29 3.25 1.29H10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h1.04a3.5 3.5 0 0 0 1.01 2h-.28A2.77 2.77 0 0 0 13 18.77v.1c0 .74.21 1.48.66 2.13H5.25A3.25 3.25 0 0 1 2 17.75zM18.5 11a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-4.75-9C14.99 2 16 3 16 4.25V6h2.92a3.25 3.25 0 0 1 2.33 5.33 3.5 3.5 0 0 0-6.1 1.17H14V12a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.5H5.25a3.25 3.25 0 0 1 0-6.5H8V4.25C8 3.01 9 2 10.25 2zm-3.5 1.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$2d858d8c32befc27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcasePerson24Regular', "24", [
    "M21.23 17c.98 0 1.77.8 1.77 1.77v.1c0 1.56-1.29 3.13-4.5 3.13S14 20.44 14 18.88v-.1c0-.99.8-1.78 1.77-1.78zM13.75 2C14.99 2 16 3 16 4.25V6h2.75C20.55 6 22 7.46 22 9.25v4.25a3.5 3.5 0 0 0-1.5-2.87V9.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v1.5c0 .97.78 1.75 1.75 1.75H10V12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h1.15a3.5 3.5 0 0 0-.11 1.5H14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1H5.25q-.97-.02-1.75-.51v4.26c0 .97.78 1.75 1.75 1.75h7.8q.15.8.61 1.5H5.25A3.25 3.25 0 0 1 2 17.75v-8.5C2 7.45 3.46 6 5.25 6H8V4.25C8 3.01 9 2 10.25 2zm4.75 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-8.25-7.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$c2b13ba71984108f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseSearch20Filled', "20", [
    "M4.5 10a3.5 3.5 0 0 1 2.8 5.6l2.55 2.55a.5.5 0 1 1-.7.7L6.6 16.3q-.9.68-2.1.7a3.5 3.5 0 1 1 0-7M18 14a3 3 0 0 1-3 3h-4.88l-1.56-1.56A4.5 4.5 0 0 0 8.97 13h1.53a.5.5 0 0 0 .5-.5V12h4c1.2 0 2.27-.53 3-1.36zM4.5 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m6.75-9c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 1 1 0 6h-4v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.5h-.76a4.5 4.5 0 0 0-5.83-1.49A3 3 0 0 1 5 5h2V3.75C7 2.78 7.78 2 8.75 2zm-2.5 1a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$b8251ce36861aebc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseSearch20Regular', "20", [
    "M4.5 10a3.5 3.5 0 0 1 2.8 5.6l2.55 2.55a.5.5 0 1 1-.7.7L6.6 16.3q-.9.68-2.1.7a3.5 3.5 0 1 1 0-7m6.75-8c.97 0 1.75.78 1.75 1.75V5h2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-4.88l-1-1H15a2 2 0 0 0 2-2v-2.77c-.53.48-1.23.77-2 .77h-4v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v.5h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v1q0 .13.02.25-.54.2-1.02.5V8a3 3 0 0 1 3-3h2V3.75C7 2.78 7.78 2 8.75 2zM4.5 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.25-8a.75.75 0 0 0-.75.75V5h4V3.75a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$558a6a8045fe091e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseSearch24Filled', "24", [
    "M5.5 12a4.5 4.5 0 0 1 3.67 7.1l2.61 2.62a.75.75 0 1 1-1.06 1.06l-2.61-2.61A4.5 4.5 0 1 1 5.5 12M22 17.75c0 1.8-1.46 3.25-3.25 3.25h-6.28l-2.04-2.05a5.5 5.5 0 0 0 .35-3.97L11 15h2a1 1 0 0 0 1-1h4.75c1.26 0 2.4-.5 3.25-1.29zM5.5 13.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M13.75 2C14.99 2 16 3 16 4.25V6h2.92a3.25 3.25 0 0 1-.17 6.5H14V12a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.5h-.73a5.5 5.5 0 0 0-6.26-.9A3.24 3.24 0 0 1 5.25 6H8V4.25C8 3.01 9 2 10.25 2zm-3.5 1.5a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$cfc69a5e8161b8ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BriefcaseSearch24Regular', "24", [
    "M5.5 12a4.5 4.5 0 0 1 3.67 7.1l2.61 2.62a.75.75 0 1 1-1.06 1.06l-2.61-2.61A4.5 4.5 0 1 1 5.5 12m8.25-10C14.99 2 16 3 16 4.25V6h2.75C20.55 6 22 7.46 22 9.25v8.5c0 1.8-1.46 3.25-3.25 3.25h-6.28l-1.5-1.5h7.78c.97 0 1.75-.78 1.75-1.75v-4.26q-.76.5-1.75.51H14a1 1 0 0 1-1 1h-2l-.22-.02a6 6 0 0 0-.78-1.64V12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h4.75c.97 0 1.75-.78 1.75-1.75v-1.5c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v1.5q0 .3.1.59a6 6 0 0 0-1.6.92V9.25C2 7.45 3.46 6 5.25 6H8V4.25C8 3.01 9 2 10.25 2zM5.5 13.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m4.75-10a.75.75 0 0 0-.75.75V6h5V4.25a.75.75 0 0 0-.75-.75z"
]);
const $82e7c60f6344ef74$export$a702138ea93242df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh16Filled', "16", [
    "M8.5 1.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z",
    "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 6v4a2 2 0 1 0 0-4",
    "M15 8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5",
    "M8.5 13.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z",
    "M3 8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5",
    "M3.85 3.15a.5.5 0 0 0-.7.7l1 1a.5.5 0 1 0 .7-.7z",
    "M3.15 12.85c.2.2.5.2.7 0l1-1a.5.5 0 1 0-.7-.7l-1 1a.5.5 0 0 0 0 .7",
    "M12.15 3.15a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7z",
    "M12.85 12.85a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l1 1c.2.2.2.5 0 .7"
]);
const $82e7c60f6344ef74$export$e25cb16aa0fc1f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh16Regular', "16", [
    "M8 1c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6.5-1.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zM8 13c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M2.5 8.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm.65-5.35c.2-.2.5-.2.7 0l1 1a.5.5 0 1 1-.7.7l-1-1a.5.5 0 0 1 0-.7m.7 9.7a.5.5 0 1 1-.7-.7l1-1a.5.5 0 1 1 .7.7zm9-9.7a.5.5 0 0 0-.7 0l-1 1a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0 0-.7m-.7 9.7a.5.5 0 0 0 .7-.7l-1-1a.5.5 0 0 0-.7.7z"
]);
const $82e7c60f6344ef74$export$787a98d36d460072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh20Filled', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM10 6a4 4 0 1 1 0 8 4 4 0 0 1 0-8m3 4a3 3 0 0 0-3-3v6a3 3 0 0 0 3-3m5 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5m-7.5 6.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM4 10a.5.5 0 0 1-.5.5H2.46a.5.5 0 0 1 0-1H3.5c.28 0 .5.22.5.5m.85-5.85a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7zm-.7 11.7c.2.2.5.2.7 0l1-1a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 0 .7m11-11.7a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7zm.7 11.7a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l1 1c.2.2.2.5 0 .7"
]);
const $82e7c60f6344ef74$export$179df1cf62499a69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh20Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6m7.5-2.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zM10 16c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-6.5-5.5a.5.5 0 0 0 0-1H2.46a.5.5 0 0 0 0 1zm.65-6.35c.2-.2.5-.2.7 0l1 1a.5.5 0 1 1-.7.7l-1-1a.5.5 0 0 1 0-.7m.7 11.7a.5.5 0 0 1-.7-.7l1-1a.5.5 0 0 1 .7.7zm11-11.7a.5.5 0 0 0-.7 0l-1 1a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0 0-.7m-.7 11.7a.5.5 0 0 0 .7-.7l-1-1a.5.5 0 0 0-.7.7z"
]);
const $82e7c60f6344ef74$export$9829c5944634fa67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh24Filled', "24", [
    "M12.75 2.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1.5 0A3.5 3.5 0 0 0 12 8.5v7a3.5 3.5 0 0 0 3.5-3.5m6.5 0c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75m-9.25 7.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM5 12c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75m.28-7.78a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06zM4.22 19.78c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 0 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06m14.5-15.56a.75.75 0 1 1 1.06 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06zm1.06 15.56c-.3.3-.77.3-1.06 0l-1.5-1.5a.75.75 0 0 1 1.06-1.06l1.5 1.5c.3.3.3.77 0 1.06"
]);
const $82e7c60f6344ef74$export$105035c61b823257 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh24Regular', "24", [
    "M12 2c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m0 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m9.25-2.75a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5zM12 19c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m-7.75-6.25a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5zm-.03-8.53c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06m1.06 15.56a.75.75 0 1 1-1.06-1.06l1.5-1.5a.75.75 0 1 1 1.06 1.06zm14.5-15.56a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 0 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06m-1.06 15.56a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 1 0-1.06 1.06z"
]);
const $82e7c60f6344ef74$export$8a91bd7d6034d64c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh28Filled', "28", [
    "M14.75 2.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM20 14a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-1.5 0A4.5 4.5 0 0 0 14 9.5v9a4.5 4.5 0 0 0 4.5-4.5m7.5 0c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75m-11.25 9.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM5 14c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75m1.28-8.78a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06zM5.22 22.78c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 1 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06m16.5-17.56a.75.75 0 1 1 1.06 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06zm1.06 17.56c-.3.3-.77.3-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06l1.5 1.5c.3.3.3.77 0 1.06"
]);
const $82e7c60f6344ef74$export$a66fa6f08e5415d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh28Regular', "28", [
    "M14 2c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.33-.75.75-.75m0 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-1.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m11.25-3.75a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5zM14 23c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.33-.75.75-.75m-9.75-8.25a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5zm.97-9.53c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06m1.06 17.56a.75.75 0 0 1-1.06-1.06l1.5-1.5a.75.75 0 0 1 1.06 1.06zm16.5-17.56a.75.75 0 0 0-1.06 0l-1.5 1.5a.75.75 0 0 0 1.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06m-1.05 17.57a.75.75 0 1 0 1.06-1.06l-1.51-1.51a.75.75 0 1 0-1.06 1.06z"
]);
const $82e7c60f6344ef74$export$fd9e21b227325a52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh32Filled', "32", [
    "M17 3a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0zm6 13a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-2 0a5 5 0 0 0-5-5v10a5 5 0 0 0 5-5m9 0a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1M17 27a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0zM6 16a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m.7-10.7a1 1 0 1 0-1.4 1.4l2 2a1 1 0 0 0 1.4-1.4zM5.3 26.7a1 1 0 0 0 1.4 0l2-2a1 1 0 1 0-1.4-1.4l-2 2a1 1 0 0 0 0 1.4m20-21.4a1 1 0 0 1 1.4 1.4l-2 2a1 1 0 0 1-1.4-1.4zm0 21.4-2-2a1 1 0 0 1 1.4-1.4l2 2a1 1 0 0 1-1.4 1.4"
]);
const $82e7c60f6344ef74$export$2225c85a5971dac7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh32Regular', "32", [
    "M16 2a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1m0 21a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-2a5 5 0 1 1 0-10 5 5 0 0 1 0 10m13-4a1 1 0 0 0 0-2h-2a1 1 0 1 0 0 2zm-13 9a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1M5 17a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm.3-11.7a1 1 0 0 1 1.4 0l2 2a1 1 0 0 1-1.4 1.4l-2-2a1 1 0 0 1 0-1.4m1.4 21.4a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 1.4zm20-21.4a1 1 0 0 0-1.4 0l-2 2a1 1 0 0 0 1.4 1.4l2-2a1 1 0 0 0 0-1.4m-3.4 19.4 2 2a1 1 0 0 0 1.4-1.4l-2-2a1 1 0 0 0-1.4 1.4"
]);
const $82e7c60f6344ef74$export$9c66d98c1e5cc2af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh48Filled', "48", [
    "M25.25 5.25a1.25 1.25 0 1 0-2.5 0v2.5a1.25 1.25 0 0 0 2.5 0zm8.77 18.8a9.98 9.98 0 1 1-19.95 0 9.98 9.98 0 0 1 19.95 0m-2.5 0a7.5 7.5 0 0 0-7.47-7.48H24v14.95h.05a7.5 7.5 0 0 0 7.47-7.47M44 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 0 1 0-2.5h2.5c.7 0 1.25.56 1.25 1.25M25.25 40.25a1.25 1.25 0 1 0-2.5 0v2.5a1.25 1.25 0 0 0 2.5 0zM9 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 0 1 0-2.5h2.5c.7 0 1.25.56 1.25 1.25m2.13-14.63a1.25 1.25 0 1 0-1.76 1.76l2.5 2.5a1.25 1.25 0 0 0 1.76-1.76zM9.37 38.63c.48.5 1.28.5 1.76 0l2.5-2.5a1.25 1.25 0 1 0-1.76-1.76l-2.5 2.5a1.25 1.25 0 0 0 0 1.76m27.5-29.26a1.25 1.25 0 1 1 1.76 1.76l-2.5 2.5a1.25 1.25 0 0 1-1.76-1.76zm1.76 29.26c-.48.5-1.28.5-1.76 0l-2.5-2.5a1.25 1.25 0 1 1 1.76-1.76l2.5 2.5c.5.48.5 1.28 0 1.76"
]);
const $82e7c60f6344ef74$export$13ab8ab5fdf72de4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessHigh48Regular', "48", [
    "M24 4c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 1 1-2.5 0v-2.5c0-.69.56-1.25 1.25-1.25m.05 30.02a9.98 9.98 0 1 0 0-19.95 9.98 9.98 0 0 0 0 19.95m0-2.5a7.48 7.48 0 1 1 0-14.95 7.48 7.48 0 0 1 0 14.95m18.7-6.27a1.25 1.25 0 0 0 0-2.5h-2.5a1.25 1.25 0 0 0 0 2.5zM24 39c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 0 1-2.5 0v-2.5c0-.7.56-1.25 1.25-1.25M7.75 25.25a1.25 1.25 0 0 0 0-2.5h-2.5a1.25 1.25 0 1 0 0 2.5zM9.37 9.37a1.25 1.25 0 0 1 1.76 0l2.5 2.5a1.25 1.25 0 1 1-1.76 1.76l-2.5-2.5a1.25 1.25 0 0 1 0-1.76m1.76 29.26a1.25 1.25 0 0 1-1.76-1.76l2.5-2.5a1.25 1.25 0 1 1 1.76 1.76zm27.5-29.26a1.25 1.25 0 0 0-1.76 0l-2.5 2.5a1.25 1.25 0 1 0 1.76 1.76l2.5-2.5c.5-.48.5-1.28 0-1.76m-1.76 29.26a1.25 1.25 0 0 0 1.76-1.76l-2.5-2.5a1.25 1.25 0 1 0-1.76 1.76z"
]);
const $82e7c60f6344ef74$export$bdb01e56bce620f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow16Filled', "16", [
    "M8.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6m2 3a2 2 0 0 0-2-2v4a2 2 0 0 0 2-2m4 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5m-5.5 4.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM4 8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5m.35-4.35a.5.5 0 0 0-.7.7l.5.5a.5.5 0 1 0 .7-.7zm-.7 8.7c.2.2.5.2.7 0l.5-.5a.5.5 0 1 0-.7-.7l-.5.5a.5.5 0 0 0 0 .7m8-8.7a.5.5 0 0 1 .7.7l-.5.5a.5.5 0 0 1-.7-.7zm0 8.7-.5-.5a.5.5 0 0 1 .7-.7l.5.5a.5.5 0 0 1-.7.7"
]);
const $82e7c60f6344ef74$export$bb1c99d2a997c155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow16Regular', "16", [
    "M8 2c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4m5.5-1.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zM8 12c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M3.5 8.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm.15-4.85c.2-.2.5-.2.7 0l.5.5a.5.5 0 1 1-.7.7l-.5-.5a.5.5 0 0 1 0-.7m.7 8.7a.5.5 0 1 1-.7-.7l.5-.5a.5.5 0 1 1 .7.7zm8-8.7a.5.5 0 0 0-.7 0l-.5.5a.5.5 0 0 0 .7.7l.5-.5a.5.5 0 0 0 0-.7m-1.2 8.2.5.5a.5.5 0 0 0 .7-.7l-.5-.5a.5.5 0 0 0-.7.7"
]);
const $82e7c60f6344ef74$export$34e2cc45525f3b64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow20Filled', "20", [
    "M10 3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 7V7a3 3 0 1 1 0 6m6.5-2.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zM10 15c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-5.5-4.5a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm.65-5.35c.2-.2.5-.2.7 0l.5.5a.5.5 0 1 1-.7.7l-.5-.5a.5.5 0 0 1 0-.7m.7 9.7a.5.5 0 0 1-.7-.7l.5-.5a.5.5 0 0 1 .7.7zm9-9.7a.5.5 0 0 0-.7 0l-.5.5a.5.5 0 0 0 .7.7l.5-.5a.5.5 0 0 0 0-.7m-.7 9.7a.5.5 0 0 0 .7-.7l-.5-.5a.5.5 0 0 0-.7.7z"
]);
const $82e7c60f6344ef74$export$cbd93fb67c9ed452 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow20Regular', "20", [
    "M10.5 3.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM10 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m10 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5m-6.5 5.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM5 10a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5m.85-4.85a.5.5 0 1 0-.7.7l.5.5a.5.5 0 1 0 .7-.7zm-.7 9.7c.2.2.5.2.7 0l.5-.5a.5.5 0 0 0-.7-.7l-.5.5a.5.5 0 0 0 0 .7m9-9.7a.5.5 0 0 1 .7.7l-.5.5a.5.5 0 0 1-.7-.7zm.7 9.7a.5.5 0 0 1-.7 0l-.5-.5a.5.5 0 0 1 .7-.7l.5.5c.2.2.2.5 0 .7"
]);
const $82e7c60f6344ef74$export$f42c914d00d4f7f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow24Filled', "24", [
    "M12.75 4.25a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zM17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1.5 0A3.5 3.5 0 0 0 12 8.5v7a3.5 3.5 0 0 0 3.5-3.5m5 0c0 .41-.34.75-.75.75h-1a.75.75 0 0 1 0-1.5h1c.41 0 .75.34.75.75m-7.75 6.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zM6 12c0 .41-.34.75-.75.75h-1a.75.75 0 0 1 0-1.5h1c.41 0 .75.34.75.75m1.28-5.78a.75.75 0 0 0-1.06 1.06l.5.5a.75.75 0 0 0 1.06-1.06zM6.22 17.78c.3.3.77.3 1.06 0l.5-.5a.75.75 0 1 0-1.06-1.06l-.5.5c-.3.3-.3.77 0 1.06m10.5-11.56a.75.75 0 1 1 1.06 1.06l-.5.5a.75.75 0 1 1-1.06-1.06zm1.06 11.56c-.3.3-.77.3-1.06 0l-.5-.5a.75.75 0 1 1 1.06-1.06l.5.5c.3.3.3.77 0 1.06"
]);
const $82e7c60f6344ef74$export$2ee3178246c22988 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow24Regular', "24", [
    "M12 3.5c.41 0 .75.34.75.75v1a.75.75 0 0 1-1.5 0v-1c0-.41.34-.75.75-.75M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m7.75-2.75a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5zM12 18c.41 0 .75.34.75.75v1a.75.75 0 0 1-1.5 0v-1c0-.41.34-.75.75-.75m-6.75-5.25a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5zm.97-6.53c.3-.3.77-.3 1.06 0l.5.5a.75.75 0 0 1-1.06 1.06l-.5-.5a.75.75 0 0 1 0-1.06m1.06 11.56a.75.75 0 0 1-1.06-1.06l.5-.5a.75.75 0 0 1 1.06 1.06zm10.5-11.56a.75.75 0 0 0-1.06 0l-.5.5a.75.75 0 0 0 1.06 1.06l.5-.5c.3-.3.3-.77 0-1.06m-1.06 11.56a.75.75 0 1 0 1.06-1.06l-.5-.5a.75.75 0 1 0-1.06 1.06z"
]);
const $82e7c60f6344ef74$export$71243db7f9fe481b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow28Filled', "28", [
    "M14.75 4.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM20 14a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-1.5 0A4.5 4.5 0 0 0 14 9.5v9a4.5 4.5 0 0 0 4.5-4.5m5.5 0c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75m-9.25 7.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM7 14c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75m.78-7.28a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06-1.06zM6.72 21.28c.3.3.77.3 1.06 0l1-1a.75.75 0 1 0-1.06-1.06l-1 1c-.3.3-.3.77 0 1.06m13.5-14.56a.75.75 0 1 1 1.06 1.06l-1 1a.75.75 0 1 1-1.06-1.06zm1.06 14.56c-.3.3-.77.3-1.06 0l-.99-.99a.75.75 0 1 1 1.06-1.06l.99.99c.3.3.3.77 0 1.06"
]);
const $82e7c60f6344ef74$export$2fb0f653868ac70e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow28Regular', "28", [
    "M14 4c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.33-.75.75-.75m0 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-1.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m9.25-3.75a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5zM14 21c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.33-.75.75-.75m-7.75-6.25a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5zm.47-8.03c.3-.3.77-.3 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m1.06 14.56a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 1.06zm13.5-14.56a.75.75 0 0 0-1.06 0l-1 1a.75.75 0 0 0 1.06 1.06l1-1c.3-.3.3-.77 0-1.06m-1.06 14.56a.75.75 0 1 0 1.06-1.06l-.99-.99a.75.75 0 1 0-1.06 1.06z"
]);
const $82e7c60f6344ef74$export$b8039ed9841ee058 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow32Filled', "32", [
    "M17 5a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0zm6 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-2 0a5 5 0 0 0-5-5v10a5 5 0 0 0 5-5m7 0a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-11 9a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0zm-9-9a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m.7-8.7a1 1 0 0 0-1.4 1.4l1 1a1 1 0 0 0 1.4-1.4zM7.3 24.7a1 1 0 0 0 1.4 0l1-1a1 1 0 1 0-1.4-1.4l-1 1a1 1 0 0 0 0 1.4m16-17.4a1 1 0 0 1 1.4 1.4l-1 1a1 1 0 0 1-1.4-1.4zm0 17.4-1-1a1 1 0 0 1 1.4-1.4l1 1a1 1 0 0 1-1.4 1.4"
]);
const $82e7c60f6344ef74$export$ebb4400c72a75736 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow32Regular', "32", [
    "M16 4a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1m0 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-2a5 5 0 1 1 0-10 5 5 0 0 1 0 10m11-4a1 1 0 0 0 0-2h-2a1 1 0 1 0 0 2zm-11 7a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m-9-7a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2zm.3-9.7a1 1 0 0 1 1.4 0l1 1a1 1 0 1 1-1.4 1.4l-1-1a1 1 0 0 1 0-1.4m1.4 17.4a1 1 0 0 1-1.4-1.4l1-1a1 1 0 0 1 1.4 1.4zm16-17.4a1 1 0 0 0-1.4 0l-1 1a1 1 0 0 0 1.4 1.4l1-1a1 1 0 0 0 0-1.4m-2.4 16.4 1 1a1 1 0 0 0 1.4-1.4l-1-1a1 1 0 0 0-1.4 1.4"
]);
const $82e7c60f6344ef74$export$b86aec3159f5266f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow48Filled', "48", [
    "M25.25 8.25a1.25 1.25 0 1 0-2.5 0v2.5a1.25 1.25 0 0 0 2.5 0zm8.77 15.8a9.98 9.98 0 1 1-19.95 0 9.98 9.98 0 0 1 19.95 0m-2.5 0a7.5 7.5 0 0 0-7.47-7.48H24v14.95h.05a7.5 7.5 0 0 0 7.47-7.47M41 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 0 1 0-2.5h2.5c.7 0 1.25.56 1.25 1.25M25.25 37.25a1.25 1.25 0 1 0-2.5 0v2.5a1.25 1.25 0 0 0 2.5 0zM12 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 1 1 0-2.5h2.5c.7 0 1.25.56 1.25 1.25m2.13-11.63a1.25 1.25 0 0 0-1.76 1.76l1.5 1.5a1.25 1.25 0 0 0 1.76-1.76zm-1.76 23.26c.48.5 1.28.5 1.76 0l1.5-1.5a1.25 1.25 0 1 0-1.76-1.76l-1.5 1.5a1.25 1.25 0 0 0 0 1.76m21.5-23.26a1.25 1.25 0 0 1 1.76 1.76l-1.5 1.5a1.25 1.25 0 0 1-1.76-1.76zm1.76 23.26c-.48.5-1.28.5-1.76 0l-1.5-1.5a1.25 1.25 0 1 1 1.76-1.76l1.5 1.5c.5.48.5 1.28 0 1.76"
]);
const $82e7c60f6344ef74$export$5140d0dab98d150f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrightnessLow48Regular', "48", [
    "M24 7c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 1 1-2.5 0v-2.5c0-.69.56-1.25 1.25-1.25m.05 27.02a9.98 9.98 0 1 0 0-19.95 9.98 9.98 0 0 0 0 19.95m0-2.5a7.48 7.48 0 1 1 0-14.95 7.48 7.48 0 0 1 0 14.95m15.7-6.27a1.25 1.25 0 1 0 0-2.5h-2.5a1.25 1.25 0 0 0 0 2.5zM24 36c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 0 1-2.5 0v-2.5c0-.69.56-1.25 1.25-1.25M10.75 25.25a1.25 1.25 0 1 0 0-2.5h-2.5a1.25 1.25 0 1 0 0 2.5zm1.62-12.88a1.25 1.25 0 0 1 1.76 0l1.5 1.5a1.25 1.25 0 1 1-1.76 1.76l-1.5-1.5a1.25 1.25 0 0 1 0-1.76m1.76 23.26a1.25 1.25 0 0 1-1.76-1.76l1.5-1.5a1.25 1.25 0 0 1 1.76 1.76zm21.5-23.26a1.25 1.25 0 0 0-1.76 0l-1.5 1.5a1.25 1.25 0 1 0 1.76 1.76l1.5-1.5c.5-.48.5-1.28 0-1.76m-1.76 23.26a1.25 1.25 0 0 0 1.76-1.76l-1.5-1.5a1.25 1.25 0 0 0-1.76 1.76z"
]);
const $82e7c60f6344ef74$export$d163837f2f76ca93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_16_color__a)",
            "d": "M12.5 8.83a1 1 0 0 0-1 0l-2 1.15a1 1 0 0 0-.5.87v2.3c0 .35.2.68.5.86l2 1.15a1 1 0 0 0 1 0L14.48 14a1 1 0 0 0 .5-.87v-2.3a1 1 0 0 0-.5-.86z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_16_color__b)",
            "d": "M4 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_16_color__c)",
            "d": "M10.5 1C9.67 1 9 1.67 9 2.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_16_color__d)",
            "d": "M2.91 1.67c.45-.9 1.73-.9 2.18 0l1.78 3.54c.4.82-.18 1.79-1.1 1.79H2.23c-.9 0-1.5-.97-1.09-1.79z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_16_color__a",
                "x1": "5.52",
                "x2": "13.62",
                "y1": "5.95",
                "y2": "14.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_16_color__b",
                "x1": "1",
                "x2": "7",
                "y1": "9",
                "y2": "15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_16_color__c",
                "x1": "6.5",
                "x2": "13.88",
                "y1": "-2",
                "y2": "7.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_16_color__d",
                "x1": "1.21",
                "x2": "5.36",
                "y1": "2.13",
                "y2": "6.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f24a9d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$635e4699078fc326 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity16Filled', "16", [
    "M2.47 1.45a1.71 1.71 0 0 1 3.06 0l1.78 3.54A1.73 1.73 0 0 1 5.78 7.5H2.22A1.73 1.73 0 0 1 .7 4.99zM9 2.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 9 5.5zm2.5 6.33a1 1 0 0 1 1 0l1.98 1.15c.31.18.5.5.5.87v2.3a1 1 0 0 1-.5.86l-1.98 1.15a1 1 0 0 1-1 0L9.5 14a1 1 0 0 1-.5-.87v-2.3a1 1 0 0 1 .5-.86zM1 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
]);
const $82e7c60f6344ef74$export$968e794f16c20793 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity16Regular', "16", [
    "M5.09 1.67c-.45-.9-1.73-.9-2.18 0L1.13 5.21C.73 6.03 1.31 7 2.23 7h3.55c.9 0 1.5-.97 1.09-1.79zm-1.28.45c.08-.16.3-.16.38 0l1.78 3.54a.23.23 0 0 1-.2.34H2.23a.23.23 0 0 1-.2-.34zM10.5 1C9.67 1 9 1.67 9 2.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM10 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM4 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11.5-3.17a1 1 0 0 0-1 0l-2 1.15a1 1 0 0 0-.5.87v2.3c0 .35.2.68.5.86l2 1.15a1 1 0 0 0 1 0L14.48 14a1 1 0 0 0 .5-.87v-2.3a1 1 0 0 0-.5-.86zm-.5.87 1.98 1.15v2.3L12 14.28l-2-1.15v-2.3z"
]);
const $82e7c60f6344ef74$export$cecba2ba4cd7c281 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_20_color__a)",
            "d": "M14.5 10.83a1 1 0 0 0-1 0l-2 1.15a1 1 0 0 0-.5.87v2.3c0 .35.2.68.5.86l2 1.15a1 1 0 0 0 1 0L16.48 16a1 1 0 0 0 .5-.87v-2.3a1 1 0 0 0-.5-.86z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_20_color__b)",
            "d": "M6 11a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_20_color__c)",
            "d": "M12.5 3c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_20_color__d)",
            "d": "M4.91 3.67c.45-.9 1.73-.9 2.18 0l1.78 3.54c.4.82-.18 1.79-1.1 1.79H4.23c-.9 0-1.5-.97-1.09-1.79z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_20_color__a",
                "x1": "7.52",
                "x2": "15.62",
                "y1": "7.95",
                "y2": "16.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_20_color__b",
                "x1": "3",
                "x2": "9",
                "y1": "11",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_20_color__c",
                "x1": "8.5",
                "x2": "15.88",
                "y1": "0",
                "y2": "9.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_20_color__d",
                "x1": "3.21",
                "x2": "7.36",
                "y1": "4.13",
                "y2": "8.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f24a9d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$d822a150a27f24c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity20Filled', "20", [
    "M4.47 3.45a1.71 1.71 0 0 1 3.06 0l1.78 3.54A1.73 1.73 0 0 1 7.78 9.5H4.22A1.73 1.73 0 0 1 2.7 6.99zM11 4.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 11 7.5zm2.5 6.33a1 1 0 0 1 1 0l1.98 1.15c.31.18.5.5.5.87v2.3a1 1 0 0 1-.5.86l-1.98 1.15a1 1 0 0 1-1 0l-2-1.15a1 1 0 0 1-.5-.87v-2.3a1 1 0 0 1 .5-.86zM3 14a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
]);
const $82e7c60f6344ef74$export$d185d67883cb8eee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity20Regular', "20", [
    "M7.09 3.67c-.45-.9-1.73-.9-2.18 0L3.13 7.21c-.4.82.18 1.79 1.1 1.79h3.55c.9 0 1.5-.97 1.09-1.79zm-1.28.45c.08-.16.3-.16.38 0l1.78 3.54a.23.23 0 0 1-.2.34H4.23a.23.23 0 0 1-.2-.34zM12.5 3c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM12 4.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM6 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11.5-3.17a1 1 0 0 0-1 0l-2 1.15a1 1 0 0 0-.5.87v2.3c0 .35.2.68.5.86l2 1.15a1 1 0 0 0 1 0L16.48 16a1 1 0 0 0 .5-.87v-2.3a1 1 0 0 0-.5-.86zm-.5.87 1.98 1.15v2.3L14 16.28l-2-1.15v-2.3z"
]);
const $82e7c60f6344ef74$export$9580ba7d81a5aef6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_24_color__a)",
            "d": "M17.63 12.74a1.3 1.3 0 0 0-1.25 0l-2.75 1.6c-.39.21-.63.63-.63 1.07v3.18c0 .44.24.86.63 1.08l2.74 1.59c.4.22.87.22 1.25 0l2.75-1.6c.39-.21.63-.63.63-1.07V15.4c0-.44-.24-.86-.63-1.08z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_24_color__b)",
            "d": "M15.25 3C14.01 3 13 4 13 5.25v3.5C13 9.99 14 11 15.25 11h3.5C19.99 11 21 10 21 8.75v-3.5C21 4.01 20 3 18.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_24_color__c)",
            "d": "M7 13a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_24_color__d)",
            "d": "M5.55 3.9c.6-1.2 2.3-1.2 2.9 0l2.37 4.71A1.64 1.64 0 0 1 9.37 11H4.63c-1.22 0-2-1.3-1.45-2.39z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_24_color__a",
                "x1": "8.34",
                "x2": "19.21",
                "y1": "8.89",
                "y2": "20.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_24_color__b",
                "x1": "9.67",
                "x2": "19.5",
                "y1": "-1",
                "y2": "11.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_24_color__c",
                "x1": "3",
                "x2": "11",
                "y1": "13",
                "y2": "21",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_24_color__d",
                "x1": "3.29",
                "x2": "8.81",
                "y1": "4.5",
                "y2": "10.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f24a9d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$95cf00f9cbe7d44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity24Filled', "24", [
    "M15.25 3C14.01 3 13 4 13 5.25v3.5C13 9.99 14 11 15.25 11h3.5C19.99 11 21 10 21 8.75v-3.5C21 4.01 20 3 18.75 3zm-6.8.9c-.6-1.2-2.3-1.2-2.9 0L3.18 8.6A1.64 1.64 0 0 0 4.63 11h4.74c1.22 0 2-1.3 1.45-2.39zM3 17a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13.38-4.26c.38-.22.86-.22 1.25 0l2.74 1.6c.39.21.63.63.63 1.07v3.18c0 .44-.24.86-.63 1.08l-2.75 1.59c-.38.22-.86.22-1.25 0l-2.74-1.6A1.3 1.3 0 0 1 13 18.6V15.4c0-.44.24-.86.63-1.08z"
]);
const $82e7c60f6344ef74$export$254b88bd31b081cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity24Regular', "24", [
    "M13 5.25C13 4.01 14 3 15.25 3h3.5C19.99 3 21 4 21 5.25v3.5C21 9.99 20 11 18.75 11h-3.5C14.01 11 13 10 13 8.75zm2.25-.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zm-6.8-.6c-.6-1.2-2.3-1.2-2.9 0L3.18 8.6A1.64 1.64 0 0 0 4.63 11h4.74c1.22 0 2-1.3 1.45-2.39zm-1.56.67q.03-.05.05-.05L7 4.5q.04 0 .06.02.02 0 .05.05L9.48 9.3q.02.05.02.07a.2.2 0 0 1-.07.13l-.06.01H4.63l-.06-.01-.05-.05-.02-.08q0-.02.02-.07zM4.5 17a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M7 13a4 4 0 1 0 0 8 4 4 0 0 0 0-8m10.63-.26a1.3 1.3 0 0 0-1.25 0l-2.75 1.6c-.39.21-.63.63-.63 1.07v3.18c0 .44.24.86.63 1.08l2.74 1.59c.4.22.87.22 1.25 0l2.75-1.6c.39-.21.63-.63.63-1.07V15.4c0-.44-.24-.86-.63-1.08zm-3.13 2.82 2.5-1.44 2.5 1.44v2.88L17 19.88l-2.5-1.44z"
]);
const $82e7c60f6344ef74$export$59c8886eef88c20a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_28_color__a)",
            "d": "M20.62 14.6a1.3 1.3 0 0 0-1.25 0l-3.74 2.16c-.39.22-.62.63-.62 1.08v4.32c0 .45.23.86.62 1.08l3.74 2.17c.4.22.87.22 1.25 0l3.75-2.17c.39-.22.62-.63.62-1.08v-4.32c0-.45-.23-.86-.62-1.08z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_28_color__b)",
            "d": "M8 15a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_28_color__c)",
            "d": "M17.75 3A2.75 2.75 0 0 0 15 5.75v4.5A2.75 2.75 0 0 0 17.75 13h4.5A2.75 2.75 0 0 0 25 10.25v-4.5A2.75 2.75 0 0 0 22.25 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_28_color__d)",
            "d": "M9.81 4.12a2.02 2.02 0 0 0-3.62 0l-2.97 5.9A2.05 2.05 0 0 0 5.04 13h5.92c1.52 0 2.5-1.62 1.82-2.98z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_28_color__a",
                "x1": "9.18",
                "x2": "22.88",
                "y1": "9.78",
                "y2": "23.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_28_color__b",
                "x1": "3",
                "x2": "13",
                "y1": "15",
                "y2": "25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_28_color__c",
                "x1": "10.83",
                "x2": "23.13",
                "y1": "-2",
                "y2": "13.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_28_color__d",
                "x1": "3.36",
                "x2": "10.26",
                "y1": "4.88",
                "y2": "12.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f24a9d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$6310eefbfa179197 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity28Filled', "28", [
    "M6.19 4.12a2.02 2.02 0 0 1 3.62 0l2.97 5.9A2.05 2.05 0 0 1 10.96 13H5.04a2.05 2.05 0 0 1-1.82-2.98zM15 5.75A2.75 2.75 0 0 1 17.75 3h4.5A2.75 2.75 0 0 1 25 5.75v4.5A2.75 2.75 0 0 1 22.25 13h-4.5A2.75 2.75 0 0 1 15 10.25zM8 15a5 5 0 1 0 0 10 5 5 0 0 0 0-10m11.38-.4c.38-.23.86-.23 1.25 0l3.74 2.16c.39.22.62.63.62 1.08v4.32c0 .45-.23.86-.62 1.08l-3.75 2.17c-.38.22-.86.22-1.25 0l-3.74-2.17a1.3 1.3 0 0 1-.62-1.08v-4.32c0-.45.23-.86.62-1.08z"
]);
const $82e7c60f6344ef74$export$37237739ddad6c6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity28Regular', "28", [
    "M6.19 4.12a2.02 2.02 0 0 1 3.62 0l2.97 5.9A2.05 2.05 0 0 1 10.96 13H5.04a2.05 2.05 0 0 1-1.82-2.98zm2.28.68a.52.52 0 0 0-.94 0l-2.97 5.9c-.2.38.1.8.48.8h5.92c.38 0 .67-.42.48-.8zM17.75 3A2.75 2.75 0 0 0 15 5.75v4.5A2.75 2.75 0 0 0 17.75 13h4.5A2.75 2.75 0 0 0 25 10.25v-4.5A2.75 2.75 0 0 0 22.25 3zM16.5 5.75c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25zM8 16.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 20a5 5 0 1 1 10 0 5 5 0 0 1-10 0m17.63-5.4a1.3 1.3 0 0 0-1.25 0l-3.75 2.16c-.39.22-.62.63-.62 1.08v4.32c0 .45.23.86.62 1.08l3.74 2.17c.4.22.87.22 1.25 0l3.75-2.17c.39-.22.62-.63.62-1.08v-4.32c0-.45-.23-.86-.62-1.08zm-4.12 3.38L20 15.97l3.5 2.01v4.04L20 24.03l-3.5-2.01z"
]);
const $82e7c60f6344ef74$export$95e1372acd42c9b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_48_color__a)",
            "d": "M34.9 25.27a1.8 1.8 0 0 0-1.76 0l-6.25 3.61c-.54.32-.88.9-.88 1.52v7.22c0 .63.34 1.2.88 1.52l6.25 3.6c.55.32 1.21.32 1.75 0l6.26-3.6c.54-.32.87-.9.87-1.52V30.4c0-.63-.33-1.2-.87-1.52z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_48_color__b)",
            "d": "M14 26a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_48_color__c)",
            "d": "M30.75 6A4.75 4.75 0 0 0 26 10.75v6.5A4.75 4.75 0 0 0 30.75 22h6.5A4.75 4.75 0 0 0 42 17.25v-6.5A4.75 4.75 0 0 0 37.25 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_diversity_48_color__d)",
            "d": "M16.9 7.8a3.24 3.24 0 0 0-5.8 0l-4.74 9.43A3.28 3.28 0 0 0 9.26 22h9.49c2.43 0 4-2.59 2.9-4.77z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_48_color__a",
                "x1": "16.68",
                "x2": "38.74",
                "y1": "17.56",
                "y2": "40.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_48_color__b",
                "x1": "6",
                "x2": "22",
                "y1": "26",
                "y2": "42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_48_color__c",
                "x1": "19.33",
                "x2": "39",
                "y1": "-2",
                "y2": "23.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_diversity_48_color__d",
                "x1": "6.58",
                "x2": "17.62",
                "y1": "9",
                "y2": "20.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f24a9d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$6f9bc60d711b9f59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity48Filled', "48", [
    "M26 10.75A4.75 4.75 0 0 1 30.75 6h6.5A4.75 4.75 0 0 1 42 10.75v6.5A4.75 4.75 0 0 1 37.25 22h-6.5A4.75 4.75 0 0 1 26 17.25zM11.1 7.8c1.21-2.4 4.6-2.4 5.8 0l4.75 9.43a3.28 3.28 0 0 1-2.9 4.77H9.26c-2.43 0-4-2.59-2.9-4.77zM14 26a8 8 0 1 0 0 16 8 8 0 0 0 0-16m19.15-.73c.54-.31 1.2-.31 1.75 0l6.25 3.61c.54.32.88.9.88 1.52v7.22c0 .63-.34 1.2-.88 1.52l-6.25 3.6c-.55.32-1.21.32-1.75 0l-6.26-3.6a1.8 1.8 0 0 1-.87-1.52V30.4c0-.63.33-1.2.87-1.52z"
]);
const $82e7c60f6344ef74$export$ff0d6f456f9ca1a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diversity48Regular', "48", [
    "M30.75 6A4.75 4.75 0 0 0 26 10.75v6.5A4.75 4.75 0 0 0 30.75 22h6.5A4.75 4.75 0 0 0 42 17.25v-6.5A4.75 4.75 0 0 0 37.25 6zm-2.25 4.75c0-1.24 1-2.25 2.25-2.25h6.5c1.24 0 2.25 1 2.25 2.25v6.5c0 1.24-1 2.25-2.25 2.25h-6.5c-1.24 0-2.25-1-2.25-2.25zm-9.08 7.62-4.75-9.43a.75.75 0 0 0-1.33 0l-4.75 9.43c-.25.5.11 1.1.67 1.1h9.49c.56 0 .92-.6.67-1.1M11.1 7.8c1.2-2.4 4.59-2.4 5.8 0l4.74 9.43a3.28 3.28 0 0 1-2.9 4.77H9.26c-2.43 0-4-2.59-2.9-4.77zM14 28.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M6 34a8 8 0 1 1 16 0 8 8 0 0 1-16 0m28.9-8.73a1.8 1.8 0 0 0-1.75 0l-6.26 3.61c-.54.32-.87.9-.87 1.52v7.22c0 .63.33 1.2.87 1.52l6.26 3.6c.54.32 1.2.32 1.75 0l6.25-3.6c.54-.32.88-.9.88-1.52V30.4c0-.63-.34-1.2-.88-1.52zm-6.38 5.56 5.5-3.18 5.5 3.18v6.36l-5.5 3.18-5.5-3.18z"
]);
const $82e7c60f6344ef74$export$8053bfb2e697eff6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerShort16Filled', "16", [
    "M7.75 3c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75"
]);
const $82e7c60f6344ef74$export$d10b16ffab1462b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerShort16Regular', "16", [
    "M7.5 3c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5"
]);
const $82e7c60f6344ef74$export$1707813ce7c815ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerShort20Filled', "20", [
    "M9.75 3c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V3.75c0-.41.34-.75.75-.75"
]);
const $82e7c60f6344ef74$export$1c6cd4b6c77acac1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerShort20Regular', "20", [
    "M9.5 3c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5"
]);
const $82e7c60f6344ef74$export$b6c8c421658cf1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerShort24Filled', "24", [
    "M11 5v14a1 1 0 1 0 2 0V5a1 1 0 1 0-2 0"
]);
const $82e7c60f6344ef74$export$a2d86f3c280e866b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerShort24Regular', "24", [
    "M11.25 4.75v14.5a.75.75 0 0 0 1.5 0V4.75a.75.75 0 0 0-1.5 0"
]);
const $82e7c60f6344ef74$export$bd1cc2efa4cc8352 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerTall16Filled', "16", [
    "M7.75 1c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V1.75c0-.41.34-.75.75-.75"
]);
const $82e7c60f6344ef74$export$586691c8378cbbee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerTall16Regular', "16", [
    "M7.5 1c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5"
]);
const $82e7c60f6344ef74$export$78076dd51fea3b3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerTall20Filled', "20", [
    "M9.75 1c.41 0 .75.34.75.75v16.5a.75.75 0 0 1-1.5 0V1.75c0-.41.34-.75.75-.75"
]);
const $82e7c60f6344ef74$export$d80472250d47a59c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerTall20Regular', "20", [
    "M9.5 1c.28 0 .5.22.5.5v17a.5.5 0 0 1-1 0v-17c0-.28.22-.5.5-.5"
]);
const $82e7c60f6344ef74$export$274d05fd8f3d91fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerTall24Filled', "24", [
    "M11 3v18a1 1 0 1 0 2 0V3a1 1 0 1 0-2 0"
]);
const $82e7c60f6344ef74$export$d32c09675dbc301d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DividerTall24Regular', "24", [
    "M11.25 2.75v18.5a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0"
]);
const $82e7c60f6344ef74$export$d688f0f9387d6279 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator20Filled', "20", [
    "M9.5 3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.5zM5.65 7.15c.2-.2.5-.2.7 0l1.5 1.5a.5.5 0 1 1-.7.7l-.65-.64v2.79a.5.5 0 0 1-1 0V8.7l-.65.65a.5.5 0 1 1-.7-.7zM10.5 16H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-4.5zm3.85-4.15a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l.65.64V7.5a.5.5 0 0 1 1 0v2.8l.65-.65a.5.5 0 0 1 .7.7z"
]);
const $82e7c60f6344ef74$export$88bdca41a50b1e71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator20Regular', "20", [
    "M5.65 7.15c.2-.2.5-.2.7 0l1.5 1.5a.5.5 0 1 1-.7.7l-.65-.64v2.79a.5.5 0 0 1-1 0V8.7l-.65.65a.5.5 0 1 1-.7-.7zm10.2 3.2-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l.65.64V7.5a.5.5 0 0 1 1 0v2.8l.65-.65a.5.5 0 0 1 .7.7M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm4.5 1v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm1 11V4H15a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2z"
]);
const $82e7c60f6344ef74$export$ef99938202b322ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator24Filled', "24", [
    "M12.75 20h6c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4h-6zm3.97-5.22-1.75-1.75a.75.75 0 1 1 1.06-1.06l.47.47V9.5a.75.75 0 0 1 1.5 0v2.94l.47-.47a.75.75 0 1 1 1.06 1.06l-1.75 1.75c-.3.3-.77.3-1.06 0M11.25 4h-6A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6zM7.28 8.97l1.75 1.75a.75.75 0 1 1-1.06 1.06l-.47-.47v2.94a.75.75 0 0 1-1.5 0v-2.94l-.47.47a.75.75 0 0 1-1.06-1.06l1.75-1.75c.3-.3.77-.3 1.06 0"
]);
const $82e7c60f6344ef74$export$8d91a1104f7ddcb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator24Regular', "24", [
    "M8.03 8.97a.75.75 0 0 0-1.06 0l-1.75 1.75a.75.75 0 1 0 1.06 1.06l.47-.47v2.94a.75.75 0 0 0 1.5 0v-2.94l.47.47a.75.75 0 0 0 1.06-1.06zm6.19 4.06 1.75 1.75c.3.3.77.3 1.06 0l1.75-1.75a.75.75 0 1 0-1.06-1.06l-.47.47V9.5a.75.75 0 0 0-1.5 0v2.94l-.47-.47a.75.75 0 1 0-1.06 1.06M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75h6v13h-6c-.97 0-1.75-.78-1.75-1.75zm9.25-1.75h6c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75h-6z"
]);
const $82e7c60f6344ef74$export$9a7ca1fc167b9059 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator32Filled', "32", [
    "M17 28h8.5a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4H17zm7.5-16v6.09l1.3-1.3a1 1 0 0 1 1.4 1.42l-3 3a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l1.3 1.3V12a1 1 0 1 1 2 0M15 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28H15zM8.5 21.5a1 1 0 0 1-1-1v-6.09l-1.3 1.3a1 1 0 0 1-1.4-1.42l3-3a1 1 0 0 1 1.4 0l3 3a1 1 0 0 1-1.4 1.42l-1.3-1.3v6.09a1 1 0 0 1-1 1"
]);
const $82e7c60f6344ef74$export$df583d9f4f1a67c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator32Regular', "32", [
    "M9.5 21.5a1 1 0 0 0 1-1v-6.09l1.3 1.3a1 1 0 0 0 1.4-1.42l-3-3a1 1 0 0 0-1.4 0l-3 3a1 1 0 1 0 1.4 1.42l1.3-1.3v6.09a1 1 0 0 0 1 1m14-9.5a1 1 0 1 0-2 0v6.09l-1.3-1.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l3-3a1 1 0 0 0-1.4-1.42l-1.3 1.3zm-17-8A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4zM4 8.5A2.5 2.5 0 0 1 6.5 6H15v20H6.5A2.5 2.5 0 0 1 4 23.5zM17 26V6h8.5A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5z"
]);
const $82e7c60f6344ef74$export$a9b448ae3a5e021e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator48Filled', "48", [
    "M22.78 8H10.25A6.25 6.25 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40h12.52l-.02-.25V8.25q0-.13.02-.25m2.45 32h12.52C41.2 40 44 37.2 44 33.75v-19.5C44 10.8 41.2 8 37.75 8H25.23l.02.25v31.5q0 .13-.02.25m14.15-13.62-4.25 4.25c-.48.5-1.28.5-1.76 0l-4.25-4.25a1.25 1.25 0 0 1 1.76-1.76L33 26.73v-8.48a1.25 1.25 0 1 1 2.5 0v8.48l2.12-2.11a1.25 1.25 0 0 1 1.76 1.76m-26.51-9.01a1.25 1.25 0 0 1 1.76 0l4.25 4.25a1.25 1.25 0 0 1-1.76 1.76L15 21.27v8.48a1.25 1.25 0 1 1-2.5 0v-8.48l-2.12 2.11a1.25 1.25 0 0 1-1.76-1.76z"
]);
const $82e7c60f6344ef74$export$855f222d791e3992 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Elevator48Regular', "48", [
    "M10.25 8A6.25 6.25 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40h27.5C41.2 40 44 37.2 44 33.75v-19.5C44 10.8 41.2 8 37.75 8zm12.5 2.5v27h-12.5a3.75 3.75 0 0 1-3.75-3.75v-19.5a3.75 3.75 0 0 1 3.75-3.75zm2.5 27v-27h12.5a3.75 3.75 0 0 1 3.75 3.75v19.5a3.75 3.75 0 0 1-3.75 3.75zm13.13-11.12-4.25 4.25c-.48.5-1.28.5-1.76 0l-4.25-4.25a1.25 1.25 0 0 1 1.76-1.76L32 26.73v-8.48a1.25 1.25 0 1 1 2.5 0v8.48l2.12-2.11a1.25 1.25 0 0 1 1.76 1.76m-24.51-9.01a1.25 1.25 0 0 1 1.76 0l4.25 4.25a1.25 1.25 0 0 1-1.76 1.76L16 21.27v8.48a1.25 1.25 0 1 1-2.5 0v-8.48l-2.12 2.11a1.25 1.25 0 0 1-1.76-1.76z"
]);
const $82e7c60f6344ef74$export$10d9652c563c8392 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Orientation20Filled', "20", [
    "M3.25 5a.25.25 0 0 0-.25.25v.25a.5.5 0 0 1-1 0v-.25C2 4.56 2.56 4 3.25 4h.25a.5.5 0 0 1 0 1z",
    "M5 4.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5",
    "M8 4.5c0-.28.22-.5.5-.5h.25C9.44 4 10 4.56 10 5.25v.25a.5.5 0 0 1-1 0v-.25A.25.25 0 0 0 8.75 5H8.5a.5.5 0 0 1-.5-.5",
    "m14.85 5.85-.15.16a3.5 3.5 0 0 1-.2 6.99.5.5 0 0 1 0-1 2.5 2.5 0 0 0 .22-5l.13.15a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 0-.7l1-1a.5.5 0 0 1 .7.7",
    "M3.5 9C2.67 9 2 9.67 2 10.5v4c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-1 0v1c0 .28.22.5.5.5z",
    "M3 7.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
]);
const $82e7c60f6344ef74$export$abd4b658c85dd2ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Orientation20Regular', "20", [
    "M3.25 5a.25.25 0 0 0-.25.25v.25a.5.5 0 0 1-1 0v-.25C2 4.56 2.56 4 3.25 4h.25a.5.5 0 0 1 0 1z",
    "M5 4.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5",
    "M8 4.5c0-.28.22-.5.5-.5h.25C9.44 4 10 4.56 10 5.25v.25a.5.5 0 0 1-1 0v-.25A.25.25 0 0 0 8.75 5H8.5a.5.5 0 0 1-.5-.5",
    "m14.85 5.85-.15.16a3.5 3.5 0 0 1-.2 6.99.5.5 0 0 1 0-1 2.5 2.5 0 0 0 .22-5l.13.15a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 0-.7l1-1a.5.5 0 0 1 .7.7",
    "M2 10.5C2 9.67 2.67 9 3.5 9h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 2 14.5zm1.5-.5a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z",
    "M9.5 9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5",
    "M3 7.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
]);
const $82e7c60f6344ef74$export$e3ebf03529481e94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Orientation24Filled', "24", [
    "M6.75 4a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM3.5 8.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM2 12.9c0-1.05.85-1.9 1.9-1.9h10.2c1.05 0 1.9.85 1.9 1.9v5.2a1.9 1.9 0 0 1-1.9 1.9H3.9A1.9 1.9 0 0 1 2 18.1zM12.25 11a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m-8.5-5.5a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5C2 4.78 2.78 4 3.75 4h.5a.75.75 0 0 1 0 1.5zm7.75.25a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 0 1-1.5 0zM17 16.08c0 .48.42.87.89.74A5.5 5.5 0 0 0 17.5 6.1l.3-.35a.75.75 0 1 0-1.13-.98l-1.5 1.75a.75.75 0 0 0 0 .98l1.5 1.75a.75.75 0 1 0 1.14-.98l-.6-.7a4 4 0 0 1 .37 7.79c-.33.1-.59.38-.59.73"
]);
const $82e7c60f6344ef74$export$400c7dddfee13ac6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Orientation24Regular', "24", [
    "M6.75 4a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM3.5 8.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM3.9 11A1.9 1.9 0 0 0 2 12.9v5.2c0 1.05.85 1.9 1.9 1.9h10.2a1.9 1.9 0 0 0 1.9-1.9v-5.2a1.9 1.9 0 0 0-1.9-1.9h-1.85c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-1.5 0v1.5c0 .41.34.75.75.75zm-.4 1.9c0-.22.18-.4.4-.4h10.2c.22 0 .4.18.4.4v5.2a.4.4 0 0 1-.4.4H3.9a.4.4 0 0 1-.4-.4zm.25-7.4a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5C2 4.78 2.78 4 3.75 4h.5a.75.75 0 0 1 0 1.5zm7.75.25a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 0 1-1.5 0zM17 16.08c0 .48.42.87.89.74A5.5 5.5 0 0 0 17.5 6.1l.3-.35a.75.75 0 1 0-1.13-.98l-1.5 1.75a.75.75 0 0 0 0 .98l1.5 1.75a.75.75 0 1 0 1.14-.98l-.6-.7a4 4 0 0 1 .37 7.79c-.33.1-.59.38-.59.73"
]);
const $82e7c60f6344ef74$export$65dd0c16532c19d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OrientationPortrait20Filled', "20", [
    "M4.5 16c.28 0 .5.22.5.5v.25c0 .14.11.25.25.25h.25a.5.5 0 0 1 0 1h-.25C4.56 18 4 17.44 4 16.75v-.25c0-.28.22-.5.5-.5m4 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm6-10c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 9 16.5v-6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5v-2c0-.83.67-1.5 1.5-1.5zm-10 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m1-3a.5.5 0 0 1 0 1h-.25a.25.25 0 0 0-.25.25v.25a.5.5 0 0 1-1 0v-.25c0-.69.56-1.25 1.25-1.25zm4-8A3.5 3.5 0 0 1 13 5.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-5-.22l.15-.13a.5.5 0 1 1 .7.7l-1 1a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.16.15A3.5 3.5 0 0 1 9.5 2"
]);
const $82e7c60f6344ef74$export$a9f4a78bd050d3de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OrientationPortrait20Regular', "20", [
    "M4.5 16c.28 0 .5.22.5.5v.25c0 .14.11.25.25.25h.25a.5.5 0 0 1 0 1h-.25C4.56 18 4 17.44 4 16.75v-.25c0-.28.22-.5.5-.5m4 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm6-10c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 9 16.5v-8c0-.83.67-1.5 1.5-1.5zm-4 1a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5zm-6 5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m1-3a.5.5 0 0 1 0 1h-.25a.25.25 0 0 0-.25.25v.25a.5.5 0 0 1-1 0v-.25c0-.69.56-1.25 1.25-1.25zm3 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm1-8A3.5 3.5 0 0 1 13 5.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-5-.22l.15-.13a.5.5 0 1 1 .7.7l-1 1a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.16.15A3.5 3.5 0 0 1 9.5 2"
]);
const $82e7c60f6344ef74$export$9e91b736004a110c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OrientationPortrait24Filled', "24", [
    "M4.75 19c.41 0 .75.34.75.75v.5c0 .14.11.25.25.25h.5a.75.75 0 0 1 0 1.5h-.5C4.78 22 4 21.22 4 20.25v-.5c0-.41.34-.75.75-.75m5.5 1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5zM18.1 8c1.05 0 1.9.85 1.9 1.9v10.2a1.9 1.9 0 0 1-1.9 1.9h-5.2a1.9 1.9 0 0 1-1.9-1.9V9.9c0-1.05.85-1.9 1.9-1.9zM4.75 15c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m1.5-4a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5c0-.97.78-1.75 1.75-1.75zm4 0a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5zm1.25-9a5.5 5.5 0 0 1 5.32 4.11c.13.47-.26.89-.74.89-.35 0-.64-.26-.73-.6a4 4 0 0 0-7.78.38l.7-.6a.75.75 0 0 1 .97 1.14l-1.75 1.5a.75.75 0 0 1-.98 0l-1.75-1.5a.75.75 0 0 1 .98-1.14l.35.3A5.5 5.5 0 0 1 11.5 2"
]);
const $82e7c60f6344ef74$export$a0566b98164180db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OrientationPortrait24Regular', "24", [
    "M4.75 19c.41 0 .75.34.75.75v.5c0 .14.11.25.25.25h.5a.75.75 0 0 1 0 1.5h-.5C4.78 22 4 21.22 4 20.25v-.5c0-.41.34-.75.75-.75m5.5 1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5zM18.1 8c1.05 0 1.9.85 1.9 1.9v10.2a1.9 1.9 0 0 1-1.9 1.9h-5.2a1.9 1.9 0 0 1-1.9-1.9v-8.35c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5c.41 0 .75.34.75.75V9.9c0-1.05.85-1.9 1.9-1.9zm-5.2 1.5a.4.4 0 0 0-.4.4v10.2c0 .22.18.4.4.4h5.2a.4.4 0 0 0 .4-.4V9.9a.4.4 0 0 0-.4-.4zM4.75 15c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m1.5-4a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5c0-.97.78-1.75 1.75-1.75zm5.25-9a5.5 5.5 0 0 1 5.32 4.11c.13.47-.26.89-.74.89-.35 0-.64-.26-.73-.6a4 4 0 0 0-7.78.38l.7-.6a.75.75 0 0 1 .97 1.14l-1.75 1.5a.75.75 0 0 1-.98 0l-1.75-1.5a.75.75 0 0 1 .98-1.14l.35.3A5.5 5.5 0 0 1 11.5 2"
]);
const $82e7c60f6344ef74$export$ad7ad7f666cb7a72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream20Filled', "20", [
    "M7.5 9.25a5.75 5.75 0 0 1 5.75-5.75h.5a.75.75 0 0 0 0-1.5h-.5C9.25 2 6 5.25 6 9.25v1c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 0 0 1.5h2.5c1.24 0 2.25-1 2.25-2.25zm6.25-3A3.25 3.25 0 0 0 10.5 9.5v1a4.75 4.75 0 0 1-4.75 4.75h-3a.75.75 0 0 1 0-1.5h3c1.8 0 3.25-1.46 3.25-3.25v-1a4.75 4.75 0 0 1 4.75-4.75h3.5a.75.75 0 0 1 0 1.5zm.5 2.75a.75.75 0 0 0-.75.75v1c0 4-3.25 7.25-7.25 7.25h-.5a.75.75 0 0 1 0-1.5h.5A5.75 5.75 0 0 0 12 10.75v-1c0-1.24 1-2.25 2.25-2.25h3a.75.75 0 0 1 0 1.5z"
]);
const $82e7c60f6344ef74$export$5dec31ae500bb747 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream20Regular', "20", [
    "M7 9a6 6 0 0 1 6-6h.5a.5.5 0 0 0 0-1H13a7 7 0 0 0-7 7v1a1 1 0 0 1-1 1H2.5a.5.5 0 0 0 0 1H5a2 2 0 0 0 2-2zm6.5-3A3.5 3.5 0 0 0 10 9.5v1A4.5 4.5 0 0 1 5.5 15h-3a.5.5 0 0 1 0-1h3A3.5 3.5 0 0 0 9 10.5v-1A4.5 4.5 0 0 1 13.5 5h4a.5.5 0 0 1 0 1zm.5 3a1 1 0 0 0-1 1v1a7 7 0 0 1-7 7h-.5a.5.5 0 0 1 0-1H6a6 6 0 0 0 6-6v-1c0-1.1.9-2 2-2h3.5a.5.5 0 0 1 0 1z"
]);
const $82e7c60f6344ef74$export$6f5660de918922d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream24Filled', "24", [
    "M9 11a7 7 0 0 1 7-7h1.5a1 1 0 1 0 0-2H16a9 9 0 0 0-9 9 1 1 0 0 1-1 1H3a1 1 0 1 0 0 2h3a3 3 0 0 0 3-3m8-3a4 4 0 0 0-4 4 6 6 0 0 1-6 6H3a1 1 0 1 1 0-2h4a4 4 0 0 0 4-4 6 6 0 0 1 6-6h4a1 1 0 1 1 0 2zm1 4a1 1 0 0 0-1 1 9 9 0 0 1-9 9H6a1 1 0 1 1 0-2h2a7 7 0 0 0 7-7 3 3 0 0 1 3-3h3a1 1 0 1 1 0 2z"
]);
const $82e7c60f6344ef74$export$924985493c646f38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream24Regular', "24", [
    "M9 11a7.5 7.5 0 0 1 7.5-7.5h.1a.75.75 0 0 0 0-1.5h-.1a9 9 0 0 0-9 9v1.25c0 .69-.56 1.25-1.25 1.25h-3.5a.75.75 0 0 0 0 1.5h3.5A2.75 2.75 0 0 0 9 12.25zm7.75-4a4.25 4.25 0 0 0-4.25 4.25v1.5a5.75 5.75 0 0 1-5.75 5.75h-4a.75.75 0 0 1 0-1.5h4C9.1 17 11 15.1 11 12.75v-1.5a5.75 5.75 0 0 1 5.75-5.75h4.5a.75.75 0 0 1 0 1.5zm.5 3.5c-.69 0-1.25.56-1.25 1.25V13a9 9 0 0 1-9 9h-.25a.75.75 0 0 1 0-1.5H7a7.5 7.5 0 0 0 7.5-7.5v-1.25A2.75 2.75 0 0 1 17.25 9h4a.75.75 0 0 1 0 1.5z"
]);
const $82e7c60f6344ef74$export$cc2fe43cd23b467f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream32Filled', "32", [
    "M20.75 3A10.75 10.75 0 0 0 10 13.75v1C10 15.99 9 17 7.75 17h-3.5a1.25 1.25 0 1 0 0 2.5h3.5a4.75 4.75 0 0 0 4.75-4.75v-1c0-4.56 3.7-8.25 8.25-8.25h2a1.25 1.25 0 1 0 0-2.5zm-6.5 11.75A6.75 6.75 0 0 1 21 8h6.75a1.25 1.25 0 1 1 0 2.5H21a4.25 4.25 0 0 0-4.25 4.25v2A7.75 7.75 0 0 1 9 24.5H4.25a1.25 1.25 0 1 1 0-2.5H9c2.9 0 5.25-2.35 5.25-5.25zm7 3.89A11.1 11.1 0 0 1 10.16 29.5h-.91a1.25 1.25 0 0 1 0-2.5h.91a8.6 8.6 0 0 0 8.59-8.59v-2.16c0-1.8 1.46-3.25 3.25-3.25h5.75a1.25 1.25 0 1 1 0 2.5H22a.75.75 0 0 0-.75.75v2.39"
]);
const $82e7c60f6344ef74$export$d14507c676efcd2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream32Regular', "32", [
    "M20.5 3C14.7 3 10 7.7 10 13.5v1A2.5 2.5 0 0 1 7.5 17H4a1 1 0 1 0 0 2h3.5a4.5 4.5 0 0 0 4.5-4.5v-1C12 8.8 15.8 5 20.5 5H23a1 1 0 1 0 0-2zm-6 11.5A6.5 6.5 0 0 1 21 8h7a1 1 0 1 1 0 2h-7a4.5 4.5 0 0 0-4.5 4.5v2A7.5 7.5 0 0 1 9 24H4a1 1 0 1 1 0-2h5a5.5 5.5 0 0 0 5.5-5.5zM9 27h1.16A8.84 8.84 0 0 0 19 18.16V16a3 3 0 0 1 3-3h6a1 1 0 1 1 0 2h-6a1 1 0 0 0-1 1v2.38A10.84 10.84 0 0 1 10.16 29H9a1 1 0 1 1 0-2"
]);
const $82e7c60f6344ef74$export$8d6a21a1854c4d91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream48Filled', "48", [
    "M30.5 7C23.6 7 18 12.6 18 19.5v1a7.5 7.5 0 0 1-7.5 7.5h-5a1.5 1.5 0 0 1 0-3h5a4.5 4.5 0 0 0 4.5-4.5v-1A15.5 15.5 0 0 1 30.5 4h4.25a1.5 1.5 0 0 1 0 3zm2 8a6.5 6.5 0 0 0-6.5 6.5v1A13.5 13.5 0 0 1 12.5 36h-7a1.5 1.5 0 0 1 0-3h7C18.3 33 23 28.3 23 22.5v-1a9.5 9.5 0 0 1 9.5-9.5h10a1.5 1.5 0 0 1 0 3zm1.5 9.36c0-.75.61-1.36 1.36-1.36h7.14a1.5 1.5 0 0 0 0-3h-7.14A4.36 4.36 0 0 0 31 24.36C31 33.56 23.55 41 14.36 41h-.86a1.5 1.5 0 0 0 0 3h.86C25.21 44 34 35.2 34 24.36"
]);
const $82e7c60f6344ef74$export$79dc1fce7f59f64e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Stream48Regular', "48", [
    "M30.25 6.5c-7.04 0-12.75 5.7-12.75 12.75v1c0 4-3.25 7.25-7.25 7.25h-5a1.25 1.25 0 1 1 0-2.5h5A4.75 4.75 0 0 0 15 20.25v-1C15 10.83 21.83 4 30.25 4h4.5a1.25 1.25 0 1 1 0 2.5zm2 8a6.75 6.75 0 0 0-6.75 6.75v1c0 7.32-5.93 13.25-13.25 13.25h-7a1.25 1.25 0 1 1 0-2.5h7C18.19 33 23 28.19 23 22.25v-1c0-5.1 4.14-9.25 9.25-9.25h10.5a1.25 1.25 0 1 1 0 2.5zm1.25 9.61c0-.89.72-1.61 1.61-1.61h7.64a1.25 1.25 0 1 0 0-2.5h-7.64A4.1 4.1 0 0 0 31 24.11C31 33.44 23.44 41 14.11 41h-.86a1.25 1.25 0 1 0 0 2.5h.86c10.71 0 19.39-8.68 19.39-19.39"
]);
const $82e7c60f6344ef74$export$5f87ed3c4a19ce34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreamInput20Filled', "20", [
    "M7.5 9.25a5.75 5.75 0 0 1 5.75-5.75h.5a.75.75 0 0 0 0-1.5h-.5C9.25 2 6 5.25 6 9.25v1c0 .41-.34.75-.75.75H4.9l1.3 1.3a2.3 2.3 0 0 0 1.3-2.05zM6.4 16.5l-1.23 1.23q.22.25.58.27h.5c4 0 7.25-3.25 7.25-7.25v-1c0-.41.34-.75.75-.75h3a.75.75 0 0 0 0-1.5h-3c-1.24 0-2.25 1-2.25 2.25v1c0 3.12-2.5 5.67-5.6 5.75m.8-3.09c.26.48.34 1.02.23 1.53a4.75 4.75 0 0 0 3.07-4.44v-1c0-1.8 1.46-3.25 3.25-3.25h3.5a.75.75 0 0 0 0-1.5h-3.5A4.75 4.75 0 0 0 9 9.5v1c0 1.28-.74 2.38-1.8 2.91m-5.48-2.44c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H.75a.75.75 0 0 1 0-1.5h2.69l-1.72-1.72a.75.75 0 0 1 0-1.06"
]);
const $82e7c60f6344ef74$export$fec72d9581b08d0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreamInput20Regular', "20", [
    "M7 9a6 6 0 0 1 6-6h.5a.5.5 0 0 0 0-1H13a7 7 0 0 0-7 7v1a1 1 0 0 1-1 1h-.9l1 1A2 2 0 0 0 7 10zM.5 14a.5.5 0 0 0 0 1h3.68l-2.14 2.15a.5.5 0 0 0 .7.7l3-2.99a.5.5 0 0 0 0-.72l-3-3a.5.5 0 0 0-.7.71L4.18 14zm9.5-3.5a4.5 4.5 0 0 1-3.15 4.3q.08-.53-.12-1.02A3.5 3.5 0 0 0 9 10.5v-1A4.5 4.5 0 0 1 13.5 5h4a.5.5 0 0 1 0 1h-4A3.5 3.5 0 0 0 10 9.5zM14 9a1 1 0 0 0-1 1v1a7 7 0 0 1-7 7h-.5a.5.5 0 0 1 0-1H6a6 6 0 0 0 6-6v-1c0-1.1.9-2 2-2h3.5a.5.5 0 0 1 0 1z"
]);
const $82e7c60f6344ef74$export$d07e6a3c9bc09ff5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreamInputOutput20Filled', "20", [
    "M13.25 3.5A5.75 5.75 0 0 0 7.5 9.25v1c0 1.24-1 2.25-2.25 2.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75-.34.75-.75v-1C6 5.25 9.25 2 13.25 2h.5a.75.75 0 0 1 0 1.5zm-2.75 6c0-1.8 1.46-3.25 3.25-3.25h3.5a.75.75 0 0 0 0-1.5h-3.5A4.75 4.75 0 0 0 9 9.5v1c0 1.8-1.46 3.25-3.25 3.25h-3a.75.75 0 0 0 0 1.5h3a4.75 4.75 0 0 0 4.75-4.75zm3.75-.5a.75.75 0 0 0-.75.75v1q0 1-.25 1.9a2 2 0 0 0-1.59.05q.34-.92.34-1.95v-1c0-1.24 1-2.25 2.25-2.25h3a.75.75 0 0 1 0 1.5zm-1.4 9.16a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7l-1.14 1.16h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.19.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l1.14-1.15h-5.58z"
]);
const $82e7c60f6344ef74$export$bdafc06e762365d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreamInputOutput20Regular', "20", [
    "M13 3a6 6 0 0 0-6 6v1a2 2 0 0 1-2 2H2.5a.5.5 0 0 1 0-1H5a1 1 0 0 0 1-1V9a7 7 0 0 1 7-7h.5a.5.5 0 0 1 0 1zm-3 6.5A3.5 3.5 0 0 1 13.5 6h4a.5.5 0 0 0 0-1h-4A4.5 4.5 0 0 0 9 9.5v1A3.5 3.5 0 0 1 5.5 14h-3a.5.5 0 0 0 0 1h3a4.5 4.5 0 0 0 4.5-4.5zm3 .5c0-.6.4-1 1-1h3.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H14a2 2 0 0 0-2 2v1c0 .9-.2 1.7-.5 2.4.3-.2.6-.4 1-.4h.2c.2-.6.3-1.3.3-2zm-.15 8.16a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7l-1.14 1.16h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.19.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l1.14-1.15h-5.58z"
]);
const $82e7c60f6344ef74$export$a1fc7d92ac351194 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreamOutput20Filled', "20", [
    "M16.78 1.97a.75.75 0 1 0-1.06 1.06l1.72 1.72h-3.69A4.75 4.75 0 0 0 9 9.5v1c0 1.8-1.46 3.25-3.25 3.25h-3a.75.75 0 0 0 0 1.5h3a4.75 4.75 0 0 0 4.75-4.75v-1c0-1.8 1.46-3.25 3.25-3.25h3.69l-1.72 1.72a.75.75 0 0 0 1.06 1.06l3-3c.3-.3.3-.77 0-1.06zM13.25 3.5A5.75 5.75 0 0 0 7.5 9.25v1c0 1.24-1 2.25-2.25 2.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75-.34.75-.75v-1C6 5.25 9.25 2 13.25 2h.5a.75.75 0 0 1 0 1.5zm.91 4q-.36.76-.17 1.54c-.28.1-.49.39-.49.71v1c0 4-3.25 7.25-7.25 7.25h-.5a.75.75 0 0 1 0-1.5h.5A5.75 5.75 0 0 0 12 10.75v-1c0-1.21.96-2.2 2.16-2.25"
]);
const $82e7c60f6344ef74$export$d17ade9f36edb47f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreamOutput20Regular', "20", [
    "M16.15 2.15c.2-.2.5-.2.7 0l3 2.99a.5.5 0 0 1 0 .72l-3 3a.5.5 0 0 1-.7-.71L18.29 6H13.5C11.6 6 10 7.6 10 9.5v1C10 13 8 15 5.5 15h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3C7.4 14 9 12.4 9 10.5v-1C9 7 11 5 13.5 5h4.8l-2.15-2.15a.5.5 0 0 1 0-.7M2.5 12H5a2 2 0 0 0 2-2V9c0-3.3 2.7-6 6-6h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H13C9.1 2 6 5.1 6 9v1c0 .6-.4 1-1 1H2.5c-.3 0-.5.2-.5.5s.2.5.5.5m12.6-4H14a2 2 0 0 0-2 2v1c0 3.3-2.7 6-6 6h-.5c-.3 0-.5.2-.5.5s.2.5.5.5H6c3.9 0 7-3.1 7-7v-1c0-.6.4-1 1-1h1.1c-.1-.3-.1-.7 0-1"
]);
const $82e7c60f6344ef74$export$b14e0e20ab582b15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreetHome20Filled', "20", [
    "M17.5 16a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zM4.5 3A2.5 2.5 0 0 1 5 7.95V14h2V9.5c0-.44.2-.85.52-1.14l3.5-3a1.5 1.5 0 0 1 1.96 0l3.5 3c.33.29.52.7.52 1.14V14h.5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1H4V7.95A2.5 2.5 0 0 1 4.5 3m7 8a.5.5 0 0 0-.5.5V14h2v-2.5a.5.5 0 0 0-.5-.5z"
]);
const $82e7c60f6344ef74$export$fb6f9ef68a6efda6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreetHome20Regular', "20", [
    "M17.5 16a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1zM4.5 3A2.5 2.5 0 0 1 5 7.95V14h2V9.5c0-.44.2-.85.52-1.14l3.5-3a1.5 1.5 0 0 1 1.96 0l3.5 3c.33.29.52.7.52 1.14V14h.5a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1H4V7.95A2.5 2.5 0 0 1 4.5 3m7.83 3.12a.5.5 0 0 0-.66 0l-3.5 3A.5.5 0 0 0 8 9.5V14h2v-2.5c0-.83.67-1.5 1.5-1.5h1c.83 0 1.5.67 1.5 1.5V14h2V9.5a.5.5 0 0 0-.17-.38zM11.5 11a.5.5 0 0 0-.5.5V14h2v-2.5a.5.5 0 0 0-.5-.5zm-7-7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $82e7c60f6344ef74$export$d5bcbf0465df6e59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreetSign20Filled', "20", [
    "M7 4a2 2 0 1 1 4 0v1h2.38a2 2 0 0 1 1.41.59l2.06 2.06a.5.5 0 0 1 0 .7l-2.06 2.06a2 2 0 0 1-1.41.59H11v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h2zm3 0a1 1 0 0 0-2 0v1h2zM8 17h2v-6H8z"
]);
const $82e7c60f6344ef74$export$687c933e9a90952d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreetSign20Regular', "20", [
    "M7 4a2 2 0 1 1 4 0v1h2.38a2 2 0 0 1 1.41.59l2.06 2.06a.5.5 0 0 1 0 .7l-2.06 2.06a2 2 0 0 1-1.41.59H11v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h2zm1 1h2V4a1 1 0 0 0-2 0zm0 6v6h2v-6zM4 7v2a1 1 0 0 0 1 1h8.38a1 1 0 0 0 .7-.3L15.8 8l-1.7-1.7a1 1 0 0 0-.71-.3H5a1 1 0 0 0-1 1"
]);
const $82e7c60f6344ef74$export$c578085e2a17819f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreetSign24Filled', "24", [
    "M8 4.5a2.5 2.5 0 0 1 5 0V6h3.38c.6 0 1.17.24 1.59.66l2.81 2.81c.3.3.3.77 0 1.06l-2.81 2.81c-.42.42-1 .66-1.6.66H13v6.75c0 .69-.56 1.25-1.25 1.25h-2.5C8.56 22 8 21.44 8 20.75V14H5.25C4.01 14 3 13 3 11.75v-3.5C3 7.01 4 6 5.25 6H8zm3.5 0a1 1 0 1 0-2 0V6h2zm-2 16h2V14h-2z"
]);
const $82e7c60f6344ef74$export$732fd269c3db5d40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StreetSign24Regular', "24", [
    "M8 4.5a2.5 2.5 0 0 1 5 0V6h3.38c.6 0 1.17.24 1.59.66l2.81 2.81c.3.3.3.77 0 1.06l-2.81 2.81c-.42.42-1 .66-1.6.66H13v6.75c0 .69-.56 1.25-1.25 1.25h-2.5C8.56 22 8 21.44 8 20.75V14H5.25C4.01 14 3 13 3 11.75v-3.5C3 7.01 4 6 5.25 6H8zM9.5 6h2V4.5a1 1 0 1 0-2 0zm0 8v6.5h2V14zm-5-5.75v3.5c0 .41.34.75.75.75h11.13q.31 0 .53-.22L19.19 10 16.9 7.72a.8.8 0 0 0-.53-.22H5.25a.75.75 0 0 0-.75.75"
]);
const $82e7c60f6344ef74$export$20ca152bdf5156d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv16Filled', "16", [
    "M4 3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 9.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
]);
const $82e7c60f6344ef74$export$e0e6b23df1f617ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv16Regular', "16", [
    "M4 3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM3 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1.5 7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $82e7c60f6344ef74$export$63cedac6667caea9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi120Filled', "20", [
    "M16.73 7.56q.6.62 1.11 1.35a.75.75 0 0 1-1.23.85q-.43-.62-.94-1.14a7.97 7.97 0 0 0-12.2 1.14.75.75 0 1 1-1.23-.86q.51-.75 1.1-1.34c3.7-3.7 9.7-3.7 13.39 0m-2.14 1.9c.47.46.88 1.04 1.2 1.64a.75.75 0 1 1-1.34.69 4.94 4.94 0 0 0-8.82-.02.75.75 0 0 1-1.34-.67q.45-.91 1.19-1.65a6.44 6.44 0 0 1 9.11 0m-1.64 2.38q.56.55.87 1.28a.75.75 0 0 1-1.37.6q-.2-.47-.56-.82a2.63 2.63 0 0 0-4.26.81.75.75 0 1 1-1.38-.6q.32-.71.86-1.27a4.13 4.13 0 0 1 5.84 0m-2.03 2.04a1.24 1.24 0 1 1-1.76 1.76 1.24 1.24 0 0 1 1.76-1.76"
]);
const $82e7c60f6344ef74$export$2158d6c4faed1235 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi120Regular', "20", [
    "M16.83 7.38q.62.63 1.14 1.37a.5.5 0 0 1-.83.57 8.61 8.61 0 0 0-14.2 0 .5.5 0 0 1-.82-.58 9.61 9.61 0 0 1 14.71-1.36M14.6 9.36q.71.72 1.19 1.65a.5.5 0 0 1-.89.46q-.4-.8-1.01-1.4a5.45 5.45 0 0 0-8.72 1.38.5.5 0 1 1-.89-.45q.45-.9 1.2-1.64a6.45 6.45 0 0 1 9.12 0m-1.71 2.5q.53.53.85 1.25a.5.5 0 0 1-.92.4 3.03 3.03 0 0 0-5.56-.01.5.5 0 1 1-.92-.4q.3-.72.84-1.25a4.03 4.03 0 0 1 5.7 0m-1.93 1.93a1.3 1.3 0 1 1-1.83 1.83 1.3 1.3 0 0 1 1.83-1.83"
]);
const $82e7c60f6344ef74$export$38e910a963644ac7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi124Filled', "24", [
    "M17.78 10.7c.6.6 1.12 1.33 1.5 2.1a1 1 0 0 1-1.77.9q-.46-.89-1.14-1.58a6.13 6.13 0 0 0-9.8 1.56 1 1 0 0 1-1.78-.9q.57-1.15 1.5-2.07a8.13 8.13 0 0 1 11.5 0m-2.04 3q.7.7 1.1 1.62a1 1 0 0 1-1.84.8 3.23 3.23 0 0 0-5.93-.01 1 1 0 1 1-1.83-.8q.4-.91 1.1-1.61a5.23 5.23 0 0 1 7.4 0m4.68-5.4q.77.77 1.4 1.69a1 1 0 0 1-1.64 1.14q-.53-.78-1.17-1.42a9.92 9.92 0 0 0-15.19 1.41 1 1 0 0 1-1.64-1.14A11.92 11.92 0 0 1 20.42 8.3m-7.36 8.14a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
]);
const $82e7c60f6344ef74$export$a173d3c21c5d585c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi124Regular', "24", [
    "M17.74 10.75q.9.9 1.5 2.07a.75.75 0 1 1-1.34.68 6.56 6.56 0 0 0-11.71-.02.75.75 0 1 1-1.34-.67q.57-1.14 1.5-2.06a8.06 8.06 0 0 1 11.4 0m-2.1 3.07q.68.7 1.08 1.58a.75.75 0 1 1-1.38.6A3.6 3.6 0 0 0 8.75 16a.75.75 0 1 1-1.37-.6q.4-.89 1.06-1.57a5.1 5.1 0 0 1 7.2 0m4.8-5.54q.79.77 1.42 1.7a.75.75 0 1 1-1.24.85q-.56-.82-1.23-1.5a10.45 10.45 0 0 0-16 1.5.75.75 0 0 1-1.23-.86q.65-.94 1.4-1.7a11.95 11.95 0 0 1 16.89 0m-7.38 8.16a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
]);
const $82e7c60f6344ef74$export$ec96710f930b2a5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi148Filled', "48", [
    "M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-7c4.1 0 7.62 2.4 9.26 5.86a1.5 1.5 0 0 1-2.7 1.28 7.25 7.25 0 0 0-13.11 0 1.5 1.5 0 1 1-2.71-1.28A10.3 10.3 0 0 1 24 26m0-8a17.2 17.2 0 0 1 14.79 8.36 1.5 1.5 0 0 1-2.58 1.55 14.24 14.24 0 0 0-24.42 0 1.5 1.5 0 0 1-2.58-1.55A17.3 17.3 0 0 1 24 18m0-8c8.36 0 15.73 4.23 20.09 10.66a1.5 1.5 0 1 1-2.49 1.68 21.23 21.23 0 0 0-35.2 0 1.5 1.5 0 0 1-2.48-1.68A24.2 24.2 0 0 1 24 10"
]);
const $82e7c60f6344ef74$export$12270c8e5c84343e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi148Regular', "48", [
    "M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-7a10 10 0 0 1 9.29 6.28 1.25 1.25 0 0 1-2.32.93 7.5 7.5 0 0 0-13.93 0 1.25 1.25 0 1 1-2.33-.93 10 10 0 0 1 9.3-6.28m0-8a17 17 0 0 1 14.84 8.7 1.25 1.25 0 1 1-2.18 1.22 14.5 14.5 0 0 0-25.32 0 1.25 1.25 0 0 1-2.18-1.22A17 17 0 0 1 24 18m0-8c8.5 0 15.96 4.42 20.22 11.07a1.25 1.25 0 0 1-2.1 1.35 21.48 21.48 0 0 0-36.24 0 1.25 1.25 0 0 1-2.1-1.35A24 24 0 0 1 24 10"
]);
const $82e7c60f6344ef74$export$27547e82cc3ef0a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_20_color__a)",
            "d": "M10 6C7.2 6 4.7 7.28 3.05 9.28a1 1 0 1 1-1.54-1.27 10.98 10.98 0 0 1 16.98 0 1 1 0 1 1-1.54 1.27A9 9 0 0 0 10 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_20_color__b)",
            "d": "M5.25 11.33a6 6 0 0 1 9.5 0 1 1 0 0 0 1.58-1.22 8 8 0 0 0-12.66 0 1 1 0 0 0 1.58 1.22"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_20_color__c)",
            "d": "M7.49 13.36a3 3 0 0 1 5.02 0 1 1 0 1 0 1.67-1.1 5 5 0 0 0-8.37 0 1 1 0 1 0 1.68 1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_20_color__d)",
            "d": "M10 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$1e804bdafa8ff6c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_24_color__a)",
            "d": "M17.78 10.7c.6.6 1.12 1.33 1.5 2.1a1 1 0 0 1-1.77.9q-.46-.89-1.14-1.58a6.13 6.13 0 0 0-9.8 1.56 1 1 0 0 1-1.78-.9q.57-1.15 1.5-2.07a8.13 8.13 0 0 1 11.5 0m-2.04 3q.7.7 1.1 1.62a1 1 0 0 1-1.84.8 3.23 3.23 0 0 0-5.93-.01 1 1 0 1 1-1.83-.8q.4-.91 1.1-1.61a5.23 5.23 0 0 1 7.4 0m4.68-5.4q.77.77 1.4 1.69a1 1 0 0 1-1.64 1.14q-.53-.78-1.17-1.42a9.92 9.92 0 0 0-15.19 1.41 1 1 0 0 1-1.64-1.14A11.92 11.92 0 0 1 20.42 8.3m-7.36 8.14a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -12.4917 17.6003 0 12 17.3)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$e9da66f031c83a6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi220Filled', "20", [
    "M14.59 9.45c.47.47.88 1.05 1.2 1.65a.75.75 0 0 1-1.34.69 4.94 4.94 0 0 0-8.82-.02.75.75 0 1 1-1.34-.67q.45-.91 1.19-1.65a6.44 6.44 0 0 1 9.11 0m-1.64 2.4q.56.54.87 1.27a.75.75 0 0 1-1.37.6q-.2-.47-.56-.82a2.63 2.63 0 0 0-4.26.82.75.75 0 1 1-1.38-.6q.32-.73.86-1.28a4.13 4.13 0 0 1 5.84 0m-2.03 2.03a1.24 1.24 0 1 1-1.76 1.76 1.24 1.24 0 0 1 1.76-1.76"
]);
const $82e7c60f6344ef74$export$ec26420679a3eaed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi220Regular', "20", [
    "M14.6 9.36q.71.72 1.2 1.65a.5.5 0 1 1-.9.46q-.4-.8-1.01-1.4a5.45 5.45 0 0 0-8.72 1.38.5.5 0 0 1-.89-.45q.45-.9 1.2-1.64a6.45 6.45 0 0 1 9.12 0m-1.71 2.5q.53.53.85 1.25a.5.5 0 1 1-.92.4 3.03 3.03 0 0 0-5.56-.01.5.5 0 1 1-.92-.4q.3-.72.84-1.25a4.03 4.03 0 0 1 5.7 0m-1.93 1.93a1.3 1.3 0 1 1-1.83 1.83 1.3 1.3 0 0 1 1.83-1.83"
]);
const $82e7c60f6344ef74$export$9e5f697772f89f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi224Filled', "24", [
    "M10.96 16.44a1.5 1.5 0 1 1 2.12 2.12 1.5 1.5 0 0 1-2.12-2.12m-2.6-2.74a5.23 5.23 0 0 1 8.5 1.62 1 1 0 1 1-1.83.8 3.23 3.23 0 0 0-5.93-.01 1 1 0 1 1-1.83-.8q.4-.91 1.09-1.61m-2.05-3a8.13 8.13 0 0 1 13 2.1 1 1 0 1 1-1.78.9q-.46-.89-1.14-1.58a6.13 6.13 0 0 0-9.8 1.56 1 1 0 1 1-1.78-.9q.57-1.15 1.5-2.07"
]);
const $82e7c60f6344ef74$export$4f59157b97633750 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi224Regular', "24", [
    "M17.74 10.75q.9.9 1.5 2.07a.75.75 0 1 1-1.34.68 6.56 6.56 0 0 0-11.71-.02.75.75 0 1 1-1.34-.67q.57-1.14 1.5-2.06a8.06 8.06 0 0 1 11.4 0m-2.1 3.07q.68.7 1.08 1.58a.75.75 0 1 1-1.38.6A3.6 3.6 0 0 0 8.75 16a.75.75 0 1 1-1.37-.6q.4-.89 1.06-1.57a5.1 5.1 0 0 1 7.2 0m-2.58 2.62a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
]);
const $82e7c60f6344ef74$export$1c1556681356cb03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi320Filled', "20", [
    "M12.95 11.84q.56.55.87 1.28a.75.75 0 0 1-1.37.6q-.2-.47-.56-.82a2.63 2.63 0 0 0-4.26.81.75.75 0 1 1-1.38-.6q.32-.71.86-1.27a4.13 4.13 0 0 1 5.84 0m-2.03 2.04a1.24 1.24 0 1 1-1.76 1.76 1.24 1.24 0 0 1 1.76-1.76"
]);
const $82e7c60f6344ef74$export$10e93eeca37f7ea7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi320Regular', "20", [
    "M12.89 11.85q.53.55.85 1.26a.5.5 0 1 1-.92.4 3.03 3.03 0 0 0-5.56-.01.5.5 0 0 1-.92-.4q.3-.72.84-1.25a4.03 4.03 0 0 1 5.7 0m-1.93 1.94a1.3 1.3 0 1 1-1.83 1.83 1.3 1.3 0 0 1 1.83-1.83"
]);
const $82e7c60f6344ef74$export$7b2b76f139a32ee1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi324Filled', "24", [
    "M10.94 16.45a1.5 1.5 0 1 1 2.12 2.12 1.5 1.5 0 0 1-2.12-2.12m-2.6-2.75a5.23 5.23 0 0 1 8.5 1.63 1 1 0 0 1-1.84.8q-.25-.58-.68-1.01a3.23 3.23 0 0 0-5.24 1 1 1 0 1 1-1.84-.8q.4-.91 1.1-1.62"
]);
const $82e7c60f6344ef74$export$a21dc057af0fa6dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi324Regular', "24", [
    "M10.94 16.44a1.5 1.5 0 1 1 2.12 2.12 1.5 1.5 0 0 1-2.12-2.12m-2.5-2.62a5.1 5.1 0 0 1 8.28 1.58.75.75 0 1 1-1.38.6A3.6 3.6 0 0 0 8.75 16a.75.75 0 1 1-1.37-.6q.4-.89 1.06-1.57"
]);
const $82e7c60f6344ef74$export$632a5de95038de64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi420Filled', "20", [
    "M10.92 13.88a1.24 1.24 0 1 1-1.76 1.76 1.24 1.24 0 0 1 1.76-1.76"
]);
const $82e7c60f6344ef74$export$1f7256e61f7fd4d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi420Regular', "20", [
    "M10.96 13.79a1.3 1.3 0 1 1-1.83 1.83 1.3 1.3 0 0 1 1.83-1.83"
]);
const $82e7c60f6344ef74$export$f518683e36594bcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi424Filled', "24", [
    "M10.96 18.57a1.5 1.5 0 1 0 2.12-2.13 1.5 1.5 0 0 0-2.12 2.13"
]);
const $82e7c60f6344ef74$export$5f49e244d246dff2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wifi424Regular', "24", [
    "M10.94 18.56a1.5 1.5 0 1 0 2.12-2.12 1.5 1.5 0 0 0-2.12 2.12"
]);
const $82e7c60f6344ef74$export$90471c85039f98ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiLock20Filled', "20", [
    "M16.73 7.56q.6.62 1.11 1.35a.75.75 0 0 1-1.23.85q-.43-.62-.94-1.14a7.97 7.97 0 0 0-10.6-.59 3 3 0 0 0-2.42 2.02.75.75 0 0 1-.41-1.15q.51-.75 1.1-1.34c3.7-3.7 9.7-3.7 13.39 0m-5.8 8.08c-.26.25-.6.37-.93.36v-2.48a1.24 1.24 0 0 1 .92 2.12m.96-2.74a2.6 2.6 0 0 0-2.08-.76 2 2 0 0 0-1.31-1.08v-.13a4.13 4.13 0 0 1 5.32 2.2.75.75 0 0 1-1.37.6q-.2-.47-.56-.83m1.64-2.39a4.9 4.9 0 0 0-5.45-1.04 3 3 0 0 0-1.15-1.1 6.45 6.45 0 0 1 8.85 2.73.75.75 0 1 1-1.33.69 5 5 0 0 0-.92-1.28M3.5 11v1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $82e7c60f6344ef74$export$eb6162fc3d96fca9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiLock20Regular', "20", [
    "M16.83 7.38q.63.63 1.13 1.37a.5.5 0 0 1-.82.57q-.46-.67-1.02-1.23A8.6 8.6 0 0 0 2.94 9.31a.5.5 0 1 1-.82-.57 9.61 9.61 0 0 1 14.71-1.36M14.6 9.36q.72.72 1.19 1.65a.5.5 0 0 1-.9.46q-.4-.8-1-1.4a5.45 5.45 0 0 0-6.17-1.09q-.38-.41-.88-.67a6.45 6.45 0 0 1 7.76 1.05m-6.1 1.7a2 2 0 0 1 1.03.65 3 3 0 0 1 3.29 1.8.5.5 0 0 0 .92-.4q-.31-.71-.85-1.26a4 4 0 0 0-4.39-.87v.08m1.5 2.35V16a1.3 1.3 0 0 0 .96-2.22 1.3 1.3 0 0 0-.96-.38M3.5 11v1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 0 0-4 0m1 1v-1a1 1 0 0 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $82e7c60f6344ef74$export$759f47c29af08fc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiLock24Filled', "24", [
    "M17.78 10.7c.6.6 1.12 1.33 1.5 2.1a1 1 0 0 1-1.77.9q-.46-.89-1.14-1.58a6.1 6.1 0 0 0-7.03-1.17 3.5 3.5 0 0 0-1.77-1.28 8.1 8.1 0 0 1 10.21 1.04m-12.8-.99-.26.27q-.91.55-1.38 1.51A1 1 0 0 1 2.18 10q.65-.94 1.39-1.7A11.92 11.92 0 0 1 21.82 10a1 1 0 0 1-1.64 1.14q-.53-.78-1.17-1.42a9.9 9.9 0 0 0-14.03 0m10.76 3.99q.7.7 1.1 1.62a1 1 0 0 1-1.84.8 3.23 3.23 0 0 0-3.37-1.93A2.5 2.5 0 0 0 10 13.05V13q0-.21-.02-.41c1.9-.82 4.2-.45 5.76 1.11m-2.68 2.74A1.5 1.5 0 0 1 12 19v-3c.38 0 .77.15 1.06.44M4 14v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 2 20.5v-5c0-.83.67-1.5 1.5-1.5zm1.5-1v1h2v-1a1 1 0 0 0-2 0m2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $82e7c60f6344ef74$export$dea9385ae9bc97a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiLock24Regular', "24", [
    "M17.74 10.75q.9.9 1.5 2.07a.75.75 0 1 1-1.34.68 6.56 6.56 0 0 0-8.85-2.9 3.5 3.5 0 0 0-1.4-.9 8.1 8.1 0 0 1 10.1 1.05m-2.1 3.07q.69.7 1.07 1.58a.75.75 0 1 1-1.37.6 3.59 3.59 0 0 0-3.93-2.12 2.5 2.5 0 0 0-1.41-.83v-.29a5.1 5.1 0 0 1 5.64 1.06m4.8-5.54q.79.77 1.42 1.7a.75.75 0 1 1-1.24.85q-.56-.82-1.23-1.5a10.45 10.45 0 0 0-16 1.5.75.75 0 0 1-1.23-.86q.65-.94 1.4-1.7a11.95 11.95 0 0 1 16.89 0m-7.38 8.16A1.5 1.5 0 0 1 12 19v-3c.38 0 .77.15 1.06.44M4 14v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 2 20.5v-5c0-.83.67-1.5 1.5-1.5zm1.5-1v1h2v-1a1 1 0 1 0-2 0m2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $82e7c60f6344ef74$export$570c22f2664ab05a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiOff20Filled', "20", [
    "M3.28 2.22a.75.75 0 0 0-1.06 1.06l2.89 2.89A9.5 9.5 0 0 0 2.24 8.9a.75.75 0 1 0 1.23.86q.43-.65.93-1.14.83-.83 1.8-1.35l.97.96A6.4 6.4 0 0 0 4.3 11.1a.75.75 0 0 0 1.34.67 5 5 0 0 1 2.68-2.4l1.28 1.28a4.1 4.1 0 0 0-3.34 2.46.75.75 0 1 0 1.38.6q.2-.46.54-.8a2.6 2.6 0 0 1 3.38-.3l5.17 5.17a.75.75 0 1 0 1.06-1.06zm8.09 7.03a5 5 0 0 1 3.08 2.54.75.75 0 1 0 1.33-.69A6.43 6.43 0 0 0 9.7 7.57zM8.55 6.43a8 8 0 0 1 8.06 3.33.75.75 0 1 0 1.23-.85A9.47 9.47 0 0 0 7.31 5.19zm2.37 9.2a1.24 1.24 0 1 0-1.76-1.75 1.24 1.24 0 0 0 1.76 1.76"
]);
const $82e7c60f6344ef74$export$2d87ac9d404feb6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l3.03 3.03a10 10 0 0 0-3.06 2.86.5.5 0 0 0 .82.57q.48-.68 1-1.22.91-.9 1.97-1.47l1.44 1.43A6.4 6.4 0 0 0 4.28 11a.5.5 0 1 0 .9.45A5.4 5.4 0 0 1 8.1 8.82l1.86 1.85a4 4 0 0 0-3.63 2.43.5.5 0 0 0 .92.4q.24-.54.63-.94c.9-.9 2.2-1.11 3.3-.66l1.65 1.65a.5.5 0 0 0 .2.2l4.1 4.1a.5.5 0 0 0 .71-.7zM9.6 7.48l1.02 1.02a5.4 5.4 0 0 1 4.28 2.97.5.5 0 0 0 .9-.46A6.43 6.43 0 0 0 9.6 7.48M7.14 5.01l.8.81a8.6 8.6 0 0 1 9.2 3.5.5.5 0 0 0 .83-.57A9.61 9.61 0 0 0 7.14 5.02m3.82 8.78a1.3 1.3 0 1 1-1.83 1.83 1.3 1.3 0 0 1 1.83-1.83"
]);
const $82e7c60f6344ef74$export$c63b7e8cab926563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiOff24Filled', "24", [
    "m12.86 14.27 7.43 7.44a1 1 0 0 0 1.42-1.42l-18-18a1 1 0 1 0-1.42 1.42l3.1 3.1a12 12 0 0 0-3.21 3.17 1 1 0 0 0 1.64 1.14q.56-.79 1.16-1.4a10 10 0 0 1 1.86-1.47L7.99 9.4a8 8 0 0 0-3.2 3.38 1 1 0 0 0 1.78.9 6 6 0 0 1 2.9-2.8l1.41 1.42a5.2 5.2 0 0 0-3.63 3.01 1 1 0 0 0 1.83.8q.25-.58.67-1a3.2 3.2 0 0 1 3.1-.84m-1.33-5.93 2.22 2.23a6 6 0 0 1 3.76 3.13 1 1 0 1 0 1.78-.9 8.1 8.1 0 0 0-7.76-4.45M8.5 5.33l1.65 1.65a9.9 9.9 0 0 1 10.02 4.15 1 1 0 1 0 1.64-1.14q-.63-.91-1.4-1.7A11.9 11.9 0 0 0 8.5 5.34m4.55 11.11a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
]);
const $82e7c60f6344ef74$export$16890541d81e5684 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l3.36 3.36a12 12 0 0 0-3.42 3.33.75.75 0 1 0 1.23.85q.58-.84 1.22-1.48.96-.95 2.06-1.6l1.6 1.59a8 8 0 0 0-3.42 3.48.75.75 0 0 0 1.34.67 6.5 6.5 0 0 1 3.2-3.03l1.93 1.93a5.1 5.1 0 0 0-3.94 3 .75.75 0 0 0 1.37.61q.29-.64.75-1.11a3.6 3.6 0 0 1 3.36-.96l7.86 7.86a.75.75 0 0 0 1.06-1.06zm8.3 6.18L13.17 10a6.5 6.5 0 0 1 4.73 3.51.75.75 0 0 0 1.34-.68 8.04 8.04 0 0 0-7.65-4.42m-3.1-3.1 1.23 1.23a10.4 10.4 0 0 1 10.91 4.3.75.75 0 0 0 1.24-.85q-.64-.93-1.41-1.7A12 12 0 0 0 8.49 5.3m4.58 11.14a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
]);
const $82e7c60f6344ef74$export$b1122fb4f1f3a0ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiOff48Filled', "48", [
    "M4.37 4.37a1.25 1.25 0 0 1 1.76 0l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76L29.48 31.25A8 8 0 0 0 24 29a7.3 7.3 0 0 0-6.55 4.14 1.5 1.5 0 0 1-2.71-1.28 10.3 10.3 0 0 1 9.5-5.86l-4.4-4.39a14.3 14.3 0 0 0-8.05 6.3 1.5 1.5 0 0 1-2.58-1.55 17.3 17.3 0 0 1 8.29-7.1l-3.68-3.67a21.4 21.4 0 0 0-7.42 6.75 1.5 1.5 0 0 1-2.48-1.68c2-2.95 4.63-5.44 7.7-7.27L4.38 6.13a1.25 1.25 0 0 1 0-1.76M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-15a17.2 17.2 0 0 1 14.79 8.36 1.5 1.5 0 0 1-2.58 1.55q-.16-.3-.36-.58A14.3 14.3 0 0 0 25.7 21.1l-3.05-3.05Q23.32 18 24 18m0-8c8.36 0 15.73 4.23 20.09 10.66a1.5 1.5 0 0 1-2.49 1.68 21.2 21.2 0 0 0-23.24-8.58l-2.4-2.4A24 24 0 0 1 24 10"
]);
const $82e7c60f6344ef74$export$96c3b70e665a7c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiOff48Regular', "48", [
    "M4.37 4.37a1.25 1.25 0 0 1 1.76 0l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76L27.72 29.5a7.5 7.5 0 0 0-10.69 3.72 1.25 1.25 0 0 1-2.32-.93A10 10 0 0 1 24.24 26l-4.78-4.77a14.5 14.5 0 0 0-8.12 6.7 1.25 1.25 0 0 1-2.18-1.23 17 17 0 0 1 8.35-7.42l-4.03-4.03a21.6 21.6 0 0 0-7.6 7.17 1.25 1.25 0 0 1-2.1-1.35c2-3.12 4.7-5.74 7.87-7.65L4.37 6.13a1.25 1.25 0 0 1 0-1.76M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0-15a17 17 0 0 1 14.84 8.7 1.25 1.25 0 1 1-2.18 1.22 14.5 14.5 0 0 0-11.52-7.37l-2.49-2.5Q23.32 18 24 18m0-8c8.5 0 15.96 4.42 20.22 11.07a1.25 1.25 0 0 1-2.1 1.35 21.5 21.5 0 0 0-24.16-9.06l-1.99-1.98Q19.75 10 24 10"
]);
const $82e7c60f6344ef74$export$f6910ed96e7720ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiSettings20Filled', "20", [
    "M17.84 8.12a9.47 9.47 0 0 0-15.6 0 .75.75 0 1 0 1.23.85q.43-.64.93-1.14a7.97 7.97 0 0 1 12.21 1.14.75.75 0 1 0 1.23-.85M7.11 11.05a4.1 4.1 0 0 1 4.18-1.02q-.75.54-1.3 1.31a2.6 2.6 0 0 0-2.36 1.58.75.75 0 1 1-1.38-.6q.32-.71.86-1.27m7.48-2.39.33.36a6 6 0 0 0-1.97.2 4.94 4.94 0 0 0-7.32 1.76.75.75 0 1 1-1.34-.68q.45-.9 1.19-1.64a6.44 6.44 0 0 1 9.11 0m-2.52 2.78a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $82e7c60f6344ef74$export$a265e320d9bfdcbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiSettings20Regular', "20", [
    "M17.96 8.18a9.61 9.61 0 0 0-15.85 0 .5.5 0 0 0 .83.56q.48-.69 1-1.22a8.6 8.6 0 0 1 13.2 1.23.5.5 0 1 0 .82-.57m-10.78 3.1a4 4 0 0 1 3.85-1.05q-.48.39-.86.88a3 3 0 0 0-2.91 1.82.5.5 0 1 1-.92-.4q.3-.72.84-1.24m7.42-2.5.2.23a6 6 0 0 0-1.35.09 5.45 5.45 0 0 0-8.28 1.79.5.5 0 0 1-.89-.46q.45-.9 1.2-1.64a6.45 6.45 0 0 1 9.12 0m-2.53 2.66a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $82e7c60f6344ef74$export$3bb624e7ec87f850 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiWarning20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_20_color__a)",
            "d": "M10 6C7.2 6 4.7 7.28 3.05 9.28a1 1 0 1 1-1.54-1.27 10.98 10.98 0 0 1 16.98 0 1 1 0 1 1-1.54 1.27A9 9 0 0 0 10 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_20_color__b)",
            "d": "M5.25 11.33a6 6 0 0 1 9.5 0 1 1 0 0 0 1.58-1.22 8 8 0 0 0-12.66 0 1 1 0 0 0 1.58 1.22"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_20_color__c)",
            "d": "M7.49 13.36a3 3 0 0 1 5.02 0 1 1 0 1 0 1.67-1.1 5 5 0 0 0-8.37 0 1 1 0 1 0 1.68 1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_20_color__d)",
            "d": "M10 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_20_color__e)",
            "d": "m13.6 10.55-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_20_color__f)",
            "d": "M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_warning_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_warning_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_warning_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_warning_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11 15.3509 0 10 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wifi_warning_20_color__e",
                "x1": "11.41",
                "x2": "17.31",
                "y1": "8.59",
                "y2": "19.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wifi_warning_20_color__f",
                "x1": "13.16",
                "x2": "16.37",
                "y1": "11.99",
                "y2": "17.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$bcb4e2ab1654b69c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiWarning20Filled', "20", [
    "M16.73 7.56q.6.62 1.11 1.35a.75.75 0 0 1-1.23.85q-.43-.62-.94-1.14a7.97 7.97 0 0 0-12.2 1.14.75.75 0 1 1-1.23-.86q.51-.75 1.1-1.34c3.7-3.7 9.7-3.7 13.39 0M5.48 9.46a6.44 6.44 0 0 1 8.65-.43c-.52.1-1 .4-1.31.9a4.94 4.94 0 0 0-7.2 1.84.75.75 0 0 1-1.33-.67q.45-.91 1.19-1.65m4.3 6.51 1.08-2.15a1.24 1.24 0 1 0-1.08 2.15m1.7-3.4.68-1.35a4.13 4.13 0 0 0-5.9 1.9.75.75 0 0 0 1.37.6q.2-.49.54-.82c.9-.9 2.3-1.01 3.31-.33m2.12-2.02-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $82e7c60f6344ef74$export$66633bc65749e630 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiWarning20Regular', "20", [
    "M16.83 7.38q.62.63 1.14 1.37a.5.5 0 1 1-.83.57q-.46-.67-1.01-1.23A8.6 8.6 0 0 0 2.94 9.31a.5.5 0 1 1-.82-.57 9.61 9.61 0 0 1 14.71-1.36M5.48 9.36a6.45 6.45 0 0 1 8.75-.34q-.57.07-1.03.46a5.45 5.45 0 0 0-8.03 1.97.5.5 0 1 1-.89-.45q.45-.9 1.2-1.64m4.3 6.62 1.12-2.25a1.3 1.3 0 1 0-1.12 2.25m1.9-3.82.46-.9a4.03 4.03 0 0 0-5.8 1.84.5.5 0 0 0 .92.4q.24-.54.63-.94a3 3 0 0 1 3.8-.4m1.92-1.6-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $82e7c60f6344ef74$export$f0a6b61073c20db4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiWarning24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_24_color__a)",
            "d": "M17.78 10.7c.6.6 1.12 1.33 1.5 2.1a1 1 0 0 1-1.77.9q-.46-.89-1.14-1.58a6.13 6.13 0 0 0-9.8 1.56 1 1 0 0 1-1.78-.9q.57-1.15 1.5-2.07a8.13 8.13 0 0 1 11.5 0m-2.04 3q.7.7 1.1 1.62a1 1 0 0 1-1.84.8 3.23 3.23 0 0 0-5.93-.01 1 1 0 1 1-1.83-.8q.4-.91 1.1-1.61a5.23 5.23 0 0 1 7.4 0m4.68-5.4q.77.77 1.4 1.69a1 1 0 0 1-1.64 1.14q-.53-.78-1.17-1.42a9.92 9.92 0 0 0-15.19 1.41 1 1 0 0 1-1.64-1.14A11.92 11.92 0 0 1 20.42 8.3m-7.36 8.14a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_24_color__b)",
            "d": "m16.16 12.83-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wifi_warning_24_color__c)",
            "d": "M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wifi_warning_24_color__b",
                "x1": "13.72",
                "x2": "20.94",
                "y1": "10.28",
                "y2": "24.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wifi_warning_24_color__c",
                "x1": "16.17",
                "x2": "19.38",
                "y1": "15",
                "y2": "20.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_wifi_warning_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -12.4917 17.6003 0 12 17.3)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".11",
                    "stopColor": "#8b52f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ]
    ]
], {
    color: true
});
const $82e7c60f6344ef74$export$386e470c899f924 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiWarning24Filled', "24", [
    "m17.78 10.7.35.38c-.8-.2-1.67-.02-2.3.56a6.13 6.13 0 0 0-9.26 2.04 1 1 0 0 1-1.78-.9q.57-1.15 1.5-2.07a8.13 8.13 0 0 1 11.5 0M11.96 19l1.21-2.43-.1-.13A1.5 1.5 0 1 0 11.95 19m2.07-4.15.9-1.8a5.23 5.23 0 0 0-7.69 2.26 1 1 0 1 0 1.84.8q.25-.58.67-1a3.23 3.23 0 0 1 4.28-.26m6.39-6.55q.77.77 1.4 1.69a1 1 0 0 1-1.64 1.14q-.53-.78-1.17-1.42a9.92 9.92 0 0 0-15.19 1.41 1 1 0 0 1-1.64-1.14A11.92 11.92 0 0 1 20.42 8.3m-4.26 4.53-4 8A1.5 1.5 0 0 0 13.5 23h8a1.5 1.5 0 0 0 1.34-2.17l-4-8a1.5 1.5 0 0 0-2.68 0M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $82e7c60f6344ef74$export$a02f9fcf1af9f789 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WifiWarning24Regular', "24", [
    "m17.74 10.75.3.3a2.5 2.5 0 0 0-1.85.31 6.56 6.56 0 0 0-10 2.12.75.75 0 1 1-1.34-.67q.57-1.14 1.5-2.06a8.06 8.06 0 0 1 11.4 0M11.96 19l1.21-2.43-.11-.13a1.5 1.5 0 1 0-1.1 2.56m2.23-4.46.67-1.36a5.1 5.1 0 0 0-7.48 2.2.75.75 0 0 0 1.37.61q.29-.64.75-1.11a3.6 3.6 0 0 1 4.69-.34m6.26-6.26q.77.77 1.4 1.7a.75.75 0 1 1-1.23.85q-.56-.82-1.23-1.5a10.45 10.45 0 0 0-16 1.5.75.75 0 0 1-1.23-.86q.65-.94 1.4-1.7a11.95 11.95 0 0 1 16.89 0m-4.3 4.55-3.99 8A1.5 1.5 0 0 0 13.5 23h8a1.5 1.5 0 0 0 1.34-2.17l-4-8a1.5 1.5 0 0 0-2.68 0M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);


"use client";
const $76e5a570f6bfc30c$export$b66bed748f703ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach12Filled', "12", [
    "M8.98 2.8a1.7 1.7 0 0 0-2.3.09l-3.4 3.39a.75.75 0 1 1-1.06-1.06l3.4-3.4a3.2 3.2 0 1 1 4.45 4.58l-4.72 4.5a1.92 1.92 0 0 1-2.69-2.76L6.9 3.9a.75.75 0 1 1 1.06 1.06L3.72 9.2a.42.42 0 0 0 .6.6l4.72-4.49a1.7 1.7 0 0 0-.06-2.5"
]);
const $76e5a570f6bfc30c$export$503edc55bdf5f3d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach12Regular', "12", [
    "M9.01 2.58a2 2 0 0 0-2.83 0L2.85 5.83a.5.5 0 0 1-.7 0 .5.5 0 0 1 0-.7l3.33-3.28a3 3 0 0 1 4.24.02 3 3 0 0 1 0 4.23l-4.33 4.32c-.77.76-2.01.76-2.78 0-.76-.76-.76-2 0-2.76l4.04-4.03c.2-.2.51-.2.71 0s.2.51 0 .7L3.32 8.38a.95.95 0 0 0 0 1.35c.38.38.98.38 1.36 0L9 5.41a2 2 0 0 0 0-2.83"
]);
const $76e5a570f6bfc30c$export$69c595d480ed8503 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach16Filled', "16", [
    "M9.5 1.75c-1 0-1.94.39-2.65 1.1l-4.6 4.6A.75.75 0 0 0 3.31 8.5l4.6-4.6a2.25 2.25 0 0 1 3.18 3.18l-5.3 5.3a.75.75 0 0 1-1.06-1.06l5.3-5.3a.75.75 0 0 0-1.06-1.06l-5.3 5.3a2.25 2.25 0 1 0 3.18 3.18l5.3-5.3a3.75 3.75 0 0 0-2.65-6.4"
]);
const $76e5a570f6bfc30c$export$d19ceacedf81b30c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach16Regular', "16", [
    "M2.28 7.98a.5.5 0 0 0 .86.35l4.6-4.6A2.5 2.5 0 0 1 12 5.5a2.5 2.5 0 0 1-.73 1.77l-5.3 5.3a1 1 0 0 1-1.71-.7 1 1 0 0 1 .3-.71l5.3-5.3a.5.5 0 0 0-.7-.7l-5.32 5.29a2 2 0 1 0 2.83 2.83l5.3-5.3A3.49 3.49 0 0 0 9.5 2c-.9 0-1.8.34-2.48 1.02l-4.6 4.6a.5.5 0 0 0-.14.35"
]);
const $76e5a570f6bfc30c$export$7c6e8775e8ca2481 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach20Filled', "20", [
    "m5.28 10.6 5.3-5.3a2.75 2.75 0 1 1 3.9 3.9L8.1 15.55a1.25 1.25 0 1 1-1.77-1.77L12 8.13a.75.75 0 0 0-1.06-1.06l-5.66 5.66a2.75 2.75 0 0 0 3.89 3.89l6.36-6.36a4.25 4.25 0 0 0-6-6.02l-5.31 5.3a.75.75 0 0 0 1.06 1.07"
]);
const $76e5a570f6bfc30c$export$56a0814980ca6b5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach20Regular', "20", [
    "m4.83 10.48 5.65-5.65a3 3 0 0 1 4.25 4.24L8 15.8a1.5 1.5 0 0 1-2.12-2.12l6-6.01a.5.5 0 1 0-.7-.71l-6 6.01a2.5 2.5 0 0 0 3.53 3.54l6.71-6.72a4 4 0 1 0-5.65-5.66L4.12 9.78a.5.5 0 0 0 .7.7"
]);
const $76e5a570f6bfc30c$export$f448817a9263ead0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach24Filled', "24", [
    "M16 2a6 6 0 0 1 4.4 10.08l-.2.2L11.49 21l-.05.04-.06.05a3.71 3.71 0 0 1-6.15-2.82c0-.9.33-1.76.9-2.42l.15-.17h.01l7.3-7.31a1 1 0 0 1 1.4 1.41L7.7 17.1l-.01.01q-.46.5-.47 1.18a1.72 1.72 0 0 0 2.76 1.38l.12-.1 8.7-8.7.16-.17a4 4 0 0 0-5.75-5.55l-.16.16-.02.01-9.32 9.33a1 1 0 0 1-1.42-1.41L11.6 3.9l.05-.04A6 6 0 0 1 16 2"
]);
const $76e5a570f6bfc30c$export$b3e25791f7e85511 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach24Regular', "24", [
    "M11.77 3.74a6 6 0 0 1 8.66 8.3l-.19.2-8.8 8.8-.03.03a3.72 3.72 0 0 1-5.4-5.1l.05-.06.08-.09.14-.15 7.44-7.45c.27-.27.69-.29.98-.07l.08.07c.27.27.3.68.08.98l-.08.08-7.59 7.61a2.23 2.23 0 0 0 3.17 3.1l8.84-8.82A4.5 4.5 0 0 0 13 4.64l-.17.16-.01.02-9.54 9.53a.75.75 0 0 1-1.13-.97l.07-.09z"
]);
const $76e5a570f6bfc30c$export$9a15ac51ad6ddd4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach28Filled', "28", [
    "M22.04 5.47a5 5 0 0 0-7.08 0L3.7 16.7a1 1 0 1 1-1.42-1.42L13.54 4.05a7 7 0 1 1 9.9 9.92L12.63 24.78a4.18 4.18 0 0 1-5.9-5.9L17.54 8.03a1 1 0 0 1 1.42 1.42L8.13 20.29a2.18 2.18 0 0 0 3.08 3.08l10.83-10.81a5 5 0 0 0 0-7.09"
]);
const $76e5a570f6bfc30c$export$a3230949180e6b6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach28Regular', "28", [
    "M22.46 5.04a5.26 5.26 0 0 0-7.44 0L3.28 16.78a.75.75 0 0 1-1.06-1.06L13.96 3.98a6.76 6.76 0 1 1 9.55 9.56L12.2 24.85a3.93 3.93 0 0 1-5.55-5.55L17.72 8.22a.75.75 0 1 1 1.06 1.06L7.7 20.36a2.43 2.43 0 0 0 3.43 3.43l11.32-11.3a5.26 5.26 0 0 0 0-7.45"
]);
const $76e5a570f6bfc30c$export$1c1213514b2f6978 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach32Filled', "32", [
    "M16.03 4.4A8.18 8.18 0 1 1 27.6 15.97L15.06 28.52a5.06 5.06 0 1 1-7.16-7.17l11.14-11.14a1.25 1.25 0 1 1 1.77 1.77L9.67 23.12a2.56 2.56 0 0 0 3.62 3.63L25.84 14.2a5.68 5.68 0 1 0-8.04-8.03L4.13 19.83a1.25 1.25 0 1 1-1.76-1.77z"
]);
const $76e5a570f6bfc30c$export$d6efb601028a1598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach32Light', "32", [
    "M17.08 4.22 2.15 19.15a.5.5 0 0 0 .7.7L17.78 4.92a6.57 6.57 0 1 1 9.3 9.3L13.28 28a3.39 3.39 0 1 1-4.79-4.8l11.86-11.86a.5.5 0 0 0-.7-.7L7.79 22.5a4.39 4.39 0 0 0 6.2 6.2l13.8-13.79a7.57 7.57 0 1 0-10.71-10.7"
]);
const $76e5a570f6bfc30c$export$20b0a90d82882550 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach32Regular', "32", [
    "M16.22 4.36a8.07 8.07 0 1 1 11.42 11.42l-12.8 12.79a4.89 4.89 0 0 1-6.9-6.92L19.28 10.3a1 1 0 0 1 1.42 1.42L9.35 23.07a2.89 2.89 0 0 0 4.08 4.08l12.8-12.79a6.07 6.07 0 1 0-8.6-8.58L3.72 19.7a1 1 0 1 1-1.42-1.42z"
]);
const $76e5a570f6bfc30c$export$d1b489b1deea602f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach48Filled', "48", [
    "M38.5 9.69a8.85 8.85 0 0 0-12.55-.16L6.55 28.57a1.5 1.5 0 0 1-2.1-2.14l19.4-19.04a11.85 11.85 0 0 1 16.64 16.89L22.74 41.83a7.52 7.52 0 1 1-10.5-10.76l15.22-14.65a1.5 1.5 0 0 1 2.08 2.16L14.32 33.23a4.52 4.52 0 1 0 6.31 6.46l17.75-17.54a8.85 8.85 0 0 0 .12-12.46"
]);
const $76e5a570f6bfc30c$export$a52a8d8e2e252fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Attach48Regular', "48", [
    "M38.94 9.49a9.46 9.46 0 0 0-13.6-.2L6.13 28.64a1.25 1.25 0 0 1-1.78-1.76l19.2-19.33a11.96 11.96 0 1 1 16.9 16.91L22.96 41.8a7.59 7.59 0 1 1-10.58-10.87l15.26-14.58a1.25 1.25 0 0 1 1.72 1.8L14.11 32.73a5.09 5.09 0 1 0 7.1 7.3l17.5-17.35a9.46 9.46 0 0 0 .23-13.2"
]);
const $76e5a570f6bfc30c$export$2fb14d8bab99f24b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachArrowRight20Filled', "20", [
    "m5.28 10.6 5.3-5.3A2.75 2.75 0 0 1 14.65 9q.84.03 1.6.29a4.25 4.25 0 0 0-6.73-5.05l-5.3 5.3a.75.75 0 0 0 1.06 1.07m2.83 4.96.9-.9q.02.94.34 1.78l-.18.18a2.75 2.75 0 0 1-3.89-3.89l5.66-5.66A.75.75 0 1 1 12 8.13L6.34 13.8a1.25 1.25 0 0 0 1.77 1.77M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$c76bb16d57afc0ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachArrowRight20Regular', "20", [
    "m4.83 10.48 5.65-5.65A3 3 0 0 1 14.79 9q.6.03 1.14.18a4 4 0 0 0-6.14-5.07L4.12 9.78a.5.5 0 0 0 .7.7M8 15.78l1-.99q.03.63.2 1.21l-.5.5a2.5 2.5 0 1 1-3.53-3.54l6.01-6.01a.5.5 0 1 1 .7.7l-6 6.02A1.5 1.5 0 0 0 8 15.79M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 1 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$f10b0478c4c7bee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachArrowRight24Filled', "24", [
    "M16 2a6 6 0 0 1 4.64 9.8 7 7 0 0 0-2.07-.71l.23-.23.16-.17a4 4 0 0 0-5.75-5.55l-.16.16-.02.01-9.32 9.33a1 1 0 0 1-1.42-1.41L11.6 3.9l.05-.04A6 6 0 0 1 16 2M11.1 18.57q.18 1.13.73 2.1l-.34.34-.05.04-.06.05a3.71 3.71 0 0 1-6.15-2.82c0-.9.33-1.76.9-2.42l.15-.17h.01l7.3-7.31a1 1 0 0 1 1.4 1.41L7.7 17.1l-.01.01q-.46.5-.47 1.18a1.72 1.72 0 0 0 2.76 1.38l.12-.1zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $76e5a570f6bfc30c$export$f73aff43d535b02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachArrowRight24Regular', "24", [
    "M11.77 3.74a6 6 0 0 1 8.87 8.07 7 7 0 0 0-1.49-.6l.05-.04A4.5 4.5 0 0 0 13 4.64l-.17.16-.01.02-9.54 9.53a.75.75 0 0 1-1.13-.97l.07-.09zm-.56 15.41q.21.8.61 1.51l-.38.38-.03.03a3.72 3.72 0 0 1-5.4-5.1l.05-.06.08-.09.14-.15 7.44-7.45c.27-.27.69-.29.98-.07l.08.07c.27.27.3.68.08.98l-.08.08-7.59 7.61a2.23 2.23 0 0 0 3.17 3.1zm11.8-1.65a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.78l-1.64 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 1 0-.7.7L19.29 17z"
]);
const $76e5a570f6bfc30c$export$157710b1f8008d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachText20Filled', "20", [
    "M6.75 3.5c-1.24 0-2.25 1-2.25 2.25v7.5a.75.75 0 0 1-1.5 0v-7.5a3.75 3.75 0 0 1 7.5-.25v10.25a2.25 2.25 0 0 1-4.5 0V5.77a.75.75 0 0 1 1.5 0v9.98a.75.75 0 0 0 1.5 0v-10C9 4.51 8 3.5 6.75 3.5M12 8.25c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM12 11.25c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$672a3d53396ea0f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachText20Regular', "20", [
    "M6.5 4A2.5 2.5 0 0 0 4 6.5V14a.5.5 0 0 1-1 0V6.5a3.5 3.5 0 1 1 7 0V15a2 2 0 0 1-4 0V6.5a.5.5 0 0 1 1 0V15a1 1 0 1 0 2 0V6.5A2.5 2.5 0 0 0 6.5 4M12 5.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm-.5 3.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$7908f38e0f985c47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachText24Filled', "24", [
    "M7 3a5 5 0 0 1 5 4.78V19a3 3 0 0 1-6 .18V9a1 1 0 0 1 2-.12V19a1 1 0 0 0 2 .12V8a3 3 0 0 0-6-.18V17a1 1 0 0 1-2 .12V8a5 5 0 0 1 5-5m8 14h2a1 1 0 0 1 .12 2H15a1 1 0 0 1-.12-2zh2zm0-4h5.5a1 1 0 0 1 .12 2H15a1 1 0 0 1-.12-2zh5.5zm0-4h5.5a1 1 0 0 1 .12 2H15a1 1 0 0 1-.12-2zh5.5zm0-4h5.5a1 1 0 0 1 .12 2H15a1 1 0 0 1-.12-2zh5.5z"
]);
const $76e5a570f6bfc30c$export$e412a8b6a8dd2d9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachText24Regular', "24", [
    "M7.25 3.5c2.28 0 4.14 1.8 4.25 4.04V18.5a2.5 2.5 0 0 1-5 .16V9A.75.75 0 0 1 8 8.9v9.6a1 1 0 0 0 2 .12V7.75a2.75 2.75 0 0 0-5.5-.17V17a.75.75 0 0 1-1.5.1V7.75C3 5.4 4.9 3.5 7.25 3.5m9 12.5a.75.75 0 0 1 .1 1.5h-2.6a.75.75 0 0 1-.1-1.5h2.6m4-3a.75.75 0 0 1 .1 1.5h-6.6a.75.75 0 0 1-.1-1.5h6.6m0-3a.75.75 0 0 1 .1 1.5h-6.6a.75.75 0 0 1-.1-1.5h6.6m0-3a.75.75 0 0 1 .1 1.5h-6.6a.75.75 0 0 1-.1-1.5h6.6"
]);
const $76e5a570f6bfc30c$export$ed7ee3a7c18f7da8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bed16Filled', "16", [
    "M7.5 6h1v-.5c0-.28.22-.5.5-.5h1.5c.28 0 .5.22.5.5V6h2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2h2v-.5c0-.28.22-.5.5-.5H7c.28 0 .5.22.5.5zm-4 1A2.5 2.5 0 0 0 1 9.5v4a.5.5 0 0 0 1 0V11h12v2.5a.5.5 0 0 0 1 0v-4A2.5 2.5 0 0 0 12.5 7z"
]);
const $76e5a570f6bfc30c$export$33011397adb1e7fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bed16Regular', "16", [
    "M3 4.5A2.5 2.5 0 0 1 5.5 2h5A2.5 2.5 0 0 1 13 4.5v1.55a2.5 2.5 0 0 1 2 2.45v5a.5.5 0 0 1-1 0V11H2v2.5a.5.5 0 0 1-1 0v-5c0-1.2.86-2.22 2-2.45zM2 10h12V8.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 7 2 7.67 2 8.5zm10-5.5c0-.83-.67-1.5-1.5-1.5h-5C4.67 3 4 3.67 4 4.5V6h1v-.5c0-.28.22-.5.5-.5H7c.28 0 .5.22.5.5V6h1v-.5c0-.28.22-.5.5-.5h1.5c.28 0 .5.22.5.5V6h1z"
]);
const $76e5a570f6bfc30c$export$ec27f355052b4ad6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bed20Filled', "20", [
    "M15.5 9a2.5 2.5 0 0 1 2.5 2.34v5.16a.5.5 0 0 1-1 .09V14H3v2.5a.5.5 0 0 1-1 .09V11.5A2.5 2.5 0 0 1 4.34 9H15.5m-9-6h7A2.5 2.5 0 0 1 16 5.34V8h-2v-.5a.5.5 0 0 0-.41-.5H11a.5.5 0 0 0-.5.41V8h-1v-.5a.5.5 0 0 0-.41-.5H6.5a.5.5 0 0 0-.5.41V8H4V5.5A2.5 2.5 0 0 1 6.34 3z"
]);
const $76e5a570f6bfc30c$export$aff8c1231994b275 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bed20Regular', "20", [
    "M13.5 3A2.5 2.5 0 0 1 16 5.34v2.71a2.5 2.5 0 0 1 2 2.28v6.17a.5.5 0 0 1-1 .09V14H3v2.5a.5.5 0 0 1-1 .09V10.5a2.5 2.5 0 0 1 2-2.45V5.5A2.5 2.5 0 0 1 6.34 3h7.16m2 6h-11c-.78 0-1.42.6-1.5 1.36V13h14v-2.5c0-.78-.6-1.42-1.36-1.5zm-2-5h-7c-.78 0-1.42.6-1.5 1.36V8h1v-.5c0-.28.22-.5.5-.5H9c.28 0 .5.22.5.5V8h1v-.5c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5V8h1V5.5c0-.78-.6-1.42-1.36-1.5z"
]);
const $76e5a570f6bfc30c$export$c957ad3eb74cea07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bed24Filled', "24", [
    "M19.25 11A2.75 2.75 0 0 1 22 13.58v6.67a.75.75 0 0 1-1.5.1V18h-17v2.25c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1v-6.5a2.75 2.75 0 0 1 2.58-2.74l.17-.01zM6.75 4h10.5A2.75 2.75 0 0 1 20 6.58V10h-3v-.12a1 1 0 0 0-.88-.87L16 9h-2a1 1 0 0 0-1 .88V10h-2v-.12a1 1 0 0 0-.88-.87L10 9H8a1 1 0 0 0-1 .88V10H4V6.75a2.75 2.75 0 0 1 2.58-2.74z"
]);
const $76e5a570f6bfc30c$export$9559a9bbd14316df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bed24Regular', "24", [
    "M6.75 4h10.5A2.75 2.75 0 0 1 20 6.58v3.52a2.75 2.75 0 0 1 2 2.46v7.69a.75.75 0 0 1-1.5.1V18h-17v2.25c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1v-7.5c0-1.26.85-2.32 2-2.65V6.75a2.75 2.75 0 0 1 2.58-2.74zm12.5 7.5H4.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h17v-3.75c0-.65-.5-1.18-1.12-1.24zm-2-6H6.75c-.65 0-1.18.5-1.24 1.12l-.01.13V10H7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 .88V10h2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 .88V10h1.5V6.75c0-.65-.5-1.18-1.12-1.24z"
]);
const $76e5a570f6bfc30c$export$a7904871165d9395 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAll16Filled', "16", [
    "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v2.5h3.75V3.5zm4 0v3.75h3.75v-2.5c0-.69-.56-1.25-1.25-1.25zm3.75 5.25H8.75v3.75h2.5c.69 0 1.25-.56 1.25-1.25zM7.25 12.5V8.75H3.5v2.5c0 .69.56 1.25 1.25 1.25zM2 4.75A2.75 2.75 0 0 1 4.75 2h6.5A2.75 2.75 0 0 1 14 4.75v6.5A2.75 2.75 0 0 1 11.25 14h-6.5A2.75 2.75 0 0 1 2 11.25z"
]);
const $76e5a570f6bfc30c$export$ed98593fad8b2e27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAll16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5v3h4.5V3zm4 0v4.5H13v-3c0-.83-.67-1.5-1.5-1.5zM13 8.5H8.5V13h3c.83 0 1.5-.67 1.5-1.5zM7.5 13V8.5H3v3c0 .83.67 1.5 1.5 1.5z"
]);
const $76e5a570f6bfc30c$export$a2f839a5daeaa731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAll20Filled', "20", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v3h4.75V4.5zm4.5 0v4.75h4.75v-3c0-.97-.78-1.75-1.75-1.75zm4.75 6.25h-4.75v4.75h3c.97 0 1.75-.78 1.75-1.75zM9.25 15.5v-4.75H4.5v3c0 .97.78 1.75 1.75 1.75zM3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z"
]);
const $76e5a570f6bfc30c$export$2ea808f5bfe08b55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAll20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v3.5h5.5V4zm4.5 0v5.5H16V6a2 2 0 0 0-2-2zm5.5 6.5h-5.5V16H14a2 2 0 0 0 2-2zM9.5 16v-5.5H4V14c0 1.1.9 2 2 2z"
]);
const $76e5a570f6bfc30c$export$5fbeafe0f6e45da3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAll24Filled', "24", [
    "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm10 13h5a1 1 0 0 0 1-1v-5h-6zm-2-6H5v5a1 1 0 0 0 1 1h5zm2-2h6V6a1 1 0 0 0-1-1h-5zm-2-6H6a1 1 0 0 0-1 1v5h6z"
]);
const $76e5a570f6bfc30c$export$17dab970a99a36ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAll24Regular', "24", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25zm9.75 13.75h5.5c.69 0 1.25-.56 1.25-1.25v-5.5h-6.75zm-1.5-6.75H4.5v5.5c0 .69.56 1.25 1.25 1.25h5.5zm1.5-1.5h6.75v-5.5c0-.69-.56-1.25-1.25-1.25h-5.5zm-1.5-6.75h-5.5c-.69 0-1.25.56-1.25 1.25v5.5h6.75z"
]);
const $76e5a570f6bfc30c$export$33bd3f4eab9f26f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottom20Filled', "20", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m.71 11.75H14a1.5 1.5 0 0 0 1.43-1.03v-.01a.75.75 0 0 1 1.38.58A3 3 0 0 1 14 17H6a3 3 0 0 1-2.81-1.96.75.75 0 1 1 1.41-.49c.22.56.77.95 1.4.95zM4.61 5.45a1.5 1.5 0 0 1 .93-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.49m9.94-.85a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.5 1.41M3 11.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm13.25.75a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75"
]);
const $76e5a570f6bfc30c$export$55face111a5a69c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottom20Regular', "20", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.54 4.05a2 2 0 0 0-1.5 1.55.5.5 0 0 1-.59.4.5.5 0 0 1-.38-.66 3 3 0 0 1 2.34-2.29.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6M3.07 14.66l-.02-.07a.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47A2 2 0 0 0 6 16h8a2 2 0 0 0 1.95-1.6.5.5 0 0 1 .6-.4.5.5 0 0 1 .38.66A3 3 0 0 1 14 17H6a3 3 0 0 1-2.93-2.34M14.6 3.06l.07.01a3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47 2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .6-.4M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"
]);
const $76e5a570f6bfc30c$export$176cbb6fc2002d46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottom24Filled', "24", [
    "M13 5a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm-8 6a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm-2 7a1 1 0 1 1 2 0 1 1 0 0 0 1 1h12a1 1 0 0 0 1-1 1 1 0 1 1 2 0 3 3 0 0 1-3 3H6a3 3 0 0 1-3-3m17-8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1M7 4a1 1 0 0 0-1-1 3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 0 1 1-1 1 1 0 0 0 1-1m11-1a1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3"
]);
const $76e5a570f6bfc30c$export$8273b2aa18c682f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottom24Regular', "24", [
    "M6.25 3a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0v-.5A2.75 2.75 0 0 1 5.75 3zm11.5 0a.75.75 0 0 0 0 1.5h.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3zm-14 7c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m15.75.75a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zm-5.5-7c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75m-11 14a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25z"
]);
const $76e5a570f6bfc30c$export$6e5d9e5afb9caaca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomDouble20Filled', "20", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m-2.55.85a1.5 1.5 0 0 0-.88.94.75.75 0 0 1-1.38-.58 3 3 0 0 1 1.77-1.77.75.75 0 1 1 .5 1.41m9.95.85a1.5 1.5 0 0 0-.94-.88.75.75 0 0 1 .58-1.38 3 3 0 0 1 1.78 1.77h-.01a.75.75 0 1 1-1.41.49M3.75 11a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m11.75-.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0zm-12.5 6c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M3.75 13a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$489a9ee7f2a42ae9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomDouble20Regular', "20", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47M14.6 3.05l.07.02a3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47 2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .6-.4M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm0 5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m.5-2.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$a309746689352b8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomDouble24Filled', "24", [
    "M13 5a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm-8 6a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm-1 7a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm0 3a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm16-11a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1M7 4a1 1 0 0 0-1-1 3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 0 1 1-1 1 1 0 0 0 1-1m11-1a1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3"
]);
const $76e5a570f6bfc30c$export$15c1806992588a97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomDouble24Regular', "24", [
    "M13.25 4.5a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zM3.75 10c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m16.5 0a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75M3.75 21a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5zM3 17.75c0 .41.34.75.75.75h16.5a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0-.75.75m4-14A.75.75 0 0 0 6.25 3h-.5A2.75 2.75 0 0 0 3 5.75v.5a.75.75 0 0 0 1.5 0v-.5c0-.69.56-1.25 1.25-1.25h.5c.41 0 .75-.34.75-.75M17.75 3a.75.75 0 0 0 0 1.5h.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3z"
]);
const $76e5a570f6bfc30c$export$2f983381ed222bf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomThick20Filled', "20", [
    "M9 3a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-4.64.5a1 1 0 1 1 1.16 1.62 1 1 0 0 0-.4.4 1 1 0 0 1-1.84-.33 1 1 0 0 1 .22-.83q.34-.53.85-.87M6 15a1 1 0 0 1-.88-.52 1 1 0 0 0-1.84.33 1 1 0 0 0 .22.83A3 3 0 0 0 6 17h8a3 3 0 0 0 2.5-1.35 1 1 0 1 0-1.62-1.17A1 1 0 0 1 14 15zm9.64-11.5a1 1 0 1 0-1.16 1.62q.25.15.4.4a1 1 0 0 0 1.84-.33 1 1 0 0 0-.22-.83 3 3 0 0 0-.85-.87M4 12a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1m11-1a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0z"
]);
const $76e5a570f6bfc30c$export$32d698b514ac2e2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomThick20Regular', "20", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m.71 11.75H14a1.5 1.5 0 0 0 1.43-1.03v-.01a.75.75 0 0 1 1.38.58A3 3 0 0 1 14 17H6a3 3 0 0 1-2.81-1.96.75.75 0 1 1 1.41-.49c.22.56.77.95 1.4.95zM4.61 5.45a1.5 1.5 0 0 1 .93-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.49m9.94-.85a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.5 1.41M3 11.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm13.25.75a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75"
]);
const $76e5a570f6bfc30c$export$46795883da2393bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomThick24Filled', "24", [
    "M14 4a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-9 7a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm14 0a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zM6 3a1 1 0 0 1 0 2 1 1 0 0 0-1 1 1 1 0 0 1-2 0 3 3 0 0 1 3-3m11 1a1 1 0 0 1 1-1 3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 0 1-1-1M5.5 17.25v.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75v-.5a1.25 1.25 0 1 1 2.5 0V18a3.25 3.25 0 0 1-3.25 3H6.25a3.25 3.25 0 0 1-3.24-3H3v-.75a1.25 1.25 0 1 1 2.5 0"
]);
const $76e5a570f6bfc30c$export$a1a857482b3eb772 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomThick24Regular', "24", [
    "M14 3.75c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75m-9.5 7a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm15 0a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zM6.25 3a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0v-.5A2.75 2.75 0 0 1 5.75 3zM17 3.75c0-.41.34-.75.75-.75h.5A2.75 2.75 0 0 1 21 5.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25h-.5a.75.75 0 0 1-.75-.75M3 18a1 1 0 1 1 2 0 1 1 0 0 0 1 1h12a1 1 0 0 0 1-1 1 1 0 1 1 2 0 3 3 0 0 1-3 3H6a3 3 0 0 1-3-3"
]);
const $76e5a570f6bfc30c$export$4d86f7d652d155ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInside16Filled', "16", [
    "M4.36 3.53a.77.77 0 0 0-.22-1.52 2.5 2.5 0 0 0-2.13 2.13.77.77 0 0 0 1.52.22c.06-.43.4-.77.83-.83m-1.7 7.44c.42-.06.81.23.87.65s.4.77.83.83a.77.77 0 1 1-.22 1.53 2.5 2.5 0 0 1-2.13-2.14.77.77 0 0 1 .65-.87m11.32.87a.77.77 0 0 0-1.53-.22 1 1 0 0 1-.83.83.77.77 0 1 0 .22 1.53 2.5 2.5 0 0 0 2.14-2.14m-3.01-9.18a.77.77 0 0 1 .87-.65 2.5 2.5 0 0 1 2.14 2.13.77.77 0 0 1-1.53.22 1 1 0 0 0-.83-.83.77.77 0 0 1-.65-.87M7.25 2a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm-4.5 7.5A.75.75 0 0 1 2 8.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m4.5 3a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm6-3a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m-4.5-4.25a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2z"
]);
const $76e5a570f6bfc30c$export$909242189b0449b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInside16Regular', "16", [
    "M3 4.5C3 3.67 3.67 3 4.5 3a.5.5 0 0 0 0-1A2.5 2.5 0 0 0 2 4.5a.5.5 0 0 0 1 0M2.5 11c.28 0 .5.22.5.5 0 .83.67 1.5 1.5 1.5a.5.5 0 0 1 0 1A2.5 2.5 0 0 1 2 11.5c0-.28.22-.5.5-.5m11.5.5a.5.5 0 0 0-1 0c0 .83-.67 1.5-1.5 1.5a.5.5 0 0 0 0 1 2.5 2.5 0 0 0 2.5-2.5m-3-9c0-.28.22-.5.5-.5A2.5 2.5 0 0 1 14 4.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1-.5-.5m-2.5 2a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3zm-2-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M2 9a.5.5 0 0 0 1 0V7a.5.5 0 0 0-1 0zm4.5 4.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M13 9a.5.5 0 0 0 1 0V7a.5.5 0 0 0-1 0z"
]);
const $76e5a570f6bfc30c$export$836a0196d5648cde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInside20Filled', "20", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m0 12.5c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75M4.6 5.45a1.5 1.5 0 0 1 .94-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.49m9.95-.85a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.5 1.41M3 11.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm13.25.75a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75M4.6 14.55a1.5 1.5 0 0 0 .94.88.75.75 0 0 1-.58 1.38 3 3 0 0 1-1.77-1.77.75.75 0 1 1 1.41-.49m9.95.85a1.5 1.5 0 0 0 .88-.94.75.75 0 0 1 1.38.58 3 3 0 0 1-1.77 1.77.75.75 0 1 1-.5-1.41m-3.8-9.15a.75.75 0 0 0-1.5 0v3h-3a.75.75 0 0 0 0 1.5h3v3a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5h-3z"
]);
const $76e5a570f6bfc30c$export$48a4e41c951846ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInside20Regular', "20", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47m0 8.92a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47M14.66 3.07l-.07-.02a.5.5 0 0 0-.6.4.5.5 0 0 0 .47.6 2 2 0 0 1 1.5 1.55.5.5 0 0 0 .59.4.5.5 0 0 0 .38-.66 3 3 0 0 0-2.27-2.27m1.29 11.4a2 2 0 0 1-1.55 1.48.5.5 0 0 0-.4.6.5.5 0 0 0 .66.38 3 3 0 0 0 2.29-2.34.5.5 0 0 0-.4-.6.5.5 0 0 0-.6.47M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm5 5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m2.5-11a.5.5 0 0 0-1 0v4h-4a.5.5 0 0 0 0 1h4v4a.5.5 0 0 0 1 0v-4h4a.5.5 0 0 0 0-1h-4z"
]);
const $76e5a570f6bfc30c$export$70410c68b78f6ef7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInside24Filled', "24", [
    "M13 5a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm-9 5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m16 0a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m-6 10a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1M6 3a1 1 0 0 1 0 2 1 1 0 0 0-1 1 1 1 0 0 1-2 0 3 3 0 0 1 3-3m11 1a1 1 0 0 1 1-1 3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 0 1-1-1M6 21a1 1 0 1 0 0-2 1 1 0 0 1-1-1 1 1 0 1 0-2 0 3 3 0 0 0 3 3m11-1a1 1 0 0 0 1 1 3 3 0 0 0 3-3 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 0 0-1 1M13 7a1 1 0 1 0-2 0v4H7a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4z"
]);
const $76e5a570f6bfc30c$export$d69522caac8717b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInside24Regular', "24", [
    "M13.25 4.5a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zM3.75 10c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m16.5 0a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75M14 20.25c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75M6.25 3a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0v-.5A2.75 2.75 0 0 1 5.75 3zM17 3.75c0-.41.34-.75.75-.75h.5A2.75 2.75 0 0 1 21 5.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25h-.5a.75.75 0 0 1-.75-.75M6.25 21a.75.75 0 0 0 0-1.5h-.5c-.69 0-1.25-.56-1.25-1.25v-.5a.75.75 0 0 0-1.5 0v.5A2.75 2.75 0 0 0 5.75 21zM17 20.25c0 .41.34.75.75.75h.5A2.75 2.75 0 0 0 21 18.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .69-.56 1.25-1.25 1.25h-.5a.75.75 0 0 0-.75.75m-4.25-14a.75.75 0 0 0-1.5 0v5h-5a.75.75 0 0 0 0 1.5h5v5a.75.75 0 0 0 1.5 0v-5h5a.75.75 0 0 0 0-1.5h-5z"
]);
const $76e5a570f6bfc30c$export$44b57d1952798c68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeft20Filled', "20", [
    "M16.25 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M3 11.27V14a3 3 0 0 0 1.96 2.81.75.75 0 0 0 .58-1.38l-.07-.03A1.5 1.5 0 0 1 4.5 14V6a1.5 1.5 0 0 1 1.04-1.43.75.75 0 0 0-.58-1.38A3 3 0 0 0 3 6v5.27M14.55 4.6a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.49 1.41m.85 9.95a1.5 1.5 0 0 1-.94.88.75.75 0 0 0 .58 1.38 3 3 0 0 0 1.77-1.77.75.75 0 1 0-1.41-.5M8.75 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM8 16.25c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
]);
const $76e5a570f6bfc30c$export$8f4fadfb23f729c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeft20Regular', "20", [
    "M17 8.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-1.05-2.96a2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .66-.38 3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47M5.34 3.07l.07-.02a.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6A2 2 0 0 0 4 6v8a2 2 0 0 0 1.6 1.95.5.5 0 0 1 .4.6.5.5 0 0 1-.66.38A3 3 0 0 1 3 14V6a3 3 0 0 1 2.34-2.93m11.6 11.52-.01.07a3 3 0 0 1-2.34 2.29.5.5 0 0 1-.6-.4.5.5 0 0 1 .47-.6 2 2 0 0 0 1.5-1.55.5.5 0 0 1 .59-.4.5.5 0 0 1 .4.6M8 16.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$e21c343d39c0a79e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeft24Filled', "24", [
    "M6 21a1 1 0 1 0 0-2 1 1 0 0 1-1-1V6a1 1 0 0 1 1-1 1 1 0 0 0 0-2 3 3 0 0 0-3 3v12a3 3 0 0 0 3 3m7-16a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm6 6a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm-5 9a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m4-17a1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3m-1 17a1 1 0 0 0 1 1 3 3 0 0 0 3-3 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 0 0-1 1"
]);
const $76e5a570f6bfc30c$export$676a6d15d4ec3fd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeft24Regular', "24", [
    "M6.25 3a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h.5a.75.75 0 0 1 0 1.5h-.5A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3zm7 1.5a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zm6.25 6.25a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zm-5.5 9.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75M17.75 3a.75.75 0 0 0 0 1.5h.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3zM17 20.25c0 .41.34.75.75.75h.5A2.75 2.75 0 0 0 21 18.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .69-.56 1.25-1.25 1.25h-.5a.75.75 0 0 0-.75.75"
]);
const $76e5a570f6bfc30c$export$ac1a9c5d7659baed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRight20Filled', "20", [
    "M15.5 6a1.5 1.5 0 0 0-1.04-1.43.75.75 0 0 1 .58-1.38A3 3 0 0 1 17 6v8a3 3 0 0 1-1.96 2.82.75.75 0 0 1-.58-1.39l.07-.03c.57-.21.97-.76.97-1.4zM8.75 3a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm0 12.5a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM5.45 4.6A1.5 1.5 0 0 0 4.5 6v8a1.5 1.5 0 0 0 1.03 1.43h.01a.75.75 0 0 1-.58 1.38A3 3 0 0 1 3 14.02V6a3 3 0 0 1 1.96-2.82.75.75 0 1 1 .49 1.42"
]);
const $76e5a570f6bfc30c$export$d3f58c5f1f81bd7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRight20Regular', "20", [
    "m14.66 3.07-.07-.02a.5.5 0 0 0-.6.4.5.5 0 0 0 .47.6A2 2 0 0 1 16 6v8a2 2 0 0 1-1.6 1.95.5.5 0 0 0-.4.6.5.5 0 0 0 .66.38A3 3 0 0 0 17 14V6a3 3 0 0 0-2.34-2.93m-9.32 0 .07-.02a.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6A2 2 0 0 0 4 6v8a2 2 0 0 0 1.6 1.95.5.5 0 0 1 .4.6.5.5 0 0 1-.66.38A3 3 0 0 1 3 14V6a3 3 0 0 1 2.34-2.93M8 16.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$c46c6c8a831613a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRight24Filled', "24", [
    "M17 4a1 1 0 0 1 1-1 3 3 0 0 1 3 3v12a3 3 0 0 1-3 3 1 1 0 1 1 0-2 1 1 0 0 0 1-1V6a1 1 0 0 0-1-1 1 1 0 0 1-1-1m-4 1a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm0 14a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zM6 3a1 1 0 1 1 0 2 1 1 0 0 0-1 1v12a1 1 0 0 0 1 1 1 1 0 1 1 0 2 3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
]);
const $76e5a570f6bfc30c$export$65afe19b1a7f0bf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRight24Regular', "24", [
    "M17 3.75c0-.41.34-.75.75-.75h.5A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21h-.5a.75.75 0 0 1 0-1.5h.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25h-.5a.75.75 0 0 1-.75-.75m-3.75.75a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zm0 15a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zM6.25 3a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h.5a.75.75 0 0 1 0 1.5h-.5A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3z"
]);
const $76e5a570f6bfc30c$export$4f5bc01e0c1c7943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNone16Filled', "16", [
    "M5.01 2.66a.77.77 0 0 1-.65.87 1 1 0 0 0-.83.83.77.77 0 0 1-1.52-.22 2.5 2.5 0 0 1 2.13-2.13c.42-.06.81.23.87.65m-1.48 8.96a.77.77 0 1 0-1.52.22 2.5 2.5 0 0 0 2.13 2.14.77.77 0 0 0 .22-1.53 1 1 0 0 1-.83-.83m9.8-.65c.41.06.7.45.65.87a2.5 2.5 0 0 1-2.14 2.14.77.77 0 0 1-.22-1.53c.43-.06.77-.4.83-.83a.77.77 0 0 1 .87-.65m-1.49-8.96a.77.77 0 0 0-.22 1.52c.43.06.77.4.83.83a.77.77 0 1 0 1.53-.22 2.5 2.5 0 0 0-2.14-2.13m-5.34.74c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m-4.5 6a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0zm4.5 4.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m6-4.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0z"
]);
const $76e5a570f6bfc30c$export$eefa5d85242ef622 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNone16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 1 4.5 2a.5.5 0 0 1 0 1M3 11.5a.5.5 0 0 0-1 0A2.5 2.5 0 0 0 4.5 14a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 3 11.5m10.5-.5c.28 0 .5.22.5.5a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5 0-.28.22-.5.5-.5m-2-9a.5.5 0 0 0 0 1c.83 0 1.5.67 1.5 1.5a.5.5 0 0 0 1 0A2.5 2.5 0 0 0 11.5 2m-5 .5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M2 9a.5.5 0 0 0 1 0V7a.5.5 0 0 0-1 0zm4.5 4.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M13 9a.5.5 0 0 0 1 0V7a.5.5 0 0 0-1 0z"
]);
const $76e5a570f6bfc30c$export$3b6c56b4090445cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNone20Filled', "20", [
    "M8.75 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm0 12.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM5.45 4.6a1.5 1.5 0 0 0-.88.94.75.75 0 0 1-1.38-.58 3 3 0 0 1 1.77-1.77.75.75 0 1 1 .5 1.41m9.95.85a1.5 1.5 0 0 0-.94-.88.75.75 0 0 1 .58-1.38 3 3 0 0 1 1.78 1.77h-.01a.75.75 0 1 1-1.41.49M3.75 12a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75m11.75-.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zM5.45 15.4a1.5 1.5 0 0 1-.88-.94.75.75 0 0 0-1.38.58 3 3 0 0 0 1.77 1.77.75.75 0 1 0 .5-1.41m9.95-.85a1.5 1.5 0 0 1-.94.88.75.75 0 0 0 .58 1.38 3 3 0 0 0 1.78-1.77h-.01a.75.75 0 1 0-1.41-.49"
]);
const $76e5a570f6bfc30c$export$922194cf490ff00a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNone20Regular', "20", [
    "M8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2.46.55a2 2 0 0 0-1.5 1.55.5.5 0 0 1-.59.4.5.5 0 0 1-.38-.66 3 3 0 0 1 2.34-2.29.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6m0 11.9a2 2 0 0 1-1.5-1.55.5.5 0 0 0-.59-.4.5.5 0 0 0-.38.66 3 3 0 0 0 2.34 2.29.5.5 0 0 0 .6-.4.5.5 0 0 0-.47-.6m9.05-12.9.07.02a3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47 2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .6-.4m-.13 12.9a2 2 0 0 0 1.5-1.55.5.5 0 0 1 .59-.4.5.5 0 0 1 .38.66 3 3 0 0 1-2.34 2.29.5.5 0 0 1-.6-.4.5.5 0 0 1 .47-.6M16 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zM3.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5m5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$1baa8671b61912a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNone24Filled', "24", [
    "M14 4a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-9 7a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm14 0a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm-6 10a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zM7 4a1 1 0 0 0-1-1 3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 0 1 1-1 1 1 0 0 0 1-1m11-1a1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3M7 20a1 1 0 0 1-1 1 3 3 0 0 1-3-3 1 1 0 1 1 2 0 1 1 0 0 0 1 1 1 1 0 0 1 1 1m11 1a1 1 0 1 1 0-2 1 1 0 0 0 1-1 1 1 0 1 1 2 0 3 3 0 0 1-3 3"
]);
const $76e5a570f6bfc30c$export$bba5878a573504b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNone24Regular', "24", [
    "M14 3.75c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75m-9.5 7a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm15 0a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zM13.25 21a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zM7 3.75A.75.75 0 0 0 6.25 3h-.5A2.75 2.75 0 0 0 3 5.75v.5a.75.75 0 0 0 1.5 0v-.5c0-.69.56-1.25 1.25-1.25h.5c.41 0 .75-.34.75-.75M17.75 3a.75.75 0 0 0 0 1.5h.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3zM7 20.25c0 .41-.34.75-.75.75h-.5A2.75 2.75 0 0 1 3 18.25v-.5a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h.5c.41 0 .75.34.75.75m10.75.75a.75.75 0 0 1 0-1.5h.5c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5A2.75 2.75 0 0 1 18.25 21z"
]);
const $76e5a570f6bfc30c$export$9fb827bbab224668 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutside20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$4939d7001d234123 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutside20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $76e5a570f6bfc30c$export$a2ea21fbf875bb6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutside24Filled', "24", [
    "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $76e5a570f6bfc30c$export$718021037deaac48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutside24Regular', "24", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25zM5.75 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $76e5a570f6bfc30c$export$19ab66421ebea7b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideThick20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $76e5a570f6bfc30c$export$b7c03234dfa92db1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideThick20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$35124e3e1396a57d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideThick24Filled', "24", [
    "M2.5 5.75c0-1.8 1.46-3.25 3.25-3.25h12.5c1.8 0 3.25 1.46 3.25 3.25v12.5c0 1.8-1.46 3.25-3.25 3.25H5.75a3.25 3.25 0 0 1-3.25-3.25zM5.75 5a.75.75 0 0 0-.75.75v12.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75V5.75a.75.75 0 0 0-.75-.75z"
]);
const $76e5a570f6bfc30c$export$4b96c9a27e003ee6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideThick24Regular', "24", [
    "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $76e5a570f6bfc30c$export$961ff87bd9a541f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderRight20Filled', "20", [
    "M3.75 12a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75M17 8.73V6a3 3 0 0 0-1.96-2.81.75.75 0 1 0-.58 1.38l.07.03c.57.21.97.76.97 1.4v8a1.5 1.5 0 0 1-1.04 1.43.75.75 0 0 0 .58 1.38A3 3 0 0 0 17 14V8.73M5.45 15.4a1.5 1.5 0 0 1-.88-.94.75.75 0 0 0-1.38.58 3 3 0 0 0 1.77 1.77.75.75 0 1 0 .49-1.41M4.6 5.45a1.5 1.5 0 0 1 .94-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.5M11.25 17a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zM12 3.75c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75"
]);
const $76e5a570f6bfc30c$export$a138cdec28263032 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderRight20Regular', "20", [
    "M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm1.05 2.96a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47m10.61 2.47a.5.5 0 0 1-.66-.38.5.5 0 0 1 .46-.6A2 2 0 0 0 16 14V6a2 2 0 0 0-1.6-1.95.5.5 0 0 1-.4-.6.5.5 0 0 1 .66-.38A3 3 0 0 1 17 6v8a3 3 0 0 1-2.34 2.93M3.06 5.4l.01-.07a3 3 0 0 1 2.34-2.29.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6 2 2 0 0 0-1.5 1.55.5.5 0 0 1-.59.4.5.5 0 0 1-.4-.59M12 3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3c.28 0 .5.22.5.5M11.5 17a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1z"
]);
const $76e5a570f6bfc30c$export$e5f8185788d03c4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderRight24Filled', "24", [
    "M13 5a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zm-8 6a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm9 9a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1M6 3a1 1 0 0 1 0 2 1 1 0 0 0-1 1 1 1 0 0 1-2 0 3 3 0 0 1 3-3m1 17a1 1 0 0 1-1 1 3 3 0 0 1-3-3 1 1 0 1 1 2 0 1 1 0 0 0 1 1 1 1 0 0 1 1 1m11 1a1 1 0 1 1 0-2 1 1 0 0 0 1-1V6a1 1 0 0 0-1-1 1 1 0 1 1 0-2 3 3 0 0 1 3 3v12a3 3 0 0 1-3 3"
]);
const $76e5a570f6bfc30c$export$4134cafdb9dbb3f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderRight24Regular', "24", [
    "M13.25 4.5a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zM4.5 10.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm9.5 9.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75M6.25 3a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0v-.5A2.75 2.75 0 0 1 5.75 3zM7 20.25c0 .41-.34.75-.75.75h-.5A2.75 2.75 0 0 1 3 18.25v-.5a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h.5c.41 0 .75.34.75.75M17.75 3a.75.75 0 0 0 0 1.5h.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25h-.5a.75.75 0 0 0 0 1.5h.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3z"
]);
const $76e5a570f6bfc30c$export$6f3bfa5b839860a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTop20Filled', "20", [
    "M12 16.25c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75M8.73 3H6a3 3 0 0 0-2.81 1.96.75.75 0 0 0 1.38.58l.03-.07A1.5 1.5 0 0 1 6 4.5h8a1.5 1.5 0 0 1 1.43 1.04.75.75 0 0 0 1.38-.58A3 3 0 0 0 14 3H8.73m6.67 11.55a1.5 1.5 0 0 1-.94.88.75.75 0 0 0 .58 1.38 3 3 0 0 0 1.77-1.77.75.75 0 1 0-1.41-.49m-9.95.85a1.5 1.5 0 0 1-.88-.94.75.75 0 0 0-1.38.58 3 3 0 0 0 1.77 1.77.75.75 0 1 0 .5-1.41M17 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zM3.75 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$db6f708fe64008fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTop20Regular', "20", [
    "M11.5 17a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1zm2.96-1.05a2 2 0 0 0 1.5-1.55.5.5 0 0 1 .59-.4.5.5 0 0 1 .38.66 3 3 0 0 1-2.34 2.29.5.5 0 0 1-.6-.4.5.5 0 0 1 .47-.6m2.47-10.61a.5.5 0 1 1-.98.2A2 2 0 0 0 14 4H6a2 2 0 0 0-1.95 1.6.5.5 0 0 1-.6.4.5.5 0 0 1-.38-.66A3 3 0 0 1 6 3h8a3 3 0 0 1 2.93 2.34M5.4 16.94l-.07-.01a3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47 2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.59.4M3.5 8c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5m13.5.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$4547407d3f5d9e66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTop24Filled', "24", [
    "M3 6a1 1 0 0 0 2 0 1 1 0 0 1 1-1h12a1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3m2 5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm14 0a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm-5 9a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-8 1a1 1 0 1 0 0-2 1 1 0 0 1-1-1 1 1 0 1 0-2 0 3 3 0 0 0 3 3m11-1a1 1 0 0 0 1 1 3 3 0 0 0 3-3 1 1 0 1 0-2 0 1 1 0 0 1-1 1 1 1 0 0 0-1 1"
]);
const $76e5a570f6bfc30c$export$fcc7211f4e97f31d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTop24Regular', "24", [
    "M3 6.25a.75.75 0 0 0 1.5 0v-.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75zm1.5 4.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm15 0a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zm-5.5 9.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75M6.25 21a.75.75 0 0 0 0-1.5h-.5c-.69 0-1.25-.56-1.25-1.25v-.5a.75.75 0 0 0-1.5 0v.5A2.75 2.75 0 0 0 5.75 21zM17 20.25c0 .41.34.75.75.75h.5A2.75 2.75 0 0 0 21 18.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .69-.56 1.25-1.25 1.25h-.5a.75.75 0 0 0-.75.75"
]);
const $76e5a570f6bfc30c$export$2eaeade2bb3d51b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottom20Filled', "20", [
    "M6 4.5a1.5 1.5 0 0 0-1.43 1.04.75.75 0 0 1-1.38-.58A3 3 0 0 1 6 3h8a3 3 0 0 1 2.81 1.96.75.75 0 0 1-1.38.58l-.03-.07A1.5 1.5 0 0 0 14 4.5zm-3 6.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm12.5 0a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm-10.9 3.3c.22.56.77.95 1.4.95h8a1.5 1.5 0 0 0 1.43-1.03v-.01a.75.75 0 0 1 1.38.58A3 3 0 0 1 14 17H6a3 3 0 0 1-2.81-1.96.75.75 0 1 1 1.41-.49"
]);
const $76e5a570f6bfc30c$export$e7cf7deaaea92531 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottom20Regular', "20", [
    "m3.07 5.34-.02.07a.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47A2 2 0 0 1 6 4h8a2 2 0 0 1 1.95 1.6.5.5 0 0 0 .6.4.5.5 0 0 0 .38-.66A3 3 0 0 0 14 3H6a3 3 0 0 0-2.93 2.34m0 9.32-.02-.07a.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47A2 2 0 0 0 6 16h8a2 2 0 0 0 1.95-1.6.5.5 0 0 1 .6-.4.5.5 0 0 1 .38.66A3 3 0 0 1 14 17H6a3 3 0 0 1-2.93-2.34M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"
]);
const $76e5a570f6bfc30c$export$8d04c7c559361b04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottom24Filled', "24", [
    "M4 7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h12a3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1H6a1 1 0 0 0-1 1 1 1 0 0 1-1 1m1 4a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm14 0a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zM3 18a1 1 0 1 1 2 0 1 1 0 0 0 1 1h12a1 1 0 0 0 1-1 1 1 0 1 1 2 0 3 3 0 0 1-3 3H6a3 3 0 0 1-3-3"
]);
const $76e5a570f6bfc30c$export$68a365fcf6a6ef5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottom24Regular', "24", [
    "M3.75 7A.75.75 0 0 1 3 6.25v-.5A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v.5c0 .41-.34.75-.75.75m.75 3.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm15 0a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zm-16.5 7a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25z"
]);
const $76e5a570f6bfc30c$export$f838973b6323aca9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomDouble20Filled', "20", [
    "M6 4.5a1.5 1.5 0 0 0-1.43 1.04.75.75 0 0 1-1.38-.58A3 3 0 0 1 6 3h8a3 3 0 0 1 2.81 1.96.75.75 0 0 1-1.38.58l-.03-.07A1.5 1.5 0 0 0 14 4.5zM3.75 11a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m12.5 0a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m-12.5 4.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zM3 13.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $76e5a570f6bfc30c$export$a493d528243b61e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomDouble20Regular', "20", [
    "m3.05 5.41.02-.07A3 3 0 0 1 6 3h8a3 3 0 0 1 2.95 2.41.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47A2 2 0 0 0 14 4H6a2 2 0 0 0-1.95 1.6.5.5 0 0 1-.6.4.5.5 0 0 1-.4-.59M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5m-13 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM3 14.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"
]);
const $76e5a570f6bfc30c$export$1b4155a0bc236a1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomDouble24Filled', "24", [
    "M3 6a1 1 0 0 0 2 0 1 1 0 0 1 1-1h12a1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3m2 5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm-1 7a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm0 3a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm16-11a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$bab9082abb912bb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomDouble24Regular', "24", [
    "M3 6.25a.75.75 0 0 0 1.5 0v-.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75zM3.75 10c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m16.5 0a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75M3 20.25c0 .41.34.75.75.75h16.5a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0-.75.75m.75-1.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5z"
]);
const $76e5a570f6bfc30c$export$ab4f05d72bc88713 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomThick20Filled', "20", [
    "M5.12 5.52A1 1 0 0 1 6 5h8a1 1 0 0 1 .88.52 1 1 0 0 0 1.84-.33 1 1 0 0 0-.22-.83A3 3 0 0 0 14 3H6a3 3 0 0 0-2.5 1.35 1 1 0 1 0 1.62 1.17m0 8.96A1 1 0 0 0 6 15h8a1 1 0 0 0 .88-.52 1 1 0 0 1 1.84.33 1 1 0 0 1-.22.83A3 3 0 0 1 14 17H6a3 3 0 0 1-2.5-1.35 1 1 0 1 1 1.62-1.17M4 12a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1m11-1a1 1 0 0 0 2 0V9a1 1 0 1 0-2 0z"
]);
const $76e5a570f6bfc30c$export$75ae4b4987d0422f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomThick20Regular', "20", [
    "M6 4.5a1.5 1.5 0 0 0-1.43 1.04.75.75 0 0 1-1.38-.58A3 3 0 0 1 6 3h8a3 3 0 0 1 2.81 1.96.75.75 0 0 1-1.38.58l-.03-.07A1.5 1.5 0 0 0 14 4.5zM3.75 12a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75M14 15.5H6a1.5 1.5 0 0 1-1.43-1.04.75.75 0 0 0-1.38.58A3 3 0 0 0 6 17h8a3 3 0 0 0 2.81-1.96.75.75 0 0 0-1.38-.58l-.03.08a1.5 1.5 0 0 1-1.4.96m1.5-4.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0z"
]);
const $76e5a570f6bfc30c$export$60e4a39f1c28fe7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomThick24Filled', "24", [
    "M3 6a1 1 0 0 0 2 0 1 1 0 0 1 1-1h12a1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3m2 5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm.5 6.25v.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75v-.5a1.25 1.25 0 1 1 2.5 0V18a3.25 3.25 0 0 1-3.25 3H6.25a3.25 3.25 0 0 1-3.24-3H3v-.75a1.25 1.25 0 1 1 2.5 0M20 10a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$eb4a956bc5a54970 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomThick24Regular', "24", [
    "M3 6.25a.75.75 0 0 0 1.5 0v-.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75zm1.5 4.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm15 0a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0zM4 17a1 1 0 0 0-1 1 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 1 1 0 1 0-2 0 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1 1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$9374638ff7183a43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard12Filled', "12", [
    "M7.91 2h.59c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 2 9.5v-6C2 2.67 2.67 2 3.5 2h.59c.2-.58.76-1 1.41-1h1c.65 0 1.2.42 1.41 1M5 2.5c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$27cb85fe6a3f47db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard12Regular', "12", [
    "M4.09 3H3.5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-1a1.5 1.5 0 0 1-1.41-1M7.9 2h.59c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 2 9.5v-6C2 2.67 2.67 2 3.5 2h.59c.2-.58.76-1 1.41-1h1c.65 0 1.2.42 1.41 1M5 2.5c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$d1fa1555a195c96e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_16_color__a)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_16_color__b)",
            "fillOpacity": ".7",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_16_color__c)",
            "fillOpacity": ".4",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_16_color__d)",
            "d": "M5 2.5C5 3.33 5.67 4 6.5 4h3a1.5 1.5 0 0 0 0-3h-3C5.67 1 5 1.67 5 2.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4.16204 -4.27976 0 8 1.28)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.02381 -4.04762 0 8 2.69)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_16_color__a",
                "x1": "3",
                "x2": "13.44",
                "y1": "3.3",
                "y2": "14.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_16_color__d",
                "x1": "8",
                "x2": "8",
                "y1": "1",
                "y2": "4",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$c17bc533ff14bd50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$c392fe5c8cd409f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.09 3H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$5a6074dadc8f4b80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__a)",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__b)",
            "fillOpacity": ".7",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__c)",
            "fillOpacity": ".4",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__d)",
            "d": "M7 3.5C7 4.33 7.67 5 8.5 5h3a1.5 1.5 0 0 0 0-3h-3C7.67 2 7 2.67 7 3.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.14077 -4.64062 0 10 2.17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.30574 -3.67969 0 10 3.74)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_20_color__a",
                "x1": "4",
                "x2": "16",
                "y1": "4.51",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_20_color__d",
                "x1": "10",
                "x2": "10",
                "y1": "2",
                "y2": "5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$45d2b2d4c3b89c14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$f999431501df89d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$cb93c1781cf8b60e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_24_color__a)",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_24_color__b)",
            "fillOpacity": ".7",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_24_color__c)",
            "fillOpacity": ".4",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_24_color__d)",
            "d": "M8 4.25C8 5.49 9 6.5 10.25 6.5h3.5a2.25 2.25 0 0 0 0-4.5h-3.5C9.01 2 8 3 8 4.25"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6.16892 -6.75 0 12 3)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.79325 -4.95298 0 12 4.62)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_24_color__a",
                "x1": "4",
                "x2": "18.15",
                "y1": "5.8",
                "y2": "23.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_24_color__d",
                "x1": "12",
                "x2": "12",
                "y1": "2",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$6347d13cb787d0a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard24Filled', "24", [
    "M15.99 4h1.76C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2h3.5c1.16 0 2.11.88 2.24 2m-6.49.25c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75"
]);
const $76e5a570f6bfc30c$export$58e2fb1a3018f2f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard24Regular', "24", [
    "M8.38 5.5H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1m7.6-1.5h1.77C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2h3.5c1.16 0 2.11.88 2.24 2m-6.48.25c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75"
]);
const $76e5a570f6bfc30c$export$113c43b2ecbcfe68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_28_color__a)",
            "d": "M5 6.75A2.75 2.75 0 0 1 7.75 4h12.5A2.75 2.75 0 0 1 23 6.75v16.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_28_color__b)",
            "fillOpacity": ".7",
            "d": "M5 6.75A2.75 2.75 0 0 1 7.75 4h12.5A2.75 2.75 0 0 1 23 6.75v16.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_28_color__c)",
            "fillOpacity": ".4",
            "d": "M5 6.75A2.75 2.75 0 0 1 7.75 4h12.5A2.75 2.75 0 0 1 23 6.75v16.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_28_color__d)",
            "d": "M9.5 4.5A2.5 2.5 0 0 1 12 2h4a2.5 2.5 0 0 1 0 5h-4a2.5 2.5 0 0 1-2.5-2.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 7.53979 -6.96094 0 14 2.78)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.38176 -5.51953 0 14 5.08)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_28_color__a",
                "x1": "5",
                "x2": "22.55",
                "y1": "6.2",
                "y2": "26.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_28_color__d",
                "x1": "14",
                "x2": "14",
                "y1": "2",
                "y2": "7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$ff474a0a74dc9e26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard28Filled', "28", [
    "M18.45 4h1.8A2.75 2.75 0 0 1 23 6.75v16.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2h4c1.2 0 2.22.86 2.45 2M11 4.5a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1"
]);
const $76e5a570f6bfc30c$export$96b712f39dfab84f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard28Regular', "28", [
    "M9.7 5.5H7.76c-.69 0-1.25.56-1.25 1.25v16.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25h-1.96A2.5 2.5 0 0 1 16 7h-4a2.5 2.5 0 0 1-2.3-1.5M18.46 4h1.8A2.75 2.75 0 0 1 23 6.75v16.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2h4c1.2 0 2.22.86 2.45 2M11 4.5a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1"
]);
const $76e5a570f6bfc30c$export$778b72a482348c6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_32_color__a)",
            "d": "M5 7.5A3.5 3.5 0 0 1 8.5 4h15A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_32_color__b)",
            "fillOpacity": ".7",
            "d": "M5 7.5A3.5 3.5 0 0 1 8.5 4h15A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_32_color__c)",
            "fillOpacity": ".4",
            "d": "M5 7.5A3.5 3.5 0 0 1 8.5 4h15A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_32_color__d)",
            "d": "M10 5a3 3 0 0 1 3-3h6a3 3 0 1 1 0 6h-6a3 3 0 0 1-3-3"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 8.91066 -8.50781 0 16 2.56)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.99662 -6.74609 0 16 5.27)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_32_color__a",
                "x1": "5",
                "x2": "25.63",
                "y1": "6.6",
                "y2": "31.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_32_color__d",
                "x1": "16",
                "x2": "16",
                "y1": "2",
                "y2": "8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$22c8d9e0f1dddc3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard32Filled', "32", [
    "M23.5 4h-1.67A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h15a3.5 3.5 0 0 0 3.5-3.5v-19A3.5 3.5 0 0 0 23.5 4M13 4h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2"
]);
const $76e5a570f6bfc30c$export$d505776cb394c709 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard32Regular', "32", [
    "M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-6 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM8.5 6C7.67 6 7 6.67 7 7.5v19c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-19c0-.83-.67-1.5-1.5-1.5h-1.67A3 3 0 0 1 19 8h-6a3 3 0 0 1-2.83-2z"
]);
const $76e5a570f6bfc30c$export$c753342247fc5a09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3Day16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-1 8v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0m3 .5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5m2-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0"
]);
const $76e5a570f6bfc30c$export$e6550b2da3e8d7e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3Day16Regular', "16", [
    "M5 10.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0zm3 .5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5m2-.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0zM6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 3h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$b4adf32dbddbe394 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3Day20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-1 10v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0m5.5.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5m-3-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0"
]);
const $76e5a570f6bfc30c$export$efca17733566ec79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3Day20Regular', "20", [
    "M7 14.5a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-1 0zm5.5.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5m-3-.5a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-1 0zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$cf8e8042519d40cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3Day24Filled', "24", [
    "M13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M8 17.25v-7.5a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0m7.25.75a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m-4-.75v-7.5a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-1.5 0"
]);
const $76e5a570f6bfc30c$export$f1c674cb9d575820 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3Day24Regular', "24", [
    "M8 17.25a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-1.5 0zm7.25.75a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5c0 .41-.34.75-.75.75m-4-.75a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-1.5 0zM15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$5e32029808bdf563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_48_color__a)",
            "d": "M8 11.5A4.5 4.5 0 0 1 12.5 7h23a4.5 4.5 0 0 1 4.5 4.5v28a4.5 4.5 0 0 1-4.5 4.5h-23A4.5 4.5 0 0 1 8 39.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_48_color__b)",
            "fillOpacity": ".7",
            "d": "M8 11.5A4.5 4.5 0 0 1 12.5 7h23a4.5 4.5 0 0 1 4.5 4.5v28a4.5 4.5 0 0 1-4.5 4.5h-23A4.5 4.5 0 0 1 8 39.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_48_color__c)",
            "fillOpacity": ".4",
            "d": "M8 11.5A4.5 4.5 0 0 1 12.5 7h23a4.5 4.5 0 0 1 4.5 4.5v28a4.5 4.5 0 0 1-4.5 4.5h-23A4.5 4.5 0 0 1 8 39.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_48_color__d)",
            "d": "M16 8.25C16 5.9 17.9 4 20.25 4h7.5a4.25 4.25 0 0 1 0 8.5h-7.5A4.25 4.25 0 0 1 16 8.25"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 12.6806 -12.375 0 24 4.94)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.6875 -9.8125 0 24 8.81)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_48_color__a",
                "x1": "8",
                "x2": "37.24",
                "y1": "10.7",
                "y2": "46.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_48_color__d",
                "x1": "24",
                "x2": "24",
                "y1": "4",
                "y2": "12.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$33ba0a14ac7d7e37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard48Filled', "48", [
    "M31.81 7h3.94C38.1 7 40 8.9 40 11.25v28.5C40 42.1 38.1 44 35.75 44h-23.5A4.25 4.25 0 0 1 8 39.75v-28.5C8 8.9 9.9 7 12.25 7h3.94c.53-1.74 2.15-3 4.06-3h7.5a4.25 4.25 0 0 1 4.06 3M18.5 8.25c0 .97.78 1.75 1.75 1.75h7.5a1.75 1.75 0 1 0 0-3.5h-7.5c-.97 0-1.75.78-1.75 1.75"
]);
const $76e5a570f6bfc30c$export$cd94c1f61d65db1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard48Regular', "48", [
    "M16.19 9.5h-3.94c-.97 0-1.75.78-1.75 1.75v28.5c0 .97.78 1.75 1.75 1.75h23.5c.97 0 1.75-.78 1.75-1.75v-28.5c0-.97-.78-1.75-1.75-1.75h-3.94a4.25 4.25 0 0 1-4.06 3h-7.5a4.25 4.25 0 0 1-4.06-3M31.8 7h3.94C38.1 7 40 8.9 40 11.25v28.5C40 42.1 38.1 44 35.75 44h-23.5A4.25 4.25 0 0 1 8 39.75v-28.5C8 8.9 9.9 7 12.25 7h3.94c.53-1.74 2.15-3 4.06-3h7.5a4.25 4.25 0 0 1 4.06 3M18.5 8.25c0 .97.78 1.75 1.75 1.75h7.5a1.75 1.75 0 1 0 0-3.5h-7.5c-.97 0-1.75.78-1.75 1.75"
]);
const $76e5a570f6bfc30c$export$3f20698925232d34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRight16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.1q-1.14-.58-2.5-.6a5.5 5.5 0 0 0-3.16 10H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L11.29 10H8.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$f6a1f95c0b37140a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRight16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.1q-.48-.24-1-.4V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h1.76q.46.58 1.08 1H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L11.29 10H8.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$999c974ac5729940 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRight20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$1ffc85ccd93dce4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRight20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$4a9d075649b228a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRight24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25A6.5 6.5 0 0 0 12.81 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m9.25 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $76e5a570f6bfc30c$export$c4b48cc28c2bd35c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRight24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25q-.71-.3-1.5-.42V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m9.25 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $76e5a570f6bfc30c$export$d9fc15d717067728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush16Filled', "16", [
    "M14.57 5.57c.33-.1.82-.15 1.16.2.34.33.29.82.2 1.16q-.16.58-.6 1.27c-.55.92-1.44 2.03-2.52 3.1-.3.31-.77.78-1.3 1.03q-.25.1-.52.15c.05.61-.15 1.24-.62 1.72l-.13.12a3.44 3.44 0 0 1-5.13-.51.5.5 0 0 1-.09-.46.5.5 0 0 1 .34-.33c.88-.26 1.12-.53 1.25-.73l.23-.49q.13-.3.46-.67c.47-.46 1.1-.67 1.71-.62q.05-.28.16-.52c.24-.54.71-1 1.02-1.3a18 18 0 0 1 3.1-2.53q.7-.43 1.28-.6M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v1.67l-.22.13c-1.01.61-2.18 1.56-3.3 2.68-.27.27-.88.85-1.21 1.57q-.86.15-1.54.75l-.13.13q-.38.39-.55.73-.13.25-.24.5-.04.09-.1.14a2 2 0 0 1-.64.26 1.5 1.5 0 0 0-1 .98c-.25.8.23 1.45.77 1.96H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2h.58c.21-.58.77-1 1.42-1zm.16 10.84a1.17 1.17 0 0 0-1.92.4c-.06.13-.16.37-.28.57a2.3 2.3 0 0 1-1.07.89 2.4 2.4 0 0 0 3.26-.2h.01l.08-.1c.37-.45.35-1.13-.08-1.56M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$92d1ae4b70c9c2cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush16Regular', "16", [
    "M14.57 5.57c.33-.1.82-.15 1.16.2.34.33.29.82.2 1.16q-.16.58-.6 1.27c-.55.92-1.44 2.03-2.52 3.1-.3.31-.77.78-1.3 1.03q-.24.1-.52.15c.06.61-.15 1.24-.62 1.72l-.13.12a3.44 3.44 0 0 1-5.13-.51.5.5 0 0 1 .25-.79c.88-.26 1.12-.53 1.25-.73l.23-.48q.13-.31.46-.68c.47-.46 1.1-.67 1.71-.62q.05-.28.16-.52c.24-.54.71-1 1.02-1.3a18 18 0 0 1 3.1-2.53q.7-.43 1.28-.6M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v1.67l-.22.13q-.37.23-.78.52V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H4.5a.5.5 0 0 0-.5.5v10.03c.01.6.42 1.07.84 1.47H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2h.58c.21-.58.77-1 1.42-1zm.16 10.84a1.17 1.17 0 0 0-1.65 0q-.17.18-.27.4c-.06.13-.16.37-.28.57a2.3 2.3 0 0 1-1.07.89 2.4 2.4 0 0 0 3.27-.2c.46-.46.46-1.2 0-1.66M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$3ab0fba96e01bf96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush20Filled', "20", [
    "M17.44 7.58c.39-.1.92-.16 1.28.2s.3.9.2 1.28a6 6 0 0 1-.68 1.47 20 20 0 0 1-2.94 3.62c-.36.36-.9.9-1.5 1.18a2 2 0 0 1-.85.2 2.5 2.5 0 0 1-.68 2.23l-.15.16a4.02 4.02 0 0 1-6.01-.61.5.5 0 0 1 .25-.79c1.07-.31 1.38-.65 1.55-.92.11-.18.16-.33.29-.59q.15-.36.53-.77a2.5 2.5 0 0 1 2.25-.7q0-.45.19-.84c.28-.6.82-1.14 1.18-1.5a20 20 0 0 1 3.62-2.94 6 6 0 0 1 1.47-.68M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.6l-.55.3c-1.16.7-2.52 1.8-3.81 3.1-.33.32-1.02.98-1.38 1.8l-.1.22c-.7.07-1.4.35-1.97.86l-.16.15a4 4 0 0 0-.73 1.05c-.1.21-.18.5-.38.64-.13.08-.37.2-.85.35-.47.14-.85.5-1 .97-.15.48-.06 1 .25 1.39l.05.06A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm.06 12.94a1.5 1.5 0 0 0-2.12 0q-.22.23-.34.5c-.08.17-.2.45-.34.68-.26.42-.65.79-1.37 1.1a3 3 0 0 0 4.16-.15h.01a1.5 1.5 0 0 0 0-2.13M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$9cec8e15b6799aca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush20Regular', "20", [
    "M17.44 7.58c.39-.1.92-.16 1.28.2s.3.9.2 1.28a6 6 0 0 1-.68 1.47 20 20 0 0 1-2.94 3.62c-.36.36-.9.9-1.5 1.18a2 2 0 0 1-.85.2 2.5 2.5 0 0 1-.68 2.23l-.15.16a4.02 4.02 0 0 1-6.01-.61.5.5 0 0 1 .25-.79c1.07-.31 1.38-.65 1.55-.92.11-.18.16-.33.29-.59q.15-.36.53-.77a2.5 2.5 0 0 1 2.25-.7q0-.45.19-.84c.28-.6.82-1.14 1.18-1.5a20 20 0 0 1 3.62-2.94 6 6 0 0 1 1.47-.68M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.6a10 10 0 0 0-1 .59V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H5.5a.5.5 0 0 0-.5.5V17q0 .51.32.93l.05.06A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm.06 12.94a1.5 1.5 0 0 0-2.12 0q-.22.23-.34.5c-.08.17-.2.45-.34.68-.26.42-.65.79-1.37 1.1a3 3 0 0 0 4.16-.15h.01a1.5 1.5 0 0 0 0-2.13M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$32844b6f4cf67b38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush24Filled', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v.93a9 9 0 0 0-1.9.9 26 26 0 0 0-4.6 3.73c-.4.4-1.23 1.2-1.66 2.16l-.03.05a4.2 4.2 0 0 0-3.47 2.59c-.14.32-.22.73-.52.95q-.18.16-.7.37l-.42.16c-.5.16-.9.54-1.08 1.03l-.07.2c-.3 1.25.83 2.12 1.76 2.68H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2zm6.67 6.1c.48-.13 1.2-.22 1.7.28s.4 1.21.28 1.69a7 7 0 0 1-.84 1.82 25 25 0 0 1-3.58 4.4c-.43.44-1.1 1.11-1.87 1.46q-.3.14-.63.2c.09.93-.22 1.88-.93 2.59l-.2.2a5.2 5.2 0 0 1-3.78 1.24 6 6 0 0 1-3.86-1.71.75.75 0 0 1 .3-1.24c1.38-.46 1.74-.91 1.92-1.25.13-.25.18-.42.33-.78a3.2 3.2 0 0 1 3.28-2q.07-.33.2-.62c.35-.77 1.03-1.43 1.46-1.86a25 25 0 0 1 4.4-3.59c.66-.39 1.28-.7 1.82-.84M13.5 17A1.75 1.75 0 0 0 11 17a2 2 0 0 0-.37.59c-.08.19-.22.58-.39.9-.29.54-.73 1.02-1.52 1.44.58.32 1.25.51 1.93.55a3.6 3.6 0 0 0 2.82-1c.69-.68.69-1.79 0-2.47M10.25 3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$b8dae379ddb3cd05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v.93q-.74.23-1.5.66V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.52c0 .44.19.88.5 1.2l.22.22q.5.46 1.1.81H6.24C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2zm6.67 6.1c.48-.13 1.2-.22 1.7.28s.4 1.21.28 1.69a7 7 0 0 1-.84 1.82 25 25 0 0 1-3.58 4.4c-.43.44-1.1 1.11-1.87 1.46q-.3.14-.63.2c.09.93-.22 1.88-.93 2.59l-.2.2a5.2 5.2 0 0 1-3.78 1.24 6 6 0 0 1-3.86-1.71.75.75 0 0 1 .3-1.24c1.38-.46 1.74-.91 1.92-1.25.13-.25.18-.42.33-.78a3.2 3.2 0 0 1 3.28-1.99q.06-.33.2-.63c.35-.77 1.03-1.43 1.46-1.86a25 25 0 0 1 4.4-3.59c.66-.39 1.28-.7 1.82-.84M13.5 17A1.75 1.75 0 0 0 11 17a2 2 0 0 0-.37.59c-.08.19-.22.58-.39.9-.29.54-.73 1.02-1.52 1.44.58.32 1.25.51 1.93.55a3.6 3.6 0 0 0 2.82-1c.69-.68.69-1.79 0-2.47M10.25 3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$7e422ee613307b20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush28Filled', "28", [
    "M23.74 10.1c.56-.15 1.34-.23 1.87.3s.45 1.3.3 1.87a9 9 0 0 1-.98 2.1 29 29 0 0 1-4.2 5.17c-.51.51-1.28 1.3-2.16 1.7q-.27.12-.59.2a3.7 3.7 0 0 1-1.08 2.96A5.6 5.6 0 0 1 13.27 26c-1.58.1-3.44-.41-5.46-1.88a.75.75 0 0 1 .16-1.3c1.57-.65 2.1-1.23 2.4-1.72.18-.28.28-.52.46-.89q.23-.53.77-1.1a3.7 3.7 0 0 1 2.98-1.08q.08-.3.2-.58c.4-.88 1.18-1.65 1.69-2.16 1.79-1.8 3.64-3.28 5.17-4.2a9 9 0 0 1 2.1-.98M16 2c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 23 6.75v2.54q-.93.35-1.88.93a30 30 0 0 0-5.36 4.36c-.48.47-1.4 1.36-1.89 2.44-1 .08-1.98.47-2.78 1.18l-.2.2c-.48.47-.76.96-.95 1.35-.23.46-.27.58-.41.82-.16.26-.5.73-1.94 1.3v.01c-.59.24-1 .78-1.08 1.4-.07.64.2 1.26.71 1.64q.9.64 1.77 1.08H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2zm-.16 18.16a2.25 2.25 0 0 0-3.67.71c-.12.25-.3.65-.52 1.01-.37.6-.9 1.17-1.87 1.72 1.33.73 2.47.95 3.4.9a4 4 0 0 0 2.66-1.16c.88-.88.88-2.3 0-3.18M12 3.5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$47d9de0051309bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush28Regular', "28", [
    "M23.74 10.1c.56-.15 1.34-.23 1.87.3s.45 1.3.3 1.87a9 9 0 0 1-.98 2.1 29 29 0 0 1-4.2 5.17c-.51.51-1.28 1.3-2.16 1.7q-.27.12-.59.2a3.7 3.7 0 0 1-1.08 2.96 5.6 5.6 0 0 1-3.63 1.59c-1.58.1-3.44-.41-5.46-1.88a.75.75 0 0 1 .16-1.3c1.57-.65 2.1-1.23 2.4-1.72.18-.28.28-.52.46-.9q.23-.52.77-1.1a3.7 3.7 0 0 1 2.98-1.07q.08-.3.2-.58c.4-.88 1.18-1.65 1.69-2.16 1.79-1.8 3.64-3.28 5.17-4.2a9 9 0 0 1 2.1-.98M16 2c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 23 6.75v2.54q-.74.27-1.5.71V6.75c0-.69-.56-1.25-1.25-1.25h-1.96A2.5 2.5 0 0 1 16 7h-4a2.5 2.5 0 0 1-2.3-1.5H7.76c-.69 0-1.25.56-1.25 1.25v16.62c-.04.6.23 1.19.72 1.55q.9.64 1.77 1.08H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2zm-.16 18.16a2.25 2.25 0 0 0-3.67.71c-.12.25-.3.65-.52 1.01-.37.6-.9 1.17-1.87 1.71 1.33.74 2.47.96 3.4.9a4 4 0 0 0 2.66-1.15c.88-.88.88-2.3 0-3.18M12 3.5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$1d88e6a35cbf8644 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush32Filled', "32", [
    "M27.18 11.14c.66-.18 1.63-.3 2.3.38s.56 1.64.38 2.3c-.2.74-.6 1.6-1.15 2.48a34 34 0 0 1-4.92 6.07c-.6.59-1.5 1.51-2.56 1.99q-.35.16-.75.25a4.5 4.5 0 0 1-1.3 3.57 6.7 6.7 0 0 1-4.3 2.05c-1.84.12-3.88-.6-6.04-2.47a1 1 0 0 1 .21-1.65 5 5 0 0 0 2.21-1.92c.24-.39.34-.62.6-1.1.24-.4.53-.84.96-1.27a4.5 4.5 0 0 1 3.56-1.3q.1-.4.26-.75c.48-1.06 1.4-1.96 2-2.56a34 34 0 0 1 6.05-4.92c.9-.54 1.75-.96 2.5-1.15M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v2.13l-.21.06c-.94.25-1.93.74-2.88 1.31a36 36 0 0 0-6.34 5.15c-.54.54-1.63 1.6-2.25 2.9-1.2.13-2.36.62-3.32 1.47l-.24.24a7 7 0 0 0-1.2 1.6c-.32.57-.58 1.21-1.08 1.67-.22.21-.55.46-1.1.74a2.5 2.5 0 0 0-.52 4.12q.71.61 1.44 1.11h-.8A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-1.23 21.23a2.5 2.5 0 0 0-3.54 0q-.36.38-.62.86c-.15.26-.42.77-.64 1.14a6 6 0 0 1-1.71 1.87 5.6 5.6 0 0 0 3.5 1.14 4.7 4.7 0 0 0 3-1.47 2.5 2.5 0 0 0 0-3.54M13 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$fff1106d89164451 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrush32Regular', "32", [
    "M27.18 11.13c.66-.17 1.63-.28 2.3.39s.56 1.64.38 2.3c-.2.74-.6 1.6-1.15 2.48a34 34 0 0 1-4.93 6.07c-.59.59-1.5 1.51-2.55 1.99q-.35.16-.75.25a4.5 4.5 0 0 1-1.3 3.57 6.7 6.7 0 0 1-4.3 2.05c-1.84.12-3.88-.6-6.04-2.48a1 1 0 0 1 .21-1.64 5 5 0 0 0 2.21-1.92c.24-.39.34-.62.6-1.1.24-.4.53-.84.96-1.27a4.5 4.5 0 0 1 3.56-1.3q.1-.4.26-.75c.48-1.06 1.4-1.97 2-2.56a34 34 0 0 1 6.05-4.92c.9-.54 1.75-.96 2.5-1.16M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v2.13l-.21.06q-.89.24-1.79.7V7.5c0-.83-.67-1.5-1.5-1.5h-1.67A3 3 0 0 1 19 8h-6a3 3 0 0 1-2.83-2H8.5C7.67 6 7 6.67 7 7.5v19q0 .1.02.21c-.1.82.22 1.63.83 2.17q.73.64 1.45 1.12h-.8A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-1.23 21.23a2.5 2.5 0 0 0-3.54 0q-.36.38-.62.86c-.15.26-.42.77-.64 1.14a6 6 0 0 1-1.71 1.87 5.6 5.6 0 0 0 3.5 1.14 4.7 4.7 0 0 0 3-1.47 2.5 2.5 0 0 0 0-3.54M13 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$7267763794e3c9d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletList16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 7.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m0 3c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5M5.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
], {
    flipInRtl: true
});
const $76e5a570f6bfc30c$export$9a5f69802ffd9705 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletList16Regular', "16", [
    "M7 7.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-.41-9c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.09 3H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
], {
    flipInRtl: true
});
const $76e5a570f6bfc30c$export$e3fb1bdbda7f3046 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletList20Filled', "20", [
    "M7.09 3H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1M8.5 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
], {
    flipInRtl: true
});
const $76e5a570f6bfc30c$export$a8af41f7c285dada = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletList20Regular', "20", [
    "M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
], {
    flipInRtl: true
});
const $76e5a570f6bfc30c$export$35b893931e76aa43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListLtr16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 7.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m0 3c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5M5.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $76e5a570f6bfc30c$export$38b9fc703e0d4fad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListLtr16Regular', "16", [
    "M7 7.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-.41-9c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.09 3H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$4e3a83e188f41a55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListLtr20Filled', "20", [
    "M7.09 3H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1M8.5 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $76e5a570f6bfc30c$export$8606777a15ce8c67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListLtr20Regular', "20", [
    "M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$2b4387f376a79b67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRtl16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5 7.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m0 3c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5M10.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $76e5a570f6bfc30c$export$63fa8b273fb939f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRtl16Regular', "16", [
    "M5 7.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M10.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.09 3H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$69501ec3dd6884ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRtl20Filled', "20", [
    "M8.5 2h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59c.2-.58.76-1 1.41-1M8 3.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m4.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M12 14.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1-6a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5"
]);
const $76e5a570f6bfc30c$export$1d88a956621267b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRtl20Regular', "20", [
    "M12.75 9.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m0 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M12 14.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1-6a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$2f38a261c7a73a86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty16Filled', "16", [
    "M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.1q-1.14-.58-2.5-.6a5.5 5.5 0 0 0-5.03 7.72l-.4 1.35q-.15.48.02.93H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2h.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 4a4.5 4.5 0 1 1-2.13 8.46l-1.73.52a.5.5 0 0 1-.62-.62l.52-1.73A4.5 4.5 0 0 1 10.5 6"
]);
const $76e5a570f6bfc30c$export$9358d999b0f89bae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty16Regular', "16", [
    "M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.1q-.48-.24-1-.4V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h.58l-.02.07q-.13.48.03.93H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2h.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 4a4.5 4.5 0 1 1-2.13 8.46l-1.73.52a.5.5 0 0 1-.62-.62l.52-1.73A4.5 4.5 0 0 1 10.5 6m0 1a3.5 3.5 0 0 0-3 5.31q.12.2.06.4l-.31 1.04 1.03-.3.1-.03q.17 0 .3.07.82.5 1.82.51a3.5 3.5 0 1 0 0-7"
]);
const $76e5a570f6bfc30c$export$7b04daff91083029 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty20Filled', "20", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.52a6.5 6.5 0 0 0-9.39 8.22l-.55 1.83q-.13.47.03.93H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 4a5.5 5.5 0 1 1-2.65 10.32l-2.2.66a.5.5 0 0 1-.63-.62l.66-2.21A5.5 5.5 0 0 1 12.5 7"
]);
const $76e5a570f6bfc30c$export$5831840e9e8366ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty20Regular', "20", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.52q-.48-.3-1-.52v-2a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h.58l-.02.07q-.13.47.03.93H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 4a5.5 5.5 0 1 1-2.65 10.32l-2.2.66a.5.5 0 0 1-.63-.62l.66-2.21A5.5 5.5 0 0 1 12.5 7m0 1a4.5 4.5 0 0 0-3.85 6.83q.11.2.05.4l-.45 1.52 1.51-.45.1-.02q.17-.02.3.07 1.05.63 2.34.65a4.5 4.5 0 1 0 0-9"
]);
const $76e5a570f6bfc30c$export$101ddbb13b008bdd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty24Filled', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25V9.5a7.5 7.5 0 0 0-11.3 9.16l-.63 2.09c-.12.42-.08.87.1 1.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2zm-3.5 1.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM22 15.5a6.5 6.5 0 0 1-9.57 5.73l-2.46.74a.75.75 0 0 1-.94-.93l.74-2.47Q9.02 17.12 9 15.5a6.5 6.5 0 1 1 13 0"
]);
const $76e5a570f6bfc30c$export$f5b29c328732e9b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25V9.5a8 8 0 0 0-1.5-.87V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h1.9l-.08.25c-.12.42-.08.87.1 1.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2zm-3.5 1.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM15.84 9a6.5 6.5 0 1 1-3.4 12.23l-2.47.74a.75.75 0 0 1-.94-.93l.74-2.47A6.5 6.5 0 0 1 9 15.73v-.23A6.5 6.5 0 0 1 15.5 9zm-.34 1.5a5 5 0 0 0-5 5l.01.35q.1 1.24.71 2.24.17.28.08.6l-.43 1.44 1.43-.43c.2-.06.43-.03.6.08q1.16.7 2.6.72h.26a5 5 0 0 0 0-10z"
]);
const $76e5a570f6bfc30c$export$542be5e31f482900 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty28Filled', "28", [
    "M16 2c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 23 6.75v3.77A9 9 0 0 0 9.91 21.95l-.84 2.8q-.17.65.1 1.25H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2zm-4 1.5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm6 6.5a8 8 0 1 1-3.85 15.01l-3.18.96a.75.75 0 0 1-.94-.94l.96-3.18A8 8 0 0 1 18 10"
]);
const $76e5a570f6bfc30c$export$6c499ecaa175304c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty28Regular', "28", [
    "M16 2c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 23 6.75v3.77a9 9 0 0 0-1.5-.81V6.75c0-.69-.56-1.25-1.25-1.25h-1.96A2.5 2.5 0 0 1 16 7h-4a2.5 2.5 0 0 1-2.3-1.5H7.76c-.69 0-1.25.56-1.25 1.25v16.5c0 .69.56 1.25 1.25 1.25h1.4l-.08.25q-.17.65.1 1.25H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2zm-4 1.5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm6 6.5a8 8 0 1 1-3.85 15.01l-3.18.96a.75.75 0 0 1-.94-.94l.96-3.18A8 8 0 0 1 18 10m0 1.5a6.5 6.5 0 0 0-5.56 9.87q.17.28.08.6l-.65 2.16 2.16-.65q.31-.09.6.08A6.5 6.5 0 1 0 18 11.5"
]);
const $76e5a570f6bfc30c$export$220b389c73d657ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty32Filled', "32", [
    "M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v4.88A10.5 10.5 0 0 0 11.47 25.4l-.86 2.88a2.5 2.5 0 0 0 .1 1.72H8.5A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-6 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm8 8a9 9 0 1 1-4.27 16.92l-3.44 1.04a1 1 0 0 1-1.25-1.25l1.04-3.44A9 9 0 0 1 21 12"
]);
const $76e5a570f6bfc30c$export$9ca5a23a104b589d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty32Regular', "32", [
    "M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v4.88q-.94-.65-2-1.09V7.5c0-.83-.67-1.5-1.5-1.5h-1.67A3 3 0 0 1 19 8h-6a3 3 0 0 1-2.83-2H8.5C7.67 6 7 6.67 7 7.5v19c0 .83.67 1.5 1.5 1.5h2.19l-.08.28a2.5 2.5 0 0 0 .1 1.72H8.5A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-6 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm8 8a9 9 0 1 1-4.27 16.92l-3.44 1.04a1 1 0 0 1-1.25-1.25l1.04-3.44A9 9 0 0 1 21 12m0 2a7 7 0 0 0-5.99 10.63 1 1 0 0 1 .1.8l-.62 2.08 2.08-.63a1 1 0 0 1 .8.1A7 7 0 1 0 21 14"
]);
const $76e5a570f6bfc30c$export$8b9bcc5524cbd444 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty48Filled', "48", [
    "M27.75 4a4.25 4.25 0 0 1 4.06 3h3.94C38.1 7 40 8.9 40 11.25v7.76a15 15 0 0 0-24 12v.52c.08 2.1.6 4.1 1.45 5.9l-1.31 4.39c-.22.73-.17 1.5.11 2.18h-4A4.25 4.25 0 0 1 8 39.75v-28.5C8 8.9 9.9 7 12.25 7h3.94c.53-1.74 2.15-3 4.06-3zm-7.5 2.5a1.75 1.75 0 1 0 0 3.5h7.5a1.75 1.75 0 1 0 0-3.5zM44 31a13 13 0 0 1-19.24 11.4l-5.15 1.55a1.25 1.25 0 0 1-1.56-1.56l1.55-5.15a13 13 0 0 1-1.6-5.78V31a13 13 0 0 1 26 0"
]);
const $76e5a570f6bfc30c$export$495d3032e3a24c7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmpty48Regular', "48", [
    "M27.75 4a4.25 4.25 0 0 1 4.06 3h3.94C38.1 7 40 8.9 40 11.25v7.76q-1.17-.88-2.5-1.53v-6.23c0-.97-.78-1.75-1.75-1.75h-3.94a4.25 4.25 0 0 1-4.06 3h-7.5a4.25 4.25 0 0 1-4.06-3h-3.94c-.97 0-1.75.78-1.75 1.75v28.5c0 .97.78 1.75 1.75 1.75h3.98l-.1.32c-.21.73-.16 1.5.12 2.18h-4A4.25 4.25 0 0 1 8 39.75v-28.5C8 8.9 9.9 7 12.25 7h3.94c.53-1.74 2.15-3 4.06-3zm-7.5 2.5a1.75 1.75 0 1 0 0 3.5h7.5a1.75 1.75 0 1 0 0-3.5zM44 31a13 13 0 0 1-19.24 11.4l-5.15 1.55a1.25 1.25 0 0 1-1.56-1.56l1.55-5.15a13 13 0 0 1-1.6-5.78V31a13 13 0 0 1 26 0M31 20.5c-5.8 0-10.5 4.7-10.5 10.5v.37c.07 1.85.61 3.58 1.52 5.07.18.3.23.67.13 1l-1.04 3.44 3.44-1.03q.53-.15 1.01.13c1.59.97 3.45 1.52 5.44 1.52l.54-.01A10.5 10.5 0 0 0 31 20.5"
]);
const $76e5a570f6bfc30c$export$71f2e699ebaa202c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmark16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.7A5.5 5.5 0 0 0 7.26 15H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm9.5 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$21ad62dea16f52c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmark16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.7q-.49-.13-1-.18V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h2.1q.27.54.66 1H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm9.5 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$8d4ee198d4eebe5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmark20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$2660abc34b9a57c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmark20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$b626f3ea931ccaf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmark24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25A6.5 6.5 0 0 0 12.81 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m9.25 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$f8715d82e5a7c1b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmark24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25q-.71-.3-1.5-.42V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m9.25 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$ced702ae3abba148 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardClock20Filled', "20", [
    "M10.5 9.5a.5.5 0 0 0-1 0V11c0 .28.22.5.5.5h1.5a.5.5 0 0 0 0-1h-1zM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.5 8a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
]);
const $76e5a570f6bfc30c$export$641be1005b3f647d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardClock20Regular', "20", [
    "M10.5 9.5a.5.5 0 0 0-1 0V11c0 .28.22.5.5.5h1.5a.5.5 0 0 0 0-1h-1zM10 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$9b130b3974cdde89 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardClock24Filled', "24", [
    "M11.38 13.62c0 .34.27.63.62.63h1.38a.63.63 0 0 0 0-1.25h-.76v-1.63a.63.63 0 0 0-1.24 0zM13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M12 8.25a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5"
]);
const $76e5a570f6bfc30c$export$6ac7b657af9be4ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardClock24Regular', "24", [
    "M12.63 13v-1.63a.62.62 0 1 0-1.26 0v2.25a.62.62 0 0 0 .7.62h1.31a.62.62 0 1 0 0-1.24zm-5.38 0a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M12 9.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m4-5.42A2.25 2.25 0 0 0 13.74 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76zm0 .02v.15zm-5.75 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$a4eeeba2dc600797 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCode16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v4q-.26 0-.5.08a1.5 1.5 0 0 0-2.94-.5l-.33 1.17H8.3a1.5 1.5 0 0 0-2.44-.23l-1.5 1.75a1.5 1.5 0 0 0 0 1.95l1.5 1.75a1.5 1.5 0 0 0 1.77.39l-.07.23q-.13.48.03.91H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-.34 8.75 1.22 1.42a.5.5 0 0 1-.76.65l-1.5-1.75a.5.5 0 0 1 0-.65l1.5-1.75a.5.5 0 0 1 .76.65zm5.33-3.11v-.05a.5.5 0 0 0-.97-.23l-2 7a.5.5 0 0 0 .97.28zm1.18 5.24a.5.5 0 0 1-.05-.71l1.22-1.42-1.22-1.43a.5.5 0 1 1 .76-.65l1.5 1.75a.5.5 0 0 1 0 .65l-1.5 1.75a.5.5 0 0 1-.7.06"
]);
const $76e5a570f6bfc30c$export$883a31e5c04e25c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCode16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v4q-.26 0-.5.08a1.5 1.5 0 0 0-.5-1.2V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h3.09l-.03.09q-.13.48.03.91H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm2.87 12.84a.5.5 0 0 1-.82-.13.5.5 0 0 1-.03-.35l2-7a.5.5 0 1 1 .97.28l-2 7a1 1 0 0 1-.12.2M7.38 9.32a.5.5 0 1 0-.76-.65l-1.5 1.75a.5.5 0 0 0 0 .65l1.5 1.75a.5.5 0 1 0 .76-.65l-1.22-1.42zm5.3 3.56a.5.5 0 0 1-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 1 1 .76-.65l1.5 1.75a.5.5 0 0 1 0 .65l-1.5 1.75a.5.5 0 0 1-.7.06"
]);
const $76e5a570f6bfc30c$export$183f02efc6d9e6a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCode20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.88a1.5 1.5 0 0 0-2.44.71l-.4 1.41h-.74a1.5 1.5 0 0 0-2.55-.48l-1.5 1.75a1.5 1.5 0 0 0 0 1.95l1.5 1.75c.29.35.7.53 1.13.53H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm2.88 10.32a.5.5 0 1 0-.76-.65l-1.5 1.75a.5.5 0 0 0 0 .65l1.5 1.75a.5.5 0 0 0 .7.06.5.5 0 0 0 .06-.71l-1.22-1.42zm4.1-1.68a.5.5 0 1 0-.96-.28l-2 7a.5.5 0 1 0 .97.28zm1.2 5.24a.5.5 0 0 1-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 0 1 .76-.65l1.5 1.75a.5.5 0 0 1 0 .65l-1.5 1.75a.5.5 0 0 1-.7.06"
]);
const $76e5a570f6bfc30c$export$21df735a3f213968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCode20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.88a1.5 1.5 0 0 0-1-.38V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.96l.4.47c.3.35.72.53 1.14.53H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm6.99 8.64a.5.5 0 1 0-.97-.28l-2 7a.5.5 0 1 0 .97.28zm-4.11 1.68a.5.5 0 1 0-.76-.65l-1.5 1.75a.5.5 0 0 0 0 .65l1.5 1.75a.5.5 0 1 0 .76-.65l-1.22-1.42zm5.3 3.56a.5.5 0 0 1-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 0 1 .76-.65l1.5 1.75a.5.5 0 0 1 0 .65l-1.5 1.75a.5.5 0 0 1-.7.06"
]);
const $76e5a570f6bfc30c$export$c456ec1114dca8f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCode24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v7.46a1.75 1.75 0 0 0-3.43-.45L16.06 15h-.73q-.15-.31-.42-.56a1.75 1.75 0 0 0-2.47.15l-2 2.25a1.75 1.75 0 0 0 0 2.32l2 2.25c.35.39.82.59 1.3.59H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m-2.56 15 2 2.25a.75.75 0 1 0 1.12-1L12.75 18l1.56-1.75a.75.75 0 0 0-1.12-1l-2 2.25a.75.75 0 0 0 0 1m6.34-4.96a.75.75 0 0 1 1.44.42l-2.5 8.5a.75.75 0 1 1-1.44-.42zm2.22 7.27a.75.75 0 0 1-.06-1.06L21.25 18l-1.56-1.75a.75.75 0 0 1 1.12-1l2 2.25c.25.29.25.71 0 1l-2 2.25a.75.75 0 0 1-1.06.06"
]);
const $76e5a570f6bfc30c$export$e52dad886d2ff5e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCode24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v7.46a1.75 1.75 0 0 0-1.5-1.7V6.26a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h5.38l.81.91c.35.39.82.59 1.3.59H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M19 13.75l-.03.21-2.5 8.5a.75.75 0 1 1-1.44-.42l2.5-8.5a.75.75 0 0 1 1.47.21m-7.81 4.75a.75.75 0 0 1 0-1l2-2.25a.75.75 0 0 1 1.12 1L12.75 18l1.56 1.75a.75.75 0 0 1-1.12 1zm8.56 2.31a.75.75 0 0 1-.06-1.06L21.25 18l-1.56-1.75a.75.75 0 0 1 1.12-1l2 2.25c.25.29.25.71 0 1l-2 2.25a.75.75 0 0 1-1.06.06"
]);
const $76e5a570f6bfc30c$export$89d35872e85d89c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBar20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m5 8.5v2.5a.5.5 0 0 1-1 0V12a.5.5 0 0 1 1 0m-3-3c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M8 7.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
]);
const $76e5a570f6bfc30c$export$379341ee836d9bc7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBar20Regular', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5m7.5 8a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0zm-3-3c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M8 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$5200d76b31e1602c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBar24Filled', "24", [
    "M10.25 3.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m3.5-1.5h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m2.75 11.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 1.5 0M12 11c.41 0 .75.34.75.75v5.5a.75.75 0 0 1-1.5 0v-5.5c0-.41.34-.75.75-.75M9 9.75v7.5a.75.75 0 0 1-1.5 0v-7.5a.75.75 0 0 1 1.5 0"
]);
const $76e5a570f6bfc30c$export$cd6bf73c43aaae65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBar24Regular', "24", [
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m6.25 10.75a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zM12 11c.41 0 .75.34.75.75v5.5a.75.75 0 0 1-1.5 0v-5.5c0-.41.34-.75.75-.75M9 9.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$84f66ea957c788bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBar32Filled', "32", [
    "M23.5 4h-1.67A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h15a3.5 3.5 0 0 0 3.5-3.5v-19A3.5 3.5 0 0 0 23.5 4M13 4h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2m-2.5 8c.83 0 1.5.67 1.5 1.5v9a1.5 1.5 0 0 1-3 0v-9c0-.83.67-1.5 1.5-1.5m4 3.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0zm7 2.5c.83 0 1.5.67 1.5 1.5v3a1.5 1.5 0 0 1-3 0v-3c0-.83.67-1.5 1.5-1.5"
]);
const $76e5a570f6bfc30c$export$ea17ebcf031d3ef9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBar32Regular', "32", [
    "M10.5 12c-.83 0-1.5.67-1.5 1.5v9a1.5 1.5 0 0 0 3 0v-9c0-.83-.67-1.5-1.5-1.5m4 3.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0zm7 2.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-6 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM8.5 6C7.67 6 7 6.67 7 7.5v19c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-19c0-.83-.67-1.5-1.5-1.5h-1.67A3 3 0 0 1 19 8h-6a3 3 0 0 1-2.83-2z"
]);
const $76e5a570f6bfc30c$export$9cbc0a9881b0cd7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDay16Filled', "16", [
    "M6 9h4v2H6zm-.91-7H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1M6.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M5 6.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $76e5a570f6bfc30c$export$a46b1239fddbd14a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDay16Regular', "16", [
    "M5 6.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm1 0v2h4V9zm-.91-7c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.09 3H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$e8a2a749119e9419 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDay20Filled', "20", [
    "M8 11h4v3H8zm-.91-8c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 7.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5M7 11v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1"
]);
const $76e5a570f6bfc30c$export$7a1337d622ac63c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDay20Regular', "20", [
    "M7 7.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M7 11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zm1 0v3h4v-3zm-.91-8c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$434e6db6faea08ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDay24Filled', "24", [
    "M9.5 13.75q.02-.23.25-.25h4.5q.23.02.25.25v2.5q-.02.23-.25.25h-4.5a.25.25 0 0 1-.25-.25zM10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M8 9.75c0 .41.34.75.75.75h6.5a.75.75 0 0 0 0-1.5h-6.5a.75.75 0 0 0-.75.75M9.75 12C8.78 12 8 12.78 8 13.75v2.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-2.5c0-.97-.78-1.75-1.75-1.75z"
]);
const $76e5a570f6bfc30c$export$8dc42e5b58e8393e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDay24Regular', "24", [
    "M8 9.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 8 9.75M9.75 12C8.78 12 8 12.78 8 13.75v2.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-2.5c0-.97-.78-1.75-1.75-1.75zm-.25 1.75q.02-.23.25-.25h4.5q.23.02.25.25v2.5q-.02.23-.25.25h-4.5a.25.25 0 0 1-.25-.25zM13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24 2.4h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1m0-3h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$c3c31a4f48687bcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardEdit20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H8l.06-.35.37-1.5a3 3 0 0 1 .84-1.48l4.83-4.83c.53-.53 1.21-.8 1.9-.84V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m1.98 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $76e5a570f6bfc30c$export$3e2b97c178a17347 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardEdit20Regular', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H8l.06-.35.16-.65H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.73q.49-.2 1-.23V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m1.98 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $76e5a570f6bfc30c$export$b9199ef051b637ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardError16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.1q-1.14-.58-2.5-.6a5.5 5.5 0 0 0-3.16 10H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M10.5 8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $76e5a570f6bfc30c$export$ad30d1aa961a811a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardError16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v2.1q-.48-.24-1-.4V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h1.76q.46.58 1.08 1H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M10.5 8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $76e5a570f6bfc30c$export$195e0969123310a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardError20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $76e5a570f6bfc30c$export$3b2fe1477234f6c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardError20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $76e5a570f6bfc30c$export$d552dbd4b69c684a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardError24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25A6.5 6.5 0 0 0 12.81 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m9.25 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M17.5 14a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m0 7.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25"
]);
const $76e5a570f6bfc30c$export$aedc8c99d6ff13c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardError24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25q-.71-.3-1.5-.42V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m9.25 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M17.5 14a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m0 7.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25"
]);
const $76e5a570f6bfc30c$export$55e20a4789cfedd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardHeart20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9c-.7.03-1.4.25-2 .66a3.85 3.85 0 0 0-4.87 5.91L11.55 18H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.15 15.68a.5.5 0 0 0 .7 0l3.82-3.81a2.85 2.85 0 1 0-4.03-4.04l-.14.14-.13-.14a2.85 2.85 0 1 0-4.04 4.04z"
]);
const $76e5a570f6bfc30c$export$33d27c44878e2e72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardHeart20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9q-.5.02-1 .18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h5.05l1 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.33 7.83a2.85 2.85 0 0 1 4.04 0l.13.14.14-.14a2.85 2.85 0 0 1 4.03 4.04l-3.81 3.81a.5.5 0 0 1-.71 0l-3.82-3.81a2.85 2.85 0 0 1 0-4.04"
]);
const $76e5a570f6bfc30c$export$e83ada25d36d5c6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardHeart24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v4.98a4.5 4.5 0 0 0-2.99.73 4.47 4.47 0 0 0-5.64 6.87L14.54 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m3.26 19.25a.8.8 0 0 1-.53-.22l-4.4-4.4a3.47 3.47 0 1 1 4.9-4.91l.03.04.04-.04a3.47 3.47 0 1 1 4.9 4.9l-4.4 4.41a.8.8 0 0 1-.54.22"
]);
const $76e5a570f6bfc30c$export$47b6ae084e24416b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardHeart24Regular', "24", [
    "M20 6.25v4.98q-.75-.08-1.5.09V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h6.79l1.5 1.5H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25M16 4.1v.15zm-5.75-.6a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm6.23 19.03a.75.75 0 0 0 1.06 0l4.41-4.4a3.47 3.47 0 1 0-4.9-4.91l-.04.04-.03-.04a3.47 3.47 0 1 0-4.9 4.9z"
]);
const $76e5a570f6bfc30c$export$a62bfeb71ada6b47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardImage20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9h-3.5A3.5 3.5 0 0 0 9 12.5v4q0 .82.34 1.5H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.5 9.5a2.5 2.5 0 0 1 2.5-2.5h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0l-3.03 3.03q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $76e5a570f6bfc30c$export$8a3801d8115d3039 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardImage20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.54q.08.53.3 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.5 9.5a2.5 2.5 0 0 1 2.5-2.5h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0l-3.03 3.03q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $76e5a570f6bfc30c$export$66e0b52f94cc357e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardImage24Filled', "24", [
    "M13.75 3.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25V11h-5a4 4 0 0 0-4 4v5q.01 1.1.54 2H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2M15 12a3 3 0 0 0-3 3v5q0 .85.42 1.52l3.49-3.49c.88-.88 2.3-.88 3.18 0l3.5 3.5q.4-.68.41-1.53v-5a3 3 0 0 0-3-3zm0 11q-.85 0-1.52-.42l3.49-3.49c.3-.3.77-.3 1.06 0l3.5 3.5q-.68.4-1.53.41zm5-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$a90479e1581bb83e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardImage24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25V11h-1.5V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h4.78q.1.82.5 1.5H6.26C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M15 12a3 3 0 0 0-3 3v5q0 .85.42 1.52l3.49-3.49c.88-.88 2.3-.88 3.18 0l3.5 3.5q.4-.68.41-1.53v-5a3 3 0 0 0-3-3zm0 11q-.85 0-1.52-.42l3.49-3.49c.3-.3.77-.3 1.06 0l3.5 3.5q-.68.4-1.53.41zm5-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$4b43bd4ead68354b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetter16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v3.72l-.13-.3a1.5 1.5 0 0 0-2.76 0l-2.1 4.9-.08.18-.81 1.91A1.5 1.5 0 0 0 7.08 15H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    "M11.49 7a.5.5 0 0 0-.46.3l-2.11 4.95-.05.1-.83 1.96a.5.5 0 1 0 .92.4L9.68 13h3.63l.73 1.7a.5.5 0 0 0 .91-.4l-.83-1.94-.05-.1-2.12-4.95a.5.5 0 0 0-.46-.3m0 1.76L12.88 12H10.1z"
]);
const $76e5a570f6bfc30c$export$9edb036f3f112226 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetter16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v3.72l-.13-.3a1.5 1.5 0 0 0-.87-.83V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h2.58a1.5 1.5 0 0 0 0 1H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.45 5.3a.5.5 0 0 0-.92 0l-2.11 4.95-.05.1-.83 1.96a.5.5 0 1 0 .92.4L9.68 13h3.63l.73 1.7a.5.5 0 0 0 .91-.4l-.83-1.94-.05-.1zm.93 4.7H10.1l1.38-3.23z"
]);
const $76e5a570f6bfc30c$export$b20eb9635d2d8c48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetter20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.59a1.5 1.5 0 0 1 .04-1.1l3.5-8a1.5 1.5 0 0 1 2.74 0l.63 1.44V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm2.95 6.3a.5.5 0 0 0-.91 0l-3.5 8a.5.5 0 1 0 .92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 0 0 .92-.4zm.97 4.7h-2.84L14 10.75z"
]);
const $76e5a570f6bfc30c$export$95d71bb2d768f1c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetter20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.84l-.63-1.44a2 2 0 0 0-.37-.51V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.59a1.5 1.5 0 0 0 0 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.95 6.3a.5.5 0 0 0-.91 0l-3.5 8a.5.5 0 0 0 .92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 0 0 .92-.4zm.97 4.7h-2.85L14 10.75z"
]);
const $76e5a570f6bfc30c$export$2cbd1cff06a7a9b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetter24Filled', "24", [
    "M10.25 3.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m3.5-1.5h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h4.92a1.8 1.8 0 0 1-.02-1.46l1.55-3.47.03-.07 2.67-5.96a1.75 1.75 0 0 1 3.2 0l1.4 3.13V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m3.93 9.44a.75.75 0 0 0-1.36 0l-2.68 5.99-.02.03-1.55 3.48a.75.75 0 1 0 1.36.62l1.37-3.06h4.4l1.37 3.06a.75.75 0 1 0 1.36-.62l-1.55-3.48-.02-.03zM17 13.6 18.53 17h-3.06z"
]);
const $76e5a570f6bfc30c$export$31dfa324f6bb93b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetter24Regular', "24", [
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h4.92a1.8 1.8 0 0 1-.02-1.46l.02-.04H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v4.6l.1.19 1.4 3.13V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74-.6h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m7.43 7.94a.75.75 0 0 0-1.36 0l-2.68 5.99-.02.03-1.55 3.48a.75.75 0 1 0 1.36.62l1.37-3.06h4.4l1.37 3.06a.75.75 0 1 0 1.36-.62l-1.55-3.48-.02-.03zM17 13.6 18.53 17h-3.06z"
]);
const $76e5a570f6bfc30c$export$ed9a7de4bfb2f64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLink16Filled', "16", [
    "M4.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5V7H8.5a4.5 4.5 0 0 0-2.83 8H3.5A1.5 1.5 0 0 1 2 13.5v-10C2 2.67 2.67 2 3.5 2zM5.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm9.5 9.5A3.5 3.5 0 0 0 11.5 8h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V15h.2a3.5 3.5 0 0 0 3.3-3.5m-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09A.5.5 0 0 0 9 8.5m2.5 2.5H8.41a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1"
]);
const $76e5a570f6bfc30c$export$7936b131ddcd37c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLink16Regular', "16", [
    "M4.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5V7h-1V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H3.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h1.26q.38.57.91 1H3.5A1.5 1.5 0 0 1 2 13.5v-10C2 2.67 2.67 2 3.5 2zM5.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm9.5 9.5A3.5 3.5 0 0 0 11.5 8h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V15h.2a3.5 3.5 0 0 0 3.3-3.5m-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09A.5.5 0 0 0 9 8.5m2.5 2.5H8.41a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1"
]);
const $76e5a570f6bfc30c$export$4032a4415926b0a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLink20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-3.5a4.5 4.5 0 0 0-3.74 7H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 15.5a3.5 3.5 0 0 0-3.5-3.5h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5m-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5m2.5 2.5h-3.09a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1"
]);
const $76e5a570f6bfc30c$export$ae0ed0f3e860cb26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLink20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h2.76q.19.54.5 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 15.5a3.5 3.5 0 0 0-3.5-3.5h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5m-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5m2.5 2.5h-3.09a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1"
]);
const $76e5a570f6bfc30c$export$477677847b9ecb4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLink24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25V14h-5a5 5 0 0 0-4 8H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M23 19a4 4 0 0 0-4-4h-.1a.75.75 0 0 0 .1 1.5h.16a2.5 2.5 0 0 1-.16 5h-.1A.75.75 0 0 0 19 23h.2a4 4 0 0 0 3.8-4m-7.25-3.25A.75.75 0 0 0 15 15h-.2a4 4 0 0 0 .2 8h.1a.75.75 0 0 0-.1-1.5h-.16a2.5 2.5 0 0 1 .16-5h.1a.75.75 0 0 0 .65-.75m3 2.5h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0-.1-1.5"
]);
const $76e5a570f6bfc30c$export$78404559c8717f54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLink24Regular', "24", [
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22H11q-.51-.67-.77-1.5H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.46-.4 1.87-1h2.13c.41 0 .75.34.75.75V14H20V6.25C20 5.01 19 4 17.75 4zm-5.74-.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M19 15a4 4 0 0 1 .2 8H19a.75.75 0 0 1-.1-1.5h.1a2.5 2.5 0 0 0 .16-5H19a.75.75 0 0 1-.1-1.5zm-4 0a.75.75 0 0 1 .1 1.5H15a2.5 2.5 0 0 0-.16 5H15a.75.75 0 0 1 .1 1.5H15a4 4 0 0 1-.2-8zm.25 3.25h3.5a.75.75 0 0 1 .1 1.5h-3.6a.75.75 0 0 1-.1-1.5z"
]);
const $76e5a570f6bfc30c$export$7c98c95047454e43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdown16Filled', "16", [
    "M9.62 10.01a.5.5 0 0 1 .38.49v4a.5.5 0 0 1-1 0v-1.88l-1.05 2.1a.5.5 0 0 1-.9 0L6 12.62v1.88a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .95-.22l1.55 3.1 1.55-3.1a.5.5 0 0 1 .57-.27M13 10c.28 0 .5.22.5.5v2.8l.65-.65a.5.5 0 1 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7l.65.64V10.5c0-.28.22-.5.5-.5M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5V9c-.83 0-1.5.67-1.5 1.5v1q-.26 0-.5.09V10.5a1.5 1.5 0 0 0-2.84-.67l-.66 1.32-.66-1.32A1.5 1.5 0 0 0 4 10.5v4q0 .23.06.43A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2h.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$df610f204d8163f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdown16Regular', "16", [
    "M9.62 10.01a.5.5 0 0 1 .38.49v4a.5.5 0 0 1-1 0v-1.88l-.94 1.88-.11.22a.5.5 0 0 1-.9 0L6 12.62v1.88a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .95-.22l1.55 3.1 1.55-3.1a.5.5 0 0 1 .57-.27M13 10c.28 0 .5.22.5.5v2.8l.65-.65a.5.5 0 1 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7l.65.64V10.5c0-.28.22-.5.5-.5M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5V9q-.58.02-1 .38V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H4.5a.5.5 0 0 0-.5.5v11q0 .23.06.43A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2h.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$b873fc2045930f11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdown20Filled', "20", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v6.59c-.58.2-1 .76-1 1.41v1.59a1.5 1.5 0 0 0-1 0V12.5a1.5 1.5 0 0 0-2.84-.67L10 14.15l-1.16-2.32A1.5 1.5 0 0 0 6 12.5v5q0 .27.09.5H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm1.12 10.01a.5.5 0 0 1 .38.49v5a.5.5 0 0 1-1 0v-2.88l-1.55 3.1a.5.5 0 0 1-.9 0L8 14.62v2.88a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .95-.22l2.05 4.1 2.05-4.1a.5.5 0 0 1 .57-.27M16.5 12c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L16 16.29V12.5c0-.28.22-.5.5-.5m-8-9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$c364bc83f68fc0ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdown20Regular', "20", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v6.59c-.58.2-1 .76-1 1.41v-8a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5H6v.5q0 .27.09.5H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm1.12 10.01a.5.5 0 0 1 .38.49v5a.5.5 0 0 1-1 0v-2.88l-1.55 3.1a.5.5 0 0 1-.9 0L8 14.62v2.88a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .95-.22l2.05 4.1.03-.06 2.02-4.04a.5.5 0 0 1 .57-.27M16.5 12c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L16 16.29V12.5c0-.28.22-.5.5-.5m-8-9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$85c7a31422ee7c83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdown24Filled', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v7.92a1.74 1.74 0 0 0-2.5 1.58v1.42a1.8 1.8 0 0 0-1.5 0v-1.42a1.75 1.75 0 0 0-3.32-.78l-1.18 2.37-1.18-2.37a1.75 1.75 0 0 0-3.32.78v5.5q0 .4.17.75h-.92C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2zm.67 13.02c.34.08.58.38.58.73v5.5a.75.75 0 0 1-1.5 0v-2.32l-1.33 2.66a.75.75 0 0 1-1.34 0L9.5 18.93v2.32a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 1.42-.34l2.08 4.16 2.08-4.16c.15-.3.5-.47.84-.39m4.83-.02c.41 0 .75.34.75.75v3.69l1.22-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.22 1.22v-3.69c0-.41.34-.75.75-.75m-9-11.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$15fc378528ef9f0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdown24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v7.92a1.7 1.7 0 0 0-1.5 0V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75H7v.75q0 .4.17.75h-.92C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2zm.67 13.02c.34.08.58.38.58.73v5.5a.75.75 0 0 1-1.5 0v-2.32l-1.33 2.66a.75.75 0 0 1-1.34 0L9.5 18.93v2.32a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 1.42-.34l2.08 4.16 2.08-4.16c.15-.3.5-.47.84-.39m4.83-.02c.41 0 .75.34.75.75v3.69l1.22-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.22 1.22v-3.69c0-.41.34-.75.75-.75m-9-11.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$fcb465b91f4b4089 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h1.65a1.5 1.5 0 0 1 1.92-2.05L8.2 11a1.5 1.5 0 0 1 .22-2.98l.02-.32a2.92 2.92 0 0 1 4.23-2.38q.18.09.32.21V3.5c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m3.45 5.28a1.92 1.92 0 0 1 2.78-1.57.5.5 0 0 1-.45.9.92.92 0 0 0-1.33.74l-.09 1.17h1.14a.5.5 0 0 1 0 1h-1.21l-.24 3.2a1.92 1.92 0 0 1-2.78 1.57.5.5 0 1 1 .46-.9.92.92 0 0 0 1.32-.74l.24-3.13H8.5a.5.5 0 1 1 0-1h.86zm5.4 4.07a.5.5 0 0 0-.7-.7l-1.06 1.05-.46-.73a1 1 0 0 0-1.42-.28.5.5 0 0 0 .58.81l.57.93-1.21 1.22a.5.5 0 0 0 .7.7l1.06-1.05.45.74c.31.5.98.61 1.44.26a.5.5 0 0 0-.6-.8l-.57-.92z"
]);
const $76e5a570f6bfc30c$export$8702e4d86b209cde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula16Regular', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h1.65a1.5 1.5 0 0 1-.11-1H4.5a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v1.57q.35.07.68.25.18.09.32.21V3.5c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m3.45 5.28a1.92 1.92 0 0 1 2.78-1.57.5.5 0 0 1-.45.9.92.92 0 0 0-1.33.74l-.09 1.17h1.14a.5.5 0 0 1 0 1h-1.21l-.24 3.2a1.92 1.92 0 0 1-2.78 1.57.5.5 0 1 1 .46-.9.92.92 0 0 0 1.32-.74l.24-3.13H8.5a.5.5 0 1 1 0-1h.86zm5.4 4.07a.5.5 0 0 0-.7-.7l-1.06 1.05-.46-.73a1 1 0 0 0-1.42-.28.5.5 0 0 0 .58.81l.57.93-1.21 1.22a.5.5 0 0 0 .7.7l1.06-1.05.45.74c.31.5.98.61 1.44.26a.5.5 0 0 0-.6-.8l-.57-.92z"
]);
const $76e5a570f6bfc30c$export$af5175965e8fe964 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.65a1.5 1.5 0 0 1 1.92-2.05L11.2 14a1.5 1.5 0 0 1 .22-2.98l.02-.32a2.92 2.92 0 0 1 4.23-2.38q.18.09.32.21V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.45 7.28a1.92 1.92 0 0 1 2.78-1.57.5.5 0 0 1-.45.9.92.92 0 0 0-1.33.74l-.09 1.17h1.14a.5.5 0 1 1 0 1h-1.21l-.24 3.2a1.92 1.92 0 0 1-2.78 1.57.5.5 0 1 1 .46-.9.92.92 0 0 0 1.32-.74l.24-3.13h-.79a.5.5 0 0 1 0-1h.86zm5.4 4.07a.5.5 0 0 0-.7-.7l-1.06 1.05-.46-.73a1 1 0 0 0-1.42-.28.5.5 0 0 0 .58.81l.57.93-1.21 1.22a.5.5 0 0 0 .7.7l1.06-1.05.45.74c.31.5.98.61 1.44.26a.5.5 0 0 0-.6-.8l-.57-.92z"
]);
const $76e5a570f6bfc30c$export$9a5cf95602189fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula20Regular', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.65a1.5 1.5 0 0 1-.11-1H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v3.57q.35.07.68.25.18.09.32.21V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.45 7.28a1.92 1.92 0 0 1 2.78-1.57.5.5 0 0 1-.45.9.92.92 0 0 0-1.33.74l-.09 1.17h1.14a.5.5 0 1 1 0 1h-1.21l-.24 3.2a1.92 1.92 0 0 1-2.78 1.57.5.5 0 1 1 .46-.9.92.92 0 0 0 1.32-.74l.24-3.13h-.79a.5.5 0 0 1 0-1h.86zm5.4 4.07a.5.5 0 0 0-.7-.7l-1.06 1.05-.46-.73a1 1 0 0 0-1.42-.28.5.5 0 0 0 .58.81l.57.93-1.21 1.22a.5.5 0 0 0 .7.7l1.06-1.05.45.74c.31.5.98.61 1.44.26a.5.5 0 0 0-.6-.8l-.57-.92z"
]);
const $76e5a570f6bfc30c$export$fc1f57e1c61b2c07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula24Filled', "24", [
    "M15.99 4h1.76C18.99 4 20 5 20 6.25v6.25h-.06c-.12-.48-.44-.9-.92-1.14a3.5 3.5 0 0 0-5 2.64h-.27a1.75 1.75 0 0 0 0 3.5l-.23 3A1.75 1.75 0 0 0 11 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2h3.5c1.16 0 2.11.88 2.24 2m-6.49.25c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75m12.28 14.03a.75.75 0 1 0-1.06-1.06l-1.09 1.08-.42-.67a1.33 1.33 0 0 0-1.9-.38.75.75 0 0 0 .71 1.3l.52.84-1.32 1.33a.75.75 0 0 0 1.06 1.06l1.08-1.08.42.68c.41.66 1.3.82 1.92.35a.75.75 0 0 0-.74-1.29l-.51-.83zm-6.8-3.97a2.5 2.5 0 0 1 3.6-2.05.75.75 0 1 1-.66 1.35 1 1 0 0 0-1.43.81l-.05.58h.81a.75.75 0 0 1 0 1.5h-.92L16 20.7a2.5 2.5 0 0 1-3.6 2.04.75.75 0 1 1 .67-1.35 1 1 0 0 0 1.43-.81l.31-4.08h-1.07a.75.75 0 0 1 0-1.5h1.19z"
]);
const $76e5a570f6bfc30c$export$4c9a5065a7872888 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula24Regular', "24", [
    "M8.38 5.5H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h5.72A1.7 1.7 0 0 0 11 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.12 1.08-2 2.24-2h3.5c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25V13a1.8 1.8 0 0 0-.98-1.64 4 4 0 0 0-.52-.2V6.24a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1M9.5 4.25c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75m12.28 14.03a.75.75 0 1 0-1.06-1.06l-1.09 1.08-.42-.67a1.33 1.33 0 0 0-1.9-.38.75.75 0 0 0 .71 1.3l.52.84-1.32 1.33a.75.75 0 0 0 1.06 1.06l1.08-1.08.42.68c.41.66 1.3.82 1.92.35a.75.75 0 0 0-.74-1.29l-.51-.83zm-6.8-3.97a2.5 2.5 0 0 1 3.6-2.05.75.75 0 1 1-.66 1.35 1 1 0 0 0-1.43.81l-.05.58h.81a.75.75 0 0 1 0 1.5h-.92L16 20.7a2.5 2.5 0 0 1-3.6 2.04.75.75 0 1 1 .67-1.35 1 1 0 0 0 1.43-.81l.31-4.08h-1.07a.75.75 0 0 1 0-1.5h1.19z"
]);
const $76e5a570f6bfc30c$export$763cba832801adeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula28Filled', "28", [
    "M18.45 4h1.8A2.75 2.75 0 0 1 23 6.75v8.14a1.8 1.8 0 0 0-.96-1.45l-.07-.04a3.75 3.75 0 0 0-5.36 2.6h-.36a1.75 1.75 0 1 0 0 3.5h.07l-.35 4.77a.25.25 0 0 1-.37.2l-.06-.03A1.75 1.75 0 0 0 13 26H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2h4c1.2 0 2.22.86 2.45 2M11 4.5a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1m11.07 15.74a1.57 1.57 0 0 0-2.26-.44.75.75 0 1 0 .88 1.21.1.1 0 0 1 .1.02l1 1.61-2.07 2.07a.75.75 0 1 0 1.06 1.06l1.83-1.82.81 1.31c.49.79 1.55.98 2.28.42a.75.75 0 1 0-.9-1.2.1.1 0 0 1-.1-.01l-1-1.61 2.07-2.08a.75.75 0 0 0-1.06-1.06l-1.83 1.83zm-4.53-3.7a2.75 2.75 0 0 1 3.98-2.24l.07.03a.75.75 0 1 1-.67 1.34l-.07-.03c-.8-.4-1.74.13-1.8 1.02l-.03.34h1.23a.75.75 0 0 1 0 1.5H18.9l-.44 5.95a2.75 2.75 0 0 1-3.98 2.25l-.07-.03a.75.75 0 1 1 .68-1.34l.07.03c.8.4 1.74-.13 1.8-1.02l.44-5.84h-1.15a.75.75 0 0 1 0-1.5h1.26z"
]);
const $76e5a570f6bfc30c$export$9e58af4427347858 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula28Regular', "28", [
    "M9.7 5.5H7.76c-.69 0-1.25.56-1.25 1.25v16.5c0 .69.56 1.25 1.25 1.25h6.1A1.7 1.7 0 0 0 13 26H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4h1.8A2.5 2.5 0 0 1 12 2h4c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 23 6.75v8.14a1.8 1.8 0 0 0-.96-1.45l-.07-.04-.47-.2V6.75c0-.69-.56-1.25-1.25-1.25h-1.96A2.5 2.5 0 0 1 16 7h-4a2.5 2.5 0 0 1-2.3-1.5m1.3-1a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1m11.07 15.74a1.57 1.57 0 0 0-2.26-.44.75.75 0 1 0 .88 1.21.1.1 0 0 1 .1.02l1 1.61-2.07 2.07a.75.75 0 1 0 1.06 1.06l1.83-1.82.81 1.31c.49.79 1.55.98 2.28.42a.75.75 0 1 0-.9-1.2.1.1 0 0 1-.1-.01l-1-1.61 2.07-2.08a.75.75 0 0 0-1.06-1.06l-1.83 1.83zm-4.53-3.7a2.75 2.75 0 0 1 3.98-2.24l.07.03a.75.75 0 1 1-.67 1.34l-.07-.03c-.8-.4-1.74.13-1.8 1.02l-.03.34h1.23a.75.75 0 0 1 0 1.5H18.9l-.44 5.95a2.75 2.75 0 0 1-3.98 2.25l-.07-.03a.75.75 0 1 1 .68-1.34l.07.03c.8.4 1.74-.13 1.8-1.02l.44-5.84h-1.15a.75.75 0 0 1 0-1.5h1.26z"
]);
const $76e5a570f6bfc30c$export$54e683461d719b7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula32Filled', "32", [
    "M21.83 4h1.67A3.5 3.5 0 0 1 27 7.5v8.35a2.5 2.5 0 0 0-.84-.7L25.9 15a4.5 4.5 0 0 0-6.56 3.58 2.5 2.5 0 0 0-.34 4.7l-.29 3.96a2.5 2.5 0 0 0-3.2 2.75H8.5A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2h6a3 3 0 0 1 2.83 2M19 4h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m6.22 12.34a3 3 0 0 0-4.38 2.45L20.75 20H20a1 1 0 0 0 0 2h.6l-.43 6.07a1 1 0 0 1-1.46.81l-.25-.13a1 1 0 1 0-.92 1.78l.25.12a3 3 0 0 0 4.37-2.44l.45-6.21H24a1 1 0 0 0 0-2h-1.24l.07-1.07a1 1 0 0 1 1.46-.81l.25.13a1 1 0 1 0 .92-1.78zm5.48 8.37a1 1 0 1 0-1.41-1.42l-1.61 1.61-.65-1.04a1.8 1.8 0 0 0-2.61-.51 1 1 0 0 0 1 1.71l.8 1.3-1.93 1.93a1 1 0 0 0 1.42 1.41l1.6-1.6.65 1.05c.57.9 1.8 1.13 2.65.48a1 1 0 0 0-1.05-1.7l-.8-1.28z"
]);
const $76e5a570f6bfc30c$export$aec3253e7efddc27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormula32Regular', "32", [
    "M19 2a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 27 7.5v8.35q-.33-.43-.84-.7L25.9 15q-.45-.23-.91-.36V7.5c0-.83-.67-1.5-1.5-1.5h-1.67A3 3 0 0 1 19 8h-6a3 3 0 0 1-2.83-2H8.5C7.67 6 7 6.67 7 7.5v19c0 .83.67 1.5 1.5 1.5h7.61a2.5 2.5 0 0 0-.58 2H8.5A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2zm-6 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm17.7 20.7a1 1 0 1 0-1.41-1.4l-1.61 1.6-.65-1.04a1.8 1.8 0 0 0-2.61-.51 1 1 0 0 0 1 1.71l.8 1.3-1.93 1.93a1 1 0 0 0 1.42 1.41l1.6-1.6.65 1.05c.57.9 1.8 1.13 2.65.48a1 1 0 0 0-1.05-1.7l-.8-1.28zm-9.86-5.91a3 3 0 0 1 4.38-2.45l.24.13a1 1 0 1 1-.92 1.78l-.25-.13a1 1 0 0 0-1.46.81L22.76 20H24a1 1 0 0 1 0 2h-1.39l-.45 6.2a3 3 0 0 1-4.37 2.45l-.25-.12a1 1 0 1 1 .92-1.78l.25.13a1 1 0 0 0 1.46-.81l.44-6.07H20a1 1 0 1 1 0-2h.75z"
]);
const $76e5a570f6bfc30c$export$2d7290820adc6626 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonth16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.75 8a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m.75 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10.25 8a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-1.5-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 10.5A.75.75 0 1 1 8 9a.75.75 0 0 1 0 1.5"
]);
const $76e5a570f6bfc30c$export$bdc14fcc2adb08a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonth16Regular', "16", [
    "M5.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10.25 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-1.5-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 10.5A.75.75 0 1 0 8 9a.75.75 0 0 0 0 1.5M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 3h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$aed3ead377fe9442 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonth20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M7 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$dcf481cb427285f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonth20Regular', "20", [
    "M7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$18b6493c964dd006 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonth24Filled', "24", [
    "M13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m-2 9a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m0 4a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m9.25-5.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-5.25 1.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m1.25 2.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $76e5a570f6bfc30c$export$d842923a4f7ec25e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonth24Regular', "24", [
    "M8.25 12.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m9.25-5.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-5.25 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m1.25 2.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 4.08A2.25 2.25 0 0 0 13.74 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76zm0 .02v.15zm-5.75 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$9c3f427407a7ade0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMore20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48q-.66.34-1 .99a2.25 2.25 0 0 0-4 0A2.25 2.25 0 0 0 6.98 18H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.75 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $76e5a570f6bfc30c$export$1b1ec70c1ac86726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMore20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48q-.66.34-1 .99V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h1.25q0 .54.23 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.75 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $76e5a570f6bfc30c$export$38518bc87529a76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMore24Filled', "24", [
    "M10.25 3.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m3.5-1.5h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22H8.5q-.48-.65-.5-1.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0c0-1.2.86-2.22 2-2.45V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2M12 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $76e5a570f6bfc30c$export$daf3455389c7e4df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMore24Regular', "24", [
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22H8.5q-.48-.65-.5-1.5H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75V19a2.5 2.5 0 0 1 1.5-.95V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74-.6h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m1.75 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $76e5a570f6bfc30c$export$5be6a79485ceaa4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMultiple16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v8c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m7 9V3.27A2 2 0 0 1 14 5v6.5a3.5 3.5 0 0 1-3.5 3.5H6a2 2 0 0 1-1.73-1h6.23a2.5 2.5 0 0 0 2.5-2.5"
]);
const $76e5a570f6bfc30c$export$3b941bfd2d5731d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMultiple16Regular', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v8c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5M4.5 3h.59c.2.58.76 1 1.41 1h2c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-8c0-.28.22-.5.5-.5m8.5 8.5V3.27A2 2 0 0 1 14 5v6.5a3.5 3.5 0 0 1-3.5 3.5H6a2 2 0 0 1-1.73-1h6.23a2.5 2.5 0 0 0 2.5-2.5"
]);
const $76e5a570f6bfc30c$export$d8245608f319b507 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNote16Filled', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5V6H8a3 3 0 0 0-3 3v4c0 .77.29 1.47.76 2H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM8 7a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm.5 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1M8 12.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$80fb67c9c1de034a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNote16Regular', "16", [
    "M5.09 2c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5V6h-1V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h.67a3 3 0 0 0 .6 1H4.5A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM8 7a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm.5 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1M8 12.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$f66fb66cd16aeb1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNote20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-4a3 3 0 0 0-3 3v4a3 3 0 0 0 .17 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.5 8a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m0-3c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$4c579a14f94be511 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNote20Regular', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.84a4 4 0 0 1-.3-1H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5V10h1V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4 7.5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m0-3c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$ad258a44226ccf20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12316Filled', "16", [
    "M5.5 1c-.65 0-1.2.42-1.41 1H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5h1.59a2 2 0 0 1-.09-.5V13a1.5 1.5 0 0 1-.62-2.87c.28-.12.47-.31.6-.47a1.7 1.7 0 0 1 1.78-.59 1.7 1.7 0 0 1 .97.7A3 3 0 0 1 9.54 9a2.7 2.7 0 0 1 2.12.84q.15-.15.34-.28V3.5c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM5 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m2 8.15c0-.2-.1-.35-.2-.45a1 1 0 0 0-.3-.16c-.16-.05-.5-.07-.73.22-.2.26-.51.57-.98.78a.5.5 0 0 0 .42.92q.46-.23.79-.5v3.04a.5.5 0 0 0 1 0zm6.73.35c-.23 0-.54.1-.86.45a.5.5 0 0 1-.74-.67 2.2 2.2 0 0 1 1.6-.78c.53 0 1.02.24 1.32.6a1.3 1.3 0 0 1-.16 1.9q.27.21.4.5a1.3 1.3 0 0 1-.24 1.4c-.3.36-.79.6-1.32.6-.55 0-1.12-.25-1.6-.78a.5.5 0 0 1 .74-.67c.32.35.63.45.86.45q.38-.01.57-.25c.11-.13.11-.25.08-.33-.04-.1-.22-.3-.8-.43a.5.5 0 0 1 0-.98c.58-.13.76-.34.8-.43q.06-.13-.08-.33a.8.8 0 0 0-.57-.25m-4.85.45c.29-.34.57-.44.77-.45q.32 0 .55.2.2.22.2.44c-.01.11-.08.28-.35.44a5 5 0 0 0-1.8 1.58 2 2 0 0 0-.25.78v.11a.5.5 0 0 0 .5.45h2.4a.5.5 0 0 0 0-1H9.23c.2-.27.6-.64 1.32-1.06.52-.3.8-.74.84-1.23.03-.48-.18-.92-.5-1.23s-.78-.5-1.3-.48c-.51.03-1.03.29-1.47.8a.5.5 0 1 0 .76.65"
]);
const $76e5a570f6bfc30c$export$8157607046543281 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12316Regular', "16", [
    "M5.5 1c-.65 0-1.2.42-1.41 1H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5h1.59a2 2 0 0 1-.09-.5V14H3.5a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v5.84a3 3 0 0 1 .66.5q.15-.15.34-.28V3.5c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM5 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m2 8.15c0-.2-.1-.35-.2-.45a1 1 0 0 0-.3-.16c-.16-.05-.5-.07-.73.22-.2.26-.51.57-.98.78a.5.5 0 0 0 .42.92q.46-.23.79-.5v3.04a.5.5 0 0 0 1 0zm6.73.35c-.23 0-.54.1-.86.45a.5.5 0 0 1-.74-.67 2.2 2.2 0 0 1 1.6-.78c.53 0 1.02.24 1.32.6a1.3 1.3 0 0 1-.16 1.9q.27.21.4.5a1.3 1.3 0 0 1-.24 1.4c-.3.36-.79.6-1.32.6-.55 0-1.12-.25-1.6-.78a.5.5 0 0 1 .74-.67c.32.35.63.45.86.45q.38-.01.57-.25c.11-.13.11-.25.08-.33-.04-.1-.22-.3-.8-.43a.5.5 0 0 1 0-.98c.58-.13.76-.34.8-.43q.06-.13-.08-.33a.8.8 0 0 0-.57-.25m-4.85.45c.29-.34.57-.44.77-.45q.32 0 .55.2.2.22.2.44c-.01.11-.08.28-.35.44a5 5 0 0 0-1.8 1.58 2 2 0 0 0-.25.78v.11a.5.5 0 0 0 .5.45h2.4a.5.5 0 0 0 0-1H9.23c.2-.27.6-.64 1.32-1.06.52-.3.8-.74.84-1.23.03-.48-.18-.92-.5-1.23s-.78-.5-1.3-.48c-.51.03-1.03.29-1.47.8a.5.5 0 1 0 .76.65"
]);
const $76e5a570f6bfc30c$export$f7e728583e8dde6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12320Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h1.59a2 2 0 0 1-.09-.5v-2a1.5 1.5 0 0 1-.73-2.81c.27-.15.5-.46.66-.79.47-.96 1.46-.92 1.76-.86a1.6 1.6 0 0 1 1.12.81q.9-.76 2.01-.85a3 3 0 0 1 2.6 1.22q.7-.76 1.58-1.05V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m7.87 10.1c.42-.46.84-.6 1.16-.6.35 0 .64.15.81.35q.25.31.12.55c-.07.17-.33.44-1.07.61a.5.5 0 0 0 0 .98c.74.17 1 .44 1.07.61q.12.25-.12.55c-.17.2-.46.35-.8.35-.33 0-.75-.14-1.17-.6a.5.5 0 0 0-.74.66c.58.65 1.26.94 1.9.94s1.2-.28 1.57-.7a1.5 1.5 0 0 0-.32-2.3q.4-.29.6-.69a1.5 1.5 0 0 0-.28-1.61c-.36-.42-.93-.7-1.56-.7-.65 0-1.33.29-1.91.94a.5.5 0 0 0 .74.67m-3.94-.6c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29M9 12.6c0-.2-.1-.35-.2-.44a1 1 0 0 0-.3-.14c-.13-.03-.5-.03-.67.32-.2.41-.54.93-1.07 1.22a.5.5 0 1 0 .48.88q.45-.26.76-.6v3.66a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$5b480034ee086527 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12320Regular', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h1.59a2 2 0 0 1-.09-.5V17H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v7.2a4 4 0 0 1 1-.53V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m2 14.05v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45m5.87-3.94c.42-.47.84-.61 1.16-.61.35 0 .64.15.81.35q.25.31.12.55c-.07.17-.33.44-1.07.61a.5.5 0 0 0 0 .98c.74.17 1 .44 1.07.61q.12.25-.12.55c-.17.2-.46.35-.8.35-.33 0-.75-.14-1.17-.6a.5.5 0 0 0-.74.66c.58.65 1.26.94 1.9.94s1.2-.28 1.57-.7a1.5 1.5 0 0 0-.32-2.3q.4-.29.6-.69a1.5 1.5 0 0 0-.28-1.61c-.36-.42-.93-.7-1.56-.7-.65 0-1.33.29-1.91.94a.5.5 0 0 0 .74.67M9 12.6c0-.2-.1-.35-.2-.44a1 1 0 0 0-.3-.14c-.13-.03-.5-.03-.67.32-.2.41-.54.93-1.07 1.22a.5.5 0 1 0 .48.88q.45-.26.76-.6v3.66a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$6d0e6f86c4a33f31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12324Filled', "24", [
    "M17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.88-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h2.42q-.16-.34-.17-.75v-2.27a1.75 1.75 0 0 1-1.14-3.24c.35-.2.7-.57.97-.96a2 2 0 0 1 2.2-.76c.41.12.98.46 1.28 1.06A4 4 0 0 1 14.3 14a3.6 3.6 0 0 1 3.1 1.48l.09-.1A4.3 4.3 0 0 1 20 14.05V6.25C20 5.01 19 4 17.75 4m-7.5 1a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5zM11 15.94a1 1 0 0 0-.74-.95c-.31-.09-.8-.06-1.11.37-.32.44-.76.94-1.28 1.24a.75.75 0 0 0 .76 1.3q.48-.3.87-.67v4.02a.75.75 0 0 0 1.5 0zm3.43.56c-.31.02-.7.16-1.13.61a.75.75 0 0 1-1.1-1.02c.65-.7 1.4-1.05 2.15-1.09.73-.03 1.4.24 1.88.67.47.42.8 1.05.76 1.75-.05.72-.5 1.35-1.26 1.75-.95.52-1.5.98-1.8 1.33h2.32a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.74-.67v-.17q0-.12.03-.29.06-.34.35-.82a7 7 0 0 1 2.63-2.2c.4-.21.46-.43.47-.54q.03-.23-.26-.53-.32-.29-.8-.28m4.86.62c.88-.92 1.76-.63 2.08-.29.16.18.14.3.1.36-.04.1-.28.4-1.13.58a.75.75 0 0 0 0 1.46c.85.18 1.09.48 1.14.58.03.06.05.18-.11.36-.32.34-1.2.63-2.08-.29a.75.75 0 0 0-1.08 1.04c1.45 1.52 3.34 1.27 4.27.26a1.8 1.8 0 0 0-.17-2.68 1.8 1.8 0 0 0 .17-2.68c-.93-1.01-2.82-1.26-4.27.26a.75.75 0 1 0 1.08 1.04"
]);
const $76e5a570f6bfc30c$export$118a2cc8b62c3d68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12324Regular', "24", [
    "M6.25 5.5h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v8.32q.74-.42 1.5-.53V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.88-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h2.42q-.16-.34-.17-.75v-.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75m4-.5a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5zM11 15.94a1 1 0 0 0-.74-.95c-.31-.09-.8-.06-1.11.37-.32.44-.76.94-1.28 1.24a.75.75 0 0 0 .76 1.3q.48-.3.87-.67v4.02a.75.75 0 0 0 1.5 0zm3.43.56c-.31.02-.7.16-1.13.61a.75.75 0 0 1-1.1-1.02c.65-.7 1.4-1.05 2.15-1.09.73-.03 1.4.24 1.88.67.47.42.8 1.05.76 1.75-.05.72-.5 1.35-1.26 1.75-.95.52-1.5.98-1.8 1.33h2.32a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.74-.67v-.17q0-.12.03-.29.06-.34.35-.82a7 7 0 0 1 2.63-2.2c.4-.21.46-.43.47-.54q.03-.23-.26-.53-.32-.29-.8-.28m4.86.62c.88-.92 1.76-.63 2.08-.29.16.18.14.3.1.36-.04.1-.28.4-1.13.58a.75.75 0 0 0 0 1.46c.85.18 1.09.48 1.14.58.03.06.05.18-.11.36-.32.34-1.2.63-2.08-.29a.75.75 0 0 0-1.08 1.04c1.45 1.52 3.34 1.27 4.27.26a1.8 1.8 0 0 0-.17-2.68 1.8 1.8 0 0 0 .17-2.68c-.93-1.01-2.82-1.26-4.27.26a.75.75 0 1 0 1.08 1.04"
]);
const $76e5a570f6bfc30c$export$e59037c5ce4a0639 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12328Filled', "28", [
    "M20.25 4h-1.8A2.5 2.5 0 0 0 16 2h-4a2.5 2.5 0 0 0-2.45 2h-1.8A2.75 2.75 0 0 0 5 6.75v16.5A2.75 2.75 0 0 0 7.75 26h1.92a2 2 0 0 1-.17-.75v-2.99a1.75 1.75 0 0 1-1.39-3.18q.62-.37 1.22-1.23a2 2 0 0 1 2.26-.75 2 2 0 0 1 1.31 1.28 4.4 4.4 0 0 1 4.59-1.14c.79.29 1.45.79 1.89 1.42l.12-.14c1-1 2.26-1.53 3.5-1.51V6.75A2.75 2.75 0 0 0 20.25 4M12 5.5a1 1 0 0 1-1-1 1 1 0 0 1 1-1h4a1 1 0 0 1 1 1 1 1 0 0 1-1 1zM14 26h4.22c.41 0 .75-.34.75-.75a.76.76 0 0 0-.75-.75h-3.14a8 8 0 0 1 2.43-1.82c.99-.52 1.52-1.35 1.45-2.27-.06-.96-.8-1.86-1.83-2.23-1.25-.45-2.63-.05-3.69 1.06-.28.3-.27.77.03 1.06.3.28.77.27 1.06-.03.65-.68 1.42-.93 2.1-.68.47.17.82.56.85.93.03.4-.34.67-.65.84-3.62 1.91-3.62 3.65-3.58 3.98.05.37.37.66.75.66m8.91 0c-.85 0-1.82-.33-2.7-1.23a.75.75 0 0 1 0-1.06.76.76 0 0 1 1.06 0c.86.88 1.79.89 2.38.62.37-.18.62-.48.59-.72-.03-.26-.45-.65-1.53-.88a.75.75 0 0 1-.6-.73c0-.35.25-.66.6-.73 1.07-.22 1.49-.61 1.53-.88.03-.24-.22-.54-.58-.72-.58-.28-1.51-.27-2.38.61a.75.75 0 0 1-1.06 0 .74.74 0 0 1 0-1.06c1.42-1.45 3.05-1.42 4.1-.91.97.47 1.53 1.36 1.42 2.26-.05.38-.24.95-.9 1.43.66.49.85 1.05.9 1.43.11.9-.45 1.79-1.43 2.26q-.61.3-1.4.31m-11.66 0zm-.75-.75c0 .4.34.75.74.75.41 0 .75-.34.75-.75v-6.26a1 1 0 0 0-.71-.94 1 1 0 0 0-1.14.37 5 5 0 0 1-1.53 1.52.76.76 0 0 0-.26 1.03c.21.35.67.47 1.03.26q.64-.4 1.12-.89z"
]);
const $76e5a570f6bfc30c$export$b19d20002e87ebc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12328Regular', "28", [
    "M7.75 5.5h1.96A2.5 2.5 0 0 0 12 7h4c1.02 0 1.9-.62 2.29-1.5h1.96c.69 0 1.25.56 1.25 1.25v10.5q.74-.24 1.5-.24V6.75A2.75 2.75 0 0 0 20.25 4h-1.8A2.5 2.5 0 0 0 16 2h-4a2.5 2.5 0 0 0-2.45 2h-1.8A2.75 2.75 0 0 0 5 6.75v16.5A2.75 2.75 0 0 0 7.75 26h1.92a2 2 0 0 1-.17-.75v-.75H7.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25m4.25 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h4a1 1 0 0 1 1 1 1 1 0 0 1-1 1zM14 26h4.22c.41 0 .75-.34.75-.75a.76.76 0 0 0-.75-.75h-3.14a8 8 0 0 1 2.43-1.82c.99-.52 1.52-1.35 1.45-2.27-.06-.96-.8-1.86-1.83-2.23-1.25-.45-2.63-.05-3.69 1.06-.28.3-.27.77.03 1.06.3.28.77.27 1.06-.03.65-.68 1.42-.93 2.1-.68.47.17.82.56.85.93.03.4-.34.67-.65.84-3.62 1.91-3.62 3.65-3.58 3.98.05.37.37.66.75.66m8.91 0c-.85 0-1.82-.33-2.7-1.23a.75.75 0 0 1 0-1.06.76.76 0 0 1 1.06 0c.86.88 1.79.89 2.38.62.37-.18.62-.48.59-.72-.03-.26-.45-.65-1.53-.88a.75.75 0 0 1-.6-.73c0-.35.25-.66.6-.73 1.07-.22 1.49-.61 1.53-.88.03-.24-.22-.54-.58-.72-.58-.28-1.51-.27-2.38.61a.75.75 0 0 1-1.06 0 .74.74 0 0 1 0-1.06c1.42-1.45 3.05-1.42 4.1-.91.97.47 1.53 1.36 1.42 2.26-.05.38-.24.95-.9 1.43.66.49.85 1.05.9 1.43.11.9-.45 1.79-1.43 2.26q-.61.3-1.4.31m-11.66 0zm-.75-.75c0 .4.34.75.74.75.41 0 .75-.34.75-.75v-6.26a1 1 0 0 0-.71-.94 1 1 0 0 0-1.14.37 5 5 0 0 1-1.53 1.52.76.76 0 0 0-.26 1.03c.21.35.67.47 1.03.26q.64-.4 1.12-.89z"
]);
const $76e5a570f6bfc30c$export$c19ad7b02d2853b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12332Filled', "32", [
    "M21.83 4h1.67A3.5 3.5 0 0 1 27 7.5v12a5.7 5.7 0 0 0-4.38 1.93q-.29-.4-.62-.7c-.9-.8-2.16-1.3-3.52-1.22-1.2.06-2.34.54-3.32 1.4a3 3 0 0 0-1.65-1.3 2.8 2.8 0 0 0-3.02 1.04c-.34.47-.8.97-1.26 1.25a2.5 2.5 0 0 0 1.27 4.65V29q0 .54.21 1H8.5A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2h6a3 3 0 0 1 2.83 2M19 4h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m-1.77 19.77c.53-.57 1.04-.75 1.43-.77.4-.02.76.13 1 .35.26.23.34.47.33.63-.01.12-.08.38-.59.66-1.87 1-2.87 1.98-3.39 2.8a3.4 3.4 0 0 0-.5 1.44v.23a1 1 0 0 0 1 .89H21a1 1 0 1 0 0-2h-2.9c.42-.43 1.1-.98 2.25-1.6.97-.52 1.57-1.33 1.63-2.28a2.8 2.8 0 0 0-.98-2.26 3.4 3.4 0 0 0-2.44-.86 4 4 0 0 0-2.79 1.4 1 1 0 0 0 1.46 1.37m10.61-.36c-.39-.42-1.5-.8-2.62.36a1 1 0 1 1-1.44-1.39c1.89-1.95 4.33-1.63 5.53-.32a2.33 2.33 0 0 1-.17 3.44q.41.34.64.82c.47.98.13 1.97-.47 2.62-1.2 1.3-3.65 1.63-5.53-.33a1 1 0 0 1 1.44-1.38c1.12 1.15 2.23.78 2.62.36.2-.22.16-.35.14-.4-.06-.11-.35-.48-1.44-.71a1 1 0 0 1 0-1.96c1.1-.23 1.38-.6 1.44-.71.02-.05.06-.18-.14-.4M14 22.24c0-.7-.52-1.08-.9-1.19-.4-.11-1-.06-1.39.47-.39.55-.99 1.24-1.72 1.67a1 1 0 0 0 1.02 1.72q.54-.32 1-.73V29a1 1 0 1 0 2 0z"
]);
const $76e5a570f6bfc30c$export$68f2b8cdf62a4eeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber12332Regular', "32", [
    "M21.83 4A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h2.21a3 3 0 0 1-.2-1v-1H8.5A1.5 1.5 0 0 1 7 26.5v-19C7 6.67 7.67 6 8.5 6h1.67A3 3 0 0 0 13 8h6a3 3 0 0 0 2.83-2h1.67c.83 0 1.5.67 1.5 1.5v12.32a5 5 0 0 1 2-.32v-12A3.5 3.5 0 0 0 23.5 4zM12 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m5.23 18.77c.53-.57 1.04-.75 1.43-.77.4-.02.76.13 1 .35.26.23.34.47.33.63-.01.12-.08.38-.59.66-1.87 1-2.87 1.98-3.39 2.8a3.4 3.4 0 0 0-.5 1.44v.23a1 1 0 0 0 1 .89H21a1 1 0 1 0 0-2h-2.9c.42-.43 1.1-.98 2.25-1.6.97-.52 1.57-1.33 1.63-2.28a2.8 2.8 0 0 0-.98-2.26 3.4 3.4 0 0 0-2.44-.86 4 4 0 0 0-2.79 1.4 1 1 0 0 0 1.46 1.37m10.61-.36c-.39-.42-1.5-.8-2.62.36a1 1 0 1 1-1.44-1.39c1.89-1.95 4.33-1.63 5.53-.32a2.33 2.33 0 0 1-.17 3.44q.41.34.64.82c.47.98.13 1.97-.47 2.62-1.2 1.3-3.65 1.63-5.53-.33a1 1 0 0 1 1.44-1.38c1.12 1.15 2.23.78 2.62.36.2-.22.16-.35.14-.4-.06-.11-.35-.48-1.44-.71a1 1 0 0 1 0-1.96c1.1-.23 1.38-.6 1.44-.71.02-.05.06-.18-.14-.4M14 22.24c0-.7-.52-1.08-.9-1.19-.4-.11-1-.06-1.39.47-.39.55-.99 1.24-1.72 1.67a1 1 0 0 0 1.02 1.72q.54-.32 1-.73V29a1 1 0 1 0 2 0z"
]);
const $76e5a570f6bfc30c$export$64962225ed22d969 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOff16Filled', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 11.5 15h-7A1.5 1.5 0 0 1 3 13.5V3.7L1.15 1.86a.5.5 0 0 1 0-.7M9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v7.38L4.16 2.04Q4.31 2 4.5 2h.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$dae1fdb0d14f1bc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOff16Regular', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 11.5 15h-7A1.5 1.5 0 0 1 3 13.5V3.7L1.15 1.86a.5.5 0 0 1 0-.7M4 13.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-.8l-8-8zM9.5 1c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v7.38l-1-1V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3q-.23 0-.45-.07l-1.89-1.9Q4.31 2 4.5 2h.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$46ccc3041d332580 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOff20Filled', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 14.5 18h-9A1.5 1.5 0 0 1 4 16.5V4.7L2.15 2.86a.5.5 0 0 1 0-.7M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v9.38L5.16 3.04Q5.31 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$8817a531483441a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOff20Regular', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 14.5 18h-9A1.5 1.5 0 0 1 4 16.5V4.7L2.15 2.86a.5.5 0 0 1 0-.7M5 16.5c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-.8L5 5.7zM11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v9.38l-1-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1h-.96l-.96-.96Q5.32 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$523e012c39e29092 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOff24Filled', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-.98-.98a2.3 2.3 0 0 1-1.99 1.2H6.25C5.01 22 4 21 4 19.75V6.25q0-.53.22-.97l-2-2a.75.75 0 0 1 0-1.06M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v10.57L7.18 4h.83c.13-1.12 1.08-2 2.24-2zm-3.5 1.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$ae16b55a539766be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOff24Regular', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-.98-.98a2.3 2.3 0 0 1-1.99 1.2H6.25C5.01 22 4 21 4 19.75V6.25q0-.53.22-.97l-2-2a.75.75 0 0 1 0-1.06M5.5 19.75c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75v-.19l-13-13zM13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25v10.57l-1.5-1.5V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5q-.35 0-.67-.1L7.18 4h.83c.13-1.12 1.08-2 2.24-2zm-3.5 1.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$f4d8fd2e726d9f68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste16Filled', "16", [
    "M3.5 2h.59c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h.59A1.5 1.5 0 0 1 12 3.5V5h-1V3.5a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H3.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2.61v1H3.5A1.5 1.5 0 0 1 2 13.5v-10A1.5 1.5 0 0 1 3.5 2m2 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3 4C7.67 6 7 6.67 7 7.5v6c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$286aea8116071789 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste16Regular', "16", [
    "M4.09 2H3.5A1.5 1.5 0 0 0 2 3.5v10A1.5 1.5 0 0 0 3.5 15h2.61v-1H3.5a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59a.5.5 0 0 1 .5.5V5h1V3.5A1.5 1.5 0 0 0 10.5 2h-.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1m.91.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M8.5 6C7.67 6 7 6.67 7 7.5v6c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5zM8 7.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$fa478d052fbcb89b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste20Filled', "20", [
    "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5m3 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$57901a53bd659f68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste20Regular', "20", [
    "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5m3 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zM10 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$d7410aada1ded516 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste24Filled', "24", [
    "M12.75 2c1.16 0 2.11.88 2.24 2h1.76c1.2 0 2.17.93 2.24 2.1l.01.15c0 .38-.28.7-.65.74h-.1a.75.75 0 0 1-.74-.64l-.01-.1c0-.38-.28-.7-.65-.74l-.1-.01h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.46-.4-1.87-1H5.25c-.38 0-.7.28-.74.65l-.01.1v13.5c0 .38.28.7.65.75h3.1c.38 0 .7.29.74.65l.01.1c0 .42-.34.75-.75.75h-3c-1.2 0-2.17-.92-2.24-2.1L3 19.76V6.25c0-1.2.93-2.17 2.1-2.24L5.25 4h1.76c.13-1.12 1.08-2 2.24-2zm6 6c1.2 0 2.17.93 2.24 2.1l.01.15v9.5c0 1.2-.93 2.17-2.1 2.24l-.15.01h-6.5c-1.2 0-2.17-.93-2.24-2.1l-.01-.15v-9.5c0-1.2.93-2.17 2.1-2.24l.15-.01zm-6-4.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 1 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$894fb336769f4f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste24Regular', "24", [
    "M12.75 2c1.16 0 2.11.88 2.24 2h1.76c1.2 0 2.17.93 2.24 2.1l.01.15c0 .38-.28.7-.65.74h-.1a.75.75 0 0 1-.74-.64l-.01-.1c0-.38-.28-.7-.65-.74l-.1-.01h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.46-.4-1.87-1H5.25c-.38 0-.7.28-.74.65l-.01.1v13.5c0 .38.28.7.65.75h3.1c.38 0 .7.29.74.65l.01.1c0 .42-.34.75-.75.75h-3c-1.2 0-2.17-.92-2.24-2.1L3 19.76V6.25c0-1.2.93-2.17 2.1-2.24L5.25 4h1.76c.13-1.12 1.08-2 2.24-2zm6 6c1.2 0 2.17.93 2.24 2.1l.01.15v9.5c0 1.2-.93 2.17-2.1 2.24l-.15.01h-6.5c-1.2 0-2.17-.93-2.24-2.1l-.01-.15v-9.5c0-1.2.93-2.17 2.1-2.24l.15-.01zm0 1.5h-6.5c-.38 0-.7.28-.74.65l-.01.1v9.5c0 .38.28.7.65.74l.1.01h6.5c.38 0 .7-.28.74-.65l.01-.1v-9.5c0-.38-.28-.7-.65-.74zm-6-6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 1 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$2e3c3d135bcc79f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste28Filled', "28", [
    "M15 2c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 22 6.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25h-1.96A2.5 2.5 0 0 1 15 7h-4a2.5 2.5 0 0 1-2.29-1.5H6.75c-.69 0-1.25.56-1.25 1.25v16.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 4 23.25V6.75A2.75 2.75 0 0 1 6.75 4h1.8A2.5 2.5 0 0 1 11 2zm7.25 7A2.75 2.75 0 0 1 25 11.75v11.5A2.75 2.75 0 0 1 22.25 26h-7.5A2.75 2.75 0 0 1 12 23.25v-11.5A2.75 2.75 0 0 1 14.75 9zM11 3.5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"
]);
const $76e5a570f6bfc30c$export$6fb86cb79e2ec24c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste28Regular', "28", [
    "M15 2c1.2 0 2.22.86 2.45 2h1.8A2.75 2.75 0 0 1 22 6.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25h-1.96A2.5 2.5 0 0 1 15 7h-4a2.5 2.5 0 0 1-2.29-1.5H6.75c-.69 0-1.25.56-1.25 1.25v16.5c0 .69.56 1.25 1.25 1.25h3.5a.75.75 0 0 1 0 1.5h-3.5A2.75 2.75 0 0 1 4 23.25V6.75A2.75 2.75 0 0 1 6.75 4h1.8A2.5 2.5 0 0 1 11 2zm7.25 7A2.75 2.75 0 0 1 25 11.75v11.5A2.75 2.75 0 0 1 22.25 26h-7.5A2.75 2.75 0 0 1 12 23.25v-11.5A2.75 2.75 0 0 1 14.75 9zm-7.5 1.5c-.69 0-1.25.56-1.25 1.25v11.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-11.5c0-.69-.56-1.25-1.25-1.25zM11 3.5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"
]);
const $76e5a570f6bfc30c$export$c532ec3f45e25829 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste32Filled', "32", [
    "M9.17 6H7.5C6.67 6 6 6.67 6 7.5v19c0 .83.67 1.5 1.5 1.5H12a1 1 0 1 1 0 2H7.5A3.5 3.5 0 0 1 4 26.5v-19A3.5 3.5 0 0 1 7.5 4h1.67A3 3 0 0 1 12 2h6a3 3 0 0 1 2.83 2h1.67A3.5 3.5 0 0 1 26 7.5a1 1 0 1 1-2 0c0-.83-.67-1.5-1.5-1.5h-1.67A3 3 0 0 1 18 8h-6a3 3 0 0 1-2.83-2M11 5a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2h-6a1 1 0 0 0-1 1m3 8.5a3.5 3.5 0 0 1 3.5-3.5h8a3.5 3.5 0 0 1 3.5 3.5v13a3.5 3.5 0 0 1-3.5 3.5h-8a3.5 3.5 0 0 1-3.5-3.5z"
]);
const $76e5a570f6bfc30c$export$a2d91b64938a0dba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste32Light', "32", [
    "M9.05 4a2.5 2.5 0 0 1 2.45-2h7c1.2 0 2.22.86 2.45 2h1.8C24.55 4 26 5.46 26 7.25v1.26l-.25-.01H25V7.25C25 6.01 24 5 22.75 5h-1.8a2.5 2.5 0 0 1-2.45 2h-7a2.5 2.5 0 0 1-2.45-2h-1.8C6.01 5 5 6 5 7.25v19.5C5 27.99 6 29 7.25 29h5.82q.3.54.72 1H7.25A3.25 3.25 0 0 1 4 26.75V7.25C4 5.45 5.46 4 7.25 4zM20 4.5c0-.83-.67-1.5-1.5-1.5h-7a1.5 1.5 0 0 0 0 3h7c.83 0 1.5-.67 1.5-1.5m-6 8.75c0-1.8 1.46-3.25 3.25-3.25h8.5c1.8 0 3.25 1.46 3.25 3.25v13.5c0 1.8-1.46 3.25-3.25 3.25h-8.5A3.25 3.25 0 0 1 14 26.75zM17.25 11C16.01 11 15 12 15 13.25v13.5c0 1.24 1 2.25 2.25 2.25h8.5c1.24 0 2.25-1 2.25-2.25v-13.5c0-1.24-1-2.25-2.25-2.25z"
]);
const $76e5a570f6bfc30c$export$4fbbf6781b358e05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPaste32Regular', "32", [
    "M7.5 6h1.67A3 3 0 0 0 12 8h6a3 3 0 0 0 2.83-2h1.67c.83 0 1.5.67 1.5 1.5a1 1 0 1 0 2 0A3.5 3.5 0 0 0 22.5 4h-1.67A3 3 0 0 0 18 2h-6a3 3 0 0 0-2.83 2H7.5A3.5 3.5 0 0 0 4 7.5v19A3.5 3.5 0 0 0 7.5 30H12a1 1 0 1 0 0-2H7.5A1.5 1.5 0 0 1 6 26.5v-19C6 6.67 6.67 6 7.5 6M12 4h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2m5.5 6a3.5 3.5 0 0 0-3.5 3.5v13a3.5 3.5 0 0 0 3.5 3.5h8a3.5 3.5 0 0 0 3.5-3.5v-13a3.5 3.5 0 0 0-3.5-3.5zM16 13.5c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$6746b02fd434bf45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPulse20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1.57l-.59-1.17a1.5 1.5 0 0 0-2.68 0l-.33.65-.9-2.92a1.5 1.5 0 0 0-2.8-.17L5.53 10H4V4.5C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5 10H16v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h2.5c.6 0 1.13-.35 1.37-.9l.37-.83.83 2.67a1.5 1.5 0 0 0 2.77.23l.74-1.48q.4.3.92.31M8.98 6.85a.5.5 0 0 0-.94-.05L6.18 11H2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .46-.3L8.4 8.42l1.61 5.23a.5.5 0 0 0 .93.07l1.55-3.1.55 1.1a.5.5 0 0 0 .45.28h4a.5.5 0 0 0 0-1h-3.7l-.85-1.72a.5.5 0 0 0-.9 0l-1.44 2.88z"
]);
const $76e5a570f6bfc30c$export$96fbcbdb7d2bc133 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPulse20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5V10H4V4.5C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM15 13h1v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h1v3.5c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5zM8.98 6.85a.5.5 0 0 0-.94-.05L6.18 11H2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .46-.3L8.4 8.42l1.61 5.23a.5.5 0 0 0 .93.07l1.55-3.1.55 1.1a.5.5 0 0 0 .45.28h4a.5.5 0 0 0 0-1h-3.7l-.85-1.72a.5.5 0 0 0-.9 0l-1.44 2.88z"
]);
const $76e5a570f6bfc30c$export$877d2f21feeda9fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPulse24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25V13h-2.26l-.99-1.65a1.75 1.75 0 0 0-3.07.12l-.5 1.02-1.25-4.23a1.75 1.75 0 0 0-3.25-.3L6.17 13H4V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m3 13H20v3.25c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V16.5h3.25c.66 0 1.27-.37 1.57-.97l1-2.02 1.25 4.23a1.75 1.75 0 0 0 3.25.3l1.08-2.18c.33.4.82.64 1.35.64m-5.78-7.96a.75.75 0 0 0-1.4-.13L6.8 14H2.75a.75.75 0 0 0 0 1.5h4.5c.28 0 .54-.16.67-.41l2.15-4.3 1.96 6.67a.75.75 0 0 0 1.4.13l1.88-3.78.8 1.33c.13.22.38.36.64.36h4.5a.75.75 0 0 0 0-1.5h-4.08l-1.28-2.14a.75.75 0 0 0-1.31.05l-1.65 3.3z"
]);
const $76e5a570f6bfc30c$export$112cd55703f9e80b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPulse24Regular', "24", [
    "M13.75 2c1.16 0 2.11.88 2.24 2h1.76C18.99 4 20 5 20 6.25V13h-1.5V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75V13H4V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.1.01.15zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m4.75 13H20v3.25c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V16.5h1.5v3.25c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75zm-7.53-7.96a.75.75 0 0 0-1.4-.13L6.8 14H2.75a.75.75 0 0 0 0 1.5h4.5c.28 0 .54-.16.67-.41l2.15-4.3 1.96 6.67a.75.75 0 0 0 1.4.13l1.88-3.78.8 1.33c.13.22.38.36.64.36h4.5a.75.75 0 0 0 0-1.5h-4.08l-1.28-2.14a.75.75 0 0 0-1.31.05l-1.65 3.3z"
]);
const $76e5a570f6bfc30c$export$e684876ed3405a8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSearch20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76a4.5 4.5 0 0 1 5.56 6.18l2 2c.42.42.54 1.03.35 1.56h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM8.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $76e5a570f6bfc30c$export$1704877df4993bdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSearch20Regular', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76q.48-.18 1-.23V4.5c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-2.59q.18.5 0 1h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM8.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $76e5a570f6bfc30c$export$8b32875b2049dfb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSearch24Filled', "24", [
    "M13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v3.85q1.14-.59 2.5-.6a5.5 5.5 0 0 1 4.75 8.27l2.24 2.24c.53.54.65 1.34.34 1.99h3.92c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m-.3 14.39a4.5 4.5 0 1 0-1.15.98l2.92 2.91a.75.75 0 1 0 1.06-1.06zM6.5 18a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $76e5a570f6bfc30c$export$86635cf320e244 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSearch24Regular', "24", [
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v3.85q.7-.36 1.5-.5V6.24c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75h-3.92c.23.47.23 1.03 0 1.5h3.92c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74-.6h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m-.3 14.39a4.5 4.5 0 1 0-1.15.98l2.92 2.91a.75.75 0 1 0 1.06-1.06zM6.5 18a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $76e5a570f6bfc30c$export$69b94e2592a04644 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSettings20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.57 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$16952e96b675a5b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSettings20Regular', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.57 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$3f2a5eaa02afb1a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSettings24Filled', "24", [
    "M10.25 2h3.5c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25A6.5 6.5 0 0 0 12.81 22H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2m3.5 1.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m.53 10.48a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.6-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $76e5a570f6bfc30c$export$418855aa18d1364a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSettings24Regular', "24", [
    "M13.75 2c1.16 0 2.11.87 2.24 2h1.76C18.99 4 20 5 20 6.25v5.25q-.71-.3-1.5-.42V6.25a.75.75 0 0 0-.75-.75h-2.13c-.4.6-1.09 1-1.87 1h-3.5c-.78 0-1.47-.4-1.87-1H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76c.13-1.13 1.08-2 2.24-2zm2.24 2.03V4zm0 .07.01.15v-.17zm-2.24-.6h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m.53 10.48a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.6-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $76e5a570f6bfc30c$export$8a08f1f40db90854 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_16_color__a)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_16_color__b)",
            "fillOpacity": ".7",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_16_color__c)",
            "fillOpacity": ".4",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_16_color__d)",
            "d": "M5 2.5C5 3.33 5.67 4 6.5 4h3a1.5 1.5 0 0 0 0-3h-3C5.67 1 5 1.67 5 2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_16_color__e)",
            "fillOpacity": ".9",
            "d": "M10.85 7.85a.5.5 0 0 0-.7-.7L7.5 9.79 6.35 8.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_16_color__a",
                "x1": "3",
                "x2": "13.44",
                "y1": "3.3",
                "y2": "14.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_16_color__d",
                "x1": "8",
                "x2": "8",
                "y1": "1",
                "y2": "4",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_16_color__e",
                "x1": "12.83",
                "x2": "6.28",
                "y1": "13.67",
                "y2": "4.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4.16204 -4.27976 0 8 1.28)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.02381 -4.04762 0 8 2.69)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$995ec08ebb0a440f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 5.35-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7.5 9.79l2.65-2.64a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$6873e65cd54cd863 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask16Regular', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 3h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5m6.35 4.85a.5.5 0 0 0-.7-.7L7.5 9.79 6.35 8.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $76e5a570f6bfc30c$export$2d752ba9fedea9d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__a)",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__b)",
            "fillOpacity": ".7",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__c)",
            "fillOpacity": ".4",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__d)",
            "d": "M7 3.5C7 4.33 7.67 5 8.5 5h3a1.5 1.5 0 0 0 0-3h-3C7.67 2 7 2.67 7 3.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__e)",
            "fillOpacity": ".9",
            "d": "M12.85 9.85a.5.5 0 0 0-.7-.7L9 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__a",
                "x1": "4",
                "x2": "16",
                "y1": "4.51",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__d",
                "x1": "10",
                "x2": "10",
                "y1": "2",
                "y2": "5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__e",
                "x1": "15",
                "x2": "7.55",
                "y1": "16.5",
                "y2": "5.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.14077 -4.64062 0 10 2.17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.30574 -3.67969 0 10 3.74)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$b2611c7d3b3cc96a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 6.35-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L9 12.29l3.15-3.14a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$acd8addb8a98bbc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask20Regular', "20", [
    "M12.85 9.85a.5.5 0 0 0-.7-.7L9 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$eb2ea97c47933b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_24_color__a)",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_24_color__b)",
            "fillOpacity": ".7",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_24_color__c)",
            "fillOpacity": ".4",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_24_color__d)",
            "d": "M8 4.25C8 5.49 9 6.5 10.25 6.5h3.5a2.25 2.25 0 0 0 0-4.5h-3.5C9.01 2 8 3 8 4.25"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_24_color__e)",
            "fillOpacity": ".9",
            "d": "M17.03 11.03a.75.75 0 1 0-1.06-1.06L11 14.94l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_24_color__a",
                "x1": "4",
                "x2": "18.15",
                "y1": "5.8",
                "y2": "23.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_24_color__d",
                "x1": "12",
                "x2": "12",
                "y1": "2",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_24_color__e",
                "x1": "18",
                "x2": "10.27",
                "y1": "18.5",
                "y2": "7.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6.16892 -6.75 0 12 3)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.79325 -4.95298 0 12 4.62)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$4f89887fc77a9819 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask24Filled', "24", [
    "M13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m6.78 7.53-5.5 5.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L11 14.94l4.97-4.97a.75.75 0 1 1 1.06 1.06"
]);
const $76e5a570f6bfc30c$export$97115061bbf1e23a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTask24Regular', "24", [
    "M17.03 11.03a.75.75 0 1 0-1.06-1.06L11 14.94l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0zm-1.04-6.95A2.25 2.25 0 0 0 13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76zm0 .02.01.15zm-5.74 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$54fbff4541640532 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskAdd20Filled', "20", [
    "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76A5.5 5.5 0 0 1 14 9.02V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 6.35-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L7 12.29l3.15-3.14a.5.5 0 0 1 .7.7M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$e214f0c1b6c0f1af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskAdd20Regular', "20", [
    "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76a6 6 0 0 1-.66-1H3.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.7q.49-.13 1-.18V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 6.35a.5.5 0 0 0-.7-.7L7 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$a396d21ae569f2ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskAdd24Filled', "24", [
    "M11.75 2h-3.5c-1.16 0-2.11.87-2.24 2H4.25C3.01 4 2 5 2 6.25v13.5C2 20.99 3 22 4.25 22h8.56a6.5 6.5 0 0 1-.85-7.9l-2.43 2.43c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L9 14.94l4.97-4.97a.75.75 0 1 1 1.06 1.06l-.93.93a6.5 6.5 0 0 1 3.9-.94V6.25C18 5.01 17 4 15.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$7649d6ddc5db7b6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskAdd24Regular', "24", [
    "M13.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H4.25C3.01 4 2 5 2 6.25v13.5C2 20.99 3 22 4.25 22h8.56a7 7 0 0 1-1.08-1.5H4.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v4.83a7 7 0 0 1 1.5-.06V6.25C18 5.01 17 4 15.75 4zm0 .1.01.15zm-5.74-.6h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m3.7 10.6a6.5 6.5 0 0 1 2.15-2.14l.93-.93a.75.75 0 1 0-1.06-1.06L9 14.94l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$badf3c95af820a83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskList16Filled', "16", [
    "M11.5 2h-.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5m-5 0h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m.85 8.35-1.5 1.5a.5.5 0 0 1-.7 0l-.5-.5a.5.5 0 0 1 .7-.7l.15.14 1.14-1.14a.5.5 0 0 1 .71.7m0-4-1.5 1.5a.5.5 0 0 1-.7 0l-.5-.5a.5.5 0 0 1 .7-.7l.15.14 1.14-1.14a.5.5 0 0 1 .71.7M10.5 11H9a.5.5 0 0 1 0-1h1.5a.5.5 0 0 1 0 1m0-4H9a.5.5 0 0 1 0-1h1.5a.5.5 0 0 1 0 1"
]);
const $76e5a570f6bfc30c$export$c6c8d4264d7445d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskList16Regular', "16", [
    "M8.5 6.5c0-.28.22-.5.5-.5h1.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h1.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M5.5 8a.5.5 0 0 1-.35-.15l-.5-.5a.5.5 0 0 1 .7-.7l.15.14 1.15-1.14a.5.5 0 0 1 .7.7l-1.5 1.5A.5.5 0 0 1 5.5 8m-.35 3.85a.5.5 0 0 0 .7 0l1.5-1.5a.5.5 0 0 0-.7-.7L5.5 10.79l-.15-.14a.5.5 0 0 0-.7.7zM5.08 2c.21-.58.77-1 1.42-1h3c.65 0 1.2.42 1.41 1h.59c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-10C3 2.67 3.67 2 4.5 2zM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.09 3H4.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1m.4 9"
]);
const $76e5a570f6bfc30c$export$512ef9d4d4be10ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListLtr20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m1.35 4.35L7.6 9.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 1 1 .68-.73l.4.36 1.4-1.41a.5.5 0 1 1 .71.7m0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0m1.65.6h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1 0-1m-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$9af30979444bc9ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListLtr20Regular', "20", [
    "M9.35 7.85a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02zm0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0m1.65.6a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$51d7623dbf85a60f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListLtr24Filled', "24", [
    "M13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m2.25 6.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m.75 4.75h3.5a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 1 1 0-1.5m-2.47-5.22-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47 1.47-1.47a.75.75 0 1 1 1.06 1.06m0 4.44c.3.3.3.77 0 1.06l-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47 1.47-1.47c.3-.3.77-.3 1.06 0"
]);
const $76e5a570f6bfc30c$export$4707fb9770f198ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListLtr24Regular', "24", [
    "M12.5 10.25c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m.75 4.75a.75.75 0 1 0 0 1.5h3.5a.75.75 0 1 0 0-1.5zm-2.47-5.22a.75.75 0 1 0-1.06-1.06l-1.47 1.47-.47-.47a.75.75 0 0 0-1.06 1.06l1 1c.3.3.77.3 1.06 0zm0 4.44c.3.3.3.77 0 1.06l-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47 1.47-1.47c.3-.3.77-.3 1.06 0m5.21-10.14A2.25 2.25 0 0 0 13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76zm0 .02.01.15zm-5.74 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$19338475aa4ec180 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListRtl20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.35 4.15a.5.5 0 0 0-.7 0l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 0 0 0-.7m0 5.7a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02zM6.5 8a.5.5 0 0 0 0 1H9a.5.5 0 0 0 0-1zM6 13.5c0 .28.22.5.5.5H9a.5.5 0 0 0 0-1H6.5a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$95cfdee9d52deb39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListRtl20Regular', "20", [
    "M13.85 7.15c.2.2.2.5 0 .7L12.1 9.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0m0 5.7a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02zM6.5 8a.5.5 0 0 0 0 1H9a.5.5 0 0 0 0-1zM6 13.5c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H6.5a.5.5 0 0 1-.5-.5M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$9026376702e89fc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListRtl24Filled', "24", [
    "M13.75 2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76a2.25 2.25 0 0 0-2.24-2m-3.5 1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m7.03 5.22c.3.3.3.77 0 1.06l-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47 1.47-1.47c.3-.3.77-.3 1.06 0m0 6.56-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47 1.47-1.47a.75.75 0 1 1 1.06 1.06M7 10.25c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75M7.75 15h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$a332ab4d174e1c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListRtl24Regular', "24", [
    "M17.28 8.72c.3.3.3.77 0 1.06l-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47 1.47-1.47c.3-.3.77-.3 1.06 0m0 6.56a.75.75 0 1 0-1.06-1.06l-1.47 1.47-.47-.47a.75.75 0 1 0-1.06 1.06l1 1c.3.3.77.3 1.06 0zM7 10.25c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75M7.75 15a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm8.24-11a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4zm-5.74 2.5h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$c2ee988c62526e56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardText32Filled', "32", [
    "M21.83 4h1.67A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2h6a3 3 0 0 1 2.83 2M19 4h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m-8 8a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm-1 6a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-5a1 1 0 0 0-1 1m1 4a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
], {
    flipInRtl: true
});
const $76e5a570f6bfc30c$export$c24df255371bd1bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardText32Regular', "32", [
    "M11 12a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm-1 6a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM21.83 4A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h15a3.5 3.5 0 0 0 3.5-3.5v-19A3.5 3.5 0 0 0 23.5 4zM12 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M7 7.5C7 6.67 7.67 6 8.5 6h1.67A3 3 0 0 0 13 8h6a3 3 0 0 0 2.83-2h1.67c.83 0 1.5.67 1.5 1.5v19c0 .83-.67 1.5-1.5 1.5h-15A1.5 1.5 0 0 1 7 26.5z"
], {
    flipInRtl: true
});
const $76e5a570f6bfc30c$export$3d026e142162246a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__a)",
            "d": "M5.5 3C4.67 3 4 3.69 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.57L16 13.44V4.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__b)",
            "fillOpacity": ".9",
            "d": "M6 8.5c0-.27.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__c)",
            "fillOpacity": ".9",
            "d": "M6 14.5c0-.27.22-.5.5-.5h7a.5.5 0 1 1 0 1h-7a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__d)",
            "fillOpacity": ".9",
            "d": "M6.5 11a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__e)",
            "fillOpacity": ".5",
            "d": "M5.5 3C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.57L16 13.42V4.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__f)",
            "fillOpacity": ".4",
            "d": "M5.5 3C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.57L16 13.42V4.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__g)",
            "d": "M7 3.5C7 4.33 7.67 5 8.5 5h3a1.5 1.5 0 0 0 0-3h-3C7.67 2 7 2.67 7 3.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__h)",
            "d": "M14.35 12H17v2.65l-3.37 3.37a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__i)",
            "d": "M13.49 18.14a2 2 0 0 1-.89.46l-1.5.37a.9.9 0 0 1-1.07-1.08l.37-1.5q.12-.47.44-.86a3.5 3.5 0 0 0 2.65 2.61"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__j)",
            "d": "m14.54 11.82 1.27-1.27a1.87 1.87 0 1 1 2.64 2.64l-1.17 1.18z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__k)",
            "d": "M18 13.65A3.5 3.5 0 0 1 15.34 11l-1 1A3.5 3.5 0 0 0 17 14.65z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__a",
                "x1": "4",
                "x2": "16",
                "y1": "4.51",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__b",
                "x1": "11",
                "x2": "6",
                "y1": "15.01",
                "y2": "8.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__c",
                "x1": "11",
                "x2": "6",
                "y1": "15.01",
                "y2": "8.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__d",
                "x1": "11",
                "x2": "6",
                "y1": "15.01",
                "y2": "8.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__g",
                "x1": "10",
                "x2": "10",
                "y1": "5",
                "y2": "2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fab500"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe06b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__h",
                "x1": "11.85",
                "x2": "15.29",
                "y1": "13.72",
                "y2": "17.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__i",
                "x1": "9.5",
                "x2": "12",
                "y1": "16.5",
                "y2": "18.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__j",
                "x1": "18.07",
                "x2": "16.46",
                "y1": "10.91",
                "y2": "12.46",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__k",
                "x1": "16.24",
                "x2": "13.66",
                "y1": "13.5",
                "y2": "12.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.5 0 0 4.88692 9.5 2.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(133.96 4.12 9.92)scale(8.10361 3.02694)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$e5a0473fa045ee32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.73q-.5.2-.9.61L10.94 14H6.5a.5.5 0 0 0 0 1h3.49a3 3 0 0 0-.56 1.16l-.37 1.5q-.04.17-.06.34H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5M13.5 8h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1M10 11.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m.98 3.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $76e5a570f6bfc30c$export$832908be1da14988 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit20Regular', "20", [
    "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 14.5c0-.28.22-.5.5-.5h4.44l-.67.67q-.15.15-.28.33H6.5a.5.5 0 0 1-.5-.5M9.22 17H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v5.44l.1-.1q.4-.4.9-.6V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H9l.06-.35zM12 3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3c.28 0 .5.22.5.5m-1.02 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $76e5a570f6bfc30c$export$f6d4bd34925ecb27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__a)",
            "d": "M6 4a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h9.55L20 15.88V6a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__b)",
            "fillOpacity": ".9",
            "d": "M8 9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__c)",
            "fillOpacity": ".9",
            "d": "M8 13a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__d)",
            "fillOpacity": ".9",
            "d": "M7 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__e)",
            "fillOpacity": ".4",
            "d": "M5.5 4C4.67 4 4 4.67 4 5.5v15c0 .83.67 1.5 1.5 1.5h7.93L20 16.5v-11c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__f)",
            "fillOpacity": ".4",
            "d": "M5.5 4C4.67 4 4 4.67 4 5.5v15c0 .83.67 1.5 1.5 1.5h7.93L20 16.5v-11c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__g)",
            "fillOpacity": ".4",
            "d": "M5.5 4C4.67 4 4 4.67 4 5.5v15c0 .83.67 1.5 1.5 1.5h7.93L20 16.5v-11c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__h)",
            "d": "M8 4c0 1.1.9 2 2 2h4a2 2 0 1 0 0-4h-4a2 2 0 0 0-2 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__i)",
            "d": "M20.59 14.46h-3.25L13.2 18.6l-.18.2V22h3.25l.18-.15 4.14-4.15z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__j)",
            "d": "M16.28 22a3 3 0 0 1-1.09.55l-1.83.46a1.1 1.1 0 0 1-1.33-1.32l.46-1.84q.15-.59.54-1.06a4.3 4.3 0 0 0 3.25 3.2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__k)",
            "d": "m17.57 14.23 1.56-1.56a2.3 2.3 0 1 1 3.25 3.25l-1.44 1.44z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_24_color__l)",
            "d": "M21.82 16.48a4.3 4.3 0 0 1-3.26-3.25l-1.22 1.23a4.3 4.3 0 0 0 3.26 3.24z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__a",
                "x1": "4",
                "x2": "18.15",
                "y1": "5.8",
                "y2": "23.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__b",
                "x1": "13.25",
                "x2": "5.85",
                "y1": "19",
                "y2": "9.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__c",
                "x1": "13.25",
                "x2": "5.85",
                "y1": "19",
                "y2": "9.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__d",
                "x1": "13.25",
                "x2": "5.85",
                "y1": "19",
                "y2": "9.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__h",
                "x1": "12",
                "x2": "12",
                "y1": "6",
                "y2": "2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fab500"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe06b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__i",
                "x1": "15.03",
                "x2": "18.73",
                "y1": "16.31",
                "y2": "20.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__j",
                "x1": "11.39",
                "x2": "14.46",
                "y1": "19.98",
                "y2": "23.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__k",
                "x1": "21.9",
                "x2": "19.93",
                "y1": "13.12",
                "y2": "15.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__l",
                "x1": "19.66",
                "x2": "16.49",
                "y1": "16.29",
                "y2": "14.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-6.5 0 0 -7.75283 12 .5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-6.5 0 0 -8.40275 12 .5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_24_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(136.97 5.4 11.95)scale(10.2591 4.59818)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$1d238bd336098095 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit24Filled', "24", [
    "M15.98 3.94A2.25 2.25 0 0 0 13.75 2h-3.5c-1.14 0-2.08.85-2.23 1.94l-.01.14V4H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22H11q0-.3.06-.6l.46-1.82q.15-.59.46-1.08H8A.75.75 0 0 1 8 17h5.36l5.03-5.04a3.3 3.3 0 0 1 1.61-.88V6.25C20 5.01 19 4 17.75 4h-1.76v.08zm-5.73-.44h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M8 13h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 8 13m0-4h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 8 9m11.1 3.67-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $76e5a570f6bfc30c$export$8c7b09ff64219acf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit24Regular', "24", [
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22H11q0-.3.06-.6l.23-.9H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v5.61q.68-.6 1.5-.78V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74-.6h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m3.1 13.5H8a.75.75 0 0 0 0 1.5h3.98q.23-.34.51-.64zM12 14.5H8A.75.75 0 0 1 8 13h4a.75.75 0 0 1 0 1.5m4-4H8A.75.75 0 0 1 8 9h8a.75.75 0 0 1 0 1.5m3.1 2.17-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $76e5a570f6bfc30c$export$3b7eb5056a2ef1cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__a)",
            "d": "M20.25 4A2.75 2.75 0 0 1 23 6.75V19l-7 7H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__b)",
            "fillOpacity": ".4",
            "d": "M20.25 4A2.75 2.75 0 0 1 23 6.75V19l-7 7H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__c)",
            "fillOpacity": ".4",
            "d": "M20.25 4A2.75 2.75 0 0 1 23 6.75V19l-7 7H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__d)",
            "fillOpacity": ".4",
            "d": "M20.25 4A2.75 2.75 0 0 1 23 6.75V19l-7 7H7.75A2.75 2.75 0 0 1 5 23.25V6.75A2.75 2.75 0 0 1 7.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__e)",
            "d": "M23.1 14.67a2.29 2.29 0 0 1 3.23 3.23l-.98.98a5 5 0 0 1-1.9-1.2 5 5 0 0 1-1.27-2.1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__f)",
            "fillOpacity": ".9",
            "d": "M16.25 20a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1 0-1.5zm-2-5a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1 0-1.5zm4.5-5a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1 0-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__g)",
            "d": "M22.06 15.7q.49 1.07 1.41 2 .83.84 1.77 1.3l-6.8 6.8q-.17.16-.35.29l-3.18-3.18.29-.34z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__h)",
            "d": "M22.18 15.59c.21.73.64 1.46 1.27 2.09.57.57 1.24.98 1.9 1.2l-1.44 1.45a5 5 0 0 1-2.08-1.26 5 5 0 0 1-1.21-1.92z"
        }
    ],
    [
        "rect",
        {
            "width": "9",
            "height": "4",
            "x": "9.5",
            "y": "2",
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__i)",
            "rx": "2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_28_color__j)",
            "d": "M15.66 22.11a5 5 0 0 0 3.09 3.38l-.32.31q-.53.54-1.25.71l-1.83.46c-.8.2-1.52-.52-1.32-1.32l.46-1.83q.18-.71.7-1.25zM19 18.8h-.02l.02-.02z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__a",
                "x1": "5",
                "x2": "24.31",
                "y1": "4.4",
                "y2": "24.76",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__e",
                "x1": "25.99",
                "x2": "24.19",
                "y1": "15.02",
                "y2": "16.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__f",
                "x1": "15.47",
                "x2": "6.86",
                "y1": "21.5",
                "y2": "11.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__g",
                "x1": "18.14",
                "x2": "24.11",
                "y1": "16.91",
                "y2": "22.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__h",
                "x1": "20.14",
                "x2": "16.52",
                "y1": "21.91",
                "y2": "20.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__i",
                "x1": "14",
                "x2": "14",
                "y1": "2",
                "y2": "6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__j",
                "x1": "13.23",
                "x2": "16.99",
                "y1": "23.24",
                "y2": "27.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7.3125 0 0 6.65892 14 2.78)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7.3125 0 0 7.51167 14 2.78)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_28_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-8.4375 8.55556 -3.5296 -4.10853 20.19 19.89)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$5940c2b08e96bbc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__a)",
            "d": "M8.5 4A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h8.97a3 3 0 0 1 .63-.9l8.5-8.5q.2-.2.4-.34V7.5A3.5 3.5 0 0 0 23.5 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__b)",
            "fillOpacity": ".9",
            "d": "M10 13a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__c)",
            "fillOpacity": ".9",
            "d": "M10 18a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__d)",
            "fillOpacity": ".9",
            "d": "M11 22a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__e)",
            "fillOpacity": ".4",
            "d": "M8.5 4A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h8.97a3 3 0 0 1 .63-.9l8.5-8.5q.2-.2.4-.34V7.5A3.5 3.5 0 0 0 23.5 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__f)",
            "fillOpacity": ".4",
            "d": "M8.5 4A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h8.97a3 3 0 0 1 .63-.9l8.5-8.5q.2-.2.4-.34V7.5A3.5 3.5 0 0 0 23.5 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__g)",
            "fillOpacity": ".4",
            "d": "M8.5 4A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h8.97a3 3 0 0 1 .63-.9l8.5-8.5q.2-.2.4-.34V7.5A3.5 3.5 0 0 0 23.5 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__h)",
            "d": "M10 5a3 3 0 0 1 3-3h6a3 3 0 1 1 0 6h-6a3 3 0 0 1-3-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__i)",
            "d": "m20.54 29.47 7.6-7.54-4.06-4.08-7.57 7.64.3 3.7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__j)",
            "d": "m26.94 23.14 2.2-2.21a2.88 2.88 0 1 0-4.06-4.08l-2.24 2.24z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__k)",
            "d": "M24.1 17.84a5.4 5.4 0 0 0 4.1 4.04l-1.55 1.55a5.4 5.4 0 0 1-4.1-4.04z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_32_color__l)",
            "d": "m20.54 29.47.22-.22s-1.72-.66-2.53-1.47-1.47-2.54-1.47-2.54l-.25.25q-.5.52-.69 1.2l-.79 3.06a1 1 0 0 0 1.22 1.22l3.02-.78q.73-.19 1.27-.72"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__a",
                "x1": "5",
                "x2": "25.63",
                "y1": "6.6",
                "y2": "31.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__b",
                "x1": "17.5",
                "x2": "8.62",
                "y1": "24",
                "y2": "13.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__c",
                "x1": "17.5",
                "x2": "8.62",
                "y1": "24",
                "y2": "13.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__d",
                "x1": "17.5",
                "x2": "8.62",
                "y1": "24",
                "y2": "13.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__h",
                "x1": "16",
                "x2": "16",
                "y1": "2",
                "y2": "8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__i",
                "x1": "19.86",
                "x2": "26.04",
                "y1": "19.95",
                "y2": "26.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__j",
                "x1": "28.5",
                "x2": "25.87",
                "y1": "17.49",
                "y2": "19.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__k",
                "x1": "25.47",
                "x2": "21.49",
                "y1": "21.66",
                "y2": "19.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__l",
                "x1": "14.17",
                "x2": "18.32",
                "y1": "26.85",
                "y2": "30.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8.9375 0 0 7.86963 16 2.56)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8.9375 0 0 8.87743 16 2.56)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_32_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(135.56 7.13 16.2)scale(14.4424 6.48727)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$35cb52f7a67b4b73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit32Filled', "32", [
    "M23.5 4h-1.67A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h5q0-.3.08-.63l.8-3.05q.28-1.08 1.07-1.89l.43-.43H11a1 1 0 1 1 0-2h6.86L24 15.8A4.4 4.4 0 0 1 27 14.5v-7A3.5 3.5 0 0 0 23.5 4M13 4h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2m-3 9a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m1 6a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2zm18.14 1.92-8.6 8.55q-.55.53-1.27.72l-3.02.78a1 1 0 0 1-1.22-1.22l.79-3.05q.18-.7.69-1.21l8.56-8.64a2.88 2.88 0 1 1 4.07 4.07"
]);
const $76e5a570f6bfc30c$export$8dc06fef9452be8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit32Regular', "32", [
    "M10 13a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm-1 6a1 1 0 0 1 1-1h6.86l-1.98 2H11a1 1 0 0 1-1-1m3.94 5H8.5A1.5 1.5 0 0 1 7 26.5v-19C7 6.67 7.67 6 8.5 6h1.67A3 3 0 0 0 13 8h6a3 3 0 0 0 2.83-2h1.67c.83 0 1.5.67 1.5 1.5v7.54q.94-.51 2-.54v-7A3.5 3.5 0 0 0 23.5 4h-1.67A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h5q0-.3.08-.63zM13 4h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2m16.14 16.92-8.6 8.55q-.55.53-1.27.72l-3.02.78a1 1 0 0 1-1.22-1.22l.79-3.05q.18-.7.69-1.21l8.56-8.64a2.88 2.88 0 1 1 4.07 4.07"
]);
const $76e5a570f6bfc30c$export$5b0bd13ccca40ac3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit48Filled', "48", [
    "M31.81 7h3.94C38.1 7 40 8.9 40 11.25V22c-1.54 0-3.08.6-4.24 1.79L26.69 33H16.25a1.25 1.25 0 1 0 0 2.5h7.97l-1.97 2a5 5 0 0 0-1.28 2.26L20.13 43q-.13.5-.13 1h-7.75A4.25 4.25 0 0 1 8 39.75v-28.5C8 8.9 9.9 7 12.25 7h3.94c.53-1.74 2.15-3 4.06-3h7.5a4.25 4.25 0 0 1 4.06 3M18.5 8.25c0 .97.78 1.75 1.75 1.75h7.5a1.75 1.75 0 1 0 0-3.5h-7.5c-.97 0-1.75.78-1.75 1.75m-3.5 12c0 .69.56 1.25 1.25 1.25h15.5a1.25 1.25 0 1 0 0-2.5h-15.5c-.69 0-1.25.56-1.25 1.25M16.25 26a1.25 1.25 0 1 0 0 2.5h7.5a1.25 1.25 0 1 0 0-2.5zm26.58-.83a4 4 0 0 0-5.65.02l-13.5 13.72a3 3 0 0 0-.78 1.35l-.83 3.24a2 2 0 0 0 2.43 2.44l3.24-.84a3 3 0 0 0 1.35-.77L42.8 30.82a4 4 0 0 0 .02-5.65"
]);
const $76e5a570f6bfc30c$export$8ecb0646744950c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEdit48Regular', "48", [
    "M16.19 9.5h-3.94c-.97 0-1.75.78-1.75 1.75v28.5c0 .97.78 1.75 1.75 1.75h8.27l-.39 1.5q-.13.5-.13 1h-7.75A4.25 4.25 0 0 1 8 39.75v-28.5C8 8.9 9.9 7 12.25 7h3.94c.53-1.74 2.15-3 4.06-3h7.5a4.25 4.25 0 0 1 4.06 3h3.94C38.1 7 40 8.9 40 11.25V22q-1.29 0-2.5.56V11.25c0-.97-.78-1.75-1.75-1.75h-3.94a4.25 4.25 0 0 1-4.06 3h-7.5a4.25 4.25 0 0 1-4.06-3M26.69 33H16.25a1.25 1.25 0 1 0 0 2.5h7.97zM18.5 8.25c0 .97.78 1.75 1.75 1.75h7.5a1.75 1.75 0 1 0 0-3.5h-7.5c-.97 0-1.75.78-1.75 1.75m-3.5 12c0-.69.56-1.25 1.25-1.25h15.5a1.25 1.25 0 1 1 0 2.5h-15.5c-.69 0-1.25-.56-1.25-1.25M16.25 26a1.25 1.25 0 1 0 0 2.5h7.5a1.25 1.25 0 1 0 0-2.5zm26.58-.83a4 4 0 0 0-5.65.02l-13.5 13.72a3 3 0 0 0-.78 1.35l-.83 3.24a2 2 0 0 0 2.43 2.44l3.24-.84a3 3 0 0 0 1.35-.77L42.8 30.82a4 4 0 0 0 .02-5.65"
]);
const $76e5a570f6bfc30c$export$fe6d0b340cd7dc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 6h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M5 9c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 5 9m.5 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$2db7a45dcde0c957 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr16Regular', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 3h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5m1 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 5 9m.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$4f2947bd1041e05a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr20Filled', "20", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-5 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M6 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$4b1450d32926e865 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr20Regular', "20", [
    "M6.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 11.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2-12c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-6 1h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$74aca97e2f1cb5d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr24Filled', "24", [
    "M13.75 3.5h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m0-1.5c1.14 0 2.08.85 2.23 1.94l.01.14V4h1.76C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76v.08l.01-.14A2.25 2.25 0 0 1 10.25 2zM14 17H8a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5m-2-4H8a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5m4-4H8a.75.75 0 0 0 0 1.5h8A.75.75 0 0 0 16 9"
]);
const $76e5a570f6bfc30c$export$6e43637d2f0862a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr24Regular', "24", [
    "M13.75 2c1.2 0 2.17.93 2.24 2.1l.01.15-.01-.25h1.76C18.99 4 20 5 20 6.25v13.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V6.25C4 5.01 5 4 6.25 4h1.76v.18L8 4.25C8 3.01 9 2 10.25 2zm0 4.5h-3.5c-.8 0-1.5-.41-1.9-1.03l.03.03H6.25a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0-.75-.75h-2.13l.02-.03c-.4.62-1.1 1.03-1.89 1.03m0-3h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5M8 14.5h4a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5m0-4h8A.75.75 0 0 0 16 9H8a.75.75 0 0 0 0 1.5m0 8h6a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5"
]);
const $76e5a570f6bfc30c$export$349a846868243199 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr32Filled', "32", [
    "M21.83 4h1.67A3.5 3.5 0 0 1 27 7.5v19a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-19A3.5 3.5 0 0 1 8.5 4h1.67A3 3 0 0 1 13 2h6a3 3 0 0 1 2.83 2M19 4h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m-8 8a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm-1 6a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-5a1 1 0 0 0-1 1m1 4a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$efa9a37a10359b11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtr32Regular', "32", [
    "M11 12a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm-1 6a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM21.83 4A3 3 0 0 0 19 2h-6a3 3 0 0 0-2.83 2H8.5A3.5 3.5 0 0 0 5 7.5v19A3.5 3.5 0 0 0 8.5 30h15a3.5 3.5 0 0 0 3.5-3.5v-19A3.5 3.5 0 0 0 23.5 4zM12 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M7 7.5C7 6.67 7.67 6 8.5 6h1.67A3 3 0 0 0 13 8h6a3 3 0 0 0 2.83-2h1.67c.83 0 1.5.67 1.5 1.5v19c0 .83-.67 1.5-1.5 1.5h-15A1.5 1.5 0 0 1 7 26.5z"
]);
const $76e5a570f6bfc30c$export$95d06ab7414927bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtl16Filled', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 6h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M8 9c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 8 9m-1.5 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$df83f2c7b0ae9969 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtl16Regular', "16", [
    "M6.5 1c-.65 0-1.2.42-1.41 1H4.5C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-.59c-.2-.58-.76-1-1.41-1zM6 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 3h.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h.59c.28 0 .5.22.5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-10c0-.28.22-.5.5-.5m1 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM8 9c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 8 9m-1.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$92068cd7fdb5130a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtl20Filled', "20", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5M10.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 8.5c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M8.5 14a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$2926a79a51237e28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtl20Regular', "20", [
    "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5",
    "M10.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    "M8.5 14a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z",
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5M7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $76e5a570f6bfc30c$export$ca223da4afb12e1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtl24Filled', "24", [
    "M15.98 3.94A2.25 2.25 0 0 0 13.75 2h-3.5c-1.14 0-2.08.85-2.23 1.94l-.01.14V4H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4h-1.76v.08zm-5.73-.44h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M8 9h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 8 9m3.25 4.75c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M10 17h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$3890132957df6356 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtl24Regular', "24", [
    "M8 9a.75.75 0 0 0 0 1.5h8A.75.75 0 0 0 16 9z",
    "M11.25 13.75c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75",
    "M10 17a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z",
    "M15.99 4a2.25 2.25 0 0 0-2.24-2h-3.5c-1.16 0-2.11.87-2.24 2H6.25C5.01 4 4 5 4 6.25v13.5C4 20.99 5 22 6.25 22h11.5c1.24 0 2.25-1 2.25-2.25V6.25C20 5.01 19 4 17.75 4zm0 .1.01.15zm-5.74 2.4h3.5c.78 0 1.47-.4 1.87-1h2.13c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75H6.25a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h2.13c.4.6 1.09 1 1.87 1m0-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$661a51dae43e0788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete12Filled', "12", [
    "M5 3h2a1 1 0 0 0-2 0M4 3a2 2 0 1 1 4 0h2.5a.5.5 0 0 1 0 1h-.44l-.44 5.17a2 2 0 0 1-2 1.83H4.38a2 2 0 0 1-2-1.83L1.94 4H1.5a.5.5 0 0 1 0-1zm3.5 3a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zM5 5.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V6a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$2e2be8c612068f16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete12Regular', "12", [
    "M5 3h2a1 1 0 0 0-2 0M4 3a2 2 0 1 1 4 0h2.5a.5.5 0 0 1 0 1h-.44l-.44 5.17a2 2 0 0 1-2 1.83H4.38a2 2 0 0 1-2-1.83L1.94 4H1.5a.5.5 0 0 1 0-1zm3.5 3a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zM5 5.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5M3.38 9.09a1 1 0 0 0 1 .91h3.24a1 1 0 0 0 1-.91L9.06 4H2.94z"
]);
const $76e5a570f6bfc30c$export$9fa7a710c1ab0fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete16Filled', "16", [
    "M7 3h2a1 1 0 0 0-2 0M6 3a2 2 0 1 1 4 0h4a.5.5 0 0 1 0 1h-.56l-1.2 8.84A2.5 2.5 0 0 1 9.74 15h-3.5a2.5 2.5 0 0 1-2.48-2.16L2.57 4H2a.5.5 0 0 1 0-1zm1 3.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$826298139e16a17a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete16Regular', "16", [
    "M7 3h2a1 1 0 0 0-2 0M6 3a2 2 0 1 1 4 0h4a.5.5 0 0 1 0 1h-.56l-1.2 8.84A2.5 2.5 0 0 1 9.74 15h-3.5a2.5 2.5 0 0 1-2.48-2.16L2.57 4H2a.5.5 0 0 1 0-1zm1 3.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zM9.5 6c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5m-4.74 6.7c.1.75.74 1.3 1.49 1.3h3.5a1.5 1.5 0 0 0 1.5-1.3L12.42 4H3.57z"
]);
const $76e5a570f6bfc30c$export$c0d3eb9597e71e9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete20Filled', "20", [
    "M8.5 4h3a1.5 1.5 0 0 0-3 0m-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM9 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zm2.5-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$6ccc14a28b9b6b42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete20Regular', "20", [
    "M8.5 4h3a1.5 1.5 0 0 0-3 0m-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM5.74 15.23A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77L15.44 5H4.56zM8.5 7.5c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5M12 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$24dc5c7f0258d657 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete24Filled', "24", [
    "M10 5h4a2 2 0 1 0-4 0M8.5 5a3.5 3.5 0 1 1 7 0h5.75a.75.75 0 0 1 0 1.5h-1.32l-1.17 12.11A3.75 3.75 0 0 1 15.03 22H8.97a3.75 3.75 0 0 1-3.73-3.39L4.07 6.5H2.75a.75.75 0 0 1 0-1.5zm2 4.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0zM14.25 9a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$aa0265e87e625719 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete24Regular', "24", [
    "M10 5h4a2 2 0 1 0-4 0M8.5 5a3.5 3.5 0 1 1 7 0h5.75a.75.75 0 0 1 0 1.5h-1.32l-1.17 12.11A3.75 3.75 0 0 1 15.03 22H8.97a3.75 3.75 0 0 1-3.73-3.39L4.07 6.5H2.75a.75.75 0 0 1 0-1.5zm2 4.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0zM14.25 9c.41 0 .75.34.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5c0-.41.34-.75.75-.75m-7.52 9.47a2.25 2.25 0 0 0 2.24 2.03h6.06c1.15 0 2.12-.88 2.24-2.03L18.42 6.5H5.58z"
]);
const $76e5a570f6bfc30c$export$838ff6c63343ab7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete28Filled', "28", [
    "M11.5 6h5a2.5 2.5 0 0 0-5 0M10 6a4 4 0 0 1 8 0h6.25a.75.75 0 0 1 0 1.5h-1.31l-1.22 14.6A4.25 4.25 0 0 1 17.5 26H10.5a4.25 4.25 0 0 1-4.23-3.9L5.06 7.5H3.75a.75.75 0 0 1 0-1.5zm2.5 5.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0zm3.75-.75a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$8a55084f12cf67f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete28Regular', "28", [
    "M11.5 6h5a2.5 2.5 0 0 0-5 0M10 6a4 4 0 0 1 8 0h6.25a.75.75 0 0 1 0 1.5h-1.31l-1.22 14.6A4.25 4.25 0 0 1 17.5 26H10.5a4.25 4.25 0 0 1-4.23-3.9L5.06 7.5H3.75a.75.75 0 0 1 0-1.5zM7.77 21.98a2.75 2.75 0 0 0 2.74 2.52h6.98c1.43 0 2.62-1.1 2.74-2.52l1.2-14.48H6.57zM11.75 11c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m5.25.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$759916dbfab27322 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete32Filled', "32", [
    "M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.5l-1.9 16.57A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.43L5.5 9H4a1 1 0 0 1 0-2zm2.5 6.5a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0zm5-1a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-10a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$1fcfd544755a875b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete32Light', "32", [
    "M14 12.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0zm4.5-.5c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5m2-5.5V7h8a.5.5 0 0 1 0 1h-2.54l-1.63 17.9a4.5 4.5 0 0 1-4.48 4.1h-7.7a4.5 4.5 0 0 1-4.48-4.1L6.04 8H3.5a.5.5 0 0 1 0-1h8v-.5a4.5 4.5 0 1 1 9 0m-8 0V7h7v-.5a3.5 3.5 0 1 0-7 0M7.05 8l1.62 17.82A3.5 3.5 0 0 0 12.15 29h7.7a3.5 3.5 0 0 0 3.48-3.18L24.95 8z"
]);
const $76e5a570f6bfc30c$export$7677591160055a7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete32Regular', "32", [
    "M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.5l-1.9 16.57A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.43L5.5 9H4a1 1 0 0 1 0-2zM9.39 25.34A3 3 0 0 0 12.37 28h7.26a3 3 0 0 0 2.98-2.66L24.48 9H7.52zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z"
]);
const $76e5a570f6bfc30c$export$7914bc8578692b08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete48Filled', "48", [
    "M20 10.5v.5h8v-.5a4 4 0 0 0-8 0m-2.5.5v-.5a6.5 6.5 0 1 1 13 0v.5h11.25a1.25 1.25 0 1 1 0 2.5h-2.92l-2 23.86A7.25 7.25 0 0 1 29.61 44H18.39a7.25 7.25 0 0 1-7.22-6.64l-2-23.86H6.25a1.25 1.25 0 1 1 0-2.5zm4 9.25a1.25 1.25 0 1 0-2.5 0v14.5a1.25 1.25 0 1 0 2.5 0zM27.75 19c-.69 0-1.25.56-1.25 1.25v14.5a1.25 1.25 0 1 0 2.5 0v-14.5c0-.69-.56-1.25-1.25-1.25"
]);
const $76e5a570f6bfc30c$export$44681300bdd9c4d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Delete48Regular', "48", [
    "M20 10.5v.5h8v-.5a4 4 0 0 0-8 0m-2.5.5v-.5a6.5 6.5 0 1 1 13 0v.5h11.25a1.25 1.25 0 1 1 0 2.5h-2.92l-2 23.86A7.25 7.25 0 0 1 29.61 44H18.39a7.25 7.25 0 0 1-7.22-6.64l-2-23.86H6.25a1.25 1.25 0 1 1 0-2.5zm-3.84 26.15a4.75 4.75 0 0 0 4.73 4.35h11.22c2.47 0 4.53-1.9 4.73-4.35l1.98-23.65H11.68zm7.84-16.9a1.25 1.25 0 1 0-2.5 0v14.5a1.25 1.25 0 1 0 2.5 0zM27.75 19c.69 0 1.25.56 1.25 1.25v14.5a1.25 1.25 0 1 1-2.5 0v-14.5c0-.69.56-1.25 1.25-1.25"
]);
const $76e5a570f6bfc30c$export$fd7a366022340785 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteArrowBack16Filled', "16", [
    "M9 3a1 1 0 0 0-2 0zM6 3a2 2 0 1 1 4 0h4a.5.5 0 0 1 0 1h-.56l-.24 1.7q-1.22-.68-2.7-.7a5.5 5.5 0 0 0-3.16 10h-1.1a2.5 2.5 0 0 1-2.47-2.16L2.57 4H2a.5.5 0 0 1 0-1zm4.5 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 13 12.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75H8.71l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7L8.9 7.9a.5.5 0 1 1 .7.7"
]);
const $76e5a570f6bfc30c$export$aafa4ead0dd77249 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteArrowBack16Regular', "16", [
    "M9 3a1 1 0 0 0-2 0zM6 3a2 2 0 1 1 4 0h4a.5.5 0 0 1 0 1h-.56l-.24 1.7q-.45-.24-.95-.42L12.43 4H3.57l1.19 8.7c.1.75.74 1.3 1.49 1.3q.48.58 1.09 1h-1.1a2.5 2.5 0 0 1-2.47-2.16L2.57 4H2a.5.5 0 0 1 0-1zm4.5 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 13 12.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75H8.71l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7L8.9 7.9a.5.5 0 1 1 .7.7"
]);
const $76e5a570f6bfc30c$export$5d86998d0a235132 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteArrowBack20Filled', "20", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.5 5.5 0 0 0-5.7 8.8H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm7 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$cbfd3bf3890c98a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteArrowBack20Regular', "20", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a6 6 0 0 0-.98-.18L15.44 5H4.56l1.18 10.23A2 2 0 0 0 7.73 17H9.6q.27.54.66 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm7 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$3caed5557af9c1b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismiss20Filled', "20", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.5 5.5 0 0 0-5.7 8.8H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $76e5a570f6bfc30c$export$c8fd44483c6c8a2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismiss20Regular', "20", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a6 6 0 0 0-.98-.18L15.44 5H4.56l1.18 10.23A2 2 0 0 0 7.73 17H9.6q.27.54.66 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $76e5a570f6bfc30c$export$38383583c1b25203 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismiss24Filled', "24", [
    "M14 5a2 2 0 1 0-4 0zM8.5 5a3.5 3.5 0 1 1 7 0h5.75a.75.75 0 0 1 0 1.5h-1.32l-.5 5.2A6.5 6.5 0 0 0 11.8 22H8.97a3.75 3.75 0 0 1-3.73-3.39L4.07 6.5H2.75a.75.75 0 0 1 0-1.5zM22 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $76e5a570f6bfc30c$export$b8d646124376aef6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismiss24Regular', "24", [
    "M14 5a2 2 0 1 0-4 0zM8.5 5a3.5 3.5 0 1 1 7 0h5.75a.75.75 0 0 1 0 1.5h-1.32l-.5 5.2q-.7-.36-1.46-.53l.45-4.67H5.58l1.15 11.97a2.25 2.25 0 0 0 2.24 2.03h1.76q.44.83 1.08 1.5H8.97a3.75 3.75 0 0 1-3.73-3.39L4.07 6.5H2.75a.75.75 0 0 1 0-1.5zM22 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $76e5a570f6bfc30c$export$4c875fdf9964d9ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismiss28Filled', "28", [
    "M16.5 6a2.5 2.5 0 0 0-5 0zM10 6a4 4 0 0 1 8 0h6.25a.75.75 0 0 1 0 1.5h-1.31l-.5 6.1q-1.36-.6-2.94-.6a7.5 7.5 0 0 0-5.1 13h-3.89a4.25 4.25 0 0 1-4.23-3.9L5.06 7.5H3.75a.75.75 0 0 1 0-1.5zm16 14.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6.5-.7-2.65-2.65a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7z"
]);
const $76e5a570f6bfc30c$export$1c9addcda3e1a62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismiss28Regular', "28", [
    "M16.5 6a2.5 2.5 0 0 0-5 0zM10 6a4 4 0 0 1 8 0h6.25a.75.75 0 0 1 0 1.5h-1.31l-.5 6.1q-.71-.3-1.48-.46l.47-5.64H6.57l1.2 14.48a2.75 2.75 0 0 0 2.74 2.52h2.64q.53.83 1.25 1.5h-3.89a4.25 4.25 0 0 1-4.23-3.9L5.06 7.5H3.75a.75.75 0 0 1 0-1.5zm16 14.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6.5-.7-2.65-2.65a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7z"
]);
const $76e5a570f6bfc30c$export$6fd0aea58eaf9167 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteLines20Filled', "20", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.81 7H11.5a1.5 1.5 0 0 0-1.12 2.5 1.5 1.5 0 0 0 0 2 1.5 1.5 0 0 0-.3 1.5H7.74a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$2e69df3793770e03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteLines20Regular', "20", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.81 7h-1l.8-7H4.56l1.18 10.23A2 2 0 0 0 7.73 17h2.36a1.5 1.5 0 0 0 0 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$8e7da5f54481ceeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteOff20Filled', "20", [
    "M3.3 4 2.14 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2-2A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm8.7 8.7-1-1V14a.5.5 0 0 0 1 0zm-3-3-1-1V14a.5.5 0 0 0 1 0zM12 8v1.88l3.48 3.48.97-8.36h1.05a.5.5 0 0 0 0-1h-5a2.5 2.5 0 0 0-5 0H6.12L11 8.88V8a.5.5 0 0 1 1 0m-.5-4h-3a1.5 1.5 0 1 1 3 0"
]);
const $76e5a570f6bfc30c$export$5808cab7a7fa537d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteOff20Regular', "20", [
    "M3.3 4 2.14 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2-2A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm10.99 11L12 12.7V14a.5.5 0 0 1-1 0v-2.3l-2-2V14a.5.5 0 0 1-1 0V8.7L4.6 5.3l1.14 9.93A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77zM11 8.87l1 1V8a.5.5 0 0 0-1 0zM15.44 5l-.86 7.46.9.9.97-8.36h1.05a.5.5 0 0 0 0-1h-5a2.5 2.5 0 0 0-5 0H6.12l1 1zM11.5 4h-3a1.5 1.5 0 1 1 3 0"
]);
const $76e5a570f6bfc30c$export$540b51f2d0e38022 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteOff24Filled', "24", [
    "M3.94 5 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-2.2-2.19a3.75 3.75 0 0 1-3.5 2.41H8.98a3.75 3.75 0 0 1-3.73-3.39L4.07 6.5H2.75a.75.75 0 0 1 0-1.5zM15 16.06l-1.5-1.5v2.69a.75.75 0 0 0 1.5 0zm-4.5-4.5L9 10.06v7.19a.75.75 0 0 0 1.5 0zM15 9.75v2.07l4.03 4.03.9-9.35h1.32a.75.75 0 0 0 0-1.5H15.5a3.5 3.5 0 1 0-7 0h-.32l5.32 5.32v-.57a.75.75 0 0 1 1.5 0M14 5h-4a2 2 0 1 1 4 0"
]);
const $76e5a570f6bfc30c$export$d0cc39b6500726ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteOff24Regular', "24", [
    "M3.94 5 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-2.2-2.19a3.75 3.75 0 0 1-3.5 2.41H8.98a3.75 3.75 0 0 1-3.73-3.39L4.07 6.5H2.75a.75.75 0 0 1 0-1.5zm13.34 13.34L15 16.06v1.19a.75.75 0 0 1-1.5 0v-2.69l-3-3v5.69a.75.75 0 0 1-1.5 0v-7.19l-3.4-3.4 1.13 11.8a2.25 2.25 0 0 0 2.24 2.04h6.06c1.15 0 2.12-.88 2.24-2.03zm-3.78-8.02 1.5 1.5V9.75a.75.75 0 0 0-1.5 0zm4.92-3.82-.77 7.97 1.38 1.38.9-9.35h1.32a.75.75 0 0 0 0-1.5H15.5a3.5 3.5 0 1 0-7 0h-.32l1.5 1.5zM14 5h-4a2 2 0 1 1 4 0"
]);
const $76e5a570f6bfc30c$export$e15dd4c5980e7214 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoard16Filled', "16", [
    "M14.5 8.5a.5.5 0 1 0 0-1H13V6h1.5a.5.5 0 1 0 0-1H13a2 2 0 0 0-2-2V1.5a.5.5 0 1 0-1 0V3H8.5V1.5a.5.5 0 1 0-1 0V3H6V1.5a.5.5 0 1 0-1 0V3a2 2 0 0 0-2 2H1.5a.5.5 0 1 0 0 1H3v1.5H1.5a.5.5 0 1 0 0 1H3V10H1.5a.5.5 0 1 0 0 1H3a2 2 0 0 0 2 2v1.5q0 .2.15.35A.5.5 0 0 0 6 14.5V13h1.5v1.5q0 .2.15.35a.5.5 0 0 0 .85-.35V13H10v1.5q0 .2.15.35a.5.5 0 0 0 .85-.35V13a2 2 0 0 0 2-2h1.5a.5.5 0 1 0 0-1H13V8.5zm-6.5 2a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$114a85008a35c12a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoard16Regular', "16", [
    "M14.5 8.5a.5.5 0 1 0 0-1H13V6h1.5a.5.5 0 1 0 0-1H13a2 2 0 0 0-2-2V1.5a.5.5 0 1 0-1 0V3H8.5V1.5a.5.5 0 1 0-1 0V3H6V1.5a.5.5 0 1 0-1 0V3a2 2 0 0 0-2 2H1.5a.5.5 0 1 0 0 1H3v1.5H1.5a.5.5 0 1 0 0 1H3V10H1.5a.5.5 0 1 0 0 1H3a2 2 0 0 0 2 2v1.5q0 .2.15.35A.5.5 0 0 0 6 14.5V13h1.5v1.5q0 .2.15.35a.5.5 0 0 0 .85-.35V13H10v1.5q0 .2.15.35a.5.5 0 0 0 .85-.35V13a2 2 0 0 0 2-2h1.5a.5.5 0 1 0 0-1H13V8.5zM12 11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-4-.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$96e2848653be73c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoard20Filled', "20", [
    "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zm5 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
]);
const $76e5a570f6bfc30c$export$3f4c7cbb4e5969e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoard20Regular', "20", [
    "M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-2 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5-8c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 0 1 1 0V4H12V2.5a.5.5 0 0 1 1 0V4h.5A2.5 2.5 0 0 1 16 6.5V7h1.5a.5.5 0 0 1 0 1H16v1.5h1.5a.5.5 0 0 1 0 1H16V12h1.5a.5.5 0 0 1 0 1H16v.5a2.5 2.5 0 0 1-2.5 2.5H13v1.5a.5.5 0 0 1-1 0V16h-1.5v1.5a.5.5 0 0 1-1 0V16H8v1.5a.5.5 0 0 1-1 0V16h-.5A2.5 2.5 0 0 1 4 13.5V13H2.5a.5.5 0 0 1 0-1H4v-1.5H2.5a.5.5 0 0 1 0-1H4V8H2.5a.5.5 0 0 1 0-1H4v-.5A2.5 2.5 0 0 1 6.5 4H7V2.5c0-.28.22-.5.5-.5M15 6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$ec415ea212d3391 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoard24Filled', "24", [
    "M15.25 2c.38 0 .7.28.74.65l.01.1v2.33A3.8 3.8 0 0 1 18.93 8h2.32a.75.75 0 0 1 .1 1.5H19v1.75h2.25c.38 0 .7.29.74.65l.01.1c0 .38-.28.7-.65.75H19v1.75h2.25c.38 0 .7.29.74.65l.01.1c0 .38-.28.7-.65.75h-2.43A3.8 3.8 0 0 1 16 18.92v2.33a.75.75 0 0 1-1.5.1V19h-1.75v2.25c0 .38-.28.7-.65.74L12 22a.75.75 0 0 1-.74-.65l-.01-.1V19H9.5v2.25c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1v-2.32A3.8 3.8 0 0 1 5.08 16H2.75a.75.75 0 0 1-.1-1.5H5v-1.75H2.75a.75.75 0 0 1-.74-.65L2 12c0-.38.28-.7.65-.74l.1-.01H5V9.5H2.75a.75.75 0 0 1-.74-.65L2 8.75c0-.38.28-.7.65-.74l.1-.01h2.33A3.8 3.8 0 0 1 8 5.07V2.75a.75.75 0 0 1 1.5-.1V5h1.75V2.75c0-.38.28-.7.65-.74L12 2c.38 0 .7.28.74.65l.01.1V5h1.75V2.75c0-.35.23-.64.55-.72l.1-.02zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $76e5a570f6bfc30c$export$59f121ee65e85f0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoard24Regular', "24", [
    "M15.25 2c.38 0 .7.28.74.65l.01.1v2.33A3.8 3.8 0 0 1 18.93 8h2.32a.75.75 0 0 1 .1 1.5H19v1.75h2.25c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01H19v1.75h2.25c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-2.33A3.8 3.8 0 0 1 16 18.92v2.33a.75.75 0 0 1-1.5.1V19h-1.75v2.25c0 .38-.28.7-.65.74L12 22a.75.75 0 0 1-.74-.65l-.01-.1V19H9.5v2.25c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1v-2.32A3.8 3.8 0 0 1 5.08 16H2.75a.75.75 0 0 1-.1-1.5H5v-1.75H2.75a.75.75 0 0 1-.74-.65L2 12c0-.38.28-.7.65-.74l.1-.01H5V9.5H2.75a.75.75 0 0 1-.74-.65L2 8.75c0-.38.28-.7.65-.74l.1-.01h2.33A3.8 3.8 0 0 1 8 5.07V2.75a.75.75 0 0 1 1.5-.1V5h1.75V2.75c0-.38.28-.7.65-.74L12 2c.38 0 .7.28.74.65l.01.1V5h1.75V2.75c0-.35.23-.64.55-.72l.1-.02zm0 4.5h-6.5c-1.24 0-2.25 1-2.25 2.25v6.5c0 1.24 1 2.25 2.25 2.25h6.5c1.24 0 2.25-1 2.25-2.25v-6.5c0-1.24-1-2.25-2.25-2.25M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$4a91cc2c96c51fc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightning20Filled', "20", [
    "M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zm2.99 5.04L10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39"
]);
const $76e5a570f6bfc30c$export$3bee090edaed822f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightning20Regular', "20", [
    "M10.99 7.54 10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zM13.5 5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 13.5v-7C5 5.67 5.67 5 6.5 5z"
]);
const $76e5a570f6bfc30c$export$1696f9f6e08d5e34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightningToolbox20Filled', "20", [
    "M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1v-2.5q0-.34.09-.67a.4.4 0 0 1-.07-.37L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39L10.57 9h1.53q.26.02.36.23Q12.94 9 13.5 9h2q.26 0 .5.05V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zm4 9.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $76e5a570f6bfc30c$export$b87c514d688304f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightningToolbox20Regular', "20", [
    "M7.5 2c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 0 1 1 0V4H12V2.5a.5.5 0 0 1 1 0V4h.5A2.5 2.5 0 0 1 16 6.5V7h1.5a.5.5 0 0 1 0 1H16v1.05a3 3 0 0 0-.5-.05H15V6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H9v1H8v1.5a.5.5 0 0 1-1 0V16h-.5A2.5 2.5 0 0 1 4 13.5V13H2.5a.5.5 0 0 1 0-1H4v-1.5H2.5a.5.5 0 0 1 0-1H4V8H2.5a.5.5 0 0 1 0-1H4v-.5A2.5 2.5 0 0 1 6.5 4H7V2.5c0-.28.22-.5.5-.5m3.54 9.04a2.5 2.5 0 0 1 1.42-1.81.4.4 0 0 0-.36-.23h-1.53l.42-1.46c.12-.44-.44-.73-.73-.39l-2.67 3.2a.4.4 0 0 0 .3.65h1.57l-.44 1.46a.4.4 0 0 0 .07.37 2.5 2.5 0 0 1 1.95-1.79M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $76e5a570f6bfc30c$export$1b0f29e1371b352d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardSearch20Filled', "20", [
    "M13 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8.5 1c.28 0 .5.22.5.5V3h1.5V1.5a.5.5 0 0 1 1 0V3H13V1.5a.5.5 0 0 1 1 0V3h.5A2.5 2.5 0 0 1 17 5.5V6h1.5a.5.5 0 0 1 0 1H17v1.5h1.5a.5.5 0 0 1 0 1H17V11h1.5a.5.5 0 0 1 0 1H17v.5a2.5 2.5 0 0 1-2.5 2.5H14v1.5a.5.5 0 0 1-1 0V15h-1.5v1.5a.5.5 0 0 1-1 0V15H8.74a4.5 4.5 0 0 0-5.68-5.76.5.5 0 0 1 .44-.74H5V7H3.5a.5.5 0 0 1 0-1H5v-.5A2.5 2.5 0 0 1 7.5 3H8V1.5c0-.28.22-.5.5-.5M11 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-6.5 5q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 0 0 .7-.7L7.3 15.6q.68-.9.7-2.1A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $76e5a570f6bfc30c$export$48b326c266e0c8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardSearch20Regular', "20", [
    "M8 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M9 1.5a.5.5 0 0 0-1 0V3h-.5A2.5 2.5 0 0 0 5 5.5V6H3.5a.5.5 0 0 0 0 1H5v1.5H3.5a.5.5 0 0 0-.44.74A4.5 4.5 0 0 1 6 9.26V5.5C6 4.67 6.67 4 7.5 4h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H8.97q-.05.52-.23 1h1.76v1.5a.5.5 0 0 0 1 0V15H13v1.5a.5.5 0 0 0 1 0V15h.5a2.5 2.5 0 0 0 2.5-2.5V12h1.5a.5.5 0 0 0 0-1H17V9.5h1.5a.5.5 0 0 0 0-1H17V7h1.5a.5.5 0 0 0 0-1H17v-.5A2.5 2.5 0 0 0 14.5 3H14V1.5a.5.5 0 0 0-1 0V3h-1.5V1.5a.5.5 0 0 0-1 0V3H9zM4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 0 0 .7-.7L7.3 15.6q.68-.9.7-2.1A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $76e5a570f6bfc30c$export$d0169ccac98ccf19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardSearch24Filled', "24", [
    "M17 1.65a.75.75 0 0 0-.75-.65h-.1l-.1.03a.75.75 0 0 0-.55.72V4h-1.75V1.65A.75.75 0 0 0 13 1h-.1a.75.75 0 0 0-.65.75V4H10.5V1.65a.75.75 0 0 0-1.5.1v2.32A3.8 3.8 0 0 0 6.08 7H3.65a.75.75 0 0 0-.65.75v.1c.06.37.37.65.75.65H6v1.75H3.65A.75.75 0 0 0 3 11v.1q.05.25.2.4 1.06-.49 2.3-.5a5.5 5.5 0 0 1 5.3 7h1.45v2.35c.06.37.37.65.75.65h.1a.75.75 0 0 0 .65-.75V18h1.75v2.35a.75.75 0 0 0 1.5-.1v-2.33A3.8 3.8 0 0 0 19.92 15h2.43a.75.75 0 0 0 .65-.75v-.1a.75.75 0 0 0-.75-.65H20v-1.75h2.35A.75.75 0 0 0 23 11v-.1a.75.75 0 0 0-.75-.65H20V8.5h2.35a.75.75 0 0 0-.1-1.5h-2.32A3.8 3.8 0 0 0 17 4.08V1.65M10 11a3 3 0 1 1 6 0 3 3 0 0 1-6 0m4.5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-9 10c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $76e5a570f6bfc30c$export$5be31a7ca6ab4645 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardSearch24Regular', "24", [
    "M17 1.65a.75.75 0 0 0-.75-.65h-.1l-.1.03a.75.75 0 0 0-.55.72V4h-1.75V1.65A.75.75 0 0 0 13 1h-.1a.75.75 0 0 0-.65.75V4H10.5V1.65a.75.75 0 0 0-1.5.1v2.32A3.8 3.8 0 0 0 6.08 7H3.65a.75.75 0 0 0-.65.75v.1c.06.37.37.65.75.65H6v1.75H3.65A.75.75 0 0 0 3 11v.1q.05.25.2.4a5.5 5.5 0 0 1 4.3-.13V7.75c0-1.24 1-2.25 2.25-2.25h6.5c1.24 0 2.25 1 2.25 2.25v6.5c0 1.24-1 2.25-2.25 2.25H11a6 6 0 0 1-.2 1.5h1.45v2.35c.06.37.37.65.75.65h.1a.75.75 0 0 0 .65-.75V18h1.75v2.35a.75.75 0 0 0 1.5-.1v-2.33A3.8 3.8 0 0 0 19.92 15h2.43a.75.75 0 0 0 .65-.75v-.1a.75.75 0 0 0-.75-.65H20v-1.75h2.35A.75.75 0 0 0 23 11v-.1a.75.75 0 0 0-.75-.65H20V8.5h2.35a.75.75 0 0 0-.1-1.5h-2.32A3.8 3.8 0 0 0 17 4.08V1.65M16 11a3 3 0 1 0-6 0 3 3 0 0 0 6 0m-4.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6 10c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $76e5a570f6bfc30c$export$a618019c69a6e901 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq16Filled', "16", [
    "M8 2c.41 0 .75.34.75.75v10.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m2.75 2c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75M6 4.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zM13.75 6c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M3 6.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$7f8404a36e07c886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq16Regular', "16", [
    "M8 2c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5m2.5 2c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5M6 4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zM13.5 6c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5M3 6.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$6036d7a0bad1854a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq20Filled', "20", [
    "M10 2c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m3.75 3c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75M7 5.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0zM17.25 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M3.5 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$3c4e8cbfdfe65108 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq20Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5m3.5 3c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5M7 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0zM16.5 8c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5M4 8.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$8aab4af528fa9be3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq24Filled', "24", [
    "M12 3a1 1 0 0 1 1 .88V20a1 1 0 0 1-2 .12V4a1 1 0 0 1 1-1M8 6a1 1 0 0 1 1 .88V17a1 1 0 0 1-2 .12V7a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 .88V17a1 1 0 0 1-2 .12V7a1 1 0 0 1 1-1M4 9a1 1 0 0 1 1 .88V14a1 1 0 0 1-2 .12V10a1 1 0 0 1 1-1m16 0a1 1 0 0 1 1 .88V14a1 1 0 0 1-2 .12V10a1 1 0 0 1 1-1"
]);
const $76e5a570f6bfc30c$export$855ae0e393ec880a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq24Regular', "24", [
    "M12 3c.38 0 .7.28.74.65l.01.1v16.5a.75.75 0 0 1-1.5.1V3.75c0-.41.34-.75.75-.75M8.25 6c.38 0 .7.28.75.65v10.6a.75.75 0 0 1-1.49.1V6.75c0-.41.33-.75.74-.75m7.5 0c.37 0 .69.28.74.65v10.6a.75.75 0 0 1-1.49.1V6.75c0-.41.33-.75.74-.75m-11 3c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 0 1-1.5.1v-4.6c0-.41.34-.75.75-.75m14.5 0c.38 0 .7.28.75.65v4.6a.75.75 0 0 1-1.5.1v-4.6c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$7a5511eba0e01dee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq28Filled', "28", [
    "M14 2a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M9 6a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m10 0a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1M4 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m20 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1"
]);
const $76e5a570f6bfc30c$export$ff9ec1a567ea8335 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq28Regular', "28", [
    "M14 2c.41 0 .75.34.75.75v22.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75M8.75 6c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V6.75c0-.41.34-.75.75-.75m10.5 0c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V6.75c0-.41.34-.75.75-.75m-15.5 4c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m20.5 0c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$1993efca5aab749c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq32Filled', "32", [
    "M16 2c.69 0 1.25.56 1.25 1.25v25.5a1.25 1.25 0 1 1-2.5 0V3.25c0-.69.56-1.25 1.25-1.25m-5.75 5c.69 0 1.25.56 1.25 1.25v15.5a1.25 1.25 0 1 1-2.5 0V8.25C9 7.56 9.56 7 10.25 7m11.5 0c.69 0 1.25.56 1.25 1.25v15.5a1.25 1.25 0 1 1-2.5 0V8.25c0-.69.56-1.25 1.25-1.25m-17.5 5c.69 0 1.25.56 1.25 1.25v5.5a1.25 1.25 0 1 1-2.5 0v-5.5c0-.69.56-1.25 1.25-1.25m23.5 0c.69 0 1.25.56 1.25 1.25v5.5a1.25 1.25 0 1 1-2.5 0v-5.5c0-.69.56-1.25 1.25-1.25"
]);
const $76e5a570f6bfc30c$export$e7dd74c698f45866 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq32Regular', "32", [
    "M16 2a1 1 0 0 1 1 1v26a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m-6 5a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m12 0a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M4 12a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m24 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1"
]);
const $76e5a570f6bfc30c$export$4e454df5b9be632d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq48Filled', "48", [
    "M24 4c.83 0 1.5.67 1.5 1.5v37a1.5 1.5 0 0 1-3 0v-37c0-.83.67-1.5 1.5-1.5m-8.5 7c.83 0 1.5.67 1.5 1.5v23a1.5 1.5 0 0 1-3 0v-23c0-.83.67-1.5 1.5-1.5m17 0c.83 0 1.5.67 1.5 1.5v23a1.5 1.5 0 0 1-3 0v-23c0-.83.67-1.5 1.5-1.5m-25 7c.83 0 1.5.67 1.5 1.5v9a1.5 1.5 0 0 1-3 0v-9c0-.83.67-1.5 1.5-1.5m33 0c.83 0 1.5.67 1.5 1.5v9a1.5 1.5 0 0 1-3 0v-9c0-.83.67-1.5 1.5-1.5"
]);
const $76e5a570f6bfc30c$export$e68d135b98ac1ac9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEq48Regular', "48", [
    "M24 4c.69 0 1.25.56 1.25 1.25v37.5a1.25 1.25 0 1 1-2.5 0V5.25c0-.69.56-1.25 1.25-1.25m-8.75 7c.69 0 1.25.56 1.25 1.25v23.5a1.25 1.25 0 1 1-2.5 0v-23.5c0-.69.56-1.25 1.25-1.25m17.5 0c.69 0 1.25.56 1.25 1.25v23.5a1.25 1.25 0 1 1-2.5 0v-23.5c0-.69.56-1.25 1.25-1.25m-25.5 7c.69 0 1.25.56 1.25 1.25v9.5a1.25 1.25 0 1 1-2.5 0v-9.5c0-.69.56-1.25 1.25-1.25m33.5 0c.69 0 1.25.56 1.25 1.25v9.5a1.25 1.25 0 1 1-2.5 0v-9.5c0-.69.56-1.25 1.25-1.25"
]);
const $76e5a570f6bfc30c$export$7a3b5a6c7ff77e54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom16Filled', "16", [
    "M2.74 3.46A2 2 0 0 1 4.67 2h6.66a2 2 0 0 1 1.93 1.46l1.66 5.9a2.08 2.08 0 0 1-2 2.64H3.08a2.08 2.08 0 0 1-2-2.64zM4.5 13a.5.5 0 1 0 0 1h7a.5.5 0 1 0 0-1z"
]);
const $76e5a570f6bfc30c$export$94d73075b7ba0063 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom16Regular', "16", [
    "M4.67 2a2 2 0 0 0-1.93 1.46l-1.66 5.9a2.08 2.08 0 0 0 2 2.64h9.84a2.08 2.08 0 0 0 2-2.64l-1.66-5.9A2 2 0 0 0 11.33 2zM3.7 3.73A1 1 0 0 1 4.67 3h6.66a1 1 0 0 1 .97.73l1.66 5.9c.2.69-.33 1.37-1.04 1.37H3.08c-.71 0-1.23-.68-1.04-1.37zM4.5 13a.5.5 0 1 0 0 1h7a.5.5 0 1 0 0-1z"
]);
const $76e5a570f6bfc30c$export$f52f0c499c4dab3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom20Filled', "20", [
    "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H4.5a2.5 2.5 0 0 1-2.43-3.05zM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 1 0 0-1z"
]);
const $76e5a570f6bfc30c$export$235cf9740c7d3b44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom20Regular', "20", [
    "M6.1 3a2.5 2.5 0 0 0-2.44 1.95l-1.6 7A2.5 2.5 0 0 0 4.5 15h11a2.5 2.5 0 0 0 2.43-3.05l-1.59-7A2.5 2.5 0 0 0 13.9 3zM4.63 5.17A1.5 1.5 0 0 1 6.1 4h7.8c.7 0 1.31.48 1.47 1.17l1.59 7A1.5 1.5 0 0 1 15.49 14H4.5a1.5 1.5 0 0 1-1.46-1.83zM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 1 0 0-1z"
]);
const $76e5a570f6bfc30c$export$114c8af6f80ad066 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom24Filled', "24", [
    "M4.1 5.35A3.06 3.06 0 0 1 7.06 3h9.86c1.41 0 2.65.97 2.98 2.35l1.99 8.27A3.55 3.55 0 0 1 18.45 18H5.55a3.55 3.55 0 0 1-3.45-4.38zM6.74 19a.75.75 0 1 0 0 1.5h10.5a.75.75 0 1 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$465e9a35b8c2542d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom24Regular', "24", [
    "M7.07 3c-1.42 0-2.65.97-2.98 2.35L2.1 13.62A3.55 3.55 0 0 0 5.55 18h12.9c2.29 0 3.98-2.15 3.44-4.38L19.9 5.35A3.06 3.06 0 0 0 16.93 3zM5.55 5.7c.17-.7.8-1.2 1.52-1.2h9.86c.72 0 1.35.5 1.51 1.2l2 8.27a2.05 2.05 0 0 1-2 2.53H5.55a2.05 2.05 0 0 1-2-2.53zM6.75 19a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$ebbfac2132bbf72c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom28Filled', "28", [
    "M4.97 5.58A3.5 3.5 0 0 1 8.35 3h11.3a3.5 3.5 0 0 1 3.38 2.58l2.83 10.37A4 4 0 0 1 22 21H6a4 4 0 0 1-3.86-5.05zM7.75 22.5a.75.75 0 1 0 0 1.5h12.5a.75.75 0 1 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$e35e61dc67615f26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom28Regular', "28", [
    "M8.35 3a3.5 3.5 0 0 0-3.38 2.58L2.14 15.95A4 4 0 0 0 6 21h16a4 4 0 0 0 3.86-5.05L23.03 5.58A3.5 3.5 0 0 0 19.65 3zM6.42 5.97A2 2 0 0 1 8.35 4.5h11.3a2 2 0 0 1 1.93 1.47l2.83 10.37A2.5 2.5 0 0 1 22 19.5H6a2.5 2.5 0 0 1-2.4-3.16zM7.75 22.5a.75.75 0 1 0 0 1.5h12.5a.75.75 0 1 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$360de6016b9e6627 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom32Filled', "32", [
    "M5.37 7.11A4.25 4.25 0 0 1 9.47 4h13.06c1.91 0 3.58 1.27 4.1 3.11l3.22 11.6A4.18 4.18 0 0 1 25.82 24H6.18a4.18 4.18 0 0 1-4.03-5.3zM8 26a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$1d0265976fb9031e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom32Regular', "32", [
    "M9.47 4a4.25 4.25 0 0 0-4.1 3.11l-3.22 11.6A4.18 4.18 0 0 0 6.18 24h19.64a4.18 4.18 0 0 0 4.03-5.3L26.63 7.11A4.25 4.25 0 0 0 22.53 4zM7.3 7.65A2.25 2.25 0 0 1 9.47 6h13.06c1.01 0 1.9.67 2.17 1.65l3.22 11.59a2.18 2.18 0 0 1-2.1 2.76H6.18a2.18 2.18 0 0 1-2.1-2.76zM8 26a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$c0db027f9f138b15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom48Filled', "48", [
    "M8.97 10.4c.7-2.6 3.05-4.4 5.74-4.4h18.58c2.7 0 5.04 1.8 5.74 4.4l4.76 17.77A6.22 6.22 0 0 1 37.78 36H10.22a6.22 6.22 0 0 1-6-7.83zM13.25 38a1.25 1.25 0 1 0 0 2.5h21.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $76e5a570f6bfc30c$export$21693153781f54d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoom48Regular', "48", [
    "M14.7 6a5.94 5.94 0 0 0-5.73 4.4L4.21 28.17A6.22 6.22 0 0 0 10.22 36h27.56a6.22 6.22 0 0 0 6-7.83L39.04 10.4A5.94 5.94 0 0 0 33.29 6zm-3.31 5.05A3.44 3.44 0 0 1 14.7 8.5h18.58a3.44 3.44 0 0 1 3.32 2.55l4.76 17.77a3.72 3.72 0 0 1-3.6 4.68H10.23a3.72 3.72 0 0 1-3.59-4.68zM13.25 38a1.25 1.25 0 1 0 0 2.5h21.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $76e5a570f6bfc30c$export$4ff2719d8bfdf820 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne12Filled', "12", [
    "M10 8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM8 2a2 2 0 0 1 2 2v3H2V4c0-1.1.9-2 2-2zM6 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
]);
const $76e5a570f6bfc30c$export$a6ec3c55f500553f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne12Regular', "12", [
    "M6 4a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m2-2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM3 8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1zm1-5a1 1 0 0 0-1 1v3h6V4a1 1 0 0 0-1-1z"
]);
const $76e5a570f6bfc30c$export$555588390f7b9706 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne16Filled', "16", [
    "M14 11.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V11h12zM11.5 2A2.5 2.5 0 0 1 14 4.5V10H2V4.5A2.5 2.5 0 0 1 4.5 2zM8 4.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$4a10e25e629650a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne16Regular', "16", [
    "M8 4.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M11.5 2A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zM3 11.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V11H3zM4.5 3C3.67 3 3 3.67 3 4.5V10h10V4.5c0-.83-.67-1.5-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$2814096ed40beaa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne20Filled', "20", [
    "M17 14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-1h14zM14 3a3 3 0 0 1 3 3v6H3V6a3 3 0 0 1 3-3zm-4 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $76e5a570f6bfc30c$export$510b26290958a79a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne20Regular', "20", [
    "M10 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4-3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM4 14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1H4zM6 4a2 2 0 0 0-2 2v6h12V6a2 2 0 0 0-2-2z"
]);
const $76e5a570f6bfc30c$export$b7b3bece4ede3cc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne24Filled', "24", [
    "M21 17.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V16h18zM17.75 3C19.55 3 21 4.46 21 6.25v8.25H3V6.25C3 4.45 4.46 3 6.25 3zM12 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $76e5a570f6bfc30c$export$6106e58947c2a9e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne24Regular', "24", [
    "M12 6.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3zM4.5 17.75c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V16h-15zM6.25 4.5c-.97 0-1.75.78-1.75 1.75v8.25h15V6.25c0-.97-.78-1.75-1.75-1.75z"
]);
const $76e5a570f6bfc30c$export$b11b3041353c8d2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne28Filled', "28", [
    "M25 21.25A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V19.5h22zM21.25 3A3.75 3.75 0 0 1 25 6.75V18H3V6.75A3.75 3.75 0 0 1 6.75 3zM14 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$cf1159e5eb50af35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne28Regular', "28", [
    "M14 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m7.25-4A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3zM4.5 21.25c0 1.24 1 2.25 2.25 2.25h14.5c1.24 0 2.25-1 2.25-2.25V19.5h-19zM6.75 4.5c-1.24 0-2.25 1-2.25 2.25V18h19V6.75c0-1.24-1-2.25-2.25-2.25z"
]);
const $76e5a570f6bfc30c$export$59b2a028bf846510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne32Filled', "32", [
    "M29 24.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5V22h26zM24.5 3A4.5 4.5 0 0 1 29 7.5V20H3V7.5A4.5 4.5 0 0 1 7.5 3zM16 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$51d25e2a2a21819c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOne32Regular', "32", [
    "M16 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m8.5-5A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zM5 24.5A2.5 2.5 0 0 0 7.5 27h17a2.5 2.5 0 0 0 2.5-2.5V22H5zM7.5 5A2.5 2.5 0 0 0 5 7.5V20h22V7.5A2.5 2.5 0 0 0 24.5 5z"
]);
const $76e5a570f6bfc30c$export$56081e819bd9b3ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar12Filled', "12", [
    "M7.5 9a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM9 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM6 3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-3 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$4e59ad25e616d159 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar12Regular', "12", [
    "M7.5 9a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM9 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM3 3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm3 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-2.5.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$4fdd4a5c4c2a125c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar16Filled', "16", [
    "M10.5 12a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm2-9A2.5 2.5 0 0 1 15 5.5v3a2.5 2.5 0 0 1-2.5 2.5h-9a2.5 2.5 0 0 1-2.49-2.24L1 8.5v-3A2.5 2.5 0 0 1 3.5 3zM8 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4.5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$eceab6e14363ef48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar16Regular', "16", [
    "M10.5 12a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm2-9A2.5 2.5 0 0 1 15 5.5v3a2.5 2.5 0 0 1-2.5 2.5h-9a2.5 2.5 0 0 1-2.49-2.24L1 8.5v-3A2.5 2.5 0 0 1 3.5 3zm-9 1C2.67 4 2 4.67 2 5.5v3.15A1.5 1.5 0 0 0 3.5 10h9c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM8 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4 .25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$e12964058e0cdf48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar20Filled', "20", [
    "M13 14a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm2-10a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm-5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-5 .75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$89b985ab32bdf91e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar20Regular', "20", [
    "M13 14a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm2-10a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM5 5a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-4.5.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$bad2efa80bd66f43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar24Filled', "24", [
    "M15.25 17.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zM18.75 5C20.55 5 22 6.46 22 8.25v4.5c0 1.8-1.45 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 12.75v-4.5C2 6.45 3.46 5 5.25 5zM12 7.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M12 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-6 .5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $76e5a570f6bfc30c$export$66acaaa7d3ff5e5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar24Regular', "24", [
    "M15.25 17.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zM18.75 5C20.55 5 22 6.46 22 8.25v4.5c0 1.8-1.45 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 12.75v-4.5C2 6.45 3.46 5 5.25 5zM5.25 6.5c-.96 0-1.75.78-1.75 1.75v4.5c0 .97.79 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-4.5c0-.97-.78-1.75-1.75-1.75zm6.75 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M12 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-5.5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $76e5a570f6bfc30c$export$f72aaec897829a2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar28Filled', "28", [
    "M18.25 22a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zm4-16A3.75 3.75 0 0 1 26 9.75v6.5A3.75 3.75 0 0 1 22.25 20H5.75A3.75 3.75 0 0 1 2 16.25v-6.5A3.75 3.75 0 0 1 5.75 6zM14 9a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 1.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-8 1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $76e5a570f6bfc30c$export$1f7a147bc71b007a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar28Regular', "28", [
    "M18.25 22a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zm4-16A3.75 3.75 0 0 1 26 9.75v6.5A3.75 3.75 0 0 1 22.25 20H5.75A3.75 3.75 0 0 1 2 16.25v-6.5A3.75 3.75 0 0 1 5.75 6zM5.75 7.5c-1.24 0-2.25 1-2.25 2.25v6.5c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25v-6.5c0-1.24-1-2.25-2.25-2.25zM14 9a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-7 1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $76e5a570f6bfc30c$export$bcaf39480887d61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar32Filled', "32", [
    "M21 24a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm4.5-18a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 17.5v-7A4.5 4.5 0 0 1 6.5 6zM16 9.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-9 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$e75c75c8eae43c87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBar32Regular', "32", [
    "M21 24a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm4.5-18a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 17.5v-7A4.5 4.5 0 0 1 6.5 6zm-19 2A2.5 2.5 0 0 0 4 10.5v7A2.5 2.5 0 0 0 6.5 20h19a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 25.5 8zM16 9.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-8 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $76e5a570f6bfc30c$export$b6c7e944d4f6bb06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneAbove16Filled', "16", [
    "M5.17 13.67a4 4 0 0 1 5.66 0 .5.5 0 0 1-.71.7 3 3 0 0 0-4.24 0 .5.5 0 1 1-.71-.7M3.4 11.9a6.5 6.5 0 0 1 9.2 0 .5.5 0 0 1-.71.71 5.5 5.5 0 0 0-7.78 0 .5.5 0 1 1-.7-.7M8 4c1.74 0 3.29.33 4.39.83C13.53 5.36 14 5.98 14 6.5v.1c-.07.5-.55 1.08-1.61 1.57-1.1.5-2.66.83-4.39.83s-3.29-.33-4.39-.83c-1.06-.5-1.54-1.07-1.6-1.56L2 6.5c0-.52.47-1.14 1.61-1.67C4.71 4.33 6.26 4 8 4m0-3c1.56 0 3 .23 4.06.62q.81.28 1.33.72c.34.3.61.68.61 1.16v1.16a6 6 0 0 0-1.2-.74A12 12 0 0 0 8 3c-1.85 0-3.55.35-4.8.92q-.68.3-1.2.74V3.5c0-.48.27-.87.6-1.16q.53-.44 1.34-.72A12 12 0 0 1 8 1"
]);
const $76e5a570f6bfc30c$export$34ec38713095579 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneAbove16Regular', "16", [
    "M5.17 13.67a4 4 0 0 1 5.66 0 .5.5 0 0 1-.71.7 3 3 0 0 0-4.24 0 .5.5 0 1 1-.71-.7M3.4 11.9a6.5 6.5 0 0 1 9.2 0 .5.5 0 0 1-.71.71 5.5 5.5 0 0 0-7.78 0 .5.5 0 1 1-.7-.7M8 1c1.56 0 3 .23 4.06.62q.81.28 1.33.72c.3.26.54.59.6.99l.01.17v3c0 .48-.27.87-.6 1.16q-.54.44-1.34.72C11 8.77 9.56 9 8 9s-3-.23-4.06-.62q-.81-.28-1.33-.72C2.27 7.36 2 6.98 2 6.5v-3l.01-.17c.06-.4.3-.73.6-.99q.52-.44 1.33-.72A12 12 0 0 1 8 1m0 4c-1.48 0-2.79.22-3.72.56q-.69.26-1.02.54c-.22.19-.26.32-.26.4s.04.21.26.4q.32.29 1.02.54C5.21 7.78 6.52 8 8 8s2.79-.22 3.72-.56q.69-.26 1.02-.54c.22-.19.26-.32.26-.4s-.04-.21-.26-.4a3 3 0 0 0-1.02-.54C10.79 5.22 9.48 5 8 5m0-3c-1.48 0-2.79.22-3.72.56q-.69.25-1.02.54-.23.21-.25.33L3 3.5v1.56q.42-.26.94-.44A12 12 0 0 1 8 4c1.56 0 3 .23 4.06.62q.53.18.94.44V3.5l-.01-.07q-.02-.12-.25-.33a3 3 0 0 0-1.02-.54C10.79 2.22 9.48 2 8 2"
]);
const $76e5a570f6bfc30c$export$4190e3429808259a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneAbove20Filled', "20", [
    "M6.11 17.11a5.5 5.5 0 0 1 7.78 0 .5.5 0 0 1-.7.7 4.5 4.5 0 0 0-6.37 0 .5.5 0 0 1-.7-.7m-1.77-1.77a8 8 0 0 1 11.32 0 .5.5 0 0 1-.71.71 7 7 0 0 0-9.9 0 .5.5 0 1 1-.7-.7M10 5c2.01 0 3.81.38 5.1.98C16.4 6.59 17 7.34 17 8v.14c-.08.62-.68 1.3-1.9 1.88-1.29.6-3.09.98-5.1.98s-3.81-.38-5.1-.98C3.69 9.45 3.09 8.76 3 8.14V8c0-.66.59-1.4 1.9-2.02A12 12 0 0 1 10 5m0-3c1.84 0 3.53.29 4.78.77q.94.35 1.55.89c.39.35.67.8.67 1.34v1.03q-.62-.57-1.49-.96A13 13 0 0 0 10 4c-2.13 0-4.08.4-5.51 1.07q-.86.39-1.49.96V5c0-.53.28-.99.67-1.34q.61-.54 1.55-.9C6.47 2.3 8.16 2 10 2"
]);
const $76e5a570f6bfc30c$export$abb9fd9b1993486f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneAbove20Regular', "20", [
    "M6.11 17.11a5.5 5.5 0 0 1 7.78 0 .5.5 0 0 1-.7.7 4.5 4.5 0 0 0-6.37 0 .5.5 0 0 1-.7-.7m-1.77-1.77a8 8 0 0 1 11.32 0 .5.5 0 0 1-.71.71 7 7 0 0 0-9.9 0 .5.5 0 1 1-.7-.7M10 2c1.84 0 3.53.29 4.78.77q.94.35 1.55.89c.34.3.6.7.66 1.14L17 5v3c0 .53-.28.99-.67 1.34q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89C3.28 9 3 8.54 3 8V5l.01-.2c.06-.45.32-.83.66-1.14q.61-.54 1.55-.9C6.47 2.3 8.16 2 10 2m0 4c-1.75 0-3.31.27-4.42.7a4 4 0 0 0-1.23.7c-.27.24-.35.44-.35.6s.08.36.35.6a4 4 0 0 0 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.27-.24.35-.44.35-.6s-.08-.36-.35-.6a4 4 0 0 0-1.23-.7C13.32 6.27 11.75 6 10 6m0-3c-1.75 0-3.31.27-4.42.7a4 4 0 0 0-1.23.7c-.24.2-.33.4-.35.54V6.4q.52-.37 1.22-.63C6.47 5.29 8.16 5 10 5s3.53.29 4.78.77q.7.25 1.22.63V4.94c-.02-.15-.11-.33-.35-.54a4 4 0 0 0-1.23-.7C13.32 3.27 11.75 3 10 3"
]);
const $76e5a570f6bfc30c$export$cb6edc395011cea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneBelow16Filled', "16", [
    "M14 12.5c0 .48-.27.87-.6 1.16q-.54.43-1.34.72C11 14.77 9.56 15 8 15s-3-.23-4.06-.62q-.81-.29-1.33-.72c-.34-.3-.61-.68-.61-1.16v-1.16q.52.43 1.2.74c1.25.57 2.95.92 4.8.92s3.55-.35 4.8-.92q.68-.3 1.2-.74zm-1.61-4.67c1.06.5 1.54 1.07 1.6 1.56l.01.11c0 .52-.47 1.14-1.61 1.67-1.1.5-2.65.83-4.39.83a11 11 0 0 1-4.39-.83C2.47 10.64 2 10.02 2 9.5v-.1c.07-.5.55-1.08 1.61-1.57C4.71 7.33 6.27 7 8 7s3.29.33 4.39.83m-.5-4.44a.5.5 0 0 1 .7.7 6.5 6.5 0 0 1-9.19 0 .5.5 0 1 1 .71-.7 5.5 5.5 0 0 0 7.78 0m-1.77-1.77a.5.5 0 0 1 .7.7 4 4 0 0 1-5.65 0 .5.5 0 1 1 .7-.7 3 3 0 0 0 4.25 0"
]);
const $76e5a570f6bfc30c$export$3eb16c7a48be0d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneBelow16Regular', "16", [
    "M8 7c1.56 0 3 .23 4.06.62q.81.29 1.33.72c.34.3.61.68.61 1.16v3l-.01.17c-.06.4-.3.73-.6.99q-.52.43-1.33.72C11 14.77 9.56 15 8 15s-3-.23-4.06-.62q-.81-.29-1.33-.72c-.3-.26-.54-.59-.6-.99L2 12.5v-3c0-.48.27-.87.6-1.16q.53-.43 1.34-.72A12 12 0 0 1 8 7m5 3.94q-.42.26-.94.44C11 11.77 9.56 12 8 12s-3-.23-4.06-.62a5 5 0 0 1-.94-.44v1.56l.01.07q.01.12.25.33.32.3 1.02.54c.93.34 2.24.56 3.72.56s2.79-.22 3.72-.56q.69-.25 1.02-.54.23-.21.25-.33l.01-.07zM8 8c-1.48 0-2.79.22-3.72.56q-.69.26-1.02.54c-.22.19-.26.32-.26.4s.04.21.26.4q.32.3 1.02.54c.93.34 2.24.56 3.72.56s2.79-.22 3.72-.56q.69-.25 1.02-.54c.22-.19.26-.32.26-.4s-.04-.21-.26-.4a3 3 0 0 0-1.02-.54C10.79 8.22 9.48 8 8 8m3.89-4.61a.5.5 0 0 1 .7.7 6.5 6.5 0 0 1-9.19 0 .5.5 0 1 1 .71-.7 5.5 5.5 0 0 0 7.78 0m-1.77-1.77a.5.5 0 0 1 .7.7 4 4 0 0 1-5.65 0 .5.5 0 1 1 .7-.7 3 3 0 0 0 4.25 0"
]);
const $76e5a570f6bfc30c$export$fd33ef4ba99b28a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneBelow20Filled', "20", [
    "M17 15c0 .53-.28.99-.67 1.34q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89C3.28 16 3 15.54 3 15v-1.03q.63.57 1.49.96A13 13 0 0 0 10 16c2.13 0 4.08-.4 5.51-1.07a6 6 0 0 0 1.49-.96zm-1.9-5.02c1.22.57 1.82 1.26 1.9 1.88V12c0 .66-.59 1.4-1.9 2.02-1.29.6-3.09.98-5.1.98a12 12 0 0 1-5.1-.98C3.6 13.41 3 12.66 3 12v-.14c.08-.62.68-1.3 1.9-1.88C6.2 9.38 8 9 10 9s3.81.38 5.1.98m-.15-6.03a.5.5 0 0 1 .7.7 8 8 0 0 1-11.3 0 .5.5 0 1 1 .7-.7 7 7 0 0 0 9.9 0m-1.77-1.77a.5.5 0 0 1 .71.7 5.5 5.5 0 0 1-7.78 0 .5.5 0 1 1 .7-.7 4.5 4.5 0 0 0 6.37 0"
]);
const $76e5a570f6bfc30c$export$cc74bc2ac4d1e5dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneBelow20Regular', "20", [
    "M10 9c1.84 0 3.53.29 4.78.77q.94.35 1.55.89c.39.35.67.8.67 1.34v3l-.01.2c-.06.45-.32.83-.66 1.14q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89c-.34-.3-.6-.7-.66-1.14L3 15v-3c0-.53.28-.99.67-1.34q.61-.54 1.55-.9C6.47 9.3 8.16 9 10 9m6 4.6q-.52.37-1.22.63c-1.25.48-2.94.77-4.78.77s-3.53-.29-4.78-.77A6 6 0 0 1 4 13.6v1.46q.01.23.35.54.4.38 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.24-.2.33-.4.35-.54zM10 10c-1.75 0-3.31.27-4.42.7a4 4 0 0 0-1.23.7c-.27.24-.35.44-.35.6s.08.36.35.6q.4.38 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.27-.24.35-.44.35-.6s-.08-.36-.35-.6a4 4 0 0 0-1.23-.7c-1.1-.43-2.67-.7-4.42-.7m4.95-6.05a.5.5 0 0 1 .7.7 8 8 0 0 1-11.3 0 .5.5 0 1 1 .7-.7 7 7 0 0 0 9.9 0m-1.77-1.77a.5.5 0 0 1 .71.7 5.5 5.5 0 0 1-7.78 0 .5.5 0 1 1 .7-.7 4.5 4.5 0 0 0 6.37 0"
]);
const $76e5a570f6bfc30c$export$bf4a26b8bd646598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote16Filled', "16", [
    "M4.67 2a2 2 0 0 0-1.93 1.46L2.31 5 2.5 5h2A2.5 2.5 0 0 1 7 7.5V12h5.9a2.08 2.08 0 0 0 2.01-2.64l-1.66-5.9A2 2 0 0 0 11.34 2zm2.28 12q.05-.24.05-.5V13h4.5a.5.5 0 1 1 0 1zM3.5 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M1 7.5C1 6.67 1.67 6 2.5 6h2C5.33 6 6 6.67 6 7.5v6c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 13.5zM2.5 7a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$5fd4187b2cadffbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote16Regular', "16", [
    "M2.74 3.46A2 2 0 0 1 4.67 2h6.67a2 2 0 0 1 1.92 1.46l1.66 5.9a2.08 2.08 0 0 1-2 2.64H7v-1h5.92c.71 0 1.23-.68 1.04-1.37l-1.66-5.9a1 1 0 0 0-.96-.73H4.67a1 1 0 0 0-.96.73L3.35 5H2.3zM6.95 14h4.55a.5.5 0 1 0 0-1H7v.5q0 .26-.05.5M3.5 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M1 7.5C1 6.67 1.67 6 2.5 6h2C5.33 6 6 6.67 6 7.5v6c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 13.5zM2.5 7a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$a6e2cb7ddd39b804 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote20Filled', "20", [
    "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H9V9.5A2.5 2.5 0 0 0 6.5 7h-3q-.15 0-.31.02zM9 16.5q0 .26-.05.5h5.55a.5.5 0 0 0 0-1H9zM5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$9a36a5330d2e6e0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote20Regular', "20", [
    "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H9v-1h6.5c.96 0 1.67-.9 1.46-1.83l-1.6-7A1.5 1.5 0 0 0 13.9 4H6.1c-.7 0-1.31.48-1.47 1.17L4.22 7H3.5q-.15 0-.31.02zM8.95 17h5.55a.5.5 0 0 0 0-1H9v.5q0 .26-.05.5M5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$23b39973c09737e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote24Filled', "24", [
    "M7.07 3c-1.41 0-2.64.97-2.97 2.35l-.77 3.18.42-.03h4a2.75 2.75 0 0 1 2.75 2.75V18h7.95c2.3 0 3.99-2.15 3.45-4.38l-2-8.27A3.06 3.06 0 0 0 16.94 3zm3.42 17.5.01-.25V19h6.75a.75.75 0 0 1 0 1.5zm-4.74-6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M2 11.25c0-.97.78-1.75 1.75-1.75h4c.97 0 1.75.78 1.75 1.75v9c0 .97-.78 1.75-1.75 1.75h-4C2.78 22 2 21.22 2 20.25zM3.75 11a.25.25 0 0 0-.25.25v9q.02.23.25.25h4c.14 0 .25-.11.25-.25v-9a.25.25 0 0 0-.25-.25z"
]);
const $76e5a570f6bfc30c$export$faf92a16ccbb1f38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote24Regular', "24", [
    "M4.1 5.35A3.06 3.06 0 0 1 7.06 3h9.86c1.42 0 2.65.97 2.98 2.35l1.99 8.27A3.55 3.55 0 0 1 18.45 18H10.5v-1.5h7.95c1.32 0 2.3-1.24 2-2.53l-2-8.27c-.17-.7-.8-1.2-1.52-1.2H7.07c-.72 0-1.35.5-1.52 1.2l-.67 2.8H3.75q-.22 0-.42.03zm6.39 15.15h6.76a.75.75 0 1 0 0-1.5H10.5v1.25zm-4.74-6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M2 11.25c0-.97.78-1.75 1.75-1.75h4c.97 0 1.75.78 1.75 1.75v9c0 .97-.78 1.75-1.75 1.75h-4C2.78 22 2 21.22 2 20.25zM3.75 11a.25.25 0 0 0-.25.25v9c0 .14.11.25.25.25h4q.23-.02.25-.25v-9a.25.25 0 0 0-.25-.25z"
]);
const $76e5a570f6bfc30c$export$9b75defad6ecf892 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote28Filled', "28", [
    "M8.35 3a3.5 3.5 0 0 0-3.38 2.58l-1.21 4.46Q4 10 4.25 10h4.5c1.8 0 3.25 1.46 3.25 3.25V21h10a4 4 0 0 0 3.86-5.05L23.03 5.58A3.5 3.5 0 0 0 19.65 3zM12 24l.01-.25V22.5h8.25a.75.75 0 1 1 0 1.5zM6.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M2 13.25C2 12.01 3 11 4.25 11h4.5C10 11 11 12 11 13.25v10.5C11 24.99 10 26 8.75 26h-4.5C3.01 26 2 25 2 23.75zm2.25-.75a.75.75 0 0 0-.75.75v10.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-10.5a.75.75 0 0 0-.75-.75z"
]);
const $76e5a570f6bfc30c$export$e31e4a042d50fdf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote28Regular', "28", [
    "M4.97 5.58A3.5 3.5 0 0 1 8.35 3h11.3a3.5 3.5 0 0 1 3.38 2.58l2.83 10.37A4 4 0 0 1 22 21H12v-1.5h10a2.5 2.5 0 0 0 2.4-3.16L21.59 5.97a2 2 0 0 0-1.93-1.47H8.35a2 2 0 0 0-1.93 1.47L5.32 10H4.25q-.25 0-.5.04zM12 24h8.26a.75.75 0 1 0 0-1.5H12V24M6.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M2 13.25C2 12.01 3 11 4.25 11h4.5C10 11 11 12 11 13.25v10.5C11 24.99 10 26 8.75 26h-4.5C3.01 26 2 25 2 23.75zm2.25-.75a.75.75 0 0 0-.75.75v10.5c0 .41.34.75.75.75h4.5c.42 0 .75-.34.75-.75v-10.5a.75.75 0 0 0-.75-.75z"
]);
const $76e5a570f6bfc30c$export$f6b6f8b3b6b68153 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote32Filled', "32", [
    "M5.38 7.11A4.25 4.25 0 0 1 9.48 4h13.05c1.91 0 3.58 1.27 4.1 3.11l3.22 11.6A4.18 4.18 0 0 1 25.82 24H14.5v-9.5a4 4 0 0 0-4-4H4.43zM14.47 28H24a1 1 0 1 0 0-2h-9.5v1.5q0 .26-.03.5M4.5 14a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h6a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zm-2.5.5A2.5 2.5 0 0 1 4.5 12h6a2.5 2.5 0 0 1 2.5 2.5v13a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 27.5zM7.5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $76e5a570f6bfc30c$export$5a4ba5491d67e789 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote32Regular', "32", [
    "M9.47 4a4.25 4.25 0 0 0-4.1 3.11l-.93 3.4.06-.01h2.01l.8-2.85A2.25 2.25 0 0 1 9.46 6h13.06c1.01 0 1.9.67 2.17 1.65l3.22 11.59a2.18 2.18 0 0 1-2.1 2.76H14.5v2h11.32a4.18 4.18 0 0 0 4.03-5.3L26.63 7.11A4.25 4.25 0 0 0 22.53 4zm5.03 22H24a1 1 0 1 1 0 2h-9.53q.03-.24.03-.5zm-10-12a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h6a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zm-2.5.5A2.5 2.5 0 0 1 4.5 12h6a2.5 2.5 0 0 1 2.5 2.5v13a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 27.5zM7.5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $76e5a570f6bfc30c$export$76544f1c1d31d348 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote48Filled', "48", [
    "M8.97 10.4c.7-2.6 3.05-4.4 5.74-4.4h18.58c2.7 0 5.04 1.8 5.74 4.4l4.76 17.77A6.22 6.22 0 0 1 37.78 36H21V22.75A5.75 5.75 0 0 0 15.25 17h-7.5q-.28 0-.55.03zM21 40.25v.25h13.75a1.25 1.25 0 1 0 0-2.5H21zM11.5 29a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-3.75-7.5c-.69 0-1.25.56-1.25 1.25v17.5c0 .69.56 1.25 1.25 1.25h7.5c.7 0 1.25-.56 1.25-1.25v-17.5c0-.69-.56-1.25-1.25-1.25zM4 22.75A3.75 3.75 0 0 1 7.75 19h7.5A3.75 3.75 0 0 1 19 22.75v17.5A3.75 3.75 0 0 1 15.25 44h-7.5A3.75 3.75 0 0 1 4 40.25z"
]);
const $76e5a570f6bfc30c$export$c7ca8f6d87436b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemote48Regular', "48", [
    "M14.7 6a5.94 5.94 0 0 0-5.73 4.4L7.2 17.03q.27-.03.55-.03h2.04l1.6-5.95A3.44 3.44 0 0 1 14.7 8.5h18.58a3.44 3.44 0 0 1 3.32 2.55l4.76 17.77a3.72 3.72 0 0 1-3.6 4.68H21V36h16.78a6.22 6.22 0 0 0 6-7.83L39.04 10.4A5.94 5.94 0 0 0 33.29 6zm20.05 34.5H21l.01-.25V38h13.75a1.25 1.25 0 0 1 0 2.5M11.5 29a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M4 22.75A3.75 3.75 0 0 1 7.75 19h7.5A3.75 3.75 0 0 1 19 22.75v17.5A3.75 3.75 0 0 1 15.25 44h-7.5A3.75 3.75 0 0 1 4 40.25zm3.75-1.25c-.69 0-1.25.56-1.25 1.25v17.5c0 .69.56 1.25 1.25 1.25h7.5c.7 0 1.25-.56 1.25-1.25v-17.5c0-.69-.56-1.25-1.25-1.25z"
]);
const $76e5a570f6bfc30c$export$c3cd751c4cf6ac2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircle16Filled', "16", [
    "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M4.5 6.5c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1H5a.5.5 0 0 0-.5.5M5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$7a008bbaf6e0585b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircle16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1M4.5 6.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$57eb0b1210433253 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircle20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.5 7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1zm0 3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1z"
]);
const $76e5a570f6bfc30c$export$10eae107e75d80c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircle20Regular', "20", [
    "M13.5 9a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1zm0 3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1zm4.5-2a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-8-7a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
]);
const $76e5a570f6bfc30c$export$2c4c8564b2468eaa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircle24Filled', "24", [
    "M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0m-5.75-1.5h-8.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 0 1.5m0 4.5h-8.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 0 1.5"
]);
const $76e5a570f6bfc30c$export$2d06ab25de4423a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircle24Regular', "24", [
    "M16.26 10.5a.75.75 0 0 0 0-1.5H7.77a.75.75 0 0 0 0 1.5zm0 4.5a.75.75 0 0 0 0-1.5H7.77a.75.75 0 0 0 0 1.5zM22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0M12 3.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17"
]);
const $76e5a570f6bfc30c$export$6d8ea72ee07ce32f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff12Filled', "12", [
    "M1.85 1.15a.5.5 0 1 0-.7.7L2.79 3.5h-.54a.75.75 0 0 0 0 1.5h2.04l2 2H2.25a.75.75 0 0 0 0 1.5h5.54l2.36 2.35a.5.5 0 0 0 .7-.7zM9.12 7l1.22 1.22q.15-.2.16-.47A.75.75 0 0 0 9.75 7zm-3.5-3.5L7.12 5h2.63a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$1c0917e3e9bd7dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff12Regular', "12", [
    "M1.85 1.15a.5.5 0 1 0-.7.7L3.29 4H2a.5.5 0 0 0 0 1h2.3l2 2H2a.5.5 0 0 0 0 1h5.3l2.85 2.85a.5.5 0 0 0 .7-.7zM9.12 7l.99.99A.5.5 0 0 0 10 7zm-3-3 1 1H10a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$6db27f4d626e5404 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff16Filled', "16", [
    "m10.3 11 3.85 3.85a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L3.79 4.5H2.75a.75.75 0 0 0 0 1.5h2.54l3.5 3.5H2.75a.75.75 0 0 0 0 1.5zm1.32-1.5 1.5 1.5h.13a.75.75 0 0 0 0-1.5zm-5-5L8.12 6h5.13a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$8ed2474edc998c50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff16Regular', "16", [
    "m10.3 11 3.85 3.85a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L4.29 5H2.5a.5.5 0 0 0 0 1h2.8l4 4H2.5a.5.5 0 0 0 0 1zm1.82-1 1 1h.38a.5.5 0 0 0 0-1zm-5-5 1 1h5.38a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$6488d0294eb9a953 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L5.79 6.5H3.75a.75.75 0 0 0 0 1.5h3.54l3.5 3.5H3.75a.75.75 0 0 0 0 1.5h8.54l4.86 4.85a.5.5 0 0 0 .7-.7zm10.77 9.35 1.5 1.5h1.13a.75.75 0 0 0 0-1.5zm-5-5 1.5 1.5h6.13a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$22558abc25554ad2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L6.29 7H3.5a.5.5 0 0 0 0 1h3.8l4 4H3.5a.5.5 0 0 0 0 1h8.8l4.85 4.85a.5.5 0 0 0 .7-.7zM14.12 12l1 1h1.38a.5.5 0 0 0 0-1zm-5-5 1 1h6.38a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$84edd3c79cf2adbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06L6.94 8H4a1 1 0 0 0 0 2h4.94l4 4H4a1 1 0 1 0 0 2h10.94l5.78 5.78a.75.75 0 0 0 1.06-1.06zM20 14h-2.82l2 2H20a1 1 0 1 0 0-2m-8.82-6 2 2H20a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$73a4d87d5baf2790 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06L6.94 8H3.75a.75.75 0 0 0 0 1.5h4.69l5 5H3.75a.75.75 0 0 0 0 1.5h11.19l5.78 5.78a.75.75 0 0 0 1.06-1.06zM20.25 14.5h-2.57l1.5 1.5h1.07a.75.75 0 0 0 0-1.5M11.18 8l1.5 1.5h7.57a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$d54b5a829adaf12c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip16Filled', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zm11 0v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0m.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M3 5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0M3.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$b937fed519677d2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM3.5 4C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM12 5.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M3 5.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM3.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$c1a9b1f271d43dfc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip20Filled', "20", [
    "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm13-.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0m.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0M4.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 12.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0M4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$ececc14d08efe0fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip20Regular', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 12.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$13b0888f6d6bf9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zm16.5.5v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0m.75 7.25a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m-.75-3.25v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0M4.75 7a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 4.75 7M4 15.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0M4.75 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$7277b3c4432aabbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zM5.25 5.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zM17.5 7.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zm.75 7.25a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m-.75-3.25a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zM5.75 7a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 5.75 7M5 15.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zM5.75 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$40a532b1b34886bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5zM25 9v2a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0m1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m-1 7v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0M6 8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-1 7v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0m1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$8500d3cd4c5b8f29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip32Regular', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5zM6.5 6A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6zM24 9a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zM7 8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$8a2f66121e1079e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip48Filled', "48", [
    "M10.25 8A6.25 6.25 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40h27.5C41.2 40 44 37.2 44 33.75v-19.5C44 10.8 41.2 8 37.75 8zM10 15.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 14c.83 0 1.5.67 1.5 1.5v1a1.5 1.5 0 0 1-3 0v-1c0-.83.67-1.5 1.5-1.5M10 23.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 22c.83 0 1.5.67 1.5 1.5v1a1.5 1.5 0 0 1-3 0v-1c0-.83.67-1.5 1.5-1.5M10 31.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 30c.83 0 1.5.67 1.5 1.5v1a1.5 1.5 0 0 1-3 0v-1c0-.83.67-1.5 1.5-1.5"
]);
const $76e5a570f6bfc30c$export$602f2dd44fd328f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filmstrip48Regular', "48", [
    "M10 15.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 14c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M10 23.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 22c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M10 31.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 30c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M4 14.25C4 10.8 6.8 8 10.25 8h27.5C41.2 8 44 10.8 44 14.25v19.5C44 37.2 41.2 40 37.75 40h-27.5A6.25 6.25 0 0 1 4 33.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v19.5a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75v-19.5a3.75 3.75 0 0 0-3.75-3.75z"
]);
const $76e5a570f6bfc30c$export$7978a5d27e0c059b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.35.14l-2 2a.5.5 0 1 0 .7.71L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 1 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9m1-7A2.5 2.5 0 0 1 15 4.5v2.76A5.5 5.5 0 0 0 6.02 12H3.5A2.5 2.5 0 0 1 1 9.5v-5A2.5 2.5 0 0 1 3.5 2zm-9 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m9 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$e3c58e89be7c8af1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.35.14l-2 2a.5.5 0 1 0 .7.71L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 1 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9m1-7A2.5 2.5 0 0 1 15 4.5v2.76a6 6 0 0 0-1-.66V4.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5h2.52a6 6 0 0 0 0 1H3.5A2.5 2.5 0 0 1 1 9.5v-5A2.5 2.5 0 0 1 3.5 2zm-9 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-4c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m9 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$47cb1458c9871c04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.35.14l-2 2a.5.5 0 1 0 .7.71L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 1 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15m.5-8a3 3 0 0 1 3 3v3.26A5.5 5.5 0 0 0 9.2 16H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM4.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m11 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$a18bdba47474d4fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.35.14l-2 2a.5.5 0 1 0 .7.71L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 1 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15m1-8A2.5 2.5 0 0 1 18 6.5v3.76a6 6 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4.52q.05.51.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-11 8c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m11 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$f3d5d45e435d837a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.35 2.15a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 1 0 .7.7L17 15.71v4.79a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 1 0 .7-.7zM18.75 4C20.55 4 22 5.46 22 7.25v5.56A6.5 6.5 0 0 0 11.5 20H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm-14 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m0-4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m0-4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 4.75 7m14.5 0a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$927a6c58b506f238 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.35 2.15a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 1 0 .7.7L17 15.71v4.79a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 1 0 .7-.7zM18.75 4C20.55 4 22 5.46 22 7.25v5.56q-.67-.65-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h5.83q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm-13 11c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m0-4c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m0-4c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m12.5 0c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$2e56353736d48288 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp32Filled', "32", [
    "M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.78 2.22a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72v7.69a.75.75 0 0 0 1.5 0v-7.69l2.72 2.72a.75.75 0 1 0 1.06-1.06zM25.5 4A4.5 4.5 0 0 1 30 8.5v8.84A9 9 0 0 0 15.52 28H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM6 20a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m0-6a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m0-6a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m20 0a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$7d13ec990ae70e75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUp32Regular', "32", [
    "M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.78 2.22a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72v7.69a.75.75 0 0 0 1.5 0v-7.69l2.72 2.72a.75.75 0 1 0 1.06-1.06zM25.5 4A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6h-19A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h8.01q.4 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM7 20a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0-6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0-6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m18 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"
]);
const $76e5a570f6bfc30c$export$cc391ad501458122 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe16Filled', "16", [
    "M12.99 12a9 9 0 0 1-.54 2.85q-.26.63-.54.91c-.18.2-.32.24-.41.24-.1 0-.23-.05-.41-.24q-.29-.29-.54-.91a9 9 0 0 1-.54-2.85zM9 12a10 10 0 0 0 .82 3.68A4.5 4.5 0 0 1 7.03 12zm6.96 0a4.5 4.5 0 0 1-2.8 3.68l.2-.46c.35-.86.57-1.99.62-3.22zM12.5 2A2.5 2.5 0 0 1 15 4.5v2.76A5.5 5.5 0 0 0 6.02 12H3.5A2.5 2.5 0 0 1 1 9.5v-5A2.5 2.5 0 0 1 3.5 2zM9.83 7.32q-.12.22-.2.46A10 10 0 0 0 9 11H7.03a4.5 4.5 0 0 1 2.8-3.68M11.5 7c.1 0 .23.05.41.24q.29.29.54.91c.3.73.5 1.72.54 2.85H10a9 9 0 0 1 .54-2.85q.26-.63.54-.91c.18-.2.32-.24.41-.24m1.67.32c1.51.6 2.62 2 2.8 3.68H14a10 10 0 0 0-.82-3.68M3.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m9 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$5415f5f523a623d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe16Regular', "16", [
    "M12.99 12a9 9 0 0 1-.54 2.85q-.26.63-.54.91c-.18.2-.32.24-.41.24-.1 0-.23-.05-.41-.24q-.29-.29-.54-.91a9 9 0 0 1-.54-2.85zM9 12a10 10 0 0 0 .82 3.68A4.5 4.5 0 0 1 7.03 12zm6.96 0a4.5 4.5 0 0 1-2.8 3.68l.2-.46c.35-.86.57-1.99.62-3.22zM12.5 2A2.5 2.5 0 0 1 15 4.5v2.76a6 6 0 0 0-1-.66V4.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5h2.52a6 6 0 0 0 0 1H3.5A2.5 2.5 0 0 1 1 9.5v-5A2.5 2.5 0 0 1 3.5 2zM9.83 7.32q-.12.22-.2.46A10 10 0 0 0 9 11H7.03a4.5 4.5 0 0 1 2.8-3.68M11.5 7c.1 0 .23.05.41.24q.29.29.54.91c.3.73.5 1.72.54 2.85H10a9 9 0 0 1 .54-2.85q.26-.63.54-.91c.18-.2.32-.24.41-.24m1.67.32c1.51.6 2.62 2 2.8 3.68H14a10 10 0 0 0-.82-3.68M3.5 8c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-4c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m9 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$589427ae443b0e31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe20Filled', "20", [
    "M15.99 15a9 9 0 0 1-.54 2.85q-.26.63-.54.91c-.18.2-.32.24-.41.24-.1 0-.23-.05-.41-.24q-.29-.29-.54-.91a9 9 0 0 1-.54-2.85zM12 15a10 10 0 0 0 .82 3.68 4.5 4.5 0 0 1-2.8-3.68zm6.96 0a4.5 4.5 0 0 1-2.8 3.68l.2-.46c.35-.86.57-1.99.62-3.22zM15 4a3 3 0 0 1 3 3v3.26A5.5 5.5 0 0 0 9.2 16H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM4.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m8.33-1.68q-.11.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68M14.5 10c.1 0 .23.05.41.24q.29.29.54.91c.3.73.5 1.72.54 2.85H13a9 9 0 0 1 .54-2.85q.26-.63.54-.91c.18-.2.32-.24.41-.24m1.67.32c1.51.6 2.62 2 2.8 3.68H17a10 10 0 0 0-.82-3.68M4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m11 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$ffb0a5dde1c25fff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe20Regular', "20", [
    "M15.99 15a9 9 0 0 1-.54 2.85q-.26.63-.54.91c-.18.2-.32.24-.41.24-.1 0-.23-.05-.41-.24q-.29-.29-.54-.91a9 9 0 0 1-.54-2.85zM12 15a10 10 0 0 0 .82 3.68 4.5 4.5 0 0 1-2.8-3.68zm6.96 0a4.5 4.5 0 0 1-2.8 3.68l.2-.46c.35-.86.57-1.99.62-3.22zM15.5 4A2.5 2.5 0 0 1 18 6.5v3.76a6 6 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4.52q.05.51.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-11 8c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m8.33-1.68q-.11.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68M14.5 10c.1 0 .23.05.41.24q.29.29.54.91c.3.73.5 1.72.54 2.85H13a9 9 0 0 1 .54-2.85q.26-.63.54-.91c.18-.2.32-.24.41-.24m1.67.32c1.51.6 2.62 2 2.8 3.68H17a10 10 0 0 0-.82-3.68M4.5 9c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m11 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$1a8cea8d73dce675 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe24Filled', "24", [
    "M18.97 18a13 13 0 0 1-.55 3.59q-.27.76-.56 1.13c-.2.25-.33.28-.38.28-.06 0-.2-.03-.39-.28a4 4 0 0 1-.55-1.13c-.3-.92-.52-2.18-.56-3.59zm-3.99 0c.04 1.5.26 2.87.6 3.9q.17.48.38.89A5.5 5.5 0 0 1 12 18zm7.98 0A5.5 5.5 0 0 1 19 22.79q.2-.4.37-.89c.34-1.03.56-2.4.6-3.9zM18.75 4C20.55 4 22 5.46 22 7.25v5.56A6.5 6.5 0 0 0 11.5 20H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm-14 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m11.2-2.79q-.2.4-.36.89c-.35 1.03-.57 2.4-.6 3.9H12a5.5 5.5 0 0 1 3.96-4.79m1.53-.21c.05 0 .19.03.38.28q.3.36.56 1.13c.3.92.51 2.18.55 3.59h-2.99c.04-1.41.25-2.67.56-3.59q.26-.76.55-1.13c.2-.25.33-.28.39-.28m1.52.21A5.5 5.5 0 0 1 22.96 17h-2.99c-.04-1.5-.26-2.87-.6-3.9q-.16-.48-.37-.89M4.75 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m0-4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 4.75 7m14.5 0a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$bd3243b8b528588 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe24Regular', "24", [
    "M18.97 18a13 13 0 0 1-.55 3.59q-.27.76-.56 1.13c-.2.25-.33.28-.38.28-.06 0-.2-.03-.39-.28a4 4 0 0 1-.55-1.13c-.3-.92-.52-2.18-.56-3.59zm-3.99 0c.04 1.5.26 2.87.6 3.9q.17.48.38.89A5.5 5.5 0 0 1 12 18zm7.98 0A5.5 5.5 0 0 1 19 22.79q.2-.4.37-.89c.34-1.03.56-2.4.6-3.9zM18.75 4C20.55 4 22 5.46 22 7.25v5.56q-.67-.65-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h5.83q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm-13 11c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m10.2-2.79q-.2.4-.36.89c-.35 1.03-.57 2.4-.6 3.9H12a5.5 5.5 0 0 1 3.96-4.79m1.53-.21c.05 0 .19.03.38.28q.3.36.56 1.13c.3.92.51 2.18.55 3.59h-2.99c.04-1.41.25-2.67.56-3.59q.26-.76.55-1.13c.2-.25.33-.28.39-.28m1.52.21A5.5 5.5 0 0 1 22.96 17h-2.99c-.04-1.5-.26-2.87-.6-3.9q-.16-.48-.37-.89M5.75 11c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m0-4c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m12.5 0c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$af297b27dbb83ca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe32Filled', "32", [
    "M25.97 24c-.2 3.67-1.45 6.5-2.97 6.5s-2.78-2.83-2.97-6.5zm-7.45 0c.1 1.83.43 3.53.97 4.86q.2.52.47 1a7.5 7.5 0 0 1-4.4-5.86zm11.91 0a7.5 7.5 0 0 1-4.39 5.86q.27-.48.47-1c.54-1.33.87-3.03.96-4.86zM25.5 4A4.5 4.5 0 0 1 30 8.5v8.84A9 9 0 0 0 15.52 28H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM6 20a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m13.96-3.86q-.27.48-.47 1a16 16 0 0 0-.99 5.36h-2.98a7.5 7.5 0 0 1 4.44-6.36M23 15.5c1.59 0 2.89 3.1 3 7h-6c.1-3.9 1.41-7 3-7m3.04.64a7.5 7.5 0 0 1 4.44 6.36H27.5c-.05-2.02-.4-3.9-.98-5.36q-.2-.52-.47-1M6 14a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m0-6a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m20 0a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$bc63667370010dae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobe32Regular', "32", [
    "M25.97 24c-.2 3.67-1.45 6.5-2.97 6.5s-2.78-2.83-2.97-6.5zm-7.45 0c.1 1.83.43 3.53.97 4.86q.2.52.47 1a7.5 7.5 0 0 1-4.4-5.86zm11.91 0a7.5 7.5 0 0 1-4.39 5.86q.27-.48.47-1c.54-1.33.87-3.03.96-4.86zM25.5 4A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6h-19A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h8.01q.4 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM7 20a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m12.96-3.86q-.27.48-.47 1a16 16 0 0 0-.99 5.36h-2.98a7.5 7.5 0 0 1 4.44-6.36M23 15.5c1.59 0 2.89 3.1 3 7h-6c.1-3.9 1.41-7 3-7m3.04.64a7.5 7.5 0 0 1 4.44 6.36H27.5c-.05-2.02-.4-3.9-.98-5.36q-.2-.52-.47-1M7 14a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0-6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m18 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"
]);
const $76e5a570f6bfc30c$export$34083fb143ab8e53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripImage20Filled', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H7v-2.5A3.5 3.5 0 0 1 10.5 7H14V4.5A2.5 2.5 0 0 0 11.5 2zm0 2c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5m7.5.5V5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 1 0M4.5 6.75c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5M5 10v.5a.5.5 0 0 1-1 0V10a.5.5 0 0 1 1 0m3 .5A2.5 2.5 0 0 1 10.5 8h5a2.5 2.5 0 0 1 2.5 2.5v5q-.01.77-.41 1.38L14.2 13.5a1.7 1.7 0 0 0-2.42 0l-3.38 3.38q-.4-.6-.41-1.38zm6 .5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-4.88 6.59q.6.4 1.38.41h5q.77-.01 1.38-.41L13.5 14.2a.7.7 0 0 0-1 0z"
]);
const $76e5a570f6bfc30c$export$71c3009a4b2b980a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripImage20Regular', "20", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5V7h-1V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7v1H4.5A2.5 2.5 0 0 1 2 10.5zM16 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-8-.5A2.5 2.5 0 0 1 10.5 8h5a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 8 15.5zM10.5 9C9.67 9 9 9.67 9 10.5v5q0 .35.15.65l2.64-2.65a1.7 1.7 0 0 1 2.42 0l2.64 2.65q.15-.3.15-.65v-5c0-.83-.67-1.5-1.5-1.5zm2 5.2-2.65 2.65q.3.15.65.15h5q.35 0 .65-.15l-2.65-2.64a.7.7 0 0 0-1 0M4.5 4c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5m7.5.5a.5.5 0 0 0-1 0V5a.5.5 0 0 0 1 0zM4.5 6.75c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5M5 10a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$b8431175e6ea653f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripImage24Filled', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h9.5C16.55 2 18 3.46 18 5.25V8h-5.75A4.25 4.25 0 0 0 8 12.25V16H5.25A3.25 3.25 0 0 1 2 12.75zM4.75 4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 4.75 4m.75 4.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0zM15.25 4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75M5.5 12.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0zm3.5-.5C9 10.45 10.46 9 12.25 9h6.5c1.8 0 3.25 1.46 3.25 3.25v6.5q-.01.92-.46 1.67l-4.49-4.31c-.86-.81-2.2-.81-3.07 0l-4.5 4.34q-.46-.76-.48-1.7zm8.75 2.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-5.5 7.5q-.95-.01-1.71-.49l4.46-4.3a.75.75 0 0 1 1.03 0l4.47 4.28q-.76.5-1.75.51z"
]);
const $76e5a570f6bfc30c$export$93d5fa4e1e6ee9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripImage24Regular', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h9.5C16.55 2 18 3.46 18 5.25V8h-1.5V5.25c0-.97-.78-1.75-1.75-1.75h-9.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75H8V16H5.25A3.25 3.25 0 0 1 2 12.75zm17 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-10-1C9 10.45 10.46 9 12.25 9h6.5c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.46 3.25-3.25 3.25h-6.5A3.25 3.25 0 0 1 9 18.75zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v6.5q0 .29.09.54l3.39-3.18c.87-.81 2.2-.81 3.07 0l3.37 3.15q.08-.24.08-.51v-6.5c0-.97-.78-1.75-1.75-1.75zm0 10h6.5q.36 0 .66-.13l-3.38-3.17a.75.75 0 0 0-1.03 0l-3.38 3.18q.3.12.63.12M5.75 5c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m.75 3.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0zM14.25 5c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75M6.5 11.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$30dec972e6a2ca91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripMusicNote220Filled', "20", [
    "M17.09 5.02c.46-.1.91.24.91.73V15a2 2 0 1 1-1-1.73V8.61l-6 2.14V16a2 2 0 1 1-1-1.73v-6.2c0-.32.2-.6.5-.7L17 5.04zM11.5 2A2.5 2.5 0 0 1 14 4.5v.55l-3.84 1.37C9.46 6.67 9 7.33 9 8.07V13H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2zm-7 7.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 1 0V10a.5.5 0 0 0-.5-.5m0-2.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5M4.5 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5m7 0a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$4831ff81874e5993 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripMusicNote220Regular', "20", [
    "M17.09 5.02c.46-.1.91.24.91.73V15a2 2 0 1 1-1-1.73V8.61l-6 2.14V16a2 2 0 1 1-1-1.73v-6.2c0-.32.2-.6.5-.7L17 5.04zM9 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M11.5 2A2.5 2.5 0 0 1 14 4.5v.55l-1 .36V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H9v1H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2zm-7 7.5c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0V10c0-.28.22-.5.5-.5M11 8.25v1.44l6-2.14V6.1zm-6.5-1.5c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5M4.5 4c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5m7 0c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$f6016b1113cc76e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripOff48Filled', "48", [
    "m38.22 39.98 3.65 3.65a1.25 1.25 0 0 0 1.76-1.76L6.13 4.37a1.25 1.25 0 1 0-1.76 1.76l2.72 2.73A6.3 6.3 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40h27.5q.23 0 .47-.02M44 33.75c0 1.57-.58 3.01-1.54 4.11l-4.64-4.64q.17-.32.18-.72v-1a1.5 1.5 0 0 0-2.74-.84L12.6 8h25.15C41.2 8 44 10.8 44 14.25zM10 15.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 14c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M10 23.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 22c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M10 31.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0z"
]);
const $76e5a570f6bfc30c$export$87f857a151d918c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripOff48Regular', "48", [
    "m38.22 39.98 3.65 3.65a1.25 1.25 0 0 0 1.76-1.76L6.13 4.37a1.25 1.25 0 1 0-1.76 1.76l2.72 2.73A6.3 6.3 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40h27.5q.23 0 .47-.02m-2.49-2.48H10.25a3.75 3.75 0 0 1-3.75-3.75v-19.5c0-1.62 1.02-3 2.46-3.52zM44 33.75c0 1.57-.58 3.01-1.54 4.11l-1.78-1.77c.51-.64.82-1.46.82-2.34v-19.5a3.75 3.75 0 0 0-3.75-3.75H15.1L12.6 8h25.15C41.2 8 44 10.8 44 14.25zm-6-1.25q0 .39-.18.72l-2.56-2.56a1.5 1.5 0 0 1 2.74.84zm-28-17a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 14c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M10 23.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zM36.5 22c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5M10 31.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0z"
]);
const $76e5a570f6bfc30c$export$b7c7084ba3b8efbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay16Filled', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 3zm9 2c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M12 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM3.5 5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M3 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm4-3c0-.39.35-.63.62-.43l2.2 1.56c.24.17.24.57 0 .74l-2.2 1.56c-.27.2-.62-.04-.62-.43z"
]);
const $76e5a570f6bfc30c$export$6a1501fc2a934472 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay16Regular', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 3zM2 5.5C2 4.67 2.67 4 3.5 4h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 2 10.5zM12.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M12 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM3.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M3 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm4-3c0-.39.35-.63.62-.43l2.2 1.56c.24.17.24.57 0 .74l-2.2 1.56c-.27.2-.62-.04-.62-.43z"
]);
const $76e5a570f6bfc30c$export$251e899a744a41d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay20Filled', "20", [
    "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm10.5 2c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-.5 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5-3.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M4 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M4 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm4-1.37c0-.49.46-.79.83-.54l2.94 1.95c.3.2.3.72 0 .92l-2.94 1.95c-.37.25-.83-.05-.83-.54z"
]);
const $76e5a570f6bfc30c$export$6cf8b91ba8a404a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay20Regular', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5zM15.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-.5 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5-3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm4-1.37c0-.49.46-.79.83-.54l2.94 1.95c.3.2.3.72 0 .92l-2.94 1.95c-.37.25-.83-.05-.83-.54z"
]);
const $76e5a570f6bfc30c$export$d1ca33dc4c1cf2a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zm14 3c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75m-.75 8.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zm.75-4.75c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75M4 7.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zM4.75 15c.41 0 .75.34.75.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.41.34-.75.75-.75M4 11.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zm6-2c0-.58.58-.94 1.03-.65l3.68 2.35c.39.24.39.86 0 1.1l-3.68 2.35c-.45.29-1.03-.07-1.03-.65z"
]);
const $76e5a570f6bfc30c$export$a27c7307922006f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75zM18.25 7a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m-.75 8.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zm.75-4.75a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75M5 7.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zM5.75 15a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75M5 11.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zm5-2c0-.58.58-.94 1.03-.65l3.68 2.35c.39.24.39.86 0 1.1l-3.68 2.35c-.45.29-1.03-.07-1.03-.65z"
]);
const $76e5a570f6bfc30c$export$473965e2630026f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay32Filled', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4zM26 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1M5 9a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm8-7.95c0-.81.88-1.31 1.58-.9l5.6 3.27a.9.9 0 0 1 0 1.54l-5.6 3.28c-.7.4-1.58-.1-1.58-.9z"
]);
const $76e5a570f6bfc30c$export$c31895afa231386b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlay32Regular', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4zM4 8.5A2.5 2.5 0 0 1 6.5 6h19A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5h-19A2.5 2.5 0 0 1 4 23.5zM25 8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1M6 9a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm7-7.95c0-.81.88-1.31 1.58-.9l5.6 3.27a.9.9 0 0 1 0 1.54l-5.6 3.28c-.7.4-1.58-.1-1.58-.9z"
]);
const $76e5a570f6bfc30c$export$34e1b7d91ab8399b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit16Filled', "16", [
    "M8.5 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zM1 5.5A2.5 2.5 0 0 1 3.5 3h3v10h-3A2.5 2.5 0 0 1 1 10.5zm2 0v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0M3.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m6 4V3h3A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5zM12 5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0m.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$b6c7d8ced18a9028 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit16Regular', "16", [
    "M8.5 1.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0zM1 5.5A2.5 2.5 0 0 1 3.5 3h3v1h-3C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h3v1h-3A2.5 2.5 0 0 1 1 10.5zM9.5 4V3h3A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-3v-1h3c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM12 5.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M3 5.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM3.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$da16bde0cdf4f5c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit20Filled', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0zM2 7a3 3 0 0 1 3-3h3.5v12H5a3 3 0 0 1-3-3zm2.5-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 13.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m7 7V4H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3zM15 7.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0zm.5 4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0"
]);
const $76e5a570f6bfc30c$export$28e28da34a95fb84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit20Regular', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0zM2 6.5A2.5 2.5 0 0 1 4.5 4h4v1h-4C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4v1h-4A2.5 2.5 0 0 1 2 13.5zM11.5 5V4h4A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-4v-1h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 12.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$d5f69935bee3fee4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit24Filled', "24", [
    "M12.75 2.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0zM2 7.25C2 5.45 3.46 4 5.25 4h5v16h-5A3.25 3.25 0 0 1 2 16.75zM4.75 7a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 4.75 7M4 15.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0M4.75 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m9 9V4h5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25zM18.5 7.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0m.75 7.25a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m-.75-3.25v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-1.5 0"
]);
const $76e5a570f6bfc30c$export$6a2ce1cc5855c8e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit24Regular', "24", [
    "M12.75 2.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0zM2 7.25C2 5.45 3.46 4 5.25 4h5v1.5h-5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h5V20h-5A3.25 3.25 0 0 1 2 16.75zM13.75 5.5V4h5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25h-5v-1.5h5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zm3.75 2.25a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zm.75 7.25a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75m-.75-3.25a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zM5.75 7a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 5.75 7M5 15.75a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-1.5 0zM5.75 11a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$e21d55884d1fc01a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit32Filled', "32", [
    "M17 3a1 1 0 1 0-2 0v26a1 1 0 1 0 2 0zM6.5 4h7v24h-7A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4M6 8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-1 7v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0m1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m19.5 8h-7V4h7A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5M25 9v2a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0m1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m-1 7v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0"
]);
const $76e5a570f6bfc30c$export$bc6553ff332f3021 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplit32Regular', "32", [
    "M17 3a1 1 0 1 0-2 0v26a1 1 0 1 0 2 0zM6.5 4h7v2h-7A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h7v2h-7A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4m19 22h-7v2h7a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4h-7v2h7A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5M24 9a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zM7 8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-1 7a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm1 5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1"
]);
const $76e5a570f6bfc30c$export$f71b752d21405e44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter12Filled', "12", [
    "M1 2.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 1 2.75m2 3c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 3 5.75M5.25 8a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$459560285c710952 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter12Regular', "12", [
    "M1 2.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m2 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$a1d9c6f9c36b71f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter16Filled', "16", [
    "M1.75 3.75c0-.41.34-.75.75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75m2 4c0-.41.34-.75.75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75m2 4c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75"
]);
const $76e5a570f6bfc30c$export$6b88a5b9a6af52e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter16Regular', "16", [
    "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m2 4c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m2 4c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$3853519cfc692f57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter20Filled', "20", [
    "M12.25 13.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm2-4.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zm2-4.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$e0d0afd197196af3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter20Regular', "20", [
    "M7.5 13h5a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1zh5zm-2-4h9a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1zh9zm-2-4h13a.5.5 0 0 1 .09 1H3.5a.5.5 0 0 1-.09-1zh13z"
]);
const $76e5a570f6bfc30c$export$2489ad170938173e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter24Filled', "24", [
    "M10 16h4a1 1 0 0 1 .12 2H10a1 1 0 0 1-.12-2zh4zm-2-5h8a1 1 0 0 1 .12 2H8a1 1 0 0 1-.12-2zh8zM5 6h14a1 1 0 0 1 .12 2H5a1 1 0 0 1-.12-2zh14z"
]);
const $76e5a570f6bfc30c$export$981b3434a7eb27cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter24Regular', "24", [
    "M13.5 16a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zm3-5a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5zm3-5a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$b6bb9a24019a12f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter28Filled', "28", [
    "M17 19a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2zm4-6a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm3-6a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z"
]);
const $76e5a570f6bfc30c$export$b978e78c1c79cd3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter28Regular', "28", [
    "M17.25 19a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5zm4-6a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5zm3-6a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$56b790d3a410fee6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter32Filled', "32", [
    "M3 9.25C3 8.56 3.56 8 4.25 8h23.5a1.25 1.25 0 1 1 0 2.5H4.25C3.56 10.5 3 9.94 3 9.25m4 7c0-.69.56-1.25 1.25-1.25h15.5a1.25 1.25 0 1 1 0 2.5H8.25c-.69 0-1.25-.56-1.25-1.25M12.25 22a1.25 1.25 0 1 0 0 2.5h7.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $76e5a570f6bfc30c$export$e4c28a3c3e7dc278 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter32Light', "32", [
    "M3 8.5c0-.28.22-.5.5-.5h25a.5.5 0 0 1 0 1h-25a.5.5 0 0 1-.5-.5m4 7c0-.28.22-.5.5-.5h17a.5.5 0 0 1 0 1h-17a.5.5 0 0 1-.5-.5m4.5 6.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$c1b080270aa6f7bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Filter32Regular', "32", [
    "M3 9a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m4 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m5 6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$41396978ab60eb8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAdd16Filled', "16", [
    "M8.5 13a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zM6.26 9a5.5 5.5 0 0 0 1.95 1.5H3.5a.75.75 0 0 1 0-1.5zm4.24-8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V5H8.5a.5.5 0 0 0 0 1H10v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H11V3.5a.5.5 0 0 0-.5-.5M5.02 5a6 6 0 0 0 .07 1.5H1.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$5221982de244d9be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAdd16Regular', "16", [
    "M8.5 13a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM6.26 9q.46.58 1.08 1H3.5a.5.5 0 0 1 0-1zm4.24-8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V5H8.5a.5.5 0 0 0 0 1H10v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H11V3.5a.5.5 0 0 0-.5-.5M5.02 5a6 6 0 0 0 0 1H1.5a.5.5 0 0 1 0-1z"
]);
const $76e5a570f6bfc30c$export$8a56d2122ef22424 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAdd20Filled', "20", [
    "M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm-.52-4.25a5.5 5.5 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5zM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5a.5.5 0 0 0-.5-.5M9.02 6q.07.79.36 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$2410ebf6ffc77d5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAdd20Regular', "20", [
    "M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09m2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09m0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.2 7q.15.52.4 1H3.5a.5.5 0 0 1-.09-1H9.2m5.3-4a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$e8a717bc3600c6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAdd24Filled', "24", [
    "M14 16a1 1 0 0 1 .12 2H10a1 1 0 0 1-.12-2H14m-1.98-5q.79 1.22 2.01 2H8a1 1 0 0 1-.12-2h4.14m5.48-9a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a.5.5 0 0 0-.5.5V7h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V8h2.5a.5.5 0 0 0 0-1H18V4.5a.5.5 0 0 0-.5-.5m-6.33 2a7 7 0 0 0-.15 2H5a1 1 0 0 1-.12-2h6.29"
]);
const $76e5a570f6bfc30c$export$5010137b119b8c6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAdd24Regular', "24", [
    "M13.5 16a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zm4-14a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-5.48 9q.54.86 1.33 1.5H7.5a.75.75 0 0 1 0-1.5zm5.48-7a.5.5 0 0 0-.5.5V7h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V8h2.5a.5.5 0 0 0 0-1H18V4.5a.5.5 0 0 0-.5-.5m-6.33 2Q11 6.72 11 7.5H4.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$ed95f5d6c5f8184e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismiss16Filled', "16", [
    "M6.26 9a5.5 5.5 0 0 0 1.95 1.5H3.5a.75.75 0 0 1 0-1.5zM5.02 5a6 6 0 0 0 .07 1.5H1.5a.75.75 0 0 1 0-1.5zm.48 8a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm5-3a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7L11.21 5.5l1.14 1.15a.5.5 0 0 1-.7.7L10.5 6.21 9.35 7.35a.5.5 0 1 1-.7-.7L9.79 5.5 8.65 4.35a.5.5 0 1 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $76e5a570f6bfc30c$export$6ea9ffb57fdb2dfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismiss16Regular', "16", [
    "M6.26 9q.46.58 1.08 1H3.5a.5.5 0 0 1 0-1zM5.02 5a6 6 0 0 0 0 1H1.5a.5.5 0 0 1 0-1zm.48 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5-3a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7L11.21 5.5l1.14 1.15a.5.5 0 0 1-.7.7L10.5 6.21 9.35 7.35a.5.5 0 1 1-.7-.7L9.79 5.5 8.65 4.35a.5.5 0 1 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $76e5a570f6bfc30c$export$ae49e52dc607c41d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismiss20Filled', "20", [
    "M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm-.52-4.25a5.5 5.5 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5zM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.02 6q.07.79.36 1.5H3.75a.75.75 0 0 1 0-1.5zm7.33-2.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$9aaba5f7517b774 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismiss20Regular', "20", [
    "M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09m2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09m0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.2 7q.16.52.4 1H3.5a.5.5 0 0 1-.09-1H9.2m7.15-3.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$5c79080a2af40c0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismiss24Filled', "24", [
    "M23 7.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7L18.21 7.5l1.64-1.65a.5.5 0 0 0-.7-.7L17.5 6.79z",
    "M8 11h4.02q.79 1.22 2.01 2H8a1 1 0 0 1-.12-2z",
    "M5 6h6.17a7 7 0 0 0-.15 2H5a1 1 0 0 1-.12-2z",
    "M9.88 16H14a1 1 0 0 1 .12 2H10a1 1 0 0 1-.12-2"
]);
const $76e5a570f6bfc30c$export$b0c194860acc41d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismiss24Regular', "24", [
    "M23 7.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7L18.21 7.5l1.64-1.65a.5.5 0 0 0-.7-.7L17.5 6.79z",
    "M13.35 12.5a7 7 0 0 1-1.33-1.5H7.5a.75.75 0 0 0 0 1.5z",
    "M11 7.5q0-.78.17-1.5H4.5a.75.75 0 0 0 0 1.5z",
    "M13.5 16a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$706f67061a621923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSync16Filled', "16", [
    "M8.5 13a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zM6.26 9a5.5 5.5 0 0 0 1.95 1.5H3.5a.75.75 0 0 1 0-1.5zm4.24-8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7A2 2 0 0 1 9.52 7H10a.5.5 0 0 0 0-1zM5.02 5a6 6 0 0 0 .07 1.5H1.5a.75.75 0 0 1 0-1.5zm7.48-2.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7A2 2 0 0 1 11.48 4H11a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$ceef474f01b33a51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSync16Regular', "16", [
    "M8.5 13a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM6.26 9q.46.58 1.08 1H3.5a.5.5 0 0 1 0-1zm4.24-8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7A2 2 0 0 1 9.52 7H10a.5.5 0 0 0 0-1zM5.02 5a6 6 0 0 0 0 1H1.5a.5.5 0 0 1 0-1zm7.48-2.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7A2 2 0 0 1 11.48 4H11a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$74de3542cc25b851 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSync20Filled', "20", [
    "M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm-.52-4.25a5.5 5.5 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5zM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7 2 2 0 0 1-2.39.33H14a.5.5 0 0 0 0-1zM9.02 6q.07.79.36 1.5H3.75a.75.75 0 0 1 0-1.5zm7.48-3.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7A2 2 0 0 1 15.48 4H15a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$832c4d4b5d8c2f53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSync20Regular', "20", [
    "M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09m2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09m0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7 2 2 0 0 1-2.39.33H14a.5.5 0 0 0 0-1zM9.2 7q.15.52.4 1H3.5a.5.5 0 0 1-.09-1H9.2m7.3-4.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7A2 2 0 0 1 15.48 4H15a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$5b46f6ad2dbe38d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSync24Filled', "24", [
    "M12 7.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M20.5 4c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4V4.5c0-.28.22-.5.5-.5M15 9.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 1 1 .77.65 3.5 3.5 0 0 1-5.18.19M8 13h6.03c-.8-.51-1.5-1.2-2-2H7.87A1 1 0 0 0 8 13M5 6h6.17a7 7 0 0 0-.15 2H5a1 1 0 0 1-.12-2zm4.88 10H14a1 1 0 0 1 .12 2H10a1 1 0 0 1-.12-2"
]);
const $76e5a570f6bfc30c$export$9cf1dbae722bd5fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSync24Regular', "24", [
    "M12 7.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M20.5 4c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4V4.5c0-.28.22-.5.5-.5M15 9.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 1 1 .77.65 3.5 3.5 0 0 1-5.18.19M7.5 12.5h5.85a7 7 0 0 1-1.33-1.5H7.5a.75.75 0 0 0 0 1.5m3.5-5q0-.78.17-1.5H4.5a.75.75 0 0 0 0 1.5zm2.5 8.5a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$921702df3ff1ee5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fire16Filled', "16", [
    "m4.11 6.19-.02.03-.22.33a5.33 5.33 0 0 0-.74 4.06c.26 1.19.77 2.3 1.65 3.1A5.3 5.3 0 0 0 8.5 15c1.62 0 2.89-.54 3.75-1.47A5 5 0 0 0 13.5 10c0-.86-.28-1.69-.67-2.46-.36-.74-.83-1.47-1.28-2.15l-.07-.1c-.47-.73-.9-1.4-1.19-2.03A2.8 2.8 0 0 1 10 1.6.5.5 0 0 0 9.5 1c-.42 0-1.12.15-1.79.5a3.3 3.3 0 0 0-1.68 1.84c-.4 1.17.06 2.5.44 3.32.17.38.02.79-.26.93a.54.54 0 0 1-.73-.24l-.53-1.07a.5.5 0 0 0-.84-.1"
]);
const $76e5a570f6bfc30c$export$53fd41c27731f152 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fire16Regular', "16", [
    "M8.17 2.38q.42-.21.8-.3.05.82.41 1.59a17 17 0 0 0 1.32 2.25q.71 1.05 1.24 2.06.54 1.05.56 2.02c0 1.15-.34 2.15-.99 2.85a4 4 0 0 1-3 1.15c-1.4 0-2.37-.4-3.05-1.03a4.8 4.8 0 0 1-1-5.43l.13.25c.38.76 1.3 1.07 2.07.7.84-.43 1.08-1.47.72-2.24-.37-.81-.66-1.81-.4-2.6.2-.58.65-1 1.19-1.27M4.1 6.18v.01l-.02.03-.22.33a5.33 5.33 0 0 0-.74 4.06c.26 1.19.77 2.3 1.65 3.1A5.3 5.3 0 0 0 8.5 15c1.62 0 2.89-.54 3.75-1.47A5 5 0 0 0 13.5 10c0-.86-.28-1.69-.67-2.46a21 21 0 0 0-1.35-2.25c-.47-.73-.9-1.4-1.19-2.03A2.8 2.8 0 0 1 10 1.6.5.5 0 0 0 9.5 1c-.42 0-1.12.15-1.79.5a3.3 3.3 0 0 0-1.68 1.84c-.4 1.17.06 2.5.44 3.32.17.38.02.79-.26.93a.54.54 0 0 1-.73-.24l-.53-1.07a.5.5 0 0 0-.84-.1"
]);
const $76e5a570f6bfc30c$export$4a45dc38eb2559b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fire20Filled', "20", [
    "M4 11.75q0-.81.19-1.59a6 6 0 0 1 .86-1.93 1 1 0 0 1 .18-.17.5.5 0 0 1 .48 0q.12.06.18.17l1.04 1.7q.07.12.19.18t.26.07q.27 0 .42-.2a.8.8 0 0 0 .06-.82q-.32-.69-.52-1.36a5 5 0 0 1 .12-3.17q.33-.75.92-1.27.58-.53 1.36-.86A8 8 0 0 1 11.5 2q.18 0 .32.12.18.15.18.38 0 1.17.4 2.23.4 1.07 1.1 2l.87 1.13q.44.57.8 1.19.37.61.6 1.28.22.66.23 1.42a6.5 6.5 0 0 1-.8 3.1 6.6 6.6 0 0 1-2.12 2.27 5.7 5.7 0 0 1-4.71.65 6 6 0 0 1-1.44-.64 6.5 6.5 0 0 1-2.13-2.27 6.2 6.2 0 0 1-.8-3.1"
]);
const $76e5a570f6bfc30c$export$12592b057c4feb02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fire20Regular', "20", [
    "M4 11.75q0-.81.19-1.59a6 6 0 0 1 .86-1.93 1 1 0 0 1 .18-.17.5.5 0 0 1 .48 0q.12.06.18.17l1.04 1.7q.07.12.19.18t.26.07q.27 0 .42-.2a.8.8 0 0 0 .06-.82q-.32-.69-.52-1.36a5 5 0 0 1 .12-3.17q.33-.75.92-1.27.58-.53 1.36-.86A8 8 0 0 1 11.5 2q.18 0 .32.12.18.15.18.38 0 1.17.4 2.23.4 1.07 1.1 2l.87 1.13q.44.57.8 1.19.37.61.6 1.28.22.66.23 1.42a6.5 6.5 0 0 1-.8 3.1 6.6 6.6 0 0 1-2.12 2.27 5.7 5.7 0 0 1-4.71.65 6 6 0 0 1-1.44-.64 6.5 6.5 0 0 1-2.13-2.27 6.2 6.2 0 0 1-.8-3.1m11-.05q0-.6-.23-1.2-.23-.58-.57-1.14a11 11 0 0 0-.75-1.06q-.4-.5-.75-.98a9 9 0 0 1-1.14-1.98 8 8 0 0 1-.54-2.23q-.63.16-1.15.43-.53.27-.92.67t-.6.94q-.2.54-.22 1.22 0 .63.17 1.2.15.57.44 1.13.1.2.15.4l.06.45q0 .33-.11.62a1.54 1.54 0 0 1-2.76.28l-.6-.96a5.45 5.45 0 0 0 1.95 6.77 4.84 4.84 0 0 0 7.2-2.55q.35-.96.37-2.01"
]);
const $76e5a570f6bfc30c$export$dd753f77bb0745a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fire24Filled', "24", [
    "M6.16 9.32zl-.01.02-.13.1q-.11.1-.3.3c-.24.24-.55.62-.83 1.12a7 7 0 0 0-.8 4.55c.27 2 1.1 3.67 2.53 4.83C8.02 21.4 9.94 22 12.25 22c2.39 0 4.3-.9 5.55-2.43a8.4 8.4 0 0 0 1.68-5.86c-.13-2.18-1.31-3.83-2.36-5.29l-.3-.42C15.68 6.4 14.78 4.9 15 2.83a.75.75 0 0 0-.75-.83q-.59.02-1.24.3-.67.27-1.37.8a7 7 0 0 0-2.35 3.15c-.49 1.4-.24 2.74.12 3.71.24.64-.02 1.27-.4 1.46a.7.7 0 0 1-.93-.31l-.81-1.54a.75.75 0 0 0-1.11-.25"
]);
const $76e5a570f6bfc30c$export$7a84d88d33e613ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fire24Regular', "24", [
    "M12.54 4.3q.49-.37.93-.57c.09 2.13 1.13 3.73 2.13 5.14l.27.38c1.08 1.52 2.01 2.82 2.11 4.54a6.9 6.9 0 0 1-1.33 4.83 5.4 5.4 0 0 1-4.4 1.88c-2.06 0-3.61-.53-4.7-1.42a5.8 5.8 0 0 1-1.98-3.87 5.6 5.6 0 0 1 .86-4l.32.6a2.2 2.2 0 0 0 2.9.96c1.3-.62 1.58-2.21 1.17-3.33a4 4 0 0 1-.11-2.7 5.3 5.3 0 0 1 1.83-2.45M6.16 9.31zl-.01.02-.13.1q-.11.1-.3.3c-.24.24-.55.62-.83 1.12a7 7 0 0 0-.8 4.55c.27 2 1.1 3.67 2.53 4.83C8.02 21.4 9.94 22 12.25 22c2.39 0 4.3-.9 5.55-2.43a8.4 8.4 0 0 0 1.68-5.86c-.13-2.18-1.31-3.83-2.36-5.29l-.3-.42C15.68 6.4 14.78 4.9 15 2.83a.75.75 0 0 0-.75-.83q-.59.02-1.24.3-.67.27-1.37.8a7 7 0 0 0-2.35 3.15c-.49 1.4-.24 2.74.12 3.71.24.64-.02 1.27-.4 1.46a.7.7 0 0 1-.93-.31l-.81-1.54a.75.75 0 0 0-1.11-.25"
]);
const $76e5a570f6bfc30c$export$8b89f6b2ba0a941 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace20Filled', "20", [
    "M10 2a7 7 0 0 0-7 7v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a7 7 0 0 0-7-7M4 9a6 6 0 1 1 12 0v5h-3.5c.62-.62 1-1.48 1-2.5 0-1.13-.63-1.97-1.17-2.7l-.13-.16c-.6-.8-1.1-1.57-1.1-2.71a.5.5 0 0 0-.76-.43c-1.4.85-1.45 2.17-1.39 3l-.42-.37a.5.5 0 0 0-.66 0h-.01l-.02.02-.2.22q-.21.23-.47.65c-.34.57-.67 1.4-.67 2.48 0 1.02.38 1.88 1 2.5H4zm-1.5 7a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$b2f72a7c8c534ef2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace20Regular', "20", [
    "M3 9a7 7 0 0 1 14 0v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm7-6a6 6 0 0 0-6 6v5h3.5c-.62-.62-1-1.48-1-2.5a4.9 4.9 0 0 1 1.34-3.35l.02-.01v-.01a.5.5 0 0 1 .65-.02q.03-.42.2-.9c.25-.63.75-1.24 1.65-1.72a.5.5 0 0 1 .74.44c0 1.14.5 1.9 1.1 2.7l.13.18c.54.72 1.17 1.56 1.17 2.69 0 1.02-.38 1.88-1 2.5H16V9a6 6 0 0 0-6-6M8.22 9.25l-.19.28a4 4 0 0 0-.53 1.97c0 1.49 1.1 2.5 2.5 2.5s2.5-1.01 2.5-2.5c0-.79-.43-1.37-1.02-2.16l-.08-.1c-.48-.65-1-1.4-1.21-2.42a2 2 0 0 0-.66 1.88q0 .13.03.23v.05l.03.15q.01.09 0 .25c0 .05-.02.17-.12.28-.12.15-.3.2-.44.2a1 1 0 0 1-.25-.09l-.12-.08-.2-.19zM2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$38348565423f7b5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace24Filled', "24", [
    "M12 2a9 9 0 0 0-9 9v6.25c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V11a9 9 0 0 0-9-9m-7.5 9a7.5 7.5 0 1 1 15 0v5.5h-4.3a4.2 4.2 0 0 0 1.3-3.01c0-1.73-.87-2.78-1.6-3.66l-.07-.09c-.74-.9-1.33-1.65-1.33-2.99a.75.75 0 0 0-.95-.72 2.5 2.5 0 0 0-1.74 1.55c-.23.57-.29 1.2-.33 1.66v.13l-.07.5a3 3 0 0 1-.53-.27.75.75 0 0 0-.89.1l-.01.01-.02.02-.23.25q-.23.26-.5.74a5.6 5.6 0 0 0-.73 2.77c0 1.18.49 2.24 1.3 3.01H4.5zm-1.75 8.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$4b868f16a0f4eb2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace24Regular', "24", [
    "M3 11a9 9 0 0 1 18 0v6.25c0 .41-.34.75-.75.75H3.75a.75.75 0 0 1-.75-.75zm9-7.5A7.5 7.5 0 0 0 4.5 11v5.5h4.3a4.1 4.1 0 0 1-1.3-3.01 5.6 5.6 0 0 1 1.46-3.76l.02-.02L9 9.7a.75.75 0 0 1 1.06.03v-.05l.02-.16c.05-.52.13-1.27.47-1.94a2.9 2.9 0 0 1 2.04-1.56.75.75 0 0 1 .92.73c0 1.34.59 2.1 1.33 3l.07.08c.73.88 1.6 1.93 1.6 3.66 0 1.17-.5 2.24-1.3 3.01h4.3V11A7.5 7.5 0 0 0 12 3.5m-2.47 7.96A4 4 0 0 0 9 13.49c0 1.47 1.23 2.76 3 2.76s3-1.31 3-2.76c0-1.19-.56-1.87-1.32-2.79a6.5 6.5 0 0 1-1.56-2.8q-.14.17-.24.35c-.2.4-.27.89-.32 1.42l-.01.13-.07.62c-.04.19-.1.56-.37.83a1 1 0 0 1-.62.3 1 1 0 0 1-.57-.1l-.3-.16zM2 20.25c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $76e5a570f6bfc30c$export$d00fdbdc0701471b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace32Filled', "32", [
    "M4 14a12 12 0 1 1 24 0v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM16 4A10 10 0 0 0 6 14v9h5.28a6.7 6.7 0 0 1-1.78-4.53 8.5 8.5 0 0 1 1.63-5.03l.32-.37.02-.02v-.01h.01v-.01a1 1 0 0 1 1.14-.2q.77.36 1.07.4.04-.24.06-.7v-.08c.03-.63.08-1.57.49-2.4.47-.98 1.36-1.72 2.82-2.03a1 1 0 0 1 1.2.98c0 2.01.88 3.26 1.9 4.56l.26.3c.95 1.19 2.08 2.6 2.08 4.61 0 1.66-.63 3.3-1.77 4.53H26v-9A10 10 0 0 0 16 4M2 28a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $76e5a570f6bfc30c$export$68e523d42e99791c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace32Regular', "32", [
    "M4 14v10a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V14a12 12 0 0 0-24 0m16.73 9a6.7 6.7 0 0 0 1.77-4.53c0-2.01-1.13-3.42-2.08-4.6l-.25-.31c-1.03-1.3-1.9-2.55-1.9-4.56a1 1 0 0 0-1.21-.98c-1.6.35-2.61 1.11-3.18 2.12-.53.94-.6 1.97-.62 2.67l-.01.28v.12l-.51-.31a1 1 0 0 0-1.26.13l-.01.02-.34.39a8.5 8.5 0 0 0-1.63 5.03c0 1.66.63 3.3 1.78 4.53H6v-9a10 10 0 0 1 20 0v9zM16 23c-2.76 0-4.5-2.2-4.5-4.53a6.5 6.5 0 0 1 .95-3.42q.35.18.65.28c.42.13 1.06.2 1.57-.26.42-.38.5-.92.53-1.19a10 10 0 0 0 .05-1c.03-.68.1-1.27.37-1.76q.2-.39.76-.75a9.5 9.5 0 0 0 2.22 4.43l.17.22c1.04 1.3 1.73 2.17 1.73 3.45A4.44 4.44 0 0 1 16 23M2 28a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $76e5a570f6bfc30c$export$37210b5f91047895 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace48Filled', "48", [
    "M24 4A18 18 0 0 0 6 22v13.25c0 .69.56 1.25 1.25 1.25h33.5c.69 0 1.25-.56 1.25-1.25V22A18 18 0 0 0 24 4M8.5 22a15.5 15.5 0 0 1 31 0v12h-9.13a8.8 8.8 0 0 0 3.13-6.75c0-2.89-1.7-4.93-3.15-6.68l-.38-.46c-1.6-1.94-2.97-3.85-2.97-6.86a1.25 1.25 0 0 0-1.54-1.22c-2.16.53-3.43 1.68-4.12 3.11a10 10 0 0 0-.75 3.8V19q-.02.6-.06.97a9 9 0 0 1-1.35-.77 1.25 1.25 0 0 0-1.53.13l-.02.02-.15.15-.37.41q-.47.54-1.07 1.54a11.6 11.6 0 0 0-1.54 5.8A8.8 8.8 0 0 0 17.64 34H8.5zM5.25 39.5a1.25 1.25 0 1 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $76e5a570f6bfc30c$export$2fda3e65bbfe0219 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fireplace48Regular', "48", [
    "M6 22a18 18 0 0 1 36 0v13.25c0 .69-.56 1.25-1.25 1.25H7.25c-.69 0-1.25-.56-1.25-1.25zM24 6.5A15.5 15.5 0 0 0 8.5 22v12h9.14a8.8 8.8 0 0 1-3.14-6.75 11.6 11.6 0 0 1 3.1-7.86l.03-.04.01-.01h.01c.44-.42 1.06-.45 1.54-.13q.68.44 1.05.62l.03-.6v-.35c.04-1.02.13-2.48.84-3.82.75-1.41 2.12-2.52 4.36-3.03A1.25 1.25 0 0 1 27 13.25c0 3.01 1.37 4.92 2.97 6.86l.38.46c1.46 1.75 3.15 3.79 3.15 6.68A8.8 8.8 0 0 1 30.37 34h9.13V22A15.5 15.5 0 0 0 24 6.5m-5.8 16.2a9 9 0 0 0-1.2 4.55c0 3.4 2.75 6.5 7 6.5s7-3.1 7-6.5c0-1.95-1.11-3.3-2.69-5.22l-.28-.34c-1.4-1.7-2.96-3.75-3.4-6.72-.69.36-1.07.82-1.31 1.27a6 6 0 0 0-.55 3c-.02.4-.03.83-.07 1.2-.05.39-.17 1.1-.72 1.6-.67.6-1.5.52-2.09.34a6 6 0 0 1-1.14-.51q-.26.34-.54.83M4 40.75c0-.69.56-1.25 1.25-1.25h37.5a1.25 1.25 0 1 1 0 2.5H5.25C4.56 42 4 41.44 4 40.75"
]);
const $76e5a570f6bfc30c$export$a5068deb17ce9725 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention12Filled', "12", [
    "M2 6a4 4 0 1 1 8 0c0 1.17-.59 1.47-.8 1.48-.1 0-.24-.03-.39-.22-.15-.2-.31-.59-.31-1.26V3.75a.75.75 0 0 0-1.4-.37Q6.5 3.01 5.75 3C4.15 3 3 4.43 3 6s1.15 3 2.75 3c.75 0 1.4-.31 1.88-.81.42.54 1.02.82 1.66.79C10.6 8.9 11.5 7.63 11.5 6a5.5 5.5 0 1 0-4.05 5.3.75.75 0 0 0-.4-1.44A4 4 0 0 1 2 6m5 0c0 .91-.64 1.5-1.25 1.5S4.5 6.91 4.5 6s.64-1.5 1.25-1.5S7 5.09 7 6",
    "M0 0h12v12H0z"
]);
const $76e5a570f6bfc30c$export$88b79544bd424199 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention12Regular', "12", [
    "M2 6a4 4 0 1 1 8 0c0 1.04-.6 1.47-1.03 1.5a.8.8 0 0 1-.62-.28C8.16 7 8 6.62 8 6V4a.5.5 0 0 0-1-.08 2 2 0 0 0-1.25-.42C4.45 3.5 3.5 4.68 3.5 6s.95 2.5 2.25 2.5c.69 0 1.28-.33 1.68-.84l.16.2c.38.45.9.66 1.44.63C10.1 8.44 11 7.46 11 6a5 5 0 1 0-3.33 4.72.5.5 0 0 0-.34-.95A4 4 0 0 1 2 6m5 0c0 .9-.62 1.5-1.25 1.5S4.5 6.9 4.5 6s.62-1.5 1.25-1.5S7 5.1 7 6"
]);
const $76e5a570f6bfc30c$export$68eb04a0f574e27e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention16Filled', "16", [
    "M8 1a7 7 0 0 1 7 7l-.01.39c-.14 1.9-1.28 3.17-2.74 3.17a2.5 2.5 0 0 1-2.1-1.2 3.1 3.1 0 0 1-2.4 1.14C5.89 11.5 4.5 9.86 4.5 8s1.39-3.5 3.25-3.5q1.01.01 1.77.57a.75.75 0 0 1 1.48.18V8c0 1.63.81 2.06 1.25 2.06.41 0 1.15-.38 1.24-1.77L13.5 8a5.5 5.5 0 1 0-3.68 5.19c.31-.11.66-.05.9.18.36.36.28.98-.2 1.16Q9.32 15 8 15A7 7 0 0 1 8 1m-.25 5C6.85 6 6 6.83 6 8s.85 2 1.75 2S9.5 9.17 9.5 8s-.85-2-1.75-2"
]);
const $76e5a570f6bfc30c$export$1be6448adb54a2f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention16Regular', "16", [
    "M8 1a7 7 0 0 1 7 7c0 2.13-1.1 3.5-2.5 3.5-.89 0-1.65-.55-2.1-1.49a3.2 3.2 0 0 1-2.65 1.49C5.92 11.5 4.5 9.9 4.5 8s1.42-3.5 3.25-3.5c.89 0 1.67.37 2.25.97V5a.5.5 0 0 1 1 0v3c0 1.87.9 2.5 1.5 2.5S14 9.87 14 8a6 6 0 1 0-3.75 5.56c.2-.08.44-.04.6.11.24.24.18.65-.14.79Q9.45 14.99 8 15A7 7 0 0 1 8 1m-.25 4.5C6.55 5.5 5.5 6.58 5.5 8s1.05 2.5 2.25 2.5S10 9.42 10 8 8.95 5.5 7.75 5.5"
]);
const $76e5a570f6bfc30c$export$aeb08e58875424b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8c0 2.48-1.49 4-3.25 4a3 3 0 0 1-2.56-1.44A3.3 3.3 0 0 1 9.5 14C7.45 14 6 12.09 6 10s1.45-4 3.5-4c.76 0 1.45.27 2 .71a.75.75 0 0 1 1.5.04V10c0 1.86 1.01 2.5 1.75 2.5s1.75-.64 1.75-2.5a6.5 6.5 0 1 0-4.56 6.2c.3-.09.63-.03.85.2.38.37.27 1.01-.23 1.18Q11.35 18 10 18a8 8 0 0 1 0-16m-.5 5.5c-1 0-2 1-2 2.5s1 2.5 2 2.5 2-1 2-2.5-1-2.5-2-2.5"
]);
const $76e5a570f6bfc30c$export$5f7bfcafc5778212 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8c0 2.5-1.38 4-3 4-1.07 0-2.04-.66-2.57-1.82A3.4 3.4 0 0 1 9.5 14c-2 0-3.5-1.87-3.5-4s1.5-4 3.5-4c1 0 1.88.47 2.5 1.2v-.7a.5.5 0 0 1 1 0V10l.01.39c.13 1.87 1.17 2.6 1.99 2.6.88 0 2-.83 2-2.99a7 7 0 1 0-4.71 6.61q.32-.1.56.13c.25.25.17.67-.16.8Q11.42 18 10 18a8 8 0 0 1 0-16m-.5 5C8.19 7 7 8.27 7 10s1.19 3 2.5 3 2.5-1.27 2.5-3-1.19-3-2.5-3"
]);
const $76e5a570f6bfc30c$export$217e057e3eaf2636 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention24Filled', "24", [
    "M12 2a10 10 0 0 1 10 10c0 3.06-1.8 5-4 5a3.7 3.7 0 0 1-3.1-1.72c-.8 1.04-2 1.72-3.4 1.72C8.9 17 7 14.63 7 12s1.9-5 4.5-5c.95 0 1.8.32 2.51.85A1 1 0 0 1 16 8v4c0 2.29 1.2 3 2 3s2-.71 2-3a8 8 0 1 0-5.42 7.57c.4-.14.87-.06 1.17.25.5.49.37 1.32-.28 1.56Q13.84 22 12 22a10 10 0 0 1 0-20m-.5 7C10.24 9 9 10.21 9 12s1.24 3 2.5 3 2.5-1.21 2.5-3-1.24-3-2.5-3"
]);
const $76e5a570f6bfc30c$export$524768bee4149bf2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention24Regular', "24", [
    "M12 2a10 10 0 0 1 10 10c0 3.09-1.68 5.03-3.75 5.03-1.3 0-2.44-.76-3.11-2.09A4.3 4.3 0 0 1 11.5 17C8.93 17 7 14.67 7 12s1.93-5 4.5-5c1.18 0 2.22.49 3 1.27v-.52a.75.75 0 0 1 1.5 0V12c0 2.61 1.32 3.53 2.25 3.53S20.5 14.6 20.5 12a8.5 8.5 0 1 0-5.6 8c.29-.11.63-.05.85.17.37.37.27 1-.22 1.19q-1.66.63-3.53.64a10 10 0 0 1 0-20m-.5 6.5c-1.57 0-3 1.48-3 3.5s1.43 3.5 3 3.5 3-1.48 3-3.5-1.43-3.5-3-3.5"
]);
const $76e5a570f6bfc30c$export$5741419c05d752c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention28Filled', "28", [
    "M14 2a12 12 0 0 1 12 12c0 3.64-2 5.97-4.5 5.97-1.5 0-2.83-.85-3.64-2.31A5.3 5.3 0 0 1 13.5 20C10.37 20 8 17.21 8 14s2.37-6 5.5-6c1.35 0 2.56.52 3.5 1.37V9a1 1 0 1 1 2 0v5c0 3 1.5 3.97 2.5 3.97S24 17 24 14a10 10 0 1 0-6.51 9.37c.4-.15.86-.07 1.17.24.49.49.36 1.31-.28 1.56Q16.32 26 14 26a12 12 0 0 1 0-24m-.5 8c-1.84 0-3.5 1.69-3.5 4s1.66 4 3.5 4 3.5-1.69 3.5-4-1.66-4-3.5-4"
]);
const $76e5a570f6bfc30c$export$e0032ef086a2c2a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention28Regular', "28", [
    "M14 2a12 12 0 0 1 12 12c0 3.7-1.9 6-4.25 6-1.55 0-2.9-1-3.64-2.73A5.4 5.4 0 0 1 13.5 20C10.4 20 8 17.24 8 14s2.4-6 5.5-6c1.6 0 3 .73 4 1.88V8.75a.75.75 0 0 1 1.5 0v5.55c.1 3.07 1.64 4.2 2.75 4.2 1.15 0 2.75-1.2 2.75-4.5a10.5 10.5 0 1 0-6.47 9.7.8.8 0 0 1 .88.16c.36.36.27.98-.2 1.18q-2.19.95-4.71.96a12 12 0 0 1 0-24m-.5 7.5c-2.14 0-4 1.94-4 4.5s1.86 4.5 4 4.5 4-1.94 4-4.5-1.86-4.5-4-4.5"
]);
const $76e5a570f6bfc30c$export$2d56814b3d11338c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention32Filled', "32", [
    "M16 2a14 14 0 0 1 14 14v.01c0 4.23-2.3 7.01-5.25 7.01a4.8 4.8 0 0 1-4.2-2.62A6.3 6.3 0 0 1 15.5 23C11.8 23 9 19.76 9 16s2.8-7 6.5-7c1.53 0 2.91.56 4 1.48v-.23a1.25 1.25 0 1 1 2.5 0V16c0 3.46 1.71 4.52 2.75 4.52S27.5 19.46 27.5 16v-.01A11.5 11.5 0 1 0 19 27.1a1.4 1.4 0 0 1 1.37.34c.65.65.44 1.74-.44 2A14 14 0 1 1 16 2m-.5 9.5c-2.1 0-4 1.9-4 4.5s1.9 4.5 4 4.5 4-1.9 4-4.5-1.9-4.5-4-4.5"
]);
const $76e5a570f6bfc30c$export$81da7ac0f50f69e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention32Light', "32", [
    "M16 2a14 14 0 0 1 13.98 14.62v.23l-.01.06v.02a8.4 8.4 0 0 1-1.31 4.23A3.9 3.9 0 0 1 25.5 23c-1.2 0-2.34-.65-3.16-1.84q-.61-.88-.97-2.16a6.5 6.5 0 0 1-5.87 4C11.87 23 9 19.83 9 16s2.87-7 6.5-7a6.4 6.4 0 0 1 5.5 3.27V9.5a.5.5 0 0 1 1 0V16c0 2.1.48 3.61 1.16 4.59.68.97 1.53 1.4 2.34 1.4s1.66-.43 2.34-1.4C28.52 19.6 29 18.09 29 16v-.01a13 13 0 1 0-8.12 12.06c.2-.08.42-.04.57.11.24.25.17.67-.16.8A14 14 0 1 1 16 2m-.5 8c-3 0-5.5 2.65-5.5 6s2.5 6 5.5 6 5.5-2.65 5.5-6-2.5-6-5.5-6"
]);
const $76e5a570f6bfc30c$export$19096d3829594640 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention32Regular', "32", [
    "M16 2a14 14 0 0 1 14 14v.01c0 4.26-2.2 6.99-5 6.99-1.77 0-3.3-1.1-4.19-2.97A6.3 6.3 0 0 1 15.5 23C11.83 23 9 19.78 9 16s2.83-7 6.5-7c1.77 0 3.34.75 4.5 1.95V10a1 1 0 1 1 2 0v6c0 3.73 1.8 5 3 5s3-1.27 3-5v-.02a12 12 0 1 0-8.45 11.48 1.1 1.1 0 0 1 1.1.26c.51.51.35 1.38-.34 1.6Q18.27 30 16 30a14 14 0 1 1 0-28m-.5 9c-2.4 0-4.5 2.15-4.5 5s2.1 5 4.5 5 4.5-2.15 4.5-5-2.1-5-4.5-5"
]);
const $76e5a570f6bfc30c$export$656fe219221644c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention48Filled', "48", [
    "M7 24a17 17 0 0 1 34 0c0 5.14-2.63 7.01-4.52 7.03C34.64 31.05 32 29.28 32 24v-8.5a1.5 1.5 0 0 0-3 0v1.04A8.4 8.4 0 0 0 23 14c-5.14 0-9 4.66-9 10s3.86 10 9 10a8.7 8.7 0 0 0 7.27-4.1c1.35 2.65 3.64 4.16 6.25 4.13C40.63 34 44 30.11 44 24a20 20 0 1 0-12.97 18.73 1.5 1.5 0 1 0-1.06-2.8A17 17 0 0 1 7 24m22 0c0 4.05-2.86 7-6 7s-6-2.95-6-7 2.86-7 6-7 6 2.95 6 7"
]);
const $76e5a570f6bfc30c$export$2537c8e30f5b8254 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mention48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 1 35 0c0 5.65-2.73 7.6-4.72 7.56C34.73 31.52 32 29.38 32 24v-8.75a1.25 1.25 0 1 0-2.5 0v1.83A8.5 8.5 0 0 0 23 14c-5.1 0-9 4.62-9 10s3.9 10 9 10a8.8 8.8 0 0 0 7.55-4.56c1.28 2.88 3.58 4.57 6.17 4.62C40.73 34.15 44 30.35 44 24a20 20 0 1 0-12.8 18.66 1.25 1.25 0 1 0-.9-2.33A17.5 17.5 0 0 1 6.5 24m23 0c0 4.29-3.05 7.5-6.5 7.5s-6.5-3.21-6.5-7.5 3.05-7.5 6.5-7.5 6.5 3.21 6.5 7.5"
]);
const $76e5a570f6bfc30c$export$cdaf79f1c05b86dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionArrowDown20Filled', "20", [
    "M3.02 10.41q.7.35 1.48.5V11a6.5 6.5 0 0 0 8.44 6.2c.3-.09.63-.03.85.2.38.37.27 1.01-.23 1.18Q12.35 19 11 19a8 8 0 0 1-7.98-8.59M11 3a8 8 0 0 1 8 8c0 2.48-1.49 4-3.25 4a3 3 0 0 1-2.56-1.44A3.3 3.3 0 0 1 10.5 15C8.45 15 7 13.09 7 11v-.21q.91-.26 1.67-.8-.17.45-.17 1.01c0 1.5 1 2.5 2 2.5s2-1 2-2.5-1-2.5-2-2.5q-.23 0-.43.06.47-.7.72-1.55.98.1 1.71.7a.75.75 0 0 1 1.5.04V11c0 1.86 1.01 2.5 1.75 2.5s1.75-.64 1.75-2.5A6.5 6.5 0 0 0 11 4.5h-.1a6 6 0 0 0-.49-1.48zM5.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5v2.8L3.85 5.14a.5.5 0 1 0-.7.7l2 2A.5.5 0 0 0 5.5 8a.5.5 0 0 0 .35-.15l2-2a.5.5 0 1 0-.7-.7L6 6.29V3.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$deffbad6ddb612c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionArrowDown20Regular', "20", [
    "M3.02 10.41q.47.24.98.38V11a7 7 0 0 0 9.29 6.61q.32-.1.56.13c.25.25.17.67-.16.8Q12.42 19 11 19a8 8 0 0 1-7.98-8.59M11 3a8 8 0 0 1 8 8c0 2.5-1.38 4-3 4-1.07 0-2.04-.66-2.57-1.82A3.4 3.4 0 0 1 10.5 15c-2 0-3.5-1.87-3.5-4v-.21q.55-.16 1.05-.42-.05.3-.05.63c0 1.73 1.19 3 2.5 3s2.5-1.27 2.5-3-1.19-3-2.5-3h-.1q.24-.46.39-.99A3.3 3.3 0 0 1 13 8.2v-.7a.5.5 0 0 1 1 0V11l.01.39c.13 1.87 1.17 2.6 1.99 2.6.88 0 2-.83 2-2.99a7 7 0 0 0-7-7h-.2q-.15-.51-.39-.98zM5.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5v2.8L3.85 5.14a.5.5 0 1 0-.7.7l2 2A.5.5 0 0 0 5.5 8a.5.5 0 0 0 .35-.15l2-2a.5.5 0 1 0-.7-.7L6 6.29V3.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$f04b5e7d82baf3a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionBrackets20Filled', "20", [
    "M4.75 2A2.75 2.75 0 0 0 2 4.75v10.5A2.75 2.75 0 0 0 4.75 18h1.5a.75.75 0 0 0 0-1.5h-1.5c-.69 0-1.25-.56-1.25-1.25V4.75c0-.69.56-1.25 1.25-1.25h1.5a.75.75 0 0 0 0-1.5zm7 5.25c.41 0 .75.34.75.75v2.75a.75.75 0 0 0 1.5 0V10a4 4 0 1 0-4.24 4 4 4 0 0 0 1.29-.13c.35-.1.75.05.89.39.17.43-.03.93-.47 1.05q-.69.2-1.47.19a5.5 5.5 0 1 1 5.5-5.5v.75q-.01.7-.37 1.24l-.13.3v-.13a2.25 2.25 0 0 1-3.58-.1q-.62.43-1.42.44a2.5 2.5 0 1 1 1.05-4.77c.1-.28.38-.48.7-.48M10 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8-4.25A2.75 2.75 0 0 0 15.25 2h-1.5a.75.75 0 0 0 0 1.5h1.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25h-1.5a.75.75 0 0 0 0 1.5h1.5A2.75 2.75 0 0 0 18 15.25z"
]);
const $76e5a570f6bfc30c$export$554dfc3bb2f682f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionBrackets20Regular', "20", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-11A2.5 2.5 0 0 1 4.5 2h2a.5.5 0 0 1 0 1zm11 14c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 18 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 0 1 0-1zm-4-7a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M10 7.5q.86.02 1.5.5a.5.5 0 0 1 1 0v2.75a.75.75 0 0 0 1.5 0V10a4 4 0 1 0-4.24 4h.02a4 4 0 0 0 1.58-.23c.3-.1.64.11.64.43 0 .23-.14.45-.36.53A5 5 0 1 1 15 10v.75a1.75 1.75 0 0 1-3.2.98A2.5 2.5 0 0 1 7.5 10 2.5 2.5 0 0 1 10 7.5"
]);
const $76e5a570f6bfc30c$export$e7ebc5f0a27d39a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Paw16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_16_color__a)",
            "d": "M8 7a5 5 0 0 0-5 5c0 1.3 1.21 2 2.29 2h5.42c1.08 0 2.29-.7 2.29-2a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_16_color__b)",
            "d": "M8.5 3.88c0-.94.64-1.88 1.63-1.88s1.62.94 1.62 1.88-.64 1.87-1.62 1.87c-1 0-1.63-.94-1.63-1.87m-6.12.37c-1 0-1.63.94-1.63 1.88S1.39 8 2.38 8 4 7.06 4 6.13s-.64-1.88-1.62-1.88m11.25 0c-1 0-1.63.94-1.63 1.88S12.64 8 13.63 8s1.62-.94 1.62-1.87-.64-1.88-1.62-1.88M5.87 2c-.98 0-1.62.94-1.62 1.88s.64 1.87 1.63 1.87S7.5 4.81 7.5 3.88 6.86 2 5.88 2"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -7.71429 11.6 0 8.4 8.43)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_16_color__a",
                "x1": "5.38",
                "x2": "8.29",
                "y1": "7.93",
                "y2": "14.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$fbf2858be966c745 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Paw20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_20_color__a)",
            "fillRule": "evenodd",
            "d": "M4 14a6 6 0 0 1 12 0c0 .99-.5 1.75-1.21 2.25-.7.5-1.6.75-2.48.75H7.69c-.88 0-1.78-.25-2.48-.75A2.7 2.7 0 0 1 4 14",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_20_color__b)",
            "fillRule": "evenodd",
            "d": "M5.5 4.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M3 4.5c-1.17 0-2 1.08-2 2.25S1.83 9 3 9s2-1.08 2-2.25S4.17 4.5 3 4.5m12 2.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25m-4.5-2.5c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -9 14.4 0 10.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_20_color__a",
                "x1": "6.85",
                "x2": "10.78",
                "y1": "9.2",
                "y2": "17.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$9f8afd9c1595246a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Paw24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_24_color__a)",
            "d": "M12 10a7 7 0 0 0-7 7 3.6 3.6 0 0 0 1.7 3.04c.96.65 2.2.96 3.38.96h3.84c1.18 0 2.42-.31 3.38-.96A3.6 3.6 0 0 0 19 17a7 7 0 0 0-7-7"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_24_color__b)",
            "d": "M6.25 5.25c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S10.22 8 8.75 8s-2.5-1.33-2.5-2.75M1 8.75C1 7.33 2.03 6 3.5 6S6 7.33 6 8.75 4.97 11.5 3.5 11.5 1 10.17 1 8.75m11.75-3.5c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S16.72 8 15.25 8s-2.5-1.33-2.5-2.75M18 8.75C18 7.33 19.03 6 20.5 6S23 7.33 23 8.75s-1.03 2.75-2.5 2.75S18 10.17 18 8.75"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11.5714 17.6 0 12.61 12.14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_24_color__a",
                "x1": "8.33",
                "x2": "13.27",
                "y1": "11.46",
                "y2": "21.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$41ad0100ae1919c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Paw28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_28_color__a)",
            "d": "M14 11a8 8 0 0 0-7.98 8.5 4.3 4.3 0 0 0 2.17 3.45A8 8 0 0 0 12.21 24h3.58a8 8 0 0 0 4.02-1.05A4.3 4.3 0 0 0 22 19a8 8 0 0 0-8-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_28_color__b)",
            "d": "M14.75 6.25c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25-2.88-1.57-2.88-3.25m-13.5 3.5c0-1.68 1.18-3.25 2.88-3.25S7 8.07 7 9.75 5.82 13 4.13 13s-2.88-1.57-2.88-3.25m19.75 0c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25S25.57 13 23.88 13 21 11.43 21 9.75M7.5 6.25C7.5 4.57 8.68 3 10.38 3s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25S7.5 7.93 7.5 6.25"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -12.8571 20.4 0 14.7 13.71)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_28_color__a",
                "x1": "9.8",
                "x2": "15.76",
                "y1": "12.73",
                "y2": "24.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$a31b684bc73bffd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Paw32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_32_color__a)",
            "d": "M16 13a9 9 0 0 0-8.98 9.68 5.2 5.2 0 0 0 2.7 4.12 9.7 9.7 0 0 0 4.83 1.2h2.9a9.7 9.7 0 0 0 4.82-1.2A5.2 5.2 0 0 0 25 22a9 9 0 0 0-9-9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_32_color__b)",
            "d": "M8.5 6.75C8.5 4.88 9.78 3 11.75 3S15 4.88 15 6.75s-1.28 3.75-3.25 3.75S8.5 8.62 8.5 6.75m8.5 0C17 4.88 18.28 3 20.25 3s3.25 1.88 3.25 3.75-1.28 3.75-3.25 3.75S17 8.62 17 6.75m7 4.5c0-1.87 1.28-3.75 3.25-3.75s3.25 1.88 3.25 3.75S29.22 15 27.25 15 24 13.12 24 11.25m-22.5 0c0-1.87 1.28-3.75 3.25-3.75S8 9.38 8 11.25 6.72 15 4.75 15 1.5 13.12 1.5 11.25"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -15.4286 23.2 0 16.8 15.86)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_32_color__a",
                "x1": "11.28",
                "x2": "18.25",
                "y1": "14.99",
                "y2": "28.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$961cd2de55278f5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Paw48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_48_color__a)",
            "d": "M10 34a14 14 0 1 1 28 .5 7 7 0 0 1-3.36 5.7 12 12 0 0 1-6.47 1.8h-8.34c-2.26 0-4.62-.59-6.47-1.8A7 7 0 0 1 10 34"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_48_color__b)",
            "d": "M18.25 6c-2.84 0-4.75 2.7-4.75 5.5s1.91 5.5 4.75 5.5S23 14.3 23 11.5 21.09 6 18.25 6M3 17.5C3 14.7 4.91 12 7.75 12s4.75 2.7 4.75 5.5S10.59 23 7.75 23 3 20.3 3 17.5m22.5-6c0-2.8 1.91-5.5 4.75-5.5S35 8.7 35 11.5 33.09 17 30.25 17s-4.75-2.7-4.75-5.5m10 6c0-2.8 1.91-5.5 4.75-5.5S45 14.7 45 17.5 43.09 23 40.25 23s-4.75-2.7-4.75-5.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -21.8571 33.6 0 25.17 24.21)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_48_color__a",
                "x1": "16.66",
                "x2": "26.53",
                "y1": "22.92",
                "y2": "42.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$b89a7b21ab56c550 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People12Filled', "12", [
    "M6.15 7A1.5 1.5 0 0 1 7.5 8.5c0 .77-.47 1.4-1.1 1.83-.64.42-1.49.67-2.4.67s-1.76-.25-2.4-.67S.5 9.27.5 8.5C.5 7.67 1.17 7 2 7h4.15M10 7c.83 0 1.5.67 1.5 1.5 0 .7-.43 1.21-.98 1.53a4 4 0 0 1-2.02.47q-.38 0-.74-.06c.43-.5.74-1.16.74-1.94Q8.48 7.64 8 7zM4 1.5A2.25 2.25 0 1 1 4 6a2.25 2.25 0 0 1 0-4.5m4.75 1a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"
]);
const $76e5a570f6bfc30c$export$d18b3e7c0b749e9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People12Regular', "12", [
    "M6.15 7A1.5 1.5 0 0 1 7.5 8.5c0 .77-.47 1.4-1.1 1.83-.64.42-1.49.67-2.4.67s-1.76-.25-2.4-.67S.5 9.27.5 8.5C.5 7.67 1.17 7 2 7h4.15M10 7c.83 0 1.5.67 1.5 1.5 0 .7-.43 1.21-.99 1.53a4 4 0 0 1-2.01.47q-.38 0-.74-.05.36-.42.56-.95h.18q.96-.01 1.52-.34c.35-.2.48-.43.48-.66A.5.5 0 0 0 10 8H8.45q-.12-.55-.46-1zM2 8a.5.5 0 0 0-.5.5c0 .33.2.7.66 1 .45.3 1.1.5 1.84.5s1.4-.2 1.84-.5c.46-.3.66-.67.66-1a.5.5 0 0 0-.4-.49L6 8zm2.23-6.5a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 4 6L3.77 6a2.25 2.25 0 0 1-2-2.01l-.02-.23c0-1.24 1-2.25 2.25-2.25zm4.52 1a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5M4 2.5A1.25 1.25 0 1 0 4 5a1.25 1.25 0 0 0 0-2.5m4.75 1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$558a0d6536e3fb3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_16_color__a)",
            "d": "M10.04 12.26q.56.23 1.46.24a4 4 0 0 0 1.46-.23c1.54-.59 1.54-2.04 1.54-2.04 0-.68-.55-1.23-1.23-1.23H9.73c-.68 0-1.23.55-1.23 1.22 0 0 0 1.46 1.54 2.04"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_16_color__b)",
            "fillOpacity": ".5",
            "d": "M10.04 12.26q.56.23 1.46.24a4 4 0 0 0 1.46-.23c1.54-.59 1.54-2.04 1.54-2.04 0-.68-.55-1.23-1.23-1.23H9.73c-.68 0-1.23.55-1.23 1.22 0 0 0 1.46 1.54 2.04"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_16_color__c)",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_16_color__d)",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_16_color__e)",
            "d": "M11.5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_16_color__f)",
            "d": "M8 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_16_color__a",
                "x1": "9.93",
                "x2": "11.2",
                "y1": "9.47",
                "y2": "12.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_16_color__c",
                "x1": "3.4",
                "x2": "5",
                "y1": "9.6",
                "y2": "14.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_16_color__d",
                "x1": "5.5",
                "x2": "7.75",
                "y1": "8.46",
                "y2": "15.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_16_color__e",
                "x1": "10.45",
                "x2": "12.49",
                "y1": "4.53",
                "y2": "7.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_16_color__f",
                "x1": "4.19",
                "x2": "6.74",
                "y1": "3.66",
                "y2": "7.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.9472 -.51042 .5289 4.09009 7.74 10.75)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$1ea9c17aed45d0bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People16Filled', "16", [
    "M7.5 9a2 2 0 0 1 2 2c0 .97-.6 1.73-1.41 2.23-.82.5-1.91.77-3.09.77a6 6 0 0 1-3.09-.77C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zm6.65 0a1.5 1.5 0 0 1 1.35 1.5c0 .77-.47 1.4-1.1 1.83-.64.42-1.49.67-2.4.67a5 5 0 0 1-1.92-.4q.4-.7.42-1.6c0-.76-.29-1.45-.75-1.98L10 9h4.15M5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m7 1A2.25 2.25 0 1 1 12 8a2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$e6bf6b8009baabd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People16Regular', "16", [
    "M7.5 9a2 2 0 0 1 2 2c0 .97-.6 1.73-1.41 2.23-.82.5-1.91.77-3.09.77a6 6 0 0 1-3.09-.77C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zm-5 1a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 13 5 13s1.94-.24 2.57-.62q.94-.6.93-1.38a1 1 0 0 0-1-1zm11.65-1a1.5 1.5 0 0 1 1.35 1.5c0 .77-.47 1.4-1.1 1.83-.64.42-1.49.67-2.4.67a5 5 0 0 1-1.92-.4q.24-.43.35-.95.66.33 1.57.35c.74 0 1.4-.2 1.84-.5.46-.3.66-.67.66-1a.5.5 0 0 0-.4-.49L14 10h-3.67a3 3 0 0 0-.58-.98L10 9h4.15m-1.92-5.5a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 12 8L11.77 8a2.25 2.25 0 0 1-2-2.01l-.02-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m7 2A1.25 1.25 0 1 0 12 7a1.25 1.25 0 0 0 0-2.5m-7-1A1.75 1.75 0 1 0 5 7a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$2eaf00c7110c34f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__a)",
            "d": "M10.5 12.5c0-.83.68-1.5 1.52-1.5h4.96c.84 0 1.52.67 1.52 1.5 0 0 0 3-4 3s-4-3-4-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__b)",
            "fillOpacity": ".5",
            "d": "M10.5 12.5c0-.83.68-1.5 1.52-1.5h4.96c.84 0 1.52.67 1.52 1.5 0 0 0 3-4 3s-4-3-4-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__c)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__d)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__e)",
            "d": "M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__f)",
            "d": "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__a",
                "x1": "12.4",
                "x2": "14",
                "y1": "11.6",
                "y2": "16.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__c",
                "x1": "4",
                "x2": "6.15",
                "y1": "11.8",
                "y2": "17.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__d",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "10.29",
                "y2": "20.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__e",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "5.66",
                "y2": "9.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__f",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "4.36",
                "y2": "9.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-7.1 111.45 -69.77)scale(5.30556)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$4c1eb028cb61c520 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People20Filled', "20", [
    "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5m5.69 5.14q.78.35 2.06.36c4 0 4-3 4-3 0-.83-.67-1.5-1.5-1.5h-4.63q.62.74.63 1.75v.36l-.02.25a5 5 0 0 1-.54 1.78M17 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4m11.5.1v.07Z"
]);
const $76e5a570f6bfc30c$export$f601acea165a38c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People20Regular', "20", [
    "M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m5.69 11.65q.79.33 2.06.35c1.88 0 2.92-.67 3.47-1.43a3 3 0 0 0 .53-1.5v-.07c0-.83-.67-1.5-1.5-1.5h-4.63q.36.44.53 1H17c.28 0 .5.22.5.5v.1l-.04.22q-.05.29-.3.66c-.33.46-1.04 1.02-2.66 1.02q-1.08-.01-1.69-.28-.12.43-.37.93M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2v.08l-.01.18q-.01.17-.08.45c-.08.37-.25.86-.6 1.36-.7 1.01-2.05 1.93-4.56 1.93s-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V13m1 .06v.1l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16s3.26-.8 3.74-1.5a3 3 0 0 0 .5-1.42l.01-.02V13a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1zM13 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $76e5a570f6bfc30c$export$88e36fd469ac559 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_24_color__a)",
            "d": "M17 19.5q-1.1 0-1.89-.2C12 18.6 12 16.2 12 16.2c0-1.21.99-2.2 2.2-2.2h5.61c1.21 0 2.19.99 2.19 2.2 0 0 0 2.87-4.07 3.26q-.43.04-.93.04"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_24_color__b)",
            "fillOpacity": ".5",
            "d": "M17 19.5q-1.1 0-1.89-.2C12 18.6 12 16.2 12 16.2c0-1.21.99-2.2 2.2-2.2h5.61c1.21 0 2.19.99 2.19 2.2 0 0 0 2.87-4.07 3.26q-.43.04-.93.04"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_24_color__c)",
            "d": "M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_24_color__d)",
            "d": "M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_24_color__e)",
            "d": "M17 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_24_color__f)",
            "d": "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_24_color__a",
                "x1": "14.38",
                "x2": "16.3",
                "y1": "14.73",
                "y2": "20.3",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_24_color__c",
                "x1": "4.85",
                "x2": "7.41",
                "y1": "14.93",
                "y2": "21.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_24_color__d",
                "x1": "8",
                "x2": "11.61",
                "y1": "13.17",
                "y2": "24.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_24_color__e",
                "x1": "15.43",
                "x2": "18.48",
                "y1": "6.8",
                "y2": "11.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_24_color__f",
                "x1": "5.9",
                "x2": "9.98",
                "y1": "5.06",
                "y2": "11.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-6.96 143.16 -79.92)scale(6.62994 6.49284)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$2869e51105e26b91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People24Filled', "24", [
    "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25zM17 19.5a7 7 0 0 1-2.75-.46 5.5 5.5 0 0 0 .75-2.49v-.3c0-.87-.34-1.66-.9-2.25h5.7c1.22 0 2.2.98 2.2 2.2 0 0 0 3.3-5 3.3"
]);
const $76e5a570f6bfc30c$export$b70fc8ab7dd8cc27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People24Regular', "24", [
    "M5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-2.75 13.04q1.04.44 2.75.46c2.28 0 3.59-.7 4.3-1.56a3 3 0 0 0 .7-1.73v-.03c0-1.2-.97-2.18-2.18-2.18H14.1q.6.63.81 1.5h4.91a.7.7 0 0 1 .68.7l-.04.18q-.05.25-.32.6C19.8 17.42 18.97 18 17 18c-.98 0-1.67-.15-2.17-.34q-.14.62-.58 1.38M4.25 14C3.01 14 2 15 2 16.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 19.97 5.17 21 8 21s4.39-1.03 5.2-2.2a4.5 4.5 0 0 0 .8-2.27v-.28c0-1.24-1-2.25-2.25-2.25zm-.75 2.5v-.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v.34l-.06.33c-.07.28-.2.65-.46 1.02-.5.71-1.56 1.56-3.98 1.56s-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43"
]);
const $76e5a570f6bfc30c$export$edd0806f03f706cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_28_color__a)",
            "d": "M20 22c6 0 6-3.75 6-3.75 0-1.24-1-2.25-2.25-2.25h-7.5c-1.25 0-2.26 1-2.26 2.25 0 0 0 3.75 6 3.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_28_color__b)",
            "fillOpacity": ".5",
            "d": "M20 22c6 0 6-3.75 6-3.75 0-1.24-1-2.25-2.25-2.25h-7.5c-1.25 0-2.26 1-2.26 2.25 0 0 0 3.75 6 3.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_28_color__c)",
            "d": "M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 24 9.5 24 2 18.75 2 18.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_28_color__d)",
            "d": "M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 24 9.5 24 2 18.75 2 18.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_28_color__e)",
            "d": "M23.5 10.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_28_color__f)",
            "d": "M9.5 14a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_28_color__a",
                "x1": "16.85",
                "x2": "18.79",
                "y1": "16.8",
                "y2": "22.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_28_color__c",
                "x1": "5.57",
                "x2": "8.29",
                "y1": "17.06",
                "y2": "25.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_28_color__d",
                "x1": "9.5",
                "x2": "13.33",
                "y1": "15.05",
                "y2": "28.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_28_color__e",
                "x1": "18.16",
                "x2": "21.73",
                "y1": "7.93",
                "y2": "13.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_28_color__f",
                "x1": "7.14",
                "x2": "11.73",
                "y1": "6.2",
                "y2": "13.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7.9006 -.875 .77996 7.04244 12.47 19)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$53cb5b355cfb4c33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People28Filled', "28", [
    "M9.5 14a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m7.6 7.62q1.13.36 2.9.38c6 0 6-3.75 6-3.75 0-1.24-1-2.25-2.25-2.25h-6.66c.56.58.9 1.38.9 2.25v.56l-.01.32q-.03.3-.14.75c-.12.48-.34 1.1-.74 1.74m6.4-11.12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 24 9.5 24 2 18.75 2 18.75z"
]);
const $76e5a570f6bfc30c$export$b6214ebda35ff094 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People28Regular', "28", [
    "M9.5 5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 7a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.53l-.02.24q-.02.24-.1.62c-.13.5-.38 1.15-.87 1.81C14.99 22.8 13.06 24 9.5 24S4 22.8 3 21.45a5 5 0 0 1-1-2.67v-.53m1.5.5v.11l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 3.2 0 4.63-1.05 5.3-1.95a3.6 3.6 0 0 0 .7-1.79v-.51a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75zm13.6 2.87A10 10 0 0 0 20 22c2.77 0 4.32-.8 5.16-1.76a3.5 3.5 0 0 0 .84-1.96v-.03c0-1.24-1-2.25-2.25-2.25h-6.66q.61.63.82 1.5h5.84a.75.75 0 0 1 .74.79q0 .07-.04.22-.07.31-.42.75c-.47.54-1.55 1.24-4.03 1.24q-1.4-.01-2.26-.26a6 6 0 0 1-.64 1.38"
]);
const $76e5a570f6bfc30c$export$3449edae78ad84d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_32_color__a)",
            "d": "M27.6 18a2.4 2.4 0 0 1 2.4 2.4s0 4.6-7 4.6-7-4.6-7-4.6a2.4 2.4 0 0 1 2.4-2.4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_32_color__b)",
            "fillOpacity": ".5",
            "d": "M27.6 18a2.4 2.4 0 0 1 2.4 2.4s0 4.6-7 4.6-7-4.6-7-4.6a2.4 2.4 0 0 1 2.4-2.4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_32_color__c)",
            "d": "M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27s8.5-5.85 8.5-5.85V21a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_32_color__d)",
            "d": "M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27s8.5-5.85 8.5-5.85V21a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_32_color__e)",
            "d": "M23 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_32_color__f)",
            "d": "M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_32_color__a",
                "x1": "19.33",
                "x2": "21.59",
                "y1": "18.93",
                "y2": "26.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_32_color__c",
                "x1": "6.04",
                "x2": "9.09",
                "y1": "19.2",
                "y2": "28.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_32_color__d",
                "x1": "10.5",
                "x2": "14.78",
                "y1": "16.93",
                "y2": "32.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_32_color__e",
                "x1": "20.9",
                "x2": "24.98",
                "y1": "9.06",
                "y2": "15.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_32_color__f",
                "x1": "7.62",
                "x2": "13.22",
                "y1": "6.46",
                "y2": "15.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-6.32 201.71 -118.02)scale(9.26794 8.26635)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$c9805a9710b725fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People32Filled', "32", [
    "M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27s8.5-5.85 8.5-5.85V21a3 3 0 0 0-3-3zm18 7c-1.46 0-2.6-.2-3.52-.51a7 7 0 0 0 1.02-3.23V21c0-1.15-.44-2.2-1.15-3h8.24a2.4 2.4 0 0 1 2.4 2.4s0 4.6-7 4.6"
]);
const $76e5a570f6bfc30c$export$97832feeb2637aa5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People32Light', "32", [
    "M6 10.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M10.5 5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m9.5 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M5 18a3 3 0 0 0-3 3c0 1.12.42 2.63 1.72 3.86C5.02 26.1 7.16 27 10.5 27s5.48-.9 6.78-2.14A5.4 5.4 0 0 0 19 21a3 3 0 0 0-3-3zm-2 3c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2c0 .88-.33 2.12-1.4 3.14-1.08 1.01-2.94 1.86-6.1 1.86s-5.02-.85-6.1-1.86A4.4 4.4 0 0 1 3 21m16.96 2.59q-.19.45-.46.9 1.38.5 3.5.51c2.84 0 4.6-.78 5.65-1.76A4 4 0 0 0 30 20.5a2.5 2.5 0 0 0-2.5-2.5h-8.15q.4.46.68 1h7.47c.83 0 1.5.67 1.5 1.5a3 3 0 0 1-1.03 2c-.82.78-2.31 1.5-4.97 1.5a10 10 0 0 1-3.04-.41"
]);
const $76e5a570f6bfc30c$export$5c0ce7bbaa5b12db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People32Regular', "32", [
    "M7 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10.5 5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M21 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 21a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v.23l-.02.27q-.03.27-.13.7a6 6 0 0 1-1 2c-1.17 1.51-3.37 2.8-7.35 2.8s-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 21.24V21m2 .18zv.1l.09.4c.09.35.27.82.64 1.29.7.9 2.25 2.02 5.77 2.02s5.07-1.12 5.77-2.02a3.6 3.6 0 0 0 .73-1.79V21a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm15.48 3.31q1.38.5 3.52.51c3.2 0 5.02-.95 6.01-2.12a4.3 4.3 0 0 0 .99-2.36v-.06C30 19.1 28.9 18 27.54 18h-8.19q.76.85 1.04 2h7.15c.25 0 .45.2.46.45v.04l-.06.25c-.06.22-.19.53-.45.84-.51.6-1.7 1.42-4.49 1.42a9 9 0 0 1-2.72-.35 7 7 0 0 1-.8 1.84"
]);
const $76e5a570f6bfc30c$export$4322fe0d30b3f908 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_48_color__a)",
            "d": "M27.22 27a3.75 3.75 0 0 0-3.75 3.75V31s0 8 10.5 8H34c10.5 0 10.5-8 10.5-8v-.25A3.75 3.75 0 0 0 40.76 27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_48_color__b)",
            "fillOpacity": ".5",
            "d": "M27.22 27a3.75 3.75 0 0 0-3.75 3.75V31s0 8 10.5 8H34c10.5 0 10.5-8 10.5-8v-.25A3.75 3.75 0 0 0 40.76 27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_48_color__c)",
            "d": "M6.75 27A3.75 3.75 0 0 0 3 30.75V32s0 9 13 9 13-9 13-9v-1.25A3.75 3.75 0 0 0 25.25 27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_48_color__d)",
            "d": "M6.75 27A3.75 3.75 0 0 0 3 30.75V32s0 9 13 9 13-9 13-9v-1.25A3.75 3.75 0 0 0 25.25 27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_48_color__e)",
            "d": "M34 24a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_48_color__f)",
            "d": "M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_48_color__a",
                "x1": "28.47",
                "x2": "32.78",
                "y1": "28.6",
                "y2": "40.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_48_color__c",
                "x1": "9.18",
                "x2": "13.99",
                "y1": "28.86",
                "y2": "43.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_48_color__d",
                "x1": "16",
                "x2": "22.75",
                "y1": "25.33",
                "y2": "48.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_48_color__e",
                "x1": "30.85",
                "x2": "36.97",
                "y1": "13.6",
                "y2": "23.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_48_color__f",
                "x1": "11.8",
                "x2": "19.96",
                "y1": "10.13",
                "y2": "23.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(13.83637 -1.75 1.7749 14.0332 20.8 33)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$757370f9237ae38c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People48Filled', "48", [
    "M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16m18 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12M6.75 27A3.75 3.75 0 0 0 3 30.75V32s0 9 13 9 13-9 13-9v-1.25A3.75 3.75 0 0 0 25.25 27zm21.92 11.09c1.38.56 3.12.91 5.33.91 10.5 0 10.5-8 10.5-8v-.25A3.75 3.75 0 0 0 40.75 27H29.6c.86 1 1.39 2.32 1.39 3.75v1.35l-.04.58q-.05.53-.24 1.33a11 11 0 0 1-2.05 4.08"
]);
const $76e5a570f6bfc30c$export$a6a9f6ea060faaed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('People48Regular', "48", [
    "M10.5 16a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M16 8a8 8 0 1 0 0 16 8 8 0 0 0 0-16m14.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 27c-2.18 0-3.92-.35-5.32-.92a11 11 0 0 0 1.35-2.16c1.02.35 2.32.58 3.97.58 4.27 0 6.17-1.53 7.06-2.83a5.6 5.6 0 0 0 .94-2.68v-.24c0-.69-.56-1.25-1.25-1.25h-9.89q-.32-1.43-1.25-2.5h11.14a3.75 3.75 0 0 1 3.75 3.75v.3l-.02.36q-.04.36-.16.92a8 8 0 0 1-1.2 2.75C41.7 37.16 38.97 39 34 39M6.75 27A3.75 3.75 0 0 0 3 30.75v1.3l.03.42q.03.4.2 1.05c.2.85.64 1.98 1.5 3.11C6.47 38.95 9.82 41 16 41s9.52-2.05 11.28-4.37A8.7 8.7 0 0 0 29 32.05v-1.3A3.75 3.75 0 0 0 25.25 27zM5.5 32.02v-1.27c0-.69.56-1.25 1.25-1.25h18.5c.69 0 1.25.56 1.25 1.25v1.27l-.02.18q-.01.24-.13.7c-.15.6-.45 1.41-1.06 2.22-1.19 1.56-3.71 3.38-9.29 3.38s-8.1-1.82-9.29-3.38a6 6 0 0 1-1.2-3.1"
]);
const $76e5a570f6bfc30c$export$764a353a14a0a054 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5a.5.5 0 0 0-.5-.5M7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$b75416359df61c71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5a.5.5 0 0 0-.5-.5M7.26 8q-.39.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$65f787d2edffaa95 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__a)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__b)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__c)",
            "fillOpacity": ".5",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__d)",
            "d": "M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__e)",
            "d": "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__f)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__g)",
            "fillRule": "evenodd",
            "d": "M14.5 12c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "10.8",
                "y2": "16.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "9.29",
                "y2": "19.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "4.66",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "3.36",
                "y2": "8.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__f",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__g",
                "x1": "12.94",
                "x2": "14.47",
                "y1": "12.51",
                "y2": "17.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_add_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2 4.5 -4.5 2 12.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$233dceeb0b153015 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$29549224ce4c998f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$9284ac2bea68938d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__a)",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__b)",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__c)",
            "fillOpacity": ".5",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__d)",
            "d": "M17 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__e)",
            "d": "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__f)",
            "d": "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_24_color__g)",
            "d": "M17.5 14c-.27 0-.49.2-.52.45v2.53h-2.45a.53.53 0 0 0-.08 1.04h2.53v2.46a.53.53 0 0 0 1.04.07v-2.53h2.46a.53.53 0 0 0 .07-1.04h-2.53v-2.45a.53.53 0 0 0-.52-.53"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_24_color__a",
                "x1": "4.85",
                "x2": "7.41",
                "y1": "13.93",
                "y2": "20.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_24_color__b",
                "x1": "8",
                "x2": "11.61",
                "y1": "12.17",
                "y2": "23.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_24_color__d",
                "x1": "15.43",
                "x2": "18.48",
                "y1": "5.8",
                "y2": "10.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_24_color__e",
                "x1": "5.9",
                "x2": "9.98",
                "y1": "4.06",
                "y2": "10.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_24_color__f",
                "x1": "12.39",
                "x2": "19.98",
                "y1": "14.06",
                "y2": "21.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_24_color__g",
                "x1": "15.31",
                "x2": "17.46",
                "y1": "14.71",
                "y2": "22.3",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_add_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(66.5 -5.65 20.28)scale(5.58857 5.51762)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$1bdafb80305cd9f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20a8 8 0 0 0 3.28-.61 6.5 6.5 0 0 1 1.36-6.2 2 2 0 0 0-.89-.19zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$8516b0db0294a7ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.37 0 2.44-.24 3.28-.62a7 7 0 0 1-.27-1.55c-.65.38-1.6.67-3.01.67-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.48q.38-.72.91-1.32a2 2 0 0 0-.89-.18zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$f41625f032ee6a2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_28_color__a)",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_28_color__b)",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_28_color__c)",
            "fillOpacity": ".5",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_28_color__d)",
            "d": "M23.5 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_28_color__e)",
            "d": "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_28_color__f)",
            "d": "M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
        }
    ],
    [
        "path",
        {
            "fill": "#fff",
            "fillRule": "evenodd",
            "d": "M20.5 16c.28 0 .5.22.5.5V20h3.5a.5.5 0 0 1 0 1H21v3.5a.5.5 0 0 1-1 0V21h-3.5a.5.5 0 0 1 0-1H20v-3.5c0-.28.22-.5.5-.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_28_color__a",
                "x1": "5.57",
                "x2": "8.29",
                "y1": "16.06",
                "y2": "24.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_28_color__b",
                "x1": "9.5",
                "x2": "13.33",
                "y1": "14.05",
                "y2": "27.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_28_color__d",
                "x1": "18.16",
                "x2": "21.73",
                "y1": "6.93",
                "y2": "12.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_28_color__e",
                "x1": "7.14",
                "x2": "11.73",
                "y1": "5.2",
                "y2": "12.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_28_color__f",
                "x1": "14.46",
                "x2": "23.44",
                "y1": "16.44",
                "y2": "25.76",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_add_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3 6 -6.28306 3.14154 18 20.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": "0",
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$8bc5821045997135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd28Filled', "28", [
    "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .57.07a7.5 7.5 0 0 0-2.07 7.35c-.98.36-2.2.58-3.75.58C2 23 2 17.75 2 17.75zm25 3.25a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $76e5a570f6bfc30c$export$5ecbd53e3c23617f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd28Regular', "28", [
    "M9.5 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.25 15C3.01 15 2 16 2 17.25v.53l.02.24q.02.24.1.62c.13.5.38 1.15.87 1.81C4.01 21.8 5.94 23 9.5 23q2.28-.02 3.75-.58-.2-.75-.24-1.52c-.84.35-1.97.6-3.51.6-3.2 0-4.63-1.05-5.3-1.95a3.6 3.6 0 0 1-.7-1.79v-.51c0-.41.34-.75.75-.75h9.9q.5-.78 1.17-1.43a2 2 0 0 0-.57-.07zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $76e5a570f6bfc30c$export$ccd03413c97d7ff4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_32_color__a)",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_32_color__b)",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_32_color__c)",
            "fillOpacity": ".5",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_32_color__d)",
            "d": "M23 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_32_color__e)",
            "d": "M10.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_32_color__f)",
            "fillRule": "evenodd",
            "d": "M30.5 24a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#fff",
            "fillRule": "evenodd",
            "d": "M23.25 18.5c.41 0 .75.34.75.75V23h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V24.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75c0-.41.34-.75.75-.75",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_32_color__a",
                "x1": "6.04",
                "x2": "9.09",
                "y1": "18.2",
                "y2": "27.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_32_color__b",
                "x1": "10.5",
                "x2": "14.78",
                "y1": "15.93",
                "y2": "31.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_32_color__d",
                "x1": "20.9",
                "x2": "24.98",
                "y1": "8.06",
                "y2": "14.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_32_color__e",
                "x1": "7.62",
                "x2": "13.22",
                "y1": "5.46",
                "y2": "14.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_32_color__f",
                "x1": "16.04",
                "x2": "26.39",
                "y1": "19.31",
                "y2": "30.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_add_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.5 8 -8.41639 3.68217 21 22.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$e855b8af052b18b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd32Filled', "32", [
    "M10.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-9 9c0-2.71 1.2-5.14 3.1-6.8A3 3 0 0 0 16 17H5a3 3 0 0 0-3 3v.15S2 26 10.5 26q2.15-.02 3.63-.45A9 9 0 0 1 14 24m9 7.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V23h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V24.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
]);
const $76e5a570f6bfc30c$export$964636b84fc452a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd32Light', "32", [
    "M10.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M6 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M23 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-4 6a3 3 0 0 1 1.1.2q-.45.39-.83.82L16 18H5a2 2 0 0 0-2 2c0 .88.33 2.12 1.4 3.14C5.49 24.15 7.35 25 10.5 25q2.12-.02 3.52-.45.03.51.11 1-1.5.44-3.63.45c-3.34 0-5.48-.9-6.78-2.14A5.4 5.4 0 0 1 2 20a3 3 0 0 1 3-3zm7 14.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m1-12.25a.75.75 0 0 0-1.5 0V23h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V24.5h3.75a.75.75 0 0 0 0-1.5H24z"
]);
const $76e5a570f6bfc30c$export$3fa7e33e11e71bc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAdd32Regular', "32", [
    "M7 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M21 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-7 10a3 3 0 0 1 1.1.2 9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1v.29l.09.4c.09.35.27.82.64 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.44-3.63.45c-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 20.24V20a3 3 0 0 1 3-3zm7 14.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V23h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V24.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
]);
const $76e5a570f6bfc30c$export$2c9ef58476bf9ca2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudience20Filled', "20", [
    "M12.21 5.22a2.23 2.23 0 1 0-4.45 0 2.23 2.23 0 0 0 4.45 0M2.51 12h3V8.83q.05-.45.26-.82H3.02l-.12.01a1 1 0 0 0-.88 1v2.48c0 .28.22.5.5.5M18 11.5a.5.5 0 0 1-.5.5h-3.02V8.87q-.04-.47-.26-.86h2.78a1 1 0 0 1 1 .89v2.6m-4.52-2.6a1 1 0 0 0-1-.89H7.5l-.11.01a1 1 0 0 0-.89 1V12h6.97V8.9m1.5-5.28a1.91 1.91 0 1 1 0 3.82 1.91 1.91 0 0 1 0-3.82M6.93 5.53a1.91 1.91 0 1 0-3.83 0 1.91 1.91 0 0 0 3.83 0M2.5 13a.5.5 0 0 0-.5.5v1A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$97f73210f4dcf301 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudience20Regular', "20", [
    "M9.99 2.99a2.23 2.23 0 1 1 0 4.45 2.23 2.23 0 0 1 0-4.45m0 1a1.23 1.23 0 1 0 0 2.45 1.23 1.23 0 0 0 0-2.45M3.02 11.5a.5.5 0 1 1-1 0V9.01a1 1 0 0 1 .88-.99h2.87q-.21.37-.26.81v.18H3zm14.47.5a.5.5 0 0 0 .5-.5V8.9a1 1 0 0 0-1-.89h-2.78q.22.4.26.86V9H17v2.49c0 .28.22.5.5.5m-5.02-3.99a1 1 0 0 1 1 .89v2.6a.5.5 0 1 1-1 0V9.01H7.5v2.49a.5.5 0 1 1-1 0V9.01a1 1 0 0 1 .89-.99h5.08m4.42-2.48a1.91 1.91 0 1 0-3.83 0 1.91 1.91 0 0 0 3.83 0m-2.83 0a.91.91 0 1 1 1.83 0 .91.91 0 0 1-1.83 0M5.02 3.62a1.91 1.91 0 1 1 0 3.82 1.91 1.91 0 0 1 0-3.82m0 1a.91.91 0 1 0 0 1.82.91.91 0 0 0 0-1.82M2.5 13a.5.5 0 0 0-.5.5v1A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-.5-.5zm.5 1.5V14h14v.5c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5"
]);
const $76e5a570f6bfc30c$export$8ad9d6e6d23cf5c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudience24Filled', "24", [
    "M14.75 10c.97 0 1.75.78 1.75 1.75V16h-9v-4.25c0-.97.79-1.75 1.75-1.75zM22 11.75c0-.97-.78-1.75-1.75-1.75h-3.38q.61.73.63 1.75V16h3.75c.41 0 .75-.34.75-.75zM6.5 15v-3.25l.01-.22q.08-.88.62-1.53H3.61c-.9.08-1.61.83-1.61 1.75v3.5c0 .41.34.75.75.75H6.5zM12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m6.5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M2 17.75c0-.41.34-.75.75-.75h18.5c.41 0 .75.34.75.75v.5A3.75 3.75 0 0 1 18.25 22H5.75A3.75 3.75 0 0 1 2 18.25z"
]);
const $76e5a570f6bfc30c$export$82fb5dbac2f86848 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudience24Regular', "24", [
    "M14.75 10c.97 0 1.75.78 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5c0-.97.79-1.75 1.75-1.75zm5.75 1.75v3.5a.75.75 0 0 0 1.5 0v-3.5c0-.97-.78-1.75-1.75-1.75h-3.38q.54.63.62 1.5h2.76q.23.02.25.25M2 15.25a.75.75 0 0 0 1.5 0v-3.5c0-.14.11-.25.25-.25h2.76q.1-.87.62-1.5H3.75C2.78 10 2 10.78 2 11.75zM12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6.5-.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M2.75 17a.75.75 0 0 0-.75.75v.5A3.75 3.75 0 0 0 5.75 22h12.5A3.75 3.75 0 0 0 22 18.25v-.5a.75.75 0 0 0-.75-.75zm3 3.5a2.25 2.25 0 0 1-2.24-2H20.5a2.25 2.25 0 0 1-2.24 2z"
]);
const $76e5a570f6bfc30c$export$a9d8407b66c98831 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudience32Filled', "32", [
    "M12 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-3.5 8c0-1.15.43-2.2 1.15-3H6a3 3 0 0 0-3 3v3.5a1 1 0 0 0 1 1h4.5zm15 0c0-1.15-.43-2.2-1.15-3H26a3 3 0 0 1 3 3v3.5a1 1 0 0 1-1 1h-4.5zM3 23.5c0-.83.67-1.5 1.5-1.5h23c.83 0 1.5.67 1.5 1.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 23.5m1-15a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m17 0a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10 16a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4.5H10z"
]);
const $76e5a570f6bfc30c$export$70aa29bd08530a35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudience32Regular', "32", [
    "M14 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 9a3 3 0 0 0-3 3v3.5a1 1 0 1 0 2 0V16a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3.5a1 1 0 1 0 2 0V16a3 3 0 0 0-3-3zm-8.5 9c-.83 0-1.5.67-1.5 1.5A4.5 4.5 0 0 0 7.5 28h17a4.5 4.5 0 0 0 4.5-4.5c0-.83-.67-1.5-1.5-1.5zm3 4a2.5 2.5 0 0 1-2.45-2h21.9a2.5 2.5 0 0 1-2.45 2zm15.89-11H26a1 1 0 0 1 1 1v3.5a1 1 0 1 0 2 0V16a3 3 0 0 0-3-3h-3.65q.77.85 1.04 2M9.65 13H6a3 3 0 0 0-3 3v3.5a1 1 0 1 0 2 0V16a1 1 0 0 1 1-1h2.61q.27-1.15 1.04-2M7.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M4 8.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m19 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M24.5 5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $76e5a570f6bfc30c$export$d9f5f081a78a243e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCall16Filled', "16", [
    "M12.87 7.83a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59-.5.18-1.02.04-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.8l.54-.6c.26-.28.66-.4 1.04-.32l1.22.29q1.46-.9 1.56-2.56l-.88-.86a.9.9 0 0 1-.22-1zM7.5 8a2 2 0 0 1 2 2c0 .97-.6 1.73-1.41 2.23-.82.5-1.91.77-3.09.77a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$c2d2550e4504d08f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCall16Regular', "16", [
    "M12.87 7.83a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59-.5.18-1.02.04-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.8l.54-.6c.26-.28.66-.4 1.04-.32l1.22.29q1.46-.9 1.56-2.56l-.88-.86a.9.9 0 0 1-.22-1zM7.5 8a2 2 0 0 1 2 2c0 .97-.6 1.73-1.41 2.23-.82.5-1.91.77-3.09.77a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm-5 1a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12s1.94-.24 2.57-.62q.94-.6.93-1.38a1 1 0 0 0-1-1zm9.23-6.5a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 11.5 7L11.27 7a2.25 2.25 0 0 1-2-2.01l-.02-.23c0-1.24 1-2.25 2.25-2.25zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$b3680b2a0238853b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCall20Filled', "20", [
    "M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2v.08l-.01.18q-.01.17-.08.45c-.08.37-.25.86-.6 1.36-.7 1.01-2.05 1.93-4.56 1.93s-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12m13-8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m1.08 7.58.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $76e5a570f6bfc30c$export$491bc9ca2cfa46f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCall20Regular', "20", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m0 4.25a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93s3.87-.92 4.57-1.93a4 4 0 0 0 .68-1.99V12a2 2 0 0 0-2-2zm-1 2.06V12a1 1 0 0 1 1-1H10a1 1 0 0 1 1 1v.16l-.06.33c-.07.27-.2.64-.45 1C10.01 14.2 9 15 6.75 15s-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42zM14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m3.58 5.08.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $76e5a570f6bfc30c$export$f74c9967be8fba1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCall24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25zm13.94 1 .48-1.21c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.8 3.8 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28"
]);
const $76e5a570f6bfc30c$export$40c81e29686718a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCall24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20s4.39-1.03 5.2-2.2a4.5 4.5 0 0 0 .8-2.27v-.28c0-1.24-1-2.25-2.25-2.25zm-.75 2.5v-.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v.34l-.06.33c-.07.28-.2.65-.46 1.02-.5.71-1.56 1.56-3.98 1.56s-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43M18.2 14l.47-1.21c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.8 3.8 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28"
]);
const $76e5a570f6bfc30c$export$3a1d90fb15ff7982 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1-2.18 8.44l-1.8.54a.4.4 0 0 1-.5-.5l.54-1.8A4.5 4.5 0 0 1 11.5 7M7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm2.24 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0-2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$c7c65474c151023c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1-2.18 8.44l-1.8.54a.4.4 0 0 1-.5-.5l.54-1.8A4.5 4.5 0 0 1 11.5 7M7.26 8q-.37.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.04.5.16 1-.57.08-1.18.09a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm2.24 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0-2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$1f9787d1fdaad8b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__a)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__b)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__c)",
            "fillOpacity": ".5",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__d)",
            "d": "M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__e)",
            "d": "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__f)",
            "d": "M19 14.5a4.5 4.5 0 0 1-6.68 3.94l-1.8.54a.4.4 0 0 1-.5-.5l.54-1.8A4.5 4.5 0 1 1 19 14.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__g)",
            "d": "M12.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "10.8",
                "y2": "16.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "9.29",
                "y2": "19.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "4.66",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "3.36",
                "y2": "8.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__f",
                "x1": "10.32",
                "x2": "18.18",
                "y1": "11.69",
                "y2": "25.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__g",
                "x1": "12.44",
                "x2": "12.74",
                "y1": "13.05",
                "y2": "16.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_chat_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2 4.5 -4.5 2 12.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$8ea57f51a823c15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat20Filled', "20", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M11 10.26a5.5 5.5 0 0 0-1.88 5.4c-.64.2-1.42.34-2.37.34-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26M14.5 19a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$9fe3d162863f852c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat20Regular', "20", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m0 4.25a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.42-.01 2.37-.35A6 6 0 0 1 9 14.63q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10l.23.03q.35-.42.76-.77A2 2 0 0 0 10 10zm11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14.5 19a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$62f3ab4c858d93f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__a)",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__b)",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__c)",
            "fillOpacity": ".5",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__d)",
            "d": "M17 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__e)",
            "d": "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__f)",
            "d": "M17.5 23a5.5 5.5 0 1 0-4.81-2.83l-.67 2.19a.5.5 0 0 0 .63.62l2.18-.67q1.2.68 2.67.7"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "M15.5 17a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1zm2 2h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_24_color__g)",
            "d": "M15.5 17a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1zm2 2h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_24_color__a",
                "x1": "4.85",
                "x2": "7.41",
                "y1": "13.93",
                "y2": "20.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_24_color__b",
                "x1": "8",
                "x2": "11.61",
                "y1": "12.17",
                "y2": "23.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_24_color__d",
                "x1": "15.43",
                "x2": "18.48",
                "y1": "5.8",
                "y2": "10.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_24_color__e",
                "x1": "5.9",
                "x2": "9.98",
                "y1": "4.06",
                "y2": "10.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_24_color__f",
                "x1": "12.39",
                "x2": "22",
                "y1": "14.06",
                "y2": "30.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_24_color__g",
                "x1": "15.44",
                "x2": "15.74",
                "y1": "16.05",
                "y2": "19.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_chat_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(66.5 -5.65 20.28)scale(5.58857 5.51762)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$2b8789767a42831c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat24Filled', "24", [
    "M12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m8 1a3 3 0 1 1-6 0 3 3 0 0 1 6 0M2 15.25C2 14.01 3 13 4.25 13h7.5q.48 0 .89.18a6.5 6.5 0 0 0-1.36 6.2A8 8 0 0 1 8 20c-6 0-6-4.5-6-4.5zM17.5 23a5.5 5.5 0 1 0-4.81-2.83l-.67 2.19a.5.5 0 0 0 .63.62l2.18-.67q1.2.68 2.67.7m-2-6a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1zm2 2h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1"
]);
const $76e5a570f6bfc30c$export$6fe667306482d072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat24Regular', "24", [
    "M8 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M14 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0M2 15.25C2 14.01 3 13 4.25 13h7.5q.48 0 .89.18-.53.6-.9 1.32H4.24a.75.75 0 0 0-.75.75v.34l.06.33c.07.28.2.65.46 1.02.5.71 1.56 1.56 3.98 1.56 1.41 0 2.36-.29 3-.67q.06.81.28 1.55c-.84.38-1.91.62-3.28.62-2.83 0-4.39-1.03-5.2-2.2a4.5 4.5 0 0 1-.8-2.27v-.28M17.5 23a5.5 5.5 0 1 0-4.81-2.83l-.67 2.19a.5.5 0 0 0 .63.62l2.18-.67q1.2.68 2.67.7m-2-6a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1zm2 2h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1"
]);
const $76e5a570f6bfc30c$export$39fbd7d36e3d6200 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__a)",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__b)",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__c)",
            "fillOpacity": ".5",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__d)",
            "d": "M23.5 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__e)",
            "d": "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__f)",
            "d": "M20.5 27a6.5 6.5 0 1 0-5.68-3.35l-.8 2.7a.5.5 0 0 0 .62.63l2.72-.8q1.41.8 3.14.82"
        }
    ],
    [
        "path",
        {
            "fill": "#fff",
            "d": "M17.5 19.5c0-.28.23-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__g)",
            "d": "M17.5 19.5c0-.28.23-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "#fff",
            "d": "M18 22a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 0 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_28_color__h)",
            "d": "M18 22a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 0 1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__a",
                "x1": "5.57",
                "x2": "8.29",
                "y1": "16.06",
                "y2": "24.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__b",
                "x1": "9.5",
                "x2": "13.33",
                "y1": "14.05",
                "y2": "27.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__d",
                "x1": "18.16",
                "x2": "21.73",
                "y1": "6.93",
                "y2": "12.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__e",
                "x1": "7.14",
                "x2": "11.73",
                "y1": "5.2",
                "y2": "12.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__f",
                "x1": "14.46",
                "x2": "25.81",
                "y1": "16.44",
                "y2": "35.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__g",
                "x1": "18.03",
                "x2": "18.28",
                "y1": "19.05",
                "y2": "22.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_28_color__h",
                "x1": "18.03",
                "x2": "18.28",
                "y1": "19.05",
                "y2": "22.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_chat_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3 6 -6.28306 3.14154 18 20.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": "0",
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$652c8245e0c0bfd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat28Filled', "28", [
    "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .58.07a7.5 7.5 0 0 0-2.08 7.35q-1.44.56-3.75.58C2 23 2 17.75 2 17.75zm25 3.25a6.5 6.5 0 0 1-9.64 5.69l-2.72.79a.5.5 0 0 1-.62-.62l.8-2.71q-.8-1.42-.82-3.15a6.5 6.5 0 1 1 13 0M18 19a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.23.5.5.5h2.5a.5.5 0 0 0 0-1H18a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$323cd833c878839b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat28Regular', "28", [
    "M9.5 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .58.07-.68.64-1.17 1.43H4.25a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 1.55 0 2.68-.25 3.52-.6q.03.78.23 1.52-1.46.56-3.75.58C5.94 23 4 21.8 3 20.45a5 5 0 0 1-1-2.67v-.53m25 3.25a6.5 6.5 0 0 1-9.64 5.69l-2.72.79a.5.5 0 0 1-.62-.62l.8-2.71q-.8-1.42-.82-3.15a6.5 6.5 0 1 1 13 0M18 19a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.23.5.5.5h2.5a.5.5 0 0 0 0-1H18a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$4287b3edb70bb14f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__a)",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__b)",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__c)",
            "fillOpacity": ".5",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__d)",
            "d": "M23 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__e)",
            "d": "M10.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__f)",
            "d": "M30.5 24a7.5 7.5 0 0 1-11 6.63l-3.37.86a.5.5 0 0 1-.61-.6l.85-3.38A7.5 7.5 0 1 1 30.5 24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_32_color__g)",
            "d": "M20.25 22a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm-.75 3.75c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_32_color__a",
                "x1": "6.04",
                "x2": "9.09",
                "y1": "18.2",
                "y2": "27.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_32_color__b",
                "x1": "10.5",
                "x2": "14.78",
                "y1": "15.93",
                "y2": "31.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_32_color__d",
                "x1": "20.9",
                "x2": "24.98",
                "y1": "8.06",
                "y2": "14.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_32_color__e",
                "x1": "7.62",
                "x2": "13.22",
                "y1": "5.46",
                "y2": "14.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_32_color__f",
                "x1": "16.04",
                "x2": "29.14",
                "y1": "19.31",
                "y2": "41.64",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_32_color__g",
                "x1": "20.11",
                "x2": "20.6",
                "y1": "22.08",
                "y2": "26.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_chat_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.5 8 -8.41639 3.68217 21 22.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$39f7db9d5bfeb132 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat32Filled', "32", [
    "M10.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-9 9c0-2.71 1.2-5.14 3.1-6.8A3 3 0 0 0 16 17H5a3 3 0 0 0-3 3v.15S2 26 10.5 26q2.15-.02 3.63-.45A9 9 0 0 1 14 24m9 7.5a7.5 7.5 0 1 0-6.63-3.99l-.85 3.37c-.1.37.24.7.6.6l3.37-.85q1.59.85 3.51.87m-3.5-8.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3.75a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5z"
]);
const $76e5a570f6bfc30c$export$dbe1c7289dd36472 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat32Regular', "32", [
    "M7 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M21 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-7 10a3 3 0 0 1 1.1.2 9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1v.29l.09.4c.09.35.27.82.64 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.44-3.63.45c-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 20.24V20a3 3 0 0 1 3-3zm7 14.5a7.5 7.5 0 1 0-6.63-3.99l-.85 3.37c-.1.37.24.7.6.6l3.37-.85q1.59.85 3.51.87m-3.5-8.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3.75a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5z"
]);
const $76e5a570f6bfc30c$export$82f00bec6454e2a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__a)",
            "d": "M6.75 25A3.75 3.75 0 0 0 3 28.75V30s0 9 13 9 13-9 13-9v-1.25A3.75 3.75 0 0 0 25.25 25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__b)",
            "d": "M6.75 25A3.75 3.75 0 0 0 3 28.75V30s0 9 13 9 13-9 13-9v-1.25A3.75 3.75 0 0 0 25.25 25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__c)",
            "fillOpacity": ".5",
            "d": "M6.75 25A3.75 3.75 0 0 0 3 28.75V30s0 9 13 9 13-9 13-9v-1.25A3.75 3.75 0 0 0 25.25 25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__d)",
            "d": "M34 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__e)",
            "d": "M16 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__f)",
            "d": "M45 35a11 11 0 1 0-20.66 5.26l-1.3 4.52a.96.96 0 0 0 1.18 1.18l4.52-1.3A11 11 0 0 0 45 35"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_48_color__g)",
            "d": "M30 32h8a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2m-1 5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_48_color__a",
                "x1": "9.18",
                "x2": "13.99",
                "y1": "26.86",
                "y2": "41.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_48_color__b",
                "x1": "16",
                "x2": "22.75",
                "y1": "23.33",
                "y2": "46.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_48_color__d",
                "x1": "30.85",
                "x2": "36.97",
                "y1": "11.6",
                "y2": "21.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_48_color__e",
                "x1": "11.8",
                "x2": "19.96",
                "y1": "8.13",
                "y2": "21.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_48_color__f",
                "x1": "23.79",
                "x2": "42.99",
                "y1": "28.13",
                "y2": "60.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_48_color__g",
                "x1": "29.87",
                "x2": "30.48",
                "y1": "32.11",
                "y2": "38.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_chat_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 11.49996 -11.9563 5.1984 29 35)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$1f026fb5ceb30924 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat48Filled', "48", [
    "M16 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16m18 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12M6.75 25A3.75 3.75 0 0 0 3 28.75V30s0 9 13 9c2.15 0 3.94-.25 5.44-.66a13 13 0 0 1 4.23-13.32l-.42-.02zM34 24a11 11 0 1 1-5.26 20.66l-4.52 1.3a.96.96 0 0 1-1.18-1.18l1.3-4.52A11 11 0 0 1 34 24m5 9a1 1 0 0 0-1-1h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1m-9 3a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$1f99e52a791fae99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChat48Regular', "48", [
    "M10.5 14a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M16 6a8 8 0 1 0 0 16 8 8 0 0 0 0-16m14.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12M6.75 25A3.75 3.75 0 0 0 3 28.75v1.3l.03.42q.03.4.2 1.05c.2.85.64 1.98 1.5 3.11C6.47 36.95 9.82 39 16 39q3.18-.02 5.44-.66-.33-1.21-.41-2.48c-1.32.39-2.96.64-5.03.64-5.57 0-8.1-1.82-9.29-3.38a6 6 0 0 1-1.21-3.13v-1.24c0-.69.56-1.25 1.25-1.25h16.63q.98-1.38 2.29-2.48l-.42-.02zM34 24a11 11 0 1 1-5.26 20.66l-4.52 1.3a.96.96 0 0 1-1.18-1.18l1.3-4.52A11 11 0 0 1 34 24m5 9a1 1 0 0 0-1-1h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1m-9 3a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$8e70293108fded5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 2.65a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 1 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M7.25 8a5.5 5.5 0 0 0-1.07 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$74813cb834f46a33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 2.65a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 1 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M7.25 8q-.38.46-.65 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$91c960f15f93d94d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$a3815cfb98398360 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$f323b97b85394c65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20a8 8 0 0 0 3.28-.61 6.5 6.5 0 0 1 1.36-6.2 2 2 0 0 0-.89-.19zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.85-2.35-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7"
]);
const $76e5a570f6bfc30c$export$ac7afd8a79659efd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.37 0 2.44-.24 3.28-.62a7 7 0 0 1-.27-1.55c-.65.38-1.6.67-3.01.67-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.48q.38-.72.91-1.32a2 2 0 0 0-.89-.18zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$e231bc606e189f1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark32Filled', "32", [
    "M23 16.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06M16 17a3 3 0 0 1 1.1.2 9 9 0 0 0-2.97 8.35q-1.48.43-3.63.45C2.04 26 2 20.2 2 20.15V20a3 3 0 0 1 3-3zM10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $76e5a570f6bfc30c$export$79b32ce13a3eca02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark32Light', "32", [
    "M23 16.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06M16 17a3 3 0 0 1 1.1.2q-.45.39-.82.82L16 18H5a2 2 0 0 0-2 2c0 .88.33 2.12 1.4 3.14C5.49 24.15 7.35 25 10.5 25q2.12-.02 3.52-.45.03.51.11 1-1.5.44-3.63.45c-3.34 0-5.48-.9-6.78-2.14A5.4 5.4 0 0 1 2 20a3 3 0 0 1 3-3zM10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8M10.5 5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M23 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $76e5a570f6bfc30c$export$26ecc970a1eca2c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmark32Regular', "32", [
    "M23 16.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06M16 17a3 3 0 0 1 1.1.2 9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1v.29l.08.4c.1.35.28.82.65 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.44-3.63.45c-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 20.3V20a3 3 0 0 1 3-3zM10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8M10.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M23 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$6b34c5b7ad4f334 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication16Filled', "16", [
    "M8.32 8.32a4.5 4.5 0 0 1 6.36 6.36.5.5 0 1 1-.7-.7 3.5 3.5 0 1 0-4.96 0 .5.5 0 1 1-.7.7 4.5 4.5 0 0 1 0-6.36m1.41 1.41a2.5 2.5 0 1 1 3.54 3.54.5.5 0 0 1-.71-.71 1.5 1.5 0 1 0-2.12 0 .5.5 0 0 1-.7.7 2.5 2.5 0 0 1 0-3.53M7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$cb85c2a7efb84eef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication16Regular', "16", [
    "M8.32 8.32a4.5 4.5 0 0 1 6.36 6.36.5.5 0 0 1-.7-.7 3.5 3.5 0 1 0-4.95 0 .5.5 0 0 1-.71.7 4.5 4.5 0 0 1 0-6.36m1.41 1.41a2.5 2.5 0 0 1 3.54 3.54.5.5 0 0 1-.71-.71 1.5 1.5 0 1 0-2.12 0 .5.5 0 0 1-.7.7 2.5 2.5 0 0 1 0-3.53M7.26 8q-.39.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$d0a13132ecfe5f78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication20Filled', "20", [
    "M11.32 11.32a4.5 4.5 0 0 1 6.36 6.36.5.5 0 1 1-.7-.7 3.5 3.5 0 1 0-4.96 0 .5.5 0 1 1-.7.7 4.5 4.5 0 0 1 0-6.36m1.41 1.41a2.5 2.5 0 0 1 3.54 3.54.5.5 0 0 1-.71-.71 1.5 1.5 0 1 0-2.12 0 .5.5 0 0 1-.7.7 2.5 2.5 0 0 1 0-3.53M10 10q.54.01 1 .26a5.5 5.5 0 0 0-1.88 5.4c-.64.2-1.42.34-2.37.34-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2zM6.75 2.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $76e5a570f6bfc30c$export$fbdd752fdbfc49f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication20Regular', "20", [
    "M11.32 11.32a4.5 4.5 0 0 1 6.36 6.36.5.5 0 0 1-.7-.7 3.5 3.5 0 1 0-4.95 0 .5.5 0 0 1-.71.7 4.5 4.5 0 0 1 0-6.36m1.41 1.41a2.5 2.5 0 0 1 3.54 3.54.5.5 0 0 1-.71-.71 1.5 1.5 0 1 0-2.12 0 .5.5 0 0 1-.7.7 2.5 2.5 0 0 1 0-3.53M10 10q.54.01 1 .26-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.44 1C3.5 14.2 4.51 15 6.75 15q1.42-.01 2.25-.37.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.67-1.81L1.5 12c0-1.1.9-2 2-2zM6.75 2.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-7.75-.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$6ae0cf80b0f94b21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication24Filled', "24", [
    "M13.11 13.61a5.5 5.5 0 0 1 7.78 7.78.75.75 0 0 1-1.06-1.06 4 4 0 1 0-5.66 0 .75.75 0 0 1-1.06 1.06 5.5 5.5 0 0 1 0-7.78M11.75 13q.26 0 .5.06a6.5 6.5 0 0 0-1.41 6.5A8 8 0 0 1 8 20c-6 0-6-4.5-6-4.5v-.25C2 14.01 3 13 4.25 13zm3.14 2.38a3 3 0 0 1 4.24 4.24.75.75 0 0 1-1.06-1.06 1.5 1.5 0 1 0-2.12 0 .75.75 0 0 1-1.06 1.06 3 3 0 0 1 0-4.24M8 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8m9 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
]);
const $76e5a570f6bfc30c$export$392b012ecb6e3ba7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication24Regular', "24", [
    "M13.11 13.61a5.5 5.5 0 0 1 7.78 7.78.75.75 0 0 1-1.06-1.06 4 4 0 1 0-5.66 0 .75.75 0 0 1-1.06 1.06 5.5 5.5 0 0 1 0-7.78M11.75 13q.26 0 .5.06-.6.64-1.02 1.44H4.25a.75.75 0 0 0-.75.75v.34l.06.32q.09.45.46 1.04c.5.7 1.56 1.55 3.98 1.55 1.1 0 1.91-.18 2.53-.43q.07.77.3 1.49A8 8 0 0 1 8 20c-2.83 0-4.39-1.03-5.2-2.2A4.5 4.5 0 0 1 2 15.74L2 15.25C2 14.01 3 13 4.25 13zm3.13 2.38a3 3 0 0 1 4.24 4.24.75.75 0 1 1-1.06-1.06 1.5 1.5 0 1 0-2.12 0 .75.75 0 0 1-1.06 1.06 3 3 0 0 1 0-4.24M8 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8m9 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-9-.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m9 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$a78fc27b24a61845 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication28Filled', "28", [
    "M15.4 15.9a6.5 6.5 0 0 1 9.2 9.2.75.75 0 0 1-1.06-1.06 5 5 0 1 0-7.08 0 .75.75 0 0 1-1.06 1.06 6.5 6.5 0 0 1 0-9.2m1.77 1.77a4 4 0 1 1 5.66 5.66.75.75 0 0 1-1.06-1.06 2.5 2.5 0 1 0-3.54 0 .75.75 0 0 1-1.06 1.06 4 4 0 0 1 0-5.66m-2.28-2.66a7.5 7.5 0 0 0-2.1 7.56q-1.34.42-3.29.43C2 23 2 17.75 2 17.75v-.5C2 16.01 3 15 4.25 15h10.64M9.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M20 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
]);
const $76e5a570f6bfc30c$export$db6990c6aa940e42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication28Regular', "28", [
    "M15.4 15.9a6.5 6.5 0 0 1 9.2 9.2.75.75 0 0 1-1.06-1.06 5 5 0 1 0-7.08 0 .75.75 0 0 1-1.06 1.06 6.5 6.5 0 0 1 0-9.2m1.77 1.77a4 4 0 1 1 5.66 5.66.75.75 0 0 1-1.06-1.06 2.5 2.5 0 1 0-3.54 0 .75.75 0 0 1-1.06 1.06 4 4 0 0 1 0-5.66m-2.28-2.66q-.71.66-1.23 1.49H4.25a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 1.26 0 2.25-.17 3.02-.42q.06.76.27 1.49-1.35.42-3.29.43C5.94 23 4 21.8 3 20.45a5 5 0 0 1-1-2.61v-.59C2 16.01 3 15 4.25 15h10.64M9.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M20 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M9.5 5.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m10.5 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$10f800d42f8a4688 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication32Filled', "32", [
    "M17.7 18.7a7.5 7.5 0 0 1 10.6 10.6 1 1 0 1 1-1.41-1.41 5.5 5.5 0 1 0-7.78 0 1 1 0 1 1-1.41 1.41 7.5 7.5 0 0 1 0-10.6m2.47 2.47a4 4 0 0 1 5.81 5.5 1 1 0 0 1-1.49-1.34 2 2 0 1 0-2.98 0 1 1 0 0 1-1.5 1.34 4 4 0 0 1 .16-5.5M16 17a3 3 0 0 1 1.1.2 9 9 0 0 0-2.97 8.35q-1.48.43-3.63.45C2.04 26 2 20.2 2 20.15V20a3 3 0 0 1 3-3zM10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $76e5a570f6bfc30c$export$43fae25d5b40084c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication32Regular', "32", [
    "M17.7 18.7a7.5 7.5 0 0 1 10.6 10.6 1 1 0 0 1-1.41-1.41 5.5 5.5 0 1 0-7.78 0 1 1 0 0 1-1.41 1.41 7.5 7.5 0 0 1 0-10.6m2.47 2.47a4 4 0 0 1 5.81 5.5 1 1 0 0 1-1.49-1.34 2 2 0 1 0-2.98 0 1 1 0 1 1-1.5 1.34 4 4 0 0 1 .16-5.5M16 17a3 3 0 0 1 1.1.2 9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1q0 .35.08.69c.1.35.28.82.65 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.44-3.63.45c-3.98 0-6.18-1.29-7.35-2.8a5.6 5.6 0 0 1-1.13-2.7L2 20a3 3 0 0 1 3-3zM10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8M10.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M23 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$e81ba8efe233c1a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication48Filled', "48", [
    "M26.22 27.22a11 11 0 0 1 15.56 15.56A1.25 1.25 0 0 1 40 41a8.5 8.5 0 1 0-12.02 0 1.25 1.25 0 0 1-1.77 1.77 11 11 0 0 1 0-15.56m3.18 3.18a6.5 6.5 0 0 1 9.2 9.2 1.25 1.25 0 0 1-1.77-1.77 4 4 0 1 0-5.66 0 1.25 1.25 0 0 1-1.77 1.77 6.5 6.5 0 0 1 0-9.2M25.25 25q.21 0 .42.02a13 13 0 0 0-4.24 13.32c-1.5.41-3.28.66-5.43.66-13 0-13-9-13-9v-1.25A3.75 3.75 0 0 1 6.75 25zM16 6a8 8 0 1 1 0 16 8 8 0 0 1 0-16m18 4a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
]);
const $76e5a570f6bfc30c$export$7ea51ec9203fa66d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunication48Regular', "48", [
    "M26.22 27.22a11 11 0 0 1 15.56 15.56A1.25 1.25 0 0 1 40 41a8.5 8.5 0 1 0-12.02 0 1.25 1.25 0 0 1-1.77 1.77 11 11 0 0 1 0-15.56m3.18 3.18a6.5 6.5 0 0 1 9.2 9.2 1.25 1.25 0 0 1-1.77-1.77 4 4 0 1 0-5.66 0 1.25 1.25 0 0 1-1.77 1.77 6.5 6.5 0 0 1 0-9.2M25.25 25q.21 0 .42.02-1.31 1.1-2.29 2.48H6.75c-.69 0-1.25.56-1.25 1.25v1.27q0 .06.02.18.01.25.13.7c.15.6.45 1.41 1.06 2.22C7.9 34.68 10.43 36.5 16 36.5c2.07 0 3.71-.25 5.03-.64q.09 1.28.4 2.48c-1.5.41-3.3.66-5.43.66-6.18 0-9.52-2.05-11.28-4.37A8.7 8.7 0 0 1 3 30.05v-1.3A3.75 3.75 0 0 1 6.75 25zM16 6a8 8 0 1 1 0 16 8 8 0 0 1 0-16m18 4a6 6 0 1 1 0 12 6 6 0 0 1 0-12M16 8.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m18 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $76e5a570f6bfc30c$export$cc600ac2ab9d9b61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity12Filled', "12", [
    "M4.25 3.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m-2 2.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11 4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5.25 6C4.56 6 4 6.56 4 7.25V8.5a2 2 0 1 0 4 0V7.25C8 6.56 7.44 6 6.75 6zM3 7.25q0-.43.15-.82l-1.23.33c-.66.18-1.06.87-.88 1.53l.2.73a2 2 0 0 0 2.44 1.41h.02C3.26 9.9 3 9.23 3 8.5zM9 8.5c0 .73-.26 1.4-.7 1.93h.02a2 2 0 0 0 2.45-1.41l.19-.73a1.25 1.25 0 0 0-.88-1.53l-1.23-.33q.15.39.15.82z"
]);
const $76e5a570f6bfc30c$export$85ba28ae50bac6ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity12Regular', "12", [
    "M6 2.5A.75.75 0 1 0 6 4a.75.75 0 0 0 0-1.5m-1.75.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0M2.5 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M1 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m8 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M9.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M4 7.25C4 6.56 4.56 6 5.25 6h1.5C7.44 6 8 6.56 8 7.25V8.5a2 2 0 1 1-4 0zM5.25 7a.25.25 0 0 0-.25.25V8.5a1 1 0 1 0 2 0V7.25A.25.25 0 0 0 6.75 7zM3 7.25q0-.43.15-.82l-1.23.33c-.66.18-1.06.87-.88 1.53l.2.73a2 2 0 0 0 2.44 1.41h.02a3 3 0 0 1-.53-.93 1 1 0 0 1-.97-.74L2 8.03a.25.25 0 0 1 .18-.3L3 7.5zm5.32 3.18H8.3a3 3 0 0 0 .53-.93 1 1 0 0 0 .97-.74l.2-.73a.25.25 0 0 0-.18-.3L9 7.5v-.26q0-.43-.15-.82l1.23.33c.66.18 1.06.87.88 1.53l-.2.73a2 2 0 0 1-2.44 1.41"
]);
const $76e5a570f6bfc30c$export$15d8da2dfff2b230 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_16_color__a)",
            "d": "M10.99 7.71a1.5 1.5 0 0 0-1.84 1.06l-.39 1.45a3 3 0 1 0 5.8 1.56l.39-1.45a1.5 1.5 0 0 0-1.06-1.84z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_16_color__b)",
            "d": "M5.01 7.71a1.5 1.5 0 0 1 1.84 1.06l.39 1.45a3 3 0 1 1-5.8 1.56l-.39-1.45a1.5 1.5 0 0 1 1.06-1.84z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_16_color__c)",
            "d": "M6.5 7C5.67 7 5 7.67 5 8.5V11a3 3 0 1 0 6 0V8.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_16_color__d)",
            "d": "M8 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_16_color__e)",
            "d": "M3 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_16_color__f)",
            "d": "M13 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -.34 11.3)scale(4.64914)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -5.47 6.14)scale(6.90379 4.96937)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.6 -3.91 10.71)scale(4.22417 3.87907)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 1.37 7.9)scale(3.12306)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -3.7 4.55)scale(3.27979)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 3.67 9.58)scale(2.93403)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$ba5e419f2764baa2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity16Filled', "16", [
    "M5.5 3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m1 3.5C5.67 7 5 7.67 5 8.5V11a3 3 0 1 0 6 0V8.5c0-.83-.67-1.5-1.5-1.5zm-2.44.97Q4 8.23 4 8.5V11c0 1.13.46 2.14 1.21 2.87l-.1.03a3 3 0 0 1-3.67-2.12l-.39-1.45a1.5 1.5 0 0 1 1.06-1.84zm6.73 5.9A4 4 0 0 0 12 11V8.5q0-.27-.06-.53l1.95.52a1.5 1.5 0 0 1 1.06 1.84l-.39 1.45a3 3 0 0 1-3.77 2.09M1 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m10 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
]);
const $76e5a570f6bfc30c$export$f81a233aec0a29ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity16Regular', "16", [
    "M8 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5.5 3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M4 8.5q0-.27.06-.53l-1.95.52a1.5 1.5 0 0 0-1.06 1.84l.39 1.45a3 3 0 0 0 3.77 2.09q-.4-.39-.68-.88a2 2 0 0 1-2.12-1.47L2 10.07a.5.5 0 0 1 .36-.61L4 9.02zm6.89 5.4-.1-.03q.4-.39.68-.88a2 2 0 0 0 2.12-1.47l.4-1.45a.5.5 0 0 0-.36-.61L12 9.02V8.5q0-.27-.06-.53l1.95.52a1.5 1.5 0 0 1 1.06 1.84l-.39 1.45a3 3 0 0 1-3.67 2.12M2 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m10 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M6.5 7C5.67 7 5 7.67 5 8.5V11a3 3 0 1 0 6 0V8.5c0-.83-.67-1.5-1.5-1.5zM6 8.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V11a2 2 0 1 1-4 0z"
]);
const $76e5a570f6bfc30c$export$6d32535621b98cd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__a)",
            "d": "M13.06 9.49a1.5 1.5 0 0 0-1.84 1.06l-.64 2.42a4 4 0 0 0 7.73 2.07l.64-2.42a1.5 1.5 0 0 0-1.06-1.84z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__b)",
            "d": "M6.94 9.49a1.5 1.5 0 0 1 1.84 1.06l.65 2.42a4 4 0 1 1-7.73 2.07l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__c)",
            "d": "M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__d)",
            "d": "M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__e)",
            "d": "M3.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__f)",
            "d": "M7.5 9C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 8 0v-3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -.53 14.04)scale(6.28119)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -6.8 7.55)scale(9.32732 6.71383)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 1.15 10.22)scale(3.74767)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 4.56 12.25)scale(3.66754)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -5.03 5.53)scale(4.09974)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.77 -5.35 13.64)scale(5.47141 5.13397)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$fed501630fbcf598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity20Filled', "20", [
    "M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-4.95 8q-.05.24-.05.5V14c0 1.53.69 2.9 1.77 3.81l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zm8.18 7.81A5 5 0 0 0 15 14v-3.5q0-.26-.05-.5l2.94.78a1.5 1.5 0 0 1 1.06 1.84l-.64 2.42a4 4 0 0 1-5.07 2.77M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4 5C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 8 0v-3.5c0-.83-.67-1.5-1.5-1.5z"
]);
const $76e5a570f6bfc30c$export$9e29fa340624c3fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity20Regular', "20", [
    "M10 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1.95 5q-.05.24-.05.5v.54l-2.63.71a.5.5 0 0 0-.35.61l.64 2.42a3 3 0 0 0 3.32 2.2q.35.45.79.83l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zM15 11.04v-.54q0-.26-.05-.5l2.94.78a1.5 1.5 0 0 1 1.06 1.84l-.64 2.42a4 4 0 0 1-5.07 2.77q.44-.37.78-.84a3 3 0 0 0 3.32-2.2l.65-2.4a.5.5 0 0 0-.36-.62zm0-4.54a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M7.5 9C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 8 0v-3.5c0-.83-.67-1.5-1.5-1.5zM7 10.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V14a3 3 0 1 1-6 0z"
]);
const $76e5a570f6bfc30c$export$8ac0103db71a88ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_24_color__a)",
            "d": "M12 3a3.25 3.25 0 1 0 0 6.5A3.25 3.25 0 0 0 12 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_24_color__b)",
            "d": "M5 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_24_color__c)",
            "d": "M19 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_24_color__d)",
            "d": "M15.39 11.44c-.93-.25-1.9.3-2.14 1.24l-.71 2.66a4.5 4.5 0 0 0 8.69 2.32l.71-2.65c.25-.94-.3-1.9-1.24-2.14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_24_color__e)",
            "d": "M8.6 11.44c.94-.25 1.9.3 2.15 1.24l.71 2.66a4.5 4.5 0 0 1-8.69 2.32l-.71-2.65c-.25-.94.3-1.9 1.24-2.14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_24_color__f)",
            "d": "M9.25 11c-.97 0-1.75.78-1.75 1.75v3.75a4.5 4.5 0 1 0 9 0v-3.75c0-.97-.78-1.75-1.75-1.75z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 1.1 12.5)scale(4.05997)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -5.87 7.65)scale(4.91969)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 4.95 14.31)scale(4.40105)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -.74 16.56)scale(7.05605)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -7.85 9.61)scale(10.478 7.54206)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.48 -6.4 16.43)scale(6.09533 5.76056)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$86831c0d638a871 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity24Filled', "24", [
    "M8.75 6.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M5 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m14 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-9.75 6c-.97 0-1.75.78-1.75 1.75v3.75a4.5 4.5 0 1 0 9 0v-3.75c0-.97-.78-1.75-1.75-1.75zm-2.64.98q-.1.36-.11.77v3.75c0 1.72.8 3.26 2.03 4.27a4.5 4.5 0 0 1-5.76-3.1L2.06 15c-.25-.94.3-1.9 1.24-2.14zm8.86 8.8a5.5 5.5 0 0 0 2.03-4.28v-3.75q0-.4-.11-.77l3.31.89A1.75 1.75 0 0 1 21.94 15l-.71 2.65a4.5 4.5 0 0 1-5.76 3.11"
]);
const $76e5a570f6bfc30c$export$6b226e7b0e96d262 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity24Regular', "24", [
    "M12 4.5A1.75 1.75 0 1 0 12 8a1.75 1.75 0 0 0 0-3.5M8.75 6.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m15.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M19 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7.5 12.75c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v3.75a4.5 4.5 0 1 1-9 0zm1.75-.25a.25.25 0 0 0-.25.25v3.75a3 3 0 1 0 6 0v-3.75a.25.25 0 0 0-.25-.25zm-2.64-.52q-.1.36-.11.77v.81l-2.81.75a.25.25 0 0 0-.18.31l.71 2.66a3 3 0 0 0 3.16 2.2q.48.75 1.15 1.3a4.5 4.5 0 0 1-5.76-3.12l-.71-2.65c-.25-.94.3-1.9 1.24-2.14zm8.86 8.8.25.07a4.5 4.5 0 0 0 5.5-3.19l.72-2.65c.25-.94-.3-1.9-1.24-2.14l-3.31-.9q.1.38.11.78v.81l2.82.75c.13.04.2.18.17.31l-.7 2.66a3 3 0 0 1-3.17 2.2q-.48.75-1.15 1.3"
]);
const $76e5a570f6bfc30c$export$22b957f84737ad2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_28_color__a)",
            "d": "M5.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_28_color__b)",
            "d": "M22.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_28_color__c)",
            "d": "M14 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_28_color__d)",
            "d": "M18.43 14.33c-.94-.25-1.9.3-2.15 1.24l-.84 3.14a5 5 0 0 0 9.66 2.59l.84-3.14c.25-.94-.3-1.9-1.23-2.15z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_28_color__e)",
            "d": "M9.58 14.33c.93-.25 1.89.3 2.14 1.24l.84 3.14A5 5 0 0 1 2.9 21.3l-.84-3.14c-.25-.94.3-1.9 1.24-2.15z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_28_color__f)",
            "d": "M10.75 13C9.78 13 9 13.78 9 14.75V20a5 5 0 0 0 10 0v-5.25c0-.97-.78-1.75-1.75-1.75z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_28_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -7.2 8.63)scale(5.73964)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 5.84 16.98)scale(5.13456)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 1.58 14.38)scale(4.99689)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_28_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -1.05 20.15)scale(7.87208)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_28_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -10.21 11.31)scale(11.6897 8.41429)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_28_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(64.24 -7.19 18.99)scale(7.20213 6.5004)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$a9b9ea6dd4765a7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity28Filled', "28", [
    "M14 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M22.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-11.75 7C9.78 13 9 13.78 9 14.75V20a5 5 0 0 0 10 0v-5.25c0-.97-.78-1.75-1.75-1.75zM8 14.75l-4.7 1.26a1.75 1.75 0 0 0-1.24 2.15l.84 3.14A5 5 0 0 0 10 24.46 6 6 0 0 1 8 20zm10.01 9.71a5.02 5.02 0 0 0 7.1-3.16l.83-3.14c.25-.94-.3-1.9-1.23-2.15L20 14.75V20c0 1.77-.77 3.36-1.99 4.46"
]);
const $76e5a570f6bfc30c$export$b446aa7dc6316d90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity28Regular', "28", [
    "M11.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M5.5 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4M2 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m20.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M9 14.75c0-.97.78-1.75 1.75-1.75h6.5c.97 0 1.75.78 1.75 1.75V20a5 5 0 0 1-10 0zm1.75-.25a.25.25 0 0 0-.25.25V20a3.5 3.5 0 1 0 7 0v-5.25a.25.25 0 0 0-.25-.25zM8 14.75l-4.7 1.26a1.75 1.75 0 0 0-1.24 2.15l.84 3.14A5 5 0 0 0 10 24.46a6 6 0 0 1-1.02-1.19 3.5 3.5 0 0 1-4.62-2.36l-.84-3.14a.25.25 0 0 1 .18-.3L8 16.3zm10.01 9.71a5.02 5.02 0 0 0 7.1-3.16l.83-3.14c.25-.94-.3-1.9-1.23-2.15L20 14.75v1.55l4.32 1.16c.13.04.21.17.17.3l-.84 3.15a3.5 3.5 0 0 1-4.62 2.36q-.44.66-1.02 1.2"
]);
const $76e5a570f6bfc30c$export$e59d1c4a7652b23d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_32_color__a)",
            "d": "M16 3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_32_color__b)",
            "d": "M6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_32_color__c)",
            "d": "M26 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_32_color__d)",
            "d": "M21.38 15.3a2.5 2.5 0 0 0-3.06 1.76l-.9 3.38A6 6 0 0 0 29 23.55l.9-3.38a2.5 2.5 0 0 0-1.77-3.06z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_32_color__e)",
            "d": "M10.61 15.3a2.5 2.5 0 0 1 3.07 1.76l.9 3.38A6 6 0 1 1 3 23.55l-.9-3.38a2.5 2.5 0 0 1 1.76-3.06z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_32_color__f)",
            "d": "M12.5 14a2.5 2.5 0 0 0-2.5 2.5V22a6 6 0 0 0 12 0v-5.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_32_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 2.22 16.2)scale(5.6215)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -7.4 9.1)scale(6.55959)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 7.34 19.16)scale(5.86806)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -.66 22.5)scale(9.38062)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -10.84 12.26)scale(13.9298 10.0267)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.6 -7.83 21.43)scale(8.44834 7.75814)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$bcf4e50dacbe3b41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity32Filled', "32", [
    "M11.5 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8m20 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8M8.5 16.5q0-.33.05-.65l-4.7 1.26a2.5 2.5 0 0 0-1.76 3.06l.9 3.38a6 6 0 0 0 8 4.03A7.5 7.5 0 0 1 8.5 22zm15 5.5c0 2.22-.96 4.2-2.49 5.58q.32.12.65.21A6 6 0 0 0 29 23.55l.9-3.38a2.5 2.5 0 0 0-1.77-3.06l-4.7-1.26q.06.32.06.65zm-11-8a2.5 2.5 0 0 0-2.5 2.5V22a6 6 0 0 0 12 0v-5.5a2.5 2.5 0 0 0-2.5-2.5z"
]);
const $76e5a570f6bfc30c$export$1321da0e310182ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity32Light', "32", [
    "M16 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-4.5 3.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M6 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-4 3a4 4 0 1 1 8 0 4 4 0 0 1-8 0m21 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M10 16.5a2.5 2.5 0 0 1 2.5-2.5h7a2.5 2.5 0 0 1 2.5 2.5V22a6 6 0 0 1-12 0zm2.5-1.5c-.83 0-1.5.67-1.5 1.5V22a5 5 0 0 0 10 0v-5.5c0-.83-.67-1.5-1.5-1.5zm-3.41.7q-.09.4-.09.8v.27l-4.89 1.3a1.5 1.5 0 0 0-1.06 1.84l.9 3.38a5 5 0 0 0 6.78 3.32q.36.4.76.75-.54.27-1.15.44a6 6 0 0 1-7.35-4.25l-.9-3.38a2.5 2.5 0 0 1 1.76-3.06zm11.42 11.66a6.02 6.02 0 0 0 8.5-3.8l.9-3.39a2.5 2.5 0 0 0-1.76-3.06l-5.24-1.4q.09.38.09.79v.27l4.89 1.3a1.5 1.5 0 0 1 1.06 1.84l-.9 3.38a5 5 0 0 1-6.78 3.32q-.35.4-.76.75"
]);
const $76e5a570f6bfc30c$export$34b25eff6568cb54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity32Regular', "32", [
    "M16 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-4.5 2.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M6 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0m22 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M8.5 16.5q0-.33.05-.65l-4.7 1.26a2.5 2.5 0 0 0-1.76 3.06l.9 3.38a6 6 0 0 0 8 4.03q-.8-.73-1.39-1.67a4 4 0 0 1-4.68-2.88l-.9-3.38a.5.5 0 0 1 .35-.61l4.13-1.1zm13.16 11.3-.65-.22q.8-.72 1.39-1.67a4 4 0 0 0 4.67-2.88l.9-3.38a.5.5 0 0 0-.34-.61l-4.13-1.1V16.5q0-.33-.05-.65l4.7 1.26a2.5 2.5 0 0 1 1.76 3.06l-.9 3.38a6 6 0 0 1-7.35 4.24M12.5 14a2.5 2.5 0 0 0-2.5 2.5V22a6 6 0 0 0 12 0v-5.5a2.5 2.5 0 0 0-2.5-2.5zm-.5 2.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5V22a4 4 0 0 1-8 0z"
]);
const $76e5a570f6bfc30c$export$8747258d12d6dfec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_48_color__a)",
            "d": "M24 5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_48_color__b)",
            "d": "M9.5 9a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_48_color__c)",
            "d": "M38.5 9a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_48_color__d)",
            "d": "M30.48 21.82a3.25 3.25 0 0 0-3.98 2.3L25 29.67a9 9 0 1 0 17.4 4.66l1.48-5.56a3.25 3.25 0 0 0-2.3-3.98z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_48_color__e)",
            "d": "M17.52 21.82a3.25 3.25 0 0 1 3.98 2.3L23 29.67A9 9 0 1 1 5.6 34.33l-1.48-5.56a3.25 3.25 0 0 1 2.3-3.98z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_48_color__f)",
            "d": "M18.25 21A3.25 3.25 0 0 0 15 24.25V32a9 9 0 1 0 18 0v-7.75c0-1.8-1.46-3.25-3.25-3.25z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_48_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 3.08 24.51)scale(8.11995)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -10.4 14.32)scale(9.01943)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 11.02 28.39)scale(8.06859)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_48_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -.87 32.57)scale(14.1533)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_48_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -14.8 18.7)scale(21.017 15.1281)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_48_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.48 -11.97 32.37)scale(12.1907 11.5211)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$aa3082ea69b100b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity48Filled', "48", [
    "M17.5 11.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0M9.5 9a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m29 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M18.25 21A3.25 3.25 0 0 0 15 24.25V32a9 9 0 1 0 18 0v-7.75c0-1.8-1.46-3.25-3.25-3.25zm-5.1 1.99q-.15.6-.15 1.26V32c0 3.46 1.6 6.54 4.09 8.56q-.22.08-.46.13A9 9 0 0 1 5.6 34.33l-1.48-5.55a3.25 3.25 0 0 1 2.3-3.99zm17.76 17.57C33.41 38.54 35 35.46 35 32v-7.75q0-.65-.15-1.26l6.74 1.8a3.25 3.25 0 0 1 2.3 3.99l-1.5 5.55a9 9 0 0 1-11.48 6.23"
]);
const $76e5a570f6bfc30c$export$6f790c5c8c8026d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunity48Regular', "48", [
    "M24 7.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.5 4a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0m-8 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-5.5 3a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m31.5 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M15 24.25c0-1.8 1.46-3.25 3.25-3.25h11.5c1.8 0 3.25 1.46 3.25 3.25V32a9 9 0 1 1-18 0zm3.25-.75a.75.75 0 0 0-.75.75V32a6.5 6.5 0 1 0 13 0v-7.75a.75.75 0 0 0-.75-.75zm-5.1-.51q-.15.6-.15 1.26v1.37L7.06 27.2c-.4.1-.64.52-.53.92l1.49 5.55a6.5 6.5 0 0 0 7.07 4.77q.86 1.2 2 2.1-.22.09-.46.14A9 9 0 0 1 5.6 34.33l-1.48-5.55a3.25 3.25 0 0 1 2.3-3.99zm17.76 17.57q.22.08.46.13a9 9 0 0 0 11.03-6.36l1.48-5.55a3.25 3.25 0 0 0-2.3-3.99L34.86 23q.15.6.15 1.26v1.37l5.94 1.59c.4.1.64.52.53.92l-1.49 5.55a6.5 6.5 0 0 1-7.07 4.77q-.86 1.2-2 2.1"
]);
const $76e5a570f6bfc30c$export$2796efe87c229cf7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAdd20Filled', "20", [
    "M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-4.95 8q-.05.24-.05.5V14c0 1.53.69 2.9 1.77 3.81l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zM16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4 5C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 4.25 4 5.5 5.5 0 0 1 2.92-8.83 1.5 1.5 0 0 0-.67-.17zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$2f2a8642ca83c5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAdd20Regular', "20", [
    "M10 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1.95 5q-.05.24-.05.5v.54l-2.63.71a.5.5 0 0 0-.35.61l.64 2.42a3 3 0 0 0 3.32 2.2q.35.45.79.83l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zM15 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M7.5 9C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 4.25 4 6 6 0 0 1-.66-1.03A3 3 0 0 1 7 14v-3.5c0-.28.22-.5.5-.5h3.84a6 6 0 0 1 1.84-.84A1.5 1.5 0 0 0 12.5 9zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$a9050849da5e4f66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAdd24Filled', "24", [
    "M8.75 6.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M5 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m14 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-9.75 6c-.97 0-1.75.78-1.75 1.75v3.75A4.5 4.5 0 0 0 12 21h.02a6.5 6.5 0 0 1 3.65-9.74 2 2 0 0 0-.92-.26zm-2.64.98q-.1.36-.11.77v3.75c0 1.72.8 3.26 2.03 4.27a4.5 4.5 0 0 1-5.76-3.1L2.06 15c-.25-.94.3-1.9 1.24-2.14zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$65183cec82edb638 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAdd24Regular', "24", [
    "M12 4.5A1.75 1.75 0 1 0 12 8a1.75 1.75 0 0 0 0-3.5M8.75 6.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m15.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M19 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7.5 12.75c0-.97.78-1.75 1.75-1.75h5.5q.51.01.92.26-1.3.39-2.32 1.24h-4.1a.25.25 0 0 0-.25.25v3.75a3 3 0 0 0 2.29 2.91q.26.86.73 1.59H12a4.5 4.5 0 0 1-4.5-4.5zm-.89-.77q-.1.36-.11.77v.81l-2.81.75a.25.25 0 0 0-.18.31l.71 2.66a3 3 0 0 0 3.16 2.2q.48.75 1.15 1.3a4.5 4.5 0 0 1-5.76-3.12l-.71-2.65c-.25-.94.3-1.9 1.24-2.14zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$ea09f99e25fd30a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAdd28Filled', "28", [
    "M14 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M22.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-11.75 7C9.78 13 9 13.78 9 14.75V20a5 5 0 0 0 5.48 4.98 7.5 7.5 0 0 1 3.8-11.64 1.7 1.7 0 0 0-1.03-.34zM8 14.75l-4.7 1.26a1.75 1.75 0 0 0-1.24 2.15l.84 3.14A5 5 0 0 0 10 24.46 6 6 0 0 1 8 20zm19 5.75a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $76e5a570f6bfc30c$export$d183bcf9638bcdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAdd28Regular', "28", [
    "M11.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M5.5 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4M2 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m20.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M9 14.75c0-.97.78-1.75 1.75-1.75h6.5q.58 0 1.03.33-1.25.4-2.28 1.17h-5.25a.25.25 0 0 0-.25.25V20a3.5 3.5 0 0 0 3.12 3.48q.35.8.86 1.5L14 25a5 5 0 0 1-5-5zm-1 0-4.7 1.26a1.75 1.75 0 0 0-1.24 2.15l.84 3.14A5 5 0 0 0 10 24.46a6 6 0 0 1-1.02-1.19 3.5 3.5 0 0 1-4.62-2.36l-.84-3.14a.25.25 0 0 1 .18-.3L8 16.3zm19 5.75a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $76e5a570f6bfc30c$export$da28e7c3090dfc44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit16Filled', "16", [
    "M12.81 7.55a1.87 1.87 0 1 1 2.64 2.64l-4.82 4.83a2 2 0 0 1-1.03.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02zM7.5 8a2 2 0 0 1 1.94 1.5l-2.17 2.17a3 3 0 0 0-.74 1.16Q5.8 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$cf1d358770e440be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit16Regular', "16", [
    "M12.81 7.55a1.87 1.87 0 1 1 2.64 2.64l-4.82 4.83a2 2 0 0 1-1.03.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02zM7.5 8a2 2 0 0 1 1.94 1.5l-1.09 1.1q.15-.3.15-.6a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12s1.94-.24 2.57-.62l-.3.29a3 3 0 0 0-.74 1.16Q5.8 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm4.23-5.5a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 11.5 7L11.27 7a2.25 2.25 0 0 1-2-2.01l-.02-.23c0-1.24 1-2.25 2.25-2.25zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$d2b804065be9c143 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M10 10a2 2 0 0 1 2 1.94l-1.73 1.73q-.61.63-.84 1.49l-.1.42q-1 .4-2.58.42C1.5 16 1.5 12 1.5 12c0-1.1.9-2 2-2zm7-3.5A2.5 2.5 0 0 1 14.5 9 2.5 2.5 0 1 1 17 6.5m-1.2 3.05-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64"
]);
const $76e5a570f6bfc30c$export$af12054c2d23ddf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M10 10a2 2 0 0 1 2 1.94l-1.42 1.42a3 3 0 0 0 .42-1.28V12a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c1.56 0 2.53-.39 3.14-.86q-.32.46-.46 1.02l-.1.42a7 7 0 0 1-2.58.42c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12c0-1.1.9-2 2-2zm7-3.5A2.5 2.5 0 0 1 14.5 9 2.5 2.5 0 1 1 17 6.5m-4 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m2.8 3.05-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64"
]);
const $76e5a570f6bfc30c$export$b8fcb332511f527e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit24Filled', "24", [
    "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m8 1a3 3 0 1 1-6 0 3 3 0 0 1 6 0M2 16.25C2 15.01 3 14 4.25 14h7.5c1.24 0 2.25 1 2.25 2.25v.1l-1.5 1.51q-.73.73-.98 1.72l-.2.79c-.82.38-1.9.63-3.32.63-6 0-6-4.5-6-4.5zm17.1-3.58-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $76e5a570f6bfc30c$export$ce350eb65036e24d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit24Regular', "24", [
    "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M14 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0M2 16.25C2 15.01 3 14 4.25 14h7.5c1.24 0 2.25 1 2.25 2.25v.1l-1.5 1.51q-.73.73-.98 1.72l-.2.78C10.5 20.75 9.4 21 8 21c-2.83 0-4.39-1.03-5.2-2.2a4.5 4.5 0 0 1-.8-2.27v-.28m1.5.24v.1l.06.33c.07.28.2.65.46 1.02.5.71 1.56 1.56 3.98 1.56s3.49-.85 3.98-1.56a3 3 0 0 0 .52-1.43v-.26a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75zm15.6-3.82-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $76e5a570f6bfc30c$export$946f9638d0c0f8dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit32Filled', "32", [
    "M16 9.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M27 11a4 4 0 1 1-8 0 4 4 0 0 1 8 0M2 20a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v.15s0 1.18-.77 2.48l-2 2.02c-1.26.78-3.08 1.35-5.73 1.35C2 26 2 20.15 2 20.15zm27.64 1.42-8.6 8.55q-.55.53-1.27.72l-3.02.78a1 1 0 0 1-1.22-1.22l.79-3.05q.18-.7.69-1.21l8.56-8.64a2.88 2.88 0 1 1 4.07 4.07"
]);
const $76e5a570f6bfc30c$export$a0d0385d3f4c5ff0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit32Light', "32", [
    "M10.5 5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M5 9.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M23 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-4 3a4 4 0 1 1 8 0 4 4 0 0 1-8 0M2 20a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3c0 .74-.18 1.65-.68 2.54l-2.14 2.15c-1.3.8-3.15 1.31-5.68 1.31-3.34 0-5.48-.9-6.78-2.14A5.4 5.4 0 0 1 2 20m3-2a2 2 0 0 0-2 2c0 .88.33 2.12 1.4 3.14C5.49 24.15 7.35 25 10.5 25s5.02-.85 6.1-1.86A4.4 4.4 0 0 0 18 20a2 2 0 0 0-2-2zm24.64 3.42-8.6 8.55q-.55.53-1.27.72l-3.02.78a1 1 0 0 1-1.22-1.22l.79-3.05q.18-.7.69-1.21l8.56-8.64a2.88 2.88 0 1 1 4.07 4.07"
]);
const $76e5a570f6bfc30c$export$1a29c3b1c22a33f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEdit32Regular', "32", [
    "M10.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M5 9.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M23 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0M5 17a3 3 0 0 0-3 3v.23l.02.27q.03.27.13.7c.14.55.43 1.28 1 2C4.32 24.72 6.52 26 10.5 26c2.6 0 4.43-.55 5.72-1.34l2.05-2.07a5.5 5.5 0 0 0 .73-2.36V20a3 3 0 0 0-3-3zm-1 3.19V20a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v.29l-.09.4c-.09.35-.27.82-.64 1.29-.7.9-2.25 2.02-5.77 2.02s-5.07-1.12-5.77-2.02A3.6 3.6 0 0 1 4 20.19m25.64 1.23-8.6 8.55q-.55.53-1.27.72l-3.02.78a1 1 0 0 1-1.22-1.22l.79-3.05q.18-.7.69-1.21l8.56-8.64a2.88 2.88 0 1 1 4.07 4.07"
]);
const $76e5a570f6bfc30c$export$b39b8d1899078de0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleError16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 5.88a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24M7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm4.24 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$5782ca5260a5e4cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleError16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 5.88a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24M7.26 8q-.39.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm4.24 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$5be6f53ccb499cab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleError20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $76e5a570f6bfc30c$export$1b50bfcd0021887e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleError20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $76e5a570f6bfc30c$export$fb9edb45d82c7726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleError24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20a8 8 0 0 0 3.28-.61 6.5 6.5 0 0 1 1.36-6.2 2 2 0 0 0-.89-.19zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M17.5 14a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m0 7.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25"
]);
const $76e5a570f6bfc30c$export$4533504c1e6fa3ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleError24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.37 0 2.44-.24 3.28-.62a7 7 0 0 1-.27-1.55c-.65.38-1.6.67-3.01.67-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.48q.38-.72.91-1.32a2 2 0 0 0-.89-.18zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M17.5 14a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m0 7.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25"
]);
const $76e5a570f6bfc30c$export$660d6d99c484872b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEye16Filled', "16", [
    "M11.5 8c2.76 0 4.5 2.3 4.5 3.5 0 1.18-1.74 3.5-4.5 3.5S7 12.7 7 11.5C7 10.32 8.74 8 11.5 8m.96 1.19a2.5 2.5 0 1 0-1.92 4.62 2.5 2.5 0 0 0 1.92-4.62M7.5 8a2 2 0 0 1 .61.1 6 6 0 0 0-1.68 1.88c-.25.47-.43 1-.43 1.52q.01.67.35 1.37Q5.71 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm4 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$f9098723995cb8a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEye16Regular', "16", [
    "M11.5 8c2.76 0 4.5 2.3 4.5 3.5 0 1.18-1.74 3.5-4.5 3.5S7 12.7 7 11.5C7 10.32 8.74 8 11.5 8m.96 1.19a2.5 2.5 0 1 0-1.92 4.62 2.5 2.5 0 0 0 1.92-4.62M7.5 8a2 2 0 0 1 .61.1 6 6 0 0 0-.99.9H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.04-.09.08.48.31.96Q5.71 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm4 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 11.5 7h-.02l-.22-.01a2.25 2.25 0 0 1-2-2.01l-.02-.23c0-1.24 1-2.25 2.25-2.25zm-.23 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$3a85fe6f1d25c00f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEye20Filled', "20", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-11 1a2 2 0 0 0-2 2s0 4 5.25 4q1.5-.02 2.49-.39A3 3 0 0 1 9 14.5c0-.52.18-1.05.43-1.52a5.5 5.5 0 0 1 2.16-2.2A2 2 0 0 0 10 10zm11 1c-2.76 0-4.5 2.32-4.5 3.5 0 1.2 1.74 3.5 4.5 3.5s4.5-2.32 4.5-3.5c0-1.2-1.74-3.5-4.5-3.5m0 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m1.5-2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $76e5a570f6bfc30c$export$ea9d214ca0ceb61e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEye20Regular', "20", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m8.1 5.04A2 2 0 0 0 10 10H3.5a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.5-.02 2.49-.39a3 3 0 0 1-.24-.98q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10a1 1 0 0 1 .77.36q.37-.3.82-.57M14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5 4.5c-2.76 0-4.5 2.32-4.5 3.5 0 1.2 1.74 3.5 4.5 3.5s4.5-2.32 4.5-3.5c0-1.2-1.74-3.5-4.5-3.5m0 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m1.5-2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $76e5a570f6bfc30c$export$8dc719e09a02a180 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleGameController20Filled', "20", [
    "m16.27 10.21.36.05h.03q.6.07.92.24a1 1 0 0 1 .4.43l.02.02a15 15 0 0 1 1.47 4.15v.04q.12 1.16-.31 1.75c-.28.41-.68.57-1 .6q-.1.02-.26-.02a1 1 0 0 1-.25-.13q-.2-.13-.51-.47-.36-.36-.56-.61v-.01c-.19-.21-.39-.46-.62-.62a.7.7 0 0 0-.46-.13h-2c-.48 0-.79.42-1.07.75q-.22.26-.57.62-.32.34-.5.47a1 1 0 0 1-.26.13q-.16.04-.27.03c-.31-.04-.7-.2-.99-.6q-.42-.6-.32-1.76v-.02l.01-.02c.22-1.1.66-2.67 1.47-4.15l.01-.02a1 1 0 0 1 .41-.43q.32-.17.92-.24h.03l.36-.05h.3q.16 0 .4.12l.21.17h1.66l.28-.17c.14-.09.3-.1.39-.12zM9.5 9.5q.63.01 1.12.34c-.29.24-.43.5-.49.6v.02a15 15 0 0 0-1.48 3.99q-.1.36-.13.73-.93.31-2.27.32c-2.51 0-3.87-.92-4.57-1.93A4 4 0 0 1 1 11.5c0-1.1.9-2 2-2zm5 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M6.25 2a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $76e5a570f6bfc30c$export$d95c509d62ff9928 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleGameController20Regular', "20", [
    "m16.27 10.21.36.05h.03q.6.07.92.24a1 1 0 0 1 .4.43l.02.02a15 15 0 0 1 1.47 4.15v.04q.12 1.16-.31 1.75c-.28.41-.68.57-1 .6q-.1.02-.26-.02a1 1 0 0 1-.25-.13q-.2-.13-.51-.47-.36-.36-.56-.61v-.01c-.3-.33-.6-.75-1.08-.75h-2c-.48 0-.79.42-1.07.75q-.22.26-.57.62-.32.34-.5.47a1 1 0 0 1-.26.13q-.16.04-.27.03c-.31-.04-.7-.2-.99-.6q-.42-.6-.32-1.76v-.02l.01-.02c.22-1.1.66-2.67 1.47-4.15l.01-.02a1 1 0 0 1 .41-.43q.32-.17.92-.24h.03l.36-.05h.3q.16 0 .4.12l.21.17h1.66l.28-.17c.14-.09.3-.1.39-.12zM9.5 9.5q.63.01 1.12.34c-.29.24-.43.5-.49.6v.02l-.1.2a1 1 0 0 0-.53-.16H3a1 1 0 0 0-1 1q0 .25.06.49c.07.27.2.64.44 1 .5.71 1.51 1.51 3.75 1.51 1.1 0 1.9-.2 2.5-.47l-.1.42q-.1.36-.13.73-.93.31-2.27.32c-2.51 0-3.87-.92-4.57-1.93A4 4 0 0 1 1 11.5c0-1.1.9-2 2-2zm5 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M6.25 2a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M6.25 3a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$feca10c89e1c18f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHome16Color', "16", [
    [
        "g",
        {
            "clipPath": "url(#ic_fluent_people_home_16_color__a)"
        },
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__b)",
                "d": "M10.5 8c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5C2 8.67 2.67 8 3.5 8z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__c)",
                "d": "M10.5 8c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5C2 8.67 2.67 8 3.5 8z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__d)",
                "fillOpacity": ".75",
                "d": "M10.5 8c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5C2 8.67 2.67 8 3.5 8z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__e)",
                "fillOpacity": ".55",
                "d": "M10.5 8c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4s-5-2.03-5-4v-.5C2 8.67 2.67 8 3.5 8z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__f)",
                "d": "M7 1.5A2.75 2.75 0 1 1 7 7a2.75 2.75 0 0 1 0-5.5"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__g)",
                "d": "M10 11h3v4h-3z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__h)",
                "d": "M8 11.46a1 1 0 0 1 .35-.76l2.83-2.42a.5.5 0 0 1 .65 0l2.82 2.42a1 1 0 0 1 .35.76v3.04a.5.5 0 0 1-.5.5h-2v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V15h-2a.5.5 0 0 1-.5-.5z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_16_color__i)",
                "fillRule": "evenodd",
                "d": "M10.52 7.36a1.5 1.5 0 0 1 1.96 0l3.26 2.82a.75.75 0 0 1-.98 1.14L11.5 8.49l-3.26 2.83a.75.75 0 0 1-.98-1.14z",
                "clipRule": "evenodd"
            }
        ]
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_16_color__b",
                "x1": "4.38",
                "x2": "6.62",
                "y1": "8.8",
                "y2": "14.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_16_color__c",
                "x1": "7",
                "x2": "10.16",
                "y1": "7.29",
                "y2": "17.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_16_color__f",
                "x1": "5.56",
                "x2": "8.36",
                "y1": "2.23",
                "y2": "6.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_16_color__g",
                "x1": "11.5",
                "x2": "8.85",
                "y1": "11",
                "y2": "15.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_16_color__h",
                "x1": "7.76",
                "x2": "14.12",
                "y1": "8.35",
                "y2": "14.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_16_color__i",
                "x1": "11.93",
                "x2": "11.19",
                "y1": "5.71",
                "y2": "11.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -2.5 1.80804 0 9 13.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2 -1.66667 0 8 11)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "clipPath",
            {
                "id": "ic_fluent_people_home_16_color__a"
            },
            [
                "path",
                {
                    "fill": "#fff",
                    "d": "M0 0h16v16H0z"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$d7a28cd3b80974fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHome20Color', "20", [
    [
        "g",
        {
            "clipPath": "url(#ic_fluent_people_home_20_color__a)"
        },
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__b)",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__c)",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__d)",
                "fillOpacity": ".75",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__e)",
                "fillOpacity": ".55",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__f)",
                "fillOpacity": ".55",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__g)",
                "d": "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__h)",
                "d": "M14 15h3v4h-3z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__i)",
                "d": "M12 15.46a1 1 0 0 1 .35-.76l2.83-2.42a.5.5 0 0 1 .65 0l2.82 2.42a1 1 0 0 1 .35.76v3.04a.5.5 0 0 1-.5.5h-2v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V19h-2a.5.5 0 0 1-.5-.5z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__j)",
                "fillRule": "evenodd",
                "d": "M14.52 11.36a1.5 1.5 0 0 1 1.96 0l3.26 2.82a.75.75 0 1 1-.98 1.14l-3.26-2.83-3.26 2.83a.75.75 0 1 1-.98-1.14z",
                "clipRule": "evenodd"
            }
        ]
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__b",
                "x1": "6.33",
                "x2": "8.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__c",
                "x1": "10",
                "x2": "13.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__g",
                "x1": "7.9",
                "x2": "11.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__h",
                "x1": "15.5",
                "x2": "12.85",
                "y1": "15",
                "y2": "19.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__i",
                "x1": "11.76",
                "x2": "18.12",
                "y1": "12.35",
                "y2": "18.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__j",
                "x1": "15.93",
                "x2": "15.19",
                "y1": "9.71",
                "y2": "15.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 0 0 4.26136 15 17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 2 16)scale(1.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".32"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1 -1.67609 0 12 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "clipPath",
            {
                "id": "ic_fluent_people_home_20_color__a"
            },
            [
                "path",
                {
                    "fill": "#fff",
                    "d": "M0 0h20v20H0z"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$fb51616cdf4a47a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHome24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__a)",
            "d": "M15.75 14C17 14 18 15 18 16.25v.92q0 .88-.51 1.6Q15.15 22 10 22t-7.49-3.24a2.8 2.8 0 0 1-.5-1.6v-.91C2 15 3 14 4.24 14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__b)",
            "d": "M15.75 14C17 14 18 15 18 16.25v.92q0 .88-.51 1.6Q15.15 22 10 22t-7.49-3.24a2.8 2.8 0 0 1-.5-1.6v-.91C2 15 3 14 4.24 14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__c)",
            "fillOpacity": ".75",
            "d": "M15.75 14C17 14 18 15 18 16.25v.92q0 .88-.51 1.6Q15.15 22 10 22t-7.49-3.24a2.8 2.8 0 0 1-.5-1.6v-.91C2 15 3 14 4.24 14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__d)",
            "fillOpacity": ".55",
            "d": "M15.75 14C17 14 18 15 18 16.25v.92q0 .88-.51 1.6Q15.15 22 10 22t-7.49-3.24a2.8 2.8 0 0 1-.5-1.6v-.91C2 15 3 14 4.24 14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__e)",
            "d": "M10 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__f)",
            "d": "M15 17h5v6h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__g)",
            "d": "M18.1 13.33a1 1 0 0 0-1.2 0l-3.5 2.62a1 1 0 0 0-.4.8V22a1 1 0 0 0 1 1h2v-3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V23h2a1 1 0 0 0 1-1v-5.25a1 1 0 0 0-.4-.8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_24_color__h)",
            "fillRule": "evenodd",
            "d": "m17.5 13.95 4.04 3.14a.75.75 0 1 0 .92-1.18l-4.2-3.26a1.25 1.25 0 0 0-1.53 0l-4.19 3.26a.75.75 0 1 0 .92 1.18z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_24_color__a",
                "x1": "5.81",
                "x2": "8.39",
                "y1": "15.06",
                "y2": "23.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_24_color__b",
                "x1": "10",
                "x2": "13.62",
                "y1": "13.05",
                "y2": "26.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_24_color__e",
                "x1": "7.38",
                "x2": "12.47",
                "y1": "3.33",
                "y2": "11.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_24_color__f",
                "x1": "17.5",
                "x2": "14.69",
                "y1": "17",
                "y2": "23.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_24_color__g",
                "x1": "13.86",
                "x2": "21.4",
                "y1": "14.11",
                "y2": "21.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_24_color__h",
                "x1": "18",
                "x2": "17.26",
                "y1": "11",
                "y2": "16.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.5 -2.77083 0 14.5 19.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".04",
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.5 -1.49974 0 13 17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$4e20a1dbbb914fdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHome28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__a)",
            "d": "M20 16a3 3 0 0 1 3 3v.71C23 23.3 18.79 26 13 26S3 23.43 3 19.71V19a3 3 0 0 1 3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__b)",
            "d": "M20 16a3 3 0 0 1 3 3v.71C23 23.3 18.79 26 13 26S3 23.43 3 19.71V19a3 3 0 0 1 3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__c)",
            "fillOpacity": ".75",
            "d": "M20 16a3 3 0 0 1 3 3v.71C23 23.3 18.79 26 13 26S3 23.43 3 19.71V19a3 3 0 0 1 3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__d)",
            "fillOpacity": ".55",
            "d": "M20 16a3 3 0 0 1 3 3v.71C23 23.3 18.79 26 13 26S3 23.43 3 19.71V19a3 3 0 0 1 3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__e)",
            "d": "M13 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M18 21.5h5V27h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__f)",
            "d": "M18 21.5h5V27h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "M19.61 15.9a1.4 1.4 0 0 1 1.78 0l4.13 3.51c.3.26.48.65.48 1.05v5.48c0 .59-.47 1.06-1.06 1.06H22.5v-4.15a.85.85 0 0 0-.84-.85h-2.32a.85.85 0 0 0-.84.85V27h-2.44c-.59 0-1.06-.47-1.06-1.06v-5.48c0-.4.18-.79.48-1.05z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__g)",
            "d": "M19.61 15.9a1.4 1.4 0 0 1 1.78 0l4.13 3.51c.3.26.48.65.48 1.05v5.48c0 .59-.47 1.06-1.06 1.06H22.5v-4.15a.85.85 0 0 0-.84-.85h-2.32a.85.85 0 0 0-.84.85V27h-2.44c-.59 0-1.06-.47-1.06-1.06v-5.48c0-.4.18-.79.48-1.05z"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "fillRule": "evenodd",
            "d": "M19.85 15a1 1 0 0 1 1.3 0l5.5 4.74a1 1 0 1 1-1.3 1.52l-4.85-4.19-4.85 4.19a1 1 0 1 1-1.3-1.52z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_28_color__h)",
            "fillRule": "evenodd",
            "d": "M19.85 15a1 1 0 0 1 1.3 0l5.5 4.74a1 1 0 1 1-1.3 1.52l-4.85-4.19-4.85 4.19a1 1 0 1 1-1.3-1.52z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_28_color__a",
                "x1": "7.76",
                "x2": "10.99",
                "y1": "17.33",
                "y2": "27.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_28_color__b",
                "x1": "13",
                "x2": "17.52",
                "y1": "14.81",
                "y2": "31.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_28_color__e",
                "x1": "9.85",
                "x2": "15.97",
                "y1": "3.6",
                "y2": "13.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_28_color__f",
                "x1": "20.5",
                "x2": "17.22",
                "y1": "21.5",
                "y2": "28.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_28_color__g",
                "x1": "16.05",
                "x2": "25.72",
                "y1": "16.85",
                "y2": "25.78",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_28_color__h",
                "x1": "21.12",
                "x2": "19.98",
                "y1": "12.83",
                "y2": "20.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.5 -2.9375 0 17 24)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".04",
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_28_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 -3 18)scale(1.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$b2f08464a4454f33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHome32Color', "32", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "M6.5 18A3.5 3.5 0 0 0 3 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.7 15.7 0 0 0 15 30c3.2 0 6.14-.82 8.32-2.2C25.48 26.41 27 24.4 27 22v-.5a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__a)",
            "d": "M6.5 18A3.5 3.5 0 0 0 3 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.7 15.7 0 0 0 15 30c3.2 0 6.14-.82 8.32-2.2C25.48 26.41 27 24.4 27 22v-.5a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__b)",
            "d": "M6.5 18A3.5 3.5 0 0 0 3 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.7 15.7 0 0 0 15 30c3.2 0 6.14-.82 8.32-2.2C25.48 26.41 27 24.4 27 22v-.5a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__c)",
            "fillOpacity": ".75",
            "d": "M6.5 18A3.5 3.5 0 0 0 3 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.7 15.7 0 0 0 15 30c3.2 0 6.14-.82 8.32-2.2C25.48 26.41 27 24.4 27 22v-.5a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__d)",
            "fillOpacity": ".55",
            "d": "M6.5 18A3.5 3.5 0 0 0 3 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.7 15.7 0 0 0 15 30c3.2 0 6.14-.82 8.32-2.2C25.48 26.41 27 24.4 27 22v-.5a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M15 16a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__e)",
            "d": "M15 16a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M21 25h5v6h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__f)",
            "d": "M21 25h5v6h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M22.45 17.89c.6-.52 1.5-.52 2.1 0l4.88 4.14c.36.31.57.76.57 1.24v6.48c0 .69-.56 1.25-1.25 1.25H25.5v-4.5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1V31h-3.25c-.69 0-1.25-.56-1.25-1.25v-6.48c0-.48.2-.93.57-1.24z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__g)",
            "d": "M22.45 17.89c.6-.52 1.5-.52 2.1 0l4.88 4.14c.36.31.57.76.57 1.24v6.48c0 .69-.56 1.25-1.25 1.25H25.5v-4.5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1V31h-3.25c-.69 0-1.25-.56-1.25-1.25v-6.48c0-.48.2-.93.57-1.24z"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "fillRule": "evenodd",
            "d": "M22.69 16.05c.46-.4 1.16-.4 1.62 0l7 6a1.25 1.25 0 1 1-1.62 1.9l-6.19-5.3-6.19 5.3a1.25 1.25 0 0 1-1.62-1.9z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_32_color__h)",
            "fillRule": "evenodd",
            "d": "M22.69 16.05c.46-.4 1.16-.4 1.62 0l7 6a1.25 1.25 0 1 1-1.62 1.9l-6.19-5.3-6.19 5.3a1.25 1.25 0 0 1-1.62-1.9z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_32_color__a",
                "x1": "8.71",
                "x2": "12.58",
                "y1": "19.6",
                "y2": "31.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_32_color__b",
                "x1": "15",
                "x2": "20.43",
                "y1": "16.57",
                "y2": "36.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_32_color__e",
                "x1": "11.33",
                "x2": "18.46",
                "y1": "3.86",
                "y2": "15.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_32_color__f",
                "x1": "23.5",
                "x2": "19.74",
                "y1": "25",
                "y2": "31.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_32_color__g",
                "x1": "5.58",
                "x2": "14.98",
                "y1": "19",
                "y2": "37.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_32_color__h",
                "x1": "24.29",
                "x2": "22.86",
                "y1": "13.33",
                "y2": "23.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6 -2.75 0 18.5 27)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".04",
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 -3.5 20)scale(2)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$da2762421349ad97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHome48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__a)",
            "d": "M8.25 28A4.25 4.25 0 0 0 4 32.25V33c0 3.76 1.94 6.57 4.92 8.38C11.85 43.16 15.79 44 20 44s8.15-.84 11.08-2.62C34.06 39.57 36 36.76 36 33v-.75C36 29.9 34.1 28 31.75 28z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__b)",
            "d": "M8.25 28A4.25 4.25 0 0 0 4 32.25V33c0 3.76 1.94 6.57 4.92 8.38C11.85 43.16 15.79 44 20 44s8.15-.84 11.08-2.62C34.06 39.57 36 36.76 36 33v-.75C36 29.9 34.1 28 31.75 28z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__c)",
            "fillOpacity": ".75",
            "d": "M8.25 28A4.25 4.25 0 0 0 4 32.25V33c0 3.76 1.94 6.57 4.92 8.38C11.85 43.16 15.79 44 20 44s8.15-.84 11.08-2.62C34.06 39.57 36 36.76 36 33v-.75C36 29.9 34.1 28 31.75 28z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__d)",
            "fillOpacity": ".55",
            "d": "M8.25 28A4.25 4.25 0 0 0 4 32.25V33c0 3.76 1.94 6.57 4.92 8.38C11.85 43.16 15.79 44 20 44s8.15-.84 11.08-2.62C34.06 39.57 36 36.76 36 33v-.75C36 29.9 34.1 28 31.75 28z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__e)",
            "d": "M20 4a10 10 0 1 0 0 20 10 10 0 0 0 0-20"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M31 37h8v9h-8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__f)",
            "d": "M31 37h8v9h-8z"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "M33.54 27.84a2.25 2.25 0 0 1 2.92 0l6.75 5.74c.5.43.79 1.06.79 1.72v8.97c0 .95-.77 1.73-1.73 1.73H38v-6.62c0-.76-.62-1.38-1.38-1.38h-3.24c-.76 0-1.38.62-1.38 1.38V46h-4.27c-.96 0-1.73-.78-1.73-1.73V35.3c0-.66.29-1.3.8-1.72z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__g)",
            "d": "M33.54 27.84a2.25 2.25 0 0 1 2.92 0l6.75 5.74c.5.43.79 1.06.79 1.72v8.97c0 .95-.77 1.73-1.73 1.73H38v-6.62c0-.76-.62-1.38-1.38-1.38h-3.24c-.76 0-1.38.62-1.38 1.38V46h-4.27c-.96 0-1.73-.78-1.73-1.73V35.3c0-.66.29-1.3.8-1.72z"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "fillRule": "evenodd",
            "d": "M34.03 26.35a1.5 1.5 0 0 1 1.94 0l9.5 8a1.5 1.5 0 0 1-1.94 2.3L35 29.46l-8.53 7.19a1.5 1.5 0 1 1-1.94-2.3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_home_48_color__h)",
            "fillRule": "evenodd",
            "d": "M34.03 26.35a1.5 1.5 0 0 1 1.94 0l9.5 8a1.5 1.5 0 0 1-1.94 2.3L35 29.46l-8.53 7.19a1.5 1.5 0 1 1-1.94-2.3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_48_color__a",
                "x1": "11.61",
                "x2": "16.78",
                "y1": "30.13",
                "y2": "46.64",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_48_color__b",
                "x1": "20",
                "x2": "27.24",
                "y1": "26.1",
                "y2": "53.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_48_color__e",
                "x1": "14.76",
                "x2": "24.95",
                "y1": "6.66",
                "y2": "22.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_48_color__f",
                "x1": "35",
                "x2": "29.56",
                "y1": "37",
                "y2": "47.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_48_color__g",
                "x1": "27.72",
                "x2": "43.55",
                "y1": "29.38",
                "y2": "44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_48_color__h",
                "x1": "36.05",
                "x2": "34.25",
                "y1": "22.87",
                "y2": "36.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 9.5 -3.40625 0 28 41)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".04",
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_48_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.5 -2.5 0 25.5 36)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$964e0c9573379fb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_16_color__a)",
            "d": "M11.25 15c1.77 0 3-2.06 3.65-3.1a.7.7 0 0 0-.06-.8L12.5 8.25a1.53 1.53 0 0 0-2.39.09L9.4 9.36s-.47.46-.75.46-1.78 1.22-1.78 1.22l-.59 2.76c.72-1.03 1.26-.67 1.62-.48C9 13.9 9.92 15 11.25 15"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_16_color__b)",
            "fillOpacity": ".5",
            "d": "M11.25 15c1.77 0 3-2.06 3.65-3.1a.7.7 0 0 0-.06-.8L12.5 8.25a1.53 1.53 0 0 0-2.39.09L9.4 9.36s-.47.46-.75.46-1.78 1.22-1.78 1.22l-.59 2.76c.72-1.03 1.26-.67 1.62-.48C9 13.9 9.92 15 11.25 15"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_16_color__c)",
            "d": "M4.75 7.72c-1.77 0-3 2.06-3.65 3.1a.7.7 0 0 0 .06.8l2.34 2.84c.61.75 1.83.7 2.39-.08L9.72 8.9C9 9.94 8.46 9.58 8.1 9.4 7 8.82 6.08 7.72 4.75 7.72"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_16_color__d)",
            "d": "M4.75 7.72c-1.77 0-3 2.06-3.65 3.1a.7.7 0 0 0 .06.8l2.34 2.84c.61.75 1.83.7 2.39-.08L9.72 8.9C9 9.94 8.46 9.58 8.1 9.4 7 8.82 6.08 7.72 4.75 7.72"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_16_color__e)",
            "d": "M4.75 7.72c-1.77 0-3 2.06-3.65 3.1a.7.7 0 0 0 .06.8l2.34 2.84c.61.75 1.83.7 2.39-.08L9.72 8.9C9 9.94 8.46 9.58 8.1 9.4 7 8.82 6.08 7.72 4.75 7.72"
        }
    ],
    [
        "circle",
        {
            "cx": "5",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_people_interwoven_16_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "5",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_people_interwoven_16_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "5",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_people_interwoven_16_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "11",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_people_interwoven_16_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "11",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_people_interwoven_16_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "11",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_people_interwoven_16_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -22.73 21.22)scale(10.0195 6.99872)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -11.6 13.3)scale(5.12632 4.91861)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 2.01 7.19)scale(8.59053 8.94905)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 1.97 2.74)scale(4.06175)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 5.89 -5.5)scale(4.77251 4.94029)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 4.97 4.71)scale(4.06175)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 8.89 -12)scale(4.77251 4.94029)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__c",
                "x1": "8.85",
                "x2": "5.45",
                "y1": "7.72",
                "y2": "16.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__e",
                "x1": "4.5",
                "x2": "4.23",
                "y1": "12.09",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__f",
                "x1": "4",
                "x2": "5.93",
                "y1": "2",
                "y2": "5.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_16_color__i",
                "x1": "10",
                "x2": "11.93",
                "y1": "2",
                "y2": "5.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$eab5888b284f432b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven16Filled', "16", [
    "M4.4 7.8c1.51 0 2.46 1.34 3.64 1.82.16.07.24.27.14.42l-2.81 4.05c-.44.63-1.35.66-1.84.07l-2.36-2.88a.5.5 0 0 1-.05-.54C1.79 9.54 3.07 7.8 4.4 7.8m6.2.48a1.15 1.15 0 0 1 1.83-.07l2.36 2.88c.13.16.15.37.06.54-.67 1.2-1.96 2.95-3.29 2.95-1.5 0-2.46-1.35-3.64-1.83-.16-.06-.24-.27-.13-.41zM5 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $76e5a570f6bfc30c$export$e981f43754ea7670 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven16Regular', "16", [
    "M4.99 7.26c.75 0 1.37.31 1.9.65l.75.52q.35.26.68.43c.11.06.24.16.37.15.03 0 .16-.02.38-.28l.49-.69.14-.18a1.92 1.92 0 0 1 2.86.07l2.18 2.64.1.15c.18.31.2.68.07 1l-.08.17c-.3.47-.76 1.24-1.37 1.88-.6.64-1.42 1.23-2.45 1.23-.75 0-1.37-.31-1.9-.65l-.75-.52-.51-.34-.17-.1c-.22-.1-.29-.15-.37-.14-.04 0-.17.02-.39.28l-.48.69a1.92 1.92 0 0 1-2.85.27l-.15-.16-2.18-2.64c-.31-.38-.34-.9-.09-1.32l.25-.4c.29-.45.66-1 1.12-1.48.6-.64 1.42-1.23 2.45-1.23m0 .99c-.63 0-1.2.36-1.73.92-.4.41-.73.9-1 1.32l-.24.4a.14.14 0 0 0 0 .17l2.25 2.71c.39.36 1.06.31 1.36-.12l2.62-3.73-.26-.1a9 9 0 0 1-.92-.58l-.72-.5c-.47-.3-.9-.5-1.36-.5m6.8.31a.93.93 0 0 0-1.42.05l-.37.53-2.24 3.2q.27.1.38.18l.2.11.6.39.71.5c.47.3.9.5 1.36.5.63 0 1.2-.37 1.73-.93.53-.55.94-1.23 1.24-1.72q.04-.08 0-.17zM5 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $76e5a570f6bfc30c$export$8372750140ec8e6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__a)",
            "d": "M13.71 18c2.03 0 3.44-2.35 4.17-3.54a.8.8 0 0 0-.06-.9l-2.68-3.26c-.7-.85-2.1-.8-2.72.1l-.82 1.16s-.54.53-.86.53-2.03 1.4-2.03 1.4l-.68 3.15c.83-1.17 1.44-.76 1.86-.54 1.25.65 2.3 1.9 3.82 1.9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__b)",
            "fillOpacity": ".5",
            "d": "M13.71 18c2.03 0 3.44-2.35 4.17-3.54a.8.8 0 0 0-.06-.9l-2.68-3.26c-.7-.85-2.1-.8-2.72.1l-.82 1.16s-.54.53-.86.53-2.03 1.4-2.03 1.4l-.68 3.15c.83-1.17 1.44-.76 1.86-.54 1.25.65 2.3 1.9 3.82 1.9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__c)",
            "d": "M6.3 9.69c-2.04 0-3.45 2.35-4.18 3.55a.8.8 0 0 0 .06.9l2.68 3.25c.7.86 2.1.8 2.72-.09l4.39-6.25c-.83 1.18-1.44.77-1.86.55-1.25-.66-2.3-1.91-3.82-1.91"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__d)",
            "d": "M6.3 9.69c-2.04 0-3.45 2.35-4.18 3.55a.8.8 0 0 0 .06.9l2.68 3.25c.7.86 2.1.8 2.72-.09l4.39-6.25c-.83 1.18-1.44.77-1.86.55-1.25-.66-2.3-1.91-3.82-1.91"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__e)",
            "d": "M6.3 9.69c-2.04 0-3.45 2.35-4.18 3.55a.8.8 0 0 0 .06.9l2.68 3.25c.7.86 2.1.8 2.72-.09l4.39-6.25c-.83 1.18-1.44.77-1.86.55-1.25-.66-2.3-1.91-3.82-1.91"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -27.79 26.9)scale(11.4508 7.99854)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -14.1 16.9)scale(5.85865 5.62127)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 2.43 8.94)scale(9.81775 10.2275)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 2.43 3.75)scale(5.07723)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 8.03 -6.9)scale(5.96569 6.17542)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 5.93 6.06)scale(5.07701 5.07605)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 11.52 -14.47)scale(5.965 6.17444)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__c",
                "x1": "10.97",
                "x2": "7.08",
                "y1": "9.69",
                "y2": "19.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__e",
                "x1": "6",
                "x2": "5.69",
                "y1": "14.68",
                "y2": "8.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__f",
                "x1": "5.25",
                "x2": "7.66",
                "y1": "3",
                "y2": "7.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__i",
                "x1": "12.25",
                "x2": "14.66",
                "y1": "3",
                "y2": "7.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$49bdd4e6d05f13ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven20Filled', "20", [
    "M12.98 10.12a1.36 1.36 0 0 1 2.1-.07l2.22 2.7.33.4c.27.33.3.8.06 1.17l-.39.6q-.42.63-.99 1.25c-.7.74-1.5 1.25-2.37 1.25-.66 0-1.24-.27-1.86-.67-.58-.37-1.11-.8-1.7-1.15l-.27-.15c-.3-.16-.45-.59-.25-.87l2.64-3.76h-.01zm-6.92-.53c.66 0 1.24.27 1.86.67.66.42 1.27.93 1.97 1.3l.17.09c.23.12.34.42.2.63l-3.24 4.6-.1.12c-.47.53-1.37.56-1.9.07l-.1-.12-2.54-3.09c-.27-.33-.3-.8-.07-1.16q.6-1 1.38-1.86c.7-.75 1.5-1.25 2.37-1.25M13.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $76e5a570f6bfc30c$export$bc0ad80b3d37860d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven20Regular', "20", [
    "M11.93 9.98a2.14 2.14 0 0 1 3.28-.02l2.57 3.13c.25.35.28.8.12 1.18l-.08.17c-.34.55-.87 1.43-1.57 2.16-.69.73-1.62 1.4-2.77 1.4-.86 0-1.56-.36-2.16-.74l-.86-.6q-.3-.22-.6-.4l-.2-.1c-.24-.13-.34-.19-.46-.18-.07 0-.24.03-.5.35l-.56.8a2.14 2.14 0 0 1-3.27.21L2.28 14.2a1.2 1.2 0 0 1-.1-1.43l.3-.47a11 11 0 0 1 1.27-1.7c.7-.73 1.62-1.4 2.77-1.4.86 0 1.56.36 2.16.75q.46.3.86.6.41.29.8.5l.28.14q.1.04.18.04c.07 0 .23-.04.5-.35l.56-.8zm2.5.62a1.14 1.14 0 0 0-1.76.05l-3.06 4.39c.24.07.42.18.51.23l.24.13q.36.22.68.44l.82.58c.55.35 1.05.58 1.62.58.75 0 1.43-.43 2.05-1.09.6-.64 1.09-1.43 1.43-2q.07-.13-.01-.27zm-7.9-.4c-.76 0-1.44.44-2.06 1.09a10 10 0 0 0-1.15 1.54l-.28.46q-.08.16.01.27l2.6 3.15c.44.41 1.2.38 1.6-.06l3.15-4.48q-.23-.07-.37-.15l-.15-.08a8 8 0 0 1-.91-.57l-.83-.58a3 3 0 0 0-1.62-.58M13.5 3A2.5 2.5 0 0 1 16 5.5l-.01.26A2.5 2.5 0 0 1 13.5 8L13.24 8a2.5 2.5 0 0 1-2.23-2.23L11 5.5A2.5 2.5 0 0 1 13.5 3m-7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m7 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$399d078c06c0927a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_24_color__a)",
            "d": "M16.64 21.4c2.53 0 4.3-2.94 5.21-4.44.22-.36.2-.8-.07-1.13l-3.35-4.07a2.18 2.18 0 0 0-3.4.12L14 13.34s-.68.65-1.07.65c-.4 0-2.54 1.75-2.54 1.75l-.85 3.95c1.03-1.47 1.8-.95 2.32-.68 1.56.82 2.88 2.38 4.78 2.38"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_24_color__b)",
            "fillOpacity": ".5",
            "d": "M16.64 21.4c2.53 0 4.3-2.94 5.21-4.44.22-.36.2-.8-.07-1.13l-3.35-4.07a2.18 2.18 0 0 0-3.4.12L14 13.34s-.68.65-1.07.65c-.4 0-2.54 1.75-2.54 1.75l-.85 3.95c1.03-1.47 1.8-.95 2.32-.68 1.56.82 2.88 2.38 4.78 2.38"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_24_color__c)",
            "d": "M7.36 11c-2.53 0-4.3 2.94-5.21 4.43-.22.36-.2.81.07 1.14l3.35 4.06c.88 1.07 2.62 1 3.4-.12l5.49-7.8c-1.03 1.46-1.8.95-2.32.68C10.58 12.57 9.26 11 7.36 11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_24_color__d)",
            "d": "M7.36 11c-2.53 0-4.3 2.94-5.21 4.43-.22.36-.2.81.07 1.14l3.35 4.06c.88 1.07 2.62 1 3.4-.12l5.49-7.8c-1.03 1.46-1.8.95-2.32.68C10.58 12.57 9.26 11 7.36 11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_24_color__e)",
            "d": "M7.36 11c-2.53 0-4.3 2.94-5.21 4.43-.22.36-.2.81.07 1.14l3.35 4.06c.88 1.07 2.62 1 3.4-.12l5.49-7.8c-1.03 1.46-1.8.95-2.32.68C10.58 12.57 9.26 11 7.36 11"
        }
    ],
    [
        "circle",
        {
            "cx": "7",
            "cy": "6",
            "r": "3",
            "fill": "url(#ic_fluent_people_interwoven_24_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "7",
            "cy": "6",
            "r": "3",
            "fill": "url(#ic_fluent_people_interwoven_24_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "7",
            "cy": "6",
            "r": "3",
            "fill": "url(#ic_fluent_people_interwoven_24_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "17",
            "cy": "6",
            "r": "3",
            "fill": "url(#ic_fluent_people_interwoven_24_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "17",
            "cy": "6",
            "r": "3",
            "fill": "url(#ic_fluent_people_interwoven_24_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "17",
            "cy": "6",
            "r": "3",
            "fill": "url(#ic_fluent_people_interwoven_24_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -32.12 31.77)scale(14.3135 9.99817)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -16.24 19.83)scale(7.32332 7.02658)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 3.17 10.45)scale(12.2722 12.7844)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 2.71 3.94)scale(6.09262)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 8.58 -7.72)scale(7.15877 7.41044)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 7.71 7.24)scale(6.09236 6.0912)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 13.58 -18.53)scale(7.15794 7.40926)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__c",
                "x1": "13.21",
                "x2": "8.35",
                "y1": "11",
                "y2": "23.18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__e",
                "x1": "7",
                "x2": "6.61",
                "y1": "17.24",
                "y2": "9.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__f",
                "x1": "5.5",
                "x2": "8.4",
                "y1": "3",
                "y2": "8.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_24_color__i",
                "x1": "15.5",
                "x2": "18.4",
                "y1": "3",
                "y2": "8.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$896e80a81a8c3d14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven24Filled', "24", [
    "M6.6 11c2.26 0 3.7 2.01 5.46 2.73.25.1.36.4.21.62l-4.22 6.09c-.65.94-2.02 1-2.75.1l-3.54-4.32a.7.7 0 0 1-.08-.8C2.68 13.6 4.6 11 6.6 11m9.3.73c.65-.94 2.02-1 2.75-.11l3.54 4.32c.19.23.22.55.08.81-1 1.81-2.93 4.42-4.93 4.42-2.26 0-3.69-2.02-5.45-2.74-.25-.1-.36-.4-.21-.62zM7 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m10 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
]);
const $76e5a570f6bfc30c$export$50634627a0a7b949 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven24Regular', "24", [
    "M7.48 10.38a5 5 0 0 1 2.85.99q.6.39 1.12.78.54.38 1.03.65c.17.08.37.23.56.22.05 0 .24-.03.57-.42l.94-1.3a2.9 2.9 0 0 1 4.3.1l3.41 4.18c.27.47.3 1.02.1 1.51l-.12.24c-.44.72-1.13 1.86-2.04 2.83-.91.95-2.14 1.84-3.68 1.84a5 5 0 0 1-2.85-.98q-.6-.39-1.12-.78-.4-.29-.78-.5l-.26-.15c-.32-.17-.43-.22-.55-.22-.05 0-.25.03-.58.44l-.72 1.02a2.9 2.9 0 0 1-4.27.4l-3.5-4.2a1.7 1.7 0 0 1-.13-1.97l.38-.6c.42-.68.98-1.5 1.66-2.23.91-.96 2.14-1.85 3.68-1.85m0 1.49c-.94 0-1.8.54-2.6 1.38a16 16 0 0 0-1.85 2.59.2.2 0 0 0 0 .24l3.27 3.96.11.12c.58.54 1.58.46 2.04-.18l3.92-5.6q-.3-.11-.57-.27-.65-.35-1.2-.75-.56-.4-1.07-.75a3.8 3.8 0 0 0-2.05-.74m10.22.47a1.4 1.4 0 0 0-2.15.07l-.56.8H15l-3.36 4.8q.4.17.57.27l.31.17q.46.27.88.58l1.07.74c.7.46 1.34.75 2.05.75.94 0 1.8-.55 2.6-1.38.78-.84 1.4-1.85 1.85-2.59q.06-.13-.01-.24zM7 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m10 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6M7 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$34fd38b6db550304 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_28_color__a)",
            "d": "M19.56 25.47c3.05 0 5.17-3.52 6.26-5.32.27-.43.24-.97-.09-1.36l-4.01-4.87a2.62 2.62 0 0 0-4.1.14L16.4 15.8s-.81.8-1.29.8c-.47 0-3.04 2.1-3.04 2.1l-1.02 4.73c1.24-1.76 2.16-1.15 2.78-.82 1.88.98 3.46 2.86 5.73 2.86"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_28_color__b)",
            "fillOpacity": ".5",
            "d": "M19.56 25.47c3.05 0 5.17-3.52 6.26-5.32.27-.43.24-.97-.09-1.36l-4.01-4.87a2.62 2.62 0 0 0-4.1.14L16.4 15.8s-.81.8-1.29.8c-.47 0-3.04 2.1-3.04 2.1l-1.02 4.73c1.24-1.76 2.16-1.15 2.78-.82 1.88.98 3.46 2.86 5.73 2.86"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_28_color__c)",
            "d": "M8.44 13c-3.05 0-5.17 3.52-6.26 5.32-.27.43-.24.97.09 1.36l4.01 4.88a2.62 2.62 0 0 0 4.1-.14l6.57-9.38c-1.24 1.77-2.16 1.15-2.78.82C12.3 14.88 10.71 13 8.44 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_28_color__d)",
            "d": "M8.44 13c-3.05 0-5.17 3.52-6.26 5.32-.27.43-.24.97.09 1.36l4.01 4.88a2.62 2.62 0 0 0 4.1-.14l6.57-9.38c-1.24 1.77-2.16 1.15-2.78.82C12.3 14.88 10.71 13 8.44 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_28_color__e)",
            "d": "M8.44 13c-3.05 0-5.17 3.52-6.26 5.32-.27.43-.24.97.09 1.36l4.01 4.88a2.62 2.62 0 0 0 4.1-.14l6.57-9.38c-1.24 1.77-2.16 1.15-2.78.82C12.3 14.88 10.71 13 8.44 13"
        }
    ],
    [
        "circle",
        {
            "cx": "8.5",
            "cy": "6.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_people_interwoven_28_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "8.5",
            "cy": "6.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_people_interwoven_28_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "8.5",
            "cy": "6.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_people_interwoven_28_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "19.5",
            "cy": "6.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_people_interwoven_28_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "19.5",
            "cy": "6.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_people_interwoven_28_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "19.5",
            "cy": "6.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_people_interwoven_28_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -38.23 37)scale(17.1762 11.9978)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -19.4 23.11)scale(8.78798 8.4319)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 3.67 12.3)scale(14.7266 15.3412)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 3.5 4.46)scale(7.10805)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 9.64 -9.62)scale(8.35189 8.64552)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 9 8.08)scale(7.10775 7.1064)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 15.14 -21.5)scale(8.35093 8.64414)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__c",
                "x1": "15.45",
                "x2": "9.62",
                "y1": "13",
                "y2": "27.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__e",
                "x1": "8",
                "x2": "7.54",
                "y1": "20.49",
                "y2": "11.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__f",
                "x1": "6.75",
                "x2": "10.13",
                "y1": "3",
                "y2": "9.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_28_color__i",
                "x1": "17.75",
                "x2": "21.13",
                "y1": "3",
                "y2": "9.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$89f3c476e4b836d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven28Filled', "28", [
    "M18.47 13.8a2.04 2.04 0 0 1 3.15-.1l3.33 4.04.49.6c.41.5.45 1.21.1 1.76-.2.32-.43.66-.59.89-.43.63-.92 1.3-1.48 1.88-1.06 1.12-2.25 1.88-3.56 1.88-.99 0-1.86-.4-2.8-1q-.68-.46-1.4-.99a17 17 0 0 0-1.14-.74l-.4-.23c-.46-.24-.67-.88-.38-1.3l3.96-5.64h-.02zM8.09 13c.99 0 1.86.4 2.8 1q.68.46 1.4.99.73.52 1.54.97l.26.13c.34.18.51.63.3.95l-4.85 6.9-.15.19c-.72.78-2.06.84-2.85.1l-.16-.18-3.82-4.63c-.4-.5-.44-1.2-.1-1.75l.1-.16c.53-.84 1.19-1.8 1.97-2.63C5.6 13.76 6.78 13 8.1 13M8.5 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m11 0a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
]);
const $76e5a570f6bfc30c$export$bca77178b417eb76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven28Regular', "28", [
    "M16.9 12.96a3.2 3.2 0 0 1 4.91-.02l3.86 4.69c.37.53.43 1.2.19 1.77l-.14.26c-.5.83-1.3 2.14-2.34 3.24S20.95 25 19.22 25a6 6 0 0 1-3.24-1.12c-.44-.28-.89-.61-1.29-.9q-.58-.4-1.2-.75c-.36-.2-.51-.27-.7-.26-.09 0-.34.05-.74.53l-.83 1.2a3.2 3.2 0 0 1-4.9.31l-3.9-4.71a1.85 1.85 0 0 1-.14-2.15l.43-.7a17 17 0 0 1 1.91-2.55c1.04-1.1 2.44-2.1 4.16-2.1a6 6 0 0 1 3.24 1.12c.83.55 1.6 1.2 2.49 1.66.21.1.45.28.7.26.09 0 .34-.05.72-.52zm3.76.93a1.7 1.7 0 0 0-2.65.09l-.64.92-3.95 5.66c.4.11.76.34 1.13.54q.52.31 1 .66.64.46 1.25.86c.81.53 1.57.88 2.42.88 1.12 0 2.14-.65 3.07-1.63s1.64-2.15 2.16-3q.09-.21-.03-.4zm-11.88-.58c-1.12 0-2.14.65-3.07 1.63-.69.72-1.26 1.57-1.73 2.3l-.42.7c-.09.13-.07.29.02.4l3.9 4.72c.66.62 1.78.58 2.39-.08l4.73-6.72a3 3 0 0 1-.56-.23q-.82-.45-1.6-.98-.63-.46-1.24-.87a4.4 4.4 0 0 0-2.42-.87M8.5 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m11 0a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m-11 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m11 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$e6e6c90837c020f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_32_color__a)",
            "d": "M22.5 29c3.54 0 6.01-4.11 7.3-6.2.3-.5.27-1.14-.11-1.6L25 15.53a3.06 3.06 0 0 0-4.77.16l-1.43 2.04s-.95.92-1.5.92-3.55 2.45-3.55 2.45l-1.19 5.52c1.44-2.05 2.52-1.33 3.24-.95C17.99 26.8 19.84 29 22.5 29"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_32_color__b)",
            "fillOpacity": ".5",
            "d": "M22.5 29c3.54 0 6.01-4.11 7.3-6.2.3-.5.27-1.14-.11-1.6L25 15.53a3.06 3.06 0 0 0-4.77.16l-1.43 2.04s-.95.92-1.5.92-3.55 2.45-3.55 2.45l-1.19 5.52c1.44-2.05 2.52-1.33 3.24-.95C17.99 26.8 19.84 29 22.5 29"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_32_color__c)",
            "d": "M9.5 14.45c-3.54 0-6.01 4.11-7.3 6.2-.3.5-.27 1.14.11 1.6L7 27.92a3.06 3.06 0 0 0 4.77-.16l7.67-10.93c-1.44 2.05-2.52 1.33-3.24.95-2.19-1.15-4.04-3.34-6.7-3.34"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_32_color__d)",
            "d": "M9.5 14.45c-3.54 0-6.01 4.11-7.3 6.2-.3.5-.27 1.14.11 1.6L7 27.92a3.06 3.06 0 0 0 4.77-.16l7.67-10.93c-1.44 2.05-2.52 1.33-3.24.95-2.19-1.15-4.04-3.34-6.7-3.34"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_32_color__e)",
            "d": "M9.5 14.45c-3.54 0-6.01 4.11-7.3 6.2-.3.5-.27 1.14.11 1.6L7 27.92a3.06 3.06 0 0 0 4.77-.16l7.67-10.93c-1.44 2.05-2.52 1.33-3.24.95-2.19-1.15-4.04-3.34-6.7-3.34"
        }
    ],
    [
        "circle",
        {
            "cx": "9.5",
            "cy": "7.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_people_interwoven_32_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "9.5",
            "cy": "7.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_people_interwoven_32_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "9.5",
            "cy": "7.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_people_interwoven_32_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "22.5",
            "cy": "7.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_people_interwoven_32_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "22.5",
            "cy": "7.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_people_interwoven_32_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "22.5",
            "cy": "7.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_people_interwoven_32_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -42.92 41.94)scale(20.039 13.9974)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -21.74 26.11)scale(10.2526 9.83722)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 4.36 13.88)scale(17.1811 17.8981)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 4.06 4.83)scale(9.13893)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 10.75 -11.25)scale(10.7381 11.1157)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-3.59903 8.4 -8.3984 -3.59835 23.1 3)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 17.25 -25.3)scale(10.7369 11.1139)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__c",
                "x1": "17.7",
                "x2": "10.89",
                "y1": "14.45",
                "y2": "31.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__e",
                "x1": "9",
                "x2": "8.46",
                "y1": "23.19",
                "y2": "12.6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__f",
                "x1": "7.25",
                "x2": "11.6",
                "y1": "3",
                "y2": "11.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_32_color__i",
                "x1": "20.25",
                "x2": "24.6",
                "y1": "3",
                "y2": "11.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$aa103612ea926f84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven32Filled', "32", [
    "M8.81 14.42c3.01 0 4.92 2.7 7.27 3.66.33.13.48.53.28.82l-5.62 8.11a2.3 2.3 0 0 1-3.67.15l-4.72-5.77a1 1 0 0 1-.11-1.08c1.33-2.4 3.9-5.89 6.57-5.89m12.39.98a2.3 2.3 0 0 1 3.66-.15l4.73 5.77c.25.3.3.73.1 1.08-1.33 2.4-3.9 5.89-6.57 5.89-3 0-4.92-2.7-7.27-3.66-.33-.13-.48-.53-.28-.82zM9.5 3a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m13 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9"
]);
const $76e5a570f6bfc30c$export$4b0b3aeefc587957 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven32Regular', "32", [
    "M9.97 13.5c1.52 0 2.76.64 3.8 1.31.52.34 1.04.72 1.5 1.04q.89.62 1.85 1.1a1 1 0 0 0 .27.06c.06 0 .32-.04.76-.56l.96-1.38.29-.36a3.84 3.84 0 0 1 5.72.15l4.35 5.28.21.3c.37.61.4 1.36.13 2l-.16.32c-.58.96-1.5 2.5-2.72 3.77-1.21 1.28-2.85 2.47-4.9 2.47a7 7 0 0 1-3.8-1.31c-.97-.63-1.87-1.35-2.88-1.91-.43-.23-.57-.3-.74-.3-.06.01-.32.04-.76.57l-.96 1.38a3.84 3.84 0 0 1-5.7.54l-.31-.33-4.35-5.28a2.3 2.3 0 0 1-.18-2.62l.5-.81c.56-.9 1.31-2 2.22-2.97 1.21-1.27 2.85-2.46 4.9-2.46m0 1.98c-1.24 0-2.4.73-3.46 1.85-.79.83-1.45 1.8-1.98 2.64l-.5.8a.3.3 0 0 0 .02.33l4.5 5.44c.77.72 2.1.61 2.71-.25l5.23-7.46q-.3-.11-.5-.22-.96-.51-1.85-1.14c-.51-.35-.96-.69-1.44-1a5 5 0 0 0-2.73-.99m13.63.64a1.85 1.85 0 0 0-2.86.08l-.75 1.07H20l-4.48 6.4c.35.13.62.29.75.36l.42.23q.61.36 1.17.77c.51.35.96.68 1.44 1a5 5 0 0 0 2.73.98c1.24 0 2.4-.72 3.46-1.84 1.05-1.1 1.87-2.46 2.47-3.44.06-.13.06-.21-.01-.33zM9.5 3a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m13 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-13 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m13 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $76e5a570f6bfc30c$export$613ba0cc8b12cf06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_48_color__a)",
            "d": "M33.27 42.79c5.07 0 8.6-5.88 10.44-8.87.43-.71.38-1.61-.15-2.27l-6.7-8.12a4.37 4.37 0 0 0-6.82.23L28 26.67S26.65 28 25.86 28c-.8 0-5.08 3.5-5.08 3.5l-1.7 7.89c2.07-2.94 3.6-1.9 4.63-1.37 3.13 1.64 5.78 4.78 9.56 4.78"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_48_color__b)",
            "fillOpacity": ".5",
            "d": "M33.27 42.79c5.07 0 8.6-5.88 10.44-8.87.43-.71.38-1.61-.15-2.27l-6.7-8.12a4.37 4.37 0 0 0-6.82.23L28 26.67S26.65 28 25.86 28c-.8 0-5.08 3.5-5.08 3.5l-1.7 7.89c2.07-2.94 3.6-1.9 4.63-1.37 3.13 1.64 5.78 4.78 9.56 4.78"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_48_color__c)",
            "d": "M14.73 22c-5.07 0-8.6 5.87-10.43 8.86-.44.72-.4 1.62.15 2.27l6.69 8.13a4.37 4.37 0 0 0 6.82-.23L28.9 25.4c-2.06 2.93-3.59 1.9-4.62 1.36C21.16 25.13 18.5 22 14.73 22"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_48_color__d)",
            "d": "M14.73 22c-5.07 0-8.6 5.87-10.43 8.86-.44.72-.4 1.62.15 2.27l6.69 8.13a4.37 4.37 0 0 0 6.82-.23L28.9 25.4c-2.06 2.93-3.59 1.9-4.62 1.36C21.16 25.13 18.5 22 14.73 22"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_48_color__e)",
            "d": "M14.73 22c-5.07 0-8.6 5.87-10.43 8.86-.44.72-.4 1.62.15 2.27l6.69 8.13a4.37 4.37 0 0 0 6.82-.23L28.9 25.4c-2.06 2.93-3.59 1.9-4.62 1.36C21.16 25.13 18.5 22 14.73 22"
        }
    ],
    [
        "circle",
        {
            "cx": "15",
            "cy": "12",
            "r": "6",
            "fill": "url(#ic_fluent_people_interwoven_48_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "15",
            "cy": "12",
            "r": "6",
            "fill": "url(#ic_fluent_people_interwoven_48_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "15",
            "cy": "12",
            "r": "6",
            "fill": "url(#ic_fluent_people_interwoven_48_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "33",
            "cy": "12",
            "r": "6",
            "fill": "url(#ic_fluent_people_interwoven_48_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "33",
            "cy": "12",
            "r": "6",
            "fill": "url(#ic_fluent_people_interwoven_48_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "33",
            "cy": "12",
            "r": "6",
            "fill": "url(#ic_fluent_people_interwoven_48_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -64.24 63.54)scale(28.6271 19.9963)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -32.49 39.67)scale(14.6466 14.0532)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 6.34 20.9)scale(24.5444 25.5687)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 5.92 8.2)scale(12.1852)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 17.66 -16.53)scale(14.3175 14.8209)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 14.92 14.14)scale(12.1847 12.1824)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 26.66 -35.98)scale(14.3159 14.8185)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__c",
                "x1": "26.42",
                "x2": "16.7",
                "y1": "22",
                "y2": "46.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__e",
                "x1": "14",
                "x2": "13.23",
                "y1": "34.48",
                "y2": "19.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__f",
                "x1": "12",
                "x2": "17.79",
                "y1": "6",
                "y2": "17.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_48_color__i",
                "x1": "30",
                "x2": "35.79",
                "y1": "6",
                "y2": "17.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$ebd5561705e09c0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven48Filled', "48", [
    "M31.44 23.75a3.4 3.4 0 0 1 5.26-.17l5.55 6.74.82 1c.68.83.75 2.02.16 2.92l-.98 1.49a25 25 0 0 1-2.47 3.14C38.02 40.73 36.04 42 33.85 42c-1.65 0-3.1-.67-4.66-1.68-.78-.5-1.53-1.06-2.35-1.63q-.9-.66-1.9-1.24l-.66-.38c-.77-.4-1.12-1.47-.62-2.17l6.58-9.4-.02-.01zm-17.3-1.33c1.66 0 3.12.67 4.67 1.68 1.65 1.06 3.17 2.33 4.91 3.24l.43.23c.57.3.85 1.05.49 1.57l-8.08 11.52-.24.3a3.43 3.43 0 0 1-4.75.16l-.27-.28-6.36-7.73c-.67-.84-.74-2-.17-2.91a29 29 0 0 1 3.45-4.66c1.76-1.85 3.74-3.12 5.93-3.12M15 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12m18 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
]);
const $76e5a570f6bfc30c$export$8dac812ead2fc2bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwoven48Regular', "48", [
    "M28.83 22.94a5.35 5.35 0 0 1 8.2-.04l6.42 7.81c.61.88.7 2 .3 2.95l-.21.43c-.85 1.39-2.17 3.58-3.9 5.42C37.9 41.33 35.57 43 32.68 43c-2.13 0-3.89-.89-5.39-1.86-.74-.48-1.48-1.02-2.15-1.5q-.77-.55-1.5-.98c-.5-.28-1.09-.75-1.66-.72-.16.01-.58.09-1.24.9l-1.4 1.98a5.35 5.35 0 0 1-8.17.53L4.7 33.5a3.1 3.1 0 0 1-.24-3.58 32 32 0 0 1 3.91-5.41c1.73-1.83 4.05-3.5 6.94-3.5 2.13 0 3.89.9 5.39 1.86.74.48 1.48 1.02 2.15 1.5q1.02.73 2 1.26l.7.35q.24.1.46.1c.15-.02.57-.1 1.21-.87zm6.26 1.55a2.85 2.85 0 0 0-4.4.14l-1.08 1.53.02.02-6.6 9.41c.59.18 1.05.46 1.28.58l.6.33q.88.53 1.68 1.1c.73.51 1.38 1 2.07 1.44 1.36.88 2.62 1.46 4.03 1.46 1.87 0 3.58-1.09 5.13-2.71 1.53-1.62 2.72-3.58 3.59-5 .1-.26.1-.44-.04-.68zm-19.78-.98c-1.87 0-3.58 1.09-5.13 2.71a30 30 0 0 0-3.59 5c-.14.23-.11.5.04.69l6.5 7.85a2.9 2.9 0 0 0 3.98-.13L25 28.43q-.56-.18-.93-.38-1.37-.75-2.66-1.64c-.73-.5-1.38-1-2.07-1.44-1.36-.88-2.62-1.46-4.03-1.46M15 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12m18 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12M15 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m18 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $76e5a570f6bfc30c$export$bbb55b029d872b4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink16Filled', "16", [
    "M7.05 9a3.5 3.5 0 0 0-.22 4.76 7 7 0 0 1-4.92-.53C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zM10 9a.5.5 0 0 1 0 1h-.5a1.5 1.5 0 0 0 0 3h.5a.5.5 0 0 1 0 1h-.5a2.5 2.5 0 0 1 0-5zm3.5 0a2.5 2.5 0 0 1 0 5H13a.5.5 0 0 1 0-1h.5a1.5 1.5 0 0 0 0-3H13a.5.5 0 0 1 0-1zm0 2a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zM5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$e052419527ab9caf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink16Regular', "16", [
    "M7.05 9q-.45.43-.71 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 13 5 13q.68 0 1.28-.13.2.48.55.89a7 7 0 0 1-4.92-.53C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zM10 9a.5.5 0 0 1 0 1h-.5a1.5 1.5 0 0 0 0 3h.5a.5.5 0 0 1 0 1h-.5a2.5 2.5 0 0 1 0-5zm3.5 0a2.5 2.5 0 0 1 0 5H13a.5.5 0 0 1 0-1h.5a1.5 1.5 0 0 0 0-3H13a.5.5 0 0 1 0-1zm0 2a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zM5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 11.51 8h-.04l-.2-.01a2.25 2.25 0 0 1-2.02-2.01l-.01-.23c0-1.24 1-2.25 2.25-2.25zm-.23 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5 3.5A1.75 1.75 0 1 0 5 7a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$e62ae42fd41b69b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink20Filled', "20", [
    "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 6c0-.98.4-1.86 1.05-2.5H3.5a2 2 0 0 0-2 2s0 4 5.25 4c1.57 0 2.68-.36 3.45-.86A3.5 3.5 0 0 1 9 13.5m3.5-2.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$fdb226acae22283e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink20Regular', "20", [
    "M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 13c0-1.1.9-2 2-2h6.55q-.45.44-.71 1H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16c1.3 0 2.18-.27 2.8-.63q.27.44.65.77c-.79.5-1.9.86-3.45.86-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V13M12 7.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0m1 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.5 3.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$a517b33c22de52d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink24Filled', "24", [
    "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21c1.4 0 2.47-.24 3.3-.62a4.73 4.73 0 0 1 .96-6.32 2 2 0 0 0-.51-.06zm18.25 3.75A3.75 3.75 0 0 0 18.75 14h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5v-.01h.2a3.75 3.75 0 0 0 3.55-3.75m-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75m3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75"
]);
const $76e5a570f6bfc30c$export$1b42f4dc2b92691b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink24Regular', "24", [
    "M5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 14C3.01 14 2 15 2 16.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 19.97 5.17 21 8 21c1.38 0 2.45-.24 3.29-.63a5 5 0 0 1-.62-1.36c-.63.29-1.49.49-2.67.49-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h6.82q.45-.85 1.2-1.44a2 2 0 0 0-.52-.06zm18.25 3.75A3.75 3.75 0 0 0 18.75 14h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5v-.01h.2a3.75 3.75 0 0 0 3.55-3.75m-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75m3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75"
]);
const $76e5a570f6bfc30c$export$f06221700f4824e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink28Filled', "28", [
    "M9.5 14a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 18.25C2 17.01 3 16 4.25 16h10.08a4.74 4.74 0 0 0-.4 7.14c-1.07.51-2.5.86-4.43.86C2 24 2 18.75 2 18.75zm15.25-.75a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5h.5a.75.75 0 0 1 0 1.5zm-.75 2.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75M22.75 22a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$bf03d1bb2cb7320 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink28Regular', "28", [
    "M9.5 5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 7a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M2 18.25C2 17.01 3 16 4.25 16h10.08q-.79.62-1.26 1.5H4.25a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 1.54 0 2.68-.25 3.51-.6q.36.7.9 1.23c-1.07.53-2.51.87-4.41.87C5.94 24 4 22.8 3 21.45a5 5 0 0 1-1-2.67v-.53m15.25-.75a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5h.5a.75.75 0 0 1 0 1.5zm-.75 2.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75M22.75 22a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$7953beafa4bd9635 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink32Filled', "32", [
    "M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27c2.03 0 3.57-.33 4.75-.84a5.97 5.97 0 0 1 .78-8.16H5m16.5 1a1 1 0 0 0-1-1H20a4.5 4.5 0 1 0 0 9h.5a1 1 0 1 0 0-2H20a2.5 2.5 0 0 1 0-5h.5a1 1 0 0 0 1-1m4-1a1 1 0 1 0 0 2h.5a2.5 2.5 0 0 1 0 5h-.5a1 1 0 1 0 0 2h.5a4.5 4.5 0 1 0 0-9zm-5 3.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$f40bfd6bb724ebd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink32Regular', "32", [
    "M7 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10.5 5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M21 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 21a3 3 0 0 1 3-3h11.03a6 6 0 0 0-1.49 2H5a1 1 0 0 0-1 1v.29l.09.4c.09.35.27.82.64 1.29.7.9 2.25 2.02 5.77 2.02 1.67 0 2.9-.25 3.8-.61q.33.97.95 1.77c-1.2.51-2.75.84-4.75.84-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 21.24V21m19.5-2a1 1 0 0 0-1-1H20a4.5 4.5 0 1 0 0 9h.5a1 1 0 1 0 0-2H20a2.5 2.5 0 0 1 0-5h.5a1 1 0 0 0 1-1m4-1a1 1 0 1 0 0 2h.5a2.5 2.5 0 0 1 0 5h-.5a1 1 0 1 0 0 2h.5a4.5 4.5 0 1 0 0-9zm-5 3.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$6be50a56074ee7e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink48Filled', "48", [
    "M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16m18 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12M6.75 27A3.75 3.75 0 0 0 3 30.75V32s0 9 13 9c3.4 0 5.9-.61 7.76-1.52A8.3 8.3 0 0 1 21 33.25c0-2.5 1.08-4.74 2.78-6.25zM23 33.25C23 29.8 25.8 27 29.25 27h1.5a1.25 1.25 0 1 1 0 2.5h-1.5a3.75 3.75 0 1 0 0 7.5h1.5a1.25 1.25 0 1 1 0 2.5h-1.5A6.25 6.25 0 0 1 23 33.25m22 0C45 29.8 42.2 27 38.75 27h-1.5a1.25 1.25 0 1 0 0 2.5h1.5a3.75 3.75 0 1 1 0 7.5h-1.5a1.25 1.25 0 1 0 0 2.5h1.5c3.45 0 6.25-2.8 6.25-6.25m-17 0c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $76e5a570f6bfc30c$export$59fe45764cb72303 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLink48Regular', "48", [
    "M10.5 16a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M16 8a8 8 0 1 0 0 16 8 8 0 0 0 0-16m14.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12M6.75 27A3.75 3.75 0 0 0 3 30.75v1.3l.03.42q.03.4.2 1.05c.2.85.64 1.98 1.5 3.11C6.47 38.95 9.82 41 16 41c3.35 0 5.87-.6 7.75-1.53a8 8 0 0 1-1.63-2A16 16 0 0 1 16 38.5c-5.57 0-8.1-1.82-9.29-3.38a6 6 0 0 1-1.21-3.13v-1.24c0-.69.56-1.25 1.25-1.25h15.12a8 8 0 0 1 1.9-2.5zM23 33.25C23 29.8 25.8 27 29.25 27h1.5a1.25 1.25 0 1 1 0 2.5h-1.5a3.75 3.75 0 1 0 0 7.5h1.5a1.25 1.25 0 1 1 0 2.5h-1.5A6.25 6.25 0 0 1 23 33.25m22 0C45 29.8 42.2 27 38.75 27h-1.5a1.25 1.25 0 1 0 0 2.5h1.5a3.75 3.75 0 1 1 0 7.5h-1.5a1.25 1.25 0 1 0 0 2.5h1.5c3.45 0 6.25-2.8 6.25-6.25m-17 0c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $76e5a570f6bfc30c$export$120a1c383efbc0e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_16_color__a)",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_16_color__b)",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_16_color__c)",
            "d": "M11.5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_16_color__d)",
            "d": "M8 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_16_color__e)",
            "d": "M7 9c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_16_color__f)",
            "d": "M9.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_16_color__a",
                "x1": "3.4",
                "x2": "5",
                "y1": "9.6",
                "y2": "14.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_16_color__b",
                "x1": "5.5",
                "x2": "7.75",
                "y1": "8.46",
                "y2": "15.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_16_color__c",
                "x1": "10.45",
                "x2": "12.49",
                "y1": "4.53",
                "y2": "7.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_16_color__d",
                "x1": "4.19",
                "x2": "6.74",
                "y1": "3.66",
                "y2": "7.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_16_color__e",
                "x1": "10.21",
                "x2": "13.66",
                "y1": "7",
                "y2": "15.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_16_color__f",
                "x1": "6.5",
                "x2": "14",
                "y1": "5.5",
                "y2": "14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$d951b5557c41cdc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList16Filled', "16", [
    "M7.5 9a2 2 0 0 1 .56.08 1.5 1.5 0 0 0 .32 1.42 1.5 1.5 0 0 0 0 2 1.5 1.5 0 0 0-.36.77C7.2 13.74 6.14 14 5 14a6 6 0 0 1-3.09-.77C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zm7 4a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m7 1A2.25 2.25 0 1 1 12 8a2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$863fcdc0e04651da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList16Regular', "16", [
    "M7.5 9a2 2 0 0 1 .56.08 1.5 1.5 0 0 0 .02.92H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 13 5 13s1.94-.24 2.57-.62q.3-.2.5-.41.11.3.31.53a1.5 1.5 0 0 0-.36.77C7.2 13.74 6.14 14 5 14a6 6 0 0 1-3.09-.77C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zm7 4a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m7.23 1a2.25 2.25 0 0 1 2.02 2.25v.23A2.25 2.25 0 0 1 12.01 8h-.04l-.2-.01a2.25 2.25 0 0 1-2.02-2.01l-.01-.23c0-1.24 1-2.25 2.25-2.25zm-.23 1A1.25 1.25 0 1 0 12 7a1.25 1.25 0 0 0 0-2.5m-7-1A1.75 1.75 0 1 0 5 7a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$5e33c157db9faef7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__a)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__b)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__c)",
            "fillOpacity": ".75",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__d)",
            "d": "M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__e)",
            "d": "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__f)",
            "d": "M10 12c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__g)",
            "d": "M12.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "11.8",
                "y2": "17.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "10.29",
                "y2": "20.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__c",
                "x1": "14.5",
                "x2": "8.5",
                "y1": "14.5",
                "y2": "14.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "5.66",
                "y2": "9.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "4.36",
                "y2": "9.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__f",
                "x1": "13.21",
                "x2": "16.66",
                "y1": "10",
                "y2": "18.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__g",
                "x1": "9.5",
                "x2": "17",
                "y1": "8.5",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$4834997827870843 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList20Filled', "20", [
    "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5m3.75 2.5c0-.48.23-.91.58-1.18A2 2 0 0 0 10 11H3.5a2 2 0 0 0-2 2s0 4 5.25 4c1.95 0 3.18-.55 3.95-1.25q.07-.13.18-.25a1.5 1.5 0 0 1 0-2 1.5 1.5 0 0 1-.38-1m6.5-5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M12 12a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$6a36fd788514b1bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList20Regular', "20", [
    "M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M10 11a2 2 0 0 1 1.08.32q-.41.32-.54.84A1 1 0 0 0 10 12H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16s3.26-.8 3.74-1.5l.01-.01v.01q.01.58.38 1l-.2.27C9.9 16.47 8.67 17 6.76 17c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V13c0-1.1.9-2 2-2zm3-3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12 12a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$672d7fa2bbd6d3c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__a)",
            "d": "M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__b)",
            "d": "M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__c)",
            "fillOpacity": ".75",
            "d": "M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__d)",
            "d": "M17 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__e)",
            "d": "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__f)",
            "d": "M11 13c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_24_color__g)",
            "d": "M13.75 13a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 2.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0 2.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__a",
                "x1": "4.85",
                "x2": "7.41",
                "y1": "14.93",
                "y2": "21.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__b",
                "x1": "8",
                "x2": "11.61",
                "y1": "13.17",
                "y2": "24.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__c",
                "x1": "15",
                "x2": "9",
                "y1": "18",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__d",
                "x1": "15.43",
                "x2": "18.48",
                "y1": "6.8",
                "y2": "11.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__e",
                "x1": "5.9",
                "x2": "9.98",
                "y1": "5.06",
                "y2": "11.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__f",
                "x1": "14.93",
                "x2": "19.14",
                "y1": "11",
                "y2": "21.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_24_color__g",
                "x1": "9.5",
                "x2": "20",
                "y1": "8.1",
                "y2": "20",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$259ad3b6ed9868f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList24Filled', "24", [
    "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 14C3.01 14 2 15 2 16.25v.25S2 21 8 21c1.85 0 3.14-.43 4.02-1.02q.1-.58.5-.98a1.74 1.74 0 0 1 0-2.5 1.74 1.74 0 0 1-.1-2.4q-.3-.1-.67-.1zm9.5.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 2.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 2.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$b68ea2e9d21471f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList24Regular', "24", [
    "M5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 14C3.01 14 2 15 2 16.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 19.97 5.17 21 8 21c1.82 0 3.11-.42 4.02-1.04q.12-.56.5-.96a1.7 1.7 0 0 1-.51-1.1l-.03.04c-.5.71-1.56 1.56-3.98 1.56s-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.5q.15 0 .28.05a1.8 1.8 0 0 1 .4-1.45q-.32-.1-.68-.1zm8.28 2.5-.03.03v-.06zm1.22-2a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 2.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 2.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$fb302ac8652ab9cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__a)",
            "d": "M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 24 9.5 24 2 18.75 2 18.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__b)",
            "d": "M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 24 9.5 24 2 18.75 2 18.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__c)",
            "fillOpacity": ".75",
            "d": "M2 18.25C2 17.01 3 16 4.25 16h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 24 9.5 24 2 18.75 2 18.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__d)",
            "d": "M23.5 10.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__e)",
            "d": "M9.5 14a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__f)",
            "d": "M14 17c0-1.1.9-2 2-2h9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_28_color__g)",
            "d": "M16.75 17a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 3.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0 3.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__a",
                "x1": "5.57",
                "x2": "8.29",
                "y1": "17.06",
                "y2": "25.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__b",
                "x1": "9.5",
                "x2": "13.33",
                "y1": "15.05",
                "y2": "28.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__c",
                "x1": "18",
                "x2": "12",
                "y1": "21",
                "y2": "21",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__d",
                "x1": "18.16",
                "x2": "21.73",
                "y1": "7.93",
                "y2": "13.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__e",
                "x1": "7.14",
                "x2": "11.73",
                "y1": "6.2",
                "y2": "13.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__f",
                "x1": "18.64",
                "x2": "22.98",
                "y1": "15",
                "y2": "26.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_28_color__g",
                "x1": "11.5",
                "x2": "23.25",
                "y1": "11.4",
                "y2": "26.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$837d0fdda245419f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList28Filled', "28", [
    "M9.5 14a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 18.25C2 17.01 3 16 4.25 16h10.5q.36 0 .68.1a1.74 1.74 0 0 0 .42 2.65 1.75 1.75 0 0 0-.05 2.97l-.39.4C14.34 23.14 12.53 24 9.5 24 2 24 2 18.75 2 18.75zm14.75-1.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$e789d45a45d209d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList28Regular', "28", [
    "M5 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6m7 4a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M2 18.25C2 17.01 3 16 4.25 16h10.5q.36 0 .68.1a1.7 1.7 0 0 0-.4 1.45 1 1 0 0 0-.28-.05H4.25a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 3.2 0 4.63-1.05 5.3-1.95l.2-.29c0 .61.32 1.15.8 1.46l-.35.36C14.33 23.16 12.49 24 9.5 24 5.94 24 4 22.8 3 21.45a5 5 0 0 1-1-2.67v-.53m14.75-1.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$a308305202187e76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__a)",
            "d": "M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27s8.5-5.85 8.5-5.85V21a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__b)",
            "d": "M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27s8.5-5.85 8.5-5.85V21a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__c)",
            "fillOpacity": ".75",
            "d": "M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27s8.5-5.85 8.5-5.85V21a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__d)",
            "d": "M23 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__e)",
            "d": "M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__f)",
            "d": "M15 18c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_32_color__g)",
            "d": "M18 18a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__a",
                "x1": "6.04",
                "x2": "9.09",
                "y1": "19.2",
                "y2": "28.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__b",
                "x1": "10.5",
                "x2": "14.78",
                "y1": "16.93",
                "y2": "32.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__c",
                "x1": "21",
                "x2": "13",
                "y1": "23",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__d",
                "x1": "20.9",
                "x2": "24.98",
                "y1": "9.06",
                "y2": "15.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__e",
                "x1": "7.62",
                "x2": "13.22",
                "y1": "6.46",
                "y2": "15.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__f",
                "x1": "20.36",
                "x2": "25.46",
                "y1": "16",
                "y2": "29.49",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_32_color__g",
                "x1": "11.5",
                "x2": "26.26",
                "y1": "11",
                "y2": "29.4",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$1d82563529ca6c53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList32Filled', "32", [
    "M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8M5 18a3 3 0 0 0-3 3v.15S2 27 10.5 27q2.48-.02 4.07-.58A2.5 2.5 0 0 1 15.5 25a2.5 2.5 0 0 1 0-4 2.5 2.5 0 0 1-.8-3zm12 0a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1"
]);
const $76e5a570f6bfc30c$export$b06e4c26ec661c23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList32Light', "32", [
    "M10.5 5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M6 10.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M23 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M5 18a3 3 0 0 0-3 3c0 1.12.42 2.63 1.72 3.86C5.02 26.1 7.16 27 10.5 27q2.43-.01 4.07-.58A2.5 2.5 0 0 1 15.5 25l-.05-.04c-1.12.61-2.7 1.04-4.95 1.04-3.16 0-5.02-.85-6.1-1.86A4.4 4.4 0 0 1 3 21c0-1.1.9-2 2-2h9.5q0-.54.2-1zm12 0a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1"
]);
const $76e5a570f6bfc30c$export$a7db3a3dbf036621 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleList32Regular', "32", [
    "M7 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10.5 5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M21 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 21a3 3 0 0 1 3-3h9.7a2.5 2.5 0 0 0 0 2H5a1 1 0 0 0-1 1v.28q.02.15.09.4c.09.36.27.83.64 1.3.7.9 2.25 2.02 5.77 2.02 2 0 3.35-.36 4.29-.83q.27.48.71.83c-.46.34-.8.84-.93 1.42q-1.62.56-4.07.58c-3.98 0-6.18-1.29-7.35-2.8a5.6 5.6 0 0 1-1.13-2.7zm15-3a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1"
]);
const $76e5a570f6bfc30c$export$6af3e23698c53616 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock16Filled', "16", [
    "M12.5 7a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5V9c0-1.1.9-2 2-2m0 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M7.5 8a2 2 0 0 1 1.8 1.13A2 2 0 0 0 8 11v1.28c-.8.47-1.87.72-3 .72a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm5 0a1 1 0 0 0-1 1v1h2V9a1 1 0 0 0-1-1M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m7 1a2.25 2.25 0 0 1 1.68 3.74 3 3 0 0 0-2.97.35 2.25 2.25 0 0 1 1.3-4.1"
]);
const $76e5a570f6bfc30c$export$df4e1ad161bedd73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock16Regular', "16", [
    "M12.5 7a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5V9c0-1.1.9-2 2-2m0 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M7.5 8a2 2 0 0 1 1.8 1.13 2 2 0 0 0-.84.6A1 1 0 0 0 7.5 9h-5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12s1.94-.24 2.57-.62q.25-.16.43-.33v1.23c-.8.47-1.87.72-3 .72a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm5 0a1 1 0 0 0-1 1v1h2V9a1 1 0 0 0-1-1M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m7.23 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.74-.57 1.26a3 3 0 0 0-2.97.35 2.3 2.3 0 0 1-.95-1.61l-.01-.23c0-1.24 1-2.25 2.25-2.25zm-.23 1A1.25 1.25 0 1 0 12 6a1.25 1.25 0 0 0 0-2.5m-7-1A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$c9abf023e7709f37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock20Filled', "20", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m1 8.7c-.74.83-2.02 1.55-4.25 1.55-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2H10a2 2 0 0 1 2 2l-.02.28A2 2 0 0 0 11 14zM14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-1 3v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$515dad41d9330ab9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock20Regular', "20", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m7.5 8.72C10.23 15.3 8.93 16 6.75 16c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2v.08l-.01.18v.02A2 2 0 0 0 11 14zm-8.5-2.4v.1l.06.32c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15s3.26-.8 3.74-1.5a3 3 0 0 0 .5-1.42l.01-.02V12a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1zM14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m1.5 5.5v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$8f8e77f1c75b01c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock24Filled', "24", [
    "M12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m4 3.83a3.5 3.5 0 0 1 2.45-.2 3 3 0 1 0-2.44.2m-2.3 3.3A2.5 2.5 0 0 0 12 16.5v2.49A7 7 0 0 1 8 20c-6 0-6-4.5-6-4.5v-.25C2 14.01 3 13 4.25 13h7.5c.83 0 1.56.45 1.95 1.13M15 15v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5zm1.5-1v1h2v-1a1 1 0 1 0-2 0m2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $76e5a570f6bfc30c$export$d16539ede8b124f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock24Regular', "24", [
    "M8 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M14 8a3 3 0 1 1 4.45 2.63 3.5 3.5 0 0 0-2.44.2A3 3 0 0 1 14 8m-.3 6.13A2.3 2.3 0 0 0 11.75 13h-7.5C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.8 0 3.1-.42 4-1.02V16.9l-.02.03c-.5.71-1.56 1.56-3.98 1.56s-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.5c.34 0 .63.23.72.54q.47-.64 1.23-.91m.8.87h.5v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5m2-1v1h2v-1a1 1 0 1 0-2 0m2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $76e5a570f6bfc30c$export$a452e7cb4a508c07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock28Filled', "28", [
    "M20 14a3 3 0 0 1 3 3v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h.5v-1a3 3 0 0 1 3-3m0 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-5.25-6c.58 0 1.11.22 1.5.58q-.24.67-.25 1.42v.04A3 3 0 0 0 13.5 20v2.32a11 11 0 0 1-4 .68C2 23 2 17.75 2 17.75v-.5C2 16.01 3 15 4.25 15zm5.25.5c-.83 0-1.5.67-1.5 1.5v1h3v-1c0-.83-.67-1.5-1.5-1.5M9.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M20 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
]);
const $76e5a570f6bfc30c$export$3c3ea0c7ba4ffc00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock28Regular', "28", [
    "M20 14a3 3 0 0 1 3 3v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h.5v-1a3 3 0 0 1 3-3m0 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-5.25-6c.58 0 1.11.22 1.5.58q-.24.67-.25 1.42v.04q-.26.04-.5.13a.75.75 0 0 0-.75-.67H4.25a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 1.87 0 3.13-.36 4-.84v1.66c-1.03.41-2.33.68-4 .68C5.94 23 4 21.8 3 20.45a5 5 0 0 1-1-2.61v-.59C2 16.01 3 15 4.25 15zm5.25.5c-.83 0-1.5.67-1.5 1.5v1h3v-1c0-.83-.67-1.5-1.5-1.5M9.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M20 6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7M9.5 5.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m10.5 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$1cc817d210cff75e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock32Filled', "32", [
    "M23 16.5a3.5 3.5 0 0 1 3.5 3.5v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5V20a3.5 3.5 0 0 1 3.5-3.5m0 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7-7a3 3 0 0 1 2.36 1.15q-.2.45-.28.96A4 4 0 0 0 15 23v2.26c-1.14.45-2.61.74-4.5.74C2.04 26 2 20.2 2 20.15V20a3 3 0 0 1 3-3zm7 1.5c-.83 0-1.5.67-1.5 1.5v.5h3V20c0-.83-.67-1.5-1.5-1.5M10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $76e5a570f6bfc30c$export$8cf5ab46c06d39d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock32Light', "32", [
    "M23 16.5a3.5 3.5 0 0 1 3.5 3.5v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5V20a3.5 3.5 0 0 1 3.5-3.5m0 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7-7a3 3 0 0 1 2.36 1.15q-.2.45-.28.96l-.26.07A2 2 0 0 0 16 18H5a2 2 0 0 0-2 2c0 .88.33 2.12 1.4 3.14C5.49 24.15 7.35 25 10.5 25c1.96 0 3.42-.33 4.5-.82v1.09c-1.17.45-2.65.73-4.5.73-3.34 0-5.48-.9-6.78-2.14A5.4 5.4 0 0 1 2 20a3 3 0 0 1 3-3zm7 1.5c-.83 0-1.5.67-1.5 1.5v.5h3V20c0-.83-.67-1.5-1.5-1.5M10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8M10.5 5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M23 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $76e5a570f6bfc30c$export$ca058bbe3cc41964 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLock32Regular', "32", [
    "M23 16.5a3.5 3.5 0 0 1 3.5 3.5v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5V20a3.5 3.5 0 0 1 3.5-3.5m0 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7-7a3 3 0 0 1 2.36 1.15q-.2.45-.28.96-.63.15-1.17.48A1 1 0 0 0 16 19H5a1 1 0 0 0-1 1v.29l.08.4c.1.35.28.82.65 1.29.7.9 2.25 2.02 5.77 2.02 2.15 0 3.56-.42 4.5-.95v2.2c-1.16.46-2.63.75-4.5.75-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 20.3V20a3 3 0 0 1 3-3zm7 1.5c-.83 0-1.5.67-1.5 1.5v.5h3V20c0-.83-.67-1.5-1.5-1.5M10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8M10.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M23 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$bb2e3e3c0220aaf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleMoney20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M9 12.5c0-1.1.71-2.04 1.7-2.37A2 2 0 0 0 10 10H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.34-.01 2.26-.31L9 15.5zm8-6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-7 6c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5zm1 0v1c.83 0 1.5-.67 1.5-1.5h-1a.5.5 0 0 1-.5.5m7 1v-1a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5M16.5 16h1c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5M11 14.5v1c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5m3.5 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $76e5a570f6bfc30c$export$2bb0e6df393a9355 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleMoney20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M10 10a2 2 0 0 1 .7.13q-.74.26-1.2.87h-6a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15q1.42-.01 2.25-.37v1.06q-.91.3-2.25.31c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12c0-1.1.9-2 2-2zm3-3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10 12.5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5zm1 0v1c.83 0 1.5-.67 1.5-1.5h-1a.5.5 0 0 1-.5.5m7 1v-1a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5M16.5 16h1c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5M11 14.5v1c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5m3.5 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $76e5a570f6bfc30c$export$30a88dc32c186e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleMoney24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20c1.24 0 2.22-.2 3-.5v-4a2.5 2.5 0 0 1 1.6-2.33q-.4-.17-.85-.17zM12 15.5c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5zm1 .5v1a2 2 0 0 0 2-2h-1a1 1 0 0 1-1 1m9 1v-1a1 1 0 0 1-1-1h-1c0 1.1.9 2 2 2m-2 3h1a1 1 0 0 1 1-1v-1a2 2 0 0 0-2 2m-7-2v1a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2m4.5 1.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
]);
const $76e5a570f6bfc30c$export$4ec64307fca56210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleMoney24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-5.25 8q.46 0 .85.17a2.5 2.5 0 0 0-1.4 1.33H4.26a.75.75 0 0 0-.75.75v.34l.06.33c.07.28.2.65.46 1.02.5.71 1.56 1.56 3.98 1.56 1.4 0 2.36-.29 3-.67v1.67c-.8.3-1.78.5-3 .5-2.83 0-4.39-1.03-5.2-2.2a4.5 4.5 0 0 1-.8-2.27v-.28C2 14.01 3 13 4.25 13zm.25 2.5c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5zm1 .5v1a2 2 0 0 0 2-2h-1a1 1 0 0 1-1 1m9 1v-1a1 1 0 0 1-1-1h-1c0 1.1.9 2 2 2m-2 3h1a1 1 0 0 1 1-1v-1a2 2 0 0 0-2 2m-7-2v1a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2m4.5 1.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
]);
const $76e5a570f6bfc30c$export$c43e5ead69fec498 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2.1 7.3a3.5 3.5 0 0 0 4.9-4.9zM11.5 8a3.5 3.5 0 0 0-2.8 5.6l4.9-4.9a3.5 3.5 0 0 0-2.1-.7M7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$f762167c5cf93a8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2.1 7.3a3.5 3.5 0 0 0 4.9-4.9zM11.5 8a3.5 3.5 0 0 0-2.8 5.6l4.9-4.9a3.5 3.5 0 0 0-2.1-.7M7.26 8q-.39.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$72c1bf8b4e6ffde8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m1 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $76e5a570f6bfc30c$export$1de626ab9b94a832 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $76e5a570f6bfc30c$export$fecc209d06863adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20a8 8 0 0 0 3.28-.61 6.5 6.5 0 0 1 1.36-6.2 2 2 0 0 0-.89-.19zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3m4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69"
]);
const $76e5a570f6bfc30c$export$444d04cdb56cb147 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.37 0 2.44-.24 3.28-.62a7 7 0 0 1-.27-1.55c-.65.38-1.6.67-3.01.67-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.48q.38-.72.91-1.32a2 2 0 0 0-.89-.18zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3m4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69"
]);
const $76e5a570f6bfc30c$export$2ece54ca03a08858 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited48Filled', "48", [
    "M34 24a11 11 0 1 1 0 22 11 11 0 0 1 0-22m-5.06 17.83a8.5 8.5 0 0 0 11.9-11.9zM34 26.5a8.5 8.5 0 0 0-6.83 13.56l11.9-11.89A8.5 8.5 0 0 0 34 26.5M25.25 25q.21 0 .42.02a13 13 0 0 0-4.24 13.32c-1.5.41-3.28.66-5.43.66-13 0-13-9-13-9v-1.25A3.75 3.75 0 0 1 6.75 25zM16 6a8 8 0 1 1 0 16 8 8 0 0 1 0-16m18 4a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
]);
const $76e5a570f6bfc30c$export$53195fee83bf792d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibited48Regular', "48", [
    "M34 24a11 11 0 1 1 0 22 11 11 0 0 1 0-22m-5.06 17.83a8.5 8.5 0 0 0 11.9-11.9zM34 26.5a8.5 8.5 0 0 0-6.83 13.56l11.9-11.89A8.5 8.5 0 0 0 34 26.5M25.25 25q.21 0 .42.02-1.31 1.1-2.29 2.48H6.75c-.69 0-1.25.56-1.25 1.25v1.24l.02.2q.01.26.13.71c.15.6.45 1.41 1.06 2.22C7.9 34.68 10.43 36.5 16 36.5c2.07 0 3.71-.25 5.03-.64q.09 1.28.4 2.48c-1.5.41-3.3.66-5.43.66-6.18 0-9.52-2.05-11.28-4.37A8.7 8.7 0 0 1 3 30.05v-1.3A3.75 3.75 0 0 1 6.75 25zM16 6a8 8 0 1 1 0 16 8 8 0 0 1 0-16m18 4a6 6 0 1 1 0 12 6 6 0 0 1 0-12M16 8.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m18 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $76e5a570f6bfc30c$export$a4b7fd036c3708a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue20Filled', "20", [
    "M8.75 5.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M4 8a1 1 0 0 0-1 1v4.5a3.5 3.5 0 1 0 7 0V9a1 1 0 0 0-1-1zm5.75-2.75c0 .65-.2 1.26-.52 1.76a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.54.8.56 1.83m-.25 11.6A4.5 4.5 0 0 0 11 13.5V9a2 2 0 0 0-.27-1H13a1 1 0 0 1 1 1v4.5a3.5 3.5 0 0 1-4.5 3.35m4.25-11.6c0 .65-.2 1.26-.52 1.76a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.54.8.56 1.83m-.25 11.6A4.5 4.5 0 0 0 15 13.5V9a2 2 0 0 0-.27-1H17a1 1 0 0 1 1 1v4.5a3.5 3.5 0 0 1-4.5 3.35"
]);
const $76e5a570f6bfc30c$export$3ea4796b5ddba157 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue20Regular', "20", [
    "M6.5 7.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m0-1a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M3 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.5a3.5 3.5 0 1 1-7 0zm1 0v4.5a2.5 2.5 0 0 0 5 0V9zm5.63-2.86q-.15.46-.4.87a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.29.42.44.94a1.25 1.25 0 0 1 2.12.89 1.25 1.25 0 0 1-2.12.9M9.5 16.85A3.5 3.5 0 0 0 14 13.5V9a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 11 9h2v4.5a2.5 2.5 0 0 1-2.75 2.49q-.32.48-.75.86m4.13-10.7q-.15.46-.4.86a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.29.42.44.94a1.25 1.25 0 0 1 2.12.89 1.25 1.25 0 0 1-2.12.9m-.13 10.7A3.5 3.5 0 0 0 18 13.5V9a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 15 9h2v4.5a2.5 2.5 0 0 1-2.75 2.49q-.32.48-.75.86"
]);
const $76e5a570f6bfc30c$export$7ae7d494a626fbe1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue24Filled', "24", [
    "M10.5 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-5.75 4C3.78 10 3 10.78 3 11.75v4.75a4.5 4.5 0 1 0 9 0v-4.75c0-.97-.78-1.75-1.75-1.75zm6.11 10.85A5.5 5.5 0 0 0 13 16.5v-4.75c0-.66-.24-1.27-.63-1.75h2.38c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 0 1-5.64 4.35M11.5 6c0 1-.37 1.91-.97 2.61Q11.18 9 12 9a3 3 0 1 0-1.47-5.61c.6.7.97 1.61.97 2.61m3.86 14.85a5.5 5.5 0 0 0 2.14-4.35v-4.75c0-.66-.24-1.27-.63-1.75h2.38c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 0 1-5.64 4.35M16 6c0 1-.37 1.91-.97 2.61q.65.38 1.47.39a3 3 0 1 0-1.47-5.61c.6.7.97 1.61.97 2.61"
]);
const $76e5a570f6bfc30c$export$112bc1496249397f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue24Regular', "24", [
    "M7.5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M3 11.75c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 1 1-9 0zm1.75-.25a.25.25 0 0 0-.25.25v4.75a3 3 0 1 0 6 0v-4.75a.25.25 0 0 0-.25-.25zm5.78-2.89Q11.18 9 12 9a3 3 0 1 0-1.47-5.61 4 4 0 0 1 .75 1.3q.32-.19.72-.19a1.5 1.5 0 1 1-.72 2.82 4 4 0 0 1-.75 1.3m.33 12.24a4.5 4.5 0 0 0 5.64-4.35v-4.75c0-.97-.78-1.75-1.75-1.75h-2.38q.53.64.62 1.5h1.76q.23.02.25.25v4.75a3 3 0 0 1-2.89 3q-.51.79-1.25 1.35m4.17-12.24q.65.38 1.47.39a3 3 0 1 0-1.47-5.61 4 4 0 0 1 .75 1.3q.32-.19.72-.19a1.5 1.5 0 1 1-.72 2.82 4 4 0 0 1-.75 1.3m.33 12.24A4.5 4.5 0 0 0 21 16.5v-4.75c0-.97-.78-1.75-1.75-1.75h-2.38q.53.64.62 1.5h1.76q.23.02.25.25v4.75a3 3 0 0 1-2.89 3q-.51.79-1.25 1.35"
]);
const $76e5a570f6bfc30c$export$ca014e0e23eaa83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue28Filled', "28", [
    "M12.25 6.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0m-7 5.25C4.01 12 3 13 3 14.25v5.25a5.5 5.5 0 1 0 11 0v-5.25c0-1.24-1-2.25-2.25-2.25zM14 10.5q-1.1-.01-1.98-.56a4.73 4.73 0 0 0 0-6.38A3.75 3.75 0 1 1 14 10.5m1 3.75c0-.87-.34-1.67-.9-2.25h3.15c1.24 0 2.25 1 2.25 2.25v5.25a5.5 5.5 0 0 1-7.16 5.25A6.5 6.5 0 0 0 15 19.5zm2.52-4.31q.89.54 1.98.56a3.75 3.75 0 1 0-1.98-6.94 4.73 4.73 0 0 1 0 6.38m.32 14.8A5.5 5.5 0 0 0 25 19.5v-5.25c0-1.24-1-2.25-2.25-2.25H19.6c.56.58.9 1.38.9 2.25v5.25a6.5 6.5 0 0 1-2.66 5.24"
]);
const $76e5a570f6bfc30c$export$9400466cbad8fbaa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue28Regular', "28", [
    "M8.5 4.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M4.75 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M3 14.25C3 13.01 4 12 5.25 12h6.5c1.24 0 2.25 1 2.25 2.25v5.25a5.5 5.5 0 1 1-11 0zm2.25-.75a.75.75 0 0 0-.75.75v5.25a4 4 0 0 0 8 0v-5.25a.75.75 0 0 0-.75-.75zm8.75-3q-1.1-.01-1.98-.56.51-.56.82-1.26.52.31 1.16.32a2.25 2.25 0 1 0-1.16-4.18q-.3-.7-.82-1.26A3.75 3.75 0 1 1 14 10.5M14 25a6 6 0 0 1-1.66-.25q.74-.54 1.3-1.27l.36.02a4 4 0 0 0 4-4v-5.25a.75.75 0 0 0-.75-.75h-2.34a3 3 0 0 0-.81-1.5h3.15c1.24 0 2.25 1 2.25 2.25v5.25A5.5 5.5 0 0 1 14 25m3.52-15.06q.89.54 1.98.56a3.75 3.75 0 1 0-1.98-6.94q.52.56.82 1.26.52-.31 1.16-.32a2.25 2.25 0 1 1-1.16 4.18q-.3.7-.82 1.26m1.62 13.54.36.02a4 4 0 0 0 4-4v-5.25a.75.75 0 0 0-.75-.75h-2.34a3 3 0 0 0-.81-1.5h3.15C24 12 25 13 25 14.25v5.25a5.5 5.5 0 0 1-7.16 5.24q.74-.53 1.3-1.26"
]);
const $76e5a570f6bfc30c$export$399d337d7bbea75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue32Filled', "32", [
    "M16 11.5q-1.16-.01-2.1-.55a5.7 5.7 0 0 0 0-7.4A4.25 4.25 0 1 1 16 11.5m1.5 4c0-.95-.33-1.82-.88-2.5H20a2.5 2.5 0 0 1 2.5 2.5v7a6.5 6.5 0 0 1-8.08 6.3 8 8 0 0 0 3.08-6.3zm5-4q-1.16-.01-2.1-.55a5.7 5.7 0 0 0 0-7.4 4.25 4.25 0 1 1 2.1 7.95m1.5 4c0-.95-.33-1.82-.88-2.5h3.38a2.5 2.5 0 0 1 2.5 2.5v7a6.5 6.5 0 0 1-8.08 6.3A8 8 0 0 0 24 22.5zM5.5 13A2.5 2.5 0 0 0 3 15.5v7a6.5 6.5 0 1 0 13 0v-7a2.5 2.5 0 0 0-2.5-2.5zm4-1.5a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5"
]);
const $76e5a570f6bfc30c$export$22dcbed0e2807c18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue32Regular', "32", [
    "M13.9 10.95q.94.54 2.1.55a4.25 4.25 0 1 0-2.1-7.95q.65.77 1 1.74Q15.4 5 16 5a2.25 2.25 0 1 1-1.1 4.21 6 6 0 0 1-1 1.74m.52 17.86a6.5 6.5 0 0 0 8.08-6.31v-7A2.5 2.5 0 0 0 20 13h-3.38q.7.86.85 2H20c.28 0 .5.22.5.5v7a4.5 4.5 0 0 1-4.38 4.5 8 8 0 0 1-1.7 1.8m5.98-17.86q.95.54 2.1.55a4.25 4.25 0 1 0-2.1-7.95q.65.77 1 1.74.5-.29 1.1-.29a2.25 2.25 0 1 1-1.1 4.21 6 6 0 0 1-1 1.74m.52 17.86A6.5 6.5 0 0 0 29 22.5v-7a2.5 2.5 0 0 0-2.5-2.5h-3.38q.7.86.85 2h2.53c.28 0 .5.22.5.5v7a4.5 4.5 0 0 1-4.38 4.5 8 8 0 0 1-1.7 1.8M3 15.5A2.5 2.5 0 0 1 5.5 13h8a2.5 2.5 0 0 1 2.5 2.5v7a6.5 6.5 0 1 1-13 0zm2.5-.5a.5.5 0 0 0-.5.5v7a4.5 4.5 0 1 0 9 0v-7a.5.5 0 0 0-.5-.5zm1.75-7.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M9.5 3a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5"
]);
const $76e5a570f6bfc30c$export$2e476cef61a0157c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue48Filled', "48", [
    "M21.05 17.23q1.33.75 2.95.77a6 6 0 1 0-2.95-11.23 8 8 0 0 1 0 10.46M24 42q-1.18 0-2.28-.3A11 11 0 0 0 26 33v-9.25c0-1.43-.53-2.74-1.4-3.75h4.65A3.75 3.75 0 0 1 33 23.75V33a9 9 0 0 1-9 9m6.05-24.77Q31.38 18 33 18a6 6 0 1 0-2.95-11.23 8 8 0 0 1 0 10.46M33 42q-1.18 0-2.28-.3A11 11 0 0 0 35 33v-9.25c0-1.43-.52-2.74-1.39-3.75h4.64A3.75 3.75 0 0 1 42 23.75V33a9 9 0 0 1-9 9M9.75 20A3.75 3.75 0 0 0 6 23.75V33a9 9 0 1 0 18 0v-9.25A3.75 3.75 0 0 0 20.25 20zM15 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
]);
const $76e5a570f6bfc30c$export$e8f5321bebbe473c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueue48Regular', "48", [
    "M24 18a6 6 0 0 1-2.95-.77 8 8 0 0 0 1.33-2.13q.73.4 1.62.4a3.5 3.5 0 1 0-1.62-6.6 8 8 0 0 0-1.33-2.13Q22.38 6.02 24 6a6 6 0 0 1 0 12m0 21.5h-.13q-.91 1.26-2.15 2.2A9 9 0 0 0 33 33v-9.25A3.75 3.75 0 0 0 29.25 20h-4.64q.92 1.07 1.25 2.5h3.4c.68 0 1.24.56 1.24 1.25V33a6.5 6.5 0 0 1-6.5 6.5M33 18a6 6 0 0 1-2.94-.77 8 8 0 0 0 1.32-2.13q.74.4 1.62.4a3.5 3.5 0 1 0-1.62-6.6 8 8 0 0 0-1.32-2.13Q31.38 6.02 33 6a6 6 0 0 1 0 12m0 21.5h-.12q-.92 1.26-2.16 2.2A9 9 0 0 0 42 33v-9.25A3.75 3.75 0 0 0 38.25 20h-4.64q.93 1.07 1.26 2.5h3.38c.7 0 1.25.56 1.25 1.25V33a6.5 6.5 0 0 1-6.5 6.5M6 23.75A3.75 3.75 0 0 1 9.75 20h10.5A3.75 3.75 0 0 1 24 23.75V33a9 9 0 1 1-18 0zm3.75-1.25c-.69 0-1.25.56-1.25 1.25V33a6.5 6.5 0 1 0 13 0v-9.25c0-.69-.56-1.25-1.25-1.25zM11.5 12a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M15 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
]);
const $76e5a570f6bfc30c$export$89a690504a6d402b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSearch20Filled', "20", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m4.87 14.8a8.5 8.5 0 0 1-3.97 1.17 2 2 0 0 0-.34-.53l-2-2A4.5 4.5 0 0 0 8.24 11H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $76e5a570f6bfc30c$export$5fd891edf0c05cd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSearch20Regular', "20", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m7.87 10.8a8.5 8.5 0 0 1-3.97 1.17 2 2 0 0 0-.34-.53l-.44-.44a8 8 0 0 0 4.2-1.05A3.4 3.4 0 0 0 16 13a1 1 0 0 0-1-1H8.74q-.19-.54-.5-1H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $76e5a570f6bfc30c$export$5866458d3b16643e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSearch24Filled', "24", [
    "M11.9 14h7.85C21 14 22 15 22 16.25v.9c0 1.1-.47 2.14-1.3 2.85q-2.36 2-6.7 2h-.18c.3-.6.23-1.36-.22-1.9l-.11-.12-2.23-2.22A5.5 5.5 0 0 0 11.9 14m-5.4-3.5a4.5 4.5 0 0 1 3.46 7.38l2.82 2.81a.75.75 0 0 1-.97 1.14l-.09-.08-2.9-2.9q-1.03.64-2.32.65a4.5 4.5 0 0 1 0-9m0 1.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M14 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10"
]);
const $76e5a570f6bfc30c$export$b899ddbe26e1a2c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSearch24Regular', "24", [
    "M11.9 14h7.85C21 14 22 15 22 16.25v.9c0 1.1-.47 2.14-1.3 2.85q-2.36 2-6.7 2h-.18c.23-.47.24-1.02.03-1.5H14q3.84-.01 5.72-1.64c.5-.43.78-1.05.78-1.7v-.91a.75.75 0 0 0-.75-.75h-7.77a6 6 0 0 0-.07-1.5m-5.4-3.5a4.5 4.5 0 0 1 3.46 7.38l2.82 2.81a.75.75 0 0 1-.97 1.14l-.09-.08-2.9-2.9q-1.03.64-2.32.65a4.5 4.5 0 0 1 0-9m0 1.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M14 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $76e5a570f6bfc30c$export$4974985b5ef0d197 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m3.06-3.06a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$d12dae94861dbc8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-2.44 7.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$2021218e4a5e42e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20a8 8 0 0 0 3.28-.61 6.5 6.5 0 0 1 1.36-6.2 2 2 0 0 0-.89-.19zm10.03.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.9l-.2-.7a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0-.01-1.8l-.54-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.58-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.91zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $76e5a570f6bfc30c$export$6aa541759def94a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.37 0 2.44-.24 3.28-.62a7 7 0 0 1-.27-1.55c-.65.38-1.6.67-3.01.67-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.48q.38-.72.91-1.32a2 2 0 0 0-.89-.18zm10.03.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.9l-.2-.7a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0-.01-1.8l-.54-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.58-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.91zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $76e5a570f6bfc30c$export$f153e054aba1a609 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings28Filled', "28", [
    "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .57.07a7.5 7.5 0 0 0-2.07 7.35c-.98.36-2.2.58-3.75.58C2 23 2 17.75 2 17.75zm14.8-.55a2 2 0 0 1-1.45 2.5l-1.02.25a7 7 0 0 0 0 2.15l.98.23a2 2 0 0 1 1.45 2.52l-.32 1.1q.79.69 1.75 1.1l.85-.9a2 2 0 0 1 2.9 0l.85.9a6 6 0 0 0 1.75-1.09l-.34-1.16a2 2 0 0 1 1.44-2.5l1.03-.25a7 7 0 0 0 0-2.15l-.99-.23a2 2 0 0 1-1.45-2.51l.33-1.1a6 6 0 0 0-1.75-1.1l-.85.88a2 2 0 0 1-2.9 0l-.85-.9a6 6 0 0 0-1.75 1.1zm3.7 5.3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $76e5a570f6bfc30c$export$4114ddbd3325ac79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings28Regular', "28", [
    "M9.5 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.25 15C3.01 15 2 16 2 17.25v.53l.02.24q.02.24.1.62c.13.5.38 1.15.87 1.81C4.01 21.8 5.94 23 9.5 23q2.28-.02 3.75-.58-.2-.75-.24-1.52c-.84.35-1.97.6-3.51.6-3.2 0-4.63-1.05-5.3-1.95a3.6 3.6 0 0 1-.7-1.79v-.51c0-.41.34-.75.75-.75h9.9q.5-.78 1.17-1.43a2 2 0 0 0-.57-.07zm12.55 1.7a2 2 0 0 1-1.45 2.5l-1.02.25a7 7 0 0 0 0 2.15l.98.23a2 2 0 0 1 1.45 2.52l-.32 1.1q.79.69 1.75 1.1l.85-.9a2 2 0 0 1 2.9 0l.85.9a6 6 0 0 0 1.75-1.09l-.34-1.16a2 2 0 0 1 1.44-2.5l1.03-.25a7 7 0 0 0 0-2.15l-.99-.23a2 2 0 0 1-1.45-2.51l.33-1.1a6 6 0 0 0-1.75-1.1l-.85.88a2 2 0 0 1-2.9 0l-.85-.9a6 6 0 0 0-1.75 1.1zm3.7 5.3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $76e5a570f6bfc30c$export$7c9bda04b94cd20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings32Filled', "32", [
    "M25.3 16.86a7.5 7.5 0 0 1 2.75 1.6l-.5 1.72c-.23.83.27 1.68 1.1 1.9l1.7.42a8 8 0 0 1-.04 3.18l-1.54.36a1.5 1.5 0 0 0-1.11 1.92l.46 1.52a7.5 7.5 0 0 1-2.73 1.63l-1.24-1.27c-.6-.62-1.6-.62-2.2 0l-1.25 1.3a7.5 7.5 0 0 1-2.75-1.6l.5-1.72a1.5 1.5 0 0 0-1.1-1.9l-1.7-.42a7.5 7.5 0 0 1 .04-3.19l1.54-.35a1.5 1.5 0 0 0 1.11-1.92l-.46-1.52a7.5 7.5 0 0 1 2.73-1.63l1.24 1.27c.6.62 1.6.62 2.2 0zM16 17q.59.01 1.1.2a9 9 0 0 0-2.97 8.35q-1.48.44-3.63.45C2.04 26 2 20.2 2 20.15V20a3 3 0 0 1 3-3zm7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4M10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $76e5a570f6bfc30c$export$ec575c07c2edc957 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings32Light', "32", [
    "M10.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M6 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M23 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-4 6a3 3 0 0 1 1.1.2q-.45.39-.83.82L16 18H5a2 2 0 0 0-2 2c0 .88.33 2.12 1.4 3.14C5.49 24.15 7.35 25 10.5 25q2.12-.02 3.52-.45.03.51.11 1-1.5.44-3.63.45c-3.34 0-5.48-.9-6.78-2.14A5.4 5.4 0 0 1 2 20a3 3 0 0 1 3-3zm2.34 3.04c.26.84-.25 1.73-1.11 1.92l-1.54.35a7.5 7.5 0 0 0-.04 3.2l1.7.42c.83.2 1.33 1.06 1.1 1.89l-.5 1.72a7.5 7.5 0 0 0 2.75 1.6l1.26-1.3c.6-.62 1.6-.62 2.2 0l1.23 1.27a7.5 7.5 0 0 0 2.73-1.63l-.46-1.52a1.5 1.5 0 0 1 1.11-1.92l1.54-.36a7.5 7.5 0 0 0 .04-3.18l-1.7-.43a1.5 1.5 0 0 1-1.1-1.89l.5-1.72a7.5 7.5 0 0 0-2.75-1.6l-1.26 1.3c-.6.62-1.6.62-2.2 0l-1.23-1.27a7.5 7.5 0 0 0-2.73 1.63zM25 24a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $76e5a570f6bfc30c$export$22a232e8e89ae782 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettings32Regular', "32", [
    "M25.3 16.86a7.5 7.5 0 0 1 2.75 1.6l-.5 1.72c-.23.83.27 1.68 1.1 1.9l1.7.42a8 8 0 0 1-.04 3.18l-1.54.36a1.5 1.5 0 0 0-1.11 1.92l.46 1.52a7.5 7.5 0 0 1-2.73 1.63l-1.24-1.27c-.6-.62-1.6-.62-2.2 0l-1.25 1.3a7.5 7.5 0 0 1-2.75-1.6l.5-1.72a1.5 1.5 0 0 0-1.1-1.9l-1.7-.42a7.5 7.5 0 0 1 .04-3.19l1.54-.35a1.5 1.5 0 0 0 1.11-1.92l-.46-1.52a7.5 7.5 0 0 1 2.73-1.63l1.24 1.27c.6.62 1.6.62 2.2 0zM16 17q.59.01 1.1.2a9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1v.29l.08.4c.1.35.28.82.65 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.43-3.63.45c-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 20.3V20a3 3 0 0 1 3-3zm7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4M10.5 4a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8M10.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M23 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $76e5a570f6bfc30c$export$a0a4e150dcc0a8f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m.48 1.86a.5.5 0 0 0-.96 0l-.47 1.53H9c-.48 0-.68.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54zM7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$af95845717c022cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m.48 1.86a.5.5 0 0 0-.96 0l-.47 1.53H9c-.48 0-.68.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54zM7.26 8q-.39.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$c816e32627e5bc19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar20Filled', "20", [
    "M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26 5.5 5.5 0 0 0-1.88 5.4q-.95.33-2.37.34c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2-1.1h-1.55l-.47-1.54a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95"
]);
const $76e5a570f6bfc30c$export$6b60243ac77acc3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54z"
]);
const $76e5a570f6bfc30c$export$bbea43fd594f230 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar24Filled', "24", [
    "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20a8 8 0 0 0 3.28-.61 6.5 6.5 0 0 1 1.36-6.2 2 2 0 0 0-.89-.19zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-4.94-3.08a.58.58 0 0 0-1.12 0l-.55 1.79h-1.8c-.57 0-.8.75-.35 1.1l1.46 1.1-.56 1.79c-.17.56.44 1.03.9.68l1.46-1.1 1.46 1.1c.46.35 1.07-.12.9-.68l-.56-1.79 1.46-1.1c.46-.35.22-1.1-.35-1.1h-1.8z"
]);
const $76e5a570f6bfc30c$export$b547188e2c89dda3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar24Regular', "24", [
    "M5.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m7.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4.25 13C3.01 13 2 14 2 15.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 18.97 5.17 20 8 20c1.37 0 2.44-.24 3.28-.62a7 7 0 0 1-.27-1.55c-.65.38-1.6.67-3.01.67-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.48q.38-.72.91-1.32a2 2 0 0 0-.89-.18zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-4.94-3.08a.58.58 0 0 0-1.12 0l-.55 1.79h-1.8c-.57 0-.8.75-.35 1.1l1.46 1.1-.56 1.79c-.17.56.44 1.03.9.68l1.46-1.1 1.46 1.1c.46.35 1.07-.12.9-.68l-.56-1.79 1.46-1.1c.46-.35.22-1.1-.35-1.1h-1.8z"
]);
const $76e5a570f6bfc30c$export$ac82f325181c7e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar28Filled', "28", [
    "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .57.07a7.5 7.5 0 0 0-2.07 7.35c-.98.36-2.2.58-3.75.58C2 23 2 17.75 2 17.75zm25 3.25a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-5.79-3.96a.74.74 0 0 0-1.42 0l-.72 2.3h-2.32c-.73 0-1.03.97-.44 1.41l1.88 1.42-.72 2.3c-.23.72.57 1.32 1.16.88l1.87-1.42 1.88 1.42c.58.44 1.38-.16 1.15-.88l-.72-2.3 1.88-1.42c.59-.44.29-1.41-.44-1.41h-2.32z"
]);
const $76e5a570f6bfc30c$export$2ab842d1da5e6811 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar28Regular', "28", [
    "M9.5 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .57.07-.67.64-1.17 1.43h-9.9a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95 1.54 0 2.67-.25 3.51-.6q.04.78.24 1.52-1.47.56-3.75.58C5.94 23 4 21.8 3 20.45a5 5 0 0 1-1-2.67v-.53m25 3.25a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-5.79-3.96a.74.74 0 0 0-1.42 0l-.72 2.3h-2.32c-.73 0-1.03.97-.44 1.41l1.88 1.42-.72 2.3c-.23.72.57 1.32 1.16.88l1.87-1.42 1.88 1.42c.58.44 1.38-.16 1.15-.88l-.72-2.3 1.88-1.42c.59-.44.29-1.41-.44-1.41h-2.32z"
]);
const $76e5a570f6bfc30c$export$59795311f76ec006 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar32Filled', "32", [
    "M10.5 14a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-9 9c0-2.71 1.2-5.14 3.1-6.8A3 3 0 0 0 16 16H5a3 3 0 0 0-3 3v.15S2 25 10.5 25q2.15-.02 3.63-.45A9 9 0 0 1 14 23m16.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-8.21-4.86-.94 2.83h-3a.75.75 0 0 0-.43 1.36l2.4 1.7-.92 2.8a.75.75 0 0 0 1.14.84L23 25.93l2.46 1.74a.75.75 0 0 0 1.14-.84l-.93-2.8 2.41-1.7a.75.75 0 0 0-.43-1.36h-3l-.94-2.83a.75.75 0 0 0-1.42 0"
]);
const $76e5a570f6bfc30c$export$53dce4cee20c2ab8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar32Regular', "32", [
    "M7 8.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10.5 3a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M21 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-7 10a3 3 0 0 1 1.1.2 9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1v.29l.09.4c.09.35.27.82.64 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.44-3.63.45c-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 19.24V19a3 3 0 0 1 3-3zm14.5 7a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-8.21-4.86-.94 2.83h-3a.75.75 0 0 0-.43 1.36l2.4 1.7-.92 2.8a.75.75 0 0 0 1.14.84L23 25.93l2.46 1.74a.75.75 0 0 0 1.14-.84l-.93-2.8 2.41-1.7a.75.75 0 0 0-.43-1.36h-3l-.94-2.83a.75.75 0 0 0-1.42 0"
]);
const $76e5a570f6bfc30c$export$eef16bfe377129d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar48Filled', "48", [
    "M16 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16m18 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12M6.75 25A3.75 3.75 0 0 0 3 28.75V30s0 9 13 9c2.6 0 4.7-.36 6.36-.94a13 13 0 0 1 4.1-12.86q-.57-.2-1.21-.2zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-9.81-6.6c-.37-1.2-2-1.2-2.38 0l-1.2 3.83h-3.86c-1.2 0-1.71 1.62-.73 2.36l3.12 2.37-1.2 3.83c-.37 1.2.95 2.2 1.94 1.45L35 39.89l3.12 2.36c.99.75 2.3-.25 1.93-1.45l-1.2-3.83 3.13-2.37c.98-.74.48-2.36-.73-2.36h-3.87z"
]);
const $76e5a570f6bfc30c$export$7fd288e0af70f948 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStar48Regular', "48", [
    "M10.5 14a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M16 6a8 8 0 1 0 0 16 8 8 0 0 0 0-16m14.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12M6.75 25A3.75 3.75 0 0 0 3 28.75v1.3l.03.42q.03.4.2 1.05c.2.85.64 1.98 1.5 3.11C6.47 36.95 9.82 39 16 39c2.59 0 4.68-.36 6.36-.95q-.3-1.23-.35-2.54c-1.45.59-3.4.99-6.01.99-5.57 0-8.1-1.82-9.29-3.38a6 6 0 0 1-1.21-3.13v-1.24c0-.69.56-1.25 1.25-1.25h17.63q.9-1.28 2.08-2.3-.57-.2-1.21-.2zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-9.81-6.6c-.37-1.2-2-1.2-2.38 0l-1.2 3.83h-3.86c-1.2 0-1.71 1.62-.73 2.36l3.12 2.37-1.2 3.83c-.37 1.2.95 2.2 1.94 1.45L35 39.89l3.12 2.36c.99.75 2.3-.25 1.93-1.45l-1.2-3.83 3.13-2.37c.98-.74.48-2.36-.73-2.36h-3.87z"
]);
const $76e5a570f6bfc30c$export$8f9b1502489765fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtract20Filled', "20", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M11 10.26a5.5 5.5 0 0 0-1.88 5.4c-.64.2-1.42.34-2.37.34-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$909b0ef9bbd012a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtract20Regular', "20", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m0 4.25a2 2 0 0 0-1.99 2.26q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.42-.01 2.37-.35A6 6 0 0 1 9 14.63q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5A3 3 0 0 1 2.5 12a1 1 0 0 1 1-1H10l.23.03q.35-.42.76-.77A2 2 0 0 0 10 10zm11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$6211e7ee012a1958 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtract24Filled', "24", [
    "M12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m8 1a3 3 0 1 1-6 0 3 3 0 0 1 6 0M2 15.25C2 14.01 3 13 4.25 13h7.5q.48 0 .89.18a6.5 6.5 0 0 0-1.36 6.2A8 8 0 0 1 8 20c-6 0-6-4.5-6-4.5zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1z"
]);
const $76e5a570f6bfc30c$export$f82ca1c932373891 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtract24Regular', "24", [
    "M8 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M14 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0M2 15.25C2 14.01 3 13 4.25 13h7.5q.48 0 .89.18-.53.6-.9 1.32H4.24a.75.75 0 0 0-.75.75v.34l.06.33c.07.28.2.65.46 1.02.5.71 1.56 1.56 3.98 1.56 1.41 0 2.36-.29 3-.67q.05.81.28 1.55c-.84.38-1.91.62-3.28.62-2.83 0-4.39-1.03-5.2-2.2a4.5 4.5 0 0 1-.8-2.22zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1z"
]);
const $76e5a570f6bfc30c$export$e6f517833ba86c55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtract32Filled', "32", [
    "M16 9.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M27 11a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-9.9 6.2a9 9 0 0 0-2.97 8.35q-1.48.44-3.63.45C2 26 2 20.15 2 20.15V20a3 3 0 0 1 3-3h11a3 3 0 0 1 1.1.2M30.5 24a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M18 23.75c0 .41.34.75.75.75h8.5a.75.75 0 0 0 0-1.5h-8.5a.75.75 0 0 0-.75.75"
]);
const $76e5a570f6bfc30c$export$c6134c752db6ed32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtract32Regular', "32", [
    "M10.5 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M5 9.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M23 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-1.9 6.2A3 3 0 0 0 16 17H5a3 3 0 0 0-3 3v.3a4 4 0 0 0 .15.9c.14.55.43 1.28 1 2C4.32 24.72 6.52 26 10.5 26q2.14-.02 3.63-.45a9 9 0 0 1-.12-2.06c-.87.3-2 .51-3.51.51-3.52 0-5.07-1.12-5.77-2.02a3.6 3.6 0 0 1-.72-1.7L4 20a1 1 0 0 1 1-1h10.52q.66-1 1.58-1.8M30.5 24a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M18 23.75c0 .41.34.75.75.75h8.5a.75.75 0 1 0 0-1.5h-8.5a.75.75 0 0 0-.75.75"
]);
const $76e5a570f6bfc30c$export$5c672886bfffe970 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap16Filled', "16", [
    "m7.5 9 .35.03-1.41 1.41a1.5 1.5 0 0 0 0 2.12l1 1q-1.1.43-2.44.44a6 6 0 0 1-3.09-.77C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zm5.65.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 1 1-.7-.7L14.29 12H8.71l1.14 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L8.71 11h5.58l-1.14-1.15a.5.5 0 0 1 0-.7M5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5"
]);
const $76e5a570f6bfc30c$export$224e15c8348f13f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap16Regular', "16", [
    "m7.5 9 .35.03-.97.97H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 13 5 13q.9-.01 1.65-.23l.78.79c-.7.28-1.55.44-2.43.44a6 6 0 0 1-3.09-.77C1.1 12.73.5 11.97.5 11c0-1.1.9-2 2-2zm5.65.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 1 1-.7-.7L14.29 12H8.71l1.14 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L8.71 11h5.58l-1.14-1.15a.5.5 0 0 1 0-.7M11.73 3.5a2.25 2.25 0 0 1 2.02 2.24v.23A2.25 2.25 0 0 1 11.5 8L11.27 8a2.25 2.25 0 0 1-2-2.01l-.02-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A2.75 2.75 0 1 1 5 8a2.75 2.75 0 0 1 0-5.5m6.5 2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5 3.5A1.75 1.75 0 1 0 5 7a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$62ccd34a26762e08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap20Filled', "20", [
    "M10 6.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m1.35 4.78-1.91 1.9a1.5 1.5 0 0 0 0 2.13l.65.65a6.3 6.3 0 0 1-3.34.79C1.5 17 1.5 13 1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 1.35.53M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-1.65 2.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 15h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 14h-5.58z"
]);
const $76e5a570f6bfc30c$export$b41d193878093c1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap20Regular', "20", [
    "M6.75 4.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 6.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m7.85 4.78A2 2 0 0 0 10 11H3.5a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93 1.48 0 2.56-.32 3.34-.79l-.65-.65-.08-.09c-.6.31-1.44.53-2.61.53-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V13a1 1 0 0 1 1-1H10a1 1 0 0 1 .64.23zM14.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m.85 5.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 15h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 14h-5.58z"
]);
const $76e5a570f6bfc30c$export$e79f30daad1957a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap24Filled', "24", [
    "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m8 1a3 3 0 1 1-6 0 3 3 0 0 1 6 0M2 16.25C2 15.01 3 14 4.25 14h7.5q.56 0 1.03.25L10.5 16.5c-.68.69-.68 1.8 0 2.48l1.19 1.18c-.87.5-2.06.83-3.7.83-6 0-6-4.5-6-4.5zm18.28-1.53a.75.75 0 0 0-1.06 1.06L20.44 17h-6.88l1.22-1.22a.75.75 0 0 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 0 0 1.06-1.06l-1.22-1.22h6.88l-1.22 1.22a.75.75 0 0 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06z"
]);
const $76e5a570f6bfc30c$export$46639bd2ae3f2edf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap24Regular', "24", [
    "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M14 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1.22 5.25Q12.3 14 11.75 14h-7.5C3.01 14 2 15 2 16.25v.28l.01.2q.02.21.1.53c.09.42.29.98.68 1.55C3.61 19.97 5.17 21 8 21c1.6 0 2.8-.33 3.7-.83l-1.13-1.12c-.61.27-1.45.45-2.57.45-2.42 0-3.49-.85-3.98-1.56a3 3 0 0 1-.52-1.43v-.26c0-.41.34-.75.75-.75h7.28zm7.5.47a.75.75 0 0 0-1.06 1.06L20.44 17h-6.88l1.22-1.22a.75.75 0 0 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 0 0 1.06-1.06l-1.22-1.22h6.88l-1.22 1.22a.75.75 0 0 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06z"
]);
const $76e5a570f6bfc30c$export$98c66caef3af4ec2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap28Filled', "28", [
    "M14 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m1.01 6.51-2.5 2.5c-.68.69-.68 1.8 0 2.48l1.9 1.89A9.5 9.5 0 0 1 9.5 24C2 24 2 18.75 2 18.75v-.5C2 17.01 3 16 4.25 16h10.5zM20 14a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-2.22 2.78a.75.75 0 0 0-1.06-1.06l-3.5 3.5c-.3.3-.3.77 0 1.06l3.5 3.5a.75.75 0 0 0 1.06-1.06l-2.22-2.22h8.88l-2.22 2.22a.75.75 0 0 0 1.06 1.06l3.5-3.5c.3-.3.3-.77 0-1.06l-3.5-3.5a.75.75 0 0 0-1.06 1.06L24.44 19h-8.88z"
]);
const $76e5a570f6bfc30c$export$71439751326b7736 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwap28Regular', "28", [
    "M5 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6m7 4a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M2 18.25C2 17.01 3 16 4.25 16h10.5l.26.01-1.48 1.49H4.25a.75.75 0 0 0-.75.75v.61l.08.41c.09.35.26.81.61 1.28.68.9 2.12 1.95 5.31 1.95a8.5 8.5 0 0 0 3.8-.73l1.1 1.1A9.5 9.5 0 0 1 9.5 24C5.94 24 4 22.8 3 21.45a5 5 0 0 1-1-2.67v-.53m15.78-1.47a.75.75 0 0 0-1.06-1.06l-3.5 3.5c-.3.3-.3.77 0 1.06l3.5 3.5a.75.75 0 0 0 1.06-1.06l-2.22-2.22h8.88l-2.22 2.22a.75.75 0 0 0 1.06 1.06l3.5-3.5c.3-.3.3-.77 0-1.06l-3.5-3.5a.75.75 0 0 0-1.06 1.06L24.44 19h-8.88z"
]);
const $76e5a570f6bfc30c$export$e2fdf32e67cfe36d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__a)",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__b)",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__c)",
            "fillOpacity": ".5",
            "d": "M9.5 10.5C9.5 9.67 8.83 9 8 9H3c-.83 0-1.5.67-1.5 1.5v.07s0 2.93 4 2.93c3.81 0 4-2.66 4-2.9v-.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__d)",
            "d": "M11.5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__e)",
            "d": "M8 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__f)",
            "d": "M16 11.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_16_color__g)",
            "d": "M13.5 8.5c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_16_color__a",
                "x1": "3.4",
                "x2": "5",
                "y1": "9.6",
                "y2": "14.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_16_color__b",
                "x1": "5.5",
                "x2": "7.75",
                "y1": "8.46",
                "y2": "15.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_16_color__d",
                "x1": "10.45",
                "x2": "12.49",
                "y1": "4.53",
                "y2": "7.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_16_color__e",
                "x1": "4.19",
                "x2": "6.74",
                "y1": "3.66",
                "y2": "7.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_16_color__f",
                "x1": "7.32",
                "x2": "13.53",
                "y1": "8.69",
                "y2": "15.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_16_color__g",
                "x1": "9",
                "x2": "13.14",
                "y1": "8",
                "y2": "14.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_sync_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.66 -4.26 13.8)scale(4.02495 4.06846)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$371d0dd75fd297e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7 2 2 0 0 1-2.39.33H11a.5.5 0 0 0 0-1zM7.26 8a5.5 5.5 0 0 0-1.08 4.9Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm6.24.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7 2 2 0 0 1 2.39-.33H12a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.67 3.76 5.5 5.5 0 0 0-3.34 0A2.24 2.24 0 0 1 11.5 2.5"
]);
const $76e5a570f6bfc30c$export$48b8f17308ef5c62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7 2 2 0 0 1-2.39.33H11a.5.5 0 0 0 0-1zM7.26 8q-.39.46-.66 1H2.5a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.54 0 1.02-.09.03.5.16 1Q5.61 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm6.24.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7 2 2 0 0 1 2.39-.33H12a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5M5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.1.75-.58 1.28A6 6 0 0 0 11.51 6a1.25 1.25 0 1 0-.02 0q-.87.01-1.66.26a2.2 2.2 0 0 1-.57-1.28l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$30c91941a3400c0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__a)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__b)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__c)",
            "fillOpacity": ".5",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__d)",
            "d": "M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__e)",
            "d": "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__f)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__g)",
            "d": "M16.5 11.5c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "11.8",
                "y2": "17.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "10.29",
                "y2": "20.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "5.66",
                "y2": "9.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "4.36",
                "y2": "9.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__f",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__g",
                "x1": "12",
                "x2": "16.14",
                "y1": "11",
                "y2": "17.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_sync_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2 4.64285 -4.64285 2 13 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$6b8cb11daab6a35e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync20Filled', "20", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m1 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $76e5a570f6bfc30c$export$19e816a16e107b6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync20Regular', "20", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $76e5a570f6bfc30c$export$b3869f28a9cbe9b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__a)",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__b)",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__c)",
            "fillOpacity": ".5",
            "d": "M4.25 13C3.01 13 2 14 2 15.25v.25S2 20 8 20s6-4.5 6-4.5v-.25c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__d)",
            "d": "M17 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__e)",
            "d": "M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__f)",
            "fillRule": "evenodd",
            "d": "M17.5 23a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_24_color__g)",
            "fillRule": "evenodd",
            "d": "M20 14.5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4zm-5 6v-.55a3.5 3.5 0 0 0 5.18-.2.5.5 0 1 0-.77-.64A2.5 2.5 0 0 1 15.5 19h1a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_24_color__a",
                "x1": "4.85",
                "x2": "7.41",
                "y1": "13.93",
                "y2": "20.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_24_color__b",
                "x1": "8",
                "x2": "11.61",
                "y1": "12.17",
                "y2": "23.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_24_color__d",
                "x1": "15.43",
                "x2": "18.48",
                "y1": "5.8",
                "y2": "10.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_24_color__e",
                "x1": "5.9",
                "x2": "9.98",
                "y1": "4.06",
                "y2": "10.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_24_color__f",
                "x1": "12.39",
                "x2": "19.98",
                "y1": "14.06",
                "y2": "21.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_24_color__g",
                "x1": "14",
                "x2": "18.44",
                "y1": "13.42",
                "y2": "21.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_sync_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(66.5 -5.65 20.28)scale(5.58857 5.51762)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$dee93d5cca96f90e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync24Filled', "24", [
    "M12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m8 1a3 3 0 1 1-6 0 3 3 0 0 1 6 0M2 15.25C2 14.01 3 13 4.25 13h7.5q.48 0 .89.18a6.5 6.5 0 0 0-1.36 6.2A8 8 0 0 1 8 20c-6 0-6-4.5-6-4.5zm10 2.25a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5M15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19"
]);
const $76e5a570f6bfc30c$export$e7802683f6b2b880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync24Regular', "24", [
    "M4 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M14 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 15.25C2 14.01 3 13 4.25 13h7.5q.48 0 .89.18-.53.6-.9 1.32H4.24a.75.75 0 0 0-.75.75v.34l.06.33c.07.28.2.65.46 1.02.5.71 1.56 1.56 3.98 1.56 1.41 0 2.36-.29 3-.67q.06.81.28 1.55c-.84.38-1.91.62-3.28.62-2.83 0-4.39-1.03-5.2-2.2a4.5 4.5 0 0 1-.8-2.27v-.28m10 2.25a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5M15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19"
]);
const $76e5a570f6bfc30c$export$75381d328a240f38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__a)",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__b)",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__c)",
            "fillOpacity": ".5",
            "d": "M2 17.25C2 16.01 3 15 4.25 15h10.5c1.24 0 2.25 1 2.25 2.25v.5S17 23 9.5 23 2 17.75 2 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__d)",
            "d": "M23.5 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__e)",
            "d": "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__f)",
            "d": "M14 20.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_28_color__g)",
            "d": "M19.35 16.42a4 4 0 0 1 4.65 1.9v-.82a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h.73a3 3 0 0 0-4.85-.87.5.5 0 0 1-.7-.7 4 4 0 0 1 1.67-1.01m2.3 8.16a4 4 0 0 1-4.65-1.9v.82a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.73a3 3 0 0 0 4.85.87.5.5 0 0 1 .7.7 4 4 0 0 1-1.67 1.01"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_28_color__a",
                "x1": "5.57",
                "x2": "8.29",
                "y1": "16.06",
                "y2": "24.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_28_color__b",
                "x1": "9.5",
                "x2": "13.33",
                "y1": "14.05",
                "y2": "27.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_28_color__d",
                "x1": "18.16",
                "x2": "21.73",
                "y1": "6.93",
                "y2": "12.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_28_color__e",
                "x1": "7.14",
                "x2": "11.73",
                "y1": "5.2",
                "y2": "12.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_28_color__f",
                "x1": "14.46",
                "x2": "23.44",
                "y1": "16.44",
                "y2": "25.76",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_28_color__g",
                "x1": "16",
                "x2": "21.23",
                "y1": "15.54",
                "y2": "25.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_sync_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(64.56 -6.58 24.64)scale(6.48585 6.79184)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$3a5f29e0e11991af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync28Filled', "28", [
    "M9.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m14-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 17.25C2 16.01 3 15 4.25 15h10.5q.3 0 .57.07a7.5 7.5 0 0 0-2.07 7.35c-.98.36-2.2.58-3.75.58C2 23 2 17.75 2 17.75zm12 3.25a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0m5.35-4.08a4 4 0 0 1 4.65 1.9v-.82a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h.73a3 3 0 0 0-4.85-.87.5.5 0 0 1-.7-.7 4 4 0 0 1 1.67-1.01m2.3 8.16a4 4 0 0 1-4.65-1.9v.82a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.73a3 3 0 0 0 4.85.87.5.5 0 0 1 .7.7 4 4 0 0 1-1.67 1.01"
]);
const $76e5a570f6bfc30c$export$b199386aa6d94138 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync28Regular', "28", [
    "M9.5 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0M20 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.25 15C3.01 15 2 16 2 17.25v.53l.02.24q.02.24.1.62c.13.5.38 1.15.87 1.81C4.01 21.8 5.94 23 9.5 23q2.28-.02 3.75-.58-.2-.75-.24-1.52c-.84.35-1.97.6-3.51.6-3.2 0-4.63-1.05-5.3-1.95a3.6 3.6 0 0 1-.7-1.79v-.51c0-.41.34-.75.75-.75h9.9q.5-.78 1.17-1.43a2 2 0 0 0-.57-.07zM14 20.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0m5.35-4.08a4 4 0 0 1 4.65 1.9v-.82a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h.73a3 3 0 0 0-4.85-.87.5.5 0 0 1-.7-.7 4 4 0 0 1 1.67-1.01m2.3 8.16a4 4 0 0 1-4.65-1.9v.82a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.73a3 3 0 0 0 4.85.87.5.5 0 0 1 .7.7 4 4 0 0 1-1.67 1.01"
]);
const $76e5a570f6bfc30c$export$3bd7d6e3c49db5da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__a)",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__b)",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__c)",
            "fillOpacity": ".5",
            "d": "M5 17a3 3 0 0 0-3 3v.15S2 26 10.5 26s8.5-5.85 8.5-5.85V20a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__d)",
            "d": "M23 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__e)",
            "d": "M10.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "fillRule": "evenodd",
            "d": "M23 31.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__f)",
            "fillRule": "evenodd",
            "d": "M23 31.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "fillRule": "evenodd",
            "d": "M24.75 24h3c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-1.5 0v1.19a4.5 4.5 0 0 0-6.8-1.47c-.43.35-.28.99.2 1.23.26.13.57.07.8-.1a3 3 0 0 1 4.4.9h-.85a.75.75 0 0 0 0 1.5m.77 3.73c.4-.27.4-.82.06-1.15-.26-.26-.66-.25-.96-.06a3 3 0 0 1-4.22-1.02h.85a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-1.19a4.5 4.5 0 0 0 6.52 1.67",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_32_color__g)",
            "fillRule": "evenodd",
            "d": "M24.75 24h3c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-1.5 0v1.19a4.5 4.5 0 0 0-6.8-1.47c-.43.35-.28.99.2 1.23.26.13.57.07.8-.1a3 3 0 0 1 4.4.9h-.85a.75.75 0 0 0 0 1.5m.77 3.73c.4-.27.4-.82.06-1.15-.26-.26-.66-.25-.96-.06a3 3 0 0 1-4.22-1.02h.85a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-1.19a4.5 4.5 0 0 0 6.52 1.67",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_32_color__a",
                "x1": "6.04",
                "x2": "9.09",
                "y1": "18.2",
                "y2": "27.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_32_color__b",
                "x1": "10.5",
                "x2": "14.78",
                "y1": "15.93",
                "y2": "31.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_32_color__d",
                "x1": "20.9",
                "x2": "24.98",
                "y1": "8.06",
                "y2": "14.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_32_color__e",
                "x1": "7.62",
                "x2": "13.22",
                "y1": "5.46",
                "y2": "14.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_32_color__f",
                "x1": "16.04",
                "x2": "26.39",
                "y1": "19.31",
                "y2": "30.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_32_color__g",
                "x1": "17.5",
                "x2": "22.57",
                "y1": "18.75",
                "y2": "29.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_sync_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(66.95 -6.51 27.13)scale(7.2969 7.6767)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$7dde9a01ca3b0b22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync32Filled', "32", [
    "M10.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M23 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-9 9c0-2.71 1.2-5.14 3.1-6.8A3 3 0 0 0 16 17H5a3 3 0 0 0-3 3v.15S2 26 10.5 26q2.15-.02 3.63-.45A9 9 0 0 1 14 24m16.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-2.75 0c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-1.5 0v1.19a4.5 4.5 0 0 0-6.8-1.47c-.43.35-.28.99.2 1.23.26.13.57.07.8-.1a3 3 0 0 1 4.4.9h-.85a.75.75 0 0 0 0 1.5zm-2.17 2.58c-.26-.26-.66-.25-.96-.06a3 3 0 0 1-4.22-1.02h.85a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-1.19a4.5 4.5 0 0 0 6.52 1.67c.4-.27.4-.82.06-1.15"
]);
const $76e5a570f6bfc30c$export$79d149d3ca8042ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync32Light', "32", [
    "M10.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M6 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M23 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-4 6a3 3 0 0 1 1.1.2q-.45.39-.83.82L16 18H5a2 2 0 0 0-2 2c0 .88.33 2.12 1.4 3.14C5.49 24.15 7.35 25 10.5 25q2.12-.02 3.52-.45.03.51.11 1-1.5.44-3.63.45c-3.34 0-5.48-.9-6.78-2.14A5.4 5.4 0 0 1 2 20a3 3 0 0 1 3-3zm14.5 7a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-2.75 0h-3a.75.75 0 0 1 0-1.5h.85a3 3 0 0 0-4.4-.9.8.8 0 0 1-.8.1c-.48-.24-.63-.88-.2-1.23a4.48 4.48 0 0 1 6.8 1.47v-1.19a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75m-2.17 2.58c.33.33.33.88-.06 1.15A4.48 4.48 0 0 1 19 26.06v1.19a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-.85a3 3 0 0 0 4.22 1.02c.3-.19.7-.2.96.06"
]);
const $76e5a570f6bfc30c$export$73a2f9ba3bdd3083 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSync32Regular', "32", [
    "M10.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M7 9.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M23 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-5 6a3 3 0 0 1 1.1.2 9 9 0 0 0-1.58 1.8H5a1 1 0 0 0-1 1v.29l.09.4c.09.35.27.82.64 1.29.7.9 2.25 2.02 5.77 2.02 1.5 0 2.64-.2 3.51-.5a9 9 0 0 0 .12 2.05q-1.5.44-3.63.45c-3.98 0-6.18-1.29-7.35-2.8A5.6 5.6 0 0 1 2 20.24V20a3 3 0 0 1 3-3zm14.5 7a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-2.75 0c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-1.5 0v1.19a4.5 4.5 0 0 0-6.8-1.47c-.43.35-.28.99.2 1.23.26.13.57.07.8-.1a3 3 0 0 1 4.4.9h-.85a.75.75 0 0 0 0 1.5zm-2.17 2.58c-.26-.26-.66-.25-.96-.06a3 3 0 0 1-4.22-1.02h.85a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-1.19a4.5 4.5 0 0 0 6.52 1.67c.4-.27.4-.82.06-1.15"
]);
const $76e5a570f6bfc30c$export$da473d6f47c0026a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__a)",
            "d": "M12.56 13A2.5 2.5 0 0 0 15 10.5V8a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v2.5a2.5 2.5 0 0 0 2.56 2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__b)",
            "fillOpacity": ".5",
            "d": "M12.56 13A2.5 2.5 0 0 0 15 10.5V8a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v2.5a2.5 2.5 0 0 0 2.56 2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__c)",
            "d": "M3.56 13A2.5 2.5 0 0 0 6 10.5V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2.5A2.5 2.5 0 0 0 3.56 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__d)",
            "fillOpacity": ".5",
            "d": "M3.56 13A2.5 2.5 0 0 0 6 10.5V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2.5A2.5 2.5 0 0 0 3.56 13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__e)",
            "d": "M5 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a3 3 0 0 1-.15.93A3 3 0 0 1 5 11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__f)",
            "d": "M5 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a3 3 0 0 1-.15.93A3 3 0 0 1 5 11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__g)",
            "d": "M12.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__h)",
            "d": "M3.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_16_color__i)",
            "d": "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__a",
                "x1": "11.19",
                "x2": "14.45",
                "y1": "7.8",
                "y2": "12.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__c",
                "x1": "2.19",
                "x2": "5.45",
                "y1": "7.8",
                "y2": "12.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__e",
                "x1": "6.43",
                "x2": "10.2",
                "y1": "7.93",
                "y2": "13.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__f",
                "x1": "8",
                "x2": "13.7",
                "y1": "6.17",
                "y2": "15.29",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__g",
                "x1": "11.71",
                "x2": "13.24",
                "y1": "3.4",
                "y2": "5.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__h",
                "x1": "2.71",
                "x2": "4.24",
                "y1": "3.4",
                "y2": "5.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_16_color__i",
                "x1": "6.95",
                "x2": "8.99",
                "y1": "2.53",
                "y2": "5.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.02365 0 0 8.1916 9.21 9.86)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.45284 0 0 -9.06537 7.62 9.86)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$7b49c938d81182d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam16Filled', "16", [
    "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m4.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a3 3 0 0 1-.15.93A3 3 0 0 1 5 11zM4 8q0-.55.27-1H2a1 1 0 0 0-1 1v2.5a2.5 2.5 0 0 0 3.44 2.32A4 4 0 0 1 4 11zm8 0v3q-.01.98-.44 1.82A2.5 2.5 0 0 0 15 10.5V8a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 12 8"
]);
const $76e5a570f6bfc30c$export$7d34170331fd6c45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam16Regular', "16", [
    "M6 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-9-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M3 4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M4.27 7A2 2 0 0 0 4 8H2v2.5a1.5 1.5 0 0 0 2.1 1.38q.11.5.34.94A2.5 2.5 0 0 1 1 10.5V8a1 1 0 0 1 1-1zm7.3 5.82A2.5 2.5 0 0 0 15 10.5V8a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 12 8h2v2.5a1.5 1.5 0 0 1-2.1 1.38q-.11.5-.34.94M6 7a1 1 0 0 0-1 1v3a3 3 0 0 0 6 0V8a1 1 0 0 0-1-1zm0 1h4v3a2 2 0 0 1-4 0z"
]);
const $76e5a570f6bfc30c$export$18b5263205fa2a51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__a)",
            "d": "M16.75 8h-2.5C13.56 8 13 8.56 13 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C18 8.56 17.44 8 16.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__b)",
            "fillOpacity": ".5",
            "d": "M16.75 8h-2.5C13.56 8 13 8.56 13 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C18 8.56 17.44 8 16.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "red",
            "fillOpacity": ".2",
            "d": "M5.75 8h-2.5C2.56 8 2 8.56 2 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C7 8.56 6.44 8 5.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__c)",
            "d": "M5.75 8h-2.5C2.56 8 2 8.56 2 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C7 8.56 6.44 8 5.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__d)",
            "fillOpacity": ".5",
            "d": "M5.75 8h-2.5C2.56 8 2 8.56 2 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C7 8.56 6.44 8 5.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__e)",
            "d": "M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__f)",
            "d": "M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__g)",
            "d": "M17.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__h)",
            "d": "M17.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__i)",
            "d": "M6.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__j)",
            "d": "M6.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__k)",
            "d": "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__a",
                "x1": "14.19",
                "x2": "18.72",
                "y1": "9.06",
                "y2": "13.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__c",
                "x1": "3.19",
                "x2": "7.72",
                "y1": "9.06",
                "y2": "13.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__e",
                "x1": "7.9",
                "x2": "13.4",
                "y1": "9.33",
                "y2": "16.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__f",
                "x1": "10",
                "x2": "18.37",
                "y1": "6.81",
                "y2": "19.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__g",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__h",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__i",
                "x1": "3.45",
                "x2": "5.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__j",
                "x1": "3.45",
                "x2": "5.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__k",
                "x1": "8.69",
                "x2": "11.24",
                "y1": "2.66",
                "y2": "6.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.02372 0 0 10.9215 12.21 11.81)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.45292 0 0 -12.0865 8.62 11.81)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$b1b2d268f012cf32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam20Filled', "20", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0zm-1 0q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zM15 14q0 1.06-.4 1.97.2.03.4.03a3 3 0 0 0 3-3V9.25C18 8.56 17.44 8 16.75 8h-2.13q.37.55.38 1.25z"
]);
const $76e5a570f6bfc30c$export$8d0ec78edff3df2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam20Regular', "20", [
    "M10 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m8-.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-10 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m.6 12H5a2 2 0 0 1-2-2V9.25c0-.14.11-.25.25-.25h1.76q.06-.55.37-1H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97 5 5 0 0 1-.3-.97m9.5.97q.2.03.4.03a3 3 0 0 0 3-3V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h1.76q.23.02.25.25V13a2 2 0 0 1-2.1 2q-.1.5-.3.97M7.25 8C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 8 0V9.25C14 8.56 13.44 8 12.75 8zM7 9.25c0-.14.11-.25.25-.25h5.5q.23.02.25.25V14a3 3 0 1 1-6 0z"
]);
const $76e5a570f6bfc30c$export$556c421ecef31304 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__a)",
            "d": "M20.25 10c.97 0 1.75.78 1.75 1.75V15a4 4 0 1 1-8 0v-3.25c0-.92.7-1.67 1.6-1.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__b)",
            "fillOpacity": ".5",
            "d": "M20.25 10c.97 0 1.75.78 1.75 1.75V15a4 4 0 1 1-8 0v-3.25c0-.92.7-1.67 1.6-1.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__c)",
            "d": "M8.25 10c.97 0 1.75.78 1.75 1.75V15a4 4 0 1 1-8 0v-3.25c0-.92.7-1.67 1.6-1.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__d)",
            "fillOpacity": ".5",
            "d": "M8.25 10c.97 0 1.75.78 1.75 1.75V15a4 4 0 1 1-8 0v-3.25c0-.92.7-1.67 1.6-1.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__e)",
            "d": "M14.75 10c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 0 1-9 0v-4.75c0-.97.79-1.75 1.75-1.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__f)",
            "d": "M14.75 10c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 0 1-9 0v-4.75c0-.97.79-1.75 1.75-1.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__g)",
            "d": "M18.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__h)",
            "d": "M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_24_color__i)",
            "d": "M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__a",
                "x1": "15.9",
                "x2": "20.7",
                "y1": "11.2",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__c",
                "x1": "3.9",
                "x2": "8.7",
                "y1": "11.2",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__e",
                "x1": "9.64",
                "x2": "15.66",
                "y1": "11.46",
                "y2": "19.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__f",
                "x1": "12",
                "x2": "21.13",
                "y1": "8.69",
                "y2": "22.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__g",
                "x1": "17.19",
                "x2": "19.74",
                "y1": "4.66",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__h",
                "x1": "4.19",
                "x2": "6.74",
                "y1": "4.66",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_24_color__i",
                "x1": "10.43",
                "x2": "13.48",
                "y1": "3.8",
                "y2": "8.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6.43822 0 0 12.2867 12.74 14.29)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-7.12497 0 0 -13.5973 12.6 14.29)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$16f45fcff8a02346 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam24Filled', "24", [
    "M14.75 10c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 0 1-9 0v-4.75c0-.97.79-1.75 1.75-1.75zm-7.62 0q-.54.64-.62 1.53v4.97q0 1.29.52 2.36Q6.55 19 6 19a4 4 0 0 1-4-4v-3.25c0-.92.7-1.67 1.6-1.74l.15-.01zm9.74 0h3.38c.97 0 1.75.78 1.75 1.75V15a4 4 0 0 1-5.03 3.87q.45-.95.53-2.06v-5.06q-.02-1.02-.63-1.75M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m6.5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $76e5a570f6bfc30c$export$ca3aa89ed8647550 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam24Regular', "24", [
    "M14.75 10c.97 0 1.75.78 1.75 1.75v4.75a4.5 4.5 0 0 1-9 0v-4.75c0-.97.79-1.75 1.75-1.75zm0 1.5h-5.5a.25.25 0 0 0-.25.25v4.75a3 3 0 0 0 6 0v-4.75a.25.25 0 0 0-.25-.25m-11-1.5h3.38q-.53.63-.62 1.5H3.75a.25.25 0 0 0-.25.25V15a2.5 2.5 0 0 0 3.08 2.43q.13.76.45 1.43Q6.55 19 6 19a4 4 0 0 1-4-4v-3.25c0-.97.78-1.75 1.75-1.75m13.12 0h3.38c.97 0 1.75.78 1.75 1.75V15a4 4 0 0 1-5.03 3.87q.32-.68.46-1.44.27.07.57.07a2.5 2.5 0 0 0 2.5-2.5v-3.25a.25.25 0 0 0-.25-.25h-2.76a2.7 2.7 0 0 0-.62-1.5M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m6.5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m6.5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6.5 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-13 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $76e5a570f6bfc30c$export$8ea50a84fdba31c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__a)",
            "d": "M21.5 23a4.5 4.5 0 0 1-4.5-4.5v-5.75c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v5.75a4.5 4.5 0 0 1-4.5 4.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__b)",
            "fillOpacity": ".5",
            "d": "M21.5 23a4.5 4.5 0 0 1-4.5-4.5v-5.75c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v5.75a4.5 4.5 0 0 1-4.5 4.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__c)",
            "d": "M6.5 23A4.5 4.5 0 0 1 2 18.5v-5.75c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v5.75A4.5 4.5 0 0 1 6.5 23"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__d)",
            "fillOpacity": ".5",
            "d": "M6.5 23A4.5 4.5 0 0 1 2 18.5v-5.75c0-.97.78-1.75 1.75-1.75h5.5c.97 0 1.75.78 1.75 1.75v5.75A4.5 4.5 0 0 1 6.5 23"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__e)",
            "d": "M17.75 11c.97 0 1.75.78 1.75 1.75v6.75a5.5 5.5 0 0 1-11 0v-6.75c0-.97.79-1.75 1.75-1.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__f)",
            "d": "M17.75 11c.97 0 1.75.78 1.75 1.75v6.75a5.5 5.5 0 0 1-11 0v-6.75c0-.97.79-1.75 1.75-1.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__g)",
            "d": "M22 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__h)",
            "d": "M6 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_28_color__i)",
            "d": "M14 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__a",
                "x1": "19.14",
                "x2": "25.83",
                "y1": "12.6",
                "y2": "20.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__c",
                "x1": "4.14",
                "x2": "10.83",
                "y1": "12.6",
                "y2": "20.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__e",
                "x1": "11.12",
                "x2": "18.85",
                "y1": "12.86",
                "y2": "22.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__f",
                "x1": "14",
                "x2": "25.8",
                "y1": "9.33",
                "y2": "26.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__g",
                "x1": "20.43",
                "x2": "23.49",
                "y1": "4.8",
                "y2": "9.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__h",
                "x1": "4.42",
                "x2": "7.48",
                "y1": "4.8",
                "y2": "9.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_28_color__i",
                "x1": "12.16",
                "x2": "15.73",
                "y1": "3.93",
                "y2": "9.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7.24251 0 0 16.3823 15.59 16.72)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_28_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-8.01505 0 0 -18.1297 13.92 16.72)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$4ba1c98ea4a6cd2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam28Filled', "28", [
    "M17.75 11c.97 0 1.75.78 1.75 1.75v6.75a5.5 5.5 0 0 1-11 0v-6.75c0-.97.79-1.75 1.75-1.75zm-14 0h4.38q-.54.64-.62 1.53v6.97c0 1.13.28 2.2.8 3.13A4.5 4.5 0 0 1 2 18.5v-5.75c0-.97.78-1.75 1.75-1.75m16.12 0h4.38c.97 0 1.75.78 1.75 1.75v5.75a4.5 4.5 0 0 1-6.3 4.13l.06-.1q.66-1.24.74-2.7v-7.08q-.02-1.02-.63-1.75M14 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M6 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
]);
const $76e5a570f6bfc30c$export$eb09411c46c0723c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam28Regular', "28", [
    "M17.25 11c1.25 0 2.25 1 2.25 2.25v6.25a5.5 5.5 0 0 1-11 0v-6.25c0-1.24 1-2.25 2.25-2.25zm0 1.5h-6.5a.75.75 0 0 0-.75.75v6.25a4 4 0 0 0 8 0v-6.25a.75.75 0 0 0-.75-.75m-13-1.5h4.16q-.61.63-.82 1.5H4.25a.75.75 0 0 0-.75.75v5.25a3 3 0 0 0 4.24 2.73q.2.75.56 1.4A4.5 4.5 0 0 1 2 18.5v-5.25C2 12.01 3 11 4.25 11m19.5 0c1.24 0 2.25 1 2.25 2.25v5.25a4.5 4.5 0 0 1-6.3 4.13l.06-.1q.32-.61.5-1.3.58.27 1.24.27a3 3 0 0 0 3-3v-5.25a.75.75 0 0 0-.75-.75h-3.33a3 3 0 0 0-.82-1.5zM14 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M6 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6m8 .5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-16 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $76e5a570f6bfc30c$export$52f24572c90d4518 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__a)",
            "d": "M24.62 27H25a5 5 0 0 0 5-5v-6.5a2.5 2.5 0 0 0-2.5-2.5h-5.38a2.5 2.5 0 0 0-2.5 2.5V22a5 5 0 0 0 5 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__b)",
            "fillOpacity": ".5",
            "d": "M24.62 27H25a5 5 0 0 0 5-5v-6.5a2.5 2.5 0 0 0-2.5-2.5h-5.38a2.5 2.5 0 0 0-2.5 2.5V22a5 5 0 0 0 5 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__c)",
            "d": "M7 27h.38a5 5 0 0 0 5-5v-6.5a2.5 2.5 0 0 0-2.5-2.5H4.5A2.5 2.5 0 0 0 2 15.5V22a5 5 0 0 0 5 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__d)",
            "fillOpacity": ".5",
            "d": "M7 27h.38a5 5 0 0 0 5-5v-6.5a2.5 2.5 0 0 0-2.5-2.5H4.5A2.5 2.5 0 0 0 2 15.5V22a5 5 0 0 0 5 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__e)",
            "d": "M12.5 13a2.5 2.5 0 0 0-2.5 2.5V23a6 6 0 0 0 12 0v-7.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__f)",
            "d": "M12.5 13a2.5 2.5 0 0 0-2.5 2.5V23a6 6 0 0 0 12 0v-7.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__g)",
            "d": "M29 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__h)",
            "d": "M10 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_32_color__i)",
            "d": "M16 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__a",
                "x1": "22.09",
                "x2": "29.91",
                "y1": "14.86",
                "y2": "24.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__c",
                "x1": "4.47",
                "x2": "12.29",
                "y1": "14.86",
                "y2": "24.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__e",
                "x1": "12.85",
                "x2": "21.77",
                "y1": "15.13",
                "y2": "25.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__f",
                "x1": "16",
                "x2": "29.7",
                "y1": "11.1",
                "y2": "30.3",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__g",
                "x1": "23.66",
                "x2": "27.23",
                "y1": "4.93",
                "y2": "10.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__h",
                "x1": "4.66",
                "x2": "8.23",
                "y1": "4.93",
                "y2": "10.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_32_color__i",
                "x1": "13.9",
                "x2": "17.98",
                "y1": "4.06",
                "y2": "10.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8.3508 0 0 19.1127 18 19.67)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-9.24155 0 0 -21.1514 15.74 19.67)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$1ea8d1599a9083bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam32Filled', "32", [
    "M16 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-6-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m19 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M9.38 13a4 4 0 0 0-.88 2.5V23q.02 1.86.83 3.43-1.06.55-2.33.57a5 5 0 0 1-5-5v-6.5A2.5 2.5 0 0 1 4.5 13zm13.3 13.43c.52-1.03.82-2.2.82-3.43v-7.5c0-.95-.33-1.82-.88-2.5h4.88a2.5 2.5 0 0 1 2.5 2.5V22a5 5 0 0 1-7.33 4.43M12.5 13a2.5 2.5 0 0 0-2.5 2.5V23a6 6 0 0 0 12 0v-7.5a2.5 2.5 0 0 0-2.5-2.5z"
]);
const $76e5a570f6bfc30c$export$3fbde8312f970412 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam32Regular', "32", [
    "M16 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0m13.5-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M22 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m-17 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M6.5 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m2.15 20.5Q7.93 25 7 25a3 3 0 0 1-3-3v-6.5c0-.28.22-.5.5-.5h4.03q.16-1.14.85-2H4.5A2.5 2.5 0 0 0 2 15.5V22a5 5 0 0 0 7.33 4.43q-.47-.9-.68-1.92m14.02 1.93q1.06.55 2.33.57a5 5 0 0 0 5-5v-6.5a2.5 2.5 0 0 0-2.5-2.5h-4.88q.7.86.85 2h4.03c.28 0 .5.22.5.5V22a3 3 0 0 1-4.65 2.5 8 8 0 0 1-.68 1.93M12.5 13a2.5 2.5 0 0 0-2.5 2.5V23a6 6 0 0 0 12 0v-7.5a2.5 2.5 0 0 0-2.5-2.5zm-.5 2.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5V23a4 4 0 0 1-8 0z"
]);
const $76e5a570f6bfc30c$export$d47cf3ac7aa24716 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__a)",
            "d": "M37.22 40A6.96 6.96 0 0 0 44 33v-9.75A4.26 4.26 0 0 0 39.75 19h-5.5q-.44 0-.84.08c-1.95.4-3.41 2.11-3.41 4.17V33a6.96 6.96 0 0 0 6.98 7h.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__b)",
            "fillOpacity": ".5",
            "d": "M37.22 40A6.96 6.96 0 0 0 44 33v-9.75A4.26 4.26 0 0 0 39.75 19h-5.5q-.44 0-.84.08c-1.95.4-3.41 2.11-3.41 4.17V33a6.96 6.96 0 0 0 6.98 7h.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__c)",
            "d": "M11.22 40A6.96 6.96 0 0 0 18 33v-9.75A4.26 4.26 0 0 0 13.75 19h-5.5q-.44 0-.84.08C5.46 19.48 4 21.2 4 23.25V33a6.96 6.96 0 0 0 6.98 7h.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__d)",
            "fillOpacity": ".5",
            "d": "M11.22 40A6.96 6.96 0 0 0 18 33v-9.75A4.26 4.26 0 0 0 13.75 19h-5.5q-.44 0-.84.08C5.46 19.48 4 21.2 4 23.25V33a6.96 6.96 0 0 0 6.98 7h.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__e)",
            "d": "M19.25 19A4.25 4.25 0 0 0 15 23.25V34a9 9 0 1 0 18 0V23.25C33 20.9 31.1 19 28.75 19z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__f)",
            "d": "M19.25 19A4.25 4.25 0 0 0 15 23.25V34a9 9 0 1 0 18 0V23.25C33 20.9 31.1 19 28.75 19z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__g)",
            "d": "M37 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__h)",
            "d": "M11 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_48_color__i)",
            "d": "M18 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__a",
                "x1": "33.33",
                "x2": "45.2",
                "y1": "21.79",
                "y2": "34.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__c",
                "x1": "7.33",
                "x2": "19.2",
                "y1": "21.79",
                "y2": "34.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__e",
                "x1": "19.28",
                "x2": "32.66",
                "y1": "22.19",
                "y2": "38.21",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__f",
                "x1": "24",
                "x2": "44.56",
                "y1": "16.14",
                "y2": "44.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__g",
                "x1": "34.38",
                "x2": "39.47",
                "y1": "8.33",
                "y2": "16.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__h",
                "x1": "8.38",
                "x2": "13.47",
                "y1": "8.33",
                "y2": "16.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_48_color__i",
                "x1": "20.85",
                "x2": "26.97",
                "y1": "6.6",
                "y2": "16.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8.7001 -.00781 .01988 22.1392 27.8 29)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_48_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(180.04 11.27 14.5)scale(11.0348 28.0801)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$5525025c55640d06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam48Filled', "48", [
    "M18 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0m19-4a5 5 0 1 0 0 10 5 5 0 0 0 0-10M11 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10m8.25 12A4.25 4.25 0 0 0 15 23.25V34a9 9 0 1 0 18 0V23.25C33 20.9 31.1 19 28.75 19zM13 23.25c0-1.6.6-3.06 1.6-4.17a4 4 0 0 0-.85-.08h-5.5A4.25 4.25 0 0 0 4 23.25V33a7 7 0 0 0 10.3 6.18c-.83-1.54-1.3-3.3-1.3-5.18zM35 34c0 1.87-.47 3.64-1.3 5.18q1.5.8 3.3.82a7 7 0 0 0 7-7v-9.75C44 20.9 42.1 19 39.75 19h-5.5q-.44 0-.84.08A6.2 6.2 0 0 1 35 23.25z"
]);
const $76e5a570f6bfc30c$export$a9b5dc2f1f81cc3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeam48Regular', "48", [
    "M24 7.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M18 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0m19-1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M32 12a5 5 0 1 1 10 0 5 5 0 0 1-10 0M8.5 12a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M11 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10m4 16.25C15 20.9 16.9 19 19.25 19h9.5C31.1 19 33 20.9 33 23.25V34a9 9 0 1 1-18 0zm9 17.25a6.5 6.5 0 0 0 6.5-6.5V23.25c0-.97-.78-1.75-1.75-1.75h-9.5c-.97 0-1.75.78-1.75 1.75V34a6.5 6.5 0 0 0 6.5 6.5m-13-3q1.32-.02 2.37-.67.33 1.23.92 2.35-1.49.8-3.29.82a7 7 0 0 1-7-7v-9.75C4 20.9 5.9 19 8.25 19h5.5q.43 0 .84.08a6 6 0 0 0-1.34 2.42h-5c-.97 0-1.75.78-1.75 1.75V33a4.5 4.5 0 0 0 4.5 4.5M37 40q-1.8-.02-3.3-.82.6-1.12.93-2.35 1.06.65 2.37.67a4.5 4.5 0 0 0 4.5-4.5v-9.75c0-.97-.78-1.75-1.75-1.75h-5a6 6 0 0 0-1.34-2.42q.4-.08.84-.08h5.5C42.1 19 44 20.9 44 23.25V33a7 7 0 0 1-7 7"
]);
const $76e5a570f6bfc30c$export$287c92c1829644d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamAdd20Filled', "20", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.61 0 1.12.44 1.23 1.02A5.5 5.5 0 0 0 10.25 18L10 18a4 4 0 0 1-4-4zm8.99-.23c1.14.1 2.18.55 3.01 1.24V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.46.37 1.02M5 9.25q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zm14 5.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$53dc0400b8fcf524 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamAdd20Regular', "20", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-11 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 15h.1q.1.5.3.97-.2.03-.4.03a3 3 0 0 1-3-3V9.25C2 8.56 2.56 8 3.25 8h2.13q-.3.45-.37 1H3.25a.25.25 0 0 0-.25.25V13c0 1.1.9 2 2 2m8.98-6c-.12-.57-.63-1-1.23-1h-5.5C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 4.25 4 6 6 0 0 1-.66-1.03A3 3 0 0 1 7 14V9.25c0-.14.11-.25.25-.25zm1 0h1.77q.23.02.25.25v.35q.54.27 1 .66V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1m-.48 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 2c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$dd0034150af550f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6q.09.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zm-3.25-4c.84 0 1.57.45 1.96 1.13A6.5 6.5 0 0 0 12.02 21H12a4.5 4.5 0 0 1-4.5-4.5v-4.25c0-1.24 1-2.25 2.25-2.25zm-6.84 0a3.2 3.2 0 0 0-.9 2.03v4.47q0 1.29.52 2.36Q6.55 19 6 19a4 4 0 0 1-4-4v-2.75c0-1.2.93-2.17 2.1-2.24l.15-.01zm12.34 0c1.24 0 2.25 1 2.25 2.25v.56A6.5 6.5 0 0 0 17.5 11h-.24a3 3 0 0 0-.66-1zM18.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $76e5a570f6bfc30c$export$f2e09b3fe50d9efc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6q.09.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zm-3.25-4c.84 0 1.57.45 1.96 1.13q-.81.16-1.52.5a1 1 0 0 0-.44-.13h-4.5a.75.75 0 0 0-.75.75v4.25a3 3 0 0 0 2.29 2.91q.26.85.73 1.6L12 21a4.5 4.5 0 0 1-4.5-4.5v-4.25c0-1.24 1-2.25 2.25-2.25zm-6.84 0q-.61.63-.82 1.5H4.25a.75.75 0 0 0-.75.75V15a2.5 2.5 0 0 0 3.08 2.43q.13.76.45 1.43Q6.55 19 6 19a4 4 0 0 1-4-4v-2.75c0-1.2.93-2.17 2.1-2.24l.15-.01zm12.34 0c1.24 0 2.25 1 2.25 2.25v.56A6.5 6.5 0 0 0 17.5 11h-.25a3 3 0 0 0-.65-1zM18.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m13 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-6.5-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-6.5 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $76e5a570f6bfc30c$export$a774fa5deddd5e72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete16Filled', "16", [
    "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m4.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a1 1 0 0 1 1-1h2.34a5.5 5.5 0 0 0-1.95 6.53A3 3 0 0 1 5 11zM4 8q0-.55.27-1H2a1 1 0 0 0-1 1v2.5a2.5 2.5 0 0 0 3.44 2.32A4 4 0 0 1 4 11zm12 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $76e5a570f6bfc30c$export$dfd2a9fd833548ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete16Regular', "16", [
    "M6 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-9-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M3 4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M4.27 7A2 2 0 0 0 4 8H2v2.5a1.5 1.5 0 0 0 2.1 1.38q.11.5.34.94A2.5 2.5 0 0 1 1 10.5V8a1 1 0 0 1 1-1zM6 7a1 1 0 0 0-1 1v3a3 3 0 0 0 1.39 2.53A5.5 5.5 0 0 1 6 11V8h1.26q.46-.58 1.08-1zm10 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $76e5a570f6bfc30c$export$706da6b5ef58b77d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete20Filled', "20", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.61 0 1.12.44 1.23 1.02A5.5 5.5 0 0 0 10.25 18L10 18a4 4 0 0 1-4-4zm8.99-.23c1.14.1 2.18.55 3.01 1.24V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.46.37 1.02M5 9.25q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zm14 5.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $76e5a570f6bfc30c$export$e556bc7e287936f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete20Regular', "20", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-11 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 15h.1q.1.5.3.97-.2.03-.4.03a3 3 0 0 1-3-3V9.25C2 8.56 2.56 8 3.25 8h2.13q-.3.45-.37 1H3.25a.25.25 0 0 0-.25.25V13c0 1.1.9 2 2 2m8.98-6c-.12-.57-.63-1-1.23-1h-5.5C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 4.25 4 6 6 0 0 1-.66-1.03A3 3 0 0 1 7 14V9.25c0-.14.11-.25.25-.25zM18 10.26V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h1.76q.23.02.25.25v.35q.54.27 1 .66M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-5.65-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$7e44e5ff94888a5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3.25-2c.84 0 1.57.45 1.96 1.13A6.5 6.5 0 0 0 12.02 21H12a4.5 4.5 0 0 1-4.5-4.5v-4.25c0-1.24 1-2.25 2.25-2.25zm.84 4.97-.07.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05zM7.41 10a3.2 3.2 0 0 0-.9 2.03v4.47q0 1.29.52 2.36Q6.55 19 6 19a4 4 0 0 1-4-4v-2.75c0-1.2.93-2.17 2.1-2.24l.15-.01zm12.34 0c1.24 0 2.25 1 2.25 2.25v.56A6.5 6.5 0 0 0 17.5 11h-.24a3 3 0 0 0-.66-1zM18.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $76e5a570f6bfc30c$export$fbf9317ac48ff81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3.25-2c.84 0 1.57.45 1.96 1.13q-.81.16-1.52.5a1 1 0 0 0-.44-.13h-4.5a.75.75 0 0 0-.75.75v4.25a3 3 0 0 0 2.29 2.91q.26.85.73 1.6L12 21a4.5 4.5 0 0 1-4.5-4.5v-4.25c0-1.24 1-2.25 2.25-2.25zm.84 4.97-.07.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05zM7.41 10q-.61.63-.82 1.5H4.25a.75.75 0 0 0-.75.75V15a2.5 2.5 0 0 0 3.08 2.43q.13.76.45 1.43Q6.55 19 6 19a4 4 0 0 1-4-4v-2.75c0-1.2.93-2.17 2.1-2.24l.15-.01zm12.34 0c1.24 0 2.25 1 2.25 2.25v.56A6.5 6.5 0 0 0 17.5 11h-.25a3 3 0 0 0-.65-1zM18.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m13 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-6.5-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-6.5 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $76e5a570f6bfc30c$export$96172b76e5c6cadc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete28Filled', "28", [
    "M17.75 11c.97 0 1.75.78 1.75 1.75v.32a7.5 7.5 0 0 0-5.02 11.9q-.23.03-.48.03a5.5 5.5 0 0 1-5.5-5.5v-6.75c0-.97.79-1.75 1.75-1.75zm2.75 2c2.18 0 4.13.93 5.5 2.4v-2.65c0-.97-.78-1.75-1.75-1.75h-4.38q.61.73.63 1.75zM3.75 11h4.38q-.54.64-.62 1.53v6.97c0 1.13.28 2.2.8 3.13A4.5 4.5 0 0 1 2 18.5v-5.75c0-.97.78-1.75 1.75-1.75M14 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M6 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6m21 16.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6.5-.7-2.65-2.65a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7z"
]);
const $76e5a570f6bfc30c$export$cf08298ea79317f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete28Regular', "28", [
    "M17.25 11c1.18 0 2.15.91 2.25 2.07q-.78.1-1.5.36v-.18a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75v6.25a4 4 0 0 0 3.62 3.98q.35.81.86 1.5L14 25a5.5 5.5 0 0 1-5.5-5.5v-6.25c0-1.24 1-2.25 2.25-2.25zm7.25 3.15q.83.53 1.5 1.25v-2.15c0-1.24-1-2.25-2.25-2.25H19.6q.6.63.82 1.5h3.33c.41 0 .75.34.75.75zM4.25 11h4.16q-.61.63-.82 1.5H4.25a.75.75 0 0 0-.75.75v5.25a3 3 0 0 0 4.24 2.73q.2.75.56 1.4A4.5 4.5 0 0 1 2 18.5v-5.25C2 12.01 3 11 4.25 11M14 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M6 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6m8 .5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-16 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m21 15a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6.5-.7-2.65-2.65a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7z"
]);
const $76e5a570f6bfc30c$export$8a5c7f9f7d9aea10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete32Filled', "32", [
    "M16 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-6-3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m19 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M9.38 13a4 4 0 0 0-.88 2.5V23q.02 1.86.83 3.43-1.06.55-2.33.57a5 5 0 0 1-5-5v-6.5A2.5 2.5 0 0 1 4.5 13zM14 23a9 9 0 0 1 7.58-8.89A2.5 2.5 0 0 0 19.5 13h-7a2.5 2.5 0 0 0-2.5 2.5V23a6 6 0 0 0 6.29 6A9 9 0 0 1 14 23m8.62-10a4 4 0 0 1 .59 1A9 9 0 0 1 30 17.34V15.5a2.5 2.5 0 0 0-2.5-2.5zm.38 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m2.72 3.72L23 21.94l-2.72-2.72a.75.75 0 1 0-1.06 1.06L21.94 23l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23 24.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L24.06 23l2.72-2.72a.75.75 0 1 0-1.06-1.06"
]);
const $76e5a570f6bfc30c$export$3ffe1ac312abfc0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDelete32Regular', "32", [
    "M16 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11.5-3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M24 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-21 0a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M6.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7 25q.93-.01 1.65-.5.21 1.03.68 1.93-1.06.55-2.33.57a5 5 0 0 1-5-5v-6.5A2.5 2.5 0 0 1 4.5 13h4.88a4 4 0 0 0-.85 2H4.5a.5.5 0 0 0-.5.5V22a3 3 0 0 0 3 3m16.21-11A9 9 0 0 1 30 17.34V15.5a2.5 2.5 0 0 0-2.5-2.5h-4.88a4 4 0 0 1 .59 1m-3.71-1c.87 0 1.63.44 2.08 1.11q-1.45.24-2.7.89H12.5a.5.5 0 0 0-.5.5V23a4 4 0 0 0 2.86 3.83q.56 1.2 1.43 2.16A6 6 0 0 1 10 23v-7.5a2.5 2.5 0 0 1 2.5-2.5zm3.5 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m2.72 3.72L23 21.94l-2.72-2.72a.75.75 0 1 0-1.06 1.06L21.94 23l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23 24.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L24.06 23l2.72-2.72a.75.75 0 1 0-1.06-1.06"
]);
const $76e5a570f6bfc30c$export$d11b8afe8fc5d908 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamToolbox20Filled', "20", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.6 0 1.1.43 1.22 1h-.47a2.5 2.5 0 0 0-2.46 2.04A2.5 2.5 0 0 0 9 13.5v4q0 .2.03.38A4 4 0 0 1 6 14zm11.96 1.8H18v-1.8C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h.51a2.5 2.5 0 0 1 2.46 2.04M5 9.24q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $76e5a570f6bfc30c$export$83073fc399809e0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamToolbox20Regular', "20", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-11 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 15h.1q.1.5.3.97-.2.03-.4.03a3 3 0 0 1-3-3V9.25C2 8.56 2.56 8 3.25 8h2.13q-.3.45-.37 1H3.25a.25.25 0 0 0-.25.25V13c0 1.1.9 2 2 2m12-5.5c.5.37.84.91.96 1.54l.04.01v-1.8C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h1.76q.23.02.25.25zm-1.5.5h-2c-.83 0-1.5.67-1.5 1.5v.5h-.5c-.83 0-1.5.67-1.5 1.5V15h2v-.5a.5.5 0 0 1 1 0v.5h3v-.5a.5.5 0 0 1 1 0v.5h2v-1.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5M7.25 9a.25.25 0 0 0-.25.25V14a3 3 0 0 0 2 2.83v.67q0 .2.03.38A4 4 0 0 1 6 14V9.25C6 8.56 6.56 8 7.25 8h5.5c.6 0 1.1.43 1.22 1zM13 12v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v.5zm4 4v.5a.5.5 0 0 1-1 0V16h-3v.5a.5.5 0 0 1-1 0V16h-2v1.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V16z"
]);
const $76e5a570f6bfc30c$export$de851be768236b84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamToolbox24Filled', "24", [
    "M14.75 10c.8 0 1.47.53 1.68 1.25h-.68A2.75 2.75 0 0 0 13 14v.05a2.5 2.5 0 0 0-2 2.45v4.39a4.5 4.5 0 0 1-3.5-4.4v-4.74c0-.97.79-1.75 1.75-1.75zm4.5 1.25A2.75 2.75 0 0 1 22 13.99v-2.24c0-.97-.78-1.75-1.75-1.75h-3.38q.45.53.59 1.25zM7.13 10q-.54.64-.62 1.53v4.97q0 1.29.52 2.36Q6.55 19 6 19a4 4 0 0 1-4-4v-3.25c0-.92.7-1.67 1.6-1.74l.15-.01zM12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m6.5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5"
]);
const $76e5a570f6bfc30c$export$233b62787978c7bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamToolbox24Regular', "24", [
    "M14.75 10c.8 0 1.47.53 1.68 1.25h-.68q-.61 0-1.15.25H9.25a.25.25 0 0 0-.25.25v4.75a3 3 0 0 0 2 2.83v1.56a4.5 4.5 0 0 1-3.5-4.4v-4.74c0-.97.79-1.75 1.75-1.75zm4.5 1.25A2.75 2.75 0 0 1 22 13.99v-2.24c0-.97-.78-1.75-1.75-1.75h-3.38q.45.53.59 1.25zM3.75 10h3.38q-.53.63-.62 1.5H3.75a.25.25 0 0 0-.25.25V15a2.5 2.5 0 0 0 3.08 2.43q.13.76.45 1.43Q6.55 19 6 19a4 4 0 0 1-4-4v-3.25c0-.97.78-1.75 1.75-1.75M12 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6.5-.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5"
]);
const $76e5a570f6bfc30c$export$2ff62a4beddd4446 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleToolbox16Filled', "16", [
    "M9 13.5a.5.5 0 0 0 1 0V13h3v.5a.5.5 0 0 0 1 0V13h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 7 14.5V13h2zM7.5 8a2 2 0 0 1 .47.06A2.5 2.5 0 0 0 6 10.5v2.43q-.49.06-1 .07a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm5-1c.83 0 1.5.67 1.5 1.5V9h.5c.83 0 1.5.67 1.5 1.5V12h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5H7v-1.5C7 9.67 7.67 9 8.5 9H9v-.5c0-.83.67-1.5 1.5-1.5zm-2 1a.5.5 0 0 0-.5.5V9h3v-.5a.5.5 0 0 0-.5-.5zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.5 1a2.25 2.25 0 0 1 1.78 3.63A3 3 0 0 0 12.5 6h-2q-.4 0-.78.13-.46-.6-.47-1.38c0-1.25 1-2.25 2.25-2.25"
]);
const $76e5a570f6bfc30c$export$8916626f12cdcafa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleToolbox16Regular', "16", [
    "M9 13.5a.5.5 0 0 0 1 0V13h3v.5a.5.5 0 0 0 1 0V13h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 7 14.5V13h2zM7.5 8a2 2 0 0 1 .47.06A2.5 2.5 0 0 0 6.5 9h-4a1 1 0 0 0-1 1c0 .5.3 1 .93 1.38S3.97 12 5 12q.53 0 1-.08v1Q5.51 13 5 13a6 6 0 0 1-3.09-.77C1.1 11.73.5 10.97.5 10c0-1.1.9-2 2-2zm5-1c.83 0 1.5.67 1.5 1.5V9h.5c.83 0 1.5.67 1.5 1.5V12h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5H7v-1.5C7 9.67 7.67 9 8.5 9H9v-.5c0-.83.67-1.5 1.5-1.5zm-2 1a.5.5 0 0 0-.5.5V9h3v-.5a.5.5 0 0 0-.5-.5zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.73 1a2.25 2.25 0 0 1 2.02 2.25v.23q-.09.65-.47 1.15A3 3 0 0 0 12.5 6h-.98a1.25 1.25 0 1 0-.04 0h-.98q-.4 0-.78.13a2.2 2.2 0 0 1-.46-1.15l-.01-.23c0-1.24 1-2.25 2.25-2.25zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5"
]);
const $76e5a570f6bfc30c$export$356b7f9ac2ac1212 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleToolbox20Filled', "20", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-3.26 1.43q-.14.3-.2.61A2.5 2.5 0 0 0 9 13.5v2.2q-.92.29-2.25.3C1.5 16 1.5 12 1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1.24.43M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$bd59f0a323c40b6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleToolbox20Regular', "20", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M14.5 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m-3.26 1.43A2 2 0 0 0 10 10H3.5a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.33 0 2.25-.3v-1.07q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10a1 1 0 0 1 .57.18q.22-.08.47-.14.05-.32.2-.6M14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$b393346950205a0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone12Filled', "12", [
    "M3 2.5C3 1.67 3.67 1 4.5 1h3C8.33 1 9 1.67 9 2.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 3 9.5zM5.5 8a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$ac039fcf7ef98e20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone12Regular', "12", [
    "M5.5 8a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-1-7C3.67 1 3 1.67 3 2.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C9 1.67 8.33 1 7.5 1zM4 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$4509563239a901cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_16_color__a)",
            "d": "M4 2.75C4 1.78 4.78 1 5.75 1h4.5c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 15 4 14.22 4 13.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_16_color__b)",
            "d": "M7 12a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.93 1.55 3.49)scale(17.632 32.6805)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(40.86 -13.18 14.13)scale(5.24774 6.16903)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$59c82d0083994623 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone16Filled', "16", [
    "M4 2.75C4 1.78 4.78 1 5.75 1h4.5c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 15 4 14.22 4 13.25zM7 12a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$7f95d8df66e84f96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone16Regular', "16", [
    "M7 12a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM5.75 1C4.78 1 4 1.78 4 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75V2.75C12 1.78 11.22 1 10.25 1zM5 2.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v10.5c0 .41-.34.75-.75.75h-4.5a.75.75 0 0 1-.75-.75z"
]);
const $76e5a570f6bfc30c$export$9fabdb08c5df25b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_20_color__a)",
            "d": "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_20_color__b)",
            "d": "M9 14h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.84 1.25 4.92)scale(20.5294 40.0975)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(40.86 -14.86 17.81)scale(5.24774 6.16903)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$7de0110e2782fdb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone20Filled', "20", [
    "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5zM9 14h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$c634aa2e57ed7c01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone20Regular', "20", [
    "M9 14a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $76e5a570f6bfc30c$export$1f127684edcbab49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_24_color__a)",
            "d": "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_24_color__b)",
            "d": "M13.25 18h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.8 1.87 5.6)scale(25.4368 48.5425)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.29166 5.15 -6.11557 6.2838 9.38 18.1)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$3c669c3cd1227104 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-2.5 16h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$9edbfaa75dd00032 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75m-2.5 14a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$626cb87b23bf741a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_28_color__a)",
            "d": "M7 4.75A2.75 2.75 0 0 1 9.75 2h8.5A2.75 2.75 0 0 1 21 4.75v18.5A2.75 2.75 0 0 1 18.25 26h-8.5A2.75 2.75 0 0 1 7 23.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_28_color__b)",
            "d": "M12.25 21a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_28_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(63.46 2.49 6.29)scale(30.3487 56.9596)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.9 -25.36 26.16)scale(8.38303 9.65446)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$659615ba94541cd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone28Filled', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8.5A2.75 2.75 0 0 1 21 4.75v18.5A2.75 2.75 0 0 1 18.25 26h-8.5A2.75 2.75 0 0 1 7 23.25zM12.25 21a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$b61b4855a55146c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone28Regular', "28", [
    "M9.75 2A2.75 2.75 0 0 0 7 4.75v18.5A2.75 2.75 0 0 0 9.75 26h8.5A2.75 2.75 0 0 0 21 23.25V4.75A2.75 2.75 0 0 0 18.25 2zM8.5 4.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v18.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25zM12.25 21a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$27c9660174a81df7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_32_color__a)",
            "d": "M10.25 2A3.25 3.25 0 0 0 7 5.25v21.5C7 28.55 8.46 30 10.25 30h11.5c1.8 0 3.25-1.46 3.25-3.25V5.25C25 3.45 23.54 2 21.75 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_32_color__b)",
            "d": "M14 24h4a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_32_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.17 2.55 6.48)scale(36.1576 71.7141)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(40.86 -26.36 28.26)scale(10.4955 12.3381)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$2f27c9c0c4e43462 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone32Filled', "32", [
    "M10.25 2A3.25 3.25 0 0 0 7 5.25v21.5C7 28.55 8.46 30 10.25 30h11.5c1.8 0 3.25-1.46 3.25-3.25V5.25C25 3.45 23.54 2 21.75 2zM14 24h4a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2"
]);
const $76e5a570f6bfc30c$export$cde411ba12a32d8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone32Light', "32", [
    "M13.5 24a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM10.25 2A3.25 3.25 0 0 0 7 5.25v21.5C7 28.55 8.46 30 10.25 30h11.5c1.8 0 3.25-1.46 3.25-3.25V5.25C25 3.45 23.54 2 21.75 2zM8 5.25C8 4.01 9 3 10.25 3h11.5C22.99 3 24 4 24 5.25v21.5c0 1.24-1 2.25-2.25 2.25h-11.5C9.01 29 8 28 8 26.75z"
]);
const $76e5a570f6bfc30c$export$7ec16b23cf049f64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone32Regular', "32", [
    "M10.25 2A3.25 3.25 0 0 0 7 5.25v21.5C7 28.55 8.46 30 10.25 30h11.5c1.8 0 3.25-1.46 3.25-3.25V5.25C25 3.45 23.54 2 21.75 2zM9 5.25C9 4.56 9.56 4 10.25 4h11.5c.69 0 1.25.56 1.25 1.25v21.5c0 .69-.56 1.25-1.25 1.25h-11.5C9.56 28 9 27.44 9 26.75zM14 24a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$257f5e06cf9da6a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_48_color__a)",
            "d": "M16.25 4A4.25 4.25 0 0 0 12 8.25v31.5C12 42.1 13.9 44 16.25 44h15.5C34.1 44 36 42.1 36 39.75V8.25C36 5.9 34.1 4 31.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_48_color__b)",
            "d": "M21.25 35.5h5.5a1.25 1.25 0 1 1 0 2.5h-5.5a1.25 1.25 0 1 1 0-2.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_48_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.8 3.75 11.2)scale(50.8736 97.0851)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(39.04 -40.92 44.28)scale(13.6265 15.8385)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$b88be7459dd6c023 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone48Filled', "48", [
    "M16.25 4A4.25 4.25 0 0 0 12 8.25v31.5C12 42.1 13.9 44 16.25 44h15.5C34.1 44 36 42.1 36 39.75V8.25C36 5.9 34.1 4 31.75 4zm5 31.5h5.5a1.25 1.25 0 1 1 0 2.5h-5.5a1.25 1.25 0 1 1 0-2.5"
]);
const $76e5a570f6bfc30c$export$3fc993671a219c20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Phone48Regular', "48", [
    "M16.25 4A4.25 4.25 0 0 0 12 8.25v31.5C12 42.1 13.9 44 16.25 44h15.5C34.1 44 36 42.1 36 39.75V8.25C36 5.9 34.1 4 31.75 4zM14.5 8.25c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75v31.5c0 .97-.78 1.75-1.75 1.75h-15.5c-.97 0-1.75-.78-1.75-1.75zm6.75 27.25a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $76e5a570f6bfc30c$export$154478526350a210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneAdd20Filled', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52A5.5 5.5 0 0 1 14 9.02V3.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$a91d90254ab7b00b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneAdd20Regular', "20", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52q-.51.05-1 .19V3.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5zM9.02 14a6 6 0 0 0 0 1H7.5a.5.5 0 0 1 0-1zm9.98.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $76e5a570f6bfc30c$export$351b378c2ef4a135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M13.75 2C14.99 2 16 3 16 4.25v6.92a6.5 6.5 0 0 0-5 6.33H8.75a.75.75 0 0 0 0 1.5h2.42a6.5 6.5 0 0 0 1.64 3H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm3.75 12h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6q.09.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4z"
]);
const $76e5a570f6bfc30c$export$6dd70f1c252b5250 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M13.75 2C14.99 2 16 3 16 4.25v6.92q-.8.2-1.5.56V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm3.75 12h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6q.09.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zm-8.75 3.5H11q0 .78.17 1.5H8.75a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$9c33b7ccf90c1adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneArrowRight20Filled', "20", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 0 0 9.02 14H7.5a.5.5 0 0 0 0 1h1.52c.1 1.13.55 2.17 1.24 3H5.5A1.5 1.5 0 0 1 4 16.5zM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$c596d8c36d0199cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneArrowRight20Regular', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a6 6 0 0 1-.66-1H5.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7q.49-.13 1-.18V3.5c0-.83-.67-1.5-1.5-1.5zM9 14.5q0-.26.02-.5H7.5a.5.5 0 0 0 0 1h1.52zm5.5-4.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $76e5a570f6bfc30c$export$adeb7e4ca2a72560 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneArrowRight24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v5.77A6.5 6.5 0 0 0 10.17 18H8.75a.75.75 0 0 0-.1 1.5h2.08a6.5 6.5 0 0 0 2.3 2.5H6.26C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm2.75 9a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.22 2.59-.07.06-.06.07a.5.5 0 0 0 0 .56l.06.07L18.29 16H13.4a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01h4.8l-1.65 1.65-.06.07a.5.5 0 0 0 .7.7l.06-.07 2.53-2.53.04-.05.04-.08.03-.08v-.22l-.03-.08-.04-.08-.04-.05-2.53-2.53-.07-.06a.5.5 0 0 0-.49-.04z"
]);
const $76e5a570f6bfc30c$export$1b9ef96ff27ac45a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneArrowRight24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v5.77q-.78.06-1.5.3V4.24a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.13q.7.9 1.66 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm2.75 9a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.22 2.59-.07.06-.06.07a.5.5 0 0 0 0 .56l.06.07L18.29 16H13.4a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01h4.8l-1.65 1.65-.06.07a.5.5 0 0 0 .7.7l.06-.07 2.53-2.53.04-.05.04-.08.03-.08v-.22l-.03-.08-.04-.08-.04-.05-2.53-2.53-.07-.06a.5.5 0 0 0-.49-.04zm-6.64 3.91q.12.79.42 1.5H8.75a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$19dd9ea790fcacbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneBriefcase24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25V11h-.25A2.75 2.75 0 0 0 13 13.75v.3a2.5 2.5 0 0 0-2 2.45V18H8.75a.75.75 0 0 0 0 1.5H11v2q0 .26.05.5h-4.8C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zM14 13.75V15h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1.25c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75m1.5 0q.02-.23.25-.25h3.5q.23.02.25.25V15h-4z"
]);
const $76e5a570f6bfc30c$export$9e542d379495fa26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneBriefcase24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25V11h-.25q-.68 0-1.25.3V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75H11v1q0 .26.05.5h-4.8C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-5 15.5H11V19H8.75a.75.75 0 0 1 0-1.5M14 13.75V15h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1.25c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75m1.5 0q.02-.23.25-.25h3.5q.23.02.25.25V15h-4z"
]);
const $76e5a570f6bfc30c$export$2848eff64cad0507 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat16Filled', "16", [
    "M4 2.75C4 1.78 4.78 1 5.75 1h4.5c.97 0 1.75.78 1.75 1.75v3.27L11.5 6a5.5 5.5 0 0 0-5.01 7.77L6.12 15h-.37C4.78 15 4 14.22 4 13.25zM11.5 16a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$5a02fdafc404086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat16Regular', "16", [
    "M5.75 1C4.78 1 4 1.78 4 2.75v10.5c0 .97.78 1.75 1.75 1.75h.37l.3-1h-.67a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v3.27a6 6 0 0 1 1 0V2.75C12 1.78 11.22 1 10.25 1zm5.75 15a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$f66081000b866da5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat20Filled', "20", [
    "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h2.62l.37-1.23A5.48 5.48 0 0 1 15 9.02V3.5c0-.83-.67-1.5-1.5-1.5zm8 17a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$9602bee9563e9c8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat20Regular', "20", [
    "M9.42 17H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.02a6 6 0 0 1 1 0V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2.12zm5.08 2a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $76e5a570f6bfc30c$export$da5fe44a0b8cc561 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v6.77l-.5-.02a6.5 6.5 0 0 0-5.88 9.26L11.09 22H8.25C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zM21 13.26A5.5 5.5 0 0 0 17.5 12a5.5 5.5 0 0 0-4.81 8.17l-.67 2.19a.5.5 0 0 0 .63.62l2.18-.67q1.2.68 2.67.7a5.5 5.5 0 0 0 3.5-9.75M15.5 17a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1zm2 2h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1"
]);
const $76e5a570f6bfc30c$export$9bf5557ed90b2086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat24Regular', "24", [
    "M18 4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22h2.84l.45-1.5H8.25a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v6.83a7 7 0 0 1 1.5-.06zm3 9A5.5 5.5 0 0 0 17.5 12a5.5 5.5 0 0 0-4.81 8.17l-.67 2.19a.5.5 0 0 0 .63.62l2.18-.67q1.2.68 2.67.7a5.5 5.5 0 0 0 3.5-9.75M15.5 17a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1zm2 2h-2a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1"
]);
const $76e5a570f6bfc30c$export$fb59f5e74fcb3813 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat28Filled', "28", [
    "M9.75 2A2.75 2.75 0 0 0 7 4.75v18.5A2.75 2.75 0 0 0 9.75 26h3.33l.66-2.25A7.5 7.5 0 0 1 21 13.02V4.75A2.75 2.75 0 0 0 18.25 2zM27 20.5a6.5 6.5 0 0 1-9.64 5.69l-2.72.79a.5.5 0 0 1-.62-.62l.8-2.71q-.8-1.42-.82-3.15a6.5 6.5 0 1 1 13 0M18 19a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.23.5.5.5h2.5a.5.5 0 0 0 0-1H18a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$70acdb8868a678cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChat28Regular', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8.5A2.75 2.75 0 0 1 21 4.75v8.27a8 8 0 0 0-1.5.05V4.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v18.5c0 .69.56 1.25 1.25 1.25h3.77l-.44 1.5H9.75A2.75 2.75 0 0 1 7 23.25zM27 20.5a6.5 6.5 0 0 1-9.65 5.69l-2.71.79a.5.5 0 0 1-.62-.62l.8-2.71q-.8-1.42-.82-3.15a6.5 6.5 0 0 1 13 0M18 19a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1zm-.5 2.5c0 .28.22.5.5.5h2.5a.5.5 0 1 0 0-1H18a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$36f1161b6a0b5da4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmark16Filled', "16", [
    "M10.5 11a6 6 0 0 0 1.5-.2v2.45c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 15 4 14.22 4 13.25V2.75C4 1.78 4.78 1 5.75 1h1.59a5.5 5.5 0 0 0 3.16 10M7 12a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm8-6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L9.5 6.29l-.65-.64a.5.5 0 1 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$67e2706f5a6d4038 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmark16Regular', "16", [
    "M11 10.98v2.27c0 .41-.34.75-.75.75h-4.5a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h.5q.48-.57 1.09-1H5.75C4.78 1 4 1.78 4 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-2.46q-.49.15-1 .19M6.5 12.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5m4-2.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2.35-5.65-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 2.65-2.64a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$fb8c5647f356a245 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmark20Filled', "20", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L12.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M6.5 2h2.76A5.5 5.5 0 0 0 15 10.8v5.7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5v-13C5 2.67 5.67 2 6.5 2M8 14.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5"
]);
const $76e5a570f6bfc30c$export$d57718b70c5a4280 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmark20Regular', "20", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L12.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M9.25 2H6.5C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.7q-.49.13-1 .18v5.52a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h2.1q.27-.54.66-1M8 14.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$6fb132405799ea0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmark24Filled', "24", [
    "M12.35 2A6.49 6.49 0 0 0 18 13.32v6.43c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-1.6 16a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM16.5 1.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3.35 3.15a.5.5 0 0 0-.7 0L15.5 8.29l-1.65-1.64a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$5b3eb419181306d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmark24Regular', "24", [
    "M12.35 2q-.78.65-1.33 1.5H8.25a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V13.5q.78 0 1.5-.18v6.43c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm.9 15.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zm3.25-16a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3.35 3.15a.5.5 0 0 0-.7 0L15.5 8.29l-1.65-1.64a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$3632d7f50a173088 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop16Filled', "16", [
    "M6 1a2 2 0 0 0-2 2v2h1.5A2.5 2.5 0 0 1 8 7.5V11h2v1H8v1h3.5a.5.5 0 0 0 0-1H11v-1h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM2.5 6C1.67 6 1 6.67 1 7.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7 6.67 6.33 6 5.5 6zm.5 6.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$ec5bd1256d4b3b55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop16Regular', "16", [
    "M6 2h7a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8v1h2v1H8v1h3.5a.5.5 0 0 0 0-1H11v-1h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2h1V3a1 1 0 0 1 1-1M3.5 12a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-1-6C1.67 6 1 6.67 1 7.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7 6.67 6.33 6 5.5 6zm0 1h3c.28 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$8f73887655440f90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop20Filled', "20", [
    "M6 2a2 2 0 0 0-2 2v3h2.5A2.5 2.5 0 0 1 9 9.5V13h3v2H9v1h5.5a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$6fbbf73fc6a356f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop20Regular', "20", [
    "M6 3h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H9v1h3v2H9v1h5.5a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3h1V4a1 1 0 0 1 1-1M4.5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$a17f4ad6cacc035c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop24Filled', "24", [
    "M8.25 9c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 22 2 21.22 2 20.25v-9.5C2 9.78 2.78 9 3.75 9zm-2 9.5h-.6a.75.75 0 0 0 0 1.49h.7a.75.75 0 0 0 0-1.49zM19.75 2c1.19 0 2.16.93 2.24 2.1v9.15c0 1.2-.92 2.17-2.09 2.24l-.15.01H16v2h1.25a.75.75 0 0 1 .1 1.5H11v-1.5h3.5v-2H11v-5A2.5 2.5 0 0 0 8.66 8H4V4.25c0-1.2.92-2.17 2.1-2.24L6.25 2z"
]);
const $76e5a570f6bfc30c$export$a68609e550cb7689 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop24Regular', "24", [
    "M8.25 9c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 22 2 21.22 2 20.25v-9.5C2 9.78 2.78 9 3.75 9zm0 1.5h-4.5a.25.25 0 0 0-.25.25v9.5c0 .14.11.25.25.25h4.5q.23-.02.25-.25v-9.5a.25.25 0 0 0-.25-.25m-2 7.5a.75.75 0 0 1 .1 1.5h-.6a.75.75 0 0 1-.1-1.5h.6m13.5-16c1.19 0 2.16.93 2.24 2.1v9.15c0 1.2-.92 2.17-2.09 2.24l-.15.01H16v2h1.25a.75.75 0 0 1 .1 1.5H11v-1.5h3.5v-2H11V14h8.75c.38 0 .7-.28.74-.65v-9.1a.75.75 0 0 0-.74-.75H6.25c-.38 0-.7.28-.74.65l-.01.1V8H4V4.25c0-1.2.92-2.17 2.1-2.24L6.25 2z"
]);
const $76e5a570f6bfc30c$export$6b66de243bd2b66c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop28Filled', "28", [
    "M5 4.25V9h4.75c1.8 0 3.25 1.46 3.25 3.25v5.5h4.5v2.75H13V22h7.35a.75.75 0 0 0-.1-1.5H19v-2.75h4.91A2.25 2.25 0 0 0 26 15.5V4.25L26 4.1A2.25 2.25 0 0 0 23.75 2H7.1A2.25 2.25 0 0 0 5 4.26M12 17v-4.75C12 11.01 11 10 9.75 10H4.1A2.25 2.25 0 0 0 2 12.26V23.9A2.25 2.25 0 0 0 4.26 26H9.9a2.25 2.25 0 0 0 2.1-2.25zm-4.25 4.5h.1a.75.75 0 0 1 0 1.5h-1.7a.75.75 0 0 1 0-1.5h1.6"
]);
const $76e5a570f6bfc30c$export$3eb0163090c0cf3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop28Regular', "28", [
    "M9.75 10c1.19 0 2.16.93 2.24 2.1v11.65c0 1.2-.92 2.17-2.09 2.24l-.15.01h-5.5c-1.2 0-2.17-.93-2.24-2.1L2 23.75v-11.5c0-1.2.93-2.17 2.1-2.24l.15-.01zm0 1.5h-5.5c-.38 0-.7.28-.74.65l-.01.1v11.5c0 .38.28.7.65.74l.1.01h5.5c.38 0 .69-.28.74-.65v-11.6c0-.38-.28-.7-.64-.74zm-2 10a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6m16-19.5c1.2 0 2.17.93 2.25 2.1v11.4c0 1.2-.92 2.17-2.1 2.24l-.15.01H19v2.75h1.25a.75.75 0 0 1 .1 1.5H13v-1.5h4.5v-2.75H13v-1.5h10.75c.38 0 .7-.28.75-.65V4.25c0-.38-.28-.7-.65-.74l-.1-.01H7.25c-.38 0-.7.28-.74.65l-.01.1V9H5V4.25c0-1.2.93-2.17 2.1-2.24L7.25 2z"
]);
const $76e5a570f6bfc30c$export$8cde9651018503f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop32Filled', "32", [
    "M5 5.25C5 3.45 6.46 2 8.25 2h18.5C28.55 2 30 3.46 30 5.25v12.5c0 1.8-1.46 3.25-3.25 3.25H22v3h2a1 1 0 1 1 0 2h-9.5v-2H20v-3h-5.5v-5.75a4.75 4.75 0 0 0-4.75-4.75H5zm-3 10C2 13.45 3.46 12 5.25 12h4.5c1.8 0 3.25 1.46 3.25 3.25v11.5c0 1.8-1.46 3.25-3.25 3.25h-4.5A3.25 3.25 0 0 1 2 26.75zM6 26a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1"
]);
const $76e5a570f6bfc30c$export$55202bc5b98679a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop32Regular', "32", [
    "M8.25 2A3.25 3.25 0 0 0 5 5.25v5.26l.25-.01H7V5.25C7 4.56 7.56 4 8.25 4h18.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H14.5v2H20v3h-5.5v2H24a1 1 0 1 0 0-2h-2v-3h4.75c1.8 0 3.25-1.46 3.25-3.25V5.25C30 3.45 28.54 2 26.75 2zM2 15.25C2 13.45 3.46 12 5.25 12h4.5c1.8 0 3.25 1.46 3.25 3.25v11.5c0 1.8-1.46 3.25-3.25 3.25h-4.5A3.25 3.25 0 0 1 2 26.75zM5.25 14C4.56 14 4 14.56 4 15.25v11.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-11.5c0-.69-.56-1.25-1.25-1.25zM7 25a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2z"
]);
const $76e5a570f6bfc30c$export$eebf57e8b07a0950 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop48Filled', "48", [
    "M9 8.25C9 5.9 10.9 4 13.25 4h26.5C42.1 4 44 5.9 44 8.25v17.5C44 28.1 42.1 30 39.75 30H32v5h2.75a1.25 1.25 0 1 1 0 2.5H22V35h7.5v-5H22v-8.75C22 17.8 19.2 15 15.75 15H9zm-5 13C4 18.9 5.9 17 8.25 17h7.5C18.1 17 20 18.9 20 21.25v18.5C20 42.1 18.1 44 15.75 44h-7.5A4.25 4.25 0 0 1 4 39.75zm5.5 17c0 .69.56 1.25 1.25 1.25h2.5a1.25 1.25 0 1 0 0-2.5h-2.5c-.69 0-1.25.56-1.25 1.25"
]);
const $76e5a570f6bfc30c$export$d5b5529c6c9e19db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktop48Regular', "48", [
    "M13.25 4A4.25 4.25 0 0 0 9 8.25V15h2.5V8.25c0-.97.78-1.75 1.75-1.75h26.5c.97 0 1.75.78 1.75 1.75v17.5c0 .97-.78 1.75-1.75 1.75H22V30h7.5v5H22v2.5h12.75a1.25 1.25 0 1 0 0-2.5H32v-5h7.75C42.1 30 44 28.1 44 25.75V8.25C44 5.9 42.1 4 39.75 4zM9.5 38.25c0-.69.56-1.25 1.25-1.25h2.5a1.25 1.25 0 1 1 0 2.5h-2.5c-.69 0-1.25-.56-1.25-1.25M8.25 17A4.25 4.25 0 0 0 4 21.25v18.5C4 42.1 5.9 44 8.25 44h7.5C18.1 44 20 42.1 20 39.75v-18.5C20 18.9 18.1 17 15.75 17zM6.5 21.25c0-.97.78-1.75 1.75-1.75h7.5c.97 0 1.75.78 1.75 1.75v18.5c0 .97-.78 1.75-1.75 1.75h-7.5c-.97 0-1.75-.78-1.75-1.75z"
]);
const $76e5a570f6bfc30c$export$8d0333d1d2ca57b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktopAdd20Filled', "20", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V11a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1H9v-1h3v-2H9V9.5A2.5 2.5 0 0 0 6.5 7H4V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 0 0 4.24 9m-11-3C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$2d82938482841685 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktopAdd20Regular', "20", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm2 7.5v-.6q.54-.27 1-.66V11a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1H9v-1h3v-2H9v-1h7a1 1 0 0 0 1-1m-6.74-9q-.39.46-.66 1H6a1 1 0 0 0-1 1v3H4V4c0-1.1.9-2 2-2zM4 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m-2-6C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$501f330252b007f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDismiss20Filled', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52A5.5 5.5 0 0 1 14 9.02V3.5c0-.83-.67-1.5-1.5-1.5zm9 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $76e5a570f6bfc30c$export$1975637d9f61d12a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDismiss20Regular', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a6 6 0 0 1-.66-1H5.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7q.49-.13 1-.18V3.5c0-.83-.67-1.5-1.5-1.5zM9 14.5q0-.26.02-.5H7.5a.5.5 0 0 0 0 1h1.52zm10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $76e5a570f6bfc30c$export$3ffd80ae22192374 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDismiss24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M13.75 2C14.99 2 16 3 16 4.25v6.92A6.5 6.5 0 0 0 11.02 18H8.75a.75.75 0 0 0-.1 1.5h2.66c.3.95.83 1.8 1.5 2.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm1.34 12.97-.07.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05z"
]);
const $76e5a570f6bfc30c$export$8fdb725910d3e4a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDismiss24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M13.75 2C14.99 2 16 3 16 4.25v6.92q-.8.2-1.5.56V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm1.34 12.97-.07.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05zM8.75 17.5H11q0 .78.17 1.5H8.75a.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$4d1c5cf98939636a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEdit20Filled', "20", [
    "m15.8 1.55-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64m-5.53 4.12 3.62-3.62A2 2 0 0 0 13.5 2h-7C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V9.06l-.67.67q-.62.61-1.48.84l-1.5.37a1.9 1.9 0 0 1-2.3-2.29l.38-1.5a3 3 0 0 1 .84-1.48M9 14h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$4fb5a433c4ea70a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEdit20Regular', "20", [
    "m15.8 1.55-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64M12.95 3l.84-.84A2 2 0 0 0 13 2H7a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V9.06l-.67.67q-.15.15-.33.29V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM9 14a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$eedb7eee29f7d948 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEdit24Filled', "24", [
    "m13.2 7.57 5.9-5.9a2.29 2.29 0 1 1 3.23 3.23l-5.9 5.9q-.53.54-1.25.71l-1.83.46c-.8.2-1.52-.52-1.32-1.32l.46-1.83q.18-.71.7-1.25m-.71-.7 4.5-4.5A2.2 2.2 0 0 0 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22h7.5c1.24 0 2.25-1 2.25-2.25v-9.1l-.86.86q-.73.71-1.72.97l-1.83.46c-1.52.38-2.9-1-2.53-2.53l.46-1.83q.25-.99.97-1.72M13.25 18a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$ca18321ed57ce56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEdit24Regular', "24", [
    "m13.2 7.57 5.9-5.9a2.29 2.29 0 1 1 3.23 3.23l-5.9 5.9q-.53.54-1.25.71l-1.83.46c-.8.2-1.52-.52-1.32-1.32l.46-1.83q.18-.71.7-1.25M15.75 2q.7.01 1.24.37L15.85 3.5l-.1-.01h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75v-7.73q.34-.21.64-.5l.86-.87v9.1c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-2.5 15.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$d9f15b27f1fde621 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEraser16Filled', "16", [
    "M10.94 1.35a1.5 1.5 0 0 1 2.12 0l1.59 1.59a1.5 1.5 0 0 1 0 2.12l-4.59 4.59a1.5 1.5 0 0 1-2.12 0L6.35 8.06a1.5 1.5 0 0 1 0-2.12zM10.29 8 8 5.7l-.94.95a.5.5 0 0 0 0 .7l1.59 1.59c.2.2.5.2.7 0zm-4.56.77a2.5 2.5 0 0 1 0-3.54l4.13-4.12Q9.56 1 9.25 1h-4.5C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-3.04l-.15.14a2.5 2.5 0 0 1-3.53 0zM6 12h2a.5.5 0 1 1 0 1H6a.5.5 0 0 1 0-1"
]);
const $76e5a570f6bfc30c$export$2e3b3e169ef977ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEraser16Regular', "16", [
    "M10 10.88v2.37c0 .41-.34.75-.75.75h-4.5a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h4.13l.91-.91A2 2 0 0 0 9.25 1h-4.5C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-3.13l-.23.23q-.36.34-.77.53M5.5 12.5c0-.28.22-.5.5-.5h2a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5m7.56-11.15a1.5 1.5 0 0 0-2.12 0L6.35 5.94a1.5 1.5 0 0 0 0 2.12l1.59 1.59a1.5 1.5 0 0 0 2.12 0l4.59-4.59a1.5 1.5 0 0 0 0-2.12zM8 5.71 10.3 8l-.95.94a.5.5 0 0 1-.7 0L7.06 7.35a.5.5 0 0 1 0-.7z"
]);
const $76e5a570f6bfc30c$export$580cdec5645e0525 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEraser20Filled', "20", [
    "M14.58 1.44a1.5 1.5 0 0 1 2.12 0l1.86 1.86a1.5 1.5 0 0 1 0 2.12l-5.14 5.14a1.5 1.5 0 0 1-2.12 0L9.44 8.7a1.5 1.5 0 0 1 0-2.12zm-4.43 5.84a.5.5 0 0 0 0 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6zM12.6 2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.11a2.5 2.5 0 0 1-3.4-.12L8.72 9.4a2.5 2.5 0 0 1 0-3.54zm-2.1 12.5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1 0-1h2c.28 0 .5.22.5.5"
]);
const $76e5a570f6bfc30c$export$ce148ffccf138bcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEraser20Regular', "20", [
    "M14.58 1.44a1.5 1.5 0 0 1 2.12 0l1.86 1.86a1.5 1.5 0 0 1 0 2.12l-5.14 5.14a1.5 1.5 0 0 1-2.12 0L9.44 8.7a1.5 1.5 0 0 1 0-2.12zm-4.43 5.84a.5.5 0 0 0 0 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6zm2.38-5.2A2 2 0 0 0 12 2H6a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-4.61q-.46.38-1 .53V16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5.6zM7.5 14.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$e7e67d666a2c63ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFooterArrowDown20Filled', "20", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 13.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m5.35-3.65-2 2A.5.5 0 0 1 10 14a.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V9.5a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$5e0c3e7c8933ed6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFooterArrowDown20Regular', "20", [
    "M7 15.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm5.35 8.85-2 2A.5.5 0 0 1 10 14a.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V9.5a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7"
]);
const $76e5a570f6bfc30c$export$b5eb62c0a1519158 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFooterArrowDown24Filled', "24", [
    "M18 4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22h7.5c1.24 0 2.25-1 2.25-2.25zm-9.5 14c0-.41.34-.75.75-.75h5.6a.75.75 0 0 1-.1 1.5h-5.6a.75.75 0 0 1-.65-.75M12 16a.8.8 0 0 1-.53-.23l-2.45-2.5a.75.75 0 1 1 1.07-1.04l1.16 1.18V9.75a.75.75 0 0 1 1.5 0v3.71l1.27-1.25a.75.75 0 1 1 1.06 1.08l-2.55 2.5a.8.8 0 0 1-.54.21"
]);
const $76e5a570f6bfc30c$export$37a8607692698849 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFooterArrowDown24Regular', "24", [
    "M18 4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22h7.5c1.24 0 2.25-1 2.25-2.25zM8.25 3.5h7.5c.41 0 .75.34.75.75v15.5c0 .41-.34.75-.75.75h-7.5a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75m7.25 14.75a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0 0 1.5h5.5c.41 0 .75-.34.75-.75M12 16q.3 0 .53-.21l2.55-2.5a.75.75 0 1 0-1.06-1.08l-1.27 1.25V9.75a.75.75 0 0 0-1.5 0v3.66l-1.16-1.18a.75.75 0 1 0-1.07 1.04l2.45 2.5q.2.23.52.23"
]);
const $76e5a570f6bfc30c$export$7b46ee0e220cf129 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneHeaderArrowUp20Filled', "20", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m5.35 3.65a.5.5 0 0 1-.7.7L10.5 7.71v2.79a.5.5 0 0 1-1 0V7.7L8.35 8.86a.5.5 0 1 1-.7-.7l2-2A.5.5 0 0 1 10 6a.5.5 0 0 1 .35.14z"
]);
const $76e5a570f6bfc30c$export$3e344139e4e7c1e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneHeaderArrowUp20Regular', "20", [
    "M7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm5.35 5.15-2-2A.5.5 0 0 0 10 6a.5.5 0 0 0-.35.15l-2 2a.5.5 0 1 0 .7.7L9.5 7.71v2.79a.5.5 0 0 0 1 0V7.7l1.15 1.15a.5.5 0 0 0 .7-.7"
]);
const $76e5a570f6bfc30c$export$48b45c8029a43778 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneHeaderArrowUp24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-1 2.5h-5.5a.75.75 0 0 0-.1 1.5h5.6a.75.75 0 0 0 .1-1.5zm-2 6.04 1.27 1.25a.75.75 0 1 0 1.06-1.08l-2.55-2.5a.75.75 0 0 0-1.06.02l-2.45 2.5a.75.75 0 1 0 1.07 1.04l1.16-1.18v3.66a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$25b905a69dba00e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneHeaderArrowUp24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75m-1 1.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5zm-2 5.54 1.27 1.25a.75.75 0 1 0 1.06-1.08l-2.55-2.5a.75.75 0 0 0-1.06.02l-2.45 2.5a.75.75 0 1 0 1.07 1.04l1.16-1.18v3.66a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$634b428d83e01ccb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneKey20Filled', "20", [
    "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5H9v-1q.01-.63.44-1.06l.94-.94H9a.5.5 0 0 1 0-1h2q.15 0 .29.1l.73-.74-.02-.42q0-.83.33-1.56A4.1 4.1 0 0 1 15 9.13V3.5c0-.83-.67-1.5-1.5-1.5zm4 17a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
]);
const $76e5a570f6bfc30c$export$e97bee08606026b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneKey20Regular', "20", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2v-1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.54a4 4 0 0 1 1-.4V4a2 2 0 0 0-2-2zm3.38 13 .91-.9A.5.5 0 0 0 11 14H9a.5.5 0 0 0 0 1zm.12 4a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
]);
const $76e5a570f6bfc30c$export$d1185f63d2c2c82e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneKey24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v7a4.5 4.5 0 0 0-2.97 4.8L13.1 18h-2.34a.75.75 0 0 0 0 1.5h.84l-.08.07c-.33.33-.51.78-.51 1.24V22H8.25C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm3.75 17a3.5 3.5 0 1 0-3.38-2.59l-.15.12-3.75 3.75a.8.8 0 0 0-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 0 0 .5-.5V22h1a.5.5 0 0 0 .5-.5v-1h1a.5.5 0 0 0 .5-.5v-1zm1.5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $76e5a570f6bfc30c$export$9e6169b65f2b452b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneKey24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v7q-.85.3-1.5.9v-7.9a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h2.78q-.03.15-.03.31V22H8.25C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-2.5 15.5q.15 0 .28.05L12.08 19h-1.33a.75.75 0 0 1 0-1.5zM19.5 19a3.5 3.5 0 1 0-3.38-2.59l-.15.12-3.75 3.75a.8.8 0 0 0-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 0 0 .5-.5V22h1a.5.5 0 0 0 .5-.5v-1h1a.5.5 0 0 0 .5-.5v-1zm1.5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $76e5a570f6bfc30c$export$219201450db25ac8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__a)",
            "d": "M5.5 10 9 9.5l3.5.5h.26a1 1 0 0 1 .45.1l1.34.68a.8.8 0 0 1 .45.72H3c0-.3.17-.59.45-.72l1.34-.67a1 1 0 0 1 .45-.11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__b)",
            "d": "M5.5 10 9 9.5l3.5.5h.26a1 1 0 0 1 .45.1l1.34.68a.8.8 0 0 1 .45.72H3c0-.3.17-.59.45-.72l1.34-.67a1 1 0 0 1 .45-.11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__c)",
            "d": "M3.5 11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__d)",
            "d": "M4 4.5C4 3.67 4.67 3 5.5 3h7c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 4 8.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__e)",
            "fillOpacity": ".3",
            "d": "M5.5 3C4.67 3 4 3.67 4 4.5v4c0 .83.67 1.5 1.5 1.5h-.26a1 1 0 0 0-.45.1l-1.34.68a.8.8 0 0 0-.45.72c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5.8.8 0 0 0-.45-.72l-1.34-.67a1 1 0 0 0-.45-.11h-.26c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__f)",
            "d": "M2.5 5C1.67 5 1 5.67 1 6.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7 5.67 6.33 5 5.5 5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_16_color__g)",
            "d": "M4 12.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(15.65 -26.91 6.48)scale(29.931 24.247)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f08af4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2.5 0 0 5.23437 6 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".15",
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(60.63 -1.88 .53)scale(14.9101 30.1586)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f08af4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(69.57 -6.65 8.19)scale(2.59661 2.03173)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d6cfff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__b",
                "x1": "15",
                "x2": "13.95",
                "y1": "11.98",
                "y2": "7.26",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#63686e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__c",
                "x1": "15",
                "x2": "14.85",
                "y1": "11.93",
                "y2": "10.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#889096"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#aab3bd"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_16_color__d",
                "x1": "11",
                "x2": "11.41",
                "y1": "3",
                "y2": "11.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4894fe"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$65dd625f6a1460f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop16Filled', "16", [
    "M3 4c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-4v-4A2.5 2.5 0 0 0 6 4H3.5a2 2 0 0 0-.5.06zm11.5 8.5h-6v-1h6a.5.5 0 0 1 0 1M3 5c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7.5 5.67 6.83 5 6 5zm1.5 7.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $76e5a570f6bfc30c$export$710961846cec1842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop16Regular', "16", [
    "M3 4c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-4v-1h4A.5.5 0 0 0 13 9V4a.5.5 0 0 0-.5-.5h-8A.5.5 0 0 0 4 4h-.5a2 2 0 0 0-.5.06zm11.5 8.5h-6v-1h6a.5.5 0 0 1 0 1m-10 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-3-6C1.5 5.67 2.17 5 3 5h3c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5zM3 6a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-6A.5.5 0 0 0 6 6z"
]);
const $76e5a570f6bfc30c$export$92eed4d462d8e773 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__a)",
            "d": "M15.76 13H4.24a1 1 0 0 0-.45.1l-1.34.68a.8.8 0 0 0-.45.72c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5.8.8 0 0 0-.45-.72l-1.34-.67a1 1 0 0 0-.45-.11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__b)",
            "d": "M2.5 14a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__c)",
            "d": "M4.5 4C3.67 4 3 4.67 3 5.5v6c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__d)",
            "fillOpacity": ".3",
            "d": "M3 5.5C3 4.67 3.67 4 4.5 4h11c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h.26a1 1 0 0 1 .45.1l1.34.68a.8.8 0 0 1 .45.72.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5c0-.3.17-.59.45-.72l1.34-.67a1 1 0 0 1 .45-.11h.26A1.5 1.5 0 0 1 3 11.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__e)",
            "d": "M2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__f)",
            "d": "M5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.5 0 0 5.59375 6 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.76 -2.57 1.82)scale(18.0277 35.5671)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f08af4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.32 -12.91 11.7)scale(3.03418 3.47746)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d6cfff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__a",
                "x1": "18",
                "x2": "17.54",
                "y1": "14.86",
                "y2": "11.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#63686e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__b",
                "x1": "18",
                "x2": "17.88",
                "y1": "14.93",
                "y2": "13.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#889096"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#aab3bd"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__c",
                "x1": "12.8",
                "x2": "13.28",
                "y1": "4",
                "y2": "14.3",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4894fe"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$8d11eddb11dff521 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop20Filled', "20", [
    "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 0 0-2-2H3zM10 15h7.5a.5.5 0 0 0 0-1H10zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5zM5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$517a09bc746ae84e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop20Regular', "20", [
    "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V6H3zM10 15h7.5a.5.5 0 0 0 0-1H10zm-5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5zM3.5 8a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$a9dc86593d8eb5d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_24_color__a)",
            "d": "m6.25 16 5.75-.53 5.75.53h.07a1 1 0 0 1 .35.06l3.12 1.18c.43.15.7.56.71 1.01H2c0-.45.28-.85.7-1.01l3.13-1.18a1 1 0 0 1 .35-.06z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_24_color__b)",
            "d": "M2.75 17.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_24_color__c)",
            "d": "M4 6.25C4 5.01 5 4 6.25 4h11.5C18.99 4 20 5 20 6.25v7.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 16 4 15 4 13.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_24_color__d)",
            "fillOpacity": ".3",
            "d": "M6.25 4C5.01 4 4 5 4 6.25v7.5C4 14.99 5 16 6.25 16h-.07a1 1 0 0 0-.35.06L2.7 17.24c-.42.16-.7.56-.7 1.01 0 .41.34.75.75.75h18.5c.41 0 .75-.34.75-.75v-.01c0-.45-.29-.85-.7-1l-3.13-1.18a1 1 0 0 0-.35-.06h-.07C19 16 20 15 20 13.75v-7.5C20 5.01 19 4 17.75 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_24_color__e)",
            "d": "M8.25 8C9.22 8 10 8.8 10 9.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 21 2 20.22 2 19.25v-9.5C2 8.8 2.78 8 3.75 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_24_color__f)",
            "d": "M6.75 17.5a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.49h1.6"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.5 0 0 8.14063 8.5 15.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".48",
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.54 -2.91 1.77)scale(21.1528 40.9645)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f08af4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.32 -15.52 12.82)scale(4.5513 5.2162)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d6cfff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_24_color__a",
                "x1": "22",
                "x2": "20.77",
                "y1": "18.91",
                "y2": "12.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#63686e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_24_color__b",
                "x1": "22",
                "x2": "21.79",
                "y1": "18.89",
                "y2": "16.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#889096"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#aab3bd"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_24_color__c",
                "x1": "15.2",
                "x2": "15.95",
                "y1": "4",
                "y2": "17.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4894fe"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$2d6a885ef08df666 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop24Filled', "24", [
    "M8.25 8C9.22 8 10 8.8 10 9.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 21 2 20.22 2 19.25v-9.5C2 8.8 2.78 8 3.75 8zm-2 9.5h-.5a.75.75 0 1 0 0 1.5h.5a.75.75 0 0 0 0-1.5m15-1a.75.75 0 0 1 .1 1.5H11v-1.5zm-3-11.5c.97 0 1.75.78 1.75 1.75v7.5c0 .97-.78 1.75-1.75 1.75H11V9a2 2 0 0 0-1.85-2H4v-.25C4 5.78 4.78 5 5.75 5z"
]);
const $76e5a570f6bfc30c$export$256293acabdd8e71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop24Regular', "24", [
    "M8.25 8C9.22 8 10 8.8 10 9.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 21 2 20.22 2 19.25v-9.5C2 8.8 2.78 8 3.75 8zm0 1.5h-4.5a.25.25 0 0 0-.25.25v9.5c0 .14.11.25.25.25h4.5q.23-.01.25-.25v-9.5a.25.25 0 0 0-.25-.25m-2 7.5a.75.75 0 0 1 .1 1.5h-.6a.75.75 0 0 1-.1-1.5h.6m15-.5a.75.75 0 0 1 .1 1.5H11v-1.5zm-3-11.5c.97 0 1.75.78 1.75 1.75v7.5c0 .97-.78 1.75-1.75 1.75H11v-1.5h7.25q.23-.02.25-.25v-7.5a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25V7H4v-.25C4 5.78 4.78 5 5.75 5z"
]);
const $76e5a570f6bfc30c$export$1cd8560f89ba4db8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_32_color__a)",
            "d": "m7.5 22 8.5-.5 8.5.5h.3a1 1 0 0 1 .38.07l3.9 1.56c.55.22.92.77.92 1.37H2c0-.6.37-1.15.93-1.37l3.9-1.56a1 1 0 0 1 .36-.07z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_32_color__b)",
            "d": "M3 24a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_32_color__c)",
            "d": "M4 9.25C4 7.45 5.46 6 7.25 6h17.5C26.55 6 28 7.46 28 9.25v9.5c0 1.8-1.46 3.25-3.25 3.25H7.25A3.25 3.25 0 0 1 4 18.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_32_color__d)",
            "fillOpacity": ".3",
            "d": "M7.25 6A3.25 3.25 0 0 0 4 9.25v9.5C4 20.55 5.46 22 7.25 22h-.06a1 1 0 0 0-.37.07l-3.9 1.56C2.38 23.85 2 24.4 2 25a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1c0-.6-.37-1.15-.93-1.37l-3.9-1.56a1 1 0 0 0-.36-.07h-.06c1.8 0 3.25-1.46 3.25-3.25v-9.5C28 7.45 26.54 6 24.75 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_32_color__e)",
            "d": "M2 13a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3z"
        }
    ],
    [
        "rect",
        {
            "width": "4",
            "height": "2",
            "x": "6",
            "y": "23",
            "fill": "url(#ic_fluent_phone_laptop_32_color__f)",
            "rx": "1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.5 0 0 13 12 22)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".01",
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(60.63 -3.76 1.05)scale(29.8201 60.3172)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f08af4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.32 -20.35 16.92)scale(6.06837 6.95492)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d6cfff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_32_color__a",
                "x1": "29.91",
                "x2": "27.62",
                "y1": "27.07",
                "y2": "16.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#63686e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_32_color__b",
                "x1": "30",
                "x2": "29.74",
                "y1": "25.86",
                "y2": "22.16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#889096"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#aab3bd"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_32_color__c",
                "x1": "20.8",
                "x2": "21.69",
                "y1": "6",
                "y2": "24.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4894fe"
                }
            ]
        ]
    ]
], {
    color: true
});
const $76e5a570f6bfc30c$export$ed2d1ba7446dd3db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop32Filled', "32", [
    "M6 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-8v-8a5 5 0 0 0-5-5H7a4 4 0 0 0-1 .13zm23 17H17v-2h12a1 1 0 1 1 0 2M6 10a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3zm3 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$e08404ec76a9a2bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptop32Regular', "32", [
    "M6 8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-8v-2h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1H7a4 4 0 0 0-1 .13zm23 17H17v-2h12a1 1 0 1 1 0 2M9 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3 13a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1z"
]);
const $76e5a570f6bfc30c$export$d637db9ff27c4b60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLinkSetup20Filled', "20", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.52L14.5 9a5.5 5.5 0 0 0-4.24 9H6.5A1.5 1.5 0 0 1 5 16.5zm7.07 7.94a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$23b595f914207c9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLinkSetup20Regular', "20", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h3.26a6 6 0 0 1-.66-1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.02a6 6 0 0 1 1 0V4a2 2 0 0 0-2-2zm5.07 9.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$95233e1da5f37add = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLinkSetup24Filled', "24", [
    "M17.5 12q.45 0 .86.07l.17.72a2 2 0 0 0 2.42 1.47l.1-.02.6-.18q.54.7.85 1.57l-.45.43a2 2 0 0 0-.17 2.7l.15.15.47.46q-.31.86-.85 1.57l-.6-.18a2 2 0 0 0-2.49 1.35l-.03.1-.17.72a5 5 0 0 1-1.72 0l-.17-.72a2 2 0 0 0-2.42-1.47l-.1.02-.6.18q-.54-.71-.85-1.57l.45-.43a2 2 0 0 0 .17-2.7l-.15-.15-.47-.46q.31-.87.85-1.57l.6.18a2 2 0 0 0 2.49-1.35l.03-.1.17-.72q.42-.07.86-.07M13.75 2C14.99 2 16 3 16 4.25v6.92A6.5 6.5 0 0 0 11.02 18H8.75a.75.75 0 0 0-.1 1.5h2.66c.3.95.83 1.8 1.5 2.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm3.75 14c-.8 0-1.45.67-1.45 1.5S16.7 19 17.5 19s1.45-.67 1.45-1.5S18.3 16 17.5 16"
]);
const $76e5a570f6bfc30c$export$9a2a26bf49b5b98a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLinkSetup24Regular', "24", [
    "M17.5 12q.45 0 .86.07l.17.72a2 2 0 0 0 2.42 1.47l.1-.02.6-.18q.54.7.85 1.57l-.45.43a2 2 0 0 0-.17 2.7l.15.15.47.46q-.31.86-.85 1.57l-.6-.18a2 2 0 0 0-2.49 1.35l-.03.1-.17.72a5 5 0 0 1-1.72 0l-.17-.72a2 2 0 0 0-2.42-1.47l-.1.02-.6.18q-.54-.71-.85-1.57l.45-.43a2 2 0 0 0 .17-2.7l-.15-.15-.47-.46q.31-.87.85-1.57l.6.18a2 2 0 0 0 2.49-1.35l.03-.1.17-.72q.42-.07.86-.07M13.75 2C14.99 2 16 3 16 4.25v6.92q-.8.2-1.5.56V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-5 15.5H11q0 .78.17 1.5H8.75a.75.75 0 0 1 0-1.5M17.5 16c-.8 0-1.45.67-1.45 1.5S16.7 19 17.5 19s1.45-.67 1.45-1.5S18.3 16 17.5 16"
]);
const $76e5a570f6bfc30c$export$5bce0ece24ec8915 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLock20Filled', "20", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.54A3 3 0 0 0 11.5 12v.06A2 2 0 0 0 10 14H8.5a.5.5 0 0 0 0 1H10v3H6.5A1.5 1.5 0 0 1 5 16.5zm7.5 8.5v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$5ab0d1bf497cfbde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLock20Regular', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5.04a3 3 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3v1H7a2 2 0 0 1-2-2zm3.5 10H10v1H8.5a.5.5 0 0 1 0-1m4-2v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$412e02e420da52ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLock24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v6.59A3.5 3.5 0 0 0 14 14v.05a2.5 2.5 0 0 0-2 2.45v2.25a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0 0 1.5h2.5c.41 0 .75-.34.75-.75v2.75q0 .26.05.5h-5.8C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zM15 14v1h-.5c-.83 0-1.5.67-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H20v-1a2.5 2.5 0 0 0-5 0m1.5 0a1 1 0 1 1 2 0v1h-2zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $76e5a570f6bfc30c$export$b81910570a6d8e5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLock24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v6.59c-.62.3-1.15.77-1.5 1.36V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75H12v1q0 .26.05.5h-5.8C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zM15 14a2.5 2.5 0 1 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h.5zm1.5 0v1h2v-1a1 1 0 1 0-2 0m2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-6.5-.75c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.33.75.75"
]);
const $76e5a570f6bfc30c$export$161bccb93f1dcd19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneMultiple24Filled', "24", [
    "M8.25 2C7.01 2 6 3 6 4.25v13c0 1.24 1 2.25 2.25 2.25h5.5c1.24 0 2.25-1 2.25-2.25v-13C16 3.01 15 2 13.75 2zM9 16.25c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75M10.75 22c-.98 0-1.81-.63-2.12-1.5h5.62A2.75 2.75 0 0 0 17 17.75V4.63c.87.3 1.5 1.14 1.5 2.12v11c0 2.35-1.9 4.25-4.25 4.25z"
]);
const $76e5a570f6bfc30c$export$57245f7e6aa80828 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneMultiple24Regular', "24", [
    "M9.75 15.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM8.25 2C7.01 2 6 3 6 4.25v13c0 1.24 1 2.25 2.25 2.25h5.5c1.24 0 2.25-1 2.25-2.25v-13C16 3.01 15 2 13.75 2zM7.5 4.25c0-.41.34-.75.75-.75h5.5c.41 0 .75.34.75.75v13c0 .41-.34.75-.75.75h-5.5a.75.75 0 0 1-.75-.75zM10.75 22c-.98 0-1.81-.63-2.12-1.5h5.62A2.75 2.75 0 0 0 17 17.75V4.63c.87.3 1.5 1.14 1.5 2.12v11c0 2.35-1.9 4.25-4.25 4.25z"
]);
const $76e5a570f6bfc30c$export$951f48b153526477 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneMultipleSettings24Filled', "24", [
    "M3.28 2.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.58-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM6.5 8c-.8 0-1.45-.67-1.45-1.5S5.7 5 6.5 5s1.45.67 1.45 1.5S7.3 8 6.5 8M13 6.5a6.5 6.5 0 0 1-7 6.48v4.27c0 1.24 1 2.25 2.25 2.25h5.5c1.24 0 2.25-1 2.25-2.25v-13C16 3.01 15 2 13.75 2h-2.56A6.5 6.5 0 0 1 13 6.5m-4 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m-.37 4.25c.3.87 1.14 1.5 2.12 1.5h3.5c2.35 0 4.25-1.9 4.25-4.25v-11c0-.98-.63-1.81-1.5-2.12v13.12a2.75 2.75 0 0 1-2.75 2.75z"
]);
const $76e5a570f6bfc30c$export$e99c226bfdab5f28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneMultipleSettings24Regular', "24", [
    "M3.28 2.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.58-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM6.5 8c-.8 0-1.45-.67-1.45-1.5S5.7 5 6.5 5s1.45.67 1.45 1.5S7.3 8 6.5 8m1 4.92a7 7 0 0 1-1.5.06v4.27c0 1.24 1 2.25 2.25 2.25h5.5c1.24 0 2.25-1 2.25-2.25v-13C16 3.01 15 2 13.75 2h-2.56q.65.67 1.08 1.5h1.48c.41 0 .75.34.75.75v13c0 .41-.34.75-.75.75h-5.5a.75.75 0 0 1-.75-.75zm2.25 2.58a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm-1.12 5c.3.87 1.14 1.5 2.12 1.5h3.5c2.35 0 4.25-1.9 4.25-4.25v-11c0-.98-.63-1.81-1.5-2.12v13.12a2.75 2.75 0 0 1-2.75 2.75z"
]);
const $76e5a570f6bfc30c$export$10eecde479947887 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePageHeader20Filled', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v1H5zm0 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V6z"
]);
const $76e5a570f6bfc30c$export$a95bda0dfe1545ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePageHeader20Regular', "20", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 5h8v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $76e5a570f6bfc30c$export$bf43b8ba7e27eb44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePageHeader24Filled', "24", [
    "M18 6v13.75c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V6.01zm-2.25-4C16.99 2 18 3 18 4.25V5H6v-.75C6 3.01 7 2 8.25 2z"
]);
const $76e5a570f6bfc30c$export$1e87617e8ec6bb98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePageHeader24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm.75 3h-9v14.75c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75z"
]);
const $76e5a570f6bfc30c$export$d87f39f26b4672bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePagination20Filled', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm3 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"
]);
const $76e5a570f6bfc30c$export$cb3ee27aacf433d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePagination20Regular', "20", [
    "M8 15a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $76e5a570f6bfc30c$export$e5476b676883225c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePagination24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zM9.5 17.76a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m2.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m2.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $76e5a570f6bfc30c$export$b29d32c7233c7e3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePagination24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75M9.5 17.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m2.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m2.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $76e5a570f6bfc30c$export$4c8782043b9e7bae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePerson24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v7.09a3.5 3.5 0 0 0-.95 5.66h-.28A2.77 2.77 0 0 0 12 19.77v.1c0 .74.21 1.48.67 2.13H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-2.5 16h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5M20 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S13 21.44 13 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $76e5a570f6bfc30c$export$6873422884b6880e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePerson24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v7.09c-.62.3-1.15.77-1.5 1.36V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.8q.14.8.62 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-2.5 15.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zm8.75-3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S13 21.44 13 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $76e5a570f6bfc30c$export$bba320477800880c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneScreenTime20Filled', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52A5.5 5.5 0 0 1 14 9.02V3.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$7df6dbf1f686faa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneScreenTime20Regular', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a6 6 0 0 1-.66-1H5.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7q.49-.13 1-.18V3.5c0-.83-.67-1.5-1.5-1.5zM9 14.5q0 .26.02.5H7.5a.5.5 0 0 1 0-1h1.52zm10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$fc9b1d0abadf4538 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneScreenTime24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M13.75 2C14.99 2 16 3 16 4.25v6.92A6.5 6.5 0 0 0 11.02 18H8.75a.75.75 0 0 0-.1 1.5h2.66c.3.95.83 1.8 1.5 2.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm2.75 12a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H17v-3.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$b9cf190da4909d02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneScreenTime24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M13.75 2C14.99 2 16 3 16 4.25v6.92q-.8.2-1.5.56V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-5 15.5H11q0 .78.17 1.5H8.75a.75.75 0 0 1 0-1.5M16.5 14a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H17v-3.5a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$9d476079e3b11f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneShake20Filled', "20", [
    "M15.37 2.93a.5.5 0 1 1 .5-.86q.2.12.4.26a4.25 4.25 0 0 1 1.24 5.4.5.5 0 0 1-.89-.47 3.25 3.25 0 0 0-1.25-4.33m-1 1.74a.5.5 0 1 1 .5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 0 1-.9-.42c.27-.58.06-1.29-.5-1.61m-9.74 12.4a.5.5 0 1 1-.5.86l-.4-.26a4.25 4.25 0 0 1-1.24-5.4.5.5 0 1 1 .89.46 3.25 3.25 0 0 0 1.25 4.33m1-1.74a.5.5 0 1 1-.5.87 2.25 2.25 0 0 1-.92-2.9.5.5 0 0 1 .9.42c-.26.58-.05 1.28.52 1.61m4.54-12.26a1.95 1.95 0 0 1 2.4 1.4l2.37 8.97a2.04 2.04 0 0 1-1.42 2.48l-3.69 1a1.95 1.95 0 0 1-2.4-1.4L5.08 6.57a2.04 2.04 0 0 1 1.42-2.49zm-.49 11.3c.07.27.34.43.6.36l1.79-.48a.5.5 0 0 0 .36-.62.5.5 0 0 0-.6-.36l-1.78.49a.5.5 0 0 0-.37.62"
]);
const $76e5a570f6bfc30c$export$e96ccd2dca65609f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneShake20Regular', "20", [
    "M15.37 2.93a.5.5 0 1 1 .5-.86q.2.12.4.26a4.25 4.25 0 0 1 1.24 5.4.5.5 0 0 1-.89-.47 3.25 3.25 0 0 0-1.25-4.33m-1 1.74a.5.5 0 1 1 .5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 0 1-.9-.42c.27-.58.06-1.29-.5-1.61m-9.74 12.4a.5.5 0 1 1-.5.86l-.4-.26a4.25 4.25 0 0 1-1.24-5.4.5.5 0 1 1 .89.46 3.25 3.25 0 0 0 1.25 4.33m1-1.74a.5.5 0 1 1-.5.87 2.25 2.25 0 0 1-.92-2.9.5.5 0 0 1 .9.42c-.26.58-.05 1.28.52 1.61m5.97-10.6a.96.96 0 0 0-1.17-.7l-3.7 1.01c-.52.14-.84.7-.7 1.25l2.37 8.98c.14.53.67.83 1.18.7l3.68-1.01c.53-.15.85-.7.7-1.25zm-1.43-1.66a1.95 1.95 0 0 1 2.4 1.4l2.36 8.97a2.04 2.04 0 0 1-1.41 2.48l-3.69 1a1.95 1.95 0 0 1-2.4-1.4L5.07 6.57a2.04 2.04 0 0 1 1.41-2.49zm-.49 11.3a.5.5 0 0 1 .36-.61l1.79-.48c.26-.08.53.08.6.35s-.1.54-.36.62l-1.78.48a.5.5 0 0 1-.6-.35"
]);
const $76e5a570f6bfc30c$export$82060c6bda1e8bff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneShake24Filled', "24", [
    "M12.34 4.07c1.2-.32 2.43.39 2.76 1.6l2.75 10.28c.32 1.2-.39 2.43-1.59 2.76l-4.6 1.23c-1.2.32-2.43-.4-2.75-1.6L6.16 8.06A2.25 2.25 0 0 1 7.75 5.3zm2.35 11.2a.75.75 0 0 0-.92-.52l-1.93.52-.1.03a.75.75 0 0 0 .49 1.42l1.93-.52.1-.04a.75.75 0 0 0 .43-.88M18.68 2.4c.2-.36.65-.5 1.01-.3a4.9 4.9 0 0 1 1.72 6.49.75.75 0 0 1-1.33-.69l.05-.09q.06-.1.17-.4a3.4 3.4 0 0 0-1.32-3.99.75.75 0 0 1-.3-1.02M17.5 4.44a.75.75 0 0 1 1.05-.14 2.6 2.6 0 0 1 .9 1.32q.15.67-.02 1.29l-.05.18-.05.13a.75.75 0 0 1-1.42-.49l.05-.14.02-.06q.08-.28.02-.52a1 1 0 0 0-.17-.31l-.16-.18-.03-.03a.75.75 0 0 1-.14-1.05M2.54 15.41a.75.75 0 0 1 1.34.66l-.1.2-.1.28a3.5 3.5 0 0 0 .6 3.36q.4.48.68.65l.07.04a.75.75 0 1 1-.75 1.3 5.04 5.04 0 0 1-1.74-6.49m2.13 1.35a.75.75 0 0 1 1.42.47l-.05.15-.01.05q-.08.28-.02.53.05.15.17.31l.15.18.04.03a.75.75 0 0 1-.92 1.19 2.6 2.6 0 0 1-.89-1.33q-.15-.66.01-1.28l.06-.17z"
]);
const $76e5a570f6bfc30c$export$71127adde1dd45f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneShake24Regular', "24", [
    "M18.68 2.4c.2-.37.65-.5 1.01-.3a4.9 4.9 0 0 1 1.72 6.49.75.75 0 0 1-1.33-.7l.05-.09q.06-.1.17-.4a3.4 3.4 0 0 0-1.32-3.99.75.75 0 0 1-.3-1.02m-4 12.88a.75.75 0 0 0-.91-.53l-1.93.52-.1.03a.75.75 0 0 0 .49 1.42l1.93-.52.1-.04a.75.75 0 0 0 .43-.88m.42-9.62a2.25 2.25 0 0 0-2.76-1.59L7.74 5.3a2.25 2.25 0 0 0-1.58 2.76L8.9 18.34a2.25 2.25 0 0 0 2.76 1.6l4.6-1.23a2.25 2.25 0 0 0 1.58-2.76zm-2.37-.14c.4-.1.8.13.92.53l2.75 10.29c.11.4-.13.81-.53.92l-4.6 1.23a.75.75 0 0 1-.91-.53L7.6 7.67c-.1-.4.14-.81.54-.92zm5.82-1.22a.75.75 0 1 0-.9 1.2l.02.02.16.18q.12.16.17.31a1 1 0 0 1-.04.58l-.05.14a.75.75 0 0 0 1.42.49l.05-.13.05-.18q.17-.62.01-1.29a2.6 2.6 0 0 0-.9-1.32M2.54 15.41a.75.75 0 0 1 1.34.66l-.1.2-.1.28a3.5 3.5 0 0 0 .6 3.36q.4.48.68.65l.07.04a.75.75 0 1 1-.75 1.3 5.04 5.04 0 0 1-1.74-6.49m3.11.94a.75.75 0 0 0-.98.4l-.04.14-.06.17q-.17.63 0 1.28.13.45.4.83.28.35.48.5a.75.75 0 0 0 .92-1.2l-.04-.02q-.07-.06-.15-.18a1 1 0 0 1-.17-.31 1 1 0 0 1 .03-.58l.05-.15a.75.75 0 0 0-.44-.88"
]);
const $76e5a570f6bfc30c$export$361b0be4a4659dff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn16Filled', "16", [
    "M6 1a2 2 0 0 0-2 2v2.09q.31.1.56.35l2 2a1.5 1.5 0 0 1 0 2.12l-2 2a2 2 0 0 1-.56.35V13c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1.09a2 2 0 0 1-.56-.35l-2-2a1.5 1.5 0 0 1 0-2.12l2-2q.25-.24.56-.35V3a2 2 0 0 0-2-2zM3.15 6.85a.5.5 0 1 1 .7-.7l2 2a.5.5 0 0 1 0 .7l-2 2a.5.5 0 0 1-.7-.7L4.29 9H1.5a.5.5 0 0 1 0-1h2.8zm9.7-.7c.2.2.2.5 0 .7L11.71 8h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2c.2-.2.5-.2.7 0"
]);
const $76e5a570f6bfc30c$export$8156c67a1ec11b95 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn16Regular', "16", [
    "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2.09q-.31.1-.56.35l-.44.44V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2.88l-.44-.44A2 2 0 0 0 4 5.09zm7 8.12V13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1.88l-.44.44a2 2 0 0 1-.56.35V13c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1.09a2 2 0 0 1-.56-.35zM3.15 6.85a.5.5 0 1 1 .7-.7l2 2a.5.5 0 0 1 0 .7l-2 2a.5.5 0 0 1-.7-.7L4.29 9H1.5a.5.5 0 0 1 0-1h2.8zm9.7-.7c.2.2.2.5 0 .7L11.71 8h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2c.2-.2.5-.2.7 0"
]);
const $76e5a570f6bfc30c$export$2a4fd252f770ae43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn20Filled', "20", [
    "M7 2a2 2 0 0 0-2 2v3.09a1.5 1.5 0 0 1 1.56.35l2 2a1.5 1.5 0 0 1 0 2.12l-2 2a1.5 1.5 0 0 1-1.56.35V16c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2.09a1.5 1.5 0 0 1-1.56-.35l-2-2a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 15 7.09V4a2 2 0 0 0-2-2zm7.85 6.15c.2.2.2.5 0 .7L13.71 10h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2c.2-.2.5-.2.7 0m-9.7.7a.5.5 0 1 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L6.29 11H3.5a.5.5 0 0 1 0-1h2.8z"
]);
const $76e5a570f6bfc30c$export$bc6a40af4ecc267b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn20Regular', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v3.09a1.5 1.5 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.09a1.5 1.5 0 0 0-1 0zm0 9.91V16c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2.09a1.5 1.5 0 0 1-1 0V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2.09a1.5 1.5 0 0 1-1 0m2.85-3.06-2 2a.5.5 0 0 1-.7-.7L6.29 11H3.5a.5.5 0 0 1 0-1h2.8L5.14 8.85a.5.5 0 1 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35m6.3-2.7-2 2a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 11h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7"
]);
const $76e5a570f6bfc30c$export$18b88351a5b3d28c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn24Filled', "24", [
    "M15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.67c-.65-.31-1.45-.2-1.99.34l-2.18 2.22c-.52.31-.83.9-.83 1.52v.16c.05.46.26.88.6 1.18l.1.1 2.31 2.3.14.12a1.8 1.8 0 0 0 1.85.22v3.67c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.68c.59.28 1.27.22 1.8-.16l.13-.12 2.36-2.35.12-.1c.37-.33.59-.82.59-1.34v-.16a1.8 1.8 0 0 0-.6-1.18l-.1-.1-2.31-2.3A1.75 1.75 0 0 0 6 7.92V4.25c0-1.2.93-2.17 2.1-2.24L8.25 2zm2.03 6.97c.27.27.3.68.07.98l-.07.08-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74h-3.87l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.37-2.37A.8.8 0 0 1 14 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0M7.2 8.9l.08.07 2.37 2.37c.2.12.35.37.35.66q0 .39-.28.61l-.07.05-2.37 2.37-.08.07c-.27.2-.62.2-.89.01l-.1-.08-.06-.08a.75.75 0 0 1-.01-.89l.08-.09 1.22-1.22H3.56C3.26 12.68 3 12.37 3 12s.25-.7.57-.74l.09-.01h3.78l-1.22-1.22-.07-.09A.75.75 0 0 1 7.2 8.9"
]);
const $76e5a570f6bfc30c$export$5294688ea8a9d6c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn24Regular', "24", [
    "M6 16.07c.48.23 1.03.23 1.5.01v3.67c0 .38.28.7.65.74l.1.01h7.5c.38 0 .7-.28.74-.65l.01-.1v-3.68c.5.23 1.04.23 1.5.01v3.67c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75zm11.78-7.1c.27.27.3.68.07.98l-.07.08-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74h-3.87l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.37-2.37A.8.8 0 0 1 14 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0M7.2 8.9l.08.07 2.37 2.37c.2.12.35.37.35.66q0 .39-.28.61l-.07.05-2.37 2.37-.08.07c-.27.2-.62.2-.89.01l-.1-.08-.06-.08a.75.75 0 0 1-.01-.89l.08-.09 1.22-1.22H3.56C3.26 12.68 3 12.37 3 12s.25-.7.57-.74l.09-.01h3.78l-1.22-1.22-.07-.09A.75.75 0 0 1 7.2 8.9M15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.67a1.8 1.8 0 0 0-1.5 0V4.25c0-.38-.28-.7-.65-.74l-.1-.01h-7.5c-.38 0-.7.28-.74.65l-.01.1v3.67a1.8 1.8 0 0 0-1.5 0V4.25c0-1.2.93-2.17 2.1-2.24L8.25 2z"
]);
const $76e5a570f6bfc30c$export$49f29368e5ea4313 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn28Filled', "28", [
    "M8.75 2A2.75 2.75 0 0 0 6 4.75v5.13c.87-.59 2.07-.5 2.84.28l3 3c.88.88.88 2.3 0 3.18l-3 3c-.77.77-1.97.87-2.84.28v3.63A2.75 2.75 0 0 0 8.75 26h10.5A2.75 2.75 0 0 0 22 23.25v-3.63c-.87.59-2.07.5-2.84-.28l-3-3a2.25 2.25 0 0 1 0-3.18l3-3A2.25 2.25 0 0 1 22 9.88V4.75A2.75 2.75 0 0 0 19.25 2zM6.72 12.28 8.44 14H3.75a.75.75 0 0 0 0 1.5h4.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06m14.56 0L19.56 14h4.69a.75.75 0 0 1 0 1.5h-4.69l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 1 1 1.06 1.06"
]);
const $76e5a570f6bfc30c$export$4155177f4140306 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanIn28Regular', "28", [
    "M8.75 2A2.75 2.75 0 0 0 6 4.75v5.13c.45-.3.98-.42 1.5-.37V4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v4.76c.52-.05 1.05.07 1.5.37V4.75A2.75 2.75 0 0 0 19.25 2zM25 14.75a.75.75 0 0 0-.75-.75h-4.69l1.72-1.72a.75.75 0 1 0-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h4.69c.41 0 .75-.34.75-.75m-3 4.87c-.45.3-.98.42-1.5.37v3.26c0 .69-.56 1.25-1.25 1.25H8.75c-.69 0-1.25-.56-1.25-1.25v-3.26a2.3 2.3 0 0 1-1.5-.37v3.63A2.75 2.75 0 0 0 8.75 26h10.5A2.75 2.75 0 0 0 22 23.25zM7.5 11.04a.75.75 0 0 0-.78 1.24L8.44 14H3.75a.75.75 0 0 0 0 1.5h4.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3c.3-.3.3-.77 0-1.06l-3-3a1 1 0 0 0-.28-.18"
]);
const $76e5a570f6bfc30c$export$daf8f1396a22343f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut16Filled', "16", [
    "M6 1a2 2 0 0 0-2 2v2.09A1.5 1.5 0 0 1 4.91 7h.59a1.5 1.5 0 1 1 0 3h-.59A1.5 1.5 0 0 1 4 11.91V13c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-.91-1.91h-.59a1.5 1.5 0 1 1 0-3h.59A1.5 1.5 0 0 1 12 5.09V3a2 2 0 0 0-2-2zm4.5 7h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2a.5.5 0 0 1-.71-.7L13.29 9H10.5a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5m-5 1 .1-.01A.5.5 0 0 0 5.5 8H2.7l1.15-1.15a.5.5 0 1 0-.7-.7l-2 2A.5.5 0 0 0 1 8.5a.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L2.71 9z"
]);
const $76e5a570f6bfc30c$export$5a3a47b9223b1456 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut16Regular', "16", [
    "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2.09a1.5 1.5 0 0 0-1 1.41V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3.5a1.5 1.5 0 0 0-1-1.41zm7 7.5V13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2.5a1.5 1.5 0 0 1-1 1.41V13c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1-1.41M1.15 8.15l2-2a.5.5 0 1 1 .7.7L2.71 8H5.5a.5.5 0 0 1 0 1H2.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2A.5.5 0 0 1 1 8.5a.5.5 0 0 1 .14-.35m11.7 2.7 2-2A.5.5 0 0 0 15 8.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L13.29 8H10.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7"
]);
const $76e5a570f6bfc30c$export$2421ba8cd3db4203 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut20Filled', "20", [
    "M7 2a2 2 0 0 0-2 2v3.09A1.5 1.5 0 0 1 6.91 9h.59a1.5 1.5 0 1 1 0 3h-.59A1.5 1.5 0 0 1 5 13.91V16c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2.09A1.5 1.5 0 0 1 13.09 12h-.59a1.5 1.5 0 0 1 0-3h.59A1.5 1.5 0 0 1 15 7.09V4a2 2 0 0 0-2-2zm7.85 6.15a.5.5 0 0 0-.7.7L15.29 10H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM4.71 10l1.14-1.15h.01a.5.5 0 0 0-.71-.7l-2 2a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L4.71 11H7.5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$e85861727e695493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut20Regular', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v3.09a1.5 1.5 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.09a1.5 1.5 0 0 0-1 0zm0 9.91q.5.18 1 0V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.09q.5.18 1 0V16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm-1.85-3.76 2-2a.5.5 0 1 1 .7.7L4.71 10H7.5a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2A.5.5 0 0 1 3 10.5a.5.5 0 0 1 .14-.35m11.7 2.7 2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 10H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7"
]);
const $76e5a570f6bfc30c$export$b0ac99799625628 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut24Filled', "24", [
    "M15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.52a1.8 1.8 0 0 0-1.49.5A1.7 1.7 0 0 0 16.1 10l.05.16.04.09h-1.52c-.85 0-1.5.65-1.64 1.46l-.01.14L13 12c0 .8.51 1.51 1.33 1.7l.16.04h1.68l-.02.04c-.2.47-.2 1.02.05 1.51l.1.17.09.14.12.14c.4.4.95.57 1.49.48v3.53c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.53c.54.09 1.09-.08 1.49-.48l.12-.14.1-.14c.33-.54.37-1.16.14-1.68l-.02-.03h1.51l.17-.01c.91-.14 1.49-.9 1.49-1.74v-.15a1.7 1.7 0 0 0-1.66-1.6H7.82l.04-.1A1.74 1.74 0 0 0 6 7.78V4.25c0-1.2.93-2.17 2.1-2.24L8.25 2zM6.78 8.97c.27.26.3.68.07.97l-.07.09-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74H5.56l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.37-2.37A.8.8 0 0 1 3 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0m10.44 0a.75.75 0 0 1 .98-.08l.08.08 2.37 2.36c.2.13.35.38.35.67q0 .39-.28.6l-.07.06-2.37 2.37-.08.07c-.27.2-.62.2-.89 0l-.1-.07-.06-.09a.75.75 0 0 1-.01-.88l.08-.1 1.22-1.21h-3.78l-.1-.01c-.31-.05-.56-.37-.56-.74 0-.38.25-.7.57-.75h3.87l-1.22-1.22-.07-.09a.75.75 0 0 1 .07-.97"
]);
const $76e5a570f6bfc30c$export$d5b369969f406d1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut24Regular', "24", [
    "m16.5 15.72.01.02c.4.4.95.57 1.49.48v3.53c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.53c.49.08.98-.05 1.36-.37l.14-.12v4.02c0 .38.28.7.65.74l.1.01h7.5c.38 0 .7-.28.74-.65l.01-.1zM6.78 8.97c.27.26.3.68.07.97l-.07.09-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74H5.56l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.37-2.37A.8.8 0 0 1 3 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0m10.44 0a.75.75 0 0 1 .98-.08l.08.08 2.37 2.36c.2.13.35.38.35.67q0 .39-.28.6l-.07.06-2.37 2.37-.08.07c-.27.2-.62.2-.89 0l-.1-.07-.06-.09a.75.75 0 0 1-.01-.88l.08-.1 1.22-1.21h-3.78l-.1-.01c-.31-.05-.56-.37-.56-.74 0-.38.25-.7.57-.75h3.87l-1.22-1.22-.07-.09a.75.75 0 0 1 .07-.97M15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.52c-.47-.07-.97.06-1.36.38l-.14.12V4.25c0-.38-.28-.7-.65-.74l-.1-.01h-7.5c-.38 0-.7.28-.74.65l-.01.1v4.02h-.01c-.4-.41-.96-.58-1.5-.5L6 4.25c0-1.2.93-2.17 2.1-2.24L8.25 2z"
]);
const $76e5a570f6bfc30c$export$fcade14f07865b6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut28Filled', "28", [
    "M8.75 2A2.75 2.75 0 0 0 6 4.75v4.88a2.25 2.25 0 0 1 2.87 2.87h1.38a2.25 2.25 0 0 1 0 4.5H8.87A2.25 2.25 0 0 1 6 19.87v3.38A2.75 2.75 0 0 0 8.75 26h10.5A2.75 2.75 0 0 0 22 23.25v-3.38A2.25 2.25 0 0 1 19.13 17h-1.38a2.25 2.25 0 0 1 0-4.5h1.38A2.25 2.25 0 0 1 22 9.63V4.75A2.75 2.75 0 0 0 19.25 2zM6.22 18.28l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06L5.56 14h4.69a.75.75 0 0 1 0 1.5H5.56l1.72 1.72a.75.75 0 1 1-1.06 1.06m15.56-7.06 3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72h-4.69a.75.75 0 0 1 0-1.5h4.69l-1.72-1.72a.75.75 0 1 1 1.06-1.06"
]);
const $76e5a570f6bfc30c$export$8d8f27ceb5737bc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOut28Regular', "28", [
    "M8.75 2A2.75 2.75 0 0 0 6 4.75v4.88a2.3 2.3 0 0 1 1.5 0V4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v4.88a2.3 2.3 0 0 1 1.5 0V4.75A2.75 2.75 0 0 0 19.25 2zm13.03 9.22a.75.75 0 1 0-1.06 1.06L22.44 14h-4.69a.75.75 0 0 0 0 1.5h4.69l-1.72 1.72a.75.75 0 0 0 0 1.06c.3.3.77.3 1.06 0l3-3c.3-.3.3-.77 0-1.06zm-1.28 8.65c.48.17 1.02.17 1.5 0v3.38A2.75 2.75 0 0 1 19.25 26H8.75A2.75 2.75 0 0 1 6 23.25v-3.38c.48.17 1.02.17 1.5 0v3.38c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25zM5.56 15.5h4.69a.75.75 0 0 0 0-1.5H5.56l1.72-1.72a.75.75 0 1 0-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 0 0 1.06-1.06z"
]);
const $76e5a570f6bfc30c$export$4ed5199d03f4886e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpeaker20Filled', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.99A1.5 1.5 0 0 1 9 16.5V15H8a.5.5 0 0 1 0-1h1.09c.2-.58.76-1 1.41-1h.38l1.56-1.56a1.5 1.5 0 0 1 1.56-.35V3.5c0-.83-.67-1.5-1.5-1.5zm8.2 10.04q.29.14.3.46v6a.5.5 0 0 1-.85.35L11.29 17h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.95.16q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 0 1 .8-.6m-1.43 1.77q-.16-.46-.27-.7a.5.5 0 1 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22q0-.76-.28-1.53"
]);
const $76e5a570f6bfc30c$export$2ed4d5bea1bf7df6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpeaker20Regular', "20", [
    "M8 14a.5.5 0 0 0 0 1h1v-.5q0-.26.09-.5zm-2 3h3.09c.2.58.75 1 1.4 1H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v7.09a1.5 1.5 0 0 0-1 0V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m7.7-4.96q.29.14.3.46v6a.5.5 0 0 1-.85.35L11.29 17h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.95.16q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 0 1 .8-.6m-1.43 1.77q-.16-.46-.27-.7a.5.5 0 1 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22q0-.76-.28-1.53"
]);
const $76e5a570f6bfc30c$export$ecd78834278efdee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpeaker24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v8.67q-.57.08-1.03.54L13.53 15H12a1 1 0 0 0-1 1v2H8.75a.75.75 0 0 0 0 1.5h2.38c.18.3.5.5.87.5h1.53l1.44 1.54.06.06q-.55.39-1.28.4h-7.5C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm8.4 12.3a5 5 0 0 0-.92-1.13.75.75 0 1 0-.96 1.16q.21.15.59.74c.4.67.64 1.48.64 2.43q-.02 1.42-.64 2.43-.38.59-.59.74a.75.75 0 1 0 .96 1.16c.25-.21.59-.58.91-1.13.54-.9.86-1.96.86-3.2s-.32-2.3-.86-3.2m-2.28 1.1q-.36-.53-.67-.75a.75.75 0 0 0-.9 1.2q.1.07.33.38.36.52.37 1.27a2.2 2.2 0 0 1-.7 1.65l-.08.07a.75.75 0 0 0 .98 1.13q.3-.21.67-.75.62-.88.63-2.1-.02-1.22-.63-2.1M17 14.75a.75.75 0 0 0-1.31-.5L14.16 16h-1.41a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h1.41l1.53 1.74a.75.75 0 0 0 1.31-.49z"
]);
const $76e5a570f6bfc30c$export$4c317f127a6a8754 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpeaker24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v8.67q-.57.08-1.03.54l-.47.5V4.26a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5q.12 0 .22-.03l1 1.07.06.06q-.55.39-1.28.4h-7.5C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-5 15.5H11V19H8.75a.75.75 0 0 1 0-1.5m13.4-3.2a5 5 0 0 0-.92-1.13.75.75 0 1 0-.96 1.16q.21.15.59.74c.4.67.64 1.48.64 2.43q-.02 1.42-.64 2.43-.38.59-.59.74a.75.75 0 1 0 .96 1.16c.25-.21.59-.58.91-1.13.54-.9.86-1.96.86-3.2s-.32-2.3-.86-3.2m-2.28 1.1q-.36-.53-.67-.75a.75.75 0 0 0-.9 1.2q.1.07.33.38.36.52.37 1.27a2.2 2.2 0 0 1-.7 1.65l-.08.07a.75.75 0 0 0 .98 1.13q.3-.21.67-.75.62-.88.63-2.1-.02-1.22-.63-2.1M17 14.75a.75.75 0 0 0-1.31-.5L14.16 16h-1.41a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h1.41l1.53 1.74a.75.75 0 0 0 1.31-.49z"
]);
const $76e5a570f6bfc30c$export$9ce4e3b605045e0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneStatusBar20Filled', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2.5 0a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$7d690bc8cfa5d468 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneStatusBar20Regular', "20", [
    "M7.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $76e5a570f6bfc30c$export$992544af1c13dde9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneStatusBar24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-1 2.5h-5.5a.75.75 0 0 0-.1 1.5h5.6a.75.75 0 0 0 .1-1.5z"
]);
const $76e5a570f6bfc30c$export$3cd286fb31f0337d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneStatusBar24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75m-1 1a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$c51950847fa05b0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSubtract24Filled', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v6.92a6.5 6.5 0 0 0-5 6.33H8.75a.75.75 0 0 0 0 1.5h2.42a6.5 6.5 0 0 0 1.64 3H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm3.75 10a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3.1 5a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01h6.1a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01h-6.1"
]);
const $76e5a570f6bfc30c$export$1718cf15216d4a6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSubtract24Regular', "24", [
    "M13.75 2C14.99 2 16 3 16 4.25v6.92q-.8.2-1.5.56V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-5 15.5H11q0 .78.17 1.5H8.75a.75.75 0 0 1 0-1.5M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1z"
]);
const $76e5a570f6bfc30c$export$541b39ac1349b563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneTablet20Filled', "20", [
    "M4 4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-2h2.5a.5.5 0 0 0 0-1H10V8a2 2 0 0 0-2-2H4zM3.5 7C2.67 7 2 7.67 2 8.5v8c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-8C9 7.67 8.33 7 7.5 7zm1 8.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5"
]);
const $76e5a570f6bfc30c$export$f14d2466bd20396d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneTablet20Regular', "20", [
    "M5.84 4a.83.83 0 0 0-.84.8V6H4V4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-1h6.16c.48 0 .84-.37.84-.8V4.8c0-.43-.36-.8-.84-.8zM10 12h2.5a.5.5 0 0 0 0-1H10zm-5 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5zM3.5 8a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$ae92feecc5235452 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneTablet24Filled', "24", [
    "M8.25 7C9.22 7 10 7.78 10 8.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 20 2 19.22 2 18.25v-9.5C2 7.78 2.78 7 3.75 7zm-2 9.5h-.6a.75.75 0 0 0 0 1.49h.7a.75.75 0 0 0 0-1.49zM19.75 4c1.19 0 2.16.93 2.24 2.1v8.65c0 1.2-.92 2.17-2.09 2.24l-.15.01H11V8.5A2.5 2.5 0 0 0 8.66 6H6.01A2.25 2.25 0 0 1 8.1 4h11.66m-4.5 9.5h-2.5a.75.75 0 0 0-.1 1.5h2.6a.75.75 0 0 0 .1-1.5z"
]);
const $76e5a570f6bfc30c$export$1c7fee772f062f3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneTablet24Regular', "24", [
    "M8.25 7C9.22 7 10 7.78 10 8.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 20 2 19.22 2 18.25v-9.5C2 7.78 2.78 7 3.75 7zm0 1.5h-4.5a.25.25 0 0 0-.25.25v9.5c0 .14.11.25.25.25h4.5q.23-.02.25-.25v-9.5a.25.25 0 0 0-.25-.25m-2 7.5a.75.75 0 0 1 .1 1.5h-.6a.75.75 0 0 1-.1-1.5h.6m13.5-12c1.19 0 2.16.93 2.24 2.1v8.65c0 1.2-.92 2.17-2.09 2.24l-.15.01H11v-1.5h8.75c.38 0 .7-.28.74-.65v-8.6c0-.38-.27-.7-.64-.74l-.1-.01H8.25c-.33 0-.6.2-.7.5H6A2.25 2.25 0 0 1 8.1 4h11.66m-4.5 9a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5z"
]);
const $76e5a570f6bfc30c$export$2b9bb6e94300d717 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdate20Filled', "20", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zm5.5 3a.5.5 0 0 0-1 0v5.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7l-1.15 1.14z"
]);
const $76e5a570f6bfc30c$export$888855d2c1006f9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdate20Regular', "20", [
    "M10 6c.28 0 .5.22.5.5v5.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2A.5.5 0 0 1 10 14a.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V6.5c0-.28.22-.5.5-.5M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zM6.5 3a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$489f2b12c74bebc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdate24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zM12 7.03h-.1l-.1.03a.8.8 0 0 0-.54.6l-.01.12v6.71l-.96-.96-.09-.07a.75.75 0 0 0-1.04 1.05l.07.08 2.24 2.24.05.05.06.04.07.05.12.05.1.02.08.01h.1l.09-.01.06-.01.1-.04.06-.03.07-.04.06-.05.04-.04 2.24-2.24.07-.08c.2-.26.2-.62.01-.89l-.08-.09-.08-.07a.75.75 0 0 0-.88 0l-.1.07-.96.96V7.68a.75.75 0 0 0-.65-.64z"
]);
const $76e5a570f6bfc30c$export$caf83c6ec45f0cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdate24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75M12 7.03c.38 0 .7.28.74.65l.01.1v6.71l.96-.96a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08-2.24 2.24-.04.04-.06.05-.07.04-.06.03-.1.04-.06.01-.1.01h-.09l-.09-.01-.1-.02-.1-.05-.08-.05-.11-.09-2.24-2.24a.75.75 0 0 1 .97-1.13l.09.07.96.96V7.8c0-.35.23-.64.55-.73l.1-.02z"
]);
const $76e5a570f6bfc30c$export$77af043f7e3fd575 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateCheckmark20Filled', "20", [
    "M5 16c0 1.1.9 2 2 2h3.26a5.5 5.5 0 0 1-.76-5.8v-5L8.35 8.36a.5.5 0 1 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L10.5 7.21v3.52a5.5 5.5 0 0 1 4.5-1.7V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2zm14-1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$9f9d285c44ec13c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateCheckmark20Regular', "20", [
    "M6 16a1 1 0 0 0 1 1h2.6q.27.54.66 1H7a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5.02a6 6 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3.5-3.8q.39-.82 1-1.47V7.2l1.15 1.14a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L9.5 7.21zm9.5 2.3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$749f72829ec5fa18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateCheckmark24Filled', "24", [
    "M8.25 22h4.56a6.5 6.5 0 0 1-1.56-6.3V9.5l-.96.97-.09.07A.75.75 0 0 1 9.16 9.5l.07-.08 2.24-2.24.05-.05.06-.04.07-.05.12-.05.1-.02.08-.01h.1l.09.01.06.01.1.04.06.03.07.04.06.05.04.04 2.24 2.24.07.08c.2.26.2.62.01.89l-.08.09-.08.07c-.26.2-.62.2-.88 0l-.1-.07-.96-.96v3.55A6.5 6.5 0 0 1 18 11.02V4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$a04008c6988f33c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateCheckmark24Regular', "24", [
    "M8.25 22h4.56a7 7 0 0 1-1.08-1.5H8.25a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v6.83a7 7 0 0 1 1.5-.06V4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22m3-6.3q.44-1.52 1.5-2.64V9.51l.96.96c.27.27.68.29.98.07l.08-.07a.75.75 0 0 0 .07-.98l-.07-.08-2.24-2.24-.04-.04-.06-.05-.07-.04-.06-.03-.1-.04-.06-.01-.1-.01h-.09l-.09.01-.1.02-.1.05-.08.05-.11.09L9.23 9.4a.75.75 0 0 0 .97 1.13l.09-.07.96-.96zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $76e5a570f6bfc30c$export$f13764789e073d20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVerticalScroll20Filled', "20", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zm7.35 5.35a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L10 7.21l1.65 1.64c.2.2.5.2.7 0m-4.7 2.3a.5.5 0 0 0 0 .7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L10 12.79l-1.65-1.64a.5.5 0 0 0-.7 0"
]);
const $76e5a570f6bfc30c$export$75bc64add3f02ff5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVerticalScroll20Regular', "20", [
    "M7.65 11.15c.2-.2.5-.2.7 0L10 12.79l1.65-1.64a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7m4-2.3a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L10 7.21zM5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zM6.5 3a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $76e5a570f6bfc30c$export$705463334b4d4d98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVerticalScroll24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-2.04 11.48L12 15.22l-1.72-1.75a.75.75 0 0 0-1.07 1.06l2.25 2.3c.3.3.78.3 1.08 0l2.25-2.3a.75.75 0 1 0-1.08-1.05m1.08-3.96-2.25-2.3a.75.75 0 0 0-1-.07l-.08.07-2.25 2.3a.75.75 0 0 0 .99 1.12l.08-.07L12 8.82l1.71 1.75a.75.75 0 0 0 1.15-.96zl-2.25-2.3z"
]);
const $76e5a570f6bfc30c$export$665331d06b1970c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVerticalScroll24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75m-.97 9.96c.26.27.3.68.08.98l-.07.09-2.25 2.3c-.27.26-.7.29-1 .07l-.08-.08-2.25-2.3a.75.75 0 0 1 .99-1.12l.08.07L12 15.22l1.71-1.75c.3-.3.77-.3 1.06 0m-2.24-6.23 2.25 2.3a.75.75 0 1 1-1.08 1.04L12 8.82l-1.72 1.75a.75.75 0 0 1-1.07-1.05l2.25-2.3c.3-.3.78-.3 1.08 0"
]);
const $76e5a570f6bfc30c$export$f762d27974603958 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVibrate20Filled', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm3.5 10.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM2.92 7.22a.5.5 0 0 0-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 1 0 .84-.56l-.38-.57a1.4 1.4 0 0 1-.1-1.43c.4-.78.34-1.7-.14-2.43zm13.3-.14a.5.5 0 0 1 .7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 1 1-.84.56l-.38-.57a2.4 2.4 0 0 1-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 0 1 .14-.7"
]);
const $76e5a570f6bfc30c$export$3bb0ddd03208b6ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVibrate20Regular', "20", [
    "M8.5 14.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM2.92 7.22a.5.5 0 0 0-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 1 0 .84-.56l-.38-.57a1.4 1.4 0 0 1-.1-1.43c.4-.78.34-1.7-.14-2.43zm13.3-.14a.5.5 0 0 1 .7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 1 1-.84.56l-.38-.57a2.4 2.4 0 0 1-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 0 1 .14-.7"
]);
const $76e5a570f6bfc30c$export$4e1939b1f2e7dfc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVibrate24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-2.5 16h-2.5a.75.75 0 0 0-.1 1.5h2.6a.75.75 0 0 0 0-1.5m6.88-10.43a1 1 0 0 1 1.25.45l.05.1L22 9.6a3 3 0 0 1-.27 2.74l-.12.17-.15.2a1 1 0 0 0-.17.85l.04.12.59 1.46a1 1 0 0 1-1.81.85l-.05-.1-.58-1.47a3 3 0 0 1 .26-2.74l.12-.17.15-.2a1 1 0 0 0 .17-.85l-.04-.12-.58-1.46a1 1 0 0 1 .56-1.3m-17.5 0a1 1 0 0 1 1.25.45l.05.1.58 1.47a3 3 0 0 1-.27 2.74l-.12.17-.15.2a1 1 0 0 0-.17.85l.04.12.59 1.46a1 1 0 0 1-1.81.85l-.05-.1L2 14.4a3 3 0 0 1 .26-2.74l.12-.17.15-.2a1 1 0 0 0 .17-.85l-.04-.12-.58-1.46a1 1 0 0 1 .56-1.3"
]);
const $76e5a570f6bfc30c$export$dca8e7a5c5b9eebd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVibrate24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.33.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75m-2.5 14a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zm7.4-9.37.05.1.58 1.45c.33.83.24 1.77-.25 2.51l-.1.16-.16.2c-.23.31-.3.7-.2 1.08l.04.14.59 1.45a.75.75 0 0 1-1.35.65l-.05-.1-.58-1.45a2.8 2.8 0 0 1 .24-2.51l.11-.16.15-.2c.24-.31.31-.7.21-1.08l-.04-.14-.59-1.45a.75.75 0 0 1 1.29-.74zm-16.5 0 .05.1.58 1.45c.33.83.24 1.77-.25 2.51l-.1.16-.16.2c-.23.31-.3.7-.2 1.08l.04.14.59 1.45a.75.75 0 0 1-1.35.65l-.05-.1-.58-1.45a2.8 2.8 0 0 1 .24-2.51l.11-.16.15-.2c.24-.31.31-.7.21-1.08l-.04-.14-.59-1.45a.75.75 0 0 1 1.29-.74z"
]);
const $76e5a570f6bfc30c$export$cd0d0857a30f31fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhotoFilter20Filled', "20", [
    "M6.26 13.74a6 6 0 1 1 7.48-7.48 6 6 0 1 1-7.48 7.48M3.5 8A4.5 4.5 0 0 0 6 12.03V12a6 6 0 0 1 6.03-6A4.5 4.5 0 0 0 3.5 8m4.47 6A4.5 4.5 0 1 0 14 7.97V8a6 6 0 0 1-6 6z"
]);
const $76e5a570f6bfc30c$export$cbc0e20fc0e62950 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhotoFilter20Regular', "20", [
    "M2 8a6 6 0 0 0 4.26 5.74 6 6 0 1 0 7.48-7.48A6 6 0 0 0 2 8m6-5a5 5 0 0 1 4.6 3.03L12 6a6 6 0 0 0-5.97 6.6A5 5 0 0 1 8 3m9 9a5 5 0 0 1-9.6 1.97L8 14a6 6 0 0 0 5.97-6.6A5 5 0 0 1 17 12"
]);
const $76e5a570f6bfc30c$export$6e5ff909dac4168a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhotoFilter24Filled', "24", [
    "M9.5 2a7.5 7.5 0 0 1 7.18 5.32 7.5 7.5 0 1 1-9.36 9.36A7.5 7.5 0 0 1 9.5 2M17 9.6v-.1A7.5 7.5 0 0 1 9.6 17 5.5 5.5 0 1 0 17 9.6M9.5 4A5.5 5.5 0 0 0 7 14.4v.1A7.5 7.5 0 0 1 14.4 7a5.5 5.5 0 0 0-4.9-3"
]);
const $76e5a570f6bfc30c$export$56f65c193139fa88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhotoFilter24Regular', "24", [
    "M9.5 2a7.5 7.5 0 0 1 7.18 5.32 7.5 7.5 0 1 1-9.36 9.36A7.5 7.5 0 0 1 9.5 2m7.49 7.04v.22l.01.24a7.5 7.5 0 0 1-7.96 7.49 6 6 0 1 0 7.95-7.95M9.5 3.5a6 6 0 0 0-2.49 11.46v-.22L7 14.5a7.5 7.5 0 0 1 7.96-7.49A6 6 0 0 0 9.5 3.5"
]);
const $76e5a570f6bfc30c$export$b0d61eaf95feccf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Power20Filled', "20", [
    "M10.75 2.5a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zm3 1.5a.75.75 0 1 0-.76 1.3A6 6 0 1 1 7 5.3.75.75 0 1 0 6.25 4a7.5 7.5 0 1 0 7.5 0"
]);
const $76e5a570f6bfc30c$export$c3b4d0fdd76bbfd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Power20Regular', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zM13.74 4a.5.5 0 1 0-.5.87 6.5 6.5 0 1 1-6.49 0 .5.5 0 1 0-.5-.87 7.5 7.5 0 1 0 7.5 0"
]);
const $76e5a570f6bfc30c$export$ce542bd04da1fd1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Power24Filled', "24", [
    "M8.2 4.84a1 1 0 0 1 .85 1.82 7 7 0 1 0 5.92 0 1 1 0 0 1 .84-1.8 9 9 0 1 1-7.6-.02M12 2a1 1 0 0 1 1 .88V10a1 1 0 0 1-2 .12V3a1 1 0 0 1 1-1"
]);
const $76e5a570f6bfc30c$export$dc38e233787a8c92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Power24Regular', "24", [
    "M8.2 4.82a.75.75 0 0 1 .64 1.36 7.51 7.51 0 1 0 6.34 0 .75.75 0 1 1 .63-1.35 9 9 0 1 1-7.6-.01M12 2.5c.38 0 .7.28.74.64v7.6a.75.75 0 0 1-1.48.1l-.01-.1v-7.5c0-.4.33-.74.75-.74"
]);
const $76e5a570f6bfc30c$export$7e8fd68e98db2c00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Power28Filled', "28", [
    "M15 3a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0zm-4.6 3.75a1 1 0 1 0-.8-1.83 11 11 0 1 0 8.8 0 1 1 0 0 0-.8 1.83 9 9 0 1 1-7.2 0"
]);
const $76e5a570f6bfc30c$export$63d768528f21aedb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Power28Regular', "28", [
    "M10.69 5.27a.75.75 0 0 1-.4.98 9.5 9.5 0 1 0 7.42 0 .75.75 0 0 1 .58-1.38 11 11 0 1 1-8.58 0c.38-.16.82.02.98.4M14 2c.41 0 .75.34.75.75v9.5a.75.75 0 0 1-1.5 0v-9.5c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$c0d9bef273651c4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCode20Filled', "20", [
    "M13 11h-2v2h2v2h-2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2v2h-2zM5 5h2v2H5zm0-2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5zM5 13h2v2H5zm0-2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5zM13 5h2v2h-2zm0-2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$e45f90405f6a30e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCode20Regular', "20", [
    "M11 15h2v2h-2zm4 0h2v2h-2zm-4-4h2v2h-2zm2 2h2v2h-2zm2-2h2v2h-2zM3 5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 1h2v2H5zm-2 8c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm0 1h2v2H5zm6-8c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 1h2v2h-2z"
]);
const $76e5a570f6bfc30c$export$b307f3bfb941a86d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCode24Filled', "24", [
    "M8 6H6v2h2zm-5-.5A2.5 2.5 0 0 1 5.5 3h3A2.5 2.5 0 0 1 11 5.5v3A2.5 2.5 0 0 1 8.5 11h-3A2.5 2.5 0 0 1 3 8.5zM5.5 5a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM6 16h2v2H6zm-3-.5A2.5 2.5 0 0 1 5.5 13h3a2.5 2.5 0 0 1 2.5 2.5v3A2.5 2.5 0 0 1 8.5 21h-3A2.5 2.5 0 0 1 3 18.5zm2.5-.5a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM18 6h-2v2h2zm-2.5-3A2.5 2.5 0 0 0 13 5.5v3a2.5 2.5 0 0 0 2.5 2.5h3A2.5 2.5 0 0 0 21 8.5v-3A2.5 2.5 0 0 0 18.5 3zM15 5.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM13 13h2.75v2.75H13zm5.25 2.75h-2.5v2.5H13V21h2.75v-2.75h2.5V21H21v-2.75h-2.75zm0 0V13H21v2.75z"
]);
const $76e5a570f6bfc30c$export$2c5bca9029056ab4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCode24Regular', "24", [
    "M8 6H6v2h2zm-5-.75C3 4.01 4 3 5.25 3h3.5C9.99 3 11 4 11 5.25v3.5C11 9.99 10 11 8.75 11h-3.5C4.01 11 3 10 3 8.75zm2.25-.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zM6 16h2v2H6zm-3-.75C3 14.01 4 13 5.25 13h3.5C9.99 13 11 14 11 15.25v3.5C11 19.99 10 21 8.75 21h-3.5C4.01 21 3 20 3 18.75zm2.25-.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zM18 6h-2v2h2zm-2.75-3C14.01 3 13 4 13 5.25v3.5C13 9.99 14 11 15.25 11h3.5C19.99 11 21 10 21 8.75v-3.5C21 4.01 20 3 18.75 3zm-.75 2.25c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75zM13 13h2.75v2.75H13zm5.25 2.75h-2.5v2.5H13V21h2.75v-2.75h2.5V21H21v-2.75h-2.75zm0 0V13H21v2.75z"
]);
const $76e5a570f6bfc30c$export$a16b8176b8a1ea0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCode28Filled', "28", [
    "M18.33 15v3.33h3.34v3.34H25V25h-3.33v-3.33h-3.34V25H15v-3.33h3.33v-3.34H15V15zm-7.83 0a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 3 22.5v-5A2.5 2.5 0 0 1 5.5 15zm0 2h-5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m-.75 1.25v3.5h-3.5v-3.5zM25 15v3.33h-3.33V15zM10.5 3A2.5 2.5 0 0 1 13 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 3 10.5v-5A2.5 2.5 0 0 1 5.5 3zm12 0A2.5 2.5 0 0 1 25 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-5a2.5 2.5 0 0 1-2.5-2.5v-5A2.5 2.5 0 0 1 17.5 3zm-12 2h-5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m12 0h-5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m-.75 1.25v3.5h-3.5v-3.5zm-12 0v3.5h-3.5v-3.5z"
]);
const $76e5a570f6bfc30c$export$b4578a621015a917 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCode28Regular', "28", [
    "M10.75 15c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C4.01 25 3 24 3 22.75v-5.5C3 16.01 4 15 5.25 15zm7.58 0v3.33h3.34v3.34h-3.34V25H15v-3.33h3.33v-3.34H15V15zM25 21.67V25h-3.33v-3.33zM10.75 16.5h-5.5a.75.75 0 0 0-.75.75v5.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 0 0-.75-.75m-1.25 2v3h-3v-3zM25 15v3.33h-3.33V15zM10.75 3C11.99 3 13 4 13 5.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C4.01 13 3 12 3 10.75v-5.5C3 4.01 4 3 5.25 3zm12 0C23.99 3 25 4 25 5.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C16.01 13 15 12 15 10.75v-5.5C15 4.01 16 3 17.25 3zm-12 1.5h-5.5a.75.75 0 0 0-.75.75v5.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 0 0-.75-.75m12 0h-5.5a.75.75 0 0 0-.75.75v5.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 0 0-.75-.75M9.5 6.5v3h-3v-3zm12 0v3h-3v-3z"
]);
const $76e5a570f6bfc30c$export$b072dffff220a5ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize16Filled', "16", [
    "M6.5 2h-2A2.5 2.5 0 0 0 2 4.5a.5.5 0 0 0 1 0C3 3.67 3.67 3 4.5 3h2a.5.5 0 0 0 0-1M2 11.5A2.5 2.5 0 0 0 4.5 14h3a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 7.5 6h-3A2.5 2.5 0 0 0 2 8.5zm9.5 2.5a.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5M14 6.5a.5.5 0 0 1-1 0v-2c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 14 4.5z"
]);
const $76e5a570f6bfc30c$export$66338d1ea0b3cee0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize16Regular', "16", [
    "M6.5 2h-2A2.5 2.5 0 0 0 2 4.5a.5.5 0 0 0 1 0C3 3.67 3.67 3 4.5 3h2a.5.5 0 0 0 0-1m-2 11h3c.83 0 1.5-.67 1.5-1.5v-3C9 7.67 8.33 7 7.5 7h-3C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5m0 1A2.5 2.5 0 0 1 2 11.5v-3A2.5 2.5 0 0 1 4.5 6h3A2.5 2.5 0 0 1 10 8.5v3A2.5 2.5 0 0 1 7.5 14zm7 0a.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5M14 6.5a.5.5 0 0 1-1 0v-2c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 14 4.5z"
]);
const $76e5a570f6bfc30c$export$675c61432f09cf39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize20Filled', "20", [
    "M8.5 3H6a3 3 0 0 0-3 3v.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1M3 14a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3zm10.5 3a.5.5 0 0 1 0-1h.5a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3zM17 8.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-2.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3z"
]);
const $76e5a570f6bfc30c$export$98d4e8d425216293 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize20Regular', "20", [
    "M8.5 3H6a3 3 0 0 0-3 3v.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1M5.8 15.99A2 2 0 0 1 4 14v-3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6zM3 14a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3zm10.5 3a.5.5 0 0 1 0-1h.5a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3zM17 8.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-2.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3z"
]);
const $76e5a570f6bfc30c$export$284fcc70398efe4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize24Filled', "24", [
    "M10.25 3h-4A3.25 3.25 0 0 0 3 6.25v2a.75.75 0 0 0 1.5 0v-2c0-.97.78-1.75 1.75-1.75h4a.75.75 0 0 0 0-1.5m.5 18c1.8 0 3.25-1.46 3.25-3.25v-4.5c0-1.8-1.46-3.25-3.25-3.25h-4.5A3.25 3.25 0 0 0 3 13.25v4.5C3 19.55 4.46 21 6.25 21zm5 0a.75.75 0 0 1 0-1.5h2c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25zM21 10.25v-4C21 4.45 19.54 3 17.75 3h-4a.75.75 0 0 0 0 1.5h4c.97 0 1.75.78 1.75 1.75v4a.75.75 0 0 0 1.5 0"
]);
const $76e5a570f6bfc30c$export$f32434f3acc60416 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize24Regular', "24", [
    "M10.25 3h-4A3.25 3.25 0 0 0 3 6.25v2a.75.75 0 0 0 1.5 0v-2c0-.97.78-1.75 1.75-1.75h4a.75.75 0 0 0 0-1.5M4.5 17.75v-4.5c0-.97.78-1.75 1.75-1.75h4.5c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75h-4.5c-.97 0-1.75-.78-1.75-1.75M10.75 21c1.8 0 3.25-1.46 3.25-3.25v-4.5c0-1.8-1.46-3.25-3.25-3.25h-4.5A3.25 3.25 0 0 0 3 13.25v4.5C3 19.55 4.46 21 6.25 21zm5 0a.75.75 0 0 1 0-1.5h2c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25zM21 10.25v-4C21 4.45 19.54 3 17.75 3h-4a.75.75 0 0 0 0 1.5h4c.97 0 1.75.78 1.75 1.75v4a.75.75 0 0 0 1.5 0"
]);
const $76e5a570f6bfc30c$export$642cfa9851a4d484 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize28Filled', "28", [
    "M11.75 3h-5A3.75 3.75 0 0 0 3 6.75v2a.75.75 0 0 0 1.5 0v-2c0-1.24 1-2.25 2.25-2.25h5a.75.75 0 0 0 0-1.5M3 21.25A3.75 3.75 0 0 0 6.75 25h6.5A3.75 3.75 0 0 0 17 21.25v-6.5A3.75 3.75 0 0 0 13.25 11h-6.5A3.75 3.75 0 0 0 3 14.75zM19.25 25a.75.75 0 0 1 0-1.5h2c1.24 0 2.25-1 2.25-2.25v-5a.75.75 0 0 1 1.5 0v5A3.75 3.75 0 0 1 21.25 25zM25 11.75a.75.75 0 0 1-1.5 0v-5c0-1.24-1-2.25-2.25-2.25h-5a.75.75 0 0 1 0-1.5h5A3.75 3.75 0 0 1 25 6.75z"
]);
const $76e5a570f6bfc30c$export$a0352fc3884f13cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize28Regular', "28", [
    "M11.75 3h-5A3.75 3.75 0 0 0 3 6.75v2a.75.75 0 0 0 1.5 0v-2c0-1.24 1-2.25 2.25-2.25h5a.75.75 0 0 0 0-1.5m-5 20.5c-1.24 0-2.25-1-2.25-2.25v-6.5c0-1.24 1-2.25 2.25-2.25h6.5c1.24 0 2.25 1 2.25 2.25v6.5c0 1.24-1 2.25-2.25 2.25zM3 21.25A3.75 3.75 0 0 0 6.75 25h6.5A3.75 3.75 0 0 0 17 21.25v-6.5A3.75 3.75 0 0 0 13.25 11h-6.5A3.75 3.75 0 0 0 3 14.75zM19.25 25a.75.75 0 0 1 0-1.5h2c1.24 0 2.25-1 2.25-2.25v-5a.75.75 0 0 1 1.5 0v5A3.75 3.75 0 0 1 21.25 25zM25 11.75a.75.75 0 0 1-1.5 0v-5c0-1.24-1-2.25-2.25-2.25h-5a.75.75 0 0 1 0-1.5h5A3.75 3.75 0 0 1 25 6.75z"
]);
const $76e5a570f6bfc30c$export$d4b7f18f9e605945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize32Filled', "32", [
    "M13 3H7.5A4.5 4.5 0 0 0 3 7.5V9a1 1 0 0 0 2 0V7.5A2.5 2.5 0 0 1 7.5 5H13a1 1 0 1 0 0-2m2.5 26a4.5 4.5 0 0 0 4.5-4.5v-8a4.5 4.5 0 0 0-4.5-4.5h-8A4.5 4.5 0 0 0 3 16.5v8A4.5 4.5 0 0 0 7.5 29zm6.5-1a1 1 0 0 1 1-1h1.5a2.5 2.5 0 0 0 2.5-2.5V19a1 1 0 1 1 2 0v5.5a4.5 4.5 0 0 1-4.5 4.5H23a1 1 0 0 1-1-1m7-15V7.5A4.5 4.5 0 0 0 24.5 3H19a1 1 0 1 0 0 2h5.5A2.5 2.5 0 0 1 27 7.5V13a1 1 0 1 0 2 0"
]);
const $76e5a570f6bfc30c$export$b4ec3d0310f11d1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize32Regular', "32", [
    "M13 3H7.5A4.5 4.5 0 0 0 3 7.5V9a1 1 0 0 0 2 0V7.5A2.5 2.5 0 0 1 7.5 5H13a1 1 0 1 0 0-2M5 24.5v-8A2.5 2.5 0 0 1 7.5 14h8a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 5 24.5M15.5 29a4.5 4.5 0 0 0 4.5-4.5v-8a4.5 4.5 0 0 0-4.5-4.5h-8A4.5 4.5 0 0 0 3 16.5v8A4.5 4.5 0 0 0 7.5 29zm6.5-1a1 1 0 0 1 1-1h1.5a2.5 2.5 0 0 0 2.5-2.5V19a1 1 0 1 1 2 0v5.5a4.5 4.5 0 0 1-4.5 4.5H23a1 1 0 0 1-1-1m7-15V7.5A4.5 4.5 0 0 0 24.5 3H19a1 1 0 1 0 0 2h5.5A2.5 2.5 0 0 1 27 7.5V13a1 1 0 1 0 2 0"
]);
const $76e5a570f6bfc30c$export$2c2df92678722662 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize48Filled', "48", [
    "M19.75 6a1.25 1.25 0 1 1 0 2.5h-7.5a3.75 3.75 0 0 0-3.75 3.75v2.5a1.25 1.25 0 1 1-2.5 0v-2.5C6 8.8 8.8 6 12.25 6zM6 25.25C6 21.8 8.8 19 12.25 19h10.5C26.2 19 29 21.8 29 25.25v10.5C29 39.2 26.2 42 22.75 42h-10.5A6.25 6.25 0 0 1 6 35.75zM33.25 42a1.25 1.25 0 1 1 0-2.5h2.5a3.75 3.75 0 0 0 3.75-3.75v-7.5a1.25 1.25 0 1 1 2.5 0v7.5C42 39.2 39.2 42 35.75 42zm-5-33.5a1.25 1.25 0 1 1 0-2.5h7.5C39.2 6 42 8.8 42 12.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5a3.75 3.75 0 0 0-3.75-3.75z"
]);
const $76e5a570f6bfc30c$export$58b17d29e780ec6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Resize48Regular', "48", [
    "M19.75 6a1.25 1.25 0 1 1 0 2.5h-7.5a3.75 3.75 0 0 0-3.75 3.75v2.5a1.25 1.25 0 1 1-2.5 0v-2.5C6 8.8 8.8 6 12.25 6zM6 25.25C6 21.8 8.8 19 12.25 19h10.5C26.2 19 29 21.8 29 25.25v10.5C29 39.2 26.2 42 22.75 42h-10.5A6.25 6.25 0 0 1 6 35.75zM22.75 39.5a3.75 3.75 0 0 0 3.75-3.75v-10.5a3.75 3.75 0 0 0-3.75-3.75h-10.5a3.75 3.75 0 0 0-3.75 3.75v10.5a3.75 3.75 0 0 0 3.75 3.75zm10.5 2.5a1.25 1.25 0 1 1 0-2.5h2.5a3.75 3.75 0 0 0 3.75-3.75v-7.5a1.25 1.25 0 1 1 2.5 0v7.5C42 39.2 39.2 42 35.75 42zm-5-33.5a1.25 1.25 0 1 1 0-2.5h7.5C39.2 6 42 8.8 42 12.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5a3.75 3.75 0 0 0-3.75-3.75z"
]);
const $76e5a570f6bfc30c$export$7cb8f455c860efc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeImage20Filled', "20", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2zM18 11.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25zM1 12.5A2.5 2.5 0 0 1 3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0L1.4 17.88q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $76e5a570f6bfc30c$export$884b6e3e624f747c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeImage20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zm6.5 9.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3zm-17 1A2.5 2.5 0 0 1 3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0L1.4 17.88q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $76e5a570f6bfc30c$export$3803388ec15b6091 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeImage24Filled', "24", [
    "M11 3a1 1 0 0 0-1-1H5.25A3.25 3.25 0 0 0 2 5.25V10a1 1 0 1 0 2 0V5.25C4 4.56 4.56 4 5.25 4H10a1 1 0 0 0 1-1m3-1a1 1 0 1 0 0 2h4.75c.69 0 1.25.56 1.25 1.25V10a1 1 0 1 0 2 0V5.25C22 3.45 20.54 2 18.75 2zm0 20a1 1 0 1 1 0-2h4.75c.69 0 1.25-.56 1.25-1.25V14a1 1 0 1 1 2 0v4.75c0 1.8-1.46 3.25-3.25 3.25zM4 12a3 3 0 0 0-3 3v5q0 .85.42 1.52l3.49-3.49c.88-.88 2.3-.88 3.18 0l3.5 3.5q.4-.68.41-1.53v-5a3 3 0 0 0-3-3zm0 11q-.85 0-1.52-.42l3.49-3.49c.3-.3.77-.3 1.06 0l3.5 3.5q-.68.4-1.53.41zm5-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$1ae1b7b070ff6c46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeImage24Regular', "24", [
    "M11 2.75a.75.75 0 0 0-.75-.75h-5A3.25 3.25 0 0 0 2 5.25v5a.75.75 0 0 0 1.5 0v-5c0-.97.78-1.75 1.75-1.75h5c.41 0 .75-.34.75-.75M13.75 2a.75.75 0 0 0 0 1.5h5c.97 0 1.75.78 1.75 1.75v5a.75.75 0 0 0 1.5 0v-5C22 3.45 20.54 2 18.75 2zm0 20a.75.75 0 0 1 0-1.5h5c.97 0 1.75-.78 1.75-1.75v-5a.75.75 0 0 1 1.5 0v5c0 1.8-1.46 3.25-3.25 3.25zM4 12a3 3 0 0 0-3 3v5q0 .85.42 1.52l3.49-3.49c.88-.88 2.3-.88 3.18 0l3.5 3.5q.4-.68.41-1.53v-5a3 3 0 0 0-3-3zm0 11q-.85 0-1.52-.42l3.49-3.49c.3-.3.77-.3 1.06 0l3.5 3.5q-.68.4-1.53.41zm5-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $76e5a570f6bfc30c$export$fb646e19ce0b6c4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLarge16Filled', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 4.5 2h1a.5.5 0 0 1 0 1zm1 1C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zm6-1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 11.5 2h-1a.5.5 0 0 0 0 1zm0 10c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-7 0A1.5 1.5 0 0 1 3 11.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 4.5 14h1.25a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$87350c37182849e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLarge16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 4.5 2h1a.5.5 0 0 1 0 1zM13 4.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 14 4.5v1a.5.5 0 0 1-1 0zm0 7c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0zm-10 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H4.5A2.5 2.5 0 0 1 2 11.5v-1.25a.5.5 0 0 1 1 0zM5.5 4C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM5 5.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$b86a3ea2a6b407c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLarge20Filled', "20", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zm1 1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm8-1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 14.5 3h-1a.5.5 0 0 0 0 1zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-9 0A1.5 1.5 0 0 1 4 14.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 5.5 17h1.25a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$a2e6158bdc57fcc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLarge20Regular', "20", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0zM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM6 6.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$ff7b54252af075de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLarge24Filled', "24", [
    "M4.5 6.25c0-.97.78-1.75 1.75-1.75h1.5a.75.75 0 0 0 0-1.5h-1.5A3.25 3.25 0 0 0 3 6.25v1.5a.75.75 0 0 0 1.5 0zM17.75 4.5c.97 0 1.75.78 1.75 1.75v1.5a.75.75 0 0 0 1.5 0v-1.5C21 4.45 19.54 3 17.75 3h-1.5a.75.75 0 0 0 0 1.5zm0 15c.97 0 1.75-.78 1.75-1.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 1.8-1.46 3.25-3.25 3.25h-1.5a.75.75 0 0 1 0-1.5zm-11.5 0c-.97 0-1.75-.78-1.75-1.75v-1.5a.75.75 0 0 0-1.5 0v1.5C3 19.55 4.46 21 6.25 21h1.5a.75.75 0 0 0 0-1.5zm2-13.5C7.01 6 6 7 6 8.25v7.5C6 16.99 7 18 8.25 18h7.5c1.24 0 2.25-1 2.25-2.25v-7.5C18 7.01 17 6 15.75 6z"
]);
const $76e5a570f6bfc30c$export$2ea7bafddd65c34c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLarge24Regular', "24", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v1.5a.75.75 0 0 1-1.5 0v-1.5C3 4.45 4.46 3 6.25 3h1.5a.75.75 0 0 1 0 1.5zM19.5 6.25c0-.97-.78-1.75-1.75-1.75h-1.5a.75.75 0 0 1 0-1.5h1.5C19.55 3 21 4.46 21 6.25v1.5a.75.75 0 0 1-1.5 0zm0 11.5c0 .97-.78 1.75-1.75 1.75h-1.5a.75.75 0 0 0 0 1.5h1.5c1.8 0 3.25-1.46 3.25-3.25v-1.5a.75.75 0 0 0-1.5 0zm-15 0c0 .97.78 1.75 1.75 1.75h1.5a.75.75 0 0 1 0 1.5h-1.5A3.25 3.25 0 0 1 3 17.75v-1.5a.75.75 0 0 1 1.5 0zM8.25 6C7.01 6 6 7 6 8.25v7.5C6 16.99 7 18 8.25 18h7.5c1.24 0 2.25-1 2.25-2.25v-7.5C18 7.01 17 6 15.75 6zM7.5 8.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v7.5c0 .41-.34.75-.75.75h-7.5a.75.75 0 0 1-.75-.75z"
]);
const $76e5a570f6bfc30c$export$70fa76620492afd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmall16Filled', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 4.5 2h1a.5.5 0 0 1 0 1zm3 3C6.67 6 6 6.67 6 7.5v1c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-1C10 6.67 9.33 6 8.5 6zm4-3c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 11.5 2h-1a.5.5 0 0 0 0 1zm0 10c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-7 0A1.5 1.5 0 0 1 3 11.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 4.5 14h1.25a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$4ece3e0ea6d3614b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmall16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 4.5 2h1a.5.5 0 0 1 0 1zM6 7.5C6 6.67 6.67 6 7.5 6h1c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 6 8.5zM7.5 7a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4-4c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 11.5 2h-1a.5.5 0 0 0 0 1zm0 10c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-7 0A1.5 1.5 0 0 1 3 11.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 4.5 14h1.25a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$5f3f1a064cf9b775 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmall20Filled', "20", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zm3 3C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zm6-3c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 14.5 3h-1a.5.5 0 0 0 0 1zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-9 0A1.5 1.5 0 0 1 4 14.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 5.5 17h1.25a.5.5 0 0 0 0-1z"
]);
const $76e5a570f6bfc30c$export$b075e0eae89333ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmall20Regular', "20", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0zM8.5 7C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM8 8.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
]);
const $76e5a570f6bfc30c$export$65c44e4c6ccdb691 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmall24Filled', "24", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v1.5a.75.75 0 0 1-1.5 0v-1.5C3 4.45 4.46 3 6.25 3h1.5a.75.75 0 0 1 0 1.5zM10.2 8c-1.24 0-2.25 1-2.25 2.25v3.5c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25v-3.5c0-1.24-1-2.25-2.25-2.25zm7.55-3.5c.97 0 1.75.78 1.75 1.75v1.5a.75.75 0 0 0 1.5 0v-1.5C21 4.45 19.54 3 17.75 3h-1.5a.75.75 0 0 0 0 1.5zm0 15c.97 0 1.75-.78 1.75-1.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 1.8-1.46 3.25-3.25 3.25h-1.5a.75.75 0 0 1 0-1.5zm-11.5 0c-.97 0-1.75-.78-1.75-1.75v-1.5a.75.75 0 0 0-1.5 0v1.5C3 19.55 4.46 21 6.25 21h1.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$d6e6684ac713f810 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmall24Regular', "24", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v1.5a.75.75 0 0 1-1.5 0v-1.5C3 4.45 4.46 3 6.25 3h1.5a.75.75 0 0 1 0 1.5zm1.7 5.75c0-1.24 1-2.25 2.25-2.25h3.5c1.24 0 2.25 1 2.25 2.25v3.5c0 1.24-1 2.25-2.25 2.25h-3.5c-1.24 0-2.25-1-2.25-2.25zm2.25-.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zm7.55-5c.97 0 1.75.78 1.75 1.75v1.5a.75.75 0 0 0 1.5 0v-1.5C21 4.45 19.54 3 17.75 3h-1.5a.75.75 0 0 0 0 1.5zm0 15c.97 0 1.75-.78 1.75-1.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 1.8-1.46 3.25-3.25 3.25h-1.5a.75.75 0 0 1 0-1.5zm-11.5 0c-.97 0-1.75-.78-1.75-1.75v-1.5a.75.75 0 0 0-1.5 0v1.5C3 19.55 4.46 21 6.25 21h1.5a.75.75 0 0 0 0-1.5z"
]);
const $76e5a570f6bfc30c$export$da6bd871210cb934 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeTable20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v2.35q.43-.49 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm10 16h-2.35q.49-.43.81-1H15a2 2 0 0 0 2-2v-3.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3M11.5 2a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zM5 7a3 3 0 0 0-3 3h3zm0 4v3H2v-3zm0 4H2a3 3 0 0 0 3 3zm1 0h3v3H6zm0-1h3v-3H6zm4 1h3a3 3 0 0 1-3 3zm0-4v3h3v-3zm0-1V7a3 3 0 0 1 3 3zM6 7h3v3H6z"
]);
const $76e5a570f6bfc30c$export$fac7ef0879041bdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeTable20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v2.35q.43-.49 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm10 16h-2.35q.49-.43.81-1H15a2 2 0 0 0 2-2v-3.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3M11.5 2a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zM5 7a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3zm-2 3c0-1.1.9-2 2-2v2zm3 0V8h3v2zm4 0V8a2 2 0 0 1 2 2zm-4 1h3v3H6zm4 0h2v3h-2zm-4 4h3v2H6zm6 0a2 2 0 0 1-2 2v-2zm-9-4h2v3H3zm0 4h2v2a2 2 0 0 1-2-2"
]);
const $76e5a570f6bfc30c$export$638c82b9a01e8055 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeTable24Filled', "24", [
    "M5.25 2h5a.75.75 0 0 1 0 1.5h-5c-.97 0-1.75.78-1.75 1.75v2.96q-.89.32-1.5.99V5.25C2 3.45 3.46 2 5.25 2m10.54 18.5q-.31.89-.99 1.5h3.95c1.8 0 3.25-1.46 3.25-3.25v-5a.75.75 0 0 0-1.5 0v5c0 .97-.78 1.75-1.75 1.75zm5.46-9.5c.41 0 .75-.34.75-.75v-5C22 3.45 20.54 2 18.75 2h-5a.75.75 0 0 0 0 1.5h5c.97 0 1.75.78 1.75 1.75v5c0 .41.34.75.75.75M7 9h3v3.5H7zm0 5h3v3.5H7zm4.5 0v3.5H15V14zM7 19h3v3H7zm4.5 0v3h.75A2.75 2.75 0 0 0 15 19.25V19zm0-10v3.5H15v-.75A2.75 2.75 0 0 0 12.25 9zm-6 0h-.75A2.75 2.75 0 0 0 2 11.75v.75h3.5zm0 5H2v3.5h3.5zm0 5H2v.25A2.75 2.75 0 0 0 4.75 22h.75z"
]);
const $76e5a570f6bfc30c$export$4c979a15f04569be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeTable24Regular', "24", [
    "M5.25 2h5a.75.75 0 0 1 0 1.5h-5c-.97 0-1.75.78-1.75 1.75v3.13q-.89.4-1.5 1.13V5.25C2 3.45 3.46 2 5.25 2m10.37 18.5q-.4.89-1.13 1.5h4.26c1.8 0 3.25-1.46 3.25-3.25v-5a.75.75 0 0 0-1.5 0v5c0 .97-.78 1.75-1.75 1.75zm5.63-9.5c.41 0 .75-.34.75-.75v-5C22 3.45 20.54 2 18.75 2h-5a.75.75 0 0 0 0 1.5h5c.97 0 1.75.78 1.75 1.75v5c0 .41.34.75.75.75m-16-2A3.25 3.25 0 0 0 2 12.25v6.5C2 20.55 3.46 22 5.25 22h6.5c1.8 0 3.25-1.46 3.25-3.25v-6.5C15 10.45 13.54 9 11.75 9zM3.5 12.25c0-.97.78-1.75 1.75-1.75H6V13H3.5zM6 14.5V17H3.5v-2.5zM7.5 17v-2.5h2V17zm3.5 0v-2.5h2.5V17zm-3.5 1.5h2v2h-2zm3.5 0h2.5v.25c0 .97-.78 1.75-1.75 1.75H11zm0-8h.75c.97 0 1.75.78 1.75 1.75V13H11zM9.5 13h-2v-2.5h2zM6 18.5v2h-.75c-.97 0-1.75-.78-1.75-1.75v-.25z"
]);
const $76e5a570f6bfc30c$export$5e6dff591b1c623c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeVideo20Filled', "20", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2zM18 11.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25zM3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4A2.5 2.5 0 0 1 7.5 19h-4A2.5 2.5 0 0 1 1 16.5v-4A2.5 2.5 0 0 1 3.5 10m.72 2.55a.5.5 0 0 0-.72.45v3a.5.5 0 0 0 .72.45l3-1.5a.5.5 0 0 0 0-.9z"
]);
const $76e5a570f6bfc30c$export$b32347eb441f3d62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeVideo20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zm6.5 9.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3zM3.5 10A2.5 2.5 0 0 0 1 12.5v4A2.5 2.5 0 0 0 3.5 19h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 7.5 10zm.72 2.55 3 1.5a.5.5 0 0 1 0 .9l-3 1.5A.5.5 0 0 1 3.5 16v-3a.5.5 0 0 1 .72-.45"
]);
const $76e5a570f6bfc30c$export$373b2f057e2c5de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeVideo24Filled', "24", [
    "M21.25 13c.38 0 .7.28.74.65l.01.1v5a3.25 3.25 0 0 1-3.07 3.24l-.18.01h-4.67q.82-.6 1.27-1.5h3.4c.92 0 1.67-.7 1.74-1.6l.01-.15v-5c0-.41.34-.75.75-.75m-9.5-4c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.45 3.25-3.25 3.25h-6.5A3.25 3.25 0 0 1 2 18.75v-6.5C2 10.45 3.46 9 5.25 9zm-5.69 4.1a1 1 0 0 0-.06.24v4.32a.5.5 0 0 0 .74.44l3.96-2.16a.5.5 0 0 0 0-.88L6.74 12.9a.5.5 0 0 0-.68.2M18.75 2A3.25 3.25 0 0 1 22 5.07v5.18a.75.75 0 0 1-1.5.1v-5.1c0-.92-.7-1.67-1.6-1.74l-.15-.01h-5a.75.75 0 0 1-.1-1.5h5.1m-8.5 0a.75.75 0 0 1 .1 1.5h-5.1c-.92 0-1.67.7-1.74 1.6l-.01.15v3.4q-.9.46-1.5 1.27V5.25a3.25 3.25 0 0 1 3.07-3.24L5.25 2z"
]);
const $76e5a570f6bfc30c$export$97bcccea8c26431c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeVideo24Regular', "24", [
    "M21.25 13c.38 0 .7.28.74.65l.01.1v5a3.25 3.25 0 0 1-3.07 3.24l-.18.01h-4.67q.82-.6 1.27-1.5h3.4c.92 0 1.67-.7 1.74-1.6l.01-.15v-5c0-.41.34-.75.75-.75m-9.5-4c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.45 3.25-3.25 3.25h-6.5A3.25 3.25 0 0 1 2 18.75v-6.5C2 10.45 3.46 9 5.25 9zm0 1.5h-6.5c-.97 0-1.75.78-1.75 1.75v6.5c0 .97.78 1.75 1.75 1.75h6.5c.97 0 1.75-.78 1.75-1.75v-6.5c0-.97-.78-1.75-1.75-1.75m-5.69 2.6a.5.5 0 0 1 .6-.23l.08.03 3.96 2.16a.5.5 0 0 1 .07.83l-.07.05-3.96 2.16a.5.5 0 0 1-.73-.35l-.01-.1v-4.3a1 1 0 0 1 .06-.25M18.75 2A3.25 3.25 0 0 1 22 5.07v5.18a.75.75 0 0 1-1.5.1v-5.1c0-.92-.7-1.67-1.6-1.74l-.15-.01h-5a.75.75 0 0 1-.1-1.5h5.1m-8.5 0a.75.75 0 0 1 .1 1.5h-5.1c-.92 0-1.67.7-1.74 1.6l-.01.15v3.4q-.9.46-1.5 1.27V5.25a3.25 3.25 0 0 1 3.07-3.24L5.25 2z"
]);
const $76e5a570f6bfc30c$export$d58c7ee95908e056 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSource20Filled', "20", [
    "M3 10a7 7 0 1 1 12.14 4.75l.65.77a8 8 0 1 0-11.58 0l.65-.77A7 7 0 0 1 3 10m11.16 3.6a5.5 5.5 0 1 0-8.32 0l.65-.78a4.5 4.5 0 1 1 7.01 0zm-1.65-1.96q.48-.71.49-1.64a3 3 0 1 0-5.51 1.64l.69-.81a2 2 0 1 1 3.64 0zm-2.13-.96a.5.5 0 0 0-.76 0l-5.5 6.5a.5.5 0 0 0 .38.82h11a.5.5 0 0 0 .38-.82z"
]);
const $76e5a570f6bfc30c$export$fd3afb41a8af52fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSource20Regular', "20", [
    "M3 10a7 7 0 1 1 12.14 4.75l.65.77a8 8 0 1 0-11.58 0l.65-.77A7 7 0 0 1 3 10m11.16 3.6a5.5 5.5 0 1 0-8.32 0l.65-.78a4.5 4.5 0 1 1 7.01 0zm-1.65-1.96q.48-.71.49-1.64a3 3 0 1 0-5.51 1.64l.69-.81a2 2 0 1 1 3.64 0zm-2.13-.96a.5.5 0 0 0-.76 0l-5.5 6.5a.5.5 0 0 0 .38.82h11a.5.5 0 0 0 .38-.82zM14.42 17H5.58L10 11.77z"
]);
const $76e5a570f6bfc30c$export$4db46fe70cc546ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSource24Filled', "24", [
    "M3.5 12a8.5 8.5 0 1 1 14.76 5.75l1 1.13a10 10 0 1 0-14.5 0l.98-1.13A8.5 8.5 0 0 1 3.5 12m15.75.13a7 7 0 0 1-1.78 4.71l-1-1.14a5.63 5.63 0 1 0-8.8-.15L6.65 16.7a7.12 7.12 0 1 1 12.6-4.57m-3-.13c0 .94-.3 1.8-.82 2.51l-1.03-1.17q.34-.6.35-1.34a2.75 2.75 0 1 0-5.15 1.34L8.57 14.5A4.25 4.25 0 1 1 16.25 12m-4.25.5q.34.01.56.26l7 8A.75.75 0 0 1 19 22H5a.75.75 0 0 1-.56-1.24l7-8a.8.8 0 0 1 .56-.26"
]);
const $76e5a570f6bfc30c$export$916f9e85088ac41b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSource24Regular', "24", [
    "M3.5 12a8.5 8.5 0 1 1 14.76 5.75l1 1.13a10 10 0 1 0-14.5 0l.98-1.13A8.5 8.5 0 0 1 3.5 12m15.75.13a7 7 0 0 1-1.78 4.71l-1-1.14a5.63 5.63 0 1 0-8.8-.15L6.65 16.7a7.12 7.12 0 1 1 12.6-4.57m-3-.13c0 .94-.3 1.8-.82 2.51l-1.03-1.17q.34-.6.35-1.34a2.75 2.75 0 1 0-5.15 1.34L8.57 14.5A4.25 4.25 0 1 1 16.25 12m-3.69.76a.75.75 0 0 0-1.12 0l-7 8A.75.75 0 0 0 5 22h14a.75.75 0 0 0 .56-1.24zm4.79 7.74H6.65L12 14.39z"
]);
const $76e5a570f6bfc30c$export$ad94c5660d9a7220 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSource28Filled', "28", [
    "M13.33 15.75a1 1 0 0 1 1.32-.02l.09.08 7.74 8.52a1 1 0 0 1-.62 1.66l-.12.01H6.26a1 1 0 0 1-.82-1.57l.08-.1 7.74-8.52zM14 2a13 13 0 0 1 9.78 21.56l-.09-.12-.1-.12-.81-.9a11.5 11.5 0 1 0-17.56 0l-.8.9q-.12.11-.2.25A13 13 0 0 1 14 2m0 4a9 9 0 0 1 7.08 14.56l-1.03-1.13a7.5 7.5 0 1 0-12.1 0l-1.03 1.13A9 9 0 0 1 14 6m0 4a5 5 0 0 1 4.32 7.52l-1.08-1.19A3.5 3.5 0 0 0 14 11.5a3.5 3.5 0 0 0-3.24 4.83l-1.08 1.2A5 5 0 0 1 14 10"
]);
const $76e5a570f6bfc30c$export$38cbbde6f63263f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSource28Regular', "28", [
    "m14.65 15.73.09.08 7.74 8.52a1 1 0 0 1-.62 1.66l-.12.01H6.26a1 1 0 0 1-.82-1.57l.08-.1 7.74-8.52.07-.06a1 1 0 0 1 1.32-.02m-.65 1.5L7.4 24.5h13.2zM14 2a13 13 0 0 1 9.78 21.56l-.09-.12-.1-.12-.81-.9a11.5 11.5 0 1 0-17.56 0l-.8.9q-.12.11-.2.25A13 13 0 0 1 14 2m0 4a9 9 0 0 1 7.08 14.56l-1.03-1.13a7.5 7.5 0 1 0-12.1 0l-1.03 1.13A9 9 0 0 1 14 6m0 4a5 5 0 0 1 4.32 7.52l-1.08-1.19A3.5 3.5 0 0 0 14 11.5a3.5 3.5 0 0 0-3.24 4.83l-1.08 1.2A5 5 0 0 1 14 10"
]);
const $76e5a570f6bfc30c$export$fe1a1195117ae63d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle16Filled', "16", [
    "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M6.5 5.5c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5M12 6v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 1 0m-3 .5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5m-4.5 1v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0"
]);
const $76e5a570f6bfc30c$export$e30714e472c3b4e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle16Regular', "16", [
    "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m5.5-2.5c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5M12 6a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zM4 7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m5.5 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$d06fdd3e512ffa45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle20Filled', "20", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0M6 8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5m5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zM8.5 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m5.5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$b419eda2576b285d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle20Regular', "20", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m4-1.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zM8.5 7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5m5.5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$b36d5c1e7c1809cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle24Filled', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-1 6.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 1.5 0m6 0v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 1.5 0m-3 1.5v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 1.5 0m-6 .5v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0"
]);
const $76e5a570f6bfc30c$export$33b60ee397f5b0e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle24Regular', "24", [
    "M11 8.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm6 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-3 1.5a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zm-6 .5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
]);
const $76e5a570f6bfc30c$export$7526cbf779d4a882 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle28Filled', "28", [
    "M14 2a12 12 0 1 0 0 24 12 12 0 0 0 0-24m-1.75 7c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m4.25 2.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 1.5 0M19.25 9c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75M9.5 12.25v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 1.5 0"
]);
const $76e5a570f6bfc30c$export$6d09528d65ccbcdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle28Regular', "28", [
    "M14 3.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0m10.25-5c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75M9.5 12.25a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zM15.75 11c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75M20 9.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$e27d7b01f5fd7d17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle32Filled', "32", [
    "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28m-2.5 8a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1m10 1v10a1 1 0 1 1-2 0V11a1 1 0 1 1 2 0M18 12.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M10 14v4a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0"
]);
const $76e5a570f6bfc30c$export$4b1023cb49e23b19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle32Regular', "32", [
    "M16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0m11.5-6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1m10 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0zM18 12.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M10 14a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"
]);
const $76e5a570f6bfc30c$export$c3a44b62a7a71d6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle48Filled', "48", [
    "M44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0m-23.25-8c-.69 0-1.25.56-1.25 1.25v13.5a1.25 1.25 0 1 0 2.5 0v-13.5c0-.69-.56-1.25-1.25-1.25M34 17.25a1.25 1.25 0 1 0-2.5 0v13.5a1.25 1.25 0 1 0 2.5 0zM14.75 20c-.69 0-1.25.56-1.25 1.25v5.5a1.25 1.25 0 1 0 2.5 0v-5.5c0-.69-.56-1.25-1.25-1.25m13.25.25a1.25 1.25 0 1 0-2.5 0v7.5a1.25 1.25 0 1 0 2.5 0z"
]);
const $76e5a570f6bfc30c$export$964de2b907766df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircle48Regular', "48", [
    "M24 6.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35M4 24a20 20 0 1 1 40 0 20 20 0 0 1-40 0m16.75-8c.69 0 1.25.56 1.25 1.25v13.5a1.25 1.25 0 1 1-2.5 0v-13.5c0-.69.56-1.25 1.25-1.25M34 17.25a1.25 1.25 0 1 0-2.5 0v13.5a1.25 1.25 0 1 0 2.5 0zM14.75 20c.69 0 1.25.56 1.25 1.25v5.5a1.25 1.25 0 1 1-2.5 0v-5.5c0-.69.56-1.25 1.25-1.25m13.25.25a1.25 1.25 0 1 0-2.5 0v7.5a1.25 1.25 0 1 0 2.5 0z"
]);
const $76e5a570f6bfc30c$export$3c232b5f6821013f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAdd20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8v.25a5.5 5.5 0 0 0-4-1.23V7.5a.5.5 0 0 0-1 0v1.7q-.81.25-1.5.7V8.5a.5.5 0 0 0-1 0v2.23a5.5 5.5 0 0 0-.25 7.26L10 18a8 8 0 1 1 0-16m4.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m-6-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5M6 8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$536d9bf509901baa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAdd20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8l-.01.25q-.47-.38-1-.66a7 7 0 1 0-7.4 7.4q.28.54.66 1H10a8 8 0 1 1 0-16m4.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m-6-5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5-.5c.28 0 .5.22.5.5v1.4q-.55.35-1 .83V8.5c0-.28.22-.5.5-.5m2.5-1c.28 0 .5.22.5.5v1.52q-.51.05-1 .19V7.5c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$465c531a931423d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78A6.5 6.5 0 0 0 17 11.02V8.75a.75.75 0 0 0-1.5 0v2.56q-.8.27-1.5.71v-1.77a.75.75 0 0 0-1.5 0v3.1a6.47 6.47 0 0 0 .28 8.62L12 22a10 10 0 0 1 0-20m5.5 12a.5.5 0 0 0-.5.5V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 0 0-.5-.5m-7.25-6a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75m-3 2a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$3df29f4bd4058c5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.48-1.05 8.5 8.5 0 1 0-8.76 8.76q.42.81 1.05 1.48L12 22a10 10 0 0 1 0-20m5.5 12a.5.5 0 0 0-.5.5V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 0 0-.5-.5m-7.25-6c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m-3 2c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m6-.5c.41 0 .75.34.75.75v1.77q-.86.55-1.5 1.33v-3.1c0-.41.34-.75.75-.75m3-1.5c.41 0 .75.34.75.75v2.27q-.78.06-1.5.3V8.74c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$2390694189d0f0a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAdd28Filled', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M14 2a12 12 0 0 1 11.93 13.33A7.5 7.5 0 0 0 20 13.02V9.75a.75.75 0 0 0-1.5 0v3.52q-1.08.3-2 .89v-2.41a.75.75 0 0 0-1.5 0v3.65a7.47 7.47 0 0 0 .33 10.53q-.66.06-1.33.07a12 12 0 0 1 0-24m6.5 14a.5.5 0 0 0-.5.5V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5a.5.5 0 0 0-.5-.5m-8.25-7a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-.75-.75m-3.5 2.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$2350f50cf4a72a1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAdd28Regular', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M14 2a12 12 0 0 1 11.93 13.33q-.65-.67-1.43-1.18V14A10.5 10.5 0 1 0 14 24.5h.15q.5.78 1.18 1.43-.66.06-1.33.07a12 12 0 0 1 0-24m6.5 14a.5.5 0 0 0-.5.5V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5a.5.5 0 0 0-.5-.5m-8.25-7c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m-3.5 2.5c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75m7-.5c.41 0 .75.34.75.75v2.4q-.83.54-1.5 1.25v-3.65c0-.41.34-.75.75-.75m3.5-2c.41 0 .75.34.75.75v3.27q-.78.05-1.5.25V9.75c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$f26fe648dd668c6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle16Filled', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.3 1.3 0 0 0 1 .21A7 7 0 1 1 8.78 1.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-1.09.34A1.4 1.4 0 0 0 6 3.5q0 .46.26.82.26.37.71.53l1.06.35q.22.06.47.29c.11.11.2.24.3.47l.17.54a.5.5 0 0 0-.47.5v2a.5.5 0 0 0 1 0V7.6l.17.14q.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.12.05.22.14t.14.22l.26.8q.15.38.48.62M7 6a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zM4 9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-1 0v1c0 .28.22.5.5.5"
]);
const $76e5a570f6bfc30c$export$14ea9c4804bb8d64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle16Regular', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.3 1.3 0 0 0 1 .21A7 7 0 1 1 8.78 1.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-.73.23a6 6 0 1 0 5.4 9.69zM8.97 6.5l.18.55q.1.3.35.54V9a.5.5 0 0 1-1 0V7c0-.27.2-.48.47-.5M7 6a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0zM4.5 7.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
]);
const $76e5a570f6bfc30c$export$f50125e6f2cfd6f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle20Filled', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.3 1.3 0 0 0 1 .21 8 8 0 1 1-6.6-9.9l-.2.07A1.4 1.4 0 0 0 10 3.5q0 .46.26.82.26.37.71.53l1.06.35q.22.06.47.29c.11.11.2.24.3.47l.35 1.1.03.06a.5.5 0 0 0-.18.38v5a.5.5 0 0 0 1 0v-4q0 .42.24.76.24.33.65.48l.77.25q.12.05.22.14t.14.22l.26.8q.15.38.48.62M5.5 9v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0M11 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 11 8m-3-.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0"
]);
const $76e5a570f6bfc30c$export$8e230031e9a25e4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle20Regular', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.09 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.58 9.9zm-3.83-4.26q-.36-.29-.5-.62a.5.5 0 0 0-.17.38v5a.5.5 0 0 0 1 0V7.92q-.17-.07-.33-.18M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zM8.5 7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$131e2958986fb87f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle24Filled', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12 2a10 10 0 0 1 2.76.39 2 2 0 0 1-.37.17L13.05 3c-.63.22-1.05.8-1.05 1.47 0 .63.42 1.28 1 1.53l1.4.46c.52.17 1.01.57 1.19 1.09l.18.63a.8.8 0 0 0-.27.57v6.5a.75.75 0 0 0 1.5 0V9.98a1.5 1.5 0 0 0 1.14-.1q-.18.31-.18.67c0 .54.36 1.05.87 1.23l.24.07c.36.09.8.2.91.55l.01.04c.24.75.51 1.61 1.47 1.61q.19 0 .34-.04A10 10 0 1 1 12 2m-1.75 6a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75m3 1.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75m-6 .5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$fe35e845dd122c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle24Regular', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12 2a10 10 0 0 1 2.76.39 2 2 0 0 1-.37.17L13.05 3q-.44.16-.71.5H12a8.5 8.5 0 1 0 8.38 9.92c.22.36.54.63 1.08.63q.19 0 .34-.04A10 10 0 1 1 12 2m3.5 6.75q0-.36.27-.57L16 9c.16.47.54.83 1 .98v5.27a.75.75 0 0 1-1.5 0zm-4.5 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm3 1.5a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zm-6 .5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z"
]);
const $76e5a570f6bfc30c$export$f54b6a749ac11b03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle28Filled', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5q-.49.16-.8.59a1.6 1.6 0 0 0 0 1.85q.3.42.78.59l1.56.5a2.3 2.3 0 0 1 1 .73q.24.28.35.64l.5 1.53.02.06v8.26a.75.75 0 0 0 1.5 0v-7.23q.51 0 .93-.29l.13-.11a1.34 1.34 0 0 0 .85 1.66l.94.3q.2.07.34.22t.22.35l.3.92A1.34 1.34 0 0 0 25 15a1.4 1.4 0 0 0 .99-.42A12 12 0 1 1 14 2m-1.75 7a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-.75-.75m4.25 7.25v-4.5a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0m-7-.5v-3.5a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0"
]);
const $76e5a570f6bfc30c$export$9ccf270b3559134f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle28Regular', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5-.12.04Q14.5 3.5 14 3.5a10.5 10.5 0 1 0 10.46 11.4 1.4 1.4 0 0 0 1.53-.32A12 12 0 1 1 14 2m4.5 16.25V9.99q.18.45.57.74.42.29.93.29v7.23a.75.75 0 0 1-1.5 0M12.25 9c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75M9.5 12.25a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zM15.75 11c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$eb4eae390eafbdd8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle32Filled', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M16 2a14 14 0 0 1 4.14.62q-.23.17-.5.26L18 3.44a2.2 2.2 0 0 0-1.5 2.06 2.2 2.2 0 0 0 1.45 2l1.71.56q.44.15.77.47.01.05.08.11l.08.08q.2.26.31.58l.55 1.7.05.13V21a1 1 0 1 0 2 0v-8.52a2 2 0 0 0 1.25-.4 2 2 0 0 0-.25.9 1.8 1.8 0 0 0 1.24 1.75l1 .3.14.11q.07.07.09.15l.3.91a2 2 0 0 0 .69.94 1.9 1.9 0 0 0 1.99.1A14 14 0 1 1 16 2m-2.5 8a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V11a1 1 0 0 0-1-1m4.5 2.5a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1M10 18v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0"
]);
const $76e5a570f6bfc30c$export$e43106f4a1d75b90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle32Regular', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M16 2a14 14 0 0 1 4.14.62q-.23.17-.5.26L18 3.44q-.54.19-.94.6Q16.54 4 16 4a12 12 0 1 0 11.95 13.13l.01.01a1.9 1.9 0 0 0 1.99.1A14 14 0 1 1 16 2m5.5 19v-9.87a2.2 2.2 0 0 0 2 1.35V21a1 1 0 1 1-2 0m-8-11a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1m4.5 2.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M10 14a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"
]);
const $76e5a570f6bfc30c$export$495d8d3859d88d28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle48Filled', "48", [
    "M32.83 12.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM24 4a20 20 0 0 1 5.66.81l-.02.01-2.57.83a3.1 3.1 0 0 0-2.04 2.4 3 3 0 0 0 1.97 3.3l2.65.86a3.3 3.3 0 0 1 2.17 2.11l.56 1.73c-.5.16-.88.64-.88 1.2v13.5a1.25 1.25 0 1 0 2.5 0V18.56a3 3 0 0 0 3.25-.14q-.22.48-.22 1a2.55 2.55 0 0 0 1.7 2.4l1.42.46.12.06.2.15q.14.14.2.33l.44 1.37q.22.82.89 1.35a2.6 2.6 0 0 0 1.9.43A20 20 0 1 1 24 4m-3.25 12c-.69 0-1.25.56-1.25 1.25v13.5a1.25 1.25 0 1 0 2.5 0v-13.5c0-.69-.56-1.25-1.25-1.25m-6 4c-.69 0-1.25.56-1.25 1.25v5.5a1.25 1.25 0 1 0 2.5 0v-5.5c0-.69-.56-1.25-1.25-1.25m13.25.25a1.25 1.25 0 1 0-2.5 0v7.5a1.25 1.25 0 1 0 2.5 0z"
]);
const $76e5a570f6bfc30c$export$64aa2b105ba31462 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkle48Regular', "48", [
    "M32.83 12.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM24 4a20 20 0 0 1 5.66.81l-.02.01-2.57.83q-.8.28-1.36.93-.85-.08-1.71-.08a17.5 17.5 0 1 0 17.47 18.48q.23.32.53.56a2.6 2.6 0 0 0 1.9.43A20 20 0 1 1 24 4m7.5 13.25c0-.56.37-1.04.88-1.2l.28.86A3 3 0 0 0 34 18.56v12.19a1.25 1.25 0 1 1-2.5 0zM20.75 16c.69 0 1.25.56 1.25 1.25v13.5a1.25 1.25 0 1 1-2.5 0v-13.5c0-.69.56-1.25 1.25-1.25m-6 4c.69 0 1.25.56 1.25 1.25v5.5a1.25 1.25 0 1 1-2.5 0v-5.5c0-.69.56-1.25 1.25-1.25m13.25.25a1.25 1.25 0 1 0-2.5 0v7.5a1.25 1.25 0 1 0 2.5 0z"
]);
const $76e5a570f6bfc30c$export$5cc22bf2b807dfbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff16Filled', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7l-1.57-1.56a7 7 0 0 1-9.87-9.87L1.15 1.85a.5.5 0 0 1 0-.7M13.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .2-.29l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2M6 10a.5.5 0 0 0 1 0V7.7l-1-1zM4 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1A.5.5 0 0 0 4 7m6.48-7a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28M8 1q.4 0 .78.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-1.09.34A1.4 1.4 0 0 0 6 3.5q0 .23.07.45L4.23 2.1A7 7 0 0 1 8 1"
]);
const $76e5a570f6bfc30c$export$c574ff849ae2a845 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff16Regular', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7l-1.57-1.56a7 7 0 0 1-9.87-9.87L1.15 1.85a.5.5 0 0 1 0-.7m2.27 2.98a6 6 0 0 0 8.45 8.45L7 7.7V10a.5.5 0 0 1-1 0V6.7zM13.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2M4 7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m6.48-7a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28M8 1q.4 0 .78.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-.73.23q-1.3.15-2.36.8l-.72-.74A7 7 0 0 1 8 1"
]);
const $76e5a570f6bfc30c$export$6bc460397fad866c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff20Filled', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7L2.15 2.85a.5.5 0 0 1 0-.7M14 8.5q0 .42.24.76.24.33.65.48l.77.25q.12.05.21.14.11.1.15.22l.26.8q.15.38.48.62a1.3 1.3 0 0 0 1 .21 8 8 0 0 1-1.14 2.51L14 11.88zm-6 4a.5.5 0 0 0 1 0V9.7l-1-1zm-2-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2M10 2q.6 0 1.17.08l-.22.07A1.4 1.4 0 0 0 10 3.5q0 .45.26.82t.71.53l1.06.35q.22.06.47.29.16.14.3.47l.35 1.1.03.06a.5.5 0 0 0-.18.38v3.38l-7.5-7.5A8 8 0 0 1 10 2m4.48-2a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $76e5a570f6bfc30c$export$8da45f51a7497b23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff20Regular', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7L2.15 2.86a.5.5 0 0 1 0-.7M4.7 5.4a7 7 0 0 0 9.87 9.87L9 9.72v2.79a.5.5 0 0 1-1 0V8.7zm12.06 6.37a1.3 1.3 0 0 0 .98.2q-.35 1.38-1.14 2.51l-.72-.72q.6-.91.88-2m-3.6-4.66q.14.33.5.62.16.11.33.18v3.96l-1-1V7.5q0-.24.18-.38M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28M10 2q.6 0 1.17.08l-.22.07a1.4 1.4 0 0 0-.86.85h-.1c-1.38 0-2.68.4-3.77 1.1l-.72-.72A8 8 0 0 1 10 2"
]);
const $76e5a570f6bfc30c$export$e6523eeddc0c4b91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff24Filled', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-2.2-2.2a10 10 0 0 1-14.1-14.1l-2.2-2.2a.75.75 0 0 1 0-1.06m15.92 7.67q-.18.3-.18.66c0 .54.36 1.05.87 1.23l.24.07c.36.09.8.2.91.55l.01.04c.24.75.51 1.61 1.47 1.61q.19 0 .34-.04a10 10 0 0 1-1.32 3.29L17 13.82V9.98a1.5 1.5 0 0 0 1.14-.1M9.5 15.25a.75.75 0 0 0 1.5 0v-3.19l-1.5-1.5zM7.25 10a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75m14.23-2a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2M12 2a10 10 0 0 1 2.76.39 2 2 0 0 1-.37.17L13.05 3c-.63.22-1.05.8-1.05 1.47 0 .63.42 1.28 1 1.53l1.4.46c.52.17 1.01.57 1.19 1.09l.18.63a.8.8 0 0 0-.27.57v3.57l-8.8-8.8A10 10 0 0 1 12 2m5.47-2a.6.6 0 0 1 .52.36l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.6.6 0 0 1-.26.2l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38a.6.6 0 0 1-.2.26.55.55 0 0 1-.82-.26l-.45-1.38a2.8 2.8 0 0 0-1.8-1.8L13.36 5a.55.55 0 0 1-.26-.83q.1-.14.26-.2l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.6.6 0 0 1 .51-.36"
]);
const $76e5a570f6bfc30c$export$1ee3227d07c1a873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff24Regular', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06l-2.2-2.2a10 10 0 0 1-14.1-14.1l-2.2-2.2a.75.75 0 0 1 0-1.06m3.26 4.32a8.5 8.5 0 0 0 11.97 11.97L11 12.06v3.19a.75.75 0 0 1-1.5 0v-4.69zm14.9 6.87c.22.37.54.64 1.08.64q.19 0 .34-.04a10 10 0 0 1-1.32 3.29l-1.1-1.1q.76-1.27 1-2.78M7.25 10c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M16 9c.16.47.54.83 1 .98v3.84l-1.5-1.5V8.75q0-.36.27-.57zm5.48-1a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-4-8a.6.6 0 0 1 .5.36l.45 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.6.6 0 0 1-.26.2l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38a.6.6 0 0 1-.2.26.55.55 0 0 1-.82-.26l-.45-1.38a2.8 2.8 0 0 0-1.8-1.8L13.36 5a.55.55 0 0 1-.26-.83q.1-.14.26-.2l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.6.6 0 0 1 .51-.36M12 2a10 10 0 0 1 2.76.39 2 2 0 0 1-.37.17L13.05 3q-.44.16-.71.5a8.7 8.7 0 0 0-4.55 1.11L6.7 3.52A10 10 0 0 1 12 2"
]);
const $76e5a570f6bfc30c$export$71b8de1ca863dd52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff28Filled', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06l-2.79-2.79A12 12 0 0 1 5 6.06L2.22 3.28a.75.75 0 0 1 0-1.06m18.84 8.4a1.3 1.3 0 0 0 .19 1.17q.25.35.66.49l.94.31q.2.06.34.21.16.15.22.35l.3.92A1.34 1.34 0 0 0 25 15a1.4 1.4 0 0 0 .99-.42c-.11 2.28-.86 4.39-2.07 6.16L20 16.82v-5.8q.51 0 .93-.29zm-9.56 7.63a.75.75 0 0 0 1.5 0v-4.19l-1.5-1.5zM8.75 11.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5q-.49.16-.8.59a1.6 1.6 0 0 0 0 1.85q.3.42.78.59l1.56.5a2.3 2.3 0 0 1 1 .73q.24.29.35.64l.5 1.53.02.06v5.33L7.26 4.07A12 12 0 0 1 14 2m10.98 6a.4.4 0 0 1 .34.24l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 .17.55q-.06.09-.17.13l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.17-.55q.06-.09.17-.13l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.4.4 0 0 1 .34-.24m-5.01-8a.6.6 0 0 1 .57.4l.5 1.53a3.2 3.2 0 0 0 2 2l1.53.5h.03a.6.6 0 0 1 0 1.14l-1.53.5a3.2 3.2 0 0 0-2 2l-.5 1.53-.01.03a.6.6 0 0 1-1.13-.03l-.5-1.53a3.2 3.2 0 0 0-2-2l-1.53-.5a.6.6 0 0 1 0-1.14l1.53-.5a3.2 3.2 0 0 0 1.96-1.96l.01-.04.5-1.53a.6.6 0 0 1 .57-.4"
]);
const $76e5a570f6bfc30c$export$8f228d744dfb6d22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOff28Regular', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06l-2.79-2.79A12 12 0 0 1 5 6.06L2.22 3.28a.75.75 0 0 1 0-1.06m3.85 4.9a10.5 10.5 0 0 0 14.8 14.8L13 14.07v4.19a.75.75 0 0 1-1.5 0v-5.69zm19.92 7.46c-.11 2.28-.86 4.39-2.07 6.16l-1.08-1.08c.9-1.4 1.48-3.02 1.62-4.77a1.4 1.4 0 0 0 1.53-.31m-7.49-4.6q.18.46.57.75.42.29.93.29v5.8l-1.5-1.5zM8.75 11.5c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75M24.98 8a.4.4 0 0 1 .34.24l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 .17.55q-.06.09-.17.13l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.17-.55q.06-.09.17-.13l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.4.4 0 0 1 .34-.24m-5.01-8a.6.6 0 0 1 .57.4l.5 1.53a3.2 3.2 0 0 0 2 2l1.53.5h.03a.6.6 0 0 1 0 1.14l-1.53.5a3.2 3.2 0 0 0-2 2l-.5 1.53-.01.03a.6.6 0 0 1-1.13-.03l-.5-1.53a3.2 3.2 0 0 0-2-2l-1.53-.5a.6.6 0 0 1 0-1.14l1.53-.5a3.2 3.2 0 0 0 1.96-1.96l.01-.04.5-1.53a.6.6 0 0 1 .57-.4M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5-.12.04a10.6 10.6 0 0 0-6.63 1.62L7.26 4.07A12 12 0 0 1 14 2"
]);
const $76e5a570f6bfc30c$export$a16c7fbb57a4908a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtract20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8v.25a5.5 5.5 0 0 0-4-1.23V7.5a.5.5 0 0 0-1 0v1.7q-.81.25-1.5.7V8.5a.5.5 0 0 0-1 0v2.23a5.5 5.5 0 0 0-.25 7.26L10 18a8 8 0 1 1 0-16m2.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-4-7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5M6 8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5"
]);
const $76e5a570f6bfc30c$export$6985608d9afbb1a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtract20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8l-.01.25q-.47-.38-1-.66a7 7 0 1 0-7.4 7.4q.28.54.66 1H10a8 8 0 1 1 0-16m2.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-4-7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5-.5c.28 0 .5.22.5.5v1.4q-.55.35-1 .83V8.5c0-.28.22-.5.5-.5m2.5-1c.28 0 .5.22.5.5v1.52q-.51.05-1 .19V7.5c0-.28.22-.5.5-.5"
]);
const $76e5a570f6bfc30c$export$92e38800e620a23d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtract24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78A6.5 6.5 0 0 0 17 11.02V8.75a.75.75 0 0 0-1.5 0v2.56q-.8.27-1.5.71v-1.77a.75.75 0 0 0-1.5 0v3.1a6.47 6.47 0 0 0 .28 8.62L12 22a10 10 0 0 1 0-20m2.5 15a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-4.25-9a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75m-3 2a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$87eb2e8c1902a98d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtract24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.48-1.05 8.5 8.5 0 1 0-8.76 8.76q.42.81 1.05 1.48L12 22a10 10 0 0 1 0-20m2.5 15a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-4.25-9c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m-3 2c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m6-.5c.41 0 .75.34.75.75v1.77q-.86.55-1.5 1.33v-3.1c0-.41.34-.75.75-.75m3-1.5c.41 0 .75.34.75.75v2.27q-.78.06-1.5.3V8.74c0-.41.34-.75.75-.75"
]);
const $76e5a570f6bfc30c$export$4f1233e991487a0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtract28Filled', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M14 2a12 12 0 0 1 11.93 13.33A7.5 7.5 0 0 0 20 13.02V9.75a.75.75 0 0 0-1.5 0v3.52q-1.08.3-2 .89v-2.41a.75.75 0 0 0-1.5 0v3.65a7.47 7.47 0 0 0 .33 10.53q-.66.06-1.33.07a12 12 0 0 1 0-24m2.5 18a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zM12.25 9a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-.75-.75m-3.5 2.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75"
]);
const $76e5a570f6bfc30c$export$35507c1669ec6c80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtract28Regular', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M14 2a12 12 0 0 1 11.93 13.33q-.65-.67-1.43-1.18V14A10.5 10.5 0 1 0 14 24.5h.15q.5.78 1.18 1.43-.66.06-1.33.07a12 12 0 0 1 0-24m2.5 18a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zM12.25 9c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75m-3.5 2.5c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75m7-.5c.41 0 .75.34.75.75v2.4q-.83.54-1.5 1.25v-3.65c0-.41.34-.75.75-.75m3.5-2c.41 0 .75.34.75.75v3.27q-.78.05-1.5.25V9.75c0-.41.34-.75.75-.75"
]);


"use client";
const $cdb0ff5c001a8842$export$beb4804b6728d8f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony16Filled', "16", [
    "M14.5 6a.5.5 0 0 1 0 1H14v4.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V7h-.5a.5.5 0 0 1 0-1zM3 11.5q0 .26.09.5H5.5V7H3zm7.5.5h2.41q.09-.24.09-.5V7h-2.5zm-4 0h3V7h-3zM9.76 1.01A2.5 2.5 0 0 1 12 3.5V5H4V3.5A2.5 2.5 0 0 1 6.5 1h3z"
]);
const $cdb0ff5c001a8842$export$3661742ceb995f77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony16Regular', "16", [
    "M9.76 1.01A2.5 2.5 0 0 1 12 3.5V6h2.5a.5.5 0 0 1 0 1H14v4.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V7h-.5a.5.5 0 0 1 0-1H4V3.5A2.5 2.5 0 0 1 6.5 1h3zM3.09 12c.2.58.76 1 1.41 1h7c.65 0 1.2-.42 1.41-1zM3 11h2.5V7H3zm7.5 0H13V7h-2.5zm-4 0h3V7h-3zm0-9C5.67 2 5 2.67 5 3.5V6h6V3.5A1.5 1.5 0 0 0 9.65 2H6.5"
]);
const $cdb0ff5c001a8842$export$40f4650798a8b709 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony20Filled', "20", [
    "M17.6 8.01a.5.5 0 0 1 0 .98l-.1.01H17v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9h-.5a.5.5 0 0 1 0-1h15zM14 14h2V9h-2zM4 14h2V9H4zm3 0h2.5V9H7zm3.5 0H13V9h-2.5zM12 2a3 3 0 0 1 3 3v2H5V5a3 3 0 0 1 3-3z"
]);
const $cdb0ff5c001a8842$export$1ab8d5e6352f83e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony20Regular', "20", [
    "M14 8V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v3zM4 14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2zm0-1h2V9H4zm3 0h2.5V9H7zm3.5 0H13V9h-2.5zm3.5 0h2V9h-2zm3.6-4.99a.5.5 0 0 1 0 .98l-.1.01H17v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9h-.5a.5.5 0 0 1 0-1H5V5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3h2.5z"
]);
const $cdb0ff5c001a8842$export$a626769e5058ffff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon12Filled', "12", [
    "M5.5 1C7.41 1 9 2.48 9 4.36c0 1.24-.46 2.38-1.1 3.21A3.7 3.7 0 0 1 6 8.94v.46c0 .22.18.4.4.4h1.2c.77 0 1.4.63 1.4 1.4v.3a.5.5 0 0 1-1 0v-.3a.4.4 0 0 0-.4-.4H6.4A1.4 1.4 0 0 1 5 9.4v-.46a3.7 3.7 0 0 1-1.9-1.37A5.3 5.3 0 0 1 2 4.37 3.43 3.43 0 0 1 5.5 1m.07 2a.5.5 0 0 0-.14 1c.3.04.53.27.58.57A.5.5 0 0 0 7 4.43 1.7 1.7 0 0 0 5.57 3"
]);
const $cdb0ff5c001a8842$export$e0125020d57da6dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon12Regular', "12", [
    "M5 3.43A.5.5 0 0 1 5.57 3c.74.11 1.32.7 1.43 1.43a.5.5 0 1 1-1 .14.7.7 0 0 0-.57-.57.5.5 0 0 1-.43-.57m-3 .93A3.43 3.43 0 0 1 5.5 1C7.41 1 9 2.48 9 4.36c0 1.24-.46 2.38-1.1 3.21A3.7 3.7 0 0 1 6 8.94v.46c0 .22.18.4.4.4h1.2c.77 0 1.4.63 1.4 1.4v.3a.5.5 0 0 1-1 0v-.3a.4.4 0 0 0-.4-.4H6.4A1.4 1.4 0 0 1 5 9.4v-.46a3.7 3.7 0 0 1-1.9-1.37A5.3 5.3 0 0 1 2 4.37M5.5 2C4.1 2 3 3.08 3 4.36c0 1 .37 1.93.9 2.6C4.43 7.66 5.05 8 5.5 8s1.07-.34 1.6-1.04c.53-.68.9-1.6.9-2.6C8 3.08 6.9 2 5.5 2"
]);
const $cdb0ff5c001a8842$export$3787b9a469c9475d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon16Filled', "16", [
    "M8 1a4.44 4.44 0 0 0-4.5 4.5c0 1.37.55 2.73 1.36 3.74.7.87 1.62 1.55 2.64 1.72V11c0 1.1.9 2 2 2H11a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V14a2 2 0 0 0-2-2H9.5a1 1 0 0 1-1-1v-.04a4.5 4.5 0 0 0 2.64-1.72A6 6 0 0 0 12.5 5.5C12.5 3.27 10.82 1 8 1m0 2c.66 0 1.28.33 1.73.77.44.45.77 1.07.77 1.73a.5.5 0 0 1-1 0c0-.34-.17-.72-.48-1.02S8.34 4 8 4a.5.5 0 0 1 0-1"
]);
const $cdb0ff5c001a8842$export$601fb2c8722a2b73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon16Regular', "16", [
    "M7.5 3.5c0-.28.22-.5.5-.5.66 0 1.28.33 1.73.77.44.45.77 1.07.77 1.73a.5.5 0 0 1-1 0c0-.34-.17-.72-.48-1.02S8.34 4 8 4a.5.5 0 0 1-.5-.5m1 7.46a4.5 4.5 0 0 0 2.64-1.72A6 6 0 0 0 12.5 5.5C12.5 3.27 10.82 1 8 1a4.44 4.44 0 0 0-4.5 4.5c0 1.37.55 2.73 1.36 3.74.7.87 1.62 1.55 2.64 1.72V11c0 1.1.9 2 2 2H11a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V14a2 2 0 0 0-2-2H9.5a1 1 0 0 1-1-1zM8 2c2.18 0 3.5 1.73 3.5 3.5 0 1.12-.45 2.26-1.14 3.12C9.66 9.49 8.79 10 8 10c-.8 0-1.66-.5-2.36-1.38-.69-.86-1.14-2-1.14-3.12C4.5 3.73 5.82 2 8 2"
]);
const $cdb0ff5c001a8842$export$3a8deeb680c417f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon20Filled', "20", [
    "M5 7a5 5 0 0 1 10 0c0 1.87-.66 3.6-1.6 4.86a5 5 0 0 1-2.9 2.1V14a1 1 0 0 0 1 1H14a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V17a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-2-2v-.05a5 5 0 0 1-2.9-2.09C5.66 10.6 5 8.86 5 7m5.57-3a.5.5 0 1 0-.14 1c.81.11 1.46.76 1.57 1.57a.5.5 0 0 0 1-.14A2.9 2.9 0 0 0 10.56 4"
]);
const $cdb0ff5c001a8842$export$2c0428df00534116 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon20Regular', "20", [
    "M10 4.43a.5.5 0 0 1 .57-.43 2.9 2.9 0 0 1 2.42 2.43.5.5 0 0 1-.99.14A1.9 1.9 0 0 0 10.43 5a.5.5 0 0 1-.43-.57M5 7a5 5 0 0 1 10 0c0 1.87-.66 3.6-1.6 4.86a5 5 0 0 1-2.9 2.1V14a1 1 0 0 0 1 1H14a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V17a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-2-2v-.05a5 5 0 0 1-2.9-2.09C5.66 10.6 5 8.86 5 7m5-4a4 4 0 0 0-4 4c0 1.64.59 3.16 1.4 4.27C8.24 12.4 9.23 13 10 13s1.76-.6 2.6-1.73A7.3 7.3 0 0 0 14 7a4 4 0 0 0-4-4"
]);
const $cdb0ff5c001a8842$export$4480b8e51556ca31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon24Filled', "24", [
    "M5 9a7 7 0 0 1 14 0c0 2.03-.67 4.24-1.85 5.96a6.6 6.6 0 0 1-4.4 2.99v.3c0 .41.34.75.75.75h3.25c1.24 0 2.25 1 2.25 2.25v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 0-.75-.75H13.5c-1.24 0-2.25-1-2.25-2.25v-.3a6.6 6.6 0 0 1-4.4-3A11 11 0 0 1 5 9m7.92-3.9a.75.75 0 0 0-.34 1.47 2.5 2.5 0 0 1 1.85 1.85.75.75 0 1 0 1.46-.35 4 4 0 0 0-2.97-2.96"
]);
const $cdb0ff5c001a8842$export$dfdeabd230bd4d2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon24Regular', "24", [
    "M12.02 5.66c.1-.4.5-.65.9-.55a4 4 0 0 1 2.97 2.96.75.75 0 0 1-1.46.35 2.5 2.5 0 0 0-1.85-1.85.75.75 0 0 1-.56-.9M5 9a7 7 0 0 1 14 0c0 2.03-.67 4.24-1.85 5.96a6.6 6.6 0 0 1-4.4 2.99v.3c0 .41.34.75.75.75h3.25c1.24 0 2.25 1 2.25 2.25v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 0-.75-.75H13.5c-1.24 0-2.25-1-2.25-2.25v-.3a6.6 6.6 0 0 1-4.4-3A11 11 0 0 1 5 9m7-5.5A5.5 5.5 0 0 0 6.5 9c0 1.73.58 3.64 1.59 5.1 1 1.47 2.36 2.4 3.91 2.4s2.9-.93 3.91-2.4A9.4 9.4 0 0 0 17.5 9 5.5 5.5 0 0 0 12 3.5"
]);
const $cdb0ff5c001a8842$export$4263436f4ba5a01d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box16Filled', "16", [
    "m4.04 2.49 6.6 2.83L8 6.46 1.43 3.64q.22-.23.53-.35zm1.33-.52 1.55-.6a3 3 0 0 1 2.16 0l4.96 1.92q.31.12.53.35l-2.65 1.14zM15 4.55 8.5 7.33v7.45a3 3 0 0 0 .58-.16l4.96-1.9c.58-.23.96-.79.96-1.4V4.54M7.5 14.78V7.33L1 4.55v6.76c0 .62.38 1.18.96 1.4l4.96 1.91a3 3 0 0 0 .58.16"
]);
const $cdb0ff5c001a8842$export$1d928b67ef55d3db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box16Regular', "16", [
    "M6.92 1.38a3 3 0 0 1 2.16 0l4.96 1.9c.58.23.96.79.96 1.4v6.63a1.5 1.5 0 0 1-.96 1.4l-4.96 1.91a3 3 0 0 1-2.16 0l-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V4.68c0-.62.38-1.18.96-1.4zm1.8.93a2 2 0 0 0-1.44 0l-1.38.53 5.59 2.12 1.95-.83zM14 4.97 8.5 7.33v6.43l.22-.07 4.96-1.91a.5.5 0 0 0 .32-.47zm-6.5 8.79V7.33L2 4.97v6.34c0 .2.13.4.32.47l4.96 1.9zM2.56 4.13 8 6.46l2.16-.93L4.5 3.38z"
]);
const $cdb0ff5c001a8842$export$90bc44ded265ae96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box20Filled', "20", [
    "m10 7.96 3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.4.15.8.21v-8.9zm8.46 11.87q.4-.05.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18q0-.17-.04-.33L10.5 8.84zM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21"
]);
const $cdb0ff5c001a8842$export$3a5fe68708ee1bc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 0 0 2.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm4.13 4.35 6.5-2.6v7.58a.5.5 0 0 1-.31.47l-5.76 2.3q-.2.09-.43.13zm-1 0v7.88a3 3 0 0 1-.43-.13l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24z"
]);
const $cdb0ff5c001a8842$export$e3a7383fec4fc177 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v10.92q.33-.07.66-.2l7.5-3.04c.66-.27 1.09-.91 1.09-1.62zM11.25 21.7V10.77L2 7.19v9.64c0 .71.43 1.35 1.1 1.62l7.5 3.04q.31.13.65.2M2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28"
]);
const $cdb0ff5c001a8842$export$cac4450e1fb6312b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v9.66c0 .71-.43 1.35-1.1 1.62l-7.5 3.04c-.9.37-1.9.37-2.8 0l-7.5-3.04c-.67-.27-1.1-.91-1.1-1.62V7.17c0-.7.43-1.35 1.1-1.62zm2.25 1.4a2.3 2.3 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45zM3.5 16.83q0 .17.16.23l7.5 3.04.09.04v-9.38L3.5 7.75zm9.35 3.27 7.5-3.04q.14-.07.15-.23V7.77l-7.75 3v9.37z"
]);
const $cdb0ff5c001a8842$export$4ceb937f21f70b4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box28Filled', "28", [
    "M15.4 2.5c-.9-.36-1.9-.36-2.8 0L9.7 3.67l11.25 4.5 4.1-1.65q-.33-.3-.77-.47zm3.52 6.47L7.67 4.47 3.73 6.06q-.44.18-.77.47L14 10.94zM2 8.6q0-.4.12-.8l11.13 4.46v13.43q-.33-.06-.64-.19l-8.88-3.55A2.75 2.75 0 0 1 2 19.4zm13.4 16.9q-.32.12-.65.2V12.25L25.88 7.8q.12.38.12.8V19.4c0 1.12-.68 2.13-1.73 2.55z"
]);
const $cdb0ff5c001a8842$export$2eced87885eda57a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box28Regular', "28", [
    "M15.4 2.5c-.9-.36-1.9-.36-2.8 0L3.74 6.05A2.75 2.75 0 0 0 2 8.6v10.8c0 1.12.69 2.13 1.73 2.55l8.88 3.55c.9.36 1.9.36 2.79 0l8.87-3.55A2.75 2.75 0 0 0 26 19.4V8.6c0-1.12-.68-2.13-1.73-2.55zm-2.23 1.4a2.3 2.3 0 0 1 1.67 0l8.4 3.35-3.61 1.44L10.4 5zm-4.8 1.9 9.24 3.7-3.6 1.44-9.24-3.69zM3.54 8.38l9.72 3.89v11.88l-.08-.03-8.88-3.55a1.3 1.3 0 0 1-.79-1.16V8.6q0-.12.03-.23m11.22 15.77V12.26l9.73-3.9.02.24v10.8c0 .5-.31.97-.79 1.16l-8.87 3.55z"
]);
const $cdb0ff5c001a8842$export$f4c1fc5288405bce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box32Filled', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L11.3 3.74l13 5L28.79 7q-.39-.31-.87-.5zm3.9 7.26-13-5-4.44 1.7q-.47.19-.87.5L16 11.93zM2 9.55q0-.43.1-.82L15 13.69v15.95a5 5 0 0 1-.62-.19l-10.3-3.96A3.25 3.25 0 0 1 2 22.45zm15.62 19.9q-.3.12-.62.19V13.69l12.9-4.96q.1.39.1.82v12.9c0 1.35-.83 2.56-2.08 3.04z"
]);
const $cdb0ff5c001a8842$export$c28c99066d4d0cca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box32Regular', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L4.08 6.51A3.25 3.25 0 0 0 2 9.55v12.9c0 1.35.83 2.56 2.08 3.04l10.3 3.96c1.04.4 2.2.4 3.24 0l10.3-3.96A3.25 3.25 0 0 0 30 22.45V9.55c0-1.35-.83-2.56-2.08-3.04zM15.1 4.42a2.5 2.5 0 0 1 1.8 0L26.2 8 22.5 9.43 12.29 5.5zM9.5 6.57l10.21 3.93L16 11.93 5.79 8zM4 9.46l11 4.23v13.85L4.8 23.62c-.48-.18-.8-.65-.8-1.17v-13m13 18.08V13.7l11-4.23v12.99c0 .52-.32.99-.8 1.17z"
]);
const $cdb0ff5c001a8842$export$51f471a39ca544eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box48Filled', "48", [
    "M26.32 4.83a6.3 6.3 0 0 0-4.64 0l-5.3 2.12 18.75 7.5 7.34-2.93a4 4 0 0 0-1.14-.69zm5.44 10.97L13.02 8.3l-6.35 2.53q-.63.26-1.14.69L24 18.9zM4 14.78q0-.58.15-1.12l18.6 7.44v22.39a6 6 0 0 1-1.07-.32l-15-6A4.25 4.25 0 0 1 4 33.21zm22.32 28.39q-.52.2-1.07.32v-22.4l18.6-7.43q.15.54.15 1.12v18.44c0 1.74-1.06 3.3-2.67 3.94z"
]);
const $cdb0ff5c001a8842$export$b16006a7ea3a34d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box48Regular', "48", [
    "M26.32 4.83a6.3 6.3 0 0 0-4.64 0l-15 6A4.25 4.25 0 0 0 4 14.78v18.44c0 1.74 1.06 3.3 2.67 3.94l15 6c1.5.6 3.16.6 4.65 0l15-6A4.25 4.25 0 0 0 44 33.22V14.78c0-1.74-1.06-3.3-2.67-3.95zm-3.71 2.32c.9-.35 1.89-.35 2.78 0l14 5.6-6.01 2.4L17.99 9zm-7.98 3.2L30 16.5 24 18.9 8.62 12.75zM6.5 14.6l16.24 6.5v19.8l-.14-.05-15.01-6c-.66-.27-1.1-.92-1.1-1.63V14.6m18.74 26.3V21.1l16.24-6.5.01.18v18.44c0 .71-.44 1.36-1.1 1.62l-15 6z"
]);
const $cdb0ff5c001a8842$export$33abc44d5e4771f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zM2 6.18q0-.17.04-.33L9.5 8.84v3.36a5.5 5.5 0 0 0 0 4.6v.93a4 4 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4zm16 0v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33m1 8.32a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-6.86-.35 2-2a.5.5 0 1 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35"
]);
const $cdb0ff5c001a8842$export$a1e5d7d26664f889 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36q.39-.81 1-1.48V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm12.63 10a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-6.86-.34 2-2a.5.5 0 1 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35"
]);
const $cdb0ff5c001a8842$export$43dab14c595963f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v2.3A6.5 6.5 0 0 1 22 12.8zm-10.75 8.52v-4.94L2 7.19v9.64c0 .71.43 1.35 1.1 1.62l7.5 3.04q.31.13.65.2v-2.4a6.5 6.5 0 0 1 0-3.58M2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28M17.5 12a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M14 17.46l.02-.09.02-.06.03-.07.03-.04 2.55-2.55.07-.06a.5.5 0 0 1 .7.7l-.07.06L15.71 17h5.38c.2.05.36.2.4.41l.01.1v.08a.5.5 0 0 1-.41.4L21 18h-5.3l1.65 1.65.06.07a.5.5 0 0 1 0 .57l-.06.06-.07.06a.5.5 0 0 1-.56 0l-.07-.06-2.52-2.5-.04-.06-.04-.08-.03-.08-.01-.06-.01-.06z"
]);
const $cdb0ff5c001a8842$export$dc8d8be51b52d58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a7 7 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08q0 .17.16.23l7.5 3.04.09.04.19.07.18.06q.37.8.94 1.45-1 .15-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62zm2.25 1.4a2.3 2.3 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03zM4.59 6.55 12 9.45l2.7-1.04L7.21 5.5zM17.5 12a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M14 17.46l.02-.09.02-.06.03-.07.03-.04 2.55-2.55.07-.06a.5.5 0 0 1 .7.7l-.07.06L15.71 17h5.38c.2.05.36.2.4.41l.01.1v.08a.5.5 0 0 1-.41.4L21 18h-5.3l1.65 1.65.06.07a.5.5 0 0 1 0 .57l-.06.06-.07.06a.5.5 0 0 1-.56 0l-.07-.06-2.52-2.5-.04-.06-.04-.08-.03-.08-.01-.06-.01-.06z"
]);
const $cdb0ff5c001a8842$export$69a8c9edffb61880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zM2 6.18q0-.17.04-.33L9.5 8.84v3.36a5.5 5.5 0 0 0 0 4.6v.93a4 4 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4zm16 0v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.35-6.86 2 2a.5.5 0 1 1-.7.71L15 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.14"
]);
const $cdb0ff5c001a8842$export$b0b66b7fa944e349 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36q.39-.81 1-1.48V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm8.13 14.5a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9m.35-6.85 2 2a.5.5 0 1 1-.7.71L15 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.14"
]);
const $cdb0ff5c001a8842$export$b071b9dc0b9e1239 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v2.3A6.5 6.5 0 0 1 22 12.8zm-10.75 3.58v4.94a6.5 6.5 0 0 0 0 3.58v2.4a4 4 0 0 1-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19zM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M17.54 14l.09.02.06.02.07.03.05.04 2.54 2.54.06.07a.5.5 0 0 1-.7.7l-.06-.07L18 15.71v5.38a.5.5 0 0 1-.41.4l-.09.01h-.09a.5.5 0 0 1-.4-.4L17 21v-5.3l-1.65 1.65-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.06a.5.5 0 0 1 0-.57l.06-.07 2.5-2.51.07-.05.07-.04.08-.03.06-.01h.11"
]);
const $cdb0ff5c001a8842$export$78117a98a042e98c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a7 7 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08q0 .17.16.23l7.5 3.04.09.04.19.07.18.06q.37.8.94 1.45-1 .15-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62zm2.25 1.4a2.3 2.3 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03zM4.59 6.55 12 9.45l2.7-1.04L7.21 5.5zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M17.54 14l.09.02.06.02.07.03.05.04 2.54 2.54.06.07a.5.5 0 0 1-.7.7l-.06-.07L18 15.71v5.38a.5.5 0 0 1-.41.4l-.09.01h-.09a.5.5 0 0 1-.4-.4L17 21v-5.3l-1.65 1.65-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.06a.5.5 0 0 1 0-.57l.06-.07 2.5-2.51.07-.05.07-.04.08-.03.06-.01h.11"
]);
const $cdb0ff5c001a8842$export$2d52f74ee13afc68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark16Filled', "16", [
    "m4.04 2.49 6.6 2.83L8 6.46 1.43 3.64q.22-.23.53-.35zm1.33-.52 1.55-.6a3 3 0 0 1 2.16 0l4.96 1.92q.31.12.53.35l-2.65 1.14zM15 4.55 11.6 6c1.3.02 2.47.5 3.4 1.26V4.55M7.5 7.33v.4a5.5 5.5 0 0 0-.51 6.92l-.07-.03-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V4.54zM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $cdb0ff5c001a8842$export$d2e2e5452a975b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark16Regular', "16", [
    "M6.92 1.38a3 3 0 0 1 2.16 0l4.96 1.9c.58.23.96.79.96 1.4v2.58a6 6 0 0 0-1-.66V4.97L11.6 6a5.5 5.5 0 0 0-4.1 1.73v-.4L2 4.97v6.34c0 .21.13.4.32.47l3.99 1.53q.25.72.68 1.34l-.07-.03-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V4.68c0-.62.38-1.18.96-1.4zm1.8.93a2 2 0 0 0-1.44 0l-1.38.53 5.59 2.12 1.95-.83zM2.56 4.13 8 6.46l2.16-.93L4.5 3.38zM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $cdb0ff5c001a8842$export$4c844e83b6e786fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zM2 6.18q0-.17.04-.33L9.5 8.84v3.36a5.5 5.5 0 0 0 0 4.6v.93a4 4 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4zm16 0v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-1-3.7 2.65-2.65a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7z"
]);
const $cdb0ff5c001a8842$export$3954fb8a62ded44c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36q.39-.81 1-1.48V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm8.13 14.5a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9m-1-3.7 2.65-2.64a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7z"
]);
const $cdb0ff5c001a8842$export$ffb4ea4349881d15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v2.3A6.5 6.5 0 0 1 22 12.8zm-10.75 3.58v4.94a6.5 6.5 0 0 0 0 3.58v2.4a4 4 0 0 1-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19zM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28M17.5 23a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m2.65-7.85a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64z"
]);
const $cdb0ff5c001a8842$export$c27718e0c02278e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a7 7 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08q0 .17.16.23l7.5 3.04.09.04.19.07.18.06q.37.8.94 1.45-1 .15-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62zm2.25 1.4a2.3 2.3 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03zM4.59 6.55 12 9.45l2.7-1.04L7.21 5.5zM17.5 23a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m-1-4.2 3.65-3.65a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7z"
]);
const $cdb0ff5c001a8842$export$6e441a3c493a2ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark28Filled', "28", [
    "M12.6 2.5c.9-.36 1.9-.36 2.8 0l8.87 3.55q.44.18.78.47l-4.11 1.65-11.25-4.5zM7.68 4.48l11.25 4.5L14 10.93 2.96 6.52q.33-.3.77-.47zM2.12 7.8q-.11.38-.12.8V19.4c0 1.12.69 2.13 1.73 2.55l8.88 3.55q.3.12.64.2v-3.26a7.5 7.5 0 0 1 0-3.88v-6.3zM26 15.4a7.48 7.48 0 0 0-11.25.27v-3.42L25.88 7.8q.12.38.12.8zm1 5.09a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-7.65 2.85 5-5a.5.5 0 0 0-.7-.7L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0"
]);
const $cdb0ff5c001a8842$export$95ed48d7e1db9c94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark28Regular', "28", [
    "M15.4 2.5c-.9-.36-1.9-.36-2.8 0L3.74 6.05A2.75 2.75 0 0 0 2 8.6v10.8c0 1.12.69 2.13 1.73 2.55l8.88 3.55c.77.31 1.62.35 2.42.13A8 8 0 0 1 14 24.27q-.43 0-.84-.16l-4.51-1.8-.03-.02-4.34-1.73a1.3 1.3 0 0 1-.79-1.16V8.6q0-.12.03-.23l9.72 3.89v6.3q.44-1.62 1.5-2.88v-3.42l9.73-3.9.02.24v5.55q.83.53 1.5 1.25V8.6c0-1.12-.68-2.13-1.73-2.55zm-2.23 1.4a2.3 2.3 0 0 1 1.67 0l8.4 3.35-3.61 1.44L10.4 5zm-4.8 1.9 9.24 3.7-3.6 1.44-9.24-3.69zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-7.65 2.85 5-5a.5.5 0 0 0-.7-.7L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0"
]);
const $cdb0ff5c001a8842$export$a39dd93165f30c87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark32Filled', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L11.3 3.74l13 5L28.79 7q-.39-.31-.87-.5zm3.9 7.26-13-5-4.44 1.7q-.47.19-.87.5L16 11.93zM2 9.55q0-.43.1-.82L15 13.69v5.18a9 9 0 0 0 0 8.26v2.5a5 5 0 0 1-.62-.18l-10.3-3.96A3.25 3.25 0 0 1 2 22.45zM23 14c2.83 0 5.35 1.3 7 3.34v-7.8q0-.42-.1-.81L17 13.69v2.6A9 9 0 0 1 23 14m0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m-.72 11.03 5.25-5.25a.75.75 0 1 0-1.06-1.06l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0"
]);
const $cdb0ff5c001a8842$export$6daf757148544816 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark32Regular', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L4.08 6.51A3.25 3.25 0 0 0 2 9.55v12.9c0 1.35.83 2.56 2.08 3.04l10.3 3.96q1.25.47 2.56.2a9 9 0 0 1-1.65-2l-.19-.07-5.24-2.01h-.01L4.8 23.61c-.48-.18-.8-.65-.8-1.17v-13l11 4.24v5.18a9 9 0 0 1 2-2.58v-2.6l11-4.23v6.06q1.14.76 2 1.82v-7.8c0-1.34-.83-2.55-2.08-3.03zM15.1 4.42a2.5 2.5 0 0 1 1.8 0L26.2 8 22.5 9.43 12.29 5.5zM9.5 6.57l10.21 3.93L16 11.93 5.79 8zM23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m-.72 11.03 5.25-5.25a.75.75 0 1 0-1.06-1.06l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0"
]);
const $cdb0ff5c001a8842$export$e95b387dc6599a12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark48Filled', "48", [
    "M26.32 4.83a6.3 6.3 0 0 0-4.64 0l-5.3 2.12 18.75 7.5 7.34-2.93a4 4 0 0 0-1.14-.69zm5.44 10.97L13.02 8.3l-6.35 2.53q-.63.26-1.14.69L24 18.9zM4 14.78q0-.58.15-1.12l18.6 7.44v9.54a13 13 0 0 0 0 8.72v4.13a6 6 0 0 1-1.07-.32l-15-6A4.25 4.25 0 0 1 4 33.21zM35 22c3.5 0 6.66 1.38 9 3.62V14.78q0-.58-.15-1.12l-18.6 7.44v5.3C27.63 23.7 31.12 22 35 22m11 13a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-12.3 4.7 8-8a1 1 0 0 0-1.4-1.4L33 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0"
]);
const $cdb0ff5c001a8842$export$778173dd721d2571 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark48Regular', "48", [
    "M26.32 4.83a6.3 6.3 0 0 0-4.64 0l-15 6A4.25 4.25 0 0 0 4 14.78v18.44c0 1.74 1.06 3.3 2.67 3.94l7.46 2.99.03.01 7.52 3c1.11.45 2.32.57 3.49.34q-.96-1.1-1.66-2.42-.46-.06-.9-.23l-15.01-6c-.66-.27-1.1-.92-1.1-1.63V14.6l16.25 6.5v9.54c.56-1.58 1.42-3.01 2.5-4.24v-5.3l16.24-6.5.01.18v8.96q1.36.79 2.5 1.88V14.78c0-1.74-1.06-3.3-2.67-3.95zm-3.71 2.32c.9-.35 1.89-.35 2.78 0l14 5.6-6.01 2.4L17.99 9zm-7.98 3.2L30 16.5 24 18.9 8.62 12.75zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-12.3 4.7 8-8a1 1 0 0 0-1.4-1.4L33 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0"
]);
const $cdb0ff5c001a8842$export$420b606af784319f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.4.15.8.21v-.94a5.5 5.5 0 0 1 0-4.58V8.84zM18 6.17v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33m1 8.32a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $cdb0ff5c001a8842$export$e6cfc7e81dede018 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.37q.39-.83 1-1.49V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $cdb0ff5c001a8842$export$5b18e9cf6b84ff65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v2.3A6.5 6.5 0 0 1 22 12.8zm-10.75 3.58v4.94a6.5 6.5 0 0 0 0 3.58v2.4a4 4 0 0 1-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19zM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $cdb0ff5c001a8842$export$99420b490497101a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a7 7 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08q0 .17.16.23l7.5 3.04.09.04v-.85q.4 1.37 1.3 2.43-1 .15-1.96-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62zm2.25 1.4a2.3 2.3 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.36a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $cdb0ff5c001a8842$export$1a66cbcfcf9b290e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.37-1.49.07-.23V8.84zM18 6.17v2.95a2.9 2.9 0 0 0-2.9.71l-4.6 4.6v-5.6l7.46-2.99q.04.16.04.33m-7.02 9.2 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $cdb0ff5c001a8842$export$ef9c16d279c91381 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.24-.97-.23-.08-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v7.08q.24-.72.77-1.25l.23-.23v-5.6l6.5-2.6V9q.52-.02 1 .13V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm4.61 10.89 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $cdb0ff5c001a8842$export$75fc9e3dd7726b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v6.84l5.64-5.65a3.3 3.3 0 0 1 3.61-.7zm-10.75 3.58v9.9l-.19.74-.04.22-.43-.14-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19zM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28m16.47 6.84-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $cdb0ff5c001a8842$export$4c619b105e3e610e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit24Regular', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v9.66c0 .71.43 1.35 1.1 1.62l7.5 3.04q.2.09.42.14l.04-.22.46-1.83q.25-.99.97-1.71l.26-.26v-6.84l7.75-3v3.24a3 3 0 0 1 1.5.25V7.17c0-.7-.43-1.35-1.1-1.62zm-2.25 1.4a2.3 2.3 0 0 1 1.7 0l6.59 2.67-2.67 1.03-7.53-2.93zM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56zM3.5 7.75l7.75 3.01v9.38l-.1-.04-7.5-3.04a.3.3 0 0 1-.15-.23zm15.6 4.92-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $cdb0ff5c001a8842$export$7c54ac7343988191 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34A2.5 2.5 0 0 1 14 10.1v4.78q0 .3-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.1a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zM6.42 7.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v4.78a1.5 1.5 0 0 1-.96 1.4l-3.46 1.33a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4zm4.67 2.91a.5.5 0 0 0-.64-.28L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.8-1.07a.5.5 0 0 0 .3-.65"
]);
const $cdb0ff5c001a8842$export$7a5904599c8de3da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.71A1.5 1.5 0 0 0 7 5.11v1.1a4 4 0 0 1 1 0v-1.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47v7.78c0 .2-.13.4-.32.47L14 14.39v.5q0 .3-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.11a1.5 1.5 0 0 0-.96-1.4zm2.51 2.92a.5.5 0 0 0-.64-.3l-2.77 1.07a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 1 0-.35.93l2.76 1.07q.54.2 1.08 0l2.76-1.07a.5.5 0 0 0 .3-.64m-5 5a.5.5 0 0 0-.64-.3L7.5 11.15l-2.95-1.13a.5.5 0 0 0-.35.93L7 12.02v2.49a.5.5 0 1 0 1 0v-2.49l2.8-1.08a.5.5 0 0 0 .3-.64M8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.71a1.5 1.5 0 0 0-.96 1.4v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l3.46-1.33c.58-.22.96-.78.96-1.4v-4.78a1.5 1.5 0 0 0-.96-1.4zm-1.8.93a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47v4.78c0 .2-.13.4-.32.47l-3.46 1.33a2 2 0 0 1-1.44 0l-3.46-1.33a.5.5 0 0 1-.32-.47v-4.78c0-.2.13-.4.32-.47z"
]);
const $cdb0ff5c001a8842$export$ec5f02843edeb791 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple24Filled', "24", [
    "M16.3 2.33a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c1.08.4 1.8 1.42 1.8 2.57v5.67q0 .49-.16.93l4.02-1.49c.68-.25 1.14-.9 1.14-1.64V5.56c0-.73-.46-1.38-1.14-1.64zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.2-1.14 0zM7.7 9.53a3.8 3.8 0 0 1 2.6 0l4.3 1.6c.7.24 1.15.9 1.15 1.63v5.67c0 .73-.46 1.39-1.14 1.64l-4.31 1.6c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64zM5.3 13.7c-.13.4.08.82.47.96l2.48.85v2.7a.75.75 0 0 0 1.5 0v-2.7l2.47-.85a.75.75 0 0 0-.49-1.42L9 14.2l-2.74-.95a.75.75 0 0 0-.95.46"
]);
const $cdb0ff5c001a8842$export$7693ebb461ff8129 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple24Regular', "24", [
    "M15.78 3.74a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v2.8q-.75-.12-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.8 3.8 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v10.67c0 .74-.46 1.4-1.14 1.64l-4.02 1.49q.16-.44.16-.93v-.73l3.34-1.23q.16-.07.16-.24V5.56q-.01-.17-.16-.23zm-4.01 3.93a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.18-1.14 0zm-6 7a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95a.75.75 0 1 1 .5 1.42l-2.48.85v2.7a.75.75 0 0 1-1.5 0v-2.7zm4.53-5.14a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.24-1.15.9-1.15 1.63v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l4.3-1.6c.7-.25 1.15-.9 1.15-1.64v-5.67c0-.73-.46-1.39-1.14-1.64zm-2.08 1.4c.5-.18 1.06-.18 1.56 0l4.3 1.6q.16.06.17.23v5.67q-.01.17-.16.24l-4.31 1.59c-.5.18-1.06.18-1.56 0l-4.3-1.6a.3.3 0 0 1-.17-.23v-5.67q.01-.17.16-.23z"
]);
const $cdb0ff5c001a8842$export$29f81a03dc56c947 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.6 5.6 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zm-3.41 4.18q.45.18.71.57-.94.32-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.5 5.5 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 1 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $cdb0ff5c001a8842$export$47451f95c6ddae33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47V9.6q.55.27 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4zM12.04 8.7q.45.18.71.57-.5.17-.95.43l-.12-.07-3.46-1.33a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42q.17.48.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zm-1.6 1.3a.5.5 0 0 1 .61.2q-.54.45-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7q.54.21 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.34a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 1 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $cdb0ff5c001a8842$export$2a8d19d22362d940 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft24Filled', "24", [
    "M16.3 2.33a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6q.79.29 1.26.94a6.5 6.5 0 0 1 5.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.2-1.14 0zm2.84 3.91q.3.11.53.32a6.5 6.5 0 0 0-2.68 1.95.8.8 0 0 0-.73-.14L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.79-.62a6.5 6.5 0 0 0 .5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.8 3.8 0 0 1 2.6 0zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.5.5a.5.5 0 1 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18z"
]);
const $cdb0ff5c001a8842$export$5c14d5f8b15ffe3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft24Regular', "24", [
    "M15.78 3.74a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v2.8q-.75-.12-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.8 3.8 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a7 7 0 0 0-1.5-.97V5.56q-.01-.17-.16-.23zm-1.17 7.38q.3.11.53.32-.86.33-1.58.9l-3.78-1.4a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v5.67q.01.17.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59q.25.72.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.8 3.8 0 0 1 2.6 0zm-2.88 2.13a.8.8 0 0 1 .73.14 7 7 0 0 0-.92 1.51l-1.79.62v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2zm.04-5.58a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.18-1.14 0zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.5.5a.5.5 0 1 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18z"
]);
const $cdb0ff5c001a8842$export$f984f542c9a972a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.6 5.6 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zm-3.41 4.18q.45.18.71.57-.94.32-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.5 5.5 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $cdb0ff5c001a8842$export$ef1483bf61600ba2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47V9.6q.55.27 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4zM12.04 8.7q.45.18.71.57-.5.17-.95.43l-.12-.07-3.46-1.33a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42q.17.48.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zm-1.6 1.3a.5.5 0 0 1 .61.2q-.54.45-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7q.54.21 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.36a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $cdb0ff5c001a8842$export$afb98287708ec813 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight24Filled', "24", [
    "M16.3 2.33a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6q.79.29 1.26.94a6.5 6.5 0 0 1 5.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.2-1.14 0zm2.84 3.91q.3.11.53.32a6.5 6.5 0 0 0-2.68 1.95.8.8 0 0 0-.73-.14L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.79-.62a6.5 6.5 0 0 0 .5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.8 3.8 0 0 1 2.6 0zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $cdb0ff5c001a8842$export$6ffe25e836555e15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight24Regular', "24", [
    "M15.78 3.74a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v2.8q-.75-.12-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.8 3.8 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a7 7 0 0 0-1.5-.97V5.56q-.01-.17-.16-.23zm-1.17 7.38q.3.11.53.32-.86.33-1.58.9l-3.78-1.4a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v5.67q.01.17.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59q.25.72.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.8 3.8 0 0 1 2.6 0zm-2.88 2.13a.8.8 0 0 1 .73.14 7 7 0 0 0-.92 1.51l-1.79.62v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2zm.04-5.58a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.18-1.14 0zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $cdb0ff5c001a8842$export$3c8d8fdb171078d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.6 5.6 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zm-3.41 4.18q.45.18.71.57-.94.32-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.5 5.5 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$bfe0970a991f39b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47V9.6q.55.27 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4zM12.04 8.7q.45.18.71.57-.5.17-.95.43l-.12-.07-3.46-1.33a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42q.17.48.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zm-1.6 1.3a.5.5 0 0 1 .61.2q-.54.45-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7q.54.21 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.84a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$beffb9012a43a834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark24Filled', "24", [
    "M16.3 2.33a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6q.79.29 1.26.94a6.5 6.5 0 0 1 5.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.2-1.14 0zm2.84 3.91q.3.11.53.32a6.5 6.5 0 0 0-2.68 1.95.8.8 0 0 0-.73-.14L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.79-.62a6.5 6.5 0 0 0 .5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.8 3.8 0 0 1 2.6 0zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$59b8245a73db5ab4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark24Regular', "24", [
    "M15.78 3.74a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v2.8q-.75-.12-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.8 3.8 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a7 7 0 0 0-1.5-.97V5.56q-.01-.17-.16-.23zm-1.17 7.38q.3.11.53.32-.86.33-1.58.9l-3.78-1.4a2.3 2.3 0 0 0-1.56 0l-4.3 1.59a.3.3 0 0 0-.17.23v5.67q.01.17.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59q.25.72.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.8 3.8 0 0 1 2.6 0zm-2.88 2.13a.8.8 0 0 1 .73.14 7 7 0 0 0-.92 1.51l-1.79.62v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2zm.04-5.58a.75.75 0 1 1 .49-1.42l2.66.92q.07.03.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92q-.57.18-1.14 0zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$eaa9a10e07a403ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch20Filled', "20", [
    "M11.42 2.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78q0 .11-.02.22A4.5 4.5 0 0 0 13.74 9a2.5 2.5 0 0 0-1.34-1.23L8.94 6.44A4 4 0 0 0 7 6.21V5.1c0-.62.38-1.18.96-1.4zm4.67 2.44a.5.5 0 0 0-.64-.29L12.68 5.6a.5.5 0 0 1-.36 0L9.55 4.53a.5.5 0 0 0-.35.94l2.76 1.06q.54.2 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M12.6 9.09a2 2 0 0 0-.56-.38L8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.7A1.5 1.5 0 0 0 2 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l1.94-.75a4.5 4.5 0 0 1-1.02-5.43l-1.5.58v2.49a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13L10.45 10a1 1 0 0 1 .25-.03q.83-.67 1.9-.9m3.7 6.5q.68-.89.7-2.1a3.5 3.5 0 1 0-1.4 2.81l2.55 2.55a.5.5 0 0 0 .7-.7zm-.3-2.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $cdb0ff5c001a8842$export$33b385621f3b6da3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch20Regular', "20", [
    "M11.42 2.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78q0 .11-.02.22a4.5 4.5 0 0 0-.98-2.44V5.11a.5.5 0 0 0-.32-.47l-3.46-1.33a2 2 0 0 0-1.44 0L8.32 4.64a.5.5 0 0 0-.32.47v1.1a4 4 0 0 0-1 0V5.1c0-.62.38-1.18.96-1.4zm1.18 6.7a2 2 0 0 0-.56-.37L8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.7A1.5 1.5 0 0 0 2 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l1.94-.75q-.4-.35-.71-.8l-1.6.62a2 2 0 0 1-1.43 0l-3.46-1.33a.5.5 0 0 1-.32-.47V10.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.16 1.22q.57-.3 1.22-.44m-1.9.9a1 1 0 0 0-.25.03L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l1.5-.57q.44-.87 1.2-1.46M15.45 5a.5.5 0 1 1 .35.93L13.04 7a1.5 1.5 0 0 1-1.08 0L9.2 5.94A.5.5 0 0 1 9.55 5l2.77 1.06a.5.5 0 0 0 .36 0zm.85 10.59q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-.3-2.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $cdb0ff5c001a8842$export$42888c1b2ef6009c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch24Filled', "24", [
    "M13.7 2.33a3.8 3.8 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v9.3A5.5 5.5 0 0 0 16.12 11q-.46-.55-1.17-.83l-4.3-1.59a5 5 0 0 0-2.4-.23v-2.8c0-.73.46-1.38 1.14-1.64zm-2.4 3.92c-.13.4.08.82.47.96l2.66.92q.57.2 1.14 0l2.65-.92a.75.75 0 0 0-.49-1.42l-2.65.92a.3.3 0 0 1-.16 0l-2.66-.92a.75.75 0 0 0-.95.46m3.57 5-.26-.13-4.31-1.6a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.91-1.15 1.64v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l2.64-.98a5.5 5.5 0 0 1-1.74-5.67l-1.45.5v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95a1 1 0 0 1 .36-.03 5.5 5.5 0 0 1 2.78-1.98m5.3 7.86a4.5 4.5 0 1 0-1.06 1.06l2.61 2.6a.75.75 0 0 0 1.06-1.05zm-.67-2.61a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
]);
const $cdb0ff5c001a8842$export$e5a4c86d373e39bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch24Regular', "24", [
    "M14.22 3.74c.5-.19 1.06-.19 1.56 0l4.3 1.59q.16.07.17.23v6.92a5.5 5.5 0 0 1 1.5 2.37V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8q.75-.12 1.5 0v-2.8q.01-.17.16-.23zm.65 7.5-.26-.12-4.31-1.6a3.8 3.8 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.91-1.15 1.64v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l2.64-.98q-.62-.53-1.06-1.2l-2.1.77c-.5.18-1.06.18-1.56 0l-4.3-1.6a.3.3 0 0 1-.17-.23v-5.67q.01-.17.16-.23l4.31-1.6c.5-.18 1.06-.18 1.56 0l3.33 1.24q.79-.62 1.76-.93m-2.78 1.98a1 1 0 0 0-.36.03L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.45-.5q.28-1 .89-1.8m-.78-6.5c-.14.38.07.81.46.95l2.66.92q.57.18 1.14 0l2.65-.92a.75.75 0 0 0-.49-1.42l-2.65.92a.3.3 0 0 1-.16 0l-2.66-.92a.75.75 0 0 0-.95.46m8.86 12.39a4.5 4.5 0 1 0-1.06 1.06l2.61 2.6a.75.75 0 0 0 1.06-1.05zm-.67-2.61a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
]);
const $cdb0ff5c001a8842$export$df530466113928f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch16Filled', "16", [
    "M11.65 4.32 5.04 1.5l-2.08.8q-.31.12-.53.35L9 5.46zM7.92.38l-1.55.6 6.55 2.8 2.65-1.14a2 2 0 0 0-.53-.35L10.08.38a3 3 0 0 0-2.16 0M9.5 6.33 16 3.55v6.76a1.5 1.5 0 0 1-.96 1.4l-4.96 1.91a3 3 0 0 1-.58.16zm-1 4.17V6.33L2 3.55v2.71A5 5 0 0 1 3.5 6c2.76 0 5 2.01 5 4.5m-5 3.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 12.6A3.5 3.5 0 1 0 3.5 14m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$f96c4c06e7dfffcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch16Regular', "16", [
    "M10.08.38a3 3 0 0 0-2.16 0l-4.96 1.9A1.5 1.5 0 0 0 2 3.69v2.58q.48-.18 1-.23V3.97l5.5 2.36v7.05l.44.44a3 3 0 0 0 1.14-.2l4.96-1.9c.58-.23.96-.79.96-1.4V3.68a1.5 1.5 0 0 0-.96-1.4zm-1.8.93a2 2 0 0 1 1.44 0l4.72 1.82-1.95.83-5.6-2.12zM9.5 6.33 15 3.97v6.34c0 .21-.13.4-.32.47l-4.96 1.9q-.11.06-.22.08zM9 5.46 3.56 3.13l1.94-.75 5.66 2.15zM3.5 14c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 12.6A3.5 3.5 0 1 0 3.5 14m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$34d95cccedc0f8cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch20Filled', "20", [
    "m10 7.96 3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v3.08a4.5 4.5 0 0 1 5.56 6.18l1.94 1.94V8.84zm8.46 11.87q.4-.05.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18q0-.17-.04-.33L10.5 8.84zM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M3.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 15.6A3.5 3.5 0 1 0 3.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$4b35fbbf731a3600 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch20Regular', "20", [
    "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v7.64a1.5 1.5 0 0 1-.94 1.4l-5.76 2.3q-.73.29-1.5.24a2 2 0 0 0-.24-.32l-.06-.06V8.84L3 6.24v2.79q-.52.05-1 .23V6.18c0-.62.37-1.17.94-1.4zm2.23.93a2.5 2.5 0 0 0-1.86 0l-1.35.54 6.16 2.46 2.27-.91zm1.6 3.54L6.38 4.49l-2.53 1L10 7.97zM17 6.24l-6.5 2.6v7.88q.22-.04.43-.13l5.76-2.3a.5.5 0 0 0 .31-.47zM3.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 15.6A3.5 3.5 0 1 0 3.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$879052b336dedf00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.89L18 7.13l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.57V21.7q.33-.07.66-.2l7.5-3.04c.66-.27 1.09-.91 1.09-1.62zm-10.75 3.57v10.01l-1.82-1.82q.55-1.12.57-2.45a5.5 5.5 0 0 0-8-4.9V7.19zM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28M4.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 4.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $cdb0ff5c001a8842$export$685fdae2ba6d1b45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch24Regular', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v4.43q.7-.36 1.5-.5V7.74l7.75 3.01v10.02l.24.23q.32.34.44.75.76.02 1.48-.27l7.5-3.04c.66-.27 1.09-.91 1.09-1.62V7.17c0-.7-.43-1.35-1.1-1.62zm-2.25 1.4a2.3 2.3 0 0 1 1.7 0l6.59 2.66-2.67 1.04-7.53-2.93zM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56zm13.13 11.56-7.5 3.04-.09.03v-9.37l7.75-2.99v9.06q0 .16-.16.23M4.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 4.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $cdb0ff5c001a8842$export$d9cd89e289f4c0a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1V13.5q.02-.85.5-1.5V8.84zM18 6.17v4.87h-.04A2.5 2.5 0 0 0 15.5 9h-2a2.5 2.5 0 0 0-2.46 2.04q-.28.06-.54.17V8.84l7.46-2.99q.04.16.04.33M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0"
]);
const $cdb0ff5c001a8842$export$d7c9a19f2bdf5748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1v-1.06L3.31 14.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6V12q.4-.52 1-.8V8.85l6.5-2.6V9.5c.5.37.84.91.96 1.54l.04.01V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm5.63 7.5v-.5c0-.82.67-1.49 1.5-1.49h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm3.5-1h-2a.5.5 0 0 0-.5.5v.5h3v-.5a.5.5 0 0 0-.5-.5M17 16.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0"
]);
const $cdb0ff5c001a8842$export$481471f1d6407116 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox24Filled', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3q-.21-.17-.46-.28zM22 7.2l-9.25 3.58v3.35l.25-.07V14a2.75 2.75 0 0 1 2.75-2.75h3.5A2.75 2.75 0 0 1 22 14zm-10.75 3.58v4.64q-.24.5-.25 1.1v5.12l-.4-.14-7.5-3.04c-.67-.27-1.1-.91-1.1-1.62V7.19zM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54q-.25.1-.46.28M14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5"
]);
const $cdb0ff5c001a8842$export$771102eba01260fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox24Regular', "24", [
    "M13.4 2.51a3.8 3.8 0 0 0-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v9.66c0 .71.43 1.35 1.1 1.62l7.5 3.04.4.14v-1.59l-7.34-2.98a.3.3 0 0 1-.16-.23V7.75l7.75 3.01v4.65a2.5 2.5 0 0 1 1.5-1.3v-3.34l7.75-3v3.78C21.39 12 22 12.93 22 14V7.17c0-.7-.43-1.35-1.1-1.62zm-2.25 1.4a2.3 2.3 0 0 1 1.7 0l6.59 2.67-2.67 1.03-7.53-2.93zM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56zM14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5"
]);
const $cdb0ff5c001a8842$export$625eb710d5531409 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03q.54.1 1 .4V5a3 3 0 0 0-3-3zm.5 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM5 8.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M6.5 11a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42z"
]);
const $cdb0ff5c001a8842$export$63c7f4837099fa0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03q.54.1 1 .4V5a3 3 0 0 0-3-3zm1.5 9a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42zm3.34 3.5L7.6 12h6.98a.5.5 0 0 1 .35.14L17.9 15l-2.95 2.86a.5.5 0 0 1-.35.14H7.61l2.23-2.5a.75.75 0 0 0 0-1M5 5.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M5.5 8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $cdb0ff5c001a8842$export$390fd890611ff40a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram24Filled', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h10.5C17.55 2 19 3.46 19 5.25v6.03a3 3 0 0 0-1.22-.28h-.28V5.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h3.37L7.36 20H5.25A3.25 3.25 0 0 1 2 16.75zM6.75 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm.32 6.43a.8.8 0 0 1 .68-.43h10.03c.52 0 1.01.23 1.34.62l3.7 4.4c.24.28.24.68 0 .96l-3.7 4.4c-.33.4-.82.62-1.34.62H7.75a.75.75 0 0 1-.57-1.23l3.59-4.27-3.6-4.27a.8.8 0 0 1-.1-.8M6.75 9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $cdb0ff5c001a8842$export$a1d9aa6eb9f55883 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram24Regular', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h10.5C17.55 2 19 3.46 19 5.25v6.03a3 3 0 0 0-1.22-.28h-.28V5.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h3.37L7.36 20H5.25A3.25 3.25 0 0 1 2 16.75zM6.75 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm.32 6.43a.8.8 0 0 1 .68-.43h10.03c.52 0 1.01.23 1.34.62l3.7 4.4c.24.28.24.68 0 .96l-3.7 4.4c-.33.4-.82.62-1.34.62H7.75a.75.75 0 0 1-.57-1.23l3.59-4.27-3.6-4.27a.8.8 0 0 1-.1-.8m2.3 1.07 2.95 3.52c.24.28.24.68 0 .96L9.36 21.5h8.42q.12 0 .2-.09l3.29-3.91-3.3-3.91a.3.3 0 0 0-.19-.09zM6.74 9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $cdb0ff5c001a8842$export$320b0461b1da4175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad20Filled', "20", [
    "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $cdb0ff5c001a8842$export$f132371f8df12155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad20Regular', "20", [
    "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $cdb0ff5c001a8842$export$172f3c5de5a6fb7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad24Filled', "24", [
    "M12 17.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $cdb0ff5c001a8842$export$ca341f40ab6d57b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad24Regular', "24", [
    "M12 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m0-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-10 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-10 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-10 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $cdb0ff5c001a8842$export$5c51a26323a650bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad28Filled', "28", [
    "M7.5 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6.5-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6.5-18a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $cdb0ff5c001a8842$export$c7ba0b979c7181d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad28Regular', "28", [
    "M9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6.5-12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6.5-18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $cdb0ff5c001a8842$export$e054f1196e062a8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad32Filled', "32", [
    "M9 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m7-14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m7-21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $cdb0ff5c001a8842$export$52b33ac2b3a08f61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad32Regular', "32", [
    "M11 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7-14a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7-21a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $cdb0ff5c001a8842$export$b62b51f49b1aee4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad48Filled', "48", [
    "M13.5 11.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m10.5-20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m10.5-30a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
]);
const $cdb0ff5c001a8842$export$c3a7ae4bd8598ec6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad48Regular', "48", [
    "M16 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m10.5-20a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M37 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $cdb0ff5c001a8842$export$79597ee4189115be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l3.9 3.9H6a1.25 1.25 0 1 0 1.25 1.2l2.8 2.8H10a1.25 1.25 0 1 0 1.25 1.2l5.9 5.9a.5.5 0 0 0 .7-.7zM15.25 12q-.02.48-.3.82l-1.77-1.76q.34-.3.82-.31c.69 0 1.25.56 1.25 1.25m-4-4q-.02.48-.3.82L9.17 7.06q.33-.3.82-.31c.69 0 1.25.56 1.25 1.25m-4-4q-.01.48-.3.82L5.17 3.06q.33-.3.82-.31c.69 0 1.25.56 1.25 1.25m0 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $cdb0ff5c001a8842$export$80e5a244ea31ac0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l4.2 4.22A1 1 0 0 0 5 8a1 1 0 1 0 1.93-.36l3.43 3.43a1 1 0 1 0 .57.57l6.22 6.21a.5.5 0 0 0 .7-.7zM15 12a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 15 12m-4-4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 11 8M7 4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 7 4m0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $cdb0ff5c001a8842$export$6f1d80b2122cf889 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.5 4.5a1.5 1.5 0 1 0 1.76 1.76l3.24 3.24a1.5 1.5 0 1 0 1.75 1.75l7.25 7.25a.75.75 0 0 0 1.06-1.06zM18.5 14.25q-.01.46-.25.82l-2.07-2.08q.35-.23.82-.24c.82 0 1.5.67 1.5 1.5m-5-5q0 .46-.25.82L11.18 8q.36-.25.82-.25c.83 0 1.5.67 1.5 1.5m-5-5q0 .46-.24.83L6.18 3q.37-.24.82-.25c.83 0 1.5.67 1.5 1.5m3.5 13.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m10-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $cdb0ff5c001a8842$export$2ed0277692c788a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.5 4.5a1.25 1.25 0 1 0 1.5 1.5l3.5 3.5a1.25 1.25 0 1 0 1.5 1.5l7.5 7.5a.75.75 0 0 0 1.06-1.06zM18.25 14q0 .46-.28.79l-1.76-1.76q.33-.28.79-.28c.69 0 1.25.56 1.25 1.25m-5-5q0 .46-.28.79l-1.76-1.76q.34-.27.79-.28c.69 0 1.25.56 1.25 1.25m-5-5q0 .46-.28.79L6.21 3.03q.34-.27.8-.28c.68 0 1.24.56 1.24 1.25M12 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m10-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $cdb0ff5c001a8842$export$a63f80c9ad224013 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark20Filled', "20", [
    "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4-8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m.41 1.57a5.5 5.5 0 0 0-1.2 2.15 1.25 1.25 0 0 1 1.2-2.15m4.33-1.81a1.25 1.25 0 1 0-1.32.1 6 6 0 0 1 1.32-.1M14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.62-2a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0m-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 0 1-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 1 1-1 0"
]);
const $cdb0ff5c001a8842$export$addd50f5230d316f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark20Regular', "20", [
    "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2 .23.03a6 6 0 0 0-.93 1.68A1 1 0 0 1 10 11m5-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25m0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95"
]);
const $cdb0ff5c001a8842$export$79752ba09487d58d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark24Filled', "24", [
    "M12 2.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.5 6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M7 12.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0q.46 0 .82.24a6.5 6.5 0 0 0-1.53 2.58 1.5 1.5 0 0 1 .71-2.82m5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-8.5 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m10-5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M7 2.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-6.12 2.88a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0m-1.23-4.55c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .51-.15.85-.53 1.3l-.13.15-.27.3-.1.1-.08.11c-.18.23-.24.39-.24.6a.5.5 0 1 1-1 0c0-.53.15-.86.53-1.32l.14-.16.27-.29.1-.1.09-.12c.17-.22.22-.37.22-.57 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 1 1-1 0"
]);
const $cdb0ff5c001a8842$export$c2a0825d2db73f9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark24Regular', "24", [
    "M12 2.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M13.25 9a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M7 12.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m5 0q.46 0 .78.28a7 7 0 0 0-1.33 2.1 1.25 1.25 0 0 1 .55-2.38m5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M8.25 9a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m10-5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M7 2.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 7.75a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25m0-5.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 0 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.05.35-.22.57l-.1.11-.1.11-.26.3-.14.15c-.38.46-.53.8-.53 1.31a.5.5 0 0 0 1 0c0-.2.06-.36.24-.59l.08-.1.1-.12.27-.29.13-.15c.38-.45.53-.79.53-1.3 0-1.1-.82-1.95-1.85-1.95"
]);
const $cdb0ff5c001a8842$export$e6f5359c2b9f06d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond12Filled', "12", [
    "M4.59 1.09a2 2 0 0 1 2.82 0l3.5 3.5a2 2 0 0 1 0 2.82l-3.5 3.5a2 2 0 0 1-2.82 0l-3.5-3.5a2 2 0 0 1 0-2.83z"
]);
const $cdb0ff5c001a8842$export$31a1879572a1baa0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond12Regular', "12", [
    "M4.59 1.09a2 2 0 0 1 2.82 0l3.5 3.5a2 2 0 0 1 0 2.82l-3.5 3.5a2 2 0 0 1-2.82 0l-3.5-3.5a2 2 0 0 1 0-2.82zm2.12.7a1 1 0 0 0-1.42 0L1.8 5.3a1 1 0 0 0 0 1.42l3.5 3.5a1 1 0 0 0 1.42 0l3.5-3.5a1 1 0 0 0 0-1.42z"
]);
const $cdb0ff5c001a8842$export$d0ba88dff23ce453 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond16Filled', "16", [
    "M6.23 1.23a2.5 2.5 0 0 1 3.54 0l5 5a2.5 2.5 0 0 1 0 3.54l-5 5a2.5 2.5 0 0 1-3.54 0l-5-5a2.5 2.5 0 0 1 0-3.54z"
]);
const $cdb0ff5c001a8842$export$fd00e1f210c37de5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond16Regular', "16", [
    "M6.23 1.23a2.5 2.5 0 0 1 3.54 0l5 5a2.5 2.5 0 0 1 0 3.54l-5 5a2.5 2.5 0 0 1-3.54 0l-5-5a2.5 2.5 0 0 1 0-3.54zm2.83.7a1.5 1.5 0 0 0-2.12 0l-5 5a1.5 1.5 0 0 0 0 2.13l5 5a1.5 1.5 0 0 0 2.12 0l5-5a1.5 1.5 0 0 0 0-2.12z"
]);
const $cdb0ff5c001a8842$export$68987415441b9598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond20Filled', "20", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24z"
]);
const $cdb0ff5c001a8842$export$7ab72549f2ef4d4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond20Regular', "20", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zm3.53.7a2 2 0 0 0-2.83 0l-6 6a2 2 0 0 0 0 2.83l6 6a2 2 0 0 0 2.83 0l6-6a2 2 0 0 0 0-2.83z"
]);
const $cdb0ff5c001a8842$export$a4be75541bffd0b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond24Filled', "24", [
    "M9.71 1.96a3.25 3.25 0 0 1 4.6 0l7.75 7.75a3.25 3.25 0 0 1 0 4.6l-7.75 7.75a3.25 3.25 0 0 1-4.6 0L1.96 14.3a3.25 3.25 0 0 1 0-4.6z"
]);
const $cdb0ff5c001a8842$export$8c510bc11a7b2fd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond24Regular', "24", [
    "M9.71 1.96a3.25 3.25 0 0 1 4.6 0l7.75 7.75a3.25 3.25 0 0 1 0 4.6l-7.75 7.75a3.25 3.25 0 0 1-4.6 0L1.96 14.3a3.25 3.25 0 0 1 0-4.6zm3.54 1.06a1.75 1.75 0 0 0-2.48 0l-7.75 7.75c-.68.69-.68 1.8 0 2.48L10.77 21c.69.68 1.8.68 2.48 0L21 13.25c.68-.69.68-1.8 0-2.48z"
]);
const $cdb0ff5c001a8842$export$8a5503f457e8ee69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond28Filled', "28", [
    "M11.35 2.1a3.75 3.75 0 0 1 5.3 0l9.25 9.25a3.75 3.75 0 0 1 0 5.3l-9.25 9.25a3.75 3.75 0 0 1-5.3 0L2.1 16.65a3.75 3.75 0 0 1 0-5.3z"
]);
const $cdb0ff5c001a8842$export$a24551263daabfb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond28Regular', "28", [
    "M11.35 2.1a3.75 3.75 0 0 1 5.3 0l9.25 9.25a3.75 3.75 0 0 1 0 5.3l-9.25 9.25a3.75 3.75 0 0 1-5.3 0L2.1 16.65a3.75 3.75 0 0 1 0-5.3zm4.24 1.06a2.25 2.25 0 0 0-3.18 0l-9.25 9.25c-.88.88-.88 2.3 0 3.18l9.25 9.25c.88.88 2.3.88 3.18 0l9.25-9.25c.88-.88.88-2.3 0-3.18z"
]);
const $cdb0ff5c001a8842$export$b96d872f2a40a4c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond32Filled', "32", [
    "M12.82 2.32a4.5 4.5 0 0 1 6.36 0l10.5 10.5a4.5 4.5 0 0 1 0 6.36l-10.5 10.5a4.5 4.5 0 0 1-6.36 0l-10.5-10.5a4.5 4.5 0 0 1 0-6.36z"
]);
const $cdb0ff5c001a8842$export$770b1ea9dd679a19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond32Regular', "32", [
    "M12.82 2.32a4.5 4.5 0 0 1 6.36 0l10.5 10.5a4.5 4.5 0 0 1 0 6.36l-10.5 10.5a4.5 4.5 0 0 1-6.36 0l-10.5-10.5a4.5 4.5 0 0 1 0-6.36zm4.95 1.41a2.5 2.5 0 0 0-3.54 0l-10.5 10.5a2.5 2.5 0 0 0 0 3.54l10.5 10.5a2.5 2.5 0 0 0 3.54 0l10.5-10.5a2.5 2.5 0 0 0 0-3.54z"
]);
const $cdb0ff5c001a8842$export$2c9ebb3af0d9c309 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond48Filled', "48", [
    "M19.58 4.83a6.25 6.25 0 0 1 8.84 0l14.75 14.75a6.25 6.25 0 0 1 0 8.84L28.42 43.17a6.25 6.25 0 0 1-8.84 0L4.83 28.42a6.25 6.25 0 0 1 0-8.84z"
]);
const $cdb0ff5c001a8842$export$cc0042640c9a646 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond48Regular', "48", [
    "M19.58 4.83a6.25 6.25 0 0 1 8.84 0l14.75 14.75a6.25 6.25 0 0 1 0 8.84L28.42 43.17a6.25 6.25 0 0 1-8.84 0L4.83 28.42a6.25 6.25 0 0 1 0-8.84zm7.07 1.77a3.75 3.75 0 0 0-5.3 0L6.6 21.35a3.75 3.75 0 0 0 0 5.3l14.75 14.76a3.75 3.75 0 0 0 5.3 0l14.76-14.76a3.75 3.75 0 0 0 0-5.3z"
]);
const $cdb0ff5c001a8842$export$170661f7405b6172 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss12Filled', "12", [
    "M4.59 1.09a2 2 0 0 1 2.82 0l3.5 3.5a2 2 0 0 1 0 2.82l-3.5 3.5a2 2 0 0 1-2.82 0l-3.5-3.5a2 2 0 0 1 0-2.83zm3.26 3.06a.5.5 0 0 0-.7 0L6 5.29 4.85 4.15a.5.5 0 0 0-.7.7L5.29 6 4.15 7.15a.5.5 0 0 0 .7.7L6 6.71l1.15 1.14a.5.5 0 1 0 .7-.7L6.71 6l1.14-1.15a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$a91795412409208f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss12Regular', "12", [
    "M4.59 1.09a2 2 0 0 1 2.82 0l3.5 3.5a2 2 0 0 1 0 2.82l-3.5 3.5a2 2 0 0 1-2.82 0l-3.5-3.5a2 2 0 0 1 0-2.83zm2.12.7a1 1 0 0 0-1.42 0L1.8 5.3a1 1 0 0 0 0 1.42l3.5 3.5a1 1 0 0 0 1.42 0l3.5-3.5a1 1 0 0 0 0-1.42zm.44 2.36a.5.5 0 1 1 .7.7L6.71 6l1.14 1.15a.5.5 0 0 1-.7.7L6 6.71 4.85 7.85a.5.5 0 0 1-.7-.7L5.29 6 4.15 4.85a.5.5 0 0 1 .7-.7L6 5.29z"
]);
const $cdb0ff5c001a8842$export$4268910a0e116ef8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss16Filled', "16", [
    "M6.23 1.23a2.5 2.5 0 0 1 3.54 0l5 5a2.5 2.5 0 0 1 0 3.54l-5 5a2.5 2.5 0 0 1-3.54 0l-5-5a2.5 2.5 0 0 1 0-3.54zm4.38 4.17a.5.5 0 0 0-.71 0L8 7.3 6.1 5.4a.5.5 0 0 0-.7.7L7.3 8 5.4 9.9a.5.5 0 0 0 .7.7L8 8.7l1.9 1.9a.5.5 0 0 0 .7-.7L8.7 8l1.9-1.9a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$a9c402885e246512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss16Regular', "16", [
    "M6.23 1.23a2.5 2.5 0 0 1 3.54 0l5 5a2.5 2.5 0 0 1 0 3.54l-5 5a2.5 2.5 0 0 1-3.54 0l-5-5a2.5 2.5 0 0 1 0-3.54zm2.83.7a1.5 1.5 0 0 0-2.12 0l-5 5a1.5 1.5 0 0 0 0 2.13l5 5a1.5 1.5 0 0 0 2.12 0l5-5a1.5 1.5 0 0 0 0-2.12zM9.9 5.4a.5.5 0 1 1 .7.7L8.7 8l1.9 1.9a.5.5 0 0 1-.7.7L8 8.7l-1.9 1.9a.5.5 0 0 1-.7-.7L7.3 8 5.4 6.1a.5.5 0 1 1 .7-.7L8 7.3z"
]);
const $cdb0ff5c001a8842$export$6092703789225435 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss20Filled', "20", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zM13.1 6.9a.5.5 0 0 0-.7 0L10 9.3 7.6 6.9a.5.5 0 0 0-.7.7L9.3 10l-2.4 2.4a.5.5 0 0 0 .7.7l2.4-2.4 2.4 2.4a.5.5 0 0 0 .7-.7L10.7 10l2.4-2.4a.5.5 0 0 0 0-.7"
]);
const $cdb0ff5c001a8842$export$5eff2aa96beae8f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss20Regular', "20", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zm3.53.7a2 2 0 0 0-2.83 0l-6 6a2 2 0 0 0 0 2.83l6 6a2 2 0 0 0 2.83 0l6-6a2 2 0 0 0 0-2.83zm.99 4.32a.5.5 0 1 1 .7.7L10.7 10l2.4 2.4a.5.5 0 0 1-.7.7L10 10.7l-2.4 2.4a.5.5 0 0 1-.7-.7L9.3 10 6.9 7.6a.5.5 0 0 1 .7-.7L10 9.3z"
]);
const $cdb0ff5c001a8842$export$73291f56b0cec2a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss24Filled', "24", [
    "M9.71 1.96a3.25 3.25 0 0 1 4.6 0l7.75 7.75a3.25 3.25 0 0 1 0 4.6l-7.75 7.75a3.25 3.25 0 0 1-4.6 0L1.96 14.3a3.25 3.25 0 0 1 0-4.6zm6.07 6.26a.75.75 0 0 0-1.06 0L12 10.94 9.28 8.22a.75.75 0 0 0-1.06 1.06L10.94 12l-2.72 2.72a.75.75 0 0 0 1.06 1.06L12 13.06l2.72 2.72a.75.75 0 0 0 1.06-1.06L13.06 12l2.72-2.72c.3-.3.3-.77 0-1.06"
]);
const $cdb0ff5c001a8842$export$6e6257d096cd22ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss24Regular', "24", [
    "M9.71 1.96a3.25 3.25 0 0 1 4.6 0l7.75 7.75a3.25 3.25 0 0 1 0 4.6l-7.75 7.75a3.25 3.25 0 0 1-4.6 0L1.96 14.3a3.25 3.25 0 0 1 0-4.6zm3.54 1.06a1.75 1.75 0 0 0-2.48 0l-7.75 7.75c-.68.69-.68 1.8 0 2.48L10.77 21c.69.68 1.8.68 2.48 0L21 13.25c.68-.69.68-1.8 0-2.48zm1.47 5.2a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 0 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 1 1 1.06-1.06L12 10.94z"
]);
const $cdb0ff5c001a8842$export$b4601eccd62510a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss28Filled', "28", [
    "M11.35 2.1a3.75 3.75 0 0 1 5.3 0l9.25 9.25a3.75 3.75 0 0 1 0 5.3l-9.25 9.26a3.75 3.75 0 0 1-5.3 0L2.1 16.65a3.75 3.75 0 0 1 0-5.3zm6.93 7.62a.75.75 0 0 0-1.06 0L14 12.94l-3.22-3.22a.75.75 0 1 0-1.06 1.06L12.94 14l-3.22 3.22a.75.75 0 0 0 1.06 1.06L14 15.06l3.22 3.22a.75.75 0 0 0 1.06-1.06L15.06 14l3.22-3.22c.3-.3.3-.77 0-1.06"
]);
const $cdb0ff5c001a8842$export$b282ccf6151fd322 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss28Regular', "28", [
    "M11.35 2.1a3.75 3.75 0 0 1 5.3 0l9.25 9.25a3.75 3.75 0 0 1 0 5.3l-9.25 9.26a3.75 3.75 0 0 1-5.3 0L2.1 16.65a3.75 3.75 0 0 1 0-5.3zm4.24 1.06a2.25 2.25 0 0 0-3.18 0l-9.25 9.25c-.88.88-.88 2.3 0 3.18l9.25 9.25c.88.88 2.3.88 3.18 0l9.25-9.25c.88-.88.88-2.3 0-3.18zm1.63 6.56a.75.75 0 0 1 1.06 1.06L15.06 14l3.22 3.22a.75.75 0 0 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 0 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94z"
]);
const $cdb0ff5c001a8842$export$1722697d3b3609c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss32Filled', "32", [
    "M12.82 2.32a4.5 4.5 0 0 1 6.36 0l10.5 10.5a4.5 4.5 0 0 1 0 6.36l-10.5 10.5a4.5 4.5 0 0 1-6.36 0l-10.5-10.5a4.5 4.5 0 0 1 0-6.36zm8.39 8.47a1 1 0 0 0-1.42 0L16 14.6l-3.8-3.8a1 1 0 0 0-1.4 1.42L14.58 16l-3.8 3.8a1 1 0 0 0 1.42 1.4L16 17.42l3.8 3.8a1 1 0 0 0 1.4-1.42L17.42 16l3.8-3.8a1 1 0 0 0 0-1.4"
]);
const $cdb0ff5c001a8842$export$52eef6c15ff013a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss32Regular', "32", [
    "M12.82 2.32a4.5 4.5 0 0 1 6.36 0l10.5 10.5a4.5 4.5 0 0 1 0 6.36l-10.5 10.5a4.5 4.5 0 0 1-6.36 0l-10.5-10.5a4.5 4.5 0 0 1 0-6.36zm4.95 1.41a2.5 2.5 0 0 0-3.54 0l-10.5 10.5a2.5 2.5 0 0 0 0 3.54l10.5 10.5a2.5 2.5 0 0 0 3.54 0l10.5-10.5a2.5 2.5 0 0 0 0-3.54zm2.02 7.06a1 1 0 1 1 1.42 1.42L17.4 16l3.8 3.8a1 1 0 0 1-1.42 1.4L16 17.42l-3.8 3.8a1 1 0 0 1-1.4-1.42L14.58 16l-3.8-3.8a1 1 0 1 1 1.42-1.4L16 14.58z"
]);
const $cdb0ff5c001a8842$export$acc758acc25613dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss48Filled', "48", [
    "M19.58 4.83a6.25 6.25 0 0 1 8.84 0l14.76 14.75a6.25 6.25 0 0 1 0 8.84L28.42 43.17a6.25 6.25 0 0 1-8.84 0L4.83 28.42a6.25 6.25 0 0 1 0-8.84zm12.06 11.54a1.25 1.25 0 0 0-1.77 0L24 22.23l-5.86-5.86a1.25 1.25 0 0 0-1.77 1.76L22.23 24l-5.86 5.87a1.25 1.25 0 0 0 1.77 1.76L24 25.77l5.87 5.86a1.25 1.25 0 0 0 1.77-1.76L25.77 24l5.87-5.87c.48-.48.48-1.28 0-1.76"
]);
const $cdb0ff5c001a8842$export$544d292f7a6e87c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss48Regular', "48", [
    "M19.58 4.83a6.25 6.25 0 0 1 8.84 0l14.75 14.75a6.25 6.25 0 0 1 0 8.84L28.42 43.17a6.25 6.25 0 0 1-8.84 0L4.83 28.42a6.25 6.25 0 0 1 0-8.84zm7.07 1.77a3.75 3.75 0 0 0-5.3 0L6.6 21.35a3.75 3.75 0 0 0 0 5.3l14.75 14.76a3.75 3.75 0 0 0 5.3 0l14.76-14.76a3.75 3.75 0 0 0 0-5.3zm3.22 9.77a1.25 1.25 0 0 1 1.76 1.76L25.77 24l5.86 5.87a1.25 1.25 0 1 1-1.76 1.76L24 25.77l-5.87 5.86a1.25 1.25 0 0 1-1.76-1.76L22.23 24l-5.86-5.87a1.25 1.25 0 0 1 1.76-1.76L24 22.23z"
]);
const $cdb0ff5c001a8842$export$7b073d1be7705e9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink16Filled', "16", [
    "M7.38 4.36a5.54 5.54 0 0 1 2.96 9.12l-.2.2-.72.74a2 2 0 0 1-2.83 0l-5-5a2 2 0 0 1 0-2.83l.73-.73q.47-.48 1.03-.81A7 7 0 0 0 3.29 7l-.64.64a.5.5 0 0 0 0 .7l5 5c.2.2.51.2.7 0l.74-.72.14-.16a4.04 4.04 0 0 0-2.45-6.7q.1-.76.6-1.41M6.6 1.59a2 2 0 0 1 2.83 0l5 5a2 2 0 0 1 0 2.82l-.73.73q-.49.48-1.03.81.17-.96.06-1.96l.64-.64a.5.5 0 0 0 0-.7l-5-5a.5.5 0 0 0-.7 0l-.74.73a4.03 4.03 0 0 0 2.3 6.85c-.07.5-.27 1-.6 1.41a5.54 5.54 0 0 1-2.76-9.33z"
]);
const $cdb0ff5c001a8842$export$ea81dc8db1170627 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink16Regular', "16", [
    "M6.82 4.28a5.54 5.54 0 0 1 3.31 9.42l-.72.72a2 2 0 0 1-2.82 0l-5-5a2 2 0 0 1 0-2.83l.71-.72q.5-.49 1.05-.82-.12.65-.1 1.3L3 6.59l-.72.71a1 1 0 0 0 0 1.42l5 5a1 1 0 0 0 1.42 0l.71-.72a4.54 4.54 0 0 0-3.04-7.74q.14-.5.44-.97m-.23-2.7a2 2 0 0 1 2.83 0l5 5a2 2 0 0 1 0 2.83l-.72.72q-.5.5-1.05.82.12-.65.1-1.3l.24-.22.72-.72a1 1 0 0 0 0-1.42l-5-5a1 1 0 0 0-1.42 0l-.72.72a4.54 4.54 0 0 0 3.05 7.74q-.15.52-.44.97A5.54 5.54 0 0 1 5.87 2.3z"
]);
const $cdb0ff5c001a8842$export$5b79ea4154f75cd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink20Filled', "20", [
    "M8.66 5.43a6.75 6.75 0 0 1 4 11.47h-.01l-.89.88a2.5 2.5 0 0 1-3.53 0l-6-6a2.5 2.5 0 0 1 0-3.55l.88-.88q.67-.65 1.44-1.1-.21.98-.17 1.96l-.2.2-.9.89a1 1 0 0 0 0 1.41l6.01 6a1 1 0 0 0 1.41 0l.89-.88a5.25 5.25 0 0 0-3.6-8.95q.2-.77.67-1.45m-.43-3.2a2.5 2.5 0 0 1 3.53 0l6 6a2.5 2.5 0 0 1 .01 3.54l-.88.88q-.66.65-1.44 1.1.21-.97.17-1.96l.2-.2.89-.88a1 1 0 0 0 0-1.41l-6-6a1 1 0 0 0-1.42 0l-.88.87a5.25 5.25 0 0 0 3.6 8.95q-.2.78-.67 1.46A6.75 6.75 0 0 1 7.35 3.11z"
]);
const $cdb0ff5c001a8842$export$424cd85b2b6dbff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink20Regular', "20", [
    "M8.07 5.47a6.75 6.75 0 0 1 4.5 11.5l-.8.8a2.5 2.5 0 0 1-3.54 0l-6-6a2.5 2.5 0 0 1 0-3.54l.8-.8a7 7 0 0 1 1.59-1.17q-.13.62-.15 1.26-.38.29-.74.63l-.8.79a1.5 1.5 0 0 0 0 2.12l6.01 6a1.5 1.5 0 0 0 2.12 0l.8-.79.2-.21a5.75 5.75 0 0 0-4.4-9.6q.15-.51.4-.99m.16-3.24a2.5 2.5 0 0 1 3.54 0l6 6a2.5 2.5 0 0 1 0 3.54l-.8.8q-.71.71-1.59 1.17.13-.62.15-1.26.38-.29.74-.63l.8-.79a1.5 1.5 0 0 0 0-2.12l-6.01-6a1.5 1.5 0 0 0-2.12 0l-.8.79a5.75 5.75 0 0 0 4.21 9.8q-.15.52-.42 1a6.75 6.75 0 0 1-4.5-11.5z"
]);
const $cdb0ff5c001a8842$export$87a32f3137469b2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink24Filled', "24", [
    "M10.23 6.27a8.38 8.38 0 0 1 5.09 14.25l-1.03 1.03a3.25 3.25 0 0 1-4.6 0L2.46 14.3a3.25 3.25 0 0 1 0-4.6l1.02-1.02q.93-.91 2.02-1.49-.3 1.27-.25 2.58-.18.15-.35.33L3.85 11.1a1.25 1.25 0 0 0 0 1.77l7.25 7.25c.49.49 1.28.49 1.77 0l1.02-1.02A6.38 6.38 0 0 0 9.36 8.23q.22-1.06.87-1.96M9.7 2.45a3.25 3.25 0 0 1 4.6 0l7.24 7.25a3.25 3.25 0 0 1 0 4.6l-1 1v.01q-.93.9-2.03 1.5.3-1.28.25-2.59l.36-.32 1-1.02c.5-.48.5-1.28 0-1.76l-7.24-7.25a1.25 1.25 0 0 0-1.77 0l-1 1a6.38 6.38 0 0 0 4.53 10.9q-.22 1.04-.87 1.95A8.38 8.38 0 0 1 8.68 3.47z"
]);
const $cdb0ff5c001a8842$export$45cfc9ff1a1c1a2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink24Regular', "24", [
    "M9.63 6.33a8.38 8.38 0 0 1 5.6 14.29l-.93.93a3.25 3.25 0 0 1-4.6 0L2.45 14.3a3.25 3.25 0 0 1 0-4.6l.93-.93A8 8 0 0 1 5.56 7.2a9 9 0 0 0-.23 1.89q-.47.33-.89.74l-.93.93c-.68.69-.68 1.8 0 2.48l7.25 7.25c.68.68 1.8.68 2.48 0l.92-.93A6.88 6.88 0 0 0 9.01 7.83q.2-.79.62-1.5m.07-3.88a3.25 3.25 0 0 1 4.6 0l7.24 7.25a3.25 3.25 0 0 1 0 4.6l-.93.93a8 8 0 0 1-2.17 1.56q.21-.93.24-1.88.46-.33.87-.74l.93-.93c.69-.69.69-1.8 0-2.48l-7.24-7.25a1.75 1.75 0 0 0-2.48 0l-.93.93a6.88 6.88 0 0 0 5.16 11.73 6 6 0 0 1-.62 1.5 8.38 8.38 0 0 1-5.6-14.29z"
]);
const $cdb0ff5c001a8842$export$3ac8ec1b88b8f941 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink28Filled', "28", [
    "M11.46 7.46a9.59 9.59 0 0 1 6.28 16.35l-1.09 1.1a3.75 3.75 0 0 1-5.3 0L3.1 16.64a3.75 3.75 0 0 1 0-5.3l1.08-1.09a10 10 0 0 1 2.58-1.84q-.3 1.25-.3 2.52-.46.33-.86.73l-1.09 1.1c-.68.68-.68 1.79 0 2.47l8.25 8.25c.69.68 1.8.68 2.48 0l1.09-1.09a7.59 7.59 0 0 0-5.7-12.94q.24-1.05.83-2m-.1-4.36a3.75 3.75 0 0 1 5.3 0l8.24 8.25a3.75 3.75 0 0 1 0 5.3l-1.09 1.1a10 10 0 0 1-2.57 1.83q.3-1.24.3-2.52.45-.33.86-.73l1.09-1.1c.68-.67.68-1.78 0-2.47l-8.25-8.25a1.75 1.75 0 0 0-2.48 0l-1.09 1.1a7.59 7.59 0 0 0 5.7 12.93q-.24 1.05-.83 2a9.59 9.59 0 0 1-6.28-16.35z"
]);
const $cdb0ff5c001a8842$export$dd864622f5e3cb6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink28Regular', "28", [
    "M10.87 7.54a9.58 9.58 0 0 1 6.78 16.36l-1 1a3.75 3.75 0 0 1-5.3 0L3.1 16.65a3.75 3.75 0 0 1 0-5.3l1-1a10 10 0 0 1 2.72-1.91q-.21.91-.27 1.85-.74.48-1.4 1.12l-1 1c-.87.88-.87 2.3 0 3.18l8.26 8.25c.88.88 2.3.88 3.18 0l1-1a8.08 8.08 0 0 0-6.32-13.78q.21-.78.6-1.52m.48-4.44a3.75 3.75 0 0 1 5.3 0l8.25 8.25a3.75 3.75 0 0 1 0 5.3l-1 1a10 10 0 0 1-2.73 1.92q.22-.92.27-1.86.75-.46 1.4-1.11l1-1c.88-.89.88-2.31 0-3.19L15.6 4.16a2.25 2.25 0 0 0-3.18 0l-1 1a8.09 8.09 0 0 0 6.31 13.78 7 7 0 0 1-.6 1.52A9.59 9.59 0 0 1 10.35 4.1z"
]);
const $cdb0ff5c001a8842$export$80fb57c47d2f7f52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink32Filled', "32", [
    "M13.6 8.36a11.22 11.22 0 0 1 7.22 18.68l-.4.42-1.24 1.23a4.5 4.5 0 0 1-6.36 0l-9.5-9.5a4.5 4.5 0 0 1 0-6.37l1.22-1.23q1.2-1.17 2.58-1.93a13 13 0 0 0-.3 3.23q-.27.22-.5.47l-1.23 1.23a2 2 0 0 0 0 2.82l9.5 9.5a2 2 0 0 0 2.83 0l1.22-1.22A8.72 8.72 0 0 0 12.5 10.8q.3-1.3 1.1-2.44m-.78-5.05a4.5 4.5 0 0 1 6.36 0l9.5 9.5a4.5 4.5 0 0 1 0 6.37l-1.22 1.23q-1.18 1.17-2.58 1.92.36-1.6.3-3.23.27-.22.51-.46l1.22-1.22a2 2 0 0 0 0-2.83l-9.5-9.5a2 2 0 0 0-2.83 0L13.36 6.3a8.72 8.72 0 0 0 6.14 14.88q-.3 1.3-1.1 2.45a11.22 11.22 0 0 1-6.82-19.1z"
]);
const $cdb0ff5c001a8842$export$5f9945537103e661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink32Regular', "32", [
    "M13 8.41a11.22 11.22 0 0 1 7.72 18.72l-.4.42-1.14 1.13a4.5 4.5 0 0 1-6.36 0l-9.5-9.5a4.5 4.5 0 0 1 0-6.36l1.13-1.14Q5.7 10.43 7.2 9.67q-.27 1.25-.3 2.54-.53.4-1.02.89l-1.14 1.13a2.5 2.5 0 0 0 0 3.54l9.5 9.5a2.5 2.5 0 0 0 3.54 0l1.14-1.14a9.22 9.22 0 0 0-6.76-15.73q.29-1.05.84-1.99m-.18-5.1a4.5 4.5 0 0 1 6.36 0l9.5 9.5a4.5 4.5 0 0 1 0 6.37l-1.13 1.14q-1.25 1.24-2.74 2.01.27-1.25.3-2.53.53-.4 1.02-.9l1.14-1.13a2.5 2.5 0 0 0 0-3.54l-9.5-9.5a2.5 2.5 0 0 0-3.54 0L13.1 5.87a9.22 9.22 0 0 0 6.76 15.73A8 8 0 0 1 19 23.6a11.22 11.22 0 0 1-7.33-19.14z"
]);
const $cdb0ff5c001a8842$export$477b789cba460b07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink48Filled', "48", [
    "M19.75 13.17a15.98 15.98 0 0 1 10.72 26.95l-.3.3-1.75 1.75a6.25 6.25 0 0 1-8.84 0L5.83 28.42a6.25 6.25 0 0 1 0-8.84l1.76-1.76q1.81-1.8 4-2.92a18 18 0 0 0-.45 3.8q-.75.57-1.43 1.24L7.95 21.7a3.25 3.25 0 0 0 0 4.6L21.7 40.05a3.25 3.25 0 0 0 4.6 0l1.76-1.76a12.98 12.98 0 0 0-9.57-22.14 11 11 0 0 1 1.26-2.98m-.17-7.34a6.25 6.25 0 0 1 8.84 0l13.75 13.75a6.25 6.25 0 0 1 0 8.84l-1.76 1.76a16 16 0 0 1-4 2.92q.42-1.89.44-3.8.76-.56 1.44-1.24l1.76-1.76a3.25 3.25 0 0 0 0-4.6L26.3 7.95a3.25 3.25 0 0 0-4.6 0l-1.76 1.76a12.97 12.97 0 0 0 9.57 22.14 11 11 0 0 1-1.26 2.98A15.98 15.98 0 0 1 17.82 7.58z"
]);
const $cdb0ff5c001a8842$export$5c36d06458439cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink48Regular', "48", [
    "M19.17 13.23A15.98 15.98 0 0 1 30.09 40.5l-1.67 1.67a6.25 6.25 0 0 1-8.84 0L5.83 28.42a6.25 6.25 0 0 1 0-8.84l1.67-1.67a16 16 0 0 1 4.15-3 18 18 0 0 0-.4 3.13q-1.05.7-1.99 1.64L7.6 21.35a3.75 3.75 0 0 0 0 5.3l13.76 13.76a3.75 3.75 0 0 0 5.3 0l1.67-1.68.24-.25a13.48 13.48 0 0 0-10.42-22.73q.36-1.3 1.03-2.52m.41-7.4a6.25 6.25 0 0 1 8.84 0l13.75 13.75a6.25 6.25 0 0 1 0 8.84l-1.67 1.67a16 16 0 0 1-4.15 3q.34-1.55.4-3.13 1.05-.71 1.99-1.64l1.67-1.67a3.75 3.75 0 0 0 0-5.3L26.65 7.6a3.75 3.75 0 0 0-5.3 0l-1.67 1.67a13.47 13.47 0 0 0 10.18 22.98 11 11 0 0 1-1.02 2.51A15.98 15.98 0 0 1 17.92 7.5z"
]);
const $cdb0ff5c001a8842$export$3ab8df74a84ca8db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v2h14V6a3 3 0 0 0-3-3zm8 14H6.91a1.5 1.5 0 0 0-.91-.91v-1.43a3.5 3.5 0 0 0 2-3.16v-2q0-.26-.09-.5H17v5a3 3 0 0 1-3 3M6.75 6.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M10 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5z"
]);
const $cdb0ff5c001a8842$export$4ac6eb83d7570036 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v2h13v6a2 2 0 0 1-2 2H6v.09c.43.15.76.48.91.91H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm10 3v1H4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2m-8.5-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.5 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5z"
]);
const $cdb0ff5c001a8842$export$8ec71be7e5761292 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25V9H3zm5.99 4.26-.02-.01H21v7.25c0 1.8-1.46 3.25-3.25 3.25H8.48A1.75 1.75 0 0 0 7 19.52v-1.9a4.3 4.3 0 0 0 2.5-3.87v-2q0-.71-.51-1.24M9 6.25a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3.75-.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm-10 5.5a.75.75 0 0 0-.75.75v2a3.25 3.25 0 0 0 2.5 3.16v3.59h-.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H6v-3.59a3.25 3.25 0 0 0 2.5-3.16v-2a.75.75 0 0 0-.75-.75z"
]);
const $cdb0ff5c001a8842$export$c875a5cfc9ea062f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25V10h1.5v-.5h15v8.25c0 .97-.78 1.75-1.75 1.75H7v.02c.77.1 1.37.71 1.48 1.48h9.27c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM19.5 8h-15V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75zM9 6.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3.75-.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM2 11.75c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75v2A3.25 3.25 0 0 1 6 16.91v3.59h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-3.59A3.25 3.25 0 0 1 2 13.75z"
]);
const $cdb0ff5c001a8842$export$ee7d0f8c274dcc3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher32Filled', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5V12H3zm8.77 6.73L11.5 14H29v10.5a4.5 4.5 0 0 1-4.5 4.5h-14A2.5 2.5 0 0 0 9 26.7v-2a6 6 0 0 0 3.5-5.45V16c0-.66-.26-1.3-.73-1.77M11.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M17 7a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zM3 15a1 1 0 0 0-1 1v3.25a4.5 4.5 0 0 0 3.5 4.39V28H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-.5v-4.36a4.5 4.5 0 0 0 3.5-4.39V16a1 1 0 0 0-1-1z"
]);
const $cdb0ff5c001a8842$export$3325fc91d4cbfad3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher32Regular', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-14c0-.82-.4-1.54-1-2h15a2.5 2.5 0 0 0 2.5-2.5V13H5v.5H3zm24 0A2.5 2.5 0 0 0 24.5 5h-17A2.5 2.5 0 0 0 5 7.5V11h22zM11.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M16 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1M3 15a1 1 0 0 0-1 1v3.25a4.5 4.5 0 0 0 3.5 4.39V28H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-.5v-4.36a4.5 4.5 0 0 0 3.5-4.39V16a1 1 0 0 0-1-1z"
]);
const $cdb0ff5c001a8842$export$f32afe9607e8285f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher48Filled', "48", [
    "M12 6a6 6 0 0 0-6 6v5.5h36V12a6 6 0 0 0-6-6zm30 14H16.25a3.25 3.25 0 0 1 3.25 3.25v5a8.75 8.75 0 0 1-5.5 8.13v3.2A3.3 3.3 0 0 1 16.41 42H36a6 6 0 0 0 6-6zm-24-7.75a2 2 0 1 1-4 0 2 2 0 0 1 4 0M25.25 11h7.5a1.25 1.25 0 1 1 0 2.5h-7.5a1.25 1.25 0 1 1 0-2.5m-20 11C4.56 22 4 22.56 4 23.25v5c0 3.3 2.37 6.05 5.5 6.63v6.62H8.25a1.25 1.25 0 1 0 0 2.5h5a1.25 1.25 0 1 0 0-2.5H12v-6.62a6.75 6.75 0 0 0 5.5-6.63v-5c0-.69-.56-1.25-1.25-1.25z"
]);
const $cdb0ff5c001a8842$export$51d983a86a15639a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher48Regular', "48", [
    "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42H16.41A3.3 3.3 0 0 0 14 39.59v-.09h21.75a3.75 3.75 0 0 0 3.75-3.75V18.5h-31V20H6zm33.5 0a3.75 3.75 0 0 0-3.75-3.75h-23.5a3.75 3.75 0 0 0-3.75 3.75V16h31zm-21.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 0c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25M5.25 22C4.56 22 4 22.56 4 23.25v5c0 3.3 2.37 6.05 5.5 6.63v6.62H8.25a1.25 1.25 0 1 0 0 2.5h5a1.25 1.25 0 1 0 0-2.5H12v-6.62a6.75 6.75 0 0 0 5.5-6.63v-5c0-.69-.56-1.25-1.25-1.25z"
]);
const $cdb0ff5c001a8842$export$f4344078770ebe25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss12Filled', "12", [
    "m1.9 2.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L6 4.94l2.97-2.97a.75.75 0 1 1 1.06 1.06L7.06 6l2.97 2.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L6 7.06l-2.97 2.97a.75.75 0 1 1-1.06-1.06L4.94 6 1.97 3.03a.75.75 0 0 1-.07-.98l.07-.08z"
]);
const $cdb0ff5c001a8842$export$ff76805637bbf529 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss12Regular', "12", [
    "m2.09 2.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L6 5.29l3.15-3.14a.5.5 0 1 1 .7.7L6.71 6l3.14 3.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L6 6.71 2.85 9.85a.5.5 0 0 1-.7-.7L5.29 6 2.15 2.85a.5.5 0 0 1-.06-.63l.06-.07z"
]);
const $cdb0ff5c001a8842$export$fe3a08578d7b9af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss16Filled', "16", [
    "m2.4 2.55.07-.08a.75.75 0 0 1 .98-.07l.08.07L8 6.94l4.47-4.47a.75.75 0 1 1 1.06 1.06L9.06 8l4.47 4.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L8 9.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06L6.94 8 2.47 3.53a.75.75 0 0 1-.07-.98l.07-.08z"
]);
const $cdb0ff5c001a8842$export$6b9f0f6797d2b702 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss16Regular', "16", [
    "m2.59 2.72.06-.07a.5.5 0 0 1 .63-.06l.07.06L8 7.29l4.65-4.64a.5.5 0 0 1 .7.7L8.71 8l4.64 4.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L8 8.71l-4.65 4.64a.5.5 0 0 1-.7-.7L7.29 8 2.65 3.35a.5.5 0 0 1-.06-.63l.06-.07z"
]);
const $cdb0ff5c001a8842$export$fb9faba164c82835 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss20Filled', "20", [
    "m3.9 4.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L10 8.94l4.97-4.97a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08L11.06 10l4.97 4.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L10 11.06l-4.97 4.97a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L8.94 10 3.97 5.03a.75.75 0 0 1-.07-.98l.07-.08z"
]);
const $cdb0ff5c001a8842$export$5b53e1eb03c72ac3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss20Regular', "20", [
    "m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07z"
]);
const $cdb0ff5c001a8842$export$15b5f0a44e7ae60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss24Filled', "24", [
    "m4.21 4.39.08-.1a1 1 0 0 1 1.32-.08l.1.08L12 10.6l6.3-6.3a1 1 0 1 1 1.4 1.42L13.43 12l6.29 6.3a1 1 0 0 1 .08 1.31l-.08.1a1 1 0 0 1-1.32.08l-.1-.08L12 13.4l-6.3 6.3a1 1 0 0 1-1.4-1.42L10.58 12l-6.3-6.3a1 1 0 0 1-.08-1.31l.08-.1z"
]);
const $cdb0ff5c001a8842$export$209e755d5656d93f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss24Regular', "24", [
    "m4.4 4.55.07-.08a.75.75 0 0 1 .98-.07l.08.07L12 10.94l6.47-6.47a.75.75 0 1 1 1.06 1.06L13.06 12l6.47 6.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L12 13.06l-6.47 6.47a.75.75 0 0 1-1.06-1.06L10.94 12 4.47 5.53a.75.75 0 0 1-.07-.98l.07-.08z"
]);
const $cdb0ff5c001a8842$export$84e4c4a0298f9a53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss28Filled', "28", [
    "M22.3 4.3a1 1 0 1 1 1.4 1.4L15.42 14l8.3 8.3a1 1 0 0 1-1.42 1.4L14 15.42l-8.3 8.3a1 1 0 0 1-1.4-1.42L12.58 14l-8.3-8.3a1 1 0 0 1 1.42-1.4L14 12.58z"
]);
const $cdb0ff5c001a8842$export$87fa4a8a433c5a73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss28Regular', "28", [
    "M22.47 4.47a.75.75 0 1 1 1.06 1.06L15.06 14l8.47 8.47a.75.75 0 1 1-1.06 1.06L14 15.06l-8.47 8.47a.75.75 0 0 1-1.06-1.06L12.94 14 4.47 5.53a.75.75 0 0 1 1.06-1.06L14 12.94z"
]);
const $cdb0ff5c001a8842$export$5f08da71c69d66e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss32Filled', "32", [
    "M26.11 4.12a1.25 1.25 0 0 1 1.77 1.76L17.77 16 27.88 26.1a1.25 1.25 0 1 1-1.77 1.77L16 17.77 5.88 27.88a1.25 1.25 0 1 1-1.76-1.77L14.23 16 4.12 5.88a1.25 1.25 0 1 1 1.76-1.76L16 14.23z"
]);
const $cdb0ff5c001a8842$export$48d099711b16a532 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss32Light', "32", [
    "M27.85 4.85a.5.5 0 0 0-.7-.7L16 15.29 4.85 4.15a.5.5 0 1 0-.7.7L15.29 16 4.15 27.15a.5.5 0 0 0 .7.7L16 16.71l11.15 11.14a.5.5 0 0 0 .7-.7L16.71 16z"
]);
const $cdb0ff5c001a8842$export$2997120479b965ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss32Regular', "32", [
    "M26.29 4.3a1 1 0 1 1 1.41 1.4L17.41 16l10.3 10.29a1 1 0 1 1-1.42 1.41l-10.3-10.29-10.28 10.3a1 1 0 0 1-1.42-1.42l10.3-10.3L4.28 5.72a1 1 0 0 1 1.42-1.42L16 14.6z"
]);
const $cdb0ff5c001a8842$export$68289010717b7708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss48Filled', "48", [
    "M8.56 6.44a1.5 1.5 0 1 0-2.12 2.12L21.88 24 6.44 39.44a1.5 1.5 0 1 0 2.12 2.12L24 26.12l15.44 15.44a1.5 1.5 0 1 0 2.12-2.12L26.12 24 41.56 8.56a1.5 1.5 0 1 0-2.12-2.12L24 21.88z"
]);
const $cdb0ff5c001a8842$export$38d273f1c35ccb6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss48Regular', "48", [
    "M8.38 6.62a1.25 1.25 0 1 0-1.76 1.76L22.23 24 6.62 39.62a1.25 1.25 0 0 0 1.76 1.76L24 25.77l15.62 15.61a1.25 1.25 0 1 0 1.76-1.76L25.77 24 41.38 8.38a1.25 1.25 0 1 0-1.76-1.76L24 22.23z"
]);
const $cdb0ff5c001a8842$export$b5d2fd2fcfbf9313 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle12Filled', "12", [
    "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m1.85-6.85c.2.2.2.5 0 .7L6.71 6l1.14 1.15a.5.5 0 1 1-.7.7L6 6.71 4.85 7.85a.5.5 0 1 1-.7-.7L5.29 6 4.15 4.85a.5.5 0 1 1 .7-.7L6 5.29l1.15-1.14c.2-.2.5-.2.7 0"
]);
const $cdb0ff5c001a8842$export$4e77e8175961a747 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle12Regular', "12", [
    "M7.85 4.15c.2.2.2.5 0 .7L6.71 6l1.14 1.15a.5.5 0 1 1-.7.7L6 6.71 4.85 7.85a.5.5 0 1 1-.7-.7L5.29 6 4.15 4.85a.5.5 0 1 1 .7-.7L6 5.29l1.15-1.14c.2-.2.5-.2.7 0M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
]);
const $cdb0ff5c001a8842$export$a01098c8897dd9b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_16_color__a)",
            "d": "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_16_color__b)",
            "d": "M5.9 5.9a.5.5 0 0 1 .63-.06l.07.06L8 7.3l1.4-1.4a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L8.7 8l1.4 1.4c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L8 8.7l-1.4 1.4a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L7.3 8 5.9 6.6a.5.5 0 0 1-.06-.63z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_16_color__a",
                "x1": "3.88",
                "x2": "13",
                "y1": "2.75",
                "y2": "16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_16_color__b",
                "x1": "6.01",
                "x2": "8.35",
                "y1": "8.2",
                "y2": "10.64",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$81af4b7599e01e26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle16Filled', "16", [
    "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M6.35 5.65 8 7.29l1.65-1.64a.5.5 0 0 1 .7.7L8.71 8l1.64 1.65a.5.5 0 0 1-.7.7L8 8.71l-1.65 1.64a.5.5 0 0 1-.7-.7L7.29 8 5.65 6.35a.5.5 0 1 1 .7-.7"
]);
const $cdb0ff5c001a8842$export$8dc1b859c30ab69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1M6.35 5.65a.5.5 0 1 0-.7.7L7.29 8 5.65 9.65a.5.5 0 0 0 .7.7L8 8.71l1.65 1.64a.5.5 0 0 0 .7-.7L8.71 8l1.64-1.65a.5.5 0 0 0-.7-.7L8 7.29z"
]);
const $cdb0ff5c001a8842$export$24014d37cf5ea207 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_20_color__a)",
            "d": "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_20_color__b)",
            "fillRule": "evenodd",
            "d": "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_20_color__a",
                "x1": "4.5",
                "x2": "15",
                "y1": "3",
                "y2": "18.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_20_color__b",
                "x1": "7.35",
                "x2": "10.47",
                "y1": "10.27",
                "y2": "13.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$b0e095d81813923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16M7.8 7.11a.5.5 0 0 0-.63.06l-.06.07a.5.5 0 0 0 .06.64L9.3 10l-2.12 2.12-.06.07a.5.5 0 0 0 .06.64l.07.06c.2.13.47.11.64-.06L10 10.7l2.12 2.12.07.06c.2.13.46.11.64-.06l.06-.07a.5.5 0 0 0-.06-.64L10.7 10l2.12-2.12.06-.07a.5.5 0 0 0-.06-.64l-.07-.06a.5.5 0 0 0-.64.06L10 9.3 7.88 7.17z"
]);
const $cdb0ff5c001a8842$export$c6bbf9574e7e7679 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle20Regular', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14M7.8 7.11l.08.06L10 9.3l2.12-2.12a.5.5 0 0 1 .64-.06l.07.06c.17.18.2.44.06.64l-.06.07L10.7 10l2.12 2.12c.17.17.2.44.06.64l-.06.07a.5.5 0 0 1-.64.06l-.07-.06L10 10.7l-2.12 2.12a.5.5 0 0 1-.64.06l-.07-.06a.5.5 0 0 1-.06-.64l.06-.07L9.3 10 7.17 7.88a.5.5 0 0 1-.06-.64l.06-.07a.5.5 0 0 1 .64-.06"
]);
const $cdb0ff5c001a8842$export$69521afd2e8ef7c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_24_color__a)",
            "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_24_color__b)",
            "d": "m15.53 8.47-.08-.07a.75.75 0 0 0-.89-.01l-.09.08L12 10.94 9.53 8.47l-.08-.07a.75.75 0 0 0-.89-.01l-.09.08-.07.08c-.2.26-.2.62-.01.89l.08.09L10.94 12l-2.47 2.47-.07.08c-.2.26-.2.62-.01.89l.08.09.08.07c.26.2.62.2.89.01l.09-.08L12 13.06l2.47 2.47.08.07c.26.2.62.2.89.01l.09-.08.07-.08c.2-.26.2-.62.01-.89l-.08-.09L13.06 12l2.47-2.47.07-.08c.2-.26.2-.62.01-.89z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_24_color__a",
                "x1": "5.13",
                "x2": "18.25",
                "y1": "3.25",
                "y2": "22.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_24_color__b",
                "x1": "8.69",
                "x2": "12.59",
                "y1": "12.33",
                "y2": "16.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$9bced2eb0e9e3f4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m3.53 6.47-.08-.07a.75.75 0 0 0-.89-.01l-.09.08L12 10.94 9.53 8.47l-.08-.07a.75.75 0 0 0-.89-.01l-.09.08-.07.08c-.2.26-.2.62-.01.89l.08.09L10.94 12l-2.47 2.47-.07.08c-.2.26-.2.62-.01.89l.08.09.08.07c.26.2.62.2.89.01l.09-.08L12 13.06l2.47 2.47.08.07c.26.2.62.2.89.01l.09-.08.07-.08c.2-.26.2-.62.01-.89l-.08-.09L13.06 12l2.47-2.47.07-.08c.2-.26.2-.62.01-.89zl-.08-.07z"
]);
const $cdb0ff5c001a8842$export$123b9be479117e05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m3.45 4.9.08.07c.27.27.3.68.07.98l-.07.08L13.06 12l2.47 2.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L12 13.06l-2.47 2.47a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L10.94 12 8.47 9.53a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07l.08.07L12 10.94l2.47-2.47a.75.75 0 0 1 .98-.07"
]);
const $cdb0ff5c001a8842$export$391651d82fa698e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_28_color__a)",
            "d": "M26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_28_color__b)",
            "d": "M18.28 9.72c.3.3.3.77 0 1.06L15.06 14l3.22 3.22a.75.75 0 1 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 1 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94l3.22-3.22c.3-.3.77-.3 1.06 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_28_color__a",
                "x1": "5.75",
                "x2": "21.5",
                "y1": "3.5",
                "y2": "26.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_28_color__b",
                "x1": "10.02",
                "x2": "14.71",
                "y1": "14.4",
                "y2": "19.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$a1041ae3e91a7bed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle28Filled', "28", [
    "M26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0m-7.72-4.28c.3.3.3.77 0 1.06L15.06 14l3.22 3.22a.75.75 0 1 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 1 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94l3.22-3.22c.3-.3.77-.3 1.06 0"
]);
const $cdb0ff5c001a8842$export$eec292ca7e8c99fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle28Regular', "28", [
    "M18.28 9.72c.3.3.3.77 0 1.06L15.06 14l3.22 3.22a.75.75 0 1 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 1 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94l3.22-3.22c.3-.3.77-.3 1.06 0M26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0M3.5 14a10.5 10.5 0 1 1 21 0 10.5 10.5 0 0 1-21 0"
]);
const $cdb0ff5c001a8842$export$cbe9d7bd2750df4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_32_color__a)",
            "d": "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_32_color__b)",
            "d": "M21.7 10.3a1 1 0 0 1 0 1.4L17.42 16l4.3 4.3a1 1 0 0 1-1.42 1.4L16 17.42l-4.3 4.3a1 1 0 0 1-1.4-1.42L14.58 16l-4.3-4.3a1 1 0 1 1 1.42-1.4L16 14.58l4.3-4.3a1 1 0 0 1 1.4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_32_color__a",
                "x1": "6.38",
                "x2": "24.75",
                "y1": "3.75",
                "y2": "30.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_32_color__b",
                "x1": "10.7",
                "x2": "16.95",
                "y1": "16.53",
                "y2": "23.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$bca0ab54a9a0f9b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0m19.7-5.7a1 1 0 0 0-1.4 0L16 14.58l-4.3-4.3a1 1 0 1 0-1.4 1.42L14.58 16l-4.3 4.3a1 1 0 1 0 1.42 1.4L16 17.42l4.3 4.3a1 1 0 0 0 1.4-1.42L17.42 16l4.3-4.3a1 1 0 0 0 0-1.4"
]);
const $cdb0ff5c001a8842$export$cfb8e33d0b575756 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Light', "32", [
    "M10.15 10.15a.5.5 0 0 0 0 .7L15.29 16l-5.14 5.15a.5.5 0 0 0 .7.7L16 16.71l5.15 5.14a.5.5 0 0 0 .7-.7L16.71 16l5.14-5.15a.5.5 0 0 0-.7-.7L16 15.29l-5.15-5.14a.5.5 0 0 0-.7 0M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0M16 3a13 13 0 1 0 0 26 13 13 0 0 0 0-26"
]);
const $cdb0ff5c001a8842$export$abf3bf54934b4de9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Regular', "32", [
    "M21.7 10.3a1 1 0 0 1 0 1.4L17.42 16l4.3 4.3a1 1 0 0 1-1.42 1.4L16 17.42l-4.3 4.3a1 1 0 0 1-1.4-1.42L14.58 16l-4.3-4.3a1 1 0 1 1 1.42-1.4L16 14.58l4.3-4.3a1 1 0 0 1 1.4 0M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0"
]);
const $cdb0ff5c001a8842$export$a310b9381080f725 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_48_color__a)",
            "d": "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_48_color__b)",
            "d": "m17.78 16.02.1.1L24 22.23l6.12-6.11a1.25 1.25 0 0 1 1.66-.1l.1.1c.46.45.49 1.17.1 1.66l-.1.1L25.77 24l6.11 6.12c.46.45.49 1.17.1 1.66l-.1.1c-.45.46-1.17.49-1.66.1l-.1-.1L24 25.77l-6.12 6.11c-.45.46-1.17.49-1.66.1l-.1-.1a1.25 1.25 0 0 1-.1-1.66l.1-.1L22.23 24l-6.11-6.12a1.25 1.25 0 0 1-.1-1.66l.1-.1a1.25 1.25 0 0 1 1.66-.1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_48_color__a",
                "x1": "10.25",
                "x2": "36.5",
                "y1": "6.5",
                "y2": "45.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_48_color__b",
                "x1": "16.71",
                "x2": "25.3",
                "y1": "24.73",
                "y2": "33.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$2ab534e539bdf78e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m-6.12 12.12-.1-.1a1.25 1.25 0 0 0-1.56 0l-.1.1-.1.1c-.36.45-.36 1.1 0 1.56l.1.1L22.23 24l-6.11 6.12-.1.1c-.36.45-.36 1.1 0 1.56l.1.1.1.1c.45.36 1.1.36 1.56 0l.1-.1L24 25.77l6.12 6.11.1.1c.45.36 1.1.36 1.56 0l.1-.1.1-.1c.36-.45.36-1.1 0-1.56l-.1-.1L25.77 24l6.11-6.12.1-.1c.36-.45.36-1.1 0-1.56l-.1-.1-.1-.1a1.25 1.25 0 0 0-1.56 0l-.1.1L24 22.23zl-.1-.1z"
]);
const $cdb0ff5c001a8842$export$4d7bb8476b4ee227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle48Regular', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m0 2.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35m-6.22 9.52.1.1L24 22.23l6.12-6.11a1.25 1.25 0 0 1 1.66-.1l.1.1c.46.45.49 1.17.1 1.66l-.1.1L25.77 24l6.11 6.12c.46.45.49 1.17.1 1.66l-.1.1c-.45.46-1.17.49-1.66.1l-.1-.1L24 25.77l-6.12 6.11c-.45.46-1.17.49-1.66.1l-.1-.1a1.25 1.25 0 0 1-.1-1.66l.1-.1L22.23 24l-6.11-6.12a1.25 1.25 0 0 1-.1-1.66l.1-.1a1.25 1.25 0 0 1 1.66-.1"
]);
const $cdb0ff5c001a8842$export$4c8e27c1b3cf5b75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm4.15 1.15a.5.5 0 0 0 0 .7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 0 0-.7 0"
]);
const $cdb0ff5c001a8842$export$62ccf8f64e9091ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare20Regular', "20", [
    "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $cdb0ff5c001a8842$export$dfe2de482451b605 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zm1.97 5.22c.3-.3.77-.3 1.06 0L12 10.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 0-1.06"
]);
const $cdb0ff5c001a8842$export$6d344683e5592c94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare24Regular', "24", [
    "M8.22 8.22c.3-.3.77-.3 1.06 0L12 10.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 0-1.06M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $cdb0ff5c001a8842$export$5c487918c4861c20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare28Filled', "28", [
    "M21.25 3A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3zm-2.47 6.22a.75.75 0 0 0-1.06 0L14 12.94l-3.72-3.72a.75.75 0 1 0-1.06 1.06L12.94 14l-3.72 3.72a.75.75 0 1 0 1.06 1.06L14 15.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L15.06 14l3.72-3.72c.3-.3.3-.77 0-1.06"
]);
const $cdb0ff5c001a8842$export$2a3c0896f8c34acc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare28Regular', "28", [
    "M21.25 3A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3zM6.75 4.5c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25h14.5c1.24 0 2.25-1 2.25-2.25V6.75c0-1.24-1-2.25-2.25-2.25zm10.97 4.72a.75.75 0 1 1 1.06 1.06L15.06 14l3.72 3.72a.75.75 0 1 1-1.06 1.06L14 15.06l-3.72 3.72a.75.75 0 1 1-1.06-1.06L12.94 14l-3.72-3.72a.75.75 0 1 1 1.06-1.06L14 12.94z"
]);
const $cdb0ff5c001a8842$export$1983754dfdb1ee3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare32Filled', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zm-2.8 7.3a1 1 0 0 0-1.4 0L16 14.58l-4.3-4.3a1 1 0 1 0-1.4 1.42L14.58 16l-4.3 4.3a1 1 0 1 0 1.42 1.4L16 17.42l4.3 4.3a1 1 0 1 0 1.4-1.42L17.42 16l4.3-4.3a1 1 0 0 0 0-1.4"
]);
const $cdb0ff5c001a8842$export$57f3ab54efd56e2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare32Light', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zm-17 1A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4zm13.65 6.15a.5.5 0 1 1 .7.7L16.71 16l5.14 5.15a.5.5 0 1 1-.7.7L16 16.71l-5.15 5.14a.5.5 0 1 1-.7-.7L15.29 16l-5.14-5.15a.5.5 0 1 1 .7-.7L16 15.29z"
]);
const $cdb0ff5c001a8842$export$57e5e82459d1a5af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare32Regular', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zm-17 2A2.5 2.5 0 0 0 5 7.5v17A2.5 2.5 0 0 0 7.5 27h17a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 24.5 5zm12.8 5.3a1 1 0 1 1 1.4 1.4L17.42 16l4.3 4.3a1 1 0 1 1-1.42 1.4L16 17.42l-4.3 4.3a1 1 0 1 1-1.4-1.42L14.58 16l-4.3-4.3a1 1 0 1 1 1.42-1.4L16 14.58z"
]);
const $cdb0ff5c001a8842$export$8106395b74553fed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare48Filled', "48", [
    "M35.75 6C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6zm-4.12 10.37a1.25 1.25 0 0 0-1.76 0L24 22.23l-5.87-5.86a1.25 1.25 0 0 0-1.76 1.76L22.23 24l-5.86 5.87a1.25 1.25 0 0 0 1.76 1.76L24 25.77l5.87 5.86a1.25 1.25 0 0 0 1.76-1.76L25.77 24l5.86-5.87c.5-.48.5-1.28 0-1.76"
]);
const $cdb0ff5c001a8842$export$b331b78a24ec136f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare48Regular', "48", [
    "M35.75 6C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6zm-23.5 2.5a3.75 3.75 0 0 0-3.75 3.75v23.5a3.75 3.75 0 0 0 3.75 3.75h23.5a3.75 3.75 0 0 0 3.75-3.75v-23.5a3.75 3.75 0 0 0-3.75-3.75zm17.62 7.87a1.25 1.25 0 0 1 1.76 1.76L25.77 24l5.86 5.87a1.25 1.25 0 0 1-1.76 1.76L24 25.77l-5.87 5.86a1.25 1.25 0 0 1-1.76-1.76L22.23 24l-5.86-5.87a1.25 1.25 0 0 1 1.76-1.76L24 22.23z"
]);
const $cdb0ff5c001a8842$export$cb3d4c98932050ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple16Filled', "16", [
    "M4 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm.65 2.65c.2-.2.5-.2.7 0L7 6.29l1.65-1.64a.5.5 0 1 1 .7.7L7.71 7l1.64 1.65a.5.5 0 1 1-.7.7L7 7.71 5.35 9.35a.5.5 0 1 1-.7-.7L6.29 7 4.65 5.35a.5.5 0 0 1 0-.7M13 10.5a2.5 2.5 0 0 1-2.5 2.5H3.27c.34.6.99 1 1.73 1h5.5a3.5 3.5 0 0 0 3.5-3.5V5a2 2 0 0 0-1-1.73z"
]);
const $cdb0ff5c001a8842$export$44d32114ff60489e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple16Regular', "16", [
    "M4.65 4.65c.2-.2.5-.2.7 0L7 6.29l1.65-1.64a.5.5 0 1 1 .7.7L7.71 7l1.64 1.65a.5.5 0 1 1-.7.7L7 7.71 5.35 9.35a.5.5 0 1 1-.7-.7L6.29 7 4.65 5.35a.5.5 0 0 1 0-.7M4 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM3 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm10-.73c.6.34 1 .99 1 1.73v5.5a3.5 3.5 0 0 1-3.5 3.5H5a2 2 0 0 1-1.73-1h7.23a2.5 2.5 0 0 0 2.5-2.5z"
]);
const $cdb0ff5c001a8842$export$ef5926354a49c152 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple20Filled', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5zm3.15.65a.5.5 0 0 0 0 .7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29 6.85 6.15a.5.5 0 0 0-.7 0M5.5 16c.46.6 1.18 1 2 1h5a4.5 4.5 0 0 0 4.5-4.5v-5c0-.82-.4-1.54-1-2v7a3.5 3.5 0 0 1-3.5 3.5z"
]);
const $cdb0ff5c001a8842$export$75c801830042f196 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple20Regular', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5zM5.5 4C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm2 13a2.5 2.5 0 0 1-2-1h7a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5zM6.85 6.15a.5.5 0 1 0-.7.7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29z"
]);
const $cdb0ff5c001a8842$export$7ed5f61fd9b3cf4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7z"
]);
const $cdb0ff5c001a8842$export$17860ebed1b09acd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5zM2 7v4.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7z"
]);
const $cdb0ff5c001a8842$export$571fe248b10678c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8z"
]);
const $cdb0ff5c001a8842$export$cc085cb1a0643386 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM3 8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5z"
]);
const $cdb0ff5c001a8842$export$a51b6aa254865438 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h13.5c1.8 0 3.25-1.46 3.25-3.25v-9c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66z"
]);
const $cdb0ff5c001a8842$export$44c7e2ed5c596085 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v9c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 17.75zM3.5 9.5v8.25c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66z"
]);
const $cdb0ff5c001a8842$export$1dc1d2ce4cfb16b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8z"
]);
const $cdb0ff5c001a8842$export$d6de7afe194c959a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v10.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25zm1.5.67v9.75c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8z"
]);
const $cdb0ff5c001a8842$export$c616433a79cf406d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13z"
]);
const $cdb0ff5c001a8842$export$5c488096ed9e653b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v11.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5zM4 13v10.5A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13z"
]);
const $cdb0ff5c001a8842$export$86b2c3e870c73218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-17.5C44 13.8 41.2 11 37.75 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1z"
]);
const $cdb0ff5c001a8842$export$b66d415a8fd2fef1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v17.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75zm2.5 6.25v16.25a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75v-17.5a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1z"
]);
const $cdb0ff5c001a8842$export$30b180a4501d8327 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm15 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $cdb0ff5c001a8842$export$f79fdb009e811ea6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zm15 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $cdb0ff5c001a8842$export$1169ebbe42e81a69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm17 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $cdb0ff5c001a8842$export$5971ab25790e8376 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm16 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $cdb0ff5c001a8842$export$5793f757fc13df72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm21 8a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $cdb0ff5c001a8842$export$31a94f852f67c764 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a7 7 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $cdb0ff5c001a8842$export$a30e809ccec4b43b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zm25 9a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V19h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V20h3.5a.5.5 0 0 0 0-1H21z"
]);
const $cdb0ff5c001a8842$export$a583a1881ff7ed0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65q-.67-.72-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87q.36.81.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25zm25 9.67a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V19h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V20h3.5a.5.5 0 0 0 0-1H21z"
]);
const $cdb0ff5c001a8842$export$d91282fdbd93bad5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm22 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H25v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
]);
const $cdb0ff5c001a8842$export$44bdc45e7f5dfee7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3q-.9-.82-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zm22 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H25v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
]);
const $cdb0ff5c001a8842$export$89a7f6405589afc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1zM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
]);
const $cdb0ff5c001a8842$export$fd847aaae7eace22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37q-1.14-1.09-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8q.5 1.33 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
]);
const $cdb0ff5c001a8842$export$ff8f3d71542c8557 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm10.5 9a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $cdb0ff5c001a8842$export$d5a9170169f5cb6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zM11.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $cdb0ff5c001a8842$export$9fa8cc4b98af39fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm12.5 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $cdb0ff5c001a8842$export$fdc3e40067989657 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $cdb0ff5c001a8842$export$ad649fee66185d89 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zM17.5 23a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m3-5a.5.5 0 0 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18z"
]);
const $cdb0ff5c001a8842$export$157e31eef8e7888e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a7 7 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75zM17.5 23a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m3-5a.5.5 0 0 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18z"
]);
const $cdb0ff5c001a8842$export$4a8cc74cca132358 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zM20.5 26a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13m4-6a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35q0 .2.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 20z"
]);
const $cdb0ff5c001a8842$export$dcce8e4af0ae14b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65q-.67-.72-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87q.36.81.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25zM20.5 26a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13m4-6a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35q0 .2.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 20z"
]);
const $cdb0ff5c001a8842$export$644f447565e1cdbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm14.5 10a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0m12.25 1h-7.69l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06l-2.72 2.72h7.69a.75.75 0 0 1 0 1.5"
]);
const $cdb0ff5c001a8842$export$9f4f3f8d34ed6270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3q-.9-.82-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zM16.5 23a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0m12.25 1h-7.69l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06l-2.72 2.72h7.69a.75.75 0 0 1 0 1.5"
]);
const $cdb0ff5c001a8842$export$aac62fd678c1f06c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1zM35 45a11 11 0 1 1 0-22 11 11 0 0 1 0 22m8-11a1 1 0 0 0-1-1H30.41l3.3-3.3a1 1 0 0 0-1.42-1.4l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.42-1.4L30.4 35H42a1 1 0 0 0 1-1"
]);
const $cdb0ff5c001a8842$export$3b65fce055e33add = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37q-1.14-1.09-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8q.5 1.33 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM35 45a11 11 0 1 1 0-22 11 11 0 0 1 0 22m8-11a1 1 0 0 0-1-1H30.41l3.3-3.3a1 1 0 0 0-1.42-1.4l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.42-1.4L30.4 35H42a1 1 0 0 0 1-1"
]);
const $cdb0ff5c001a8842$export$302f2aaa74d3013c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm10.5 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L12.29 11H9.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$68090fca8b3d983e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zM11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L12.29 11H9.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e0dae068ad9f4ccf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm12.5 2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$24f627cd110213ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$90a62fb19e17928f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9339cb80e5862ba9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a7 7 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6077ab72d9c944b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zM20.5 13a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m-4 6a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 19z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c303fcd0f756ce6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65q-.67-.72-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87q.36.81.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25zM20.5 13a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m-4 6a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 19z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$221156a8556f81d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm29.5 10a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-12.25-1h7.69l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72h-7.69a.75.75 0 0 1 0-1.5"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$baf075ba95515c73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight32Light', "32", [
    "M3 12h7.6c.71 0 1.4-.31 1.87-.85L15.23 8H25.5a3.5 3.5 0 0 1 3.5 3.5v4.02q.53.35 1 .77V11.5A4.5 4.5 0 0 0 25.5 7H14.7l-2.26-2.27A2.5 2.5 0 0 0 10.67 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h10.02a9 9 0 0 1-.58-1H6.5A3.5 3.5 0 0 1 3 23.5zm0-3.5A3.5 3.5 0 0 1 6.5 5h4.17q.62.01 1.06.44l2.35 2.35-2.36 2.7c-.28.32-.7.51-1.13.51H3zM31.5 23a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-12.25-1a.75.75 0 0 0 0 1.5h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06L26.94 22z"
]);
const $cdb0ff5c001a8842$export$c99fc446560e27f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3q-.9-.82-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zM31.5 23a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-12.25-1h7.69l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72h-7.69a.75.75 0 0 1 0-1.5"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9db0c29b9f63827a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1zM35 23a11 11 0 1 1 0 22 11 11 0 0 1 0-22m-8 11a1 1 0 0 0 1 1h11.59l-3.3 3.3a1 1 0 0 0 1.42 1.4l5-5a1 1 0 0 0 0-1.4l-5-5a1 1 0 0 0-1.42 1.4l3.3 3.3H28a1 1 0 0 0-1 1"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e392d21e88e31a24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37q-1.14-1.09-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8q.5 1.33 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM35 23a11 11 0 1 1 0 22 11 11 0 0 1 0-22m-8 11a1 1 0 0 0 1 1h11.59l-3.3 3.3a1 1 0 0 0 1.42 1.4l5-5a1 1 0 0 0 0-1.4l-5-5a1 1 0 0 0-1.42 1.4l3.3 3.3H28a1 1 0 0 0-1 1"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$aca497960b9b66f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm15 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9a.5.5 0 0 0-.35.14"
]);
const $cdb0ff5c001a8842$export$4f298807578b4683 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zm15 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9a.5.5 0 0 0-.35.14"
]);
const $cdb0ff5c001a8842$export$f8044c8c3ffaee0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm17 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $cdb0ff5c001a8842$export$c6ba17e1da0c19e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm16 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $cdb0ff5c001a8842$export$1ff0118277724ae1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm21 8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6 3a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 .7.7L17 15.71z"
]);
const $cdb0ff5c001a8842$export$647230c4d8916834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a7 7 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6 3a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 .7.7L17 15.71z"
]);
const $cdb0ff5c001a8842$export$c180386908c8e886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zm25 9a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-7 4a.5.5 0 0 0 1 0v-6.8l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.15l-3 3a.5.5 0 0 0 .7.7L20 16.71z"
]);
const $cdb0ff5c001a8842$export$7dc1838a2b686dd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65q-.67-.72-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87q.36.81.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25zm25 9.67a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-7 4a.5.5 0 0 0 1 0v-6.8l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.15l-3 3a.5.5 0 0 0 .7.7L20 16.71z"
]);
const $cdb0ff5c001a8842$export$a1cd7460a9c95f56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm29.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M25 20.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72v7.69a.75.75 0 0 0 1.5 0z"
]);
const $cdb0ff5c001a8842$export$2219fb60cfab9f98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3q-.9-.82-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zM31.5 23a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M25 20.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72v7.69a.75.75 0 0 0 1.5 0z"
]);
const $cdb0ff5c001a8842$export$fe95a3b9f86f41a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1zM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10.3-7.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 1.4 1.4l3.3-3.29V41a1 1 0 1 0 2 0V29.41l3.3 3.3a1 1 0 0 0 1.4-1.42z"
]);
const $cdb0ff5c001a8842$export$5d5f76cdaf32a7b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37q-1.14-1.09-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8q.5 1.33 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10.3-7.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 1.4 1.4l3.3-3.29V41a1 1 0 1 0 2 0V29.41l3.3 3.3a1 1 0 0 0 1.4-1.42z"
]);
const $cdb0ff5c001a8842$export$c89ae2c1a2e2f012 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderBriefcase20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17H9v-3.5a2.5 2.5 0 0 1 2.04-2.46A2.5 2.5 0 0 1 13.5 9h2a2.5 2.5 0 0 1 2.46 2.04l.04.01V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10 3.5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5m1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5"
]);
const $cdb0ff5c001a8842$export$e6390fb8878c4576 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderBriefcase20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H9v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2c.5.37.84.91.96 1.54l.04.01V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9 6v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5m1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5"
]);
const $cdb0ff5c001a8842$export$421eab4543225bb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDataBar20Filled', "20", [
    "M12 14a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m3-4a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m3 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m-2.5-7A2.5 2.5 0 0 1 18 7.5V11q-.54 0-1 .27V11a2 2 0 1 0-4 0v2.27q-.46-.26-1-.27a2 2 0 0 0-2 2v2H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $cdb0ff5c001a8842$export$4a50c0cd109b7e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDataBar20Regular', "20", [
    "M12 14a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m3-4a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m3 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5V11q-.54 0-1 .27V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H10v1H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $cdb0ff5c001a8842$export$9aaa5d85e5f73118 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismiss16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m1-3A2.5 2.5 0 0 1 15 6.5v.76A5.5 5.5 0 0 0 6.6 14H3.5A2.5 2.5 0 0 1 1 11.5V7h4.59q.62-.01 1.06-.44L9.2 4zm.85 5.65a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M5.6 2q.62.01 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5A2.5 2.5 0 0 1 3.5 2z"
]);
const $cdb0ff5c001a8842$export$e84c97ab7f7c1bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismiss16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M5.59 2q.62.01 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.15.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7A2.5 2.5 0 0 1 3.5 2zm7.76 7.65a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M3.5 3C2.67 3 2 3.67 2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3z"
]);
const $cdb0ff5c001a8842$export$df0ced0d2221e4dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismiss20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m1-5A2.5 2.5 0 0 1 18 7.5v2.76A5.5 5.5 0 0 0 9.6 17H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zm.85 7.65a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $cdb0ff5c001a8842$export$82a2f65d1e9fbeee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismiss20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v2.76a6 6 0 0 0-1-.66V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h4.7q.15.52.4 1H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zm9.37 9.65a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $cdb0ff5c001a8842$export$f1038de92f59973b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismiss24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m1.25-6.5c1.8 0 3.25 1.46 3.25 3.25v4.06A6.5 6.5 0 0 0 12.02 21H5.25A3.25 3.25 0 0 1 2 17.75V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34zm1.1 9.65a.5.5 0 0 0-.7 0l-1.65 1.64-1.65-1.64a.5.5 0 1 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 1 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 1 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0 0-.7M8.13 3c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22H2V6.25C2 4.45 3.46 3 5.25 3z"
]);
const $cdb0ff5c001a8842$export$d369ce25b2e2f5e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismiss24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M8.13 3c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06q-.67-.65-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25C2 4.45 3.46 3 5.25 3zm11.72 12.15a.5.5 0 0 0-.7 0l-1.65 1.64-1.65-1.64a.5.5 0 1 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 1 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 1 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0 0-.7M5.25 4.5c-.97 0-1.75.78-1.75 1.75V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22z"
]);
const $cdb0ff5c001a8842$export$37f788851c63a1b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14H8V8c0-1.1.9-2 2-2h2.59a2 2 0 0 1 1.41.59l1 1V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm9.25 0H12v2.5c0 .83.67 1.5 1.5 1.5H16v3.75c0 .69-.56 1.25-1.25 1.25h-4.5C9.56 16 9 15.44 9 14.75v-6.5C9 7.56 9.56 7 10.25 7M13 7l3 3h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $cdb0ff5c001a8842$export$2829e83e9161162f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument16Regular', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v1.09l-1-1V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5H8v1H3.5A2.5 2.5 0 0 1 1 11.5zm1 0V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5M10.25 7H12v2.5c0 .83.67 1.5 1.5 1.5H16v3.75c0 .69-.56 1.25-1.25 1.25h-4.5C9.56 16 9 15.44 9 14.75v-6.5C9 7.56 9.56 7 10.25 7M13 7l3 3h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $cdb0ff5c001a8842$export$fb6126671c3cbbd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17H11v-6c0-1.1.9-2 2-2h2.59a2 2 0 0 1 1.41.59l1 1V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm11.25 2H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25M16 10l3 3h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $cdb0ff5c001a8842$export$6fd9f466e295e9b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H11v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.09l1 1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM13.25 10H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25M16 10l3 3h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $cdb0ff5c001a8842$export$2aa77493853ade7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21H13v-7.5a2.5 2.5 0 0 1 2.5-2.5h2.92a2 2 0 0 1 1.42.59L22 13.75v-5c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm16 5.75V12h-2.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V17h-3.25c-.97 0-1.75-.78-1.75-1.75m1 0V12l4 4h-3.25a.75.75 0 0 1-.75-.75"
]);
const $cdb0ff5c001a8842$export$f6be6d517c2c0cc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument24Regular', "24", [
    "M2 6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.84l-1.5-1.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75H13V21H5.25A3.25 3.25 0 0 1 2 17.75zm1.5 0V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m14.5 9V12h-2.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V17h-3.25c-.97 0-1.75-.78-1.75-1.75m1 0V12l4 4h-3.25a.75.75 0 0 1-.75-.75"
]);
const $cdb0ff5c001a8842$export$56a1be16651fd86d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24H15v-8.25A2.75 2.75 0 0 1 17.75 13h4.84a2 2 0 0 1 1.41.59l2 2V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zM22 17v-3h-4.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V19h-3a2 2 0 0 1-2-2m1 0v-3l4 4h-3a1 1 0 0 1-1-1"
]);
const $cdb0ff5c001a8842$export$2d8bdea185e151d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument28Regular', "28", [
    "M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v5.84l-1.5-1.5V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25H15V24H5.75A3.75 3.75 0 0 1 2 20.25zm1.5-3.15V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M22 17v-3h-4.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V19h-3a2 2 0 0 1-2-2m1 0v-3l4 4h-3a1 1 0 0 1-1-1"
]);
const $cdb0ff5c001a8842$export$bebece98c3340332 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm9.55 1.15a9 9 0 0 0-.54 2.85h2.98a9 9 0 0 0-.54-2.85 3 3 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24q-.27.29-.53.91m-.72-.83q-.12.22-.2.46A10 10 0 0 0 9 11H7.03a4.5 4.5 0 0 1 2.8-3.68m3.34 0q.12.22.2.46c.35.86.57 1.99.62 3.22h1.98a4.5 4.5 0 0 0-2.8-3.68m2.8 4.68H14a10 10 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68m-4.47 4c.1 0 .23-.05.42-.24q.27-.29.53-.91c.3-.73.5-1.72.54-2.85h-2.98a9 9 0 0 0 .54 2.85q.26.63.53.91c.19.2.33.24.42.24m-1.67-.32A4.5 4.5 0 0 1 7.03 12H9a10 10 0 0 0 .82 3.68"
]);
const $cdb0ff5c001a8842$export$60c849b1d818fcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zm9.55 3.65a9 9 0 0 0-.54 2.85h2.98a9 9 0 0 0-.54-2.85 3 3 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24q-.27.29-.53.91m-.72-.83q-.12.22-.2.46A10 10 0 0 0 9 11H7.03a4.5 4.5 0 0 1 2.8-3.68m3.34 0q.12.22.2.46c.35.86.57 1.99.62 3.22h1.98a4.5 4.5 0 0 0-2.8-3.68m2.8 4.68H14a10 10 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68m-4.47 4c.1 0 .23-.05.42-.24q.27-.29.53-.91c.3-.73.5-1.72.54-2.85h-2.98a9 9 0 0 0 .54 2.85q.26.63.53.91c.19.2.33.24.42.24m-1.67-.32A4.5 4.5 0 0 1 7.03 12H9a10 10 0 0 0 .82 3.68"
]);
const $cdb0ff5c001a8842$export$20f3837e2021246e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm11.55 3.15a9 9 0 0 0-.54 2.85h2.98a9 9 0 0 0-.54-2.85 3 3 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24q-.27.29-.53.91m-.72-.83q-.12.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68m3.34 0q.12.22.2.46c.35.86.57 1.99.62 3.22h1.98a4.5 4.5 0 0 0-2.8-3.68m2.8 4.68H17a10 10 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68m-4.47 4c.1 0 .23-.05.42-.24q.27-.29.53-.91c.3-.73.5-1.72.54-2.85h-2.98a9 9 0 0 0 .54 2.85q.26.63.53.91c.19.2.33.24.42.24m-1.67-.32a4.5 4.5 0 0 1-2.8-3.68H12a10 10 0 0 0 .82 3.68"
]);
const $cdb0ff5c001a8842$export$f64c7ead07b985cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm10.55 5.65a9 9 0 0 0-.54 2.85h2.98a9 9 0 0 0-.54-2.85 3 3 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24q-.27.29-.53.91m-.72-.83q-.12.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68m3.34 0q.12.22.2.46c.35.86.57 1.99.62 3.22h1.98a4.5 4.5 0 0 0-2.8-3.68m2.8 4.68H17a10 10 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68m-4.47 4c.1 0 .23-.05.42-.24q.27-.29.53-.91c.3-.73.5-1.72.54-2.85h-2.98a9 9 0 0 0 .54 2.85q.26.63.53.91c.19.2.33.24.42.24m-1.67-.32a4.5 4.5 0 0 1-2.8-3.68H12a10 10 0 0 0 .82 3.68"
]);
const $cdb0ff5c001a8842$export$8d080bba3bb8faf7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHint20Filled', "20", [
    "M2.5 13.5c.28 0 .5.22.5.5v.5c0 .83.67 1.5 1.5 1.5H5a.5.5 0 0 1 0 1h-.5A2.5 2.5 0 0 1 2 14.5V14c0-.28.22-.5.5-.5M9 16a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm4 0a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm4.5-2.5c.28 0 .5.22.5.5v.5a2.5 2.5 0 0 1-2.5 2.5H15a.5.5 0 0 1 0-1h.5c.83 0 1.5-.67 1.5-1.5V14c0-.28.22-.5.5-.5M15.25 7c.41 0 .75.34.75.75v6.5c0 .41-.34.75-.75.75H4.75a.75.75 0 0 1-.75-.75v-4.5c0-.41.34-.75.75-.75h2a3 3 0 0 0 2.13-.88l.9-.9a.8.8 0 0 1 .53-.22zM2.5 10c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5m15 0c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5M7.09 3q.62.01 1.06.44l1.7 1.7c.2.2.2.52 0 .71l-1.7 1.71A1.5 1.5 0 0 1 7.09 8H6.5a.5.5 0 0 1 0-1h.59a.5.5 0 0 0 .35-.15L8.79 5.5 7.44 4.15A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5V7h1.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0v-3A2.5 2.5 0 0 1 4.5 3zm8.41 2A2.5 2.5 0 0 1 18 7.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5H15a.5.5 0 0 1 0-1zM13 5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
]);
const $cdb0ff5c001a8842$export$cf9710a7b546511e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHint20Regular', "20", [
    "M2.5 13.5c.28 0 .5.22.5.5v.5c0 .83.67 1.5 1.5 1.5H5a.5.5 0 0 1 0 1h-.5A2.5 2.5 0 0 1 2 14.5V14c0-.28.22-.5.5-.5M9 16a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm4 0a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm4.5-2.5c.28 0 .5.22.5.5v.5a2.5 2.5 0 0 1-2.5 2.5H15a.5.5 0 0 1 0-1h.5c.83 0 1.5-.67 1.5-1.5V14c0-.28.22-.5.5-.5M2.5 10c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5m15 0c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5M7.09 3q.62.01 1.06.44l1.7 1.7c.2.2.2.52 0 .71l-1.7 1.71A1.5 1.5 0 0 1 7.09 8H6.5a.5.5 0 0 1 0-1h.59a.5.5 0 0 0 .35-.15L8.79 5.5 7.44 4.15A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5V7h1.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0v-3A2.5 2.5 0 0 1 4.5 3zm8.41 2A2.5 2.5 0 0 1 18 7.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5H15a.5.5 0 0 1 0-1zM13 5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
]);
const $cdb0ff5c001a8842$export$cfd9ebf33ce7257f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHolder20Filled', "20", [
    "M15.5 5A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v-4.5c0-.83-.67-1.5-1.5-1.5h-7c-.83 0-1.5.67-1.5 1.5V17h-.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zm-2 7c.28 0 .5.22.5.5V17H6v-4.5c0-.28.22-.5.5-.5zm-6 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $cdb0ff5c001a8842$export$d9c38bd31e5fec2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHolder20Regular', "20", [
    "M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zm2.73 3L8.15 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H5v-3.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V16h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM6.5 12a.5.5 0 0 0-.5.5V16h8v-3.5a.5.5 0 0 0-.5-.5zm6 2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm-8-10C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $cdb0ff5c001a8842$export$f8a0c8e725b6e9ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h5a1.5 1.5 0 0 1-1.38-2.08l2.08-5A1.5 1.5 0 0 1 10.58 6h3.48q.55 0 .93.33A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm7.5 6h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $cdb0ff5c001a8842$export$34611243394b3d1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.33q-.4-.31-.94-.33h-.15c-.2-.58-.76-1-1.41-1H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h3.59c.2.57.74 1 1.41 1h-5A2.5 2.5 0 0 1 1 11.5zM8.5 13h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $cdb0ff5c001a8842$export$8f0f89148beb19a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h8a1.5 1.5 0 0 1-1.38-2.08l2.08-5A1.5 1.5 0 0 1 14.58 9H18V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.5 8h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $cdb0ff5c001a8842$export$6e79196f449a3c06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h8a1.5 1.5 0 0 1-1.41-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V9h1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM12.5 16h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $cdb0ff5c001a8842$export$ddb88d7b3f55e7a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h10.72l.25-1H14.5a1.5 1.5 0 0 1-1.36-2.14l2.82-6a1.5 1.5 0 0 1 1.36-.86H22V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zM17.32 12h4.83a.5.5 0 0 1 .43.75L20.75 16h1.5c.64 0 .99.76.56 1.24L18 22.75c-.5.58-1.45.09-1.26-.66L17.5 19h-3a.5.5 0 0 1-.45-.71l2.82-6a.5.5 0 0 1 .45-.29"
]);
const $cdb0ff5c001a8842$export$f694f162b3fc96c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25V11h-1.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h8.13c.27.3.66.5 1.12.5h1.72l-.25 1H5.25A3.25 3.25 0 0 1 2 17.75zM17.32 12h4.83a.5.5 0 0 1 .43.75L20.75 16h1.5c.64 0 .99.76.56 1.24L18 22.75c-.5.58-1.45.09-1.26-.66L17.5 19h-3a.5.5 0 0 1-.45-.71l2.82-6a.5.5 0 0 1 .45-.29"
]);
const $cdb0ff5c001a8842$export$1387df90dd354d83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h2.84A3.5 3.5 0 0 1 9.5 9h4q.82 0 1.5.34V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm8.5 3a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H13a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$93838779ab60ec7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v2.84a4 4 0 0 0-1-.3V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.54q.08.53.3 1H3.5A2.5 2.5 0 0 1 1 11.5zM9.5 10a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H13a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$6431cd10ce4968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.84a3.5 3.5 0 0 1 3.16-5h4q.82 0 1.5.34V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.5 5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$135708c5e5eebb97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.84a4 4 0 0 1-.3-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v4.54q.53.07 1 .3V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9.5 7.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$9376cd2034e0cd5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.63a4.75 4.75 0 0 1 3.87-7.5h3.5c1.02 0 1.97.32 2.75.88V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm21 8.75a3.75 3.75 0 0 0-3.75-3.75h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5V22h.2A3.75 3.75 0 0 0 23 18.24m-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75m3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75"
]);
const $cdb0ff5c001a8842$export$dd1261793e9cadfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v5.63a5 5 0 0 0-1.5-.71V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h5.92q.22.83.7 1.5H5.26A3.25 3.25 0 0 1 2 17.75zm21 12a3.75 3.75 0 0 0-3.75-3.75h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5V22h.2A3.75 3.75 0 0 0 23 18.24m-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75m3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75"
]);
const $cdb0ff5c001a8842$export$b4f37aed129d813e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.13a4.75 4.75 0 0 1 3.87-7.5h5.5q1.56.02 2.75.88V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zM17.75 19a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5h.5a.75.75 0 0 1 0 1.5zM17 21.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m6.25 2.25a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5z"
]);
const $cdb0ff5c001a8842$export$fee84c6e7c0e583b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v7.63a5 5 0 0 0-1.5-.71V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.42q.22.82.7 1.5H5.76A3.75 3.75 0 0 1 2 20.25zM17.75 19a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5h.5a.75.75 0 0 1 0 1.5zM17 21.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m6.25 2.25a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5z"
]);
const $cdb0ff5c001a8842$export$ab9b3d29a061650c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h8.3a6 6 0 0 1 5.2-9h6c1.54 0 2.94.58 4 1.53V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm19.5 8.5a1 1 0 0 0-1-1H20a4.5 4.5 0 1 0 0 9h.5a1 1 0 1 0 0-2H20a2.5 2.5 0 0 1 0-5h.5a1 1 0 0 0 1-1m4-1a1 1 0 1 0 0 2h.5a2.5 2.5 0 0 1 0 5h-.5a1 1 0 1 0 0 2h.5a4.5 4.5 0 1 0 0-9zm-5 3.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
]);
const $cdb0ff5c001a8842$export$201e1522ee318f00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v8.53a6 6 0 0 0-2-1.19V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h7.58q.19 1.09.72 2H6.5A4.5 4.5 0 0 1 2 23.5zm19.5 13a1 1 0 0 0-1-1H20a4.5 4.5 0 1 0 0 9h.5a1 1 0 1 0 0-2H20a2.5 2.5 0 0 1 0-5h.5a1 1 0 0 0 1-1m4-1a1 1 0 1 0 0 2h.5a2.5 2.5 0 0 1 0 5h-.5a1 1 0 1 0 0 2h.5a4.5 4.5 0 1 0 0-9zm-5 3.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
]);
const $cdb0ff5c001a8842$export$5f528ccd5100b2a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h11.62a8.4 8.4 0 0 1-.87-3.75A8.13 8.13 0 0 1 29 29h10c1.9 0 3.63.68 5 1.8V17.26C44 13.8 41.2 11 37.75 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1zm19 18.75C23 33.8 25.8 31 29.25 31h1.5a1.25 1.25 0 1 1 0 2.5h-1.5a3.75 3.75 0 1 0 0 7.5h1.5a1.25 1.25 0 1 1 0 2.5h-1.5A6.25 6.25 0 0 1 23 37.25m22 0C45 33.8 42.2 31 38.75 31h-1.5a1.25 1.25 0 1 0 0 2.5h1.5a3.75 3.75 0 1 1 0 7.5h-1.5a1.25 1.25 0 1 0 0 2.5h1.5c3.45 0 6.25-2.8 6.25-6.25m-17 0c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $cdb0ff5c001a8842$export$3030e71dd0785627 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v13.56a8 8 0 0 0-2.5-1.4V17.25a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75h10.84q.2 1.34.78 2.5H10.25A6.25 6.25 0 0 1 4 34.75zm19 25C23 33.8 25.8 31 29.25 31h1.5a1.25 1.25 0 1 1 0 2.5h-1.5a3.75 3.75 0 1 0 0 7.5h1.5a1.25 1.25 0 1 1 0 2.5h-1.5A6.25 6.25 0 0 1 23 37.25m22 0C45 33.8 42.2 31 38.75 31h-1.5a1.25 1.25 0 1 0 0 2.5h1.5a3.75 3.75 0 1 1 0 7.5h-1.5a1.25 1.25 0 1 0 0 2.5h1.5c3.45 0 6.25-2.8 6.25-6.25m-17 0c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $cdb0ff5c001a8842$export$b11100896c8ec3b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h4.59q.09-.29.3-.5a1.5 1.5 0 0 1 0-2A1.5 1.5 0 0 1 9.5 9h4.99q.26 0 .5.09V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm8.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM9 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$db6b71742cfb9a76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v2.59a2 2 0 0 0-.5-.09H14V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h4.59q.09.29.3.5a2 2 0 0 0-.3.5H3.5A2.5 2.5 0 0 1 1 11.5zM9.5 10a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM9 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$a9a88f6de9e73da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h6.59q.09-.29.3-.5a1.5 1.5 0 0 1 0-2A1.5 1.5 0 0 1 12.5 12h5.49V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.5 5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$5d1f5708bbc6ec59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h6.59q.09-.29.3-.5a2 2 0 0 1-.3-.5H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V12h1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9.5 7.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
]);
const $cdb0ff5c001a8842$export$df8a41e72faae368 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h2.55a3 3 0 0 1-.05-.5v-4A2.5 2.5 0 0 1 8.5 7h6q.26 0 .5.05V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm10.51 4.93L7.01 9.3c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 7 13.5v-3.05l4.25 2.48q.24.14.49.01"
]);
const $cdb0ff5c001a8842$export$75385421ca2c0a6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.55a3 3 0 0 0-.5-.05H14v-.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5H6v.5q0 .26.05.5H3.5A2.5 2.5 0 0 1 1 11.5zm10.51 7.43L7.01 9.3c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 7 13.5v-3.05l4.25 2.48q.24.14.49.01"
]);
const $cdb0ff5c001a8842$export$3836904429653055 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.55a3 3 0 0 1-.05-.5v-4a2.5 2.5 0 0 1 2.5-2.5h6q.26 0 .5.05V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm8.01 4.3 4.5 2.63L19 12.5v-.01c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3M19 13.64l-4.26 2.3a.5.5 0 0 1-.5 0L10 13.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5z"
]);
const $cdb0ff5c001a8842$export$f92cafa0f044d570 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.55a3 3 0 0 1-.05-.5V16H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V10h.5q.26 0 .5.05V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm7.01 6.8 4.5 2.63L19 12.5v-.01c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3M19 13.64l-4.26 2.3a.5.5 0 0 1-.5 0L10 13.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5z"
]);
const $cdb0ff5c001a8842$export$77d6150857088f3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h5.92a3 3 0 0 1-.17-1v-5a3 3 0 0 1 3-3h7a3 3 0 0 1 1 .17V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm10.02 5.22 5.49 3.2L23 14.98A2 2 0 0 0 21 13h-7a2 2 0 0 0-1.98 1.72M23 16.11l-5.26 2.83a.5.5 0 0 1-.5 0L12 15.86V20c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2z"
]);
const $cdb0ff5c001a8842$export$29b58f2a5bb979d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v3.42a3 3 0 0 0-1-.17h-.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75H11v.5a3 3 0 0 0 .17 1H5.25A3.25 3.25 0 0 1 2 17.75zm10.02 8.47 5.49 3.2L23 14.98A2 2 0 0 0 21 13h-7a2 2 0 0 0-1.98 1.72M23 16.11l-5.26 2.83a.5.5 0 0 1-.5 0L12 15.86V20c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2z"
]);
const $cdb0ff5c001a8842$export$8d8587b434fa2bf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h7.59a3.5 3.5 0 0 1-.34-1.5v-6a3.5 3.5 0 0 1 3.5-3.5h8q.82 0 1.5.34V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zM16.5 14a2.5 2.5 0 0 0-2.5 2.5v.2l6.5 3.24L27 16.7v-.19a2.5 2.5 0 0 0-2.5-2.5zM27 17.8l-6.28 3.15a.5.5 0 0 1-.44 0L14 17.8v4.69a2.5 2.5 0 0 0 2.5 2.5h8a2.5 2.5 0 0 0 2.5-2.5z"
]);
const $cdb0ff5c001a8842$export$4d4be69fde0fbbe7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v3.59a3.5 3.5 0 0 0-1.5-.34V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25H13q0 .82.34 1.5H5.75A3.75 3.75 0 0 1 2 20.25zM16.5 14a2.5 2.5 0 0 0-2.5 2.5v.2l6.5 3.24L27 16.7v-.19a2.5 2.5 0 0 0-2.5-2.5zM27 17.8l-6.28 3.15a.5.5 0 0 1-.44 0L14 17.8v4.69a2.5 2.5 0 0 0 2.5 2.5h8a2.5 2.5 0 0 0 2.5-2.5z"
]);
const $cdb0ff5c001a8842$export$45de31f056023c39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h7.11a5 5 0 0 1-.11-1v-8a4.5 4.5 0 0 1 4.5-4.5h10q1.09.01 2 .47V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm13 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v.2l-8 4.44-8-4.44zm8.36 6.16L31 20.9V27a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6.09l7.64 4.25c.22.12.5.12.72 0"
]);
const $cdb0ff5c001a8842$export$a80194b03a34969 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail32Light', "32", [
    "M3 12h7.6c.71 0 1.4-.31 1.87-.85L15.23 8H25.5a3.5 3.5 0 0 1 3.5 3.5v3.11q.53.12 1 .36V11.5A4.5 4.5 0 0 0 25.5 7H14.7l-2.26-2.27A2.5 2.5 0 0 0 10.67 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h7.11a5 5 0 0 1-.11-1h-7A3.5 3.5 0 0 1 3 23.5zm0-3.5A3.5 3.5 0 0 1 6.5 5h4.17q.62.01 1.06.44l2.35 2.35-2.36 2.7c-.28.32-.7.51-1.13.51H3zM15 19a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v.2l-8 4.44-8-4.44zm8.36 6.16L31 20.9V27a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6.09l7.64 4.25c.22.12.5.12.72 0"
]);
const $cdb0ff5c001a8842$export$c32b8a88939e009b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v2.97q-.91-.46-2-.47V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h7v1q0 .51.11 1H6.5A4.5 4.5 0 0 1 2 23.5zM15 19a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v.2l-8 4.44-8-4.44zm8.36 6.16L31 20.9V27a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6.09l7.64 4.25c.22.12.5.12.72 0"
]);
const $cdb0ff5c001a8842$export$6e64c7f454e1cc1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple16Filled', "16", [
    "m6.15 2.44.85.85-1.56 1.56a.5.5 0 0 1-.35.15H1v-.5A2.5 2.5 0 0 1 3.5 2h1.59c.4 0 .78.16 1.06.44M1 9.5V6h4.09c.4 0 .78-.16 1.06-.44L8.2 3.5h2.29A2.5 2.5 0 0 1 13 6v3.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 1 9.5M14 6v3.5a3.5 3.5 0 0 1-3.5 3.5h-7c.46.6 1.18 1 2 1h5A4.5 4.5 0 0 0 15 9.5V8c0-.82-.4-1.54-1-2"
]);
const $cdb0ff5c001a8842$export$7fbc89f41cb5db8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple16Regular', "16", [
    "M3.5 3C2.67 3 2 3.67 2 4.5V5h3.09a.5.5 0 0 0 .35-.15L6.29 4l-.85-.85A.5.5 0 0 0 5.09 3zM1 4.44V4.4A2.5 2.5 0 0 1 3.5 2h1.59c.4 0 .78.16 1.06.44L7.2 3.5h3.29A2.5 2.5 0 0 1 13 6v3.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 1 9.5zm6.2.06L6.16 5.56A1.5 1.5 0 0 1 5.09 6H2v3.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5zM14 6c.6.46 1 1.18 1 2v1.5a4.5 4.5 0 0 1-4.5 4.5h-5a2.5 2.5 0 0 1-2-1h7A3.5 3.5 0 0 0 14 9.5z"
]);
const $cdb0ff5c001a8842$export$d52c30e37f766338 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple20Filled', "20", [
    "M17 7.76c.6.55 1 1.35 1 2.24v2a5 5 0 0 1-5 5H7a3 3 0 0 1-2.24-1H13a4 4 0 0 0 4-4V7.76M13 5a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8h4.88a2 2 0 0 0 1.41-.59L10.71 5zM6.88 3a2 2 0 0 1 1.41.59l1.21 1.2-1.91 1.92a1 1 0 0 1-.71.29H2V6a3 3 0 0 1 3-3z"
]);
const $cdb0ff5c001a8842$export$411675fbaaebe016 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple20Regular', "20", [
    "M17 7.76c.6.55 1 1.35 1 2.24v2a5 5 0 0 1-5 5H7a3 3 0 0 1-2.24-1H13a4 4 0 0 0 4-4V7.76M6.87 3a2 2 0 0 1 1.41.59L9.71 5H13a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm1.41 4.41A2 2 0 0 1 6.88 8H3v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H9.7zM5 4a2 2 0 0 0-2 2v1h3.88a1 1 0 0 0 .7-.3L8.8 5.5 7.6 4.3a1 1 0 0 0-.71-.3z"
]);
const $cdb0ff5c001a8842$export$5d47f08b6cb77e64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple24Filled', "24", [
    "M20.5 8.5c.9.58 1.5 1.6 1.5 2.75v4A5.75 5.75 0 0 1 16.25 21h-8.5c-1.15 0-2.17-.6-2.74-1.5h11.24c2.35 0 4.25-1.9 4.25-4.25V8.51m-4.25-3c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.46 3.25-3.25 3.25h-11A3.25 3.25 0 0 1 2 15.25V9.5h5.4c.58 0 1.14-.23 1.56-.63.8-.78 2.53-2.48 3.37-3.37zM7.41 3c.57 0 1.12.22 1.54.62.4.39 1.03 1 1.58 1.57L7.91 7.8A.7.7 0 0 1 7.4 8H2V6.25C2 4.45 3.46 3 5.25 3z"
]);
const $cdb0ff5c001a8842$export$581a31c575c76175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple24Regular', "24", [
    "M20.5 8.5c.9.58 1.5 1.6 1.5 2.75v4A5.75 5.75 0 0 1 16.25 21h-8.5c-1.15 0-2.17-.6-2.74-1.5h11.24c2.35 0 4.25-1.9 4.25-4.25V8.51M7.4 3c.58 0 1.13.22 1.55.62.48.46 1.27 1.23 1.88 1.88h5.42c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.46 3.25-3.25 3.25h-11A3.25 3.25 0 0 1 2 15.25v-9C2 4.45 3.46 3 5.25 3zm3.43 4c-.6.65-1.4 1.42-1.88 1.88-.42.4-.97.62-1.54.62H3.5v5.75c0 .97.78 1.75 1.75 1.75h11c.97 0 1.75-.78 1.75-1.75v-6.5C18 7.78 17.22 7 16.25 7zM5.25 4.5c-.97 0-1.75.78-1.75 1.75V8h3.9q.3 0 .51-.2c.41-.4 1.04-1 1.56-1.55A59 59 0 0 0 7.91 4.7a.7.7 0 0 0-.5-.2z"
]);
const $cdb0ff5c001a8842$export$104a0571d57b411f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple28Filled', "28", [
    "M24.47 9.23A3.7 3.7 0 0 1 26 12.25v5.5C26 21.2 23.2 24 19.75 24H8.25c-1.24 0-2.34-.6-3.02-1.53q.26.03.52.03h14a4.75 4.75 0 0 0 4.75-4.75v-8q0-.27-.03-.52M19.75 6a3.75 3.75 0 0 1 3.75 3.75v8a3.75 3.75 0 0 1-3.75 3.75h-14A3.75 3.75 0 0 1 2 17.75V10.5h6.17c.73 0 1.43-.29 1.95-.8L13.8 6zM8.17 3c.73 0 1.43.29 1.95.8L12 5.7 9.06 8.63Q8.68 9 8.17 9H2V6.75A3.75 3.75 0 0 1 5.75 3z"
]);
const $cdb0ff5c001a8842$export$43d4e5d437cbdf0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple28Regular', "28", [
    "M24.47 9.23A3.7 3.7 0 0 1 26 12.25v5.5C26 21.2 23.2 24 19.75 24H8.25c-1.24 0-2.34-.6-3.02-1.53q.26.03.52.03h14a4.75 4.75 0 0 0 4.75-4.75v-8q0-.27-.03-.52M8.17 3c.73 0 1.43.29 1.95.8L12.3 6h7.44a3.75 3.75 0 0 1 3.75 3.75v8a3.75 3.75 0 0 1-3.75 3.75h-14A3.75 3.75 0 0 1 2 17.75v-11A3.75 3.75 0 0 1 5.75 3zm1.95 6.7c-.52.51-1.22.8-1.95.8H3.5v7.25C3.5 18.99 4.51 20 5.75 20h14C21 20 22 19 22 17.75v-8c0-1.24-1-2.25-2.25-2.25h-7.44zM5.75 4.5c-1.24 0-2.25 1-2.25 2.25V9h4.67q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37z"
]);
const $cdb0ff5c001a8842$export$feb6cef32ad33711 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple32Filled', "32", [
    "M27.99 10.25c1.21.8 2 2.19 2 3.75v6a8 8 0 0 1-8 8H10a4.5 4.5 0 0 1-3.74-2H22a6 6 0 0 0 6-6v-9.5zM22 6a4.5 4.5 0 0 1 4.5 4.5V20a4.5 4.5 0 0 1-4.5 4.5H6.5A4.5 4.5 0 0 1 2 20v-9h7.96a3.5 3.5 0 0 0 2.48-1.03l3.77-3.76.15-.21zM9.96 3c.93 0 1.82.37 2.48 1.03L14 5.59l-2.97 2.97A1.5 1.5 0 0 1 9.96 9H2V7.5A4.5 4.5 0 0 1 6.5 3z"
]);
const $cdb0ff5c001a8842$export$5b1e0bd80267d6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple32Regular', "32", [
    "M27.99 10.25c1.21.8 2 2.19 2 3.75v6a8 8 0 0 1-8 8H10a4.5 4.5 0 0 1-3.74-2H22a6 6 0 0 0 6-6v-9.5zM9.96 3c.93 0 1.82.37 2.48 1.03L14.41 6H22a4.5 4.5 0 0 1 4.5 4.5V20a4.5 4.5 0 0 1-4.5 4.5H6.5A4.5 4.5 0 0 1 2 20V7.5A4.5 4.5 0 0 1 6.5 3zm2.48 6.97A3.5 3.5 0 0 1 9.96 11H4v9a2.5 2.5 0 0 0 2.5 2.5H22a2.5 2.5 0 0 0 2.5-2.5v-9.5A2.5 2.5 0 0 0 22 8h-7.59zM6.5 5A2.5 2.5 0 0 0 4 7.5V9h5.96q.62-.01 1.07-.44L12.59 7l-1.56-1.56A1.5 1.5 0 0 0 9.96 5z"
]);
const $cdb0ff5c001a8842$export$c9a7406d3c105943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple48Filled', "48", [
    "M41.48 15.74A6.2 6.2 0 0 1 44 20.75v9.5C44 36.19 39.19 41 33.25 41h-18.5a6.2 6.2 0 0 1-5.02-2.52l.52.02h23c4.55 0 8.25-3.7 8.25-8.25v-14q0-.26-.02-.51M33.25 10c3.45 0 6.25 2.8 6.25 6.25v14c0 3.45-2.8 6.25-6.25 6.25h-23A6.25 6.25 0 0 1 4 30.25V17h11.76c1.12 0 2.2-.45 3-1.25L24.52 10zm-17.5-4.5c1.13 0 2.22.45 3.01 1.25l2.74 2.73-4.5 4.5c-.33.34-.78.52-1.24.52H4v-2.75C4 8.3 6.8 5.5 10.25 5.5z"
]);
const $cdb0ff5c001a8842$export$6e6e2f02c98e4902 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple48Regular', "48", [
    "M41.48 15.74A6.2 6.2 0 0 1 44 20.75v9.5C44 36.19 39.19 41 33.25 41h-18.5a6.2 6.2 0 0 1-5.02-2.52l.52.02h23c4.55 0 8.25-3.7 8.25-8.25v-14q0-.26-.02-.51M15.76 5.5c1.12 0 2.2.45 3 1.25L22.02 10h11.23c3.45 0 6.25 2.8 6.25 6.25v14c0 3.45-2.8 6.25-6.25 6.25h-23A6.25 6.25 0 0 1 4 30.25v-18.5C4 8.3 6.8 5.5 10.25 5.5zm3 10.25c-.8.8-1.88 1.25-3 1.25H6.5v13.25A3.75 3.75 0 0 0 10.25 34h23A3.75 3.75 0 0 0 37 30.25v-14a3.75 3.75 0 0 0-3.75-3.75H22.02zM10.25 8a3.75 3.75 0 0 0-3.75 3.75v2.75h9.26q.71 0 1.24-.51l2.73-2.74L17 8.51A1.8 1.8 0 0 0 15.76 8z"
]);
const $cdb0ff5c001a8842$export$19e16a61075adfae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen16Filled', "16", [
    "M1 4.5v4.97l1-1.72A3.5 3.5 0 0 1 5.01 6h7.93a2.5 2.5 0 0 0-2.45-2H7.2L5.66 2.44A1.5 1.5 0 0 0 4.59 2H3.5A2.5 2.5 0 0 0 1 4.5M5.02 7H13a2 2 0 0 1 1.73 3l-1.59 2.75A2.5 2.5 0 0 1 10.98 14H3a2 2 0 0 1-1.73-3l1.59-2.75A2.5 2.5 0 0 1 5.02 7"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ad18ab6762eea7cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen16Regular', "16", [
    "M2 4.5v4.6l.92-1.6A3 3 0 0 1 5.52 6h6.4c-.21-.58-.77-1-1.42-1H7a.5.5 0 0 1-.35-.15l-1.71-1.7A.5.5 0 0 0 4.59 3H3.5C2.67 3 2 3.67 2 4.5M7.07 14H3.5A2.5 2.5 0 0 1 1 11.5v-7A2.5 2.5 0 0 1 3.5 2h1.09c.4 0 .78.16 1.06.44L7.2 4h3.29a2.5 2.5 0 0 1 2.46 2.04 2.5 2.5 0 0 1 1.7 3.71l-1.58 2.75a3 3 0 0 1-2.6 1.5zM5.52 7A2 2 0 0 0 3.8 8L2.2 10.75A1.5 1.5 0 0 0 3.5 13h6.98a2 2 0 0 0 1.73-1l1.59-2.75A1.5 1.5 0 0 0 12.5 7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c143d94da5945b56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen20Filled', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v6.97l1.57-2.72A3.5 3.5 0 0 1 6.6 8H16v-.5A2.5 2.5 0 0 0 13.5 5H9.7L8.16 3.44A1.5 1.5 0 0 0 7.09 3zm-.07 7.25A2.5 2.5 0 0 1 6.6 9H17a2 2 0 0 1 1.73 3l-2.16 3.75A2.5 2.5 0 0 1 14.4 17H4a2 2 0 0 1-1.73-3z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1fad2891ebd54b46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen20Regular', "20", [
    "M3 5.5v6.6l1.5-2.6A3 3 0 0 1 7.1 8H15v-.5c0-.83-.67-1.5-1.5-1.5h-4a.5.5 0 0 1-.35-.15l-1.71-1.7A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5m1.28 10.48.22.02h9.4a2 2 0 0 0 1.73-1l2.17-3.75A1.5 1.5 0 0 0 16.5 9H7.1a2 2 0 0 0-1.73 1L3.2 13.75a1.5 1.5 0 0 0 1.08 2.23M2 14.46V5.5A2.5 2.5 0 0 1 4.5 3h2.59c.4 0 .78.16 1.06.44L9.7 5h3.79A2.5 2.5 0 0 1 16 7.5V8h.5a2.5 2.5 0 0 1 2.16 3.75L16.5 15.5a3 3 0 0 1-2.6 1.5H4.5a2.5 2.5 0 0 1-1.62-.6A2.5 2.5 0 0 1 2 14.46"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ddb3b82b55d0e31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen24Filled', "24", [
    "M5.25 3A3.25 3.25 0 0 0 2 6.25v8.91l2.04-3.54A4.3 4.3 0 0 1 7.73 9.5H20v-.75c0-1.8-1.46-3.25-3.25-3.25h-5.19L9.72 3.66c-.42-.42-1-.66-1.6-.66zm2.48 8h13.01a2.25 2.25 0 0 1 1.95 3.37l-3.03 5.26c-.5.85-1.4 1.37-2.38 1.37H4.26a2.25 2.25 0 0 1-1.95-3.37l3.03-5.26c.5-.85 1.4-1.37 2.39-1.37"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$500e61c6971f6840 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen24Regular', "24", [
    "M3.5 6.25c0-.97.78-1.75 1.75-1.75h2.88q.31 0 .53.22l2.06 2.06q.22.22.53.22h5.5c.97 0 1.75.78 1.75 1.75q0 .13.04.25H8.72c-1.34 0-2.58.71-3.25 1.87L3.5 14.28zM2 17.79A3.25 3.25 0 0 0 5.25 21h11.04c1.33 0 2.57-.72 3.24-1.88l3.03-5.25A3.25 3.25 0 0 0 19.96 9a1 1 0 0 0 .04-.25c0-1.8-1.45-3.25-3.25-3.25h-5.19L9.72 3.66c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25v11.54m6.72-7.3h11.03a1.75 1.75 0 0 1 1.51 2.63l-3.03 5.25c-.4.7-1.14 1.13-1.95 1.13H5.25a1.75 1.75 0 0 1-1.51-2.63l3.03-5.25c.4-.7 1.14-1.12 1.95-1.12"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3d017608e2b36d61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen28Filled', "28", [
    "M5.75 3A3.75 3.75 0 0 0 2 6.75v11.76l2.65-5.53A5.3 5.3 0 0 1 9.4 10H23v-.25A3.75 3.75 0 0 0 19.25 6h-5.59a.3.3 0 0 1-.17-.07L11.37 3.8A2.8 2.8 0 0 0 9.42 3zM2.12 21.76l-.01.03a1.64 1.64 0 0 0 1.53 2.2h15.97c1.34 0 2.58-.7 3.25-1.86l3.77-6.5a2.75 2.75 0 0 0-2.38-4.13H9.39c-1.44 0-2.76.83-3.38 2.13l-3.85 8.02z"
]);
const $cdb0ff5c001a8842$export$3f517a9ca79cdb4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen28Regular', "28", [
    "M5.75 3A3.75 3.75 0 0 0 2 6.75v14.3A2.86 2.86 0 0 0 4.88 24h14.6c1.34 0 2.58-.71 3.25-1.87l3.77-6.5A3.75 3.75 0 0 0 23.24 10H23v-.25A3.75 3.75 0 0 0 19.25 6h-5.59a.3.3 0 0 1-.17-.07L11.37 3.8A2.8 2.8 0 0 0 9.42 3zm15.75 7H9.39c-1.44 0-2.76.83-3.38 2.13l-2.5 5.23V6.75c0-1.24 1-2.25 2.24-2.25h3.67q.51 0 .89.37l2.12 2.12c.33.33.77.51 1.23.51h5.59c1.24 0 2.25 1 2.25 2.25zm-2.03 12.5H4.87a1.36 1.36 0 0 1-1.23-1.95l3.72-7.77a2.3 2.3 0 0 1 2.03-1.28h13.85a2.25 2.25 0 0 1 1.95 3.38l-3.77 6.5c-.4.7-1.15 1.12-1.95 1.12"
]);
const $cdb0ff5c001a8842$export$e1d6cdd4f5018324 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown16Filled', "16", [
    "M1 11.5V6.53l1 1.72A3.5 3.5 0 0 0 5.01 10h7.93a2.5 2.5 0 0 1-2.45 2H7.2l-1.55 1.56a1.5 1.5 0 0 1-1.06.44H3.5A2.5 2.5 0 0 1 1 11.5M5.02 9H13a2 2 0 0 0 1.73-3l-1.59-2.75A2.5 2.5 0 0 0 10.98 2H3a2 2 0 0 0-1.73 3l1.59 2.75A2.5 2.5 0 0 0 5.02 9"
]);
const $cdb0ff5c001a8842$export$77cc83f3510a112d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown16Regular', "16", [
    "M2 11.5V6.9l.92 1.6a3 3 0 0 0 2.6 1.5h6.4c-.21.58-.77 1-1.42 1H7a.5.5 0 0 0-.35.15l-1.71 1.7a.5.5 0 0 1-.35.15H3.5A1.5 1.5 0 0 1 2 11.5M7.07 2H3.5A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h1.09c.4 0 .78-.16 1.06-.44L7.2 12h3.29a2.5 2.5 0 0 0 2.46-2.04 2.5 2.5 0 0 0 1.7-3.71L13.08 3.5a3 3 0 0 0-2.6-1.5zM5.52 9A2 2 0 0 1 3.8 8L2.2 5.25A1.5 1.5 0 0 1 3.5 3h6.98a2 2 0 0 1 1.73 1l1.59 2.75A1.5 1.5 0 0 1 12.5 9z"
]);
const $cdb0ff5c001a8842$export$aae55a69808bf56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown20Filled', "20", [
    "M4.5 17A2.5 2.5 0 0 1 2 14.5V7.53l1.57 2.72A3.5 3.5 0 0 0 6.6 12H16v.5a2.5 2.5 0 0 1-2.5 2.5H9.7l-1.55 1.56a1.5 1.5 0 0 1-1.06.44zm-.07-7.25A2.5 2.5 0 0 0 6.6 11H17a2 2 0 0 0 1.73-3l-2.16-3.75A2.5 2.5 0 0 0 14.4 3H4a2 2 0 0 0-1.73 3z"
]);
const $cdb0ff5c001a8842$export$4de85368af242f00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown20Regular', "20", [
    "M3 14.5V7.9l1.5 2.6A3 3 0 0 0 7.1 12H15v.5c0 .83-.67 1.5-1.5 1.5h-4a.5.5 0 0 0-.35.15l-1.71 1.7a.5.5 0 0 1-.35.15H4.5A1.5 1.5 0 0 1 3 14.5M4.28 4.02 4.5 4h9.4a2 2 0 0 1 1.73 1l2.17 3.75A1.5 1.5 0 0 1 16.5 11H7.1a2 2 0 0 1-1.73-1L3.2 6.25a1.5 1.5 0 0 1 1.08-2.23M2 5.54v8.96A2.5 2.5 0 0 0 4.5 17h2.59c.4 0 .78-.16 1.06-.44L9.7 15h3.79a2.5 2.5 0 0 0 2.5-2.5V12h.5a2.5 2.5 0 0 0 2.16-3.75L16.5 4.5A3 3 0 0 0 13.9 3H4.5a2.5 2.5 0 0 0-1.62.6A2.5 2.5 0 0 0 2 5.54"
]);
const $cdb0ff5c001a8842$export$6d9210a95c9e9317 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown24Filled', "24", [
    "M5.25 21A3.25 3.25 0 0 1 2 17.75v-8.9l2.04 3.53a4.3 4.3 0 0 0 3.69 2.13H20v.74c0 1.8-1.46 3.25-3.25 3.25h-5.19l-1.84 1.85c-.42.42-1 .65-1.6.65zm2.48-8h13.01a2.25 2.25 0 0 0 1.95-3.37l-3.03-5.26A2.8 2.8 0 0 0 17.28 3H4.26A2.25 2.25 0 0 0 2.3 6.37l3.03 5.26c.5.85 1.4 1.38 2.39 1.38"
]);
const $cdb0ff5c001a8842$export$38daf38a18e9a41a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown24Regular', "24", [
    "M3.5 17.75c0 .97.78 1.75 1.75 1.75h2.88q.31 0 .53-.22l2.06-2.06a.8.8 0 0 1 .53-.22h5.5c.97 0 1.75-.78 1.75-1.75q0-.13.04-.25H8.72a3.8 3.8 0 0 1-3.25-1.87L3.5 9.72zM2 6.21A3.25 3.25 0 0 1 5.25 3h11.04c1.33 0 2.57.72 3.24 1.88l3.03 5.25a3.25 3.25 0 0 1-2.6 4.87q.03.12.04.25c0 1.8-1.45 3.25-3.25 3.25h-5.19l-1.84 1.84c-.42.42-1 .66-1.6.66H5.26A3.25 3.25 0 0 1 2 17.75V6.21m6.72 7.3h11.03a1.75 1.75 0 0 0 1.51-2.63l-3.03-5.25a2.3 2.3 0 0 0-1.95-1.13H5.25a1.75 1.75 0 0 0-1.51 2.63l3.03 5.25c.4.7 1.14 1.12 1.95 1.12"
]);
const $cdb0ff5c001a8842$export$ec3219a76d7d9d68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown28Filled', "28", [
    "M5.75 25A3.75 3.75 0 0 1 2 21.25V9.48l2.65 5.53A5.3 5.3 0 0 0 9.4 18H23v.25A3.75 3.75 0 0 1 19.25 22h-5.59a.3.3 0 0 0-.17.07l-2.12 2.12c-.52.52-1.22.8-1.95.8zM2.12 6.23l-.01-.02A1.64 1.64 0 0 1 3.64 4h15.97c1.34 0 2.58.71 3.25 1.87l3.77 6.5a2.75 2.75 0 0 1-2.38 4.13H9.39A3.8 3.8 0 0 1 6 14.37L2.16 6.34z"
]);
const $cdb0ff5c001a8842$export$e5e5bd7fba19ee03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown28Regular', "28", [
    "M5.75 25A3.75 3.75 0 0 1 2 21.25V6.95A2.87 2.87 0 0 1 4.88 4h14.6c1.34 0 2.58.71 3.25 1.87l3.77 6.5A3.75 3.75 0 0 1 23.24 18H23v.25A3.75 3.75 0 0 1 19.25 22h-5.59a.3.3 0 0 0-.17.07l-2.12 2.12c-.52.52-1.22.81-1.95.81zm15.75-7H9.39A3.8 3.8 0 0 1 6 15.87l-2.5-5.23v10.61c0 1.24 1 2.25 2.24 2.25h3.67q.51 0 .89-.37l2.12-2.12c.33-.33.77-.51 1.23-.51h5.59c1.24 0 2.25-1 2.25-2.25zM19.47 5.5H4.87a1.36 1.36 0 0 0-1.23 1.95l3.72 7.77a2.3 2.3 0 0 0 2.03 1.28h13.85a2.25 2.25 0 0 0 1.95-3.38l-3.77-6.5a2.3 2.3 0 0 0-1.95-1.12"
]);
const $cdb0ff5c001a8842$export$908e711d7460b5f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical16Filled', "16", [
    "M11.5 1H6.53l1.72 1A3.5 3.5 0 0 1 10 5.01v7.93a2.5 2.5 0 0 0 2-2.45V7.2l1.56-1.55c.28-.28.44-.67.44-1.06V3.5A2.5 2.5 0 0 0 11.5 1M9 5.02V13a2 2 0 0 1-3 1.73l-2.75-1.59A2.5 2.5 0 0 1 2 10.98V3a2 2 0 0 1 3-1.73l2.75 1.59A2.5 2.5 0 0 1 9 5.02"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e0ec99b270325676 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical16Regular', "16", [
    "M11.5 2H6.9l1.6.92a3 3 0 0 1 1.5 2.6v6.4c.58-.21 1-.77 1-1.42V7a.5.5 0 0 1 .15-.35l1.7-1.71a.5.5 0 0 0 .15-.35V3.5c0-.83-.67-1.5-1.5-1.5M2 7.07V3.5A2.5 2.5 0 0 1 4.5 1h7A2.5 2.5 0 0 1 14 3.5v1.09c0 .4-.16.78-.44 1.06L12 7.2v3.29a2.5 2.5 0 0 1-2.04 2.46 2.5 2.5 0 0 1-3.71 1.7L3.5 13.08a3 3 0 0 1-1.5-2.6zm7-1.55A2 2 0 0 0 8 3.8L5.25 2.2A1.5 1.5 0 0 0 3 3.5v6.98a2 2 0 0 0 1 1.73l2.75 1.59A1.5 1.5 0 0 0 9 12.5z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$29b8516e20a9bc2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical20Filled', "20", [
    "M17 4.5A2.5 2.5 0 0 0 14.5 2H7.53l2.72 1.57A3.5 3.5 0 0 1 12 6.6V16h.5a2.5 2.5 0 0 0 2.5-2.5V9.7l1.56-1.55c.28-.28.44-.67.44-1.06zm-7.25-.07A2.5 2.5 0 0 1 11 6.6V17a2 2 0 0 1-3 1.73l-3.75-2.16A2.5 2.5 0 0 1 3 14.4V4a2 2 0 0 1 3-1.73z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$5e37fbf3be69228c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical20Regular', "20", [
    "M14.5 3H7.9l2.6 1.5A3 3 0 0 1 12 7.1V15h.5c.83 0 1.5-.67 1.5-1.5v-4a.5.5 0 0 1 .15-.35l1.7-1.71a.5.5 0 0 0 .15-.35V4.5c0-.83-.67-1.5-1.5-1.5M4.02 4.28 4 4.5v9.4a2 2 0 0 0 1 1.73l3.75 2.17A1.5 1.5 0 0 0 11 16.5V7.1a2 2 0 0 0-1-1.73L6.25 3.2a1.5 1.5 0 0 0-2.23 1.08M5.54 2h8.96A2.5 2.5 0 0 1 17 4.5v2.59q-.01.61-.44 1.06L15 9.7v3.79a2.5 2.5 0 0 1-2.5 2.5H12v.5a2.5 2.5 0 0 1-3.75 2.16L4.5 16.5A3 3 0 0 1 3 13.9V4.5a2.5 2.5 0 0 1 .6-1.62A2.5 2.5 0 0 1 5.54 2"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$30211e8f41d2cdff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical24Filled', "24", [
    "M21 5.25C21 3.45 19.55 2 17.75 2H8.84l3.54 2.04a4.3 4.3 0 0 1 2.12 3.69V20h.75c1.8 0 3.25-1.46 3.25-3.25v-5.19l1.84-1.84c.42-.42.66-1 .66-1.6zm-8 2.48v13.01a2.25 2.25 0 0 1-3.37 1.95l-5.26-3.03A2.8 2.8 0 0 1 3 17.28V4.26A2.25 2.25 0 0 1 6.37 2.3l5.26 3.03c.85.5 1.37 1.4 1.37 2.39"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6d14b21d19a8f49e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical24Regular', "24", [
    "M17.75 3.5c.97 0 1.75.78 1.75 1.75v2.88q0 .31-.22.53l-2.06 2.06a.8.8 0 0 0-.22.53v5.5c0 .97-.78 1.75-1.75 1.75a1 1 0 0 0-.25.04V8.72c0-1.34-.71-2.58-1.87-3.25L9.72 3.5zM6.21 2A3.25 3.25 0 0 0 3 5.25v11.04c0 1.33.72 2.57 1.88 3.24l5.25 3.03a3.25 3.25 0 0 0 4.87-2.6q.12.03.25.04c1.8 0 3.25-1.45 3.25-3.25v-5.19l1.84-1.84c.42-.42.66-1 .66-1.6V5.26C21 3.45 19.54 2 17.75 2H6.21m7.3 6.72v11.03a1.75 1.75 0 0 1-2.63 1.51l-5.25-3.03a2.3 2.3 0 0 1-1.13-1.95V5.25a1.75 1.75 0 0 1 2.63-1.51l5.25 3.03c.7.4 1.12 1.14 1.12 1.95"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fcd7f2ca060ff553 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.52L9 16.6a2.6 2.6 0 0 1 1.95-2.52 2.75 2.75 0 1 1 4.54-3 2.2 2.2 0 0 1 2.51-.35V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm12.75 4.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $cdb0ff5c001a8842$export$55de418d0b54761e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.52L9 16.6q0-.3.07-.6H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v3q.54 0 1 .23V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm11.75 6.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $cdb0ff5c001a8842$export$77e202914547f38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h5.87a4 4 0 0 1-.12-1 3 3 0 0 1 2.33-2.93A2.99 2.99 0 0 1 15.5 12a3 3 0 0 1 2.88 2.17A2.5 2.5 0 0 1 22 13.5V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zM15.5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3m4-1.02.5.02c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.16c.47.53.76 1.23.76 2 0 .66-.14 1.35-.5 1.98M22 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $cdb0ff5c001a8842$export$cebfc8f0d5a5e0e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.75q-.65-.48-1.5-.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h5.8q-.05.24-.05.5 0 .5.12 1H5.25A3.25 3.25 0 0 1 2 17.75zM15.5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3m4-1.02.5.02c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.16c.47.53.76 1.23.76 2 0 .66-.14 1.35-.5 1.98M22 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $cdb0ff5c001a8842$export$15e4c7ad738fee37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5V6h4.59a.5.5 0 0 0 .35-.15L8 3.8 6.65 2.44A1.5 1.5 0 0 0 5.59 2zM1 11.5V7h4.59c.4 0 .78-.16 1.06-.44L9.2 4h3.29A2.5 2.5 0 0 1 15 6.5v.84a3 3 0 1 0-4.73 3.67A2.5 2.5 0 0 0 8.04 14H3.5A2.5 2.5 0 0 1 1 11.5M14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $cdb0ff5c001a8842$export$624aab655db9af8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson16Regular', "16", [
    "M2 6V4.5C2 3.67 2.67 3 3.5 3h2.09a.5.5 0 0 1 .35.15L7.29 4.5 5.94 5.85a.5.5 0 0 1-.35.15zm1.5-4A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h4.54a3 3 0 0 1 .01-1H3.5A1.5 1.5 0 0 1 2 11.5V7h3.59c.4 0 .78-.16 1.06-.44L8.2 5h4.29c.8 0 1.44.62 1.5 1.4q.6.35 1 .94V6.5A2.5 2.5 0 0 0 12.5 4H8.2L6.66 2.44A1.5 1.5 0 0 0 5.59 2zm11 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $cdb0ff5c001a8842$export$fc92ba0b56bf8bb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson20Filled', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5V7h5.09a.5.5 0 0 0 .35-.15L9.5 4.8 8.22 3.51A1.8 1.8 0 0 0 6.98 3zM2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79A2.5 2.5 0 0 1 18 7.5v2.84a3 3 0 1 0-4.73 3.67A2.5 2.5 0 0 0 11.04 17H4.5A2.5 2.5 0 0 1 2 14.5M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $cdb0ff5c001a8842$export$eadca07819411a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson20Regular', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v2.84q-.4-.57-1-.94V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h6.55a3 3 0 0 0-.01 1H4.5A2.5 2.5 0 0 1 2 14.5zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4zm13 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $cdb0ff5c001a8842$export$3dc709ff1bef6678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson24Filled', "24", [
    "M2 6.25V8h6.13q.31 0 .53-.22l2.59-2.6-1.53-1.52c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25m0 11.5V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69c1.8 0 3.25 1.46 3.25 3.25v5.75a3.5 3.5 0 1 0-5.95 2.5h-.28A2.77 2.77 0 0 0 13 19.77v.1q0 .57.17 1.13H5.25A3.25 3.25 0 0 1 2 17.75m19-3.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $cdb0ff5c001a8842$export$bfa086208f7fd30a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson24Regular', "24", [
    "M3.5 8V6.25c0-.97.78-1.75 1.75-1.75h2.88q.31 0 .53.22l1.53 1.53-1.53 1.53a.8.8 0 0 1-.53.22zm1.75-5A3.25 3.25 0 0 0 2 6.25v11.5C2 19.55 3.46 21 5.25 21h7.92a4 4 0 0 1-.17-1.12v-.1l.01-.28H5.25c-.97 0-1.75-.78-1.75-1.75V9.5h4.63c.6 0 1.17-.24 1.59-.66L11.56 7h7.19c.97 0 1.75.78 1.75 1.75v2.88A3.5 3.5 0 0 1 22 14.5V8.75c0-1.8-1.46-3.25-3.25-3.25h-7.19L9.72 3.66c-.42-.42-1-.66-1.6-.66zM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $cdb0ff5c001a8842$export$9e8694636165c164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson28Filled', "28", [
    "M5.75 3A3.75 3.75 0 0 0 2 6.75V9h7.42q.51 0 .89-.37l2.94-2.94-1.88-1.88A2.8 2.8 0 0 0 9.42 3zM2 20.25V10.5h7.42c.73 0 1.43-.29 1.95-.8l3.7-3.7h7.18A3.75 3.75 0 0 1 26 9.75V17h-.5a4 4 0 1 0-6.65 3h-.8A3.04 3.04 0 0 0 15 23.04v.21q0 .38.07.75H5.75A3.75 3.75 0 0 1 2 20.25M24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $cdb0ff5c001a8842$export$e75239a7136d7945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson28Regular', "28", [
    "M3.5 6.75v-.07A2.25 2.25 0 0 1 5.75 4.5h3.67q.51 0 .89.37l1.88 1.88-1.88 1.88Q9.93 9 9.42 9H3.5zm-1.5 3v10.5A3.75 3.75 0 0 0 5.75 24h9.32q-.07-.38-.07-.75v-.2q0-.29.05-.55h-9.3c-1.24 0-2.25-1-2.25-2.25V10.5h5.92c.73 0 1.43-.29 1.95-.8l2.2-2.2h8.68c1.24 0 2.25 1 2.25 2.25v4.6c.62.71 1 1.64 1 2.65h.5V9.75A3.75 3.75 0 0 0 22.25 6h-8.69l-2.2-2.2A2.8 2.8 0 0 0 9.43 3H5.75A3.75 3.75 0 0 0 2 6.75zM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $cdb0ff5c001a8842$export$aebfac0f6661d28b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson32Filled', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5V11h8.46q.62-.01 1.07-.44L15 7.1l-2.06-2.06A3.5 3.5 0 0 0 10.46 4zM2 23.5V13h8.46a3.5 3.5 0 0 0 2.48-1.03L17.4 7.5h8.09A4.5 4.5 0 0 1 30 12v7h-.02a5 5 0 1 0-8.55 4h-.01a3.93 3.93 0 0 0-3.92 3.94 5 5 0 0 0 .11 1.06H6.5A4.5 4.5 0 0 1 2 23.5m26.5-4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06a2.43 2.43 0 0 1 2.42-2.44h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $cdb0ff5c001a8842$export$9a716a537fa6fa91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson32Regular', "32", [
    "M4 11V8.5A2.5 2.5 0 0 1 6.5 6h3.96q.62.01 1.07.44l2.06 2.06-2.06 2.06a1.5 1.5 0 0 1-1.07.44zm2.5-7A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h11.11a5 5 0 0 1 0-2H6.5A2.5 2.5 0 0 1 4 23.5V13h6.46a3.5 3.5 0 0 0 2.48-1.03L15.4 9.5H25.5A2.5 2.5 0 0 1 28 12v3.5a5 5 0 0 1 1.98 3.5H30v-7a4.5 4.5 0 0 0-4.5-4.5H15.41l-2.47-2.47A3.5 3.5 0 0 0 10.46 4zm22 15.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06a2.43 2.43 0 0 1 2.42-2.44h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $cdb0ff5c001a8842$export$91f7a70b2a2632fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson48Filled', "48", [
    "M10.25 6A6.25 6.25 0 0 0 4 12.25V16h12.71q.52 0 .89-.37l5.15-5.15-3.38-3.38C18.67 6.4 17.7 6 16.7 6zM4 34.75V18.5h12.71c1 0 1.95-.4 2.66-1.1l6.4-6.4h11.98C41.2 11 44 13.8 44 17.25V29a7 7 0 1 0-11.9 5H31a5 5 0 0 0-5 5v.5q0 .77.15 1.5h-15.9A6.25 6.25 0 0 1 4 34.75M42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $cdb0ff5c001a8842$export$456531f495db9677 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson48Regular', "48", [
    "M6.5 16v-3.75a3.75 3.75 0 0 1 3.75-3.75h6.46q.52 0 .89.37l3.38 3.38-3.38 3.38q-.37.37-.89.37zm3.75-10A6.25 6.25 0 0 0 4 12.25v22.5C4 38.2 6.8 41 10.25 41h15.9q-.15-.73-.15-1.5V39q0-.26.02-.5H10.25a3.75 3.75 0 0 1-3.75-3.75V18.5h10.21c1 0 1.95-.4 2.66-1.1l3.9-3.9h14.48a3.75 3.75 0 0 1 3.75 3.75v6.39A7 7 0 0 1 44 29V17.25C44 13.8 41.2 11 37.75 11H23.27l-3.9-3.9C18.67 6.4 17.7 6 16.7 6zM42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $cdb0ff5c001a8842$export$1607886dae23522e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm6 4.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6"
]);
const $cdb0ff5c001a8842$export$a23aa322810fc6f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zm6 7a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6"
]);
const $cdb0ff5c001a8842$export$51249d8510360eb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm8 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $cdb0ff5c001a8842$export$81dfc1c0b282afe5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm7 9a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $cdb0ff5c001a8842$export$7d3255d4588745b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm21 8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3m4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69"
]);
const $cdb0ff5c001a8842$export$73bdca25564c50dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a7 7 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3m4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69"
]);
const $cdb0ff5c001a8842$export$a7be6f245e6d1fc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94Q9.93 9 9.42 9H2zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8zM20.5 26a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0-1.5a5 5 0 0 1-2.97-.97l7-7a5 5 0 0 1-4.03 7.97m2.97-9.03-7 7a5 5 0 0 1 7-7"
]);
const $cdb0ff5c001a8842$export$828d220f8d97349f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited28Regular', "28", [
    "M3.5 6.68V9h5.92q.51 0 .89-.37l1.88-1.88-1.88-1.88a1.3 1.3 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65q-.67-.72-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87q.36.81.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25zM20.5 26a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0-1.5a5 5 0 0 1-2.97-.97l7-7a5 5 0 0 1-4.03 7.97m2.97-9.03-7 7a5 5 0 0 1 7-7"
]);
const $cdb0ff5c001a8842$export$92896d56835b5bfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2zM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13zm22 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-2a5.5 5.5 0 0 1-3.12-.97l7.65-7.65A5.5 5.5 0 0 1 24 28.5m3.12-10.03-7.65 7.65a5.5 5.5 0 0 1 7.65-7.65"
]);
const $cdb0ff5c001a8842$export$64d4a7360bfa740d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited32Regular', "32", [
    "M4 8.5V11h6.46q.62-.01 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5m-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3q-.9-.82-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zm22 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-2a5.5 5.5 0 0 1-3.12-.97l7.65-7.65A5.5 5.5 0 0 1 24 28.5m3.12-10.03-7.65 7.65a5.5 5.5 0 0 1 7.65-7.65"
]);
const $cdb0ff5c001a8842$export$1584824f0540934c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15q-.37.37-.89.37H4zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1zM35 45a11 11 0 1 0 0-22 11 11 0 0 0 0 22m0-2.5c-1.9 0-3.65-.62-5.06-1.67l11.89-11.9A8.5 8.5 0 0 1 35 42.5m5.06-15.33-11.89 11.9a8.5 8.5 0 0 1 11.9-11.9"
]);
const $cdb0ff5c001a8842$export$c94a2a983c654f9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited48Regular', "48", [
    "M6.5 12.25V16h10.21q.52 0 .89-.37l3.38-3.38-3.38-3.38a1.3 1.3 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75m-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37q-1.14-1.09-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8q.5 1.33 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM35 45a11 11 0 1 0 0-22 11 11 0 0 0 0 22m0-2.5c-1.9 0-3.65-.62-5.06-1.67l11.89-11.9A8.5 8.5 0 0 1 35 42.5m5.06-15.33-11.89 11.9a8.5 8.5 0 0 1 11.9-11.9"
]);
const $cdb0ff5c001a8842$export$7a90f22b36758c52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5V6h4.59a.5.5 0 0 0 .35-.15L8 3.8 6.65 2.44A1.5 1.5 0 0 0 5.59 2zM1 11.5V7h4.59c.4 0 .78-.16 1.06-.44L9.2 4h3.29A2.5 2.5 0 0 1 15 6.5V10h-.03a4.5 4.5 0 1 0-7.3 4H3.5A2.5 2.5 0 0 1 1 11.5m9.5 2.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 12.6a3.5 3.5 0 1 0-2.8 1.4m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$2ccd8ffbfbdec873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch16Regular', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h4.17a5 5 0 0 1-.91-1H3.5A1.5 1.5 0 0 1 2 11.5V7h3.59c.4 0 .78-.16 1.06-.44L8.2 5h4.29c.83 0 1.5.67 1.5 1.5v1.17c.53.65.88 1.45.97 2.33H15V6.5A2.5 2.5 0 0 0 12.5 4H8.2L6.66 2.44A1.5 1.5 0 0 0 5.59 2zM2 6V4.5C2 3.67 2.67 3 3.5 3h2.09a.5.5 0 0 1 .35.15L7.29 4.5 5.94 5.85a.5.5 0 0 1-.35.15zm8.5 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 12.6a3.5 3.5 0 1 0-2.8 1.4m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$c19f7124bc90ec5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch20Filled', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5V7h5.09a.5.5 0 0 0 .35-.15L9.5 4.8 8.22 3.51A1.8 1.8 0 0 0 6.98 3zM2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79A2.5 2.5 0 0 1 18 7.5V12h-.03A4.5 4.5 0 1 0 13 16.97V17H4.5A2.5 2.5 0 0 1 2 14.5M13.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-3.5 3.5m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$7cd2d5a500d8d5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch20Regular', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5V12h-.03A4.5 4.5 0 0 0 17 9.67V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h6.17q1 .82 2.33.97V17H4.5A2.5 2.5 0 0 1 2 14.5zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4zm9 12c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-3.5 3.5m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $cdb0ff5c001a8842$export$544adf2310035877 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch24Filled', "24", [
    "M2 6.25V8h6.13q.31 0 .53-.22l2.59-2.6-1.53-1.52c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25m0 11.5V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69c1.8 0 3.25 1.46 3.25 3.25V15h-.02a5.5 5.5 0 1 0-5.48 6H5.25A3.25 3.25 0 0 1 2 17.75M16.5 21q.26 0 .5-.02V21zm0-1c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 16.5 20m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $cdb0ff5c001a8842$export$67550ebb27033d87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch24Regular', "24", [
    "M5.25 3A3.25 3.25 0 0 0 2 6.25v11.5C2 19.55 3.46 21 5.25 21H17v-.02a5.6 5.6 0 0 1-4.27-1.48H5.25c-.97 0-1.75-.78-1.75-1.75V9.5h4.63c.6 0 1.17-.24 1.59-.66L11.56 7h7.19c.97 0 1.75.78 1.75 1.75v2.98A5.5 5.5 0 0 1 21.98 15H22V8.75c0-1.8-1.46-3.25-3.25-3.25h-7.19L9.72 3.66c-.42-.42-1-.66-1.6-.66zM3.5 8V6.25c0-.97.78-1.75 1.75-1.75h2.88q.31 0 .53.22l1.53 1.53-1.53 1.53a.8.8 0 0 1-.53.22zm13 12c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 16.5 20m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $cdb0ff5c001a8842$export$f5701a0f692af73d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h2.38l-.44-.44a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 9.9 11h1.18a1.5 1.5 0 0 1 2.47-1.56L15 10.88V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm7.85 3.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L7.71 13h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L13.29 12H7.71z"
]);
const $cdb0ff5c001a8842$export$50a6cf702f650f9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v4.38l-1-1V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h1.59q.1.31.35.56l.44.44H3.5A2.5 2.5 0 0 1 1 11.5zm7.85 6.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L7.71 13h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L13.29 12H7.71z"
]);
const $cdb0ff5c001a8842$export$b3d831d4ec14e349 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.38l-.44-.44a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 13.9 14h1.18a1.5 1.5 0 0 1 2.47-1.56l.44.44V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.85 5.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58z"
]);
const $cdb0ff5c001a8842$export$1bc1cce9d8687adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.38l-.44-.44a2 2 0 0 1-.35-.56H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v4.59q.31.1.56.35l.44.44V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9.85 8.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58z"
]);
const $cdb0ff5c001a8842$export$6c983157a9f9d4de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap24Filled', "24", [
    "M2 6.25V8h6.13q.31 0 .53-.22l2.59-2.6-1.53-1.52c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25m0 11.5V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69c1.8 0 3.25 1.46 3.25 3.25v7.28L20.99 15A1.75 1.75 0 0 0 18.17 17h-1.34a1.75 1.75 0 0 0-2.82-1.99l-2.5 2.5c-.68.69-.68 1.8 0 2.48L12.53 21H5.25A3.25 3.25 0 0 1 2 17.75m13.78-.97a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h5.88l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06L20.44 18h-5.88z"
]);
const $cdb0ff5c001a8842$export$fd5a03beb13e1c22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap24Regular', "24", [
    "M3.5 8V6.25c0-.97.78-1.75 1.75-1.75h2.88q.31 0 .53.22l1.53 1.53-1.53 1.53a.8.8 0 0 1-.53.22zm1.75-5A3.25 3.25 0 0 0 2 6.25v11.5C2 19.55 3.46 21 5.25 21h7.28l-1.02-1.01a2 2 0 0 1-.34-.49H5.25c-.97 0-1.75-.78-1.75-1.75V9.5h4.63c.6 0 1.17-.24 1.59-.66L11.56 7h7.19c.97 0 1.75.78 1.75 1.75v5.92q.27.13.49.34L22 16.03V8.75c0-1.8-1.46-3.25-3.25-3.25h-7.19L9.72 3.66c-.42-.42-1-.66-1.6-.66zm10.53 13.78a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h5.88l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06L20.44 18h-5.88z"
]);
const $cdb0ff5c001a8842$export$aa0ab355e9a49a80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1zM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7zm6 4.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $cdb0ff5c001a8842$export$468d741e37cb9473 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5m-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a6 6 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7q.16.52.4 1H3.5A2.5 2.5 0 0 1 1 11.5zm6 7a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $cdb0ff5c001a8842$export$d9db346fc09348b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm8 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $cdb0ff5c001a8842$export$4ee5bf5e22fc6239 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm7 9a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $cdb0ff5c001a8842$export$603670d19d386dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66zm10 8a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5M15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19"
]);
const $cdb0ff5c001a8842$export$6cc3ccb930af7799 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync24Regular', "24", [
    "M3.5 6.25V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75m-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a7 7 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06q.27.8.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75zM12 17.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5M15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19"
]);
const $cdb0ff5c001a8842$export$f61051c8fbc12fc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip16Filled', "16", [
    "M11 11a1 1 0 0 1 1 1v2.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25V11.9a1 1 0 0 1 1-.9m1.5-7A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2 2.45V12a2 2 0 1 0-4 0v2H3.5A2.5 2.5 0 0 1 1 11.5V7h4.59q.62-.01 1.06-.44L9.2 4zM11 10h1.5a.5.5 0 0 0 0-1H11zM9.5 8a.5.5 0 0 0 0 1H11V8zM11 8h1.5a.5.5 0 0 0 0-1H11zM9.5 6a.5.5 0 0 0 0 1H11V6zM5.59 2q.62.01 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5A2.5 2.5 0 0 1 3.5 2z"
]);
const $cdb0ff5c001a8842$export$d50dc786c074ae76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip16Regular', "16", [
    "M5.59 2q.62.01 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2 2.45v.67c0 .18-.13.34-.3.37l-.08.01H9.3a.4.4 0 0 1-.31-.38V14H3.5A2.5 2.5 0 0 1 1 11.5v-7A2.5 2.5 0 0 1 3.5 2zM11 11a1 1 0 0 0-1 .9V14h2v-2a1 1 0 0 0-1-1M6.65 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5H9v-1a2 2 0 1 1 4 0v.91c.58-.2 1-.76 1-1.41v-5c0-.83-.67-1.5-1.5-1.5H8.2zM12.5 9a.5.5 0 0 1 0 1H11V9zM11 9H9.5a.5.5 0 0 1 0-1H11zm1.5-2a.5.5 0 0 1 0 1H11V7zM11 7H9.5a.5.5 0 0 1 0-1H11zM3.5 3C2.67 3 2 3.67 2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3z"
]);
const $cdb0ff5c001a8842$export$7c322acb2a9ae382 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip20Filled', "20", [
    "M13 13a1 1 0 0 1 1 1v3.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25V14a1 1 0 0 1 1-1m2.5-8A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v-3a2 2 0 1 0-4 0v3H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zm-4 6a.5.5 0 0 0 0 1H13v-1zm1.5 0h1.5a.5.5 0 0 0 0-1H13zm-1.5-2a.5.5 0 0 0 0 1H13V9zM13 9h1.5a.5.5 0 0 0 0-1H13zm-1.5-2a.5.5 0 0 0 0 1H13V7zM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $cdb0ff5c001a8842$export$b0afb2ca0125d471 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip20Regular', "20", [
    "M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v.54c0 .25-.2.46-.46.46h-3.08l-.1-.01a.46.46 0 0 1-.36-.45V17H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zM13 13a1 1 0 0 0-1 1v3h2v-3a1 1 0 0 0-1-1M8.15 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H11v-2a2 2 0 1 1 4 0v2h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H9.7zM13 12h-1.5a.5.5 0 0 1 0-1H13zm1.5-2a.5.5 0 0 1 0 1H13v-1zM13 10h-1.5a.5.5 0 0 1 0-1H13zm1.5-2a.5.5 0 0 1 0 1H13V8zM13 8h-1.5a.5.5 0 0 1 0-1H13zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $cdb0ff5c001a8842$export$91fd1941ca09a722 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip24Filled', "24", [
    "M17.5 22.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V18a1.5 1.5 0 0 1 3 0zm1.25-17c1.8 0 3.25 1.46 3.25 3.25v9a3.25 3.25 0 0 1-3 3.24V18a3 3 0 0 0-3-3v-1h-2.25a.75.75 0 0 0 0 1.5h.6A3 3 0 0 0 13 18v3H5.25A3.25 3.25 0 0 1 2 17.75V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34zM16 14h2.25a.75.75 0 0 0 0-1.5H16zm-2.25-3a.75.75 0 0 0 0 1.5H16V11zM16 11h2.25a.75.75 0 0 0 0-1.5H16zm-2.25-3a.75.75 0 0 0 0 1.5H16V8zM8.13 3c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.8.8 0 0 1-.52.22H2V6.25C2 4.45 3.46 3 5.25 3z"
]);
const $cdb0ff5c001a8842$export$7d96d03963ae695a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip24Regular', "24", [
    "M8.13 3c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v9a3.25 3.25 0 0 1-3 3.24v1.4l-.01.12a.6.6 0 0 1-.48.48l-.13.01h-4.76a.6.6 0 0 1-.6-.5l-.02-.12V21H5.25A3.25 3.25 0 0 1 2 17.75V6.25C2 4.45 3.46 3 5.25 3zM16 16.5c-.83 0-1.5.67-1.5 1.5v3.5h3V18c0-.83-.67-1.5-1.5-1.5M9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75H13V18a3 3 0 0 1 1.34-2.5h-.59a.75.75 0 0 1 0-1.5H16v1a3 3 0 0 1 3 3v1.48c.85-.12 1.5-.85 1.5-1.73v-9c0-.97-.78-1.75-1.75-1.75h-7.19zm8.53 3.66a.75.75 0 0 1 0 1.5H16v-1.5zm-2.25 0h-2.25a.75.75 0 0 1 0-1.5H16zm2.25-3a.75.75 0 0 1 0 1.5H16V9.5zM16 9.5h-2.25a.75.75 0 0 1 0-1.5H16zm-10.75-5c-.97 0-1.75.78-1.75 1.75V8h4.63q.31 0 .53-.22l1.53-1.53-1.53-1.53a.8.8 0 0 0-.53-.22z"
]);
const $cdb0ff5c001a8842$export$6f5b822199367a05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive16Filled', "16", [
    "M12.5 8c.83 0 1.5.67 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 10.5v-1C2 8.67 2.67 8 3.5 8zm1.06-.77-1.68-3.5v-.01A1.2 1.2 0 0 0 10.76 3h-5.5a1.2 1.2 0 0 0-1.13.72L2.44 7.24A2.5 2.5 0 0 1 3.5 7h9q.57 0 1.06.23M12 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $cdb0ff5c001a8842$export$c893d188235a8b09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive16Regular', "16", [
    "M13.85 7.85 11.9 3.73v-.01A1.2 1.2 0 0 0 10.75 3h-5.5a1.2 1.2 0 0 0-1.13.72L2.15 7.86Q2 8.16 2 8.5v2A1.5 1.5 0 0 0 3.5 12h9a1.5 1.5 0 0 0 1.5-1.5v-2q0-.33-.15-.65M5.25 4h5.5a.24.24 0 0 1 .23.14L12.34 7H3.66l1.36-2.86A.24.24 0 0 1 5.25 4M13 10.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5zm-1-1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
]);
const $cdb0ff5c001a8842$export$d987524f3e6d8781 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive20Filled', "20", [
    "M4 10q-.9.01-1.6.46l2.25-5.25A2 2 0 0 1 6.5 4h7.1c.75 0 1.43.41 1.77 1.09.54 1.1 1.53 3.2 2.33 5.43A3 3 0 0 0 16 10zm12 1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H3.99A2 2 0 0 1 2 14v-1c0-1.1.9-2 2-2zm-.5 3.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $cdb0ff5c001a8842$export$311351340fbdb62f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive20Regular', "20", [
    "M2 12q0-.61.24-1.16l2.41-5.63A2 2 0 0 1 6.5 4h7.1c.75 0 1.43.41 1.77 1.09a55 55 0 0 1 2.45 5.77q.2.56.19 1.14v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm11.6-7H6.48a1 1 0 0 0-.92.6l-1.9 4.43L4 10h12q.23 0 .45.05a57 57 0 0 0-2-4.52A1 1 0 0 0 13.6 5M16 15a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm-1.25-1.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $cdb0ff5c001a8842$export$2ea733824e22d72f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive24Filled', "24", [
    "M7.44 4c-.86 0-1.65.5-2.02 1.27l-2.7 5.55q.71-.31 1.53-.32h15.5q.82 0 1.52.32l-2.69-5.55A2.3 2.3 0 0 0 16.56 4zm12.31 8c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 19 2 18 2 16.75v-2.5C2 13.01 3 12 4.25 12zm-1.25 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $cdb0ff5c001a8842$export$f88e3ae5d04a604f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive24Regular', "24", [
    "M5.42 5.27A2.3 2.3 0 0 1 7.44 4h9.12c.86 0 1.65.5 2.02 1.27l3.1 6.39q.31.67.32 1.41v3.68c0 1.24-1 2.25-2.25 2.25H4.25C3.01 19 2 18 2 16.75v-3.68q0-.74.32-1.41zm11.81.65a.8.8 0 0 0-.67-.42H7.44a.8.8 0 0 0-.67.42L4.3 11h15.38zM3.5 13.25v3.5c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75M18 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $cdb0ff5c001a8842$export$bd6f5854d76a2dce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive28Filled', "28", [
    "M6.53 6.44A2.8 2.8 0 0 1 8.95 5h10.1c1.02 0 1.95.55 2.43 1.44l3.46 6.41a4 4 0 0 0-1.69-.35H4.75q-.9 0-1.68.35zM23.25 23A2.75 2.75 0 0 0 26 20.25v-3.5A2.75 2.75 0 0 0 23.25 14H4.75A2.75 2.75 0 0 0 2 16.75v3.5A2.75 2.75 0 0 0 4.75 23zm-3-4.5c0-.69.55-1.24 1.24-1.25h.02a1.25 1.25 0 1 1-1.26 1.25"
]);
const $cdb0ff5c001a8842$export$82f81b6dd2cbde1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive28Regular', "28", [
    "M6.53 6.44A2.8 2.8 0 0 1 8.95 5h10.1c1.02 0 1.95.55 2.43 1.44l3.95 7.31a5 5 0 0 1 .57 2v4.5A2.75 2.75 0 0 1 23.25 23H4.75A2.75 2.75 0 0 1 2 20.25v-4.5q0-.44.13-.83.15-.6.45-1.17zm13.63.72c-.22-.4-.64-.66-1.1-.66H8.95c-.46 0-.88.25-1.1.66L4.69 13h18.63zM3.58 15.33q-.08.33-.08.68v4.24c0 .69.56 1.25 1.25 1.25h18.5c.7 0 1.25-.56 1.25-1.25v-4.24q0-.35-.07-.68a1.25 1.25 0 0 0-1.18-.83H4.75c-.54 0-1 .35-1.17.83M21 19.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $cdb0ff5c001a8842$export$eaea9f7179de4ff5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive32Filled', "32", [
    "M9.9 5c-1.24 0-2.37.7-2.92 1.8l-3.81 7.63A5 5 0 0 1 5.25 14h21.5q1.12 0 2.08.43L25.02 6.8A3.3 3.3 0 0 0 22.1 5zM2 19.25V19c.14-1.68 1.54-3 3.25-3h21.5A3.25 3.25 0 0 1 30 19.25v3.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 22.75zm23.5 3a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $cdb0ff5c001a8842$export$4e68ba7357227cf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive32Regular', "32", [
    "M6.98 6.8A3.3 3.3 0 0 1 9.9 5h12.22c1.23 0 2.36.7 2.9 1.8l4.54 9.07q.45.9.45 1.9v4.98c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 22.75v-4.98q0-1 .45-1.9zm16.25.9c-.21-.43-.65-.7-1.12-.7H9.89c-.47 0-.9.27-1.12.7L5.12 15h21.76zM4 18.24v4.5c0 .69.56 1.25 1.25 1.25h21.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25H5.25C4.56 17 4 17.56 4 18.25m20.5 3.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $cdb0ff5c001a8842$export$da4f8b95c03bf38c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive48Filled', "48", [
    "M15.12 9c-1.62 0-3.1.92-3.82 2.37L6.16 21.83a7 7 0 0 1 2.09-.33h31.5q1.1 0 2.1.33L36.7 11.37A4.3 4.3 0 0 0 32.88 9zM4 28.25v6.5C4 37.1 5.9 39 8.25 39h31.5C42.1 39 44 37.1 44 34.75v-6.5C44 25.9 42.1 24 39.75 24H8.25A4.25 4.25 0 0 0 4 28.25m34.5 3.25a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $cdb0ff5c001a8842$export$2ed742a78f3cc13d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive48Regular', "48", [
    "M11.3 11.37A4.3 4.3 0 0 1 15.12 9h17.76c1.62 0 3.1.92 3.82 2.37l6.66 13.53.2.48q.43.86.44 1.87v7.5C44 37.1 42.1 39 39.75 39H8.25A4.25 4.25 0 0 1 4 34.75v-7.5q.01-1.01.43-1.87l.21-.48zm23.15 1.1c-.3-.6-.9-.97-1.57-.97H15.12c-.67 0-1.28.38-1.57.98L8.37 23h31.26zM6.72 26.4q-.22.6-.22 1.26v7.09c0 .97.78 1.75 1.75 1.75h31.5c.97 0 1.75-.78 1.75-1.75v-7.09q0-.64-.22-1.26c-.3-.54-.87-.9-1.53-.9H8.25c-.66 0-1.23.36-1.53.9M36 33a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $cdb0ff5c001a8842$export$d897c6d3e9c4d678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall24Filled', "24", [
    "M7.44 4c-.86 0-1.65.5-2.02 1.27l-2.7 5.55q.71-.31 1.53-.32h15.16c.41-.33.93-.51 1.46-.5l-2.29-4.73A2.3 2.3 0 0 0 16.56 4zm-3.19 8h14.26l-.25.62c-.31.8-.14 1.71.46 2.33l.59.63q-.18 1-.95 1.64l-.84-.2c-.83-.2-1.7.1-2.23.77l-.8 1-.15.21H4.25C3.01 19 2 18 2 16.75v-2.5C2 13.01 3 12 4.25 12m14.94 1 .48-1.21c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.8 3.8 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28"
]);
const $cdb0ff5c001a8842$export$f0be59ab6c5adceb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall24Regular', "24", [
    "M5.42 5.27A2.3 2.3 0 0 1 7.44 4h9.12c.86 0 1.65.5 2.02 1.27l2.3 4.73a2.3 2.3 0 0 0-1.44.48l-2.2-4.56a.8.8 0 0 0-.68-.42H7.44a.8.8 0 0 0-.67.42L4.3 11h14.65q-.13.2-.22.42l-.43 1.08H4.25a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h11.31q-.15.13-.27.29l-.8 1-.15.21H4.25C3.01 19 2 18 2 16.75v-3.68q0-.74.32-1.41zm13.77 7.72.48-1.2c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.8 3.8 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28"
]);
const $cdb0ff5c001a8842$export$9117ed25fea9a01e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall32Filled', "32", [
    "M9.9 5c-1.24 0-2.37.7-2.92 1.8l-3.81 7.63A5 5 0 0 1 5.25 14h19.7a3.5 3.5 0 0 1 3.21-.91l-3.14-6.3A3.3 3.3 0 0 0 22.1 5zM5.24 16h18.63l-.25.72a3 3 0 0 0 .69 3.1l.97 1a3.5 3.5 0 0 1-1.17 2.09l-1.33-.35a3 3 0 0 0-3.03.96l-.93 1.11q-.53.63-.71 1.37H5.25A3.25 3.25 0 0 1 2 22.75V19c.14-1.68 1.54-3 3.25-3m19.8 1.21.48-1.38a1.97 1.97 0 0 1 2.7-1.15l.5.24c.85.39 1.55 1.08 1.69 2 .67 4.52-2.88 10.76-7.07 12.43-.86.34-1.8.07-2.55-.47l-.46-.34a2.03 2.03 0 0 1-.37-2.94l.94-1.11c.37-.44.95-.62 1.5-.48l2.02.53a5.1 5.1 0 0 0 2.43-4.26l-1.46-1.5a1.5 1.5 0 0 1-.35-1.57"
]);
const $cdb0ff5c001a8842$export$1e055ae28e92f6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall32Regular', "32", [
    "M6.98 6.8A3.3 3.3 0 0 1 9.9 5h12.22c1.23 0 2.36.7 2.9 1.8l3.15 6.29a3.5 3.5 0 0 0-2.14.2l-2.8-5.6c-.2-.42-.64-.69-1.11-.69H9.89c-.47 0-.9.27-1.12.7L5.12 15h19.13l-.14.34-.48 1.38-.08.28H5.25C4.56 17 4 17.56 4 18.25v4.5c0 .69.56 1.25 1.25 1.25h14.11l-.53.63q-.53.63-.71 1.37H5.25A3.25 3.25 0 0 1 2 22.75v-4.98q0-1 .45-1.9zM25.05 17.2l.48-1.38a1.97 1.97 0 0 1 2.7-1.15l.5.24c.85.39 1.55 1.08 1.69 2 .67 4.52-2.88 10.76-7.07 12.43-.86.34-1.8.07-2.55-.47l-.46-.34a2.03 2.03 0 0 1-.37-2.94l.94-1.11c.37-.44.95-.62 1.5-.48l2.02.53a5.1 5.1 0 0 0 2.43-4.26l-1.46-1.5a1.5 1.5 0 0 1-.35-1.57"
]);
const $cdb0ff5c001a8842$export$94f22c9cc6ce5164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert16Filled', "16", [
    "M4 13V8.5H1v2A2.5 2.5 0 0 0 3.5 13zm1 0h7.5a2.5 2.5 0 0 0 2.5-2.5v-2H5zm2.5-2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 7.5v-2A2.5 2.5 0 0 0 12.5 3H5v4.5zM6.75 6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M4 3h-.5A2.5 2.5 0 0 0 1 5.5v2h3z"
]);
const $cdb0ff5c001a8842$export$dc2792da400790e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert16Regular', "16", [
    "M7.25 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.5 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM3.5 4C2.67 4 2 4.67 2 5.5v2h2V4zM5 4v3.5h9v-2c0-.83-.67-1.5-1.5-1.5zM4 8.5H2v2c0 .83.67 1.5 1.5 1.5H4zM5 12h7.5c.83 0 1.5-.67 1.5-1.5v-2H5z"
]);
const $cdb0ff5c001a8842$export$79b37682908bdb86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert20Filled', "20", [
    "M6 16v-5.5H2V13a3 3 0 0 0 3 3zm1 0h8a3 3 0 0 0 3-3v-2.5H7zm2-2a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M18 9.5V7a3 3 0 0 0-3-3H7v5.5zM9.75 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6 4H5a3 3 0 0 0-3 3v2.5h4z"
]);
const $cdb0ff5c001a8842$export$8df724de910affbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert20Regular', "20", [
    "M9.5 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v2.5h3V5zm1 5.5H3V13c0 1.1.9 2 2 2h1zm1 0V15h8a2 2 0 0 0 2-2v-2.5zm10-1V7a2 2 0 0 0-2-2H7v4.5z"
]);
const $cdb0ff5c001a8842$export$e7469aee1b0d38ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert24Filled', "24", [
    "M6 4H5a3 3 0 0 0-3 3v4.25h4zm-4 8.75V17a3 3 0 0 0 3 3h1v-7.25zM7.5 20H19a3 3 0 0 0 3-3v-4.25H7.5zm3.75-3.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2.75 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2-5H7.5V4H19a3 3 0 0 1 3 3zm-11.75-2.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.75-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $cdb0ff5c001a8842$export$3d6d33f0c080e8c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert24Regular', "24", [
    "M10.75 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2.75 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9.75 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2.75 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm14 1.5c.83 0 1.5.67 1.5 1.5v4.25h-13V5.5zm1.5 7.25V17c0 .83-.67 1.5-1.5 1.5H7.5v-5.75zM6 11.25H3.5V7c0-.83.67-1.5 1.5-1.5h1zm-2.5 1.5H6v5.75H5A1.5 1.5 0 0 1 3.5 17z"
]);
const $cdb0ff5c001a8842$export$54b0f539cce93a29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottom20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v5h14V6a2 2 0 0 0-2-2z"
]);
const $cdb0ff5c001a8842$export$3cbad97c95f0d5e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottom20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM3 6c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v5H3zm0 6h14v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
]);
const $cdb0ff5c001a8842$export$dcf07f65ef0de4b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomContract20Filled', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 1 1 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-3.83a2 2 0 0 1-.3.5l-1.74 2a1.5 1.5 0 0 1-2.26 0l-1.75-2a2 2 0 0 1-.29-.5H3z"
]);
const $cdb0ff5c001a8842$export$5d342ee4f18cf7c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomContract20Regular', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 1 1 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-3.83a2 2 0 0 1-.3.5l-.44.5H17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2h4.57l-.45-.5a2 2 0 0 1-.29-.5H3z"
]);
const $cdb0ff5c001a8842$export$f7bf56625e1d7c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomExpand20Filled', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-5.5v1.5a1.5 1.5 0 1 1-3 0V11H3z"
]);
const $cdb0ff5c001a8842$export$b98f062c1425ddfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomExpand20Regular', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-5.5v1H17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2h5.5v-1H3z"
]);
const $cdb0ff5c001a8842$export$4519ad16c1af3f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft16Filled', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3zM7 4h4.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H7z"
]);
const $cdb0ff5c001a8842$export$b7ce30859c6622ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft16Regular', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5zM7 4v8h4.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM6 4H4.5C3.67 4 3 4.67 3 5.5v5c0 .83.67 1.5 1.5 1.5H6z"
]);
const $cdb0ff5c001a8842$export$70140ccc7786d505 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft20Filled', "20", [
    "M15 4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8.5 15H15a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8.5z"
]);
const $cdb0ff5c001a8842$export$9a37c6312dab1007 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft20Regular', "20", [
    "M15 4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8.5 15H15a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8.5zM5 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h2.5V5z"
]);
const $cdb0ff5c001a8842$export$63c005c468d377e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zm13.5 1.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H9.5v-13z"
]);
const $cdb0ff5c001a8842$export$26690d86af9a133c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zM9.5 5.5v13h9.25c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zM8 5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H8z"
]);
const $cdb0ff5c001a8842$export$7fef9404d69832db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25zM22.25 21.5c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H10.5v16z"
]);
const $cdb0ff5c001a8842$export$bb7bf0a721f643bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4zM3.5 7.75c0-1.24 1.01-2.25 2.25-2.25H9v16H5.75c-1.24 0-2.25-1-2.25-2.25zm7 13.75v-16h11.75c1.24 0 2.25 1 2.25 2.25v11.5c0 1.24-1 2.25-2.25 2.25z"
]);
const $cdb0ff5c001a8842$export$99642ca5a32f359c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft32Filled', "32", [
    "M25.5 28a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28zm0-22A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5H12V6z"
]);
const $cdb0ff5c001a8842$export$dfea4301022025b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft32Regular', "32", [
    "M12 6v20h13.5a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6zm-2 0H6.5A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H10zM2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5z"
]);
const $cdb0ff5c001a8842$export$4a21aab1188fdf6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft48Filled', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75zM37.75 38.5a3.75 3.75 0 0 0 3.75-3.75v-21.5a3.75 3.75 0 0 0-3.75-3.75h-19.5v29z"
]);
const $cdb0ff5c001a8842$export$352f31a57702afa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft48Regular', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5C44 9.8 41.2 7 37.75 7zM6.5 13.25a3.75 3.75 0 0 1 3.75-3.75h5.5v29h-5.5a3.75 3.75 0 0 1-3.75-3.75zM18.25 38.5v-29h19.5a3.75 3.75 0 0 1 3.75 3.75v21.5a3.75 3.75 0 0 1-3.75 3.75z"
]);
const $cdb0ff5c001a8842$export$f1e55ff97c1c08a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h2.52a6 6 0 0 1 0-1H6V3h4.5c.83 0 1.5.67 1.5 1.5v1.52q.51.05 1 .19V4.5A2.5 2.5 0 0 0 10.5 2zM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$78dcba5182ea6765 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd16Regular', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v1.7q-.49-.13-1-.18V4.5c0-.83-.67-1.5-1.5-1.5H6v8h.02a6 6 0 0 0 0 1H3.5A2.5 2.5 0 0 1 1 9.5zM5 3H3.5C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5H5zm11 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$eeec06a7b49e0c7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H8.5V4H15a2 2 0 0 1 2 2v3.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm14 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$311cd7ce16d307f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd20Regular', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V6a2 2 0 0 0-2-2H8.5v11h.52q.05.51.19 1H5a3 3 0 0 1-3-3zm5.5-2H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d6374732d672bb72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25q-.3-.71-.42-1.5H9.5v-13h9.25c.97 0 1.75.78 1.75 1.75v4.48q.83.44 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a68283a166bd54cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a7 7 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H9.5v13h1.58q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75zM8 5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H8zm15 12a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fdb1569604ba927f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65q-.67-.72-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H10.5v16h2.57q.1.78.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$4536205f860492b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.67q-.25-.72-.36-1.5H10.5v-16h11.75c1.24 0 2.25 1 2.25 2.25v6.4q.83.53 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4zM3.5 7.75c0-1.24 1-2.25 2.25-2.25H9v16H5.75c-1.24 0-2.25-1-2.25-2.25zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fa4119aa0bc1c6c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd32Filled', "32", [
    "M6.5 28h9.02a9 9 0 0 1-1-2H12V6h13.5A2.5 2.5 0 0 1 28 8.5v7.02q1.14.76 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28M23 30.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9c9fd9364c84d8c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd32Regular', "32", [
    "M12 6h13.5A2.5 2.5 0 0 1 28 8.5v7.02q1.14.76 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h9.02a9 9 0 0 1-1-2H12zm-2 0v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6zm13 24.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ab2cc4c6e08ce03a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd48Filled', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37q-1.14-1.09-2.5-1.88V13.25a3.75 3.75 0 0 0-3.75-3.75h-19.5v29h4.23q.36 1.31.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c2b580e1d94e5100 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd48Regular', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21q-.61-1.19-.98-2.5h-4.23v-29h19.5a3.75 3.75 0 0 1 3.75 3.75v10.49q1.36.79 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7zM6.5 13.25a3.75 3.75 0 0 1 3.75-3.75h5.5v29h-5.5a3.75 3.75 0 0 1-3.75-3.75zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$b13463c40f40e5b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract16Filled', "16", [
    "m9.7 8.5.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h1.79a.5.5 0 0 1 0 1zM4 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm3 9V4h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1z"
]);
const $cdb0ff5c001a8842$export$b0acc1ab684811c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract16Regular', "16", [
    "m9.7 8.5.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h1.79a.5.5 0 0 1 0 1zM4 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM3 5a1 1 0 0 1 1-1h2v8H4a1 1 0 0 1-1-1zm4 7V4h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1z"
]);
const $cdb0ff5c001a8842$export$70de915d02443b62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract20Filled', "20", [
    "M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm4 11V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $cdb0ff5c001a8842$export$e0c5a188f53a98da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract20Regular', "20", [
    "M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h3v10H4a1 1 0 0 1-1-1zm5 9V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $cdb0ff5c001a8842$export$614515b5dd2cc51c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract24Filled', "24", [
    "M14.8 9.25a.75.75 0 0 0-1.05-.06l-2.5 2.25a.75.75 0 0 0 0 1.12l2.5 2.25a.75.75 0 1 0 1-1.12l-1.05-.94h3.55a.75.75 0 0 0 0-1.5H13.7l1.05-.94c.31-.28.33-.75.06-1.06M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM9 5.5v13h10.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $cdb0ff5c001a8842$export$512e9e980f0a03f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract24Regular', "24", [
    "M14.8 9.25a.75.75 0 0 0-1.05-.06l-2.5 2.25a.75.75 0 0 0 0 1.12l2.5 2.25a.75.75 0 0 0 1-1.12l-1.05-.94h3.55a.75.75 0 1 0 0-1.5H13.7l1.05-.94c.31-.28.33-.75.06-1.06m-12.8 8A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4H4.75A2.75 2.75 0 0 0 2 6.75zm2.75 1.25c-.69 0-1.25-.56-1.25-1.25V6.75c0-.7.56-1.25 1.25-1.25H8v13zm4.75 0v-13h9.75c.69 0 1.25.56 1.25 1.25v10.5c0 .7-.56 1.25-1.25 1.25z"
]);
const $cdb0ff5c001a8842$export$851d62af266ab69e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract28Filled', "28", [
    "M17.28 11.53a.75.75 0 1 0-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69zM22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zm2.25 3.75c0-1.24-1-2.25-2.25-2.25H11v17h11.25c1.24 0 2.25-1 2.25-2.25z"
]);
const $cdb0ff5c001a8842$export$f6962596d6fecca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract28Regular', "28", [
    "M17.28 11.53a.75.75 0 1 0-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69zM26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25zM22.25 5.5c1.24 0 2.25 1 2.25 2.25v12.5c0 1.24-1 2.25-2.25 2.25H11v-17zM9.5 5.5v17H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25z"
]);
const $cdb0ff5c001a8842$export$c4f6664247c2f7f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftDefault28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM11 22.5h11.25c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H11z"
]);
const $cdb0ff5c001a8842$export$7cb3fc24ccfb4bcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftDefault28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-17zm5.25 0v17h11.25c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25z"
]);
const $cdb0ff5c001a8842$export$129c6b81df117f67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftDefault32Light', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5zM25.5 27a3.5 3.5 0 0 0 3.5-3.5v-15A3.5 3.5 0 0 0 25.5 5H12v22z"
]);
const $cdb0ff5c001a8842$export$dbe58ddf2b8f967 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand16Filled', "16", [
    "M8.5 7.5h1.8l-.66-.65a.5.5 0 0 1 .71-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 1 1-.7-.7l.64-.65H8.5a.5.5 0 0 1 0-1",
    "M2 5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H7v8h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1"
]);
const $cdb0ff5c001a8842$export$5c68ab7aa1375bd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand16Regular', "16", [
    "m9.65 9.15.64-.65H8.5a.5.5 0 0 1 0-1h1.8l-.65-.65a.5.5 0 1 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 1 1-.7-.7",
    "M2 5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2V4zm3 0v8h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
]);
const $cdb0ff5c001a8842$export$482758427fff5b81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand20Filled', "20", [
    "m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1zM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm6 1V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $cdb0ff5c001a8842$export$30bb4dd174a64cbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand20Regular', "20", [
    "m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1zM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm2 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3v10zm4 0V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $cdb0ff5c001a8842$export$1b39b816b184fe88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand24Filled', "24", [
    "M14.2 14.75c.27.3.74.33 1.05.06l2.5-2.25a.75.75 0 0 0 0-1.12l-2.5-2.25a.75.75 0 0 0-1 1.12l1.05.94h-3.55a.75.75 0 1 0 0 1.5h3.55l-1.05.94a.75.75 0 0 0-.06 1.06M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM9 5.5v13h10.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $cdb0ff5c001a8842$export$d0a64c78ae5c0339 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand24Regular', "24", [
    "M14.2 14.75c.27.3.74.33 1.05.06l2.5-2.25a.75.75 0 0 0 0-1.12l-2.5-2.25a.75.75 0 0 0-1 1.12l1.05.94h-3.55a.75.75 0 1 0 0 1.5h3.55l-1.05.94a.75.75 0 0 0-.06 1.06M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25H8v-13zm4.75 0v13h9.75c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $cdb0ff5c001a8842$export$45c3779bd5461088 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand28Filled', "28", [
    "M17.72 11.53a.75.75 0 1 1 1.06-1.06l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-5.69a.75.75 0 0 1 0-1.5h5.69zM22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zm2.25 3.75c0-1.24-1-2.25-2.25-2.25H11v17h11.25c1.24 0 2.25-1 2.25-2.25z"
]);
const $cdb0ff5c001a8842$export$1c52e3eae258e502 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand28Regular', "28", [
    "M17.72 11.53a.75.75 0 1 1 1.06-1.06l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-5.69a.75.75 0 0 1 0-1.5h5.69zM26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25zM22.25 5.5c1.24 0 2.25 1 2.25 2.25v12.5c0 1.24-1 2.25-2.25 2.25H11v-17zM9.5 5.5v17H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25z"
]);
const $cdb0ff5c001a8842$export$79d928601e3a2ae8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight16Filled', "16", [
    "M12 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2zM6 4v8H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
]);
const $cdb0ff5c001a8842$export$ec5a3911ac86e8aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight20Filled', "20", [
    "M16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zM7 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $cdb0ff5c001a8842$export$257b322e868c558e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight24Filled', "24", [
    "M19.25 20A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20zM8 5.5v13H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25z"
]);
const $cdb0ff5c001a8842$export$97d734f8a938ce9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight28Filled', "28", [
    "M2 20.25A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75zm3.75 2.25c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25H9v17z"
]);
const $cdb0ff5c001a8842$export$742dbf6b59a135b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight32Filled', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-19 2A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H10V6z"
]);
const $cdb0ff5c001a8842$export$bbeda8e83d4e401e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight32Light', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5zM6.5 5A3.5 3.5 0 0 0 3 8.5v15A3.5 3.5 0 0 0 6.5 27H11V5z"
]);
const $cdb0ff5c001a8842$export$a5b6ff2142dde550 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader16Filled', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5zm11 1v-1c0-.83-.67-1.5-1.5-1.5H7v2.5zm-6 1V12h4.5c.83 0 1.5-.67 1.5-1.5v-3z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d9cfc0df50a294c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader16Regular', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3zM13 6.5H7V4h4.5c.83 0 1.5.67 1.5 1.5zM6 4v8H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4zm1 3.5h6v3c0 .83-.67 1.5-1.5 1.5H7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$635efa68aa6d3d73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm12 3v1H8.5V4H15a2 2 0 0 1 2 2m-2 9H8.5V8H17v5a2 2 0 0 1-2 2"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1f7119a34f3ae0a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm3.5 4V4H15a2 2 0 0 1 2 2v1zm0 1H17v5a2 2 0 0 1-2 2H8.5zM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$72fcdf428d2d8892 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zm18.5 0c0-.97-.78-1.75-1.75-1.75H9.5V9h11zm0 3.25h-11v8h9.25c.97 0 1.75-.78 1.75-1.75z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$33d2d0ce35497e03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zm4.25 6.5h11v6.25c0 .97-.78 1.75-1.75 1.75H9.5zm11-1.5h-11V5.5h9.25c.97 0 1.75.78 1.75 1.75zM5.25 5.5H8v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$29419ef9369ae7a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4zM24.5 19.25c0 1.24-1 2.25-2.25 2.25H10.5v-10h14zm0-9.25h-14V5.5h11.75c1.24 0 2.25 1 2.25 2.25z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$72573e195b34bcb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9v-16zm4.75 6v10h11.75c1.24 0 2.25-1 2.25-2.25V11.5zm14-1.5V7.75c0-1.24-1-2.25-2.25-2.25H10.5V10z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$abe4688010f3607a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader32Filled', "32", [
    "M30 23.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5zm-2-15A2.5 2.5 0 0 0 25.5 6H12v5h16zm0 4.5H12v13h13.5a2.5 2.5 0 0 0 2.5-2.5z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1388228b4bcafcf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader32Regular', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4zm5.5 9h16v10.5a2.5 2.5 0 0 1-2.5 2.5H12zm16-2H12V6h13.5A2.5 2.5 0 0 1 28 8.5zM6.5 6H10v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7bca2c71f762c82b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5C44 9.8 41.2 7 37.75 7zM41.5 34.75a3.75 3.75 0 0 1-3.75 3.75h-19.5v-18H41.5zm0-16.75H18.25V9.5h19.5a3.75 3.75 0 0 1 3.75 3.75z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$618f61f942f3f8f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader48Regular', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h5.5v-29zm8 11v18h19.5a3.75 3.75 0 0 0 3.75-3.75V20.5zm0-2.5H41.5v-4.75a3.75 3.75 0 0 0-3.75-3.75h-19.5z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$46d4baa0f67ef792 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12H6V6.5h7v-2A2.5 2.5 0 0 0 10.5 2zM12 5.5H6V3h4.5c.83 0 1.5.67 1.5 1.5zM11.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.5-6.5a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6dcde1b150151762 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd16Regular', "16", [
    "M1 4.5v5A2.5 2.5 0 0 0 3.5 12H6V6.5h7v-2A2.5 2.5 0 0 0 10.5 2h-7A2.5 2.5 0 0 0 1 4.5m11 0v1H6V3h4.5c.83 0 1.5.67 1.5 1.5M3.5 3H5v8H3.5A1.5 1.5 0 0 1 2 9.5v-5C2 3.67 2.67 3 3.5 3M7 11.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m5-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$519496efda3236ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V8H8.5v7h.52q.05.51.19 1H5a3 3 0 0 1-3-3zm15 0a2 2 0 0 0-2-2H8.5v3H17zm2 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$cf32cd52190469ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H8.5V8H17v1.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm12 4H8.5V4H15a2 2 0 0 1 2 2zM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$abd5a878655f0baa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a7 7 0 0 0-1.5-1.08V10.5h-11v8h1.58q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75zm18.5 0c0-.97-.78-1.75-1.75-1.75H9.5V9h11zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e8bee79be68f2710 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25q-.3-.71-.42-1.5H9.5v-8h11v1.23q.83.44 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4zM20.5 9h-11V5.5h9.25c.97 0 1.75.78 1.75 1.75zM5.25 5.5H8v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$bd4354ab76dc6e4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.68q-.26-.72-.36-1.5H10.5v-10h14v2.65q.83.53 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4zm18.75 6h-14V5.5h11.75c1.24 0 2.25 1 2.25 2.25zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7f13f091eae2489b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65q-.67-.72-1.5-1.25V11.5h-14v10h2.57q.1.78.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25zm22.5 0c0-1.24-1-2.25-2.25-2.25H10.5V10h14zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9v-16zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9e91adaaf98fff0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd32Filled', "32", [
    "M12 13v13h2.51q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V13zm0-2h16V8.5A2.5 2.5 0 0 0 25.5 6H12zm18.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M24 18.25a.75.75 0 0 0-1.5 0V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$4e289696d5c8ba27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd32Regular', "32", [
    "M12 13v13h2.51q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V13zm0-2h16V8.5A2.5 2.5 0 0 0 25.5 6H12zm-2-5H6.5A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H10zm20.5 17a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M24 18.25a.75.75 0 0 0-1.5 0V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a182c8f3a01a05d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21q-.61-1.19-.98-2.5h-4.23v-18H41.5v3.24q1.36.79 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7zM41.5 18H18.25V9.5h19.5a3.75 3.75 0 0 1 3.75 3.75zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$233b15837dda9ef5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd48Regular', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37q-1.14-1.09-2.5-1.88V20.5H18.25v18h4.23q.36 1.31.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75zM18.25 18H41.5v-4.75a3.75 3.75 0 0 0-3.75-3.75h-19.5zm-8-8.5a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h5.5v-29zM35 46a11 11 0 1 0 0-22 11 11 0 0 0 0 22m0-19a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6h-6a1 1 0 1 1 0-2h6v-6a1 1 0 0 1 1-1"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1494684d471fac78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v2H6V11h2.38l-1 1H3.5A2.5 2.5 0 0 1 1 9.5zm5 1h6v-1c0-.83-.67-1.5-1.5-1.5H6zM7.5 16a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V14q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57Q12.4 7.02 13 7a3 3 0 0 1 2.13.88A3.01 3.01 0 0 1 12 12.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H11q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L10 15v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$39229b6855e75ee3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey16Regular', "16", [
    "M13 6.5H6V11h2.38l-1 1H3.5A2.5 2.5 0 0 1 1 9.5v-5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5zM10.5 3H6v2.5h6v-1c0-.83-.67-1.5-1.5-1.5M5 3H3.5C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5H5zm2.5 13a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V14q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57Q12.4 7.02 13 7a3 3 0 0 1 2.13.88A3.01 3.01 0 0 1 12 12.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H11q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L10 15v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$695969fb63dc3c70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.53a4 4 0 0 0-1-.4V8H8.5v7h1.88l-.94.94-.05.06H5a3 3 0 0 1-3-3zm6.5 1H17V6a2 2 0 0 0-2-2H8.5zm2 12a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f00481783593dc2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.39l.05-.06.94-.94H8.5V8H17v1.12a4 4 0 0 1 1 .41V6a3 3 0 0 0-3-3zm12 4H8.5V4H15a2 2 0 0 1 2 2zM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m5.5 15a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c55e30a436a5eb87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v4.5q-.68-.46-1.5-.64v-.61h-11v8h3.09l-1.08 1.07q-.19.2-.31.43H5.25A3.25 3.25 0 0 1 2 16.75zM9.5 9h11V7.25c0-.97-.78-1.75-1.75-1.75H9.5zm10 10a3.5 3.5 0 1 0-3.38-2.59l-.15.12-3.75 3.75a.8.8 0 0 0-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 0 0 .5-.5V22h1a.5.5 0 0 0 .5-.5v-1h1a.5.5 0 0 0 .5-.5v-1zm1.5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f666b68ed728446d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h5.95q.12-.24.31-.43l1.08-1.07H9.5v-8h11v.61q.82.2 1.5.65V7.25C22 5.45 20.54 4 18.75 4zM20.5 9h-11V5.5h9.25c.97 0 1.75.78 1.75 1.75zM8 5.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75zM19.5 19a3.5 3.5 0 1 0-3.38-2.59l-.15.12-3.75 3.75a.8.8 0 0 0-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 0 0 .5-.5V22h1a.5.5 0 0 0 .5-.5v-1h1a.5.5 0 0 0 .5-.5v-1zm1.5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d3cd1d3354ff5d36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h3.88l1-1H6V3h4.5c.83 0 1.5.67 1.5 1.5v1.63q.48-.12.97-.13H13V4.5A2.5 2.5 0 0 0 10.5 2zm3.65 13.85q.14.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V15l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L11 14h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 16 10a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94Q7 13.79 7 14v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d77fb3ef98da9756 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey16Regular', "16", [
    "M6 3h4.5c.83 0 1.5.67 1.5 1.5v1.63q.48-.12.97-.13H13V4.5A2.5 2.5 0 0 0 10.5 2h-7A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h3.88l1-1H6zM5 3v8H3.5A1.5 1.5 0 0 1 2 9.5v-5C2 3.67 2.67 3 3.5 3zm2.15 12.85q.14.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V15l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L11 14h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 16 10a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94Q7 13.79 7 14v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$75b5e49106d3df2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.39l.05-.06.94-.94H8.5V4H15a2 2 0 0 1 2 2v3.12a4 4 0 0 1 1 .41V6a3 3 0 0 0-3-3zm5.15 15.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$de4279315932f662 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey20Regular', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.53a4 4 0 0 0-1-.4V6a2 2 0 0 0-2-2H8.5v11h1.88l-.94.94-.05.06H5a3 3 0 0 1-3-3zm5.5-2H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5zm2.65 14.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$29a10d9e540b7a8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h5.95q.12-.24.31-.43l1.08-1.07H9.5v-13h9.25c.97 0 1.75.78 1.75 1.75v3.86q.82.2 1.5.65V7.25C22 5.45 20.54 4 18.75 4zM23 15.5a3.5 3.5 0 0 1-3.5 3.5H18v1a.5.5 0 0 1-.5.5h-1v1a.5.5 0 0 1-.5.5h-1v.5a.5.5 0 0 1-.5.5h-1.75a.75.75 0 0 1-.75-.75v-1.44q0-.31.22-.53l3.75-3.75.15-.12A3.5 3.5 0 1 1 23 15.5m-3 .5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$cdafd45fe73faca9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v4.5q-.68-.46-1.5-.64V7.25c0-.97-.78-1.75-1.75-1.75H9.5v13h3.09l-1.08 1.07q-.19.2-.31.43H5.25A3.25 3.25 0 0 1 2 16.75zM8 5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H8zm15 10a3.5 3.5 0 0 1-3.5 3.5H18v1a.5.5 0 0 1-.5.5h-1v1a.5.5 0 0 1-.5.5h-1v.5a.5.5 0 0 1-.5.5h-1.75a.75.75 0 0 1-.75-.75v-1.44q0-.31.22-.53l3.75-3.75.15-.12A3.5 3.5 0 1 1 23 15.5m-3 .5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$858a7e8a7462eba0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTall20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM8.5 16H15a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5z"
]);
const $cdb0ff5c001a8842$export$f917dec80dcb089a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTall20Regular', "20", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM8.5 16H15a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5zM5 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2.5V4z"
]);
const $cdb0ff5c001a8842$export$e298c58a88e4a1ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText16Filled', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5zm9.5 6.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H8v8zm-7-7a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM4 8c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1A.5.5 0 0 0 4 8m.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9d27c90ea2340470 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText16Regular', "16", [
    "M4 5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M4 8c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 4 8m.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3zM3 5.5C3 4.67 3.67 4 4.5 4H7v8H4.5A1.5 1.5 0 0 1 3 10.5zM8 12V4h3.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7244e7e10f148669 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM9 16h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H9zm-4.59-3a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0-.09-1H4.41m.09-3.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM4.41 6a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0-.09-1H4.41"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$2763ec549b9cc84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText20Regular', "20", [
    "M6.5 13a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H6.5m0-3.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0-3.5a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H6.5M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM5 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3V4zm4 0v12h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$8b6d60d58e46e38a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zm8 11.25h8.75c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75H10zm-5.25-10c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75m0 3.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75m.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3c9becb6b1460021 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText24Regular', "24", [
    "M4.75 8.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75m0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75m0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zm13.5 14.5H10v-13h8.75c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75m-13.5-13H8.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3206bcc3da74df3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4zM11 21.5v-16h11.25c1.24 0 2.25 1 2.25 2.25v11.5c0 1.24-1 2.25-2.25 2.25zm-6-13c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5m.75 4.25h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c4d24235461b930e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText28Regular', "28", [
    "M5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 18.5M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-16zm5.25 0v16h11.25c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f7a3c546e690b011 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5zM25.5 6H13v20h12.5a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6m-19 3a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-1 7a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1m0 6a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7fbc88294e3858c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText32Regular', "32", [
    "M6.5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm0-17A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4zM13 26V6h12.5A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5zM6.5 6H11v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f4b76882863f93f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5C44 9.8 41.2 7 37.75 7zM19 9.5h18.75a3.75 3.75 0 0 1 3.75 3.75v21.5a3.75 3.75 0 0 1-3.75 3.75H19zM8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m1.25 7.75h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a1.25 1.25 0 1 1 0-2.5"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$8e65c341d53b35f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText48Regular', "48", [
    "M8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h6.25v-29zm27.5 0H19v29h18.75a3.75 3.75 0 0 0 3.75-3.75v-21.5a3.75 3.75 0 0 0-3.75-3.75"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$20726c5508a7498d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v1.7q-.49-.13-1-.18V4.5c0-.83-.67-1.5-1.5-1.5H7v5.34A5.5 5.5 0 0 0 6.02 12H3.5A2.5 2.5 0 0 1 1 9.5zM3.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM3 7c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1A.5.5 0 0 0 3 7m.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$aa53b90b5da844b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd16Regular', "16", [
    "M3 4.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M3 7c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 3 7m0 2.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h2.52A5.6 5.6 0 0 1 7 8.34V3h3.5c.83 0 1.5.67 1.5 1.5v1.52q.51.05 1 .19V4.5A2.5 2.5 0 0 0 10.5 2zM2 4.5C2 3.67 2.67 3 3.5 3H6v8H3.5A1.5 1.5 0 0 1 2 9.5zm14 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d819b8f7c927ac24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V6a2 2 0 0 0-2-2H9v11h.02q.05.51.19 1H5a3 3 0 0 1-3-3zm4.59 1a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 0-.5-.5H4.41a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0 .41-.5m12 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fa2be664654c4a72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd20Regular', "20", [
    "M6.59 7a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 1-.41.5H4.5a.5.5 0 0 1-.09-1H6.5c.28 0 .5.22.5.5M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H9V4h6a2 2 0 0 1 2 2v3.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm0 1h3v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$198b970b20ca2d6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a7 7 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H10v13h1.08q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75zM4.75 8.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75m0 3.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75m.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a5bb93884443355d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd24Regular', "24", [
    "M4.75 8.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75m0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75m.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5zM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25q-.3-.71-.42-1.5H10v-13h8.75c.97 0 1.75.78 1.75 1.75v4.48q.83.44 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4zm0 1.5H8.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3e07a67ca03ffa7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.68q-.26-.72-.36-1.5H11v-16h11.25c1.24 0 2.25 1 2.25 2.25v6.4q.83.53 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4zM5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5m.75 4.25h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$988864c81b40e051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd28Regular', "28", [
    "M5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5m.75 4.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65q-.67-.72-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H11v16h2.07q.1.78.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-16zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a112c3813b2460b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6H13v20h1.51q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zm4.5.5a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-1 7a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1m0 6a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1M23 30.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$542f0748e6a601da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd32Regular', "32", [
    "M6.5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m1-18A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h9.02a9 9 0 0 1-1-2H13V6h12.5A2.5 2.5 0 0 1 28 8.5v7.02q1.14.76 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4zm0 2H11v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6M23 30.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ffb43c72903df67a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21q-.61-1.19-.98-2.5H19v-29h18.75a3.75 3.75 0 0 1 3.75 3.75v10.49q1.36.79 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7zM8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m1.25 7.75h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a1.25 1.25 0 1 1 0-2.5M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$99d66493f643d036 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd48Regular', "48", [
    "M8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m1.25 7.75a1.25 1.25 0 1 0 0 2.5h3.5a1.25 1.25 0 1 0 0-2.5zM4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37q-1.14-1.09-2.5-1.88V13.25a3.75 3.75 0 0 0-3.75-3.75H19v29h3.48q.36 1.31.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h6.25v-29zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$5a9339d8b7f1cd77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss16Filled', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v1.1q-.48-.24-1-.4v-.7c0-.83-.67-1.5-1.5-1.5H8v3.26A5.5 5.5 0 0 0 6.2 13H4.5A2.5 2.5 0 0 1 2 10.5zM4.5 5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM4 8c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1A.5.5 0 0 0 4 8m.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$751fa3f6854877d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss16Regular', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h1.7q-.13-.49-.18-1H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H7v4.34q.42-.6 1-1.08V4h3.5c.83 0 1.5.67 1.5 1.5v.7q.52.16 1 .4V5.5A2.5 2.5 0 0 0 11.5 3zM4 5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M4 8c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 4 8m0 2.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m12 1a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$db73782479f2ddf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V6a2 2 0 0 0-2-2H9v11h.02q.05.51.19 1H5a3 3 0 0 1-3-3zm4.59 1a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 0-.5-.5H4.41a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0 .41-.5m12 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c40bb220b1ba2c5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss20Regular', "20", [
    "M6.59 7a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 1-.41.5H4.5a.5.5 0 0 1-.09-1H6.5c.28 0 .5.22.5.5M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H9V4h6a2 2 0 0 1 2 2v3.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm0 1h3v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6abdd9470f347cc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a7 7 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H10v13h1.08q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75zM4.75 8.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75m0 3.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75m.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$b02376765cd57afc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss24Regular', "24", [
    "M4.75 8.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75m0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75m.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5zM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25q-.3-.71-.42-1.5H10v-13h8.75c.97 0 1.75.78 1.75 1.75v4.48q.83.44 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4zm0 1.5H8.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$30a2e4d00d5744eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.68q-.26-.72-.36-1.5H11v-16h11.25c1.24 0 2.25 1 2.25 2.25v6.4q.83.53 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4zM5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5m.75 4.25h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$99f27e0cfdf90b24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss28Regular', "28", [
    "M5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5m0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5m.75 4.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65q-.67-.72-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H11v16h2.07q.1.78.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-16zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d04349d041a8b175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6H13v20h1.51q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zm4.5.5a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-1 7a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1m0 6a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m2.72 3.72L23 21.94l-2.72-2.72a.75.75 0 1 0-1.06 1.06L21.94 23l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23 24.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L24.06 23l2.72-2.72a.75.75 0 1 0-1.06-1.06"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1c7d9b23c122dc53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss32Regular', "32", [
    "M6.5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m1-18A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h9.02a9 9 0 0 1-1-2H13V6h12.5A2.5 2.5 0 0 1 28 8.5v7.02q1.14.76 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4zm0 2H11v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6M23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m2.72 3.72L23 21.94l-2.72-2.72a.75.75 0 1 0-1.06 1.06L21.94 23l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23 24.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L24.06 23l2.72-2.72a.75.75 0 1 0-1.06-1.06"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3705b959dec2b351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21q-.61-1.19-.98-2.5H19v-29h18.75a3.75 3.75 0 0 1 3.75 3.75v10.49q1.36.79 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7zM8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m1.25 7.75h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a1.25 1.25 0 1 1 0-2.5M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6c21ee2efadee579 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss48Regular', "48", [
    "M8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25m1.25 7.75a1.25 1.25 0 1 0 0 2.5h3.5a1.25 1.25 0 1 0 0-2.5zM4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37q-1.14-1.09-2.5-1.88V13.25a3.75 3.75 0 0 0-3.75-3.75H19v29h3.48q.36 1.31.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h6.25v-29zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$81d74ba4e85aad40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight12Filled', "12", [
    "M9 2H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M2 8V4a1 1 0 0 1 1-1h4v6H3a1 1 0 0 1-1-1"
]);
const $cdb0ff5c001a8842$export$f500c357dcf9e30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight12Regular', "12", [
    "M9 2H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M2 8V4a1 1 0 0 1 1-1h4v6H3a1 1 0 0 1-1-1m8 0a1 1 0 0 1-1 1H8V3h1a1 1 0 0 1 1 1z"
]);
const $cdb0ff5c001a8842$export$bd72954a245473c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight16Filled', "16", [
    "M11.5 3A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5v-5A2.5 2.5 0 0 1 4.5 3zM9 4H4.5C3.67 4 3 4.67 3 5.5v5c0 .83.67 1.5 1.5 1.5H9z"
]);
const $cdb0ff5c001a8842$export$1760650939d63ea8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight16Regular', "16", [
    "M14 5.5A2.5 2.5 0 0 0 11.5 3h-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5zM9 4v8H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4zm1 0h1.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H10z"
]);
const $cdb0ff5c001a8842$export$fdc10796714e22be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM5 4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h6.5V4z"
]);
const $cdb0ff5c001a8842$export$6661e79dd6ef43f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight20Regular', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3zm-6.5-2v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm1 0H15a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2.5z"
]);
const $cdb0ff5c001a8842$export$d7414cec19661827 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zM5.25 5.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h9.25v-13z"
]);
const $cdb0ff5c001a8842$export$33b8cf4b06d113bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight24Regular', "24", [
    "M22 7.25C22 5.45 20.54 4 18.75 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25zM14.5 5.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75zm1.5 0h2.75c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H16z"
]);
const $cdb0ff5c001a8842$export$defc49b972314676 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight28Filled', "28", [
    "M26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25zM5.75 21.5c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1-2.25 2.25-2.25H17.5v16z"
]);
const $cdb0ff5c001a8842$export$9b6c32a985718e2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75A3.75 3.75 0 0 1 5.75 4zm2.25 3.75c0-1.24-1.01-2.25-2.25-2.25H19v16h3.25c1.24 0 2.25-1 2.25-2.25zm-7 13.75v-16H5.75c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1 2.25 2.25 2.25z"
]);
const $cdb0ff5c001a8842$export$1687f5df2f22c247 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight32Filled', "32", [
    "M6.5 28A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5zm0-22A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H20V6z"
]);
const $cdb0ff5c001a8842$export$8e5b817562960d09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight32Regular', "32", [
    "M20 6v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6zm2 0h3.5A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5H22zm8 2.5A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5z"
]);
const $cdb0ff5c001a8842$export$b54897ddbb6bdb3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight48Filled', "48", [
    "M44 13.25C44 9.8 41.2 7 37.75 7h-27.5A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75zM10.25 38.5a3.75 3.75 0 0 1-3.75-3.75v-21.5a3.75 3.75 0 0 1 3.75-3.75h19.5v29z"
]);
const $cdb0ff5c001a8842$export$51b882ccd14b2175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight48Regular', "48", [
    "M37.75 7C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-21.5C4 9.8 6.8 7 10.25 7zm3.75 6.25a3.75 3.75 0 0 0-3.75-3.75h-5.5v29h5.5a3.75 3.75 0 0 0 3.75-3.75zM29.75 38.5v-29h-19.5a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75z"
]);
const $cdb0ff5c001a8842$export$ec29313264446813 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightAdd20Filled', "20", [
    "M18 6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2q-.13-.49-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8v4.6a5.5 5.5 0 0 1 6 .66zm-3.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $cdb0ff5c001a8842$export$9d5f8421c49e11a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightAdd20Regular', "20", [
    "M18 6c0-1.1-.9-2.02-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2q-.13-.49-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8v4.6q.49-.25 1-.4V5h3a1 1 0 0 1 1 1v3.6q.54.27 1 .66zm-3.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $cdb0ff5c001a8842$export$6afccd389ddaded3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract16Filled', "16", [
    "M6.3 7.5H4.5a.5.5 0 0 0 0 1h1.8l-.65.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7zM12 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2zm-3-1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5z"
]);
const $cdb0ff5c001a8842$export$b825cd59e0c68f74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract16Regular', "16", [
    "m6.3 8.5-.65.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7l.64.65H4.5a.5.5 0 1 0 0 1zM12 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2zm1-2a1 1 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1zM9 4v8H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
]);
const $cdb0ff5c001a8842$export$ed144c304c697d46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract20Filled', "20", [
    "m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1zM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zM12 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $cdb0ff5c001a8842$export$789bbed396bbc3f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract20Regular', "20", [
    "m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1zM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zm1-2a1 1 0 0 1-1 1h-3V5h3a1 1 0 0 1 1 1zm-5-9v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $cdb0ff5c001a8842$export$c709dba07cd09e23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract24Filled', "24", [
    "M9.2 9.25a.75.75 0 0 1 1.05-.06l2.5 2.25a.75.75 0 0 1 0 1.12l-2.5 2.25a.75.75 0 1 1-1-1.12l1.05-.94H6.75a.75.75 0 0 1 0-1.5h3.55l-1.05-.94a.75.75 0 0 1-.06-1.06m12.8 8A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75zm-7 1.25v-13H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25z"
]);
const $cdb0ff5c001a8842$export$efeabf7ae05b5625 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract24Regular', "24", [
    "M9.2 9.25a.75.75 0 0 1 1.05-.06l2.5 2.25a.75.75 0 0 1 0 1.12l-2.5 2.25a.75.75 0 0 1-1-1.12l1.05-.94H6.75a.75.75 0 1 1 0-1.5h3.55l-1.05-.94a.75.75 0 0 1-.06-1.06m12.8 8A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75zm-2.75 1.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.7-.56-1.25-1.25-1.25H16v13zm-4.75 0v-13H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .7.56 1.25 1.25 1.25z"
]);
const $cdb0ff5c001a8842$export$6eecc441dcc06552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17zm4.97 4.97c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H6.75a.75.75 0 0 1 0-1.5h5.7l-1.73-1.72a.75.75 0 0 1 0-1.06"
]);
const $cdb0ff5c001a8842$export$73647208e141125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17zm12.75 0v17h3.75c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25zm-7.78 4.97c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H6.75a.75.75 0 0 1 0-1.5h5.7l-1.73-1.72a.75.75 0 0 1 0-1.06"
]);
const $cdb0ff5c001a8842$export$42c4e9b705ca55ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v7q-.01.8-.38 1.45l-5.06-5.01A1.5 1.5 0 0 0 11.5 9V4H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h5v1H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm-3.14 7.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $cdb0ff5c001a8842$export$24c210f511644f87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor20Regular', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h5v-1H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.5v5c.36 0 .72.13 1 .38V4H15a2 2 0 0 1 2 2v7a2 2 0 0 1-.13.7l.75.75Q18 13.8 18 13zm-6.14 4.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $cdb0ff5c001a8842$export$7a632c209c8b6ebe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5q0 .63-.22 1.18l-5.73-6.35c-.4-.44-.98-.65-1.55-.56V5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H13V20H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm-4.26 8.05a.8.8 0 0 1 .82.2l6.37 7.06a.75.75 0 0 1-.74 1.23l-3.54-.88-2.03 3.01a.75.75 0 0 1-1.37-.42v-9.5c0-.31.2-.59.49-.7"
]);
const $cdb0ff5c001a8842$export$7a9f47bdc41d48ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor24Regular', "24", [
    "M22 7.25C22 5.45 20.54 4 18.75 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20H13v-1.5H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75h9.25v5.52c.55-.08 1.1.1 1.5.5V5.5h2.75c.97 0 1.75.78 1.75 1.75v9.26l1.28 1.42q.22-.55.22-1.18zm-7.51 4.8a.8.8 0 0 1 .82.2l6.37 7.06a.75.75 0 0 1-.74 1.23l-3.54-.88-2.03 3.01a.75.75 0 0 1-1.37-.42v-9.5c0-.31.2-.59.49-.7"
]);
const $cdb0ff5c001a8842$export$39c3609f3b5a5f1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightDefault28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17z"
]);
const $cdb0ff5c001a8842$export$825ed40f489f9751 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightDefault28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17zm12.75 17h3.75c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H18.5z"
]);
const $cdb0ff5c001a8842$export$b0a7cc96d2e0563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand20Filled', "20", [
    "m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1zM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2zm-6 1V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1z"
]);
const $cdb0ff5c001a8842$export$df9abde7ba263ae7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand20Regular', "20", [
    "m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1zM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2zm-2 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3v10zm-4 0V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1z"
]);
const $cdb0ff5c001a8842$export$6213d9a92b986326 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17zm3.47 4.97a.75.75 0 1 1 1.06 1.06l-1.72 1.72h5.7a.75.75 0 0 1 0 1.5h-5.7l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06z"
]);
const $cdb0ff5c001a8842$export$6c5eae33a9ff6c32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17zm12.75 0v17h3.75c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25zm-9.28 4.97a.75.75 0 1 1 1.06 1.06l-1.72 1.72h5.7a.75.75 0 0 1 0 1.5h-5.7l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06z"
]);
const $cdb0ff5c001a8842$export$dd7713fd0fbea73a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery16Filled', "16", [
    "M14 5.5A2.5 2.5 0 0 0 11.5 3h-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5V10h-4v2H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H10v2h4zM14 7h-4v2h4z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a55f98507f039319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery16Regular', "16", [
    "M14 5.5A2.5 2.5 0 0 0 11.5 3h-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5zm-1 0V6h-3V4h1.5c.83 0 1.5.67 1.5 1.5M10 9V7h3v2zm0 1h3v.5c0 .83-.67 1.5-1.5 1.5H10zM9 4v8H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$dcb76b6147085934 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery20Filled', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1h-5v3H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8v3h5zm0 2h-5v3h5z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$39f93f4dfe4b8750 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery20Regular', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3zm-1 5h-4V8h4zm-4 1h4v1a2 2 0 0 1-2 2h-2zm4-6v1h-4V4h2a2 2 0 0 1 2 2m-5-2v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d008125ada9cabb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25V8.5h-6v-3H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H16v-3h6v1.25c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zM22 14v-4h-6v4z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$8cc7a9ddbfda3eb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery24Regular', "24", [
    "M22 7.25C22 5.45 20.54 4 18.75 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25zm-1.5 6.25h-5v-3h5zm-5 1.5h5v1.75c0 .97-.78 1.75-1.75 1.75H15.5zm5-7.75V9h-5V5.5h3.25c.97 0 1.75.78 1.75 1.75M14 5.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$60eaf434069815bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery28Filled', "28", [
    "M26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V17.5h-8v4H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1-2.25 2.25-2.25H18v4h8zM18 16h8v-5h-8z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f17d844d6dca5d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75A3.75 3.75 0 0 1 5.75 4zm2.25 3.75c0-1.24-1.01-2.25-2.25-2.25H18.5V10h6zm-6 7.75h6v-4h-6zm0 1.5v4.5h3.75c1.24 0 2.25-1 2.25-2.25V17zM17 21.5v-16H5.75c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1 2.25 2.25 2.25z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$27d327ad18e969d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelSeparateWindow20Filled', "20", [
    "M3 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 12v-3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
]);
const $cdb0ff5c001a8842$export$e0ab46bbcaf7df53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelSeparateWindow20Regular', "20", [
    "M3 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM2 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm1 10v-3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
]);
const $cdb0ff5c001a8842$export$217d6e66e0e82a8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopContract20Filled', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-3.83a2 2 0 0 0-.3-.5l-1.74-2a1.5 1.5 0 0 0-2.26 0l-1.75 2a2 2 0 0 0-.29.5H3z"
]);
const $cdb0ff5c001a8842$export$d985d833683a1fc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopContract20Regular', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-3.83a2 2 0 0 0-.3-.5l-.44-.5H17V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h4.57l-.45.5a2 2 0 0 0-.29.5H3z"
]);
const $cdb0ff5c001a8842$export$7d6cc0c761c677a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopExpand20Filled', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 0 1 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5.5V7.5a1.5 1.5 0 1 0-3 0V9H3z"
]);
const $cdb0ff5c001a8842$export$b278d89398ce5f2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopExpand20Regular', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 0 1 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5.5V8H17V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h5.5v1H3z"
]);
const $cdb0ff5c001a8842$export$7c2534fedbb7babc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery16Filled', "16", [
    "M5 3h-.5A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3H11v4h2v3.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 10.5V7h2zm1 4h4V3H6z"
]);
const $cdb0ff5c001a8842$export$d3c5551f9a5413e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery16Regular', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3zM3 5.5C3 4.67 3.67 4 4.5 4H6v3H3zM3 8h10v2.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 10.5zm10-1h-3V4h1.5c.83 0 1.5.67 1.5 1.5zM9 4v3H7V4z"
]);
const $cdb0ff5c001a8842$export$a8d31e6198f3cfc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery20Filled', "20", [
    "M7 4H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-2v5h4v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9h4zm1 5h4V4H8z"
]);
const $cdb0ff5c001a8842$export$f10040033b2f1a2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery20Regular', "20", [
    "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM3 7c0-1.1.9-2 2-2h2v4H3zm0 3h14v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm14-1h-4V5h2a2 2 0 0 1 2 2zm-5-4v4H8V5z"
]);
const $cdb0ff5c001a8842$export$bfbe08ecaf370c3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery24Filled', "24", [
    "M7.5 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H16.5v7h4v5.75c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75V11h4zM9 11h6V4H9z"
]);
const $cdb0ff5c001a8842$export$505efe31bf6c4964 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75H8v5H3.5zm0 4.75h17v4.75c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75zm17-1.5H16v-5h2.75c.97 0 1.75.78 1.75 1.75zm-6-5v5h-5v-5z"
]);
const $cdb0ff5c001a8842$export$d069a0aef08f7848 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery28Filled', "28", [
    "M9 4H5.75c-.88 0-1.7.3-2.34.82q-.36.24-.59.6A3.7 3.7 0 0 0 2 7.74v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.73 3.73 0 0 0 22.25 4H19v8h5.5v8.25c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25V12H9zm1.5 8h7V4h-7z"
]);
const $cdb0ff5c001a8842$export$750d5a773978686f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4zM3.5 7.75c0-1.24 1.01-2.25 2.25-2.25H9.5v6h-6zm0 5.25h21v7.25c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25zm21-1.5h-6v-6h3.75c1.24 0 2.25 1 2.25 2.25zm-7.5-6v6h-6v-6z"
]);
const $cdb0ff5c001a8842$export$35825cad497fd342 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket16Filled', "16", [
    "M5.15 12.65a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7zm-1.5-1a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 1 1-.7-.7zM12.5 1A2.5 2.5 0 0 1 15 3.5v.43a5.5 5.5 0 0 1-1.61 3.89l-.51.5c.5.95.36 2.15-.44 2.95l-1.09 1.08a.5.5 0 0 1-.7 0l-.95-.94a1.5 1.5 0 0 1-1.76-.26l-.36-.37-.66 1a.5.5 0 0 1-.77.07l-2-2a.5.5 0 0 1 .07-.77l1-.66-.37-.36A1.5 1.5 0 0 1 4.6 6.3l-.94-.95a.5.5 0 0 1 0-.7l1.08-1.09c.8-.8 2-.94 2.94-.44l.51-.5A5.5 5.5 0 0 1 12.08 1zm-9.85 9.15a.5.5 0 1 1 .7.7l-1 1a.5.5 0 1 1-.7-.7zM12.07 2A4.5 4.5 0 0 0 8.9 3.32L5.56 6.65a.5.5 0 0 0 0 .7l3.09 3.09c.2.2.5.2.7 0l3.33-3.33A4.5 4.5 0 0 0 14 3.93V3.5c0-.83-.67-1.5-1.5-1.5zM10 4.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m0 1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $cdb0ff5c001a8842$export$18564c9840112cad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket16Regular', "16", [
    "M4.9 12.9a.5.5 0 0 1 .7.7l-.75.75a.5.5 0 0 1-.7-.7zm-1.25-1.25a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 1 1-.7-.7zM12.5 1A2.5 2.5 0 0 1 15 3.5v.43a5.5 5.5 0 0 1-1.61 3.89l-.51.5c.5.95.36 2.15-.44 2.95l-1.09 1.08a.5.5 0 0 1-.7 0l-.95-.94a1.5 1.5 0 0 1-1.76-.26l-.36-.37-.66 1a.5.5 0 0 1-.77.07l-2-2a.5.5 0 0 1 .07-.77l1-.66-.37-.36A1.5 1.5 0 0 1 4.6 6.3l-.94-.95a.5.5 0 0 1 0-.7l1.08-1.09c.8-.8 2-.94 2.94-.44l.51-.5A5.5 5.5 0 0 1 12.08 1zM2.4 10.4a.5.5 0 0 1 .7.7l-.75.75a.5.5 0 0 1-.7-.7zm8.06.35.54.54.73-.73c.4-.4.53-.96.38-1.47zM5.28 9.58l1.14 1.13.44-.65-.92-.92zM12.08 2a4.5 4.5 0 0 0-3.2 1.32L5.57 6.65a.5.5 0 0 0 0 .7l3.09 3.09c.2.2.5.2.7 0l3.33-3.33A4.5 4.5 0 0 0 14 3.93V3.5c0-.83-.67-1.5-1.5-1.5zM10 4.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m0 1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M6.9 3.88a1.5 1.5 0 0 0-1.46.39L4.7 5l.54.54z"
]);
const $cdb0ff5c001a8842$export$ae6022de14e4977a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket20Filled', "20", [
    "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82m2.11.7a1 1 0 1 0-1.4 1.41 1 1 0 0 0 1.4-1.4M9.44 13.6l.6.6a1.5 1.5 0 0 0 1.71.3l1.12 1.12c.2.2.51.2.7 0L15 14.2c.86-.86.96-2.17.31-3.14l.85-.85a6.3 6.3 0 0 0 1.56-6.33 2.4 2.4 0 0 0-1.6-1.6A6.3 6.3 0 0 0 9.8 3.86l-.85.85A2.5 2.5 0 0 0 5.8 5L4.38 6.43a.5.5 0 0 0 0 .7L5.5 8.27a1.5 1.5 0 0 0 .3 1.7l.6.61-1.21.73a.5.5 0 0 0-.1.78l2.83 2.83a.5.5 0 0 0 .79-.1zm7.32-9.42a5.3 5.3 0 0 1-1.3 5.33l-4 4a.5.5 0 0 1-.7 0l-1.07-1.07-2.12-2.12L6.5 9.24a.5.5 0 0 1 0-.7l3.99-4a5.3 5.3 0 0 1 5.33-1.3c.44.13.8.48.93.93M5.8 14.91a.5.5 0 0 0-.7-.7l-1.77 1.76a.5.5 0 1 0 .7.7zM4.4 12.79c.2.2.2.5 0 .7l-.7.71a.5.5 0 1 1-.72-.7l.71-.71c.2-.2.51-.2.71 0m2.83 3.53a.5.5 0 1 0-.7-.7l-.72.7a.5.5 0 1 0 .71.71z"
]);
const $cdb0ff5c001a8842$export$e046528df89a0516 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket20Regular', "20", [
    "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82m2.11.7a1 1 0 1 0-1.4 1.42 1 1 0 0 0 1.4-1.42m-1.12 7.37a1.5 1.5 0 0 1-1.7-.3l-.61-.6-.74 1.22a.5.5 0 0 1-.78.1L5.1 12.09a.5.5 0 0 1 .1-.79l1.22-.73-.61-.6a1.5 1.5 0 0 1-.3-1.71L4.38 7.14a.5.5 0 0 1 0-.7l1.06-1.07a3 3 0 0 1 3.42-.59l.93-.93a6.3 6.3 0 0 1 6.33-1.56c.76.24 1.36.83 1.6 1.6a6.3 6.3 0 0 1-1.56 6.32l-.94.94a3 3 0 0 1-.58 3.41l-1.06 1.06a.5.5 0 0 1-.71 0zm4.08-11.26a5.3 5.3 0 0 0-5.33 1.31l-.81.82-.7.7h-.01L6.86 8.2l-.4.4a.5.5 0 0 0 .05.66l4.24 4.24c.18.18.46.2.66.05l.4-.4 2.12-2.12.7-.71.82-.81a5.3 5.3 0 0 0 1.31-5.33c-.14-.45-.49-.8-.93-.94m-3.31 10.62.7.7.7-.7a2 2 0 0 0 .53-1.93zm-4.44-8.3a2 2 0 0 0-1.93.52l-.7.7.7.71zm.63 7.31L7.14 11.3l-.89.53 1.93 1.93zm-2.9 2.04a.5.5 0 1 0-.71-.7l-1.77 1.76a.5.5 0 1 0 .7.71zM4.38 12.8c.2.2.2.51 0 .7l-.71.72a.5.5 0 0 1-.7-.71l.7-.71c.2-.2.51-.2.7 0m2.83 3.54a.5.5 0 0 0-.7-.71l-.72.7a.5.5 0 1 0 .7.72z"
]);
const $cdb0ff5c001a8842$export$9b7cbb4d7078395a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket24Filled', "24", [
    "M13.06 7.43a2.5 2.5 0 1 1 3.53 3.54 2.5 2.5 0 0 1-3.53-3.54m2.47 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.42m4.17-5.98c.86.27 1.54.95 1.8 1.81l.21.67c.75 2.4.1 5-1.67 6.77l-1 1a3.5 3.5 0 0 1-.32 4.57l-1.25 1.24c-.29.3-.76.3-1.06 0l-1.59-1.59-.17.18c-.69.68-1.8.68-2.48 0l-.48-.49-.82 1.4a.75.75 0 0 1-1.17.14l-3.9-3.89a.75.75 0 0 1 .15-1.17l1.39-.83-.47-.47a1.75 1.75 0 0 1 0-2.47l.18-.18-1.6-1.6a.75.75 0 0 1 0-1.05L6.7 5.3a3.5 3.5 0 0 1 4.57-.32l1-1a6.8 6.8 0 0 1 6.77-1.67zm.38 2.26q-.21-.62-.83-.83l-.66-.2a5.3 5.3 0 0 0-5.27 1.3l-5.4 5.4c-.1.1-.1.25 0 .35l5.31 5.3c.1.1.26.1.36 0l5.4-5.39a5.3 5.3 0 0 0 1.3-5.27zM6.69 18.39a.75.75 0 0 0-1.06-1.06l-2.48 2.48a.75.75 0 0 0 1.06 1.06zm-1.94-3c.29.3.29.77 0 1.06l-1.07 1.06a.75.75 0 0 1-1.06-1.06l1.06-1.06c.3-.3.77-.3 1.07 0m3.88 4.95a.75.75 0 1 0-1.06-1.06l-1.06 1.06a.75.75 0 0 0 1.06 1.06z"
]);
const $cdb0ff5c001a8842$export$9376d3a9a0f0b4a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket24Regular', "24", [
    "M13.06 7.43a2.5 2.5 0 1 1 3.53 3.54 2.5 2.5 0 0 1-3.53-3.54m2.47 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.42m5.98-4.17a2.8 2.8 0 0 0-1.81-1.8l-.66-.21c-2.4-.75-5-.1-6.78 1.67l-1 1a3.5 3.5 0 0 0-4.56.32L5.45 6.55c-.29.29-.29.76 0 1.06l1.6 1.59-.18.18c-.69.68-.69 1.79 0 2.47l.5.5-1.4.8a.75.75 0 0 0-.16 1.17l3.89 3.9a.75.75 0 0 0 1.18-.16l.8-1.4.5.5c.68.68 1.78.68 2.47 0l.17-.18 1.6 1.6c.29.28.76.28 1.05 0l1.25-1.25a3.5 3.5 0 0 0 .32-4.57l1-1A6.8 6.8 0 0 0 21.72 5zm-2.26-.38q.62.21.83.83l.2.66c.58 1.86.08 3.9-1.3 5.27l-5.4 5.4c-.1.1-.25.1-.35 0l-5.3-5.3a.25.25 0 0 1 0-.36l5.4-5.4a5.3 5.3 0 0 1 5.26-1.3zm-1.29 9.9a2 2 0 0 1-.3 2.43l-.72.71-1.06-1.06zM7.76 6.36a2 2 0 0 1 2.43-.3L8.1 8.14 7.05 7.08zm2.82 9.2-.52.9-2.5-2.5.9-.51zM6.69 18.4a.75.75 0 0 0-1.06-1.06l-2.48 2.48a.75.75 0 0 0 1.06 1.06zm-1.94-3c.29.3.29.77 0 1.06l-1.07 1.06a.75.75 0 0 1-1.06-1.06l1.06-1.06c.3-.3.77-.3 1.07 0m3.88 4.95a.75.75 0 1 0-1.06-1.06l-1.06 1.06a.75.75 0 0 0 1.06 1.06z"
]);
const $cdb0ff5c001a8842$export$c831a3861999b9d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket28Filled', "28", [
    "M8.47 22.97a.75.75 0 0 1 1.06 1.06l-1.25 1.25a.75.75 0 1 1-1.06-1.06zm-2.25-2.25a.75.75 0 0 1 1.06 1.06l-3 3a.75.75 0 1 1-1.06-1.06zM21.75 2C24.1 2 26 3.9 26 6.25v1.44c0 2.32-.92 4.54-2.56 6.18l-1.82 1.82a4.25 4.25 0 0 1-.56 5.31l-1.53 1.53c-.3.3-.77.3-1.06 0l-1.85-1.85-.03.04c-.88.88-2.3.88-3.18 0l-.34-.34-.9 1.72a.75.75 0 0 1-1.2.18l-5.25-5.25a.75.75 0 0 1 .18-1.2l1.72-.9-.34-.34a2.25 2.25 0 0 1 0-3.18l.03-.04-1.84-1.84a.75.75 0 0 1 0-1.06L7 6.94a4.25 4.25 0 0 1 5.3-.56l1.83-1.82A8.8 8.8 0 0 1 20.3 2zM3.97 18.47a.75.75 0 0 1 1.06 1.06l-1.25 1.25a.75.75 0 1 1-1.06-1.06zM20.31 3.5c-1.92 0-3.76.76-5.12 2.12l-6.85 6.85c-.3.3-.3.77 0 1.06l6.13 6.13c.3.3.77.3 1.06 0l6.85-6.85A7.3 7.3 0 0 0 24.5 7.7V6.25a2.75 2.75 0 0 0-2.75-2.75zM17 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $cdb0ff5c001a8842$export$d0eb777aaceb4b0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket28Regular', "28", [
    "M8.47 22.97a.75.75 0 0 1 1.06 1.06l-1.25 1.25a.75.75 0 1 1-1.06-1.06zm-2.25-2.25a.75.75 0 0 1 1.06 1.06l-3 3a.75.75 0 1 1-1.06-1.06zM21.75 2C24.1 2 26 3.9 26 6.25v1.44c0 2.32-.92 4.54-2.56 6.18l-1.82 1.82a4.25 4.25 0 0 1-.56 5.31l-1.53 1.53c-.3.3-.77.3-1.06 0l-1.84-1.85-.04.04c-.88.88-2.3.88-3.18 0l-.34-.34-.9 1.72a.75.75 0 0 1-1.2.18l-5.25-5.25a.75.75 0 0 1 .18-1.2l1.71-.9-.33-.34a2.25 2.25 0 0 1 0-3.18l.04-.04-1.85-1.84a.75.75 0 0 1 0-1.06L7 6.94a4.25 4.25 0 0 1 5.3-.56l1.83-1.82A8.8 8.8 0 0 1 20.3 2zM3.97 18.47a.75.75 0 0 1 1.06 1.06l-1.25 1.25a.75.75 0 1 1-1.06-1.06zm13.72 1.15L19 20.94l1-1a2.75 2.75 0 0 0 .52-3.15zM7.49 16.7l3.82 3.8.65-1.22-3.24-3.23zM20.32 3.5c-1.92 0-3.76.76-5.12 2.12l-6.85 6.85c-.3.3-.3.77 0 1.06l6.13 6.13c.3.3.77.3 1.06 0l6.85-6.85A7.3 7.3 0 0 0 24.5 7.7V6.25a2.75 2.75 0 0 0-2.75-2.75zM17 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-5.8-2.02A2.75 2.75 0 0 0 8.07 8l-1 1 1.32 1.31z"
]);
const $cdb0ff5c001a8842$export$478dca447322e0e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket32Filled', "32", [
    "M9.8 26.8a1 1 0 1 1 1.4 1.4l-1.5 1.5a1 1 0 0 1-1.4-1.4zm-3-3a1 1 0 1 1 1.4 1.4l-3.5 3.5a1 1 0 0 1-1.4-1.4zM25 2a5 5 0 0 1 5 5v1.65a11.5 11.5 0 0 1-3.37 8.13l-.79.8a4.5 4.5 0 0 1-.6 5.6l-2.53 2.53a1 1 0 0 1-1.42 0l-1.81-1.82a2.5 2.5 0 0 1-3.25-.24l-.92-.92-.86 2.59a1 1 0 0 1-1.66.39l-6.5-6.5a1 1 0 0 1 .4-1.66l2.58-.86-.92-.92a2.5 2.5 0 0 1-.24-3.25l-1.82-1.81a1 1 0 0 1 0-1.42l2.53-2.52a4.5 4.5 0 0 1 5.6-.61l.8-.8A11.5 11.5 0 0 1 23.35 2zM3.8 20.8a1 1 0 1 1 1.4 1.4l-1.5 1.5a1 1 0 1 1-1.4-1.4zM23.34 4a9.5 9.5 0 0 0-6.72 2.78l-6.86 6.87a.5.5 0 0 0 0 .7l7.88 7.88c.2.2.5.2.7 0l6.87-6.86A9.5 9.5 0 0 0 28 8.65V7a3 3 0 0 0-3-3zM20.5 8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $cdb0ff5c001a8842$export$91fa34b8d450bdd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket32Regular', "32", [
    "M9.8 26.8a1 1 0 1 1 1.4 1.4l-1.5 1.5a1 1 0 0 1-1.4-1.4zm-3-3a1 1 0 1 1 1.4 1.4l-3.5 3.5a1 1 0 0 1-1.4-1.4zM25 2a5 5 0 0 1 5 5v1.65a11.5 11.5 0 0 1-3.37 8.13l-.79.8a4.5 4.5 0 0 1-.6 5.6l-2.53 2.53a1 1 0 0 1-1.42 0l-1.81-1.82a2.5 2.5 0 0 1-3.25-.24l-.92-.92-.86 2.59a1 1 0 0 1-1.66.39l-6.5-6.5a1 1 0 0 1 .4-1.66l2.58-.86-.92-.92a2.5 2.5 0 0 1-.24-3.25l-1.82-1.81a1 1 0 0 1 0-1.42l2.53-2.52a4.5 4.5 0 0 1 5.6-.61l.8-.8A11.5 11.5 0 0 1 23.35 2zM3.8 20.8a1 1 0 1 1 1.4 1.4l-1.5 1.5a1 1 0 1 1-1.4-1.4zm17.12 1.7L22 23.58l1.82-1.81a2.5 2.5 0 0 0 .54-2.72zM8.85 18.94l4.21 4.2.67-2-2.88-2.87zM23.35 4a9.5 9.5 0 0 0-6.72 2.78l-6.86 6.87a.5.5 0 0 0 0 .7l7.88 7.88c.2.2.5.2.7 0l6.87-6.86A9.5 9.5 0 0 0 28 8.65V7a3 3 0 0 0-3-3zM20.5 8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7.55-2.37a2.5 2.5 0 0 0-2.72.55L8.41 10l1.1 1.09z"
]);
const $cdb0ff5c001a8842$export$356be620d5963993 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket48Filled', "48", [
    "M14.37 38.87a1.25 1.25 0 0 1 1.76 1.76l-2.5 2.5a1.25 1.25 0 1 1-1.76-1.76zm-3.5-3.5a1.25 1.25 0 0 1 1.76 1.76l-4.5 4.5a1.25 1.25 0 1 1-1.76-1.76zM36.75 5C40.2 5 43 7.8 43 11.25v1.54c0 4.3-1.71 8.44-4.76 11.49l-1.35 1.34a7.25 7.25 0 0 1-1 9l-3 3.01c-.5.5-1.29.5-1.77 0l-3.14-3.13c-1.27.98-3.11.89-4.28-.28l-.42-.43-2.21 3.61a1.25 1.25 0 0 1-1.95.23l-8.75-8.75a1.25 1.25 0 0 1 .23-1.95l3.6-2.2-.42-.43a3.25 3.25 0 0 1-.28-4.28l-3.13-3.14a1.25 1.25 0 0 1 0-1.76l3-3.01a7.25 7.25 0 0 1 9-1l1.35-1.35A16.3 16.3 0 0 1 35.22 5zM7.37 31.87a1.25 1.25 0 1 1 1.76 1.76l-2.5 2.5a1.25 1.25 0 1 1-1.76-1.76zM35.2 7.5c-3.64 0-7.14 1.45-9.72 4.03l-9.94 9.94c-.3.3-.3.77 0 1.06l9.92 9.92c.3.3.77.3 1.06 0l9.94-9.94a13.8 13.8 0 0 0 4.03-9.72v-1.54a3.75 3.75 0 0 0-3.75-3.75zm-5.71 6a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $cdb0ff5c001a8842$export$bd78ec9ab7cbc4dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket48Regular', "48", [
    "M14.37 38.87a1.25 1.25 0 0 1 1.76 1.76l-2.5 2.5a1.25 1.25 0 1 1-1.76-1.76zm-3.5-3.5a1.25 1.25 0 0 1 1.76 1.76l-4.5 4.5a1.25 1.25 0 1 1-1.76-1.76zM36.75 5C40.2 5 43 7.8 43 11.25v1.54c0 4.3-1.71 8.44-4.76 11.49l-1.35 1.34a7.25 7.25 0 0 1-1 9l-3 3.01c-.5.5-1.29.5-1.77 0l-3.14-3.13c-1.27.98-3.11.89-4.28-.28l-.42-.43-2.21 3.61a1.25 1.25 0 0 1-1.95.23l-8.75-8.75a1.25 1.25 0 0 1 .23-1.95l3.6-2.2-.42-.43a3.25 3.25 0 0 1-.28-4.28l-3.13-3.14a1.25 1.25 0 0 1 0-1.76l3-3.01a7.25 7.25 0 0 1 9-1l1.35-1.35A16.3 16.3 0 0 1 35.22 5zM7.37 31.87a1.25 1.25 0 1 1 1.76 1.76l-2.5 2.5a1.25 1.25 0 1 1-1.76-1.76zm22.4.88L32 34.98l2.12-2.12a4.75 4.75 0 0 0 .94-5.4zm-16.52-4.51 6.51 6.5 1.7-2.76-5.44-5.44zM35.21 7.5c-3.64 0-7.14 1.45-9.72 4.03l-9.94 9.94c-.3.3-.3.77 0 1.06l9.92 9.92c.3.3.77.3 1.06 0l9.94-9.94a13.8 13.8 0 0 0 4.03-9.72v-1.54a3.75 3.75 0 0 0-3.75-3.75zm-5.71 6a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-8.96-3.06a4.75 4.75 0 0 0-5.4.94L13.02 16l2.23 2.23z"
]);
const $cdb0ff5c001a8842$export$ce3e81dd8ad743ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h5A2.5 2.5 0 0 1 12 4.5v5A2.5 2.5 0 0 1 9.5 12h-5A2.5 2.5 0 0 1 2 9.5zM7 14a2.5 2.5 0 0 1-2-1h4.5A3.5 3.5 0 0 0 13 9.5V4c.6.46 1 1.18 1 2v3.5A4.5 4.5 0 0 1 9.5 14z"
]);
const $cdb0ff5c001a8842$export$9f6064aa3e5cdda6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v5A2.5 2.5 0 0 0 4.5 12h5A2.5 2.5 0 0 0 12 9.5v-5A2.5 2.5 0 0 0 9.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 9.5zM5 13c.46.6 1.18 1 2 1h2.5A4.5 4.5 0 0 0 14 9.5V6c0-.82-.4-1.54-1-2v5.5A3.5 3.5 0 0 1 9.5 13z"
]);
const $cdb0ff5c001a8842$export$105ef60c9f4c31cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm4.99 11a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.77A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $cdb0ff5c001a8842$export$73e4532398b5d3ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm3.99 11a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.77A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $cdb0ff5c001a8842$export$b8507b362de3735f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v9.5C3 17.55 4.46 19 6.25 19h9.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C19 4.45 17.54 3 15.75 3zm3 18.5c-1.16 0-2.17-.6-2.75-1.5h9.74A3.75 3.75 0 0 0 20 16.25V6.5c.9.58 1.5 1.59 1.5 2.74v7c0 2.9-2.35 5.26-5.25 5.26z"
]);
const $cdb0ff5c001a8842$export$41fe42b40caf1d1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v9c0 1.8 1.46 3.25 3.25 3.25h9c1.8 0 3.25-1.46 3.25-3.25v-9c0-1.8-1.46-3.25-3.25-3.25zM4.5 6.25c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v9c0 .97-.78 1.75-1.75 1.75h-9c-.97 0-1.75-.78-1.75-1.75zM6.01 19.5c.58.9 1.59 1.5 2.74 1.5h7c2.9 0 5.25-2.35 5.25-5.25v-7c0-1.15-.6-2.16-1.5-2.74v9.74a3.75 3.75 0 0 1-3.75 3.75H6.02"
]);
const $cdb0ff5c001a8842$export$5fa19454dcc06794 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v5A2.5 2.5 0 0 0 4.5 12h5A2.5 2.5 0 0 0 12 9.5v-5A2.5 2.5 0 0 0 9.5 2zm5.35 3.85-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64a.5.5 0 1 1 .7.7M5 13c.46.6 1.18 1 2 1h2.5A4.5 4.5 0 0 0 14 9.5V6c0-.82-.4-1.54-1-2v5.5A3.5 3.5 0 0 1 9.5 13z"
]);
const $cdb0ff5c001a8842$export$caaa1f0651f864db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn16Regular', "16", [
    "M9.85 5.85a.5.5 0 0 0-.7-.7L6.5 7.79 5.35 6.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM2 4.5A2.5 2.5 0 0 1 4.5 2h5A2.5 2.5 0 0 1 12 4.5v5A2.5 2.5 0 0 1 9.5 12h-5A2.5 2.5 0 0 1 2 9.5zM4.5 3C3.67 3 3 3.67 3 4.5v5c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM7 14a2.5 2.5 0 0 1-2-1h4.5A3.5 3.5 0 0 0 13 9.5V4c.6.46 1 1.18 1 2v3.5A4.5 4.5 0 0 1 9.5 14z"
]);
const $cdb0ff5c001a8842$export$c8ae8d7572d855e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm6.33 3.62c.2.19.23.5.05.7l-3.5 4a.5.5 0 0 1-.73.03l-2-2a.5.5 0 1 1 .7-.7l1.63 1.62 3.14-3.6a.5.5 0 0 1 .7-.05M5.75 16A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.23v6.73a3.5 3.5 0 0 1-3.5 3.5H5.75"
]);
const $cdb0ff5c001a8842$export$af376b942d39900e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn20Regular', "20", [
    "M12.33 6.62c.2.19.23.5.05.7l-3.5 4a.5.5 0 0 1-.73.03l-2-2a.5.5 0 1 1 .7-.7l1.63 1.62 3.14-3.6a.5.5 0 0 1 .7-.05M3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-.25 12A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.23v6.73a3.5 3.5 0 0 1-3.5 3.5H5.75"
]);
const $cdb0ff5c001a8842$export$7958e49db3d07be8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h9.5C17.55 3 19 4.46 19 6.25v9.5c0 1.8-1.46 3.25-3.25 3.25h-9.5A3.25 3.25 0 0 1 3 15.75zm12.28 2.78a.75.75 0 0 0-1.06-1.06L10 12.19l-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0zM6.5 20c.58.9 1.59 1.5 2.74 1.5h7c2.9 0 5.26-2.35 5.26-5.25v-7c0-1.16-.6-2.17-1.5-2.75v9.75A3.75 3.75 0 0 1 16.25 20H6.5"
]);
const $cdb0ff5c001a8842$export$62f7ba9a249464d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn24Regular', "24", [
    "M15.28 9.03a.75.75 0 0 0-1.06-1.06L10 12.19l-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0zM3 6.25C3 4.45 4.46 3 6.25 3h9.5C17.55 3 19 4.46 19 6.25v9.5c0 1.8-1.46 3.25-3.25 3.25h-9.5A3.25 3.25 0 0 1 3 15.75zM6.25 4.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h9.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zm3 17c-1.16 0-2.17-.6-2.75-1.5h9.74A3.75 3.75 0 0 0 20 16.25V6.5c.9.58 1.5 1.59 1.5 2.74v7c0 2.9-2.35 5.26-5.25 5.26z"
]);
const $cdb0ff5c001a8842$export$7d0e807c0deaa910 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject16Filled', "16", [
    "M3.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-3.25.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zM3.75 6c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m8.5 0c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M3.5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9.25 3a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5z"
]);
const $cdb0ff5c001a8842$export$e976a496edf7115e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject16Regular', "16", [
    "M3.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-6-6c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5m9 0c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5m-9-4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $cdb0ff5c001a8842$export$25518b15f5a40d9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject20Filled', "20", [
    "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 4.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75m0 10.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m-3-7.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0zm10.5 0a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0z"
]);
const $cdb0ff5c001a8842$export$e866c6c61d9d9463 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject20Regular', "20", [
    "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 11c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3-8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0zm11 0a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0z"
]);
const $cdb0ff5c001a8842$export$aa5b7144e2bf4e26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject24Filled', "24", [
    "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1 0a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1M5 8a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m14 0a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1M9 20a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zm-4 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4M21 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $cdb0ff5c001a8842$export$6c6cd6ecff2ce427 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject24Regular', "24", [
    "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1-.25c0 .41.34.75.75.75h6.5a.75.75 0 0 0 0-1.5h-6.5a.75.75 0 0 0-.75.75M4.75 8a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5A.75.75 0 0 0 4.75 8m14.5 0a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75M8.75 20a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5zM5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4M21 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $cdb0ff5c001a8842$export$cea3c846255e0772 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew16Filled', "16", [
    "M2.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m8 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-2.29.5a2.5 2.5 0 0 0-.16 1.5h-3.1a2.5 2.5 0 0 0-.16-1.5zM4.07 5.55q.62.44 1.43.45l-1.57 4.45q-.62-.43-1.43-.45zm8 0q.62.44 1.43.45l-1.57 4.45q-.62-.43-1.43-.45zM5.5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m8 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-2.45 1a2.5 2.5 0 0 0 .16 1.5H7.79A2.5 2.5 0 0 0 7.95 3z"
]);
const $cdb0ff5c001a8842$export$2d3d7e65105f012 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew16Regular', "16", [
    "M2.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m8 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-2.45 1a3 3 0 0 0 0 1h-3.1a3 3 0 0 0 0-1zm-3.8-6.34q.43.26.95.32l-1.45 4.36q-.43-.26-.95-.32zm8 0q.43.26.95.32l-1.45 4.36q-.43-.26-.95-.32zM5.5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m8 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-2.45 1a3 3 0 0 0 0 1h-3.1a3 3 0 0 0 0-1z"
]);
const $cdb0ff5c001a8842$export$97788873825d0dde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew20Filled', "20", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-4 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M6 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m8.11.75H9.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5M3.61 13 5.98 6.5q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5m6.5 3.25H5.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5m2.5-3.25 2.37-6.51q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5"
]);
const $cdb0ff5c001a8842$export$f394e24ed75e9b9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew20Regular', "20", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02A1.5 1.5 0 0 0 16.48 6m-5.4 10a1.5 1.5 0 1 0 1.42-2h-.01c-.65 0-1.2.42-1.41 1l-.01.02a1.5 1.5 0 0 0 0 .98M3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M7.49 6a1.5 1.5 0 1 0 .02-3 1.5 1.5 0 0 0-.02 3m-3.62 7.03 2.32-6.4q.42.27.94.34l-2.32 6.4q-.43-.27-.94-.34M14.05 5h-4.1a3 3 0 0 0 0-1h4.1a3 3 0 0 0 0 1m-8.1 11h4.1a3 3 0 0 1 0-1h-4.1a3 3 0 0 1 0 1m6.92-2.97 2.32-6.4q.42.27.94.34l-2.32 6.4q-.42-.27-.94-.34"
]);
const $cdb0ff5c001a8842$export$89bd950bd7ec1095 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew24Filled', "24", [
    "M18.59 6.41A2 2 0 0 0 22 5a2 2 0 1 0-3.41 1.41M14.27 20a2 2 0 1 0 3.46-2 2 2 0 0 0-3.46 2M4 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4M6.59 6.41A2 2 0 0 0 10 5a2 2 0 0 0-2-2 2 2 0 0 0-1.41 3.41m-2.77 9.6 2.44-8.56a3 3 0 0 0 1.92.54l-2.44 8.56a3 3 0 0 0-1.92-.54M17.17 6h-6.34a3 3 0 0 0 0-2h6.34a3 3 0 0 0 0 2m-4 14a3 3 0 0 1 0-2H6.83a3 3 0 0 1 0 2zm2.65-4 2.44-8.55a3 3 0 0 0 1.92.54l-2.44 8.56a3 3 0 0 0-1.92-.54"
]);
const $cdb0ff5c001a8842$export$e353e16511161759 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew24Regular', "24", [
    "M18.88 6.66a2 2 0 0 0 1.33.33 2 2 0 1 0-1.33-.33M14 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0M4 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4M6.88 6.66a2 2 0 0 0 3-.97 2 2 0 1 0-3 .97m-.4.93L4.08 16q.79.03 1.44.41L7.92 8a3 3 0 0 1-1.44-.41M17.1 5.75h-6.18a3 3 0 0 0 0-1.5h6.18a3 3 0 0 0 0 1.5m-4 14a3 3 0 0 1 0-1.5H6.91a3 3 0 0 1 0 1.5zM16.08 16l2.4-8.41q.65.39 1.44.4l-2.4 8.42q-.65-.39-1.44-.4"
]);
const $cdb0ff5c001a8842$export$63ea8b3fc677e465 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss20Filled', "20", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5M3.6 13 5.98 6.5q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5m2.28 3.25h3.4a6 6 0 0 1-.28-1.5H5.89a2.5 2.5 0 0 1 0 1.5M16.39 7l-.77 2.11a6 6 0 0 0-1.56-.1l.92-2.52q.6.46 1.41.5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $cdb0ff5c001a8842$export$aba4ac5ae3ea79d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss20Regular', "20", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64q.4.33.94.34M2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5M7.49 6zc.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68q.4.33.94.34m-1.3.63-2.32 6.4q.52.08.94.34l2.32-6.4a3 3 0 0 1-.94-.34M14.05 5h-4.1a3 3 0 0 0 0-1h4.1a3 3 0 0 0 0 1m.45 4q.45 0 .87.07l.76-2.1a3 3 0 0 1-.94-.34L14.33 9zm-5.48 6q.05.51.19 1H5.95a3 3 0 0 0 0-1zm9.98-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $cdb0ff5c001a8842$export$8ebaad005014446b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss24Filled', "24", [
    "M18.59 6.41A2 2 0 0 0 22 5a2 2 0 1 0-3.44 1.4zM2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0M6.59 6.41A2 2 0 0 0 10 5a2 2 0 0 0-2-2 2 2 0 0 0-1.44 3.4zm-.33 1.04L3.82 16a3 3 0 0 1 1.92.54L8.18 8a3 3 0 0 1-1.92-.54M17.17 6h-6.34a3 3 0 0 0 0-2h6.34a3 3 0 0 0 0 2M11.5 20a7 7 0 0 1-.48-2h-4.2a3 3 0 0 1 0 2zm8.68-12-.92 3.24a7 7 0 0 0-2.02-.24l1.02-3.55a3 3 0 0 0 1.92.54M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $cdb0ff5c001a8842$export$33d87ae534275c47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss24Regular', "24", [
    "M18.88 6.66a2 2 0 0 0 1.33.33 2 2 0 1 0-1.33-.33M2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0M6.88 6.66a2 2 0 0 0 3-.97 2 2 0 1 0-3 .97M4.08 16l2.4-8.41q.65.39 1.44.4l-2.4 8.42q-.65-.39-1.44-.4M17.09 5.75h-6.18a3 3 0 0 0 0-1.5h6.18a3 3 0 0 0 0 1.5m-5.69 14q-.27-.72-.36-1.5H6.91a3 3 0 0 1 0 1.5zM19.92 8l-.9 3.18A7 7 0 0 0 17.5 11l.97-3.41q.65.39 1.44.4M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $cdb0ff5c001a8842$export$2e7e31aa1b2d52f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit20Filled', "20", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5M3.6 13 5.98 6.5q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5m2.28 3.25H9.4l.02-.1q.18-.7.65-1.26 0-.08.03-.14H5.9a2.5 2.5 0 0 1 0 1.5M16.39 7l-.92 2.53-.37.31-2.1 2.1 1.98-5.45q.6.46 1.41.5m-5.41 8.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $cdb0ff5c001a8842$export$34b79a2f990869fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit20Regular', "20", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64q.4.33.94.34M2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5M7.49 6zc.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68q.4.33.94.34m-1.3.63-2.32 6.4q.52.08.94.34l2.32-6.4a3 3 0 0 1-.94-.34M14.05 5h-4.1a3 3 0 0 0 0-1h4.1a3 3 0 0 0 0 1m-.64 6.53 1.67-1.67 1.05-2.89a3 3 0 0 1-.94-.34zM5.95 16h3.52q.17-.54.52-1H5.95a3 3 0 0 1 0 1m5.03-.62 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $cdb0ff5c001a8842$export$d17ea1ff465f1320 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit24Filled', "24", [
    "M18.59 6.41A2 2 0 0 0 22 5a2 2 0 1 0-3.44 1.4zM2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0M6.59 6.41A2 2 0 0 0 10 5a2 2 0 0 0-2-2 2 2 0 0 0-1.44 3.4zm-.33 1.04L3.82 16a3 3 0 0 1 1.92.54L8.18 8a3 3 0 0 1-1.92-.54M17.17 6h-6.34a3 3 0 0 0 0-2h6.34a3 3 0 0 0 0 2m-5.65 13.58q.23-.9.84-1.58H6.83a3 3 0 0 1 0 2h4.59zm8.66-11.59-.96 3.37q-.45.22-.83.6l-1.99 2 1.86-6.51a3 3 0 0 0 1.92.54m-1.08 4.68-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $cdb0ff5c001a8842$export$7ccbfd0c06967471 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit24Regular', "24", [
    "M18.88 6.66a2 2 0 0 0 1.33.33 2 2 0 1 0-1.33-.33M2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0M6.88 6.66a2 2 0 0 0 3-.97 2 2 0 1 0-3 .97M4.08 16l2.4-8.41q.65.39 1.44.4l-2.4 8.42q-.65-.39-1.44-.4M17.09 5.75h-6.18a3 3 0 0 0 0-1.5h6.18a3 3 0 0 0 0 1.5m-5.57 13.83q.18-.74.64-1.33H6.9a3 3 0 0 1 0 1.5h4.57zM19.92 8l-1 3.54a3 3 0 0 0-.53.42l-1.62 1.63 1.71-6q.65.39 1.44.4m-.82 4.67-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $cdb0ff5c001a8842$export$df94141195c42ccf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool20Filled', "20", [
    "M5.75 4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0V7.5h5V4.75a.75.75 0 1 0-1.5 0v.5a.75.75 0 1 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0v7.03q-.6.22-1.5.22V9H8v1.23A7 7 0 0 0 6.5 10V4.75A.75.75 0 0 0 5.75 4m.06 8.53c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a7 7 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.3 7.3 0 0 1-7.5-.17 5.4 5.4 0 0 0-3.32-.86m0 3c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a7 7 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.3 7.3 0 0 1-7.5-.17 5.4 5.4 0 0 0-3.32-.86"
]);
const $cdb0ff5c001a8842$export$1ec95d12ca8b0819 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool20Regular', "20", [
    "M5 5a1 1 0 0 1 2 0v5.05q.48.05 1 .19V9h5v3q.55 0 1-.09V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0V5a1 1 0 1 1 2 0v3H8V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0zm8.08 9a7.6 7.6 0 0 1-3.83-1.08c-3.42-1.97-5.32-.15-5.39-.08a.5.5 0 0 1-.71 0 .5.5 0 0 1 0-.7c.1-.1 2.48-2.46 6.6-.1a6 6 0 0 0 6.45.05c.22-.16.53-.11.7.1a.5.5 0 0 1-.1.7 6.7 6.7 0 0 1-3.72 1.1zm-3.83 1.92A7.6 7.6 0 0 0 13.08 17v-.01a6.7 6.7 0 0 0 3.71-1.1.5.5 0 0 0 .11-.7.5.5 0 0 0-.7-.1 6 6 0 0 1-6.44-.04c-4.13-2.37-6.5 0-6.61.1-.2.19-.2.5 0 .7s.52.18.71 0c.07-.08 1.97-1.9 5.39.07"
]);
const $cdb0ff5c001a8842$export$c20104e8fa58fddb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool24Filled', "24", [
    "M6 6a1 1 0 0 1 2 0v6.03q.95.09 2 .41V11h6v3.48c.8 0 1.48-.17 2-.35V6a3 3 0 0 0-6 0 1 1 0 1 0 2 0 1 1 0 1 1 2 0v3h-6V6a3 3 0 0 0-6 0 1 1 0 0 0 2 0m.6 9.02c-1.03.13-1.7.55-2 .77a1 1 0 0 1-1.2-1.6c.49-.37 1.49-.97 2.95-1.15a9 9 0 0 1 5.51 1.32 7.5 7.5 0 0 0 7.63.18 1 1 0 0 1 1.02 1.72 9.5 9.5 0 0 1-9.64-.17C9.03 15.06 7.6 14.9 6.6 15.02m-2 4.77c.3-.22.97-.64 2-.77 1-.12 2.43.03 4.27 1.07a9.5 9.5 0 0 0 9.64.17 1 1 0 1 0-1.02-1.72 7.5 7.5 0 0 1-7.63-.18 9 9 0 0 0-5.51-1.32 6 6 0 0 0-2.96 1.16 1 1 0 0 0 1.22 1.6"
]);
const $cdb0ff5c001a8842$export$df4f3b57d4febd94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool24Regular', "24", [
    "M5.5 5.75a1.25 1.25 0 1 1 2.5 0v6.29q.72.06 1.5.27V11H16v3.5a7 7 0 0 0 1.5-.2V5.75a2.75 2.75 0 1 0-5.5 0v.5a.75.75 0 0 0 1.5 0v-.5a1.25 1.25 0 1 1 2.5 0V9.5H9.5V5.75a2.75 2.75 0 0 0-5.5 0v.5a.75.75 0 0 0 1.5 0zm-1.22 9.78a.75.75 0 0 1-1.06-1.06l.02-.02.16-.14q.15-.14.44-.33c.4-.26.96-.56 1.7-.76 1.5-.4 3.6-.37 6.2 1.11a8 8 0 0 0 5.77 1 8 8 0 0 0 2.3-.94.75.75 0 0 1 .88 1.21l-.02.02-.2.13q-.21.13-.57.32a9.43 9.43 0 0 1-8.9-.43c-2.28-1.3-3.98-1.27-5.07-.97a4.4 4.4 0 0 0-1.64.85m-1.06 4c.3.29.77.29 1.06 0l.01-.01.07-.06q.1-.1.3-.23c.29-.18.71-.4 1.27-.56 1.1-.3 2.8-.33 5.06.96a9.4 9.4 0 0 0 6.85 1.16 9 9 0 0 0 2.83-1.17l.01-.01h.01a.75.75 0 0 0-.88-1.22l-.02.02a4 4 0 0 1-.56.31 7.94 7.94 0 0 1-7.5-.4c-2.59-1.47-4.7-1.5-6.2-1.1a6 6 0 0 0-2.3 1.23v.01h-.01v.01a.75.75 0 0 0 0 1.06"
]);
const $cdb0ff5c001a8842$export$4a39d859d91f56d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool32Filled', "32", [
    "M8.25 5.5c-.97 0-1.75.78-1.75 1.75v.5a1.25 1.25 0 1 1-2.5 0v-.5a4.25 4.25 0 0 1 8.5 0v4.25H22V7.25a1.75 1.75 0 1 0-3.5 0v.5a1.25 1.25 0 1 1-2.5 0v-.5a4.25 4.25 0 0 1 8.5 0v11.42A10 10 0 0 1 22 19v-5h-9.5v1.98q-1.32-.34-2.5-.44V7.25c0-.97-.78-1.75-1.75-1.75M3.39 18.9v-.01l.03-.03.24-.2q.22-.18.64-.44a9 9 0 0 1 2.42-.96c2.14-.5 5.16-.41 8.94 1.59a12.7 12.7 0 0 0 8.26 1.48 11 11 0 0 0 3.13-1.07l.03-.02a1.25 1.25 0 0 1 1.35 2.1l-.01.01-.03.02-.3.17q-.29.16-.8.39c-.7.3-1.7.65-2.95.86-2.5.44-5.95.33-9.85-1.73-3.29-1.74-5.69-1.72-7.2-1.37a6 6 0 0 0-2.18 1.01 1.25 1.25 0 0 1-1.72-1.8m0 6v-.01l.03-.03.24-.2q.22-.18.64-.44a9 9 0 0 1 2.42-.96c2.14-.5 5.16-.41 8.94 1.59a12.7 12.7 0 0 0 8.26 1.48 11 11 0 0 0 3.13-1.07l.03-.02a1.25 1.25 0 0 1 1.35 2.1l-.01.01-.03.02-.3.17q-.29.16-.8.39c-.7.3-1.7.65-2.95.86-2.5.44-5.95.33-9.85-1.73-3.29-1.74-5.69-1.72-7.2-1.37a6 6 0 0 0-2.18 1.01 1.25 1.25 0 0 1-1.72-1.8"
]);
const $cdb0ff5c001a8842$export$e73fdc418ed5e9c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool32Regular', "32", [
    "M8 5a2 2 0 0 0-2 2v1a1 1 0 0 1-2 0V7a4 4 0 1 1 8 0v5h10V7a2 2 0 1 0-4 0v1a1 1 0 1 1-2 0V7a4 4 0 0 1 8 0v11.82a11 11 0 0 1-2 .18v-5H12v1.87q-1.04-.25-2-.32V7a2 2 0 0 0-2-2M4.66 20.3a1 1 0 0 1-1.33-1.5h.01l.02-.02.23-.19q.23-.16.65-.41c.56-.32 1.37-.7 2.42-.93 2.13-.49 5.14-.4 8.88 1.57 3.4 1.8 6.4 1.87 8.55 1.5a12 12 0 0 0 3.35-1.1l.03-.02h.01a1 1 0 0 1 1.04 1.7l-.03.02-.29.16q-.29.15-.82.38c-.7.29-1.7.63-2.96.84-2.5.42-5.97.32-9.81-1.71-3.34-1.76-5.86-1.77-7.5-1.4a7 7 0 0 0-2.43 1.1zm0 6a1 1 0 0 1-1.33-1.5h.01l.02-.02.23-.19q.23-.16.65-.41c.56-.32 1.37-.7 2.42-.93 2.13-.49 5.14-.4 8.88 1.57 3.4 1.8 6.4 1.87 8.55 1.5a12 12 0 0 0 3.35-1.1l.03-.02h.01a1 1 0 0 1 1.04 1.7l-.03.02-.29.16q-.29.15-.82.38c-.7.29-1.7.63-2.96.84-2.5.42-5.97.32-9.81-1.71-3.34-1.76-5.86-1.77-7.5-1.4a7 7 0 0 0-2.43 1.1z"
]);
const $cdb0ff5c001a8842$export$f85962f75c3ea05b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool48Filled', "48", [
    "M12 8a3 3 0 0 0-3 3v1.5a1.5 1.5 0 0 1-3 0V11a6 6 0 1 1 12 0v7h15v-7a3 3 0 1 0-6 0v1.5a1.5 1.5 0 1 1-3 0V11a6 6 0 0 1 12 0v17.71a17 17 0 0 1-3 .29v-8H18v3.52a21 21 0 0 0-3-.46V11a3 3 0 0 0-3-3M5.34 30.48a1.5 1.5 0 0 1 .2-2.1v-.01h.01l.01-.01.03-.02.34-.25q.33-.24.95-.56c.81-.43 2-.93 3.53-1.23 3.1-.62 7.47-.46 12.92 2.31a20.3 20.3 0 0 0 12.48 2.17 18 18 0 0 0 4.89-1.52l.05-.02a1.5 1.5 0 0 1 1.5 2.6h-.02l-.02.02-.43.22q-.42.21-1.2.52c-1.02.4-2.5.86-4.31 1.14-3.65.57-8.7.4-14.3-2.45-4.87-2.48-8.56-2.53-10.97-2.05a10 10 0 0 0-3.39 1.33l-.16.12a1.5 1.5 0 0 1-2.1-.2m0 9a1.5 1.5 0 0 1 .2-2.1v-.01h.01l.01-.01.03-.02.34-.25q.33-.23.95-.56c.81-.43 2-.93 3.53-1.23 3.1-.62 7.47-.46 12.92 2.31a20.3 20.3 0 0 0 12.48 2.17 18 18 0 0 0 4.89-1.52l.05-.02a1.5 1.5 0 0 1 1.5 2.6h-.02l-.02.02-.43.22q-.42.21-1.2.52c-1.02.4-2.5.86-4.31 1.14-3.65.57-8.7.4-14.3-2.45-4.87-2.48-8.56-2.53-10.97-2.05a10 10 0 0 0-3.39 1.33l-.16.12a1.5 1.5 0 0 1-2.1-.2"
]);
const $cdb0ff5c001a8842$export$4a708e9d5405bcbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool48Regular', "48", [
    "M9 10.75a3.25 3.25 0 0 1 6.5 0v13.4q1.2.11 2.5.4V21h15.5v8.06a17 17 0 0 0 2.5-.27V10.75a5.75 5.75 0 0 0-11.5 0v1a1.25 1.25 0 1 0 2.5 0v-1a3.25 3.25 0 0 1 6.5 0v7.75H18v-7.75a5.75 5.75 0 0 0-11.5 0v1a1.25 1.25 0 1 0 2.5 0zm13.05 20C12.57 25.9 7.33 30.4 7.1 30.6c-.51.46-1.3.42-1.76-.09-.46-.5-.43-1.28.08-1.75.27-.25 6.69-5.94 17.8-.23 9.93 5.1 17.59.76 17.91.57a1.26 1.26 0 0 1 1.7.44c.36.59.17 1.35-.43 1.7-.23.14-3.9 2.26-9.44 2.26-3.84-.1-7.47-.98-10.9-2.75M7.1 39.6c.24-.2 5.48-4.71 14.96.15a25 25 0 0 0 10.9 2.75c5.54 0 9.2-2.12 9.44-2.26.6-.35.79-1.11.44-1.7a1.26 1.26 0 0 0-1.71-.44c-.32.2-7.98 4.54-17.9-.57-11.12-5.7-17.54-.02-17.81.23a1.24 1.24 0 0 0-.08 1.75c.46.51 1.25.55 1.76.1"
]);
const $cdb0ff5c001a8842$export$9823b288288f9a3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown20Filled', "20", [
    "M14 6a4 4 0 0 1-2.25 3.6V8.44a3 3 0 1 0-3.5 0V9.6A4 4 0 1 1 14 6M9.47 17.78c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22V5.75a.75.75 0 0 0-1.5 0v9.69l-1.22-1.22a.75.75 0 0 0-1.06 1.06z"
]);
const $cdb0ff5c001a8842$export$2acd8e09ffcf8f5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown20Regular', "20", [
    "M14 6a4 4 0 0 1-2.5 3.7V8.6a3 3 0 1 0-3 0v1.1A4 4 0 1 1 14 6M9.65 17.85c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7l-2.15 2.14V5.5a.5.5 0 0 0-1 0v10.8l-2.15-2.15a.5.5 0 1 0-.7.7z"
]);
const $cdb0ff5c001a8842$export$95b7f4011e6200ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown24Filled', "24", [
    "M12 6a1 1 0 0 1 1 1v11.59l1.3-1.3a1 1 0 0 1 1.31-.08l.1.08a1 1 0 0 1 .08 1.32l-.08.1-3 3a1 1 0 0 1-1.32.08l-.1-.08-3-3a1 1 0 0 1 1.32-1.5l.1.08L11 18.6V7a1 1 0 0 1 1-1m0-4a5 5 0 0 1 2 9.58v-1.7a3.5 3.5 0 1 0-4 0v1.7A5 5 0 0 1 12 2"
]);
const $cdb0ff5c001a8842$export$f90f75f10c20900 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown24Regular', "24", [
    "M12 6c.38 0 .7.28.74.64l.01.1v12.7l2.22-2.22a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.69.07.98l-.07.08-3.5 3.5a.75.75 0 0 1-.98.07l-.08-.07-3.5-3.5a.75.75 0 0 1 .98-1.13l.08.07 2.22 2.22V6.74c0-.4.34-.74.75-.74m0-4a5 5 0 0 1 1.75 9.68v-1.66a3.5 3.5 0 1 0-3.5 0v1.66A5 5 0 0 1 12 2"
]);
const $cdb0ff5c001a8842$export$f77a061de0e71d5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight20Filled', "20", [
    "M6 6a4 4 0 0 1 3.6 2.25H8.44a3 3 0 1 0 0 3.5H9.6A4 4 0 1 1 6 6m9.28 7.03 2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06l1.22 1.22H5.75a.75.75 0 1 0 0 1.5h9.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06"
]);
const $cdb0ff5c001a8842$export$5706d26221fa01d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight20Regular', "20", [
    "M6 6a4 4 0 0 1 3.7 2.5H8.6a3 3 0 1 0 0 3h1.1A4 4 0 1 1 6 6m8.85 7.35 3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 1 0-.7.7l2.14 2.15H5.5a.5.5 0 0 0 0 1h10.8l-2.15 2.15a.5.5 0 0 0 .7.7"
]);
const $cdb0ff5c001a8842$export$55062d94f921f74e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight24Filled', "24", [
    "M6 12a1 1 0 0 0 1 1h11.59l-1.3 1.3a1 1 0 0 0-.08 1.31l.08.1a1 1 0 0 0 1.32.08l.1-.08 3-3a1 1 0 0 0 .08-1.32l-.08-.1-3-3a1 1 0 0 0-1.5 1.32l.08.1L18.6 11H7a1 1 0 0 0-1 1m-4 0a5 5 0 0 0 9.58 2h-1.7a3.5 3.5 0 1 1 0-4h1.7A5 5 0 0 0 2 12"
]);
const $cdb0ff5c001a8842$export$b7cf012205e79beb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight24Regular', "24", [
    "M6 12c0 .38.28.7.64.74l.1.01h12.7l-2.22 2.22a.75.75 0 0 0-.07.98l.07.08c.27.27.69.3.98.07l.08-.07 3.5-3.5a.75.75 0 0 0 .07-.98l-.07-.08-3.5-3.5a.75.75 0 0 0-1.13.98l.07.08 2.22 2.22H6.74A.75.75 0 0 0 6 12m-4 0a5 5 0 0 0 9.68 1.75h-1.66a3.5 3.5 0 1 1 0-3.5h1.66A5 5 0 0 0 2 12"
]);
const $cdb0ff5c001a8842$export$b70bdd910f067428 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp20Filled', "20", [
    "M10.53 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v9.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06zM6 14a4 4 0 0 1 2.25-3.6v1.16a3 3 0 1 0 3.5 0V10.4A4 4 0 1 1 6 14"
]);
const $cdb0ff5c001a8842$export$9cee8614f96df716 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp20Regular', "20", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L9.5 3.71V14.5a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 0 0 .7-.7zM6 14a4 4 0 0 1 2.5-3.7v1.1a3 3 0 1 0 3 0v-1.1A4 4 0 1 1 6 14"
]);
const $cdb0ff5c001a8842$export$cdf2fbf99f8b6ea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp24Filled', "24", [
    "M12 18a1 1 0 0 0 1-1V5.42l1.3 1.29a1 1 0 0 0 1.31.08l.1-.08a1 1 0 0 0 .08-1.32l-.08-.1-3-3a1 1 0 0 0-1.32-.08l-.1.08-3 3a1 1 0 0 0 1.32 1.5l.1-.08L11 5.4V17a1 1 0 0 0 1 1m0 4a5 5 0 0 0 2-9.58v1.7a3.5 3.5 0 1 1-4 0v-1.7A5 5 0 0 0 12 22"
]);
const $cdb0ff5c001a8842$export$3970155ad0f795b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp24Regular', "24", [
    "M12 18c.38 0 .7-.28.74-.64l.01-.1V4.55l2.22 2.22c.27.26.68.29.98.07l.08-.07a.75.75 0 0 0 .07-.98l-.07-.08-3.5-3.5a.75.75 0 0 0-.98-.07l-.08.07-3.5 3.5a.75.75 0 0 0 .98 1.13l.08-.07 2.22-2.22v12.7c0 .4.34.74.75.74m0 4a5 5 0 0 0 1.75-9.68v1.66a3.5 3.5 0 1 1-3.5 0v-1.66A5 5 0 0 0 12 22"
]);
const $cdb0ff5c001a8842$export$84fc1ff1c788ce3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble20Filled', "20", [
    "M4 8.5a5.5 5.5 0 1 1 10.97.6q.51.22.93.57.1-.57.1-1.17a6.5 6.5 0 1 0-12.36 2.81q.38-.37.82-.61A5.5 5.5 0 0 1 4 8.5m10 0-.01.33-1-.17.01-.16a3.5 3.5 0 1 0-6.57 1.69 4 4 0 0 0-1.05.13A4.48 4.48 0 0 1 9.5 4 4.5 4.5 0 0 1 14 8.5m-6-1a1.5 1.5 0 1 1 3 0v2.08l2.94.51a2.5 2.5 0 0 1 1.91 3.33l-.98 2.67a2.5 2.5 0 0 1-1.92 1.6l-1.52.26c-1.02.18-1.95-.45-2.43-1.23A5.9 5.9 0 0 0 4.44 14a.5.5 0 0 1-.43-.62q.23-.89.82-1.36c.39-.32.85-.47 1.3-.52.63-.06 1.29.05 1.87.25z"
]);
const $cdb0ff5c001a8842$export$718fcb556403ebcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble20Regular', "20", [
    "M9.5 3a5.5 5.5 0 0 0-5.04 7.7q-.45.24-.82.61Q3 10.02 3 8.5a6.5 6.5 0 1 1 12.9 1.17 4 4 0 0 0-.93-.57l.03-.6A5.5 5.5 0 0 0 9.5 3m4.49 5.83L14 8.5a4.5 4.5 0 1 0-8.62 1.82 4 4 0 0 1 1.05-.13A3.5 3.5 0 1 1 13 8.66zM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.5 4.5 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52q-.59.48-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5M9 7.5a.5.5 0 0 1 1 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 0 1 1.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.8 6.8 0 0 0-4.65-3.1q.12-.2.26-.3.3-.25.78-.3c.64-.07 1.42.14 2.04.45A.5.5 0 0 0 9 12.5z"
]);
const $cdb0ff5c001a8842$export$1e9f155897907732 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble24Filled', "24", [
    "M11.75 7c1.36 0 1.95.9 2 2.33V12l2.87.41.34.07c1.4.4 2.25 1.8 1.96 3.22l-.05.17-1.22 4.44c-.17.62-.67 1.1-1.3 1.24l-.14.03-3.06.43c-.76.11-1.5-.29-1.83-.97l-.06-.14-.21-.57a4 4 0 0 0-1.18-1.67l-.2-.17-1.6-1.2-.27-.16-.14-.07-2.2-.86a.8.8 0 0 1-.47-.66c-.03-.73.5-1.25 1.42-1.72q1.07-.53 3.07.05l.27.08V9.5c0-1.54.58-2.51 2-2.51m0-5a7.25 7.25 0 0 1 6.67 10.1 4 4 0 0 0-1.2-.57l-.17-.04q.44-1.04.45-2.24a5.75 5.75 0 1 0-10.37 3.43 3 3 0 0 0-1.51.44A7.25 7.25 0 0 1 11.75 2m0 2.5a4.75 4.75 0 0 1 4.27 6.82l-1.27-.18v-.65a3.2 3.2 0 0 0-.83-3.66l-.15-.12A2.9 2.9 0 0 0 11.75 6q-1.33.02-2.04.72a3.24 3.24 0 0 0-.96 3.79v1.85a.3.3 0 0 1-.3.3 4.75 4.75 0 0 1 3.3-8.16"
]);
const $cdb0ff5c001a8842$export$d6ead6f6ed9251 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble24Regular', "24", [
    "M11.75 7c1.35 0 2.18.97 2.25 2.33v2.29l2.22.4a3.25 3.25 0 0 1 2.6 3.86l-.04.18L17.73 20a2.3 2.3 0 0 1-1.69 1.61l-.16.03-2.42.35a2.25 2.25 0 0 1-2.28-1.12l-.08-.16-.03-.06q-.37-.77-1.03-1.28l-.2-.14-1.87-1.26-.1-.06-.1-.05-2.36-1.17a.8.8 0 0 1-.41-.66 2.5 2.5 0 0 1 1.41-2.44q1.05-.52 2.83.02l.26.08V9.5c0-1.45.84-2.51 2.25-2.51m0 1.5q-.69-.02-.75.87v5.38c0 .54-.54.9-1.04.7q-2.2-.88-2.87-.53a1 1 0 0 0-.51.52l-.04.12 1.9.95.18.1.18.1 1.88 1.26a5 5 0 0 1 1.63 1.8l.12.24.03.06c.12.27.39.43.68.43h.1l2.42-.35c.26-.04.48-.2.58-.45l.04-.1 1.05-3.92c.25-.94-.3-1.9-1.24-2.15l-.07-.01-2.9-.53a.75.75 0 0 1-.61-.63l-.01-.11V9.51q0-1.03-.75-1.01m0-6.5a7.25 7.25 0 0 1 6.7 10.03 4 4 0 0 0-1.3-.78q.34-.94.35-2a5.75 5.75 0 1 0-10.58 3.13 3 3 0 0 0-1.4.57A7.25 7.25 0 0 1 11.75 2m0 2.5a4.75 4.75 0 0 1 4.41 6.5L15 10.8V9.25q-.02-1.03-.57-1.83l-.09-.14A3 3 0 0 0 11.75 6c-1.18 0-2.08.53-2.64 1.35a3.2 3.2 0 0 0-.61 1.9v3.15l-.26-.04a1 1 0 0 1-.62-.32Q7 11.35 7 9.25a4.75 4.75 0 0 1 4.75-4.75"
]);
const $cdb0ff5c001a8842$export$4e7e3718f1408e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble32Filled', "32", [
    "M8 12a8 8 0 1 1 15.58 2.56q1 .31 1.8.92.61-1.63.62-3.48a10 10 0 1 0-18.7 4.93q.75-.69 1.7-1.06A8 8 0 0 1 8 12m14.5 0q0 1.2-.4 2.25l-1.6-.31V12a4.5 4.5 0 1 0-9 .18v3.33a6 6 0 0 0-.97 0A6.5 6.5 0 1 1 22.5 12M16 9a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 15.18V12a3 3 0 0 0-3-3"
]);
const $cdb0ff5c001a8842$export$2c4428c7f834b068 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble32Regular', "32", [
    "M8 12a8 8 0 1 1 15.58 2.56q1 .31 1.8.92.61-1.63.62-3.48a10 10 0 1 0-18.7 4.93q.75-.69 1.7-1.06A8 8 0 0 1 8 12m14.5 0q0 1.2-.4 2.25l-1.6-.31V12a4.5 4.5 0 1 0-9 .18v3.33a6 6 0 0 0-.97 0A6.5 6.5 0 1 1 22.5 12M15 12a1 1 0 1 1 2 0v4c0 .48.34.9.81.98l4.57.89a2 2 0 0 1 1.55 2.49l-1.52 5.53a1 1 0 0 1-.88.73l-4.76.38h-.02l-.05-.08c-.78-2.15-2.68-4.74-7.6-6.56a2 2 0 0 1 2.68-1.21l1.83.77a1 1 0 0 0 1.4-.92zm1-3a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 15.18V12a3 3 0 0 0-3-3"
]);
const $cdb0ff5c001a8842$export$d6e575f35562cd82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble48Filled', "48", [
    "M12.5 17.5a11 11 0 1 1 21.18 4.16l.2.05q1.16.25 2.16.8a13.5 13.5 0 1 0-23.96 2.17 7 7 0 0 1 2.53-.7 11 11 0 0 1-2.11-6.48m20 0q-.02 2.01-.81 3.74L30 20.87V17.5a6.5 6.5 0 1 0-13 .09v6.14a9 9 0 1 1 15.5-6.23m-9-4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3 3 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 22.5V17.5a4.5 4.5 0 0 0-4.5-4.5"
]);
const $cdb0ff5c001a8842$export$afb59ed8b2195b49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble48Regular', "48", [
    "M12.5 17.5a11 11 0 1 1 21.18 4.16l.2.05q1.16.25 2.16.8a13.5 13.5 0 1 0-23.96 2.17 7 7 0 0 1 2.53-.7 11 11 0 0 1-2.11-6.48m20 0q-.02 2.01-.81 3.74L30 20.87V17.5a6.5 6.5 0 1 0-13 .09v6.14a9 9 0 1 1 15.5-6.23m-11 0a2 2 0 1 1 4 0v6c0 .59.41 1.1.99 1.22l6.44 1.39a3.25 3.25 0 0 1 2.45 4.03l-2.3 8.35c-.18.69-.77 1.2-1.48 1.27l-6.24.74q-.08.02-.21-.07a1 1 0 0 1-.27-.3c-1.43-3.08-5.1-6.42-12.29-9.73a2.84 2.84 0 0 1 3.68-1.77l3.55 1.3a1.25 1.25 0 0 0 1.68-1.17zm2-4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3 3 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 22.5V17.5a4.5 4.5 0 0 0-4.5-4.5"
]);
const $cdb0ff5c001a8842$export$532e143e4fa3861b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle20Filled', "20", [
    "M6 8.5a3.5 3.5 0 1 1 7 .16l.99.17.01-.33a4.5 4.5 0 1 0-8.62 1.82 4 4 0 0 1 1.05-.13A3.5 3.5 0 0 1 6 8.5M9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.5 4.5 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52q-.59.48-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5"
]);
const $cdb0ff5c001a8842$export$e23d413802afd8e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle20Regular', "20", [
    "M6 8.5a3.5 3.5 0 1 1 7 .16l.99.17.01-.33a4.5 4.5 0 1 0-8.62 1.82 4 4 0 0 1 1.05-.13A3.5 3.5 0 0 1 6 8.5M9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.5 4.5 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52q-.59.48-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5M9 7.5a.5.5 0 0 1 1 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 0 1 1.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.8 6.8 0 0 0-4.65-3.1q.12-.2.26-.3.3-.25.78-.3c.64-.07 1.42.14 2.04.45A.5.5 0 0 0 9 12.5z"
]);
const $cdb0ff5c001a8842$export$80e46f90adb35a9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle24Filled', "24", [
    "M11.75 6c1.36 0 1.95.9 2 2.33V11l2.87.41a2.75 2.75 0 0 1 2.3 3.29l-.05.17-1.22 4.44c-.18.62-.67 1.1-1.3 1.24l-.14.03-3.06.43c-.76.11-1.5-.29-1.83-.97l-.06-.14-.21-.57a4 4 0 0 0-1.18-1.67l-.2-.17-1.6-1.2-.27-.16-.14-.07-2.2-.86a.8.8 0 0 1-.47-.66c-.03-.73.5-1.25 1.42-1.72q1.07-.53 3.07.05l.27.08V8.5c0-1.54.58-2.51 2-2.51m0-3.5a5.75 5.75 0 0 1 5.3 7.99l.17.04-.45-.1-1.27-.18q.49-.91.5-2a4.25 4.25 0 1 0-7.25 3.02v.41a6 6 0 0 0-1.67-.07 5.75 5.75 0 0 1 4.67-9.1"
]);
const $cdb0ff5c001a8842$export$29decb8c62f16fe5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle24Regular', "24", [
    "M11.75 6c1.35 0 2.18.97 2.25 2.33v2.29l2.22.4a3.25 3.25 0 0 1 2.6 3.86l-.04.18L17.73 19a2.3 2.3 0 0 1-1.69 1.61l-.16.03-2.42.35a2.25 2.25 0 0 1-2.28-1.12l-.08-.16-.03-.06q-.37-.77-1.03-1.28l-.19-.14-1.88-1.26-.1-.06-.1-.05-2.36-1.17a.8.8 0 0 1-.41-.66 2.5 2.5 0 0 1 1.41-2.44q1.05-.51 2.83.02l.26.08V8.5c0-1.45.84-2.51 2.25-2.51m0 1.5q-.69-.01-.75.87v5.38c0 .54-.54.9-1.04.7q-2.2-.88-2.87-.53a1 1 0 0 0-.51.52l-.04.12 1.9.95.18.1.18.1 1.88 1.26a5 5 0 0 1 1.63 1.8l.12.24.03.06c.12.27.39.43.68.43h.1l2.42-.35c.26-.04.48-.2.58-.45l.04-.1 1.05-3.92c.25-.94-.3-1.9-1.24-2.15l-.07-.01-2.9-.53a.75.75 0 0 1-.61-.63l-.01-.11V8.51c0-.7-.25-1.01-.75-1.01m0-5a5.75 5.75 0 0 1 5.4 7.75L17 10.2a6 6 0 0 0-1.34-.3A4.24 4.24 0 0 0 11.75 4a4.25 4.25 0 0 0-3.25 7q-.49.03-.82.11-.53.13-.76.27a5.75 5.75 0 0 1 4.83-8.88"
]);
const $cdb0ff5c001a8842$export$63a1cea37f2d18f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle32Filled', "32", [
    "M16 5a6 6 0 0 0-4.88 9.5 6 6 0 0 0-2.12.37 8 8 0 1 1 14.58-1.31q-.26-.08-.53-.13l-1.45-.28A6 6 0 0 0 16 5m0 3a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 14.18V11a3 3 0 0 0-3-3"
]);
const $cdb0ff5c001a8842$export$60b1d98e90c24513 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle32Regular', "32", [
    "M16 5a6 6 0 0 0-4.88 9.5 6 6 0 0 0-2.12.37 8 8 0 1 1 14.58-1.31q-.26-.08-.53-.13l-1.45-.28A6 6 0 0 0 16 5m-1 6a1 1 0 1 1 2 0v4c0 .48.34.9.81.98l4.57.89a2 2 0 0 1 1.55 2.49l-1.52 5.53a1 1 0 0 1-.88.73l-4.76.38h-.02l-.05-.08c-.78-2.15-2.68-4.74-7.6-6.56a2 2 0 0 1 2.68-1.21l1.83.77a1 1 0 0 0 1.4-.92zm1-3a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 14.18V11a3 3 0 0 0-3-3"
]);
const $cdb0ff5c001a8842$export$cb3584882b3eeb70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle48Filled', "48", [
    "M23.5 7.5A9 9 0 0 0 17 22.73v.42q-1.51-.35-2.95-.1a11.5 11.5 0 1 1 20.13-2.28l-.3-.06-2.19-.47q.8-1.72.81-3.74a9 9 0 0 0-9-9m0 4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3 3 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 21.5V16.5a4.5 4.5 0 0 0-4.5-4.5"
]);
const $cdb0ff5c001a8842$export$599c8815187e0e7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle48Regular', "48", [
    "M23.5 7.5A9 9 0 0 0 17 22.73v.42q-1.51-.35-2.95-.1a11.5 11.5 0 1 1 20.13-2.28l-.3-.06-2.19-.47q.8-1.72.81-3.74a9 9 0 0 0-9-9m-2 9a2 2 0 1 1 4 0v6c0 .59.41 1.1.99 1.22l6.44 1.39a3.25 3.25 0 0 1 2.45 4.03l-2.3 8.35c-.18.69-.77 1.2-1.48 1.27l-6.24.74q-.08.02-.21-.07a1 1 0 0 1-.27-.3c-1.43-3.08-5.1-6.42-12.29-9.73a2.84 2.84 0 0 1 3.68-1.77l3.55 1.3a1.25 1.25 0 0 0 1.68-1.17zm2-4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3 3 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 21.5V16.5a4.5 4.5 0 0 0-4.5-4.5"
]);
const $cdb0ff5c001a8842$export$e203fe60c281c028 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy20Filled', "20", [
    "M5.5 3a3.5 3.5 0 0 0-2.85 5.53 8 8 0 0 1 5.5-4.32A3.5 3.5 0 0 0 5.5 3M18 6.5q-.02 1.16-.65 2.03a8 8 0 0 0-5.5-4.32A3.5 3.5 0 0 1 18 6.5m-15 5C3 7.87 6.17 5 10 5s7 2.87 7 6.5a6.2 6.2 0 0 1-1.76 4.31 5.5 5.5 0 0 0-10.48 0A6.2 6.2 0 0 1 3 11.5m8.33 1.7a4.5 4.5 0 0 1 3.07 3.35A7.3 7.3 0 0 1 10 18c-1.66 0-3.2-.54-4.4-1.45a4.5 4.5 0 0 1 3.07-3.35 1.5 1.5 0 0 0 2.66 0"
]);
const $cdb0ff5c001a8842$export$5c73ce1aef509566 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy20Regular', "20", [
    "M2 6.5a3.5 3.5 0 0 0 1.4 2.8Q3 10.35 3 11.5c0 3.63 3.17 6.5 7 6.5s7-2.87 7-6.5q0-1.16-.4-2.2a3.5 3.5 0 1 0-5.31-4.19 8 8 0 0 0-2.58 0A3.5 3.5 0 0 0 2 6.5M5.5 4c.97 0 1.8.55 2.22 1.35a7 7 0 0 0-3.87 3.03A2.5 2.5 0 0 1 5.5 4m6.78 1.35a2.5 2.5 0 1 1 3.87 3.03 7 7 0 0 0-3.87-3.03M10 6c3.35 0 6 2.5 6 5.5a5.2 5.2 0 0 1-1.2 3.3 5.5 5.5 0 0 0-9.6 0A5.2 5.2 0 0 1 4 11.5C4 8.5 6.65 6 10 6m4.06 9.55A6.3 6.3 0 0 1 10 17c-1.57 0-3-.55-4.06-1.45a4.5 4.5 0 0 1 2.73-2.35 1.5 1.5 0 0 0 2.66 0c1.2.37 2.19 1.23 2.73 2.35"
]);
const $cdb0ff5c001a8842$export$e6cd9408726f0906 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy24Filled', "24", [
    "M3.2 10.27a4 4 0 0 1 6.25-4.96 9.2 9.2 0 0 0-6.24 4.96m11.34-4.96A3.99 3.99 0 0 1 21.5 8c0 .84-.26 1.63-.7 2.27a9.2 9.2 0 0 0-6.26-4.96m-7.91 14A7.2 7.2 0 0 1 3.5 13.5C3.5 9.36 7.3 6 12 6s8.5 3.36 8.5 7.5a7.2 7.2 0 0 1-3.13 5.81 5.5 5.5 0 0 0-10.74 0M15 17.14q-.69-.6-1.54-.9c-.17.44-.76.76-1.46.76s-1.3-.32-1.46-.76a4.5 4.5 0 0 0-3 3.65c1.3.7 2.82 1.11 4.46 1.11s3.16-.4 4.46-1.11A4.5 4.5 0 0 0 15 17.14"
]);
const $cdb0ff5c001a8842$export$bb3e29063c42e865 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy24Regular', "24", [
    "M17.5 3.88a4.12 4.12 0 0 1 2.7 7.24q.42 1.13.43 2.38a7.3 7.3 0 0 1-3.19 5.91q-.42.3-.88.57l-.04.02A9.4 9.4 0 0 1 12 21.13a9.4 9.4 0 0 1-5.4-1.68l-.04-.04a7.3 7.3 0 0 1-3.18-5.91q0-1.25.42-2.38a4.12 4.12 0 1 1 6.34-5.07 10 10 0 0 1 3.72 0 4.1 4.1 0 0 1 3.64-2.17M13.52 16.4q-.17.3-.53.5-.43.22-.99.23-.56 0-.99-.24-.36-.18-.53-.5a4.4 4.4 0 0 0-2.53 2.44A8 8 0 0 0 12 19.88c1.5 0 2.89-.4 4.05-1.05a4.4 4.4 0 0 0-2.53-2.43M12 7.13c-4.12 0-7.37 2.9-7.37 6.37a6 6 0 0 0 2.28 4.6 5.63 5.63 0 0 1 10.18 0 6 6 0 0 0 2.29-4.6c0-3.48-3.26-6.37-7.38-6.37m-5.5-2a2.87 2.87 0 0 0-2.13 4.8A8.4 8.4 0 0 1 8.88 6.4 2.9 2.9 0 0 0 6.5 5.13m11 0c-.97 0-1.86.48-2.38 1.26a8.4 8.4 0 0 1 4.5 3.55 2.87 2.87 0 0 0-2.12-4.81"
]);
const $cdb0ff5c001a8842$export$280e96ce2640338e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy16Color', "16", [
    [
        "path",
        {
            "fill": "#c55d5d",
            "d": "M7.5 13v-3h1v3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_16_color__a)",
            "d": "M7.5 13v-3h1v3z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M4 14c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_16_color__b)",
            "d": "M4 14c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M2 4.5C2 3.67 2.67 3 3.5 3h2C6.33 3 7 3.67 7 4.5v1a2.5 2.5 0 0 1-5 0zM3.5 4a.5.5 0 0 0-.5.5v1a1.5 1.5 0 1 0 3 0v-1a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_16_color__c)",
            "fillRule": "evenodd",
            "d": "M2 4.5C2 3.67 2.67 3 3.5 3h2C6.33 3 7 3.67 7 4.5v1a2.5 2.5 0 0 1-5 0zM3.5 4a.5.5 0 0 0-.5.5v1a1.5 1.5 0 1 0 3 0v-1a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M9 4.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-5 0zm1.5-.5a.5.5 0 0 0-.5.5v1a1.5 1.5 0 0 0 3 0v-1a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_16_color__d)",
            "fillRule": "evenodd",
            "d": "M9 4.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-5 0zm1.5-.5a.5.5 0 0 0-.5.5v1a1.5 1.5 0 0 0 3 0v-1a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M6 1a2 2 0 0 0-2 2v4a4 4 0 1 0 8 0V3a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_16_color__e)",
            "d": "M6 1a2 2 0 0 0-2 2v4a4 4 0 1 0 8 0V3a2 2 0 0 0-2-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_16_color__a",
                "x1": "7",
                "x2": "12",
                "y1": "9.4",
                "y2": "15.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_16_color__b",
                "x1": "26.67",
                "x2": "22.12",
                "y1": "24.01",
                "y2": "7.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_16_color__c",
                "x1": "5.75",
                "x2": ".75",
                "y1": "5.08",
                "y2": "5.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_16_color__d",
                "x1": "10.67",
                "x2": "15.25",
                "y1": "5.08",
                "y2": "5.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(229.01 8.4 2.55)scale(11.5196 12.3112)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$92b456b76624267a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy16Filled', "16", [
    "M4 3h-.5C2.67 3 2 3.67 2 4.5v1a2.5 2.5 0 0 0 2.12 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V14a2 2 0 0 0-2-2H8.5v-1.03a4 4 0 0 0 3.38-3A2.5 2.5 0 0 0 14 5.5v-1c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2m8 1h.5c.28 0 .5.22.5.5v1c0 .65-.42 1.2-1 1.41zM4 4v2.91c-.58-.2-1-.76-1-1.41v-1c0-.28.22-.5.5-.5z"
]);
const $cdb0ff5c001a8842$export$a27290dbb39ae614 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy16Regular', "16", [
    "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-2.12 2.47 4 4 0 0 1-3.38 3V12H10a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1C2 3.67 2.67 3 3.5 3zm7 0a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a3 3 0 0 0 6 .07zm1 3.91c.58-.2 1-.76 1-1.41v-1a.5.5 0 0 0-.5-.5H12zM4 4h-.5a.5.5 0 0 0-.5.5v1c0 .65.42 1.2 1 1.41zm1 10h6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1"
]);
const $cdb0ff5c001a8842$export$2388099ba0d34c86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__a)",
            "fillRule": "evenodd",
            "d": "M9.5 15.5V13h1v2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__b)",
            "d": "M7.5 15a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5V17a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__c)",
            "fillRule": "evenodd",
            "d": "M3 5.5C3 4.67 3.67 4 4.5 4h3C8.33 4 9 4.67 9 5.5V7a3 3 0 0 1-6 0zM4.5 5a.5.5 0 0 0-.5.5V7a2 2 0 1 0 4 0V5.5a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__d)",
            "fillRule": "evenodd",
            "d": "M11 5.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5V7a3 3 0 1 1-6 0zm1.5-.5a.5.5 0 0 0-.5.5V7a2 2 0 1 0 4 0V5.5a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__e)",
            "d": "M7.5 2a2 2 0 0 0-2 2v5a4.5 4.5 0 1 0 9 0V4a2 2 0 0 0-2-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__a",
                "x1": "9",
                "x2": "13",
                "y1": "12.5",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__b",
                "x1": "31",
                "x2": "26.91",
                "y1": "27",
                "y2": "10.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__c",
                "x1": "7.5",
                "x2": "1.5",
                "y1": "6.5",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__d",
                "x1": "13",
                "x2": "18.5",
                "y1": "6.5",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(229.63 10.26 3.15)scale(13.1244 13.98)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$cd2956bea43da404 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy20Filled', "20", [
    "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97 4.5 4.5 0 0 1-3.9 3.5v1.5h2a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4zm9 4.94A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1zM5.5 5h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93z"
]);
const $cdb0ff5c001a8842$export$f877ac4d7737e242 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy20Regular', "20", [
    "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5a4.5 4.5 0 0 0 3.9-3.5A3 3 0 0 0 17 7V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5m10 0h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94zm-1-1v5a3.5 3.5 0 0 1-7 .16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1m-7 12.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1z"
]);
const $cdb0ff5c001a8842$export$9b787f7087dbb452 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy24Color', "24", [
    [
        "path",
        {
            "fill": "#c55d5d",
            "d": "M11 18.5v-3.68h1.5v3.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_24_color__a)",
            "d": "M11 18.5v-3.68h1.5v3.68z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M14.25 17.5a3.25 3.25 0 0 1 3.25 3.07v.68c0 .38-.28.7-.65.74l-.1.01h-10a.75.75 0 0 1-.74-.65l-.01-.1v-.5a3.25 3.25 0 0 1 3.07-3.24l.18-.01z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_24_color__b)",
            "d": "M14.25 17.5a3.25 3.25 0 0 1 3.25 3.07v.68c0 .38-.28.7-.65.74l-.1.01h-10a.75.75 0 0 1-.74-.65l-.01-.1v-.5a3.25 3.25 0 0 1 3.07-3.24l.18-.01z"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M3 5.75C3 4.78 3.78 4 4.75 4h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_24_color__c)",
            "fillRule": "evenodd",
            "d": "M3 5.75C3 4.78 3.78 4 4.75 4h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M14 5.75c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_24_color__d)",
            "fillRule": "evenodd",
            "d": "M14 5.75c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M8.25 2C7.01 2 6 3 6 4.25v6a5.75 5.75 0 0 0 11.5 0v-6c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_24_color__e)",
            "d": "M8.25 2C7.01 2 6 3 6 4.25v6a5.75 5.75 0 0 0 11.5 0v-6c0-1.24-1-2.25-2.25-2.25z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_24_color__a",
                "x1": "10.25",
                "x2": "16.11",
                "y1": "14.08",
                "y2": "22.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_24_color__b",
                "x1": "38.59",
                "x2": "31.53",
                "y1": "35.5",
                "y2": "10.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_24_color__c",
                "x1": "7.88",
                "x2": "1.38",
                "y1": "7.33",
                "y2": "7.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_24_color__d",
                "x1": "16.17",
                "x2": "22.13",
                "y1": "7.33",
                "y2": "7.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(228.26 12.2 3.78)scale(16.3147 17.4942)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$66a95805fbbeb725 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy24Filled', "24", [
    "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01a5.8 5.8 0 0 1-4.74 3.95v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07v.68c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.8 5.8 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2zm3.5 3.5H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.3.3 0 0 0-.18-.24zM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73z"
]);
const $cdb0ff5c001a8842$export$9d8470916016ecc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy24Regular', "24", [
    "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01a5.8 5.8 0 0 1-4.74 3.95v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07v.68c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.8 5.8 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2zm-1 17h-5c-.83 0-1.52.58-1.7 1.35l-.03.15h8.47A1.75 1.75 0 0 0 14.4 19zm1-15.5h-7a.75.75 0 0 0-.75.75v6a4.25 4.25 0 0 0 8.5 0v-6a.75.75 0 0 0-.75-.75m3.5 2H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.3.3 0 0 0-.18-.24zM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73z"
]);
const $cdb0ff5c001a8842$export$3f09d1c001f59b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy28Color', "28", [
    [
        "path",
        {
            "fill": "#c55d5d",
            "d": "M13 21.5v-3.68h1.5v3.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_28_color__a)",
            "d": "M13 21.5v-3.68h1.5v3.68z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M17.25 21c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_28_color__b)",
            "d": "M17.25 21c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21z"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M3 6.76C3 5.8 3.79 5 4.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_28_color__c)",
            "fillRule": "evenodd",
            "d": "M3 6.76C3 5.8 3.79 5 4.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M16 6.76C16 5.8 16.79 5 17.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_28_color__d)",
            "fillRule": "evenodd",
            "d": "M16 6.76C16 5.8 16.79 5 17.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M9.75 2A2.75 2.75 0 0 0 7 4.75v7.5a6.75 6.75 0 0 0 13.5 0v-7.5A2.75 2.75 0 0 0 17.75 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_28_color__e)",
            "d": "M9.75 2A2.75 2.75 0 0 0 7 4.75v7.5a6.75 6.75 0 0 0 13.5 0v-7.5A2.75 2.75 0 0 0 17.75 2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_28_color__a",
                "x1": "12.25",
                "x2": "18.11",
                "y1": "17.08",
                "y2": "25.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_28_color__b",
                "x1": "45.25",
                "x2": "37.77",
                "y1": "41",
                "y2": "13.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_28_color__c",
                "x1": "9.38",
                "x2": ".88",
                "y1": "8.75",
                "y2": "8.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_28_color__d",
                "x1": "18.83",
                "x2": "26.63",
                "y1": "8.75",
                "y2": "8.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_28_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(229.22 14.43 4.44)scale(19.5215 20.8409)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$ab44a06b5ab5840c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy28Filled', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 2.34-1.9 4.24-4.23 4.25a6.8 6.8 0 0 1-5.77 4.96V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.8 6.8 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7zM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5m13.5 5.99c1.4-.13 2.5-1.3 2.5-2.74v-3a.25.25 0 0 0-.25-.25H20.5v5.99"
]);
const $cdb0ff5c001a8842$export$ab1227726d2904e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy28Regular', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 2.34-1.9 4.24-4.23 4.25a6.8 6.8 0 0 1-5.77 4.96V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.8 6.8 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7zM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5m13.5 5.99c1.4-.13 2.5-1.3 2.5-2.74v-3a.25.25 0 0 0-.25-.25H20.5v5.99M9.75 3.5c-.69 0-1.25.56-1.25 1.25v7.5a5.25 5.25 0 1 0 10.5 0v-7.5c0-.69-.56-1.25-1.25-1.25zM8.5 24.25v.25H19v-.25c0-.97-.78-1.75-1.75-1.75h-7c-.97 0-1.75.78-1.75 1.75"
]);
const $cdb0ff5c001a8842$export$96c00523537c896 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy32Color', "32", [
    [
        "path",
        {
            "fill": "#c55d5d",
            "d": "M15 24.68V21h2v3.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_32_color__a)",
            "d": "M15 24.68V21h2v3.68z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M11.5 24A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_32_color__b)",
            "d": "M11.5 24A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M4 7.42A2.4 2.4 0 0 1 6.42 5h4.16A2.4 2.4 0 0 1 13 7.42v4.08a4.5 4.5 0 1 1-9 0zM6.42 7a.4.4 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.4.4 0 0 0-.42-.42z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_32_color__c)",
            "fillRule": "evenodd",
            "d": "M4 7.42A2.4 2.4 0 0 1 6.42 5h4.16A2.4 2.4 0 0 1 13 7.42v4.08a4.5 4.5 0 1 1-9 0zM6.42 7a.4.4 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.4.4 0 0 0-.42-.42z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M19 7.42A2.4 2.4 0 0 1 21.42 5h4.16A2.4 2.4 0 0 1 28 7.42v4.08a4.5 4.5 0 1 1-9 0zM21.42 7a.4.4 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.4.4 0 0 0-.42-.42z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_32_color__d)",
            "fillRule": "evenodd",
            "d": "M19 7.42A2.4 2.4 0 0 1 21.42 5h4.16A2.4 2.4 0 0 1 28 7.42v4.08a4.5 4.5 0 1 1-9 0zM21.42 7a.4.4 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.4.4 0 0 0-.42-.42z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M11 2a3 3 0 0 0-3 3v9a8 8 0 1 0 16 0V5a3 3 0 0 0-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_32_color__e)",
            "d": "M11 2a3 3 0 0 0-3 3v9a8 8 0 1 0 16 0V5a3 3 0 0 0-3-3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_32_color__a",
                "x1": "14",
                "x2": "19.15",
                "y1": "20.26",
                "y2": "29.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_32_color__b",
                "x1": "53.33",
                "x2": "44.26",
                "y1": "48",
                "y2": "14.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_32_color__c",
                "x1": "10.75",
                "x2": "1.75",
                "y1": "9.58",
                "y2": "9.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_32_color__d",
                "x1": "22",
                "x2": "30.25",
                "y1": "9.58",
                "y2": "9.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(229.01 16.82 5.1)scale(23.0392 24.6224)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$ee4a42d747e74504 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy32Filled', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.06a8 8 0 0 0 6.75-5.95A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3zm13 11.95V7h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45M8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5z"
]);
const $cdb0ff5c001a8842$export$7a9ae08a32b45020 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy32Regular', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.06a8 8 0 0 0 6.75-5.95A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3zm13 5h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45zM8 13.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8zM10 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a6 6 0 0 1-12 0zm0 22.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v.5H10z"
]);
const $cdb0ff5c001a8842$export$c1490e417be0f0de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy48Color', "48", [
    [
        "path",
        {
            "fill": "#c55d5d",
            "d": "M22.75 37.5V32h2.5v5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_48_color__a)",
            "d": "M22.75 37.5V32h2.5v5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#d9d9d9",
            "d": "M31 36.5a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_48_color__b)",
            "d": "M31 36.5a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5z"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M28 10.75A2.75 2.75 0 0 1 30.75 8h8.5A2.75 2.75 0 0 1 42 10.75V17a7 7 0 1 1-14 0zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_48_color__c)",
            "fillRule": "evenodd",
            "d": "M28 10.75A2.75 2.75 0 0 1 30.75 8h8.5A2.75 2.75 0 0 1 42 10.75V17a7 7 0 1 1-14 0zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#d96a6a",
            "fillRule": "evenodd",
            "d": "M6 10.75A2.75 2.75 0 0 1 8.75 8h8.5A2.75 2.75 0 0 1 20 10.75V17a7 7 0 1 1-14 0zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_48_color__d)",
            "fillRule": "evenodd",
            "d": "M6 10.75A2.75 2.75 0 0 1 8.75 8h8.5A2.75 2.75 0 0 1 20 10.75V17a7 7 0 1 1-14 0zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M16 4a4 4 0 0 0-4 4v13a12 12 0 0 0 24 0V8a4 4 0 0 0-4-4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_48_color__e)",
            "d": "M16 4a4 4 0 0 0-4 4v13a12 12 0 0 0 24 0V8a4 4 0 0 0-4-4z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_48_color__a",
                "x1": "21.5",
                "x2": "29.9",
                "y1": "30.9",
                "y2": "44.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_48_color__b",
                "x1": "80",
                "x2": "70.34",
                "y1": "66.5",
                "y2": "23.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_48_color__c",
                "x1": "32.67",
                "x2": "45.5",
                "y1": "14.67",
                "y2": "14.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_48_color__d",
                "x1": "16.5",
                "x2": "2.5",
                "y1": "14.67",
                "y2": "14.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_48_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(228.05 25.07 7.85)scale(33.9071 36.3886)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $cdb0ff5c001a8842$export$f5272b63ebe598ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy48Filled', "48", [
    "M12 8c.14-2.23 1.99-4 4.25-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85a12 12 0 0 1-10.38 8.96v3.56H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12 12 0 0 1-10.38-8.96A6.9 6.9 0 0 1 6 17.13v-6.38A2.75 2.75 0 0 1 8.75 8zm0 2.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.24 10 21 12 21.4V10.5m24 10.91c2-.4 3.5-2.17 3.5-4.28v-6.38a.25.25 0 0 0-.25-.25H36v10.91"
]);
const $cdb0ff5c001a8842$export$bfbf5cbbb96257a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy48Regular', "48", [
    "M12 10.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.24 10 21 12 21.4V10.5m.37 13.48A6.9 6.9 0 0 1 6 17.13v-6.38A2.75 2.75 0 0 1 8.75 8h3.26c.13-2.23 1.98-4 4.24-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85a12 12 0 0 1-10.38 8.96v3.56H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12 12 0 0 1-10.38-8.96M36 21.41c2-.4 3.51-2.17 3.51-4.28v-6.38a.25.25 0 0 0-.25-.25H36v10.91M14.5 8.25V21a9.5 9.5 0 0 0 19 0V8.25c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75m0 33.25h19A2.5 2.5 0 0 0 31 39H17a2.5 2.5 0 0 0-2.5 2.5"
]);
const $cdb0ff5c001a8842$export$6ba920c8ce6049fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock16Filled', "16", [
    "M4 3h-.5C2.67 3 2 3.67 2 4.5v1a2.5 2.5 0 0 0 2.12 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h3.77A2 2 0 0 1 8 14v-4a2 2 0 0 1 1.5-1.94V8A3 3 0 0 1 12 5.04V4h.5c.28 0 .5.22.5.5v.54q.54.1 1 .36v-.9c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2m0 1v2.91c-.58-.2-1-.76-1-1.41v-1c0-.28.22-.5.5-.5zm6.5 4v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0m1 1V8a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $cdb0ff5c001a8842$export$dd53ba4c36022e80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock16Regular', "16", [
    "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v.9q-.46-.26-1-.36V4.5a.5.5 0 0 0-.5-.5H12v1.04q-.54.1-1 .36V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a3 3 0 0 0 3 3v3H6a1 1 0 0 0-1 1h3q0 .56.27 1H4.5a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1C2 3.67 2.67 3 3.5 3zm0 1h-.5a.5.5 0 0 0-.5.5v1c0 .65.42 1.2 1 1.41zm6.5 4v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0m1 1V8a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $cdb0ff5c001a8842$export$da8d777e9cb06c05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock20Filled', "20", [
    "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7q0 .68-.28 1.26-.45-.21-1-.25.27-.45.28-1V5.5a.5.5 0 0 0-.5-.5h-1v3.17a3 3 0 0 0-2 2.83v.06A2 2 0 0 0 11 13v.39q-.24.05-.5.08v1.5h.5V17q.01.53.25.97H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4zm0 1h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93zm8 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $cdb0ff5c001a8842$export$e171681079d3da08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock20Regular', "20", [
    "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h5.25A2 2 0 0 1 11 17v-.03H6.5a1 1 0 0 1 1-1H11v-1h-.5v-1.5q.26-.03.5-.08V13a2 2 0 0 1 .12-.68A3.5 3.5 0 0 1 6.5 9.16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.76a3 3 0 0 1 1-.59V5h1c.27 0 .5.22.5.5V7q0 .56-.27 1 .52.05 1 .26.26-.57.27-1.26V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5m9 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $cdb0ff5c001a8842$export$c0d0938d6bc8d18e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock24Filled', "24", [
    "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15q0 .65-.23 1.23a3.5 3.5 0 0 0-1.44-.46q.14-.3.17-.62V5.75a.3.3 0 0 0-.18-.24l-.06-.01H17.5v4.14A3.5 3.5 0 0 0 15 13v.05a2.5 2.5 0 0 0-2 2.45v.36l-.5.1v1.54h.5v3q.02.85.5 1.5H6.75a.75.75 0 0 1-.74-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.8 5.8 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2zM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73zM16 14v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5zm1.5-1v1h2v-1a1 1 0 1 0-2 0m2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $cdb0ff5c001a8842$export$91a7e141c431cabb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock24Regular', "24", [
    "M17.49 4a2.25 2.25 0 0 0-2.24-2h-7c-1.16 0-2.11.88-2.24 2H4.75C3.78 4 3 4.78 3 5.75v3C3 10.55 4.45 12 6.25 12h.02A5.8 5.8 0 0 0 11 15.95v1.55H9.07A3.25 3.25 0 0 0 6 20.76v.6c.06.37.37.65.75.65h6.75q-.48-.65-.5-1.5H7.52l.03-.15c.18-.77.87-1.35 1.7-1.35H13v-1.5h-.5v-1.55q.26-.03.5-.09v-.36q.01-.74.38-1.32a4.24 4.24 0 0 1-5.88-3.93v-6c0-.41.34-.75.75-.75h7c.42 0 .75.34.75.75v6.3a3.5 3.5 0 0 1 1.5-.9V5.5h1.31q.19.06.2.25V8.9q-.05.33-.18.62.78.06 1.44.46.23-.58.24-1.23V5.61C20.42 4.7 19.67 4 18.75 4zM4.75 5.5H6v4.98a1.75 1.75 0 0 1-1.5-1.73v-3c0-.14.1-.25.25-.25m13.75 5A2.5 2.5 0 0 0 16 13v1h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-2.5-2.5m0 1.5a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 1-1m0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $cdb0ff5c001a8842$export$7932c4ec533b4534 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock28Filled', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 1.27-.55 2.4-1.43 3.18a4 4 0 0 0-1.48-.78A2.8 2.8 0 0 0 23 9.75v-3a.25.25 0 0 0-.25-.25H20.5V12a4 4 0 0 0-4 4v.04A3 3 0 0 0 14 19v5c0 .77.29 1.47.76 2H8.25C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.8 6.8 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7zM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5M17.5 17v-1a3 3 0 1 1 6 0v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2zm1.5-1v1h3v-1a1.5 1.5 0 0 0-3 0m3 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
]);
const $cdb0ff5c001a8842$export$bf7656d15ac2daf6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock28Regular', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 1.27-.55 2.4-1.43 3.18a4 4 0 0 0-1.48-.78A2.8 2.8 0 0 0 23 9.75v-3a.25.25 0 0 0-.25-.25H20.5V12q-.8 0-1.5.3V4.74c0-.69-.56-1.25-1.25-1.25h-8c-.69 0-1.25.56-1.25 1.25v7.5a5.25 5.25 0 0 0 5.93 5.2Q14 18.16 14 19v3.5h-3.75c-.97 0-1.75.78-1.75 1.75v.25h5.54q.16.87.72 1.5H8.25C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.8 6.8 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7zM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5M17.5 17v-1a3 3 0 1 1 6 0v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2zm1.5-1v1h3v-1a1.5 1.5 0 0 0-3 0m3 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
]);
const $cdb0ff5c001a8842$export$f068ce8cd85fe70e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock32Filled', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h7.3q-.3-.7-.3-1.5v-6a4 4 0 0 1 3.08-3.9 5 5 0 0 1 6.87-3.7A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3zm13 11.95V7h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45M8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5zm13 13v-.5a3.5 3.5 0 1 1 7 0v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5zm2-.5v.5h3v-.5a1.5 1.5 0 0 0-3 0m3.5 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
]);
const $cdb0ff5c001a8842$export$97bd25e5c39a0904 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock32Regular', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h7.3q-.3-.7-.3-1.5V28H10v-.5c0-.83.67-1.5 1.5-1.5h5v-3.5c0-1.04.4-2 1.05-2.7A6 6 0 0 1 10 14V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9q0 .64-.13 1.25a5 5 0 0 1 4.58-.35A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3zm13 5h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45zM8 13.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8zM21 20v-.5a3.5 3.5 0 1 1 7 0v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5zm2-.5v.5h3v-.5a1.5 1.5 0 0 0-3 0m3.5 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
]);
const $cdb0ff5c001a8842$export$3d85e89f8e006ec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock48Filled', "48", [
    "M12 8c.14-2.23 1.99-4 4.25-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 2.14-.98 4.06-2.53 5.32a6.98 6.98 0 0 0-9.41 5.64A5 5 0 0 0 26 32.83q-.38.07-.75.1v3.57H26V43q0 .52.1 1H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12 12 0 0 1-10.38-8.96A6.9 6.9 0 0 1 6 17.13v-6.38A2.75 2.75 0 0 1 8.75 8zm0 2.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.24 10 21 12 21.4V10.5m24 10.91c2-.4 3.5-2.17 3.5-4.28v-6.38a.25.25 0 0 0-.25-.25H36v10.91M32 30v-1a5 5 0 0 1 10 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3zm2.5-1v1h5v-1a2.5 2.5 0 0 0-5 0m5.5 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0"
]);
const $cdb0ff5c001a8842$export$85d3d0868fa4b57a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock48Regular', "48", [
    "M12 10.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.24 10 21 12 21.4V10.5m.37 13.48A6.9 6.9 0 0 1 6 17.13v-6.38A2.75 2.75 0 0 1 8.75 8h3.26c.13-2.23 1.98-4 4.24-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 2.14-.98 4.06-2.53 5.32a7 7 0 0 0-6.2.62q.23-1 .23-2.07V8.25c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75V21a9.5 9.5 0 0 0 12.48 9.02 5 5 0 0 0-.98 2.81q-.38.07-.75.1v3.57H26V39h-9a2.5 2.5 0 0 0-2.5 2.5H26V43q0 .52.1 1H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12 12 0 0 1-10.38-8.96M36 21.41c2-.4 3.51-2.17 3.51-4.28v-6.38a.25.25 0 0 0-.25-.25H36v10.91M32 30v-1a5 5 0 0 1 10 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3zm2.5-1v1h5v-1a2.5 2.5 0 0 0-5 0m5.5 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0"
]);
const $cdb0ff5c001a8842$export$2d3eb183908d3bc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff16Filled', "16", [
    "m9.84 10.55 4.3 4.3a.5.5 0 0 0 .71-.7l-13-13a.5.5 0 1 0-.7.7L2.59 3.3c-.36.28-.6.71-.6 1.2v1a2.5 2.5 0 0 0 2.13 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V14a2 2 0 0 0-2-2H8.5v-1.03q.72-.09 1.34-.42M3.32 4.03l.68.68v2.2c-.58-.2-1-.76-1-1.41v-1q.02-.35.32-.47m8.56 3.94q-.17.68-.55 1.24L4.22 2.1A2 2 0 0 1 6 1h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-2.12 2.47M12 4v2.91c.58-.2 1-.76 1-1.41v-1a.5.5 0 0 0-.5-.5z"
]);
const $cdb0ff5c001a8842$export$1d06b0f6fdb909a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff16Regular', "16", [
    "M3.32 4.03A.5.5 0 0 0 3 4.5v1c0 .65.42 1.2 1 1.41v-2.2zM2.6 3.3 1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7l-4.3-4.3q-.63.32-1.35.42V12H10a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1c0-.49.23-.92.6-1.2m6.5 6.5-4.1-4.1V7a3 3 0 0 0 4.1 2.8m1.9-2.73q-.01.78-.38 1.41l.72.73q.38-.57.55-1.24A2.5 2.5 0 0 0 14 5.5v-1c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-1.78 1.1l.79.78A1 1 0 0 1 6 2h4a1 1 0 0 1 1 1zm1-.16V4h.5c.29 0 .5.22.5.5v1c0 .65-.4 1.2-1 1.41M5 14h6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1"
]);
const $cdb0ff5c001a8842$export$b55327acbcd90fbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5q.92-.11 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7zM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5q.02-.35.32-.47zm8.9 3.76a5 5 0 0 1-.7 1.6L5.57 3.46A2 2 0 0 1 7.5 2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97m.1-1.03A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1z"
]);
const $cdb0ff5c001a8842$export$744f652aefe6d572 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5q.92-.11 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7zm8.62 10.03q-.67.31-1.47.32a3.5 3.5 0 0 1-3.5-3.34V7.2zM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5q.02-.35.32-.47zm8 2.79q-.02 1.03-.53 1.85l.72.72q.5-.71.7-1.6A3 3 0 0 0 17 7V5.5c0-.83-.67-1.5-1.5-1.5h-.99a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.92 1.46l.92.92V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1zm1-4h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94zm-8 11.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1z"
]);
const $cdb0ff5c001a8842$export$b167640df9915dca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff24Filled', "24", [
    "M3.48 4.54 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.39-6.39q-.85.43-1.83.56v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07v.68c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.8 5.8 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3c0-.47.18-.9.48-1.2M6 7.06 4.54 5.6a.3.3 0 0 0-.04.15v3c0 .88.65 1.61 1.5 1.73zM17.23 12q-.24.75-.66 1.39L6.3 3.12A2.3 2.3 0 0 1 8.25 2h7c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24zm1.53-6.5H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.3.3 0 0 0-.18-.24z"
]);
const $cdb0ff5c001a8842$export$bb46332db634b7e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff24Regular', "24", [
    "M3.48 4.54 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.39-6.39q-.85.43-1.83.56v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07v.68c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.8 5.8 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3c0-.47.18-.9.48-1.2m9.71 9.71L7.5 8.56v1.69a4.25 4.25 0 0 0 5.69 4M6 7.06 4.54 5.6a.3.3 0 0 0-.04.15v3c0 .88.65 1.61 1.5 1.73zm10 3.19q-.01 1.12-.52 2.05l1.1 1.09q.41-.65.65-1.39h.21a3.25 3.25 0 0 0 3.07-3.25V5.61C20.42 4.7 19.67 4 18.75 4h-1.27a2.25 2.25 0 0 0-2.24-2h-7c-.83 0-1.56.45-1.95 1.12l1.2 1.2v-.07c0-.41.34-.75.75-.75h7c.42 0 .75.34.75.75zM9.25 19c-.83 0-1.52.58-1.7 1.35l-.03.15h8.47A1.75 1.75 0 0 0 14.4 19H9.25m9.5-13.5h.07q.17.06.19.25V8.9c-.08.82-.7 1.47-1.5 1.58V5.5z"
]);
const $cdb0ff5c001a8842$export$754e8f54b5957d73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff28Filled', "28", [
    "M4.07 5.14 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06l-7.65-7.65a7 7 0 0 1-2.57.83V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.8 6.8 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3c0-.73.44-1.35 1.07-1.61M7 8.06 5.44 6.5h-.69a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V8.06m.12-4.12L19.3 16.11q.67-.96.98-2.11a4.25 4.25 0 0 0 4.23-4.25v-3c0-.97-.78-1.75-1.75-1.75H20.5v-.25A2.75 2.75 0 0 0 17.75 2h-8c-1.24 0-2.28.82-2.63 1.94m13.38 8.55V6.5h2.25c.14 0 .25.11.25.25v3c0 1.44-1.1 2.61-2.5 2.74"
]);
const $cdb0ff5c001a8842$export$8a7f6edc9485986 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff28Regular', "28", [
    "M4.07 5.14 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06l-7.65-7.65a7 7 0 0 1-2.57.83V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.8 6.8 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3c0-.73.44-1.35 1.07-1.61m11.89 11.88L8.5 9.56v2.69a5.25 5.25 0 0 0 7.46 4.77M7 8.06 5.44 6.5h-.69a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V8.06m.12-4.12L8.5 5.32v-.57c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v7.5c0 1.02-.3 1.97-.8 2.78l1.09 1.08q.67-.96.98-2.11a4.25 4.25 0 0 0 4.23-4.25v-3c0-.97-.78-1.75-1.75-1.75H20.5v-.25A2.75 2.75 0 0 0 17.75 2h-8c-1.24 0-2.28.82-2.63 1.94m13.38 8.55V6.5h2.25c.14 0 .25.11.25.25v3c0 1.44-1.1 2.61-2.5 2.74m-12 11.76v.25H19v-.25c0-.97-.78-1.75-1.75-1.75h-7c-.97 0-1.75.78-1.75 1.75"
]);
const $cdb0ff5c001a8842$export$ef0380a2b86905f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff32Filled', "32", [
    "M4.54 5.95 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-8.6-8.6q-1.25.63-2.7.83V24h3.5a3.5 3.5 0 0 1 3.5 3.5v1c0 .83-.66 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 8 28.5v-1a3.5 3.5 0 0 1 3.5-3.5H15v-2.06a8 8 0 0 1-6.74-5.95A4.5 4.5 0 0 1 4 11.5v-4q.01-.9.54-1.55M8 9.41l-2-2v4.09a2.5 2.5 0 0 0 2 2.45zM23.75 16q-.41 1.58-1.38 2.85L8.04 4.5A3 3 0 0 1 11 2h10a3 3 0 0 1 3 3h1.5A2.5 2.5 0 0 1 28 7.5v4a4.5 4.5 0 0 1-4.25 4.5m.25-2.04a2.5 2.5 0 0 0 2-2.45v-4a.5.5 0 0 0-.5-.5H24z"
]);
const $cdb0ff5c001a8842$export$4b0b4756d4b51416 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff32Regular', "32", [
    "M4.54 5.95 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-8.6-8.6q-1.25.63-2.7.83V24h3.5a3.5 3.5 0 0 1 3.5 3.5v1c0 .83-.66 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 8 28.5v-1a3.5 3.5 0 0 1 3.5-3.5H15v-2.06a8 8 0 0 1-6.74-5.95A4.5 4.5 0 0 1 4 11.5v-4q.01-.9.54-1.55M18.18 19.6 10 11.41V14a6 6 0 0 0 8.18 5.6M8 9.41l-2-2v4.09a2.5 2.5 0 0 0 2 2.45zM22 14c0 1.26-.4 2.44-1.06 3.4l1.43 1.44q.97-1.27 1.38-2.85A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11a3 3 0 0 0-2.96 2.5L10 6.46V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zm2-7h1.5c.27 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45zM10 27.5v.5h12v-.5c0-.83-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5"
]);
const $cdb0ff5c001a8842$export$ff7e98afeec242a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff48Filled', "48", [
    "M6.93 8.7 4.37 6.12a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76l-12.1-12.1a12 12 0 0 1-4.52 1.4v3.57H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12 12 0 0 1-10.38-8.96A6.9 6.9 0 0 1 6 17.13v-6.38c0-.82.36-1.55.93-2.06M12 13.76 8.73 10.5a.25.25 0 0 0-.23.25v6.38C8.5 19.24 10 21 12 21.4v-7.64m23.63 10.21a12 12 0 0 1-2.07 4.28L12.2 6.9A4.25 4.25 0 0 1 16.26 4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85m.36-2.57c2-.4 3.51-2.17 3.51-4.28v-6.38a.25.25 0 0 0-.25-.25H36v10.91"
]);
const $cdb0ff5c001a8842$export$361c6f73d83031ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff48Regular', "48", [
    "M6.93 8.7 4.37 6.12a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76l-12.1-12.1a12 12 0 0 1-4.52 1.4v3.57H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12 12 0 0 1-10.38-8.96A6.9 6.9 0 0 1 6 17.13v-6.38c0-.82.36-1.55.93-2.06M27.9 29.66l-13.4-13.4V21a9.5 9.5 0 0 0 13.4 8.67M12 13.77 8.73 10.5a.25.25 0 0 0-.23.25v6.38C8.5 19.24 10 21 12 21.4v-7.64M33.5 21c0 2.04-.64 3.92-1.73 5.47l1.79 1.79q1.44-1.9 2.07-4.28A6.9 6.9 0 0 0 42 17.13v-6.38A2.75 2.75 0 0 0 39.25 8h-3.26a4.25 4.25 0 0 0-4.24-4h-15.5a4.25 4.25 0 0 0-4.03 2.91L14.5 9.2v-.95c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75zm2.5.41V10.5h3.25q.23.02.25.25v6.38c0 2.11-1.5 3.88-3.5 4.28M33.5 41.5A2.5 2.5 0 0 0 31 39H17a2.5 2.5 0 0 0-2.5 2.5z"
]);
const $cdb0ff5c001a8842$export$340f1e7ad13e94a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork16Filled', "16", [
    "M2.92 4.78a.75.75 0 1 1 1.16.94L2.22 8l1.86 2.28a.75.75 0 0 1-1.16.95L.67 8.48a.75.75 0 0 1 0-.95zm9.1-.11a.75.75 0 0 1 1.06.1l2.25 2.76c.23.27.23.67 0 .95l-2.25 2.75a.75.75 0 0 1-1.16-.95L13.78 8l-1.86-2.28a.75.75 0 0 1 .1-1.05m-.9 2.46a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75m-6.24 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75m3.12 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75"
]);
const $cdb0ff5c001a8842$export$2bdf075e9711e04c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork16Regular', "16", [
    "M3.12 4.68a.5.5 0 0 1 .76.64L1.65 8l2.23 2.68a.5.5 0 0 1-.76.64l-2.5-3a.5.5 0 0 1 0-.64zm9.06-.06a.5.5 0 0 1 .7.06l2.5 3a.5.5 0 0 1 0 .64l-2.5 3a.5.5 0 0 1-.76-.64L14.35 8l-2.23-2.68a.5.5 0 0 1 .06-.7m-1.05 2.51a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75m-6.25 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75m3.12 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75"
]);
const $cdb0ff5c001a8842$export$796f97bce9120978 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork20Filled', "20", [
    "M4.7 6.16c.34.25.4.72.14 1.05L2.7 10l2.14 2.8a.75.75 0 1 1-1.18.9l-2.5-3.24a.75.75 0 0 1 0-.92l2.5-3.25a.75.75 0 0 1 1.05-.13m10.46 6.63a.75.75 0 1 0 1.18.92l2.5-3.25c.21-.27.21-.65 0-.92l-2.5-3.25a.75.75 0 1 0-1.18.92L17.3 10zM6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $cdb0ff5c001a8842$export$5014b1422dd0f5b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork20Regular', "20", [
    "M4.83 6.12c.2.18.23.5.05.7L2.16 10l2.72 3.17a.5.5 0 1 1-.76.66l-3-3.5a.5.5 0 0 1 0-.66l3-3.5a.5.5 0 0 1 .7-.05m10.29 7.05a.5.5 0 0 0 .76.66l3-3.5a.5.5 0 0 0 0-.66l-3-3.5a.5.5 0 1 0-.76.66L17.84 10zM6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $cdb0ff5c001a8842$export$b474be5c20aad14e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork24Filled', "24", [
    "M4.47 7.37a1 1 0 0 1 1.56 1.26L3.29 12l2.74 3.37a1 1 0 0 1-1.56 1.26l-3.25-4a1 1 0 0 1 0-1.26zm13.65-.15a1 1 0 0 1 1.4.15l3.26 4c.3.37.3.9 0 1.26l-3.25 4a1 1 0 0 1-1.56-1.26L20.71 12l-2.74-3.37a1 1 0 0 1 .15-1.4M7.5 10.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $cdb0ff5c001a8842$export$ca62d1fae4e41932 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork24Regular', "24", [
    "M4.67 7.27a.75.75 0 0 1 1.16.96L2.73 12l3.1 3.77a.75.75 0 0 1-1.16.96l-3.5-4.25a.75.75 0 0 1 0-.96zm13.6-.1a.75.75 0 0 1 1.06.1l3.5 4.25c.23.28.23.68 0 .96l-3.5 4.25a.75.75 0 0 1-1.16-.96l3.1-3.77-3.1-3.77a.75.75 0 0 1 .1-1.06M7.5 10.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $cdb0ff5c001a8842$export$a54a36f28ca6374e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkToolbox20Filled', "20", [
    "M4.84 7.2a.75.75 0 0 0-1.18-.9l-2.5 3.24c-.21.27-.21.65 0 .92l2.5 3.25a.75.75 0 1 0 1.18-.92L2.7 10zm13.12 3.84a2.5 2.5 0 0 0-1.13-1.66l-1.67-2.17a.75.75 0 1 1 1.18-.92l2.5 3.25c.21.27.21.65 0 .92l-.52.68zM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $cdb0ff5c001a8842$export$3d496de34945c943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkToolbox20Regular', "20", [
    "M4.88 6.83a.5.5 0 1 0-.76-.66l-3 3.5a.5.5 0 0 0 0 .66l3 3.5a.5.5 0 1 0 .76-.66L2.16 10zm13.08 4.21q-.09-.45-.31-.82l.2-.22-2.73-3.17a.5.5 0 0 1 .76-.66l3 3.5a.5.5 0 0 1 0 .66l-.67.77zM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);


"use client";
const $e9fce37105e983ce$export$a45eba228fd53bbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_16_color__a)",
            "d": "m10.12 5.54-.87-.49-2.19 3.87.87.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_16_color__b)",
            "d": "M3.88 12.5 6 13.56l1.71-1.2 1.79 1.2 2-.7h.8a4.5 4.5 0 1 0-9 .2l.58-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_16_color__c)",
            "d": "M4.12 11.75a.5.5 0 0 1 .5.34 1.42 1.42 0 0 0 2.72.06.5.5 0 0 1 .94 0A1.42 1.42 0 0 0 11 12.1a.5.5 0 0 1 .95 0c.24.74.95 1.2 1.67 1.2a.5.5 0 1 1 0 1 2.8 2.8 0 0 1-2.14-1.01 2.4 2.4 0 0 1-3.67.04 2.4 2.4 0 0 1-3.62.02q-.26.36-.63.58c-.5.3-1.06.38-1.56.38a.5.5 0 0 1 0-1 2 2 0 0 0 1.04-.23c.26-.16.49-.43.61-.94a.5.5 0 0 1 .47-.38"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_16_color__d)",
            "d": "M12.66 7.8a.5.5 0 0 0 .69-.2l.1-.17A4.33 4.33 0 0 0 11.9 1.6a4.14 4.14 0 0 0-5.73 1.6l-.1.19a.5.5 0 0 0 .18.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_16_color__e)",
            "d": "M12.01 1.65c.22 1 .06 3.27-1.03 5.15L8.25 5.22a8 8 0 0 1 3.76-3.57"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_16_color__a",
                "x1": "7.68",
                "x2": "10.43",
                "y1": "8.26",
                "y2": "4.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cd3e1d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#592a00"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_16_color__b",
                "x1": "7.27",
                "x2": "7.27",
                "y1": "12.75",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc7a3"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_16_color__c",
                "x1": "7.82",
                "x2": "7.82",
                "y1": "13.87",
                "y2": "11.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_16_color__d",
                "x1": "13.16",
                "x2": "6.97",
                "y1": "9.2",
                "y2": "1.16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb6f7b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_16_color__e",
                "x1": "11.93",
                "x2": "8.54",
                "y1": "4.78",
                "y2": "3.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fecbe6"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fdafd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$6e3d06519eb8757f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach16Filled', "16", [
    "M11.91 1.56a4.2 4.2 0 0 0-5.69 1.52l-.15.26a.5.5 0 0 0 .18.68L8.9 5.54 7.27 8.4a4.9 4.9 0 0 0-3.46 2.4 1.5 1.5 0 0 1 1.75.99q.1.24.2.29.1.07.23.07a.4.4 0 0 0 .23-.06q.08-.04.17-.25a1.5 1.5 0 0 1 2.84 0q.08.2.17.25a.4.4 0 0 0 .23.06q.13 0 .23-.07a.6.6 0 0 0 .2-.3 1.5 1.5 0 0 1 1.75-.98A5 5 0 0 0 8.4 8.4l1.36-2.36 2.84 1.63a.5.5 0 0 0 .68-.18l.15-.26a4.14 4.14 0 0 0-1.53-5.67m-7.3 10.53a.5.5 0 0 0-.96.04c-.12.51-.35.78-.6.94A2 2 0 0 1 2 13.3a.5.5 0 1 0 0 1c.5 0 1.07-.08 1.56-.38q.37-.22.63-.58a2.4 2.4 0 0 0 3.62-.02 2.4 2.4 0 0 0 3.67-.04 2.8 2.8 0 0 0 2.14 1.02.5.5 0 0 0 0-1c-.72 0-1.43-.47-1.67-1.2a.5.5 0 0 0-.95 0 1.42 1.42 0 0 1-2.72.05.5.5 0 0 0-.94 0 1.42 1.42 0 0 1-2.73-.06"
]);
const $e9fce37105e983ce$export$d8dd6eb783dbbbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach16Regular', "16", [
    "M11.91 1.56a4.2 4.2 0 0 0-5.69 1.52l-.15.26a.5.5 0 0 0 .18.68L8.9 5.54 7.27 8.4a4.9 4.9 0 0 0-3.46 2.4 1.5 1.5 0 0 1 1.09.17 3.7 3.7 0 0 1 2.9-1.6 3.7 3.7 0 0 1 2.92 1.6 1.5 1.5 0 0 1 1.09-.17A5 5 0 0 0 8.4 8.4l1.36-2.36 2.84 1.63a.5.5 0 0 0 .68-.18l.15-.26a4.14 4.14 0 0 0-1.53-5.67M7.2 3.4a3.2 3.2 0 0 1 3.42-1.31q-.56.28-.99.6c-.5.39-.89.82-1.3 1.36zm3.03.1q.4-.32 1.03-.61.08.59.02 1.07c-.06.44-.2.9-.53 1.48L9.2 4.56a5 5 0 0 1 1.02-1.06m2.45 3.05-1.06-.61a4.67 4.67 0 0 0 .67-2.8c.77.94.96 2.27.39 3.4M4.6 12.09a.5.5 0 0 0-.96.04c-.12.51-.35.78-.6.94A2 2 0 0 1 2 13.3a.5.5 0 1 0 0 1c.5 0 1.07-.08 1.56-.38q.37-.22.63-.58a2.4 2.4 0 0 0 3.62-.02 2.4 2.4 0 0 0 3.67-.04 2.8 2.8 0 0 0 2.14 1.02.5.5 0 0 0 0-1c-.72 0-1.43-.47-1.67-1.2a.5.5 0 0 0-.95 0 1.42 1.42 0 0 1-2.72.05.5.5 0 0 0-.94 0 1.42 1.42 0 0 1-2.73-.06"
]);
const $e9fce37105e983ce$export$94a9f6f51de3122c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_20_color__a)",
            "d": "m13.12 8.06-.87-.5-2.68 4.73.87.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_20_color__b)",
            "d": "M4.86 16.42 7 17.5l2.39-.94 2.61.94 2.13-1 1.12.7a5.75 5.75 0 1 0-11.5.26z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_20_color__c)",
            "d": "M14.2 14.75c-.32 0-.6.2-.7.51-.57 1.7-2.74 1.68-3.3.09a.75.75 0 0 0-.7-.5c-.33 0-.6.2-.7.5-.55 1.59-2.72 1.63-3.29-.07a.74.74 0 0 0-.73-.5.8.8 0 0 0-.7.55v.01c-.16.64-.44.95-.74 1.13q-.49.29-1.28.3a.75.75 0 0 0-.74.74c0 .4.34.74.74.74.66 0 1.4-.11 2.05-.5q.44-.26.77-.68a3.2 3.2 0 0 0 4.63-.04 3.2 3.2 0 0 0 4.7-.07c.7.8 1.72 1.25 2.74 1.25.42 0 .75-.34.75-.74s-.34-.75-.75-.75c-.88 0-1.74-.57-2.03-1.46a.75.75 0 0 0-.72-.51"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_20_color__d)",
            "d": "M16.5 10.37a.5.5 0 0 0 .68-.18l.18-.31c1.42-2.5.6-5.63-1.9-7.05a5.2 5.2 0 0 0-7.1 1.94l-.18.3a.5.5 0 0 0 .19.68z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_20_color__e)",
            "d": "M15.66 2.96c-1.16.38-3.41 1.96-4.66 4.3l3.37 1.9c1.36-2.27 1.56-5.01 1.29-6.2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_20_color__a",
                "x1": "10.29",
                "x2": "13.76",
                "y1": "11.47",
                "y2": "7.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cd3e1d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#592a00"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_20_color__b",
                "x1": "9.5",
                "x2": "9.5",
                "y1": "16.65",
                "y2": "11.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc7a3"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_20_color__c",
                "x1": "9.52",
                "x2": "9.52",
                "y1": "17.5",
                "y2": "15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_20_color__d",
                "x1": "17.02",
                "x2": "9.6",
                "y1": "12",
                "y2": "2.12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb6f7b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_20_color__e",
                "x1": "15.56",
                "x2": "11.38",
                "y1": "6.73",
                "y2": "5.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fecbe6"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fdafd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$97aaa419ab56931b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach20Filled', "20", [
    "M15.39 2.7a5.2 5.2 0 0 0-7.13 1.9l-.2.35a.5.5 0 0 0 .19.68l3.83 2.21-2.1 3.68-.48-.02a6 6 0 0 0-4.83 2.75h.03a1.5 1.5 0 0 1 1.49 1.03c.35 1.05 1.58.98 1.9.07a1.5 1.5 0 0 1 2.83 0c.31.9 1.54.98 1.9-.07a1.5 1.5 0 0 1 1.51-1.03 6.3 6.3 0 0 0-3.31-2.52l1.93-3.39 3.47 2a.5.5 0 0 0 .68-.18l.2-.34a5.2 5.2 0 0 0-1.91-7.12M5.24 15.6a.5.5 0 0 0-.96.03c-.17.7-.5 1.08-.86 1.3q-.58.33-1.42.32a.5.5 0 0 0 0 1c.64 0 1.33-.1 1.94-.47q.52-.3.88-.87a2.96 2.96 0 0 0 4.68-.01 2.96 2.96 0 0 0 4.74-.06c.64.9 1.7 1.41 2.76 1.41a.5.5 0 1 0 0-1c-.98 0-1.96-.64-2.29-1.65a.5.5 0 0 0-.95 0 1.98 1.98 0 0 1-3.79.07.5.5 0 0 0-.94 0 1.98 1.98 0 0 1-3.8-.08"
]);
const $e9fce37105e983ce$export$9c9e74f6351b783e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach20Regular', "20", [
    "M8.26 4.6a5.21 5.21 0 0 1 9.03 5.22l-.2.34a.5.5 0 0 1-.67.19l-3.47-2-1.93 3.38c1.34.4 2.5 1.33 3.31 2.52h-.09q-.52 0-.92.31A4.9 4.9 0 0 0 9.5 12.5a4.9 4.9 0 0 0-3.82 2.06 1.5 1.5 0 0 0-1.01-.3 6 6 0 0 1 5.31-2.74l2.1-3.68-3.83-2.2a.5.5 0 0 1-.18-.7zm.92.42 1.7.98.02-.02a8 8 0 0 1 3.27-2.74 4.2 4.2 0 0 0-4.99 1.78M14 7.8c.47-.82.7-1.46.77-2.09a6 6 0 0 0-.06-1.62 6.96 6.96 0 0 0-2.95 2.41zm.87.5 1.61.93a4.2 4.2 0 0 0-.74-5.02q.12.84.02 1.63c-.1.79-.38 1.56-.89 2.46m-9.63 7.3a.5.5 0 0 0-.96.03c-.17.7-.5 1.08-.86 1.3q-.58.33-1.42.32a.5.5 0 0 0 0 1c.64 0 1.33-.1 1.94-.47q.52-.3.88-.87a2.96 2.96 0 0 0 4.68-.01 2.96 2.96 0 0 0 4.74-.06c.64.9 1.7 1.41 2.76 1.41a.5.5 0 1 0 0-1c-.98 0-1.96-.64-2.29-1.65a.5.5 0 0 0-.95 0 1.98 1.98 0 0 1-3.79.07.5.5 0 0 0-.94 0 1.98 1.98 0 0 1-3.8-.08"
]);
const $e9fce37105e983ce$export$e5616a64938109da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_24_color__a)",
            "d": "m16.55 7.8-1.3-.74-4.32 7.6 1.3.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_24_color__b)",
            "d": "m6.35 19.45 2.46 1.61 3.05-1.46 3.05 1.38 2.72-1.45 1.37.77a6.3 6.3 0 0 0-3.54-5.41c-3.36-1.73-7.65-.66-9.56 2.38a5.7 5.7 0 0 0-.9 3.32l1.35-1.15"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_24_color__c)",
            "d": "M17.92 18.06a.9.9 0 0 0-.84.6c-.72 2.21-3.54 2.18-4.26.12a.9.9 0 0 0-.83-.6c-.39 0-.7.25-.82.6-.71 2.06-3.53 2.1-4.26-.09a.9.9 0 0 0-.87-.6c-.4.01-.72.32-.82.66v.01c-.2.82-.56 1.23-.96 1.47q-.65.36-1.64.37c-.49 0-.87.4-.87.87 0 .48.4.88.87.88.82 0 1.75-.14 2.55-.62q.57-.35 1-.9a3.97 3.97 0 0 0 5.83-.06 3.96 3.96 0 0 0 5.91-.08 4.6 4.6 0 0 0 3.47 1.6c.49 0 .87-.4.87-.87s-.4-.87-.87-.87a2.8 2.8 0 0 1-2.63-1.88.9.9 0 0 0-.83-.6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_24_color__d)",
            "d": "M19.65 12.81a1 1 0 0 0 1.36-.37l.07-.12c1.89-3.33.8-7.5-2.54-9.4A6.94 6.94 0 0 0 9.07 5.5l-.2.33c-.2.36-.08.82.29 1.03z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_24_color__e)",
            "d": "M18.62 2.97c-1.55.5-4.55 2.62-6.22 5.73l4.5 2.55c1.81-3.03 2.08-6.69 1.72-8.28"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_24_color__a",
                "x1": "12.07",
                "x2": "17.74",
                "y1": "13.33",
                "y2": "7.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cd3e1d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#592a00"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_24_color__b",
                "x1": "12",
                "x2": "12",
                "y1": "19.7",
                "y2": "14.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc7a3"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_24_color__c",
                "x1": "12.01",
                "x2": "12.01",
                "y1": "21.47",
                "y2": "18.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_24_color__d",
                "x1": "20.62",
                "x2": "10.73",
                "y1": "15.15",
                "y2": "1.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb6f7b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_24_color__e",
                "x1": "18.48",
                "x2": "12.91",
                "y1": "8.01",
                "y2": "6.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fecbe6"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fdafd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$47a3f7a13360307e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach24Filled', "24", [
    "M18.57 2.85a6.75 6.75 0 0 0-9.22 2.47l-.25.43c-.2.36-.08.82.28 1.03L13.9 9.4l-2.8 4.9a7.8 7.8 0 0 0-4.79 2.61 2 2 0 0 1 1.58 1.37c.24.73.73.95 1.12.96.4 0 .86-.22 1.08-.87a2 2 0 0 1 3.8 0c.22.65.68.87 1.08.87s.88-.23 1.12-.96a2 2 0 0 1 1.58-1.37 7.8 7.8 0 0 0-4.84-2.61l2.37-4.15 4.56 2.63c.36.2.81.08 1.02-.28l.25-.43a6.75 6.75 0 0 0-2.47-9.22M6.71 18.65a.75.75 0 0 0-1.44.07c-.21.89-.6 1.36-1.04 1.63q-.7.42-1.73.4a.75.75 0 0 0 0 1.5c.82 0 1.73-.13 2.52-.63q.62-.38 1.06-1.03a3.8 3.8 0 0 0 5.92-.02 3.82 3.82 0 0 0 6-.08 4.5 4.5 0 0 0 3.5 1.76.75.75 0 1 0 0-1.5c-1.18 0-2.38-.8-2.78-2.08a.75.75 0 0 0-1.43-.01c-.79 2.44-3.81 2.4-4.58.1a.75.75 0 0 0-1.42 0c-.77 2.3-3.8 2.34-4.58-.1"
]);
const $e9fce37105e983ce$export$7e878b005793d4c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach24Regular', "24", [
    "M9.35 5.32a6.75 6.75 0 0 1 11.7 6.75l-.26.43a.75.75 0 0 1-1.02.28l-4.56-2.63-2.37 4.15a7.8 7.8 0 0 1 4.84 2.61 2 2 0 0 0-1.3.8A6.1 6.1 0 0 0 12 15.76c-1.67 0-3.21.76-4.38 1.97a2 2 0 0 0-1.3-.8 7.8 7.8 0 0 1 4.78-2.61l2.81-4.91-4.53-2.62a.75.75 0 0 1-.28-1.03zm1.43.54 1.97 1.13c.53-.82 1.07-1.49 1.74-2.1q.77-.7 1.83-1.32a5.25 5.25 0 0 0-5.54 2.29m5.81 3.35c.55-1 .82-1.79.92-2.55.07-.62.04-1.26-.07-2.01a8.86 8.86 0 0 0-3.4 3.1zm1.3.75 1.97 1.14a5.25 5.25 0 0 0-.85-6.02q.09.9-.02 1.76c-.12 1.01-.47 2-1.1 3.12M6.7 18.66a.75.75 0 0 0-1.44.06c-.21.89-.6 1.36-1.04 1.63q-.7.42-1.73.4a.75.75 0 0 0 0 1.5c.82 0 1.73-.13 2.52-.63q.62-.38 1.06-1.03a3.8 3.8 0 0 0 5.92-.02 3.82 3.82 0 0 0 6-.08 4.5 4.5 0 0 0 3.5 1.76.75.75 0 1 0 0-1.5c-1.18 0-2.38-.8-2.78-2.08a.75.75 0 0 0-1.43-.01c-.79 2.44-3.81 2.4-4.58.1a.75.75 0 0 0-1.42 0c-.77 2.3-3.8 2.34-4.58-.1"
]);
const $e9fce37105e983ce$export$6426a29e24cafdb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_28_color__a)",
            "d": "m19.68 8.89-1.3-.74-4.97 8.74 1.3.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_28_color__b)",
            "d": "m7.09 22.37 3.41 2.89 3-2 4.32 1.65L21 22.76l1 .63a7.4 7.4 0 0 0-4.18-6.41c-3.96-2.04-9-.78-11.25 2.81a7 7 0 0 0-1.06 3.94z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_28_color__c)",
            "d": "M21.03 21.45a1 1 0 0 0-.94.69c-.87 2.65-4.26 2.61-5.13.13a1 1 0 0 0-.94-.67c-.44 0-.8.28-.93.67a2.67 2.67 0 0 1-5.13-.1 1 1 0 0 0-.98-.68 1 1 0 0 0-.92.75c-.24.98-.68 1.48-1.16 1.77-.5.3-1.19.43-1.97.45a1 1 0 0 0-.98.98 1 1 0 0 0 .99.99 6 6 0 0 0 2.98-.73q.7-.4 1.2-1.1a4.65 4.65 0 0 0 6.91-.06 4.64 4.64 0 0 0 7-.1 5.4 5.4 0 0 0 4.1 1.93c.55 0 .99-.45.99-.99a1 1 0 0 0-.99-.98c-1.36 0-2.7-.88-3.15-2.26a1 1 0 0 0-.95-.69"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_28_color__d)",
            "d": "M23.47 14.15a1 1 0 0 0 1.36-.37l.14-.24c2.11-3.72.89-8.4-2.85-10.52a7.76 7.76 0 0 0-10.59 2.9l-.26.44c-.2.37-.08.82.29 1.03z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_28_color__e)",
            "d": "M22.43 3.21c-1.74.57-5.09 2.94-6.96 6.42l5.04 2.85c2.02-3.4 2.33-7.49 1.92-9.27"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_28_color__a",
                "x1": "14.68",
                "x2": "21.36",
                "y1": "15.32",
                "y2": "8.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cd3e1d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#592a00"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_28_color__b",
                "x1": "13.75",
                "x2": "13.75",
                "y1": "22.67",
                "y2": "16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc7a3"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_28_color__c",
                "x1": "14.05",
                "x2": "14.05",
                "y1": "25.43",
                "y2": "21.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_28_color__d",
                "x1": "24.45",
                "x2": "13.39",
                "y1": "16.71",
                "y2": "1.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb6f7b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_28_color__e",
                "x1": "22.28",
                "x2": "16.05",
                "y1": "8.85",
                "y2": "6.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fecbe6"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fdafd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$ec2df341da2a9064 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach28Filled', "28", [
    "M22.15 2.98A7.7 7.7 0 0 0 11.64 5.8l-.29.5a.75.75 0 0 0 .28 1.02l5.46 3.15-3.27 5.72h-.07c-3.16 0-5.9 1.84-7.52 4.42a2 2 0 0 1 2.56 1.26c.6 1.8 2.77 1.7 3.32.1a2 2 0 0 1 3.78 0c.55 1.6 2.72 1.7 3.32-.1a2 2 0 0 1 2-1.37 9.3 9.3 0 0 0-5.77-4.13l2.95-5.15 5.27 3.05a.75.75 0 0 0 1.02-.28l.3-.5a7.7 7.7 0 0 0-2.83-10.51M7.61 22.26a.75.75 0 0 0-1.44.06c-.26 1.04-.74 1.62-1.3 1.95a4 4 0 0 1-2.12.48.75.75 0 0 0 0 1.5c.96 0 2-.15 2.9-.7q.8-.46 1.33-1.3a4.45 4.45 0 0 0 7.02-.03 4.45 4.45 0 0 0 7.1-.09 5.2 5.2 0 0 0 4.15 2.12.75.75 0 1 0 0-1.5 3.6 3.6 0 0 1-3.43-2.48.75.75 0 0 0-1.43 0 2.96 2.96 0 0 1-5.68.12.75.75 0 0 0-1.42 0 2.96 2.96 0 0 1-5.68-.13"
]);
const $e9fce37105e983ce$export$115456d5f6b67e6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach28Regular', "28", [
    "M22.15 2.98A7.7 7.7 0 0 0 11.64 5.8l-.29.5a.75.75 0 0 0 .28 1.02l5.46 3.15-3.27 5.72h-.07c-3.16 0-5.9 1.84-7.52 4.42a2 2 0 0 1 1.7.18 7.4 7.4 0 0 1 5.82-3.1c2.4 0 4.6 1.34 6 3.34a2 2 0 0 1 1.45-.53 9.3 9.3 0 0 0-5.76-4.13l2.95-5.15 5.27 3.05a.75.75 0 0 0 1.02-.28l.3-.5a7.7 7.7 0 0 0-2.83-10.51m-2.19 7.42-3.15-1.82c.57-.88 1.11-1.55 1.77-2.14.63-.58 1.39-1.1 2.42-1.67.15.95.2 1.75.1 2.53-.12.93-.45 1.9-1.14 3.1m1.3.75a10 10 0 0 0 1.33-3.67 10 10 0 0 0-.03-2.34 6.2 6.2 0 0 1 1.2 7.45zm-3.7-5.82c-.78.71-1.42 1.51-2.05 2.5L13.03 6.4a6.2 6.2 0 0 1 6.88-2.74c-.92.53-1.68 1.06-2.34 1.67M7.62 22.26a.75.75 0 0 0-1.44.06c-.26 1.04-.74 1.62-1.3 1.95a4 4 0 0 1-2.12.48.75.75 0 0 0 0 1.5c.96 0 2-.15 2.9-.7q.8-.46 1.33-1.3a4.45 4.45 0 0 0 7.02-.03 4.45 4.45 0 0 0 7.1-.09 5.2 5.2 0 0 0 4.15 2.12.75.75 0 1 0 0-1.5 3.6 3.6 0 0 1-3.43-2.48.75.75 0 0 0-1.43 0 2.96 2.96 0 0 1-5.68.12.75.75 0 0 0-1.42 0 2.96 2.96 0 0 1-5.68-.13"
]);
const $e9fce37105e983ce$export$644c1984b41e7fc7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_32_color__a)",
            "d": "m22.27 10.18-1.52-.87-5.79 10.2 1.52.86z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_32_color__b)",
            "d": "m7.88 25.22 3.24 3.5 4.87-1.97 4.57 1.33 3.76-2.43 1.18.71c-.05-2.9-1.82-5.72-4.94-7.26-4.68-2.3-10.64-.87-13.3 3.2A7.5 7.5 0 0 0 6 26.74l1.87-1.55z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_32_color__c)",
            "d": "M24.03 24.55c-.5 0-.92.32-1.07.78a3.2 3.2 0 0 1-6.15.16 1.1 1.1 0 0 0-1.08-.77c-.5 0-.9.32-1.05.76a3.2 3.2 0 0 1-6.15-.11c-.16-.47-.61-.79-1.12-.77-.51 0-.92.4-1.05.85-.29 1.17-.81 1.77-1.39 2.12-.6.37-1.43.52-2.35.54-.63 0-1.12.51-1.12 1.12 0 .6.51 1.12 1.12 1.12a7 7 0 0 0 3.51-.85 5 5 0 0 0 1.45-1.34 5.45 5.45 0 0 0 8.17-.07 5.44 5.44 0 0 0 8.28-.11 6.4 6.4 0 0 0 4.85 2.3c.63 0 1.12-.52 1.12-1.12s-.51-1.12-1.12-1.12a4 4 0 0 1-3.77-2.7 1.1 1.1 0 0 0-1.08-.79"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_32_color__d)",
            "d": "M27.13 16.5a1 1 0 0 0 1.36-.36l.25-.45A9.1 9.1 0 0 0 25.37 3.2 9.2 9.2 0 0 0 12.8 6.64l-.38.66c-.2.36-.08.82.29 1.03z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_32_color__e)",
            "d": "M25.25 3.15c-2.06.67-6.04 3.48-8.25 7.6l5.97 3.4c2.4-4.03 2.77-8.89 2.28-11"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_32_color__a",
                "x1": "16.44",
                "x2": "24.23",
                "y1": "17.68",
                "y2": "9.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cd3e1d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#592a00"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_32_color__b",
                "x1": "15.75",
                "x2": "15.75",
                "y1": "25.55",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc7a3"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_32_color__c",
                "x1": "15.77",
                "x2": "15.77",
                "y1": "29.22",
                "y2": "24.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_32_color__d",
                "x1": "28.13",
                "x2": "15.01",
                "y1": "19.45",
                "y2": "1.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb6f7b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_32_color__e",
                "x1": "25.07",
                "x2": "17.68",
                "y1": "9.83",
                "y2": "7.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fecbe6"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fdafd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$34c60a1808ce1959 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach32Filled', "32", [
    "M25.5 3.19a9.04 9.04 0 0 0-12.26 3.25l-.33.57a.85.85 0 0 0 .32 1.18l6.37 3.64-3.81 6.58h-.08c-3.69 0-6.88 2.11-8.78 5.1a2.4 2.4 0 0 1 1.98.2 8.7 8.7 0 0 1 6.8-3.57c2.8 0 5.35 1.54 7 3.85a2.4 2.4 0 0 1 1.69-.61 10.8 10.8 0 0 0-6.72-4.76l3.43-5.93 6.15 3.5a.9.9 0 0 0 1.2-.31l.34-.58A8.8 8.8 0 0 0 25.5 3.2M8.55 25.41a.9.9 0 0 0-.87-.6.9.9 0 0 0-.81.67c-.3 1.2-.86 1.85-1.5 2.24-.67.4-1.53.55-2.49.55a.87.87 0 0 0-.87.87c0 .47.4.86.87.86 1.12 0 2.34-.18 3.4-.8q.91-.54 1.54-1.51a5.23 5.23 0 0 0 8.19-.03 5.23 5.23 0 0 0 8.28-.1A6 6 0 0 0 29.12 30c.48 0 .87-.39.87-.86 0-.48-.39-.87-.87-.87a4.2 4.2 0 0 1-4-2.85.9.9 0 0 0-.83-.6.9.9 0 0 0-.84.59 3.47 3.47 0 0 1-6.63.14.9.9 0 0 0-.82-.59c-.38 0-.7.24-.83.59a3.47 3.47 0 0 1-6.63-.14"
]);
const $e9fce37105e983ce$export$ce13356f5b208e22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach32Regular', "32", [
    "M25.5 3.19a9.04 9.04 0 0 0-12.26 3.25l-.33.57a.85.85 0 0 0 .32 1.18l6.37 3.64-3.81 6.58h-.08c-3.69 0-6.88 2.11-8.78 5.1a2.4 2.4 0 0 1 1.98.2 8.7 8.7 0 0 1 6.8-3.57c2.8 0 5.35 1.54 7 3.85a2.4 2.4 0 0 1 1.69-.61 10.8 10.8 0 0 0-6.72-4.76l3.43-5.93 6.15 3.5a.9.9 0 0 0 1.2-.31l.34-.58A8.8 8.8 0 0 0 25.5 3.2m-2.55 8.55-3.68-2.1a12 12 0 0 1 2.07-2.47c.74-.66 1.62-1.26 2.82-1.92.18 1.1.23 2.02.12 2.92a9.5 9.5 0 0 1-1.33 3.57m1.52.87A11 11 0 0 0 26 8.38c.12-.9.09-1.77-.02-2.7a7.1 7.1 0 0 1 1.39 8.59zm-4.31-6.72c-.92.83-1.66 1.75-2.4 2.89l-2.9-1.65a7.3 7.3 0 0 1 8.04-3.16 16 16 0 0 0-2.74 1.92M8.54 25.41a.9.9 0 0 0-.87-.6.9.9 0 0 0-.81.67c-.3 1.2-.86 1.85-1.5 2.24-.67.4-1.53.55-2.49.55a.87.87 0 0 0-.87.87c0 .47.4.86.87.86 1.12 0 2.34-.18 3.4-.8q.91-.54 1.54-1.51a5.23 5.23 0 0 0 8.19-.03 5.23 5.23 0 0 0 8.28-.1A6 6 0 0 0 29.12 30c.48 0 .87-.39.87-.86 0-.48-.39-.87-.87-.87a4.2 4.2 0 0 1-4-2.85.9.9 0 0 0-.83-.6.9.9 0 0 0-.84.59 3.47 3.47 0 0 1-6.63.14.9.9 0 0 0-.82-.59c-.38 0-.7.24-.83.59a3.47 3.47 0 0 1-6.63-.14"
]);
const $e9fce37105e983ce$export$ac2d0e41d78571fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_48_color__a)",
            "d": "m32.5 16.44-2.1-1.27-8.55 14.09 2.1 1.28z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_48_color__b)",
            "d": "M11.8 39.76 18.49 43l5.1-3.24 7.33 2.67 3.81-3.48L37 40.52l1-.55c-.07-4.16-2.6-8.2-7.09-10.39-6.72-3.3-15.29-1.26-19.1 4.57a10.6 10.6 0 0 0-1.8 6.37z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_48_color__c)",
            "d": "M35.83 35.73c-.67 0-1.23.45-1.43 1.1-.77 2.46-2.65 3.66-4.5 3.68-1.86.02-3.73-1.13-4.5-3.45a1.5 1.5 0 0 0-1.42-1.07c-.68 0-1.21.45-1.41 1.07-.75 2.32-2.62 3.48-4.48 3.46-1.85 0-3.73-1.19-4.51-3.64a1.5 1.5 0 0 0-1.5-1.07c-.68 0-1.23.55-1.4 1.18V37c-.41 1.79-1.17 2.73-2.03 3.27-.9.57-2.08.8-3.4.83-.86 0-1.5.73-1.5 1.56s.67 1.57 1.5 1.57c1.62 0 3.41-.3 4.96-1.28a7 7 0 0 0 2.1-2.09 7.42 7.42 0 0 0 11.69-.1 7.4 7.4 0 0 0 11.83-.17 8.8 8.8 0 0 0 6.92 3.53c.86 0 1.5-.73 1.5-1.56s-.67-1.57-1.5-1.57a5.9 5.9 0 0 1-5.48-4.16c-.2-.65-.77-1.1-1.44-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_48_color__d)",
            "d": "M39.43 26.1c.77.48 1.78.28 2.32-.44l.5-.68c3.5-6.5 1.86-14.75-4.75-18.8-6.6-4.05-15.28-2.32-19.3 4.27l-.28.46c-.51.82-.25 1.9.58 2.41z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_beach_48_color__e)",
            "d": "M37.42 6.23c-3.12.9-9.2 4.91-12.71 10.99l8.77 5.34c3.79-5.9 4.56-13.15 3.94-16.33"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_48_color__a",
                "x1": "24",
                "x2": "35.29",
                "y1": "26.75",
                "y2": "15.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cd3e1d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#592a00"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_48_color__b",
                "x1": "24",
                "x2": "24",
                "y1": "38.8",
                "y2": "28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc7a3"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_48_color__c",
                "x1": "24.03",
                "x2": "24.03",
                "y1": "42.65",
                "y2": "35.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".06",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_48_color__d",
                "x1": "40.85",
                "x2": "21.75",
                "y1": "30.79",
                "y2": "3.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb6f7b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_beach_48_color__e",
                "x1": "36.83",
                "x2": "25.89",
                "y1": "16.21",
                "y2": "12.18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fecbe6"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fdafd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$1bd22054eceebb4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach48Filled', "48", [
    "m41.76 25.64.36-.64a14 14 0 1 0-24.25-14l-.12.22c-.41.71-.18 1.62.52 2.05L28 19.14l-5.38 8.92c-4.71.42-8.74 2.92-10.9 6.45a3.2 3.2 0 0 1 2.46.82c1.97-2.84 5.53-4.83 9.83-4.83s7.86 2 9.83 4.83a3.3 3.3 0 0 1 2.46-.82c-2.14-3.5-6.11-5.99-10.77-6.44l4.61-7.63 9.54 5.76c.72.44 1.67.18 2.09-.56M36.7 36.71q-.31-.2-.68-.2L36 36.5h-.03a1.25 1.25 0 0 0-1.16.85c-.04.13-1.3 3.65-4.81 3.65-3.52 0-4.77-3.5-4.81-3.65a1.25 1.25 0 0 0-2.38 0c-.04.13-1.3 3.65-4.81 3.65-3.52 0-4.77-3.5-4.81-3.65a1.2 1.2 0 0 0-1.16-.85h-.02a1.25 1.25 0 0 0-1.17.8c-.02.05-1.74 4.45-5.59 4.45a1.25 1.25 0 0 0 0 2.5 8.2 8.2 0 0 0 6.75-3.9 7.3 7.3 0 0 0 12 0 7.3 7.3 0 0 0 12 0 8.2 8.2 0 0 0 6.75 3.9 1.25 1.25 0 1 0 0-2.5c-2.48 0-4.09-1.86-4.91-3.18a9 9 0 0 1-.67-1.26q-.15-.38-.47-.6"
]);
const $e9fce37105e983ce$export$188440732e54d5b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beach48Regular', "48", [
    "m41.76 25.64.36-.64a14 14 0 1 0-24.25-14l-.12.22c-.41.71-.18 1.62.52 2.05L28 19.14l-5.38 8.92c-4.71.42-8.74 2.92-10.9 6.45a3.2 3.2 0 0 1 2.46.82c1.97-2.84 5.53-4.83 9.83-4.83s7.86 2 9.83 4.83a3.3 3.3 0 0 1 2.46-.82c-2.14-3.5-6.11-5.99-10.77-6.44l4.61-7.63 9.54 5.76c.72.44 1.67.18 2.09-.56m-4.08-16.2a11.5 11.5 0 0 1 2.4 14.09l-4.87-2.95.02-.03q.18-.28.47-.8c.37-.7.84-1.69 1.24-2.91.64-1.95 1.12-4.52.74-7.4m-4.26-2.42c-2.15.96-4 2.56-5.38 3.99a29 29 0 0 0-2.86 3.48l-.02.02-4.75-2.87a11.5 11.5 0 0 1 13.01-4.62M27.3 15.8l.49-.66a26 26 0 0 1 2.05-2.4c1.48-1.53 3.3-3.02 5.24-3.7.51 2.7.1 5.15-.52 7a16 16 0 0 1-1.49 3.24zm9.4 20.9q-.31-.2-.68-.2L36 36.5h-.03a1.25 1.25 0 0 0-1.16.85c-.04.13-1.3 3.65-4.81 3.65-3.52 0-4.77-3.5-4.81-3.65a1.25 1.25 0 0 0-2.38 0c-.04.13-1.3 3.65-4.81 3.65-3.52 0-4.77-3.5-4.81-3.65a1.2 1.2 0 0 0-1.16-.85h-.02a1.25 1.25 0 0 0-1.17.8c-.02.05-1.74 4.45-5.59 4.45a1.25 1.25 0 0 0 0 2.5 8.2 8.2 0 0 0 6.75-3.9 7.3 7.3 0 0 0 12 0 7.3 7.3 0 0 0 12 0 8.2 8.2 0 0 0 6.75 3.9 1.25 1.25 0 1 0 0-2.5c-2.48 0-4.09-1.86-4.91-3.18a9 9 0 0 1-.67-1.26q-.15-.38-.47-.6"
]);
const $e9fce37105e983ce$export$1a426bc9fab669f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker16Filled', "16", [
    "M6 3v3.69q0 .68-.34 1.26L5.05 9h5.9l-.6-1.05A2.5 2.5 0 0 1 10 6.69V3h.5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0 0 1zm5.54 7H4.46l-1.01 1.74A1.5 1.5 0 0 0 4.75 14h6.5a1.5 1.5 0 0 0 1.3-2.26z"
]);
const $e9fce37105e983ce$export$ceb6a4626323ca46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker16Regular', "16", [
    "M5.5 3H6v3.69q0 .68-.34 1.26l-2.21 3.8A1.5 1.5 0 0 0 4.75 14h6.5a1.5 1.5 0 0 0 1.3-2.26l-2.21-3.8A2.5 2.5 0 0 1 10 6.7V3h.5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0 0 1M7 6.69V3h2v3.69q0 .95.48 1.76L9.8 9H6.2l.32-.55A3.5 3.5 0 0 0 7 6.7M5.62 10h4.76l1.31 2.25a.5.5 0 0 1-.43.75H4.74a.5.5 0 0 1-.43-.75z"
]);
const $e9fce37105e983ce$export$381cc3b7f845883a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker20Filled', "20", [
    "M5.5 3.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-1v4.68q0 .88.42 1.66l.9 1.66H5.68l.9-1.65a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1-.5-.5M5.15 13l-.97 1.79A1.5 1.5 0 0 0 5.5 17h9a1.5 1.5 0 0 0 1.32-2.21L14.85 13z"
]);
const $e9fce37105e983ce$export$d409ba4c976d18ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker20Regular', "20", [
    "M14 3a.5.5 0 0 1 0 1h-1v4.68q0 .88.42 1.66l2.4 4.45A1.5 1.5 0 0 1 14.5 17h-9a1.5 1.5 0 0 1-1.32-2.21l2.4-4.44a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1 0-1zM8 4v4.69a4.5 4.5 0 0 1-.54 2.13L6.82 12h6.36l-.64-1.18A4.5 4.5 0 0 1 12 8.68V4zm5.72 9H6.28l-1.22 2.26a.5.5 0 0 0 .44.74h9a.5.5 0 0 0 .44-.74z"
]);
const $e9fce37105e983ce$export$2ebc6f11ea9bf5c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker24Filled', "24", [
    "M9 4.5v6.24q0 .57-.27 1.07L7.53 14h8.93l-1.19-2.19q-.27-.5-.27-1.07V4.5h1A.75.75 0 0 0 16 3H8a.75.75 0 0 0 0 1.5zm8.27 11H6.73l-1.59 2.91A1.75 1.75 0 0 0 6.68 21h10.64a1.75 1.75 0 0 0 1.54-2.59z"
]);
const $e9fce37105e983ce$export$47de91177c25a420 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker24Regular', "24", [
    "M8 4.5h1v6.24q0 .57-.27 1.07l-3.59 6.6A1.75 1.75 0 0 0 6.68 21h10.64a1.75 1.75 0 0 0 1.54-2.59l-3.59-6.6q-.27-.5-.27-1.07V4.5h1A.75.75 0 0 0 16 3H8a.75.75 0 0 0 0 1.5m2.5 6.24V4.5h3v6.24q0 .95.45 1.79l.8 1.47h-5.5l.8-1.47q.45-.84.45-1.8M8.43 15.5h7.14l1.97 3.63a.25.25 0 0 1-.22.37H6.68a.25.25 0 0 1-.22-.37z"
]);
const $e9fce37105e983ce$export$be2dc0525c7de29b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker32Filled', "32", [
    "M12 5v8.44a4 4 0 0 1-.71 2.28L9.7 18h12.58l-1.58-2.28a4 4 0 0 1-.71-2.28V5h1a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2zm11.68 15H8.32l-2.74 3.96A3.21 3.21 0 0 0 8.22 29h15.56c2.6 0 4.11-2.9 2.64-5.04z"
]);
const $e9fce37105e983ce$export$5352460ccfe0a4da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Beaker32Regular', "32", [
    "M20 5v8.44a4 4 0 0 0 .71 2.28l5.71 8.24A3.21 3.21 0 0 1 23.78 29H8.22a3.21 3.21 0 0 1-2.64-5.04l5.7-8.25a4 4 0 0 0 .72-2.27V5h-1a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2zm-6 8.44a6 6 0 0 1-1.07 3.41l-.8 1.15h7.73l-.8-1.15A6 6 0 0 1 18 13.44V5h-4zm-3.23 6.53L7.22 25.1c-.55.8.02 1.9 1 1.9h15.56c.98 0 1.55-1.1 1-1.9l-3.55-5.13L21 20H11z"
]);
const $e9fce37105e983ce$export$81a91e8862e97a50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerAdd20Filled', "20", [
    "M5.5 3.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-1v4.68q0 .27.04.52A5.5 5.5 0 0 0 9.6 12H5.68l.9-1.65a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1-.5-.5m3.5 11q0-.78.2-1.5H5.16l-.97 1.79A1.5 1.5 0 0 0 5.5 17h4.1q-.58-1.14-.6-2.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $e9fce37105e983ce$export$bad6c36f6ce204bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerAdd20Regular', "20", [
    "M14 3a.5.5 0 0 1 0 1h-1v4.68q0 .27.04.52-.5.13-.95.35a5 5 0 0 1-.09-.87V4H8v4.69a4.5 4.5 0 0 1-.54 2.13L6.82 12H9.6q-.24.48-.4 1H6.29l-1.22 2.26a.5.5 0 0 0 .44.74h3.7q.15.52.4 1H5.5a1.5 1.5 0 0 1-1.32-2.21l2.4-4.44a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1 0-1zm5 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $e9fce37105e983ce$export$fe05584ea236d177 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerAdd24Filled', "24", [
    "M9 4.5v6.24q0 .57-.27 1.07L7.53 14h4.5a6.5 6.5 0 0 1 3.09-2.55 2 2 0 0 1-.12-.71V4.5h1A.75.75 0 0 0 16 3H8a.75.75 0 0 0 0 1.5zm-2.28 11h4.6a6.5 6.5 0 0 0 .7 5.5H6.68a1.75 1.75 0 0 1-1.54-2.59zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.5 8.5V18h2.5a.5.5 0 1 0 0-1H18v-2.5a.5.5 0 1 0-1 0V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 1 0 1 0"
]);
const $e9fce37105e983ce$export$ab85559d943e3b0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerAdd24Regular', "24", [
    "M8 4.5h1v6.24q0 .57-.27 1.07l-3.59 6.6A1.75 1.75 0 0 0 6.68 21h5.34q-.45-.7-.7-1.5H6.67a.25.25 0 0 1-.22-.37l1.97-3.63h2.88q.26-.8.71-1.5H9.25l.8-1.47q.45-.84.45-1.8V4.5h3v6.24q0 .74.28 1.43.62-.44 1.34-.72a2 2 0 0 1-.12-.71V4.5h1A.75.75 0 0 0 16 3H8a.75.75 0 0 0 0 1.5m9.5 7.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.5 8.5V18h2.5a.5.5 0 1 0 0-1H18v-2.5a.5.5 0 1 0-1 0V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 1 0 1 0"
]);
const $e9fce37105e983ce$export$6a21fa2c159fe464 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerDismiss20Filled', "20", [
    "M5.5 3.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-1v4.68q0 .27.04.52A5.5 5.5 0 0 0 9.6 12H5.68l.9-1.65a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1-.5-.5m3.5 11q0-.78.2-1.5H5.16l-.97 1.79A1.5 1.5 0 0 0 5.5 17h4.1q-.58-1.14-.6-2.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $e9fce37105e983ce$export$da61bb2eab948d13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerDismiss20Regular', "20", [
    "M14 3a.5.5 0 0 1 0 1h-1v4.68q0 .27.04.52-.5.13-.95.35a5 5 0 0 1-.09-.87V4H8v4.69a4.5 4.5 0 0 1-.54 2.13L6.82 12H9.6q-.24.48-.4 1H6.29l-1.22 2.26a.5.5 0 0 0 .44.74h3.7q.15.52.4 1H5.5a1.5 1.5 0 0 1-1.32-2.21l2.4-4.44a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1 0-1zm5 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $e9fce37105e983ce$export$f58784618319db47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerDismiss24Filled', "24", [
    "M9 4.5v6.24q0 .57-.27 1.07L7.53 14h4.5a6.5 6.5 0 0 1 3.09-2.55 2 2 0 0 1-.12-.71V4.5h1A.75.75 0 0 0 16 3H8a.75.75 0 0 0 0 1.5zm-2.28 11h4.6a6.5 6.5 0 0 0 .7 5.5H6.68a1.75 1.75 0 0 1-1.54-2.59zm16.28 2a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-7.98-2.48.07-.05.08-.05a.5.5 0 0 1 .5.05l.06.05 1.77 1.77 1.77-1.77.07-.05a.5.5 0 0 1 .57 0l.07.05.06.07a.5.5 0 0 1 0 .57l-.06.07-1.77 1.77 1.77 1.77.05.07a.5.5 0 0 1 0 .57l-.05.07-.07.05a.5.5 0 0 1-.57 0l-.07-.05-1.77-1.77-1.77 1.76-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.06a.5.5 0 0 1 0-.57l.06-.07 1.76-1.77-1.77-1.77-.05-.07a.5.5 0 0 1 0-.57z"
]);
const $e9fce37105e983ce$export$6ab2266ee3b856d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerDismiss24Regular', "24", [
    "M8 4.5h1v6.24q0 .57-.27 1.07l-3.59 6.6A1.75 1.75 0 0 0 6.68 21h5.34q-.45-.7-.7-1.5H6.67a.25.25 0 0 1-.22-.37l1.97-3.63h2.88q.26-.8.71-1.5H9.25l.8-1.47q.45-.84.45-1.8V4.5h3v6.24q0 .74.28 1.43.62-.44 1.34-.72a2 2 0 0 1-.12-.71V4.5h1A.75.75 0 0 0 16 3H8a.75.75 0 0 0 0 1.5m15 13a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-7.98-2.48.07-.05.08-.05a.5.5 0 0 1 .5.05l.06.05 1.77 1.77 1.77-1.77.07-.05a.5.5 0 0 1 .57 0l.07.05.06.07a.5.5 0 0 1 0 .57l-.06.07-1.77 1.77 1.77 1.77.05.07a.5.5 0 0 1 0 .57l-.05.07-.07.05a.5.5 0 0 1-.57 0l-.07-.05-1.77-1.77-1.77 1.76-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.06a.5.5 0 0 1 0-.57l.06-.07 1.76-1.77-1.77-1.77-.05-.07a.5.5 0 0 1 0-.57z"
]);
const $e9fce37105e983ce$export$4d48cb4c42374323 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerEdit20Filled', "20", [
    "M5.5 3.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-1v4.68q0 .88.42 1.66l.41.77-.89.89H5.68l.9-1.65a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1-.5-.5m4.77 11.17L11.94 13h-6.8l-.96 1.79A1.5 1.5 0 0 0 5.5 17h3.72l.21-.84a3 3 0 0 1 .84-1.49m.71.7 4.83-4.82a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $e9fce37105e983ce$export$b88660cb1e685140 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerEdit20Regular', "20", [
    "M14 3a.5.5 0 0 1 0 1h-1v4.68q0 .88.42 1.66l.41.77-.73.74-.56-1.03A4.5 4.5 0 0 1 12 8.68V4H8v4.69a4.5 4.5 0 0 1-.54 2.13L6.82 12h6.12l-1 1H6.28l-1.22 2.26a.5.5 0 0 0 .44.74h3.97l-.04.16-.21.84H5.5a1.5 1.5 0 0 1-1.32-2.21l2.4-4.44a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1 0-1zm-3.02 12.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $e9fce37105e983ce$export$97f0cf752e8c01d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerEdit24Filled', "24", [
    "M7 3.5v6.24q0 .56-.27 1.07L5.53 13h8.93l-1.19-2.19q-.27-.5-.27-1.07V3.5h1A.75.75 0 0 0 14 2H6a.75.75 0 0 0 0 1.5zm8.27 11H4.73l-1.59 2.91A1.75 1.75 0 0 0 4.68 20h6.74l.1-.42q.25-.99.97-1.72l2.99-2.98zm3.83-1.83-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $e9fce37105e983ce$export$f9b545734d36be72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerEdit24Regular', "24", [
    "M6 3.5h1v6.24q0 .56-.27 1.07l-3.59 6.6A1.75 1.75 0 0 0 4.68 20h6.74l.1-.42q.15-.59.46-1.08h-7.3a.25.25 0 0 1-.22-.37l1.97-3.63h7.14l.8 1.48 1.1-1.1-2.2-4.07q-.27-.5-.27-1.07V3.5h1A.75.75 0 0 0 14 2H6a.75.75 0 0 0 0 1.5m2.5 6.24V3.5h3v6.24q0 .95.45 1.79l.8 1.47h-5.5l.8-1.47q.45-.84.45-1.8m10.6 2.93-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $e9fce37105e983ce$export$d92b50a6395178d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerEmpty16Filled', "16", [
    "M12.56 11.74 10.95 9l-.61-1.05A2.5 2.5 0 0 1 10 6.69V3h.5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5H6v3.69q0 .67-.34 1.26L5.05 9l-1.61 2.74A1.5 1.5 0 0 0 4.74 14h6.52a1.5 1.5 0 0 0 1.3-2.26"
]);
const $e9fce37105e983ce$export$b7173282614d5d64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerEmpty16Regular', "16", [
    "M12.56 11.74 10.95 9l-.61-1.05A2.5 2.5 0 0 1 10 6.69V3h.5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5H6v3.69q0 .67-.34 1.26L5.05 9l-1.61 2.74A1.5 1.5 0 0 0 4.74 14h6.52a1.5 1.5 0 0 0 1.3-2.26M11.26 13H4.74a.5.5 0 0 1-.43-.75L5.62 10l.58-1 .32-.55A3.4 3.4 0 0 0 7 6.69V3h2v3.69q0 .95.48 1.76L9.8 9l.58 1 1.31 2.25a.5.5 0 0 1-.43.75"
]);
const $e9fce37105e983ce$export$1acce77e04ee517 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L6.99 7.7v.99a3.5 3.5 0 0 1-.41 1.66L5.68 12h5.61l1 1H5.15l-.97 1.79A1.5 1.5 0 0 0 5.5 17h9c.5 0 .93-.24 1.2-.6l1.45 1.45a.5.5 0 0 0 .7-.7zM7 4.87 14.12 12h.2l-.9-1.66A3.5 3.5 0 0 1 13 8.68V4h1a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.49.4l.61.6H7z"
]);
const $e9fce37105e983ce$export$491cf119b6620a0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L6.99 7.7v.99a3.5 3.5 0 0 1-.41 1.66l-2.4 4.44A1.5 1.5 0 0 0 5.5 17h9c.5 0 .93-.24 1.2-.6l1.45 1.45a.5.5 0 0 0 .7-.7zm12.12 13.52a.5.5 0 0 1-.47.33h-9a.5.5 0 0 1-.44-.74L6.28 13h6.01zM11.29 12H6.82l.64-1.18a4.5 4.5 0 0 0 .53-2.12zM12 8.68q0 .75.24 1.44l2.3 2.3-1.12-2.08A3.5 3.5 0 0 1 13 8.68V4h1a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.49.4l.61.6H7v.87l1 1V4H12z"
]);
const $e9fce37105e983ce$export$ced3c22a4f59f661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerOff32Filled', "32", [
    "m26.33 27.74 1.96 1.97a1 1 0 0 0 1.42-1.42l-26-26a1 1 0 0 0-1.42 1.42l9.7 9.7v.03a4 4 0 0 1-.7 2.27L9.7 18h6.89l2 2H8.32l-2.74 3.96A3.21 3.21 0 0 0 8.22 29h15.56c1.08 0 1.98-.5 2.55-1.26M21.53 18 12 8.46V5h-1a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2h-1v8.44a4 4 0 0 0 .7 2.27L22.3 18z"
]);
const $e9fce37105e983ce$export$ce0a40141fb10539 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerOff32Regular', "32", [
    "m26.33 27.74 1.96 1.97a1 1 0 0 0 1.42-1.42l-26-26a1 1 0 0 0-1.42 1.42l9.7 9.7v.03a4 4 0 0 1-.7 2.27l-5.71 8.25A3.21 3.21 0 0 0 8.22 29h15.56c1.08 0 1.98-.5 2.55-1.26m-1.45-1.45c-.19.4-.59.71-1.1.71H8.22c-.98 0-1.55-1.1-1-1.9l3.55-5.13.23.03h7.59zM16.58 18h-4.44l.8-1.15a6 6 0 0 0 .8-1.7zM18 13.44a6 6 0 0 0 .1 1.13L24 20.45 20.7 15.7a4 4 0 0 1-.71-2.27V5h1a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2h1v3.46l2 2V5h4z"
]);
const $e9fce37105e983ce$export$86777a8609fdd065 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerSettings16Filled', "16", [
    "M5 3v3.69q0 .68-.34 1.26L4.05 9H6.6A5.5 5.5 0 0 1 9 6.6V3h.5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0 0 1zm-1.54 7h2.75a5.5 5.5 0 0 0 .39 4H3.74a1.5 1.5 0 0 1-1.3-2.26zm5.6-1.56a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 9 14.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 14 8.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $e9fce37105e983ce$export$9d5cf91f0dee266e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerSettings16Regular', "16", [
    "M4.5 3H5v3.69q0 .68-.34 1.26l-2.22 3.8A1.5 1.5 0 0 0 3.74 14H6.6q-.24-.48-.4-1H3.75a.5.5 0 0 1-.43-.75L4.62 10h1.59q.15-.52.39-1H5.2l.32-.55A3.5 3.5 0 0 0 6 6.7V3h2v3.69q0 .27.04.53.45-.36.96-.62V3h.5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0 0 1m4.56 5.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 9 14.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 14 8.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $e9fce37105e983ce$export$b10a1a44253137dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerSettings20Filled', "20", [
    "M5.5 3.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-1v4.68q0 .27.04.52A5.5 5.5 0 0 0 9.6 12H5.68l.9-1.65a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1-.5-.5m3.5 11q0-.78.2-1.5H5.16l-.97 1.79A1.5 1.5 0 0 0 5.5 17h4.1q-.58-1.14-.6-2.5m3.07-3.06a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $e9fce37105e983ce$export$a3cd85602a2c7aa7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BeakerSettings20Regular', "20", [
    "M14 3a.5.5 0 0 1 0 1h-1v4.68q0 .27.04.52-.5.13-.95.35a5 5 0 0 1-.09-.87V4H8v4.69a4.5 4.5 0 0 1-.54 2.13L6.82 12H9.6q-.24.48-.4 1H6.29l-1.22 2.26a.5.5 0 0 0 .44.74h3.7q.15.52.4 1H5.5a1.5 1.5 0 0 1-1.32-2.21l2.4-4.44a3.5 3.5 0 0 0 .41-1.66V4H6a.5.5 0 0 1 0-1zm-1.93 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $e9fce37105e983ce$export$11ff5da58cbd196b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bench20Filled', "20", [
    "M5 4a2 2 0 0 0-2 2v4h14V6a2 2 0 0 0-2-2zm-2.5 7a1.5 1.5 0 0 0 0 3H3v1.5a.5.5 0 0 0 1 0V14h12v1.5a.5.5 0 0 0 1 0V14h.5a1.5 1.5 0 0 0 0-3z"
]);
const $e9fce37105e983ce$export$9083f84529992350 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bench20Regular', "20", [
    "M3 6c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v4a2 2 0 1 1 0 4v1.5a.5.5 0 0 1-1 0V14H4v1.5a.5.5 0 0 1-1 0V14a2 2 0 1 1 0-4zm14 7a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2zm-1-7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4h12z"
]);
const $e9fce37105e983ce$export$8600b7b85e269e0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bench24Filled', "24", [
    "M5.75 4A2.75 2.75 0 0 0 3 6.75V12h18V6.75A2.75 2.75 0 0 0 18.25 4zM3 13a2 2 0 1 0 0 4v2.25a.75.75 0 0 0 1.5 0V17h15v2.25a.75.75 0 0 0 1.5 0V17a2 2 0 1 0 0-4z"
]);
const $e9fce37105e983ce$export$a10d6feee2d214ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Bench24Regular', "24", [
    "M5.75 4A2.75 2.75 0 0 0 3 6.75v5.3a2.5 2.5 0 0 0 0 4.9v2.3a.75.75 0 0 0 1.5 0V17h15v2.25a.75.75 0 0 0 1.5 0v-2.3a2.5 2.5 0 0 0 0-4.9v-5.3A2.75 2.75 0 0 0 18.25 4zm13.75 8h-15V6.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25zm1 3.5h-17a1 1 0 1 1 0-2h17a1 1 0 1 1 0 2"
]);
const $e9fce37105e983ce$export$bf18f9ca74eb2b3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__a)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v10c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__b)",
            "d": "M8.5 14 8 12.5l.5-1.5h2c.28 0 .5.22.5.5V14z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__c)",
            "d": "M6 14v-2.5c0-.28.22-.5.5-.5h2v3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__d)",
            "d": "M11 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__e)",
            "d": "M9 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__f)",
            "d": "M7 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__g)",
            "d": "M9 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__h)",
            "d": "M7 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__i)",
            "d": "M9 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_16_color__j)",
            "d": "M7 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__a",
                "x1": "4",
                "x2": "15.44",
                "y1": "2.38",
                "y2": "13.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__b",
                "x1": "8.11",
                "x2": "10.18",
                "y1": "11.56",
                "y2": "13.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__c",
                "x1": "6.09",
                "x2": "8.14",
                "y1": "11.56",
                "y2": "13.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__d",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__e",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__f",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__g",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__h",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__i",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_16_color__j",
                "x1": "7.5",
                "x2": "10.05",
                "y1": "3.33",
                "y2": "10.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$3132b8f432e7a14c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building16Filled', "16", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v10c0 .28.22.5.5.5H6v-2.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 0 .5-.5v-5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5zM7 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M7 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M10 14v-2H9v2zm-2 0v-2H7v2z"
]);
const $e9fce37105e983ce$export$e8e636afae06136d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building16Regular', "16", [
    "M6.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M7 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.5 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M9 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.5 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m.5 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-5-8C4.67 2 4 2.67 4 3.5v10c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5zM5 3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v4c0 .28.22.5.5.5h1c.28 0 .5.22.5.5V13h-1v-1.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V13H5zm5 8.5v1H9v-1zm-2 0v1H7v-1z"
]);
const $e9fce37105e983ce$export$5ac6f632f905e98c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__a)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-8c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__b)",
            "d": "M10 18h3v-3.5a.5.5 0 0 0-.5-.5H10l-.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__c)",
            "d": "M10 14H7.5a.5.5 0 0 0-.5.5V18h3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__d)",
            "d": "M7.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__e)",
            "d": "M9.75 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__f)",
            "d": "M9.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__g)",
            "d": "M6.75 8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__h)",
            "d": "M6.75 12.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__i)",
            "d": "M10.5 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_20_color__j)",
            "d": "M12.75 12.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__a",
                "x1": "4",
                "x2": "19.26",
                "y1": "2.5",
                "y2": "17.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__b",
                "x1": "9.63",
                "x2": "12.38",
                "y1": "14.75",
                "y2": "17.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__c",
                "x1": "7.11",
                "x2": "9.79",
                "y1": "14.75",
                "y2": "16.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__d",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__e",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__f",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__g",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__h",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__i",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_20_color__j",
                "x1": "8.25",
                "x2": "10.99",
                "y1": "4.17",
                "y2": "14.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$1917103eb6676534 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building20Filled', "20", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v8a.5.5 0 0 1-.5.5H13v-3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V18H4.5a.5.5 0 0 1-.5-.5zm2.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-6.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M9.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M12 15v3h-1.5v-3zm-2.5 0H8v3h1.5z"
]);
const $e9fce37105e983ce$export$a1c9afce49ef7f0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building20Regular', "20", [
    "M6.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M4.5 18a.5.5 0 0 1-.5-.5v-14C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v8a.5.5 0 0 1-.5.5zM5 3.5V17h2v-2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V17h2V9.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5M12 15h-1.5v2H12zm-2.5 0H8v2h1.5z"
]);
const $e9fce37105e983ce$export$5a3121d0f6d646b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_24_color__a)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h8c1.24 0 2.25 1 2.25 2.25V9.5h1.25c1.24 0 2.25 1 2.25 2.25v9.5c0 .41-.34.75-.75.75H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_24_color__b)",
            "d": "M16.5 18.25c0-.69-.56-1.25-1.25-1.25H12l-1 2.5 1 2.5h4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_24_color__c)",
            "d": "M7.5 18.25c0-.69.56-1.25 1.25-1.25H12v5H7.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_24_color__d)",
            "d": "M7.5 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_24_color__a",
                "x1": "4",
                "x2": "23.08",
                "y1": "2.63",
                "y2": "22.17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_24_color__b",
                "x1": "12.36",
                "x2": "16.13",
                "y1": "17.42",
                "y2": "20.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_24_color__c",
                "x1": "7.66",
                "x2": "11.11",
                "y1": "17.94",
                "y2": "21.16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_24_color__d",
                "x1": "10.2",
                "x2": "13.49",
                "y1": "4.5",
                "y2": "16.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$12ef876c7f0e5aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building24Filled', "24", [
    "M4 4.25C4 3.01 5 2 6.25 2h8c1.24 0 2.25 1 2.25 2.25V9.5h1.25c1.24 0 2.25 1 2.25 2.25v9.5c0 .41-.34.75-.75.75H16.5v-3.75c0-.69-.56-1.25-1.25-1.25h-6.5c-.69 0-1.25.56-1.25 1.25V22H4.75a.75.75 0 0 1-.75-.75zM15 18.5V22h-2.25v-3.5zm-3.75 0V22H9v-3.5zM7.5 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $e9fce37105e983ce$export$cff0bb9ff201e0dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building24Regular', "24", [
    "M6.25 3.5a.75.75 0 0 0-.75.75V20.5h2v-2.75c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v2.75h2v-8.75a.75.75 0 0 0-.75-.75h-2a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 0-.75-.75zM9 18v2.5h2.25V18zm3.75 0v2.5H15V18zm6.5 4H4.75a.75.75 0 0 1-.75-.75v-17C4 3.01 5 2 6.25 2h8c1.24 0 2.25 1 2.25 2.25V9.5h1.25c1.24 0 2.25 1 2.25 2.25v9.5c0 .41-.34.75-.75.75M7.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $e9fce37105e983ce$export$5dede5fe7cf2c699 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_32_color__a)",
            "d": "M27 30a1 1 0 0 0 1-1V16.25c0-1.8-1.46-3.25-3.25-3.25H22V5.25C22 3.45 20.54 2 18.75 2H7a3 3 0 0 0-3 3v24a1 1 0 0 0 1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_32_color__b)",
            "d": "M21.5 24c.83 0 1.5.67 1.5 1.5V30h-7l-1-2.5 1-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_32_color__c)",
            "d": "M10.5 24c-.83 0-1.5.67-1.5 1.5V30h7v-6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_32_color__d)",
            "d": "M10.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5-8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_32_color__a",
                "x1": "4",
                "x2": "30.61",
                "y1": "2.88",
                "y2": "32.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_32_color__b",
                "x1": "16",
                "x2": "21.15",
                "y1": "23",
                "y2": "29.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_32_color__c",
                "x1": "9.25",
                "x2": "14.08",
                "y1": "25.31",
                "y2": "30.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_32_color__d",
                "x1": "12.9",
                "x2": "17.65",
                "y1": "5.56",
                "y2": "22.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$808f8c7b5868a33c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building32Filled', "32", [
    "M4 5a3 3 0 0 1 3-3h11.75C20.55 2 22 3.46 22 5.25V13h2.75c1.8 0 3.25 1.46 3.25 3.25V29a1 1 0 0 1-1 1h-4v-4.5c0-.83-.67-1.5-1.5-1.5h-11c-.83 0-1.5.67-1.5 1.5V30H5a1 1 0 0 1-1-1zm17 21v4h-4v-4zm-6 0v4h-4v-4zM12 8.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0 5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M10.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17 8.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $e9fce37105e983ce$export$4ad48a3f2ce5a4ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building32Regular', "32", [
    "M7 4h11.75c.69 0 1.25.56 1.25 1.25V14a1 1 0 0 0 1 1h3.75c.69 0 1.25.56 1.25 1.25V28h-3v-3.5c0-.83-.67-1.5-1.5-1.5h-11c-.83 0-1.5.67-1.5 1.5V28H6V5a1 1 0 0 1 1-1m14 24h-4v-3h4zm-6 0h-4v-3h4zm12 2a1 1 0 0 0 1-1V16.25c0-1.8-1.46-3.25-3.25-3.25H22V5.25C22 3.45 20.54 2 18.75 2H7a3 3 0 0 0-3 3v24a1 1 0 0 0 1 1zM10.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5-8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $e9fce37105e983ce$export$e04826bc2444b5cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_48_color__a)",
            "d": "M9.25 44C8.56 44 8 43.44 8 42.75V8.25C8 5.9 9.9 4 12.25 4h15.5C30.1 4 32 5.9 32 8.25V19h3.75C38.1 19 40 20.9 40 23.25v19.5c0 .69-.56 1.25-1.25 1.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_48_color__b)",
            "d": "M34 37.25V44H24l-1-4 1-5h7.75c1.24 0 2.25 1 2.25 2.25"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_48_color__c)",
            "d": "M14 37.25V44h10v-9h-7.75C15.01 35 14 36 14 37.25"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_48_color__d)",
            "d": "M18 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_48_color__a",
                "x1": "8",
                "x2": "46.16",
                "y1": "5.25",
                "y2": "44.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_48_color__b",
                "x1": "24.38",
                "x2": "31.77",
                "y1": "33.57",
                "y2": "41.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_48_color__c",
                "x1": "14.36",
                "x2": "21.26",
                "y1": "36.88",
                "y2": "44.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_48_color__d",
                "x1": "20",
                "x2": "26",
                "y1": "10",
                "y2": "34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$720753ddf70620 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building48Filled', "48", [
    "M8 8.25C8 5.9 9.9 4 12.25 4h15.5C30.1 4 32 5.9 32 8.25V19h3.75C38.1 19 40 20.9 40 23.25v19.5c0 .69-.56 1.25-1.25 1.25H34v-6.75c0-1.24-1-2.25-2.25-2.25h-15.5C15.01 35 14 36 14 37.25V44H9.25C8.56 44 8 43.44 8 42.75zM16.5 44h6.25v-6.5H16.5zm8.75 0h6.25v-6.5h-6.25zM18 14a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m6-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
]);
const $e9fce37105e983ce$export$a4ecf47532403eac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Building48Regular', "48", [
    "M12.25 6.5c-.97 0-1.75.78-1.75 1.75V41.5H14v-5.25c0-1.24 1-2.25 2.25-2.25h15.5c1.24 0 2.25 1 2.25 2.25v5.25h3.5V23.25c0-.97-.78-1.75-1.75-1.75h-5c-.69 0-1.25-.56-1.25-1.25v-12c0-.97-.78-1.75-1.75-1.75zm-3 37.5C8.56 44 8 43.44 8 42.75V8.25C8 5.9 9.9 4 12.25 4h15.5C30.1 4 32 5.9 32 8.25V19h3.75C38.1 19 40 20.9 40 23.25v19.5c0 .69-.56 1.25-1.25 1.25zm7.25-2.5h6.25v-5H16.5zm8.75 0h6.25v-5h-6.25zM18 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $e9fce37105e983ce$export$df05202b6577a1e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank16Filled', "16", [
    "M7.3 1.71c.41-.32 1-.32 1.4 0l4.97 3.8c.63.48.3 1.49-.5 1.49H2.83a.83.83 0 0 1-.5-1.5zM8 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M3.5 8v3H5V8zM6 8v3h1.5V8zm2.5 0v3H10V8zM11 8v3h1.5V8zm-9 5.25c0-.69.56-1.25 1.25-1.25h9.5c.69 0 1.25.56 1.25 1.25v.25a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5z"
]);
const $e9fce37105e983ce$export$67431c979c0a9d59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank16Regular', "16", [
    "M8 5a.75.75 0 1 0 0-1.5A.75.75 0 0 0 8 5m.74-3.55a1.2 1.2 0 0 0-1.48 0l-5 4.07A.83.83 0 0 0 2.8 7H3v4.2c-.6.3-1 .92-1 1.63v.67c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-.67c0-.7-.4-1.33-1-1.63V7h.21a.83.83 0 0 0 .53-1.48zm-.84.78a.2.2 0 0 1 .2 0L12.75 6H3.26zM12 11h-1V7h1zm-2 0H8.5V7H10zm-2.5 0H6V7h1.5zm4.67 1c.46 0 .83.37.83.83V13H3v-.17c0-.46.37-.83.83-.83zM5 11H4V7h1z"
]);
const $e9fce37105e983ce$export$2292012a38a961e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank20Filled', "20", [
    "M9.23 2.18a1.3 1.3 0 0 1 1.54 0l5.85 4.15A.92.92 0 0 1 16.1 8H3.9a.92.92 0 0 1-.52-1.67zm.77 3.7a.83.83 0 1 0 0-1.67.83.83 0 0 0 0 1.66M4.5 9v4h2V9zM3 16.17c0-1.2.97-2.17 2.17-2.17h9.66c1.2 0 2.17.97 2.17 2.17v.33a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5zM15.5 9v4h-2V9zm-3 0v4h-2V9zm-3 0v4h-2V9z"
]);
const $e9fce37105e983ce$export$7d5253778f1866a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank20Regular', "20", [
    "M10 5.87a.83.83 0 1 0 0-1.66.83.83 0 0 0 0 1.66m6 7.47V8h.1a.92.92 0 0 0 .52-1.67l-5.85-4.15a1.3 1.3 0 0 0-1.54 0L3.38 6.33A.92.92 0 0 0 3.9 8H4v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-1.33c0-.77-.4-1.45-1-1.83M9.8 3a.3.3 0 0 1 .4 0l5.63 4H4.17zM15 8v5h-2V8zM5 13V8h2v5H5m.17 1h9.66c.65 0 1.17.52 1.17 1.17V16H4v-.83c0-.65.52-1.17 1.17-1.17m4.33-1H8V8h1.5zm1 0V8H12v5z"
]);
const $e9fce37105e983ce$export$4d8faa049cadf6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank24Filled', "24", [
    "M10.97 2.32a1.75 1.75 0 0 1 2.06 0l7.42 5.42c.98.71.48 2.26-.73 2.26H4.28a1.25 1.25 0 0 1-.73-2.26zM13 6.25a1 1 0 1 0-2 0 1 1 0 0 0 2 0M11.25 16h-2v-5h2zm3.5 0h-2v-5h2zm3.75 0h-2.25v-5h2.25zm.25 1H5.25C4.01 17 3 18 3 19.25v.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75v-.5c0-1.24-1-2.25-2.25-2.25m-11-1H5.5v-5h2.25z"
]);
const $e9fce37105e983ce$export$7c700e5f8bba1675 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank24Regular', "24", [
    "M13 6.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.03-3.93a1.75 1.75 0 0 0-2.06 0L3.55 7.74c-.98.71-.48 2.26.73 2.26h.22v5.8A2.8 2.8 0 0 0 3 18.25v1.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75v-1.5c0-1.07-.61-2-1.5-2.45V10h.22c1.2 0 1.71-1.55.73-2.26zm-1.18 1.22q.15-.1.3 0l6.8 4.96H5.05zM18 10v5.5h-2V10zm-3.5 0v5.5h-1.75V10zm-3.25 0v5.5H9.5V10zm-5.5 7h12.5c.69 0 1.25.56 1.25 1.25V19h-15v-.75c0-.69.56-1.25 1.25-1.25M6 15.5V10h2v5.5z"
]);
const $e9fce37105e983ce$export$c7d7ce1a37188cde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank28Filled', "28", [
    "M13.11 2.3a1.5 1.5 0 0 1 1.78 0l9.5 7a1.5 1.5 0 0 1-.74 2.7H4.35a1.5 1.5 0 0 1-.74-2.7zM14 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5.5 4H22v6h-2.5zm-2 6v-6H15v6zM13 19v-6h-2.5v6zm-4.5 0v-6H6v6zm-2.25 1A3.25 3.25 0 0 0 3 23.25v.5c0 .41.34.75.75.75h20.5c.41 0 .75-.34.75-.75v-.5c0-1.8-1.46-3.25-3.25-3.25z"
]);
const $e9fce37105e983ce$export$15270d71d8d41f4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank28Regular', "28", [
    "M14 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m.89-6.7a1.5 1.5 0 0 0-1.78 0l-9.5 7a1.5 1.5 0 0 0 .9 2.7H5v7.25c-1.17.49-2 1.65-2 3v1.5c0 .41.34.75.75.75h20.5c.41 0 .75-.34.75-.75v-1.5c0-1.35-.83-2.51-2-3V12h.5a1.5 1.5 0 0 0 .89-2.71zM6.5 19v-7H9v7zm15-7v7H19v-7zm-4 0v7h-2.75v-7zm-4.25 0v7H10.5v-7zM4.5 10.5l9.5-7 9.5 7zm0 11.75c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75V23h-19z"
]);
const $e9fce37105e983ce$export$8c7678639eac2b05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank48Filled', "48", [
    "M25.35 4.45c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 0 0 1.05 3.15h32.48c1.69 0 2.4-2.14 1.05-3.15zM24 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4M6 38.25C6 35.35 8.35 33 11.25 33h25.5c2.9 0 5.25 2.35 5.25 5.25v1.5c0 .69-.56 1.25-1.25 1.25H7.25C6.56 41 6 40.44 6 39.75zM14 31h-4v-9.5h4zm4-9.5V31h4v-9.5zm8 0V31h4v-9.5zm8 0V31h4v-9.5z"
]);
const $e9fce37105e983ce$export$2e48b24063fb9a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBank48Regular', "48", [
    "M24 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1.35-9.55c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 0 0 1.05 3.15H9v12c-1.77.85-3 2.66-3 4.75v3.5c0 .69.56 1.25 1.25 1.25h33.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-2.1-1.23-3.9-3-4.74v-12h1.24c1.69 0 2.4-2.15 1.05-3.16zM36.5 31H32V19.5h4.5zm-7 0h-4.25V19.5h4.25zm-6.75 0H18.5V19.5h4.25zM16 31h-4.5V19.5H16zm-5.99-14L24 6.56 37.99 17zM8.5 36.25a2.75 2.75 0 0 1 2.75-2.75h25.5a2.75 2.75 0 0 1 2.75 2.75v2.25h-31z"
]);
const $e9fce37105e983ce$export$9e22ac8941957905 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink16Filled', "16", [
    "M7.3 1.71c.41-.32 1-.32 1.4 0l4.97 3.8c.63.48.3 1.49-.5 1.49H2.83a.83.83 0 0 1-.5-1.5zM8 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M3.5 8v3H5V8zM6 8v2.05a3.5 3.5 0 0 1 1.5-.9V8zm-2.75 4h1.79a3.5 3.5 0 0 0 .3 2H2.5a.5.5 0 0 1-.5-.5v-.25c0-.69.56-1.25 1.25-1.25m9.25-4v1H11V8zM10 8v1H8.5V8zm-1.5 2a2.5 2.5 0 0 0 0 5H9a.5.5 0 1 0 0-1h-.5a1.5 1.5 0 1 1 0-3H9a.5.5 0 1 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H12a.5.5 0 0 0 0 1h.5a2.5 2.5 0 1 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $e9fce37105e983ce$export$6f05076ac12b3a16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink16Regular', "16", [
    "M8 5a.75.75 0 1 0 0-1.5A.75.75 0 0 0 8 5m.74-3.55a1.2 1.2 0 0 0-1.48 0l-5 4.07A.83.83 0 0 0 2.8 7H3v4.2c-.6.3-1 .92-1 1.63v.67c0 .28.22.5.5.5h2.84a4 4 0 0 1-.3-1H3v-.17c0-.46.37-.83.83-.83h1.2c.11-.75.46-1.43.97-1.95V7h1.5v2.15Q7.98 9 8.5 9V7H10v2h1V7h1v2h.5q.26 0 .5.04V7h.21a.83.83 0 0 0 .53-1.48zm-.84.78a.2.2 0 0 1 .2 0L12.75 6H3.26zM5 11H4V7h1zm3.5-1a2.5 2.5 0 1 0 0 5H9a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3H9a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 1 0 0 1h.5a1.5 1.5 0 1 1 0 3H12a.5.5 0 1 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $e9fce37105e983ce$export$e206fbedd3016baa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink20Filled', "20", [
    "M9.23 2.18a1.3 1.3 0 0 1 1.54 0l5.85 4.15A.92.92 0 0 1 16.1 8H3.9a.92.92 0 0 1-.52-1.67zm.77 3.7a.83.83 0 1 0 0-1.67.83.83 0 0 0 0 1.66M4.5 9v4h2V9zM3 16.17c0-1.2.97-2.17 2.17-2.17h3.17a3.5 3.5 0 0 0 0 3H3.5a.5.5 0 0 1-.5-.5zM9.05 13q.21-.2.45-.37V9h-2v4zm2.45-1h1V9h-2v3.14q.48-.14 1-.14m2 0h2V9h-2zm-2 1a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 1 0 0 1h.5a1.5 1.5 0 0 1 0 3H15a.5.5 0 1 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $e9fce37105e983ce$export$d9222537a1d32d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink20Regular', "20", [
    "M10 5.87a.83.83 0 1 0 0-1.66.83.83 0 0 0 0 1.66M3.5 17h4.84a4 4 0 0 1-.3-1H4v-.83c0-.65.52-1.17 1.17-1.17h3.17q.27-.57.71-1H8V8h1.5v4.63q.46-.32 1-.49V8H12v4h1V8h2v4h.5q.26 0 .5.03V8h.1a.92.92 0 0 0 .52-1.67l-5.85-4.15a1.3 1.3 0 0 0-1.54 0L3.38 6.33A.92.92 0 0 0 3.9 8H4v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5M9.8 3a.3.3 0 0 1 .4 0l5.63 4H4.17zM5 13V8h2v5H5m6.5 0a2.5 2.5 0 0 0 0 5h.5a.5.5 0 1 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 1 0 0-1zm3.5 0a.5.5 0 1 0 0 1h.5a1.5 1.5 0 1 1 0 3H15a.5.5 0 1 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $e9fce37105e983ce$export$9ca7a5bd76f1454c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink24Filled', "24", [
    "M10.97 2.32a1.75 1.75 0 0 1 2.06 0l7.42 5.42c.98.71.48 2.26-.73 2.26H4.28a1.25 1.25 0 0 1-.73-2.26zM13 6.25a1 1 0 1 0-2 0 1 1 0 0 0 2 0M11.25 16h-2v-5h2zm1.5-.43q.87-.71 2-.96V11h-2zm3.5-1.07h2.25V11h-2.25zM11 19.25q0-1.23.57-2.25H5.25C4.01 17 3 18 3 19.25v.5c0 .41.34.75.75.75h7.42q-.17-.6-.17-1.25M7.75 16H5.5v-5h2.25zM23 19.25a3.75 3.75 0 0 0-3.75-3.75h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5V23h.2A3.75 3.75 0 0 0 23 19.25m-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75m3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75"
]);
const $e9fce37105e983ce$export$f5df2f139a9824bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink24Regular', "24", [
    "M13 6.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.03-3.93a1.75 1.75 0 0 0-2.06 0L3.55 7.74c-.98.71-.48 2.26.73 2.26h.22v5.8A2.8 2.8 0 0 0 3 18.25v1.5c0 .41.34.75.75.75h7.42A5 5 0 0 1 11 19H4.5v-.75c0-.69.56-1.25 1.25-1.25h5.82q.47-.88 1.26-1.5h-.08V10h1.75v4.67q.6-.17 1.25-.17H16V10h2v4.5h1.5V10h.22c1.2 0 1.71-1.55.73-2.26zm-1.18 1.22q.15-.1.3 0l6.8 4.96H5.05zm-.6 6.46v5.5H9.5V10zM6 15.5V10h2v5.5zm17 3.75a3.75 3.75 0 0 0-3.75-3.75h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5V23h.2A3.75 3.75 0 0 0 23 19.25m-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75m3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75"
]);
const $e9fce37105e983ce$export$3302e9bfb2d22220 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink28Filled', "28", [
    "M13.11 2.3a1.5 1.5 0 0 1 1.78 0l9.5 7a1.5 1.5 0 0 1-.74 2.7H4.35a1.5 1.5 0 0 1-.74-2.7zm.9 6.7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5.5 4H22v5h-2.5zM13 22.75c0-1.03.32-1.97.87-2.75H6.25A3.25 3.25 0 0 0 3 23.25v.5c0 .41.34.75.75.75h9.58a5 5 0 0 1-.33-1.75m2-3.87c.7-.51 1.56-.83 2.5-.87V13H15zM13 19v-6h-2.5v6zm-4.5-6v6H6v-6zm9.24 7.5a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 0 1 0-7.5h.5a.75.75 0 0 1 0 1.5zM17 22.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75M23.25 25a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 0 1 0 7.5h-.5a.75.75 0 0 1 0-1.5z"
]);
const $e9fce37105e983ce$export$cebfdf95faddee57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink28Regular', "28", [
    "M14 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m.9-6.7a1.5 1.5 0 0 0-1.79 0l-9.5 7a1.5 1.5 0 0 0 .9 2.7H5v7.25c-1.18.49-2 1.65-2 3v1.5c0 .41.33.75.74.75h9.58q-.28-.7-.32-1.5H4.5v-.75c0-.97.78-1.75 1.74-1.75h7.32q.48-.88 1.27-1.5h-.09v-7h2.75v6H19v-6h2.5v6H23v-6h.5a1.5 1.5 0 0 0 .89-2.7zM6.5 19v-7H9v7zm6.75-7v7H10.5v-7zM4.5 10.5l9.5-7 9.5 7zm13.25 10a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 0 1 0-7.5h.5a.75.75 0 0 1 0 1.5zM17 22.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75M23.25 25a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 0 1 0 7.5h-.5a.75.75 0 0 1 0-1.5z"
]);
const $e9fce37105e983ce$export$b0682ba5630f713f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink48Filled', "48", [
    "M25.35 4.45c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 0 0 1.05 3.15h32.48c1.69 0 2.4-2.14 1.05-3.15zM24 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4M6 38.25C6 35.35 8.35 33 11.25 33h11.9a8.4 8.4 0 0 0-.28 8H7.25C6.56 41 6 40.44 6 39.75zm20-8.15a8 8 0 0 1 4-1.1v-7.5h-4zm8-1.1h4v-7.5h-4zm-20 2h-4v-9.5h4zm4-9.5V31h4v-9.5zM30.25 31a6.25 6.25 0 1 0 0 12.5h1.5a1.25 1.25 0 1 0 0-2.5h-1.5a3.75 3.75 0 1 1 0-7.5h1.5a1.25 1.25 0 1 0 0-2.5zm9.5 0a6.25 6.25 0 1 1 0 12.5h-1.5a1.25 1.25 0 1 1 0-2.5h1.5a3.75 3.75 0 1 0 0-7.5h-1.5a1.25 1.25 0 1 1 0-2.5zM29 37.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $e9fce37105e983ce$export$615e09a62c775101 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankLink48Regular', "48", [
    "M24 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1.35-9.55c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 0 0 1.05 3.15H9v12c-1.77.85-3 2.66-3 4.75v3.5c0 .7.56 1.25 1.25 1.25h15.62a8 8 0 0 1-.78-2.5H8.5v-2.25a2.75 2.75 0 0 1 2.75-2.75h11.62a8 8 0 0 1 2.38-2.89v-11.1h4.25V29H32v-9.5h4.5V29H39v-9.5h1.24c1.69 0 2.4-2.15 1.05-3.16zM22.75 31H18.5V19.5h4.25zM16 31h-4.5V19.5H16zm-5.99-14L24 6.56 37.99 17zm20.24 14a6.25 6.25 0 1 0 0 12.5h1.5a1.25 1.25 0 1 0 0-2.5h-1.5a3.75 3.75 0 1 1 0-7.5h1.5a1.25 1.25 0 1 0 0-2.5zm9.5 0a6.25 6.25 0 1 1 0 12.5h-1.5a1.25 1.25 0 1 1 0-2.5h1.5a3.75 3.75 0 1 0 0-7.5h-1.5a1.25 1.25 0 1 1 0-2.5zM29 37.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $e9fce37105e983ce$export$83275198f4b40d72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankToolbox20Filled', "20", [
    "M8.23 2.18a1.3 1.3 0 0 1 1.54 0l5.85 4.15A.92.92 0 0 1 15.1 8H2.9a.92.92 0 0 1-.52-1.67zM9 5.88A.83.83 0 1 0 9 4.2a.83.83 0 0 0 0 1.66M3.5 9v4h2V9zm.67 5C2.97 14 2 14.97 2 16.17v.33c0 .28.22.5.5.5H9v-3zm7.33-4V9h-2v3c.37-.5.91-.84 1.54-.96q.11-.58.46-1.04m-3 3V9h-2v4zm3.5-1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0z"
]);
const $e9fce37105e983ce$export$7eb34e0c1885f86c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankToolbox20Regular', "20", [
    "M9 5.87a.83.83 0 1 0 0-1.66.83.83 0 0 0 0 1.66M2.5 17H9v-1H3v-.83c0-.65.52-1.17 1.17-1.17H9v-.5q.02-.86.5-1.5V8H11v3.05h.04A2.5 2.5 0 0 1 12 9.5V8h2v1h1V8h.1a.92.92 0 0 0 .52-1.67L9.77 2.18a1.3 1.3 0 0 0-1.54 0L2.38 6.33A.92.92 0 0 0 2.9 8H3v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5M8.8 3a.3.3 0 0 1 .4 0l5.63 4H3.17zM4 13V8h2v5H4m4.5 0H7V8h1.5zm3.5-1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 1 0-1 0v.5h-3v-.5a.5.5 0 1 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0z"
]);
const $e9fce37105e983ce$export$b42218a2361e3487 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankToolbox24Filled', "24", [
    "M13.03 2.34a1.75 1.75 0 0 0-2.06 0l-7.42 5.4c-.98.72-.48 2.26.73 2.27H16V10h3.72c1.2 0 1.71-1.54.73-2.25zM12 5.26a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-.75 10.15q-.14.28-.2.6h-1.8v-5h2zm3.5-3.97A2.75 2.75 0 0 0 13 14v.05l-.25.06v-3.1h2zM11 17v3.5H3.75a.75.75 0 0 1-.75-.75v-.5C3 18.01 4 17 5.25 17zm-5.5-1h2.25v-5H5.5zm8.5-1h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zm-2 9a1.5 1.5 0 0 1-1.5-1.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5z"
]);
const $e9fce37105e983ce$export$936d248fc1850ecb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingBankToolbox24Regular', "24", [
    "M13 6.26a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.03-3.92a1.75 1.75 0 0 0-2.06 0l-7.42 5.4c-.98.72-.48 2.27.73 2.27h.22v5.8A2.8 2.8 0 0 0 3 18.24v1.5c0 .41.34.75.75.75H11V19H4.5v-.75c0-.69.56-1.25 1.25-1.25H11v-.5q0-.54.2-1H9.5V10h1.75v5.4a2.5 2.5 0 0 1 1.5-1.29v-4.1h1.75v1.54q.57-.3 1.25-.3H16v-1.24h2v1.24h1.25l.25.01v-1.25h.22c1.2 0 1.71-1.55.73-2.26zm-1.18 1.2q.15-.09.3 0l6.8 4.97H5.05zM6 15.5V10h2v5.5zm8-.5h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zm-2 9a1.5 1.5 0 0 1-1.5-1.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5z"
]);
const $e9fce37105e983ce$export$c4ee48fb6cc714b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingCheckmark16Filled', "16", [
    "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5v2.7A5.5 5.5 0 0 0 6.02 11H5.5a.5.5 0 0 0-.5.5V14H3.5a.5.5 0 0 1-.5-.5zM5.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m8.5 4a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $e9fce37105e983ce$export$5a4c4a80d657f9b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingCheckmark16Regular', "16", [
    "M6 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.5 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m.5 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M7.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5v2.7q-.52.16-1 .4V3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V13h1v-1.5c0-.28.22-.5.5-.5h.52a5.6 5.6 0 0 0 .58 3H3.5a.5.5 0 0 1-.5-.5zm13 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7"
]);
const $e9fce37105e983ce$export$48e8246f6750e0f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingCheckmark20Filled', "20", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5H7v-3.5c0-.28.22-.5.5-.5h1.52q.08-.84.39-1.58a.75.75 0 1 1 .75-1.3 5.5 5.5 0 0 1 5.81-1.92A1.5 1.5 0 0 0 14.5 8H13V3.5c0-.83-.67-1.5-1.5-1.5zm2 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.75 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.02 15c.1 1.13.55 2.17 1.24 3H8v-3zm9.98-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $e9fce37105e983ce$export$c84104f1b48f8a16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingCheckmark20Regular', "20", [
    "M6.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-.34 2.92q.28-.7.75-1.3a.75.75 0 1 0-.75 1.3M7.5 14h1.52a6 6 0 0 0 0 1H8v2h1.5v-.2q.3.64.76 1.2H4.5a.5.5 0 0 1-.5-.5v-14C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.73 0 1.33.51 1.47 1.2A6 6 0 0 0 14.5 9h-2a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5V17h2v-2.5c0-.28.22-.5.5-.5m11.5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $e9fce37105e983ce$export$713bcd1e41a36489 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingCloud24Filled', "24", [
    "M3.75 18h1.5a4.7 4.7 0 0 1 3.34-4.26A5.9 5.9 0 0 1 14 9.84V8.76C14 7.78 13.22 7 12.25 7h-1a.25.25 0 0 1-.25-.25v-3C11 2.78 10.22 2 9.25 2h-5.5C2.78 2 2 2.78 2 3.75v12.5c0 .97.78 1.75 1.75 1.75M6 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.5-3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.75 9.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-2.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.25 6.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m8.88 4.35a4.9 4.9 0 0 0-4.75 3.72 3.74 3.74 0 0 0 .6 7.43h8.28a3.74 3.74 0 0 0 .61-7.43 4.9 4.9 0 0 0-4.75-3.72m-3.37 4.5a3.39 3.39 0 0 1 6.73 0l.08.68h.7a2.24 2.24 0 0 1 0 4.47H9.98a2.24 2.24 0 0 1 0-4.48h.7z"
]);
const $e9fce37105e983ce$export$79ed8ddcdc69dcd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingCloud24Regular', "24", [
    "M3.5 3.75c0-.14.11-.25.25-.25h5.5c.14 0 .25.11.25.25v3c0 .97.78 1.75 1.75 1.75h1q.23.02.25.25v1.32q.72-.2 1.5-.22v-1.1C14 7.78 13.22 7 12.25 7h-1a.25.25 0 0 1-.25-.25v-3C11 2.78 10.22 2 9.25 2h-5.5C2.78 2 2 2.78 2 3.75v12.5c0 .97.78 1.75 1.75 1.75h1.5q.06-.8.34-1.5H3.75a.25.25 0 0 1-.25-.25zM5.25 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.5-6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6.38-1.65a4.9 4.9 0 0 0-4.75 3.72 3.74 3.74 0 0 0 .6 7.43h8.28a3.74 3.74 0 0 0 .61-7.43 4.9 4.9 0 0 0-4.75-3.72m-3.37 4.5a3.39 3.39 0 0 1 6.73 0l.08.68h.7a2.24 2.24 0 0 1 0 4.47H9.98a2.24 2.24 0 0 1 0-4.48h.7z"
]);
const $e9fce37105e983ce$export$816f92077517cdb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop16Filled', "16", [
    "M2 2.25C2 1.56 2.56 1 3.25 1h4.5c.7 0 1.26.56 1.25 1.25v2c0 .14.11.25.25.25h.5A1.25 1.25 0 0 1 11 5.75V6H7.75A2.75 2.75 0 0 0 5 8.75v2.5q0 .39.1.75H3.25C2.56 12 2 11.44 2 10.75zM4 3.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M4 7.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M6.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 5.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m0 3.25C6 7.78 6.78 7 7.75 7h5.5c.97 0 1.75.78 1.75 1.75v2.5c0 .97-.78 1.75-1.75 1.75H12v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H9v-1H7.75C6.78 13 6 12.22 6 11.25zM7.75 12h5.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75M11 14v-1h-1v1z"
]);
const $e9fce37105e983ce$export$ed784480bc79d258 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop16Regular', "16", [
    "M3 2.25c0-.14.11-.25.25-.25h4.5c.14 0 .26.11.25.25v2c0 .69.56 1.25 1.25 1.25h.5c.14 0 .25.11.25.25V6h1v-.3a1.25 1.25 0 0 0-1.25-1.2h-.5A.25.25 0 0 1 9 4.25v-2C9 1.56 8.45 1 7.75 1h-4.5C2.56 1 2 1.56 2 2.25v8.5c0 .69.56 1.25 1.25 1.25H5.1q-.1-.36-.1-.75V11H3.25a.25.25 0 0 1-.25-.25zM4.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M7 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 8.75C6 7.78 6.78 7 7.75 7h5.5c.97 0 1.75.78 1.75 1.75v2.5c0 .97-.78 1.75-1.75 1.75H12v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H9v-1H7.75C6.78 13 6 12.22 6 11.25zM7.75 12h5.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75M11 14v-1h-1v1z"
]);
const $e9fce37105e983ce$export$ee73e3eea10a0db6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop20Filled', "20", [
    "M2 3.25C2 2.56 2.56 2 3.25 2h5.5C9.44 2 10 2.56 10 3.25v2.5c0 .14.11.25.25.25h1.5c.69 0 1.25.56 1.25 1.25V8h-3c-.82 0-1.57.33-2.1.86A.75.75 0 1 0 7.16 10 3 3 0 0 0 7 11v4H3.25C2.56 15 2 14.44 2 13.75zM8.27 10A2 2 0 0 1 10 9h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2v1h1.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1H12v-1h-2a2 2 0 0 1-2-2v-4q0-.54.27-1M10 10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zM4 4.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M4 9.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M7.25 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6.5 7A.75.75 0 1 0 8 7a.75.75 0 0 0-1.5 0M14 18v-1h-1v1z"
]);
const $e9fce37105e983ce$export$48eb099d75fa30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop20Regular', "20", [
    "M3 3.25c0-.14.11-.25.25-.25h5.5c.14 0 .25.11.25.25v2.5C9 6.44 9.56 7 10.25 7h1.5c.14 0 .25.11.25.25V8h1v-.75C13 6.56 12.44 6 11.75 6h-1.5a.25.25 0 0 1-.25-.25v-2.5C10 2.56 9.44 2 8.75 2h-5.5C2.56 2 2 2.56 2 3.25v10.5c0 .69.56 1.25 1.25 1.25H7v-1H3.25a.25.25 0 0 1-.25-.25zM7.25 8.5c.27 0 .51.15.64.36A3 3 0 0 0 7.17 10a.75.75 0 0 1 .08-1.5m-2.5-3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M5.5 7A.75.75 0 1 1 4 7a.75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8 11c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2v1h1.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1H12v-1h-2a2 2 0 0 1-2-2zm2 5h7a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m4 2v-1h-1v1z"
]);
const $e9fce37105e983ce$export$3cdfafb4715ef6cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop24Filled', "24", [
    "M8.5 12.75v4q0 .65.22 1.25H3.5A1.5 1.5 0 0 1 2 16.5v-13A1.5 1.5 0 0 1 3.5 2h6A1.5 1.5 0 0 1 11 3.5V7h1.5A1.5 1.5 0 0 1 14 8.5V9h-1.75a3.75 3.75 0 0 0-3.75 3.75m-.33-7.62A1 1 0 0 0 7.75 5a.76.76 0 0 0-.75.75.75.75 0 1 0 1.17-.62m0 3A1 1 0 0 0 7.75 8a.76.76 0 0 0-.75.75.75.75 0 1 0 1.17-.62m-3.34 4.24q.2.13.42.13a.76.76 0 0 0 .75-.75.75.75 0 1 0-1.17.62m0-3q.2.13.42.13A.76.76 0 0 0 6 8.75a.75.75 0 1 0-1.17.62m0-3q.2.13.42.13A.76.76 0 0 0 6 5.75a.75.75 0 1 0-1.17.62m2.5 6q.2.13.42.13a.76.76 0 0 0 .75-.75.75.75 0 1 0-1.17.62m2.17.38A2.75 2.75 0 0 1 12.25 10h7A2.75 2.75 0 0 1 22 12.75v4a2.75 2.75 0 0 1-2.75 2.75H18v1h1.25a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5h1.25v-1h-1.25a2.75 2.75 0 0 1-2.75-2.75zM15 19.5v1h1.5v-1zm-2.75-8c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h7c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25z"
]);
const $e9fce37105e983ce$export$eb266035506ae6dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop24Regular', "24", [
    "M3.75 3.5a.25.25 0 0 0-.25.25v12.5c0 .14.11.25.25.25H8.5v.25q0 .64.21 1.25H3.75C2.78 18 2 17.22 2 16.25V3.75C2 2.78 2.78 2 3.75 2h5.5c.97 0 1.75.78 1.75 1.75v3c0 .14.11.25.25.25h1c.97 0 1.75.78 1.75 1.75V9h-1.5v-.25a.25.25 0 0 0-.25-.25h-1c-.97 0-1.75-.78-1.75-1.75v-3a.25.25 0 0 0-.25-.25zM6 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.25 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m1.75.25A2.75 2.75 0 0 1 12.25 10h7A2.75 2.75 0 0 1 22 12.75v4a2.75 2.75 0 0 1-2.75 2.75H18v1h1.25a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5h1.25v-1h-1.25a2.75 2.75 0 0 1-2.75-2.75zM15 19.5v1h1.5v-1zm-2.75-8c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h7c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25z"
]);
const $e9fce37105e983ce$export$c77175e404642c0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop32Filled', "32", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h7.5C14.55 2 16 3.46 16 5.25V8a1 1 0 0 0 1 1 3 3 0 0 1 3 3v.5h-2.75a4.75 4.75 0 0 0-4.75 4.75v5.5q0 1.23.57 2.25H5.25A3.25 3.25 0 0 1 2 21.75zM17.25 16c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25zm9.5 10H25v2h1a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h1v-2h-1.75A3.25 3.25 0 0 1 14 22.75v-5.5c0-1.8 1.46-3.25 3.25-3.25h9.5c1.8 0 3.25 1.46 3.25 3.25v5.5c0 1.8-1.46 3.25-3.25 3.25M21 28h2v-2h-2zM8 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $e9fce37105e983ce$export$7cb2eec76b330dfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingDesktop32Regular', "32", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v16.5C2 23.55 3.46 25 5.25 25h7.81a5 5 0 0 1-.55-2H5.25C4.56 23 4 22.44 4 21.75V5.25C4 4.56 4.56 4 5.25 4h7.5c.69 0 1.25.56 1.25 1.25V8a3 3 0 0 0 3 3 1 1 0 0 1 1 1v.5h2V12a3 3 0 0 0-3-3 1 1 0 0 1-1-1V5.25C16 3.45 14.54 2 12.75 2zm12 12h9.5c1.8 0 3.25 1.46 3.25 3.25v5.5c0 1.8-1.46 3.25-3.25 3.25H25v2h1a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h1v-2h-1.75A3.25 3.25 0 0 1 14 22.75v-5.5c0-1.8 1.46-3.25 3.25-3.25M21 28h2v-2h-2zm5.75-4c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-9.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25zM8 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $e9fce37105e983ce$export$d7090800548e8827 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory16Filled', "16", [
    "M1.46 2.44c.03-.8.7-1.44 1.5-1.44h1.08c.8 0 1.47.64 1.5 1.44l.42 11A1.5 1.5 0 0 1 4.46 15H2.54a1.5 1.5 0 0 1-1.5-1.56zm5 12.56q.51-.68.5-1.6L6.7 6.82l3.48-2.71a.5.5 0 0 1 .81.39v2.4l3.17-2.78a.5.5 0 0 1 .83.38v9c0 .83-.67 1.5-1.5 1.5zM13 14v-3.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V14z"
]);
const $e9fce37105e983ce$export$7d59fe06f6d72338 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory16Regular', "16", [
    "M1.46 2.44c.03-.8.7-1.44 1.5-1.44h1.08c.8 0 1.47.64 1.5 1.44l.42 11A1.5 1.5 0 0 1 4.46 15H2.54a1.5 1.5 0 0 1-1.5-1.56zM2.96 2a.5.5 0 0 0-.5.48l-.42 11a.5.5 0 0 0 .5.52h1.92a.5.5 0 0 0 .5-.52l-.42-11a.5.5 0 0 0-.5-.48zM13.5 15c.83 0 1.5-.67 1.5-1.5v-9a.5.5 0 0 0-.85-.35L11 7.29V4.5a.5.5 0 0 0-.83-.37L6.72 7.19l.05 1.3L10 5.6V8.5a.5.5 0 0 0 .85.35L14 5.71v7.79a.5.5 0 0 1-.5.5H13v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3H6.91q-.11.55-.45 1zM9 14v-3h3v3z"
]);
const $e9fce37105e983ce$export$395c747cb2a13b31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory20Filled', "20", [
    "M2.94 3.4c.05-.79.7-1.4 1.5-1.4h1.12c.8 0 1.45.61 1.5 1.4l.87 13a1.5 1.5 0 0 1-1.5 1.6H3.57a1.5 1.5 0 0 1-1.5-1.6zM8.44 18q.53-.7.49-1.67L8.4 8.51l3.76-3.38a.5.5 0 0 1 .84.37v3.38l4.16-3.75a.5.5 0 0 1 .84.37v11c0 .83-.67 1.5-1.5 1.5zM16 17v-4.2a.8.8 0 0 0-.8-.8h-3.4a.8.8 0 0 0-.8.8V17z"
]);
const $e9fce37105e983ce$export$9708a90f85482a21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory20Regular', "20", [
    "M4.44 2a1.5 1.5 0 0 0-1.5 1.4l-.87 13a1.5 1.5 0 0 0 1.5 1.6h2.86a1.5 1.5 0 0 0 1.5-1.6l-.87-13A1.5 1.5 0 0 0 5.56 2zm-.5 1.47a.5.5 0 0 1 .5-.47h1.12c.27 0 .49.2.5.47l.87 13a.5.5 0 0 1-.5.53H3.57a.5.5 0 0 1-.5-.53zM16.5 18H8.43q.34-.45.45-1H10v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4h.5a.5.5 0 0 0 .5-.5V6.62l-4.17 3.75A.5.5 0 0 1 12 10V6.62L8.49 9.78 8.4 8.51l3.76-3.38a.5.5 0 0 1 .84.37v3.38l4.16-3.75a.5.5 0 0 1 .84.37v11c0 .83-.67 1.5-1.5 1.5M11 17h4v-4h-4z"
]);
const $e9fce37105e983ce$export$1039ed6f73e9c4b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory24Filled', "24", [
    "M2.92 4.13A2.25 2.25 0 0 1 5.17 2h1.16c1.2 0 2.18.93 2.24 2.13l.84 15.5A2.25 2.25 0 0 1 7.17 22H4.33a2.25 2.25 0 0 1-2.24-2.37zM9.52 22h10.23c1.24 0 2.25-1 2.25-2.25V6a.75.75 0 0 0-1.26-.55l-5.24 4.84V6a.75.75 0 0 0-1.26-.55L9.87 9.49l.54 10.08c.05.94-.3 1.8-.9 2.43M13 16a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4.5h-6z"
]);
const $e9fce37105e983ce$export$eaa4796d5d789f4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory24Regular', "24", [
    "M5.17 2c-1.2 0-2.18.93-2.25 2.13l-.83 15.5A2.25 2.25 0 0 0 4.33 22h2.84a2.25 2.25 0 0 0 2.24-2.37l-.84-15.5A2.25 2.25 0 0 0 6.33 2zm-.75 2.21c.02-.4.35-.71.75-.71h1.16c.4 0 .73.31.75.71l.83 15.5c.03.43-.31.79-.74.79H4.33a.75.75 0 0 1-.75-.8zM9.52 22q.6-.63.8-1.5h1.18v-4.25c0-.97.78-1.75 1.75-1.75h4c.97 0 1.75.78 1.75 1.75v4.25h.75c.41 0 .75-.34.75-.75V7.71l-5.24 4.84A.75.75 0 0 1 14 12V7.71l-4.03 3.72-.1-1.94 4.37-4.04A.75.75 0 0 1 15.5 6v4.29l5.24-4.84A.75.75 0 0 1 22 6v13.75c0 1.24-1 2.25-2.25 2.25zM13 16.25v4.25h4.5v-4.25a.25.25 0 0 0-.25-.25h-4a.25.25 0 0 0-.25.25"
]);
const $e9fce37105e983ce$export$33d0cc04d1625209 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory28Filled', "28", [
    "M2.94 4.15A2.25 2.25 0 0 1 5.19 2h2.13c1.2 0 2.19.95 2.24 2.15l.87 19.5A2.25 2.25 0 0 1 8.18 26H4.32a2.25 2.25 0 0 1-2.25-2.35zM10.53 26c.59-.62.94-1.47.9-2.4l-.54-12.1 5.86-5.3a.75.75 0 0 1 1.25.55v5.56l6.75-6.12a.75.75 0 0 1 1.25.56v16.5A2.75 2.75 0 0 1 23.25 26zM22 24.5v-6.25c0-.69-.56-1.25-1.25-1.25h-4.5c-.69 0-1.25.56-1.25 1.25v6.25z"
]);
const $e9fce37105e983ce$export$8e4eee13cfd07ab0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory28Regular', "28", [
    "M5.19 2c-1.2 0-2.2.95-2.25 2.15l-.87 19.5A2.25 2.25 0 0 0 4.32 26h3.86c1.28 0 2.3-1.07 2.25-2.35l-.87-19.5A2.25 2.25 0 0 0 7.32 2zm-.75 2.22c.01-.4.34-.72.75-.72h2.13c.4 0 .73.32.74.72l.87 19.5a.75.75 0 0 1-.75.78H4.32a.75.75 0 0 1-.75-.78zM10.53 26q.6-.63.82-1.5H13v-6.75c0-.69.56-1.25 1.25-1.25h7c.7 0 1.25.56 1.25 1.25v6.75h.75c.7 0 1.25-.56 1.25-1.25V8.45l-6.75 6.1A.75.75 0 0 1 16.5 14V8.44l-5.52 5-.09-1.94 5.86-5.3a.75.75 0 0 1 1.25.55v5.56l6.75-6.12a.75.75 0 0 1 1.25.56v16.5A2.75 2.75 0 0 1 23.25 26zm3.97-1.5H21V18h-6.5z"
]);
const $e9fce37105e983ce$export$d92f1907893208c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory32Filled', "32", [
    "M2.82 4.9a3 3 0 0 1 3-2.9h2.36a3 3 0 0 1 3 2.9l.75 22a3 3 0 0 1-3 3.1H5.07a3 3 0 0 1-3-3.1zM11.58 30c.86-.76 1.4-1.9 1.35-3.14l-.47-13.73 6.83-6.84A1 1 0 0 1 21 7v6.59l7.3-7.3A1 1 0 0 1 30 7v19.5a3.5 3.5 0 0 1-3.48 3.5H11.58M25 20.5c0-.83-.67-1.5-1.5-1.5h-5c-.83 0-1.5.67-1.5 1.5V28h8z"
]);
const $e9fce37105e983ce$export$fed5a627aab1182d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory32Regular', "32", [
    "M5.82 2a3 3 0 0 0-3 2.9l-.75 22a3 3 0 0 0 3 3.1h3.86a3 3 0 0 0 3-3.1l-.75-22a3 3 0 0 0-3-2.9zm-1 2.97a1 1 0 0 1 1-.97h2.36a1 1 0 0 1 1 .97l.75 22a1 1 0 0 1-1 1.03H5.07a1 1 0 0 1-1-1.03zM11.58 30H26.5a3.5 3.5 0 0 0 3.5-3.5V7a1 1 0 0 0-1.7-.7L21 13.58V7a1 1 0 0 0-1.7-.7l-6.84 6.83.1 2.73L19 9.41V16a1 1 0 0 0 1.7.7L28 9.42V26.5c0 .83-.67 1.5-1.5 1.5H26v-7.5c0-.83-.67-1.5-1.5-1.5h-8c-.83 0-1.5.67-1.5 1.5V28h-2.2a4 4 0 0 1-1.22 2M17 28v-7h7v7z"
]);
const $e9fce37105e983ce$export$767ec98d0adfb3c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory48Filled', "48", [
    "M5.6 7.78a4.25 4.25 0 0 1 4.24-4.03h3.31a4.25 4.25 0 0 1 4.25 4.03l1.68 31.75A4.25 4.25 0 0 1 14.84 44H8.16a4.25 4.25 0 0 1-4.24-4.47zM19.42 44a6.2 6.2 0 0 0 1.66-4.58L20 19.22l9.1-9.1a1.25 1.25 0 0 1 2.14.88v9.98l10.87-10.86a1.25 1.25 0 0 1 2.13.89l-.22 27.78A5.25 5.25 0 0 1 38.78 44zm18.08-2.5v-9.75c0-.97-.78-1.75-1.75-1.75h-8c-.97 0-1.75.78-1.75 1.75v9.75z"
]);
const $e9fce37105e983ce$export$aca703bbc045258b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingFactory48Regular', "48", [
    "M9.84 3.75A4.25 4.25 0 0 0 5.6 7.78L3.92 39.53A4.25 4.25 0 0 0 8.16 44h6.68a4.25 4.25 0 0 0 4.24-4.47L17.4 7.78a4.25 4.25 0 0 0-4.25-4.03zM8.1 7.91c.05-.93.81-1.66 1.74-1.66h3.31c.93 0 1.7.73 1.75 1.66l1.68 31.75c.06 1-.74 1.84-1.74 1.84H8.16c-1 0-1.8-.84-1.75-1.84zM19.42 44a6 6 0 0 0 1.42-2.5h2.66V31.25c0-.97.78-1.75 1.75-1.75h11c.97 0 1.75.78 1.75 1.75V41.5h.78a2.75 2.75 0 0 0 2.75-2.73l.2-24.73-10.85 10.84a1.25 1.25 0 0 1-2.13-.88v-9.98l-8.56 8.56-.18-3.36 9.1-9.1a1.25 1.25 0 0 1 2.14.88v9.98l10.87-10.86a1.25 1.25 0 0 1 2.13.89l-.22 27.78A5.25 5.25 0 0 1 38.78 44zM26 41.5h9.5V32H26z"
]);
const $e9fce37105e983ce$export$30169783d3e9ed42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment16Color', "16", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M7 2h1v2.5H7z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M7 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_16_color__a)",
            "d": "M4 8a4 4 0 1 1 8 0v1.5H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_16_color__b)",
            "d": "M4 8a4 4 0 1 1 8 0v1.5H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_16_color__c)",
            "d": "M1 10.5C1 9.67 1.67 9 2.5 9h11c.83 0 1.5.67 1.5 1.5v4a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_16_color__d)",
            "fillOpacity": ".6",
            "d": "M1 10.5C1 9.67 1.67 9 2.5 9h11c.83 0 1.5.67 1.5 1.5v4a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#55595e",
            "d": "M6.5 12a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3h-3z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M4.5 11c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m7.5.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M9.5 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-3 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.96154 -4.26938 0 10.8 4.85)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(97.27 3.1 10.72)scale(3.45637 7.92075)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_16_color__a",
                "x1": "8",
                "x2": "8",
                "y1": "4",
                "y2": "9.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_16_color__c",
                "x1": "6.47",
                "x2": "12.68",
                "y1": "9",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$7928b74a59856a5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment16Filled', "16", [
    "M8 3v1a4 4 0 0 1 4 4v1h1.5c.83 0 1.5.67 1.5 1.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2.25a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25v2.25a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4C1 9.67 1.67 9 2.5 9H4V8a4 4 0 0 1 3.02-3.88L7 4V1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5zm-3.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m7.5.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM9.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M7 7.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
]);
const $e9fce37105e983ce$export$a01805f8ff58fde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment16Regular', "16", [
    "M7.5 1a.5.5 0 0 0-.5.5V4q0 .06.02.12A4 4 0 0 0 4 8v1H2.5C1.67 9 1 9.67 1 10.5v4c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-4c0-.83-.67-1.5-1.5-1.5H12V8a4 4 0 0 0-4-4V3h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2 13v-2.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V14H2v-3.5c0-.28.22-.5.5-.5h2a.5.5 0 0 0 .5-.5V8a3 3 0 0 1 6 0v1.5c0 .28.22.5.5.5h2c.28 0 .5.22.5.5V14zm-5-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m7.5.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM9.5 7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-3 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m2 7h-1v-2h1z"
]);
const $e9fce37105e983ce$export$d7053a883abdd2b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment20Color', "20", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M9 3h1v2.5H9z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_20_color__a)",
            "d": "M10 5a5 5 0 0 0-5 5v1.5h10V10a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_20_color__b)",
            "d": "M10 5a5 5 0 0 0-5 5v1.5h10V10a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_20_color__c)",
            "d": "M4 11a2 2 0 0 0-2 2v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_20_color__d)",
            "fillOpacity": ".6",
            "d": "M4 11a2 2 0 0 0-2 2v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "#55595e",
            "d": "M8 15v3h4v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M6 13.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M8.5 7.5A.5.5 0 0 0 8 8v1a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5M12 8a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.5 -5.33673 0 13.5 6)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-.5 4 -8.9853 -1.12316 17 11)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_20_color__a",
                "x1": "10",
                "x2": "10",
                "y1": "5",
                "y2": "11.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_20_color__c",
                "x1": "8.25",
                "x2": "15.5",
                "y1": "11",
                "y2": "18.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$e1285e2faee33757 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment20Filled', "20", [
    "M9.5 2a.5.5 0 0 0-.5.5v2.6A5 5 0 0 0 5 10v1H4a2 2 0 0 0-2 2v4a1 1 0 0 0 1 1h4.5a.5.5 0 0 0 .5-.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2c0 .28.22.5.5.5H17a1 1 0 0 0 1-1v-4a2 2 0 0 0-2-2h-1v-1a5 5 0 0 0-5-5V4h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM6 13.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0m8.5-.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5M9 9.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0m2.5-.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5"
]);
const $e9fce37105e983ce$export$b2cfe0d4db9c8e59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment20Regular', "20", [
    "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5H10v1a5 5 0 0 1 5 5v1h1a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4c0-1.1.9-2 2-2h1v-1a5 5 0 0 1 4-4.9zm7 9.5h-1.5a.5.5 0 0 1-.5-.5V10a4 4 0 0 0-8 0v1.5a.5.5 0 0 1-.5.5H4a1 1 0 0 0-1 1v4h5v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h5v-4a1 1 0 0 0-1-1M6 13.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm9 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zM8.5 9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m3.5.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zM9 17h2v-2H9z"
]);
const $e9fce37105e983ce$export$804d56c0a8c8a15f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment24Color', "24", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M11 4.5h1.5v2H11z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M11 2.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_24_color__a)",
            "d": "M5 13a7 7 0 0 1 14 0v.5H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_24_color__b)",
            "d": "M5 13a7 7 0 0 1 14 0v.5H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_24_color__c)",
            "d": "M2 15.5A2.5 2.5 0 0 1 4.5 13h15a2.5 2.5 0 0 1 2.5 2.5v5.75c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_24_color__d)",
            "fillOpacity": ".6",
            "d": "M2 15.5A2.5 2.5 0 0 1 4.5 13h15a2.5 2.5 0 0 1 2.5 2.5v5.75c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "#55595e",
            "d": "M9.5 17.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75V22h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M5.75 15.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m13.25.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M16 9.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM12 9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m-2.5.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4.03846 -7.47142 0 16.9 7.15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(96.93 4.62 15.69)scale(5.1807 11.3238)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_24_color__a",
                "x1": "12",
                "x2": "12",
                "y1": "6",
                "y2": "13.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_24_color__c",
                "x1": "9.81",
                "x2": "19.14",
                "y1": "13",
                "y2": "22.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$5801a04bd3726ebb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment24Filled', "24", [
    "M15.5 2h-3.75a.75.75 0 0 0-.75.75v3.32A7 7 0 0 0 5 13h-.75C3.01 13 2 14 2 15.25v6c0 .41.34.75.75.75H10q.23-.02.25-.25v-3c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v3q.02.23.25.25h7.25c.41 0 .75-.34.75-.75v-6c0-1.24-1-2.25-2.25-2.25H19a7 7 0 0 0-6.5-6.98V5h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5m0 9.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0M11.75 11c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0v-2c0-.41.34-.75.75-.75m-2.25.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0M5.75 15.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m13.25.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0"
]);
const $e9fce37105e983ce$export$3fcbdcb7371d706e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment24Regular', "24", [
    "M15.5 11.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0zM11.75 11c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0v-2c0-.41.34-.75.75-.75m-2.25.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0zM5.75 15.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m13.25.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zM11.75 2h3.75c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-3v1.02A7 7 0 0 1 19 13h.75c1.24 0 2.25 1 2.25 2.25v6c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75v-6C2 14.01 3 13 4.25 13H5a7 7 0 0 1 6-6.93V2.75c0-.41.34-.75.75-.75M12 7.5A5.5 5.5 0 0 0 6.5 13v.75c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 0-.75.75v5.25h6v-2.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v2.75h6v-5.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 1-.75-.75V13A5.5 5.5 0 0 0 12 7.5m1 11h-2v2h2z"
]);
const $e9fce37105e983ce$export$c19a0da2d90dbdde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment32Color', "32", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M15 5h2v3h-2z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M15 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_32_color__a)",
            "d": "M7 16a9 9 0 1 1 18 0v1H7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_32_color__b)",
            "d": "M7 16a9 9 0 1 1 18 0v1H7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_32_color__c)",
            "d": "M2 19a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_32_color__d)",
            "fillOpacity": ".6",
            "d": "M2 19a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "#55595e",
            "d": "M13 23a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6h-6z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M8 20a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m17 1a1 1 0 1 0-2 0v3a1 1 0 0 0 2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M21 12a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm-5-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m-3 1a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.38462 -9.60611 0 22.3 8.54)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(96.72 7.01 20.56)scale(7.47993 15.8603)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_32_color__a",
                "x1": "16",
                "x2": "16",
                "y1": "7",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_32_color__c",
                "x1": "12.94",
                "x2": "26.42",
                "y1": "16",
                "y2": "29.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$c2b069bcdfadadce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment32Filled', "32", [
    "M20.67 2H16a1 1 0 0 0-1 1v4.05A9 9 0 0 0 7 16H5a3 3 0 0 0-3 3v9a1 1 0 0 0 1 1h10v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4h10a1 1 0 0 0 1-1v-9a3 3 0 0 0-3-3h-2a9 9 0 0 0-8-8.95V6h3.67c.37 0 .66-.3.66-.67V2.67c0-.37-.3-.67-.66-.67M12 13a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m8 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-3 1v3a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0m-9 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m16 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1"
]);
const $e9fce37105e983ce$export$6f8baaa5130d99fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernment32Regular', "32", [
    "M21 14a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-5-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-3 1a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-5 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1m17 1a1 1 0 1 0-2 0v3a1 1 0 0 0 2 0zM16 2h4.67c.37 0 .66.3.66.67v2.66c0 .37-.3.67-.66.67H17v1.05A9 9 0 0 1 25 16h2a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9a3 3 0 0 1 3-3h2a9 9 0 0 1 8-8.95V3a1 1 0 0 1 1-1m0 7a7 7 0 0 0-7 7v1a1 1 0 0 1-1 1H5a1 1 0 0 0-1 1v8h8.5v-3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3H28v-8a1 1 0 0 0-1-1h-3a1 1 0 0 1-1-1v-1a7 7 0 0 0-7-7m1.5 16h-3v2h3z"
]);
const $e9fce37105e983ce$export$164bd91f094e62fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch16Color', "16", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M7 2h1v2.5H7z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M7 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__a)",
            "d": "M4 8a4 4 0 1 1 8 0v1.5H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__b)",
            "d": "M4 8a4 4 0 1 1 8 0v1.5H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__c)",
            "d": "M4 8a4 4 0 1 1 8 0v1.5H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__d)",
            "d": "M2.5 9C1.67 9 1 9.67 1 10.5V12h.2a2.75 2.75 0 0 0 4.3.39L8.03 15h6.47a.5.5 0 0 0 .5-.5v-4c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__e)",
            "fillOpacity": ".5",
            "d": "M2.5 9C1.67 9 1 9.67 1 10.5V12h.2a2.75 2.75 0 0 0 4.3.39L8.03 15h6.47a.5.5 0 0 0 .5-.5v-4c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__f)",
            "fillOpacity": ".6",
            "d": "M2.5 9C1.67 9 1 9.67 1 10.5V12h.2a2.75 2.75 0 0 0 4.3.39L8.03 15h6.47a.5.5 0 0 0 .5-.5v-4c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__g)",
            "fillOpacity": ".6",
            "d": "M2.5 9C1.67 9 1 9.67 1 10.5V12h.2a2.75 2.75 0 0 0 4.3.39L8.03 15h6.47a.5.5 0 0 0 .5-.5v-4c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M12 11.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M9.5 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-3 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__h)",
            "d": "M6.25 10.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_16_color__i)",
            "fillRule": "evenodd",
            "d": "M3.5 7a3.5 3.5 0 1 0 1.89 6.45l2.33 2.33a.75.75 0 0 0 1.06-1.06l-2.33-2.33q.54-.84.55-1.89A3.5 3.5 0 0 0 3.5 7m-2 3.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__a",
                "x1": "8",
                "x2": "8",
                "y1": "4",
                "y2": "9.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__d",
                "x1": "6.47",
                "x2": "12.68",
                "y1": "9",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__e",
                "x1": "5.81",
                "x2": "9.72",
                "y1": "14.57",
                "y2": "9.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopOpacity": ".69"
                }
            ],
            [
                "stop",
                {
                    "offset": ".62",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__h",
                "x1": "4.88",
                "x2": ".75",
                "y1": "8.67",
                "y2": "13.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__i",
                "x1": ".47",
                "x2": "8.05",
                "y1": "15.05",
                "y2": "8.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.96154 -4.26938 0 10.8 4.85)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.4 -4.91154 4.85578 4.35005 3.6 11.91)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".49",
                    "stopColor": "#e67505"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#e67505",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-44.4 15.24 1.67)scale(6.12438 6.12307)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".12"
                }
            ],
            [
                "stop",
                {
                    "offset": ".88",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_16_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(97.27 3.1 10.72)scale(3.45637 7.92075)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$d65967730e7377d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch16Filled', "16", [
    "M8 3v1a4 4 0 0 1 4 4v1h1.5c.83 0 1.5.67 1.5 1.5v4a.5.5 0 0 1-.5.5H9.92a2 2 0 0 0-.36-.56L9 13.88v-1.63a.25.25 0 0 0-.25-.25h-1a4.5 4.5 0 0 0-3.27-5.9 4 4 0 0 1 2.54-1.98L7 4V1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5zm4 8.5a.5.5 0 0 0-1 0v1a.5.5 0 1 0 1 0zM9.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.5-.5m-6 7c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 12.6A3.5 3.5 0 1 0 3.5 14m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $e9fce37105e983ce$export$e08b8054a118da32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch16Regular', "16", [
    "M8 4V3h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5V4q0 .06.02.12a4 4 0 0 0-2.54 1.99q.5.1.96.33A3 3 0 0 1 11 8v1.5c0 .28.22.5.5.5h2c.28 0 .5.22.5.5V14H9.5v-2.25a.75.75 0 0 0-.75-.75h-.78q-.05.52-.23 1h.76v1.38l1.06 1.06q.25.25.36.56h4.58a.5.5 0 0 0 .5-.5v-4c0-.83-.67-1.5-1.5-1.5H12V8a4 4 0 0 0-4-4m4 7.5a.5.5 0 0 0-1 0v1a.5.5 0 1 0 1 0zM9.5 7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-6 7c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 12.6A3.5 3.5 0 1 0 3.5 14m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $e9fce37105e983ce$export$91ee05759a8f755a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch20Color', "20", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M9 3h1v2.5H9z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__a)",
            "d": "M10 5a5 5 0 0 0-5 5v1.5h10V10a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__b)",
            "d": "M10 5a5 5 0 0 0-5 5v1.5h10V10a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__c)",
            "d": "M10 5a5 5 0 0 0-5 5v1.5h10V10a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__d)",
            "d": "M2 13c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H9l-2-2c-.33.33-1.3 1-2.5 1s-2.17-.67-2.5-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__e)",
            "fillOpacity": ".5",
            "d": "M2 13c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H9l-2-2c-.33.33-1.3 1-2.5 1s-2.17-.67-2.5-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__f)",
            "fillOpacity": ".6",
            "d": "M2 13c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H9l-2-2c-.33.33-1.3 1-2.5 1s-2.17-.67-2.5-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__g)",
            "fillOpacity": ".6",
            "d": "M2 13c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H9l-2-2c-.33.33-1.3 1-2.5 1s-2.17-.67-2.5-1z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M15 13.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M8.5 7.5A.5.5 0 0 0 8 8v1a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5M12 8a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__h)",
            "d": "M7.5 13.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_20_color__i)",
            "fillRule": "evenodd",
            "d": "M4.5 9.5a4 4 0 1 0 2.25 7.3l1.97 1.98a.75.75 0 0 0 1.06-1.06l-1.97-1.97A4 4 0 0 0 4.5 9.5m-2.5 4a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__a",
                "x1": "10",
                "x2": "10",
                "y1": "5",
                "y2": "11.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__d",
                "x1": "8.25",
                "x2": "15.5",
                "y1": "11",
                "y2": "18.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__e",
                "x1": "7.5",
                "x2": "12.08",
                "y1": "17.5",
                "y2": "12.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopOpacity": ".69"
                }
            ],
            [
                "stop",
                {
                    "offset": ".62",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__h",
                "x1": "6",
                "x2": "1.5",
                "y1": "11.5",
                "y2": "16.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__i",
                "x1": "1",
                "x2": "9",
                "y1": "18",
                "y2": "11.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -5 5 5 4.5 13.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".49",
                    "stopColor": "#e67505"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#e67505",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.5 -5.33673 0 13.5 6)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -5 5 5 4.5 13.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".12"
                }
            ],
            [
                "stop",
                {
                    "offset": ".88",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-.5 4 -8.9853 -1.12316 17 11)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$e42441c060118cab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch20Filled', "20", [
    "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5H10v1a5 5 0 0 1 5 5v1h1a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1h-4.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5H8.74a4.5 4.5 0 0 0-.02-3.05.5.5 0 0 0 .28-.45v-2a.5.5 0 1 0-1 0v1.17a4.5 4.5 0 0 0-2.9-1.63A5 5 0 0 1 9 5.1zm6 11a.5.5 0 0 0-1 0v2a.5.5 0 1 0 1 0zm-3-4a.5.5 0 0 0-1 0v2a.5.5 0 1 0 1 0zM4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $e9fce37105e983ce$export$615f58445ee06748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch20Regular', "20", [
    "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5H10v1a5 5 0 0 1 5 5v1h1a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1h-6.09a2 2 0 0 0-.35-.56l-.44-.44H11v-2H8.74q.18-.48.23-1H11a1 1 0 0 1 1 1v2h5v-4a1 1 0 0 0-1-1h-1.5a.5.5 0 0 1-.5-.5V10a4 4 0 0 0-7.94-.72q-.46-.18-.97-.24A5 5 0 0 1 9 5.1zm0 9a.5.5 0 0 1-.28.45A5 5 0 0 0 8 10.67V9.5a.5.5 0 0 1 1 0zm6 2a.5.5 0 0 0-1 0v2a.5.5 0 1 0 1 0zm-3-4a.5.5 0 0 0-1 0v2a.5.5 0 1 0 1 0zM4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $e9fce37105e983ce$export$9324c7f2c30a32ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch24Color', "24", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M11 4.5h1.5v2H11z"
        }
    ],
    [
        "rect",
        {
            "width": "5",
            "height": "3",
            "x": "11",
            "y": "2",
            "fill": "#f83f54",
            "rx": ".5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__a)",
            "d": "M5 13a7 7 0 0 1 14 0v.5H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__b)",
            "d": "M5 13a7 7 0 0 1 14 0v.5H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__c)",
            "d": "M5 13a7 7 0 0 1 14 0v.5H5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__d)",
            "d": "M4.5 13A2.5 2.5 0 0 0 2 15.5V18h.34a3.5 3.5 0 0 0 5.69.92l3 3.08h10.22c.41 0 .75-.34.75-.75V15.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__e)",
            "fillOpacity": ".5",
            "d": "M4.5 13A2.5 2.5 0 0 0 2 15.5V18h.34a3.5 3.5 0 0 0 5.69.92l3 3.08h10.22c.41 0 .75-.34.75-.75V15.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__f)",
            "fillOpacity": ".6",
            "d": "M4.5 13A2.5 2.5 0 0 0 2 15.5V18h.34a3.5 3.5 0 0 0 5.69.92l3 3.08h10.22c.41 0 .75-.34.75-.75V15.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__g)",
            "fillOpacity": ".6",
            "d": "M4.5 13A2.5 2.5 0 0 0 2 15.5V18h.34a3.5 3.5 0 0 0 5.69.92l3 3.08h10.22c.41 0 .75-.34.75-.75V15.5a2.5 2.5 0 0 0-2.5-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M19 16.25a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M16 9.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM12 9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m-2.5.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__h)",
            "d": "M9 16.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_24_color__i)",
            "d": "M5.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__a",
                "x1": "12",
                "x2": "12",
                "y1": "6",
                "y2": "13.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__d",
                "x1": "9.81",
                "x2": "19.14",
                "y1": "13",
                "y2": "22.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__e",
                "x1": "8.88",
                "x2": "14.16",
                "y1": "21.36",
                "y2": "15.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopOpacity": ".69"
                }
            ],
            [
                "stop",
                {
                    "offset": ".62",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__h",
                "x1": "7.25",
                "x2": "2",
                "y1": "14.17",
                "y2": "20",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__i",
                "x1": "1.58",
                "x2": "10.84",
                "y1": "21.84",
                "y2": "14.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4.03846 -7.47142 0 16.9 7.15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -6.5 6.38034 4.90795 5.5 17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".49",
                    "stopColor": "#e67505"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#e67505",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -5 4.99801 4.99801 5.5 16.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".12"
                }
            ],
            [
                "stop",
                {
                    "offset": ".88",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_24_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(96.93 4.62 15.69)scale(5.1807 11.3238)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$73a3e1480b64b3d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch24Filled', "24", [
    "M11.75 2h3.75c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-3v1.02A7 7 0 0 1 19 13h.75c1.24 0 2.25 1 2.25 2.25v6c0 .41-.34.75-.75.75H14a.25.25 0 0 1-.25-.25v-3a.5.5 0 0 0-.5-.5h-2.53a5.5 5.5 0 0 0-1.22-5.52v-.98a.75.75 0 0 0-1.49-.14A5.5 5.5 0 0 0 5.3 11 7 7 0 0 1 11 6.06V2.75c0-.41.34-.75.75-.75m3.75 11.75v-2a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0m-3-2a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0zm6.5 7v-2.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0M5.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $e9fce37105e983ce$export$92d741d621f0e51c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch24Regular', "24", [
    "M15.5 11.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0zM11.75 11c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0v-2c0-.41.34-.75.75-.75m-2.25.75a.75.75 0 0 0-1.49-.14q.84.43 1.49 1.12zM13.75 17h-2.77a6 6 0 0 1-.35 1.5H13v2h-1.02l.5.51q.43.43.5.99h8.27c.41 0 .75-.34.75-.75v-6c0-1.24-1-2.25-2.25-2.25H19a7 7 0 0 0-6.5-6.98V5h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3.75a.75.75 0 0 0-.75.75v3.32A7 7 0 0 0 5.29 11a6 6 0 0 1 1.53.16A5.5 5.5 0 0 1 17.5 13v.75c0 .41.34.75.75.75h1.5c.41 0 .75.34.75.75v5.25h-6v-2.75a.75.75 0 0 0-.75-.75m5.25-.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zM5.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $e9fce37105e983ce$export$b3c8fe60921b5d94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch32Color', "32", [
    [
        "path",
        {
            "fill": "#70777d",
            "d": "M15 5h2v3h-2z"
        }
    ],
    [
        "path",
        {
            "fill": "#f83f54",
            "d": "M15 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__a)",
            "d": "M7 16a9 9 0 1 1 18 0v1H7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__b)",
            "d": "M7 16a9 9 0 1 1 18 0v1H7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__c)",
            "d": "M7 16a9 9 0 1 1 18 0v1H7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__d)",
            "d": "m13.52 29-3.2-3.26A5 5 0 1 1 7 17v-1h19.99a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__e)",
            "fillOpacity": ".5",
            "d": "m13.52 29-3.2-3.26A5 5 0 1 1 7 17v-1h19.99a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__f)",
            "fillOpacity": ".6",
            "d": "m13.52 29-3.2-3.26A5 5 0 1 1 7 17v-1h19.99a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__g)",
            "fillOpacity": ".6",
            "d": "m13.52 29-3.2-3.26A5 5 0 1 1 7 17v-1h19.99a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "#63686e",
            "d": "M25 21a1 1 0 1 0-2 0v3a1 1 0 0 0 2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "#ca6407",
            "d": "M21 12a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm-5-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m-3 1a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__h)",
            "d": "M11.98 22.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_government_search_32_color__i)",
            "d": "M7 28.5c1.3 0 2.5-.41 3.48-1.1l3.31 3.3a1 1 0 0 0 1.42-1.4l-3.32-3.32A6 6 0 1 0 7 28.5m0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__a",
                "x1": "16",
                "x2": "16",
                "y1": "7",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc205"
                }
            ],
            [
                "stop",
                {
                    "offset": ".73",
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e67505"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__d",
                "x1": "12.94",
                "x2": "26.42",
                "y1": "16",
                "y2": "29.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#aab3bd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__e",
                "x1": "11.63",
                "x2": "17.89",
                "y1": "28.07",
                "y2": "21.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopOpacity": ".69"
                }
            ],
            [
                "stop",
                {
                    "offset": ".62",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__h",
                "x1": "9.48",
                "x2": "1.98",
                "y1": "19.17",
                "y2": "27.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__i",
                "x1": "1.76",
                "x2": "13.97",
                "y1": "29.47",
                "y2": "19.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#29c3ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.38462 -9.60611 0 22.3 8.54)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd638"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffd638",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 -10 9.87797 5.9268 7 24)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".49",
                    "stopColor": "#e67505"
                }
            ],
            [
                "stop",
                {
                    "offset": ".84",
                    "stopColor": "#e67505",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7.50002 -8.5 6.81458 6.01287 7 24.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".12"
                }
            ],
            [
                "stop",
                {
                    "offset": ".88",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_government_search_32_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(96.72 7.01 20.56)scale(7.47993 15.8603)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffb357"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$e9ed1c70b05e57a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch32Filled', "32", [
    "M16 2h4.67c.36 0 .66.3.66.67v2.66c0 .37-.3.67-.66.67H17v1.05A9 9 0 0 1 25 16h2a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1H19v-4a1 1 0 0 0-1-1h-3.65a7.5 7.5 0 0 0-1.61-6.33A1 1 0 0 0 13 17v-3a1 1 0 1 0-2 0v2.15A7.5 7.5 0 0 0 7.05 15 9 9 0 0 1 15 7.05V3a1 1 0 0 1 1-1m5 12a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-4 3v-3a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0m8 4a1 1 0 1 0-2 0v3a1 1 0 0 0 2 0zM7 28.5c1.3 0 2.5-.41 3.48-1.1l3.31 3.3a1 1 0 0 0 1.42-1.4l-3.32-3.32A6 6 0 1 0 7 28.5m0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $e9fce37105e983ce$export$d6ceaf4b946ab390 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingGovernmentSearch32Regular', "32", [
    "M21 14a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-5-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-3 1a1 1 0 1 0-2 0v2.15q.99.63 1.74 1.52A1 1 0 0 0 13 17zm3-5a7 7 0 0 0-6.96 6.28A8 8 0 0 0 7.05 15 9 9 0 0 1 15 7.05V3a1 1 0 0 1 1-1h4.67c.36 0 .66.3.66.67v2.66c0 .37-.3.67-.66.67H17v1.05A9 9 0 0 1 25 16h2a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1H16.8a3 3 0 0 0-.53-.77L15.04 27h2.46v-2h-3.43q.35-.95.41-2h4.02a1 1 0 0 1 1 1v3H28v-8a1 1 0 0 0-1-1h-3a1 1 0 0 1-1-1v-1a7 7 0 0 0-7-7m9 12a1 1 0 1 0-2 0v3a1 1 0 0 0 2 0zM7 28.5c1.3 0 2.5-.41 3.48-1.1l3.31 3.3a1 1 0 0 0 1.42-1.4l-3.32-3.32A6 6 0 1 0 7 28.5m0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $e9fce37105e983ce$export$5fa332762f44c69c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__a)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V14H3.5a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__b)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V14H3.5a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__c)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V14H3.5a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__d)",
            "d": "M6 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__e)",
            "d": "M8 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__f)",
            "d": "M6 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__g)",
            "d": "M8 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__h)",
            "d": "M6 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__i)",
            "d": "M10 11h3v4h-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__j)",
            "d": "M8 11.46a1 1 0 0 1 .35-.76l2.83-2.42a.5.5 0 0 1 .65 0l2.82 2.42a1 1 0 0 1 .35.76v3.04a.5.5 0 0 1-.5.5h-2v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V15h-2a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_16_color__k)",
            "fillRule": "evenodd",
            "d": "M10.52 7.36a1.5 1.5 0 0 1 1.96 0l3.26 2.82a.75.75 0 0 1-.98 1.14L11.5 8.49l-3.26 2.83a.75.75 0 0 1-.98-1.14z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__a",
                "x1": "3",
                "x2": "13.98",
                "y1": "2.38",
                "y2": "10.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__d",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__e",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__f",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__g",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__h",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__i",
                "x1": "11.5",
                "x2": "8.85",
                "y1": "11",
                "y2": "15.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__j",
                "x1": "7.76",
                "x2": "14.12",
                "y1": "8.35",
                "y2": "14.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_16_color__k",
                "x1": "11.93",
                "x2": "11.19",
                "y1": "5.71",
                "y2": "11.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4 -2.05556 0 9 13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-1.91666 2 -1.87874 -1.80045 9.42 11)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$2bdc9e6462532af6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome16Filled', "16", [
    "M3.25 1C2.56 1 2 1.56 2 2.25v8.5c0 .69.56 1.25 1.25 1.25H5v-1.56c0-.7.29-1.36.8-1.84l.65-.6A.5.5 0 1 1 7 7.49l1.64-1.52A2 2 0 0 1 11 5.7a1.25 1.25 0 0 0-1.25-1.2h-.5A.25.25 0 0 1 9 4.25v-2C9 1.56 8.45 1 7.75 1zM4.5 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4.5 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M7 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m4.18.7a1 1 0 0 0-1.36 0L6.48 9.34c-.3.28-.48.68-.48 1.1V14a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-1h1v1a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1v-3.56c0-.42-.17-.82-.48-1.1zm-3.52 3.37L10 7.43l2.84 2.64q.16.15.16.37V14h-1.5v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1H7v-3.56a.5.5 0 0 1 .16-.37"
]);
const $e9fce37105e983ce$export$a9700ad4769467d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome16Regular', "16", [
    "M3.25 2a.25.25 0 0 0-.25.25v8.5c0 .14.11.25.25.25H5v1H3.25C2.56 12 2 11.44 2 10.75v-8.5C2 1.56 2.56 1 3.25 1h4.5c.7 0 1.26.56 1.25 1.25v2c0 .14.11.25.25.25h.5c.67 0 1.22.53 1.25 1.2a2 2 0 0 0-1.52-.2h-.23C8.56 5.5 8 4.94 8 4.25v-2A.25.25 0 0 0 7.75 2zm7.43 4.7a1 1 0 0 0-1.36 0L6.48 9.34c-.3.28-.48.68-.48 1.1V14a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-1h1v1a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1v-3.56c0-.42-.17-.82-.48-1.1zm-3.52 3.37L10 7.43l2.84 2.64q.16.15.16.37V14h-1.5v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1H7v-3.56a.5.5 0 0 1 .16-.37M5 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M5 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M7 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $e9fce37105e983ce$export$179097497907df44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__a)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h10c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__b)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h10c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__c)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h10c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__d)",
            "d": "M6.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__e)",
            "d": "M11 5.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__f)",
            "d": "M11 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__g)",
            "d": "M7.5 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__h)",
            "d": "M7.5 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__i)",
            "d": "M14 15h3v4h-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__j)",
            "d": "M12 15.46a1 1 0 0 1 .35-.76l2.83-2.42a.5.5 0 0 1 .65 0l2.82 2.42a1 1 0 0 1 .35.76v3.04a.5.5 0 0 1-.5.5h-2v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V19h-2a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_20_color__k)",
            "fillRule": "evenodd",
            "d": "M14.52 11.36a1.5 1.5 0 0 1 1.96 0l3.26 2.82a.75.75 0 1 1-.98 1.14l-3.26-2.83-3.26 2.83a.75.75 0 0 1-.98-1.14z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__a",
                "x1": "4",
                "x2": "19.26",
                "y1": "2.5",
                "y2": "17.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__d",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__e",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__f",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__g",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__h",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__i",
                "x1": "15.5",
                "x2": "12.85",
                "y1": "15",
                "y2": "19.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__j",
                "x1": "11.76",
                "x2": "18.12",
                "y1": "12.35",
                "y2": "18.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_20_color__k",
                "x1": "15.93",
                "x2": "15.19",
                "y1": "9.71",
                "y2": "15.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.5 -2.3125 0 13 17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.5 3.5 -1.8232 -2.3441 15 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$3d82c7e9e705bdee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome20Filled', "20", [
    "M3.25 2C2.56 2 2 2.56 2 3.25v10.5c0 .69.56 1.25 1.25 1.25H7.5v-1.74c0-.68.3-1.33.82-1.78l3.47-2.96Q12.33 8.07 13 8v-.75C13 6.56 12.44 6 11.75 6h-1.5a.25.25 0 0 1-.25-.25v-2.5C10 2.56 9.44 2 8.75 2zm1.5 3.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M5.5 7A.75.75 0 1 1 4 7a.75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M8 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M8 9.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.06.03c-.47-.4-1.15-.4-1.62 0l-3.47 2.96c-.3.26-.47.63-.47 1.02v4.61C8.5 18.5 9 19 9.63 19h1.74c.63 0 1.13-.5 1.13-1.13v-1.75q.01-.1.13-.12h1.24q.12.01.13.13v1.74c0 .63.5 1.13 1.13 1.13h1.74c.63 0 1.13-.5 1.13-1.13v-4.61q-.01-.61-.47-1.02zm-.97.77q.17-.12.32 0L16.88 13q.12.1.12.26v4.61q-.01.12-.12.13h-1.75a.12.12 0 0 1-.13-.13v-1.75c0-.62-.5-1.12-1.12-1.12h-1.26c-.62 0-1.12.5-1.12 1.13v1.74q-.02.12-.12.13H9.62a.12.12 0 0 1-.12-.13v-4.61q0-.16.12-.26z"
]);
const $e9fce37105e983ce$export$c882ceee6467d890 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome20Regular', "20", [
    "M3.25 3a.25.25 0 0 0-.25.25v10.5c0 .14.11.25.25.25H7.5v1H3.25C2.56 15 2 14.44 2 13.75V3.25C2 2.56 2.56 2 3.25 2h5.5C9.44 2 10 2.56 10 3.25v2.5c0 .14.11.25.25.25h1.5c.69 0 1.25.56 1.25 1.25V8q-.54.06-1 .37V7.25a.25.25 0 0 0-.25-.25h-1.5C9.56 7 9 6.44 9 5.75v-2.5A.25.25 0 0 0 8.75 3zm10.81 6.28c-.47-.4-1.15-.4-1.62 0l-3.47 2.96c-.3.26-.47.63-.47 1.02v4.61C8.5 18.5 9 19 9.63 19h1.74c.63 0 1.13-.5 1.13-1.13v-1.75q.01-.1.13-.12h1.24q.12.01.13.13v1.74c0 .63.5 1.13 1.13 1.13h1.74c.63 0 1.13-.5 1.13-1.13v-4.61q-.01-.61-.47-1.02zm-.97.77q.17-.12.32 0L16.88 13q.12.1.12.26v4.61q-.01.12-.12.13h-1.75a.12.12 0 0 1-.13-.13v-1.75c0-.62-.5-1.12-1.12-1.12h-1.26c-.62 0-1.12.5-1.12 1.13v1.74q-.02.12-.12.13H9.62a.12.12 0 0 1-.12-.13v-4.61q0-.16.12-.26zM5.5 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.25 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8 7a.75.75 0 1 1-1.5 0A.75.75 0 0 1 8 7m-.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $e9fce37105e983ce$export$fda9b6f633eda38f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__a)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__b)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__c)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__d)",
            "d": "M7 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__e)",
            "d": "M15 17h5v6h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__f)",
            "d": "M18.1 13.33a1 1 0 0 0-1.2 0l-3.5 2.62a1 1 0 0 0-.4.8V22a1 1 0 0 0 1 1h2v-3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V23h2a1 1 0 0 0 1-1v-5.25a1 1 0 0 0-.4-.8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_24_color__g)",
            "fillRule": "evenodd",
            "d": "m17.5 13.95 4.04 3.14a.75.75 0 1 0 .92-1.18l-4.2-3.26a1.25 1.25 0 0 0-1.53 0l-4.19 3.26a.75.75 0 1 0 .92 1.18z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_24_color__a",
                "x1": "4",
                "x2": "23.08",
                "y1": "2.63",
                "y2": "22.17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_24_color__d",
                "x1": "9.15",
                "x2": "13.95",
                "y1": "4.5",
                "y2": "15.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_24_color__e",
                "x1": "17.5",
                "x2": "14.69",
                "y1": "17",
                "y2": "23.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_24_color__f",
                "x1": "13.86",
                "x2": "21.4",
                "y1": "14.11",
                "y2": "21.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_24_color__g",
                "x1": "18",
                "x2": "17.26",
                "y1": "11",
                "y2": "16.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 8.25 -4.75 0 16 20.75)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.5 3.5 -2.36586 -3.04182 17 16)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$144cc525f95bfd6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome24Filled', "24", [
    "M3.5 2C2.67 2 2 2.67 2 3.5v13c0 .83.67 1.5 1.5 1.5H9v-3.32c0-.76.32-1.49.87-2L14 8.81V8.5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5zM6 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.25 9.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M6 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.75 6.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m9.44-3.06a1.75 1.75 0 0 0-2.38 0l-4.25 3.97c-.36.33-.56.79-.56 1.27v5.82c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V18h2v2.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-5.82c0-.48-.2-.94-.56-1.27zm-1.36 1.1q.17-.15.34 0l4.25 3.96q.08.08.08.18v5.82h-2V18c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v2.5h-2v-5.82q0-.1.08-.18zM9.25 2h-5.5Z"
]);
const $e9fce37105e983ce$export$d0b4273e9f80031 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome24Regular', "24", [
    "M3.75 3.5a.25.25 0 0 0-.25.25v12.5c0 .14.11.25.25.25H9V18H3.75C2.78 18 2 17.22 2 16.25V3.75C2 2.78 2.78 2 3.75 2h5.5c.97 0 1.75.78 1.75 1.75v3c0 .14.11.25.25.25h1c.97 0 1.75.78 1.75 1.75v.07l-1.5 1.4V8.75a.25.25 0 0 0-.25-.25h-1c-.97 0-1.75-.78-1.75-1.75v-3a.25.25 0 0 0-.25-.25zM6 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.25 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m9.44-3.06a1.75 1.75 0 0 0-2.38 0l-4.25 3.97c-.36.33-.56.79-.56 1.27v5.82c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V18h2v2.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-5.82c0-.48-.2-.94-.56-1.27zm-1.36 1.1q.17-.15.34 0l4.25 3.96q.08.08.08.18v5.82h-2V18c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v2.5h-2v-5.82q0-.1.08-.18z"
]);
const $e9fce37105e983ce$export$5ec608eca5b38770 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__a)",
            "d": "M27 30a1 1 0 0 0 1-1V16.25c0-1.8-1.46-3.25-3.25-3.25H22V5.25C22 3.45 20.54 2 18.75 2H7a3 3 0 0 0-3 3v24a1 1 0 0 0 1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__b)",
            "d": "M27 30a1 1 0 0 0 1-1V16.25c0-1.8-1.46-3.25-3.25-3.25H22V5.25C22 3.45 20.54 2 18.75 2H7a3 3 0 0 0-3 3v24a1 1 0 0 0 1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__c)",
            "d": "M27 30a1 1 0 0 0 1-1V16.25c0-1.8-1.46-3.25-3.25-3.25H22V5.25C22 3.45 20.54 2 18.75 2H7a3 3 0 0 0-3 3v24a1 1 0 0 0 1 1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__d)",
            "d": "M10.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5-8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__e)",
            "d": "M21 25h5v6h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__f)",
            "d": "M22.45 17.89c.6-.52 1.5-.52 2.1 0l4.88 4.14c.36.31.57.76.57 1.24v6.48c0 .69-.56 1.25-1.25 1.25H25.5v-4.5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1V31h-3.25c-.69 0-1.25-.56-1.25-1.25v-6.48c0-.48.2-.93.57-1.24z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_home_32_color__g)",
            "fillRule": "evenodd",
            "d": "M22.69 16.05c.46-.4 1.16-.4 1.62 0l7 6a1.25 1.25 0 1 1-1.62 1.9l-6.19-5.3-6.19 5.3a1.25 1.25 0 0 1-1.62-1.9z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_32_color__a",
                "x1": "4",
                "x2": "30.61",
                "y1": "2.88",
                "y2": "32.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_32_color__d",
                "x1": "12.9",
                "x2": "17.65",
                "y1": "5.56",
                "y2": "22.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_32_color__e",
                "x1": "23.5",
                "x2": "19.74",
                "y1": "25",
                "y2": "31.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_32_color__f",
                "x1": "5.58",
                "x2": "14.98",
                "y1": "19",
                "y2": "37.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_home_32_color__g",
                "x1": "24.29",
                "x2": "22.86",
                "y1": "13.33",
                "y2": "23.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(140.71 6.07 14.57)scale(7.10634 2.87156)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_home_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 10 -7.25 0 22 28)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$f7622664acfe5e5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome32Filled', "32", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h6A2.5 2.5 0 0 1 14 5.5v4c0 .28.22.5.5.5h1a2.5 2.5 0 0 1 2.5 2.5v.69l-4.08 3.45a4 4 0 0 0-1.42 3.06V24h-7A2.5 2.5 0 0 1 3 21.5zM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-.5 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12.7-2.8a2.5 2.5 0 0 0-3.4 0l-5 4.62a2.5 2.5 0 0 0-.8 1.84v6.84a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-3c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v3a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-6.84c0-.7-.3-1.37-.8-1.84zm-2.04 1.47a.5.5 0 0 1 .68 0l5 4.62q.16.16.16.37v6.84a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a2.5 2.5 0 0 0-2.5-2.5h-2a2.5 2.5 0 0 0-2.5 2.5v3a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6.84a.5.5 0 0 1 .16-.37z"
]);
const $e9fce37105e983ce$export$6a495d1cf994860e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingHome32Regular', "32", [
    "M5.5 5a.5.5 0 0 0-.5.5v16c0 .28.22.5.5.5h7v2h-7A2.5 2.5 0 0 1 3 21.5v-16A2.5 2.5 0 0 1 5.5 3h6A2.5 2.5 0 0 1 14 5.5v4c0 .28.22.5.5.5h1a2.5 2.5 0 0 1 2.5 2.5v.69l-2 1.69V12.5a.5.5 0 0 0-.5-.5h-1A2.5 2.5 0 0 1 12 9.5v-4a.5.5 0 0 0-.5-.5zm17.7 8.2a2.5 2.5 0 0 0-3.4 0l-5 4.62a2.5 2.5 0 0 0-.8 1.84v6.84a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-3c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v3a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5v-6.84c0-.7-.3-1.37-.8-1.84zm-2.04 1.47a.5.5 0 0 1 .68 0l5 4.62q.16.16.16.37v6.84a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a2.5 2.5 0 0 0-2.5-2.5h-2a2.5 2.5 0 0 0-2.5 2.5v3a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6.84a.5.5 0 0 1 .16-.37zM8 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.5 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $e9fce37105e983ce$export$c2bed5c1e97c4937 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse16Filled', "16", [
    "M8.13 1.22a1 1 0 0 0-1.25 0l-2.5 2A1 1 0 0 0 5 5v2.1c-.6.2-1.07.72-1.17 1.39L3 13.85a1 1 0 0 0 1 1.15H11a1 1 0 0 0 .99-1.15l-.82-5.36A1.8 1.8 0 0 0 10 7.09V5a1 1 0 0 0 .62-1.78zM6 7V5h3v2zm-1.8 5.65.24-1.53 5.87-1.63.21 1.4zM12.5 6h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1m1.35-3.85c.2.2.2.5 0 .7l-1 1a.5.5 0 1 1-.7-.7l1-1c.2-.2.5-.2.7 0m0 6a.5.5 0 0 1-.7.7l-1-1a.5.5 0 1 1 .7-.7z"
]);
const $e9fce37105e983ce$export$bbfd2d3e0f683b6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse16Regular', "16", [
    "M6.88 1.22a1 1 0 0 1 1.25 0l2.5 2A1 1 0 0 1 10 5v2.1c.6.2 1.07.72 1.17 1.39l.82 5.36a1 1 0 0 1-1 1.15H4a1 1 0 0 1-.99-1.15l.82-5.36c.1-.67.56-1.2 1.17-1.4V5a1 1 0 0 1-.62-1.78zM6 7h3V5H6zm4-3L7.5 2 5 4zm.15 4.5a.75.75 0 0 0-.71-.5H5.56a.75.75 0 0 0-.74.64l-.22 1.4zm-5.71 2.62-.23 1.53 6.31-1.76-.2-1.4zm-.4 2.6L4 14h7l-.32-2.11zM14.5 6h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1m-.65-3.15a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 1 0 .7.7zm0 6a.5.5 0 0 0 0-.7l-1-1a.5.5 0 1 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $e9fce37105e983ce$export$b8b8f55ef7b170bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse20Filled', "20", [
    "M8.45 2.17a1 1 0 0 1 1.1 0l3 2A1 1 0 0 1 12 6v2.16a2 2 0 0 1 1.2 1.62l.8 7.1A1 1 0 0 1 13 18H5a1 1 0 0 1-1-1.11l.8-7.11A2 2 0 0 1 6 8.16V6a1 1 0 0 1-.55-1.83zM7 6v2h4V6zm5.33 5.07-6.87 1.81-.22 2.03 7.3-1.93zM14.5 7h2a.5.5 0 1 0 0-1h-2a.5.5 0 0 0 0 1m1.35-3.85c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m0 6a.5.5 0 0 1-.7.7l-1-1a.5.5 0 1 1 .7-.7z"
]);
const $e9fce37105e983ce$export$c77950c1550bf240 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse20Regular', "20", [
    "m10.33 2.69-.77-.52a1 1 0 0 0-1.1 0l-.78.5-2.1 1.21A1.1 1.1 0 0 0 5 4.93 1 1 0 0 0 6 6v2.16a2 2 0 0 0-1.2 1.62l-.8 7.1A1 1 0 0 0 5 18h8a1 1 0 0 0 1-1.11l-.8-7.11A2 2 0 0 0 12 8.16V6a1 1 0 0 0 1-1.09v-.04c0-.4-.22-.78-.57-.99zM11 8H7V6h4zM6.1 5l-.05-.03L8.2 3.53l.8-.45.8.46 2.15 1.43-.06.03zm.74 4h4.32a1 1 0 0 1 1 .89l.01.18-3.55.95-2.98.78.2-1.91a1 1 0 0 1 1-.89m2.03 2.99 3.41-.9.22 1.9-3.88 1.03-3.33.87.23-2.01zm-3.7 3.98 3.7-.98 3.74-.99.33 3H5.06zM16.5 7h-2a.5.5 0 0 1 0-1h2l.1.01a.5.5 0 0 1-.1.99m-.65-3.85c.2.2.2.5 0 .7l-1 1a.5.5 0 1 1-.7-.7l1-1a.5.5 0 0 1 .7 0m0 6a.5.5 0 0 1-.7.7l-1-1a.5.5 0 1 1 .7-.7z"
]);
const $e9fce37105e983ce$export$adef875e5a3e147e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse24Filled', "24", [
    "M10.7 2.21a1.3 1.3 0 0 0-1.4 0l-3.74 2.5A1.25 1.25 0 0 0 6.26 7h.24v2.15c-.76.3-1.32.99-1.42 1.84l-1.06 9.06A1.75 1.75 0 0 0 5.76 22h8.5c1.04 0 1.85-.91 1.73-1.95l-1.06-9.06a2.3 2.3 0 0 0-1.43-1.84V7h.25c1.24 0 1.72-1.6.7-2.3zM12 9H8V7h4zm1.95 6.53L5.77 18l.36-3.04 7.49-2.25zm2.27-11.31a.75.75 0 0 0 1.06 1.06l1.5-1.5a.75.75 0 0 0-1.06-1.06zm0 6c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0M20.25 7h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5"
]);
const $e9fce37105e983ce$export$f2381ee913a8bc72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse24Regular', "24", [
    "M9.3 2.21c.43-.28.97-.28 1.4 0l3.74 2.5C15.47 5.39 15 7 13.75 7h-.25v2.15c.76.29 1.33.99 1.43 1.84l1.06 9.06A1.75 1.75 0 0 1 14.25 22h-8.5a1.75 1.75 0 0 1-1.73-1.95l1.06-9.06c.1-.85.66-1.54 1.42-1.84V7h-.25a1.25 1.25 0 0 1-.69-2.3zM8 9h4V7H8zm2-5.45L7.08 5.5h5.84zm6.22.67a.75.75 0 0 0 1.06 1.06l1.5-1.5a.75.75 0 0 0-1.06-1.06zm0 7.06a.75.75 0 1 1 1.06-1.06l1.5 1.5a.75.75 0 1 1-1.06 1.06zM16.75 7h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M5.58 19.61l-.07.61c-.02.15.1.28.25.28h8.5c.14 0 .26-.13.24-.28l-.37-3.18zm8.37-4.08-.33-2.83-7.5 2.25-.35 3.04zm-.5-4.35v-.02a.75.75 0 0 0-.75-.66H7.32c-.38 0-.7.28-.75.66l-.25 2.16z"
]);
const $e9fce37105e983ce$export$c08a0ff12ac1a7c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse28Filled', "28", [
    "M10.81 2.2c.42-.27.96-.27 1.37 0l4.64 3.05A1.5 1.5 0 0 1 16 8v3.14a2.8 2.8 0 0 1 1.86 2.3L19 23.49c.15 1.34-.89 2.51-2.23 2.51H6.27a2.25 2.25 0 0 1-2.23-2.5l1.14-10.06A2.8 2.8 0 0 1 7 11.16V8a1.5 1.5 0 0 1-.82-2.75zm5.73 12.97L6.18 17.96l-.4 3.56 11.14-3zM14.5 8h-6v3h6zm4.72-2.78a.75.75 0 1 0 1.06 1.06l1.5-1.5a.75.75 0 1 0-1.06-1.06zm0 6c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0M23.25 8h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 1 0 0-1.5"
]);
const $e9fce37105e983ce$export$b6a497079d403dd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse28Regular', "28", [
    "M12.18 2.2a1.3 1.3 0 0 0-1.37 0L6.18 5.25A1.5 1.5 0 0 0 7 8v3.16a2.8 2.8 0 0 0-1.82 2.28L4.04 23.49C3.88 24.83 4.93 26 6.27 26h10.5A2.25 2.25 0 0 0 19 23.5l-1.14-10.06a2.8 2.8 0 0 0-1.86-2.3V8a1.5 1.5 0 0 0 .82-2.75zM14.5 11h-6V8h6zM7 6.5l4.5-2.95L16 6.5zM5.77 21.52l.4-3.56 10.37-2.8.38 3.35zm.59-5.16.31-2.75c.07-.63.6-1.11 1.24-1.11h7.21c.64 0 1.17.48 1.24 1.1l.01.06zm-.77 6.76 11.5-3.1.42 3.64c.05.45-.3.84-.74.84H6.27a.75.75 0 0 1-.74-.84zm13.63-17.9a.75.75 0 1 0 1.06 1.06l1.5-1.5a.75.75 0 1 0-1.06-1.06zm0 6c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06l-1.5-1.5a.75.75 0 0 0-1.06 0M23.25 8h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 1 0 0-1.5"
]);
const $e9fce37105e983ce$export$62a95e7bd68d0560 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse32Filled', "32", [
    "M14.76 2.2a1.5 1.5 0 0 0-1.52 0L8 5.27C6.23 6.3 6.96 9 9 9v3.11a3.3 3.3 0 0 0-2.37 2.73L5.02 27.47A2.25 2.25 0 0 0 7.25 30h13.5c1.36 0 2.4-1.19 2.23-2.53l-1.6-12.63A3.25 3.25 0 0 0 19 12.1V9c2.04 0 2.77-2.7 1-3.73zM7.4 24.6l.45-3.56 11.9-3.17.42 3.32zM11 12V9h6v3zm12-2a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m3.7-5.3a1 1 0 0 0-1.4-1.4l-2 2a1 1 0 0 0 1.4 1.4zm0 12a1 1 0 0 0 0-1.4l-2-2a1 1 0 0 0-1.4 1.4l2 2a1 1 0 0 0 1.4 0"
]);
const $e9fce37105e983ce$export$b89292b6fc0eeff9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse32Regular', "32", [
    "M13.24 2.2a1.5 1.5 0 0 1 1.52 0L20 5.27C21.77 6.3 21.04 9 19 9v3.11c1.24.34 2.2 1.4 2.37 2.73l1.61 12.63A2.25 2.25 0 0 1 20.75 30H7.25a2.25 2.25 0 0 1-2.23-2.53l1.61-12.63A3.3 3.3 0 0 1 9 12.1V9C6.96 9 6.23 6.3 8 5.27zM9.85 14c-.62 0-1.16.47-1.24 1.1l-.48 3.8 11.36-3.03-.1-.78A1.25 1.25 0 0 0 18.15 14zm9.9 3.87-11.9 3.17-.45 3.55 12.77-3.4zM7 27.72c-.02.15.1.28.25.28h13.5c.15 0 .27-.13.25-.28l-.58-4.53-13.3 3.54zM17 12V9h-6v3zm-3-7.92L9 7h10zM23 10a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m3.7-5.3a1 1 0 0 0-1.4-1.4l-2 2a1 1 0 0 0 1.4 1.4zm0 12a1 1 0 0 0 0-1.4l-2-2a1 1 0 0 0-1.4 1.4l2 2a1 1 0 0 0 1.4 0"
]);
const $e9fce37105e983ce$export$3d2d2b52254d8485 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse48Filled', "48", [
    "M19.76 4.37c.75-.5 1.73-.5 2.48 0l7.64 5.04A2.5 2.5 0 0 1 28.5 14H28v5.05a4.25 4.25 0 0 1 3.56 3.62l2.41 17.64A3.25 3.25 0 0 1 30.75 44h-19.5a3.25 3.25 0 0 1-3.22-3.69l2.41-17.64A4.25 4.25 0 0 1 14 19.05V14h-.5a2.5 2.5 0 0 1-1.37-4.59zM16.5 14v5h9v-5zm19.63-2.37a1.25 1.25 0 0 1-1.76-1.76l2.5-2.5a1.25 1.25 0 0 1 1.76 1.76zM11.8 31.18l-.76 5.62 19.23-5.13-.72-5.22zM35.25 14.5a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 0 0 0-2.5zm.88 5.37 2.5 2.5a1.25 1.25 0 0 1-1.76 1.76l-2.5-2.5a1.25 1.25 0 0 1 1.76-1.76"
]);
const $e9fce37105e983ce$export$deb94b40552ef1a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingLighthouse48Regular', "48", [
    "M22.24 4.37c-.75-.5-1.73-.5-2.48 0l-7.63 5.04A2.5 2.5 0 0 0 13.5 14h.5v5.05a4.25 4.25 0 0 0-3.56 3.62l-2.4 17.64A3.25 3.25 0 0 0 11.24 44h19.5a3.25 3.25 0 0 0 3.22-3.69l-2.4-17.64A4.25 4.25 0 0 0 28 19.05V14h.5a2.5 2.5 0 0 0 1.38-4.59zM25.5 14v5h-9v-5zm-12-2.5L21 6.55l7.5 4.95zm20.87.13c.48.5 1.28.5 1.76 0l2.5-2.5a1.25 1.25 0 0 0-1.76-1.76l-2.5 2.5a1.25 1.25 0 0 0 0 1.76M14.65 21.5h12.7c.88 0 1.62.65 1.74 1.51l.19 1.42-17.18 4.58.82-6c.12-.86.86-1.51 1.73-1.51m-3.54 14.78.62-4.58 17.89-4.77.58 4.26zm19.43-2.6.95 6.97a.75.75 0 0 1-.74.85h-19.5c-.45 0-.8-.4-.74-.85l.23-1.69zM34 15.75c0-.69.56-1.25 1.25-1.25h5.5a1.25 1.25 0 0 1 0 2.5h-5.5c-.69 0-1.25-.56-1.25-1.25m4.63 6.62-2.5-2.5a1.25 1.25 0 0 0-1.76 1.76l2.5 2.5a1.25 1.25 0 0 0 1.76-1.76"
]);
const $e9fce37105e983ce$export$77ad2c05a27bcef9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque12Filled', "12", [
    "M2.25 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-9 .5c.28 0 .5.22.5.5V6h1.17A3 3 0 0 1 3 5c0-.5.22-.93.5-1.28.27-.35.62-.65.96-.9a8 8 0 0 1 1.3-.76l.03-.01a.5.5 0 0 1 .41 0h.01l.03.01.39.2q.4.2.91.57c.34.24.69.54.96.89.28.35.5.78.5 1.28a3 3 0 0 1-.17 1H10V3.5a.5.5 0 0 1 1 0V10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V9a1 1 0 0 0-2 0v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3.5c0-.28.22-.5.5-.5"
]);
const $e9fce37105e983ce$export$fedb88be0170875e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque12Regular', "12", [
    "M2 3.5a.5.5 0 0 0-1 0V10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3.5a.5.5 0 0 0-1 0V6H8.83A3 3 0 0 0 9 5c0-.5-.22-.93-.5-1.28a5 5 0 0 0-.96-.9 8 8 0 0 0-1.3-.76l-.03-.01a.5.5 0 0 0-.41 0h-.01l-.03.01-.39.2q-.4.2-.91.57a5 5 0 0 0-.96.89C3.22 4.07 3 4.5 3 5a3 3 0 0 0 .17 1H2zM7.73 6H4.27A2 2 0 0 1 4 5q0-.3.28-.66.31-.39.76-.7A7 7 0 0 1 6 3.06a8 8 0 0 1 .96.58q.45.31.76.7Q8 4.7 8 5a2 2 0 0 1-.27 1M10 10H7.5V9a1.5 1.5 0 1 0-3 0v1H2V7h8zM6.5 9v1h-1V9a.5.5 0 0 1 1 0M2.25 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $e9fce37105e983ce$export$aae37e29de9a293e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque16Filled', "16", [
    "M2.25 2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m12.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.2 2.04a.5.5 0 0 0-.4 0l-.02.01-.04.02-.6.3c-.39.21-.91.52-1.43.9-.52.37-1.06.84-1.48 1.36A3 3 0 0 0 3.5 6.5q0 .8.26 1.5H2V4.5a.5.5 0 0 0-1 0V13a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.5a1 1 0 1 1 2 0V13a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-1 0V8h-1.76q.26-.7.26-1.5c0-.7-.32-1.34-.73-1.87-.42-.52-.96-.99-1.48-1.36a13 13 0 0 0-2.03-1.2l-.04-.02z"
]);
const $e9fce37105e983ce$export$9b508a46c1df8d27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque16Regular', "16", [
    "M2 4.5a.5.5 0 0 0-1 0V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-1 0V8h-1.76q.26-.7.26-1.5c0-.7-.32-1.34-.73-1.87-.42-.52-.96-.99-1.48-1.36a13 13 0 0 0-2.03-1.2l-.04-.02H8.2a.5.5 0 0 0-.41 0h-.02l-.04.02-.6.3c-.39.21-.91.52-1.43.9-.52.37-1.06.84-1.48 1.36A3 3 0 0 0 3.5 6.5q0 .8.26 1.5H2zM11.16 8H4.84a3.5 3.5 0 0 1-.34-1.5q0-.6.52-1.25c.33-.43.8-.83 1.27-1.17A12 12 0 0 1 8 3.05a12 12 0 0 1 1.7 1.03c.49.34.95.74 1.28 1.17q.52.65.52 1.25 0 .82-.34 1.5M14 13h-4v-1a2 2 0 1 0-4 0v1H2V9h12zm-7-1a1 1 0 1 1 2 0v1H7zM2.25 2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m12.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $e9fce37105e983ce$export$4dc39b0281a563d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque20Filled', "20", [
    "M3.25 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m14.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-7.3-1.46a.5.5 0 0 0-.4 0l-.02.01-.04.02-.68.34c-.44.24-1.02.58-1.6 1s-1.19.94-1.65 1.53A3.4 3.4 0 0 0 5 9q0 1.08.42 2H3V6.5a.5.5 0 0 0-1 0V17a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6.5a.5.5 0 0 0-1 0V11h-2.42q.41-.92.42-2c0-.77-.35-1.47-.81-2.06a8 8 0 0 0-1.65-1.53 15 15 0 0 0-2.28-1.34l-.04-.02z"
]);
const $e9fce37105e983ce$export$4175dd827061eb7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque20Regular', "20", [
    "M2.5 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m15.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-8.05-.7a.5.5 0 0 0-.4 0h-.02l-.04.02-.68.34c-.44.24-1.02.58-1.6 1s-1.19.94-1.65 1.53A3.4 3.4 0 0 0 5 9q0 1.08.42 2H3V6.5a.5.5 0 0 0-1 0V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6.5a.5.5 0 0 0-1 0V11h-2.42q.41-.92.42-2c0-.77-.35-1.47-.81-2.06a8 8 0 0 0-1.65-1.53 15 15 0 0 0-2.28-1.34l-.04-.02zM17 17h-5v-2a2 2 0 1 0-4 0v2H3v-5h14zm-7-3a1 1 0 0 1 1 1v2H9v-2a1 1 0 0 1 1-1m3.4-6.44q.6.73.6 1.44-.01 1.1-.54 2H6.54A4 4 0 0 1 6 9q0-.7.6-1.44c.38-.5.9-.94 1.44-1.34A14 14 0 0 1 10 5.05a14 14 0 0 1 1.96 1.17c.54.4 1.06.85 1.44 1.34"
]);
const $e9fce37105e983ce$export$64e66e4e77edd466 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque24Filled', "24", [
    "M2.75 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m18.5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2.75 7c.41 0 .75.34.75.75V13H6a7 7 0 0 1-.5-2.5c0-1.02.46-1.94 1.06-2.7s1.38-1.43 2.13-1.97a19 19 0 0 1 2.93-1.73l.05-.02.02-.01q.31-.15.62 0h.02l.05.03.87.44c.56.3 1.31.74 2.06 1.29.75.54 1.53 1.2 2.13 1.97.6.76 1.06 1.68 1.06 2.7q-.01 1.34-.5 2.5h2.5V7.75a.75.75 0 0 1 1.5 0v13c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25V19a2 2 0 1 0-4 0v1.75c0 .69-.56 1.25-1.25 1.25h-5.5C2.56 22 2 21.44 2 20.75v-13c0-.41.34-.75.75-.75"
]);
const $e9fce37105e983ce$export$902b92a8d1e07382 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque24Regular', "24", [
    "M3.5 7.75a.75.75 0 0 0-1.5 0v13c0 .69.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25v-13a.75.75 0 0 0-1.5 0V13H18q.49-1.16.5-2.5c0-1.02-.46-1.94-1.06-2.7s-1.38-1.43-2.13-1.97a19 19 0 0 0-2.93-1.73l-.05-.02-.02-.01a.8.8 0 0 0-.62 0h-.02l-.05.03-.87.44c-.56.3-1.31.74-2.06 1.29-.75.54-1.53 1.2-2.13 1.97a4.4 4.4 0 0 0-1.06 2.7q.01 1.34.5 2.5H3.5zM16.33 13H7.67A5 5 0 0 1 7 10.5q.01-.85.74-1.78a9 9 0 0 1 1.82-1.68A17 17 0 0 1 12 5.58a17 17 0 0 1 2.44 1.46c.68.5 1.34 1.07 1.82 1.68q.73.94.74 1.78-.01 1.38-.67 2.5m4.17 7.5h-6v-2a2.5 2.5 0 0 0-5 0v2h-6v-6h17zm-9.5-2a1 1 0 1 1 2 0v2h-2zM3.75 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m17.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $e9fce37105e983ce$export$197f25695704311e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque28Filled', "28", [
    "M4.75 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m19.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3.75 8c.41 0 .75.34.75.75V15h3.17A7 7 0 0 1 7 12c0-1.1.5-2.08 1.14-2.9a12 12 0 0 1 2.3-2.13A20 20 0 0 1 13.6 5.1l.06-.02.02-.01q.31-.15.62 0h.02l.06.03a14 14 0 0 1 .94.48c.6.33 1.42.8 2.23 1.4.82.58 1.66 1.3 2.3 2.12.65.82 1.14 1.8 1.14 2.9 0 1.07-.24 2.1-.67 3h3.17V8.75a.75.75 0 0 1 1.5 0v14.5c0 .97-.78 1.75-1.75 1.75h-5.5c-.97 0-1.75-.78-1.75-1.75V21a2 2 0 1 0-4 0v2.25c0 .97-.78 1.75-1.75 1.75h-5.5C3.78 25 3 24.22 3 23.25V8.75c0-.41.34-.75.75-.75"
]);
const $e9fce37105e983ce$export$80240fb41f8ed2fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque28Regular', "28", [
    "M4.5 8.75a.75.75 0 0 0-1.5 0v14.5c0 .97.78 1.75 1.75 1.75h18.5c.97 0 1.75-.78 1.75-1.75V8.75a.75.75 0 0 0-1.5 0V15h-3.17c.43-.9.67-1.93.67-3 0-1.1-.5-2.08-1.14-2.9a12 12 0 0 0-2.3-2.13A20 20 0 0 0 14.4 5.1l-.06-.02-.02-.01a.8.8 0 0 0-.62 0h-.02l-.06.03a14 14 0 0 0-.94.48c-.6.33-1.42.8-2.23 1.4a12 12 0 0 0-2.3 2.12A4.8 4.8 0 0 0 7 12c0 1.07.24 2.1.67 3H4.5zM18.61 15H9.39a5.5 5.5 0 0 1-.89-3q.01-.96.82-1.97c.52-.67 1.24-1.3 2-1.84A19 19 0 0 1 14 6.59a19 19 0 0 1 2.69 1.6c.75.54 1.47 1.17 2 1.84q.8 1.02.81 1.97c0 1.1-.33 2.14-.89 3m4.64 8.5H17V21a3 3 0 1 0-6 0v2.5H4.75a.25.25 0 0 1-.25-.25V16.5h19v6.75q-.02.23-.25.25M12.5 21a1.5 1.5 0 0 1 3 0v2.5h-3zM3.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m21.5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $e9fce37105e983ce$export$6e85c551e7b24009 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque32Filled', "32", [
    "M5.25 6.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M28 7.5A1.25 1.25 0 1 0 28 5a1.25 1.25 0 0 0 0 2.5M15.6 5.09a1 1 0 0 1 .8 0h.01l.35.16a24 24 0 0 1 3.58 2.14c.97.7 2 1.58 2.78 2.57a5.8 5.8 0 0 1 1.38 3.54q-.02 1.88-.75 3.5H27v-7a1 1 0 1 1 2 0v17a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-2a3 3 0 1 0-6 0v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V10a1 1 0 0 1 2 0v7h3.25a8.5 8.5 0 0 1-.75-3.5c0-1.34.6-2.54 1.38-3.54.79-1 1.8-1.87 2.78-2.57a25 25 0 0 1 3.93-2.3"
]);
const $e9fce37105e983ce$export$41fb7e291808b8c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque32Regular', "32", [
    "M16.4 5.09a1 1 0 0 0-.8 0h-.01l-.03.01-.32.15a24 24 0 0 0-3.58 2.14c-.97.7-2 1.58-2.78 2.57A5.8 5.8 0 0 0 7.5 13.5q.01 1.88.75 3.5H5v-7a1 1 0 0 0-2 0v17c0 1.1.9 2 2 2h22a2 2 0 0 0 2-2V10a1 1 0 1 0-2 0v7h-3.25q.73-1.62.75-3.5a5.8 5.8 0 0 0-1.38-3.54c-.79-1-1.8-1.87-2.78-2.57a25 25 0 0 0-3.9-2.29h-.02v-.01zM21.49 17H10.52a6.5 6.5 0 0 1-1.02-3.5q0-1.1.96-2.3c.62-.8 1.48-1.54 2.38-2.2A23 23 0 0 1 16 7.1 23 23 0 0 1 19.16 9c.9.66 1.76 1.4 2.38 2.2q.95 1.2.96 2.3c0 1.29-.37 2.49-1.02 3.5M27 27h-7v-2a4 4 0 0 0-8 0v2H5v-8h22zm-9-2v2h-4v-2a2 2 0 1 1 4 0M4 7.5A1.25 1.25 0 1 0 4 5a1.25 1.25 0 0 0 0 2.5m25.25-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.59 5.09l-.03.01z"
]);
const $e9fce37105e983ce$export$60eba384d21ad9f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque48Filled', "48", [
    "M7.25 12.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m35.25-1.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m-34 4.5a1.25 1.25 0 1 0-2.5 0v24.5C6 40.99 7 42 8.25 42h9.5c1.24 0 2.25-1 2.25-2.25v-3A3.75 3.75 0 0 1 23.75 33h.5A3.75 3.75 0 0 1 28 36.75v3c0 1.24 1 2.25 2.25 2.25h9.5c1.24 0 2.25-1 2.25-2.25v-24.5a1.25 1.25 0 1 0-2.5 0V26h-4.59c.7-1.52 1.09-3.22 1.09-5 0-1.87-.84-3.55-1.95-4.96a20 20 0 0 0-3.94-3.65 35 35 0 0 0-5.56-3.26l-.03-.02q-.51-.22-1.03 0h-.01l-.03.02-.46.21a34 34 0 0 0-5.1 3.05c-1.4 1-2.84 2.24-3.94 3.65A8 8 0 0 0 12 21c0 1.78.39 3.48 1.09 5H8.5zm16.01-6.14.04.02zh.01"
]);
const $e9fce37105e983ce$export$e8fb71f7f63cd954 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMosque48Regular', "48", [
    "M8.5 15.25a1.25 1.25 0 1 0-2.5 0v24.5C6 40.99 7 42 8.25 42h31.5c1.24 0 2.25-1 2.25-2.25v-24.5a1.25 1.25 0 1 0-2.5 0V26h-4.59c.7-1.52 1.09-3.22 1.09-5 0-1.87-.84-3.55-1.95-4.96a20 20 0 0 0-3.94-3.65 35 35 0 0 0-5.56-3.26l-.03-.02q-.51-.22-1.03 0h-.01l-.03.02-.46.21a34 34 0 0 0-5.1 3.05c-1.4 1-2.84 2.24-3.94 3.65A8 8 0 0 0 12 21c0 1.78.39 3.48 1.09 5H8.5zM32.08 26H15.92a9.5 9.5 0 0 1-1.42-5c0-1.1.5-2.25 1.41-3.41s2.15-2.24 3.45-3.18A33 33 0 0 1 24 11.63a32 32 0 0 1 4.64 2.78c1.3.94 2.54 2.02 3.45 3.18A5.7 5.7 0 0 1 33.5 21c0 1.83-.52 3.55-1.42 5m7.42 13.5H29V36a5 5 0 0 0-10 0v3.5H8.5v-11h31zm-13 0h-5V36a2.5 2.5 0 0 1 5 0zm-19.25-27a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m35.25-1.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M24.51 9.11l.04.02zh.01"
]);
const $e9fce37105e983ce$export$76ef42c4e6944a81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple16Filled', "16", [
    "M4.5 10a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m4-2c.83 0 1.5.67 1.5 1.5V5h2.5c.83 0 1.5.67 1.5 1.5v7a.5.5 0 0 1-.5.5h-1.25a.25.25 0 0 1-.25-.25V12a.5.5 0 0 0-.4-.49l-.1-.01h-2a.5.5 0 0 0-.49.4L9 12v1.75q-.02.23-.25.25H3a1 1 0 0 1-1-1V3.5C2 2.67 2.67 2 3.5 2zm-5 1a.5.5 0 0 0-.5.5V13h4V6.5C7 5.67 7.67 5 8.5 5H9V3.5a.5.5 0 0 0-.5-.5zm6 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-2-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
]);
const $e9fce37105e983ce$export$9523ceef22a12484 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple16Regular', "16", [
    "M4.5 10a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m5 5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-2-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-3-5c.83 0 1.5.67 1.5 1.5V5h2.5c.83 0 1.5.67 1.5 1.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5C2 2.67 2.67 2 3.5 2zm-5 1a.5.5 0 0 0-.5.5V13h4V6.5C7 5.67 7.67 5 8.5 5H9V3.5a.5.5 0 0 0-.5-.5zm5 3a.5.5 0 0 0-.5.5V13h1v-1.5l.01-.1a.5.5 0 0 1 .49-.4h2l.1.01c.23.05.4.25.4.49V13h1V6.5a.5.5 0 0 0-.5-.5zm1.5 7h1v-1h-1z"
]);
const $e9fce37105e983ce$export$9ab24a6b77a2eafb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__a)",
            "d": "M2 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__b)",
            "fillOpacity": ".2",
            "d": "M2 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__c)",
            "d": "M2 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__d)",
            "d": "M5.25 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__e)",
            "d": "M6 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__f)",
            "d": "M6 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__g)",
            "d": "M5.25 15.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__h)",
            "d": "M16 5a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7c0-1.1.9-2 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__i)",
            "d": "M11 15.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V18h-4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__j)",
            "d": "M11.25 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__k)",
            "d": "M14.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__l)",
            "d": "M12 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_20_color__m)",
            "d": "M14.75 12.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__a",
                "x1": "2.36",
                "x2": "12.45",
                "y1": "5",
                "y2": "11.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#a3a3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5750e2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__b",
                "x1": "5.5",
                "x2": "9",
                "y1": "4",
                "y2": "4",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__c",
                "x1": "9.13",
                "x2": "9",
                "y1": "6.88",
                "y2": "2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#a3a3ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#a3a3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__d",
                "x1": "4",
                "x2": "6",
                "y1": "4.5",
                "y2": "16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__e",
                "x1": "4",
                "x2": "6",
                "y1": "4.5",
                "y2": "16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__f",
                "x1": "4",
                "x2": "6",
                "y1": "4.5",
                "y2": "16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__g",
                "x1": "4",
                "x2": "6",
                "y1": "4.5",
                "y2": "16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__h",
                "x1": "8",
                "x2": "20.41",
                "y1": "5.41",
                "y2": "17.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__i",
                "x1": "11.14",
                "x2": "13.11",
                "y1": "15.56",
                "y2": "18.29",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__j",
                "x1": "12",
                "x2": "13.5",
                "y1": "7.5",
                "y2": "13.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__k",
                "x1": "12",
                "x2": "13.5",
                "y1": "7.5",
                "y2": "13.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__l",
                "x1": "12",
                "x2": "13.5",
                "y1": "7.5",
                "y2": "13.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_20_color__m",
                "x1": "12",
                "x2": "13.5",
                "y1": "7.5",
                "y2": "13.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$96c34776cc3f34e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple20Filled', "20", [
    "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 1 1h7.5a.5.5 0 0 0 .5-.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2c0 .28.22.5.5.5H17a1 1 0 0 0 1-1V7a2 2 0 0 0-2-2h-4V4a2 2 0 0 0-2-2zm7 3h-1a2 2 0 0 0-2 2v10H3V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zM5.25 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m5.25-2.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.75-2.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $e9fce37105e983ce$export$d6a26b879d0e322d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple20Regular', "20", [
    "M2 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v1h4a2 2 0 0 1 2 2v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm10 13h2v-2h-2zm3 0h2V7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v10h2v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zM11 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v13h5V7c0-1.1.9-2 2-2h1zm1 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m5.25 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 14.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75-2.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M15.5 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $e9fce37105e983ce$export$e1349155648e4062 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__a)",
            "fillRule": "evenodd",
            "d": "M14 4.25V22H3.75a.75.75 0 0 1-.75-.75v-17C3 3.01 4 2 5.25 2h6.5C12.99 2 14 3 14 4.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__b)",
            "fillOpacity": ".2",
            "fillRule": "evenodd",
            "d": "M14 4.25V22H3.75a.75.75 0 0 1-.75-.75v-17C3 3.01 4 2 5.25 2h6.5C12.99 2 14 3 14 4.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__c)",
            "fillRule": "evenodd",
            "d": "M14 4.25V22H3.75a.75.75 0 0 1-.75-.75v-17C3 3.01 4 2 5.25 2h6.5C12.99 2 14 3 14 4.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__d)",
            "d": "M8 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__e)",
            "d": "M8 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__f)",
            "d": "M8 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__g)",
            "d": "M8 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__h)",
            "d": "M8 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__i)",
            "d": "M18.75 5C19.99 5 21 6 21 7.25v14c0 .41-.34.75-.75.75H11a1 1 0 0 1-1-1V7.25C10 6.01 11 5 12.25 5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__j)",
            "d": "M13 19a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3h-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__k)",
            "d": "M15 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__l)",
            "d": "M15 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__m)",
            "d": "M15 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__n)",
            "d": "M18 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__o)",
            "d": "M18 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_multiple_24_color__p)",
            "d": "M18 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__a",
                "x1": "3.39",
                "x2": "15.29",
                "y1": "5.75",
                "y2": "12.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#a3a3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5750e2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__b",
                "x1": "6.85",
                "x2": "10.7",
                "y1": "4.5",
                "y2": "4.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__c",
                "x1": "10.84",
                "x2": "10.66",
                "y1": "8.09",
                "y2": "2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#a3a3ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#a3a3ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__d",
                "x1": "5.33",
                "x2": "8",
                "y1": "4.33",
                "y2": "19.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__e",
                "x1": "5.33",
                "x2": "8",
                "y1": "4.33",
                "y2": "19.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__f",
                "x1": "5.33",
                "x2": "8",
                "y1": "4.33",
                "y2": "19.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__g",
                "x1": "5.33",
                "x2": "8",
                "y1": "4.33",
                "y2": "19.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__h",
                "x1": "5.33",
                "x2": "8",
                "y1": "4.33",
                "y2": "19.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__i",
                "x1": "10",
                "x2": "25.94",
                "y1": "5.53",
                "y2": "18.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__j",
                "x1": "13.8",
                "x2": "16.47",
                "y1": "18.75",
                "y2": "22.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__k",
                "x1": "14.5",
                "x2": "18.71",
                "y1": "7.11",
                "y2": "16.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__l",
                "x1": "14.5",
                "x2": "18.71",
                "y1": "7.11",
                "y2": "16.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__m",
                "x1": "14.5",
                "x2": "18.71",
                "y1": "7.11",
                "y2": "16.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__n",
                "x1": "14.5",
                "x2": "18.71",
                "y1": "7.11",
                "y2": "16.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__o",
                "x1": "14.5",
                "x2": "18.71",
                "y1": "7.11",
                "y2": "16.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_multiple_24_color__p",
                "x1": "14.5",
                "x2": "18.71",
                "y1": "7.11",
                "y2": "16.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$a8dcc00100415626 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple24Filled', "24", [
    "M7 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-2.75V5h4.75C19.99 5 21 6 21 7.25v13.5c0 .41-.34.75-.75.75h-3v-2.75a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v2.75h-10a.75.75 0 0 1-.75-.75V4.25C3 3.01 4 2 5.25 2h6.5C12.99 2 14 3 14 4.25M5.25 3.5a.75.75 0 0 0-.75.75V20H10V7.25C10 6.01 11 5 12.25 5h.25v-.75a.75.75 0 0 0-.75-.75zM18 15a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $e9fce37105e983ce$export$d8b07e6d4c321b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingMultiple24Regular', "24", [
    "M8 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-4v-.75C14 3.01 13 2 11.75 2h-6.5C4.01 2 3 3 3 4.25v16.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V7.25C21 6.01 20 5 18.75 5zm-9.5-.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75V5h-.25C11.01 5 10 6 10 7.25V20H4.5zM14.5 20v-1.5h2V20zm3.5-2.25a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75V20h-1.5V7.25c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75V20H18z"
]);
const $e9fce37105e983ce$export$cf3882ec61f2e818 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__a)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V14H3.5a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__b)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V14H3.5a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__c)",
            "d": "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V14H3.5a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__d)",
            "d": "M6 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__e)",
            "d": "M8 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__f)",
            "d": "M6 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__g)",
            "d": "M8 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__h)",
            "d": "M6 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__i)",
            "d": "M13.75 14c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-2.1c-.66 0-1.2.54-1.2 1.2 0 .89.6 1.8 2.25 1.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__j)",
            "fillOpacity": ".5",
            "d": "M13.75 14c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-2.1c-.66 0-1.2.54-1.2 1.2 0 .89.6 1.8 2.25 1.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__k)",
            "d": "M15 8.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__l)",
            "d": "M10 15c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6H8.6c-.88 0-1.6.72-1.6 1.6 0 1.18.8 2.4 3 2.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__m)",
            "d": "M10 15c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6H8.6c-.88 0-1.6.72-1.6 1.6 0 1.18.8 2.4 3 2.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_16_color__n)",
            "d": "M11.75 8.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__a",
                "x1": "3",
                "x2": "13.98",
                "y1": "2.38",
                "y2": "10.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__d",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__e",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__f",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__g",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__h",
                "x1": "5.9",
                "x2": "9.51",
                "y1": "3.33",
                "y2": "9.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__i",
                "x1": "12.57",
                "x2": "13.78",
                "y1": "11.4",
                "y2": "14.29",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__k",
                "x1": "13.09",
                "x2": "14.37",
                "y1": "7.83",
                "y2": "9.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__l",
                "x1": "8.43",
                "x2": "10.04",
                "y1": "11.53",
                "y2": "15.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__m",
                "x1": "10",
                "x2": "12.29",
                "y1": "10.52",
                "y2": "16.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_16_color__n",
                "x1": "9.08",
                "x2": "10.87",
                "y1": "6.97",
                "y2": "9.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.10763 -.0625 .0499 3.27938 8.9 13.28)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(88.78 -.74 9.43)scale(2.28177 1.77523)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_16_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-8.4 90.54 -68.13)scale(2.9936 3.52614)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$7f4fd01988fbf155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople16Filled', "16", [
    "M4.5 2C3.67 2 3 2.67 3 3.5v10c0 .28.22.5.5.5h2.8q-.3-.7-.3-1.4a2.6 2.6 0 0 1 1.95-2.52A2.75 2.75 0 0 1 10 5.5v-2C10 2.67 9.33 2 8.5 2zm1 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m2-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m4.25 3.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 12.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $e9fce37105e983ce$export$1db605328823577a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople16Regular', "16", [
    "M5.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-1-8C3.67 2 3 2.67 3 3.5v10c0 .28.22.5.5.5h2.8a3 3 0 0 1-.28-1H4V3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v2.19q.47-.19 1-.19v-2C10 2.67 9.33 2 8.5 2zm3 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m5.75 1.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 12.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $e9fce37105e983ce$export$7e3403a4257bbbae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__a)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h10c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__b)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h10c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__c)",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v14c0 .28.22.5.5.5h10c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__d)",
            "d": "M6.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__e)",
            "d": "M11 5.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__f)",
            "d": "M11 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__g)",
            "d": "M7.5 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__h)",
            "d": "M7.5 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__i)",
            "d": "M16.75 18c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-2.1c-.66 0-1.2.54-1.2 1.2 0 .89.6 1.8 2.25 1.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__j)",
            "fillOpacity": ".5",
            "d": "M16.75 18c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-2.1c-.66 0-1.2.54-1.2 1.2 0 .89.6 1.8 2.25 1.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__k)",
            "d": "M18 12.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__l)",
            "d": "M13 19c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.8c-.88 0-1.6.72-1.6 1.6 0 1.18.8 2.4 3 2.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__m)",
            "d": "M13 19c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.8c-.88 0-1.6.72-1.6 1.6 0 1.18.8 2.4 3 2.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_20_color__n)",
            "d": "M14.75 12.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__a",
                "x1": "4",
                "x2": "19.26",
                "y1": "2.5",
                "y2": "17.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__d",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__e",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__f",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__g",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__h",
                "x1": "7.35",
                "x2": "11.4",
                "y1": "4.17",
                "y2": "12.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__i",
                "x1": "15.57",
                "x2": "16.78",
                "y1": "15.4",
                "y2": "18.29",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__k",
                "x1": "16.09",
                "x2": "17.37",
                "y1": "11.83",
                "y2": "13.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__l",
                "x1": "11.43",
                "x2": "13.04",
                "y1": "15.53",
                "y2": "19.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__m",
                "x1": "13",
                "x2": "15.29",
                "y1": "14.52",
                "y2": "20.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_20_color__n",
                "x1": "12.08",
                "x2": "13.87",
                "y1": "10.97",
                "y2": "13.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4 0 0 3.69444 12 17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -3 0 13.5 13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_20_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-8.4 119.26 -86.55)scale(2.9936 3.52614)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$144b90116c605de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople20Filled', "20", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v1.23q-.29.15-.51.35a2.75 2.75 0 1 0-4.54 3A2.6 2.6 0 0 0 9 16.6q0 .7.3 1.4H4.5a.5.5 0 0 1-.5-.5zm3.5 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M6.75 8a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m.75 3.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M10.25 5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M11 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m3.75 3.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $e9fce37105e983ce$export$d2ad6db02d0460fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople20Regular', "20", [
    "M6.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3-3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M4 17.5c0 .28.22.5.5.5h4.8a3 3 0 0 1-.28-1H5V3.5c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v5c0 .28.22.5.5.5h2c.28 0 .5.22.5.5v.86q.3.32.49.72.22-.2.51-.35V9.5c0-.83-.67-1.5-1.5-1.5H13V3.5c0-.83-.67-1.5-1.5-1.5h-6C4.67 2 4 2.67 4 3.5zm2.75-5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m8 5.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $e9fce37105e983ce$export$cd16ad44d2a678ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__a)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__b)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__c)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__d)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__e)",
            "d": "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__f)",
            "d": "M7 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__g)",
            "d": "M20 22c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.8c-.88 0-1.6.72-1.6 1.6 0 1.18.8 2.4 3 2.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__h)",
            "fillOpacity": ".5",
            "d": "M20 22c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.8c-.88 0-1.6.72-1.6 1.6 0 1.18.8 2.4 3 2.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__i)",
            "d": "M20 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__j)",
            "d": "M15.5 23c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__k)",
            "d": "M15.5 23c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_people_24_color__l)",
            "d": "M15.5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__a",
                "x1": "4",
                "x2": "23.08",
                "y1": "2.63",
                "y2": "22.17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__f",
                "x1": "9.15",
                "x2": "13.95",
                "y1": "4.5",
                "y2": "15.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__g",
                "x1": "18.43",
                "x2": "20.04",
                "y1": "18.53",
                "y2": "22.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__i",
                "x1": "19.21",
                "x2": "20.74",
                "y1": "14.4",
                "y2": "16.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__j",
                "x1": "13.66",
                "x2": "15.78",
                "y1": "18.66",
                "y2": "23.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__k",
                "x1": "15.5",
                "x2": "18.52",
                "y1": "17.4",
                "y2": "25.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_people_24_color__l",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "13.53",
                "y2": "16.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.6875 .0625 -.05412 4.92472 14.31 20.66)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.875 -.125 .10824 5.08708 19.44 19.72)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(88.99 -.2 15.95)scale(3.5318 3.76726)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(91.45 2.59 17.91)scale(2.46954 2.63418)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_building_people_24_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.94861 -.58333 .6871 4.65104 16.24 20)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$d5da297a31f09472 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople24Filled', "24", [
    "M4 4.25C4 3.01 5 2 6.25 2h7.5C14.99 2 16 3 16 4.25V9.5h1.75c1.24 0 2.25 1 2.25 2.25v1.3a2.5 2.5 0 0 0-1.62 1.12 3 3 0 1 0-5.05 2.9A3 3 0 0 0 11 20c0 .66.15 1.37.5 2H4.76a.75.75 0 0 1-.75-.75zM8 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1 6a1 1 0 1 0 2 0 1 1 0 0 0-2 0M7 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4-3.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 3.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4.5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3m4-1.02.5.02c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.16c.47.53.76 1.23.76 2 0 .66-.14 1.35-.5 1.98M22 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $e9fce37105e983ce$export$222917a4d4d997ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingPeople24Regular', "24", [
    "M4.75 22a.75.75 0 0 1-.75-.75v-17C4 3.01 5 2 6.25 2h8c1.24 0 2.25 1 2.25 2.25V9.5h1.25c1.24 0 2.25 1 2.25 2.25v1.3a2.5 2.5 0 0 0-1.5.95v-2.25a.75.75 0 0 0-.75-.75h-2a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 0-.75-.75h-8a.75.75 0 0 0-.75.75V20.5h5.53q.07.77.48 1.5zM7.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0M12 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1-2.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M8.5 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 6c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3m4-1.02.5.02c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.16c.47.53.76 1.23.76 2 0 .66-.14 1.35-.5 1.98M22 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $e9fce37105e983ce$export$a35ae265e4a393e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetail20Filled', "20", [
    "M6 10V8h8v2zm6 4v-1h2v1zm6-9.5c0 .65-.42 1.2-1 1.41V16.5a.5.5 0 0 1-.5.5H10v-4.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V17H3.5a.5.5 0 0 1-.5-.5V5.91A1.5 1.5 0 0 1 3.5 3h13c.83 0 1.5.67 1.5 1.5m-15 0c0 .28.22.5.5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5M5.5 7a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6 5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zM6 17h3v-4H6z"
]);
const $e9fce37105e983ce$export$c1e61b61effadc58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetail20Regular', "20", [
    "M5.5 7a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm.5 3V8h8v2zm5.5 2a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm.5 2v-1h2v1zM2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 0 1 .5 2.91V16.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V5.91c-.58-.2-1-.76-1-1.41M3.5 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM4 6v10h1v-3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V16h6V6zm2 10h3v-3H6z"
]);
const $e9fce37105e983ce$export$31ae980488cac4ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetail24Filled', "24", [
    "M7.5 11.5v-2h9v2zM4 3a2 2 0 0 0-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75V21h8.75c.41 0 .75-.34.75-.75V6.73A2 2 0 0 0 20 3zm-.5 2c0-.28.22-.5.5-.5h16a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5m3.25 3h10.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75H6.75a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75m8 7h2.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1-.75-.75v-2.5c0-.41.34-.75.75-.75M10 16.5V21H7.5v-4.5z"
]);
const $e9fce37105e983ce$export$54f2bc278bf02b20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetail24Regular', "24", [
    "M6.75 8a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zm.75 3.5v-2h9v2zm6.25 2.5a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 0 0-.75-.75zm.75 2.5v-1h2v1zM4 3a2 2 0 0 0-1 3.73v13.52c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V6.73A2 2 0 0 0 20 3zm15.5 4v12.5h-8v-4.75a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0-.75.75v4.75H4.5V7zm-16-2c0-.28.22-.5.5-.5h16a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5M10 19.5H7.5v-4H10z"
]);
const $e9fce37105e983ce$export$154bc46f0201bb32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMoney20Filled', "20", [
    "M6 10V8h8v2zm11-4.09A1.5 1.5 0 0 0 16.5 3h-13A1.5 1.5 0 0 0 3 5.91V16.5c0 .28.22.5.5.5H5v-4.5c0-.28.22-.5.5-.5h4c.2 0 .38.12.46.3q.46-.3 1.04-.3h6zM3.5 4h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1M5 7.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zM9 13v4H6v-4zm8.5 0c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5zm0 5c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5zm.5-3.5a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5zm-6.5-.5a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm3.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $e9fce37105e983ce$export$9fafac402876f5d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMoney20Regular', "20", [
    "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 0 1 .5 2.91V12h-1V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4c.2 0 .38.12.46.3A2 2 0 0 0 9 14v-1H6v3h3v1H3.5a.5.5 0 0 1-.5-.5V5.91c-.58-.2-1-.76-1-1.41M3.5 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm.5 3V8h8v2zm13 4.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5M17.5 18c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5zm.5-3.5a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5zm-6.5-.5a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm3.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $e9fce37105e983ce$export$a07a0dc72af14bc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMoney24Filled', "24", [
    "M7.5 11.5v-2h9v2zM4 3a2 2 0 0 0-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75V16c.46-.6 1.18-1 2-1H21V6.73A2 2 0 0 0 20 3zm-.5 2c0-.28.22-.5.5-.5h16a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5m3.25 3h10.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75H6.75a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75M10 16.5V21H7.5v-4.5zm2 1c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5zm10 .5a1 1 0 0 1-1-1h-1c0 1.1.9 2 2 2zm0 2a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1zm-8-3a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2zm1 5a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1zm4.25-2.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0"
]);
const $e9fce37105e983ce$export$ade014a702bd27d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMoney24Regular', "24", [
    "M6.75 8a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zm.75 3.5v-2h9v2zm6.25 2.5a.75.75 0 0 0-.75.75v.3q.24-.05.5-.05H18v-.25a.75.75 0 0 0-.75-.75zm-2.25.75V16q-.48.65-.5 1.5V21H3.75a.75.75 0 0 1-.75-.75V6.73A2 2 0 0 1 4 3h16a2 2 0 0 1 1 3.73V15h-1.5V7h-15v12.5H6v-4.75c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75M3.5 5c0 .28.22.5.5.5h16a.5.5 0 0 0 0-1H4a.5.5 0 0 0-.5.5M10 19.5v-4H7.5v4zm2-2c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5zm10 .5a1 1 0 0 1-1-1h-1c0 1.1.9 2 2 2zm0 2a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1zm-8-3a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2zm1 5a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1zm4.25-2.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0"
]);
const $e9fce37105e983ce$export$cbd9bd1d3d5cb9e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMore20Filled', "20", [
    "M4 3.3a1 1 0 0 1 .7-.3h10.6a1 1 0 0 1 .7.3l2.64 2.63c.76.77.22 2.07-.85 2.07H2.2a1.21 1.21 0 0 1-.85-2.07zM17 9H3v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2zM7 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $e9fce37105e983ce$export$885a673e77dec19f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMore20Regular', "20", [
    "M7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4 3.3a1 1 0 0 1 .7-.3h10.6a1 1 0 0 1 .7.3l2.64 2.63c.76.77.22 2.07-.85 2.07H17v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8h-.79a1.21 1.21 0 0 1-.85-2.07zM16 15V8H4v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1m1.79-8c.18 0 .28-.23.14-.36L15.3 4H4.71L2.07 6.64A.21.21 0 0 0 2.2 7z"
]);
const $e9fce37105e983ce$export$36d38ff12be2b0ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMore24Filled', "24", [
    "M6.22 3c-.52 0-1.01.23-1.35.63L1.3 7.95c-.67.82-.1 2.05.96 2.05h19.5c1.05 0 1.63-1.23.96-2.05l-3.58-4.32c-.33-.4-.83-.63-1.35-.63zM3 11.5v7.25a2.5 2.5 0 0 0 2.5 2.5h13a2.5 2.5 0 0 0 2.5-2.5V11.5zm6 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m3 1.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m5.5-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $e9fce37105e983ce$export$eeb65c5b10e4702a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMore24Regular', "24", [
    "M7.75 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m5.5-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m3 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M4.87 3.63c.34-.4.83-.63 1.35-.63h11.56c.52 0 1.02.23 1.35.63l3.58 4.32c.67.82.1 2.05-.96 2.05H21v8.75a2.5 2.5 0 0 1-2.5 2.5h-13a2.5 2.5 0 0 1-2.5-2.5V10h-.75a1.25 1.25 0 0 1-.96-2.05zm1.35.87a.3.3 0 0 0-.2.09L2.8 8.5H21.2l-3.24-3.91a.3.3 0 0 0-.19-.09zM4.5 10v8.75a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V10z"
]);
const $e9fce37105e983ce$export$a1b84b2af1225e09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMore32Filled', "32", [
    "M6.13 4.09A3 3 0 0 1 8.44 3h15.12a3 3 0 0 1 2.31 1.09l4.67 5.63A2 2 0 0 1 28.99 13H3.01a2 2 0 0 1-1.55-3.28zM4 15v10.75C4 27.55 5.46 29 7.25 29h17.5c1.8 0 3.25-1.46 3.25-3.25V15zm8 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4m8-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $e9fce37105e983ce$export$1a87dc019a2f1564 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailMore32Regular', "32", [
    "M10 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4m8-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6.13 4.09A3 3 0 0 1 8.44 3h15.12a3 3 0 0 1 2.31 1.09l4.67 5.63A2 2 0 0 1 28.99 13H28v12.75c0 1.8-1.46 3.25-3.25 3.25H7.25A3.25 3.25 0 0 1 4 25.75V13H3a2 2 0 0 1-1.54-3.28zM6 13v12.75c0 .69.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25V13zm2.44-8a1 1 0 0 0-.77.36L3.01 11h25.98l-4.66-5.64a1 1 0 0 0-.77-.36z"
]);
const $e9fce37105e983ce$export$ef64b58e05926260 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailShield20Filled', "20", [
    "M14.12 9.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4M16.5 3a1.5 1.5 0 0 1 .5 2.92v4.27c-.49-.2-.92-.5-1.24-.78l-.19-.17-.11-.1q-.21-.16-.46-.24V7.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h4.76q-.2.27-.25.66l-.01.15V12H5.5a.5.5 0 0 0-.5.5V17H3.5a.5.5 0 0 1-.5-.5V5.92A1.5 1.5 0 0 1 3.5 3zM10 17H6v-4h4zm4-8.1q-.25.08-.46.24l-.11.1a5 5 0 0 1-1.03.76H6V8h8zM3.5 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $e9fce37105e983ce$export$4d00975665c583ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailShield20Regular', "20", [
    "M14.12 9.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4M16.5 3a1.5 1.5 0 0 1 .5 2.92v4.27a4 4 0 0 1-1-.58V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V16h.46q.27.56.65 1H3.5a.5.5 0 0 1-.5-.5V5.92A1.5 1.5 0 0 1 3.5 3zM6 16h3v-3H6zm8.5-9c.28 0 .5.22.5.5v1.4a1.6 1.6 0 0 0-1 0V8H6v2h6.4q-.43.25-.93.36l-.27.04c-.34.07-.7.28-.94.6H5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5zm-11-3a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $e9fce37105e983ce$export$9549c274d12df970 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailShield24Filled', "24", [
    "M17.01 11.2a.7.7 0 0 1 .98 0c.65.65 1.9 1.68 3.45 1.9.3.04.56.28.56.58v2.84c0 3.82-3.58 5.2-4.35 5.46q-.15.05-.3 0c-.77-.26-4.35-1.64-4.35-5.46v-2.84c0-.3.25-.54.56-.59a6.4 6.4 0 0 0 3.45-1.9M20 3a2 2 0 0 1 1 3.73v5.24a6 6 0 0 1-2.31-1.48q-.3-.3-.69-.41V8.75a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h5.41q-.15.3-.16.69V15H6.75a.75.75 0 0 0-.75.75V21H3.75a.75.75 0 0 1-.75-.75V6.73A2 2 0 0 1 4 3zm-8.5 18h-4v-4.5h4zm5-10.68q-.1.07-.2.17c-.29.28-.73.68-1.28 1.01H7.5v-2h9zM4 4.5a.5.5 0 0 0 0 1h16a.5.5 0 0 0 0-1z"
]);
const $e9fce37105e983ce$export$9a9649cbab335150 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailShield24Regular', "24", [
    "M17.01 11.2a.7.7 0 0 1 .98 0c.65.65 1.9 1.68 3.45 1.9.3.04.56.28.56.58v2.84c0 3.82-3.58 5.2-4.35 5.46q-.15.05-.3 0c-.77-.26-4.35-1.64-4.35-5.46v-2.84c0-.3.25-.54.56-.59a6.4 6.4 0 0 0 3.45-1.9M20 3a2 2 0 0 1 1 3.73v5.24a5 5 0 0 1-1.5-.79V7h-15v12.5H6v-4.75c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75v4.75h1.23q.45.81 1.13 1.5H3.75a.75.75 0 0 1-.75-.75V6.73A2 2 0 0 1 4 3zM7.5 19.5H10v-4H7.5zM17.25 8c.41 0 .75.34.75.75v1.33a1.7 1.7 0 0 0-1.5.24V9.5h-9v2h7.52a4 4 0 0 1-1.6.6c-.5.08-1 .4-1.26.9H6.75a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75zM4 4.5a.5.5 0 0 0 0 1h16a.5.5 0 0 0 0-1z"
]);
const $e9fce37105e983ce$export$a74612fe75f20057 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailToolbox20Filled', "20", [
    "M17 5.91A1.5 1.5 0 0 0 16.5 3h-13A1.5 1.5 0 0 0 3 5.91V16.5c0 .28.22.5.5.5H5v-4.5c0-.28.22-.5.5-.5h4c.37-.5.91-.84 1.54-.96l.01-.04H5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5V9h.5q.85.02 1.5.5zM3.5 4h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1M9 13v4H6v-4zm4.5-4h.5V8H6v2h5.5c.46-.6 1.18-1 2-1M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $e9fce37105e983ce$export$494d2a5320a92409 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailToolbox20Regular', "20", [
    "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 0 1 .5 2.91V9.5q-.45-.33-1-.45V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4q-.48.64-.5 1.5V13H6v3h3v1H3.5a.5.5 0 0 1-.5-.5V5.91c-.58-.2-1-.76-1-1.41M3.5 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM15 7.5V9h-1V8H6v2h5.5q-.33.45-.45 1H5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $e9fce37105e983ce$export$5292e7c34365f53e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailToolbox24Filled', "24", [
    "M7.5 11.5v-2h9v1.75h-.75q-.61 0-1.15.25zM18 8.75v2.5h1.25c.66 0 1.27.24 1.75.63V6.73A2 2 0 0 0 20 3H4a2 2 0 0 0-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4q.36 0 .57.27A2.5 2.5 0 0 1 13 14.05V14q0-.53.19-1H6.75a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75h10.5c.41 0 .75.34.75.75M3.5 5c0-.28.22-.5.5-.5h16a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5M10 16.5V21H7.5v-4.5zm4-1.5h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5"
]);
const $e9fce37105e983ce$export$5ed5643e03520e73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingRetailToolbox24Regular', "24", [
    "M6.75 8a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h6.44c.26-.66.77-1.2 1.41-1.5H7.5v-2h9v1.75H18v-2.5a.75.75 0 0 0-.75-.75zm4.75 6.75V15q-.48.64-.5 1.5V21H3.75a.75.75 0 0 1-.75-.75V6.73A2 2 0 0 1 4 3h16a2 2 0 0 1 1 3.73v5.15a2.7 2.7 0 0 0-1.5-.62V7h-15v12.5H6v-4.75c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75M3.5 5c0 .28.22.5.5.5h16a.5.5 0 0 0 0-1H4a.5.5 0 0 0-.5.5M10 19.5v-4H7.5v4zm4-4.5h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75zm1.5-1q.02-.23.25-.25h3.5q.23.02.25.25v1h-4zM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5"
]);
const $e9fce37105e983ce$export$40bd169141521308 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingShop16Filled', "16", [
    "M10 10v1h1v-1zM4.19 1.11l-2.5 2c-.17.13-.19.36-.19.56V5.5q.02.86.5 1.5v7.5c0 .28.22.5.5.5H4V9.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V15h5.5a.5.5 0 0 0 .5-.5V7q.48-.64.5-1.5V3.67c0-.2-.02-.43-.19-.56l-2.5-2A.5.5 0 0 0 11.5 1h-7a.5.5 0 0 0-.31.11M2.5 5.5V4h3v1.5a1.5 1.5 0 1 1-3 0m4 0V4h3v1.5a1.5 1.5 0 1 1-3 0m4 0V4h3v1.5a1.5 1.5 0 0 1-3 0M3.43 3l1.25-1h1.35l-.38 1zm3.3 0 .37-1h1.79l.33 1zm3.21-1h1.38l1.25 1h-2.3zM9 9.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zM5 15h2v-5H5z"
]);
const $e9fce37105e983ce$export$6d9fb55f8a3a39b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingShop16Regular', "16", [
    "M9 9.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zm1 1.5h1v-1h-1zM4.19 1.11l-2.5 2c-.17.13-.19.36-.19.56V5.5q.02.86.5 1.5v7.5c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V7q.48-.64.5-1.5V3.67c0-.2-.02-.43-.19-.56l-2.5-2A.5.5 0 0 0 11.5 1h-7a.5.5 0 0 0-.31.11M5.5 4v1.5a1.5 1.5 0 1 1-3 0V4zm4 0v1.5a1.5 1.5 0 1 1-3 0V4zm4 0v1.5a1.5 1.5 0 0 1-3 0V4zM6.03 2l-.38 1H3.43l1.25-1zm.7 1 .37-1h1.79l.33 1zm3.21-1h1.38l1.25 1h-2.3zM13 7.8V14H8V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V14H3V7.8A2.5 2.5 0 0 0 6 7a2.5 2.5 0 0 0 4 0 2.5 2.5 0 0 0 3 .8M7 14H5v-4h2z"
]);
const $e9fce37105e983ce$export$bbb10d70f35d6c5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingShop20Filled', "20", [
    "M12 12h2v2h-2zM5 2h10a.5.5 0 0 1 .38.18l2.5 3c.12.14.12.21.12.3V7a3 3 0 0 1-1 2.24v8.26a.5.5 0 0 1-.5.5H10v-6.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V18H3.5a.5.5 0 0 1-.5-.5V9.24A3 3 0 0 1 2 7V5.5a.5.5 0 0 1 .12-.32l2.5-3A.5.5 0 0 1 5 2M3 6v1a2 2 0 1 0 4 0V6zm5 0v1a2 2 0 1 0 4 0V6zm5 0v1a2 2 0 1 0 4 0V6zM5.23 3 3.57 5h3.57l.67-2zm6.58 2-.67-2H8.86l-.67 2zm1.05 0h3.57l-1.66-2h-2.58zM11 11.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M9 18v-6H6v6z"
]);
const $e9fce37105e983ce$export$1d8210a77a9fac54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingShop20Regular', "20", [
    "M11 11.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5m1 2.5v-2h2v2zM5 2a.5.5 0 0 0-.38.18l-2.5 3A.5.5 0 0 0 2 5.5V7a3 3 0 0 0 1 2.24v8.26c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5V9.24A3 3 0 0 0 18 7V5.48c0-.09 0-.16-.12-.3l-2.5-3A.5.5 0 0 0 15 2zm0 7a2 2 0 0 1-2-2V6h4v1a2 2 0 0 1-2 2m5 0a2 2 0 0 1-2-2V6h4v1a2 2 0 0 1-2 2m5 0a2 2 0 0 1-2-2V6h4v1a2 2 0 0 1-2 2M5 17H4V9.83a3 3 0 0 0 3.5-1.17 3 3 0 0 0 5 0A3 3 0 0 0 16 9.83V17h-6v-5.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5zM7.14 5H3.57l1.66-2h2.58zm4.67 0H8.19l.67-2h2.28zm1.05 0-.67-2h2.58l1.66 2zM6 17v-5h3v5z"
]);
const $e9fce37105e983ce$export$4076c92590728732 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingShop24Filled', "24", [
    "M10.5 14.5V22h-3v-7.5zm6.76-1.5h-3.5a.75.75 0 0 0-.76.75v3.5c0 .42.34.75.75.75h3.5c.42 0 .76-.33.76-.75v-3.5a.75.75 0 0 0-.75-.75m-.76 1.5v2h-2v-2zM8.17 7H3.5v1.17c0 1.18.88 2.15 2.02 2.3l.15.02h.16c1.24 0 2.25-.95 2.33-2.16V7m6.16 0H9.67v1.17c0 1.18.87 2.15 2.01 2.3l.16.02H12c1.23 0 2.24-.95 2.33-2.16V7m6.17 0h-4.67v1.17c0 1.18.88 2.15 2.02 2.3l.16.02h.16c1.23 0 2.24-.95 2.32-2.16V7M9.06 3.5H6.33l-1.86 2h3.98zm4.3 0h-2.73l-.62 2h3.97zm4.31 0h-2.73l.61 2h3.98zM2.2 5.74l3.25-3.5q.19-.19.45-.23L6 2h12q.27 0 .47.17l.08.07 3.27 3.53.03.04q.15.2.15.44v1.92c0 1-.38 1.9-1 2.58v10.5c0 .38-.28.7-.65.74l-.1.01H12v-8.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V22H3.75a.75.75 0 0 1-.74-.65v-10.6a3.8 3.8 0 0 1-1-2.39V6.3q-.03-.21.09-.4l.05-.08z"
]);
const $e9fce37105e983ce$export$7bdb758b59f6c97a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingShop24Regular', "24", [
    "M18 2q.27 0 .47.17l.08.07 3.27 3.53.03.04q.15.2.15.44v1.92c0 1-.38 1.9-1 2.58v10.5c0 .38-.28.7-.65.74l-.1.01H3.75a.75.75 0 0 1-.74-.65v-10.6a3.8 3.8 0 0 1-1-2.36V6.3q-.03-.21.09-.4l.06-.1.04-.05 3.25-3.5q.19-.19.45-.23L6 2zm-2.92 8.44-.01.02a3.83 3.83 0 0 1-6.15-.02 3.8 3.8 0 0 1-4.42 1.32v8.74H6v-6.75c0-.38.28-.7.65-.74h4.6c.38 0 .69.27.74.64v6.85h7.5v-8.74a3.8 3.8 0 0 1-4.4-1.32M10.5 14.5h-3v6h3zm6.76-1.5c.37 0 .69.28.74.65v3.6c0 .38-.28.7-.64.75h-3.6a.75.75 0 0 1-.75-.65v-3.6c0-.38.28-.7.64-.74h3.6m-.76 1.5h-2v2h2zM8.17 7H3.5v1.34l.04.23.03.16.05.17.05.15.04.09.1.2.1.16.06.07.13.16.14.14.1.09.04.03q.49.38 1.11.48l.18.02h.16c1.24 0 2.25-.95 2.33-2.16V7m6.16 0H9.67v1.17c0 1.18.87 2.15 2.01 2.3l.16.02H12c1.23 0 2.24-.95 2.33-2.16V7m6.17 0h-4.67v1.17c0 1.18.88 2.15 2.02 2.3l.16.02h.16c.56 0 1.08-.2 1.48-.52l.1-.08.1-.12.15-.17q.08-.1.15-.21l.1-.19.07-.14.06-.15.03-.1.04-.15.03-.16.01-.16V7M9.06 3.5H6.33l-1.86 2h3.98zm4.3 0h-2.73l-.62 2h3.97zm4.31 0h-2.73l.61 2h3.98z"
]);
const $e9fce37105e983ce$export$a938665b6361b59e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSkyscraper16Filled', "16", [
    "M6.75 1h-.5a.25.25 0 0 0-.25.25V2h1v-.75A.25.25 0 0 0 6.75 1M8.5 3h-4a.5.5 0 0 0-.5.5V4h5v-.5a.5.5 0 0 0-.5-.5m3 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m.5-2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M3 6.45c0-.61.32-1.15.81-1.45H9.2c.49.3.81.84.81 1.45v.05h.3a3.7 3.7 0 0 1 3.7 3.7v3.3a.5.5 0 0 1-.5.5H7v-2.1a.4.4 0 0 0-.4-.4h-.2a.4.4 0 0 0-.4.4V14H3.5a.5.5 0 0 1-.5-.5zm10 3.75c0-1.5-1.2-2.7-2.7-2.7H10V13h3zM6 7.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 9.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $e9fce37105e983ce$export$fbdef2fbd6d8b6e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSkyscraper16Regular', "16", [
    "M6 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m4.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.5-1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-6-9a.5.5 0 0 0-.5.5V3h-.5a.5.5 0 0 0-.5.5v1.65c-.59.27-1 .86-1 1.55v6.8c0 .28.22.5.5.5h10a.5.5 0 0 0 .5-.5v-3.3a3.7 3.7 0 0 0-3.7-3.7h-.31A1.7 1.7 0 0 0 9 5.15V3.5a.5.5 0 0 0-.5-.5H8V1.5a.5.5 0 0 0-.5-.5zM8 5H5V4h3zm1 1.7V13H8v-1.1c0-.5-.4-.9-.9-.9H5.9c-.5 0-.9.4-.9.9V13H4V6.7c0-.39.31-.7.7-.7h3.6c.39 0 .7.31.7.7M6 13v-1h1v1zm4 0V7.5h.3c1.5 0 2.7 1.2 2.7 2.7V13zM7 3H6V2h1z"
]);
const $e9fce37105e983ce$export$4156944936ea87c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSkyscraper20Filled', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V3H7zM5.46 4a.5.5 0 0 0-.46.5V5h6v-.5a.5.5 0 0 0-.46-.5zm8.29 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75-3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5 6h6v.02c.6.34 1 .99 1 1.73V8h.5a4.5 4.5 0 0 1 4.5 4.5v4a.5.5 0 0 1-.5.5H9v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V17H4.5a.5.5 0 0 1-.5-.5V7.75a2 2 0 0 1 1-1.73zm7 10h4v-3.5A3.5 3.5 0 0 0 12.5 9H12zM7.5 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.5 11.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $e9fce37105e983ce$export$82ac2a89f739109c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSkyscraper20Regular', "20", [
    "M7.5 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.5 11.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m5.25 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75-1.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7 2a.5.5 0 0 0-.5.5V4h-.94a.5.5 0 0 0-.5.5v1.74A2 2 0 0 0 4 8v8.5c0 .27.22.5.5.5h12a.5.5 0 0 0 .5-.5v-4A4.5 4.5 0 0 0 12.5 8H12a2 2 0 0 0-.94-1.7V4.5a.5.5 0 0 0-.5-.5H9.5V2.5A.5.5 0 0 0 9 2zm3 4H6.06V5h4v1zm1 10h-1v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2H5V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zm-4 0v-2h2v2zm9 0h-4V9h.5a3.5 3.5 0 0 1 3.5 3.5zM8.5 4h-1V3h1z"
]);
const $e9fce37105e983ce$export$c1119624268d2868 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSkyscraper24Filled', "24", [
    "M8.75 2a.75.75 0 0 0-.75.75V4h3V2.75a.75.75 0 0 0-.75-.75zM11 5H6.75a.75.75 0 0 0-.75.75V7h7V5.75a.75.75 0 0 0-.75-.75zm6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 10a2 2 0 0 1 1.96-2h7.08A2 2 0 0 1 15 10a5.75 5.75 0 0 1 5.5 5.75v5c0 .41-.34.75-.75.75h-8.5v-3a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v3h-3a.75.75 0 0 1-.75-.75zm15 5.75a4.25 4.25 0 0 0-4-4.24V20h4zM12.25 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 4.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.75 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1 4.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $e9fce37105e983ce$export$a4218d1a09f8a46f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSkyscraper24Regular', "24", [
    "M12 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.25 2a.75.75 0 0 0-.75.75V5H6.25a.75.75 0 0 0-.75.75V7.8A2.8 2.8 0 0 0 4 10.25v10.5c0 .41.34.75.75.75h15c.41 0 .75-.34.75-.75v-5c0-3.1-2.45-5.62-5.51-5.74a2.8 2.8 0 0 0-1.49-2.2V5.74a.75.75 0 0 0-.75-.75H11.5V2.75a.75.75 0 0 0-.75-.75zM12 7.5H7v-1h5zM13.5 20H12v-2.75a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75V20H5.5v-9.75C5.5 9.56 6.06 9 6.75 9h5.5c.69 0 1.25.56 1.25 1.25zm-5 0v-2h2v2zm6.5 0v-8.5c2.23.14 4 1.99 4 4.25V20zM10 5H9V3.5h1z"
]);
const $e9fce37105e983ce$export$294f9aeb67bc06bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingStore16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_16_color__a)",
            "d": "M2 6.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_16_color__b)",
            "fillOpacity": ".8",
            "d": "M4 9.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V15H4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_16_color__c)",
            "fillOpacity": ".8",
            "d": "M9 9.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_16_color__d)",
            "d": "M7 2.5V1H4.5a.5.5 0 0 0-.31.11l-2.5 2q-.17.16-.18.39H1.5v2a2.5 2.5 0 0 0 5 0v-2l-.42-.08z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_16_color__e)",
            "d": "M14.5 3.5q-.02-.24-.19-.39l-2.5-2a.5.5 0 0 0-.3-.11H9v1.5l.92.92-.42.08v2a2.5 2.5 0 0 0 5 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_16_color__f)",
            "d": "m9.5 1 1 2.5v2a2.5 2.5 0 0 1-5 0v-2l1-2.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_16_color__a",
                "x1": "5",
                "x2": "6.57",
                "y1": "6.82",
                "y2": "15.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".31",
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_16_color__b",
                "x1": "4.14",
                "x2": "8.02",
                "y1": "10.13",
                "y2": "12.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_16_color__c",
                "x1": "9.9",
                "x2": "11",
                "y1": "8.67",
                "y2": "12.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_16_color__d",
                "x1": "4.04",
                "x2": "4.04",
                "y1": "1",
                "y2": "4.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb6f7b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_16_color__e",
                "x1": "11.54",
                "x2": "11.54",
                "y1": "1",
                "y2": "4.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb6f7b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_16_color__f",
                "x1": "8",
                "x2": "8",
                "y1": "1",
                "y2": "4.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".3",
                    "stopColor": "#ff9fb2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#f97dbd"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$287b1255949e3546 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingStore20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_20_color__a)",
            "d": "M3 7h14v10.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_20_color__b)",
            "fillOpacity": ".8",
            "d": "M5 11.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_20_color__c)",
            "fillOpacity": ".8",
            "d": "M11 11.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_20_color__d)",
            "d": "M4.6 2.18 2.13 5.15A.6.6 0 0 0 2 5.5V7a3 3 0 0 0 6 0V5.5h-.5l1-3.5H4.98a.5.5 0 0 0-.38.18"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_20_color__e)",
            "d": "m11.5 2 1 3.5H12V7a3 3 0 1 0 6 0V5.5a.6.6 0 0 0-.13-.35L15.4 2.18a.5.5 0 0 0-.38-.18z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_20_color__f)",
            "d": "M8.1 2 7 5.5v1.75C7 8.77 8.34 10 10 10s3-1.23 3-2.75V5.5L11.9 2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_20_color__a",
                "x1": "6.5",
                "x2": "8.5",
                "y1": "8",
                "y2": "18.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".31",
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_20_color__b",
                "x1": "5.18",
                "x2": "9.81",
                "y1": "12.31",
                "y2": "15.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_20_color__c",
                "x1": "12.2",
                "x2": "13.66",
                "y1": "10.56",
                "y2": "15.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_20_color__d",
                "x1": "5",
                "x2": "5",
                "y1": "2",
                "y2": "5.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb6f7b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_20_color__e",
                "x1": "14.5",
                "x2": "14.5",
                "y1": "2",
                "y2": "5.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb6f7b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_20_color__f",
                "x1": "10",
                "x2": "10",
                "y1": "2",
                "y2": "5.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".3",
                    "stopColor": "#ff9fb2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#f97dbd"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$a5194afc0c403972 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingStore24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_24_color__a)",
            "d": "M3 9.75c0-.41.34-.75.75-.75h16.5c.41 0 .75.34.75.75v11.5c0 .41-.34.75-.75.75H3.75a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_24_color__b)",
            "fillOpacity": ".8",
            "d": "M6 13.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75V22H6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_24_color__c)",
            "fillOpacity": ".8",
            "d": "M13 13.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_24_color__d)",
            "d": "m14 6-1-4h4.9a1 1 0 0 1 .75.33l3.09 3.38a1 1 0 0 1 .26.68V8a4 4 0 0 1-8 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_24_color__e)",
            "d": "M2 6.39a1 1 0 0 1 .26-.68l3.1-3.38A1 1 0 0 1 6.08 2H11l-1 4v2a4 4 0 0 1-8 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_building_store_24_color__f)",
            "d": "M8 6.18q0-.19.06-.34L9.5 2h5l1.44 3.84q.06.15.06.34V8a4 4 0 0 1-8 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_24_color__a",
                "x1": "7.5",
                "x2": "9.68",
                "y1": "10.18",
                "y2": "22.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".31",
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_24_color__b",
                "x1": "6.21",
                "x2": "12.03",
                "y1": "14.69",
                "y2": "18.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0067bf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_24_color__c",
                "x1": "14.5",
                "x2": "16.33",
                "y1": "12.44",
                "y2": "19.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_24_color__d",
                "x1": "17.15",
                "x2": "17.15",
                "y1": "2",
                "y2": "6.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb6f7b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_24_color__e",
                "x1": "6.15",
                "x2": "6.15",
                "y1": "2",
                "y2": "6.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb6f7b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_building_store_24_color__f",
                "x1": "12",
                "x2": "12",
                "y1": "2",
                "y2": "6.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".3",
                    "stopColor": "#ff9fb2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#f97dbd"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$a1e7bcd3906d264b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap16Filled', "16", [
    "M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V7h.5c.83 0 1.5.67 1.5 1.5V11h-1.09a1.5 1.5 0 0 0-2.47-1.56l-2 2a1.5 1.5 0 0 0 0 2.12l.44.44H3.5a.5.5 0 0 1-.5-.5zM5.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.35 3.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L8.71 13h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L14.29 12H8.71z"
]);
const $e9fce37105e983ce$export$fbaddf5c2b4f91e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap16Regular', "16", [
    "M6 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.5 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m.5 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M7.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M3 3.5C3 2.67 3.67 2 4.5 2h4c.83 0 1.5.67 1.5 1.5V7h.5c.83 0 1.5.67 1.5 1.5V11h-1V8.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V13h2.09q.1.31.35.56l.44.44H3.5a.5.5 0 0 1-.5-.5zm6.85 7.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L8.71 13h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L14.29 12H8.71z"
]);
const $e9fce37105e983ce$export$f295f1dab123a78e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap20Filled', "20", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v2.59a1.5 1.5 0 0 0-.91 1.91H13.9a1.5 1.5 0 0 0-2.47-1.56l-2 2a1.5 1.5 0 0 0 0 2.12L10.88 18H4.5a.5.5 0 0 1-.5-.5zm2.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-6.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M9.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m2.35 2.1a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58z"
]);
const $e9fce37105e983ce$export$16e7bc5a6c38fd8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap20Regular', "20", [
    "M7.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.13 4.5 1 1H4.5a.5.5 0 0 1-.5-.5v-14C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v2.59a1.5 1.5 0 0 0-1 1.4V9.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5V17zm2.97-3.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58z"
]);
const $e9fce37105e983ce$export$5786c41a4b724e71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap24Filled', "24", [
    "M6.25 2C5.01 2 4 3 4 4.25v17c0 .41.34.75.75.75h8.78l-2.02-2.01a1.75 1.75 0 0 1 0-2.48l2.5-2.5A1.75 1.75 0 0 1 16.83 17h1.34A1.75 1.75 0 0 1 20 14.52v-2.77c0-1.24-1-2.25-2.25-2.25H16.5V4.25c0-1.24-1-2.25-2.25-2.25zM8.5 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0-3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M11 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0-3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4.78 6.78a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h5.88l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06L20.44 18h-5.88z"
]);
const $e9fce37105e983ce$export$7f2b16b9a10a40be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap24Regular', "24", [
    "M5.5 4.25c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v6c0 .41.34.75.75.75h2c.41 0 .75.34.75.75v3.28l.01-.02c.4-.4.96-.57 1.49-.5v-2.76c0-1.24-1-2.25-2.25-2.25H16.5V4.25c0-1.24-1-2.25-2.25-2.25h-8C5.01 2 4 3 4 4.25v17c0 .41.34.75.75.75h8.78l-1.5-1.5H5.5zm3 1.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0-3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M11 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0-3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4.78 6.78a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h5.88l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06L20.44 18h-5.88z"
]);
const $e9fce37105e983ce$export$4fff1bccf644abda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap32Filled', "32", [
    "M4 5a3 3 0 0 1 3-3h11.75C20.55 2 22 3.46 22 5.25V13h2.75c1.8 0 3.25 1.46 3.25 3.25V21a2.5 2.5 0 0 0-3.95 2.5h-2.1a2.5 2.5 0 0 0-4.22-2.27l-3 3a2.5 2.5 0 0 0 0 3.54L16.96 30H5a1 1 0 0 1-1-1zm8 3.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0 5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M10.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17 8.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m3.2 5.2a1 1 0 0 0-1.4-1.4l-3 3a1 1 0 0 0 0 1.4l3 3a1 1 0 0 0 1.4-1.4L18.92 27h8.18l-1.3 1.3a1 1 0 0 0 1.42 1.4l3-3a1 1 0 0 0 0-1.4l-3-3a1 1 0 0 0-1.42 1.4l1.3 1.3H18.9z"
]);
const $e9fce37105e983ce$export$8dbaa85330af5b7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap32Regular', "32", [
    "M7 4h11.75c.69 0 1.25.56 1.25 1.25V14a1 1 0 0 0 1 1h3.75c.69 0 1.25.56 1.25 1.25v4.3a2.5 2.5 0 0 1 2 .45v-4.75c0-1.8-1.46-3.25-3.25-3.25H22V5.25C22 3.45 20.54 2 18.75 2H7a3 3 0 0 0-3 3v24a1 1 0 0 0 1 1h11.96l-2-2H6V5a1 1 0 0 1 1-1m3.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m3.5-8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4.7 3.7a1 1 0 0 0-1.4-1.4l-3 3a1 1 0 0 0 0 1.4l3 3a1 1 0 0 0 1.4-1.4L18.92 27h8.18l-1.3 1.3a1 1 0 0 0 1.42 1.4l3-3a1 1 0 0 0 0-1.4l-3-3a1 1 0 0 0-1.42 1.4l1.3 1.3H18.9z"
]);
const $e9fce37105e983ce$export$3a0a9851382929b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap48Filled', "48", [
    "M8 8.25C8 5.9 9.9 4 12.25 4h15.5C30.1 4 32 5.9 32 8.25V19h3.75C38.1 19 40 20.9 40 23.25v7.34A3.25 3.25 0 0 0 36.25 35h-4.5a3.25 3.25 0 0 0-5.3-3.55l-4.5 4.5a3.25 3.25 0 0 0 0 4.6L25.4 44H9.25C8.56 44 8 43.44 8 42.75zM18 14a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m6-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m5.63 4.63a1.25 1.25 0 0 0-1.76-1.76l-4.5 4.5a1.25 1.25 0 0 0 0 1.76l4.5 4.5a1.25 1.25 0 0 0 1.76-1.76l-2.36-2.37h13.46l-2.36 2.37a1.25 1.25 0 0 0 1.76 1.76l4.5-4.5a1.25 1.25 0 0 0 0-1.76l-4.5-4.5a1.25 1.25 0 0 0-1.76 1.76L40.73 37H27.27z"
]);
const $e9fce37105e983ce$export$6a16d75174689d6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingSwap48Regular', "48", [
    "M12.25 6.5c-.97 0-1.75.78-1.75 1.75V41.5h12.4l2.5 2.5H9.25C8.56 44 8 43.44 8 42.75V8.25C8 5.9 9.9 4 12.25 4h15.5C30.1 4 32 5.9 32 8.25V19h3.75C38.1 19 40 20.9 40 23.25v7.34a3.3 3.3 0 0 0-2.5.42v-7.76c0-.97-.78-1.75-1.75-1.75h-5c-.69 0-1.25-.56-1.25-1.25v-12c0-.97-.78-1.75-1.75-1.75zM18 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m5.63 4.63a1.25 1.25 0 0 0-1.76-1.76l-4.5 4.5a1.25 1.25 0 0 0 0 1.76l4.5 4.5a1.25 1.25 0 0 0 1.76-1.76l-2.36-2.37h13.46l-2.36 2.37a1.25 1.25 0 0 0 1.76 1.76l4.5-4.5a1.25 1.25 0 0 0 0-1.76l-4.5-4.5a1.25 1.25 0 0 0-1.76 1.76L40.73 37H27.27z"
]);
const $e9fce37105e983ce$export$3a3b1f880d4d5305 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingTownhouse20Filled', "20", [
    "M6.96 3.3a1 1 0 0 0-1.42 0l-2.1 2.1A1.5 1.5 0 0 0 3 6.44v9.05c0 .83.67 1.5 1.5 1.5H7v-3.5c0-.28.22-.5.5-.5h2V6.45c0-.4-.16-.78-.44-1.06zm3.54 3.15V13h2c.28 0 .5.22.5.5V17h2.5c.83 0 1.5-.67 1.5-1.5V6.45q-.01-.62-.44-1.06l-2.1-2.1a1 1 0 0 0-1.42 0l-2.1 2.1a1.5 1.5 0 0 0-.44 1.06m0 7.55v3H12v-3zm-1 3v-3H8v3zM7 7.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m8.25-3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $e9fce37105e983ce$export$b8e80973055e4821 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingTownhouse20Regular', "20", [
    "M6.1 3.24a1 1 0 0 1 1.3 0L9.97 5.4l.03.03.03-.03 2.57-2.17a1 1 0 0 1 1.3 0l2.57 2.17c.34.28.53.7.53 1.15v8.94c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 15.5V6.56c0-.45.2-.87.53-1.15zM10.5 13h2c.28 0 .5.22.5.5V16h2.5a.5.5 0 0 0 .5-.5V6.56a.5.5 0 0 0-.18-.39L13.25 4l-2.57 2.17a.5.5 0 0 0-.18.39zm-1 0V6.56a.5.5 0 0 0-.18-.39L6.75 4 4.18 6.17a.5.5 0 0 0-.18.39v8.94c0 .28.22.5.5.5H7v-2.5c0-.28.22-.5.5-.5zM8 16h1.5v-2H8zm2.5-2v2H12v-2zM6.75 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m5.75-2.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $e9fce37105e983ce$export$fbc4c2a38674929c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingTownhouse24Filled', "24", [
    "M8.48 3.53c-.69-.7-1.82-.7-2.5 0l-2.34 2.4C3.23 6.35 3 6.91 3 7.5v11.75c0 .97.78 1.75 1.75 1.75H8v-4.25c0-.41.34-.75.75-.75h2.5V7.29c0-.59-.23-1.15-.64-1.57zm4.27 3.76V16h2.5c.41 0 .75.34.75.75V21h3.25c.97 0 1.75-.78 1.75-1.75V7.5c0-.59-.23-1.15-.64-1.57l-2.33-2.4c-.69-.7-1.82-.7-2.51 0l-2.13 2.19c-.41.42-.64.98-.64 1.57m0 10.21V21h1.75v-3.5zm-1.5 3.5v-3.5H9.5V21zM8.13 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8.74 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-8.75 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8.76 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $e9fce37105e983ce$export$7a07c6d408a91e45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingTownhouse24Regular', "24", [
    "m8.04 4.58 2.95 2.55q.26.23.26.57v7.8h-2.5a.75.75 0 0 0-.75.75v3.25H4.75a.25.25 0 0 1-.25-.25V7.7q.01-.34.26-.57L7.7 4.58q.16-.12.33 0M11.25 17v2.5H9.5V17zm1.5 0h1.75v2.5h-1.75zM16 19.5v-3.25a.75.75 0 0 0-.75-.75h-2.5V7.7q.01-.34.26-.57l2.95-2.55q.16-.12.33 0l2.95 2.55q.26.23.26.57v11.55q-.02.23-.25.25zM4.75 21h14.5c.97 0 1.75-.78 1.75-1.75V7.7c0-.65-.28-1.27-.78-1.7l-2.95-2.56a1.75 1.75 0 0 0-2.3 0L12.04 6l-.03.02-.03-.02-2.95-2.56a1.75 1.75 0 0 0-2.3 0L3.79 6C3.28 6.43 3 7.05 3 7.7v11.55c0 .97.78 1.75 1.75 1.75M8.88 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m8.24-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-1 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $e9fce37105e983ce$export$ae08bd54c84d9140 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingTownhouse32Filled', "32", [
    "M10.42 3.71a2 2 0 0 0-2.84 0L3.86 7.47A3 3 0 0 0 3 9.58V26a3 3 0 0 0 3 3h4v-7a1 1 0 0 1 1-1h4V9.58a3 3 0 0 0-.86-2.1zM17 9.58V21h4a1 1 0 0 1 1 1v7h4a3 3 0 0 0 3-3V9.58a3 3 0 0 0-.86-2.1L24.42 3.7a2 2 0 0 0-2.84 0l-3.72 3.76A3 3 0 0 0 17 9.58M17 23v6h3v-6zm-2 6v-6h-3v6zM9 13.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M21.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M9 18.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M21.75 17a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
]);
const $e9fce37105e983ce$export$efc32371051dcd49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingTownhouse32Regular', "32", [
    "M8.7 3.47a2 2 0 0 1 2.6 0l4.64 3.93.06.05.06-.05 4.65-3.93a2 2 0 0 1 2.58 0l4.65 3.93A3 3 0 0 1 29 9.69V26a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9.69a3 3 0 0 1 1.06-2.3zM15 27v-4h-3v4zm0-6V9.69a1 1 0 0 0-.35-.76L10 5 5.35 8.93a1 1 0 0 0-.35.76V26a1 1 0 0 0 1 1h4v-5a1 1 0 0 1 1-1zm2 6h3v-4h-3zm0-6h4a1 1 0 0 1 1 1v5h4a1 1 0 0 0 1-1V9.69a1 1 0 0 0-.35-.76L22 5l-4.65 3.93a1 1 0 0 0-.35.76zm-5.75-9a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M22 13.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M11.25 17a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M22 18.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
]);
const $e9fce37105e983ce$export$a8782224d44bc08f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingYurt16Filled', "16", [
    "M15 12.25c0 .97-.78 1.75-1.75 1.75H10.5A1.5 1.5 0 0 1 9 12.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2c0 .83-.67 1.5-1.5 1.5H2.75C1.78 14 1 13.22 1 12.25V7.83q.34.16.75.17h12.5q.4 0 .75-.17zM7.14 2.23c.53-.3 1.19-.3 1.72 0l5.25 2.98c.47.26.78.71.86 1.22a.75.75 0 0 1-.72.57H1.75a.75.75 0 0 1-.72-.57c.08-.5.4-.96.86-1.22z"
]);
const $e9fce37105e983ce$export$d2ee6680e469c93c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingYurt16Regular', "16", [
    "M7.14 2.22c.53-.3 1.19-.3 1.72 0l5.4 3.07A1.5 1.5 0 0 1 15 6.5v5.75c0 .97-.78 1.75-1.75 1.75H10.5A1.5 1.5 0 0 1 9 12.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2c0 .83-.67 1.5-1.5 1.5H2.75c-.9 0-1.65-.69-1.74-1.57L1 12.25V6.5l.01-.1c.05-.46.32-.88.72-1.1zM14 7.92q-.22.08-.45.08H2.45Q2.22 8 2 7.93v4.4c.04.38.36.67.75.67H5.5a.5.5 0 0 0 .5-.5v-2C6 9.67 6.67 9 7.5 9h1c.83 0 1.5.67 1.5 1.5v2c0 .28.22.5.5.5h2.75c.41 0 .75-.34.75-.75zM8.37 3.1a.8.8 0 0 0-.74 0l-5.4 3.06a.45.45 0 0 0 .22.84h11.1a.45.45 0 0 0 .22-.84z"
]);
const $e9fce37105e983ce$export$90c8248646df6e94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingYurt20Filled', "20", [
    "M18 15a2 2 0 0 1-2 2h-3.5a1.5 1.5 0 0 1-1.5-1.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2c0 .83-.67 1.5-1.5 1.5H4a2 2 0 0 1-2-2V9.73q.46.26 1 .27h14q.54 0 1-.27zM9.02 3.26a2 2 0 0 1 1.96 0l6 3.37a2 2 0 0 1 1 1.52A1 1 0 0 1 17 9H3a1 1 0 0 1-.99-.85 2 2 0 0 1 1.01-1.52z"
]);
const $e9fce37105e983ce$export$d4c7efeec1481069 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BuildingYurt20Regular', "20", [
    "M9.02 3.26a2 2 0 0 1 1.96 0L17.1 6.7c.54.3.88.87.9 1.48V15a2 2 0 0 1-2 2h-3.5a1.5 1.5 0 0 1-1.5-1.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2c0 .83-.67 1.5-1.5 1.5H4a2 2 0 0 1-2-2V8.18c.02-.61.36-1.18.9-1.48zM17 9.82q-.35.17-.76.18H3.76q-.41 0-.76-.18V15a1 1 0 0 0 1 1h3.5a.5.5 0 0 0 .5-.5v-2c0-.83.67-1.5 1.5-1.5h1c.83 0 1.5.67 1.5 1.5v2c0 .28.22.5.5.5H16a1 1 0 0 0 1-1zm-6.51-5.7a1 1 0 0 0-.98 0L3.39 7.58A.76.76 0 0 0 3.76 9h12.48a.76.76 0 0 0 .37-1.43z"
]);
const $e9fce37105e983ce$export$501c2903112e7c11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__a)",
            "d": "M1 2.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__b)",
            "fillOpacity": ".7",
            "d": "M1 2.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__c)",
            "d": "M1 5.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 1 5.25"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__d)",
            "fillOpacity": ".7",
            "d": "M1 5.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 1 5.25"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__e)",
            "d": "M1 7.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 1 7.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__f)",
            "fillOpacity": ".7",
            "d": "M1 7.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 1 7.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__g)",
            "d": "m2.66 9.64 7.09-7.1 3.7 3.71-7.09 7.1L4.1 11.9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__h)",
            "d": "m2.96 9.33-.3.3q-.57.58-.78 1.36l-.86 3.39a.5.5 0 0 0 .6.6l3.39-.87q.78-.2 1.35-.77l.31-.3s-1.28-.3-2.34-1.37c-1.06-1.06-1.37-2.34-1.37-2.34"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__i)",
            "d": "M10.53 1.76a2.62 2.62 0 1 1 3.7 3.71l-1.9 1.9-3.7-3.7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_16_color__j)",
            "d": "M8.27 4.03s.3 1.29 1.35 2.35a5.4 5.4 0 0 0 2.35 1.35l1.43-1.42S12.1 6 11.05 4.95A5.4 5.4 0 0 1 9.69 2.6z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__a",
                "x1": "-.8",
                "x2": "2.54",
                "y1": "1.07",
                "y2": "11.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__c",
                "x1": "-.8",
                "x2": "2.54",
                "y1": "1.07",
                "y2": "11.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__e",
                "x1": "-.8",
                "x2": "2.54",
                "y1": "1.07",
                "y2": "11.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__g",
                "x1": "8.63",
                "x2": "10.28",
                "y1": "5.56",
                "y2": "10.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__h",
                "x1": ".19",
                "x2": "4.28",
                "y1": "10.91",
                "y2": "14.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__i",
                "x1": "13.67",
                "x2": "11.32",
                "y1": "2.32",
                "y2": "4.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_16_color__j",
                "x1": "10.92",
                "x2": "7.29",
                "y1": "6.11",
                "y2": "4.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(138 2.14 6.16)scale(11.5347 4.93393)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(138 2.14 6.16)scale(11.5347 4.93393)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(138 2.14 6.16)scale(11.5347 4.93393)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$6adf8dd0384983d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts16Filled', "16", [
    "M13.98 2a2.6 2.6 0 0 0-3.71 0l-.78.78 3.7 3.71.8-.79a2.6 2.6 0 0 0-.01-3.7M2.8 9.49l5.98-6 3.71 3.7-5.98 6a2 2 0 0 1-.56.36L2 14.96a.75.75 0 0 1-.96-.96l1.42-3.96q.12-.31.35-.55M1.5 2h7.36l-1 1H1.5a.5.5 0 0 1 0-1m0 2h5.36l-1 1H1.5a.5.5 0 0 1 0-1m0 2h3.37l-1 1H1.5a.5.5 0 0 1 0-1"
]);
const $e9fce37105e983ce$export$4278a6c0af8350c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts16Regular', "16", [
    "M10.27 2a2.62 2.62 0 0 1 3.71 3.7l-7.47 7.5a2 2 0 0 1-.56.35L2 14.96a.75.75 0 0 1-.96-.96l1.42-3.96q.12-.31.35-.55zm3 .7a1.6 1.6 0 0 0-2.3 0l-.77.8 2.29 2.28.78-.78c.64-.64.63-1.66 0-2.3m-1.49 3.8L9.5 4.2l-5.98 6a1 1 0 0 0-.12.18l-1.24 3.46 3.47-1.23a1 1 0 0 0 .18-.12zM8.86 2H1.5a.5.5 0 1 0 0 1h6.36zm-2 2H1.5a.5.5 0 1 0 0 1h4.37zm-2 2H1.5a.5.5 0 1 0 0 1h2.37z"
]);
const $e9fce37105e983ce$export$2a7eaf328608953c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__a)",
            "d": "M2 3a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__b)",
            "fillOpacity": ".7",
            "d": "M2 3a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__c)",
            "d": "M2 6a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__d)",
            "fillOpacity": ".7",
            "d": "M2 6a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__e)",
            "d": "M2 9a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__f)",
            "fillOpacity": ".7",
            "d": "M2 9a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__g)",
            "d": "M12.25 3.54 4 11.8l1.05 3.16 3.17 1.03 8.24-8.23z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__h)",
            "d": "m4.12 11.67-.57.58q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l.56-.56s-1.6-.48-2.67-1.54a7 7 0 0 1-1.54-2.67"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__i)",
            "d": "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-2.08 2.08-4.2-4.2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_20_color__j)",
            "d": "M10.26 5.53 11.9 3.9s.47 1.6 1.54 2.66A7 7 0 0 0 16.1 8.1L14.5 9.72s-1.62-.47-2.68-1.53-1.55-2.66-1.55-2.66"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__a",
                "x1": "-.1",
                "x2": "4.19",
                "y1": ".86",
                "y2": "13.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__c",
                "x1": "-.1",
                "x2": "4.19",
                "y1": ".86",
                "y2": "13.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__e",
                "x1": "-.1",
                "x2": "4.19",
                "y1": ".86",
                "y2": "13.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__g",
                "x1": "10.89",
                "x2": "12.79",
                "y1": "7.02",
                "y2": "12.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__h",
                "x1": "1.09",
                "x2": "5.65",
                "y1": "13.44",
                "y2": "17.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__i",
                "x1": "16.5",
                "x2": "13.86",
                "y1": "3.49",
                "y2": "5.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_20_color__j",
                "x1": "13.28",
                "x2": "9.16",
                "y1": "7.88",
                "y2": "6.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(136.47 2.8 7.5)scale(13.7931 5.9246)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(136.47 2.8 7.5)scale(13.7931 5.9246)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(136.47 2.8 7.5)scale(13.7931 5.9246)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$590a784c11bcc0c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts20Filled', "20", [
    "m15.61 8.32-3.93-3.94-8.04 8.04-.12.13a2 2 0 0 0-.4.76l-1.1 4.06-.02.08a.5.5 0 0 0 .63.53l4.06-1.1.16-.06a2 2 0 0 0 .73-.46zm1.57-5.5a2.8 2.8 0 0 0-3.93 0l-.87.86 3.94 3.93.86-.86.13-.14c.96-1.09.91-2.75-.13-3.8M11.65 3H2.5a.5.5 0 0 0 0 1h8.15zm-3 3H2.5a.5.5 0 0 0 0 1h5.15zm-3 3-1 1H2.5a.5.5 0 1 1 0-1z"
]);
const $e9fce37105e983ce$export$c4d40cd60f4b352f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts20Regular', "20", [
    "m13.25 2.82-9.61 9.6-.12.13a2 2 0 0 0-.4.76l-1.1 4.06-.02.08a.5.5 0 0 0 .63.53l4.06-1.1.16-.06a2 2 0 0 0 .73-.46l9.6-9.6.13-.15a2.78 2.78 0 0 0-4.06-3.8m-8.9 10.31 8.04-8.04 2.52 2.52-8.04 8.04-.1.09-.1.07-.25.1-3.2.87.87-3.2.04-.13a1 1 0 0 1 .22-.32m12.12-9.6.11.11c.59.7.55 1.75-.1 2.4l-.87.87-2.52-2.53.86-.86.12-.1c.7-.59 1.75-.55 2.4.1M11.65 3H2.5a.5.5 0 0 0 0 1h8.15zm-3 3H2.5a.5.5 0 0 0 0 1h5.15zm-4 4 1-1H2.5a.5.5 0 0 0 0 1z"
]);
const $e9fce37105e983ce$export$80a1fc54efcf8879 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__a)",
            "d": "M2 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__b)",
            "fillOpacity": ".7",
            "d": "M2 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__c)",
            "d": "M2 8a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__d)",
            "fillOpacity": ".7",
            "d": "M2 8a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__e)",
            "d": "M2 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__f)",
            "fillOpacity": ".7",
            "d": "M2 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__g)",
            "d": "M3.59 15.35 14.65 4.3l5.06 5.06L8.65 20.41 4.7 19.3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__h)",
            "d": "M3.94 15c-.4.4-.7.92-.82 1.48l-1.1 4.6a.75.75 0 0 0 .9.9l4.6-1.1A3 3 0 0 0 9 20.07s-1.82-.4-3.24-1.82C4.35 16.82 3.94 15 3.94 15"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__i)",
            "d": "M20.95 3.05a3.6 3.6 0 0 0-5.06 0l-2.3 2.3 5.06 5.06 2.3-2.3a3.6 3.6 0 0 0 0-5.06"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_drafts_24_color__j)",
            "d": "m12.78 6.16 2.12-2.12s.41 1.82 1.82 3.24a7.4 7.4 0 0 0 3.24 1.82l-2.12 2.12s-1.82-.4-3.24-1.82a7.4 7.4 0 0 1-1.82-3.24"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__a",
                "x1": "-.4",
                "x2": "5.36",
                "y1": "1.57",
                "y2": "17.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__c",
                "x1": "-.4",
                "x2": "5.36",
                "y1": "1.57",
                "y2": "17.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__e",
                "x1": "-.4",
                "x2": "5.36",
                "y1": "1.57",
                "y2": "17.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__g",
                "x1": "13.14",
                "x2": "15.44",
                "y1": "8.47",
                "y2": "14.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__h",
                "x1": "1",
                "x2": "6.04",
                "y1": "16.95",
                "y2": "21.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__i",
                "x1": "20.24",
                "x2": "17.14",
                "y1": "3.75",
                "y2": "6.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_drafts_24_color__j",
                "x1": "16.49",
                "x2": "11.42",
                "y1": "8.95",
                "y2": "6.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(133.9 2.54 9.5)scale(16.4811 7.26581)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(133.9 2.54 9.5)scale(16.4811 7.26581)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_drafts_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(133.9 2.54 9.5)scale(16.4811 7.26581)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$cbaf21b1f4ac1f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts24Filled', "24", [
    "M13.94 5 19 10.06 9.06 20q-.42.43-1 .58l-5.11 1.4a.75.75 0 0 1-.92-.93l1.4-5.11q.16-.58.57-1zm-7.41 6-1.5 1.5H2.75a.75.75 0 0 1 0-1.5zm14.35-8.17.15.14.15.15a3.6 3.6 0 0 1-.15 4.91l-.97.97L15 3.94l.97-.97a3.6 3.6 0 0 1 4.9-.14M10.53 7l-1.5 1.5H2.75a.75.75 0 1 1 0-1.5zm4-4-1.5 1.5H2.75a.75.75 0 1 1 0-1.5z"
]);
const $e9fce37105e983ce$export$66e3c84526d0a5a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts24Regular', "24", [
    "m20.88 2.83.15.14.15.15a3.6 3.6 0 0 1-.15 4.91L9.06 20q-.42.43-1 .58l-5.11 1.4a.75.75 0 0 1-.92-.93l1.4-5.11q.16-.58.57-1L15.97 2.97a3.6 3.6 0 0 1 4.9-.14M15 6.06 5.06 16q-.14.14-.19.33l-1.05 3.85 3.85-1.05q.2-.05.33-.2L17.94 9zM6.53 11l-1.5 1.5H2.75a.75.75 0 0 1 0-1.5zm4-4-1.5 1.5H2.75a.75.75 0 1 1 0-1.5zm6.5-2.97-.97.97L19 7.94l.97-.97a2.08 2.08 0 1 0-2.94-2.94M14.53 3l-1.5 1.5H2.75a.75.75 0 1 1 0-1.5z"
]);
const $e9fce37105e983ce$export$c2c41a7b63a48a3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts28Filled', "28", [
    "M22.25 11.31 10.06 23.5q-.67.67-1.58.93l-5.53 1.54a.75.75 0 0 1-.92-.92l1.54-5.53q.27-.91.93-1.58L16.7 5.75zM6.52 14.5H2.75a.75.75 0 0 1 0-1.5h5.27zM19.3 3.15a3.93 3.93 0 0 1 5.56 5.56l-1.54 1.54-5.56-5.56zM11.52 9.5H2.75a.75.75 0 0 1 0-1.5h10.27zM17.75 3q.12 0 .23.04L16.52 4.5H2.75a.75.75 0 0 1 0-1.5z"
]);
const $e9fce37105e983ce$export$ae1a8d5726d34866 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drafts28Regular', "28", [
    "M19.29 3.15a3.93 3.93 0 0 1 5.56 5.56L10.06 23.5q-.67.67-1.58.93l-5.53 1.54a.75.75 0 0 1-.92-.92l1.54-5.53q.27-.91.93-1.58zM5.56 19q-.39.4-.54.93l-1.19 4.24 4.24-1.19q.53-.16.93-.54L21.2 10.25l-3.44-3.44zm.96-4.5H2.75a.75.75 0 0 1 0-1.5h5.27zm5-5H2.75a.75.75 0 0 1 0-1.5h10.27zM23.8 4.21a2.43 2.43 0 0 0-3.44 0L18.8 5.75l3.44 3.44 1.54-1.54c.95-.95.95-2.49 0-3.44M17.75 3q.12 0 .23.04L16.52 4.5H2.75a.75.75 0 0 1 0-1.5z"
]);
const $e9fce37105e983ce$export$a1d98995db1b6458 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drag20Filled', "20", [
    "M10 2q.31 0 .53.22l1.5 1.5a.75.75 0 0 1-1.06 1.06l-.22-.22v1.69a.75.75 0 0 1-1.5 0V4.56l-.22.22a.75.75 0 0 1-1.06-1.06l1.5-1.5A.8.8 0 0 1 10 2m2 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-9.78-.53a.75.75 0 0 0 0 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06l-.22-.22h1.69a.75.75 0 0 0 0-1.5H4.56l.22-.22a.75.75 0 0 0-1.06-1.06zM10 18q.31 0 .53-.22l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.22.22v-1.69a.75.75 0 0 0-1.5 0v1.69l-.22-.22a.75.75 0 0 0-1.06 1.06l1.5 1.5q.22.22.53.22m7.78-8.53a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.22-.22h-1.69a.75.75 0 0 1 0-1.5h1.69l-.22-.22a.75.75 0 0 1 1.06-1.06z"
]);
const $e9fce37105e983ce$export$8788841a1e0ade12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drag20Regular', "20", [
    "M9.65 2.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L10.5 3.71V6.5a.5.5 0 0 1-1 0V3.7L8.35 4.86a.5.5 0 1 1-.7-.7zM10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m5.85 1.35 2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7l1.14 1.15H13.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7m-5.5 5.5 2-2a.5.5 0 0 0-.7-.7l-1.15 1.14V13.5a.5.5 0 0 0-1 0v2.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0m-8.2-7.5a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L3.71 9.5H6.5a.5.5 0 0 1 0 1H3.7l1.15 1.15a.5.5 0 0 1-.7.7z"
]);
const $e9fce37105e983ce$export$18d26539d96d257d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drag24Filled', "24", [
    "M12 16a1 1 0 0 1 1 .88v1.7l.3-.29a1 1 0 0 1 1.31-.08l.1.08a1 1 0 0 1 .08 1.32l-.08.1-2 2-.05.04-.06.05-.12.08-.1.05-.11.03-.12.03h-.27l-.11-.02-.11-.03-.08-.03-.1-.06-.1-.06-.09-.08-2-2a1 1 0 0 1 1.32-1.5l.1.08.29.3V17a1 1 0 0 1 .88-1zm6.3-6.7a1 1 0 0 1 1.31-.09l.1.08 2 2 .04.05.05.07.08.1.05.12.03.1.03.12v.27l-.02.11-.03.11-.03.08-.06.1-.07.1-.07.09-2 2a1 1 0 0 1-1.5-1.32l.08-.1.3-.29H17a1 1 0 0 1-1-.88V12a1 1 0 0 1 .88-1h1.7l-.29-.3a1 1 0 0 1-.08-1.31zm-14 0a1 1 0 0 1 1.49 1.31l-.08.1-.3.29H7a1 1 0 0 1 1 .88V12a1 1 0 0 1-.88 1H5.4l.3.3a1 1 0 0 1 .08 1.31l-.08.1a1 1 0 0 1-1.32.08l-.1-.08-2-2-.1-.11-.07-.12-.05-.1-.03-.11-.03-.12v-.06l-.01-.1v-.08l.02-.11.03-.11.04-.11.06-.1.06-.1.08-.09zm7.7-.05a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m-.15-7.24h.32l.14.04.11.04.1.06.1.07.09.07 2 2a1 1 0 0 1-1.32 1.5l-.1-.08-.29-.3V7a1 1 0 0 1-.88 1H12a1 1 0 0 1-1-.88V5.4l-.3.3a1 1 0 0 1-1.31.08l-.1-.08a1 1 0 0 1-.08-1.32l.08-.1 2-2 .11-.1.12-.06.1-.06.11-.03z"
]);
const $e9fce37105e983ce$export$f64ef5fc10d73f93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drag24Regular', "24", [
    "M12 16.5c.38 0 .7.28.74.65l.01.1v2.19l.72-.72c.27-.27.68-.3.98-.07l.08.07c.27.27.3.68.07.98l-.07.08-2 2-.04.04-.07.05-.1.06-.08.03-.1.03h-.19l-.12-.01-.07-.02-.06-.02-.07-.04-.05-.03-.03-.02-.08-.07-2-2a.75.75 0 0 1 .98-1.13l.08.07.72.72v-2.19c0-.38.28-.7.65-.74zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6m6.72.47a.75.75 0 0 1 .98-.07l.08.07 2 2 .04.04.05.07.06.1.03.08.03.1v.31l-.03.07-.02.06-.04.07-.03.05-.03.04-.06.07-2 2a.75.75 0 0 1-1.13-.98l.07-.08.72-.72h-2.19a.75.75 0 0 1-.74-.65V12c0-.38.27-.7.64-.74l.1-.01h2.19l-.72-.72a.75.75 0 0 1-.07-.98zm-14.5 0a.75.75 0 0 1 1.13.98l-.07.08-.72.72h2.2c.37 0 .68.28.73.65l.01.1c0 .38-.28.7-.65.74l-.1.01H4.56l.72.72c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2-2-.1-.11-.05-.1-.03-.08-.03-.1v-.19l.01-.12.02-.07.02-.06.04-.07.03-.05.02-.03.07-.08zM12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-.14-8.49h.07l.09-.01h.06l.1.02.06.02.06.02.07.04.05.03.04.03.07.06 2 2a.75.75 0 0 1-.98 1.13l-.08-.07-.72-.72v2.19c0 .38-.28.7-.65.74l-.1.01a.75.75 0 0 1-.74-.65V4.56l-.73.72a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08 2-2 .11-.1.1-.05.08-.03z"
]);
const $e9fce37105e983ce$export$daecde3c2a875bfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawImage20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v9.08c0 .45.55.68.87.36L5.2 14.1l3.74-3.68a1.5 1.5 0 0 1 2.1 0l1.74 1.72 2.31-2.3c.53-.54 1.21-.82 1.9-.85V6a3 3 0 0 0-3-3zm8 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2.73 7.17 1.82-1.81-1.74-1.71a.5.5 0 0 0-.7 0L5.43 15.3c-.23.23-.01.58.3.47l.32-.11c.7-.26 1.76-.55 2.75-.16q.41.18.68.48.23-.76.8-1.32m.71.7 4.83-4.82a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 0 1-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 0 1-1.33-.82c-.12-.2.15-.4.36-.28.37.18.83.33 1.22.24q.38-.1.94-.34c.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18q.41.1 1.11.09 0-.08.03-.14l.37-1.5q.16-.6.58-1.02"
]);
const $e9fce37105e983ce$export$dea866406104a89e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawImage20Regular', "20", [
    "M14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3q-.52.03-1 .23V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8.83c0 .17.21.26.34.14l.8-.8 1.05-1.03.2-.2 2.56-2.5a1.5 1.5 0 0 1 2.1 0l1.75 1.7-.71.71-1.74-1.7a.5.5 0 0 0-.7 0l-2.76 2.7-1.85 1.83A1.2 1.2 0 0 1 3 14.83zm.4 11.04c.37.18.83.33 1.22.24q.38-.1.94-.34c.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18q.41.1 1.11.09 0-.08.03-.14l.37-1.5q.16-.6.58-1.02l4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 0 1-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 0 1-1.33-.82c-.12-.2.15-.4.36-.28"
]);
const $e9fce37105e983ce$export$4e36240f5bc24878 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawImage24Filled', "24", [
    "m15.66 14.7-2.08-2.05-.13-.12c-.84-.7-2.06-.7-2.9 0l-.13.12-6.23 6.12a.7.7 0 0 1-1.2-.5V6.25C3 4.45 4.46 3 6.26 3h11.5C19.55 3 21 4.46 21 6.25v4.76c-.93-.08-1.9.24-2.6.95zM13.5 8.24a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0m2.25-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m-4.28 6.22.09-.07c.26-.2.61-.2.87-.01l.1.08 2.07 2.03-2.11 2.11q-.67.67-.93 1.57a3 3 0 0 0-1.41-1.13 2.7 2.7 0 0 0-1.94.04l-.11.04c-.48.17-.87-.41-.53-.8l.2-.24zm7.63-1.05-5.9 5.9q-.54.54-.7 1.25l-.44 1.71c-.35.17-.7.2-1.13.1-.13-.02-.18-.17-.13-.29.43-.96-.19-1.77-1.03-2.11-.95-.38-2.22.51-3.29 1.27-.6.42-1.12.8-1.5.87-.52.12-1.16-.12-1.63-.38-.2-.1-.48.08-.38.3.24.52.73 1.12 1.7 1.25.99.12 1.77-.35 2.56-.82.58-.35 1.16-.7 1.82-.8.09-.01.15.1.1.17-.24.48-.35 1.37.22 1.82.85.66 3.24.29 3.83.09l.15-.03 1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $e9fce37105e983ce$export$5eb075fae4a854ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawImage24Regular', "24", [
    "M21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 0 0 3 6.25v12.28c0 1.3 1.57 1.96 2.5 1.05l4.03-3.96.02-.02 1.92-1.89.09-.07c.29-.2.7-.18.96.07l2.08 2.04 1.06-1.06-2.09-2.05-.12-.11a2.25 2.25 0 0 0-3.02.11L5.97 17h.01L4.5 18.46V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v4.98q.73-.28 1.5-.22zm-3.5 2.5a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0m-3 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-1.3 9.82 5.9-5.9a2.29 2.29 0 1 1 3.23 3.23l-5.9 5.9q-.53.54-1.25.71l-1.83.46-.15.03c-.59.2-2.98.57-3.82-.1-.58-.44-.47-1.33-.22-1.81.04-.08-.02-.18-.1-.17-.67.1-1.25.45-1.83.8-.79.47-1.57.94-2.55.82a2.1 2.1 0 0 1-1.71-1.26c-.1-.21.18-.4.38-.29.47.26 1.11.5 1.64.38.37-.08.9-.45 1.5-.87 1.06-.76 2.33-1.65 3.28-1.27.84.34 1.46 1.15 1.03 2.11-.05.12 0 .27.13.3q.62.15 1.13-.1l.43-1.72q.18-.71.7-1.25"
]);
const $e9fce37105e983ce$export$b075bfa0cbe96d9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawShape20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3c-.69.03-1.37.31-1.9.84l-4.83 4.83a3 3 0 0 0-.8 1.31q-.24-.29-.67-.47c-.99-.4-2.05-.1-2.75.16l-.41.15q-.57.27-1.01.4A1.2 1.2 0 0 1 3.47 16c-.3-.26-.47-.64-.47-1.05V6m7.98 9.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 0 1-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 0 1-1.33-.82c-.12-.2.15-.4.36-.28.37.18.83.33 1.22.24q.38-.1.94-.34c.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18q.41.1 1.11.09 0-.08.03-.14l.37-1.5q.16-.6.58-1.02"
]);
const $e9fce37105e983ce$export$adfdfa64da053d21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawShape20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3q-.52.03-1 .23V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9.5a.5.5 0 0 1-1 0zm.4 11.04c.37.18.83.33 1.22.24q.38-.1.94-.34c.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18q.41.1 1.11.09 0-.08.03-.14l.37-1.5q.16-.6.58-1.02l4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 0 1-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 0 1-1.33-.82c-.12-.2.15-.4.36-.28"
]);
const $e9fce37105e983ce$export$522c06060cde76e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawShape24Filled', "24", [
    "M3 6.25C3 4.45 4.45 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v4.76c-.93-.08-1.9.24-2.61.95l-5.9 5.9q-.67.67-.93 1.57a3 3 0 0 0-1.42-1.13 2.7 2.7 0 0 0-1.93.04 6 6 0 0 0-.82.4l-1.7 1.03q-.7.4-1.3.34a2 2 0 0 1-.9-.32c-.38-.25-.5-.68-.5-1V6.25m16.1 6.42-5.9 5.9q-.54.54-.7 1.25l-.44 1.71c-.35.17-.7.2-1.13.1-.13-.02-.18-.17-.13-.29.43-.96-.19-1.77-1.03-2.11-.95-.38-2.22.51-3.29 1.27-.6.42-1.12.8-1.5.87-.52.12-1.16-.12-1.63-.38-.2-.1-.48.08-.38.3.24.52.73 1.12 1.7 1.25.99.12 1.77-.35 2.56-.82.58-.35 1.16-.7 1.82-.8.09-.01.15.1.1.17-.24.48-.35 1.37.22 1.82.85.66 3.24.29 3.83.09l.15-.03 1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $e9fce37105e983ce$export$cc26269e8c301b51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawShape24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v13a.75.75 0 0 0 1.5 0v-13c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v4.98q.73-.28 1.5-.22V6.25C21 4.45 19.54 3 17.75 3zm6.95 15.57 5.9-5.9a2.29 2.29 0 1 1 3.23 3.23l-5.9 5.9q-.53.54-1.25.71l-1.83.46-.15.03c-.59.2-2.98.57-3.82-.1-.58-.44-.47-1.33-.22-1.81.04-.08-.02-.18-.1-.17-.67.1-1.25.45-1.83.8-.79.47-1.57.94-2.55.82a2.1 2.1 0 0 1-1.71-1.26c-.1-.21.18-.4.38-.29.47.26 1.11.5 1.64.38.37-.08.9-.45 1.5-.87 1.06-.76 2.33-1.65 3.28-1.27.84.34 1.46 1.15 1.03 2.11-.05.12 0 .27.13.3q.62.15 1.13-.1l.43-1.72q.18-.71.7-1.25"
]);
const $e9fce37105e983ce$export$e3781c8f8ff5a3c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawText20Filled', "20", [
    "M10.14 10.5H6.86L8.5 5.82zm.53 1.5.33.94 1.17-1.17-2.87-8.2a.85.85 0 0 0-1.6 0L4.04 14a.75.75 0 0 0 1.42.5l.87-2.5zm5.14-2.45-4.83 4.83a2 2 0 0 0-.58 1.02l-.37 1.5-.03.14a5 5 0 0 1-1.11-.1c-.07 0-.1-.1-.07-.17.18-.35.24-1.07-.4-1.33-.86-.35-1.98.13-2.86.5-.37.15-.7.29-.95.34-.38.09-.84-.06-1.21-.24-.21-.11-.48.08-.36.28.22.37.61.74 1.32.83.82.1 1.4-.16 1.98-.41.4-.18.8-.36 1.3-.43.08-.01.14.09.11.17-.15.35-.13.9.32 1.24.52.4 2.19.51 3.31.19l1.22-.31q.6-.16 1.02-.58l4.83-4.83a1.87 1.87 0 1 0-2.64-2.64"
]);
const $e9fce37105e983ce$export$ce1ec90e9e379a36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawText20Regular', "20", [
    "M10.72 11H6.28L8.5 4.79zm.35 1 .23.64.78-.78-3.02-8.47a.6.6 0 0 0-1.13 0l-3.9 10.95a.5.5 0 0 0 .94.33L5.92 12zm4.74-2.45-4.83 4.83a2 2 0 0 0-.58 1.02l-.37 1.5-.03.14a5 5 0 0 1-1.11-.1c-.07 0-.1-.1-.07-.17.18-.35.24-1.07-.4-1.33-.86-.34-1.98.13-2.86.5q-.56.24-.95.34c-.38.09-.84-.06-1.21-.24-.21-.11-.48.08-.36.28.22.37.61.74 1.32.83.82.1 1.4-.16 1.98-.41.4-.18.8-.36 1.3-.43.08-.01.14.09.11.17-.15.36-.13.9.32 1.24.52.4 2.19.51 3.31.19l1.22-.31q.6-.16 1.02-.58l4.83-4.83a1.87 1.87 0 1 0-2.64-2.64"
]);
const $e9fce37105e983ce$export$22b807799c0da595 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawText24Filled', "24", [
    "M12.24 13.15H7.76L10 6.75zm.7 2 .33.93 1.57-1.57-3.76-10.75a1.14 1.14 0 0 0-2.15 0L4.06 17.67a1 1 0 1 0 1.88.66l1.12-3.18zm.26 2.42 5.9-5.9a2.29 2.29 0 1 1 3.23 3.23l-5.9 5.9q-.53.54-1.25.71l-1.83.46-.15.03c-.59.2-2.98.57-3.82-.1-.58-.44-.47-1.33-.22-1.81.04-.08-.02-.18-.1-.17-.67.1-1.25.45-1.83.8-.79.47-1.57.94-2.55.82a2.1 2.1 0 0 1-1.71-1.26c-.1-.21.18-.4.38-.29.47.26 1.11.5 1.64.38.37-.08.9-.45 1.5-.87 1.06-.76 2.33-1.65 3.28-1.27.84.34 1.46 1.15 1.03 2.11-.05.12 0 .27.13.3q.62.15 1.13-.1l.43-1.72q.18-.71.7-1.25"
]);
const $e9fce37105e983ce$export$e7c25dab18520853 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawText24Regular', "24", [
    "M10 5.71 7.23 13.5h5.53zm3.57 10.07L13.3 15H6.7l-1.24 3.5a.75.75 0 0 1-1.42-.5L9.16 3.6a.89.89 0 0 1 1.68 0l3.9 11zM5 20.38c-.53.11-1.17-.13-1.64-.39-.2-.1-.48.08-.38.3.24.52.73 1.12 1.7 1.25.99.12 1.77-.35 2.56-.82.58-.35 1.16-.7 1.82-.8.09-.01.15.1.1.17-.24.48-.35 1.37.22 1.82.85.66 3.24.29 3.83.09l.15-.03 1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24l-5.9 5.9q-.54.54-.7 1.25l-.44 1.71c-.35.17-.7.2-1.13.1-.13-.02-.18-.17-.13-.29.43-.96-.19-1.77-1.03-2.11-.95-.38-2.22.51-3.29 1.27-.6.42-1.12.8-1.5.87"
]);
const $e9fce37105e983ce$export$78b9e8d97444e6ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drawer20Filled', "20", [
    "M7.16 3a2 2 0 0 0-1.74 1L4.26 6.05a2 2 0 0 0-.26 1V9a1 1 0 0 0 1 1h.07l-.72 2A1.5 1.5 0 0 0 3 13.5v2c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-2c0-.78-.6-1.42-1.35-1.5l-.72-2H15a1 1 0 0 0 1-1V7.03a2 2 0 0 0-.26-1l-1.16-2.02A2 2 0 0 0 12.84 3zm7.41 6-.71-2H15v2zM12.8 7l1.78 5H5.42L7.2 7zM6.14 7l-.71 2H5V7zm2.36 7h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $e9fce37105e983ce$export$54b58e1e5fa46aa0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drawer20Regular', "20", [
    "M8.5 14a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-4.15-2A1.5 1.5 0 0 0 3 13.5v2c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-2c0-.78-.6-1.42-1.35-1.5l-.72-2H15a1 1 0 0 0 1-1V7.03a2 2 0 0 0-.26-1l-1.16-2.02A2 2 0 0 0 12.84 3H7.16a2 2 0 0 0-1.74 1L4.26 6.05a2 2 0 0 0-.26 1V9a1 1 0 0 0 1 1h.07zm8.49-8a1 1 0 0 1 .87.5l.85 1.5H5.44l.85-1.5a1 1 0 0 1 .87-.5zm-.04 3 1.78 5H5.42L7.2 7zm2.7 6c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5zM5.43 9H5V7h1.14zm9.14 0-.71-2H15v2z"
]);
const $e9fce37105e983ce$export$d07e48bc7b9a3b3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drawer24Filled', "24", [
    "M6.4 3.9A2 2 0 0 1 8.08 3h7.86a2 2 0 0 1 1.66.9L19.66 7A2 2 0 0 1 20 8.1V11a1 1 0 0 1-1 1h-.36l.86 2c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-4c0-.83.67-1.5 1.5-1.5l.86-2H5a1 1 0 0 1-1-1V8.1A2 2 0 0 1 4.34 7zM6 10.5l.86-2H5.5v2zm9.51-2H8.5l-2.34 5.45.03.05h11.64l.03-.05zm1.63 0 .86 2h.5v-2zm-6.89 8.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
]);
const $e9fce37105e983ce$export$89503b43a03b5a06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drawer24Regular', "24", [
    "M10.25 16.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM8.07 3a2 2 0 0 0-1.66.9L4.34 7A2 2 0 0 0 4 8.1V11a1 1 0 0 0 1 1h.36l-.86 2c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5l-.86-2H19a1 1 0 0 0 1-1V8.1a2 2 0 0 0-.34-1.1L17.6 3.9a2 2 0 0 0-1.66-.9zM18 10.5l-.86-2h1.36v2zm-2.49-2 2.34 5.45-.03.05H6.18l-.03-.05L8.5 8.5zM17.86 7H6.14l1.51-2.28a.5.5 0 0 1 .42-.22h7.86a.5.5 0 0 1 .42.22zm-11 1.5-.86 2h-.5v-2zm-2.36 7h15v4h-15z"
]);
const $e9fce37105e983ce$export$69b390978ab5de61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerAdd20Filled', "20", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H13v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H14zM6 4h2.2q-.13.49-.18 1H6a2 2 0 0 0-2 2h4.2q.16.52.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 1 0 4 0c0-.28.22-.5.5-.5H16v-.6q.54-.27 1-.66V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3"
]);
const $e9fce37105e983ce$export$fa867e9ebed08eb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerAdd20Regular', "20", [
    "M13.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V5h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V6h-1.5a.5.5 0 0 1 0-1H13V3.5c0-.28.22-.5.5-.5M17 9.74V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2.2q-.13.49-.18 1H6a2 2 0 0 0-2 2h4.2q.16.52.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 1 0 4 0c0-.28.22-.5.5-.5H16v-.6q.54-.27 1-.66M14 17a2 2 0 0 0 2-2v-3h-3.04a3 3 0 0 1-5.92 0H4v3c0 1.1.9 2 2 2z"
]);
const $e9fce37105e983ce$export$6d55f65a0072728d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerAdd24Filled', "24", [
    "M22 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M17 7v2.5a.5.5 0 1 1-1 0V7h-2.5a.5.5 0 0 1 0-1H16V3.5a.5.5 0 0 1 1 0V6h2.5a.5.5 0 0 1 0 1zM6.25 4h4.25q-.3.71-.42 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h5.67q.2.8.56 1.5H4.5V14h4.56c.38 0 .69.31.69.7v.05a2.25 2.25 0 0 0 4.5 0v-.06c0-.38.31-.69.7-.69h4.55v-1.73a7 7 0 0 0 1.5-1.08v7.56c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 18.75V7.25C3 5.45 4.46 4 6.25 4"
]);
const $e9fce37105e983ce$export$610483c51b7d1fa5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerAdd24Regular', "24", [
    "M22 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M17 7v2.5a.5.5 0 1 1-1 0V7h-2.5a.5.5 0 0 1 0-1H16V3.5a.5.5 0 0 1 1 0V6h2.5a.5.5 0 0 1 0 1zm4 4.19q-.67.65-1.5 1.08V14h-4.56a.7.7 0 0 0-.69.7v.05a2.25 2.25 0 0 1-4.5 0v-.06a.7.7 0 0 0-.7-.69H4.5V9.5h6.23a7 7 0 0 1-.56-1.5H4.5v-.75c0-.97.78-1.75 1.75-1.75h3.83q.12-.79.42-1.5H6.25A3.25 3.25 0 0 0 3 7.25v11.5C3 20.55 4.46 22 6.25 22h11.5c1.8 0 3.25-1.46 3.25-3.25zm-1.5 4.31v3.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V15.5h3.83a3.75 3.75 0 0 0 7.35 0z"
]);
const $e9fce37105e983ce$export$e22a7454e60800f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerArrowDownload20Filled', "20", [
    "M9 5.5a4.5 4.5 0 0 1 4-4.47v3.76l-.65-.64a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7l-.65.64V1.03A4.5 4.5 0 1 1 9 5.5m2 2c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5M6 4h2.2q-.13.49-.18 1H6a2 2 0 0 0-2 2h4.2q.16.52.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 1 0 4 0c0-.28.22-.5.5-.5H16v-.6q.54-.27 1-.66V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3"
]);
const $e9fce37105e983ce$export$aca61357ad3789d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerArrowDownload20Regular', "20", [
    "M9 5.5a4.5 4.5 0 0 1 4-4.47v3.76l-.65-.64a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7l-.65.64V1.03A4.5 4.5 0 1 1 9 5.5m2 2c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m6 2.24q-.46.39-1 .66v.6h-3.5a.5.5 0 0 0-.5.5 2 2 0 1 1-4 0 .5.5 0 0 0-.5-.5H4V8h4.6q-.24-.48-.4-1H4c0-1.1.9-2 2-2h2.02q.05-.51.19-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3zM16 15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3h3.04a3 3 0 0 0 5.92 0H16z"
]);
const $e9fce37105e983ce$export$7a1458826f53e855 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerArrowDownload24Filled', "24", [
    "M11 6.5a5.5 5.5 0 0 1 5-5.48V6.8l-1.65-1.64a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L17 6.79V1.02a5.5 5.5 0 1 1-6 5.48m8.5 3A.5.5 0 0 0 19 9h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5M6.25 4h4.25q-.3.72-.42 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h5.67q.2.8.56 1.5H4.5V14h4.56c.38 0 .69.31.69.7v.05a2.25 2.25 0 0 0 4.5 0v-.06c0-.38.31-.69.7-.69h4.55v-1.73a7 7 0 0 0 1.5-1.08v7.56c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 18.75V7.25C3 5.45 4.46 4 6.25 4"
]);
const $e9fce37105e983ce$export$e6b1835dc042af93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerArrowDownload24Regular', "24", [
    "M11 6.5a5.5 5.5 0 0 1 5-5.48V6.8l-1.65-1.64a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L17 6.79V1.02a5.5 5.5 0 1 1-6 5.48m8.5 3A.5.5 0 0 0 19 9h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m1.5 1.7q-.67.63-1.5 1.07V14h-4.56a.7.7 0 0 0-.69.7v.05a2.25 2.25 0 0 1-4.5 0v-.06a.7.7 0 0 0-.7-.69H4.5V9.5h6.23a7 7 0 0 1-.56-1.5H4.5v-.75c0-.97.78-1.75 1.75-1.75h3.83q.12-.78.42-1.5H6.25A3.25 3.25 0 0 0 3 7.25v11.5C3 20.55 4.46 22 6.25 22h11.5c1.8 0 3.25-1.45 3.25-3.25zm-1.5 4.3v3.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V15.5h3.83a3.75 3.75 0 0 0 7.35 0z"
]);
const $e9fce37105e983ce$export$b5bb442846ea187 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerDismiss20Filled', "20", [
    "M13.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7L14.21 5.5l1.14 1.15a.5.5 0 0 1-.7.7L13.5 6.21l-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0M8.21 4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9.74q-.46.39-1 .66v.6h-3.5a.5.5 0 0 0-.5.5 2 2 0 1 1-4 0 .5.5 0 0 0-.5-.5H4V8h4.6q-.24-.48-.4-1H4c0-1.1.9-2 2-2h2.02q.05-.51.19-1"
]);
const $e9fce37105e983ce$export$e6196791da953753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerDismiss20Regular', "20", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7L13.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L14.21 5.5zM17 9.75q-.46.38-1 .65v.6h-3.5a.5.5 0 0 0-.5.5 2 2 0 1 1-4 0 .5.5 0 0 0-.5-.5H4V8h4.6q-.24-.48-.4-1H4c0-1.1.9-2 2-2h2.02q.05-.51.19-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3zM16 15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3h3.04a3 3 0 0 0 5.92 0H16z"
]);
const $e9fce37105e983ce$export$d68bc6ce7764b659 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerDismiss24Filled', "24", [
    "M22 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7L17.21 6.5l1.64-1.65a.5.5 0 0 0-.7-.7L16.5 5.79zM6.25 4h4.25q-.3.71-.42 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h5.67q.2.8.56 1.5H4.5V14h4.56c.38 0 .69.31.69.7v.05a2.25 2.25 0 0 0 4.5 0v-.06c0-.38.31-.69.7-.69h4.55v-1.73a7 7 0 0 0 1.5-1.08v7.56c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 18.75V7.25C3 5.45 4.46 4 6.25 4"
]);
const $e9fce37105e983ce$export$55635f9b3448be5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerDismiss24Regular', "24", [
    "M22 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7L17.21 6.5l1.64-1.65a.5.5 0 0 0-.7-.7L16.5 5.79zM21 11.19q-.67.65-1.5 1.08V14h-4.56a.7.7 0 0 0-.69.7v.05a2.25 2.25 0 0 1-4.5 0v-.06a.7.7 0 0 0-.7-.69H4.5V9.5h6.23a7 7 0 0 1-.56-1.5H4.5v-.75c0-.97.78-1.75 1.75-1.75h3.83q.12-.79.42-1.5H6.25A3.25 3.25 0 0 0 3 7.25v11.5C3 20.55 4.46 22 6.25 22h11.5c1.8 0 3.25-1.46 3.25-3.25zm-1.5 4.31v3.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V15.5h3.83a3.75 3.75 0 0 0 7.35 0z"
]);
const $e9fce37105e983ce$export$a2d5535baa1baac2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerPlay20Filled', "20", [
    "M8.2 4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9.74q-.46.39-1 .66v.6h-3.5a.5.5 0 0 0-.5.5 2 2 0 1 1-4 0 .5.5 0 0 0-.5-.5H4V8h4.6q-.24-.48-.4-1H4c0-1.1.9-2 2-2h2.02q.05-.51.19-1m5.3 6a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.76-6.59 2.97 1.65a.5.5 0 0 1 0 .88l-2.97 1.65a.5.5 0 0 1-.74-.44v-3.3a.5.5 0 0 1 .74-.44"
]);
const $e9fce37105e983ce$export$d00352b63b31b319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerPlay20Regular', "20", [
    "M17 9.74V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2.2q-.13.49-.18 1H6a2 2 0 0 0-2 2h4.2q.16.52.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 1 0 4 0c0-.28.22-.5.5-.5H16v-.6q.54-.27 1-.66M14 17a2 2 0 0 0 2-2v-3h-3.04a3 3 0 0 1-5.92 0H4v3c0 1.1.9 2 2 2zm-.5-7a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.76-6.59 2.97 1.65a.5.5 0 0 1 0 .88l-2.97 1.65a.5.5 0 0 1-.74-.44v-3.3a.5.5 0 0 1 .74-.44"
]);
const $e9fce37105e983ce$export$71c4b05651eb9d80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerPlay24Filled', "24", [
    "M22 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7 2.11c0 .4.42.63.76.43l3.53-2.11a.5.5 0 0 0 0-.86l-3.53-2.12a.5.5 0 0 0-.76.43zM6.25 4h4.25q-.3.71-.42 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h5.67q.2.8.56 1.5H4.5V14h4.56c.38 0 .69.31.69.7v.05a2.25 2.25 0 0 0 4.5 0v-.06c0-.38.31-.69.7-.69h4.55v-1.73a7 7 0 0 0 1.5-1.08v7.56c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 18.75V7.25C3 5.45 4.46 4 6.25 4"
]);
const $e9fce37105e983ce$export$ef3b0c442f491537 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerPlay24Regular', "24", [
    "M22 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7 2.11c0 .4.42.63.76.43l3.53-2.11a.5.5 0 0 0 0-.86l-3.53-2.12a.5.5 0 0 0-.76.43zm6 2.58q-.67.65-1.5 1.08V14h-4.56a.7.7 0 0 0-.69.7v.05a2.25 2.25 0 0 1-4.5 0v-.06a.7.7 0 0 0-.7-.69H4.5V9.5h6.23a7 7 0 0 1-.56-1.5H4.5v-.75c0-.97.78-1.75 1.75-1.75h3.83q.12-.79.42-1.5H6.25A3.25 3.25 0 0 0 3 7.25v11.5C3 20.55 4.46 22 6.25 22h11.5c1.8 0 3.25-1.46 3.25-3.25zm-1.5 4.31v3.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V15.5h3.83a3.75 3.75 0 0 0 7.35 0z"
]);
const $e9fce37105e983ce$export$c0136ea49af8b493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerSubtract20Filled', "20", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2 0a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .5-.5M6 4h2.2q-.13.49-.18 1H6a2 2 0 0 0-2 2h4.2q.16.52.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 1 0 4 0c0-.28.22-.5.5-.5H16v-.6q.54-.27 1-.66V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3"
]);
const $e9fce37105e983ce$export$df8a22350181361c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerSubtract20Regular', "20", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2 0a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .5-.5m1 4.24q-.46.39-1 .66v.6h-3.5a.5.5 0 0 0-.5.5 2 2 0 1 1-4 0 .5.5 0 0 0-.5-.5H4V8h4.6q-.24-.48-.4-1H4c0-1.1.9-2 2-2h2.02q.05-.51.19-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3zM16 15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3h3.04a3 3 0 0 0 5.92 0H16z"
]);
const $e9fce37105e983ce$export$91b85c23a3d038f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerSubtract24Filled', "24", [
    "M22 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-8.5.5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zM6.25 4h4.25q-.3.71-.42 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h5.67q.2.8.56 1.5H4.5V14h4.56c.38 0 .69.31.69.7v.05a2.25 2.25 0 0 0 4.5 0v-.06c0-.38.31-.69.7-.69h4.55v-1.73a7 7 0 0 0 1.5-1.08v7.56c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 18.75V7.25C3 5.45 4.46 4 6.25 4"
]);
const $e9fce37105e983ce$export$32ed0a117ebda30e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DrawerSubtract24Regular', "24", [
    "M22 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-8.5.5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zm7.5 4.19q-.67.65-1.5 1.08V14h-4.56a.7.7 0 0 0-.69.7v.05a2.25 2.25 0 0 1-4.5 0v-.06a.7.7 0 0 0-.7-.69H4.5V9.5h6.23a7 7 0 0 1-.56-1.5H4.5v-.75c0-.97.78-1.75 1.75-1.75h3.83q.12-.79.42-1.5H6.25A3.25 3.25 0 0 0 3 7.25v11.5C3 20.55 4.46 22 6.25 22h11.5c1.8 0 3.25-1.46 3.25-3.25zm-1.5 4.31v3.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V15.5h3.83a3.75 3.75 0 0 0 7.35 0z"
]);
const $e9fce37105e983ce$export$7ea4f8f58638ceaf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle12Filled', "12", [
    "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m-.75-2.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.26-4.84a.5.5 0 0 1 .98 0l.01.09v2.59a.5.5 0 0 1-1 0V3.41"
]);
const $e9fce37105e983ce$export$19d6a0a931112d3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle12Regular', "12", [
    "M5.25 8.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.26-4.84a.5.5 0 0 1 .98 0l.01.09v2.59a.5.5 0 0 1-1 0V3.41M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0m-1 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
]);
const $e9fce37105e983ce$export$ea910aac6a08c394 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_16_color__a)",
            "d": "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_16_color__b)",
            "d": "M8 10a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-5.5a.5.5 0 0 0-.5.41v3.68a.5.5 0 0 0 1 0V4.91A.5.5 0 0 0 8 4.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_16_color__a",
                "x1": "3.88",
                "x2": "11.75",
                "y1": ".13",
                "y2": "15.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_16_color__b",
                "x1": "6",
                "x2": "9.21",
                "y1": "4.5",
                "y2": "11.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$5469a51e7774e3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 9a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-5.5a.5.5 0 0 0-.5.5v3.59a.5.5 0 0 0 1-.09V4.91A.5.5 0 0 0 8 4.5"
]);
const $e9fce37105e983ce$export$416edf8c5418324d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2m0 8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-5.5a.5.5 0 0 1 .5.41V8.5a.5.5 0 0 1-1 .09V5c0-.28.22-.5.5-.5"
]);
const $e9fce37105e983ce$export$80ee73f5106d24f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_20_color__a)",
            "d": "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_20_color__b)",
            "fillRule": "evenodd",
            "d": "M10.5 6.5a.5.5 0 0 0-1 0V11a.5.5 0 0 0 1 0zM10 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_20_color__a",
                "x1": "4.5",
                "x2": "15",
                "y1": "-.5",
                "y2": "19.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_20_color__b",
                "x1": "8",
                "x2": "12",
                "y1": "6",
                "y2": "14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$7853015d976919a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 10.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M10 6a.5.5 0 0 0-.5.41v4.68a.5.5 0 0 0 1 0V6.41A.5.5 0 0 0 10 6"
]);
const $e9fce37105e983ce$export$a94e3087af762885 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle20Regular', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 9.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M10 6a.5.5 0 0 1 .5.41V11a.5.5 0 0 1-1 .09V6.5c0-.28.22-.5.5-.5"
]);
const $e9fce37105e983ce$export$3da28f82f8c35af6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_24_color__a)",
            "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_24_color__b)",
            "d": "M12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-8a1 1 0 0 0-1 .88v5.24a1 1 0 0 0 2 0V7.88A1 1 0 0 0 12 7"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_24_color__a",
                "x1": "5.13",
                "x2": "18.25",
                "y1": "-1.13",
                "y2": "23.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_24_color__b",
                "x1": "9.33",
                "x2": "14.13",
                "y1": "7",
                "y2": "17.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$9780644da38238f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 12.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 7a.75.75 0 0 0-.75.75v4.6a.75.75 0 0 0 1.5-.1v-4.5l-.01-.1a.75.75 0 0 0-.75-.65"
]);
const $e9fce37105e983ce$export$3f86f2978ead53a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M12 7c.37 0 .69.28.74.65v4.6a.75.75 0 0 1-1.48.1l-.01-.1v-4.5c0-.41.33-.75.74-.75"
]);
const $e9fce37105e983ce$export$a36dc5b792551e65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_48_color__a)",
            "d": "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_error_circle_48_color__b)",
            "d": "M24 13c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m0 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_48_color__a",
                "x1": "10.25",
                "x2": "36.5",
                "y1": "-2.25",
                "y2": "47.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_error_circle_48_color__b",
                "x1": "18.67",
                "x2": "29.07",
                "y1": "13",
                "y2": "34.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$c01fd25cd57eb39a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle48Filled', "48", [
    "M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40m0 9c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m0 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
]);
const $e9fce37105e983ce$export$2749587b7eb06343 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircle48Regular', "48", [
    "M24 13c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m0 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4M4 24a20 20 0 1 1 40 0 20 20 0 0 1-40 0M24 6.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35"
]);
const $e9fce37105e983ce$export$878f5b7d8214242f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleHint16Filled', "16", [
    "M8.74 13.45c.38-.05.76.13.9.48.18.42-.05.9-.5.98a7 7 0 0 1-2.28 0c-.45-.08-.68-.56-.5-.98a.84.84 0 0 1 .9-.48 6 6 0 0 0 1.48 0m-6.1-2.42c.35-.14.75 0 .98.3q.46.6 1.05 1.05c.3.23.44.63.3.98-.18.42-.68.6-1.04.33q-.95-.68-1.62-1.61c-.27-.37-.09-.87.33-1.05m9.74.3c.23-.3.63-.44.98-.3.42.18.6.68.33 1.05q-.68.94-1.62 1.61c-.36.27-.86.09-1.04-.33a.84.84 0 0 1 .3-.98q.6-.46 1.05-1.05M8 10a1 1 0 1 1 0 2 1 1 0 0 1 0-2M1.1 6.86c.07-.45.55-.68.96-.5.36.14.54.52.49.9a6 6 0 0 0 0 1.48.84.84 0 0 1-.48.9c-.42.18-.9-.05-.98-.5a7 7 0 0 1 0-2.28m12.84-.5c.41-.18.9.05.97.5a7 7 0 0 1 0 2.29c-.08.44-.56.67-.98.5a.84.84 0 0 1-.48-.9 6 6 0 0 0 0-1.5.84.84 0 0 1 .49-.9M8 4.24c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0V5c0-.41.34-.75.75-.75M3.93 2.31c.36-.27.86-.09 1.04.33.14.35 0 .75-.3.98q-.6.46-1.05 1.05a.84.84 0 0 1-.98.3c-.42-.17-.6-.68-.33-1.04q.67-.94 1.62-1.62m7.1.33c.18-.42.68-.6 1.04-.33q.95.67 1.62 1.62c.27.36.09.87-.33 1.04a.84.84 0 0 1-.98-.3q-.46-.6-1.05-1.05a.84.84 0 0 1-.3-.98M8 1q.59 0 1.14.1c.45.07.68.55.5.97a.84.84 0 0 1-.9.48 6 6 0 0 0-1.48 0 .84.84 0 0 1-.9-.48c-.18-.42.05-.9.5-.98Q7.4 1 8 1"
]);
const $e9fce37105e983ce$export$6d1aa71276b5de3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleHint16Regular', "16", [
    "M6.85 13.89a6 6 0 0 0 2.3 0c.25-.05.5.08.6.31.12.28-.03.6-.33.66a7 7 0 0 1-2.85 0 .47.47 0 0 1-.33-.66c.1-.24.36-.36.6-.31m6.13-2.54c.14-.2.4-.3.64-.2.28.1.4.44.23.7a7 7 0 0 1-2.01 2 .48.48 0 0 1-.7-.22c-.1-.24 0-.5.2-.65q.98-.66 1.64-1.63m-10.6-.2c.23-.1.5-.01.64.2q.66.97 1.63 1.63c.21.14.3.4.2.64a.48.48 0 0 1-.7.23 7 7 0 0 1-2-2.01.48.48 0 0 1 .23-.7M8 10a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m6.2-3.76c.28-.11.6.04.66.33a7 7 0 0 1 0 2.86.48.48 0 0 1-.66.33.54.54 0 0 1-.31-.6 6 6 0 0 0 0-2.31.54.54 0 0 1 .31-.6m-13.05.34c.06-.3.37-.45.65-.33.24.1.36.35.31.6a6 6 0 0 0 0 2.3c.05.25-.07.5-.3.6a.47.47 0 0 1-.66-.33 7 7 0 0 1 0-2.84M8 4.5a.5.5 0 0 1 .5.41V8.5a.5.5 0 0 1-1 .09V5c0-.28.22-.5.5-.5M4.16 2.15a.48.48 0 0 1 .7.23c.1.23 0 .5-.21.64q-.97.67-1.63 1.63a.54.54 0 0 1-.64.21.47.47 0 0 1-.24-.7 7 7 0 0 1 2.02-2.01m6.98.22c.11-.27.45-.4.7-.23q1.21.8 2.02 2.02c.16.25.04.58-.23.7-.24.1-.5 0-.65-.21a6 6 0 0 0-1.63-1.63.54.54 0 0 1-.21-.65M8 1q.73 0 1.42.14c.3.07.45.38.33.66a.54.54 0 0 1-.6.31 6 6 0 0 0-2.3 0 .54.54 0 0 1-.6-.3.48.48 0 0 1 .32-.66Q7.27 1 8 1"
]);
const $e9fce37105e983ce$export$7da24430d6c11f47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleHint20Filled', "20", [
    "M11.06 16.41a.75.75 0 0 1 .24 1.48c-.85.14-1.75.14-2.6 0a.75.75 0 0 1 .24-1.48c.69.12 1.43.12 2.12 0m-7.4-2.8a.75.75 0 0 1 1.06.18q.62.86 1.5 1.5a.75.75 0 0 1-.88 1.21 8 8 0 0 1-1.84-1.84.75.75 0 0 1 .17-1.05m11.62.18a.75.75 0 0 1 1.22.87 8 8 0 0 1-1.84 1.84.75.75 0 0 1-.87-1.22 7 7 0 0 0 1.5-1.5M10 12.5h.1a1 1 0 1 1-.1 0M2.1 8.7a.75.75 0 0 1 1.49.24 7 7 0 0 0 0 2.12.75.75 0 0 1-1.48.24 8 8 0 0 1 0-2.6m14.93-.62c.41-.07.8.2.86.62.14.85.14 1.75 0 2.6a.75.75 0 0 1-1.48-.24c.12-.69.12-1.43 0-2.12-.06-.4.21-.8.62-.86M10 5.75c.41 0 .75.34.75.75V11a.75.75 0 0 1-1.5 0V6.5c0-.41.34-.75.75-.75M5.34 3.5a.75.75 0 0 1 .87 1.22q-.86.62-1.5 1.5a.75.75 0 0 1-1.21-.88A8 8 0 0 1 5.34 3.5m8.27.17a.75.75 0 0 1 1.05-.17 8 8 0 0 1 1.84 1.84.75.75 0 0 1-1.22.87 7 7 0 0 0-1.5-1.5.75.75 0 0 1-.17-1.04M8.7 2.1a8 8 0 0 1 2.6 0 .75.75 0 0 1-.24 1.48 7 7 0 0 0-2.12 0A.75.75 0 0 1 8.7 2.1"
]);
const $e9fce37105e983ce$export$344cf5d68152bbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleHint20Regular', "20", [
    "M11.37 16.87a.5.5 0 0 1 .2.98 8 8 0 0 1-3.13 0 .5.5 0 0 1 .2-.98 7 7 0 0 0 2.73 0m-7.89-3.12a.5.5 0 0 1 .7.14 7 7 0 0 0 1.93 1.93.5.5 0 0 1-.56.83 8 8 0 0 1-2.2-2.2.5.5 0 0 1 .13-.7m12.34.14a.5.5 0 0 1 .83.55 8 8 0 0 1-2.2 2.21.5.5 0 1 1-.56-.83 7 7 0 0 0 1.93-1.93M10 12.49A.75.75 0 1 1 10 14a.75.75 0 0 1 0-1.5M2.74 8.06a.5.5 0 0 1 .4.58 7 7 0 0 0 0 2.74.5.5 0 0 1-.99.2 8 8 0 0 1 0-3.13.5.5 0 0 1 .59-.4m14.52 0a.5.5 0 0 1 .59.39 8 8 0 0 1 0 3.12.5.5 0 0 1-.98-.2 7 7 0 0 0 0-2.73.5.5 0 0 1 .39-.58M10 6a.5.5 0 0 1 .5.41V11a.5.5 0 0 1-1 .09V6.5c0-.28.22-.5.5-.5M5.55 3.35a.5.5 0 0 1 .56.83A7 7 0 0 0 4.18 6.1a.5.5 0 1 1-.83-.56 8 8 0 0 1 2.2-2.2m8.2.13a.5.5 0 0 1 .7-.13 8 8 0 0 1 2.2 2.2.5.5 0 0 1-.83.56 7 7 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7M8.44 2.15a8 8 0 0 1 3.12 0 .5.5 0 0 1-.2.98 7 7 0 0 0-2.73 0 .5.5 0 0 1-.2-.98"
]);
const $e9fce37105e983ce$export$4a30ea8072444729 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleHint24Filled', "24", [
    "M13.24 19.9c.5-.07 1.02.17 1.22.64.22.56-.07 1.2-.66 1.3a10 10 0 0 1-3.6 0c-.59-.1-.89-.74-.66-1.3.2-.47.71-.71 1.22-.64a8 8 0 0 0 2.48 0m-9.02-3.6c.47-.2 1 0 1.3.41q.76 1.02 1.77 1.76c.4.3.6.84.4 1.3-.23.56-.89.8-1.38.46q-1.5-1.05-2.54-2.54c-.34-.5-.1-1.16.45-1.39m14.24.4c.3-.4.84-.6 1.31-.4.56.23.8.9.45 1.39q-1.03 1.5-2.53 2.53c-.5.35-1.16.1-1.39-.45-.2-.47 0-1 .4-1.3a8 8 0 0 0 1.76-1.76M12 14.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-9.84-4.3c.1-.59.74-.89 1.3-.66.47.2.71.71.63 1.22a8 8 0 0 0 0 2.48c.08.5-.16 1.02-.64 1.22-.55.22-1.19-.08-1.3-.67a10 10 0 0 1 0-3.59m18.38-.66c.55-.23 1.19.07 1.3.66a10 10 0 0 1 0 3.6c-.11.58-.75.88-1.3.65-.47-.2-.72-.7-.64-1.21a8 8 0 0 0 0-2.48c-.08-.5.17-1.02.64-1.22M12 6.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m4.3-2.28c.23-.55.9-.79 1.39-.45q1.5 1.05 2.53 2.54c.34.5.1 1.16-.45 1.39-.47.19-1 0-1.3-.41a8 8 0 0 0-1.76-1.76c-.41-.3-.6-.83-.4-1.3m-9.99-.45c.5-.34 1.16-.1 1.39.45.19.47 0 1.01-.41 1.31A8 8 0 0 0 5.53 7.3c-.3.41-.84.6-1.3.4-.56-.23-.8-.89-.46-1.38q1.05-1.5 2.54-2.54M12 2q.91 0 1.8.16c.58.1.88.74.65 1.3-.2.47-.7.71-1.21.64a8 8 0 0 0-2.48 0c-.5.07-1.02-.17-1.22-.64-.23-.56.07-1.2.66-1.3q.88-.15 1.8-.16"
]);
const $e9fce37105e983ce$export$b6f002e851ff68b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleHint24Regular', "24", [
    "M13.65 20.34a.8.8 0 0 1 .92.46.7.7 0 0 1-.5.99 10 10 0 0 1-4.14 0 .7.7 0 0 1-.5-.99.8.8 0 0 1 .92-.46 9 9 0 0 0 3.3 0m5.42-3.61a.8.8 0 0 1 .97-.32c.41.17.6.67.35 1.04a10 10 0 0 1-2.94 2.93.7.7 0 0 1-1.04-.34.8.8 0 0 1 .32-.97 9 9 0 0 0 2.34-2.34m-15.1-.32a.8.8 0 0 1 .97.31 9 9 0 0 0 2.33 2.34.8.8 0 0 1 .32.98.7.7 0 0 1-1.04.34 10 10 0 0 1-2.93-2.93.7.7 0 0 1 .34-1.04m8.03-1.9a1 1 0 1 1 0 1.99 1 1 0 0 1 0-2m8.8-5.08c.42-.17.9.06.99.5a10 10 0 0 1 0 4.14.7.7 0 0 1-.98.5.8.8 0 0 1-.47-.92 9 9 0 0 0 0-3.3.8.8 0 0 1 .47-.92m-18.58.5c.1-.44.56-.67.98-.5a.8.8 0 0 1 .46.92 9 9 0 0 0 0 3.3.8.8 0 0 1-.46.91.7.7 0 0 1-.98-.49 10 10 0 0 1 0-4.15M11.99 7c.38 0 .7.28.75.65v4.6a.75.75 0 0 1-1.48.1l-.01-.1v-4.5c0-.41.33-.75.74-.75M6.55 3.62a.7.7 0 0 1 1.04.34.8.8 0 0 1-.32.98 9 9 0 0 0-2.33 2.33.8.8 0 0 1-.98.32.7.7 0 0 1-.34-1.04 10 10 0 0 1 2.93-2.93m9.86.34a.7.7 0 0 1 1.04-.35q1.77 1.17 2.93 2.94c.25.37.07.86-.34 1.04a.8.8 0 0 1-.97-.32 9 9 0 0 0-2.34-2.34.8.8 0 0 1-.32-.97M12.01 2q1.06 0 2.06.21c.44.1.67.57.5.99a.8.8 0 0 1-.92.46 9 9 0 0 0-3.3 0 .8.8 0 0 1-.91-.46.7.7 0 0 1 .49-.98Q10.93 2 12 2"
]);
const $e9fce37105e983ce$export$b3aaeba7860a4137 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleSettings16Filled', "16", [
    "M11.25 9.23a2 2 0 0 0 2.56.02q.46.2.84.49a2 2 0 0 0 1.3 2.2 4 4 0 0 1 .03.92h-.03a2 2 0 0 0-1.4 2.44v.04a4 4 0 0 1-.8.43 2 2 0 0 0-2.56-.03 4 4 0 0 1-.84-.48 2 2 0 0 0-1.3-2.2 4 4 0 0 1-.03-.92h.03a2 2 0 0 0 1.4-2.44v-.04q.38-.27.8-.43M7 0a7 7 0 0 1 6.9 8.22 4.5 4.5 0 0 0-5.68 5.67Q7.62 14 7 14A7 7 0 1 1 7 0m5.5 11.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M7 9a.75.75 0 1 0 0 1.5A.75.75 0 0 0 7 9m0-5.5a.5.5 0 0 0-.5.5v3.59a.5.5 0 0 0 1-.09V3.91A.5.5 0 0 0 7 3.5"
]);
const $e9fce37105e983ce$export$b9bfdc4db1d662d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleSettings16Regular', "16", [
    "M11.25 9.23a2 2 0 0 0 2.56.02q.46.2.84.49a2 2 0 0 0 1.3 2.2 4 4 0 0 1 .03.92h-.03a2 2 0 0 0-1.4 2.44v.04a4 4 0 0 1-.8.43 2 2 0 0 0-2.56-.03 4 4 0 0 1-.84-.48 2 2 0 0 0-1.3-2.2 4 4 0 0 1-.03-.92h.03a2 2 0 0 0 1.4-2.44v-.04q.38-.27.8-.43M7 0a7 7 0 0 1 6.9 8.22q-.48-.15-.99-.2Q13 7.52 13 7a6 6 0 1 0-4.98 5.91q.05.51.2.98-.6.1-1.22.11A7 7 0 1 1 7 0m5.5 11.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M7 9a.75.75 0 1 1 0 1.5A.75.75 0 0 1 7 9m0-5.5a.5.5 0 0 1 .5.41V7.5a.5.5 0 0 1-1 .09V4c0-.28.22-.5.5-.5"
]);
const $e9fce37105e983ce$export$2abe53e39f0ba8e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleSettings20Filled', "20", [
    "M18 10a8 8 0 1 0-7.41 7.98 5.5 5.5 0 0 1-.37-4.01.75.75 0 1 1 .44-1.08 5.5 5.5 0 0 1 7.32-2.3zM9.5 6.41a.5.5 0 0 1 1 0v4.68a.5.5 0 0 1-1 0V6.41m2.14 8.51a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $e9fce37105e983ce$export$f273605095bff823 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ErrorCircleSettings20Regular', "20", [
    "M18 10a8 8 0 1 0-7.41 7.98 6 6 0 0 1-.38-.98H10a7 7 0 1 1 7-6.8q.51.15.98.39zm-7.34 2.89a.75.75 0 1 0-.44 1.08q.15-.57.44-1.08m-.17-6.48a.5.5 0 0 0-.99.09v4.59a.5.5 0 0 0 1-.09V6.41m1.15 8.51a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $e9fce37105e983ce$export$8cc5bdc69f9de331 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance12Filled', "12", [
    "M6 9.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-2C6.67 5 6 5.67 6 6.5zm-5-4C1 6.33 1.67 7 2.5 7h1C4.33 7 5 6.33 5 5.5v-3C5 1.67 4.33 1 3.5 1h-1C1.67 1 1 1.67 1 2.5zM7.5 4a1.5 1.5 0 1 1 0-3h2a1.5 1.5 0 0 1 0 3zM1 9.5c0 .83.67 1.5 1.5 1.5h1a1.5 1.5 0 0 0 0-3h-1C1.67 8 1 8.67 1 9.5"
]);
const $e9fce37105e983ce$export$125f35cd9412e0fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance12Regular', "12", [
    "M6 9.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-2C6.67 5 6 5.67 6 6.5zm1.5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5zM1 5.5C1 6.33 1.67 7 2.5 7h1C4.33 7 5 6.33 5 5.5v-3C5 1.67 4.33 1 3.5 1h-1C1.67 1 1 1.67 1 2.5zm1.5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5zm5-2a1.5 1.5 0 1 1 0-3h2a1.5 1.5 0 0 1 0 3zM7 2.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5m-6 7c0 .83.67 1.5 1.5 1.5h1a1.5 1.5 0 0 0 0-3h-1C1.67 8 1 8.67 1 9.5m1.5.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1z"
]);
const $e9fce37105e983ce$export$8f9d325d1df8c32a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance16Filled', "16", [
    "M14 12.25c0 .97-.78 1.75-1.75 1.75h-2.5C8.78 14 8 13.22 8 12.25v-3.5C8 7.78 8.78 7 9.75 7h2.5c.97 0 1.75.78 1.75 1.75zm-7-5C7 8.22 6.22 9 5.25 9h-1.5C2.78 9 2 8.22 2 7.25v-3.5C2 2.78 2.78 2 3.75 2h1.5C6.22 2 7 2.78 7 3.75zm0 5C7 13.22 6.22 14 5.25 14h-1.5C2.78 14 2 13.22 2 12.25v-.5c0-.97.78-1.75 1.75-1.75h1.5c.97 0 1.75.78 1.75 1.75zm7-8C14 5.22 13.22 6 12.25 6h-2.5C8.78 6 8 5.22 8 4.25v-.5C8 2.78 8.78 2 9.75 2h2.5c.97 0 1.75.78 1.75 1.75z"
]);
const $e9fce37105e983ce$export$e113ecc13fdfc0f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance16Regular', "16", [
    "M14 12.25c0 .97-.78 1.75-1.75 1.75h-2.5C8.78 14 8 13.22 8 12.25v-3.5C8 7.78 8.78 7 9.75 7h2.5c.97 0 1.75.78 1.75 1.75zm-1.75.75c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75zM7 7.25C7 8.22 6.22 9 5.25 9h-1.5C2.78 9 2 8.22 2 7.25v-3.5C2 2.78 2.78 2 3.75 2h1.5C6.22 2 7 2.78 7 3.75zM5.25 8c.41 0 .75-.34.75-.75v-3.5A.75.75 0 0 0 5.25 3h-1.5a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75zm0 6C6.22 14 7 13.22 7 12.25v-.5C7 10.78 6.22 10 5.25 10h-1.5C2.78 10 2 10.78 2 11.75v.5c0 .97.78 1.75 1.75 1.75zM6 12.25c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1-.75-.75v-.5c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75zm8-8C14 5.22 13.22 6 12.25 6h-2.5C8.78 6 8 5.22 8 4.25v-.5C8 2.78 8.78 2 9.75 2h2.5c.97 0 1.75.78 1.75 1.75zM12.25 5c.41 0 .75-.34.75-.75v-.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v.5c0 .41.34.75.75.75z"
]);
const $e9fce37105e983ce$export$cb2d7b61993e8dfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance20Filled', "20", [
    "M3 14.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5m0-10v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5C9 3.67 8.33 3 7.5 3h-3C3.67 3 3 3.67 3 4.5m8 0v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5M12.5 9c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5z"
]);
const $e9fce37105e983ce$export$44c4e79ae3613266 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance20Regular', "20", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5C9 3.67 8.33 3 7.5 3zM4 4.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM12.5 9c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zm-.5 1.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm-1-6c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 11 5.5zm1.5-.5a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-8 9c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5zM4 14.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
]);
const $e9fce37105e983ce$export$4ffe911106618b17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance24Filled', "24", [
    "M19.25 11c.97 0 1.75.79 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75h-4.5c-.97 0-1.75-.78-1.75-1.75v-6.5c0-.96.78-1.75 1.75-1.75zm-9.98 4.01c.96 0 1.75.79 1.75 1.75v2.5c0 .96-.79 1.74-1.75 1.74H4.75C3.8 21 3 20.22 3 19.25v-2.49c0-.96.79-1.75 1.75-1.75zM9.25 3c.97 0 1.75.78 1.75 1.75v6.5c0 .92-.7 1.67-1.6 1.74l-.15.01h-4.5C3.8 13 3 12.22 3 11.25v-6.5C3 3.78 3.8 3 4.75 3zm10 0c.97 0 1.75.78 1.75 1.75v2.5C21 8.22 20.22 9 19.25 9h-4.5C13.78 9 13 8.22 13 7.25v-2.5c0-.97.78-1.75 1.75-1.75z"
]);
const $e9fce37105e983ce$export$e37bf5cb04d44045 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance24Regular', "24", [
    "M19.25 11c.97 0 1.75.79 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75h-4.5c-.97 0-1.75-.78-1.75-1.75v-6.5c0-.96.78-1.75 1.75-1.75zm-9.98 4.01c.96 0 1.75.79 1.75 1.75v2.5c0 .96-.79 1.74-1.75 1.74H4.75C3.8 21 3 20.22 3 19.25v-2.49c0-.96.79-1.75 1.75-1.75zm9.98-2.5h-4.5a.25.25 0 0 0-.25.24v6.5q.02.23.25.25h4.5q.23-.02.25-.25v-6.5a.25.25 0 0 0-.25-.25m-9.98 4H4.75a.25.25 0 0 0-.25.25v2.5c0 .13.12.24.25.24h4.52q.23-.02.25-.25v-2.49a.25.25 0 0 0-.25-.25M9.25 3c.97 0 1.75.78 1.75 1.75v6.5c0 .92-.7 1.67-1.6 1.74l-.15.01h-4.5C3.8 13 3 12.22 3 11.25v-6.5C3 3.78 3.8 3 4.75 3zm0 1.5h-4.5a.25.25 0 0 0-.25.25v6.5c0 .14.12.25.25.25h4.56q.18-.06.2-.25v-6.5a.25.25 0 0 0-.26-.25m10-1.5c.97 0 1.75.78 1.75 1.75v2.5C21 8.22 20.22 9 19.25 9h-4.5C13.78 9 13 8.22 13 7.25v-2.5c0-.97.78-1.75 1.75-1.75zm-4.5 1.5a.25.25 0 0 0-.25.25v2.5c0 .14.11.25.25.25h4.5c.14 0 .25-.11.25-.25v-2.5a.25.25 0 0 0-.25-.25z"
]);
const $e9fce37105e983ce$export$6b55cda586aef967 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance28Filled', "28", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v6.5A2.75 2.75 0 0 0 5.75 15h4.5A2.75 2.75 0 0 0 13 12.25v-6.5A2.75 2.75 0 0 0 10.25 3zM3 20.75A2.75 2.75 0 0 1 5.75 18h4.5A2.75 2.75 0 0 1 13 20.75v1.5A2.75 2.75 0 0 1 10.25 25h-4.5A2.75 2.75 0 0 1 3 22.25zm12-15A2.75 2.75 0 0 1 17.75 3h4.5A2.75 2.75 0 0 1 25 5.75v1.5A2.75 2.75 0 0 1 22.25 10h-4.5A2.75 2.75 0 0 1 15 7.25zm0 10A2.75 2.75 0 0 1 17.75 13h4.5A2.75 2.75 0 0 1 25 15.75v6.5A2.75 2.75 0 0 1 22.25 25h-4.5A2.75 2.75 0 0 1 15 22.25z"
]);
const $e9fce37105e983ce$export$fd7c1383f42fea00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance28Regular', "28", [
    "M5.75 3A2.75 2.75 0 0 0 3 5.75v6.5A2.75 2.75 0 0 0 5.75 15h4.5A2.75 2.75 0 0 0 13 12.25v-6.5A2.75 2.75 0 0 0 10.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25v6.5c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25zM5.75 18A2.75 2.75 0 0 0 3 20.75v1.5A2.75 2.75 0 0 0 5.75 25h4.5A2.75 2.75 0 0 0 13 22.25v-1.5A2.75 2.75 0 0 0 10.25 18zM4.5 20.75c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25v1.5c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25zm10.5-15A2.75 2.75 0 0 1 17.75 3h4.5A2.75 2.75 0 0 1 25 5.75v1.5A2.75 2.75 0 0 1 22.25 10h-4.5A2.75 2.75 0 0 1 15 7.25zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v1.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-1.5c0-.69-.56-1.25-1.25-1.25zm0 8.5A2.75 2.75 0 0 0 15 15.75v6.5A2.75 2.75 0 0 0 17.75 25h4.5A2.75 2.75 0 0 0 25 22.25v-6.5A2.75 2.75 0 0 0 22.25 13zm-1.25 2.75c0-.69.56-1.25 1.25-1.25h4.5c.69 0 1.25.56 1.25 1.25v6.5c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25z"
]);
const $e9fce37105e983ce$export$c37df12c60d487c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance32Filled', "32", [
    "M29 25.75c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 17 25.75v-8.5c0-1.8 1.46-3.25 3.25-3.25h5.5c1.8 0 3.25 1.46 3.25 3.25zm-15-11c0 1.8-1.46 3.25-3.25 3.25h-4.5A3.25 3.25 0 0 1 3 14.75v-8.5C3 4.45 4.46 3 6.25 3h4.5C12.55 3 14 4.46 14 6.25zm15-7c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 17 7.75v-1.5C17 4.45 18.46 3 20.25 3h5.5C27.55 3 29 4.46 29 6.25zm-15 18c0 1.8-1.46 3.25-3.25 3.25h-4.5A3.25 3.25 0 0 1 3 25.75v-1.5C3 22.45 4.46 21 6.25 21h4.5c1.8 0 3.25 1.46 3.25 3.25z"
]);
const $e9fce37105e983ce$export$57a06e8c53ef7ebd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance32Regular', "32", [
    "M29 25.75c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 17 25.75v-8.5c0-1.8 1.46-3.25 3.25-3.25h5.5c1.8 0 3.25 1.46 3.25 3.25zM25.75 27c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25zM14 14.75c0 1.8-1.46 3.25-3.25 3.25h-4.5A3.25 3.25 0 0 1 3 14.75v-8.5C3 4.45 4.46 3 6.25 3h4.5C12.55 3 14 4.46 14 6.25zM10.75 16c.69 0 1.25-.56 1.25-1.25v-8.5C12 5.56 11.44 5 10.75 5h-4.5C5.56 5 5 5.56 5 6.25v8.5c0 .69.56 1.25 1.25 1.25zm15-5C27.55 11 29 9.54 29 7.75v-1.5C29 4.45 27.54 3 25.75 3h-5.5A3.25 3.25 0 0 0 17 6.25v1.5c0 1.8 1.46 3.25 3.25 3.25zM27 7.75C27 8.44 26.44 9 25.75 9h-5.5C19.56 9 19 8.44 19 7.75v-1.5c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25zm-13 18c0 1.8-1.46 3.25-3.25 3.25h-4.5A3.25 3.25 0 0 1 3 25.75v-1.5C3 22.45 4.46 21 6.25 21h4.5c1.8 0 3.25 1.46 3.25 3.25zM10.75 27c.69 0 1.25-.56 1.25-1.25v-1.5c0-.69-.56-1.25-1.25-1.25h-4.5C5.56 23 5 23.56 5 24.25v1.5c0 .69.56 1.25 1.25 1.25z"
]);
const $e9fce37105e983ce$export$d91abd06d32359fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance48Filled', "48", [
    "M10.25 6A4.25 4.25 0 0 0 6 10.25v11.5C6 24.1 7.9 26 10.25 26h7.5C20.1 26 22 24.1 22 21.75v-11.5C22 7.9 20.1 6 17.75 6zM6 34.25C6 31.9 7.9 30 10.25 30h7.5C20.1 30 22 31.9 22 34.25v3.5C22 40.1 20.1 42 17.75 42h-7.5A4.25 4.25 0 0 1 6 37.75zm20-24C26 7.9 27.9 6 30.25 6h7.5C40.1 6 42 7.9 42 10.25v3.5C42 16.1 40.1 18 37.75 18h-7.5A4.25 4.25 0 0 1 26 13.75zm0 16C26 23.9 27.9 22 30.25 22h7.5C40.1 22 42 23.9 42 26.25v11.5C42 40.1 40.1 42 37.75 42h-7.5A4.25 4.25 0 0 1 26 37.75z"
]);
const $e9fce37105e983ce$export$bc80937e08464856 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glance48Regular', "48", [
    "M10.25 6A4.25 4.25 0 0 0 6 10.25v11.5C6 24.1 7.9 26 10.25 26h7.5C20.1 26 22 24.1 22 21.75v-11.5C22 7.9 20.1 6 17.75 6zM8.5 10.25c0-.97.78-1.75 1.75-1.75h7.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75h-7.5c-.97 0-1.75-.78-1.75-1.75zM10.25 30A4.25 4.25 0 0 0 6 34.25v3.5C6 40.1 7.9 42 10.25 42h7.5C20.1 42 22 40.1 22 37.75v-3.5C22 31.9 20.1 30 17.75 30zM8.5 34.25c0-.97.78-1.75 1.75-1.75h7.5c.97 0 1.75.78 1.75 1.75v3.5c0 .97-.78 1.75-1.75 1.75h-7.5c-.97 0-1.75-.78-1.75-1.75zm17.5-24C26 7.9 27.9 6 30.25 6h7.5C40.1 6 42 7.9 42 10.25v3.5C42 16.1 40.1 18 37.75 18h-7.5A4.25 4.25 0 0 1 26 13.75zm4.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-3.5c0-.97-.78-1.75-1.75-1.75zm0 13.5A4.25 4.25 0 0 0 26 26.25v11.5C26 40.1 27.9 42 30.25 42h7.5C40.1 42 42 40.1 42 37.75v-11.5C42 23.9 40.1 22 37.75 22zm-1.75 4.25c0-.97.78-1.75 1.75-1.75h7.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75h-7.5c-.97 0-1.75-.78-1.75-1.75z"
]);
const $e9fce37105e983ce$export$f3003990457cf706 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceDefault12Filled', "12", [
    "M6 9.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-2C6.67 5 6 5.67 6 6.5zm-5-4C1 6.33 1.67 7 2.5 7h1C4.33 7 5 6.33 5 5.5v-3C5 1.67 4.33 1 3.5 1h-1C1.67 1 1 1.67 1 2.5zM7.5 4a1.5 1.5 0 1 1 0-3h2a1.5 1.5 0 0 1 0 3zM1 9.5c0 .83.67 1.5 1.5 1.5h1a1.5 1.5 0 0 0 0-3h-1C1.67 8 1 8.67 1 9.5"
]);
const $e9fce37105e983ce$export$d0b5c245a0f00c62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceDefault12Regular', "12", [
    "M6 9.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-2C6.67 5 6 5.67 6 6.5zm1.5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5zM1 5.5C1 6.33 1.67 7 2.5 7h1C4.33 7 5 6.33 5 5.5v-3C5 1.67 4.33 1 3.5 1h-1C1.67 1 1 1.67 1 2.5zm1.5.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5zm5-2a1.5 1.5 0 1 1 0-3h2a1.5 1.5 0 0 1 0 3zM7 2.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5m-6 7c0 .83.67 1.5 1.5 1.5h1a1.5 1.5 0 0 0 0-3h-1C1.67 8 1 8.67 1 9.5m1.5.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1z"
]);
const $e9fce37105e983ce$export$9474b32a6a456805 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal12Filled', "12", [
    "M2.5 6A1.5 1.5 0 0 1 1 4.5v-2C1 1.67 1.67 1 2.5 1h3C6.33 1 7 1.67 7 2.5v2C7 5.33 6.33 6 5.5 6z",
    "M6.5 11A1.5 1.5 0 0 1 5 9.5v-1C5 7.67 5.67 7 6.5 7h3c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5z",
    "M8 4.5a1.5 1.5 0 1 0 3 0v-2a1.5 1.5 0 0 0-3 0z",
    "M2.5 11A1.5 1.5 0 0 1 1 9.5v-1a1.5 1.5 0 1 1 3 0v1c0 .83-.67 1.5-1.5 1.5"
]);
const $e9fce37105e983ce$export$b2721ca883ecbe14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal12Regular', "12", [
    "M2.5 6A1.5 1.5 0 0 1 1 4.5v-2C1 1.67 1.67 1 2.5 1h3C6.33 1 7 1.67 7 2.5v2C7 5.33 6.33 6 5.5 6zM2 4.5c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5zM6.5 11A1.5 1.5 0 0 1 5 9.5v-1C5 7.67 5.67 7 6.5 7h3c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5zM6 9.5c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5zm2-5a1.5 1.5 0 1 0 3 0v-2a1.5 1.5 0 0 0-3 0zm1.5.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5m-7 6A1.5 1.5 0 0 1 1 9.5v-1a1.5 1.5 0 1 1 3 0v1c0 .83-.67 1.5-1.5 1.5M2 9.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0z"
]);
const $e9fce37105e983ce$export$1824e2cf36cfd678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal16Filled', "16", [
    "M3.75 2C2.78 2 2 2.78 2 3.75v2.5C2 7.22 2.78 8 3.75 8h3.5C8.22 8 9 7.22 9 6.25v-2.5C9 2.78 8.22 2 7.25 2zm5 7C7.78 9 7 9.78 7 10.75v1.5c0 .97.78 1.75 1.75 1.75h3.5c.97 0 1.75-.78 1.75-1.75v-1.5C14 9.78 13.22 9 12.25 9zm-5 0C2.78 9 2 9.78 2 10.75v1.5c0 .97.78 1.75 1.75 1.75h.5C5.22 14 6 13.22 6 12.25v-1.5C6 9.78 5.22 9 4.25 9zm8-7C10.78 2 10 2.78 10 3.75v2.5c0 .97.78 1.75 1.75 1.75h.5C13.22 8 14 7.22 14 6.25v-2.5C14 2.78 13.22 2 12.25 2z"
]);
const $e9fce37105e983ce$export$5e863ed12ea0c269 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal16Regular', "16", [
    "M3.75 2C2.78 2 2 2.78 2 3.75v2.5C2 7.22 2.78 8 3.75 8h3.5C8.22 8 9 7.22 9 6.25v-2.5C9 2.78 8.22 2 7.25 2zM3 3.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-3.5A.75.75 0 0 1 3 6.25zM8.75 9C7.78 9 7 9.78 7 10.75v1.5c0 .97.78 1.75 1.75 1.75h3.5c.97 0 1.75-.78 1.75-1.75v-1.5C14 9.78 13.22 9 12.25 9zM8 10.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v1.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75zm-6 0C2 9.78 2.78 9 3.75 9h.5C5.22 9 6 9.78 6 10.75v1.5C6 13.22 5.22 14 4.25 14h-.5C2.78 14 2 13.22 2 12.25zM3.75 10a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75zm8-8C10.78 2 10 2.78 10 3.75v2.5c0 .97.78 1.75 1.75 1.75h.5C13.22 8 14 7.22 14 6.25v-2.5C14 2.78 13.22 2 12.25 2zM11 3.75c0-.41.34-.75.75-.75h.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-.5a.75.75 0 0 1-.75-.75z"
]);
const $e9fce37105e983ce$export$a1e4f80b71d5dcf6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal20Filled', "20", [
    "M14.5 3h1c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 13 7.5v-3c0-.83.67-1.5 1.5-1.5m-10 0h5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 7.5v-3C3 3.67 3.67 3 4.5 3m0 8h1c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 3 15.5v-3c0-.83.67-1.5 1.5-1.5M9 12.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 9 15.5z"
]);
const $e9fce37105e983ce$export$d01a2c89b1de8e86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal20Regular', "20", [
    "M17 15.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 9 15.5v-3c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5zm-1.5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5zM11 7.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 7.5v-3C3 3.67 3.67 3 4.5 3h5c.83 0 1.5.67 1.5 1.5zM9.5 8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5zm6 1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5zm.5-1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5zm-9 8c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 3 15.5v-3c0-.83.67-1.5 1.5-1.5h1c.83 0 1.5.67 1.5 1.5zm-1.5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5z"
]);
const $e9fce37105e983ce$export$850c35e2c2fa011b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal24Filled', "24", [
    "M13 4.75C13 3.8 12.22 3 11.25 3h-6.5C3.78 3 3 3.8 3 4.75v4.5c0 .97.78 1.75 1.75 1.75h6.5c.97 0 1.75-.78 1.75-1.75zM9 14.73c0-.96-.78-1.75-1.75-1.75H4.75c-.97 0-1.75.79-1.75 1.75v4.52C3 20.2 3.78 21 4.75 21h2.49c.97 0 1.75-.79 1.75-1.75zm12.01.02c0-.97-.78-1.75-1.75-1.75h-6.5c-.92 0-1.67.7-1.74 1.6v4.65c0 .96.78 1.75 1.74 1.75h6.5c.97 0 1.75-.79 1.75-1.75zm0-10C21 3.8 20.22 3 19.25 3h-2.5C15.8 3 15 3.8 15 4.75v4.5c0 .97.79 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75z"
]);
const $e9fce37105e983ce$export$bd13c5e574fac0bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal24Regular', "24", [
    "M13 4.75C13 3.8 12.22 3 11.25 3h-6.5C3.78 3 3 3.8 3 4.75v4.5c0 .97.78 1.75 1.75 1.75h6.5c.97 0 1.75-.78 1.75-1.75zM9 14.73c0-.96-.78-1.75-1.75-1.75H4.75c-.97 0-1.75.79-1.75 1.75v4.52C3 20.2 3.78 21 4.75 21h2.49c.97 0 1.75-.79 1.75-1.75zm2.51-9.98v4.5q-.02.23-.25.25h-6.5a.25.25 0 0 1-.25-.25v-4.5c0-.14.11-.25.25-.25h6.5c.14 0 .25.11.25.25M7.5 14.73v4.52c0 .14-.11.25-.25.25H4.75a.25.25 0 0 1-.25-.25v-4.52c0-.13.11-.25.25-.25h2.49c.14 0 .25.12.25.25m13.51.02c0-.97-.78-1.75-1.75-1.75h-6.5c-.92 0-1.67.7-1.74 1.6v4.65c0 .96.78 1.75 1.74 1.75h6.5c.97 0 1.75-.79 1.75-1.75zm-1.5 0v4.5q-.01.23-.25.25h-6.5a.25.25 0 0 1-.25-.25v-4.56q.06-.18.25-.2h6.5c.14 0 .25.12.25.26m1.5-10C21 3.8 20.22 3 19.25 3h-2.5C15.8 3 15 3.8 15 4.75v4.5c0 .97.79 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75zm-1.5 4.5q-.01.23-.25.25h-2.5a.25.25 0 0 1-.25-.25v-4.5c0-.14.11-.25.25-.25h2.5c.14 0 .25.11.25.25z"
]);
const $e9fce37105e983ce$export$989848d480d77cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal28Filled', "28", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h6.5A2.75 2.75 0 0 1 15 5.75v4.5A2.75 2.75 0 0 1 12.25 13h-6.5A2.75 2.75 0 0 1 3 10.25zM20.75 3A2.75 2.75 0 0 0 18 5.75v4.5A2.75 2.75 0 0 0 20.75 13h1.5A2.75 2.75 0 0 0 25 10.25v-4.5A2.75 2.75 0 0 0 22.25 3zm-15 12A2.75 2.75 0 0 0 3 17.75v4.5A2.75 2.75 0 0 0 5.75 25h1.5A2.75 2.75 0 0 0 10 22.25v-4.5A2.75 2.75 0 0 0 7.25 15zm10 0A2.75 2.75 0 0 0 13 17.75v4.5A2.75 2.75 0 0 0 15.75 25h6.5A2.75 2.75 0 0 0 25 22.25v-4.5A2.75 2.75 0 0 0 22.25 15z"
]);
const $e9fce37105e983ce$export$2be221599662db9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal28Regular', "28", [
    "M3 5.75A2.75 2.75 0 0 1 5.75 3h6.5A2.75 2.75 0 0 1 15 5.75v4.5A2.75 2.75 0 0 1 12.25 13h-6.5A2.75 2.75 0 0 1 3 10.25zM5.75 4.5c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25zM18 5.75A2.75 2.75 0 0 1 20.75 3h1.5A2.75 2.75 0 0 1 25 5.75v4.5A2.75 2.75 0 0 1 22.25 13h-1.5A2.75 2.75 0 0 1 18 10.25zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25zM5.75 15A2.75 2.75 0 0 0 3 17.75v4.5A2.75 2.75 0 0 0 5.75 25h1.5A2.75 2.75 0 0 0 10 22.25v-4.5A2.75 2.75 0 0 0 7.25 15zM4.5 17.75c0-.69.56-1.25 1.25-1.25h1.5c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-1.5c-.69 0-1.25-.56-1.25-1.25zm8.5 0A2.75 2.75 0 0 1 15.75 15h6.5A2.75 2.75 0 0 1 25 17.75v4.5A2.75 2.75 0 0 1 22.25 25h-6.5A2.75 2.75 0 0 1 13 22.25zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25z"
]);
const $e9fce37105e983ce$export$fa6a99ee22853730 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal32Filled', "32", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v5.5C3 13.55 4.46 15 6.25 15h8.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C18 4.45 16.54 3 14.75 3zm11 15A3.25 3.25 0 0 0 14 21.25v4.5c0 1.8 1.46 3.25 3.25 3.25h8.5c1.8 0 3.25-1.46 3.25-3.25v-4.5c0-1.8-1.46-3.25-3.25-3.25zm7-15A3.25 3.25 0 0 0 21 6.25v5.5c0 1.8 1.46 3.25 3.25 3.25h1.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C29 4.45 27.54 3 25.75 3zm-18 15A3.25 3.25 0 0 0 3 21.25v4.5C3 27.55 4.46 29 6.25 29h1.5c1.8 0 3.25-1.46 3.25-3.25v-4.5C11 19.45 9.54 18 7.75 18z"
]);
const $e9fce37105e983ce$export$ff2b2d42e4f19d72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal32Regular', "32", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v5.5C3 13.55 4.46 15 6.25 15h8.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C18 4.45 16.54 3 14.75 3zM5 6.25C5 5.56 5.56 5 6.25 5h8.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-8.5C5.56 13 5 12.44 5 11.75zM17.25 18A3.25 3.25 0 0 0 14 21.25v4.5c0 1.8 1.46 3.25 3.25 3.25h8.5c1.8 0 3.25-1.46 3.25-3.25v-4.5c0-1.8-1.46-3.25-3.25-3.25zM16 21.25c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25zm5-15C21 4.45 22.46 3 24.25 3h1.5C27.55 3 29 4.46 29 6.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-1.5A3.25 3.25 0 0 1 21 11.75zM24.25 5C23.56 5 23 5.56 23 6.25v5.5c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25v-5.5C27 5.56 26.44 5 25.75 5zm-18 13A3.25 3.25 0 0 0 3 21.25v4.5C3 27.55 4.46 29 6.25 29h1.5c1.8 0 3.25-1.46 3.25-3.25v-4.5C11 19.45 9.54 18 7.75 18zM5 21.25c0-.69.56-1.25 1.25-1.25h1.5c.69 0 1.25.56 1.25 1.25v4.5C9 26.44 8.44 27 7.75 27h-1.5C5.56 27 5 26.44 5 25.75z"
]);
const $e9fce37105e983ce$export$f31009b756a55695 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal48Filled', "48", [
    "M6 10.25C6 7.9 7.9 6 10.25 6h11.5C24.1 6 26 7.9 26 10.25v7.5C26 20.1 24.1 22 21.75 22h-11.5A4.25 4.25 0 0 1 6 17.75zM34.25 6A4.25 4.25 0 0 0 30 10.25v7.5C30 20.1 31.9 22 34.25 22h3.5C40.1 22 42 20.1 42 17.75v-7.5C42 7.9 40.1 6 37.75 6zm-24 20A4.25 4.25 0 0 0 6 30.25v7.5C6 40.1 7.9 42 10.25 42h3.5C16.1 42 18 40.1 18 37.75v-7.5C18 27.9 16.1 26 13.75 26zm16 0A4.25 4.25 0 0 0 22 30.25v7.5C22 40.1 23.9 42 26.25 42h11.5C40.1 42 42 40.1 42 37.75v-7.5C42 27.9 40.1 26 37.75 26z"
]);
const $e9fce37105e983ce$export$cb89b6ae810dc968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontal48Regular', "48", [
    "M6 10.25C6 7.9 7.9 6 10.25 6h11.5C24.1 6 26 7.9 26 10.25v7.5C26 20.1 24.1 22 21.75 22h-11.5A4.25 4.25 0 0 1 6 17.75zm4.25-1.75c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-7.5c0-.97-.78-1.75-1.75-1.75zM30 10.25C30 7.9 31.9 6 34.25 6h3.5C40.1 6 42 7.9 42 10.25v7.5C42 20.1 40.1 22 37.75 22h-3.5A4.25 4.25 0 0 1 30 17.75zm4.25-1.75c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h3.5c.97 0 1.75-.78 1.75-1.75v-7.5c0-.97-.78-1.75-1.75-1.75zm-24 17.5A4.25 4.25 0 0 0 6 30.25v7.5C6 40.1 7.9 42 10.25 42h3.5C16.1 42 18 40.1 18 37.75v-7.5C18 27.9 16.1 26 13.75 26zM8.5 30.25c0-.97.78-1.75 1.75-1.75h3.5c.97 0 1.75.78 1.75 1.75v7.5c0 .97-.78 1.75-1.75 1.75h-3.5c-.97 0-1.75-.78-1.75-1.75zm13.5 0C22 27.9 23.9 26 26.25 26h11.5C40.1 26 42 27.9 42 30.25v7.5C42 40.1 40.1 42 37.75 42h-11.5A4.25 4.25 0 0 1 22 37.75zm4.25-1.75c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-7.5c0-.97-.78-1.75-1.75-1.75z"
]);
const $e9fce37105e983ce$export$5ee0e8ec4c74c68f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkle32Filled', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 11.75zm11 15c0-1.8 1.46-3.25 3.25-3.25h8.5c1.8 0 3.25 1.46 3.25 3.25v4.5c0 1.8-1.46 3.25-3.25 3.25h-8.5A3.25 3.25 0 0 1 14 25.75zm-11 0C3 19.45 4.46 18 6.25 18h1.5c1.8 0 3.25 1.46 3.25 3.25v4.5C11 27.55 9.54 29 7.75 29h-1.5A3.25 3.25 0 0 1 3 25.75z"
]);
const $e9fce37105e983ce$export$a5cbd0f5ad2dc8f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkle32Regular', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M6.25 3A3.25 3.25 0 0 0 3 6.25v5.5C3 13.55 4.46 15 6.25 15h7.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C17 4.45 15.54 3 13.75 3zM5 6.25C5 5.56 5.56 5 6.25 5h7.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-7.5C5.56 13 5 12.44 5 11.75zm9 15c0-1.8 1.46-3.25 3.25-3.25h8.5c1.8 0 3.25 1.46 3.25 3.25v4.5c0 1.8-1.46 3.25-3.25 3.25h-8.5A3.25 3.25 0 0 1 14 25.75zM17.25 20c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25zm-11-2A3.25 3.25 0 0 0 3 21.25v4.5C3 27.55 4.46 29 6.25 29h1.5c1.8 0 3.25-1.46 3.25-3.25v-4.5C11 19.45 9.54 18 7.75 18zM5 21.25c0-.69.56-1.25 1.25-1.25h1.5c.69 0 1.25.56 1.25 1.25v4.5C9 26.44 8.44 27 7.75 27h-1.5C5.56 27 5 26.44 5 25.75z"
]);
const $e9fce37105e983ce$export$ba27bb4b87dc1454 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkles16Filled', "16", [
    "M13.78 2.21h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.12.14.3.3 0 0 1-.17.06.3.3 0 0 1-.29-.2l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1L11.2.2a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1zm2.05 3.56-.62-.2a1.3 1.3 0 0 1-.8-.8l-.2-.6a.24.24 0 0 0-.45 0l-.2.6a1.3 1.3 0 0 1-.79.8l-.6.2a.24.24 0 0 0 0 .46l.6.2a1.3 1.3 0 0 1 .8.8l.2.6a.24.24 0 0 0 .46 0l.2-.6a1.3 1.3 0 0 1 .8-.8l.6-.2a.24.24 0 0 0 0-.46M2 3.75C2 2.78 2.78 2 3.75 2h2.5C7.22 2 8 2.78 8 3.75v2.5C8 7.22 7.22 8 6.25 8h-2.5C2.78 8 2 7.22 2 6.25zm5 7C7 9.78 7.78 9 8.75 9h3.5c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75h-3.5C7.78 14 7 13.22 7 12.25zm-5 0C2 9.78 2.78 9 3.75 9h.5C5.22 9 6 9.78 6 10.75v1.5C6 13.22 5.22 14 4.25 14h-.5C2.78 14 2 13.22 2 12.25z"
]);
const $e9fce37105e983ce$export$30cbd155fa7a92d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkles16Regular', "16", [
    "M13.78 2.21h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.12.14.3.3 0 0 1-.17.06.3.3 0 0 1-.29-.2l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1L11.2.2a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1zm2.05 3.56-.62-.2a1.3 1.3 0 0 1-.8-.8l-.2-.6a.24.24 0 0 0-.45 0l-.2.6a1.3 1.3 0 0 1-.79.8l-.6.2a.24.24 0 0 0 0 .46l.6.2a1.3 1.3 0 0 1 .8.8l.2.6a.24.24 0 0 0 .46 0l.2-.6a1.3 1.3 0 0 1 .8-.8l.6-.2a.24.24 0 0 0 0-.46M3.75 2C2.78 2 2 2.78 2 3.75v2.5C2 7.22 2.78 8 3.75 8h2.5C7.22 8 8 7.22 8 6.25v-2.5C8 2.78 7.22 2 6.25 2zM3 3.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-2.5A.75.75 0 0 1 3 6.25zM8.75 9C7.78 9 7 9.78 7 10.75v1.5c0 .97.78 1.75 1.75 1.75h3.5c.97 0 1.75-.78 1.75-1.75v-1.5C14 9.78 13.22 9 12.25 9zM8 10.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v1.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75zm-6 0C2 9.78 2.78 9 3.75 9h.5C5.22 9 6 9.78 6 10.75v1.5C6 13.22 5.22 14 4.25 14h-.5C2.78 14 2 13.22 2 12.25zM3.75 10a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75z"
]);
const $e9fce37105e983ce$export$ff742a6d6d395634 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkles20Filled', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM9.5 3q.3 0 .55.1a1.43 1.43 0 0 0 .92 1.75H11V7.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 7.5v-3C3 3.67 3.67 3 4.5 3zm-4 8h-1c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5m5 0c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
]);
const $e9fce37105e983ce$export$d35dc9e1f0924d63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkles20Regular', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM9.5 3q.3 0 .55.1a1.43 1.43 0 0 0 .92 1.75H11V7.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 7.5v-3C3 3.67 3.67 3 4.5 3zm6 14c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-5c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5zm.5-1.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5zm-6-8v-3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5M5.5 17c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5zm.5-1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5z"
]);
const $e9fce37105e983ce$export$a6d0f4fe792adc58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkles24Filled', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-13.54-7.2c.97 0 1.75.78 1.75 1.74v4.5c0 .97-.78 1.75-1.75 1.75h-5.5C3.78 11 3 10.22 3 9.25v-4.5C3 3.8 3.78 3 4.75 3zm-3.01 9.97c.97 0 1.75.79 1.75 1.75v4.52c0 .97-.78 1.75-1.75 1.75H4.75C3.78 21 3 20.22 3 19.25v-4.52c0-.96.78-1.75 1.75-1.75zm12.01.02c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75h-6.5c-.96 0-1.75-.78-1.75-1.75V14.6c.08-.9.83-1.61 1.75-1.61z"
]);
const $e9fce37105e983ce$export$6a55f14d7bd6187e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlanceHorizontalSparkles24Regular', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-13.54-7.2c.97 0 1.75.78 1.75 1.74v4.5c0 .97-.78 1.75-1.75 1.75h-5.5C3.78 11 3 10.22 3 9.25v-4.5C3 3.8 3.78 3 4.75 3zm.25 6.24v-4.5a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25v4.5c0 .14.11.25.25.25h5.5q.23-.02.25-.25m-3.26 3.73c.96 0 1.75.79 1.75 1.75v4.52c0 .96-.79 1.75-1.75 1.75H4.75C3.78 21 3 20.2 3 19.25v-4.52c0-.96.78-1.75 1.75-1.75zm.25 6.27v-4.52a.25.25 0 0 0-.25-.25H4.75a.25.25 0 0 0-.25.25v4.52c0 .14.11.25.25.25h2.49q.23-.02.25-.25M19.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .96-.78 1.75-1.75 1.75h-6.5C11.8 21 11 20.2 11 19.25V14.6c.08-.9.83-1.6 1.75-1.6zm.25 6.25v-4.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.24.2v4.55q.01.23.24.25h6.5q.23-.02.25-.25"
]);
const $e9fce37105e983ce$export$418c625a8670b3b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses16Filled', "16", [
    "M5.17 3.13A.5.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-.81L3.44 6H5.5C6.33 6 7 6.67 7 7.5V8h2v-.5c0-.83.67-1.5 1.5-1.5h2.06l-2.25-2H9.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .33.13l3.62 3.21c.34.28.55.7.55 1.16v2a2.5 2.5 0 0 1-2.5 2.5h-1A2.5 2.5 0 0 1 9 9.5V9H7v.5A2.5 2.5 0 0 1 4.5 12h-1A2.5 2.5 0 0 1 1 9.5v-2c0-.47.21-.88.55-1.16z"
]);
const $e9fce37105e983ce$export$3bd89e14ef0b4057 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses16Regular', "16", [
    "M5.17 3.13A.5.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-.81L3.44 6H5.5C6.33 6 7 6.67 7 7.5V8h2v-.5c0-.83.67-1.5 1.5-1.5h2.06l-2.25-2H9.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .33.13l3.62 3.21c.34.28.55.7.55 1.16v2a2.5 2.5 0 0 1-2.5 2.5h-1A2.5 2.5 0 0 1 9 9.5V9H7v.5A2.5 2.5 0 0 1 4.5 12h-1A2.5 2.5 0 0 1 1 9.5v-2c0-.47.21-.88.55-1.16zM13.8 7.1A.5.5 0 0 0 13.5 7h-3a.5.5 0 0 0-.5.5v2c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 0-.17-.38zm-11.64.01A.5.5 0 0 0 2 7.5v2c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.3.1z"
]);
const $e9fce37105e983ce$export$30c0f3c98e0b8564 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses20Filled', "20", [
    "M7.19 4a2 2 0 0 0-1.52.7L2.37 8.5A1.5 1.5 0 0 0 2 9.5v3A2.5 2.5 0 0 0 4.5 15h2A2.5 2.5 0 0 0 9 12.5V11h2v1.5a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-3c0-.43-.18-.82-.47-1.09l-3.2-3.72A2 2 0 0 0 12.8 4H12a.5.5 0 1 0 0 1h.81a1 1 0 0 1 .76.35L15.86 8H12.5c-.83 0-1.5.67-1.5 1.5v.5H9v-.5C9 8.67 8.33 8 7.5 8H4.14l2.29-2.65A1 1 0 0 1 7.19 5H8a.5.5 0 0 0 0-1z"
]);
const $e9fce37105e983ce$export$2857d7dbf1ac04a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses20Regular', "20", [
    "M7.19 4a2 2 0 0 0-1.52.7l-3.3 3.82Q2 8.92 2 9.5v3A2.5 2.5 0 0 0 4.5 15h2A2.5 2.5 0 0 0 9 12.5V11h2v1.5a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-3c0-.43-.18-.82-.47-1.09l-3.2-3.72A2 2 0 0 0 12.8 4H12a.5.5 0 1 0 0 1h.81a1 1 0 0 1 .76.35L15.86 8H12.5c-.83 0-1.5.67-1.5 1.5v.5H9v-.5C9 8.67 8.33 8 7.5 8H4.14l2.29-2.65A1 1 0 0 1 7.19 5H8a.5.5 0 1 0 0-1zM8 9.5v3c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 12.5v-3c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5m4 3v-3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 .32.11l.05.07q.13.13.13.32v3c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5"
]);
const $e9fce37105e983ce$export$4d92310cc8560d63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses24Filled', "24", [
    "M7.9 5h.85a.75.75 0 0 1 .1 1.5h-.94a.8.8 0 0 0-.48.17l-.07.07L5.28 9h3.47c1.16 0 2.11.88 2.24 2H13c.13-1.12 1.08-2 2.24-2h3.48l-2.09-2.26a.8.8 0 0 0-.44-.23l-.1-.01h-.85a.75.75 0 0 1-.1-1.5h.94c.57 0 1.11.21 1.52.6l.14.12 3.64 3.95.12.18q.47.59.49 1.4v3.5c0 1.8-1.46 3.25-3.25 3.25h-2.5A3.25 3.25 0 0 1 13 14.75V12.5h-2v2.25C11 16.55 9.54 18 7.75 18h-2.5A3.25 3.25 0 0 1 2 14.75v-3.5c0-.56.2-1.08.55-1.47l.03-.06.05-.05 3.62-3.94c.39-.42.91-.68 1.47-.72zh.84z"
]);
const $e9fce37105e983ce$export$ec0c0c764b5d57b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses24Regular', "24", [
    "M7.9 5h1.35a.75.75 0 0 1 .1 1.5H7.91a.8.8 0 0 0-.48.17l-.07.07L5.28 9h3.47c1.16 0 2.11.88 2.24 2H13c.13-1.12 1.08-2 2.24-2h3.48l-2.09-2.26a.8.8 0 0 0-.44-.23l-.1-.01h-1.35a.75.75 0 0 1-.1-1.5h1.44c.57 0 1.11.21 1.52.6l.14.12 3.64 3.95.12.18q.47.59.49 1.4v3.5c0 1.8-1.46 3.25-3.25 3.25h-2.5A3.25 3.25 0 0 1 13 14.75V12.5h-2v2.25C11 16.55 9.54 18 7.75 18h-2.5A3.25 3.25 0 0 1 2 14.75v-3.5c0-.56.2-1.08.55-1.47l.03-.06.05-.05 3.62-3.94c.39-.42.91-.68 1.47-.72zh1.34zm.85 5.5h-4.5a.75.75 0 0 0-.75.75v3.5c0 .96.78 1.75 1.75 1.75h2.5c.97 0 1.75-.79 1.75-1.75v-3.5a.75.75 0 0 0-.75-.75m11 0h-4.5a.75.75 0 0 0-.75.75v3.5c0 .96.78 1.75 1.75 1.75h2.5c.97 0 1.75-.79 1.75-1.75v-3.5a.75.75 0 0 0-.75-.75"
]);
const $e9fce37105e983ce$export$ec5d504ae3ff48e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses28Filled', "28", [
    "M9.32 7.5q-.5 0-.88.36L5.77 10.5h4.48c1.35 0 2.47.97 2.7 2.25h2.1a2.75 2.75 0 0 1 2.7-2.25h4.48l-2.67-2.64a1.3 1.3 0 0 0-.88-.36h-1.43a.75.75 0 1 1 0-1.5h1.43c.72 0 1.42.28 1.93.8l4.42 4.35.3.3.02.02c.4.48.65 1.1.65 1.78v4A3.75 3.75 0 0 1 22.25 21h-3.5A3.75 3.75 0 0 1 15 17.25v-3h-2v3A3.75 3.75 0 0 1 9.25 21h-3.5A3.75 3.75 0 0 1 2 17.25v-4c0-.68.25-1.3.66-1.78l.02-.03q.13-.15.29-.28l4.42-4.37C7.9 6.3 8.59 6 9.32 6h1.43a.75.75 0 0 1 0 1.5z"
]);
const $e9fce37105e983ce$export$56db66b3f3540c11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses28Regular', "28", [
    "M9.32 7.5q-.5 0-.88.36L5.77 10.5h4.48c1.35 0 2.47.97 2.7 2.25h2.1a2.75 2.75 0 0 1 2.7-2.25h4.48l-2.67-2.64a1.3 1.3 0 0 0-.88-.36h-1.43a.75.75 0 0 1 0-1.5h1.43c.72 0 1.42.28 1.93.8l4.42 4.36q.15.13.29.28l.03.03c.4.48.65 1.1.65 1.78v4A3.75 3.75 0 0 1 22.25 21h-3.5A3.75 3.75 0 0 1 15 17.25v-3h-2v3A3.75 3.75 0 0 1 9.25 21h-3.5A3.75 3.75 0 0 1 2 17.25v-4c0-.68.25-1.3.66-1.78l.02-.03q.13-.15.29-.28l4.42-4.37C7.9 6.3 8.59 6 9.32 6h1.43a.75.75 0 0 1 0 1.5zm14.7 4.77a1.2 1.2 0 0 0-.77-.27h-5.5c-.69 0-1.25.56-1.25 1.25v4c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25v-4q0-.46-.28-.79zm-20.05 0-.19.2q-.27.31-.28.78v4c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25v-4c0-.69-.56-1.25-1.25-1.25h-5.5q-.45 0-.78.27"
]);
const $e9fce37105e983ce$export$376ccf57b64e07fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses32Filled', "32", [
    "M9.01 8.52c.29-.33.7-.52 1.14-.52H12a1 1 0 1 0 0-2h-1.85c-1.02 0-2 .45-2.66 1.22l-4.65 5.43A3.5 3.5 0 0 0 2 14.92v4.58A4.5 4.5 0 0 0 6.5 24h4a4.5 4.5 0 0 0 4.5-4.5V17h2v2.5a4.5 4.5 0 0 0 4.5 4.5h4a4.5 4.5 0 0 0 4.5-4.5v-4.58c0-.83-.3-1.64-.84-2.27L24.5 7.22A3.5 3.5 0 0 0 21.85 6H20a1 1 0 1 0 0 2h1.85c.44 0 .85.2 1.14.52L25.97 12H20.5a3.5 3.5 0 0 0-3.46 3h-2.08a3.5 3.5 0 0 0-3.46-3H6.03z"
]);
const $e9fce37105e983ce$export$a3583671a44ad417 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses32Regular', "32", [
    "M9.01 8.52c.29-.33.7-.52 1.14-.52H12a1 1 0 1 0 0-2h-1.85c-1.02 0-2 .45-2.66 1.22l-4.65 5.43A3.5 3.5 0 0 0 2 14.92v4.58A4.5 4.5 0 0 0 6.5 24h4a4.5 4.5 0 0 0 4.5-4.5V17h2v2.5a4.5 4.5 0 0 0 4.5 4.5h4a4.5 4.5 0 0 0 4.5-4.5v-4.58c0-.83-.3-1.64-.84-2.27L24.5 7.22A3.5 3.5 0 0 0 21.85 6H20a1 1 0 1 0 0 2h1.85c.44 0 .85.2 1.14.52L25.97 12H20.5a3.5 3.5 0 0 0-3.46 3h-2.08a3.5 3.5 0 0 0-3.46-3H6.03zM28 15.5v4a2.5 2.5 0 0 1-2.5 2.5h-4a2.5 2.5 0 0 1-2.5-2.5v-4c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5m-15 0v4a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 4 19.5v-4c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5"
]);
const $e9fce37105e983ce$export$cc2201b2fe1ee229 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses48Filled', "48", [
    "M14.53 13.06c.33-.36.8-.56 1.28-.56h2.94a1.25 1.25 0 1 0 0-2.5h-2.94c-1.18 0-2.31.5-3.12 1.36l-7.23 7.82A4.5 4.5 0 0 0 4 22.42v7.08a6.5 6.5 0 0 0 6.5 6.5h5a6.5 6.5 0 0 0 6.5-6.5v-5h4v5a6.5 6.5 0 0 0 6.5 6.5h5a6.5 6.5 0 0 0 6.5-6.5v-7.08q-.01-1.28-.7-2.35a5 5 0 0 0-.76-.89l-7.23-7.82A4.3 4.3 0 0 0 32.19 10h-2.94a1.25 1.25 0 1 0 0 2.5h2.94c.49 0 .95.2 1.28.56L38.04 18H30.5a4.5 4.5 0 0 0-4.47 4h-4.06a4.5 4.5 0 0 0-4.47-4H9.96z"
]);
const $e9fce37105e983ce$export$f5f4350636872d9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Glasses48Regular', "48", [
    "M14.53 13.06c.33-.36.8-.56 1.28-.56h2.94a1.25 1.25 0 1 0 0-2.5h-2.94c-1.18 0-2.31.5-3.12 1.36l-7.23 7.82A4.5 4.5 0 0 0 4 22.42v7.08a6.5 6.5 0 0 0 6.5 6.5h5a6.5 6.5 0 0 0 6.5-6.5v-5h4v5a6.5 6.5 0 0 0 6.5 6.5h5a6.5 6.5 0 0 0 6.5-6.5v-7.08q-.01-1.28-.7-2.35a5 5 0 0 0-.76-.89l-7.23-7.82A4.3 4.3 0 0 0 32.19 10h-2.94a1.25 1.25 0 1 0 0 2.5h2.94c.49 0 .95.2 1.28.56L38.04 18H30.5a4.5 4.5 0 0 0-4.47 4h-4.06a4.5 4.5 0 0 0-4.47-4H9.96zM28.5 29.5v-7c0-1.1.9-2 2-2h9a2 2 0 0 1 1.29.47l.24.27q.09.08.16.2.3.46.31 1.06v7a4 4 0 0 1-4 4h-5a4 4 0 0 1-4-4m-9-7v7a4 4 0 0 1-4 4h-5a4 4 0 0 1-4-4v-7a2 2 0 0 1 .3-1.07l.17-.2.24-.26a2 2 0 0 1 1.29-.47h9a2 2 0 0 1 2 2"
]);
const $e9fce37105e983ce$export$2b138bf906ec287c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff16Filled', "16", [
    "m11.28 12 2.87 2.85a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L3.7 4.42 1.54 6.34c-.33.28-.54.7-.54 1.16v2A2.5 2.5 0 0 0 3.5 12h1A2.5 2.5 0 0 0 7 9.5V9h1.3l.7.72a2.5 2.5 0 0 0 2.28 2.27M5.3 6H3.44l.98-.87zm8.48 5.65L9.1 6.97A1.5 1.5 0 0 1 10.5 6h2.06l-2.25-2H9.5a.5.5 0 1 1 0-1h1a.5.5 0 0 1 .33.13l3.63 3.21c.33.28.54.7.54 1.16v2c0 .92-.5 1.72-1.23 2.15M5.21 3.1l.91.91h.38a.5.5 0 1 0 0-1h-1a.5.5 0 0 0-.29.1"
]);
const $e9fce37105e983ce$export$d7a4b68d3cb7a63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff16Regular', "16", [
    "m11.28 12 2.87 2.85a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L3.7 4.42 1.55 6.34C1.2 6.62 1 7.04 1 7.5v2A2.5 2.5 0 0 0 3.5 12h1A2.5 2.5 0 0 0 7 9.5V9h1.3l.7.72a2.5 2.5 0 0 0 2.28 2.27M5.3 6H3.44l.98-.87zM2.17 7.12l.02-.01A.5.5 0 0 1 2.5 7h3c.28 0 .5.22.5.5v2c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 2 9.5v-2a.5.5 0 0 1 .17-.38m7.83.76-.9-.9A1.5 1.5 0 0 1 10.5 6h2.06l-2.25-2H9.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .33.13l3.62 3.21c.34.28.55.7.55 1.16v2c0 .92-.5 1.72-1.23 2.15l-.74-.75c.57-.2.97-.76.97-1.4v-2a.5.5 0 0 0-.17-.38l-.02-.01A.5.5 0 0 0 13.5 7h-3a.5.5 0 0 0-.5.5zM5.21 3.09l.91.91h.38a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.29.1"
]);
const $e9fce37105e983ce$export$d50265dc2f40ca8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L4.89 5.6 2.36 8.52q-.35.4-.36.98v3A2.5 2.5 0 0 0 4.5 15h2A2.5 2.5 0 0 0 9 12.5V11h1.3l.7.7v.8a2.5 2.5 0 0 0 2.5 2.5h.8l2.85 2.85a.5.5 0 0 0 .7-.7zM7.3 8H4.14L5.6 6.3zm9.48 6.65L11.1 8.97A1.5 1.5 0 0 1 12.5 8h3.36l-2.29-2.65a1 1 0 0 0-.76-.35H12a.5.5 0 0 1 0-1h.81a2 2 0 0 1 1.52.7l3.2 3.71q.45.43.47 1.09v3c0 .92-.5 1.72-1.23 2.15M6.32 4.2l.8.8H8a.5.5 0 0 0 0-1h-.81a2 2 0 0 0-.87.2"
]);
const $e9fce37105e983ce$export$5dfc92ac21178784 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L4.89 5.6 2.36 8.52q-.35.4-.36.98v3A2.5 2.5 0 0 0 4.5 15h2A2.5 2.5 0 0 0 9 12.5V11h1.3l.7.7v.8a2.5 2.5 0 0 0 2.5 2.5h.8l2.85 2.85a.5.5 0 0 0 .7-.7zM7.3 8H4.14L5.6 6.3zM8 9.5v3c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 12.5v-3c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5m4 .38-.9-.9A1.5 1.5 0 0 1 12.5 8h3.36l-2.29-2.65a1 1 0 0 0-.76-.35H12a.5.5 0 0 1 0-1h.81a2 2 0 0 1 1.52.7l3.2 3.71q.45.43.47 1.09v3c0 .92-.5 1.72-1.23 2.15l-.74-.75c.57-.2.97-.76.97-1.4v-3a.5.5 0 0 0-.12-.33l-.06-.06A.5.5 0 0 0 16.5 9h-4a.5.5 0 0 0-.5.5zM7.12 5l-.8-.8a2 2 0 0 1 .87-.2H8a.5.5 0 0 1 0 1h-.88"
]);
const $e9fce37105e983ce$export$fa13bf909e2d2bad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l3.27 3.27-2.86 3.12-.05.05-.03.06q-.53.6-.55 1.47v3.5C2 16.55 3.46 18 5.25 18h2.5c1.8 0 3.25-1.46 3.25-3.25V12.5h.44L13 14.06v.69c0 1.8 1.46 3.25 3.25 3.25h.69l3.78 3.78a.75.75 0 0 0 1.06-1.06zM7.94 9H5.28l1.27-1.38zm5.36 1.12 7.3 7.3a3.3 3.3 0 0 0 1.4-2.67v-3.5q-.01-.81-.49-1.4l-.12-.18-3.64-3.95-.14-.13C17.2 5.21 16.66 5 16.1 5h-.94a.75.75 0 0 0 .1 1.5h.94q.28.04.45.24L18.73 9h-3.48c-.83 0-1.56.45-1.95 1.12"
]);
const $e9fce37105e983ce$export$21a396a539412287 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l3.27 3.27-2.86 3.12-.05.05-.03.06q-.53.6-.55 1.47v3.5C2 16.55 3.46 18 5.25 18h2.5c1.8 0 3.25-1.46 3.25-3.25V12.5h.44L13 14.06v.69c0 1.8 1.46 3.25 3.25 3.25h.69l3.78 3.78a.75.75 0 0 0 1.06-1.06zM7.94 9H5.28l1.27-1.38zm-3.69 1.5h4.5c.41 0 .75.34.75.75v3.5c0 .96-.78 1.75-1.75 1.75h-2.5c-.97 0-1.75-.79-1.75-1.75v-3.5c0-.41.34-.75.75-.75m9.05-.38 1.2 1.2v-.07c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v3.5c0 .7-.4 1.3-1 1.57l1.1 1.1a3.3 3.3 0 0 0 1.4-2.67v-3.5q-.01-.81-.49-1.4l-.12-.18-3.64-3.95-.14-.13C17.2 5.21 16.66 5 16.1 5h-1.44a.75.75 0 0 0 .1 1.5h1.44q.28.04.45.24L18.73 9h-3.48c-.83 0-1.56.45-1.95 1.12"
]);
const $e9fce37105e983ce$export$e05cfcc0d94f5fa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff28Filled', "28", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.33 4.34-3.58 3.54-.3.28-.02.03c-.4.48-.65 1.1-.65 1.78v4A3.75 3.75 0 0 0 5.75 21h3.5A3.75 3.75 0 0 0 13 17.25v-3h.19L15 16.06v1.19A3.75 3.75 0 0 0 18.75 21h1.19l4.78 4.78a.75.75 0 0 0 1.06-1.06zm6.16 8.28H5.77l1.85-1.82zM9.19 6l1.5 1.5h.06a.75.75 0 0 0 0-1.5H9.19m14.64 14.65-8.57-8.57a2.8 2.8 0 0 1 2.49-1.58h4.48l-2.67-2.64a1.3 1.3 0 0 0-.88-.36h-1.43a.75.75 0 0 1 0-1.5h1.43c.72 0 1.42.28 1.93.8l4.42 4.35.3.3.02.02c.4.48.65 1.1.65 1.78v4c0 1.5-.89 2.8-2.17 3.4"
]);
const $e9fce37105e983ce$export$dcfe9a103fc2f942 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff28Regular', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06L19.94 21h-1.19A3.75 3.75 0 0 1 15 17.25v-1.19l-1.81-1.81H13v3A3.75 3.75 0 0 1 9.25 21h-3.5A3.75 3.75 0 0 1 2 17.25v-4c0-.68.25-1.3.66-1.78l.02-.03q.14-.16.29-.28l3.58-3.54-4.33-4.34a.75.75 0 0 1 0-1.06m5.4 6.46L5.77 10.5h3.67zm-3.84 3.78q-.27.34-.28.79v4c0 1.24 1 2.25 2.25 2.25h3.5c1.24 0 2.25-1 2.25-2.25v-4c0-.69-.56-1.25-1.25-1.25h-5.5q-.45 0-.78.27zm6.9-4.96L9.18 6h1.57a.75.75 0 0 1 0 1.5zm4.58 4.58 1.24 1.24v-.07c0-.69.56-1.25 1.25-1.25h5.5q.45 0 .78.27l.19.2q.27.32.28.78v4c0 1.1-.8 2.03-1.85 2.22l1.18 1.18a3.8 3.8 0 0 0 2.17-3.4v-4c0-.68-.25-1.3-.66-1.78l-.02-.03q-.13-.16-.29-.28l-4.42-4.37c-.51-.5-1.2-.79-1.93-.79h-1.43a.75.75 0 0 0 0 1.5h1.43q.5 0 .88.36l2.67 2.64h-4.48c-1.1 0-2.05.65-2.49 1.58"
]);
const $e9fce37105e983ce$export$8cecfcc4f435bafb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff32Filled', "32", [
    "m22.59 24 5.7 5.7a1 1 0 0 0 1.42-1.4l-26-26a1 1 0 0 0-1.42 1.4l4.43 4.43-3.88 4.52A3.5 3.5 0 0 0 2 14.92v4.58A4.5 4.5 0 0 0 6.5 24h4a4.5 4.5 0 0 0 4.5-4.5V17h.59L17 18.41v1.09a4.5 4.5 0 0 0 4.5 4.5zm-12-12H6.03l2.1-2.45zM27.2 23.67l-9.8-9.8A3.5 3.5 0 0 1 20.5 12h5.47l-2.98-3.48A1.5 1.5 0 0 0 21.85 8H20a1 1 0 1 1 0-2h1.85c1.02 0 2 .45 2.66 1.22l4.65 5.43c.54.63.84 1.44.84 2.27v4.58a4.5 4.5 0 0 1-2.8 4.17M9.58 6.05 11.53 8H12a1 1 0 1 0 0-2h-1.85q-.3 0-.57.05"
]);
const $e9fce37105e983ce$export$45173314694fd73e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff32Regular', "32", [
    "M28.3 29.7 22.58 24H21.5a4.5 4.5 0 0 1-4.5-4.5v-1.09L15.59 17H15v2.5a4.5 4.5 0 0 1-4.5 4.5h-4A4.5 4.5 0 0 1 2 19.5v-4.58c0-.83.3-1.64.84-2.27l3.88-4.52-4.43-4.42a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42M8.12 9.56 6.03 12h4.56zm9.27 4.32 1.6 1.6A1.5 1.5 0 0 1 20.5 14h6c.83 0 1.5.67 1.5 1.5v4a2.5 2.5 0 0 1-2.47 2.5l1.67 1.67A4.5 4.5 0 0 0 30 19.5v-4.58c0-.83-.3-1.64-.84-2.27L24.5 7.22A3.5 3.5 0 0 0 21.85 6H20a1 1 0 1 0 0 2h1.85c.44 0 .85.2 1.14.52L25.97 12H20.5a3.5 3.5 0 0 0-3.1 1.87M11.53 8 9.58 6.05q.29-.05.57-.05H12a1 1 0 1 1 0 2zM13 19.5v-4c0-.83-.67-1.5-1.5-1.5h-6c-.83 0-1.5.67-1.5 1.5v4A2.5 2.5 0 0 0 6.5 22h4a2.5 2.5 0 0 0 2.5-2.5"
]);
const $e9fce37105e983ce$export$9d6e440c8eb9a6fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff48Filled', "48", [
    "m34.23 36 7.64 7.63a1.25 1.25 0 0 0 1.76-1.76L6.13 4.37a1.25 1.25 0 1 0-1.76 1.76l6.83 6.84-5.74 6.21A4.5 4.5 0 0 0 4 22.42v7.08a6.5 6.5 0 0 0 6.5 6.5h5a6.5 6.5 0 0 0 6.5-6.5v-5h.73L26 27.77v1.73a6.5 6.5 0 0 0 6.5 6.5zm-18-18H9.96l3.01-3.26zM44 29.5a6.5 6.5 0 0 1-3.93 5.97L26.1 21.51A4.5 4.5 0 0 1 30.5 18h7.54l-4.57-4.94c-.33-.36-.8-.56-1.28-.56h-2.94a1.25 1.25 0 1 1 0-2.5h2.94c1.18 0 2.31.5 3.12 1.36l7.23 7.82A4.5 4.5 0 0 1 44 22.42zm-25.25-17H17.1l-2.37-2.36q.53-.14 1.08-.14h2.94a1.25 1.25 0 1 1 0 2.5"
]);
const $e9fce37105e983ce$export$8ea02140ec9a81e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlassesOff48Regular', "48", [
    "m34.23 36 7.64 7.63a1.25 1.25 0 0 0 1.76-1.76L6.13 4.37a1.25 1.25 0 1 0-1.76 1.76l6.83 6.84-5.74 6.21A4.5 4.5 0 0 0 4 22.42v7.08a6.5 6.5 0 0 0 6.5 6.5h5a6.5 6.5 0 0 0 6.5-6.5v-5h.73L26 27.77v1.73a6.5 6.5 0 0 0 6.5 6.5zm-18-18H9.96l3.01-3.26zm23.84 17.47A6.5 6.5 0 0 0 44 29.5v-7.08q-.01-1.28-.7-2.35a5 5 0 0 0-.76-.89l-7.23-7.82A4.3 4.3 0 0 0 32.19 10h-2.94a1.25 1.25 0 1 0 0 2.5h2.94c.49 0 .95.2 1.28.56L38.04 18H30.5a4.5 4.5 0 0 0-4.4 3.51l2.4 2.4V22.5c0-1.1.9-2 2-2h9a2 2 0 0 1 1.29.47l.24.27q.09.08.16.2.3.46.31 1.06v7a4 4 0 0 1-3.44 3.96zM14.74 10.14l2.36 2.36h1.65a1.25 1.25 0 1 0 0-2.5h-2.94q-.55 0-1.08.14M17.5 20.5a2 2 0 0 1 2 2v7a4 4 0 0 1-4 4h-5a4 4 0 0 1-4-4v-7a2 2 0 0 1 .3-1.07l.17-.2.24-.26a2 2 0 0 1 1.29-.47z"
]);
const $e9fce37105e983ce$export$c574220aaf4cb206 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone12Filled', "12", [
    "M8.96 1.1A1.5 1.5 0 0 1 11 2.5v6a1.5 1.5 0 0 1-1.96 1.43l-2.06-.66A2 2 0 0 1 3 9V8l-.96-.3A1.5 1.5 0 0 1 1 6.27V5.19c0-.62.38-1.18.96-1.4zM4 8.32V9a1 1 0 0 0 2 0v-.04z"
]);
const $e9fce37105e983ce$export$95d7f0806cfd1d0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone12Regular', "12", [
    "M11 2.5a1.5 1.5 0 0 0-2.04-1.4l-7 2.69A1.5 1.5 0 0 0 1 5.19v1.08c0 .65.42 1.23 1.04 1.43L3 8v1a2 2 0 0 0 3.98.27l2.06.66A1.5 1.5 0 0 0 11 8.5zM6 8.96V9a1 1 0 0 1-2 0v-.68zm3.32-6.92a.5.5 0 0 1 .68.46v6a.5.5 0 0 1-.65.48l-7-2.23A.5.5 0 0 1 2 6.27V5.19c0-.2.13-.4.32-.47z"
]);
const $e9fce37105e983ce$export$813b40fd8a6981aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone16Filled', "16", [
    "M15 3.5c0-1.02-1-1.75-1.98-1.42l-11 3.72A1.5 1.5 0 0 0 1 7.22v1.56c0 .65.4 1.22 1.02 1.42l1.98.68V12a3 3 0 0 0 5.87.87l3.15 1.07A1.5 1.5 0 0 0 15 12.5zM5 11.22l3.92 1.33A2 2 0 0 1 5 12z"
]);
const $e9fce37105e983ce$export$99b8b53c4a645b68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone16Regular', "16", [
    "M15 3.5c0-1.02-1-1.75-1.98-1.42l-11 3.72A1.5 1.5 0 0 0 1 7.22v1.56c0 .65.4 1.22 1.02 1.42l1.98.68V12a3 3 0 0 0 5.87.87l3.15 1.07A1.5 1.5 0 0 0 15 12.5zm-1.66-.47a.5.5 0 0 1 .66.47v9.01a.5.5 0 0 1-.66.48l-11-3.73A.5.5 0 0 1 2 8.78V7.22c0-.22.14-.4.34-.48zm-4.42 9.52A2 2 0 0 1 5 12v-.78z"
]);
const $e9fce37105e983ce$export$1ed112031997531b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone20Filled', "20", [
    "M16.11 3.35A1.5 1.5 0 0 1 18 4.8v10.31c0 1.03-1 1.75-1.97 1.43l-4.76-1.59A3.25 3.25 0 0 1 5 13.75v-.89l-1.97-.66A1.5 1.5 0 0 1 2 10.78V8.27c0-.68.46-1.28 1.11-1.45zM6 13.2v.56a2.25 2.25 0 0 0 4.32.88z"
]);
const $e9fce37105e983ce$export$442808a0e6469c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone20Regular', "20", [
    "M18 4.8c0-.98-.93-1.7-1.89-1.45l-13 3.47A1.5 1.5 0 0 0 2 8.27v2.5c0 .65.41 1.23 1.03 1.43l1.97.66v.89a3.25 3.25 0 0 0 6.27 1.2l4.76 1.59A1.5 1.5 0 0 0 18 15.1zm-7.68 9.83A2.25 2.25 0 0 1 6 13.75v-.56zm6.05-10.31a.5.5 0 0 1 .63.48v10.31a.5.5 0 0 1-.66.48l-13-4.34a.5.5 0 0 1-.34-.47V8.27a.5.5 0 0 1 .37-.48z"
]);
const $e9fce37105e983ce$export$cb9bba5204b36d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone24Filled', "24", [
    "M21.9 5.62q.1.32.1.64v11.48a2.25 2.25 0 0 1-2.9 2.16l-5.5-1.64A4 4 0 0 1 6 16.7V16l-2.4-.71A2.25 2.25 0 0 1 2 13.13v-2.26c0-1 .65-1.87 1.6-2.16l15.5-4.6c1.2-.36 2.45.32 2.8 1.51M7.5 16.44v.06a2.5 2.5 0 0 0 4.62 1.32z"
]);
const $e9fce37105e983ce$export$90c077256d2c6e42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone24Regular', "24", [
    "M21.9 5.62q.1.32.1.64v11.48a2.25 2.25 0 0 1-2.9 2.16l-5.5-1.64A4 4 0 0 1 6 16.7V16l-2.4-.71A2.25 2.25 0 0 1 2 13.13v-2.26c0-1 .65-1.87 1.6-2.16l15.5-4.6c1.2-.36 2.45.32 2.8 1.51M7.5 16.44v.06a2.5 2.5 0 0 0 4.62 1.32zm12.04-10.9-15.5 4.61a.75.75 0 0 0-.54.72v2.26c0 .33.22.63.54.72l15.5 4.6a.75.75 0 0 0 .96-.71V6.26a.75.75 0 0 0-.96-.72"
]);
const $e9fce37105e983ce$export$252a474a035a88f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone28Filled', "28", [
    "M26 7.35c0-1.8-1.71-3.12-3.46-2.65L4.04 9.63A2.75 2.75 0 0 0 2 12.29v3.42c0 1.25.84 2.34 2.05 2.66l2.95.79v.34a4.5 4.5 0 0 0 8.56 1.94l6.98 1.86A2.75 2.75 0 0 0 26 20.65zM8.5 19.55l5.57 1.5a3 3 0 0 1-5.57-1.5"
]);
const $e9fce37105e983ce$export$dd1cc08106efd4b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Megaphone28Regular', "28", [
    "M26 7.35c0-1.8-1.71-3.12-3.46-2.65L4.04 9.63A2.75 2.75 0 0 0 2 12.29v3.42c0 1.25.84 2.34 2.05 2.66l2.95.79v.34a4.5 4.5 0 0 0 8.56 1.94l6.98 1.86A2.75 2.75 0 0 0 26 20.65zm-3.07-1.2c.8-.22 1.57.38 1.57 1.2v13.3c0 .82-.78 1.42-1.57 1.2l-18.5-4.93a1.25 1.25 0 0 1-.93-1.2v-3.43c0-.57.38-1.07.93-1.21zm-8.86 14.9a3 3 0 0 1-5.57-1.5z"
]);
const $e9fce37105e983ce$export$c61378216361bdc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneCircle20Filled', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M7 12.02l-1.17-.42c-.5-.17-.83-.64-.83-1.17v-.85c0-.53.33-1 .83-1.18l6.5-2.33c.81-.29 1.67.32 1.67 1.18v5.5c0 .87-.86 1.47-1.67 1.18l-1.38-.5A2 2 0 0 1 7 13zm3 1.07A1 1 0 0 1 8 13v-.62z"
]);
const $e9fce37105e983ce$export$2d69d9e405c4e508 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneCircle20Regular', "20", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5 2.02-1.17-.42c-.5-.17-.83-.64-.83-1.17v-.85c0-.53.33-1 .83-1.18l6.5-2.33c.81-.29 1.67.32 1.67 1.18v5.5c0 .87-.86 1.47-1.67 1.18l-1.38-.5A2 2 0 0 1 7 13zm3 1.07-2-.7V13a1 1 0 0 0 2 .1m2.67-6.07-6.5 2.32a.3.3 0 0 0-.17.24v.85q.01.17.17.23l6.5 2.33c.16.06.33-.06.33-.24v-5.5c0-.17-.17-.3-.33-.23"
]);
const $e9fce37105e983ce$export$d58f99e6a8b0ed1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneCircle24Filled', "24", [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20m-4-7.57-.86-.31A1.75 1.75 0 0 1 6 12.47v-.95c0-.73.45-1.38 1.14-1.64l7.5-2.77A1.75 1.75 0 0 1 17 8.75v6.5a1.75 1.75 0 0 1-2.36 1.64l-1.43-.53A2.63 2.63 0 0 1 8 15.88zm3.75 1.4v.04a1.13 1.13 0 0 1-2.25 0V15z"
]);
const $e9fce37105e983ce$export$3aeeb00783b9c18d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneCircle24Regular', "24", [
    "M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m2.64 5.1A1.75 1.75 0 0 1 17 8.76v6.5a1.75 1.75 0 0 1-2.36 1.64l-1.56-.58A2.63 2.63 0 0 1 8 15.38v-.95l-.86-.31A1.75 1.75 0 0 1 6 12.47v-.95c0-.73.45-1.38 1.14-1.64zM9.5 15v.38a1.13 1.13 0 0 0 2.17.42zm6-6.24c0-.18-.18-.3-.34-.24l-7.5 2.78a.3.3 0 0 0-.16.23v.95q0 .16.16.24l7.5 2.77c.16.06.34-.06.34-.23z"
]);
const $e9fce37105e983ce$export$e22549f674efb1a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_16_color__a)",
            "fillRule": "evenodd",
            "d": "M5 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_16_color__b)",
            "fillOpacity": ".8",
            "fillRule": "evenodd",
            "d": "M5 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_16_color__c)",
            "d": "M2.81 13.6c.41.4 1.03.51 1.56.28l8.8-3.9a1.4 1.4 0 0 0 .42-2.26L8.26 2.41a1.4 1.4 0 0 0-2.27.43l-3.87 8.8a1.4 1.4 0 0 0 .29 1.55z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_16_color__d)",
            "fillOpacity": ".8",
            "d": "M2.81 13.6c.41.4 1.03.51 1.56.28l8.8-3.9a1.4 1.4 0 0 0 .42-2.26L8.26 2.41a1.4 1.4 0 0 0-2.27.43l-3.87 8.8a1.4 1.4 0 0 0 .29 1.55z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_16_color__e)",
            "d": "M10.87 1.01a.5.5 0 0 1 .37.61l-.25 1a.5.5 0 1 1-.97-.24l.24-1a.5.5 0 0 1 .61-.37m2.98 1.14c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0M14.5 5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_16_color__a",
                "x1": "12.29",
                "x2": "9.7",
                "y1": "18.86",
                "y2": "12.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0c74a1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_16_color__b",
                "x1": "6.71",
                "x2": "9.29",
                "y1": "9.86",
                "y2": "16.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".08",
                    "stopColor": "#e362f8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".66",
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_16_color__c",
                "x1": "2.43",
                "x2": "10.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1384b1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_16_color__d",
                "x1": "8",
                "x2": "13.25",
                "y1": "8.75",
                "y2": "17.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-45 15.91 -.2)scale(15.2297 15.2403)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$70d255c92e1a66e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud16Filled', "16", [
    "M10.87 1.02a.5.5 0 0 1 .37.6l-.25 1a.5.5 0 1 1-.97-.24l.24-1a.5.5 0 0 1 .61-.36m2.98 1.13c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0M6.28 13.03a2 2 0 0 0 3.63-1.6zm-.92.4-1 .45a1.4 1.4 0 0 1-1.55-.29l-.4-.4a1.4 1.4 0 0 1-.3-1.55L6 2.84a1.4 1.4 0 0 1 2.27-.43l5.33 5.31c.7.7.48 1.87-.42 2.27l-2.34 1.03a3 3 0 0 1-5.47 2.42M14.5 5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1"
]);
const $e9fce37105e983ce$export$d7da0075824dd634 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud16Regular', "16", [
    "M10.87 1.02a.5.5 0 0 1 .37.6l-.25 1a.5.5 0 1 1-.97-.24l.24-1a.5.5 0 0 1 .61-.36m2.98 1.13c.2.2.2.5 0 .7l-1 1a.5.5 0 1 1-.7-.7l1-1c.2-.2.5-.2.7 0M6.28 13.03a2 2 0 0 0 3.63-1.6zm-.92.4-1 .45a1.4 1.4 0 0 1-1.55-.29l-.4-.4a1.4 1.4 0 0 1-.3-1.55L6 2.84a1.4 1.4 0 0 1 2.27-.43l5.33 5.31c.7.7.48 1.87-.42 2.27l-2.34 1.03a3 3 0 0 1-5.47 2.42M14.5 5h-1a.5.5 0 0 0 0 1h1a.5.5 0 1 0 0-1M6.9 3.24l-3.87 8.8a.4.4 0 0 0 .09.44l.4.4c.11.12.29.15.44.09l8.8-3.9a.4.4 0 0 0 .12-.64L7.55 3.12a.4.4 0 0 0-.65.12"
]);
const $e9fce37105e983ce$export$7142bcc868c8fcbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__a)",
            "fillRule": "evenodd",
            "d": "M6 15.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__b)",
            "fillOpacity": ".8",
            "fillRule": "evenodd",
            "d": "M6 15.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__c)",
            "d": "M7.6 3.15a2 2 0 0 1 3.27-.52l6.58 6.98a2 2 0 0 1-.64 3.2L5.32 17.87a1.5 1.5 0 0 1-1.66-.3l-1.22-1.22a1.5 1.5 0 0 1-.3-1.7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__d)",
            "fillOpacity": ".8",
            "d": "M7.6 3.15a2 2 0 0 1 3.27-.52l6.58 6.98a2 2 0 0 1-.64 3.2L5.32 17.87a1.5 1.5 0 0 1-1.66-.3l-1.22-1.22a1.5 1.5 0 0 1-.3-1.7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__e)",
            "d": "M14.71 1.74a.75.75 0 0 0-1.42-.48l-.5 1.5a.75.75 0 1 0 1.42.48z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__f)",
            "d": "M18.03 3.03a.75.75 0 0 0-1.06-1.06l-2 2a.75.75 0 0 0 1.06 1.06z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_20_color__g)",
            "d": "M17 5.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__a",
                "x1": "14.5",
                "x2": "11.49",
                "y1": "23.5",
                "y2": "16.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0c74a1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__b",
                "x1": "8",
                "x2": "11",
                "y1": "13",
                "y2": "20.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".08",
                    "stopColor": "#e362f8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".66",
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__c",
                "x1": "2.57",
                "x2": "13.61",
                "y1": "5",
                "y2": "16.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1384b1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__d",
                "x1": "10",
                "x2": "17",
                "y1": "11",
                "y2": "22.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(14 -14 14.00977 14.00977 6 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(14 -14 14.00977 14.00977 6 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(14 -14 14.00977 14.00977 6 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$4ee5eed7cb994e15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud20Filled', "20", [
    "M14.16 1.03c.26.08.4.37.31.63l-.5 1.5a.5.5 0 0 1-.94-.32l.5-1.5a.5.5 0 0 1 .63-.31m3.7 1.82a.5.5 0 1 0-.71-.7l-2 2a.5.5 0 0 0 .7.7zm-10.25.3a2 2 0 0 1 3.26-.52l6.58 6.98a2 2 0 0 1-.64 3.2l-3.94 1.74a3.5 3.5 0 0 1-6.34 2.8l-1.2.52a1.5 1.5 0 0 1-1.67-.3l-1.22-1.22a1.5 1.5 0 0 1-.3-1.7zm-.16 13.78a2.5 2.5 0 0 0 4.5-1.97zM17 6a.5.5 0 0 0 0 1h1.5a.5.5 0 1 0 0-1z"
]);
const $e9fce37105e983ce$export$bdabc207eda2c465 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud20Regular', "20", [
    "M14.16 1.03c.26.08.4.37.31.63l-.5 1.5a.5.5 0 0 1-.94-.32l.5-1.5a.5.5 0 0 1 .63-.31m3.7 1.82a.5.5 0 1 0-.71-.7l-2 2a.5.5 0 0 0 .7.7zm-10.25.3a2 2 0 0 1 3.26-.52l6.58 6.98a2 2 0 0 1-.64 3.2l-3.94 1.74a3.5 3.5 0 0 1-6.34 2.8l-1.2.52a1.5 1.5 0 0 1-1.67-.3l-1.22-1.22a1.5 1.5 0 0 1-.3-1.7zm-.16 13.78a2.5 2.5 0 0 0 4.5-1.97zm2.7-13.61a1 1 0 0 0-1.64.25l-5.46 11.5a.5.5 0 0 0 .1.57l1.22 1.21a.5.5 0 0 0 .55.1L16.4 11.9a1 1 0 0 0 .33-1.6zM17 6a.5.5 0 0 0 0 1h1.5a.5.5 0 1 0 0-1z"
]);
const $e9fce37105e983ce$export$afb81c3a3a11d896 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_24_color__a)",
            "fillRule": "evenodd",
            "d": "M8 18a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_24_color__b)",
            "fillOpacity": ".8",
            "fillRule": "evenodd",
            "d": "M8 18a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_24_color__c)",
            "d": "M9.08 4.32a2.33 2.33 0 0 1 3.8-.58l7 7.5c1.09 1.18.7 3.07-.76 3.72L6.97 20.34A1.8 1.8 0 0 1 5 20.01l-1.43-1.36a1.8 1.8 0 0 1-.4-2.1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_24_color__d)",
            "fillOpacity": ".8",
            "d": "M9.08 4.32a2.33 2.33 0 0 1 3.8-.58l7 7.5c1.09 1.18.7 3.07-.76 3.72L6.97 20.34A1.8 1.8 0 0 1 5 20.01l-1.43-1.36a1.8 1.8 0 0 1-.4-2.1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_24_color__e)",
            "d": "M17.21 2.24a.75.75 0 0 0-1.42-.48l-.75 2.25a.75.75 0 0 0 1.42.48zm4.57-.02c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0M19 8.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_24_color__a",
                "x1": "17.71",
                "x2": "14.27",
                "y1": "27.14",
                "y2": "18.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0c74a1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_24_color__b",
                "x1": "10.29",
                "x2": "13.72",
                "y1": "15.14",
                "y2": "23.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".08",
                    "stopColor": "#e362f8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".66",
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_24_color__c",
                "x1": "3.63",
                "x2": "15.7",
                "y1": "6.28",
                "y2": "18.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1384b1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_24_color__d",
                "x1": "11.75",
                "x2": "19.41",
                "y1": "12.84",
                "y2": "25.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-45.94 23.72 .02)scale(23.2273 23.231)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$96551d3e50debc07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud24Filled', "24", [
    "M17.21 2.24a.75.75 0 0 0-1.42-.48l-.75 2.25a.75.75 0 0 0 1.42.48zm4.57-.02c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0m-8.9 1.52a2.33 2.33 0 0 0-3.8.58l-5.9 12.24a1.8 1.8 0 0 0 .39 2.09L5 20.01c.53.5 1.3.63 1.97.33l1.42-.63a4 4 0 0 0 7.3-3.24l3.43-1.51a2.33 2.33 0 0 0 .76-3.71zm1.45 13.34a2.5 2.5 0 0 1-4.57 2.03zM19 8.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75"
]);
const $e9fce37105e983ce$export$4478fc3306f37273 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud24Regular', "24", [
    "M17.21 2.24a.75.75 0 0 0-1.42-.48l-.75 2.25a.75.75 0 0 0 1.42.48zm4.57-.02c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0m-12.7 2.1a2.33 2.33 0 0 1 3.8-.58l7 7.5c1.09 1.18.7 3.07-.76 3.72l-3.42 1.51A4 4 0 0 1 12 22a4 4 0 0 1-3.61-2.29l-1.42.63A1.8 1.8 0 0 1 5 20.01l-1.43-1.36a1.8 1.8 0 0 1-.4-2.1zm.68 14.79a2.5 2.5 0 0 0 4.57-2.03zm2.01-14.35a.83.83 0 0 0-1.34.2l-5.9 12.25a.3.3 0 0 0 .06.35l1.44 1.36q.16.12.33.05l12.15-5.38c.52-.23.66-.9.27-1.32zM19 8.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75"
]);
const $e9fce37105e983ce$export$fec0254fcee53480 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_28_color__a)",
            "fillRule": "evenodd",
            "d": "M10 21.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_28_color__b)",
            "fillOpacity": ".8",
            "fillRule": "evenodd",
            "d": "M10 21.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_28_color__c)",
            "d": "M5 24.2a2.75 2.75 0 0 0 3.17.5l14.31-7.15a2.75 2.75 0 0 0 .71-4.4l-8.34-8.34a2.75 2.75 0 0 0-4.4.71L3.29 19.83A2.75 2.75 0 0 0 3.81 23z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_28_color__d)",
            "fillOpacity": ".8",
            "d": "M5 24.2a2.75 2.75 0 0 0 3.17.5l14.31-7.15a2.75 2.75 0 0 0 .71-4.4l-8.34-8.34a2.75 2.75 0 0 0-4.4.71L3.29 19.83A2.75 2.75 0 0 0 3.81 23z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_28_color__e)",
            "d": "M17.53 4.47a.75.75 0 0 0 1.44.38l.65-2.41a.75.75 0 0 0-1.45-.39zm7.25-1.25c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0M22.5 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_28_color__a",
                "x1": "20.93",
                "x2": "17.05",
                "y1": "31.79",
                "y2": "22.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0c74a1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_28_color__b",
                "x1": "12.57",
                "x2": "16.43",
                "y1": "18.29",
                "y2": "27.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".08",
                    "stopColor": "#e362f8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".66",
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_28_color__c",
                "x1": "3.75",
                "x2": "18.24",
                "y1": "7.94",
                "y2": "22.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1384b1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_28_color__d",
                "x1": "13.5",
                "x2": "22.69",
                "y1": "15.81",
                "y2": "30.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_28_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-45.02 28.03 .09)scale(27.4241 27.4432)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$3f88db41960d636 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud28Filled', "28", [
    "M17.53 4.47a.75.75 0 1 0 1.44.38l.65-2.41a.75.75 0 1 0-1.45-.39zm7.25-1.25c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0M22.5 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75M14.25 26a4.8 4.8 0 0 1-4.07-2.3l-2 1.01A2.75 2.75 0 0 1 5 24.19L3.8 23a2.75 2.75 0 0 1-.5-3.17l7.15-14.3a2.75 2.75 0 0 1 4.4-.72l8.34 8.34a2.75 2.75 0 0 1-.71 4.4l-3.83 1.92a4.74 4.74 0 0 1-4.4 6.53m3.06-5.86-5.78 2.89a3.25 3.25 0 0 0 5.78-2.89"
]);
const $e9fce37105e983ce$export$631227b1dee60ca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud28Regular', "28", [
    "M17.53 4.47a.75.75 0 1 0 1.44.38l.65-2.41a.75.75 0 1 0-1.45-.39zm7.25-1.25c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0M10.18 23.7a4.75 4.75 0 0 0 8.47-4.23l3.83-1.91a2.75 2.75 0 0 0 .71-4.4L14.85 4.8a2.75 2.75 0 0 0-4.4.71L3.29 19.83A2.75 2.75 0 0 0 3.81 23L5 24.2a2.75 2.75 0 0 0 3.17.5zm1.35-.67 5.78-2.89a3.24 3.24 0 0 1-3.06 4.36 3.3 3.3 0 0 1-2.72-1.47m.26-16.84c.38-.76 1.4-.93 2-.32l8.34 8.34c.6.6.44 1.62-.32 2L7.5 23.37c-.48.24-1.06.14-1.44-.24l-1.2-1.19a1.25 1.25 0 0 1-.23-1.44zM22.5 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
]);
const $e9fce37105e983ce$export$176d9ea2bf588dfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_32_color__a)",
            "fillRule": "evenodd",
            "d": "M11 24.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m5.5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_32_color__b)",
            "fillOpacity": ".8",
            "fillRule": "evenodd",
            "d": "M11 24.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m5.5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_32_color__c)",
            "d": "M27.12 15.24a3 3 0 0 1-.78 4.8L9.06 28.68a3 3 0 0 1-3.46-.56L3.88 26.4a3 3 0 0 1-.56-3.46l8.64-17.28a3 3 0 0 1 4.8-.78z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_32_color__d)",
            "fillOpacity": ".8",
            "d": "M27.12 15.24a3 3 0 0 1-.78 4.8L9.06 28.68a3 3 0 0 1-3.46-.56L3.88 26.4a3 3 0 0 1-.56-3.46l8.64-17.28a3 3 0 0 1 4.8-.78z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_megaphone_loud_32_color__e)",
            "d": "M20.72 5.99a1 1 0 0 1-.68-1.24l.83-2.88a1 1 0 0 1 1.92.55l-.83 2.88a1 1 0 0 1-1.24.69m7.99-2.7a1 1 0 0 1 0 1.42l-3 3a1 1 0 1 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0M27 10a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_32_color__a",
                "x1": "24.36",
                "x2": "19.62",
                "y1": "37.07",
                "y2": "25.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0c74a1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_32_color__b",
                "x1": "14.14",
                "x2": "18.86",
                "y1": "20.57",
                "y2": "32.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".08",
                    "stopColor": "#e362f8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".66",
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_32_color__c",
                "x1": "3.89",
                "x2": "21.15",
                "y1": "8.69",
                "y2": "26.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1384b1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_megaphone_loud_32_color__d",
                "x1": "15.5",
                "x2": "26.44",
                "y1": "18.06",
                "y2": "36.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#96f",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_megaphone_loud_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-44.63 32.65 1.2)scale(33.2915 33.3119)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".62",
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#ffa43d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $e9fce37105e983ce$export$5927a2631b7d03c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud32Filled', "32", [
    "M20.72 5.99a1 1 0 0 1-.68-1.24l.83-2.88a1 1 0 1 1 1.92.55l-.83 2.88a1 1 0 0 1-1.24.69m7.99-2.7a1 1 0 0 1 0 1.42l-3 3a1 1 0 1 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0m-7.12 19.13 4.75-2.38a3 3 0 0 0 .78-4.8L16.76 4.88a3 3 0 0 0-4.8.78L3.32 22.94a3 3 0 0 0 .56 3.46l1.72 1.72a3 3 0 0 0 3.46.56l2.72-1.36a5.5 5.5 0 0 0 9.81-4.9m-1.8.9a3.5 3.5 0 0 1-6.21 3.1zM27 10a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2z"
]);
const $e9fce37105e983ce$export$7429e545ff99dc6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud32Regular', "32", [
    "M20.04 4.75a1 1 0 0 0 1.92.55l.83-2.88a1 1 0 1 0-1.92-.55zM28.7 3.3a1 1 0 0 1 0 1.42l-3 3a1 1 0 1 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0M26 11a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2h-3a1 1 0 0 1-1-1M11.96 5.66a3 3 0 0 1 4.8-.78l10.36 10.36a3 3 0 0 1-.78 4.8l-4.75 2.38A5.48 5.48 0 0 1 16.5 30a5.5 5.5 0 0 1-4.72-2.68l-2.72 1.36a3 3 0 0 1-3.46-.56L3.88 26.4a3 3 0 0 1-.56-3.46zm1.62 20.77a3.5 3.5 0 0 0 6.21-3.11zm1.77-20.14a1 1 0 0 0-1.6.26L5.1 23.83A1 1 0 0 0 5.29 25l1.72 1.72a1 1 0 0 0 1.16.18l17.28-8.64a1 1 0 0 0 .26-1.6z"
]);
const $e9fce37105e983ce$export$76104963697d9fed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud48Filled', "48", [
    "M18.62 8.44a4.25 4.25 0 0 1 6.7-.81l14.6 14.96.19.2a4.25 4.25 0 0 1-1.2 6.5l-.24.13-7.2 3.31q.52 1.3.53 2.77a7.5 7.5 0 0 1-14.13 3.51l-3.46 1.6c-1.5.7-3.27.44-4.52-.62l-.25-.22-2.37-2.35a4.25 4.25 0 0 1-.8-4.93l12.02-23.8zm1.53 29.52a5 5 0 0 0 9.05-4.18zM45.25 15a1.25 1.25 0 0 1 0 2.5h-5a1.25 1.25 0 0 1 0-2.5zm-4.38-9.63a1.25 1.25 0 0 1 1.76 1.76l-4.5 4.5a1.25 1.25 0 1 1-1.76-1.76zM31.6 2.74a1.25 1.25 0 0 1 2.36.78l-.03.13-1.5 4.5a1.25 1.25 0 0 1-2.38-.8l1.5-4.5z"
]);
const $e9fce37105e983ce$export$9d62b243c282d358 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneLoud48Regular', "48", [
    "M18.62 8.44a4.25 4.25 0 0 1 6.7-.81l14.6 14.96a4.25 4.25 0 0 1-1.25 6.82l-7.2 3.33q.52 1.28.53 2.76a7.5 7.5 0 0 1-14.13 3.51l-3.46 1.6c-1.5.7-3.27.44-4.52-.62l-.25-.22-2.37-2.35a4.25 4.25 0 0 1-.8-4.93l12.02-23.8zm1.52 29.52a5 5 0 0 0 9.05-4.17zm3.4-28.58c-.79-.8-2.1-.66-2.7.24l-.12.19L8.7 33.61c-.35.68-.21 1.5.33 2.04l2.37 2.34.1.1c.52.43 1.24.53 1.86.25l24.26-11.2.2-.1c.92-.58 1.1-1.9.32-2.7zM45.25 15a1.25 1.25 0 0 1 0 2.5h-5a1.25 1.25 0 0 1 0-2.5zm-4.38-9.63a1.25 1.25 0 0 1 1.76 1.76l-4.5 4.5a1.25 1.25 0 1 1-1.76-1.76zM31.6 2.74a1.25 1.25 0 0 1 2.36.78l-.03.13-1.5 4.5a1.25 1.25 0 0 1-2.38-.8l1.5-4.5z"
]);
const $e9fce37105e983ce$export$a954a8f26cc26d30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff16Filled', "16", [
    "m13.3 14 .85.85a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L4.3 5.02l-2.29.78A1.5 1.5 0 0 0 1 7.22v1.56c0 .65.4 1.22 1.02 1.42l1.98.68V12a3 3 0 0 0 5.87.87l3.15 1.07zM5 11.22l3.92 1.33A2 2 0 0 1 5 12zm10 1.3q0 .16-.04.32L6.43 4.31l6.59-2.23A1.5 1.5 0 0 1 15 3.5z"
]);
const $e9fce37105e983ce$export$d7feda06c31b2880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff16Regular', "16", [
    "m13.3 14 .85.85a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L4.3 5.02l-2.29.78A1.5 1.5 0 0 0 1 7.22v1.56c0 .65.4 1.22 1.02 1.42l1.98.68V12a3 3 0 0 0 5.87.87l3.15 1.07zm-1.56-1.55-9.4-3.2A.5.5 0 0 1 2 8.79V7.22c0-.22.14-.4.34-.48l2.76-.93zm-2.82.1A2 2 0 0 1 5 12v-.78zM14 3.5v8.38l.96.96q.04-.15.04-.33v-9c0-1.03-1-1.76-1.98-1.43l-6.6 2.23.8.79 6.12-2.07a.5.5 0 0 1 .66.47"
]);
const $e9fce37105e983ce$export$66ce851239623cc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L5.48 6.2l-2.37.63A1.5 1.5 0 0 0 2 8.27v2.5c0 .65.41 1.23 1.03 1.43l1.97.66v.89a3.25 3.25 0 0 0 6.27 1.2l4.46 1.49 1.42 1.41a.5.5 0 0 0 .7-.7zM6 13.19l4.32 1.44A2.25 2.25 0 0 1 6 13.75zm12 1.92q0 .34-.14.63L7.71 5.6l8.4-2.24A1.5 1.5 0 0 1 18 4.8z"
]);
const $e9fce37105e983ce$export$97befde6f17539f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L5.48 6.2l-2.37.63A1.5 1.5 0 0 0 2 8.27v2.5c0 .65.41 1.23 1.03 1.43l1.97.66v.89a3.25 3.25 0 0 0 6.27 1.2l4.46 1.49 1.42 1.41a.5.5 0 0 0 .7-.7zm11.3 12.7-10.8-3.6a.5.5 0 0 1-.35-.47V8.27a.5.5 0 0 1 .37-.48L6.3 7zm-3.83-.22A2.25 2.25 0 0 1 6 13.75v-.56zM17 4.8v10.08l.86.86q.14-.29.14-.63V4.81c0-1-.93-1.71-1.89-1.46L7.71 5.6l.82.82 7.84-2.1a.5.5 0 0 1 .63.5"
]);
const $e9fce37105e983ce$export$1fcb8a2bba02f390 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.5 4.5-3.11.93A2.25 2.25 0 0 0 2 10.87v2.26c0 1 .65 1.87 1.6 2.16l2.4.7v.7a4 4 0 0 0 7.6 1.57l5.12 1.52 2 2a.75.75 0 0 0 1.06-1.06zM7.5 16.44l4.62 1.38A2.5 2.5 0 0 1 7.5 16.5zm14.5 1.3q0 .48-.18.9L10 6.8l9.1-2.7A2.25 2.25 0 0 1 22 6.26z"
]);
const $e9fce37105e983ce$export$9297e367a7b7d1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.5 4.5-3.11.93A2.25 2.25 0 0 0 2 10.87v2.26c0 1 .65 1.87 1.6 2.16l2.4.7v.7a4 4 0 0 0 7.6 1.57l5.12 1.52 2 2a.75.75 0 0 0 1.06-1.06zm13.21 15.33-12.45-3.7a.75.75 0 0 1-.54-.72v-2.26c0-.33.22-.63.54-.72l3.9-1.16zm-9-1.1 4.63 1.37A2.5 2.5 0 0 1 7.5 16.5zM20.5 6.25v11.06l1.32 1.31q.17-.4.18-.9V6.27a2.25 2.25 0 0 0-2.9-2.15L10 6.8l1.2 1.21 8.34-2.48a.75.75 0 0 1 .96.72"
]);
const $e9fce37105e983ce$export$24c5a9a646844a2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff28Filled', "28", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l5.4 5.4-3.57.95A2.75 2.75 0 0 0 2 12.29v3.42c0 1.25.84 2.34 2.05 2.66l2.95.79v.34a4.5 4.5 0 0 0 8.56 1.94l6.57 1.76 2.59 2.58a.75.75 0 0 0 1.06-1.06zM8.5 19.56l5.57 1.48a3 3 0 0 1-5.57-1.48m2.47-11.78 14.5 14.5q.51-.69.53-1.63V7.35c0-1.8-1.71-3.12-3.46-2.65z"
]);
const $e9fce37105e983ce$export$a3de5cc39e7f912c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MegaphoneOff28Regular', "28", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l5.4 5.4-3.57.95A2.75 2.75 0 0 0 2 12.29v3.42c0 1.25.84 2.34 2.05 2.66l2.95.79v.34a4.5 4.5 0 0 0 8.56 1.94l6.57 1.75 2.59 2.59a.75.75 0 0 0 1.06-1.06zm16.74 18.86L4.43 16.92a1.25 1.25 0 0 1-.93-1.2v-3.43c0-.57.39-1.07.93-1.21L8.84 9.9zm-5.95-.04a3 3 0 0 1-5.57-1.48zm-3.1-13.26 1.22 1.23 10.74-2.86c.8-.22 1.57.38 1.57 1.2v13.3q0 .3-.12.54l1.08 1.1q.52-.7.54-1.64V7.35c0-1.8-1.71-3.12-3.46-2.65z"
]);
const $e9fce37105e983ce$export$1ada2866daba69e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Merge16Filled', "16", [
    "M2 4.25c0-.41.34-.75.75-.75h1.79c.83 0 1.62.38 2.15 1.03l1.5 1.88c.42.53 1.07.84 1.75.84h1.79l-1.57-2.04a.75.75 0 0 1 1.18-.92l2.5 3.25c.21.27.21.65 0 .92l-2.5 3.25a.75.75 0 0 1-1.18-.92l1.57-2.04H9.7c-.38 0-.74.17-.97.47l-1.5 1.87A3.8 3.8 0 0 1 4.3 12.5H2.75a.75.75 0 0 1 0-1.5h1.56c.68 0 1.33-.31 1.76-.84l1.5-1.88.2-.22q-.43-.3-.76-.72l-1.5-1.87c-.23-.3-.6-.47-.97-.47H2.75A.75.75 0 0 1 2 4.25"
]);
const $e9fce37105e983ce$export$975b508a0ea0a1e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Merge16Regular', "16", [
    "M11.5 7.5H9.88a2.5 2.5 0 0 1-1.9-.87l-1.5-1.76A2.5 2.5 0 0 0 4.58 4H2.5a.5.5 0 0 0 0 1h2.08c.44 0 .85.2 1.14.52l1.5 1.76q.38.44.86.72-.48.3-.86.72l-1.5 1.76c-.29.33-.7.52-1.14.52H2.5a.5.5 0 0 0 0 1h2.08a2.5 2.5 0 0 0 1.9-.87l1.5-1.76a2.5 2.5 0 0 1 1.9-.87h2.53l-2.29 2.67a.5.5 0 1 0 .76.66l3-3.5a.5.5 0 0 0 0-.66l-3-3.5a.5.5 0 1 0-.76.66l2.3 2.67z"
]);
const $e9fce37105e983ce$export$2d7b58c4f5c8a9be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Merge20Filled', "20", [
    "M3 5.75c0-.41.34-.75.75-.75h1.76c1 0 1.95.4 2.65 1.1l2.5 2.5c.41.41.99.65 1.58.65h3.2l-2.97-2.97a.75.75 0 0 1 1.06-1.06l4.25 4.25c.3.3.3.77 0 1.06l-4.25 4.25a.75.75 0 1 1-1.06-1.06l2.97-2.97h-3.2c-.6 0-1.17.24-1.59.66l-2.5 2.5C7.46 14.6 6.5 15 5.52 15H3.75a.75.75 0 0 1 0-1.5h1.76c.6 0 1.17-.24 1.59-.66l2.5-2.5q.18-.18.4-.34-.22-.15-.4-.35l-2.5-2.5c-.42-.41-1-.65-1.6-.65H3.76A.75.75 0 0 1 3 5.75"
]);
const $e9fce37105e983ce$export$fb8e46481f7476f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Merge20Regular', "20", [
    "M3 5.5c0-.28.22-.5.5-.5h1.65c1 0 1.95.43 2.62 1.17l2.2 2.5a2.5 2.5 0 0 0 1.88.83h4.44l-3.64-3.65a.5.5 0 0 1 .7-.7l4.5 4.5c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 0 1-.7-.7l3.64-3.65h-4.44c-.72 0-1.4.3-1.87.84l-2.21 2.49A3.5 3.5 0 0 1 5.15 15H3.5a.5.5 0 0 1 0-1h1.65c.72 0 1.4-.3 1.87-.84l2.21-2.49q.36-.4.81-.67a4 4 0 0 1-.8-.67l-2.22-2.5A2.5 2.5 0 0 0 5.15 6H3.5a.5.5 0 0 1-.5-.5"
]);
const $e9fce37105e983ce$export$5c1bf37c6c6a2880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Merge24Filled', "24", [
    "M3 7a1 1 0 0 1 1-1h2.76a4 4 0 0 1 2.83 1.17l2.95 2.95a3 3 0 0 0 2.12.88h3.92L15.3 7.71a1 1 0 0 1 1.42-1.41l5 5a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.42-1.4l3.3-3.3h-3.97a3 3 0 0 0-2.08.88l-2.95 2.95A4 4 0 0 1 6.76 18H4a1 1 0 1 1 0-2h2.76a2 2 0 0 0 1.41-.59l2.95-2.95a5 5 0 0 1 .54-.46 5 5 0 0 1-.54-.46L8.17 8.59A2 2 0 0 0 6.76 8H4a1 1 0 0 1-1-1"
]);
const $e9fce37105e983ce$export$73f563e8682b04fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Merge24Regular', "24", [
    "M3 6.75c0-.41.34-.75.75-.75h3.26c1 0 1.95.4 2.65 1.1l2.95 2.95c.6.6 1.43.95 2.3.95h4.53l-3.72-3.72a.75.75 0 1 1 1.06-1.06l5 5c.3.3.3.77 0 1.06l-5 5a.75.75 0 1 1-1.06-1.06l3.72-3.72h-4.47c-.9 0-1.75.37-2.36 1.01l-2.68 2.82c-.7.75-1.69 1.17-2.72 1.17H3.75a.75.75 0 0 1 0-1.5h3.46c.62 0 1.2-.25 1.63-.7l2.68-2.82q.4-.4.86-.71-.45-.28-.83-.66L8.6 8.16c-.42-.42-1-.66-1.6-.66H3.76A.75.75 0 0 1 3 6.75"
]);
const $e9fce37105e983ce$export$ea836d802cf716e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation12Filled', "12", [
    "M6 7.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m.75-5.68a4 4 0 0 1 3.18 3.18h1.32a.75.75 0 0 1 0 1.5H9.93a4 4 0 0 1-3.18 3.18v1.32a.75.75 0 0 1-1.5 0V9.93a4 4 0 0 1-3.18-3.18H.75a.75.75 0 0 1 0-1.5h1.32a4 4 0 0 1 3.18-3.18V.75a.75.75 0 0 1 1.5 0zM8.5 6a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0",
    "M0 0h12v12H0z"
]);
const $e9fce37105e983ce$export$e27f37e92de26d1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation12Regular', "12", [
    "M6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-.5-5.97V.5a.5.5 0 0 1 1 0v1.53A4 4 0 0 1 9.97 5.5h1.53a.5.5 0 0 1 0 1H9.97A4 4 0 0 1 6.5 9.97v1.53a.5.5 0 0 1-1 0V9.97A4 4 0 0 1 2.03 6.5H.5a.5.5 0 0 1 0-1h1.53A4 4 0 0 1 5.5 2.03M3 6a3 3 0 1 0 6 0 3 3 0 0 0-6 0",
    "M0 0h12v12H0z"
]);
const $e9fce37105e983ce$export$4f531192bdf71374 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation16Filled', "16", [
    "M8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m.75-8.75a.75.75 0 0 0-1.5 0v1.3a5 5 0 0 0-4.2 4.2h-1.3a.75.75 0 0 0 0 1.5h1.3a5 5 0 0 0 4.2 4.2v1.3a.75.75 0 0 0 1.5 0v-1.3a5 5 0 0 0 4.2-4.2h1.3a.75.75 0 0 0 0-1.5h-1.3a5 5 0 0 0-4.2-4.2zM8 11.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
]);
const $e9fce37105e983ce$export$4d86cf54561b29fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation16Regular', "16", [
    "M8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m.5-9a.5.5 0 0 0-1 0v1.52A5 5 0 0 0 3.02 7.5H1.5a.5.5 0 0 0 0 1h1.52a5 5 0 0 0 4.48 4.48v1.52a.5.5 0 0 0 1 0v-1.52a5 5 0 0 0 4.48-4.48h1.52a.5.5 0 1 0 0-1h-1.52A5 5 0 0 0 8.5 3.02zM8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $e9fce37105e983ce$export$819368c78e475848 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation20Filled', "20", [
    "M10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6m.75-10.25a.75.75 0 0 0-1.5 0v1.3a6 6 0 0 0-5.2 5.2h-1.3a.75.75 0 0 0 0 1.5h1.3a6 6 0 0 0 5.2 5.2v1.3a.75.75 0 0 0 1.5 0v-1.3a6 6 0 0 0 5.2-5.2h1.3a.75.75 0 0 0 0-1.5h-1.3a6 6 0 0 0-5.2-5.2zM10 14.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
]);
const $e9fce37105e983ce$export$53b0751df1bfa947 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation20Regular', "20", [
    "M10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6m.5-10.5a.5.5 0 0 0-1 0v1.52A6 6 0 0 0 4.02 9.5H2.5a.5.5 0 0 0 0 1h1.52a6 6 0 0 0 5.48 5.48v1.52a.5.5 0 0 0 1 0v-1.52a6 6 0 0 0 5.48-5.48h1.52a.5.5 0 0 0 0-1h-1.52a6 6 0 0 0-5.48-5.48zM10 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10"
]);
const $e9fce37105e983ce$export$851f2aec3a2b4c31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation24Filled', "24", [
    "M12 2a1 1 0 0 1 1 .88v1.43a7.75 7.75 0 0 1 6.69 6.7L21 11a1 1 0 0 1 .12 2h-1.43A7.75 7.75 0 0 1 13 19.69V21a1 1 0 0 1-2 .12v-1.43A7.75 7.75 0 0 1 4.31 13H3a1 1 0 0 1-.12-2h1.43a7.75 7.75 0 0 1 6.7-6.69L11 3a1 1 0 0 1 1-1m0 4.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $e9fce37105e983ce$export$171319475e7d1af3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MyLocation24Regular', "24", [
    "M12 2c.38 0 .7.28.74.65l.01.1v1.79a7.5 7.5 0 0 1 6.71 6.71h1.79a.75.75 0 0 1 .1 1.5h-1.89a7.5 7.5 0 0 1-6.71 6.71v1.79a.75.75 0 0 1-1.5.1v-1.89a7.5 7.5 0 0 1-6.71-6.71H2.75a.75.75 0 0 1-.1-1.5h1.89a7.5 7.5 0 0 1 6.71-6.71V2.75c0-.41.34-.75.75-.75m0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $e9fce37105e983ce$export$4050c36737c4a1e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PageFit16Filled', "16", [
    "M1 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2 1v1a.5.5 0 0 0 1 0V6h1a.5.5 0 0 0 0-1H4a1 1 0 0 0-1 1m9-1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0V6a1 1 0 0 0-1-1m0 6a1 1 0 0 0 1-1V9a.5.5 0 0 0-1 0v1h-1a.5.5 0 0 0 0 1zm-8 0h1a.5.5 0 0 0 0-1H4V9a.5.5 0 0 0-1 0v1a1 1 0 0 0 1 1"
]);
const $e9fce37105e983ce$export$2eb050182a41f1fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PageFit16Regular', "16", [
    "M3 6a1 1 0 0 1 1-1h1a.5.5 0 0 1 0 1H4v1a.5.5 0 0 1-1 0zm10 0a1 1 0 0 0-1-1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0zm0 4a1 1 0 0 1-1 1h-1a.5.5 0 0 1 0-1h1V9a.5.5 0 0 1 1 0zM3 10a1 1 0 0 0 1 1h1a.5.5 0 0 0 0-1H4V9a.5.5 0 0 0-1 0zm0-7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm10 1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
]);
const $e9fce37105e983ce$export$23aa4e78562ccbf7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PageFit20Filled', "20", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm1.5 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1C4 6.67 4.67 6 5.5 6m8 0h1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1 0-1M5 11.5v1c0 .28.22.5.5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 4 12.5v-1a.5.5 0 0 1 1 0m11 0v1c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 1 0"
]);
const $e9fce37105e983ce$export$a52b6ebed98a32e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PageFit20Regular', "20", [
    "M5.5 6C4.67 6 4 6.67 4 7.5v1a.5.5 0 0 0 1 0v-1c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1zm8 0a.5.5 0 0 0 0 1h1c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5zM5 11.5a.5.5 0 0 0-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 1-.5-.5zm11 0a.5.5 0 0 0-1 0v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 0 0 1h1c.83 0 1.5-.67 1.5-1.5zM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm1 0v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1m2.5 0C4.67 6 4 6.67 4 7.5v1a.5.5 0 0 0 1 0v-1c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1zM5 11.5a.5.5 0 0 0-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 1-.5-.5z"
]);
const $e9fce37105e983ce$export$28eb773226dbdcb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PageFit24Filled', "24", [
    "M18.25 4A3.75 3.75 0 0 1 22 7.75v8.5A3.75 3.75 0 0 1 18.25 20H5.75A3.75 3.75 0 0 1 2 16.25v-8.5A3.75 3.75 0 0 1 5.75 4zm0 9c-.38 0-.7.28-.74.65l-.01.1V15a.5.5 0 0 1-.41.5h-1.34a.75.75 0 0 0-.1 1.5H17a2 2 0 0 0 2-1.85v-1.4a.75.75 0 0 0-.75-.75m-12.5 0c-.38 0-.7.28-.74.65l-.01.1V15a2 2 0 0 0 1.85 2h1.4a.75.75 0 0 0 .1-1.5H7a.5.5 0 0 1-.5-.41v-1.34a.75.75 0 0 0-.75-.75m2.5-6h-1.4a2 2 0 0 0-1.84 1.84L5 9v1.35a.75.75 0 0 0 1.5 0V8.91a.5.5 0 0 1 .41-.4L7 8.5h1.35a.75.75 0 0 0 0-1.5zM17 7h-1.25a.75.75 0 0 0-.1 1.5H17a.5.5 0 0 1 .5.41v1.34a.75.75 0 0 0 1.5.1V9a2 2 0 0 0-1.85-2z"
]);
const $e9fce37105e983ce$export$ce1bf6a29cd31cab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PageFit24Regular', "24", [
    "M18.25 4A3.75 3.75 0 0 1 22 7.75v8.5A3.75 3.75 0 0 1 18.25 20H5.75A3.75 3.75 0 0 1 2 16.25v-8.5A3.75 3.75 0 0 1 5.75 4zm0 1.5H5.75c-1.24 0-2.25 1-2.25 2.25v8.5c0 1.24 1 2.25 2.25 2.25h12.5c1.24 0 2.25-1 2.25-2.25v-8.5c0-1.24-1-2.25-2.25-2.25m0 7.5c.41 0 .75.34.75.75V15a2 2 0 0 1-2 2h-1.25a.75.75 0 0 1 0-1.5H17a.5.5 0 0 0 .5-.5v-1.25c0-.41.34-.75.75-.75m-12.5 0c.41 0 .75.34.75.75V15c0 .28.22.5.5.5h1.25a.75.75 0 0 1 0 1.5H7a2 2 0 0 1-2-2v-1.25c0-.41.34-.75.75-.75M7 7h1.25a.75.75 0 0 1 .1 1.5H7a.5.5 0 0 0-.5.41v1.34a.75.75 0 0 1-1.5.1V9a2 2 0 0 1 1.85-2zm10 0a2 2 0 0 1 2 2v1.25a.75.75 0 0 1-1.5 0V9a.5.5 0 0 0-.5-.5h-1.25a.75.75 0 0 1 0-1.5z"
]);
const $e9fce37105e983ce$export$e1c3f7e5c7ee22d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print16Filled', "16", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h5c.83 0 1.5.67 1.5 1.5V4h1a2 2 0 0 1 2 2v4.5c0 .83-.67 1.5-1.5 1.5H12v.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 12.5V12H2.5A1.5 1.5 0 0 1 1 10.5V6c0-1.1.9-2 2-2h1zm7 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V4h6zm-6 7v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5"
]);
const $e9fce37105e983ce$export$3192802a7f055d52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print16Regular', "16", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h5c.83 0 1.5.67 1.5 1.5V4h1a2 2 0 0 1 2 2v4.5c0 .83-.67 1.5-1.5 1.5H12v.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 12.5V12H2.5A1.5 1.5 0 0 1 1 10.5V6c0-1.1.9-2 2-2h1zM4 11v-.5C4 9.67 4.67 9 5.5 9h5c.83 0 1.5.67 1.5 1.5v.5h1.5a.5.5 0 0 0 .5-.5V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4.5c0 .28.22.5.5.5zm1-7h6v-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5zm0 6.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5"
]);
const $e9fce37105e983ce$export$303d2bef70724cd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print20Filled', "20", [
    "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V5h.5A2.5 2.5 0 0 1 18 7.5v5c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5V14H3.5A1.5 1.5 0 0 1 2 12.5v-5A2.5 2.5 0 0 1 4.5 5H5zm9 0a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V5h8zm-8 7v4c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5"
]);
const $e9fce37105e983ce$export$3dd2fff471a73968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print20Regular', "20", [
    "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V5h.5A2.5 2.5 0 0 1 18 7.5v5c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5V14H3.5A1.5 1.5 0 0 1 2 12.5v-5A2.5 2.5 0 0 1 4.5 5H5zM6 5h8v-.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5zm-1 8v-1.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V13h1.5a.5.5 0 0 0 .5-.5v-5c0-.83-.67-1.5-1.5-1.5h-11C3.67 6 3 6.67 3 7.5v5c0 .28.22.5.5.5zm1.5-2a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z"
]);
const $e9fce37105e983ce$export$2b2772d4428a7be7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print24Filled', "24", [
    "M18 17.5v1.25c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 21 6 20 6 18.75V17.5H4.25c-1.24 0-2.25-1-2.25-2.25v-6C2 7.45 3.46 6 5.25 6H6v-.75C6 4.01 7 3 8.25 3h7.5C17 3 18 4 18 5.25V6h.75C20.55 6 22 7.46 22 9.25v6c0 1.24-1 2.25-2.24 2.25zm-2.25-4h-7.5a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75m0-9h-7.5a.75.75 0 0 0-.75.75V6h9v-.75a.75.75 0 0 0-.75-.75"
]);
const $e9fce37105e983ce$export$2e1d9cbf1072a51b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print24Regular', "24", [
    "M15.75 3C17 3 18 4 18 5.25V6h.75C20.55 6 22 7.46 22 9.25v6c0 1.24-1 2.25-2.24 2.25H18v1.25c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 21 6 20 6 18.75V17.5H4.25c-1.24 0-2.25-1-2.25-2.25v-6C2 7.45 3.46 6 5.25 6H6v-.75C6 4.01 7 3 8.25 3zm0 10.5h-7.5a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75m3-6H5.25c-.97 0-1.75.79-1.75 1.75v6c0 .41.34.75.75.75H6v-1.75C6 13.01 7 12 8.25 12h7.5c1.24 0 2.25 1 2.25 2.25V16h1.78c.4-.01.73-.34.73-.75v-6c0-.96-.8-1.75-1.76-1.75m-3-3h-7.5a.75.75 0 0 0-.75.75V6h9v-.75a.75.75 0 0 0-.75-.75"
]);
const $e9fce37105e983ce$export$b2d5d6b7cc28de79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print28Filled', "28", [
    "M7 5.77V7H6a4 4 0 0 0-4 4v7a3 3 0 0 0 3 3h2v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h2a3 3 0 0 0 3-3v-7a4 4 0 0 0-4-4h-1V5.75A2.75 2.75 0 0 0 18.25 3l-8.5.02A2.75 2.75 0 0 0 7 5.77m12.5-.02V7h-11V5.77c0-.7.56-1.25 1.25-1.25l8.5-.02c.69 0 1.25.56 1.25 1.25M10 15.5h8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 8.5 22v-5c0-.83.67-1.5 1.5-1.5"
]);
const $e9fce37105e983ce$export$e5009e13947fc893 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print28Regular', "28", [
    "M7 5.77V7H6a4 4 0 0 0-4 4v7a3 3 0 0 0 3 3h2v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h2a3 3 0 0 0 3-3v-7a4 4 0 0 0-4-4h-1V5.75A2.75 2.75 0 0 0 18.25 3l-8.5.02A2.75 2.75 0 0 0 7 5.77M21 19.5V17a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v2.5H5A1.5 1.5 0 0 1 3.5 18v-7A2.5 2.5 0 0 1 6 8.5h16a2.5 2.5 0 0 1 2.5 2.5v7c0 .83-.67 1.5-1.5 1.5zM19.5 5.75V7h-11V5.77c0-.7.56-1.25 1.25-1.25l8.5-.02c.69 0 1.25.56 1.25 1.25M10 15.5h8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 8.5 22v-5c0-.83.67-1.5 1.5-1.5"
]);
const $e9fce37105e983ce$export$63a2acd41f2b0ef4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print32Filled', "32", [
    "M8 6.5V8H7a5 5 0 0 0-5 5v7.5A3.5 3.5 0 0 0 5.5 24H7v1.5a3.5 3.5 0 0 0 3.5 3.5h11a3.5 3.5 0 0 0 3.5-3.5V24h1.5a3.5 3.5 0 0 0 3.5-3.5V13a5 5 0 0 0-5-5h-1V6.5A3.5 3.5 0 0 0 20.5 3h-9A3.5 3.5 0 0 0 8 6.5M11.5 5h9c.83 0 1.5.67 1.5 1.5V8H10V6.5c0-.83.67-1.5 1.5-1.5M9 19.5c0-.83.67-1.5 1.5-1.5h11c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 9 25.5z"
]);
const $e9fce37105e983ce$export$bc4f881913cfd78b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print32Light', "32", [
    "M7 8h1V6.5A3.5 3.5 0 0 1 11.5 3h9A3.5 3.5 0 0 1 24 6.5V8h1a5 5 0 0 1 5 5v7.5a3.5 3.5 0 0 1-3.5 3.5H25v1.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 7 25.5V24H5.5A3.5 3.5 0 0 1 2 20.5V13a5 5 0 0 1 5-5m4.5-4A2.5 2.5 0 0 0 9 6.5V8h14V6.5A2.5 2.5 0 0 0 20.5 4zM8 25.5a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-6a2.5 2.5 0 0 0-2.5-2.5h-11A2.5 2.5 0 0 0 8 19.5zM25 23h1.5a2.5 2.5 0 0 0 2.5-2.5V13a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v7.5A2.5 2.5 0 0 0 5.5 23H7v-3.5a3.5 3.5 0 0 1 3.5-3.5h11a3.5 3.5 0 0 1 3.5 3.5z"
]);
const $e9fce37105e983ce$export$bd0b598fb8ce1550 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print32Regular', "32", [
    "M24 6.5V8h1a5 5 0 0 1 5 5v7.5a3.5 3.5 0 0 1-3.5 3.5H25v1.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 7 25.5V24H5.5A3.5 3.5 0 0 1 2 20.5V13a5 5 0 0 1 5-5h1V6.5A3.5 3.5 0 0 1 11.5 3h9A3.5 3.5 0 0 1 24 6.5m-14 0V8h12V6.5c0-.83-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5m-1 19c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-11c-.83 0-1.5.67-1.5 1.5zM25 22h1.5c.83 0 1.5-.67 1.5-1.5V13a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v7.5c0 .83.67 1.5 1.5 1.5H7v-2.5a3.5 3.5 0 0 1 3.5-3.5h11a3.5 3.5 0 0 1 3.5 3.5z"
]);
const $e9fce37105e983ce$export$bed6c1972845bda1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print48Filled', "48", [
    "M31.75 8a3.25 3.25 0 0 1 3.24 3.07l.01.18V14h1.75c2.9 0 5.25 2.35 5.25 5.25v13.5c0 1.8-1.46 3.25-3.25 3.25H35v1.75c0 1.8-1.46 3.25-3.25 3.25h-15.5A3.25 3.25 0 0 1 13 37.75V36H9.25A3.25 3.25 0 0 1 6 32.75v-13.5C6 16.35 8.35 14 11.25 14H13v-2.75a3.25 3.25 0 0 1 3.07-3.24l.18-.01zM15.5 37.75c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75h-15.5a.75.75 0 0 0-.75.75zM31.75 10.5h-15.5c-.38 0-.7.28-.74.65l-.01.1V14h17v-2.75c0-.38-.28-.7-.65-.74z"
]);
const $e9fce37105e983ce$export$c33487f0b20a94f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Print48Regular', "48", [
    "M16.25 8h15.5a3.25 3.25 0 0 1 3.24 3.07l.01.18V14h1.75c2.9 0 5.25 2.35 5.25 5.25v13.5c0 1.8-1.46 3.25-3.25 3.25H35v1.75c0 1.8-1.46 3.25-3.25 3.25h-15.5A3.25 3.25 0 0 1 13 37.75V36H9.25A3.25 3.25 0 0 1 6 32.75v-13.5C6 16.35 8.35 14 11.25 14H13v-2.75a3.25 3.25 0 0 1 3.07-3.24zm15.5 20.5h-15.5a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75m5-12h-25.5a2.75 2.75 0 0 0-2.75 2.75v13.5c0 .41.34.75.75.75H13v-4.25c0-1.8 1.46-3.25 3.25-3.25h15.5c1.8 0 3.25 1.46 3.25 3.25v4.25h3.75c.41 0 .75-.34.75-.75v-13.5a2.75 2.75 0 0 0-2.75-2.75m-5-6h-15.5c-.38 0-.7.28-.74.65l-.01.1V14h17v-2.75c0-.38-.28-.7-.65-.74z"
]);
const $e9fce37105e983ce$export$8bdf404a3bd18306 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PrintAdd20Filled', "20", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5V15H3.5A1.5 1.5 0 0 1 2 13.5v-5A2.5 2.5 0 0 1 4.5 6H5v-.5C5 4.67 5.67 4 6.5 4h2.7q-.13.49-.18 1H6.5a.5.5 0 0 0-.5.5V6h3.02c.26 2.8 2.61 5 5.48 5M6 12.5v4c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5"
]);
const $e9fce37105e983ce$export$3eb99dedece5288e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PrintAdd20Regular', "20", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm2 10v-3.1q.54-.27 1-.66v3.76c0 .83-.67 1.5-1.5 1.5H15v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5V15H3.5A1.5 1.5 0 0 1 2 13.5v-5A2.5 2.5 0 0 1 4.5 6H5v-.5C5 4.67 5.67 4 6.5 4h2.7q-.13.49-.18 1H6.5a.5.5 0 0 0-.5.5V6h3.02q.05.51.19 1H4.5C3.67 7 3 7.67 3 8.5v5c0 .28.22.5.5.5H5v-1.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V14h1.5a.5.5 0 0 0 .5-.5M6.5 12a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z"
]);
const $e9fce37105e983ce$export$5a3a026bee999511 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PrintAdd24Filled', "24", [
    "M23 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M18 7v2.5a.5.5 0 1 1-1 0V7h-2.5a.5.5 0 0 1 0-1H17V3.5a.5.5 0 0 1 1 0V6h2.5a.5.5 0 0 1 0 1zm-.5 6c1.75 0 3.34-.7 4.5-1.81v5.06c0 1.24-1 2.25-2.24 2.25H18v1.25c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V18.5H4.25c-1.24 0-2.25-1-2.25-2.25v-6C2 8.45 3.46 7 5.25 7H6v-.75C6 5.01 7 4 8.25 4h3.25q-.3.71-.42 1.5H8.25a.75.75 0 0 0-.75.75V7h3.52a6.5 6.5 0 0 0 6.48 6m-1 2.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75z"
]);
const $e9fce37105e983ce$export$e341e75d8343a0fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PrintAdd24Regular', "24", [
    "M23 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M18 7v2.5a.5.5 0 1 1-1 0V7h-2.5a.5.5 0 0 1 0-1H17V3.5a.5.5 0 0 1 1 0V6h2.5a.5.5 0 0 1 0 1zm2.5 9.25v-3.98a7 7 0 0 0 1.5-1.08v5.06c0 1.24-1 2.25-2.24 2.25H18v1.25c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V18.5H4.25c-1.24 0-2.25-1-2.25-2.25v-6C2 8.45 3.46 7 5.25 7H6v-.75C6 5.01 7 4 8.25 4h3.25q-.3.71-.42 1.5H8.25a.75.75 0 0 0-.75.75V7h3.52q.06.79.3 1.5H5.24c-.97 0-1.75.79-1.75 1.75v6c0 .41.34.75.75.75H6v-1.75C6 14.01 7 13 8.25 13h7.5c1.24 0 2.25 1 2.25 2.25V17h1.78c.4-.01.73-.34.73-.75m-4-1a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75z"
]);
const $e9fce37105e983ce$export$d0766675c32e2d4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TopSpeed16Regular', "16", [
    "M10.7 4.6a.5.5 0 0 1 .75.62v.01l-.02.04-.07.12-.22.44a123 123 0 0 1-1.47 2.8l-.33.55q-.14.23-.28.38a1.5 1.5 0 0 1-2.12-2.12A100.16 100.16 0 0 1 9 5.84l1.18-.86.38-.28.1-.08zM8 1a7 7 0 0 1 3.73 12.92.5.5 0 0 1-.53-.84 6 6 0 0 0 2.78-4.58h-1.51c-.27 0-.47-.23-.47-.5s.2-.5.47-.5h1.5A6 6 0 0 0 8.5 2.02v1.51c0 .27-.24.47-.5.47-.27 0-.5-.2-.5-.47v-1.5c-1.29.1-2.45.6-3.38 1.4L5.2 4.48c.19.19.17.5-.02.68-.19.2-.5.22-.69.03L3.42 4.13a6 6 0 0 0-1.4 3.37h1.51c.27 0 .47.23.47.5s-.2.5-.47.5h-1.5a6 6 0 0 0 2.77 4.58.5.5 0 0 1-.53.84A7 7 0 0 1 8 1"
]);
const $e9fce37105e983ce$export$716d45a5cce28806 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TopSpeed20Filled', "20", [
    "M10 2a8 8 0 0 1 5.52 13.8.75.75 0 0 1-1.04-1.1 6.5 6.5 0 0 0 1.94-3.7h-1.17a.75.75 0 0 1 0-1.5h1.23a6.5 6.5 0 0 0-5.73-5.96v1.27c0 .4-.36.69-.75.69-.4 0-.75-.3-.75-.69V3.54A6.5 6.5 0 0 0 5.97 4.9l.8.82a.75.75 0 0 1-1.05 1.06l-.81-.82A6.5 6.5 0 0 0 3.52 9.5h1.3a.75.75 0 0 1 0 1.5H3.58c.2 1.34.82 2.54 1.71 3.48l.23.23.05.05a.75.75 0 0 1-1.09 1.03A8 8 0 0 1 10 2m3.2 4.1a.5.5 0 0 1 .74.64l-.01.01-.02.04-.08.14a195 195 0 0 1-2.1 3.64l-.37.6q-.15.24-.3.39a1.5 1.5 0 0 1-2.12-2.12c.12-.12.46-.4.86-.72a153 153 0 0 1 3.23-2.5q.08-.05.12-.09l.04-.02"
]);
const $e9fce37105e983ce$export$2b390cb89cf091bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TopSpeed20Regular', "20", [
    "M10 2a8 8 0 0 1 5.44 13.87l-.08.06a.5.5 0 0 1-.6-.8l.25-.24a7 7 0 0 0 1.97-4.39h-1.5A.5.5 0 0 1 15 10c0-.27.2-.5.48-.5h1.5a7 7 0 0 0-6.48-6.48v1.5A.5.5 0 0 1 10 5c-.27 0-.5-.2-.5-.48v-1.5A7 7 0 0 0 5.42 4.7l1.06 1.06c.2.2.17.5-.02.7-.18.18-.5.2-.69.01L4.71 5.42A7 7 0 0 0 3.02 9.5h1.5c.27 0 .48.23.48.5s-.2.5-.48.5h-1.5c.12 1.7.85 3.24 1.97 4.39l.25.24.07.08a.5.5 0 0 1-.75.66A8 8 0 0 1 10 2m3.2 4.1a.5.5 0 0 1 .74.64l-.01.01-.02.04-.08.14a195 195 0 0 1-2.1 3.64l-.37.6q-.15.24-.3.39a1.5 1.5 0 0 1-2.12-2.12c.12-.12.46-.4.86-.72a153 153 0 0 1 3.23-2.5q.08-.05.12-.09l.04-.02"
]);
const $e9fce37105e983ce$export$4f1c74f56df332c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TopSpeed24Filled', "24", [
    "M12 2a10 10 0 0 1 6.29 17.78 1 1 0 0 1-1.26-1.56 8 8 0 0 0 2.9-5.22h-1.52c-.52 0-.91-.48-.91-1s.39-1 .91-1h1.53A8 8 0 0 0 13 4.06V5.6c0 .52-.48.91-1 .91s-1-.4-1-.91V4.06c-1.46.19-2.8.76-3.9 1.62l1.07 1.08c.37.37.31.98-.06 1.35s-.98.43-1.35.06L5.68 7.1A8 8 0 0 0 4.06 11H5.6c.52 0 .91.48.91 1s-.39 1-.91 1H4.06a8 8 0 0 0 2.58 4.94l.33.28.08.07a1 1 0 0 1-1.25 1.55l-.09-.06-.41-.36A10 10 0 0 1 12 2m3.95 4.65c.23-.2.57-.2.8-.02.25.19.32.51.18.78l-.13.25-2.62 4.84-.78 1.3c-.65.8-1.85.94-2.68.3a1.84 1.84 0 0 1-.3-2.62q.14-.17.41-.42l.69-.63a157 157 0 0 1 4.21-3.6z"
]);
const $e9fce37105e983ce$export$999783f3944be6d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TopSpeed24Regular', "24", [
    "M6.54 5.48a8.5 8.5 0 0 1 4.71-1.95v1.72a.75.75 0 0 0 1.5 0V3.53a8.5 8.5 0 0 1 7.74 7.97h-1.74a.75.75 0 0 0 0 1.5h1.7a8.5 8.5 0 0 1-3.17 5.67.75.75 0 0 0 .94 1.16A10 10 0 0 0 22 12a10 10 0 1 0-16.23 7.83.75.75 0 0 0 .96-1.16A8.7 8.7 0 0 1 3.56 13h1.69a.75.75 0 0 0 0-1.5H3.51c.11-1.88.84-3.6 1.97-4.96l1.24 1.24a.75.75 0 0 0 1.06-1.06zm10.22 1.15a.65.65 0 0 0-.8.02l-.23.18-4.21 3.6-1.1 1.05c-.66.8-.52 1.98.3 2.62s2.03.5 2.68-.3q.14-.19.32-.5l.46-.8a153 153 0 0 0 2.62-4.85l.13-.24a.6.6 0 0 0-.17-.78"
]);
const $e9fce37105e983ce$export$4e67e027a7dd377 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv20Filled', "20", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm3.5 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);
const $e9fce37105e983ce$export$d7a288da9c5a7300 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv20Regular', "20", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm1 11.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5"
]);
const $e9fce37105e983ce$export$f9d1e53164c4ee17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v8.5A2.75 2.75 0 0 0 4.75 18h14.5A2.75 2.75 0 0 0 22 15.25v-8.5A2.75 2.75 0 0 0 19.25 4zM5 20.25c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75"
]);
const $e9fce37105e983ce$export$e175dd03894aae5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v8.5A2.75 2.75 0 0 0 4.75 18h14.5A2.75 2.75 0 0 0 22 15.25v-8.5A2.75 2.75 0 0 0 19.25 4zM3.5 6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25zM5.75 19.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $e9fce37105e983ce$export$72c0a90ed0eb2df9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv28Filled', "28", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v10.5C2 19.55 3.46 21 5.25 21h17.5c1.8 0 3.25-1.45 3.25-3.25V7.25C26 5.45 24.55 4 22.75 4zM6 23.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75"
]);
const $e9fce37105e983ce$export$46f8cf4fd7e2e7d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tv28Regular', "28", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v10.5C2 19.55 3.46 21 5.25 21h17.5c1.8 0 3.25-1.45 3.25-3.25V7.25C26 5.45 24.55 4 22.75 4zM3.5 7.25c0-.97.79-1.75 1.75-1.75h17.5c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75H5.25c-.96 0-1.75-.78-1.75-1.75zM6.75 23a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $e9fce37105e983ce$export$49d01da2145ac98d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip16Filled', "16", [
    "M12.5 3A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-5A2.5 2.5 0 0 1 3.5 3zM6.97 5.8a.5.5 0 0 0-.67.23L5 8.63l-1.3-2.6a.5.5 0 0 0-.9.44l1.75 3.5a.5.5 0 0 0 .9 0l1.75-3.5a.5.5 0 0 0-.23-.67m1.53-.05a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 1 0v-3.5a.5.5 0 0 0-.5-.5m2 0a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 1 0V9h.63a1.62 1.62 0 1 0 0-3.25zm1.13 1a.62.62 0 1 1 0 1.25H11V6.75z"
]);
const $e9fce37105e983ce$export$cd8189f48aa1be8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip16Regular', "16", [
    "M12.5 3A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-5A2.5 2.5 0 0 1 3.5 3zm-9 1C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zm2.8 2.03a.5.5 0 0 1 .9.44l-1.75 3.5a.5.5 0 0 1-.9 0L2.8 6.47a.5.5 0 0 1 .9-.44L5 8.63zm2.2-.28c.28 0 .5.22.5.5v3.5a.5.5 0 0 1-1 0v-3.5c0-.28.22-.5.5-.5m3.13 0a1.62 1.62 0 1 1 0 3.25H11v.75a.5.5 0 0 1-1 0v-3.5c0-.28.22-.5.5-.5zM11 8h.63a.62.62 0 1 0 0-1.25H11z"
]);
const $e9fce37105e983ce$export$5d428ee2325a11ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip20Filled', "20", [
    "M15 4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8.67 7.03a.5.5 0 0 0-.64.3L6.5 11.7 4.97 7.33a.5.5 0 1 0-.94.34l1.67 4.76a.85.85 0 0 0 1.6 0l1.67-4.76a.5.5 0 0 0-.3-.64M10.5 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m2 0a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0V11h1a2 2 0 1 0 0-4zM14 8a1 1 0 1 1 0 2h-1V8z"
]);
const $e9fce37105e983ce$export$6603a306dd44aca4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip20Regular', "20", [
    "M15 4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM5 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm3.03 2.33a.5.5 0 1 1 .94.34L7.3 12.43a.85.85 0 0 1-1.6 0L4.03 7.67a.5.5 0 1 1 .94-.34L6.5 11.7zM10.5 7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M14 7a2 2 0 1 1 0 4h-1v1.5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5zm-1 3h1a1 1 0 1 0 0-2h-1z"
]);
const $e9fce37105e983ce$export$c333dfb8a9f1d23f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm-8.74 4.54a.75.75 0 0 0-.97.45L7.5 13.24 5.96 9a.75.75 0 0 0-1.42.52l1.92 5.26a1.1 1.1 0 0 0 2.08 0l1.92-5.26a.75.75 0 0 0-.45-.97m2.24-.04a.75.75 0 0 0-.75.75v5.5a.75.75 0 0 0 1.5 0v-5.5a.75.75 0 0 0-.75-.75m3 0a.75.75 0 0 0-.75.75v5.5a.75.75 0 0 0 1.5 0V13h1.25a2.25 2.25 0 0 0 0-4.5zm2 1.5a.75.75 0 0 1 0 1.5H16V10z"
]);
const $e9fce37105e983ce$export$8f9c4fef47c36e3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip24Regular', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zM5.25 5.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zM9.05 9a.75.75 0 0 1 1.4.5l-1.91 5.27a1.1 1.1 0 0 1-2.08 0L4.54 9.51a.75.75 0 0 1 1.42-.52l1.54 4.25zm3.2-.5c.41 0 .75.34.75.75v5.5a.75.75 0 0 1-1.5 0v-5.5c0-.41.34-.75.75-.75m5 0a2.25 2.25 0 0 1 0 4.5H16v1.75a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75zm-1.25 3h1.25a.75.75 0 0 0 0-1.5H16z"
]);
const $e9fce37105e983ce$export$e8f5aee1f1ad06cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zm-9.96 6.06a.75.75 0 0 0-.98.4L9 15.9l-2.31-5.45a.75.75 0 1 0-1.38.58l2.65 6.27a1.13 1.13 0 0 0 2.08 0l2.65-6.27a.75.75 0 0 0-.4-.98m2.46-.06a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75m3.5 0a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0V15.5h1.25a2.75 2.75 0 1 0 0-5.5zm2 1.5a1.25 1.25 0 1 1 0 2.5H19v-2.5z"
]);
const $e9fce37105e983ce$export$4454edc8c3ce317c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25zm5.56 4.96a.75.75 0 1 1 1.38.58l-2.65 6.27a1.13 1.13 0 0 1-2.08 0l-2.65-6.27a.75.75 0 1 1 1.38-.58L9 15.9zm3.44-.46c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m5.5 0a2.75 2.75 0 1 1 0 5.5H19v1.75a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75zM19 14h1.25a1.25 1.25 0 1 0 0-2.5H19z"
]);
const $e9fce37105e983ce$export$ad95f9d2369859a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip32Filled', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-12.63 7.57a1 1 0 0 0-1.3.56L9.5 17.4l-2.07-5.27a1 1 0 0 0-1.86.74l2.66 6.76a1.37 1.37 0 0 0 2.54 0l2.66-6.76a1 1 0 0 0-.56-1.3M16 11.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V18h1.75a3.25 3.25 0 0 0 0-6.5zm2.75 2a1.25 1.25 0 1 1 0 2.5H21v-2.5z"
]);
const $e9fce37105e983ce$export$4e4ff8653e5be0ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip32Light', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-19 1A3.5 3.5 0 0 0 3 8.5v15A3.5 3.5 0 0 0 6.5 27h19a3.5 3.5 0 0 0 3.5-3.5v-15A3.5 3.5 0 0 0 25.5 5zm7.03 6.32a.5.5 0 1 1 .94.36l-3.34 8.88a.67.67 0 0 1-1.26 0l-3.34-8.88a.5.5 0 1 1 .94-.36l3.03 8.08zM16.5 11c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5m6.5 0a3 3 0 1 1 0 6h-3v3.5a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5zm-3 5h3a2 2 0 1 0 0-4h-3z"
]);
const $e9fce37105e983ce$export$d9c3f1cbc1664021 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip32Regular', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-19 2A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6zm5.07 6.13a1 1 0 0 1 1.86.74l-2.66 6.76a1.37 1.37 0 0 1-2.54 0l-2.66-6.76a1 1 0 0 1 1.86-.74L9.5 17.4zM16 11.5a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m6.75 0a3.25 3.25 0 0 1 0 6.5H21v1.5a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zM21 16h1.75a1.25 1.25 0 1 0 0-2.5H21z"
]);
const $e9fce37105e983ce$export$d3692ac6c3ca3758 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip48Filled', "48", [
    "M37.75 8C41.2 8 44 10.8 44 14.25v19.5C44 37.2 41.2 40 37.75 40h-27.5A6.25 6.25 0 0 1 4 33.75v-19.5C4 10.8 6.8 8 10.25 8zm-17.3 8.58a1.25 1.25 0 0 0-1.62.73L15 27.39 11.17 17.3a1.25 1.25 0 0 0-2.34.88l4.66 12.27a1.61 1.61 0 0 0 3.02 0l4.66-12.27a1.25 1.25 0 0 0-.73-1.6m4.3-.08c-.69 0-1.25.56-1.25 1.25v12.5a1.25 1.25 0 1 0 2.5 0v-12.5c0-.69-.56-1.25-1.25-1.25m5.5 0A1.25 1.25 0 0 0 29 17.75v12.5a1.25 1.25 0 1 0 2.5 0V26.5h3a5 5 0 0 0 0-10zM34.5 19a2.5 2.5 0 0 1 0 5h-3v-5z"
]);
const $e9fce37105e983ce$export$89f57314955fb58b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Vip48Regular', "48", [
    "M37.75 8C41.2 8 44 10.8 44 14.25v19.5C44 37.2 41.2 40 37.75 40h-27.5A6.25 6.25 0 0 1 4 33.75v-19.5C4 10.8 6.8 8 10.25 8zm-27.5 2.5a3.75 3.75 0 0 0-3.75 3.75v19.5a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75v-19.5a3.75 3.75 0 0 0-3.75-3.75zm8.58 6.8a1.25 1.25 0 0 1 2.34.9L16.5 30.45a1.61 1.61 0 0 1-3.02 0L8.83 18.19a1.25 1.25 0 0 1 2.34-.88L15 27.39zm5.92-.8c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m9.75 0a5 5 0 0 1 0 10h-3v3.75a1.25 1.25 0 1 1-2.5 0v-12.5a1.25 1.25 0 0 1 1.25-1.25zm-3 7.5h3a2.5 2.5 0 0 0 0-5h-3z"
]);


"use client";
const $bd5c6ab3f2a8957d$export$b3377b730b7c9303 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFit32Light', "32", [
    "M6 4.5c0-.28.22-.5.5-.5h19a.5.5 0 0 1 0 1h-19a.5.5 0 0 1-.5-.5m0 23c0-.28.22-.5.5-.5h19a.5.5 0 0 1 0 1h-19a.5.5 0 0 1-.5-.5M16.85 7.15a.5.5 0 0 0-.7 0l-4 4a.5.5 0 0 0 .7.7L16 8.71v14.58l-3.65-3.64a.5.5 0 0 0-.7.7l4.5 4.5c.2.2.5.2.7 0l4.5-4.5a.5.5 0 0 0-.7-.7L17 23.29V8.71l3.15 3.14a.5.5 0 0 0 .7-.7z"
]);
const $bd5c6ab3f2a8957d$export$ea8f2c4817a489c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight20Filled', "20", [
    "M4.25 2a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zm0 14.5a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zm6.03-1.72 2-2a.75.75 0 1 0-1.06-1.06l-.72.72V7.56l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06L9 7.56v4.88l-.72-.72a.75.75 0 0 0-1.06 1.06l2 2c.3.3.77.3 1.06 0"
]);
const $bd5c6ab3f2a8957d$export$7c99cd701d493524 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight20Regular', "20", [
    "M4 2a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm0 15a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zM9.15 5.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L10 6.71v6.58l1.15-1.14a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 13.29V6.71L7.85 7.85a.5.5 0 1 1-.7-.7z"
]);
const $bd5c6ab3f2a8957d$export$d1b0e36f9b3ee06e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight24Filled', "24", [
    "M6 3a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zm4.35 10.7.1.09.8.8V9.4l-.8.8-.1.09a1 1 0 0 1-1.4-1.4l.09-.1 2.35-2.36c.18-.27.5-.44.86-.44.32 0 .62.14.8.37h.01l.05.07 2.36 2.36.08.1a1 1 0 0 1 .01 1.18v.01l-.1.12-.1.09h-.01a1 1 0 0 1-1.18.01l-.12-.1-.8-.8v5.18l.8-.8a1 1 0 0 1 1.3-.1v.01l.1.09h.01a1 1 0 0 1 .1 1.3v.01l-.1.1-2.35 2.36c-.18.27-.5.44-.86.44-.35 0-.68-.17-.86-.44L9.04 15.2a1 1 0 0 1 1.3-1.51zM5 20a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
]);
const $bd5c6ab3f2a8957d$export$8bc80ed4e32b1ad9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight24Regular', "24", [
    "M5.75 3a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zm3.47 11.22a.75.75 0 0 1 .98-.07l.08.07 1.22 1.22V8.56l-1.22 1.22-.08.07A.75.75 0 0 1 9.15 8.8l.07-.08 2.37-2.37c.12-.2.37-.35.66-.35.25 0 .48.1.61.28l.05.07 2.37 2.37.07.08c.2.27.2.62.01.89l-.08.1-.08.06c-.26.2-.62.2-.88.01l-.1-.08L13 8.56v6.88l1.22-1.22a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.08.98l-.08.08-2.36 2.37a.8.8 0 0 1-.67.35.8.8 0 0 1-.66-.35l-2.37-2.37a.75.75 0 0 1 0-1.06M5 20.25c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75"
]);
const $bd5c6ab3f2a8957d$export$bde84e4cb22b580a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight28Filled', "28", [
    "M21.1 23a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2h14.1M13.37 7.22a1 1 0 0 1 1.34.07l3 3 .07.08a1 1 0 0 1-1.41 1.4l-.08-.06L15 10.4v7.18l1.3-1.3a1 1 0 1 1 1.4 1.42l-3 3a1 1 0 0 1-1.33.07l-.08-.07-3-3-.07-.08a1 1 0 0 1 1.41-1.4l.08.06L13 17.6V10.4l-1.3 1.3a1 1 0 1 1-1.4-1.42l3-3zM21.1 3a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h14.1"
]);
const $bd5c6ab3f2a8957d$export$d900734f3a0ae7a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight28Regular', "28", [
    "M21.25 23.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5zM13.53 7.17a.75.75 0 0 1 1 .05l3.25 3.25.05.06a.75.75 0 0 1-1.05 1.05l-.06-.05-1.97-1.97v8.88l1.97-1.97a.75.75 0 1 1 1.06 1.06l-3.25 3.25c-.3.3-.77.3-1.06 0l-3.25-3.25-.05-.06a.75.75 0 0 1 1.05-1.05l.06.05 1.97 1.97V9.56l-1.97 1.97a.75.75 0 1 1-1.06-1.06l3.25-3.25zM21.25 3a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$c5b7d97f8028c9da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight32Filled', "32", [
    "M24.88 26.5a1.25 1.25 0 0 1 0 2.5H7.25a1.25 1.25 0 1 1 0-2.5h17.63M15.2 7.29c.5-.4 1.22-.37 1.67.09l3.75 3.75.09.1a1.25 1.25 0 0 1-1.76 1.75l-.1-.09-1.61-1.61v9.46l1.62-1.61a1.25 1.25 0 0 1 1.76 1.76l-3.75 3.75c-.48.5-1.28.5-1.76 0l-3.75-3.75-.09-.1a1.25 1.25 0 0 1 1.76-1.75l.1.09 1.61 1.61v-9.46l-1.62 1.61a1.25 1.25 0 0 1-1.76-1.76l3.75-3.75zm9.67-4.27a1.25 1.25 0 0 1 0 2.48l-.13.01H7.25a1.25 1.25 0 1 1 0-2.5h17.63"
]);
const $bd5c6ab3f2a8957d$export$8854e5a6ad440905 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitHeight32Regular', "32", [
    "M25 27a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM16 7a1 1 0 0 1 .7.3l4 4 .08.07a1 1 0 0 1-1.41 1.4l-.08-.06L17 10.4V21.6l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-1.33.07l-.08-.07-4-4-.07-.08a1 1 0 0 1 1.41-1.4l.08.06L15 21.6V10.4l-2.3 2.3a1 1 0 1 1-1.4-1.42l4-4 .07-.06A1 1 0 0 1 16 7m9-4a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2z"
]);
const $bd5c6ab3f2a8957d$export$e70cc387cce3e64f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth20Filled', "20", [
    "M18 4.25a.75.75 0 0 0-1.5 0v11a.75.75 0 0 0 1.5 0zm-14.5 0a.75.75 0 0 0-1.5 0v11a.75.75 0 0 0 1.5 0zm1.72 6.03 2 2a.75.75 0 0 0 1.06-1.06l-.72-.72h4.88l-.72.72a.75.75 0 1 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.72.72H7.56l.72-.72a.75.75 0 0 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06"
]);
const $bd5c6ab3f2a8957d$export$f8c80a83d996a572 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth20Regular', "20", [
    "M18 4a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0zM3 4a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0zm11.85 5.15c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L13.29 10H6.71l1.14 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L6.71 9h6.58l-1.14-1.15a.5.5 0 0 1 .7-.7z"
]);
const $bd5c6ab3f2a8957d$export$6ddc775925142057 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth24Filled', "24", [
    "M3 18a1 1 0 1 0 2 0V6a1 1 0 0 0-2 0zm16 0a1 1 0 1 0 2 0V6a1 1 0 1 0-2 0zm-5.21-4.2-.09.1a1 1 0 0 0 1.5 1.3l2.36-2.34c.27-.18.44-.5.44-.86s-.17-.68-.44-.86L15.2 8.78l-.1-.08a1 1 0 0 0-1.3.1h-.01l-.09.1a1 1 0 0 0 .1 1.3l.79.8H9.4l.8-.8.1-.11a1 1 0 0 0 0-1.19h-.01l-.1-.1-.1-.1-.02-.01a1 1 0 0 0-1.17 0l-.01.01-.1.09-2.36 2.35-.07.05Q6 11.5 6 12c0 .36.17.68.44.86l2.36 2.36.1.08a1 1 0 0 0 1.4-1.4l-.09-.1-.8-.8h5.18z"
]);
const $bd5c6ab3f2a8957d$export$5e3139d081760041 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth24Regular', "24", [
    "M3 18.25a.75.75 0 0 0 1.5 0V5.75a.75.75 0 0 0-1.5 0zm16.5 0a.75.75 0 0 0 1.5 0V5.75a.75.75 0 0 0-1.5 0zm-5.35-4.2a.75.75 0 0 0 1.13.98l2.37-2.37c.2-.12.35-.37.35-.66a.8.8 0 0 0-.35-.66l-2.37-2.37-.08-.07a.75.75 0 0 0-.98.07l-.07.08c-.22.3-.2.71.07.98l1.22 1.22H8.56l1.22-1.22.08-.1a.75.75 0 0 0 0-.88l-.08-.08-.1-.08a.75.75 0 0 0-.88 0l-.08.08-2.37 2.37-.07.05A.8.8 0 0 0 6 12c0 .29.14.54.35.66l2.37 2.37.08.07a.75.75 0 0 0 1.05-1.04l-.07-.09-1.22-1.22h6.88l-1.22 1.22z"
]);
const $bd5c6ab3f2a8957d$export$e8b8b55bfedc6155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth28Filled', "28", [
    "M4 6a1 1 0 0 1 1 .9V21a1 1 0 1 1-2 0V6.9A1 1 0 0 1 4 6m20 0a1 1 0 0 1 1 .9V21a1 1 0 1 1-2 0V6.9a1 1 0 0 1 1-.9m-7.7 4.3a1 1 0 0 1 1.4 0l3 3a1 1 0 0 1 .08 1.33l-.07.08-3 3-.08.07a1 1 0 0 1-1.4-1.41l.06-.08L17.6 15H10.4l1.3 1.3a1 1 0 1 1-1.42 1.4l-3-3-.07-.07a1 1 0 0 1 .07-1.34l3-3 .08-.07a1 1 0 0 1 1.4 1.41l-.06.08L10.4 13h7.18l-1.3-1.3a1 1 0 0 1 0-1.4"
]);
const $bd5c6ab3f2a8957d$export$b1056e3e76cf127d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth28Regular', "28", [
    "M3.75 6c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V6.75c0-.41.34-.75.75-.75m20.5 0c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V6.75c0-.41.34-.75.75-.75m-7.78 4.22c.3-.3.77-.3 1.06 0l3.25 3.25c.3.3.3.77 0 1.06l-3.25 3.25-.06.05a.75.75 0 0 1-1.05-1.05l.05-.06 1.97-1.97H9.56l1.97 1.97a.75.75 0 1 1-1.06 1.06l-3.25-3.25-.05-.06a.75.75 0 0 1 .05-1l3.25-3.25.06-.05a.75.75 0 0 1 1.05 1.05l-.05.06-1.97 1.97h8.88l-1.97-1.97a.75.75 0 0 1 0-1.06"
]);
const $bd5c6ab3f2a8957d$export$a2c7676fa11c6b9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth32Filled', "32", [
    "M4.25 6c.65 0 1.18.5 1.24 1.12l.01.13v17.5a1.25 1.25 0 1 1-2.5 0V7.12C3.08 6.5 3.6 6 4.26 6m23.5 0c.65 0 1.18.5 1.24 1.12l.01.13v17.5a1.25 1.25 0 1 1-2.5 0V7.12c.07-.63.6-1.12 1.25-1.12m-8.63 5.37a1.25 1.25 0 0 1 1.76 0l3.75 3.75c.5.48.5 1.28 0 1.76l-3.75 3.75-.1.09a1.25 1.25 0 0 1-1.75-1.76l.09-.1 1.61-1.61h-9.46l1.61 1.62a1.25 1.25 0 0 1-1.76 1.76l-3.75-3.75-.09-.1c-.4-.48-.37-1.2.09-1.66l3.75-3.75.1-.09a1.25 1.25 0 0 1 1.75 1.76l-.09.1-1.61 1.61h9.46l-1.61-1.62a1.25 1.25 0 0 1 0-1.76"
]);
const $bd5c6ab3f2a8957d$export$16759724aca87969 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth32Light', "32", [
    "M4.5 6c.28 0 .5.22.5.5v19a.5.5 0 0 1-1 0v-19c0-.28.22-.5.5-.5m23 0c.28 0 .5.22.5.5v19a.5.5 0 0 1-1 0v-19c0-.28.22-.5.5-.5m-7.85 4.65c.2-.2.5-.2.7 0l4.5 4.5c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 1 1-.7-.7L23.29 16H8.71l3.14 3.15a.5.5 0 1 1-.7.7l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 1 1 .7.7L8.71 15h14.58l-3.64-3.65a.5.5 0 0 1 0-.7"
]);
const $bd5c6ab3f2a8957d$export$385b7c7d862f5a4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AutoFitWidth32Regular', "32", [
    "M4 6a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m24 0a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m-8.7 5.3a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 .08 1.33l-.07.08-4 4-.08.07a1 1 0 0 1-1.4-1.41l.06-.08L21.6 17H10.4l2.3 2.3a1 1 0 1 1-1.42 1.4l-4-4-.06-.07a1 1 0 0 1 .06-1.34l4-4 .08-.07a1 1 0 0 1 1.4 1.41l-.06.08L10.4 15H21.6l-2.3-2.3a1 1 0 0 1 0-1.4"
]);
const $bd5c6ab3f2a8957d$export$ae3f243d82e58c4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect20Filled', "20", [
    "M2.17 14.75 8.03 4.16a2.25 2.25 0 0 1 3.94 0L14.1 8h3.15a.75.75 0 0 1 0 1.5h-2.26a4.25 4.25 0 1 1-2.89-1.49l.15-.01h.03l-1.84-3.25a.5.5 0 0 0-.87 0L3.47 15.5l-.06.12a.75.75 0 1 1-1.31-.73zM9 12.25a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0"
]);
const $bd5c6ab3f2a8957d$export$48b76281bbd3733e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect20Regular', "20", [
    "M9.14 5.48a1 1 0 0 1 1.72 0L12.98 9h-.73a3.75 3.75 0 1 0 2.55 1h2.7a.5.5 0 0 0 0-1h-3.35l-2.44-4.03a2 2 0 0 0-3.42 0L2.07 15.24a.5.5 0 0 0 .86.52zM12.25 10a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5"
]);
const $bd5c6ab3f2a8957d$export$b1502cbc6c9f2bb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect24Filled', "24", [
    "M13.6 4.72a3 3 0 0 1 .94.95l2.87 4.58h4.09a1 1 0 0 1 0 2h-2.75a5 5 0 1 1-4-2h.3l-.28-.45-1.92-3.07a1 1 0 0 0-1.63-.1l-.07.1L3.6 18.78a1 1 0 0 1-1.75-.96l.05-.1L9.46 5.67a3 3 0 0 1 4.13-.95m1.15 7.53a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bd5c6ab3f2a8957d$export$829e00cfbc500146 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect24Regular', "24", [
    "M13.46 4.93q.45.28.75.7l.12.17 2.94 4.7h4.23c.38 0 .7.28.74.65l.01.1c0 .41-.34.75-.75.75h-3.28a4.75 4.75 0 1 1-3.46-1.5h.75l-2.45-3.9a1.25 1.25 0 0 0-2.04-.11l-.08.11L3.4 18.65a.75.75 0 0 1-1.33-.7l.05-.1L9.67 5.8a2.75 2.75 0 0 1 3.8-.87M14.75 12a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5"
]);
const $bd5c6ab3f2a8957d$export$8722a892334b1351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect28Filled', "28", [
    "M11.46 6.36a3 3 0 0 1 5.04.05L20.02 12H25a1 1 0 0 1 0 2h-3.73l.14.2q.26.37.47.77l.02.03q.59 1.14.6 2.5A5.5 5.5 0 1 1 17 12h.65l-2.84-4.53a1 1 0 0 0-1.68-.01l-9.3 14.1a1 1 0 0 1-1.66-1.1zM17 14a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $bd5c6ab3f2a8957d$export$9be7790100403662 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect28Regular', "28", [
    "M11.69 6.25a2.75 2.75 0 0 1 4.6.02L20 12h5.26a.75.75 0 0 1 0 1.5h-4.3l.51.79A5.5 5.5 0 1 1 17 12h1.2l-3.16-4.92a1.25 1.25 0 0 0-2.1-.01l-9.56 14.6a.75.75 0 0 1-1.26-.83zM17 13.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
]);
const $bd5c6ab3f2a8957d$export$9886afd0d4fb99da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect32Filled', "32", [
    "M15.16 7.9a1 1 0 0 1 1.68 0l3.35 5.1h-.69a6.5 6.5 0 1 0 5.56 3.12l-.37-.62h4.06a1.25 1.25 0 1 0 0-2.5h-5.57l-4.26-6.47a3.5 3.5 0 0 0-5.84 0L2.2 23.06a1.25 1.25 0 0 0 2.08 1.38zm.34 11.6a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
]);
const $bd5c6ab3f2a8957d$export$4f4cda3e4e4e94cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect32Light', "32", [
    "M13.9 7.15a2.5 2.5 0 0 1 4.2 0L21.85 13H19.5a6.5 6.5 0 1 0 5.26 2.68L23.68 14h5.82a.5.5 0 1 0 0-1h-6.46l-4.1-6.39a3.5 3.5 0 0 0-5.89 0L2.08 23.73a.5.5 0 0 0 .84.54zm10.03 9.1.39.6a5.5 5.5 0 1 1-.38-.6"
]);
const $bd5c6ab3f2a8957d$export$4735b26d022465a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autocorrect32Regular', "32", [
    "M14.74 7.69a1.5 1.5 0 0 1 2.52 0L20.7 13h-1.2a6.5 6.5 0 1 0 5.3 2.75l-.46-.75H29a1 1 0 1 0 0-2h-5.92l-4.14-6.4a3.5 3.5 0 0 0-5.88 0L2.16 23.45a1 1 0 1 0 1.68 1.1zM15 19.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0"
]);
const $bd5c6ab3f2a8957d$export$bd094c5ac6aeb8f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot20Filled', "20", [
    "M16 3a3 3 0 0 1 3 3v.1a3 3 0 0 1-1.05 2.28l-7 5.97-1.63 1.4-2 1.71a2.23 2.23 0 0 1-3.62-1.14 2.2 2.2 0 0 1 .25-1.7l3.38-5.54-4.08-1.92A2.18 2.18 0 0 1 4.18 3zM4.8 15.15A1.22 1.22 0 0 0 5.85 17q.46 0 .81-.3l3.66-3.12a2 2 0 0 0-.46-3.3L8.24 9.5zM4.18 4a1.18 1.18 0 0 0-.5 2.25l4.18 1.98.87-1.43a1.84 1.84 0 0 0-1.38-2.79L7.15 4z"
]);
const $bd5c6ab3f2a8957d$export$ffce9b283da18c50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot20Regular', "20", [
    "M16 3a3 3 0 0 1 3 3v.1a3 3 0 0 1-1.05 2.28l-7 5.98-3.64 3.1a2.23 2.23 0 0 1-3.62-1.14 2.2 2.2 0 0 1 .26-1.7l3.38-5.54-4.08-1.92A2.18 2.18 0 0 1 4.18 3zM4.8 15.15A1.22 1.22 0 0 0 5.85 17q.46 0 .81-.3l3.66-3.12a2 2 0 0 0-.46-3.3L8.24 9.5zM9.32 4a2.8 2.8 0 0 1 .26 3.32l-.81 1.34 1.59.75c1 .47 1.64 1.48 1.64 2.59v.14l5.3-4.52A2 2 0 0 0 18 6.1V6a2 2 0 0 0-2-2zM4.18 4a1.18 1.18 0 0 0-.5 2.25l4.18 1.98.87-1.43a1.84 1.84 0 0 0-1.38-2.79L7.15 4z"
]);
const $bd5c6ab3f2a8957d$export$566662dee680db06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot24Filled', "24", [
    "M19.24 3a3.75 3.75 0 0 1 2.43 6.6l-8.7 7.4-.12.1-1.53 1.33-.16.1-3.3 2.8a2.68 2.68 0 0 1-4.06-3.38l4.18-7.18-4.65-2.73A2.7 2.7 0 0 1 4.71 3zM5.1 18.7a1.18 1.18 0 0 0 1.79 1.5l5.04-4.3c.8-.76.7-2.1-.24-2.71l-2.44-1.63zM4.7 4.5a1.2 1.2 0 0 0-.6 2.25l4.64 2.72.9-1.62a2.25 2.25 0 0 0-1.8-3.35H4.71"
]);
const $bd5c6ab3f2a8957d$export$136e397995a68c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot24Regular', "24", [
    "M19.24 3a3.75 3.75 0 0 1 2.43 6.6l-8.7 7.4-.12.1-1.53 1.33-.16.1-3.3 2.8a2.68 2.68 0 0 1-4.06-3.38l4.18-7.18-4.65-2.73A2.7 2.7 0 0 1 4.71 3zM5.1 18.7a1.18 1.18 0 0 0 1.79 1.5l5.04-4.3c.8-.76.7-2.1-.24-2.71l-2.44-1.63zm5.58-14.2a3.7 3.7 0 0 1 .27 4.08l-.94 1.69 2.51 1.67c.83.54 1.3 1.38 1.42 2.26l6.76-5.74a2.25 2.25 0 0 0-1.46-3.96zm-5.97 0a1.2 1.2 0 0 0-.62 2.25l4.65 2.72.9-1.62a2.25 2.25 0 0 0-1.8-3.35H4.71"
]);
const $bd5c6ab3f2a8957d$export$e20b441bfe5e852b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot28Filled', "28", [
    "M22.74 3a4.25 4.25 0 0 1 2.78 7.46l-10.03 8.7q-.17.2-.38.38l-1.94 1.66-.13.09-4.6 3.98a2.98 2.98 0 0 1-4.5-3.77l5.53-9.23-5.91-3.43A3.13 3.13 0 0 1 5.13 3zM5.24 22.27a1.47 1.47 0 0 0 2.22 1.87l6.96-6.04c.8-1 .57-2.5-.57-3.2l-3.1-1.87zM5.12 4.5a1.63 1.63 0 0 0-.82 3.04L10.27 11l1.4-2.32A2.75 2.75 0 0 0 9.34 4.5z"
]);
const $bd5c6ab3f2a8957d$export$fbff0a3c3ddbb3ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot28Regular', "28", [
    "M22.74 3a4.25 4.25 0 0 1 2.78 7.46l-10.03 8.7q-.17.2-.38.38l-1.94 1.66-.13.09-4.6 3.98a2.98 2.98 0 0 1-4.5-3.77l5.53-9.23-5.91-3.43A3.13 3.13 0 0 1 5.13 3zM5.24 22.27a1.47 1.47 0 0 0 2.22 1.87l6.96-6.04c.8-1 .57-2.5-.57-3.2l-3.1-1.87zM12.56 4.5a4.2 4.2 0 0 1 .39 4.96l-1.4 2.3 3.06 1.86a3.6 3.6 0 0 1 1.75 2.79l8.17-7.08a2.75 2.75 0 0 0-1.8-4.83zm-7.44 0a1.63 1.63 0 0 0-.82 3.04L10.27 11l1.4-2.32A2.75 2.75 0 0 0 9.34 4.5z"
]);
const $bd5c6ab3f2a8957d$export$78e5c09c89fed242 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot32Filled', "32", [
    "M25.99 4a5 5 0 0 1 3.18 8.86L16.73 23.1l-1.78 1.47-.08.06-5.51 4.54a3.57 3.57 0 0 1-5.34-4.58l6.1-10.24-6.32-3.64A3.6 3.6 0 0 1 5.6 4zM5.73 25.62a1.57 1.57 0 0 0 2.35 2.02l7.55-6.22.22-.18a2.33 2.33 0 0 0-.34-3.83l-3.65-2.06zM5.6 6a1.6 1.6 0 0 0-.8 2.98l6.37 3.68 1.25-2.13A3 3 0 0 0 9.85 6L7.4 6z"
]);
const $bd5c6ab3f2a8957d$export$f0e6eeeeac7becdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autopilot32Regular', "32", [
    "M25.99 4a5 5 0 0 1 3.18 8.86L16.73 23.1l-1.78 1.47-.08.06-5.51 4.54a3.57 3.57 0 0 1-5.34-4.58l6.1-10.24-6.32-3.64A3.6 3.6 0 0 1 5.6 4zM5.73 25.62a1.57 1.57 0 0 0 2.35 2.02l7.41-6.1.36-.3a2.33 2.33 0 0 0-.34-3.83l-3.65-2.06zM13.82 6a5 5 0 0 1 .33 5.54l-1.24 2.1 3.58 2.03a4.3 4.3 0 0 1 2.17 3.25l9.23-7.6A3 3 0 0 0 26 6zM5.6 6a1.6 1.6 0 0 0-.8 2.98l6.37 3.68 1.25-2.13A3 3 0 0 0 9.85 6L7.4 6z"
]);
const $bd5c6ab3f2a8957d$export$7639bfaa6bf00667 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autosum16Filled', "16", [
    "M2.06 1.96a.8.8 0 0 1 .69-.46h9.5a.75.75 0 0 1 0 1.5H4.51l3.92 4.08c.27.28.27.73 0 1.02l-3.99 4.4h7.81a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.56-1.25L6.86 7.6 2.2 2.77a.8.8 0 0 1-.15-.81"
]);
const $bd5c6ab3f2a8957d$export$c0375ad439db0198 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autosum16Regular', "16", [
    "M2.54 2.3A.5.5 0 0 1 3 2h9.5a.5.5 0 1 1 0 1H4.17l4.08 4.25a.5.5 0 0 1 .02.67L4.07 13h8.43a.5.5 0 1 1 0 1H3a.5.5 0 0 1-.39-.82l4.6-5.56-4.57-4.77a.5.5 0 0 1-.1-.55"
]);
const $bd5c6ab3f2a8957d$export$b5b70572c04a3118 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autosum20Filled', "20", [
    "M3.81 3.7a.8.8 0 0 1 .69-.45h11a.75.75 0 0 1 0 1.5H6.26l4.15 4.3c.26.28.28.72.03 1l-4.34 5.2h9.4a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.58-1.23l4.94-5.9-4.9-5.1a.8.8 0 0 1-.15-.81"
]);
const $bd5c6ab3f2a8957d$export$93729e77ede03ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autosum20Regular', "20", [
    "M4.04 3.8a.5.5 0 0 1 .46-.3h11a.5.5 0 1 1 0 1H5.67l4.56 4.73a.5.5 0 0 1 .02.67l-4.68 5.6h9.93a.5.5 0 1 1 0 1h-11a.5.5 0 0 1-.38-.82L9.2 9.6 4.14 4.35a.5.5 0 0 1-.1-.55"
]);
const $bd5c6ab3f2a8957d$export$3fb5a0af0e4b0e32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autosum24Filled', "24", [
    "M4.83 4.61A1 1 0 0 1 5.75 4h12.5a1 1 0 1 1 0 2H8.11l4.95 5.12a1 1 0 0 1 .04 1.34L7.92 18.5h10.33a1 1 0 1 1 0 2H5.75a1 1 0 0 1-.76-1.65l6-7L5.03 5.7a1 1 0 0 1-.2-1.09"
]);
const $bd5c6ab3f2a8957d$export$c12b5940558a2134 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Autosum24Regular', "24", [
    "M5.06 4.46A.8.8 0 0 1 5.75 4h12.5a.75.75 0 0 1 0 1.5H7.52l5.36 5.54c.27.28.28.71.03 1L7.38 18.5h10.87a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.57-1.24l6.15-7.17L5.2 5.27a.8.8 0 0 1-.15-.81"
]);
const $bd5c6ab3f2a8957d$export$5041d02d6cc2e8b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BubbleMultiple20Filled', "20", [
    "M19 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M9.17 15.6a3.5 3.5 0 1 0 3.74-4.58 6 6 0 0 1-3.74 4.57M12 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0M7.03 7.5a.5.5 0 0 0 .3.64 2.5 2.5 0 0 1 1.53 1.53.5.5 0 1 0 .94-.34A3.5 3.5 0 0 0 7.67 7.2a.5.5 0 0 0-.64.3"
]);
const $bd5c6ab3f2a8957d$export$cb761dc2806994de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BubbleMultiple20Regular', "20", [
    "M15.5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12 4.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M3 10a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-5a5 5 0 1 0 0 10A5 5 0 0 0 7 5m5.5 13a3.5 3.5 0 0 1-3.33-2.4q.49-.2.91-.45A2.5 2.5 0 1 0 12.66 12q.16-.47.25-.98A3.5 3.5 0 0 1 12.5 18M7.67 7.2a.5.5 0 1 0-.34.94 2.5 2.5 0 0 1 1.53 1.53.5.5 0 1 0 .94-.34A3.5 3.5 0 0 0 7.67 7.2"
]);
const $bd5c6ab3f2a8957d$export$53db142d61334bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut16Filled', "16", [
    "M10.84 9.53q.2-.03.41-.03a2.75 2.75 0 1 1-1.79.67L8 7.97l-1.46 2.2A2.74 2.74 0 0 1 4.75 15a2.75 2.75 0 1 1 .41-5.47l1.94-2.9-2.97-4.46a.75.75 0 1 1 1.24-.84zM3.5 12.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m6.5 0a1.25 1.25 0 1 0 .82-1.17h-.01l-.05.02c-.45.2-.76.63-.76 1.15m1.67-11.12c.34.23.43.7.2 1.04L9.8 5.27l-.9-1.35 1.73-2.59a.75.75 0 0 1 1.04-.2"
]);
const $bd5c6ab3f2a8957d$export$4fe3e4399fa6cdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut16Regular', "16", [
    "M11.78 1.08c.23.16.29.47.14.7L9.21 5.85l-.61-.91 2.48-3.72a.5.5 0 0 1 .7-.14m-.95 9.01q.32-.09.67-.09a2.5 2.5 0 1 1-1.57.55L8 7.65l-1.93 2.9a2.5 2.5 0 1 1-.9-.46l2.22-3.35-3.3-4.96a.5.5 0 0 1 .83-.56zM3 12.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m7 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $bd5c6ab3f2a8957d$export$2ffb849e61395181 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut20Filled', "20", [
    "m14.88 3.16-3.1 4.77-.9-1.38 2.74-4.2a.75.75 0 0 1 1.26.8m-2.38 8.6a3.24 3.24 0 0 1 4.5 2.99 3.25 3.25 0 1 1-5.72-2.11L10 10.66l-1.28 1.98a3.25 3.25 0 1 1-1.21-.88l1.6-2.47-3.99-6.13a.75.75 0 0 1 1.26-.82zm.2 1.6a1.75 1.75 0 1 0 .01-.02zM6.24 13a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
]);
const $bd5c6ab3f2a8957d$export$90c4cb25bcf58d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut20Regular', "20", [
    "M5.92 2.23a.5.5 0 0 0-.84.54L9.4 9.43l-1.92 2.96a3 3 0 1 0 .78.64L10 10.35l1.74 2.68a3 3 0 1 0 .78-.64zM14 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4M4 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7.2-6.49-.6-.92 3.48-5.36a.5.5 0 0 1 .84.54z"
]);
const $bd5c6ab3f2a8957d$export$972ae50af2385104 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut24Filled', "24", [
    "M7.83 2.44a1 1 0 0 0-1.66 1.12l4.8 7.11-2.33 3.68A4 4 0 0 0 3 18a4 4 0 1 0 7.2-2.4l1.98-3.12 1.89 2.8A3.99 3.99 0 0 0 17 22a4 4 0 1 0-1.25-7.8l-3.62-5.38zM5 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0m10 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.48-9.21 3.33-5.26a1 1 0 0 0-1.7-1.07L13.3 6.98z"
]);
const $bd5c6ab3f2a8957d$export$9d3851b65fc17e65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut24Regular', "24", [
    "M12.14 9.34 7.37 2.33a.75.75 0 1 0-1.24.84l5.13 7.55-2.4 3.74Q8.02 14 7 14a4 4 0 1 0 3.04 1.4l2.14-3.33 2.06 3.03A3.99 3.99 0 0 0 17 22a4 4 0 1 0-1.5-7.71l-2.44-3.6zM4.5 18a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m10 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-.56-8.68 3.94-6.17a.75.75 0 1 0-1.26-.8l-3.6 5.62z"
]);
const $bd5c6ab3f2a8957d$export$4adc3dd36f0aa347 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut28Filled', "28", [
    "M7.45 2.17a1 1 0 0 1 1.38.28l9.29 13.92A5 5 0 0 1 25 21a5 5 0 1 1-8.55-3.52L14 13.8l-2.45 3.68A4.98 4.98 0 0 1 8 26a5 5 0 1 1 1.88-9.63L12.8 12 7.17 3.55a1 1 0 0 1 .28-1.38M8 18a3 3 0 1 0 1.81.6l-.15-.1A3 3 0 0 0 8 18m12 0q-.94.02-1.66.5l-.15.1A3 3 0 1 0 20 18m-.83-15.55a1 1 0 0 1 1.66 1.1L15.8 11.1l-1.2-1.8z"
]);
const $bd5c6ab3f2a8957d$export$595f4c41c8d2fabd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut28Regular', "28", [
    "M7.33 2.13a.75.75 0 0 1 1 .14l.04.06 9.5 14.15A4.98 4.98 0 0 1 25 21a5 5 0 1 1-8.38-3.69L14 13.41l-2.62 3.9A4.99 4.99 0 0 1 8 26a5 5 0 1 1 2.13-9.52l2.97-4.42-5.97-8.9-.04-.06a.75.75 0 0 1 .24-.97M8 17.5a3.5 3.5 0 1 0 2.12.72l-.17-.13A3.5 3.5 0 0 0 8 17.5m12 0c-.72 0-1.4.22-1.95.6l-.17.12A3.5 3.5 0 1 0 20 17.5m-.33-15.23a.75.75 0 0 1 1.24.83l-.04.07-5.37 8-.9-1.35 5.03-7.49z"
]);
const $bd5c6ab3f2a8957d$export$1fa0733dda80480f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut32Filled', "32", [
    "M8.57 2.2c.58-.37 1.35-.2 1.73.37l10.84 16.76A5.49 5.49 0 1 1 23 30a5.5 5.5 0 0 1-3.96-9.32L16 15.98l-3.04 4.7A5.48 5.48 0 0 1 9 30a5.5 5.5 0 1 1 1.86-10.67l3.65-5.65L8.2 3.93c-.37-.58-.2-1.35.37-1.73M9 21.5a3 3 0 1 0 1.78.59l-.15-.11A3 3 0 0 0 9 21.5m14 0q-.91.01-1.63.48l-.15.1A3 3 0 1 0 23 21.5M21.7 2.57a1.25 1.25 0 0 1 2.1 1.36l-5.42 8.37L16.9 10z"
]);
const $bd5c6ab3f2a8957d$export$89e2b916894de490 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut32Light', "32", [
    "M8.22 2.08a.5.5 0 0 1 .63.07l.07.07L20.4 19.65a5.5 5.5 0 1 1-.84.55L16 14.8l-3.57 5.41a5.49 5.49 0 1 1-.84-.55l3.81-5.77-7.32-11.1-.04-.1a.5.5 0 0 1 .18-.6M9 20a4.5 4.5 0 1 0 2.7.9l-.22-.16A4.5 4.5 0 0 0 9 20m14 0q-1.4.02-2.48.74l-.22.16A4.5 4.5 0 1 0 23 20m.15-17.85a.5.5 0 0 1 .81.54l-.04.09-6.72 10.19-.6-.9 6.48-9.85z"
]);
const $bd5c6ab3f2a8957d$export$e51940a7f7e274eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut32Regular', "32", [
    "M8.45 2.16a1 1 0 0 1 1.33.21l.06.08 11.05 16.97a5.48 5.48 0 0 1 7.61 5.08 5.5 5.5 0 1 1-9.29-3.99L16 15.58l-3.21 4.93A5.49 5.49 0 0 1 9 30a5.5 5.5 0 1 1 2.11-10.58l3.7-5.67-6.65-10.2-.05-.1a1 1 0 0 1 .34-1.29M9 21a3.5 3.5 0 1 0 2.09.69l-.18-.12A3.5 3.5 0 0 0 9 21m14 0c-.7 0-1.36.2-1.9.57l-.19.12A3.5 3.5 0 1 0 23 21m-.78-18.63a1 1 0 0 1 1.67 1.09l-.05.09-5.75 8.83-1.2-1.84 5.27-8.09z"
]);
const $bd5c6ab3f2a8957d$export$34778a56eddc7b7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut48Filled', "48", [
    "M12.66 4.25a1.5 1.5 0 0 1 2 .29l.09.12 16.11 23.98a8 8 0 1 1-2.49 1.68L24 23.8l-4.37 6.5a8 8 0 1 1-2.49-1.68l5.05-7.51-9.94-14.78-.07-.14a1.5 1.5 0 0 1 .48-1.95M14 31a5 5 0 1 0 3.03 1.03l-.24-.18A5 5 0 0 0 14 31m20 0c-1.03 0-2 .31-2.79.85l-.24.18A4.99 4.99 0 1 0 34 31m-.65-26.46a1.5 1.5 0 0 1 2.47 1.67l-.07.13L27 19.33l-1.8-2.69 8.04-11.98z"
]);
const $bd5c6ab3f2a8957d$export$741d292ff8fbae18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cut48Regular', "48", [
    "M12.8 4.21a1.25 1.25 0 0 1 1.74.35l16.12 24.17a8 8 0 1 1-2.08 1.4L24 23.24l-4.58 6.87a8 8 0 1 1-2.08-1.4l5.16-7.72L12.46 5.94a1.25 1.25 0 0 1 .35-1.73M14 30.5a5.5 5.5 0 1 0 3.32 1.12l-.27-.2A5.5 5.5 0 0 0 14 30.5m20 0c-1.13 0-2.18.34-3.05.92l-.27.2A5.49 5.49 0 1 0 34 30.5m-.54-25.94a1.25 1.25 0 0 1 2.08 1.38L26.7 19.2l-1.5-2.26z"
]);
const $bd5c6ab3f2a8957d$export$6ed9787fc2e2c83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeDown20Filled', "20", [
    "M6.28 17.78c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06L5 15.44V5.75a.75.75 0 0 1 1.5 0v9.69l1.22-1.22a.75.75 0 1 1 1.06 1.06zM2 5.75c0 1.44.81 2.69 2 3.32v-1.9q-.48-.6-.5-1.42a2.25 2.25 0 1 1 4 1.41v1.9A3.75 3.75 0 1 0 2 5.76m10.5 3.32a3.75 3.75 0 1 1 3.5 0v-1.9q.48-.6.5-1.42a2.25 2.25 0 1 0-4 1.41zm2.28 8.71c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.22 1.22V5.75a.75.75 0 0 1 1.5 0v9.69l1.22-1.22a.75.75 0 1 1 1.06 1.06z"
]);
const $bd5c6ab3f2a8957d$export$ddbd7dc0e76b7c4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeDown20Regular', "20", [
    "M5.85 17.85a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7L5 16.29V5.5a.5.5 0 0 1 1 0v10.8l2.15-2.15a.5.5 0 0 1 .7.7zm9 0a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7L14 16.29V5.5a.5.5 0 0 1 1 0v10.8l2.15-2.15a.5.5 0 0 1 .7.7zM11 5.5c0 1.4.82 2.6 2 3.16V7.5a2.5 2.5 0 1 1 3 0v1.16a3.5 3.5 0 1 0-5-3.16M4 8.66a3.5 3.5 0 1 1 3 0V7.5a2.5 2.5 0 1 0-3 0z"
]);
const $bd5c6ab3f2a8957d$export$c0d7dcdfaf5e9507 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeDown24Filled', "24", [
    "M18.2 21.7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.4l1.3 1.29V7a1 1 0 1 1 2 0v11.59l1.3-1.3a1 1 0 1 1 1.4 1.42zM12.5 7a5 5 0 0 0 3 4.58V9.24a3 3 0 0 1 2-5.24 3 3 0 0 1 2 5.24v2.34a5 5 0 1 0-7-4.58m-8 4.58a5 5 0 1 1 4 0V9.24A3 3 0 0 0 6.5 4a3 3 0 0 0-2 5.24zm2.7 10.13a1 1 0 0 1-1.4 0l-3-3a1 1 0 1 1 1.4-1.42l1.3 1.3V7a1 1 0 0 1 2 0v11.59l1.3-1.3a1 1 0 1 1 1.4 1.42z"
]);
const $bd5c6ab3f2a8957d$export$173288385c79d548 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeDown24Regular', "24", [
    "M6.75 6c.38 0 .7.28.74.65l.01.1v12.69l2.22-2.22a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08-3.5 3.5a.75.75 0 0 1-.98.07l-.08-.07-3.5-3.5a.75.75 0 0 1 .98-1.13l.08.07L6 19.44V6.75c0-.41.34-.75.75-.75m10.5 0c.38 0 .7.28.74.65v12.79l2.23-2.22a.75.75 0 0 1 .97-.07l.09.07c.26.27.29.68.07.98l-.07.08-3.5 3.5a.75.75 0 0 1-.98.07l-.08-.07-3.5-3.5a.75.75 0 0 1 .97-1.13l.09.07 2.22 2.22V6.75c0-.41.33-.75.75-.75M6.75 2a4.75 4.75 0 0 1 1.75 9.17V9.49a3.25 3.25 0 1 0-3.5 0v1.68A4.75 4.75 0 0 1 6.75 2m10.5 0A4.75 4.75 0 0 1 19 11.17V9.49a3.25 3.25 0 1 0-3.5 0v1.68A4.75 4.75 0 0 1 17.25 2"
]);
const $bd5c6ab3f2a8957d$export$f96a8195415ccb55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeUp20Filled', "20", [
    "M6.28 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06L5 4.56v9.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 0 0 1.06-1.06zM2 14.25c0-1.44.81-2.69 2-3.32v1.9q-.48.6-.5 1.42a2.25 2.25 0 1 0 4-1.41v-1.9A3.75 3.75 0 1 1 2 14.24m10.5-3.32a3.75 3.75 0 1 0 3.5 0v1.9q.48.6.5 1.42a2.25 2.25 0 1 1-4-1.41zm2.28-8.71a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v9.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06z"
]);
const $bd5c6ab3f2a8957d$export$571dfcaceceb6c5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeUp20Regular', "20", [
    "M5.85 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L5 3.71V14.5a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 1 0 .7-.7zm9 0a.5.5 0 0 0-.7 0l-3 3a.5.5 0 0 0 .7.7L14 3.71V14.5a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 0 0 .7-.7zM11 14.5c0-1.4.82-2.6 2-3.16v1.16a2.5 2.5 0 1 0 3 0v-1.16a3.5 3.5 0 1 1-5 3.16m-7-3.16a3.5 3.5 0 1 0 3 0v1.16a2.5 2.5 0 1 1-3 0z"
]);
const $bd5c6ab3f2a8957d$export$a71f0c57754595ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeUp24Filled', "24", [
    "M18.2 2.3a1 1 0 0 0-1.4 0l-3 3a1 1 0 0 0 1.4 1.4l1.3-1.29V17a1 1 0 1 0 2 0V5.41l1.3 1.3a1 1 0 1 0 1.4-1.42zM12.5 17a5 5 0 0 1 3-4.58v2.34a3 3 0 0 0 2 5.24 3 3 0 0 0 2-5.24v-2.34a5 5 0 1 1-7 4.58m-8-4.58a5 5 0 1 0 4 0v2.34a3 3 0 0 1-2 5.24 3 3 0 0 1-2-5.24zM7.2 2.29a1 1 0 0 0-1.4 0l-3 3a1 1 0 0 0 1.4 1.42l1.3-1.3V17a1 1 0 1 0 2 0V5.41l1.3 1.3a1 1 0 0 0 1.4-1.42z"
]);
const $bd5c6ab3f2a8957d$export$3831dbb2da273d16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleSwipeUp24Regular', "24", [
    "M6.75 18c.38 0 .7-.28.74-.65l.01-.1V4.56l2.22 2.22c.27.27.68.3.98.07l.08-.07a.75.75 0 0 0 .07-.98l-.07-.08-3.5-3.5a.75.75 0 0 0-.98-.07l-.08.07-3.5 3.5a.75.75 0 0 0 .98 1.13l.08-.07L6 4.56v12.69c0 .41.34.75.75.75m10.5 0c.38 0 .7-.28.74-.65V4.56l2.23 2.22c.26.27.68.3.97.07l.09-.07c.26-.27.29-.68.07-.98l-.07-.08-3.5-3.5a.75.75 0 0 0-.98-.07l-.08.07-3.5 3.5a.75.75 0 0 0 .97 1.13l.09-.07 2.22-2.22v12.69c0 .41.33.75.75.75m-10.5 4a4.75 4.75 0 0 0 1.75-9.17v1.68a3.25 3.25 0 1 1-3.5 0v-1.68A4.75 4.75 0 0 0 6.75 22m10.5 0A4.75 4.75 0 0 0 19 12.83v1.68a3.25 3.25 0 1 1-3.5 0v-1.68A4.75 4.75 0 0 0 17.25 22"
]);
const $bd5c6ab3f2a8957d$export$4e86f26717ffd81d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeDown16Filled', "16", [
    "M4 5.5a4 4 0 1 1 5.75 3.6v1.62a5.5 5.5 0 1 0-3.5 0V9.1A4 4 0 0 1 4 5.5m7 0a3 3 0 0 1-1.25 2.44V5.75a1.75 1.75 0 1 0-3.5 0v2.19A3 3 0 1 1 11 5.5m-2.25.25a.75.75 0 0 0-1.5 0v7.19l-1.22-1.22a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22z"
]);
const $bd5c6ab3f2a8957d$export$d5086d10f522a788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeDown16Regular', "16", [
    "M4.5 5.5a3.5 3.5 0 1 1 5 3.16v1.08a4.5 4.5 0 1 0-3 0V8.66a3.5 3.5 0 0 1-2-3.16m6 0c0 .82-.4 1.54-1 2v-2a1.5 1.5 0 1 0-3 0v2a2.5 2.5 0 1 1 4-2m-2 0a.5.5 0 0 0-1 0v7.8l-1.65-1.65a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L8.5 13.29z"
]);
const $bd5c6ab3f2a8957d$export$e99d72ea63b91c3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeDown20Filled', "20", [
    "M10.53 17.78c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.22 1.22V7.75a.75.75 0 1 1 1.5 0v7.69l1.22-1.22a.75.75 0 1 1 1.06 1.06zM4.25 7.5a5.75 5.75 0 0 0 4 5.48v-1.6a4.25 4.25 0 1 1 3.5 0v1.6a5.75 5.75 0 1 0-7.5-5.48m2.5 0c0 1.15.6 2.16 1.5 2.74V7.5a1.75 1.75 0 1 1 3.5.13v2.61a3.25 3.25 0 1 0-5-2.74"
]);
const $bd5c6ab3f2a8957d$export$e2e2b7240f16d6ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeDown20Regular', "20", [
    "M10.35 17.85a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7l2.15 2.14V7.5a.5.5 0 0 1 1 0v8.8l2.15-2.15a.5.5 0 0 1 .7.7zM4.5 7.5a5.5 5.5 0 0 0 4 5.3v-1.06a4.5 4.5 0 1 1 3 0v1.05a5.5 5.5 0 1 0-7-5.29m2 0c0 1.4.82 2.6 2 3.16V9.5a2.5 2.5 0 1 1 3 0v1.16a3.5 3.5 0 1 0-5-3.16"
]);
const $bd5c6ab3f2a8957d$export$89edd7f7e02b8ba9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeDown24Filled', "24", [
    "M12.7 21.7a1 1 0 0 1-1.4 0l-3-3a1 1 0 1 1 1.4-1.4l1.3 1.29V9a1 1 0 1 1 2 0v9.59l1.3-1.3a1 1 0 0 1 1.4 1.42zM4.5 9a7.5 7.5 0 0 0 5.5 7.23v-2.1a5.5 5.5 0 1 1 4 0v2.1A7.5 7.5 0 1 0 4.5 9m3 0a4.5 4.5 0 0 0 2.5 4.03V10.5q-.48-.64-.5-1.5a2.5 2.5 0 1 1 4.5 1.5v2.53A4.5 4.5 0 1 0 7.5 9"
]);
const $bd5c6ab3f2a8957d$export$d10ab1f4881a48a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeDown24Regular', "24", [
    "M12.53 21.78c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V8.75a.75.75 0 0 1 1.5 0v10.69l2.22-2.22a.75.75 0 1 1 1.06 1.06zM5 9a7 7 0 0 0 5.25 6.78v-1.56a5.5 5.5 0 1 1 3.5 0v1.56A7 7 0 1 0 5 9m2.5 0a4.5 4.5 0 0 0 2.75 4.15v-1.71a3 3 0 1 1 3.5 0v1.7A4.5 4.5 0 1 0 7.5 9"
]);
const $bd5c6ab3f2a8957d$export$2199e3b625f93fa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeUp16Filled', "16", [
    "M4 10.5a4 4 0 1 0 5.75-3.6V5.28a5.5 5.5 0 1 1-3.5 0V6.9A4 4 0 0 0 4 10.5m7 0a3 3 0 0 0-1.25-2.44v2.19a1.75 1.75 0 1 1-3.5 0V8.06A3 3 0 1 0 11 10.5m-2.25-.25a.75.75 0 0 1-1.5 0V3.06L6.03 4.28a.75.75 0 0 1-1.06-1.06l2.5-2.5c.3-.3.77-.3 1.06 0l2.5 2.5a.75.75 0 1 1-1.06 1.06L8.75 3.06z"
]);
const $bd5c6ab3f2a8957d$export$7f74b6e4f1b8f30a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeUp16Regular', "16", [
    "M4.5 10.5a3.5 3.5 0 1 0 5-3.16V6.26a4.5 4.5 0 1 1-3 0v1.08a3.5 3.5 0 0 0-2 3.16m6 0c0-.82-.4-1.54-1-2v2a1.5 1.5 0 0 1-3 0v-2a2.5 2.5 0 1 0 4 2m-2 0a.5.5 0 0 1-1 0V2.7L5.85 4.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L8.5 2.71z"
]);
const $bd5c6ab3f2a8957d$export$c111cefb9af219f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeUp20Filled', "20", [
    "M10.53 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v7.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06zM4.25 12.5a5.75 5.75 0 0 1 4-5.48v1.6a4.25 4.25 0 1 0 3.5 0v-1.6a5.75 5.75 0 1 1-7.5 5.48m2.5 0c0-1.15.6-2.16 1.5-2.74v2.74a1.75 1.75 0 1 0 3.5 0V9.76a3.25 3.25 0 1 1-5 2.74"
]);
const $bd5c6ab3f2a8957d$export$69377726255484df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeUp20Regular', "20", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L9.5 3.71v8.79a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 0 0 .7-.7zM4.5 12.5a5.5 5.5 0 0 1 4-5.3v1.06a4.5 4.5 0 1 0 3 0V7.2a5.5 5.5 0 1 1-7 5.29m2 0c0-1.4.82-2.6 2-3.16v1.16a2.5 2.5 0 1 0 3 0V9.34a3.5 3.5 0 1 1-5 3.16"
]);
const $bd5c6ab3f2a8957d$export$534e756139880d4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeUp24Filled', "24", [
    "M12.7 2.3a1 1 0 0 0-1.4 0l-3 3a1 1 0 0 0 1.4 1.4L11 5.42V15a1 1 0 1 0 2 0V5.41l1.3 1.3a1 1 0 1 0 1.4-1.42zM4.5 15A7.5 7.5 0 0 1 10 7.77v2.1a5.5 5.5 0 1 0 4 0v-2.1A7.5 7.5 0 1 1 4.5 15m3 0a4.5 4.5 0 0 1 2.5-4.03v2.53q-.48.64-.5 1.5a2.5 2.5 0 1 0 4.5-1.5v-2.53A4.5 4.5 0 1 1 7.5 15"
]);
const $bd5c6ab3f2a8957d$export$95e369909b98c773 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoubleTapSwipeUp24Regular', "24", [
    "M12.53 2.22a.75.75 0 0 0-1.06 0l-3.5 3.5a.75.75 0 0 0 1.06 1.06l2.22-2.22v10.69a.75.75 0 0 0 1.5 0V4.56l2.22 2.22a.75.75 0 1 0 1.06-1.06zM5 15a7 7 0 0 1 5.25-6.78v1.56a5.5 5.5 0 1 0 3.5 0V8.22A7 7 0 1 1 5 15m2.5 0a4.5 4.5 0 0 1 2.75-4.15v1.71a3 3 0 1 0 3.5 0v-1.7A4.5 4.5 0 1 1 7.5 15"
]);
const $bd5c6ab3f2a8957d$export$4059ce1672ac09c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop12Filled', "12", [
    "M6 1a.5.5 0 0 1 .35.15c.26.25 1.04 1.03 1.75 2.07A7 7 0 0 1 9.5 7q-.02 2.01-1.02 3.03c-.66.69-1.55.97-2.48.97s-1.82-.28-2.48-.97Q2.52 9 2.5 7c0-1.4.7-2.76 1.4-3.78a15 15 0 0 1 1.75-2.07A.5.5 0 0 1 6 1"
]);
const $bd5c6ab3f2a8957d$export$81cd749192db347e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop12Regular', "12", [
    "M6 1a.5.5 0 0 1 .35.15c.26.25 1.04 1.03 1.75 2.07A7 7 0 0 1 9.5 7q-.02 2.01-1.02 3.03c-.66.69-1.55.97-2.48.97s-1.82-.28-2.48-.97Q2.52 9 2.5 7c0-1.4.7-2.76 1.4-3.78a15 15 0 0 1 1.75-2.07A.5.5 0 0 1 6 1m0 1.22c-.34.35-.82.9-1.28 1.56A6 6 0 0 0 3.5 7c0 1.16.31 1.9.74 2.34Q4.89 10 6 10t1.76-.66C8.2 8.9 8.5 8.16 8.5 7c0-1.1-.56-2.24-1.22-3.22-.46-.66-.94-1.2-1.28-1.56"
]);
const $bd5c6ab3f2a8957d$export$c530a512dc17aa03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop16Filled', "16", [
    "M7.65 1.15c.2-.2.5-.2.7 0 .27.26 1.41 1.45 2.5 3C11.92 5.68 13 7.67 13 9.5c0 1.78-.58 3.16-1.52 4.1C10.55 14.55 9.3 15 8 15c-1.3 0-2.55-.46-3.48-1.4A5.6 5.6 0 0 1 3 9.5c0-1.83 1.08-3.82 2.15-5.35a24 24 0 0 1 2.5-3"
]);
const $bd5c6ab3f2a8957d$export$d39c9749396c6723 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop16Regular', "16", [
    "M7.65 1.15c.2-.2.5-.2.7 0 .27.26 1.41 1.45 2.5 3C11.92 5.68 13 7.67 13 9.5c0 1.78-.58 3.16-1.52 4.1C10.55 14.55 9.3 15 8 15c-1.3 0-2.55-.46-3.48-1.4A5.6 5.6 0 0 1 3 9.5c0-1.83 1.08-3.82 2.15-5.35a24 24 0 0 1 2.5-3M5.97 4.72C4.92 6.23 4 8 4 9.5c0 1.56.5 2.67 1.22 3.4.73.73 1.72 1.1 2.78 1.1s2.05-.37 2.78-1.1A4.6 4.6 0 0 0 12 9.5c0-1.5-.92-3.27-1.97-4.78-.77-1.1-1.57-2-2.03-2.5-.46.5-1.26 1.4-2.03 2.5"
]);
const $bd5c6ab3f2a8957d$export$2824f63a3478c033 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop20Filled', "20", [
    "M9.65 2.15c.2-.2.5-.2.7 0 .54.53 1.8 2.06 2.95 3.9 1.13 1.82 2.2 4.05 2.2 5.95 0 1.84-.53 3.35-1.5 4.4a5.3 5.3 0 0 1-4 1.6c-1.61 0-3-.54-4-1.6A6.3 6.3 0 0 1 4.5 12c0-1.9 1.07-4.13 2.2-5.95a25 25 0 0 1 2.95-3.9"
]);
const $bd5c6ab3f2a8957d$export$a02524aa427c3bd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop20Regular', "20", [
    "M9.65 2.15c.2-.2.5-.2.7 0 .54.53 1.8 2.06 2.95 3.9 1.13 1.82 2.2 4.05 2.2 5.95 0 1.84-.53 3.35-1.5 4.4a5.3 5.3 0 0 1-4 1.6c-1.61 0-3-.54-4-1.6A6.3 6.3 0 0 1 4.5 12c0-1.9 1.07-4.13 2.2-5.95a25 25 0 0 1 2.95-3.9m-2.1 4.43C6.43 8.38 5.5 10.4 5.5 12c0 1.66.47 2.9 1.24 3.72A4.3 4.3 0 0 0 10 17a4.3 4.3 0 0 0 3.26-1.28A5.3 5.3 0 0 0 14.5 12c0-1.6-.93-3.62-2.05-5.42A27 27 0 0 0 10 3.24c-.59.67-1.56 1.9-2.45 3.34"
]);
const $bd5c6ab3f2a8957d$export$fc779fe499509f96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop24Filled', "24", [
    "M11.47 2.22c.3-.3.77-.3 1.06 0 .4.4 2 2.13 3.5 4.36C17.5 8.78 19 11.63 19 14.25c0 2.52-.75 4.48-2.04 5.8A6.8 6.8 0 0 1 12 22a6.8 6.8 0 0 1-4.96-1.94C5.74 18.73 5 16.77 5 14.25c0-2.62 1.5-5.46 2.97-7.67 1.5-2.23 3.1-3.96 3.5-4.36"
]);
const $bd5c6ab3f2a8957d$export$274d0bb7d500c19c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop24Regular', "24", [
    "M11.47 2.22c.3-.3.77-.3 1.06 0 .4.4 2 2.13 3.5 4.36C17.5 8.78 19 11.63 19 14.25c0 2.52-.75 4.48-2.04 5.8A6.8 6.8 0 0 1 12 22a6.8 6.8 0 0 1-4.96-1.94C5.74 18.73 5 16.77 5 14.25c0-2.62 1.5-5.46 2.97-7.67 1.5-2.23 3.1-3.96 3.5-4.36m-2.25 5.2c-1.46 2.17-2.72 4.7-2.72 6.83 0 2.23.65 3.77 1.62 4.76.96.98 2.32 1.49 3.88 1.49s2.92-.5 3.88-1.5c.97-.98 1.62-2.52 1.62-4.75 0-2.13-1.26-4.66-2.72-6.83A33 33 0 0 0 12 3.85c-.65.73-1.74 2.02-2.78 3.57"
]);
const $bd5c6ab3f2a8957d$export$be5f9fc44c0d3d11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop28Filled', "28", [
    "M13.47 2.22c.3-.3.77-.3 1.06 0 .52.52 2.5 2.61 4.34 5.32 1.82 2.66 3.63 6.08 3.63 9.21 0 3.04-.92 5.37-2.49 6.95A8.3 8.3 0 0 1 14 26c-2.3 0-4.44-.73-6.01-2.3-1.57-1.58-2.49-3.9-2.49-6.95 0-3.13 1.8-6.55 3.63-9.21 1.85-2.7 3.82-4.8 4.34-5.32"
]);
const $bd5c6ab3f2a8957d$export$ac9deb14369bdc96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop28Regular', "28", [
    "M13.47 2.22c.3-.3.77-.3 1.06 0 .52.52 2.5 2.61 4.34 5.32 1.82 2.66 3.63 6.08 3.63 9.21 0 3.04-.92 5.37-2.49 6.95A8.3 8.3 0 0 1 14 26c-2.3 0-4.44-.73-6.01-2.3-1.57-1.58-2.49-3.9-2.49-6.95 0-3.13 1.8-6.55 3.63-9.21 1.85-2.7 3.82-4.8 4.34-5.32M14 3.84c-.8.87-2.26 2.53-3.63 4.54C8.57 11.02 7 14.1 7 16.75c0 2.74.82 4.65 2.05 5.89A6.8 6.8 0 0 0 14 24.5c1.98 0 3.71-.63 4.95-1.86C20.18 21.4 21 19.49 21 16.75c0-2.65-1.57-5.73-3.37-8.37A41 41 0 0 0 14 3.84"
]);
const $bd5c6ab3f2a8957d$export$eb348c86439ec9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop32Filled', "32", [
    "M26 20a10 10 0 0 1-20 0c0-4.3 2.4-8.77 4.68-12.06a47 47 0 0 1 4.2-5.22C15.2 2.39 15.5 2 16 2s.8.39 1.12.72q.38.4 1.04 1.16c.86 1 2.01 2.4 3.16 4.06C23.6 11.23 26 15.7 26 20"
]);
const $bd5c6ab3f2a8957d$export$6ebee88bd7c9a7e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop32Regular', "32", [
    "M24 20c0-3.66-2.1-7.7-4.32-10.92A45 45 0 0 0 16 4.46a42 42 0 0 0-3.68 4.62C10.1 12.3 8 16.34 8 20a8 8 0 1 0 16 0m2 0a10 10 0 0 1-20 0c0-4.3 2.4-8.77 4.68-12.06a47 47 0 0 1 4.2-5.22C15.2 2.39 15.5 2 16 2s.8.39 1.12.72q.38.4 1.04 1.16c.86 1 2.01 2.4 3.16 4.06C23.6 11.23 26 15.7 26 20"
]);
const $bd5c6ab3f2a8957d$export$12d636c3f406ada4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop48Filled', "48", [
    "M24 4q.51 0 .88.37l.24.23a68 68 0 0 1 7.17 8.23c3.13 4.3 6.21 9.88 6.21 15.42 0 5.38-1.6 9.36-4.31 12C31.49 42.85 27.83 44 24 44s-7.48-1.14-10.19-3.76S9.5 33.63 9.5 28.25c0-5.54 3.01-11.06 6.11-15.33 2.9-3.98 6-7.06 7.24-8.29l.27-.26c.23-.24.55-.37.88-.37"
]);
const $bd5c6ab3f2a8957d$export$5b02a844e26a579e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Drop48Regular', "48", [
    "M24 4q.51 0 .88.37l.24.23a68 68 0 0 1 7.17 8.23c3.13 4.3 6.21 9.88 6.21 15.42 0 5.38-1.6 9.36-4.31 12C31.49 42.85 27.83 44 24 44s-7.48-1.14-10.19-3.76S9.5 33.63 9.5 28.25c0-5.54 3.01-11.06 6.11-15.33 2.9-3.98 6-7.06 7.24-8.29l.27-.26c.23-.24.55-.37.88-.37m-6.36 10.4C14.6 18.55 12 23.53 12 28.24c0 4.87 1.44 8.14 3.55 10.2 2.13 2.06 5.1 3.05 8.45 3.05s6.32-.99 8.45-3.05c2.11-2.06 3.55-5.33 3.55-10.2 0-4.71-2.67-9.75-5.73-13.95A64 64 0 0 0 24 7a64 64 0 0 0-6.36 7.38"
]);
const $bd5c6ab3f2a8957d$export$44eddb37aff1eee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastAcceleration20Filled', "20", [
    "M8.9 7.2a3.5 3.5 0 0 1 4.2 0l-1.08 1.08a2 2 0 0 0-2.04 0zM13 10a2 2 0 0 0-.28-1.02L13.8 7.9a3.5 3.5 0 0 1 0 4.2l-1.08-1.08A2 2 0 0 0 13 10m-2 2a2 2 0 0 0 1.02-.28l1.08 1.08a3.5 3.5 0 0 1-4.2 0l1.08-1.08A2 2 0 0 0 11 12m-2-2q0 .56.28 1.02L8.2 12.1a3.5 3.5 0 0 1 0-4.2l1.08 1.08A2 2 0 0 0 9 10M6.1 5a7 7 0 0 0-1.43 8H3.5a.5.5 0 0 0 0 1h1.75q.39.54.85 1H1.5a.5.5 0 0 0 0 1h5.9a7 7 0 1 0 0-12H2.5a.5.5 0 0 0 0 1zM11 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $bd5c6ab3f2a8957d$export$997d18b398fa7ea4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastAcceleration20Regular', "20", [
    "M11 4a6 6 0 1 1-3.3 11.01V15h-.02A6 6 0 0 1 11 4M5.25 14q.39.54.85 1H1.5a.5.5 0 0 0 0 1h5.9a7 7 0 1 0 0-12H2.5a.5.5 0 0 0 0 1h3.6a7 7 0 0 0-1.43 8H3.5a.5.5 0 0 0 0 1zM8.2 7.9a3.5 3.5 0 0 0 0 4.2l1.08-1.08a2 2 0 0 1 0-2.04zm.7-.7 1.08 1.08a2 2 0 0 1 2.04 0L13.1 7.2a3.5 3.5 0 0 0-4.2 0m4.9.7-1.08 1.08a2 2 0 0 1 0 2.04l1.08 1.08a3.5 3.5 0 0 0 0-4.2m-.7 4.9-1.08-1.08a2 2 0 0 1-2.04 0L8.9 12.8a3.5 3.5 0 0 0 4.2 0M6.5 10a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m3.5 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $bd5c6ab3f2a8957d$export$c2ba2ad37b1eb490 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastAcceleration24Filled', "24", [
    "M13.5 4a8.5 8.5 0 1 1-4.82 15.5H1.75a.75.75 0 0 1-.1-1.5h5.37q-.6-.69-1.02-1.5H3.75a.75.75 0 0 1-.1-1.5h1.72a8.5 8.5 0 0 1 1.65-8H2.75a.75.75 0 0 1-.1-1.5h6.03A8.5 8.5 0 0 1 13.5 4m1.15 10.72a2.5 2.5 0 0 1-2.3 0l-1.09 1.1a4 4 0 0 0 4.5 0zM9.5 12.5c0 .84.26 1.62.7 2.26l1.09-1.1a2.5 2.5 0 0 1 0-2.32l-1.1-1.09c-.43.65-.69 1.42-.69 2.25m7.32-2.24-1.1 1.1a2.5 2.5 0 0 1 0 2.3l1.1 1.1a4 4 0 0 0 0-4.5M13.5 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3q-1.26.02-2.25.7l1.1 1.08a2.5 2.5 0 0 1 2.32 0l1.09-1.08a4 4 0 0 0-2.26-.7"
]);
const $bd5c6ab3f2a8957d$export$8f41e8f231560993 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastAcceleration24Regular', "24", [
    "M13.5 4a8.5 8.5 0 1 1-4.82 15.5H1.75a.75.75 0 0 1-.1-1.5h5.37q-.6-.69-1.02-1.5H3.75a.75.75 0 0 1-.1-1.5h1.72a8.5 8.5 0 0 1 1.65-8H2.75a.75.75 0 0 1-.1-1.5h6.03A8.5 8.5 0 0 1 13.5 4m0 1.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 1.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m1.15 7.72a2.5 2.5 0 0 1-2.3 0l-1.09 1.1a4 4 0 0 0 4.5 0zM9.5 12.5c0 .84.26 1.62.7 2.26l1.09-1.1a2.5 2.5 0 0 1 0-2.32l-1.1-1.09c-.43.65-.69 1.42-.69 2.25m7.32-2.24-1.1 1.1a2.5 2.5 0 0 1 0 2.3l1.1 1.1a4 4 0 0 0 0-4.5M13.5 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-3q-1.26.02-2.25.7l1.1 1.08a2.5 2.5 0 0 1 2.32 0l1.09-1.08a4 4 0 0 0-2.26-.7"
]);
const $bd5c6ab3f2a8957d$export$dacc575728f57f1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward16Filled', "16", [
    "M8 4.46a1 1 0 0 1 1.58-.81l5 3.53a1 1 0 0 1 0 1.64l-5 3.53A1 1 0 0 1 8 11.54v-2.3l-4.42 3.11A1 1 0 0 1 2 11.54V4.46a1 1 0 0 1 1.58-.81L8 6.77z"
]);
const $bd5c6ab3f2a8957d$export$df74eb0f881d97ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward16Regular', "16", [
    "M2 4.46a1 1 0 0 1 1.58-.81L8 6.77v-2.3a1 1 0 0 1 1.58-.82l5 3.53a1 1 0 0 1 0 1.64l-5 3.53A1 1 0 0 1 8 11.54v-2.3l-4.42 3.11A1 1 0 0 1 2 11.54zM8 8 3 4.46v7.08L8 8zm1 3.55L14.01 8 9 4.46z"
]);
const $bd5c6ab3f2a8957d$export$5cfb478a1af63ddf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward20Filled', "20", [
    "M10.02 5.49a1 1 0 0 1 1.59-.81l5.88 4.31c.68.5.68 1.52 0 2.02l-5.88 4.3a1 1 0 0 1-1.6-.8v-3.16l-5.4 3.97a1 1 0 0 1-1.6-.8V5.48a1 1 0 0 1 1.6-.81l5.4 3.97z"
]);
const $bd5c6ab3f2a8957d$export$5c817fb213fa09c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward20Regular', "20", [
    "M10.02 5.49a1 1 0 0 1 1.59-.81l5.88 4.31c.68.5.68 1.52 0 2.02l-5.88 4.3a1 1 0 0 1-1.6-.8v-3.16l-5.4 3.97a1 1 0 0 1-1.6-.8V5.48a1 1 0 0 1 1.6-.81l5.4 3.97zm6.88 4.3-5.88-4.3v9.02l5.88-4.3c.13-.1.13-.31 0-.41m-7 0L4.02 5.5v9.02l5.88-4.3c.13-.1.13-.31 0-.41"
]);
const $bd5c6ab3f2a8957d$export$ba7a82644187c6eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward24Filled', "24", [
    "M13.97 4.36A1.5 1.5 0 0 0 11.5 5.5v4L5.47 4.35A1.5 1.5 0 0 0 3 5.51V18.5c0 .88.7 1.48 1.46 1.5h.09q.49 0 .92-.36l6.03-5.13v3.99a1.5 1.5 0 0 0 2.47 1.14l7.41-6.3c.82-.7.82-1.97 0-2.67z"
]);
const $bd5c6ab3f2a8957d$export$c3fc56103b414841 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward24Regular', "24", [
    "M11.5 5.5a1.5 1.5 0 0 1 2.47-1.14l7.41 6.3c.82.7.82 1.97 0 2.67l-7.4 6.3a1.5 1.5 0 0 1-2.48-1.13v-4l-6.03 5.14A1.5 1.5 0 0 1 3 18.5v-13a1.5 1.5 0 0 1 2.47-1.14L11.5 9.5zm0 5.96-7-5.96v13l7-5.96zm8.91.35L13 5.5V18.5l7.41-6.31a.25.25 0 0 0 0-.38"
]);
const $bd5c6ab3f2a8957d$export$6586272b1abe2b17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward28Filled', "28", [
    "M15.64 4.86A1.63 1.63 0 0 0 13 6.13v4.57L5.64 4.86A1.62 1.62 0 0 0 3 6.13v15.74a1.62 1.62 0 0 0 2.64 1.27L13 17.3v4.57a1.63 1.63 0 0 0 2.64 1.27l9.63-7.64c.97-.77.97-2.23 0-3z"
]);
const $bd5c6ab3f2a8957d$export$502848d885b05edb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForward28Regular', "28", [
    "M13 10.7V6.13a1.63 1.63 0 0 1 2.64-1.27l9.63 7.64c.97.77.97 2.24 0 3l-9.63 7.64A1.63 1.63 0 0 1 13 21.87V17.3l-7.36 5.84A1.63 1.63 0 0 1 3 21.87V6.13a1.62 1.62 0 0 1 2.64-1.27zm0 4.69V12.6L4.7 6.03 4.64 6q-.03 0-.07.02l-.05.04-.02.07v15.74q0 .04.02.07l.05.04.07.02.06-.03zm1.7-9.36L14.64 6q-.03 0-.07.02l-.05.04-.02.07v15.74l.02.07.05.04.07.02.06-.03 9.64-7.64a.42.42 0 0 0 0-.66z"
]);
const $bd5c6ab3f2a8957d$export$f988b9e30991d065 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FastForwardCircle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_fast_forward_circle_24_color__a)",
            "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "M12.53 8.88c0-.71.85-1.13 1.46-.72l4.62 3.12a.86.86 0 0 1 0 1.44l-4.62 3.12c-.61.4-1.46 0-1.46-.72v-2.03l-4.08 2.75c-.6.4-1.45 0-1.45-.72V8.88c0-.71.84-1.13 1.45-.72l4.08 2.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_fast_forward_circle_24_color__b)",
            "d": "M12.53 8.88c0-.71.85-1.13 1.46-.72l4.62 3.12a.86.86 0 0 1 0 1.44l-4.62 3.12c-.61.4-1.46 0-1.46-.72v-2.03l-4.08 2.75c-.6.4-1.45 0-1.45-.72V8.88c0-.71.84-1.13 1.45-.72l4.08 2.75z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_fast_forward_circle_24_color__a",
                "x1": "2.71",
                "x2": "16.52",
                "y1": "5.75",
                "y2": "20.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_fast_forward_circle_24_color__b",
                "x1": "9.25",
                "x2": "10.96",
                "y1": "8.82",
                "y2": "17.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$52b7a713538c8579 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticStrong16Filled', "16", [
    "M6.75 14.25q-.07 0-.16-.02c-.36-.07-3.59-.8-3.59-2.98 0-1.26 1.1-1.86 1.9-2.29C5.66 8.54 6 8.31 6 8s-.33-.54-1.1-.96C4.1 6.6 3 6.01 3 4.75c0-2.18 3.23-2.9 3.6-2.98l.15-.02a.75.75 0 0 1 .15 1.48c-.75.16-2.4.76-2.4 1.52 0 .31.33.54 1.1.96.8.44 1.9 1.03 1.9 2.28 0 1.26-1.1 1.86-1.9 2.29-.77.42-1.1.65-1.1.97 0 .75 1.65 1.36 2.4 1.52a.75.75 0 0 1-.15 1.48m6.23-.6a.75.75 0 0 0-.58-.88c-.75-.16-2.4-.77-2.4-1.52 0-.32.33-.55 1.1-.97.8-.43 1.9-1.02 1.9-2.29 0-1.26-1.1-1.85-1.9-2.28-.77-.42-1.1-.65-1.1-.96 0-.72 1.56-1.34 2.4-1.52a.75.75 0 0 0-.3-1.47c-.37.08-3.6.81-3.6 2.99C8.5 6 9.6 6.6 10.4 7.03c.77.42 1.1.65 1.1.96 0 .32-.33.55-1.1.97-.8.43-1.9 1.03-1.9 2.29 0 2.17 3.23 2.9 3.6 2.98l.15.02c.35 0 .66-.25.73-.6"
]);
const $bd5c6ab3f2a8957d$export$cf3db1de86306162 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticStrong16Regular', "16", [
    "M6.5 14 6.4 14c-.35-.07-3.4-.77-3.4-2.74 0-1.11.98-1.64 1.76-2.07C5.53 8.76 6 8.48 6 8c0-.48-.47-.76-1.24-1.18C3.98 6.4 3 5.86 3 4.75 3 2.77 6.05 2.08 6.4 2a.5.5 0 0 1 .2.98c-.67.14-2.6.77-2.6 1.76 0 .48.47.76 1.24 1.18C6.02 6.36 7 6.88 7 8s-.98 1.65-1.76 2.07c-.77.42-1.24.7-1.24 1.19 0 .99 1.93 1.62 2.6 1.76a.5.5 0 0 1-.1.99m5.49-.4a.5.5 0 0 0-.39-.59c-.67-.14-2.6-.77-2.6-1.76 0-.48.47-.77 1.24-1.19C11.02 9.64 12 9.11 12 8c0-1.1-.98-1.63-1.76-2.06C9.47 5.51 9 5.23 9 4.75c0-1 1.93-1.62 2.6-1.76a.5.5 0 0 0-.2-.98c-.35.07-3.4.76-3.4 2.74 0 1.1.98 1.64 1.76 2.06.77.42 1.24.7 1.24 1.18s-.47.77-1.24 1.2C8.98 9.6 8 10.13 8 11.24c0 1.97 3.05 2.67 3.4 2.74l.1.01a.5.5 0 0 0 .49-.4"
]);
const $bd5c6ab3f2a8957d$export$4c25c2a19d87dc04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticStrong20Filled', "20", [
    "M8.93 3.23a.75.75 0 0 0-.36-1.46h-.02l-.04.02-.62.19c-.4.13-.93.33-1.48.6-.53.27-1.11.62-1.57 1.08A2.6 2.6 0 0 0 4 5.5c0 .78.4 1.37.86 1.8.43.42.98.77 1.46 1.06l.03.03q.79.47 1.26.89c.3.28.39.5.39.72 0 .2-.09.4-.37.65-.29.26-.67.48-1.16.76l-.1.06c-.49.28-1.07.63-1.53 1.09-.47.48-.84 1.1-.84 1.94 0 .77.39 1.39.84 1.84.46.46 1.04.81 1.57 1.08a11 11 0 0 0 2.1.8h.05a.75.75 0 0 0 .37-1.45H8.9l-.54-.17c-.35-.12-.82-.3-1.27-.52-.47-.23-.89-.5-1.18-.8q-.43-.44-.41-.78 0-.5.4-.88a6 6 0 0 1 1.23-.85l.13-.08c.44-.26.96-.55 1.36-.91.47-.42.88-.99.88-1.78 0-.78-.4-1.37-.86-1.8-.43-.42-.98-.77-1.46-1.06l-.03-.03q-.79-.47-1.26-.89c-.3-.28-.39-.5-.39-.72q-.02-.35.4-.78.47-.45 1.19-.8a10 10 0 0 1 1.8-.68zm6.5 0a.75.75 0 0 0-.36-1.46h-.02l-.04.02-.62.19c-.4.13-.93.33-1.48.6-.53.27-1.11.62-1.57 1.08a2.6 2.6 0 0 0-.84 1.84c0 .78.4 1.37.86 1.8.43.42.98.77 1.46 1.06l.03.03q.79.47 1.26.89c.3.28.39.5.39.72 0 .2-.09.4-.37.65-.29.26-.67.48-1.16.76l-.1.06c-.49.28-1.07.63-1.53 1.09-.47.48-.84 1.1-.84 1.94 0 .77.39 1.39.84 1.84.46.46 1.04.81 1.57 1.08a11 11 0 0 0 2.1.8h.05a.75.75 0 0 0 .37-1.45h-.03l-.54-.17c-.35-.12-.82-.3-1.27-.52q-.72-.35-1.18-.8c-.3-.3-.41-.55-.41-.78q0-.5.4-.88a6 6 0 0 1 1.23-.85l.13-.08c.44-.26.96-.55 1.36-.91.47-.42.88-.99.88-1.78 0-.78-.4-1.37-.86-1.8a9 9 0 0 0-1.46-1.06l-.03-.03q-.79-.47-1.26-.89c-.3-.28-.39-.5-.39-.72q-.02-.35.4-.78.47-.45 1.19-.8a10 10 0 0 1 1.8-.68z"
]);
const $bd5c6ab3f2a8957d$export$451f21f04642387 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticStrong20Regular', "20", [
    "M8.62 2.99A.5.5 0 0 0 8.38 2h-.02l-.03.02-.61.18c-.4.13-.92.33-1.44.6-.53.25-1.08.6-1.5 1.02-.44.43-.78 1-.78 1.67 0 .69.35 1.22.78 1.63.41.4.95.73 1.43 1.03l.03.01c.5.32.96.6 1.29.93q.47.44.47.9.01.44-.46.84c-.3.27-.7.5-1.18.78l-.11.07c-.5.28-1.05.61-1.48 1.04A2.4 2.4 0 0 0 4 14.5c0 .68.34 1.24.77 1.67s.98.77 1.5 1.03a11 11 0 0 0 2.06.77l.03.01h.01a.5.5 0 0 0 .25-.96L8.57 17l-.55-.17c-.36-.12-.83-.3-1.3-.54a5 5 0 0 1-1.25-.84Q5 14.98 5 14.5q0-.61.48-1.06.5-.47 1.27-.89l.13-.07c.45-.26.94-.55 1.33-.89.43-.39.79-.9.79-1.59s-.35-1.22-.78-1.63A9 9 0 0 0 6.8 7.34l-.03-.01c-.5-.32-.96-.6-1.29-.93Q5 5.96 5 5.5q0-.48.48-.96c.32-.32.77-.6 1.24-.84A10 10 0 0 1 8.58 3zm6 0a.5.5 0 0 0-.24-.98h-.02l-.03.02-.61.18c-.4.13-.92.33-1.44.6-.53.25-1.08.6-1.5 1.02-.44.43-.78 1-.78 1.67 0 .69.35 1.22.78 1.63.41.4.95.73 1.43 1.03l.02.01c.52.32.97.6 1.3.93q.47.44.47.9.01.44-.46.84c-.3.27-.7.5-1.18.78l-.11.07c-.5.28-1.05.61-1.48 1.04A2.4 2.4 0 0 0 10 14.5c0 .68.34 1.24.77 1.67s.98.77 1.5 1.03a11 11 0 0 0 2.06.77l.03.01h.01a.5.5 0 0 0 .25-.96l-.04-.01-.55-.17c-.36-.12-.83-.3-1.3-.54a5 5 0 0 1-1.25-.84q-.48-.48-.48-.96 0-.61.48-1.06.5-.47 1.27-.89l.13-.07c.45-.26.94-.55 1.33-.89.43-.39.79-.9.79-1.59s-.35-1.22-.78-1.63c-.41-.4-.95-.73-1.43-1.03l-.02-.01c-.52-.32-.97-.6-1.3-.93Q11 5.96 11 5.5q0-.48.48-.96c.32-.32.77-.6 1.24-.84a10 10 0 0 1 1.86-.7z"
]);
const $bd5c6ab3f2a8957d$export$fd204454aee3c11f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticStrong24Filled', "24", [
    "m10 21.25-.2-.02c-.55-.11-5.3-1.2-5.3-4.36 0-1.81 1.6-2.68 2.77-3.32C8.35 12.97 9 12.57 9 12s-.65-.97-1.73-1.55C6.1 9.8 4.5 8.94 4.5 7.12c0-3.16 4.76-4.24 5.3-4.35l.2-.02a1 1 0 0 1 .2 1.98c-1.16.24-3.7 1.18-3.7 2.39 0 .58.65.98 1.72 1.56C9.4 9.3 11 10.18 11 11.99s-1.6 2.69-2.77 3.32c-1.08.58-1.73.98-1.73 1.56 0 1.23 2.5 2.15 3.7 2.4a1 1 0 0 1-.2 1.98m8.98-.8a1 1 0 0 0-.78-1.18c-1.2-.25-3.7-1.17-3.7-2.4 0-.58.65-.98 1.73-1.56 1.17-.63 2.77-1.5 2.77-3.32s-1.6-2.68-2.77-3.31c-1.08-.58-1.73-.98-1.73-1.56 0-1.2 2.54-2.15 3.7-2.39a1 1 0 0 0 .78-1.18 1 1 0 0 0-1.18-.78c-.54.11-5.3 1.2-5.3 4.35 0 1.81 1.6 2.68 2.77 3.32 1.08.58 1.73.97 1.73 1.55s-.65.98-1.73 1.56c-1.17.64-2.77 1.5-2.77 3.32 0 3.16 4.75 4.25 5.3 4.36a1 1 0 0 0 1.18-.78"
]);
const $bd5c6ab3f2a8957d$export$a9b9ca5a8db23268 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticStrong24Regular', "24", [
    "M10.25 21q-.08 0-.15-.02c-.52-.1-5.1-1.15-5.1-4.11 0-1.67 1.47-2.46 2.64-3.1C8.8 13.15 9.5 12.71 9.5 12s-.7-1.15-1.86-1.77C6.47 9.58 5 8.78 5 7.12c0-2.96 4.57-4 5.1-4.1.4-.09.8.17.88.58.09.4-.17.8-.58.89-1 .2-3.9 1.15-3.9 2.63 0 .72.7 1.15 1.86 1.78C9.54 9.54 11 10.33 11 12c0 1.66-1.46 2.45-2.64 3.1-1.16.62-1.86 1.05-1.86 1.77 0 1.5 2.9 2.44 3.9 2.65a.75.75 0 0 1-.15 1.48m8.73-.6a.75.75 0 0 0-.58-.88c-1.01-.22-3.9-1.16-3.9-2.65 0-.72.7-1.15 1.86-1.78 1.18-.64 2.64-1.43 2.64-3.1s-1.47-2.46-2.64-3.1c-1.16-.62-1.86-1.05-1.86-1.77 0-1.48 2.9-2.42 3.9-2.64a.75.75 0 0 0-.3-1.47c-.53.11-5.1 1.15-5.1 4.1 0 1.67 1.47 2.47 2.64 3.1 1.16.63 1.86 1.06 1.86 1.78s-.7 1.15-1.86 1.78c-1.18.64-2.64 1.43-2.64 3.1 0 2.96 4.57 4 5.1 4.11a.75.75 0 0 0 .88-.58"
]);
const $bd5c6ab3f2a8957d$export$35056b92089fb51f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticWeak16Filled', "16", [
    "M10.75 14.25a1 1 0 0 1-.4-.11c-.14-.1-1.35-.92-1.35-2.9 0-1.02.34-1.57.61-2.01.24-.38.39-.63.39-1.24 0-.6-.15-.85-.39-1.23C9.34 6.32 9 5.77 9 4.75c0-2.02 1.3-2.85 1.35-2.89a.75.75 0 0 1 1.03.24c.22.35.12.81-.23 1.03-.02.02-.65.45-.65 1.62 0 .6.15.85.39 1.23.27.44.61.99.61 2.01 0 1.03-.34 1.58-.61 2.02-.23.38-.39.63-.39 1.24 0 1.16.63 1.6.66 1.62.34.23.44.69.22 1.03a.8.8 0 0 1-.63.35m-3.37-.35a.75.75 0 0 0-.22-1.03c-.03-.02-.66-.46-.66-1.62 0-.6.16-.86.4-1.24.26-.44.6-1 .6-2.02s-.34-1.57-.61-2.01c-.23-.38-.39-.63-.39-1.23 0-1.17.63-1.6.66-1.62a.75.75 0 0 0-.8-1.27C6.3 1.9 5 2.73 5 4.75c0 1.02.34 1.57.61 2.02.23.38.39.63.39 1.23s-.15.85-.39 1.23c-.27.44-.61 1-.61 2.02 0 2.02 1.3 2.85 1.35 2.89a.75.75 0 0 0 1.03-.23"
]);
const $bd5c6ab3f2a8957d$export$6f9be4e84efcba4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticWeak16Regular', "16", [
    "M6.23 13.92q.13.09.27.08a.5.5 0 0 0 .27-.92c-.03-.02-.77-.53-.77-1.83 0-.67.19-.98.42-1.37C6.7 9.45 7 8.95 7 8s-.3-1.44-.58-1.88C6.2 5.72 6 5.4 6 4.75c0-1.3.73-1.8.77-1.83a.5.5 0 0 0-.53-.84C6.18 2.1 5 2.87 5 4.75c0 .95.3 1.45.57 1.88.24.4.43.7.43 1.36 0 .68-.19.98-.43 1.37-.27.44-.57.93-.57 1.89 0 1.88 1.18 2.64 1.23 2.67m4 0q.13.09.27.08a.5.5 0 0 0 .27-.92c-.03-.02-.77-.53-.77-1.83 0-.67.19-.98.43-1.37.26-.43.57-.93.57-1.88 0-.96-.3-1.45-.57-1.9-.24-.38-.43-.68-.43-1.35 0-1.3.73-1.8.77-1.83a.5.5 0 0 0-.54-.84C10.2 2.1 9 2.87 9 4.75c0 .95.3 1.45.57 1.88.24.4.43.7.43 1.36 0 .68-.19.98-.43 1.37-.27.44-.57.93-.57 1.89 0 1.88 1.18 2.64 1.23 2.67"
]);
const $bd5c6ab3f2a8957d$export$9985764610dc9f09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticWeak20Filled', "20", [
    "M8.75 18.25q-.15 0-.3-.06c-.1-.04-2.45-1.1-2.45-3.76 0-1.4.66-2.13 1.2-2.72.46-.52.8-.9.8-1.72s-.34-1.19-.8-1.7C6.66 7.68 6 6.95 6 5.55a4.2 4.2 0 0 1 2.46-3.75q.14-.06.29-.06a.75.75 0 0 1 .3 1.44c-.07.03-1.55.7-1.55 2.38 0 .81.34 1.19.8 1.7.54.6 1.2 1.33 1.2 2.72s-.66 2.13-1.2 2.72c-.46.52-.8.9-.8 1.72 0 1.68 1.48 2.35 1.55 2.38q.28.13.4.41.1.3-.01.58a.8.8 0 0 1-.69.45m5.69-.46a.75.75 0 0 0-.4-.98c-.05-.03-1.54-.7-1.54-2.38 0-.82.34-1.2.8-1.72A3.7 3.7 0 0 0 14.5 10c0-1.4-.66-2.13-1.2-2.72-.46-.52-.8-.89-.8-1.7 0-1.69 1.48-2.35 1.55-2.38a.75.75 0 0 0 .39-.98.75.75 0 0 0-.98-.4A4.2 4.2 0 0 0 11 5.56c0 1.4.66 2.13 1.2 2.72.46.52.8.9.8 1.71 0 .82-.34 1.2-.8 1.72a3.7 3.7 0 0 0-1.2 2.72c0 2.67 2.35 3.71 2.46 3.76q.14.06.29.06c.3 0 .57-.18.69-.46"
]);
const $bd5c6ab3f2a8957d$export$1ff202704360f835 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticWeak20Regular', "20", [
    "M8.5 18a1 1 0 0 1-.2-.04A3.9 3.9 0 0 1 6 14.43c0-1.3.6-1.97 1.13-2.55.49-.54.87-.97.87-1.89s-.38-1.34-.87-1.88C6.6 7.53 6 6.86 6 5.56a3.9 3.9 0 0 1 2.3-3.52.5.5 0 1 1 .4.92C8.6 3 7 3.73 7 5.56c0 .92.38 1.34.87 1.88C8.4 8.03 9 8.7 9 10s-.6 1.97-1.13 2.55c-.49.55-.87.97-.87 1.89 0 1.87 1.68 2.6 1.7 2.61a.5.5 0 0 1-.2.96m5.46-.3a.5.5 0 0 0-.26-.66c-.02 0-1.7-.75-1.7-2.61 0-.92.38-1.34.87-1.88.53-.6 1.13-1.26 1.13-2.56s-.6-1.96-1.13-2.55C12.4 6.9 12 6.48 12 5.56c0-1.83 1.61-2.56 1.7-2.6a.5.5 0 0 0-.4-.92c-.09.04-2.3 1-2.3 3.52 0 1.3.6 1.97 1.13 2.55.48.54.87.97.87 1.88 0 .92-.38 1.35-.87 1.88-.53.6-1.13 1.26-1.13 2.56 0 2.52 2.21 3.49 2.3 3.53a.5.5 0 0 0 .66-.26"
]);
const $bd5c6ab3f2a8957d$export$1d7f446e09e29a1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticWeak24Filled', "24", [
    "M15.5 21.25a1 1 0 0 1-.53-.15c-.08-.05-1.97-1.27-1.97-4.23 0-1.5.5-2.31.9-2.96.35-.57.6-.98.6-1.92s-.25-1.34-.6-1.9a5 5 0 0 1-.9-2.97c0-2.97 1.9-4.17 1.97-4.22q.24-.15.53-.15a1 1 0 0 1 .54 1.84C16 4.62 15 5.3 15 7.12c0 .93.25 1.34.6 1.91.42.69.9 1.46.9 2.96s-.5 2.31-.9 2.97c-.35.56-.6.97-.6 1.91 0 1.82 1 2.51 1.05 2.54a1 1 0 0 1 .29 1.38 1 1 0 0 1-.85.46m-6 0a1 1 0 0 0 .54-1.84C10 19.4 9 18.7 9 16.87c0-.93.25-1.34.6-1.91.4-.65.9-1.46.9-2.97 0-1.5-.48-2.27-.9-2.96-.35-.56-.6-.97-.6-1.9 0-1.82 1-2.5 1.04-2.53a1 1 0 0 0-.54-1.85 1 1 0 0 0-.53.15C8.9 2.95 7 4.15 7 7.12c0 1.5.48 2.28.9 2.97.35.56.6.97.6 1.9a3 3 0 0 1-.6 1.92c-.4.65-.9 1.46-.9 2.96 0 2.96 1.89 4.18 1.97 4.23q.24.15.52.15"
]);
const $bd5c6ab3f2a8957d$export$8ea730c8049ec52b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HapticWeak24Regular', "24", [
    "M15.25 21a1 1 0 0 1-.4-.11c-.07-.05-1.85-1.2-1.85-4.02 0-1.43.46-2.18.86-2.83.36-.58.64-1.04.64-2.05s-.28-1.46-.64-2.04c-.4-.66-.86-1.4-.86-2.83 0-2.82 1.78-3.96 1.85-4a.75.75 0 0 1 .8 1.26c-.06.04-1.15.8-1.15 2.74 0 1 .28 1.46.64 2.04.4.66.86 1.4.86 2.83s-.46 2.18-.86 2.83c-.36.58-.64 1.04-.64 2.05 0 1.96 1.1 2.72 1.16 2.75.34.23.44.69.22 1.03a.8.8 0 0 1-.64.35m-5.37-.35a.75.75 0 0 0-.22-1.03c-.05-.03-1.16-.8-1.16-2.75 0-1 .28-1.47.64-2.05.4-.65.86-1.4.86-2.83s-.46-2.17-.86-2.83c-.36-.58-.64-1.03-.64-2.04 0-1.94 1.1-2.7 1.15-2.74a.75.75 0 0 0-.8-1.27C8.78 3.16 7 4.31 7 7.12c0 1.43.46 2.17.86 2.83.36.58.64 1.04.64 2.04s-.28 1.47-.64 2.05c-.4.66-.86 1.4-.86 2.83 0 2.82 1.78 3.97 1.85 4.02q.18.1.4.11c.24 0 .48-.12.63-.35"
]);
const $bd5c6ab3f2a8957d$export$6b5cd6c11d1b6e1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon12Filled', "12", [
    "M4.41 2c-.44 0-.85.24-1.08.63L1.75 5.38c-.23.38-.23.86 0 1.24l1.58 2.75c.23.4.64.63 1.08.63h3.17c.45 0 .86-.24 1.09-.63l1.58-2.75c.23-.38.23-.86 0-1.24L8.67 2.63A1.3 1.3 0 0 0 7.58 2z"
]);
const $bd5c6ab3f2a8957d$export$a1e38db79a73b456 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon12Regular', "12", [
    "M3.33 2.63c.23-.4.64-.63 1.08-.63h3.17c.45 0 .86.24 1.09.63l1.58 2.75c.23.38.23.86 0 1.24L8.67 9.37c-.23.4-.64.63-1.09.63H4.41c-.44 0-.85-.24-1.08-.63L1.75 6.62a1.3 1.3 0 0 1 0-1.24zM4.41 3a.3.3 0 0 0-.21.13L2.6 5.88a.3.3 0 0 0 0 .24L4.2 8.87q.08.13.21.13h3.17q.15 0 .22-.13L9.4 6.12a.3.3 0 0 0 0-.24L7.8 3.13A.3.3 0 0 0 7.58 3z"
]);
const $bd5c6ab3f2a8957d$export$5fe3f3856b24782a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon16Filled', "16", [
    "M5.4 2a1.5 1.5 0 0 0-1.3.75l-2.6 4.5a1.5 1.5 0 0 0 0 1.5l2.6 4.5c.27.46.76.75 1.3.75h5.2a1.5 1.5 0 0 0 1.3-.75l2.6-4.5a1.5 1.5 0 0 0 0-1.5l-2.6-4.5A1.5 1.5 0 0 0 10.6 2z"
]);
const $bd5c6ab3f2a8957d$export$ca19c18d4f54e607 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon16Regular', "16", [
    "M5.4 3a.5.5 0 0 0-.43.25l-2.6 4.5a.5.5 0 0 0 0 .5l2.6 4.5a.5.5 0 0 0 .43.25h5.2a.5.5 0 0 0 .43-.25l2.6-4.5a.5.5 0 0 0 0-.5l-2.6-4.5A.5.5 0 0 0 10.6 3zm-1.3-.25A1.5 1.5 0 0 1 5.4 2h5.2c.54 0 1.03.29 1.3.75l2.6 4.5a1.5 1.5 0 0 1 0 1.5l-2.6 4.5a1.5 1.5 0 0 1-1.3.75H5.4a1.5 1.5 0 0 1-1.3-.75l-2.6-4.5a1.5 1.5 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$c29f6de062013b10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon20Filled', "20", [
    "M6.83 3a1.5 1.5 0 0 0-1.3.75l-3.18 5.5a1.5 1.5 0 0 0 0 1.5l3.18 5.5c.26.46.76.75 1.3.75h6.35a1.5 1.5 0 0 0 1.3-.75l3.17-5.5a1.5 1.5 0 0 0 0-1.5l-3.17-5.5a1.5 1.5 0 0 0-1.3-.75z"
]);
const $bd5c6ab3f2a8957d$export$7416b8b42b1c5582 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon20Regular', "20", [
    "M6.83 4a.5.5 0 0 0-.44.25l-3.17 5.5a.5.5 0 0 0 0 .5l3.17 5.5a.5.5 0 0 0 .44.25h6.35a.5.5 0 0 0 .43-.25l3.17-5.5a.5.5 0 0 0 0-.5l-3.17-5.5a.5.5 0 0 0-.43-.25zm-1.3-.25A1.5 1.5 0 0 1 6.83 3h6.35c.53 0 1.03.29 1.3.75l3.17 5.5a1.5 1.5 0 0 1 0 1.5l-3.17 5.5a1.5 1.5 0 0 1-1.3.75H6.83a1.5 1.5 0 0 1-1.3-.75l-3.18-5.5a1.5 1.5 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$992a7776f3b55d91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon24Filled', "24", [
    "M8.1 3c-.8 0-1.54.43-1.94 1.13l-3.9 6.75c-.4.7-.4 1.55 0 2.24l3.9 6.75c.4.7 1.14 1.13 1.95 1.13h7.79c.8 0 1.54-.43 1.94-1.13l3.9-6.75c.4-.7.4-1.55 0-2.24l-3.9-6.75A2.3 2.3 0 0 0 15.9 3z"
]);
const $bd5c6ab3f2a8957d$export$8dce4d5b7bd591c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon24Regular', "24", [
    "M6.16 4.13C6.56 3.43 7.3 3 8.1 3h7.79c.8 0 1.54.43 1.94 1.13l3.9 6.75c.4.7.4 1.55 0 2.24l-3.9 6.75c-.4.7-1.14 1.13-1.94 1.13H8.1c-.8 0-1.54-.43-1.94-1.13l-3.9-6.75c-.4-.7-.4-1.55 0-2.24zm1.95.37a.8.8 0 0 0-.65.38l-3.9 6.75a.8.8 0 0 0 0 .74l3.9 6.75c.13.24.38.38.65.38h7.79c.26 0 .51-.14.64-.38l3.9-6.75a.8.8 0 0 0 0-.74l-3.9-6.75a.8.8 0 0 0-.64-.38z"
]);
const $bd5c6ab3f2a8957d$export$b8cee5145e27a7fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon28Filled', "28", [
    "M9.39 3c-.97 0-1.87.51-2.37 1.35L2.14 12.6a2.8 2.8 0 0 0 0 2.8l4.88 8.25c.5.84 1.4 1.35 2.37 1.35h9.22c.97 0 1.87-.51 2.37-1.35l4.88-8.25c.52-.86.52-1.94 0-2.8l-4.88-8.25A2.8 2.8 0 0 0 18.6 3zm-7.25 9.6.64.38z"
]);
const $bd5c6ab3f2a8957d$export$1f3f31282d97e4bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon28Regular', "28", [
    "M9.39 4.5c-.44 0-.85.23-1.08.61l-4.88 8.25c-.23.4-.23.88 0 1.28l4.88 8.25c.23.38.64.61 1.08.61h9.22c.44 0 .85-.23 1.08-.61l4.88-8.25c.24-.4.24-.88 0-1.28L19.7 5.11a1.3 1.3 0 0 0-1.08-.61zm-2.37-.15C7.52 3.5 8.42 3 9.4 3h9.22c.97 0 1.87.51 2.37 1.35l4.88 8.25c.52.86.52 1.94 0 2.8l-4.88 8.25c-.5.84-1.4 1.35-2.37 1.35H9.39c-.97 0-1.87-.51-2.37-1.35L2.14 15.4a2.8 2.8 0 0 1 0-2.8z"
]);
const $bd5c6ab3f2a8957d$export$4903bfe7ade356a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon32Filled', "32", [
    "M10.62 3a3 3 0 0 0-2.56 1.43l-6.13 10a3 3 0 0 0 0 3.14l6.13 10A3 3 0 0 0 10.62 29h10.76a3 3 0 0 0 2.55-1.43l6.12-10a3 3 0 0 0 0-3.14l-6.12-10A3 3 0 0 0 21.38 3z"
]);
const $bd5c6ab3f2a8957d$export$d05800cef59bfe77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon32Regular', "32", [
    "M10.62 5a1 1 0 0 0-.85.48l-6.13 10a1 1 0 0 0 0 1.04l6.13 10c.18.3.5.48.85.48h10.76a1 1 0 0 0 .85-.48l6.12-10a1 1 0 0 0 0-1.04l-6.12-10a1 1 0 0 0-.85-.48zm-2.56-.57A3 3 0 0 1 10.62 3h10.76a3 3 0 0 1 2.56 1.43l6.12 10a3 3 0 0 1 0 3.14l-6.12 10A3 3 0 0 1 21.38 29H10.62a3 3 0 0 1-2.56-1.43l-6.12-10a3 3 0 0 1 0-3.14z"
]);
const $bd5c6ab3f2a8957d$export$bae624e33e28938c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon48Filled', "48", [
    "M15.43 6c-1.18 0-2.27.64-2.84 1.67L4.38 22.42a3.3 3.3 0 0 0 0 3.16l8.2 14.75A3.3 3.3 0 0 0 15.44 42h17.15c1.17 0 2.26-.64 2.84-1.67l8.2-14.75c.55-.98.55-2.18 0-3.16l-8.2-14.75A3.3 3.3 0 0 0 32.58 6z"
]);
const $bd5c6ab3f2a8957d$export$19e0490750d2bbb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hexagon48Regular', "48", [
    "M15.43 8.5a.8.8 0 0 0-.66.39l-8.2 14.75a.8.8 0 0 0 0 .72l8.2 14.75c.13.24.38.39.66.39h17.15c.27 0 .52-.15.65-.39l8.2-14.75a.8.8 0 0 0 0-.72l-8.2-14.75a.8.8 0 0 0-.65-.39zm-2.84-.83A3.3 3.3 0 0 1 15.43 6h17.15c1.17 0 2.26.64 2.84 1.67l8.2 14.75c.55.98.55 2.18 0 3.16l-8.2 14.75A3.3 3.3 0 0 1 32.58 42H15.43a3.3 3.3 0 0 1-2.84-1.67L4.38 25.58a3.3 3.3 0 0 1 0-3.16z"
]);
const $bd5c6ab3f2a8957d$export$ec84c6409703b71c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle16Filled', "16", [
    "M6.95 2.15A1.4 1.4 0 0 0 6 3.5q0 .45.26.82t.71.53l1.06.35q.22.06.47.29.16.14.3.47l.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.12.05.21.14.11.1.15.22l.26.8q.15.38.47.62l-.85 1.48a1.5 1.5 0 0 1-1.3.75H5.4a1.5 1.5 0 0 1-1.3-.75l-2.6-4.5a1.5 1.5 0 0 1 0-1.5l2.6-4.5A1.5 1.5 0 0 1 5.4 2h2.03zM13.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.03-.01a.4.4 0 0 1-.13-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $bd5c6ab3f2a8957d$export$3bbfeac45ba89948 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle16Regular', "16", [
    "M6.95 2.15A1.4 1.4 0 0 0 6.1 3H5.4a.5.5 0 0 0-.43.25l-2.6 4.5a.5.5 0 0 0 0 .5l2.6 4.5a.5.5 0 0 0 .43.25h5.2a.5.5 0 0 0 .43-.25l1.13-1.95.12.35q.15.38.47.62l-.85 1.48a1.5 1.5 0 0 1-1.3.75H5.4a1.5 1.5 0 0 1-1.3-.75l-2.6-4.5a1.5 1.5 0 0 1 0-1.5l2.6-4.5A1.5 1.5 0 0 1 5.4 2h2.03zM13.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.03-.01a.4.4 0 0 1-.13-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $bd5c6ab3f2a8957d$export$6529aa65e93a6f0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle20Filled', "20", [
    "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM16.5 12q-.41 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 9 3.5q0-.27.09-.5H6.83a1.5 1.5 0 0 0-1.3.75l-3.18 5.5a1.5 1.5 0 0 0 0 1.5l3.18 5.5c.26.46.76.75 1.3.75h6.35a1.5 1.5 0 0 0 1.3-.75l2.49-4.32q-.22.07-.47.07"
]);
const $bd5c6ab3f2a8957d$export$5e90e0ef6390ce3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle20Regular', "20", [
    "m13.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM16.5 12q-.34 0-.63-.16l-2.26 3.91a.5.5 0 0 1-.43.25H6.83a.5.5 0 0 1-.44-.25l-3.17-5.5a.5.5 0 0 1 0-.5l3.17-5.5A.5.5 0 0 1 6.83 4h2.26a1.4 1.4 0 0 1 0-1H6.83a1.5 1.5 0 0 0-1.3.75l-3.18 5.5a1.5 1.5 0 0 0 0 1.5l3.18 5.5c.26.46.76.75 1.3.75h6.35a1.5 1.5 0 0 0 1.3-.75l2.49-4.32q-.22.07-.47.07"
]);
const $bd5c6ab3f2a8957d$export$ca95f8ec8cd3fe66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle24Filled', "24", [
    "M15.09 6.41a3 3 0 0 0-1.35-.95L12.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12.04 3H8.1c-.8 0-1.55.43-1.95 1.13l-3.9 6.75c-.4.7-.4 1.55 0 2.24l3.9 6.75c.4.7 1.14 1.13 1.95 1.13h7.79c.8 0 1.54-.43 1.94-1.13l3.68-6.37c-.22.32-.53.55-1.02.55h-.04c-.96 0-1.23-.86-1.47-1.6l-.01-.05c-.12-.35-.55-.46-.9-.55l-.25-.07c-.5-.18-.87-.7-.87-1.23q0-.35.18-.66-.32.15-.68.16c-.66 0-1.25-.43-1.46-1.05l-.41-1.45a1.9 1.9 0 0 0-1.19-1.1L12 6c-.58-.25-1-.9-1-1.53 0-.67.42-1.25 1.05-1.47"
]);
const $bd5c6ab3f2a8957d$export$897106ac607e0b67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle24Regular', "24", [
    "M15.09 6.41a3 3 0 0 0-1.35-.95L12.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-4.95 9.66 3.68-6.37c-.21.32-.52.55-1.02.55h-.04q-.52-.02-.81-.3l-3.1 5.37a.8.8 0 0 1-.65.38H8.1a.8.8 0 0 1-.64-.38l-3.9-6.75a.8.8 0 0 1 0-.74l3.9-6.75a.8.8 0 0 1 .65-.38H11v-.03c0-.67.42-1.25 1.05-1.47H8.1c-.8 0-1.55.43-1.95 1.13l-3.9 6.75c-.4.7-.4 1.55 0 2.24l3.9 6.75c.4.7 1.14 1.13 1.95 1.13h7.79c.8 0 1.54-.43 1.94-1.13"
]);
const $bd5c6ab3f2a8957d$export$793da2100e19beb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle28Filled', "28", [
    "M15.09 3.5q-.49.16-.8.59a1.6 1.6 0 0 0 0 1.85q.3.42.78.59l1.56.5a2.3 2.3 0 0 1 1 .73q.24.29.35.64l.5 1.53q.18.49.59.8a1.6 1.6 0 0 0 1.86 0l.13-.11a1.3 1.3 0 0 0 .19 1.17q.25.35.66.49l.94.31q.2.06.34.21.16.15.22.35l.3.92A1.34 1.34 0 0 0 25 15q.43 0 .79-.25.3-.21.45-.56-.05.64-.38 1.21l-4.88 8.25c-.5.84-1.4 1.35-2.37 1.35H9.39c-.97 0-1.87-.51-2.37-1.35L2.14 15.4a2.8 2.8 0 0 1 0-2.8l4.88-8.25C7.52 3.5 8.42 3 9.4 3h7.22zm9.9 4.5a.4.4 0 0 1 .33.24l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 .17.55q-.06.09-.17.13l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.55.17.4.4 0 0 1-.13-.17l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.17-.55q.06-.09.17-.13l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.4.4 0 0 1 .34-.24m-5.02-8a.6.6 0 0 1 .57.4l.5 1.53a3.2 3.2 0 0 0 2 2l1.53.5h.03a.6.6 0 0 1 0 1.14l-1.53.5a3.2 3.2 0 0 0-2 2l-.5 1.53-.01.03a.6.6 0 0 1-1.13-.03l-.5-1.53a3.2 3.2 0 0 0-2-2l-1.53-.5a.6.6 0 0 1 0-1.14l1.53-.5a3.2 3.2 0 0 0 1.96-1.96l.01-.04.5-1.53a.6.6 0 0 1 .57-.4"
]);
const $bd5c6ab3f2a8957d$export$526ebaca0f82c5f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle28Regular', "28", [
    "M15.09 3.5a1.6 1.6 0 0 0-1 1h-4.7c-.44 0-.85.23-1.08.61l-4.88 8.25c-.23.4-.23.88 0 1.28l4.88 8.25c.23.38.64.61 1.08.61h9.22c.44 0 .85-.23 1.07-.61l4.75-8.01a1.4 1.4 0 0 0 1.36-.13q.3-.21.45-.56-.05.64-.38 1.21l-4.88 8.25c-.5.84-1.4 1.35-2.37 1.35H9.39c-.97 0-1.87-.51-2.37-1.35L2.14 15.4a2.8 2.8 0 0 1 0-2.8l4.88-8.25C7.52 3.5 8.42 3 9.4 3h7.22zm9.9 4.5a.4.4 0 0 1 .33.24l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 .17.55q-.06.09-.17.13l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.55.17.4.4 0 0 1-.13-.17l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.17-.55q.06-.09.17-.13l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.4.4 0 0 1 .34-.24m-5.02-8a.6.6 0 0 1 .57.4l.5 1.53a3.2 3.2 0 0 0 2 2l1.53.5h.03a.6.6 0 0 1 0 1.14l-1.53.5a3.2 3.2 0 0 0-2 2l-.5 1.53-.01.03a.6.6 0 0 1-1.13-.03l-.5-1.53a3.2 3.2 0 0 0-2-2l-1.53-.5a.6.6 0 0 1 0-1.14l1.53-.5a3.2 3.2 0 0 0 1.96-1.96l.01-.04.5-1.53a.6.6 0 0 1 .57-.4"
]);
const $bd5c6ab3f2a8957d$export$17639caab0ef211d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle32Filled', "32", [
    "M18 3.44a2.2 2.2 0 0 0-1.5 2.06 2.2 2.2 0 0 0 1.45 2l1.71.56q.44.14.77.47.01.05.08.11l.08.08q.2.26.31.58l.55 1.7a2.16 2.16 0 0 0 3.3 1.08 2 2 0 0 0-.25.9 1.8 1.8 0 0 0 1.24 1.75l1 .3.14.11q.07.07.09.15l.3.9a2 2 0 0 0 .69.95 1.9 1.9 0 0 0 2.38-.19 3 3 0 0 1-.29.62l-6.12 10A3 3 0 0 1 21.37 29H10.62a3 3 0 0 1-2.56-1.43l-6.13-10a3 3 0 0 1 0-3.14l6.13-10A3 3 0 0 1 10.62 3h8.67zM28.98 10a.4.4 0 0 1 .34.24l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 .17.55q-.06.09-.17.13l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.17-.55q.06-.09.17-.13l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.4.4 0 0 1 .34-.24M23.47 0a.7.7 0 0 1 .62.44l.55 1.69a3.5 3.5 0 0 0 2.2 2.2l1.68.54h.04a.67.67 0 0 1 .32 1.02q-.13.17-.32.24l-1.69.55a3.5 3.5 0 0 0-2.2 2.2l-.54 1.68a.7.7 0 0 1-.63.44.7.7 0 0 1-.63-.44l-.54-1.69a3.5 3.5 0 0 0-2.2-2.2l-1.69-.55a.67.67 0 0 1-.32-1q.13-.18.32-.25l1.69-.55a3.5 3.5 0 0 0 2.15-2.15l.01-.04.55-1.69a.7.7 0 0 1 .63-.44"
]);
const $bd5c6ab3f2a8957d$export$d4df25051cf48aa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle32Regular', "32", [
    "M18 3.44A2.2 2.2 0 0 0 16.56 5h-5.94a1 1 0 0 0-.85.48l-6.13 10a1 1 0 0 0 0 1.04l6.13 10c.18.3.5.48.85.48h10.76a1 1 0 0 0 .85-.48l5.74-9.37a1.9 1.9 0 0 0 2.37-.2 3 3 0 0 1-.28.62l-6.12 10A3 3 0 0 1 21.38 29H10.62a3 3 0 0 1-2.56-1.43l-6.12-10a3 3 0 0 1 0-3.14l6.12-10A3 3 0 0 1 10.62 3h8.67zM28.98 10a.4.4 0 0 1 .34.24l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 .17.55q-.06.09-.17.13l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.17-.55q.06-.09.17-.13l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.4.4 0 0 1 .34-.24M23.47 0a.7.7 0 0 1 .62.44l.55 1.69a3.5 3.5 0 0 0 2.2 2.2l1.68.54h.04a.67.67 0 0 1 .32 1.02q-.13.17-.32.24l-1.69.55a3.5 3.5 0 0 0-2.2 2.2l-.54 1.68a.7.7 0 0 1-.63.44.7.7 0 0 1-.63-.44l-.54-1.69a3.5 3.5 0 0 0-2.2-2.2l-1.69-.55a.67.67 0 0 1-.32-1q.13-.18.32-.25l1.69-.55a3.5 3.5 0 0 0 2.15-2.15l.01-.04.55-1.69a.7.7 0 0 1 .63-.44"
]);
const $bd5c6ab3f2a8957d$export$2c906240908618ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle48Filled', "48", [
    "M25.36 6a3 3 0 0 0-1.33 2.04A3 3 0 0 0 26 11.35l2.65.86a3.3 3.3 0 0 1 2.17 2.11l.84 2.59a3 3 0 0 0 4.59 1.51q-.21.48-.22 1a2.55 2.55 0 0 0 1.7 2.4l1.42.46.12.06.2.15q.14.14.2.33l.44 1.37q.22.82.89 1.35a2.6 2.6 0 0 0 2.5.24l-8.09 14.55A3.3 3.3 0 0 1 32.57 42H15.43a3.3 3.3 0 0 1-2.84-1.67L4.38 25.58a3.3 3.3 0 0 1 0-3.16l8.2-14.75A3.3 3.3 0 0 1 15.44 6zm17.11 9a.6.6 0 0 1 .52.36l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.6.6 0 0 1-.26.2l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.04a.55.55 0 0 1-.81.23.6.6 0 0 1-.2-.26l-.45-1.38a2.8 2.8 0 0 0-1.36-1.63l-.44-.18-1.38-.45a.55.55 0 0 1-.26-.83q.1-.14.26-.2l1.38-.44a2.8 2.8 0 0 0 1.77-1.8l.45-1.38a.6.6 0 0 1 .51-.36M34.45 0a1 1 0 0 1 .97.69l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.91-.07l-.85-2.6a5.4 5.4 0 0 0-3.4-3.4l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.33-3.33l.02-.06.85-2.6a1 1 0 0 1 .97-.69"
]);
const $bd5c6ab3f2a8957d$export$e159bb1dd386dc7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonSparkle48Regular', "48", [
    "M25.36 6a3 3 0 0 0-1.33 2.04L24 8.5h-8.57a.8.8 0 0 0-.66.39l-8.2 14.75a.8.8 0 0 0 0 .72l8.2 14.75c.13.24.38.39.66.39h17.14c.28 0 .53-.15.66-.39l7.62-13.7.15.13a2.6 2.6 0 0 0 2.5.24l-8.09 14.55A3.3 3.3 0 0 1 32.57 42H15.43a3.3 3.3 0 0 1-2.84-1.67L4.38 25.58a3.3 3.3 0 0 1 0-3.16l8.2-14.75A3.3 3.3 0 0 1 15.44 6zm17.11 9a.6.6 0 0 1 .52.36l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.6.6 0 0 1-.26.2l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.04a.55.55 0 0 1-.81.23.6.6 0 0 1-.2-.26l-.45-1.38a2.8 2.8 0 0 0-1.36-1.63l-.44-.18-1.38-.45a.55.55 0 0 1-.26-.83q.1-.14.26-.2l1.38-.44a2.8 2.8 0 0 0 1.77-1.8l.45-1.38a.6.6 0 0 1 .51-.36M34.45 0a1 1 0 0 1 .97.69l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.91-.07l-.85-2.6a5.4 5.4 0 0 0-3.4-3.4l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.33-3.33l.02-.06.85-2.6a1 1 0 0 1 .97-.69"
]);
const $bd5c6ab3f2a8957d$export$9484234a14074c92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree12Filled', "12", [
    "M2.71 2a1 1 0 0 1 .87-.5h1.16a1 1 0 0 1 .87.5l.58 1a1 1 0 0 1 0 1L5.6 5a1 1 0 0 1-.87.5H3.58a1 1 0 0 1-.87-.5l-.58-1a1 1 0 0 1 0-1zm4.34 2.5A1 1 0 0 1 7.9 4h1.16a1 1 0 0 1 .87.5l.58 1a1 1 0 0 1 0 1l-.58 1a1 1 0 0 1-.87.5H7.91a1 1 0 0 1-.86-.5l-.58-1a1 1 0 0 1 0-1zm-3.47 2a1 1 0 0 0-.87.5l-.58 1a1 1 0 0 0 0 1l.58 1c.18.31.51.5.87.5h1.16a1 1 0 0 0 .87-.5l.58-1a1 1 0 0 0 0-1L5.6 7a1 1 0 0 0-.87-.5z"
]);
const $bd5c6ab3f2a8957d$export$9827468c2f337ce0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree12Regular', "12", [
    "M3.58 1.5a1 1 0 0 0-.87.5l-.58 1a1 1 0 0 0 0 1l.58 1c.18.31.51.5.87.5h1.16a1 1 0 0 0 .87-.5l.58-1a1 1 0 0 0 0-1L5.6 2a1 1 0 0 0-.87-.5zm0 1h1.16l.58 1-.58 1H3.58L3 3.5zm3.47 2A1 1 0 0 1 7.9 4h1.16a1 1 0 0 1 .87.5l.58 1a1 1 0 0 1 0 1l-.58 1a1 1 0 0 1-.87.5H7.91a1 1 0 0 1-.86-.5l-.58-1a1 1 0 0 1 0-1zm2.02.5H7.91l-.58 1 .58 1h1.16l.58-1zM2.71 7a1 1 0 0 1 .87-.5h1.16a1 1 0 0 1 .87.5l.58 1a1 1 0 0 1 0 1l-.58 1a1 1 0 0 1-.87.5H3.58a1 1 0 0 1-.87-.5l-.58-1a1 1 0 0 1 0-1zm2.03.5H3.58L3 8.5l.58 1h1.16l.58-1z"
]);
const $bd5c6ab3f2a8957d$export$3f3c23064ba84d2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree16Filled', "16", [
    "M3.47 2a1 1 0 0 1 .87-.5h2.32a1 1 0 0 1 .87.5l1.16 2a1 1 0 0 1 0 1L7.53 7a1 1 0 0 1-.87.5H4.34a1 1 0 0 1-.87-.5L2.31 5a1 1 0 0 1 0-1zm.87 6.5a1 1 0 0 0-.87.5l-1.16 2a1 1 0 0 0 0 1l1.16 2c.18.31.51.5.87.5h2.32a1 1 0 0 0 .87-.5l1.16-2a1 1 0 0 0 0-1L7.53 9a1 1 0 0 0-.87-.5zm5.13-3a1 1 0 0 1 .87-.5h2.32a1 1 0 0 1 .87.5l1.16 2a1 1 0 0 1 0 1l-1.16 2a1 1 0 0 1-.87.5h-2.32a1 1 0 0 1-.87-.5l-1.16-2a1 1 0 0 1 0-1z"
]);
const $bd5c6ab3f2a8957d$export$6bcb43dc46b94596 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree16Regular', "16", [
    "M3.47 2a1 1 0 0 1 .87-.5h2.32a1 1 0 0 1 .87.5l1.16 2a1 1 0 0 1 0 1L7.53 7a1 1 0 0 1-.87.5H4.34a1 1 0 0 1-.87-.5L2.31 5a1 1 0 0 1 0-1zm3.2.5H4.33l-1.16 2 1.16 2h2.32l1.16-2zM3.46 9a1 1 0 0 1 .87-.5h2.32a1 1 0 0 1 .87.5l1.16 2a1 1 0 0 1 0 1l-1.16 2a1 1 0 0 1-.87.5H4.34a1 1 0 0 1-.87-.5l-1.16-2a1 1 0 0 1 0-1zm3.2.5H4.33l-1.16 2 1.16 2h2.32l1.16-2zM10.33 5a1 1 0 0 0-.87.5l-1.16 2a1 1 0 0 0 0 1l1.16 2c.18.31.51.5.87.5h2.32a1 1 0 0 0 .87-.5l1.16-2a1 1 0 0 0 0-1l-1.16-2a1 1 0 0 0-.87-.5zm0 1h2.32l1.16 2-1.16 2h-2.32L9.18 8z"
]);
const $bd5c6ab3f2a8957d$export$1fe9fb81d6ebdcd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree20Filled', "20", [
    "M3.75 2.13c.23-.4.64-.63 1.09-.63H8c.44 0 .86.24 1.08.63l1.58 2.75c.23.38.23.86 0 1.24L9.1 8.87c-.22.4-.64.63-1.08.63H4.84c-.45 0-.86-.24-1.09-.63L2.17 6.12a1.3 1.3 0 0 1 0-1.24zM12.6 6c-.45 0-.86.24-1.09.63L9.93 9.38c-.22.38-.22.86 0 1.24l1.58 2.75c.23.4.64.63 1.09.63h3.17c.44 0 .86-.24 1.08-.63l1.58-2.75c.23-.38.23-.86 0-1.24l-1.58-2.75A1.3 1.3 0 0 0 15.77 6zm-8.85 5.13c.23-.4.64-.63 1.09-.63H8c.44 0 .86.24 1.08.63l1.58 2.75c.23.38.23.86 0 1.24L9.1 17.87c-.22.4-.64.63-1.08.63H4.84c-.45 0-.86-.24-1.09-.63l-1.58-2.75a1.3 1.3 0 0 1 0-1.24z"
]);
const $bd5c6ab3f2a8957d$export$babf9f77fe10ccd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree20Regular', "20", [
    "M4.62 2.63a.3.3 0 0 1 .22-.13H8q.14 0 .21.13l1.59 2.75q.06.12 0 .24L8.22 8.37a.3.3 0 0 1-.21.13H4.84a.3.3 0 0 1-.22-.13L3.03 5.62a.3.3 0 0 1 0-.24zm.22-1.13c-.45 0-.86.24-1.09.63L2.17 4.88c-.23.38-.23.86 0 1.24l1.58 2.75c.23.4.64.63 1.09.63H8c.44 0 .86-.24 1.08-.63l1.58-2.75c.23-.38.23-.86 0-1.24L9.1 2.13A1.3 1.3 0 0 0 8 1.5zM12.6 7a.3.3 0 0 0-.22.13l-1.59 2.75a.3.3 0 0 0 0 .24l1.59 2.75q.07.13.22.13h3.17q.14 0 .21-.13l1.59-2.75a.3.3 0 0 0 0-.24l-1.59-2.75a.3.3 0 0 0-.21-.13zm-1.09-.37c.23-.4.64-.63 1.09-.63h3.17c.44 0 .86.24 1.08.63l1.58 2.75c.23.38.23.86 0 1.24l-1.58 2.75c-.22.4-.64.63-1.08.63H12.6c-.45 0-.86-.24-1.09-.63l-1.58-2.75a1.3 1.3 0 0 1 0-1.24zM4.84 11.5a.3.3 0 0 0-.22.13l-1.59 2.75a.3.3 0 0 0 0 .24l1.59 2.75q.07.13.22.13H8q.14 0 .21-.13l1.59-2.75a.3.3 0 0 0 0-.24l-1.59-2.75a.3.3 0 0 0-.21-.13zm-1.09-.37c.23-.4.64-.63 1.09-.63H8c.44 0 .86.24 1.08.63l1.58 2.75c.23.38.23.86 0 1.24L9.1 17.87c-.22.4-.64.63-1.08.63H4.84c-.45 0-.86-.24-1.09-.63l-1.58-2.75a1.3 1.3 0 0 1 0-1.24z"
]);
const $bd5c6ab3f2a8957d$export$7648d1934dbfb0b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree24Filled', "24", [
    "M6.34 2c-.62 0-1.2.33-1.51.88l-1.6 2.75c-.3.54-.3 1.2 0 1.75l1.6 2.75c.31.54.89.87 1.51.87h3.18c.62 0 1.2-.33 1.51-.87l1.6-2.76c.3-.54.3-1.2 0-1.74l-1.6-2.75A1.8 1.8 0 0 0 9.52 2zM4.83 13.88c.31-.55.89-.88 1.51-.88h3.18c.62 0 1.2.33 1.51.88l1.6 2.74c.3.55.3 1.21 0 1.75l-1.6 2.75c-.3.55-.89.88-1.51.88H6.34c-.62 0-1.2-.33-1.51-.87l-1.6-2.75a1.8 1.8 0 0 1 0-1.75zm9.5-5.5c.31-.55.89-.88 1.51-.88h3.18c.62 0 1.2.33 1.51.88l1.6 2.74c.3.55.3 1.21 0 1.76l-1.6 2.74c-.3.55-.89.88-1.51.88h-3.18c-.62 0-1.2-.33-1.51-.87l-1.6-2.76a1.8 1.8 0 0 1 0-1.74z"
]);
const $bd5c6ab3f2a8957d$export$527b2253d6260852 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HexagonThree24Regular', "24", [
    "M4.83 2.88c.31-.55.89-.88 1.51-.88h3.18c.62 0 1.2.33 1.51.88l1.6 2.75c.3.54.3 1.2 0 1.75l-1.6 2.75c-.3.54-.89.87-1.51.87H6.34c-.62 0-1.2-.33-1.51-.87l-1.6-2.76a1.8 1.8 0 0 1 0-1.74zm1.51.62a.3.3 0 0 0-.21.13l-1.6 2.75a.3.3 0 0 0 0 .25l1.6 2.75q.07.11.21.12h3.18q.14 0 .21-.12l1.6-2.76a.3.3 0 0 0 0-.25l-1.6-2.74a.3.3 0 0 0-.21-.13zM4.83 13.88c.31-.55.89-.88 1.51-.88h3.18c.62 0 1.2.33 1.51.88l1.6 2.74c.3.55.3 1.21 0 1.75l-1.6 2.75c-.3.55-.89.88-1.51.88H6.34c-.62 0-1.2-.33-1.51-.87l-1.6-2.75a1.8 1.8 0 0 1 0-1.75zm1.51.62a.3.3 0 0 0-.21.13l-1.6 2.74a.3.3 0 0 0 0 .25l1.6 2.75q.07.13.21.13h3.18q.14 0 .21-.12l1.6-2.75a.3.3 0 0 0 0-.25l-1.6-2.75a.3.3 0 0 0-.21-.13zm9.5-7c-.62 0-1.2.33-1.51.88l-1.6 2.74c-.3.55-.3 1.21 0 1.76l1.6 2.74c.31.55.89.88 1.51.88h3.18c.62 0 1.2-.33 1.51-.87l1.6-2.76c.3-.54.3-1.2 0-1.74l-1.6-2.76a1.8 1.8 0 0 0-1.51-.87zm-.21 1.63a.3.3 0 0 1 .21-.13h3.18q.14 0 .21.13l1.6 2.74q.06.13 0 .26l-1.6 2.74a.3.3 0 0 1-.21.13h-3.18a.3.3 0 0 1-.21-.12l-1.6-2.76a.3.3 0 0 1 0-.24z"
]);
const $bd5c6ab3f2a8957d$export$e104c8ba68fa6eb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass12Filled', "12", [
    "M8.55 1c.8 0 1.56.67 1.43 1.57A4.3 4.3 0 0 1 8.71 5.2C8.54 5.38 8 5.73 8 6s.54.62.71.79a4.3 4.3 0 0 1 1.27 2.64c.13.9-.62 1.57-1.43 1.57H3.44c-.8 0-1.55-.67-1.43-1.57.2-1.38.75-2.13 1.27-2.64.17-.17.72-.52.72-.79s-.55-.62-.72-.79a4.3 4.3 0 0 1-1.27-2.64C1.89 1.67 2.64 1 3.44 1zM3.44 2c-.3 0-.47.23-.44.43a3.3 3.3 0 0 0 .98 2.07C4.42 4.93 5 5.32 5 6s-.58 1.07-1.02 1.5c-.39.39-.82.94-.98 2.07-.03.2.14.43.44.43h5.11c.3 0 .47-.23.44-.43a3.3 3.3 0 0 0-.98-2.07C7.57 7.07 7 6.68 7 6S7.57 4.93 8 4.5c.4-.39.83-.94.98-2.07.03-.2-.14-.43-.44-.43zM6 6.05c.01.73.38 1.24.65 1.54l.38.36.28.26c.18.18.37.4.52.79H4.17c.14-.39.34-.61.52-.79l.28-.26.37-.36c.27-.3.64-.8.66-1.54M7.83 3c-.15.39-.34.61-.52.79l-.28.26-.38.36c-.27.3-.64.8-.65 1.54a2.3 2.3 0 0 0-.66-1.54l-.37-.36-.28-.26c-.18-.18-.38-.4-.52-.79z"
]);
const $bd5c6ab3f2a8957d$export$42d9c29df1dfc502 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass12Regular', "12", [
    "M8.55 1c.8 0 1.56.67 1.43 1.57A4.3 4.3 0 0 1 8.71 5.2C8.54 5.38 8 5.73 8 6s.54.62.71.79a4.3 4.3 0 0 1 1.27 2.64c.13.9-.62 1.57-1.43 1.57H3.44c-.8 0-1.55-.67-1.43-1.57.2-1.38.75-2.13 1.27-2.64.17-.17.72-.52.72-.79s-.55-.62-.72-.79a4.3 4.3 0 0 1-1.27-2.64C1.89 1.67 2.64 1 3.44 1zM3.44 2c-.3 0-.47.23-.44.43a3.3 3.3 0 0 0 .98 2.07C4.42 4.93 5 5.32 5 6s-.58 1.07-1.02 1.5c-.39.39-.82.94-.98 2.07-.03.2.14.43.44.43h5.11c.3 0 .47-.23.44-.43a3.3 3.3 0 0 0-.98-2.07C7.57 7.07 7 6.68 7 6S7.57 4.93 8 4.5c.4-.39.83-.94.98-2.07.03-.2-.14-.43-.44-.43z"
]);
const $bd5c6ab3f2a8957d$export$2bb291fbabed5e6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass16Filled', "16", [
    "M5.34 4.11c-.13-.24-.26-.6-.31-1.11h5.94c-.05.52-.18.87-.3 1.11-.17.31-.4.55-.69.8l-.32.28-.19.15q-.28.22-.61.56A3 3 0 0 0 8 8a3 3 0 0 0-.86-2.1 6 6 0 0 0-.8-.71l-.32-.27c-.3-.26-.52-.5-.68-.8M10.97 13H5.03q.09-.77.3-1.11.26-.45.69-.8l.32-.28.19-.15q.28-.23.61-.56A3 3 0 0 0 8 8a3 3 0 0 0 .86 2.1 6 6 0 0 0 .8.71l.32.27q.45.37.68.8c.13.25.26.6.31 1.12"
]);
const $bd5c6ab3f2a8957d$export$350350d8cc6f6b37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass16Regular', "16", [
    "M3 2.65C2.98 1.68 3.8 1 4.68 1h6.64c.88 0 1.7.68 1.68 1.65a5 5 0 0 1-.57 2.4 5 5 0 0 1-1.14 1.38l-.4.34-.15.11q-.25.2-.42.38a1 1 0 0 0 0 1.48 4 4 0 0 0 .57.5l.4.33c.4.34.81.76 1.14 1.38s.54 1.39.57 2.4c.02.97-.8 1.65-1.68 1.65H4.68c-.88 0-1.7-.68-1.68-1.65q.06-1.5.57-2.4c.33-.62.75-1.04 1.14-1.38l.4-.33.15-.12q.25-.2.42-.38a1 1 0 0 0 0-1.48 4 4 0 0 0-.57-.5l-.4-.33c-.4-.34-.82-.76-1.14-1.38A5 5 0 0 1 3 2.65M4.68 2c-.4 0-.69.3-.68.62.02.88.2 1.5.45 1.96s.57.8.91 1.1l.37.3.16.13q.27.21.52.47a2 2 0 0 1 0 2.84q-.24.26-.52.47l-.16.13-.37.3c-.34.3-.66.63-.9 1.1A4.3 4.3 0 0 0 4 13.38c0 .32.27.62.68.62h6.64c.4 0 .68-.3.68-.62-.03-.88-.21-1.5-.46-1.96-.24-.47-.56-.8-.9-1.1l-.37-.3-.17-.13q-.26-.21-.51-.47a2 2 0 0 1 0-2.84 5 5 0 0 1 .68-.6l.37-.3c.34-.3.66-.64.9-1.1.25-.46.44-1.08.46-1.96 0-.32-.28-.62-.68-.62z"
]);
const $bd5c6ab3f2a8957d$export$586d13765eb5d2c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass20Filled', "20", [
    "M13.69 5.4q.3-.67.31-1.4H6a3.4 3.4 0 0 0 1.22 2.56l1.82 1.52a2.5 2.5 0 0 1 .9 1.92q0 .56-.24 1.06t-.66.86l-1.82 1.52q-.58.47-.9 1.16-.3.67-.32 1.4h8q0-.73-.31-1.4a3.4 3.4 0 0 0-.91-1.16L11 11.91q-.42-.35-.65-.85a2.4 2.4 0 0 1-.29-1.06q.02-.56.29-1.06.23-.5.65-.85l1.78-1.53q.59-.47.91-1.16"
]);
const $bd5c6ab3f2a8957d$export$ed9b42e536c491d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass20Regular', "20", [
    "M5.92 18q-.38 0-.72-.16-.35-.15-.62-.42A2 2 0 0 1 4 16.08a6 6 0 0 1 .5-2.3 5 5 0 0 1 1.44-1.88l1.82-1.52q.18-.15.18-.38a.5.5 0 0 0-.18-.38L5.94 8.09A5.3 5.3 0 0 1 4 3.92q0-.38.16-.72.15-.35.42-.62A2 2 0 0 1 5.92 2h8.16q.38 0 .72.16.35.15.62.42A2 2 0 0 1 16 3.92q0 1.24-.5 2.3a5 5 0 0 1-1.44 1.87l-1.82 1.53a.5.5 0 0 0 0 .77l1.82 1.5A5.4 5.4 0 0 1 16 16.09q0 .38-.16.72-.15.35-.42.62a2 2 0 0 1-1.34.58zm8.12-1a1 1 0 0 0 .68-.28q.15-.15.2-.3.06-.18.08-.38a4.3 4.3 0 0 0-1.58-3.37l-1.82-1.52a1.5 1.5 0 0 1-.54-1.15 1.5 1.5 0 0 1 .54-1.16l1.82-1.51A4.3 4.3 0 0 0 15 3.96a1 1 0 0 0-.28-.68 1 1 0 0 0-.3-.2q-.17-.06-.38-.08H5.96a1 1 0 0 0-.37.07 1 1 0 0 0-.3.21q-.15.15-.21.3-.07.18-.08.38a4.5 4.5 0 0 0 .9 2.67q.3.37.68.7L8.4 8.84q.25.21.4.52a1.5 1.5 0 0 1-.4 1.79l-1.82 1.52A4.3 4.3 0 0 0 5 16.04q0 .2.07.37.08.18.21.3.15.14.3.21.18.07.38.08z"
]);
const $bd5c6ab3f2a8957d$export$655bb329cf7b387 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass24Filled', "24", [
    "M17.25 4.5H6.75a.25.25 0 0 0-.25.25v.6A3.2 3.2 0 0 0 7.92 8L10 9.48q.64.43 1.02 1.09a2.8 2.8 0 0 1 0 2.86q-.38.66-1.02 1.09L7.92 16a3.2 3.2 0 0 0-1.42 2.65v.6a.25.25 0 0 0 .25.25h10.5a.25.25 0 0 0 .25-.25v-.6A3.2 3.2 0 0 0 16.08 16L14 14.52a3 3 0 0 1-1.02-1.09 2.8 2.8 0 0 1 0-2.86q.38-.66 1.02-1.09L16.08 8a3.2 3.2 0 0 0 1.42-2.65v-.6a.25.25 0 0 0-.25-.25"
]);
const $bd5c6ab3f2a8957d$export$6ce4b41cb85f29bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Hourglass24Regular', "24", [
    "M4 4.75A2.75 2.75 0 0 1 6.75 2h10.5A2.75 2.75 0 0 1 20 4.75v.42c0 2.02-1.06 3.89-2.8 4.93l-1.8 1.09a.75.75 0 0 0-.04 1.26l2.12 1.44A5.8 5.8 0 0 1 20 18.65v.6A2.75 2.75 0 0 1 17.25 22H6.75A2.75 2.75 0 0 1 4 19.25v-.6c0-1.9.94-3.69 2.52-4.76l2.12-1.44a.75.75 0 0 0-.04-1.26L6.8 10.1A5.8 5.8 0 0 1 4 5.17zM6.75 3.5c-.69 0-1.25.56-1.25 1.25v.42c0 1.5.78 2.88 2.06 3.64L9.37 9.9c1.41.84 1.47 2.87.11 3.79l-2.12 1.44a4.3 4.3 0 0 0-1.86 3.52v.6c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-.6c0-1.41-.7-2.73-1.86-3.52l-2.12-1.44a2.25 2.25 0 0 1 .1-3.79l1.82-1.09a4.3 4.3 0 0 0 2.06-3.64v-.42c0-.69-.56-1.25-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$58f88ba501373018 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf12Filled', "12", [
    "M6 6.05c.01.73.38 1.24.65 1.54l.37.36.29.26c.18.18.37.4.52.79H4.16c.15-.39.35-.61.53-.79l.28-.26.37-.36c.27-.3.64-.8.66-1.54"
]);
const $bd5c6ab3f2a8957d$export$bbb826d74578f327 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf12Regular', "12", [
    "M8.55 1c.8 0 1.56.67 1.43 1.57A4.3 4.3 0 0 1 8.71 5.2C8.54 5.38 8 5.73 8 6s.54.62.71.79a4.3 4.3 0 0 1 1.27 2.64c.13.9-.62 1.57-1.43 1.57H3.44c-.8 0-1.55-.67-1.43-1.57.2-1.38.75-2.13 1.27-2.64.17-.17.72-.52.72-.79s-.55-.62-.72-.79a4.3 4.3 0 0 1-1.27-2.64C1.89 1.67 2.64 1 3.44 1zM3.44 2c-.3 0-.47.23-.44.43a3.3 3.3 0 0 0 .98 2.07C4.42 4.93 5 5.32 5 6s-.58 1.07-1.02 1.5c-.39.39-.82.94-.98 2.07-.03.2.14.43.44.43h5.11c.3 0 .47-.23.44-.43a3.3 3.3 0 0 0-.98-2.07C7.57 7.07 7 6.68 7 6S7.57 4.93 8 4.5c.4-.39.83-.94.98-2.07.03-.2-.14-.43-.44-.43zM6 6.05c.01.73.38 1.24.65 1.54l.37.36.29.26c.18.18.37.4.52.79H4.16c.15-.39.35-.61.53-.79l.28-.26.37-.36c.27-.3.64-.8.66-1.54"
]);
const $bd5c6ab3f2a8957d$export$935ffc63140c44d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf16Filled', "16", [
    "M5.03 13h5.94a3 3 0 0 0-.3-1.11 3 3 0 0 0-.69-.81l-.32-.27-.19-.15q-.28-.23-.61-.56A3 3 0 0 1 8 8a3 3 0 0 1-.86 2.1c-.2.22-.43.41-.61.56l-.19.15-.32.27q-.45.37-.68.8-.22.36-.31 1.12"
]);
const $bd5c6ab3f2a8957d$export$b9302f5c945a2315 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf16Regular', "16", [
    "M5.03 13h5.94a3 3 0 0 0-.3-1.11 3 3 0 0 0-.7-.81l-.31-.27-.19-.15q-.28-.23-.61-.56A3 3 0 0 1 8 8a3 3 0 0 1-.86 2.1q-.32.33-.61.56l-.19.15-.32.27q-.44.37-.68.8-.22.36-.31 1.12M3 2.65C2.98 1.68 3.8 1 4.68 1h6.64c.88 0 1.7.68 1.68 1.65a5 5 0 0 1-.57 2.4 5 5 0 0 1-1.14 1.38l-.4.34-.15.11q-.25.2-.42.38a1 1 0 0 0 0 1.48 4 4 0 0 0 .57.5l.4.33c.4.34.81.76 1.14 1.38s.54 1.39.57 2.4c.02.97-.8 1.65-1.68 1.65H4.68c-.88 0-1.7-.68-1.68-1.65q.06-1.5.57-2.4c.33-.62.75-1.04 1.14-1.38l.4-.33.15-.12q.25-.2.42-.38a1 1 0 0 0 0-1.48 4 4 0 0 0-.57-.5l-.4-.33c-.4-.34-.82-.76-1.14-1.38A5 5 0 0 1 3 2.65M4.68 2c-.4 0-.69.3-.68.62.02.88.2 1.5.45 1.96s.57.8.91 1.1l.37.3.16.13q.27.21.52.47a2 2 0 0 1 0 2.84q-.24.26-.52.47l-.16.13-.37.3c-.34.3-.66.63-.9 1.1A4.3 4.3 0 0 0 4 13.38c0 .32.27.62.68.62h6.64c.4 0 .68-.3.68-.62-.03-.88-.21-1.5-.46-1.96-.24-.47-.56-.8-.9-1.1l-.37-.3-.17-.13q-.26-.21-.51-.47a2 2 0 0 1 0-2.84 5 5 0 0 1 .68-.6l.37-.3c.34-.3.66-.64.9-1.1.25-.46.44-1.08.46-1.96 0-.32-.28-.62-.68-.62z"
]);
const $bd5c6ab3f2a8957d$export$f4be16764742049e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf20Filled', "20", [
    "M9.94 10q0 .56-.24 1.06t-.66.86l-1.82 1.52q-.58.47-.9 1.16-.3.67-.32 1.4h8q0-.73-.31-1.4a3.4 3.4 0 0 0-.91-1.16L11 11.91q-.42-.35-.65-.85a2.4 2.4 0 0 1-.29-1.06z"
]);
const $bd5c6ab3f2a8957d$export$66befe5dd23be613 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf20Regular', "20", [
    "M13.69 14.6q.3.67.31 1.4H6a3.4 3.4 0 0 1 1.22-2.56l1.82-1.52a2.5 2.5 0 0 0 .9-1.92h.12q.02.56.29 1.06.23.5.65.85l1.78 1.53q.59.47.91 1.16m-8.5 3.24q.35.16.73.16h8.16a1.9 1.9 0 0 0 1.76-1.2q.15-.34.16-.72a5 5 0 0 0-.5-2.31 5 5 0 0 0-1.44-1.87l-1.82-1.52a.5.5 0 0 1 0-.77l1.82-1.52A5.3 5.3 0 0 0 16 3.92a1.9 1.9 0 0 0-1.2-1.76Q14.46 2 14.08 2H5.92a1.9 1.9 0 0 0-1.76 1.2Q4 3.54 4 3.92q0 1.24.5 2.3.49 1.08 1.44 1.87l1.82 1.53q.09.06.13.17a.5.5 0 0 1-.13.6l-1.82 1.5a6 6 0 0 0-1.44 1.88 5 5 0 0 0-.5 2.3 1.9 1.9 0 0 0 1.2 1.77m9.22-.91a1 1 0 0 1-.37.07H5.96q-.2 0-.37-.08t-.3-.2a1 1 0 0 1-.22-.3 1 1 0 0 1-.07-.38 4.5 4.5 0 0 1 1.58-3.37l1.82-1.52A1.5 1.5 0 0 0 8.94 10a1.5 1.5 0 0 0-.54-1.16L6.58 7.33A4 4 0 0 1 5.4 5.82 4 4 0 0 1 5 3.96q0-.2.08-.37.06-.17.2-.3.14-.15.3-.22A1 1 0 0 1 5.97 3h8.08q.2.02.37.08t.3.2a1 1 0 0 1 .29.68 4.4 4.4 0 0 1-1.58 3.37L11.6 8.84q-.25.21-.4.52a1.5 1.5 0 0 0 .4 1.79l1.82 1.52A4.4 4.4 0 0 1 15 16.04q-.02.2-.08.37t-.2.3q-.15.15-.31.22"
]);
const $bd5c6ab3f2a8957d$export$c80d084b26e6a128 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf24Filled', "24", [
    "M6.75 19.5h10.5a.25.25 0 0 0 .25-.25v-.6A3.2 3.2 0 0 0 16.08 16L14 14.52A3.2 3.2 0 0 1 12.56 12h-1.12A3.2 3.2 0 0 1 10 14.52L7.92 16a3.2 3.2 0 0 0-1.42 2.65v.6a.25.25 0 0 0 .25.25"
]);
const $bd5c6ab3f2a8957d$export$25048cc400f87b9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassHalf24Regular', "24", [
    "M17.25 19.5H6.75a.25.25 0 0 1-.25-.25v-.6A3.2 3.2 0 0 1 7.92 16L10 14.52A3.2 3.2 0 0 0 11.44 12h1.12A3.2 3.2 0 0 0 14 14.52L16.08 16a3.2 3.2 0 0 1 1.42 2.65v.6a.25.25 0 0 1-.25.25M6.75 2A2.75 2.75 0 0 0 4 4.75v.42c0 2.02 1.06 3.89 2.8 4.93l1.8 1.09c.47.28.5.95.04 1.26l-2.12 1.44A5.8 5.8 0 0 0 4 18.65v.6A2.75 2.75 0 0 0 6.75 22h10.5A2.75 2.75 0 0 0 20 19.25v-.6c0-1.9-.94-3.69-2.52-4.76l-2.12-1.44a.75.75 0 0 1 .04-1.26l1.8-1.09A5.8 5.8 0 0 0 20 5.17v-.42A2.75 2.75 0 0 0 17.25 2zM5.5 4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v.42c0 1.5-.78 2.88-2.06 3.64L14.63 9.9a2.25 2.25 0 0 0-.11 3.79l2.12 1.44c1.16.8 1.86 2.1 1.86 3.52v.6c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25v-.6c0-1.41.7-2.73 1.86-3.52l2.12-1.44a2.25 2.25 0 0 0-.1-3.79L7.55 8.81A4.3 4.3 0 0 1 5.5 5.17z"
]);
const $bd5c6ab3f2a8957d$export$6a928776318818d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter12Filled', "12", [
    "M7.3 8.21c.19.18.38.4.53.79H4.16c.15-.39.35-.61.53-.79L4.9 8h2.17z"
]);
const $bd5c6ab3f2a8957d$export$775e8d63b4aaf807 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter12Regular', "12", [
    "M8.55 1c.8 0 1.56.67 1.43 1.57A4.3 4.3 0 0 1 8.71 5.2C8.54 5.38 8 5.73 8 6s.54.62.71.79a4.3 4.3 0 0 1 1.27 2.64c.13.9-.62 1.57-1.43 1.57H3.44c-.8 0-1.55-.67-1.43-1.57.2-1.38.75-2.13 1.27-2.64.17-.17.72-.52.72-.79s-.55-.62-.72-.79a4.3 4.3 0 0 1-1.27-2.64C1.89 1.67 2.64 1 3.44 1zM3.44 2c-.3 0-.47.23-.44.43a3.3 3.3 0 0 0 .98 2.07C4.42 4.93 5 5.32 5 6s-.58 1.07-1.02 1.5c-.39.39-.82.94-.98 2.07-.03.2.14.43.44.43h5.11c.3 0 .47-.23.44-.43a3.3 3.3 0 0 0-.98-2.07C7.57 7.07 7 6.68 7 6S7.57 4.93 8 4.5c.4-.39.83-.94.98-2.07.03-.2-.14-.43-.44-.43zm3.87 6.21c.18.18.37.4.52.79H4.16c.15-.39.35-.61.53-.79L4.9 8h2.17z"
]);
const $bd5c6ab3f2a8957d$export$b23a335f264a7f26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter16Filled', "16", [
    "m6.11 11-.1.08q-.43.37-.67.8-.22.36-.31 1.12h5.94a3 3 0 0 0-.3-1.11 3 3 0 0 0-.78-.89z"
]);
const $bd5c6ab3f2a8957d$export$f30191ceded387a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter16Regular', "16", [
    "M4.68 1C3.8 1 2.98 1.68 3 2.65q.06 1.5.57 2.4c.32.62.75 1.04 1.14 1.38l.55.45q.25.2.42.38a1 1 0 0 1 0 1.48 4 4 0 0 1-.57.5l-.4.33c-.4.34-.81.76-1.14 1.38a5 5 0 0 0-.57 2.4c-.02.97.8 1.65 1.68 1.65h6.64c.88 0 1.7-.68 1.68-1.65a5 5 0 0 0-.57-2.4 5 5 0 0 0-1.14-1.38l-.4-.33-.15-.12q-.25-.2-.42-.38a1 1 0 0 1 0-1.48q.17-.18.42-.38l.15-.11.4-.34c.4-.34.81-.76 1.14-1.38q.51-.9.57-2.4c.02-.97-.8-1.65-1.68-1.65zM4 2.62c0-.32.28-.62.68-.62h6.64c.4 0 .69.3.68.62-.02.88-.2 1.5-.45 1.96s-.57.8-.91 1.1l-.53.43q-.27.21-.52.47a2 2 0 0 0 0 2.84q.25.26.51.47l.17.13.36.3c.35.3.67.63.91 1.1.25.46.43 1.08.46 1.96 0 .32-.28.62-.68.62H4.68c-.4 0-.69-.3-.68-.62.02-.88.2-1.5.45-1.96.25-.47.57-.8.91-1.1l.37-.3.16-.13q.27-.21.52-.47a2 2 0 0 0 0-2.84 5 5 0 0 0-.68-.6l-.37-.3c-.34-.3-.66-.63-.9-1.1A4 4 0 0 1 4 2.62m2.02 8.46.1-.08h3.77l.09.08q.45.37.68.8.22.36.31 1.12H5.03q.09-.77.3-1.11.26-.45.69-.8"
]);
const $bd5c6ab3f2a8957d$export$2ac04d4a763df0e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter20Filled', "20", [
    "M6.68 14q-.21.29-.36.6-.3.67-.32 1.4h8a3.5 3.5 0 0 0-.68-2z"
]);
const $bd5c6ab3f2a8957d$export$29c819e462d7ee9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter20Regular', "20", [
    "M6.32 14.6q.15-.32.36-.6h6.64q.22.29.37.6.3.67.31 1.4H6q.01-.73.32-1.4M5.2 17.84q.34.16.72.16h8.16a1.9 1.9 0 0 0 1.76-1.2q.15-.34.16-.72a5 5 0 0 0-.5-2.31 5 5 0 0 0-1.44-1.87l-1.82-1.52a.5.5 0 0 1 0-.77l1.82-1.52A5.3 5.3 0 0 0 16 3.92a1.9 1.9 0 0 0-1.2-1.76Q14.46 2 14.08 2H5.92a1.9 1.9 0 0 0-1.76 1.2Q4 3.54 4 3.92q0 1.24.5 2.3.49 1.08 1.44 1.87l1.82 1.53q.09.06.13.17a.5.5 0 0 1-.13.6l-1.82 1.5a6 6 0 0 0-1.44 1.88 5 5 0 0 0-.5 2.3 1.9 1.9 0 0 0 1.2 1.77m9.2-.91a1 1 0 0 1-.36.07H5.96q-.2 0-.37-.08t-.3-.2a1 1 0 0 1-.22-.3 1 1 0 0 1-.07-.38 4.5 4.5 0 0 1 1.58-3.37l1.82-1.52A1.5 1.5 0 0 0 8.94 10a1.5 1.5 0 0 0-.54-1.16L6.58 7.33A4 4 0 0 1 5.4 5.82 4 4 0 0 1 5 3.96q0-.2.08-.37.06-.17.2-.3.14-.15.3-.22A1 1 0 0 1 5.97 3h8.08q.2.02.37.08t.3.2a1 1 0 0 1 .29.68 4.4 4.4 0 0 1-1.58 3.37L11.6 8.84q-.25.21-.4.52a1.5 1.5 0 0 0 .4 1.79l1.82 1.52A4.4 4.4 0 0 1 15 16.04q-.02.2-.08.37t-.2.3q-.15.15-.31.22"
]);
const $bd5c6ab3f2a8957d$export$4c770b25b4eab27f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter24Filled', "24", [
    "M7.92 16a3.2 3.2 0 0 0-1.42 2.65v.6a.25.25 0 0 0 .25.25h10.5a.25.25 0 0 0 .25-.25v-.6A3.2 3.2 0 0 0 16.08 16z"
]);
const $bd5c6ab3f2a8957d$export$a27a4292f823c854 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassOneQuarter24Regular', "24", [
    "M6.88 17.15q.38-.7 1.04-1.15h8.16a3.2 3.2 0 0 1 1.42 2.65v.6a.25.25 0 0 1-.25.25H6.75a.25.25 0 0 1-.25-.25v-.6q.01-.8.38-1.5M6.75 2A2.75 2.75 0 0 0 4 4.75v.42c0 2.02 1.06 3.89 2.8 4.93l1.8 1.09c.47.28.5.95.04 1.26l-2.12 1.44A5.8 5.8 0 0 0 4 18.65v.6A2.75 2.75 0 0 0 6.75 22h10.5A2.75 2.75 0 0 0 20 19.25v-.6c0-1.9-.94-3.69-2.52-4.76l-2.12-1.44a.75.75 0 0 1 .04-1.26l1.8-1.09A5.8 5.8 0 0 0 20 5.17v-.42A2.75 2.75 0 0 0 17.25 2zM5.5 4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v.42c0 1.5-.78 2.88-2.06 3.64L14.63 9.9a2.25 2.25 0 0 0-.11 3.79l2.12 1.44c1.16.8 1.86 2.1 1.86 3.52v.6c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25v-.6c0-1.41.7-2.73 1.86-3.52l2.12-1.44a2.25 2.25 0 0 0-.1-3.79L7.55 8.81A4.3 4.3 0 0 1 5.5 5.17z"
]);
const $bd5c6ab3f2a8957d$export$26538febd9bb03d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter12Filled', "12", [
    "M6 6.05c.01.73.38 1.24.65 1.54l.37.36.29.26c.18.18.37.4.52.79H4.16c.15-.39.35-.61.53-.79l.28-.26.37-.36c.27-.3.64-.8.66-1.54m1.02-2-.37.36c-.27.3-.64.8-.65 1.54a2.3 2.3 0 0 0-.66-1.54l-.37-.36L4.91 4h2.17z"
]);
const $bd5c6ab3f2a8957d$export$9659f473e458bae0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter12Regular', "12", [
    "M8.55 1c.8 0 1.56.67 1.43 1.57A4.3 4.3 0 0 1 8.71 5.2C8.54 5.38 8 5.73 8 6s.54.62.71.79a4.3 4.3 0 0 1 1.27 2.64c.13.9-.62 1.57-1.43 1.57H3.44c-.8 0-1.55-.67-1.43-1.57.2-1.38.75-2.13 1.27-2.64.17-.17.72-.52.72-.79s-.55-.62-.72-.79a4.3 4.3 0 0 1-1.27-2.64C1.89 1.67 2.64 1 3.44 1zM3.44 2c-.3 0-.47.23-.44.43a3.3 3.3 0 0 0 .98 2.07C4.42 4.93 5 5.32 5 6s-.58 1.07-1.02 1.5c-.39.39-.82.94-.98 2.07-.03.2.14.43.44.43h5.11c.3 0 .47-.23.44-.43a3.3 3.3 0 0 0-.98-2.07C7.57 7.07 7 6.68 7 6S7.57 4.93 8 4.5c.4-.39.83-.94.98-2.07.03-.2-.14-.43-.44-.43zM6 6.05c.01.73.38 1.24.65 1.54l.37.36.29.26c.18.18.37.4.52.79H4.16c.15-.39.35-.61.53-.79l.28-.26.37-.36c.27-.3.64-.8.66-1.54m1.02-2-.37.36c-.27.3-.64.8-.65 1.54a2.3 2.3 0 0 0-.66-1.54l-.37-.36L4.91 4h2.17z"
]);
const $bd5c6ab3f2a8957d$export$37c5dfdf1df494e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter16Filled', "16", [
    "m5.28 4 .06.11q.24.45.68.8l.32.28.19.15q.29.22.6.56A3 3 0 0 1 8 8a3 3 0 0 1 .86-2.1 6 6 0 0 1 .8-.71l.32-.27a3 3 0 0 0 .74-.92zm-.25 9h5.94a3 3 0 0 0-.3-1.11 3 3 0 0 0-.69-.81l-.32-.27-.19-.15q-.28-.23-.61-.56A3 3 0 0 1 8 8a3 3 0 0 1-.86 2.1c-.2.22-.43.41-.61.56l-.19.15-.32.27q-.45.37-.68.8-.22.36-.31 1.12"
]);
const $bd5c6ab3f2a8957d$export$27810a77ab800697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter16Regular', "16", [
    "M4.68 1C3.8 1 2.98 1.68 3 2.65q.06 1.5.57 2.4c.32.62.75 1.04 1.14 1.38l.55.45q.25.2.42.38a1 1 0 0 1 0 1.48 4 4 0 0 1-.57.5l-.4.33c-.4.34-.81.76-1.14 1.38a5 5 0 0 0-.57 2.4c-.02.97.8 1.65 1.68 1.65h6.64c.88 0 1.7-.68 1.68-1.65a5 5 0 0 0-.57-2.4 5 5 0 0 0-1.14-1.38l-.4-.33-.15-.12q-.25-.2-.42-.38a1 1 0 0 1 0-1.48q.17-.18.42-.38l.15-.11.4-.34c.4-.34.81-.76 1.14-1.38q.51-.9.57-2.4c.02-.97-.8-1.65-1.68-1.65zM4 2.62c0-.32.28-.62.68-.62h6.64c.4 0 .69.3.68.62-.02.88-.2 1.5-.45 1.96s-.57.8-.91 1.1l-.53.43q-.27.21-.52.47a2 2 0 0 0 0 2.84q.25.26.51.47l.17.13.36.3c.35.3.67.63.91 1.1.25.46.43 1.08.46 1.96 0 .32-.28.62-.68.62H4.68c-.4 0-.69-.3-.68-.62.02-.88.2-1.5.45-1.96.25-.47.57-.8.91-1.1l.37-.3.16-.13q.27-.21.52-.47a2 2 0 0 0 0-2.84 5 5 0 0 0-.68-.6l-.37-.3c-.34-.3-.66-.63-.9-1.1A4 4 0 0 1 4 2.62m1.34 1.5L5.28 4h5.44l-.06.11c-.16.31-.38.55-.68.8l-.32.28-.19.15q-.28.22-.61.56A3 3 0 0 0 8 8a3 3 0 0 0-.86-2.1 6 6 0 0 0-.8-.71l-.32-.27c-.3-.26-.52-.5-.68-.8M10.97 13H5.03q.09-.77.3-1.11.26-.45.69-.8l.32-.28.19-.15q.28-.23.61-.56A3 3 0 0 0 8 8a3 3 0 0 0 .86 2.1 6 6 0 0 0 .8.71l.32.27q.45.37.68.8.22.36.31 1.12"
]);
const $bd5c6ab3f2a8957d$export$35651b71b3bd6b29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter20Filled', "20", [
    "M6.16 5h7.68q-.07.2-.15.4-.32.68-.91 1.16L11 8.09q-.42.35-.65.85-.27.5-.29 1.06.02.56.29 1.06.23.5.65.85l1.78 1.53q.59.47.91 1.16.3.67.31 1.4H6a3.4 3.4 0 0 1 1.22-2.56l1.82-1.52a2.5 2.5 0 0 0 .9-1.92q0-.56-.24-1.06a2.5 2.5 0 0 0-.66-.86L7.22 6.56A3.3 3.3 0 0 1 6.16 5"
]);
const $bd5c6ab3f2a8957d$export$da11efc3eb162100 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter20Regular', "20", [
    "M13.84 5H6.16a3.4 3.4 0 0 0 1.06 1.56l1.82 1.52a2.5 2.5 0 0 1 .9 1.92q0 .56-.24 1.06t-.66.86l-1.82 1.52q-.58.47-.9 1.16-.3.67-.32 1.4h8q0-.73-.31-1.4a3.4 3.4 0 0 0-.91-1.16L11 11.91q-.42-.35-.65-.85a2.4 2.4 0 0 1-.29-1.06q.02-.56.29-1.06.23-.5.65-.85l1.78-1.53A3.4 3.4 0 0 0 13.84 5M5.2 17.84q.34.16.72.16h8.16a1.9 1.9 0 0 0 1.76-1.2q.15-.34.16-.72a5 5 0 0 0-.5-2.31 5 5 0 0 0-1.44-1.87l-1.82-1.52a.5.5 0 0 1 0-.77l1.82-1.52A5.3 5.3 0 0 0 16 3.92a1.9 1.9 0 0 0-1.2-1.76Q14.46 2 14.08 2H5.92a1.9 1.9 0 0 0-1.76 1.2Q4 3.54 4 3.92q0 1.24.5 2.3.49 1.08 1.44 1.87l1.82 1.53q.09.06.13.17a.5.5 0 0 1-.13.6l-1.82 1.5a6 6 0 0 0-1.44 1.88 5 5 0 0 0-.5 2.3 1.9 1.9 0 0 0 1.2 1.77m9.2-.91a1 1 0 0 1-.36.07H5.96q-.2 0-.37-.08t-.3-.2a1 1 0 0 1-.22-.3 1 1 0 0 1-.07-.38 4.5 4.5 0 0 1 1.58-3.37l1.82-1.52A1.5 1.5 0 0 0 8.94 10a1.5 1.5 0 0 0-.54-1.16L6.58 7.33A4 4 0 0 1 5.4 5.82 4 4 0 0 1 5 3.96q0-.2.08-.37.06-.17.2-.3.14-.15.3-.22A1 1 0 0 1 5.97 3h8.08q.2.02.37.08t.3.2a1 1 0 0 1 .29.68 4.4 4.4 0 0 1-1.58 3.37L11.6 8.84q-.25.21-.4.52a1.5 1.5 0 0 0 .4 1.79l1.82 1.52A4.4 4.4 0 0 1 15 16.04q-.02.2-.08.37t-.2.3q-.15.15-.31.22"
]);
const $bd5c6ab3f2a8957d$export$a4b6b1b858da5f60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter24Filled', "24", [
    "M6.97 7q.36.6.95 1L10 9.48q.64.43 1.02 1.09a2.8 2.8 0 0 1 0 2.86q-.38.66-1.02 1.09L7.92 16a3.2 3.2 0 0 0-1.42 2.65v.6a.25.25 0 0 0 .25.25h10.5a.25.25 0 0 0 .25-.25v-.6A3.2 3.2 0 0 0 16.08 16L14 14.52a3 3 0 0 1-1.02-1.09 2.8 2.8 0 0 1 0-2.86q.38-.66 1.02-1.09L16.08 8q.58-.4.95-1z"
]);
const $bd5c6ab3f2a8957d$export$935d6bf838fcdece = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HourglassThreeQuarter24Regular', "24", [
    "M7.92 8q-.58-.4-.95-1h10.06q-.36.6-.95 1L14 9.48q-.64.43-1.02 1.09a2.8 2.8 0 0 0 0 2.86q.38.66 1.02 1.09L16.08 16a3.2 3.2 0 0 1 1.42 2.65v.6a.25.25 0 0 1-.25.25H6.75a.25.25 0 0 1-.25-.25v-.6A3.2 3.2 0 0 1 7.92 16L10 14.52q.64-.43 1.02-1.09a2.8 2.8 0 0 0 0-2.86Q10.64 9.9 10 9.48zM6.75 2A2.75 2.75 0 0 0 4 4.75v.42c0 2.02 1.06 3.89 2.8 4.93l1.8 1.09c.47.28.5.95.04 1.26l-2.12 1.44A5.8 5.8 0 0 0 4 18.65v.6A2.75 2.75 0 0 0 6.75 22h10.5A2.75 2.75 0 0 0 20 19.25v-.6c0-1.9-.94-3.69-2.52-4.76l-2.12-1.44a.75.75 0 0 1 .04-1.26l1.8-1.09A5.8 5.8 0 0 0 20 5.17v-.42A2.75 2.75 0 0 0 17.25 2zM5.5 4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v.42c0 1.5-.78 2.88-2.06 3.64L14.63 9.9a2.25 2.25 0 0 0-.11 3.79l2.12 1.44c1.16.8 1.86 2.1 1.86 3.52v.6c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25v-.6c0-1.41.7-2.73 1.86-3.52l2.12-1.44a2.25 2.25 0 0 0-.1-3.79L7.55 8.81A4.3 4.3 0 0 1 5.5 5.17z"
]);
const $bd5c6ab3f2a8957d$export$a5796cc4e57c91d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare16Filled', "16", [
    "M8 2c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5M4.5 5.5C5.33 5.5 6 6.17 6 7v2c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 9V7c0-.83.67-1.5 1.5-1.5zm9 0c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 10 9V7c0-.83.67-1.5 1.5-1.5z"
]);
const $bd5c6ab3f2a8957d$export$cffb856352e1c924 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare16Regular', "16", [
    "M8 2c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5M4.5 5.5C5.33 5.5 6 6.17 6 7v2c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 9V7c0-.83.67-1.5 1.5-1.5zm9 0c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 10 9V7c0-.83.67-1.5 1.5-1.5zm-11 1A.5.5 0 0 0 2 7v2c0 .28.22.5.5.5h2A.5.5 0 0 0 5 9V7a.5.5 0 0 0-.5-.5zm9 0a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h2A.5.5 0 0 0 14 9V7a.5.5 0 0 0-.5-.5z"
]);
const $bd5c6ab3f2a8957d$export$74c51f7943547300 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare20Filled', "20", [
    "M10 2c.28 0 .5.22.5.5v15l-.01.1a.5.5 0 0 1-.98 0l-.01-.1v-15c0-.28.22-.5.5-.5M6 6.5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3c0-1.1.9-2 2-2zm11 0a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3c0-1.1.9-2 2-2z"
]);
const $bd5c6ab3f2a8957d$export$7d72e6c5a9786ef4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare20Regular', "20", [
    "M10 2c.28 0 .5.22.5.5v15l-.01.1a.5.5 0 0 1-.98 0l-.01-.1v-15c0-.28.22-.5.5-.5M6 6.5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3c0-1.1.9-2 2-2zm11 0a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3c0-1.1.9-2 2-2zm-14 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zm11 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$b9f2f9c5e2e20fdd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare24Filled', "24", [
    "M12 2.5c.41 0 .75.34.75.75v17.58a.75.75 0 0 1-1.5 0V3.25c0-.41.34-.75.75-.75M6.75 8C7.99 8 9 9 9 10.25v3.5C9 14.99 8 16 6.75 16h-3.5C2.01 16 1 15 1 13.75v-3.5C1 9.01 2 8 3.25 8zm14 0C21.99 8 23 9 23 10.25v3.5c0 1.24-1 2.25-2.25 2.25h-3.5C16.01 16 15 15 15 13.75v-3.5C15 9.01 16 8 17.25 8z"
]);
const $bd5c6ab3f2a8957d$export$c9ab663fcc867565 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare24Regular', "24", [
    "M12 2.5c.41 0 .75.34.75.75v17.58a.75.75 0 0 1-1.5 0V3.25c0-.41.34-.75.75-.75M6.75 8C7.99 8 9 9 9 10.25v3.5C9 14.99 8 16 6.75 16h-3.5C2.01 16 1 15 1 13.75v-3.5C1 9.01 2 8 3.25 8zm14 0C21.99 8 23 9 23 10.25v3.5c0 1.24-1 2.25-2.25 2.25h-3.5C16.01 16 15 15 15 13.75v-3.5C15 9.01 16 8 17.25 8zM3.25 9.5a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zm14 0a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75z"
]);
const $bd5c6ab3f2a8957d$export$36c210923a6ad657 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare28Filled', "28", [
    "M14 3c.41 0 .75.34.75.75v20.5a.75.75 0 0 1-1.5 0V3.75c0-.41.34-.75.75-.75M8.25 9A2.75 2.75 0 0 1 11 11.75v4.5A2.75 2.75 0 0 1 8.25 19h-4.5A2.75 2.75 0 0 1 1 16.25v-4.5A2.75 2.75 0 0 1 3.75 9zm16 0A2.75 2.75 0 0 1 27 11.75v4.5A2.75 2.75 0 0 1 24.25 19h-4.5A2.75 2.75 0 0 1 17 16.25v-4.5A2.75 2.75 0 0 1 19.75 9z"
]);
const $bd5c6ab3f2a8957d$export$65121f18e543e041 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare28Regular', "28", [
    "M14 3c.41 0 .75.34.75.75v20.5a.75.75 0 0 1-1.5 0V3.75c0-.41.34-.75.75-.75M8.25 9A2.75 2.75 0 0 1 11 11.75v4.5A2.75 2.75 0 0 1 8.25 19h-4.5A2.75 2.75 0 0 1 1 16.25v-4.5A2.75 2.75 0 0 1 3.75 9zm16 0A2.75 2.75 0 0 1 27 11.75v4.5A2.75 2.75 0 0 1 24.25 19h-4.5A2.75 2.75 0 0 1 17 16.25v-4.5A2.75 2.75 0 0 1 19.75 9zm-20.5 1.5c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25zm16 0c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$136b075b4a4de964 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare32Filled', "32", [
    "M16 3a1 1 0 0 1 1 1v24a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1m-6.25 7c1.8 0 3.25 1.46 3.25 3.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 1 18.75v-5.5C1 11.45 2.46 10 4.25 10zm18 0c1.8 0 3.25 1.46 3.25 3.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 19 18.75v-5.5c0-1.8 1.46-3.25 3.25-3.25z"
]);
const $bd5c6ab3f2a8957d$export$c472689459ef88d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare32Regular', "32", [
    "M16 3a1 1 0 0 1 1 1v24a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1m-6.25 7c1.8 0 3.25 1.46 3.25 3.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 1 18.75v-5.5C1 11.45 2.46 10 4.25 10zm18 0c1.8 0 3.25 1.46 3.25 3.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 19 18.75v-5.5c0-1.8 1.46-3.25 3.25-3.25zm-23.5 2C3.56 12 3 12.56 3 13.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25zm18 0c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$2a309d706efc49a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare48Filled', "48", [
    "M24 5c.69 0 1.25.56 1.25 1.25v35.63a1.25 1.25 0 0 1-2.5 0V6.25c0-.69.56-1.25 1.25-1.25m-9.25 11C17.1 16 19 17.9 19 20.25v7.5C19 30.1 17.1 32 14.75 32h-7.5A4.25 4.25 0 0 1 3 27.75v-7.5C3 17.9 4.9 16 7.25 16zm26 0C43.1 16 45 17.9 45 20.25v7.5C45 30.1 43.1 32 40.75 32h-7.5A4.25 4.25 0 0 1 29 27.75v-7.5C29 17.9 30.9 16 33.25 16z"
]);
const $bd5c6ab3f2a8957d$export$e2cebaf700a4e572 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ItemCompare48Regular', "48", [
    "M24 5c.69 0 1.25.56 1.25 1.25v35.63a1.25 1.25 0 0 1-2.5 0V6.25c0-.69.56-1.25 1.25-1.25m-9.25 11C17.1 16 19 17.9 19 20.25v7.5C19 30.1 17.1 32 14.75 32h-7.5A4.25 4.25 0 0 1 3 27.75v-7.5C3 17.9 4.9 16 7.25 16zm26 0C43.1 16 45 17.9 45 20.25v7.5C45 30.1 43.1 32 40.75 32h-7.5A4.25 4.25 0 0 1 29 27.75v-7.5C29 17.9 30.9 16 33.25 16zm-33.5 2.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-7.5c0-.97-.78-1.75-1.75-1.75zm26 0c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-7.5c0-.97-.78-1.75-1.75-1.75z"
]);
const $bd5c6ab3f2a8957d$export$e145d8e374dbfea3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Road20Filled', "20", [
    "M5 2.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0zm11.5 0a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0zm-5.75 0a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zm-1.5 8.5a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm0 3.5a.75.75 0 0 1 1.5 0v2.5a.75.75 0 0 1-1.5 0z"
]);
const $bd5c6ab3f2a8957d$export$6efd3070e48e14a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Road20Regular', "20", [
    "M5 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0zm11 0a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0zm-5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-1 9a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm0 3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
]);
const $bd5c6ab3f2a8957d$export$6bbab994b32a497b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Road24Filled', "24", [
    "M6 3a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0zm14 0a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0zm-7 0a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-2 10.5a1 1 0 1 0 2 0v-3a1 1 0 1 0-2 0zm0 4.5a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $bd5c6ab3f2a8957d$export$7c32d30be81a6489 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Road24Regular', "24", [
    "M5.5 2.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0zm14.5 0a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0zm-7.25 0a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zm-1.5 11a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0zm0 4a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0z"
]);
const $bd5c6ab3f2a8957d$export$d3a297562b5affee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone16Filled', "16", [
    "M7.46 1a1 1 0 0 0-.97.76L5.06 7.5H8.5a.5.5 0 0 1 0 1H4.8l-.5 2h4.95a.5.5 0 0 1 0 1h-5.2L3.44 14H1.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-1.93L9.5 1.76A1 1 0 0 0 8.54 1z"
]);
const $bd5c6ab3f2a8957d$export$80dccad4754d0893 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone16Regular', "16", [
    "M7.46 1a1 1 0 0 0-.97.76L3.43 14H1.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-1.93L9.5 1.76A1 1 0 0 0 8.54 1zm4.08 13H4.46l.63-2.5h4.16a.5.5 0 0 0 0-1H5.34l.5-2H8.5a.5.5 0 0 0 0-1H6.09L7.46 2h1.08z"
]);
const $bd5c6ab3f2a8957d$export$449b7b8a0073322b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone20Filled', "20", [
    "M8.42 2.76A1 1 0 0 1 9.4 2h1.23a1 1 0 0 1 .96.74L15.38 17h2.12a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1h2.11l.8-3h6.09a.5.5 0 0 0 0-1H5.69l.45-1.63.1-.37h4.26a.5.5 0 0 0 0-1H6.52c.68-2.48 1.35-4.96 1.9-7.24"
]);
const $bd5c6ab3f2a8957d$export$4a0a270aa2b8f7d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone20Regular', "20", [
    "M9.38 2a1 1 0 0 0-.96.74L4.62 17H2.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-2.12l-3.8-14.26a1 1 0 0 0-.96-.74zM5.65 17l.8-3h5.05a.5.5 0 0 0 0-1H6.72l.53-2h3.25a.5.5 0 0 0 0-1H7.52l1.86-7h1.24l3.73 14z"
]);
const $bd5c6ab3f2a8957d$export$11ce819203cc55c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone24Filled', "24", [
    "M11.2 2c-.58 0-1.08.4-1.22.96A325 325 0 0 1 7.59 12h5.16a.75.75 0 0 1 0 1.5H7.18l-.55 2h7.12a.75.75 0 0 1 0 1.5H6.22l-.93 3.5H2.75a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-2.54L14.02 2.93a1.25 1.25 0 0 0-1.2-.93z"
]);
const $bd5c6ab3f2a8957d$export$11c553c05c35c5f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone24Regular', "24", [
    "M11.18 2c-.56 0-1.06.38-1.2.93L5.29 20.5H2.75a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-2.54L14.02 2.93a1.25 1.25 0 0 0-1.2-.93zM6.84 20.5l.94-3.5h5.97a.75.75 0 0 0 0-1.5H8.18l.53-2h4.04a.75.75 0 0 0 0-1.5H9.11l2.27-8.5h1.24l4.54 17z"
]);
const $bd5c6ab3f2a8957d$export$94a4bd2720eba192 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone28Filled', "28", [
    "M12.98 2c-.56 0-1.05.38-1.2.92L8.67 14.25h6.58a.75.75 0 0 1 0 1.5h-7l-.68 2.5h8.68a.75.75 0 0 1 0 1.5H7.16l-1.3 4.75H3.08a.75.75 0 0 0 0 1.5h21.84a.75.75 0 1 0 0-1.5h-2.78L16.22 2.92a1.25 1.25 0 0 0-1.2-.92z"
]);
const $bd5c6ab3f2a8957d$export$71a220abc9d9adab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone28Regular', "28", [
    "M12.98 2c-.56 0-1.06.38-1.2.92L5.86 24.5H3.08a.75.75 0 0 0 0 1.5h21.84a.75.75 0 1 0 0-1.5h-2.78L16.22 2.92a1.25 1.25 0 0 0-1.2-.92zm-5.5 22.25 1.24-4.5h7.53a.75.75 0 0 0 0-1.5H9.13l.68-2.5h5.44a.75.75 0 0 0 0-1.5h-5.03L13.17 3.5h1.66l5.69 20.75z"
]);
const $bd5c6ab3f2a8957d$export$27edf5009f3ee42b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone32Filled', "32", [
    "M14.77 2a1.5 1.5 0 0 0-1.43 1.06L9.4 16H17a1 1 0 1 1 0 2H8.8l-.81 2.67H18.5a1 1 0 1 1 0 2h-11l-.12-.01L5.76 28H3a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2h-2.76L18.66 3.06A1.5 1.5 0 0 0 17.23 2z"
]);
const $bd5c6ab3f2a8957d$export$47a60d5528bf2e19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone32Regular', "32", [
    "M14.77 2a1.5 1.5 0 0 0-1.43 1.06L5.76 28H3a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2h-2.76L18.66 3.06A1.5 1.5 0 0 0 17.23 2zM7.85 28l1.66-5.46a1 1 0 0 0 .49.13h8.5a1 1 0 1 0 0-2h-8.42l.8-2.67H17a1 1 0 1 0 0-2h-5.5l3.64-12h1.72l7.3 24z"
]);
const $bd5c6ab3f2a8957d$export$3504e1fb53031d5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone48Filled', "48", [
    "M22.39 4a2.5 2.5 0 0 0-2.43 1.91A651 651 0 0 1 15.19 24H25.5a1.5 1.5 0 1 1 0 3H14.36l-1.1 4H27.5a1.5 1.5 0 0 1 0 3H12.44q-.97 3.6-1.86 7H5.5a1.5 1.5 0 0 0 0 3h37a1.5 1.5 0 1 0 0-3h-5.08L28.05 5.86A2.5 2.5 0 0 0 25.63 4z"
]);
const $bd5c6ab3f2a8957d$export$30cfd35fdbd169f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RoadCone48Regular', "48", [
    "M22.37 4a2.5 2.5 0 0 0-2.42 1.86L10.58 41H5.5a1.5 1.5 0 0 0 0 3h37a1.5 1.5 0 1 0 0-3h-5.08L28.05 5.86A2.5 2.5 0 0 0 25.63 4zm-8.68 37 1.86-7H27.5a1.5 1.5 0 0 0 0-3H16.35l1.07-4h8.08a1.5 1.5 0 0 0 0-3h-7.28l4.53-17h2.5l9.06 34z"
]);
const $bd5c6ab3f2a8957d$export$f16a7b43b78773b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_settings_16_color__a)",
            "d": "M2.27 6.15q.4-1.21 1.26-2.17.17-.16.38-.1l1.36.49a.7.7 0 0 0 .94-.54l.26-1.41a.4.4 0 0 1 .27-.29 6 6 0 0 1 2.52 0q.23.06.27.28l.26 1.42a.7.7 0 0 0 .94.54l1.36-.49a.4.4 0 0 1 .38.1q.86.96 1.26 2.17.06.23-.1.38l-1.1.93a.7.7 0 0 0 0 1.08l1.1.93q.16.16.1.38-.4 1.21-1.26 2.17-.17.16-.38.1l-1.36-.49a.7.7 0 0 0-.94.54l-.26 1.41a.4.4 0 0 1-.27.29 6 6 0 0 1-2.52 0 .4.4 0 0 1-.27-.29l-.26-1.41a.7.7 0 0 0-.94-.54l-1.36.49a.4.4 0 0 1-.38-.1q-.86-.96-1.26-2.17a.4.4 0 0 1 .1-.38l1.1-.93a.7.7 0 0 0 0-1.08l-1.1-.93a.4.4 0 0 1-.1-.38M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_settings_16_color__a",
                "x1": "10.87",
                "x2": "4.17",
                "y1": "13.53",
                "y2": "3.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$a6558c6d8ba4be5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings16Filled', "16", [
    "M2.27 6.15q.4-1.21 1.26-2.17.17-.16.38-.1l1.36.49a.7.7 0 0 0 .94-.54l.26-1.41a.4.4 0 0 1 .27-.29 6 6 0 0 1 2.52 0q.23.06.27.28l.26 1.42a.7.7 0 0 0 .94.54l1.36-.49a.4.4 0 0 1 .38.1q.86.96 1.26 2.17.06.23-.1.38l-1.1.93a.7.7 0 0 0 0 1.08l1.1.93q.16.16.1.38-.4 1.21-1.26 2.17-.17.16-.38.1l-1.36-.49a.7.7 0 0 0-.94.54l-.26 1.41a.4.4 0 0 1-.27.29 6 6 0 0 1-2.52 0 .4.4 0 0 1-.27-.29l-.26-1.41a.7.7 0 0 0-.94-.54l-1.36.49a.4.4 0 0 1-.38-.1q-.86-.96-1.26-2.17a.4.4 0 0 1 .1-.38l1.1-.93a.7.7 0 0 0 0-1.08l-1.1-.93a.4.4 0 0 1-.1-.38M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0"
]);
const $bd5c6ab3f2a8957d$export$5d0949dbaa3e950a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings16Regular', "16", [
    "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3.62-3.6a.7.7 0 0 1-.83-.57l-.26-1.42a.4.4 0 0 0-.27-.28 6 6 0 0 0-2.52 0 .4.4 0 0 0-.27.29L6.2 3.83l-.03.11a.7.7 0 0 1-.9.43L3.9 3.88a.4.4 0 0 0-.38.1q-.86.96-1.26 2.17-.06.23.1.38l1.1.93a.7.7 0 0 1 0 1.08l-1.1.93q-.16.16-.1.38.4 1.21 1.26 2.17.17.16.38.1l1.36-.49.11-.03a.7.7 0 0 1 .83.57l.26 1.41q.05.23.27.29a6 6 0 0 0 2.52 0 .4.4 0 0 0 .27-.29l.26-1.41.03-.11a.7.7 0 0 1 .9-.43l1.37.49q.21.06.38-.1.86-.96 1.26-2.17a.4.4 0 0 0-.1-.38l-1.1-.93-.09-.08a.7.7 0 0 1 .08-1l1.1-.93q.18-.16.11-.38-.4-1.21-1.26-2.17a.4.4 0 0 0-.38-.1l-1.36.49zM4 4.98l.94.33a1.7 1.7 0 0 0 2.25-1.3l.18-.97a5 5 0 0 1 1.26 0l.18.97a1.7 1.7 0 0 0 2.25 1.3l.94-.33q.39.5.63 1.08l-.75.64a1.7 1.7 0 0 0 0 2.6l.75.64q-.24.59-.63 1.08l-.94-.33a1.7 1.7 0 0 0-2.25 1.3l-.18.97a5 5 0 0 1-1.26 0l-.18-.97a1.7 1.7 0 0 0-2.25-1.3l-.94.33q-.39-.5-.63-1.08l.75-.64a1.7 1.7 0 0 0 0-2.6l-.75-.64q.24-.58.63-1.08"
]);
const $bd5c6ab3f2a8957d$export$d27548834672ad37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_settings_20_color__a)",
            "d": "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.5 8.5 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54M8 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_settings_20_color__a",
                "x1": "14.06",
                "x2": "4.53",
                "y1": "17.84",
                "y2": "3.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$8bcf4ae44a7114d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings20Filled', "20", [
    "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.5 8.5 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54M8 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
]);
const $bd5c6ab3f2a8957d$export$a52c9e8901a6cdff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings20Regular', "20", [
    "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.5 8.5 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54m1.06 0 1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1q.45 1.19 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67a8 8 0 0 0 2.5 0l.3-1.67a2 2 0 0 1 2.64-1.53l1.6.58a8 8 0 0 0 1.24-2.16l-1.3-1.1a2 2 0 0 1 0-3.04l1.3-1.1a8 8 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a8 8 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a8 8 0 0 0-1.24 2.16M7.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m1 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $bd5c6ab3f2a8957d$export$201407c2a6cf0285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_settings_24_color__a)",
            "d": "M12.01 2.25q1.11.01 2.18.25c.32.07.55.33.59.65l.17 1.53a1.38 1.38 0 0 0 1.92 1.11l1.4-.61c.3-.13.64-.06.85.17a10 10 0 0 1 2.2 3.8c.1.3 0 .63-.26.82l-1.25.92a1.38 1.38 0 0 0 0 2.22l1.25.92c.26.19.36.52.27.82a10 10 0 0 1-2.2 3.8.75.75 0 0 1-.85.17l-1.4-.62a1.38 1.38 0 0 0-1.93 1.12l-.17 1.52a.75.75 0 0 1-.58.65 9.5 9.5 0 0 1-4.4 0 .75.75 0 0 1-.57-.65l-.17-1.52a1.38 1.38 0 0 0-1.93-1.11l-1.4.62a.75.75 0 0 1-.85-.18 10 10 0 0 1-2.2-3.8c-.1-.3 0-.63.26-.82l1.25-.92a1.38 1.38 0 0 0 0-2.22l-1.24-.92a.75.75 0 0 1-.28-.82 10 10 0 0 1 2.2-3.8c.23-.23.57-.3.86-.17l1.4.62c.4.17.86.15 1.25-.08.38-.22.63-.6.68-1.04l.17-1.53a.75.75 0 0 1 .58-.65q1.08-.24 2.2-.25M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_settings_24_color__a",
                "x1": "16.68",
                "x2": "5.78",
                "y1": "21",
                "y2": "4",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$706889d46a13a187 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings24Filled', "24", [
    "M12.01 2.25q1.11.01 2.18.25c.32.07.55.33.59.65l.17 1.53a1.38 1.38 0 0 0 1.92 1.11l1.4-.61c.3-.13.64-.06.85.17a10 10 0 0 1 2.2 3.8c.1.3 0 .63-.26.82l-1.25.92a1.38 1.38 0 0 0 0 2.22l1.25.92c.26.19.36.52.27.82a10 10 0 0 1-2.2 3.8.75.75 0 0 1-.85.17l-1.4-.62a1.38 1.38 0 0 0-1.93 1.12l-.17 1.52a.75.75 0 0 1-.58.65 9.5 9.5 0 0 1-4.4 0 .75.75 0 0 1-.57-.65l-.17-1.52a1.38 1.38 0 0 0-1.93-1.11l-1.4.62a.75.75 0 0 1-.85-.18 10 10 0 0 1-2.2-3.8c-.1-.3 0-.63.26-.82l1.25-.92a1.38 1.38 0 0 0 0-2.22l-1.24-.92a.75.75 0 0 1-.28-.82 10 10 0 0 1 2.2-3.8c.23-.23.57-.3.86-.17l1.4.62c.4.17.86.15 1.25-.08.38-.22.63-.6.68-1.04l.17-1.53a.75.75 0 0 1 .58-.65q1.08-.24 2.2-.25M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $bd5c6ab3f2a8957d$export$f3052fa8a993e0f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings24Regular', "24", [
    "M12.01 2.25q1.11.01 2.18.25c.32.07.55.33.59.65l.17 1.53a1.38 1.38 0 0 0 1.92 1.11l1.4-.61c.3-.13.64-.06.85.17a10 10 0 0 1 2.2 3.8c.1.3 0 .63-.26.82l-1.25.92a1.38 1.38 0 0 0 0 2.22l1.25.92c.26.19.36.52.27.82a10 10 0 0 1-2.2 3.8.75.75 0 0 1-.85.17l-1.4-.62a1.38 1.38 0 0 0-1.93 1.12l-.17 1.52a.75.75 0 0 1-.58.65 9.5 9.5 0 0 1-4.4 0 .75.75 0 0 1-.57-.65l-.17-1.52a1.38 1.38 0 0 0-1.93-1.11l-1.4.62a.75.75 0 0 1-.85-.18 10 10 0 0 1-2.2-3.8c-.1-.3 0-.63.26-.82l1.25-.92a1.38 1.38 0 0 0 0-2.22l-1.24-.92a.75.75 0 0 1-.28-.82 10 10 0 0 1 2.2-3.8c.23-.23.57-.3.86-.17l1.4.62c.4.17.86.15 1.25-.08.38-.22.63-.6.68-1.04l.17-1.53a.75.75 0 0 1 .58-.65q1.08-.24 2.2-.25m0 1.5q-.67 0-1.35.12l-.11.97a2.9 2.9 0 0 1-4.03 2.33l-.9-.4A8 8 0 0 0 4.29 9.1l.8.59a2.88 2.88 0 0 1 0 4.64l-.8.59a8 8 0 0 0 1.35 2.32l.9-.4a2.88 2.88 0 0 1 4.02 2.32l.1.99q1.35.22 2.7 0l.1-.99a2.88 2.88 0 0 1 4.02-2.32l.9.4a8 8 0 0 0 1.35-2.32l-.8-.59a2.88 2.88 0 0 1 0-4.64l.8-.59a8 8 0 0 0-1.35-2.32l-.9.4q-.55.24-1.15.24c-1.47 0-2.7-1.1-2.86-2.57l-.11-.97q-.68-.11-1.34-.12M12 8.25a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5m0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5"
]);
const $bd5c6ab3f2a8957d$export$6b0d9014a3fa7e9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_settings_28_color__a)",
            "d": "M16.7 2.31Q15.35 2.01 14 2q-1.38.01-2.7.31a.9.9 0 0 0-.72.8l-.2 1.88A1.7 1.7 0 0 1 8 6.36L6.3 5.61a.9.9 0 0 0-1.04.21 12 12 0 0 0-2.7 4.67c-.12.37 0 .78.33 1.02l1.52 1.12a1.7 1.7 0 0 1 0 2.74L2.87 16.5a.9.9 0 0 0-.33 1.01 12 12 0 0 0 2.7 4.68c.27.28.7.37 1.05.21l1.73-.76a1.7 1.7 0 0 1 2.36 1.37l.21 1.88c.04.38.32.7.7.8 1.78.42 3.64.42 5.42 0 .37-.1.66-.42.7-.8l.2-1.88a1.7 1.7 0 0 1 2.37-1.37l1.73.75c.36.16.77.08 1.04-.21a12 12 0 0 0 2.7-4.67.9.9 0 0 0-.32-1.01l-1.53-1.13a1.7 1.7 0 0 1 0-2.74l1.52-1.13a.9.9 0 0 0 .34-1.01 12 12 0 0 0-2.71-4.67.9.9 0 0 0-1.05-.21l-1.72.75q-.32.15-.67.15a1.7 1.7 0 0 1-1.7-1.52l-.2-1.88a.9.9 0 0 0-.72-.8M14 18a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_settings_28_color__a",
                "x1": "19.75",
                "x2": "6.33",
                "y1": "25.07",
                "y2": "4.17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$d63ddea64fdc0d24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings28Filled', "28", [
    "M16.7 2.31Q15.35 2.01 14 2q-1.38.01-2.7.31a.9.9 0 0 0-.72.8l-.2 1.88A1.7 1.7 0 0 1 8 6.36L6.3 5.61a.9.9 0 0 0-1.04.21 12 12 0 0 0-2.7 4.67c-.12.37 0 .78.33 1.02l1.52 1.12a1.7 1.7 0 0 1 0 2.74L2.87 16.5a.9.9 0 0 0-.33 1.01 12 12 0 0 0 2.7 4.68c.27.28.7.37 1.05.21l1.73-.76a1.7 1.7 0 0 1 2.36 1.37l.21 1.88c.04.38.32.7.7.8 1.78.42 3.64.42 5.42 0 .37-.1.66-.42.7-.8l.2-1.88a1.7 1.7 0 0 1 2.37-1.37l1.73.75c.36.16.77.08 1.04-.21a12 12 0 0 0 2.7-4.67.9.9 0 0 0-.32-1.01l-1.53-1.13a1.7 1.7 0 0 1 0-2.74l1.52-1.13a.9.9 0 0 0 .34-1.01 12 12 0 0 0-2.71-4.67.9.9 0 0 0-1.05-.21l-1.72.75q-.32.15-.67.15a1.7 1.7 0 0 1-1.7-1.52l-.2-1.88a.9.9 0 0 0-.72-.8M14 18a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $bd5c6ab3f2a8957d$export$90f90f6cf5c8915c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings28Regular', "28", [
    "M14 9.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M11 14a3 3 0 1 1 6 0 3 3 0 0 1-6 0m10.7 8.4-1.72-.76A1.68 1.68 0 0 0 17.61 23l-.2 1.88a.9.9 0 0 1-.7.8c-1.78.42-3.64.42-5.42 0a.9.9 0 0 1-.7-.8L10.4 23a1.7 1.7 0 0 0-2.37-1.37l-1.73.76a.9.9 0 0 1-1.04-.21 12 12 0 0 1-2.7-4.68.9.9 0 0 1 .32-1.01l1.53-1.13a1.7 1.7 0 0 0 0-2.74l-1.52-1.12a.9.9 0 0 1-.34-1.02 12 12 0 0 1 2.71-4.67.9.9 0 0 1 1.04-.21l1.72.75a1.7 1.7 0 0 0 2.37-1.38l.21-1.87c.05-.4.33-.71.72-.8q1.32-.3 2.7-.31 1.36.01 2.68.31c.39.09.67.4.72.8l.2 1.88a1.7 1.7 0 0 0 2.37 1.37l1.72-.75a.9.9 0 0 1 1.05.21 12 12 0 0 1 2.7 4.67.9.9 0 0 1-.33 1.01l-1.52 1.13c-.44.32-.7.83-.7 1.37s.26 1.05.7 1.37l1.53 1.13c.31.23.44.64.33 1.01a12 12 0 0 1-2.7 4.67.9.9 0 0 1-1.05.21m-5.44-.2c.24-.73.73-1.37 1.43-1.78a3.2 3.2 0 0 1 2.9-.16l1.34.6c.86-1 1.53-2.16 1.97-3.4l-1.2-.88a3.2 3.2 0 0 1 0-5.16l1.2-.87q-.67-1.89-1.98-3.4l-1.33.58q-.6.27-1.29.28a3.2 3.2 0 0 1-3.17-2.86l-.17-1.46q-.97-.18-1.95-.19-1 0-1.97.2l-.16 1.45A3.2 3.2 0 0 1 7.4 7.74l-1.34-.6q-1.3 1.52-1.97 3.4l1.2.88a3.2 3.2 0 0 1 0 5.16l-1.2.88c.44 1.24 1.1 2.4 1.97 3.4l1.35-.6a3.2 3.2 0 0 1 4.45 2.58l.17 1.47q1.97.38 3.92 0l.16-1.47q.05-.33.14-.64"
]);
const $bd5c6ab3f2a8957d$export$4b016301c5f851b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_settings_32_color__a)",
            "d": "M28.83 18.47q.38.28.53.73.15.46 0 .9a14 14 0 0 1-3.15 5.45 1.5 1.5 0 0 1-1.67.35l-1.95-.86a1.47 1.47 0 0 0-2.07 1.2l-.24 2.12a1.5 1.5 0 0 1-1.12 1.28c-2.08.5-4.24.5-6.32 0a1.5 1.5 0 0 1-1.13-1.27l-.23-2.13a1.48 1.48 0 0 0-2.07-1.2l-1.95.87a1.5 1.5 0 0 1-1.67-.35 14 14 0 0 1-3.16-5.45 1.5 1.5 0 0 1 .54-1.63l1.72-1.27a1.5 1.5 0 0 0 0-2.4l-1.72-1.28a1.48 1.48 0 0 1-.54-1.62A14 14 0 0 1 5.8 6.47 1.4 1.4 0 0 1 6.88 6q.3 0 .58.12l1.95.85a1.5 1.5 0 0 0 2.07-1.2l.24-2.12a1.5 1.5 0 0 1 1.14-1.29q1.57-.33 3.15-.36 1.58.03 3.13.36a1.5 1.5 0 0 1 1.14 1.29l.24 2.12a1.48 1.48 0 0 0 2.07 1.2l1.94-.86a1.5 1.5 0 0 1 1.68.35 14 14 0 0 1 3.15 5.44 1.5 1.5 0 0 1-.53 1.63L27.1 14.8a1.48 1.48 0 0 0 0 2.4zM16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_settings_32_color__a",
                "x1": "22.72",
                "x2": "7.06",
                "y1": "28.93",
                "y2": "4.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$642cfbb3c60bbecc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings32Filled', "32", [
    "M28.83 18.47q.38.28.53.73.15.46 0 .9a14 14 0 0 1-3.15 5.45 1.5 1.5 0 0 1-1.67.35l-1.95-.86a1.47 1.47 0 0 0-2.07 1.2l-.24 2.12a1.5 1.5 0 0 1-1.12 1.28c-2.08.5-4.24.5-6.32 0a1.5 1.5 0 0 1-1.13-1.27l-.23-2.13a1.48 1.48 0 0 0-2.07-1.2l-1.95.87a1.5 1.5 0 0 1-1.67-.35 14 14 0 0 1-3.16-5.45 1.5 1.5 0 0 1 .54-1.63l1.72-1.27a1.5 1.5 0 0 0 0-2.4l-1.72-1.28a1.48 1.48 0 0 1-.54-1.62A14 14 0 0 1 5.8 6.47 1.4 1.4 0 0 1 6.88 6q.3 0 .58.12l1.95.85a1.5 1.5 0 0 0 2.07-1.2l.24-2.12a1.5 1.5 0 0 1 1.14-1.29q1.57-.33 3.15-.36 1.58.03 3.13.36a1.5 1.5 0 0 1 1.14 1.29l.24 2.12a1.48 1.48 0 0 0 2.07 1.2l1.94-.86a1.5 1.5 0 0 1 1.68.35 14 14 0 0 1 3.15 5.44 1.5 1.5 0 0 1-.53 1.63L27.1 14.8a1.48 1.48 0 0 0 0 2.4zM16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
]);
const $bd5c6ab3f2a8957d$export$b4a47afb5c89ace3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings32Light', "32", [
    "M21 16a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0M5.9 6.3A1 1 0 0 1 7 6.11l1.8.83A2 2 0 0 0 11.6 5.4l.3-2.18a1 1 0 0 1 .71-.81 14 14 0 0 1 6.76 0c.38.1.65.42.7.8l.3 2.19a2 2 0 0 0 2.82 1.54l1.8-.83a1 1 0 0 1 1.1.2 14 14 0 0 1 3.35 5.79c.11.4-.05.8-.38 1.04l-1.74 1.22a2 2 0 0 0 0 3.28l1.74 1.22c.33.23.5.65.38 1.04-.64 2.2-1.8 4.19-3.35 5.8a1 1 0 0 1-1.1.19l-1.8-.83a2 2 0 0 0-2.82 1.54l-.3 2.18a1 1 0 0 1-.7.81 14 14 0 0 1-6.76 0 1 1 0 0 1-.7-.8l-.3-2.19a2 2 0 0 0-2.82-1.54l-1.8.83a1 1 0 0 1-1.1-.2 14 14 0 0 1-3.35-5.79 1 1 0 0 1 .38-1.04l1.74-1.22a2 2 0 0 0 0-3.28l-1.74-1.22a1 1 0 0 1-.38-1.04c.64-2.2 1.8-4.19 3.35-5.8m-2.38 6.04 1.72 1.2a3 3 0 0 1 0 4.92l-1.72 1.2c.6 2.02 1.66 3.83 3.07 5.31l1.79-.82a3 3 0 0 1 4.23 2.32l.29 2.16a13 13 0 0 0 6.2 0l.3-2.16a3 3 0 0 1 4.22-2.32l1.79.82a13 13 0 0 0 3.07-5.3l-1.72-1.21a3 3 0 0 1 0-4.92l1.72-1.2a13 13 0 0 0-3.07-5.31l-1.79.82a3 3 0 0 1-4.23-2.32l-.3-2.16a13 13 0 0 0-6.19 0l-.3 2.16a3 3 0 0 1-4.22 2.32l-1.79-.82a13 13 0 0 0-3.07 5.3"
]);
const $bd5c6ab3f2a8957d$export$ed2743963d9b416f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings32Regular', "32", [
    "M16 11a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.16 13.63a13.6 13.6 0 0 0 6.32 0 1.5 1.5 0 0 0 1.13-1.28l.23-2.13a1.47 1.47 0 0 1 2.07-1.2l1.95.86a1.5 1.5 0 0 0 1.67-.35 14 14 0 0 0 3.16-5.44 1.5 1.5 0 0 0-.54-1.63l-1.73-1.27a1.48 1.48 0 0 1 0-2.4l1.73-1.27a1.5 1.5 0 0 0 .53-1.63 14 14 0 0 0-3.15-5.44 1.5 1.5 0 0 0-1.68-.35l-1.94.86a1.48 1.48 0 0 1-2.07-1.2l-.24-2.12a1.5 1.5 0 0 0-1.14-1.29A15 15 0 0 0 16 2a15 15 0 0 0-3.15.36 1.5 1.5 0 0 0-1.14 1.28l-.24 2.13a1.5 1.5 0 0 1-2.07 1.2l-1.95-.85a1.5 1.5 0 0 0-1.67.35 14 14 0 0 0-3.16 5.44 1.5 1.5 0 0 0 .54 1.63l1.72 1.27a1.5 1.5 0 0 1 0 2.4l-1.72 1.27a1.5 1.5 0 0 0-.54 1.63c.64 2.03 1.71 3.9 3.16 5.45a1.5 1.5 0 0 0 1.08.46q.3 0 .59-.12l1.96-.86a1.48 1.48 0 0 1 2.06 1.2l.24 2.13a1.5 1.5 0 0 0 1.12 1.27m5.5-1.87c-1.54.32-3.13.32-4.68 0l-.2-1.74a3.48 3.48 0 0 0-4.85-2.8l-1.6.7a12 12 0 0 1-2.35-4.06l1.42-1.05a3.5 3.5 0 0 0 0-5.61l-1.42-1.05A12 12 0 0 1 7 8.1l1.6.7a3.5 3.5 0 0 0 3.72-.6A3.5 3.5 0 0 0 13.47 6l.2-1.75q1.16-.23 2.35-.24 1.18.01 2.32.24l.2 1.74A3.48 3.48 0 0 0 23.4 8.8l1.6-.7a12 12 0 0 1 2.34 4.04l-1.42 1.05a3.48 3.48 0 0 0 0 5.62l1.42 1.05A12 12 0 0 1 25 23.9l-1.6-.7a3.47 3.47 0 0 0-4.87 2.81z"
]);
const $bd5c6ab3f2a8957d$export$fd13426696333f65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_settings_48_color__a)",
            "d": "M19.5 43.47a19.4 19.4 0 0 0 9.01 0 1.9 1.9 0 0 0 1.47-1.68l.34-3.07a2.32 2.32 0 0 1 3.25-1.87l2.81 1.23a1.9 1.9 0 0 0 2.2-.45 20 20 0 0 0 4.51-7.78 1.9 1.9 0 0 0-.7-2.13l-2.49-1.84a2.33 2.33 0 0 1 0-3.77l2.49-1.83a1.9 1.9 0 0 0 .7-2.14c-.9-2.9-2.45-5.55-4.52-7.78a1.9 1.9 0 0 0-2.2-.45l-2.8 1.24q-.44.2-.92.2a2.34 2.34 0 0 1-2.32-2.09l-.34-3.06a1.9 1.9 0 0 0-1.5-1.68q-2.21-.5-4.47-.52-2.28.04-4.5.52a1.9 1.9 0 0 0-1.5 1.68l-.34 3.06a2.35 2.35 0 0 1-3.26 1.9l-2.8-1.24a1.9 1.9 0 0 0-2.2.45 20 20 0 0 0-4.51 7.78 1.9 1.9 0 0 0 .7 2.13l2.49 1.84a2.34 2.34 0 0 1 0 3.77l-2.5 1.83a1.9 1.9 0 0 0-.7 2.14c.91 2.9 2.45 5.56 4.52 7.78a2 2 0 0 0 1.41.62q.4 0 .78-.16l2.82-1.24q.44-.2.92-.2a2.34 2.34 0 0 1 2.33 2.08l.34 3.06a1.9 1.9 0 0 0 1.47 1.67M24 30.25a6.25 6.25 0 1 1 0-12.5 6.25 6.25 0 0 1 0 12.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_settings_48_color__a",
                "x1": "33.59",
                "x2": "11.23",
                "y1": "42.45",
                "y2": "7.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$de6655857c5263cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings48Filled', "48", [
    "M19.5 43.47a19.4 19.4 0 0 0 9.01 0 1.9 1.9 0 0 0 1.47-1.68l.34-3.07a2.32 2.32 0 0 1 3.25-1.87l2.81 1.23a1.9 1.9 0 0 0 2.2-.45 20 20 0 0 0 4.51-7.78 1.9 1.9 0 0 0-.7-2.13l-2.49-1.84a2.33 2.33 0 0 1 0-3.77l2.49-1.83a1.9 1.9 0 0 0 .7-2.14c-.9-2.9-2.45-5.55-4.52-7.78a1.9 1.9 0 0 0-2.2-.45l-2.8 1.24q-.44.2-.92.2a2.34 2.34 0 0 1-2.32-2.09l-.34-3.06a1.9 1.9 0 0 0-1.5-1.68q-2.21-.5-4.47-.52-2.28.04-4.5.52a1.9 1.9 0 0 0-1.5 1.68l-.34 3.06a2.35 2.35 0 0 1-3.26 1.9l-2.8-1.24a1.9 1.9 0 0 0-2.2.45 20 20 0 0 0-4.51 7.78 1.9 1.9 0 0 0 .7 2.13l2.49 1.84a2.34 2.34 0 0 1 0 3.77l-2.5 1.83a1.9 1.9 0 0 0-.7 2.14c.91 2.9 2.45 5.56 4.52 7.78a2 2 0 0 0 1.41.62q.4 0 .78-.16l2.82-1.24q.44-.2.92-.2a2.34 2.34 0 0 1 2.33 2.08l.34 3.06a1.9 1.9 0 0 0 1.47 1.67M24 30.25a6.25 6.25 0 1 1 0-12.5 6.25 6.25 0 0 1 0 12.5"
]);
const $bd5c6ab3f2a8957d$export$54854d836087f136 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Settings48Regular', "48", [
    "M24 16.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M19 24a5 5 0 1 1 10 0 5 5 0 0 1-10 0m.5 19.47a19.4 19.4 0 0 0 9.01 0 1.9 1.9 0 0 0 1.47-1.68l.34-3.07a2.32 2.32 0 0 1 3.25-1.87l2.81 1.23a1.9 1.9 0 0 0 2.2-.45 20 20 0 0 0 4.51-7.78 1.9 1.9 0 0 0-.7-2.13l-2.49-1.84a2.33 2.33 0 0 1 0-3.77l2.49-1.83a1.9 1.9 0 0 0 .7-2.14c-.9-2.9-2.45-5.55-4.52-7.78a1.9 1.9 0 0 0-2.2-.45l-2.8 1.24q-.44.2-.92.2a2.34 2.34 0 0 1-2.32-2.09l-.34-3.06a1.9 1.9 0 0 0-1.5-1.68q-2.21-.5-4.47-.52-2.28.04-4.5.52a1.9 1.9 0 0 0-1.5 1.68l-.34 3.06a2.35 2.35 0 0 1-3.26 1.9l-2.8-1.24a1.9 1.9 0 0 0-2.2.45 20 20 0 0 0-4.51 7.78 1.9 1.9 0 0 0 .7 2.13l2.49 1.84a2.34 2.34 0 0 1 0 3.77l-2.5 1.83a1.9 1.9 0 0 0-.7 2.14c.91 2.9 2.45 5.56 4.52 7.78a2 2 0 0 0 1.41.62q.4 0 .78-.16l2.82-1.24q.44-.2.92-.2a2.34 2.34 0 0 1 2.33 2.08l.34 3.06a1.9 1.9 0 0 0 1.47 1.67m8.06-2.35c-2.34.5-4.76.5-7.1 0l-.3-2.66a4.84 4.84 0 0 0-4.8-4.3h-.02q-1 0-1.92.4l-2.45 1.07a18 18 0 0 1-3.56-6.14l2.17-1.6a4.84 4.84 0 0 0 0-7.8L7.4 18.5a18 18 0 0 1 3.56-6.13l2.44 1.07q.91.4 1.93.4a4.85 4.85 0 0 0 4.82-4.3l.3-2.67q1.76-.35 3.56-.37 1.79.02 3.53.37l.3 2.66a4.83 4.83 0 0 0 6.75 3.9l2.43-1.07a18 18 0 0 1 3.56 6.15l-2.16 1.59a4.83 4.83 0 0 0 0 7.8l2.17 1.6a18 18 0 0 1-3.56 6.14l-2.44-1.07a4.82 4.82 0 0 0-6.75 3.9z"
]);
const $bd5c6ab3f2a8957d$export$32d3e93c242722f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsChat16Filled', "16", [
    "M1.27 5.15q.4-1.21 1.26-2.17.17-.16.38-.1l1.36.49a.7.7 0 0 0 .94-.54l.26-1.41a.4.4 0 0 1 .27-.29 6 6 0 0 1 2.52 0q.23.06.27.28l.26 1.42a.7.7 0 0 0 .94.54l1.36-.49a.4.4 0 0 1 .38.1q.86.96 1.26 2.17.06.23-.1.38l-.6.5a5.6 5.6 0 0 0-3.3.72 1.75 1.75 0 1 0-1.98 1.98 5.5 5.5 0 0 0-.56 4.21l-.45-.07a.4.4 0 0 1-.27-.29l-.26-1.41a.7.7 0 0 0-.94-.54l-1.36.49a.4.4 0 0 1-.38-.1q-.86-.96-1.26-2.17a.4.4 0 0 1 .1-.38l1.1-.93a.7.7 0 0 0 0-1.08l-1.1-.93a.4.4 0 0 1-.1-.38M11.5 16a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $bd5c6ab3f2a8957d$export$8d4a4bc11ae9bdfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsChat16Regular', "16", [
    "M7 5a2 2 0 0 0-.38 3.96q.28-.54.67-1a1 1 0 1 1 .67-.67q.46-.39 1-.67A2 2 0 0 0 7 5M4.2 9.62c.8-.15 1.56.28 1.87.99a6 6 0 0 0 .12 2.33l-.45-.07a.4.4 0 0 1-.27-.29l-.26-1.41a.7.7 0 0 0-.94-.54l-1.36.49a.4.4 0 0 1-.38-.1q-.86-.96-1.26-2.17a.4.4 0 0 1 .1-.38l1.1-.93a.7.7 0 0 0 0-1.08l-1.1-.93a.4.4 0 0 1-.1-.38q.4-1.21 1.26-2.17.17-.16.38-.1l1.36.49a.7.7 0 0 0 .94-.54l.26-1.41a.4.4 0 0 1 .27-.29 6 6 0 0 1 2.52 0q.23.06.27.28l.26 1.42a.7.7 0 0 0 .94.54l1.36-.49a.4.4 0 0 1 .38.1q.86.96 1.26 2.17.06.23-.1.38l-.6.5a6 6 0 0 0-1.49.05q.13-.21.34-.38l.75-.64A5 5 0 0 0 11 3.98l-.94.33a1.7 1.7 0 0 1-2.25-1.3l-.18-.97a5 5 0 0 0-1.26 0l-.18.97a1.7 1.7 0 0 1-2.25 1.3L3 3.98q-.39.5-.63 1.08l.75.64a1.7 1.7 0 0 1 0 2.6l-.75.64q.24.59.63 1.08l.94-.33q.12-.05.26-.07M11.5 16a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $bd5c6ab3f2a8957d$export$21d47d41cdc7b51f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsChat20Filled', "20", [
    "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32-.07.06a5.5 5.5 0 0 0-4.35.32 2 2 0 1 0-2.34 2.34 5.5 5.5 0 0 0-.13 4.81l-.43 1.4-.05.27-.79-.13a.5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54m8.1 11.12a.4.4 0 0 0 .52.48l1.79-.54q.98.55 2.18.56a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0-2.72.92q-.5.36-.86.86a4.5 4.5 0 0 0-.36 4.9l-.54 1.8zM14.5 15a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1zm-2-2h4a.5.5 0 1 1 0 1h-4a.5.5 0 1 1 0-1"
]);
const $bd5c6ab3f2a8957d$export$4b3f1ba6c2ab001e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsChat20Regular', "20", [
    "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32-.07.06q-.5-.17-1.04-.25a2 2 0 0 1 .47-.57l1.29-1.1a8 8 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a8 8 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a8 8 0 0 0-1.24 2.16l1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1q.45 1.19 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67.53.07-.22.7-.05.27-.79-.13a.5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54m8.1 11.12a.4.4 0 0 0 .52.48l1.79-.54q.98.55 2.18.56a4.5 4.5 0 1 0-2.05-8.5 4.48 4.48 0 0 0-1.89 6.19l-.24.8-.3.98zM14.5 15a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1zm2-1h-4a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1M10 7.5a2.5 2.5 0 0 1 2.43 1.9q-.5.2-.93.5a1.5 1.5 0 1 0-1.6 1.6q-.3.43-.5.93A2.5 2.5 0 0 1 10 7.5"
]);
const $bd5c6ab3f2a8957d$export$aa05e0181c3e396c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsChat24Filled', "24", [
    "M14.2 2.5q-1.08-.24-2.19-.25-1.12.01-2.2.25a.75.75 0 0 0-.58.65l-.17 1.53A1.4 1.4 0 0 1 7.13 5.8l-1.4-.62a.75.75 0 0 0-.85.17 10 10 0 0 0-2.2 3.8c-.1.3 0 .63.27.82l1.24.92a1.38 1.38 0 0 1 0 2.22l-1.24.92a.75.75 0 0 0-.28.82 10 10 0 0 0 2.2 3.8c.23.23.57.3.86.18l1.4-.62a1.38 1.38 0 0 1 1.93 1.11l.17 1.52c.03.32.26.58.57.65q.68.16 1.37.22l.45-1.45a6.5 6.5 0 0 1-.1-5.3 3 3 0 1 1 3.44-3.44 6.5 6.5 0 0 1 4.49-.22q.13-.24.37-.41l1.24-.92a.75.75 0 0 0 .27-.82 10 10 0 0 0-2.2-3.8.75.75 0 0 0-.86-.17l-1.4.61q-.26.12-.55.12c-.7 0-1.3-.53-1.37-1.23l-.17-1.53a.75.75 0 0 0-.59-.65m5.08 9.8A5.5 5.5 0 0 0 12 17.5q.02 1.47.69 2.67l-.67 2.19a.5.5 0 0 0 .63.62l2.18-.67q1.2.68 2.67.7a5.5 5.5 0 0 0 1.78-10.71M15.5 18h2a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1m4-1h-4a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1"
]);
const $bd5c6ab3f2a8957d$export$a96dbf8d9950c8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsChat24Regular', "24", [
    "M12.01 2.25q1.11.01 2.18.25c.32.07.55.33.59.65l.17 1.53a1.38 1.38 0 0 0 1.92 1.11l1.4-.61c.3-.13.64-.06.85.17a10 10 0 0 1 2.2 3.8c.1.3 0 .63-.26.82l-1.24.92q-.24.16-.37.4-.74-.22-1.52-.28c.19-.52.53-1 1-1.33l.8-.59a8 8 0 0 0-1.35-2.32l-.9.4q-.56.24-1.16.24c-1.47 0-2.7-1.1-2.86-2.57l-.11-.97A9 9 0 0 0 12 3.75q-.67 0-1.35.12l-.11.97a2.9 2.9 0 0 1-4.02 2.33l-.9-.4A8 8 0 0 0 4.28 9.1l.8.59a2.88 2.88 0 0 1 0 4.64l-.8.59a8 8 0 0 0 1.35 2.32l.9-.4a2.88 2.88 0 0 1 4.02 2.32l.1.99q.48.07.95.1l.02.02-.45 1.45a10 10 0 0 1-1.37-.22.75.75 0 0 1-.57-.65l-.17-1.52a1.38 1.38 0 0 0-1.93-1.11l-1.4.62a.75.75 0 0 1-.85-.18 10 10 0 0 1-2.2-3.8c-.1-.3 0-.63.27-.82l1.24-.92a1.38 1.38 0 0 0 0-2.22l-1.24-.92a.75.75 0 0 1-.28-.82 10 10 0 0 1 2.2-3.8c.23-.23.57-.3.86-.17l1.4.62c.4.17.86.15 1.25-.08.38-.22.63-.6.68-1.04l.17-1.53a.75.75 0 0 1 .58-.65q1.08-.24 2.2-.25m5.74 9.76q.81.03 1.53.29a5.5 5.5 0 1 1-4.45 10.01l-2.18.67a.5.5 0 0 1-.63-.62l.67-2.2A5.5 5.5 0 0 1 17.75 12m-.25 6h-2a.5.5 0 0 0-.4.8q.15.19.4.2h2a.5.5 0 1 0 0-1m-2-1h4a.5.5 0 1 0 0-1h-4a.5.5 0 0 0-.36.83q.14.16.36.16M12 8.24c1.82 0 3.33 1.3 3.68 3q-.76.24-1.43.62a2.25 2.25 0 1 0-2.38 2.38q-.39.66-.61 1.43A3.75 3.75 0 0 1 12 8.25"
]);
const $bd5c6ab3f2a8957d$export$4b61e7e7256b5ee4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsCogMultiple20Filled', "20", [
    "M15 11q.23 0 .44.02.31.06.4.38l.22 1.03a.5.5 0 0 0 .64.37l1-.32q.32-.09.53.15a4 4 0 0 1 .43.76c.09.18.03.4-.12.53l-.79.7a.5.5 0 0 0 0 .75l.79.71c.15.13.2.35.13.53a4 4 0 0 1-.44.76.5.5 0 0 1-.52.15l-1.01-.32a.5.5 0 0 0-.64.37l-.22 1.03q-.09.32-.4.38a4 4 0 0 1-.87 0 .5.5 0 0 1-.4-.38l-.22-1.03a.5.5 0 0 0-.64-.37l-1.01.32c-.2.06-.4 0-.52-.15a4 4 0 0 1-.44-.76.5.5 0 0 1 .13-.53l.78-.7a.5.5 0 0 0 0-.75l-.78-.71a.5.5 0 0 1-.13-.53 4 4 0 0 1 .44-.76.5.5 0 0 1 .52-.15l1 .32a.5.5 0 0 0 .65-.37l.22-1.03q.08-.32.4-.38zm0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2M7.5 1q.45 0 .9.06l.28.05.07.02q.27.1.33.37l.4 1.84a.5.5 0 0 0 .64.37l1.79-.58.07-.02a.5.5 0 0 1 .46.17q.77.9 1.19 2.05a.5.5 0 0 1-.14.53l-1.4 1.27a.5.5 0 0 0 0 .74l1.4 1.26c.15.14.2.35.13.54a7 7 0 0 1-1.18 2.05.5.5 0 0 1-.53.15l-1.8-.58a.5.5 0 0 0-.64.37l-.4 1.84a.5.5 0 0 1-.4.4 7 7 0 0 1-2.35 0 .5.5 0 0 1-.4-.4l-.4-1.84a.5.5 0 0 0-.64-.37l-1.79.58a.5.5 0 0 1-.53-.15 7 7 0 0 1-1.19-2.05.5.5 0 0 1 .14-.54l1.4-1.26a.5.5 0 0 0 .07-.66l-.07-.08-1.4-1.27a.5.5 0 0 1-.14-.53 7 7 0 0 1 1.19-2.05l.05-.05a.5.5 0 0 1 .48-.1l1.8.58a.5.5 0 0 0 .64-.37l.39-1.84.02-.08a.5.5 0 0 1 .38-.31Q6.89 1 7.5 1m0 4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
]);
const $bd5c6ab3f2a8957d$export$13ce6a0895064dd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsCogMultiple20Regular', "20", [
    "M15 11q.23 0 .44.02.31.06.4.38l.21 1.03a.5.5 0 0 0 .65.37l1-.32q.32-.09.52.15.26.36.44.76c.08.18.02.4-.12.53l-.79.7a.5.5 0 0 0 0 .75l.79.7c.14.14.2.36.12.54q-.18.4-.44.76a.5.5 0 0 1-.52.15l-1-.32a.5.5 0 0 0-.65.37l-.22 1.03c-.04.2-.2.35-.4.38a4 4 0 0 1-.87 0 .5.5 0 0 1-.4-.38l-.21-1.03a.5.5 0 0 0-.65-.37l-1 .32c-.2.06-.4 0-.52-.15a4 4 0 0 1-.44-.76.5.5 0 0 1 .12-.53l.79-.7a.5.5 0 0 0 0-.75l-.79-.71a.5.5 0 0 1-.12-.53 4 4 0 0 1 .44-.76.5.5 0 0 1 .52-.15l1 .32a.5.5 0 0 0 .65-.37l.22-1.03c.04-.2.2-.35.4-.38zm0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2M7.5 1q.45 0 .9.06l.28.05.07.02q.27.1.33.37l.4 1.84a.5.5 0 0 0 .64.37l1.79-.58.07-.02a.5.5 0 0 1 .46.17q.78.9 1.18 2.05a.5.5 0 0 1-.13.53l-1.4 1.27a.5.5 0 0 0 0 .74l1.4 1.26c.15.14.2.35.13.54a7 7 0 0 1-1.18 2.05.5.5 0 0 1-.53.15l-1.8-.58a.5.5 0 0 0-.64.37l-.4 1.84a.5.5 0 0 1-.4.4 7 7 0 0 1-2.35 0 .5.5 0 0 1-.4-.4l-.4-1.84a.5.5 0 0 0-.64-.37l-1.79.58a.5.5 0 0 1-.53-.15 7 7 0 0 1-1.19-2.05.5.5 0 0 1 .14-.54l1.4-1.26a.5.5 0 0 0 .07-.66l-.07-.08-1.4-1.27a.5.5 0 0 1-.14-.53 7 7 0 0 1 1.19-2.05l.05-.05a.5.5 0 0 1 .48-.1l1.8.58a.5.5 0 0 0 .64-.37l.39-1.84.02-.08a.5.5 0 0 1 .38-.31Q6.89 1 7.5 1m0 1q-.34 0-.67.04l-.33 1.5a1.5 1.5 0 0 1-1.93 1.12L3.11 4.2q-.4.54-.68 1.16L3.58 6.4l.12.11c.54.61.5 1.55-.12 2.11L2.43 9.64q.27.63.68 1.17l1.46-.47a1.5 1.5 0 0 1 1.93 1.11l.33 1.5a5 5 0 0 0 1.34 0l.32-1.5a1.5 1.5 0 0 1 1.93-1.11l1.47.47q.41-.54.67-1.17l-1.14-1.03a1.5 1.5 0 0 1 0-2.22l1.14-1.04q-.27-.62-.67-1.16l-1.47.47A1.5 1.5 0 0 1 8.5 3.55l-.32-1.5A6 6 0 0 0 7.5 2m0 3.25a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m0 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $bd5c6ab3f2a8957d$export$a58abb7bd01bbde8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsCogMultiple24Filled', "24", [
    "M18 13q.25 0 .5.02c.3.03.53.27.59.56l.26 1.24c.07.33.4.52.72.42l1.21-.4c.29-.09.6 0 .78.24a5 5 0 0 1 .5.86c.12.27.03.59-.2.79l-.93.85a.56.56 0 0 0 0 .83l.94.85c.22.2.31.52.19.8q-.2.45-.5.85a.7.7 0 0 1-.77.24l-1.22-.4a.56.56 0 0 0-.72.42l-.26 1.25c-.07.3-.3.53-.6.56a5 5 0 0 1-.98 0 .7.7 0 0 1-.6-.56l-.26-1.25a.56.56 0 0 0-.72-.42l-1.22.4c-.28.09-.6 0-.77-.24a5 5 0 0 1-.5-.85.7.7 0 0 1 .19-.8l.95-.85a.56.56 0 0 0 0-.83l-.95-.86a.7.7 0 0 1-.18-.78 5 5 0 0 1 .5-.86c.17-.24.48-.33.77-.24l1.21.4c.32.1.65-.1.72-.42l.26-1.24c.07-.3.3-.53.6-.56zm0 3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-9-15q.52 0 1 .07l.33.05.1.02q.4.15.5.56L11.3 4l.02.07c.11.36.5.57.88.44l1.72-.57.11-.03c.26-.05.53.05.7.25a8 8 0 0 1 1.34 2.3c.1.3.02.62-.21.82l-1.37 1.21a.7.7 0 0 0 0 1.04l1.37 1.2c.23.21.3.53.2.82q-.46 1.28-1.33 2.3a.8.8 0 0 1-.81.23l-1.72-.57a.7.7 0 0 0-.88.44l-.02.07-.37 1.78c-.06.3-.3.53-.6.59a8 8 0 0 1-2.66 0 .8.8 0 0 1-.6-.6l-.36-1.77a.7.7 0 0 0-.9-.51l-1.72.57c-.29.1-.61 0-.8-.23a8 8 0 0 1-1.34-2.3.8.8 0 0 1 .2-.82l1.36-1.2a.7.7 0 0 0 0-1.04l-1.35-1.2a.8.8 0 0 1-.21-.81 8 8 0 0 1 1.33-2.31l.08-.08c.2-.18.47-.23.73-.15l1.72.57A.7.7 0 0 0 6.7 4l.36-1.78.03-.11q.15-.39.57-.48.65-.12 1.34-.12m0 5.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5"
]);
const $bd5c6ab3f2a8957d$export$85ed28cc2a1a3f03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsCogMultiple24Regular', "24", [
    "M18 13q.24 0 .5.02c.3.03.52.27.58.56l.27 1.24c.07.33.4.52.72.42l1.2-.4c.3-.09.6 0 .78.24a5 5 0 0 1 .5.86c.12.27.04.59-.18.79l-.95.85a.56.56 0 0 0 0 .83l.95.85c.22.2.3.52.18.8q-.2.45-.5.85a.7.7 0 0 1-.77.24l-1.21-.4a.56.56 0 0 0-.72.42l-.27 1.25c-.06.3-.29.53-.59.56a5 5 0 0 1-.99 0 .7.7 0 0 1-.59-.56l-.26-1.25a.56.56 0 0 0-.72-.42l-1.22.4c-.29.09-.6 0-.78-.24a5 5 0 0 1-.5-.85.7.7 0 0 1 .2-.8l.94-.85a.56.56 0 0 0 0-.83l-.94-.86a.7.7 0 0 1-.19-.78 5 5 0 0 1 .5-.86c.17-.24.49-.33.77-.24l1.22.4c.31.1.65-.1.72-.42l.26-1.24c.06-.3.3-.53.6-.56zm0 3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-9-15q.52 0 1 .07l.33.05.1.02q.4.15.5.56L11.3 4l.02.07c.11.36.5.57.88.44l1.72-.57.11-.03c.26-.05.53.05.7.25a8 8 0 0 1 1.34 2.3c.1.3.02.62-.21.82l-1.37 1.21a.7.7 0 0 0 0 1.04l1.37 1.2c.23.21.3.53.2.82q-.46 1.28-1.33 2.3a.8.8 0 0 1-.81.23l-1.72-.57a.7.7 0 0 0-.88.44l-.02.07-.37 1.78c-.06.3-.3.53-.6.59a8 8 0 0 1-2.66 0 .8.8 0 0 1-.6-.6l-.36-1.77a.7.7 0 0 0-.9-.51l-1.72.57c-.29.1-.61 0-.8-.23a8 8 0 0 1-1.34-2.3.8.8 0 0 1 .2-.82l1.36-1.2a.7.7 0 0 0 0-1.04l-1.35-1.2a.8.8 0 0 1-.21-.81 8 8 0 0 1 1.33-2.31l.08-.08c.2-.18.47-.23.73-.15l1.72.57A.7.7 0 0 0 6.7 4l.36-1.78.03-.11q.15-.39.57-.48.65-.12 1.34-.12M9 3q-.29 0-.57.03l-.26 1.26a2.2 2.2 0 0 1-2.84 1.64l-1.21-.4a6 6 0 0 0-.57.98l.96.85c.98.87.98 2.4 0 3.28l-.96.85q.24.52.57.99l1.21-.4a2.2 2.2 0 0 1 2.84 1.63l.26 1.26a6 6 0 0 0 1.14 0l.26-1.26.06-.23a2.2 2.2 0 0 1 2.78-1.4l1.22.4a6 6 0 0 0 .57-.98l-.96-.86a2.2 2.2 0 0 1 0-3.28l.96-.86a6 6 0 0 0-.57-.98l-1.22.4a2.2 2.2 0 0 1-2.78-1.4l-.06-.23-.26-1.26zm0 3.25a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $bd5c6ab3f2a8957d$export$62c00707418d4c82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsSync20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 1.5q.9 0 1.78.19.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13q1.21 1.36 1.78 3.08.08.32-.15.54l-1.56 1.32-.07.07a5.5 5.5 0 0 0-4.35.31 2 2 0 1 0-2.34 2.34 5.5 5.5 0 0 0 1.07 6.5 9 9 0 0 1-2.47-.15.5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4A9 9 0 0 1 10 1.5M12.5 15a.5.5 0 0 0-.5.5V17a.5.5 0 1 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 0 0-.7-.7 2 2 0 0 1-2.39.33H14a.5.5 0 0 0 0-1zm4-3.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7 2 2 0 0 1 2.39-.33H15a.5.5 0 1 0 0 1h1.5a.5.5 0 0 0 .5-.5V12a.5.5 0 0 0-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$af376684d7c10e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SettingsSync20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 1.5q.9 0 1.78.19.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13q1.21 1.36 1.78 3.08.08.32-.15.54l-1.56 1.32-.07.07q-.5-.17-1.04-.26a2 2 0 0 1 .47-.57l1.29-1.1a8 8 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a8 8 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a8 8 0 0 0-1.24 2.16l1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1q.44 1.19 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67q.57.1 1.14.1.35.53.8.97a9 9 0 0 1-2.47-.16.5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4A9 9 0 0 1 10 1.5M12.5 15a.5.5 0 0 0-.5.5V17a.5.5 0 1 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 0 0-.7-.7 2 2 0 0 1-2.39.33H14a.5.5 0 0 0 0-1zm4-3.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7 2 2 0 0 1 2.39-.33H15a.5.5 0 1 0 0 1h1.5a.5.5 0 0 0 .5-.5V12a.5.5 0 0 0-.5-.5m-6.5-4a2.5 2.5 0 0 1 2.43 1.9q-.5.2-.94.5a1.5 1.5 0 1 0-1.6 1.6q-.29.44-.48.93A2.5 2.5 0 0 1 10 7.5"
]);
const $bd5c6ab3f2a8957d$export$6367475b9971e418 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeExclude16Filled', "16", [
    "M3 2.27A2 2 0 0 0 2 4v5c0 1.1.9 2 2 2h1v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2H4a2 2 0 0 0-1 .27M11 5v4a2 2 0 0 1-2 2H5V7c0-1.1.9-2 2-2z"
]);
const $bd5c6ab3f2a8957d$export$7780e550884e1b42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeExclude16Regular', "16", [
    "M2 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1H4a2 2 0 0 1-2-2zm1 2.56v1.58L8.14 3H6.56zM5.14 3H4a1 1 0 0 0-1 1v1.14zm4.31.1L7.55 5H9.3l.71-.7V4a1 1 0 0 0-.55-.9M5 7.57 3.1 9.45A1 1 0 0 0 4 10h.3l.7-.7zM11.7 13h.3a1 1 0 0 0 1-1v-.3zm1.3-2.7V8.7L8.7 13h1.6zm0-3V7a1 1 0 0 0-.45-.84L11 7.71V9q0 .15-.03.32zm-3.68 3.67Q9.17 11 9 11H7.7l-1.54 1.55A1 1 0 0 0 7 13h.3zM6 7v3h3a1 1 0 0 0 1-1V6H7a1 1 0 0 0-1 1"
]);
const $bd5c6ab3f2a8957d$export$4e0f85d7e20611e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeExclude20Filled', "20", [
    "M2 10.5v-6A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V7H9.5A2.5 2.5 0 0 0 7 9.5V13H4.5A2.5 2.5 0 0 1 2 10.5M7 13v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13v3.5a2.5 2.5 0 0 1-2.5 2.5z"
]);
const $bd5c6ab3f2a8957d$export$730c9a5a45686285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeExclude20Regular', "20", [
    "M2 10.53V4.5A2.5 2.5 0 0 1 4.5 2h6.06A2.5 2.5 0 0 1 13 4.5V7h2.5A2.5 2.5 0 0 1 18 9.5v6.22A2.5 2.5 0 0 1 15.5 18h-6A2.5 2.5 0 0 1 7 15.5V13H4.5a2.5 2.5 0 0 1-2.09-1.12q-.39-.59-.4-1.32zM12 8H9.5C8.67 8 8 8.67 8 9.5V12h2.5c.83 0 1.5-.67 1.5-1.5zM3 9.56v.94q0 .35.15.65l8-8A2 2 0 0 0 10.5 3h-.94zM8.14 3H6.56L3 6.56v1.58zM3 5.14 5.14 3H4.5C3.67 3 3 3.67 3 4.5zm8.85-1.29L8.5 7.21Q8.96 7 9.5 7h.8L12 5.3v-.8q0-.35-.15-.65M7.21 8.5l-3.36 3.35q.3.15.65.15h.8L7 10.3v-.8q0-.54.2-1M8 13.7v1.6l2.3-2.3H8.7zm5-3.4L15.3 8h-1.6l-.7.7zm3.4-2-8.1 8.1q.38.49 1 .59L17 9.3a1.5 1.5 0 0 0-.59-1m.6 2.4L10.7 17h1.6l4.7-4.7zm0 3L13.7 17h1.6l1.7-1.7z"
]);
const $bd5c6ab3f2a8957d$export$aa686bdf4275a18d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeExclude24Filled', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v8c0 1.8 1.46 3.25 3.25 3.25H7.5v2.25c0 1.8 1.46 3.25 3.25 3.25h8c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H16.5V5.25c0-1.8-1.46-3.25-3.25-3.25zM16.5 7.5v5.75c0 1.8-1.46 3.25-3.25 3.25H7.5v-5.75c0-1.8 1.46-3.25 3.25-3.25z"
]);
const $bd5c6ab3f2a8957d$export$ee5ef68775f6d7c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeExclude24Regular', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h8a3.3 3.3 0 0 1 1.82.56 3.3 3.3 0 0 1 1.42 2.4l.01.29V7.5h2.25A3.24 3.24 0 0 1 22 10.75v8c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25V16.5H5.25a3.3 3.3 0 0 1-1.7-.48h-.02a3.3 3.3 0 0 1-1.52-2.47l-.01-.3zm1.5 2.81v1.88L9.94 3.5H8.06zM5.94 3.5h-.69c-.97 0-1.75.78-1.75 1.75v.69zm6.12 0L3.5 12.06v1.19q0 .3.1.59L7.64 9.8A3.3 3.3 0 0 1 9.8 7.64l4.04-4.04q-.28-.1-.59-.1zm2.84 1.16L12.06 7.5h1.88L15 6.44V5.25q0-.3-.1-.59m-7.4 7.4L4.66 14.9q.28.1.59.1h1.19l1.06-1.06zm1.5 6.5v.19c0 .47.18.9.48 1.2l3.46-3.45h-1.88zm7.5-5.62 3.46-3.46q-.5-.46-1.21-.48h-.19l-2.06 2.06zm4-1.88-9.44 9.44h1.88l7.56-7.56zm0 4-5.44 5.44h1.88l3.56-3.56zm-.03 4.03a1.8 1.8 0 0 1-1.38 1.38zM9 10.75V15h4.25c.97 0 1.75-.78 1.75-1.75V9h-4.25C9.78 9 9 9.78 9 10.75"
]);
const $bd5c6ab3f2a8957d$export$2e4f407721ed8704 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeIntersect16Filled', "16", [
    "M2 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1H4a2 2 0 0 1-2-2zm8 0a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1V7c0-1.1.9-2 2-2h3zm-4 7v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1v3a2 2 0 0 1-2 2z"
]);
const $bd5c6ab3f2a8957d$export$27a88b55886361ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeIntersect16Regular', "16", [
    "M2 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1H4a2 2 0 0 1-2-2zm8 0a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1V7c0-1.1.9-2 2-2h3zM6 9.7v.3h1.3L10 7.3V6h-.3zM8.3 6H7a1 1 0 0 0-1 1v1.3zM11 9a2 2 0 0 1-1.68 1.97Q9.17 11 9 11H6v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1zm-2.3 1H9a1 1 0 0 0 1-1v-.3z"
]);
const $bd5c6ab3f2a8957d$export$6eebd695e10095d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeIntersect20Filled', "20", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V7h2.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5V13H4.5A2.5 2.5 0 0 1 2 10.5zM7 12V9.5A2.5 2.5 0 0 1 9.5 7H12V4.5c0-.83-.67-1.5-1.5-1.5h-6C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5zm1 1v2.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H13v2.5a2.5 2.5 0 0 1-2.5 2.5z"
]);
const $bd5c6ab3f2a8957d$export$73883bad33631884 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeIntersect20Regular', "20", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V7h2.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5V13H4.5A2.5 2.5 0 0 1 2 10.5zm10 0c0-.83-.67-1.5-1.5-1.5h-6C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7V9.5A2.5 2.5 0 0 1 9.5 7H12zm-4 6.2V12h.3L12 8.3V8h-1.3zm.02-1.42 1.26-1.26a1.5 1.5 0 0 0-1.26 1.26M13 8v2.5a2.5 2.5 0 0 1-2.5 2.5H8v2.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5zm-3.3 4h.8c.83 0 1.5-.67 1.5-1.5v-.8z"
]);
const $bd5c6ab3f2a8957d$export$630fed21013c6822 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeIntersect24Filled', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V7.5h2.25c1.8 0 3.25 1.46 3.25 3.25v8c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25V16.5H5.25A3.25 3.25 0 0 1 2 13.25zm13 0c0-.97-.78-1.75-1.75-1.75h-8c-.97 0-1.75.78-1.75 1.75v8c0 .97.78 1.75 1.75 1.75H7.5v-4.25a3.23 3.23 0 0 1 3.25-3.25H15zm1 9.73A3.4 3.4 0 0 1 14.98 16q-.77.49-1.73.5H9v2.25c0 .97.78 1.75 1.75 1.75h8c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75H16.5v4.25q-.01.97-.5 1.73"
]);
const $bd5c6ab3f2a8957d$export$26ba9bfb54ee917 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeIntersect24Regular', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V7.5h2.25c1.8 0 3.25 1.46 3.25 3.25v8c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25V16.5H5.25A3.25 3.25 0 0 1 2 13.25zm13 0c0-.97-.78-1.75-1.75-1.75h-8c-.97 0-1.75.78-1.75 1.75v8c0 .97.78 1.75 1.75 1.75H7.5v-4.25a3.25 3.25 0 0 1 3.25-3.25H15zm-6 9.31V15h1.44L15 10.44V9h-.44zM12.44 9h-1.69l-.2.01L9 10.55l-.01.2v1.69zm4.06 0v4.25c0 1.8-1.46 3.25-3.25 3.25H9v2.25c0 .97.78 1.75 1.75 1.75h8c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75zm-3.94 6h.69c.97 0 1.75-.78 1.75-1.75v-.69z"
]);
const $bd5c6ab3f2a8957d$export$d61086c17c57f6a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic16Filled', "16", [
    "M11.95 6.07c-.35-.27-.76-.81-.76-1.97 0-1.62-1.2-2.4-2.2-2.75A7 7 0 0 0 6.96 1c-1.56 0-2.74.48-3.62 1.23a6 6 0 0 0-1.75 2.65A10 10 0 0 0 1 8.3c-.02 2.14.66 4.5 2.62 5.64 1.55.9 3.55 1.06 5.42 1.06 1.73 0 3.23-.28 4.3-1.05q1.65-1.2 1.66-3.78c0-1.6-.52-2.56-1.1-3.12a3 3 0 0 0-.8-.53c-.4-.18-.8-.18-1.15-.45"
]);
const $bd5c6ab3f2a8957d$export$267b383695f7a22d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic16Regular', "16", [
    "M13.1 6.52c-.22-.1-.43-.12-.65-.2a2 2 0 0 1-.5-.25c-.35-.27-.76-.81-.76-1.97 0-1.62-1.19-2.4-2.2-2.75A7 7 0 0 0 6.96 1a5.7 5.7 0 0 0-3.6 1.12 5.7 5.7 0 0 0-1.77 2.45 9 9 0 0 0-.55 2.37C.82 9.3 1.3 12.08 3.3 13.6 4.72 14.67 6.6 15 8.5 15c1.73 0 3.35-.28 4.54-1.03a4.2 4.2 0 0 0 1.96-3.8c0-1.6-.52-2.56-1.1-3.12a3 3 0 0 0-.8-.53M3.9 12.8C2.39 11.64 1.99 9.54 2 7.73a8 8 0 0 1 .52-2.8c.3-.75.75-1.48 1.45-2.02a5.1 5.1 0 0 1 4.7-.61c.84.3 1.52.82 1.52 1.8 0 1.44.54 2.29 1.15 2.76.56.43 1.34.41 1.86.92 1.47 1.4.92 4.32-.7 5.34-.95.6-2.34.88-4 .88-1.82 0-3.44-.32-4.6-1.2"
]);
const $bd5c6ab3f2a8957d$export$f49d324c7475bc38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic20Filled', "20", [
    "M14.5 7.83c.42.32.89.33 1.35.53q.39.15.9.6C17.4 9.6 18 10.68 18 12.5a4.7 4.7 0 0 1-2.54 4.33C13.97 17.68 12 18 10 18c-2.19 0-4.21-.38-5.68-1.62-1.91-1.6-2.35-4.35-2.32-6.7 0-.66.09-2.12.67-3.61.4-1 1.02-2.02 2.01-2.8A6.7 6.7 0 0 1 8.86 2c.25 0 1.23.05 2.26.4 1.15.4 2.48 1.28 2.48 3.1 0 1.36.49 2 .9 2.33"
]);
const $bd5c6ab3f2a8957d$export$2eed239f2fe1aafd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic20Regular', "20", [
    "M14.5 7.83c.42.32.89.33 1.35.53q.39.15.9.6C17.4 9.6 18 10.68 18 12.5a4.7 4.7 0 0 1-2.54 4.33C13.97 17.68 12 18 10 18c-2.19 0-4.21-.38-5.68-1.62-1.91-1.6-2.35-4.35-2.32-6.7 0-.66.09-2.12.67-3.61.4-1 1.02-2.02 2.01-2.8A6.7 6.7 0 0 1 8.86 2c.25 0 1.23.05 2.26.4 1.15.4 2.48 1.28 2.48 3.1 0 1.36.49 2 .9 2.33m-9.54 7.79C6.16 16.62 7.89 17 10 17c1.92 0 3.7-.31 4.97-1.04 2.04-1.15 2.93-4.5 1.09-6.27a2 2 0 0 0-.62-.42c-.5-.22-1.1-.3-1.54-.65-.69-.53-1.3-1.48-1.3-3.12 0-1.18-.82-1.8-1.81-2.15A7 7 0 0 0 8.96 3 5.6 5.6 0 0 0 5.3 4.07a5.5 5.5 0 0 0-1.7 2.36A10 10 0 0 0 3 9.68c-.02 2.1.26 4.5 1.96 5.94"
]);
const $bd5c6ab3f2a8957d$export$e9adf89d502f8821 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic24Filled', "24", [
    "M16.85 8.95c-.35-.3-.85-.97-.85-2.6 0-1.07-.34-1.92-.88-2.56a4.6 4.6 0 0 0-1.85-1.29 7 7 0 0 0-2.53-.5 8.5 8.5 0 0 0-5.28 1.6 8 8 0 0 0-2.6 3.5 12 12 0 0 0-.8 3.38c-.33 3.35.4 7.27 3.2 9.44 2 1.56 4.7 2.08 7.5 2.08 2.57 0 4.87-.57 6.54-1.82a6.7 6.7 0 0 0 2.7-5.62 5.05 5.05 0 0 0-3.7-5.14c-.47-.15-1.05-.14-1.45-.47"
]);
const $bd5c6ab3f2a8957d$export$2d41785e662c8cd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic24Regular', "24", [
    "M16.85 8.95c-.35-.3-.85-.97-.85-2.6 0-1.07-.34-1.92-.88-2.56a4.6 4.6 0 0 0-1.85-1.29 7 7 0 0 0-2.53-.5 8.5 8.5 0 0 0-5.28 1.6 8 8 0 0 0-2.6 3.5 12 12 0 0 0-.8 3.38c-.33 3.35.4 7.27 3.2 9.44 2 1.56 4.7 2.08 7.5 2.08 2.57 0 4.87-.57 6.54-1.82a6.7 6.7 0 0 0 2.7-5.62 5.05 5.05 0 0 0-3.7-5.14c-.47-.15-1.05-.14-1.45-.47M6.17 18.73c-2.4-1.86-2.9-5.25-2.61-8.1.08-.82.27-1.9.7-2.97a6.6 6.6 0 0 1 2.1-2.87 7 7 0 0 1 6.35-.9q.76.3 1.26.86c.3.37.53.87.53 1.6 0 1.97.62 3.12 1.4 3.75.37.31.75.47 1.04.56.3.08.62.1.92.2.3.09.7.25 1.1.51 2.6 1.75 1.68 5.96-.55 7.6-1.33 1-3.28 1.53-5.66 1.53-2.65 0-4.95-.5-6.58-1.77"
]);
const $bd5c6ab3f2a8957d$export$2fe5575f4be89a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic28Filled', "28", [
    "M21.88 11.06c.45.15 1.06.4 1.67.85 1.25.9 2.45 2.5 2.45 5.26 0 3-1.38 5.24-3.56 6.7-2.16 1.46-5.07 2.13-8.19 2.13-3.39 0-6.48-.61-8.72-2.48-2.85-2.38-3.57-6.44-3.53-9.97A16 16 0 0 1 3.05 8.1a10 10 0 0 1 3.1-4.2 10.4 10.4 0 0 1 9.48-1.31c.79.3 1.63.77 2.27 1.51a4.5 4.5 0 0 1 1.08 3.03c0 2.04.63 2.91 1.1 3.3.5.41 1.2.42 1.8.62"
]);
const $bd5c6ab3f2a8957d$export$6ee399811a75a4a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic28Regular', "28", [
    "M21.88 11.06c.45.15 1.06.4 1.67.85 1.25.9 2.45 2.5 2.45 5.26 0 3-1.38 5.24-3.56 6.7-2.16 1.46-5.07 2.13-8.19 2.13-3.39 0-6.48-.61-8.72-2.48-2.85-2.38-3.57-6.44-3.53-9.97A16 16 0 0 1 3.05 8.1a10 10 0 0 1 3.1-4.2 10.4 10.4 0 0 1 9.48-1.31c.79.3 1.63.77 2.27 1.51a4.5 4.5 0 0 1 1.08 3.03c0 2.04.63 2.91 1.1 3.3.5.41 1.2.42 1.8.62M6.5 22.36c1.84 1.54 4.5 2.14 7.76 2.14 2.93 0 5.52-.64 7.35-1.87 2.91-1.95 4.35-7.15 1.08-9.5a5 5 0 0 0-1.27-.65c-.35-.11-.72-.14-1.07-.24a3 3 0 0 1-1.21-.64c-.9-.74-1.65-2.1-1.65-4.46 0-.91-.3-1.56-.71-2.04A4 4 0 0 0 15.09 4a8 8 0 0 0-2.6-.5c-2.44 0-4.18.66-5.43 1.61a8.3 8.3 0 0 0-2.62 3.57 14 14 0 0 0-.94 4.88c-.03 3.1.47 6.7 3 8.8"
]);
const $bd5c6ab3f2a8957d$export$6390e4c750561fa0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic32Filled', "32", [
    "M23.26 11.78c-.5-.41-1.22-1.38-1.22-3.7 0-1.52-.51-2.7-1.31-3.6A7 7 0 0 0 18 2.7a12 12 0 0 0-3.74-.7c-3.18 0-5.6.87-7.41 2.24a11.4 11.4 0 0 0-3.63 4.91c-.7 1.75-1 3.48-1.13 4.76-.45 4.6.3 10.08 4.04 13.2C8.75 29.28 12.36 30 16.29 30c3.62 0 7.01-.78 9.53-2.48A9.1 9.1 0 0 0 30 19.67c0-3.2-1.36-5.1-2.8-6.18-.7-.52-1.4-.83-1.91-1-.67-.23-1.47-.23-2.03-.7"
]);
const $bd5c6ab3f2a8957d$export$a26cf9867fc17c05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic32Regular', "32", [
    "M23.26 11.78c-.5-.41-1.22-1.38-1.22-3.7 0-1.52-.51-2.7-1.31-3.6A7 7 0 0 0 18 2.7a12 12 0 0 0-3.74-.7c-3.18 0-5.6.87-7.41 2.24a11.4 11.4 0 0 0-3.63 4.91c-.7 1.75-1 3.48-1.13 4.76-.45 4.6.3 10.08 4.04 13.2C8.75 29.28 12.36 30 16.29 30c3.62 0 7.01-.78 9.53-2.48A9.1 9.1 0 0 0 30 19.67c0-3.2-1.36-5.1-2.8-6.18-.7-.52-1.4-.83-1.91-1-.67-.23-1.47-.23-2.03-.7M7.41 25.56c-3.22-2.68-3.72-7.52-3.33-11.45.11-1.17.38-2.7 1-4.21a9.4 9.4 0 0 1 2.98-4.06C9.48 4.76 11.46 4 14.26 4q.47 0 .94.07c1.43.18 3.04.62 4.04 1.74.47.53.8 1.24.8 2.27 0 2.76.88 4.36 1.95 5.25.53.43 1.05.65 1.45.77s.8.14 1.2.27c.38.13.88.35 1.37.72 3.64 2.7 1.97 8.58-1.3 10.77-2.1 1.4-5.05 2.14-8.42 2.14-3.75 0-6.79-.69-8.88-2.44"
]);
const $bd5c6ab3f2a8957d$export$8766fc1b67ffcdbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic48Filled', "48", [
    "M39.65 20.43a11 11 0 0 0-2.94-1.4c-1.06-.32-2.16-.28-3.05-1.01-.78-.65-1.82-2.1-1.82-5.47a7.6 7.6 0 0 0-1.72-5.02A9 9 0 0 0 26.47 5a15 15 0 0 0-5.04-1c-3.52 0-7.34.8-10.53 3.18a16 16 0 0 0-5.16 6.98c-1 2.49-1.44 4.95-1.61 6.79-.67 6.73.74 14.52 6.35 18.89 4 3.1 9.4 4.16 15.04 4.16 5.18 0 9.79-1.16 13.12-3.63C42.04 37.87 44 34.1 44 29.2c0-4.6-2.15-7.28-4.35-8.76"
]);
const $bd5c6ab3f2a8957d$export$d359a0123fc92532 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeOrganic48Regular', "48", [
    "M39.65 20.43a11 11 0 0 0-2.94-1.4c-1.06-.32-2.16-.28-3.05-1.01-.78-.65-1.82-2.1-1.82-5.47a7.6 7.6 0 0 0-1.72-5.02A9 9 0 0 0 26.47 5a15 15 0 0 0-5.04-1c-3.52 0-7.34.8-10.53 3.18a16 16 0 0 0-5.16 6.98c-1 2.49-1.44 4.95-1.61 6.79-.67 6.73.74 14.52 6.35 18.89 4 3.1 9.4 4.16 15.04 4.16 5.18 0 9.79-1.16 13.12-3.63C42.04 37.87 44 34.1 44 29.2c0-4.6-2.15-7.28-4.35-8.76M12.02 37.86C7.18 34.11 6.04 27 6.62 21.2c.16-1.68.55-3.9 1.44-6.1 2.29-5.67 7.33-8.59 13.37-8.59q.63.01 1.27.1c.8.1 1.83.32 2.85.72 1.02.41 1.96 1 2.65 1.81a5 5 0 0 1 1.14 3.42c0 3.92 1.24 6.17 2.73 7.4 1.21 1 2.48 1.03 3.9 1.47.63.2 1.46.53 2.28 1.08 5.44 3.66 3.57 12.42-1.1 15.86-2.76 2.05-6.77 3.14-11.63 3.14-5.4 0-10.13-1.02-13.5-3.64"
]);
const $bd5c6ab3f2a8957d$export$5f5751fc20fbce8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeSubtract16Filled', "16", [
    "M3 2.27A2 2 0 0 0 2 4v5a2 2 0 0 0 .38 1.18A2 2 0 0 0 4 11h1v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2H4a2 2 0 0 0-1 .27M6 7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $bd5c6ab3f2a8957d$export$81a4032e8bcd54e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeSubtract16Regular', "16", [
    "M4 2a2 2 0 0 0-2 2v5a2 2 0 0 0 .38 1.18A2 2 0 0 0 4 11h1v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2zm1.14 1L3 5.14V4a1 1 0 0 1 1-1zM3 6.56 6.56 3h1.58L3 8.14zM9.45 3.1A1 1 0 0 1 10 4v.3l-.7.7H7.55zM5 7.56v1.73l-.7.71H4a1 1 0 0 1-.9-.55zM6 7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $bd5c6ab3f2a8957d$export$75bc5232b716aa21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeSubtract20Filled', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13V4.5A2.5 2.5 0 0 0 10.5 2zM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5z"
]);
const $bd5c6ab3f2a8957d$export$bde9e5e409668733 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeSubtract20Regular', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6.06q.02.74.41 1.32l.02.02A2.5 2.5 0 0 0 4.3 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13V4.5a2.5 2.5 0 0 0-.41-1.38l-.02-.02A2.5 2.5 0 0 0 10.51 2H4.5m.64 1L3 5.14V4.5C3 3.67 3.67 3 4.5 3zM3 6.56 6.56 3h1.58L3 8.14zM9.56 3h.94q.35 0 .65.15l-8 8A2 2 0 0 1 3 10.5v-.94zm2.3.85q.14.3.14.65v.8L10.3 7h-.8q-.54 0-1 .2zM7.2 8.5Q7 8.96 7 9.5v.8L5.3 12h-.8a2 2 0 0 1-.65-.15zm.79 1C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5z"
]);
const $bd5c6ab3f2a8957d$export$7bd84853c95e2f5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeSubtract24Filled', "24", [
    "M3 2.9c-.62.6-1 1.43-1 2.35v8a3.3 3.3 0 0 0 .56 1.82 3.3 3.3 0 0 0 2.69 1.43H7.5v2.25c0 1.8 1.46 3.25 3.25 3.25h8c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H16.5V5.25c0-1.8-1.46-3.25-3.25-3.25h-8c-.87 0-1.67.34-2.25.9m6 7.85C9 9.78 9.78 9 10.75 9h8c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-8c-.97 0-1.75-.78-1.75-1.75z"
]);
const $bd5c6ab3f2a8957d$export$76339274aba5572f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeSubtract24Regular', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v8a3.3 3.3 0 0 0 .56 1.82 3.3 3.3 0 0 0 2.4 1.42l.29.01H7.5v2.25c0 1.8 1.46 3.25 3.25 3.25h8c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H16.5V5.25a3.3 3.3 0 0 0-1.54-2.77q-.64-.38-1.41-.47l-.3-.01zm.69 1.5L3.5 5.94v-.69c0-.97.78-1.75 1.75-1.75zM3.5 8.06 8.06 3.5h1.88L3.5 9.94zm8.56-4.56h1.19q.3 0 .59.1L9.8 7.64A3.3 3.3 0 0 0 7.64 9.8L3.6 13.84q-.1-.28-.1-.59v-1.19zm2.84 1.16q.1.28.1.59v1.19L13.94 7.5h-1.88zm-7.4 7.4v1.88L6.44 15H5.25q-.3 0-.59-.1zM9 10.75C9 9.78 9.78 9 10.75 9h8c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-8c-.97 0-1.75-.78-1.75-1.75z"
]);
const $bd5c6ab3f2a8957d$export$88004de0969f975c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeUnion16Filled', "16", [
    "M4 2a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h1v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2z"
]);
const $bd5c6ab3f2a8957d$export$53c1cfd0c19136de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeUnion16Regular', "16", [
    "M4 2a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h1v1c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2zm1.14 1L3 5.14V4a1 1 0 0 1 1-1zM3 6.56 6.56 3h1.58L3 8.14zM9.45 3.1A1 1 0 0 1 10 4v.3L4.3 10H4a1 1 0 0 1-.9-.55zM10 5.7V6h1.3L6 11.3V10h-.3zm-3.84 6.84 6.39-6.39A1 1 0 0 1 13 7v.3L7.3 13H7a1 1 0 0 1-.84-.45M13 8.7v1.58L10.3 13H8.7zm0 3V12a1 1 0 0 1-1 1h-.3z"
]);
const $bd5c6ab3f2a8957d$export$b34dbb3a498a553f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeUnion20Filled', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13V4.5A2.5 2.5 0 0 0 10.5 2z"
]);
const $bd5c6ab3f2a8957d$export$181a8cfc5b5eaf19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeUnion20Regular', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.3 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6.22a2.5 2.5 0 0 0 2.27-2.28v-.01l.01-.21v-6A2.5 2.5 0 0 0 15.5 7H13V4.5a2.5 2.5 0 0 0-.5-1.5 2.5 2.5 0 0 0-2-1zm6.65 1.15-8 8A2 2 0 0 1 3 10.5v-.94L9.56 3h.94q.35 0 .65.15m-7.3 8.7 8-8q.15.3.15.65v.8L5.3 12h-.8a2 2 0 0 1-.65-.15M12 6.71v.79c0 .21.13.4.32.47l-4.35 4.35A.5.5 0 0 0 7.5 12h-.8zM13.7 8h1.6L8 15.3v-1.6zm2.7.3q.49.38.59 1L9.3 17a1.5 1.5 0 0 1-1-.59zm.6 2.4v1.6L12.3 17h-1.6zm0 3v1.6L15.3 17h-1.6zM3 8.15V6.56L6.56 3h1.58zm0-3V4.5C3 3.67 3.67 3 4.5 3h.64z"
]);
const $bd5c6ab3f2a8957d$export$3e64e5afaa23b33d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeUnion24Filled', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v8c0 1.8 1.46 3.25 3.25 3.25H7.5v2.25c0 1.8 1.46 3.25 3.25 3.25h8c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H16.5V5.25c0-1.8-1.46-3.25-3.25-3.25z"
]);
const $bd5c6ab3f2a8957d$export$5f3dac42efd74898 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShapeUnion24Regular', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v8a3.3 3.3 0 0 0 .56 1.82 3.3 3.3 0 0 0 2.4 1.42l.29.01H7.5v2.25A3.24 3.24 0 0 0 10.75 22h8c1.8 0 3.25-1.46 3.25-3.25v-8a3.25 3.25 0 0 0-3.25-3.25H16.5V5.25a3.3 3.3 0 0 0-1.54-2.77q-.64-.38-1.41-.47l-.3-.01zm.69 1.5L3.5 5.94v-.69c0-.97.78-1.75 1.75-1.75zM3.5 8.06 8.06 3.5h1.88L3.5 9.94zm8.56-4.56h1.19q.3 0 .59.1L3.6 13.84q-.1-.28-.1-.59v-1.19zm2.84 1.16q.1.28.1.59v1.19L6.44 15H5.25q-.3 0-.59-.1zm.1 3.9a.5.5 0 0 0 .5.44h.94L9 16.44v-.94a.5.5 0 0 0-.44-.5zm3.56.44h.19c.47 0 .9.18 1.2.48L9.49 19.96q-.46-.5-.48-1.21v-.19zm1.94 2.06v1.88l-7.56 7.56h-1.88zm0 4v1.88l-3.56 3.56h-1.88zm-.03 4.03a1.8 1.8 0 0 1-1.38 1.38z"
]);
const $bd5c6ab3f2a8957d$export$ac0dfc46594918f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes16Filled', "16", [
    "M1 5.5A4.5 4.5 0 0 1 9.97 5H8.5A3.5 3.5 0 0 0 5 8.5v1.47A4.5 4.5 0 0 1 1 5.5m7.5.5A2.5 2.5 0 0 0 6 8.5v4A2.5 2.5 0 0 0 8.5 15h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 6z"
]);
const $bd5c6ab3f2a8957d$export$fc67c8802f5d8297 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes16Regular', "16", [
    "M5.5 2A3.5 3.5 0 0 0 5 8.96v1.01A4.5 4.5 0 1 1 9.97 5h-1A3.5 3.5 0 0 0 5.5 2m3 4A2.5 2.5 0 0 0 6 8.5v4A2.5 2.5 0 0 0 8.5 15h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 6zM7 8.5C7 7.67 7.67 7 8.5 7h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 12.5z"
]);
const $bd5c6ab3f2a8957d$export$95fa5a28f20acf22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes20Filled', "20", [
    "M2 7.5A5.5 5.5 0 0 1 12.98 7H10.5A3.5 3.5 0 0 0 7 10.5v2.48A5.5 5.5 0 0 1 2 7.5m8.5.5A2.5 2.5 0 0 0 8 10.5v5a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 15.5 8z"
]);
const $bd5c6ab3f2a8957d$export$b25b994b1f87603f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes20Regular', "20", [
    "M7.5 3a4.5 4.5 0 0 0-.5 8.97v1A5.5 5.5 0 1 1 12.98 7h-1A4.5 4.5 0 0 0 7.5 3m3 5A2.5 2.5 0 0 0 8 10.5v5a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 15.5 8zM9 10.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 9 15.5z"
]);
const $bd5c6ab3f2a8957d$export$af92903542d2c6b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes24Filled', "24", [
    "M2 8.75A6.75 6.75 0 0 1 15.46 8h-3.21A4.25 4.25 0 0 0 8 12.25v3.2a6.75 6.75 0 0 1-6-6.7M12.25 9A3.25 3.25 0 0 0 9 12.25v6.5c0 1.8 1.46 3.25 3.25 3.25h6.5c1.8 0 3.25-1.46 3.25-3.25v-6.5C22 10.45 20.54 9 18.75 9z"
]);
const $bd5c6ab3f2a8957d$export$953977e188acf144 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes24Regular', "24", [
    "M8.75 3.5A5.25 5.25 0 0 0 8 13.95v1.5A6.75 6.75 0 1 1 15.46 8h-1.51a5.25 5.25 0 0 0-5.2-4.5m3.5 5.5A3.25 3.25 0 0 0 9 12.25v6.5c0 1.8 1.46 3.25 3.25 3.25h6.5c1.8 0 3.25-1.46 3.25-3.25v-6.5C22 10.45 20.54 9 18.75 9zm-1.75 3.25c0-.97.78-1.75 1.75-1.75h6.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75h-6.5c-.97 0-1.75-.78-1.75-1.75z"
]);
const $bd5c6ab3f2a8957d$export$2b8011f2e337ac40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes28Filled', "28", [
    "M10 2a8 8 0 0 1 8 8h-3.25A4.75 4.75 0 0 0 10 14.75V18a8 8 0 1 1 0-16m1 12.75A3.75 3.75 0 0 1 14.75 11h7.5A3.75 3.75 0 0 1 26 14.75v7.5A3.75 3.75 0 0 1 22.25 26h-7.5A3.75 3.75 0 0 1 11 22.25z"
]);
const $bd5c6ab3f2a8957d$export$2c637d907dbe4e6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes28Regular', "28", [
    "M10 16.5a6.5 6.5 0 1 1 6.5-6.5H18a8 8 0 1 0-8 8zm4.75-5.5A3.75 3.75 0 0 0 11 14.75v7.5A3.75 3.75 0 0 0 14.75 26h7.5A3.75 3.75 0 0 0 26 22.25v-7.5A3.75 3.75 0 0 0 22.25 11zm-2.25 3.75c0-1.24 1-2.25 2.25-2.25h7.5c1.24 0 2.25 1 2.25 2.25v7.5c0 1.24-1 2.25-2.25 2.25h-7.5c-1.24 0-2.25-1-2.25-2.25z"
]);
const $bd5c6ab3f2a8957d$export$c5d04135185b0260 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes32Filled', "32", [
    "M3 12a9 9 0 0 1 17.88-1.5H16.5a6 6 0 0 0-6 6v4.38A9 9 0 0 1 3 12m9 4.5a4.5 4.5 0 0 1 4.5-4.5h8a4.5 4.5 0 0 1 4.5 4.5v8a4.5 4.5 0 0 1-4.5 4.5h-8a4.5 4.5 0 0 1-4.5-4.5z"
]);
const $bd5c6ab3f2a8957d$export$ed20063c2550b970 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes32Regular', "32", [
    "M5 12a7 7 0 0 1 13.84-1.5h2.04A9 9 0 1 0 10.5 20.88v-2.04A7 7 0 0 1 5 12m11.5 0a4.5 4.5 0 0 0-4.5 4.5v8a4.5 4.5 0 0 0 4.5 4.5h8a4.5 4.5 0 0 0 4.5-4.5v-8a4.5 4.5 0 0 0-4.5-4.5zM14 16.5a2.5 2.5 0 0 1 2.5-2.5h8a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5z"
]);
const $bd5c6ab3f2a8957d$export$c45c5442138e738f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes48Filled', "48", [
    "M23.25 15.5h7.6A13.5 13.5 0 1 0 15.5 30.85v-7.6a7.75 7.75 0 0 1 7.75-7.75m0 2.5A5.25 5.25 0 0 0 18 23.25v15.5c0 2.9 2.35 5.25 5.25 5.25h15.5c2.9 0 5.25-2.35 5.25-5.25v-15.5c0-2.9-2.35-5.25-5.25-5.25z"
]);
const $bd5c6ab3f2a8957d$export$5323f39ffc3ff3bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shapes48Regular', "48", [
    "M17.5 6.5a11 11 0 0 0-2 21.82v2.53A13.5 13.5 0 1 1 30.85 15.5h-2.53a11 11 0 0 0-10.82-9M23.25 18A5.25 5.25 0 0 0 18 23.25v15.5c0 2.9 2.35 5.25 5.25 5.25h15.5c2.9 0 5.25-2.35 5.25-5.25v-15.5c0-2.9-2.35-5.25-5.25-5.25zm-2.75 5.25a2.75 2.75 0 0 1 2.75-2.75h15.5a2.75 2.75 0 0 1 2.75 2.75v15.5a2.75 2.75 0 0 1-2.75 2.75h-15.5a2.75 2.75 0 0 1-2.75-2.75z"
]);
const $bd5c6ab3f2a8957d$export$538d69a84ebbd4c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share16Filled', "16", [
    "M7.5 2a.5.5 0 0 1 0 1h-3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm3.28-.95a.5.5 0 0 1 .53.06l4.5 3.5a.5.5 0 0 1 0 .78l-4.5 3.5a.5.5 0 0 1-.81-.39V7.03c-2.23.23-3.62 1.97-4.4 3.4l-.15.3A.5.5 0 0 1 5 10.5a8.8 8.8 0 0 1 1.54-5.3 5.4 5.4 0 0 1 3.96-2.18V1.5q0-.31.28-.45"
]);
const $bd5c6ab3f2a8957d$export$cb289f91ba1e7fd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share16Regular', "16", [
    "M7.5 2a.5.5 0 0 1 0 1h-3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm3.28-.95a.5.5 0 0 1 .53.06l4.5 3.5a.5.5 0 0 1 0 .78l-4.5 3.5a.5.5 0 0 1-.81-.39V7.03c-2.23.23-3.62 1.97-4.4 3.4l-.15.3A.5.5 0 0 1 5 10.5a8.8 8.8 0 0 1 1.54-5.3 5.4 5.4 0 0 1 3.96-2.18V1.5q0-.31.28-.45m.72 2.45a.5.5 0 0 1-.5.5 4.4 4.4 0 0 0-3.66 1.8 7 7 0 0 0-1.15 2.68A6 6 0 0 1 11 6c.28 0 .5.22.5.5v.98L14.69 5 11.5 2.52z"
]);
const $bd5c6ab3f2a8957d$export$3e81a4e4837fc6ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share20Filled', "20", [
    "M9.5 3a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm3.8-.96a.5.5 0 0 1 .54.09l5 4.5a.5.5 0 0 1 0 .74l-5 4.5a.5.5 0 0 1-.84-.37V9.34c-1.4.13-2.67.78-3.7 1.6a10 10 0 0 0-2.2 2.5l-.15.28A.5.5 0 0 1 6 13.5c0-2.05.38-4.28 1.52-6.02A6.6 6.6 0 0 1 13 4.5V2.43a.5.5 0 0 1 .3-.39"
]);
const $bd5c6ab3f2a8957d$export$6f5ff9f6a0adf993 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share20Regular', "20", [
    "M9.5 3a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm3.8-.96a.5.5 0 0 1 .53.09l5 4.5a.5.5 0 0 1 0 .74l-5 4.5a.5.5 0 0 1-.83-.37V9.34c-1.4.13-2.67.78-3.7 1.6a10 10 0 0 0-2.2 2.5l-.15.28A.5.5 0 0 1 6 13.5c0-2.05.38-4.28 1.52-6.02A6.6 6.6 0 0 1 13 4.5V2.43a.5.5 0 0 1 .3-.39M14 5a.5.5 0 0 1-.5.5c-2.59 0-4.18 1.05-5.14 2.52a9 9 0 0 0-1.25 3.69 11 11 0 0 1 1.56-1.54 7.8 7.8 0 0 1 4.83-1.85c.28 0 .5.22.5.5v1.56L17.75 7 14 3.62z"
]);
const $bd5c6ab3f2a8957d$export$679ec50f9a6bd457 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share24Filled', "24", [
    "M10.25 3a.75.75 0 0 1 0 1.5h-3.5c-1.24 0-2.25 1-2.25 2.25v10.5l.01.23a2.25 2.25 0 0 0 2.24 2.02h10.5c1.24 0 2.25-1 2.25-2.25v-2a.75.75 0 0 1 1.5 0v2A3.75 3.75 0 0 1 17.25 21H6.75c-2 0-3.64-1.58-3.75-3.56V6.75A3.75 3.75 0 0 1 6.75 3zm4.69-.93a.8.8 0 0 1 .8.11l7 6a.75.75 0 0 1 .03 1.11l-7 6.75a.75.75 0 0 1-1.27-.54v-2.98a7 7 0 0 0-2.94.77 11.4 11.4 0 0 0-3.69 3.3l-.27.36a.75.75 0 0 1-1.35-.45c0-2.86.69-5.59 2.17-7.63a8 8 0 0 1 6.08-3.34V2.65q.07-.4.44-.58"
]);
const $bd5c6ab3f2a8957d$export$4d34fc04b098b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share24Regular', "24", [
    "M10.25 3a.75.75 0 0 1 0 1.5h-3.5c-1.24 0-2.25 1-2.25 2.25v10.5l.01.23a2.25 2.25 0 0 0 2.24 2.02h10.5c1.24 0 2.25-1 2.25-2.25v-2a.75.75 0 0 1 1.5 0v2A3.75 3.75 0 0 1 17.25 21H6.75c-2 0-3.64-1.58-3.75-3.56V6.75A3.75 3.75 0 0 1 6.75 3zm4.69-.93a.8.8 0 0 1 .8.11l7 6a.75.75 0 0 1 .03 1.11l-7 6.75a.75.75 0 0 1-1.27-.54v-2.98a7 7 0 0 0-2.94.77 11.4 11.4 0 0 0-3.69 3.3l-.27.36a.75.75 0 0 1-1.35-.45c0-2.86.69-5.59 2.17-7.63a8 8 0 0 1 6.08-3.34V2.65q.07-.4.44-.58M16 6.25c0 .41-.34.75-.75.75a6.6 6.6 0 0 0-5.62 2.75 10 10 0 0 0-1.72 4.5q1.5-1.56 2.97-2.3a9 9 0 0 1 4.37-.95.75.75 0 0 1 .75.75v1.98l5.13-4.95L16 4.38z"
]);
const $bd5c6ab3f2a8957d$export$37ac92559c0c61f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share28Filled', "28", [
    "M12.25 3a.75.75 0 0 1 0 1.5h-5A2.75 2.75 0 0 0 4.5 7.25v13.5a2.75 2.75 0 0 0 2.75 2.75h13.5a2.75 2.75 0 0 0 2.75-2.75v-5a.75.75 0 0 1 1.5 0v5C25 23.1 23.1 25 20.75 25H7.25A4.25 4.25 0 0 1 3 20.75V7.25C3 4.9 4.9 3 7.25 3zm5.18-.93a.8.8 0 0 1 .8.1l8.24 6.75a.75.75 0 0 1 .04 1.13l-8.25 7.75a.75.75 0 0 1-1.26-.55v-3.74a10 10 0 0 0-3.85.8c-1.59.7-3.35 2.02-5.16 4.58l-.37.53A.75.75 0 0 1 6.25 19c0-4.4 1.34-7.56 3.51-9.6A11.2 11.2 0 0 1 17 6.51V2.75c0-.29.17-.55.43-.68"
]);
const $bd5c6ab3f2a8957d$export$83f1bf453d2a1837 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share28Regular', "28", [
    "M12.25 3a.75.75 0 1 1 0 1.5h-5A2.75 2.75 0 0 0 4.5 7.25v13.5a2.75 2.75 0 0 0 2.75 2.75h13.5a2.75 2.75 0 0 0 2.75-2.75v-5a.75.75 0 0 1 1.5 0v5C25 23.1 23.1 25 20.75 25H7.25A4.25 4.25 0 0 1 3 20.75V7.25C3 4.9 4.9 3 7.25 3zm5.18-.93a.8.8 0 0 1 .8.1l8.24 6.75a.75.75 0 0 1 .04 1.13l-8.25 7.75a.75.75 0 0 1-1.26-.55v-3.74a10 10 0 0 0-3.85.8c-1.59.7-3.35 2.02-5.16 4.58l-.37.53A.75.75 0 0 1 6.25 19c0-4.4 1.34-7.56 3.51-9.6A11.2 11.2 0 0 1 17 6.51V2.75c0-.29.17-.55.43-.68m1.07 5.18c0 .41-.34.75-.75.75-2.66 0-5.15.77-6.96 2.48-1.41 1.34-2.47 3.3-2.87 6.05a13 13 0 0 1 4.62-3.6c2-.87 3.8-.93 5.21-.93a.75.75 0 0 1 .75.75v2.77l6.36-5.98-6.36-5.2z"
]);
const $bd5c6ab3f2a8957d$export$93991d6f95611e12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share32Filled', "32", [
    "M14 3a1 1 0 1 1 0 2H7.5A2.5 2.5 0 0 0 5 7.5v17A2.5 2.5 0 0 0 7.5 27h17a2.5 2.5 0 0 0 2.5-2.5V19a1 1 0 1 1 2 0v5.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zm5.58-.9a1 1 0 0 1 1.07.14l10 8.5a1 1 0 0 1 0 1.52l-10 8.5A1 1 0 0 1 19 20v-3.96c-3.2.26-5.64 1.72-7.34 3.21a16 16 0 0 0-2.76 3.2l-.03.04A1 1 0 0 1 7 22.05v-.67a20 20 0 0 1 1.39-6.75 12.4 12.4 0 0 1 3.85-5.23A12 12 0 0 1 19 7.03V3a1 1 0 0 1 .58-.9"
]);
const $bd5c6ab3f2a8957d$export$a4c0f4c19b16ac9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share32Light', "32", [
    "M14.5 3a.5.5 0 0 1 0 1h-7A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h16a3.5 3.5 0 0 0 3.5-3.5v-6a.5.5 0 0 1 1 0v6a4.5 4.5 0 0 1-4.5 4.5h-16A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zm4.8-.96a.5.5 0 0 1 .54.09l10 9a.5.5 0 0 1 0 .74l-10 9a.5.5 0 0 1-.84-.37v-5.49c-3.57.16-6.28 1.98-8.14 3.84a18 18 0 0 0-2.9 3.87h-.01a.5.5 0 0 1-.94-.12L7 22.35v-.47a20 20 0 0 1 1.35-6.57c.75-1.8 1.9-3.64 3.7-5.02A11.7 11.7 0 0 1 19 8.01V2.43a.5.5 0 0 1 .3-.39M20 8.5a.5.5 0 0 1-.5.5c-3.02 0-5.22.84-6.84 2.08a11 11 0 0 0-3.38 4.61 18 18 0 0 0-1.19 4.9c.5-.7 1.19-1.57 2.06-2.44C12.2 16.09 15.32 14 19.5 14a.5.5 0 0 1 .5.5v4.88l8.75-7.88L20 3.62z"
]);
const $bd5c6ab3f2a8957d$export$a0b0198c3636a26a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share32Regular', "32", [
    "M14 3a1 1 0 1 1 0 2H7.5A2.5 2.5 0 0 0 5 7.5v17A2.5 2.5 0 0 0 7.5 27h17a2.5 2.5 0 0 0 2.5-2.5V19a1 1 0 1 1 2 0v5.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3zm5.58-.9a1 1 0 0 1 1.07.14l10 8.5a1 1 0 0 1 0 1.52l-10 8.5A1 1 0 0 1 19 20v-3.96c-3.2.26-5.64 1.72-7.34 3.21a16 16 0 0 0-2.79 3.24A1 1 0 0 1 7 22.05v-.67a20 20 0 0 1 1.39-6.75 12.4 12.4 0 0 1 3.85-5.23A12 12 0 0 1 19 7.03V3a1 1 0 0 1 .58-.9M21 8a1 1 0 0 1-1 1c-2.93 0-5.02.81-6.54 1.98a10.4 10.4 0 0 0-3.22 4.4 17 17 0 0 0-.96 3.38q.48-.5 1.06-1.01A14.5 14.5 0 0 1 20 14a1 1 0 0 1 1 1v2.84l7.46-6.34L21 5.16z"
]);
const $bd5c6ab3f2a8957d$export$bb79cc867a2c52dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share48Filled', "48", [
    "M20.75 6a1.25 1.25 0 0 1 0 2.5h-7.5a4.75 4.75 0 0 0-4.75 4.75v21.5a4.75 4.75 0 0 0 4.75 4.75h21.5a4.75 4.75 0 0 0 4.75-4.75v-6.5a1.25 1.25 0 0 1 2.5 0v6.5c0 4-3.25 7.25-7.25 7.25h-21.5C9.25 42 6 38.75 6 34.75v-21.5C6 9.25 9.25 6 13.25 6zm8.97-3.88c.44-.2.96-.14 1.33.17l14.5 12.25a1.25 1.25 0 0 1 .04 1.88L31.1 29.67a1.25 1.25 0 0 1-2.1-.92v-5.72c-2.05.1-4.01.47-6.03 1.47-2.28 1.12-4.72 3.09-7.42 6.54l-.54.71a1.25 1.25 0 0 1-2.22-.48l-.03-.19c-.26-3.99.79-9.44 3.53-13.92C18.86 12.92 23 9.46 29 9.04V3.25c0-.49.28-.93.72-1.13"
]);
const $bd5c6ab3f2a8957d$export$8bc2c33eaacf10e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Share48Regular', "48", [
    "M20.75 6a1.25 1.25 0 1 1 0 2.5h-7.5a4.75 4.75 0 0 0-4.75 4.75v21.5a4.75 4.75 0 0 0 4.75 4.75h21.5a4.75 4.75 0 0 0 4.75-4.75v-6.5a1.25 1.25 0 0 1 2.5 0v6.5c0 4-3.25 7.25-7.25 7.25h-21.5C9.25 42 6 38.75 6 34.75v-21.5C6 9.25 9.25 6 13.25 6zm8.97-3.88c.44-.2.96-.14 1.34.17l14.5 12.25a1.25 1.25 0 0 1 .03 1.88L31.1 29.67a1.25 1.25 0 0 1-2.09-.92v-5.72c-2.05.1-4.02.47-6.04 1.47-2.28 1.12-4.71 3.09-7.42 6.54l-.54.71a1.25 1.25 0 0 1-2.25-.67c-.26-3.99.8-9.44 3.53-13.92 2.58-4.24 6.74-7.7 12.72-8.12V3.25c0-.49.28-.93.72-1.13m1.78 8.13a1.25 1.25 0 0 1-1.25 1.25c-5.59 0-9.41 3-11.84 6.96a23 23 0 0 0-3.04 8.9 22 22 0 0 1 6.48-5.1 18 18 0 0 1 8.4-1.76 1.25 1.25 0 0 1 1.25 1.25v4.16l11.36-10.37-11.36-9.6z"
]);
const $bd5c6ab3f2a8957d$export$6612295f8c62ddbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_16_color__a)",
            "d": "m10.78 4.05.44.9L5.12 8l6.1 3.05-.44.9L2.88 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_16_color__b)",
            "d": "m10.78 4.05.44.9L5.12 8l6.1 3.05-.44.9L2.88 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_16_color__c)",
            "d": "m10.78 4.05.44.9L5.12 8l6.1 3.05-.44.9L2.88 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_16_color__d)",
            "d": "m10.78 4.05.44.9L5.12 8l6.1 3.05-.44.9L2.88 8z"
        }
    ],
    [
        "circle",
        {
            "cx": "12",
            "cy": "12",
            "r": "2",
            "fill": "url(#ic_fluent_share_android_16_color__e)"
        }
    ],
    [
        "circle",
        {
            "cx": "4",
            "cy": "8",
            "r": "2",
            "fill": "url(#ic_fluent_share_android_16_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "12",
            "cy": "4",
            "r": "2",
            "fill": "url(#ic_fluent_share_android_16_color__g)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-2.5 -1.50001 1.607 -2.67831 12 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2.5 0 0 2.86722 4 8)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-2.5 1.50001 -1.67631 -2.79382 12 4)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -1.7 10.27)scale(10.8171 9.26431)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -1.73 .36)scale(10.8171 9.26431)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_16_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 6.22 6.27)scale(10.8171 9.26431)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_share_android_16_color__a",
                "x1": "2.88",
                "x2": "5.59",
                "y1": "4.05",
                "y2": "12.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$cf66abf744842c60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid16Filled', "16", [
    "M10 4a2 2 0 1 1 .5 1.31L5.95 7.58a2 2 0 0 1 0 .84l4.53 2.27A2 2 0 0 1 14 12a2 2 0 1 1-3.96-.42L5.51 9.31A2 2 0 0 1 2 8a2 2 0 0 1 3.5-1.31l4.54-2.27A2 2 0 0 1 10 4"
]);
const $bd5c6ab3f2a8957d$export$52f3ac017e97f4ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid16Regular', "16", [
    "M12 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 .5 1.31L5.95 7.58a2 2 0 0 1 0 .84l4.53 2.27a2 2 0 1 1-.45.9L5.51 9.3A2 2 0 0 1 2 8a2 2 0 0 1 3.5-1.31l4.54-2.27A2 2 0 0 1 10 4M3 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0m8 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $bd5c6ab3f2a8957d$export$d68ee7bae6184a99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_20_color__a)",
            "fillRule": "evenodd",
            "d": "m13.16 5.33.68 1.34L7.18 10l7.66 3.83-.68 1.34L3.82 10z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_20_color__b)",
            "fillRule": "evenodd",
            "d": "m13.16 5.33.68 1.34L7.18 10l7.66 3.83-.68 1.34L3.82 10z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_20_color__c)",
            "fillRule": "evenodd",
            "d": "m13.16 5.33.68 1.34L7.18 10l7.66 3.83-.68 1.34L3.82 10z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_20_color__d)",
            "fillRule": "evenodd",
            "d": "m13.16 5.33.68 1.34L7.18 10l7.66 3.83-.68 1.34L3.82 10z",
            "clipRule": "evenodd"
        }
    ],
    [
        "circle",
        {
            "cx": "14.5",
            "cy": "14.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_share_android_20_color__e)"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_20_color__f)",
            "d": "M8 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "circle",
        {
            "cx": "14.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_share_android_20_color__g)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-65 17.63 -3.11)scale(3.08155 3.42846)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.72703 0 0 4.03643 5.55 9.99)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(146.74 6.24 4.74)scale(3.82039 4.17888)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -1.87 12.1)scale(13.5213 11.5804)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -1.92 .94)scale(13.5213 11.5804)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 7.04 7.6)scale(13.5213 11.5804)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_share_android_20_color__a",
                "x1": "3.82",
                "x2": "7.05",
                "y1": "5.33",
                "y2": "15.64",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$87a76ee977530f36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid20Filled', "20", [
    "M17 5.5a2.5 2.5 0 0 1-4.47 1.54L7.92 9.35a2.5 2.5 0 0 1 0 1.3l4.61 2.3a2.5 2.5 0 1 1-.45.9l-4.61-2.3a2.5 2.5 0 1 1 0-3.1l4.61-2.3A2.5 2.5 0 1 1 17 5.5"
]);
const $bd5c6ab3f2a8957d$export$98c00fd489d382e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid20Regular', "20", [
    "M12 5.5a2.5 2.5 0 1 1 .53 1.54L7.92 9.35a2.5 2.5 0 0 1 0 1.3l4.61 2.3a2.5 2.5 0 1 1-.45.9l-4.61-2.3a2.5 2.5 0 1 1 0-3.1l4.61-2.3A3 3 0 0 1 12 5.5M14.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M4 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $bd5c6ab3f2a8957d$export$ab8f1a320f3605d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__a)",
            "d": "m16.63 5.35.74 1.3L8.01 12l9.36 5.35-.74 1.3L4.99 12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__b)",
            "d": "m16.63 5.35.74 1.3L8.01 12l9.36 5.35-.74 1.3L4.99 12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__c)",
            "d": "m16.63 5.35.74 1.3L8.01 12l9.36 5.35-.74 1.3L4.99 12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__d)",
            "d": "m16.63 5.35.74 1.3L8.01 12l9.36 5.35-.74 1.3L4.99 12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__e)",
            "d": "M20.5 18a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__f)",
            "d": "M10 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_24_color__g)",
            "d": "M20.5 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(212 11.08 6.56)scale(4.71699 4.62011)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.5 0 0 5.85787 6.5 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(152.74 7.77 5.06)scale(4.5976 5.33157)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -2 12.52)scale(18.9298 16.2125)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -1.3 -.87)scale(18.9298 16.2125)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_24_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 9.88 6.52)scale(18.9298 16.2125)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_share_android_24_color__a",
                "x1": "4.99",
                "x2": "10.03",
                "y1": "5.35",
                "y2": "18.76",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$70fefd9a84a8d89e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid24Filled', "24", [
    "M17 3a3 3 0 1 1-2.15 5.1L9.4 11.2a3 3 0 0 1 0 1.58l5.45 3.12A2.99 2.99 0 0 1 20 18a3 3 0 1 1-5.9-.79L8.66 14.1A2.99 2.99 0 0 1 3.5 12a3 3 0 0 1 5.15-2.1L14.1 6.8A3 3 0 0 1 17 3"
]);
const $bd5c6ab3f2a8957d$export$b43a4953c54e5708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid24Regular', "24", [
    "M17 2.5a3.5 3.5 0 1 1-2.6 5.85l-4.56 2.6a3.5 3.5 0 0 1 0 2.1l4.56 2.6A3.5 3.5 0 0 1 20.5 18a3.5 3.5 0 1 1-6.84-1.05l-4.56-2.6A3.5 3.5 0 0 1 3 12a3.5 3.5 0 0 1 6.1-2.35l4.56-2.6A3.5 3.5 0 0 1 17 2.5M17 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4M6.5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4M17 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $bd5c6ab3f2a8957d$export$50819d38dd6dee3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__a)",
            "d": "m21.05 8.1.9 1.8L9.74 16l14.2 7.1-.89 1.8L5.26 16z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__b)",
            "d": "m21.05 8.1.9 1.8L9.74 16l14.2 7.1-.89 1.8L5.26 16z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__c)",
            "d": "m21.05 8.1.9 1.8L9.74 16l14.2 7.1-.89 1.8L5.26 16z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__d)",
            "d": "m21.05 8.1.9 1.8L9.74 16l14.2 7.1-.89 1.8L5.26 16z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__e)",
            "d": "M29 24.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__f)",
            "d": "M12 16a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_android_32_color__g)",
            "d": "M29 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(210.26 15.56 8.94)scale(6.94622 7.70089)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 0 0 6.53387 7.5 16)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(151.39 11.3 6.87)scale(6.26498 6.8678)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -2.58 19.4)scale(24.3384 20.8447)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 -2.67 -1.68)scale(24.3384 20.8447)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_android_32_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.62 14.24 10.9)scale(24.3384 20.8447)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_share_android_32_color__a",
                "x1": "5.26",
                "x2": "10.79",
                "y1": "8.11",
                "y2": "25.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$970a3fe773ac9add = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid32Filled', "32", [
    "M20 7.5q0 .56.13 1.07l-9.15 4.57a4.5 4.5 0 1 0 0 5.72l9.15 4.57A4.5 4.5 0 0 0 24.5 29a4.5 4.5 0 1 0-3.48-7.36l-9.15-4.57a4.5 4.5 0 0 0 0-2.14l9.15-4.57A4.5 4.5 0 1 0 20 7.5"
]);
const $bd5c6ab3f2a8957d$export$6ab9d4eeb89c153d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareAndroid32Regular', "32", [
    "M22 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M24.5 3a4.5 4.5 0 0 0-4.37 5.57l-9.15 4.57a4.5 4.5 0 1 0 0 5.72l9.15 4.57A4.5 4.5 0 0 0 24.5 29a4.5 4.5 0 1 0-3.48-7.36l-9.15-4.57a4.5 4.5 0 0 0 0-2.14l9.15-4.57A4.5 4.5 0 1 0 24.5 3M5 16a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m19.5 6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $bd5c6ab3f2a8957d$export$7c9cf21a4916d9fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareCloseTray20Filled', "20", [
    "M4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm6-10a.5.5 0 0 0-.5.5v5.8l-1.65-1.65a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7l-1.65 1.64V6.5A.5.5 0 0 0 10 6"
]);
const $bd5c6ab3f2a8957d$export$1733163d7351363d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareCloseTray20Regular', "20", [
    "M10 6a.5.5 0 0 0-.5.5v5.8l-1.65-1.65a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7l-1.65 1.64V6.5A.5.5 0 0 0 10 6m-8 8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm2 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $bd5c6ab3f2a8957d$export$bbf9224071a09308 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareCloseTray24Filled', "24", [
    "M4.25 20C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4h15.5C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25zm8.28-3.47 3.25-3.25a.75.75 0 1 0-1.06-1.06l-1.97 1.97V7.75a.75.75 0 0 0-1.5 0v6.44l-1.97-1.97a.75.75 0 1 0-1.06 1.06l3.25 3.25a.75.75 0 0 0 1.06 0"
]);
const $bd5c6ab3f2a8957d$export$3025dd3d8959a498 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareCloseTray24Regular', "24", [
    "M2 17.75C2 18.99 3 20 4.25 20h15.5c1.24 0 2.25-1 2.25-2.25V6.25C22 5.01 21 4 19.75 4H4.25C3.01 4 2 5 2 6.25zm2.25.75a.75.75 0 0 1-.75-.75V6.25c0-.41.34-.75.75-.75h15.5c.41 0 .75.34.75.75v11.5c0 .41-.34.75-.75.75zM12 16.75q.31 0 .53-.22l3.25-3.25a.75.75 0 1 0-1.06-1.06l-1.97 1.97V7.75a.75.75 0 0 0-1.5 0v6.44l-1.97-1.97a.75.75 0 1 0-1.06 1.06l3.25 3.25q.22.22.53.22"
]);
const $bd5c6ab3f2a8957d$export$29adb41f61fbba77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_ios_20_color__a)",
            "d": "M10.29 2.06a.8.8 0 0 0-.82.16L5.22 6.47a.75.75 0 0 0 1.06 1.06l2.97-2.97v7.69a.75.75 0 0 0 1.5 0V4.56l2.97 2.97a.75.75 0 1 0 1.06-1.06l-4.25-4.25a1 1 0 0 0-.24-.16M3.75 9c.41 0 .75.34.75.75v4c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-4c0-.41.34-.75.75-.75"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_ios_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(52.1 2.88 .33)scale(25.4447 21.3416)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".28",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$383e111593be985e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos20Filled', "20", [
    "M10.29 2.06a.8.8 0 0 0-.82.16L5.22 6.47a.75.75 0 0 0 1.06 1.06l2.97-2.97v7.69a.75.75 0 0 0 1.5 0V4.56l2.97 2.97a.75.75 0 1 0 1.06-1.06l-4.25-4.25a1 1 0 0 0-.24-.16M3.75 9c.41 0 .75.34.75.75v4c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-4c0-.41.34-.75.75-.75"
]);
const $bd5c6ab3f2a8957d$export$c026e4fa0cbab74b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos20Regular', "20", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 1 0 .7.7L9.5 3.71v8.79a.5.5 0 0 0 1 0V3.7l3.65 3.65a.5.5 0 0 0 .7-.7zM4 9.5a.5.5 0 0 0-1 0V14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);
const $bd5c6ab3f2a8957d$export$6f5f5c498fccab9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_ios_24_color__a)",
            "d": "M12.7 2.3a1 1 0 0 0-1.4 0L6.03 7.53a1 1 0 0 0 1.42 1.42L11 5.4V15a1 1 0 1 0 2 0V5.41l3.54 3.55a1 1 0 1 0 1.42-1.42zM4 11a1 1 0 0 1 1 1v5.5c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V12a1 1 0 1 1 2 0v5.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 17.5V12a1 1 0 0 1 1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_ios_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(51.69 3.8 -.69)scale(32.4136 27.2837)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".28",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$35fb4f57e9be0982 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos24Filled', "24", [
    "M12.7 2.3a1 1 0 0 0-1.4 0L6.03 7.53a1 1 0 0 0 1.42 1.42L11 5.4V15a1 1 0 1 0 2 0V5.41l3.54 3.55a1 1 0 1 0 1.42-1.42zM4 11a1 1 0 0 1 1 1v5.5c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V12a1 1 0 1 1 2 0v5.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 17.5V12a1 1 0 0 1 1-1"
]);
const $bd5c6ab3f2a8957d$export$f59fc597f4331160 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos24Regular', "24", [
    "M12.53 2.22a.75.75 0 0 0-1.06 0L6.22 7.47a.75.75 0 0 0 1.06 1.06l3.97-3.97v10.69a.75.75 0 0 0 1.5 0V4.56l3.97 3.97a.75.75 0 1 0 1.06-1.06zM3.75 11c.41 0 .75.34.75.75v6c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-6a.75.75 0 0 1 1.5 0v6c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75v-6c0-.41.34-.75.75-.75"
]);
const $bd5c6ab3f2a8957d$export$47a27f505a515005 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_ios_28_color__a)",
            "d": "M14.7 2.3a1 1 0 0 0-1.4 0L6.53 9.03a1 1 0 0 0 1.42 1.42L13 5.4V18a1 1 0 1 0 2 0V5.41l5.04 5.05a1 1 0 0 0 1.42-1.42zM4 13a1 1 0 0 1 1 1v7c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-7a1 1 0 1 1 2 0v7a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-7a1 1 0 0 1 1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_ios_28_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(51.42 4.74 -1.72)scale(39.3836 33.223)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".28",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$619c8344285b464f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos28Filled', "28", [
    "M14.7 2.3a1 1 0 0 0-1.4 0L6.53 9.03a1 1 0 0 0 1.42 1.42L13 5.4V18a1 1 0 1 0 2 0V5.41l5.04 5.05a1 1 0 0 0 1.42-1.42zM4 13a1 1 0 0 1 1 1v7c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-7a1 1 0 1 1 2 0v7a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-7a1 1 0 0 1 1-1"
]);
const $bd5c6ab3f2a8957d$export$66f0c4071da89227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos28Regular', "28", [
    "M14 2a.8.8 0 0 1 .53.22l6.75 6.75a.75.75 0 1 1-1.06 1.06l-5.47-5.47v13.69a.75.75 0 0 1-1.5 0V4.56l-5.47 5.47a.75.75 0 1 1-1.06-1.06l6.75-6.75A.8.8 0 0 1 14 2M4.5 13.75a.75.75 0 0 0-1.5 0v7.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25v-7.5a.75.75 0 0 0-1.5 0v7.5c0 1.24-1 2.25-2.25 2.25H6.75c-1.24 0-2.25-1-2.25-2.25z"
]);
const $bd5c6ab3f2a8957d$export$f4089bca392d6dfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_ios_32_color__a)",
            "d": "M16.88 2.37a1.25 1.25 0 0 0-1.76 0l-7.75 7.75a1.25 1.25 0 0 0 1.76 1.76l5.62-5.61v14.48a1.25 1.25 0 1 0 2.5 0V6.27l5.62 5.61a1.25 1.25 0 0 0 1.76-1.76zM5.5 16.25a1.25 1.25 0 1 0-2.5 0v8.25A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-8.25a1.25 1.25 0 1 0-2.5 0v8.25a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_ios_32_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(51.23 5.68 -2.75)scale(46.3543 39.1607)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".28",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$32940dd584c85ede = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos32Filled', "32", [
    "M16.88 2.37a1.25 1.25 0 0 0-1.76 0l-7.75 7.75a1.25 1.25 0 0 0 1.76 1.76l5.62-5.61v14.48a1.25 1.25 0 1 0 2.5 0V6.27l5.62 5.61a1.25 1.25 0 0 0 1.76-1.76zM5.5 16.25a1.25 1.25 0 1 0-2.5 0v8.25A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5v-8.25a1.25 1.25 0 1 0-2.5 0v8.25a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2z"
]);
const $bd5c6ab3f2a8957d$export$b8f10f07c7e783f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos32Regular', "32", [
    "M16.7 2.3a1 1 0 0 0-1.4 0l-8 8a1 1 0 1 0 1.4 1.4L15 5.42V21a1 1 0 1 0 2 0V5.41l6.3 6.3a1 1 0 0 0 1.4-1.42zM5 16a1 1 0 1 0-2 0v8.5A4.5 4.5 0 0 0 7.5 29h17a4.5 4.5 0 0 0 4.5-4.5V16a1 1 0 1 0-2 0v8.5a2.5 2.5 0 0 1-2.5 2.5h-17A2.5 2.5 0 0 1 5 24.5z"
]);
const $bd5c6ab3f2a8957d$export$a25179ec1094734c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_share_ios_48_color__a)",
            "d": "M25.06 4.44a1.5 1.5 0 0 0-2.12 0l-11.5 11.5a1.5 1.5 0 0 0 2.12 2.12l8.94-8.94V30.5a1.5 1.5 0 0 0 3 0V9.12l8.94 8.94a1.5 1.5 0 0 0 2.12-2.12zM7.5 22c.83 0 1.5.67 1.5 1.5v12a3.5 3.5 0 0 0 3.5 3.5h23a3.5 3.5 0 0 0 3.5-3.5v-12a1.5 1.5 0 0 1 3 0v12a6.5 6.5 0 0 1-6.5 6.5h-23A6.5 6.5 0 0 1 6 35.5v-12c0-.83.67-1.5 1.5-1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_share_ios_48_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(51.69 7.6 -1.38)scale(64.8272 54.5673)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".28",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$f717165999d0c5ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos48Filled', "48", [
    "M25.06 4.44a1.5 1.5 0 0 0-2.12 0l-11.5 11.5a1.5 1.5 0 0 0 2.12 2.12l8.94-8.94V30.5a1.5 1.5 0 0 0 3 0V9.12l8.94 8.94a1.5 1.5 0 0 0 2.12-2.12zM7.5 22c.83 0 1.5.67 1.5 1.5v12a3.5 3.5 0 0 0 3.5 3.5h23a3.5 3.5 0 0 0 3.5-3.5v-12a1.5 1.5 0 0 1 3 0v12a6.5 6.5 0 0 1-6.5 6.5h-23A6.5 6.5 0 0 1 6 35.5v-12c0-.83.67-1.5 1.5-1.5"
]);
const $bd5c6ab3f2a8957d$export$ba198d658bc023a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareIos48Regular', "48", [
    "M23.12 4.37a1.25 1.25 0 0 1 1.76 0l11.5 11.5a1.25 1.25 0 0 1-1.76 1.76l-9.37-9.36v22.48a1.25 1.25 0 1 1-2.5 0V8.27l-9.37 9.36a1.25 1.25 0 0 1-1.76-1.76zM7.25 22c.69 0 1.25.56 1.25 1.25v12.5a3.75 3.75 0 0 0 3.75 3.75h23.5a3.75 3.75 0 0 0 3.75-3.75v-12.5a1.25 1.25 0 1 1 2.5 0v12.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-12.5c0-.69.56-1.25 1.25-1.25"
]);
const $bd5c6ab3f2a8957d$export$1f2a955f1cbba726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareMultiple16Filled', "16", [
    "M10.8 9.46q.1.04.2.04.2 0 .34-.13l3.5-3.25q.16-.15.16-.37a.5.5 0 0 0-.16-.37l-3.5-3.25a.5.5 0 0 0-.54-.09.5.5 0 0 0-.3.46v1.52C6.05 4.34 6 8.95 6 9a.5.5 0 0 0 .88.32c.1-.11 1.44-1.6 3.62-1.8V9c0 .2.12.38.3.46M8 3.5a.5.5 0 0 0-.5-.5h-1A2.5 2.5 0 0 0 4 5.5v4A2.5 2.5 0 0 0 6.5 12h4a2.5 2.5 0 0 0 2.45-2c.06-.27-.17-.5-.45-.5s-.5.23-.58.5c-.2.58-.76 1-1.42 1h-4A1.5 1.5 0 0 1 5 9.5v-4C5 4.67 5.67 4 6.5 4h1a.5.5 0 0 0 .5-.5m-5 2c-.6.46-1 1.18-1 2v2A4.5 4.5 0 0 0 6.5 14h2c.82 0 1.54-.4 2-1h-4A3.5 3.5 0 0 1 3 9.5z"
]);
const $bd5c6ab3f2a8957d$export$50b94ab8f621d3f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareMultiple16Regular', "16", [
    "M10.8 9.46q.1.04.2.04.2 0 .34-.13l3.5-3.25q.16-.15.16-.37a.5.5 0 0 0-.16-.37l-3.5-3.25a.5.5 0 0 0-.54-.09.5.5 0 0 0-.3.46v1.52C6.05 4.34 6 8.95 6 9a.5.5 0 0 0 .88.32c.1-.11 1.44-1.6 3.62-1.8V9c0 .2.12.38.3.46M11.5 7a.5.5 0 0 0-.5-.5c-1.67 0-2.95.64-3.79 1.22C7.56 6.55 8.5 5 11 5a.5.5 0 0 0 .5-.5v-.85l2.27 2.1-2.27 2.1zM8 3.5a.5.5 0 0 0-.5-.5h-1A2.5 2.5 0 0 0 4 5.5v4A2.5 2.5 0 0 0 6.5 12h4a2.5 2.5 0 0 0 2.45-2c.06-.27-.17-.5-.45-.5s-.5.23-.58.5c-.2.58-.76 1-1.42 1h-4A1.5 1.5 0 0 1 5 9.5v-4C5 4.67 5.67 4 6.5 4h1a.5.5 0 0 0 .5-.5m-5 2c-.6.46-1 1.18-1 2v2A4.5 4.5 0 0 0 6.5 14h2c.82 0 1.54-.4 2-1h-4A3.5 3.5 0 0 1 3 9.5z"
]);
const $bd5c6ab3f2a8957d$export$92c842418afb9551 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareMultiple20Filled', "20", [
    "M13.31 11.96a.4.4 0 0 0 .19.04q.2 0 .35-.14l4-3.91a.5.5 0 0 0 .01-.71l-4-4.09a.5.5 0 0 0-.55-.11.5.5 0 0 0-.31.46v1.76c-5.93.32-6 6.18-6 6.24 0 .19.11.37.28.45s.38.06.53-.06l.01-.01c.2-.15 2.52-1.9 5.18-2.11v1.73c0 .2.12.38.31.46M10 4.5a.5.5 0 0 0-.5-.5H8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 2.96-2.5c.04-.27-.18-.5-.46-.5s-.5.23-.56.5A2 2 0 0 1 13 14H8a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1.5a.5.5 0 0 0 .5-.5M4 7v-.24A3 3 0 0 0 3 9v3a5 5 0 0 0 5 5h3a3 3 0 0 0 2.24-1H8a4 4 0 0 1-4-4z"
]);
const $bd5c6ab3f2a8957d$export$4eb0d76be538f805 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareMultiple20Regular', "20", [
    "M13.31 11.96a.4.4 0 0 0 .19.04q.2 0 .35-.14l4-3.91a.5.5 0 0 0 .01-.71l-4-4.09a.5.5 0 0 0-.55-.11.5.5 0 0 0-.31.46v1.76c-5.93.32-6 6.18-6 6.24 0 .19.11.37.28.45s.38.06.53-.06l.01-.01c.2-.15 2.52-1.9 5.18-2.11v1.73c0 .2.12.38.31.46M14 5.75V4.72l2.79 2.86L14 10.31V9.25a.5.5 0 0 0-.5-.5c-2.23 0-4.25 1.02-5.38 1.72.31-1.54 1.43-4.22 5.38-4.22a.5.5 0 0 0 .5-.5M10 4.5a.5.5 0 0 0-.5-.5H8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 2.96-2.5c.04-.27-.18-.5-.46-.5s-.5.23-.56.5A2 2 0 0 1 13 14H8a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1.5a.5.5 0 0 0 .5-.5M4 7v-.24A3 3 0 0 0 3 9v3a5 5 0 0 0 5 5h3a3 3 0 0 0 2.24-1H8a4 4 0 0 1-4-4z"
]);
const $bd5c6ab3f2a8957d$export$b3f761b2b5dda36e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareMultiple24Filled', "24", [
    "M8.97 13.95q.14.05.28.05.32 0 .54-.23c.07-.07 2.37-2.41 5.7-2.73v2.21a.74.74 0 0 0 1.26.54l5-4.75a.7.7 0 0 0 .23-.54q0-.31-.23-.54l-5-4.75a.74.74 0 0 0-1.26.54v2.28a7.3 7.3 0 0 0-4.87 2.03 8 8 0 0 0-2.12 5.19c0 .31.19.58.47.7M12 4.75a.75.75 0 0 0-.75-.75h-2.5A3.25 3.25 0 0 0 5.5 7.25v8c0 1.8 1.46 3.25 3.25 3.25h8c1.8 0 3.25-1.46 3.25-3.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .97-.78 1.75-1.75 1.75h-8C7.78 17 7 16.22 7 15.25v-8c0-.97.78-1.75 1.75-1.75h2.5c.41 0 .75-.34.75-.75m-7.5 2.5v-.24C3.6 7.58 3 8.6 3 9.75v5.5A5.75 5.75 0 0 0 8.75 21h5.5c1.15 0 2.17-.6 2.74-1.5H8.75a4.25 4.25 0 0 1-4.25-4.25z"
]);
const $bd5c6ab3f2a8957d$export$a87e33f1ea532d44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareMultiple24Regular', "24", [
    "M8.97 13.95q.14.05.28.05.32 0 .54-.23c.07-.07 2.37-2.41 5.7-2.73v2.21a.74.74 0 0 0 1.26.54l5-4.75a.7.7 0 0 0 .23-.54q0-.31-.23-.54l-5-4.75a.74.74 0 0 0-1.26.54v2.28a7.3 7.3 0 0 0-4.87 2.03 8 8 0 0 0-2.12 5.19c0 .31.19.58.47.7m8.03-3.7a.76.76 0 0 0-.75-.75c-2.52 0-4.59 1.02-5.92 1.92.54-1.69 2-3.92 5.92-3.92.41 0 .75-.34.75-.75V5.5l3.16 3-3.16 3zm-5-5.5a.75.75 0 0 0-.75-.75h-2.5A3.25 3.25 0 0 0 5.5 7.25v8c0 1.8 1.46 3.25 3.25 3.25h8c1.8 0 3.25-1.46 3.25-3.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .97-.78 1.75-1.75 1.75h-8C7.78 17 7 16.22 7 15.25v-8c0-.97.78-1.75 1.75-1.75h2.5c.41 0 .75-.34.75-.75m-7.5 2.5v-.24C3.6 7.58 3 8.6 3 9.75v5.5A5.75 5.75 0 0 0 8.75 21h5.5c1.15 0 2.17-.6 2.74-1.5H8.75a4.25 4.25 0 0 1-4.25-4.25z"
]);
const $bd5c6ab3f2a8957d$export$99730832947fcdea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson16Filled', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h3.54L7 12.5c0-1.3 1-2.38 2.27-2.49a3 3 0 1 1 5.22-2.26c.01.14.12.25.26.25s.25-.11.25-.25V5.5A2.5 2.5 0 0 0 12.5 3zm10 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$c54426ca4e0a2f9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson16Regular', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h3.54a3 3 0 0 1 .01-1H3.5A1.5 1.5 0 0 1 2 10.5v-5C2 4.67 2.67 4 3.5 4h9c.83 0 1.5.67 1.5 1.5v.84q.42.63.49 1.41c.01.14.12.25.26.25s.25-.11.25-.25V5.5A2.5 2.5 0 0 0 12.5 3zm10 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$27bb2c00b83b2cab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson20Filled', "20", [
    "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6.05a2.5 2.5 0 0 1 2.22-1.99A2.99 2.99 0 0 1 15.5 9a3 3 0 0 1 2.5 1.34V7a3 3 0 0 0-3-3zm12.5 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$38fff5a1120902e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson20Regular', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h6.3q.11-.55.45-1H4.75C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V9.4q.6.36 1 .94V6.75A2.75 2.75 0 0 0 15.25 4zm12.75 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$4989eba5c6a68aa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20H13v-.22A2.77 2.77 0 0 1 15.77 17h.28a3.49 3.49 0 0 1 2.45-6 3.5 3.5 0 0 1 3.5 3.5V7.25C22 5.45 20.54 4 18.75 4zM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $bd5c6ab3f2a8957d$export$4d01639cd887aa7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20H13v-.22q0-.7.3-1.28H5.26c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v4.38A3.5 3.5 0 0 1 22 14.5V7.25C22 5.45 20.54 4 18.75 4zM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $bd5c6ab3f2a8957d$export$77b0f4f865f0fd34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h9.32q-.07-.37-.07-.75v-.2A3.04 3.04 0 0 1 18.05 20h.8a3.99 3.99 0 0 1 2.65-7 4 4 0 0 1 4 3.75q.02.23.25.25.23-.02.25-.25v-9A3.75 3.75 0 0 0 22.25 4zM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $bd5c6ab3f2a8957d$export$14d8a63407e98cd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPerson28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h9.32q-.07-.37-.07-.75v-.2q0-.29.05-.55h-9.3c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1-2.25 2.25-2.25h16.5c1.24 0 2.25 1 2.25 2.25v6.6c.57.65.94 1.48 1 2.4q.02.23.25.25.23-.02.25-.25v-9A3.75 3.75 0 0 0 22.25 4zM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $bd5c6ab3f2a8957d$export$8aedb77eb0fffbb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay16Filled', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v2.25c0 .14-.11.25-.25.25a.3.3 0 0 1-.26-.25 3 3 0 1 0-5.22 2.26A2.5 2.5 0 0 0 7.04 13H3.5A2.5 2.5 0 0 1 1 10.5zM3 6v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1m10.5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$cd66e74f29cf10de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v2.25c0 .14-.11.25-.25.25a.3.3 0 0 1-.26-.25q-.07-.79-.49-1.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h3.55a3 3 0 0 0-.01 1H3.5A2.5 2.5 0 0 1 1 10.5zM11.5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5M4 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$3db438a4934cade6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay20Filled', "20", [
    "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.34a3 3 0 1 0-4.73 3.67c-1.1.1-2 .92-2.22 1.99H5a3 3 0 0 1-3-3zm2 0v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1m13.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$12bd36810b792f2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay20Regular', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.6q-.4-.6-1-.95V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h6.75q-.33.45-.45 1h-6.3A2.75 2.75 0 0 1 2 13.25zM15.5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5M5 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$ba4b5010d98f04b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v7.25a3.5 3.5 0 1 0-5.95 2.5h-.28A2.77 2.77 0 0 0 13 19.77V20H5.25A3.25 3.25 0 0 1 2 16.75zM5 8v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m16 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $bd5c6ab3f2a8957d$export$af17310e61cbaedf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v7.25a3.5 3.5 0 0 0-1.5-2.87V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h8.06q-.3.57-.31 1.27V20H5.25A3.25 3.25 0 0 1 2 16.75zM18.5 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 6c3.21 0 4.5-1.57 4.5-3.12v-.1c0-.99-.8-1.78-1.77-1.78h-5.46c-.98 0-1.77.8-1.77 1.77v.1c0 1.57 1.29 3.13 4.5 3.13M6 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$5575b484c40cf074 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v9q-.02.23-.25.25a.26.26 0 0 1-.26-.25A4 4 0 1 0 18.85 20h-.8A3.04 3.04 0 0 0 15 23.04v.21q0 .38.07.75H5.75A3.75 3.75 0 0 1 2 20.25zm4 1.5v4.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-4.5C14 8.56 13.44 8 12.75 8h-5.5C6.56 8 6 8.56 6 9.25M24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $bd5c6ab3f2a8957d$export$d46d9701fec6e52e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlay28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v9q-.02.23-.25.25a.26.26 0 0 1-.26-.25 4 4 0 0 0-.99-2.4v-6.6c0-1.24-1-2.25-2.25-2.25H5.75c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1 2.25 2.25 2.25h9.3q-.05.27-.05.54v.21q0 .38.07.75H5.75A3.75 3.75 0 0 1 2 20.25zM21.5 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 7c3.93 0 5.5-1.88 5.5-3.75v-.2c0-1.13-.92-2.05-2.05-2.05h-6.9c-1.13 0-2.05.92-2.05 2.04v.21c0 1.87 1.57 3.75 5.5 3.75M7.25 8C6.56 8 6 8.56 6 9.25v4.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-4.5C14 8.56 13.44 8 12.75 8z"
]);
const $bd5c6ab3f2a8957d$export$5a000edfee140fbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside16Filled', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM4 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm9 3.75a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v.5c0 .97.78 1.75 1.75 1.75h.5c.97 0 1.75-.78 1.75-1.75zM11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $bd5c6ab3f2a8957d$export$d760d17406e36579 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside16Regular', "16", [
    "M4 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm9 3.75a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v.5c0 .97.78 1.75 1.75 1.75h.5c.97 0 1.75-.78 1.75-1.75zM11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 3zM2 5.5C2 4.67 2.67 4 3.5 4h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 2 10.5z"
]);
const $bd5c6ab3f2a8957d$export$23581bacadc5e196 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside20Filled', "20", [
    "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm10 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M12 10a1 1 0 0 0-1 1v1c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$4f4b43fce6c0d2d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside20Regular', "20", [
    "M13.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M11 11a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zM5 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-.25-2A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25z"
]);
const $bd5c6ab3f2a8957d$export$3e98c1a4ef3b434c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zM16 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M5 8v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m9 5a1 1 0 0 0-1 1v.25A2.75 2.75 0 0 0 15.75 17h.5A2.75 2.75 0 0 0 19 14.25V14a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$d3bc0d3a52166ab3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside24Regular', "24", [
    "M16 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-3 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v.25A2.75 2.75 0 0 1 16.25 17h-.5A2.75 2.75 0 0 1 13 14.25zM6.25 7C5.56 7 5 7.56 5 8.25v3.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25v-3.5C12 7.56 11.44 7 10.75 7zm-1-3A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $bd5c6ab3f2a8957d$export$ee34b89f74841e68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25zM6.5 7C5.67 7 5 7.67 5 8.5v4c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM21 10.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m-7 5v.25C14 18.1 15.9 20 18.25 20h.5C21.1 20 23 18.1 23 15.75v-.25c0-.83-.67-1.5-1.5-1.5h-6c-.83 0-1.5.67-1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$e7bb558023d110be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonOverlayInside28Regular', "28", [
    "M6.5 7C5.67 7 5 7.67 5 8.5v4c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM21 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-7 5v.25C14 18.1 15.9 20 18.25 20h.5C21.1 20 23 18.1 23 15.75v-.25c0-.83-.67-1.5-1.5-1.5h-6c-.83 0-1.5.67-1.5 1.5M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4zM3.5 7.75c0-1.24 1.01-2.25 2.25-2.25h16.5c1.24 0 2.25 1 2.25 2.25v12.5c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25z"
]);
const $bd5c6ab3f2a8957d$export$e021dd599c9587a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP16Filled', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v2.25c0 .14-.11.25-.25.25a.3.3 0 0 1-.26-.25 3 3 0 1 0-5.22 2.26A2.5 2.5 0 0 0 7.04 13H3.5A2.5 2.5 0 0 1 1 10.5zm2 0v5a.5.5 0 0 0 1 0V9h1a2 2 0 1 0 0-4H3.5a.5.5 0 0 0-.5.5M4 8h1a1 1 0 0 0 0-2H4zm9.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$c97d059cd3393852 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v2.25c0 .14-.11.25-.25.25a.3.3 0 0 1-.26-.25q-.07-.79-.49-1.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h3.55a3 3 0 0 0-.01 1H3.5A2.5 2.5 0 0 1 1 10.5zM11.5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5m-8-10a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0V9h1a2 2 0 1 0 0-4zM5 8H4V6h1a1 1 0 0 1 0 2"
]);
const $bd5c6ab3f2a8957d$export$55a26d9561a956ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP20Filled', "20", [
    "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.34a3 3 0 1 0-4.73 3.67c-1.1.1-2 .92-2.22 1.99H5a3 3 0 0 1-3-3zm4 .5v5a.5.5 0 0 0 1 0V11h1a2 2 0 1 0 0-4H6.5a.5.5 0 0 0-.5.5M7 10h1a1 1 0 0 0 0-2H7zm10.5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$557488a1dc9e4ce0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP20Regular', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.6q-.4-.6-1-.95V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h6.75q-.33.45-.45 1h-6.3A2.75 2.75 0 0 1 2 13.25zM15.5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5m-9-12a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0V11h1a2 2 0 1 0 0-4zM8 10H7V8h1a1 1 0 0 1 0 2"
]);
const $bd5c6ab3f2a8957d$export$9c6a61cc03cb295d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v7.25a3.5 3.5 0 1 0-5.95 2.5h-.28A2.77 2.77 0 0 0 13 19.77V20H5.25A3.25 3.25 0 0 1 2 16.75zm5 1.5v6.5a.75.75 0 0 0 1.5 0V13.5h1.25a2.75 2.75 0 1 0 0-5.5h-2a.75.75 0 0 0-.75.75M8.5 12h1.25a1.25 1.25 0 1 0 0-2.5H8.5zM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $bd5c6ab3f2a8957d$export$fb7f0638b16f84c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v7.25a3.5 3.5 0 0 0-1.5-2.87V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h8.06q-.3.57-.31 1.27V20H5.25A3.25 3.25 0 0 1 2 16.75zM18.5 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 6c3.21 0 4.5-1.57 4.5-3.12v-.1c0-.99-.8-1.78-1.77-1.78h-5.46c-.98 0-1.77.8-1.77 1.77v.1c0 1.57 1.29 3.13 4.5 3.13M7.75 8a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0V13.5h1.25a2.75 2.75 0 1 0 0-5.5zm2 4H8.5V9.5h1.25a1.25 1.25 0 1 1 0 2.5"
]);
const $bd5c6ab3f2a8957d$export$39c331f701d1d7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v9q-.02.23-.25.25a.26.26 0 0 1-.26-.25A4 4 0 1 0 18.85 20h-.8A3.04 3.04 0 0 0 15 23.04v.21q0 .38.07.75H5.75A3.75 3.75 0 0 1 2 20.25zm6 2v8.5a.75.75 0 0 0 1.5 0V16h2a3.5 3.5 0 1 0 0-7H8.75a.75.75 0 0 0-.75.75m1.5 4.75h2a2 2 0 1 0 0-4h-2zm15 2.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $bd5c6ab3f2a8957d$export$834f7b22d2bca057 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenPersonP28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v9q-.02.23-.25.25a.26.26 0 0 1-.26-.25 4 4 0 0 0-.99-2.4v-6.6c0-1.24-1-2.25-2.25-2.25H5.75c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1 2.25 2.25 2.25h9.3q-.05.27-.05.54v.21q0 .38.07.75H5.75A3.75 3.75 0 0 1 2 20.25zM21.5 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 7c3.93 0 5.5-1.88 5.5-3.75v-.2c0-1.13-.92-2.05-2.05-2.05h-6.9c-1.13 0-2.05.92-2.05 2.04v.21c0 1.87 1.57 3.75 5.5 3.75M8.75 9a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0V16h2a3.5 3.5 0 1 0 0-7zm2.75 5.5h-2v-4h2a2 2 0 1 1 0 4"
]);
const $bd5c6ab3f2a8957d$export$51aa8d1ceb9ecd72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart16Filled', "16", [
    "M2.75 3C1.78 3 1 3.78 1 4.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C15 3.78 14.22 3 13.25 3zm5.6 2.15 2 2a.5.5 0 0 1-.7.7L8.5 6.71v3.79a.5.5 0 0 1-1 0V6.7L6.35 7.86a.5.5 0 1 1-.7-.7l2-2c.2-.2.5-.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$c40503361dcd5e63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart16Regular', "16", [
    "M2.75 3C1.78 3 1 3.78 1 4.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C15 3.78 14.22 3 13.25 3zM2 4.75c0-.41.34-.75.75-.75h10.5c.41 0 .75.34.75.75v6.5c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75zm6.35.4a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L7.5 6.71v3.79a.5.5 0 0 0 1 0V6.7l1.15 1.15a.5.5 0 0 0 .7-.7z"
]);
const $bd5c6ab3f2a8957d$export$2050b9211bf277ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart20Filled', "20", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm6 10a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5"
]);
const $bd5c6ab3f2a8957d$export$77e72cb8ddf61f7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart20Regular', "20", [
    "M10 14a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$2df0f5dea61f3ce9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart24Filled', "24", [
    "M4.25 4C3.01 4 2 5 2 6.25v11.5C2 18.99 3 20 4.25 20h15.5c1.24 0 2.25-1 2.25-2.25V6.25C22 5.01 21 4 19.75 4zm8.28 3.47 3.25 3.25a.75.75 0 1 1-1.06 1.06l-1.97-1.97v6.44a.75.75 0 1 1-1.5 0V9.81l-1.97 1.97a.75.75 0 1 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0"
]);
const $bd5c6ab3f2a8957d$export$8e20c22032785c34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart24Regular', "24", [
    "M2 6.25C2 5.01 3 4 4.25 4h15.5C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 20 2 19 2 17.75zm2.25-.75a.75.75 0 0 0-.75.75v11.5c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0-.75-.75zM12 7.25q.31 0 .53.22l3.25 3.25a.75.75 0 1 1-1.06 1.06l-1.97-1.97v6.44a.75.75 0 0 1-1.5 0V9.81l-1.97 1.97a.75.75 0 1 1-1.06-1.06l3.25-3.25a.8.8 0 0 1 .53-.22"
]);
const $bd5c6ab3f2a8957d$export$228a1b47d43ae3c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart28Filled', "28", [
    "M4.25 5C3.01 5 2 6 2 7.25v13.5C2 21.99 3 23 4.25 23h19.5c1.24 0 2.25-1 2.25-2.25V7.25C26 6 25 5 23.75 5zm10.28 3.84 3.25 3.25a.75.75 0 0 1-1.06 1.07l-1.97-1.98v7.45a.75.75 0 0 1-1.5 0v-7.45l-1.97 1.98a.75.75 0 1 1-1.06-1.06l3.25-3.26a.75.75 0 0 1 1.06 0"
]);
const $bd5c6ab3f2a8957d$export$5a198293733e776d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart28Regular', "28", [
    "M2 7.25C2 6 3 5 4.25 5h19.5C24.99 5 26 6 26 7.25v13.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 23 2 22 2 20.75zm2.25-.75a.75.75 0 0 0-.75.75v13.5c0 .41.34.75.75.75h19.5c.41 0 .75-.34.75-.75V7.25a.75.75 0 0 0-.75-.75zM14 8.62q.31 0 .53.22l3.25 3.25a.75.75 0 0 1-1.06 1.07l-1.97-1.98v7.45a.75.75 0 1 1-1.5 0v-7.45l-1.97 1.98a.75.75 0 1 1-1.06-1.06l3.25-3.26a.8.8 0 0 1 .53-.22"
]);
const $bd5c6ab3f2a8957d$export$8eeb8bbb8ff18624 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart48Filled', "48", [
    "M8.25 8A4.25 4.25 0 0 0 4 12.25v23.5C4 38.1 5.9 40 8.25 40h31.5C42.1 40 44 38.1 44 35.75v-23.5C44 9.9 42.1 8 39.75 8zM24 14.75q.51 0 .88.37l6 6a1.25 1.25 0 0 1-1.76 1.76l-3.87-3.86v12.73a1.25 1.25 0 1 1-2.5 0V19.02l-3.87 3.86a1.25 1.25 0 0 1-1.76-1.76l6-6c.23-.24.55-.37.88-.37"
]);
const $bd5c6ab3f2a8957d$export$65e922270d5c76a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStart48Regular', "48", [
    "M24 14.75q.51 0 .88.37l6 6a1.25 1.25 0 0 1-1.76 1.76l-3.87-3.86v12.73a1.25 1.25 0 1 1-2.5 0V19.02l-3.87 3.86a1.25 1.25 0 0 1-1.76-1.76l6-6c.23-.24.55-.37.88-.37M8.25 8A4.25 4.25 0 0 0 4 12.25v23.5C4 38.1 5.9 40 8.25 40h31.5C42.1 40 44 38.1 44 35.75v-23.5C44 9.9 42.1 8 39.75 8zM6.5 12.25c0-.97.78-1.75 1.75-1.75h31.5c.97 0 1.75.78 1.75 1.75v23.5c0 .97-.78 1.75-1.75 1.75H8.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $bd5c6ab3f2a8957d$export$5bc3cf99f454540e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop16Filled', "16", [
    "M3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm2.15 2.15c.2-.2.5-.2.7 0L8 7.29l2.15-2.14a.5.5 0 0 1 .7.7L8.71 8l2.14 2.15a.5.5 0 0 1-.7.7L8 8.71l-2.15 2.14a.5.5 0 0 1-.7-.7L7.29 8 5.15 5.85a.5.5 0 0 1 0-.7"
]);
const $bd5c6ab3f2a8957d$export$50575239c88a4e93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop16Regular', "16", [
    "M5.15 5.15c.2-.2.5-.2.7 0L8 7.29l2.15-2.14a.5.5 0 0 1 .7.7L8.71 8l2.14 2.15a.5.5 0 0 1-.7.7L8 8.71l-2.15 2.14a.5.5 0 0 1-.7-.7L7.29 8 5.15 5.85a.5.5 0 0 1 0-.7M1 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$ceb1b279c6c76629 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zm2.65 3.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7"
]);
const $bd5c6ab3f2a8957d$export$b045f4e75d7c6826 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop20Regular', "20", [
    "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $bd5c6ab3f2a8957d$export$547016d586790f67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop24Filled', "24", [
    "M4.25 4h15.5C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4m5.03 4.22a.75.75 0 0 0-1.06 1.06L10.94 12l-2.72 2.72a.75.75 0 0 0 1.06 1.06L12 13.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L13.06 12l2.72-2.72a.75.75 0 1 0-1.06-1.06L12 10.94z"
]);
const $bd5c6ab3f2a8957d$export$f7866e7bcb3368c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop24Regular', "24", [
    "M2 6.25C2 5.01 3 4 4.25 4h15.5C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 20 2 19 2 17.75zm2.25-.75a.75.75 0 0 0-.75.75v11.5c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0-.75-.75zm3.97 2.72c.3-.3.77-.3 1.06 0L12 10.94l2.72-2.72a.75.75 0 0 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 1 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 0-1.06"
]);
const $bd5c6ab3f2a8957d$export$fb5c936d67bbfcf2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop28Filled', "28", [
    "M4.25 5h19.5C24.99 5 26 6 26 7.25v13.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 23 2 22 2 20.75V7.25C2 6 3 5 4.25 5m7.03 5.22a.75.75 0 0 0-1.06 1.06L12.94 14l-2.72 2.72a.75.75 0 0 0 1.06 1.06L14 15.06l2.72 2.72a.75.75 0 0 0 1.06-1.06L15.06 14l2.72-2.72a.75.75 0 1 0-1.06-1.06L14 12.94z"
]);
const $bd5c6ab3f2a8957d$export$e070cf37b99fc3e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop28Regular', "28", [
    "M11.28 10.22a.75.75 0 0 0-1.06 1.06L12.94 14l-2.72 2.72a.75.75 0 0 0 1.06 1.06L14 15.06l2.72 2.72a.75.75 0 0 0 1.06-1.06L15.06 14l2.72-2.72a.75.75 0 1 0-1.06-1.06L14 12.94zM4.25 5C3.01 5 2 6 2 7.25v13.5C2 21.99 3 23 4.25 23h19.5c1.24 0 2.25-1 2.25-2.25V7.25C26 6 25 5 23.75 5zM3.5 7.25c0-.42.34-.75.75-.75h19.5c.41 0 .75.33.75.75v13.5c0 .41-.34.75-.75.75H4.25a.75.75 0 0 1-.75-.75z"
]);
const $bd5c6ab3f2a8957d$export$ac2a78c1eb7caa61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop48Filled', "48", [
    "M8.75 8A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.75 4.75 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8zm13.48 16-5.86-5.87a1.25 1.25 0 0 1 1.76-1.76L24 22.23l5.87-5.86a1.25 1.25 0 0 1 1.76 1.76L25.77 24l5.86 5.87a1.25 1.25 0 0 1-1.76 1.76L24 25.77l-5.87 5.86a1.25 1.25 0 0 1-1.76-1.76z"
]);
const $bd5c6ab3f2a8957d$export$f4e158431a03909e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShareScreenStop48Regular', "48", [
    "m22.23 24-5.86-5.87a1.25 1.25 0 0 1 1.76-1.76L24 22.23l5.87-5.86a1.25 1.25 0 0 1 1.76 1.76L25.77 24l5.86 5.87a1.25 1.25 0 0 1-1.76 1.76L24 25.77l-5.87 5.86a1.25 1.25 0 0 1-1.76-1.76zM4 12.75A4.75 4.75 0 0 1 8.75 8h30.5A4.75 4.75 0 0 1 44 12.75v22.5A4.75 4.75 0 0 1 39.25 40H8.75A4.75 4.75 0 0 1 4 35.25zm4.75-2.25c-1.24 0-2.25 1-2.25 2.25v22.5c0 1.24 1 2.25 2.25 2.25h30.5c1.24 0 2.25-1 2.25-2.25v-22.5c0-1.24-1-2.25-2.25-2.25z"
]);
const $bd5c6ab3f2a8957d$export$ab7eaffeff581530 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag16Filled', "16", [
    "M5 5V3a2 2 0 0 1 3-1.73A2 2 0 0 1 11 3v2h.5c.83 0 1.5.67 1.5 1.5v7a1.5 1.5 0 0 1-3 0V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 9 3v10.5q.02.86.5 1.5H5a2 2 0 0 1-2-2V6.5C3 5.67 3.67 5 4.5 5zm2-3a1 1 0 0 0-1 1v2h2V3a1 1 0 0 0-1-1"
]);
const $bd5c6ab3f2a8957d$export$5c7790f07748b7d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag16Regular', "16", [
    "M5 5V3a2 2 0 0 1 3-1.73A2 2 0 0 1 11 3v2h.5c.83 0 1.5.67 1.5 1.5V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5C3 5.67 3.67 5 4.5 5zm1-2v2h2V3a1 1 0 0 0-2 0m5 11a1 1 0 0 0 1-1V6.5a.5.5 0 0 0-.5-.5H10v7a1 1 0 0 0 1 1M9 6H4.5a.5.5 0 0 0-.5.5V13a1 1 0 0 0 1 1h4.27A2 2 0 0 1 9 13zm0-3v2h1V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 9 3"
]);
const $bd5c6ab3f2a8957d$export$9506a854af165475 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag20Filled', "20", [
    "M6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 .88 2.13A3 3 0 0 0 7 18h4.76a3 3 0 0 1-.76-2V4.5a2.5 2.5 0 0 0-.33-1.24q.37-.26.83-.26a1.5 1.5 0 0 1 1.38.91q.12.28.12.59V6h-1v10a2 2 0 1 0 4 0V7a1 1 0 0 0-1-1h-1V4.5q0-.51-.2-.97A2.48 2.48 0 0 0 10 2.51 2.5 2.5 0 0 0 8.5 2a2.4 2.4 0 0 0-1.77.73A2.4 2.4 0 0 0 6 4.5m1 0a1.5 1.5 0 0 1 .91-1.38Q8.2 3 8.5 3a1.5 1.5 0 0 1 1.38.91q.12.28.12.59V6H7z"
]);
const $bd5c6ab3f2a8957d$export$c721b071bdd48a69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag20Regular', "20", [
    "M10 2.5q-.64-.48-1.5-.5A2.5 2.5 0 0 0 6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h6.5a2.5 2.5 0 0 0 2.5-2.5V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2m-3 2a1.5 1.5 0 1 1 3 0V6H7zm3.67-1.25q.36-.24.83-.25c.83 0 1.5.67 1.5 1.5V6h-2V4.5q0-.69-.33-1.25M7 17a2 2 0 0 1-2-2V7h6v8.5q.02.85.5 1.5zm8-1.5a1.5 1.5 0 0 1-3 0V7h3z"
]);
const $bd5c6ab3f2a8957d$export$a6dadd7f0c4a7ca5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag24Filled', "24", [
    "M7 5v2H5.5C4.67 7 4 7.67 4 8.5V18a4 4 0 0 0 4 4h6c-.62-.74-1-1.7-1-2.75V5a3 3 0 0 0-.16-.96A1.5 1.5 0 0 1 15.5 5v2h-1v12.25a2.75 2.75 0 1 0 5.5 0V8.5c0-.83-.67-1.5-1.5-1.5H17V5a3 3 0 0 0-5-2.24A3 3 0 0 0 7 5m1.5 0a1.5 1.5 0 1 1 3 0v2h-3z"
]);
const $bd5c6ab3f2a8957d$export$e8855dc4b752f70e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag24Regular', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v10a3.5 3.5 0 0 1-3.5 3.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm6.64 13.5a3.5 3.5 0 0 1-.63-2v-10H5.5V18A2.5 2.5 0 0 0 8 20.5zM11.5 7V5a1.5 1.5 0 0 0-3 0v2zM13 7h2.5V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5zm1.51 11.5a2 2 0 0 0 3.99 0v-10h-3.99z"
]);
const $bd5c6ab3f2a8957d$export$5eb75b92d421f1fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag28Filled', "28", [
    "M8 5.5a3.5 3.5 0 0 1 6-2.45 3.49 3.49 0 0 1 6 2.45V8h2.5c.83 0 1.5.67 1.5 1.5v13.25A3.25 3.25 0 0 1 20.8 26h-.1a3.25 3.25 0 0 1-3.2-3.25V8h1V5.5a2 2 0 0 0-3.67-1.1q.16.53.17 1.1V8h1v14.75c0 1.26.49 2.4 1.29 3.25H8a4 4 0 0 1-4-4V9.5C4 8.67 4.67 8 5.5 8H8zm5.5 0a2 2 0 1 0-4 0V8h4z"
]);
const $bd5c6ab3f2a8957d$export$31dbaca651c0dc04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag28Regular', "28", [
    "M8 5.5a3.5 3.5 0 0 1 6-2.45 3.49 3.49 0 0 1 6 2.45V8h2.5c.83 0 1.5.67 1.5 1.5V22a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9.5C4 8.67 4.67 8 5.5 8H8zM18.5 8V5.5a2 2 0 0 0-3.67-1.1q.16.53.17 1.1V8zm-5-2.5a2 2 0 1 0-4 0V8h4zm2.5 4H5.5V22A2.5 2.5 0 0 0 8 24.5h8.88A4 4 0 0 1 16 22zm4 15a2.5 2.5 0 0 0 2.5-2.5V9.5h-5V22a2.5 2.5 0 0 0 2.5 2.5"
]);
const $bd5c6ab3f2a8957d$export$feed0498d35ed57d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag32Filled', "32", [
    "M9 6.5a4.5 4.5 0 0 1 7-3.74 4.5 4.5 0 0 1 7 3.74V10h2a2 2 0 0 1 2 2v14.5a3.5 3.5 0 1 1-7 0V10h1V6.5a2.5 2.5 0 0 0-3.6-2.25q.59 1 .6 2.25v20c0 1.33.47 2.55 1.26 3.5H9.5A4.5 4.5 0 0 1 5 25.5V12c0-1.1.9-2 2-2h2zm2 3.5h5V6.5a2.5 2.5 0 0 0-5 0z"
]);
const $bd5c6ab3f2a8957d$export$7f0ad9f704ddd73c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag32Regular', "32", [
    "M13.5 2A4.5 4.5 0 0 0 9 6.5V10H7a2 2 0 0 0-2 2v13.5A4.5 4.5 0 0 0 9.5 30h13a4.5 4.5 0 0 0 4.5-4.5V12a2 2 0 0 0-2-2h-2V6.5a4.5 4.5 0 0 0-7-3.74A4.5 4.5 0 0 0 13.5 2M25 12v13.5a2.5 2.5 0 0 1-5 0V12zm-6.24 16H9.5A2.5 2.5 0 0 1 7 25.5V12h11v13.5c0 .93.28 1.79.76 2.5M21 10h-3V6.5q-.02-1.25-.6-2.25.5-.25 1.1-.25A2.5 2.5 0 0 1 21 6.5zM11 6.5a2.5 2.5 0 0 1 5 0V10h-5z"
]);
const $bd5c6ab3f2a8957d$export$d5fd345a4ad1bc2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag48Filled', "48", [
    "M14 10a6 6 0 0 1 10-4.47A6 6 0 0 1 34 10v4h3.5a2.5 2.5 0 0 1 2.5 2.5v22.25a5.25 5.25 0 1 1-10.5 0V14h2v-4a3.5 3.5 0 0 0-6.01-2.43q.5 1.12.51 2.43v4h1v24.75c0 2.03.78 3.87 2.05 5.25H14.5A6.5 6.5 0 0 1 8 37.5v-21a2.5 2.5 0 0 1 2.5-2.5H14zm2.5 4h7v-4a3.5 3.5 0 1 0-7 0z"
]);
const $bd5c6ab3f2a8957d$export$ffcccd59506de56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBag48Regular', "48", [
    "M20 4a6 6 0 0 0-6 6v4h-3.5A2.5 2.5 0 0 0 8 16.5v21a6.5 6.5 0 0 0 6.5 6.5h19a6.5 6.5 0 0 0 6.5-6.5v-21a2.5 2.5 0 0 0-2.5-2.5H34v-4a6 6 0 0 0-10-4.47A6 6 0 0 0 20 4m17.5 12.5v21a4 4 0 0 1-8 0v-21zm-9.12 25H14.5a4 4 0 0 1-4-4v-21H27v21c0 1.5.51 2.9 1.38 4M31.5 14H26v-4q0-1.31-.51-2.43A3.49 3.49 0 0 1 31.5 10zm-8-4v4h-7v-4a3.5 3.5 0 1 1 7 0"
]);
const $bd5c6ab3f2a8957d$export$12a26f2dcfaf7124 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagAdd16Filled', "16", [
    "M5 3v2h-.5C3.67 5 3 5.67 3 6.5V13c0 1.1.9 2 2 2h2.26a5.5 5.5 0 0 1 5.71-8.8A1.5 1.5 0 0 0 11.5 5H11V3a2 2 0 0 0-3-1.73A2 2 0 0 0 5 3m5 2H9V3a2 2 0 0 0-.25-.97A1 1 0 0 1 10 3zM8 5H6V3a1 1 0 0 1 2 0zm8 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $bd5c6ab3f2a8957d$export$2900d3b8f57e92bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagAdd16Regular', "16", [
    "M5 3v2h-.5C3.67 5 3 5.67 3 6.5V13c0 1.1.9 2 2 2h2.26a6 6 0 0 1-.66-1H5a1 1 0 0 1-1-1V6.5c0-.28.22-.5.5-.5h7q.76 0 1.47.2A1.5 1.5 0 0 0 11.5 5H11V3a2 2 0 0 0-3-1.73A2 2 0 0 0 5 3m1 2V3a1 1 0 0 1 2 0v2zm3 0V3a2 2 0 0 0-.25-.97A1 1 0 0 1 10 3v2zm7 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $bd5c6ab3f2a8957d$export$7fd4dc3b6b03de35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagAdd20Filled', "20", [
    "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5M6 6V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.5 5.5 0 0 0-.74 7.74H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1zm4 0V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6z"
]);
const $bd5c6ab3f2a8957d$export$76cda6718eb07cb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagAdd20Regular', "20", [
    "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5M10 2.5q-.64-.48-1.5-.5A2.5 2.5 0 0 0 6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h3.26a6 6 0 0 1-.66-1H7a2 2 0 0 1-2-2V7h6v3.26q.46-.39 1-.66V7h3v2.02q.51.05 1 .19V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2m-3 2a1.5 1.5 0 1 1 3 0V6H7zm3.67-1.25q.36-.24.83-.25c.83 0 1.5.67 1.5 1.5V6h-2V4.5q0-.69-.33-1.25"
]);
const $bd5c6ab3f2a8957d$export$39b3b161666db48b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagAdd24Filled', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3a6.5 6.5 0 0 0-5.5.23V7h1V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v7.81a6.5 6.5 0 0 0-.19 9.19H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm1.5-2v2h3V5a1.5 1.5 0 0 0-3 0m9 7a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.5 8.5V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 1 0-1 0V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 1 0 1 0"
]);
const $bd5c6ab3f2a8957d$export$4e6d561dd0efa8b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagAdd24Regular', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3q-.71-.3-1.5-.42V8.5h-3.99v3.23q-.83.43-1.5 1.07V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h3.73q.44.83 1.08 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm4.5 0V5a1.5 1.5 0 0 0-3 0v2zM13 7h2.5V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5zm4.5 5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.5 8.5V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 1 0-1 0V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 1 0 1 0"
]);
const $bd5c6ab3f2a8957d$export$927bc4ec639c65dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagArrowLeft20Filled', "20", [
    "M6 6V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.5 5.5 0 0 0-.74 7.74H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1zm4 0V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6zm9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $bd5c6ab3f2a8957d$export$e4b4d67fabbb41dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagArrowLeft20Regular', "20", [
    "M15 6a1 1 0 0 1 1 1v2.2q-.49-.13-1-.18V7h-3v2.6q-.54.27-1 .66V7H5v8a2 2 0 0 0 1.23 1.84q.36.16.77.16h2.6q.27.54.66 1H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1h1V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6zm-2-1.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5V6h2zM7 6h3V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5zm7.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-2.36-4.85 2-2a.5.5 0 0 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35"
]);
const $bd5c6ab3f2a8957d$export$e25440c41586161c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagArrowLeft24Filled', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3a6.5 6.5 0 0 0-5.5.23V7h1V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v7.81a6.5 6.5 0 0 0-.19 9.19H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm4.5-2a1.5 1.5 0 0 0-3 0v2h3zm6 7a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-.78 2.59-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .76-.63l-.05-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06"
]);
const $bd5c6ab3f2a8957d$export$559df031c9119bcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagArrowLeft24Regular', "24", [
    "M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-6.35-2.85.07-.06a.5.5 0 0 1 .64.06l.05.07a.5.5 0 0 1-.05.63L15.7 17h4.88a.5.5 0 0 1 .41.5v.09a.5.5 0 0 1-.5.41h-4.79l1.65 1.65.05.07a.5.5 0 0 1-.76.63l-2.52-2.51-.05-.07-.03-.06-.03-.08-.01-.09v-.1l.02-.1.02-.05.04-.08.04-.05zM7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3q-.71-.3-1.5-.42V8.5h-4v3.23q-.83.44-1.5 1.08V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h3.73q.44.83 1.08 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm3-3.5c-.83 0-1.5.67-1.5 1.5v2h3V5c0-.83-.67-1.5-1.5-1.5M15.5 7V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v2z"
]);
const $bd5c6ab3f2a8957d$export$3e32feed555768b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark16Filled', "16", [
    "M5 5V3a2 2 0 0 1 3-1.73A2 2 0 0 1 11 3v2h.5c.73 0 1.33.51 1.47 1.2a5.5 5.5 0 0 0-2.97 0V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 9 3v3.6A5.5 5.5 0 0 0 7.26 15H5a2 2 0 0 1-2-2V6.5C3 5.67 3.67 5 4.5 5zm2-3a1 1 0 0 0-1 1v2h2V3a1 1 0 0 0-1-1m9 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$756841ecb8e25d3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark16Regular', "16", [
    "M5 5V3a2 2 0 0 1 3-1.73A2 2 0 0 1 11 3v2h.5c.73 0 1.33.51 1.47 1.2A6 6 0 0 0 11.5 6H10v.2q-.52.16-1 .4V6H4.5a.5.5 0 0 0-.5.5V13a1 1 0 0 0 1 1h1.6q.27.54.66 1H5a2 2 0 0 1-2-2V6.5C3 5.67 3.67 5 4.5 5zm1-2v2h2V3a1 1 0 0 0-2 0m3 0v2h1V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 9 3m7 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$b928a818e5c9bc6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark20Filled', "20", [
    "M6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 .88 2.13A3 3 0 0 0 7 18h3.26a5.5 5.5 0 0 1 .74-7.74V4.5a2.5 2.5 0 0 0-.33-1.24q.37-.26.83-.26a1.5 1.5 0 0 1 1.38.91q.12.28.12.59V6h-1v3.6a5.5 5.5 0 0 1 4-.4V7a1 1 0 0 0-1-1h-1V4.5q0-.51-.2-.97A2.48 2.48 0 0 0 10 2.51 2.5 2.5 0 0 0 8.5 2a2.4 2.4 0 0 0-1.77.73A2.4 2.4 0 0 0 6 4.5m1 0a1.5 1.5 0 0 1 .91-1.38Q8.2 3 8.5 3a1.5 1.5 0 0 1 1.38.91q.12.28.12.59V6H7zm12 10a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$3120b397e7a91d6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark20Regular', "20", [
    "M10 2.5q-.64-.48-1.5-.5A2.5 2.5 0 0 0 6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h3.26a6 6 0 0 1-.66-1H7a2 2 0 0 1-2-2V7h6v3.26q.46-.39 1-.66V7h3v2.02q.51.05 1 .19V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2m-3 2a1.5 1.5 0 1 1 3 0V6H7zm3.67-1.25q.36-.24.83-.25c.83 0 1.5.67 1.5 1.5V6h-2V4.5q0-.69-.33-1.25M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$5ae3a6bfdf9c98f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark24Filled', "24", [
    "M7 5v2H5.5C4.67 7 4 7.67 4 8.5V18a4 4 0 0 0 4 4h4.81a6.5 6.5 0 0 1 .19-9.19V5a3 3 0 0 0-.16-.96A1.5 1.5 0 0 1 15.5 5v2h-1v4.73a6.5 6.5 0 0 1 5.5-.23v-3c0-.83-.67-1.5-1.5-1.5H17V5a3 3 0 0 0-5-2.24A3 3 0 0 0 7 5m1.5 0a1.5 1.5 0 1 1 3 0v2h-3zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$96fe37b0e1f0eb79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark24Regular', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3q-.71-.3-1.5-.42V8.5h-3.99v3.23q-.83.43-1.5 1.07V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h3.73q.44.83 1.08 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm4.5 0V5a1.5 1.5 0 0 0-3 0v2zM13 7h2.5V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5zm10 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$79d50eec03143968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark28Filled', "28", [
    "M8 5.5a3.5 3.5 0 0 1 6-2.45 3.49 3.49 0 0 1 6 2.45V8h2.5c.83 0 1.5.67 1.5 1.5v4.37a7.5 7.5 0 0 0-6.5-.25V8h1V5.5a2 2 0 0 0-3.67-1.1q.16.53.17 1.1V8h1v6.5a7.5 7.5 0 0 0-.6 11.5H8a4 4 0 0 1-4-4V9.5C4 8.67 4.67 8 5.5 8H8zm5.5 0a2 2 0 1 0-4 0V8h4zm13.5 15a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2.65-2.85a.5.5 0 0 0-.7 0L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$9f734f8b7dfc0152 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark28Regular', "28", [
    "M8 5.5a3.5 3.5 0 0 1 6-2.45 3.49 3.49 0 0 1 6 2.45V8h2.5c.83 0 1.5.67 1.5 1.5v4.37a8 8 0 0 0-1.5-.6V9.5h-5v4.12q-.81.36-1.5.88v-5H5.5V22A2.5 2.5 0 0 0 8 24.5h6.15q.53.83 1.25 1.5H8a4 4 0 0 1-4-4V9.5C4 8.67 4.67 8 5.5 8H8zM18.5 8V5.5a2 2 0 0 0-3.67-1.1q.16.53.17 1.1V8zm-5-2.5a2 2 0 1 0-4 0V8h4zm13.5 15a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2.65-2.85a.5.5 0 0 0-.7 0L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$971c318e4f0d316b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark32Filled', "32", [
    "M9 6.5a4.5 4.5 0 0 1 7-3.74 4.5 4.5 0 0 1 7 3.74V10h2a2 2 0 0 1 2 2v2.94a9 9 0 0 0-7-.43V10h1V6.5a2.5 2.5 0 0 0-3.6-2.25q.59 1 .6 2.25v9.02A9 9 0 0 0 17.34 30H9.5A4.5 4.5 0 0 1 5 25.5V12c0-1.1.9-2 2-2h2zm7 3.5V6.5a2.5 2.5 0 0 0-5 0V10zm7 5.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06"
]);
const $bd5c6ab3f2a8957d$export$4315dc8f8384e58f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark32Regular', "32", [
    "M13.5 2A4.5 4.5 0 0 0 9 6.5V10H7a2 2 0 0 0-2 2v13.5A4.5 4.5 0 0 0 9.5 30h7.84a9 9 0 0 1-1.82-2H9.5A2.5 2.5 0 0 1 7 25.5V12h11v3.52a9 9 0 0 1 2-1V12h5v2.22q1.05.24 2 .72V12a2 2 0 0 0-2-2h-2V6.5a4.5 4.5 0 0 0-7-3.74A4.5 4.5 0 0 0 13.5 2m7.5 8h-3V6.5q-.02-1.25-.6-2.25.5-.25 1.1-.25A2.5 2.5 0 0 1 21 6.5zM11 6.5a2.5 2.5 0 0 1 5 0V10h-5zm12 9a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m4.53 4.72a.75.75 0 0 0-1.06 0l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5.25-5.25c.3-.3.3-.77 0-1.06"
]);
const $bd5c6ab3f2a8957d$export$c6d0ca8ff82e0fc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark48Filled', "48", [
    "M14 10a6 6 0 0 1 10-4.47A6 6 0 0 1 34 10v4h3.5a2.5 2.5 0 0 1 2.5 2.5v6.96a13 13 0 0 0-10.5-.66V14h2v-4a3.5 3.5 0 0 0-6.01-2.43q.5 1.12.51 2.43v4h1v10.04A13 13 0 0 0 24.62 44H14.5A6.5 6.5 0 0 1 8 37.5v-21a2.5 2.5 0 0 1 2.5-2.5H14zm9.5 4v-4a3.5 3.5 0 1 0-7 0v4zM45 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-4.3-4.7a1 1 0 0 0-1.4 0L32 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l8-8a1 1 0 0 0 0-1.42"
]);
const $bd5c6ab3f2a8957d$export$45a36a66af8876bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagCheckmark48Regular', "48", [
    "M20 4a6 6 0 0 0-6 6v4h-3.5A2.5 2.5 0 0 0 8 16.5v21a6.5 6.5 0 0 0 6.5 6.5h10.12q-1.09-1.14-1.88-2.5H14.5a4 4 0 0 1-4-4v-21H27v7.54q1.18-.75 2.5-1.24v-6.3h8v5.98q1.31.36 2.5.98V16.5a2.5 2.5 0 0 0-2.5-2.5H34v-4a6 6 0 0 0-10-4.47A6 6 0 0 0 20 4m11.5 10H26v-4q0-1.31-.51-2.43A3.49 3.49 0 0 1 31.5 10zm-8-4v4h-7v-4a3.5 3.5 0 1 1 7 0M45 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-4.3-4.7a1 1 0 0 0-1.4 0L32 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l8-8a1 1 0 0 0 0-1.42"
]);
const $bd5c6ab3f2a8957d$export$aa5747645d34d0de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagDismiss20Filled', "20", [
    "M6 6V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.5 5.5 0 0 0-.74 7.74H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1zm4 0V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6zm9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bd5c6ab3f2a8957d$export$4dc0248136b57f6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagDismiss20Regular', "20", [
    "M10 2.5q-.64-.48-1.5-.5A2.5 2.5 0 0 0 6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h3.26a6 6 0 0 1-.66-1H7a2 2 0 0 1-2-2V7h6v3.26q.46-.39 1-.66V7h3v2.02q.51.05 1 .19V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2m-3 2a1.5 1.5 0 1 1 3 0V6H7zm3.67-1.25q.36-.24.83-.25c.83 0 1.5.67 1.5 1.5V6h-2V4.5q0-.69-.33-1.25M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $bd5c6ab3f2a8957d$export$10e683db8a13802c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagDismiss24Filled', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3a6.5 6.5 0 0 0-5.5.23V7h1V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v7.81a6.5 6.5 0 0 0-.19 9.19H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm1.5-2v2h3V5a1.5 1.5 0 0 0-3 0M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $bd5c6ab3f2a8957d$export$f7f50fdc4886d389 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagDismiss24Regular', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3q-.71-.3-1.5-.42V8.5h-3.99v3.23q-.83.43-1.5 1.07V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h3.73q.44.83 1.08 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm4.5 0V5a1.5 1.5 0 0 0-3 0v2zM13 7h2.5V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5zm10 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $bd5c6ab3f2a8957d$export$2b1472d97e3c7b1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPause20Filled', "20", [
    "M6 6V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.5 5.5 0 0 0-.74 7.74H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1zm4 0V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6zm9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M13 12a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m3 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$db492cb18b849cda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPause20Regular', "20", [
    "M10 2.5q-.64-.48-1.5-.5A2.5 2.5 0 0 0 6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h3.26a6 6 0 0 1-.66-1H7a2 2 0 0 1-2-2V7h6v3.26q.46-.39 1-.66V7h3v2.02q.51.05 1 .19V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2m-3 2a1.5 1.5 0 1 1 3 0V6H7zm3.67-1.25q.36-.24.83-.25c.83 0 1.5.67 1.5 1.5V6h-2V4.5q0-.69-.33-1.25M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M13 12a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m3 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$e7c292f3564bcafc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPause24Filled', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3a6.5 6.5 0 0 0-5.5.23V7h1V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v7.81a6.5 6.5 0 0 0-.19 9.19H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm1.5-2v2h3V5a1.5 1.5 0 0 0-3 0M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.5-3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m4 0a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$3902bb11cdc86e26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPause24Regular', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v3q-.71-.3-1.5-.42V8.5h-3.99v3.23q-.83.43-1.5 1.07V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h3.73q.44.83 1.08 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm4.5 0V5a1.5 1.5 0 0 0-3 0v2zM13 7h2.5V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5zm10 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.5-3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m4 0a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$36277be6ff5d1a0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPercent20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-3-8A2.5 2.5 0 0 1 14 4.5V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.5 5.5 0 0 0-.74 7.74H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1h1V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 1.5-.5m5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m.35-2.85a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7l4-4a.5.5 0 0 0 0-.7M12.5 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4-9a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6h3V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3"
]);
const $bd5c6ab3f2a8957d$export$a1da42ba90ccb301 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPercent20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-3-8A2.5 2.5 0 0 1 14 4.5V6h1a1 1 0 0 1 1 1v2.2q-.49-.13-1-.18V7h-3v2.6q-.54.27-1 .66V7H5v8a2 2 0 0 0 1.23 1.84q.36.16.77.16h2.6q.27.54.66 1H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1h1V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 1.5-.5m5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m.35-2.85a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7l4-4a.5.5 0 0 0 0-.7M12.5 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4-9a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6h3V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3m3 0q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5V6h2V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3"
]);
const $bd5c6ab3f2a8957d$export$18aed042dd326920 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPercent24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M14 2a3 3 0 0 1 3 3v2h1.5c.83 0 1.5.67 1.5 1.5v3a6.5 6.5 0 0 0-5.5.23V7h1V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v7.81a6.5 6.5 0 0 0-.19 9.19H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7H7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 14 2m6 15.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m.33-2.83a.5.5 0 0 0-.7 0l-4.96 4.95a.5.5 0 0 0 .71.7l4.95-4.94a.5.5 0 0 0 0-.7M20 18.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-5-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-5-12c-.83 0-1.5.67-1.5 1.5v2h3V5c0-.83-.67-1.5-1.5-1.5"
]);
const $bd5c6ab3f2a8957d$export$af9aa7828c0d8eba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPercent24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M14 2a3 3 0 0 1 3 3v2h1.5c.83 0 1.5.67 1.5 1.5v3q-.71-.3-1.5-.42V8.5h-4v3.23q-.83.44-1.5 1.08V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h3.73q.44.83 1.08 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7H7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 14 2m6 15.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m.33-2.83a.5.5 0 0 0-.7 0l-4.96 4.95a.5.5 0 0 0 .71.7l4.95-4.94a.5.5 0 0 0 0-.7M20 18.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-5-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-5-12c-.83 0-1.5.67-1.5 1.5v2h3V5c0-.83-.67-1.5-1.5-1.5m4 0c-.46 0-.88.21-1.16.54Q13 4.5 13 5v2h2.5V5c0-.83-.67-1.5-1.5-1.5"
]);
const $bd5c6ab3f2a8957d$export$a9032fee24ea6cf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPlay20Filled', "20", [
    "M6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 .88 2.13A3 3 0 0 0 7 18h3.26a5.5 5.5 0 0 1 .74-7.74V4.5a2.5 2.5 0 0 0-.33-1.24q.37-.26.83-.26a1.5 1.5 0 0 1 1.38.91q.12.28.12.59V6h-1v3.6a5.5 5.5 0 0 1 4-.4V7a1 1 0 0 0-1-1h-1V4.5q0-.51-.2-.97A2.48 2.48 0 0 0 10 2.51 2.5 2.5 0 0 0 8.5 2a2.4 2.4 0 0 0-1.77.73A2.4 2.4 0 0 0 6 4.5M10 6H7V4.5a1.5 1.5 0 0 1 .91-1.38Q8.2 3 8.5 3a1.5 1.5 0 0 1 1.38.91q.12.28.12.59zm4.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.74-6.55q.14 0 .26.08l2.3 1.51q.1.07.16.18a.54.54 0 0 1-.03.54l-.13.13-2.3 1.57-.12.06-.14.03-.18-.04-.16-.12-.1-.16a1 1 0 0 1-.05-.2v-3.07a.5.5 0 0 1 .3-.46.4.4 0 0 1 .2-.05"
]);
const $bd5c6ab3f2a8957d$export$2c05ac1c4f250baf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPlay20Regular', "20", [
    "M15 6a1 1 0 0 1 1 1v2.2q-.49-.13-1-.18V7h-3v2.6q-.54.27-1 .66V7H5v8a2 2 0 0 0 1.23 1.84q.36.16.77.16h2.6q.27.54.66 1H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1h1V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6zm-2-1.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5V6h2zM7 6h3V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5zm12 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.98-1.97a.5.5 0 0 0-.45-.03l-.15.1-.1.17a1 1 0 0 0-.05.2v3.07a.5.5 0 0 0 .15.35q.06.07.16.12a.5.5 0 0 0 .35 0l.1-.05 2.3-1.57a1 1 0 0 0 .16-.18.5.5 0 0 0 0-.49 1 1 0 0 0-.17-.18z"
]);
const $bd5c6ab3f2a8957d$export$fe76207ad3499b0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPlay24Filled', "24", [
    "M7 5v2H5.5C4.67 7 4 7.67 4 8.5V18a4 4 0 0 0 4 4h4.81a6.5 6.5 0 0 1 .19-9.19V5a3 3 0 0 0-.16-.96A1.5 1.5 0 0 1 15.5 5v2h-1v4.73a6.5 6.5 0 0 1 5.5-.23v-3c0-.83-.67-1.5-1.5-1.5H17V5a3 3 0 0 0-5-2.24A3 3 0 0 0 7 5m3-1.5c.83 0 1.5.67 1.5 1.5v2h-3V5c0-.83.67-1.5 1.5-1.5m13 14a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.09-2.4a.6.6 0 0 0-.54-.05 1 1 0 0 0-.2.13.62.62 0 0 0-.18.44v3.76a.6.6 0 0 0 .19.44q.08.08.19.13a.6.6 0 0 0 .44 0l.11-.05 2.8-1.92a1 1 0 0 0 .2-.22.7.7 0 0 0 0-.6 1 1 0 0 0-.2-.22z"
]);
const $bd5c6ab3f2a8957d$export$5c72c3c93e81adae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagPlay24Regular', "24", [
    "M7 5v2H5.5C4.67 7 4 7.67 4 8.5V18a4 4 0 0 0 4 4h4.81a7 7 0 0 1-1.08-1.5H8A2.5 2.5 0 0 1 5.5 18V8.5H13v4.31q.67-.65 1.5-1.08V8.5h4v2.58q.79.12 1.5.42v-3c0-.83-.67-1.5-1.5-1.5H17V5a3 3 0 0 0-5-2.24A3 3 0 0 0 7 5m3-1.5c.83 0 1.5.67 1.5 1.5v2h-3V5c0-.83.67-1.5 1.5-1.5M15.5 7H13V5a3 3 0 0 0-.16-.96A1.5 1.5 0 0 1 15.5 5zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.09-2.4a.6.6 0 0 0-.54-.05 1 1 0 0 0-.2.13.62.62 0 0 0-.18.44v3.76a.6.6 0 0 0 .19.44q.08.08.19.13a.6.6 0 0 0 .44 0l.11-.05 2.8-1.92a1 1 0 0 0 .2-.22.7.7 0 0 0 0-.6 1 1 0 0 0-.2-.22z"
]);
const $bd5c6ab3f2a8957d$export$f54d72dacb492b28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag16Filled', "16", [
    "M4 5V3a2 2 0 0 1 3-1.73A2 2 0 0 1 10 3v2h.5c.68 0 1.25.45 1.43 1.06a3 3 0 0 0-.55-.06H9V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 8 3v3.05C6.86 6.3 6 7.3 6 8.51v2.88c0 .66.26 1.29.72 1.76l1.7 1.74.08.11H4a2 2 0 0 1-2-2V6.5C2 5.67 2.67 5 3.5 5zm2-3a1 1 0 0 0-1 1v2h2V3a1 1 0 0 0-1-1m1.43 10.45A1.5 1.5 0 0 1 7 11.39V8.51C7 7.68 7.68 7 8.51 7h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 0 1-2.12-.03zM9 9.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
]);
const $bd5c6ab3f2a8957d$export$1a85427953464c4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag16Regular', "16", [
    "M4 3v2h-.5C2.67 5 2 5.67 2 6.5V13c0 1.1.9 2 2 2h4.53l-.98-1H4a1 1 0 0 1-1-1V6.5c0-.28.22-.5.5-.5h7.88q.29 0 .55.06A1.5 1.5 0 0 0 10.5 5H10V3a2 2 0 0 0-3-1.73A2 2 0 0 0 4 3m1 2V3a1 1 0 0 1 2 0v2zm3 0V3a2 2 0 0 0-.25-.97A1 1 0 0 1 9 3v2zm-.57 7.45A1.5 1.5 0 0 1 7 11.39V8.51C7 7.68 7.68 7 8.51 7h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 0 1-2.12-.03zM9 9.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
]);
const $bd5c6ab3f2a8957d$export$67b6b88fc2f88cea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag20Filled', "20", [
    "M6 6V4.5a2.4 2.4 0 0 1 .73-1.77A2.4 2.4 0 0 1 8.5 2a2.4 2.4 0 0 1 1.5.5 2.4 2.4 0 0 1 2.48-.3 2.5 2.5 0 0 1 1.32 1.33q.2.45.2.97V6h1a1 1 0 0 1 1 1v2.6a2.5 2.5 0 0 0-1.62-.6H12V6h1V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 11.5 3q-.45 0-.83.26A2.5 2.5 0 0 1 11 4.5v4.55c-1.14.24-2 1.25-2 2.46v2.88c0 .66.26 1.29.72 1.76L11.53 18H7q-.62 0-1.16-.23A3 3 0 0 1 4 15V7a1 1 0 0 1 1-1zm4 0V4.5a1.5 1.5 0 0 0-.44-1.06A1.5 1.5 0 0 0 8.5 3a1.5 1.5 0 0 0-1.06.44A1.5 1.5 0 0 0 7 4.5V6zm.43 9.45a1.5 1.5 0 0 1-.43-1.06v-2.88c0-.83.68-1.51 1.51-1.51h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 0 1-2.12-.03zm1.57-2.7a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
]);
const $bd5c6ab3f2a8957d$export$d6f70d3114ded95e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag20Regular', "20", [
    "M10 2.5q-.64-.48-1.5-.5A2.5 2.5 0 0 0 6 4.5V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h4.53l-.98-1H7a2 2 0 0 1-2-2V7h6v2.05q.25-.05.51-.05H12V7h3v2.08q.55.14 1 .51V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2m-3 2a1.5 1.5 0 1 1 3 0V6H7zm3.67-1.25q.36-.24.83-.25c.83 0 1.5.67 1.5 1.5V6h-2V4.5q0-.69-.33-1.25m-.24 12.2a1.5 1.5 0 0 1-.43-1.06v-2.88c0-.83.68-1.51 1.51-1.51h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 0 1-2.12-.03zm1.57-2.7a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
]);
const $bd5c6ab3f2a8957d$export$eaa320199c9348cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag24Filled', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v4.32l-.97-.96a3 3 0 0 0-2.11-.86H14.5V7h1V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5v6.17A3 3 0 0 0 11 14v2.93a3 3 0 0 0 .86 2.1L14.77 22H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm1.5-2v2h3V5a1.5 1.5 0 0 0-3 0m4.07 13.33 4 4.07a2 2 0 0 0 2.86.02l2.99-3a2 2 0 0 0-.01-2.83l-4.08-4.01a2 2 0 0 0-1.41-.58H14a2 2 0 0 0-2 2v2.93a2 2 0 0 0 .57 1.4M16 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $bd5c6ab3f2a8957d$export$36a67a18dfc98ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag24Regular', "24", [
    "M7 7V5a3 3 0 0 1 5-2.24A3 3 0 0 1 17 5v2h1.5c.83 0 1.5.67 1.5 1.5v4.32l-.97-.96a3 3 0 0 0-.53-.41V8.5h-3.99V11h-.5a3 3 0 0 0-1 .17V8.5H5.5V18A2.5 2.5 0 0 0 8 20.5h5.3l1.47 1.5H8a4 4 0 0 1-4-4V8.5C4 7.67 4.67 7 5.5 7zm4.5 0V5a1.5 1.5 0 0 0-3 0v2zM13 7h2.5V5a1.5 1.5 0 0 0-2.66-.96Q13 4.5 13 5zm-.43 11.33 4 4.07a2 2 0 0 0 2.86.02l2.99-3a2 2 0 0 0-.01-2.83l-4.08-4.01a2 2 0 0 0-1.41-.58H14a2 2 0 0 0-2 2v2.93a2 2 0 0 0 .57 1.4M16 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $bd5c6ab3f2a8957d$export$386f02b25eda00d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag28Filled', "28", [
    "M11.5 2A3.5 3.5 0 0 0 8 5.5V8H5.5C4.67 8 4 8.67 4 9.5V22a4 4 0 0 0 4 4h10.09l-4.21-4.2a3 3 0 0 1-.88-2.12V16a3 3 0 0 1 3-3V8h-1V5.5q0-.57-.17-1.1a2 2 0 0 1 3.67 1.1V8h-1v5h2.18a3 3 0 0 1 2.12.88l2.2 2.2V9.5c0-.83-.67-1.5-1.5-1.5H20V5.5a3.5 3.5 0 0 0-6-2.45A3.5 3.5 0 0 0 11.5 2m0 1.5a2 2 0 0 1 2 2V8h-4V5.5c0-1.1.9-2 2-2M14 19.68V16c0-1.1.9-2 2-2h3.68a2 2 0 0 1 1.41.6l5.33 5.31a2 2 0 0 1 0 2.83l-3.68 3.67a2 2 0 0 1-2.83 0l-5.32-5.32a2 2 0 0 1-.59-1.41M16 17a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $bd5c6ab3f2a8957d$export$6d3388aefe36b67f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag28Regular', "28", [
    "M11.5 2A3.5 3.5 0 0 0 8 5.5V8H5.5C4.67 8 4 8.67 4 9.5V22a4 4 0 0 0 4 4h10.08l-1.5-1.5H8A2.5 2.5 0 0 1 5.5 22V9.5H16V13h1.5V9.5h5v5.08l1.5 1.5V9.5c0-.83-.67-1.5-1.5-1.5H20V5.5a3.5 3.5 0 0 0-6-2.45A3.5 3.5 0 0 0 11.5 2m7 3.5V8H15V5.5q0-.57-.17-1.1a2 2 0 0 1 3.67 1.1m-7-2a2 2 0 0 1 2 2V8h-4V5.5c0-1.1.9-2 2-2M14 19.68V16c0-1.1.9-2 2-2h3.68a2 2 0 0 1 1.41.6l5.33 5.31a2 2 0 0 1 0 2.83l-3.68 3.67a2 2 0 0 1-2.83 0l-5.32-5.32a2 2 0 0 1-.59-1.41M16 17a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $bd5c6ab3f2a8957d$export$dadd545fc2fb9788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag32Filled', "32", [
    "M13.5 2A4.5 4.5 0 0 0 9 6.5V10H7a2 2 0 0 0-2 2v13.5A4.5 4.5 0 0 0 9.5 30h10.88l-4.85-4.86a3.5 3.5 0 0 1-1.03-2.47V18a3.5 3.5 0 0 1 3.5-3.5v-8q-.02-1.25-.6-2.25.5-.25 1.1-.25A2.5 2.5 0 0 1 21 6.5V10h-1v4.5h2.67c.93 0 1.82.37 2.47 1.03L27 17.38V12a2 2 0 0 0-2-2h-2V6.5a4.5 4.5 0 0 0-7-3.74A4.5 4.5 0 0 0 13.5 2M16 6.5V10h-5V6.5a2.5 2.5 0 0 1 5 0m13.8 15.8a2.4 2.4 0 0 1 0 3.4l-4.1 4.1a2.4 2.4 0 0 1-3.4 0l-5.71-5.72a2 2 0 0 1-.59-1.41V18c0-1.1.9-2 2-2h4.67a2 2 0 0 1 1.41.59zm-11.3-2.8a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $bd5c6ab3f2a8957d$export$11f1c542700d6474 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag32Regular', "32", [
    "M13.5 2A4.5 4.5 0 0 0 9 6.5V10H7a2 2 0 0 0-2 2v13.5A4.5 4.5 0 0 0 9.5 30h10.88l-2-2H9.5A2.5 2.5 0 0 1 7 25.5V12h11v2.5h2V12h5v3.39l.14.13L27 17.39V12a2 2 0 0 0-2-2h-2V6.5a4.5 4.5 0 0 0-7-3.74A4.5 4.5 0 0 0 13.5 2m7.5 8h-3V6.5q-.02-1.25-.6-2.25.5-.25 1.1-.25A2.5 2.5 0 0 1 21 6.5zM11 6.5a2.5 2.5 0 0 1 5 0V10h-5zm18.8 15.8a2.4 2.4 0 0 1 0 3.4l-4.1 4.1a2.4 2.4 0 0 1-3.4 0l-5.71-5.72a2 2 0 0 1-.59-1.41V18c0-1.1.9-2 2-2h4.67a2 2 0 0 1 1.41.59zm-11.3-2.8a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $bd5c6ab3f2a8957d$export$5f4f0b030f25a91a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag48Filled', "48", [
    "M14 10a6 6 0 0 1 10-4.47A6 6 0 0 1 34 10v4h3.5a2.5 2.5 0 0 1 2.5 2.5v8.34l-1.08-1.08A6 6 0 0 0 34.67 22H29.5v-8h2v-4a3.5 3.5 0 0 0-6.01-2.43q.5 1.12.51 2.43v4h1v8.08a6 6 0 0 0-5 5.93v6.66a6 6 0 0 0 1.76 4.25L28.84 44H14.5A6.5 6.5 0 0 1 8 37.5v-21a2.5 2.5 0 0 1 2.5-2.5H14zm9.5 4v-4a3.5 3.5 0 1 0-7 0v4zm.5 20.67v-6.66A4 4 0 0 1 28 24h6.67a4 4 0 0 1 2.84 1.17l7.32 7.32a4 4 0 0 1 0 5.67l-6.67 6.67a4 4 0 0 1-5.67 0l-7.32-7.32A4 4 0 0 1 24 34.67m4-5.17a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $bd5c6ab3f2a8957d$export$dc22998bf87bf499 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShoppingBagTag48Regular', "48", [
    "M20 4a6 6 0 0 0-6 6v4h-3.5A2.5 2.5 0 0 0 8 16.5v21a6.5 6.5 0 0 0 6.5 6.5h14.34l-2.5-2.5H14.5a4 4 0 0 1-4-4v-21H27v5.58q.5-.08 1-.08h1.5v-5.5h8v6.2a6 6 0 0 1 1.42 1.06L40 24.84V16.5a2.5 2.5 0 0 0-2.5-2.5H34v-4a6 6 0 0 0-10-4.47A6 6 0 0 0 20 4m11.5 10H26v-4q0-1.31-.51-2.43A3.49 3.49 0 0 1 31.5 10zm-8-4v4h-7v-4a3.5 3.5 0 1 1 7 0m.5 24.67v-6.66A4 4 0 0 1 28 24h6.67a4 4 0 0 1 2.84 1.17l7.32 7.32a4 4 0 0 1 0 5.67l-6.67 6.67a4 4 0 0 1-5.67 0l-7.32-7.32A4 4 0 0 1 24 34.67m4-5.17a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $bd5c6ab3f2a8957d$export$d786624465917dd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shortpick20Filled', "20", [
    "M7 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.5a.5.5 0 0 0 0-1H7V3h.5a.5.5 0 0 0 0-1zm2.5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h.5v2h-.5a.5.5 0 0 0 0 1h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-3 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-5 2c.28 0 .5.22.5.5v8c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-8a.5.5 0 0 1 1 0v8a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5v-8c0-.28.22-.5.5-.5M7 12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zM6 8a1 1 0 0 1 1-1h.5a.5.5 0 0 1 0 1H7v2h.5a.5.5 0 0 1 0 1H7a1 1 0 0 1-1-1zm3-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0c0-.28.22-.5.5-.5h.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.5a.5.5 0 0 1 0-1h.5V8h-.5a.5.5 0 0 1-.5-.5m-3 3c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$eb8508c52f5fad31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shortpick20Regular', "20", [
    "M7 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.5a.5.5 0 0 0 0-1H7V3h.5a.5.5 0 0 0 0-1zm2.5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h.5v2h-.5a.5.5 0 0 0 0 1h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-3 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM5 7.5a.5.5 0 0 0-1 0v8A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-8a.5.5 0 0 0-1 0v8c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5zM7 12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm0 1h6v2H7zM6 8a1 1 0 0 1 1-1h.5a.5.5 0 0 1 0 1H7v2h.5a.5.5 0 0 1 0 1H7a1 1 0 0 1-1-1zm3-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3 0c0-.28.22-.5.5-.5h.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.5a.5.5 0 0 1 0-1h.5V8h-.5a.5.5 0 0 1-.5-.5m-3 3c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$43398bf7ce47b593 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shortpick24Filled', "24", [
    "M8.96 3.5H8.5v2h.46a.75.75 0 0 1 0 1.5h-.71C7.56 7 7 6.44 7 5.75v-2.5C7 2.56 7.56 2 8.25 2h.71a.75.75 0 0 1 0 1.5M11.5 2a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm3.54 0a.75.75 0 0 0 0 1.5h.46v2h-.46a.75.75 0 0 0 0 1.5h.71C16.44 7 17 6.44 17 5.75v-2.5C17 2.56 16.44 2 15.75 2zM11.5 5.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zM4.75 8c.41 0 .75.34.75.75v10c0 .97.78 1.75 1.75 1.75h9.5c.97 0 1.75-.78 1.75-1.75v-10a.75.75 0 0 1 1.5 0v10c0 1.8-1.46 3.25-3.25 3.25h-9.5A3.25 3.25 0 0 1 4 18.75v-10c0-.41.34-.75.75-.75m3.5 6C7.56 14 7 14.56 7 15.25v2.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm.25-4.5h.46a.75.75 0 0 0 0-1.5h-.71C7.56 8 7 8.56 7 9.25v2.5c0 .69.56 1.25 1.25 1.25h.71a.75.75 0 0 0 0-1.5H8.5zm2.25-.75c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75m3.54 0c0-.41.33-.75.75-.75h.71c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-.71a.75.75 0 0 1 0-1.5h.46v-2h-.46a.75.75 0 0 1-.75-.75m-3.54 3.5c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75"
]);
const $bd5c6ab3f2a8957d$export$1c5c050162e78ab0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shortpick24Regular', "24", [
    "M8.96 3.5H8.5v2h.46a.75.75 0 0 1 0 1.5h-.71C7.56 7 7 6.44 7 5.75v-2.5C7 2.56 7.56 2 8.25 2h.71a.75.75 0 0 1 0 1.5M11.5 2a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm3.54 0a.75.75 0 0 0 0 1.5h.46v2h-.46a.75.75 0 0 0 0 1.5h.71C16.44 7 17 6.44 17 5.75v-2.5C17 2.56 16.44 2 15.75 2zM11.5 5.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm-6 3.25a.75.75 0 0 0-1.5 0v10C4 20.55 5.46 22 7.25 22h9.5c1.8 0 3.25-1.46 3.25-3.25v-10a.75.75 0 0 0-1.5 0v10c0 .97-.78 1.75-1.75 1.75h-9.5c-.97 0-1.75-.78-1.75-1.75zM8.25 14C7.56 14 7 14.56 7 15.25v2.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm.25 3.5v-2h7v2zm0-8h.46a.75.75 0 0 0 0-1.5h-.71C7.56 8 7 8.56 7 9.25v2.5c0 .69.56 1.25 1.25 1.25h.71a.75.75 0 0 0 0-1.5H8.5zm2.25-.75c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75m3.54 0c0-.41.33-.75.75-.75h.71c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-.71a.75.75 0 0 1 0-1.5h.46v-2h-.46a.75.75 0 0 1-.75-.75m-3.54 3.5c0-.41.34-.75.75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75"
]);
const $bd5c6ab3f2a8957d$export$c979690aad5972de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Showerhead20Filled', "20", [
    "m15.48 2.42-1.7 1.7a7 7 0 0 1 2.06 2.02l1.68-1.68a1.44 1.44 0 1 0-2.04-2.04M4.85 11.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 .7.7zm2 2a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 .7.7zm2 1.3c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0m4.86-.8-.18-.22-7.66-7.66-.23-.18a1.45 1.45 0 0 0-1.82 2.23l7.66 7.66a1.45 1.45 0 0 0 2.23-1.82M6.58 5.78a3 3 0 0 0-.45-.36 6 6 0 0 1 8.46 8.46q-.15-.23-.35-.44z"
]);
const $bd5c6ab3f2a8957d$export$922776695d01faae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Showerhead20Regular', "20", [
    "M17.43 2.57a1.94 1.94 0 0 0-2.74 0L12.65 4.6v.01a6 6 0 0 0-6.76 1.02 1.91 1.91 0 0 0-1.74 3.22l7 7a1.91 1.91 0 0 0 3.23-1.74 6 6 0 0 0 1.01-6.76l2.04-2.03c.76-.76.76-2 0-2.75m-2.57 3.9a6 6 0 0 0-1.34-1.33l1.88-1.86a.94.94 0 1 1 1.33 1.33zm-8.02-.34a5 5 0 0 1 7.03 7.03l-.01-.01-7-7zm-.72.7 7.05 7.05a.91.91 0 0 1-1.31 1.27l-7-7a.91.91 0 0 1 1.26-1.32m.73 6.32c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0m-2-1.3a.5.5 0 1 0-.7-.7l-2 2a.5.5 0 1 0 .7.7zm4 3.3c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$1ecc645485df4ade = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Showerhead24Filled', "24", [
    "M21.49 4.98 19.48 7a9 9 0 0 0-2.47-2.47l2.01-2a1.75 1.75 0 1 1 2.47 2.46M5.28 13.72c.3.3.3.77 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l2-2c.3-.3.77-.3 1.06 0m2.5 3.56a.75.75 0 1 0-1.06-1.06l-2 2a.75.75 0 1 0 1.06 1.06zm2.5 2.5a.75.75 0 1 0-1.06-1.06l-2 2a.75.75 0 1 0 1.06 1.06zM3.74 7.26a1.75 1.75 0 0 1 2.47 0l10.56 10.56a1.75 1.75 0 1 1-2.47 2.48L3.74 9.74a1.75 1.75 0 0 1 0-2.48m3.18-.7a3 3 0 0 0-.43-.36A8 8 0 0 1 17.8 17.5q-.14-.2-.32-.39z"
]);
const $bd5c6ab3f2a8957d$export$6887c66848595295 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Showerhead24Regular', "24", [
    "m15.6 4.86 2.13-2.13a2.5 2.5 0 1 1 3.53 3.53l-2.12 2.12a8 8 0 0 1-1.2 8.98 2.5 2.5 0 0 1-4.18 2.4l-9.5-9.48a2.5 2.5 0 0 1 2.36-4.2 8 8 0 0 1 8.98-1.22m2.71 2.23L20.2 5.2a1 1 0 0 0-1.41-1.4L16.9 5.67a8 8 0 0 1 1.41 1.4M5.33 7.8a1 1 0 0 0 0 1.4l9.49 9.5a1 1 0 1 0 1.4-1.41L6.75 7.8a1 1 0 0 0-1.41 0m2.45 9.47a.75.75 0 1 0-1.06-1.06l-2 2a.75.75 0 1 0 1.06 1.06zm2.5 1.44c.3.3.3.77 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l2-2c.3-.3.77-.3 1.06 0m-5-3.94a.75.75 0 1 0-1.06-1.06l-2 2a.75.75 0 1 0 1.06 1.06zm11.82 1.26A6.5 6.5 0 0 0 7.96 6.9z"
]);
const $bd5c6ab3f2a8957d$export$ec2a67d43f000324 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Showerhead32Filled', "32", [
    "m28.38 6.62-2.89 2.89a12 12 0 0 0-3-3l2.89-2.89a2.12 2.12 0 0 1 3 3M7.7 19.71a1 1 0 1 0-1.42-1.42l-3 3a1 1 0 1 0 1.42 1.42zm3 1.58a1 1 0 0 1 0 1.42l-3 3a1 1 0 0 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0m3 4.42a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 1 0 1.42 1.42zM8.24 9.62a2.13 2.13 0 0 0-2.98 3.05l14.1 14.1a2.13 2.13 0 0 0 3.02-3l-.01-.02-14.1-14.1zm1.1-1.03-.03-.02a10 10 0 0 1 14.12 14.12z"
]);
const $bd5c6ab3f2a8957d$export$62c7309b77a7cf46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Showerhead32Regular', "32", [
    "M20.5 7.07a10 10 0 0 0-10.95 1.3 3.12 3.12 0 0 0-3.6 5l12.7 12.7a3.12 3.12 0 0 0 5-3.62 10 10 0 0 0 1.28-10.97l3.15-3.15a3.12 3.12 0 1 0-4.42-4.42zm-9.4 2.6A8 8 0 0 1 22.32 20.9zm-3.73.7c.42-.43 1.1-.44 1.54-.04L21.7 23.1a1.12 1.12 0 0 1-1.63 1.55l-12.7-12.7a1.1 1.1 0 0 1 0-1.6m14.86-2.2 2.85-2.84a1.12 1.12 0 1 1 1.58 1.59l-2.84 2.84a10 10 0 0 0-1.59-1.58M7.71 19.72a1 1 0 1 0-1.42-1.42l-3 3a1 1 0 1 0 1.42 1.42zm3 1.58a1 1 0 0 1 0 1.42l-3 3a1 1 0 0 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0m3 4.42a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 1 0 1.42 1.42z"
]);
const $bd5c6ab3f2a8957d$export$192c748c54740cbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v2.76A5.5 5.5 0 0 0 6.02 12H3.5A2.5 2.5 0 0 1 1 9.5zm15 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $bd5c6ab3f2a8957d$export$4fbd93111e74619b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd16Regular', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v2.76a6 6 0 0 0-1-.66V4.5c0-.83-.67-1.5-1.5-1.5h-9C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5h2.52a6 6 0 0 0 0 1H3.5A2.5 2.5 0 0 1 1 9.5zm15 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $bd5c6ab3f2a8957d$export$776ae0352cd1d0bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd20Filled', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.5A5.5 5.5 0 0 0 9.2 16H4.76A2.75 2.75 0 0 1 2 13.26zm17 7.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bd5c6ab3f2a8957d$export$aff7744de0646117 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd20Regular', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.5a6 6 0 0 0-1-.65V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h4.27q.05.51.19 1H4.75A2.75 2.75 0 0 1 2 13.25zm17 7.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bd5c6ab3f2a8957d$export$1292ba0c28ad0415 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75A6.5 6.5 0 0 1 22 12.81V6.75A2.75 2.75 0 0 0 19.25 4zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 1 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 1 1 0 1z"
]);
const $bd5c6ab3f2a8957d$export$e08855f9fcf18e34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd24Regular', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v6.06a7 7 0 0 0-1.5-1.08V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h6.33q.12.79.42 1.5H4.75A2.75 2.75 0 0 1 2 17.25zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 1 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 1 1 0 1z"
]);
const $bd5c6ab3f2a8957d$export$72e7344881ccc3c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h8.12A7.5 7.5 0 0 1 26 15.4V7.75A3.75 3.75 0 0 0 22.24 4zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $bd5c6ab3f2a8957d$export$e6becdbc0e279153 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65q-.67-.72-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H5.75c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25h7.52q.22.8.6 1.5H5.75A3.75 3.75 0 0 1 2 20.25zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $bd5c6ab3f2a8957d$export$fe8d4e074f1a7842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84A9 9 0 0 0 15.52 28H6.5A4.5 4.5 0 0 1 2 23.5zm21 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
]);
const $bd5c6ab3f2a8957d$export$24e73efab5eb26f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd32Regular', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9 9 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6h-19A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h8.01q.39 1.07 1 2H6.5A4.5 4.5 0 0 1 2 23.5zm21 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0"
]);
const $bd5c6ab3f2a8957d$export$a61bd19f2d5b8818 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd48Filled', "48", [
    "M10.25 8A6.25 6.25 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40H23q-.99-2.33-1-5a13 13 0 0 1 22-9.38V14.25C44 10.8 41.2 8 37.75 8zM35 46a11 11 0 1 0 0-22 11 11 0 0 0 0 22m0-19a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6h-6a1 1 0 1 1 0-2h6v-6a1 1 0 0 1 1-1"
]);
const $bd5c6ab3f2a8957d$export$74d35bb1f85cad56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideAdd48Regular', "48", [
    "M4 14.25C4 10.8 6.8 8 10.25 8h27.5C41.2 8 44 10.8 44 14.25v11.37q-1.14-1.09-2.5-1.88v-9.49a3.75 3.75 0 0 0-3.75-3.75h-27.5a3.75 3.75 0 0 0-3.75 3.75v19.5a3.75 3.75 0 0 0 3.75 3.75h11.99q.25 1.3.76 2.5H10.25A6.25 6.25 0 0 1 4 33.75zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
]);
const $bd5c6ab3f2a8957d$export$f0deb24850e23faf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowForward20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m1.6 1.9a.5.5 0 1 0-.7.7l.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 1 0 .71.7l1.76-1.75A.5.5 0 0 0 18 14a.5.5 0 0 0-.15-.35zM15.5 4A2.5 2.5 0 0 1 18 6.5v3.76a5.5 5.5 0 0 0-5.8-.76H5.5a.5.5 0 0 0 0 1h5.23q-.7.65-1.13 1.5H5.5a.5.5 0 0 0 0 1h3.7a5.5 5.5 0 0 0 0 3H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-10 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $bd5c6ab3f2a8957d$export$a8a8325d08c6660e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowForward20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m1.6 1.9a.5.5 0 1 0-.7.7l.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 1 0 .71.7l1.76-1.75A.5.5 0 0 0 18 14a.5.5 0 0 0-.15-.35zM15.5 4A2.5 2.5 0 0 1 18 6.5v3.76a6 6 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4.52q.05.51.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-5.9 8q-.25.48-.4 1H5.5a.5.5 0 0 1 0-1zm2.6-2.5a6 6 0 0 0-1.47 1H5.5a.5.5 0 0 1 0-1zM9.5 7a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
]);
const $bd5c6ab3f2a8957d$export$bff5103f424be78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowForward24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m1.75-8A2.75 2.75 0 0 1 22 6.75v6.06a6.5 6.5 0 0 0-6.21-1.58.8.8 0 0 0-.54-.23h-8.5a.75.75 0 0 0 0 1.5h6.6q-.78.64-1.33 1.5H6.75a.75.75 0 0 0 0 1.5h4.56a6.5 6.5 0 0 0 .19 4.5H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4zm.1 10.65a.5.5 0 1 0-.7.7l.64.65h-2.04A3.25 3.25 0 0 0 14 19.25v.25a.5.5 0 0 0 1 0v-.25c0-1.24 1-2.25 2.25-2.25h2.04l-.64.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zM6.75 8a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$466a3a0c7fef6a3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowForward24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m1.75-8A2.75 2.75 0 0 1 22 6.75v6.06q-.67-.65-1.5-1.08V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h6.33q.12.79.42 1.5H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4zm.1 10.65a.5.5 0 1 0-.7.7l.64.65h-2.04A3.25 3.25 0 0 0 14 19.25v.25a.5.5 0 0 0 1 0v-.25c0-1.24 1-2.25 2.25-2.25h2.04l-.64.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zM12.02 14q-.45.7-.7 1.5H6.74a.75.75 0 0 1 0-1.5zm3.23-3q.32.01.54.23-1.38.39-2.44 1.27h-6.6a.75.75 0 0 1 0-1.5zm-4-3a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$a67bbe14f6a7378b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowRight20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v3.76a5.5 5.5 0 0 0-5.8-.76H5.5a.5.5 0 0 0 0 1h5.23q-.7.65-1.13 1.5H5.5a.5.5 0 0 0 0 1h3.7a5.5 5.5 0 0 0 0 3H4.5A2.5 2.5 0 0 1 2 13.5zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $bd5c6ab3f2a8957d$export$cd49c3fc4a1c71b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowRight20Regular', "20", [
    "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5.23q.65-.61 1.48-1zm0 2.5h4.1q-.24.48-.4 1H5.5a.5.5 0 0 1 0-1m-1 3h4.52q.05.51.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v3.76a6 6 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5m14.5-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $bd5c6ab3f2a8957d$export$631af0341d9a1218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowRight24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v6.06a6.5 6.5 0 0 0-6.21-1.58.8.8 0 0 0-.54-.23h-8.5a.75.75 0 0 0 0 1.5h6.6q-.79.64-1.33 1.5H6.75a.75.75 0 0 0 0 1.5h4.56a6.5 6.5 0 0 0 .19 4.5H4.75A2.75 2.75 0 0 1 2 17.25zM6.75 8a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $bd5c6ab3f2a8957d$export$2005426d699d60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideArrowRight24Regular', "24", [
    "M6.75 8a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM6 11.75c0-.41.34-.75.75-.75h8.5q.32.01.54.23-1.38.38-2.44 1.27h-6.6a.75.75 0 0 1-.75-.75m14.5-5v4.98q.83.44 1.5 1.08V6.75A2.75 2.75 0 0 0 19.25 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75q-.3-.71-.42-1.5H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25m-9.19 8.75q.27-.8.71-1.5H6.75a.75.75 0 0 0 0 1.5zm11.69 2a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $bd5c6ab3f2a8957d$export$b1d4ce790602aaa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideContent20Filled', "20", [
    "M15.76 4.01A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h11zM6 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm5.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0-2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0-2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $bd5c6ab3f2a8957d$export$cbb630084c99bdd8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideContent20Regular', "20", [
    "M15.76 4.01A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h11zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7A1.5 1.5 0 0 0 15.65 5H4.5M9 7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm5.5 5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm0-2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm0-2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $bd5c6ab3f2a8957d$export$86ce1cc76fbb5296 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideContent24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM6.25 8C5.56 8 5 8.56 5 9.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5C13 8.56 12.44 8 11.75 8zm7.75.75c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75m.75 2.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM14 14.75c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75"
]);
const $bd5c6ab3f2a8957d$export$17f8860fe82da162 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideContent24Regular', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25zM5 9.25C5 8.56 5.56 8 6.25 8h5.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-5.5C5.56 16 5 15.44 5 14.75zm9-.5c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM14 14.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75"
]);
const $bd5c6ab3f2a8957d$export$87a79a8211b05e27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideEraser16Filled', "16", [
    "M1 3.75C1 2.78 1.78 2 2.75 2h10.5c.97 0 1.75.78 1.75 1.75v4.32l-1.4-1.41a2.25 2.25 0 0 0-3.2 0l-3.74 3.75A2.2 2.2 0 0 0 6 12H2.75C1.78 12 1 11.22 1 10.25zm10.12 3.62a1.25 1.25 0 0 1 1.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52zm-3.18 3.17-.57.58a1.25 1.25 0 0 0 0 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57z"
]);
const $bd5c6ab3f2a8957d$export$c660fcac6ad4ec24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideEraser16Regular', "16", [
    "M1 3.75C1 2.78 1.78 2 2.75 2h10.5c.97 0 1.75.78 1.75 1.75V8h-.07L14 7.07V3.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h3.48Q6 11.48 6 12H2.75C1.78 12 1 11.22 1 10.25zm10.12 3.62a1.25 1.25 0 0 1 1.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52zm-3.18 3.17-.57.58a1.25 1.25 0 0 0 0 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57z"
]);
const $bd5c6ab3f2a8957d$export$ed1d25e1d90412a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideEraser20Filled', "20", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v5.07l-.4-.41a2.25 2.25 0 0 0-3.2 0l-3.74 3.75A2.2 2.2 0 0 0 10 16H4a2 2 0 0 1-2-2zm13.12 5.37a1.25 1.25 0 0 1 1.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52zm-3.18 3.17-.57.58a1.25 1.25 0 0 0 0 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57z"
]);
const $bd5c6ab3f2a8957d$export$c3f9f1bd719f58bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideEraser20Regular', "20", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h6q0-.52.23-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4.23q.32.16.6.43l.4.41V6a2 2 0 0 0-2-2zm11.12 7.37a1.25 1.25 0 0 1 1.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52zm-3.18 3.17-.57.58a1.25 1.25 0 0 0 0 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57z"
]);
const $bd5c6ab3f2a8957d$export$7e767ac89b985f34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideEraser24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h7.83a2.5 2.5 0 0 1 .17-3.35l4.91-4.92a2.5 2.5 0 0 1 3.54 0l.8.8V6.76A2.75 2.75 0 0 0 19.25 4z",
    "M20.5 12.44a1.5 1.5 0 0 0-2.13 0l-3.11 3.11 4.2 4.2 3.12-3.1a1.5 1.5 0 0 0 0-2.12z",
    "m13.45 17.36 1.1-1.1 4.21 4.2-1.1 1.1a1.5 1.5 0 0 1-2.12 0l-2.09-2.08a1.5 1.5 0 0 1 0-2.12"
]);
const $bd5c6ab3f2a8957d$export$358bbbf54159c543 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideEraser24Regular', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v5.79l-.8-.8a3 3 0 0 0-.7-.5V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h7.26c.02.53.2 1.06.57 1.5H4.75A2.75 2.75 0 0 1 2 17.25z",
    "M20.5 12.44a1.5 1.5 0 0 0-2.13 0l-3.11 3.11 4.2 4.2 3.12-3.1a1.5 1.5 0 0 0 0-2.12z",
    "m13.45 17.36 1.1-1.1 4.21 4.2-1.1 1.1a1.5 1.5 0 0 1-2.12 0l-2.09-2.08a1.5 1.5 0 0 1 0-2.12"
]);
const $bd5c6ab3f2a8957d$export$c9b6f79253c8cc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideGrid20Filled', "20", [
    "M4 7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm1 3.5a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1zM10.5 7a1 1 0 0 1 1-1H15a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1zm1 3.5a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1H15a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1zM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$5415d990a767a5b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideGrid20Regular', "20", [
    "M5 6a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm3.5 1v1.5H5V7zM4 11.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm1 0V13h3.5v-1.5zM11.5 6H15a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1M15 7h-3.5v1.5H15zm-4.5 4.5a1 1 0 0 1 1-1H15a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1zm1 0V13H15v-1.5zM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $bd5c6ab3f2a8957d$export$fbad8b9e824fb003 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideGrid24Filled', "24", [
    "M6.25 12.5c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zm7.5 0c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zM6.25 7C5.56 7 5 7.56 5 8.25v2c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zm7.5 0c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2C19 7.56 18.44 7 17.75 7zM2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$b774727a4a3d3295 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideGrid24Regular', "24", [
    "M5 13.75c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-4C5.56 17 5 16.44 5 15.75zm1.5.25v1.5H10V14zm7.25-1.5c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zm.25 3V14h3.5v1.5zM5 8.25C5 7.56 5.56 7 6.25 7h4c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25zm1.5.25V10H10V8.5zM13.75 7c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2C19 7.56 18.44 7 17.75 7zm.25 3V8.5h3.5V10zM2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$ef80219fdbd14d0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideHide20Filled', "20", [
    "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2zm0 5a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H7a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0zm3.5-2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h.5a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V8a2 2 0 0 0-2-2zM6 10.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm12 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm-12 4a.5.5 0 0 0-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H7a1 1 0 0 1-1-1zm12 0a.5.5 0 0 0-1 0v.5a1 1 0 0 1-1 1h-.5a.5.5 0 0 0 0 1h.5a2 2 0 0 0 2-2zM9.5 16a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $bd5c6ab3f2a8957d$export$5bdd74dffd48e5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideHide20Regular', "20", [
    "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2v-1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm0 5a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H7a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0zm3.5-2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h.5a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V8a2 2 0 0 0-2-2zM6 10.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm12 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm-12 4a.5.5 0 0 0-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H7a1 1 0 0 1-1-1zm12 0a.5.5 0 0 0-1 0v.5a1 1 0 0 1-1 1h-.5a.5.5 0 0 0 0 1h.5a2 2 0 0 0 2-2zM9.5 16a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $bd5c6ab3f2a8957d$export$5a5bb5b6e7cdd8c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideHide24Filled', "24", [
    "M6.75 3A4.75 4.75 0 0 0 2 7.75v7C2 15.99 3 17 4.25 17h.25V8.75c0-1.8 1.46-3.25 3.25-3.25H19v-.25C19 4.01 18 3 16.75 3zm12.5 3.5h.5c1.2 0 2.17.93 2.24 2.1l.01.15v1a.75.75 0 0 1-1.5.1v-1.1c0-.38-.28-.7-.65-.74l-.1-.01h-.5a.75.75 0 0 1-.1-1.5zm-13 5c.38 0 .7.28.74.65l.01.1v2.5a.75.75 0 0 1-1.5.1v-2.6c0-.41.34-.75.75-.75m.74 5.64a.75.75 0 0 0-1.49.1v1.16a2.25 2.25 0 0 0 2.25 2.1h.6a.75.75 0 0 0-.1-1.5h-.6a.75.75 0 0 1-.65-.75v-1.1m15.01.1a.75.75 0 1 0-1.5 0v1.01c0 .41-.34.75-.75.75h-1a.75.75 0 0 0 0 1.5h1c1.24 0 2.25-1 2.25-2.25zM14.75 19h1.5a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5zm-2.5 0h-1.6a.75.75 0 0 0 .1 1.5h1.6a.75.75 0 0 0-.1-1.5m9.74-6.85a.75.75 0 0 0-1.49.1v2.6a.75.75 0 0 0 1.5-.1v-2.6M9.5 7.25a.75.75 0 0 0-.75-.75h-1c-1.24 0-2.25 1-2.25 2.25v1a.75.75 0 0 0 1.5 0v-1c0-.41.34-.75.75-.75h1c.42 0 .75-.34.75-.75m5.75-.75h1.5a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5zm-2.5 0h-1.6a.75.75 0 0 0 .1 1.5h1.6a.75.75 0 0 0-.1-1.5"
]);
const $bd5c6ab3f2a8957d$export$955cf43445670d7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideHide24Regular', "24", [
    "M6.75 3A4.75 4.75 0 0 0 2 7.75v7C2 15.99 3 17 4.25 17h.25v-1.5h-.25a.75.75 0 0 1-.75-.75v-7c0-1.8 1.46-3.25 3.25-3.25h10c.41 0 .75.34.75.75v.25H19v-.25C19 4.01 18 3 16.75 3zm12.5 3.5h.5c1.2 0 2.17.93 2.24 2.1l.01.15v1a.75.75 0 0 1-1.5.1v-1.1c0-.38-.28-.7-.65-.74l-.1-.01h-.5a.75.75 0 0 1-.1-1.5zm-13 5c.38 0 .7.28.74.65l.01.1v2.5a.75.75 0 0 1-1.5.1v-2.6c0-.41.34-.75.75-.75m.74 5.64a.75.75 0 0 0-1.49.1v1.16a2.25 2.25 0 0 0 2.25 2.1h.6a.75.75 0 0 0-.1-1.5h-.6a.75.75 0 0 1-.65-.75v-1.1m15.01.1a.75.75 0 1 0-1.5 0v1.01c0 .41-.34.75-.75.75h-1a.75.75 0 0 0 0 1.5h1c1.24 0 2.25-1 2.25-2.25zM14.75 19h1.5a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5zm-2.5 0h-1.6a.75.75 0 0 0 .1 1.5h1.6a.75.75 0 0 0-.1-1.5m9.74-6.85a.75.75 0 0 0-1.49.1v2.6a.75.75 0 0 0 1.5-.1v-2.6M9.5 7.25a.75.75 0 0 0-.75-.75h-1c-1.24 0-2.25 1-2.25 2.25v1a.75.75 0 0 0 1.5 0v-1c0-.41.34-.75.75-.75h1c.42 0 .75-.34.75-.75m5.75-.75h1.5a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5zm-2.5 0h-1.6a.75.75 0 0 0 .1 1.5h1.6a.75.75 0 0 0-.1-1.5"
]);
const $bd5c6ab3f2a8957d$export$8713a347ac33a5b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLayout20Filled', "20", [
    "M5.5 7h9c.28 0 .5.22.5.5V9H5V7.5c0-.28.22-.5.5-.5M7 10v3H5.5a.5.5 0 0 1-.5-.5V10zm7.5 3H8v-3h7v2.5a.5.5 0 0 1-.5.5m-10-9A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zm10 10h-9A1.5 1.5 0 0 1 4 12.5v-5C4 6.67 4.67 6 5.5 6h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$3dee11c93180d3c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLayout20Regular', "20", [
    "M5.5 14A1.5 1.5 0 0 1 4 12.5v-5C4 6.67 4.67 6 5.5 6h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5zm0-7a.5.5 0 0 0-.5.5V9h10V7.5a.5.5 0 0 0-.5-.5zM7 10H5v2.5c0 .28.22.5.5.5H7zm1 3h6.5a.5.5 0 0 0 .5-.5V10H8zM2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $bd5c6ab3f2a8957d$export$ac15cf80b42ca66c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLayout24Filled', "24", [
    "M6.5 8.75c0-.14.11-.25.25-.25h10.5q.23.02.25.25v1.75h-11zm0 3.25v3.25c0 .14.11.25.25.25H9V12zm10.75 3.5H10.5V12h7v3.25q-.02.23-.25.25M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM6.75 7C5.78 7 5 7.78 5 8.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C19 7.78 18.22 7 17.25 7z"
]);
const $bd5c6ab3f2a8957d$export$24a940d85f4d0cd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLayout24Regular', "24", [
    "M6.75 7C5.78 7 5 7.78 5 8.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C19 7.78 18.22 7 17.25 7zM6.5 8.75c0-.14.11-.25.25-.25h10.5q.23.02.25.25v1.75h-11zm4 3.25h7v3.25q-.02.23-.25.25H10.5zM9 12v3.5H6.75a.25.25 0 0 1-.25-.25V12zM4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM3.5 6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$8715a02c2ecf636e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLink20Filled', "20", [
    "M13 11.5a.5.5 0 0 1 0 1h-.5a1.5 1.5 0 0 0 0 3h.5a.5.5 0 0 1 0 1h-.5a2.5 2.5 0 0 1 0-5zm3.5 0a2.5 2.5 0 0 1 0 5H16a.5.5 0 0 1 0-1h.5a1.5 1.5 0 0 0 0-3H16a.5.5 0 0 1 0-1zM15 4a3 3 0 0 1 3 3v3.84a3.5 3.5 0 0 0-1.5-.34h-4A3.5 3.5 0 0 0 9.63 16H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm1.5 9.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
]);
const $bd5c6ab3f2a8957d$export$a278411bc1d35f65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLink20Regular', "20", [
    "M13 11.5a.5.5 0 0 1 0 1h-.5a1.5 1.5 0 0 0 0 3h.5a.5.5 0 0 1 0 1h-.5a2.5 2.5 0 0 1 0-5zm3.5 0a2.5 2.5 0 0 1 0 5H16a.5.5 0 0 1 0-1h.5a1.5 1.5 0 0 0 0-3H16a.5.5 0 0 1 0-1zM15 4a3 3 0 0 1 3 3v3.84a4 4 0 0 0-1-.3V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h4.15q.16.54.48 1H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm1.5 9.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
]);
const $bd5c6ab3f2a8957d$export$5cff187c7dc696b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLink24Filled', "24", [
    "M19.25 13.5a3.75 3.75 0 0 1 .2 7.5h-.2a.75.75 0 0 1-.1-1.49h.1v-.01a2.25 2.25 0 0 0 .15-4.5h-.15a.75.75 0 0 1-.1-1.5zm-3.5 0a.75.75 0 0 1 .1 1.5h-.1a2.25 2.25 0 0 0-.15 4.5h.15a.75.75 0 0 1 .1 1.5h-.1a3.75 3.75 0 0 1-.2-7.5zm3-9.5C20.55 4 22 5.46 22 7.25v6.13a4.7 4.7 0 0 0-2.75-.88h-3.5a4.75 4.75 0 0 0-3.87 7.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm.5 12.5a.75.75 0 0 1 .1 1.5h-3.6a.75.75 0 0 1-.1-1.5h3.6"
]);
const $bd5c6ab3f2a8957d$export$f565a2bc5d38200c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLink24Regular', "24", [
    "M19.25 13.5a3.75 3.75 0 0 1 .2 7.5h-.2a.75.75 0 0 1-.1-1.49h.1v-.01a2.25 2.25 0 0 0 .15-4.5h-.15a.75.75 0 0 1-.1-1.5zm-3.5 0a.75.75 0 0 1 .1 1.5h-.1a2.25 2.25 0 0 0-.15 4.5h.15a.75.75 0 0 1 .1 1.5h-.1a3.75 3.75 0 0 1-.2-7.5zm3-9.5C20.55 4 22 5.46 22 7.25v6.13a5 5 0 0 0-1.5-.71V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h5.92q.23.83.7 1.5H5.26A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4zm.5 12.5a.75.75 0 0 1 .1 1.5h-3.6a.75.75 0 0 1-.1-1.5h3.6"
]);
const $bd5c6ab3f2a8957d$export$ca73b88138b50d5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLink28Filled', "28", [
    "M18.25 18.5a.75.75 0 0 1 0 1.5h-.5a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5zm5 0a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5h.5a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5zm-1-14.5A3.75 3.75 0 0 1 26 7.75v10.63a4.7 4.7 0 0 0-2.75-.88h-5.5a4.75 4.75 0 0 0-4.42 6.5H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zm1 17.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$c778c9a490814b50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideLink28Regular', "28", [
    "M18.25 18.5a.75.75 0 0 1 0 1.5h-.5a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5zm5 0a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5h.5a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5zm-1-14.5A3.75 3.75 0 0 1 26 7.75v10.63a5 5 0 0 0-1.5-.71V7.75c0-1.24-1.01-2.25-2.25-2.25H5.75c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1 2.25 2.25 2.25h7.26q.04.8.32 1.5H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4zm1 17.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$1fd07bcd64538216 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMicrophone20Filled', "20", [
    "M18.5 13.5c.28 0 .5.22.5.5a4 4 0 0 1-3.5 3.97v.53a.5.5 0 0 1-1 0v-.53A4 4 0 0 1 11 14a.5.5 0 0 1 1 0 3 3 0 1 0 6 0c0-.28.22-.5.5-.5m-3-9.5A2.5 2.5 0 0 1 18 6.5V12a3 3 0 1 0-6 0v.59A1.5 1.5 0 0 0 10 14q0 1.08.42 2H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-.5 6a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2c0-1.1.9-2 2-2m-9.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0-2.5a.5.5 0 0 0 0 1H11a.5.5 0 0 0 0-1zm0-2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $bd5c6ab3f2a8957d$export$f2d65ab317e29f12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMicrophone20Regular', "20", [
    "M18.5 13.5c.28 0 .5.22.5.5a4 4 0 0 1-3.5 3.97v.53a.5.5 0 0 1-1 0v-.53A4 4 0 0 1 11 14a.5.5 0 0 1 1 0 3 3 0 1 0 6 0c0-.28.22-.5.5-.5m-3-9.5A2.5 2.5 0 0 1 18 6.5V12c0-.89-.39-1.68-1-2.23V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h5.6q.1.52.32 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-.5 6a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2c0-1.1.9-2 2-2m-5 2a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1 0-1zm1.5-2.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zM9.5 7a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
]);
const $bd5c6ab3f2a8957d$export$11f9e8e0e039f1e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMicrophone24Filled', "24", [
    "M22.25 16c.41 0 .75.34.75.75a4.75 4.75 0 0 1-4 4.69v.81a.75.75 0 0 1-1.5 0v-.81a4.75 4.75 0 0 1-4-4.69.75.75 0 0 1 1.5 0 3.25 3.25 0 0 0 6.5 0c0-.41.34-.75.75-.75m-3-12A2.75 2.75 0 0 1 22 6.75v8.27q-.26.04-.5.15v-.92a3.25 3.25 0 0 0-6.5 0v.92a1.74 1.74 0 0 0-2.5 1.58c0 1.2.37 2.33 1 3.25H4.76A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4zm-1 8c1.24 0 2.25 1 2.25 2.25v2.5a2.25 2.25 0 0 1-4.5 0v-2.5c0-1.24 1-2.25 2.25-2.25m-11.5 2a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm0-3a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm0-3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$fdbc70c537f9d0bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMicrophone24Regular', "24", [
    "M22.25 16c.41 0 .75.34.75.75a4.75 4.75 0 0 1-4 4.69v.81a.75.75 0 0 1-1.5 0v-.81a4.75 4.75 0 0 1-4-4.69.75.75 0 0 1 1.5 0 3.25 3.25 0 0 0 6.5 0c0-.41.34-.75.75-.75m-3-12A2.75 2.75 0 0 1 22 6.75v8.27q-.26.04-.5.15v-.92c0-.92-.38-1.75-1-2.34V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h8.02q.26.81.74 1.5H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4zm-1 8c1.24 0 2.25 1 2.25 2.25v2.5a2.25 2.25 0 0 1-4.5 0v-2.5c0-1.24 1-2.25 2.25-2.25m-6 2a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5zm2-3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm-3-3a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5z"
]);
const $bd5c6ab3f2a8957d$export$3e35891caf648a4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMicrophone32Filled', "32", [
    "M29.5 21a1 1 0 0 1 1 1 6.5 6.5 0 0 1-5.5 6.42v1.08a1 1 0 1 1-2 0v-1.08A6.5 6.5 0 0 1 17.5 22a1 1 0 1 1 2 0 4.5 4.5 0 1 0 9 0 1 1 0 0 1 1-1m-4-17A4.5 4.5 0 0 1 30 8.5v11.05a2.5 2.5 0 0 0-1.5.16V18.5a4.5 4.5 0 1 0-9 0v1.2A2.5 2.5 0 0 0 16 22c0 2.4 1.05 4.53 2.71 6H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM24 15.5a3 3 0 0 1 3 3V22a3 3 0 1 1-6 0v-3.5a3 3 0 0 1 3-3M9 20a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm0-5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm0-5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $bd5c6ab3f2a8957d$export$e722a324f2a7c0c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMicrophone32Regular', "32", [
    "M29.5 21a1 1 0 0 1 1 1 6.5 6.5 0 0 1-5.5 6.42v1.08a1 1 0 1 1-2 0v-1.08A6.5 6.5 0 0 1 17.5 22a1 1 0 1 1 2 0 4.5 4.5 0 1 0 9 0 1 1 0 0 1 1-1m-4-17A4.5 4.5 0 0 1 30 8.5v11.05a2.5 2.5 0 0 0-1.5.16V18.5q-.01-1.12-.5-2.06V8.5A2.5 2.5 0 0 0 25.5 6h-19A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h10.57q.67 1.13 1.64 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM24 15.5a3 3 0 0 1 3 3V22a3 3 0 1 1-6 0v-3.5a3 3 0 0 1 3-3M15 20a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm3-5a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm-2-5a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2z"
]);
const $bd5c6ab3f2a8957d$export$1d15d2e95a209fdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultiple16Filled', "16", [
    "M13.25 5c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75h-7.5C4.78 14 4 13.22 4 12.25v-5.5C4 5.78 4.78 5 5.75 5zm-3-3c.97 0 1.75.78 1.75 1.75V4H5.75A2.75 2.75 0 0 0 3 6.75V11h-.25C1.78 11 1 10.22 1 9.25v-3.5A3.75 3.75 0 0 1 4.75 2z"
]);
const $bd5c6ab3f2a8957d$export$b0cbd12d71c6b3fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultiple16Regular', "16", [
    "M13.25 5c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75h-7.5C4.78 14 4 13.22 4 12.25v-5.5C4 5.78 4.78 5 5.75 5zm-7.5 1a.75.75 0 0 0-.75.75v5.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 0 0-.75-.75zm4.5-4c.97 0 1.75.78 1.75 1.75V4h-1v-.25a.75.75 0 0 0-.75-.75h-5.5A2.75 2.75 0 0 0 2 5.75v3.5c0 .41.34.75.75.75H3v1h-.25C1.78 11 1 10.22 1 9.25v-3.5A3.75 3.75 0 0 1 4.75 2z"
]);
const $bd5c6ab3f2a8957d$export$f779a119f286e0d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultiple20Filled', "20", [
    "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
]);
const $bd5c6ab3f2a8957d$export$d0a560c2af9c24c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultiple20Regular', "20", [
    "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2v-1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM6 8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $bd5c6ab3f2a8957d$export$fff9ff6eaf9ddc31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultiple24Filled', "24", [
    "M2 7.75A4.75 4.75 0 0 1 6.75 3h10C17.99 3 19 4 19 5.25v.25H7.75A3.25 3.25 0 0 0 4.5 8.75V17h-.25C3.01 17 2 16 2 14.75zM7.75 6.5c-1.24 0-2.25 1-2.25 2.25v9.5c0 1.24 1 2.25 2.25 2.25h12c1.24 0 2.25-1 2.25-2.25v-9.5c0-1.24-1-2.25-2.25-2.25z"
]);
const $bd5c6ab3f2a8957d$export$9bbea2f762a0ed87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultiple24Regular', "24", [
    "M6.75 3A4.75 4.75 0 0 0 2 7.75v7C2 15.99 3 17 4.25 17h.25v-1.5h-.25a.75.75 0 0 1-.75-.75v-7c0-1.8 1.46-3.25 3.25-3.25h10c.41 0 .75.34.75.75v.25H19v-.25C19 4.01 18 3 16.75 3zm1 3.5c-1.24 0-2.25 1-2.25 2.25v9.5c0 1.24 1 2.25 2.25 2.25h12c1.24 0 2.25-1 2.25-2.25v-9.5c0-1.24-1-2.25-2.25-2.25zM7 8.75c0-.41.34-.75.75-.75h12c.41 0 .75.34.75.75v9.5c0 .41-.34.75-.75.75h-12a.75.75 0 0 1-.75-.75z"
]);
const $bd5c6ab3f2a8957d$export$25c246d7d1838d03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleArrowRight20Filled', "20", [
    "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.6q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V8a2 2 0 0 0-2-2zm7.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $bd5c6ab3f2a8957d$export$b6feabc5662cfc1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleArrowRight20Regular', "20", [
    "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2v-1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.6q-.24-.48-.4-1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1.6q.54.27 1 .66V8a2 2 0 0 0-2-2zm7.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $bd5c6ab3f2a8957d$export$1e9d537df67c7604 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleArrowRight24Filled', "24", [
    "M2 7.75A4.75 4.75 0 0 1 6.75 3h10C17.99 3 19 4 19 5.25v.25H7.75A3.25 3.25 0 0 0 4.5 8.75V17h-.25C3.01 17 2 16 2 14.75zM7.75 6.5c-1.24 0-2.25 1-2.25 2.25v9.5c0 1.24 1 2.25 2.25 2.25h3.98A6.5 6.5 0 0 1 22 12.81V8.75c0-1.24-1-2.25-2.25-2.25zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $bd5c6ab3f2a8957d$export$fe1bf3932c43856f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleArrowRight24Regular', "24", [
    "M6.75 3A4.75 4.75 0 0 0 2 7.75v7C2 15.99 3 17 4.25 17h.25v-1.5h-.25a.75.75 0 0 1-.75-.75v-7c0-1.8 1.46-3.25 3.25-3.25h10c.41 0 .75.34.75.75v.25H19v-.25C19 4.01 18 3 16.75 3zm1 3.5c-1.24 0-2.25 1-2.25 2.25v9.5c0 1.24 1 2.25 2.25 2.25h3.98a7 7 0 0 1-.56-1.5H7.75a.75.75 0 0 1-.75-.75v-9.5c0-.41.34-.75.75-.75h12c.41 0 .75.34.75.75v2.98q.83.44 1.5 1.08V8.75c0-1.24-1-2.25-2.25-2.25zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $bd5c6ab3f2a8957d$export$d21ce1a442359200 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleSearch20Filled', "20", [
    "M6 3a4 4 0 0 0-4 4v2.76q.89-.6 2-.73V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2zm10 14h-5.88l-1.56-1.56q.43-.9.44-1.94a4.5 4.5 0 0 0-4-4.47V8c0-1.1.9-2 2-2h9a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$c19379a851b4684c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleSearch20Regular', "20", [
    "M6 3a4 4 0 0 0-4 4v2.76q.46-.31 1-.5V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm10 14h-5.88l-1-1H16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1.26a5 5 0 0 0-1-.23V8c0-1.1.9-2 2-2h9a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$387c09bb98b13da0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleSearch24Filled', "24", [
    "M2 7.75A4.75 4.75 0 0 1 6.75 3h10C17.99 3 19 4 19 5.25v.25H7.75A3.25 3.25 0 0 0 4.5 8.75v2.34q-1.43.27-2.5 1.17zm8.43 11.2 1.54 1.55h7.78c1.24 0 2.25-1 2.25-2.25v-9.5c0-1.24-1-2.25-2.25-2.25h-12c-1.24 0-2.25 1-2.25 2.25V11a5.5 5.5 0 0 1 4.93 7.95M5.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $bd5c6ab3f2a8957d$export$243ad9e3e831577c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideMultipleSearch24Regular', "24", [
    "M6.75 3A4.75 4.75 0 0 0 2 7.75v4.5a6 6 0 0 1 1.5-.88V7.75c0-1.8 1.46-3.25 3.25-3.25h10c.41 0 .75.34.75.75v.25H19v-.25C19 4.01 18 3 16.75 3zm13 17.5h-7.78l-1.5-1.5h9.28c.41 0 .75-.34.75-.75v-9.5a.75.75 0 0 0-.75-.75h-12a.75.75 0 0 0-.75.75v2.46A6 6 0 0 0 5.5 11V8.75c0-1.24 1-2.25 2.25-2.25h12c1.24 0 2.25 1 2.25 2.25v9.5c0 1.24-1 2.25-2.25 2.25M5.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 21m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $bd5c6ab3f2a8957d$export$5e197de413fd9331 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlidePlay20Filled', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h4.46A5.5 5.5 0 0 1 18 10.26V6.75A2.75 2.75 0 0 0 15.25 4zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M13 16c0 .38.42.62.76.42l2.5-1.5a.5.5 0 0 0 0-.85l-2.5-1.5A.5.5 0 0 0 13 13z"
]);
const $bd5c6ab3f2a8957d$export$5a74607dcde231a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlidePlay20Regular', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h4.46q-.15-.49-.19-1H4.75C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V9.6q.54.27 1 .66V6.75A2.75 2.75 0 0 0 15.25 4zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M13 16c0 .38.42.62.76.42l2.5-1.5a.5.5 0 0 0 0-.85l-2.5-1.5A.5.5 0 0 0 13 13z"
]);
const $bd5c6ab3f2a8957d$export$32732e94b5fa74c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlidePlay24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v6.06A6.5 6.5 0 0 0 11.5 20H4.75A2.75 2.75 0 0 1 2 17.25zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7 2c0 .4.44.64.78.42l3-2a.5.5 0 0 0 0-.84l-3-2a.5.5 0 0 0-.78.42z"
]);
const $bd5c6ab3f2a8957d$export$3476a3a46f5cdea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlidePlay24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75q-.3-.71-.42-1.5H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v4.98q.83.44 1.5 1.08V6.75A2.75 2.75 0 0 0 19.25 4zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7 2c0 .4.44.64.78.42l3-2a.5.5 0 0 0 0-.84l-3-2a.5.5 0 0 0-.78.42z"
]);
const $bd5c6ab3f2a8957d$export$22452725e8be462b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord16Filled', "16", [
    "M3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h2.6a5.5 5.5 0 0 1-.58-3H4.5a.5.5 0 0 1 0-1h.7q.16-.52.4-1H4.5a.5.5 0 0 1 0-1h1.76q.46-.58 1.08-1H4.5a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .49.6A5.5 5.5 0 0 1 15 7.35V5a2 2 0 0 0-2-2zm7.5 11a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m0 1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $bd5c6ab3f2a8957d$export$2570b03f9910f60f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord16Regular', "16", [
    "M4 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 .49.6 6 6 0 0 0-.65.4H4.5a.5.5 0 0 1-.5-.5M6.26 7H4.5a.5.5 0 0 0 0 1h1.1q.27-.55.66-1M5.2 9H4.5a.5.5 0 0 0 0 1h.52q.05-.52.19-1m0 3H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.26q.58.46 1 1.08V5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h2.6q-.24-.48-.4-1m5.29 2a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m0 1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$322d8b3a5d58fb25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7a5.5 5.5 0 0 1 0-3H5.5a.5.5 0 0 1 0-1h4.1q.44-.85 1.13-1.5H5.5a.5.5 0 0 1 0-1h6.7a5.5 5.5 0 0 1 5.8.76V6.5A2.5 2.5 0 0 0 15.5 4zM5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M14.5 18a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m0 1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $bd5c6ab3f2a8957d$export$f3ec61431eb86c46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord20Regular', "20", [
    "M5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M5 10c0-.28.22-.5.5-.5h6.7q-.82.39-1.47 1H5.5A.5.5 0 0 1 5 10m4.6 2H5.5a.5.5 0 0 0 0 1h3.7q.16-.52.4-1m-.58 3H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v3.1q.54.27 1 .66V6.5A2.5 2.5 0 0 0 15.5 4h-11A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7q-.13-.49-.18-1m5.48 3a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m0 1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $bd5c6ab3f2a8957d$export$96b13d59dde51fc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75a6.5 6.5 0 0 1-.19-4.5H6.75a.75.75 0 0 1 0-1.5h5.27q.54-.86 1.33-1.5h-6.6a.75.75 0 0 1 0-1.5h8.5q.32.01.54.23A6.5 6.5 0 0 1 22 12.8V6.75A2.75 2.75 0 0 0 19.25 4zM6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75M17.5 21.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0 1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $bd5c6ab3f2a8957d$export$d882927ccd46c85b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord24Regular', "24", [
    "M6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75M6.75 11a.75.75 0 0 0 0 1.5h6.6a6.5 6.5 0 0 1 2.44-1.27.8.8 0 0 0-.54-.23zm13.75.73V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h6.33q.12.79.42 1.5H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v6.06a7 7 0 0 0-1.5-1.08M12.02 14q-.45.7-.7 1.5H6.74a.75.75 0 0 1 0-1.5zm5.48 7.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0 1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
]);
const $bd5c6ab3f2a8957d$export$fd6259eeda25fc1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h8.12a7.5 7.5 0 0 1-.6-5.5H7.73a.73.73 0 0 1-.73-.73v-.04c0-.4.33-.73.73-.73h6.14A7.5 7.5 0 0 1 16 14.5H7.73a.73.73 0 0 1-.73-.73v-.04c0-.4.33-.73.73-.73h10.54q.3.01.5.2A7.5 7.5 0 0 1 26 15.4V7.75A3.75 3.75 0 0 0 22.25 4zM7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zM20.5 25.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0 1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0-3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
]);
const $bd5c6ab3f2a8957d$export$3668a002c2013733 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord28Regular', "28", [
    "M7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 4c0-.4.33-.73.73-.73h10.54q.3.01.5.2A7.5 7.5 0 0 0 16 14.5H7.73a.73.73 0 0 1-.73-.73zM13.87 17H7.73c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h5.54q.22-.8.6-1.5m-.6 5.5H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25h16.5c1.24 0 2.25 1 2.25 2.25v6.4q.83.53 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h8.12a8 8 0 0 1-.6-1.5m7.23 3a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0 1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0-3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
]);
const $bd5c6ab3f2a8957d$export$418576c6c6448bcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord48Filled', "48", [
    "M8.75 8A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40H23a13 13 0 0 1-.52-8.5h-9.23a1.25 1.25 0 1 1 0-2.5h10.21q1.22-2.33 3.23-4H13.25a1.25 1.25 0 1 1 0-2.5h17.5q.22 0 .42.07A13 13 0 0 1 44 25.62V12.75A4.75 4.75 0 0 0 39.25 8zM12 17.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25M35 43.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17m0 2.5a11 11 0 1 0 0-22 11 11 0 0 0 0 22m0-5a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
]);
const $bd5c6ab3f2a8957d$export$9183ff21e6dff74d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideRecord48Regular', "48", [
    "M12 17.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25m1.25 5.25a1.25 1.25 0 1 0 0 2.5h13.44a13 13 0 0 1 4.48-2.43 1 1 0 0 0-.42-.07zm0 6.5h10.21q-.61 1.19-.98 2.5h-9.23a1.25 1.25 0 1 1 0-2.5m-4.5 8.5h13.49q.25 1.3.76 2.5H8.75A4.75 4.75 0 0 1 4 35.25v-22.5A4.75 4.75 0 0 1 8.75 8h30.5A4.75 4.75 0 0 1 44 12.75v12.87q-1.14-1.09-2.5-1.88V12.75c0-1.24-1-2.25-2.25-2.25H8.75c-1.24 0-2.25 1-2.25 2.25v22.5c0 1.24 1 2.25 2.25 2.25m26.25 6a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17m0 2.5a11 11 0 1 0 0-22 11 11 0 0 0 0 22m6-11a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
]);
const $bd5c6ab3f2a8957d$export$2beddc469dc9acd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v6a2.5 2.5 0 0 1-2.5 2.5H9.12l-.56-.56A4.5 4.5 0 0 0 8.97 10h1.53a.5.5 0 0 0 0-1H8.74q-.19-.54-.5-1h3.26a.5.5 0 0 0 0-1H7.33c-.77-.63-1.76-1-2.83-1h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1A4.5 4.5 0 0 0 1 7.67zM4.5 14c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 12.6A3.5 3.5 0 1 0 4.5 14m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$e9c97c825cfb80f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch16Regular', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v3.17q.43-.53 1-.91V4.5C2 3.67 2.67 3 3.5 3h9c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5H8.74q-.08.23-.18.44l.56.56h3.38a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 2zm3.83 5q.53.43.91 1h3.26a.5.5 0 0 0 0-1zm1.41 2q.18.48.23 1h1.53a.5.5 0 0 0 0-1zM7.5 6h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1m-3 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 12.6A3.5 3.5 0 1 0 4.5 14m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$adde18b17b7f79cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-5.38l-1.56-1.56q.33-.67.41-1.44h3.53a.5.5 0 0 0 0-1H8.97a5 5 0 0 0-.44-1.5h5.97a.5.5 0 0 0 0-1H7.85A4.5 4.5 0 0 0 2 8.76zm3.5.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-1 9c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 14.6A3.5 3.5 0 1 0 4.5 16m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$34deaad134327a5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch20Regular', "20", [
    "M5.5 7a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm3.03 3.5a5 5 0 0 0-.68-1h6.65a.5.5 0 0 1 0 1zm.47 2q0 .26-.03.5h3.53a.5.5 0 0 0 0-1H8.97q.03.24.03.5m-6-6v1.76q-.54.19-1 .5V6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-5.38l-1-1h6.38c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5M4.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 14.6A3.5 3.5 0 1 0 4.5 16m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $bd5c6ab3f2a8957d$export$27e4c0b53d83ec82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20h-6.78l-2.04-2.05q.55-1.12.57-2.45h4.25a.75.75 0 0 0 0-1.5h-4.46a6 6 0 0 0-.68-1.5h7.14a.75.75 0 0 0 0-1.5H8.66a5.5 5.5 0 0 0-6.66.26zM6.75 8a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM5.5 20c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 20m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $bd5c6ab3f2a8957d$export$3c79488c40e36886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v4.5a6 6 0 0 1 1.5-.88V6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25h-8.28l1.5 1.5h6.78A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zm3.91 7q.88.6 1.45 1.5h7.14a.75.75 0 0 0 0-1.5zm6.59 4.5H11a6 6 0 0 0-.2-1.5h4.45a.75.75 0 0 1 0 1.5M6.75 8a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM5.5 20c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 5.5 20m0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
]);
const $bd5c6ab3f2a8957d$export$24c86971a5b47a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch28Filled', "28", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v6.56A6.5 6.5 0 0 1 9.97 13h10.28a.75.75 0 0 1 0 1.5h-8.63q.87 1.1 1.2 2.5h5.43a.75.75 0 0 1 0 1.5H13q-.02 1.76-.84 3.19L14.47 24h8.28c1.8 0 3.25-1.45 3.25-3.25V7.25C26 5.45 24.55 4 22.75 4zM7 9.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 9.75m3.88 12.07a5.5 5.5 0 1 0-1.06 1.06l2.9 2.9a.75.75 0 1 0 1.06-1.06zm-.38-3.32a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
]);
const $bd5c6ab3f2a8957d$export$6a2f0a0bd266687d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch28Regular', "28", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h17.5C24.55 4 26 5.46 26 7.25v13.5c0 1.8-1.45 3.25-3.25 3.25h-8.28l-1.5-1.5h9.78c.97 0 1.75-.78 1.75-1.75V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.96 0-1.75.78-1.75 1.75v5.48q-.82.44-1.5 1.08zm9.62 7.25A7 7 0 0 0 9.97 13h10.28a.75.75 0 0 1 0 1.5zm1.38 4h5.25a.75.75 0 0 0 0-1.5h-5.42q.17.72.17 1.5M7 9.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7 9.75m3.88 12.07a5.5 5.5 0 1 0-1.06 1.06l2.9 2.9a.75.75 0 1 0 1.06-1.06zm-.38-3.32a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
]);
const $bd5c6ab3f2a8957d$export$f97ca06f2d06e9a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-9q-.1-.14-.23-.27l-2.5-2.5q.72-1.48.73-3.23H19a1 1 0 1 0 0-2h-4.77a7.5 7.5 0 0 0-1.64-3H22a1 1 0 1 0 0-2H9.7A7.5 7.5 0 0 0 2 16.41zM8 11a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1M7 28c1.3 0 2.5-.41 3.48-1.1l3.31 3.3a1 1 0 0 0 1.42-1.4l-3.32-3.32A6 6 0 1 0 7 28m0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $bd5c6ab3f2a8957d$export$5619e9e24b402ff2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSearch32Regular', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5v7.91a8 8 0 0 1 2-1.29V8.5A2.5 2.5 0 0 1 6.5 6h19A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5H14.54l1.73 1.73.23.27h9a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4zm3.2 11a7.5 7.5 0 0 1 2.89 2H22a1 1 0 1 0 0-2zm9.3 7h-4.5q0-1.04-.27-2H19a1 1 0 1 1 0 2M8 11a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M7 28c1.3 0 2.5-.41 3.48-1.1l3.31 3.3a1 1 0 0 0 1.42-1.4l-3.32-3.32A6 6 0 1 0 7 28m0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $bd5c6ab3f2a8957d$export$bf135e2aa2562e0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSettings20Filled', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h4.46A5.5 5.5 0 0 1 18 10.26V6.75A2.75 2.75 0 0 0 15.25 4zm7.32 7.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $bd5c6ab3f2a8957d$export$6fbcc796e02126a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSettings20Regular', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.5a6 6 0 0 0-1-.65V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h4.27q.05.51.19 1H4.75A2.75 2.75 0 0 1 2 13.25zm10.07 4.7a2 2 0 0 1-1.44 2.47l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.05a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $bd5c6ab3f2a8957d$export$1f9306d95d5b72a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSettings24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25A6.5 6.5 0 0 1 22 12.81V7.25C22 5.45 20.54 4 18.75 4zm9.03 9.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.59-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $bd5c6ab3f2a8957d$export$75ecfd21574a4150 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSettings24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a7 7 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h5.83q.12.79.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75zm12.28 6.73a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.59-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $bd5c6ab3f2a8957d$export$ac54d1017098dc10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSize20Filled', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zm9-.25c0 .28.22.5.5.5h.8l-1.65 1.65a.5.5 0 0 0 .7.7L13 7.71v.79a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m-1.65 4.15a.5.5 0 0 0-.7 0L7 12.29v-.79a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-.8l1.65-1.65a.5.5 0 0 0 0-.7"
]);
const $bd5c6ab3f2a8957d$export$b0429b0392614c48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSize20Regular', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5zM11 6.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-.8l-1.65 1.65a.5.5 0 0 1-.7-.7L12.29 7h-.79a.5.5 0 0 1-.5-.5m-2.35 4.15a.5.5 0 0 1 .7.7L7.71 13h.79a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v.8z"
]);
const $bd5c6ab3f2a8957d$export$edf58fb3713583d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSize24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zm14.78.47a.8.8 0 0 0-.53-.22h-2.5a.75.75 0 0 0 0 1.5h.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72v.69a.75.75 0 0 0 1.5 0v-2.5q0-.31-.22-.53M7.75 17h2.5a.75.75 0 0 0 0-1.5h-.69l1.72-1.72a.75.75 0 0 0-1.06-1.06L8.5 14.44v-.69a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 .75.75"
]);
const $bd5c6ab3f2a8957d$export$c38ccb9cb9c6371 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideSize24Regular', "24", [
    "M16.78 7.22q.21.22.22.53v2.5a.75.75 0 0 1-1.5 0v-.69l-1.72 1.72a.75.75 0 1 1-1.06-1.06l1.72-1.72h-.7a.75.75 0 0 1 0-1.5h2.51q.31 0 .53.22M7 16.25a.75.75 0 0 0 .75.75h2.5a.75.75 0 0 0 0-1.5h-.69l1.72-1.72a.75.75 0 0 0-1.06-1.06L8.5 14.44v-.69a.75.75 0 0 0-1.5 0zm-5-9.5A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $bd5c6ab3f2a8957d$export$7148b930782dbdc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText16Filled', "16", [
    "M1 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm3.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 7.5c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5M4.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$19fe3030c8619dd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText16Regular', "16", [
    "M4.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 7.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M4.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM2 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$997480eb74d42069 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m.5 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$98a215d1e0ce0dc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText20Regular', "20", [
    "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm-.5 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$9b7a9d7d17fa32a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zM6.75 8a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM6 14.75c0 .41.34.75.75.75h6.5a.75.75 0 0 0 0-1.5h-6.5a.75.75 0 0 0-.75.75"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$1287d01e5817f51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText24Regular', "24", [
    "M6.75 8a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM6 11.75c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75M6.75 14a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm-2-10A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM3.5 6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$7b164ba4bf331d7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25zM7.73 9c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h5.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zM7 13.73v.04c0 .4.33.73.73.73h10.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73H7.73c-.4 0-.73.33-.73.73M7.73 17c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h7.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$9ee6cdd68d6b82c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText28Regular', "28", [
    "M7.73 9c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h5.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zm0 4c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h10.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zM7 17.73c0-.4.33-.73.73-.73h7.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73zM5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4zM3.5 7.75c0-1.24 1.01-2.25 2.25-2.25h16.5c1.24 0 2.25 1 2.25 2.25v12.5c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$7a1298afc530d4eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText32Filled', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zM9 20a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm0-5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2zm0-5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z"
]);
const $bd5c6ab3f2a8957d$export$769f3aeedecd6b53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText32Regular', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4zm-19 2A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6zM19 20a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm3-5a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm-6-5a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2z"
]);
const $bd5c6ab3f2a8957d$export$af16cc18427cc81d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText48Filled', "48", [
    "M4 12.75A4.75 4.75 0 0 1 8.75 8h30.5A4.75 4.75 0 0 1 44 12.75v22.5A4.75 4.75 0 0 1 39.25 40H8.75A4.75 4.75 0 0 1 4 35.25zm9.25 9.75a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zM12 30.25c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25M13.25 16a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$e7ad40bb9e6b7545 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideText48Regular', "48", [
    "M12 17.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25m1.25 5.25a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zm0 6.5a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM8.75 8A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.75 4.75 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8zM6.5 12.75c0-1.24 1-2.25 2.25-2.25h30.5c1.24 0 2.25 1 2.25 2.25v22.5c0 1.24-1 2.25-2.25 2.25H8.75c-1.24 0-2.25-1-2.25-2.25z"
], {
    flipInRtl: true
});
const $bd5c6ab3f2a8957d$export$fa54751794a8c233 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall16Filled', "16", [
    "M1 5c0-1.1.9-2 2-2h10a2 2 0 0 1 1.79 1.1 2.3 2.3 0 0 0-2.86 1.38l-.28.75c-.28.72-.1 1.53.46 2.07l.51.51q-.15.66-.7 1.12l-.8-.18c-.72-.18-1.5.06-2 .62l-.55.61a2.2 2.2 0 0 0-.5 2.02H3a2 2 0 0 1-2-2zm3.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 7.5c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5M4.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm8.08-2.42.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $bd5c6ab3f2a8957d$export$8e6f7e1d7d83c1df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall16Regular', "16", [
    "M4.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 7.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M4.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h5.07a2 2 0 0 1-.02-1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 .43.1q.66-.2 1.36 0A2 2 0 0 0 13 3zm9.58 3.58.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $bd5c6ab3f2a8957d$export$dbfa1603768c85c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v.68c-1.19-.5-2.6.07-3.07 1.3l-.28.75c-.28.72-.1 1.53.46 2.07l.51.51q-.15.66-.7 1.12l-.8-.18c-.72-.18-1.5.06-2 .62l-.55.61a2.2 2.2 0 0 0-.5 2.02H4.5A2.5 2.5 0 0 1 2 13.5zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m.5 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm10.08-2.42.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $bd5c6ab3f2a8957d$export$c3dbba32fada0f8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall20Regular', "20", [
    "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm-.5 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h6.57a2 2 0 0 1-.02-1H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5V7q.5-.01 1 .18V6.5A2.5 2.5 0 0 0 15.5 4zm11.08 5.58.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $bd5c6ab3f2a8957d$export$89ccc1a8794988f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h9.4a2.3 2.3 0 0 1 .34-2.2l.8-1.01a2.2 2.2 0 0 1 2.23-.77l.84.2q.77-.64.95-1.64l-.6-.63a2.2 2.2 0 0 1-.45-2.32l.48-1.2a2.25 2.25 0 0 1 2.78-1.32l.44.14.04.02V6.75A2.75 2.75 0 0 0 19.25 4zM6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75m0 3c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 3.75a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5zM19.19 12l.48-1.21c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.8 3.8 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28"
]);
const $bd5c6ab3f2a8957d$export$6120e5240b38ca56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall24Regular', "24", [
    "M6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75M6.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM6 14.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m-4-8A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v2.52l-.04-.02-.44-.14q-.52-.16-1.02-.09V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h9.36q-.24.77.04 1.5h-9.4A2.75 2.75 0 0 1 2 17.25zm17.2 5.24.47-1.2c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.8 3.8 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28"
]);
const $bd5c6ab3f2a8957d$export$df42e382e473636d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v3.76l-.1-.05-.45-.2a2.7 2.7 0 0 0-3.69 1.57l-.41 1.2c-.29.82-.08 1.74.52 2.37l.95.98a3.3 3.3 0 0 1-1.26 2.24l-1.29-.34a2.3 2.3 0 0 0-2.32.73l-.8.96A2.8 2.8 0 0 0 16.8 24H5.75A3.75 3.75 0 0 1 2 20.25zM7.73 9c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h5.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zM7 13.73v.04c0 .4.33.73.73.73h10.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73H7.73c-.4 0-.73.33-.73.73M7.73 17c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h7.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zm14.56-2.65.42-1.2a1.7 1.7 0 0 1 2.32-1l.45.21c.72.34 1.33.94 1.45 1.74.58 3.91-2.49 9.32-6.1 10.77-.75.3-1.56.06-2.21-.41l-.4-.3a1.76 1.76 0 0 1-.31-2.54l.8-.96c.33-.38.83-.54 1.3-.42l1.75.46a4.4 4.4 0 0 0 2.1-3.69l-1.27-1.3a1.3 1.3 0 0 1-.3-1.36"
]);
const $bd5c6ab3f2a8957d$export$b565997759fc53a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall28Regular', "28", [
    "M7.73 9c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h5.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zm0 4c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h10.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zM7 17.73c0-.4.33-.73.73-.73h7.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73zM5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24H16.8a3 3 0 0 1-.29-1.5H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25h16.5c1.24 0 2.25 1 2.25 2.25v3.26q.48.03.95.24l.45.2.1.06V7.75A3.75 3.75 0 0 0 22.25 4zM22.3 14.35l.42-1.2a1.7 1.7 0 0 1 2.32-1l.45.21c.72.34 1.33.94 1.45 1.74.58 3.91-2.49 9.32-6.1 10.77-.75.3-1.56.06-2.21-.41l-.4-.3a1.76 1.76 0 0 1-.31-2.54l.8-.96c.33-.38.83-.54 1.3-.42l1.75.46a4.4 4.4 0 0 0 2.1-3.69l-1.27-1.3a1.3 1.3 0 0 1-.3-1.36"
]);
const $bd5c6ab3f2a8957d$export$5634c9c6683e4112 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall48Filled', "48", [
    "M4 12.75A4.75 4.75 0 0 1 8.75 8h30.5A4.75 4.75 0 0 1 44 12.75v5.92l-.47-.22a4.86 4.86 0 0 0-6.65 2.86l-.7 2.02a4.3 4.3 0 0 0 .95 4.32l1.5 1.55a5.3 5.3 0 0 1-1.87 3.35l-2.01-.53a4.1 4.1 0 0 0-4.23 1.35l-1.36 1.62a5 5 0 0 0-.82 5.01H8.75A4.75 4.75 0 0 1 4 35.25zm9.25 9.75a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zM12 30.25c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25M13.25 16a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zm24.82 7.98.7-2.02a2.86 2.86 0 0 1 3.92-1.7l.75.36c1.22.57 2.24 1.58 2.44 2.93.98 6.63-4.2 15.78-10.28 18.23-1.25.5-2.62.1-3.71-.7l-.67-.49a3 3 0 0 1-.53-4.31l1.36-1.63a2.1 2.1 0 0 1 2.19-.7l2.94.78a7.5 7.5 0 0 0 3.52-6.25l-2.12-2.22c-.59-.6-.78-1.49-.5-2.28"
]);
const $bd5c6ab3f2a8957d$export$697f1b24af6dec15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCall48Regular', "48", [
    "M12 17.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25m1.25 5.25a1.25 1.25 0 1 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5zm0 6.5a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM8.75 8A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h19.6q-.48-1.22-.3-2.5H8.75c-1.24 0-2.25-1-2.25-2.25v-22.5c0-1.24 1-2.25 2.25-2.25h30.5c1.24 0 2.25 1 2.25 2.25V18q1.03 0 2.03.45l.47.22v-5.92A4.75 4.75 0 0 0 39.25 8zm29.32 15.98.7-2.02a2.86 2.86 0 0 1 3.92-1.7l.75.36c1.22.57 2.24 1.58 2.44 2.93.98 6.63-4.2 15.78-10.28 18.23-1.25.5-2.62.1-3.71-.7l-.67-.49a3 3 0 0 1-.53-4.31l1.36-1.63a2.1 2.1 0 0 1 2.19-.7l2.94.78a7.5 7.5 0 0 0 3.52-6.25l-2.12-2.22c-.59-.6-.78-1.49-.5-2.28"
]);
const $bd5c6ab3f2a8957d$export$2773c1e360193ca8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCursor20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v6.33l-4.44-4.4A1.5 1.5 0 0 0 11 9.5H5.5a.5.5 0 0 0 0 1H11V16H4.5A2.5 2.5 0 0 1 2 13.5zm3.5.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.36-2.85a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $bd5c6ab3f2a8957d$export$2edb5f7fe788d86b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCursor20Regular', "20", [
    "M5.5 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1H11v-1zm-1 5.5H11v1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v6.33l-1-.99V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5m.5-2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.86-3.35a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $bd5c6ab3f2a8957d$export$cef975e401b117c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCursor24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v9.31l-4.95-5.48a1.75 1.75 0 0 0-2.88.42H6.75a.75.75 0 0 0 0 1.5H14V20H4.75A2.75 2.75 0 0 1 2 17.25zM6.75 8a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM6 14.75c0 .41.34.75.75.75h5.5a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 0-.75.75m9.49-3.7a.8.8 0 0 1 .82.2l6.37 7.06a.75.75 0 0 1-.74 1.23l-3.54-.88-2.03 3.01a.75.75 0 0 1-1.37-.42v-9.5c0-.31.2-.59.49-.7"
]);
const $bd5c6ab3f2a8957d$export$c72f51eb80645422 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextCursor24Regular', "24", [
    "M6.75 8a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM6 11.75c0-.41.34-.75.75-.75h7.42q-.16.34-.17.75v.75H6.75a.75.75 0 0 1-.75-.75m14.5-5v7.65l1.5 1.66V6.75A2.75 2.75 0 0 0 19.25 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20H14v-1.5H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25M6.75 14a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm8.74-2.95a.8.8 0 0 1 .82.2l6.37 7.06a.75.75 0 0 1-.74 1.23l-3.54-.88-2.03 3.01a.75.75 0 0 1-1.37-.42v-9.5c0-.31.2-.59.49-.7"
]);
const $bd5c6ab3f2a8957d$export$bb7c424c83bb81a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit16Filled', "16", [
    "M3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h3.22l.21-.84a3 3 0 0 1 .84-1.49l.67-.67H4.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .32.12L9.94 8H4.5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 .32.12l1.28-1.28a2.9 2.9 0 0 1 2.9-.7V5a2 2 0 0 0-2-2zm1 2.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m3.98 5.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$6ee54cc0d004c898 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit16Regular', "16", [
    "M4 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 7a.5.5 0 0 0 0 1h5.44l.88-.88A.5.5 0 0 0 10.5 7zM14 5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.47l-.04.16-.21.84H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v.13q-.49-.15-1-.13M8.82 9.12l-.88.88H4.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .32.12m-.84 2.26 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$704289ad4a4174de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v2.63a2.9 2.9 0 0 0-2.9.71l-4.83 4.83a3 3 0 0 0-.8 1.33H4.5A2.5 2.5 0 0 1 2 13.5zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m.5 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm5.48 3.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$1ab9b40418145bbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit20Regular', "20", [
    "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm-.5 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.97q.17-.54.52-1H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5V9q.52-.02 1 .13V6.5A2.5 2.5 0 0 0 15.5 4zm6.48 11.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$7f082f4349403492 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.67l.1-.42q.25-.99.97-1.72l5.9-5.9a3.3 3.3 0 0 1 3.61-.7V6.75A2.75 2.75 0 0 0 19.25 4zM6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75m0 3c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 3.75a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5zm12.35-2.83-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $bd5c6ab3f2a8957d$export$9f0274b9f9df283b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit24Regular', "24", [
    "M6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75M6.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM6 14.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m-4-8A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v4.51q-.73-.3-1.5-.25V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h7.23q-.3.5-.46 1.08l-.1.42H4.75A2.75 2.75 0 0 1 2 17.25zm17.1 5.92-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $bd5c6ab3f2a8957d$export$682ceb918ae110b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h7.67l.1-.42q.25-.99.97-1.72l7.9-7.9a3.3 3.3 0 0 1 3.61-.7V7.75A3.75 3.75 0 0 0 22.25 4zM7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 4.04v-.04c0-.4.33-.73.73-.73h10.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73m0 3.96c0-.4.33-.73.73-.73h7.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73zm16.1-3.06-7.9 7.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l7.9-7.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $bd5c6ab3f2a8957d$export$9f6d42dd57b375d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextEdit28Regular', "28", [
    "M7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 4c0-.4.33-.73.73-.73h10.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73zM7.73 17c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h7.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zM2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v5.51q-.74-.3-1.5-.25V7.75c0-1.24-1-2.25-2.25-2.25H5.75c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25h8.23q-.3.5-.46 1.08l-.1.42H5.75A3.75 3.75 0 0 1 2 20.25zm21.1 6.92-7.9 7.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l7.9-7.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $bd5c6ab3f2a8957d$export$8f48c845ac35bbef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple16Filled', "16", [
    "M1.5 4.5A2.5 2.5 0 0 1 4 2h6.5A2.5 2.5 0 0 1 13 4.5v5a2.5 2.5 0 0 1-2.5 2.5H4a2.5 2.5 0 0 1-2.5-2.5zm3-.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM4 8.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m6.5 4.5A3.5 3.5 0 0 0 14 9.5V3.67c.63.77 1 1.76 1 2.83v3a4.5 4.5 0 0 1-4.5 4.5h-4a4.5 4.5 0 0 1-2.83-1z"
]);
const $bd5c6ab3f2a8957d$export$4c3a984097b4dbec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple16Regular', "16", [
    "M4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 6.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M4.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-3-3.5A2.5 2.5 0 0 1 4 2h6.5A2.5 2.5 0 0 1 13 4.5v5a2.5 2.5 0 0 1-2.5 2.5H4a2.5 2.5 0 0 1-2.5-2.5zM4 3c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zm10 6.5a3.5 3.5 0 0 1-3.5 3.5H3.67c.77.63 1.76 1 2.83 1h4A4.5 4.5 0 0 0 15 9.5v-3c0-1.07-.37-2.06-1-2.83z"
]);
const $bd5c6ab3f2a8957d$export$4589bc84aa0add35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple20Filled', "20", [
    "M13.5 15a2.5 2.5 0 0 0 2.5-2.5v-7q0-.15-.02-.28A2.5 2.5 0 0 0 13.5 3h-9A2.5 2.5 0 0 0 2 5.5v7A2.5 2.5 0 0 0 4.48 15h9.02m-8-9h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1m0 2.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m-.5 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M6.5 17a2.5 2.5 0 0 1-2-1h9a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $bd5c6ab3f2a8957d$export$b1f27fe33fa3fdba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple20Regular', "20", [
    "M5.5 6a.5.5 0 1 0 0 1h4a.5.5 0 0 0 0-1zM5 9c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 9m.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM16 5.5A2.5 2.5 0 0 0 13.5 3h-9A2.5 2.5 0 0 0 2 5.5v7A2.5 2.5 0 0 0 4.5 15h9a2.5 2.5 0 0 0 2.5-2.5zm-13 7v-7C3 4.67 3.67 4 4.5 4h9c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 3 12.5M6.5 17a2.5 2.5 0 0 1-2-1h9a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $bd5c6ab3f2a8957d$export$898be1e96c6e7f05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple24Filled', "24", [
    "M17 4a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM6.75 7.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM6 14.25c0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75m15-6.74c.9.58 1.5 1.59 1.5 2.74v6c0 2.9-2.35 5.25-5.25 5.25h-9c-1.15 0-2.16-.6-2.74-1.5h11.74A3.75 3.75 0 0 0 21 16.25z"
]);
const $bd5c6ab3f2a8957d$export$9eb0a28f8d3bfa1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple24Regular', "24", [
    "M6.75 7.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM6 11.25c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM5.25 4h11.5a3.25 3.25 0 0 1 3.24 3.07l.01.18v8.5a3.25 3.25 0 0 1-3.07 3.24l-.18.01H5.25a3.25 3.25 0 0 1-3.24-3.07L2 15.75v-8.5a3.25 3.25 0 0 1 3.07-3.24zM3.5 7.2v8.55c0 .92.7 1.67 1.6 1.74l.15.01h11.5c.92 0 1.67-.7 1.74-1.6l.01-.15V7.2c-.03-.94-.8-1.7-1.75-1.7H5.25c-.92 0-1.67.7-1.74 1.6zm17.5.31c.9.58 1.5 1.59 1.5 2.74v6c0 2.9-2.35 5.25-5.25 5.25h-9c-1.15 0-2.16-.6-2.74-1.5h11.74A3.75 3.75 0 0 0 21 16.25z"
]);
const $bd5c6ab3f2a8957d$export$cde13082d16e3e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple32Filled', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5v11A4.5 4.5 0 0 0 6.5 24h15a4.5 4.5 0 0 0 4.5-4.5v-11A4.5 4.5 0 0 0 21.5 4zM8 9h7a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2m0 4h12a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2m-1 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m21 3a5 5 0 0 1-5 5H7.1c1.26 1.24 3 2 4.9 2h11a7 7 0 0 0 7-7v-7c0-1.9-.76-3.64-2-4.9z"
]);
const $bd5c6ab3f2a8957d$export$8a7af2a658bfeb36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextMultiple32Regular', "32", [
    "M8 9a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM2 8.5A4.5 4.5 0 0 1 6.5 4h15A4.5 4.5 0 0 1 26 8.5v11a4.5 4.5 0 0 1-4.5 4.5h-15A4.5 4.5 0 0 1 2 19.5zM6.5 6A2.5 2.5 0 0 0 4 8.5v11A2.5 2.5 0 0 0 6.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 21.5 6zM28 21a5 5 0 0 1-5 5H7.1c1.26 1.24 3 2 4.9 2h11a7 7 0 0 0 7-7v-7c0-1.9-.76-3.64-2-4.9z"
]);
const $bd5c6ab3f2a8957d$export$a6dd0ee6a3ead4de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson16Filled', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h4.54L8 12.5c0-1.3 1-2.38 2.27-2.49A3 3 0 0 1 9.5 8h-5a.5.5 0 0 1 0-1h5.17A3 3 0 0 1 15 6.34V5.5A2.5 2.5 0 0 0 12.5 3zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0 4h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1m10-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 13.75 9 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$a0998e850fb7734f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v.84q-.4-.58-1-.94A1.5 1.5 0 0 0 12.5 4h-9C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h4.55a3 3 0 0 0-.01 1H3.5A2.5 2.5 0 0 1 1 10.5zM9.67 7a3 3 0 0 0-.17 1h-5a.5.5 0 0 1 0-1zM4.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm10-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 13.75 9 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$4e62513c2ff0c74e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h6.54l-.04-.5c0-1.3 1-2.38 2.27-2.49a3 3 0 0 1-.73-2.51H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .33.13A3 3 0 0 1 18 9.34V6.5A2.5 2.5 0 0 0 15.5 4zM5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M17.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 16.75 12 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$a1178b11a8b42135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson20Regular', "20", [
    "M5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M5 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 .33.13q-.21.4-.29.87H5.5A.5.5 0 0 1 5 10m6.05 5H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v1.9q.6.36 1 .94V6.5A2.5 2.5 0 0 0 15.5 4h-11A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h6.54a3 3 0 0 1 .01-1M5.5 12a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm12-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 16.75 12 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $bd5c6ab3f2a8957d$export$a5eb7a8cd2abc803 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20H13v-.22A2.77 2.77 0 0 1 15.77 17h.28a3.5 3.5 0 0 1-.42-4.5H6.75a.75.75 0 0 1 0-1.5h9c.37 0 .69.27.74.63q.87-.62 2.01-.63a3.5 3.5 0 0 1 3.46 3H22V6.75A2.75 2.75 0 0 0 19.25 4zM6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75m.75 6.75a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5zm14.25-1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $bd5c6ab3f2a8957d$export$b7712f71b1433849 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson24Regular', "24", [
    "M6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75M6.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM6 14.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m-4-8A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75V14h-.04a3.5 3.5 0 0 0-1.46-2.37V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h8.56q-.3.57-.31 1.27V20H4.75A2.75 2.75 0 0 1 2 17.25zm19 7.75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $bd5c6ab3f2a8957d$export$ed8a4fe4ebed173b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h9.32q-.07-.38-.07-.75v-.2A3.04 3.04 0 0 1 18.05 20h.8a4 4 0 0 1-.47-5.5H7.73a.73.73 0 0 1-.73-.73v-.04c0-.4.33-.73.73-.73h10.54c.4 0 .73.33.73.73v.15A4 4 0 0 1 25.5 17h.5V7.75A3.75 3.75 0 0 0 22.25 4zM7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 8c0-.4.33-.73.73-.73h7.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73zM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $bd5c6ab3f2a8957d$export$7e647460abddee4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson28Regular', "28", [
    "M7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 4c0-.4.33-.73.73-.73h10.54c.4 0 .73.33.73.73v.15q-.35.28-.62.61l-.1.01H7.72a.73.73 0 0 1-.73-.73zm8.05 8.77h-9.3c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25h16.5c1.24 0 2.25 1 2.25 2.25v6.6c.62.71 1 1.64 1 2.65h.5V7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h9.32q-.07-.38-.07-.75v-.2q0-.29.05-.55M7.73 17c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h7.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73zm16.77 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $bd5c6ab3f2a8957d$export$b57bad2ea242b55c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5V18h-.02a5 5 0 0 0-8.62-2.93A1 1 0 0 0 21 15H9a1 1 0 1 0 0 2h11.23a5 5 0 0 0 1.2 5h-.01a3.93 3.93 0 0 0-3.92 3.94q0 1.06.45 2.06H6.5A4.5 4.5 0 0 1 2 23.5zM8 11a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1m0 10a1 1 0 0 0 1 1h9a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1m20.5-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06a2.43 2.43 0 0 1 2.42-2.44h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $bd5c6ab3f2a8957d$export$a7d4d7982ebf0dab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson32Regular', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5V18h-.02A5 5 0 0 0 28 14.5v-6A2.5 2.5 0 0 0 25.5 6h-19A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26h11q0 1.03.45 2H6.5A4.5 4.5 0 0 1 2 23.5zM21 15a1 1 0 0 1 .36.07A5 5 0 0 0 20.23 17H9a1 1 0 1 1 0-2zM8 11a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 9a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm19.5-1.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06a2.43 2.43 0 0 1 2.42-2.44h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $bd5c6ab3f2a8957d$export$5869cc119caabb3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson48Filled', "48", [
    "M8.75 8A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h17.27l-.02-.5V39a5 5 0 0 1 5-5h1.1a7 7 0 0 1-.73-9.17q-.28.16-.62.17h-17.5a1.25 1.25 0 1 1 0-2.5h17.5a1.25 1.25 0 0 1 1.17 1.68A7 7 0 0 1 44 29V12.75A4.75 4.75 0 0 0 39.25 8zm4.5 23.5a1.25 1.25 0 1 1 0-2.5h13.5a1.25 1.25 0 1 1 0 2.5zM12 17.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25M42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $bd5c6ab3f2a8957d$export$be19107b4983ebbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextPerson48Regular', "48", [
    "M13.25 16a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM12 23.75c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 0 1 1.17 1.68q-.3.3-.55.65-.28.16-.62.17h-17.5c-.69 0-1.25-.56-1.25-1.25M26.23 37.5H8.75c-1.24 0-2.25-1-2.25-2.25v-22.5c0-1.24 1-2.25 2.25-2.25h30.5c1.24 0 2.25 1 2.25 2.25v10.89A7 7 0 0 1 44 29V12.75A4.75 4.75 0 0 0 39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h17.27l-.02-.5V39a5 5 0 0 1 .23-1.5M12 30.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $bd5c6ab3f2a8957d$export$a52c9bb31088941c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__a)",
            "d": "M13 3H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__b)",
            "fillOpacity": ".3",
            "d": "M13 3H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__c)",
            "fillOpacity": ".3",
            "d": "M13 3H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__d)",
            "fillOpacity": ".3",
            "d": "M13 3H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__e)",
            "fillOpacity": ".6",
            "d": "M13 3H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__f)",
            "fillOpacity": ".4",
            "d": "M13 3H3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__g)",
            "d": "m7.29 3.94 1.06.31q.42.14.75.43l.12.11a2 2 0 0 1 .53.87l.35 1.07a1 1 0 0 0 .15.21q.11.08.24.08t.24-.08a.4.4 0 0 0 .15-.2l.35-1.07a2.2 2.2 0 0 1 1.39-1.39l1.07-.35a.4.4 0 0 0 .28-.39.4.4 0 0 0-.08-.24.4.4 0 0 0-.2-.15h-.02L12.6 2.8a2.2 2.2 0 0 1-1.39-1.39L10.86.34a.4.4 0 0 0-.39-.28.4.4 0 0 0-.24.08.4.4 0 0 0-.15.2l-.35 1.07q-.17.49-.52.86-.36.37-.85.54l-1.07.35a.4.4 0 0 0-.28.39q0 .13.08.24t.2.15"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "M4.5 9a.5.5 0 0 0-.5.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__h)",
            "d": "M4.5 9a.5.5 0 0 0-.5.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M10.12 7.95a1 1 0 0 1-.45-.21 1.5 1.5 0 0 1-.52-.69L9.13 7H4.5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5h5.6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__i)",
            "d": "M10.12 7.95a1 1 0 0 1-.45-.21 1.5 1.5 0 0 1-.52-.69L9.13 7H4.5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5h5.6z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M4.5 6h3a.5.5 0 0 0 .34-.86 1 1 0 0 0-.33-.13L7.43 5H4.5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__j)",
            "d": "M4.5 6h3a.5.5 0 0 0 .34-.86 1 1 0 0 0-.33-.13L7.43 5H4.5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_16_color__k)",
            "d": "M15.94 8.33a.4.4 0 0 0-.17-.11L15 7.97a2 2 0 0 1-.62-.38q-.27-.26-.38-.62l-.25-.76a.3.3 0 0 0-.11-.15.3.3 0 0 0-.34 0 .3.3 0 0 0-.11.15l-.25.76q-.12.35-.37.61-.26.26-.61.38l-.77.25a.3.3 0 0 0-.15.11.3.3 0 0 0 0 .34q.06.08.15.11l.77.25q.35.12.62.38.26.27.38.62l.25.76q.03.09.11.15a.3.3 0 0 0 .34 0 .3.3 0 0 0 .11-.15l.25-.76q.12-.35.38-.62.27-.26.62-.38l.77-.25a.3.3 0 0 0 .15-.11.3.3 0 0 0 0-.34z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__a",
                "x1": "1.28",
                "x2": "9.93",
                "y1": "12.92",
                "y2": ".71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".51",
                    "stopColor": "#dd3ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91cbf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__g",
                "x1": "13.84",
                "x2": "8.3",
                "y1": "7.79",
                "y2": "3.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__h",
                "x1": "8.79",
                "x2": "3.38",
                "y1": "9.5",
                "y2": "9.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__i",
                "x1": "9.87",
                "x2": "3.23",
                "y1": "7.5",
                "y2": "7.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__j",
                "x1": "7.83",
                "x2": "3.5",
                "y1": "5.5",
                "y2": "5.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__k",
                "x1": "16.81",
                "x2": "10.57",
                "y1": "11.81",
                "y2": "8.94",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .5 -2.15625 0 5.96 6)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .75 -4.15781 0 7.42 8)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .75 -2.95717 0 6.54 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.25 -3.41328 0 11.5 4)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.5 -1.86793 0 14.42 7)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$e07f19d28c9c8ef0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle16Filled', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56q.33.23.74.23.41.01.75-.21.33-.23.48-.65l.25-.76.02-.06V11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.09a1.4 1.4 0 0 0 .17 1.32q.26.37.71.53l.46.15H4.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .34-.86l.2.06q.2.06.46.29c.11.11.2.24.3.47L9.13 7H4.5a.5.5 0 0 0 0 1h5.6a1.3 1.3 0 0 0 .14 1.26q.24.33.65.48l.77.25q.12.05.22.14t.14.22l.26.8q.15.38.48.62M4 9.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $bd5c6ab3f2a8957d$export$3eff50a152d3ed3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle16Regular', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-2.55 3.76.27.03q.41.01.75-.21.33-.23.48-.65l.25-.76.02-.06V11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.09a1.4 1.4 0 0 0 0 1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10zM9.13 7l.02.05q.13.37.52.7.22.15.45.2L10.1 8H4.5a.5.5 0 0 1 0-1zm-1.7-2 .41.14A.5.5 0 0 1 7.5 6h-3a.5.5 0 0 1 0-1zM4 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $bd5c6ab3f2a8957d$export$67a8831aab984021 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle20Color', "20", [
    [
        "path",
        {
            "fill": "#fff600",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__a)",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__b)",
            "fillOpacity": ".3",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__c)",
            "fillOpacity": ".3",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__d)",
            "fillOpacity": ".3",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__e)",
            "fillOpacity": ".6",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__f)",
            "fillOpacity": ".4",
            "d": "M15.5 3.97h-11A2.5 2.5 0 0 0 2 6.47v7a2.5 2.5 0 0 0 2.5 2.5h11a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 0-2.5-2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__g)",
            "d": "M12.5 9.47h-7a.5.5 0 0 0-.5.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__h)",
            "d": "M5.5 7.97h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5c0 .28.22.5.5.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__i)",
            "d": "M10.5 11.97h-5a.5.5 0 0 0-.5.5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__j)",
            "d": "M15.78 5.75q.37-.37.86-.53l1.07-.35a.4.4 0 0 0 .28-.39.4.4 0 0 0-.08-.24.4.4 0 0 0-.2-.15h-.02l-1.07-.35a2.2 2.2 0 0 1-1.39-1.39l-.35-1.07a.4.4 0 0 0-.39-.28.4.4 0 0 0-.24.08.4.4 0 0 0-.15.2l-.35 1.07q-.17.49-.52.86-.37.37-.85.54l-1.07.35a.4.4 0 0 0-.28.39q0 .13.08.24t.2.15l1.07.35q.42.14.75.43l.12.11q.3.3.47.7l.06.17.35 1.07a1 1 0 0 0 .13.19l.02.02q.11.08.24.08t.24-.08a.4.4 0 0 0 .15-.2l.35-1.07c.11-.33.28-.66.52-.9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_20_color__k)",
            "d": "M19.94 9.3a.3.3 0 0 0-.15-.11h-.02L19 8.94a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.11-.15.3.3 0 0 0-.34 0 .3.3 0 0 0-.11.15l-.25.76q-.12.35-.37.61-.26.26-.61.38l-.77.25a.3.3 0 0 0-.15.11.3.3 0 0 0 0 .34q.06.08.15.11l.77.25q.35.12.62.38.26.27.38.62l.25.76q.03.09.11.15a.3.3 0 0 0 .34 0 .3.3 0 0 0 .11-.15l.25-.76q.12-.35.38-.62.27-.26.62-.38l.77-.25a.3.3 0 0 0 .15-.11.3.3 0 0 0 0-.34z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__a",
                "x1": "2.33",
                "x2": "12.86",
                "y1": "15.88",
                "y2": "1.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".51",
                    "stopColor": "#dd3ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91cbf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__g",
                "x1": "12.67",
                "x2": "4",
                "y1": "9.97",
                "y2": "9.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__h",
                "x1": "9.79",
                "x2": "4.38",
                "y1": "7.47",
                "y2": "7.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__i",
                "x1": "10.75",
                "x2": "4.25",
                "y1": "12.47",
                "y2": "12.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__j",
                "x1": "17.86",
                "x2": "12.3",
                "y1": "8.78",
                "y2": "4.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__k",
                "x1": "23.13",
                "x2": "15.98",
                "y1": "13.94",
                "y2": "7.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .6 -2.46429 0 7.67 7.57)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .9 -4.75179 0 9.33 9.97)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .9 -3.37963 0 8.33 12.37)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.7 -3.90089 0 14 5.17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.8 -2.13477 0 17.33 8.77)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$445bb7ba1c0eb84f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle20Filled', "20", [
    "m14.88 1.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56q.32.23.74.23.26 0 .5-.08v.58a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h5.59a1.4 1.4 0 0 0 .17 1.32q.26.37.71.53l1.06.35q.22.06.47.29c.11.11.2.24.3.47l.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.12.05.22.14t.14.22l.26.8q.15.38.48.62M5 7.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m.5 3h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1m-.5 2c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5"
]);
const $bd5c6ab3f2a8957d$export$40127fbaddec7e03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle20Regular', "20", [
    "m14.88 1.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17 12.91q.24.09.5.09t.5-.08v.58a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h5.59a1.4 1.4 0 0 0 0 1H4.5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5zM5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M5 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 10m.5 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $bd5c6ab3f2a8957d$export$828192324e1acd04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__a)",
            "d": "M19.25 3.99H4.75A2.75 2.75 0 0 0 2 6.74v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 17.24V6.74a2.75 2.75 0 0 0-2.75-2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__b)",
            "fillOpacity": ".3",
            "d": "M19.25 3.99H4.75A2.75 2.75 0 0 0 2 6.74v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 17.24V6.74a2.75 2.75 0 0 0-2.75-2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__c)",
            "fillOpacity": ".3",
            "d": "M19.25 3.99H4.75A2.75 2.75 0 0 0 2 6.74v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 17.24V6.74a2.75 2.75 0 0 0-2.75-2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__d)",
            "fillOpacity": ".3",
            "d": "M19.25 3.99H4.75A2.75 2.75 0 0 0 2 6.74v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 17.24V6.74a2.75 2.75 0 0 0-2.75-2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__e)",
            "fillOpacity": ".6",
            "d": "M19.25 3.99H4.75A2.75 2.75 0 0 0 2 6.74v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 17.24V6.74a2.75 2.75 0 0 0-2.75-2.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__f)",
            "fillOpacity": ".4",
            "d": "M19.25 3.99H4.75A2.75 2.75 0 0 0 2 6.74v10.5a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 17.24V6.74a2.75 2.75 0 0 0-2.75-2.75"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "m13.36 5 1.38.45a2.9 2.9 0 0 1 1.79 1.81l.45 1.38q.06.17.2.26.14.1.31.1a.5.5 0 0 0 .31-.1 1 1 0 0 0 .19-.23l.01-.03.45-1.38q.21-.64.69-1.11.47-.47 1.11-.69l1.38-.45q.17-.06.26-.2a.5.5 0 0 0 .1-.31.5.5 0 0 0-.1-.31.6.6 0 0 0-.26-.2h-.03l-1.38-.45q-.64-.21-1.11-.69a3 3 0 0 1-.69-1.11L17.97.36a.5.5 0 0 0-.2-.26.5.5 0 0 0-.31-.1.5.5 0 0 0-.31.1 1 1 0 0 0-.2.26l-.45 1.38v.03q-.23.61-.67 1.07-.47.47-1.1.69l-1.38.45a.5.5 0 0 0-.26.2.5.5 0 0 0-.1.31q0 .17.1.31t.26.2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__g)",
            "d": "m13.36 5 1.38.45a2.9 2.9 0 0 1 1.79 1.81l.45 1.38q.06.17.2.26.14.1.31.1a.5.5 0 0 0 .31-.1 1 1 0 0 0 .19-.23l.01-.03.45-1.38q.21-.64.69-1.11.47-.47 1.11-.69l1.38-.45q.17-.06.26-.2a.5.5 0 0 0 .1-.31.5.5 0 0 0-.1-.31.6.6 0 0 0-.26-.2h-.03l-1.38-.45q-.64-.21-1.11-.69a3 3 0 0 1-.69-1.11L17.97.36a.5.5 0 0 0-.2-.26.5.5 0 0 0-.31-.1.5.5 0 0 0-.31.1 1 1 0 0 0-.2.26l-.45 1.38v.03q-.23.61-.67 1.07-.47.47-1.1.69l-1.38.45a.5.5 0 0 0-.26.2.5.5 0 0 0-.1.31q0 .17.1.31t.26.2z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M16 11.74a.76.76 0 0 0-.75-.75h-8.5a.76.76 0 0 0-.75.75c0 .41.34.75.75.75h8.5c.41 0 .75-.34.75-.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__h)",
            "d": "M16 11.74a.76.76 0 0 0-.75-.75h-8.5a.76.76 0 0 0-.75.75c0 .41.34.75.75.75h8.5c.41 0 .75-.34.75-.75"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M6.75 13.99a.76.76 0 0 0-.75.75c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75a.76.76 0 0 0-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__i)",
            "d": "M6.75 13.99a.76.76 0 0 0-.75.75c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75a.76.76 0 0 0-.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__j)",
            "d": "M23.94 10.32a.3.3 0 0 0-.15-.11h-.02L23 9.96a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.11-.15.3.3 0 0 0-.34 0 .3.3 0 0 0-.11.15l-.25.76q-.12.35-.37.61-.26.26-.61.38l-.77.25a.3.3 0 0 0-.15.11.3.3 0 0 0 0 .34q.06.08.15.11l.77.25q.35.12.62.38.26.27.38.62l.25.76q.03.09.11.15a.3.3 0 0 0 .34 0 .3.3 0 0 0 .11-.15l.25-.76q.12-.35.38-.62.27-.26.62-.38l.77-.25a.3.3 0 0 0 .15-.11.3.3 0 0 0 0-.34z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M6.75 9.49h4.5c.41 0 .75-.34.75-.75a.76.76 0 0 0-.75-.75h-4.5a.76.76 0 0 0-.75.75c0 .41.34.75.75.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_24_color__k)",
            "d": "M6.75 9.49h4.5c.41 0 .75-.34.75-.75a.76.76 0 0 0-.75-.75h-4.5a.76.76 0 0 0-.75.75c0 .41.34.75.75.75"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__a",
                "x1": "2.41",
                "x2": "16.69",
                "y1": "19.87",
                "y2": "1.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".51",
                    "stopColor": "#dd3ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91cbf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__g",
                "x1": "21.82",
                "x2": "14.66",
                "y1": "10",
                "y2": "4.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__h",
                "x1": "15.58",
                "x2": "4.75",
                "y1": "11.74",
                "y2": "11.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__i",
                "x1": "13.67",
                "x2": "5",
                "y1": "14.74",
                "y2": "14.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__j",
                "x1": "29.13",
                "x2": "13.87",
                "y1": "21.5",
                "y2": "12.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__k",
                "x1": "11.75",
                "x2": "5.25",
                "y1": "8.74",
                "y2": "8.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 .8 -3.08036 0 9.08 8.79)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.2 -5.93973 0 11.17 11.99)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.2 -4.22453 0 9.92 15.19)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.6 -4.87611 0 17 5.59)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.4 -2.66847 0 21.17 10.39)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$6b6e5bb53d5d50dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle24Filled', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12.06 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25v-3.32a1.3 1.3 0 0 1-1.29-.12q-.35-.25-.49-.65l-.24-.76a1 1 0 0 0-.14-.23 1 1 0 0 0-.22-.14l-.79-.25a1.3 1.3 0 0 1-.69-1.9q-.32.17-.68.17-.49 0-.89-.28-.4-.3-.57-.77l-.41-1.45q-.1-.3-.29-.55l-.18-.1q-.3-.3-.72-.44L13 6q-.46-.2-.72-.64a1.6 1.6 0 0 1-.2-1.36M6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75m0 3c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75m.75 3.75a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5z"
]);
const $bd5c6ab3f2a8957d$export$3656ac1a9e691433 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle24Regular', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12.06 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25v-3.32a1.3 1.3 0 0 1-1.5-.3v3.62c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25h7.62l-.09-.14a1.6 1.6 0 0 1-.2-1.36M6 8.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 6 8.75M6.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM6 14.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75"
]);
const $bd5c6ab3f2a8957d$export$ee9ebc530bdde090 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle28Color', "28", [
    [
        "rect",
        {
            "width": "24",
            "height": "20",
            "x": "2",
            "y": "4",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__a)",
            "rx": "3.8"
        }
    ],
    [
        "rect",
        {
            "width": "24",
            "height": "20",
            "x": "2",
            "y": "4",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__b)",
            "fillOpacity": ".3",
            "rx": "3.8"
        }
    ],
    [
        "rect",
        {
            "width": "24",
            "height": "20",
            "x": "2",
            "y": "4",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__c)",
            "fillOpacity": ".3",
            "rx": "3.8"
        }
    ],
    [
        "rect",
        {
            "width": "24",
            "height": "20",
            "x": "2",
            "y": "4",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__d)",
            "fillOpacity": ".3",
            "rx": "3.8"
        }
    ],
    [
        "rect",
        {
            "width": "24",
            "height": "20",
            "x": "2",
            "y": "4",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__e)",
            "fillOpacity": ".6",
            "rx": "3.8"
        }
    ],
    [
        "rect",
        {
            "width": "24",
            "height": "20",
            "x": "2",
            "y": "4",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__f)",
            "fillOpacity": ".4",
            "rx": "3.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__g)",
            "d": "m26.82 10.36.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.91-.3a.36.36 0 0 1 0-.68l.91-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .69 0l.3.92a1.9 1.9 0 0 0 1.2 1.2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__h)",
            "d": "M18.17 6.83a3 3 0 0 1 .77 1.24l.5 1.53a.6.6 0 0 0 1.13 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53v.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.7.23 1.23.76"
        }
    ],
    [
        "rect",
        {
            "width": "7",
            "height": "1.5",
            "x": "7",
            "y": "9",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__i)",
            "rx": ".75"
        }
    ],
    [
        "rect",
        {
            "width": "12",
            "height": "1.5",
            "x": "7",
            "y": "13",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__j)",
            "rx": ".75"
        }
    ],
    [
        "rect",
        {
            "width": "9",
            "height": "1.5",
            "x": "7",
            "y": "17",
            "fill": "url(#ic_fluent_slide_text_sparkle_28_color__k)",
            "rx": ".75"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__a",
                "x1": "2.49",
                "x2": "20.5",
                "y1": "23.85",
                "y2": "2.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".51",
                    "stopColor": "#dd3ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91cbf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__g",
                "x1": "35.69",
                "x2": "11.45",
                "y1": "28.13",
                "y2": "9.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__h",
                "x1": "24.82",
                "x2": "16.86",
                "y1": "11.11",
                "y2": "4.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__i",
                "x1": "13.71",
                "x2": "6.13",
                "y1": "9.75",
                "y2": "9.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__j",
                "x1": "18.5",
                "x2": "5.5",
                "y1": "13.75",
                "y2": "13.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__k",
                "x1": "15.63",
                "x2": "5.88",
                "y1": "17.75",
                "y2": "17.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1 -3.69643 0 10.5 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.5 -7.12768 0 13 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.5 -5.06944 0 11.5 18)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4.5 -5.85134 0 20 6)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_28_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -3.20216 0 25 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$4750fb494b69fba1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle28Filled', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14.37 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25v-5.69l-.21.19a1.4 1.4 0 0 1-1.58 0q-.36-.26-.5-.68l-.3-.92a1 1 0 0 0-.22-.35 1 1 0 0 0-.34-.21l-.94-.31a1.3 1.3 0 0 1-.66-.49Q21 11.44 21 11q0-.2.06-.38l-.13.11a1.6 1.6 0 0 1-1.86 0 1.7 1.7 0 0 1-.6-.8l-.5-1.53a2 2 0 0 0-.51-.85 2 2 0 0 0-.83-.52l-1.56-.5q-.48-.17-.77-.6a1.6 1.6 0 0 1 .07-1.93M7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 4.04v-.04c0-.4.33-.73.73-.73h10.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73m0 3.96c0-.4.33-.73.73-.73h7.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73z"
]);
const $bd5c6ab3f2a8957d$export$d035ad42caacb022 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle28Regular', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14.37 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25v-5.69l-.21.19a1.4 1.4 0 0 1-1.29.16v5.34c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25h8.33a1.6 1.6 0 0 1 .29-1.5M7 9.73c0-.4.33-.73.73-.73h5.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73A.73.73 0 0 1 7 9.77zm0 4c0-.4.33-.73.73-.73h10.54c.4 0 .73.33.73.73v.04c0 .4-.33.73-.73.73H7.73a.73.73 0 0 1-.73-.73zM7.73 17c-.4 0-.73.33-.73.73v.04c0 .4.33.73.73.73h7.54c.4 0 .73-.33.73-.73v-.04c0-.4-.33-.73-.73-.73z"
]);
const $bd5c6ab3f2a8957d$export$37d8c7342a53c9c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__a)",
            "fillRule": "evenodd",
            "d": "M28.64 5.28A3 3 0 0 1 26.5 6C25.12 6 24 5.33 24 4.5q0-.26.14-.5H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15c0-1.26-.52-2.4-1.36-3.22",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__b)",
            "fillOpacity": ".3",
            "fillRule": "evenodd",
            "d": "M28.64 5.28A3 3 0 0 1 26.5 6C25.12 6 24 5.33 24 4.5q0-.26.14-.5H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15c0-1.26-.52-2.4-1.36-3.22",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__c)",
            "fillOpacity": ".3",
            "fillRule": "evenodd",
            "d": "M28.64 5.28A3 3 0 0 1 26.5 6C25.12 6 24 5.33 24 4.5q0-.26.14-.5H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15c0-1.26-.52-2.4-1.36-3.22",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__d)",
            "fillOpacity": ".3",
            "fillRule": "evenodd",
            "d": "M28.64 5.28A3 3 0 0 1 26.5 6C25.12 6 24 5.33 24 4.5q0-.26.14-.5H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15c0-1.26-.52-2.4-1.36-3.22",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__e)",
            "fillOpacity": ".6",
            "fillRule": "evenodd",
            "d": "M28.64 5.28A3 3 0 0 1 26.5 6C25.12 6 24 5.33 24 4.5q0-.26.14-.5H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15c0-1.26-.52-2.4-1.36-3.22",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__f)",
            "fillOpacity": ".4",
            "fillRule": "evenodd",
            "d": "M28.64 5.28A3 3 0 0 1 26.5 6C25.12 6 24 5.33 24 4.5q0-.26.14-.5H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15c0-1.26-.52-2.4-1.36-3.22",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "m30.82 12.36.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__g)",
            "d": "m30.82 12.36.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__h)",
            "d": "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84"
        }
    ],
    [
        "rect",
        {
            "width": "8",
            "height": "2",
            "x": "8",
            "y": "9",
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__i)",
            "rx": "1"
        }
    ],
    [
        "rect",
        {
            "width": "15",
            "height": "2",
            "x": "8",
            "y": "14",
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__j)",
            "rx": "1"
        }
    ],
    [
        "rect",
        {
            "width": "10",
            "height": "2",
            "x": "8",
            "y": "19",
            "fill": "url(#ic_fluent_slide_text_sparkle_32_color__k)",
            "rx": "1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__a",
                "x1": "2.57",
                "x2": "24.28",
                "y1": "27.82",
                "y2": "2.26",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".51",
                    "stopColor": "#dd3ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91cbf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__g",
                "x1": "29.12",
                "x2": "20.12",
                "y1": "12.59",
                "y2": "5.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__h",
                "x1": "28.8",
                "x2": "20.05",
                "y1": "12.22",
                "y2": "5.19",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__i",
                "x1": "15.67",
                "x2": "7",
                "y1": "10",
                "y2": "10",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__j",
                "x1": "22.38",
                "x2": "6.13",
                "y1": "15",
                "y2": "15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__k",
                "x1": "17.58",
                "x2": "6.75",
                "y1": "20",
                "y2": "20",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1.5 -5.39063 0 12 10.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2 -10.4301 0 16 15.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2 -7.18751 0 13 20.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6 -7.58507 0 23.5 6)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 4 -4.15095 0 29 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$9fe53f77be5a54e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle32Filled', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M17.1 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-6.26a1.9 1.9 0 0 1-2.04-.08 2 2 0 0 1-.69-.94l-.3-.91a.3.3 0 0 0-.09-.15l-.14-.1-1-.31A1.85 1.85 0 0 1 24.5 13q.01-.5.25-.91a2.16 2.16 0 0 1-3.3-1.08l-.55-1.7a2 2 0 0 0-.39-.67q-.07-.06-.08-.1a2 2 0 0 0-.77-.48l-1.71-.56a2.2 2.2 0 0 1-1.45-2 2.2 2.2 0 0 1 .6-1.5M8 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 9h8a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2m-1-4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
]);
const $bd5c6ab3f2a8957d$export$727d7281e1665e19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle32Regular', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M17.1 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-6.26a1.9 1.9 0 0 1-2-.05v6.31a2.5 2.5 0 0 1-2.5 2.5h-19A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6h10.07a2 2 0 0 1-.07-.5 2.2 2.2 0 0 1 .6-1.5M9 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zM8 20a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1-6a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2z"
]);
const $bd5c6ab3f2a8957d$export$7b6180a2d19eaad4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__a)",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__b)",
            "fillOpacity": ".4",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__c)",
            "fillOpacity": ".4",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__d)",
            "fillOpacity": ".4",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__e)",
            "fillOpacity": ".6",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__f)",
            "fillOpacity": ".4",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__g)",
            "d": "M39.25 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.74 4.74 0 0 0 44 35.25v-22.5A4.75 4.75 0 0 0 39.25 8"
        }
    ],
    [
        "path",
        {
            "fill": "#212121",
            "d": "M13.25 29.03a1.25 1.25 0 0 0 0 2.5h13.5a1.25 1.25 0 0 0 0-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__h)",
            "d": "M13.25 29.03a1.25 1.25 0 0 0 0 2.5h13.5a1.25 1.25 0 0 0 0-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M32 23.78c0-.7-.55-1.26-1.24-1.26h-17.5a1.25 1.25 0 0 0 0 2.5h17.5c.69 0 1.25-.55 1.25-1.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__i)",
            "d": "M32 23.78c0-.7-.55-1.26-1.24-1.26h-17.5a1.25 1.25 0 0 0 0 2.5h17.5c.69 0 1.25-.55 1.25-1.24"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "M13.25 18.52h9.5a1.25 1.25 0 0 0 0-2.5h-9.5a1.25 1.25 0 0 0 0 2.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__j)",
            "d": "M13.25 18.52h9.5a1.25 1.25 0 0 0 0-2.5h-9.5a1.25 1.25 0 0 0 0 2.5"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "m27.7 10.48 2.6.85a5.3 5.3 0 0 1 3.39 3.4l.85 2.6a1 1 0 0 0 .97.7 1 1 0 0 0 .94-.63l.02-.06.85-2.6a5.3 5.3 0 0 1 3.4-3.4l2.6-.85a1 1 0 0 0 .69-.97 1 1 0 0 0-.7-.97h-.04l-2.6-.86a5.3 5.3 0 0 1-3.4-3.4l-.85-2.6a1 1 0 0 0-.97-.69 1 1 0 0 0-.97.69l-.85 2.6-.02.06a5.4 5.4 0 0 1-3.32 3.33l-2.6.85a1 1 0 0 0-.7.97 1 1 0 0 0 .7.97z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__k)",
            "d": "m27.7 10.48 2.6.85a5.3 5.3 0 0 1 3.39 3.4l.85 2.6a1 1 0 0 0 .97.7 1 1 0 0 0 .94-.63l.02-.06.85-2.6a5.3 5.3 0 0 1 3.4-3.4l2.6-.85a1 1 0 0 0 .69-.97 1 1 0 0 0-.7-.97h-.04l-2.6-.86a5.3 5.3 0 0 1-3.4-3.4l-.85-2.6a1 1 0 0 0-.97-.69 1 1 0 0 0-.97.69l-.85 2.6-.02.06a5.4 5.4 0 0 1-3.32 3.33l-2.6.85a1 1 0 0 0-.7.97 1 1 0 0 0 .7.97z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_slide_text_sparkle_48_color__l)",
            "d": "M47.91 20.21a1 1 0 0 0-.26-.2h-.03l-1.38-.45q-.64-.21-1.11-.69a3 3 0 0 1-.7-1.1L44 16.37a.5.5 0 0 0-.2-.26.5.5 0 0 0-.32-.1.5.5 0 0 0-.31.1.6.6 0 0 0-.2.26l-.45 1.38a2.82 2.82 0 0 1-1.77 1.8l-1.38.45a.5.5 0 0 0-.26.2q-.1.15-.1.31 0 .17.1.31.1.15.26.2l1.38.45q.23.07.44.2v.01q.37.2.67.5.46.48.69 1.12l.45 1.38q.06.16.2.26t.3.1a.5.5 0 0 0 .32-.1 1 1 0 0 0 .18-.22q0-.01.02-.05l.45-1.38q.21-.64.69-1.12.46-.46 1.11-.69l1.38-.45q.17-.05.26-.2a.5.5 0 0 0 .1-.3.5.5 0 0 0-.1-.32z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__a",
                "x1": "4.81",
                "x2": "33.38",
                "y1": "39.76",
                "y2": "3.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fc92cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".51",
                    "stopColor": "#dd3ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91cbf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__g",
                "x1": "32.22",
                "x2": "25.75",
                "y1": "13.34",
                "y2": "-4.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#dd3ce2",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#f4a7f7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__h",
                "x1": "27.34",
                "x2": "10",
                "y1": "30.28",
                "y2": "30.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__i",
                "x1": "31.17",
                "x2": "9.5",
                "y1": "23.78",
                "y2": "23.78",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__j",
                "x1": "23.5",
                "x2": "10.5",
                "y1": "17.27",
                "y2": "17.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__k",
                "x1": "43.69",
                "x2": "30.15",
                "y1": "19.92",
                "y2": "9.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__l",
                "x1": "47.69",
                "x2": "28.71",
                "y1": "25.63",
                "y2": "11.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fee5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".96",
                    "stopColor": "#f0b6f2"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.62392 -5.3338 0 16.76 17.41)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.55202 -12.536 0 21.78 24)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.58034 -8.71639 0 18.88 30.4)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(109.68 15.74 17.66)scale(9.81228 10.968)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#55107a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_slide_text_sparkle_48_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(139.55 18.01 18.37)scale(5.13261 5.70674)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#55107a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a1061",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $bd5c6ab3f2a8957d$export$f3e7012d2a1508b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle48Filled', "48", [
    "M32.83 13.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L44 16.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM25.4 8A3 3 0 0 0 27 12.35l2.65.86a3.3 3.3 0 0 1 2.17 2.11l.84 2.59a3 3 0 0 0 4.59 1.51q-.22.48-.22 1a2.55 2.55 0 0 0 1.7 2.4l1.42.46.12.06.2.15q.14.14.2.33l.44 1.37q.22.82.89 1.35a2.6 2.6 0 0 0 2 .41v8.3A4.75 4.75 0 0 1 39.25 40H8.75A4.75 4.75 0 0 1 4 35.25v-22.5A4.75 4.75 0 0 1 8.75 8zM12 23.75c0 .69.56 1.25 1.25 1.25h17.5a1.25 1.25 0 1 0 0-2.5h-17.5c-.69 0-1.25.56-1.25 1.25m1.25 7.75h13.5a1.25 1.25 0 1 0 0-2.5h-13.5a1.25 1.25 0 1 0 0 2.5M12 17.25c0 .69.56 1.25 1.25 1.25h9.5a1.25 1.25 0 1 0 0-2.5h-9.5c-.69 0-1.25.56-1.25 1.25"
]);
const $bd5c6ab3f2a8957d$export$78a5d35a82ae89e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextSparkle48Regular', "48", [
    "M32.83 13.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L44 16.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM25.4 8H8.75A4.75 4.75 0 0 0 4 12.75v22.5A4.75 4.75 0 0 0 8.75 40h30.5A4.75 4.75 0 0 0 44 35.25v-8.3a2.6 2.6 0 0 1-2-.4q-.3-.24-.5-.53v9.23c0 1.24-1 2.25-2.25 2.25H8.75c-1.24 0-2.25-1-2.25-2.25v-22.5c0-1.24 1-2.25 2.25-2.25h16.41a3 3 0 0 1-.13-1.45A3 3 0 0 1 25.41 8m-12.16 8a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM12 23.75c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 1 1 0 2.5h-17.5c-.69 0-1.25-.56-1.25-1.25m0 6.5c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $bd5c6ab3f2a8957d$export$c988ef841e191b47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitle16Filled', "16", [
    "M3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm2 3h6a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2"
]);
const $bd5c6ab3f2a8957d$export$1c68663ed0ac10f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitle16Regular', "16", [
    "M3 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM2 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm3 1a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $bd5c6ab3f2a8957d$export$2df8d68de14e68a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitle20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM6 7h8a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2"
]);
const $bd5c6ab3f2a8957d$export$71d296367e948f21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitle20Regular', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5zM6 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z"
]);
const $bd5c6ab3f2a8957d$export$4d74dce85d669724 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitle24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM7.5 8h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1 0-3"
]);
const $bd5c6ab3f2a8957d$export$3a7032918accc81a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitle24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM3.5 6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25zM7.5 8a1.5 1.5 0 1 0 0 3h9a1.5 1.5 0 0 0 0-3z"
]);
const $bd5c6ab3f2a8957d$export$f85d258af004f9d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleAdd16Filled', "16", [
    "M3 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h3.02L6 11.5C6 9.64 6.92 8 8.34 7H5a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1v.02c1.13.1 2.17.55 3 1.24V4a2 2 0 0 0-2-2zm13 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $bd5c6ab3f2a8957d$export$c97da59c283ea828 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleAdd16Regular', "16", [
    "M3 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h3.02a6 6 0 0 1 0-1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.6q.54.27 1 .66V4a2 2 0 0 0-2-2zm8.5 4q.26 0 .5.02V6a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h3.34c.9-.63 1.98-1 3.16-1m4.5 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $bd5c6ab3f2a8957d$export$7d3932d00a0461ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleAdd20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7a5.5 5.5 0 0 1 8.8-5.74V6.5A2.5 2.5 0 0 0 15.5 4zM6 7h8a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2m13 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bd5c6ab3f2a8957d$export$48bba9adf6843d4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleAdd20Regular', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7q-.13-.49-.18-1H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v3.1q.54.27 1 .66V6.5A2.5 2.5 0 0 0 15.5 4zM6 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm13 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $bd5c6ab3f2a8957d$export$d87666851b6ee834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleAdd24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75A6.5 6.5 0 0 1 22 12.81V6.75A2.75 2.75 0 0 0 19.25 4zM7.5 8h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1 0-3M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $bd5c6ab3f2a8957d$export$d83f4777562f8d03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleAdd24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75q-.3-.71-.42-1.5H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v4.98q.83.44 1.5 1.08V6.75A2.75 2.75 0 0 0 19.25 4zM7.5 8a1.5 1.5 0 1 0 0 3h9a1.5 1.5 0 0 0 0-3zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $bd5c6ab3f2a8957d$export$6ad8cc500a50678b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleCheckmark16Filled', "16", [
    "M3 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h3.02L6 11.5C6 9.64 6.92 8 8.34 7H5a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1v.02c1.13.1 2.17.55 3 1.24V4a2 2 0 0 0-2-2zm13 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$b20e4067c501e21d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleCheckmark16Regular', "16", [
    "M3 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h3.02a6 6 0 0 1 0-1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.6q.54.27 1 .66V4a2 2 0 0 0-2-2zm8.5 4q.26 0 .5.02V6a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h3.34c.9-.63 1.98-1 3.16-1m4.5 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$2856084be0ead6d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleCheckmark20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7a5.5 5.5 0 0 1 8.8-5.74V6.5A2.5 2.5 0 0 0 15.5 4zM6 7h8a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2m13 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$a2bab36c8bc8757b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleCheckmark20Regular', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7q-.13-.49-.18-1H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v3.1q.54.27 1 .66V6.5A2.5 2.5 0 0 0 15.5 4zM6 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm13 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$a8bb0d6f8902f42c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleCheckmark24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75A6.5 6.5 0 0 1 22 12.81V6.75A2.75 2.75 0 0 0 19.25 4zM7.5 8h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1 0-3M23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.15 2.35 4-4a.5.5 0 0 0-.7-.7l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$9a7d9bc3e11d5517 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleCheckmark24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h6.75q-.3-.71-.42-1.5H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v4.98q.83.44 1.5 1.08V6.75A2.75 2.75 0 0 0 19.25 4zM7.5 8a1.5 1.5 0 1 0 0 3h9a1.5 1.5 0 0 0 0-3zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.15 2.35 4-4a.5.5 0 0 0-.7-.7l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0"
]);
const $bd5c6ab3f2a8957d$export$95bd24b11e8be473 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleEdit16Filled', "16", [
    "M1 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v.13a2.9 2.9 0 0 0-2.9.71l-.42.43A1 1 0 0 0 11 6H5a1 1 0 0 0 0 2h4.94l-2.67 2.67q-.62.63-.84 1.49l-.2.84H3a2 2 0 0 1-2-2zm6.98 6.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$5208e2a62133b49f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleEdit16Regular', "16", [
    "M1 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v.13q-.49-.15-1-.13a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.48l-.05.16-.2.84H3a2 2 0 0 1-2-2zm10.68 1.27L9.94 8H5a1 1 0 0 1 0-2h6q.4 0 .68.27m-3.7 5.1 4.83-4.82a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$b2e34d3cedcf2d10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleEdit20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.98q.23-.76.8-1.33l4.82-4.83a2.9 2.9 0 0 1 2.9-.7V6.5A2.5 2.5 0 0 0 15.5 4zM6 7h8a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2m4.98 8.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$3e0214caccb61bd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleEdit20Regular', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.98q.16-.54.5-1H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5V9q.52-.02 1 .13V6.5A2.5 2.5 0 0 0 15.5 4zM6 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm4.98 8.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $bd5c6ab3f2a8957d$export$e05fb819b1102cfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleEdit24Filled', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v4.51a3.3 3.3 0 0 0-3.6.7l-5.9 5.9q-.73.73-.98 1.72l-.1.42H4.75A2.75 2.75 0 0 1 2 17.25zM16.5 8h-9a1.5 1.5 0 1 0 0 3h9a1.5 1.5 0 0 0 0-3m2.6 4.67-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $bd5c6ab3f2a8957d$export$f68e72810d1810f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTextTitleEdit24Regular', "24", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v4.51q-.73-.3-1.5-.25V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h7.23q-.3.5-.46 1.08l-.1.42H4.75A2.75 2.75 0 0 1 2 17.25zM6 9.5C6 8.67 6.67 8 7.5 8h9a1.5 1.5 0 0 1 0 3h-9A1.5 1.5 0 0 1 6 9.5m13.1 3.17-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $bd5c6ab3f2a8957d$export$6545c0474782350 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTopicAdd16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5a.5.5 0 0 0-.5-.5m0-3c-1.7 0-3.23.78-4.24 2H3.5a.5.5 0 0 0 0 1h3.1q-.25.48-.4 1H3.5a.5.5 0 0 0 0 1h2.52a5.6 5.6 0 0 0 .58 3H3.5a2.5 2.5 0 0 1-2.49-2.24L1 11.5v-3A2.5 2.5 0 0 1 3.5 6zm2-4a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 1 1 0-3z"
]);
const $bd5c6ab3f2a8957d$export$74e56d64aa124d27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTopicAdd16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5a.5.5 0 0 0-.5-.5m0-3c-1.18 0-2.27.37-3.16 1H3.5C2.67 7 2 7.67 2 8.5v3.15A1.5 1.5 0 0 0 3.5 13h2.7q.15.52.4 1H3.5a2.5 2.5 0 0 1-2.49-2.24L1 11.5v-3A2.5 2.5 0 0 1 3.5 6zm-5.3 4q-.13.48-.18 1H3.5a.5.5 0 0 1 0-1zm1.06-2q-.39.46-.66 1H3.5a.5.5 0 0 1 0-1zm6.24-6a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 1 1 0-3z"
]);
const $bd5c6ab3f2a8957d$export$17174616b833c39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTopicAdd20Filled', "20", [
    "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V15h-1.5a.5.5 0 0 0 0 1H15v1.5a.5.5 0 0 0 1 0V16h1.5a.5.5 0 0 0 0-1H16v-1.5a.5.5 0 0 0-.5-.5M15 7a3 3 0 0 1 3 3v.6q-1.14-.58-2.5-.6a5.5 5.5 0 0 0-5.3 7H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3zm-9.5 5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0-2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm11-7a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 1 1 0-3z"
]);
const $bd5c6ab3f2a8957d$export$3ba2bf2367ca8448 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTopicAdd20Regular', "20", [
    "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V15h-1.5a.5.5 0 0 0 0 1H15v1.5a.5.5 0 0 0 1 0V16h1.5a.5.5 0 0 0 0-1H16v-1.5a.5.5 0 0 0-.5-.5M15 7a3 3 0 0 1 3 3v.6q-.48-.25-1-.4V10a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5.02q.05.52.19 1H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3zm-5.5 5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm2-2a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zm5-7a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 1 1 0-3z"
]);
const $bd5c6ab3f2a8957d$export$ff04eb9c23c95cf2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTopicAdd32Filled', "32", [
    "M23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.25 2a.75.75 0 0 0-.75.75v3.75h-3.75a.75.75 0 0 0 0 1.5H23v3.75a.75.75 0 0 0 1.5 0V24h3.75a.75.75 0 0 0 0-1.5H24.5v-3.75a.75.75 0 0 0-.75-.75m1.75-8a4.5 4.5 0 0 1 4.5 4.5v2.78A9 9 0 0 0 16.38 29H6.5A4.5 4.5 0 0 1 2 24.5v-10A4.5 4.5 0 0 1 6.5 10zM7 20a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm0-5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM27.5 3a2.5 2.5 0 0 1 0 5h-23a2.5 2.5 0 0 1 0-5z"
]);
const $bd5c6ab3f2a8957d$export$17f53fa4b56d0e6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTopicAdd32Regular', "32", [
    "M23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.25 2a.75.75 0 0 0-.75.75v3.75h-3.75a.75.75 0 0 0 0 1.5H23v3.75a.75.75 0 0 0 1.5 0V24h3.75a.75.75 0 0 0 0-1.5H24.5v-3.75a.75.75 0 0 0-.75-.75m1.75-8a4.5 4.5 0 0 1 4.5 4.5v2.78a9 9 0 0 0-2-1.57V14.5a2.5 2.5 0 0 0-2.5-2.5h-19A2.5 2.5 0 0 0 4 14.5v10A2.5 2.5 0 0 0 6.5 27h8.7a9 9 0 0 0 1.18 2H6.5A4.5 4.5 0 0 1 2 24.5v-10A4.5 4.5 0 0 1 6.5 10zM13 20a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm3-5a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM27.5 3a2.5 2.5 0 0 1 0 5h-23a2.5 2.5 0 0 1 0-5z"
]);
const $bd5c6ab3f2a8957d$export$857b99da2f6976ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTransition20Filled', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM6 5H5v10h1zm3 0H8v10h1zm3 0v10h1V5z"
]);
const $bd5c6ab3f2a8957d$export$8f2bebf93e7bf7f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTransition20Regular', "20", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM12 5v10H9V5zm1 10V5h2.25c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75zm-5 0H6V5h2zM5 5v10h-.25C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5z"
]);
const $bd5c6ab3f2a8957d$export$81c55ec6642f4c68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTransition24Filled', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM6.5 5.5v13H5v-13zm4 13H9v-13h1.5zm5 0H14v-13h1.5z"
]);
const $bd5c6ab3f2a8957d$export$503dbeefe19e3b47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SlideTransition24Regular', "24", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zM3.5 6.75c0-.69.56-1.25 1.25-1.25H5v13h-.25c-.69 0-1.25-.56-1.25-1.25zm3 11.75v-13H9v13zm7.5 0h-3.5v-13H14zm1.5 0v-13h3.75c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25z"
]);
const $bd5c6ab3f2a8957d$export$f1de222167063159 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SyncOff16Filled', "16", [
    "M14 8A6 6 0 0 1 2 8h3.88l-.85 2.33a.5.5 0 0 0 .94.34l2-5.5a.5.5 0 1 0-.94-.34L6.24 7H2.08a6 6 0 0 1 11.84 0H10.3l.67-1.83a.5.5 0 1 0-.94-.34l-2 5.5a.5.5 0 0 0 .94.34L9.94 8z"
]);
const $bd5c6ab3f2a8957d$export$badd57d8a18682a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SyncOff16Regular', "16", [
    "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m-1 0H9.94l-.97 2.67a.5.5 0 1 1-.94-.34l2-5.5a.5.5 0 0 1 .94.34L10.3 7h2.6a5 5 0 0 0-9.8 0h3.14l.79-2.17a.5.5 0 0 1 .94.34l-2 5.5a.5.5 0 1 1-.94-.34L5.88 8H3a5 5 0 0 0 10 0"
]);
const $bd5c6ab3f2a8957d$export$3dea066dd023c43f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SyncOff20Filled', "20", [
    "M17.94 9H12.3l.67-2.36a.5.5 0 0 0-.96-.28l-2 7a.5.5 0 0 0 .96.28L12.02 10H18a8 8 0 0 1-16 0h5.98l-.96 3.36a.5.5 0 0 0 .96.28l2-7a.5.5 0 0 0-.96-.28L8.27 9h-6.2a8 8 0 0 1 15.87 0"
]);
const $bd5c6ab3f2a8957d$export$bc3a2476f077e46e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SyncOff20Regular', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 0 0-6.93 6h5.2l.75-2.64a.5.5 0 1 1 .96.28l-2 7a.5.5 0 1 1-.96-.28L7.98 10H3a7 7 0 1 0 14 0h-4.98l-1.04 3.64a.5.5 0 1 1-.96-.28l2-7a.5.5 0 1 1 .96.28L12.31 9h4.62A7 7 0 0 0 10 3"
]);



const $6babe0488a39ce9b$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    main: {
        display: "flex",
        alignItems: "flex-start",
        gap: "1rem",
        height: "calc( 100vh - 55px )"
    }
});
const $6babe0488a39ce9b$var$DashboardIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $82e7c60f6344ef74$export$2a550ac5e65e6f4b), (0, $82e7c60f6344ef74$export$c6fd3b7d9df8dbd3));
const $6babe0488a39ce9b$var$SalesIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $db6ad3fef28672ff$export$494c1bb36691cf), (0, $db6ad3fef28672ff$export$7dac0e74aed3ee1));
const $6babe0488a39ce9b$var$CustomersIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $76e5a570f6bfc30c$export$bb2e3e3c0220aaf8), (0, $76e5a570f6bfc30c$export$2bb0e6df393a9355));
const $6babe0488a39ce9b$var$ProductsIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $cdb0ff5c001a8842$export$7c54ac7343988191), (0, $cdb0ff5c001a8842$export$7a5904599c8de3da));
const $6babe0488a39ce9b$var$VendorsIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $e9fce37105e983ce$export$bbb10d70f35d6c5a), (0, $e9fce37105e983ce$export$1d8210a77a9fac54));
const $6babe0488a39ce9b$var$DropboxesIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $cdb0ff5c001a8842$export$90bc44ded265ae96), (0, $cdb0ff5c001a8842$export$3a5fe68708ee1bc0));
const $6babe0488a39ce9b$var$SettingsIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $bd5c6ab3f2a8957d$export$8bcf4ae44a7114d7), (0, $bd5c6ab3f2a8957d$export$a52c9e8901a6cdff));
function $6babe0488a39ce9b$export$2e2bcd8739ae039() {
    const styles = $6babe0488a39ce9b$var$useStyles();
    let pageId = window.location.pathname.substring(1).trim().toLowerCase();
    if (pageId == "") pageId = "dashboard";
    //
    // Strip any trailing slashes from the pageId
    //
    if (pageId.includes("/")) pageId = pageId.substring(0, pageId.indexOf("/"));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: styles.main,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76daa8b00e1f169e$export$7b98f7b2abd01120), {
                        surfaceMotion: null,
                        open: true,
                        type: "inline",
                        selectedValue: pageId,
                        style: {
                            flex: "0 0 auto",
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bf547612cab457ee$export$f8e4c6ba6de2a0f2), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/dashboard",
                                    value: "dashboard",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$DashboardIcon, {}),
                                    children: "Dashboard"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/sales",
                                    value: "sales",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$SalesIcon, {}),
                                    children: "Sales"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/customers",
                                    value: "customers",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$CustomersIcon, {}),
                                    children: "Customers"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/products",
                                    value: "products",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$ProductsIcon, {}),
                                    children: "Products"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/vendors",
                                    value: "vendors",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$VendorsIcon, {}),
                                    children: "Vendors"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/dropboxes",
                                    value: "dropboxes",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$DropboxesIcon, {}),
                                    children: "Dropboxes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ba202ace73a9adb$export$e3925dbaeffcc83f), {
                                    href: "/settings",
                                    value: "settings",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6babe0488a39ce9b$var$SettingsIcon, {}),
                                    children: "Settings"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");


'use client';
const $5c00400f2a150872$export$ddba8bf7f25ff112 = (props, ref)=>{
    const { size: size = 'medium' } = props;
    const state = $5c00400f2a150872$export$3d2b9fc04269a58c(props, ref);
    const arrowNavigationProps = $5c00400f2a150872$export$8ac79c67fb0293b4();
    return {
        size: size,
        ...state,
        root: {
            ...state.root,
            ...arrowNavigationProps
        }
    };
};
const $5c00400f2a150872$export$3d2b9fc04269a58c = (props, ref)=>{
    const { vertical: vertical = false } = props;
    const initialState = {
        vertical: vertical,
        // TODO add appropriate props/defaults
        components: {
            // TODO add each slot's element type or component
            root: 'div'
        },
        // TODO add appropriate slots, for example:
        // mySlot: resolveShorthand(props.mySlot),
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            role: 'toolbar',
            ref: ref,
            ...vertical && {
                'aria-orientation': 'vertical'
            },
            ...props
        }), {
            elementType: 'div'
        })
    };
    const [checkedValues, onCheckedValueChange] = $5c00400f2a150872$var$useToolbarSelectableState({
        checkedValues: props.checkedValues,
        defaultCheckedValues: props.defaultCheckedValues,
        onCheckedValueChange: props.onCheckedValueChange
    });
    const handleToggleButton = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, name, value, checked)=>{
        if (name && value) {
            const checkedItems = (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues[name]) || [];
            const newCheckedItems = [
                ...checkedItems
            ];
            if (checked) newCheckedItems.splice(newCheckedItems.indexOf(value), 1);
            else newCheckedItems.push(value);
            onCheckedValueChange === null || onCheckedValueChange === void 0 || onCheckedValueChange(e, {
                name: name,
                checkedItems: newCheckedItems
            });
        }
    });
    const handleRadio = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, name, value, checked)=>{
        if (name && value) onCheckedValueChange === null || onCheckedValueChange === void 0 || onCheckedValueChange(e, {
            name: name,
            checkedItems: [
                value
            ]
        });
    });
    return {
        ...initialState,
        handleToggleButton: handleToggleButton,
        handleRadio: handleRadio,
        checkedValues: checkedValues !== null && checkedValues !== void 0 ? checkedValues : {}
    };
};
/**
 * Adds appropriate state values and handlers for selectable items
 * i.e checkboxes and radios
 */ const $5c00400f2a150872$var$useToolbarSelectableState = (state)=>{
    const [checkedValues, setCheckedValues] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: state.checkedValues,
        defaultState: state.defaultCheckedValues,
        initialState: {}
    });
    const { onCheckedValueChange: onCheckedValueChangeOriginal } = state;
    const onCheckedValueChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, { name: name, checkedItems: checkedItems })=>{
        if (onCheckedValueChangeOriginal) onCheckedValueChangeOriginal(e, {
            name: name,
            checkedItems: checkedItems
        });
        setCheckedValues((s)=>{
            return s ? {
                ...s,
                [name]: checkedItems
            } : {
                [name]: checkedItems
            };
        });
    });
    return [
        checkedValues,
        onCheckedValueChange
    ];
};
const $5c00400f2a150872$export$8ac79c67fb0293b4 = ()=>{
    return (0, $d560ba8cc00a7511$export$ce58b15831f653b8)({
        circular: true,
        axis: 'both'
    });
};





'use client';
const $76e3bab2c481ba3c$export$6311e7ab80ef752f = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $76e3bab2c481ba3c$var$toolbarContextDefaultValue = {
    size: 'medium',
    handleToggleButton: ()=>null,
    handleRadio: ()=>null,
    vertical: false,
    checkedValues: {}
};
const $76e3bab2c481ba3c$export$8f50c9a87516eb9b = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($76e3bab2c481ba3c$export$6311e7ab80ef752f, (ctx = $76e3bab2c481ba3c$var$toolbarContextDefaultValue)=>selector(ctx));


const $eb368177ac085d29$export$5c6b21b24e992570 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $76e3bab2c481ba3c$export$6311e7ab80ef752f).Provider, {
        value: contextValues.toolbar,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
            children: state.root.children
        })
    });
};



'use client';
const $1634fdbbe004866c$export$ae707797cb3a08bb = {
    root: 'fui-Toolbar'
};
/**
 * Styles for the root slot
 */ const $1634fdbbe004866c$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1yqiaad"
    },
    vertical: {
        Beiy3e4: "f1vx9l62",
        a9b677: "f1acs6jw"
    },
    small: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fvz760z"
    },
    medium: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1yqiaad"
    },
    large: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1ms6bdn"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}",
        [
            ".f1yqiaad{padding:4px 8px;}",
            {
                p: -1
            }
        ],
        ".f1vx9l62{flex-direction:column;}",
        ".f1acs6jw{width:fit-content;}",
        [
            ".fvz760z{padding:0px 4px;}",
            {
                p: -1
            }
        ],
        [
            ".f1yqiaad{padding:4px 8px;}",
            {
                p: -1
            }
        ],
        [
            ".f1ms6bdn{padding:4px 20px;}",
            {
                p: -1
            }
        ]
    ]
});
const $1634fdbbe004866c$export$e089d47d2bca13e1 = (state)=>{
    const styles = $1634fdbbe004866c$var$useStyles();
    const { vertical: vertical, size: size } = state;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($1634fdbbe004866c$export$ae707797cb3a08bb.root, styles.root, vertical && styles.vertical, size === 'small' && !vertical && styles.small, size === 'medium' && !vertical && styles.medium, size === 'large' && !vertical && styles.large, state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $6338295ec5f16ae5$export$176aaa713e7d8e66(state) {
    const { size: size, handleToggleButton: handleToggleButton, vertical: vertical, checkedValues: checkedValues, handleRadio: handleRadio } = state;
    const toolbar = $acw62.useMemo(()=>({
            size: size,
            vertical: vertical,
            handleToggleButton: handleToggleButton,
            handleRadio: handleRadio,
            checkedValues: checkedValues
        }), [
        size,
        vertical,
        handleToggleButton,
        handleRadio,
        checkedValues
    ]);
    return {
        toolbar: toolbar
    };
}



'use client';
const $bfbac4c65a4ae1cd$export$4c260019440d418f = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $5c00400f2a150872$export$ddba8bf7f25ff112)(props, ref);
    const contextValues = (0, $6338295ec5f16ae5$export$176aaa713e7d8e66)(state);
    (0, $1634fdbbe004866c$export$e089d47d2bca13e1)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useToolbarStyles_unstable')(state);
    return (0, $eb368177ac085d29$export$5c6b21b24e992570)(state, contextValues);
});
$bfbac4c65a4ae1cd$export$4c260019440d418f.displayName = 'Toolbar';



var $acw62 = parcelRequire("acw62");
const $848f7c387707f0c9$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    toolbar: {}
});
function $848f7c387707f0c9$export$2e2bcd8739ae039() {
    const styles = $848f7c387707f0c9$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        document.title = "Dashboard - Omnivend";
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
            className: styles.toolbar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                appearance: "subtle",
                children: "Test"
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");
const $1ea5c9096dfc059f$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    toolbar: {}
});
function $1ea5c9096dfc059f$export$2e2bcd8739ae039() {
    const styles = $1ea5c9096dfc059f$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        document.title = "Customers - Omnivend";
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
            className: styles.toolbar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                appearance: "subtle",
                children: "Test"
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");
const $56191df1229db6ef$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    toolbar: {}
});
function $56191df1229db6ef$export$2e2bcd8739ae039() {
    const styles = $56191df1229db6ef$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        document.title = "Dropboxes - Omnivend";
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
            className: styles.toolbar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                appearance: "subtle",
                children: "Test"
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");
const $05ce4054dd27d6d3$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    toolbar: {}
});
function $05ce4054dd27d6d3$export$2e2bcd8739ae039() {
    const styles = $05ce4054dd27d6d3$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        document.title = "Products - Omnivend";
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
            className: styles.toolbar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                appearance: "subtle",
                children: "Test"
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");
const $95b60346774b487b$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    toolbar: {}
});
function $95b60346774b487b$export$2e2bcd8739ae039() {
    const styles = $95b60346774b487b$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        document.title = "Sales - Omnivend";
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
            className: styles.toolbar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                appearance: "subtle",
                children: "Test"
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 









class $9e18f219568bdbe3$var$GroupperDummyManager extends (0, $f8063a7f7d87cb7c$export$2b3665f1498b1a50) {
    constructor(element, groupper, tabster, sys){
        super(tabster, element, (0, $f8063a7f7d87cb7c$export$96ba7a05d53985a3).Groupper, sys, true);
        this._setHandlers((dummyInput, isBackward, relatedTarget)=>{
            const container = element.get();
            const input = dummyInput.input;
            if (container && input) {
                const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, input);
                if (ctx) {
                    let next;
                    next = groupper.findNextTabbable(relatedTarget || undefined, undefined, isBackward, true)?.element;
                    if (!next) next = (0, $018eb0b75e35c758$export$406337e29e552119).findNextTabbable(tabster, ctx, undefined, dummyInput.isOutside ? input : (0, $8031a5e97995bd92$export$b7afccb7bf36a427)(container, !isBackward), undefined, isBackward, true)?.element;
                    if (next) (0, $134104a7b4fa5d8e$export$cf4c60ff2c946f35)(next);
                }
            }
        });
    }
}
class $9e18f219568bdbe3$export$c46d5af24e5afa0b extends (0, $8031a5e97995bd92$export$512356fecf866417) {
    constructor(tabster, element, onDispose, props, sys){
        super(tabster, element, props);
        this._shouldTabInside = false;
        this.makeTabbable(false);
        this._onDispose = onDispose;
        if (!tabster.controlTab) this.dummyManager = new $9e18f219568bdbe3$var$GroupperDummyManager(this._element, this, tabster, sys);
    }
    dispose() {
        this._onDispose(this);
        const element = this._element.get();
        this.dummyManager?.dispose();
        delete this.dummyManager;
        element;
        delete this._first;
    }
    findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const groupperElement = this.getElement();
        if (!groupperElement) return null;
        const currentIsDummy = (0, $f8063a7f7d87cb7c$export$6c7070ee46ec4271)(currentElement) === groupperElement;
        if (!this._shouldTabInside && currentElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(groupperElement, currentElement) && !currentIsDummy) return {
            element: undefined,
            outOfDOMOrder: true
        };
        const groupperFirstFocusable = this.getFirst(true);
        if (!currentElement || !(0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(groupperElement, currentElement) || currentIsDummy) return {
            element: groupperFirstFocusable,
            outOfDOMOrder: true
        };
        const tabster = this._tabster;
        let next = null;
        let outOfDOMOrder = false;
        let uncontrolled;
        if (this._shouldTabInside && groupperFirstFocusable) {
            const findProps = {
                container: groupperElement,
                currentElement: currentElement,
                referenceElement: referenceElement,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            next = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
            if (!next && this._props.tabbability === (0, $43f171f5f7088580$export$7ee1c0e36fdd1f6d).LimitedTrapFocus) {
                next = tabster.focusable[isBackward ? "findLast" : "findFirst"]({
                    container: groupperElement,
                    ignoreAccessibility: ignoreAccessibility,
                    useActiveModalizer: true
                }, findPropsOut);
                outOfDOMOrder = true;
            }
            uncontrolled = findPropsOut.uncontrolled;
        }
        return {
            element: next,
            uncontrolled: uncontrolled,
            outOfDOMOrder: outOfDOMOrder
        };
    }
    makeTabbable(isTabbable) {
        this._shouldTabInside = isTabbable || !this._props.tabbability;
    }
    isActive(noIfFirstIsFocused) {
        const element = this.getElement() || null;
        let isParentActive = true;
        for(let e = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(element); e; e = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(e)){
            const g = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(this._tabster, e)?.groupper;
            if (g) {
                if (!g._shouldTabInside) isParentActive = false;
            }
        }
        let ret = isParentActive ? this._props.tabbability ? this._shouldTabInside : false : undefined;
        if (ret && noIfFirstIsFocused) {
            const focused = this._tabster.focusedElement.getFocusedElement();
            if (focused) ret = focused !== this.getFirst(true);
        }
        return ret;
    }
    getFirst(orContainer) {
        const groupperElement = this.getElement();
        let first;
        if (groupperElement) {
            if (orContainer && this._tabster.focusable.isFocusable(groupperElement)) return groupperElement;
            first = this._first?.get();
            if (!first) {
                first = this._tabster.focusable.findFirst({
                    container: groupperElement,
                    useActiveModalizer: true
                }) || undefined;
                if (first) this.setFirst(first);
            }
        }
        return first;
    }
    setFirst(element) {
        if (element) this._first = new (0, $8031a5e97995bd92$export$e61d664de92eea96)(element);
        else delete this._first;
    }
    acceptElement(element, state) {
        const cachedGrouppers = state.cachedGrouppers;
        const parentElement = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(this.getElement());
        const parentCtx = parentElement && (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(this._tabster, parentElement);
        const parentCtxGroupper = parentCtx?.groupper;
        const parentGroupper = parentCtx?.groupperBeforeMover ? parentCtxGroupper : undefined;
        let parentGroupperElement;
        const getIsActive = (groupper)=>{
            let cached = cachedGrouppers[groupper.id];
            let isActive;
            if (cached) isActive = cached.isActive;
            else {
                isActive = this.isActive(true);
                cached = cachedGrouppers[groupper.id] = {
                    isActive: isActive
                };
            }
            return isActive;
        };
        if (parentGroupper) {
            parentGroupperElement = parentGroupper.getElement();
            if (!getIsActive(parentGroupper) && parentGroupperElement && state.container !== parentGroupperElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(state.container, parentGroupperElement)) {
                // Do not fall into a child groupper of inactive parent groupper if it's in the scope of the search.
                state.skippedFocusable = true;
                return NodeFilter.FILTER_REJECT;
            }
        }
        const isActive = getIsActive(this);
        const groupperElement = this.getElement();
        if (groupperElement) {
            if (isActive !== true) {
                if (groupperElement === element && parentCtxGroupper) {
                    if (!parentGroupperElement) parentGroupperElement = parentCtxGroupper.getElement();
                    if (parentGroupperElement && !getIsActive(parentCtxGroupper) && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(state.container, parentGroupperElement) && parentGroupperElement !== state.container) {
                        state.skippedFocusable = true;
                        return NodeFilter.FILTER_REJECT;
                    }
                }
                if (groupperElement !== element && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(groupperElement, element)) {
                    state.skippedFocusable = true;
                    return NodeFilter.FILTER_REJECT;
                }
                const cached = cachedGrouppers[this.id];
                let first;
                if ("first" in cached) first = cached.first;
                else first = cached.first = this.getFirst(true);
                if (first && state.acceptCondition(first)) {
                    state.rejectElementsFrom = groupperElement;
                    state.skippedFocusable = true;
                    if (first !== state.from) {
                        state.found = true;
                        state.foundElement = first;
                        return NodeFilter.FILTER_ACCEPT;
                    } else return NodeFilter.FILTER_REJECT;
                }
            }
        }
        return undefined;
    }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $9e18f219568bdbe3$var$validateGroupperProps(props) {
// TODO: Implement validation.
}
class $9e18f219568bdbe3$export$5000568efbbd62fa {
    constructor(tabster, getWindow){
        this._current = {};
        this._grouppers = {};
        this._init = ()=>{
            const win = this._win();
            // Making sure groupper's onFocus is called before modalizer's onFocus.
            this._tabster.focusedElement.subscribeFirst(this._onFocus);
            const doc = win.document;
            const activeElement = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getActiveElement(doc);
            if (activeElement) this._onFocus(activeElement);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(doc, "mousedown", this._onMouseDown, true);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, "keydown", this._onKeyDown, true);
            (0, $8031a5e97995bd92$export$f03a6b845d3fb58b)(win, (0, $b6b59d8a07a2383a$export$7e4efd5c8bf2a678), this._onMoveFocus);
        };
        this._onGroupperDispose = (groupper)=>{
            delete this._grouppers[groupper.id];
        };
        this._onFocus = (element)=>{
            if (element) this._updateCurrent(element);
        };
        this._onMouseDown = (e)=>{
            let target = e.target;
            while(target && !this._tabster.focusable.isFocusable(target))target = this._tabster.getParent(target);
            if (target) this._updateCurrent(target);
        };
        this._onKeyDown = (event)=>{
            if (event.key !== (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Enter && event.key !== (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Escape) return;
            // Give a chance to other listeners to handle the event.
            if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) return;
            const element = this._tabster.focusedElement.getFocusedElement();
            if (element) this.handleKeyPress(element, event);
        };
        this._onMoveFocus = (e)=>{
            const element = e.composedPath()[0];
            const action = e.detail?.action;
            if (element && action !== undefined && !e.defaultPrevented) {
                if (action === (0, $43f171f5f7088580$export$16ef694586cb4846).Enter) this._enterGroupper(element);
                else this._escapeGroupper(element);
                e.stopImmediatePropagation();
            }
        };
        this._tabster = tabster;
        this._win = getWindow;
        tabster.queueInit(this._init);
    }
    dispose() {
        const win = this._win();
        this._tabster.focusedElement.cancelAsyncFocus((0, $43f171f5f7088580$export$ef584e37c331a849).EscapeGroupper);
        this._current = {};
        if (this._updateTimer) {
            win.clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win.document, "mousedown", this._onMouseDown, true);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, "keydown", this._onKeyDown, true);
        (0, $8031a5e97995bd92$export$b03e9483f936dccb)(win, (0, $b6b59d8a07a2383a$export$7e4efd5c8bf2a678), this._onMoveFocus);
        Object.keys(this._grouppers).forEach((groupperId)=>{
            if (this._grouppers[groupperId]) {
                this._grouppers[groupperId].dispose();
                delete this._grouppers[groupperId];
            }
        });
    }
    createGroupper(element, props, sys) {
        const tabster = this._tabster;
        const newGroupper = new $9e18f219568bdbe3$export$c46d5af24e5afa0b(tabster, element, this._onGroupperDispose, props, sys);
        this._grouppers[newGroupper.id] = newGroupper;
        const focusedElement = tabster.focusedElement.getFocusedElement();
        // Newly created groupper contains currently focused element, update the state on the next tick (to
        // make sure all grouppers are processed).
        if (focusedElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(element, focusedElement) && !this._updateTimer) this._updateTimer = this._win().setTimeout(()=>{
            delete this._updateTimer;
            // Making sure the focused element hasn't changed.
            if (focusedElement === tabster.focusedElement.getFocusedElement()) this._updateCurrent(focusedElement);
        }, 0);
        return newGroupper;
    }
    forgetCurrentGrouppers() {
        this._current = {};
    }
    _updateCurrent(element) {
        if (this._updateTimer) {
            this._win().clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        const tabster = this._tabster;
        const newIds = {};
        for(let el = tabster.getParent(element); el; el = tabster.getParent(el)){
            const groupper = (0, $cac64caf55b8b085$export$18eb7fa290c97ad6)(tabster, el)?.groupper;
            if (groupper) {
                newIds[groupper.id] = true;
                this._current[groupper.id] = groupper;
                const isTabbable = groupper.isActive() || element !== el && (!groupper.getProps().delegated || groupper.getFirst(false) !== element);
                groupper.makeTabbable(isTabbable);
            }
        }
        for (const id of Object.keys(this._current)){
            const groupper = this._current[id];
            if (!(groupper.id in newIds)) {
                groupper.makeTabbable(false);
                groupper.setFirst(undefined);
                delete this._current[id];
            }
        }
    }
    _enterGroupper(element, relatedEvent) {
        const tabster = this._tabster;
        const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, element);
        const groupper = ctx?.groupper || ctx?.modalizerInGroupper;
        const groupperElement = groupper?.getElement();
        if (groupper && groupperElement && (element === groupperElement || groupper.getProps().delegated && element === groupper.getFirst(false))) {
            const next = tabster.focusable.findNext({
                container: groupperElement,
                currentElement: element,
                useActiveModalizer: true
            });
            if (next && (!relatedEvent || relatedEvent && (0, $8031a5e97995bd92$export$716a11175c03fb4e)(groupperElement, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                by: "groupper",
                owner: groupperElement,
                next: next,
                relatedEvent: relatedEvent
            })))) {
                if (relatedEvent) {
                    // When the application hasn't prevented default,
                    // we consider the event completely handled, hence we
                    // prevent the initial event's default action and stop
                    // propagation.
                    relatedEvent.preventDefault();
                    relatedEvent.stopImmediatePropagation();
                }
                next.focus();
                return next;
            }
        }
        return null;
    }
    _escapeGroupper(element, relatedEvent, fromModalizer) {
        const tabster = this._tabster;
        const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, element);
        let groupper = ctx?.groupper || ctx?.modalizerInGroupper;
        const groupperElement = groupper?.getElement();
        if (groupper && groupperElement && (0, $1f57f26a88fe463d$export$df3a06d6289f983e).nodeContains(groupperElement, element)) {
            let next;
            if (element !== groupperElement || fromModalizer) next = groupper.getFirst(true);
            else {
                const parentElement = (0, $1f57f26a88fe463d$export$df3a06d6289f983e).getParentElement(groupperElement);
                const parentCtx = parentElement ? (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, parentElement) : undefined;
                groupper = parentCtx?.groupper;
                next = groupper?.getFirst(true);
            }
            if (next && (!relatedEvent || relatedEvent && (0, $8031a5e97995bd92$export$716a11175c03fb4e)(groupperElement, new (0, $b6b59d8a07a2383a$export$94e7298c3ba0dcfc)({
                by: "groupper",
                owner: groupperElement,
                next: next,
                relatedEvent: relatedEvent
            })))) {
                if (groupper) groupper.makeTabbable(false);
                // This part happens asynchronously inside setTimeout,
                // so no need to prevent default or stop propagation.
                next.focus();
                return next;
            }
        }
        return null;
    }
    moveFocus(element, action) {
        return action === (0, $43f171f5f7088580$export$16ef694586cb4846).Enter ? this._enterGroupper(element) : this._escapeGroupper(element);
    }
    handleKeyPress(element, event, fromModalizer) {
        const tabster = this._tabster;
        const ctx = (0, $7fd0b2ef4cf9c004$export$21337b879fb836da).getTabsterContext(tabster, element);
        if (ctx && (ctx?.groupper || ctx?.modalizerInGroupper)) {
            tabster.focusedElement.cancelAsyncFocus((0, $43f171f5f7088580$export$ef584e37c331a849).EscapeGroupper);
            if (ctx.ignoreKeydown(event)) return;
            if (event.key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Enter) this._enterGroupper(element, event);
            else if (event.key === (0, $fa0e9f07c91ff38c$export$4b0075e5ea5e1f26).Escape) {
                // We will handle Esc asynchronously, if something in the application will
                // move focus during the keypress handling, we will not interfere.
                const focusedElement = tabster.focusedElement.getFocusedElement();
                tabster.focusedElement.requestAsyncFocus((0, $43f171f5f7088580$export$ef584e37c331a849).EscapeGroupper, ()=>{
                    if (focusedElement !== tabster.focusedElement.getFocusedElement() && // A part of Modalizer that has called this handler to escape the active groupper
                    // might have been removed from DOM, if the focus is on body, we still want to handle Esc.
                    (fromModalizer && !focusedElement || !fromModalizer)) // Something else in the application has moved focus, we will not handle Esc.
                    return;
                    this._escapeGroupper(element, event, fromModalizer);
                }, 0);
            }
        }
    }
}
function $9e18f219568bdbe3$var$_setInformativeStyle(weakElement, remove) {}


function $053d2a1c7a9f2645$export$d2ade2e151331a73(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.groupper) {
        const api = new (0, $9e18f219568bdbe3$export$5000568efbbd62fa)(tabsterCore, tabsterCore.getWindow);
        tabsterCore.groupper = api;
        tabsterCore.attrHandlers.set("groupper", (element, existingGroupper, newProps, _oldProps, sys)=>{
            if (existingGroupper) {
                existingGroupper.setProps(newProps);
                return existingGroupper;
            }
            return api.createGroupper(element, newProps, sys);
        });
    }
    return tabsterCore.groupper;
}




'use client';
const $3a1d6c4ac0998739$export$7cdad6852d2f5fdf = (options)=>{
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)((0, $053d2a1c7a9f2645$export$d2ade2e151331a73));
    return (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        groupper: {
            tabbability: $3a1d6c4ac0998739$var$getTabbability(options === null || options === void 0 ? void 0 : options.tabBehavior)
        },
        focusable: {
            ignoreKeydown: options === null || options === void 0 ? void 0 : options.ignoreDefaultKeydown
        }
    });
};
const $3a1d6c4ac0998739$var$getTabbability = (tabBehavior)=>{
    switch(tabBehavior){
        case 'unlimited':
            return (0, $43f171f5f7088580$export$7ee1c0e36fdd1f6d).Unlimited;
        case 'limited':
            return (0, $43f171f5f7088580$export$7ee1c0e36fdd1f6d).Limited;
        case 'limited-trap-focus':
            return (0, $43f171f5f7088580$export$7ee1c0e36fdd1f6d).LimitedTrapFocus;
        default:
            return undefined;
    }
};


var $acw62 = parcelRequire("acw62");



function $a512b3ba371ced77$export$9c146637081c1506(element, win) {
    const keyborg = (0, $134104a7b4fa5d8e$export$9ccd7417191c0e4b)(win);
    // When navigation mode changes to mouse, remove the focus-within selector
    keyborg.subscribe((isNavigatingWithKeyboard)=>{
        if (!isNavigatingWithKeyboard) $a512b3ba371ced77$var$removeFocusWithinClass(element);
    });
    // Keyborg's focusin event is delegated so it's only registered once on the window
    // and contains metadata about the focus event
    const keyborgListener = (e)=>{
        if (keyborg.isNavigatingWithKeyboard() && $a512b3ba371ced77$var$isHTMLElement(e.target)) // Griffel can't create chained global styles so use the parent element for now
        $a512b3ba371ced77$var$applyFocusWithinClass(element);
    };
    // Make sure that when focus leaves the scope, the focus within class is removed
    const blurListener = (e)=>{
        if (!e.relatedTarget || $a512b3ba371ced77$var$isHTMLElement(e.relatedTarget) && !element.contains(e.relatedTarget)) $a512b3ba371ced77$var$removeFocusWithinClass(element);
    };
    element.addEventListener((0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), keyborgListener);
    element.addEventListener('focusout', blurListener);
    // Return disposer
    return ()=>{
        element.removeEventListener((0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), keyborgListener);
        element.removeEventListener('focusout', blurListener);
        (0, $134104a7b4fa5d8e$export$6c71cf8529293a97)(keyborg);
    };
}
function $a512b3ba371ced77$var$applyFocusWithinClass(el) {
    el.setAttribute((0, $adb94d615d1e4f94$export$922950948586e05d), '');
}
function $a512b3ba371ced77$var$removeFocusWithinClass(el) {
    el.removeAttribute((0, $adb94d615d1e4f94$export$922950948586e05d));
}
function $a512b3ba371ced77$var$isHTMLElement(target) {
    if (!target) return false;
    return Boolean(target && typeof target === 'object' && 'classList' in target && 'contains' in target);
}


'use client';
function $4f816f386fc6883e$export$420e68273165f4ec() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const elementRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) && elementRef.current) return (0, $a512b3ba371ced77$export$9c146637081c1506)(elementRef.current, targetDocument.defaultView);
    }, [
        elementRef,
        targetDocument
    ]);
    return elementRef;
}



var $acw62 = parcelRequire("acw62");


'use client';
const $171121ef11107538$export$b8d9e2f475c49dec = (props, { referenceLabel: referenceLabel, referenceId: referenceId })=>{
    const { checkbox: checkbox = {}, onSelectionChange: onSelectionChange, floatingAction: floatingAction, onClick: onClick, onKeyDown: onKeyDown, disabled: disabled, shouldRestrictTriggerAction: shouldRestrictTriggerAction } = props;
    const checkboxRef = $acw62.useRef(null);
    const [selected, setSelected] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.selected,
        defaultState: props.defaultSelected,
        initialState: false
    });
    const selectable = [
        props.selected,
        props.defaultSelected,
        onSelectionChange
    ].some((prop)=>typeof prop !== 'undefined');
    const [selectFocused, setSelectFocused] = $acw62.useState(false);
    const onChangeHandler = $acw62.useCallback((event)=>{
        if (disabled) return;
        const isCheckboxOrFloatingActionTarget = checkboxRef.current === event.target;
        if (!isCheckboxOrFloatingActionTarget && (shouldRestrictTriggerAction === null || shouldRestrictTriggerAction === void 0 ? void 0 : shouldRestrictTriggerAction(event))) return;
        const newCheckedValue = !selected;
        setSelected(newCheckedValue);
        if (onSelectionChange) onSelectionChange(event, {
            selected: newCheckedValue
        });
    }, [
        disabled,
        onSelectionChange,
        selected,
        setSelected,
        shouldRestrictTriggerAction
    ]);
    const onKeyDownHandler = $acw62.useCallback((event)=>{
        if ([
            (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a)
        ].includes(event.key)) {
            event.preventDefault();
            onChangeHandler(event);
        }
    }, [
        onChangeHandler
    ]);
    const checkboxSlot = $acw62.useMemo(()=>{
        if (!selectable || floatingAction) return;
        const selectableCheckboxProps = {};
        if (referenceId) selectableCheckboxProps['aria-labelledby'] = referenceId;
        else if (referenceLabel) selectableCheckboxProps['aria-label'] = referenceLabel;
        // eslint-disable-next-line react-hooks/refs
        return (0, $fcf7ddccaab7fd8f$exports).optional(checkbox, {
            defaultProps: {
                ref: checkboxRef,
                type: 'checkbox',
                checked: selected,
                disabled: disabled,
                onChange: (event)=>onChangeHandler(event),
                onFocus: ()=>setSelectFocused(true),
                onBlur: ()=>setSelectFocused(false),
                ...selectableCheckboxProps
            },
            elementType: 'input'
        });
    }, [
        checkbox,
        disabled,
        floatingAction,
        selected,
        selectable,
        onChangeHandler,
        referenceId,
        referenceLabel
    ]);
    const floatingActionSlot = $acw62.useMemo(()=>{
        if (!floatingAction) return;
        // eslint-disable-next-line react-hooks/refs
        return (0, $fcf7ddccaab7fd8f$exports).optional(floatingAction, {
            defaultProps: {
                ref: checkboxRef
            },
            elementType: 'div'
        });
    }, [
        floatingAction
    ]);
    const selectableCardProps = $acw62.useMemo(()=>{
        if (!selectable) return null;
        return {
            // eslint-disable-next-line react-hooks/refs
            onClick: (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onClick, onChangeHandler),
            // eslint-disable-next-line react-hooks/refs
            onKeyDown: (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onKeyDown, onKeyDownHandler)
        };
    }, [
        selectable,
        onChangeHandler,
        onClick,
        onKeyDown,
        onKeyDownHandler
    ]);
    return {
        selected: selected,
        selectable: selectable,
        selectFocused: selectFocused,
        selectableCardProps: selectableCardProps,
        checkboxSlot: checkboxSlot,
        floatingActionSlot: floatingActionSlot
    };
};



var $acw62 = parcelRequire("acw62");
'use client';
const $eecf8fa9ba90d928$var$cardContext = $acw62.createContext(undefined);
const $eecf8fa9ba90d928$export$98b7e8b4c1856037 = {
    selectableA11yProps: {
        referenceId: undefined,
        setReferenceId () {
        /* Noop */ },
        referenceLabel: undefined,
        setReferenceLabel () {
        /* Noop */ }
    }
};
const $eecf8fa9ba90d928$export$4aacc92b34f48449 = $eecf8fa9ba90d928$var$cardContext.Provider;
const $eecf8fa9ba90d928$export$a48f47fa4aca13ad = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($eecf8fa9ba90d928$var$cardContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $eecf8fa9ba90d928$export$98b7e8b4c1856037;
};


'use client';
const $286f73972e25332e$var$focusMap = {
    off: undefined,
    'no-tab': 'limited-trap-focus',
    'tab-exit': 'limited',
    'tab-only': 'unlimited'
};
const $286f73972e25332e$var$interactiveEventProps = [
    'onClick',
    'onDoubleClick',
    'onMouseUp',
    'onMouseDown',
    'onPointerUp',
    'onPointerDown',
    'onTouchStart',
    'onTouchEnd',
    'onDragStart',
    'onDragEnd'
];
/**
 * Compute whether a Card is interactive based on the presence of pointer/mouse
 * event props and the disabled flag. This intentionally does not depend on
 * focus management utilities so it can be used from headless contexts.
 */ const $286f73972e25332e$var$computeInteractive = (props)=>{
    if (props.disabled) return false;
    return $286f73972e25332e$var$interactiveEventProps.some((prop)=>props[prop] !== undefined);
};
const $286f73972e25332e$export$7312a9ff4417f572 = (props, ref)=>{
    const { appearance: appearance = 'filled', orientation: orientation = 'vertical', size: size = 'medium', ...cardProps } = props;
    const { disabled: disabled = false, focusMode: focusModeProp } = props;
    // Focus-within ref drives the styled focus outline; merged with the user ref
    // before being passed down so the base hook does not depend on react-tabster.
    const focusWithinRef = (0, $4f816f386fc6883e$export$420e68273165f4ec)();
    const cardRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(focusWithinRef, ref);
    // Focus-aware predicate that prevents toggling the selection when the user
    // interacts with an inner focusable element.
    const { findAllFocusable: findAllFocusable } = (0, $708e79e1f2ab4237$export$2b0519dd5d2bc6d4)();
    const shouldRestrictTriggerAction = $acw62.useCallback((event)=>{
        if (!focusWithinRef.current) return false;
        const focusableElements = findAllFocusable(focusWithinRef.current);
        const target = event.target;
        return focusableElements.some((element)=>element.contains(target));
    }, [
        findAllFocusable,
        focusWithinRef
    ]);
    const interactive = $286f73972e25332e$var$computeInteractive(props);
    const focusMode = focusModeProp !== null && focusModeProp !== void 0 ? focusModeProp : interactive ? 'no-tab' : 'off';
    const groupperAttrs = (0, $3a1d6c4ac0998739$export$7cdad6852d2f5fdf)({
        tabBehavior: $286f73972e25332e$var$focusMap[focusMode]
    });
    const state = $286f73972e25332e$export$a1c3063453d210b7({
        shouldRestrictTriggerAction: shouldRestrictTriggerAction,
        ...cardProps
    }, cardRef);
    // Apply focusable-group attributes only when the card is not selectable, not
    // disabled and the focus mode is enabled.
    const shouldApplyFocusAttributes = !disabled && !state.selectable && focusMode !== 'off';
    if (shouldApplyFocusAttributes) Object.assign(state.root, groupperAttrs, {
        tabIndex: 0
    });
    return {
        ...state,
        appearance: appearance,
        orientation: orientation,
        size: size
    };
};
const $286f73972e25332e$export$a1c3063453d210b7 = (props, ref)=>{
    const { disabled: disabled = false, ...restProps } = props;
    const [referenceId, setReferenceId] = $acw62.useState((0, $eecf8fa9ba90d928$export$98b7e8b4c1856037).selectableA11yProps.referenceId);
    const [referenceLabel, setReferenceLabel] = $acw62.useState((0, $eecf8fa9ba90d928$export$98b7e8b4c1856037).selectableA11yProps.referenceId);
    const { selectable: selectable, selected: selected, selectableCardProps: selectableCardProps, selectFocused: selectFocused, checkboxSlot: checkboxSlot, floatingActionSlot: floatingActionSlot } = (0, $171121ef11107538$export$b8d9e2f475c49dec)(props, {
        referenceId: referenceId,
        referenceLabel: referenceLabel
    });
    const interactive = $286f73972e25332e$var$computeInteractive(props);
    let cardRootProps = {
        ...restProps,
        ...selectableCardProps
    };
    if (disabled) cardRootProps = {
        ...restProps,
        'aria-disabled': true,
        onClick: undefined
    };
    return {
        interactive: interactive,
        selectable: selectable,
        selectFocused: selectFocused,
        selected: selected,
        disabled: disabled,
        selectableA11yProps: {
            setReferenceId: setReferenceId,
            referenceId: referenceId,
            referenceLabel: referenceLabel,
            setReferenceLabel: setReferenceLabel
        },
        components: {
            root: 'div',
            floatingAction: 'div',
            checkbox: 'input'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ref: ref,
            role: 'group',
            ...cardRootProps
        }), {
            elementType: 'div'
        }),
        floatingAction: floatingActionSlot,
        checkbox: checkboxSlot
    };
};





const $4d8624d7d9c36ac1$export$cfc6040d9efe83ba = (state, cardContextValue)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $eecf8fa9ba90d928$export$4aacc92b34f48449), {
            value: cardContextValue,
            children: [
                state.checkbox ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.checkbox, {}) : null,
                state.floatingAction ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.floatingAction, {}) : null,
                state.root.children
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");
// This should be just "export * as shorthands from "
// https://github.com/microsoft/fluentui/issues/20694
const $ab498ea24acade8d$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $ab498ea24acade8d$export$593755c5b8f32d8f(property, suffix, ...values) {
    const [firstValue, secondValue = firstValue, thirdValue = firstValue, fourthValue = secondValue] = values;
    const valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    const styles = {};
    for(let i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
        const newKey = property + $ab498ea24acade8d$var$positionMap[i] + suffix;
        styles[newKey] = valuesWithDefaults[i];
    }
    return styles;
}


function $c834ea95d2bb83fa$export$12879c7697ed953d(...values) {
    return (0, $ab498ea24acade8d$export$593755c5b8f32d8f)('border', 'Width', ...values);
}



function $8fd87c60144b5b82$export$4d0a7f76ad443516(...values) {
    return (0, $ab498ea24acade8d$export$593755c5b8f32d8f)('border', 'Style', ...values);
}



function $81fbcf343036416d$export$e7fb0694ba2404fc(...values) {
    return (0, $ab498ea24acade8d$export$593755c5b8f32d8f)('border', 'Color', ...values);
}


const $7b9e9bbdb4457769$var$LINE_STYLES = [
    'none',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset'
];
function $7b9e9bbdb4457769$export$92e33d7d4e8eec9a(value) {
    return $7b9e9bbdb4457769$var$LINE_STYLES.includes(value);
}


function $382cca0b98a30ce6$export$1edee58a52776cd9(...values) {
    if ((0, $7b9e9bbdb4457769$export$92e33d7d4e8eec9a)(values[0])) return {
        ...(0, $8fd87c60144b5b82$export$4d0a7f76ad443516)(values[0]),
        ...values[1] && (0, $c834ea95d2bb83fa$export$12879c7697ed953d)(values[1]),
        ...values[2] && (0, $81fbcf343036416d$export$e7fb0694ba2404fc)(values[2])
    };
    return {
        ...(0, $c834ea95d2bb83fa$export$12879c7697ed953d)(values[0]),
        ...values[1] && (0, $8fd87c60144b5b82$export$4d0a7f76ad443516)(values[1]),
        ...values[2] && (0, $81fbcf343036416d$export$e7fb0694ba2404fc)(values[2])
    };
}


function $1017a3f70150a1da$export$e2ce9f12a980a822(...values) {
    if ((0, $7b9e9bbdb4457769$export$92e33d7d4e8eec9a)(values[0])) return {
        borderBottomStyle: values[0],
        ...values[1] && {
            borderBottomWidth: values[1]
        },
        ...values[2] && {
            borderBottomColor: values[2]
        }
    };
    return {
        borderBottomWidth: values[0],
        ...values[1] && {
            borderBottomStyle: values[1]
        },
        ...values[2] && {
            borderBottomColor: values[2]
        }
    };
}


function $b2ec18e46c513e09$export$47658cca1a909427(...values) {
    if ((0, $7b9e9bbdb4457769$export$92e33d7d4e8eec9a)(values[0])) return {
        borderLeftStyle: values[0],
        ...values[1] && {
            borderLeftWidth: values[1]
        },
        ...values[2] && {
            borderLeftColor: values[2]
        }
    };
    return {
        borderLeftWidth: values[0],
        ...values[1] && {
            borderLeftStyle: values[1]
        },
        ...values[2] && {
            borderLeftColor: values[2]
        }
    };
}

/**
 * A function that implements CSS spec conformant expansion for "borderRadius". "/" is not supported, please use CSS
 * longhands directly.
 *
 * @example
 *   borderRadius('10px')
 *   borderRadius('10px', '5%')
 *   borderRadius('2px', '4px', '8px')
 *   borderRadius('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-radius
 *
 * @deprecated Just use `{ borderRadius: '10px 5% 8px 4px' }` instead as Griffel supports CSS shorthands now
 */ function $24355517cfa59275$export$7a57f79000377ca2(value1, value2 = value1, value3 = value1, value4 = value2) {
    return {
        borderBottomRightRadius: value3,
        borderBottomLeftRadius: value4,
        borderTopRightRadius: value2,
        borderTopLeftRadius: value1
    };
}


function $f75479487c0ac7f4$export$5abca33e6be905d2(...values) {
    if ((0, $7b9e9bbdb4457769$export$92e33d7d4e8eec9a)(values[0])) return {
        borderRightStyle: values[0],
        ...values[1] && {
            borderRightWidth: values[1]
        },
        ...values[2] && {
            borderRightColor: values[2]
        }
    };
    return {
        borderRightWidth: values[0],
        ...values[1] && {
            borderRightStyle: values[1]
        },
        ...values[2] && {
            borderRightColor: values[2]
        }
    };
}


function $6a479150986bd18f$export$f9a7b6bd24892946(...values) {
    if ((0, $7b9e9bbdb4457769$export$92e33d7d4e8eec9a)(values[0])) return {
        borderTopStyle: values[0],
        ...values[1] && {
            borderTopWidth: values[1]
        },
        ...values[2] && {
            borderTopColor: values[2]
        }
    };
    return {
        borderTopWidth: values[0],
        ...values[1] && {
            borderTopStyle: values[1]
        },
        ...values[2] && {
            borderTopColor: values[2]
        }
    };
}

const $5ce7dc4b8607e6a4$var$isUnit = (value)=>typeof value === 'string' && /(\d+(\w+|%))/.test(value);
const $5ce7dc4b8607e6a4$var$isUnitless = (value)=>typeof value === 'number' && !Number.isNaN(value);
const $5ce7dc4b8607e6a4$var$isInitial = (value)=>value === 'initial';
const $5ce7dc4b8607e6a4$var$isAuto = (value)=>value === 'auto';
const $5ce7dc4b8607e6a4$var$isNone = (value)=>value === 'none';
const $5ce7dc4b8607e6a4$var$widthReservedKeys = [
    'content',
    'fit-content',
    'max-content',
    'min-content'
];
const $5ce7dc4b8607e6a4$var$isWidth = (value)=>$5ce7dc4b8607e6a4$var$widthReservedKeys.some((key)=>value === key) || $5ce7dc4b8607e6a4$var$isUnit(value);
function $5ce7dc4b8607e6a4$export$97691fbb80847c19(...values) {
    const isOneValueSyntax = values.length === 1;
    const isTwoValueSyntax = values.length === 2;
    const isThreeValueSyntax = values.length === 3;
    if (isOneValueSyntax) {
        const [firstValue] = values;
        if ($5ce7dc4b8607e6a4$var$isInitial(firstValue)) return {
            flexGrow: 0,
            flexShrink: 1,
            flexBasis: 'auto'
        };
        if ($5ce7dc4b8607e6a4$var$isAuto(firstValue)) return {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 'auto'
        };
        if ($5ce7dc4b8607e6a4$var$isNone(firstValue)) return {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: 'auto'
        };
        if ($5ce7dc4b8607e6a4$var$isUnitless(firstValue)) return {
            flexGrow: firstValue,
            flexShrink: 1,
            flexBasis: 0
        };
        if ($5ce7dc4b8607e6a4$var$isWidth(firstValue)) return {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: firstValue
        };
    }
    if (isTwoValueSyntax) {
        const [firstValue, secondValue] = values;
        if ($5ce7dc4b8607e6a4$var$isUnitless(secondValue)) return {
            flexGrow: firstValue,
            flexShrink: secondValue,
            flexBasis: 0
        };
        if ($5ce7dc4b8607e6a4$var$isWidth(secondValue)) return {
            flexGrow: firstValue,
            flexShrink: 1,
            flexBasis: secondValue
        };
    }
    if (isThreeValueSyntax) {
        const [firstValue, secondValue, thirdValue] = values;
        if ($5ce7dc4b8607e6a4$var$isUnitless(firstValue) && $5ce7dc4b8607e6a4$var$isUnitless(secondValue) && ($5ce7dc4b8607e6a4$var$isAuto(thirdValue) || $5ce7dc4b8607e6a4$var$isWidth(thirdValue))) return {
            flexGrow: firstValue,
            flexShrink: secondValue,
            flexBasis: thirdValue
        };
    }
    return {};
}

/**
 * A function that implements CSS spec conformant expansion for "gap"
 *
 * @example
 *   gap('10px')
 *   gap('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/gap
 *
 * @deprecated Just use `{ gap: '10px 5px' }` instead as Griffel supports CSS shorthands now
 */ function $f93e6478305e575d$export$5df9adcb0db95e1e(columnGap, rowGap = columnGap) {
    return {
        columnGap: columnGap,
        rowGap: rowGap
    };
}

const $758b334f927783bb$var$cssVarRegEx = /var\(.*\)/gi;
function $758b334f927783bb$var$isValidGridAreaInput(value) {
    return value === undefined || typeof value === 'number' || typeof value === 'string' && !$758b334f927783bb$var$cssVarRegEx.test(value);
}
// A custom-ident can be an alpha-numeric string including dash (-), underscore, escaped (\) characters, and escaped unicode
const $758b334f927783bb$var$customIdentRegEx = /^[a-zA-Z0-9\-_\\#;]+$/;
const $758b334f927783bb$var$nonCustomIdentRegEx = /^-moz-initial$|^auto$|^initial$|^inherit$|^revert$|^unset$|^span \d+$|^\d.*/;
function $758b334f927783bb$export$aa88247a84cade50(value) {
    return value !== undefined && typeof value === 'string' && $758b334f927783bb$var$customIdentRegEx.test(value) && !$758b334f927783bb$var$nonCustomIdentRegEx.test(value);
}
function $758b334f927783bb$export$bdb486e40d52d26f(...values) {
    // if any value is not valid, then do not apply the CSS.
    if (values.some((value)=>!$758b334f927783bb$var$isValidGridAreaInput(value))) return {};
    const gridRowStart = values[0] !== undefined ? values[0] : 'auto';
    // When grid-column-start is omitted, if grid-row-start is a <custom-ident>,
    // all four longhands are set to that value.
    // Otherwise, it is set to auto.
    const gridColumnStart = values[1] !== undefined ? values[1] : $758b334f927783bb$export$aa88247a84cade50(gridRowStart) ? gridRowStart : 'auto';
    // When grid-row-end is omitted,
    // if grid-row-start is a <custom-ident>, grid-row-end is set to that <custom-ident>;
    // otherwise, it is set to auto.
    const gridRowEnd = values[2] !== undefined ? values[2] : $758b334f927783bb$export$aa88247a84cade50(gridRowStart) ? gridRowStart : 'auto';
    // When grid-column-end is omitted,
    // if grid-column-start is a <custom-ident>, grid-column-end is set to that <custom-ident>;
    // otherwise, it is set to auto.
    const gridColumnEnd = values[3] !== undefined ? values[3] : $758b334f927783bb$export$aa88247a84cade50(gridColumnStart) ? gridColumnStart : 'auto';
    return {
        gridRowStart: gridRowStart,
        gridColumnStart: gridColumnStart,
        gridRowEnd: gridRowEnd,
        gridColumnEnd: gridColumnEnd
    };
}

/**
 * A function that implements CSS spec conformant expansion for "inset"
 *
 * @example
 *   inset('10px')
 *   inset('10px', '5px')
 *   inset('2px', '4px', '8px')
 *   inset('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/inset
 *
 * @deprecated Use `{ inset: '10px 5px 8px 4px' }` instead as Griffel supports CSS shorthands now
 */ function $990fd6c745791400$export$7ce2732760c0a276(...values) {
    const [firstValue, secondValue = firstValue, thirdValue = firstValue, fourthValue = secondValue] = values;
    return {
        top: firstValue,
        right: secondValue,
        bottom: thirdValue,
        left: fourthValue
    };
}


function $02c5bdd1eb9a82b8$export$7ede87f9b603dd3c(...values) {
    return (0, $ab498ea24acade8d$export$593755c5b8f32d8f)('margin', '', ...values);
}

/**
 * A function that implements CSS spec conformant expansion for "margin-block"
 *
 * @example
 *   marginBlock('10px')
 *   marginBlock('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/margin-block
 *
 * @deprecated Just use `{ marginBlock: '10px' }` instead as Griffel supports CSS shorthands now
 */ function $224376141d2f34c4$export$9bb54ac136bea18b(start, end = start) {
    return {
        marginBlockStart: start,
        marginBlockEnd: end
    };
}

/**
 * A function that implements CSS spec conformant expansion for "margin-inline"
 *
 * @example
 *   marginInline('10px')
 *   marginInline('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/margin-inline
 *
 * @deprecated Just use `{ marginInline: '10px' }` instead as Griffel supports CSS shorthands now
 */ function $0c4c9ac2429c1320$export$c29f95372aadab80(start, end = start) {
    return {
        marginInlineStart: start,
        marginInlineEnd: end
    };
}

/**
 * A function that implements expansion for "outline", it's simplified - check usage examples.
 *
 * @example
 *  outline('2px')
 *  outline('2px', 'solid')
 *  outline('2px', 'solid', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/outline
 *
 * @deprecated Just use `{ outline: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */ function $a14b0a7158227765$export$f9258c55612cbed7(outlineWidth, outlineStyle, outlineColor) {
    return {
        outlineWidth: outlineWidth,
        ...outlineStyle && {
            outlineStyle: outlineStyle
        },
        ...outlineColor && {
            outlineColor: outlineColor
        }
    };
}

/**
 * A function that implements CSS spec conformant expansion for "overflow"
 *
 * @example
 *   overflow('hidden')
 *   overflow('hidden', 'scroll')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
 *
 * @deprecated Just use `{ overflow: 'hidden scroll' }` instead as Griffel supports CSS shorthands now
 */ function $2466deabecf60c05$export$f6530fb6e67e00bd(overflowX, overflowY = overflowX) {
    return {
        overflowX: overflowX,
        overflowY: overflowY
    };
}


function $4b81bb78d8eba2ff$export$6f98e8eaf0be1996(...values) {
    return (0, $ab498ea24acade8d$export$593755c5b8f32d8f)('padding', '', ...values);
}

/**
 * A function that implements CSS spec conformant expansion for "padding-block"
 *
 * @example
 *   paddingBlock('10px')
 *   paddingBlock('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/padding-block
 *
 * @deprecated Just use `{ paddingBlock: '10px' }` instead as Griffel supports CSS shorthands now
 */ function $cf0495958e123729$export$d811220387c2487d(start, end = start) {
    return {
        paddingBlockStart: start,
        paddingBlockEnd: end
    };
}

/**
 * A function that implements CSS spec conformant expansion for "padding-inline"
 *
 * @example
 *   paddingInline('10px')
 *   paddingInline('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/padding-inline
 *
 * @deprecated Just use `{ paddingInline: '10px' }` instead as Griffel supports CSS shorthands now
 */ function $cd614bf7c1b132d4$export$1d0e55017f110280(start, end = start) {
    return {
        paddingInlineStart: start,
        paddingInlineEnd: end
    };
}

/**
 * A function that implements expansion for "textDecoration" to all sides of an element, it's simplified - check usage examples.
 *
 * @example
 *  textDecoration('none')
 *  textDecoration('dotted')
 *  textDecoration('underline', 'dotted')
 *  textDecoration('underline', 'dotted', 'red')
 *  textDecoration('underline', 'dotted', 'red', '2px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration
 *
 * @deprecated Just use `{ textDecoration: 'underline dotted red 2px' }` instead as Griffel supports CSS shorthands now
 */ function $cf7991a9a1743608$export$6b7f9af9aa033040(value, ...values) {
    if (values.length === 0) return $cf7991a9a1743608$var$isTextDecorationStyleInput(value) ? {
        textDecorationStyle: value
    } : {
        textDecorationLine: value
    };
    const [textDecorationStyle, textDecorationColor, textDecorationThickness] = values;
    return {
        textDecorationLine: value,
        ...textDecorationStyle && {
            textDecorationStyle: textDecorationStyle
        },
        ...textDecorationColor && {
            textDecorationColor: textDecorationColor
        },
        ...textDecorationThickness && {
            textDecorationThickness: textDecorationThickness
        }
    };
}
const $cf7991a9a1743608$var$textDecorationStyleInputs = [
    'dashed',
    'dotted',
    'double',
    'solid',
    'wavy'
];
function $cf7991a9a1743608$var$isTextDecorationStyleInput(value) {
    return $cf7991a9a1743608$var$textDecorationStyleInputs.includes(value);
}

/**
 * A function that implements expansion for "transition", it's simplified - check usage examples.
 *
 * @example
 *  transition('inherit')
 *  transition('margin-right', '4s')
 *  transition('margin-right', '4s', '1s')
 *  transition('margin-right', '4s', '1s', 'ease-in')
 *  transition([
 *    ['margin-right', '4s', '1s', 'ease-in'],
 *    ['margin-right', '4s', '1s', 'ease-in'],
 * ])
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/transition
 *
 * @deprecated Just use `{ transition: 'margin-right 4s 1s ease-in' }` instead as Griffel supports CSS shorthands now
 */ function $44f0cfc2e99f3033$export$66bb15e2994e6a26(...values) {
    if ($44f0cfc2e99f3033$var$isTransitionGlobalInputs(values)) return {
        transitionDelay: values[0],
        transitionDuration: values[0],
        transitionProperty: values[0],
        transitionTimingFunction: values[0]
    };
    const transitionInputs = $44f0cfc2e99f3033$var$normalizeTransitionInputs(values);
    return transitionInputs.reduce((acc, [property, duration = '0s', delay = '0s', timingFunction = 'ease'], index)=>{
        if (index === 0) {
            acc.transitionProperty = property;
            acc.transitionDuration = duration;
            acc.transitionDelay = delay;
            acc.transitionTimingFunction = timingFunction;
        } else {
            acc.transitionProperty += `, ${property}`;
            acc.transitionDuration += `, ${duration}`;
            acc.transitionDelay += `, ${delay}`;
            acc.transitionTimingFunction += `, ${timingFunction}`;
        }
        return acc;
    }, {});
}
const $44f0cfc2e99f3033$var$transitionGlobalInputs = [
    '-moz-initial',
    'inherit',
    'initial',
    'revert',
    'unset'
];
function $44f0cfc2e99f3033$var$isTransitionGlobalInputs(values) {
    return values.length === 1 && $44f0cfc2e99f3033$var$transitionGlobalInputs.includes(values[0]);
}
function $44f0cfc2e99f3033$var$normalizeTransitionInputs(transitionInputs) {
    if (transitionInputs.length === 1 && Array.isArray(transitionInputs[0])) return transitionInputs[0];
    return [
        transitionInputs
    ];
}
























const $65b2a1446c384ca3$export$648f2124b45d7105 = {
    border: $382cca0b98a30ce6$export$1edee58a52776cd9,
    borderLeft: $b2ec18e46c513e09$export$47658cca1a909427,
    borderBottom: $1017a3f70150a1da$export$e2ce9f12a980a822,
    borderRight: $f75479487c0ac7f4$export$5abca33e6be905d2,
    borderTop: $6a479150986bd18f$export$f9a7b6bd24892946,
    borderColor: $81fbcf343036416d$export$e7fb0694ba2404fc,
    borderStyle: $8fd87c60144b5b82$export$4d0a7f76ad443516,
    borderRadius: $24355517cfa59275$export$7a57f79000377ca2,
    borderWidth: $c834ea95d2bb83fa$export$12879c7697ed953d,
    flex: $5ce7dc4b8607e6a4$export$97691fbb80847c19,
    gap: $f93e6478305e575d$export$5df9adcb0db95e1e,
    gridArea: $758b334f927783bb$export$bdb486e40d52d26f,
    margin: $02c5bdd1eb9a82b8$export$7ede87f9b603dd3c,
    marginBlock: $224376141d2f34c4$export$9bb54ac136bea18b,
    marginInline: $0c4c9ac2429c1320$export$c29f95372aadab80,
    padding: $4b81bb78d8eba2ff$export$6f98e8eaf0be1996,
    paddingBlock: $cf0495958e123729$export$d811220387c2487d,
    paddingInline: $cd614bf7c1b132d4$export$1d0e55017f110280,
    overflow: $2466deabecf60c05$export$f6530fb6e67e00bd,
    inset: $990fd6c745791400$export$7ce2732760c0a276,
    outline: $a14b0a7158227765$export$f9258c55612cbed7,
    transition: $44f0cfc2e99f3033$export$66bb15e2994e6a26,
    textDecoration: $cf7991a9a1743608$export$6b7f9af9aa033040
};








'use client';
const $98bce817719bd19f$export$6db8930890cdfadf = {
    root: 'fui-Card',
    floatingAction: 'fui-Card__floatingAction',
    checkbox: 'fui-Card__checkbox'
};
const $98bce817719bd19f$export$17baa74a499d867f = {
    cardSizeVar: '--fui-Card--size',
    cardBorderRadiusVar: '--fui-Card--border-radius'
};
const $98bce817719bd19f$var$focusOutlineStyle = {
    outlineRadius: `var(${$98bce817719bd19f$export$17baa74a499d867f.cardBorderRadiusVar})`,
    outlineWidth: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).strokeWidthThick,
    outlineOffset: '-2px'
};
const $98bce817719bd19f$var$useCardResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rfxo2k2", "rgle7w9", [
    ".rfxo2k2{overflow:hidden;border-radius:var(--fui-Card--border-radius);padding:var(--fui-Card--size);gap:var(--fui-Card--size);display:flex;position:relative;box-sizing:border-box;color:var(--colorNeutralForeground1);}",
    ".rfxo2k2::after{position:absolute;top:0;left:0;right:0;bottom:0;content:\"\";pointer-events:none;border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-radius:var(--fui-Card--border-radius);}",
    ".rfxo2k2>.fui-CardHeader,.rfxo2k2>.fui-CardFooter{flex-shrink:0;}",
    ".rgle7w9{overflow:hidden;border-radius:var(--fui-Card--border-radius);padding:var(--fui-Card--size);gap:var(--fui-Card--size);display:flex;position:relative;box-sizing:border-box;color:var(--colorNeutralForeground1);}",
    ".rgle7w9::after{position:absolute;top:0;right:0;left:0;bottom:0;content:\"\";pointer-events:none;border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-radius:var(--fui-Card--border-radius);}",
    ".rgle7w9>.fui-CardHeader,.rgle7w9>.fui-CardFooter{flex-shrink:0;}"
]);
const $98bce817719bd19f$var$disabledStyles = {
    cursor: 'not-allowed',
    userSelect: 'none',
    color: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralForegroundDisabled,
    backgroundColor: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralBackgroundDisabled,
    boxShadow: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).shadow2,
    .../*#__PURE__*/ (0, $65b2a1446c384ca3$export$648f2124b45d7105).borderColor((0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralStrokeDisabled),
    '::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: `calc(${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).zIndexContent} + 1)`
    },
    '::after': {
        .../*#__PURE__*/ (0, $65b2a1446c384ca3$export$648f2124b45d7105).borderColor((0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorNeutralStrokeDisabled)
    }
};
const $98bce817719bd19f$var$useCardStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    focused: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bqhya38: "f1j6vpng",
        Bwxa6fj: [
            "f1pniga2",
            "f1ffjurs"
        ],
        Bdhvstf: "f987i1v",
        B7zbvrb: [
            "f1ffjurs",
            "f1pniga2"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        f6g5ot: 0,
        Boxcth7: 0,
        Bhdgwq3: 0,
        hgwjuy: 0,
        Bshpdp8: 0,
        Bsom6fd: 0,
        Blkhhs4: 0,
        Bonggc9: 0,
        Ddfuxk: 0,
        i03rao: 0,
        kclons: 0,
        clg4pj: 0,
        Bpqj9nj: 0,
        B6dhp37: 0,
        Bf4ptjt: 0,
        Bqtpl0w: 0,
        i4rwgc: "fpqizxz",
        Dah5zi: 0,
        B1tsrr9: 0,
        qqdqy8: 0,
        Bkh64rk: 0,
        e3fwne: "fnd8nzh",
        J0r882: "f15fr7a0",
        Bule8hv: [
            "fwsq40z",
            "fy0y4wt"
        ],
        Bjwuhne: "f34ld9f",
        Ghsupd: [
            "fy0y4wt",
            "fwsq40z"
        ]
    },
    selectableFocused: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        Bssx7fj: "f1b1k54r",
        uh7if5: [
            "f4ne723",
            "fqqcjud"
        ],
        clntm0: "fh7aioi",
        Dlk2r6: [
            "fqqcjud",
            "f4ne723"
        ],
        h6p2u: "f1ufm4qn",
        I6qiy5: [
            "f1qnwcb4",
            "fgrk5zm"
        ],
        yzno9d: "fi52z01",
        By0wis0: [
            "fgrk5zm",
            "f1qnwcb4"
        ],
        B2j2mmj: "ffht0p2",
        wigs8: "f1p0ul1q",
        pbfy6t: "f1c901ms",
        B0v4ure: "f1alokd7",
        Byrf0fs: 0,
        Bsiemmq: 0,
        Bwckmig: 0,
        skfxo0: 0,
        Iidy0u: 0,
        B98u21t: 0,
        Bvwlmkc: 0,
        jo1ztg: 0,
        Ba1iezr: 0,
        Blmvk6g: 0,
        B24cy0v: 0,
        Bil7v7r: 0,
        Br3gin4: 0,
        nr063g: 0,
        ghq09: 0,
        Bbgo44z: 0,
        Bseh09z: "f1i978nd",
        az1dzo: 0,
        Ba3ybja: 0,
        B6352mv: 0,
        vppk2z: 0,
        Biaj6j7: "f1nh8hsq",
        B2pnrqr: "f1amxum7",
        B29w5g4: [
            "f1cec8w7",
            "f554mv0"
        ],
        Bhhzhcn: "f1sj6kbr",
        Bec0n69: [
            "f554mv0",
            "f1cec8w7"
        ]
    },
    orientationHorizontal: {
        Beiy3e4: "f1063pyq",
        Bt984gj: "f122n59",
        Binpb3b: "ftrw7vg",
        qrt8p2: "f18opajm",
        k6ws3r: [
            "f13002it",
            "fqo182t"
        ],
        Btcwela: [
            "f18yna97",
            "f1kd6wh7"
        ],
        Fer9m8: "f4i4759"
    },
    orientationVertical: {
        Beiy3e4: "f1vx9l62",
        B5nvv7i: [
            "f14k419y",
            "f1fgo9fz"
        ],
        Baxg94k: [
            "f1fgo9fz",
            "f14k419y"
        ],
        tn21ii: "fvqmfsm",
        B0ud6bj: "f3am6yf",
        Bgdo4j: "f1r5wgso"
    },
    sizeSmall: {
        B7balbw: "f1pi9uxy",
        B1h88n7: "f1h1zgly"
    },
    sizeMedium: {
        B7balbw: "frsmuga",
        B1h88n7: "fuldkky"
    },
    sizeLarge: {
        B7balbw: "f1qua4xo",
        B1h88n7: "fimkt6v"
    },
    interactive: {
        rhjd8f: "f1epqm3e"
    },
    filled: {
        De3pzq: "fxugw4r",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ]
    },
    filledInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "fxugw4r",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ],
        Bi91k9c: "feu1g3u",
        Jwef8y: "f1knas48",
        Bvxd0ez: "f1m145df",
        ecr2s2: "fb40n2d"
    },
    filledInteractiveSelected: {
        De3pzq: "f1nfm20t",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Bi91k9c: "fx9teim",
        Jwef8y: "f1kz6goq"
    },
    filledAlternative: {
        De3pzq: "f1dmdbja",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ]
    },
    filledAlternativeInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "f1dmdbja",
        E5pizo: "f1whvlc6",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ],
        Bi91k9c: "fnwyq0v",
        Jwef8y: "f1uvynv3",
        Bvxd0ez: "f1m145df",
        ecr2s2: "f1yhgkbh"
    },
    filledAlternativeInteractiveSelected: {
        De3pzq: "fjxa0vh",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Bi91k9c: "f1luvkty",
        Jwef8y: "fehi0vp"
    },
    outline: {
        De3pzq: "f1c21dwh",
        E5pizo: "f1couhl3",
        B0n5ga8: "ft83z1f",
        s924m2: [
            "f1g4150c",
            "f192dr6e"
        ],
        B1q35kw: "f1qnawh6",
        Gp14am: [
            "f192dr6e",
            "f1g4150c"
        ]
    },
    outlineInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "f1c21dwh",
        E5pizo: "f1couhl3",
        B0n5ga8: "ft83z1f",
        s924m2: [
            "f1g4150c",
            "f192dr6e"
        ],
        B1q35kw: "f1qnawh6",
        Gp14am: [
            "f192dr6e",
            "f1g4150c"
        ],
        Bi91k9c: "feu1g3u",
        Jwef8y: "fjxutwb",
        Be0v6ae: "f1llr77y",
        B5kxglz: [
            "fzk0khw",
            "fjj8tog"
        ],
        B3pwyw6: "fb1u8ub",
        Bymgtzf: [
            "fjj8tog",
            "fzk0khw"
        ],
        ecr2s2: "fophhak",
        dmfk: "f1uohb70",
        B4ofi8: [
            "f1jm7v1n",
            "f1bus3rq"
        ],
        jgq6uv: "f1fbu7rr",
        Baxewws: [
            "f1bus3rq",
            "f1jm7v1n"
        ]
    },
    outlineInteractiveSelected: {
        De3pzq: "f1q9pm1r",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Bi91k9c: "fx9teim",
        Jwef8y: "fg59vm4"
    },
    outlineDisabled: {
        De3pzq: "f1c21dwh",
        E5pizo: "f1couhl3",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        ezxybo: "f1ls5moo",
        wc7uws: "f1qiza15",
        B0n5ga8: "f13dj02",
        s924m2: [
            "f9wngki",
            "f17v59j0"
        ],
        B1q35kw: "f1vxzwsp",
        Gp14am: [
            "f17v59j0",
            "f9wngki"
        ]
    },
    subtle: {
        De3pzq: "fhovq9v",
        E5pizo: "f1couhl3",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ]
    },
    subtleInteractive: {
        Bceei9c: "f1k6fduh",
        De3pzq: "fhovq9v",
        E5pizo: "f1couhl3",
        B0n5ga8: "f16gxe2i",
        s924m2: [
            "fpgykix",
            "fzybk4o"
        ],
        B1q35kw: "f1osi826",
        Gp14am: [
            "fzybk4o",
            "fpgykix"
        ],
        Bi91k9c: "feu1g3u",
        Jwef8y: "f1t94bn6",
        ecr2s2: "f1wfn5kd"
    },
    subtleInteractiveSelected: {
        De3pzq: "fq5gl1p",
        B0n5ga8: "f16eln5f",
        s924m2: [
            "fa2okxs",
            "fg4zq3l"
        ],
        B1q35kw: "ff6932p",
        Gp14am: [
            "fg4zq3l",
            "fa2okxs"
        ],
        Bi91k9c: "fx9teim",
        Jwef8y: "f1uqaxdt"
    },
    highContrastSelected: {
        B8gzw0y: "f1h3a8gf",
        By8wz76: "f1nz3ub2",
        B7iucu3: "fqc85l4",
        Boo9lyk: "f1ucc5z8",
        sga51p: "fyj59f4",
        qj1yg9: [
            "f19v95gn",
            "f1n69f6i"
        ],
        B8acmzm: "f16q7dot",
        Gezqo6: [
            "f1n69f6i",
            "f19v95gn"
        ]
    },
    highContrastInteractive: {
        waf3gn: "f1quqgnd",
        B96h8j5: "f193utb4",
        Bpd3jnq: "f1io67iv",
        uhbujs: "f3n01jk",
        sga51p: "fyj59f4",
        qj1yg9: [
            "f19v95gn",
            "f1n69f6i"
        ],
        B8acmzm: "f16q7dot",
        Gezqo6: [
            "f1n69f6i",
            "f19v95gn"
        ]
    },
    select: {
        qhf8xq: "f1euv43f",
        Bhzewxz: "fqclxi7",
        j35jbq: [
            "fiv86kb",
            "f36uhnt"
        ],
        Bj3rh1h: "fom9my7"
    },
    hiddenCheckbox: {
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        a9b677: "frkrog8",
        Bqenvij: "f1mpe4l3",
        qhf8xq: "f1euv43f",
        Bh84pgu: "fmf1zke",
        Bgl5zvf: "f1wch0ki",
        Huce71: "fz5stix"
    },
    disabled: {
        Bceei9c: "fdrzuqr",
        famaaq: "f1xqy1su",
        sj55zd: "f1s2aq7o",
        De3pzq: "f1bg9a2p",
        E5pizo: "fyed02w",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        Ftih45: "f1wl9k8s",
        Brfgrao: "f1j7ml58",
        lawp4y: 0,
        Fbdkly: 0,
        mdwyqc: 0,
        Bciustq: 0,
        gc50h5: "f13vvzas",
        Ehzi8l: "f198lalb",
        B0n5ga8: "f13dj02",
        s924m2: [
            "f9wngki",
            "f17v59j0"
        ],
        B1q35kw: "f1vxzwsp",
        Gp14am: [
            "f17v59j0",
            "f9wngki"
        ],
        Bikrtoi: "f11og98d",
        G8qf51: "f1rg3h4v",
        Brxh4y7: "fbm2y3b",
        ezxybo: "f4yodeu",
        wc7uws: "fcwfbwp",
        gp3uxg: "f1repx37",
        Fohawp: [
            "f1ybi8ct",
            "f1h4eg6q"
        ],
        Bxulg6k: "f18mejnb",
        vcjq4m: [
            "f1h4eg6q",
            "f1ybi8ct"
        ],
        Bsqkqe9: "f1nift3m",
        fskg1g: "f1wu3i8x",
        iwiei9: 0,
        Effecx: 0,
        Bkt1b9m: 0,
        jfmxvr: 0,
        orauir: "f6v4vfa",
        B2yd9ot: "folrdqs",
        Fn9tzk: "f168z5yf",
        Bv0wker: [
            "fpor7gj",
            "fzextn6"
        ],
        Bp2dl5b: "f1yaw79v",
        pzn0iz: [
            "fzextn6",
            "fpor7gj"
        ]
    }
}, {
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    d: [
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        [
            ".fpqizxz[data-fui-focus-visible]::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}",
            {
                p: -2
            }
        ],
        [
            ".fnd8nzh[data-fui-focus-visible]::after{border-radius:var(--fui-Card--border-radius);}",
            {
                p: -1
            }
        ],
        ".f15fr7a0[data-fui-focus-visible]::after{top:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".fwsq40z[data-fui-focus-visible]::after{right:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".fy0y4wt[data-fui-focus-visible]::after{left:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f34ld9f[data-fui-focus-visible]::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1b1k54r[data-fui-focus-within]:focus-within{border-top-color:transparent;}",
        ".f4ne723[data-fui-focus-within]:focus-within{border-right-color:transparent;}",
        ".fqqcjud[data-fui-focus-within]:focus-within{border-left-color:transparent;}",
        ".fh7aioi[data-fui-focus-within]:focus-within{border-bottom-color:transparent;}",
        ".ffht0p2[data-fui-focus-within]:focus-within::after{content:\"\";}",
        ".f1p0ul1q[data-fui-focus-within]:focus-within::after{position:absolute;}",
        ".f1c901ms[data-fui-focus-within]:focus-within::after{pointer-events:none;}",
        ".f1alokd7[data-fui-focus-within]:focus-within::after{z-index:1;}",
        [
            ".f1i978nd[data-fui-focus-within]:focus-within::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}",
            {
                p: -2
            }
        ],
        [
            ".f1nh8hsq[data-fui-focus-within]:focus-within::after{border-radius:var(--fui-Card--border-radius);}",
            {
                p: -1
            }
        ],
        ".f1amxum7[data-fui-focus-within]:focus-within::after{top:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1cec8w7[data-fui-focus-within]:focus-within::after{right:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f554mv0[data-fui-focus-within]:focus-within::after{left:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1sj6kbr[data-fui-focus-within]:focus-within::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}",
        ".f1063pyq{flex-direction:row;}",
        ".f122n59{align-items:center;}",
        ".ftrw7vg>.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}",
        ".f18opajm>.fui-CardPreview{margin-bottom:calc(var(--fui-Card--size) * -1);}",
        ".f13002it>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-left:calc(var(--fui-Card--size) * -1);}",
        ".fqo182t>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-right:calc(var(--fui-Card--size) * -1);}",
        ".f18yna97>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-right:calc(var(--fui-Card--size) * -1);}",
        ".f1kd6wh7>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-left:calc(var(--fui-Card--size) * -1);}",
        ".f4i4759>.fui-CardHeader:last-of-type,.f4i4759>.fui-CardFooter:last-of-type{flex-grow:1;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f14k419y>.fui-CardPreview{margin-left:calc(var(--fui-Card--size) * -1);}",
        ".f1fgo9fz>.fui-CardPreview{margin-right:calc(var(--fui-Card--size) * -1);}",
        ".fvqmfsm>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-top:calc(var(--fui-Card--size) * -1);}",
        ".f3am6yf>.fui-Card__floatingAction+.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}",
        ".f1r5wgso>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-bottom:calc(var(--fui-Card--size) * -1);}",
        ".f1pi9uxy{--fui-Card--size:8px;}",
        ".f1h1zgly{--fui-Card--border-radius:var(--borderRadiusSmall);}",
        ".frsmuga{--fui-Card--size:12px;}",
        ".fuldkky{--fui-Card--border-radius:var(--borderRadiusMedium);}",
        ".f1qua4xo{--fui-Card--size:16px;}",
        ".fimkt6v{--fui-Card--border-radius:var(--borderRadiusLarge);}",
        ".f1epqm3e .fui-Text{color:currentColor;}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1whvlc6{box-shadow:var(--shadow4);}",
        ".f16gxe2i::after{border-top-color:var(--colorTransparentStroke);}",
        ".fpgykix::after{border-right-color:var(--colorTransparentStroke);}",
        ".fzybk4o::after{border-left-color:var(--colorTransparentStroke);}",
        ".f1osi826::after{border-bottom-color:var(--colorTransparentStroke);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}",
        ".f16eln5f::after{border-top-color:var(--colorNeutralStroke1Selected);}",
        ".fa2okxs::after{border-right-color:var(--colorNeutralStroke1Selected);}",
        ".fg4zq3l::after{border-left-color:var(--colorNeutralStroke1Selected);}",
        ".ff6932p::after{border-bottom-color:var(--colorNeutralStroke1Selected);}",
        ".f1dmdbja{background-color:var(--colorNeutralBackground2);}",
        ".fjxa0vh{background-color:var(--colorNeutralBackground2Selected);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1couhl3{box-shadow:none;}",
        ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}",
        ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}",
        ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}",
        ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f13dj02::after{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f9wngki::after{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f17v59j0::after{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1vxzwsp::after{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1euv43f{position:absolute;}",
        ".fqclxi7{top:4px;}",
        ".fiv86kb{right:4px;}",
        ".f36uhnt{left:4px;}",
        ".fom9my7{z-index:var(--zIndexContent, 1);}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".frkrog8{width:1px;}",
        ".f1mpe4l3{height:1px;}",
        ".fmf1zke{clip:rect(0 0 0 0);}",
        ".f1wch0ki{clip-path:inset(50%);}",
        ".fz5stix{white-space:nowrap;}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1xqy1su{-webkit-user-select:none;-moz-user-select:none;user-select:none;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".fyed02w{box-shadow:var(--shadow2);}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1j7ml58::before{position:absolute;}",
        [
            ".f13vvzas::before{inset:0;}",
            {
                p: -1
            }
        ],
        ".f198lalb::before{z-index:calc(var(--zIndexContent, 1) + 1);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1j6vpng[data-fui-focus-visible]::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ffjurs[data-fui-focus-visible]::after{border-left-color:Highlight;}.f1pniga2[data-fui-focus-visible]::after{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f987i1v[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ufm4qn[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1qnwcb4[data-fui-focus-within]:focus-within::after{border-right-color:Highlight;}.fgrk5zm[data-fui-focus-within]:focus-within::after{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fi52z01[data-fui-focus-within]:focus-within::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1h3a8gf{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1nz3ub2{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fqc85l4{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ucc5z8 .fui-CardPreview,.f1ucc5z8 .fui-CardFooter{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fyj59f4::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f19v95gn::after{border-right-color:Highlight;}.f1n69f6i::after{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16q7dot::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1quqgnd:hover,.f1quqgnd :active{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f193utb4:hover,.f193utb4 :active{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1io67iv:hover,.f1io67iv :active{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3n01jk:hover .fui-CardPreview,.f3n01jk :active .fui-CardPreview,.f3n01jk:hover .fui-CardFooter,.f3n01jk :active .fui-CardFooter{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    h: [
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".f1m145df:hover{box-shadow:var(--shadow8);}",
        ".fx9teim:hover{color:var(--colorNeutralForeground1Selected);}",
        ".f1kz6goq:hover{background-color:var(--colorNeutralBackground1Selected);}",
        ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",
        ".f1uvynv3:hover{background-color:var(--colorNeutralBackground2Hover);}",
        ".f1luvkty:hover{color:var(--colorNeutralForeground2Selected);}",
        ".fehi0vp:hover{background-color:var(--colorNeutralBackground2Selected);}",
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f1llr77y:hover::after{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".fzk0khw:hover::after{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".fjj8tog:hover::after{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".fb1u8ub:hover::after{border-bottom-color:var(--colorNeutralStroke1Hover);}",
        ".fg59vm4:hover{background-color:var(--colorTransparentBackgroundSelected);}",
        ".f1ls5moo:hover,.f1ls5moo:active{background-color:var(--colorTransparentBackground);}",
        ".f1qiza15:hover,.f1qiza15:active{box-shadow:none;}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".f1uqaxdt:hover{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f11og98d:hover,.f11og98d:active{cursor:not-allowed;}",
        ".f1rg3h4v:hover,.f1rg3h4v:active{-webkit-user-select:none;-moz-user-select:none;user-select:none;}",
        ".fbm2y3b:hover,.fbm2y3b:active{color:var(--colorNeutralForegroundDisabled);}",
        ".f4yodeu:hover,.f4yodeu:active{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".fcwfbwp:hover,.fcwfbwp:active{box-shadow:var(--shadow2);}",
        ".f1repx37:hover,.f1repx37:active{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1ybi8ct:hover,.f1ybi8ct:active{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f1h4eg6q:hover,.f1h4eg6q:active{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f18mejnb:hover,.f18mejnb:active{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1nift3m:hover::before,.f1nift3m:active::before{content:\"\";}",
        ".f1wu3i8x:hover::before,.f1wu3i8x:active::before{position:absolute;}",
        [
            ".f6v4vfa:hover::before,.f6v4vfa:active::before{inset:0;}",
            {
                p: -1
            }
        ],
        ".folrdqs:hover::before,.folrdqs:active::before{z-index:calc(var(--zIndexContent, 1) + 1);}",
        ".f168z5yf:hover::after,.f168z5yf:active::after{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".fpor7gj:hover::after,.fpor7gj:active::after{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fzextn6:hover::after,.fzextn6:active::after{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1yaw79v:hover::after,.f1yaw79v:active::after{border-bottom-color:var(--colorNeutralStrokeDisabled);}"
    ],
    a: [
        ".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}",
        ".f1yhgkbh:active{background-color:var(--colorNeutralBackground2Pressed);}",
        ".fophhak:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f1uohb70:active::after{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f1jm7v1n:active::after{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f1bus3rq:active::after{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1fbu7rr:active::after{border-bottom-color:var(--colorNeutralStroke1Pressed);}",
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"
    ]
});
const $98bce817719bd19f$export$408cc720307531f7 = (state)=>{
    const resetStyles = $98bce817719bd19f$var$useCardResetStyles();
    const styles = $98bce817719bd19f$var$useCardStyles();
    const orientationMap = {
        horizontal: styles.orientationHorizontal,
        vertical: styles.orientationVertical
    };
    const sizeMap = {
        small: styles.sizeSmall,
        medium: styles.sizeMedium,
        large: styles.sizeLarge
    };
    const appearanceMap = {
        filled: styles.filled,
        'filled-alternative': styles.filledAlternative,
        outline: styles.outline,
        subtle: styles.subtle
    };
    const selectedMap = {
        filled: styles.filledInteractiveSelected,
        'filled-alternative': styles.filledAlternativeInteractiveSelected,
        outline: styles.outlineInteractiveSelected,
        subtle: styles.subtleInteractiveSelected
    };
    const interactiveMap = {
        filled: styles.filledInteractive,
        'filled-alternative': styles.filledAlternativeInteractive,
        outline: styles.outlineInteractive,
        subtle: styles.subtleInteractive
    };
    const isSelectableOrInteractive = !state.disabled && (state.interactive || state.selectable);
    const focusedClassName = $acw62.useMemo(()=>{
        if (state.disabled) return '';
        if (state.selectable) {
            if (state.selectFocused) return styles.selectableFocused;
            return '';
        }
        return styles.focused;
    }, [
        state.disabled,
        state.selectFocused,
        state.selectable,
        styles.focused,
        styles.selectableFocused
    ]);
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($98bce817719bd19f$export$6db8930890cdfadf.root, resetStyles, orientationMap[state.orientation], sizeMap[state.size], appearanceMap[state.appearance], isSelectableOrInteractive && styles.interactive, isSelectableOrInteractive && interactiveMap[state.appearance], state.selected && selectedMap[state.appearance], focusedClassName, isSelectableOrInteractive && styles.highContrastInteractive, state.selected && styles.highContrastSelected, state.disabled && styles.disabled, state.disabled && state.appearance === 'outline' && styles.outlineDisabled, state.root.className);
    if (state.floatingAction) // eslint-disable-next-line react-hooks/immutability
    state.floatingAction.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($98bce817719bd19f$export$6db8930890cdfadf.floatingAction, styles.select, state.floatingAction.className);
    if (state.checkbox) // eslint-disable-next-line react-hooks/immutability
    state.checkbox.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($98bce817719bd19f$export$6db8930890cdfadf.checkbox, styles.hiddenCheckbox, state.checkbox.className);
    return state;
};


function $e9c6f80421afa875$export$ce78727e36cd3d2c({ selectableA11yProps: selectableA11yProps }) {
    return {
        selectableA11yProps: selectableA11yProps
    };
}



'use client';
const $6cbe9bc797fdbc91$export$60332b2344f7fe41 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $286f73972e25332e$export$7312a9ff4417f572)(props, ref);
    const cardContextValue = (0, $e9c6f80421afa875$export$ce78727e36cd3d2c)(state);
    (0, $98bce817719bd19f$export$408cc720307531f7)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useCardStyles_unstable')(state);
    return (0, $4d8624d7d9c36ac1$export$cfc6040d9efe83ba)(state, cardContextValue);
});
$6cbe9bc797fdbc91$export$60332b2344f7fe41.displayName = 'Card';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


'use client';
/**
 * Finds the first child of CardHeader with an id prop.
 *
 * @param header - the header prop of CardHeader
 */ function $20ec70847b7e9c85$var$getChildWithId(header) {
    function isReactElementWithIdProp(element) {
        return $acw62.isValidElement(element) && Boolean(element.props.id);
    }
    return $acw62.Children.toArray(header).find(isReactElementWithIdProp);
}
/**
 * Returns the id to use for the CardHeader root element.
 *
 * @param headerId - the id prop of the CardHeader component
 * @param childWithId - the first child of the CardHeader component with an id prop
 * @param generatedId - a generated id
 *
 * @returns the id to use for the CardHeader root element
 */ function $20ec70847b7e9c85$var$getReferenceId(headerId, childWithId, generatedId) {
    if (headerId) return headerId;
    if (childWithId === null || childWithId === void 0 ? void 0 : childWithId.props.id) return childWithId.props.id;
    return generatedId;
}
const $20ec70847b7e9c85$export$a37de05d2ffee789 = (props, ref)=>{
    return $20ec70847b7e9c85$export$7a4622dbcda3588e(props, ref);
};
const $20ec70847b7e9c85$export$7a4622dbcda3588e = (props, ref)=>{
    const { image: image, header: header, description: description, action: action } = props;
    const { selectableA11yProps: { referenceId: referenceId, setReferenceId: setReferenceId } } = (0, $eecf8fa9ba90d928$export$a48f47fa4aca13ad)();
    const headerRef = $acw62.useRef(null);
    const hasChildId = $acw62.useRef(false);
    const generatedId = (0, $0200d30cfa270435$export$f680877a34711e37)('fui-CardHeader__header', referenceId);
    // eslint-disable-next-line react-hooks/refs
    const headerSlot = (0, $fcf7ddccaab7fd8f$exports).optional(header, {
        renderByDefault: true,
        defaultProps: {
            ref: headerRef,
            // eslint-disable-next-line react-hooks/refs
            id: !hasChildId.current ? referenceId : undefined
        },
        elementType: 'div'
    });
    $acw62.useEffect(()=>{
        var _headerRef_current;
        const headerId = !hasChildId.current ? (_headerRef_current = headerRef.current) === null || _headerRef_current === void 0 ? void 0 : _headerRef_current.id : undefined;
        const childWithId = $20ec70847b7e9c85$var$getChildWithId(headerSlot === null || headerSlot === void 0 ? void 0 : headerSlot.children);
        hasChildId.current = Boolean(childWithId);
        setReferenceId($20ec70847b7e9c85$var$getReferenceId(headerId, childWithId, generatedId));
    }, [
        generatedId,
        header,
        headerSlot,
        setReferenceId
    ]);
    return {
        components: {
            root: 'div',
            image: 'div',
            header: 'div',
            description: 'div',
            action: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        image: (0, $fcf7ddccaab7fd8f$exports).optional(image, {
            elementType: 'div'
        }),
        header: headerSlot,
        description: (0, $fcf7ddccaab7fd8f$exports).optional(description, {
            elementType: 'div'
        }),
        action: (0, $fcf7ddccaab7fd8f$exports).optional(action, {
            elementType: 'div'
        })
    };
};




const $2d0bed9555a24e1d$export$665f51e880b2cd0 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.image && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.image, {}),
            state.header && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.header, {}),
            state.description && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.description, {}),
            state.action && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.action, {})
        ]
    });
};



'use client';
const $3cd5d01c990b9887$export$df93a060b7c73c6c = {
    root: 'fui-CardHeader',
    image: 'fui-CardHeader__image',
    header: 'fui-CardHeader__header',
    description: 'fui-CardHeader__description',
    action: 'fui-CardHeader__action'
};
const $3cd5d01c990b9887$export$a6bb0bb6a538f6f7 = {
    cardHeaderGapVar: '--fui-CardHeader--gap'
};
const $3cd5d01c990b9887$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bkc6ea2: "fkufhic",
        Bt984gj: "f122n59"
    },
    image: {
        mc9l5x: "ftuwxu6",
        t21cq0: [
            "fql5097",
            "f6yss9k"
        ]
    },
    header: {
        mc9l5x: "f22iagw"
    },
    description: {
        mc9l5x: "f22iagw"
    },
    action: {
        Frg6f3: [
            "f6yss9k",
            "fql5097"
        ],
        rjrqlh: "fs9eatd",
        Boue1pl: [
            "fxoo9ru",
            "f1g0ekvh"
        ],
        Bhz1vi0: "f1m6zfxz",
        etxrgc: [
            "f1g0ekvh",
            "fxoo9ru"
        ],
        Bdua9ef: "f1sret3r",
        cbfxhg: "fs4gbcv"
    }
}, {
    d: [
        ".fkufhic{--fui-CardHeader--gap:12px;}",
        ".f122n59{align-items:center;}",
        ".ftuwxu6{display:inline-flex;}",
        ".fql5097{margin-right:var(--fui-CardHeader--gap);}",
        ".f6yss9k{margin-left:var(--fui-CardHeader--gap);}",
        ".f22iagw{display:flex;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fs9eatd .fui-Button,.fs9eatd .fui-Link{border-top-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1g0ekvh .fui-Button,.f1g0ekvh .fui-Link{border-left-color:currentColor;}.fxoo9ru .fui-Button,.fxoo9ru .fui-Link{border-right-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1m6zfxz .fui-Button,.f1m6zfxz .fui-Link{border-bottom-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1sret3r .fui-Button,.f1sret3r .fui-Link{color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fs4gbcv .fui-Button,.fs4gbcv .fui-Link{outline-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $3cd5d01c990b9887$var$useStylesGrid = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f13qh94s",
        t4k1zu: "f8a668j"
    },
    image: {
        Br312pm: "fwpfdsa",
        Ijaq50: "fldnz9j"
    },
    header: {
        Br312pm: "fd46tj4",
        Ijaq50: "f16hsg94"
    },
    description: {
        Br312pm: "fd46tj4",
        Ijaq50: "faunodf"
    },
    action: {
        Br312pm: "fis13di",
        Ijaq50: "fldnz9j"
    }
}, {
    d: [
        ".f13qh94s{display:grid;}",
        ".f8a668j{grid-auto-columns:min-content 1fr min-content;}",
        ".fwpfdsa{grid-column-start:1;}",
        ".fldnz9j{grid-row-start:span 2;}",
        ".fd46tj4{grid-column-start:2;}",
        ".f16hsg94{grid-row-start:1;}",
        ".faunodf{grid-row-start:2;}",
        ".fis13di{grid-column-start:3;}"
    ]
});
const $3cd5d01c990b9887$var$useStylesFlex = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw"
    },
    header: {
        Bh6795r: "fqerorx"
    },
    image: {},
    description: {},
    action: {}
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}"
    ]
});
const $3cd5d01c990b9887$export$27a3c83e50d44fdd = (state)=>{
    const styles = $3cd5d01c990b9887$var$useStyles();
    const stylesGrid = $3cd5d01c990b9887$var$useStylesGrid();
    const stylesFlex = $3cd5d01c990b9887$var$useStylesFlex();
    const boxModelStyles = state.description ? stylesGrid : stylesFlex;
    const getSlotStyles = (slotName)=>{
        var _state_slotName;
        return (0, $00898283de415a49$export$3d46f4579dba46e5)($3cd5d01c990b9887$export$df93a060b7c73c6c[slotName], styles[slotName], boxModelStyles[slotName], (_state_slotName = state[slotName]) === null || _state_slotName === void 0 ? void 0 : _state_slotName.className);
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = getSlotStyles('root');
    if (state.image) // eslint-disable-next-line react-hooks/immutability
    state.image.className = getSlotStyles('image');
    if (state.header) // eslint-disable-next-line react-hooks/immutability
    state.header.className = getSlotStyles('header');
    if (state.description) // eslint-disable-next-line react-hooks/immutability
    state.description.className = getSlotStyles('description');
    if (state.action) // eslint-disable-next-line react-hooks/immutability
    state.action.className = getSlotStyles('action');
    return state;
};



'use client';
const $e23feb91a07e879e$export$5665775b26e26c5d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $20ec70847b7e9c85$export$a37de05d2ffee789)(props, ref);
    (0, $3cd5d01c990b9887$export$27a3c83e50d44fdd)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useCardHeaderStyles_unstable')(state);
    return (0, $2d0bed9555a24e1d$export$665f51e880b2cd0)(state);
});
$e23feb91a07e879e$export$5665775b26e26c5d.displayName = 'CardHeader';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $9be8a0b8d40bba68$var$FieldContext = $acw62.createContext(undefined);
const $9be8a0b8d40bba68$export$f9a33f37cefdc55a = $9be8a0b8d40bba68$var$FieldContext.Provider;
const $9be8a0b8d40bba68$export$100197406d2d5de2 = ()=>$acw62.useContext($9be8a0b8d40bba68$var$FieldContext);


'use client';
function $af5cf4826b6cd175$export$fc5228adfb2d94ce(props, options) {
    return $af5cf4826b6cd175$export$6628ce0d0b903197((0, $9be8a0b8d40bba68$export$100197406d2d5de2)(), props, options);
}
function $af5cf4826b6cd175$export$6628ce0d0b903197(context, props, options) {
    if (!context) return props;
    // Create a copy of props so we don't modify the original
    props = {
        ...props
    };
    const { generatedControlId: generatedControlId, hintId: hintId, labelFor: labelFor, labelId: labelId, required: required, validationMessageId: validationMessageId, validationState: validationState } = context;
    if (generatedControlId) {
        var _props;
        var _id;
        (_id = (_props = props).id) !== null && _id !== void 0 ? _id : _props.id = generatedControlId;
    }
    // Set aria-labelledby if the control doesn't support label.htmlFor, or if the label's htmlFor doesn't refer
    // to this control (i.e. the user set this control's id prop without also setting the Field's label.htmlFor).
    if (labelId && (!(options === null || options === void 0 ? void 0 : options.supportsLabelFor) || labelFor !== props.id)) {
        var _props1, _arialabelledby;
        var _;
        (_ = (_props1 = props)[_arialabelledby = 'aria-labelledby']) !== null && _ !== void 0 ? _ : _props1[_arialabelledby] = labelId;
    }
    // The control is described by the validation message, or hint, or both.
    // We also preserve and append any aria-describedby from props.
    // For reference: https://github.com/microsoft/fluentui/pull/25580#discussion_r1017259933
    if (validationMessageId || hintId) // NOTE: Not using ??= since we're merging and overriding the user-provided value.
    props['aria-describedby'] = [
        validationMessageId,
        hintId,
        props === null || props === void 0 ? void 0 : props['aria-describedby']
    ].filter(Boolean).join(' ');
    if (validationState === 'error') {
        var _props2, _ariainvalid;
        var _1;
        (_1 = (_props2 = props)[_ariainvalid = 'aria-invalid']) !== null && _1 !== void 0 ? _1 : _props2[_ariainvalid] = true;
    }
    if (required) {
        if (options === null || options === void 0 ? void 0 : options.supportsRequired) {
            var _props3;
            var _required;
            (_required = (_props3 = props).required) !== null && _required !== void 0 ? _required : _props3.required = true;
        } else {
            var _props4, _ariarequired;
            var _2;
            (_2 = (_props4 = props)[_ariarequired = 'aria-required']) !== null && _2 !== void 0 ? _2 : _props4[_ariarequired] = true;
        }
    }
    // Include the size prop if this control supports it
    if (options === null || options === void 0 ? void 0 : options.supportsSize) {
        var _props5;
        var _size;
        (_size = (_props5 = props).size) !== null && _size !== void 0 ? _size : _props5.size = context.size;
    }
    return props;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


'use client';
function $445ef382aaae6992$export$22c92c328db732ac() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const keyborgRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        const targetWindow = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
        if (targetWindow) {
            const keyborg = (0, $134104a7b4fa5d8e$export$9ccd7417191c0e4b)(targetWindow);
            keyborgRef.current = keyborg;
            return ()=>{
                (0, $134104a7b4fa5d8e$export$6c71cf8529293a97)(keyborg);
                keyborgRef.current = null;
            };
        }
    }, [
        targetDocument
    ]);
    return keyborgRef;
}


'use client';
function $6056a079b6515181$export$38848de96c4734a8(callback) {
    const keyborgRef = (0, $445ef382aaae6992$export$22c92c328db732ac)();
    const eventCallback = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(callback);
    $acw62.useEffect(()=>{
        const keyborg = keyborgRef.current;
        if (keyborg) {
            const cb = (next)=>{
                eventCallback(next);
            };
            keyborg.subscribe(cb);
            cb(keyborg.isNavigatingWithKeyboard());
            return ()=>{
                keyborg.unsubscribe(cb);
            };
        }
    }, [
        keyborgRef,
        eventCallback
    ]);
}



var $acw62 = parcelRequire("acw62");


'use client';
function $a7f855c6581d7cab$export$a26fa0246760c6e6(options) {
    const { matchOption: matchOption } = options;
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const treeWalkerRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const optionFilter = $acw62.useCallback((node)=>{
        if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(node) && matchOption(node)) return NodeFilter.FILTER_ACCEPT;
        return NodeFilter.FILTER_SKIP;
    }, [
        matchOption
    ]);
    const setListbox = $acw62.useCallback((el)=>{
        if (el && targetDocument) {
            listboxRef.current = el;
            treeWalkerRef.current = targetDocument.createTreeWalker(el, NodeFilter.SHOW_ELEMENT, optionFilter);
        } else {
            listboxRef.current = null;
            treeWalkerRef.current = null;
        }
    }, [
        targetDocument,
        optionFilter
    ]);
    const optionWalker = $acw62.useMemo(()=>({
            first: ()=>{
                if (!treeWalkerRef.current || !listboxRef.current) return null;
                treeWalkerRef.current.currentNode = listboxRef.current;
                return treeWalkerRef.current.firstChild();
            },
            last: ()=>{
                if (!treeWalkerRef.current || !listboxRef.current) return null;
                treeWalkerRef.current.currentNode = listboxRef.current;
                return treeWalkerRef.current.lastChild();
            },
            next: ()=>{
                if (!treeWalkerRef.current) return null;
                return treeWalkerRef.current.nextNode();
            },
            prev: ()=>{
                if (!treeWalkerRef.current) return null;
                return treeWalkerRef.current.previousNode();
            },
            find: (predicate, startFrom)=>{
                if (!treeWalkerRef.current || !listboxRef.current) return null;
                const start = startFrom ? targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.getElementById(startFrom) : null;
                treeWalkerRef.current.currentNode = start !== null && start !== void 0 ? start : listboxRef.current;
                let cur = treeWalkerRef.current.currentNode;
                while(cur && !predicate(cur.id))cur = treeWalkerRef.current.nextNode();
                return cur;
            },
            setCurrent: (el)=>{
                if (!treeWalkerRef.current) return;
                treeWalkerRef.current.currentNode = el;
            }
        }), [
        targetDocument
    ]);
    return {
        optionWalker: optionWalker,
        listboxCallbackRef: setListbox
    };
}


/**
 * Applied to the element that is active descendant
 */ const $fc1733cf7c32aa48$export$26fcc5a6901acc3c = 'data-activedescendant';
const $fc1733cf7c32aa48$export$33faf83683cd9855 = 'data-activedescendant-focusvisible';


const $879a503962c4545a$export$53a0910f038337bd = (target)=>{
    if (!target) return;
    const scrollParent = $879a503962c4545a$var$findScrollableParent(target.parentElement);
    if (!scrollParent) return;
    const { offsetHeight: offsetHeight } = target;
    const offsetTop = $879a503962c4545a$var$getTotalOffsetTop(target, scrollParent);
    const { scrollMarginTop: scrollMarginTop, scrollMarginBottom: scrollMarginBottom } = $879a503962c4545a$var$getScrollMargins(target);
    const { offsetHeight: parentOffsetHeight, scrollTop: scrollTop } = scrollParent;
    const isAbove = offsetTop - scrollMarginTop < scrollTop;
    const isBelow = offsetTop + offsetHeight + scrollMarginBottom > scrollTop + parentOffsetHeight;
    const buffer = 2;
    if (isAbove) scrollParent.scrollTo(0, offsetTop - scrollMarginTop - buffer);
    else if (isBelow) scrollParent.scrollTo(0, offsetTop + offsetHeight + scrollMarginBottom - parentOffsetHeight + buffer);
};
const $879a503962c4545a$var$findScrollableParent = (element)=>{
    if (!element) return null;
    if (element.scrollHeight > element.offsetHeight) return element;
    return $879a503962c4545a$var$findScrollableParent(element.parentElement);
};
const $879a503962c4545a$var$getTotalOffsetTop = (element, scrollParent)=>{
    if (!element || element === scrollParent) return 0;
    if (element.contains(scrollParent)) // subtract the scroll parent's offset top from the running total if the offsetParent is above it
    return scrollParent.offsetTop * -1;
    return element.offsetTop + $879a503962c4545a$var$getTotalOffsetTop(element.offsetParent, scrollParent);
};
const $879a503962c4545a$var$getScrollMargins = (element)=>{
    var _element_ownerDocument;
    const win = (_element_ownerDocument = element.ownerDocument) === null || _element_ownerDocument === void 0 ? void 0 : _element_ownerDocument.defaultView;
    if (!win) return {
        scrollMarginTop: 0,
        scrollMarginBottom: 0
    };
    const computedStyles = win.getComputedStyle(element);
    var _getIntValueOfComputedStyle;
    const scrollMarginTop = (_getIntValueOfComputedStyle = $879a503962c4545a$var$getIntValueOfComputedStyle(computedStyles.scrollMarginTop)) !== null && _getIntValueOfComputedStyle !== void 0 ? _getIntValueOfComputedStyle : $879a503962c4545a$var$getIntValueOfComputedStyle(computedStyles.scrollMarginBlockStart);
    var _getIntValueOfComputedStyle1;
    const scrollMarginBottom = (_getIntValueOfComputedStyle1 = $879a503962c4545a$var$getIntValueOfComputedStyle(computedStyles.scrollMarginBottom)) !== null && _getIntValueOfComputedStyle1 !== void 0 ? _getIntValueOfComputedStyle1 : $879a503962c4545a$var$getIntValueOfComputedStyle(computedStyles.scrollMarginBlockEnd);
    return {
        scrollMarginTop: scrollMarginTop,
        scrollMarginBottom: scrollMarginBottom
    };
};
const $879a503962c4545a$var$getIntValueOfComputedStyle = (computedStyle)=>{
    return computedStyle ? parseInt(computedStyle, 10) : 0;
};


'use client';
const $7c58394d65e14600$export$71acbe38fcabc10f = (detail)=>new CustomEvent('activedescendantchange', {
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: detail
    });
function $7c58394d65e14600$export$52b2d283d5b129ab(options) {
    const { imperativeRef: imperativeRef, matchOption: matchOptionUnstable } = options;
    const focusVisibleRef = $acw62.useRef(false);
    const shouldShowFocusVisibleAttrRef = $acw62.useRef(true);
    const activeIdRef = $acw62.useRef(null);
    const lastActiveIdRef = $acw62.useRef(null);
    const activeParentRef = $acw62.useRef(null);
    const attributeVisibilityRef = $acw62.useRef(true);
    const removeAttribute = $acw62.useCallback(()=>{
        var _activeParentRef_current;
        (_activeParentRef_current = activeParentRef.current) === null || _activeParentRef_current === void 0 || _activeParentRef_current.removeAttribute('aria-activedescendant');
    }, []);
    const setAttribute = $acw62.useCallback((id)=>{
        if (id) activeIdRef.current = id;
        if (attributeVisibilityRef.current && activeIdRef.current) {
            var _activeParentRef_current;
            (_activeParentRef_current = activeParentRef.current) === null || _activeParentRef_current === void 0 || _activeParentRef_current.setAttribute('aria-activedescendant', activeIdRef.current);
        }
    }, []);
    (0, $6056a079b6515181$export$38848de96c4734a8)((isNavigatingWithKeyboard)=>{
        focusVisibleRef.current = isNavigatingWithKeyboard;
        // eslint-disable-next-line react-hooks/immutability, react-hooks/preserve-manual-memoization
        const active = getActiveDescendant();
        if (!active) return;
        if (isNavigatingWithKeyboard && shouldShowFocusVisibleAttrRef.current) active.setAttribute((0, $fc1733cf7c32aa48$export$33faf83683cd9855), '');
        else active.removeAttribute((0, $fc1733cf7c32aa48$export$33faf83683cd9855));
    });
    const matchOption = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(matchOptionUnstable);
    const listboxRef = $acw62.useRef(null);
    const { optionWalker: optionWalker, listboxCallbackRef: listboxCallbackRef } = (0, $a7f855c6581d7cab$export$a26fa0246760c6e6)({
        matchOption: matchOption
    });
    // eslint-disable-next-line react-hooks/preserve-manual-memoization
    const getActiveDescendant = $acw62.useCallback(()=>{
        var _listboxRef_current;
        return (_listboxRef_current = listboxRef.current) === null || _listboxRef_current === void 0 ? void 0 : _listboxRef_current.querySelector(`#${activeIdRef.current}`);
    }, [
        listboxRef
    ]);
    const setShouldShowFocusVisibleAttribute = $acw62.useCallback((shouldShow)=>{
        shouldShowFocusVisibleAttrRef.current = shouldShow;
        const active = getActiveDescendant();
        if (!active) return;
        if (shouldShow && focusVisibleRef.current) active.setAttribute((0, $fc1733cf7c32aa48$export$33faf83683cd9855), '');
        else active.removeAttribute((0, $fc1733cf7c32aa48$export$33faf83683cd9855));
    }, [
        getActiveDescendant
    ]);
    const blurActiveDescendant = $acw62.useCallback(()=>{
        const active = getActiveDescendant();
        if (active) {
            active.removeAttribute((0, $fc1733cf7c32aa48$export$26fcc5a6901acc3c));
            active.removeAttribute((0, $fc1733cf7c32aa48$export$33faf83683cd9855));
        }
        removeAttribute();
        lastActiveIdRef.current = activeIdRef.current;
        activeIdRef.current = null;
        var _active_id;
        return (_active_id = active === null || active === void 0 ? void 0 : active.id) !== null && _active_id !== void 0 ? _active_id : null;
    }, [
        getActiveDescendant,
        removeAttribute
    ]);
    const focusActiveDescendant = $acw62.useCallback((nextActive)=>{
        if (!nextActive) return;
        const previousActiveId = blurActiveDescendant();
        (0, $879a503962c4545a$export$53a0910f038337bd)(nextActive);
        setAttribute(nextActive.id);
        nextActive.setAttribute((0, $fc1733cf7c32aa48$export$26fcc5a6901acc3c), '');
        if (focusVisibleRef.current && shouldShowFocusVisibleAttrRef.current) nextActive.setAttribute((0, $fc1733cf7c32aa48$export$33faf83683cd9855), '');
        const event = $7c58394d65e14600$export$71acbe38fcabc10f({
            id: nextActive.id,
            previousId: previousActiveId
        });
        nextActive.dispatchEvent(event);
    }, [
        blurActiveDescendant,
        setAttribute
    ]);
    const controller = $acw62.useMemo(()=>({
            first: ({ passive: passive } = {})=>{
                const first = optionWalker.first();
                if (!passive) focusActiveDescendant(first);
                return first === null || first === void 0 ? void 0 : first.id;
            },
            last: ({ passive: passive } = {})=>{
                const last = optionWalker.last();
                if (!passive) focusActiveDescendant(last);
                return last === null || last === void 0 ? void 0 : last.id;
            },
            next: ({ passive: passive } = {})=>{
                const active = getActiveDescendant();
                if (!active) return;
                optionWalker.setCurrent(active);
                const next = optionWalker.next();
                if (!passive) focusActiveDescendant(next);
                return next === null || next === void 0 ? void 0 : next.id;
            },
            prev: ({ passive: passive } = {})=>{
                const active = getActiveDescendant();
                if (!active) return;
                optionWalker.setCurrent(active);
                const next = optionWalker.prev();
                if (!passive) focusActiveDescendant(next);
                return next === null || next === void 0 ? void 0 : next.id;
            },
            blur: ()=>{
                blurActiveDescendant();
            },
            active: ()=>{
                var _getActiveDescendant;
                return (_getActiveDescendant = getActiveDescendant()) === null || _getActiveDescendant === void 0 ? void 0 : _getActiveDescendant.id;
            },
            focus: (id)=>{
                if (!listboxRef.current) return;
                const target = listboxRef.current.querySelector(`#${id}`);
                if (target) focusActiveDescendant(target);
            },
            focusLastActive: ()=>{
                if (!listboxRef.current || !lastActiveIdRef.current) return;
                const target = listboxRef.current.querySelector(`#${lastActiveIdRef.current}`);
                if (target) {
                    focusActiveDescendant(target);
                    return true;
                }
            },
            find (predicate, { passive: passive, startFrom: startFrom } = {}) {
                const target = optionWalker.find(predicate, startFrom);
                if (!passive) focusActiveDescendant(target);
                return target === null || target === void 0 ? void 0 : target.id;
            },
            scrollActiveIntoView: ()=>{
                if (!listboxRef.current) return;
                const active = getActiveDescendant();
                if (!active) return;
                (0, $879a503962c4545a$export$53a0910f038337bd)(active);
            },
            showAttributes () {
                attributeVisibilityRef.current = true;
                setAttribute();
            },
            hideAttributes () {
                attributeVisibilityRef.current = false;
                removeAttribute();
            },
            showFocusVisibleAttributes () {
                setShouldShowFocusVisibleAttribute(true);
            },
            hideFocusVisibleAttributes () {
                setShouldShowFocusVisibleAttribute(false);
            }
        }), [
        optionWalker,
        listboxRef,
        setAttribute,
        removeAttribute,
        focusActiveDescendant,
        blurActiveDescendant,
        getActiveDescendant,
        setShouldShowFocusVisibleAttribute
    ]);
    $acw62.useImperativeHandle(imperativeRef, ()=>controller);
    return {
        listboxRef: (0, $de7d48ea62179626$export$9cf7d991616612b3)(listboxRef, listboxCallbackRef),
        activeParentRef: activeParentRef,
        controller: controller
    };
}



"use client";
const $81c528f1808b6955$export$93770f390151ed6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BalconyFilled', "1em", [
    "M17.6 8.01a.5.5 0 0 1 0 .98l-.1.01H17v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9h-.5a.5.5 0 0 1 0-1h15zM14 14h2V9h-2zM4 14h2V9H4zm3 0h2.5V9H7zm3.5 0H13V9h-2.5zM12 2a3 3 0 0 1 3 3v2H5V5a3 3 0 0 1 3-3z"
]);
const $81c528f1808b6955$export$a0dd3ce4190406d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BalconyRegular', "1em", [
    "M14 8V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v3zM4 14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2zm0-1h2V9H4zm3 0h2.5V9H7zm3.5 0H13V9h-2.5zm3.5 0h2V9h-2zm3.6-4.99a.5.5 0 0 1 0 .98l-.1.01H17v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9h-.5a.5.5 0 0 1 0-1H5V5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3h2.5z"
]);
const $81c528f1808b6955$export$782ce1c34477be3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BalloonFilled', "1em", [
    "M5 7a5 5 0 0 1 10 0c0 1.87-.66 3.6-1.6 4.86a5 5 0 0 1-2.9 2.1V14a1 1 0 0 0 1 1H14a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V17a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-2-2v-.05a5 5 0 0 1-2.9-2.09C5.66 10.6 5 8.86 5 7m5.57-3a.5.5 0 1 0-.14 1c.81.11 1.46.76 1.57 1.57a.5.5 0 0 0 1-.14A2.9 2.9 0 0 0 10.56 4"
]);
const $81c528f1808b6955$export$f0d8e96384ef9a2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BalloonRegular', "1em", [
    "M10 4.43a.5.5 0 0 1 .57-.43 2.9 2.9 0 0 1 2.42 2.43.5.5 0 0 1-.99.14A1.9 1.9 0 0 0 10.43 5a.5.5 0 0 1-.43-.57M5 7a5 5 0 0 1 10 0c0 1.87-.66 3.6-1.6 4.86a5 5 0 0 1-2.9 2.1V14a1 1 0 0 0 1 1H14a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V17a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-2-2v-.05a5 5 0 0 1-2.9-2.09C5.66 10.6 5 8.86 5 7m5-4a4 4 0 0 0-4 4c0 1.64.59 3.16 1.4 4.27C8.24 12.4 9.23 13 10 13s1.76-.6 2.6-1.73A7.3 7.3 0 0 0 14 7a4 4 0 0 0-4-4"
]);
const $81c528f1808b6955$export$5b2d13551a6e1243 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxFilled', "1em", [
    "m10 7.96 3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.4.15.8.21v-8.9zm8.46 11.87q.4-.05.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18q0-.17-.04-.33L10.5 8.84zM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21"
]);
const $81c528f1808b6955$export$4fc7b4fb4012ccd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 0 0 2.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm4.13 4.35 6.5-2.6v7.58a.5.5 0 0 1-.31.47l-5.76 2.3q-.2.09-.43.13zm-1 0v7.88a3 3 0 0 1-.43-.13l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24z"
]);
const $81c528f1808b6955$export$6551bd0a7901db34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeftFilled', "1em", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zM2 6.18q0-.17.04-.33L9.5 8.84v3.36a5.5 5.5 0 0 0 0 4.6v.93a4 4 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4zm16 0v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33m1 8.32a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-6.86-.35 2-2a.5.5 0 1 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35"
]);
const $81c528f1808b6955$export$b5c7fa36c7fcceb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeftRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36q.39-.81 1-1.48V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm12.63 10a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-6.86-.34 2-2a.5.5 0 1 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35"
]);
const $81c528f1808b6955$export$19c1de31bae48a04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUpFilled', "1em", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zM2 6.18q0-.17.04-.33L9.5 8.84v3.36a5.5 5.5 0 0 0 0 4.6v.93a4 4 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4zm16 0v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.35-6.86 2 2a.5.5 0 1 1-.7.71L15 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.14"
]);
const $81c528f1808b6955$export$dfea6444ecb50ec1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUpRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36q.39-.81 1-1.48V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm8.13 14.5a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9m.35-6.85 2 2a.5.5 0 1 1-.7.71L15 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.14"
]);
const $81c528f1808b6955$export$e9fbbe70b7ad9b1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmarkFilled', "1em", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zM2 6.18q0-.17.04-.33L9.5 8.84v3.36a5.5 5.5 0 0 0 0 4.6v.93a4 4 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4zm16 0v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-1-3.7 2.65-2.65a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7z"
]);
const $81c528f1808b6955$export$99542e8e0277a97a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmarkRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36q.39-.81 1-1.48V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm8.13 14.5a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9m-1-3.7 2.65-2.64a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7z"
]);
const $81c528f1808b6955$export$a83a6ff38081f1e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismissFilled', "1em", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.4.15.8.21v-.94a5.5 5.5 0 0 1 0-4.58V8.84zM18 6.17v4.08a5.5 5.5 0 0 0-7.5.46V8.84l7.46-2.99q.04.16.04.33m1 8.32a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $81c528f1808b6955$export$db8ebc2434e481ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismissRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3q.66.26 1.38.25a6 6 0 0 1-.62-1.06l-.39-.12-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.37q.39-.83 1-1.49V8.84l6.5-2.6V9.6q.54.27 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $81c528f1808b6955$export$4df1b9a0c6472cb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEditFilled', "1em", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.37-1.49.07-.23V8.84zM18 6.17v2.95a2.9 2.9 0 0 0-2.9.71l-4.6 4.6v-5.6l7.46-2.99q.04.16.04.33m-7.02 9.2 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $81c528f1808b6955$export$5e193dba2c519c43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEditRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.24-.97-.23-.08-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v7.08q.24-.72.77-1.25l.23-.23v-5.6l6.5-2.6V9q.52-.02 1 .13V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm4.61 10.89 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $81c528f1808b6955$export$6d2f52a23fed04e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleFilled', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34A2.5 2.5 0 0 1 14 10.1v4.78q0 .3-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.1a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zM6.42 7.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v4.78a1.5 1.5 0 0 1-.96 1.4l-3.46 1.33a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4zm4.67 2.91a.5.5 0 0 0-.64-.28L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.8-1.07a.5.5 0 0 0 .3-.65"
]);
const $81c528f1808b6955$export$f691f563be2d0fa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleRegular', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.71A1.5 1.5 0 0 0 7 5.11v1.1a4 4 0 0 1 1 0v-1.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47v7.78c0 .2-.13.4-.32.47L14 14.39v.5q0 .3-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.11a1.5 1.5 0 0 0-.96-1.4zm2.51 2.92a.5.5 0 0 0-.64-.3l-2.77 1.07a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 1 0-.35.93l2.76 1.07q.54.2 1.08 0l2.76-1.07a.5.5 0 0 0 .3-.64m-5 5a.5.5 0 0 0-.64-.3L7.5 11.15l-2.95-1.13a.5.5 0 0 0-.35.93L7 12.02v2.49a.5.5 0 1 0 1 0v-2.49l2.8-1.08a.5.5 0 0 0 .3-.64M8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.71a1.5 1.5 0 0 0-.96 1.4v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l3.46-1.33c.58-.22.96-.78.96-1.4v-4.78a1.5 1.5 0 0 0-.96-1.4zm-1.8.93a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47v4.78c0 .2-.13.4-.32.47l-3.46 1.33a2 2 0 0 1-1.44 0l-3.46-1.33a.5.5 0 0 1-.32-.47v-4.78c0-.2.13-.4.32-.47z"
]);
const $81c528f1808b6955$export$1e50000ab9f0a31d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeftFilled', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.6 5.6 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zm-3.41 4.18q.45.18.71.57-.94.32-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.5 5.5 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 1 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $81c528f1808b6955$export$5dab0752b72e9f5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeftRegular', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47V9.6q.55.27 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4zM12.04 8.7q.45.18.71.57-.5.17-.95.43l-.12-.07-3.46-1.33a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42q.17.48.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zm-1.6 1.3a.5.5 0 0 1 .61.2q-.54.45-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7q.54.21 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.34a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 1 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $81c528f1808b6955$export$99d0b1dbd8c3551f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRightFilled', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.6 5.6 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zm-3.41 4.18q.45.18.71.57-.94.32-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.5 5.5 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $81c528f1808b6955$export$4674824a0a08f798 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRightRegular', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47V9.6q.55.27 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4zM12.04 8.7q.45.18.71.57-.5.17-.95.43l-.12-.07-3.46-1.33a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42q.17.48.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zm-1.6 1.3a.5.5 0 0 1 .61.2q-.54.45-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7q.54.21 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.36a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $81c528f1808b6955$export$a3caaa0871d7b80c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmarkFilled', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.6 5.6 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0zm-3.41 4.18q.45.18.71.57-.94.32-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.5 5.5 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $81c528f1808b6955$export$8796b8813369f625 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmarkRegular', "1em", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33q.31.14.32.47V9.6q.55.27 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4zM12.04 8.7q.45.18.71.57-.5.17-.95.43l-.12-.07-3.46-1.33a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42q.17.48.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0zm-1.6 1.3a.5.5 0 0 1 .61.2q-.54.45-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7q.54.21 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.84a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $81c528f1808b6955$export$13663da576e113e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearchFilled', "1em", [
    "M11.42 2.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78q0 .11-.02.22A4.5 4.5 0 0 0 13.74 9a2.5 2.5 0 0 0-1.34-1.23L8.94 6.44A4 4 0 0 0 7 6.21V5.1c0-.62.38-1.18.96-1.4zm4.67 2.44a.5.5 0 0 0-.64-.29L12.68 5.6a.5.5 0 0 1-.36 0L9.55 4.53a.5.5 0 0 0-.35.94l2.76 1.06q.54.2 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65M12.6 9.09a2 2 0 0 0-.56-.38L8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.7A1.5 1.5 0 0 0 2 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l1.94-.75a4.5 4.5 0 0 1-1.02-5.43l-1.5.58v2.49a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13L10.45 10a1 1 0 0 1 .25-.03q.83-.67 1.9-.9m3.7 6.5q.68-.89.7-2.1a3.5 3.5 0 1 0-1.4 2.81l2.55 2.55a.5.5 0 0 0 .7-.7zm-.3-2.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $81c528f1808b6955$export$6d5944f7a9af978b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearchRegular', "1em", [
    "M11.42 2.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78q0 .11-.02.22a4.5 4.5 0 0 0-.98-2.44V5.11a.5.5 0 0 0-.32-.47l-3.46-1.33a2 2 0 0 0-1.44 0L8.32 4.64a.5.5 0 0 0-.32.47v1.1a4 4 0 0 0-1 0V5.1c0-.62.38-1.18.96-1.4zm1.18 6.7a2 2 0 0 0-.56-.37L8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.7A1.5 1.5 0 0 0 2 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l1.94-.75q-.4-.35-.71-.8l-1.6.62a2 2 0 0 1-1.43 0l-3.46-1.33a.5.5 0 0 1-.32-.47V10.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.16 1.22q.57-.3 1.22-.44m-1.9.9a1 1 0 0 0-.25.03L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l1.5-.57q.44-.87 1.2-1.46M15.45 5a.5.5 0 1 1 .35.93L13.04 7a1.5 1.5 0 0 1-1.08 0L9.2 5.94A.5.5 0 0 1 9.55 5l2.77 1.06a.5.5 0 0 0 .36 0zm.85 10.59q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-.3-2.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $81c528f1808b6955$export$e8bd8568fef65294 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearchFilled', "1em", [
    "m10 7.96 3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v3.08a4.5 4.5 0 0 1 5.56 6.18l1.94 1.94V8.84zm8.46 11.87q.4-.05.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18q0-.17-.04-.33L10.5 8.84zM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M3.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 15.6A3.5 3.5 0 1 0 3.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $81c528f1808b6955$export$fb3c2a6fe5cd59df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearchRegular', "1em", [
    "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v7.64a1.5 1.5 0 0 1-.94 1.4l-5.76 2.3q-.73.29-1.5.24a2 2 0 0 0-.24-.32l-.06-.06V8.84L3 6.24v2.79q-.52.05-1 .23V6.18c0-.62.37-1.17.94-1.4zm2.23.93a2.5 2.5 0 0 0-1.86 0l-1.35.54 6.16 2.46 2.27-.91zm1.6 3.54L6.38 4.49l-2.53 1L10 7.97zM17 6.24l-6.5 2.6v7.88q.22-.04.43-.13l5.76-2.3a.5.5 0 0 0 .31-.47zM3.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 15.6A3.5 3.5 0 1 0 3.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $81c528f1808b6955$export$ade1760c77e4e918 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolboxFilled', "1em", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3q.2.09.36.21M10 7.95l3.03-1.21-7.5-3-2.59 1.03a2 2 0 0 0-.36.21zm-7.96-2.1Q2 6 2 6.17v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1V13.5q.02-.85.5-1.5V8.84zM18 6.17v4.87h-.04A2.5 2.5 0 0 0 15.5 9h-2a2.5 2.5 0 0 0-2.46 2.04q-.28.06-.54.17V8.84l7.46-2.99q.04.16.04.33M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0"
]);
const $81c528f1808b6955$export$8285ffd9bae28d40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolboxRegular', "1em", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1v-1.06L3.31 14.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6V12q.4-.52 1-.8V8.85l6.5-2.6V9.5c.5.37.84.91.96 1.54l.04.01V6.18a1.5 1.5 0 0 0-.94-1.4zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5zm5.63 7.5v-.5c0-.82.67-1.49 1.5-1.49h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm3.5-1h-2a.5.5 0 0 0-.5.5v.5h3v-.5a.5.5 0 0 0-.5-.5M17 16.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0"
]);
const $81c528f1808b6955$export$e5c73860feeb9214 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiagramFilled', "1em", [
    "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03q.54.1 1 .4V5a3 3 0 0 0-3-3zm.5 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM5 8.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M6.5 11a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42z"
]);
const $81c528f1808b6955$export$3c5f06a13d4c14c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiagramRegular', "1em", [
    "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03q.54.1 1 .4V5a3 3 0 0 0-3-3zm1.5 9a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42zm3.34 3.5L7.6 12h6.98a.5.5 0 0 1 .35.14L17.9 15l-2.95 2.86a.5.5 0 0 1-.35.14H7.61l2.23-2.5a.75.75 0 0 0 0-1M5 5.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M5.5 8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $81c528f1808b6955$export$69ba80e901cccea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadFilled', "1em", [
    "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $81c528f1808b6955$export$8481d0900a1fb72d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadRegular', "1em", [
    "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $81c528f1808b6955$export$52b579451edef416 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l3.9 3.9H6a1.25 1.25 0 1 0 1.25 1.2l2.8 2.8H10a1.25 1.25 0 1 0 1.25 1.2l5.9 5.9a.5.5 0 0 0 .7-.7zM15.25 12q-.02.48-.3.82l-1.77-1.76q.34-.3.82-.31c.69 0 1.25.56 1.25 1.25m-4-4q-.02.48-.3.82L9.17 7.06q.33-.3.82-.31c.69 0 1.25.56 1.25 1.25m-4-4q-.01.48-.3.82L5.17 3.06q.33-.3.82-.31c.69 0 1.25.56 1.25 1.25m0 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $81c528f1808b6955$export$ac8c8bb7c5567ec1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l4.2 4.22A1 1 0 0 0 5 8a1 1 0 1 0 1.93-.36l3.43 3.43a1 1 0 1 0 .57.57l6.22 6.21a.5.5 0 0 0 .7-.7zM15 12a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 15 12m-4-4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 11 8M7 4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 7 4m0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $81c528f1808b6955$export$4afe33a2bf00038d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMarkFilled', "1em", [
    "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4-8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m.41 1.57a5.5 5.5 0 0 0-1.2 2.15 1.25 1.25 0 0 1 1.2-2.15m4.33-1.81a1.25 1.25 0 1 0-1.32.1 6 6 0 0 1 1.32-.1M14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.62-2a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0m-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 0 1-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 1 1-1 0"
]);
const $81c528f1808b6955$export$c6a0550bf5c56e86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMarkRegular', "1em", [
    "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2 .23.03a6 6 0 0 0-.93 1.68A1 1 0 0 1 10 11m5-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25m0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95"
]);
const $81c528f1808b6955$export$4127fbdca3a71de6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondFilled', "1em", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24z"
]);
const $81c528f1808b6955$export$bdf29d49e7674cf0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondRegular', "1em", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zm3.53.7a2 2 0 0 0-2.83 0l-6 6a2 2 0 0 0 0 2.83l6 6a2 2 0 0 0 2.83 0l6-6a2 2 0 0 0 0-2.83z"
]);
const $81c528f1808b6955$export$a3e24f6751d686a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismissFilled', "1em", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zM13.1 6.9a.5.5 0 0 0-.7 0L10 9.3 7.6 6.9a.5.5 0 0 0-.7.7L9.3 10l-2.4 2.4a.5.5 0 0 0 .7.7l2.4-2.4 2.4 2.4a.5.5 0 0 0 .7-.7L10.7 10l2.4-2.4a.5.5 0 0 0 0-.7"
]);
const $81c528f1808b6955$export$913d25dda460c01a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismissRegular', "1em", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zm3.53.7a2 2 0 0 0-2.83 0l-6 6a2 2 0 0 0 0 2.83l6 6a2 2 0 0 0 2.83 0l6-6a2 2 0 0 0 0-2.83zm.99 4.32a.5.5 0 1 1 .7.7L10.7 10l2.4 2.4a.5.5 0 0 1-.7.7L10 10.7l-2.4 2.4a.5.5 0 0 1-.7-.7L9.3 10 6.9 7.6a.5.5 0 0 1 .7-.7L10 9.3z"
]);
const $81c528f1808b6955$export$13d0c3955e423532 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLinkFilled', "1em", [
    "M8.66 5.43a6.75 6.75 0 0 1 4 11.47h-.01l-.89.88a2.5 2.5 0 0 1-3.53 0l-6-6a2.5 2.5 0 0 1 0-3.55l.88-.88q.67-.65 1.44-1.1-.21.98-.17 1.96l-.2.2-.9.89a1 1 0 0 0 0 1.41l6.01 6a1 1 0 0 0 1.41 0l.89-.88a5.25 5.25 0 0 0-3.6-8.95q.2-.77.67-1.45m-.43-3.2a2.5 2.5 0 0 1 3.53 0l6 6a2.5 2.5 0 0 1 .01 3.54l-.88.88q-.66.65-1.44 1.1.21-.97.17-1.96l.2-.2.89-.88a1 1 0 0 0 0-1.41l-6-6a1 1 0 0 0-1.42 0l-.88.87a5.25 5.25 0 0 0 3.6 8.95q-.2.78-.67 1.46A6.75 6.75 0 0 1 7.35 3.11z"
]);
const $81c528f1808b6955$export$7e5440aeffe0fdab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLinkRegular', "1em", [
    "M8.07 5.47a6.75 6.75 0 0 1 4.5 11.5l-.8.8a2.5 2.5 0 0 1-3.54 0l-6-6a2.5 2.5 0 0 1 0-3.54l.8-.8a7 7 0 0 1 1.59-1.17q-.13.62-.15 1.26-.38.29-.74.63l-.8.79a1.5 1.5 0 0 0 0 2.12l6.01 6a1.5 1.5 0 0 0 2.12 0l.8-.79.2-.21a5.75 5.75 0 0 0-4.4-9.6q.15-.51.4-.99m.16-3.24a2.5 2.5 0 0 1 3.54 0l6 6a2.5 2.5 0 0 1 0 3.54l-.8.8q-.71.71-1.59 1.17.13-.62.15-1.26.38-.29.74-.63l.8-.79a1.5 1.5 0 0 0 0-2.12l-6.01-6a1.5 1.5 0 0 0-2.12 0l-.8.79a5.75 5.75 0 0 0 4.21 9.8q-.15.52-.42 1a6.75 6.75 0 0 1-4.5-11.5z"
]);
const $81c528f1808b6955$export$46fa445f28b51567 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DishwasherFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v2h14V6a3 3 0 0 0-3-3zm8 14H6.91a1.5 1.5 0 0 0-.91-.91v-1.43a3.5 3.5 0 0 0 2-3.16v-2q0-.26-.09-.5H17v5a3 3 0 0 1-3 3M6.75 6.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M10 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5z"
]);
const $81c528f1808b6955$export$3cceac0e83b650d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DishwasherRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v2h13v6a2 2 0 0 1-2 2H6v.09c.43.15.76.48.91.91H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm10 3v1H4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2m-8.5-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.5 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5z"
]);
const $81c528f1808b6955$export$cd7ecad8820348f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissFilled', "1em", [
    "m3.9 4.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L10 8.94l4.97-4.97a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08L11.06 10l4.97 4.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L10 11.06l-4.97 4.97a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L8.94 10 3.97 5.03a.75.75 0 0 1-.07-.98l.07-.08z"
]);
const $81c528f1808b6955$export$ccebaeb0763e0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissRegular', "1em", [
    "m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07z"
]);
const $81c528f1808b6955$export$e0d4848b27d1b65f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_20_color__a)",
            "d": "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_dismiss_circle_20_color__b)",
            "fillRule": "evenodd",
            "d": "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_20_color__a",
                "x1": "4.5",
                "x2": "15",
                "y1": "3",
                "y2": "18.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f83f54"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ca2134"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_dismiss_circle_20_color__b",
                "x1": "7.35",
                "x2": "10.47",
                "y1": "10.27",
                "y2": "13.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fecbe6"
                }
            ]
        ]
    ]
], {
    color: true
});
const $81c528f1808b6955$export$6819c87e09d718cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircleFilled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16M7.8 7.11a.5.5 0 0 0-.63.06l-.06.07a.5.5 0 0 0 .06.64L9.3 10l-2.12 2.12-.06.07a.5.5 0 0 0 .06.64l.07.06c.2.13.47.11.64-.06L10 10.7l2.12 2.12.07.06c.2.13.46.11.64-.06l.06-.07a.5.5 0 0 0-.06-.64L10.7 10l2.12-2.12.06-.07a.5.5 0 0 0-.06-.64l-.07-.06a.5.5 0 0 0-.64.06L10 9.3 7.88 7.17z"
]);
const $81c528f1808b6955$export$4f7f0f60ff0e08a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircleRegular', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14M7.8 7.11l.08.06L10 9.3l2.12-2.12a.5.5 0 0 1 .64-.06l.07.06c.17.18.2.44.06.64l-.06.07L10.7 10l2.12 2.12c.17.17.2.44.06.64l-.06.07a.5.5 0 0 1-.64.06l-.07-.06L10 10.7l-2.12 2.12a.5.5 0 0 1-.64.06l-.07-.06a.5.5 0 0 1-.06-.64l.06-.07L9.3 10 7.17 7.88a.5.5 0 0 1-.06-.64l.06-.07a.5.5 0 0 1 .64-.06"
]);
const $81c528f1808b6955$export$18026936082e044f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm4.15 1.15a.5.5 0 0 0 0 .7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 0 0-.7 0"
]);
const $81c528f1808b6955$export$2580b975c67290bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareRegular', "1em", [
    "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $81c528f1808b6955$export$5a3200fe6afa2213 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultipleFilled', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5zm3.15.65a.5.5 0 0 0 0 .7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29 6.85 6.15a.5.5 0 0 0-.7 0M5.5 16c.46.6 1.18 1 2 1h5a4.5 4.5 0 0 0 4.5-4.5v-5c0-.82-.4-1.54-1-2v7a3.5 3.5 0 0 1-3.5 3.5z"
]);
const $81c528f1808b6955$export$7ffebe3fd730176f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultipleRegular', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5zM5.5 4C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm2 13a2.5 2.5 0 0 1-2-1h7a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5zM6.85 6.15a.5.5 0 1 0-.7.7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29z"
]);
const $81c528f1808b6955$export$c5f83204c027478a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8z"
]);
const $81c528f1808b6955$export$c188d4e0d65f2bcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM3 8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5z"
]);
const $81c528f1808b6955$export$b7734dc1d88ef163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAddFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm17 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $81c528f1808b6955$export$685a78304e545857 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAddRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm16 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $81c528f1808b6955$export$67f72b067cba3c7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeftFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm12.5 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $81c528f1808b6955$export$b9d48794aa42f963 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeftRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $81c528f1808b6955$export$2ed8992e426bfcee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRightFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm12.5 2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$8c816be00e24a796 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRightRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$932e03103d257e54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUpFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm17 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $81c528f1808b6955$export$a2ba82f4e9d1b84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUpRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm16 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $81c528f1808b6955$export$1d6620a57e961e81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderBriefcaseFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17H9v-3.5a2.5 2.5 0 0 1 2.04-2.46A2.5 2.5 0 0 1 13.5 9h2a2.5 2.5 0 0 1 2.46 2.04l.04.01V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10 3.5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5m1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5"
]);
const $81c528f1808b6955$export$463ea956ed56802 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderBriefcaseRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H9v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2c.5.37.84.91.96 1.54l.04.01V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9 6v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5m1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5"
]);
const $81c528f1808b6955$export$a983e5310d8b4080 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDataBarFilled', "1em", [
    "M12 14a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m3-4a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m3 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m-2.5-7A2.5 2.5 0 0 1 18 7.5V11q-.54 0-1 .27V11a2 2 0 1 0-4 0v2.27q-.46-.26-1-.27a2 2 0 0 0-2 2v2H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $81c528f1808b6955$export$e787c4ea9c06e31a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDataBarRegular', "1em", [
    "M12 14a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m3-4a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m3 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5V11q-.54 0-1 .27V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H10v1H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $81c528f1808b6955$export$2adc610f6f9ec7cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismissFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m1-5A2.5 2.5 0 0 1 18 7.5v2.76A5.5 5.5 0 0 0 9.6 17H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zm.85 7.65a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $81c528f1808b6955$export$bdf6468c2ff0c403 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDismissRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v2.76a6 6 0 0 0-1-.66V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h4.7q.15.52.4 1H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zm9.37 9.65a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $81c528f1808b6955$export$53b2a10431abd50c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocumentFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17H11v-6c0-1.1.9-2 2-2h2.59a2 2 0 0 1 1.41.59l1 1V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm11.25 2H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25M16 10l3 3h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $81c528f1808b6955$export$8fc1b6cd440739a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocumentRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H11v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.09l1 1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM13.25 10H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25M16 10l3 3h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $81c528f1808b6955$export$226dc763775bb39d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobeFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm11.55 3.15a9 9 0 0 0-.54 2.85h2.98a9 9 0 0 0-.54-2.85 3 3 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24q-.27.29-.53.91m-.72-.83q-.12.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68m3.34 0q.12.22.2.46c.35.86.57 1.99.62 3.22h1.98a4.5 4.5 0 0 0-2.8-3.68m2.8 4.68H17a10 10 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68m-4.47 4c.1 0 .23-.05.42-.24q.27-.29.53-.91c.3-.73.5-1.72.54-2.85h-2.98a9 9 0 0 0 .54 2.85q.26.63.53.91c.19.2.33.24.42.24m-1.67-.32a4.5 4.5 0 0 1-2.8-3.68H12a10 10 0 0 0 .82 3.68"
]);
const $81c528f1808b6955$export$a17a722299a0761b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobeRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm10.55 5.65a9 9 0 0 0-.54 2.85h2.98a9 9 0 0 0-.54-2.85 3 3 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24q-.27.29-.53.91m-.72-.83q-.12.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68m3.34 0q.12.22.2.46c.35.86.57 1.99.62 3.22h1.98a4.5 4.5 0 0 0-2.8-3.68m2.8 4.68H17a10 10 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68m-4.47 4c.1 0 .23-.05.42-.24q.27-.29.53-.91c.3-.73.5-1.72.54-2.85h-2.98a9 9 0 0 0 .54 2.85q.26.63.53.91c.19.2.33.24.42.24m-1.67-.32a4.5 4.5 0 0 1-2.8-3.68H12a10 10 0 0 0 .82 3.68"
]);
const $81c528f1808b6955$export$37e6995dda95a3fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHintFilled', "1em", [
    "M2.5 13.5c.28 0 .5.22.5.5v.5c0 .83.67 1.5 1.5 1.5H5a.5.5 0 0 1 0 1h-.5A2.5 2.5 0 0 1 2 14.5V14c0-.28.22-.5.5-.5M9 16a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm4 0a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm4.5-2.5c.28 0 .5.22.5.5v.5a2.5 2.5 0 0 1-2.5 2.5H15a.5.5 0 0 1 0-1h.5c.83 0 1.5-.67 1.5-1.5V14c0-.28.22-.5.5-.5M15.25 7c.41 0 .75.34.75.75v6.5c0 .41-.34.75-.75.75H4.75a.75.75 0 0 1-.75-.75v-4.5c0-.41.34-.75.75-.75h2a3 3 0 0 0 2.13-.88l.9-.9a.8.8 0 0 1 .53-.22zM2.5 10c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5m15 0c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5M7.09 3q.62.01 1.06.44l1.7 1.7c.2.2.2.52 0 .71l-1.7 1.71A1.5 1.5 0 0 1 7.09 8H6.5a.5.5 0 0 1 0-1h.59a.5.5 0 0 0 .35-.15L8.79 5.5 7.44 4.15A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5V7h1.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0v-3A2.5 2.5 0 0 1 4.5 3zm8.41 2A2.5 2.5 0 0 1 18 7.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5H15a.5.5 0 0 1 0-1zM13 5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
]);
const $81c528f1808b6955$export$5b511af53cafc7cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHintRegular', "1em", [
    "M2.5 13.5c.28 0 .5.22.5.5v.5c0 .83.67 1.5 1.5 1.5H5a.5.5 0 0 1 0 1h-.5A2.5 2.5 0 0 1 2 14.5V14c0-.28.22-.5.5-.5M9 16a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm4 0a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm4.5-2.5c.28 0 .5.22.5.5v.5a2.5 2.5 0 0 1-2.5 2.5H15a.5.5 0 0 1 0-1h.5c.83 0 1.5-.67 1.5-1.5V14c0-.28.22-.5.5-.5M2.5 10c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5m15 0c.28 0 .5.22.5.5V12a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5M7.09 3q.62.01 1.06.44l1.7 1.7c.2.2.2.52 0 .71l-1.7 1.71A1.5 1.5 0 0 1 7.09 8H6.5a.5.5 0 0 1 0-1h.59a.5.5 0 0 0 .35-.15L8.79 5.5 7.44 4.15A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5V7h1.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0v-3A2.5 2.5 0 0 1 4.5 3zm8.41 2A2.5 2.5 0 0 1 18 7.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5H15a.5.5 0 0 1 0-1zM13 5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
]);
const $81c528f1808b6955$export$3f0811b91e581dd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHolderFilled', "1em", [
    "M15.5 5A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v-4.5c0-.83-.67-1.5-1.5-1.5h-7c-.83 0-1.5.67-1.5 1.5V17h-.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zm-2 7c.28 0 .5.22.5.5V17H6v-4.5c0-.28.22-.5.5-.5zm-6 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $81c528f1808b6955$export$be2c74fc41ba1ff1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderHolderRegular', "1em", [
    "M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zm2.73 3L8.15 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H5v-3.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V16h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM6.5 12a.5.5 0 0 0-.5.5V16h8v-3.5a.5.5 0 0 0-.5-.5zm6 2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm-8-10C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $81c528f1808b6955$export$a559f2d748fe0377 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightningFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h8a1.5 1.5 0 0 1-1.38-2.08l2.08-5A1.5 1.5 0 0 1 14.58 9H18V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.5 8h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $81c528f1808b6955$export$ed642a7aa7e3a5a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightningRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h8a1.5 1.5 0 0 1-1.41-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V9h1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zM12.5 16h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $81c528f1808b6955$export$c04dddafb5e306ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLinkFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.84a3.5 3.5 0 0 1 3.16-5h4q.82 0 1.5.34V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.5 5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $81c528f1808b6955$export$a4befdde9ab500b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLinkRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.84a4 4 0 0 1-.3-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v4.54q.53.07 1 .3V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9.5 7.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $81c528f1808b6955$export$5c444b1b9dce8bb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderListFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h6.59q.09-.29.3-.5a1.5 1.5 0 0 1 0-2A1.5 1.5 0 0 1 12.5 12h5.49V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.5 5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
]);
const $81c528f1808b6955$export$e839f95591d8d951 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderListRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h6.59q.09-.29.3-.5a2 2 0 0 1-.3-.5H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V12h1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9.5 7.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
]);
const $81c528f1808b6955$export$a5e6fabb4e5684c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMailFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.55a3 3 0 0 1-.05-.5v-4a2.5 2.5 0 0 1 2.5-2.5h6q.26 0 .5.05V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm8.01 4.3 4.5 2.63L19 12.5v-.01c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3M19 13.64l-4.26 2.3a.5.5 0 0 1-.5 0L10 13.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5z"
]);
const $81c528f1808b6955$export$dbaf862c40d26f46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMailRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.55a3 3 0 0 1-.05-.5V16H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V10h.5q.26 0 .5.05V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm7.01 6.8 4.5 2.63L19 12.5v-.01c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3M19 13.64l-4.26 2.3a.5.5 0 0 1-.5 0L10 13.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5z"
]);
const $81c528f1808b6955$export$8b757bbe9799c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultipleFilled', "1em", [
    "M17 7.76c.6.55 1 1.35 1 2.24v2a5 5 0 0 1-5 5H7a3 3 0 0 1-2.24-1H13a4 4 0 0 0 4-4V7.76M13 5a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8h4.88a2 2 0 0 0 1.41-.59L10.71 5zM6.88 3a2 2 0 0 1 1.41.59l1.21 1.2-1.91 1.92a1 1 0 0 1-.71.29H2V6a3 3 0 0 1 3-3z"
]);
const $81c528f1808b6955$export$c72f2b30cabe55c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultipleRegular', "1em", [
    "M17 7.76c.6.55 1 1.35 1 2.24v2a5 5 0 0 1-5 5H7a3 3 0 0 1-2.24-1H13a4 4 0 0 0 4-4V7.76M6.87 3a2 2 0 0 1 1.41.59L9.71 5H13a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm1.41 4.41A2 2 0 0 1 6.88 8H3v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H9.7zM5 4a2 2 0 0 0-2 2v1h3.88a1 1 0 0 0 .7-.3L8.8 5.5 7.6 4.3a1 1 0 0 0-.71-.3z"
]);
const $81c528f1808b6955$export$16debf5d834efe50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenFilled', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v6.97l1.57-2.72A3.5 3.5 0 0 1 6.6 8H16v-.5A2.5 2.5 0 0 0 13.5 5H9.7L8.16 3.44A1.5 1.5 0 0 0 7.09 3zm-.07 7.25A2.5 2.5 0 0 1 6.6 9H17a2 2 0 0 1 1.73 3l-2.16 3.75A2.5 2.5 0 0 1 14.4 17H4a2 2 0 0 1-1.73-3z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$16f8b9b6f1cfd6ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenRegular', "1em", [
    "M3 5.5v6.6l1.5-2.6A3 3 0 0 1 7.1 8H15v-.5c0-.83-.67-1.5-1.5-1.5h-4a.5.5 0 0 1-.35-.15l-1.71-1.7A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5m1.28 10.48.22.02h9.4a2 2 0 0 0 1.73-1l2.17-3.75A1.5 1.5 0 0 0 16.5 9H7.1a2 2 0 0 0-1.73 1L3.2 13.75a1.5 1.5 0 0 0 1.08 2.23M2 14.46V5.5A2.5 2.5 0 0 1 4.5 3h2.59c.4 0 .78.16 1.06.44L9.7 5h3.79A2.5 2.5 0 0 1 16 7.5V8h.5a2.5 2.5 0 0 1 2.16 3.75L16.5 15.5a3 3 0 0 1-2.6 1.5H4.5a2.5 2.5 0 0 1-1.62-.6A2.5 2.5 0 0 1 2 14.46"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$95b174a33f5cb329 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDownFilled', "1em", [
    "M4.5 17A2.5 2.5 0 0 1 2 14.5V7.53l1.57 2.72A3.5 3.5 0 0 0 6.6 12H16v.5a2.5 2.5 0 0 1-2.5 2.5H9.7l-1.55 1.56a1.5 1.5 0 0 1-1.06.44zm-.07-7.25A2.5 2.5 0 0 0 6.6 11H17a2 2 0 0 0 1.73-3l-2.16-3.75A2.5 2.5 0 0 0 14.4 3H4a2 2 0 0 0-1.73 3z"
]);
const $81c528f1808b6955$export$b3fd8e4c7b8aa457 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDownRegular', "1em", [
    "M3 14.5V7.9l1.5 2.6A3 3 0 0 0 7.1 12H15v.5c0 .83-.67 1.5-1.5 1.5h-4a.5.5 0 0 0-.35.15l-1.71 1.7a.5.5 0 0 1-.35.15H4.5A1.5 1.5 0 0 1 3 14.5M4.28 4.02 4.5 4h9.4a2 2 0 0 1 1.73 1l2.17 3.75A1.5 1.5 0 0 1 16.5 11H7.1a2 2 0 0 1-1.73-1L3.2 6.25a1.5 1.5 0 0 1 1.08-2.23M2 5.54v8.96A2.5 2.5 0 0 0 4.5 17h2.59c.4 0 .78-.16 1.06-.44L9.7 15h3.79a2.5 2.5 0 0 0 2.5-2.5V12h.5a2.5 2.5 0 0 0 2.16-3.75L16.5 4.5A3 3 0 0 0 13.9 3H4.5a2.5 2.5 0 0 0-1.62.6A2.5 2.5 0 0 0 2 5.54"
]);
const $81c528f1808b6955$export$e1cc8faf5162a895 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVerticalFilled', "1em", [
    "M17 4.5A2.5 2.5 0 0 0 14.5 2H7.53l2.72 1.57A3.5 3.5 0 0 1 12 6.6V16h.5a2.5 2.5 0 0 0 2.5-2.5V9.7l1.56-1.55c.28-.28.44-.67.44-1.06zm-7.25-.07A2.5 2.5 0 0 1 11 6.6V17a2 2 0 0 1-3 1.73l-3.75-2.16A2.5 2.5 0 0 1 3 14.4V4a2 2 0 0 1 3-1.73z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$7057abce4f6b1542 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVerticalRegular', "1em", [
    "M14.5 3H7.9l2.6 1.5A3 3 0 0 1 12 7.1V15h.5c.83 0 1.5-.67 1.5-1.5v-4a.5.5 0 0 1 .15-.35l1.7-1.71a.5.5 0 0 0 .15-.35V4.5c0-.83-.67-1.5-1.5-1.5M4.02 4.28 4 4.5v9.4a2 2 0 0 0 1 1.73l3.75 2.17A1.5 1.5 0 0 0 11 16.5V7.1a2 2 0 0 0-1-1.73L6.25 3.2a1.5 1.5 0 0 0-2.23 1.08M5.54 2h8.96A2.5 2.5 0 0 1 17 4.5v2.59q-.01.61-.44 1.06L15 9.7v3.79a2.5 2.5 0 0 1-2.5 2.5H12v.5a2.5 2.5 0 0 1-3.75 2.16L4.5 16.5A3 3 0 0 1 3 13.9V4.5a2.5 2.5 0 0 1 .6-1.62A2.5 2.5 0 0 1 5.54 2"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$57128440c5c96cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeopleFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.52L9 16.6a2.6 2.6 0 0 1 1.95-2.52 2.75 2.75 0 1 1 4.54-3 2.2 2.2 0 0 1 2.51-.35V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm12.75 4.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $81c528f1808b6955$export$b1919456631b826d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeopleRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.52L9 16.6q0-.3.07-.6H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v3q.54 0 1 .23V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm11.75 6.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6m.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35q.53.68.55 1.6 0 .7-.3 1.4"
]);
const $81c528f1808b6955$export$d56e5882091be944 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPersonFilled', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5V7h5.09a.5.5 0 0 0 .35-.15L9.5 4.8 8.22 3.51A1.8 1.8 0 0 0 6.98 3zM2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79A2.5 2.5 0 0 1 18 7.5v2.84a3 3 0 1 0-4.73 3.67A2.5 2.5 0 0 0 11.04 17H4.5A2.5 2.5 0 0 1 2 14.5M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $81c528f1808b6955$export$7f90be4128f93dc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPersonRegular', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v2.84q-.4-.57-1-.94V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h6.55a3 3 0 0 0-.01 1H4.5A2.5 2.5 0 0 1 2 14.5zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4zm13 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $81c528f1808b6955$export$b629f6bc537790b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibitedFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm8 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $81c528f1808b6955$export$de966c3d2c61a117 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibitedRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm7 9a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $81c528f1808b6955$export$846fd9993cde33d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearchFilled', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5V7h5.09a.5.5 0 0 0 .35-.15L9.5 4.8 8.22 3.51A1.8 1.8 0 0 0 6.98 3zM2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79A2.5 2.5 0 0 1 18 7.5V12h-.03A4.5 4.5 0 1 0 13 16.97V17H4.5A2.5 2.5 0 0 1 2 14.5M13.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-3.5 3.5m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $81c528f1808b6955$export$b6802ea88ebd3aa5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearchRegular', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5V12h-.03A4.5 4.5 0 0 0 17 9.67V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h6.17q1 .82 2.33.97V17H4.5A2.5 2.5 0 0 1 2 14.5zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4zm9 12c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-3.5 3.5m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $81c528f1808b6955$export$fcd553068486ec94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwapFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.38l-.44-.44a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 13.9 14h1.18a1.5 1.5 0 0 1 2.47-1.56l.44.44V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm10.85 5.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58z"
]);
const $81c528f1808b6955$export$b424c65fca364400 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwapRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.38l-.44-.44a2 2 0 0 1-.35-.56H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v4.59q.31.1.56.35l.44.44V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm9.85 8.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58z"
]);
const $81c528f1808b6955$export$cd812e99821ce8dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSyncFilled', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2zM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 9-4.24V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8zm8 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $81c528f1808b6955$export$184233d658f5a622 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSyncRegular', "1em", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1q-.24-.48-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1q.54.27 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.8 1.8 0 0 0 6.98 3zM3 5.5C3 4.67 3.67 4 4.5 4h2.48q.32 0 .53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3zm7 9a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $81c528f1808b6955$export$23be23a42d6a74e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZipFilled', "1em", [
    "M13 13a1 1 0 0 1 1 1v3.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25V14a1 1 0 0 1 1-1m2.5-8A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v-3a2 2 0 1 0-4 0v3H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09q.62-.01 1.06-.44L10.7 5zm-4 6a.5.5 0 0 0 0 1H13v-1zm1.5 0h1.5a.5.5 0 0 0 0-1H13zm-1.5-2a.5.5 0 0 0 0 1H13V9zM13 9h1.5a.5.5 0 0 0 0-1H13zm-1.5-2a.5.5 0 0 0 0 1H13V7zM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3z"
]);
const $81c528f1808b6955$export$f0d2b7f3176e32b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZipRegular', "1em", [
    "M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v.54c0 .25-.2.46-.46.46h-3.08l-.1-.01a.46.46 0 0 1-.36-.45V17H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zM13 13a1 1 0 0 0-1 1v3h2v-3a1 1 0 0 0-1-1M8.15 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H11v-2a2 2 0 1 1 4 0v2h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H9.7zM13 12h-1.5a.5.5 0 0 1 0-1H13zm1.5-2a.5.5 0 0 1 0 1H13v-1zM13 10h-1.5a.5.5 0 0 1 0-1H13zm1.5-2a.5.5 0 0 1 0 1H13V8zM13 8h-1.5a.5.5 0 0 1 0-1H13zM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.8.8 0 0 0 6.98 4z"
]);
const $81c528f1808b6955$export$c0dcc4d743591826 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveFilled', "1em", [
    "M4 10q-.9.01-1.6.46l2.25-5.25A2 2 0 0 1 6.5 4h7.1c.75 0 1.43.41 1.77 1.09.54 1.1 1.53 3.2 2.33 5.43A3 3 0 0 0 16 10zm12 1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H3.99A2 2 0 0 1 2 14v-1c0-1.1.9-2 2-2zm-.5 3.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $81c528f1808b6955$export$c9f99b33a2af3073 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveRegular', "1em", [
    "M2 12q0-.61.24-1.16l2.41-5.63A2 2 0 0 1 6.5 4h7.1c.75 0 1.43.41 1.77 1.09a55 55 0 0 1 2.45 5.77q.2.56.19 1.14v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm11.6-7H6.48a1 1 0 0 0-.92.6l-1.9 4.43L4 10h12q.23 0 .45.05a57 57 0 0 0-2-4.52A1 1 0 0 0 13.6 5M16 15a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm-1.25-1.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $81c528f1808b6955$export$9fd41e45971421cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdFilled', "1em", [
    "M12.42 12h-.92V8h.92c.87 0 1.58.7 1.58 1.58v.84c0 .87-.7 1.58-1.58 1.58M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-.5 4c.28 0 .5.22.5.5V10h2.5V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V11H6v1.5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M11 7h1.42A2.6 2.6 0 0 1 15 9.58v.84A2.6 2.6 0 0 1 12.42 13H11a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5"
]);
const $81c528f1808b6955$export$4a0a58ff6303d2d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LikertFilled', "1em", [
    "M6 16v-5.5H2V13a3 3 0 0 0 3 3zm1 0h8a3 3 0 0 0 3-3v-2.5H7zm2-2a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M18 9.5V7a3 3 0 0 0-3-3H7v5.5zM9.75 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6 4H5a3 3 0 0 0-3 3v2.5h4z"
]);
const $81c528f1808b6955$export$4bf5ca9938ec92ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LikertRegular', "1em", [
    "M9.5 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v2.5h3V5zm1 5.5H3V13c0 1.1.9 2 2 2h1zm1 0V15h8a2 2 0 0 0 2-2v-2.5zm10-1V7a2 2 0 0 0-2-2H7v4.5z"
]);
const $81c528f1808b6955$export$5c25198b88365981 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomFilled', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v5h14V6a2 2 0 0 0-2-2z"
]);
const $81c528f1808b6955$export$fbc1ca0dc5193543 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomRegular', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM3 6c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v5H3zm0 6h14v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
]);
const $81c528f1808b6955$export$b3517ead8f6d8632 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomContractFilled', "1em", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 1 1 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-3.83a2 2 0 0 1-.3.5l-1.74 2a1.5 1.5 0 0 1-2.26 0l-1.75-2a2 2 0 0 1-.29-.5H3z"
]);
const $81c528f1808b6955$export$d8bc83220b95d5ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomContractRegular', "1em", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 1 1 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-3.83a2 2 0 0 1-.3.5l-.44.5H17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2h4.57l-.45-.5a2 2 0 0 1-.29-.5H3z"
]);
const $81c528f1808b6955$export$5e887642c122263e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomExpandFilled', "1em", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-5.5v1.5a1.5 1.5 0 1 1-3 0V11H3z"
]);
const $81c528f1808b6955$export$5b77fc065494ee11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomExpandRegular', "1em", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-5.5v1H17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2h5.5v-1H3z"
]);
const $81c528f1808b6955$export$9fadf10bf8a9473d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFilled', "1em", [
    "M15 4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8.5 15H15a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8.5z"
]);
const $81c528f1808b6955$export$bd6b1075b7e17460 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftRegular', "1em", [
    "M15 4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM8.5 15H15a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8.5zM5 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h2.5V5z"
]);
const $81c528f1808b6955$export$22eba0188facb7a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAddFilled', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H8.5V4H15a2 2 0 0 1 2 2v3.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm14 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$d9e3a70aeb7a37de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAddRegular', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V6a2 2 0 0 0-2-2H8.5v11h.52q.05.51.19 1H5a3 3 0 0 1-3-3zm5.5-2H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$e480533af50e1bb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContractFilled', "1em", [
    "M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm4 11V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $81c528f1808b6955$export$13ec26d030838d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContractRegular', "1em", [
    "M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76zM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h3v10H4a1 1 0 0 1-1-1zm5 9V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $81c528f1808b6955$export$b3b9a43aa9282b0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpandFilled', "1em", [
    "m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1zM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm6 1V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $81c528f1808b6955$export$e9837099cf8dc1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpandRegular', "1em", [
    "m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1zM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm2 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3v10zm4 0V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $81c528f1808b6955$export$c5b10d0380b35fda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRightFilled', "1em", [
    "M16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zM7 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $81c528f1808b6955$export$b69cf4bf3a19b594 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderFilled', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm12 3v1H8.5V4H15a2 2 0 0 1 2 2m-2 9H8.5V8H17v5a2 2 0 0 1-2 2"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$29c558d28987664b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderRegular', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm3.5 4V4H15a2 2 0 0 1 2 2v1zm0 1H17v5a2 2 0 0 1-2 2H8.5zM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$5652aeace4c20a46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAddFilled', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V8H8.5v7h.52q.05.51.19 1H5a3 3 0 0 1-3-3zm15 0a2 2 0 0 0-2-2H8.5v3H17zm2 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$52f0139f4939ceb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAddRegular', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H8.5V8H17v1.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm12 4H8.5V4H15a2 2 0 0 1 2 2zM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$20bf7b5708809551 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKeyFilled', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.53a4 4 0 0 0-1-.4V8H8.5v7h1.88l-.94.94-.05.06H5a3 3 0 0 1-3-3zm6.5 1H17V6a2 2 0 0 0-2-2H8.5zm2 12a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$412f1b624ce5d86c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKeyRegular', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.39l.05-.06.94-.94H8.5V8H17v1.12a4 4 0 0 1 1 .41V6a3 3 0 0 0-3-3zm12 4H8.5V4H15a2 2 0 0 1 2 2zM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m5.5 15a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$7ac61fa204ac9f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKeyFilled', "1em", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.39l.05-.06.94-.94H8.5V4H15a2 2 0 0 1 2 2v3.12a4 4 0 0 1 1 .41V6a3 3 0 0 0-3-3zm5.15 15.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$5eb0bf13cb06638c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKeyRegular', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.53a4 4 0 0 0-1-.4V6a2 2 0 0 0-2-2H8.5v11h1.88l-.94.94-.05.06H5a3 3 0 0 1-3-3zm5.5-2H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5zm2.65 14.85q.15.15.35.15h2q.16 0 .27-.07.1-.06.15-.17l.06-.24.02-.25V18l.56-.02a.5.5 0 0 0 .3-.12q.1-.1.12-.3L14 17h.5q.16 0 .27-.07a1 1 0 0 0 .15-.17 1 1 0 0 0 .07-.24 2 2 0 0 0 .01-.5v-.2q.26.1.52.14.27.04.54.04a2.9 2.9 0 0 0 2.08-.9A3 3 0 0 0 19 13a3 3 0 0 0-.87-2.12 3 3 0 0 0-5.04 2.83l-2.94 2.94q-.15.14-.15.35v1.5q0 .2.15.35m7.13-7.13q.22.21.22.53 0 .31-.22.53a.7.7 0 0 1-.53.22.7.7 0 0 1-.53-.22.7.7 0 0 1-.22-.53q0-.31.22-.53a.7.7 0 0 1 .53-.22q.31 0 .53.22"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$f0d9af53e3313f0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTallFilled', "1em", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM8.5 16H15a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5z"
]);
const $81c528f1808b6955$export$a1e4c97d59381265 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTallRegular', "1em", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM8.5 16H15a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5zM5 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2.5V4z"
]);
const $81c528f1808b6955$export$72d73c8c90494056 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextFilled', "1em", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM9 16h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H9zm-4.59-3a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0-.09-1H4.41m.09-3.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM4.41 6a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0-.09-1H4.41"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$941b97a423f06358 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextRegular', "1em", [
    "M6.5 13a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H6.5m0-3.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0-3.5a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H6.5M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM5 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3V4zm4 0v12h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$f9aedbfc8517c389 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAddFilled', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V6a2 2 0 0 0-2-2H9v11h.02q.05.51.19 1H5a3 3 0 0 1-3-3zm4.59 1a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 0-.5-.5H4.41a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0 .41-.5m12 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$97c13381a35356de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAddRegular', "1em", [
    "M6.59 7a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 1-.41.5H4.5a.5.5 0 0 1-.09-1H6.5c.28 0 .5.22.5.5M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H9V4h6a2 2 0 0 1 2 2v3.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm0 1h3v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$1f20b319079f0278 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismissFilled', "1em", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a6 6 0 0 0-1-.66V6a2 2 0 0 0-2-2H9v11h.02q.05.51.19 1H5a3 3 0 0 1-3-3zm4.59 1a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 0-.5-.5H4.41a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0 .41-.5m12 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$e6601c8017e0458d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismissRegular', "1em", [
    "M6.59 7a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09m0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09M7 12.5a.5.5 0 0 1-.41.5H4.5a.5.5 0 0 1-.09-1H6.5c.28 0 .5.22.5.5M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H9V4h6a2 2 0 0 1 2 2v3.6q.54.27 1 .66V6a3 3 0 0 0-3-3zm0 1h3v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$b0d098b3371668ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightFilled', "1em", [
    "M15 3a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM5 4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h6.5V4z"
]);
const $81c528f1808b6955$export$d4f1886e29d8a739 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightRegular', "1em", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3zm-6.5-2v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm1 0H15a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2.5z"
]);
const $81c528f1808b6955$export$84293262f92979cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightAddFilled', "1em", [
    "M18 6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2q-.13-.49-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8v4.6a5.5 5.5 0 0 1 6 .66zm-3.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $81c528f1808b6955$export$2d86eea2b4d53857 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightAddRegular', "1em", [
    "M18 6c0-1.1-.9-2.02-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2q-.13-.49-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8v4.6q.49-.25 1-.4V5h3a1 1 0 0 1 1 1v3.6q.54.27 1 .66zm-3.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $81c528f1808b6955$export$b8f67d27b8fb0bdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContractFilled', "1em", [
    "m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1zM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zM12 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $81c528f1808b6955$export$1f6bfaad985d3f3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContractRegular', "1em", [
    "m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1zM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zm1-2a1 1 0 0 1-1 1h-3V5h3a1 1 0 0 1 1 1zm-5-9v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $81c528f1808b6955$export$c36146a851ced3e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursorFilled', "1em", [
    "M15 3a3 3 0 0 1 3 3v7q-.01.8-.38 1.45l-5.06-5.01A1.5 1.5 0 0 0 11.5 9V4H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h5v1H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm-3.14 7.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $81c528f1808b6955$export$894857d7e517a0dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursorRegular', "1em", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h5v-1H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.5v5c.36 0 .72.13 1 .38V4H15a2 2 0 0 1 2 2v7a2 2 0 0 1-.13.7l.75.75Q18 13.8 18 13zm-6.14 4.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $81c528f1808b6955$export$7bbaf42af3a73a1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpandFilled', "1em", [
    "m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1zM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2zm-6 1V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1z"
]);
const $81c528f1808b6955$export$84a242a9906239f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpandRegular', "1em", [
    "m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1zM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2zm-2 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3v10zm-4 0V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1z"
]);
const $81c528f1808b6955$export$483c7a5cb1a630ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGalleryFilled', "1em", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1h-5v3H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8v3h5zm0 2h-5v3h5z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$188052540ce65dc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGalleryRegular', "1em", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3zm-1 5h-4V8h4zm-4 1h4v1a2 2 0 0 1-2 2h-2zm4-6v1h-4V4h2a2 2 0 0 1 2 2m-5-2v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2z"
], {
    flipInRtl: true
});
const $81c528f1808b6955$export$b455d4157ea5dc43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelSeparateWindowFilled', "1em", [
    "M3 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 12v-3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
]);
const $81c528f1808b6955$export$97746aa9f1d42e9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelSeparateWindowRegular', "1em", [
    "M3 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM2 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm1 10v-3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
]);
const $81c528f1808b6955$export$daf8869971304db7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopContractFilled', "1em", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-3.83a2 2 0 0 0-.3-.5l-1.74-2a1.5 1.5 0 0 0-2.26 0l-1.75 2a2 2 0 0 0-.29.5H3z"
]);
const $81c528f1808b6955$export$39aa18b7131141c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopContractRegular', "1em", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-3.83a2 2 0 0 0-.3-.5l-.44-.5H17V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h4.57l-.45.5a2 2 0 0 0-.29.5H3z"
]);
const $81c528f1808b6955$export$690cb735aae75508 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopExpandFilled', "1em", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 0 1 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5.5V7.5a1.5 1.5 0 1 0-3 0V9H3z"
]);
const $81c528f1808b6955$export$b7f48053d49ecbf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopExpandRegular', "1em", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 0 1 1 0zM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5.5V8H17V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h5.5v1H3z"
]);
const $81c528f1808b6955$export$ebe0cc6abad10e84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGalleryFilled', "1em", [
    "M7 4H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-2v5h4v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9h4zm1 5h4V4H8z"
]);
const $81c528f1808b6955$export$86244d067a8fc59f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGalleryRegular', "1em", [
    "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM3 7c0-1.1.9-2 2-2h2v4H3zm0 3h14v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm14-1h-4V5h2a2 2 0 0 1 2 2zm-5-4v4H8V5z"
]);
const $81c528f1808b6955$export$e3917b6a0072c49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RocketFilled', "1em", [
    "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82m2.11.7a1 1 0 1 0-1.4 1.41 1 1 0 0 0 1.4-1.4M9.44 13.6l.6.6a1.5 1.5 0 0 0 1.71.3l1.12 1.12c.2.2.51.2.7 0L15 14.2c.86-.86.96-2.17.31-3.14l.85-.85a6.3 6.3 0 0 0 1.56-6.33 2.4 2.4 0 0 0-1.6-1.6A6.3 6.3 0 0 0 9.8 3.86l-.85.85A2.5 2.5 0 0 0 5.8 5L4.38 6.43a.5.5 0 0 0 0 .7L5.5 8.27a1.5 1.5 0 0 0 .3 1.7l.6.61-1.21.73a.5.5 0 0 0-.1.78l2.83 2.83a.5.5 0 0 0 .79-.1zm7.32-9.42a5.3 5.3 0 0 1-1.3 5.33l-4 4a.5.5 0 0 1-.7 0l-1.07-1.07-2.12-2.12L6.5 9.24a.5.5 0 0 1 0-.7l3.99-4a5.3 5.3 0 0 1 5.33-1.3c.44.13.8.48.93.93M5.8 14.91a.5.5 0 0 0-.7-.7l-1.77 1.76a.5.5 0 1 0 .7.7zM4.4 12.79c.2.2.2.5 0 .7l-.7.71a.5.5 0 1 1-.72-.7l.71-.71c.2-.2.51-.2.71 0m2.83 3.53a.5.5 0 1 0-.7-.7l-.72.7a.5.5 0 1 0 .71.71z"
]);
const $81c528f1808b6955$export$bb41fa62c74c812a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RocketRegular', "1em", [
    "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82m2.11.7a1 1 0 1 0-1.4 1.42 1 1 0 0 0 1.4-1.42m-1.12 7.37a1.5 1.5 0 0 1-1.7-.3l-.61-.6-.74 1.22a.5.5 0 0 1-.78.1L5.1 12.09a.5.5 0 0 1 .1-.79l1.22-.73-.61-.6a1.5 1.5 0 0 1-.3-1.71L4.38 7.14a.5.5 0 0 1 0-.7l1.06-1.07a3 3 0 0 1 3.42-.59l.93-.93a6.3 6.3 0 0 1 6.33-1.56c.76.24 1.36.83 1.6 1.6a6.3 6.3 0 0 1-1.56 6.32l-.94.94a3 3 0 0 1-.58 3.41l-1.06 1.06a.5.5 0 0 1-.71 0zm4.08-11.26a5.3 5.3 0 0 0-5.33 1.31l-.81.82-.7.7h-.01L6.86 8.2l-.4.4a.5.5 0 0 0 .05.66l4.24 4.24c.18.18.46.2.66.05l.4-.4 2.12-2.12.7-.71.82-.81a5.3 5.3 0 0 0 1.31-5.33c-.14-.45-.49-.8-.93-.94m-3.31 10.62.7.7.7-.7a2 2 0 0 0 .53-1.93zm-4.44-8.3a2 2 0 0 0-1.93.52l-.7.7.7.71zm.63 7.31L7.14 11.3l-.89.53 1.93 1.93zm-2.9 2.04a.5.5 0 1 0-.71-.7l-1.77 1.76a.5.5 0 1 0 .7.71zM4.38 12.8c.2.2.2.51 0 .7l-.71.72a.5.5 0 0 1-.7-.71l.7-.71c.2-.2.51-.2.7 0m2.83 3.54a.5.5 0 0 0-.7-.71l-.72.7a.5.5 0 1 0 .7.72z"
]);
const $81c528f1808b6955$export$5a336e2b39fe7dd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOffFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm4.99 11a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.77A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $81c528f1808b6955$export$9012ab2f4a43b2c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOffRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm3.99 11a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.77A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $81c528f1808b6955$export$4d5cbeff103c5d08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOnFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm6.33 3.62c.2.19.23.5.05.7l-3.5 4a.5.5 0 0 1-.73.03l-2-2a.5.5 0 1 1 .7-.7l1.63 1.62 3.14-3.6a.5.5 0 0 1 .7-.05M5.75 16A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.23v6.73a3.5 3.5 0 0 1-3.5 3.5H5.75"
]);
const $81c528f1808b6955$export$4c585319ee235d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOnRegular', "1em", [
    "M12.33 6.62c.2.19.23.5.05.7l-3.5 4a.5.5 0 0 1-.73.03l-2-2a.5.5 0 1 1 .7-.7l1.63 1.62 3.14-3.6a.5.5 0 0 1 .7-.05M3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-.25 12A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.23v6.73a3.5 3.5 0 0 1-3.5 3.5H5.75"
]);
const $81c528f1808b6955$export$3d5aaec708650109 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectFilled', "1em", [
    "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 4.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75m0 10.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m-3-7.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0zm10.5 0a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0z"
]);
const $81c528f1808b6955$export$83df983f7e8592ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectRegular', "1em", [
    "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 11c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3-8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0zm11 0a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0z"
]);
const $81c528f1808b6955$export$745ad041d06b569a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewFilled', "1em", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-4 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M6 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m8.11.75H9.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5M3.61 13 5.98 6.5q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5m6.5 3.25H5.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5m2.5-3.25 2.37-6.51q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5"
]);
const $81c528f1808b6955$export$ccf9886a9eba423c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewRegular', "1em", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02A1.5 1.5 0 0 0 16.48 6m-5.4 10a1.5 1.5 0 1 0 1.42-2h-.01c-.65 0-1.2.42-1.41 1l-.01.02a1.5 1.5 0 0 0 0 .98M3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M7.49 6a1.5 1.5 0 1 0 .02-3 1.5 1.5 0 0 0-.02 3m-3.62 7.03 2.32-6.4q.42.27.94.34l-2.32 6.4q-.43-.27-.94-.34M14.05 5h-4.1a3 3 0 0 0 0-1h4.1a3 3 0 0 0 0 1m-8.1 11h4.1a3 3 0 0 1 0-1h-4.1a3 3 0 0 1 0 1m6.92-2.97 2.32-6.4q.42.27.94.34l-2.32 6.4q-.42-.27-.94-.34"
]);
const $81c528f1808b6955$export$6f9b6f0abdadf511 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismissFilled', "1em", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5M3.6 13 5.98 6.5q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5m2.28 3.25h3.4a6 6 0 0 1-.28-1.5H5.89a2.5 2.5 0 0 1 0 1.5M16.39 7l-.77 2.11a6 6 0 0 0-1.56-.1l.92-2.52q.6.46 1.41.5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $81c528f1808b6955$export$5cfa09a5088574 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismissRegular', "1em", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64q.4.33.94.34M2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5M7.49 6zc.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68q.4.33.94.34m-1.3.63-2.32 6.4q.52.08.94.34l2.32-6.4a3 3 0 0 1-.94-.34M14.05 5h-4.1a3 3 0 0 0 0-1h4.1a3 3 0 0 0 0 1m.45 4q.45 0 .87.07l.76-2.1a3 3 0 0 1-.94-.34L14.33 9zm-5.48 6q.05.51.19 1H5.95a3 3 0 0 0 0-1zm9.98-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $81c528f1808b6955$export$485d70f72a755f33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEditFilled', "1em", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5M3.6 13 5.98 6.5q.6.46 1.41.5l-2.37 6.52q-.6-.46-1.41-.5m2.28 3.25H9.4l.02-.1q.18-.7.65-1.26 0-.08.03-.14H5.9a2.5 2.5 0 0 1 0 1.5M16.39 7l-.92 2.53-.37.31-2.1 2.1 1.98-5.45q.6.46 1.41.5m-5.41 8.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $81c528f1808b6955$export$b3f2073f398fbe7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEditRegular', "1em", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64q.4.33.94.34M2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5M7.49 6zc.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68q.4.33.94.34m-1.3.63-2.32 6.4q.52.08.94.34l2.32-6.4a3 3 0 0 1-.94-.34M14.05 5h-4.1a3 3 0 0 0 0-1h4.1a3 3 0 0 0 0 1m-.64 6.53 1.67-1.67 1.05-2.89a3 3 0 0 1-.94-.34zM5.95 16h3.52q.17-.54.52-1H5.95a3 3 0 0 1 0 1m5.03-.62 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $81c528f1808b6955$export$9434e5b627e8dd71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPoolFilled', "1em", [
    "M5.75 4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0V7.5h5V4.75a.75.75 0 1 0-1.5 0v.5a.75.75 0 1 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0v7.03q-.6.22-1.5.22V9H8v1.23A7 7 0 0 0 6.5 10V4.75A.75.75 0 0 0 5.75 4m.06 8.53c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a7 7 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.3 7.3 0 0 1-7.5-.17 5.4 5.4 0 0 0-3.32-.86m0 3c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a7 7 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.3 7.3 0 0 1-7.5-.17 5.4 5.4 0 0 0-3.32-.86"
]);
const $81c528f1808b6955$export$4b64c169385cb70b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPoolRegular', "1em", [
    "M5 5a1 1 0 0 1 2 0v5.05q.48.05 1 .19V9h5v3q.55 0 1-.09V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0V5a1 1 0 1 1 2 0v3H8V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0zm8.08 9a7.6 7.6 0 0 1-3.83-1.08c-3.42-1.97-5.32-.15-5.39-.08a.5.5 0 0 1-.71 0 .5.5 0 0 1 0-.7c.1-.1 2.48-2.46 6.6-.1a6 6 0 0 0 6.45.05c.22-.16.53-.11.7.1a.5.5 0 0 1-.1.7 6.7 6.7 0 0 1-3.72 1.1zm-3.83 1.92A7.6 7.6 0 0 0 13.08 17v-.01a6.7 6.7 0 0 0 3.71-1.1.5.5 0 0 0 .11-.7.5.5 0 0 0-.7-.1 6 6 0 0 1-6.44-.04c-4.13-2.37-6.5 0-6.61.1-.2.19-.2.5 0 .7s.52.18.71 0c.07-.08 1.97-1.9 5.39.07"
]);
const $81c528f1808b6955$export$5b0fa5d19a1a5411 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDownFilled', "1em", [
    "M14 6a4 4 0 0 1-2.25 3.6V8.44a3 3 0 1 0-3.5 0V9.6A4 4 0 1 1 14 6M9.47 17.78c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22V5.75a.75.75 0 0 0-1.5 0v9.69l-1.22-1.22a.75.75 0 0 0-1.06 1.06z"
]);
const $81c528f1808b6955$export$342cc147a940d41c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDownRegular', "1em", [
    "M14 6a4 4 0 0 1-2.5 3.7V8.6a3 3 0 1 0-3 0v1.1A4 4 0 1 1 14 6M9.65 17.85c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7l-2.15 2.14V5.5a.5.5 0 0 0-1 0v10.8l-2.15-2.15a.5.5 0 1 0-.7.7z"
]);
const $81c528f1808b6955$export$faae1d11844cf58d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRightFilled', "1em", [
    "M6 6a4 4 0 0 1 3.6 2.25H8.44a3 3 0 1 0 0 3.5H9.6A4 4 0 1 1 6 6m9.28 7.03 2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06l1.22 1.22H5.75a.75.75 0 1 0 0 1.5h9.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06"
]);
const $81c528f1808b6955$export$bf0fb97847d23583 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRightRegular', "1em", [
    "M6 6a4 4 0 0 1 3.7 2.5H8.6a3 3 0 1 0 0 3h1.1A4 4 0 1 1 6 6m8.85 7.35 3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 1 0-.7.7l2.14 2.15H5.5a.5.5 0 0 0 0 1h10.8l-2.15 2.15a.5.5 0 0 0 .7.7"
]);
const $81c528f1808b6955$export$2b50f63912079473 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUpFilled', "1em", [
    "M10.53 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v9.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06zM6 14a4 4 0 0 1 2.25-3.6v1.16a3 3 0 1 0 3.5 0V10.4A4 4 0 1 1 6 14"
]);
const $81c528f1808b6955$export$d60f896db2c1a89e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUpRegular', "1em", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L9.5 3.71V14.5a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 0 0 .7-.7zM6 14a4 4 0 0 1 2.5-3.7v1.1a3 3 0 1 0 3 0v-1.1A4 4 0 1 1 6 14"
]);
const $81c528f1808b6955$export$fdcc5593de05567 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDoubleFilled', "1em", [
    "M4 8.5a5.5 5.5 0 1 1 10.97.6q.51.22.93.57.1-.57.1-1.17a6.5 6.5 0 1 0-12.36 2.81q.38-.37.82-.61A5.5 5.5 0 0 1 4 8.5m10 0-.01.33-1-.17.01-.16a3.5 3.5 0 1 0-6.57 1.69 4 4 0 0 0-1.05.13A4.48 4.48 0 0 1 9.5 4 4.5 4.5 0 0 1 14 8.5m-6-1a1.5 1.5 0 1 1 3 0v2.08l2.94.51a2.5 2.5 0 0 1 1.91 3.33l-.98 2.67a2.5 2.5 0 0 1-1.92 1.6l-1.52.26c-1.02.18-1.95-.45-2.43-1.23A5.9 5.9 0 0 0 4.44 14a.5.5 0 0 1-.43-.62q.23-.89.82-1.36c.39-.32.85-.47 1.3-.52.63-.06 1.29.05 1.87.25z"
]);
const $81c528f1808b6955$export$eace6455d986601f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDoubleRegular', "1em", [
    "M9.5 3a5.5 5.5 0 0 0-5.04 7.7q-.45.24-.82.61Q3 10.02 3 8.5a6.5 6.5 0 1 1 12.9 1.17 4 4 0 0 0-.93-.57l.03-.6A5.5 5.5 0 0 0 9.5 3m4.49 5.83L14 8.5a4.5 4.5 0 1 0-8.62 1.82 4 4 0 0 1 1.05-.13A3.5 3.5 0 1 1 13 8.66zM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.5 4.5 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52q-.59.48-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5M9 7.5a.5.5 0 0 1 1 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 0 1 1.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.8 6.8 0 0 0-4.65-3.1q.12-.2.26-.3.3-.25.78-.3c.64-.07 1.42.14 2.04.45A.5.5 0 0 0 9 12.5z"
]);
const $81c528f1808b6955$export$c50ef2122a64aa71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingleFilled', "1em", [
    "M6 8.5a3.5 3.5 0 1 1 7 .16l.99.17.01-.33a4.5 4.5 0 1 0-8.62 1.82 4 4 0 0 1 1.05-.13A3.5 3.5 0 0 1 6 8.5M9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.5 4.5 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52q-.59.48-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5"
]);
const $81c528f1808b6955$export$60b7aa16b287ff3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingleRegular', "1em", [
    "M6 8.5a3.5 3.5 0 1 1 7 .16l.99.17.01-.33a4.5 4.5 0 1 0-8.62 1.82 4 4 0 0 1 1.05-.13A3.5 3.5 0 0 1 6 8.5M9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.5 4.5 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52q-.59.48-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5M9 7.5a.5.5 0 0 1 1 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 0 1 1.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.8 6.8 0 0 0-4.65-3.1q.12-.2.26-.3.3-.25.78-.3c.64-.07 1.42.14 2.04.45A.5.5 0 0 0 9 12.5z"
]);
const $81c528f1808b6955$export$ac1e1127db1187e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TeddyFilled', "1em", [
    "M5.5 3a3.5 3.5 0 0 0-2.85 5.53 8 8 0 0 1 5.5-4.32A3.5 3.5 0 0 0 5.5 3M18 6.5q-.02 1.16-.65 2.03a8 8 0 0 0-5.5-4.32A3.5 3.5 0 0 1 18 6.5m-15 5C3 7.87 6.17 5 10 5s7 2.87 7 6.5a6.2 6.2 0 0 1-1.76 4.31 5.5 5.5 0 0 0-10.48 0A6.2 6.2 0 0 1 3 11.5m8.33 1.7a4.5 4.5 0 0 1 3.07 3.35A7.3 7.3 0 0 1 10 18c-1.66 0-3.2-.54-4.4-1.45a4.5 4.5 0 0 1 3.07-3.35 1.5 1.5 0 0 0 2.66 0"
]);
const $81c528f1808b6955$export$e65eb6d5ff1dfbe9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TeddyRegular', "1em", [
    "M2 6.5a3.5 3.5 0 0 0 1.4 2.8Q3 10.35 3 11.5c0 3.63 3.17 6.5 7 6.5s7-2.87 7-6.5q0-1.16-.4-2.2a3.5 3.5 0 1 0-5.31-4.19 8 8 0 0 0-2.58 0A3.5 3.5 0 0 0 2 6.5M5.5 4c.97 0 1.8.55 2.22 1.35a7 7 0 0 0-3.87 3.03A2.5 2.5 0 0 1 5.5 4m6.78 1.35a2.5 2.5 0 1 1 3.87 3.03 7 7 0 0 0-3.87-3.03M10 6c3.35 0 6 2.5 6 5.5a5.2 5.2 0 0 1-1.2 3.3 5.5 5.5 0 0 0-9.6 0A5.2 5.2 0 0 1 4 11.5C4 8.5 6.65 6 10 6m4.06 9.55A6.3 6.3 0 0 1 10 17c-1.57 0-3-.55-4.06-1.45a4.5 4.5 0 0 1 2.73-2.35 1.5 1.5 0 0 0 2.66 0c1.2.37 2.19 1.23 2.73 2.35"
]);
const $81c528f1808b6955$export$c45ec12e967e74e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__a)",
            "fillRule": "evenodd",
            "d": "M9.5 15.5V13h1v2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__b)",
            "d": "M7.5 15a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5V17a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__c)",
            "fillRule": "evenodd",
            "d": "M3 5.5C3 4.67 3.67 4 4.5 4h3C8.33 4 9 4.67 9 5.5V7a3 3 0 0 1-6 0zM4.5 5a.5.5 0 0 0-.5.5V7a2 2 0 1 0 4 0V5.5a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__d)",
            "fillRule": "evenodd",
            "d": "M11 5.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5V7a3 3 0 1 1-6 0zm1.5-.5a.5.5 0 0 0-.5.5V7a2 2 0 1 0 4 0V5.5a.5.5 0 0 0-.5-.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_trophy_20_color__e)",
            "d": "M7.5 2a2 2 0 0 0-2 2v5a4.5 4.5 0 1 0 9 0V4a2 2 0 0 0-2-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__a",
                "x1": "9",
                "x2": "13",
                "y1": "12.5",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".17",
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#ff921f",
                    "stopOpacity": ".99"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__b",
                "x1": "31",
                "x2": "26.91",
                "y1": "27",
                "y2": "10.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".18",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6f47"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__c",
                "x1": "7.5",
                "x2": "1.5",
                "y1": "6.5",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_trophy_20_color__d",
                "x1": "13",
                "x2": "18.5",
                "y1": "6.5",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f",
                    "stopOpacity": ".99"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_trophy_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(229.63 10.26 3.15)scale(13.1244 13.98)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $81c528f1808b6955$export$bc8c270e121aa2a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyFilled', "1em", [
    "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97 4.5 4.5 0 0 1-3.9 3.5v1.5h2a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4zm9 4.94A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1zM5.5 5h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93z"
]);
const $81c528f1808b6955$export$e24223128b9ab363 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyRegular', "1em", [
    "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5a4.5 4.5 0 0 0 3.9-3.5A3 3 0 0 0 17 7V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5m10 0h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94zm-1-1v5a3.5 3.5 0 0 1-7 .16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1m-7 12.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1z"
]);
const $81c528f1808b6955$export$cfe1eaf7b5d665ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLockFilled', "1em", [
    "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7q0 .68-.28 1.26-.45-.21-1-.25.27-.45.28-1V5.5a.5.5 0 0 0-.5-.5h-1v3.17a3 3 0 0 0-2 2.83v.06A2 2 0 0 0 11 13v.39q-.24.05-.5.08v1.5h.5V17q.01.53.25.97H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4zm0 1h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93zm8 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $81c528f1808b6955$export$2d935723f0b02815 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLockRegular', "1em", [
    "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h5.25A2 2 0 0 1 11 17v-.03H6.5a1 1 0 0 1 1-1H11v-1h-.5v-1.5q.26-.03.5-.08V13a2 2 0 0 1 .12-.68A3.5 3.5 0 0 1 6.5 9.16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.76a3 3 0 0 1 1-.59V5h1c.27 0 .5.22.5.5V7q0 .56-.27 1 .52.05 1 .26.26-.57.27-1.26V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5m9 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $81c528f1808b6955$export$c7b4a72677a63347 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5q.92-.11 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7zM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5q.02-.35.32-.47zm8.9 3.76a5 5 0 0 1-.7 1.6L5.57 3.46A2 2 0 0 1 7.5 2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97m.1-1.03A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1z"
]);
const $81c528f1808b6955$export$685967860d893eab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5q.92-.11 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7zm8.62 10.03q-.67.31-1.47.32a3.5 3.5 0 0 1-3.5-3.34V7.2zM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5q.02-.35.32-.47zm8 2.79q-.02 1.03-.53 1.85l.72.72q.5-.71.7-1.6A3 3 0 0 0 17 7V5.5c0-.83-.67-1.5-1.5-1.5h-.99a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.92 1.46l.92.92V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1zm1-4h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94zm-8 11.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1z"
]);
const $81c528f1808b6955$export$b7dea71678818e94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkFilled', "1em", [
    "M4.7 6.16c.34.25.4.72.14 1.05L2.7 10l2.14 2.8a.75.75 0 1 1-1.18.9l-2.5-3.24a.75.75 0 0 1 0-.92l2.5-3.25a.75.75 0 0 1 1.05-.13m10.46 6.63a.75.75 0 1 0 1.18.92l2.5-3.25c.21-.27.21-.65 0-.92l-2.5-3.25a.75.75 0 1 0-1.18.92L17.3 10zM6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $81c528f1808b6955$export$a6e3b20189b198b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkRegular', "1em", [
    "M4.83 6.12c.2.18.23.5.05.7L2.16 10l2.72 3.17a.5.5 0 1 1-.76.66l-3-3.5a.5.5 0 0 1 0-.66l3-3.5a.5.5 0 0 1 .7-.05m10.29 7.05a.5.5 0 0 0 .76.66l3-3.5a.5.5 0 0 0 0-.66l-3-3.5a.5.5 0 1 0-.76.66L17.84 10zM6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $81c528f1808b6955$export$f75cbc2fc21a9460 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkToolboxFilled', "1em", [
    "M4.84 7.2a.75.75 0 0 0-1.18-.9l-2.5 3.24c-.21.27-.21.65 0 .92l2.5 3.25a.75.75 0 1 0 1.18-.92L2.7 10zm13.12 3.84a2.5 2.5 0 0 0-1.13-1.66l-1.67-2.17a.75.75 0 1 1 1.18-.92l2.5 3.25c.21.27.21.65 0 .92l-.52.68zM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $81c528f1808b6955$export$c12a9304c7573cf0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkToolboxRegular', "1em", [
    "M4.88 6.83a.5.5 0 1 0-.76-.66l-3 3.5a.5.5 0 0 0 0 .66l3 3.5a.5.5 0 1 0 .76-.66L2.16 10zm13.08 4.21q-.09-.45-.31-.82l.2-.22-2.73-3.17a.5.5 0 0 1 .76-.66l3 3.5a.5.5 0 0 1 0 .66l-.67.77zM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);


"use client";
const $6c2c53ad43edfb7d$export$e884c1c3f57da249 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneFilled', "1em", [
    "M9 2c.6 0 1.16.36 1.4.92l2.37 5.4 3.23-.2a1.9 1.9 0 0 1 2 1.76V10c0 1.04-.84 1.88-1.88 1.88H16l-3.23-.2-2.37 5.4c-.24.56-.8.92-1.4.92a.9.9 0 0 1-.88-.88v-.06l.7-5.63-2.46-.16-1.14 2.28a.8.8 0 0 1-.72.45.5.5 0 0 1-.5-.5v-2.38l-1.06-.06a1 1 0 0 1-.94-1v-.12a1 1 0 0 1 .94-1L4 8.88V6.5c0-.28.22-.5.5-.5.3 0 .59.17.72.45l1.14 2.28 2.46-.16L8.12 3A.9.9 0 0 1 9 2"
]);
const $6c2c53ad43edfb7d$export$b709ecf1e8228069 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneRegular', "1em", [
    "M8.78 8.29 8.1 2.81a1.16 1.16 0 0 1 1-1.3h.08l.17-.01c.6 0 1.13.35 1.37.9l2.51 5.74 2.75-.09c1.03-.03 1.9.73 2 1.74l.02.15V10c0 1.08-.87 1.95-1.96 1.95l-2.8-.1-2.52 5.75c-.24.55-.78.9-1.37.9h-.1a1.16 1.16 0 0 1-1.15-1.3l.68-5.5-2.14-.06-.96 1.67c-.24.43-.7.69-1.18.69a1 1 0 0 1-1-1v-1.47h-.16a1.53 1.53 0 0 1 0-3.05l.16-.01V7a1 1 0 0 1 1-1c.49 0 .94.26 1.18.69l.96 1.67zm.57-5.79h-.12a.16.16 0 0 0-.14.18l.82 6.57-3.84.13-1.26-2.2A.4.4 0 0 0 4.5 7v2.43l-.98.04a.53.53 0 0 0 0 1.06l.98.04V13h.08q.15-.05.23-.18l1.26-2.2 3.84.13-.82 6.59q.01.15.16.16h.1a.5.5 0 0 0 .45-.3l2.79-6.36 3.46.11c.52 0 .95-.42.95-.95v-.03a.95.95 0 0 0-.98-.92l-3.43.11L9.8 2.8a.5.5 0 0 0-.45-.3"
]);
const $6c2c53ad43edfb7d$export$42b8b3f677dfb499 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLandingFilled', "1em", [
    "m11.88 6-1.03-2.15C10.16 2.41 8 2.91 8 4.5v.74l2.77.76zm-1.11 1-.27-.04L6 5.74V4.2c0-1.22-1.61-1.66-2.23-.6L2.24 6.19c-.57.96-.1 2.2.96 2.55l3.42 1.12-1.68 1.52c-1.17 1.08-.08 3 1.45 2.55l6.6-1.99 3.04 1A1.5 1.5 0 0 0 18 11.5V11a4 4 0 0 0-4-4zM2 17.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $6c2c53ad43edfb7d$export$8ab6df5e3d879a91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLandingRegular', "1em", [
    "m12.36 7-1.5-3.15C10.15 2.41 8 2.91 8 4.5v1.78l-2-.54V4.2c0-1.22-1.61-1.66-2.23-.6L2.24 6.19c-.57.96-.1 2.2.96 2.55l3.42 1.12-1.68 1.52c-1.17 1.08-.08 3 1.45 2.55l6.6-1.99 3.04 1A1.5 1.5 0 0 0 18 11.5V11a4 4 0 0 0-4-4zm-1.1 0h-.5l-.26-.04-1.5-.4V4.5c0-.53.72-.7.95-.21zM2 17.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m11.59-6.41a2 2 0 0 0-1.18-.01L6.1 12.97c-.51.15-.87-.49-.48-.85l1.67-1.53a1 1 0 0 0-.36-1.68L3.52 7.79a.75.75 0 0 1-.42-1.1L4.63 4.1c.1-.17.37-.1.37.1v1.92c0 .22.15.42.37.48l4.87 1.33a2 2 0 0 0 .53.07H14a3 3 0 0 1 3 3v.51a.5.5 0 0 1-.66.48l-2.39-.79z"
]);
const $6c2c53ad43edfb7d$export$dd346cea9d158e8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOffFilled', "1em", [
    "m11.68 5.16-.38.33q-.35.33-.74.46L4.76 7.9l-.6-1.23a1 1 0 0 0-.24-.34c-.62-.6-1.74-.27-1.9.62L2 7.16v2.99c0 1.2 1.18 2.04 2.32 1.65l3.02-1.04-.3 1.46c-.3 1.56 1.7 2.47 2.66 1.21l3.1-4 4.18-1.35c.84-.27 1.33-1.28.74-2.1-.52-.7-1.43-1.68-2.67-1.92a3 3 0 0 0-.88-.04 5 5 0 0 0-2.5 1.14m-2.57.22L5.38 6.62l-.04-.05a1.6 1.6 0 0 1 2.17-2.29zM2.5 17a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$b2cbb34b8295d77e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOffRegular', "1em", [
    "M14.5 4c-1.41-.01-2.63.96-3.2 1.49q-.35.33-.74.46l-.41.14L7.5 4.28a1.6 1.6 0 0 0-2.17 2.3l.7.88-1.28.43-.6-1.23C3.65 5.57 2 5.95 2 7.16v2.99c0 1.2 1.18 2.04 2.32 1.65l3.02-1.04-.3 1.46c-.3 1.56 1.7 2.47 2.66 1.21l3.1-4 4.18-1.35c.84-.27 1.33-1.28.74-2.1-.6-.8-1.7-1.97-3.22-1.98M7.04 7.13l-.9-1.17a.6.6 0 0 1 .8-.86L8.96 6.5zm4.94-.91c.55-.51 1.51-1.23 2.52-1.22 1 0 1.85.8 2.41 1.58q.1.15.04.3-.06.16-.28.25l-4.32 1.4a.5.5 0 0 0-.25.16l-3.19 4.13c-.32.42-.99.12-.88-.4l.29-1.47a1 1 0 0 0-1.3-1.14l-3.03 1.04c-.48.17-.99-.19-.99-.7V7.16q0-.07.03-.1l.08-.04.1.01.06.07.78 1.62c.1.22.37.33.6.25l6.23-2.07c.43-.14.8-.4 1.1-.68M2.5 17a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$9cd746c5e8438238 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelFilled', "1em", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m-4-5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1"
]);
const $6c2c53ad43edfb7d$export$4c037288df0e312 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelRegular', "1em", [
    "M3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m0-1q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15m3.5 4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$fdccd763c8fc4a9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAddFilled', "1em", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $6c2c53ad43edfb7d$export$a28d23e22ac361d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAddRegular', "1em", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $6c2c53ad43edfb7d$export$ccee2990988fa744 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlertFilled', "1em", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M16.5 13a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36zm-3.41 4a1.5 1.5 0 0 0 2.82 0z"
]);
const $6c2c53ad43edfb7d$export$780a60dd6c13e230 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlertRegular', "1em", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M16.5 13a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36zm-3.41 4a1.5 1.5 0 0 0 2.82 0z"
]);
const $6c2c53ad43edfb7d$export$a7ff3a08126b3892 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeftFilled', "1em", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $6c2c53ad43edfb7d$export$6ff701d60beb9b63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeftRegular', "1em", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $6c2c53ad43edfb7d$export$ad03c8825251116 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRightFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0-7A2.5 2.5 0 0 1 17 5.5v4.1a5.5 5.5 0 0 0-6.74 1.4H7.5a.5.5 0 0 0 0 1h2.1a5.5 5.5 0 0 0 0 5H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 1 0 .2-3.92A2.5 2.5 0 0 1 5.5 3zm.35 9.15a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM7.5 8a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm-4-2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $6c2c53ad43edfb7d$export$8609f979d91d1c79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRightRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M4 14.5c0 .83.67 1.5 1.5 1.5h3.7q.15.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0zm10.85-2.35a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM10.25 11q-.38.46-.65 1H7.5a.5.5 0 0 1 0-1zm4.25-8A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.25-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-1.06-.13A2.5 2.5 0 0 1 5.5 3zm-2 5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm-9-2.5a1 1 0 0 1 1 1 1 1 0 1 1-1-1"
]);
const $6c2c53ad43edfb7d$export$19356066c0427e73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismissFilled', "1em", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $6c2c53ad43edfb7d$export$2e6733fe63396f1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismissRegular', "1em", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $6c2c53ad43edfb7d$export$7c669764acdc024e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShareFilled', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5zM7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5"
]);
const $6c2c53ad43edfb7d$export$175e0533c65c0640 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShareRegular', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5zm8 6.75a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5m.25-7.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $6c2c53ad43edfb7d$export$ce4bbe4c025205df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtractFilled', "1em", [
    "M3.2 4.52A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1a5.5 5.5 0 0 0-6.74 1.4H7.5a.5.5 0 0 0 0 1h2.1a5.5 5.5 0 0 0 0 5H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 1 0 .2-3.92M7.5 8a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM3 5.63a1 1 0 1 1 1 1.73 1 1 0 0 1-1-1.73M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
]);
const $6c2c53ad43edfb7d$export$6435901b28b75ed9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtractRegular', "1em", [
    "M3.2 4.52a2 2 0 0 1 1.06.13C4.53 4.25 5 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v3.7q.52.16 1 .4V5.5A2.5 2.5 0 0 0 14.5 3h-9a2.5 2.5 0 0 0-2.3 1.52M9.6 17q-.24-.48-.4-1H5.5A1.5 1.5 0 0 1 4 14.5V8.44a2 2 0 0 1-1 0v6.06A2.5 2.5 0 0 0 5.5 17zm0-5q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3 5.63a1 1 0 0 1 1 0 1 1 0 1 1-1 0M7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
]);
const $6c2c53ad43edfb7d$export$2a6f4ca732b7fa66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultipleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__a)",
            "d": "M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__b)",
            "fillOpacity": ".4",
            "d": "M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__c)",
            "fillOpacity": ".4",
            "d": "M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__d)",
            "d": "M16.52 9c.26 0 .48-.2.48-.46V8.5A6.5 6.5 0 0 0 10.46 2a.47.47 0 0 0-.46.48V8.5c0 .28.22.5.5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__e)",
            "d": "M16 11a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__f)",
            "d": "M13 13a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__g)",
            "d": "M10 15a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__a",
                "x1": "15.07",
                "x2": ".5",
                "y1": "17.93",
                "y2": "3.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6d37cd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__d",
                "x1": "17.29",
                "x2": "16.98",
                "y1": "6.84",
                "y2": ".87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e23cb4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__e",
                "x1": "17.74",
                "x2": "23.32",
                "y1": "7.24",
                "y2": "9.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__f",
                "x1": "13.5",
                "x2": "17.47",
                "y1": "12.5",
                "y2": "14.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__g",
                "x1": "10.5",
                "x2": "13.01",
                "y1": "14",
                "y2": "15.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -2.95312 0 11 16)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -2.65625 0 14 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$eedb2cc589c46e91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultipleFilled', "1em", [
    "M17 8.54c0 .26-.22.46-.48.46H10.5a.5.5 0 0 1-.5-.5V2.48c0-.26.2-.48.46-.48h.04A6.5 6.5 0 0 1 17 8.5zM9 4.5c0-.28-.22-.5-.5-.48A6 6 0 0 0 9 16v-1a2 2 0 0 1 3-1.73V13c0-1.1.9-2 2-2h.92l.06-.5a.47.47 0 0 0-.48-.5H10a1 1 0 0 1-1-1zm8 5.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $6c2c53ad43edfb7d$export$aa0c0c1e75d246b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultipleRegular', "1em", [
    "M16.52 9c.26 0 .48-.2.48-.46V8.5A6.5 6.5 0 0 0 10.5 2h-.04a.47.47 0 0 0-.46.48V8.5c0 .28.22.5.5.5zM11 3.02A5.5 5.5 0 0 1 15.98 8H11zM8 9V5.1A5 5 0 0 0 9 15v1a6 6 0 0 1-.5-11.98c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5l-.06.5H10a2 2 0 0 1-2-2m9 1a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $6c2c53ad43edfb7d$export$95bc3d9568920dc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPersonFilled', "1em", [
    "M10.5 2.5a.5.5 0 1 0-1 0V3H4.75A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15h1.82l-1.49 2.23a.5.5 0 0 0 .84.55L7.77 15h3.73a2.5 2.5 0 0 1 1.77-.99A2.99 2.99 0 0 1 15.5 9a3 3 0 0 1 2.5 1.34V5.75A2.75 2.75 0 0 0 15.25 3H10.5zM5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 4.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1m0-2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m12 3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $6c2c53ad43edfb7d$export$f5ecba2943b1aea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPersonRegular', "1em", [
    "M10 2c.28 0 .5.22.5.5V3h4.75A2.75 2.75 0 0 1 18 5.75v4.6q-.4-.6-1-.95V5.75c0-.65-.35-1.22-.88-1.52l-.02-.01a2 2 0 0 0-.85-.22H4.75C3.78 4 3 4.78 3 5.75v6.55c.03.94.8 1.7 1.75 1.7h8.51l.01.01a2.5 2.5 0 0 0-1.77.99H7.77l-1.85 2.78a.5.5 0 1 1-.84-.55L6.57 15H4.75A2.75 2.75 0 0 1 2 12.25v-6.5A2.75 2.75 0 0 1 4.75 3H9.5v-.5c0-.28.22-.5.5-.5M5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 9c0-.27.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 9m12.5 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $6c2c53ad43edfb7d$export$43b6e9b6c72310da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_20_color__a)",
            "d": "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_20_color__b)",
            "d": "M10.5 11H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 0-1zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_20_color__a",
                "x1": "2.57",
                "x2": "16.54",
                "y1": "5",
                "y2": "28.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_20_color__b",
                "x1": "7.52",
                "x2": "7.97",
                "y1": "8.07",
                "y2": "12.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$79012e74be3857e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatFilled', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m.5 9H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 0-1zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$bdec5c459b95e697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatRegular', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m.5 8a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h3.09m2-3a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09"
]);
const $6c2c53ad43edfb7d$export$be11aa059b0c1ae0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAddColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_20_color__a)",
            "d": "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_20_color__b)",
            "d": "M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_20_color__a",
                "x1": "2.57",
                "x2": "16.54",
                "y1": "5",
                "y2": "28.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_20_color__b",
                "x1": "6.7",
                "x2": "8.03",
                "y1": "6.14",
                "y2": "14.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$3204c9e165a43ea8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAddFilled', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
]);
const $6c2c53ad43edfb7d$export$10135b130845ff01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAddRegular', "1em", [
    "M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3zM18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 3 10"
]);
const $6c2c53ad43edfb7d$export$e5a8057512f1ac48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackFilled', "1em", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a8 8 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m4.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $6c2c53ad43edfb7d$export$7bccf671429d17e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackRegular', "1em", [
    "M10 2a8 8 0 0 1 8 8.25 6 6 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04q1.4.78 3.01.88.28.54.66 1a8 8 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m4.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $6c2c53ad43edfb7d$export$30d07419fe18b9bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDownFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 3.86.86A5.5 5.5 0 0 1 18 10.26zm-3.5 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 17 12.75v-.25a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75h-1.54l.9-.9a.5.5 0 0 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7l1.76 1.75a.5.5 0 0 0 .7-.7"
]);
const $6c2c53ad43edfb7d$export$51ea812c935ac100 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDownRegular', "1em", [
    "M10 2a8 8 0 0 1 8 8.25 6 6 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04q1.4.78 3.01.88.28.54.66 1a8 8 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m4.5 8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 17 12.75v-.25a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75h-1.54l.9-.9a.5.5 0 0 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7l1.76 1.75a.5.5 0 0 0 .7-.7"
]);
const $6c2c53ad43edfb7d$export$39d19f4d20cb1907 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBackFilled', "1em", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a8 8 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m9 12.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-1.14-1.15zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H17v.5a.5.5 0 0 0 1 0V15a1 1 0 0 0-1-1z"
]);
const $6c2c53ad43edfb7d$export$d5201d00e2561b42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBackRegular', "1em", [
    "M10 2a8 8 0 0 1 8 8.25 6 6 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04q1.4.78 3.01.88.28.54.66 1a8 8 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m9 12.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-1.14-1.15zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H17v.5a.5.5 0 0 0 1 0V15a1 1 0 0 0-1-1z"
]);
const $6c2c53ad43edfb7d$export$4ccbecd83ff4b0d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestionColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_20_color__a)",
            "d": "M11.5 5a6.5 6.5 0 0 1 5.67 9.67l.8 2.08a1 1 0 0 1-1.2 1.32l-2.5-.7q-1.27.61-2.77.63a6.5 6.5 0 1 1 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_20_color__b)",
            "d": "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_20_color__c)",
            "d": "M8.5 6.02c-.37.07-.76.3-1.07.85a.5.5 0 0 1-.86-.5A2.6 2.6 0 0 1 8.3 5.05c.65-.12 1.3.04 1.8.36.48.33.87.85.88 1.48.01.65-.39 1.24-1.12 1.67-.5.3-.7.5-.77.63-.07.11-.09.22-.09.44a.5.5 0 0 1-1 0c0-.27.01-.6.24-.97q.3-.48 1.11-.96c.54-.31.63-.61.63-.8s-.14-.45-.44-.65c-.29-.2-.67-.29-1.05-.22m.25 6.6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_20_color__b",
                "x1": "2",
                "x2": "15.11",
                "y1": "2",
                "y2": "15.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_20_color__c",
                "x1": "6.89",
                "x2": "8.96",
                "y1": "5.13",
                "y2": "12.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 7 -7 6 8.5 8.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$39f3f4b803c9a1b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestionFilled', "1em", [
    "M8.5 2a6.5 6.5 0 0 0-5.67 9.67l-.8 2.08a1 1 0 0 0 1.2 1.32l2.5-.7Q7 15 8.5 15a6.5 6.5 0 1 0 0-13m0 3.9c-.37.07-.76.3-1.07.85a.5.5 0 1 1-.86-.5A2.6 2.6 0 0 1 8.3 4.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 0 1-1 0c0-.27.01-.61.24-.97q.3-.5 1.11-.96c.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22m.25 6.6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-2.21 3.24a6.5 6.5 0 0 0 7.7 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.23.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09A5.5 5.5 0 0 1 8.3 16a8 8 0 0 1-1.76-.26"
]);
const $6c2c53ad43edfb7d$export$1225a7db8331c413 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestionRegular', "1em", [
    "M8.5 5.9c-.37.07-.76.3-1.07.85a.5.5 0 1 1-.86-.5A2.6 2.6 0 0 1 8.3 4.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 0 1-1 0c0-.27.01-.61.24-.97q.3-.5 1.11-.96c.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22m.25 6.6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.5 2a6.5 6.5 0 0 0-5.67 9.67l-.8 2.08a1 1 0 0 0 1.2 1.32l2.5-.7Q7 15 8.5 15a6.5 6.5 0 1 0 0-13M3 8.5a5.5 5.5 0 1 1 3 4.9l-.18-.09-2.86.8.97-2.53-.13-.21A5.5 5.5 0 0 1 3 8.5m8.46 9.5a6.5 6.5 0 0 1-4.92-2.26A8 8 0 0 0 8.3 16a5.5 5.5 0 0 0 5.66.4l.18-.09 2.86.8-.97-2.53.13-.21A5.5 5.5 0 0 0 16 8.39q-.01-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.27.61-2.78.63"
]);
const $6c2c53ad43edfb7d$export$42a6198692aa6806 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmarkFilled', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.64-.06-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m3.35 5.65a.5.5 0 0 0-.7 0L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $6c2c53ad43edfb7d$export$7b41496b168ff54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmarkRegular', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.64-.06-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m2.65 4.65a.5.5 0 1 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 11.29z"
]);
const $6c2c53ad43edfb7d$export$8ed7adbf29281f82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursorFilled', "1em", [
    "M8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2a6 6 0 0 0 4 .73V8.75c0-1.5 1.74-2.3 2.88-1.34l1.8 1.53A6 6 0 0 0 8 1m2 7.75v9a.75.75 0 0 0 1.37.42l1.98-2.95a.5.5 0 0 1 .42-.22h3.48c.7 0 1.02-.87.49-1.32l-6.5-5.5a.75.75 0 0 0-1.24.57"
]);
const $6c2c53ad43edfb7d$export$2469c75b4ae976ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursorRegular', "1em", [
    "M8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2a6 6 0 0 0 4 .73V11.9a5 5 0 0 1-3.67-.67.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39 5 5 0 1 1 9.15-1.32l.83.7A6 6 0 0 0 8 1m2 7.75v9a.75.75 0 0 0 1.37.42l1.98-2.95a.5.5 0 0 1 .42-.22h3.48c.7 0 1.02-.87.49-1.32l-6.5-5.5a.75.75 0 0 0-1.24.57"
]);
const $6c2c53ad43edfb7d$export$cee0b1d62945836c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismissFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M7.85 7.15 10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 1 1 .7-.7"
]);
const $6c2c53ad43edfb7d$export$ff688609f823c740 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismissRegular', "1em", [
    "M7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29zM18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 3 10"
]);
const $6c2c53ad43edfb7d$export$287137212e04a3d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmptyFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10"
]);
const $6c2c53ad43edfb7d$export$672b9d78ead36701 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmptyRegular', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3"
]);
const $6c2c53ad43edfb7d$export$a5ffd1e2454e7d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelpFilled', "1em", [
    "M2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 0 1 2 10m7.25-2.7c.15-.17.39-.3.75-.3s.6.13.75.3q.24.3.25.7c0 .32-.07.52-.17.69s-.23.3-.42.5l-.02.03c-.19.2-.42.44-.6.78q-.28.5-.29 1.3a.5.5 0 1 0 1 0c0-.4.08-.64.18-.84s.24-.35.43-.55l.04-.04c.17-.18.38-.4.55-.68q.29-.47.3-1.19a1.95 1.95 0 0 0-2-2 1.95 1.95 0 0 0-2 2 .5.5 0 0 0 1 0q0-.4.25-.7m1.45 6.21a.7.7 0 1 0-1.4 0 .7.7 0 0 0 1.4 0"
]);
const $6c2c53ad43edfb7d$export$41b78a84ef4e0731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelpRegular', "1em", [
    "M9.25 7.3Q9 7.6 9 8a.5.5 0 0 1-1 0 1.95 1.95 0 0 1 2-2 1.95 1.95 0 0 1 2 2q-.02.72-.3 1.19-.28.41-.55.68l-.04.04c-.19.2-.33.35-.43.55q-.17.28-.18.83a.5.5 0 1 1-1 0 2.7 2.7 0 0 1 .89-2.07l.02-.02c.19-.2.32-.34.42-.51S11 8.32 11 8q0-.4-.25-.7A1 1 0 0 0 10 7c-.36 0-.6.13-.75.3m.75 6.91a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4M2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 0 1 2 10m8-7a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05A7 7 0 1 0 10 3"
]);
const $6c2c53ad43edfb7d$export$1fd05ce65bc0534a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalfFilled', "1em", [
    "M3.35 5.56a.48.48 0 0 1 .73-.06c.18.18.2.46.06.66q-.2.3-.36.62a7 7 0 0 0 .11 6.64.5.5 0 0 1 .05.37L3.2 16.8l3.02-.75.1-.02q.13 0 .27.07a7 7 0 0 0 7.25-.25.5.5 0 0 1 .67.05c.22.22.2.57-.06.74a8.1 8.1 0 0 1-8.18.42L2.62 18a.5.5 0 0 1-.6-.61l.9-3.65a8 8 0 0 1 .13-7.69zm10.9 8.68a6 6 0 0 1-6.94 1.12l-.1-.05-.34-.18-.34-.18-1.97.49.4-1.6.1-.36-.37-.68-.06-.11a6 6 0 0 1 1.13-6.93zM17.35 11c.3 0 .54.27.48.56a8 8 0 0 1-1.19 2.88.48.48 0 0 1-.74.06.5.5 0 0 1-.05-.67q.71-1.09 1-2.4a.5.5 0 0 1 .5-.43m-1.45-5.5c.22-.22.57-.2.74.06q.88 1.3 1.2 2.88c.05.3-.18.56-.49.56a.5.5 0 0 1-.5-.43 7 7 0 0 0-1-2.4.5.5 0 0 1 .05-.67M8.44 2.16c.3-.06.56.17.56.48 0 .25-.18.46-.43.5q-1.31.29-2.4 1a.5.5 0 0 1-.67-.06.48.48 0 0 1 .06-.73 8 8 0 0 1 2.88-1.2m3.12 0q1.58.31 2.88 1.19c.25.17.27.52.06.73a.5.5 0 0 1-.67.06 7 7 0 0 0-2.4-1 .5.5 0 0 1-.43-.5c0-.3.27-.54.56-.48"
]);
const $6c2c53ad43edfb7d$export$b9d5ff9aa4312080 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalfRegular', "1em", [
    "M3.35 5.56a.48.48 0 0 1 .73-.06c.18.18.2.46.06.66a7 7 0 0 0-.25 7.26.5.5 0 0 1 .05.37L3.2 16.8l3.02-.75.1-.02q.14 0 .27.07a7 7 0 0 0 7.25-.25c.21-.14.5-.12.67.05.21.22.2.57-.06.74a8 8 0 0 1-8.18.42L2.62 18a.5.5 0 0 1-.6-.61l.9-3.65a8 8 0 0 1 .43-8.17M17.36 11c.3 0 .54.27.48.56a8 8 0 0 1-1.19 2.88.48.48 0 0 1-.74.06.5.5 0 0 1-.05-.67q.71-1.09 1-2.4a.5.5 0 0 1 .5-.43m-1.45-5.5c.22-.21.57-.2.74.06q.88 1.3 1.2 2.88c.05.3-.18.56-.49.56a.5.5 0 0 1-.5-.43 7 7 0 0 0-1-2.4.5.5 0 0 1 .05-.67M8.44 2.16c.3-.06.56.17.56.47 0 .26-.18.47-.43.52q-1.31.27-2.4 1a.5.5 0 0 1-.67-.07.48.48 0 0 1 .06-.73 8 8 0 0 1 2.88-1.2m3.12 0q1.58.32 2.88 1.19c.25.17.27.52.06.74a.5.5 0 0 1-.67.05 7 7 0 0 0-2.4-1 .5.5 0 0 1-.43-.5c0-.3.27-.54.56-.48"
]);
const $6c2c53ad43edfb7d$export$5d3a314a99ebdc7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistoryFilled', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10q0-.82.16-1.6a.5.5 0 0 1 .61-.4c.31.09.42.4.36.68l-.01.04a7 7 0 0 0 .77 4.7.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 4.26 6H6.5a.5.5 0 0 1 0 .99h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.2A8 8 0 0 1 10 2M4.34 8A6 6 0 0 0 4 9.98v.28l.03.31q.1 1.13.6 2.13l.42.78-.49 1.96 1.97-.5.78.42Q8.56 16 10 16A6 6 0 1 0 6.67 5a1.5 1.5 0 0 1-.17 3zM10 7.5V11h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0"
]);
const $6c2c53ad43edfb7d$export$692ea0eb491583cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistoryRegular', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10q0-.82.16-1.6a.5.5 0 0 1 .61-.4c.31.09.42.4.36.68l-.01.04a7 7 0 0 0 .77 4.7.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 4.26 6H6.5a.5.5 0 0 1 0 .99h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.2A8 8 0 0 1 10 2m0 5.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10z"
]);
const $6c2c53ad43edfb7d$export$83c090506398cbc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLockFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 4.61.8V14a2 2 0 0 1 1.5-1.94V12a3 3 0 0 1 5.5-1.67zm-4.5 2v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $6c2c53ad43edfb7d$export$a7467c0a9cd77444 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLockRegular', "1em", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 4.61.8v-1.01a7 7 0 0 1-4.42-.82l-.09-.04-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27 7 7 0 1 1 13.08-4.04q.62.36 1.02.95zm-4.5 2v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $6c2c53ad43edfb7d$export$d7b1629077b243f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMailFilled', "1em", [
    "M2 7a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A6 6 0 0 1 2 7m4.5-1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm2 2h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1",
    "m12.28 14.95-2.4-1.2q.65-.19 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 0 0-1-1h-1.67q.23-.48.38-1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.07q.5.07 1 .07v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.2l-4.28 2.15a.5.5 0 0 1-.44 0"
]);
const $6c2c53ad43edfb7d$export$fa338295df0bfdda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMailRegular', "1em", [
    "M6 6c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 6m.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2q1.34.8 3 .81A6 6 0 0 0 8 1M3 7a5 5 0 1 1 2.33 4.23.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A5 5 0 0 1 3 7m9.28 7.95-2.4-1.2q.65-.19 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 0 0-1-1h-1.67q.23-.48.38-1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.07q.5.07 1 .07v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.2l-4.28 2.15a.5.5 0 0 1-.44 0"
]);
const $6c2c53ad43edfb7d$export$8fcd9a28ca504886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMoreColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_20_color__a)",
            "d": "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_20_color__b)",
            "d": "M10.5 11H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 0-1zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_20_color__a",
                "x1": "2.57",
                "x2": "16.54",
                "y1": "5",
                "y2": "28.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_20_color__b",
                "x1": "7.52",
                "x2": "7.97",
                "y1": "8.07",
                "y2": "12.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$f0c302ff285536c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_20_color__a)",
            "d": "M11.5 5a6.5 6.5 0 0 1 5.67 9.67l.8 2.08a1 1 0 0 1-1.2 1.32l-2.5-.7q-1.27.61-2.77.63a6.5 6.5 0 1 1 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_20_color__b)",
            "d": "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_multiple_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 7 -7 6 8.5 8.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_multiple_20_color__b",
                "x1": "2",
                "x2": "15.11",
                "y1": "2",
                "y2": "15.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$bc229453c511a60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleFilled', "1em", [
    "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $6c2c53ad43edfb7d$export$95f6e7aff50d4b9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleRegular', "1em", [
    "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13m-5.5 6.5a5.5 5.5 0 1 1 3 4.9l-.18-.09-2.86.8.97-2.53-.13-.21a5.5 5.5 0 0 1-.8-2.87M11.5 18a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $6c2c53ad43edfb7d$export$e510e8fde10068e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmarkFilled', "1em", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17m9.31-1.85a.5.5 0 0 0-.7 0l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L7.4 10.6c.2.2.5.2.7 0l3.25-3.25a.5.5 0 0 0 0-.7M11.5 18a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $6c2c53ad43edfb7d$export$2306b0b6eed1c6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmarkRegular', "1em", [
    "M11.35 6.65c.2.2.2.5 0 .7L8.1 10.6a.5.5 0 0 1-.7 0L5.65 8.85a.5.5 0 1 1 .7-.7l1.4 1.4 2.9-2.9c.2-.2.5-.2.7 0M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.59 2.5.6a5.5 5.5 0 0 0 0-11M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $6c2c53ad43edfb7d$export$2523078a14dda3b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeartFilled', "1em", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17m3.51-2.01a1.9 1.9 0 0 0 0 2.68L8.3 11.9c.12.12.3.12.42 0l2.73-2.73a1.9 1.9 0 0 0-2.7-2.69l-.25.27-.27-.27a1.9 1.9 0 0 0-2.68 0M11.5 18a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $6c2c53ad43edfb7d$export$9ca382353cfef626 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeartRegular', "1em", [
    "M5.55 6.49a1.9 1.9 0 0 1 2.68 0l.27.27.26-.26a1.9 1.9 0 0 1 2.69 2.68l-2.73 2.73a.3.3 0 0 1-.42 0L5.56 9.17a1.9 1.9 0 0 1 0-2.68M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.59 2.5.6a5.5 5.5 0 0 0 0-11M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $6c2c53ad43edfb7d$export$a23481b7116e10b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinusFilled', "1em", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M5.5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm6 10a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $6c2c53ad43edfb7d$export$893a481003574754 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinusRegular', "1em", [
    "M5.5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-3.46.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.59 2.5.6a5.5 5.5 0 0 0 0-11M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $6c2c53ad43edfb7d$export$5e7174bd1303ee7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePersonFilled', "1em", [
    "M15.8 6.63a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7a6.5 6.5 0 0 1-7.7-1.63 8 8 0 0 0 1.75.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76M8.54 2a6.5 6.5 0 1 1-2.78 12.38l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08A6.5 6.5 0 0 1 8.53 2M6.75 9c-.69 0-1.25.56-1.25 1.25 0 1.25 1 2.25 3 2.25s3-1 3-2.25c0-.69-.56-1.25-1.25-1.25zM8.5 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
]);
const $6c2c53ad43edfb7d$export$5a5dbcd223375b6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePersonRegular', "1em", [
    "M15.8 6.63a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7a6.5 6.5 0 0 1-7.7-1.63 8 8 0 0 0 1.75.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76M8.54 2a6.5 6.5 0 1 1-2.78 12.38l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08A6.5 6.5 0 0 1 8.53 2m0 1a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.58 2.5.6a5.5 5.5 0 0 0 0-11m1.71 6c.69 0 1.25.56 1.25 1.25 0 1.25-1 2.25-3 2.25s-3-1-3-2.25C5.5 9.56 6.06 9 6.75 9zM8.5 4.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"
]);
const $6c2c53ad43edfb7d$export$85eddb1e8e6902cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOffFilled', "1em", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7L4.71 4 16 15.3l1.85 1.85a.5.5 0 0 1-.7.7L15.29 16a8 8 0 0 1-8.9 1.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3m6.97 6.98-.68-.68H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 .38-.32M8.29 9l-.97-.97a.5.5 0 0 0 .09.96L7.5 9z",
    "M12.5 9h-1.38l5.5 5.5A8 8 0 0 0 5.5 3.39L10.11 8h2.47a.5.5 0 0 1 0 1z"
]);
const $6c2c53ad43edfb7d$export$3ac2a88b1332b40b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOffRegular', "1em", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7L4.71 4l.7.7 9.88 9.88.7.71 1.86 1.86a.5.5 0 0 1-.7.7L15.29 16a8 8 0 0 1-8.9 1.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3m10.58 10.6-3.61-3.62a.5.5 0 0 1-.38.31l-.09.01h-3a.5.5 0 0 1-.09-1h2.89l-2-2h-.8a.5.5 0 0 1-.18-.97L4.71 5.42a7 7 0 0 0-.82 8 .5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04a7 7 0 0 0 8-.82",
    "m16.62 14.5-.72-.73A7 7 0 0 0 6.23 4.1l-.73-.72A8 8 0 0 1 16.61 14.5",
    "M12.5 9h-1.38l-1-1h2.38a.5.5 0 0 1 .09 1z"
]);
const $6c2c53ad43edfb7d$export$80ab6693d4f0d33f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatPersonFilled', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.64-.06-.12A8 8 0 0 1 10 2m-2.5 8c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.62.74.59 1.74.88 2.79.88s2.05-.29 2.79-.88S14 12.62 14 11.5c0-.83-.67-1.5-1.5-1.5zM10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $6c2c53ad43edfb7d$export$a1096e0adb2a3b97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatPersonRegular', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.65-.06-.11A8 8 0 0 1 10 2m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m2.5 7c.83 0 1.5.67 1.5 1.5 0 1.12-.46 2.01-1.21 2.62-.74.59-1.74.88-2.79.88a4.4 4.4 0 0 1-2.79-.88A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5zM10 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $6c2c53ad43edfb7d$export$bcedcbe4ee9bcc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettingsFilled', "1em", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a8 8 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m2.07 9.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $6c2c53ad43edfb7d$export$7056afd1ac452641 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettingsRegular', "1em", [
    "M10 3a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05q1.36.77 3.01.88.28.54.66 1a8 8 0 0 1-3.99-.92L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 1 1 18 10.26q-.46-.39-1-.67A7 7 0 0 0 10 3m2.07 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $6c2c53ad43edfb7d$export$1d54c7680ed99f46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07A8 8 0 0 0 2 10v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 11.37-5.16z"
]);
const $6c2c53ad43edfb7d$export$69b6ae10823425cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22a7 7 0 0 1-10.2 4.33l-.08-.04-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07A8 8 0 0 0 2 10v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 11.37-5.16z"
]);
const $6c2c53ad43edfb7d$export$f2aea9651c5f8746 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideoFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M6 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm7.15-.15a.5.5 0 0 1 .85.36v3.58a.5.5 0 0 1-.85.36L12 11V9z"
]);
const $6c2c53ad43edfb7d$export$ee9c48342b667619 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideoRegular', "1em", [
    "M6 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm6 1 1.15-1.15a.5.5 0 0 1 .85.36v3.58a.5.5 0 0 1-.85.36L12 11zm-2-7a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3"
]);
const $6c2c53ad43edfb7d$export$c8786f4d649d30a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarningFilled', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 3.5a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 1 0V6a.5.5 0 0 0-.5-.5m0 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $6c2c53ad43edfb7d$export$9fa09f47f3128de9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarningRegular', "1em", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m0 2.5c.28 0 .5.22.5.5v5.5a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5m0 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $6c2c53ad43edfb7d$export$8f895311c845f8ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckFilled', "1em", [
    "M15.88 5H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7.12l-4.44 4.44a1.5 1.5 0 0 1-2.12-2.12zM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5m13.85-5.65a.5.5 0 0 0-.7-.7l-5 5a.5.5 0 0 0 .7.7z"
]);
const $6c2c53ad43edfb7d$export$b357fd0806766347 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckRegular', "1em", [
    "M18 7.12V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h11.88l-1 1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.12zM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5m13.85-6.35c.2.2.2.5 0 .7l-6 6a.5.5 0 0 1-.7-.7l6-6c.2-.2.5-.2.7 0"
]);
const $6c2c53ad43edfb7d$export$616a21115f1208a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox1Filled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8c.77 0 1.47-.29 2-.76v-.83a1.5 1.5 0 0 1-1.4-2.61l2-1.5q.19-.14.4-.21V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7m3.87 4.2a.5.5 0 0 1 .28.45v5a.5.5 0 0 1-1 0v-4l-1.2.9a.5.5 0 0 1-.6-.8l2-1.5a.5.5 0 0 1 .52-.05"
]);
const $6c2c53ad43edfb7d$export$a1f176c2738427c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox1Regular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8c.77 0 1.47-.29 2-.76v-.83q-.33.12-.67.08A2 2 0 0 1 14 16H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.75l.6-.45q.19-.14.4-.21V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zm3.87 4.2a.5.5 0 0 1 .28.45v5a.5.5 0 0 1-1 0v-4l-1.2.9a.5.5 0 0 1-.6-.8l2-1.5a.5.5 0 0 1 .52-.05"
]);
const $6c2c53ad43edfb7d$export$82ed4b28ecb67608 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_20_color__a)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_20_color__b)",
            "d": "M13.85 7.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_20_color__a",
                "x1": "3.5",
                "x2": "13.16",
                "y1": "5.63",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_20_color__b",
                "x1": "7.54",
                "x2": "11.07",
                "y1": "7.46",
                "y2": "18.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$a4a8158151bc9b04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox2Filled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h7.05q.08-.45.4-1 .34-.6 1.04-1.23a1.5 1.5 0 0 1-1.12-2.48A3.5 3.5 0 0 1 15.82 11q.63-.02 1.18.17V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29"
]);
const $6c2c53ad43edfb7d$export$5e8fe673925e654d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox2Regular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h7.05q.08-.45.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5q.53 0 1 .17V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zM15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29"
]);
const $6c2c53ad43edfb7d$export$11412eae9ceb6cb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRightFilled', "1em", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2A5.5 5.5 0 0 1 16 9.2V5a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $6c2c53ad43edfb7d$export$36f050a80e9689da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRightRegular', "1em", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4.02q.51.05 1 .19V5a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0zM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $6c2c53ad43edfb7d$export$b256ebcb503b38df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7"
]);
const $6c2c53ad43edfb7d$export$9ace334004f6d76e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm9.85 1.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
]);
const $6c2c53ad43edfb7d$export$2b908c617f06497f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSyncFilled', "1em", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2A5.5 5.5 0 0 1 16 9.2V5a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $6c2c53ad43edfb7d$export$d6fa47251adb097d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSyncRegular', "1em", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4.02q.51.05 1 .19V5a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0zM10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $6c2c53ad43edfb7d$export$4bb1e2d8bef529eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminateFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4.5 6c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H6A1.5 1.5 0 0 1 4.5 14zM7 6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
]);
const $6c2c53ad43edfb7d$export$f6f016513a79b47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminateRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2.5-1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $6c2c53ad43edfb7d$export$5ee9dcb93f168fe5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPersonColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__a)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__b)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__c)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__d)",
            "d": "M13.85 7.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__e)",
            "d": "M19 16.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__f)",
            "d": "M19 16.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__g)",
            "d": "M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__a",
                "x1": "3.5",
                "x2": "13.16",
                "y1": "5.63",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__d",
                "x1": "7.54",
                "x2": "11.07",
                "y1": "7.46",
                "y2": "18.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__e",
                "x1": "13.66",
                "x2": "15.1",
                "y1": "15.53",
                "y2": "19.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__f",
                "x1": "15.5",
                "x2": "17.53",
                "y1": "14.52",
                "y2": "21.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__g",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "10.53",
                "y2": "13.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6.6292 0 0 4.5921 15.53 16.25)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 1.32 14.13)scale(3.24526)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$44e51f3ff67ca37c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPersonFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.04l-.04-.5c0-1.3 1-2.38 2.27-2.49A2.99 2.99 0 0 1 15.5 9q.83.01 1.5.4V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $6c2c53ad43edfb7d$export$11cab7ecfc853d09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPersonRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.04a3 3 0 0 1 .01-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.04q.54.1 1 .36V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $6c2c53ad43edfb7d$export$e37df7de61ed97ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUncheckedFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5z"
]);
const $6c2c53ad43edfb7d$export$c8983c4361ef831e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUncheckedRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $6c2c53ad43edfb7d$export$2a76b18f7a4b113c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarningFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.27l3.44-6.9a2 2 0 0 1 3.58 0l.71 1.42V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7m-.25 2.7-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $6c2c53ad43edfb7d$export$7fae73d98a7cfa8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarningRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.27l.5-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.67q.16.19.3.44l.7 1.41V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zm-.25 2.7-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $6c2c53ad43edfb7d$export$931168ba4a0d2b6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkFilled', "1em", [
    "M7.03 13.9 3.56 10a.75.75 0 0 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06z"
]);
const $6c2c53ad43edfb7d$export$6bbb957e55aacfb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkRegular', "1em", [
    "M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27z"
]);
const $6c2c53ad43edfb7d$export$13cea058a894eb7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_20_color__a)",
            "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_20_color__b)",
            "fillRule": "evenodd",
            "d": "M13.35 7.65c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 11.29l3.65-3.64c.2-.2.5-.2.7 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_20_color__a",
                "x1": "2.57",
                "x2": "13.61",
                "y1": "5",
                "y2": "16.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_20_color__b",
                "x1": "7.81",
                "x2": "8.95",
                "y1": "8.01",
                "y2": "13.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$f5ae24d05067c167 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleFilled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63"
]);
const $6c2c53ad43edfb7d$export$4b1b95a3bd9a5ecd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleRegular', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14m3.36 4.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0"
]);
const $6c2c53ad43edfb7d$export$9b43b2139fe78137 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHintFilled', "1em", [
    "M11.06 16.41a.75.75 0 0 1 .24 1.48c-.85.14-1.76.14-2.6 0a.75.75 0 0 1 .24-1.48c.69.12 1.43.12 2.12 0m-7.4-2.8a.75.75 0 0 1 1.05.18q.64.86 1.5 1.5a.75.75 0 1 1-.87 1.21 8 8 0 0 1-1.84-1.84.75.75 0 0 1 .17-1.05m11.62.18a.75.75 0 1 1 1.22.87 8 8 0 0 1-1.84 1.84.75.75 0 0 1-.88-1.22 7 7 0 0 0 1.5-1.5m-2.81-6.32a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1-1.11l.06.05L9 10.94zM2.1 8.7a.75.75 0 0 1 1.48.24 7 7 0 0 0 0 2.12.75.75 0 1 1-1.48.24 8 8 0 0 1 0-2.6m14.93-.62c.41-.07.8.2.86.62a8 8 0 0 1 0 2.6.75.75 0 0 1-1.48-.24c.11-.69.11-1.43 0-2.12-.06-.4.21-.8.62-.86M5.33 3.5a.75.75 0 0 1 .88 1.21q-.86.64-1.5 1.5a.75.75 0 1 1-1.21-.87A8 8 0 0 1 5.34 3.5m8.28.17a.75.75 0 0 1 1.05-.17q1.06.76 1.84 1.84a.75.75 0 0 1-1.22.87 7 7 0 0 0-1.5-1.5.75.75 0 0 1-.17-1.04M8.7 2.1a8 8 0 0 1 2.6 0 .75.75 0 0 1-.24 1.48 7 7 0 0 0-2.12 0A.75.75 0 1 1 8.7 2.1"
]);
const $6c2c53ad43edfb7d$export$f0dc097f1dc17d5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHintRegular', "1em", [
    "M11.37 16.87a.5.5 0 0 1 .2.98 8 8 0 0 1-3.13 0 .5.5 0 1 1 .2-.98 7 7 0 0 0 2.73 0m-7.88-3.12a.5.5 0 0 1 .69.14 7 7 0 0 0 1.93 1.93.5.5 0 0 1-.55.83 8 8 0 0 1-2.21-2.2.5.5 0 0 1 .14-.7m12.33.14a.5.5 0 0 1 .83.55 8 8 0 0 1-2.2 2.21.5.5 0 0 1-.56-.83 7 7 0 0 0 1.93-1.93m-3.17-6.24a.5.5 0 1 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .63-.77l.07.07L9 11.29zm-9.9.4a.5.5 0 0 1 .39.58 7 7 0 0 0 0 2.74.5.5 0 0 1-.99.19 8 8 0 0 1 0-3.12.5.5 0 0 1 .6-.4m14.51 0a.5.5 0 0 1 .59.39 8 8 0 0 1 0 3.12.5.5 0 0 1-.98-.2 7 7 0 0 0 0-2.73.5.5 0 0 1 .4-.58m-11.7-4.7a.5.5 0 0 1 .55.83A7 7 0 0 0 4.18 6.1a.5.5 0 0 1-.83-.56 8 8 0 0 1 2.2-2.2m8.2.13a.5.5 0 0 1 .69-.13 8 8 0 0 1 2.2 2.2.5.5 0 0 1-.83.56 7 7 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7M8.43 2.15a8 8 0 0 1 3.12 0 .5.5 0 0 1-.2.98 7 7 0 0 0-2.72 0 .5.5 0 0 1-.2-.98"
]);
const $6c2c53ad43edfb7d$export$f23df656533381c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkleFilled', "1em", [
    "M10 2q.6 0 1.17.08l-.22.07A1.4 1.4 0 0 0 10 3.5q0 .45.26.82t.71.53l1.06.35q.22.06.47.29.16.14.3.47l.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.12.05.21.14.11.1.15.22l.26.8q.15.38.48.62a1.3 1.3 0 0 0 1 .2A8 8 0 1 1 10 2m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $6c2c53ad43edfb7d$export$659df0e07bb4e632 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkleRegular', "1em", [
    "M10 2q.6 0 1.17.08l-.22.07a1.4 1.4 0 0 0-.86.85H10a7 7 0 1 0 6.77 8.78 1.3 1.3 0 0 0 .98.2A8 8 0 1 1 10 2m2.65 5.65a.5.5 0 0 1 .77.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3zM17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $6c2c53ad43edfb7d$export$87abfb6ed24cc7f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquareFilled', "1em", [
    "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12m2.85-7.15-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64a.5.5 0 1 1 .7.7M8 13.93V16a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3h-2.07q-.07.52-.22 1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2.29q-.48.15-1 .22m8.35-1.58a.5.5 0 0 0-.7-.7L13 14.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $6c2c53ad43edfb7d$export$1071eff26c407754 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquareRegular', "1em", [
    "M12 7A5 5 0 1 0 2 7a5 5 0 0 0 10 0m1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0m-5 9v-2.07q.52-.07 1-.22V16c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-2.29q.15-.48.22-1H16a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3M9.85 5.15c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64c.2-.2.5-.2.7 0m3.5 10.2 3-3a.5.5 0 0 0-.7-.7L13 14.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0"
]);
const $6c2c53ad43edfb7d$export$290418f78ab5e2d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarningFilled', "1em", [
    "M10 2a8 8 0 0 1 7.74 10.01l-.45-.9a2 2 0 0 0-3.58 0L10.27 18H10a8 8 0 1 1 0-16m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63m1.24 3.9a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 19 20h-7a1 1 0 0 1-.9-1.45zM16 13.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $6c2c53ad43edfb7d$export$5ffb7bbb8e2a2e1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarningRegular', "1em", [
    "M10 2a8 8 0 0 1 7.74 10.01l-.45-.9q-.14-.27-.32-.47.03-.31.03-.64a7 7 0 1 0-6.2 6.96L10.26 18H10a8 8 0 1 1 0-16m3.36 5.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0m1.24 3.9a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 19 20h-7a1 1 0 0 1-.9-1.45zM16 13.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $6c2c53ad43edfb7d$export$9991af15fa65f75b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLockFilled', "1em", [
    "M10 2a8 8 0 0 1 8 8.33A3 3 0 0 0 12.5 12v.06A2 2 0 0 0 11 14v3.94q-.5.06-1 .06a8 8 0 1 1 0-16m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63M15.5 10a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5v-1c0-1.1.9-2 2-2m-.65 6.37a.75.75 0 1 0 1.3-.74.75.75 0 0 0-1.3.74M15.5 11a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1"
]);
const $6c2c53ad43edfb7d$export$8ec105cea3c9cc68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLockRegular', "1em", [
    "M10 2a8 8 0 0 1 8 8.33 3 3 0 0 0-1.03-.94A7 7 0 1 0 11 16.93v1q-.5.07-1 .07a8 8 0 1 1 0-16m6.97 8.64A2 2 0 0 1 17.5 12v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5v-1a2 2 0 0 1 3.47-1.36M14.5 13h2v-1a1 1 0 1 0-2 0zm.35 3.37a.75.75 0 1 0 1.3-.74.75.75 0 0 0-1.3.74m-1.5-8.72c.18.17.2.44.07.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0"
]);
const $6c2c53ad43edfb7d$export$c703b5f58b10d565 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkNoteFilled', "1em", [
    "M6.03 12.9 2.56 9a.75.75 0 1 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06zM11 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$d6407fda33dd787c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkNoteRegular', "1em", [
    "M1.67 9.13a.5.5 0 0 1 .7.04l3.65 4.1L16.15 3.15a.5.5 0 1 1 .7.7l-10.5 10.5a.5.5 0 0 1-.72-.02l-4-4.5a.5.5 0 0 1 .04-.7M11 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$235828f8a6ccdee4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquareFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm7.35 5.35-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 11.29l3.65-3.64a.5.5 0 0 1 .7.7"
]);
const $6c2c53ad43edfb7d$export$e8d82cfa3a0d2365 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquareRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm9.35 2.35a.5.5 0 0 0-.7-.7L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0z"
]);
const $6c2c53ad43edfb7d$export$e230804fb2aec204 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburstFilled', "1em", [
    "M11.54 1.9c1.21-.48 2.58.09 3.1 1.28l.43.98q.24.53.77.78l.98.42a2.4 2.4 0 0 1 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.4.99a2.4 2.4 0 0 1-1.3 3.1l-.97.43a1.5 1.5 0 0 0-.77.77l-.43.98a2.4 2.4 0 0 1-3.1 1.28l-.99-.39a1.5 1.5 0 0 0-1.1 0l-.99.4a2.4 2.4 0 0 1-3.1-1.3l-.42-.97a1.5 1.5 0 0 0-.78-.77l-.98-.43a2.4 2.4 0 0 1-1.28-3.1l.39-.99a1.5 1.5 0 0 0 0-1.1l-.4-.99a2.4 2.4 0 0 1 1.3-3.1l.97-.42q.53-.25.78-.78l.42-.98a2.4 2.4 0 0 1 3.1-1.28l1 .39q.54.21 1.1 0zm1.81 5.75a.5.5 0 0 0-.7 0L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $6c2c53ad43edfb7d$export$59166bfb5f0784ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburstRegular', "1em", [
    "M11.54 1.9c1.21-.48 2.58.09 3.1 1.28l.43.98q.24.53.77.77l.98.43a2.4 2.4 0 0 1 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.4.99a2.4 2.4 0 0 1-1.3 3.1l-.97.43a1.5 1.5 0 0 0-.77.77l-.43.98a2.4 2.4 0 0 1-3.1 1.28l-.99-.39a1.5 1.5 0 0 0-1.1 0l-.99.4a2.4 2.4 0 0 1-3.1-1.3l-.42-.97a1.5 1.5 0 0 0-.78-.77l-.98-.43a2.4 2.4 0 0 1-1.28-3.1l.39-.99a1.5 1.5 0 0 0 0-1.1l-.4-.99a2.4 2.4 0 0 1 1.3-3.1l.97-.43q.53-.24.78-.77l.42-.98a2.4 2.4 0 0 1 3.1-1.28l1 .39q.54.21 1.1 0zm2.19 1.68c-.3-.7-1.11-1.03-1.82-.75l-1 .39a2.5 2.5 0 0 1-1.82 0l-1-.4a1.4 1.4 0 0 0-1.81.76l-.43.98a2.5 2.5 0 0 1-1.3 1.3l-.97.42c-.7.3-1.03 1.1-.75 1.82l.39.99a2.5 2.5 0 0 1 0 1.83l-.4.99c-.27.7.06 1.51.76 1.81l.98.43a2.5 2.5 0 0 1 1.3 1.3l.42.97c.3.7 1.1 1.03 1.82.75l.99-.39a2.5 2.5 0 0 1 1.83 0l.99.4c.7.27 1.51-.06 1.82-.76l.42-.98a2.5 2.5 0 0 1 1.3-1.3l.97-.42c.7-.3 1.03-1.1.75-1.81l-.39-1a2.5 2.5 0 0 1 0-1.82l.4-1a1.4 1.4 0 0 0-.76-1.81l-.98-.43a2.5 2.5 0 0 1-1.29-1.3zm-1.08 4.07a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 11.29z"
]);
const $6c2c53ad43edfb7d$export$6c7d180cccac334d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircleFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0M7.5 13h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $6c2c53ad43edfb7d$export$8c2cd151ac212c29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircleRegular', "1em", [
    "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0M7 13.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5"
]);
const $6c2c53ad43edfb7d$export$8bbf8e287c08718f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChessFilled', "1em", [
    "M10.5 2a.5.5 0 0 0-.5.5v2.6a3 3 0 0 0 2.2 2.89 16 16 0 0 1-1.67 6.05q.28.31.5.49c.51.43.97 1.14.97 2.02q-.02.82-.48 1.45H17c.83 0 1.5-.67 1.5-1.5v-.3q-.02-.54-.3-.94A15 15 0 0 1 15.8 8 3 3 0 0 0 18 5.1V2.5a.5.5 0 0 0-.5-.5h-.75a.75.75 0 0 0-.75.75v.75a.5.5 0 0 1-1 0v-.75a.75.75 0 0 0-.75-.75h-.5a.75.75 0 0 0-.75.75v.75a.5.5 0 0 1-1 0v-.75a.75.75 0 0 0-.75-.75zm-4 3a3 3 0 0 0-2.24 5H4a1 1 0 1 0 0 2h.52a5.8 5.8 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.8 5.8 0 0 1 8.48 12H9a1 1 0 1 0 0-2h-.26A3 3 0 0 0 6.5 5"
]);
const $6c2c53ad43edfb7d$export$177f094ab5c43169 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChessRegular', "1em", [
    "M10 3a1 1 0 0 1 1-1h.5q.6.02 1 .38a1.5 1.5 0 0 1 1-.38h1q.58.02 1 .38a1.5 1.5 0 0 1 1-.38h.5a1 1 0 0 1 1 1v2.5a2.5 2.5 0 0 1-1.95 2.44c.28 4.04 1.7 6.58 2.19 7.35q.25.38.26.88v.33c0 .83-.67 1.5-1.5 1.5h-5.48q.33-.45.44-1H17a.5.5 0 0 0 .5-.5v-.33q0-.17-.1-.34c-.58-.9-2.16-3.78-2.38-8.3a.5.5 0 0 1 .5-.53A1.5 1.5 0 0 0 17 5.5V3h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5H11v2.5c0 .82.66 1.49 1.48 1.5a.5.5 0 0 1 .5.52 18 18 0 0 1-1.76 7.2l-.2-.2a4 4 0 0 1-.55-.55 17 17 0 0 0 1.48-6.03A2.5 2.5 0 0 1 10 5.5zM4.5 8a2 2 0 1 1 3.6 1.2.5.5 0 0 0 .4.8H9a.5.5 0 0 1 0 1H7.9a.5.5 0 0 0-.5.56 6.9 6.9 0 0 0 2.34 4.5q.26.24.26.49c0 .25-.2.45-.45.45h-6.1a.45.45 0 0 1-.45-.45q0-.25.26-.49a6.9 6.9 0 0 0 2.34-4.5.5.5 0 0 0-.5-.56H4a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .4-.8q-.39-.51-.4-1.2m2-3a3 3 0 0 0-2.82 4.03A1.5 1.5 0 0 0 4 12h.52a5.8 5.8 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.8 5.8 0 0 1 8.48 12H9a1.5 1.5 0 0 0 .32-2.97A3 3 0 0 0 6.5 5"
]);
const $6c2c53ad43edfb7d$export$32de864ce4fded60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDownFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m4.85-1.85a.5.5 0 1 0-.7.7l3.5 3.5a.5.5 0 0 0 .7 0l3.5-3.5a.5.5 0 0 0-.7-.7L10 11.29z"
]);
const $6c2c53ad43edfb7d$export$49d5db464f17ada = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDownRegular', "1em", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16M6.85 8.15a.5.5 0 1 0-.7.7l3.5 3.5a.5.5 0 0 0 .7 0l3.5-3.5a.5.5 0 0 0-.7-.7L10 11.29z"
]);
const $6c2c53ad43edfb7d$export$2ad5e20413873faa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeftFilled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m1.85 4.85a.5.5 0 0 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L8.71 10z"
]);
const $6c2c53ad43edfb7d$export$658869b7dba5a369 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeftRegular', "1em", [
    "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14m8 7a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-6.15-3.15a.5.5 0 0 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L8.71 10z"
]);
const $6c2c53ad43edfb7d$export$74a854cdc48eaede = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRightFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m-1.85-4.85a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 1 0-.7.7L11.29 10z"
]);
const $6c2c53ad43edfb7d$export$f8f78fd5160abb4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRightRegular', "1em", [
    "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14m-8-7a8 8 0 1 0 16 0 8 8 0 0 0-16 0m6.15 3.15a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 1 0-.7.7L11.29 10z"
]);
const $6c2c53ad43edfb7d$export$9b1b82d6815e0cb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUpFilled', "1em", [
    "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m4.85 1.85a.5.5 0 0 1-.7-.7l3.5-3.5a.5.5 0 0 1 .7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 8.71z"
]);
const $6c2c53ad43edfb7d$export$c07fa46d833d72bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUpRegular', "1em", [
    "M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0m7 8a8 8 0 1 1 0-16 8 8 0 0 1 0 16m-3.15-6.15a.5.5 0 0 1-.7-.7l3.5-3.5a.5.5 0 0 1 .7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 8.71z"
]);
const $6c2c53ad43edfb7d$export$fcf681fa54d3a22a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDownFilled', "1em", [
    "M14.72 9.97a.75.75 0 1 1 1.06 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0l-5.25-5.25a.75.75 0 1 1 1.06-1.06L10 14.69zm0-5.5a.75.75 0 1 1 1.06 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0L4.22 5.53a.75.75 0 1 1 1.06-1.06L10 9.19z"
]);
const $6c2c53ad43edfb7d$export$f0edd6597e73c0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDownRegular', "1em", [
    "M15.15 9.65a.5.5 0 1 1 .7.7l-5.5 5.5a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L10 14.79zm0-5a.5.5 0 1 1 .7.7l-5.5 5.5a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L10 9.79z"
]);
const $6c2c53ad43edfb7d$export$fd4b6a636bfb44dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeftFilled', "1em", [
    "M8.97 4.22a.75.75 0 1 1 1.06 1.06L5.31 10l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06zm5.5 0a.75.75 0 1 1 1.06 1.06L10.81 10l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06z"
]);
const $6c2c53ad43edfb7d$export$85f385a0068ecc6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeftRegular', "1em", [
    "M9.65 4.15a.5.5 0 1 1 .7.7L5.21 10l5.14 5.15a.5.5 0 1 1-.7.7l-5.5-5.5a.5.5 0 0 1 0-.7zm5 0a.5.5 0 1 1 .7.7L10.21 10l5.14 5.15a.5.5 0 1 1-.7.7l-5.5-5.5a.5.5 0 0 1 0-.7z"
]);
const $6c2c53ad43edfb7d$export$8af51a71d28570c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRightFilled', "1em", [
    "M4.47 4.22c.3-.3.77-.3 1.06 0l5.25 5.25c.3.3.3.77 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L9.19 10 4.47 5.28a.75.75 0 0 1 0-1.06m5.5 0c.3-.3.77-.3 1.06 0l5.25 5.25c.3.3.3.77 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L14.69 10 9.97 5.28a.75.75 0 0 1 0-1.06"
]);
const $6c2c53ad43edfb7d$export$f75c39a03ac04691 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRightRegular', "1em", [
    "M4.65 4.15c.2-.2.5-.2.7 0l5.5 5.5a.5.5 0 0 1 0 .7l-5.5 5.5a.5.5 0 1 1-.7-.7L9.79 10 4.65 4.85a.5.5 0 0 1 0-.7m5 0c.2-.2.5-.2.7 0l5.5 5.5a.5.5 0 0 1 0 .7l-5.5 5.5a.5.5 0 1 1-.7-.7L14.79 10 9.65 4.85a.5.5 0 0 1 0-.7"
]);
const $6c2c53ad43edfb7d$export$56efe71c1eff81d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUpFilled', "1em", [
    "M9.47 9.22c.3-.3.77-.3 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06L10 10.81l-4.72 4.72a.75.75 0 0 1-1.06-1.06zm0-5.5c.3-.3.77-.3 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06L10 5.31l-4.72 4.72a.75.75 0 0 1-1.06-1.06z"
]);
const $6c2c53ad43edfb7d$export$e27c1962d22d015b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUpRegular', "1em", [
    "M10 9a.5.5 0 0 1 .35.15l5.5 5.5a.5.5 0 0 1-.7.7L10 10.21l-5.15 5.14a.5.5 0 1 1-.7-.7l5.5-5.5A.5.5 0 0 1 10 9m0-5a.5.5 0 0 1 .35.15l5.5 5.5a.5.5 0 0 1-.7.7L10 5.21l-5.15 5.14a.5.5 0 1 1-.7-.7l5.5-5.5A.5.5 0 0 1 10 4"
]);
const $6c2c53ad43edfb7d$export$d66f8550eeda341a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownFilled', "1em", [
    "M15.8 7.73c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 0 1-1.04 0l-5.25-5a.75.75 0 0 1 1.04-1.08L10 12.2l4.73-4.5a.75.75 0 0 1 1.06.02"
]);
const $6c2c53ad43edfb7d$export$670ea3392d1ca9e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownRegular', "1em", [
    "M15.85 7.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 0 1-.78 0L4.15 8.35a.5.5 0 1 1 .7-.7L10 12.8l5.15-5.16c.2-.2.5-.2.7 0"
]);
const $6c2c53ad43edfb7d$export$c4a9a95d98046b2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUpFilled', "1em", [
    "M6.28 2.97a.75.75 0 0 0-1.06 1.06l4.25 4.25c.3.3.77.3 1.06 0l4.25-4.25a.75.75 0 0 0-1.06-1.06L10 6.69zm8.5 13-4.25-4.25a.75.75 0 0 0-1.06 0l-4.25 4.25a.75.75 0 1 0 1.06 1.06L10 13.31l3.72 3.72a.75.75 0 1 0 1.06-1.06"
]);
const $6c2c53ad43edfb7d$export$3ff4b6ea23279f2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUpRegular', "1em", [
    "M5.85 3.15a.5.5 0 1 0-.7.7l4.5 4.5c.2.2.5.2.7 0l4.5-4.5a.5.5 0 0 0-.7-.7L10 7.29zm9 13-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 .7.7L10 12.71l4.15 4.14a.5.5 0 0 0 .7-.7"
]);
const $6c2c53ad43edfb7d$export$895e27ed574dc7b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeftFilled', "1em", [
    "M12.27 15.8a.75.75 0 0 1-1.06-.03l-5-5.25a.75.75 0 0 1 0-1.04l5-5.25a.75.75 0 1 1 1.08 1.04L7.8 10l4.5 4.73c.29.3.28.78-.02 1.06"
]);
const $6c2c53ad43edfb7d$export$628bf69ef29e7c68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeftRegular', "1em", [
    "M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7"
]);
const $6c2c53ad43edfb7d$export$dd4ae601b5a528d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRightFilled', "1em", [
    "M7.73 4.2a.75.75 0 0 1 1.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 1 1-1.08-1.04L12.2 10l-4.5-4.73a.75.75 0 0 1 .02-1.06"
]);
const $6c2c53ad43edfb7d$export$8d3108d21b9dedd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRightRegular', "1em", [
    "M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.47a.5.5 0 0 1-.7-.71L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7"
]);
const $6c2c53ad43edfb7d$export$ee2d19e44778efdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpFilled', "1em", [
    "M4.2 12.27a.75.75 0 0 1 .03-1.06l5.25-5a.75.75 0 0 1 1.04 0l5.25 5a.75.75 0 0 1-1.04 1.08L10 7.8l-4.73 4.5a.75.75 0 0 1-1.06-.02"
]);
const $6c2c53ad43edfb7d$export$3f38e62209a2e0af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpRegular', "1em", [
    "M4.15 12.35a.5.5 0 0 1 0-.7L9.6 6.16a.55.55 0 0 1 .78 0l5.47 5.49a.5.5 0 0 1-.71.7L10 7.2l-5.15 5.16a.5.5 0 0 1-.7 0"
]);
const $6c2c53ad43edfb7d$export$d63f4452634583c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDownFilled', "1em", [
    "M10.53 2.72a.75.75 0 0 0-1.06 0L5.22 6.97a.75.75 0 0 0 1.06 1.06L10 4.31l3.72 3.72a.75.75 0 1 0 1.06-1.06zm4.25 10.31-4.25 4.25c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 1 1 1.06-1.06L10 15.69l3.72-3.72a.75.75 0 1 1 1.06 1.06"
]);
const $6c2c53ad43edfb7d$export$c3cf968c5cbdf8be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDownRegular', "1em", [
    "M14.91 7.22a.5.5 0 0 1-.76.63L10 3.71 5.85 7.85l-.07.06a.5.5 0 0 1-.63-.76l4.5-4.5.07-.06a.5.5 0 0 1 .63.06l4.5 4.5zM5.1 12.78a.5.5 0 0 1 .76-.63L10 16.29l4.15-4.14.07-.06a.5.5 0 0 1 .63.76l-4.5 4.5-.07.06a.5.5 0 0 1-.63-.06l-4.5-4.5z"
]);
const $6c2c53ad43edfb7d$export$bfdb5cb288084be0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorFilled', "1em", [
    "M14 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $6c2c53ad43edfb7d$export$c03b9e77d85a3b54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorRegular', "1em", [
    "M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2 13h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
]);
const $6c2c53ad43edfb7d$export$95e0e1777209b392 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAddFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2a5.5 5.5 0 0 0-5.74 8.8H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5M7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $6c2c53ad43edfb7d$export$b6bce6645b48694b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAddRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2q-.49-.13-1-.18V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3.6q.27.54.66 1H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5M7 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $6c2c53ad43edfb7d$export$46088a2698f76aa0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeftFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2a5.5 5.5 0 0 0-5.74 8.8H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.85 10.15a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 1 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0 0-.7M7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $6c2c53ad43edfb7d$export$b55fb7312536fe42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeftRegular', "1em", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a6 6 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02q.51.05 1 .19V4a2 2 0 0 0-2-2zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $6c2c53ad43edfb7d$export$ccd08a7ae617535 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRightFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2a5.5 5.5 0 0 0-5.74 8.8H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.85 10.15a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $6c2c53ad43edfb7d$export$a6bc6b5a801c70d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRightRegular', "1em", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a6 6 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02q.51.05 1 .19V4a2 2 0 0 0-2-2zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.35-2.15a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $6c2c53ad43edfb7d$export$e396b157e035f906 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTagFilled', "1em", [
    "M9.3 6.3A1 1 0 1 1 10 8H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7.05a4.98 4.98 0 0 0-8.54-3.59A2 2 0 1 0 9.3 6.3M8 14h4a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1"
]);
const $6c2c53ad43edfb7d$export$521adc0d03b0f352 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTagRegular', "1em", [
    "M9.3 6.3A1 1 0 1 1 10 8H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7.05a4.98 4.98 0 0 0-8.54-3.59A2 2 0 1 0 9.3 6.3M11.4 8.4A2 2 0 1 0 8.6 5.6a1 1 0 0 1-1.42-1.42A4 4 0 0 1 14 7V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3a2 2 0 0 0 1.41-.59M8 14a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$2e99d747f3055ddf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7h-.25q.18.34.37.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 8.86 1.25l-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a6 6 0 0 1 .7-.7q.22-.2.39-.37a1 1 0 0 0 .2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19q-.13.07-.34.12a.6.6 0 0 1-.54-.18 1 1 0 0 1-.18-.37l-.03-.28v-.07l-.02-.23q-.02-.33-.15-.83c-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a1 1 0 0 1 .03-.55q.12-.28.35-.44a19 19 0 0 0 1.74-1.66q.47-.48.77-.82h.01A7 7 0 0 0 10 3"
]);
const $6c2c53ad43edfb7d$export$838d842e40f816c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthRegular', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7h-.25q.18.34.37.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 8.86 1.25l-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a6 6 0 0 1 .7-.7q.22-.2.39-.37a1 1 0 0 0 .2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19q-.13.07-.34.12a.6.6 0 0 1-.54-.18 1 1 0 0 1-.18-.37l-.03-.28v-.07l-.02-.23q-.02-.33-.15-.83c-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 19 19 0 0 0 1.74-1.65q.47-.48.77-.82h.01A7 7 0 0 0 10 3m4.64 1.76a42 42 0 0 1-2.71 2.66q.04.1.24.36l.12.16c.32.4.78.97.96 1.68q.15.6.17.98v.01c.6-.33 1.21-.3 1.66.06.46.35.66.97.47 1.57-.08.27-.27.5-.43.66l-.44.43-.11.1q-.3.26-.48.48a1 1 0 0 0-.19.34q-.05.35.29.78.15.19.3.3 0 .02.02.03a7 7 0 0 0 .13-10.6M8.8 3.36l-.13-.23a7 7 0 0 0-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02q.3-.04.45-.13.15-.06.28-.3.05-.07.02-.34l-.15-.54-.05-.15c-.15-.5-.37-1.26.09-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6 6 0 0 0-.38-.83"
]);
const $6c2c53ad43edfb7d$export$d84d56df292e01d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeafFilled', "1em", [
    "M2 10a8 8 0 1 1 16 .34l-.64-.16a10 10 0 0 0-3.3-.17q-.9.12-1.67.4l-.1-.54c-.13-.49-.45-.89-.77-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 19 19 0 0 0 1.74-1.65l.78-.82A7 7 0 0 0 9.74 3q.19.34.38.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 3.87 2.17q-.27.45-.51.91A8 8 0 0 1 2 10m16.93 1.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02-.3-.08-.09-.03q-.34-.1-.84-.21a9 9 0 0 0-2.95-.16q-1.8.24-2.75 1.15a2.9 2.9 0 0 0-.9 2.62 13 13 0 0 1 3.77-2.23.5.5 0 1 1 .38.92q-1.2.49-2.2 1.1a8.5 8.5 0 0 0-3.44 3.72.5.5 0 0 0 .9.44q.56-1.14 1.44-2.06a4 4 0 0 0 .59.8 3.1 3.1 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a8 8 0 0 1 1-2.03v-.02q.15-.21.23-.38a.5.5 0 0 0-.02-.48"
]);
const $6c2c53ad43edfb7d$export$c61c6f571ed6292f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeafRegular', "1em", [
    "M2 10a8 8 0 1 1 16 .34l-1-.23V10c0-2.1-.91-3.97-2.36-5.25l-.07.07-.79.84c-.6.62-1.35 1.37-1.85 1.75q.04.1.24.36l.12.16a4.7 4.7 0 0 1 1.07 2.2q-.5.1-.97.28l-.1-.55c-.13-.49-.45-.89-.77-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 19 19 0 0 0 1.74-1.65l.78-.82A7 7 0 0 0 9.74 3q.19.34.38.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 3.87 2.17q-.27.45-.51.91A8 8 0 0 1 2 10m6.8-6.65-.13-.22a7 7 0 0 0-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02q.3-.04.45-.13.16-.06.28-.3.06-.07.02-.34l-.15-.54-.04-.15c-.16-.5-.38-1.26.08-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6 6 0 0 0-.38-.83m10.13 8.39a.5.5 0 0 0-.43-.24h-.03l-.1-.02-.3-.08-.09-.03q-.34-.1-.84-.21a9 9 0 0 0-2.95-.16q-1.8.24-2.75 1.15a2.9 2.9 0 0 0-.9 2.62 13 13 0 0 1 3.77-2.23.5.5 0 1 1 .38.92q-1.2.49-2.2 1.1a8.5 8.5 0 0 0-3.44 3.72.5.5 0 0 0 .9.44q.56-1.14 1.44-2.06a4 4 0 0 0 .59.8 3.1 3.1 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a8 8 0 0 1 1-2.03v-.02q.15-.21.23-.38a.5.5 0 0 0-.02-.48"
]);
const $6c2c53ad43edfb7d$export$904e28a5425ac577 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FluentFilled', "1em", [
    "M10.72 2.05a.5.5 0 0 0-.44 0l-5 2.5A.5.5 0 0 0 5 5v9.5q.01.28.24.43l5 3a.5.5 0 0 0 .76-.43v-4.7l4.72-2.35a.5.5 0 0 0 0-.9l-4.1-2.05 4.1-2.05a.5.5 0 0 0 0-.9z"
]);
const $6c2c53ad43edfb7d$export$1eb9537f81d7ab23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FluentRegular', "1em", [
    "M10.28 2.05a.5.5 0 0 1 .44 0l5 2.5a.5.5 0 0 1 0 .9l-4.1 2.05 4.1 2.05a.5.5 0 0 1 0 .9L11 12.8v4.69a.5.5 0 0 1-.76.43l-5-3A.5.5 0 0 1 5 14.5V5q0-.3.28-.45zM6 5.31v8.9l4 2.4v-3.8a1 1 0 0 1 .55-.9L14.38 10l-4.1-2.05a.5.5 0 0 1 0-.9L14.38 5 10.5 3.06z"
]);
const $6c2c53ad43edfb7d$export$ebd61eb6ecfe4c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FluidFilled', "1em", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 5.54zM8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 0 0-.5-.5H8zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 0 1 4 13.5V8zm6.5 2c-.82 0-1.5.67-1.5 1.5v5c0 .83.68 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5z"
]);
const $6c2c53ad43edfb7d$export$949c0507566bf727 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FluidRegular', "1em", [
    "M8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 0 0-.5-.5H8zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 0 1 4 13.5V8zM2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 5.54zM3.5 3a.5.5 0 0 0-.5.5v2.04c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5zm6.5 8.5c0-.83.68-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v5c0 .28.23.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5z"
]);
const $6c2c53ad43edfb7d$export$8f66a755bb230595 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChartFilled', "1em", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4H7v2H4.5a1.5 1.5 0 1 0 0 3H7v7H4.5A2.5 2.5 0 0 1 2 13.5zM8 16V9.5c0 .83.67 1.5 1.5 1.5H11v.5c0 .65.42 1.2 1 1.41V16zm2-8h2V4H8v2h.5c.83 0 1.5.67 1.5 1.5zm5.5 5H13v3h2.5a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4H13v4h.5c.83 0 1.5.67 1.5 1.5v.5h.5a1.5 1.5 0 0 1 0 3m-11-6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m3.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $6c2c53ad43edfb7d$export$d7a6edad1d05d5c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChartRegular', "1em", [
    "M4.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m3.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-8-7A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5H7v1h1V5h4v3h1V5h2.5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H13v-2h-1v2H8V9H7v6H4.5A1.5 1.5 0 0 1 3 13.5z"
]);
const $6c2c53ad43edfb7d$export$21f16e73cd2cf9c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeFilled', "1em", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98q.3.14.57.41c.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17q-2.15.28-3.22.52.3.08.68.14c.99.17 2.24.32 3.57.43 1 .09 2.09.23 3.01.4q.7.13 1.26.3.56.15.97.4c.13.1.3.23.42.45q.23.4.03.85c-.11.24-.3.4-.45.5q-.25.15-.54.25c-.77.29-2.15.55-4.29.8-2.12.23-3.4.54-4.11.85q-.44.2-.51.3.04.06.16.17.22.22.64.45c.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96q-.53-.3-.93-.65a2 2 0 0 1-.62-.94q-.17-.68.28-1.24.4-.49 1.1-.77c.93-.4 2.4-.73 4.55-.98q2.03-.23 3.05-.46l-.56-.12c-.86-.16-1.89-.29-2.86-.37a44 44 0 0 1-3.7-.46q-.8-.14-1.4-.3c-.37-.11-.75-.24-1.02-.43a1 1 0 0 1-.43-.49 1 1 0 0 1 .06-.87c.13-.22.32-.36.47-.44q.26-.14.56-.26c.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96q-.98-.3-2.9-.63a89 89 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82"
]);
const $6c2c53ad43edfb7d$export$72bd1806f0659118 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeRegular', "1em", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96q.3.14.51.36c.14.16.27.4.22.69a1 1 0 0 1-.4.57q-.25.2-.63.34c-.99.4-2.89.77-5.92 1.15a23 23 0 0 0-4.13.78l.3.1q.51.13 1.28.27c1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4q.68.12 1.23.29.54.15.9.38.2.1.34.35.16.28.03.62a1 1 0 0 1-.37.4q-.2.12-.49.23c-.74.27-2.08.53-4.22.77a16 16 0 0 0-4.2.88c-.37.16-.55.3-.63.4q-.07.1-.04.14.01.1.26.35.25.23.7.48c.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94q-.5-.29-.88-.62a2 2 0 0 1-.55-.81q-.14-.55.23-1.03.35-.41 1.02-.7c.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7l-.3-.1q-.48-.15-1.14-.27a30 30 0 0 0-2.89-.38 44 44 0 0 1-3.68-.45q-.78-.15-1.37-.3Q5.37 9.26 5 9a1 1 0 0 1-.34-.38.7.7 0 0 1 .04-.64q.16-.25.39-.36.22-.12.52-.23a23 23 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09q.16-.06.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96"
]);
const $6c2c53ad43edfb7d$export$c3dd12e2783ef994 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDownFilled', "1em", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98q.3.14.57.41c.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17q-2.15.28-3.22.52.3.08.68.14c.99.17 2.24.32 3.57.43 1 .09 2.09.23 3.01.4q.7.13 1.26.3.56.15.97.4a1.3 1.3 0 0 1 .49.59 1.75 1.75 0 0 0-2.33 1.65v.16q-1.13.23-2.99.44c-2.12.24-3.4.55-4.11.86q-.44.2-.51.3.04.06.16.17.22.22.64.45c.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96q-.53-.3-.93-.65a2 2 0 0 1-.62-.94q-.17-.68.28-1.24.4-.49 1.1-.77c.93-.4 2.4-.73 4.55-.98q2.03-.23 3.05-.46l-.56-.12c-.86-.16-1.89-.29-2.86-.37a44 44 0 0 1-3.7-.46q-.8-.14-1.4-.3c-.37-.11-.75-.24-1.02-.43a1 1 0 0 1-.43-.49 1 1 0 0 1 .06-.87c.13-.22.32-.36.47-.44q.26-.14.56-.26c.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96q-.98-.3-2.9-.63a89 89 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82M17 12.25a.75.75 0 0 0-1.5 0v4.19l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72z"
]);
const $6c2c53ad43edfb7d$export$2ed72f0548c61b6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDownRegular', "1em", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96q.3.14.51.36c.14.16.27.4.22.69a1 1 0 0 1-.4.57q-.25.2-.63.34c-.99.4-2.89.77-5.92 1.15-2.15.27-3.44.53-4.1.77H5.9l.3.1q.51.15 1.28.28c1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4q.68.12 1.23.29.54.15.9.38.2.1.34.35.11.2.09.43L16.5 11a1.5 1.5 0 0 0-1.42 1.02c-.8.2-1.96.4-3.6.58a16 16 0 0 0-4.18.88c-.38.16-.56.3-.64.4q-.07.1-.04.14.01.1.26.35.25.23.7.48c.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94q-.5-.29-.88-.62a2 2 0 0 1-.55-.81q-.14-.55.23-1.03.35-.41 1.02-.7c.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7l-.3-.1q-.48-.15-1.14-.27a30 30 0 0 0-2.89-.38 44 44 0 0 1-3.68-.45q-.78-.15-1.37-.3Q5.37 9.26 5 9a1 1 0 0 1-.34-.38.7.7 0 0 1 .04-.64q.16-.25.39-.36.22-.12.52-.23a23 23 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09q.16-.06.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96m14 9.54a.5.5 0 0 0-1 0v4.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L17 17.29z"
]);
const $6c2c53ad43edfb7d$export$e01f6eb5c9200311 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDownFilled', "1em", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98q.3.14.57.41c.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17q-2.15.28-3.22.52.3.08.68.14c.99.17 2.24.32 3.57.43a31 31 0 0 1 3.51.5l-1.28 1.29a32 32 0 0 0-2.36-.3 44 44 0 0 1-3.7-.45q-.8-.14-1.4-.3c-.37-.11-.75-.24-1.02-.43a1 1 0 0 1-.43-.49 1 1 0 0 1 .06-.87c.13-.22.32-.36.47-.44q.26-.14.56-.26c.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96q-.98-.3-2.9-.63a89 89 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82m10.13 8.23a1.8 1.8 0 0 0-.32 1.56q-.48.07-1.05.13c-2.12.24-3.4.55-4.11.86q-.44.2-.51.3.04.06.16.17.22.22.64.45c.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96q-.53-.3-.93-.65a2 2 0 0 1-.62-.94q-.17-.68.28-1.24.4-.49 1.1-.77c.93-.4 2.4-.73 4.55-.98q.87-.1 1.54-.2m3.9-1.44a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v4.38l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72v-4.38l.72.72a.75.75 0 1 0 1.06-1.06z"
]);
const $6c2c53ad43edfb7d$export$427da0f5f85e18d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDownRegular', "1em", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96q.3.14.51.36c.14.16.27.4.22.69a1 1 0 0 1-.4.57q-.25.2-.63.34c-.99.4-2.89.77-5.92 1.15-2.15.27-3.44.53-4.1.77H5.9l.3.1q.51.15 1.28.28c1 .18 2.25.33 3.59.44a31 31 0 0 1 4.01.63l-.83.83-.38-.08a30 30 0 0 0-2.89-.38 44 44 0 0 1-3.68-.45q-.78-.15-1.37-.3Q5.37 9.26 5 9a1 1 0 0 1-.34-.38.7.7 0 0 1 .04-.64q.16-.25.39-.36.22-.12.52-.23a23 23 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09q.16-.06.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96m10.44 8.48a1.5 1.5 0 0 0-.44.97l-1.51.2a16 16 0 0 0-4.2.87c-.37.16-.55.3-.63.4q-.07.1-.04.14.01.1.26.35.25.23.7.48c.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94q-.5-.29-.88-.62a2 2 0 0 1-.55-.81q-.14-.55.23-1.03.35-.41 1.02-.7c.88-.38 2.32-.7 4.47-.95q1.31-.15 2.2-.3zm3.41-1.3a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.71L16 11.71v5.58l-1.15-1.14a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L17 17.29v-5.58l1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $6c2c53ad43edfb7d$export$218558612164f8b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolFilled', "1em", [
    "m8.52 15-.02.5c0 .58.07 1.16.27 1.62s.6.88 1.23.88 1.02-.41 1.23-.88c.2-.46.27-1.04.27-1.62q0-.26-.02-.5zM2.5 5.5v-3c0-.28.22-.5.5-.5h14c.28 0 .5.22.5.5v3c0 .83-.67 1.5-1.5 1.5H4a1.5 1.5 0 0 1-1.5-1.5M4.75 8l2.72 5.45a1 1 0 0 0 .9.55h3.26a1 1 0 0 0 .9-.55L15.25 8z"
]);
const $6c2c53ad43edfb7d$export$5ba22a6cba305710 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolRegular', "1em", [
    "M3.5 2.5a.5.5 0 0 0-1 0v3C2.5 6.33 3.17 7 4 7h.2l3.58 7.17q.26.5.75.71c-.05.66-.03 1.31.1 1.83q.13.5.45.88.35.4.92.41.58-.02.93-.41.32-.37.43-.88c.14-.52.17-1.17.11-1.83.32-.14.6-.39.75-.7L15.81 7H16c.83 0 1.5-.67 1.5-1.5v-3a.5.5 0 0 0-1 0v3a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5zM5.3 7h9.4l-3.37 6.72a.5.5 0 0 1-.45.28H9.12a.5.5 0 0 1-.45-.28zm4.22 8h.96q.06.89-.08 1.46-.1.35-.21.45A.2.2 0 0 1 10 17a.2.2 0 0 1-.18-.09 1 1 0 0 1-.21-.45q-.15-.57-.09-1.46"
]);
const $6c2c53ad43edfb7d$export$41e633f508b19129 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccentFilled', "1em", [
    "M17 6V3H3v3c0 .28.22.5.5.5h13A.5.5 0 0 0 17 6m-4.55 1-2.4 4.78a.5.5 0 1 0 .9.44L13.56 7 13 6.5zM10 17.5c.55 0 1-.67 1-1.5s-.45-1.5-1-1.5-1 .67-1 1.5.45 1.5 1 1.5"
]);
const $6c2c53ad43edfb7d$export$a187c0606f971ad9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotFilled', "1em", [
    "M16 4a2 2 0 0 1-2.65 1.89l-1.28 1.94A3 3 0 0 1 13 9.99l1.17.2a2 2 0 1 1-.16.99l-1.17-.2a3 3 0 0 1-1.43 1.67l.45 1.36H12a2 2 0 1 1-1.1.31l-.44-1.35a3 3 0 0 1-2.87-1.18l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4"
]);
const $6c2c53ad43edfb7d$export$388797f70132b619 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotRegular', "1em", [
    "M16 4a2 2 0 0 1-2.65 1.89l-1.28 1.94A3 3 0 0 1 13 9.99l1.17.2a2 2 0 1 1-.16.99l-1.17-.2a3 3 0 0 1-1.43 1.67l.45 1.36H12a2 2 0 1 1-1.1.31l-.44-1.35a3 3 0 0 1-2.87-1.18l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m8 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $6c2c53ad43edfb7d$export$7b04565088a0d33e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlertFilled', "1em", [
    "M16 4a2 2 0 0 1-2.65 1.88l-1.28 1.95.3.33A4 4 0 0 0 9.5 12v.96a3 3 0 0 1-1.91-1.17l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4m-5.5 8a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 14zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $6c2c53ad43edfb7d$export$11b0e94c7e89231c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlertRegular', "1em", [
    "M16 4a2 2 0 0 1-2.65 1.88l-1.28 1.95.3.33q-.51.15-.96.43A2 2 0 0 0 8 10a2 2 0 0 0 1.5 1.94v1.02a3 3 0 0 1-1.91-1.17l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0m5.5-1a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 14zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $6c2c53ad43edfb7d$export$10eb99078bed331e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LibraryColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__a)",
            "d": "M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__b)",
            "d": "M7 3.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__c)",
            "d": "M15.72 6.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.85 1.15l.98-.25c.79-.2 1.27-1 1.1-1.78z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__d)",
            "d": "M6 7H2V5h4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__e)",
            "d": "m12.32 8.36 3.73-.76.45 1.95-3.78.76z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__f)",
            "d": "M7 7h4V5H7z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__a",
                "x1": "7.52",
                "x2": "9.5",
                "y1": "4.99",
                "y2": "22.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__b",
                "x1": "7.52",
                "x2": "9.5",
                "y1": "4.99",
                "y2": "22.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__c",
                "x1": "7.52",
                "x2": "9.5",
                "y1": "4.99",
                "y2": "22.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__d",
                "x1": "7",
                "x2": "11",
                "y1": "4.09",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__e",
                "x1": "7",
                "x2": "11",
                "y1": "4.09",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__f",
                "x1": "7",
                "x2": "11",
                "y1": "4.09",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$cb196a54de4f9b81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LibraryFilled', "1em", [
    "M3.5 2C2.67 2 2 2.67 2 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5C6 2.67 5.33 2 4.5 2zm5 0C7.67 2 7 2.67 7 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5c0-.83-.67-1.5-1.5-1.5zm7.22 4.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78z"
]);
const $6c2c53ad43edfb7d$export$d780468c73c72d78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LibraryRegular', "1em", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zM3.5 3a.5.5 0 0 0-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5zm3.5.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zM8.5 3a.5.5 0 0 0-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5zm7.22 3.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78zM14.12 6a.5.5 0 0 1 .62.37L17 16.14a.5.5 0 0 1-.37.6l-.98.25a.5.5 0 0 1-.61-.39l-2-9.8a.5.5 0 0 1 .35-.58z"
]);
const $6c2c53ad43edfb7d$export$5f2a0725e54270d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTvFilled', "1em", [
    "M16.13 5.38 7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V8.57l-.26-.9a2.5 2.5 0 0 1 1.71-3.09L13.1 2.1a2.5 2.5 0 0 1 3.1 1.7l.27.97a.5.5 0 0 1-.34.62M3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 0 0 3.7 7.4zm2-.57 2.11-.61L9.4 4.2l-2.13.61-.02.04zm5.62-1.63 1.44-2.5-2.12.62-.03.05L9.34 6.3zm2.68-2.65q0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 0 0-1.09-1.05"
]);
const $6c2c53ad43edfb7d$export$dc5960b812b12fa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTvRegular', "1em", [
    "M16.13 5.38 7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V8.57l-.26-.9a2.5 2.5 0 0 1 1.71-3.09L13.1 2.1a2.5 2.5 0 0 1 3.1 1.7l.27.97a.5.5 0 0 1-.34.62M3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 0 0 3.7 7.4zm2-.57 2.11-.61L9.4 4.2l-2.13.61-.02.04zm5.62-1.63 1.44-2.5-2.12.62-.03.05L9.34 6.3zm2.68-2.65q0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 0 0-1.09-1.05M4 9v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V9z"
]);
const $6c2c53ad43edfb7d$export$550c217ba41297b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackwardFilled', "1em", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V6H9.5A3.5 3.5 0 0 0 6 9.5V13H4.5A2.5 2.5 0 0 1 2 10.5zM9.5 7A2.5 2.5 0 0 0 7 9.5v6A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7zM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5z"
]);
const $6c2c53ad43edfb7d$export$b7f808d2cfe58054 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackwardRegular', "1em", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H6v-1.7l-.7.7h-.8a2 2 0 0 1-.65-.15L6 9.71V9.5q.01-.86.38-1.59l-3.23 3.24A2 2 0 0 1 3 10.5v-.94L9.56 3h.94q.35 0 .65.15L7.9 6.38A3.5 3.5 0 0 1 9.5 6h.2l2.15-2.15q.15.3.15.65v.8l-.7.7H13V4.5A2.5 2.5 0 0 0 10.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h.65L3 5.15zm0 2.06L6.56 3h1.59L3 8.15zM7 9.5A2.5 2.5 0 0 1 9.5 7h6A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5zM9.5 8C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
]);
const $6c2c53ad43edfb7d$export$92be3ead0a8c4ef0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForwardFilled', "1em", [
    "M7 14v1.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5V14zM2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5z"
]);
const $6c2c53ad43edfb7d$export$74a9d59b2916c2d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForwardRegular', "1em", [
    "M7 14v1.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5V14zM2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5zM4.5 3C3.67 3 3 3.67 3 4.5v.65L5.15 3zm2.06 0L3 6.56v1.59L8.15 3zM3 10.5q0 .35.15.65l8-8A2 2 0 0 0 10.5 3h-.94L3 9.56zM4.5 12h.8L12 5.3v-.8q0-.35-.15-.65l-8 8q.3.15.65.15m5.2 0h.8c.83 0 1.5-.67 1.5-1.5v-.8zm-1.4 0L12 8.3V6.7L6.7 12z"
]);
const $6c2c53ad43edfb7d$export$d9adf1e1d306d70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBackFilled', "1em", [
    "M12 14c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM5 9h1.3C7.8 9 9 7.8 9 6.3V5h3.5A2.5 2.5 0 0 1 15 7.5V11h-1.3a2.7 2.7 0 0 0-2.7 2.7V15H7.5A2.5 2.5 0 0 1 5 12.5zM1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
]);
const $6c2c53ad43edfb7d$export$fac2163fed05af17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBackRegular', "1em", [
    "M12 14c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM5 9v3.5A2.5 2.5 0 0 0 7.5 15H11v-1H9.7l1.67-1.66q.36-.61.97-.97L14 9.7V11h1V7.5A2.5 2.5 0 0 0 12.5 5H9v1h1.3L8.62 7.66q-.36.61-.97.97L6 10.3V9zm6.7-3h.8q.35 0 .65.15l-7 7A2 2 0 0 1 6 12.5v-.8zm-4.2 8a2 2 0 0 1-.65-.15l7-7q.15.3.15.65v.8L8.3 14zM1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
]);
const $6c2c53ad43edfb7d$export$5038dbb4684f894a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFrontFilled', "1em", [
    "M1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v1h-.5q-.26 0-.5.04V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1.04Q4 7.24 4 7.5V8H3a2 2 0 0 1-2-2zm11 13v1c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1v.5q0 .26-.04.5H17a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.04q-.24.04-.5.04zM5 7.5A2.5 2.5 0 0 1 7.5 5h5A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 12.5z"
]);
const $6c2c53ad43edfb7d$export$fbfd0bbee97da1f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFrontRegular', "1em", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h1v-.5q0-.26.04-.5H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.04Q7.24 4 7.5 4H8V3a2 2 0 0 0-2-2zm9 16v-1h.5q.26 0 .5-.04V17a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-1.04q.04-.24.04-.5V12h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2M5 7.5A2.5 2.5 0 0 1 7.5 5h5A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 12.5zm2.28-1.48a1.5 1.5 0 0 0-1.26 1.26zM6 10.29 10.3 6H8.7L6 8.7zM11.7 6 6 11.7v.8q0 .35.15.65l7-7A2 2 0 0 0 12.5 6zm-4.2 8h.8L14 8.3v-.8q0-.35-.15-.65l-7 7q.3.15.65.15m2.2 0h1.6l2.7-2.7V9.7zm3.02-.02a1.5 1.5 0 0 0 1.26-1.26z"
]);
const $6c2c53ad43edfb7d$export$60bef58a2b953d56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RulerFilled', "1em", [
    "M12.5 2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 6 16.5v-13C6 2.67 6.67 2 7.5 2zM7 15.5h2.5a.5.5 0 0 0 0-1H7zM7 13h3.5a.5.5 0 0 0 0-1H7zm0-2.5h2.5a.5.5 0 0 0 0-1H7zM7 8h3.5a.5.5 0 0 0 0-1H7zm0-2.5h2.5a.5.5 0 0 0 0-1H7z"
]);
const $6c2c53ad43edfb7d$export$d9f8ddd4e57a13ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RulerRegular', "1em", [
    "M12.5 2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 6 16.5v-13C6 2.67 6.67 2 7.5 2zm-5 1a.5.5 0 0 0-.5.5v1h2.5a.5.5 0 0 1 0 1H7V7h3.5a.5.5 0 0 1 0 1H7v1.5h2.5a.5.5 0 0 1 0 1H7V12h3.5a.5.5 0 0 1 0 1H7v1.5h2.5a.5.5 0 0 1 0 1H7v1c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $6c2c53ad43edfb7d$export$a9a55198dcc1cfbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TentFilled', "1em", [
    "M10.4 2.82a.5.5 0 0 0-.77 0 21 21 0 0 1-4.91 3.9.5.5 0 0 0-.25.36L3.37 15H2.5a.5.5 0 0 0 0 1h3.94l.1.01h6.9l.1-.01h3.96a.5.5 0 0 0 0-1h-.84l-1.1-7.92a.5.5 0 0 0-.24-.36 21 21 0 0 1-4.92-3.9M7.51 15c.84-1.22 1.7-2.79 2.49-5.26.7 2.23 1.5 3.78 2.49 5.26z"
]);
const $6c2c53ad43edfb7d$export$a3b336befa0ea271 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TentRegular', "1em", [
    "M10.4 2.82a.5.5 0 0 0-.77 0 21 21 0 0 1-4.91 3.9.5.5 0 0 0-.25.36L3.37 15H2.5a.5.5 0 0 0 0 1h3.94l.1.01h6.9l.1-.01h3.96a.5.5 0 0 0 0-1h-.84l-1.1-7.92a.5.5 0 0 0-.24-.36 21 21 0 0 1-4.92-3.9M13.7 15a20 20 0 0 1-3.22-7.2.5.5 0 0 0-.97 0c-.98 3.84-2.14 5.75-3.22 7.2H4.4l1.03-7.54c1.3-.76 3.3-2.2 4.6-3.57a23 23 0 0 0 4.6 3.57L15.64 15zm-1.22 0H7.52c.84-1.22 1.7-2.78 2.48-5.25.7 2.23 1.49 3.77 2.48 5.25"
]);
const $6c2c53ad43edfb7d$export$631d5fd3d4c4fe29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeatherFilled', "1em", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zm-5 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M10 8.5a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1zm0 7.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7m-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7"
]);
const $6c2c53ad43edfb7d$export$3488ffa5a2b5027f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeatherRegular', "1em", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zm-.5 6a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1zm0-3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M6.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7m-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7"
]);
const $6c2c53ad43edfb7d$export$bb204080b0a21bb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePickerFilled', "1em", [
    "M10.47 2.17a.75.75 0 0 0-.94 0L6.78 4.42a.75.75 0 0 0 .94 1.16L10 3.72l2.28 1.86a.75.75 0 1 0 .94-1.16zm2.75 13.41-2.75 2.25a.75.75 0 0 1-.94 0l-2.75-2.25a.75.75 0 0 1 .94-1.16L10 16.28l2.28-1.86a.75.75 0 1 1 .94 1.16m-2.47-6.83a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8M6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8M2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0z"
]);
const $6c2c53ad43edfb7d$export$fb06faf56e060865 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePickerRegular', "1em", [
    "M10.32 2.12a.5.5 0 0 0-.64 0l-3 2.5a.5.5 0 1 0 .64.76L10 3.15l2.68 2.23a.5.5 0 0 0 .64-.76zm3 13.26-3 2.5a.5.5 0 0 1-.64 0l-3-2.5a.5.5 0 1 1 .64-.76L10 16.85l2.68-2.23a.5.5 0 0 1 .64.76m-2.57-6.63a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8M6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8M2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0z"
]);
const $6c2c53ad43edfb7d$export$a06c5c4edeea03e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimelineFilled', "1em", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zm0 8c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM17 12.44a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88M16.5 3c.28 0 .5.22.5.5v4.04a3 3 0 0 0-1 0V3.5c0-.28.22-.5.5-.5m0 10.5q-.26 0-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04q-.24.04-.5.04"
]);
const $6c2c53ad43edfb7d$export$1b702242bc5a5af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimelineRegular', "1em", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM3 4.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zm.5 6.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM3 12.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zm14-.06a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88M16.5 3c.28 0 .5.22.5.5v4.04a3 3 0 0 0-1 0V3.5c0-.28.22-.5.5-.5m0 10.5q-.26 0-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04q-.24.04-.5.04"
]);
const $6c2c53ad43edfb7d$export$f2e970b43a222cf0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer10Filled', "1em", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zM16.43 10c-.98.02-1.86.44-2.48 1.1a1.5 1.5 0 0 0-1.92-1.02l-1.5.5A1.5 1.5 0 0 0 11 13.5v4.34A7.03 7.03 0 0 1 2.5 11a7 7 0 0 1 13.93-1M9 10.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0zm5 3a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5m-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0z"
]);
const $6c2c53ad43edfb7d$export$3f8335390cde7083 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer10Regular', "1em", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71M9 6.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zM9.5 18q.77 0 1.5-.16V16.8a6.01 6.01 0 1 1 4.44-6.65q.47-.15.99-.16a7 7 0 1 0-6.93 8m4.5-4.5a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5m-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0z"
]);
const $6c2c53ad43edfb7d$export$27ecd9ffa0c0b0b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerFilled', "1em", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71M16.5 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0M9 6.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0"
]);
const $6c2c53ad43edfb7d$export$f8fab4df4347862f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerRegular', "1em", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m0 12a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-1a6 6 0 1 1 0-12 6 6 0 0 1 0 12"
]);
const $6c2c53ad43edfb7d$export$ae49aa3841aa6c4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer2Filled', "1em", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zm1.29 6.2A3.5 3.5 0 0 0 12 13.5c0 .7.47 1.27 1.1 1.45A3.5 3.5 0 0 0 12 17.5v.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87M9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm6.5-.5a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5"
]);
const $6c2c53ad43edfb7d$export$5bd94987f696c9d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer2Regular', "1em", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71M9 6.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0zm3 11.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87 4 4 0 0 0-1.03-.13 6 6 0 1 0-3.23 6.37A4 4 0 0 0 12 17.5zM15.5 11a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5"
]);
const $6c2c53ad43edfb7d$export$1ca8b1657ad7d904 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer3Filled', "1em", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zm1.29 6.2a4 4 0 0 0-.95-.13 4.5 4.5 0 0 0-2.74.97l-.25.2v.01a1.5 1.5 0 0 0 1.63 2.48 2.5 2.5 0 0 0-.04 2.62l-.04.03a1.5 1.5 0 0 0-2.05 1.23q-1.18.45-2.51.46a7 7 0 1 1 6.95-7.88M9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm4.84 1.21.03-.02a3 3 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25q0 .43-.51.84c-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41q.51.4.51.84c0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3 3 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a4 4 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4 4 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73"
]);
const $6c2c53ad43edfb7d$export$dbe02353880cd664 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer3Regular', "1em", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m0 12q1.33 0 2.5-.46l.01-.07a1.5 1.5 0 0 1 .45-1.25Q11.13 17 9.5 17a6 6 0 1 1 5.92-7 4 4 0 0 1 1.03.12A7 7 0 1 0 9.5 18m4.34-5.29.03-.02a3 3 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25q0 .43-.51.84c-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41q.51.4.51.84c0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3 3 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a4 4 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4 4 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73"
]);
const $6c2c53ad43edfb7d$export$6a61150ffd98e565 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOffFilled', "1em", [
    "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33M10 10.71l-1-1v1.79a.5.5 0 0 0 1 0zm0-4.21v1.38l5.92 5.92q.57-1.3.58-2.8a7 7 0 0 0-9.8-6.42L9 6.88V6.5a.5.5 0 0 1 1 0m-3-4c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71"
]);
const $6c2c53ad43edfb7d$export$8de989e84d54bc97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOffRegular', "1em", [
    "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33m9.16 9.16L10 10.7v.79a.5.5 0 0 1-1 0V9.7L5.67 6.39A5.99 5.99 0 0 0 9.5 17c1.86 0 3.52-.85 4.62-2.17M9 6.5v.38l1 1V6.5a.5.5 0 0 0-1 0m6.5 4.5a6 6 0 0 1-.35 2.03l.77.77q.57-1.3.58-2.8a7 7 0 0 0-9.8-6.42l.77.77A6 6 0 0 1 15.5 11m-8-9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7z"
]);
const $6c2c53ad43edfb7d$export$3fc072619128455a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopFilled', "1em", [
    "M1.96 4.5c0-.83.67-1.5 1.5-1.5H16.4c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H12v2.01h1.5a.5.5 0 0 1 0 1h-7a.5.5 0 1 1 0-1H8V14H3.46a1.5 1.5 0 0 1-1.5-1.5zM9 14v2.01h2V14zM4 5.5v6c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3 0v6c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5"
]);
const $6c2c53ad43edfb7d$export$3d65e45a76670961 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopRegular', "1em", [
    "M4 5.5c0-.28.22-.5.5-.5h1c.27 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zm-5.54-.5c0-.83.67-1.5 1.5-1.5H16.4c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H12v2.01h1.5a.5.5 0 0 1 0 1h-7a.5.5 0 1 1 0-1H8V14H3.46a1.5 1.5 0 0 1-1.5-1.5zM9 14v2.01h2V14zM3.46 4a.5.5 0 0 0-.5.5v8c0 .28.23.5.5.5H16.4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $6c2c53ad43edfb7d$export$2138cc025a32ab09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobileFilled', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2.5 0a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zM9 15.5c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.5.5"
]);
const $6c2c53ad43edfb7d$export$1309f47b44444d48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobileRegular', "1em", [
    "M7.5 4a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zM7 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zM9.5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $6c2c53ad43edfb7d$export$d349c1bf07c6c426 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_20_color__a)",
            "d": "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3l6.37-6.46a4.5 4.5 0 0 0 5.49-5.37.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84A5 5 0 0 0 13.5 2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_20_color__a",
                "x1": "8.5",
                "x2": "11.36",
                "y1": "3",
                "y2": "18.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$51ab08cf7e3915f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchFilled', "1em", [
    "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3l6.37-6.46a4.5 4.5 0 0 0 5.49-5.37.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84 5 5 0 0 0-1-.11"
]);
const $6c2c53ad43edfb7d$export$9551f7c8a242d73d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchRegular', "1em", [
    "M9 6.5a4.5 4.5 0 0 1 6.35-4.1.5.5 0 0 1 .15.8l-2.3 2.3 1.3 1.3 2.3-2.3a.5.5 0 0 1 .8.15A4.5 4.5 0 0 1 13.5 11a5 5 0 0 1-1.1-.14l-6.37 6.45a2.36 2.36 0 0 1-3.37-3.3l6.42-6.65A5 5 0 0 1 9 6.5M13.5 3a3.5 3.5 0 0 0-3.39 4.39.5.5 0 0 1-.12.47L3.38 14.7a1.36 1.36 0 0 0 1.94 1.9l6.57-6.66a.5.5 0 0 1 .51-.12 3.5 3.5 0 0 0 4.53-4.05l-2.08 2.07a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2.07-2.08A4 4 0 0 0 13.5 3"
]);
const $6c2c53ad43edfb7d$export$5b83237039988eab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriverColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__a)",
            "d": "M16 5.12v5.38h-3V5.12l-.44-.87A1 1 0 0 1 12.5 4q0-.09.07-.31l.45-1.35q.05-.15.18-.24.15-.1.3-.1h2q.15 0 .29.1.12.09.19.24l.11.35.34.99.07.32q0 .09-.06.24l-.3.64z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__b)",
            "d": "M17 11.5h-5v4.05q0 .51.2.96a2.6 2.6 0 0 0 1.35 1.3 2.5 2.5 0 0 0 1.9 0q.45-.2.8-.53.34-.33.55-.77.2-.45.2-.96z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__c)",
            "d": "M17 12v-1.5q0-.16-.07-.27a.4.4 0 0 0-.17-.15l-.24-.06-.25-.02h-3.54q-.14 0-.26.02a1 1 0 0 0-.24.07.4.4 0 0 0-.17.14.5.5 0 0 0-.06.27V12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__d)",
            "d": "M5.78 2.13q.21.15.22.41V6a1 1 0 0 0 2 0V2.54a.5.5 0 0 1 .69-.46 4.5 4.5 0 0 1 .31 8.2V16a2 2 0 1 1-4 0v-5.72a4.5 4.5 0 0 1 .31-8.2.5.5 0 0 1 .47.05"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__a",
                "x1": "15.83",
                "x2": "12.81",
                "y1": ".38",
                "y2": "16.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__b",
                "x1": "17",
                "x2": "10.45",
                "y1": "18.14",
                "y2": "13.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__c",
                "x1": "13.38",
                "x2": "14.04",
                "y1": "10.48",
                "y2": "12.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__d",
                "x1": "10",
                "x2": "4.8",
                "y1": "-1",
                "y2": "18.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $6c2c53ad43edfb7d$export$9a3761d06907cc01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriverFilled', "1em", [
    "M17 12v-1.5q0-.16-.07-.27a.4.4 0 0 0-.17-.15l-.24-.06-.25-.02H16V5.12l.13-.24.17-.32.14-.32q.06-.15.06-.24 0-.1-.07-.32a7 7 0 0 0-.34-1q-.09-.22-.11-.34a.6.6 0 0 0-.2-.25.5.5 0 0 0-.28-.09h-2q-.15 0-.3.1a.5.5 0 0 0-.18.24l-.3.86-.22.8q0 .11.06.25a8 8 0 0 0 .44.87V10h-.27q-.14 0-.26.02a1 1 0 0 0-.24.07.4.4 0 0 0-.17.14.5.5 0 0 0-.06.27V12zm0 1h-5v2.55q0 .51.2.96a2.6 2.6 0 0 0 1.35 1.3 2.5 2.5 0 0 0 1.9 0q.45-.2.8-.53.34-.33.55-.77.2-.45.2-.96zM5.78 2.13q.21.15.22.41V6a1 1 0 0 0 2 0V2.54a.5.5 0 0 1 .69-.46 4.5 4.5 0 0 1 .31 8.2V16a2 2 0 1 1-4 0v-5.72a4.5 4.5 0 0 1 .31-8.2.5.5 0 0 1 .47.05"
]);
const $6c2c53ad43edfb7d$export$ebb6f93e46368d6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriverRegular', "1em", [
    "M17 15.55V10.5q0-.16-.07-.27a.4.4 0 0 0-.17-.15l-.24-.06-.25-.02H16V5.12l.13-.24.17-.32.14-.32q.06-.15.06-.24 0-.1-.07-.32a7 7 0 0 0-.34-1q-.09-.22-.11-.34a.6.6 0 0 0-.2-.25.5.5 0 0 0-.28-.09h-2q-.15 0-.3.1a.5.5 0 0 0-.18.24l-.3.86-.22.8q0 .11.06.25a8 8 0 0 0 .44.87V10h-.27q-.14 0-.26.02a1 1 0 0 0-.24.07.4.4 0 0 0-.17.14.5.5 0 0 0-.06.27v5.05q0 .51.2.96a2.6 2.6 0 0 0 1.35 1.3 2.5 2.5 0 0 0 1.9 0q.45-.2.8-.53.34-.33.55-.77.2-.45.2-.96M15 10h-1V5a1 1 0 0 0-.05-.23l-.41-.8.32-.97h1.28l.32.96-.4.81A1 1 0 0 0 15 5zm-2 2v-1h3v1zm3 1v2.5q0 .3-.12.58-.12.29-.33.48a1.5 1.5 0 0 1-1.63.32q-.29-.12-.48-.33A1.5 1.5 0 0 1 13 15.5V13zM6 2.54a.5.5 0 0 0-.69-.46 4.5 4.5 0 0 0-.31 8.2V16a2 2 0 0 0 4 0v-5.72a4.5 4.5 0 0 0-.31-8.2.5.5 0 0 0-.69.46V6a1 1 0 1 1-2 0zM3.5 6.25c0-1.19.6-2.24 1.5-2.87V6a2 2 0 1 0 4 0V3.38a3.5 3.5 0 0 1-.69 6.12.5.5 0 0 0-.31.46V16a1 1 0 1 1-2 0V9.96a.5.5 0 0 0-.31-.46A3.5 3.5 0 0 1 3.5 6.25"
]);
const $6c2c53ad43edfb7d$export$e136347db07a209c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettingsFilled', "1em", [
    "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3L9 14.3a5.5 5.5 0 0 1 7.84-4.78 4.5 4.5 0 0 0 1.05-4.03.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84 5 5 0 0 0-1-.11m-2.86 11.92a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $6c2c53ad43edfb7d$export$3194a9b4cc339daa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettingsRegular', "1em", [
    "M9 6.5a4.5 4.5 0 0 1 6.35-4.1.5.5 0 0 1 .15.8l-2.3 2.3 1.3 1.3 2.3-2.3a.5.5 0 0 1 .8.15 4.5 4.5 0 0 1-.76 4.87 6 6 0 0 0-1.05-.37 3.5 3.5 0 0 0 1.14-3.37l-2.08 2.07a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2.07-2.08a3.52 3.52 0 0 0-4.1 4.32.5.5 0 0 1-.13.47L3.38 14.7a1.36 1.36 0 0 0 1.94 1.9l4.06-4.11A6 6 0 0 0 9 14.3L6.03 17.3a2.36 2.36 0 0 1-3.37-3.3l6.42-6.65A5 5 0 0 1 9 6.5m1.64 7.42a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
'use client';
const $00e670baa912f252$export$7d005ae4b97e6d98 = ()=>{
    const optionsById = $acw62.useRef(new Map());
    const collectionAPI = $acw62.useMemo(()=>{
        const getCount = ()=>optionsById.current.size;
        // index searches are no longer used
        const getOptionAtIndex = ()=>undefined;
        const getIndexOfId = ()=>-1;
        const getOptionById = (id)=>{
            return optionsById.current.get(id);
        };
        const getOptionsMatchingText = (matcher)=>{
            return Array.from(optionsById.current.values()).filter(({ text: text })=>matcher(text));
        };
        const getOptionsMatchingValue = (matcher)=>{
            const matches = [];
            for (const option of optionsById.current.values())if (matcher(option.value)) matches.push(option);
            return matches;
        };
        return {
            getCount: getCount,
            getOptionAtIndex: getOptionAtIndex,
            getIndexOfId: getIndexOfId,
            getOptionById: getOptionById,
            getOptionsMatchingText: getOptionsMatchingText,
            getOptionsMatchingValue: getOptionsMatchingValue
        };
    }, []);
    const registerOption = $acw62.useCallback((option)=>{
        optionsById.current.set(option.id, option);
        return ()=>optionsById.current.delete(option.id);
    }, []);
    return {
        ...collectionAPI,
        // eslint-disable-next-line react-hooks/refs
        options: Array.from(optionsById.current.values()),
        registerOption: registerOption
    };
};



var $acw62 = parcelRequire("acw62");

'use client';
const $573898e91b4ba49c$export$a97c3cc4bf1da1ca = (props)=>{
    const { defaultSelectedOptions: defaultSelectedOptions, multiselect: multiselect, onOptionSelect: onOptionSelect } = props;
    const [selectedOptions, setSelectedOptions] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.selectedOptions,
        defaultState: defaultSelectedOptions,
        initialState: []
    });
    const selectOption = $acw62.useCallback((event, option)=>{
        // if the option is disabled, do nothing
        if (option.disabled) return;
        // for single-select, always return the selected option
        let newSelection = [
            option.value
        ];
        // toggle selected state of the option for multiselect
        if (multiselect) {
            const selectedIndex = selectedOptions.findIndex((o)=>o === option.value);
            if (selectedIndex > -1) // deselect option
            newSelection = [
                ...selectedOptions.slice(0, selectedIndex),
                ...selectedOptions.slice(selectedIndex + 1)
            ];
            else // select option
            newSelection = [
                ...selectedOptions,
                option.value
            ];
        }
        setSelectedOptions(newSelection);
        onOptionSelect === null || onOptionSelect === void 0 || onOptionSelect(event, {
            optionValue: option.value,
            optionText: option.text,
            selectedOptions: newSelection
        });
    }, [
        onOptionSelect,
        multiselect,
        selectedOptions,
        setSelectedOptions
    ]);
    const clearSelection = (event)=>{
        setSelectedOptions([]);
        onOptionSelect === null || onOptionSelect === void 0 || onOptionSelect(event, {
            optionValue: undefined,
            optionText: undefined,
            selectedOptions: []
        });
    };
    return {
        clearSelection: clearSelection,
        selectOption: selectOption,
        selectedOptions: selectedOptions
    };
};


'use client';
const $0a74f76ce3acc1e8$export$716d886ba8bfc7a9 = (props)=>{
    const { appearance: appearance = 'outline', disableAutoFocus: disableAutoFocus, children: children, clearable: clearable = false, editable: editable = false, inlinePopup: inlinePopup = false, mountNode: mountNode, multiselect: multiselect, onOpenChange: onOpenChange, size: size = 'medium', activeDescendantController: activeDescendantController, freeform: freeform = false, disabled: disabled = false, onActiveOptionChange: onActiveOptionChange = null } = props;
    const optionCollection = (0, $00e670baa912f252$export$7d005ae4b97e6d98)();
    const { getOptionsMatchingValue: getOptionsMatchingValue } = optionCollection;
    const { getOptionById: getOptionById } = optionCollection;
    const getActiveOption = $acw62.useCallback(()=>{
        const activeOptionId = activeDescendantController.active();
        return activeOptionId ? getOptionById(activeOptionId) : undefined;
    }, [
        activeDescendantController,
        getOptionById
    ]);
    // Keeping some kind of backwards compatible functionality here
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const UNSAFE_activeOption = getActiveOption();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const UNSAFE_setActiveOption = $acw62.useCallback((option)=>{
        let nextOption = undefined;
        if (typeof option === 'function') {
            const activeOption = getActiveOption();
            nextOption = option(activeOption);
        }
        if (nextOption) activeDescendantController.focus(nextOption.id);
        else activeDescendantController.blur();
    }, [
        activeDescendantController,
        getActiveOption
    ]);
    // track whether keyboard focus outline should be shown
    // tabster/keyborg doesn't work here, since the actual keyboard focus target doesn't move
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    // track focused state to conditionally render collapsed listbox
    // when the trigger is focused - the listbox should but hidden until the open state is changed
    const [hasFocus, setHasFocus] = $acw62.useState(false);
    const ignoreNextBlur = $acw62.useRef(false);
    // calculate value based on props, internal value changes, and selected options
    const isFirstMount = (0, $949974c661be515d$export$c3c1287055233f8d)();
    const [controllableValue, setValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.value,
        initialState: undefined
    });
    const { selectedOptions: selectedOptions, selectOption: baseSelectOption, clearSelection: clearSelection } = (0, $573898e91b4ba49c$export$a97c3cc4bf1da1ca)(props);
    // reset any typed value when an option is selected
    const selectOption = $acw62.useCallback((ev, option)=>{
        $1u0KT.unstable_batchedUpdates(()=>{
            setValue(undefined);
            baseSelectOption(ev, option);
        });
    }, [
        setValue,
        baseSelectOption
    ]);
    const value = $acw62.useMemo(()=>{
        // don't compute the value if it is defined through props or setValue,
        if (controllableValue !== undefined) return controllableValue;
        // handle defaultValue here, so it is overridden by selection
        if (isFirstMount && props.defaultValue !== undefined) return props.defaultValue;
        const selectedOptionsText = getOptionsMatchingValue((optionValue)=>{
            return selectedOptions.includes(optionValue);
        }).map((option)=>option.text);
        if (multiselect) // editable inputs should not display multiple selected options in the input as text
        return editable ? '' : selectedOptionsText.join(', ');
        return selectedOptionsText[0];
    // do not change value after isFirstMount changes,
    // we do not want to accidentally override defaultValue on a second render
    // unless another value is intentionally set
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        controllableValue,
        editable,
        getOptionsMatchingValue,
        multiselect,
        selectedOptions
    ]);
    // Handle open state, which is shared with options in context
    const [open, setOpenState] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.open,
        defaultState: props.defaultOpen,
        initialState: false
    });
    const setOpen = $acw62.useCallback((event, newState)=>{
        if (disabled || newState === open) return;
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(event, {
            open: newState
        });
        $1u0KT.unstable_batchedUpdates(()=>{
            if (!newState && !freeform) setValue(undefined);
            setOpenState(newState);
        });
    }, [
        disabled,
        freeform,
        onOpenChange,
        open,
        setOpenState,
        setValue
    ]);
    // update active option based on change in open state
    $acw62.useEffect(()=>{
        if (open) // if it is single-select and there is a selected option, start at the selected option
        {
            if (!multiselect && selectedOptions.length > 0) {
                const selectedOption = getOptionsMatchingValue((v)=>v === selectedOptions[0]).pop();
                if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) activeDescendantController.focus(selectedOption.id);
            }
        } else activeDescendantController.blur();
    // this should only be run in response to changes in the open state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        activeDescendantController
    ]);
    // Fallback focus when children are updated in an open popover results in no item being focused
    $acw62.useEffect(()=>{
        if (open && !disableAutoFocus && !activeDescendantController.active()) activeDescendantController.first();
    // this should only be run in response to changes in the open state or children
    }, [
        open,
        children,
        disableAutoFocus,
        activeDescendantController,
        getOptionById
    ]);
    const onActiveDescendantChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        const previousOption = event.detail.previousId ? optionCollection.getOptionById(event.detail.previousId) : null;
        const nextOption = optionCollection.getOptionById(event.detail.id);
        onActiveOptionChange === null || onActiveOptionChange === void 0 || onActiveOptionChange(event, {
            event: event,
            type: 'change',
            previousOption: previousOption,
            nextOption: nextOption
        });
    });
    return {
        ...optionCollection,
        freeform: freeform,
        disabled: disabled,
        selectOption: selectOption,
        clearSelection: clearSelection,
        selectedOptions: selectedOptions,
        activeOption: UNSAFE_activeOption,
        appearance: appearance,
        clearable: clearable,
        focusVisible: focusVisible,
        ignoreNextBlur: ignoreNextBlur,
        inlinePopup: inlinePopup,
        mountNode: mountNode,
        open: open,
        hasFocus: hasFocus,
        setActiveOption: UNSAFE_setActiveOption,
        setFocusVisible: setFocusVisible,
        setHasFocus: setHasFocus,
        setOpen: setOpen,
        setValue: setValue,
        size: size,
        value: value,
        multiselect: multiselect,
        onOptionClick: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
            if (!multiselect) setOpen(e, false);
        }),
        onActiveDescendantChange: onActiveDescendantChange
    };
};



'use client';
function $dbc00c85ca944dd1$export$c22f0a858cd4e88c(props) {
    const { positioning: positioning } = props;
    // Set a default set of fallback positions to try if the dropdown does not fit on screen
    const fallbackPositions = [
        'above',
        'after',
        'after-top',
        'before',
        'before-top'
    ];
    // popper options
    const popperOptions = {
        position: 'below',
        align: 'start',
        offset: {
            crossAxis: 0,
            mainAxis: 2
        },
        fallbackPositions: fallbackPositions,
        matchTargetSize: 'width',
        autoSize: true,
        ...(0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(positioning)
    };
    const { targetRef: targetRef, containerRef: containerRef } = (0, $52c6e5e426b327c0$export$76e597284ffc020)(popperOptions);
    return [
        containerRef,
        targetRef
    ];
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
const $c1885444320cfc69$var$noop = ()=>undefined;
const $c1885444320cfc69$var$activeDescendantContextDefaultValue = {
    controller: {
        active: $c1885444320cfc69$var$noop,
        blur: $c1885444320cfc69$var$noop,
        find: $c1885444320cfc69$var$noop,
        first: $c1885444320cfc69$var$noop,
        focus: $c1885444320cfc69$var$noop,
        focusLastActive: $c1885444320cfc69$var$noop,
        scrollActiveIntoView: $c1885444320cfc69$var$noop,
        last: $c1885444320cfc69$var$noop,
        next: $c1885444320cfc69$var$noop,
        prev: $c1885444320cfc69$var$noop,
        showAttributes: $c1885444320cfc69$var$noop,
        hideAttributes: $c1885444320cfc69$var$noop,
        showFocusVisibleAttributes: $c1885444320cfc69$var$noop,
        hideFocusVisibleAttributes: $c1885444320cfc69$var$noop
    }
};
const $c1885444320cfc69$var$ActiveDescendantContext = $acw62.createContext(undefined);
const $c1885444320cfc69$export$414cface5675821c = $c1885444320cfc69$var$ActiveDescendantContext.Provider;
const $c1885444320cfc69$export$4f05d3a7578fc562 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($c1885444320cfc69$var$ActiveDescendantContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $c1885444320cfc69$var$activeDescendantContextDefaultValue;
};
const $c1885444320cfc69$export$de07c7e932d8c955 = ()=>!!$acw62.useContext($c1885444320cfc69$var$ActiveDescendantContext);



function $a4b034384e5a0a68$export$18e0e93767bb8127(e, options = {}) {
    const { open: open = true, multiselect: multiselect = false } = options;
    const code = e.key;
    const { altKey: altKey, ctrlKey: ctrlKey, key: key, metaKey: metaKey } = e;
    // typing action occurs whether open or closed
    if (key.length === 1 && code !== $c823d65ebf8ac0ff$export$eef1e68107c58ef2 && !altKey && !ctrlKey && !metaKey) return 'Type';
    // handle opening the dropdown if closed
    if (!open) {
        if (code === $c823d65ebf8ac0ff$export$1fa5a43af950a186 || code === $c823d65ebf8ac0ff$export$2624c5890f1bbcf7 || code === $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a || code === $c823d65ebf8ac0ff$export$eef1e68107c58ef2) return 'Open';
        // if the dropdown is closed and an action did not match the above, do nothing
        return 'None';
    }
    // select or close actions
    if (code === $c823d65ebf8ac0ff$export$2624c5890f1bbcf7 && altKey || code === $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a || !multiselect && code === $c823d65ebf8ac0ff$export$eef1e68107c58ef2) return 'CloseSelect';
    if (multiselect && code === $c823d65ebf8ac0ff$export$eef1e68107c58ef2) return 'Select';
    if (code === $c823d65ebf8ac0ff$export$d244daf709653685) return 'Close';
    // navigation interactions
    if (code === $c823d65ebf8ac0ff$export$1fa5a43af950a186) return 'Next';
    if (code === $c823d65ebf8ac0ff$export$2624c5890f1bbcf7) return 'Previous';
    if (code === $c823d65ebf8ac0ff$export$b94310965bed44e6) return 'First';
    if (code === $c823d65ebf8ac0ff$export$290d774e6bd35c9a) return 'Last';
    if (code === $c823d65ebf8ac0ff$export$f1f11e2fed2d2ae0) return 'PageUp';
    if (code === $c823d65ebf8ac0ff$export$f3f5fc7dcaa52927) return 'PageDown';
    if (code === $c823d65ebf8ac0ff$export$3e41faf802a29e71) return 'Tab';
    // if nothing matched, return none
    return 'None';
}





'use client';
const $3da7f046412336d6$var$listboxContextDefaultValue = {
    activeOption: undefined,
    focusVisible: false,
    multiselect: false,
    getOptionById () {
        return undefined;
    },
    getOptionsMatchingValue () {
        return [];
    },
    registerOption () {
        return ()=>undefined;
    },
    selectedOptions: [],
    onOptionClick () {
    // noop
    },
    onActiveDescendantChange () {
    // noop
    },
    selectOption () {
    // noop
    },
    setActiveOption () {
    // noop
    }
};
const $3da7f046412336d6$export$ded099ca77d022f9 = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $3da7f046412336d6$export$e12dcb7f4977f165 = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($3da7f046412336d6$export$ded099ca77d022f9, (ctx = $3da7f046412336d6$var$listboxContextDefaultValue)=>selector(ctx));
const $3da7f046412336d6$export$114930a426733f06 = $3da7f046412336d6$export$ded099ca77d022f9.Provider;



/**
 * Checks whether the given element is a combobox option element.
 * Supports elements with role="option" or role="menuitemcheckbox".
 *
 * @param element - the element to check
 * @returns true if the element has a valid combobox option role, false otherwise
 */ function $328500eb8d6a4776$export$b828ab979486a899(element) {
    return element.role === 'option' || element.role === 'menuitemcheckbox';
}


'use client';
// eslint-disable-next-line @typescript-eslint/naming-convention
const $6846618fd3cdde39$var$UNSAFE_noLongerUsed = {
    activeOption: undefined,
    focusVisible: false,
    setActiveOption: ()=>null
};
const $6846618fd3cdde39$export$e72d1c70f7f8d788 = (props, ref)=>{
    const { multiselect: multiselect, disableAutoFocus: disableAutoFocus = false } = props;
    const optionCollection = (0, $00e670baa912f252$export$7d005ae4b97e6d98)();
    const { listboxRef: activeDescendantListboxRef, activeParentRef: activeParentRef, controller: controller } = (0, $7c58394d65e14600$export$52b2d283d5b129ab)({
        matchOption: (0, $328500eb8d6a4776$export$b828ab979486a899)
    });
    const hasListboxContext = (0, $43f01c3e5f4f08d3$export$ed40f17238e0af3f)((0, $3da7f046412336d6$export$ded099ca77d022f9));
    const onActiveDescendantChange = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.onActiveDescendantChange);
    const contextGetOptionById = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.getOptionById);
    const contextGetOptionsMatchingValue = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.getOptionsMatchingValue);
    const getOptionById = hasListboxContext ? contextGetOptionById : optionCollection.getOptionById;
    const getOptionsMatchingValue = hasListboxContext ? contextGetOptionsMatchingValue : optionCollection.getOptionsMatchingValue;
    // eslint-disable-next-line react-hooks/immutability
    const listenerRef = $acw62.useMemo(()=>{
        let element = null;
        const listener = (untypedEvent)=>{
            // Typescript doesn't support custom event types on handler
            const event = untypedEvent;
            onActiveDescendantChange === null || onActiveDescendantChange === void 0 || onActiveDescendantChange(event);
        };
        return (el)=>{
            if (!el) {
                element === null || element === void 0 || element.removeEventListener('activedescendantchange', listener);
                return;
            }
            // eslint-disable-next-line react-hooks/immutability
            element = el;
            element.addEventListener('activedescendantchange', listener);
        };
    }, [
        onActiveDescendantChange
    ]);
    const [isNavigatingWithKeyboard, setIsNavigatingWithKeyboard] = $acw62.useState(false);
    (0, $6056a079b6515181$export$38848de96c4734a8)(setIsNavigatingWithKeyboard);
    const activeDescendantContext = (0, $c1885444320cfc69$export$4f05d3a7578fc562)();
    const hasParentActiveDescendantContext = (0, $c1885444320cfc69$export$de07c7e932d8c955)();
    const activeDescendantController = hasParentActiveDescendantContext ? activeDescendantContext.controller : controller;
    const { clearSelection: clearSelection, selectedOptions: selectedOptions, selectOption: selectOption } = (0, $573898e91b4ba49c$export$a97c3cc4bf1da1ca)(props);
    const onKeyDown = (event)=>{
        const action = (0, $a4b034384e5a0a68$export$18e0e93767bb8127)(event, {
            open: true
        });
        const activeOptionId = activeDescendantController.active();
        const activeOption = activeOptionId ? getOptionById(activeOptionId) : null;
        switch(action){
            case 'First':
            case 'Last':
            case 'Next':
            case 'Previous':
            case 'PageDown':
            case 'PageUp':
            case 'CloseSelect':
            case 'Select':
                event.preventDefault();
                break;
        }
        switch(action){
            case 'Next':
                if (activeOption) activeDescendantController.next();
                else activeDescendantController.first();
                break;
            case 'Previous':
                if (activeOption) activeDescendantController.prev();
                else activeDescendantController.first();
                break;
            case 'PageUp':
            case 'First':
                activeDescendantController.first();
                break;
            case 'PageDown':
            case 'Last':
                activeDescendantController.last();
                break;
            case 'Select':
            case 'CloseSelect':
                activeOption && selectOption(event, activeOption);
                break;
        }
    };
    // get state from parent combobox, if it exists
    const contextSelectedOptions = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.selectedOptions);
    const contextSelectOption = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.selectOption);
    // without a parent combobox context, provide values directly from Listbox
    const optionContextValues = hasListboxContext ? {
        selectedOptions: contextSelectedOptions,
        selectOption: contextSelectOption,
        ...$6846618fd3cdde39$var$UNSAFE_noLongerUsed
    } : {
        selectedOptions: selectedOptions,
        selectOption: selectOption,
        ...$6846618fd3cdde39$var$UNSAFE_noLongerUsed
    };
    $acw62.useEffect(()=>{
        // if the listbox has a parent context, that parent context should handle the activedescendant
        if (hasParentActiveDescendantContext) return;
        // disable focus-visible attributes until focus is received
        activeDescendantController.hideFocusVisibleAttributes();
        if (!disableAutoFocus) {
            // if it is single-select and there is a selected option, start at the selected option
            if (!multiselect && optionContextValues.selectedOptions.length > 0) {
                const selectedOption = getOptionsMatchingValue((v)=>v === optionContextValues.selectedOptions[0]).pop();
                if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) activeDescendantController.focus(selectedOption.id);
            } else activeDescendantController.first();
        }
        return ()=>{
            activeDescendantController.blur();
        };
    // this should only be run once in the lifecycle of the Listbox
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onFocus = $acw62.useCallback(()=>{
        if (hasParentActiveDescendantContext) return;
        activeDescendantController.showFocusVisibleAttributes();
        if (isNavigatingWithKeyboard) activeDescendantController.scrollActiveIntoView();
    }, [
        activeDescendantController,
        hasParentActiveDescendantContext,
        isNavigatingWithKeyboard
    ]);
    const onBlur = $acw62.useCallback(()=>{
        if (hasParentActiveDescendantContext) return;
        activeDescendantController.hideFocusVisibleAttributes();
    }, [
        activeDescendantController,
        hasParentActiveDescendantContext
    ]);
    const state = {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, activeParentRef, activeDescendantListboxRef, listenerRef),
            role: multiselect ? 'menu' : 'listbox',
            tabIndex: 0,
            ...props
        }), {
            elementType: 'div'
        }),
        standalone: !hasListboxContext,
        multiselect: multiselect,
        clearSelection: clearSelection,
        activeDescendantController: activeDescendantController,
        onActiveDescendantChange: onActiveDescendantChange,
        ...optionCollection,
        ...optionContextValues
    };
    state.root.onKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.root.onKeyDown, onKeyDown));
    state.root.onFocus = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.root.onFocus, onFocus));
    state.root.onBlur = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.root.onBlur, onBlur));
    return state;
};






const $a277d024db62df09$export$1462eb5614896d90 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $c1885444320cfc69$export$414cface5675821c), {
        value: contextValues.activeDescendant,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $3da7f046412336d6$export$ded099ca77d022f9).Provider, {
            value: contextValues.listbox,
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
        })
    });
};




'use client';
const $c03589b6bd469a25$export$c1dcc2f5f8cc0f7 = {
    root: 'fui-Listbox'
};
/**
 * Styles for the root slot
 */ const $c03589b6bd469a25$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        De3pzq: "fxugw4r",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Bf4jedk: "f3hsy1e",
        Bmxbyg5: "f5zp4f",
        Bw0xxkn: 0,
        oeaueh: 0,
        Bpd4iqm: 0,
        Befb4lg: "f1iepc6i",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1t35pdg",
        Belr9w4: "fiut8dr"
    }
}, {
    d: [
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f3hsy1e{min-width:160px;}",
        ".f5zp4f{overflow-y:auto;}",
        [
            ".f1iepc6i{outline:1px solid var(--colorTransparentStroke);}",
            {
                p: -1
            }
        ],
        [
            ".f1t35pdg{padding:var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".fiut8dr{row-gap:var(--spacingHorizontalXXS);}"
    ]
});
const $c03589b6bd469a25$export$671095107ddc50 = (state)=>{
    const styles = $c03589b6bd469a25$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($c03589b6bd469a25$export$c1dcc2f5f8cc0f7.root, styles.root, state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");


'use client';
function $055f23ea9722eae8$export$cabf8fdec8874821(state) {
    const hasListboxContext = (0, $43f01c3e5f4f08d3$export$ed40f17238e0af3f)((0, $3da7f046412336d6$export$ded099ca77d022f9));
    const { getOptionById: getOptionById, getOptionsMatchingValue: getOptionsMatchingValue, multiselect: multiselect, registerOption: registerOption, selectedOptions: selectedOptions, selectOption: selectOption, activeDescendantController: activeDescendantController } = state;
    // get register/unregister functions from parent combobox context
    const parentRegisterOption = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.registerOption);
    const onOptionClick = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.onOptionClick);
    const onActiveDescendantChange = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.onActiveDescendantChange);
    const registerOptionValue = hasListboxContext ? parentRegisterOption : registerOption;
    const listbox = {
        activeOption: undefined,
        focusVisible: false,
        getOptionById: getOptionById,
        getOptionsMatchingValue: getOptionsMatchingValue,
        multiselect: multiselect,
        registerOption: registerOptionValue,
        selectedOptions: selectedOptions,
        selectOption: selectOption,
        setActiveOption: ()=>undefined,
        onOptionClick: onOptionClick,
        onActiveDescendantChange: onActiveDescendantChange
    };
    const activeDescendant = $acw62.useMemo(()=>({
            controller: activeDescendantController
        }), [
        activeDescendantController
    ]);
    return {
        listbox: listbox,
        activeDescendant: activeDescendant
    };
}



'use client';
const $ec7780f39abc58b6$export$8bad31ff872c7659 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $6846618fd3cdde39$export$e72d1c70f7f8d788)(props, ref);
    const contextValues = (0, $055f23ea9722eae8$export$cabf8fdec8874821)(state);
    (0, $c03589b6bd469a25$export$671095107ddc50)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useListboxStyles_unstable')(state);
    return (0, $a277d024db62df09$export$1462eb5614896d90)(state, contextValues);
});
$ec7780f39abc58b6$export$8bad31ff872c7659.displayName = 'Listbox';





'use client';
function $b76f755b2b8c89b4$export$20574c65de3543d1(listboxSlotFromProp, ref, options) {
    const { state: { multiselect: multiselect }, triggerRef: triggerRef, defaultProps: defaultProps } = options;
    const listboxId = (0, $0200d30cfa270435$export$f680877a34711e37)('fluent-listbox', (0, $d0895351777ecebe$export$1b77b191c557a246)(listboxSlotFromProp) ? listboxSlotFromProp.id : undefined);
    const listboxSlot = (0, $fcf7ddccaab7fd8f$exports).optional(listboxSlotFromProp, {
        renderByDefault: true,
        elementType: (0, $ec7780f39abc58b6$export$8bad31ff872c7659),
        defaultProps: {
            id: listboxId,
            multiselect: multiselect,
            tabIndex: undefined,
            ...defaultProps
        }
    });
    const fieldControlProps = (0, $af5cf4826b6cd175$export$fc5228adfb2d94ce)({
        id: listboxId
    }, {
        supportsLabelFor: true
    });
    // Use the field's label to provide an accessible name for the listbox if it doesn't already have one
    if (listboxSlot && !listboxSlot['aria-label'] && !listboxSlot['aria-labelledby'] && fieldControlProps['aria-labelledby']) listboxSlot['aria-labelledby'] = fieldControlProps['aria-labelledby'];
    /**
   * Clicking on the listbox should never blur the trigger
   * in a combobox
   */ const onMouseDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)((event)=>{
        event.preventDefault();
    }, listboxSlot === null || listboxSlot === void 0 ? void 0 : listboxSlot.onMouseDown));
    const onClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)((event)=>{
        var _triggerRef_current;
        event.preventDefault();
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 || _triggerRef_current.focus();
    }, listboxSlot === null || listboxSlot === void 0 ? void 0 : listboxSlot.onClick));
    const listboxRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(listboxSlot === null || listboxSlot === void 0 ? void 0 : listboxSlot.ref, ref);
    if (listboxSlot) {
        listboxSlot.ref = listboxRef;
        listboxSlot.onMouseDown = onMouseDown;
        listboxSlot.onClick = onClick;
    }
    return listboxSlot;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

'use client';
function $56ce35ee344d9d3f$export$8b1c2a65d1976d22() {
    const keyborgRef = (0, $445ef382aaae6992$export$22c92c328db732ac)();
    return $acw62.useCallback((isNavigatingWithKeyboard)=>{
        var _keyborgRef_current;
        (_keyborgRef_current = keyborgRef.current) === null || _keyborgRef_current === void 0 || _keyborgRef_current.setVal(isNavigatingWithKeyboard);
    }, [
        keyborgRef
    ]);
}




'use client';
function $67ae173ef5d6e85b$export$cc4d5344f2526e37(triggerSlotFromProp, ref, options) {
    const { state: { open: open, setOpen: setOpen, setHasFocus: setHasFocus }, defaultProps: defaultProps, elementType: elementType, activeDescendantController: activeDescendantController, shouldCloseOnBlur: shouldCloseOnBlur } = options;
    const trigger = (0, $fcf7ddccaab7fd8f$exports).always(triggerSlotFromProp, {
        defaultProps: {
            type: 'text',
            'aria-expanded': open,
            role: 'combobox',
            ...typeof defaultProps === 'object' && defaultProps
        },
        elementType: elementType
    });
    // handle trigger focus/blur
    const triggerRef = $acw62.useRef(null);
    trigger.ref = (0, $de7d48ea62179626$export$9cf7d991616612b3)(triggerRef, trigger.ref, ref);
    // the trigger should open/close the popup on click or blur
    trigger.onBlur = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)((event)=>{
        var _shouldCloseOnBlur;
        if ((_shouldCloseOnBlur = shouldCloseOnBlur === null || shouldCloseOnBlur === void 0 ? void 0 : shouldCloseOnBlur(event)) !== null && _shouldCloseOnBlur !== void 0 ? _shouldCloseOnBlur : true) {
            setOpen(event, false);
            setHasFocus(false);
        }
    }, trigger.onBlur);
    trigger.onFocus = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)((event)=>{
        if (event.target === event.currentTarget) setHasFocus(true);
    }, trigger.onFocus);
    trigger.onClick = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)((event)=>{
        setOpen(event, !open);
    }, trigger.onClick);
    // handle combobox keyboard interaction
    trigger.onKeyDown = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)($67ae173ef5d6e85b$var$useTriggerKeydown({
        activeDescendantController: activeDescendantController,
        ...options.state
    }), trigger.onKeyDown);
    return trigger;
}
function $67ae173ef5d6e85b$var$useTriggerKeydown(options) {
    const { activeDescendantController: activeDescendantController, getOptionById: getOptionById, setOpen: setOpen, selectOption: selectOption, multiselect: multiselect, open: open } = options;
    const getActiveOption = $acw62.useCallback(()=>{
        const activeOptionId = activeDescendantController.active();
        return activeOptionId ? getOptionById(activeOptionId) : undefined;
    }, [
        activeDescendantController,
        getOptionById
    ]);
    const first = ()=>{
        activeDescendantController.first();
    };
    const last = ()=>{
        activeDescendantController.last();
    };
    const next = (activeOption)=>{
        if (activeOption) activeDescendantController.next();
        else activeDescendantController.first();
    };
    const previous = (activeOption)=>{
        if (activeOption) activeDescendantController.prev();
        else activeDescendantController.first();
    };
    const pageUp = ()=>{
        for(let i = 0; i < 10; i++)activeDescendantController.prev();
    };
    const pageDown = ()=>{
        for(let i = 0; i < 10; i++)activeDescendantController.next();
    };
    const setKeyboardNavigation = (0, $56ce35ee344d9d3f$export$8b1c2a65d1976d22)();
    return (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        const action = (0, $a4b034384e5a0a68$export$18e0e93767bb8127)(e, {
            open: open,
            multiselect: multiselect
        });
        const activeOption = getActiveOption();
        switch(action){
            case 'First':
            case 'Last':
            case 'Next':
            case 'Previous':
            case 'PageDown':
            case 'PageUp':
            case 'Open':
            case 'Close':
            case 'CloseSelect':
            case 'Select':
                e.preventDefault();
                break;
        }
        setKeyboardNavigation(true);
        switch(action){
            case 'First':
                first();
                break;
            case 'Last':
                last();
                break;
            case 'Next':
                next(activeOption);
                break;
            case 'Previous':
                previous(activeOption);
                break;
            case 'PageDown':
                pageDown();
                break;
            case 'PageUp':
                pageUp();
                break;
            case 'Open':
                setOpen(e, true);
                break;
            case 'Close':
                // stop propagation for escape key to avoid dismissing any parent popups
                e.stopPropagation();
                setOpen(e, false);
                break;
            case 'CloseSelect':
                !multiselect && !(activeOption === null || activeOption === void 0 ? void 0 : activeOption.disabled) && setOpen(e, false);
            // fallthrough
            case 'Select':
                activeOption && selectOption(e, activeOption);
                break;
            case 'Tab':
                !multiselect && activeOption && selectOption(e, activeOption);
                break;
        }
    });
}



'use client';
function $e09348b6c049bcd3$export$c096760dbbd962b9(triggerFromProps, ref, options) {
    const { state: { open: open, setOpen: setOpen, getOptionById: getOptionById }, defaultProps: defaultProps, activeDescendantController: activeDescendantController } = options;
    // jump to matching option based on typing
    const searchString = $acw62.useRef('');
    const [setKeyTimeout, clearKeyTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    const moveToNextMatchingOption = (matcher, opt = {
        startFromNext: false
    })=>{
        const { startFromNext: startFromNext } = opt;
        const activeOptionId = activeDescendantController.active();
        const nextInOrder = activeDescendantController.find((id)=>{
            const option = getOptionById(id);
            return !!option && matcher(option.text);
        }, {
            startFrom: startFromNext ? activeDescendantController.next({
                passive: true
            }) : activeOptionId
        });
        if (nextInOrder) return nextInOrder;
        // Cycle back to first match
        return activeDescendantController.find((id)=>{
            const option = getOptionById(id);
            return !!option && matcher(option.text);
        });
    };
    const moveToNextMatchingOptionWithSameCharacterHandling = ()=>{
        if (moveToNextMatchingOption((optionText)=>{
            return optionText.toLocaleLowerCase().indexOf(searchString.current) === 0;
        }, {
            // Slowly pressing the same key will cycle through options
            startFromNext: searchString.current.length === 1
        })) return;
        // if there are no direct matches, check if the search is all the same letter, e.g. "aaa"
        if ($e09348b6c049bcd3$var$allCharactersSame(searchString.current) && moveToNextMatchingOption((optionText)=>{
            return optionText.toLocaleLowerCase().indexOf(searchString.current[0]) === 0;
        }, {
            // if the search is all the same letter, cycle through options starting with that letter
            startFromNext: true
        })) return;
        activeDescendantController.blur();
    };
    const onTriggerKeyDown = (ev)=>{
        // clear timeout, if it exists
        clearKeyTimeout();
        // if the key was a char key, update search string
        if ((0, $a4b034384e5a0a68$export$18e0e93767bb8127)(ev) === 'Type') {
            // update search string
            searchString.current += ev.key.toLowerCase();
            setKeyTimeout(()=>{
                searchString.current = '';
            }, 500);
            if (open) moveToNextMatchingOptionWithSameCharacterHandling();
            // update state
            !open && setOpen(ev, true);
        }
    };
    const trigger = (0, $67ae173ef5d6e85b$export$cc4d5344f2526e37)(triggerFromProps, ref, {
        state: options.state,
        defaultProps: defaultProps,
        elementType: 'button',
        activeDescendantController: activeDescendantController
    });
    // eslint-disable-next-line react-hooks/immutability, react-hooks/refs
    trigger.onKeyDown = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onTriggerKeyDown, trigger.onKeyDown);
    return trigger;
}
/**
 * @returns - whether every character in the string is the same
 */ function $e09348b6c049bcd3$var$allCharactersSame(str) {
    for(let i = 1; i < str.length; i++){
        if (str[i] !== str[i - 1]) return false;
    }
    return true;
}




var $acw62 = parcelRequire("acw62");

'use client';
const $744ef6bdb1bd6c25$export$4f2c8c336209612d = (...attributes)=>{
    // The collected attributes are reduced to a single primitive `key` so the
    // `React.useMemo` dependency list keeps a constant size, even when the number
    // of contributing attributes changes between renders. The array and the key
    // are built in a single pass.
    const stringAttributes = [];
    let key = '';
    for (const attribute of attributes){
        const value = attribute === null || attribute === void 0 ? void 0 : attribute[0, $43f171f5f7088580$export$a1195ad1c253d145];
        if (value) {
            stringAttributes.push(value);
            key += value + $744ef6bdb1bd6c25$var$MERGE_KEY_SEPARATOR;
        }
    }
    return $acw62.useMemo(()=>({
            [(0, $43f171f5f7088580$export$a1195ad1c253d145)]: $744ef6bdb1bd6c25$var$mergeAttributes(stringAttributes)
        }), // on every render and therefore cannot be a dependency itself.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
};
/**
 * `NUL` separator used to build the memoization key. It is a safe separator
 * because the attribute values originate from `JSON.stringify`, which escapes
 * control characters, so a literal `NUL` can never appear inside one of them.
 */ const $744ef6bdb1bd6c25$var$MERGE_KEY_SEPARATOR = '\u0000';
/**
 * Merges a collection of tabster attribute JSON strings into a single one.
 * Later attributes take priority over earlier ones.
 */ const $744ef6bdb1bd6c25$var$mergeAttributes = (stringAttributes)=>{
    if (stringAttributes.length === 0) return undefined;
    // common case: a single hook contributed an attribute, no parsing required
    if (stringAttributes.length === 1) return stringAttributes[0];
    return JSON.stringify(Object.assign({}, ...stringAttributes.map($744ef6bdb1bd6c25$var$safelyParseJSON)));
};
/**
 * Tries to parse a JSON string and returns an object.
 * If the JSON string is invalid, an empty object is returned.
 */ const $744ef6bdb1bd6c25$var$safelyParseJSON = (json)=>{
    try {
        return JSON.parse(json);
    } catch  {
        return {};
    }
};


'use client';
function $010f820a828aa731$export$fe11391452783443(props, shouldIgnoreEscape) {
    const ignoreEscapeKeyAttribute = (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        focusable: {
            ignoreKeydown: {
                Escape: shouldIgnoreEscape
            }
        }
    });
    return (0, $744ef6bdb1bd6c25$export$4f2c8c336209612d)(ignoreEscapeKeyAttribute, typeof props === 'object' ? props : {});
}


'use client';
const $201dc32abbef170b$export$498a276298023400 = (props, ref)=>{
    var _state_clearButton;
    // Merge props from surrounding <Field>, if any
    props = (0, $af5cf4826b6cd175$export$fc5228adfb2d94ce)(props, {
        supportsLabelFor: true
    });
    const { listboxRef: activeDescendantListboxRef, activeParentRef: activeParentRef, controller: activeDescendantController } = (0, $7c58394d65e14600$export$52b2d283d5b129ab)({
        matchOption: (0, $328500eb8d6a4776$export$b828ab979486a899)
    });
    const dropdownInternalState = (0, $0a74f76ce3acc1e8$export$716d886ba8bfc7a9)({
        ...props,
        activeDescendantController: activeDescendantController,
        freeform: false
    });
    const { appearance: _appearance, size: _size, freeform: _freeform, ...baseState } = dropdownInternalState;
    const { clearable: clearable, clearSelection: clearSelection, disabled: disabled, hasFocus: hasFocus, multiselect: multiselect, open: open, selectedOptions: selectedOptions, setOpen: setOpen } = baseState;
    const { primary: triggerNativeProps, root: rootNativeProps } = (0, $f5c0cec12bf016e1$export$199c93d3d8d08c56)({
        props: props,
        primarySlotTagName: 'button',
        excludedPropNames: [
            'children'
        ]
    });
    const [comboboxPopupRef, comboboxTargetRef] = (0, $dbc00c85ca944dd1$export$c22f0a858cd4e88c)(props);
    const triggerRef = $acw62.useRef(null);
    const listbox = (0, $b76f755b2b8c89b4$export$20574c65de3543d1)(props.listbox, (0, $de7d48ea62179626$export$9cf7d991616612b3)(comboboxPopupRef, activeDescendantListboxRef), {
        state: dropdownInternalState,
        triggerRef: triggerRef,
        defaultProps: {
            children: props.children
        }
    });
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    (0, $090a6633426263f1$export$9afc64c180e82dc4)({
        element: targetDocument,
        callback: (event)=>setOpen(event, false),
        refs: [
            triggerRef,
            comboboxPopupRef,
            comboboxTargetRef
        ],
        disabled: !open
    });
    var _props_button;
    const trigger = (0, $e09348b6c049bcd3$export$c096760dbbd962b9)((_props_button = props.button) !== null && _props_button !== void 0 ? _props_button : {}, (0, $de7d48ea62179626$export$9cf7d991616612b3)(triggerRef, activeParentRef, ref), {
        state: dropdownInternalState,
        defaultProps: {
            type: 'button',
            // tabster navigation breaks if the button is disabled and tabIndex is 0
            tabIndex: triggerNativeProps.disabled ? undefined : 0,
            children: baseState.value || props.placeholder,
            'aria-controls': open ? listbox === null || listbox === void 0 ? void 0 : listbox.id : undefined,
            ...triggerNativeProps
        },
        activeDescendantController: activeDescendantController
    });
    const rootSlot = (0, $fcf7ddccaab7fd8f$exports).always(props.root, {
        defaultProps: {
            'aria-owns': !props.inlinePopup && open ? listbox === null || listbox === void 0 ? void 0 : listbox.id : undefined,
            children: props.children,
            ...rootNativeProps
        },
        elementType: 'div'
    });
    rootSlot.ref = (0, $de7d48ea62179626$export$9cf7d991616612b3)(rootSlot.ref, comboboxTargetRef);
    const showClearButton = selectedOptions.length > 0 && !disabled && clearable && !multiselect;
    const state = {
        components: {
            root: 'div',
            button: 'button',
            clearButton: 'button',
            expandIcon: 'span',
            listbox: (0, $ec7780f39abc58b6$export$8bad31ff872c7659)
        },
        root: rootSlot,
        button: trigger,
        listbox: open || hasFocus ? listbox : undefined,
        clearButton: (0, $fcf7ddccaab7fd8f$exports).optional(props.clearButton, {
            defaultProps: {
                'aria-label': 'Clear selection',
                // Safari doesn't allow to focus an element with this
                // when the element is not visible (display: none) we need to remove it to avoid tabster issues
                tabIndex: showClearButton ? 0 : undefined,
                type: 'button'
            },
            elementType: 'button',
            renderByDefault: true
        }),
        expandIcon: (0, $fcf7ddccaab7fd8f$exports).optional(props.expandIcon, {
            renderByDefault: true,
            elementType: 'span'
        }),
        placeholderVisible: !baseState.value && !!props.placeholder,
        showClearButton: showClearButton,
        activeDescendantController: activeDescendantController,
        ...baseState
    };
    const onClearButtonClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)((_state_clearButton = state.clearButton) === null || _state_clearButton === void 0 ? void 0 : _state_clearButton.onClick, (ev)=>{
        var _triggerRef_current;
        clearSelection(ev);
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 || _triggerRef_current.focus();
    }));
    if (state.clearButton) state.clearButton.onClick = onClearButtonClick;
    // Heads up! We don't support "clearable" in multiselect mode, so we should never display a slot
    if (multiselect) state.clearButton = undefined;
    return state;
};
const $201dc32abbef170b$export$4a8503fe627fdd5f = (props, ref)=>{
    const fieldContext = (0, $9be8a0b8d40bba68$export$100197406d2d5de2)();
    var _fieldContext_size;
    const { appearance: appearance = 'outline', size: size = (_fieldContext_size = fieldContext === null || fieldContext === void 0 ? void 0 : fieldContext.size) !== null && _fieldContext_size !== void 0 ? _fieldContext_size : 'medium', ...baseProps } = props;
    const baseState = $201dc32abbef170b$export$498a276298023400(baseProps, ref);
    if (baseState.clearButton) {
        var _baseState_clearButton;
        var _children;
        (_children = (_baseState_clearButton = baseState.clearButton).children) !== null && _children !== void 0 ? _children : _baseState_clearButton.children = /*#__PURE__*/ $acw62.createElement((0, $81c528f1808b6955$export$ccebaeb0763e0c), null);
    }
    if (baseState.expandIcon) {
        var _baseState_expandIcon;
        var _children1;
        (_children1 = (_baseState_expandIcon = baseState.expandIcon).children) !== null && _children1 !== void 0 ? _children1 : _baseState_expandIcon.children = /*#__PURE__*/ $acw62.createElement((0, $6c2c53ad43edfb7d$export$670ea3392d1ca9e5), null);
    }
    return {
        ...baseState,
        appearance: appearance,
        size: size,
        button: {
            ...(0, $010f820a828aa731$export$fe11391452783443)(baseState.button, baseState.open),
            ...baseState.button
        }
    };
};







'use client';
const $a06d36a1833deff4$export$ff587987c5eb6af7 = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)({
    activeOption: undefined,
    appearance: 'outline',
    focusVisible: false,
    open: false,
    registerOption () {
        return ()=>undefined;
    },
    selectedOptions: [],
    selectOption () {
    // noop
    },
    setActiveOption () {
    // noop
    },
    setOpen () {
    // noop
    },
    size: 'medium'
});
const $a06d36a1833deff4$export$f11a865534e57bfe = $a06d36a1833deff4$export$ff587987c5eb6af7.Provider;



const $1e607745785dfd68$export$fdc3a99b20884bbe = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $c1885444320cfc69$export$414cface5675821c), {
            value: contextValues.activeDescendant,
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $3da7f046412336d6$export$ded099ca77d022f9).Provider, {
                value: contextValues.listbox,
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $a06d36a1833deff4$export$ff587987c5eb6af7).Provider, {
                    value: contextValues.combobox,
                    children: [
                        /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.button, {
                            children: [
                                state.button.children,
                                state.expandIcon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.expandIcon, {})
                            ]
                        }),
                        state.clearButton && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.clearButton, {}),
                        state.listbox && (state.inlinePopup ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.listbox, {}) : /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $aa8a2d30f790b072$export$602eac185826482c), {
                            mountNode: state.mountNode,
                            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.listbox, {})
                        }))
                    ]
                })
            })
        })
    });
};






'use client';
const $75ab7c81ed82d6fa$export$a0aef31c66b43d88 = {
    root: 'fui-Dropdown',
    button: 'fui-Dropdown__button',
    clearButton: 'fui-Dropdown__clearButton',
    expandIcon: 'fui-Dropdown__expandIcon',
    listbox: 'fui-Dropdown__listbox'
};
/**
 * Styles for Dropdown
 */ const $75ab7c81ed82d6fa$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "ftuwxu6",
        Bf4jedk: "f1exfvgq",
        qhf8xq: "f10pi13n",
        ha4doy: "fmrv4ls",
        Bbr2w1p: "f14a1fxs",
        Bduesf4: "f3e99gv",
        Bpq79vn: "fhljsf7",
        li1rpt: "f1gw3sf2",
        Bsft5z2: "f13zj6fq",
        E3zdtr: "f1mdlcz9",
        Eqx8gd: [
            "f1a7op3",
            "f1cjjd47"
        ],
        By385i5: "f1gboi2j",
        B1piin3: [
            "f1cjjd47",
            "f1a7op3"
        ],
        Dlnsje: "ffyw7fx",
        d9w3h3: [
            "f1kp91vd",
            "f1ibwz09"
        ],
        B3778ie: [
            "f1ibwz09",
            "f1kp91vd"
        ],
        B1q35kw: 0,
        Bw17bha: 0,
        Bcgy8vk: 0,
        Bjuhk93: "f1mnjydx",
        Gjdm7m: "f13evtba",
        b1kco5: "f1yk9hq",
        Ba2ppi3: "fhwpy7i",
        F2fol1: "f14ee0xe",
        lck23g: "f1xhbsuh",
        wi16st: "fsrmcvb",
        ywj3b2: "f1t3k7v9",
        umuwi5: "fjw5xc1",
        Blcqepd: "f1xdyd5c",
        nplu4u: "fatpbeo",
        Bioka5o: "fb7uyps",
        Bnupc0a: "fx04xgm",
        bing71: "f1c7in40",
        Bercvud: "f1ibeo51",
        Br277j9: "f18qfb8s",
        Btis473: "f1m082s7"
    },
    listbox: {
        B7ck84d: "f1ewtqcl",
        E5pizo: "f1hg901r",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bxyxcbc: "fmmk62d"
    },
    listboxCollapsed: {
        mc9l5x: "fjseox"
    },
    inlineListbox: {
        Bj3rh1h: "f19g0ac"
    },
    button: {
        Bt984gj: "f122n59",
        De3pzq: "f1c21dwh",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh",
        B7ck84d: "f1ewtqcl",
        sj55zd: "f19n0e5",
        i8kkvl: "f14mj54c",
        Bceei9c: "f1k6fduh",
        mc9l5x: "f13qh94s",
        Bahqtrf: "fk6fouc",
        Budl1dq: "f12nh0o2",
        Brf1p80: "f1869bpl",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        a9b677: "fly5x3f",
        Brovlpu: "ftqa4ok"
    },
    placeholder: {
        sj55zd: "fxc4j92"
    },
    small: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "fye6m5k",
            "f3cq2dl"
        ]
    },
    medium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f14ev680",
            "f58uxzw"
        ]
    },
    large: {
        i8kkvl: "f1rjii52",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f139mn7i",
            "f1v3q0m"
        ]
    },
    outline: {
        De3pzq: "fxugw4r",
        Bgfg5da: 0,
        B9xav0g: "f1c1zstj",
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fhz96rm"
    },
    outlineInteractive: {
        Bgoe8wy: "fvcxoqz",
        Bwzppfd: [
            "f1ub3y4t",
            "f1m52nbi"
        ],
        oetu4i: "f1l4zc64",
        gg5e9n: [
            "f1m52nbi",
            "f1ub3y4t"
        ],
        B6oc9vd: "fvs00aa",
        ak43y8: [
            "f1assf6x",
            "f4ruux4"
        ],
        wmxk5l: "f1z0osm6",
        B50zh58: [
            "f4ruux4",
            "f1assf6x"
        ],
        Bvq3b66: "f1b473iu",
        Brahy3i: [
            "f381qr8",
            "ft4skwv"
        ],
        zoxjo1: "f1qzcrsd",
        an54nd: [
            "ft4skwv",
            "f381qr8"
        ]
    },
    underline: {
        De3pzq: "f1c21dwh",
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f9ez7ne",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "fokr779"
    },
    "filled-lighter": {
        De3pzq: "fxugw4r",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f88035w"
    },
    "filled-darker": {
        De3pzq: "f16xq7d1",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f88035w"
    },
    invalid: {
        tvckwq: "fs4k3qj",
        gk2u95: [
            "fcee079",
            "fmyw78r"
        ],
        hhx65j: "f1fgmyf4",
        Bxowmz0: [
            "fmyw78r",
            "fcee079"
        ]
    },
    invalidUnderline: {
        hhx65j: "f1fgmyf4"
    },
    disabled: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1c21dwh",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        Bcq6wej: "f9dbb4x",
        Jcjdmf: [
            "f3qs60o",
            "f5u9ap2"
        ],
        sc4o1m: "fwd1oij",
        Bosien3: [
            "f5u9ap2",
            "f3qs60o"
        ]
    },
    disabledText: {
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr"
    },
    hidden: {
        mc9l5x: "fjseox"
    }
}, {
    d: [
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f1ewtqcl{box-sizing:border-box;}",
        ".ftuwxu6{display:inline-flex;}",
        ".f1exfvgq{min-width:250px;}",
        ".f10pi13n{position:relative;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f1gw3sf2::after{box-sizing:border-box;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1mdlcz9::after{position:absolute;}",
        ".f1a7op3::after{left:-1px;}",
        ".f1cjjd47::after{right:-1px;}",
        ".f1gboi2j::after{bottom:-1px;}",
        ".ffyw7fx::after{height:max(var(--strokeWidthThick), var(--borderRadiusMedium));}",
        ".f1kp91vd::after{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1ibwz09::after{border-bottom-right-radius:var(--borderRadiusMedium);}",
        [
            ".f1mnjydx::after{border-bottom:var(--strokeWidthThick) solid var(--colorCompoundBrandStroke);}",
            {
                p: -1
            }
        ],
        ".f13evtba::after{clip-path:inset(calc(100% - 2px) 0 0 0);}",
        ".f1yk9hq::after{transform:scaleX(0);}",
        ".fhwpy7i::after{transition-property:transform;}",
        ".f14ee0xe::after{transition-duration:var(--durationUltraFast);}",
        ".f1xhbsuh::after{transition-delay:var(--curveAccelerateMid);}",
        ".f1hg901r{box-shadow:var(--shadow16);}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fmmk62d{max-height:80vh;}",
        ".fjseox{display:none;}",
        ".f19g0ac{z-index:1;}",
        ".f122n59{align-items:center;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f14mj54c{column-gap:var(--spacingHorizontalXXS);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f13qh94s{display:grid;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f12nh0o2{grid-template-columns:[content] 1fr [icon] auto [end];}",
        ".f1869bpl{justify-content:space-between;}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".fly5x3f{width:100%;}",
        ".fxc4j92{color:var(--colorNeutralForeground4);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        [
            ".fye6m5k{padding:3px var(--spacingHorizontalSNudge) 3px calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        [
            ".f3cq2dl{padding:3px calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS)) 3px var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".f14ev680{padding:5px var(--spacingHorizontalMNudge) 5px calc(var(--spacingHorizontalMNudge) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        [
            ".f58uxzw{padding:5px calc(var(--spacingHorizontalMNudge) + var(--spacingHorizontalXXS)) 5px var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        ".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        [
            ".f139mn7i{padding:7px var(--spacingHorizontalM) 7px calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge));}",
            {
                p: -1
            }
        ],
        [
            ".f1v3q0m{padding:7px calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge)) 7px var(--spacingHorizontalM);}",
            {
                p: -1
            }
        ],
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        [
            ".fhz96rm{border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);}",
            {
                p: -2
            }
        ],
        ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        [
            ".f9ez7ne{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStrokeAccessible);}",
            {
                p: -1
            }
        ],
        [
            ".fokr779{border-radius:0;}",
            {
                p: -1
            }
        ],
        [
            ".f88035w{border:var(--strokeWidthThin) solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        [
            ".f88035w{border:var(--strokeWidthThin) solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fs4k3qj:not(:focus-within),.fs4k3qj:hover:not(:focus-within){border-top-color:var(--colorPaletteRedBorder2);}",
        ".fcee079:not(:focus-within),.fcee079:hover:not(:focus-within){border-right-color:var(--colorPaletteRedBorder2);}",
        ".fmyw78r:not(:focus-within),.fmyw78r:hover:not(:focus-within){border-left-color:var(--colorPaletteRedBorder2);}",
        ".f1fgmyf4:not(:focus-within),.f1fgmyf4:hover:not(:focus-within){border-bottom-color:var(--colorPaletteRedBorder2);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}"
    ],
    w: [
        ".f14a1fxs:focus-within{outline-width:2px;}",
        ".f3e99gv:focus-within{outline-style:solid;}",
        ".fhljsf7:focus-within{outline-color:transparent;}",
        ".fjw5xc1:focus-within::after{transform:scaleX(1);}",
        ".f1xdyd5c:focus-within::after{transition-property:transform;}",
        ".fatpbeo:focus-within::after{transition-duration:var(--durationNormal);}",
        ".fb7uyps:focus-within::after{transition-delay:var(--curveDecelerateMid);}",
        ".f1ibeo51:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",
        ".f1b473iu:focus-within{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f381qr8:focus-within{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".ft4skwv:focus-within{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1qzcrsd:focus-within{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"
    ],
    m: [
        [
            "@media screen and (prefers-reduced-motion: reduce){.fsrmcvb::after{transition-duration:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1t3k7v9::after{transition-delay:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.fx04xgm:focus-within::after{transition-duration:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1c7in40:focus-within::after{transition-delay:0.01ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media (forced-colors: active){.f9dbb4x{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3qs60o{border-right-color:GrayText;}.f5u9ap2{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fwd1oij{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    t: [
        "@supports selector(:has(*)){.f18qfb8s:has(.fui-Dropdown__clearButton:focus)::after{border-bottom-color:initial;}}",
        "@supports selector(:has(*)){.f1m082s7:has(.fui-Dropdown__clearButton:focus)::after{transform:scaleX(0);}}"
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    h: [
        ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".f1l4zc64:hover{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}"
    ],
    a: [
        ".fvs00aa:active{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f1assf6x:active{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f4ruux4:active{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1z0osm6:active{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"
    ]
});
const $75ab7c81ed82d6fa$var$useIconStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    icon: {
        B7ck84d: "f1ewtqcl",
        sj55zd: "fxkbij4",
        mc9l5x: "ftgm304",
        Be2twd7: "f1pp30po",
        Br312pm: "f12w6cgp",
        Bw0ie65: "f8bv1bt",
        Bo70h7d: "fvc9v3g"
    },
    small: {
        Be2twd7: "f4ybsrx",
        Frg6f3: [
            "f1h9en5y",
            "f1xk557c"
        ]
    },
    medium: {
        Be2twd7: "fe5j1ua",
        Frg6f3: [
            "f1h9en5y",
            "f1xk557c"
        ]
    },
    large: {
        Be2twd7: "f1rt2boy",
        Frg6f3: [
            "f1t5qyk5",
            "f1ikr372"
        ]
    },
    disabled: {
        sj55zd: "f1s2aq7o"
    }
}, {
    d: [
        ".f1ewtqcl{box-sizing:border-box;}",
        ".fxkbij4{color:var(--colorNeutralStrokeAccessible);}",
        ".ftgm304{display:block;}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f12w6cgp{grid-column-start:icon;}",
        ".f8bv1bt{grid-column-end:end;}",
        ".fvc9v3g svg{display:block;}",
        ".f4ybsrx{font-size:16px;}",
        ".f1h9en5y{margin-left:var(--spacingHorizontalXXS);}",
        ".f1xk557c{margin-right:var(--spacingHorizontalXXS);}",
        ".fe5j1ua{font-size:20px;}",
        ".f1rt2boy{font-size:24px;}",
        ".f1t5qyk5{margin-left:var(--spacingHorizontalSNudge);}",
        ".f1ikr372{margin-right:var(--spacingHorizontalSNudge);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}"
    ]
});
const $75ab7c81ed82d6fa$var$useBaseClearButtonStyle = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rticfuj", "r1vp6jef", {
    r: [
        ".rticfuj{align-self:center;background-color:var(--colorTransparentBackground);border:none;cursor:pointer;height:fit-content;margin:0;margin-right:var(--spacingHorizontalMNudge);padding:0;position:relative;}",
        ".rticfuj:focus{outline-style:none;}",
        ".rticfuj:focus-visible{outline-style:none;}",
        ".rticfuj[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".rticfuj[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".r1vp6jef{align-self:center;background-color:var(--colorTransparentBackground);border:none;cursor:pointer;height:fit-content;margin:0;margin-left:var(--spacingHorizontalMNudge);padding:0;position:relative;}",
        ".r1vp6jef:focus{outline-style:none;}",
        ".r1vp6jef:focus-visible{outline-style:none;}",
        ".r1vp6jef[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".r1vp6jef[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.rticfuj[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media (forced-colors: active){.r1vp6jef[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"
    ]
});
const $75ab7c81ed82d6fa$export$c3a6859d9153ae5a = (state)=>{
    const { appearance: appearance, open: open, placeholderVisible: placeholderVisible, showClearButton: showClearButton, size: size } = state;
    const invalid = `${state.button['aria-invalid']}` === 'true';
    const disabled = state.button.disabled;
    const styles = $75ab7c81ed82d6fa$var$useStyles();
    const iconStyles = $75ab7c81ed82d6fa$var$useIconStyles();
    const clearButtonStyle = $75ab7c81ed82d6fa$var$useBaseClearButtonStyle();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75ab7c81ed82d6fa$export$a0aef31c66b43d88.root, styles.root, styles[appearance], !disabled && appearance === 'outline' && styles.outlineInteractive, invalid && appearance !== 'underline' && styles.invalid, invalid && appearance === 'underline' && styles.invalidUnderline, disabled && styles.disabled, state.root.className);
    // eslint-disable-next-line react-hooks/immutability
    state.button.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75ab7c81ed82d6fa$export$a0aef31c66b43d88.button, styles.button, styles[size], placeholderVisible && styles.placeholder, disabled && styles.disabledText, state.button.className);
    if (state.listbox) // eslint-disable-next-line react-hooks/immutability
    state.listbox.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75ab7c81ed82d6fa$export$a0aef31c66b43d88.listbox, styles.listbox, state.inlinePopup && styles.inlineListbox, !open && styles.listboxCollapsed, state.listbox.className);
    if (state.expandIcon) // eslint-disable-next-line react-hooks/immutability
    state.expandIcon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75ab7c81ed82d6fa$export$a0aef31c66b43d88.expandIcon, iconStyles.icon, iconStyles[size], disabled && iconStyles.disabled, showClearButton && styles.hidden, state.expandIcon.className);
    if (state.clearButton) // eslint-disable-next-line react-hooks/immutability
    state.clearButton.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75ab7c81ed82d6fa$export$a0aef31c66b43d88.clearButton, clearButtonStyle, iconStyles.icon, iconStyles[size], disabled && iconStyles.disabled, !showClearButton && styles.hidden, state.clearButton.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $f84e89dc2fd854ac$export$e97e26a582ec2dcf(state) {
    const { appearance: appearance, open: open, getOptionById: getOptionById, getOptionsMatchingValue: getOptionsMatchingValue, registerOption: registerOption, selectedOptions: selectedOptions, selectOption: selectOption, setOpen: setOpen, size: size, activeDescendantController: activeDescendantController, onOptionClick: onOptionClick, onActiveDescendantChange: onActiveDescendantChange } = state;
    const combobox = {
        activeOption: undefined,
        appearance: appearance,
        focusVisible: false,
        open: open,
        registerOption: registerOption,
        selectedOptions: selectedOptions,
        selectOption: selectOption,
        setActiveOption: ()=>null,
        setOpen: setOpen,
        size: size
    };
    const listbox = {
        activeOption: undefined,
        focusVisible: false,
        getOptionById: getOptionById,
        getOptionsMatchingValue: getOptionsMatchingValue,
        registerOption: registerOption,
        selectedOptions: selectedOptions,
        selectOption: selectOption,
        setActiveOption: ()=>null,
        onOptionClick: onOptionClick,
        onActiveDescendantChange: onActiveDescendantChange
    };
    const activeDescendant = $acw62.useMemo(()=>({
            controller: activeDescendantController
        }), [
        activeDescendantController
    ]);
    return {
        combobox: combobox,
        activeDescendant: activeDescendant,
        listbox: listbox
    };
}



'use client';
const $196ff0182fdd345f$export$931cbfb6bfb85fc = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $201dc32abbef170b$export$4a8503fe627fdd5f)(props, ref);
    const contextValues = (0, $f84e89dc2fd854ac$export$e97e26a582ec2dcf)(state);
    (0, $75ab7c81ed82d6fa$export$c3a6859d9153ae5a)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDropdownStyles_unstable')(state);
    return (0, $1e607745785dfd68$export$fdc3a99b20884bbe)(state, contextValues);
});
$196ff0182fdd345f$export$931cbfb6bfb85fc.displayName = 'Dropdown';


var $acw62 = parcelRequire("acw62");



const $9d564f25d704974e$export$f6b0663682a12f37 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {}),
            state.infoButton && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.infoButton, {})
        ]
    });
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

'use client';
const $2848a314d8ac401f$export$297f2b836c871bf2 = (props, ref)=>{
    const { weight: weight = 'regular', size: size = 'medium', ...baseProps } = props;
    const state = $2848a314d8ac401f$export$e764f418f031c7c0(baseProps, ref);
    return {
        weight: weight,
        size: size,
        ...state
    };
};
const $2848a314d8ac401f$export$e764f418f031c7c0 = (props, ref)=>{
    const { disabled: disabled = false, required: required = false, ...rest } = props;
    return {
        disabled: disabled,
        required: (0, $fcf7ddccaab7fd8f$exports).optional(required === true ? '*' : required || undefined, {
            defaultProps: {
                'aria-hidden': 'true'
            },
            elementType: 'span'
        }),
        components: {
            root: 'label',
            required: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('label', {
            ref: ref,
            ...rest
        }), {
            elementType: 'label'
        })
    };
};




const $5f2d7caf2e03ed24$export$d9062ad594251d74 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.root.children,
            state.required && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.required, {})
        ]
    });
};




'use client';
const $5f3488a634124728$export$17b3ba63392dd087 = {
    root: 'fui-Label',
    required: 'fui-Label__required'
};
/**
 * Styles for the label
 */ const $5f3488a634124728$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        sj55zd: "f19n0e5"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        B7iucu3: "f1cyfu5x"
    },
    required: {
        sj55zd: "f1whyuy6",
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ]
    },
    small: {
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm"
    },
    medium: {
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        Be2twd7: "fod5ikn",
        Bg96gwp: "faaz57k",
        Bhrd7zp: "fl43uef"
    },
    semibold: {
        Bhrd7zp: "fl43uef"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1whyuy6{color:var(--colorPaletteRedForeground3);}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1cyfu5x{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $5f3488a634124728$export$226b295eeaef99ee = (state)=>{
    const styles = $5f3488a634124728$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5f3488a634124728$export$17b3ba63392dd087.root, styles.root, state.disabled && styles.disabled, styles[state.size], state.weight === 'semibold' && styles.semibold, state.root.className);
    if (state.required) // eslint-disable-next-line react-hooks/immutability
    state.required.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5f3488a634124728$export$17b3ba63392dd087.required, styles.required, state.disabled && styles.disabled, state.required.className);
    return state;
};



'use client';
const $0d13e5c2b1019ada$export$b04be29aa201d4f5 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $2848a314d8ac401f$export$297f2b836c871bf2)(props, ref);
    (0, $5f3488a634124728$export$226b295eeaef99ee)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useLabelStyles_unstable')(state);
    return (0, $5f2d7caf2e03ed24$export$d9062ad594251d74)(state);
});
$0d13e5c2b1019ada$export$b04be29aa201d4f5.displayName = 'Label';




var $acw62 = parcelRequire("acw62");




const $3a031b21ff566868$export$9ef445a692a707f5 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.popover, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $f1d682872ff40f20$export$7dacb05d26466c3), {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
            }),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.info, {})
        ]
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
const $7972e53b1de568ed$export$907a96fb84c6c8ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_16_color__a)",
            "d": "M13.5 1A4.5 4.5 0 0 0 9 5.5V7a1 1 0 0 0 1 1h.94l-.02.2-.17 1.69A54 54 0 0 0 10.5 13a2 2 0 1 0 4 0c0-.45-.13-1.85-.25-3.11l-.23-2.24-.02-.18V1.5a.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_16_color__b)",
            "d": "M6.72 1.05q.23.13.27.34c.02.08.51 2.2.51 3.61a3 3 0 0 1-1.13 2.35q-.37.3-.37.6v.55l.28 2.12c.1.94.22 1.96.22 2.38a2 2 0 1 1-4 0c0-.42.11-1.44.22-2.38L3 8.43v-.48q0-.3-.37-.6A3 3 0 0 1 1.5 5c0-1.41.49-3.52.51-3.61a.5.5 0 0 1 .5-.39c.27 0 .5.23.5.5v3a.5.5 0 1 0 .99 0v-3a.5.5 0 0 1 1 0v3.03a.5.5 0 0 0 .99-.03v-3c0-.27.23-.5.5-.5q.06-.01.23.05"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_16_color__a",
                "x1": "8.15",
                "x2": "21.2",
                "y1": "1.88",
                "y2": "6.75",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_16_color__b",
                "x1": ".58",
                "x2": "14.48",
                "y1": "1.88",
                "y2": "7.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$a560a7806577e7a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food16Filled', "16", [
    "M6.72 1.05q.23.13.27.34c.02.08.51 2.2.51 3.61a3 3 0 0 1-1.13 2.35q-.37.3-.37.6v.55l.28 2.12c.1.94.22 1.96.22 2.38a2 2 0 1 1-4 0c0-.42.11-1.44.22-2.38L3 8.43v-.48q0-.3-.37-.6A3 3 0 0 1 1.5 5c0-1.41.49-3.52.51-3.61a.5.5 0 0 1 .5-.39c.27 0 .5.23.5.5v3a.5.5 0 1 0 .99 0v-3a.5.5 0 0 1 1 0v3.03a.5.5 0 0 0 .99-.03v-3c0-.27.23-.5.5-.5q.06-.01.23.05M9 5.5A4.5 4.5 0 0 1 13.5 1c.28 0 .5.22.5.5v5.97l.02.18.23 2.24c.12 1.26.25 2.66.25 3.11a2 2 0 1 1-4 0c0-.45.13-1.85.25-3.11l.17-1.7.02-.19H10a1 1 0 0 1-1-1z"
]);
const $7972e53b1de568ed$export$2e899b96f1bd6b6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food16Regular', "16", [
    "M1.34 1.96c.16-.6.7-.96 1.27-.96q.55.01.93.35a1.5 1.5 0 0 1 1.92 0q.38-.34.93-.35c.57 0 1.11.36 1.27.96.15.57.34 1.5.34 2.54a3.5 3.5 0 0 1-1.6 2.94c-.27.17-.4.4-.4.6v.46l.28 2.12c.1.94.22 1.96.22 2.38a2 2 0 1 1-4 0c0-.42.11-1.44.22-2.38L3 8.43v-.4c0-.19-.13-.42-.4-.6A3.5 3.5 0 0 1 1 4.5c0-1.05.19-1.97.34-2.54M6 5a.5.5 0 0 1-1 0V2.5a.5.5 0 0 0-1 0V5a.5.5 0 0 1-1 0V2.39A.4.4 0 0 0 2.61 2c-.16 0-.27.1-.3.22A9 9 0 0 0 2 4.5c0 .88.45 1.65 1.14 2.1.44.28.86.78.86 1.44v.4l-.01.2c-.04.24-.16 1.15-.27 2.1-.12.97-.22 1.92-.22 2.26a1 1 0 1 0 2 0c0-.34-.1-1.3-.22-2.26L5 8.44v-.4c0-.66.42-1.16.86-1.44A2.5 2.5 0 0 0 7 4.5a9 9 0 0 0-.3-2.28C6.65 2.1 6.54 2 6.38 2a.4.4 0 0 0-.39.39zm3 .5A4.5 4.5 0 0 1 13.5 1c.28 0 .5.22.5.5v5.97l.02.18.23 2.24c.12 1.26.25 2.66.25 3.11a2 2 0 1 1-4 0c0-.45.13-1.85.25-3.11l.17-1.7.02-.19H10a1 1 0 0 1-1-1zm3 2.05-.02.2-.23 2.24A56 56 0 0 0 11.5 13a1 1 0 1 0 2 0c0-.38-.12-1.72-.25-3.01l-.23-2.24-.02-.2V2.04c-1.7.24-3 1.7-3 3.46V7h1.5a.5.5 0 0 1 .5.55"
]);
const $7972e53b1de568ed$export$5e824fcfe3044e23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_20_color__a)",
            "d": "M15.5 2A4.5 4.5 0 0 0 11 6.5v2c0 .83.67 1.5 1.5 1.5h.45l-.03.36-.17 2.04c-.12 1.5-.25 3.16-.25 3.6a2 2 0 1 0 4 0c0-.44-.13-2.1-.25-3.6l-.23-2.7-.02-.22V2.5a.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_20_color__b)",
            "d": "M4.5 2c.29 0 .51.23.51.5v4a.5.5 0 1 0 .99 0v-4a.5.5 0 0 1 1 0v4.03a.5.5 0 0 0 .99-.03v-4a.5.5 0 0 1 .5-.5h.02q.03 0 .13.02a.5.5 0 0 1 .35.4c.02.08.51 3.17.51 4.58a3 3 0 0 1-1.13 2.35q-.37.3-.37.6v.55l.27 2.63c.12 1.19.23 2.45.23 2.87a2 2 0 1 1-4 0c0-.42.11-1.68.23-2.87L5 10.45v-.5q0-.3-.37-.6A3 3 0 0 1 3.5 7c0-1.4.5-4.48.5-4.58A.5.5 0 0 1 4.5 2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_20_color__a",
                "x1": "10.15",
                "x2": "23.58",
                "y1": "3",
                "y2": "7.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_20_color__b",
                "x1": "2.58",
                "x2": "16.96",
                "y1": "3",
                "y2": "8.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$cb49f6fc94251592 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food20Filled', "20", [
    "m4.5 2-.18.04a.5.5 0 0 0-.31.38C3.99 2.52 3.5 5.6 3.5 7a3 3 0 0 0 1.13 2.35q.37.3.37.6v.55l-.27 2.63A49 49 0 0 0 4.5 16a2 2 0 1 0 4 0c0-.42-.11-1.68-.23-2.87L8 10.45v-.5q0-.3.37-.6A3 3 0 0 0 9.5 7c0-1.4-.5-4.5-.5-4.58a.5.5 0 0 0-.36-.4Q8.54 2 8.5 2h-.02a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-.99.03V2.5a.5.5 0 0 0-1 0v4.03a.5.5 0 0 1-.99-.03v-4a.5.5 0 0 0-.5-.5M11 6.5A4.5 4.5 0 0 1 15.5 2c.28 0 .5.22.5.5v6.98l.02.22.23 2.7c.12 1.5.25 3.16.25 3.6a2 2 0 1 1-4 0c0-.44.13-2.1.25-3.6l.17-2.04.03-.36h-.45A1.5 1.5 0 0 1 11 8.5zM8.5 2"
]);
const $7972e53b1de568ed$export$3ab657f06a3348 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food20Regular', "20", [
    "M4.67 2a1.3 1.3 0 0 0-1.29 1.07C3.23 3.89 3 5.34 3 6.5a3.5 3.5 0 0 0 1.6 2.94c.27.17.4.4.4.6v.46l-.27 2.63A49 49 0 0 0 4.5 16a2 2 0 1 0 4 0c0-.42-.11-1.68-.23-2.87L8 10.45v-.41c0-.2.13-.43.4-.6A3.5 3.5 0 0 0 10 6.5c0-1.16-.23-2.61-.38-3.43A1.3 1.3 0 0 0 8.32 2q-.51.01-.87.34a1.5 1.5 0 0 0-1.9 0Q5.2 2 4.67 2M6 3.5a.5.5 0 0 1 1 0v3a.5.5 0 0 0 1 0V3.33c0-.18.15-.33.33-.33q.25.01.3.25c.15.81.37 2.19.37 3.25a2.5 2.5 0 0 1-1.14 2.1c-.44.28-.86.78-.86 1.44v.57c.04.25.16 1.42.28 2.62.11 1.21.22 2.41.22 2.77a1 1 0 1 1-2 0c0-.36.1-1.56.22-2.77L6 10.45v-.41c0-.66-.42-1.16-.86-1.44A2.5 2.5 0 0 1 4 6.5c0-1.06.22-2.44.36-3.25A.3.3 0 0 1 4.67 3c.18 0 .33.15.33.33V6.5a.5.5 0 0 0 1 0zm5 3A4.5 4.5 0 0 1 15.5 2c.28 0 .5.22.5.5v6.98l.02.22.23 2.7c.12 1.5.25 3.16.25 3.6a2 2 0 1 1-4 0c0-.44.13-2.1.25-3.6l.17-2.04.03-.36h-.45A1.5 1.5 0 0 1 11 8.5zm3 3.04-.02.25-.23 2.69A87 87 0 0 0 13.5 16a1 1 0 1 0 2 0c0-.39-.12-1.98-.25-3.52l-.23-2.7-.02-.24v-6.5c-1.7.24-3 1.7-3 3.46v2c0 .28.22.5.5.5h1a.5.5 0 0 1 .5.54"
]);
const $7972e53b1de568ed$export$b20525e5a9055705 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_24_color__a)",
            "d": "M18.75 2A5.75 5.75 0 0 0 13 7.75v2.5c0 .97.78 1.75 1.75 1.75h.7l-.03.35-.17 2.61c-.12 1.93-.25 4.02-.25 4.54a2.5 2.5 0 0 0 5 0c0-.54-.14-2.62-.27-4.53v-.08c-.12-1.75-.23-3.32-.23-3.64v-8.5a.75.75 0 0 0-.75-.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_24_color__b)",
            "d": "M3.74 2.82a.88.88 0 0 1 1.76.06v4.5a.62.62 0 1 0 1.25 0V2.74a.75.75 0 0 1 1.5 0v4.62a.62.62 0 1 0 1.25 0V2.88a.88.88 0 0 1 1.76-.06c.04.6.24 3.55.24 5.18a4 4 0 0 1-1.7 3.27c-.2.15-.26.31-.25.4.12 1.87.45 7.01.45 7.83a2.5 2.5 0 0 1-5 0c0-.82.33-5.96.45-7.84.01-.08-.04-.24-.26-.4A4 4 0 0 1 3.5 8c0-1.63.2-4.57.24-5.18"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_24_color__a",
                "x1": "11.92",
                "x2": "28.95",
                "y1": "3.25",
                "y2": "8.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_24_color__b",
                "x1": "2.27",
                "x2": "21.16",
                "y1": "3.25",
                "y2": "10.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$f6a457dc69e0f49d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food24Filled', "24", [
    "M3.74 2.82a.88.88 0 0 1 1.76.06v4.5a.62.62 0 1 0 1.25 0V2.74a.75.75 0 0 1 1.5 0v4.62a.62.62 0 1 0 1.25 0V2.88a.88.88 0 0 1 1.76-.06c.04.6.24 3.55.24 5.18a4 4 0 0 1-1.7 3.27c-.2.15-.26.31-.25.4.12 1.87.45 7.01.45 7.83a2.5 2.5 0 0 1-5 0c0-.82.33-5.96.45-7.84.01-.08-.04-.24-.26-.4A4 4 0 0 1 3.5 8c0-1.63.2-4.57.24-5.18M13 7.75A5.75 5.75 0 0 1 18.75 2c.41 0 .75.34.75.75v8.5c0 .32.1 1.9.22 3.64l.01.08c.13 1.91.27 3.99.27 4.53a2.5 2.5 0 0 1-5 0c0-.52.13-2.61.25-4.54l.17-2.6.03-.36h-.7c-.97 0-1.75-.78-1.75-1.75z"
]);
const $7972e53b1de568ed$export$e3b52be451665286 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food24Regular', "24", [
    "M3.2 3.73a1.9 1.9 0 0 1 3.09-1.31 2 2 0 0 1 2.43 0 1.9 1.9 0 0 1 3.09 1.3c.08.98.19 2.49.19 3.78a4.5 4.5 0 0 1-2.18 3.85c-.22.14-.28.3-.27.39.13 1.93.45 6.95.45 7.76a2.5 2.5 0 0 1-5 0c0-.8.32-5.83.45-7.76 0-.09-.05-.25-.27-.39A4.5 4.5 0 0 1 3 7.5c0-1.3.1-2.8.2-3.77m6.3 3.52a.75.75 0 0 1-1.5 0V4a.5.5 0 0 0-1 0v3.25a.75.75 0 0 1-1.5 0V3.92a.4.4 0 0 0-.42-.42.4.4 0 0 0-.4.36A46 46 0 0 0 4.5 7.5a3 3 0 0 0 1.45 2.57c.55.33 1.05.96 1 1.77-.13 1.98-.45 6.92-.45 7.66a1 1 0 1 0 2 0c0-.74-.32-5.68-.45-7.66-.05-.81.45-1.44 1-1.77A3 3 0 0 0 10.5 7.5a46 46 0 0 0-.19-3.64.4.4 0 0 0-.4-.36.4.4 0 0 0-.41.42zm3.5.5A5.75 5.75 0 0 1 18.75 2c.41 0 .75.34.75.75v8.5c0 .32.1 1.9.22 3.64l.01.08c.13 1.91.27 3.99.27 4.53a2.5 2.5 0 0 1-5 0c0-.52.13-2.61.25-4.54l.17-2.6.03-.36h-.7c-.97 0-1.75-.78-1.75-1.75zm4 3.55-.02.32-.48 7.88a1 1 0 1 0 2 0c0-.48-.14-2.53-.27-4.5v-.11a119 119 0 0 1-.23-3.64V3.57a4.25 4.25 0 0 0-3.5 4.18v2.5q.02.23.25.25h1.5a.75.75 0 0 1 .75.8"
]);
const $7972e53b1de568ed$export$784c0df6a71cbd53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_28_color__a)",
            "d": "m18.92 14.56.04-.56h-1.21c-.97 0-1.75-.78-1.75-1.75v-3.5A6.75 6.75 0 0 1 22.75 2h.5c.41 0 .75.34.75.75v10.5c0 .3.1 1.93.2 3.83v.07c.14 2.38.3 5.13.3 5.85a3 3 0 1 1-6 0c0-.65.13-3.11.25-5.38z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_28_color__b)",
            "d": "M5.5 2.79a.88.88 0 0 1 1.75.1v5.86a.75.75 0 1 0 1.5 0v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 0 1.5 0V2.88a.88.88 0 0 1 1.76-.09c.07.72.49 4.79.49 6.71a4.5 4.5 0 0 1-1.51 3.36q-.5.46-.49.86v.78c.04.6.5 7.28.5 8.5a3 3 0 1 1-6 0 312 312 0 0 1 .5-8.55v-.73q0-.4-.49-.86A4.5 4.5 0 0 1 5 9.5c0-1.92.42-5.99.5-6.71"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_28_color__a",
                "x1": "14.69",
                "x2": "35.33",
                "y1": "3.5",
                "y2": "10.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_28_color__b",
                "x1": "3.62",
                "x2": "25.2",
                "y1": "3.5",
                "y2": "11.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$76c60eefc45b5774 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food28Filled', "28", [
    "M5.5 2.79a.88.88 0 0 1 1.75.1v5.86a.75.75 0 1 0 1.5 0v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 0 1.5 0V2.88a.88.88 0 0 1 1.76-.09c.07.72.49 4.79.49 6.71a4.5 4.5 0 0 1-1.51 3.36q-.5.46-.49.86v.78c.04.6.5 7.28.5 8.5a3 3 0 1 1-6 0 312 312 0 0 1 .5-8.55v-.73q0-.4-.49-.86A4.5 4.5 0 0 1 5 9.5c0-1.92.42-5.99.5-6.71M18.95 14l-.04.56-.17 3.06c-.12 2.27-.25 4.73-.25 5.38a3 3 0 1 0 6 0c0-.72-.16-3.47-.3-5.85v-.07c-.1-1.9-.2-3.53-.2-3.83V2.75a.75.75 0 0 0-.75-.75h-.5A6.75 6.75 0 0 0 16 8.75v3.5c0 .97.78 1.75 1.75 1.75z"
]);
const $7972e53b1de568ed$export$1d7a459de57d801b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food28Regular', "28", [
    "M7.06 2c-.98 0-1.82.74-1.92 1.73-.15 1.4-.39 3.95-.39 5.52 0 1.48.68 2.8 1.74 3.67q.52.45.51.87v.71c-.04.6-.5 7.28-.5 8.5a3 3 0 1 0 6 0 312 312 0 0 0-.5-8.55v-.66q0-.42.51-.87a4.7 4.7 0 0 0 1.74-3.67c0-1.57-.24-4.12-.39-5.52a1.93 1.93 0 0 0-3.13-1.3 2 2 0 0 0-2.46 0A2 2 0 0 0 7.06 2M9 4a.5.5 0 0 1 1 0v5.25a.75.75 0 0 0 1.5 0V3.94c0-.24.2-.44.44-.44s.4.17.43.38c.15 1.42.38 3.9.38 5.37 0 1.01-.46 1.92-1.19 2.51a2.7 2.7 0 0 0-1.06 2.03v.81c.05.64.5 7.25.5 8.4a1.5 1.5 0 0 1-3 0 319 319 0 0 1 .5-8.55v-.66c0-.89-.52-1.58-1.06-2.03a3.2 3.2 0 0 1-1.19-2.51c0-1.48.23-3.95.38-5.37.02-.21.2-.38.43-.38.24 0 .44.2.44.44v5.31a.75.75 0 0 0 1.5 0zm13.5-.5v9.75c0 .35.1 2 .2 3.81v.1c.14 2.44.3 5.17.3 5.84a1.5 1.5 0 0 1-3 0c0-.6.12-3 .25-5.3l.23-4.04.02-.37v-.04a.75.75 0 0 0-.75-.75h-2a.25.25 0 0 1-.25-.25v-3.5a5.25 5.25 0 0 1 5-5.24M18.96 14l-.04.56-.17 3.06c-.12 2.27-.25 4.73-.25 5.38a3 3 0 1 0 6 0c0-.72-.16-3.47-.3-5.85v-.07c-.1-1.9-.2-3.53-.2-3.83V2.75a.75.75 0 0 0-.75-.75h-.5A6.75 6.75 0 0 0 16 8.75v3.5c0 .97.78 1.75 1.75 1.75z"
]);
const $7972e53b1de568ed$export$52dd972a0396dbc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_32_color__a)",
            "d": "M25.5 2A7.5 7.5 0 0 0 18 9.5v4a2.5 2.5 0 0 0 2.5 2.5h.39l-.43 4.26c-.23 2.37-.46 4.9-.46 5.74a4 4 0 1 0 8 0c0-.98-.32-4.03-.59-6.63v-.12L27 15V3a1 1 0 0 0-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_32_color__b)",
            "d": "M14.97 2.77A1 1 0 0 0 13.94 2a1 1 0 0 0-.95 1v6a1 1 0 0 1-1.99.04V3a1 1 0 1 0-2 0v6.06a1 1 0 0 1-1.99-.05V3a1 1 0 0 0-1.98-.24C5 2.87 4 7.14 4 10a6 6 0 0 0 2.27 4.7q.74.62.73 1.18V16c-.07.5-.31 2.59-.55 4.75A77 77 0 0 0 6 26a4 4 0 0 0 8 0c0-.84-.23-3.13-.45-5.25L13 15.88c0-.36.23-.79.73-1.18A6 6 0 0 0 16 10c0-2.86-1-7.14-1.03-7.23m-1.08-.76h.02z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_32_color__a",
                "x1": "16.46",
                "x2": "40.69",
                "y1": "3.75",
                "y2": "11.98",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_32_color__b",
                "x1": "2.15",
                "x2": "29.97",
                "y1": "3.75",
                "y2": "15.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$ad1185821a8e3507 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food32Filled', "32", [
    "M18 9.5A7.5 7.5 0 0 1 25.5 2h.5a1 1 0 0 1 1 1v12q0 .26.12 1.47l.28 2.78.01.12c.27 2.6.59 5.65.59 6.63a4 4 0 1 1-8 0c0-.84.23-3.37.46-5.74l.43-4.26h-.39a2.5 2.5 0 0 1-2.5-2.5zm-3.03-6.73A1 1 0 0 0 13.94 2a1 1 0 0 0-.95 1v6a1 1 0 0 1-1.99.04V3a1 1 0 1 0-2 0v6.06a1 1 0 0 1-1.99-.05V3a1 1 0 0 0-1.98-.24C5 2.87 4 7.14 4 10a6 6 0 0 0 2.27 4.7q.74.62.73 1.18V16c-.07.5-.31 2.59-.55 4.75A77 77 0 0 0 6 26a4 4 0 0 0 8 0c0-.84-.23-3.13-.45-5.25L13 15.88c0-.36.23-.79.73-1.18A6 6 0 0 0 16 10c0-2.86-1-7.14-1.03-7.23m-1.08-.76h.02z"
]);
const $7972e53b1de568ed$export$2861260d870dcc82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food32Regular', "32", [
    "M6.68 2a2.5 2.5 0 0 0-2.44 1.92A26 26 0 0 0 3.5 9.5a6.5 6.5 0 0 0 2.82 5.36c.47.32.68.71.68 1.03v.1c-.06.49-.31 2.58-.54 4.74A77 77 0 0 0 6 26a4 4 0 0 0 8 0c0-.84-.23-3.14-.46-5.27L13 15.9c0-.32.21-.71.68-1.03A6.5 6.5 0 0 0 16.5 9.5c0-2.07-.44-4.3-.74-5.58A2.5 2.5 0 0 0 13.32 2c-.62 0-1.19.22-1.63.58a2.74 2.74 0 0 0-3.38 0A2.6 2.6 0 0 0 6.68 2m6.07 2.57c0-.31.26-.57.57-.57a.5.5 0 0 1 .5.37c.29 1.25.68 3.3.68 5.13a4.5 4.5 0 0 1-1.95 3.71 3.3 3.3 0 0 0-1.53 3.02l.54 4.72c.23 2.18.44 4.35.44 5.05a2 2 0 1 1-4 0c0-.7.2-2.87.44-5.05L9 15.89c0-1.2-.76-2.14-1.55-2.68A4.5 4.5 0 0 1 5.5 9.5c0-1.84.4-3.88.68-5.13a.5.5 0 0 1 .5-.37c.31 0 .57.26.57.57V10a1 1 0 1 0 2 0V4.75a.75.75 0 0 1 1.5 0V10a1 1 0 1 0 2 0zM20 9.5a5.5 5.5 0 0 1 5-5.48V15c0 .28.05.9.13 1.66l.28 2.79c.28 2.71.59 5.69.59 6.55a2 2 0 1 1-4 0c0-.71.21-3.11.45-5.54l.55-5.4A1 1 0 0 0 22 14h-1.5a.5.5 0 0 1-.5-.5zM25.5 2A7.5 7.5 0 0 0 18 9.5v4a2.5 2.5 0 0 0 2.5 2.5h.39l-.43 4.26c-.23 2.37-.46 4.9-.46 5.74a4 4 0 1 0 8 0c0-.98-.32-4.03-.59-6.63v-.12L27 15V3a1 1 0 0 0-1-1z"
]);
const $7972e53b1de568ed$export$db4fc131f98bd5d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_48_color__a)",
            "d": "m30.85 24.91.06-.91h-1.66A3.25 3.25 0 0 1 26 20.75v-5.5C26 9.04 31.04 4 37.25 4h.5c.69 0 1.25.56 1.25 1.25v17.5c0 .49.19 3.2.4 6.37l.01.13c.27 3.96.59 8.54.59 9.75a5 5 0 0 1-10 0c0-1.09.25-5.21.5-8.98z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_48_color__b)",
            "d": "M10.61 4c-.64 0-1.26.46-1.36 1.18C9.1 6.12 8 13.67 8 17c0 2.2.95 4.17 2.45 5.54q1.05.98 1.05 1.85v.12c-.1 1.17-1 12.47-1 14.49a5 5 0 0 0 10 0 462 462 0 0 0-1-14.61q0-.87 1.05-1.85A7.5 7.5 0 0 0 23 17c0-3.33-1.1-10.88-1.25-11.82A1.4 1.4 0 0 0 20.4 4h-.02c-.8 0-1.37.65-1.37 1.37v10.51a1.12 1.12 0 1 1-2.24 0V5.32a1.26 1.26 0 1 0-2.52.05v10.51a1.12 1.12 0 1 1-2.24 0V5.37C12 4.65 11.43 4 10.63 4z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_48_color__a",
                "x1": "23.85",
                "x2": "57.91",
                "y1": "6.5",
                "y2": "17.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_48_color__b",
                "x1": "5.69",
                "x2": "41.66",
                "y1": "6.5",
                "y2": "19.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$662beb7947ae3a7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food48Filled', "48", [
    "M10.61 4c-.64 0-1.26.46-1.36 1.18C9.1 6.12 8 13.67 8 17c0 2.2.95 4.17 2.45 5.54q1.05.98 1.05 1.85v.12c-.1 1.17-1 12.47-1 14.49a5 5 0 0 0 10 0 462 462 0 0 0-1-14.61q0-.87 1.05-1.85A7.5 7.5 0 0 0 23 17c0-3.33-1.1-10.88-1.25-11.82A1.4 1.4 0 0 0 20.4 4h-.02c-.8 0-1.37.65-1.37 1.37v10.51a1.12 1.12 0 1 1-2.24 0V5.32a1.26 1.26 0 1 0-2.52.05v10.51a1.12 1.12 0 1 1-2.24 0V5.37C12 4.65 11.43 4 10.63 4zm20.3 20-.06.91-.35 5.1c-.25 3.78-.5 7.9-.5 8.99a5 5 0 0 0 10 0c0-1.2-.32-5.8-.59-9.75v-.13c-.22-3.17-.41-5.88-.41-6.37V5.25C39 4.56 38.44 4 37.75 4h-.5A11.25 11.25 0 0 0 26 15.25v5.5c0 1.8 1.46 3.25 3.25 3.25z"
]);
const $7972e53b1de568ed$export$e421092700e8ed71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food48Regular', "48", [
    "M7.98 6.73a3.26 3.26 0 0 1 5.34-1.96 3.5 3.5 0 0 1 4.36 0 3.28 3.28 0 0 1 5.34 1.96c.37 2.25.98 6.4.98 9.27 0 2.85-1.4 5.37-3.55 6.9-.64.47-.95 1.02-.95 1.5v.1c.1 1.09 1 12.47 1 14.5a5 5 0 0 1-10 0 464 464 0 0 1 1-14.6c0-.48-.31-1.03-.95-1.5A8.5 8.5 0 0 1 7 16c0-2.87.61-7.02.98-9.27M19 16.75a1.25 1.25 0 1 1-2.5 0V7.5a1 1 0 1 0-2 0v9.25a1.25 1.25 0 1 1-2.5 0V7.3a.8.8 0 0 0-.8-.8c-.38 0-.7.27-.75.63A65 65 0 0 0 9.5 16c0 2 .99 3.79 2.5 4.88A4.4 4.4 0 0 1 14 24.69C13.89 25.88 13 37.1 13 39a2.5 2.5 0 0 0 5 0 476 476 0 0 0-1-14.6c0-1.57.98-2.79 2-3.52A6 6 0 0 0 21.5 16c0-2.64-.57-6.6-.95-8.87a.76.76 0 0 0-.75-.63.8.8 0 0 0-.8.8zM36.5 6.53v16.22c0 .59.19 3.33.4 6.34v.2c.29 4.07.6 8.6.6 9.71a2.5 2.5 0 0 1-5 0c0-.98.25-4.99.5-8.82l.45-6.73.05-.61a1.25 1.25 0 0 0-1.25-1.34h-3a.75.75 0 0 1-.75-.75v-5.5a8.75 8.75 0 0 1 8-8.72M30.91 24l-.06.91-.35 5.1c-.25 3.78-.5 7.9-.5 8.99a5 5 0 0 0 10 0c0-1.2-.32-5.8-.59-9.75v-.13c-.22-3.17-.41-5.88-.41-6.37V5.25C39 4.56 38.44 4 37.75 4h-.5A11.25 11.25 0 0 0 26 15.25v5.5c0 1.8 1.46 3.25 3.25 3.25z"
]);
const $7972e53b1de568ed$export$d9efaa8f8ea0fe37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple20Filled', "20", [
    "M12.16 2.97a.5.5 0 1 0-.32-.94 3.2 3.2 0 0 0-1.86 1.9q-.08.17-.13.34A4 4 0 0 0 6.2 2.14c-.58.01-1.04.48-1.06 1.06A4 4 0 0 0 6.3 6.14l.03.03A4 4 0 0 0 3.2 9.76v.07a8.5 8.5 0 0 0 1 4.75l.36.66.03.05 1 1.4a2.7 2.7 0 0 0 4.09.34.46.46 0 0 1 .64 0 2.7 2.7 0 0 0 4.09-.34l1-1.4.03-.05.36-.66a8.5 8.5 0 0 0 1-4.75v-.07a4 4 0 0 0-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34m-5.25 6c-.27.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 0 1-.99.12c-.13-1.06 0-1.86.31-2.45.32-.6.8-.93 1.28-1.08a.5.5 0 0 1 .32.94"
]);
const $7972e53b1de568ed$export$33500dddbbc57a84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple20Regular', "20", [
    "M7.22 8.34a.5.5 0 0 1-.31.63c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 0 1-.99.12q-.17-1.58.31-2.45c.32-.6.8-.93 1.28-1.08a.5.5 0 0 1 .63.31m4.94-5.37a.5.5 0 1 0-.32-.94 3.2 3.2 0 0 0-1.86 1.9q-.08.17-.13.34A4 4 0 0 0 6.2 2.14c-.58.01-1.04.48-1.06 1.06a4 4 0 0 0 1.2 2.97A4 4 0 0 0 3.2 9.76v.07a8.5 8.5 0 0 0 1 4.75l.36.66.03.05 1 1.4a2.7 2.7 0 0 0 4.09.34.46.46 0 0 1 .64 0 2.7 2.7 0 0 0 4.09-.34l1-1.4.03-.05.36-.66a8.5 8.5 0 0 0 1-4.75v-.07a4 4 0 0 0-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34M8.72 6.28l-.16-.03a3 3 0 0 1-2.42-3.02q0-.08.09-.1a3 3 0 0 1 3.08 3.1q0 .07-.09.08-.25 0-.5-.03m-.33.96.17.03.78.13a4 4 0 0 0 1.32 0l1.66-.28a3 3 0 0 1 3.49 2.72v.07a7.5 7.5 0 0 1-.89 4.2l-.34.62-.99 1.38c-.6.85-1.82.95-2.56.21a1.46 1.46 0 0 0-2.06 0c-.74.74-1.96.64-2.56-.21l-.99-1.38-.34-.63a7.5 7.5 0 0 1-.9-4.19l.01-.07a3 3 0 0 1 3.49-2.72z"
]);
const $7972e53b1de568ed$export$1985304da9118b40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple24Filled', "24", [
    "M5.47 3.42A5.2 5.2 0 0 0 6.9 7.3a5.1 5.1 0 0 0-3.66 4.22c-.33 2.35.15 4.75 1.37 6.8l.35.58.04.07 1.42 1.9a3.46 3.46 0 0 0 5.28.34.44.44 0 0 1 .62 0 3.46 3.46 0 0 0 5.28-.34l1.42-1.9.04-.07.35-.59a10.5 10.5 0 0 0 1.37-6.8 5.1 5.1 0 0 0-6.1-4.3l-1.9.4h-.01a9 9 0 0 1 .39-2.34c.29-.87.7-1.4 1.14-1.58a.75.75 0 1 0-.58-1.38c-1.05.44-1.65 1.48-1.98 2.48l-.05.15a5.2 5.2 0 0 0-4.92-2.8c-.7.04-1.25.59-1.29 1.28m2.93 7.81c-.35.07-.67.32-.87.78-.2.48-.27 1.18-.05 2.06a.75.75 0 0 1-1.46.36 4.7 4.7 0 0 1 .13-3A2.7 2.7 0 0 1 8.1 9.75a.75.75 0 1 1 .3 1.47"
]);
const $7972e53b1de568ed$export$97a63929f7590163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple24Regular', "24", [
    "M8.4 11.23a.75.75 0 0 0-.3-1.47 2.7 2.7 0 0 0-1.95 1.66 4.7 4.7 0 0 0-.13 3.01.75.75 0 1 0 1.46-.36A3.3 3.3 0 0 1 7.53 12c.2-.46.52-.7.87-.78M5.47 3.42A5.2 5.2 0 0 0 6.9 7.3a5.1 5.1 0 0 0-3.66 4.22c-.33 2.35.15 4.75 1.37 6.8l.35.58.04.07 1.42 1.9a3.46 3.46 0 0 0 5.28.34.44.44 0 0 1 .62 0 3.46 3.46 0 0 0 5.28-.34l1.42-1.9.04-.07.35-.59a10.5 10.5 0 0 0 1.37-6.8 5.1 5.1 0 0 0-6.1-4.3l-1.9.4h-.01a9 9 0 0 1 .39-2.34c.29-.87.7-1.4 1.14-1.58a.75.75 0 1 0-.58-1.38c-1.05.44-1.65 1.48-1.98 2.48l-.05.15a5.2 5.2 0 0 0-4.92-2.8c-.7.04-1.25.59-1.29 1.28m1.5.2a3.7 3.7 0 0 1 3.79 3.8q-.28 0-.55-.03l-.61-.12a3.7 3.7 0 0 1-2.64-3.64m2.06 5.06.2.04q.37.1.73.15l.97.2q1.06.23 2.14 0l1.9-.39a3.6 3.6 0 0 1 4.32 3.04 9 9 0 0 1-1.18 5.83l-.33.55-1.4 1.88a1.96 1.96 0 0 1-2.98.19c-.77-.8-2.03-.8-2.8 0-.84.87-2.26.78-2.99-.2L6.22 18.1l-.33-.55a9 9 0 0 1-1.18-5.83 3.6 3.6 0 0 1 4.32-3.04"
]);
const $7972e53b1de568ed$export$84ba82e7d64d0f9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake12Filled', "12", [
    "M4.93 1.65c-.18.3-.29.64-.3.88-.02.43.04.85.3 1.16.28.33.68.44 1.07.44.4 0 .8-.12 1.07-.45.26-.32.33-.73.3-1.15a2 2 0 0 0-.3-.87C6.87 1.36 6.53 1 6 1s-.88.36-1.07.65M3.5 5C2.67 5 2 5.67 2 6.5l1.87 1.46q.13.1.3 0l1.1-.78c.44-.31 1.02-.31 1.46 0l1.1.79q.17.09.3 0L10 6.5V6.5C10 5.67 9.33 5 8.5 5zm5.25 3.75L10 7.77V10h.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H2V7.77l1.25.98c.44.34 1.05.35 1.5.03L5.85 8q.15-.09.3 0l1.1.8c.45.31 1.06.3 1.5-.04"
]);
const $7972e53b1de568ed$export$30f4c3f120b2a359 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake12Regular', "12", [
    "M6 1c-.53 0-.88.36-1.06.65s-.3.64-.3.88c-.03.43.03.85.3 1.16.27.33.67.44 1.06.44.4 0 .8-.12 1.07-.45.26-.32.33-.73.3-1.15a2 2 0 0 0-.3-.87C6.89 1.36 6.54 1 6 1m-.37 1.6c0-.07.05-.26.15-.42S5.97 2 6 2c.04 0 .12.02.22.19s.15.35.16.4c.02.3-.04.41-.08.45-.02.03-.1.09-.3.09-.22 0-.28-.06-.3-.08s-.08-.15-.07-.46M10 10V6.5C10 5.67 9.33 5 8.5 5h-5C2.67 5 2 5.67 2 6.5V10h-.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM3.5 6h5c.28 0 .5.22.5.5v.79l-.87.67a.3.3 0 0 1-.3 0l-1.1-.78c-.44-.31-1.02-.31-1.46 0l-1.1.79a.3.3 0 0 1-.3 0L3 7.28V6.5c0-.28.22-.5.5-.5M3 8.55l.25.2c.44.34 1.04.35 1.5.03L5.85 8q.15-.09.3 0l1.1.8c.45.31 1.06.3 1.5-.04l.25-.2V10H3z"
]);
const $7972e53b1de568ed$export$a7054ca0a73cffc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake16Filled', "16", [
    "M6.81 1.67C7.08 1.32 7.48 1 8 1s.92.32 1.19.67.45.81.5 1.26a2 2 0 0 1-.26 1.38Q8.97 4.99 8 5q-.97-.01-1.43-.7a2 2 0 0 1-.27-1.37c.06-.45.25-.9.51-1.26M2.03 7.65A2 2 0 0 1 4 6h8a2 2 0 0 1 1.99 1.8 31 31 0 0 1-1.43 1.32c-.43.37-.88.73-1.27 1q-.3.2-.53.3a1 1 0 0 1-.26.08c-.26 0-.43-.17-.82-.59C9.34 9.54 8.84 9 8 9s-1.34.54-1.68.9v.01c-.39.42-.56.59-.82.59l-.06-.01-.18-.07a4 4 0 0 1-.51-.3c-.4-.27-.85-.63-1.29-1A33 33 0 0 1 2.01 7.8zM2 9.15q.37.35.82.73c.44.38.93.77 1.37 1.07q.33.23.65.37.3.16.66.18c.73 0 1.2-.51 1.5-.84l.06-.07c.35-.39.58-.59.94-.59s.59.2.94.59l.06.07c.3.33.77.84 1.5.84q.36-.02.68-.17t.66-.38c.45-.3.93-.7 1.38-1.07l.78-.7V13h.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H2z"
]);
const $7972e53b1de568ed$export$eb060aa5e4e77ec0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake16Regular', "16", [
    "M6.81 1.67C7.08 1.32 7.48 1 8 1s.92.32 1.19.67.45.81.5 1.26a2 2 0 0 1-.26 1.38Q8.97 4.99 8 5q-.97-.01-1.43-.7a2 2 0 0 1-.27-1.37c.06-.45.25-.9.51-1.26m.6 2.08c.07.12.23.25.59.25s.52-.13.6-.25q.16-.22.1-.68c-.04-.3-.15-.6-.31-.8C8.23 2.05 8.09 2 8 2c-.08 0-.23.05-.39.27-.16.2-.27.5-.31.8q-.05.46.1.68M2 8c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5h.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H2zm1 5h10v-2.98l-.28.25a8 8 0 0 1-1.05.81c-.34.22-.76.42-1.17.42-.73 0-1.2-.51-1.5-.84l-.06-.07C8.6 10.2 8.36 10 8 10s-.59.2-.94.59l-.06.07c-.3.33-.77.84-1.5.84-.4 0-.8-.21-1.14-.42A9 9 0 0 1 3 10zm0-4.4a17 17 0 0 0 .97.92q.47.42.92.71.48.29.61.27c.26 0 .43-.17.82-.59C6.66 9.54 7.16 9 8 9s1.34.54 1.68.9v.01c.39.42.56.59.82.59q.17.02.64-.27t.92-.7A14 14 0 0 0 13 8.6V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z"
]);
const $7972e53b1de568ed$export$a80f4b193f8f067f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake20Filled', "20", [
    "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67s1.22-.2 1.6-.7c.37-.47.49-1.11.44-1.83a4 4 0 0 0-.47-1.43C11.28 2.55 10.77 2 10 2M3 9.78l3.2 2.94a1 1 0 0 0 1.43-.07l.86-.98a2 2 0 0 1 3 0l.86.98a1 1 0 0 0 1.43.07l3.2-2.94A2 2 0 0 0 15 8H5a2 2 0 0 0-1.99 1.79M17 11.14l-2.54 2.33a2 2 0 0 1-2.85-.15l-.86-.97a1 1 0 0 0-1.5 0l-.86.97a2 2 0 0 1-2.85.15L3 11.14V16h-.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H17z"
]);
const $7972e53b1de568ed$export$d2d274b534edd91c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake20Regular', "20", [
    "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67s1.22-.2 1.6-.7c.37-.47.49-1.11.44-1.83a4 4 0 0 0-.47-1.43C11.28 2.55 10.77 2 10 2M8.96 4.51c0-.2.11-.63.33-.99q.34-.55.7-.54.38-.01.72.55c.21.37.32.8.33.98.04.6-.07.96-.23 1.16-.14.18-.38.31-.81.31-.45 0-.69-.12-.82-.3-.15-.18-.26-.54-.22-1.17M5 8a2 2 0 0 0-2 2v6h-.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H17v-6a2 2 0 0 0-2-2zm11 8H4v-3.88l1.54 1.38a2 2 0 0 0 2.83-.16l.88-1a1 1 0 0 1 1.5 0l.88 1a2 2 0 0 0 2.83.16L16 12.12zm0-5.22-2.21 1.97a1 1 0 0 1-1.42-.08l-.87-.99a2 2 0 0 0-3 0l-.87 1a1 1 0 0 1-1.42.07L4 10.78V10a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"
]);
const $7972e53b1de568ed$export$e490e45c9e31e260 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake24Filled', "24", [
    "M12 7c1.71 0 2-1.34 2-2.44s-.74-3.06-2-3.06-2 1.95-2 3.06c0 1.1.29 2.44 2 2.44m-8.5 3.25C3.5 9.01 4.5 8 5.75 8h12.5c1.24 0 2.25 1 2.25 2.25v.88l-3.63 2.72c-.4.3-.95.33-1.39.08l-2.04-1.2c-.9-.53-2-.5-2.88.06L8.8 13.92c-.41.27-.94.27-1.35 0L3.5 11.42zm0 2.94v5.31h-.75a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-.75V13l-2.73 2.05c-.9.67-2.1.73-3.05.17l-2.04-1.2c-.4-.24-.91-.23-1.3.03L9.6 15.18c-.9.59-2.06.59-2.97.01z"
]);
const $7972e53b1de568ed$export$f2915d7ee88f5794 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake24Regular', "24", [
    "M12 1c-.95 0-1.59.68-1.94 1.28a4 4 0 0 0-.56 1.97c0 .5.06 1.17.43 1.75.41.63 1.1 1 2.07 1s1.66-.37 2.07-1c.37-.58.43-1.26.43-1.75 0-.6-.2-1.35-.56-1.97C13.59 1.68 12.95 1 12 1m-1 3.25c0-.3.12-.8.36-1.21.25-.42.49-.54.64-.54s.4.12.64.54c.24.4.36.9.36 1.21q0 .62-.2.93c-.08.14-.26.32-.8.32s-.72-.18-.8-.32q-.2-.3-.2-.93m9.5 6v8.25h.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.75v-8.25C3.5 9.01 4.5 8 5.75 8h12.5c1.24 0 2.25 1 2.25 2.25m-15.5 0v2.1l2.45 1.57c.41.27.94.27 1.35 0l1.75-1.13c.88-.56 2-.58 2.9-.05l2 1.2c.43.25.96.23 1.37-.05L19 12.36v-2.11a.75.75 0 0 0-.75-.75H5.75a.75.75 0 0 0-.75.75m12.68 4.87c-.89.62-2.06.67-2.99.11l-2-1.2c-.42-.24-.93-.23-1.33.02l-1.74 1.13c-.91.59-2.08.59-2.99 0L5 14.13v4.37h14v-4.3z"
]);
const $7972e53b1de568ed$export$4f4e7636db9fce98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot20Filled', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14 5.29V2.5a.5.5 0 1 0-1 0v2.88a3.66 3.66 0 0 0-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.42.62 2.05.18l8.93-6.18A3.6 3.6 0 0 0 14.63 7h2.87a.5.5 0 1 0 0-1h-2.8z"
]);
const $7972e53b1de568ed$export$30f4d315bde87163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot20Regular', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14 5.29V2.5a.5.5 0 0 0-1 0v2.88a3.66 3.66 0 0 0-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.41.62 2.05.18l8.93-6.18A3.6 3.6 0 0 0 14.63 7h2.87a.5.5 0 0 0 0-1h-2.8zM9.2 7.14a2.64 2.64 0 0 1 4.04-.39 2.58 2.58 0 0 1-.35 3.96L3.95 16.9a.6.6 0 0 1-.77-.07.6.6 0 0 1-.07-.75z"
]);
const $7972e53b1de568ed$export$4bcebf1203eec024 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot24Filled', "24", [
    "M17.5 2.75a.75.75 0 0 0-1.5 0v4.01a4.56 4.56 0 0 0-6.3 1.22l-7.35 10.8c-.55.82-.45 1.92.26 2.61.71.71 1.84.8 2.67.23l10.78-7.46A4.45 4.45 0 0 0 17.24 8h4.01a.75.75 0 0 0 0-1.5h-2.69l3.22-3.22a.75.75 0 0 0-1.06-1.06L17.5 5.44z"
]);
const $7972e53b1de568ed$export$3714d4e420052403 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot24Regular', "24", [
    "M17.5 2.75a.75.75 0 0 0-1.5 0v4.01a4.56 4.56 0 0 0-6.3 1.22l-7.34 10.8c-.56.82-.45 1.92.25 2.61.71.71 1.84.8 2.67.23l10.79-7.46A4.45 4.45 0 0 0 17.24 8h4.01a.75.75 0 0 0 0-1.5h-2.69l3.22-3.22a.75.75 0 0 0-1.06-1.06L17.5 5.44zm-6.54 6.06a3.04 3.04 0 0 1 4.65-.44 2.97 2.97 0 0 1-.4 4.56L4.4 20.4a.6.6 0 0 1-.73-.06.56.56 0 0 1-.07-.72z"
]);
const $7972e53b1de568ed$export$4157042fade15b66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg16Filled', "16", [
    "M15 5a4 4 0 0 0-7.94-.68q-.3.93-.54 1.45L4.15 8.15A.5.5 0 0 0 4.5 9h.08l-1.49 1.48h-.01L3 10.5a2 2 0 0 0-1.22 3.59q.08.05.13.13A2 2 0 0 0 5.5 13l.01-.08v-.01L7 11.43v.07a.5.5 0 0 0 .85.35l2.36-2.35q.55-.26 1.56-.57A4 4 0 0 0 15 5M5.99 9H7v1.01l-2.2 2.2c-.23.23-.3.54-.3.79a1 1 0 0 1-1.8.6q-.14-.16-.3-.3a1 1 0 0 1 .6-1.8c.25 0 .56-.07.8-.3z"
]);
const $7972e53b1de568ed$export$88f77685a030330 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg16Regular', "16", [
    "M15 5a4 4 0 0 0-7.94-.68q-.3.93-.54 1.45L4.15 8.15A.5.5 0 0 0 4.5 9h.08l-1.49 1.48h-.01L3 10.5a2 2 0 0 0-1.22 3.59q.08.05.13.13A2 2 0 0 0 5.5 13l.01-.08v-.01L7 11.43v.07a.5.5 0 0 0 .85.35l2.36-2.35q.55-.26 1.56-.57A4 4 0 0 0 15 5m-8 5.01-2.2 2.2c-.23.23-.3.54-.3.79a1 1 0 0 1-1.8.6q-.14-.16-.3-.3a1 1 0 0 1 .6-1.8c.25 0 .56-.07.8-.3L5.99 9H7zM11 2a3 3 0 0 1 .5 5.96q-1.16.36-1.79.67l-.14.1L8 10.29V8.5a.5.5 0 0 0-.5-.5H5.7l1.6-1.59.1-.14a14 14 0 0 0 .64-1.75A3 3 0 0 1 11 2"
]);
const $7972e53b1de568ed$export$5d15dae821440c7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg20Filled', "20", [
    "M18 7a5 5 0 0 0-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 0 0 .35.85h.39l-2 2a2 2 0 0 0-1.15 3.55q.12.09.2.21A2 2 0 0 0 6.5 16.1l2-2v.4a.5.5 0 0 0 .85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A5 5 0 0 0 18 7M7.3 11.5h1.2v1.19l-2.78 2.78a.8.8 0 0 0-.22.53 1 1 0 0 1-1.78.63q-.15-.2-.35-.35A1 1 0 0 1 4 14.5q.29 0 .51-.21z"
]);
const $7972e53b1de568ed$export$15c05b9cc35ede65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg20Regular', "20", [
    "M18 7a5 5 0 0 0-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 0 0 .35.85h.39l-2 2a2 2 0 0 0-1.15 3.55q.12.09.2.21A2 2 0 0 0 6.5 16.1l2-2v.4a.5.5 0 0 0 .85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A5 5 0 0 0 18 7m-9.5 5.69-2.78 2.78a.8.8 0 0 0-.22.53 1 1 0 0 1-1.78.63q-.15-.2-.35-.35A1 1 0 0 1 4 14.5q.29 0 .51-.21l2.8-2.79H8.5zM13 3a4 4 0 0 1 1.37 7.76l-.05.02a4 4 0 0 1-.64.16 12 12 0 0 0-3.12 1.3L9.5 13.28v-2.23a.5.5 0 0 0-.15-.35l-.06-.06a.5.5 0 0 0-.35-.15H6.71l1.07-1.07.07-.09a12 12 0 0 0 1.2-3.01 4 4 0 0 1 .24-.82A4 4 0 0 1 13 3"
]);
const $7972e53b1de568ed$export$52b302f6c10681af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg24Filled', "24", [
    "M22 8a6 6 0 0 0-11.9-1.1 15 15 0 0 1-1.36 3.3l-2.52 2.52a.75.75 0 0 0 .28 1.24L4.46 16a2.5 2.5 0 0 0-1.42 4.53q.25.18.43.43A2.5 2.5 0 0 0 8 19.53l2.04-2.04a.75.75 0 0 0 1.24.29l2.52-2.52c.48-.29 1.48-.8 3.32-1.36A6 6 0 0 0 22 8M8.58 14H10v1.41l-3.12 3.12c-.29.3-.38.67-.38.97a1 1 0 0 1-1.81.58q-.33-.45-.77-.77a1 1 0 0 1 .58-1.81c.3 0 .67-.09.96-.38z"
]);
const $7972e53b1de568ed$export$6d2d62107ebb3957 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg24Regular', "24", [
    "M22 8a6 6 0 0 0-11.9-1.1 15 15 0 0 1-1.36 3.3l-2.52 2.52a.75.75 0 0 0 .28 1.24L4.46 16a2.5 2.5 0 0 0-1.42 4.53q.25.18.43.43A2.5 2.5 0 0 0 8 19.53l2.04-2.04a.75.75 0 0 0 1.24.29l2.52-2.52c.48-.29 1.48-.8 3.32-1.36A6 6 0 0 0 22 8m-12 7.41-3.12 3.12c-.29.3-.38.67-.38.97a1 1 0 0 1-1.81.58q-.33-.45-.77-.77a1 1 0 0 1 .58-1.81c.3 0 .67-.09.96-.38L8.58 14H10zM16 3.5a4.5 4.5 0 0 1 .72 8.95 16 16 0 0 0-3.91 1.68l-1.31 1.3v-2.18a.75.75 0 0 0-.75-.75H8.56l1.3-1.3.1-.13a16 16 0 0 0 1.61-3.87A4.5 4.5 0 0 1 16 3.5"
]);
const $7972e53b1de568ed$export$34780e512626054 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg32Filled', "32", [
    "M30 10.5a8.5 8.5 0 0 0-16.86-1.53 21 21 0 0 1-1.86 4.34l-3.99 3.98A1 1 0 0 0 8 19h.1l-3.02 3.02a3.5 3.5 0 0 0-1.71 6.26q.2.15.36.36a3.5 3.5 0 0 0 6.25-1.74L13 23.88V24a1 1 0 0 0 1.7.7l4-3.98c.65-.4 1.99-1.09 4.37-1.86A8.5 8.5 0 0 0 30 10.5M10.94 19H13v2.05l-4.68 4.68q-.32.33-.32.77a1.5 1.5 0 0 1-2.69.92 4 4 0 0 0-.73-.73A1.5 1.5 0 0 1 5.5 24q.44 0 .75-.31z"
]);
const $7972e53b1de568ed$export$39a67631f79f7dbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg32Regular', "32", [
    "M30 10.5a8.5 8.5 0 0 0-16.86-1.53 21 21 0 0 1-1.86 4.34l-3.99 3.98A1 1 0 0 0 8 19h.1l-3.02 3.02a3.5 3.5 0 0 0-1.71 6.26q.2.15.36.36a3.5 3.5 0 0 0 6.25-1.74L13 23.88V24a1 1 0 0 0 1.7.7l4-3.98c.65-.4 1.99-1.09 4.37-1.86A8.5 8.5 0 0 0 30 10.5M13 21.05l-4.68 4.68q-.32.33-.32.77a1.5 1.5 0 0 1-2.69.92 4 4 0 0 0-.73-.73A1.5 1.5 0 0 1 5.5 24q.44 0 .75-.31L10.94 19H13zM21.5 4a6.5 6.5 0 0 1 1.01 12.93c-2.67.87-4.19 1.67-4.97 2.15l-.18.14L15 21.6V18a1 1 0 0 0-1-1h-3.59l2.36-2.36.14-.18a23 23 0 0 0 2.19-5.08A6.5 6.5 0 0 1 21.5 4"
]);
const $7972e53b1de568ed$export$cddbeef1db13636e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg16Filled', "16", [
    "M7.7 8.22a1 1 0 0 1 .2-.37l.11-.07a.5.5 0 0 0 .19-.99c-.4-.08-.76.13-.98.33q-.38.35-.5.9a.5.5 0 1 0 .97.2M3.51 5.83c-1.79 1.42-1.83 3.84-1 5.46a3.6 3.6 0 0 0 3.28 2.07l.92-.02c.69-.03.82-.04 1.78.35 1.28.52 2.65.37 3.79-.35 1.03-.65 1.62-2.15 1.52-3.37-.06-.65 0-.91.07-1.21.05-.27.12-.56.12-1.18 0-1.32-.39-2.16-.78-2.84a5.3 5.3 0 0 0-2.01-2.13 4.5 4.5 0 0 0-4.33-.11A5.3 5.3 0 0 0 4.6 4.74c-.24.41-.48.61-1.08 1.09M11.6 8.3a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0"
]);
const $7972e53b1de568ed$export$b764d83fa48211bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg16Regular', "16", [
    "M7.7 8.22a1 1 0 0 1 .2-.36l.11-.08a.5.5 0 0 0 .19-.99c-.4-.08-.76.13-.98.34q-.38.34-.5.88a.5.5 0 1 0 .97.21m.6 3.38a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6m0-1a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6M9.2 2c.79.06 1.53.29 2.07.63a5.4 5.4 0 0 1 2.02 2.12c.39.67.79 1.53.79 2.85 0 .62-.07.93-.13 1.2v.04c-.05.21-.1.4-.05.91a4 4 0 0 1-.35 1.98c-.27.62-.7 1.2-1.28 1.57-1.19.74-2.62.9-3.96.37-.59-.24-.77-.29-.97-.3h-.47L6 13.4a3.8 3.8 0 0 1-3.46-2.16C1.68 9.6 1.7 7.1 3.59 5.61a3 3 0 0 0 .88-.87q.44-.76.98-1.29.54-.52 1.3-.94a4.5 4.5 0 0 1 2.45-.5m-.06 1a3.5 3.5 0 0 0-1.9.39c-.47.26-.8.5-1.09.77-.28.28-.53.62-.82 1.1-.28.46-.57.7-1.12 1.13-1.41 1.12-1.48 3.04-.79 4.38.46.88 1.31 1.62 2.58 1.62q.53 0 .83-.02h.57c.38.02.7.13 1.29.37 1.03.4 2.12.29 3.05-.29q.55-.37.9-1.12c.2-.49.3-1.03.26-1.5-.05-.61 0-.9.07-1.2v-.06a4.37 4.37 0 0 0-.55-3.32 4.4 4.4 0 0 0-1.69-1.78A3.5 3.5 0 0 0 9.13 3"
]);
const $7972e53b1de568ed$export$b93311058e1a4520 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg20Filled', "20", [
    "M10.47 9.6a.5.5 0 0 0 .14-.98 2.14 2.14 0 0 0-2.35 2.16.5.5 0 0 0 1 0c0-.8.7-1.24 1.2-1.17M3.99 7.14c-2.41 1.91-2.48 5.15-1.34 7.32a4.9 4.9 0 0 0 4.42 2.77q.8 0 1.24-.03c.94-.03 1.11-.04 2.42.48a5.6 5.6 0 0 0 5.12-.47c1.39-.87 2.19-2.88 2.05-4.52-.08-.98 0-1.36.09-1.86.06-.33.13-.7.17-1.34a7 7 0 0 0-1.05-3.81 7.6 7.6 0 0 0-2.72-2.85 6.2 6.2 0 0 0-5.86-.15 7 7 0 0 0-3.07 3 5 5 0 0 1-1.47 1.46m10.91 3.34a4.5 4.5 0 1 1-8.99 0 4.5 4.5 0 0 1 8.99 0"
]);
const $7972e53b1de568ed$export$dace4b19db3eee6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg20Regular', "20", [
    "M10.06 9.58a.5.5 0 1 0 .14-1c-.94-.12-1.78.6-1.78 1.64a.5.5 0 0 0 1 0c0-.46.32-.68.64-.64m.35 5.38a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9m0-1a3.5 3.5 0 1 1 0-6.99 3.5 3.5 0 0 1 0 7m1.22-11.89c1.04.07 2.02.38 2.72.83a7.6 7.6 0 0 1 2.7 2.83 7 7 0 0 1 1.05 3.82 10 10 0 0 1-.21 1.53c-.06.32-.1.66-.04 1.38.07.85-.1 1.78-.46 2.6a4.5 4.5 0 0 1-1.68 2.07 5.7 5.7 0 0 1-5.22.48c-.8-.33-1.08-.4-1.38-.42h-.65q-.43.03-1.18.03a5 5 0 0 1-4.56-2.84C1.59 12.2 1.62 8.9 4.1 6.94c.75-.6.98-.8 1.24-1.22.42-.7.82-1.25 1.3-1.73A8 8 0 0 1 8.4 2.74a6 6 0 0 1 3.23-.67m-.07 1c-.9-.06-1.85.1-2.68.55a7 7 0 0 0-1.53 1.09c-.4.39-.75.86-1.14 1.52-.37.6-.73.9-1.49 1.5-2 1.59-2.1 4.31-1.11 6.19a4 4 0 0 0 3.67 2.3l1.14-.02h.02q.4-.02.73 0c.48.02.89.16 1.7.48 1.46.58 3 .41 4.31-.4.54-.34 1-.92 1.3-1.61s.43-1.46.38-2.13a6 6 0 0 1 .08-1.87c.06-.3.12-.63.16-1.19a6 6 0 0 0-.91-3.26 6.6 6.6 0 0 0-2.37-2.48 5 5 0 0 0-2.26-.67"
]);
const $7972e53b1de568ed$export$b16bea3d3913ad3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg24Filled', "24", [
    "M11.5 12.25c0-.41.34-.75.75-.75a.75.75 0 0 0 0-1.5C11.01 10 10 11 10 12.25a.75.75 0 0 0 1.5 0M13.5 2a8.4 8.4 0 0 0-7.29 4.5q-.37.65-1.05 1.1A7.4 7.4 0 0 0 2 13.76C2 17.7 4.97 21 8.75 21q.48 0 .95-.07c.87-.13 1.8 0 2.57.38q1.36.67 2.98.69a6.75 6.75 0 0 0 6.64-7.98 3 3 0 0 1-.03-1.08q.15-.81.14-1.66C22 6.22 18.26 2 13.5 2m3.75 10.5a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0"
]);
const $7972e53b1de568ed$export$fd6cb36ad22ee65a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg24Regular', "24", [
    "M11.5 12.25c0-.41.34-.75.75-.75a.75.75 0 0 0 0-1.5C11.01 10 10 11 10 12.25a.75.75 0 0 0 1.5 0M7 12.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m5.5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.29-2A8.4 8.4 0 0 1 13.5 2c4.76 0 8.5 4.22 8.5 9.28q0 .85-.14 1.66-.07.51.03 1.08.1.6.11 1.23a6.75 6.75 0 0 1-9.73 6.06 4.4 4.4 0 0 0-2.57-.38q-.46.07-.95.07C4.97 21 2 17.7 2 13.75a7.4 7.4 0 0 1 3.16-6.14q.68-.46 1.05-1.12m7.29-3a6.9 6.9 0 0 0-5.97 3.72A5 5 0 0 1 6 8.85a5.9 5.9 0 0 0-2.5 4.9c0 3.23 2.4 5.75 5.25 5.75q.38 0 .73-.05a6 6 0 0 1 3.45.51q1.06.53 2.32.54a5.25 5.25 0 0 0 5.16-6.21 5 5 0 0 1-.03-1.6q.12-.69.12-1.41c0-4.37-3.2-7.78-7-7.78"
]);
const $7972e53b1de568ed$export$82d59b9aedd30fa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish20Filled', "20", [
    "M8.63 3.7c-1.5 1.5-1.76 3.87-1.72 5.67a.4.4 0 0 1-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52q.53.15.9.33.38.18.5.3.14.13.31.5.18.4.33.91c.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 0 1 .4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25s.17-2.37.08-3.32a3 3 0 0 0-2.73-2.73 13 13 0 0 0-3.32.08c-1.17.2-2.35.65-3.25 1.54m4.62.8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $7972e53b1de568ed$export$7e9f4b46b75cbe1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish20Regular', "20", [
    "M7.91 9.35c-.04-1.76.24-3.76 1.43-4.95.7-.7 1.66-1.08 2.72-1.26a12 12 0 0 1 3.05-.07c.98.09 1.73.84 1.82 1.82.09.9.11 2-.07 3.06a5 5 0 0 1-1.26 2.71c-1.19 1.2-3.19 1.47-4.95 1.43a1.4 1.4 0 0 0-1.43 1.3c-.1 1.47-.4 3.17-1.11 4.52q-.06.09-.08.09h-.06q-.12-.03-.2-.25c-.13-.7-.3-1.54-.53-2.28a8 8 0 0 0-.38-1.03q-.2-.46-.5-.8-.33-.3-.8-.5-.46-.21-1.03-.38c-.74-.22-1.57-.4-2.28-.54-.16-.03-.23-.13-.25-.2v-.06q0-.01.09-.07a12 12 0 0 1 4.52-1.11 1.4 1.4 0 0 0 1.3-1.43m.72-5.66c-1.5 1.5-1.76 3.88-1.72 5.68a.4.4 0 0 1-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52q.53.15.9.33.38.18.5.3.14.13.31.5.18.4.33.91c.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 0 1 .4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25s.17-2.37.08-3.32a3 3 0 0 0-2.73-2.73 13 13 0 0 0-3.32.08c-1.17.2-2.35.65-3.25 1.54m4.62.8a.75.75 0 1 1 0 1.51.75.75 0 0 1 0-1.5"
]);
const $7972e53b1de568ed$export$51cfa87b42084916 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish24Filled', "24", [
    "M10.36 4.1c-1 1-1.58 2.34-1.91 3.68A17 17 0 0 0 8 11.73c0 .17-.14.32-.32.32-1.77 0-4.01.22-5.83 1.09-.68.32-.97 1-.82 1.63.13.6.61 1.09 1.26 1.25.8.19 1.72.44 2.52.72q.6.23 1.05.44.45.23.58.37.15.14.37.58.23.44.44 1.05c.28.8.53 1.72.72 2.52.16.65.65 1.13 1.25 1.26.64.14 1.3-.14 1.63-.82.87-1.82 1.08-4.06 1.1-5.82 0-.18.14-.33.32-.33 1.2 0 2.6-.1 3.95-.43a8 8 0 0 0 3.67-1.91 7.4 7.4 0 0 0 1.92-4.06c.25-1.45.2-2.92.1-4.09a3.8 3.8 0 0 0-3.41-3.4 16 16 0 0 0-4.1.09 7.4 7.4 0 0 0-4.05 1.91M16 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $7972e53b1de568ed$export$4cb8c67b91971787 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish24Regular', "24", [
    "M9.51 11.72c0-1.13.1-2.4.4-3.58a6.3 6.3 0 0 1 1.5-2.98 6 6 0 0 1 3.26-1.5 14 14 0 0 1 3.69-.08c1.1.11 1.95.96 2.06 2.07.1 1.09.14 2.42-.08 3.69a6 6 0 0 1-1.5 3.25 6.3 6.3 0 0 1-2.97 1.52c-1.19.3-2.46.38-3.6.38-1 0-1.81.82-1.82 1.82 0 1.7-.22 3.66-.93 5.17a.3.3 0 0 1-.08-.14c-.2-.82-.46-1.8-.77-2.66q-.23-.67-.5-1.22c-.18-.36-.4-.71-.66-.97a4 4 0 0 0-.97-.65q-.55-.29-1.22-.5c-.87-.32-1.85-.58-2.66-.78a.3.3 0 0 1-.14-.08c1.51-.71 3.48-.92 5.18-.93 1 0 1.82-.82 1.81-1.83m.85-7.62c-1 1-1.58 2.34-1.91 3.68A17 17 0 0 0 8 11.73c0 .17-.14.32-.32.32-1.77 0-4.01.22-5.83 1.09-.68.32-.97 1-.82 1.63.13.6.61 1.09 1.26 1.25.8.19 1.72.44 2.52.72q.6.23 1.05.44.45.23.58.37.15.14.37.58.23.44.44 1.05c.28.8.53 1.72.72 2.52.16.65.65 1.13 1.25 1.26.64.14 1.3-.14 1.63-.82.87-1.82 1.08-4.06 1.1-5.82 0-.18.14-.33.32-.33 1.2 0 2.6-.1 3.95-.43a8 8 0 0 0 3.67-1.91 7.4 7.4 0 0 0 1.92-4.06c.25-1.45.2-2.92.1-4.09a3.8 3.8 0 0 0-3.41-3.4 16 16 0 0 0-4.1.09 7.4 7.4 0 0 0-4.05 1.91M16 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $7972e53b1de568ed$export$342253f3e7924c4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains20Filled', "20", [
    "M10.43 2.21a.65.65 0 0 0-.86 0 5.7 5.7 0 0 0-1.92 4.35q0 .28.24.43A7 7 0 0 1 9.63 8.4a.5.5 0 0 0 .74 0 7 7 0 0 1 1.74-1.42.5.5 0 0 0 .24-.43c.02-1.59-.62-3.2-1.92-4.35m-7.41 10a.66.66 0 0 1 .6-.72A6.4 6.4 0 0 1 10 15.33a6.4 6.4 0 0 1 6.38-3.84c.36.03.64.35.6.72A6.37 6.37 0 0 1 10.64 18h-.46q-.1 0-.18-.02l-.18.02h-.46a6.37 6.37 0 0 1-6.34-5.8M10 10.83a6.4 6.4 0 0 0-6.38-3.84.66.66 0 0 0-.6.72q.13 1.36.76 2.5a.5.5 0 0 0 .43.26c2.1.01 4.03.92 5.37 2.39q.18.18.42.16a.5.5 0 0 0 .42-.16 7.4 7.4 0 0 1 5.36-2.4.5.5 0 0 0 .44-.25q.63-1.14.76-2.5a.66.66 0 0 0-.6-.72A6.4 6.4 0 0 0 10 10.83"
]);
const $7972e53b1de568ed$export$aa97ea1e409a5b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains20Regular', "20", [
    "M10.43 2.21a.65.65 0 0 0-.86 0 5.7 5.7 0 0 0-1.74 5.74 7 7 0 0 0-4.2-.96.66.66 0 0 0-.61.72 7 7 0 0 0 1.65 3.77q-.53-.03-1.05 0a.66.66 0 0 0-.6.73A6.37 6.37 0 0 0 9.36 18h1.28c3.3 0 6.04-2.51 6.34-5.8a.66.66 0 0 0-.6-.71q-.53-.04-1.05-.01a7 7 0 0 0 1.65-3.77.66.66 0 0 0-.6-.72 7 7 0 0 0-4.21.96c.52-2-.06-4.24-1.74-5.74M10 14.43a7 7 0 0 0-3.47-2.6 6.2 6.2 0 0 1-2.47-3.86c1.54-.05 3 .5 4.12 1.45.76.64.96 1.23 1.15 1.76l.22.54a.5.5 0 0 0 .9 0l.22-.54c.18-.53.4-1.12 1.15-1.76a6 6 0 0 1 4.12-1.45 6.2 6.2 0 0 1-2.5 3.9A7 7 0 0 0 10 14.42M9.36 17a5.4 5.4 0 0 1-5.3-4.53 6.1 6.1 0 0 1 5.5 3.13.5.5 0 0 0 .88 0 6.1 6.1 0 0 1 5.5-3.13 5.4 5.4 0 0 1-5.3 4.53zM10 9.82a4.74 4.74 0 0 1 0-6.64 4.74 4.74 0 0 1 0 6.64"
]);
const $7972e53b1de568ed$export$4b3679628877c6ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains24Filled', "24", [
    "M12.61 2.29a.93.93 0 0 0-1.22 0A7.2 7.2 0 0 0 8.9 7.57q.01.3.28.45a9 9 0 0 1 2.4 1.83c.23.24.62.24.84 0q.3-.36.7-.69a9 9 0 0 1 1.7-1.14.5.5 0 0 0 .28-.45 7.2 7.2 0 0 0-2.49-5.28m-.6 15.75a8.2 8.2 0 0 1 8.16-4.06c.49.07.85.5.81 1A7.6 7.6 0 0 1 13.41 22H10.6a7.6 7.6 0 0 1-7.57-7.01.94.94 0 0 1 .81-1A8.2 8.2 0 0 1 12 18.03m7.64-5.11a10 10 0 0 0-5.13 1.16 9 9 0 0 0-2.32 1.78c-.1.11-.3.11-.4 0a9 9 0 0 0-2.32-1.78 10 10 0 0 0-5.11-1.16 9 9 0 0 1-1.35-3.8.96.96 0 0 1 .87-1.04c2.46-.2 4.5.28 6.35 1.84.82.7 1.38 1.54 1.76 2.26.38-.72.94-1.56 1.77-2.26 1.84-1.56 3.9-2.04 6.35-1.84.53.04.93.5.88 1.04a9 9 0 0 1-1.35 3.8"
]);
const $7972e53b1de568ed$export$61ddd807022b6034 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains24Regular', "24", [
    "M11.39 2.29a7.2 7.2 0 0 0-2.37 6.78 8.5 8.5 0 0 0-5.13-.98.96.96 0 0 0-.87 1.04 9 9 0 0 0 2.06 4.78q-.62 0-1.25.07c-.5.07-.85.5-.81 1A7.6 7.6 0 0 0 10.59 22h2.82a7.6 7.6 0 0 0 7.57-7.01.94.94 0 0 0-.81-1 9 9 0 0 0-1.23-.08A9 9 0 0 0 21 9.13a.96.96 0 0 0-.88-1.04 8.6 8.6 0 0 0-5.14.98A7.2 7.2 0 0 0 12.6 2.3a.93.93 0 0 0-1.22 0m.61 9.44a5.74 5.74 0 0 1 0-7.96 5.74 5.74 0 0 1 0 7.96m0 5.6a9 9 0 0 0-4.23-2.97l-.1-.09a7.8 7.8 0 0 1-3.08-4.72 6.4 6.4 0 0 1 4.67 1.52c1.03.87 1.48 1.93 1.82 2.72l.25.55a.75.75 0 0 0 1.34 0l.25-.55a7 7 0 0 1 1.81-2.72 6.5 6.5 0 0 1 4.7-1.52 7.8 7.8 0 0 1-3.17 4.8A9 9 0 0 0 12 17.33m.64 1.71c1.4-2.33 4-3.78 6.78-3.62a6.1 6.1 0 0 1-6.01 5.08h-2.82a6.1 6.1 0 0 1-6.01-5.08 7.5 7.5 0 0 1 6.78 3.62.75.75 0 0 0 1.28 0"
]);
const $7972e53b1de568ed$export$977e3cce023b9979 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza20Filled', "20", [
    "M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86l-.25.19-.4-.44V9.3A16.4 16.4 0 0 0 4.88 4.5H4zM4 5.5V16.5a1.5 1.5 0 0 0 2.4 1.2L8 16.5a1 1 0 0 0 2 0v-2a.5.5 0 0 1 1-.06V15a1 1 0 0 0 2 0v-2.24c.82-.6 2.09-1.56 3.19-2.4l-.33-.37A15.4 15.4 0 0 0 4.87 5.5zm4.25 2.74a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.97 2a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-2.96 2.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $7972e53b1de568ed$export$9c3290e2ac5743b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza20Regular', "20", [
    "M7.5 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.72 1.26a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86-1.24.95-3.12 2.4-4.23 3.2v1.74c0 .72-.55 1.5-1.5 1.5q-.27 0-.5-.08v.09c0 .7-.55 1.49-1.5 1.49-.75 0-1.25-.5-1.42-1.05L6.4 17.7A1.5 1.5 0 0 1 4 16.5zm7 10.54c0 .26.2.5.5.5s.5-.24.5-.5v-2a.5.5 0 0 1 .21-.4c.78-.56 2.1-1.57 3.28-2.47A15.4 15.4 0 0 0 5 5.51V16.5c0 .41.47.64.8.4l2.4-1.8a.5.5 0 0 1 .8.4v.5c0 .25.2.5.5.5a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 1 1 0m5.62-5.73c.46-.36.5-1 .12-1.36-2.86-2.72-6.52-4.15-10.77-4.4a.93.93 0 0 0-.97.95v.55c4.33.04 8.4 1.7 11.3 4.5z"
]);
const $7972e53b1de568ed$export$36bca581e0958eac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza24Filled', "24", [
    "M5 4.66a2.6 2.6 0 0 1 2.82-2.65 20.8 20.8 0 0 1 13.45 6.83 2.6 2.6 0 0 1-.48 3.85l-.43.3-.36-.54A17.6 17.6 0 0 0 5.74 5.16H5zm13.77 8.65.38.56-3.95 2.87-.2.15v2.1a1 1 0 0 1-2 0v-.06a.5.5 0 0 0-1 .06v1.5a1 1 0 0 1-2 .1l-1.43 1.04A2.25 2.25 0 0 1 5 19.81V6.67h.75c5.36 0 10.1 2.61 13.02 6.64M9 10.99a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$b0dee51b6d8c7449 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza24Regular', "24", [
    "M9 10.99a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 4.66a2.6 2.6 0 0 1 2.82-2.65 20.8 20.8 0 0 1 13.44 6.83 2.6 2.6 0 0 1-.48 3.85l-5.28 3.83v1.72a1.75 1.75 0 0 1-2.06 1.72c-.2.83-.93 1.53-1.94 1.53-.7 0-1.26-.34-1.61-.82l-1.33.96A2.25 2.25 0 0 1 5 19.81zm2.67-1.15c-.6-.06-1.17.44-1.17 1.15v.52c5.25.22 9.91 2.75 12.98 6.6l.42-.3c.58-.43.65-1.18.25-1.64A19.3 19.3 0 0 0 7.66 3.51M6.5 19.8c0 .6.69.96 1.19.6.72-.52 1.5-1.07 2.12-1.53a.75.75 0 0 1 1.2.6c0 .28.2.5.49.5.3 0 .5-.22.5-.5v-1.24a.75.75 0 0 1 1.5 0q.02.23.25.25.23-.02.25-.25v-2.12q.01-.36.31-.6l3.96-2.86A16 16 0 0 0 6.5 6.68z"
]);
const $7972e53b1de568ed$export$ba6c4701a2449225 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast16Filled', "16", [
    "M4.85 6.5c0-.28.22-.5.5-.5h3.2c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3.2a.5.5 0 0 1-.5-.5zm1 2.5h2.2V7h-2.2zM1.27 4.01A3.3 3.3 0 0 1 4.2 2H12c1.44 0 3 1.19 3 3 0 1.06-.6 1.95-1 2.4-.01.55.01 1.28.04 2.06v.23c.03.8.06 1.62.06 2.31 0 .64-.06 1.24-.5 1.61-.2.2-.46.28-.72.33q-.4.07-.88.06H4q-1.4-.01-1.87-.8A2 2 0 0 1 1.9 12V7.42a3 3 0 0 1-.63-3.4M4.2 3c-.87 0-1.66.6-2.02 1.41-.35.8-.26 1.72.54 2.4q.18.16.18.39v4.87c0 .27 0 .46.1.61.05.1.24.32 1 .32h6q.46 0 .68-.04c.14-.03.18-.07.2-.08q.01 0 .07-.2.05-.21.05-.68v-1.57c-.01-1.11-.02-2.26 0-3.04a.5.5 0 0 1 .15-.34l.23-.23c.2-.18.36-.34.52-.57.19-.28.34-.65.34-1.25 0-.66-.3-1.14-.73-1.48A2.6 2.6 0 0 0 10 3z"
]);
const $7972e53b1de568ed$export$8a99187daf6c325c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast16Regular', "16", [
    "M4.85 6.5c0-.28.22-.5.5-.5h3.2c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3.2a.5.5 0 0 1-.5-.5zm1 2.5h2.2V7h-2.2zM1.27 4.01A3.3 3.3 0 0 1 4.2 2H12c1.44 0 3 1.19 3 3 0 1.06-.6 1.95-1 2.4-.01.55.01 1.28.04 2.06v.23c.03.8.06 1.62.06 2.31 0 .64-.06 1.24-.5 1.61-.2.2-.46.28-.72.33q-.4.07-.88.06H4q-1.4-.01-1.87-.8A2 2 0 0 1 1.9 12V7.42a3 3 0 0 1-.63-3.4M4.2 3c-.87 0-1.66.6-2.02 1.41-.35.8-.26 1.72.54 2.4q.18.16.18.39v4.87c0 .27 0 .46.1.61.05.1.24.32 1 .32h6q.46 0 .68-.04c.14-.03.18-.07.2-.08q.01 0 .07-.2.05-.21.05-.68v-1.57c-.01-1.11-.02-2.26 0-3.04a.5.5 0 0 1 .15-.34l.23-.23c.2-.18.36-.34.52-.57.19-.28.34-.65.34-1.25 0-.66-.3-1.14-.73-1.48A2.6 2.6 0 0 0 10 3zm7.73 9.88-.02.12H12q.46 0 .7-.04.22-.05.25-.1c.05-.05.15-.2.15-.86 0-.67-.03-1.48-.05-2.28l-.01-.23c-.03-.86-.06-1.7-.04-2.3a.5.5 0 0 1 .16-.35c.3-.29.84-1.03.84-1.84 0-.98-.71-1.71-1.5-1.93.44.48.74 1.13.74 1.93s-.21 1.37-.52 1.82c-.22.32-.5.59-.71.78l-.02.02v2.77L12 12q.01.5-.07.88"
]);
const $7972e53b1de568ed$export$c1a474b6af95c1dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast20Filled', "20", [
    "M6.78 7.45a.5.5 0 0 0-.5.5v4.1c0 .27.22.5.5.5h4.34a.5.5 0 0 0 .5-.5v-4.1a.5.5 0 0 0-.5-.5zm.5 1h3.34v3.1H7.28zM5.45 2.5c-1.63 0-3 1.1-3.6 2.48-.6 1.33-.49 3 .81 4.22v5.98c0 .3-.01.87.28 1.36.36.6 1.08.96 2.26.96h10.18q.61 0 1.1-.07.46-.07.85-.39c.5-.43.59-1.13.59-1.95 0-.88-.04-1.92-.07-2.93a67 67 0 0 1-.07-2.97 4.7 4.7 0 0 0 1.28-3 3.73 3.73 0 0 0-3.68-3.69zm7.38 1c.62 0 1.39.3 2 .82.6.51.99 1.18 1 1.85-.05.75-.21 1.24-.41 1.58q-.24.39-.56.69l-.16.15-.31.3-.14.13v.2c-.04 1-.03 2.44-.02 3.84v.01l.01 2.02q0 .6-.06.9-.07.28-.14.32-.04.07-.32.13-.2.04-.49.05l-.4.01H5.2c-1 0-1.3-.29-1.4-.47-.14-.23-.14-.51-.14-.84v-6.2a.5.5 0 0 0-.18-.39 2.65 2.65 0 0 1-.72-3.22 3 3 0 0 1 2.7-1.88z"
]);
const $7972e53b1de568ed$export$7be872dcc60479a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast20Regular', "20", [
    "M6.23 7.95c0-.27.22-.5.5-.5h4.34c.28 0 .5.23.5.5v4.1a.5.5 0 0 1-.5.5H6.73a.5.5 0 0 1-.5-.5zm1 3.6h3.34v-3.1H7.23zM1.79 4.98A4 4 0 0 1 5.4 2.5h9.93A3.73 3.73 0 0 1 19 6.18c0 1.33-.76 2.46-1.28 3.01 0 .7.02 1.66.06 2.67v.3c.04 1 .08 2.05.08 2.93 0 .82-.1 1.52-.59 1.95q-.37.31-.86.39-.47.07-1.1.07H5.16c-1.18 0-1.9-.35-2.26-.96a2.5 2.5 0 0 1-.28-1.45V9.2a3.6 3.6 0 0 1-.82-4.22M5.4 3.5c-1.16 0-2.21.8-2.7 1.88a2.65 2.65 0 0 0 .73 3.22q.18.16.18.38v6.21c0 .33 0 .6.14.84.1.18.4.47 1.4.47h7.63q.59 0 .89-.06c.2-.03.28-.09.32-.13q.08-.04.14-.32.06-.3.06-.9v-2c-.02-1.42-.03-2.87 0-3.87a.5.5 0 0 1 .15-.34l.3-.3c.24-.21.44-.4.63-.68.25-.35.46-.86.5-1.73 0-.67-.39-1.34-1-1.85a3.3 3.3 0 0 0-1.99-.82zm9.71 12.69-.08.31h.3q.6 0 .9-.06c.23-.04.33-.1.4-.15.12-.1.24-.36.24-1.2 0-.86-.04-1.89-.07-2.9l-.01-.3c-.04-1.1-.07-2.16-.05-2.92a.5.5 0 0 1 .15-.35 3.7 3.7 0 0 0 1.12-2.44 2.73 2.73 0 0 0-2.65-2.68l.06.06a3.5 3.5 0 0 1 1.35 2.62v.03a4.2 4.2 0 0 1-.67 2.26c-.26.38-.58.67-.84.91l-.07.07c-.02.97-.02 2.3 0 3.6v2.04q0 .64-.08 1.1"
]);
const $7972e53b1de568ed$export$c0f148ebc60ed22f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast24Filled', "24", [
    "M8.25 9a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75zM9 13.5v-3h3v3zM2 7.75A4.75 4.75 0 0 1 6.75 3h10.5a4.75 4.75 0 0 1 3.5 7.96v7.79c0 1.24-1 2.25-2.25 2.25h-13c-1.24 0-2.25-1-2.25-2.25v-7.79A4.7 4.7 0 0 1 2 7.75M6.75 4.5a3.25 3.25 0 0 0-2.23 5.61q.23.22.23.54v8.1c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-7.7q0-.38.33-.61a3.25 3.25 0 0 0-1.83-5.94z"
]);
const $7972e53b1de568ed$export$f0b5ddf9f146cf8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast24Regular', "24", [
    "M8.25 9a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75zM9 13.5v-3h3v3zM2 7.75A4.75 4.75 0 0 1 6.75 3h10.5a4.75 4.75 0 0 1 3.5 7.96v7.79c0 1.24-1 2.25-2.25 2.25h-13c-1.24 0-2.25-1-2.25-2.25v-7.79A4.7 4.7 0 0 1 2 7.75M6.75 4.5a3.25 3.25 0 0 0-2.23 5.61q.23.22.23.54v8.1c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-7.7q0-.38.33-.61a3.25 3.25 0 0 0-1.83-5.94zM19.5 7.75c0 1.49-.68 2.81-1.75 3.68v7.32q0 .4-.13.75h.88c.41 0 .75-.34.75-.75v-8.1q0-.31.23-.54a3.24 3.24 0 0 0-1.08-5.4c.69.82 1.1 1.88 1.1 3.04"
]);
const $7972e53b1de568ed$export$27ee5ac8ab5ded84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info12Filled', "12", [
    "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0m-5.5.5V8a.5.5 0 0 0 1 0V6.5a.5.5 0 0 0-1 0M6 3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $7972e53b1de568ed$export$515949b0e3098366 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info12Regular', "12", [
    "M5.5 6.5a.5.5 0 0 1 1 0V8a.5.5 0 0 1-1 0zM6 3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6m5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
]);
const $7972e53b1de568ed$export$994e675395c5ac42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.5 1.25a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
]);
const $7972e53b1de568ed$export$fb9cc08986d6ea9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info16Regular', "16", [
    "M8.5 7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0zm.25-2a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
]);
const $7972e53b1de568ed$export$6faa23478c869acb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M9.5 8.91a.5.5 0 0 1 1 0v4.69a.5.5 0 0 1-1 0V8.9m-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
]);
const $7972e53b1de568ed$export$92e1c56f07f9445f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info20Regular', "20", [
    "M10.5 8.91a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91m.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $7972e53b1de568ed$export$1a3d73bdedb2c3fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 8.5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$91f70b808248a723 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 7c.41 0 .75.34.75.75v5a.75.75 0 0 1-1.5 0v-5c0-.41.34-.75.75-.75M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$afd7c8a05656084c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info28Filled', "28", [
    "M2 14a12 12 0 1 0 24 0 12 12 0 0 0-24 0m12-2.5c.41 0 .75.34.75.75v7a.75.75 0 0 1-1.5 0v-7c0-.41.34-.75.75-.75m0-1.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $7972e53b1de568ed$export$db09393bb96a6ae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info28Regular', "28", [
    "M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0M14 3.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21m0 8c.41 0 .75.34.75.75v7a.75.75 0 0 1-1.5 0v-7c0-.41.34-.75.75-.75m0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$d91efc6eb9bba50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info32Filled', "32", [
    "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28m0 11a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1m0-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $7972e53b1de568ed$export$a2a92ff38706a4ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info32Regular', "32", [
    "M16 13a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0M16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24"
]);
const $7972e53b1de568ed$export$5eeb28de4fe433cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info48Filled', "48", [
    "M44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0m-20-4c-.69 0-1.25.56-1.25 1.25v12.5a1.25 1.25 0 1 0 2.5 0v-12.5c0-.69-.56-1.25-1.25-1.25m0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $7972e53b1de568ed$export$44afdc466b0959b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info48Regular', "48", [
    "M24 6.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35M4 24a20 20 0 1 1 40 0 20 20 0 0 1-40 0m20-4c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $7972e53b1de568ed$export$fc74f811a0c06a24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoShield20Filled', "20", [
    "M17 9a8 8 0 1 0-6.28 7.81l-.2-.42a7 7 0 0 1-.52-2.5v-2.8c0-.75.59-1.42 1.4-1.42.9 0 1.76-.37 2.6-1.24a1.4 1.4 0 0 1 2 0 5 5 0 0 0 1 .8zM8.5 7.91a.5.5 0 0 1 1 0v4.69a.5.5 0 0 1-1 0V7.9m-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m8.75 4.6a5 5 0 0 1-1-.59q-.36-.27-.72-.64a.4.4 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77q.05 1.2.44 2.15A5 5 0 0 0 13 18q.78.6 1.87.98.13.05.26 0 3.86-1.35 3.87-5.4V11a.4.4 0 0 0-.4-.33 4 4 0 0 1-1.6-.32"
]);
const $7972e53b1de568ed$export$d0f7fdb5d26a4dd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoShield20Regular', "20", [
    "M17 9a8 8 0 1 0-6.28 7.81 6 6 0 0 1-.39-.94Q9.7 16 9 16a7 7 0 1 1 6.97-7.6q.03 0 .04.03a5 5 0 0 0 .99.8zM9.05 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M9 7.5a.5.5 0 0 1 .5.41v4.59a.5.5 0 0 1-1 .1V8c0-.28.22-.5.5-.5m8 2.85a5 5 0 0 1-1-.59q-.36-.27-.72-.64a.4.4 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77q.05 1.2.44 2.15A5 5 0 0 0 13 18q.78.6 1.87.98.13.05.26 0 3.86-1.35 3.87-5.4V11a.4.4 0 0 0-.4-.33 4 4 0 0 1-1.6-.32"
]);
const $7972e53b1de568ed$export$bdf48a5fdc483960 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle16Filled', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.3 1.3 0 0 0 1 .21A7 7 0 1 1 8.78 1.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-1.09.34A1.4 1.4 0 0 0 6 3.5q0 .46.26.82.26.37.71.53l.47.15a.75.75 0 1 0 1.26.76l.1.2.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.12.05.22.14t.14.22l.26.8q.15.38.48.62M8 7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 7"
]);
const $7972e53b1de568ed$export$f33cf63a7abcd693 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle16Regular', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.3 1.3 0 0 0 1 .21A7 7 0 1 1 8.78 1.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-.73.23a6 6 0 1 0 5.4 9.69zM7.44 5l.6.2q.2.06.46.29.12.1.2.27A.75.75 0 1 1 7.44 5M8 7c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5"
]);
const $7972e53b1de568ed$export$1ec6ffb10c9b38e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle20Filled', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9zm-8-3.09a.5.5 0 0 1 1 0v4.69a.5.5 0 0 1-1 0V8.9m-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
]);
const $7972e53b1de568ed$export$def13e18ca0cdc87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle20Regular', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9zm-7-3.09a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91m.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $7972e53b1de568ed$export$a1afa409381c3c8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle24Filled', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-2.33 3.84q.2 0 .34-.04a10 10 0 1 1-7.04-11.63 2 2 0 0 1-.37.18L13.05 3c-.63.22-1.05.8-1.05 1.47 0 .63.42 1.28 1 1.53l1.4.46c.52.17 1.01.57 1.19 1.09L16 9a1.55 1.55 0 0 0 2.14.89q-.18.3-.18.66c0 .54.36 1.05.87 1.23l.24.07c.36.09.8.2.91.55l.01.04c.24.75.51 1.61 1.47 1.61M12 10.5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$8382febde417d016 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle24Regular', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12 22.01a10 10 0 0 0 9.8-8q-.15.04-.34.04c-.53 0-.85-.27-1.07-.63a8.5 8.5 0 1 1-8.05-9.91q.27-.35.71-.51l1.34-.44q.2-.06.37-.18A10 10 0 1 0 12 22m0-11.51c.41 0 .75.34.75.75v5a.75.75 0 0 1-1.5 0v-5c0-.41.34-.75.75-.75M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$276e9ead41033e1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle28Filled', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5q-.49.16-.8.59a1.6 1.6 0 0 0 0 1.85q.3.42.78.59l1.56.5a2.3 2.3 0 0 1 1 .73q.24.28.35.64l.5 1.53q.18.49.59.8a1.6 1.6 0 0 0 1.86 0l.13-.11a1.34 1.34 0 0 0 .85 1.66l.94.3q.2.07.34.22t.22.35l.3.92A1.34 1.34 0 0 0 25 15a1.4 1.4 0 0 0 .99-.42A12 12 0 1 1 14 2m0 9.5a.75.75 0 0 0-.75.75v7a.75.75 0 0 0 1.5 0v-7a.75.75 0 0 0-.75-.75m0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$c3b7847c00ce29ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle28Regular', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5-.12.04Q14.5 3.5 14 3.5a10.5 10.5 0 1 0 10.46 11.4 1.4 1.4 0 0 0 1.53-.32A12 12 0 1 1 14 2m0 9.5c.41 0 .75.34.75.75v7a.75.75 0 0 1-1.5 0v-7c0-.41.34-.75.75-.75m0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $7972e53b1de568ed$export$c69e0fcbfbdabc35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle32Filled', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M16 2a14 14 0 0 1 4.14.62q-.23.17-.5.26L18 3.44a2.2 2.2 0 0 0-1.5 2.06 2.2 2.2 0 0 0 1.45 2l1.71.56q.44.15.77.47.01.05.08.11l.08.08q.2.26.31.58l.55 1.7a2.16 2.16 0 0 0 3.3 1.08 2 2 0 0 0-.25.9 1.8 1.8 0 0 0 1.24 1.75l1 .3.14.11q.07.07.09.15l.3.91a2 2 0 0 0 .69.94 1.9 1.9 0 0 0 1.99.1A14 14 0 1 1 16 2m0 11a1 1 0 0 0-1 1v9a1 1 0 1 0 2 0v-9a1 1 0 0 0-1-1m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $7972e53b1de568ed$export$85f5207e1f9549e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle32Regular', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M16 2a14 14 0 0 1 4.14.62q-.23.17-.5.26L18 3.44q-.54.19-.94.6Q16.54 4 16 4a12 12 0 1 0 11.95 13.13l.01.01a1.9 1.9 0 0 0 1.99.1A14 14 0 1 1 16 2m0 11a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $7972e53b1de568ed$export$1a41eb167badf834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle48Filled', "48", [
    "M32.83 12.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM29.64 4.82h.02A20 20 0 1 0 43.9 25.96a2.6 2.6 0 0 1-1.9-.43 2.5 2.5 0 0 1-.89-1.35l-.44-1.37a1 1 0 0 0-.4-.48l-.12-.06-1.42-.46a2.55 2.55 0 0 1-1.7-2.4q0-.52.22-1a3 3 0 0 1-4.59-1.51l-.84-2.59a3.2 3.2 0 0 0-2.17-2.11L27 11.35a3 3 0 0 1-1.44-4.58q.57-.8 1.51-1.12zM24 20c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m0-3a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
]);
const $7972e53b1de568ed$export$7e5bc54f0ff205b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle48Regular', "48", [
    "M32.83 12.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM24 4a20 20 0 0 1 5.66.81l-.02.01-2.57.83q-.8.28-1.36.93-.85-.08-1.71-.08a17.5 17.5 0 1 0 17.47 18.48q.23.32.53.56a2.6 2.6 0 0 0 1.9.43A20 20 0 1 1 24 4m0 16c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25m0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $7972e53b1de568ed$export$7b729b0e7343614c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line20Filled', "20", [
    "M17.78 2.22c.3.3.3.77 0 1.06l-14.5 14.5a.75.75 0 0 1-1.06-1.06l14.5-14.5c.3-.3.77-.3 1.06 0"
]);
const $7972e53b1de568ed$export$934d180254a51d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line20Regular', "20", [
    "M17.85 2.15c.2.2.2.51 0 .7l-15 15a.5.5 0 0 1-.7-.7l15-15c.2-.2.5-.2.7 0"
]);
const $7972e53b1de568ed$export$48c493393fbebb6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line24Filled', "24", [
    "M21.7 2.3a1 1 0 0 1 0 1.4l-18 18a1 1 0 0 1-1.4-1.4l18-18a1 1 0 0 1 1.4 0"
]);
const $7972e53b1de568ed$export$817d3350af5a5d67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line24Regular', "24", [
    "M21.78 2.22c.3.3.3.77 0 1.06l-18.5 18.5a.75.75 0 1 1-1.06-1.06l18.5-18.5c.3-.3.77-.3 1.06 0"
]);
const $7972e53b1de568ed$export$55108d36cbb578cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line32Filled', "32", [
    "M28.63 3.37c.5.48.5 1.28 0 1.76l-23.5 23.5a1.25 1.25 0 0 1-1.76-1.76l23.5-23.5a1.25 1.25 0 0 1 1.76 0"
]);
const $7972e53b1de568ed$export$4696827e857d7514 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line32Regular', "32", [
    "M28.7 3.3a1 1 0 0 1 0 1.4l-24 24a1 1 0 0 1-1.4-1.4l24-24a1 1 0 0 1 1.4 0"
]);
const $7972e53b1de568ed$export$7dd994fe2a5e27e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line48Filled', "48", [
    "M43.56 4.44a1.5 1.5 0 0 1 0 2.12l-37 37a1.5 1.5 0 0 1-2.12-2.12l37-37a1.5 1.5 0 0 1 2.12 0"
]);
const $7972e53b1de568ed$export$fb78822440a412ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line48Regular', "48", [
    "M43.63 4.37c.5.48.5 1.28 0 1.76l-37.5 37.5a1.25 1.25 0 0 1-1.76-1.76l37.5-37.5a1.25 1.25 0 0 1 1.76 0"
]);
const $7972e53b1de568ed$export$cff7fcbe83f9f34a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes20Filled', "20", [
    "M16.78 4.28a.75.75 0 0 0-1.06-1.06l-.5.5a.75.75 0 0 0 1.06 1.06zm-3 1.94c.3.3.3.77 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0m-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0m-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 0 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0m-3 4.06a.75.75 0 1 0-1.06-1.06l-.5.5a.75.75 0 1 0 1.06 1.06z"
]);
const $7972e53b1de568ed$export$a8c558eb2b406886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes20Regular', "20", [
    "M16.85 3.85a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 .7.7zm-3 2.3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m-3 3.7a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 .7.7z"
]);
const $7972e53b1de568ed$export$997d6ac9cb01979d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes24Filled', "24", [
    "M21.7 2.3a1 1 0 0 1 0 1.41l-.5.5a1 1 0 1 1-1.4-1.41l.5-.5a1 1 0 0 1 1.4 0m-4 4a1 1 0 0 1 0 1.41l-1 1a1 1 0 1 1-1.4-1.42l.99-1a1 1 0 0 1 1.41 0m-4.5 4.5a1 1 0 0 1 0 1.4l-1 1a1 1 0 0 1-1.4-1.4l1-1a1 1 0 0 1 1.4 0M8.7 16.7A1 1 0 1 0 7.3 15.3l-1 1a1 1 0 1 0 1.42 1.4zm-4.49 4.5a1 1 0 0 0-1.41-1.42l-.5.5a1 1 0 0 0 1.41 1.42z"
]);
const $7972e53b1de568ed$export$2cc11456eeb2aa18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes24Regular', "24", [
    "M21.79 2.22c.29.3.29.77 0 1.06l-1 1a.75.75 0 1 1-1.07-1.06l1-1c.3-.29.77-.29 1.07 0m-4.01 4c.29.3.29.77 0 1.06l-1.5 1.5a.75.75 0 0 1-1.06-1.06l1.5-1.5c.29-.29.76-.29 1.06 0m-4.5 4.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l1.5-1.5c.3-.3.77-.3 1.06 0m-4.5 5.56a.75.75 0 0 0-1.06-1.06l-1.5 1.5a.75.75 0 0 0 1.06 1.06zm-4.5 4.5a.75.75 0 1 0-1.06-1.06l-1 1a.75.75 0 1 0 1.06 1.06z"
]);
const $7972e53b1de568ed$export$f323d5181c516640 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes32Filled', "32", [
    "M28.63 3.37c.5.48.5 1.28 0 1.76l-.98.98a1.25 1.25 0 1 1-1.76-1.76l.98-.98a1.25 1.25 0 0 1 1.76 0m-4.9 4.9c.5.48.5 1.27 0 1.76l-1.95 1.96a1.25 1.25 0 1 1-1.77-1.77l1.96-1.96a1.25 1.25 0 0 1 1.77 0m-5.87 5.87c.5.49.5 1.28 0 1.76l-1.96 1.96a1.25 1.25 0 1 1-1.76-1.76l1.96-1.96a1.25 1.25 0 0 1 1.76 0M12 20c.49.49.49 1.28 0 1.77l-1.96 1.96a1.25 1.25 0 0 1-1.77-1.77l1.96-1.96a1.25 1.25 0 0 1 1.77 0M6.1 25.9c.5.49.5 1.28 0 1.76l-.98.98a1.25 1.25 0 0 1-1.76-1.76l.98-.98a1.25 1.25 0 0 1 1.76 0"
]);
const $7972e53b1de568ed$export$1030f38758473d10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes32Regular', "32", [
    "M28.7 3.3a1 1 0 0 1 0 1.4l-1 1a1 1 0 1 1-1.4-1.4l1-1a1 1 0 0 1 1.4 0m-5 5a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 0m-6 6a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 0m-6 6a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 0m-6 6a1 1 0 0 1 0 1.4l-1 1a1 1 0 0 1-1.4-1.4l1-1a1 1 0 0 1 1.4 0"
]);
const $7972e53b1de568ed$export$25aa0a4264f7b401 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes48Filled', "48", [
    "M43.56 6.56a1.5 1.5 0 0 0-2.12-2.12l-2 2a1.5 1.5 0 0 0 2.12 2.12zm-8 5.88a1.5 1.5 0 0 1 0 2.12l-3 3a1.5 1.5 0 0 1-2.12-2.12l3-3a1.5 1.5 0 0 1 2.12 0m-9 11.12a1.5 1.5 0 0 0-2.12-2.12l-3 3a1.5 1.5 0 0 0 2.12 2.12zm-9 6.88a1.5 1.5 0 0 1 0 2.12l-3 3a1.5 1.5 0 0 1-2.12-2.12l3-3a1.5 1.5 0 0 1 2.12 0m-9 9a1.5 1.5 0 0 1 0 2.12l-2 2a1.5 1.5 0 0 1-2.12-2.12l2-2a1.5 1.5 0 0 1 2.12 0"
]);
const $7972e53b1de568ed$export$18f4b3b9c71a7407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes48Regular', "48", [
    "M43.63 6.14a1.25 1.25 0 1 0-1.77-1.77l-2.5 2.5a1.25 1.25 0 0 0 1.77 1.76zm-8 6.23c.5.48.5 1.28 0 1.76l-3.5 3.5a1.25 1.25 0 0 1-1.76-1.76l3.5-3.5a1.25 1.25 0 0 1 1.76 0m-9 10.76a1.25 1.25 0 0 0-1.76-1.76l-3.5 3.5a1.25 1.25 0 0 0 1.76 1.76zm-9 7.24c.5.48.5 1.28 0 1.76l-3.5 3.5a1.25 1.25 0 0 1-1.76-1.76l3.5-3.5a1.25 1.25 0 0 1 1.76 0m-9 9c.5.48.5 1.28 0 1.76l-2.5 2.5a1.25 1.25 0 0 1-1.76-1.77l2.5-2.5a1.25 1.25 0 0 1 1.76 0"
]);
const $7972e53b1de568ed$export$7f470abe81eda80d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight16Filled', "16", [
    "M12.85 3.85a.5.5 0 0 0-.7-.7L5.88 9.4q-.6-.4-1.38-.41a2.5 2.5 0 1 0 2.09 1.12z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$4adc033448c48eed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight16Regular', "16", [
    "M12.85 3.85a.5.5 0 0 0-.7-.7L5.88 9.4q-.6-.4-1.38-.41a2.5 2.5 0 1 0 2.09 1.12zM3 11.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$76f233f5996438c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight20Filled', "20", [
    "M15.85 4.85a.5.5 0 0 0-.7-.7l-7.41 7.4a3 3 0 1 0 .7.7z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$8903dda37df2699f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight20Regular', "20", [
    "M15.85 4.85a.5.5 0 0 0-.7-.7l-7.41 7.4a3 3 0 1 0 .7.7zM4 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$b706997fb905e671 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight24Filled', "24", [
    "M19.78 5.28a.75.75 0 0 0-1.06-1.06l-9.47 9.47a4 4 0 1 0 1.06 1.06z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$e687a225424e99a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight24Regular', "24", [
    "M19.78 5.28a.75.75 0 0 0-1.06-1.06l-9.47 9.47a4 4 0 1 0 1.06 1.06zM4.5 17a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$20ff6a2cdc232ca9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight32Filled', "32", [
    "M26.7 6.7a1 1 0 0 0-1.4-1.4L11.61 18.96a5.5 5.5 0 1 0 1.41 1.41z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$b63a5eb01ff9f12b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight32Regular', "32", [
    "M26.7 6.7a1 1 0 0 0-1.4-1.4L11.61 18.96a5.5 5.5 0 1 0 1.41 1.41zM5 23.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$a1809c19046e8bb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal116Filled', "16", [
    "M2 7.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75"
]);
const $7972e53b1de568ed$export$aa7d0f295573ab1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal116Regular', "16", [
    "M2 7.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$20ae25676d2d990e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal120Filled', "20", [
    "M2 9.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75"
]);
const $7972e53b1de568ed$export$1751b69ed8d10fd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal120Regular', "20", [
    "M2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$3dbdca8bfeba8133 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal124Filled', "24", [
    "M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $7972e53b1de568ed$export$5ecadb77040d4abd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal124Regular', "24", [
    "M2 11.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$8aa5f1e667dac18f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal128Filled', "28", [
    "M2 14a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1"
]);
const $7972e53b1de568ed$export$10dda66b1b1a29e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal128Regular', "28", [
    "M2 13.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$5f77b5b2fe607c59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashDotDash20Filled', "20", [
    "M10 11.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M2.75 9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm12 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$16b9eca4fd995229 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashDotDash20Regular', "20", [
    "M10 10.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M2 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m11 0c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$839756025d262635 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes16Filled', "16", [
    "M2 7.75c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 2 7.75m4.5 0c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m4.5 0c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$a1fd0d02e4be867c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes16Regular', "16", [
    "M2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m4.5 0c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5m4.5 0c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$1875b427bd8e9ae8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes20Filled', "20", [
    "M2 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 2 9.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 9.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$6656d070b673f36c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes20Regular', "20", [
    "M2 9.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$36494c08782f121 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes24Filled', "24", [
    "M2 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m7.5 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1m7.5 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
]);
const $7972e53b1de568ed$export$399807c987a06911 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes24Regular', "24", [
    "M2 11.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m7.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m7.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$a105a655c1c8d446 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes28Filled', "28", [
    "M2 14a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1"
]);
const $7972e53b1de568ed$export$88e3bc65583f145e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes28Regular', "28", [
    "M2 13.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m9 0c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m9 0c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$b64c943f9e0f548a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dot20Filled', "20", [
    "M3.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $7972e53b1de568ed$export$bacc4707885ef000 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dot20Regular', "20", [
    "M3.25 10.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M18 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $7972e53b1de568ed$export$774b926484a255bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid16Filled', "16", [
    "M2.75 5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm4.5 0a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm4.5 0a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm-9 5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$d6503597de79e746 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid16Regular', "16", [
    "M2.5 5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM7 5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm4.5 0a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm-9 5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$16b0f3eb5c928fb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid20Filled', "20", [
    "M2.75 6a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm6 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm6 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm-12 6a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$36378d0880ae1455 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid20Regular', "20", [
    "M2.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm6 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm6 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-12 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$9060c649127f8d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid24Filled', "24", [
    "M3 7a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7.5 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zM18 7a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zM3 15a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$54d574c856094bc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid24Regular', "24", [
    "M2.75 7a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm-15 8a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$5a1d1a5f7143aa64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid28Filled', "28", [
    "M3 9a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zm9 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm9 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zM3 17a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$d3b41551a72805d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid28Regular', "28", [
    "M2.75 9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm9 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm9 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zm-18 8a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$513403f818b2bc43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal316Filled', "16", [
    "M2 3.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75m0 4c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75m0 4c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$bc2a2779392400df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal316Regular', "16", [
    "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 4c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$58dba1ca981cde30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal320Filled', "20", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75m0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M2.75 14a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$8b4a5498541f8a3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal320Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$87bb06d7b0434575 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal324Filled', "24", [
    "M3 17h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18zm0-6h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18zm0-6h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2zh18z"
]);
const $7972e53b1de568ed$export$85994846335a9990 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal324Regular', "24", [
    "M2.75 18h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5zm0-6.5h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5zh18.5zm0-6.5h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.49zh18.5z"
]);
const $7972e53b1de568ed$export$34506bf943ac18c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal328Filled', "28", [
    "M2 6a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 16a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1-9a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$be1c91892fc1b7eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal328Regular', "28", [
    "M2 5.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m0 16c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M2.75 13a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$f92806d119397e5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal332Filled', "32", [
    "M2 6.25C2 5.56 2.56 5 3.25 5h25.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 7.5 2 6.94 2 6.25m0 10c0-.69.56-1.25 1.25-1.25h25.5a1.25 1.25 0 1 1 0 2.5H3.25c-.69 0-1.25-.56-1.25-1.25M3.25 25a1.25 1.25 0 1 0 0 2.5h25.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $7972e53b1de568ed$export$dd6373240d8c479b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal332Regular', "32", [
    "M2 6a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 10a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1 9a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$18e30ec78d5b98a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal348Filled', "48", [
    "M4 11.5c0-.83.67-1.5 1.5-1.5h37a1.5 1.5 0 0 1 0 3h-37A1.5 1.5 0 0 1 4 11.5m0 13c0-.83.67-1.5 1.5-1.5h37a1.5 1.5 0 0 1 0 3h-37A1.5 1.5 0 0 1 4 24.5M5.5 36a1.5 1.5 0 0 0 0 3h37a1.5 1.5 0 0 0 0-3z"
]);
const $7972e53b1de568ed$export$e217b9a2131067f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal348Regular', "48", [
    "M4 11.25c0-.69.56-1.25 1.25-1.25h37.5a1.25 1.25 0 1 1 0 2.5H5.25c-.69 0-1.25-.56-1.25-1.25m0 13c0-.69.56-1.25 1.25-1.25h37.5a1.25 1.25 0 1 1 0 2.5H5.25c-.69 0-1.25-.56-1.25-1.25M5.25 36a1.25 1.25 0 1 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $7972e53b1de568ed$export$72545c0ba3a8e3ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal416Filled', "16", [
    "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zM2 9.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M2.75 12a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$4cb211faa6a4fcd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal416Regular', "16", [
    "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zM2 9.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$19a7954b149e11ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal420Filled', "20", [
    "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75m0 4c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75M2.75 11a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 15.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$b335eb7ff470eeb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal420Regular', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 4h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1M2 11.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$875b3f217fc5f44b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search16Filled', "16", [
    "M10.5 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 6.6A3.5 3.5 0 1 0 10.5 8m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m3.43 3.06L12.88 9H2.75a.75.75 0 0 0 0 1.5h10.5c.3 0 .57-.18.68-.44M7.15 7.5a5 5 0 0 1-.9-1.5h-3.5a.75.75 0 0 0 0 1.5zM6.25 3A5 5 0 0 0 6 4.5H2.75a.75.75 0 0 1 0-1.5zm-3.5 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$f960074d03fe4de1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search16Regular', "16", [
    "M10.5 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 6.6A3.5 3.5 0 1 0 10.5 8m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m3.29 2.9-.91-.9H2.5a.5.5 0 0 0 0 1h11q.15 0 .29-.1M6.76 7q-.31-.45-.5-1H2.5a.5.5 0 0 0 0 1zm-.5-4q-.18.48-.23 1H2.5a.5.5 0 0 1 0-1zM2.5 12a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$15aafaccddcd15f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search20Filled', "20", [
    "M12.5 10c.97 0 1.87-.3 2.6-.83l3.62 3.61a.75.75 0 1 0 1.06-1.06l-3.61-3.61A4.5 4.5 0 1 0 12.5 10m0-7.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6m3.03 8.5 1.5 1.5H2.75a.75.75 0 0 1 0-1.5h12.78M2.75 3H7.6q-.36.7-.5 1.5H2.74a.75.75 0 0 1 0-1.5m0 4h4.46q.23.81.68 1.5H2.75a.75.75 0 0 1 0-1.5M2 15.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $7972e53b1de568ed$export$370f8642b7d3d0d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search20Regular', "20", [
    "M12.5 10c1.06 0 2.04-.37 2.8-.98l3.85 3.83a.5.5 0 0 0 .7-.7L16.02 8.3A4.5 4.5 0 1 0 12.5 10m0-8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m.02 9h3.36l1 1H2.5a.5.5 0 0 1 0-1h10.02M2.5 3h5.1q-.24.48-.4 1H2.5a.5.5 0 0 1 0-1m5.1 5q-.25-.48-.4-1H2.5a.5.5 0 0 0 0 1zM2 15.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $7972e53b1de568ed$export$8fd9514a40a7db8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal520Filled', "20", [
    "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75m0 6c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M2.75 12a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 6.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 6.75M2.75 15a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$ddf3e5775351de38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal520Regular', "20", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 6c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M2.5 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$bfa66526d796c93c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5Error20Filled', "20", [
    "M2.75 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 6a.75.75 0 0 0 0 1.5h7.14q.57-.9 1.45-1.5zm0 3h6.46Q9 12.72 9 13.5H2.75a.75.75 0 0 1 0-1.5m0 3h6.46q.23.81.68 1.5H2.75a.75.75 0 0 1 0-1.5m0-9a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM19 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $7972e53b1de568ed$export$b5fc716bbf57022 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5Error20Regular', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 6a.5.5 0 0 0 0 1h7.76q.47-.58 1.08-1zm0 3h6.7q-.13.49-.18 1H2.5a.5.5 0 0 1 0-1m0 3h6.7q.16.52.4 1H2.5a.5.5 0 0 1 0-1m0-9a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM19 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $7972e53b1de568ed$export$a11b23076db21503 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle20Filled', "20", [
    "M2 4.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 2 4.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 4.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m-12 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M3.25 14a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $7972e53b1de568ed$export$4844189aca972e9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-12 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M3 14a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$b68bad75a4792260 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle24Filled', "24", [
    "M3 5a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7.5 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zM18 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zM2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m1.5 5a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3z"
]);
const $7972e53b1de568ed$export$4234409d0e156bf0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle24Regular', "24", [
    "M2.75 5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm3.5 6.5H2.75l-.1.01a.75.75 0 0 0 .1 1.5h18.5l.1-.01a.75.75 0 0 0-.1-1.5m-18 5.5a1.25 1.25 0 0 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $7972e53b1de568ed$export$af1412774b2c7c6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch16Filled', "16", [
    "M1 3.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.75m6.65 4.7c.6.25 1.31.55 2.32.55.89 0 1.57-.23 2.11-.42l.22-.08c.58-.19 1.08-.31 1.82-.18a.75.75 0 0 0 .26-1.47 5 5 0 0 0-2.8.31c-.54.19-.99.34-1.6.34-.7 0-1.18-.2-1.77-.44l-.02-.01c-.6-.25-1.32-.55-2.33-.55a6 6 0 0 0-2.32.55h-.02a4 4 0 0 1-1.77.45.75.75 0 0 0 0 1.5c1.01 0 1.73-.3 2.32-.55h.03A4 4 0 0 1 5.86 8c.7 0 1.18.2 1.77.44zm-5.33 4.8a.75.75 0 0 1-1.14-1l.21-.2q.19-.19.51-.42C2.33 11.33 3 11 3.78 11q.6 0 1.03.27c.25.15.43.35.53.47l.02.02c.11.13.15.17.2.2q0 .02.24.04c.36 0 .63-.14 1.07-.4l.04-.02c.42-.24 1-.58 1.78-.58.8 0 1.36.35 1.75.6l.04.01c.41.26.65.39 1 .39.4 0 .97-.19 1.5-.43a9 9 0 0 0 .87-.46.75.75 0 0 1 .8 1.28l-.3.17q-.3.16-.74.37c-.57.26-1.39.57-2.14.57a3 3 0 0 1-1.75-.6l-.03-.01c-.41-.26-.65-.39-1-.39s-.62.14-1.07.4l-.03.02c-.42.24-1 .58-1.79.58q-.6 0-1.03-.27c-.25-.15-.43-.35-.53-.47l-.02-.02a1 1 0 0 0-.2-.2q0-.02-.24-.04c-.37 0-.73.16-1.02.37a3 3 0 0 0-.44.37"
]);
const $7972e53b1de568ed$export$ea648934e327ac1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch16Regular', "16", [
    "M1 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m6.74 4.47c.62.25 1.32.53 2.31.53a6 6 0 0 0 2.1-.4l.23-.08c.62-.2 1.2-.34 2.03-.2a.5.5 0 1 0 .18-.98 5 5 0 0 0-2.76.3c-.57.2-1.08.36-1.78.36a5 5 0 0 1-1.95-.46l-.01-.01c-.63-.25-1.32-.53-2.31-.53-1 0-1.7.28-2.31.53h-.02a5 5 0 0 1-1.95.47.5.5 0 0 0 0 1c1 0 1.69-.28 2.31-.53h.01a5 5 0 0 1 1.96-.47c.79 0 1.33.22 1.95.46zm-6.58 4.9c.2.19.53.17.71-.03L2 12.7q.13-.13.38-.3c.33-.21.76-.41 1.23-.41q.32.02.41.09c.09.05.15.11.27.25h.01q.16.21.5.44.36.22.92.22c.73 0 1.28-.3 1.71-.55l.03-.01c.46-.26.8-.44 1.26-.44s.77.18 1.2.43l.02.01c.4.25.93.56 1.67.56.71 0 1.52-.29 2.1-.54a11 11 0 0 0 1.04-.53.5.5 0 0 0-.5-.86l-.27.14q-.25.15-.67.33c-.57.25-1.2.46-1.7.46-.45 0-.76-.18-1.19-.43l-.02-.01c-.41-.25-.94-.56-1.68-.56-.73 0-1.28.3-1.72.55l-.02.01c-.46.26-.8.44-1.26.44a1 1 0 0 1-.42-.09 1 1 0 0 1-.27-.25q-.17-.21-.5-.44A2 2 0 0 0 3.6 11c-.74 0-1.36.3-1.78.58a4 4 0 0 0-.7.58.5.5 0 0 0 .03.71"
]);
const $7972e53b1de568ed$export$4ec364e701e77c13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch20Filled', "20", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75m2.9 4.29c.7-.25 1.49-.54 2.62-.54s1.92.29 2.62.54h.02c.68.25 1.27.46 2.13.46.76 0 1.3-.16 1.94-.35l.28-.08a6 6 0 0 1 2.86-.23.75.75 0 1 1-.24 1.48 4.7 4.7 0 0 0-2.46.27c-.64.19-1.4.41-2.38.41-1.13 0-1.93-.29-2.62-.54h-.02A6 6 0 0 0 7.52 10c-.86 0-1.45.2-2.13.46h-.02c-.7.25-1.49.54-2.62.54a.75.75 0 0 1 0-1.5c.86 0 1.44-.2 2.13-.46zM17.9 14.4a.75.75 0 0 0-1.01-.31l-.29.14q-.28.14-.74.32c-.62.25-1.32.45-1.84.45a2.5 2.5 0 0 1-1.26-.41l-.03-.02a4 4 0 0 0-1.93-.57c-.85 0-1.5.32-1.98.56l-.03.02c-.52.25-.87.42-1.35.42a1 1 0 0 1-.4-.07 1 1 0 0 1-.24-.21l-.02-.02c-.12-.12-.32-.31-.6-.46A2.3 2.3 0 0 0 5.1 14c-.85 0-1.58.32-2.06.6a5 5 0 0 0-.81.61.75.75 0 0 0 1.05 1.08l.12-.11q.15-.12.4-.29c.36-.2.81-.39 1.3-.39q.34.01.4.07.07.03.25.21l.01.02c.12.12.32.31.6.46q.44.24 1.1.24c.84 0 1.48-.32 1.97-.56l.03-.02c.51-.25.87-.42 1.35-.42.46 0 .78.16 1.25.41l.03.02a4 4 0 0 0 1.94.57c.82 0 1.73-.3 2.39-.55a13 13 0 0 0 1.18-.54c.37-.2.5-.65.31-1.01"
]);
const $7972e53b1de568ed$export$300c2b0050e23ca8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m7.75 5.48c.72.25 1.5.52 2.62.52a8 8 0 0 0 2.64-.48c.72-.2 1.41-.34 2.42-.2a.5.5 0 0 0 .14-.98c-1.2-.18-2.04 0-2.82.22l-.29.08a7 7 0 0 1-2.1.36c-.94 0-1.58-.22-2.3-.47a7 7 0 0 0-2.63-.53c-1.12 0-1.9.27-2.62.52-.72.26-1.37.48-2.31.48a.5.5 0 0 0 0 1c1.12 0 1.9-.27 2.62-.52h.01a6 6 0 0 1 2.3-.48c.95 0 1.6.22 2.3.47zm8.2 4.3a.5.5 0 0 0-.68-.22l-.3.14q-.31.15-.8.33c-.64.25-1.4.47-2 .47-.56 0-.95-.2-1.44-.44l-.02-.02a4 4 0 0 0-1.88-.54c-.8 0-1.41.3-1.92.54h-.03c-.52.26-.95.46-1.52.46q-.4-.01-.54-.1-.14-.08-.33-.26v-.01c-.13-.12-.3-.3-.56-.42a2 2 0 0 0-1-.21c-.81 0-1.5.3-1.98.57a5 5 0 0 0-.8.57.5.5 0 1 0 .73.7 3 3 0 0 1 .56-.4c.4-.23.92-.44 1.5-.44.28 0 .43.05.54.1q.14.08.32.26l.01.01c.13.12.3.3.56.42q.39.21 1 .21c.8 0 1.41-.3 1.92-.54h.03c.52-.26.95-.46 1.51-.46s.95.2 1.44.44l.02.02c.48.24 1.06.54 1.88.54.79 0 1.7-.28 2.36-.53a14 14 0 0 0 1.2-.52.5.5 0 0 0 .21-.68"
]);
const $7972e53b1de568ed$export$fe0ee0ffb2ec37cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch24Filled', "24", [
    "M3 4a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm2.6 6.82A8 8 0 0 1 8.91 10c1.45 0 2.47.45 3.33.82l.03.01a6 6 0 0 0 2.56.67c.9 0 1.55-.23 2.34-.51l.35-.12a6.6 6.6 0 0 1 3.66-.35 1 1 0 1 1-.38 1.96 4.6 4.6 0 0 0-2.63.28l-.31.1c-.8.3-1.76.64-3.03.64a8 8 0 0 1-3.33-.82l-.03-.01A6 6 0 0 0 8.92 12c-1.01 0-1.7.3-2.56.67l-.03.01c-.86.37-1.88.82-3.33.82a1 1 0 1 1 0-2c1.01 0 1.7-.3 2.56-.67zm14.86 6.34a1 1 0 1 1 1.08 1.68l-.43.26q-.4.24-1.06.55c-.8.39-1.98.85-3.05.85-1.13 0-1.93-.51-2.5-.88l-.04-.03c-.6-.38-.95-.59-1.46-.59-.52 0-.92.22-1.57.6l-.05.04c-.6.36-1.43.86-2.54.86a2.7 2.7 0 0 1-2.2-1.08l-.03-.03c-.17-.2-.23-.27-.3-.31-.04-.03-.14-.08-.4-.08-.53 0-1.05.25-1.5.56a4 4 0 0 0-.65.58 1 1 0 0 1-1.53-1.28l.03-.03.26-.28q.26-.27.73-.61c.6-.44 1.54-.94 2.67-.94a2.7 2.7 0 0 1 2.2 1.08l.03.03c.16.2.23.27.3.31.04.03.13.08.39.08.52 0 .92-.22 1.56-.6l.06-.04c.6-.36 1.43-.86 2.54-.86 1.13 0 1.93.51 2.5.88l.04.03c.6.38.95.59 1.46.59.6 0 1.42-.29 2.2-.65a13 13 0 0 0 1.26-.7"
]);
const $7972e53b1de568ed$export$a107488d8362ced8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch24Regular', "24", [
    "M2.75 4a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zm2.77 6.8c.89-.37 1.89-.8 3.31-.8s2.43.43 3.32.8l.02.01c.88.37 1.64.69 2.75.69.98 0 1.7-.25 2.5-.53l.36-.12a6.7 6.7 0 0 1 3.6-.34.75.75 0 1 1-.27 1.48 5 5 0 0 0-2.85.28l-.33.12c-.81.28-1.77.61-3.01.61-1.43 0-2.43-.43-3.31-.8l-.03-.01a6.5 6.5 0 0 0-2.75-.69c-1.1 0-1.87.32-2.74.69l-.03.01c-.88.37-1.88.8-3.31.8a.75.75 0 0 1 0-1.5c1.11 0 1.87-.32 2.75-.69zm16.37 6.55a.75.75 0 0 0-1.04-.24l-.37.22q-.37.2-.96.49c-.8.37-1.71.68-2.38.68-.62 0-1.05-.25-1.66-.64l-.04-.02a4.4 4.4 0 0 0-2.41-.84c-1.06 0-1.86.46-2.48.83l-.04.02c-.66.39-1.13.65-1.76.65a1 1 0 0 1-.56-.12 2 2 0 0 1-.37-.37L7.8 18c-.15-.18-.38-.44-.7-.64Q6.55 17 5.74 17c-1.07 0-1.97.47-2.57.89a6 6 0 0 0-1 .87.75.75 0 0 0 1.14.98l.18-.18q.18-.19.54-.45a3 3 0 0 1 1.71-.61 1 1 0 0 1 .56.12c.11.07.2.17.37.37l.02.02c.15.18.38.44.7.64q.54.35 1.35.35c1.06 0 1.86-.46 2.47-.83l.05-.02c.65-.39 1.13-.65 1.76-.65.61 0 1.05.25 1.66.64l.03.02c.59.37 1.35.84 2.42.84 1.03 0 2.18-.44 3.01-.82a16 16 0 0 0 1.5-.8.75.75 0 0 0 .24-1.03"
]);
const $7972e53b1de568ed$export$3257e483dc35bf5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch28Filled', "28", [
    "M2 6a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1m11.46 7.92A9 9 0 0 0 17.47 15c1.52 0 2.69-.46 3.65-.83l.39-.15a5.4 5.4 0 0 1 3.29-.37 1 1 0 0 0 .4-1.96 7.3 7.3 0 0 0-4.4.46l-.42.16c-.97.37-1.78.69-2.9.69-1.28 0-2.15-.4-3.2-.9l-.03-.02A9 9 0 0 0 10.24 11c-1.75 0-2.97.58-4.02 1.08l-.03.02c-1.05.5-1.92.9-3.19.9a1 1 0 1 0 0 2c1.74 0 2.97-.58 4.01-1.08l.04-.02c1.05-.5 1.92-.9 3.19-.9s2.14.4 3.18.9zM2.39 22.79a1 1 0 0 0 1.45-.23 5 5 0 0 1 .8-.77A3.3 3.3 0 0 1 6.57 21c.33 0 .47.07.56.13.12.09.22.21.43.48l.02.03c.18.23.45.6.86.87q.66.48 1.7.49c1.32 0 2.3-.65 3.02-1.12l.07-.04c.79-.52 1.31-.84 2-.84.66 0 1.13.3 1.86.82l.06.04A5 5 0 0 0 20.1 23c1.28 0 2.69-.6 3.67-1.11a18 18 0 0 0 1.8-1.07 1 1 0 0 0-1.15-1.64l-.44.29q-.44.27-1.13.64c-.95.5-1.99.89-2.75.89-.66 0-1.13-.3-1.87-.82l-.06-.04A5 5 0 0 0 15.22 19a5.4 5.4 0 0 0-3.03 1.12l-.06.04c-.8.52-1.32.84-2 .84-.32 0-.47-.07-.56-.13a2 2 0 0 1-.42-.48l-.03-.03c-.18-.23-.45-.6-.85-.87a3 3 0 0 0-1.7-.49c-1.34 0-2.45.65-3.17 1.21a8 8 0 0 0-1.2 1.18 1 1 0 0 0 .2 1.4"
]);
const $7972e53b1de568ed$export$4705987cef792ac3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch28Regular', "28", [
    "M2 5.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75m11.56 8.2A9 9 0 0 0 17.55 15c1.5 0 2.64-.44 3.63-.81l.4-.15a6 6 0 0 1 3.52-.39.75.75 0 1 0 .3-1.47 7.4 7.4 0 0 0-4.34.45l-.43.16c-.99.38-1.87.71-3.08.71a7.4 7.4 0 0 1-3.38-.93l-.03-.01c-1.07-.5-2.27-1.06-3.99-1.06s-2.92.56-3.99 1.06l-.03.01c-1.07.5-2.01.93-3.38.93a.75.75 0 0 0 0 1.5c1.72 0 2.92-.56 3.99-1.06l.03-.01a7.4 7.4 0 0 1 3.38-.93c1.37 0 2.31.43 3.38.93zM2.3 22.84c.32.25.8.19 1.05-.14l.23-.25q.25-.27.68-.62c.6-.45 1.34-.84 2.15-.84.39 0 .6.09.73.18.17.11.3.27.5.53l.02.03c.19.23.44.56.82.82.42.28.92.44 1.58.44 1.26 0 2.2-.6 2.95-1.09l.05-.03c.8-.51 1.4-.88 2.2-.88.78 0 1.33.36 2.08.87l.04.03c.7.48 1.6 1.1 2.88 1.1 1.23 0 2.62-.57 3.62-1.08a18 18 0 0 0 1.8-1.05.75.75 0 0 0-.84-1.24l-.46.3q-.45.27-1.18.65c-.97.5-2.09.92-2.94.92-.78 0-1.33-.36-2.08-.87l-.04-.03c-.7-.48-1.6-1.1-2.88-1.1-1.26 0-2.2.6-2.96 1.09l-.05.03c-.8.51-1.4.88-2.2.88-.38 0-.59-.09-.73-.18q-.22-.15-.5-.53l-.02-.03a2.72 2.72 0 0 0-2.4-1.26c-1.27 0-2.34.6-3.05 1.16a8 8 0 0 0-1.18 1.13c-.26.32-.2.8.13 1.05"
]);
const $7972e53b1de568ed$export$2b86a724a5309e6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch32Filled', "32", [
    "M2 7.25C2 6.56 2.56 6 3.25 6h25.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 8.5 2 7.94 2 7.25m13.3 9.39c1.22.62 2.66 1.36 4.72 1.36 1.8 0 3.19-.58 4.3-1.05l.45-.19c1.18-.48 2.2-.8 3.7-.46a1.25 1.25 0 0 0 .55-2.44 8 8 0 0 0-5.2.59l-.49.2a8 8 0 0 1-3.3.85c-1.43 0-2.41-.49-3.63-1.11l-.05-.03c-1.2-.62-2.65-1.36-4.71-1.36s-3.51.74-4.72 1.36l-.05.03c-1.22.62-2.2 1.11-3.62 1.11a1.25 1.25 0 1 0 0 2.5c2.06 0 3.5-.74 4.72-1.36L8 16.6c1.22-.62 2.2-1.11 3.63-1.11s2.4.49 3.62 1.11zM2.24 25.03a1.25 1.25 0 0 0 2.04 1.45l.05-.07a6 6 0 0 1 .92-.96 3.5 3.5 0 0 1 2.15-.95c.34 0 .48.08.56.14.13.1.24.24.48.58l.03.04c.2.3.53.75 1 1.1q.81.62 2.06.64c1.58 0 2.75-.83 3.59-1.42l.08-.06c.93-.66 1.5-1.02 2.23-1.02.7 0 1.21.34 2.08 1l.07.05c.79.6 1.9 1.45 3.51 1.45 1.53 0 3.2-.77 4.33-1.4a21 21 0 0 0 2.1-1.35 1.25 1.25 0 0 0-1.51-2l-.5.36q-.5.33-1.3.8c-1.11.61-2.28 1.09-3.12 1.09-.7 0-1.21-.34-2.08-1l-.07-.05A5.7 5.7 0 0 0 17.42 22c-1.59 0-2.76.83-3.59 1.42l-.08.06c-.93.66-1.5 1.02-2.23 1.02-.34 0-.48-.08-.56-.14-.13-.1-.25-.24-.49-.58l-.03-.04c-.2-.3-.52-.75-1-1.1A3.3 3.3 0 0 0 7.4 22c-1.62 0-2.94.84-3.77 1.55a9 9 0 0 0-1.35 1.43z"
]);
const $7972e53b1de568ed$export$1006995812a0c7af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch32Regular', "32", [
    "M29 8H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h26a1 1 0 0 1 1 1 1 1 0 0 1-1 1m-8.9 9.5a10 10 0 0 1-4.72-1.36l-.02-.01c-1.21-.6-2.26-1.13-3.8-1.13-1.56 0-2.6.52-3.81 1.13l-.02.01A10 10 0 0 1 3 17.5a1 1 0 0 1 0-2c1.55 0 2.6-.53 3.83-1.14A10 10 0 0 1 11.55 13c2.03 0 3.46.72 4.73 1.36l.02.01c1.21.6 2.26 1.13 3.8 1.13a9 9 0 0 0 3.45-.86l.06-.02c1.48-.61 3.16-1.3 5.6-.77a1 1 0 1 1-.42 1.95c-1.84-.4-3.04.09-4.43.66h-.02c-1.16.49-2.49 1.03-4.24 1.03zm-.35 7.53c.9.68 1.95 1.45 3.47 1.45v.02c2.66 0 6-2.41 6.37-2.7a1 1 0 0 0 .21-1.4 1 1 0 0 0-1.4-.2c-.86.64-3.48 2.3-5.18 2.3-.86 0-1.52-.49-2.27-1.04l-.01-.01c-.91-.68-1.96-1.45-3.48-1.45-1.51 0-2.6.75-3.56 1.41l-.02.02-.02.01c-.82.56-1.54 1.05-2.42 1.05-.68 0-.87-.25-1.27-.79l-.03-.04C9.66 23 8.94 22 7.22 22c-2.85 0-4.89 2.72-5.02 2.9a1 1 0 0 0 .21 1.4c.45.31 1.08.21 1.4-.23l.02-.01c.15-.2 1.62-2.07 3.4-2.07.67 0 .86.25 1.26.79l.03.04c.48.66 1.21 1.66 2.92 1.66 1.51 0 2.6-.75 3.56-1.41l.02-.02c.83-.57 1.57-1.06 2.44-1.06s1.53.47 2.29 1.04"
]);
const $7972e53b1de568ed$export$7fedf7e85e8feb9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness20Filled', "20", [
    "M2.75 4a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 9.25C2 8.56 2.56 8 3.25 8h13.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 10.5 2 9.94 2 9.25m0 5.5c0-.97.78-1.75 1.75-1.75h12.5a1.75 1.75 0 1 1 0 3.5H3.75c-.97 0-1.75-.78-1.75-1.75"
]);
const $7972e53b1de568ed$export$19db97b4eabd1ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 10c0-.83.67-1.5 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13A1.5 1.5 0 0 1 2 14.5M3 8a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$5992ccaf41073ea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness24Filled', "24", [
    "M3 3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm-1 7.5C2 9.67 2.67 9 3.5 9h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 10.5M2 18c0-1.1.9-2 2-2h16a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2"
]);
const $7972e53b1de568ed$export$1c2e65b07475c070 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness24Regular', "24", [
    "M2.75 3.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5zM2 10.75c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 12 2 11.44 2 10.75m0 7.5c0-.97.78-1.75 1.75-1.75h16.5a1.75 1.75 0 1 1 0 3.5H3.75C2.78 20 2 19.22 2 18.25"
]);
const $7972e53b1de568ed$export$c00293a2c85493b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link12Filled', "12", [
    "M1.5 5.2c0-1.5 1.2-2.7 2.7-2.7h.05a.75.75 0 0 1 0 1.5H4.2C3.54 4 3 4.54 3 5.2v.6C3 6.46 3.54 7 4.2 7h.05a.75.75 0 0 1 0 1.5H4.2a2.7 2.7 0 0 1-2.7-2.7zm9 0c0-1.5-1.2-2.7-2.7-2.7h-.05a.75.75 0 0 0 0 1.5h.05C8.46 4 9 4.54 9 5.2v.6C9 6.46 8.46 7 7.8 7h-.05a.75.75 0 0 0 0 1.5h.05c1.5 0 2.7-1.2 2.7-2.7zm-5.75-.45a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z"
]);
const $7972e53b1de568ed$export$7f23d7ac1501b48d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link12Regular', "12", [
    "M2 5.4A2.4 2.4 0 0 1 4.4 3h.1a.5.5 0 0 1 0 1h-.1C3.63 4 3 4.63 3 5.4v.2C3 6.37 3.63 7 4.4 7h.1a.5.5 0 0 1 0 1h-.1A2.4 2.4 0 0 1 2 5.6zm8 0A2.4 2.4 0 0 0 7.6 3h-.1a.5.5 0 0 0 0 1h.1C8.37 4 9 4.63 9 5.4v.2C9 6.37 8.37 7 7.6 7h-.1a.5.5 0 0 0 0 1h.1A2.4 2.4 0 0 0 10 5.6zM4.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$8046b841ac4c016f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link16Filled', "16", [
    "M9.75 4h.52a3.74 3.74 0 0 1 .2 7.5h-.71a.75.75 0 0 1-.12-1.49h.1l.53-.01c1.23 0 2.23-1 2.23-2.25 0-1.2-.92-2.17-2.08-2.24l-.15-.01h-.52a.75.75 0 0 1-.1-1.5zh.52zm-4 0h.5a.75.75 0 0 1 .1 1.5h-.6A2.25 2.25 0 0 0 5.6 10h.65a.75.75 0 0 1 .1 1.5h-.6a3.75 3.75 0 0 1-.2-7.5zh.5zm0 3h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5zh4.5z"
]);
const $7972e53b1de568ed$export$88722466d3a220e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link16Regular', "16", [
    "M9.5 4h1a3.5 3.5 0 0 1 .2 7H9.5a.5.5 0 0 1-.1-.99h.1l1-.01a2.5 2.5 0 0 0 .16-5H9.5a.5.5 0 0 1-.09-1zh1zm-4 0h1a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.5a.5.5 0 0 1 .09 1H5.5a3.5 3.5 0 0 1-.2-7zh1zm0 3h5a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1z"
]);
const $7972e53b1de568ed$export$9c96fa1ea6f6c59b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_20_color__a)",
            "d": "M14 6a4 4 0 0 1 .2 8H12a.75.75 0 0 1-.1-1.5H14a2.5 2.5 0 0 0 .16-5H12a.75.75 0 0 1-.1-1.5H14M8 6a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8M6.25 9.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zh7.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_20_color__a",
                "x1": "-3.14",
                "x2": "3.2",
                "y1": "2.5",
                "y2": "21.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$ef737b7be8ff51b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link20Filled', "20", [
    "M14 6a4 4 0 0 1 .2 8H12a.75.75 0 0 1-.1-1.5H14a2.5 2.5 0 0 0 .16-5H12a.75.75 0 0 1-.1-1.5H14M8 6a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8M6.25 9.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zh7.5z"
]);
const $7972e53b1de568ed$export$44f98338b7f512bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link20Regular', "20", [
    "M8 6a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 .22 8H12a.5.5 0 0 1-.09-1H14a3 3 0 0 0 .2-6H12a.5.5 0 0 1-.09-1H14M6 9.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1zh8z"
]);
const $7972e53b1de568ed$export$4819af48490fccbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_24_color__a)",
            "d": "M9 7a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9m8 0a5 5 0 0 1 .22 10H15a1 1 0 0 1-.12-2H17a3 3 0 0 0 .18-6H15a1 1 0 0 1-.12-2H17M7 11h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2zh10z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_24_color__a",
                "x1": "-4.43",
                "x2": "3.5",
                "y1": "2.63",
                "y2": "26.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$6ad003eb7d87e60f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link24Filled', "24", [
    "M9 7a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9m8 0a5 5 0 0 1 .22 10H15a1 1 0 0 1-.12-2H17a3 3 0 0 0 .18-6H15a1 1 0 0 1-.12-2H17M7 11h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2zh10z"
]);
const $7972e53b1de568ed$export$abc41a13a016ef8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link24Regular', "24", [
    "M9.25 7a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5M17 7a5 5 0 0 1 .25 10h-2.5a.75.75 0 0 1-.11-1.5H17a3.5 3.5 0 0 0 .2-7h-2.45a.75.75 0 0 1-.11-1.5H17M7 11.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5zh10z"
]);
const $7972e53b1de568ed$export$1ac813cd0ce18e4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_28_color__a)",
            "d": "M11 8a1 1 0 0 1 .12 2H8a4 4 0 0 0-.2 8H11a1 1 0 0 1 .12 2H8a6 6 0 0 1-.22-12H11m9 0a6 6 0 0 1 .22 12H17a1 1 0 0 1-.12-2H20a4 4 0 0 0 .2-8H17a1 1 0 0 1-.12-2H20M8 13h12a1 1 0 0 1 .12 2H8a1 1 0 0 1-.12-2zh12z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_28_color__a",
                "x1": "-5.71",
                "x2": "3.81",
                "y1": "2.75",
                "y2": "31.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$3da22c0efc281878 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link28Filled', "28", [
    "M11 8a1 1 0 0 1 .12 2H8a4 4 0 0 0-.2 8H11a1 1 0 0 1 .12 2H8a6 6 0 0 1-.22-12H11m9 0a6 6 0 0 1 .22 12H17a1 1 0 0 1-.12-2H20a4 4 0 0 0 .2-8H17a1 1 0 0 1-.12-2H20M8 13h12a1 1 0 0 1 .12 2H8a1 1 0 0 1-.12-2zh12z"
]);
const $7972e53b1de568ed$export$594bc4bc55f4df0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link28Regular', "28", [
    "M11 8a.75.75 0 0 1 .1 1.5H8a4.5 4.5 0 0 0-.21 9H11a.75.75 0 0 1 .1 1.5H8a6 6 0 0 1-.22-12H11m9 0a6 6 0 0 1 .22 12H17a.75.75 0 0 1-.1-1.5H20a4.5 4.5 0 0 0 .21-9H17a.75.75 0 0 1-.1-1.5H20M8 13.25h12a.75.75 0 0 1 .1 1.5H8a.75.75 0 0 1-.1-1.5zh12z"
]);
const $7972e53b1de568ed$export$97cc07605a6150bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_32_color__a)",
            "d": "M2 16.25C2 12.25 5.25 9 9.25 9h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a4.75 4.75 0 1 0 0 9.5h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-4 0-7.25-3.25-7.25-7.25m28 0c0-4-3.25-7.25-7.25-7.25h-3.5a1.25 1.25 0 1 0 0 2.5h3.5a4.75 4.75 0 1 1 0 9.5h-3.5a1.25 1.25 0 1 0 0 2.5h3.5c4 0 7.25-3.25 7.25-7.25M9.75 15a1.25 1.25 0 1 0 0 2.5h12.5a1.25 1.25 0 1 0 0-2.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_32_color__a",
                "x1": "-7",
                "x2": "4.83",
                "y1": "2.66",
                "y2": "37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$3d6bd6f3c4fb1f36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Filled', "32", [
    "M2 16.25C2 12.25 5.25 9 9.25 9h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a4.75 4.75 0 1 0 0 9.5h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-4 0-7.25-3.25-7.25-7.25m28 0c0-4-3.25-7.25-7.25-7.25h-3.5a1.25 1.25 0 1 0 0 2.5h3.5a4.75 4.75 0 1 1 0 9.5h-3.5a1.25 1.25 0 1 0 0 2.5h3.5c4 0 7.25-3.25 7.25-7.25M9.75 15a1.25 1.25 0 1 0 0 2.5h12.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $7972e53b1de568ed$export$ca2bd101c59ea045 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Light', "32", [
    "M2 15.5A6.5 6.5 0 0 1 8.5 9h5a.5.5 0 0 1 0 1h-5a5.5 5.5 0 1 0 0 11h5a.5.5 0 0 1 0 1h-5A6.5 6.5 0 0 1 2 15.5m28 0A6.5 6.5 0 0 0 23.5 9h-5a.5.5 0 0 0 0 1h5a5.5 5.5 0 1 1 0 11h-5a.5.5 0 0 0 0 1h5a6.5 6.5 0 0 0 6.5-6.5M9.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $7972e53b1de568ed$export$cbbb641296c2180 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Regular', "32", [
    "M2 16a7 7 0 0 1 7-7h4a1 1 0 1 1 0 2H9a5 5 0 0 0 0 10h4a1 1 0 1 1 0 2H9a7 7 0 0 1-7-7m28 0a7 7 0 0 0-7-7h-4a1 1 0 1 0 0 2h4a5 5 0 0 1 0 10h-4a1 1 0 1 0 0 2h4a7 7 0 0 0 7-7M9.5 15a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2z"
]);
const $7972e53b1de568ed$export$2f7464e195ffa606 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link48Filled', "48", [
    "M33.25 13c5.84 0 10.6 4.66 10.75 10.46v.79c0 5.84-4.66 10.6-10.46 10.75h-4.79a1.75 1.75 0 0 1-.14-3.5h4.64a7.25 7.25 0 0 0 7.25-7.01v-.74a7.25 7.25 0 0 0-7.01-7.25h-4.74a1.75 1.75 0 0 1-.14-3.5h4.64m-14 0a1.75 1.75 0 0 1 .14 3.5h-4.64a7.25 7.25 0 0 0-7.25 7.01v.74a7.25 7.25 0 0 0 7.01 7.25h4.74a1.75 1.75 0 0 1 .14 3.5h-4.64C8.91 35 4.15 30.34 4 24.54v-.79C4 17.91 8.66 13.15 14.46 13h4.79M14 22.25h20a1.75 1.75 0 0 1 .14 3.5H14a1.75 1.75 0 0 1-.14-3.5zh20z"
]);
const $7972e53b1de568ed$export$bcdc3f59f71243bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link48Regular', "48", [
    "M34 14a10 10 0 0 1 .28 20h-6.03a1.25 1.25 0 0 1-.13-2.5H34a7.5 7.5 0 0 0 .24-15h-5.99a1.25 1.25 0 0 1-.13-2.5H34m-14.25 0a1.25 1.25 0 0 1 .13 2.5H14a7.5 7.5 0 0 0-.24 15h5.99a1.25 1.25 0 0 1 .13 2.5H14a10 10 0 0 1-.28-20h6.03M13 22.75h22a1.25 1.25 0 0 1 .13 2.5H13a1.25 1.25 0 0 1-.13-2.5zh22z"
]);
const $7972e53b1de568ed$export$8ef5c6a0156192b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd16Filled', "16", [
    "M9.75 3h.52c2 0 3.65 1.6 3.73 3.6a6 6 0 0 0-1.6-.53 2.2 2.2 0 0 0-1.98-1.56l-.15-.01h-.52a.75.75 0 0 1-.1-1.5zm-3.66 7.5q.14-.75.47-1.43A1 1 0 0 0 6.25 9H5.6a2.25 2.25 0 0 1 .15-4.5h.6a.75.75 0 0 0-.1-1.5h-.7a3.75 3.75 0 0 0 .2 7.5zm1.64-3a5.5 5.5 0 0 1 2.85-1.42 1 1 0 0 0-.33-.08h-4.6a.75.75 0 0 0 .1 1.5zm8.27 4a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $7972e53b1de568ed$export$ec757a5abd117183 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd16Regular', "16", [
    "M9.5 3h1A3.5 3.5 0 0 1 14 6.6q-.48-.25-1.02-.4A2.5 2.5 0 0 0 10.66 4H9.5a.5.5 0 0 1-.09-1zm-3.3 7q.16-.52.4-1H5.34a2.5 2.5 0 0 1 .16-5h1.09a.5.5 0 0 0-.09-1H5.3a3.5 3.5 0 0 0 .2 7zm2.14-3q1.05-.75 2.38-.95A1 1 0 0 0 10.5 6H5.41a.5.5 0 0 0 .09 1zM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $7972e53b1de568ed$export$8bcb62cd58cc021e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd20Filled', "20", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 2 3.76q.73.23 1.36.64.46-.85.48-1.9M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75m5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $7972e53b1de568ed$export$9f404c349cb73bce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd20Regular', "20", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5M18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.44 4.43q.46.2.88.47.46-.85.48-1.9m-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1m5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $7972e53b1de568ed$export$e88262683062ffa7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd24Filled', "24", [
    "M9 5a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9m8 0a5 5 0 0 1 4.43 7.32 7 7 0 0 0-1.76-.95q.32-.62.33-1.37a3 3 0 0 0-2.82-3H15a1 1 0 0 1-.12-2H17M7 9h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2zm16 8.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $7972e53b1de568ed$export$8c09e551469358f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd24Regular', "24", [
    "M9.25 5a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5M17 5a5 5 0 0 1 4.43 7.32 7 7 0 0 0-1.3-.76q.36-.71.37-1.56a3.5 3.5 0 0 0-3.3-3.5h-2.45a.75.75 0 0 1-.11-1.5H17M7 9.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5zm16 8.25a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $7972e53b1de568ed$export$823703571d909351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss16Filled', "16", [
    "M10.27 3h-.62a.75.75 0 0 0 .1 1.5h.67c.93.07 1.7.7 1.98 1.57q.85.15 1.6.53c-.08-2-1.72-3.6-3.73-3.6m-3.7 6.07q-.35.68-.48 1.43h-.34a3.75 3.75 0 0 1-.2-7.5h.7a.75.75 0 0 1 .1 1.5h-.6A2.25 2.25 0 0 0 5.6 9h.65q.17 0 .31.07m4.01-3c-1.1.2-2.08.7-2.85 1.43H5.75a.75.75 0 0 1-.1-1.5h4.6q.18 0 .33.08M11.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $7972e53b1de568ed$export$39689b681c7a806 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss16Regular', "16", [
    "M10.5 3H9.41a.5.5 0 0 0 .09 1h1.16a2.5 2.5 0 0 1 2.32 2.2q.54.15 1.02.4v-.1A3.5 3.5 0 0 0 10.5 3M6.6 9q-.24.48-.4 1h-.7a3.5 3.5 0 0 1-.2-7h1.2a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.6m4.12-2.95q-1.33.2-2.38.95H5.5a.5.5 0 0 1-.09-1h5.09a1 1 0 0 1 .22.05M11.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $7972e53b1de568ed$export$8e000df0be771abc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss20Filled', "20", [
    "M14 4a4 4 0 0 1 3.52 5.9q-.63-.42-1.36-.64.33-.56.34-1.26a2.5 2.5 0 0 0-2.34-2.5H12a.75.75 0 0 1-.1-1.5H14M8 4a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8M6.25 7.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.73-1.06a.5.5 0 0 0-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 0 0-.7.7l1.05 1.07-1.06 1.06a.5.5 0 0 0 .7.7l1.07-1.05 1.06 1.06a.5.5 0 0 0 .7-.7l-1.05-1.07z"
]);
const $7972e53b1de568ed$export$b097a138c0022014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss20Regular', "20", [
    "M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 3.52 5.9 6 6 0 0 0-.88-.47Q16.99 8.8 17 8a3 3 0 0 0-2.8-3H12a.5.5 0 0 1-.09-1H14M6 7.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1zm13 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.73-1.06a.5.5 0 0 0-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 0 0-.7.7l1.05 1.07-1.06 1.06a.5.5 0 0 0 .7.7l1.07-1.05 1.06 1.06a.5.5 0 0 0 .7-.7l-1.05-1.07z"
]);
const $7972e53b1de568ed$export$32f580bf224b1962 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss24Filled', "24", [
    "M9 5a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9m8 0a5 5 0 0 1 4.43 7.32 7 7 0 0 0-1.76-.95q.32-.62.33-1.37a3 3 0 0 0-2.82-3H15a1 1 0 0 1-.12-2H17M7 9h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2zm16 8.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $7972e53b1de568ed$export$840a9b568b1ce6a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss24Regular', "24", [
    "M9.25 5a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5M17 5a5 5 0 0 1 4.43 7.32 7 7 0 0 0-1.3-.76q.36-.71.37-1.56a3.5 3.5 0 0 0-3.3-3.5h-2.45a.75.75 0 0 1-.11-1.5H17M7 9.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5zm16 8.25a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64z"
]);
const $7972e53b1de568ed$export$abcf470e5f5f58a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit16Filled', "16", [
    "M10.26 3h-.61a.75.75 0 0 0 .1 1.5h.67c.67.05 1.26.4 1.63.9.46-.3 1-.43 1.52-.4a3.7 3.7 0 0 0-3.3-2m.67 3.44L9.88 7.5H5.75a.75.75 0 0 1-.1-1.5h4.6c.3 0 .57.18.68.44m2.26-.42q-.4.06-.73.32l-.12.11L9 9.8l-.95.95q-.54.54-.73 1.3l-.3 1.2a.6.6 0 0 0 .73.74l1.22-.3q.74-.2 1.29-.73l4.28-4.29a1.56 1.56 0 0 0-1.35-2.64M6.25 3h-.7a3.75 3.75 0 0 0 .2 7.5h.6a.75.75 0 0 0-.1-1.5H5.6a2.25 2.25 0 0 1 .15-4.5h.6a.75.75 0 0 0-.1-1.5"
]);
const $7972e53b1de568ed$export$65a17f2954d2e295 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit16Regular', "16", [
    "M10.5 3H9.4a.5.5 0 0 0 .1 1h1.16c.81.06 1.52.5 1.94 1.14q.52-.18 1.06-.13A3.5 3.5 0 0 0 10.5 3m.49 3.39-.61.61H5.5a.5.5 0 0 1-.09-1h5.09a.5.5 0 0 1 .49.39m2.15-.36q-.09 0-.18.04-.35.12-.62.38L9.06 9.73l-1.01 1.01q-.54.54-.73 1.3l-.3 1.2a.6.6 0 0 0 .73.74l1.22-.3q.74-.2 1.29-.73l4.28-4.29a1.56 1.56 0 0 0-1.4-2.63M6.5 3H5.3a3.5 3.5 0 0 0 .2 7h1l.09-.01a.5.5 0 0 0-.1-1H5.35A2.5 2.5 0 0 1 5.5 4h1.09a.5.5 0 0 0-.1-1"
]);
const $7972e53b1de568ed$export$6c67f1752e0c4092 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit20Filled', "20", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16A2.5 2.5 0 0 1 16.5 8v.02q.8.1 1.45.63Q18 8.33 18 8M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75m5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5m-3.77 7.13 4.83-4.83a1.87 1.87 0 0 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.08l.37-1.5q.15-.58.58-1.01"
]);
const $7972e53b1de568ed$export$f7436826a7ddbac9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit20Regular', "20", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09a.5.5 0 0 0-.1-1H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .4-.5M18 8a4 4 0 0 0-4-4h-2.1a.5.5 0 0 0 .1 1h2.2A3 3 0 0 1 17 8.14q.5.16.95.52Q18 8.33 18 8m-4-.5H5.9a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.1-1m-4.02 6.88 4.83-4.83a1.87 1.87 0 0 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.08l.37-1.5q.15-.58.58-1.01"
]);
const $7972e53b1de568ed$export$5eb4108855ac04fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit24Filled', "24", [
    "M10 6a1 1 0 0 0-1-1H6.78A5 5 0 0 0 7 15h2.12A1 1 0 0 0 9 13H6.82A3 3 0 0 1 7 7h2.12A1 1 0 0 0 10 6m12 4a5 5 0 0 0-5-5h-2.12A1 1 0 0 0 15 7h2.17A3 3 0 0 1 20 10V10q1.07.09 1.93.84.06-.41.07-.85m-4.23.64q-.15.1-.29.24a1 1 0 0 1-.36.11H7a1 1 0 0 1-.12-1.98L7 9h10a1 1 0 0 1 .77 1.64m.33 1.03-5.9 5.9q-.53.53-.71 1.25l-.46 1.83c-.2.8.52 1.52 1.32 1.32l1.83-.46q.72-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $7972e53b1de568ed$export$9f32c233a9965a7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit24Regular', "24", [
    "M10 5.75A.75.75 0 0 0 9.25 5h-2.5A5 5 0 0 0 7 15h2.36a.75.75 0 0 0-.11-1.5H6.8a3.5 3.5 0 0 1 .2-7h2.36a.75.75 0 0 0 .64-.75M22 10a5 5 0 0 0-5-5h-2.36a.75.75 0 0 0 .1 1.5h2.46a3.5 3.5 0 0 1 3.3 3.6q.78.18 1.43.75.06-.41.07-.85m-5-.75H6.9a.75.75 0 0 0 .1 1.5h10.1a.75.75 0 0 0-.1-1.5m1.1 2.42-5.9 5.9q-.53.53-.71 1.25l-.46 1.83c-.2.8.52 1.52 1.32 1.32l1.83-.46q.72-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $7972e53b1de568ed$export$9342e7344c53516d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_16_color__a)",
            "fillRule": "evenodd",
            "d": "M1 6.25C1 4.45 2.46 3 4.25 3h4.5a3.25 3.25 0 0 1 0 6.5h-4.5A3.25 3.25 0 0 1 1 6.25M4.25 4.5a1.75 1.75 0 1 0 0 3.5h4.5a1.75 1.75 0 1 0 0-3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_16_color__b)",
            "fillRule": "evenodd",
            "d": "M1 6.25C1 4.45 2.46 3 4.25 3h4.5a3.25 3.25 0 0 1 0 6.5h-4.5A3.25 3.25 0 0 1 1 6.25M4.25 4.5a1.75 1.75 0 1 0 0 3.5h4.5a1.75 1.75 0 1 0 0-3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_16_color__c)",
            "fillRule": "evenodd",
            "d": "M1 6.25C1 4.45 2.46 3 4.25 3h4.5a3.25 3.25 0 0 1 0 6.5h-4.5A3.25 3.25 0 0 1 1 6.25M4.25 4.5a1.75 1.75 0 1 0 0 3.5h4.5a1.75 1.75 0 1 0 0-3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_16_color__d)",
            "d": "M10.48 6.5H7.25a3.25 3.25 0 1 0 0 6.5h4.5a3.25 3.25 0 0 0 .24-6.5 3 3 0 0 1-.5 1.5h.26a1.75 1.75 0 1 1 0 3.5h-4.5A1.75 1.75 0 0 1 7 8.02V8h1.75c.88 0 1.61-.65 1.73-1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_16_color__e)",
            "d": "M10.48 6.5H7.25a3.25 3.25 0 1 0 0 6.5h4.5a3.25 3.25 0 0 0 .24-6.5 3 3 0 0 1-.5 1.5h.26a1.75 1.75 0 1 1 0 3.5h-4.5A1.75 1.75 0 0 1 7 8.02V8h1.75c.88 0 1.61-.65 1.73-1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_16_color__f)",
            "d": "M10.48 6.5H7.25a3.25 3.25 0 1 0 0 6.5h4.5a3.25 3.25 0 0 0 .24-6.5 3 3 0 0 1-.5 1.5h.26a1.75 1.75 0 1 1 0 3.5h-4.5A1.75 1.75 0 0 1 7 8.02V8h1.75c.88 0 1.61-.65 1.73-1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(9.00003 7.00003 -6.27 8.06142 1.5 3)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#367af2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#5750e2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6f47df"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-5 0 0 -5.07351 7.5 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".5",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".87",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.5 0 0 4.56616 9 6)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_16_color__c",
                "x1": "12",
                "x2": "6.36",
                "y1": "8",
                "y2": "3.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".07",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".6",
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_16_color__d",
                "x1": ".46",
                "x2": "6.33",
                "y1": "3.66",
                "y2": "18.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_16_color__f",
                "x1": "4",
                "x2": "9.53",
                "y1": "5",
                "y2": "7.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#31b3ee",
                    "stopOpacity": ".24"
                }
            ],
            [
                "stop",
                {
                    "offset": ".21",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".76",
                    "stopColor": "#31b3ee",
                    "stopOpacity": ".9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#31b3ee",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$5fa721e60ed026c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple16Filled', "16", [
    "M1 6.5A3.5 3.5 0 0 1 4.5 3h4a3.5 3.5 0 0 1 3.47 3.03 4 4 0 0 1-.12 1.5A3.5 3.5 0 0 1 8.5 10h-.75a.75.75 0 0 1 0-1.5h.75a2 2 0 1 0 0-4h-4a2 2 0 0 0-1.26 3.55A5 5 0 0 0 3 9.66 3.5 3.5 0 0 1 1 6.5m8 .25c0 .41-.34.75-.75.75H7.5a2 2 0 1 0 0 4h4a2 2 0 0 0 1.26-3.55A5 5 0 0 0 13 6.34 3.5 3.5 0 0 1 11.5 13h-4a3.5 3.5 0 1 1 0-7h.75c.41 0 .75.34.75.75"
]);
const $7972e53b1de568ed$export$56d5e3c599109c15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple16Regular', "16", [
    "M12 6.5A3.5 3.5 0 0 0 8.5 3H4.3A3.5 3.5 0 0 0 3 9.67a5 5 0 0 1 .1-1.1A2.5 2.5 0 0 1 4.5 4h4.16a2.5 2.5 0 0 1-.16 5h-1l-.1.01a.5.5 0 0 0 .1 1l1-.01h.2A3.5 3.5 0 0 0 12 6.5m2 3a2.5 2.5 0 0 0-1.1-2.07 5 5 0 0 0 .1-1.1A3.5 3.5 0 0 1 11.7 13l-.2.01h-4a3.5 3.5 0 0 1-.2-7h1.2a.5.5 0 0 1 .09 1H7.5a2.5 2.5 0 0 0-.16 5h4.16A2.5 2.5 0 0 0 14 9.5"
]);
const $7972e53b1de568ed$export$3f8b07c3e79171 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__a)",
            "fillRule": "evenodd",
            "d": "M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8m6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__b)",
            "fillRule": "evenodd",
            "d": "M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8m6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__c)",
            "fillRule": "evenodd",
            "d": "M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8m6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__d)",
            "d": "M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8q-.01 1.1-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__e)",
            "d": "M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8q-.01 1.1-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__f)",
            "d": "M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8q-.01 1.1-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(36.95 -5.17 4.45)scale(14.3329 12.726)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#367af2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#5750e2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6f47df"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-6 0 0 -5.8875 9 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".23",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".4",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".78",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 0 0 5.8875 11 8)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".23",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".4",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".78",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__c",
                "x1": "13.5",
                "x2": "8",
                "y1": "13",
                "y2": "4.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".07",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".6",
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__d",
                "x1": ".5",
                "x2": "7.54",
                "y1": "4.5",
                "y2": "23.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__f",
                "x1": "9.5",
                "x2": "13",
                "y1": "5",
                "y2": "11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#31b3ee",
                    "stopOpacity": ".24"
                }
            ],
            [
                "stop",
                {
                    "offset": ".21",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".57",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".88",
                    "stopColor": "#31b3ee",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$8b77bb1b2a400ede = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple20Filled', "20", [
    "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H9.75a.75.75 0 0 1 0-1.5H11a2.5 2.5 0 0 0 0-5H5a2.5 2.5 0 0 0-.74 4.89q-.24.71-.26 1.48A4 4 0 0 1 1 8m15 .13q-.02.77-.26 1.48A2.5 2.5 0 0 1 15 14.5H9a2.5 2.5 0 0 1 0-5h1.25a.75.75 0 0 0 0-1.5H9a4 4 0 1 0 0 8h6a4 4 0 0 0 1-7.87"
]);
const $7972e53b1de568ed$export$2d1665b8a4dbd1b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple20Regular', "20", [
    "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H9.5a.5.5 0 0 1 0-1H11a3 3 0 1 0 0-6H5a3 3 0 0 0-.87 5.87 5 5 0 0 0-.13 1A4 4 0 0 1 1 8m17 4a3 3 0 0 0-2.13-2.87q.12-.49.13-1A4 4 0 0 1 15 16H9a4 4 0 0 1 0-8h1.5a.5.5 0 0 1 0 1H9a3 3 0 1 0 0 6h6a3 3 0 0 0 3-3"
]);
const $7972e53b1de568ed$export$75cc9e5735b9e300 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_24_color__a)",
            "fillRule": "evenodd",
            "d": "M1 10a5 5 0 0 1 5-5h7a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5m5-3a3 3 0 0 0 0 6h7a3 3 0 1 0 0-6z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_24_color__b)",
            "fillRule": "evenodd",
            "d": "M1 10a5 5 0 0 1 5-5h7a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5m5-3a3 3 0 0 0 0 6h7a3 3 0 1 0 0-6z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_24_color__c)",
            "fillRule": "evenodd",
            "d": "M1 10a5 5 0 0 1 5-5h7a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5m5-3a3 3 0 0 0 0 6h7a3 3 0 1 0 0-6z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_24_color__d)",
            "d": "M15.83 9H11a5 5 0 0 0 0 10h7a5 5 0 0 0 0-10h-.1a5 5 0 0 1 0 2h.1a3 3 0 1 1 0 6h-7a3 3 0 1 1 0-6h4.83a3 3 0 0 0 0-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_24_color__e)",
            "d": "M15.83 9H11a5 5 0 0 0 0 10h7a5 5 0 0 0 0-10h-.1a5 5 0 0 1 0 2h.1a3 3 0 1 1 0 6h-7a3 3 0 1 1 0-6h4.83a3 3 0 0 0 0-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_24_color__f)",
            "d": "M15.83 9H11a5 5 0 0 0 0 10h7a5 5 0 0 0 0-10h-.1a5 5 0 0 1 0 2h.1a3 3 0 1 1 0 6h-7a3 3 0 1 1 0-6h4.83a3 3 0 0 0 0-2"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.75 -6.43 5.1)scale(17.5909 15.7387)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#367af2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#5750e2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6f47df"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-7 0 0 -7.77785 10.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".42",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".57",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7 0 0 7.77785 13.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".25",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".4",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_24_color__c",
                "x1": "17",
                "x2": "8.38",
                "y1": "15.5",
                "y2": "5.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".07",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".32",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".6",
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_24_color__d",
                "x1": ".54",
                "x2": "11.12",
                "y1": "4.19",
                "y2": "28.78",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_24_color__f",
                "x1": "8.5",
                "x2": "16.77",
                "y1": "5",
                "y2": "12.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#31b3ee",
                    "stopOpacity": ".24"
                }
            ],
            [
                "stop",
                {
                    "offset": ".21",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".57",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".76",
                    "stopColor": "#31b3ee",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $7972e53b1de568ed$export$b80331c424392f59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple24Filled', "24", [
    "M6.5 4a5.5 5.5 0 0 0-1.99 10.63q.07-1.05.43-2A3.5 3.5 0 0 1 6.5 6h6a3.5 3.5 0 1 1 0 7H12a1 1 0 1 0 0 2h.5a5.5 5.5 0 1 0 0-11zm12.61 8.21A3 3 0 0 1 18 18h-7a3 3 0 1 1 0-6h1a1 1 0 0 0 0-2h-1a5 5 0 0 0 0 10h7a5 5 0 0 0 1.5-9.77q-.05 1.05-.39 1.98"
]);
const $7972e53b1de568ed$export$af23332fe76c60ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple24Regular', "24", [
    "M6.25 4a5.25 5.25 0 0 0-1.7 10.22q.1-.76.35-1.47A3.75 3.75 0 0 1 6.25 5.5h6.5a3.75 3.75 0 1 1 0 7.5h-1a.75.75 0 0 0 0 1.5h1a5.25 5.25 0 1 0 0-10.5zm13.14 6.2q-.14.75-.44 1.43A3.5 3.5 0 0 1 18 18.5h-7a3.5 3.5 0 1 1 0-7h1.25a.75.75 0 0 0 0-1.5H11a5 5 0 0 0 0 10h7a5 5 0 0 0 1.4-9.8"
]);
const $7972e53b1de568ed$export$1a21f806dde221d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOff20Filled', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L13.29 14H12a.75.75 0 0 1-.18-1.48l-1.78-1.77H6.25a.75.75 0 0 1-.1-1.5h2.4L6.78 7.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.65-7.95l-3.2-3.2a.5.5 0 0 1 0-.7M14 6a4 4 0 0 1 1.73 7.6l-1.17-1.16a2.5 2.5 0 0 0-.4-4.94H12a.75.75 0 0 1-.1-1.5H14m-.25 3.25a.75.75 0 0 1 .1 1.5h-.98l-1.5-1.5z"
]);
const $7972e53b1de568ed$export$b10bd40c46e49d4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOff20Regular', "20", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L13.29 14H12a.5.5 0 0 1-.09-1h.39l-2.5-2.5H6a.5.5 0 0 1-.09-1H8.8L6.3 7H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.65-7.95l-3.2-3.2a.5.5 0 0 1 0-.7M14 6a4 4 0 0 1 1.73 7.6l-.77-.76a3 3 0 0 0-.76-5.83L14 7h-2a.5.5 0 0 1-.09-1H14m0 3.5a.5.5 0 0 1 .09 1h-1.47l-1-1z"
]);
const $7972e53b1de568ed$export$8c31678c2c58d32e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOff24Filled', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06L15.94 17H15a1 1 0 0 1-.74-1.68L11.94 13H7a1 1 0 0 1-.12-2h3.06l-2-2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.97-9.9L2.22 3.27a.75.75 0 0 1 0-1.06M17 7a5 5 0 0 1 2.5 9.33l-1.5-1.5A3 3 0 0 0 17.18 9H15a1 1 0 0 1-.12-2H17m0 4a1 1 0 0 1 .12 2h-.94l-2-2z"
]);
const $7972e53b1de568ed$export$21ca57341b8c924 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOff24Regular', "24", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l18.5 18.5a.75.75 0 0 1-1.06 1.06L15.94 17h-1.19a.75.75 0 0 1-.26-1.45l-2.8-2.8H7a.75.75 0 0 1-.1-1.5h3.29L7.44 8.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.97-9.9L2.22 3.27a.75.75 0 0 1 0-1.06M17 7a5 5 0 0 1 2.5 9.33l-1.1-1.12a3.5 3.5 0 0 0-1.2-6.7L17 8.5h-2.25a.75.75 0 0 1-.11-1.5H17m0 4.25a.75.75 0 0 1 .1 1.5h-1.17l-1.5-1.5z"
]);
const $7972e53b1de568ed$export$81e884fb86fcb9c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOff28Filled', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06L18.94 20H17a1 1 0 0 1-.12-2h.06l-3-3H8a1 1 0 0 1-.12-2h4.06l-3-3H8a4 4 0 0 0-.2 8H11a1 1 0 0 1 .12 2H8a6 6 0 0 1-.98-11.92l-4.8-4.8a.75.75 0 0 1 0-1.06M20 8a6 6 0 0 1 2.6 11.41l-1.56-1.55A4 4 0 0 0 20.2 10H17a1 1 0 0 1-.12-2H20m0 5a1 1 0 0 1 .12 2h-1.94l-2-2z"
]);
const $7972e53b1de568ed$export$442fe13b6142f208 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOff28Regular', "28", [
    "M2.22 2.22c.3-.3.77-.3 1.06 0l22.5 22.5a.75.75 0 0 1-1.06 1.06L18.94 20H17a.75.75 0 0 1-.1-1.5h.54l-3.75-3.75H8a.75.75 0 0 1-.1-1.5h4.29L8.44 9.5H8a4.5 4.5 0 0 0-.21 9H11a.75.75 0 0 1 .1 1.5H8a6 6 0 0 1-.98-11.92l-4.8-4.8a.75.75 0 0 1 0-1.06M20 8a6 6 0 0 1 2.6 11.41l-1.16-1.15a4.5 4.5 0 0 0-1.23-8.76H17a.75.75 0 0 1-.1-1.5H20m0 5.25a.75.75 0 0 1 .1 1.5h-2.17l-1.5-1.5z"
]);
const $7972e53b1de568ed$export$422cfe50ece1c997 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson16Filled', "16", [
    "M9.75 3h.52a3.74 3.74 0 0 1 3.7 4.29 3 3 0 0 0-1.55-1.15 2.2 2.2 0 0 0-2-1.63l-.15-.01h-.52a.75.75 0 0 1-.1-1.5zM8.9 7.5a3 3 0 0 1 1.76-1.38 1 1 0 0 0-.41-.12h-4.6a.75.75 0 0 0 .1 1.5zM5.75 3h.5a.75.75 0 0 1 .1 1.5h-.6A2.25 2.25 0 0 0 5.6 9h.65a.75.75 0 0 1 .1 1.5h-.6a3.75 3.75 0 0 1-.2-7.5zm7.75 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 14.75 8 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $7972e53b1de568ed$export$78cb7947f3dfb1a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson16Regular', "16", [
    "M9.5 3h1a3.5 3.5 0 0 1 3.42 4.23A3 3 0 0 0 13 6.4 2.5 2.5 0 0 0 10.66 4H9.5a.5.5 0 0 1-.09-1zm-.24 4a3 3 0 0 1 1.52-.91.5.5 0 0 0-.28-.09H5.41a.5.5 0 0 0 .09 1zM5.5 3h1a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.5a.5.5 0 0 1 .09 1H5.5a3.5 3.5 0 0 1-.2-7zm8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 14.75 8 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $7972e53b1de568ed$export$7ba79c488ddff905 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson20Filled', "20", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 1.89 3.93q.67.41 1.06 1.09c.56-.69.89-1.57.89-2.52M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75m5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5M16.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $7972e53b1de568ed$export$a3b455cc73b7bea9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson20Regular', "20", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5M18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.26 4.72q.4.35.65.8c.56-.69.89-1.57.89-2.52m-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1m2.5 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $7972e53b1de568ed$export$9682907bb580f218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson24Filled', "24", [
    "M10 6a1 1 0 0 0-1-1H6.78A5 5 0 0 0 7 15h2.12A1 1 0 0 0 9 13H6.82A3 3 0 0 1 7 7h2.12A1 1 0 0 0 10 6m12 4a5 5 0 0 0-5-5h-2.12A1 1 0 0 0 15 7h2.18a3 3 0 0 1 2.33 4.64c.58.4 1.02.97 1.27 1.63A5 5 0 0 0 22 10m-5-1H6.88A1 1 0 0 0 7 11h10.12A1 1 0 0 0 17 9m3 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S13 21.44 13 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $7972e53b1de568ed$export$8d42f29144ca1b51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson24Regular', "24", [
    "M10 5.75A.75.75 0 0 0 9.25 5h-2.5A5 5 0 0 0 7 15h2.36a.75.75 0 0 0-.11-1.5H6.8a3.5 3.5 0 0 1 .2-7h2.36a.75.75 0 0 0 .64-.75M22 10a5 5 0 0 0-5-5h-2.36a.75.75 0 0 0 .11 1.5h2.45a3.5 3.5 0 0 1 2.7 5.46q.59.54.88 1.31A5 5 0 0 0 22 10m-5-.75H6.9a.75.75 0 0 0 .1 1.5h10.1a.75.75 0 0 0-.1-1.5m3 5.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S13 21.44 13 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $7972e53b1de568ed$export$4c2dde386fb7379e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson32Filled', "32", [
    "M9.25 6a7.25 7.25 0 0 0 0 14.5h3.5a1.25 1.25 0 1 0 0-2.5h-3.5a4.75 4.75 0 1 1 0-9.5h3.5a1.25 1.25 0 1 0 0-2.5zm13.5 0a7.25 7.25 0 0 1 5.97 11.36 5 5 0 0 0-1.6-2.26 4.74 4.74 0 0 0-4.37-6.6h-3.5a1.25 1.25 0 1 1 0-2.5zm.45 8.06q-.73.12-1.38.44H9.75a1.25 1.25 0 1 1 0-2.5h12.5a1.25 1.25 0 0 1 .95 2.06M27.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06A2.43 2.43 0 0 1 20.42 24h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $7972e53b1de568ed$export$49f83461f2814cdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson32Regular', "32", [
    "M9 6a7 7 0 0 0 0 14h4a1 1 0 1 0 0-2H9A5 5 0 0 1 9 8h4a1 1 0 1 0 0-2zm14 0a7 7 0 0 1 5.64 11.14q-.42-1.04-1.22-1.8.57-1.06.58-2.34a5 5 0 0 0-5-5h-4a1 1 0 1 1 0-2zM8.5 13a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-13a1 1 0 0 1-1-1m19 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06A2.43 2.43 0 0 1 20.42 24h7.16c1.34 0 2.42 1.1 2.42 2.44"
]);
const $7972e53b1de568ed$export$d684c0a81b768e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson48Filled', "48", [
    "M44 19.46A10.75 10.75 0 0 0 33.25 9h-4.64a1.75 1.75 0 0 0 .14 3.5h4.74a7.25 7.25 0 0 1 7.01 7.25v.74a7 7 0 0 1-.89 3.24 7 7 0 0 1 2.07 3.19A10.7 10.7 0 0 0 44 20.25v-.79m-23-8.71C21 9.78 20.22 9 19.25 9h-4.79C8.66 9.16 4 13.9 4 19.75v.79C4.16 26.34 8.9 31 14.75 31h4.64a1.75 1.75 0 0 0-.14-3.5h-4.74a7.25 7.25 0 0 1-7.01-7.25v-.74a7.25 7.25 0 0 1 7.25-7.01h4.64c.9-.08 1.61-.83 1.61-1.75m13 7.5H13.86a1.75 1.75 0 0 0 .14 3.5h20.14a1.75 1.75 0 0 0-.14-3.5M40 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $7972e53b1de568ed$export$a38c6723fb193eb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson48Regular', "48", [
    "M44 20a10 10 0 0 0-10-10h-5.88a1.25 1.25 0 0 0 .13 2.5h5.99a7.5 7.5 0 0 1 5.92 11.77 7 7 0 0 1 1.4 2.28A10 10 0 0 0 44 20m-23-8.75c0-.69-.56-1.25-1.25-1.25h-6.03A10 10 0 0 0 14 30h5.88a1.25 1.25 0 0 0-.13-2.5h-5.99a7.5 7.5 0 0 1 .24-15h5.88c.63-.07 1.12-.6 1.12-1.25m14 7.5H12.87a1.25 1.25 0 0 0 .13 2.5h22.13a1.25 1.25 0 0 0-.13-2.5M40 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $7972e53b1de568ed$export$3080b0b066365131 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettings20Filled', "20", [
    "M12.06 8.9a2 2 0 0 0 2.9 0l.5-.52q.81.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.66.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8l.58-.15a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91zM13.5 12c-.8 0-1.45.67-1.45 1.5S12.7 15 13.5 15s1.45-.67 1.45-1.5S14.3 12 13.5 12M8 4c.41 0 .75.34.75.75 0 .43-.34.72-.75.75H6a2.5 2.5 0 0 0-.16 5h1.89q-.37.7-.55 1.5H6a4 4 0 0 1-.2-8H8m3.72 3.25q-1.52.44-2.65 1.5H6.25a.75.75 0 0 1-.1-1.5h5.57M14 4a4 4 0 0 1 3.93 4.75q-.65-.6-1.45-1.03a2.5 2.5 0 0 0-2.32-2.22H12a.75.75 0 0 1-.1-1.5H14"
]);
const $7972e53b1de568ed$export$aa8106e247d6695d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettings20Regular', "20", [
    "M12.06 8.9a2 2 0 0 0 2.9 0l.5-.52q.81.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.66.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8l.58-.15a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91zM13.5 12c-.8 0-1.45.67-1.45 1.5S12.7 15 13.5 15s1.45-.67 1.45-1.5S14.3 12 13.5 12M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6h1.7q-.2.49-.32 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 3.93 4.75q-.44-.4-.93-.73V8a3 3 0 0 0-2.8-3H12a.5.5 0 0 1-.09-1H14m-3 3.5a7 7 0 0 0-1.65 1H6a.5.5 0 0 1-.09-1H11"
]);
const $7972e53b1de568ed$export$b5ab8edfeb06bec0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettings24Filled', "24", [
    "M10 6a1 1 0 0 0-1-1H6.78A5 5 0 0 0 7 15h2.12A1 1 0 0 0 9 13H6.82A3 3 0 0 1 7 7h2.12A1 1 0 0 0 10 6m12 4a5 5 0 0 0-5-5h-2.12A1 1 0 0 0 15 7h2.18a3 3 0 0 1 2.49 4.37q.96.35 1.76.95.55-1.06.57-2.32m-5-1H6.88A1 1 0 0 0 7 11h10.12A1 1 0 0 0 17 9m-4.16 7.47a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91l.5.52a2 2 0 0 0 2.9 0l.5-.52q.82.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.67.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8zm6.11 1.03c0-.83-.65-1.5-1.45-1.5s-1.45.67-1.45 1.5.65 1.5 1.45 1.5 1.45-.67 1.45-1.5"
]);
const $7972e53b1de568ed$export$8e8332b703692cd8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettings24Regular', "24", [
    "M9.25 5a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5M17 5a5 5 0 0 1 4.43 7.32 7 7 0 0 0-1.3-.76q.36-.71.37-1.56a3.5 3.5 0 0 0-3.3-3.5h-2.45a.75.75 0 0 1-.11-1.5H17M7 9.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5zm7.28 4.73a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.59-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $7972e53b1de568ed$export$d05361b31e9df05b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare12Filled', "12", [
    "M1 3.25C1 2 2 1 3.25 1h2.5c1.22 0 2.2.96 2.25 2.16v2.68a2.25 2.25 0 0 1-1.5 2.03V3.25a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .33.2.6.5.71v1.53a2.25 2.25 0 0 1-2-2.24zm3 5.5C4 9.99 5 11 6.25 11h2.5C9.99 11 11 10 11 8.75v-2.5c0-1.16-.88-2.11-2-2.24v1.53c.3.1.5.38.5.71v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1-.75-.75V4.13C4.63 4.43 4 5.27 4 6.25z"
]);
const $7972e53b1de568ed$export$1bd10b3bef9008b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare12Regular', "12", [
    "M1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2V7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1v1a2 2 0 0 1-2-2zm3 6c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1V4a2 2 0 0 0-2 2z"
]);
const $7972e53b1de568ed$export$757432f0e5a66227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare16Filled', "16", [
    "M2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5c0 .98-.63 1.81-1.5 2.12V4.25a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75H5V10h-.75C3.01 10 2 9 2 7.75zm4 7.5C6 12.99 7 14 8.25 14h3.5c1.24 0 2.25-1 2.25-2.25v-3.5C14 7.01 13 6 11.75 6H11v1.5h.75c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75V6.13C6.63 6.43 6 7.27 6 8.25z"
]);
const $7972e53b1de568ed$export$772830f113bcc6bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare16Regular', "16", [
    "M4 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h1V9H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7 4v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1V6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
]);
const $7972e53b1de568ed$export$5fc818bf5326fd69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare20Filled', "20", [
    "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25H6V13H4.75A2.75 2.75 0 0 1 2 10.25v-5.5A2.75 2.75 0 0 1 4.75 2h5.5A2.75 2.75 0 0 1 13 4.75v5.5A2.75 2.75 0 0 1 10.25 13H9.5v-1.5h.75c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25zM7 9.75A2.75 2.75 0 0 1 9.75 7h1v1.5h-1c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-1.5V7h1.5A2.75 2.75 0 0 1 18 9.75v5.5A2.75 2.75 0 0 1 15.25 18h-5.5A2.75 2.75 0 0 1 7 15.25z"
]);
const $7972e53b1de568ed$export$a9ff7d20ed23a3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare20Regular', "20", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H6v1H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5H9v-1h1.5c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5zm5 4H11v1H9.5C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H14V7h1.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5v-6A2.5 2.5 0 0 1 9.5 7"
]);
const $7972e53b1de568ed$export$2cae4b14e0a42c14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare24Filled', "24", [
    "M6.5 3A3.5 3.5 0 0 0 3 6.5v6A3.5 3.5 0 0 0 6.5 16H7v-2h-.5A1.5 1.5 0 0 1 5 12.5v-6C5 5.67 5.67 5 6.5 5h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5H11v2h1.5a3.5 3.5 0 0 0 3.5-3.5v-6A3.5 3.5 0 0 0 12.5 3zm3.5 8.5c0-.83.67-1.5 1.5-1.5H13V8h-1.5A3.5 3.5 0 0 0 8 11.5v6a3.5 3.5 0 0 0 3.5 3.5h6a3.5 3.5 0 0 0 3.5-3.5v-6A3.5 3.5 0 0 0 17.5 8H17v2h.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $7972e53b1de568ed$export$72f492535159e05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v6c0 1.8 1.46 3.25 3.25 3.25H7.5V14H6.25c-.97 0-1.75-.78-1.75-1.75v-6c0-.97.78-1.75 1.75-1.75h6c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75H11v1.5h1.25c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25zM10 11.75c0-.97.78-1.75 1.75-1.75H13V8.5h-1.25a3.25 3.25 0 0 0-3.25 3.25v6c0 1.8 1.46 3.25 3.25 3.25h6c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25H16.5V10h1.25c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-6c-.97 0-1.75-.78-1.75-1.75z"
]);
const $7972e53b1de568ed$export$4c2c12bb4d2904ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkToolbox20Filled', "20", [
    "M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 2.08 3.61q.76.25 1.24.86.5-.88.52-1.97M6.25 7.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $7972e53b1de568ed$export$8809e39ad856fe5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkToolbox20Regular', "20", [
    "M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 3.48 5.97q-.32-.41-.78-.66.3-.6.3-1.31a3 3 0 0 0-2.8-3H12a.5.5 0 0 1-.09-1H14M6 7.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1zm6 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $7972e53b1de568ed$export$cbc2cd2b7bb5a01b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Memory16Filled', "16", [
    "M14.41 4.59A2 2 0 0 0 13 4V2.5a.5.5 0 0 0-.5-.5.5.5 0 0 0-.5.5V4h-2V2.5a.5.5 0 1 0-1 0V4H7V2.5a.5.5 0 1 0-1 0V4H4V2.5a.5.5 0 1 0-1 0V4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v1.5q0 .2.15.35A.5.5 0 0 0 4 13.5V12h2v1.5q0 .2.15.35A.5.5 0 0 0 7 13.5V12h2v1.5q0 .2.15.35a.5.5 0 0 0 .85-.35V12h2v1.5q0 .2.15.35a.5.5 0 0 0 .85-.35V12a2 2 0 0 0 2-2V6a2 2 0 0 0-.59-1.41M13 9.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5zM4 9h8V7H4z"
]);
const $7972e53b1de568ed$export$441d0876aa73e5d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Memory16Regular', "16", [
    "M14.41 4.59A2 2 0 0 0 13 4V2.5a.5.5 0 0 0-1 0V4h-2V2.5a.5.5 0 1 0-1 0V4H7V2.5a.5.5 0 1 0-1 0V4H4V2.5a.5.5 0 1 0-1 0V4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v1.5a.5.5 0 0 0 1 0V12h2v1.5a.5.5 0 0 0 1 0V12h2v1.5a.5.5 0 0 0 1 0V12h2v1.5a.5.5 0 0 0 1 0V12a2 2 0 0 0 2-2V6a2 2 0 0 0-.59-1.41M14 10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zm-1.5-4h-9a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5M12 9H4V7h8z"
]);
const $7972e53b1de568ed$export$67351f07bdf517de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd16Filled', "16", [
    "M8 1a7 7 0 0 1 5.36 11.5h-2.2A5.5 5.5 0 0 0 8 2.5H1.75a.75.75 0 0 1 0-1.5zm0 14A7 7 0 0 1 2.64 3.5h2.2A5.5 5.5 0 0 0 8 13.5h6.25a.75.75 0 0 1 0 1.5zm.75-9.25a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5z"
]);
const $7972e53b1de568ed$export$4fac5ca8c1d9927c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd16Regular', "16", [
    "M1 1.5c0-.28.22-.5.5-.5H8a7 7 0 0 1 6.84 5.5A7 7 0 0 1 12.9 13h-1.58A6 6 0 0 0 8 2H1.5a.5.5 0 0 1-.5-.5M1 8a7 7 0 0 0 7 7h6.5a.5.5 0 0 0 0-1H8a6 6 0 0 1-6-6 6 6 0 0 1 2.68-5H3.1A7 7 0 0 0 1 8m7-3c.28 0 .5.22.5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2c0-.28.22-.5.5-.5"
]);
const $7972e53b1de568ed$export$5096578c2dbf9d71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd20Filled', "20", [
    "M2.75 2a.75.75 0 0 0 0 1.5H10a6.5 6.5 0 0 1 6.5 6.5 6.5 6.5 0 0 1-3.03 5.5h2.34A8 8 0 0 0 10 2zm5.6 15.83A8 8 0 0 1 4.19 4.5h2.34a6.5 6.5 0 0 0 3.47 12h7.25a.75.75 0 0 1 0 1.5H10q-.86 0-1.65-.17M10 7c.41 0 .75.34.75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5c0-.41.34-.75.75-.75"
]);
const $7972e53b1de568ed$export$35429768b51acc72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd20Regular', "20", [
    "M2 2.5c0-.28.22-.5.5-.5H10a7.98 7.98 0 0 1 5.3 14h-1.7A7 7 0 0 0 10 3H2.5a.5.5 0 0 1-.5-.5M10 18A8 8 0 0 1 4.7 4h1.7A7 7 0 0 0 10 17h7.5a.5.5 0 0 1 0 1zm.5-10.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 1 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2z"
]);
const $7972e53b1de568ed$export$684b11648fee5bf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd24Filled', "24", [
    "M2 3a1 1 0 0 1 1-1h9a10 10 0 0 1 7.14 17h-3.26A8 8 0 0 0 12 4H3a1 1 0 0 1-1-1m8.18 18.84q.9.16 1.82.16h9a1 1 0 1 0 0-2h-9A8 8 0 0 1 8.12 5H4.86a10 10 0 0 0 5.32 16.83M12 8a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1"
]);
const $7972e53b1de568ed$export$e466deb7afeae2ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd24Regular', "24", [
    "M2 2.75c0-.41.34-.75.75-.75H12a10 10 0 0 1 6.61 17.5h-2.6A8.5 8.5 0 0 0 12 3.5H2.75A.75.75 0 0 1 2 2.75m8.36 19.12q.8.13 1.64.13h9.25a.75.75 0 0 0 0-1.5H12a8.5 8.5 0 0 1-4-16H5.39a10 10 0 0 0 4.98 17.37M12 8c.41 0 .75.34.75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5c0-.41.34-.75.75-.75"
]);
const $7972e53b1de568ed$export$979e72591e743af9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd32Filled', "32", [
    "M2 3.25C2 2.56 2.56 2 3.25 2H16q1.31 0 2.56.23A14 14 0 0 1 25.8 26h-4.12A11.5 11.5 0 0 0 16 4.5H3.25C2.56 4.5 2 3.94 2 3.25M2 16a14 14 0 0 0 2.04 7.29A14 14 0 0 0 16 30h11.75a1.25 1.25 0 1 0 0-2.5H16q-1.2 0-2.32-.23A11.5 11.5 0 0 1 10.32 6H6.2A14 14 0 0 0 2 16m14-6c.69 0 1.25.56 1.25 1.25v3.5h3.5a1.25 1.25 0 1 1 0 2.5h-3.5v3.5a1.25 1.25 0 1 1-2.5 0v-3.5h-3.5a1.25 1.25 0 1 1 0-2.5h3.5v-3.5c0-.69.56-1.25 1.25-1.25"
]);
const $7972e53b1de568ed$export$43673a089203cf70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd32Regular', "32", [
    "M2 3a1 1 0 0 1 1-1h13q1.2 0 2.37.2a14 14 0 0 1 6.89 24.3h-3.45A12 12 0 0 0 16 4H3a1 1 0 0 1-1-1m0 13a14 14 0 0 0 1.28 5.85A14 14 0 0 0 16 30h13a1 1 0 1 0 0-2H16q-1.12 0-2.2-.2A12 12 0 0 1 10.2 5.5H6.74A14 14 0 0 0 2 16m14-6a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4h-4a1 1 0 1 1 0-2h4v-4a1 1 0 0 1 1-1"
]);
const $7972e53b1de568ed$export$568585a28f6e8796 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote16Filled', "16", [
    "M13.8 3.26a.75.75 0 1 0-1.1-1.02l-4 4.25a.75.75 0 0 0 0 1.02l4 4.25a.75.75 0 1 0 1.1-1.02L10.28 7zm-10.5.98a.75.75 0 1 0-1.1 1.02L5.72 9 2.2 12.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02z"
]);
const $7972e53b1de568ed$export$37ab5357f8b722b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote16Regular', "16", [
    "M13.85 2.85a.5.5 0 0 0-.7-.7l-4.5 4.5a.5.5 0 0 0 0 .7l4.5 4.5a.5.5 0 0 0 .7-.7L9.71 7zm-11 1.3a.5.5 0 1 0-.7.7L6.29 9l-4.14 4.15a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7z"
]);
const $7972e53b1de568ed$export$760a94ac13bee930 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote20Filled', "20", [
    "M16.97 15.03a.75.75 0 1 0 1.06-1.06L12.56 8.5l5.47-5.47a.75.75 0 0 0-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06zM3.03 4.97a.75.75 0 0 0-1.06 1.06l5.47 5.47-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6c.3-.3.3-.77 0-1.06z"
]);
const $7972e53b1de568ed$export$ef4467a9cf061563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote20Regular', "20", [
    "M17.15 14.85a.5.5 0 0 0 .7-.7L12.21 8.5l5.64-5.65a.5.5 0 0 0-.7-.7l-6 6a.5.5 0 0 0 0 .7zm-14.3-9.7a.5.5 0 1 0-.7.7l5.64 5.65-5.64 5.65a.5.5 0 0 0 .7.7l6-6a.5.5 0 0 0 0-.7z"
]);
const $7972e53b1de568ed$export$8017c91d6b17c2da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut20Filled', "20", [
    "M11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11zm-2.5 7.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m4 4.75H12v-5h1v4.5a.5.5 0 0 1-.5.5M12 8V4h.5c.28 0 .5.22.5.5V8z"
]);
const $7972e53b1de568ed$export$f7c6ac52f3ea7a12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut20Regular', "20", [
    "M8.5 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11zm-1 .58v11.84L4 15V5zM12.5 16H12v-5h1v4.5a.5.5 0 0 1-.5.5M12 8V4h.5c.28 0 .5.22.5.5V8z"
]);
const $7972e53b1de568ed$export$45ef50a7922e9d88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut24Filled', "24", [
    "M12 4.35V11h7.44l-1.72-1.72a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07l.08.07 3 3c.26.26.29.68.07.97l-.07.09-3 3a.75.75 0 0 1-1.13-.97l.07-.09 1.71-1.72H12v6.75c0 .47-.42.82-.88.74l-8.5-1.5a.75.75 0 0 1-.62-.74v-12c0-.37.27-.68.63-.74l8.5-1.4c.46-.07.87.28.87.74M8.5 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4.5 7h.87a.75.75 0 0 0 .65-.75l-.01-4.25H13zm0-8.5V5h.75c.37 0 .69.28.74.65v.1L14.5 10z"
]);
const $7972e53b1de568ed$export$e3aa6cff83390753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut24Regular', "24", [
    "M8.5 11.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M12 4.35V11h7.44l-1.72-1.72a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07l.08.07 3 3c.26.26.29.68.07.97l-.07.09-3 3a.75.75 0 0 1-1.13-.97l.07-.09 1.71-1.72H12v6.75c0 .47-.42.82-.88.74l-8.5-1.5a.75.75 0 0 1-.62-.74v-12c0-.37.27-.68.63-.74l8.5-1.4c.46-.07.87.28.87.74m-1.5.89-7 1.15v10.73l7 1.24zM13 18.5h.87a.75.75 0 0 0 .65-.75l-.01-4.25H13zm0-8.5V5h.75c.37 0 .69.28.74.65v.1L14.5 10z"
]);
const $7972e53b1de568ed$export$de35447401ae8b38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature16Filled', "16", [
    "M12.48 1.77a2.44 2.44 0 0 0-3.46 0L2.4 8.4a1 1 0 0 0-.12.2l-1.25 3.74a.5.5 0 0 0 .6.65l4-1a1 1 0 0 0 .22-.14l5.65-5.64.09.08a1 1 0 0 1 0 1.42l-1.44 1.44a.5.5 0 0 0 .7.7l1.44-1.44a2 2 0 0 0 0-2.82l-.08-.09.27-.27c.95-.96.95-2.5 0-3.46M4.97 15c-1.24 0-2.21-.57-2.86-1.1l1.29-.33c.44.25.97.43 1.57.43q.6 0 1.27-.46.66-.45 1.31-1.1l.11-.1c.39-.36.79-.74 1.17-1 .4-.27.95-.53 1.52-.3q.54.22.79.73.23.47.38 1.1.08.31.23.5.06.09.11.12l.04.01q.18.01.63-.29.27-.18.5-.37l.3-.24a5 5 0 0 1 .98-.56l.02-.01h.01l.16.47-.16-.47a.5.5 0 0 1 .32.94l-.03.02-.15.06q-.2.1-.55.35l-.22.17q-.28.24-.62.47c-.3.21-.74.46-1.19.46a1.2 1.2 0 0 1-.95-.52c-.2-.25-.33-.57-.4-.85a4 4 0 0 0-.3-.9q-.13-.23-.26-.26c-.08-.03-.25-.04-.6.2q-.46.33-1.06.91l-.1.1c-.43.4-.92.85-1.45 1.2S5.64 15 4.97 15"
]);
const $7972e53b1de568ed$export$8658fab8dcce1b53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature16Regular', "16", [
    "M9.02 1.77a2.44 2.44 0 0 1 3.46 3.46l-.27.27.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-5.65 5.64a1 1 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65L2.29 8.6a1 1 0 0 1 .12-.2zm2.75.7a1.44 1.44 0 0 0-2.04 0L3.19 9.03l-.93 2.77 2.98-.74 6.53-6.53c.57-.56.57-1.48 0-2.04M4.97 15c-1.24 0-2.21-.57-2.86-1.1l1.29-.33c.44.25.97.43 1.57.43q.6 0 1.27-.46.66-.45 1.31-1.1l.11-.1c.39-.36.79-.74 1.17-1 .4-.27.95-.53 1.52-.3q.54.22.79.73.23.47.38 1.1.08.31.23.5.06.09.11.12l.04.01q.18.01.63-.29.27-.18.5-.37l.3-.24a5 5 0 0 1 .98-.56l.02-.01h.01l.16.47-.16-.47a.5.5 0 0 1 .32.94l-.03.02-.15.06q-.2.1-.55.35l-.22.17q-.28.24-.62.47c-.3.21-.74.46-1.19.46a1.2 1.2 0 0 1-.95-.52c-.2-.25-.33-.57-.4-.85a4 4 0 0 0-.3-.9q-.13-.23-.26-.26c-.08-.03-.25-.04-.6.2q-.46.33-1.06.91l-.1.1c-.43.4-.92.85-1.45 1.2S5.64 15 4.97 15"
]);
const $7972e53b1de568ed$export$93f3d91e0dcca555 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature20Filled', "20", [
    "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a1 1 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a1 1 0 0 1 .12-.2zM3.27 16.9q-.03 0-.05-.03l1.35-.34c.53.27 1.18.47 1.93.47q.75-.02 1.53-.47c.53-.3 1.03-.7 1.53-1.1l.13-.11c.44-.36.9-.74 1.34-1 .47-.27 1.04-.49 1.63-.3.82.28 1.08 1.04 1.32 1.84q.09.28.26.49.17.17.26.15.29 0 .8-.3a9 9 0 0 0 .93-.62 6 6 0 0 1 1.1-.55h.03l.14.47-.14-.48a.5.5 0 0 1 .28.96q-.02 0-.05.02-.05 0-.17.07a5 5 0 0 0-.91.53l-.7.46a3 3 0 0 1-1.31.44c-.44 0-.78-.23-1-.49a2 2 0 0 1-.48-.87c-.26-.87-.41-1.08-.68-1.17-.16-.05-.4-.02-.8.22q-.55.33-1.23.92l-.12.1c-.5.4-1.06.84-1.66 1.19s-1.29.6-2.03.6a5.5 5.5 0 0 1-3.23-1.1"
]);
const $7972e53b1de568ed$export$7102775a33860f22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature20Regular', "20", [
    "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a1 1 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a1 1 0 0 1 .12-.2zm2.75.7a1.44 1.44 0 0 0-2.04 0l-8.54 8.55-.93 2.77 2.98-.74 8.53-8.53c.57-.56.57-1.48 0-2.04M3.22 16.88l.05.03C4 17.44 5.1 18 6.5 18c.74 0 1.42-.26 2.03-.6.6-.35 1.16-.8 1.66-1.2l.12-.1q.68-.57 1.23-.91c.4-.24.64-.27.8-.22.27.1.42.3.68 1.17q.13.46.47.87c.23.26.57.49 1.01.49.47 0 .94-.23 1.3-.44a13 13 0 0 0 .97-.64 5 5 0 0 1 .82-.42l.04-.02h.01a.5.5 0 0 0-.28-.96h-.01l-.02.01-.31.12q-.3.13-.8.43l-.33.23q-.28.2-.6.39-.5.3-.79.3-.1.02-.26-.15-.17-.2-.26-.5c-.24-.8-.5-1.55-1.32-1.82-.59-.2-1.16.02-1.63.3-.44.25-.9.63-1.34.99l-.13.1q-.74.63-1.53 1.1-.77.46-1.53.48c-.75 0-1.4-.2-1.93-.47zM17.5 15.5l-.14-.48z"
]);
const $7972e53b1de568ed$export$9cbbb54110437f30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature24Filled', "24", [
    "M14.75 16.5c1.3 0 1.82.58 2.2 1.87l.07.24c.19.66.3.86.52.95.26.1.43.09.7-.05l.15-.08.17-.11.67-.46c.61-.4 1.17-.67 1.84-.84a.75.75 0 1 1 .36 1.46q-.59.14-1.14.49l-.3.19-.48.33q-.33.22-.58.35a2.2 2.2 0 0 1-1.96.1c-.75-.3-1.05-.78-1.33-1.72l-.16-.54c-.18-.59-.3-.68-.73-.68q-.43-.01-1.07.52l-.18.16-.92.88c-1.41 1.32-2.61 1.97-4.33 1.97q-2.54 0-4.37-.77l2.95-.8q.67.06 1.42.07c1.18 0 2.03-.42 3.09-1.37l.25-.24.54-.5.59-.55c.68-.57 1.3-.87 2.03-.87m4.28-13.53a3.6 3.6 0 0 1 0 5.06l-.29.29c1.15 1.4 1.11 2.89.04 3.96l-2 2a.75.75 0 0 1-1.06-1.06l2-2c.48-.49.54-1.09-.04-1.84L9.06 18q-.42.43-1 .58l-5.11 1.4a.75.75 0 0 1-.92-.93l1.4-5.11q.16-.58.57-1l9.97-9.97a3.6 3.6 0 0 1 5.06 0"
]);
const $7972e53b1de568ed$export$603d858711029590 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature24Regular', "24", [
    "M14.75 16.5c1.3 0 1.82.58 2.2 1.87l.07.24c.19.66.3.86.52.95.26.1.43.09.7-.05l.15-.08.17-.11.67-.46c.61-.4 1.17-.67 1.84-.84a.75.75 0 1 1 .36 1.46q-.59.14-1.14.49l-.3.19-.48.33q-.33.22-.58.35a2.2 2.2 0 0 1-1.96.1c-.75-.3-1.05-.78-1.33-1.72l-.16-.54c-.18-.59-.3-.68-.73-.68q-.43-.01-1.07.52l-.18.16-.92.88c-1.41 1.32-2.61 1.97-4.33 1.97q-2.54 0-4.37-.77l2.95-.8q.67.06 1.42.07c1.18 0 2.03-.42 3.09-1.37l.25-.24.54-.5.59-.55c.68-.57 1.3-.87 2.03-.87m4.28-13.53a3.6 3.6 0 0 1 0 5.06l-.29.29c1.15 1.4 1.11 2.89.04 3.96l-2 2a.75.75 0 0 1-1.06-1.06l2-2c.48-.49.54-1.09-.04-1.84L9.06 18q-.42.43-1 .58l-5.11 1.4a.75.75 0 0 1-.92-.93l1.4-5.11q.16-.58.57-1l9.97-9.97a3.6 3.6 0 0 1 5.06 0m-4 1.06L5.06 14q-.14.14-.19.33l-1.05 3.85 3.85-1.05q.2-.05.33-.2l9.97-9.96a2.08 2.08 0 1 0-2.94-2.94"
]);
const $7972e53b1de568ed$export$59c9feb2af9f84a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature28Filled', "28", [
    "M16.48 21h.27c1.22 0 1.86.5 2.65 1.7l.4.61c.3.46.5.65.74.75.43.18.79.09 2.1-.55l.4-.2a10 10 0 0 1 2.03-.79.75.75 0 1 1 .36 1.46 7 7 0 0 0-1.27.47l-1.15.55c-1.57.74-2.1.83-3.05.44-.62-.25-.98-.63-1.5-1.42l-.2-.3c-.6-.95-.9-1.22-1.5-1.22h-.17c-.43.03-.71.23-2.58 1.61-1.74 1.3-3.07 1.92-4.76 1.92q-3.09 0-5.82-1.14l2.88-.67q1.42.3 2.94.3c1.29 0 2.36-.5 3.87-1.61l1.16-.86c1.27-.92 1.55-1.03 2.2-1.05m6.3-17.78a4.3 4.3 0 0 1 0 6.06l-1.04 1.04c1.15 1.4 1.11 2.89.04 3.96l-3 3a.75.75 0 1 1-1.06-1.06l3-3c.48-.49.54-1.09-.04-1.84l-10.6 10.6q-.46.45-1.08.6l-6.08 1.4a.75.75 0 0 1-.9-.9L3.42 17q.15-.63.6-1.08l12.7-12.7a4.3 4.3 0 0 1 6.06 0"
]);
const $7972e53b1de568ed$export$c7a44917cc963d0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature28Regular', "28", [
    "M16.48 21h.27c1.22 0 1.86.5 2.65 1.7l.4.61c.3.46.5.65.74.75.43.18.79.09 2.1-.55l.4-.2a10 10 0 0 1 2.03-.79.75.75 0 1 1 .36 1.46 7 7 0 0 0-1.27.47l-1.15.55c-1.57.74-2.1.83-3.05.44-.62-.25-.98-.63-1.5-1.42l-.2-.3c-.55-.9-.85-1.18-1.4-1.22h-.1c-.56 0-.67.07-2.75 1.61-1.74 1.3-3.07 1.92-4.76 1.92q-3.09 0-5.82-1.14l2.88-.67q1.42.3 2.94.3c1.29 0 2.36-.5 3.87-1.61l1.16-.86c1.27-.92 1.55-1.03 2.2-1.05m6.3-17.78a4.3 4.3 0 0 1 0 6.06l-1.04 1.04c1.15 1.4 1.11 2.89.04 3.96l-3 3a.75.75 0 1 1-1.06-1.06l3-3c.48-.49.54-1.09-.04-1.84l-10.6 10.6q-.46.45-1.08.6l-6.08 1.4a.75.75 0 0 1-.9-.9L3.42 17q.15-.63.6-1.08l12.7-12.7a4.3 4.3 0 0 1 6.06 0m-5 1.06-12.7 12.7q-.14.15-.2.36l-1.13 4.9 4.91-1.12q.22-.05.36-.2l12.7-12.7a2.79 2.79 0 0 0-3.94-3.94"
]);
const $7972e53b1de568ed$export$25991def0078110c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature32Filled', "32", [
    "M24.54 3.46a5 5 0 0 0-7.07 0L4.39 16.54a3 3 0 0 0-.8 1.45l-1.56 6.79a1 1 0 0 0 1.2 1.2L10 24.41a3 3 0 0 0 1.45-.8l10.87-10.88.2.2a1.5 1.5 0 0 1 0 2.12l-3.24 3.23a1 1 0 0 0 1.42 1.42l3.23-3.23a3.5 3.5 0 0 0 0-4.95l-.2-.2.8-.8a5 5 0 0 0 0-7.07M8.56 29.9a8.8 8.8 0 0 1-4.71-2.53l2.42-.55c.7.5 1.61.93 2.62 1.1 1.54.27 3.43-.07 5.4-2.03a33 33 0 0 1 2.85-2.57c.78-.6 1.5-1.05 2.19-1.23.76-.2 1.5-.08 2.09.44.5.45.8 1.12 1.03 1.78l.03.1c.41 1.22.62 1.84.83 2.22q.14.24.2.28t.3.14s.12.04.45-.13q.47-.26 1.18-.83l.27-.22c.38-.3.8-.65 1.23-.94a6 6 0 0 1 1.82-.9 1 1 0 0 1 .48 1.94q-.48.12-1.16.6-.53.38-1.08.83l-.31.25c-.47.37-1 .78-1.52 1.05a2.55 2.55 0 0 1-2.92-.25q-.44-.36-.69-.85c-.3-.55-.56-1.34-.92-2.38l-.09-.27c-.2-.59-.36-.83-.46-.92-.02-.02-.05-.06-.24 0-.3.07-.76.31-1.48.87q-1.04.81-2.67 2.41c-2.42 2.4-4.94 2.96-7.14 2.59"
]);
const $7972e53b1de568ed$export$b9a43e68d5e123d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature32Light', "32", [
    "M17.9 3.39a4.74 4.74 0 1 1 6.7 6.7l-.65.67.02.03a3.5 3.5 0 0 1 0 4.95l-3.11 3.11a.5.5 0 1 1-.71-.7l3.12-3.12a2.5 2.5 0 0 0 0-3.53l-.03-.03-11.95 11.95q-.68.68-1.62.92l-6.42 1.62a1 1 0 0 1-1.22-1.21l1.63-6.43a3.5 3.5 0 0 1 .92-1.61zm6 .7a3.74 3.74 0 0 0-5.3 0L5.3 17.42a2.5 2.5 0 0 0-.66 1.16L3 25l6.42-1.63a2.5 2.5 0 0 0 1.16-.66L23.9 9.4a3.74 3.74 0 0 0 0-5.3M4 27.33q.57.55 1.28 1.03A9 9 0 0 0 10 30c1.22 0 2.4-.45 3.46-1.08a19 19 0 0 0 2.96-2.23q.53-.46.98-.9.75-.67 1.34-1.18.48-.39.8-.55.15-.07.24-.08h.06q.37.1.66.69.24.51.45 1.2l.1.28c.35 1.07.86 2.47 2.33 2.84.64.16 1.2.03 1.71-.23.48-.25.93-.64 1.36-1l.02-.02c.88-.75 1.78-1.52 3.11-1.75a.5.5 0 1 0-.16-.98 7 7 0 0 0-3.55 1.93l-.07.06c-.45.38-.81.68-1.17.87q-.5.27-1 .14c-.88-.21-1.25-1.03-1.63-2.17l-.09-.26c-.15-.46-.3-.95-.51-1.36a2.2 2.2 0 0 0-1.24-1.2c-.38-.12-.76 0-1.06.15q-.48.24-1 .67-.63.53-1.4 1.25l-.94.85c-.88.77-1.82 1.54-2.8 2.12-.99.58-1.98.94-2.96.94a8 8 0 0 1-4.16-1.48l-.67-.5zm-1.97-2.57.49.12z"
]);
const $7972e53b1de568ed$export$e41a7cdf33a2bc27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature32Regular', "32", [
    "M17.47 3.46a5 5 0 1 1 7.07 7.08l-.8.79.2.2a3.5 3.5 0 0 1 0 4.95L20.7 19.7a1 1 0 1 1-1.42-1.42l3.23-3.23a1.5 1.5 0 0 0 0-2.12l-.2-.2-10.86 10.88a3 3 0 0 1-1.45.8l-6.79 1.55a1 1 0 0 1-1.2-1.2L3.59 18a3 3 0 0 1 .8-1.45zm5.65 1.42a3 3 0 0 0-4.24 0L5.8 17.96a1 1 0 0 0-.27.48l-1.2 5.23 5.23-1.2a1 1 0 0 0 .48-.27L23.12 9.12a3 3 0 0 0 0-4.24M8.56 29.9a8.8 8.8 0 0 1-4.71-2.53l2.42-.55c.7.5 1.61.93 2.62 1.1 1.54.27 3.43-.07 5.4-2.03a33 33 0 0 1 2.85-2.57c.78-.6 1.5-1.05 2.19-1.23.76-.2 1.5-.08 2.09.44.5.45.8 1.12 1.03 1.78l.03.1c.41 1.22.62 1.84.83 2.22q.14.24.2.28t.3.14s.12.04.45-.13q.47-.26 1.18-.83l.27-.22c.38-.3.8-.65 1.23-.94a6 6 0 0 1 1.82-.9 1 1 0 0 1 .48 1.94q-.48.12-1.16.6-.53.38-1.08.83l-.31.25c-.47.37-1 .78-1.52 1.05a2.55 2.55 0 0 1-2.92-.25q-.44-.36-.69-.85c-.3-.55-.56-1.34-.92-2.38l-.09-.27c-.2-.59-.36-.83-.46-.92-.02-.02-.05-.06-.24 0-.3.07-.76.31-1.48.87q-1.04.81-2.67 2.41c-2.42 2.4-4.94 2.96-7.14 2.59"
]);


const $b11634e761ce411b$export$ea2f5cb61d899ae6 = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $7972e53b1de568ed$export$27ee5ac8ab5ded84), (0, $7972e53b1de568ed$export$515949b0e3098366));
const $b11634e761ce411b$export$57e1bf38e1f55571 = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $7972e53b1de568ed$export$994e675395c5ac42), (0, $7972e53b1de568ed$export$fb9cc08986d6ea9a));
const $b11634e761ce411b$export$7ed1b62a96a5843e = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $7972e53b1de568ed$export$6faa23478c869acb), (0, $7972e53b1de568ed$export$92e1c56f07f9445f));




'use client';
const $0f3d4dea9209d885$var$infoButtonIconMap = {
    small: /*#__PURE__*/ $acw62.createElement((0, $b11634e761ce411b$export$ea2f5cb61d899ae6), null),
    medium: /*#__PURE__*/ $acw62.createElement((0, $b11634e761ce411b$export$57e1bf38e1f55571), null),
    large: /*#__PURE__*/ $acw62.createElement((0, $b11634e761ce411b$export$7ed1b62a96a5843e), null)
};
const $0f3d4dea9209d885$var$popoverSizeMap = {
    small: 'small',
    medium: 'small',
    large: 'medium'
};
const $0f3d4dea9209d885$export$d64b8a2bdde1dfcc = (props, ref)=>{
    const { size: size = 'medium', inline: inline = true, popover: popover, info: info, ...rest } = props;
    const rootRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref);
    const state = {
        inline: inline,
        size: size,
        components: {
            root: 'button',
            popover: (0, $d4448b917a5b7f9a$export$5b6b19405a83ff9d),
            info: (0, $e8c10046741b8692$export$8b7437164e479115)
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('button', {
            children: $0f3d4dea9209d885$var$infoButtonIconMap[size],
            type: 'button',
            'aria-label': 'information',
            ...rest,
            ref: rootRef
        }), {
            elementType: 'button'
        }),
        popover: (0, $fcf7ddccaab7fd8f$exports).always(popover, {
            defaultProps: {
                inline: inline,
                positioning: 'above-start',
                size: $0f3d4dea9209d885$var$popoverSizeMap[size],
                withArrow: true
            },
            elementType: (0, $d4448b917a5b7f9a$export$5b6b19405a83ff9d)
        }),
        info: (0, $fcf7ddccaab7fd8f$exports).always(info, {
            defaultProps: {
                role: 'note',
                tabIndex: -1
            },
            elementType: (0, $e8c10046741b8692$export$8b7437164e479115)
        })
    };
    const [popoverOpen, setPopoverOpen] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: state.popover.open,
        defaultState: state.popover.defaultOpen,
        initialState: false
    });
    state.popover.open = popoverOpen;
    state.popover.onOpenChange = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.popover.onOpenChange, (e, data)=>setPopoverOpen(data.open));
    const infoRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(state.info.ref);
    state.info.ref = infoRef;
    // Hide the popover when focus moves out of the button and popover
    const onBlurButtonOrInfo = (e)=>{
        const nextFocused = e.relatedTarget;
        if (nextFocused && rootRef.current !== nextFocused && !(0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd)(infoRef.current, nextFocused)) setPopoverOpen(false);
    };
    // eslint-disable-next-line react-hooks/refs
    state.root.onBlur = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.root.onBlur, onBlurButtonOrInfo));
    // eslint-disable-next-line react-hooks/refs
    state.info.onBlurCapture = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.info.onBlurCapture, onBlurButtonOrInfo));
    return state;
};






'use client';
const $b0af19cd4a72b4a2$export$51800f574cdd94c9 = {
    root: 'fui-InfoButton',
    // this className won't be used, but it's needed to satisfy the type checker
    popover: 'fui-InfoButton__popover',
    info: 'fui-InfoButton__info'
};
/**
 * Styles for the root slot
 */ const $b0af19cd4a72b4a2$var$useButtonStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Bt984gj: "f122n59",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23",
        w71qe1: "f1iuv45f",
        ha4doy: "fmrv4ls",
        qhf8xq: "f10pi13n",
        De3pzq: "f1c21dwh",
        sj55zd: "fkfq4zb",
        icvyot: "f1ern45e",
        vrafjx: [
            "f1n71otn",
            "f1deefiw"
        ],
        oivjwe: "f1h8hb77",
        wvpqe5: [
            "f1deefiw",
            "f1n71otn"
        ],
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1s184ao",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f16d74zd",
        D0sxk3: "f16u1re",
        t6yez3: "f1rw4040",
        Jwef8y: "fjxutwb",
        Bi91k9c: "f139oj5f",
        eoavqd: "f8491dx",
        Bk3fhr4: "f1jpd6y0",
        Bmfj8id: "fuxngvv",
        iro3zm: "fwiml72",
        B2d53fq: "f1fg1p5m"
    },
    selected: {
        De3pzq: "f1q9pm1r",
        sj55zd: "f1qj7y59",
        D0sxk3: "fgzdkf0",
        t6yez3: "f15q0o9g",
        By8wz76: "f1nz3ub2",
        B7iucu3: "f1205bnn"
    },
    highContrast: {
        B7iucu3: "fslfhp6",
        Bfsdueo: "f11s1vgy",
        pb71ee: "f12b7wpn",
        ik86qs: "f1u668rv"
    },
    focusIndicator: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bqhya38: "f1j6vpng",
        Bwxa6fj: [
            "f1pniga2",
            "f1ffjurs"
        ],
        Bdhvstf: "f987i1v",
        B7zbvrb: [
            "f1ffjurs",
            "f1pniga2"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        f6g5ot: 0,
        Boxcth7: 0,
        Bhdgwq3: 0,
        hgwjuy: 0,
        Bshpdp8: 0,
        Bsom6fd: 0,
        Blkhhs4: 0,
        Bonggc9: 0,
        Ddfuxk: 0,
        i03rao: 0,
        kclons: 0,
        clg4pj: 0,
        Bpqj9nj: 0,
        B6dhp37: 0,
        Bf4ptjt: 0,
        Bqtpl0w: 0,
        i4rwgc: "ffwy5si",
        Dah5zi: 0,
        B1tsrr9: 0,
        qqdqy8: 0,
        Bkh64rk: 0,
        e3fwne: "f3znvyf",
        J0r882: "f57olzd",
        Bule8hv: [
            "f4stah7",
            "fs1por5"
        ],
        Bjwuhne: "f480a47",
        Ghsupd: [
            "fs1por5",
            "f4stah7"
        ]
    },
    large: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1kx978o"
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".ftuwxu6{display:inline-flex;}",
        ".f4d9j23{justify-content:center;}",
        ".f1iuv45f{text-decoration-line:none;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f10pi13n{position:relative;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f1ern45e{border-top-style:none;}",
        ".f1n71otn{border-right-style:none;}",
        ".f1deefiw{border-left-style:none;}",
        ".f1h8hb77{border-bottom-style:none;}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f1s184ao{margin:0;}",
            {
                p: -1
            }
        ],
        [
            ".f16d74zd{padding:var(--spacingVerticalXS) var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".f16u1re .fui-Icon-filled{display:none;}",
        ".f1rw4040 .fui-Icon-regular{display:inline-flex;}",
        ".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}",
        ".f1qj7y59{color:var(--colorNeutralForeground2BrandSelected);}",
        ".fgzdkf0 .fui-Icon-filled{display:inline-flex;}",
        ".f15q0o9g .fui-Icon-regular{display:none;}",
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        [
            ".ffwy5si[data-fui-focus-visible]::after{border:2px solid var(--colorStrokeFocus2);}",
            {
                p: -2
            }
        ],
        [
            ".f3znvyf[data-fui-focus-visible]::after{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}",
        ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}",
        ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}",
        ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}",
        [
            ".f1kx978o{padding:var(--spacingVerticalXXS) var(--spacingVerticalXXS);}",
            {
                p: -1
            }
        ]
    ],
    h: [
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f8491dx:hover{cursor:pointer;}",
        ".f1jpd6y0:hover .fui-Icon-filled{display:inline-flex;}",
        ".fuxngvv:hover .fui-Icon-regular{display:none;}",
        ".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f1fg1p5m:hover:active{color:var(--colorNeutralForeground2BrandPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1nz3ub2{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1205bnn{color:Canvas;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fslfhp6{color:CanvasText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f11s1vgy:hover,.f11s1vgy:hover:active{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f12b7wpn:hover,.f12b7wpn:hover:active{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1u668rv:hover,.f1u668rv:hover:active{color:Canvas;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1j6vpng[data-fui-focus-visible]::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ffjurs[data-fui-focus-visible]::after{border-left-color:Highlight;}.f1pniga2[data-fui-focus-visible]::after{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f987i1v[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ]
});
const $b0af19cd4a72b4a2$var$usePopoverSurfaceStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        B2u0y6b: "f1qmtlvf"
    },
    smallMedium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f1qmtlvf{max-width:264px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const $b0af19cd4a72b4a2$export$5f0c18bb69638ffa = (state)=>{
    const { size: size } = state;
    const { open: open } = state.popover;
    const buttonStyles = $b0af19cd4a72b4a2$var$useButtonStyles();
    const popoverSurfaceStyles = $b0af19cd4a72b4a2$var$usePopoverSurfaceStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.info.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($b0af19cd4a72b4a2$export$51800f574cdd94c9.info, popoverSurfaceStyles.base, size === 'large' ? popoverSurfaceStyles.large : popoverSurfaceStyles.smallMedium, state.info.className);
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($b0af19cd4a72b4a2$export$51800f574cdd94c9.root, buttonStyles.base, buttonStyles.highContrast, buttonStyles.focusIndicator, open && buttonStyles.selected, size === 'large' && buttonStyles.large, state.root.className);
    return state;
};


'use client';
const $c411844bf030ee28$export$10d4b9c1046c21df = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $0f3d4dea9209d885$export$d64b8a2bdde1dfcc)(props, ref);
    (0, $b0af19cd4a72b4a2$export$5f0c18bb69638ffa)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useInfoButtonStyles_unstable')(state);
    return (0, $3a031b21ff566868$export$9ef445a692a707f5)(state);
});
$c411844bf030ee28$export$10d4b9c1046c21df.displayName = 'InfoButton';


'use client';
const $afd8ebd6dc0e5442$export$d262c2e297b8bb80 = (props, ref)=>{
    const { root: rootShorthand, label: labelShorthand, infoButton: infoButtonShorthand, info: info, size: size, className: className, style: style, ...labelProps } = props;
    const baseId = (0, $0200d30cfa270435$export$f680877a34711e37)('infolabel-');
    const [open, setOpen] = $acw62.useState(false);
    const root = (0, $fcf7ddccaab7fd8f$exports).always(rootShorthand, {
        defaultProps: {
            className: className,
            style: style
        },
        elementType: 'span'
    });
    const label = (0, $fcf7ddccaab7fd8f$exports).always(labelShorthand, {
        defaultProps: {
            id: baseId + '__label',
            ref: ref,
            size: size,
            ...labelProps
        },
        elementType: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
    });
    const infoButton = (0, $fcf7ddccaab7fd8f$exports).optional(infoButtonShorthand, {
        renderByDefault: !!info,
        defaultProps: {
            id: baseId + '__infoButton',
            size: size,
            info: info
        },
        elementType: (0, $c411844bf030ee28$export$10d4b9c1046c21df)
    });
    const infoButtonPopover = (0, $fcf7ddccaab7fd8f$exports).always(infoButton === null || infoButton === void 0 ? void 0 : infoButton.popover, {
        elementType: 'div'
    });
    infoButtonPopover.onOpenChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(infoButtonPopover.onOpenChange, (_, data)=>{
        setOpen(data.open);
    }));
    if (infoButton) {
        var _infoButton, _arialabelledby;
        infoButton.popover = infoButtonPopover;
        const infoPopupId = baseId + '__info'; // used as a self-referencing aria-labelledby to name the popup
        infoButton.info = (0, $fcf7ddccaab7fd8f$exports).optional(infoButton === null || infoButton === void 0 ? void 0 : infoButton.info, {
            defaultProps: {
                id: infoPopupId,
                'aria-labelledby': infoPopupId
            },
            elementType: 'div'
        });
        var _;
        (_ = (_infoButton = infoButton)[_arialabelledby = 'aria-labelledby']) !== null && _ !== void 0 ? _ : _infoButton[_arialabelledby] = `${label.id} ${infoButton.id}`;
        if (open) {
            var _infoButton_info;
            var _root, _ariaowns;
            var _1;
            (_1 = (_root = root)[_ariaowns = 'aria-owns']) !== null && _1 !== void 0 ? _1 : _root[_ariaowns] = (_infoButton_info = infoButton.info) === null || _infoButton_info === void 0 ? void 0 : _infoButton_info.id;
        }
    }
    return {
        size: size,
        components: {
            root: 'span',
            label: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5),
            infoButton: (0, $c411844bf030ee28$export$10d4b9c1046c21df)
        },
        root: root,
        label: label,
        infoButton: infoButton
    };
};




'use client';
const $76bc261a2cb36f06$export$fad2dd3120c384c0 = {
    root: 'fui-InfoLabel',
    label: 'fui-InfoLabel__label',
    infoButton: 'fui-InfoLabel__infoButton'
};
const $76bc261a2cb36f06$var$useLabelStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        ha4doy: "f12kltsn",
        Bceei9c: "fpo1scq",
        sj55zd: "f1ym3bx4"
    }
}, {
    d: [
        ".f12kltsn{vertical-align:top;}",
        ".fpo1scq{cursor:inherit;}",
        ".f1ym3bx4{color:inherit;}"
    ]
});
const $76bc261a2cb36f06$var$useInfoButtonStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        ha4doy: "f12kltsn",
        B6of3ja: "f1bmzb36",
        jrapky: "f1nyzk09"
    },
    large: {
        B6of3ja: "fkrn0sh",
        jrapky: "fmxx68s"
    }
}, {
    d: [
        ".f12kltsn{vertical-align:top;}",
        ".f1bmzb36{margin-top:calc(0px - var(--spacingVerticalXXS));}",
        ".f1nyzk09{margin-bottom:calc(0px - var(--spacingVerticalXXS));}",
        ".fkrn0sh{margin-top:-1px;}",
        ".fmxx68s{margin-bottom:-1px;}"
    ]
});
const $76bc261a2cb36f06$export$a61a8874c3d5fd23 = (state)=>{
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($76bc261a2cb36f06$export$fad2dd3120c384c0.root, state.root.className);
    const labelStyles = $76bc261a2cb36f06$var$useLabelStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.label.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($76bc261a2cb36f06$export$fad2dd3120c384c0.label, labelStyles.base, state.label.className);
    const infoButtonStyles = $76bc261a2cb36f06$var$useInfoButtonStyles();
    if (state.infoButton) // eslint-disable-next-line react-hooks/immutability
    state.infoButton.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($76bc261a2cb36f06$export$fad2dd3120c384c0.infoButton, infoButtonStyles.base, state.size === 'large' && infoButtonStyles.large, state.infoButton.className);
    return state;
};


'use client';
const $123fb63dcb21233c$export$6fdf58e0e61e341c = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $afd8ebd6dc0e5442$export$d262c2e297b8bb80)(props, ref);
    (0, $76bc261a2cb36f06$export$a61a8874c3d5fd23)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useInfoLabelStyles_unstable')(state);
    return (0, $9d564f25d704974e$export$f6b0663682a12f37)(state);
});
$123fb63dcb21233c$export$6fdf58e0e61e341c.displayName = 'InfoLabel';


var $acw62 = parcelRequire("acw62");



'use client';
const $9e973c873ac10c35$export$878f5318e879007 = (props, ref)=>{
    const overrides = (0, $dcb30b81376c0f2d$export$ab0d8295b09da679)();
    const fieldContext = (0, $9be8a0b8d40bba68$export$100197406d2d5de2)();
    var _fieldContext_size, _overrides_inputDefaultAppearance;
    const { size: size = (_fieldContext_size = fieldContext === null || fieldContext === void 0 ? void 0 : fieldContext.size) !== null && _fieldContext_size !== void 0 ? _fieldContext_size : 'medium', appearance: appearance = (_overrides_inputDefaultAppearance = overrides.inputDefaultAppearance) !== null && _overrides_inputDefaultAppearance !== void 0 ? _overrides_inputDefaultAppearance : 'outline', ...baseProps } = props;
    const state = $9e973c873ac10c35$export$38dd9834de030ae9(baseProps, ref);
    return {
        size: size,
        appearance: appearance,
        ...state
    };
};
const $9e973c873ac10c35$export$38dd9834de030ae9 = (props, ref)=>{
    const fieldControlProps = (0, $af5cf4826b6cd175$export$fc5228adfb2d94ce)(props, {
        supportsLabelFor: true,
        supportsRequired: true
    });
    const [value, setValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: fieldControlProps.value,
        defaultState: fieldControlProps.defaultValue,
        initialState: ''
    });
    const nativeProps = (0, $f5c0cec12bf016e1$export$199c93d3d8d08c56)({
        props: fieldControlProps,
        primarySlotTagName: 'input',
        excludedPropNames: [
            'onChange',
            'value',
            'defaultValue'
        ]
    });
    const state = {
        components: {
            root: 'span',
            input: 'input',
            contentBefore: 'span',
            contentAfter: 'span'
        },
        input: (0, $fcf7ddccaab7fd8f$exports).always(fieldControlProps.input, {
            defaultProps: {
                type: 'text',
                ref: ref,
                ...nativeProps.primary
            },
            elementType: 'input'
        }),
        contentAfter: (0, $fcf7ddccaab7fd8f$exports).optional(fieldControlProps.contentAfter, {
            elementType: 'span'
        }),
        contentBefore: (0, $fcf7ddccaab7fd8f$exports).optional(fieldControlProps.contentBefore, {
            elementType: 'span'
        }),
        root: (0, $fcf7ddccaab7fd8f$exports).always(fieldControlProps.root, {
            defaultProps: nativeProps.root,
            elementType: 'span'
        })
    };
    state.input.value = value;
    state.input.onChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        var _fieldControlProps_onChange;
        const newValue = ev.target.value;
        (_fieldControlProps_onChange = fieldControlProps.onChange) === null || _fieldControlProps_onChange === void 0 || _fieldControlProps_onChange.call(fieldControlProps, ev, {
            value: newValue
        });
        setValue(newValue);
    });
    return state;
};




const $f5e3769fe1755ae5$export$54ec0041a8fd630f = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.contentBefore && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.contentBefore, {}),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.input, {}),
            state.contentAfter && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.contentAfter, {})
        ]
    });
};




'use client';
const $835a7c0809077e06$export$f0c3f58cf17c701f = {
    root: 'fui-Input',
    input: 'fui-Input__input',
    contentBefore: 'fui-Input__contentBefore',
    contentAfter: 'fui-Input__contentAfter'
};
// TODO(sharing) should these be shared somewhere?
const $835a7c0809077e06$var$fieldHeights = {
    small: '24px',
    medium: '32px',
    large: '40px'
};
// With no contentBefore or contentAfter, the input slot uses combined padding to increase its hit target.
// If there is contentBefore or contentAfter, then the root and input slots use their individual padding.
const $835a7c0809077e06$var$horizontalPadding = {
    root: {
        small: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalSNudge,
        medium: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalMNudge,
        large: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalM
    },
    input: {
        small: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalXXS,
        medium: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalXXS,
        large: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalSNudge
    },
    combined: {
        small: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalS,
        medium: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalM,
        large: `calc(${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalM} + ${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).spacingHorizontalSNudge})`
    }
};
const $835a7c0809077e06$var$useRootClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1oeeo9n", "r9sxh5", {
    r: [
        ".r1oeeo9n{display:inline-flex;align-items:center;flex-wrap:nowrap;gap:var(--spacingHorizontalXXS);border-radius:var(--borderRadiusMedium);position:relative;box-sizing:border-box;vertical-align:middle;min-height:32px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);background-color:var(--colorNeutralBackground1);border:1px solid var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        ".r1oeeo9n::after{box-sizing:border-box;content:\"\";position:absolute;left:-1px;bottom:-1px;right:-1px;height:max(2px, var(--borderRadiusMedium));border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-bottom:2px solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - 2px) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}",
        ".r1oeeo9n:focus-within::after{transform:scaleX(1);transition-property:transform;transition-duration:var(--durationNormal);transition-delay:var(--curveDecelerateMid);}",
        ".r1oeeo9n:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",
        ".r1oeeo9n:focus-within{outline:2px solid transparent;}",
        ".r9sxh5{display:inline-flex;align-items:center;flex-wrap:nowrap;gap:var(--spacingHorizontalXXS);border-radius:var(--borderRadiusMedium);position:relative;box-sizing:border-box;vertical-align:middle;min-height:32px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);background-color:var(--colorNeutralBackground1);border:1px solid var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        ".r9sxh5::after{box-sizing:border-box;content:\"\";position:absolute;right:-1px;bottom:-1px;left:-1px;height:max(2px, var(--borderRadiusMedium));border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-bottom:2px solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - 2px) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}",
        ".r9sxh5:focus-within::after{transform:scaleX(1);transition-property:transform;transition-duration:var(--durationNormal);transition-delay:var(--curveDecelerateMid);}",
        ".r9sxh5:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",
        ".r9sxh5:focus-within{outline:2px solid transparent;}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.r1oeeo9n::after{transition-duration:0.01ms;transition-delay:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1oeeo9n:focus-within::after{transition-duration:0.01ms;transition-delay:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r9sxh5::after{transition-duration:0.01ms;transition-delay:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r9sxh5:focus-within::after{transition-duration:0.01ms;transition-delay:0.01ms;}}"
    ]
});
const $835a7c0809077e06$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    small: {
        sshi5w: "f1pha7fy",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    medium: {},
    large: {
        sshi5w: "f1w5jphr",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k",
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f1eyhf9v"
    },
    outline: {},
    outlineInteractive: {
        Bgoe8wy: "fvcxoqz",
        Bwzppfd: [
            "f1ub3y4t",
            "f1m52nbi"
        ],
        oetu4i: "f1l4zc64",
        gg5e9n: [
            "f1m52nbi",
            "f1ub3y4t"
        ],
        Drbcw7: "f8vnjqi",
        udz0bu: [
            "fz1etlk",
            "f1hc16gm"
        ],
        Be8ivqh: "f1klwx88",
        ofdepl: [
            "f1hc16gm",
            "fz1etlk"
        ]
    },
    underline: {
        De3pzq: "f1c21dwh",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "fokr779",
        icvyot: "f1ern45e",
        vrafjx: [
            "f1n71otn",
            "f1deefiw"
        ],
        wvpqe5: [
            "f1deefiw",
            "f1n71otn"
        ],
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        B1piin3: [
            "f15yvnhg",
            "f1n6gb5g"
        ]
    },
    underlineInteractive: {
        oetu4i: "f1l4zc64",
        Be8ivqh: "f1klwx88",
        d9w3h3: 0,
        B3778ie: 0,
        B4j8arr: 0,
        Bl18szs: 0,
        Blrzh8d: "f2ale1x"
    },
    filled: {
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ]
    },
    filledInteractive: {
        q7v0qe: "ftmjh5b",
        kmh5ft: [
            "f17blpuu",
            "fsrcdbj"
        ],
        nagaa4: "f1tpwn32",
        B1yhkcb: [
            "fsrcdbj",
            "f17blpuu"
        ]
    },
    invalid: {
        tvckwq: "fs4k3qj",
        gk2u95: [
            "fcee079",
            "fmyw78r"
        ],
        hhx65j: "f1fgmyf4",
        Bxowmz0: [
            "fmyw78r",
            "fcee079"
        ]
    },
    "filled-darker": {
        De3pzq: "f16xq7d1"
    },
    "filled-lighter": {
        De3pzq: "fxugw4r"
    },
    "filled-darker-shadow": {
        De3pzq: "f16xq7d1",
        E5pizo: "fyed02w"
    },
    "filled-lighter-shadow": {
        De3pzq: "fxugw4r",
        E5pizo: "fyed02w"
    },
    disabled: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1c21dwh",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        Bcq6wej: "f9dbb4x",
        Jcjdmf: [
            "f3qs60o",
            "f5u9ap2"
        ],
        sc4o1m: "fwd1oij",
        Bosien3: [
            "f5u9ap2",
            "f3qs60o"
        ],
        Bsft5z2: "fhr9occ",
        Bduesf4: "f99w1ws"
    },
    smallWithContentBefore: {
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    },
    smallWithContentAfter: {
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ]
    },
    mediumWithContentBefore: {
        uwmqm3: [
            "f1ng84yb",
            "f11gcy0p"
        ]
    },
    mediumWithContentAfter: {
        z189sj: [
            "f11gcy0p",
            "f1ng84yb"
        ]
    },
    largeWithContentBefore: {
        uwmqm3: [
            "f1uw59to",
            "fw5db7e"
        ]
    },
    largeWithContentAfter: {
        z189sj: [
            "fw5db7e",
            "f1uw59to"
        ]
    }
}, {
    d: [
        ".f1pha7fy{min-height:24px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f1w5jphr{min-height:40px;}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        [
            ".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        [
            ".fokr779{border-radius:0;}",
            {
                p: -1
            }
        ],
        ".f1ern45e{border-top-style:none;}",
        ".f1n71otn{border-right-style:none;}",
        ".f1deefiw{border-left-style:none;}",
        ".f1n6gb5g::after{left:0;}",
        ".f15yvnhg::after{right:0;}",
        [
            ".f2ale1x::after{border-radius:0;}",
            {
                p: -1
            }
        ],
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".fs4k3qj:not(:focus-within),.fs4k3qj:hover:not(:focus-within){border-top-color:var(--colorPaletteRedBorder2);}",
        ".fcee079:not(:focus-within),.fcee079:hover:not(:focus-within){border-right-color:var(--colorPaletteRedBorder2);}",
        ".fmyw78r:not(:focus-within),.fmyw78r:hover:not(:focus-within){border-left-color:var(--colorPaletteRedBorder2);}",
        ".f1fgmyf4:not(:focus-within),.f1fgmyf4:hover:not(:focus-within){border-bottom-color:var(--colorPaletteRedBorder2);}",
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".fyed02w{box-shadow:var(--shadow2);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fhr9occ::after{content:unset;}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".f1ng84yb{padding-left:var(--spacingHorizontalMNudge);}",
        ".f11gcy0p{padding-right:var(--spacingHorizontalMNudge);}",
        ".f1uw59to{padding-left:var(--spacingHorizontalM);}",
        ".fw5db7e{padding-right:var(--spacingHorizontalM);}"
    ],
    h: [
        ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".f1l4zc64:hover{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}",
        ".ftmjh5b:hover,.ftmjh5b:focus-within{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".f17blpuu:hover,.f17blpuu:focus-within{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".fsrcdbj:hover,.fsrcdbj:focus-within{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".f1tpwn32:hover,.f1tpwn32:focus-within{border-bottom-color:var(--colorTransparentStrokeInteractive);}"
    ],
    a: [
        ".f8vnjqi:active,.f8vnjqi:focus-within{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".fz1etlk:active,.fz1etlk:focus-within{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f1hc16gm:active,.f1hc16gm:focus-within{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1klwx88:active,.f1klwx88:focus-within{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f9dbb4x{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3qs60o{border-right-color:GrayText;}.f5u9ap2{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fwd1oij{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    w: [
        ".f99w1ws:focus-within{outline-style:none;}"
    ]
});
const $835a7c0809077e06$var$useInputClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r12stul0", null, [
    ".r12stul0{align-self:stretch;box-sizing:border-box;flex-grow:1;min-width:0;border-style:none;padding:0 var(--spacingHorizontalM);color:var(--colorNeutralForeground1);background-color:transparent;outline-style:none;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;}",
    ".r12stul0::-webkit-input-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r12stul0::-moz-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r12stul0::placeholder{color:var(--colorNeutralForeground4);opacity:1;}"
]);
const $835a7c0809077e06$var$useInputElementStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    small: {
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ]
    },
    medium: {},
    large: {
        uwmqm3: [
            "fnphzt9",
            "flt1dlf"
        ],
        z189sj: [
            "flt1dlf",
            "fnphzt9"
        ]
    },
    smallWithContentBefore: {
        uwmqm3: [
            "fgiv446",
            "ffczdla"
        ]
    },
    smallWithContentAfter: {
        z189sj: [
            "ffczdla",
            "fgiv446"
        ]
    },
    mediumWithContentBefore: {
        uwmqm3: [
            "fgiv446",
            "ffczdla"
        ]
    },
    mediumWithContentAfter: {
        z189sj: [
            "ffczdla",
            "fgiv446"
        ]
    },
    largeWithContentBefore: {
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    },
    largeWithContentAfter: {
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ]
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        De3pzq: "f1c21dwh",
        Bceei9c: "fdrzuqr",
        yvdlaj: "fahhnxm"
    }
}, {
    d: [
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".fnphzt9{padding-left:calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge));}",
        ".flt1dlf{padding-right:calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge));}",
        ".fgiv446{padding-left:var(--spacingHorizontalXXS);}",
        ".ffczdla{padding-right:var(--spacingHorizontalXXS);}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}",
        ".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}"
    ]
});
const $835a7c0809077e06$var$useContentClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1572tok", null, [
    ".r1572tok{box-sizing:border-box;color:var(--colorNeutralForeground3);display:flex;}",
    ".r1572tok>svg{font-size:20px;}"
]);
const $835a7c0809077e06$var$useContentStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    disabled: {
        sj55zd: "f1s2aq7o"
    },
    small: {
        Duoase: "f3qv9w"
    },
    medium: {},
    large: {
        Duoase: "f16u2scb"
    }
}, {
    d: [
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f3qv9w>svg{font-size:16px;}",
        ".f16u2scb>svg{font-size:24px;}"
    ]
});
const $835a7c0809077e06$export$fce54e6b2c661423 = (state)=>{
    const { size: size, appearance: appearance } = state;
    const disabled = state.input.disabled;
    const invalid = `${state.input['aria-invalid']}` === 'true';
    const filled = appearance.startsWith('filled');
    const rootStyles = $835a7c0809077e06$var$useRootStyles();
    const inputStyles = $835a7c0809077e06$var$useInputElementStyles();
    const contentStyles = $835a7c0809077e06$var$useContentStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($835a7c0809077e06$export$f0c3f58cf17c701f.root, $835a7c0809077e06$var$useRootClassName(), rootStyles[size], state.contentBefore && rootStyles[`${size}WithContentBefore`], state.contentAfter && rootStyles[`${size}WithContentAfter`], rootStyles[appearance], !disabled && appearance === 'outline' && rootStyles.outlineInteractive, !disabled && appearance === 'underline' && rootStyles.underlineInteractive, !disabled && filled && rootStyles.filledInteractive, filled && rootStyles.filled, !disabled && invalid && rootStyles.invalid, disabled && rootStyles.disabled, state.root.className);
    // eslint-disable-next-line react-hooks/immutability
    state.input.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($835a7c0809077e06$export$f0c3f58cf17c701f.input, $835a7c0809077e06$var$useInputClassName(), inputStyles[size], state.contentBefore && inputStyles[`${size}WithContentBefore`], state.contentAfter && inputStyles[`${size}WithContentAfter`], disabled && inputStyles.disabled, state.input.className);
    const contentClasses = [
        $835a7c0809077e06$var$useContentClassName(),
        disabled && contentStyles.disabled,
        contentStyles[size]
    ];
    if (state.contentBefore) // eslint-disable-next-line react-hooks/immutability
    state.contentBefore.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($835a7c0809077e06$export$f0c3f58cf17c701f.contentBefore, ...contentClasses, state.contentBefore.className);
    if (state.contentAfter) // eslint-disable-next-line react-hooks/immutability
    state.contentAfter.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($835a7c0809077e06$export$f0c3f58cf17c701f.contentAfter, ...contentClasses, state.contentAfter.className);
    return state;
};



'use client';
const $ffa73c40fd1a9147$export$f5b8910cec6cf069 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $9e973c873ac10c35$export$878f5318e879007)(props, ref);
    (0, $835a7c0809077e06$export$fce54e6b2c661423)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useInputStyles_unstable')(state);
    return (0, $f5e3769fe1755ae5$export$54ec0041a8fd630f)(state);
});
$ffa73c40fd1a9147$export$f5b8910cec6cf069.displayName = 'Input';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



"use client";
const $77e1bce0ac0f7fe7$export$7bc1c4f0765ef7e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane16Filled', "16", [
    "M7.9 1A.9.9 0 0 0 7 2.05l.69 4.43-1.88.17L4.57 4.5A1 1 0 0 0 3.73 4c-.4 0-.73.33-.73.73v2.18L1.97 7a1 1 0 0 0 0 2L3 9.1v2.17c0 .4.33.73.73.73.35 0 .67-.19.84-.49L5.8 9.35l1.88.17-.68 4.43A.9.9 0 0 0 7.9 15c.51 0 .98-.3 1.2-.77l2.02-4.4c.62.06 1.25.17 1.87.17a2 2 0 1 0 0-4c-.62 0-1.25.11-1.87.17L9.1 1.77A1.3 1.3 0 0 0 7.9 1"
]);
const $77e1bce0ac0f7fe7$export$38e3ca7ae182a492 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane16Regular', "16", [
    "M7.04 2.28C6.94 1.61 7.46 1 8.14 1s1.3.4 1.57 1l1.88 4.07Q12.29 6 13 6a2 2 0 1 1 0 4q-.7-.01-1.41-.07L9.7 14c-.28.6-.9 1-1.56 1-.69 0-1.2-.6-1.1-1.28l.6-3.97-1.53-.08-.92 1.61c-.25.45-.73.72-1.24.72a.96.96 0 0 1-.96-.96V9.52l-.51-.02a1.5 1.5 0 0 1 0-3L3 6.48V4.96c0-.53.43-.96.96-.96.51 0 .99.27 1.24.72l.92 1.6 1.54-.07zM8.14 2a.1.1 0 0 0-.1.13L8.8 7.2l-3.25.16L4.33 5.2a.4.4 0 0 0-.33-.2v2.42l-1.49.07H2.5a.5.5 0 0 0 0 1h.01L4 8.57V11q.22-.03.33-.21l1.23-2.15 3.25.16-.78 5.07q0 .12.12.13c.28 0 .54-.16.65-.42l2.16-4.68 1.94.1h.1a1 1 0 1 0-.1-2l-1.94.1L8.8 2.42A.7.7 0 0 0 8.15 2"
]);
const $77e1bce0ac0f7fe7$export$588d994261a971a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane20Filled', "20", [
    "M9 2c.6 0 1.16.36 1.4.92l2.37 5.4 3.23-.2a1.9 1.9 0 0 1 2 1.76V10c0 1.04-.84 1.88-1.88 1.88H16l-3.23-.2-2.37 5.4c-.24.56-.8.92-1.4.92a.9.9 0 0 1-.88-.88v-.06l.7-5.63-2.46-.16-1.14 2.28a.8.8 0 0 1-.72.45.5.5 0 0 1-.5-.5v-2.38l-1.06-.06a1 1 0 0 1-.94-1v-.12a1 1 0 0 1 .94-1L4 8.88V6.5c0-.28.22-.5.5-.5.3 0 .59.17.72.45l1.14 2.28 2.46-.16L8.12 3A.9.9 0 0 1 9 2"
]);
const $77e1bce0ac0f7fe7$export$39cf74e878a42ab6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane20Regular', "20", [
    "M8.78 8.29 8.1 2.81a1.16 1.16 0 0 1 1-1.3h.08l.17-.01c.6 0 1.13.35 1.37.9l2.51 5.74 2.75-.09c1.03-.03 1.9.73 2 1.74l.02.15V10c0 1.08-.87 1.95-1.96 1.95l-2.8-.1-2.52 5.75c-.24.55-.78.9-1.37.9h-.1a1.16 1.16 0 0 1-1.15-1.3l.68-5.5-2.14-.06-.96 1.67c-.24.43-.7.69-1.18.69a1 1 0 0 1-1-1v-1.47h-.16a1.53 1.53 0 0 1 0-3.05l.16-.01V7a1 1 0 0 1 1-1c.49 0 .94.26 1.18.69l.96 1.67zm.57-5.79h-.12a.16.16 0 0 0-.14.18l.82 6.57-3.84.13-1.26-2.2A.4.4 0 0 0 4.5 7v2.43l-.98.04a.53.53 0 0 0 0 1.06l.98.04V13h.08q.15-.05.23-.18l1.26-2.2 3.84.13-.82 6.59q.01.15.16.16h.1a.5.5 0 0 0 .45-.3l2.79-6.36 3.46.11c.52 0 .95-.42.95-.95v-.03a.95.95 0 0 0-.98-.92l-3.43.11L9.8 2.8a.5.5 0 0 0-.45-.3"
]);
const $77e1bce0ac0f7fe7$export$644520e55f3584f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane24Filled', "24", [
    "M21.99 11.95a2 2 0 0 1-2.05 1.99l-4.74-.14-3.45 7.14c-.28.57-.86.94-1.5.94a.93.93 0 0 1-.92-1.04l.86-7.19-3.76-.1-.5 1.33c-.18.51-.66.85-1.2.85a.9.9 0 0 1-.9-.9v-1.48L3 13.18a1.26 1.26 0 0 1 0-2.47l.82-.17V9.07a.9.9 0 0 1 .78-.9h.12c.54 0 1.02.33 1.2.84l.5 1.34 3.75-.1-.85-7.1v-.1c0-.51.4-.93.92-.93.58 0 1.12.3 1.42.8l.08.14 3.4 7.04 4.79-.14a2 2 0 0 1 2.05 1.93z"
]);
const $77e1bce0ac0f7fe7$export$7faf10301b8cb745 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane24Regular', "24", [
    "m9.47 9.64-.7-5.87v-.08c0-.88.72-1.6 1.6-1.6.8 0 1.55.42 1.98 1.13l.1.16 2.94 6.09 3.95-.12a2.6 2.6 0 0 1 2.68 2.53v.07a2.6 2.6 0 0 1-2.62 2.6l-3.97-.12-2.99 6.19a2.3 2.3 0 0 1-2.06 1.3c-.9 0-1.61-.73-1.61-1.64v-.12l.71-5.9-2.13-.07-.27.74a1.95 1.95 0 0 1-1.83 1.28c-.87 0-1.58-.71-1.58-1.59v-.76l-.16-.03a1.92 1.92 0 0 1 0-3.76l.16-.03v-.76c0-.8.6-1.48 1.43-1.58h.15c.75 0 1.43.42 1.77 1.12l.06.15.27.74zm.9-6.05q-.09.01-.1.08l.88 7.42-4.84.15-.62-1.72-.04-.08c-.07-.15-.23-.25-.35-.25h-.06a.1.1 0 0 0-.07.09v1.98l-1.35.28a.42.42 0 0 0 0 .82l1.35.28v1.98q0 .08.08.09c.19 0 .36-.12.42-.3l.64-1.75 4.86.15-.9 7.47v.03q.01.1.1.1a.8.8 0 0 0 .72-.44l3.42-7.07 4.9.15c.61 0 1.1-.5 1.1-1.09v-.04a1.1 1.1 0 0 0-1.12-1.07l-4.93.15-3.35-6.93-.06-.1a.8.8 0 0 0-.67-.38"
]);
const $77e1bce0ac0f7fe7$export$4646e1d56d3c7e1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane28Filled', "28", [
    "M12.3 2c-.78 0-1.37.68-1.28 1.44l1 8.14-2.7.14-1.65-2.88C7.37 8.32 6.8 8 6.2 8 5.54 8 5 8.54 5 9.21v2.74L3.98 12a2 2 0 0 0 0 4l1.02.05v2.74c0 .67.54 1.21 1.21 1.21.6 0 1.16-.32 1.46-.84l1.64-2.88 2.7.14-1 8.14c-.08.77.51 1.44 1.28 1.44.72 0 1.37-.42 1.66-1.07l3.69-8.21c1.78.1 3.58.28 5.36.28a3 3 0 1 0 0-6c-1.78 0-3.58.19-5.36.28l-3.69-8.2A1.8 1.8 0 0 0 12.3 2"
]);
const $77e1bce0ac0f7fe7$export$73eaec2e30c712c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane28Regular', "28", [
    "M11.04 3.9A1.7 1.7 0 0 1 12.72 2c1.04 0 1.99.61 2.41 1.56l3.4 7.56C20.02 11.08 21.5 11 23 11a3 3 0 1 1 0 6c-1.49 0-2.98-.08-4.47-.12l-3.4 7.56A2.6 2.6 0 0 1 12.72 26a1.7 1.7 0 0 1-1.68-1.9l.9-7.4-2.83-.07-1.18 2.06A2.6 2.6 0 0 1 5.68 20C4.75 20 4 19.25 4 18.32v-1.87a2.5 2.5 0 0 1 0-4.9V9.68C4 8.75 4.75 8 5.68 8s1.8.5 2.25 1.31l1.18 2.06 2.83-.07zm1.68-.4a.2.2 0 0 0-.2.22l1.11 9.03-5.37.15-1.63-2.85a1.1 1.1 0 0 0-.95-.55q-.17.02-.18.18v3.3l-.99.02H4.5a1 1 0 1 0 0 2h.01l.99.03v3.3q.02.16.18.17c.4 0 .76-.21.95-.55l1.63-2.85 5.37.15-1.1 9.03a.2.2 0 0 0 .19.22c.45 0 .86-.26 1.04-.68l3.8-8.47 5.36.15H23a1.5 1.5 0 1 0-.08-3l-5.35.15-3.8-8.47c-.2-.42-.6-.68-1.05-.68"
]);
const $77e1bce0ac0f7fe7$export$87c7c90c5e15f88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane32Filled', "32", [
    "M14.76 2a1.8 1.8 0 0 0-1.8 2L14 13.56l-3.8.17-1.46-3.4A2.2 2.2 0 0 0 6.7 9C5.77 9 5 9.77 5 10.71v3.25L3.97 14a2 2 0 0 0 0 4l1.03.04v3.25c0 .94.77 1.71 1.71 1.71a2.2 2.2 0 0 0 2.02-1.33l1.46-3.4 3.8.17L12.96 28a1.8 1.8 0 0 0 1.8 2c.94 0 1.78-.56 2.15-1.42l4.22-9.83c1.95.08 3.92.25 5.87.25a3 3 0 1 0 0-6c-1.95 0-3.92.17-5.87.25L16.9 3.42A2.4 2.4 0 0 0 14.76 2"
]);
const $77e1bce0ac0f7fe7$export$9f0db725384b7492 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane32Regular', "32", [
    "M12.02 4.5c-.15-1.34.9-2.5 2.24-2.5a3.1 3.1 0 0 1 2.85 1.88l3.59 8.37c1.76-.08 3.54-.25 5.3-.25a4 4 0 0 1 0 8c-1.76 0-3.54-.17-5.3-.25l-3.59 8.37A3.1 3.1 0 0 1 14.26 30a2.26 2.26 0 0 1-2.24-2.5l.87-8.12-2.13-.1-.83 1.91A3 3 0 0 1 7.2 23 2.2 2.2 0 0 1 5 20.8V19h-.03a3 3 0 0 1 0-6H5v-1.8C5 9.97 5.98 9 7.2 9c1.19 0 2.26.71 2.73 1.8l.83 1.92 2.13-.1zm2.24-.5a.26.26 0 0 0-.26.29l1.1 10.23-5.64.27-1.36-3.2a1 1 0 0 0-.9-.59.2.2 0 0 0-.2.2v3.7l-1.98.1H5a1 1 0 1 0 0 2h.02l1.98.1v3.7q.02.18.2.2c.39 0 .74-.23.9-.6l1.36-3.19 5.64.27L14 27.71c-.01.16.1.29.26.29.44 0 .84-.26 1.01-.67l4.14-9.65 6.4.31.19.01a2 2 0 1 0-.2-4l-6.4.32-4.13-9.65a1.1 1.1 0 0 0-1-.67"
]);
const $77e1bce0ac0f7fe7$export$d672d4616aa6502 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane48Filled', "48", [
    "M21.01 3a2 2 0 0 0-2 2.22l1.5 14.93-4.36.28-2.5-4.37A4.1 4.1 0 0 0 10.1 14 2.1 2.1 0 0 0 8 16.1v4.84L6.96 21a3 3 0 0 0 0 6l1.04.06v4.84c0 1.16.94 2.1 2.1 2.1 1.47 0 2.82-.79 3.55-2.06l2.5-4.37 4.36.28-1.5 14.93A2 2 0 0 0 21 45c1.5 0 2.85-.87 3.47-2.23l6.5-14.27c2.66.17 5.36.5 8.02.5a5 5 0 0 0 0-10c-2.66 0-5.36.33-8.02.5l-6.5-14.27A3.8 3.8 0 0 0 21.01 3"
]);
const $77e1bce0ac0f7fe7$export$e8f5024cd4c3d2d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane48Regular', "48", [
    "M19.02 5.56A2.33 2.33 0 0 1 21.33 3c1.9 0 3.62 1.1 4.4 2.83l5.93 13c2.27-.1 4.57-.33 6.84-.33a5.5 5.5 0 1 1 0 11c-2.27 0-4.57-.22-6.84-.33l-5.93 13a4.8 4.8 0 0 1-4.4 2.83 2.33 2.33 0 0 1-2.31-2.56l1.4-13.83-3.76-.18-1.68 2.94A5.2 5.2 0 0 1 10.44 34 2.44 2.44 0 0 1 8 31.56V28h-.03a4 4 0 0 1 0-8H8v-3.56C8 15.1 9.1 14 10.44 14c1.88 0 3.61 1 4.54 2.63l1.68 2.94 3.76-.18zm2.5-.05 1.65 16.25-7.92.38-2.44-4.27a2.7 2.7 0 0 0-2.31-1.37v5.88l-2.47.12H8a1.5 1.5 0 0 0 0 3h.03l2.47.12v5.88a2.7 2.7 0 0 0 2.3-1.37l2.45-4.27 7.92.38-1.65 16.25a2.3 2.3 0 0 0 1.94-1.36l6.63-14.55 8.11.4q.15.02.3.02a3 3 0 1 0-.3-5.99l-8.11.4-6.63-14.54a2.3 2.3 0 0 0-1.94-1.36"
]);
const $77e1bce0ac0f7fe7$export$115089d364be5718 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding16Filled', "16", [
    "m8.85 2.85 1.07 2.19H8.89L6 4v-.5c0-1.6 2.15-2.08 2.85-.65m3.12 3.17a3 3 0 0 1 3.03 3v.48a1.5 1.5 0 0 1-1.98 1.42l-2.25-.77-5.23 1.77c-1.54.51-2.69-1.43-1.5-2.53l1.22-1.12-3.24-1.1a1.5 1.5 0 0 1-.73-2.3L3 2.47c.63-.88 2-.44 2 .63v1.6l3.54 1.29a1 1 0 0 0 .36.06zM1 14.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$b1bebd1bfedaf28b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding16Regular', "16", [
    "M6 5.06V3.5c0-1.59 2.15-2.09 2.85-.65l1.55 3.18 1.57-.01a3 3 0 0 1 3.03 3v.48a1.5 1.5 0 0 1-1.98 1.42l-2.25-.77-5.23 1.77c-1.54.51-2.69-1.43-1.5-2.53l1.22-1.12-3.24-1.1a1.5 1.5 0 0 1-.73-2.3L3 2.47c.63-.88 2-.44 2 .63v1.6zm3.3.98L7.95 3.28c-.23-.47-.95-.3-.95.22v1.93l1.54.56a1 1 0 0 0 .36.06zM1 14.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m1.34-8.28 3.25 1.1a1 1 0 0 1 .35 1.69l-1.22 1.12c-.4.36-.01 1.01.5.84l5.23-1.76a1 1 0 0 1 .65 0l2.24.76A.5.5 0 0 0 14 9.5v-.48a2 2 0 0 0-2.02-2l-3.08.03a2 2 0 0 1-.7-.12L4.33 5.52A.5.5 0 0 1 4 5.05V3.1a.1.1 0 0 0-.18-.06L2.1 5.45a.5.5 0 0 0 .24.77"
]);
const $77e1bce0ac0f7fe7$export$242f1e18a0ce8f13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding20Filled', "20", [
    "m11.88 6-1.03-2.15C10.16 2.41 8 2.91 8 4.5v.74l2.77.76zm-1.11 1-.27-.04L6 5.74V4.2c0-1.22-1.61-1.66-2.23-.6L2.24 6.19c-.57.96-.1 2.2.96 2.55l3.42 1.12-1.68 1.52c-1.17 1.08-.08 3 1.45 2.55l6.6-1.99 3.04 1A1.5 1.5 0 0 0 18 11.5V11a4 4 0 0 0-4-4zM2 17.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$9881a4a5f19da6ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding20Regular', "20", [
    "m12.36 7-1.5-3.15C10.15 2.41 8 2.91 8 4.5v1.78l-2-.54V4.2c0-1.22-1.61-1.66-2.23-.6L2.24 6.19c-.57.96-.1 2.2.96 2.55l3.42 1.12-1.68 1.52c-1.17 1.08-.08 3 1.45 2.55l6.6-1.99 3.04 1A1.5 1.5 0 0 0 18 11.5V11a4 4 0 0 0-4-4zm-1.1 0h-.5l-.26-.04-1.5-.4V4.5c0-.53.72-.7.95-.21zM2 17.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m11.59-6.41a2 2 0 0 0-1.18-.01L6.1 12.97c-.51.15-.87-.49-.48-.85l1.67-1.53a1 1 0 0 0-.36-1.68L3.52 7.79a.75.75 0 0 1-.42-1.1L4.63 4.1c.1-.17.37-.1.37.1v1.92c0 .22.15.42.37.48l4.87 1.33a2 2 0 0 0 .53.07H14a3 3 0 0 1 3 3v.51a.5.5 0 0 1-.66.48l-2.39-.79z"
]);
const $77e1bce0ac0f7fe7$export$8d21cfce2d47e3cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding24Filled', "24", [
    "M10 5.04v.78l3.03 1.2h2.12l-1.25-2.8C13 2.2 10 2.83 10 5.03m2.72 2.93L8.5 6.3V4.76a1.75 1.75 0 0 0-3.21-.96L3.38 6.7a2.3 2.3 0 0 0 1.04 3.4l3.5 1.46-2.05 1.9c-1.62 1.5 0 4.16 2.09 3.4l6.76-2.46 3.46 1.44A2.04 2.04 0 0 0 21 13.96v-1.23c0-2.6-2.11-4.71-4.72-4.71h-3.32a1 1 0 0 1-.24-.05M3 20.25c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$adc7ff18f14d0d70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding24Regular', "24", [
    "M11.5 7.49V5.04c0-.58.79-.75 1.03-.22l1.42 3.2h-1a1 1 0 0 1-.23-.05zm4.1.53-1.7-3.8C13 2.2 10 2.83 10 5.03v1.85l-1.5-.6V4.77a1.75 1.75 0 0 0-3.21-.96L3.38 6.7a2.3 2.3 0 0 0 1.04 3.4l3.5 1.46-2.05 1.9c-1.62 1.5 0 4.16 2.09 3.4l6.76-2.46 3.46 1.44A2.04 2.04 0 0 0 21 13.96v-1.23c0-2.6-2.11-4.71-4.72-4.71zM7 6.95c0 .22.13.42.34.5l4.83 1.92q.38.15.79.15h3.32a3.2 3.2 0 0 1 3.22 3.21v1.23c0 .39-.39.65-.74.5l-3.64-1.52a1 1 0 0 0-.73-.02l-6.95 2.53c-.55.2-.97-.5-.55-.9l2.62-2.42a1 1 0 0 0-.3-1.66L5 8.71a.8.8 0 0 1-.36-1.18l1.91-2.91c.14-.2.46-.11.46.14zm-4 13.3c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$6f74e1eee6d2cd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff16Filled', "16", [
    "M8.6 3.74q-.17.21-.3.41-.43.66-1.1.86l-3.43.9-.6-1.25C2.64 3.57 1 3.95 1 5.16V8c0 1.16 1.1 2 2.22 1.68l3.11-.87-.31 1.4c-.36 1.61 1.76 2.54 2.7 1.19l3.1-4.48 2.23-.82.15-.07c.62-.3.98-1.03.71-1.7V4.3q-.06-.15-.16-.29L14.72 4l-.22-.29c-.62-.77-1.65-1.7-3-1.7q-.3 0-.57.06c-.54.11-1.02.39-1.41.7q-.54.47-.91.96zm-4.16.96-.1-.13a1.6 1.6 0 0 1 2.17-2.29l1.27.87-.31.45c-.19.28-.39.4-.52.44zM1.5 14a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$2a51ff9be2a62983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff16Regular', "16", [
    "m5.1 5.56-.76-.99a1.6 1.6 0 0 1 2.17-2.29l2.1 1.44q.38-.5.9-.95c.53-.43 1.2-.77 2-.77 1.54.01 2.65 1.21 3.24 2.02.57.8.11 1.78-.7 2.08l-2.23.82-3.1 4.48c-.94 1.35-3.06.42-2.7-1.18l.31-1.41-3.1.87A1.75 1.75 0 0 1 1 8V5.16c0-1.21 1.64-1.59 2.17-.5l.6 1.25zm.03-1.6 1.03 1.32 1.04-.27q.45-.12.8-.5l-2.06-1.4a.6.6 0 0 0-.8.85m4 .74a3 3 0 0 1-1.67 1.28l-3.83 1a.5.5 0 0 1-.58-.26L2.27 5.1q-.04-.06-.07-.07h-.1l-.07.04Q2 5.08 2 5.16V8c0 .5.47.86.95.72l3.1-.87a1 1 0 0 1 1.26 1.18l-.32 1.4c-.12.54.59.85.9.4l3.2-4.61a.5.5 0 0 1 .24-.19l2.38-.87a.4.4 0 0 0 .27-.26.3.3 0 0 0-.05-.3C13.37 3.84 12.52 3 11.5 3q-.73.02-1.35.54A5 5 0 0 0 9.14 4.7M1.5 14a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$6401bcd14635661a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff20Filled', "20", [
    "m11.68 5.16-.38.33q-.35.33-.74.46L4.76 7.9l-.6-1.23a1 1 0 0 0-.24-.34c-.62-.6-1.74-.27-1.9.62L2 7.16v2.99c0 1.2 1.18 2.04 2.32 1.65l3.02-1.04-.3 1.46c-.3 1.56 1.7 2.47 2.66 1.21l3.1-4 4.18-1.35c.84-.27 1.33-1.28.74-2.1-.52-.7-1.43-1.68-2.67-1.92a3 3 0 0 0-.88-.04 5 5 0 0 0-2.5 1.14m-2.57.22L5.38 6.62l-.04-.05a1.6 1.6 0 0 1 2.17-2.29zM2.5 17a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$82d027adfc45eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff20Regular', "20", [
    "M14.5 4c-1.41-.01-2.63.96-3.2 1.49q-.35.33-.74.46l-.41.14L7.5 4.28a1.6 1.6 0 0 0-2.17 2.3l.7.88-1.28.43-.6-1.23C3.65 5.57 2 5.95 2 7.16v2.99c0 1.2 1.18 2.04 2.32 1.65l3.02-1.04-.3 1.46c-.3 1.56 1.7 2.47 2.66 1.21l3.1-4 4.18-1.35c.84-.27 1.33-1.28.74-2.1-.6-.8-1.7-1.97-3.22-1.98M7.04 7.13l-.9-1.17a.6.6 0 0 1 .8-.86L8.96 6.5zm4.94-.91c.55-.51 1.51-1.23 2.52-1.22 1 0 1.85.8 2.41 1.58q.1.15.04.3-.06.16-.28.25l-4.32 1.4a.5.5 0 0 0-.25.16l-3.19 4.13c-.32.42-.99.12-.88-.4l.29-1.47a1 1 0 0 0-1.3-1.14l-3.03 1.04c-.48.17-.99-.19-.99-.7V7.16q0-.07.03-.1l.08-.04.1.01.06.07.78 1.62c.1.22.37.33.6.25l6.23-2.07c.43-.14.8-.4 1.1-.68M2.5 17a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$77d29957c6457afc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff24Filled', "24", [
    "m10.52 4.41 1.87 1.52-.5.56q-.19.21-.29.21l-3.46.72-.38-.68a1.84 1.84 0 0 1 2.76-2.33m6.17.1c2.24-.18 3.91 1.24 4.86 2.32.49.56.58 1.27.37 1.88s-.69 1.1-1.34 1.32l-5.37 1.85-3.23 4.32a2 2 0 0 1-3.46-1.97l.5-1.23-3.3.63A2.3 2.3 0 0 1 3 11.38V7.7a1.7 1.7 0 0 1 3.18-.8l.96 1.76 4.67-.97q.47-.1.85-.55c.38-.45.93-1.05 1.6-1.57A4.7 4.7 0 0 1 16.7 4.5M3.75 19.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$7dac991cf5af2ce8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff24Regular', "24", [
    "m8.32 8.4-.78-1.12a2.1 2.1 0 0 1 3.05-2.81l2.58 2.09q.47-.5 1.1-1a4.7 4.7 0 0 1 2.42-1.06c2.24-.17 3.91 1.25 4.86 2.33.49.56.58 1.27.37 1.88s-.69 1.1-1.34 1.32l-5.37 1.85-3.16 4.22a2.25 2.25 0 0 1-4-1.78l.25-1.28-2.53.54A2.28 2.28 0 0 1 3 11.35V7.7a1.7 1.7 0 0 1 3.18-.8l.96 1.76zm.46-1.97 1.13 1.65 1.9-.4q.13-.03.26-.09L9.65 5.63a.6.6 0 0 0-.87.8M16.81 6c-.5.04-1.07.32-1.63.75-.55.42-1.03.94-1.36 1.34-.42.5-1 .91-1.7 1.06L6.9 10.23a.75.75 0 0 1-.8-.37L4.85 7.6a.2.2 0 0 0-.36.1v3.65c0 .5.46.87.95.77l3.64-.79a.75.75 0 0 1 .9.88l-.47 2.4a.75.75 0 0 0 1.33.6l3.3-4.41a1 1 0 0 1 .36-.26l5.58-1.93a.6.6 0 0 0 .41-.38.4.4 0 0 0-.08-.41c-.86-.98-2.1-1.94-3.61-1.82M3.75 19.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$d42ee41964b71e72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel16Filled', "16", [
    "M2.5 4.55a1 1 0 0 0-1 1 1 1 0 1 0 1-1m0-1q-.17 0-.32.03A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V7.49a2 2 0 1 0 .5-3.94m3 2.95c0 .28.22.5.5.5h4a.5.5 0 1 0 0-1H6a.5.5 0 0 0-.5.5m0 3c0 .28.22.5.5.5h2.61a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.5.5"
]);
const $77e1bce0ac0f7fe7$export$6e5569d28240ed9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel16Regular', "16", [
    "M2.5 6.55a1 1 0 0 1-1-1 1 1 0 1 1 1 1m-.32-2.97a2 2 0 0 1 1.06.11C3.5 3.28 3.97 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5V7.49a2 2 0 0 1-1 0v4.01A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7a2.5 2.5 0 0 0-2.32 1.58M6 6a.5.5 0 0 0 0 1h4a.5.5 0 1 0 0-1zm0 3a.5.5 0 0 0 0 1h2.61a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$c0983e5f2d26dcb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m-4-5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1"
]);
const $77e1bce0ac0f7fe7$export$71460282f7886f05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel20Regular', "20", [
    "M3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m0-1q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15m3.5 4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$74340571970d3728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel24Filled', "24", [
    "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.45 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.25 3zm-4.5 10h-4.5l-.1.01a.75.75 0 0 0 0 1.49h4.7a.75.75 0 0 0-.1-1.5m2-3.5h-6.6a.75.75 0 0 0 0 1.49h6.7a.75.75 0 0 0-.1-1.5M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$44956a5baf399d06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel24Regular', "24", [
    "M17.75 3A3.25 3.25 0 0 1 21 6.07v11.68a3.25 3.25 0 0 1-3.07 3.24l-.18.01H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.3 2.3 0 0 0 1.5 0v8.38c0 .92.7 1.67 1.6 1.74l.15.01h11.5c.92 0 1.67-.7 1.74-1.6l.01-.15V6.25c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.2 2.2 0 0 0-1.59-.2 3.3 3.3 0 0 1 2.85-2.05L6.25 3zm-4.5 10a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.49h4.6m2-3.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$403873410304dd9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17m.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h13.5C23.1 25 25 23.1 25 20.75V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06M9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M9 15.75c0-.41.34-.75.75-.75h5.75a.75.75 0 0 1 0 1.5H9.75a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$211b0e8f85249a50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel28Regular', "28", [
    "M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0m1 2.65v9.35C3 23.1 4.9 25 7.25 25h13.5C23.1 25 25 23.1 25 20.75V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06 3 3 0 0 1 1.55.12A2.8 2.8 0 0 1 7.25 4.5h13.5a2.75 2.75 0 0 1 2.75 2.75v13.5a2.75 2.75 0 0 1-2.75 2.75H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a3 3 0 0 1-1.5 0m6.75-.4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM9 15.75c0-.41.34-.75.75-.75h5.75a.75.75 0 0 1 0 1.5H9.75a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$f9ae3ca816f112e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel48Filled', "48", [
    "M6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4m.19-1.78A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6h-23.5c-2.92 0-5.38 2-6.06 4.72M16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M17.25 26h9.5a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$552e62bde3258cf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel48Regular', "48", [
    "M6.19 10.72A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75V18.21a4 4 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75h23.5a3.75 3.75 0 0 0 3.75-3.75v-23.5a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-2.63 0M6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4M17.25 19a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM16 27.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $77e1bce0ac0f7fe7$export$733c3c5f96e6a029 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd16Filled', "16", [
    "M1.63 2.29A1.76 1.76 0 0 1 3.75 4 1.75 1.75 0 0 1 1.5 5.68V8c0 1.1.9 2 2 2h1.52c.26-2.8 2.61-5 5.48-5V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29M4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 7a.5.5 0 0 1 0-1H6a.5.5 0 0 1 0 1zM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V10H8.5a.5.5 0 0 0 0 1H10v1.5a.5.5 0 0 0 1 0V11h1.5a.5.5 0 0 0 0-1H11z"
]);
const $77e1bce0ac0f7fe7$export$f6c5d78152012133 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd16Regular', "16", [
    "M2 2.25q-.2 0-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2q-.52 0-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4q-.32-.15-.7-.15M5.2 9H3.5a1 1 0 0 1-1-1V5.68a2 2 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52q.05-.52.19-1M4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1zM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V10H8.5a.5.5 0 0 0 0 1H10v1.5a.5.5 0 0 0 1 0V11h1.5a.5.5 0 0 0 0-1H11z"
]);
const $77e1bce0ac0f7fe7$export$55fd27dfeabec24a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $77e1bce0ac0f7fe7$export$189d17f296beccc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd20Regular', "20", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $77e1bce0ac0f7fe7$export$1de557b68f0e5974 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd24Filled', "24", [
    "M17.75 3C19.55 3 21 4.46 21 6.25v5.77a6.5 6.5 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.5 6.5 0 0 0 .3 6.5H6.24A3.25 3.25 0 0 1 3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.25 3zm-2.5 6.5h-6.6a.75.75 0 0 0 0 1.49h6.7a.75.75 0 0 0-.1-1.5M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $77e1bce0ac0f7fe7$export$24a9f54ea72a1266 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd24Regular', "24", [
    "M17.75 3A3.25 3.25 0 0 1 21 6.07v5.95q-.7-.45-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.2 2.2 0 0 0-1.59-.2 3.3 3.3 0 0 1 2.85-2.05L6.25 3zm-6.44 16.5q.27.8.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.3 2.3 0 0 0 1.5 0v8.38c0 .92.7 1.67 1.6 1.74l.15.01zm.42-5q.43-.83 1.08-1.5H8.75l-.1.01a.75.75 0 0 0 .1 1.5zm3.52-5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $77e1bce0ac0f7fe7$export$e299b7eb5c7cb1b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd28Filled', "28", [
    "M3.17 6.06A2.76 2.76 0 0 1 6.5 8.75 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.5 7.5 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.5 7.5 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06M9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $77e1bce0ac0f7fe7$export$379be5864c6bdc5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a8 8 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a3 3 0 0 1-1.5 0m22-4.15v7.25a8 8 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.7 2.7 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25M9.75 15h5.65q-.72.67-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21z"
]);
const $77e1bce0ac0f7fe7$export$57c1d4cd082afdfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.9 12.9 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6zM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
]);
const $77e1bce0ac0f7fe7$export$893c0dc6ec4f8477 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8q-1.17-.75-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22m15.3 29q.5 1.33 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a4 4 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75zm.94-11q.79-1.36 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5zM7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12m9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
]);
const $77e1bce0ac0f7fe7$export$c024757c5230182c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert16Filled', "16", [
    "M1.63 2.29A1.76 1.76 0 0 1 3.75 4 1.75 1.75 0 0 1 1.5 5.68V8c0 1.1.9 2 2 2h1.52c.26-2.8 2.61-5 5.48-5V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29M4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 7a.5.5 0 0 1 0-1H6a.5.5 0 0 1 0 1zM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M12.5 9a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36zm-3.41 4a1.5 1.5 0 0 0 2.82 0z"
]);
const $77e1bce0ac0f7fe7$export$939b1435b5a46d05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert16Regular', "16", [
    "M2 2.25q-.2 0-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2q-.52 0-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4q-.32-.15-.7-.15M5.2 9H3.5a1 1 0 0 1-1-1V5.68a2 2 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52q.05-.52.19-1M4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1zM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M12.5 9a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36zm-3.41 4a1.5 1.5 0 0 0 2.82 0z"
]);
const $77e1bce0ac0f7fe7$export$4f6dfa4cafa2d708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M16.5 13a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36zm-3.41 4a1.5 1.5 0 0 0 2.82 0z"
]);
const $77e1bce0ac0f7fe7$export$702842529f3e13b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert20Regular', "20", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M16.5 13a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36zm-3.41 4a1.5 1.5 0 0 0 2.82 0z"
]);
const $77e1bce0ac0f7fe7$export$d9aea319a24d5973 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-9A3.25 3.25 0 0 1 21 6.07v5.95a6.5 6.5 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.5 6.5 0 0 0 .3 6.5H6.24a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.3 3.3 0 0 1 6.05 3l.2-.01zm.75 17h-2v.12a1 1 0 0 0 2-.12m-1-6h-.16c-.94.1-1.67.77-1.81 1.64l-.02.16v1.5l-.86.85a.5.5 0 0 0 .26.84L15 19h5a.5.5 0 0 0 .41-.79l-.06-.06-.85-.85v-1.5a2 2 0 0 0-2-1.8m-2.25-4.5h-6.6a.75.75 0 0 0 0 1.49h6.7a.75.75 0 0 0-.1-1.5M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$e6e42f6c7dc663e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-13-2.63v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06q.27.8.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.3 2.3 0 0 0 1.5 0M18.5 20h-2v.12a1 1 0 0 0 2-.12m-1-6h-.16c-.94.1-1.67.77-1.81 1.64l-.02.16v1.5l-.86.85a.5.5 0 0 0 .26.84L15 19h5a.5.5 0 0 0 .41-.79l-.06-.06-.85-.85v-1.5a2 2 0 0 0-2-1.8m-4.7-1q-.63.68-1.07 1.5H8.75a.75.75 0 0 1-.1-1.49h4.16m4.95-10A3.25 3.25 0 0 1 21 6.07v5.95q-.7-.45-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.2 2.2 0 0 0-1.59-.2 3.3 3.3 0 0 1 2.85-2.05L6.25 3zm-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$c31d7cbc8376a800 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17m.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.5 7.5 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.5 7.5 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06M9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M20.5 16a2.5 2.5 0 0 0-2.5 2.5v2.8l-.85.85a.5.5 0 0 0 .35.85h6a.5.5 0 0 0 .35-.85l-.85-.86V18.5a2.5 2.5 0 0 0-2.5-2.5m-1.41 8a1.5 1.5 0 0 0 2.82 0z"
]);
const $77e1bce0ac0f7fe7$export$5c30bbe81d47e221 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a8 8 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a3 3 0 0 1-1.5 0m22-4.15v7.25a8 8 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.7 2.7 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25M9.75 15h5.65q-.72.67-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M20.5 16a2.5 2.5 0 0 0-2.5 2.5v2.8l-.85.85a.5.5 0 0 0 .35.85h6a.5.5 0 0 0 .35-.85l-.85-.86V18.5a2.5 2.5 0 0 0-2.5-2.5m-1.41 8a1.5 1.5 0 0 0 2.82 0z"
]);
const $77e1bce0ac0f7fe7$export$f135093870bd201e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.9 12.9 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6zM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-11-7a5 5 0 0 0-5 5v3.38l-.95 1.9a.5.5 0 0 0 .45.72h11a.5.5 0 0 0 .45-.72l-.95-1.9V33a5 5 0 0 0-5-5m-2 12a2 2 0 1 0 4 0z"
]);
const $77e1bce0ac0f7fe7$export$94703628afc41381 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8q-1.17-.75-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22m15.3 29q.5 1.33 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a4 4 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75zm.94-11q.79-1.36 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5zM7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12m9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-11-7a5 5 0 0 0-5 5v3.38l-.95 1.9a.5.5 0 0 0 .45.72h11a.5.5 0 0 0 .45-.72l-.95-1.9V33a5 5 0 0 0-5-5m-2 12a2 2 0 1 0 4 0z"
]);
const $77e1bce0ac0f7fe7$export$e56dfc0f1a998a4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft16Filled', "16", [
    "M2 2.25q-.2 0-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2a5.5 5.5 0 0 0-5.48 5H3.5a2 2 0 0 1-2-2V5.68A1.75 1.75 0 1 0 2 2.25M4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 6.5c0 .28.22.5.5.5H6a.5.5 0 0 0 0-1H4.5a.5.5 0 0 0-.5.5M2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m13 5.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L9.71 11h2.79a.5.5 0 0 0 0-1H9.7l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$63ce371805d4be56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft16Regular', "16", [
    "M2 2.25q-.2 0-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2q-.52 0-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4q-.32-.15-.7-.15M5.2 9H3.5a1 1 0 0 1-1-1V5.68a2 2 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52q.05-.52.19-1m-.7-5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1zM2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m13 5.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L9.71 11h2.79a.5.5 0 0 0 0-1H9.7l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$b50af028b4af267e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$1a6e5b427f3ac52e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft20Regular', "20", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$502fca0a9458544e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-9A3.25 3.25 0 0 1 21 6.07v5.95a6.5 6.5 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.5 6.5 0 0 0 .3 6.5H6.24a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.3 3.3 0 0 1 6.05 3l.2-.01zm-1.03 11.59-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .77-.63l-.06-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06m-1.47-5.1h-6.5l-.1.01a.75.75 0 0 0 0 1.49h6.7a.75.75 0 0 0-.1-1.5M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$f0ee41e3b354b653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-13-2.63v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06q.27.8.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.3 2.3 0 0 0 1.5 0m12.22 5.22-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .77-.63l-.06-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06M12.8 13q-.65.68-1.08 1.5H8.75a.75.75 0 0 1-.1-1.49h4.16m4.94-10A3.25 3.25 0 0 1 21 6.07v5.95q-.7-.45-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.2 2.2 0 0 0-1.59-.2 3.3 3.3 0 0 1 2.85-2.05L6.25 3zm-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$a6f3b51676874ba8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17m.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.5 7.5 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.5 7.5 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06M9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2.5.5a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35q0 .2.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 21z"
]);
const $77e1bce0ac0f7fe7$export$25f2eab997fa03a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a8 8 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a3 3 0 0 1-1.5 0m22-4.15v7.25a8 8 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.7 2.7 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25M9.75 15h5.65q-.72.67-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2.5.5a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35q0 .2.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 21z"
]);
const $77e1bce0ac0f7fe7$export$c2f47d6e02002fca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.9 12.9 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6zM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-12.3-5.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.4-1.4L30.42 36H42a1 1 0 1 0 0-2H30.41l3.3-3.3a1 1 0 0 0 0-1.4"
]);
const $77e1bce0ac0f7fe7$export$f8e54cdfcb4d27e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8q-1.17-.75-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22m15.3 29q.5 1.33 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a4 4 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75zm.94-11q.79-1.36 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5zM7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12m9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-12.3-5.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.4-1.4L30.42 36H42a1 1 0 1 0 0-2H30.41l3.3-3.3a1 1 0 0 0 0-1.4"
]);
const $77e1bce0ac0f7fe7$export$a89e3194952e9202 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight16Filled', "16", [
    "M10.5 6a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m.35 2.15a.5.5 0 1 0-.7.7L11.29 10H8.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM8.5 1a2 2 0 0 1 2 2v2a5.5 5.5 0 0 0-5.48 5H3.5a2 2 0 0 1-2-2V5.68a1.75 1.75 0 1 0 .13-3.4A2 2 0 0 1 3.5 1zm-4 5a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1zm0-2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM2 3.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$c2fd8b007f7645af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight16Regular', "16", [
    "M10.5 6a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m.35 2.15a.5.5 0 1 0-.7.7L11.29 10H8.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM2.5 8a1 1 0 0 0 1 1h1.7q-.13.48-.18 1H3.5a2 2 0 0 1-2-2V5.68a2 2 0 0 0 1 0zM6 6a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1 0-1zm2.5-5a2 2 0 0 1 2 2v2q-.52 0-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4 1.7 1.7 0 0 0-1.07-.11A2 2 0 0 1 3.5 1zm-1 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM2 3.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$cd6b38cb4c3ffb8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0-7A2.5 2.5 0 0 1 17 5.5v4.1a5.5 5.5 0 0 0-6.74 1.4H7.5a.5.5 0 0 0 0 1h2.1a5.5 5.5 0 0 0 0 5H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 1 0 .2-3.92A2.5 2.5 0 0 1 5.5 3zm.35 9.15a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM7.5 8a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm-4-2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $77e1bce0ac0f7fe7$export$45c3cf5032d16ad4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M4 14.5c0 .83.67 1.5 1.5 1.5h3.7q.15.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0zm10.85-2.35a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM10.25 11q-.38.46-.65 1H7.5a.5.5 0 0 1 0-1zm4.25-8A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.25-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-1.06-.13A2.5 2.5 0 0 1 5.5 3zm-2 5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm-9-2.5a1 1 0 0 1 1 1 1 1 0 1 1-1-1"
]);
const $77e1bce0ac0f7fe7$export$fd2db670480c7809 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-9C19.55 3 21 4.46 21 6.25v5.77a6.5 6.5 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.5 6.5 0 0 0 .3 6.5H6.24A3.25 3.25 0 0 1 3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.25 3zm.6 11.65a.5.5 0 1 0-.7.7L19.29 17H14.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7zM8.65 9.5a.75.75 0 0 0 0 1.49h6.7a.75.75 0 0 0-.1-1.5h-6.5zM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$afdaa3f5750fc738 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-13 5.75c0 .92.7 1.67 1.6 1.74l.15.01h5.06q.27.8.71 1.5H6.25A3.25 3.25 0 0 1 3 17.93V9.37a2.3 2.3 0 0 0 1.5 0zm13.85-3.1a.5.5 0 1 0-.7.7L19.29 17H14.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7zM12.81 13q-.65.67-1.08 1.5H8.75a.75.75 0 0 1-.1-1.49h4.16m4.94-10A3.25 3.25 0 0 1 21 6.07v5.95q-.7-.45-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.45.76a2.2 2.2 0 0 0-1.58-.2A3.3 3.3 0 0 1 6.07 3h11.68m-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$9e26b87ccb8f4fe4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight28Filled', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m.25-11C23.1 3 25 4.9 25 7.25v7.25a7.5 7.5 0 0 0-9.6.5H9.75a.75.75 0 0 0 0 1.5h4.4a7.5 7.5 0 0 0 .35 8.5H7.25A4.25 4.25 0 0 1 3 20.75V11.4a2.75 2.75 0 1 0 .17-5.34A4.25 4.25 0 0 1 7.25 3zm1.1 14.15a.5.5 0 1 0-.7.7L23.29 20H16.5a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 1 0 .7.7l3-3a.5.5 0 0 0 0-.7zM9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm-6-4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$5d153fda2f998178 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowRight28Regular', "28", [
    "M20.5 14a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13m-16 6.75a2.75 2.75 0 0 0 2.75 2.75h6.38q.35.81.87 1.5H7.25A4.25 4.25 0 0 1 3 20.75V11.4a3 3 0 0 0 1.5 0zm17.35-3.6a.5.5 0 1 0-.7.7L23.29 20H16.5a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 1 0 .7.7l3-3a.5.5 0 0 0 0-.7zM15.4 15q-.72.67-1.24 1.5H9.75a.75.75 0 0 1 0-1.5zm5.35-12C23.1 3 25 4.9 25 7.25v7.25a8 8 0 0 0-1.5-.87V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.69-2.53 1.67a2.7 2.7 0 0 0-1.55-.1A4.25 4.25 0 0 1 7.25 3zm-2.5 8a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zM3.75 7A1.74 1.74 0 0 1 5.5 8.75 1.75 1.75 0 1 1 3.75 7"
]);
const $77e1bce0ac0f7fe7$export$ad92a4bb1b35d726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss16Filled', "16", [
    "M1.63 2.29A1.76 1.76 0 0 1 3.75 4 1.75 1.75 0 0 1 1.5 5.68V8c0 1.1.9 2 2 2h1.52c.26-2.8 2.61-5 5.48-5V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29M4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 7a.5.5 0 0 1 0-1H6a.5.5 0 0 1 0 1zM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7L10.5 9.79 9.35 8.65a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $77e1bce0ac0f7fe7$export$5f93b17c8e6790a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss16Regular', "16", [
    "M2 2.25q-.2 0-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2q-.52 0-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4q-.32-.15-.7-.15M5.2 9H3.5a1 1 0 0 1-1-1V5.68a2 2 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52q.05-.52.19-1M4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1zM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7L10.5 9.79 9.35 8.65a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $77e1bce0ac0f7fe7$export$67c874acb6d7c193 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.5 5.5 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.5 5.5 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3zM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1m15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $77e1bce0ac0f7fe7$export$fb93dc783725c5a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss20Regular', "20", [
    "M3.5 4.5q-.15 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.24-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15M9.2 16q.16.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5zm.4-4q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1m4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $77e1bce0ac0f7fe7$export$5e5114a0730a64a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-9A3.25 3.25 0 0 1 21 6.07v5.95a6.5 6.5 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.5 6.5 0 0 0 .3 6.5H6.24a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.3 3.3 0 0 1 6.05 3l.2-.01zm-2.66 11.97-.07.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05zm.16-5.47h-6.6a.75.75 0 0 0 0 1.49h6.7a.75.75 0 0 0-.1-1.5M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$35e5af0ff761c73d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-13-2.63v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06q.27.8.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.3 2.3 0 0 0 1.5 0m10.6 5.6-.08.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05zM12.8 13q-.63.68-1.07 1.5H8.75a.75.75 0 0 1-.1-1.49h4.16m4.95-10A3.25 3.25 0 0 1 21 6.07v5.95q-.7-.45-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.2 2.2 0 0 0-1.59-.2 3.3 3.3 0 0 1 2.85-2.05L6.25 3zm-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6M3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$11c36fa44f28863f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17m.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.5 7.5 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.5 7.5 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06M9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64z"
]);
const $77e1bce0ac0f7fe7$export$d531b2bc4fc8e006 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a8 8 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a3 3 0 0 1-1.5 0m22-4.15v7.25a8 8 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.7 2.7 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25M9.75 15h5.65q-.72.67-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64z"
]);
const $77e1bce0ac0f7fe7$export$b9eccea65312cb21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.9 12.9 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6zM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35z"
]);
const $77e1bce0ac0f7fe7$export$53f0a00506aeaf2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8q-1.17-.75-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22m15.3 29q.5 1.33 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a4 4 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75zm.94-11q.79-1.36 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5zM7.5 12A2.5 2.5 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12m9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35z"
]);
const $77e1bce0ac0f7fe7$export$84148c1c62fd5fa9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare12Filled', "12", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h3.09a1.5 1.5 0 1 0 0-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm6 10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5.91a1.5 1.5 0 1 0 0 1H9a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1H4c0 1.1.9 2 2 2z"
]);
const $77e1bce0ac0f7fe7$export$256296b50a7ab9ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare12Regular', "12", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h3.09a1.5 1.5 0 1 0 0-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2zm5 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9 11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5.91a1.5 1.5 0 1 0 0 1H9a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1H4c0 1.1.9 2 2 2zM4.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$3d7420d90aa58542 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare16Filled', "16", [
    "M1 3.5A2.5 2.5 0 0 1 3.5 1h4A2.5 2.5 0 0 1 10 3.5V4H9v-.5C9 2.67 8.33 2 7.5 2h-4C2.67 2 2 2.67 2 3.5v4C2 8.33 2.67 9 3.5 9h5.59a1.5 1.5 0 1 1 0 1H3.5A2.5 2.5 0 0 1 1 7.5zM6 11v.5A2.5 2.5 0 0 0 8.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 5H6.91a1.5 1.5 0 1 0 0 1h5.59c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 11.5V11z"
]);
const $77e1bce0ac0f7fe7$export$7514e12fb4bbb007 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare16Regular', "16", [
    "M1 3.5A2.5 2.5 0 0 1 3.5 1h4A2.5 2.5 0 0 1 10 3.5V4H9v-.5C9 2.67 8.33 2 7.5 2h-4C2.67 2 2 2.67 2 3.5v4C2 8.33 2.67 9 3.5 9h5.59a1.5 1.5 0 1 1 0 1H3.5A2.5 2.5 0 0 1 1 7.5zm9 6a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M6 11v.5A2.5 2.5 0 0 0 8.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 5H6.91a1.5 1.5 0 1 0 0 1h5.59c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 11.5V11zm-.5-6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
]);
const $77e1bce0ac0f7fe7$export$a823618a44e808c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare20Filled', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5zM7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$193a77fc602f4731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare20Regular', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5zm8 6.75a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5m.25-7.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$f52e544f19eb0dc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h6c1.8 0 3.25 1.46 3.25 3.25a.75.75 0 0 1-1.5 0c0-.97-.78-1.75-1.75-1.75h-6c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h5.85a2.75 2.75 0 1 1 0 1.5H6.25A3.25 3.25 0 0 1 3 12.25zM17.75 10c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-6c-.97 0-1.75-.78-1.75-1.75a.75.75 0 0 0-1.5 0c0 1.8 1.46 3.25 3.25 3.25h6c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25H11.9a2.75 2.75 0 1 0 0 1.5z"
]);
const $77e1bce0ac0f7fe7$export$751cff4fccabcd0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h6c1.8 0 3.25 1.46 3.25 3.25a.75.75 0 0 1-1.5 0c0-.97-.78-1.75-1.75-1.75h-6c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h5.85a2.75 2.75 0 1 1 0 1.5H6.25A3.25 3.25 0 0 1 3 12.25zm10.5 8.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M17.75 10c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-6c-.97 0-1.75-.78-1.75-1.75a.75.75 0 0 0-1.5 0c0 1.8 1.46 3.25 3.25 3.25h6c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25H11.9a2.75 2.75 0 1 0 0 1.5zm-8.5-2a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$89254b03360c2ecf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v7.5A3.75 3.75 0 0 0 6.75 18h7.42a3 3 0 1 0-.13-1.5H6.75c-1.24 0-2.25-1-2.25-2.25v-7.5c0-1.24 1-2.25 2.25-2.25h7.5c1.24 0 2.25 1 2.25 2.25v.5a.75.75 0 0 0 1.5 0v-.5A3.75 3.75 0 0 0 14.25 3zm7.08 7a3 3 0 1 0 .13 1.5h7.29c1.24 0 2.25 1 2.25 2.25v7.5c0 1.24-1 2.25-2.25 2.25h-7.5c-1.24 0-2.25-1-2.25-2.25v-.5a.75.75 0 0 0-1.5 0v.5A3.75 3.75 0 0 0 13.75 25h7.5A3.75 3.75 0 0 0 25 21.25v-7.5A3.75 3.75 0 0 0 21.25 10z"
]);
const $77e1bce0ac0f7fe7$export$a6c9ce4a6275b44d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v7.5A3.75 3.75 0 0 0 6.75 18h7.42a3 3 0 1 0-.13-1.5H6.75c-1.24 0-2.25-1-2.25-2.25v-7.5c0-1.24 1-2.25 2.25-2.25h7.5c1.24 0 2.25 1 2.25 2.25v.5a.75.75 0 0 0 1.5 0v-.5A3.75 3.75 0 0 0 14.25 3zM17 15.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-3.04-4h7.29c1.24 0 2.25 1 2.25 2.25v7.5c0 1.24-1 2.25-2.25 2.25h-7.5c-1.24 0-2.25-1-2.25-2.25v-.5a.75.75 0 0 0-1.5 0v.5A3.75 3.75 0 0 0 13.75 25h7.5A3.75 3.75 0 0 0 25 21.25v-7.5A3.75 3.75 0 0 0 21.25 10h-7.42a3 3 0 1 0 .13 1.5M9.5 11a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
]);
const $77e1bce0ac0f7fe7$export$437e1d23384d0772 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare48Filled', "48", [
    "M12.48 6A6.5 6.5 0 0 0 6 12.48v12.04C6 28.1 8.9 31 12.48 31H24.2a5.5 5.5 0 1 0-.12-2.5H12.48a4 4 0 0 1-3.98-3.98V12.49c0-2.2 1.78-3.98 3.97-3.98h12.05c2.2 0 3.98 1.78 3.98 3.97v.28a1.25 1.25 0 1 0 2.5 0v-.28C31 8.9 28.1 6 24.52 6zM17 35.75v-.5a1.25 1.25 0 1 1 2.5 0v.5a3.75 3.75 0 0 0 3.75 3.75h12.5a3.75 3.75 0 0 0 3.75-3.75v-12.5a3.75 3.75 0 0 0-3.75-3.75H23.91a5.5 5.5 0 1 1-.12-2.5h11.96C39.2 17 42 19.8 42 23.25v12.5C42 39.2 39.2 42 35.75 42h-12.5A6.25 6.25 0 0 1 17 35.75"
]);
const $77e1bce0ac0f7fe7$export$c55281a869842e39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare48Regular', "48", [
    "M12.48 6h12.04C28.1 6 31 8.9 31 12.48v.27a1.25 1.25 0 1 1-2.5 0v-.28c0-2.19-1.78-3.97-3.98-3.97H12.49a4 4 0 0 0-3.98 3.97v12.05c0 2.2 1.78 3.98 3.97 3.98H24.1a5.5 5.5 0 1 1 .12 2.5H12.47A6.5 6.5 0 0 1 6 24.52V12.49C6 8.9 8.9 6 12.48 6M26.5 29.5a3 3 0 1 0 6 0 3 3 0 0 0-6 0M17 35.75v-.5a1.25 1.25 0 1 1 2.5 0v.5a3.75 3.75 0 0 0 3.75 3.75h12.5a3.75 3.75 0 0 0 3.75-3.75v-12.5a3.75 3.75 0 0 0-3.75-3.75H23.91a5.5 5.5 0 1 1-.12-2.5h11.96C39.2 17 42 19.8 42 23.25v12.5C42 39.2 39.2 42 35.75 42h-12.5A6.25 6.25 0 0 1 17 35.75m1.5-20.25a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
]);
const $77e1bce0ac0f7fe7$export$d1270654f242439f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract16Filled', "16", [
    "M2 2.25q-.2 0-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2a5.5 5.5 0 0 0-5.48 5H3.5a2 2 0 0 1-2-2V5.68A1.75 1.75 0 1 0 2 2.25M4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 6.5c0 .28.22.5.5.5H6a.5.5 0 0 0 0-1H4.5a.5.5 0 0 0-.5.5M2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10.5 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$b703c742c6b48b88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract16Regular', "16", [
    "M1.63 2.29a1.8 1.8 0 0 1 1.07.1A1 1 0 0 1 3.5 2h5a1 1 0 0 1 1 1v2.1q.48-.1 1-.1V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29M5.03 10q.04-.52.18-1H3.5a1 1 0 0 1-1-1V5.68a2 2 0 0 1-1 0V8c0 1.1.9 2 2 2zM4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 6.5c0-.28.22-.5.5-.5H6a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5M2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10.5 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$abf099ffac0be0e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract20Filled', "20", [
    "M3.2 4.52A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1a5.5 5.5 0 0 0-6.74 1.4H7.5a.5.5 0 0 0 0 1h2.1a5.5 5.5 0 0 0 0 5H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 1 0 .2-3.92M7.5 8a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM3 5.63a1 1 0 1 1 1 1.73 1 1 0 0 1-1-1.73M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$bd7e700490fb9046 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract20Regular', "20", [
    "M3.2 4.52a2 2 0 0 1 1.06.13C4.53 4.25 5 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v3.7q.52.16 1 .4V5.5A2.5 2.5 0 0 0 14.5 3h-9a2.5 2.5 0 0 0-2.3 1.52M9.6 17q-.24-.48-.4-1H5.5A1.5 1.5 0 0 1 4 14.5V8.44a2 2 0 0 1-1 0v6.06A2.5 2.5 0 0 0 5.5 17zm0-5q.27-.54.66-1H7.5a.5.5 0 0 0 0 1zM3 5.63a1 1 0 0 1 1 0 1 1 0 1 1-1 0M7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$258fc83e0d952b93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract24Filled', "24", [
    "M21 6.25C21 4.45 19.55 3 17.75 3H6.25c-1.38 0-2.55.85-3.03 2.06A2.26 2.26 0 1 1 3 9.37v8.38C3 19.55 4.46 21 6.25 21h5.77a6.5 6.5 0 0 1-.29-6.5H8.65a.75.75 0 0 1 0-1.49h4.16a6.5 6.5 0 0 1 8.19-.99zM8.75 9.5h6.5a.75.75 0 0 1 .1 1.49h-6.7a.75.75 0 0 1 0-1.49zM5 7.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1z"
]);
const $77e1bce0ac0f7fe7$export$6028bf9755b3ef92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract24Regular', "24", [
    "M21 6.07A3.25 3.25 0 0 0 17.75 3H6.07c-1.3.08-2.4.9-2.85 2.06a2.3 2.3 0 0 1 1.59.2c.31-.46.84-.76 1.44-.76h11.64c.9.08 1.61.83 1.61 1.75v5.06q.8.27 1.5.71V6.07M12.02 21q-.45-.7-.7-1.5H6.1c-.9-.08-1.61-.83-1.61-1.75V9.37a2.3 2.3 0 0 1-1.5 0v8.56A3.25 3.25 0 0 0 6.26 21zm-.29-6.5q.43-.83 1.08-1.5H8.75l-.1.01a.75.75 0 0 0 .1 1.5zM16 10.25a.75.75 0 0 0-.75-.75h-6.6a.75.75 0 0 0 .1 1.5h6.5l.1-.01a.75.75 0 0 0 .65-.74m-11-3a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1z"
]);
const $77e1bce0ac0f7fe7$export$ce5081758e0547f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract28Filled', "28", [
    "M3.17 6.06A2.76 2.76 0 0 1 6.5 8.75 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.5 7.5 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.5 7.5 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06M9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2 0a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5"
]);
const $77e1bce0ac0f7fe7$export$f4a5de840b9ba748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a8 8 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a3 3 0 0 1-1.5 0m22-4.15v7.25a8 8 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.7 2.7 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25M9.75 15h5.65q-.72.67-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0m-2 0a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5"
]);
const $77e1bce0ac0f7fe7$export$2e545ec56c2ab699 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract48Filled', "48", [
    "M6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4m.19-1.78A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.9 12.9 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6h-23.5c-2.92 0-5.38 2-6.06 4.72M16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25M46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-3 0a1 1 0 0 0-1-1H28a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1"
]);
const $77e1bce0ac0f7fe7$export$839094f48451d017 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract48Regular', "48", [
    "M6.19 10.72A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8q-1.17-.75-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-2.63 0M22.8 39.5q.5 1.33 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a4 4 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75zm.94-11q.79-1.36 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5zM6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4M17.25 19a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5zM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0m-3 0a1 1 0 0 0-1-1H28a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1"
]);
const $77e1bce0ac0f7fe7$export$7f2d9d7735b9fdfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__a)",
            "d": "M5.46 2.1c.29-.06.54.18.54.47V7a1 1 0 0 0 1 1h4.43c.3 0 .53.25.47.54A5.5 5.5 0 1 1 5.46 2.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__b)",
            "fillOpacity": ".4",
            "d": "M5.46 2.1c.29-.06.54.18.54.47V7a1 1 0 0 0 1 1h4.43c.3 0 .53.25.47.54A5.5 5.5 0 1 1 5.46 2.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__c)",
            "fillOpacity": ".4",
            "d": "M5.46 2.1c.29-.06.54.18.54.47V7a1 1 0 0 0 1 1h4.43c.3 0 .53.25.47.54A5.5 5.5 0 1 1 5.46 2.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__d)",
            "d": "M13 6.57C13 3.49 10.5 1 7.43 1c-.24 0-.43.2-.43.45V6.5c0 .28.22.5.5.5h5.06c.24 0 .44-.19.44-.43"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__e)",
            "d": "M13 7a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__f)",
            "d": "M10 9a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_16_color__g)",
            "d": "M7 11a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__a",
                "x1": "11.99",
                "x2": "-1.28",
                "y1": "14.76",
                "y2": "1.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6d37cd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__d",
                "x1": "13.25",
                "x2": "12.98",
                "y1": "5.15",
                "y2": ".03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e23cb4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__e",
                "x1": "14.74",
                "x2": "20.32",
                "y1": "3.24",
                "y2": "5.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__f",
                "x1": "10.5",
                "x2": "14.47",
                "y1": "8.5",
                "y2": "10.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__g",
                "x1": "7.5",
                "x2": "10.01",
                "y1": "10",
                "y2": "11.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.74881 -2.71092 0 8.34 13)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.74881 -2.4384 0 11.1 11.63)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$ef9cb9dbf7650778 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple16Filled', "16", [
    "M12 7a2 2 0 0 1 .87-1.65A5.6 5.6 0 0 0 7.43 1c-.24 0-.43.2-.43.45V6.5c0 .28.22.5.5.5zM1 7.5a5.5 5.5 0 0 0 5 5.48V11a2 2 0 0 1 3-1.73V9q0-.54.27-1H7a1 1 0 0 1-1-1V2.57c0-.3-.25-.53-.54-.47A5.5 5.5 0 0 0 1 7.5M14 6a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1m-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $77e1bce0ac0f7fe7$export$73986e32ab5a0a62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple16Regular', "16", [
    "M12 7a2 2 0 0 1 .87-1.65A5.6 5.6 0 0 0 7.43 1c-.24 0-.43.2-.43.45V6.5c0 .28.22.5.5.5zM8 2.04c2.07.25 3.7 1.9 3.96 3.96H8zM1 7.5a5.5 5.5 0 0 0 5 5.48v-1a4.5 4.5 0 0 1-1-8.72V7c0 1.1.9 2 2 2h2q0-.54.27-1H7a1 1 0 0 1-1-1V2.57c0-.3-.25-.53-.54-.47A5.5 5.5 0 0 0 1 7.5M14 6a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1m-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1m-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $77e1bce0ac0f7fe7$export$77e144a2314164a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__a)",
            "d": "M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__b)",
            "fillOpacity": ".4",
            "d": "M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__c)",
            "fillOpacity": ".4",
            "d": "M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__d)",
            "d": "M16.52 9c.26 0 .48-.2.48-.46V8.5A6.5 6.5 0 0 0 10.46 2a.47.47 0 0 0-.46.48V8.5c0 .28.22.5.5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__e)",
            "d": "M16 11a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__f)",
            "d": "M13 13a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_20_color__g)",
            "d": "M10 15a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__a",
                "x1": "15.07",
                "x2": ".5",
                "y1": "17.93",
                "y2": "3.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6d37cd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__d",
                "x1": "17.29",
                "x2": "16.98",
                "y1": "6.84",
                "y2": ".87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e23cb4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__e",
                "x1": "17.74",
                "x2": "23.32",
                "y1": "7.24",
                "y2": "9.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__f",
                "x1": "13.5",
                "x2": "17.47",
                "y1": "12.5",
                "y2": "14.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__g",
                "x1": "10.5",
                "x2": "13.01",
                "y1": "14",
                "y2": "15.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -2.95312 0 11 16)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3 -2.65625 0 14 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$6d0a49d79f39b7ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple20Filled', "20", [
    "M17 8.54c0 .26-.22.46-.48.46H10.5a.5.5 0 0 1-.5-.5V2.48c0-.26.2-.48.46-.48h.04A6.5 6.5 0 0 1 17 8.5zM9 4.5c0-.28-.22-.5-.5-.48A6 6 0 0 0 9 16v-1a2 2 0 0 1 3-1.73V13c0-1.1.9-2 2-2h.92l.06-.5a.47.47 0 0 0-.48-.5H10a1 1 0 0 1-1-1zm8 5.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $77e1bce0ac0f7fe7$export$3d4256e85f34db36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple20Regular', "20", [
    "M16.52 9c.26 0 .48-.2.48-.46V8.5A6.5 6.5 0 0 0 10.5 2h-.04a.47.47 0 0 0-.46.48V8.5c0 .28.22.5.5.5zM11 3.02A5.5 5.5 0 0 1 15.98 8H11zM8 9V5.1A5 5 0 0 0 9 15v1a6 6 0 0 1-.5-11.98c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5l-.06.5H10a2 2 0 0 1-2-2m9 1a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1m-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z"
]);
const $77e1bce0ac0f7fe7$export$a1c25be48e3b655e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__a)",
            "fillRule": "evenodd",
            "d": "M10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5A7.5 7.5 0 1 1 10 4.02",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__b)",
            "fillOpacity": ".4",
            "fillRule": "evenodd",
            "d": "M10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5A7.5 7.5 0 1 1 10 4.02",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__c)",
            "fillOpacity": ".4",
            "fillRule": "evenodd",
            "d": "M10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5A7.5 7.5 0 1 1 10 4.02",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__d)",
            "fillRule": "evenodd",
            "d": "M20 9.4v.14c0 .26-.22.46-.48.46H12.5a.5.5 0 0 1-.5-.5V2.49c0-.27.2-.49.46-.49h.11C16.67 2 20 5.31 20 9.4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__e)",
            "d": "M21.5 12c-.83 0-1.5.67-1.5 1.5v8a1.5 1.5 0 0 0 3 0v-8c0-.83-.67-1.5-1.5-1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__f)",
            "d": "M16 16.5a1.5 1.5 0 0 1 3 0v5a1.5 1.5 0 0 1-3 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_24_color__g)",
            "d": "M13.5 18c-.83 0-1.5.67-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2c0-.83-.67-1.5-1.5-1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__a",
                "x1": "18.09",
                "x2": "-.13",
                "y1": "21.42",
                "y2": "3.37",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6d37cd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__d",
                "x1": "20.33",
                "x2": "19.97",
                "y1": "7.53",
                "y2": ".71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e23cb4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__e",
                "x1": "22.61",
                "x2": "30.4",
                "y1": "8.62",
                "y2": "12.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__f",
                "x1": "16.75",
                "x2": "21.91",
                "y1": "15.57",
                "y2": "19.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__g",
                "x1": "12.75",
                "x2": "15.36",
                "y1": "18",
                "y2": "20.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.86087 -3.80424 0 13.3 19)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 3.86087 -3.4218 0 17.17 17.07)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$9b5d995699c7f958 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple24Filled', "24", [
    "M20 9.46V9.4A7.43 7.43 0 0 0 12.46 2a.5.5 0 0 0-.46.49V9.5c0 .28.22.5.5.5h7.02c.26 0 .48-.2.48-.46zM10.5 4.5c0-.28-.22-.5-.5-.48a7.5 7.5 0 1 0 1.05 14.96A2.5 2.5 0 0 1 15 17.5v-1a2.5 2.5 0 0 1 2.57-2.5q.35-.95.41-2a.5.5 0 0 0-.48-.5h-6a1 1 0 0 1-1-1zm9.5 9a1.5 1.5 0 0 1 3 0v8a1.5 1.5 0 0 1-3 0zM17.5 15c-.83 0-1.5.67-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5c0-.83-.67-1.5-1.5-1.5m-4 3c-.83 0-1.5.67-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2c0-.83-.67-1.5-1.5-1.5"
]);
const $77e1bce0ac0f7fe7$export$332a846cb30e3ddb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple24Regular', "24", [
    "M20 9.54V9.4A7.43 7.43 0 0 0 12.46 2a.5.5 0 0 0-.46.49V9.5c0 .28.22.5.5.5h7.02c.26 0 .48-.2.48-.46m-6.5-5.97c2.53.4 4.53 2.4 4.93 4.93H13.5zM9 10.5V5.69a6 6 0 1 0 3.01 11.62c-.57.38-.97.98-1.11 1.68l-.4.01A7.5 7.5 0 0 1 10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5a8 8 0 0 1-.36 1.85h-.12c-.74 0-1.4.3-1.88.79q.46-.76.7-1.64H11.5A2.5 2.5 0 0 1 9 10.5m11 3a1.5 1.5 0 0 1 3 0v8a1.5 1.5 0 0 1-3 0zM17.5 15c-.83 0-1.5.67-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5c0-.83-.67-1.5-1.5-1.5m-4 3c-.83 0-1.5.67-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2c0-.83-.67-1.5-1.5-1.5"
]);
const $77e1bce0ac0f7fe7$export$d1df3a8f5669a973 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple28Filled', "28", [
    "M16.5 19c.83 0 1.5.67 1.5 1.5v4a1.5 1.5 0 0 1-3 0v-4c0-.83.67-1.5 1.5-1.5m4-2.5c.83 0 1.5.67 1.5 1.5v6.5a1.5 1.5 0 0 1-3 0V18c0-.83.67-1.5 1.5-1.5m4-3.5c.83 0 1.5.67 1.5 1.5v10a1.5 1.5 0 0 1-3 0v-10c0-.83.67-1.5 1.5-1.5M11.75 5.5c.69 0 1.25.56 1.25 1.25v4.5c0 1.24 1 2.25 2.25 2.25h4.5c.69 0 1.25.56 1.25 1.25v.02q-.02.4-.06.77l-.44-.04A2.5 2.5 0 0 0 18 18v.5q-.65-.48-1.5-.5a2.5 2.5 0 0 0-2.5 2.5v2.77q-.96.23-2 .23a9 9 0 0 1-.27-18zM15.5 2a9 9 0 0 1 9 9 1 1 0 0 1-1 1h-7.75c-.69 0-1.25-.56-1.25-1.25V3a1 1 0 0 1 1-1"
]);
const $77e1bce0ac0f7fe7$export$dd2027cf8cc4949 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple28Regular', "28", [
    "M16.5 19c.83 0 1.5.67 1.5 1.5v4a1.5 1.5 0 0 1-3 0v-4c0-.83.67-1.5 1.5-1.5m4-2.5c.83 0 1.5.67 1.5 1.5v6.5a1.5 1.5 0 0 1-3 0V18c0-.83.67-1.5 1.5-1.5m4-3.5c.83 0 1.5.67 1.5 1.5v10a1.5 1.5 0 0 1-3 0v-10c0-.83.67-1.5 1.5-1.5M11.75 5.5c.69 0 1.25.56 1.25 1.25v4.5c0 1.24 1 2.25 2.25 2.25h4.5c.69 0 1.25.56 1.25 1.25v.02q-.02.4-.06.77a2.5 2.5 0 0 0-1.55.22l.1-.76h-4.24a3.75 3.75 0 0 1-3.75-3.75V7.02a7.5 7.5 0 1 0 2.5 14.7v1.55q-.96.23-2 .23a9 9 0 0 1-.27-18zM15.5 2a9 9 0 0 1 9 9 1 1 0 0 1-1 1h-7.75c-.69 0-1.25-.56-1.25-1.25V3a1 1 0 0 1 1-1m.5 8.5h6.98A7.5 7.5 0 0 0 16 3.52z"
]);
const $77e1bce0ac0f7fe7$export$ea95844b7863822e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__a)",
            "d": "M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 11.57 11.57c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__b)",
            "fillOpacity": ".4",
            "d": "M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 11.57 11.57c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__c)",
            "fillOpacity": ".4",
            "d": "M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 11.57 11.57c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__d)",
            "d": "m17.5 2-.55.01a1 1 0 0 0-.95 1V12c0 1.1.9 2 2 2h8.99a1 1 0 0 0 1-.95l.01-.55C28 6.7 23.3 2 17.5 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__e)",
            "d": "M29 16a2 2 0 0 0-2 2v11a2 2 0 1 0 4 0V18a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__f)",
            "d": "M24 20a2 2 0 0 0-2 2v7a2 2 0 1 0 4 0v-7a2 2 0 0 0-2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chart_multiple_32_color__g)",
            "d": "M17 25a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__a",
                "x1": "24.1",
                "x2": "-1.37",
                "y1": "30.38",
                "y2": "5.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6d37cd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__d",
                "x1": "28.5",
                "x2": "27.96",
                "y1": "10.3",
                "y2": ".07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e23cb4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ea71ef"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__e",
                "x1": "30.47",
                "x2": "40.96",
                "y1": "11.39",
                "y2": "16.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__f",
                "x1": "23",
                "x2": "30.02",
                "y1": "20.79",
                "y2": "25.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__g",
                "x1": "18",
                "x2": "22.63",
                "y1": "22",
                "y2": "25.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 6.5 -5.34375 0 19 26)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chart_multiple_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.5 -3.79687 0 24 24.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$89feac9530134bde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple32Filled', "32", [
    "M16.95 2.01 17.5 2a10.5 10.5 0 0 1 10.49 11.05 1 1 0 0 1-1 .95H18a2 2 0 0 1-2-2V3.01a1 1 0 0 1 .95-1M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 3.13 20.75V25a3.5 3.5 0 0 1 5-3.16 3.5 3.5 0 0 1 3.3-3.34q.08-.42.14-.87c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3zM27 18a2 2 0 1 1 4 0v11a2 2 0 1 1-4 0zm-5 4a2 2 0 1 1 4 0v7a2 2 0 1 1-4 0zm-3 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2"
]);
const $77e1bce0ac0f7fe7$export$eb10fded4df69da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple32Regular', "32", [
    "M16.95 2.01 17.5 2a10.5 10.5 0 0 1 10.49 11.05 1 1 0 0 1-1 .95H18a2 2 0 0 1-2-2V3.01a1 1 0 0 1 .95-1m1.05 2V12h7.99A8.5 8.5 0 0 0 18 4.01m-4 3.53c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 3.13 20.75v-2.04A8.52 8.52 0 0 1 5 16.5a8.5 8.5 0 0 1 7-8.37V13a5 5 0 0 0 5 5h4.87q-.16.87-.48 1.67a3.5 3.5 0 0 1 2.42-1.17q.08-.42.13-.87c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3zM27 18a2 2 0 1 1 4 0v11a2 2 0 1 1-4 0zm-5 4a2 2 0 1 1 4 0v7a2 2 0 1 1-4 0zm-3 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2"
]);
const $77e1bce0ac0f7fe7$export$d8e9710c38a97c7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson20Filled', "20", [
    "M10.5 2.5a.5.5 0 1 0-1 0V3H4.75A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15h1.82l-1.49 2.23a.5.5 0 0 0 .84.55L7.77 15h3.73a2.5 2.5 0 0 1 1.77-.99A2.99 2.99 0 0 1 15.5 9a3 3 0 0 1 2.5 1.34V5.75A2.75 2.75 0 0 0 15.25 3H10.5zM5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 4.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1m0-2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1m12 3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $77e1bce0ac0f7fe7$export$4a35da29834851b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson20Regular', "20", [
    "M10 2c.28 0 .5.22.5.5V3h4.75A2.75 2.75 0 0 1 18 5.75v4.6q-.4-.6-1-.95V5.75c0-.65-.35-1.22-.88-1.52l-.02-.01a2 2 0 0 0-.85-.22H4.75C3.78 4 3 4.78 3 5.75v6.55c.03.94.8 1.7 1.75 1.7h8.51l.01.01a2.5 2.5 0 0 0-1.77.99H7.77l-1.85 2.78a.5.5 0 1 1-.84-.55L6.57 15H4.75A2.75 2.75 0 0 1 2 12.25v-6.5A2.75 2.75 0 0 1 4.75 3H9.5v-.5c0-.28.22-.5.5-.5M5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 9c0-.27.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 9m12.5 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $77e1bce0ac0f7fe7$export$b4c0c53f2763fd46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson24Filled', "24", [
    "M12.5 2.75a.75.75 0 0 0-1.5 0V3H5.25A3.25 3.25 0 0 0 2 6.25v9.5C2 17.55 3.46 19 5.25 19h2.4l-1.48 1.77a.75.75 0 0 0 1.16.96L9.6 19h3.5c.34-1.16 1.41-2 2.67-2h.28a3.49 3.49 0 0 1 2.45-6 3.5 3.5 0 0 1 3.5 3.5V6.25C22 4.45 20.54 3 18.75 3H12.5zm-6.5 5c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 6 7.75M6.75 10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5m0 3h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5M21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $77e1bce0ac0f7fe7$export$1275eec312ba6ec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson24Regular', "24", [
    "M12.5 2.75a.75.75 0 0 0-1.5 0V3H5.25A3.25 3.25 0 0 0 2 6.25v9.5C2 17.55 3.46 19 5.25 19h2.4l-1.48 1.77a.75.75 0 0 0 1.16.96L9.6 19h3.5c.19-.61.57-1.14 1.08-1.5H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v5.38A3.5 3.5 0 0 1 22 14.5V6.25C22 4.45 20.54 3 18.75 3H12.5zm-6.5 5c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 6 7.75M6.75 10a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM6 13.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m15 .75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $77e1bce0ac0f7fe7$export$58b725d8727d7a2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson28Filled', "28", [
    "M14.25 2c.41 0 .75.34.75.75V3h7.75a3 3 0 0 1 1.2.23A3.25 3.25 0 0 1 26 6.25v10.5q-.02.23-.25.25a.26.26 0 0 1-.26-.25A4 4 0 1 0 18.85 20h-.8c-1.32 0-2.44.83-2.87 2h-4.6l-3.27 3.74a.75.75 0 0 1-1.13-.98L8.6 22H5.25l-.45-.03A3.25 3.25 0 0 1 2 18.75V6.25C2 4.45 3.46 3 5.25 3h8.25v-.25c0-.41.33-.75.75-.75m-7.5 5.5a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5zM6 12.25c0 .41.33.75.75.75h10.5a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0-.75.75m0 4c0 .41.33.75.75.75h8.5a.75.75 0 1 0 0-1.5h-8.5a.75.75 0 0 0-.75.75m18.5.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $77e1bce0ac0f7fe7$export$4864674f526f42a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson28Regular', "28", [
    "M14.25 2c.41 0 .75.34.75.75V3h7.75C24.55 3 26 4.46 26 6.25v10.5q-.02.23-.25.25a.26.26 0 0 1-.26-.25 4 4 0 0 0-.99-2.4v-8.1c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v12.5c0 .97.78 1.75 1.75 1.75h11.12q-.83.55-1.19 1.5h-4.6l-3.27 3.74a.75.75 0 0 1-1.13-.99L8.59 22H5.25A3.25 3.25 0 0 1 2 18.75V6.25C2 4.45 3.46 3 5.25 3h8.25v-.25c0-.41.34-.75.75-.75m-7.5 5.5a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5zm0 4a.75.75 0 1 0 0 1.5h10.5a.75.75 0 0 0 0-1.5zm0 4a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5zM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.5 6.25c0 1.87-1.57 3.75-5.5 3.75S16 25.12 16 23.25v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04z"
]);
const $77e1bce0ac0f7fe7$export$3d8abf1091517c09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson48Filled', "48", [
    "M23.75 4c.69 0 1.25.56 1.25 1.25V6h13.75C41.65 6 44 8.35 44 11.25V29a7 7 0 1 0-11.9 5H31a5 5 0 0 0-4.58 3h-7.17l-.08.1-6 6.5a1.25 1.25 0 1 1-1.84-1.7l4.53-4.9H9.25A5.25 5.25 0 0 1 4 31.75v-20.5C4 8.35 6.35 6 9.25 6H22.5v-.75c0-.69.56-1.25 1.25-1.25m-11.5 9.5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM11 21.75c0 .69.56 1.25 1.25 1.25h14.5a1.25 1.25 0 1 0 0-2.5h-14.5c-.69 0-1.25.56-1.25 1.25m0 7c0 .69.56 1.25 1.25 1.25h11.5a1.25 1.25 0 1 0 0-2.5h-11.5c-.69 0-1.25.56-1.25 1.25M42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $77e1bce0ac0f7fe7$export$854b57f913b02b18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson48Regular', "48", [
    "M25 5.25a1.25 1.25 0 1 0-2.5 0V6H9.25A5.25 5.25 0 0 0 4 11.25v20.5C4 34.65 6.35 37 9.25 37h6.6l-4.52 4.9a1.25 1.25 0 1 0 1.84 1.7l6-6.5.08-.1h7.17a5 5 0 0 1 2.4-2.5H9.25a2.75 2.75 0 0 1-2.75-2.75v-20.5A2.75 2.75 0 0 1 9.25 8.5h29.5a2.75 2.75 0 0 1 2.75 2.75v12.39A7 7 0 0 1 44 29V11.25C44 8.35 41.65 6 38.75 6H25zM12.25 13.5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM11 21.75c0-.69.56-1.25 1.25-1.25h14.5a1.25 1.25 0 1 1 0 2.5h-14.5c-.69 0-1.25-.56-1.25-1.25m0 7c0-.69.56-1.25 1.25-1.25h11.5a1.25 1.25 0 1 1 0 2.5h-11.5c-.69 0-1.25-.56-1.25-1.25M42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0m4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
]);
const $77e1bce0ac0f7fe7$export$311f7c11f0706ece = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat12Filled', "12", [
    "M1 6a5 5 0 1 1 2.6 4.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A5 5 0 0 1 1 6m3-.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5M4.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$664889444ee4a155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat12Regular', "12", [
    "M4 5.5c0-.28.22-.5.5-.5h3a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM1 6a5 5 0 1 1 2.6 4.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A5 5 0 0 1 1 6m5-4a4 4 0 0 0-3.42 6.08q.12.2.05.4l-.38 1.26 1.26-.38a.5.5 0 0 1 .4.05Q4.84 10 6 10a4 4 0 0 0 0-8"
]);
const $77e1bce0ac0f7fe7$export$944da024ff4983c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_16_color__a)",
            "d": "M8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2q1.34.8 3 .81A6 6 0 0 0 8 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_16_color__b)",
            "d": "M6 7c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7m.5 1.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_16_color__a",
                "x1": "2.43",
                "x2": "12.9",
                "y1": "4.25",
                "y2": "22.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_16_color__b",
                "x1": "6.35",
                "x2": "6.73",
                "y1": "6.55",
                "y2": "9.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$51991fc8938e2d6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1M5.5 9a.5.5 0 0 0 0 1h3a.5.5 0 1 0 0-1zm0-3a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$f749dbbee791d214 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.23-.06.42.06A6 6 0 1 0 8 2m.5 7a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm2-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $77e1bce0ac0f7fe7$export$d802222eb5625e03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_20_color__a)",
            "d": "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_20_color__b)",
            "d": "M10.5 11H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 0-1zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_20_color__a",
                "x1": "2.57",
                "x2": "16.54",
                "y1": "5",
                "y2": "28.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_20_color__b",
                "x1": "7.52",
                "x2": "7.97",
                "y1": "8.07",
                "y2": "12.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$3a54bb59f5034e64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m.5 9H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 0-1zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$7067d921f146093d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m.5 8a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h3.09m2-3a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09"
]);
const $77e1bce0ac0f7fe7$export$e4561528ec1dd0a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_24_color__a)",
            "d": "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_24_color__b)",
            "d": "M13.25 13h-4.6a.75.75 0 0 0 0 1.5h4.7a.75.75 0 0 0 0-1.5zm2-3.5h-6.6a.75.75 0 0 0 0 1.5h6.7a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_24_color__a",
                "x1": "2.71",
                "x2": "20.18",
                "y1": "5.75",
                "y2": "35.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_24_color__b",
                "x1": "8.7",
                "x2": "9.23",
                "y1": "9.59",
                "y2": "15.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$4b1011faa575c5fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2m1.25 11h-4.6a.75.75 0 0 0 0 1.5h4.7a.75.75 0 0 0 0-1.5zm2-3.5h-6.6a.75.75 0 0 0 0 1.5h6.7a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$62fe31be16192f54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2m0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5M8.75 13h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5zh4.5zm0-3.5h6.5a.75.75 0 0 1 .1 1.5h-6.6a.75.75 0 0 1-.1-1.5zh6.5z"
]);
const $77e1bce0ac0f7fe7$export$748ce0df1ff19dcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_28_color__a)",
            "d": "M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14m7.5-2.25c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75m.75 3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_28_color__b)",
            "d": "M9.5 11.75c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75m.75 3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_28_color__a",
                "x1": "2.86",
                "x2": "23.81",
                "y1": "6.5",
                "y2": "42.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_28_color__b",
                "x1": "10.29",
                "x2": "10.96",
                "y1": "11.11",
                "y2": "17.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$3176de60cfda2552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat28Filled', "28", [
    "M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14m7.5-2.25c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75m.75 3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$626f2dc30490ed84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat28Regular', "28", [
    "M9.07 23.27a10.5 10.5 0 1 0-4.34-4.34q.27.55.12 1.12L3.6 24.39l4.34-1.24q.59-.15 1.12.12M14 26c-2.04 0-3.96-.5-5.64-1.4L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 1 1 14 26M9.5 11.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m0 4.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$78b13d6157b1606c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_32_color__a)",
            "d": "M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 2 16m8-3a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H11a1 1 0 0 0-1 1m1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_32_color__b)",
            "d": "M10 13a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H11a1 1 0 0 0-1 1m1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_32_color__a",
                "x1": "3",
                "x2": "27.45",
                "y1": "7.25",
                "y2": "48.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_32_color__b",
                "x1": "11.05",
                "x2": "11.95",
                "y1": "12.14",
                "y2": "20.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$5d2c7176d5c2a125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Filled', "32", [
    "M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 2 16m8-3a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H11a1 1 0 0 0-1 1m1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $77e1bce0ac0f7fe7$export$1be355d7fbaa7ab8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Light', "32", [
    "M16 2A14 14 0 0 0 3.63 22.56L2.06 28.1a1.5 1.5 0 0 0 1.85 1.85l5.53-1.57A14 14 0 1 0 16 2m0 27c-2.12 0-4.23-.52-6.09-1.51l-.36-.2L3.64 29l-.15.01a.5.5 0 0 1-.47-.64l1.68-5.91-.19-.36A13.02 13.02 0 0 1 16 3a13.01 13.01 0 0 1 0 26m5.5-16h-11a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1m-4 6h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$9e7ea54b82e5925c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Regular', "32", [
    "M16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1A12 12 0 1 0 16 4M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 2 16m8-3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $77e1bce0ac0f7fe7$export$874d2f883d3757b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_48_color__a)",
            "d": "M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 4 24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_48_color__b)",
            "d": "M16 20.25c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25m1.25 6.25a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_48_color__a",
                "x1": "5.43",
                "x2": "40.35",
                "y1": "11.5",
                "y2": "71.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_48_color__b",
                "x1": "17.4",
                "x2": "18.45",
                "y1": "19.18",
                "y2": "30.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$43c6e5e89d5f91f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat48Filled', "48", [
    "M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 4 24m12-3.75c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25m1.25 6.25a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $77e1bce0ac0f7fe7$export$a5f7f9498d037a8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat48Regular', "48", [
    "M24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11q.51-.14.97.12A17.5 17.5 0 1 0 24 6.5M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 4 24m12-3.75c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25m1.25 6.25a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $77e1bce0ac0f7fe7$export$a586357cc8a39912 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_16_color__a)",
            "d": "M8 2a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A6 6 0 0 1 8 2m.5 3.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_16_color__b)",
            "d": "M8.5 5.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_16_color__a",
                "x1": "2.43",
                "x2": "12.9",
                "y1": "4.25",
                "y2": "22.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_16_color__b",
                "x1": "5.52",
                "x2": "6.52",
                "y1": "5.11",
                "y2": "11.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$c77764279cdb20d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 3.5a.5.5 0 0 0-.5.5v2.5H5a.5.5 0 0 0 0 1h2.5V11a.5.5 0 0 0 1 0V8.5H11a.5.5 0 1 0 0-1H8.5V5a.5.5 0 0 0-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$99ea78f967946a18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.23-.06.42.06A6 6 0 1 0 8 2m0 2.5c.28 0 .5.22.5.5v2.5H11a.5.5 0 0 1 0 1H8.5V11a.5.5 0 1 1-1 0V8.5H5a.5.5 0 0 1 0-1h2.5V5c0-.28.22-.5.5-.5"
]);
const $77e1bce0ac0f7fe7$export$f70b8e3326a37a60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_20_color__a)",
            "d": "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_20_color__b)",
            "d": "M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_20_color__a",
                "x1": "2.57",
                "x2": "16.54",
                "y1": "5",
                "y2": "28.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_20_color__b",
                "x1": "6.7",
                "x2": "8.03",
                "y1": "6.14",
                "y2": "14.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$89ba831c3aacda1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
]);
const $77e1bce0ac0f7fe7$export$34b0375c618e5386 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd20Regular', "20", [
    "M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3zM18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 3 10"
]);
const $77e1bce0ac0f7fe7$export$1998c993195eff42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_24_color__a)",
            "d": "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2m.75 5.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_24_color__b)",
            "d": "M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_24_color__a",
                "x1": "2.71",
                "x2": "20.18",
                "y1": "5.75",
                "y2": "35.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_24_color__b",
                "x1": "7.87",
                "x2": "9.54",
                "y1": "7.18",
                "y2": "17.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$b372735183fc8f10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2m.75 5.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5z"
]);
const $77e1bce0ac0f7fe7$export$d4506f69b85dcfae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd24Regular', "24", [
    "M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5zM22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12M3.5 12a8.5 8.5 0 1 1 4.37 7.43l-.27-.15-3.99 1.11 1.11-3.98-.15-.27A8.5 8.5 0 0 1 3.5 12"
]);
const $77e1bce0ac0f7fe7$export$9dba58375d4c54c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_28_color__a)",
            "d": "M14 2a12 12 0 1 1-5.64 22.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2m.75 6.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_28_color__b)",
            "d": "M14.75 8.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_28_color__a",
                "x1": "2.86",
                "x2": "23.81",
                "y1": "6.5",
                "y2": "42.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_28_color__b",
                "x1": "9.05",
                "x2": "11.04",
                "y1": "8.21",
                "y2": "21.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$44fdd01a450af5e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd28Filled', "28", [
    "M14 2a12 12 0 1 1-5.64 22.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2m.75 6.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5z"
]);
const $77e1bce0ac0f7fe7$export$7751eb6c5f140989 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd28Regular', "28", [
    "M14.75 8.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5zM14 2A12 12 0 0 0 3.4 19.64l-1.35 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35A12 12 0 1 0 14 2M3.5 14a10.5 10.5 0 1 1 5.32 9.14.8.8 0 0 0-.57-.07L3.6 24.39l1.32-4.64q.08-.3-.07-.57A10.5 10.5 0 0 1 3.5 14"
]);
const $77e1bce0ac0f7fe7$export$92fed5ef1f40a3a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_32_color__a)",
            "d": "M16 2a14 14 0 1 1-6.56 26.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2m0 7a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_32_color__b)",
            "d": "M16 9a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_32_color__a",
                "x1": "3",
                "x2": "27.45",
                "y1": "7.25",
                "y2": "48.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_32_color__b",
                "x1": "10.22",
                "x2": "12.55",
                "y1": "9.25",
                "y2": "24.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$6fb2e639082bb910 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd32Filled', "32", [
    "M16 2a14 14 0 1 1-6.56 26.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2m0 7a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1"
]);
const $77e1bce0ac0f7fe7$export$f7fc144b49a9ca2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd32Regular', "32", [
    "M16 9a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1m0-7A14 14 0 0 0 3.63 22.56L2.06 28.1a1.5 1.5 0 0 0 1.85 1.85l5.53-1.57A14 14 0 1 0 16 2M4 16a12 12 0 1 1 6.06 10.43 1 1 0 0 0-.77-.1l-5.06 1.44 1.44-5.06a1 1 0 0 0-.1-.77C4.57 20.2 4 18.16 4 16"
]);
const $77e1bce0ac0f7fe7$export$f770bec62a9e004 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_48_color__a)",
            "d": "M24 4a20 20 0 1 1-9.53 37.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4m1.25 11.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_add_48_color__b)",
            "d": "M25.25 15.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_48_color__a",
                "x1": "5.43",
                "x2": "40.35",
                "y1": "11.5",
                "y2": "71.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_add_48_color__b",
                "x1": "15.75",
                "x2": "19.07",
                "y1": "14.35",
                "y2": "35.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$7f989546cd53e0bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd48Filled', "48", [
    "M24 4a20 20 0 1 1-9.53 37.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4m1.25 11.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5z"
]);
const $77e1bce0ac0f7fe7$export$37f9e935441d309a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd48Regular', "48", [
    "M25.25 15.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5zM24 4A20 20 0 0 0 6.41 33.53l-2.34 8.24a1.75 1.75 0 0 0 2.16 2.16l8.24-2.34A20 20 0 1 0 24 4M6.5 24a17.5 17.5 0 1 1 8.75 15.16q-.46-.25-.97-.12l-7.44 2.11 2.12-7.44c.1-.32.05-.67-.12-.97A17.4 17.4 0 0 1 6.5 24"
]);
const $77e1bce0ac0f7fe7$export$18086e6f57618f14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack16Filled', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29 5.5 5.5 0 1 0-7.67 7.67 7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-.9 1.9a.5.5 0 0 0-.7 0L7.15 9.65Q7 9.79 7 10t.14.35L8.9 12.1a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75H8.71l.9-.9a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$a85836758140a5e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack16Regular', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29q-.54-.75-1.3-1.3a6 6 0 1 0-10.73 5.22q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 1.2.58q.54.76 1.3 1.31a7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-.9 1.9a.5.5 0 0 0-.7 0L7.15 9.65Q7 9.79 7 10t.14.35L8.9 12.1a.5.5 0 1 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75H8.71l.9-.9a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$47d6f3d324b9cd7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a8 8 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m4.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $77e1bce0ac0f7fe7$export$7434ace4cb20a168 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.25 6 6 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04q1.4.78 3.01.88.28.54.66 1a8 8 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m4.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $77e1bce0ac0f7fe7$export$7da9d4b08946b7ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown16Filled', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29 5.5 5.5 0 1 0-7.67 7.67 7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2 2a.5.5 0 0 0-.5.5v.25c0 .97-.78 1.75-1.75 1.75H8.71l.9-.9a.5.5 0 1 0-.71-.7l-1.76 1.75Q7 10.8 7 11q0 .21.15.35L8.9 13.1a.5.5 0 0 0 .7-.7l-.9-.9h1.55A2.75 2.75 0 0 0 13 8.75V8.5a.5.5 0 0 0-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$3a81ff3c3a2393f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown16Regular', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29q-.54-.75-1.3-1.3a6 6 0 1 0-10.73 5.22q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 1.2.58q.54.76 1.3 1.31a7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2 2a.5.5 0 0 0-.5.5v.25c0 .97-.78 1.75-1.75 1.75H8.71l.9-.9a.5.5 0 1 0-.71-.7l-1.76 1.75Q7 10.8 7 11q0 .21.15.35L8.9 13.1a.5.5 0 1 0 .7-.7l-.9-.9h1.55A2.75 2.75 0 0 0 13 8.75V8.5a.5.5 0 0 0-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$9965fa2977867ca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 3.86.86A5.5 5.5 0 0 1 18 10.26zm-3.5 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 17 12.75v-.25a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75h-1.54l.9-.9a.5.5 0 0 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7l1.76 1.75a.5.5 0 0 0 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$30cfaf1c4f4a09d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.25 6 6 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04q1.4.78 3.01.88.28.54.66 1a8 8 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m4.5 8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 17 12.75v-.25a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75h-1.54l.9-.9a.5.5 0 0 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7l1.76 1.75a.5.5 0 0 0 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$447cb8cdc05bb6a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12a10 10 0 0 0 5.42 1.11 6.5 6.5 0 0 1 9.19-9.19zm1 5.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-6.65 2.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h2.04c1.24 0 2.25-1 2.25-2.25v-.25a.5.5 0 0 1 1 0v.25c0 1.8-1.46 3.25-3.25 3.25h-2.04z"
]);
const $77e1bce0ac0f7fe7$export$fe94b56a5de57917 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05 8.5 8.5 0 1 0-15.93 4.4l.15.28-1.1 3.98 3.98-1.11.27.15a8.5 8.5 0 0 0 3.86 1.07q.43.81 1.05 1.47a10 10 0 0 1-5.37-1.08L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2m11 15.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-6.65 2.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h2.04c1.24 0 2.25-1 2.25-2.25v-.25a.5.5 0 0 1 1 0v.25c0 1.8-1.46 3.25-3.25 3.25h-2.04z"
]);
const $77e1bce0ac0f7fe7$export$da4f1b15b72f24d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown28Filled', "28", [
    "M2 14a12 12 0 1 1 23.93 1.32 7.5 7.5 0 1 0-10.6 10.6 12 12 0 0 1-6.97-1.32L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14m25 6.5a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-8.15 2.65a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L17.71 21h2.54A2.75 2.75 0 0 0 23 18.25V18a.5.5 0 0 1 1 0v.25A3.75 3.75 0 0 1 20.25 22h-2.54z"
]);
const $77e1bce0ac0f7fe7$export$e831200b572d4697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown28Regular', "28", [
    "M14 3.5a10.5 10.5 0 0 0-9.14 15.68q.15.27.07.57L3.61 24.4l4.64-1.32q.3-.08.57.07a10.5 10.5 0 0 0 5.33 1.36q.5.78 1.17 1.43a12 12 0 0 1-6.96-1.33L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77a12 12 0 1 1 22.52-4.32q-.64-.67-1.43-1.17V14c0-5.8-4.7-10.5-10.5-10.5m13 17a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-8.15 2.65a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L17.71 21h2.54A2.75 2.75 0 0 0 23 18.25V18a.5.5 0 0 1 1 0v.25A3.75 3.75 0 0 1 20.25 22h-2.54z"
]);
const $77e1bce0ac0f7fe7$export$8fe356533532b52a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown32Filled', "32", [
    "M2 16a14 14 0 1 1 27.95 1.22 9 9 0 1 0-12.73 12.73 14 14 0 0 1-7.78-1.58l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 2 16m21.5 0a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m-1.22 10.22L21.06 25h2.69C26.1 25 28 23.1 28 20.75v-.5a.75.75 0 0 0-1.5 0v.5a2.75 2.75 0 0 1-2.75 2.75h-2.69l1.22-1.22a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06"
]);
const $77e1bce0ac0f7fe7$export$489dda8d117f86ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown32Regular', "32", [
    "M16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1c1.67.95 3.59 1.52 5.64 1.57q.63 1.08 1.52 1.95a14 14 0 0 1-7.78-1.58l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53a14 14 0 1 1 26.32-5.34A9 9 0 0 0 28 15.7 12 12 0 0 0 16 4m7.5 12a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m-1.22 10.22L21.06 25h2.69C26.1 25 28 23.1 28 20.75v-.5a.75.75 0 0 0-1.5 0v.5a2.75 2.75 0 0 1-2.75 2.75h-2.69l1.22-1.22a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06"
]);
const $77e1bce0ac0f7fe7$export$9bfb64ce251d3fc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown48Filled', "48", [
    "M4 24a20 20 0 1 1 39.94 1.62 13 13 0 1 0-18.32 18.32Q24.8 44 24 44c-3.45 0-6.7-.87-9.53-2.41l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 4 24m41 10a11 11 0 1 0-22 0 11 11 0 0 0 22 0m-14.3 3.3a1 1 0 0 1-1.4 1.4l-3-3a1 1 0 0 1 0-1.4l3-3a1 1 0 0 1 1.4 1.4L29.42 34H35a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6h-5.59z"
]);
const $77e1bce0ac0f7fe7$export$3ce8485c1398a28a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown48Regular', "48", [
    "M24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11q.51-.14.97.12a17.4 17.4 0 0 0 8.12 2.33q.97 1.36 2.25 2.45Q24.8 44 24 44c-3.45 0-6.7-.87-9.53-2.41l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24a20 20 0 1 1 37.52-7.91q-1.07-1.28-2.44-2.25A17.5 17.5 0 0 0 24 6.5M45 34a11 11 0 1 0-22 0 11 11 0 0 0 22 0m-14.3 3.3a1 1 0 0 1-1.4 1.4l-3-3a1 1 0 0 1 0-1.4l3-3a1 1 0 0 1 1.4 1.4L29.42 34H35a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6h-5.59z"
]);
const $77e1bce0ac0f7fe7$export$1b172b3af504979f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack16Filled', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29 5.5 5.5 0 1 0-7.67 7.67 7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.35 8.65a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7L8.21 10.5l1.14-1.15a.5.5 0 0 0 0-.7m2.5 0a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7l-.64-.65H13v.5a.5.5 0 0 0 1 0V11a1 1 0 0 0-1-1h-1.8l.65-.65a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$ffcb64dfa61b3252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack16Regular', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29q-.54-.75-1.3-1.3a6 6 0 1 0-10.73 5.22q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 1.2.58q.54.76 1.3 1.31a7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.35 8.65a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7L8.21 10.5l1.14-1.15a.5.5 0 0 0 0-.7m2.5 0a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H13v.5a.5.5 0 0 0 1 0V11a1 1 0 0 0-1-1h-1.8l.65-.65a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$ac7d6d8df3364eaa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a8 8 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m9 12.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-1.14-1.15zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H17v.5a.5.5 0 0 0 1 0V15a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$84f5766e28c8a34a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.25 6 6 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04q1.4.78 3.01.88.28.54.66 1a8 8 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m9 12.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-1.14-1.15zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H17v.5a.5.5 0 0 0 1 0V15a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$5be7ef9a597f9571 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_16_color__a)",
            "d": "M9 4a5 5 0 0 1 4.53 7.11l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46A4.98 4.98 0 0 1 4 9a5 5 0 0 1 5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_16_color__b)",
            "d": "M7 2a5 5 0 0 0-4.53 7.11L2 11.41a.5.5 0 0 0 .59.58l2.29-.46A4.98 4.98 0 0 0 12 7a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_16_color__c)",
            "d": "M6.38 9.5a.62.62 0 1 1 1.25 0 .62.62 0 0 1-1.25 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_16_color__d)",
            "d": "M5.15 5.95C5.14 4.82 5.95 4 7 4c1.03 0 1.86.85 1.86 1.95 0 .59-.22.9-.73 1.32l-.28.21c-.24.2-.33.3-.34.45l-.01.16a.5.5 0 0 1-1-.1c0-.56.21-.88.72-1.28l.28-.22c.29-.23.36-.34.36-.54C7.86 5.39 7.48 5 7 5c-.49 0-.86.37-.85.94a.5.5 0 1 1-1 .01"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_16_color__b",
                "x1": "2",
                "x2": "12",
                "y1": "2",
                "y2": "12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_16_color__c",
                "x1": "5.47",
                "x2": "7.09",
                "y1": "4.11",
                "y2": "10.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_16_color__d",
                "x1": "5.47",
                "x2": "7.09",
                "y1": "4.11",
                "y2": "10.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(49.24 -3.93 10.63)scale(7.04808 7.0541)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$fe285589ce465c51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion16Filled', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 8a.75.75 0 1 0 0 1.5A.75.75 0 0 0 7 9m0-5.5c-.97 0-1.75.78-1.75 1.75a.5.5 0 0 0 1 0 .75.75 0 0 1 1.5 0c0 .34-.16.5-.5.9S6.5 7.07 6.5 8a.5.5 0 0 0 1 0c0-.57.22-.86.5-1.2.28-.32.75-.77.75-1.55 0-.97-.78-1.75-1.75-1.75"
]);
const $77e1bce0ac0f7fe7$export$b9946b07f87320c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion16Regular', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 1a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05A5 5 0 1 0 7 2m0 7a.75.75 0 1 1 0 1.5A.75.75 0 0 1 7 9m0-5.5c.97 0 1.75.78 1.75 1.75 0 .78-.47 1.23-.75 1.56s-.5.62-.5 1.19a.5.5 0 0 1-1 0c0-.93.4-1.45.75-1.85s.5-.56.5-.9a.75.75 0 0 0-1.5 0 .5.5 0 0 1-1 0c0-.97.78-1.75 1.75-1.75"
]);
const $77e1bce0ac0f7fe7$export$384edc7de702e3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_20_color__a)",
            "d": "M11.5 5a6.5 6.5 0 0 1 5.67 9.67l.8 2.08a1 1 0 0 1-1.2 1.32l-2.5-.7q-1.27.61-2.77.63a6.5 6.5 0 1 1 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_20_color__b)",
            "d": "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_20_color__c)",
            "d": "M8.5 6.02c-.37.07-.76.3-1.07.85a.5.5 0 0 1-.86-.5A2.6 2.6 0 0 1 8.3 5.05c.65-.12 1.3.04 1.8.36.48.33.87.85.88 1.48.01.65-.39 1.24-1.12 1.67-.5.3-.7.5-.77.63-.07.11-.09.22-.09.44a.5.5 0 0 1-1 0c0-.27.01-.6.24-.97q.3-.48 1.11-.96c.54-.31.63-.61.63-.8s-.14-.45-.44-.65c-.29-.2-.67-.29-1.05-.22m.25 6.6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_20_color__b",
                "x1": "2",
                "x2": "15.11",
                "y1": "2",
                "y2": "15.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_20_color__c",
                "x1": "6.89",
                "x2": "8.96",
                "y1": "5.13",
                "y2": "12.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 7 -7 6 8.5 8.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$fd27a0cf70438154 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion20Filled', "20", [
    "M8.5 2a6.5 6.5 0 0 0-5.67 9.67l-.8 2.08a1 1 0 0 0 1.2 1.32l2.5-.7Q7 15 8.5 15a6.5 6.5 0 1 0 0-13m0 3.9c-.37.07-.76.3-1.07.85a.5.5 0 1 1-.86-.5A2.6 2.6 0 0 1 8.3 4.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 0 1-1 0c0-.27.01-.61.24-.97q.3-.5 1.11-.96c.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22m.25 6.6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-2.21 3.24a6.5 6.5 0 0 0 7.7 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.23.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09A5.5 5.5 0 0 1 8.3 16a8 8 0 0 1-1.76-.26"
]);
const $77e1bce0ac0f7fe7$export$85f5ce5c5afbf102 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion20Regular', "20", [
    "M8.5 5.9c-.37.07-.76.3-1.07.85a.5.5 0 1 1-.86-.5A2.6 2.6 0 0 1 8.3 4.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 0 1-1 0c0-.27.01-.61.24-.97q.3-.5 1.11-.96c.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22m.25 6.6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.5 2a6.5 6.5 0 0 0-5.67 9.67l-.8 2.08a1 1 0 0 0 1.2 1.32l2.5-.7Q7 15 8.5 15a6.5 6.5 0 1 0 0-13M3 8.5a5.5 5.5 0 1 1 3 4.9l-.18-.09-2.86.8.97-2.53-.13-.21A5.5 5.5 0 0 1 3 8.5m8.46 9.5a6.5 6.5 0 0 1-4.92-2.26A8 8 0 0 0 8.3 16a5.5 5.5 0 0 0 5.66.4l.18-.09 2.86.8-.97-2.53.13-.21A5.5 5.5 0 0 0 16 8.39q-.01-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.27.61-2.78.63"
]);
const $77e1bce0ac0f7fe7$export$6b158c77aee5a32e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_24_color__a)",
            "fillRule": "evenodd",
            "d": "M22 13.5a7.5 7.5 0 1 0-4.41 6.84c1.26.29 2.61.54 3.24.65a1 1 0 0 0 1.15-1.17 68 68 0 0 0-.68-3.15q.69-1.46.7-3.17M14.52 18h-.04.04",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_24_color__b)",
            "fillRule": "evenodd",
            "d": "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 2 10.5M9.48 15h.04-.04",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_bubbles_question_24_color__c)",
            "d": "M7.1 7.4q.38-.75 1.04-1.1a2.8 2.8 0 0 1 3 .28c.5.42.86 1.07.86 1.92 0 .97-.69 1.5-1.08 1.8l-.08.07c-.43.33-.59.5-.59.88a.75.75 0 1 1-1.5 0c0-1.13.71-1.7 1.16-2.06.52-.4.59-.5.59-.7 0-.39-.15-.61-.32-.75-.2-.16-.46-.24-.68-.24q-.44 0-.65.13c-.14.08-.3.21-.44.48a.75.75 0 0 1-1.32-.71M9.5 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_24_color__b",
                "x1": "2",
                "x2": "17",
                "y1": "3",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_24_color__c",
                "x1": "7.44",
                "x2": "10",
                "y1": "6.16",
                "y2": "15.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_bubbles_question_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(49.24 -5.4 17.03)scale(10.5735 10.5821)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$caa871aaa02bb661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion24Filled', "24", [
    "M9.5 3a7.5 7.5 0 0 0-6.8 10.67 68 68 0 0 0-.68 3.15 1 1 0 0 0 1.15 1.17c.63-.11 1.98-.36 3.24-.65q1.43.64 3.09.66a7.5 7.5 0 0 0 0-15M7.1 7.4q.38-.74 1.04-1.1a2.8 2.8 0 0 1 3 .28c.5.42.86 1.07.86 1.92 0 .97-.69 1.5-1.08 1.8l-.08.07c-.43.33-.59.51-.59.88a.75.75 0 0 1-1.5 0c0-1.13.71-1.7 1.16-2.06.51-.4.59-.5.59-.69 0-.4-.15-.62-.32-.76-.2-.16-.46-.24-.68-.24q-.44 0-.65.13c-.14.08-.3.21-.44.48a.75.75 0 1 1-1.32-.71M9.5 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-.1 6a7.5 7.5 0 0 0 8.19 1.34c1.04.24 2.18.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8q.69-1.47.7-3.18a7.5 7.5 0 0 0-5.05-7.09q.53.96.8 2.05a6 6 0 0 1 2.09 7.79l-.13.25.07.28.64 2.65-2.74-.61-.27-.07-.24.12a6 6 0 0 1-5.59-.13A9 9 0 0 1 9.4 19"
]);
const $77e1bce0ac0f7fe7$export$6253e8b8f6840d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion24Regular', "24", [
    "M8.14 6.3a2.8 2.8 0 0 1 2.99.28c.52.42.87 1.07.87 1.92 0 .97-.69 1.5-1.08 1.8l-.08.07c-.43.33-.6.51-.6.88a.75.75 0 1 1-1.5 0c0-1.13.72-1.7 1.17-2.06.51-.4.59-.5.59-.69 0-.4-.15-.62-.32-.76-.2-.16-.46-.24-.68-.24q-.44 0-.65.13c-.14.08-.3.21-.44.48a.75.75 0 0 1-1.32-.71q.39-.74 1.05-1.1M9.5 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-12a7.5 7.5 0 0 0-6.8 10.67l-.72 2.84c-.24.92.59 1.75 1.5 1.53l2.93-.7q1.42.64 3.09.66a7.5 7.5 0 0 0 0-15m-6 7.5a6 6 0 1 1 3.33 5.37l-.24-.12-.27.07-2.79.66.7-2.7.06-.28-.13-.25a6 6 0 0 1-.66-2.75m11 10.5a7.5 7.5 0 0 1-5.1-2 8 8 0 0 0 2.18-.26 6 6 0 0 0 5.59.13l.24-.12.27.07c.92.22 1.96.44 2.74.6-.18-.74-.42-1.75-.65-2.64l-.07-.28.14-.25a5.97 5.97 0 0 0-2.09-7.8 8 8 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.58 1.7-1.47 1.5-.73-.15-1.87-.39-2.91-.63q-1.44.64-3.1.66"
]);
const $77e1bce0ac0f7fe7$export$bfcf31af20589fcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion28Filled', "28", [
    "M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3m0 14.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2M9.5 9.26A.75.75 0 0 1 8 9.25V9.1a3 3 0 0 1 .38-1.22C8.78 7.15 9.6 6.5 11 6.5s2.21.65 2.62 1.38A3 3 0 0 1 14 9.2v.05c0 1.12-.7 1.88-1.2 2.43l-.12.13c-.54.61-.93 1.11-.93 1.94a.75.75 0 0 1-1.5 0c0-1.42.74-2.3 1.32-2.94l.02-.02c.6-.68.9-1.01.91-1.53a2 2 0 0 0-.18-.64C12.16 8.35 11.85 8 11 8s-1.16.35-1.32.62a2 2 0 0 0-.18.64M17 25a9 9 0 0 1-6.73-3.03 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55q.89-1.62.91-3.59a7.5 7.5 0 0 0-3.83-6.54 10 10 0 0 0-.74-1.97 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A9 9 0 0 1 17 25M12.5 9.26"
]);
const $77e1bce0ac0f7fe7$export$492bd53f02edccb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion28Regular', "28", [
    "M3.5 12a7.5 7.5 0 1 1 3.9 6.59.8.8 0 0 0-.54-.07l-3.26.87.88-3.25a.8.8 0 0 0-.07-.55A7.5 7.5 0 0 1 3.5 12M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3m6 22a9 9 0 0 1-6.73-3.03 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55q.89-1.62.91-3.59a7.5 7.5 0 0 0-3.83-6.54 10 10 0 0 0-.74-1.97 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A9 9 0 0 1 17 25m-5-8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 9.26v-.04l.02-.14q.04-.21.16-.46C9.84 8.35 10.15 8 11 8s1.16.35 1.32.62a2 2 0 0 1 .18.63c0 .53-.3.86-.91 1.54l-.02.02a4.2 4.2 0 0 0-1.32 2.94.75.75 0 0 0 1.5 0c0-.83.39-1.33.93-1.94l.13-.13c.5-.55 1.19-1.3 1.19-2.43V9.2l-.05-.4a3 3 0 0 0-.33-.92C13.22 7.15 12.4 6.5 11 6.5s-2.21.65-2.62 1.38A3 3 0 0 0 8 9.23v.02a.75.75 0 0 0 1.5 0"
]);
const $77e1bce0ac0f7fe7$export$40299383627f9f7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion32Filled', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3m1.95 22.34a12 12 0 0 1-2.8.13 10.5 10.5 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.4 10.4 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7q.54 1.3.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.5 8.5 0 0 1-9.14-.62M11.5 15c0-1.66.88-2.66 1.6-3.48l.02-.02c.56-.64.88-1.02.88-1.5-.01-.29-.18-1-1.5-1-1.43 0-1.5.83-1.5 1a1 1 0 0 1-1 1 1 1 0 0 1-1-1c0-1.21.93-3 3.5-3S16 8.79 16 10s-.73 2.09-1.38 2.83l-.02.02c-.59.67-1.1 1.25-1.1 2.15a1 1 0 0 1-1 1 1 1 0 0 1-1-1m2.25 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $77e1bce0ac0f7fe7$export$dae9e9e67d6bd272 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion32Regular', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3M5.05 17.59a8.5 8.5 0 1 1 3.36 3.36 1 1 0 0 0-.75-.09l-3.45.93.93-3.46a1 1 0 0 0-.1-.74m9.4 7.75a12 12 0 0 1-2.8.13 10.5 10.5 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.4 10.4 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7q.54 1.3.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.5 8.5 0 0 1-9.14-.62M11.5 15a1 1 0 0 0 1 1 1 1 0 0 0 1-1c0-.9.51-1.48 1.1-2.15l.02-.02C15.27 12.09 16 11.21 16 10s-.93-3-3.5-3S9 8.79 9 10a1 1 0 0 0 1 1 1 1 0 0 0 1-1c0-.17.07-1 1.5-1 1.32 0 1.49.71 1.5 1 0 .48-.32.86-.88 1.5l-.02.02c-.72.82-1.6 1.82-1.6 3.48m2.25 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $77e1bce0ac0f7fe7$export$4897ac219b9aa3be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark12Filled', "12", [
    "M6 1a5 5 0 1 1-2.4 9.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A5 5 0 0 1 6 1m2.35 3.4a.5.5 0 0 0-.7 0L5.5 6.54 4.35 5.4a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$aa5fb18f230710b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark12Regular', "12", [
    "M6 1a5 5 0 1 1-2.4 9.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A5 5 0 0 1 6 1m0 1a4 4 0 0 0-3.42 6.08q.12.2.05.4l-.38 1.26 1.26-.38a.5.5 0 0 1 .4.05Q4.85 10 6 10a4 4 0 0 0 0-8m1.65 2.4a.5.5 0 0 1 .7.7l-2.5 2.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L5.5 6.54z"
]);
const $77e1bce0ac0f7fe7$export$eeccf6f95d4860b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.85 5.15a.5.5 0 0 0-.7 0l-2.9 2.9-1.4-1.4a.5.5 0 0 0-.7.7L6.9 10.1c.2.2.5.2.7 0l3.25-3.25a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$170d924428830741 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.22-.06.42.06A6 6 0 1 0 8 2m2.15 4.15a.5.5 0 0 1 .7.7L7.6 10.1a.5.5 0 0 1-.7 0L5.15 8.35a.5.5 0 0 1 .7-.7l1.4 1.4z"
]);
const $77e1bce0ac0f7fe7$export$b110f776950762e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.64-.06-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m3.35 5.65a.5.5 0 0 0-.7 0L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$81a33cdb6a88da74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.64-.06-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m2.65 4.65a.5.5 0 1 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 11.29z"
]);
const $77e1bce0ac0f7fe7$export$40d78195090efa30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2m4.28 6.97a.75.75 0 0 0-1.06 0l-4.47 4.47-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5c.3-.3.3-.77 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$1e566a21539f1873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.55L3.1 16.6A10 10 0 0 1 12 2m0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5m3.22 5.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.97 1.97z"
]);
const $77e1bce0ac0f7fe7$export$dffda8dcd9cb829c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark28Filled', "28", [
    "M14 2a12 12 0 1 1-5.64 22.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2m5.53 8.22a.75.75 0 0 0-1.06 0l-5.97 5.97-2.97-2.97a.75.75 0 0 0-1.06 1.06l3.5 3.5c.3.3.77.3 1.06 0l6.5-6.5c.3-.3.3-.77 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$71957c1b52d6ce07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark28Regular', "28", [
    "M14 2a12 12 0 1 1-5.64 22.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.35-4.77A12 12 0 0 1 14 2m0 1.5a10.5 10.5 0 0 0-9.14 15.68q.15.27.07.57L3.61 24.4l4.64-1.32q.3-.09.57.07A10.5 10.5 0 1 0 14 3.5m4.47 6.72a.75.75 0 0 1 1.06 1.06l-6.5 6.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 0 1 1.06-1.06l2.97 2.97z"
]);
const $77e1bce0ac0f7fe7$export$2cc75c7ae1ee7ae1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark32Filled', "32", [
    "M16 2a14 14 0 1 1-6.56 26.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2m6.7 9.3a1 1 0 0 0-1.4 0l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l7.5-7.5a1 1 0 0 0 0-1.42"
]);
const $77e1bce0ac0f7fe7$export$c181d4a0a695f9dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark32Regular', "32", [
    "M16 2a14 14 0 1 1-6.56 26.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2m0 2A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.43a1 1 0 0 1 .77.09A12 12 0 1 0 16 4m5.3 7.3a1 1 0 0 1 1.4 1.4l-7.5 7.5a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29z"
]);
const $77e1bce0ac0f7fe7$export$68c2134c4879b8c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark48Filled', "48", [
    "M24 4a20 20 0 1 1-9.53 37.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4m8.63 13.62a1.25 1.25 0 0 0-1.76 0L20.75 27.73l-3.62-3.61a1.25 1.25 0 0 0-1.76 1.76l4.5 4.5c.49.5 1.28.5 1.77 0l11-11c.48-.48.48-1.27 0-1.76"
]);
const $77e1bce0ac0f7fe7$export$add2fdb9939e44c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCheckmark48Regular', "48", [
    "M24 4a20 20 0 1 1-9.53 37.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4m0 2.5A17.5 17.5 0 0 0 8.84 32.75c.17.29.21.64.12.96l-2.12 7.45 7.44-2.12c.33-.1.68-.05.97.12A17.5 17.5 0 1 0 24 6.5m6.87 11.12a1.25 1.25 0 0 1 1.76 1.77l-11 11c-.48.48-1.27.48-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.77l3.62 3.61z"
]);
const $77e1bce0ac0f7fe7$export$cb87b173cb230de1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor16Filled', "16", [
    "M8.01 7.64a.75.75 0 0 1 1.22-.47l5.5 4.5a.75.75 0 0 1-.48 1.33h-2.99a.5.5 0 0 0-.4.2l-1.51 2A.75.75 0 0 1 8 14.75v-7zM7 1a6 6 0 0 1 5.74 7.75L9.86 6.4l-.1-.08A1.75 1.75 0 0 0 7 7.75V13c-1.1 0-2.12-.3-3-.8l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1"
]);
const $77e1bce0ac0f7fe7$export$582db7b65d91598a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor16Regular', "16", [
    "M8.01 7.64a.75.75 0 0 1 1.22-.47l5.5 4.5a.75.75 0 0 1-.48 1.33h-2.99a.5.5 0 0 0-.4.2l-1.51 2A.75.75 0 0 1 8 14.75v-7zM7 1a6 6 0 0 1 5.74 7.75l-.85-.7A5.02 5.02 0 0 0 7 2a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05c.77.5 1.69.78 2.67.78v1c-1.1 0-2.12-.3-3-.8l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1"
]);
const $77e1bce0ac0f7fe7$export$4fda91566e0bcb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor20Filled', "20", [
    "M8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2a6 6 0 0 0 4 .73V8.75c0-1.5 1.74-2.3 2.88-1.34l1.8 1.53A6 6 0 0 0 8 1m2 7.75v9a.75.75 0 0 0 1.37.42l1.98-2.95a.5.5 0 0 1 .42-.22h3.48c.7 0 1.02-.87.49-1.32l-6.5-5.5a.75.75 0 0 0-1.24.57"
]);
const $77e1bce0ac0f7fe7$export$bb6cf7c4aace8170 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor20Regular', "20", [
    "M8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2a6 6 0 0 0 4 .73V11.9a5 5 0 0 1-3.67-.67.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39 5 5 0 1 1 9.15-1.32l.83.7A6 6 0 0 0 8 1m2 7.75v9a.75.75 0 0 0 1.37.42l1.98-2.95a.5.5 0 0 1 .42-.22h3.48c.7 0 1.02-.87.49-1.32l-6.5-5.5a.75.75 0 0 0-1.24.57"
]);
const $77e1bce0ac0f7fe7$export$d59f18b6bc05dac9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor24Filled', "24", [
    "M12 11a1 1 0 0 1 1.6-.8l8 6A1 1 0 0 1 21 18h-4.4a1 1 0 0 0-.88.53l-1.84 3.44c-.49.92-1.88.57-1.88-.47zM10 1a8 8 0 0 1 7.47 10.85L14.2 9.4A2 2 0 0 0 11 11v5.94a8 8 0 0 1-4.64-.82l-3.43.86a.75.75 0 0 1-.9-.91l.85-3.43A8 8 0 0 1 10 1"
]);
const $77e1bce0ac0f7fe7$export$7ef7233c8185aa30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor24Regular', "24", [
    "M12 11a1 1 0 0 1 1.6-.8l8 6A1 1 0 0 1 21 18h-4.4a1 1 0 0 0-.88.53l-1.84 3.44c-.49.92-1.88.57-1.88-.47zM10 1a8 8 0 0 1 7.47 10.85l-1.26-.94a6.5 6.5 0 1 0-11.88 1.27q.15.25.07.55l-.62 2.49 2.5-.62.13-.03q.22 0 .41.1a6.5 6.5 0 0 0 4.18.75v1.52a8 8 0 0 1-4.64-.82l-3.43.86a.75.75 0 0 1-.9-.91l.85-3.43A8 8 0 0 1 10 1"
]);
const $77e1bce0ac0f7fe7$export$3cf96f821c375556 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m2.35 4.65a.5.5 0 0 0-.7 0L8 7.29 6.35 5.65a.5.5 0 0 0-.7.7L7.29 8 5.65 9.65a.5.5 0 0 0 .7.7L8 8.71l1.65 1.64a.5.5 0 0 0 .7-.7L8.71 8l1.64-1.65a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$4c952bf9e55d0014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.22-.06.42.06A6 6 0 1 0 8 2m1.65 3.65a.5.5 0 0 1 .7.7L8.71 8l1.64 1.65a.5.5 0 0 1-.7.7L8 8.71l-1.65 1.64a.5.5 0 0 1-.7-.7L7.29 8 5.65 6.35a.5.5 0 0 1 .7-.7L8 7.29z"
]);
const $77e1bce0ac0f7fe7$export$8f3a4c52c95cfb77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M7.85 7.15 10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 1 1 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$9dfc798f37d2e71e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss20Regular', "20", [
    "M7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29zM18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 3 10"
]);
const $77e1bce0ac0f7fe7$export$d9457806d8e3f0e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss24Filled', "24", [
    "M22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12M9.28 8.22 12 10.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 1.06-1.06"
]);
const $77e1bce0ac0f7fe7$export$691b5468c2e72004 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss24Regular', "24", [
    "M9.28 8.22a.75.75 0 0 0-1.06 1.06L10.94 12l-2.72 2.72a.75.75 0 1 0 1.06 1.06L12 13.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L13.06 12l2.72-2.72a.75.75 0 0 0-1.06-1.06L12 10.94zM22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12M3.5 12a8.5 8.5 0 1 1 4.37 7.43l-.27-.15-3.99 1.11 1.11-3.98-.15-.27A8.5 8.5 0 0 1 3.5 12"
]);
const $77e1bce0ac0f7fe7$export$fb554a607c09a800 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty12Filled', "12", [
    "M6 1a5 5 0 0 0-4.39 7.4l-.59 1.95a.5.5 0 0 0 .63.62l1.94-.59Q4.7 11 6 11A5 5 0 1 0 6 1"
]);
const $77e1bce0ac0f7fe7$export$4b7df8920b77ede4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty12Regular', "12", [
    "M1 6a5 5 0 1 1 2.6 4.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A5 5 0 0 1 1 6m5-4a4 4 0 0 0-3.42 6.08q.12.2.05.4l-.38 1.26 1.26-.38a.5.5 0 0 1 .4.05Q4.84 10 6 10a4 4 0 0 0 0-8"
]);
const $77e1bce0ac0f7fe7$export$1232cd5562674a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1"
]);
const $77e1bce0ac0f7fe7$export$1394d9e48daac3f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.22-.06.42.06A6 6 0 1 0 8 2"
]);
const $77e1bce0ac0f7fe7$export$1411e8bf0b4d84d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10"
]);
const $77e1bce0ac0f7fe7$export$6b4675ae05032a1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3"
]);
const $77e1bce0ac0f7fe7$export$662f7176cfc333bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12A10 10 0 0 0 22 12"
]);
const $77e1bce0ac0f7fe7$export$e2e509debfe15a9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2m0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5"
]);
const $77e1bce0ac0f7fe7$export$906cc77d5b44ea14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty28Filled', "28", [
    "M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14"
]);
const $77e1bce0ac0f7fe7$export$392ac74865d2856e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty28Regular', "28", [
    "M14 3.5a10.5 10.5 0 0 0-9.14 15.68q.15.27.07.57L3.61 24.4l4.64-1.32q.3-.08.57.07A10.5 10.5 0 1 0 14 3.5M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14"
]);
const $77e1bce0ac0f7fe7$export$f5c6b0f93292510f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty32Filled', "32", [
    "M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 2 16"
]);
const $77e1bce0ac0f7fe7$export$2e627e8de476eaa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty32Regular', "32", [
    "M16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1A12 12 0 1 0 16 4M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 2 16"
]);
const $77e1bce0ac0f7fe7$export$203c1b9f6c042855 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty48Filled', "48", [
    "M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 4 24"
]);
const $77e1bce0ac0f7fe7$export$9319f2b204a39ebb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty48Regular', "48", [
    "M24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11q.51-.14.97.12A17.5 17.5 0 1 0 24 6.5M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 4 24"
]);
const $77e1bce0ac0f7fe7$export$8ba4d89ebdfb0101 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 9.5A.75.75 0 1 0 8 12a.75.75 0 0 0 0-1.5M8 4a2 2 0 0 0-2 2 .5.5 0 0 0 1 0 1 1 0 0 1 2 0c0 .26-.06.4-.14.51-.1.15-.23.26-.46.47a2.8 2.8 0 0 0-.9 2.27.5.5 0 0 0 1 0c0-.49.08-.8.19-1.02q.15-.3.4-.53c.16-.15.4-.36.58-.61Q9.98 6.67 10 6a2 2 0 0 0-2-2"
]);
const $77e1bce0ac0f7fe7$export$96a4052452588da4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.23-.06.42.06A6 6 0 1 0 8 2m0 8.5A.75.75 0 1 1 8 12a.75.75 0 0 1 0-1.5M8 4a2 2 0 0 1 1.67 3.09c-.17.25-.42.46-.57.6q-.26.24-.41.54c-.1.22-.19.53-.19 1.02a.5.5 0 0 1-1 0q0-.89.28-1.45c.18-.37.42-.62.62-.82.23-.21.35-.32.46-.47A1 1 0 0 0 9 6a1 1 0 1 0-2 0 .5.5 0 1 1-1 0c0-1.1.9-2 2-2"
]);
const $77e1bce0ac0f7fe7$export$40c96fd8d85a590 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp20Filled', "20", [
    "M2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 0 1 2 10m7.25-2.7c.15-.17.39-.3.75-.3s.6.13.75.3q.24.3.25.7c0 .32-.07.52-.17.69s-.23.3-.42.5l-.02.03c-.19.2-.42.44-.6.78q-.28.5-.29 1.3a.5.5 0 1 0 1 0c0-.4.08-.64.18-.84s.24-.35.43-.55l.04-.04c.17-.18.38-.4.55-.68q.29-.47.3-1.19a1.95 1.95 0 0 0-2-2 1.95 1.95 0 0 0-2 2 .5.5 0 0 0 1 0q0-.4.25-.7m1.45 6.21a.7.7 0 1 0-1.4 0 .7.7 0 0 0 1.4 0"
]);
const $77e1bce0ac0f7fe7$export$a36eabf02991c5ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp20Regular', "20", [
    "M9.25 7.3Q9 7.6 9 8a.5.5 0 0 1-1 0 1.95 1.95 0 0 1 2-2 1.95 1.95 0 0 1 2 2q-.02.72-.3 1.19-.28.41-.55.68l-.04.04c-.19.2-.33.35-.43.55q-.17.28-.18.83a.5.5 0 1 1-1 0 2.7 2.7 0 0 1 .89-2.07l.02-.02c.19-.2.32-.34.42-.51S11 8.32 11 8q0-.4-.25-.7A1 1 0 0 0 10 7c-.36 0-.6.13-.75.3m.75 6.91a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4M2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 0 1 2 10m8-7a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05A7 7 0 1 0 10 3"
]);
const $77e1bce0ac0f7fe7$export$632383b1e2107c2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2m0 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-8.75A2.75 2.75 0 0 0 9.25 9.5a.75.75 0 0 0 1.5.1v-.23a1.25 1.25 0 0 1 2.5.13c0 .54-.13.8-.64 1.33l-.3.31c-.76.79-1.06 1.35-1.06 2.36a.75.75 0 0 0 1.5 0c0-.54.13-.8.64-1.33l.3-.31c.76-.79 1.06-1.35 1.06-2.36A2.75 2.75 0 0 0 12 6.75"
]);
const $77e1bce0ac0f7fe7$export$4449a2d9673d706a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2m0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5m0 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-8.75a2.75 2.75 0 0 1 2.75 2.75c0 1.01-.3 1.57-1.05 2.36l-.17.17c-.62.62-.78.89-.78 1.47a.75.75 0 0 1-1.5 0c0-1.01.3-1.57 1.05-2.36l.17-.17c.62-.62.78-.89.78-1.47a1.25 1.25 0 0 0-2.5-.13v.13a.75.75 0 0 1-1.5 0A2.75 2.75 0 0 1 12 6.75"
]);
const $77e1bce0ac0f7fe7$export$95d192396ff74135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf16Filled', "16", [
    "M2.21 4.06A.48.48 0 0 1 2.95 4c.18.18.2.46.05.67a6 6 0 0 0-.07 6.53q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 6.53-.07c.2-.14.5-.13.67.05.21.21.2.57-.05.73a7 7 0 0 1-7.48.26l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8a7 7 0 0 1 .25-7.48m9.33 7.48a5 5 0 0 1-7.08-7.08zm2.86-2.79c.3 0 .53.26.48.56a7 7 0 0 1-1.1 2.63.48.48 0 0 1-.73.05.54.54 0 0 1-.05-.67q.63-.97.88-2.13a.54.54 0 0 1 .52-.44m-1.35-4.74c.21-.22.57-.2.73.05q.82 1.18 1.1 2.63c.05.3-.18.56-.48.56a.54.54 0 0 1-.52-.44A6 6 0 0 0 13 4.68a.54.54 0 0 1 .05-.67M6.7 1.12c.3-.05.56.18.56.48 0 .26-.2.47-.44.52q-1.17.24-2.13.88a.54.54 0 0 1-.67-.06.48.48 0 0 1 .05-.73 7 7 0 0 1 2.63-1.09m2.62 0q1.45.28 2.63 1.1c.25.16.26.51.05.72a.54.54 0 0 1-.67.06 6 6 0 0 0-2.13-.88.54.54 0 0 1-.44-.52c0-.3.26-.53.56-.48"
]);
const $77e1bce0ac0f7fe7$export$5fc1e6afaefc2aca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf16Regular', "16", [
    "M2.21 4.06a.48.48 0 0 1 .74-.05c.18.18.2.46.05.67a6 6 0 0 0-.07 6.53q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 6.53-.07c.2-.14.5-.13.67.05.21.22.2.57-.05.73a6.97 6.97 0 0 1-7.48.25l-2.8.94a.5.5 0 0 1-.63-.63l.93-2.8a7 7 0 0 1 .25-7.48M14.4 8.75c.3 0 .53.26.48.56a7 7 0 0 1-1.1 2.63.48.48 0 0 1-.73.05.54.54 0 0 1-.05-.67q.63-.97.88-2.13a.54.54 0 0 1 .52-.44m-1.35-4.74c.21-.22.57-.2.74.05q.8 1.18 1.09 2.63c.05.3-.18.56-.48.56a.54.54 0 0 1-.52-.44A6 6 0 0 0 13 4.68a.54.54 0 0 1 .05-.67M6.7 1.12c.3-.05.56.18.56.48 0 .26-.2.47-.44.52q-1.17.25-2.13.88a.54.54 0 0 1-.67-.05.48.48 0 0 1 .05-.74 7 7 0 0 1 2.63-1.09m2.62 0q1.45.28 2.63 1.1c.25.16.26.51.05.73a.54.54 0 0 1-.67.05 6 6 0 0 0-2.13-.88.54.54 0 0 1-.44-.52c0-.3.26-.53.56-.48"
]);
const $77e1bce0ac0f7fe7$export$456e5ab8de979a02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf20Filled', "20", [
    "M3.35 5.56a.48.48 0 0 1 .73-.06c.18.18.2.46.06.66q-.2.3-.36.62a7 7 0 0 0 .11 6.64.5.5 0 0 1 .05.37L3.2 16.8l3.02-.75.1-.02q.13 0 .27.07a7 7 0 0 0 7.25-.25.5.5 0 0 1 .67.05c.22.22.2.57-.06.74a8.1 8.1 0 0 1-8.18.42L2.62 18a.5.5 0 0 1-.6-.61l.9-3.65a8 8 0 0 1 .13-7.69zm10.9 8.68a6 6 0 0 1-6.94 1.12l-.1-.05-.34-.18-.34-.18-1.97.49.4-1.6.1-.36-.37-.68-.06-.11a6 6 0 0 1 1.13-6.93zM17.35 11c.3 0 .54.27.48.56a8 8 0 0 1-1.19 2.88.48.48 0 0 1-.74.06.5.5 0 0 1-.05-.67q.71-1.09 1-2.4a.5.5 0 0 1 .5-.43m-1.45-5.5c.22-.22.57-.2.74.06q.88 1.3 1.2 2.88c.05.3-.18.56-.49.56a.5.5 0 0 1-.5-.43 7 7 0 0 0-1-2.4.5.5 0 0 1 .05-.67M8.44 2.16c.3-.06.56.17.56.48 0 .25-.18.46-.43.5q-1.31.29-2.4 1a.5.5 0 0 1-.67-.06.48.48 0 0 1 .06-.73 8 8 0 0 1 2.88-1.2m3.12 0q1.58.31 2.88 1.19c.25.17.27.52.06.73a.5.5 0 0 1-.67.06 7 7 0 0 0-2.4-1 .5.5 0 0 1-.43-.5c0-.3.27-.54.56-.48"
]);
const $77e1bce0ac0f7fe7$export$8da65b16c1b79736 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf20Regular', "20", [
    "M3.35 5.56a.48.48 0 0 1 .73-.06c.18.18.2.46.06.66a7 7 0 0 0-.25 7.26.5.5 0 0 1 .05.37L3.2 16.8l3.02-.75.1-.02q.14 0 .27.07a7 7 0 0 0 7.25-.25c.21-.14.5-.12.67.05.21.22.2.57-.06.74a8 8 0 0 1-8.18.42L2.62 18a.5.5 0 0 1-.6-.61l.9-3.65a8 8 0 0 1 .43-8.17M17.36 11c.3 0 .54.27.48.56a8 8 0 0 1-1.19 2.88.48.48 0 0 1-.74.06.5.5 0 0 1-.05-.67q.71-1.09 1-2.4a.5.5 0 0 1 .5-.43m-1.45-5.5c.22-.21.57-.2.74.06q.88 1.3 1.2 2.88c.05.3-.18.56-.49.56a.5.5 0 0 1-.5-.43 7 7 0 0 0-1-2.4.5.5 0 0 1 .05-.67M8.44 2.16c.3-.06.56.17.56.47 0 .26-.18.47-.43.52q-1.31.27-2.4 1a.5.5 0 0 1-.67-.07.48.48 0 0 1 .06-.73 8 8 0 0 1 2.88-1.2m3.12 0q1.58.32 2.88 1.19c.25.17.27.52.06.74a.5.5 0 0 1-.67.05 7 7 0 0 0-2.4-1 .5.5 0 0 1-.43-.5c0-.3.27-.54.56-.48"
]);
const $77e1bce0ac0f7fe7$export$715449ad7d9cba10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf24Filled', "24", [
    "M3.58 6.62a.75.75 0 0 1 1.26.8 8.5 8.5 0 0 0-.27 8.72l.15.27-1.1 3.98 3.98-1.11.27.15a8.5 8.5 0 0 0 8.61-.2.75.75 0 0 1 .79 1.27 10 10 0 0 1-9.86.39L3.6 21.95a1.25 1.25 0 0 1-1.54-1.54L3.1 16.6a10 10 0 0 1 .47-9.97M16.9 17.68a7.5 7.5 0 0 1-8.38.96l-.86-.44-.56.14-1.94.5.65-2.5-.45-.85-.2-.4A7.5 7.5 0 0 1 6.4 7zm3.38-3.73a.75.75 0 0 1 1.46.34 10 10 0 0 1-1.3 3.09.75.75 0 0 1-1.27-.8 9 9 0 0 0 1.11-2.63m-.8-7.46a.75.75 0 0 1 1.03.25q.9 1.44 1.26 3.1a.75.75 0 0 1-1.46.33 9 9 0 0 0-1.07-2.64.75.75 0 0 1 .24-1.04M13.4 2.82c.1-.4.5-.65.9-.56a10 10 0 0 1 3.09 1.3.75.75 0 0 1-.8 1.27 9 9 0 0 0-2.64-1.1.75.75 0 0 1-.55-.91m-3.55-.59a.75.75 0 0 1 .32 1.47Q8.77 4 7.53 4.77a.75.75 0 0 1-.78-1.28q1.44-.88 3.1-1.26"
]);
const $77e1bce0ac0f7fe7$export$f5291f4b936301e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf24Regular', "24", [
    "M3.58 6.62a.75.75 0 0 1 1.26.8 8.5 8.5 0 0 0-.27 8.72l.15.27-1.1 3.98 3.98-1.11.27.15a8.5 8.5 0 0 0 8.61-.2.75.75 0 0 1 .79 1.27 10 10 0 0 1-9.86.39L3.6 21.95a1.25 1.25 0 0 1-1.54-1.54L3.1 16.6a10 10 0 0 1 .47-9.97m16.7 7.33a.75.75 0 0 1 1.46.34 10 10 0 0 1-1.3 3.09.75.75 0 0 1-1.27-.8 9 9 0 0 0 1.11-2.63m-.8-7.46a.75.75 0 0 1 1.03.25q.9 1.44 1.26 3.1a.75.75 0 0 1-1.46.33 9 9 0 0 0-1.07-2.64.75.75 0 0 1 .24-1.04M13.4 2.82c.1-.4.5-.65.9-.56a10 10 0 0 1 3.09 1.3.75.75 0 0 1-.8 1.27 9 9 0 0 0-2.64-1.1.75.75 0 0 1-.55-.91m-3.55-.59a.75.75 0 0 1 .32 1.47Q8.77 4 7.53 4.77a.75.75 0 0 1-.78-1.28q1.44-.88 3.1-1.26"
]);
const $77e1bce0ac0f7fe7$export$37bd94366a91a79d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10q0-.82.16-1.6a.5.5 0 0 1 .61-.4c.31.09.42.4.36.68l-.01.04a7 7 0 0 0 .77 4.7.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 4.26 6H6.5a.5.5 0 0 1 0 .99h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.2A8 8 0 0 1 10 2M4.34 8A6 6 0 0 0 4 9.98v.28l.03.31q.1 1.13.6 2.13l.42.78-.49 1.96 1.97-.5.78.42Q8.56 16 10 16A6 6 0 1 0 6.67 5a1.5 1.5 0 0 1-.17 3zM10 7.5V11h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0"
]);
const $77e1bce0ac0f7fe7$export$2beb2520a00c22b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10q0-.82.16-1.6a.5.5 0 0 1 .61-.4c.31.09.42.4.36.68l-.01.04a7 7 0 0 0 .77 4.7.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 4.26 6H6.5a.5.5 0 0 1 0 .99h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.2A8 8 0 0 1 10 2m0 5.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10z"
]);
const $77e1bce0ac0f7fe7$export$81a07057e33f92f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory24Filled', "24", [
    "M22 12A10 10 0 0 0 5 4.86V3.75a.75.75 0 0 0-1.5 0v3.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H5.52a8.5 8.5 0 1 1 2.35 12.93l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 0 1-.84-6.1c.08-.3.06-.89-.54-1.02-.61-.14-.87.35-.93.72a10 10 0 0 0 .85 6.85l-1.06 3.83a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12M8.17 5.55a7.5 7.5 0 1 1 .18 13l-.62-.34-2.68.74.75-2.67-.35-.63a7.5 7.5 0 0 1-.75-5.37A2 2 0 0 0 4.6 9h3.15a1.75 1.75 0 0 0 .42-3.45M11.25 8a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5H12V8.75a.75.75 0 0 0-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$8c0a6a0f0a2b2351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory24Regular', "24", [
    "M22 12A10 10 0 0 0 5 4.86V3.75a.75.75 0 0 0-1.5 0v3.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H5.52a8.5 8.5 0 1 1 2.35 12.93l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 0 1-.84-6.1c.08-.3.06-.89-.54-1.02-.61-.14-.87.35-.93.72a10 10 0 0 0 .85 6.85l-1.06 3.83a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12M12 8.75a.75.75 0 0 0-1.5 0v4.5c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5H12z"
]);
const $77e1bce0ac0f7fe7$export$aa5a05e47898beb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory28Filled', "28", [
    "M5.5 4.25v1.28A12 12 0 1 1 8.36 24.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 2.17 12c.25-1.31.6-2.18 1.33-1.97.7.2.51.84.32 1.5l-.14.52a10.6 10.6 0 0 0 1.18 7.13q.15.27.07.57L3.61 24.4l4.64-1.32q.3-.08.57.07A10.5 10.5 0 1 0 5.75 7.5h3a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 4 8.25v-4a.75.75 0 0 1 1.5 0M8.75 6.5h-.58a9.5 9.5 0 1 1 1.15 15.77c-.4-.23-.9-.3-1.34-.16l-2.91.82.82-2.9c.13-.45.07-.94-.16-1.35a9.5 9.5 0 0 1-.95-6.87l.02-.06c.08-.28.22-.76.2-1.2a2 2 0 0 0-.13-.55h3.88a1.75 1.75 0 1 0 0-3.5M14 9.75a.75.75 0 0 0-1.5 0v6c0 .41.34.75.75.75h4a.75.75 0 0 0 0-1.5H14z"
]);
const $77e1bce0ac0f7fe7$export$2f9769b66ea7cd52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory28Regular', "28", [
    "M5.5 5.53V4.25a.75.75 0 0 0-1.5 0v4c0 .41.34.75.75.75h4a.75.75 0 0 0 0-1.5h-3a10.5 10.5 0 1 1 3.07 15.64.8.8 0 0 0-.57-.07L3.6 24.39l1.32-4.64q.08-.3-.07-.57a10.5 10.5 0 0 1-1.18-7.13l.14-.52c.2-.66.38-1.3-.32-1.5-.72-.21-1.08.66-1.33 1.97a12 12 0 0 0 1.24 7.64l-1.36 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35A12 12 0 1 0 5.5 5.53M13.25 9c.41 0 .75.34.75.75V15h3.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75v-6c0-.41.34-.75.75-.75"
]);
const $77e1bce0ac0f7fe7$export$43aa8aafd43e9252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock16Filled', "16", [
    "M8 1a7 7 0 0 1 7 7v.26a2 2 0 0 0-.5-.2V8a3 3 0 1 0-6 0v.06A2 2 0 0 0 7 10v4a2 2 0 0 0 .24.96q-1.52-.18-2.78-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m3.5 5a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5V8c0-1.1.9-2 2-2m0 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-4.25a1 1 0 0 0-1 1v1h2V8a1 1 0 0 0-1-1"
]);
const $77e1bce0ac0f7fe7$export$8e7824cc01c397f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock16Regular', "16", [
    "M8 1a7 7 0 0 1 7 7v.26a2 2 0 0 0-.5-.2V8c0-.83-.34-1.59-.9-2.13A6 6 0 1 0 2.94 11.2q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06 1 .64 2.21.84V14a2 2 0 0 0 .24.96q-1.52-.18-2.78-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m3.5 5a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5V8c0-1.1.9-2 2-2m0 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-4.25a1 1 0 0 0-1 1v1h2V8a1 1 0 0 0-1-1"
]);
const $77e1bce0ac0f7fe7$export$a920119f100f975c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 4.61.8V14a2 2 0 0 1 1.5-1.94V12a3 3 0 0 1 5.5-1.67zm-4.5 2v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$bee39e0d1682b3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock20Regular', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 4.61.8v-1.01a7 7 0 0 1-4.42-.82l-.09-.04-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27 7 7 0 1 1 13.08-4.04q.62.36 1.02.95zm-4.5 2v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$d8b57a3602f8d695 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12a10 10 0 0 0 5.68 1.09 3 3 0 0 1-.04-.45v-5a2.5 2.5 0 0 1 2-2.45V14a3.5 3.5 0 0 1 6.92-.74Q22 12.65 22 12m-6 3h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-5 0zm1.5-1a1 1 0 1 1 2 0v1h-2zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $77e1bce0ac0f7fe7$export$69df91f684d6a8bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock24Regular', "24", [
    "M22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07a10 10 0 0 0 5.63 1.06 3 3 0 0 1-.04-.45v-1.06a8.6 8.6 0 0 1-5.13-1.01l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 1 1 15.88-5.04 3.5 3.5 0 0 1 1.47 2.16Q22 12.65 22 12m-6 3h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-5 0zm1.5-1a1 1 0 1 1 2 0v1h-2zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $77e1bce0ac0f7fe7$export$f216205bfff363e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock28Filled', "28", [
    "M14 2A12 12 0 0 0 3.4 19.64l-1.35 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35a12 12 0 0 0 6.8 1.35A3 3 0 0 1 15 25v-5a3 3 0 0 1 2.5-2.96V17a4 4 0 0 1 8 0v.04l.1.02A12.02 12.02 0 0 0 14 2m4.5 16H18a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-.5v-1a3 3 0 1 0-6 0zm1.5-1a1.5 1.5 0 0 1 3 0v1h-3zm3 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $77e1bce0ac0f7fe7$export$68fdb4933134e0e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock28Regular', "28", [
    "M14 24.5c-1.78 0-3.46-.44-4.93-1.23a1.5 1.5 0 0 0-1.12-.12L3.61 24.4l1.24-4.34q.15-.58-.12-1.12a10.5 10.5 0 1 1 19.77-4.59c.62.71 1 1.64 1 2.66v.04l.1.02A12.02 12.02 0 0 0 14 2 12 12 0 0 0 3.4 19.64l-1.35 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35a12 12 0 0 0 6.8 1.35A3 3 0 0 1 15 25v-.55q-.5.05-1 .05m4.5-6.5H18a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-.5v-1a3 3 0 1 0-6 0zm1.5-1a1.5 1.5 0 0 1 3 0v1h-3zm3 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $77e1bce0ac0f7fe7$export$56fb7398967aea23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMail20Filled', "20", [
    "M2 7a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A6 6 0 0 1 2 7m4.5-1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm2 2h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1",
    "m12.28 14.95-2.4-1.2q.65-.19 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 0 0-1-1h-1.67q.23-.48.38-1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.07q.5.07 1 .07v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.2l-4.28 2.15a.5.5 0 0 1-.44 0"
]);
const $77e1bce0ac0f7fe7$export$8bac20b3f2f5722e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMail20Regular', "20", [
    "M6 6c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 6m.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2q1.34.8 3 .81A6 6 0 0 0 8 1M3 7a5 5 0 1 1 2.33 4.23.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A5 5 0 0 1 3 7m9.28 7.95-2.4-1.2q.65-.19 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 0 0-1-1h-1.67q.23-.48.38-1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.07q.5.07 1 .07v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.2l-4.28 2.15a.5.5 0 0 1-.44 0"
]);
const $77e1bce0ac0f7fe7$export$fbadb733dfb3381a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMore16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_16_color__a)",
            "d": "M8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2q1.34.8 3 .81A6 6 0 0 0 8 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_16_color__b)",
            "d": "M6 7c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7m.5 1.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_16_color__a",
                "x1": "2.43",
                "x2": "12.9",
                "y1": "4.25",
                "y2": "22.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_16_color__b",
                "x1": "6.35",
                "x2": "6.73",
                "y1": "6.55",
                "y2": "9.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$8d76900af933cc72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMore20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_20_color__a)",
            "d": "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_20_color__b)",
            "d": "M10.5 11H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 0-1zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_20_color__a",
                "x1": "2.57",
                "x2": "16.54",
                "y1": "5",
                "y2": "28.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_20_color__b",
                "x1": "7.52",
                "x2": "7.97",
                "y1": "8.07",
                "y2": "12.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$a55ad55710bb96d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMore24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_24_color__a)",
            "d": "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_more_24_color__b)",
            "d": "M13.25 13h-4.6a.75.75 0 0 0 0 1.5h4.7a.75.75 0 0 0 0-1.5zm2-3.5h-6.6a.75.75 0 0 0 0 1.5h6.7a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_24_color__a",
                "x1": "2.71",
                "x2": "20.18",
                "y1": "5.75",
                "y2": "35.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_more_24_color__b",
                "x1": "8.7",
                "x2": "9.23",
                "y1": "9.59",
                "y2": "15.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$462597e552ea9638 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple12Filled', "12", [
    "M9.95 4.3a4 4 0 0 1 .55 4.63l.47 1.41a.5.5 0 0 1-.63.63l-1.41-.47a4 4 0 0 1-4.63-.55 5 5 0 0 0 1.83-.08 3 3 0 0 0 2.47-.33.5.5 0 0 1 .43-.06l.68.23-.23-.68a.5.5 0 0 1 .06-.43 3 3 0 0 0 .33-2.47 5 5 0 0 0 .08-1.83M5 1a4 4 0 1 1-1.93 7.5l-1.41.47a.5.5 0 0 1-.63-.63l.47-1.41A4 4 0 0 1 5 1"
]);
const $77e1bce0ac0f7fe7$export$11fa33499114c562 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple12Regular', "12", [
    "M9.95 4.3a4 4 0 0 1 .55 4.63l.47 1.41a.5.5 0 0 1-.63.63l-1.41-.47a4 4 0 0 1-4.63-.55 5 5 0 0 0 1.83-.08 3 3 0 0 0 2.47-.33.5.5 0 0 1 .43-.06l.68.23-.23-.68a.5.5 0 0 1 .06-.43 3 3 0 0 0 .33-2.47 5 5 0 0 0 .08-1.83M5 1a4 4 0 1 1-1.93 7.5l-1.41.47a.5.5 0 0 1-.63-.63l.47-1.41A4 4 0 0 1 5 1m0 1a3 3 0 0 0-2.54 4.6q.12.2.06.43l-.23.68.68-.23a.5.5 0 0 1 .43.06q.7.45 1.6.46a3 3 0 1 0 0-6"
]);
const $77e1bce0ac0f7fe7$export$875ace76933778e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_16_color__a)",
            "d": "M9 4a5 5 0 0 1 4.53 7.11l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46A4.98 4.98 0 0 1 4 9a5 5 0 0 1 5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_16_color__b)",
            "d": "M7 2a5 5 0 0 0-4.53 7.11L2 11.41a.5.5 0 0 0 .59.58l2.29-.46A4.98 4.98 0 0 0 12 7a5 5 0 0 0-5-5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_multiple_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(49.24 -3.93 10.63)scale(7.04808 7.0541)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_multiple_16_color__b",
                "x1": "2",
                "x2": "12",
                "y1": "2",
                "y2": "12",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$32d43a6ffb7e389f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple16Filled', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1"
]);
const $77e1bce0ac0f7fe7$export$288ae28c1ccbbafa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple16Regular', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 1a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05A5 5 0 1 0 7 2"
]);
const $77e1bce0ac0f7fe7$export$b70f24c4e5ee8775 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_20_color__a)",
            "d": "M11.5 5a6.5 6.5 0 0 1 5.67 9.67l.8 2.08a1 1 0 0 1-1.2 1.32l-2.5-.7q-1.27.61-2.77.63a6.5 6.5 0 1 1 0-13"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_20_color__b)",
            "d": "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_multiple_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 7 -7 6 8.5 8.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_multiple_20_color__b",
                "x1": "2",
                "x2": "15.11",
                "y1": "2",
                "y2": "15.04",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$413df688f1311942 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple20Filled', "20", [
    "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $77e1bce0ac0f7fe7$export$7a72d50817a7f886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple20Regular', "20", [
    "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7q1.27.62 2.78.63a6.5 6.5 0 1 0 0-13m-5.5 6.5a5.5 5.5 0 1 1 3 4.9l-.18-.09-2.86.8.97-2.53-.13-.21a5.5 5.5 0 0 1-.8-2.87M11.5 18a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $77e1bce0ac0f7fe7$export$27a756491409442f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_24_color__a)",
            "fillRule": "evenodd",
            "d": "M22 13.5a7.5 7.5 0 1 0-4.41 6.84c1.26.29 2.61.54 3.24.65a1 1 0 0 0 1.15-1.17 68 68 0 0 0-.68-3.15q.69-1.46.7-3.17M14.52 18h-.04.04",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_chat_multiple_24_color__b)",
            "fillRule": "evenodd",
            "d": "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 2 10.5M9.48 15h.04-.04",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_chat_multiple_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(49.24 -5.4 17.03)scale(10.5735 10.5821)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#3d35b1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#6553c9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7660d3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_chat_multiple_24_color__b",
                "x1": "2",
                "x2": "17",
                "y1": "3",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$24e313a898e43541 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple24Filled', "24", [
    "M9.5 3a7.5 7.5 0 0 0-6.8 10.67 68 68 0 0 0-.68 3.15 1 1 0 0 0 1.15 1.17c.63-.11 1.98-.36 3.24-.65q1.43.64 3.09.66a7.5 7.5 0 0 0 0-15m-.04 16a7.5 7.5 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8q.69-1.47.7-3.18a7.5 7.5 0 0 0-5.04-7.09q.53.96.8 2.05a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.13a6 6 0 0 1-5.59-.14 9 9 0 0 1-2.18.26"
]);
const $77e1bce0ac0f7fe7$export$b61ab4d7d48c2b50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple24Regular', "24", [
    "M9.56 3a7.5 7.5 0 0 0-6.8 10.67l-.72 2.84c-.23.92.59 1.75 1.5 1.53l2.93-.7q1.44.64 3.1.66a7.5 7.5 0 0 0 0-15m-6 7.5a6 6 0 1 1 3.33 5.37l-.24-.12-.27.07-2.78.66.69-2.7.07-.28-.13-.25a6 6 0 0 1-.67-2.75m11 10.5a7.5 7.5 0 0 1-5.1-2 8 8 0 0 0 2.18-.26 6 6 0 0 0 5.6.13l.24-.12.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8 8 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63q-1.43.64-3.09.66"
]);
const $77e1bce0ac0f7fe7$export$b7055ecad625f999 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple28Filled', "28", [
    "M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3m6 22a9 9 0 0 1-6.73-3.03 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55q.89-1.62.91-3.59a7.5 7.5 0 0 0-3.83-6.54 10 10 0 0 0-.74-1.97 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A9 9 0 0 1 17 25"
]);
const $77e1bce0ac0f7fe7$export$65b8fc3eaceb4e93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple28Regular', "28", [
    "M3.5 12a7.5 7.5 0 1 1 3.9 6.59.8.8 0 0 0-.54-.07l-3.26.87.88-3.25a.8.8 0 0 0-.07-.55A7.5 7.5 0 0 1 3.5 12M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3m6 22a9 9 0 0 1-6.73-3.03 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55q.89-1.62.91-3.59a7.5 7.5 0 0 0-3.83-6.54 10 10 0 0 0-.74-1.97 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A9 9 0 0 1 17 25"
]);
const $77e1bce0ac0f7fe7$export$592909d3c5cbc12c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple32Filled', "32", [
    "M2 13.5a10.5 10.5 0 1 1 5.8 9.4L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.4 10.4 0 0 1 2 13.5m10.5 12q1 0 1.95-.16a8.5 8.5 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08q-.24-1.42-.8-2.7a10.5 10.5 0 0 1 5.36 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42q.42.03.85.03"
]);
const $77e1bce0ac0f7fe7$export$40bf1fae74336a56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple32Regular', "32", [
    "M2 13.5a10.5 10.5 0 1 1 5.8 9.4L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.4 10.4 0 0 1 2 13.5m2 0c0 1.48.38 2.88 1.05 4.09a1 1 0 0 1 .09.74l-.93 3.46 3.45-.93a1 1 0 0 1 .75.1A8.5 8.5 0 1 0 4 13.5m8.5 12q1 0 1.95-.16a8.5 8.5 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08q-.24-1.42-.8-2.7a10.5 10.5 0 0 1 5.36 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42q.42.03.85.03"
]);
const $77e1bce0ac0f7fe7$export$9adb3a45a642ea20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple48Filled', "48", [
    "M34.52 13.05A15 15 0 0 1 44 27l-.01.51c-.08 2.34-.7 4.56-1.73 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A15 15 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17 17 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67q.47-.27.98-.12l4.92 1.43-1.44-4.92q-.14-.52.12-.97c1-1.73 1.6-3.7 1.66-5.82V27c0-4.47-2.34-8.4-5.88-10.6a17 17 0 0 0-1.1-3.35M19.39 5a15 15 0 0 1 14.6 15v.39a15 15 0 0 1-14.6 14.6l-.4.01c-2.53 0-4.92-.63-7.02-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74a15 15 0 0 1-1.73-6.51V20A15 15 0 0 1 19 5z"
]);
const $77e1bce0ac0f7fe7$export$4cbc3196641c7738 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple48Regular', "48", [
    "M34.51 13.05A15 15 0 0 1 44 27l-.01.51c-.08 2.34-.7 4.56-1.73 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A15 15 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17 17 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67q.47-.27.98-.12l4.92 1.43-1.44-4.92q-.14-.52.12-.97c1-1.73 1.6-3.7 1.66-5.82V27c0-4.47-2.34-8.4-5.88-10.6a17 17 0 0 0-1.1-3.35M19.38 5A15 15 0 0 1 34 20v.39a15 15 0 0 1-14.62 14.6L19 35c-2.54 0-4.93-.63-7.03-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74A15 15 0 0 1 4 20.51L4 20A15 15 0 0 1 19 5zM19 7.5C12.1 7.5 6.5 13.1 6.5 20v.43c.07 2.11.67 4.1 1.67 5.82q.26.46.11.97l-1.43 4.92 4.92-1.43c.32-.1.68-.06.97.12A12.4 12.4 0 0 0 19 32.5h.32a12.5 12.5 0 0 0 0-25z"
]);
const $77e1bce0ac0f7fe7$export$f7c3a58119321541 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark16Filled', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m2.35 4.15a.5.5 0 0 0-.7 0L6 7.79 4.85 6.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$258df6ce26548582 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark16Regular', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 1a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05A5 5 0 1 0 7 2m1.65 3.15a.5.5 0 1 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L6 7.79z"
]);
const $77e1bce0ac0f7fe7$export$c73fcf6271a29a11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark20Filled', "20", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17m9.31-1.85a.5.5 0 0 0-.7 0l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L7.4 10.6c.2.2.5.2.7 0l3.25-3.25a.5.5 0 0 0 0-.7M11.5 18a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $77e1bce0ac0f7fe7$export$619154dd8d0b277a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark20Regular', "20", [
    "M11.35 6.65c.2.2.2.5 0 .7L8.1 10.6a.5.5 0 0 1-.7 0L5.65 8.85a.5.5 0 1 1 .7-.7l1.4 1.4 2.9-2.9c.2-.2.5-.2.7 0M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.59 2.5.6a5.5 5.5 0 0 0 0-11M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $77e1bce0ac0f7fe7$export$a7b1960dad3e5835 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark24Filled', "24", [
    "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 2 10.5M13.06 9a.75.75 0 0 0-1.12-1l-3.5 3.94L7 10.64a.75.75 0 0 0-1 1.1l2 1.82a.75.75 0 0 0 1.06-.06zm1.5 12a7.5 7.5 0 0 1-5.1-2 8 8 0 0 0 2.18-.26 6 6 0 0 0 5.6.14l.24-.13.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8 8 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63q-1.43.65-3.09.66"
]);
const $77e1bce0ac0f7fe7$export$479511d6aa1e13bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark24Regular', "24", [
    "M13.06 9a.75.75 0 0 0-1.12-1l-3.5 3.94L7 10.64a.75.75 0 0 0-1 1.1l2 1.82a.75.75 0 0 0 1.06-.06zm-11 1.5a7.5 7.5 0 1 1 4.41 6.84l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84a7.5 7.5 0 0 1-.7-3.17m7.5-6a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.12q1.21.61 2.67.63a6 6 0 1 0 0-12M9.46 19a7.5 7.5 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8q.69-1.47.7-3.18a7.5 7.5 0 0 0-5.04-7.09q.53.96.8 2.05a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.12a6 6 0 0 1-5.59-.13 9 9 0 0 1-2.18.26"
]);
const $77e1bce0ac0f7fe7$export$cd3594f9422232c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark28Filled', "28", [
    "M2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A9 9 0 0 1 2 12m12.22-3.03-4.47 4.47-1.97-1.97-.08-.07a.75.75 0 0 0-.98 1.13l2.5 2.5.08.07c.3.22.71.2.98-.07l5-5 .07-.08a.75.75 0 0 0-1.13-.98m-3.95 13a9 9 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55q.47.95.74 1.98a7.5 7.5 0 0 1 2.92 10.13.8.8 0 0 0-.07.55l.88 3.25-3.26-.87a.8.8 0 0 0-.55.07 7.5 7.5 0 0 1-8.21-.68 10 10 0 0 1-2.11.06"
]);
const $77e1bce0ac0f7fe7$export$9ae26dcebed1ab88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark28Regular', "28", [
    "m14.22 8.97-4.47 4.47-1.97-1.97-.08-.07a.75.75 0 0 0-.98 1.13l2.5 2.5.08.07c.3.22.71.2.98-.07l5-5 .07-.08a.75.75 0 0 0-1.13-.98M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3m0 1.5a7.5 7.5 0 1 1-3.6 14.09.8.8 0 0 0-.54-.07l-3.26.87.88-3.25a.8.8 0 0 0-.07-.55A7.5 7.5 0 0 1 11 4.5M17 25a9 9 0 0 1-6.73-3.03 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55q.89-1.62.91-3.59a7.5 7.5 0 0 0-3.83-6.54 10 10 0 0 0-.74-1.97 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A9 9 0 0 1 17 25"
]);
const $77e1bce0ac0f7fe7$export$b5af111abd998201 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart16Filled', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m2.56 4.44a1.5 1.5 0 0 0-2.12 0L7 5.88l-.44-.44a1.5 1.5 0 1 0-2.12 2.12l2.2 2.2q.16.15.36.15a.5.5 0 0 0 .35-.14l2.21-2.2a1.5 1.5 0 0 0 0-2.13"
]);
const $77e1bce0ac0f7fe7$export$92635e9589cfe9dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart16Regular', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 1a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05A5 5 0 1 0 7 2m.44 3.44a1.5 1.5 0 1 1 2.12 2.12l-2.2 2.2a.5.5 0 0 1-.36.15.5.5 0 0 1-.35-.14l-2.21-2.2a1.5 1.5 0 1 1 2.12-2.13l.44.44z"
]);
const $77e1bce0ac0f7fe7$export$ef8ebeea9962f142 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart20Filled', "20", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17m3.51-2.01a1.9 1.9 0 0 0 0 2.68L8.3 11.9c.12.12.3.12.42 0l2.73-2.73a1.9 1.9 0 0 0-2.7-2.69l-.25.27-.27-.27a1.9 1.9 0 0 0-2.68 0M11.5 18a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $77e1bce0ac0f7fe7$export$73f4eb9bc0b93f20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart20Regular', "20", [
    "M5.55 6.49a1.9 1.9 0 0 1 2.68 0l.27.27.26-.26a1.9 1.9 0 0 1 2.69 2.68l-2.73 2.73a.3.3 0 0 1-.42 0L5.56 9.17a1.9 1.9 0 0 1 0-2.68M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.59 2.5.6a5.5 5.5 0 0 0 0-11M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $77e1bce0ac0f7fe7$export$6ef10af4f3ab9a75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart24Filled', "24", [
    "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 2 10.5m4.34-2.16c-.79.8-.79 2.08 0 2.87l2.95 2.95c.12.12.32.12.44 0l2.93-2.93a2.03 2.03 0 0 0-2.88-2.88l-.28.28-.29-.28c-.8-.8-2.08-.8-2.87 0M14.56 21a7.5 7.5 0 0 1-5.1-2 8 8 0 0 0 2.18-.26 6 6 0 0 0 5.6.14l.24-.13.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8 8 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63q-1.43.65-3.09.66"
]);
const $77e1bce0ac0f7fe7$export$86e9ca0467b7ef72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart24Regular', "24", [
    "M6.34 8.34c.8-.79 2.08-.79 2.87 0l.29.3.28-.29a2.03 2.03 0 0 1 2.88 2.88l-2.93 2.93a.3.3 0 0 1-.44 0L6.35 11.2c-.8-.8-.8-2.08 0-2.87M2.06 10.5a7.5 7.5 0 1 1 4.41 6.84l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84a7.5 7.5 0 0 1-.7-3.17m7.5-6a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.12q1.21.61 2.67.63a6 6 0 1 0 0-12M9.46 19a7.5 7.5 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8q.69-1.47.7-3.18a7.5 7.5 0 0 0-5.04-7.09q.53.96.8 2.05a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.12a6 6 0 0 1-5.59-.13 9 9 0 0 1-2.18.26"
]);
const $77e1bce0ac0f7fe7$export$fed4fc383d15ae56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart28Filled', "28", [
    "M2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A9 9 0 0 1 2 12m4.79-3.2a2.75 2.75 0 0 0 0 3.86l3.93 3.97c.16.16.43.16.59 0l3.9-3.94a2.76 2.76 0 0 0 0-3.87 2.7 2.7 0 0 0-3.84-.01l-.37.38-.38-.38a2.7 2.7 0 0 0-3.83-.01m3.48 13.17a9 9 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55q.47.95.74 1.98a7.5 7.5 0 0 1 2.92 10.13.8.8 0 0 0-.07.55l.88 3.25-3.26-.87a.8.8 0 0 0-.55.07 7.5 7.5 0 0 1-8.21-.68 10 10 0 0 1-2.11.06"
]);
const $77e1bce0ac0f7fe7$export$a7ed9dd1296cf7d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart28Regular', "28", [
    "M6.79 8.8a2.7 2.7 0 0 1 3.83 0l.38.39.37-.38a2.7 2.7 0 0 1 3.83.01 2.76 2.76 0 0 1 .01 3.87l-3.9 3.94a.4.4 0 0 1-.59 0L6.8 12.66a2.75 2.75 0 0 1-.01-3.86M2 12c0 1.45.34 2.82.95 4.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 2 12m9-7.5a7.5 7.5 0 1 1-3.6 14.09.8.8 0 0 0-.54-.07l-3.26.87.88-3.25a.8.8 0 0 0-.07-.55A7.5 7.5 0 0 1 11 4.5m-.73 17.47a9 9 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55q.47.95.74 1.98a7.5 7.5 0 0 1 2.92 10.13.8.8 0 0 0-.07.55l.88 3.25-3.26-.87a.8.8 0 0 0-.55.07 7.5 7.5 0 0 1-8.21-.68 10 10 0 0 1-2.11.06"
]);
const $77e1bce0ac0f7fe7$export$5c2e2f6a78e55d34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart32Filled', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3m1.95 22.34a12 12 0 0 1-2.8.13 10.5 10.5 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.4 10.4 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7q.54 1.3.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.5 8.5 0 0 1-9.14-.62m-2.37-14.96.42.4.4-.4a2.99 2.99 0 0 1 4.23 4.2l-4.29 4.29a.46.46 0 0 1-.65 0l-4.31-4.3a2.96 2.96 0 1 1 4.2-4.2"
]);
const $77e1bce0ac0f7fe7$export$d2c14672915c090d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart32Regular', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3M5.05 17.59a8.5 8.5 0 1 1 3.36 3.36 1 1 0 0 0-.75-.09l-3.45.93.93-3.46a1 1 0 0 0-.1-.74m9.4 7.75a12 12 0 0 1-2.8.13 10.5 10.5 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.4 10.4 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7q.54 1.3.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.5 8.5 0 0 1-9.14-.62m-2.37-14.96a2.96 2.96 0 1 0-4.2 4.19l4.31 4.3c.18.17.47.17.65 0l4.3-4.28a2.99 2.99 0 0 0-4.23-4.2l-.41.4z"
]);
const $77e1bce0ac0f7fe7$export$416725787ce84da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus16Filled', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1M4.5 6.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$1660de87647aa6ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus16Regular', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 1a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05A5 5 0 1 0 7 2m2.5 4.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
]);
const $77e1bce0ac0f7fe7$export$6758dba688b4195f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus20Filled', "20", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M5.5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm6 10a6.5 6.5 0 0 1-4.93-2.26 8 8 0 0 0 1.76.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7q-1.28.61-2.78.63"
]);
const $77e1bce0ac0f7fe7$export$23e81ecda24c5ea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus20Regular', "20", [
    "M5.5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-3.46.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.5 6.5 0 0 1-.83-3.17M8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.59 2.5.6a5.5 5.5 0 0 0 0-11M6.57 15.74a6.5 6.5 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.5 6.5 0 0 0-1.37-8.04q.22.84.24 1.76a5.5 5.5 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.5 5.5 0 0 1-5.67-.4 8 8 0 0 1-1.76-.26"
]);
const $77e1bce0ac0f7fe7$export$4c2afc2f53527d7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus24Filled', "24", [
    "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 2 10.5m4.5-.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM14.56 21a7.5 7.5 0 0 1-5.1-2 8 8 0 0 0 2.18-.26 6 6 0 0 0 5.6.14l.24-.13.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8 8 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63q-1.43.65-3.09.66"
]);
const $77e1bce0ac0f7fe7$export$6613b05dc66edad1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus24Regular', "24", [
    "M6.25 9.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm-4.19 1a7.5 7.5 0 1 1 4.41 6.84l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84a7.5 7.5 0 0 1-.7-3.17m7.5-6a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.12q1.21.61 2.67.63a6 6 0 1 0 0-12M9.46 19a7.5 7.5 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8q.69-1.47.7-3.18a7.5 7.5 0 0 0-5.04-7.09q.53.96.8 2.05a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.12a6 6 0 0 1-5.59-.13 9 9 0 0 1-2.18.26"
]);
const $77e1bce0ac0f7fe7$export$4a03a9f825da7c04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus28Filled', "28", [
    "M2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A9 9 0 0 1 2 12m5.5-.75a.75.75 0 0 0 0 1.5H15a.75.75 0 0 0 0-1.5zm2.77 10.72a9 9 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55q.47.95.74 1.98a7.5 7.5 0 0 1 2.92 10.13.8.8 0 0 0-.07.55l.88 3.25-3.26-.87a.8.8 0 0 0-.55.07 7.5 7.5 0 0 1-8.21-.68 10 10 0 0 1-2.11.06"
]);
const $77e1bce0ac0f7fe7$export$644abb499a1294c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus28Regular', "28", [
    "M7.25 11a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A9 9 0 0 1 2 12m9-7.5a7.5 7.5 0 0 0-6.59 11.09q.15.25.07.55l-.88 3.25 3.26-.87a.8.8 0 0 1 .55.07A7.5 7.5 0 1 0 11 4.5m-.73 17.47a9 9 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55q.47.95.74 1.98a7.5 7.5 0 0 1 2.92 10.13.8.8 0 0 0-.07.55l.88 3.25-3.26-.87a.8.8 0 0 0-.55.07 7.5 7.5 0 0 1-8.21-.68 10 10 0 0 1-2.11.06"
]);
const $77e1bce0ac0f7fe7$export$c0ec5d90cdac3b73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson16Filled', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1M5.5 7a1 1 0 0 0-1 1c0 1.1 1.12 2 2.5 2s2.5-.9 2.5-2a1 1 0 0 0-1-1zM7 3.5A1.25 1.25 0 1 0 7 6a1.25 1.25 0 0 0 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$8b7104f687d3f1be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson16Regular', "16", [
    "M13.82 5.43a6 6 0 0 1 .47 6.4l.7 2.54a.5.5 0 0 1-.65.6L12 14.2a6 6 0 0 1-6.57-.37 7 7 0 0 0 2.66.1 5 5 0 0 0 3.58-.7q.2-.1.43-.05l1.67.56-.5-1.83a.5.5 0 0 1 .05-.39 5 5 0 0 0 .6-3.42 7 7 0 0 0-.1-2.66M7 1a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.69-2.54A6 6 0 0 1 7 1m0 1a5 5 0 0 0-4.32 7.51.5.5 0 0 1 .05.39l-.5 1.83 1.67-.56q.22-.06.43.05A5 5 0 1 0 7 2m1.5 5a1 1 0 0 1 1 1c0 1.1-1.12 2-2.5 2s-2.5-.9-2.5-2a1 1 0 0 1 1-1zM7 3.5A1.25 1.25 0 1 1 7 6a1.25 1.25 0 0 1 0-2.5"
]);
const $77e1bce0ac0f7fe7$export$68f5f283438c36b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson20Filled', "20", [
    "M15.8 6.63a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7a6.5 6.5 0 0 1-7.7-1.63 8 8 0 0 0 1.75.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76M8.54 2a6.5 6.5 0 1 1-2.78 12.38l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08A6.5 6.5 0 0 1 8.53 2M6.75 9c-.69 0-1.25.56-1.25 1.25 0 1.25 1 2.25 3 2.25s3-1 3-2.25c0-.69-.56-1.25-1.25-1.25zM8.5 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$bde8de27401c483 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson20Regular', "20", [
    "M15.8 6.63a6.5 6.5 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7a6.5 6.5 0 0 1-7.7-1.63 8 8 0 0 0 1.75.26 5.5 5.5 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.5 5.5 0 0 0-.16-5.98q-.02-.91-.24-1.76M8.54 2a6.5 6.5 0 1 1-2.78 12.38l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08A6.5 6.5 0 0 1 8.53 2m0 1a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09q1.14.58 2.5.6a5.5 5.5 0 0 0 0-11m1.71 6c.69 0 1.25.56 1.25 1.25 0 1.25-1 2.25-3 2.25s-3-1-3-2.25C5.5 9.56 6.06 9 6.75 9zM8.5 4.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$7716a33c6fde075b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson24Filled', "24", [
    "M17.01 6.41a7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.58 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63A7.5 7.5 0 0 1 9.46 19h.1q1.08 0 2.08-.26a6 6 0 0 0 5.6.14l.23-.13.27.07c.92.22 1.96.44 2.74.6l-.64-2.64-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8 8 0 0 0-.8-2.04M9.5 3a7.5 7.5 0 1 1-3.09 14.34c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 9.5 3m-2 8c-.83 0-1.5.67-1.5 1.5C6 14 7.5 15 9.5 15s3.5-1 3.5-2.5c0-.83-.67-1.5-1.5-1.5zm2-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $77e1bce0ac0f7fe7$export$f841cf43f68ce876 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson24Regular', "24", [
    "M17.01 6.41a7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.58 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63A7.5 7.5 0 0 1 9.46 19h.1q1.09 0 2.08-.26a6 6 0 0 0 5.6.14l.23-.13.27.07c.92.22 1.96.44 2.74.6l-.64-2.64-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 9 9 0 0 0-.8-2.04M9.56 3a7.5 7.5 0 1 1-3.09 14.34l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84A7.5 7.5 0 0 1 9.56 3m0 1.5a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.13q1.21.61 2.67.62a6 6 0 1 0 0-12M11.5 11c.83 0 1.5.67 1.5 1.5C13 14 11.5 15 9.5 15S6 14 6 12.5c0-.83.67-1.5 1.5-1.5zm-2-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $77e1bce0ac0f7fe7$export$6a12aa55cb137b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson28Filled', "28", [
    "M19.93 7.49a9 9 0 0 1 5.12 12.54l.9 3.4c.26.92-.6 1.77-1.53 1.52l-3.38-.9a9 9 0 0 1-10.77-2.08 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 10 10 0 0 0-.75-1.98M11 3a9 9 0 1 1-4.04 17.04l-3.38.91c-.93.25-1.79-.6-1.54-1.53l.91-3.39A9 9 0 0 1 11 3M8.25 13c-.97 0-1.75.78-1.75 1.75C6.5 16.5 8.5 18 11 18s4.5-1.5 4.5-3.25c0-.97-.78-1.75-1.75-1.75zM11 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $77e1bce0ac0f7fe7$export$f4260854a548f274 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson28Regular', "28", [
    "M19.93 7.49a9 9 0 0 1 5.12 12.54l.9 3.4c.26.92-.6 1.77-1.53 1.52l-3.38-.9a9 9 0 0 1-10.77-2.08 10 10 0 0 0 2.1-.06 7.5 7.5 0 0 0 8.22.68q.27-.15.55-.07l3.25.87-.87-3.25a.8.8 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 10 10 0 0 0-.75-1.98M11 3a9 9 0 1 1-4.04 17.04l-3.38.91c-.93.25-1.79-.6-1.54-1.53l.91-3.39A9 9 0 0 1 11 3m0 1.5a7.5 7.5 0 0 0-6.59 11.09q.15.25.07.55l-.88 3.25 3.26-.87a.8.8 0 0 1 .55.07A7.5 7.5 0 1 0 11 4.5m2.75 8.5c.97 0 1.75.78 1.75 1.75 0 1.75-2 3.25-4.5 3.25s-4.5-1.5-4.5-3.25c0-.97.78-1.75 1.75-1.75zM11 6.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $77e1bce0ac0f7fe7$export$fd398b2690689c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson32Filled', "32", [
    "M23.55 8.81a10.5 10.5 0 0 1 5.35 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42 12 12 0 0 0 2.8-.13 8.5 8.5 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08q-.24-1.42-.8-2.7M12.5 3a10.5 10.5 0 1 1-4.7 19.9L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.5 10.5 0 0 1 2 13.5C2 7.7 6.7 3 12.5 3m-3 11a2 2 0 0 0-2 2c0 2 1.5 4 5 4s5-2 5-4a2 2 0 0 0-2-2zm3-7a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5"
]);
const $77e1bce0ac0f7fe7$export$96161dc4fdaf1b62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson32Regular', "32", [
    "M23.55 8.81a10.5 10.5 0 0 1 5.35 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42 12 12 0 0 0 2.8-.13 8.5 8.5 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08q-.24-1.42-.8-2.7M12.5 3a10.5 10.5 0 1 1-4.7 19.9L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.5 10.5 0 0 1 2 13.5C2 7.7 6.7 3 12.5 3m0 2a8.5 8.5 0 0 0-7.45 12.59 1 1 0 0 1 .09.74l-.93 3.46 3.45-.93a1 1 0 0 1 .75.1A8.5 8.5 0 1 0 12.5 5m3 9a2 2 0 0 1 2 2c0 2-1.5 4-5 4s-5-2-5-4c0-1.1.9-2 2-2zm-3-7a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5"
]);
const $77e1bce0ac0f7fe7$export$37b11390fffb679f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson48Filled', "48", [
    "M34.52 13.05A15 15 0 0 1 44 27l-.01.51c-.08 2.34-.7 4.56-1.73 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A15 15 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17 17 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67q.47-.27.98-.12l4.92 1.43-1.44-4.92q-.14-.52.12-.97c1-1.73 1.6-3.7 1.66-5.82V27c0-4.47-2.34-8.4-5.88-10.6a17 17 0 0 0-1.1-3.35M19.39 5a15 15 0 0 1 14.6 15v.39a15 15 0 0 1-14.6 14.6l-.4.01c-2.53 0-4.92-.63-7.02-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74a15 15 0 0 1-1.73-6.51V20A15 15 0 0 1 19 5zM14.5 21a3 3 0 0 0-3 3c0 3 3 5.5 7.5 5.5s7.5-2.5 7.5-5.5a3 3 0 0 0-3-3zM19 11a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
]);
const $77e1bce0ac0f7fe7$export$4de900e7a1fcecb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson48Regular', "48", [
    "M34.52 13.05A15 15 0 0 1 44 27v.51c-.09 2.34-.7 4.56-1.74 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A15 15 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17 17 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67q.47-.27.98-.12l4.92 1.43-1.44-4.92q-.14-.52.12-.97c1-1.73 1.6-3.7 1.66-5.82l.01-.43c0-4.47-2.35-8.4-5.89-10.6a17 17 0 0 0-1.1-3.35M19.38 5A15 15 0 0 1 34 20v.39a15 15 0 0 1-14.62 14.6L19 35c-2.54 0-4.93-.63-7.03-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74a15 15 0 0 1-1.73-6.51L4 20A15 15 0 0 1 19 5zM19 7.5C12.1 7.5 6.5 13.1 6.5 20v.43c.08 2.11.67 4.1 1.67 5.82q.26.46.12.97l-1.44 4.92 4.92-1.43q.51-.15.97.12A12.4 12.4 0 0 0 19 32.5h.32a12.5 12.5 0 0 0 0-25zM23.5 21a3 3 0 0 1 3 3c0 3-3 5.5-7.5 5.5S11.5 27 11.5 24a3 3 0 0 1 3-3zM19 11a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $77e1bce0ac0f7fe7$export$95a72e34df1141b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff16Filled', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7l-1.57-1.56a7 7 0 0 1-8.12.75l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8a7 7 0 0 1 .75-8.12L1.15 1.85a.5.5 0 0 1 0-.7M8 1a7 7 0 0 1 5.9 10.77L9.11 7h1.38a.5.5 0 0 0 0-1H8.12l-3.9-3.9A7 7 0 0 1 8 1M5.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .47-.33L8.29 9zm-.17-2.97A.5.5 0 0 0 5.5 7h.8z"
]);
const $77e1bce0ac0f7fe7$export$a8deb1b9f9689980 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff16Regular', "16", [
    "M1.15 1.15c.2-.2.5-.2.7 0l13 13a.5.5 0 1 1-.7.7l-1.57-1.56a7 7 0 0 1-8.12.75l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8a7 7 0 0 1 .75-8.12L1.15 1.85a.5.5 0 0 1 0-.7m2.27 2.98a6 6 0 0 0-.49 7.08q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 7.08-.49l-2.9-2.9a.5.5 0 0 1-.47.32h-3a.5.5 0 0 1 0-1h2.8l-2-2h-.8a.5.5 0 0 1-.17-.97zM8 1a7 7 0 0 1 5.9 10.77l-.73-.72Q13.98 9.68 14 8a6 6 0 0 0-9.05-5.17l-.72-.73A7 7 0 0 1 8 1m2.5 5a.5.5 0 1 1 0 1H9.12l-1-1z"
]);
const $77e1bce0ac0f7fe7$export$e5f42fb89fa06971 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff20Filled', "20", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7L4.71 4 16 15.3l1.85 1.85a.5.5 0 0 1-.7.7L15.29 16a8 8 0 0 1-8.9 1.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3m6.97 6.98-.68-.68H7.41a.5.5 0 0 0 0 1h3.18a.5.5 0 0 0 .38-.32M8.29 9l-.97-.97a.5.5 0 0 0 .09.96L7.5 9z",
    "M12.5 9h-1.38l5.5 5.5A8 8 0 0 0 5.5 3.39L10.11 8h2.47a.5.5 0 0 1 0 1z"
]);
const $77e1bce0ac0f7fe7$export$988de9a26c4ea5a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff20Regular', "20", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7L4.71 4l.7.7 9.88 9.88.7.71 1.86 1.86a.5.5 0 0 1-.7.7L15.29 16a8 8 0 0 1-8.9 1.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3m10.58 10.6-3.61-3.62a.5.5 0 0 1-.38.31l-.09.01h-3a.5.5 0 0 1-.09-1h2.89l-2-2h-.8a.5.5 0 0 1-.18-.97L4.71 5.42a7 7 0 0 0-.82 8 .5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04a7 7 0 0 0 8-.82",
    "m16.62 14.5-.72-.73A7 7 0 0 0 6.23 4.1l-.73-.72A8 8 0 0 1 16.61 14.5",
    "M12.5 9h-1.38l-1-1h2.38a.5.5 0 0 1 .09 1z"
]);
const $77e1bce0ac0f7fe7$export$3426ddaaa38aefb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l2.2 2.2a10 10 0 0 0-1.28 11.17l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12a10 10 0 0 0 11.16-1.28l2.2 2.2a.75.75 0 0 0 1.06-1.06zm10.14 12.26-.07.01-.1.01h-4.6a.75.75 0 0 1 0-1.5h3.29zM9.94 11H8.65a.75.75 0 0 1-.16-1.45z",
    "M15.25 11h-1.07l6.3 6.3A10 10 0 0 0 6.7 3.52l5.98 5.98h2.67a.75.75 0 0 1 0 1.5z"
]);
const $77e1bce0ac0f7fe7$export$f2041738c355bbae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l2.2 2.2a10 10 0 0 0-1.3 11.11l-1.07 3.83a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07a10 10 0 0 0 11.11-1.3l2.2 2.19a.75.75 0 0 0 1.06-1.06zm14.18 16.3a8.5 8.5 0 0 1-9.6.91l-.26-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 0 1 .91-9.6l3 3A.75.75 0 0 0 8.76 11h1.19l2 2H8.65a.75.75 0 0 0 .1 1.5h4.6l.07-.02z",
    "M15.25 9.5h-2.57l1.5 1.5h1.17a.75.75 0 0 0-.1-1.5",
    "M20.5 12c0 1.53-.4 2.97-1.11 4.2l1.1 1.1A10 10 0 0 0 6.7 3.52l1.08 1.1A8.5 8.5 0 0 1 20.5 12"
]);
const $77e1bce0ac0f7fe7$export$c42e0850233f0b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatPerson20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.64-.06-.12A8 8 0 0 1 10 2m-2.5 8c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.62.74.59 1.74.88 2.79.88s2.05-.29 2.79-.88S14 12.62 14 11.5c0-.83-.67-1.5-1.5-1.5zM10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $77e1bce0ac0f7fe7$export$5b7bc2c3cb3f56ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatPerson20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.06-3.65.9a.5.5 0 0 1-.62-.44v-.08l.01-.08.91-3.65-.06-.11A8 8 0 0 1 10 2m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m2.5 7c.83 0 1.5.67 1.5 1.5 0 1.12-.46 2.01-1.21 2.62-.74.59-1.74.88-2.79.88a4.4 4.4 0 0 1-2.79-.88A3.3 3.3 0 0 1 6 11.5c0-.83.67-1.5 1.5-1.5zM10 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $77e1bce0ac0f7fe7$export$37c914c6636dde02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings16Filled', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29 5.5 5.5 0 1 0-7.67 7.67 7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m1.07 5.75a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01l.45-.12a2 2 0 0 0 1.44-2.48L7.9 6.9q.38-.3.82-.5zM10.5 9.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$2992e05589610995 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings16Regular', "16", [
    "M8 1a7 7 0 0 1 6.96 6.29q-.54-.75-1.3-1.3a6 6 0 1 0-10.73 5.22q.12.2.05.42l-.69 2.08 2.08-.7q.23-.06.42.06a6 6 0 0 0 1.2.58q.54.76 1.3 1.31a7 7 0 0 1-2.83-.92l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m1.07 5.75a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01l.45-.12a2 2 0 0 0 1.44-2.48L7.9 6.9q.38-.3.82-.5zM10.5 9.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$533a7a9cd4133861 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a8 8 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m2.07 9.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $77e1bce0ac0f7fe7$export$5a88b2e274a2eebd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings20Regular', "20", [
    "M10 3a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05q1.36.77 3.01.88.28.54.66 1a8 8 0 0 1-3.99-.92L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 1 1 18 10.26q-.46-.39-1-.67A7 7 0 0 0 10 3m2.07 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $77e1bce0ac0f7fe7$export$1e1586590432d485 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings24Filled', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 6.5 6.5 0 0 0-9.19 9.19 10 10 0 0 1-5.42-1.11l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2m2.28 11.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.6-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19s-1.45-.67-1.45-1.5.65-1.5 1.45-1.5"
]);
const $77e1bce0ac0f7fe7$export$43ed5ff73bfa9b21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings24Regular', "24", [
    "M22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07a10 10 0 0 0 5.37 1.08 7 7 0 0 1-1.05-1.47 8.5 8.5 0 0 1-3.86-1.07l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 1 1 15.92-4.4q.82.42 1.48 1.04zm-9.16 4.47a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91l.5.52a2 2 0 0 0 2.9 0l.5-.52q.82.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.67.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8zm6.11 1.03c0-.83-.65-1.5-1.45-1.5s-1.45.67-1.45 1.5.65 1.5 1.45 1.5 1.45-.67 1.45-1.5"
]);
const $77e1bce0ac0f7fe7$export$3c743fb3fbbfbfc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle16Filled', "16", [
    "M8 1q.39 0 .78.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-1.09.34A1.4 1.4 0 0 0 6 3.5q0 .45.26.82t.71.53l1.06.35q.22.06.47.29.16.14.3.47l.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.13.05.22.14.1.1.14.22l.26.8q.15.38.48.62a1.3 1.3 0 0 0 1 .2 7 7 0 0 1-9.3 2.07l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m5.48 5a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.43.43 0 0 1 .2.65.4.4 0 0 1-.2.15l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $77e1bce0ac0f7fe7$export$3f74b99e22c5d6fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle16Regular', "16", [
    "M8 1q.39 0 .78.04a1 1 0 0 1-.29.47q-.2.2-.45.3l-.74.23a6 6 0 0 0-4.37 9.17q.12.2.05.42l-.69 2.08 2.08-.7q.22-.06.42.06a5.97 5.97 0 0 0 7.91-1.35l.06.05a1.3 1.3 0 0 0 1 .2 7 7 0 0 1-9.3 2.07l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m5.48 5a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.43.43 0 0 1 .2.65.4.4 0 0 1-.2.15l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $77e1bce0ac0f7fe7$export$daf609e59deb4b08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle20Filled', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07A8 8 0 0 0 2 10v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 11.37-5.16z"
]);
const $77e1bce0ac0f7fe7$export$7bb457ed46c95eeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle20Regular', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22a7 7 0 0 1-10.2 4.33l-.08-.04-.1-.02h-.18l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07A8 8 0 0 0 2 10v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 11.37-5.16z"
]);
const $77e1bce0ac0f7fe7$export$9bb9615868abba58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle24Filled', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12 2a10 10 0 0 1 2.76.39q-.18.1-.37.17L13.05 3q-.47.16-.77.57a1.57 1.57 0 0 0 0 1.79q.26.42.72.64l1.4.46q.41.14.72.44l.18.1q.19.25.29.55L16 9q.16.47.57.77a1.6 1.6 0 0 0 1.57.12 1.3 1.3 0 0 0 .06 1.4q.25.35.63.49l.79.25q.12.05.22.14t.14.23l.24.76q.15.4.49.65a1.3 1.3 0 0 0 1.09.2 10 10 0 0 1-14.44 6.85l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2"
]);
const $77e1bce0ac0f7fe7$export$2aaa4724198422c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle24Regular', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12 2a10 10 0 0 1 2.76.39q-.18.1-.37.17L13.05 3q-.43.16-.72.5H12a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15a8.5 8.5 0 0 0 12.5-5.96q.14.2.34.34a1.3 1.3 0 0 0 1.09.2A10 10 0 0 1 7.4 20.88L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2"
]);
const $77e1bce0ac0f7fe7$export$5de211489087f9d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle28Filled', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5q-.49.16-.8.59a1.6 1.6 0 0 0 0 1.85q.3.42.78.59l1.56.5a2.3 2.3 0 0 1 1 .73q.24.28.35.64l.5 1.53q.18.49.59.8a1.6 1.6 0 0 0 1.86 0l.13-.11a1.34 1.34 0 0 0 .85 1.66l.94.3q.2.07.34.22t.22.35l.3.92A1.34 1.34 0 0 0 25 15a1.4 1.4 0 0 0 .99-.42A12 12 0 0 1 8.36 24.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2"
]);
const $77e1bce0ac0f7fe7$export$84bc6687161a69bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle28Regular', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.2 3.2 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M14 2a12 12 0 0 1 3.45.5q-.37.35-.84.5l-1.52.5-.12.04Q14.5 3.5 14 3.5a10.5 10.5 0 0 0-9.14 15.68q.15.27.07.57L3.61 24.4l4.64-1.32q.3-.08.57.07a10.5 10.5 0 0 0 15.64-8.25 1.4 1.4 0 0 0 1.53-.31A12 12 0 0 1 8.36 24.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2"
]);
const $77e1bce0ac0f7fe7$export$51cb9aaa44442069 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle32Filled', "32", [
    "M21.49 8.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2l-.55-1.68a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M16 2q2.54.01 4.79.84-.15.31-.39.56-.32.33-.76.48L18 4.44a2.2 2.2 0 0 0-1.5 2.06 2.2 2.2 0 0 0 1.45 2l1.71.56c.36.12.71.35.93.66q.2.26.31.58l.55 1.7a2.16 2.16 0 0 0 3.3 1.08 2 2 0 0 0-.25.9 1.8 1.8 0 0 0 1.24 1.75l1 .3.14.11q.07.07.09.15l.3.91a2 2 0 0 0 .69.94 1.9 1.9 0 0 0 1.85.17A14 14 0 0 1 9.44 28.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2"
]);
const $77e1bce0ac0f7fe7$export$c3f8fc6fcdb1f9eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle32Regular', "32", [
    "M21.49 8.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2l-.55-1.68a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M16 2q2.54.01 4.79.84-.15.31-.39.56-.32.33-.76.48l-1.13.38Q17.3 4 16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1 12 12 0 0 0 17.77-8.4l.13.11a1.9 1.9 0 0 0 1.85.17A14 14 0 0 1 9.44 28.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2"
]);
const $77e1bce0ac0f7fe7$export$d6969e4836b59323 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle48Filled', "48", [
    "M31.83 13.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L43 16.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM29.93 5l.08-.08a20 20 0 0 0-23.6 28.6l-2.34 8.25a1.75 1.75 0 0 0 2.16 2.16l8.24-2.34a20 20 0 0 0 29.36-14.97 2.6 2.6 0 0 1-2.83-.08 2.5 2.5 0 0 1-.89-1.35l-.44-1.37a1 1 0 0 0-.4-.48l-.12-.06-1.42-.46a2.55 2.55 0 0 1-1.7-2.4q0-.52.22-1a3 3 0 0 1-4.59-1.51l-.84-2.59a3.2 3.2 0 0 0-2.17-2.11L26 12.35a3 3 0 0 1-1.44-4.58q.57-.8 1.51-1.12l2.57-.83q.74-.26 1.29-.82"
]);
const $77e1bce0ac0f7fe7$export$cef917c35bb6a3c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle48Regular', "48", [
    "M31.83 13.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m14.78 6.87-1.38-.44a2.8 2.8 0 0 1-1.8-1.8L43 16.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45q.23.08.44.18v.02a2.8 2.8 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03zM24 4a20 20 0 0 1 6.01.92l-.08.08q-.55.56-1.29.82l-2.5.8Q25.08 6.5 24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11q.51-.14.97.12a17.5 17.5 0 0 0 26.04-12.44 2.6 2.6 0 0 0 2.54-.1 20 20 0 0 1-29.36 14.97l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4"
]);
const $77e1bce0ac0f7fe7$export$c7fed079b97079ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38q.15 1.53.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10M6 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm7.15-.15a.5.5 0 0 1 .85.36v3.58a.5.5 0 0 1-.85.36L12 11V9z"
]);
const $77e1bce0ac0f7fe7$export$3a1874985925af56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo20Regular', "20", [
    "M6 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm6 1 1.15-1.15a.5.5 0 0 1 .85.36v3.58a.5.5 0 0 1-.85.36L12 11zm-2-7a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3"
]);
const $77e1bce0ac0f7fe7$export$c674bec42c5f8ddf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12A10 10 0 0 0 22 12M12 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2zm3 5.16v-2.32l1.73-1.64a.75.75 0 0 1 1.27.54v4.52c0 .66-.79 1-1.27.54z"
]);
const $77e1bce0ac0f7fe7$export$328e14ceeeb7ea5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo24Regular', "24", [
    "M12 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2zm3 5.16v-2.32l1.73-1.64a.75.75 0 0 1 1.27.54v4.52c0 .66-.79 1-1.27.54zM22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12M3.5 12a8.5 8.5 0 1 1 4.37 7.43l-.27-.15-3.99 1.11 1.11-3.98-.15-.27A8.5 8.5 0 0 1 3.5 12"
]);
const $77e1bce0ac0f7fe7$export$c8b18a4b4d00e101 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning16Filled', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 9a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-5.5a.5.5 0 0 0-.5.5v3.59a.5.5 0 0 0 1-.09V4.91A.5.5 0 0 0 8 4.5"
]);
const $77e1bce0ac0f7fe7$export$14d0abdecf5d1a3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning16Regular', "16", [
    "M8 1a7 7 0 1 1-3.54 13.04l-2.8.93a.5.5 0 0 1-.63-.63l.93-2.8A7 7 0 0 1 8 1m0 1a6 6 0 0 0-5.07 9.2q.12.2.05.43l-.69 2.08 2.08-.7q.23-.06.42.06A6 6 0 1 0 8 2m0 8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-5.5a.5.5 0 0 1 .5.41V8.5a.5.5 0 0 1-1 .09V5c0-.28.22-.5.5-.5"
]);
const $77e1bce0ac0f7fe7$export$2c899825e892d555 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 3.5a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 1 0V6a.5.5 0 0 0-.5-.5m0 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $77e1bce0ac0f7fe7$export$ccfb2e952f3242ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a8 8 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8m0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75.19-.01.09.02.09.04A7 7 0 1 0 10 3m0 2.5c.28 0 .5.22.5.5v5.5a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5m0 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $77e1bce0ac0f7fe7$export$a278fdafcc136730 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.03l4.29-1.11A10 10 0 0 0 22 12M12 6.5c.41 0 .75.34.75.75v6.25a.75.75 0 0 1-1.5 0V7.25c0-.41.34-.75.75-.75m1 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $77e1bce0ac0f7fe7$export$83805d6781758e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning24Regular', "24", [
    "M12 6.5c.41 0 .75.34.75.75v6.25a.75.75 0 0 1-1.5 0V7.25c0-.41.34-.75.75-.75m0 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2m0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5"
]);
const $77e1bce0ac0f7fe7$export$46d3f2b895feb843 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check20Filled', "20", [
    "M15.88 5H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7.12l-4.44 4.44a1.5 1.5 0 0 1-2.12-2.12zM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5m13.85-5.65a.5.5 0 0 0-.7-.7l-5 5a.5.5 0 0 0 .7.7z"
]);
const $77e1bce0ac0f7fe7$export$40e1fbd66d279874 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check20Regular', "20", [
    "M18 7.12V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h11.88l-1 1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.12zM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5m13.85-6.35c.2.2.2.5 0 .7l-6 6a.5.5 0 0 1-.7-.7l6-6c.2-.2.5-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$9a03e4b20f5fe33f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check24Filled', "24", [
    "M21.77 5.79a.75.75 0 1 0-1.04-1.08l-6.75 6.5a.75.75 0 1 0 1.04 1.08zM18.99 5H4.55A2.55 2.55 0 0 0 2 7.55v6.9C2 15.85 3.14 17 4.55 17h14.9c1.4 0 2.55-1.14 2.55-2.55v-6.9q0-.27-.06-.54l-6.23 6a1.75 1.75 0 0 1-2.42-2.52zM4.5 9.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 3.5c0-.41.34-.75.75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$eed406905ced219c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check24Regular', "24", [
    "M21.78 5.78a.75.75 0 0 0-1.06-1.06l-7.5 7.5a.75.75 0 1 0 1.06 1.06zm.17 1.25q.05.25.05.52v6.9c0 1.4-1.14 2.55-2.55 2.55H4.55A2.55 2.55 0 0 1 2 14.45v-6.9C2 6.15 3.14 5 4.55 5h14.48l-1.5 1.5H4.55c-.58 0-1.05.47-1.05 1.05v6.9c0 .58.47 1.05 1.05 1.05h14.9c.58 0 1.05-.47 1.05-1.05V8.47zM4.5 9.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 3.5c0-.41.34-.75.75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$34004d92a1b1bc13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_16_color__a)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_16_color__b)",
            "d": "m10.85 6.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7 9.29l3.15-3.14a.5.5 0 0 1 .7.7"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_16_color__a",
                "x1": "2.43",
                "x2": "10.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_16_color__b",
                "x1": "6.15",
                "x2": "8.8",
                "y1": "6.35",
                "y2": "14.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$ddc296961e40d14b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox120Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8c.77 0 1.47-.29 2-.76v-.83a1.5 1.5 0 0 1-1.4-2.61l2-1.5q.19-.14.4-.21V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7m3.87 4.2a.5.5 0 0 1 .28.45v5a.5.5 0 0 1-1 0v-4l-1.2.9a.5.5 0 0 1-.6-.8l2-1.5a.5.5 0 0 1 .52-.05"
]);
const $77e1bce0ac0f7fe7$export$f57d2d52cc47345 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox120Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8c.77 0 1.47-.29 2-.76v-.83q-.33.12-.67.08A2 2 0 0 1 14 16H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.75l.6-.45q.19-.14.4-.21V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zm3.87 4.2a.5.5 0 0 1 .28.45v5a.5.5 0 0 1-1 0v-4l-1.2.9a.5.5 0 0 1-.6-.8l2-1.5a.5.5 0 0 1 .52-.05"
]);
const $77e1bce0ac0f7fe7$export$26c4fb6ce6d395f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox124Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5q.97-.02 1.75-.51v-1.66a1.75 1.75 0 0 1-1.84-2.95l2.5-2a2 2 0 0 1 .84-.36V6.25C21 4.45 19.54 3 17.75 3zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06M21 14.54a1 1 0 0 0-.22.12l-2.5 2a.75.75 0 1 0 .94 1.18l1.28-1.03v4.44a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1-.7"
]);
const $77e1bce0ac0f7fe7$export$b015a6ac6a418c2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox124Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5q.97-.02 1.75-.51v-1.66q-.24.12-.5.15-.5.5-1.25.52H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v8.16l.66-.53a2 2 0 0 1 .84-.36V6.25C21 4.45 19.54 3 17.75 3zm11.03 6.28a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0zM21 14.54a1 1 0 0 0-.22.12l-2.5 2a.75.75 0 1 0 .94 1.18l1.28-1.03v4.44a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1-.7"
]);
const $77e1bce0ac0f7fe7$export$c1c5f6675b65d0c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_20_color__a)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_20_color__b)",
            "d": "M13.85 7.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_20_color__a",
                "x1": "3.5",
                "x2": "13.16",
                "y1": "5.63",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_20_color__b",
                "x1": "7.54",
                "x2": "11.07",
                "y1": "7.46",
                "y2": "18.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$48e14e54dca18d2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_24_color__a)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_24_color__b)",
            "d": "m17.28 9.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_24_color__a",
                "x1": "3.64",
                "x2": "16.07",
                "y1": "6.38",
                "y2": "19.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_24_color__b",
                "x1": "8.62",
                "x2": "13.47",
                "y1": "8.63",
                "y2": "24.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$3766828a2cdf841a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox220Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h7.05q.08-.45.4-1 .34-.6 1.04-1.23a1.5 1.5 0 0 1-1.12-2.48A3.5 3.5 0 0 1 15.82 11q.63-.02 1.18.17V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29"
]);
const $77e1bce0ac0f7fe7$export$8a6536ece20fe103 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox220Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h7.05q.08-.45.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5q.53 0 1 .17V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zM15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29"
]);
const $77e1bce0ac0f7fe7$export$e52a5bd321bba7f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox224Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h10c.11-1.86 1.38-2.85 2.1-3.38a1.75 1.75 0 0 1-1.65-2.88 3.8 3.8 0 0 1 3.47-1.18q.42.08.83.29v-7.6C21 4.45 19.54 3 17.75 3zm12.81 15.35c-.7.5-1.7 1.23-1.8 2.65l-.01.25c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5h-2.06a3.5 3.5 0 0 1 1.09-1l.04-.03q.34-.23.72-.56c.5-.46.96-1.08.96-2q0-.96-.5-1.6a2 2 0 0 0-1.27-.76 2.8 2.8 0 0 0-2.54.86.75.75 0 1 0 1.12 1c.27-.3.76-.47 1.13-.4q.26.07.38.22c.09.11.18.31.18.68 0 .55-.35.83-1.19 1.44m-1.78-9.07-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06"
]);
const $77e1bce0ac0f7fe7$export$18632c6763606f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox224Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h10q.07-.87.4-1.5H6.24c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v7.25a3.5 3.5 0 0 1 1.5.35v-7.6C21 4.45 19.54 3 17.75 3zm11.56 16.5a3 3 0 0 0-.56 1.75c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5h-2.06a3.5 3.5 0 0 1 1.09-1l.04-.03q.34-.23.72-.56c.5-.46.96-1.08.96-2q0-.96-.5-1.6a2 2 0 0 0-1.27-.76 2.82 2.82 0 0 0-2.54.86.75.75 0 1 0 1.12 1 1.3 1.3 0 0 1 1.13-.4q.26.07.38.22c.09.11.18.31.18.68 0 .45-.23.72-.77 1.13q-.19.15-.42.3c-.4.3-.88.65-1.25 1.16m-.53-10.22a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0z"
]);
const $77e1bce0ac0f7fe7$export$5f3303fb4e4a2d5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2A5.5 5.5 0 0 1 16 9.2V5a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $77e1bce0ac0f7fe7$export$119b1753c492bb1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4.02q.51.05 1 .19V5a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0zM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $77e1bce0ac0f7fe7$export$11aea36eb024ed94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight24Filled', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v11.5C2 18.55 3.46 20 5.25 20h6.25a6.5 6.5 0 0 1 8.5-8.5V5.25C20 3.45 18.54 2 16.75 2zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L9 13.44l6.22-6.22a.75.75 0 1 1 1.06 1.06M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $77e1bce0ac0f7fe7$export$f20901f0b21c5616 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight24Regular', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v11.5C2 18.55 3.46 20 5.25 20h6.25q-.3-.71-.42-1.5H5.25c-.97 0-1.75-.78-1.75-1.75V5.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v5.83q.79.12 1.5.42V5.25C20 3.45 18.54 2 16.75 2zm11.03 6.28a.75.75 0 1 0-1.06-1.06L9 13.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0zM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17z"
]);
const $77e1bce0ac0f7fe7$export$3221cacdfc23a74b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm6.35 4.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7 9.29l3.15-3.14a.5.5 0 0 1 .7.7"
]);
const $77e1bce0ac0f7fe7$export$ac176cfd9164d78f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zm7.85 2.35a.5.5 0 0 0-.7-.7L7 9.29 5.85 8.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$7afbd228ce7724b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7"
]);
const $77e1bce0ac0f7fe7$export$4163fc3f4a6afc6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm9.85 1.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$c8735a94ad571647 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06"
]);
const $77e1bce0ac0f7fe7$export$c9f70fc1b1a87bbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75zm12.78 3.03a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0z"
]);
const $77e1bce0ac0f7fe7$export$4b55059290401a13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync16Filled', "16", [
    "M2.5 0A2.5 2.5 0 0 0 0 2.5v7A2.5 2.5 0 0 0 2.5 12h3.52L6 11.5a5.5 5.5 0 0 1 6-5.48V2.5A2.5 2.5 0 0 0 9.5 0zm6.35 4.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L5 7.29l3.15-3.14a.5.5 0 1 1 .7.7M7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $77e1bce0ac0f7fe7$export$46033ebfd01b1261 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync16Regular', "16", [
    "M2.5 0A2.5 2.5 0 0 0 0 2.5v7A2.5 2.5 0 0 0 2.5 12h3.52a6 6 0 0 1 0-1H2.5A1.5 1.5 0 0 1 1 9.5v-7C1 1.67 1.67 1 2.5 1h7c.83 0 1.5.67 1.5 1.5v3.52a6 6 0 0 1 1 0V2.5A2.5 2.5 0 0 0 9.5 0zm6.35 4.85a.5.5 0 1 0-.7-.7L5 7.29 3.85 6.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $77e1bce0ac0f7fe7$export$901736fdd14acd50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2A5.5 5.5 0 0 1 16 9.2V5a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $77e1bce0ac0f7fe7$export$3e6c3906e9a83976 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2q-.13-.49-.18-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4.02q.51.05 1 .19V5a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0zM10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $77e1bce0ac0f7fe7$export$981bf28810402867 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm-1 2.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1zm2 .5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$8cefe2ba281c6a58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5zM5 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$bde9ff718393ca4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4.5 6c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H6A1.5 1.5 0 0 1 4.5 14zM7 6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$2c0315ead1e5e105 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2.5-1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$8465c0eb67c8226e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM5 6.25C5 5.56 5.56 5 6.25 5h11.5c.69 0 1.25.56 1.25 1.25v11.5c0 .69-.56 1.25-1.25 1.25H6.25C5.56 19 5 18.44 5 17.75zm2.5.25a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$e02915b90ee5e8f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75zM7.25 6C6.56 6 6 6.56 6 7.25v9.5c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25v-9.5C18 6.56 17.44 6 16.75 6z"
]);
const $77e1bce0ac0f7fe7$export$6c79b8e125a62bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__a)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__b)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__c)",
            "d": "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__d)",
            "d": "m10.85 6.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7 9.29l3.15-3.14a.5.5 0 0 1 .7.7"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__e)",
            "d": "M16 13.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__f)",
            "d": "M16 13.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_16_color__g)",
            "d": "M14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__a",
                "x1": "2.43",
                "x2": "10.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__d",
                "x1": "6.15",
                "x2": "8.8",
                "y1": "6.35",
                "y2": "14.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__e",
                "x1": "10.66",
                "x2": "12.1",
                "y1": "12.53",
                "y2": "16.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__f",
                "x1": "12.5",
                "x2": "14.53",
                "y1": "11.52",
                "y2": "18.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__g",
                "x1": "11.45",
                "x2": "13.49",
                "y1": "7.53",
                "y2": "10.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 0 0 3.46354 12.5 13.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.5 -2.5 0 12.5 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$d784ccb2228cbccc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson16Filled', "16", [
    "M3.5 1A2.5 2.5 0 0 0 1 3.5v7A2.5 2.5 0 0 0 3.5 13h4.55a2.5 2.5 0 0 1 2.22-1.99A3 3 0 0 1 13 6.04V3.5A2.5 2.5 0 0 0 10.5 1zm6.35 4.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6 8.29l3.15-3.14a.5.5 0 1 1 .7.7M14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $77e1bce0ac0f7fe7$export$989156c24de2de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson16Regular', "16", [
    "M3.5 1A2.5 2.5 0 0 0 1 3.5v7A2.5 2.5 0 0 0 3.5 13h4.55q.11-.55.45-1h-5A1.5 1.5 0 0 1 2 10.5v-7C2 2.67 2.67 2 3.5 2h7c.83 0 1.5.67 1.5 1.5v2.54a3 3 0 0 1 1 0V3.5A2.5 2.5 0 0 0 10.5 1zm6.35 4.85a.5.5 0 0 0-.7-.7L6 8.29 4.85 7.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $77e1bce0ac0f7fe7$export$2c4ee4a40f37925d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__a)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__b)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__c)",
            "fillRule": "evenodd",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__d)",
            "d": "M13.85 7.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__e)",
            "d": "M19 16.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__f)",
            "d": "M19 16.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_20_color__g)",
            "d": "M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__a",
                "x1": "3.5",
                "x2": "13.16",
                "y1": "5.63",
                "y2": "15.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__d",
                "x1": "7.54",
                "x2": "11.07",
                "y1": "7.46",
                "y2": "18.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__e",
                "x1": "13.66",
                "x2": "15.1",
                "y1": "15.53",
                "y2": "19.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__f",
                "x1": "15.5",
                "x2": "17.53",
                "y1": "14.52",
                "y2": "21.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__g",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "10.53",
                "y2": "13.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6.6292 0 0 4.5921 15.53 16.25)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 1.32 14.13)scale(3.24526)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$a4cc5d996c686a49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.04l-.04-.5c0-1.3 1-2.38 2.27-2.49A2.99 2.99 0 0 1 15.5 9q.83.01 1.5.4V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $77e1bce0ac0f7fe7$export$bbc2e89b68e3cf6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.04a3 3 0 0 1 .01-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.04q.54.1 1 .36V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $77e1bce0ac0f7fe7$export$31d42aa45c581c03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__a)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__b)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__c)",
            "d": "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__d)",
            "d": "m17.28 9.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__e)",
            "d": "M23 19.88c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__f)",
            "d": "M23 19.88c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkbox_person_24_color__g)",
            "d": "M21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__a",
                "x1": "3.64",
                "x2": "16.07",
                "y1": "6.38",
                "y2": "19.28",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__d",
                "x1": "8.62",
                "x2": "13.47",
                "y1": "8.63",
                "y2": "24.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__e",
                "x1": "16.14",
                "x2": "17.9",
                "y1": "18.66",
                "y2": "23.72",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__f",
                "x1": "18.5",
                "x2": "20.97",
                "y1": "17.4",
                "y2": "25.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__g",
                "x1": "17.19",
                "x2": "19.74",
                "y1": "12.66",
                "y2": "16.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8 0 0 5.54167 18.5 20.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": ".91",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_checkbox_person_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 1.5 17)scale(3.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$b061524226690e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h6.92a4 4 0 0 1-.17-1.12v-.1A2.77 2.77 0 0 1 15.77 17h.28a3.49 3.49 0 0 1 2.45-6c.98 0 1.86.4 2.5 1.05v-5.8C21 4.45 19.54 3 17.75 3zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06M21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $77e1bce0ac0f7fe7$export$397d83e9ed1cf29a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h6.92a4 4 0 0 1-.17-1.12v-.1l.01-.28H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v4.9a3.5 3.5 0 0 1 1.5.9v-5.8C21 4.45 19.54 3 17.75 3zm11.03 6.28a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0zM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $77e1bce0ac0f7fe7$export$defa37380057cc99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked12Filled', "12", [
    "M2 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$e2df8e3c56fb7d4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked12Regular', "12", [
    "M2 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$c0e6692b191fd2d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zm2.5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$b9df7686607478b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$fb86162d9555deb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$f27666c2b1a774f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $77e1bce0ac0f7fe7$export$bfd493d27bc7bab5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zM6.25 5C5.56 5 5 5.56 5 6.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V6.25C19 5.56 18.44 5 17.75 5z"
]);
const $77e1bce0ac0f7fe7$export$799dc389d102935a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zM6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75z"
]);
const $77e1bce0ac0f7fe7$export$964c03e09ffcb159 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.27l3.44-6.9a2 2 0 0 1 3.58 0l.71 1.42V6a3 3 0 0 0-3-3zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7m-.25 2.7-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$59b708156d5960eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.27l.5-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.67q.16.19.3.44l.7 1.41V6a3 3 0 0 0-3-3zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zm-.25 2.7-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$7b9cf511bae51a37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h4.8q.07-.31.22-.62l4-8a2.5 2.5 0 0 1 4.47 0L21 14.9V6.25C21 4.45 19.54 3 17.75 3zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06m-1.12 3.55-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$e9e1a1a7029f16da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h4.8q.07-.31.22-.62l.44-.88H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v5.74q.14.18.24.4L21 14.9V6.25C21 4.45 19.54 3 17.75 3zm11.03 6.28a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0zm-1.12 3.55-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$ea97004bee98e8e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark12Filled', "12", [
    "M9.76 3.2c.3.29.32.76.04 1.06l-4.25 4.5a.75.75 0 0 1-1.08.02L2.22 6.53a.75.75 0 0 1 1.06-1.06l1.7 1.7L8.7 3.24a.75.75 0 0 1 1.06-.04"
]);
const $77e1bce0ac0f7fe7$export$515f34a868f2f664 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark12Regular', "12", [
    "M9.85 3.15c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L5 7.29l4.15-4.14c.2-.2.5-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$d958ed78946d42ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark16Filled', "16", [
    "M14.05 3.49c.28.3.27.77-.04 1.06l-7.93 7.47A.85.85 0 0 1 4.9 12L2.22 9.28a.75.75 0 1 1 1.06-1.06l2.24 2.27 7.47-7.04a.75.75 0 0 1 1.06.04"
]);
const $77e1bce0ac0f7fe7$export$7fa2da86ef4db94b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark16Regular', "16", [
    "M13.86 3.66a.5.5 0 0 1-.02.7l-7.93 7.48a.6.6 0 0 1-.84-.02L2.4 9.1a.5.5 0 0 1 .72-.7l2.4 2.44 7.65-7.2a.5.5 0 0 1 .7.02"
]);
const $77e1bce0ac0f7fe7$export$c6c730cc7dfbec73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark20Filled', "20", [
    "M7.03 13.9 3.56 10a.75.75 0 0 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06z"
]);
const $77e1bce0ac0f7fe7$export$2c80ee2f74739ccd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark20Regular', "20", [
    "M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27z"
]);
const $77e1bce0ac0f7fe7$export$40e0285be0ea111d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark24Filled', "24", [
    "m8.5 16.59-3.8-3.8a1 1 0 0 0-1.4 1.42l4.5 4.5a1 1 0 0 0 1.4 0l11-11a1 1 0 0 0-1.4-1.42z"
]);
const $77e1bce0ac0f7fe7$export$c1c7efebde6aa976 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark24Regular', "24", [
    "M4.53 12.97a.75.75 0 0 0-1.06 1.06l4.5 4.5c.3.3.77.3 1.06 0l11-11a.75.75 0 0 0-1.06-1.06L8.5 16.94z"
]);
const $77e1bce0ac0f7fe7$export$fbc3dfef2e71f82e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark28Filled', "28", [
    "m10.5 19.59-6.3-6.3a1 1 0 0 0-1.4 1.42l7 7a1 1 0 0 0 1.4 0l14-14a1 1 0 0 0-1.4-1.42z"
]);
const $77e1bce0ac0f7fe7$export$cff6e9518fed6ecd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark28Regular', "28", [
    "M4.03 13.47a.75.75 0 0 0-1.06 1.06l7 7c.3.3.77.3 1.06 0l14-14a.75.75 0 0 0-1.06-1.06L10.5 19.94z"
]);
const $77e1bce0ac0f7fe7$export$f2111711b82fc63e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark32Filled', "32", [
    "M29.9 5.14c.48.5.46 1.3-.04 1.77l-19 18a1.25 1.25 0 0 1-1.77-.06L2.34 17.6a1.25 1.25 0 0 1 1.82-1.7l5.9 6.33L28.14 5.09c.5-.47 1.3-.45 1.77.05"
]);
const $77e1bce0ac0f7fe7$export$2576c8304bdffdde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark32Light', "32", [
    "M29.85 5.15c.2.2.2.5 0 .7l-19 19a.5.5 0 0 1-.7 0l-8-8a.5.5 0 0 1 .7-.7l7.65 7.64L29.15 5.15c.2-.2.5-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$b0d22be9f84942fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark32Regular', "32", [
    "M29.73 5.31a1 1 0 0 1-.04 1.42l-19 18a1 1 0 0 1-1.42-.05l-7-7.5a1 1 0 1 1 1.46-1.36l6.31 6.76 18.27-17.3a1 1 0 0 1 1.42.03"
]);
const $77e1bce0ac0f7fe7$export$a5effc10870e495c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark48Filled', "48", [
    "M40.32 12.7a1.5 1.5 0 0 1-.02 2.12l-22.25 22a1.5 1.5 0 0 1-2.1 0l-9.25-9a1.5 1.5 0 1 1 2.1-2.15l8.2 7.98 21.2-20.97a1.5 1.5 0 0 1 2.12.02"
]);
const $77e1bce0ac0f7fe7$export$d7be6162f76b15da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark48Regular', "48", [
    "M40.14 12.87c.48.5.48 1.28-.01 1.77l-22.25 22c-.49.48-1.26.48-1.75 0l-9.25-9a1.25 1.25 0 1 1 1.74-1.79L17 34l21.38-21.14c.5-.48 1.28-.48 1.77.01"
]);
const $77e1bce0ac0f7fe7$export$7c4f9b2e13b339fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle12Filled', "12", [
    "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6m7.35-.9a.5.5 0 1 0-.7-.7L5.5 6.54 4.35 5.4a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$9ab2ebacb21926b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle12Regular', "12", [
    "M8.35 5.1a.5.5 0 1 0-.7-.7L5.5 6.54 4.35 5.4a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
]);
const $77e1bce0ac0f7fe7$export$f56a2825a10f121d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_16_color__a)",
            "d": "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_16_color__b)",
            "d": "M10.12 6.16 7.25 9.04l-1.4-1.4a.5.5 0 1 0-.7.71L6.9 10.1c.2.2.5.2.7 0l3.23-3.23a.5.5 0 0 0-.71-.7"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_16_color__a",
                "x1": "2.43",
                "x2": "10.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_16_color__b",
                "x1": "6.12",
                "x2": "7.08",
                "y1": "6.45",
                "y2": "11.21",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$2ba3a0b4e685c4b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle16Filled', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m9.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L6.9 10.1c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$2bd6ba17bb026eaf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1m2.85 5.85a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L6.9 10.1c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$bbd915ec87019f0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_20_color__a)",
            "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_20_color__b)",
            "fillRule": "evenodd",
            "d": "M13.35 7.65c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 11.29l3.65-3.64c.2-.2.5-.2.7 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_20_color__a",
                "x1": "2.57",
                "x2": "13.61",
                "y1": "5",
                "y2": "16.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_20_color__b",
                "x1": "7.81",
                "x2": "8.95",
                "y1": "8.01",
                "y2": "13.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$2e08cd71852e8bd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63"
]);
const $77e1bce0ac0f7fe7$export$e0a0bd9924d25c26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle20Regular', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14m3.36 4.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$64b1a9de151a5fc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_24_color__a)",
            "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_24_color__b)",
            "d": "m15.22 8.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_24_color__a",
                "x1": "2.71",
                "x2": "16.52",
                "y1": "5.75",
                "y2": "20.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_24_color__b",
                "x1": "9.19",
                "x2": "10.68",
                "y1": "9.41",
                "y2": "16.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$17cd49aa44fc764c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06"
]);
const $77e1bce0ac0f7fe7$export$efb54d2bdf5b8f19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m-1.25 9.94 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07zl4.47-4.47z"
]);
const $77e1bce0ac0f7fe7$export$8f735f02223a2796 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle28Filled', "28", [
    "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24m5.53 8.22a.75.75 0 0 0-1.06 0l-5.97 5.97-2.97-2.97a.75.75 0 1 0-1.06 1.06l3.5 3.5c.3.3.77.3 1.06 0l6.5-6.5c.3-.3.3-.77 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$7ef4824714d88e2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle28Regular', "28", [
    "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24m0 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21m4.47 6.72a.75.75 0 0 1 1.06 1.06l-6.5 6.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.97 2.97z"
]);
const $77e1bce0ac0f7fe7$export$67ba6fc685411cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_32_color__a)",
            "d": "M30 16a14 14 0 1 1-28 0 14 14 0 0 1 28 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_32_color__b)",
            "d": "M22.7 12.7a1 1 0 0 0-1.4-1.4l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_32_color__a",
                "x1": "3",
                "x2": "22.32",
                "y1": "7.25",
                "y2": "27.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_32_color__b",
                "x1": "12.03",
                "x2": "14.16",
                "y1": "11.97",
                "y2": "22.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$2b2bab55016df3b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0m20.7-3.3a1 1 0 0 0-1.4-1.4l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0z"
]);
const $77e1bce0ac0f7fe7$export$a860305cb5a0b68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Light', "32", [
    "M3 16a13 13 0 1 1 26 0 13 13 0 0 1-26 0M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28m6.85 10.35a.5.5 0 0 0-.7-.7l-7.65 7.64-3.65-3.64a.5.5 0 0 0-.7.7l4 4c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$4be6bee60ab25878 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Regular', "32", [
    "M22.7 12.7a1 1 0 0 0-1.4-1.4l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0zM16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0"
]);
const $77e1bce0ac0f7fe7$export$73912fa45a949164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_48_color__a)",
            "d": "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_checkmark_circle_48_color__b)",
            "d": "M32.63 17.62c.5.48.5 1.28 0 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61 10.12-10.11a1.25 1.25 0 0 1 1.76 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_48_color__a",
                "x1": "5.43",
                "x2": "33.03",
                "y1": "11.5",
                "y2": "40.18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_checkmark_circle_48_color__b",
                "x1": "18.38",
                "x2": "21.59",
                "y1": "18.63",
                "y2": "33.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$847c1f2c967bd529 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m8.63 13.62a1.25 1.25 0 0 0-1.66-.1l-.1.1-10.12 10.11-3.62-3.61a1.25 1.25 0 0 0-1.85 1.66l.09.1 4.5 4.5c.45.46 1.17.49 1.66.1l.1-.1 11-11c.5-.48.5-1.28 0-1.76"
]);
const $77e1bce0ac0f7fe7$export$dead63c6d32d0315 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle48Regular', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m0 2.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35m8.63 11.12c.5.48.5 1.28 0 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61 10.12-10.11a1.25 1.25 0 0 1 1.76 0"
]);
const $77e1bce0ac0f7fe7$export$fb53b96eccab63bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint16Filled', "16", [
    "M8.74 13.45c.38-.05.76.13.9.48.18.42-.05.9-.5.98a7 7 0 0 1-2.28 0c-.45-.08-.68-.56-.5-.98a.84.84 0 0 1 .9-.48 6 6 0 0 0 1.48 0m-6.1-2.42c.35-.14.75 0 .98.3q.46.6 1.05 1.05c.3.23.44.63.3.98-.18.42-.68.6-1.04.33q-.95-.68-1.62-1.61c-.27-.37-.09-.87.33-1.05m9.74.3c.23-.3.63-.44.98-.3.42.18.6.68.33 1.05q-.68.94-1.62 1.61c-.36.27-.86.09-1.04-.33a.84.84 0 0 1 .3-.98q.6-.46 1.05-1.05M9.97 5.97a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.97 8.53a.75.75 0 0 1 1-1.11l.06.05 1.22 1.22zm-8.88.89c.08-.45.56-.68.97-.5.36.14.54.52.49.9a6 6 0 0 0 0 1.48.84.84 0 0 1-.48.9c-.42.18-.9-.05-.98-.5a7 7 0 0 1 0-2.28m12.85-.5c.41-.18.9.05.97.5a7 7 0 0 1 0 2.29c-.08.44-.56.67-.98.5a.84.84 0 0 1-.48-.9 6 6 0 0 0 0-1.5.84.84 0 0 1 .49-.9M3.93 2.3c.36-.27.86-.09 1.04.33.14.35 0 .75-.3.98q-.6.46-1.05 1.05a.84.84 0 0 1-.98.3c-.42-.17-.6-.68-.33-1.04q.67-.94 1.62-1.62m7.1.33c.18-.42.68-.6 1.04-.33q.95.67 1.62 1.62c.27.36.09.87-.33 1.04a.84.84 0 0 1-.98-.3q-.46-.6-1.05-1.05a.84.84 0 0 1-.3-.98M8 1q.59 0 1.14.1c.45.07.68.55.5.97a.84.84 0 0 1-.9.48 6 6 0 0 0-1.48 0 .84.84 0 0 1-.9-.48c-.18-.42.05-.9.5-.98Q7.4 1 8 1"
]);
const $77e1bce0ac0f7fe7$export$56c8b8a0478583c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint16Regular', "16", [
    "M6.84 13.89a6 6 0 0 0 2.3 0c.26-.05.52.08.61.31.12.28-.03.6-.33.66a7 7 0 0 1-2.85 0 .47.47 0 0 1-.33-.66c.1-.24.36-.36.6-.31m6.14-2.54c.14-.2.4-.3.64-.2.28.1.4.44.23.7a7 7 0 0 1-2.01 2 .48.48 0 0 1-.7-.22c-.1-.24 0-.5.2-.65q.98-.66 1.64-1.63m-10.6-.2c.23-.1.5-.01.64.2q.66.97 1.63 1.63c.2.14.3.4.2.64a.48.48 0 0 1-.7.23 7 7 0 0 1-2-2.01.48.48 0 0 1 .23-.7m7.77-5a.5.5 0 1 1 .7.7L7.6 10.1a.5.5 0 0 1-.7 0L5.15 8.35a.5.5 0 0 1 .63-.77l.07.07 1.4 1.4zm4.05.1c.28-.12.6.03.65.32a7 7 0 0 1 0 2.86.5.5 0 0 1-.65.33.54.54 0 0 1-.31-.6 6 6 0 0 0 0-2.31.54.54 0 0 1 .3-.6m-13.06.33c.07-.3.38-.45.66-.33.23.1.36.35.31.6a6 6 0 0 0 0 2.3c.05.25-.07.5-.3.6a.47.47 0 0 1-.66-.33 7 7 0 0 1 0-2.84m3.02-4.43a.48.48 0 0 1 .7.23c.1.23 0 .5-.21.64q-.97.67-1.63 1.63a.54.54 0 0 1-.65.21.47.47 0 0 1-.23-.7 7 7 0 0 1 2.02-2.01m6.98.22c.11-.27.45-.4.7-.23q1.21.8 2.01 2.02c.17.25.05.58-.23.7-.23.1-.5 0-.64-.21a6 6 0 0 0-1.63-1.63.54.54 0 0 1-.21-.65M8 1q.73 0 1.42.14c.3.07.45.38.33.66a.54.54 0 0 1-.6.31 6 6 0 0 0-2.3 0 .54.54 0 0 1-.6-.3.48.48 0 0 1 .32-.66Q7.27 1 8 1"
]);
const $77e1bce0ac0f7fe7$export$85762b1966445e35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint20Filled', "20", [
    "M11.06 16.41a.75.75 0 0 1 .24 1.48c-.85.14-1.76.14-2.6 0a.75.75 0 0 1 .24-1.48c.69.12 1.43.12 2.12 0m-7.4-2.8a.75.75 0 0 1 1.05.18q.64.86 1.5 1.5a.75.75 0 1 1-.87 1.21 8 8 0 0 1-1.84-1.84.75.75 0 0 1 .17-1.05m11.62.18a.75.75 0 1 1 1.22.87 8 8 0 0 1-1.84 1.84.75.75 0 0 1-.88-1.22 7 7 0 0 0 1.5-1.5m-2.81-6.32a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1-1.11l.06.05L9 10.94zM2.1 8.7a.75.75 0 0 1 1.48.24 7 7 0 0 0 0 2.12.75.75 0 1 1-1.48.24 8 8 0 0 1 0-2.6m14.93-.62c.41-.07.8.2.86.62a8 8 0 0 1 0 2.6.75.75 0 0 1-1.48-.24c.11-.69.11-1.43 0-2.12-.06-.4.21-.8.62-.86M5.33 3.5a.75.75 0 0 1 .88 1.21q-.86.64-1.5 1.5a.75.75 0 1 1-1.21-.87A8 8 0 0 1 5.34 3.5m8.28.17a.75.75 0 0 1 1.05-.17q1.06.76 1.84 1.84a.75.75 0 0 1-1.22.87 7 7 0 0 0-1.5-1.5.75.75 0 0 1-.17-1.04M8.7 2.1a8 8 0 0 1 2.6 0 .75.75 0 0 1-.24 1.48 7 7 0 0 0-2.12 0A.75.75 0 1 1 8.7 2.1"
]);
const $77e1bce0ac0f7fe7$export$78a8ef3973757031 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint20Regular', "20", [
    "M11.37 16.87a.5.5 0 0 1 .2.98 8 8 0 0 1-3.13 0 .5.5 0 1 1 .2-.98 7 7 0 0 0 2.73 0m-7.88-3.12a.5.5 0 0 1 .69.14 7 7 0 0 0 1.93 1.93.5.5 0 0 1-.55.83 8 8 0 0 1-2.21-2.2.5.5 0 0 1 .14-.7m12.33.14a.5.5 0 0 1 .83.55 8 8 0 0 1-2.2 2.21.5.5 0 0 1-.56-.83 7 7 0 0 0 1.93-1.93m-3.17-6.24a.5.5 0 1 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .63-.77l.07.07L9 11.29zm-9.9.4a.5.5 0 0 1 .39.58 7 7 0 0 0 0 2.74.5.5 0 0 1-.99.19 8 8 0 0 1 0-3.12.5.5 0 0 1 .6-.4m14.51 0a.5.5 0 0 1 .59.39 8 8 0 0 1 0 3.12.5.5 0 0 1-.98-.2 7 7 0 0 0 0-2.73.5.5 0 0 1 .4-.58m-11.7-4.7a.5.5 0 0 1 .55.83A7 7 0 0 0 4.18 6.1a.5.5 0 0 1-.83-.56 8 8 0 0 1 2.2-2.2m8.2.13a.5.5 0 0 1 .69-.13 8 8 0 0 1 2.2 2.2.5.5 0 0 1-.83.56 7 7 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7M8.43 2.15a8 8 0 0 1 3.12 0 .5.5 0 0 1-.2.98 7 7 0 0 0-2.72 0 .5.5 0 0 1-.2-.98"
]);
const $77e1bce0ac0f7fe7$export$5a1c644876c67163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint24Filled', "24", [
    "M13.24 19.9c.5-.07 1.02.17 1.21.64.23.56-.07 1.2-.66 1.3a10 10 0 0 1-3.59 0c-.59-.1-.89-.74-.66-1.3.2-.47.71-.71 1.22-.64a8 8 0 0 0 2.48 0m-9.02-3.6c.47-.2 1 0 1.3.41q.76 1.02 1.77 1.76c.4.3.6.84.4 1.3-.23.56-.89.8-1.38.46q-1.5-1.05-2.54-2.54c-.34-.5-.1-1.16.45-1.39m14.24.4c.3-.4.84-.6 1.31-.4.56.23.8.9.45 1.39q-1.03 1.5-2.53 2.53c-.5.35-1.16.1-1.39-.45-.2-.47 0-1 .4-1.3a8 8 0 0 0 1.76-1.76m-3.42-7.9a1 1 0 1 1 1.42 1.4l-5 5a1 1 0 0 1-1.42 0l-2.5-2.5-.07-.07a1 1 0 0 1 1.41-1.4l.08.06 1.79 1.8zM2.16 10.2c.1-.59.74-.89 1.3-.66.47.2.71.71.63 1.22a8 8 0 0 0 0 2.48c.08.5-.17 1.02-.64 1.22-.55.22-1.19-.08-1.3-.67a10 10 0 0 1 0-3.59m18.38-.66c.55-.23 1.19.07 1.3.66a10 10 0 0 1 0 3.6c-.11.58-.75.88-1.3.65-.47-.2-.72-.7-.64-1.21a8 8 0 0 0 0-2.48c-.08-.5.17-1.02.64-1.22M16.3 4.22c.23-.55.9-.79 1.38-.45q1.51 1.05 2.54 2.54c.34.5.1 1.16-.45 1.39-.47.19-1 0-1.3-.41a8 8 0 0 0-1.76-1.76c-.41-.3-.6-.83-.4-1.3m-9.99-.45c.5-.34 1.15-.1 1.38.45.2.47 0 1.01-.4 1.31A8 8 0 0 0 5.53 7.3c-.3.41-.84.6-1.3.4-.56-.23-.8-.89-.46-1.38q1.05-1.5 2.54-2.54M12 2q.91 0 1.8.16c.58.1.88.74.65 1.3-.2.47-.7.71-1.21.64a8 8 0 0 0-2.48 0c-.5.07-1.02-.17-1.22-.64-.23-.56.07-1.2.66-1.3q.87-.15 1.8-.16"
]);
const $77e1bce0ac0f7fe7$export$1c2b999ae1ed0fa5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint24Regular', "24", [
    "M13.65 20.34a.8.8 0 0 1 .91.46.7.7 0 0 1-.49.99 10 10 0 0 1-4.15 0 .7.7 0 0 1-.49-.99.8.8 0 0 1 .91-.46 9 9 0 0 0 3.31 0m5.42-3.61a.8.8 0 0 1 .97-.32c.41.17.59.67.34 1.04a10 10 0 0 1-2.93 2.93.7.7 0 0 1-1.04-.34.8.8 0 0 1 .32-.97 9 9 0 0 0 2.34-2.34m-15.1-.32a.8.8 0 0 1 .96.31 9 9 0 0 0 2.34 2.34.8.8 0 0 1 .32.98.7.7 0 0 1-1.04.34 10 10 0 0 1-2.94-2.93.7.7 0 0 1 .35-1.04m11.25-7.44a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2.5-2.5-.05-.06a.75.75 0 0 1 1.05-1.05l.06.05 1.97 1.97zm5.58.46c.42-.17.9.06.98.5a10 10 0 0 1 0 4.14.7.7 0 0 1-.98.5.8.8 0 0 1-.46-.92 9 9 0 0 0 0-3.3.8.8 0 0 1 .46-.92m-18.58.5c.09-.44.56-.67.98-.5a.8.8 0 0 1 .46.92 9 9 0 0 0 0 3.3.8.8 0 0 1-.46.91.7.7 0 0 1-.99-.49 10 10 0 0 1 0-4.15m4.33-6.31a.7.7 0 0 1 1.04.34.8.8 0 0 1-.32.97 9 9 0 0 0-2.34 2.34.8.8 0 0 1-.97.32.7.7 0 0 1-.34-1.04 10 10 0 0 1 2.93-2.93m9.86.34a.7.7 0 0 1 1.04-.35q1.77 1.17 2.93 2.94c.25.37.07.86-.34 1.04a.8.8 0 0 1-.98-.32 9 9 0 0 0-2.33-2.34.8.8 0 0 1-.32-.97M12 2q1.07 0 2.07.21c.44.1.66.57.5.99a.8.8 0 0 1-.92.46 9 9 0 0 0-3.3 0 .8.8 0 0 1-.92-.46.7.7 0 0 1 .5-.98Q10.92 2 12 2"
]);
const $77e1bce0ac0f7fe7$export$5e2d3b8d5c374f4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint28Filled', "28", [
    "M15.77 23.84c.5-.09 1.02.16 1.21.63.23.55-.07 1.19-.66 1.3a12 12 0 0 1-4.64 0c-.6-.1-.9-.74-.66-1.3.2-.47.7-.72 1.2-.63a10 10 0 0 0 3.55 0M4.48 19.3c.47-.2 1.01 0 1.3.42q1.04 1.47 2.51 2.5c.42.3.61.84.42 1.3-.23.56-.9.8-1.4.46q-1.96-1.32-3.28-3.29c-.34-.5-.1-1.16.45-1.39m17.73.41c.3-.42.83-.6 1.3-.41.56.23.8.89.46 1.39a12 12 0 0 1-3.29 3.29c-.5.33-1.16.1-1.39-.46-.2-.47 0-1 .41-1.3q1.48-1.03 2.51-2.5m-3.92-9.65a1 1 0 0 1 1.41 1.41l-6.5 6.5a1 1 0 0 1-1.4 0l-3.5-3.5a1 1 0 0 1 1.4-1.42l2.8 2.8zM2.22 11.67c.12-.59.75-.89 1.3-.66.48.2.72.71.63 1.21a10 10 0 0 0 0 3.55c.1.5-.15 1.02-.62 1.21-.56.23-1.2-.07-1.3-.66a12 12 0 0 1 0-4.65m22.25-.65c.55-.23 1.19.07 1.3.66a12 12 0 0 1 0 4.64c-.11.59-.75.89-1.3.66-.47-.2-.72-.7-.63-1.21a10 10 0 0 0 0-3.54c-.1-.5.16-1.02.63-1.21m-5.18-6.53c.23-.55.9-.79 1.4-.45q1.95 1.32 3.27 3.28c.34.5.1 1.16-.45 1.39-.47.2-1 0-1.3-.42a10 10 0 0 0-2.5-2.5c-.42-.3-.61-.83-.42-1.3M7.32 4.03c.5-.33 1.16-.1 1.39.46.19.47 0 1-.42 1.3Q6.82 6.8 5.8 8.28c-.3.42-.83.6-1.3.41-.56-.23-.8-.89-.46-1.39q1.32-1.95 3.29-3.28M14 2q1.2 0 2.33.23c.58.11.88.75.66 1.3-.2.47-.71.72-1.21.63a10 10 0 0 0-3.56 0c-.5.09-1.01-.16-1.2-.63-.23-.56.07-1.19.65-1.3Q12.8 2 14 2"
]);
const $77e1bce0ac0f7fe7$export$33c9ca8384c840ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint28Regular', "28", [
    "M16.18 24.27a.8.8 0 0 1 .91.46.72.72 0 0 1-.49.99 12 12 0 0 1-5.2 0 .72.72 0 0 1-.49-.99.8.8 0 0 1 .9-.46 11 11 0 0 0 4.37 0M4.22 19.4a.8.8 0 0 1 .97.32C6 20.95 7.05 22 8.3 22.8c.31.2.46.61.31.97a.72.72 0 0 1-1.04.34 12 12 0 0 1-3.68-3.68.72.72 0 0 1 .34-1.04m18.59.32a.8.8 0 0 1 .97-.32c.41.17.59.67.34 1.04a12 12 0 0 1-3.67 3.68.72.72 0 0 1-1.05-.35.8.8 0 0 1 .32-.96c1.23-.8 2.29-1.86 3.09-3.1m-4.34-9.5a.75.75 0 0 1 1.06 1.07l-6.5 6.49c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 0 1 1.06-1.06l2.97 2.97zM2.28 11.4c.1-.44.57-.67.99-.5a.8.8 0 0 1 .46.91 11 11 0 0 0 0 4.37.8.8 0 0 1-.46.91.72.72 0 0 1-.99-.5 12 12 0 0 1 0-5.2m22.45-.5c.42-.17.89.06.99.5a12 12 0 0 1 0 5.2.72.72 0 0 1-.99.49.8.8 0 0 1-.46-.9 11 11 0 0 0 0-4.38.8.8 0 0 1 .46-.9M19.4 4.24a.72.72 0 0 1 1.05-.35c1.47.94 2.73 2.2 3.67 3.67.24.38.07.87-.35 1.05a.8.8 0 0 1-.96-.32 11 11 0 0 0-3.09-3.09.8.8 0 0 1-.32-.96M7.55 3.88a.72.72 0 0 1 1.05.35.8.8 0 0 1-.32.96C7.05 6 6 7.05 5.2 8.28a.8.8 0 0 1-.96.32.72.72 0 0 1-.35-1.05c.94-1.48 2.2-2.73 3.67-3.67M14 2q1.35 0 2.6.28c.44.1.67.57.5.99a.8.8 0 0 1-.91.46 11 11 0 0 0-4.38 0 .8.8 0 0 1-.9-.46.72.72 0 0 1 .49-.99Q12.66 2 14 2"
]);
const $77e1bce0ac0f7fe7$export$78c45e4c6a9f4338 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint32Filled', "32", [
    "M17.9 27.34c.62-.1 1.26.2 1.5.8.3.69-.09 1.49-.83 1.62a14 14 0 0 1-5.13 0c-.74-.13-1.12-.93-.83-1.62.24-.59.88-.9 1.5-.8a12 12 0 0 0 3.79 0M5.02 22.18c.58-.24 1.25-.01 1.62.5a12 12 0 0 0 2.69 2.69c.51.37.75 1.03.5 1.62-.29.7-1.12 1-1.74.57a14 14 0 0 1-3.64-3.64c-.42-.62-.13-1.45.57-1.74m20.34.5a1.4 1.4 0 0 1 1.63-.5c.7.28.99 1.11.56 1.73a14 14 0 0 1-3.63 3.64c-.62.43-1.46.13-1.74-.57-.25-.58-.01-1.25.5-1.62a12 12 0 0 0 2.68-2.68m-4.24-11.56a1.25 1.25 0 0 1 1.76 1.76l-7.5 7.5c-.48.5-1.28.5-1.76 0l-4-4a1.25 1.25 0 1 1 1.76-1.76l3.12 3.11zm-18.88 2.3c.13-.73.93-1.11 1.63-.82.58.24.89.88.79 1.5a12 12 0 0 0 0 3.8c.1.63-.2 1.27-.8 1.5-.69.3-1.48-.08-1.62-.82a14 14 0 0 1 0-5.15m25.9-.82c.7-.28 1.49.1 1.63.83a14 14 0 0 1 0 5.14c-.14.74-.94 1.12-1.64.83-.58-.24-.89-.88-.79-1.5a12 12 0 0 0 0-3.79c-.1-.63.21-1.26.8-1.5m-5.96-7.58c.29-.7 1.12-1 1.74-.56 1.42.97 2.66 2.2 3.63 3.63.43.62.13 1.45-.56 1.74-.59.24-1.26.01-1.63-.5a12 12 0 0 0-2.67-2.69 1.4 1.4 0 0 1-.5-1.62m-14.1-.57c.63-.43 1.46-.13 1.75.56.24.59 0 1.26-.51 1.63a12 12 0 0 0-2.68 2.68c-.37.52-1.04.75-1.63.5-.7-.28-.99-1.11-.56-1.73a14 14 0 0 1 3.64-3.64M16 2q1.32 0 2.58.24c.74.14 1.12.93.83 1.63-.24.58-.88.9-1.5.79a12 12 0 0 0-3.8 0c-.63.1-1.27-.21-1.51-.8-.29-.7.1-1.49.83-1.62Q14.7 2 16 2"
]);
const $77e1bce0ac0f7fe7$export$46d694f6c699c36a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint32Regular', "32", [
    "M18.3 27.78c.5-.1 1.02.15 1.21.62a.95.95 0 0 1-.66 1.31 14 14 0 0 1-5.7 0 .95.95 0 0 1-.66-1.31c.2-.47.71-.72 1.21-.62a12 12 0 0 0 4.6 0m7.66-5.08c.29-.42.82-.6 1.3-.41.55.23.78.89.45 1.39a14 14 0 0 1-4.03 4.03.95.95 0 0 1-1.4-.46c-.2-.47 0-1 .42-1.29 1.28-.87 2.4-1.97 3.26-3.26m-21.2-.41c.47-.2 1-.01 1.29.41q1.3 1.95 3.26 3.26c.42.28.6.82.41 1.29a.95.95 0 0 1-1.4.46 14 14 0 0 1-4.02-4.03.95.95 0 0 1 .46-1.4m16.53-11a1 1 0 1 1 1.42 1.42l-7.5 7.5a1 1 0 0 1-1.42 0l-4-4a1 1 0 1 1 1.42-1.42l3.29 3.3zm-19 1.86a.95.95 0 0 1 1.31-.66c.47.2.72.7.62 1.2a12 12 0 0 0 0 4.62c.1.5-.14 1.01-.61 1.2a.95.95 0 0 1-1.32-.65 14 14 0 0 1 0-5.7m26.11-.66a.95.95 0 0 1 1.31.66 14 14 0 0 1 0 5.7.95.95 0 0 1-1.3.66c-.48-.19-.73-.7-.63-1.2a12 12 0 0 0 0-4.61c-.1-.5.15-1.01.62-1.2M8.32 4.3a.95.95 0 0 1 1.4.46c.2.47 0 1.01-.42 1.3Q7.36 7.35 6.04 9.3c-.28.43-.82.61-1.29.42a.95.95 0 0 1-.46-1.4A14 14 0 0 1 8.32 4.3m13.97.46a.95.95 0 0 1 1.4-.46 14 14 0 0 1 4.02 4.04c.33.5.1 1.16-.46 1.39-.46.2-1 0-1.29-.42a12 12 0 0 0-3.26-3.26 1.1 1.1 0 0 1-.41-1.29M16 2q1.48 0 2.86.3c.59.11.89.75.66 1.3-.2.47-.7.72-1.2.62a12 12 0 0 0-4.63 0c-.5.1-1-.15-1.2-.62a.95.95 0 0 1 .66-1.3Q14.54 2 16 2"
]);
const $77e1bce0ac0f7fe7$export$da92883582a96ff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint48Filled', "48", [
    "M18.62 41.56a1.6 1.6 0 0 1 1.84-.93 17 17 0 0 0 7.07 0c.76-.16 1.55.21 1.85.93.34.82-.1 1.76-.97 1.95a20 20 0 0 1-8.83 0 1.42 1.42 0 0 1-.96-1.95m19.64-8.3a1.6 1.6 0 0 1 1.95-.65c.82.34 1.18 1.31.7 2.06a20 20 0 0 1-6.24 6.25c-.75.47-1.72.12-2.06-.7-.3-.72 0-1.54.65-1.96 2-1.3 3.7-3 5-5m-30.48-.65c.72-.3 1.54 0 1.96.65 1.3 2 3 3.7 5 5 .65.42.94 1.24.65 1.95a1.42 1.42 0 0 1-2.07.7 20 20 0 0 1-6.24-6.24 1.42 1.42 0 0 1 .7-2.06m22.9-15.17a1.5 1.5 0 1 1 2.13 2.12l-11 11a1.5 1.5 0 0 1-2.12 0l-4.5-4.5a1.5 1.5 0 1 1 2.12-2.12l3.44 3.44zm10.88 1.18c.82-.34 1.76.1 1.95.96a20 20 0 0 1 0 8.84c-.2.86-1.13 1.3-1.95.96a1.6 1.6 0 0 1-.93-1.84 17 17 0 0 0 0-7.08c-.16-.75.21-1.54.93-1.84m-37.07.96c.2-.86 1.13-1.3 1.95-.96.72.3 1.09 1.09.93 1.85a17 17 0 0 0 0 7.06c.16.76-.21 1.55-.93 1.85-.82.34-1.76-.1-1.95-.97a20 20 0 0 1 0-8.82m8.83-12.5a1.42 1.42 0 0 1 2.07.7c.3.72 0 1.54-.65 1.96-2 1.3-3.7 3-5 5-.42.65-1.24.95-1.95.65a1.42 1.42 0 0 1-.7-2.06 20 20 0 0 1 6.23-6.25m19.29.7a1.42 1.42 0 0 1 2.06-.7 20 20 0 0 1 6.25 6.25c.47.75.11 1.72-.7 2.06-.72.3-1.54 0-1.96-.65-1.3-2-3-3.7-5-5a1.6 1.6 0 0 1-.65-1.96M24 4q2.29 0 4.41.49c.87.2 1.3 1.13.96 1.95a1.6 1.6 0 0 1-1.84.93 17 17 0 0 0-7.07 0c-.76.16-1.54-.21-1.84-.93-.34-.82.1-1.76.96-1.95Q21.71 4 24 4"
]);
const $77e1bce0ac0f7fe7$export$4ebfd8d0ce53db23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint48Regular', "48", [
    "M27.95 41.05c.63-.14 1.28.16 1.53.76a1.2 1.2 0 0 1-.8 1.64 20 20 0 0 1-9.37 0 1.2 1.2 0 0 1-.8-1.64c.25-.6.9-.9 1.54-.76a17.6 17.6 0 0 0 7.9 0M7.53 32.72c.6-.25 1.27 0 1.62.54a17.6 17.6 0 0 0 5.58 5.59c.55.34.8 1.03.55 1.62a1.2 1.2 0 0 1-1.72.6 20 20 0 0 1-6.63-6.63 1.2 1.2 0 0 1 .6-1.72m31.32.54c.34-.54 1.02-.8 1.62-.54.68.28.98 1.09.59 1.72a20 20 0 0 1-6.62 6.62 1.2 1.2 0 0 1-1.73-.59c-.24-.6 0-1.28.55-1.62a17.6 17.6 0 0 0 5.59-5.59m-7.98-15.64a1.25 1.25 0 0 1 1.76 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61zm-26.32 1.7a1.2 1.2 0 0 1 1.63-.8c.6.24.9.9.76 1.53a17.6 17.6 0 0 0 0 7.9c.15.63-.16 1.29-.76 1.53a1.2 1.2 0 0 1-1.63-.8 20 20 0 0 1 0-9.37m37.26-.8a1.2 1.2 0 0 1 1.63.8 20 20 0 0 1 0 9.37 1.2 1.2 0 0 1-1.63.8c-.6-.25-.9-.91-.76-1.54a17.6 17.6 0 0 0 0-7.9c-.15-.63.16-1.29.76-1.53M13.56 6.94a1.2 1.2 0 0 1 1.72.59c.25.6 0 1.28-.55 1.62a17.6 17.6 0 0 0-5.58 5.59c-.34.54-1.03.79-1.62.54a1.2 1.2 0 0 1-.6-1.72 20 20 0 0 1 6.63-6.62m19.15.59a1.2 1.2 0 0 1 1.73-.6 20 20 0 0 1 6.62 6.63 1.2 1.2 0 0 1-.6 1.72c-.59.25-1.27 0-1.61-.54a17.6 17.6 0 0 0-5.59-5.59 1.3 1.3 0 0 1-.55-1.62M24 4q2.42.01 4.68.55c.72.17 1.08.96.8 1.64-.25.6-.9.9-1.53.76a17.6 17.6 0 0 0-7.9 0 1.3 1.3 0 0 1-1.54-.76 1.2 1.2 0 0 1 .8-1.64Q21.56 4.01 24 4"
]);
const $77e1bce0ac0f7fe7$export$9af961a05ecd76b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle20Filled', "20", [
    "M10 2q.6 0 1.17.08l-.22.07A1.4 1.4 0 0 0 10 3.5q0 .45.26.82t.71.53l1.06.35q.22.06.47.29.16.14.3.47l.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25q.12.05.21.14.11.1.15.22l.26.8q.15.38.48.62a1.3 1.3 0 0 0 1 .2A8 8 0 1 1 10 2m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $77e1bce0ac0f7fe7$export$902f05329bcfa3f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle20Regular', "20", [
    "M10 2q.6 0 1.17.08l-.22.07a1.4 1.4 0 0 0-.86.85H10a7 7 0 1 0 6.77 8.78 1.3 1.3 0 0 0 .98.2A8 8 0 1 1 10 2m2.65 5.65a.5.5 0 0 1 .77.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3zM17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $77e1bce0ac0f7fe7$export$c34bd028441cbad3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle24Filled', "24", [
    "M12 2a10 10 0 0 1 2.75.39 2 2 0 0 1-.36.17L13.05 3c-.63.22-1.05.8-1.05 1.47 0 .63.42 1.28 1 1.53l1.4.46c.52.17 1.01.57 1.19 1.09l.35 1.23a.8.8 0 0 0-.72.19l-4.47 4.47-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5q.14-.16.2-.34a1.5 1.5 0 0 0 1.66.2q-.18.3-.18.66c0 .54.36 1.05.87 1.23.38.12 1 .18 1.15.62.24.76.5 1.65 1.48 1.65q.19 0 .34-.04A10 10 0 1 1 12 2m9.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-4-8a.6.6 0 0 1 .5.36l.45 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.6.6 0 0 1-.26.2l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38a.6.6 0 0 1-.2.26.55.55 0 0 1-.82-.26l-.45-1.38a2.8 2.8 0 0 0-1.8-1.8L13.36 5a.55.55 0 0 1-.26-.83q.1-.14.26-.2l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.6.6 0 0 1 .51-.36"
]);
const $77e1bce0ac0f7fe7$export$56ed7dde2018bca3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle24Regular', "24", [
    "M12 2a10 10 0 0 1 2.75.39 2 2 0 0 1-.36.17L13.05 3q-.44.16-.71.5H12a8.5 8.5 0 1 0 8.38 9.91c.22.37.54.64 1.08.64q.19 0 .34-.04A10 10 0 1 1 12 2m3.22 6.97a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07 1.97 1.97zM21.48 8a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-4-8a.6.6 0 0 1 .5.36l.45 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.6.6 0 0 1-.26.2l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38a.6.6 0 0 1-.2.26.55.55 0 0 1-.82-.26l-.45-1.38a2.8 2.8 0 0 0-1.8-1.8L13.36 5a.55.55 0 0 1-.26-.83q.1-.14.26-.2l1.38-.44a2.8 2.8 0 0 0 1.76-1.77l.01-.03.45-1.38a.6.6 0 0 1 .51-.36"
]);
const $77e1bce0ac0f7fe7$export$209f6d48b1b545ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare16Filled', "16", [
    "M5.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-5.15-2 2a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 1.65-1.64a.5.5 0 1 1 .7.7M6 10.98v1.52A2.5 2.5 0 0 0 8.5 15h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 6h-1.52q-.05.51-.19 1h1.71c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 12.5v-1.7q-.49.13-1 .18m6.35-1.13a.5.5 0 0 0-.7-.7L10 10.79l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$cbdaf28d44a06bbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare16Regular', "16", [
    "M9 5.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0m1 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4 7v-1.52q.51-.05 1-.19v1.71c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-1.7q.14-.49.18-1h1.52A2.5 2.5 0 0 1 15 8.5v4a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 6 12.5m1.35-8.35c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0m5 5.7a.5.5 0 0 0-.7-.7L10 10.79l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$989e3ee947a4a90e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare20Filled', "20", [
    "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12m2.85-7.15-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64a.5.5 0 1 1 .7.7M8 13.93V16a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3h-2.07q-.07.52-.22 1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2.29q-.48.15-1 .22m8.35-1.58a.5.5 0 0 0-.7-.7L13 14.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$e8dd1107d599267c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare20Regular', "20", [
    "M12 7A5 5 0 1 0 2 7a5 5 0 0 0 10 0m1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0m-5 9v-2.07q.52-.07 1-.22V16c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-2.29q.15-.48.22-1H16a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3M9.85 5.15c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64c.2-.2.5-.2.7 0m3.5 10.2 3-3a.5.5 0 0 0-.7-.7L13 14.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$587b135e09dc0e31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare24Filled', "24", [
    "M8.5 16a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m3.78-9.22-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l1.47 1.47 3.47-3.47a.75.75 0 1 1 1.06 1.06m8 6.94c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 3.47-3.47c.3-.3.77-.3 1.06 0M9.75 20v-3.1q.78-.1 1.5-.35V20c0 .97.78 1.75 1.75 1.75h7c.97 0 1.75-.78 1.75-1.75v-7c0-.97-.78-1.75-1.75-1.75h-3.45q.24-.72.36-1.5H20c1.8 0 3.25 1.46 3.25 3.25v7c0 1.8-1.46 3.25-3.25 3.25h-7A3.25 3.25 0 0 1 9.75 20"
]);
const $77e1bce0ac0f7fe7$export$d4455856aed78793 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare24Regular', "24", [
    "M14.5 8.5a6 6 0 1 0-12 0 6 6 0 0 0 12 0m1.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m4.28 6.28a.75.75 0 1 0-1.06-1.06l-3.47 3.47-1.47-1.47a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0zm-8-9.06c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l1.47 1.47 3.47-3.47c.3-.3.77-.3 1.06 0M9.75 20v-3.1q.78-.1 1.5-.35V20c0 .97.78 1.75 1.75 1.75h7c.97 0 1.75-.78 1.75-1.75v-7c0-.97-.78-1.75-1.75-1.75h-3.45q.24-.72.36-1.5H20c1.8 0 3.25 1.46 3.25 3.25v7c0 1.8-1.46 3.25-3.25 3.25h-7A3.25 3.25 0 0 1 9.75 20"
]);
const $77e1bce0ac0f7fe7$export$b4a699e8ab53a874 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning16Filled', "16", [
    "M0 7a7 7 0 1 1 13.88 1.29L13.3 7.1a2 2 0 0 0-3.58 0L6.3 13.96A7 7 0 0 1 0 7m9.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0zm.75 1.7-3.5 7A1 1 0 0 0 8 16h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M12 9.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$11e47445c3eaec15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning16Regular', "16", [
    "M1 7a6 6 0 0 1 12-.34q.15.2.3.45l.58 1.18Q14 7.66 14 7a7 7 0 1 0-7.71 6.96l.48-.96A6 6 0 0 1 1 7m8.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0zm.75 1.7-3.5 7A1 1 0 0 0 8 16h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M12 9.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $77e1bce0ac0f7fe7$export$d0a4ff0be34beeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning20Filled', "20", [
    "M10 2a8 8 0 0 1 7.74 10.01l-.45-.9a2 2 0 0 0-3.58 0L10.27 18H10a8 8 0 1 1 0-16m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63m1.24 3.9a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 19 20h-7a1 1 0 0 1-.9-1.45zM16 13.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $77e1bce0ac0f7fe7$export$e473b61af3cc9d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning20Regular', "20", [
    "M10 2a8 8 0 0 1 7.74 10.01l-.45-.9q-.14-.27-.32-.47.03-.31.03-.64a7 7 0 1 0-6.2 6.96L10.26 18H10a8 8 0 1 1 0-16m3.36 5.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0m1.24 3.9a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 19 20h-7a1 1 0 0 1-.9-1.45zM16 13.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $77e1bce0ac0f7fe7$export$4ce58862deadad9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning24Filled', "24", [
    "M12 2a10 10 0 0 1 9.54 13l-.8-1.62a2.5 2.5 0 0 0-4.47 0l-4 8q-.15.3-.21.62H12a10 10 0 0 1 0-20m3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06m1.94 4.86a1.5 1.5 0 0 1 2.69 0l4 8c.5 1-.23 2.17-1.35 2.17h-8a1.5 1.5 0 0 1-1.34-2.17zM19 16.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $77e1bce0ac0f7fe7$export$a906cfa961a69148 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning24Regular', "24", [
    "M12 2a10 10 0 0 1 9.54 13l-.8-1.62a3 3 0 0 0-.29-.45q.05-.46.05-.93a8.5 8.5 0 1 0-7.77 8.47l-.46.91q-.15.3-.21.62H12a10 10 0 0 1 0-20m-1.25 11.44 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07zm6.41.39a1.5 1.5 0 0 1 2.69 0l4 8c.5 1-.23 2.17-1.35 2.17h-8a1.5 1.5 0 0 1-1.34-2.17zM19 16.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $77e1bce0ac0f7fe7$export$3e9366a3d8611cf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock16Filled', "16", [
    "M0 7a7 7 0 0 1 13.97-.61A3 3 0 0 0 9.5 9v.06A2 2 0 0 0 8 11v2.93Q7.5 14 7 14a7 7 0 0 1-7-7m9.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0zM10.5 9v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V9a2 2 0 1 0-4 0m1 1V9a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$cfbdee6253d6b671 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock16Regular', "16", [
    "M1 7a6 6 0 0 1 11.92-.97q.57.08 1.05.36A7 7 0 1 0 8 13.93v-1.01Q7.5 13 7 13a6 6 0 0 1-6-6m8.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0zM10.5 9v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V9a2 2 0 1 0-4 0m1 1V9a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$70808698fe09d09b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.33A3 3 0 0 0 12.5 12v.06A2 2 0 0 0 11 14v3.94q-.5.06-1 .06a8 8 0 1 1 0-16m3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63M15.5 10a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5v-1c0-1.1.9-2 2-2m-.65 6.37a.75.75 0 1 0 1.3-.74.75.75 0 0 0-1.3.74M15.5 11a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1"
]);
const $77e1bce0ac0f7fe7$export$8aa052f6085bce80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.33 3 3 0 0 0-1.03-.94A7 7 0 1 0 11 16.93v1q-.5.07-1 .07a8 8 0 1 1 0-16m6.97 8.64A2 2 0 0 1 17.5 12v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5v-1a2 2 0 0 1 3.47-1.36M14.5 13h2v-1a1 1 0 1 0-2 0zm.35 3.37a.75.75 0 1 0 1.3-.74.75.75 0 0 0-1.3.74m-1.5-8.72c.18.17.2.44.07.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$b28c494f9a55e892 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock24Filled', "24", [
    "M12 2a10 10 0 0 1 9.92 11.26A3.5 3.5 0 0 0 15 14v.05a2.5 2.5 0 0 0-2 2.45v5q0 .22.04.45-.51.05-1.04.05a10 10 0 0 1 0-20m3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06m3.28 2.53A2.5 2.5 0 0 1 21 14v1h.54c.81.02 1.46.69 1.46 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h.5v-1a2.5 2.5 0 0 1 2.5-2.5m-.4 8.42a1 1 0 0 0 1.35-1.24 1 1 0 1 0-1.34 1.24M17.5 14v1h2v-1a1 1 0 1 0-2 0"
]);
const $77e1bce0ac0f7fe7$export$b11015c889692983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock24Regular', "24", [
    "M12 2a10 10 0 0 1 9.92 11.26 3.5 3.5 0 0 0-1.47-2.17A8.5 8.5 0 1 0 13 20.44v1.06q0 .22.04.45-.51.05-1.04.05a10 10 0 0 1 0-20m8.49 10.48A2.5 2.5 0 0 0 16 14v1h-.5c-.83 0-1.5.67-1.5 1.5v5l.03.3c.14.68.74 1.2 1.47 1.2h6c.83 0 1.5-.67 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5H21v-1c0-.57-.2-1.1-.51-1.52m-2.38 7.44a1 1 0 1 1 .78-1.84 1 1 0 0 1-.78 1.84M17.5 14a1 1 0 1 1 2 0v1h-2zm-6.75-.56 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07z"
]);
const $77e1bce0ac0f7fe7$export$b7ce22fb2aa9e84e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkNote20Filled', "20", [
    "M6.03 12.9 2.56 9a.75.75 0 1 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06zM11 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$6485224de4d6a6b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkNote20Regular', "20", [
    "M1.67 9.13a.5.5 0 0 1 .7.04l3.65 4.1L16.15 3.15a.5.5 0 1 1 .7.7l-10.5 10.5a.5.5 0 0 1-.72-.02l-4-4.5a.5.5 0 0 1 .04-.7M11 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$fd06d5c9f650d53a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm7.35 5.35-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 11.29l3.65-3.64a.5.5 0 0 1 .7.7"
]);
const $77e1bce0ac0f7fe7$export$682e76233421f0f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm9.35 2.35a.5.5 0 0 0-.7-.7L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$16e22662a2685f82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zm10.03 6.78-5 5c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 4.47-4.47a.75.75 0 1 1 1.06 1.06"
]);
const $77e1bce0ac0f7fe7$export$b951b34e50107802 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare24Regular', "24", [
    "M16.28 9.78a.75.75 0 0 0-1.06-1.06l-4.47 4.47-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2c.3.3.77.3 1.06 0zM6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $77e1bce0ac0f7fe7$export$7e20265d53fdff4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst16Filled', "16", [
    "M4.1 2.25a2 2 0 0 1 2.65-1.08l.88.38c.25.11.54.11.79 0l.89-.37a2 2 0 0 1 2.64 1.1l.35.9q.16.4.56.56l.9.36a2 2 0 0 1 1.07 2.65l-.38.89a1 1 0 0 0 0 .78l.37.9a2 2 0 0 1-1.1 2.63l-.9.35a1 1 0 0 0-.56.56l-.36.9a2 2 0 0 1-2.65 1.08l-.88-.39a1 1 0 0 0-.8 0l-.88.37a2 2 0 0 1-2.64-1.1l-.35-.9a1 1 0 0 0-.56-.56l-.9-.36a2 2 0 0 1-1.07-2.65l.38-.88a1 1 0 0 0 0-.79l-.37-.89a2 2 0 0 1 1.1-2.64l.9-.35a1 1 0 0 0 .56-.55zm6.75 3.9a.5.5 0 0 0-.7 0l-2.9 2.9-1.4-1.4a.5.5 0 0 0-.7.7L6.9 10.1c.2.2.5.2.7 0l3.25-3.25a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$aea04397f79a8872 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst16Regular', "16", [
    "M4.1 2.25a2 2 0 0 1 2.65-1.08l.88.38q.4.15.8 0l.88-.37a2 2 0 0 1 2.64 1.1l.35.9q.16.4.56.56l.9.36a2 2 0 0 1 1.08 2.65l-.39.88a1 1 0 0 0 0 .8l.37.88a2 2 0 0 1-1.1 2.64l-.9.35a1 1 0 0 0-.56.56l-.36.9a2 2 0 0 1-2.65 1.08l-.88-.39a1 1 0 0 0-.8 0l-.88.37a2 2 0 0 1-2.64-1.1l-.35-.9a1 1 0 0 0-.56-.56l-.9-.36a2 2 0 0 1-1.08-2.65l.39-.88a1 1 0 0 0 0-.8l-.37-.88a2 2 0 0 1 1.1-2.64l.9-.35a1 1 0 0 0 .56-.56zm2.25-.17a1 1 0 0 0-1.32.54l-.37.9a2 2 0 0 1-1.11 1.1l-.9.36A1 1 0 0 0 2.1 6.3l.37.89a2 2 0 0 1 0 1.57l-.39.89a1 1 0 0 0 .54 1.32l.9.37c.5.2.9.6 1.1 1.11l.36.9a1 1 0 0 0 1.32.55l.89-.37a2 2 0 0 1 1.57 0l.89.39a1 1 0 0 0 1.32-.54l.37-.9a2 2 0 0 1 1.11-1.1l.9-.36a1 1 0 0 0 .55-1.32l-.37-.89a2 2 0 0 1 0-1.57l.39-.89a1 1 0 0 0-.54-1.32l-.9-.36a2 2 0 0 1-1.1-1.12l-.36-.9A1 1 0 0 0 9.7 2.1l-.89.37a2 2 0 0 1-1.57 0zm3.8 4.07a.5.5 0 0 1 .7.7L7.6 10.1a.5.5 0 0 1-.7 0L5.15 8.35a.5.5 0 0 1 .7-.7l1.4 1.4z"
]);
const $77e1bce0ac0f7fe7$export$deed0f49b38688a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst20Filled', "20", [
    "M11.54 1.9c1.21-.48 2.58.09 3.1 1.28l.43.98q.24.53.77.78l.98.42a2.4 2.4 0 0 1 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.4.99a2.4 2.4 0 0 1-1.3 3.1l-.97.43a1.5 1.5 0 0 0-.77.77l-.43.98a2.4 2.4 0 0 1-3.1 1.28l-.99-.39a1.5 1.5 0 0 0-1.1 0l-.99.4a2.4 2.4 0 0 1-3.1-1.3l-.42-.97a1.5 1.5 0 0 0-.78-.77l-.98-.43a2.4 2.4 0 0 1-1.28-3.1l.39-.99a1.5 1.5 0 0 0 0-1.1l-.4-.99a2.4 2.4 0 0 1 1.3-3.1l.97-.42q.53-.25.78-.78l.42-.98a2.4 2.4 0 0 1 3.1-1.28l1 .39q.54.21 1.1 0zm1.81 5.75a.5.5 0 0 0-.7 0L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$88a6657e828b7510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst20Regular', "20", [
    "M11.54 1.9c1.21-.48 2.58.09 3.1 1.28l.43.98q.24.53.77.77l.98.43a2.4 2.4 0 0 1 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.4.99a2.4 2.4 0 0 1-1.3 3.1l-.97.43a1.5 1.5 0 0 0-.77.77l-.43.98a2.4 2.4 0 0 1-3.1 1.28l-.99-.39a1.5 1.5 0 0 0-1.1 0l-.99.4a2.4 2.4 0 0 1-3.1-1.3l-.42-.97a1.5 1.5 0 0 0-.78-.77l-.98-.43a2.4 2.4 0 0 1-1.28-3.1l.39-.99a1.5 1.5 0 0 0 0-1.1l-.4-.99a2.4 2.4 0 0 1 1.3-3.1l.97-.43q.53-.24.78-.77l.42-.98a2.4 2.4 0 0 1 3.1-1.28l1 .39q.54.21 1.1 0zm2.19 1.68c-.3-.7-1.11-1.03-1.82-.75l-1 .39a2.5 2.5 0 0 1-1.82 0l-1-.4a1.4 1.4 0 0 0-1.81.76l-.43.98a2.5 2.5 0 0 1-1.3 1.3l-.97.42c-.7.3-1.03 1.1-.75 1.82l.39.99a2.5 2.5 0 0 1 0 1.83l-.4.99c-.27.7.06 1.51.76 1.81l.98.43a2.5 2.5 0 0 1 1.3 1.3l.42.97c.3.7 1.1 1.03 1.82.75l.99-.39a2.5 2.5 0 0 1 1.83 0l.99.4c.7.27 1.51-.06 1.82-.76l.42-.98a2.5 2.5 0 0 1 1.3-1.3l.97-.42c.7-.3 1.03-1.1.75-1.81l-.39-1a2.5 2.5 0 0 1 0-1.82l.4-1a1.4 1.4 0 0 0-.76-1.81l-.98-.43a2.5 2.5 0 0 1-1.29-1.3zm-1.08 4.07a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 11.29z"
]);
const $77e1bce0ac0f7fe7$export$c2df18216d425fb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst24Filled', "24", [
    "M6.35 3.75a2.75 2.75 0 0 1 3.81-1.58l1.29.63c.35.17.75.17 1.1 0l1.28-.63a2.75 2.75 0 0 1 3.69 1.25l.07.16.06.17.46 1.36c.13.36.42.65.78.78l1.36.46a2.75 2.75 0 0 1 1.58 3.81l-.63 1.29c-.17.35-.17.75 0 1.1l.63 1.29a2.75 2.75 0 0 1-1.58 3.81l-1.36.46c-.36.13-.65.42-.78.78l-.46 1.36a2.75 2.75 0 0 1-3.82 1.58l-1.28-.63a1.3 1.3 0 0 0-1.1 0l-1.28.63a2.75 2.75 0 0 1-3.82-1.58l-.46-1.36a1.3 1.3 0 0 0-.78-.78l-1.36-.46a2.75 2.75 0 0 1-1.58-3.81l.63-1.29c.17-.35.17-.75 0-1.1l-.63-1.28a2.75 2.75 0 0 1 1.58-3.82l1.36-.46c.36-.13.65-.42.78-.78zm9.93 5.22a.75.75 0 0 0-1.06 0l-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5c.3-.3.3-.77 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$96985897b6dca161 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst24Regular', "24", [
    "M6.35 3.75a2.75 2.75 0 0 1 3.81-1.58l1.29.63c.35.17.75.17 1.1 0l1.28-.63a2.75 2.75 0 0 1 3.69 1.25l.07.16.06.17.46 1.36c.13.36.42.65.78.78l1.36.46a2.75 2.75 0 0 1 1.58 3.82l-.63 1.28c-.17.35-.17.75 0 1.1l.63 1.29a2.75 2.75 0 0 1-1.58 3.81l-1.36.46c-.36.13-.65.42-.78.78l-.46 1.36a2.75 2.75 0 0 1-3.82 1.58l-1.28-.63a1.3 1.3 0 0 0-1.1 0l-1.28.63a2.75 2.75 0 0 1-3.82-1.58l-.46-1.36a1.3 1.3 0 0 0-.78-.78l-1.36-.46a2.75 2.75 0 0 1-1.58-3.81l.63-1.29c.17-.35.17-.75 0-1.1l-.63-1.28a2.75 2.75 0 0 1 1.58-3.82l1.36-.46c.36-.13.65-.42.78-.78zm9.76.22a1.25 1.25 0 0 0-1.61-.45l-1.29.63c-.76.37-1.66.37-2.42 0L9.5 3.52a1.26 1.26 0 0 0-1.73.72L7.3 5.59c-.28.8-.91 1.44-1.72 1.72l-1.35.46q-.08.02-.16.06c-.61.3-.87 1.05-.56 1.67l.63 1.29c.37.76.37 1.66 0 2.42l-.63 1.29a1.25 1.25 0 0 0 .72 1.73l1.35.46c.8.28 1.44.91 1.72 1.72l.46 1.35q.02.08.06.15c.3.62 1.05.88 1.67.57l1.29-.63a2.8 2.8 0 0 1 2.42 0l1.29.63.15.07c.65.22 1.36-.13 1.58-.79l.46-1.35c.28-.8.91-1.44 1.72-1.72l1.35-.46q.08-.02.15-.06c.62-.3.88-1.05.57-1.67l-.63-1.29a2.8 2.8 0 0 1 0-2.42l.63-1.29.07-.15a1.25 1.25 0 0 0-.79-1.58l-1.35-.46a2.8 2.8 0 0 1-1.72-1.72l-.46-1.35-.03-.08-.03-.08zm-.89 5a.75.75 0 1 1 1.06 1.06l-5 5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.97 1.97z"
]);
const $77e1bce0ac0f7fe7$export$9c6eff0fda7fe679 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst28Filled', "28", [
    "M15.72 2.4a3.75 3.75 0 0 1 5.26 2.18l.25.75c.22.68.75 1.22 1.43 1.44l.76.25a3.75 3.75 0 0 1 2.17 5.26l-.35.7c-.33.64-.33 1.4 0 2.03l.35.7a3.75 3.75 0 0 1-2.17 5.27l-.76.24c-.68.23-1.21.76-1.43 1.44l-.25.75a3.75 3.75 0 0 1-5.26 2.18l-.7-.36a2.3 2.3 0 0 0-2.04 0l-.7.36a3.75 3.75 0 0 1-5.26-2.18l-.25-.75a2.3 2.3 0 0 0-1.43-1.44l-.76-.24a3.75 3.75 0 0 1-2.17-5.26l.35-.7c.33-.65.33-1.4 0-2.04l-.35-.7a3.75 3.75 0 0 1 2.17-5.26l.76-.25a2.3 2.3 0 0 0 1.43-1.44l.25-.75a3.75 3.75 0 0 1 5.26-2.18l.7.36c.64.32 1.4.32 2.04 0zm3.81 7.82a.75.75 0 0 0-1.06 0l-5.97 5.97-2.97-2.97a.75.75 0 0 0-1.06 1.06l3.5 3.5c.3.3.77.3 1.06 0l6.5-6.5c.3-.3.3-.77 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$b1b2f75d10b4778c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst28Regular', "28", [
    "M15.72 2.4a3.75 3.75 0 0 1 5.26 2.18l.25.75c.22.68.75 1.22 1.43 1.44l.76.25a3.75 3.75 0 0 1 2.17 5.26l-.35.7c-.33.64-.33 1.4 0 2.03l.35.7a3.75 3.75 0 0 1-2.17 5.27l-.76.24c-.68.23-1.21.76-1.43 1.44l-.25.75a3.75 3.75 0 0 1-5.26 2.18l-.7-.36a2.3 2.3 0 0 0-2.04 0l-.7.36a3.75 3.75 0 0 1-5.26-2.18l-.25-.75a2.3 2.3 0 0 0-1.43-1.44l-.76-.24a3.75 3.75 0 0 1-2.17-5.26l.35-.7c.33-.65.33-1.4 0-2.04l-.35-.7a3.75 3.75 0 0 1 2.17-5.26l.76-.25a2.3 2.3 0 0 0 1.43-1.44l.25-.75a3.75 3.75 0 0 1 5.26-2.18l.7.36c.64.32 1.4.32 2.04 0zm3.83 2.65a2.25 2.25 0 0 0-3.15-1.3l-.7.35a3.8 3.8 0 0 1-3.4 0l-.7-.36a2.25 2.25 0 0 0-3.15 1.3l-.25.76a3.8 3.8 0 0 1-2.4 2.4l-.75.24a2.25 2.25 0 0 0-1.3 3.16l.35.7a3.8 3.8 0 0 1 0 3.4l-.36.7a2.25 2.25 0 0 0 1.31 3.15l.75.25a3.8 3.8 0 0 1 2.4 2.4l.25.75a2.25 2.25 0 0 0 3.15 1.3l.7-.35a3.8 3.8 0 0 1 3.4 0l.7.35c1.23.63 2.73 0 3.15-1.3l.25-.75a3.8 3.8 0 0 1 2.4-2.4l.75-.25a2.25 2.25 0 0 0 1.3-3.15l-.35-.7a3.8 3.8 0 0 1 0-3.4l.36-.7c.62-1.23 0-2.73-1.31-3.16l-.75-.24a3.8 3.8 0 0 1-2.4-2.4zm-1.08 5.17a.75.75 0 0 1 1.06 1.06l-6.5 6.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 0 1 1.06-1.06l2.97 2.97z"
]);
const $77e1bce0ac0f7fe7$export$df4460f7988deef6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst32Filled', "32", [
    "M8.11 4.73a4 4 0 0 1 5.61-2.3l1.43.74a2 2 0 0 0 1.8 0l1.44-.71a4 4 0 0 1 5.59 2.34l.5 1.53a2 2 0 0 0 1.26 1.28l1.52.5a4 4 0 0 1 2.3 5.61l-.73 1.43a2 2 0 0 0-.01 1.8l.72 1.44a4 4 0 0 1-2.35 5.59l-1.52.5a2 2 0 0 0-1.28 1.26l-.5 1.52a4 4 0 0 1-5.62 2.3l-1.42-.73a2 2 0 0 0-1.81 0l-1.43.7A4 4 0 0 1 8 27.2l-.49-1.53a2 2 0 0 0-1.27-1.28l-1.52-.5a4 4 0 0 1-2.3-5.62l.74-1.42a2 2 0 0 0 0-1.8l-.71-1.44A4 4 0 0 1 4.8 8l1.53-.48A2 2 0 0 0 7.6 6.25zm14.6 6.56a1 1 0 0 0-1.42 0l-6.8 6.8-3.28-3.3a1 1 0 0 0-1.42 1.42l4 4a1 1 0 0 0 1.42 0l7.5-7.5a1 1 0 0 0 0-1.42"
]);
const $77e1bce0ac0f7fe7$export$4bbfba83827e9708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst32Regular', "32", [
    "M8.11 4.73a4 4 0 0 1 5.61-2.3l1.43.74a2 2 0 0 0 1.8 0l1.44-.71a4 4 0 0 1 5.59 2.34l.5 1.53a2 2 0 0 0 1.26 1.28l1.52.5a4 4 0 0 1 2.3 5.61l-.73 1.43a2 2 0 0 0-.01 1.8l.72 1.44a4 4 0 0 1-2.35 5.59l-1.52.5a2 2 0 0 0-1.28 1.26l-.5 1.52a4 4 0 0 1-5.62 2.3l-1.42-.73a2 2 0 0 0-1.81 0l-1.43.7A4 4 0 0 1 8 27.2l-.49-1.53a2 2 0 0 0-1.27-1.28l-1.52-.5a4 4 0 0 1-2.3-5.62l.74-1.42a2 2 0 0 0 0-1.8l-.71-1.44A4 4 0 0 1 4.8 8l1.53-.48A2 2 0 0 0 7.6 6.25zm4.7-.51a2 2 0 0 0-2.8 1.14l-.5 1.52a4 4 0 0 1-2.57 2.55l-1.53.49a2 2 0 0 0-1.17 2.8l.72 1.43a4 4 0 0 1-.02 3.6l-.73 1.43a2 2 0 0 0 1.15 2.8l1.52.51a4 4 0 0 1 2.54 2.57l.5 1.52a2 2 0 0 0 2.8 1.17l1.43-.71a4 4 0 0 1 3.6.01l1.43.73a2 2 0 0 0 2.8-1.15l.51-1.52a4 4 0 0 1 2.57-2.54l1.52-.5a2 2 0 0 0 1.17-2.79l-.71-1.43a4 4 0 0 1 .01-3.61l.73-1.43a2 2 0 0 0-1.15-2.8l-1.52-.5a4 4 0 0 1-2.54-2.57l-.5-1.53a2 2 0 0 0-2.79-1.17l-1.43.72a4 4 0 0 1-3.61-.01zm8.48 7.07a1 1 0 1 1 1.42 1.42l-7.5 7.5a1 1 0 0 1-1.42 0l-4-4a1 1 0 1 1 1.42-1.42l3.29 3.3z"
]);
const $77e1bce0ac0f7fe7$export$2bdcb0c64d72650a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst48Filled', "48", [
    "M13.1 7.28a5.25 5.25 0 0 1 6.95-2.85L23 5.71c.69.3 1.47.3 2.16.01l2.96-1.25a5.25 5.25 0 0 1 6.92 2.9l1.18 2.99c.28.7.83 1.25 1.53 1.53l2.97 1.21a5.25 5.25 0 0 1 2.85 6.95L42.29 23c-.3.69-.3 1.47-.01 2.16l1.25 2.96a5.25 5.25 0 0 1-2.9 6.92l-2.99 1.18c-.7.28-1.25.83-1.53 1.53l-1.21 2.97a5.25 5.25 0 0 1-6.95 2.85L25 42.29c-.69-.3-1.47-.3-2.16-.01l-2.96 1.25a5.25 5.25 0 0 1-6.92-2.9l-1.18-2.99a2.8 2.8 0 0 0-1.53-1.53L7.28 34.9a5.25 5.25 0 0 1-2.85-6.95L5.71 25c.3-.69.3-1.47.01-2.16l-1.25-2.96a5.25 5.25 0 0 1 2.9-6.92l2.99-1.18c.7-.28 1.25-.83 1.53-1.53zm19.53 10.34a1.25 1.25 0 0 0-1.76 0L20.75 27.73l-3.62-3.61a1.25 1.25 0 0 0-1.76 1.76l4.5 4.5c.48.5 1.28.5 1.76 0l11-11c.5-.48.5-1.28 0-1.76"
]);
const $77e1bce0ac0f7fe7$export$daf7a802e736eec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst48Regular', "48", [
    "M13.1 7.28a5.25 5.25 0 0 1 6.95-2.85L23 5.71c.69.3 1.47.3 2.16 0l2.96-1.24a5.25 5.25 0 0 1 6.92 2.9l1.18 2.99c.28.7.83 1.25 1.53 1.53l2.97 1.21a5.25 5.25 0 0 1 2.85 6.95L42.29 23c-.3.69-.3 1.47 0 2.16l1.24 2.96a5.25 5.25 0 0 1-2.9 6.92l-2.99 1.18c-.7.28-1.25.83-1.53 1.53l-1.21 2.97a5.25 5.25 0 0 1-6.95 2.85L25 42.29c-.69-.3-1.47-.3-2.16-.01l-2.96 1.25a5.25 5.25 0 0 1-6.92-2.9l-1.18-2.99a2.8 2.8 0 0 0-1.53-1.53L7.28 34.9a5.25 5.25 0 0 1-2.85-6.95L5.71 25c.3-.69.3-1.47.01-2.16l-1.25-2.96a5.25 5.25 0 0 1 2.9-6.92l2.99-1.18c.7-.28 1.25-.83 1.53-1.53zm5.96-.55a2.75 2.75 0 0 0-3.64 1.49l-1.2 2.97a5.3 5.3 0 0 1-2.94 2.91l-2.99 1.18a2.75 2.75 0 0 0-1.52 3.63l1.25 2.96A5.3 5.3 0 0 1 8 26l-1.27 2.94a2.75 2.75 0 0 0 1.49 3.64l2.97 1.21a5.3 5.3 0 0 1 2.91 2.93l1.18 2.99a2.75 2.75 0 0 0 3.63 1.52l2.96-1.25A5.3 5.3 0 0 1 26 40l2.95 1.27a2.75 2.75 0 0 0 3.63-1.49l1.21-2.97a5.3 5.3 0 0 1 2.93-2.91l3-1.18a2.75 2.75 0 0 0 1.51-3.63l-1.25-2.96A5.3 5.3 0 0 1 40 22l1.27-2.94a2.75 2.75 0 0 0-1.49-3.64l-2.97-1.21a5.3 5.3 0 0 1-2.91-2.93l-1.18-3a2.75 2.75 0 0 0-3.63-1.51l-2.96 1.25A5.3 5.3 0 0 1 22 8zm11.8 10.89a1.25 1.25 0 0 1 1.77 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61z"
]);
const $77e1bce0ac0f7fe7$export$b1e8ffbf60a8d109 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle16Filled', "16", [
    "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m2.86-8.85c.19.2.19.52 0 .72L7.97 8.85a.5.5 0 0 1-.7 0L6.15 7.68a.5.5 0 0 1 0-.72c.2-.2.5-.2.7 0l.78.81 2.54-2.62c.2-.2.5-.2.7 0M6.5 10h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $77e1bce0ac0f7fe7$export$be00f3230aa510f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle16Regular', "16", [
    "M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10m0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12m2.86-8.85c.19.2.19.52 0 .72L7.97 8.85a.5.5 0 0 1-.7 0L6.15 7.68a.5.5 0 0 1 0-.72c.2-.2.5-.2.7 0l.78.81 2.54-2.62c.2-.2.5-.2.7 0M6 10.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$1cd847e219b683d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle20Filled', "20", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0M7.5 13h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
]);
const $77e1bce0ac0f7fe7$export$ba8d87f30eceaa4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle20Regular', "20", [
    "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0M7 13.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5"
]);
const $77e1bce0ac0f7fe7$export$4e051ad2b50bcc06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle24Filled', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-1.25 9.44 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5A.75.75 0 0 1 8.7 9.4l.08.07zM8.5 15h6.75a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1 0-1.5"
]);
const $77e1bce0ac0f7fe7$export$3cdb3f8b4100b5f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle24Regular', "24", [
    "m10.75 11.44 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5A.75.75 0 0 1 8.7 9.4l.08.07zM8.5 15a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5zM2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0m10-8.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
]);
const $77e1bce0ac0f7fe7$export$569e85cb21c2e84a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess16Filled', "16", [
    "M5 4a2.5 2.5 0 0 1 2 4 1 1 0 0 1 0 2h-.46a3.4 3.4 0 0 0 1.69 2.3c.42.26.77.73.77 1.3 0 .78-.62 1.4-1.4 1.4H2.4A1.4 1.4 0 0 1 1 13.6c0-.57.35-1.04.77-1.3.6-.38 1.49-1.11 1.69-2.3H3a1 1 0 0 1 0-2q-.48-.64-.5-1.5A2.5 2.5 0 0 1 5 4m4-3c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.28.22-.5.5-.5h.25c.41 0 .75.34.75.75V4a2 2 0 0 1-2 2c.07 4.14 1 5.75 1.46 6.3.25.3.54.74.54 1.27 0 .8-.64 1.43-1.43 1.43H9.53q.46-.62.47-1.43c0-.9-.48-1.6-1-2.02.45-.9.94-2.57 1-5.55a2 2 0 0 1-2-2V1.75c0-.41.34-.75.75-.75z"
]);
const $77e1bce0ac0f7fe7$export$39f873b955a864ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess16Regular', "16", [
    "M5 4a2.5 2.5 0 0 1 2.43 3.06 1.5 1.5 0 0 1-.4 2.94c.16 1.2.84 1.93 1.3 2.29.36.28.67.74.67 1.28v.15c-.08.67-.6 1.2-1.28 1.27l-.15.01H2.43c-.74 0-1.35-.56-1.42-1.28L1 13.57c0-.54.3-1 .67-1.28a3.5 3.5 0 0 0 1.3-2.3 1.5 1.5 0 0 1-.4-2.93A2.5 2.5 0 0 1 5 4m4.5-3q.58.01 1 .39a1.5 1.5 0 0 1 2 0 1.5 1.5 0 0 1 1-.39h.5a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2c.07 4.14 1 5.75 1.46 6.3.25.3.54.74.54 1.27 0 .8-.64 1.43-1.43 1.43H9.53q.33-.45.43-1h3.61c.24 0 .43-.2.43-.43q0-.26-.3-.63c-.7-.82-1.7-2.8-1.7-7.44 0-.28.22-.5.5-.5h.5a1 1 0 0 0 1-1V2h-.5a.5.5 0 0 0-.5.5V3a.5.5 0 0 1-1 0V2.5a.5.5 0 0 0-.98-.1l-.01.1L11 3a.5.5 0 0 1-1 0v-.52A.5.5 0 0 0 9.5 2H9v2a1 1 0 0 0 1 1h.5c.28 0 .5.22.5.5 0 3.81-.68 5.83-1.3 6.89a3 3 0 0 0-.7-.84c.45-.9.94-2.57 1-5.55a2 2 0 0 1-2-2V2a1 1 0 0 1 1-1zM5 5a1.5 1.5 0 0 0-1.3 2.25.5.5 0 0 1-.43.75H3a.5.5 0 0 0 0 1h.5c.28 0 .5.22.5.5a4.5 4.5 0 0 1-1.71 3.58q-.3.24-.29.5v.08c.05.2.22.34.43.34h5.23q.27-.07.33-.34l.01-.09q0-.24-.29-.5A4.5 4.5 0 0 1 6 9.5c0-.28.22-.5.5-.5H7l.1-.01a.5.5 0 0 0 0-.98L7 8h-.27a.5.5 0 0 1-.43-.75q.2-.34.2-.75C6.5 5.67 5.83 5 5 5"
]);
const $77e1bce0ac0f7fe7$export$f82ba2c948694adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess20Filled', "20", [
    "M10.5 2a.5.5 0 0 0-.5.5v2.6a3 3 0 0 0 2.2 2.89 16 16 0 0 1-1.67 6.05q.28.31.5.49c.51.43.97 1.14.97 2.02q-.02.82-.48 1.45H17c.83 0 1.5-.67 1.5-1.5v-.3q-.02-.54-.3-.94A15 15 0 0 1 15.8 8 3 3 0 0 0 18 5.1V2.5a.5.5 0 0 0-.5-.5h-.75a.75.75 0 0 0-.75.75v.75a.5.5 0 0 1-1 0v-.75a.75.75 0 0 0-.75-.75h-.5a.75.75 0 0 0-.75.75v.75a.5.5 0 0 1-1 0v-.75a.75.75 0 0 0-.75-.75zm-4 3a3 3 0 0 0-2.24 5H4a1 1 0 1 0 0 2h.52a5.8 5.8 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.8 5.8 0 0 1 8.48 12H9a1 1 0 1 0 0-2h-.26A3 3 0 0 0 6.5 5"
]);
const $77e1bce0ac0f7fe7$export$d72b9ebdc19953a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess20Regular', "20", [
    "M10 3a1 1 0 0 1 1-1h.5q.6.02 1 .38a1.5 1.5 0 0 1 1-.38h1q.58.02 1 .38a1.5 1.5 0 0 1 1-.38h.5a1 1 0 0 1 1 1v2.5a2.5 2.5 0 0 1-1.95 2.44c.28 4.04 1.7 6.58 2.19 7.35q.25.38.26.88v.33c0 .83-.67 1.5-1.5 1.5h-5.48q.33-.45.44-1H17a.5.5 0 0 0 .5-.5v-.33q0-.17-.1-.34c-.58-.9-2.16-3.78-2.38-8.3a.5.5 0 0 1 .5-.53A1.5 1.5 0 0 0 17 5.5V3h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5H11v2.5c0 .82.66 1.49 1.48 1.5a.5.5 0 0 1 .5.52 18 18 0 0 1-1.76 7.2l-.2-.2a4 4 0 0 1-.55-.55 17 17 0 0 0 1.48-6.03A2.5 2.5 0 0 1 10 5.5zM4.5 8a2 2 0 1 1 3.6 1.2.5.5 0 0 0 .4.8H9a.5.5 0 0 1 0 1H7.9a.5.5 0 0 0-.5.56 6.9 6.9 0 0 0 2.34 4.5q.26.24.26.49c0 .25-.2.45-.45.45h-6.1a.45.45 0 0 1-.45-.45q0-.25.26-.49a6.9 6.9 0 0 0 2.34-4.5.5.5 0 0 0-.5-.56H4a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .4-.8q-.39-.51-.4-1.2m2-3a3 3 0 0 0-2.82 4.03A1.5 1.5 0 0 0 4 12h.52a5.8 5.8 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.8 5.8 0 0 1 8.48 12H9a1.5 1.5 0 0 0 .32-2.97A3 3 0 0 0 6.5 5"
]);
const $77e1bce0ac0f7fe7$export$919574d8d51e4fdd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess24Filled', "24", [
    "M7.5 6a3.5 3.5 0 0 1 2.45 6h.55a1.5 1.5 0 0 1 0 3h-.37c.38 1.8 1.5 3 2.14 3.56.42.36.73.92.73 1.55 0 1.04-.85 1.89-1.89 1.89H3.89A1.9 1.9 0 0 1 2 20.11c0-.63.31-1.19.73-1.55A6.7 6.7 0 0 0 4.87 15H4.5a1.5 1.5 0 0 1 0-3h.55A3.49 3.49 0 0 1 7.5 6M13 2a1 1 0 0 1 1 1v1.25a.75.75 0 0 0 1.5 0V3a1 1 0 1 1 2 0v1.25a.75.75 0 0 0 1.5 0V3a1 1 0 0 1 1-1h.25c.41 0 .75.34.75.75V7a2 2 0 0 1-2 2h-.22c.26 5.45 2.16 8.73 2.83 9.71.23.35.39.78.39 1.25 0 1.13-.91 2.04-2.04 2.04h-6.67c.44-.5.71-1.17.71-1.89 0-.97-.48-1.78-1.07-2.3a6 6 0 0 1-.65-.67c.8-1.65 1.76-4.37 1.94-8.14H14a2 2 0 0 1-2-2V2.75c0-.41.34-.75.75-.75z"
]);
const $77e1bce0ac0f7fe7$export$981e2df2d442ef45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess24Regular', "24", [
    "M7.5 6a3.5 3.5 0 0 1 3.33 4.58 2.25 2.25 0 0 1-.58 4.42h-.12a6.7 6.7 0 0 0 2.14 3.56c.42.36.73.92.73 1.55l-.01.2c-.09.88-.8 1.59-1.69 1.68l-.19.01H3.89c-.98 0-1.78-.74-1.88-1.7L2 20.11c0-.63.31-1.19.73-1.55A6.7 6.7 0 0 0 4.87 15h-.12a2.25 2.25 0 0 1-.58-4.42A3.5 3.5 0 0 1 7.5 6m6.23-4c.54 0 1.04.2 1.43.52a2 2 0 0 1 2.68 0q.6-.5 1.43-.52h.38A1.5 1.5 0 0 1 21 3.5v3.25c0 1.33-.94 2.44-2.2 2.7.34 5.18 2.16 8.3 2.8 9.26.24.35.4.78.4 1.25l-.01.2c-.1.97-.86 1.73-1.82 1.83l-.21.01h-6.67q.55-.63.68-1.5h5.99l.1-.01a.5.5 0 0 0 .43-.42l.01-.11a1 1 0 0 0-.14-.41c-.8-1.18-2.87-4.81-3.09-10.77a.75.75 0 0 1 .75-.78h.23c.69 0 1.25-.56 1.25-1.25V3.5h-.23c-.4 0-.74.33-.75.73l-.02 1.03a.75.75 0 0 1-1.5-.01V4a.5.5 0 0 0-1 0v1.33a.75.75 0 0 1-1.5-.07l-.02-1.03c0-.4-.34-.73-.75-.73h-.23v3.25c0 .69.56 1.25 1.25 1.25h.23a.75.75 0 0 1 .75.78 22 22 0 0 1-2.35 9.51 3 3 0 0 0-.45-.48 6 6 0 0 1-.65-.67 21 21 0 0 0 1.91-7.7A2.75 2.75 0 0 1 12 6.75V3.5c0-.83.67-1.5 1.5-1.5zM7.5 7.5a2 2 0 0 0-1.54 3.27.75.75 0 0 1-.58 1.23h-.63a.75.75 0 0 0 0 1.5h.98a.75.75 0 0 1 .75.8 8 8 0 0 1-2.76 5.38.6.6 0 0 0-.22.43v.08c.04.18.2.31.39.31h7.3a.4.4 0 0 0 .3-.31l.01-.08a.6.6 0 0 0-.22-.43 8 8 0 0 1-2.76-5.38.75.75 0 0 1 .75-.8h1.06a.75.75 0 0 0-.08-1.5h-.63a.75.75 0 0 1-.58-1.23q.45-.53.46-1.27a2 2 0 0 0-2-2"
]);
const $77e1bce0ac0f7fe7$export$2a5fc15f81ec94fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown12Filled', "12", [
    "M6 1a5 5 0 1 1 0 10A5 5 0 0 1 6 1m1.85 4.85a.5.5 0 1 0-.7-.7L6 6.29 4.85 5.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $77e1bce0ac0f7fe7$export$92bb7fb515b03540 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown12Regular', "12", [
    "M7.85 5.85a.5.5 0 1 0-.7-.7L6 6.29 4.85 5.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0M6 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
]);
const $77e1bce0ac0f7fe7$export$7a0b860e2a65abc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m3.35 5.65a.5.5 0 0 0-.7 0L8 9.29 5.35 6.65a.5.5 0 1 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$3778e7909b62ebd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2m2.65 4.65a.5.5 0 1 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-3-3a.5.5 0 1 1 .7-.7L8 9.29z"
]);
const $77e1bce0ac0f7fe7$export$7d37a2cba0b2aabd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m4.85-1.85a.5.5 0 1 0-.7.7l3.5 3.5a.5.5 0 0 0 .7 0l3.5-3.5a.5.5 0 0 0-.7-.7L10 11.29z"
]);
const $77e1bce0ac0f7fe7$export$4c42ab072de1faae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown20Regular', "20", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16M6.85 8.15a.5.5 0 1 0-.7.7l3.5 3.5a.5.5 0 0 0 .7 0l3.5-3.5a.5.5 0 0 0-.7-.7L10 11.29z"
]);
const $77e1bce0ac0f7fe7$export$46969c85cd00773f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20M7.47 9.97c-.3.3-.3.77 0 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L12 13.44 8.53 9.97a.75.75 0 0 0-1.06 0"
]);
const $77e1bce0ac0f7fe7$export$3c40ad3419582687 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M7.47 9.97c.3-.3.77-.3 1.06 0L12 13.44l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$99812d3e1b65a8c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown28Filled', "28", [
    "M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0m7.03-2.78a.75.75 0 0 0-1.06 1.06l5.5 5.5c.3.3.77.3 1.06 0l5.5-5.5a.75.75 0 1 0-1.06-1.06L14 16.19z"
]);
const $77e1bce0ac0f7fe7$export$c9e9ba1edf9c74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown28Regular', "28", [
    "M3.5 14a10.5 10.5 0 1 1 21 0 10.5 10.5 0 0 1-21 0M14 2a12 12 0 1 0 0 24 12 12 0 0 0 0-24m-4.97 9.22a.75.75 0 0 0-1.06 1.06l5.5 5.5c.3.3.77.3 1.06 0l5.5-5.5a.75.75 0 1 0-1.06-1.06L14 16.19z"
]);
const $77e1bce0ac0f7fe7$export$f2b826ba95e374b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown32Filled', "32", [
    "M16 2a14 14 0 1 1 0 28 14 14 0 0 1 0-28m6.7 12.7a1 1 0 0 0-1.4-1.4L16 18.58l-5.3-5.3a1 1 0 0 0-1.4 1.42l5.87 5.88.03.02.08.08q.31.3.72.29.38 0 .72-.3.06-.03.1-.1z"
]);
const $77e1bce0ac0f7fe7$export$23dbeaa81ff24b27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown32Regular', "32", [
    "M22.7 14.7a1 1 0 0 0-1.4-1.4L16 18.58l-5.3-5.3a1 1 0 0 0-1.4 1.42l5.87 5.88.03.02.08.08q.31.3.72.29.38 0 .72-.3.06-.03.1-.1zM30 16a14 14 0 1 0-28 0 14 14 0 0 0 28 0M16 4a12 12 0 1 1 0 24 12 12 0 0 1 0-24"
]);
const $77e1bce0ac0f7fe7$export$771e26bd3c76cabb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown48Filled', "48", [
    "M24 44a20 20 0 1 0 0-40 20 20 0 0 0 0 40m-8.62-23.63L24 28.98l8.62-8.61a1.25 1.25 0 0 1 1.76 1.76l-9.5 9.5c-.48.5-1.28.5-1.76 0l-9.5-9.5a1.25 1.25 0 0 1 1.76-1.76"
]);
const $77e1bce0ac0f7fe7$export$30abd1c0041c4fa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 1 35 0 17.5 17.5 0 0 1-35 0M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40m-8.62 16.37a1.25 1.25 0 0 0-1.76 1.76l9.5 9.5c.48.5 1.28.5 1.76 0l9.5-9.5a1.25 1.25 0 0 0-1.76-1.76L24 28.98z"
]);
const $77e1bce0ac0f7fe7$export$904a433301365dbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft12Filled', "12", [
    "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M6.15 7.85a.5.5 0 1 0 .7-.7L5.71 6l1.14-1.15a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7z"
]);
const $77e1bce0ac0f7fe7$export$8128867870ce7039 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft12Regular', "12", [
    "M6.15 7.85a.5.5 0 1 0 .7-.7L5.71 6l1.14-1.15a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7zM6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m4-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
]);
const $77e1bce0ac0f7fe7$export$6018bfb20d7df034 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m1.35 3.65a.5.5 0 0 0-.7 0l-3 3a.5.5 0 0 0 0 .7l3 3a.5.5 0 1 0 .7-.7L6.71 8l2.64-2.65a.5.5 0 0 0 0-.7"
]);
const $77e1bce0ac0f7fe7$export$b108056a2c74185d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2m.65 2.65a.5.5 0 1 1 .7.7L6.71 8l2.64 2.65a.5.5 0 1 1-.7.7l-3-3a.5.5 0 0 1 0-.7z"
]);
const $77e1bce0ac0f7fe7$export$2d03c751266431d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m1.85 4.85a.5.5 0 0 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L8.71 10z"
]);
const $77e1bce0ac0f7fe7$export$104109799aa0071e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft20Regular', "20", [
    "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14m8 7a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-6.15-3.15a.5.5 0 0 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L8.71 10z"
]);
const $77e1bce0ac0f7fe7$export$95e4f5c9b7ba3a36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft24Filled', "24", [
    "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0m-7.97-4.53a.75.75 0 0 0-1.06 0l-4 4c-.3.3-.3.77 0 1.06l4 4a.75.75 0 1 0 1.06-1.06L10.56 12l3.47-3.47c.3-.3.3-.77 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$d5e829d578f1ab60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft24Regular', "24", [
    "M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0m-1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-6.47 4.53c.3-.3.3-.77 0-1.06L10.56 12l3.47-3.47a.75.75 0 0 0-1.06-1.06l-4 4c-.3.3-.3.77 0 1.06l4 4c.3.3.77.3 1.06 0"
]);
const $77e1bce0ac0f7fe7$export$fff2773883ed9d8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft28Filled', "28", [
    "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24m2.78 7.03a.75.75 0 0 0-1.06-1.06l-5.5 5.5c-.3.3-.3.77 0 1.06l5.5 5.5a.75.75 0 1 0 1.06-1.06L11.81 14z"
]);
const $77e1bce0ac0f7fe7$export$f0ab9b343a015b8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft28Regular', "28", [
    "M14 3.5a10.5 10.5 0 1 1 0 21 10.5 10.5 0 0 1 0-21M26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0m-9.22-4.97a.75.75 0 0 0-1.06-1.06l-5.5 5.5c-.3.3-.3.77 0 1.06l5.5 5.5a.75.75 0 1 0 1.06-1.06L11.81 14z"
]);
const $77e1bce0ac0f7fe7$export$71a12b46f0f4d6af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft32Filled', "32", [
    "M30 16a14 14 0 1 1-28 0 14 14 0 0 1 28 0m-12.7 6.7a1 1 0 0 0 1.4-1.4L13.42 16l5.3-5.3a1 1 0 0 0-1.42-1.4l-5.88 5.87-.02.03-.08.08a1 1 0 0 0-.29.72q0 .38.3.72.03.06.1.1z"
]);
const $77e1bce0ac0f7fe7$export$78670066bf5e0498 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft32Regular', "32", [
    "M17.3 22.7a1 1 0 0 0 1.4-1.4L13.42 16l5.3-5.3a1 1 0 0 0-1.42-1.4l-5.88 5.87-.02.03-.08.08a1 1 0 0 0-.29.72q0 .38.3.72.03.06.1.1zM16 30a14 14 0 1 0 0-28 14 14 0 0 0 0 28m12-14a12 12 0 1 1-24 0 12 12 0 0 1 24 0"
]);
const $77e1bce0ac0f7fe7$export$af27e8bdc93dab8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft48Filled', "48", [
    "M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40m3.63 28.62a1.25 1.25 0 0 1-1.76 1.76l-9.5-9.5a1.25 1.25 0 0 1 0-1.76l9.5-9.5a1.25 1.25 0 0 1 1.76 1.76L19.02 24z"
]);
const $77e1bce0ac0f7fe7$export$ddce28bd1fef545a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft48Regular', "48", [
    "M24 41.5a17.5 17.5 0 1 0 0-35 17.5 17.5 0 0 0 0 35M44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0m-16.37 8.62a1.25 1.25 0 0 1-1.76 1.76l-9.5-9.5a1.25 1.25 0 0 1 0-1.76l9.5-9.5a1.25 1.25 0 0 1 1.76 1.76L19.02 24z"
]);
const $77e1bce0ac0f7fe7$export$92f4311a039112bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight12Filled', "12", [
    "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6m4.85-1.85a.5.5 0 1 0-.7.7L6.29 6 5.15 7.15a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7z"
]);
const $77e1bce0ac0f7fe7$export$df56548f94a0a3da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight12Regular', "12", [
    "M5.85 4.15a.5.5 0 1 0-.7.7L6.29 6 5.15 7.15a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zM6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
]);
const $77e1bce0ac0f7fe7$export$81c418a43ec310a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m-.65 3.65a.5.5 0 1 0-.7.7L9.29 8l-2.64 2.65a.5.5 0 1 0 .7.7l3-3a.5.5 0 0 0 0-.7z"
]);
const $77e1bce0ac0f7fe7$export$dd5e35c7227a08c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2M6.65 4.65c.2-.2.5-.2.7 0l3 3c.2.2.2.5 0 .7l-3 3a.5.5 0 1 1-.7-.7L9.29 8 6.65 5.35a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$a0d02266f49d3bae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight20Filled', "20", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m-1.85-4.85a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 1 0-.7.7L11.29 10z"
]);
const $77e1bce0ac0f7fe7$export$5bb269e0ecdc948c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight20Regular', "20", [
    "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14m-8-7a8 8 0 1 0 16 0 8 8 0 0 0-16 0m6.15 3.15a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 1 0-.7.7L11.29 10z"
]);
const $77e1bce0ac0f7fe7$export$3c2a0a7d43b5992f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight24Filled', "24", [
    "M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0m7.97 4.53c.3.3.77.3 1.06 0l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06L13.44 12l-3.47 3.47c-.3.3-.3.77 0 1.06"
]);
const $77e1bce0ac0f7fe7$export$7b8aa18793a831a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight24Regular', "24", [
    "M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0m1.5 0a8.5 8.5 0 1 0 17 0 8.5 8.5 0 0 0-17 0m6.47 4.53a.75.75 0 0 1 0-1.06L13.44 12 9.97 8.53a.75.75 0 0 1 1.06-1.06l4 4c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0"
]);
const $77e1bce0ac0f7fe7$export$485566085279e83b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight28Filled', "28", [
    "M14 26a12 12 0 1 1 0-24 12 12 0 0 1 0 24m-2.78-7.03a.75.75 0 1 0 1.06 1.06l5.5-5.5c.3-.3.3-.77 0-1.06l-5.5-5.5a.75.75 0 1 0-1.06 1.06L16.19 14z"
]);
const $77e1bce0ac0f7fe7$export$6a9f703c258a9d96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight28Regular', "28", [
    "M14 24.5a10.5 10.5 0 1 1 0-21 10.5 10.5 0 0 1 0 21M2 14a12 12 0 1 0 24 0 12 12 0 0 0-24 0m9.22 4.97a.75.75 0 1 0 1.06 1.06l5.5-5.5c.3-.3.3-.77 0-1.06l-5.5-5.5a.75.75 0 1 0-1.06 1.06L16.19 14z"
]);
const $77e1bce0ac0f7fe7$export$7f3d12da9a51b120 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0m12.7-6.7a1 1 0 1 0-1.4 1.4l5.29 5.3-5.3 5.3a1 1 0 0 0 1.42 1.4l5.88-5.87.02-.03.08-.08a1 1 0 0 0 .29-.72q0-.37-.3-.72l-.1-.1z"
]);
const $77e1bce0ac0f7fe7$export$493a4b59a172549f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight32Regular', "32", [
    "M14.7 9.3a1 1 0 1 0-1.4 1.4l5.29 5.3-5.3 5.3a1 1 0 0 0 1.42 1.4l5.88-5.87.02-.03.08-.08a1 1 0 0 0 .29-.72q0-.37-.3-.72l-.1-.1zM16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0"
]);
const $77e1bce0ac0f7fe7$export$d3a4ca90ed7d8a38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m-3.63 28.62a1.25 1.25 0 0 0 1.76 1.76l9.5-9.5c.5-.48.5-1.28 0-1.76l-9.5-9.5a1.25 1.25 0 0 0-1.76 1.76L28.98 24z"
]);
const $77e1bce0ac0f7fe7$export$974274cfbf4bd495 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight48Regular', "48", [
    "M24 41.5a17.5 17.5 0 1 1 0-35 17.5 17.5 0 0 1 0 35M4 24a20 20 0 1 0 40 0 20 20 0 0 0-40 0m16.37 8.62a1.25 1.25 0 0 0 1.76 1.76l9.5-9.5c.5-.48.5-1.28 0-1.76l-9.5-9.5a1.25 1.25 0 0 0-1.76 1.76L28.98 24z"
]);
const $77e1bce0ac0f7fe7$export$29f23d08c7df2b19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp12Filled', "12", [
    "M6 11A5 5 0 1 1 6 1a5 5 0 0 1 0 10M4.15 6.15a.5.5 0 1 0 .7.7L6 5.71l1.15 1.14a.5.5 0 1 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0z"
]);
const $77e1bce0ac0f7fe7$export$1fcda9f032aec311 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp12Regular', "12", [
    "M4.15 6.15a.5.5 0 1 0 .7.7L6 5.71l1.15 1.14a.5.5 0 1 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0zM1 6a5 5 0 1 0 10 0A5 5 0 0 0 1 6m5 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
]);
const $77e1bce0ac0f7fe7$export$67f469f9207c5e21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m.35 4.65a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L8 6.71l2.65 2.64a.5.5 0 1 0 .7-.7z"
]);
const $77e1bce0ac0f7fe7$export$895adcdab6200bd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2m-.35 3.65c.2-.2.5-.2.7 0l3 3a.5.5 0 1 1-.7.7L8 6.71 5.35 9.35a.5.5 0 1 1-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$daf871f7bcf829d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp20Filled', "20", [
    "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m4.85 1.85a.5.5 0 0 1-.7-.7l3.5-3.5a.5.5 0 0 1 .7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 8.71z"
]);
const $77e1bce0ac0f7fe7$export$dbd5cdfadcdacc66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp20Regular', "20", [
    "M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0m7 8a8 8 0 1 1 0-16 8 8 0 0 1 0 16m-3.15-6.15a.5.5 0 0 1-.7-.7l3.5-3.5a.5.5 0 0 1 .7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 8.71z"
]);
const $77e1bce0ac0f7fe7$export$bf727b9f8d87cd09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp24Filled', "24", [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20m-4.53-7.97a.75.75 0 0 1 0-1.06l4-4c.3-.3.77-.3 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12 10.56l-3.47 3.47c-.3.3-.77.3-1.06 0"
]);
const $77e1bce0ac0f7fe7$export$dc3e2f23f8903f31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp24Regular', "24", [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20m0-1.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17m-4.53-6.47c.3.3.77.3 1.06 0L12 10.56l3.47 3.47a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4c-.3.3-.3.77 0 1.06"
]);
const $77e1bce0ac0f7fe7$export$a1445298ccf0a32d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp28Filled', "28", [
    "M2 14a12 12 0 1 0 24 0 12 12 0 0 0-24 0m7.03 2.78a.75.75 0 0 1-1.06-1.06l5.5-5.5c.3-.3.77-.3 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06L14 11.81z"
]);
const $77e1bce0ac0f7fe7$export$45cbbd3e4641b50a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp28Regular', "28", [
    "M3.5 14a10.5 10.5 0 1 0 21 0 10.5 10.5 0 0 0-21 0M14 26a12 12 0 1 1 0-24 12 12 0 0 1 0 24m-4.97-9.22a.75.75 0 0 1-1.06-1.06l5.5-5.5c.3-.3.77-.3 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06L14 11.81z"
]);
const $77e1bce0ac0f7fe7$export$efffbe4450e13e07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp32Filled', "32", [
    "M16 30a14 14 0 1 1 0-28 14 14 0 0 1 0 28M9.3 17.3a1 1 0 1 0 1.4 1.4l5.3-5.29 5.3 5.3a1 1 0 0 0 1.4-1.42l-5.87-5.88-.03-.02-.08-.08a1 1 0 0 0-.72-.29q-.37 0-.72.3-.06.03-.1.1z"
]);
const $77e1bce0ac0f7fe7$export$62fec6f273e2bbdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp32Regular', "32", [
    "M4 16a12 12 0 1 0 24 0 12 12 0 0 0-24 0m12 14a14 14 0 1 1 0-28 14 14 0 0 1 0 28M9.3 18.7a1 1 0 0 1 0-1.4l5.87-5.89.11-.1q.35-.3.72-.29a1 1 0 0 1 .72.3l.1.1 5.89 5.87a1 1 0 0 1-1.42 1.42L16 13.4l-5.3 5.3a1 1 0 0 1-1.4 0"
]);
const $77e1bce0ac0f7fe7$export$a68e120449d233b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m-8.62 23.63L24 19.02l8.62 8.61a1.25 1.25 0 0 0 1.76-1.76l-9.5-9.5a1.25 1.25 0 0 0-1.76 0l-9.5 9.5a1.25 1.25 0 0 0 1.76 1.76"
]);
const $77e1bce0ac0f7fe7$export$e4601fd42072bf8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 0 35 0 17.5 17.5 0 0 0-35 0M24 44a20 20 0 1 1 0-40 20 20 0 0 1 0 40m-8.62-16.37a1.25 1.25 0 0 1-1.76-1.76l9.5-9.5a1.25 1.25 0 0 1 1.76 0l9.5 9.5a1.25 1.25 0 0 1-1.76 1.76L24 19.02z"
]);
const $77e1bce0ac0f7fe7$export$fd7b76e13d57b45f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown16Filled', "16", [
    "M11.72 7.97a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 9.03a.75.75 0 1 1 1.06-1.06L8 11.69zm0-4.5a.75.75 0 1 1 1.06 1.06L8.53 8.78a.75.75 0 0 1-1.06 0L3.22 4.53a.75.75 0 1 1 1.06-1.06L8 7.19z"
]);
const $77e1bce0ac0f7fe7$export$ff764729d76295c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown16Regular', "16", [
    "M3.15 7.65c.2-.2.5-.2.7 0L8 11.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5-.07.07a.5.5 0 0 1-.63-.07l-4.5-4.5a.5.5 0 0 1 0-.7m0-4c.2-.2.5-.2.7 0L8 7.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5-.07.07a.5.5 0 0 1-.63-.07l-4.5-4.5-.07-.07a.5.5 0 0 1 .07-.63"
]);
const $77e1bce0ac0f7fe7$export$a7fd08e94ec759f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown20Filled', "20", [
    "M14.72 9.97a.75.75 0 1 1 1.06 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0l-5.25-5.25a.75.75 0 1 1 1.06-1.06L10 14.69zm0-5.5a.75.75 0 1 1 1.06 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0L4.22 5.53a.75.75 0 1 1 1.06-1.06L10 9.19z"
]);
const $77e1bce0ac0f7fe7$export$7d4392ac1163682d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown20Regular', "20", [
    "M15.15 9.65a.5.5 0 1 1 .7.7l-5.5 5.5a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L10 14.79zm0-5a.5.5 0 1 1 .7.7l-5.5 5.5a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L10 9.79z"
]);
const $77e1bce0ac0f7fe7$export$9c9ed1eca4959a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft16Filled', "16", [
    "M6.97 3.22a.75.75 0 1 1 1.06 1.06L4.31 8l3.72 3.72a.75.75 0 1 1-1.06 1.06L2.72 8.53a.75.75 0 0 1 0-1.06zm4.5 0a.75.75 0 1 1 1.06 1.06L8.81 8l3.72 3.72a.75.75 0 1 1-1.06 1.06L7.22 8.53a.75.75 0 0 1 0-1.06z"
]);
const $77e1bce0ac0f7fe7$export$e8fd97f848a43b69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft16Regular', "16", [
    "M7.65 3.15a.5.5 0 0 1 .7.7L4.21 8l4.14 4.15a.5.5 0 1 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7zm4 0a.5.5 0 0 1 .7.7L8.21 8l4.14 4.15a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7z"
]);
const $77e1bce0ac0f7fe7$export$fcd375a494703178 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft20Filled', "20", [
    "M8.97 4.22a.75.75 0 1 1 1.06 1.06L5.31 10l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06zm5.5 0a.75.75 0 1 1 1.06 1.06L10.81 10l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06z"
]);
const $77e1bce0ac0f7fe7$export$9a922493494456e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft20Regular', "20", [
    "M9.65 4.15a.5.5 0 1 1 .7.7L5.21 10l5.14 5.15a.5.5 0 1 1-.7.7l-5.5-5.5a.5.5 0 0 1 0-.7zm5 0a.5.5 0 1 1 .7.7L10.21 10l5.14 5.15a.5.5 0 1 1-.7.7l-5.5-5.5a.5.5 0 0 1 0-.7z"
]);
const $77e1bce0ac0f7fe7$export$abf125fb9a9bf8de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight16Filled', "16", [
    "M3.47 3.22c.3-.3.77-.3 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L7.19 8 3.47 4.28a.75.75 0 0 1 0-1.06m4.5 0c.3-.3.77-.3 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.69 8 7.97 4.28a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$8dbabd4110ba48b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight16Regular', "16", [
    "M3.65 3.15c.2-.2.5-.2.7 0l4.5 4.5a.5.5 0 0 1 0 .7l-4.5 4.5a.5.5 0 0 1-.7-.7L7.79 8 3.65 3.85a.5.5 0 0 1 0-.7m4 0c.2-.2.5-.2.7 0l4.5 4.5a.5.5 0 0 1 .14.45.5.5 0 0 1-.14.25l-4.5 4.5a.5.5 0 0 1-.7-.7L11.79 8 7.65 3.85a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$6b251f47ce55b0f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight20Filled', "20", [
    "M4.47 4.22c.3-.3.77-.3 1.06 0l5.25 5.25c.3.3.3.77 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L9.19 10 4.47 5.28a.75.75 0 0 1 0-1.06m5.5 0c.3-.3.77-.3 1.06 0l5.25 5.25c.3.3.3.77 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L14.69 10 9.97 5.28a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$af346d6b32bc19f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight20Regular', "20", [
    "M4.65 4.15c.2-.2.5-.2.7 0l5.5 5.5a.5.5 0 0 1 0 .7l-5.5 5.5a.5.5 0 1 1-.7-.7L9.79 10 4.65 4.85a.5.5 0 0 1 0-.7m5 0c.2-.2.5-.2.7 0l5.5 5.5a.5.5 0 0 1 0 .7l-5.5 5.5a.5.5 0 1 1-.7-.7L14.79 10 9.65 4.85a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$500d38468ba4ecf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp16Filled', "16", [
    "M8 7q.31 0 .53.22l4.25 4.25a.75.75 0 0 1-1.06 1.06L8 8.81l-3.72 3.72a.75.75 0 1 1-1.06-1.06l4.25-4.25A.8.8 0 0 1 8 7m0-4.5q.31 0 .53.22l4.25 4.25a.75.75 0 0 1-1.06 1.06L8 4.31 4.28 8.03a.75.75 0 1 1-1.06-1.06l4.25-4.25A.8.8 0 0 1 8 2.5"
]);
const $77e1bce0ac0f7fe7$export$d59d2a13e91c7dc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp16Regular', "16", [
    "M7.72 7.08a.5.5 0 0 1 .63.07l4.5 4.5.07.08a.5.5 0 0 1-.14.69.5.5 0 0 1-.63-.07L8 8.21l-4.15 4.14a.5.5 0 0 1-.7-.7l4.5-4.5zm0-4a.5.5 0 0 1 .63.07l4.5 4.5.07.08a.5.5 0 0 1-.14.69.5.5 0 0 1-.63-.07L8 4.21 3.85 8.35a.5.5 0 0 1-.7-.7l4.5-4.5z"
]);
const $77e1bce0ac0f7fe7$export$9f2809b57388f3ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp20Filled', "20", [
    "M9.47 9.22c.3-.3.77-.3 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06L10 10.81l-4.72 4.72a.75.75 0 0 1-1.06-1.06zm0-5.5c.3-.3.77-.3 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06L10 5.31l-4.72 4.72a.75.75 0 0 1-1.06-1.06z"
]);
const $77e1bce0ac0f7fe7$export$a621f83a0f4938c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp20Regular', "20", [
    "M10 9a.5.5 0 0 1 .35.15l5.5 5.5a.5.5 0 0 1-.7.7L10 10.21l-5.15 5.14a.5.5 0 1 1-.7-.7l5.5-5.5A.5.5 0 0 1 10 9m0-5a.5.5 0 0 1 .35.15l5.5 5.5a.5.5 0 0 1-.7.7L10 5.21l-5.15 5.14a.5.5 0 1 1-.7-.7l5.5-5.5A.5.5 0 0 1 10 4"
]);
const $77e1bce0ac0f7fe7$export$8ede359537058d1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown12Filled', "12", [
    "M2.22 4.47c.3-.3.77-.3 1.06 0L6 7.19l2.72-2.72a.75.75 0 0 1 1.06 1.06L6.53 8.78c-.3.3-.77.3-1.06 0L2.22 5.53a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$31cf9241c3bcfc42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown12Regular', "12", [
    "M2.15 4.65c.2-.2.5-.2.7 0L6 7.79l3.15-3.14a.5.5 0 1 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$92a412ced084861c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown16Filled', "16", [
    "M3.2 5.74a.75.75 0 0 1 1.06-.04L8 9.23l3.74-3.53a.75.75 0 1 1 1.02 1.1l-4.25 4a.75.75 0 0 1-1.02 0l-4.25-4a.75.75 0 0 1-.04-1.06"
]);
const $77e1bce0ac0f7fe7$export$4c6c51570726ab4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown16Regular', "16", [
    "M3.15 5.65c.2-.2.5-.2.7 0L8 9.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$c09e9bddba195db4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown20Filled', "20", [
    "M15.8 7.73c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 0 1-1.04 0l-5.25-5a.75.75 0 0 1 1.04-1.08L10 12.2l4.73-4.5a.75.75 0 0 1 1.06.02"
]);
const $77e1bce0ac0f7fe7$export$c582cc3ceb1d3030 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown20Regular', "20", [
    "M15.85 7.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 0 1-.78 0L4.15 8.35a.5.5 0 1 1 .7-.7L10 12.8l5.15-5.16c.2-.2.5-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$6b6bd648af0cd5d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown24Filled', "24", [
    "M4.3 8.3a1 1 0 0 1 1.4 0l6.3 6.29 6.3-6.3a1 1 0 1 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-7-7a1 1 0 0 1 0-1.42"
]);
const $77e1bce0ac0f7fe7$export$ecee63a4f5c6a76d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown24Regular', "24", [
    "M4.22 8.47c.3-.3.77-.3 1.06 0L12 15.19l6.72-6.72a.75.75 0 1 1 1.06 1.06l-7.25 7.25c-.3.3-.77.3-1.06 0L4.22 9.53a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$1b543d00c743dec3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown28Filled', "28", [
    "M4.3 9.3a1 1 0 0 1 1.4 0l8.3 8.29 8.3-8.3a1 1 0 1 1 1.4 1.42l-9 9a1 1 0 0 1-1.4 0l-9-9a1 1 0 0 1 0-1.42"
]);
const $77e1bce0ac0f7fe7$export$45f8839e91670ccd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown28Regular', "28", [
    "M4.22 9.47c.3-.3.77-.3 1.06 0L14 18.19l8.72-8.72a.75.75 0 1 1 1.06 1.06l-9.25 9.25c-.3.3-.77.3-1.06 0l-9.25-9.25a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$527b558e877769af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown32Filled', "32", [
    "M5.37 11.12a1.25 1.25 0 0 1 1.76 0L16 19.98l8.87-8.86a1.25 1.25 0 0 1 1.76 1.76l-9.75 9.75c-.48.5-1.28.5-1.76 0l-9.75-9.75a1.25 1.25 0 0 1 0-1.76"
]);
const $77e1bce0ac0f7fe7$export$52bdca8f98cd0815 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown32Regular', "32", [
    "M5.3 11.3a1 1 0 0 1 1.4 0l9.3 9.29 9.3-9.3a1 1 0 0 1 1.4 1.42l-10 10a1 1 0 0 1-1.4 0l-10-10a1 1 0 0 1 0-1.42"
]);
const $77e1bce0ac0f7fe7$export$f57a8964e6697c6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown48Filled', "48", [
    "M8.44 15.94a1.5 1.5 0 0 1 2.12 0L24 29.38l13.44-13.44a1.5 1.5 0 0 1 2.12 2.12l-14.5 14.5a1.5 1.5 0 0 1-2.12 0l-14.5-14.5a1.5 1.5 0 0 1 0-2.12"
]);
const $77e1bce0ac0f7fe7$export$784ee78bee2794d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown48Regular', "48", [
    "M8.37 16.12a1.25 1.25 0 0 0 0 1.76l14.75 14.75c.48.5 1.28.5 1.76 0l14.75-14.75a1.25 1.25 0 0 0-1.76-1.76L24 29.98 10.13 16.12a1.25 1.25 0 0 0-1.76 0"
]);
const $77e1bce0ac0f7fe7$export$c5fec23d3a03b482 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp16Filled', "16", [
    "M11.78 3.53 8.53 6.78c-.3.3-.77.3-1.06 0L4.22 3.53a.75.75 0 0 1 1.06-1.06L8 5.19l2.72-2.72a.75.75 0 1 1 1.06 1.06M8.53 9.22a.75.75 0 0 0-1.06 0l-3.25 3.25a.75.75 0 1 0 1.06 1.06L8 10.81l2.72 2.72a.75.75 0 1 0 1.06-1.06z"
]);
const $77e1bce0ac0f7fe7$export$749942d6a9da2234 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp16Regular', "16", [
    "m11.85 3.35-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 1 1 .7-.7L8 5.79l3.15-3.14a.5.5 0 0 1 .7.7m0 9.3-3.5-3.5a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 .7.7L8 10.21l3.15 3.14a.5.5 0 0 0 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$2586da9e98756b7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp20Filled', "20", [
    "M6.28 2.97a.75.75 0 0 0-1.06 1.06l4.25 4.25c.3.3.77.3 1.06 0l4.25-4.25a.75.75 0 0 0-1.06-1.06L10 6.69zm8.5 13-4.25-4.25a.75.75 0 0 0-1.06 0l-4.25 4.25a.75.75 0 1 0 1.06 1.06L10 13.31l3.72 3.72a.75.75 0 1 0 1.06-1.06"
]);
const $77e1bce0ac0f7fe7$export$60aea861cac8a53e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp20Regular', "20", [
    "M5.85 3.15a.5.5 0 1 0-.7.7l4.5 4.5c.2.2.5.2.7 0l4.5-4.5a.5.5 0 0 0-.7-.7L10 7.29zm9 13-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 .7.7L10 12.71l4.15 4.14a.5.5 0 0 0 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$2dd3ef3d33ea37f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp24Filled', "24", [
    "M6.7 2.8a1 1 0 0 0-1.4 1.4l6 6a1 1 0 0 0 1.4 0l6-6a1 1 0 0 0-1.4-1.4L12 8.08zm0 18.4a1 1 0 0 1-1.4-1.4l6-6a1 1 0 0 1 1.4 0l6 6a1 1 0 0 1-1.4 1.4L12 15.92z"
]);
const $77e1bce0ac0f7fe7$export$bb1d80d6c6dbd119 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp24Regular', "24", [
    "M6.28 2.97a.75.75 0 0 0-1.06 1.06l6.25 6.25c.3.3.77.3 1.06 0l6.25-6.25a.75.75 0 0 0-1.06-1.06L12 8.69zm0 18.06a.75.75 0 0 1-1.06-1.06l6.25-6.25c.3-.3.77-.3 1.06 0l6.25 6.25a.75.75 0 1 1-1.06 1.06L12 15.31z"
]);
const $77e1bce0ac0f7fe7$export$e5e9255d4584e527 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft12Filled', "12", [
    "M7.53 2.22c.3.3.3.77 0 1.06L4.81 6l2.72 2.72a.75.75 0 0 1-1.06 1.06L3.22 6.53a.75.75 0 0 1 0-1.06l3.25-3.25c.3-.3.77-.3 1.06 0"
]);
const $77e1bce0ac0f7fe7$export$d227ddf35cadc99c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft12Regular', "12", [
    "M7.35 2.15c.2.2.2.5 0 .7L4.21 6l3.14 3.15a.5.5 0 1 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5c.2-.2.5-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$63ad940419973b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft16Filled', "16", [
    "M10.26 3.2c.3.28.32.76.04 1.06L6.77 8l3.53 3.74a.75.75 0 1 1-1.1 1.02l-4-4.25a.75.75 0 0 1 0-1.02l4-4.25a.75.75 0 0 1 1.06-.04"
]);
const $77e1bce0ac0f7fe7$export$be85cf8cb46d6189 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft16Regular', "16", [
    "M10.35 3.15c.2.2.2.5 0 .7L6.21 8l4.14 4.15a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0"
]);
const $77e1bce0ac0f7fe7$export$7ebf1e34ba329263 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft20Filled', "20", [
    "M12.27 15.8a.75.75 0 0 1-1.06-.03l-5-5.25a.75.75 0 0 1 0-1.04l5-5.25a.75.75 0 1 1 1.08 1.04L7.8 10l4.5 4.73c.29.3.28.78-.02 1.06"
]);
const $77e1bce0ac0f7fe7$export$9446244bdce3b644 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft20Regular', "20", [
    "M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7"
]);
const $77e1bce0ac0f7fe7$export$ecbc9bcc844d8cd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft24Filled', "24", [
    "M15.7 4.3a1 1 0 0 1 0 1.4L9.42 12l6.3 6.3a1 1 0 0 1-1.42 1.4l-7-7a1 1 0 0 1 0-1.4l7-7a1 1 0 0 1 1.42 0"
]);
const $77e1bce0ac0f7fe7$export$1e7ef057c950ea64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft24Regular', "24", [
    "M15.53 4.22c.3.3.3.77 0 1.06L8.81 12l6.72 6.72a.75.75 0 1 1-1.06 1.06l-7.25-7.25a.75.75 0 0 1 0-1.06l7.25-7.25c.3-.3.77-.3 1.06 0"
]);
const $77e1bce0ac0f7fe7$export$4327048b5a99e322 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft28Filled', "28", [
    "M18.46 23.2a1 1 0 0 1-1.42 0L8.3 14.47a1 1 0 0 1 0-1.42l8.75-8.75a1 1 0 1 1 1.42 1.42l-8.05 8.04 8.05 8.04a1 1 0 0 1 0 1.42"
]);
const $77e1bce0ac0f7fe7$export$bbf8eba905ce46c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft28Regular', "28", [
    "M18.03 22.78c-.3.3-.77.3-1.06 0l-8.75-8.75a.75.75 0 0 1 0-1.06l8.75-8.75a.75.75 0 1 1 1.06 1.06L9.81 13.5l8.22 8.22c.3.3.3.77 0 1.06"
]);
const $77e1bce0ac0f7fe7$export$db024ea3edd86f12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft32Filled', "32", [
    "M20.88 5.37c.5.48.5 1.28 0 1.76L12.02 16l8.86 8.87a1.25 1.25 0 0 1-1.76 1.76l-9.75-9.75a1.25 1.25 0 0 1 0-1.76l9.75-9.75a1.25 1.25 0 0 1 1.76 0"
]);
const $77e1bce0ac0f7fe7$export$a574d9218f744319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft32Regular', "32", [
    "M20.7 5.3a1 1 0 0 1 0 1.4L11.42 16l9.3 9.3a1 1 0 0 1-1.42 1.4l-10-10a1 1 0 0 1 0-1.4l10-10a1 1 0 0 1 1.42 0"
]);
const $77e1bce0ac0f7fe7$export$5e6f503203d79ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft48Filled', "48", [
    "M32.06 8.19a1.5 1.5 0 0 1 0 2.12L18.62 23.75l13.44 13.44a1.5 1.5 0 0 1-2.12 2.12l-14.5-14.5a1.5 1.5 0 0 1 0-2.12l14.5-14.5a1.5 1.5 0 0 1 2.12 0"
]);
const $77e1bce0ac0f7fe7$export$8d123056d8c9e13d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft48Regular', "48", [
    "M31.88 8.37c.5.48.5 1.28 0 1.76L18.02 24l13.86 13.87a1.25 1.25 0 0 1-1.76 1.76L15.37 24.88a1.25 1.25 0 0 1 0-1.76L30.12 8.37a1.25 1.25 0 0 1 1.76 0"
]);
const $77e1bce0ac0f7fe7$export$5a89398dca6fb05f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight12Filled', "12", [
    "M4.47 2.22c-.3.3-.3.77 0 1.06L7.19 6 4.47 8.72a.75.75 0 0 0 1.06 1.06l3.25-3.25c.3-.3.3-.77 0-1.06L5.53 2.22a.75.75 0 0 0-1.06 0"
]);
const $77e1bce0ac0f7fe7$export$33afbe898eda2576 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight12Regular', "12", [
    "M4.65 2.15a.5.5 0 0 0 0 .7L7.79 6 4.65 9.15a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 0 0-.7 0"
]);
const $77e1bce0ac0f7fe7$export$8d7a50ae66cb8fce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight16Filled', "16", [
    "M5.74 3.2a.75.75 0 0 0-.04 1.06L9.23 8 5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04"
]);
const $77e1bce0ac0f7fe7$export$b85c2ddf81cdbdc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight16Regular', "16", [
    "M5.65 3.15a.5.5 0 0 0 0 .7L9.79 8l-4.14 4.15a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7l-4.5-4.5a.5.5 0 0 0-.7 0"
]);
const $77e1bce0ac0f7fe7$export$8676d73c4ff1ee29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight20Filled', "20", [
    "M7.73 4.2a.75.75 0 0 1 1.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 1 1-1.08-1.04L12.2 10l-4.5-4.73a.75.75 0 0 1 .02-1.06"
]);
const $77e1bce0ac0f7fe7$export$e3f0d4752148cea7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight20Regular', "20", [
    "M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.47a.5.5 0 0 1-.7-.71L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$2e16027e8fd2aad9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight24Filled', "24", [
    "M8.3 4.3a1 1 0 0 0 0 1.4l6.29 6.3-6.3 6.3a1 1 0 1 0 1.42 1.4l7-7a1 1 0 0 0 0-1.4l-7-7a1 1 0 0 0-1.42 0"
]);
const $77e1bce0ac0f7fe7$export$1478f2ef8eb23ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight24Regular', "24", [
    "M8.47 4.22c-.3.3-.3.77 0 1.06L15.19 12l-6.72 6.72a.75.75 0 1 0 1.06 1.06l7.25-7.25c.3-.3.3-.77 0-1.06L9.53 4.22a.75.75 0 0 0-1.06 0"
]);
const $77e1bce0ac0f7fe7$export$26d7fba6e4399c77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight28Filled', "28", [
    "M9.54 4.3a1 1 0 0 1 1.42 0l8.75 8.74a1 1 0 0 1 0 1.42l-8.75 8.75a1 1 0 0 1-1.42-1.42l8.05-8.04-8.05-8.04a1 1 0 0 1 0-1.42"
]);
const $77e1bce0ac0f7fe7$export$9a984518e841eda5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight28Regular', "28", [
    "M9.97 4.22c.3-.3.77-.3 1.06 0l8.75 8.75a.75.75 0 0 1 0 1.06l-8.75 8.75a.75.75 0 1 1-1.06-1.06l8.22-8.22-8.22-8.22a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$7e82dc392daa4f71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight32Filled', "32", [
    "M11.12 26.63a1.25 1.25 0 0 1 0-1.76L19.98 16l-8.86-8.87a1.25 1.25 0 0 1 1.76-1.76l9.75 9.75c.5.48.5 1.28 0 1.76l-9.75 9.75c-.48.5-1.28.5-1.76 0"
]);
const $77e1bce0ac0f7fe7$export$713536791546a81f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight32Regular', "32", [
    "M11.3 26.7a1 1 0 0 1 0-1.4l9.29-9.3-9.3-9.3a1 1 0 0 1 1.42-1.4l10 10a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-1.42 0"
]);
const $77e1bce0ac0f7fe7$export$d83ad5de52b5cdcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight48Filled', "48", [
    "M15.94 39.31a1.5 1.5 0 0 1 0-2.12l13.44-13.44-13.44-13.44a1.5 1.5 0 0 1 2.12-2.12l14.5 14.5a1.5 1.5 0 0 1 0 2.12l-14.5 14.5a1.5 1.5 0 0 1-2.12 0"
]);
const $77e1bce0ac0f7fe7$export$1d703fde24f47fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight48Regular', "48", [
    "M16.12 39.63a1.25 1.25 0 0 1 0-1.76L29.98 24 16.12 10.13a1.25 1.25 0 0 1 1.76-1.76l14.75 14.75c.5.48.5 1.28 0 1.76L17.88 39.63c-.48.5-1.28.5-1.76 0"
]);
const $77e1bce0ac0f7fe7$export$fe506f26b56b6a5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp12Filled', "12", [
    "M2.22 7.53c.3.3.77.3 1.06 0L6 4.81l2.72 2.72a.75.75 0 0 0 1.06-1.06L6.53 3.22a.75.75 0 0 0-1.06 0L2.22 6.47c-.3.3-.3.77 0 1.06"
]);
const $77e1bce0ac0f7fe7$export$64d34f52799e5dfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp12Regular', "12", [
    "M2.15 7.35c.2.2.5.2.7 0L6 4.21l3.15 3.14a.5.5 0 1 0 .7-.7l-3.5-3.5a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 0 .7"
]);
const $77e1bce0ac0f7fe7$export$1c0fdd1f968e84c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp16Filled', "16", [
    "M3.2 10.26c.28.3.76.32 1.06.04L8 6.77l3.74 3.53a.75.75 0 1 0 1.02-1.1l-4.25-4a.75.75 0 0 0-1.02 0l-4.25 4a.75.75 0 0 0-.04 1.06"
]);
const $77e1bce0ac0f7fe7$export$5fc3128e974fde90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp16Regular', "16", [
    "M3.15 10.35c.2.2.5.2.7 0L8 6.21l4.15 4.14a.5.5 0 0 0 .7-.7l-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 0 .7"
]);
const $77e1bce0ac0f7fe7$export$c26ed8d9fef79842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp20Filled', "20", [
    "M4.2 12.27a.75.75 0 0 1 .03-1.06l5.25-5a.75.75 0 0 1 1.04 0l5.25 5a.75.75 0 0 1-1.04 1.08L10 7.8l-4.73 4.5a.75.75 0 0 1-1.06-.02"
]);
const $77e1bce0ac0f7fe7$export$2fb99f3cc19a5e86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp20Regular', "20", [
    "M4.15 12.35a.5.5 0 0 1 0-.7L9.6 6.16a.55.55 0 0 1 .78 0l5.47 5.49a.5.5 0 0 1-.71.7L10 7.2l-5.15 5.16a.5.5 0 0 1-.7 0"
]);
const $77e1bce0ac0f7fe7$export$ce67089fac78efb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp24Filled', "24", [
    "M4.3 15.7a1 1 0 0 0 1.4 0L12 9.42l6.3 6.3a1 1 0 0 0 1.4-1.42l-7-7a1 1 0 0 0-1.4 0l-7 7a1 1 0 0 0 0 1.42"
]);
const $77e1bce0ac0f7fe7$export$58e2d56f9f7c11b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp24Regular', "24", [
    "M4.22 15.53c.3.3.77.3 1.06 0L12 8.81l6.72 6.72a.75.75 0 1 0 1.06-1.06l-7.25-7.25a.75.75 0 0 0-1.06 0l-7.25 7.25c-.3.3-.3.77 0 1.06"
]);
const $77e1bce0ac0f7fe7$export$5eaef7a39ba111db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp28Filled', "28", [
    "M23.7 18.7a1 1 0 0 1-1.4 0L14 10.42l-8.3 8.3a1 1 0 0 1-1.4-1.42l9-9a1 1 0 0 1 1.4 0l9 9a1 1 0 0 1 0 1.42"
]);
const $77e1bce0ac0f7fe7$export$53a8c7c429681c0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp28Regular', "28", [
    "M23.78 18.53c-.3.3-.77.3-1.06 0L14 9.81l-8.72 8.72a.75.75 0 0 1-1.06-1.06l9.25-9.25c.3-.3.77-.3 1.06 0l9.25 9.25c.3.3.3.77 0 1.06"
]);
const $77e1bce0ac0f7fe7$export$2352532f0f4a79c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp32Filled', "32", [
    "M5.37 20.88c.48.5 1.28.5 1.76 0L16 12.02l8.87 8.86a1.25 1.25 0 0 0 1.76-1.76l-9.75-9.75a1.25 1.25 0 0 0-1.76 0l-9.75 9.75a1.25 1.25 0 0 0 0 1.76"
]);
const $77e1bce0ac0f7fe7$export$226acf21722b5c33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp32Regular', "32", [
    "M5.3 20.7a1 1 0 0 0 1.4 0l9.3-9.29 9.3 9.3a1 1 0 0 0 1.4-1.42l-10-10a1 1 0 0 0-1.4 0l-10 10a1 1 0 0 0 0 1.42"
]);
const $77e1bce0ac0f7fe7$export$2c6f68d6ad29f7e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp48Filled', "48", [
    "M39.56 32.06a1.5 1.5 0 0 1-2.12 0L24 18.62 10.56 32.06a1.5 1.5 0 0 1-2.12-2.12l14.5-14.5a1.5 1.5 0 0 1 2.12 0l14.5 14.5a1.5 1.5 0 0 1 0 2.12"
]);
const $77e1bce0ac0f7fe7$export$64ea2740598048e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp48Regular', "48", [
    "M39.63 31.88c-.48.5-1.28.5-1.76 0L24 18.02 10.13 31.88a1.25 1.25 0 0 1-1.76-1.76l14.75-14.75a1.25 1.25 0 0 1 1.76 0l14.75 14.75c.5.48.5 1.28 0 1.76"
]);
const $77e1bce0ac0f7fe7$export$8b9d6c193f7c2d3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown16Filled', "16", [
    "M4.22 6.53c.3.3.77.3 1.06 0L8 3.81l2.72 2.72a.75.75 0 1 0 1.06-1.06L8.53 2.22a.75.75 0 0 0-1.06 0L4.22 5.47c-.3.3-.3.77 0 1.06m0 2.94c.3-.3.77-.3 1.06 0L8 12.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25c-.3.3-.77.3-1.06 0l-3.25-3.25a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$ead95d908001de23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown16Regular', "16", [
    "M4.15 6.35c.2.2.5.2.7 0L8 3.21l3.15 3.14a.5.5 0 0 0 .7-.7l-3.5-3.5a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 0 .7m0 3.3c.2-.2.5-.2.7 0L8 12.79l3.15-3.14a.5.5 0 0 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 0-.7"
]);
const $77e1bce0ac0f7fe7$export$ec22b2ea339ab996 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown20Filled', "20", [
    "M10.53 2.72a.75.75 0 0 0-1.06 0L5.22 6.97a.75.75 0 0 0 1.06 1.06L10 4.31l3.72 3.72a.75.75 0 1 0 1.06-1.06zm4.25 10.31-4.25 4.25c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 1 1 1.06-1.06L10 15.69l3.72-3.72a.75.75 0 1 1 1.06 1.06"
]);
const $77e1bce0ac0f7fe7$export$d281dccdcfc5c0c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown20Regular', "20", [
    "M14.91 7.22a.5.5 0 0 1-.76.63L10 3.71 5.85 7.85l-.07.06a.5.5 0 0 1-.63-.76l4.5-4.5.07-.06a.5.5 0 0 1 .63.06l4.5 4.5zM5.1 12.78a.5.5 0 0 1 .76-.63L10 16.29l4.15-4.14.07-.06a.5.5 0 0 1 .63.76l-4.5 4.5-.07.06a.5.5 0 0 1-.63-.06l-4.5-4.5z"
]);
const $77e1bce0ac0f7fe7$export$860f58bb500e8f03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown24Filled', "24", [
    "M18.79 8.39a1 1 0 0 1-1.5 1.32L12 4.4l-5.3 5.3-.09.08a1 1 0 0 1-1.32-1.5l6-6 .1-.08a1 1 0 0 1 1.32.08l6 6zM5.21 15.6a1 1 0 0 1 1.5-1.32L12 19.6l5.3-5.3.09-.08a1 1 0 0 1 1.32 1.5l-6 6-.1.08a1 1 0 0 1-1.32-.08l-6-6z"
]);
const $77e1bce0ac0f7fe7$export$437b95df136d559d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown24Regular', "24", [
    "M12.54 2.23a.75.75 0 0 0-1.08 0L5.2 8.73a.75.75 0 1 0 1.08 1.04L12 3.83l5.7 5.94a.75.75 0 1 0 1.1-1.04zm0 19.54a.75.75 0 0 1-1.08 0l-6.25-6.5a.75.75 0 1 1 1.08-1.04L12 20.17l5.7-5.94a.75.75 0 1 1 1.1 1.04z"
]);
const $77e1bce0ac0f7fe7$export$211458b4cdc92b6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door16Filled', "16", [
    "M3 3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm3 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $77e1bce0ac0f7fe7$export$d48067cbe854849a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door16Regular', "16", [
    "M6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 1a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
]);
const $77e1bce0ac0f7fe7$export$d0e717b4c71b9018 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door20Filled', "20", [
    "M14 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$c48ee1d778453a48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door20Regular', "20", [
    "M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2 13h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
]);
const $77e1bce0ac0f7fe7$export$32a7d15130657b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door24Filled', "24", [
    "M17.75 2C18.99 2 20 3 20 4.25v15.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zM8.5 10.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $77e1bce0ac0f7fe7$export$18776d5fa6c0ffa3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door24Regular', "24", [
    "M17.75 2C18.99 2 20 3 20 4.25v15.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zM6.25 3.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75zm2.25 6.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $77e1bce0ac0f7fe7$export$6cea0a8f04ceea41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door28Filled', "28", [
    "M8 2a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm1.5 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $77e1bce0ac0f7fe7$export$b507381b7c36661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door28Regular', "28", [
    "M9.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M5 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v18c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5V5c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$454a0f737b08a903 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door32Filled', "32", [
    "M23.75 2C25.55 2 27 3.46 27 5.25v21.5c0 1.8-1.46 3.25-3.25 3.25H8.25A3.25 3.25 0 0 1 5 26.92V5.25C5 3.45 6.46 2 8.25 2zM10.5 13.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$18903c90a172b23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door32Regular', "32", [
    "M23.75 2C25.55 2 27 3.46 27 5.25v21.5c0 1.8-1.46 3.25-3.25 3.25H8.25A3.25 3.25 0 0 1 5 26.92V5.25C5 3.45 6.46 2 8.25 2zM8.25 4C7.56 4 7 4.56 7 5.25v21.63c.07.63.6 1.12 1.25 1.12h15.5c.69 0 1.25-.56 1.25-1.25V5.25C25 4.56 24.44 4 23.75 4zm2.25 9.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$f43c123a9e6f009 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAdd16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M11 1a2 2 0 0 1 2 2v3.2A5.5 5.5 0 0 0 7.26 15H5a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2zm.5 8a.5.5 0 0 0-.5.5V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5a.5.5 0 0 0-.5-.5M6 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$af777426362519a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAdd16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M11 1a2 2 0 0 1 2 2v3.2q-.49-.13-1-.18V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.6q.27.54.66 1H5a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2zm.5 8a.5.5 0 0 0-.5.5V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5a.5.5 0 0 0-.5-.5M6 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $77e1bce0ac0f7fe7$export$14e98bcf8ef3ba5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAdd20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2a5.5 5.5 0 0 0-5.74 8.8H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5M7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$4bddb355d1cf497a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAdd20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2q-.49-.13-1-.18V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3.6q.27.54.66 1H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5M7 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $77e1bce0ac0f7fe7$export$1d71ed86d1422615 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-10C18.99 2 20 3 20 4.25v7.25A6.5 6.5 0 0 0 12.81 22H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-.25 12a.5.5 0 0 0-.5.5V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 0 0-.5-.5m-9-3.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $77e1bce0ac0f7fe7$export$a83f042de4882a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.25-10C18.99 2 20 3 20 4.25v7.25q-.71-.3-1.5-.42V4.25a.75.75 0 0 0-.75-.75H6.25a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h5.48q.44.83 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2zm-.25 12a.5.5 0 0 0-.5.5V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 0 0-.5-.5m-9-3.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $77e1bce0ac0f7fe7$export$d1427adcd76ee3bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft16Filled', "16", [
    "M3 2.75C3 1.78 3.78 1 4.75 1h6.5c.97 0 1.75.78 1.75 1.75v3.46A5.5 5.5 0 0 0 7.26 15H4.75C3.78 15 3 14.22 3 13.25zM6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 2.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$1896c47f41559656 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft16Regular', "16", [
    "M4.75 1C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h2.5a6 6 0 0 1-.65-1H4.75a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.27q.51.05 1 .19V2.75C13 1.78 12.22 1 11.25 1zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m9 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$8609b3b6b9845bef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2a5.5 5.5 0 0 0-5.74 8.8H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.85 10.15a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 1 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0 0-.7M7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$589a136ff5d86b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft20Regular', "20", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a6 6 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02q.51.05 1 .19V4a2 2 0 0 0-2-2zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $77e1bce0ac0f7fe7$export$9c46e7c3496e218e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft24Filled', "24", [
    "M6.25 2.75c-.83 0-1.5.67-1.5 1.5v15.5c0 .83.67 1.5 1.5 1.5h5.94a6.5 6.5 0 0 1 7.06-10.01V4.25c0-.83-.67-1.5-1.5-1.5zm2.25 10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 9.75a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m3.5-5.5a.5.5 0 0 1-.5.5h-4.8l1.65 1.65a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5a.5.5 0 0 1 .7.7L15.71 17h4.79c.28 0 .5.22.5.5"
]);
const $77e1bce0ac0f7fe7$export$2d0a71c7ad8a30ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft24Regular', "24", [
    "M6.25 2C5.01 2 4 3 4 4.25v15.5C4 20.99 5 22 6.25 22h6.56a7 7 0 0 1-1.08-1.5H6.25a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75h11.5c.41 0 .75.34.75.75v6.83q.79.12 1.5.42V4.25C20 3.01 19 2 17.75 2zM17.5 23a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m3.5-5.5a.5.5 0 0 1-.5.5h-4.8l1.65 1.65a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5a.5.5 0 0 1 .7.7L15.71 17h4.79c.28 0 .5.22.5.5M8.5 13.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $77e1bce0ac0f7fe7$export$4482837f936a1d5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight16Filled', "16", [
    "M3 2.75C3 1.78 3.78 1 4.75 1h6.5c.97 0 1.75.78 1.75 1.75v3.46A5.5 5.5 0 0 0 7.26 15H4.75C3.78 15 3 14.22 3 13.25zM6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5.5 7a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.35-2.15a.5.5 0 0 1-.7-.7L12.29 12H9.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $77e1bce0ac0f7fe7$export$bfc69ec658fdba85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight16Regular', "16", [
    "M4.75 1C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h2.5a6 6 0 0 1-.65-1H4.75a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.27q.51.05 1 .19V2.75C13 1.78 12.22 1 11.25 1zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.35-2.15a.5.5 0 0 1-.7-.7L12.29 12H9.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $77e1bce0ac0f7fe7$export$3e72b722863e8f01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M14 2a2 2 0 0 1 2 2v5.2a5.5 5.5 0 0 0-5.74 8.8H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm.85 10.15a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 0-.7zM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $77e1bce0ac0f7fe7$export$38c9709c1dbb662a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight20Regular', "20", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a6 6 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02q.51.05 1 .19V4a2 2 0 0 0-2-2zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.35-2.15a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $77e1bce0ac0f7fe7$export$e25398e573c08b33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight28Filled', "28", [
    "M8 2a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h7.4A7.5 7.5 0 0 1 23 13.43V5a3 3 0 0 0-3-3zm1.5 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M16.5 20a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 20z"
]);
const $77e1bce0ac0f7fe7$export$edb3730dbd54f653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight28Regular', "28", [
    "M5 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8.43q-.72-.26-1.5-.36V5c0-.83-.67-1.5-1.5-1.5H8c-.83 0-1.5.67-1.5 1.5v18c0 .83.67 1.5 1.5 1.5h6.15q.53.83 1.25 1.5H8a3 3 0 0 1-3-3zm4.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M16.5 20a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 20z"
]);
const $77e1bce0ac0f7fe7$export$3809c7eb0dfda03b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight32Filled', "32", [
    "M23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.25-14C25.55 2 27 3.46 27 5.25v9.96A9 9 0 0 0 17.28 30H8.25A3.25 3.25 0 0 1 5 26.9V5.26C5 3.45 6.46 2 8.25 2zm1.03 16.72a.75.75 0 1 0-1.06 1.06l2.72 2.72h-7.69a.75.75 0 0 0 0 1.5h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06zM10.5 13.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$ca0bd8e968333c1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight32Light', "32", [
    "M8.25 2A3.25 3.25 0 0 0 5 5.25v21.5C5 28.55 6.46 30 8.25 30h9.02a9 9 0 0 1-.9-1H8.26C7.01 29 6 28 6 26.75V5.25C6 4.01 7 3 8.25 3h15.5C24.99 3 26 4 26 5.25v9.6q.51.15 1 .36V5.25C27 3.45 25.54 2 23.75 2zM23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M18 23.25c0 .41.34.75.75.75h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06l2.72 2.72h-7.69a.75.75 0 0 0-.75.75m-8.5-6a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
]);
const $77e1bce0ac0f7fe7$export$f7e187f1e9cce4ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight32Regular', "32", [
    "M23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.25-14C25.55 2 27 3.46 27 5.25v9.96a9 9 0 0 0-2-.58V5.25C25 4.56 24.44 4 23.75 4H8.25C7.56 4 7 4.56 7 5.25v21.63c.07.63.6 1.12 1.25 1.12h7.46q.64 1.11 1.57 2H8.25A3.25 3.25 0 0 1 5 26.92V5.25C5 3.45 6.46 2 8.25 2zm1.03 16.72a.75.75 0 1 0-1.06 1.06l2.72 2.72h-7.69a.75.75 0 0 0 0 1.5h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06zM10.5 13.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"
]);
const $77e1bce0ac0f7fe7$export$2afbe3560921b0ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag20Filled', "20", [
    "M9.3 6.3A1 1 0 1 1 10 8H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7.05a4.98 4.98 0 0 0-8.54-3.59A2 2 0 1 0 9.3 6.3M8 14h4a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1"
]);
const $77e1bce0ac0f7fe7$export$572043c0b0d13925 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag20Regular', "20", [
    "M9.3 6.3A1 1 0 1 1 10 8H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7.05a4.98 4.98 0 0 0-8.54-3.59A2 2 0 1 0 9.3 6.3M11.4 8.4A2 2 0 1 0 8.6 5.6a1 1 0 0 1-1.42-1.42A4 4 0 0 1 14 7V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3a2 2 0 0 0 1.41-.59M8 14a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$fa17368313b7d79b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag24Filled', "24", [
    "M12 6.5c-.49 0-.92.23-1.2.6a2.25 2.25 0 0 1-3.6-2.7A6 6 0 0 1 18 8v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8.5c0-1.1.9-2 2-2h4a1.5 1.5 0 0 0 0-3m-2.25 11a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$5cff03aea53f6873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag24Regular', "24", [
    "M9.75 17.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM10.8 7.1A1.5 1.5 0 1 1 12 9.5H8a2 2 0 0 0-2 2V20c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8A6 6 0 0 0 7.2 4.4a2.25 2.25 0 1 0 3.6 2.7M12 5a3 3 0 0 0-2.4 1.2.75.75 0 0 1-1.2-.9A4.5 4.5 0 0 1 16.5 8v12a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-8.5c0-.28.22-.5.5-.5h4a3 3 0 1 0 0-6"
]);
const $77e1bce0ac0f7fe7$export$ea2182f382a21663 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth16Filled', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-6h-.05q.14.28.28.63c.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38s-.1.43.04.9l.03.1q.1.3.16.6c.04.26.06.58-.1.89q-.25.45-.63.65c-.23.13-.47.17-.66.2l-.07.02c-.36.06-.54.1-.71.28q-.2.22-.27.77l-.05.46v.08l-.07.53-.03.11a6 6 0 0 0 7.4 1.03l-.26-.28c-.23-.3-.54-.81-.43-1.41.05-.29.2-.53.35-.72a5 5 0 0 1 .62-.61l.32-.31.12-.15.04-.05c.05-.17-.01-.3-.09-.35-.05-.04-.2-.1-.44.05l-.26.16a1 1 0 0 1-.27.12.53.53 0 0 1-.63-.36l-.03-.2.01-.19c.03-.21.07-.52-.06-.98q-.15-.54-.38-.94l-.2-.42c-.08-.2-.18-.46-.16-.73q.04-.48.44-.78c.32-.24.72-.78 1.06-1.33q.26-.41.41-.7l.02-.03A6 6 0 0 0 8 2"
]);
const $77e1bce0ac0f7fe7$export$5fa9ebe3f44de04b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth16Regular', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-6h-.05q.14.28.28.63c.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38s-.1.43.04.9l.03.1q.1.3.16.6c.04.26.06.58-.1.89q-.25.45-.63.65c-.23.13-.47.17-.66.2l-.07.02c-.36.06-.54.1-.71.28q-.2.22-.27.77l-.05.46v.08l-.07.53-.03.11a6 6 0 0 0 7.4 1.03l-.26-.28c-.23-.3-.54-.81-.43-1.41.05-.29.2-.53.35-.72a5 5 0 0 1 .62-.61l.32-.31.12-.15.04-.05c.05-.17-.01-.3-.09-.35-.05-.04-.2-.1-.44.05l-.26.16a1 1 0 0 1-.27.12.53.53 0 0 1-.63-.36l-.03-.2.01-.19c.03-.21.07-.52-.06-.98q-.15-.54-.38-.94l-.2-.42c-.08-.2-.18-.46-.16-.73q.04-.48.44-.78c.32-.24.72-.78 1.06-1.33q.26-.41.41-.7l.02-.03A6 6 0 0 0 8 2m4.03 1.56-.38.65a6 6 0 0 1-1.35 1.64c0 .03 0 .1.08.27l.13.27c.16.32.38.76.5 1.24q.1.38.11.68c.44-.15.88-.08 1.21.18.42.32.6.88.43 1.43-.07.25-.25.45-.39.6l-.38.37-.5.5a1 1 0 0 0-.15.25q-.04.26.24.61a2 2 0 0 0 .3.32 6 6 0 0 0 .15-9M2 8c0 1.08.29 2.1.79 2.97l.01-.15c.06-.4.17-.93.54-1.32.41-.45.92-.53 1.24-.58l.1-.02q.24-.04.36-.1.1-.04.21-.24.03-.02 0-.24-.03-.2-.12-.45l-.04-.14c-.13-.42-.33-1.11.08-1.74.36-.55.94-.69 1.32-.78q.06 0 .11-.03c.4-.1.63-.2.8-.54.2-.46.12-1.07-.1-1.65a5 5 0 0 0-.44-.88A6 6 0 0 0 2 8"
]);
const $77e1bce0ac0f7fe7$export$f210fbb2142194e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7h-.25q.18.34.37.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 8.86 1.25l-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a6 6 0 0 1 .7-.7q.22-.2.39-.37a1 1 0 0 0 .2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19q-.13.07-.34.12a.6.6 0 0 1-.54-.18 1 1 0 0 1-.18-.37l-.03-.28v-.07l-.02-.23q-.02-.33-.15-.83c-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a1 1 0 0 1 .03-.55q.12-.28.35-.44a19 19 0 0 0 1.74-1.66q.47-.48.77-.82h.01A7 7 0 0 0 10 3"
]);
const $77e1bce0ac0f7fe7$export$c2c57f3395cae90a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth20Regular', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7h-.25q.18.34.37.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 8.86 1.25l-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a6 6 0 0 1 .7-.7q.22-.2.39-.37a1 1 0 0 0 .2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19q-.13.07-.34.12a.6.6 0 0 1-.54-.18 1 1 0 0 1-.18-.37l-.03-.28v-.07l-.02-.23q-.02-.33-.15-.83c-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 19 19 0 0 0 1.74-1.65q.47-.48.77-.82h.01A7 7 0 0 0 10 3m4.64 1.76a42 42 0 0 1-2.71 2.66q.04.1.24.36l.12.16c.32.4.78.97.96 1.68q.15.6.17.98v.01c.6-.33 1.21-.3 1.66.06.46.35.66.97.47 1.57-.08.27-.27.5-.43.66l-.44.43-.11.1q-.3.26-.48.48a1 1 0 0 0-.19.34q-.05.35.29.78.15.19.3.3 0 .02.02.03a7 7 0 0 0 .13-10.6M8.8 3.36l-.13-.23a7 7 0 0 0-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02q.3-.04.45-.13.15-.06.28-.3.05-.07.02-.34l-.15-.54-.05-.15c-.15-.5-.37-1.26.09-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6 6 0 0 0-.38-.83"
]);
const $77e1bce0ac0f7fe7$export$511b3700ca9299b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth24Filled', "24", [
    "M10.95 2.05Q11.47 2 12 2a10 10 0 1 1-7.9 16.14 10 10 0 0 1 6.83-16.08zM12 3.5h-.16q.2.37.37.85c.35.92.67 2.28.1 3.49-.52 1.11-1.42 1.4-2.09 1.57l-.08.02c-.66.17-.9.24-1.1.52-.16.25-.14.58.07 1.25l.04.14q.14.4.23.87c.07.36.09.82-.15 1.27q-.35.66-.9.95c-.34.18-.7.25-.96.3l-.09.02c-.51.09-.76.13-1 .39q-.27.3-.38 1.07l-.06.65v.12q-.04.38-.1.76a8.5 8.5 0 0 0 10.58 1.58l-.31-.35c-.34-.43-.79-1.16-.63-2.03.07-.42.3-.77.51-1.04s.49-.52.72-.74l.16-.14q.27-.24.46-.44c.17-.18.21-.26.21-.27.07-.22-.01-.38-.1-.45a.3.3 0 0 0-.2-.06 1 1 0 0 0-.4.14.9.9 0 0 1-.83.08c-.27-.1-.41-.31-.49-.43a3 3 0 0 1-.27-.77l-.12-.55-.04-.21-.13-.54-.02-.04-.07-.1q-.08-.14-.22-.32l-.11-.14q-.26-.33-.52-.71c-.2-.3-.42-.7-.49-1.1q-.06-.35.06-.74.15-.4.49-.65a13 13 0 0 0 1.82-1.96q.44-.56.73-.95A8.5 8.5 0 0 0 12 3.5"
]);
const $77e1bce0ac0f7fe7$export$462f7342665633d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth24Regular', "24", [
    "M10.95 2.05Q11.47 2 12 2a10 10 0 1 1-7.9 16.14 10 10 0 0 1 6.83-16.08zM12 3.5h-.16q.2.37.37.85c.35.92.67 2.28.1 3.49-.52 1.11-1.42 1.4-2.09 1.57l-.08.02c-.66.17-.9.24-1.1.52-.16.25-.14.58.07 1.25l.04.14q.14.4.23.87c.07.36.09.82-.15 1.27q-.35.66-.9.95c-.34.18-.7.25-.96.3l-.09.02c-.51.09-.76.13-1 .39q-.27.3-.38 1.07l-.06.65v.12q-.04.38-.1.76a8.5 8.5 0 0 0 10.58 1.58l-.31-.35c-.34-.43-.79-1.16-.63-2.03.07-.42.3-.77.51-1.04s.49-.52.72-.74l.16-.14q.27-.24.46-.44c.17-.18.21-.26.21-.27.07-.22-.01-.38-.1-.45a.3.3 0 0 0-.2-.06 1 1 0 0 0-.4.14.9.9 0 0 1-.83.08c-.27-.1-.41-.31-.49-.43a3 3 0 0 1-.27-.77l-.12-.55-.04-.21-.13-.54-.02-.04-.07-.1q-.08-.14-.22-.32l-.11-.14q-.26-.33-.52-.71c-.2-.3-.42-.7-.49-1.1q-.06-.35.06-.74.15-.4.49-.65a13 13 0 0 0 1.82-1.96q.44-.56.73-.95A8.5 8.5 0 0 0 12 3.5m5.73 2.22-.76.98c-.6.75-1.4 1.68-2.05 2.19q.03.14.26.5a11 11 0 0 0 .56.77c.18.23.42.54.52.84.1.23.15.52.2.76l.05.25.08.37c.6-.17 1.2-.07 1.67.3.6.46.86 1.28.62 2.07-.11.36-.36.66-.56.87l-.56.53-.13.12q-.35.3-.57.57a1 1 0 0 0-.2.36q-.07.34.32.84a3 3 0 0 0 .38.4 8.48 8.48 0 0 0 .17-12.72M3.5 12c0 1.4.34 2.72.94 3.88.08-.56.26-1.25.74-1.77a3 3 0 0 1 1.93-.86q.36-.05.5-.14a.7.7 0 0 0 .3-.32c0-.03.03-.1 0-.33q-.06-.26-.18-.63l-.06-.2c-.18-.6-.48-1.6.12-2.5.53-.8 1.36-1 1.9-1.13l.16-.04c.56-.15.88-.28 1.1-.76.3-.63.18-1.48-.14-2.32a8 8 0 0 0-.58-1.2A8.5 8.5 0 0 0 3.5 12"
]);
const $77e1bce0ac0f7fe7$export$ef38267e4a99b18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth32Filled', "32", [
    "M8.22 4.36a14 14 0 1 1 15.56 23.28A14 14 0 0 1 8.22 4.36M8.3 20.6c-.8 1.07-.55 3.11-.39 4.24a11.9 11.9 0 0 0 14.49 1.28 3.8 3.8 0 0 1-1.9-2.42c-.36-1.79.83-2.91 1.73-3.74s1.11-1.14 1-1.52a5 5 0 0 0-.73.15 2.1 2.1 0 0 1-2.08-.17 1.7 1.7 0 0 1-.42-1.59 4 4 0 0 0-1.07-2.93c-.67-.95-1.68-2.39-.3-3.64q2.16-1.95 3.76-4.4A12 12 0 0 0 16 4h-.37l.05.18.06.1c.83 1.53 1.74 3.17 1.19 5.45-.44 1.82-2.14 2.4-3.4 2.83l-.04.01q-.65.17-1.23.53c-.5.67-.36 1.34-.1 2.34a3.6 3.6 0 0 1-.16 3.11 2.6 2.6 0 0 1-2 1.13 2 2 0 0 0-1.7.92"
]);
const $77e1bce0ac0f7fe7$export$13663aa77a43dd78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth32Regular', "32", [
    "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28m-2.51 2.27.49.9c.76 1.36 1.43 2.53 1 4.1-.17.68-1 1-2.14 1.4-.82.2-1.56.62-2.14 1.23a4.3 4.3 0 0 0-.43 4c.19.74.3 1.2.1 1.5s-.15.18-.68.25a4 4 0 0 0-3 1.7c-.58.84-.9 1.82-.93 2.84a11.85 11.85 0 0 1 .91-13.73 12 12 0 0 1 6.82-4.19M7.91 24.84c-.16-1.13-.41-3.17.39-4.24a2 2 0 0 1 1.7-.92 2.6 2.6 0 0 0 2-1.13 3.6 3.6 0 0 0 .16-3.11c-.26-1-.4-1.67.1-2.34q.58-.36 1.23-.53c1.27-.43 3-1 3.44-2.84.56-2.33-.4-4-1.25-5.55L15.63 4H16c2.26 0 4.48.65 6.39 1.86a22 22 0 0 1-3.76 4.4c-1.38 1.25-.37 2.69.3 3.64A4 4 0 0 1 20 16.83a1.7 1.7 0 0 0 .42 1.59 2.1 2.1 0 0 0 2.08.17 5 5 0 0 1 .73-.15c.11.38-.1.69-1 1.52s-2.09 1.95-1.73 3.74a3.8 3.8 0 0 0 1.9 2.42 11.9 11.9 0 0 1-14.49-1.28m16.2 0-.39-.25c-.7-.42-1.13-.72-1.24-1.27s.25-1.05 1.14-1.88 2.13-2 1.47-3.77c-.61-1.61-2.29-1.2-3.05-1a6.2 6.2 0 0 0-1.47-3.9q-.37-.46-.6-1a23 23 0 0 0 4-4.67 11.95 11.95 0 0 1 .12 17.75z"
]);
const $77e1bce0ac0f7fe7$export$ddbb268968792fd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth48Filled', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.6 10.6 0 0 1 2.73 7.35c-.02.85.62 1.31.95 1.47.35.16 1.04.33 1.66-.12.93-.67 1.9-.36 2.14-.06.07.09.17.26.02.65-.17.46-.66 1.18-1.85 2.07a5.4 5.4 0 0 0-2.13 2.84c-.3 1.07-.1 2.07.3 2.91a7 7 0 0 0 2.08 2.45 17.44 17.44 0 0 1-21.75-2.2v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a5 5 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22q-.11-.74-.29-1.41l-.04-.18q-.14-.56-.23-1.07c-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9q3.48-1 5-2.95a5.7 5.7 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4q-.42-.76-.87-1.46M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40"
]);
const $77e1bce0ac0f7fe7$export$b7577c48a3d424fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth48Regular', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.6 10.6 0 0 1 2.73 7.35c-.02.85.62 1.31.95 1.47.35.16 1.04.33 1.66-.12.93-.67 1.9-.36 2.14-.06.07.09.17.26.02.65-.17.46-.66 1.18-1.85 2.07a5.4 5.4 0 0 0-2.13 2.84c-.3 1.07-.1 2.07.3 2.91a7 7 0 0 0 2.08 2.45 17.44 17.44 0 0 1-21.75-2.2v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a5 5 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22q-.11-.74-.29-1.41l-.04-.18q-.14-.56-.23-1.07c-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9q3.48-1 5-2.95a5.7 5.7 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4q-.42-.76-.87-1.46m-2.77.34q.76 1.08 1.44 2.31c.58 1.08 1 2.14 1.11 3.1.11.94-.06 1.74-.6 2.45-.58.73-1.68 1.5-3.72 2.08-1.47.42-2.5 1.15-3 2.27a5 5 0 0 0-.2 3.07q.12.6.26 1.19l.04.16q.16.65.25 1.23c.12.78.08 1.31-.13 1.72-.1.21-.26.35-.88.46l-.64.09-.5.06c-.44.06-.96.15-1.47.34a4.4 4.4 0 0 0-2.68 2.76q-.46 1.23-.55 3.13A17.5 17.5 0 0 1 20.44 6.87M35.6 37.12a5.3 5.3 0 0 1-1.9-1.95q-.31-.63-.16-1.17c.1-.37.4-.9 1.22-1.5q2.1-1.57 2.7-3.2a3.1 3.1 0 0 0-.44-3.1c-.97-1.2-2.68-1.52-4.22-1.04a13 13 0 0 0-3.24-7.59 39 39 0 0 0 5.85-6.85A17.5 17.5 0 0 1 41.5 24c0 5.22-2.29 9.9-5.91 13.12M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40"
]);
const $77e1bce0ac0f7fe7$export$24db641b7d13735d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf16Filled', "16", [
    "M1 8a7 7 0 0 1 13.97-.67l-.61-.15a9.5 9.5 0 0 0-4.53.09l-.36-.75c-.1-.2-.19-.46-.17-.73q.04-.48.44-.78c.32-.24.72-.78 1.06-1.33q.26-.41.41-.7l.02-.03A6 6 0 0 0 8 2h-.05q.14.28.28.63c.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38s-.1.43.04.9l.03.1q.1.3.16.6c.05.26.06.58-.1.89q-.24.45-.62.65c-.24.13-.48.17-.67.2l-.07.02c-.36.06-.54.1-.71.28q-.2.22-.27.77l-.05.46v.08l-.07.53-.03.11a6 6 0 0 0 2.22 1.48q-.3.42-.53.87A7 7 0 0 1 1 8m14.93.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02-.3-.08-.09-.03q-.34-.1-.84-.21A9 9 0 0 0 11.19 8c-1.2.15-2.12.56-2.75 1.15a2.9 2.9 0 0 0-.9 2.62 13 13 0 0 1 3.77-2.23.5.5 0 1 1 .38.92q-1.2.49-2.2 1.1a8.5 8.5 0 0 0-3.44 3.72.5.5 0 1 0 .9.44q.55-1.14 1.44-2.06a4 4 0 0 0 .59.8 3.1 3.1 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a8 8 0 0 1 1-2.03V9.6q.15-.21.23-.38a.5.5 0 0 0-.02-.48"
]);
const $77e1bce0ac0f7fe7$export$8cb56bb03f8c54e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf16Regular', "16", [
    "M1 8a7 7 0 0 1 13.97-.67 14 14 0 0 0-1.04-.24 6 6 0 0 0-1.9-3.53l-.38.65a6 6 0 0 1-1.35 1.64q-.02.03.08.27l.13.27q.15.27.3.66-.51.07-.98.22l-.36-.75c-.1-.2-.19-.46-.17-.73q.04-.48.44-.78c.32-.24.72-.78 1.06-1.33q.26-.41.41-.7l.02-.03A6 6 0 0 0 8 2h-.05q.14.28.28.63c.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38s-.1.43.04.9l.03.1q.1.3.16.6c.05.26.06.58-.1.89q-.24.45-.62.65c-.24.13-.48.17-.67.2l-.07.02c-.36.06-.54.1-.71.28q-.2.22-.27.77l-.05.46v.08l-.07.53-.03.11a6 6 0 0 0 2.22 1.48q-.3.42-.53.87A7 7 0 0 1 1 8m1 0c0 1.08.29 2.1.79 2.97q0-.07.02-.15c.05-.4.16-.93.53-1.32a2 2 0 0 1 1.34-.6q.25-.04.36-.1.1-.04.21-.24.03-.02 0-.24-.03-.2-.12-.45 0-.07-.04-.14c-.13-.42-.33-1.11.08-1.74.36-.55.94-.69 1.32-.78q.06 0 .11-.03c.4-.1.63-.2.8-.54.2-.46.12-1.07-.1-1.65a5 5 0 0 0-.44-.88A6 6 0 0 0 2 8m13.93.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02-.3-.08-.09-.03q-.34-.1-.84-.21A9 9 0 0 0 11.19 8c-1.2.15-2.12.56-2.75 1.15a2.9 2.9 0 0 0-.9 2.62 13 13 0 0 1 3.77-2.23.5.5 0 1 1 .38.92q-1.2.49-2.2 1.1a8.5 8.5 0 0 0-3.44 3.72.5.5 0 1 0 .9.44q.55-1.14 1.44-2.06a4 4 0 0 0 .59.8 3.1 3.1 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a8 8 0 0 1 1-2.03V9.6q.15-.21.23-.38a.5.5 0 0 0-.02-.48"
]);
const $77e1bce0ac0f7fe7$export$de52142d361175b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf20Filled', "20", [
    "M2 10a8 8 0 1 1 16 .34l-.64-.16a10 10 0 0 0-3.3-.17q-.9.12-1.67.4l-.1-.54c-.13-.49-.45-.89-.77-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 19 19 0 0 0 1.74-1.65l.78-.82A7 7 0 0 0 9.74 3q.19.34.38.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 3.87 2.17q-.27.45-.51.91A8 8 0 0 1 2 10m16.93 1.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02-.3-.08-.09-.03q-.34-.1-.84-.21a9 9 0 0 0-2.95-.16q-1.8.24-2.75 1.15a2.9 2.9 0 0 0-.9 2.62 13 13 0 0 1 3.77-2.23.5.5 0 1 1 .38.92q-1.2.49-2.2 1.1a8.5 8.5 0 0 0-3.44 3.72.5.5 0 0 0 .9.44q.56-1.14 1.44-2.06a4 4 0 0 0 .59.8 3.1 3.1 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a8 8 0 0 1 1-2.03v-.02q.15-.21.23-.38a.5.5 0 0 0-.02-.48"
]);
const $77e1bce0ac0f7fe7$export$7238fc4e44fd89df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf20Regular', "20", [
    "M2 10a8 8 0 1 1 16 .34l-1-.23V10c0-2.1-.91-3.97-2.36-5.25l-.07.07-.79.84c-.6.62-1.35 1.37-1.85 1.75q.04.1.24.36l.12.16a4.7 4.7 0 0 1 1.07 2.2q-.5.1-.97.28l-.1-.55c-.13-.49-.45-.89-.77-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 19 19 0 0 0 1.74-1.65l.78-.82A7 7 0 0 0 9.74 3q.19.34.38.83c.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12q.11.33.18.69c.05.28.06.63-.11.97q-.27.5-.69.72-.4.2-.75.24l-.08.01c-.41.07-.65.12-.87.35q-.26.3-.34.94l-.05.54v.1q-.02.3-.09.6v.02a7 7 0 0 0 3.87 2.17q-.27.45-.51.91A8 8 0 0 1 2 10m6.8-6.65-.13-.22a7 7 0 0 0-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02q.3-.04.45-.13.16-.06.28-.3.06-.07.02-.34l-.15-.54-.04-.15c-.16-.5-.38-1.26.08-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6 6 0 0 0-.38-.83m10.13 8.39a.5.5 0 0 0-.43-.24h-.03l-.1-.02-.3-.08-.09-.03q-.34-.1-.84-.21a9 9 0 0 0-2.95-.16q-1.8.24-2.75 1.15a2.9 2.9 0 0 0-.9 2.62 13 13 0 0 1 3.77-2.23.5.5 0 1 1 .38.92q-1.2.49-2.2 1.1a8.5 8.5 0 0 0-3.44 3.72.5.5 0 0 0 .9.44q.56-1.14 1.44-2.06a4 4 0 0 0 .59.8 3.1 3.1 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a8 8 0 0 1 1-2.03v-.02q.15-.21.23-.38a.5.5 0 0 0-.02-.48"
]);
const $77e1bce0ac0f7fe7$export$f8d6c4867da6a16d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf24Filled', "24", [
    "M10.95 2.05Q11.48 2 12 2a10 10 0 0 1 10 9.75c-1.17-.24-2.85-.4-5.23-.08q-.96.14-1.76.5l-.15-.65-.02-.04-.07-.1q-.08-.14-.22-.32l-.11-.14c-.16-.21-.36-.47-.52-.71-.2-.3-.42-.7-.49-1.1q-.06-.35.06-.74.15-.4.49-.65a13 13 0 0 0 1.82-1.96q.44-.56.73-.95a8.5 8.5 0 0 0-4.69-1.3q.18.36.37.84c.35.92.67 2.28.1 3.49-.52 1.11-1.42 1.4-2.09 1.57l-.08.02c-.66.17-.9.24-1.1.52-.16.25-.14.58.07 1.25l.04.14a7 7 0 0 1 .23.87c.07.36.09.82-.15 1.27q-.35.66-.9.95c-.34.18-.7.25-.96.3l-.09.02c-.51.09-.76.13-1 .39q-.27.3-.38 1.07l-.06.65-.01.12q-.02.38-.1.76a8.5 8.5 0 0 0 5.63 2.74q-.26.76-.34 1.47A9.96 9.96 0 0 1 2 12a10 10 0 0 1 8.93-9.94zM12 22.2c.05-.97.49-2.15 1.23-3.26a8.9 8.9 0 0 1 5.38-3.97.5.5 0 0 0-.24-.96 10 10 0 0 0-5.73 4q-.15-.45-.15-1.02c0-.92.46-1.91 1.2-2.7a5.3 5.3 0 0 1 3.2-1.64 13.5 13.5 0 0 1 5.56.23.75.75 0 0 1 .21 1.35 1 1 0 0 0-.26.34q-.14.3-.32.82l-.26.93-.05.21q-.17.62-.39 1.29c-.29.86-.7 1.78-1.4 2.48a4 4 0 0 1-3 1.2 3.8 3.8 0 0 1-2.84-1.16c-.4.74-.62 1.43-.65 1.95a.75.75 0 1 1-1.5-.1"
]);
const $77e1bce0ac0f7fe7$export$5592a7ee6f6318a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf24Regular', "24", [
    "M10.95 2.05h-.02A10 10 0 0 0 4.1 18.15a10 10 0 0 0 6.92 3.81q.08-.71.34-1.47a8.5 8.5 0 0 1-5.63-2.74c.06-.24.08-.52.1-.76l.01-.12.06-.65q.1-.78.38-1.07c.24-.26.49-.3 1-.4l.1-.01c.26-.05.61-.12.95-.3q.55-.29.9-.95c.24-.45.22-.9.15-1.27a7 7 0 0 0-.27-1.01c-.2-.67-.23-1-.06-1.25.18-.28.43-.35 1.09-.52l.08-.02c.67-.17 1.57-.46 2.1-1.57.56-1.2.24-2.57-.1-3.49q-.2-.48-.38-.85H12c1.67 0 3.22.48 4.53 1.3q-.29.4-.73.96a13 13 0 0 1-1.82 1.96 1.4 1.4 0 0 0-.55 1.38c.07.42.3.8.5 1.1.15.25.35.5.5.72l.12.14.29.42.02.04a4 4 0 0 1 .15.65q.67-.3 1.44-.45c-.04-.23-.1-.5-.19-.72a4 4 0 0 0-.65-1.01q-.23-.3-.43-.6-.23-.36-.26-.5a15 15 0 0 0 2.05-2.2q.45-.55.76-.97a8.5 8.5 0 0 1 2.76 5.82q.87.07 1.5.2a10 10 0 0 0-11.04-9.69M4.44 15.88a8.5 8.5 0 0 1 5.8-12.2 7 7 0 0 1 .57 1.2c.31.84.44 1.7.15 2.32-.23.48-.55.61-1.11.76L9.69 8c-.54.13-1.37.33-1.9 1.12-.6.91-.3 1.91-.12 2.52l.06.19q.12.37.18.63c.03.22 0 .3 0 .33a.7.7 0 0 1-.3.32q-.14.09-.5.14l-.13.02c-.46.08-1.2.2-1.8.84a3.3 3.3 0 0 0-.74 1.77M12 22.2c.06-.96.5-2.14 1.23-3.25q.35-.6.89-1.21a9 9 0 0 1 4.5-2.75.5.5 0 0 0-.25-.98 10 10 0 0 0-5.73 4q-.15-.45-.15-1.01c0-.92.47-1.91 1.2-2.7a5.3 5.3 0 0 1 3.2-1.64 13.5 13.5 0 0 1 5.56.23.75.75 0 0 1 .22 1.35 1 1 0 0 0-.26.34q-.17.3-.32.82-.14.44-.26.93l-.06.21q-.17.62-.38 1.29c-.3.86-.7 1.78-1.4 2.48a4 4 0 0 1-3 1.2 3.8 3.8 0 0 1-2.85-1.16c-.4.74-.61 1.43-.65 1.95a.75.75 0 0 1-1.5-.1"
]);
const $77e1bce0ac0f7fe7$export$44ca0b03e6c06526 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf32Filled', "32", [
    "M8.22 4.36A14 14 0 0 1 30 16v.07c-1.77-.4-3.88-.7-6-.53-1.33.1-2.7.39-4 .95a4 4 0 0 0-1.07-2.59c-.67-.95-1.68-2.39-.3-3.64q2.16-1.95 3.76-4.4A12 12 0 0 0 16 4h-.37l.05.18.06.1c.83 1.53 1.74 3.17 1.19 5.45-.44 1.82-2.14 2.4-3.4 2.83l-.04.01q-.65.17-1.23.53c-.5.67-.36 1.34-.1 2.34a3.6 3.6 0 0 1-.16 3.11 2.6 2.6 0 0 1-2 1.13 2 2 0 0 0-1.7.92c-.8 1.07-.55 3.11-.39 4.24a12 12 0 0 0 7.03 3.1l.04.01q-.35 1.05-.45 1.97A14.02 14.02 0 0 1 3.07 10.64a14 14 0 0 1 5.15-6.28M18.38 27.3c.77.8 2.18 1.69 4.62 1.69 4.3 0 5.64-5.53 6.25-8.04q.15-.64.25-.96c.15-.45.54-.8.98-1.04.7-.4.7-1.05-.06-1.25-3.63-.95-9.03-1.48-12.42 1.9-1.4 1.41-1.38 3.25-1.1 4.6l.18-.25A14.6 14.6 0 0 1 24 18.79a.75.75 0 0 1 .5 1.42 13 13 0 0 0-6.2 4.64 11.4 11.4 0 0 0-2.3 5.42.75.75 0 0 0 1.5.04c.07-.91.36-1.95.88-3"
]);
const $77e1bce0ac0f7fe7$export$7a141de9aa08b040 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf32Regular', "32", [
    "M16 2a14 14 0 0 0-1.47 27.92q.1-.93.45-1.97h-.04a12 12 0 0 1-7.03-3.11c-.16-1.13-.41-3.17.39-4.24a2 2 0 0 1 1.7-.92 2.6 2.6 0 0 0 2-1.13 3.6 3.6 0 0 0 .16-3.11c-.26-1-.4-1.67.1-2.34q.58-.36 1.23-.53l.03-.01c1.27-.43 2.97-1 3.41-2.83.55-2.28-.36-3.92-1.2-5.44l-.05-.11-.05-.18H16c2.26 0 4.48.65 6.39 1.86a22 22 0 0 1-3.76 4.4c-1.38 1.25-.37 2.69.3 3.64A4 4 0 0 1 20 16.49q.97-.42 1.97-.64a6 6 0 0 0-1.4-3.08q-.37-.46-.6-1a23 23 0 0 0 4-4.67 12 12 0 0 1 4 8.6q1.07.15 2.03.37V16A14 14 0 0 0 16 2m-2.51 2.27.49.9.03.05c.75 1.34 1.4 2.5.97 4.05-.17.68-1 1-2.14 1.4-.82.2-1.56.62-2.14 1.23a4.3 4.3 0 0 0-.43 4c.19.74.3 1.2.1 1.5-.14.21-.16.21-.35.22l-.33.03a4 4 0 0 0-3 1.7c-.58.84-.9 1.82-.93 2.84a11.85 11.85 0 0 1 .91-13.73 12 12 0 0 1 6.82-4.19m4.89 23.04c.77.8 2.18 1.69 4.62 1.69 4.3 0 5.64-5.53 6.25-8.04q.15-.64.25-.96c.15-.45.54-.8.98-1.04.7-.4.7-1.05-.06-1.25-3.63-.95-9.03-1.48-12.42 1.9-1.4 1.41-1.38 3.25-1.1 4.6l.18-.25A14.6 14.6 0 0 1 24 18.79a.75.75 0 0 1 .5 1.42 13 13 0 0 0-6.2 4.64 11.4 11.4 0 0 0-2.3 5.42.75.75 0 0 0 1.5.04c.07-.91.36-1.95.88-3"
]);
const $77e1bce0ac0f7fe7$export$a3c1e21dce19ceed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf48Filled', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.7 10.7 0 0 1 2.61 5.47q.53-.3 1.07-.55a25 25 0 0 1 12.63-1.93A20 20 0 1 0 24.17 44q.07-.17.15-.35.6-1.16 1.2-2.22-.74.07-1.52.07c-4.77 0-9.1-1.9-12.25-5v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a5 5 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22q-.11-.74-.29-1.41l-.04-.18q-.14-.56-.23-1.07c-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9q3.48-1 5-2.95a5.7 5.7 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4q-.42-.76-.87-1.46m21.75 17.76c-4.14-.66-9.05-.17-12.82 1.6-1.9.88-3.58 2.11-4.7 3.75a8.2 8.2 0 0 0-1.33 5.98 10 10 0 0 0 1.05 3.26 33 33 0 0 1 6.7-7.27 28 28 0 0 1 3.68-2.48h.01v-.01h.01a1 1 0 0 1 .9 1.78l-.22.12-.7.41c-.59.37-1.43.95-2.43 1.74a32 32 0 0 0-6.85 7.66 38 38 0 0 0-2.14 3.73 1 1 0 1 0 1.78.9q.96-1.9 1.99-3.46 1.32.95 2.8 1.44c1.52.52 3.12.68 4.57.5a6.5 6.5 0 0 0 3.78-1.63 9 9 0 0 0 2.44-3.62 12 12 0 0 0 .51-3.89c.07-2.18.15-4.77 1.91-8.77a1.25 1.25 0 0 0-.94-1.74"
]);
const $77e1bce0ac0f7fe7$export$bfd3e8038bf0a3b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf48Regular', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.7 10.7 0 0 1 2.61 5.47 17 17 0 0 1 2.34-1.08 13 13 0 0 0-3-5.96 39 39 0 0 0 5.85-6.85A17.5 17.5 0 0 1 41.39 22q1.28 0 2.52.13A20 20 0 1 0 24.17 44q.07-.17.15-.35.6-1.16 1.2-2.22-.75.07-1.52.07c-4.77 0-9.1-1.9-12.25-5v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a5 5 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22q-.11-.74-.29-1.41l-.04-.18q-.14-.56-.23-1.07c-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9q3.48-1 5-2.95a5.7 5.7 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4q-.42-.76-.87-1.46m-2.77.34q.76 1.08 1.44 2.31c.58 1.08 1 2.14 1.11 3.1.11.94-.06 1.74-.6 2.45-.58.73-1.68 1.5-3.72 2.08-1.47.42-2.5 1.15-3 2.27a5 5 0 0 0-.2 3.07q.12.6.26 1.19l.04.16q.16.65.25 1.23c.12.78.08 1.31-.13 1.72-.1.21-.26.35-.88.46l-.64.09-.5.06c-.44.06-.96.15-1.47.34a4.4 4.4 0 0 0-2.68 2.76q-.46 1.23-.55 3.13A17.5 17.5 0 0 1 20.44 6.87M44.95 24.3c-4.14-.67-9.05-.17-12.82 1.59-1.9.88-3.58 2.11-4.7 3.75a8.2 8.2 0 0 0-1.33 5.98 10 10 0 0 0 1.05 3.26 33 33 0 0 1 6.7-7.27 28 28 0 0 1 3.65-2.47l.03-.01h.01v-.01h.01a1 1 0 0 1 .9 1.78l-.22.12-.7.41c-.59.37-1.43.95-2.43 1.74a32 32 0 0 0-6.85 7.66 38 38 0 0 0-2.14 3.73 1 1 0 1 0 1.78.9q.96-1.9 1.99-3.46 1.32.95 2.8 1.44c1.52.52 3.12.68 4.57.5a6.5 6.5 0 0 0 3.78-1.63 9 9 0 0 0 2.44-3.62 12 12 0 0 0 .51-3.89c.07-2.18.15-4.77 1.91-8.77a1.25 1.25 0 0 0-.94-1.73"
]);
const $77e1bce0ac0f7fe7$export$af6a1d11b5198e00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent20Filled', "20", [
    "M10.72 2.05a.5.5 0 0 0-.44 0l-5 2.5A.5.5 0 0 0 5 5v9.5q.01.28.24.43l5 3a.5.5 0 0 0 .76-.43v-4.7l4.72-2.35a.5.5 0 0 0 0-.9l-4.1-2.05 4.1-2.05a.5.5 0 0 0 0-.9z"
]);
const $77e1bce0ac0f7fe7$export$1243d3250eaa1a92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent20Regular', "20", [
    "M10.28 2.05a.5.5 0 0 1 .44 0l5 2.5a.5.5 0 0 1 0 .9l-4.1 2.05 4.1 2.05a.5.5 0 0 1 0 .9L11 12.8v4.69a.5.5 0 0 1-.76.43l-5-3A.5.5 0 0 1 5 14.5V5q0-.3.28-.45zM6 5.31v8.9l4 2.4v-3.8a1 1 0 0 1 .55-.9L14.38 10l-4.1-2.05a.5.5 0 0 1 0-.9L14.38 5 10.5 3.06z"
]);
const $77e1bce0ac0f7fe7$export$c455dc1c19009b1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent24Filled', "24", [
    "M12.59 2.08a.8.8 0 0 0-.68 0l-6 3a.8.8 0 0 0-.41.67v11.73q.01.41.35.64l6 3.77a.75.75 0 0 0 1.15-.64v-6.03l5.59-2.8a.75.75 0 0 0 0-1.34l-4.66-2.33 4.66-2.33a.75.75 0 0 0 0-1.34z"
]);
const $77e1bce0ac0f7fe7$export$4162df2c5c5125ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent24Regular', "24", [
    "M11.91 2.08q.34-.15.68 0l6 3a.75.75 0 0 1 0 1.34l-4.66 2.33 4.66 2.33a.75.75 0 0 1 0 1.34L13 15.22v6.03a.75.75 0 0 1-1.15.64l-6-3.77a.8.8 0 0 1-.35-.64V5.75c0-.28.16-.54.41-.67zM7 6.22v10.85l4.5 2.82v-5.14c0-.28.16-.54.41-.67l4.66-2.33-4.66-2.33a.75.75 0 0 1 0-1.34l4.66-2.33-4.32-2.16z"
]);
const $77e1bce0ac0f7fe7$export$5a966efd4dd48271 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent32Filled', "32", [
    "M17.45 2.1a1 1 0 0 0-.9 0l-8 4A1 1 0 0 0 8 7v17.5c0 .36.2.7.51.87l8 4.5A1 1 0 0 0 18 29v-9.38l7.45-3.73a1 1 0 0 0 0-1.78L19.24 11l6.2-3.1a1 1 0 0 0 0-1.8z"
]);
const $77e1bce0ac0f7fe7$export$2e26587f6b78e01e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent32Regular', "32", [
    "M16.55 2.1a1 1 0 0 1 .9 0l8 4a1 1 0 0 1 0 1.8L19.24 11l6.2 3.1a1 1 0 0 1 0 1.8L18 19.61V29a1 1 0 0 1-1.49.87l-8-4.5A1 1 0 0 1 8 24.5V7a1 1 0 0 1 .55-.9zM10 7.63v16.3l6 3.37V19a1 1 0 0 1 .55-.9l6.21-3.1-6.2-3.1a1 1 0 0 1 0-1.8l6.2-3.1L17 4.12z"
]);
const $77e1bce0ac0f7fe7$export$508f1ce63642933 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent48Filled', "48", [
    "M25.17 4.16a1.5 1.5 0 0 0-1.34 0l-12 6c-.5.26-.83.78-.83 1.35v23.45c0 .52.27 1 .7 1.27l12 7.54A1.5 1.5 0 0 0 26 42.5V30.43l11.17-5.58a1.5 1.5 0 0 0 0-2.69l-9.32-4.65 9.32-4.66a1.5 1.5 0 0 0 0-2.69z"
]);
const $77e1bce0ac0f7fe7$export$e6822e43619d1fda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent48Regular', "48", [
    "M23.83 4.16a1.5 1.5 0 0 1 1.34 0l12 6a1.5 1.5 0 0 1 0 2.68l-9.32 4.66 9.32 4.66a1.5 1.5 0 0 1 0 2.68L26 30.43V42.5a1.5 1.5 0 0 1-2.3 1.27l-12-7.54a1.5 1.5 0 0 1-.7-1.27V11.5c0-.57.32-1.09.83-1.34zM14 12.43v21.7l9 5.66V29.5c0-.57.32-1.08.83-1.34l9.32-4.66-9.32-4.66a1.5 1.5 0 0 1 0-2.68l9.32-4.66-8.65-4.32z"
]);
const $77e1bce0ac0f7fe7$export$6eb6a67f3771aaef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid16Filled', "16", [
    "M1 2.5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5v2C6 5.33 5.33 6 4.5 6h-2A1.5 1.5 0 0 1 1 4.5zm7 7C8 8.67 8.67 8 9.5 8h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 8 13.5zm-5 1V7h1v3.5c0 .28.22.5.5.5H7v1H4.5A1.5 1.5 0 0 1 3 10.5M7 3v1h3.5c.28 0 .5.22.5.5V7h1V4.5c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$b74ad81d6d60e8a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid16Regular', "16", [
    "M1 2.5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5v2C6 5.33 5.33 6 4.5 6h-2A1.5 1.5 0 0 1 1 4.5zM2.5 2a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zM8 9.5C8 8.67 8.67 8 9.5 8h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 8 13.5zM9.5 9a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5zM3 10.5V7h1v3.5c0 .28.22.5.5.5H7v1H4.5A1.5 1.5 0 0 1 3 10.5M7 3v1h3.5c.28 0 .5.22.5.5V7h1V4.5c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$fba7ef6bf32c00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid20Filled', "20", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 5.54zM8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 0 0-.5-.5H8zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 0 1 4 13.5V8zm6.5 2c-.82 0-1.5.67-1.5 1.5v5c0 .83.68 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$1185b1d95d131234 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid20Regular', "20", [
    "M8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 0 0-.5-.5H8zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 0 1 4 13.5V8zM2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 5.54zM3.5 3a.5.5 0 0 0-.5.5v2.04c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5zm6.5 8.5c0-.83.68-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v5c0 .28.23.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$1d94df8ec55555ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid24Filled', "24", [
    "M11 5h5.75C17.99 5 19 6 19 7.25V11h-1.5V7.25a.75.75 0 0 0-.75-.75H11zm-4.5 6v5.75c0 .4.34.75.75.75H11V19H7.25C6.01 19 5 17.99 5 16.75V11zM2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5C10 8.99 9 10 7.75 10h-3.5C3.01 10 2 9 2 7.75zm10 10c0-1.24 1-2.25 2.25-2.25h5.5c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C13.01 22 12 21 12 19.75z"
]);
const $77e1bce0ac0f7fe7$export$e404823320523011 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid24Regular', "24", [
    "M11 5h5.75C17.99 5 19 6 19 7.25V11h-1.5V7.25a.75.75 0 0 0-.75-.75H11zm-4.5 6v5.75c0 .4.34.75.75.75H11V19H7.25C6.01 19 5 17.99 5 16.75V11zM2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5C10 8.99 9 10 7.75 10h-3.5C3.01 10 2 9 2 7.75zm2.25-.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75zM12 14.25c0-1.24 1-2.25 2.25-2.25h5.5c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C13.01 22 12 21 12 19.75zm2.25-.75a.75.75 0 0 0-.75.75v5.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 0 0-.75-.75z"
]);
const $77e1bce0ac0f7fe7$export$87ca6e2b3954ba16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart16Filled', "16", [
    "M10 3H6v1h.5a1.5 1.5 0 0 1 1.41 2H10zm1 10v-2h1.5a1.5 1.5 0 0 0 .4-2.95A1.5 1.5 0 0 0 11.5 6H11V3h1.5A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5zM9 9.5q0-.27.09-.5H7.5A1.5 1.5 0 0 1 6 7.5V13h4v-2.09c-.58-.2-1-.76-1-1.41M5 7H3.5a1.5 1.5 0 1 1 0-3H5V3H3.5A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13H5zM3.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm3 2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$a16ac00f51144127 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM3.5 4C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5H5V7h1v5h4v-1.09q.23.09.5.09h.5v1h1.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H11v2h-1V4zm0 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M10.5 9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$b4488b8abae85842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4H7v2H4.5a1.5 1.5 0 1 0 0 3H7v7H4.5A2.5 2.5 0 0 1 2 13.5zM8 16V9.5c0 .83.67 1.5 1.5 1.5H11v.5c0 .65.42 1.2 1 1.41V16zm2-8h2V4H8v2h.5c.83 0 1.5.67 1.5 1.5zm5.5 5H13v3h2.5a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4H13v4h.5c.83 0 1.5.67 1.5 1.5v.5h.5a1.5 1.5 0 0 1 0 3m-11-6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m3.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $77e1bce0ac0f7fe7$export$7fcd62f9f5e73ead = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart20Regular', "20", [
    "M4.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m3.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-8-7A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5H7v1h1V5h4v3h1V5h2.5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H13v-2h-1v2H8V9H7v6H4.5A1.5 1.5 0 0 1 3 13.5z"
]);
const $77e1bce0ac0f7fe7$export$8ccf786c11d897fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h3v3H6a2 2 0 1 0 0 4h2.25v9h-3A3.25 3.25 0 0 1 2 16.75zM9.25 20v-9H10v1c0 1.1.9 2 2 2h1v1a2 2 0 0 0 1.75 1.98V20zM12 10h2.75V4h-5.5v3H10a2 2 0 0 1 2 2zm6 7h-2.25v3h3c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4h-3v6H16a2 2 0 0 1 2 2v1a2 2 0 1 1 0 4M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zm5 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m4 2a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z"
]);
const $77e1bce0ac0f7fe7$export$3e93fbb4134394d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart24Regular', "24", [
    "M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zm5 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m4 2a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM8 5.5V7h1.5V5.5h5V10H16V5.5h2.75c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H16V17h-1a2 2 0 0 1-.5-.06v1.56h-5V11H8v7.5H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75z"
]);
const $77e1bce0ac0f7fe7$export$bb878c3f8f38c271 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke20Filled', "20", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98q.3.14.57.41c.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17q-2.15.28-3.22.52.3.08.68.14c.99.17 2.24.32 3.57.43 1 .09 2.09.23 3.01.4q.7.13 1.26.3.56.15.97.4c.13.1.3.23.42.45q.23.4.03.85c-.11.24-.3.4-.45.5q-.25.15-.54.25c-.77.29-2.15.55-4.29.8-2.12.23-3.4.54-4.11.85q-.44.2-.51.3.04.06.16.17.22.22.64.45c.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96q-.53-.3-.93-.65a2 2 0 0 1-.62-.94q-.17-.68.28-1.24.4-.49 1.1-.77c.93-.4 2.4-.73 4.55-.98q2.03-.23 3.05-.46l-.56-.12c-.86-.16-1.89-.29-2.86-.37a44 44 0 0 1-3.7-.46q-.8-.14-1.4-.3c-.37-.11-.75-.24-1.02-.43a1 1 0 0 1-.43-.49 1 1 0 0 1 .06-.87c.13-.22.32-.36.47-.44q.26-.14.56-.26c.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96q-.98-.3-2.9-.63a89 89 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82"
]);
const $77e1bce0ac0f7fe7$export$60be0391352f71ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke20Regular', "20", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96q.3.14.51.36c.14.16.27.4.22.69a1 1 0 0 1-.4.57q-.25.2-.63.34c-.99.4-2.89.77-5.92 1.15a23 23 0 0 0-4.13.78l.3.1q.51.13 1.28.27c1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4q.68.12 1.23.29.54.15.9.38.2.1.34.35.16.28.03.62a1 1 0 0 1-.37.4q-.2.12-.49.23c-.74.27-2.08.53-4.22.77a16 16 0 0 0-4.2.88c-.37.16-.55.3-.63.4q-.07.1-.04.14.01.1.26.35.25.23.7.48c.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94q-.5-.29-.88-.62a2 2 0 0 1-.55-.81q-.14-.55.23-1.03.35-.41 1.02-.7c.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7l-.3-.1q-.48-.15-1.14-.27a30 30 0 0 0-2.89-.38 44 44 0 0 1-3.68-.45q-.78-.15-1.37-.3Q5.37 9.26 5 9a1 1 0 0 1-.34-.38.7.7 0 0 1 .04-.64q.16-.25.39-.36.22-.12.52-.23a23 23 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09q.16-.06.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96"
]);
const $77e1bce0ac0f7fe7$export$a2f1b72be78160e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke24Filled', "24", [
    "M3 2.9A1 1 0 0 1 4.1 2l3.74.35c2.66.27 5.2.59 7.3.95 2.04.35 3.8.76 4.76 1.27q.4.18.73.55c.22.26.44.66.35 1.16-.08.46-.38.77-.61.96q-.38.3-.88.48c-1.27.53-3.66 1.03-7.4 1.51-1.67.22-2.91.44-3.8.64l.69.14c1.21.22 2.75.41 4.38.56a37 37 0 0 1 3.72.51q.86.17 1.57.38c.43.14.88.31 1.22.55.16.11.38.3.53.58.17.32.2.72.04 1.1-.15.31-.4.52-.58.65q-.3.2-.69.34c-.95.37-2.66.7-5.3 1.02-2.6.31-4.17.7-5.03 1.1q-.49.23-.59.36l.18.2q.27.27.79.57c.68.4 1.56.78 2.41 1.07l3.25 1.05a1 1 0 1 1-.61 1.9L11 20.9c-.94-.32-1.96-.75-2.8-1.25a6 6 0 0 1-1.15-.84c-.32-.3-.64-.71-.77-1.22a1.8 1.8 0 0 1 .34-1.6q.51-.63 1.4-1.01c1.14-.52 2.96-.95 5.62-1.26q2.37-.3 3.59-.56l-.54-.12c-1.05-.2-2.31-.37-3.5-.48a52 52 0 0 1-4.57-.59q-.99-.18-1.73-.4a5 5 0 0 1-1.29-.55 1.6 1.6 0 0 1-.54-.65c-.16-.39-.12-.8.07-1.13.17-.28.4-.46.6-.58q.31-.2.7-.34c1.01-.37 2.77-.72 5.41-1.07 3.23-.42 5.27-.83 6.4-1.2q-1.17-.39-3.44-.78c-2.03-.35-4.53-.66-7.16-.93L3.91 4A1 1 0 0 1 3 2.9"
]);
const $77e1bce0ac0f7fe7$export$dd5919b0fd22d902 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke24Regular', "24", [
    "M3.25 2.93c.04-.41.4-.72.82-.68l3.74.35c2.66.27 5.2.58 7.28.94 2.05.35 3.77.76 4.7 1.25q.36.19.65.5c.2.21.36.55.3.95-.07.37-.31.63-.53.8q-.34.26-.81.45c-1.24.51-3.6 1-7.33 1.5-2.38.3-3.9.61-4.76.89l.08.02q.61.18 1.54.35c1.23.23 2.77.42 4.4.57 1.25.1 2.57.28 3.7.5q.87.17 1.54.38c.43.14.85.3 1.16.51.15.1.33.26.45.5a1 1 0 0 1 .03.87c-.12.26-.32.43-.5.55q-.27.18-.62.32c-.93.35-2.6.69-5.24 1-2.62.32-4.22.71-5.11 1.12-.45.2-.65.38-.73.48q-.06.1-.04.1c.02.06.08.2.29.4q.3.29.83.6c.7.41 1.6.8 2.47 1.09l3.24 1.05a.75.75 0 0 1-.46 1.42l-3.26-1.05a15 15 0 0 1-2.75-1.22q-.63-.36-1.1-.81a2.4 2.4 0 0 1-.71-1.1q-.19-.74.3-1.39.45-.56 1.3-.94c1.1-.5 2.9-.92 5.55-1.24 2.29-.27 3.72-.55 4.54-.8l-.08-.03q-.57-.17-1.39-.33a35 35 0 0 0-3.54-.49 52 52 0 0 1-4.54-.58q-.97-.18-1.7-.4c-.46-.13-.9-.3-1.21-.52a1.3 1.3 0 0 1-.46-.54 1 1 0 0 1 .06-.9c.13-.23.34-.4.51-.5q.3-.18.66-.31c.98-.36 2.7-.72 5.35-1.06 3.75-.5 5.92-.97 6.95-1.4l.13-.05c-.73-.34-2.16-.7-4.11-1.03-2.04-.35-4.54-.66-7.17-.92l-3.74-.35a.75.75 0 0 1-.68-.82"
]);
const $77e1bce0ac0f7fe7$export$86014ece0efe0c7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown20Filled', "20", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98q.3.14.57.41c.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17q-2.15.28-3.22.52.3.08.68.14c.99.17 2.24.32 3.57.43 1 .09 2.09.23 3.01.4q.7.13 1.26.3.56.15.97.4a1.3 1.3 0 0 1 .49.59 1.75 1.75 0 0 0-2.33 1.65v.16q-1.13.23-2.99.44c-2.12.24-3.4.55-4.11.86q-.44.2-.51.3.04.06.16.17.22.22.64.45c.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96q-.53-.3-.93-.65a2 2 0 0 1-.62-.94q-.17-.68.28-1.24.4-.49 1.1-.77c.93-.4 2.4-.73 4.55-.98q2.03-.23 3.05-.46l-.56-.12c-.86-.16-1.89-.29-2.86-.37a44 44 0 0 1-3.7-.46q-.8-.14-1.4-.3c-.37-.11-.75-.24-1.02-.43a1 1 0 0 1-.43-.49 1 1 0 0 1 .06-.87c.13-.22.32-.36.47-.44q.26-.14.56-.26c.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96q-.98-.3-2.9-.63a89 89 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82M17 12.25a.75.75 0 0 0-1.5 0v4.19l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72z"
]);
const $77e1bce0ac0f7fe7$export$e00790a76164066e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown20Regular', "20", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96q.3.14.51.36c.14.16.27.4.22.69a1 1 0 0 1-.4.57q-.25.2-.63.34c-.99.4-2.89.77-5.92 1.15-2.15.27-3.44.53-4.1.77H5.9l.3.1q.51.15 1.28.28c1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4q.68.12 1.23.29.54.15.9.38.2.1.34.35.11.2.09.43L16.5 11a1.5 1.5 0 0 0-1.42 1.02c-.8.2-1.96.4-3.6.58a16 16 0 0 0-4.18.88c-.38.16-.56.3-.64.4q-.07.1-.04.14.01.1.26.35.25.23.7.48c.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94q-.5-.29-.88-.62a2 2 0 0 1-.55-.81q-.14-.55.23-1.03.35-.41 1.02-.7c.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7l-.3-.1q-.48-.15-1.14-.27a30 30 0 0 0-2.89-.38 44 44 0 0 1-3.68-.45q-.78-.15-1.37-.3Q5.37 9.26 5 9a1 1 0 0 1-.34-.38.7.7 0 0 1 .04-.64q.16-.25.39-.36.22-.12.52-.23a23 23 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09q.16-.06.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96m14 9.54a.5.5 0 0 0-1 0v4.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L17 17.29z"
]);
const $77e1bce0ac0f7fe7$export$c98df533bc0cc740 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown24Filled', "24", [
    "M3 2.9A1 1 0 0 1 4.1 2l3.74.35c2.66.27 5.2.59 7.3.95 2.04.35 3.8.76 4.76 1.27q.4.18.73.55c.22.26.44.66.35 1.16-.08.46-.38.77-.61.96q-.38.3-.88.48c-1.27.53-3.66 1.03-7.4 1.51-1.67.22-2.91.44-3.8.64l.69.14c1.21.22 2.75.41 4.38.56a37 37 0 0 1 3.72.51 16 16 0 0 1 1.89.5 2 2 0 0 0-1.47 1.92v1.64q-1.39.3-3.62.56c-2.61.31-4.18.7-5.04 1.1q-.49.23-.59.36l.18.2q.27.27.79.57c.68.4 1.56.78 2.41 1.07l3.25 1.05a1 1 0 1 1-.61 1.9L11 20.9c-.94-.32-1.96-.75-2.8-1.25a6 6 0 0 1-1.15-.84c-.32-.3-.64-.71-.77-1.22a1.8 1.8 0 0 1 .34-1.6q.51-.63 1.4-1.01c1.14-.52 2.96-.95 5.62-1.26q2.37-.3 3.59-.56l-.54-.12c-1.05-.2-2.31-.37-3.5-.48a52 52 0 0 1-4.57-.59q-.99-.18-1.73-.4a5 5 0 0 1-1.29-.55 1.6 1.6 0 0 1-.54-.65c-.16-.39-.12-.8.07-1.13.17-.28.4-.46.6-.58q.31-.2.7-.34c1.01-.37 2.77-.72 5.41-1.07 3.23-.42 5.27-.83 6.4-1.2q-1.17-.39-3.44-.78c-2.03-.35-4.53-.66-7.16-.93L3.91 4A1 1 0 0 1 3 2.9m17.5 10.6a1 1 0 1 0-2 0v6.09l-.8-.8a1 1 0 0 0-1.4 1.42l2.5 2.5a1 1 0 0 0 1.4 0l2.5-2.5a1 1 0 0 0-1.4-1.42l-.8.8z"
]);
const $77e1bce0ac0f7fe7$export$7de2fda0bebd41ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown24Regular', "24", [
    "M3.25 2.93c.04-.41.4-.72.82-.68l3.74.35c2.66.27 5.2.58 7.28.94 2.05.35 3.77.76 4.7 1.25q.36.19.65.5c.2.21.36.55.3.95-.07.37-.31.63-.53.8q-.34.26-.81.45c-1.24.51-3.6 1-7.33 1.5-2.38.3-3.9.61-4.76.89l.08.02q.61.18 1.54.35c1.23.23 2.77.42 4.4.57 1.25.1 2.57.28 3.7.5q.87.17 1.54.38.46.14.85.33c-.6.12-1.1.54-1.3 1.1q-.58-.18-1.38-.33a35 35 0 0 0-3.54-.49 52 52 0 0 1-4.54-.58q-.97-.18-1.7-.4c-.46-.13-.9-.3-1.21-.52a1.3 1.3 0 0 1-.46-.54 1 1 0 0 1 .06-.9c.13-.23.34-.4.51-.5q.3-.18.66-.31c.98-.36 2.7-.72 5.35-1.06 3.75-.5 5.92-.97 6.95-1.4l.13-.05c-.73-.34-2.16-.7-4.11-1.03-2.04-.35-4.54-.66-7.17-.92l-3.74-.35a.75.75 0 0 1-.68-.82M18 13.75v1.02q-1.45.36-4.15.68c-2.62.32-4.22.71-5.11 1.12-.45.2-.65.38-.73.48q-.06.1-.04.1c.02.06.08.2.29.4q.3.29.83.6c.7.41 1.6.8 2.47 1.09l3.24 1.05a.75.75 0 0 1-.46 1.42l-3.26-1.05a15 15 0 0 1-2.75-1.22q-.63-.36-1.1-.81a2.4 2.4 0 0 1-.71-1.1q-.19-.74.3-1.39.45-.56 1.3-.94c1.1-.5 2.9-.92 5.55-1.24 2.17-.26 3.58-.52 4.42-.76q-.09.26-.09.55m2.5 0a.75.75 0 0 0-1.5 0v6.69l-1.22-1.22a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22z"
]);
const $77e1bce0ac0f7fe7$export$1c60b86d4c317b5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown20Filled', "20", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98q.3.14.57.41c.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17q-2.15.28-3.22.52.3.08.68.14c.99.17 2.24.32 3.57.43a31 31 0 0 1 3.51.5l-1.28 1.29a32 32 0 0 0-2.36-.3 44 44 0 0 1-3.7-.45q-.8-.14-1.4-.3c-.37-.11-.75-.24-1.02-.43a1 1 0 0 1-.43-.49 1 1 0 0 1 .06-.87c.13-.22.32-.36.47-.44q.26-.14.56-.26c.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96q-.98-.3-2.9-.63a89 89 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82m10.13 8.23a1.8 1.8 0 0 0-.32 1.56q-.48.07-1.05.13c-2.12.24-3.4.55-4.11.86q-.44.2-.51.3.04.06.16.17.22.22.64.45c.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96q-.53-.3-.93-.65a2 2 0 0 1-.62-.94q-.17-.68.28-1.24.4-.49 1.1-.77c.93-.4 2.4-.73 4.55-.98q.87-.1 1.54-.2m3.9-1.44a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v4.38l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72v-4.38l.72.72a.75.75 0 1 0 1.06-1.06z"
]);
const $77e1bce0ac0f7fe7$export$acb5bd75150fbb3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown20Regular', "20", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96q.3.14.51.36c.14.16.27.4.22.69a1 1 0 0 1-.4.57q-.25.2-.63.34c-.99.4-2.89.77-5.92 1.15-2.15.27-3.44.53-4.1.77H5.9l.3.1q.51.15 1.28.28c1 .18 2.25.33 3.59.44a31 31 0 0 1 4.01.63l-.83.83-.38-.08a30 30 0 0 0-2.89-.38 44 44 0 0 1-3.68-.45q-.78-.15-1.37-.3Q5.37 9.26 5 9a1 1 0 0 1-.34-.38.7.7 0 0 1 .04-.64q.16-.25.39-.36.22-.12.52-.23a23 23 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09q.16-.06.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96m10.44 8.48a1.5 1.5 0 0 0-.44.97l-1.51.2a16 16 0 0 0-4.2.87c-.37.16-.55.3-.63.4q-.07.1-.04.14.01.1.26.35.25.23.7.48c.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94q-.5-.29-.88-.62a2 2 0 0 1-.55-.81q-.14-.55.23-1.03.35-.41 1.02-.7c.88-.38 2.32-.7 4.47-.95q1.31-.15 2.2-.3zm3.41-1.3a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.71L16 11.71v5.58l-1.15-1.14a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L17 17.29v-5.58l1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $77e1bce0ac0f7fe7$export$29b05b2de9f2c33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown24Filled', "24", [
    "M3 2.9A1 1 0 0 1 4.1 2l3.74.35c2.66.27 5.2.59 7.3.95 2.04.35 3.8.76 4.76 1.27q.4.18.73.55c.22.26.44.66.35 1.16-.08.46-.38.77-.61.96q-.38.3-.88.48c-1.27.53-3.66 1.03-7.4 1.51-1.67.22-2.91.44-3.8.64l.69.14c1.21.22 2.75.41 4.38.56a37 37 0 0 1 3.72.51l-1.5 1.5-.2.24q-1.09-.16-2.2-.26a52 52 0 0 1-4.56-.59q-.99-.18-1.73-.4a5 5 0 0 1-1.29-.55 1.6 1.6 0 0 1-.54-.65c-.16-.39-.12-.8.07-1.13.17-.28.4-.46.6-.58q.31-.2.7-.34c1.01-.37 2.77-.72 5.41-1.07 3.23-.42 5.27-.83 6.4-1.2q-1.17-.39-3.44-.78c-2.03-.35-4.53-.66-7.16-.93L3.91 4A1 1 0 0 1 3 2.9M15.6 15.42l.05.06q-.8.12-1.76.23c-2.61.31-4.18.7-5.04 1.1q-.49.23-.59.36l.18.2q.27.27.79.57c.68.4 1.56.78 2.41 1.07l3.25 1.05a1 1 0 1 1-.61 1.9L11 20.9c-.94-.32-1.96-.75-2.8-1.25a6 6 0 0 1-1.15-.84c-.32-.3-.64-.71-.77-1.22a1.8 1.8 0 0 1 .34-1.6q.51-.63 1.4-1.01c1.14-.52 2.96-.95 5.62-1.26l1.42-.19a2 2 0 0 0 .53 1.88m4.62-4.62a1 1 0 0 0-1.42 0l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8v5.68l-.8-.8a1 1 0 0 0-1.4 1.42l2.5 2.5a1 1 0 0 0 1.4 0l2.5-2.5a1 1 0 0 0-1.4-1.42l-.8.8V13.9l.8.8a1 1 0 0 0 1.4-1.42z"
]);
const $77e1bce0ac0f7fe7$export$378917b89e9e26d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown24Regular', "24", [
    "M3.25 2.93c.04-.41.4-.72.82-.68l3.74.35c2.66.27 5.2.58 7.28.94 2.05.35 3.77.76 4.7 1.25q.36.19.65.5c.2.21.36.55.3.95-.07.37-.31.63-.53.8q-.34.26-.81.45c-1.24.51-3.6 1-7.33 1.5-2.38.3-3.9.61-4.76.89l.08.02q.61.18 1.54.35c1.23.23 2.77.42 4.4.57a37 37 0 0 1 4.25.62l-1.27 1.28c-.97-.18-2.06-.32-3.1-.41a52 52 0 0 1-4.55-.58q-.97-.18-1.7-.4c-.46-.13-.9-.3-1.21-.52a1.3 1.3 0 0 1-.46-.54 1 1 0 0 1 .06-.9c.13-.23.34-.4.51-.5q.3-.18.66-.31c.98-.36 2.7-.72 5.35-1.06 3.75-.5 5.92-.97 6.95-1.4l.13-.05c-.73-.34-2.16-.7-4.11-1.03-2.04-.35-4.54-.66-7.17-.92l-3.74-.35a.75.75 0 0 1-.68-.82M15.6 13.71c-.16.49-.1 1.04.19 1.48q-.87.14-1.93.26c-2.62.32-4.22.71-5.11 1.12-.45.2-.65.38-.73.48q-.06.1-.04.1c.02.06.08.2.29.4q.3.29.83.6c.7.41 1.6.8 2.47 1.09l3.24 1.05a.75.75 0 0 1-.46 1.42l-3.26-1.05a15 15 0 0 1-2.75-1.22q-.63-.36-1.1-.81a2.4 2.4 0 0 1-.71-1.1q-.19-.74.3-1.39.45-.56 1.3-.94c1.1-.5 2.9-.92 5.55-1.24zm4.69-2.49a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06L19 13.56v6.88l-1.22-1.22a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22v-6.88l1.22 1.22a.75.75 0 1 0 1.06-1.06z"
]);
const $77e1bce0ac0f7fe7$export$9021b747ff7bc51d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool16Filled', "16", [
    "M2 1a1 1 0 0 0-1 1v1.5C1 4.33 1.67 5 2.5 5h11c.83 0 1.5-.67 1.5-1.5V2a1 1 0 0 0-1-1zm4.5 12c.02.41.12.86.32 1.23.21.39.6.76 1.17.77H8c.58 0 .97-.38 1.18-.77.2-.37.3-.82.31-1.23zm3.48-1.55L12.74 6H3.26l2.76 5.45a1 1 0 0 0 .89.55h2.18a1 1 0 0 0 .89-.55"
]);
const $77e1bce0ac0f7fe7$export$5070b677b3f58149 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool16Regular', "16", [
    "M2 1.5a.5.5 0 0 0-1 0v2C1 4.33 1.67 5 2.5 5h.25l3.26 6.45a1 1 0 0 0 .58.5c-.12.62-.11 1.23.02 1.74.17.64.6 1.31 1.4 1.31.78 0 1.22-.67 1.39-1.31.13-.5.14-1.12.02-1.74a1 1 0 0 0 .56-.5L13.25 5h.25c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zM3.87 5h8.26l-3.04 6H6.91zm3.73 7h.8c.14.55.13 1.06.03 1.44-.13.48-.33.56-.43.56s-.3-.08-.42-.56c-.1-.38-.1-.9.02-1.44"
]);
const $77e1bce0ac0f7fe7$export$37882fad2a818ec6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool20Filled', "20", [
    "m8.52 15-.02.5c0 .58.07 1.16.27 1.62s.6.88 1.23.88 1.02-.41 1.23-.88c.2-.46.27-1.04.27-1.62q0-.26-.02-.5zM2.5 5.5v-3c0-.28.22-.5.5-.5h14c.28 0 .5.22.5.5v3c0 .83-.67 1.5-1.5 1.5H4a1.5 1.5 0 0 1-1.5-1.5M4.75 8l2.72 5.45a1 1 0 0 0 .9.55h3.26a1 1 0 0 0 .9-.55L15.25 8z"
]);
const $77e1bce0ac0f7fe7$export$f92fae909a5b0ebe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool20Regular', "20", [
    "M3.5 2.5a.5.5 0 0 0-1 0v3C2.5 6.33 3.17 7 4 7h.2l3.58 7.17q.26.5.75.71c-.05.66-.03 1.31.1 1.83q.13.5.45.88.35.4.92.41.58-.02.93-.41.32-.37.43-.88c.14-.52.17-1.17.11-1.83.32-.14.6-.39.75-.7L15.81 7H16c.83 0 1.5-.67 1.5-1.5v-3a.5.5 0 0 0-1 0v3a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5zM5.3 7h9.4l-3.37 6.72a.5.5 0 0 1-.45.28H9.12a.5.5 0 0 1-.45-.28zm4.22 8h.96q.06.89-.08 1.46-.1.35-.21.45A.2.2 0 0 1 10 17a.2.2 0 0 1-.18-.09 1 1 0 0 1-.21-.45q-.15-.57-.09-1.46"
]);
const $77e1bce0ac0f7fe7$export$81989a399a84a1b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool24Filled', "24", [
    "M13.82 20.04q-.18.69-.56 1.27a1.5 1.5 0 0 1-2.47.08l-.08-.12-.13-.22q-.25-.47-.39-1.01a6 6 0 0 1-.16-2.04h3.94q.1 1.08-.15 2.04M18.48 9 15 16.09c-.22.45-.62.78-1.1.91h-3.73l-.1-.03q-.58-.2-.92-.72l-.08-.15L5.54 9zm1.77-7c.38 0 .7.28.74.65l.01.1v3.5c0 .92-.7 1.67-1.6 1.74H4.74c-.92 0-1.67-.7-1.74-1.6V2.75c0-.38.27-.7.64-.75h16.6"
]);
const $77e1bce0ac0f7fe7$export$116758badd387170 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool24Regular', "24", [
    "M4.5 2.75a.75.75 0 0 0-1.5 0v3.5C3 7.22 3.78 8 4.75 8h.27l4.03 8.97c.2.45.59.79 1.04.94a6 6 0 0 0 .27 3.01c.3.6.83 1.08 1.64 1.08s1.35-.48 1.64-1.08a5.79 5.79 0 0 0 .27-3.01c.45-.15.83-.49 1.04-.94L18.98 8h.27C20.22 8 21 7.22 21 6.25v-3.5a.75.75 0 0 0-1.5 0v3.5c0 .14-.11.25-.25.25H4.75a.25.25 0 0 1-.25-.25zM6.66 8h10.68l-3.76 8.35a.3.3 0 0 1-.23.15h-2.7a.3.3 0 0 1-.23-.15zm4.95 10h.78q.1.4.11 1 0 .86-.21 1.26c-.1.22-.2.24-.29.24-.1 0-.18-.02-.29-.24A3 3 0 0 1 11.5 19q0-.6.11-1"
]);
const $77e1bce0ac0f7fe7$export$14417d4ea4594e08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool32Filled', "32", [
    "M4.02 2a2 2 0 0 0-2 2v.81L2 5v2a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V4a2 2 0 0 0-2-2zm9 24c.02.82.21 1.72.62 2.45.43.78 1.2 1.54 2.34 1.55h.04c1.14-.01 1.91-.77 2.34-1.55.4-.73.6-1.63.62-2.45zm6.94-3.1L25.48 12H6.52l5.51 10.9a2 2 0 0 0 1.79 1.1h4.36a2 2 0 0 0 1.78-1.1"
]);
const $77e1bce0ac0f7fe7$export$a648b3da81f079da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool32Regular', "32", [
    "M4.02 2.95a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h.46l6.55 12.95a2 2 0 0 0 1.11.98c-.07.62-.12 1.33-.12 1.97 0 .86.19 1.82.62 2.6S14.84 30 15.98 30h.04c1.14-.01 1.91-.77 2.34-1.55s.62-1.74.62-2.6a18 18 0 0 0-.12-1.97 2 2 0 0 0 1.1-.98l6.56-12.95h.5a3 3 0 0 0 3-3v-4a1 1 0 1 0-2 0v4a1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1zM16.86 24a14 14 0 0 1 .12 1.85c0 .6-.14 1.21-.37 1.64-.23.41-.44.5-.61.51-.17 0-.38-.1-.6-.5a3.6 3.6 0 0 1-.38-1.65c0-.54.04-1.17.11-1.73l.01-.12zm7.42-14.05L18.18 22h-4.36L7.72 9.95z"
]);
const $77e1bce0ac0f7fe7$export$31d6c02426837894 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent16Filled', "16", [
    "M14.5 2v2a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2zm-4 2.5.52.48-2.4 4.75a.5.5 0 1 1-.9-.46l2.18-4.3zM9 13c0 .83-.45 1.5-1 1.5s-1-.67-1-1.5.45-1.5 1-1.5 1 .67 1 1.5"
]);
const $77e1bce0ac0f7fe7$export$9631b11e278f0648 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent20Filled', "20", [
    "M17 6V3H3v3c0 .28.22.5.5.5h13A.5.5 0 0 0 17 6m-4.55 1-2.4 4.78a.5.5 0 1 0 .9.44L13.56 7 13 6.5zM10 17.5c.55 0 1-.67 1-1.5s-.45-1.5-1-1.5-1 .67-1 1.5.45 1.5 1 1.5"
]);
const $77e1bce0ac0f7fe7$export$17c239c39472ca80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent24Filled', "24", [
    "M4 7h16.25q.2-.01.24-.2l.01-.05V3H3.75v3.75q.01.2.2.24zm7.98 6.95L14.62 8l.88-.5.76.5-2.91 6.55a.75.75 0 1 1-1.37-.6M13 19c0 1.1-.45 2-1 2s-1-.9-1-2 .45-2 1-2 1 .9 1 2"
]);
const $77e1bce0ac0f7fe7$export$c864ecab0625870b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent32Filled', "32", [
    "M3 4h26v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-.1.45l-5 10a1 1 0 1 1-1.8-.9L20.89 9H4a1 1 0 0 1-1-1zm14.86 21.88c0 1.86-.87 3.37-1.93 3.37-1.07 0-1.93-1.51-1.93-3.37 0-1.87.86-3.38 1.93-3.38s1.93 1.51 1.93 3.38"
]);
const $77e1bce0ac0f7fe7$export$99bc36e4aa597c58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot16Filled', "16", [
    "M12 3.5a1.5 1.5 0 0 1-1.75 1.48L9.63 6.1c.48.41.8 1 .86 1.67l.66.08a1.5 1.5 0 1 1-.11 1l-.66-.08q-.32.92-1.13 1.4l.28.83a1.5 1.5 0 1 1-.95.32l-.28-.84a2.5 2.5 0 0 1-2.2-.85l-1.12.62.02.25a1.5 1.5 0 1 1-.5-1.12l1.12-.63a2.5 2.5 0 0 1 .3-2.13l-.77-.77Q4.85 6 4.5 6a1.5 1.5 0 1 1 1.35-.85l.77.76a2.5 2.5 0 0 1 2.13-.3l.63-1.12a1.5 1.5 0 1 1 2.62-1"
]);
const $77e1bce0ac0f7fe7$export$253946f40477962b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot16Regular', "16", [
    "M10 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m.5-1.5a1.5 1.5 0 0 0-1.12 2.5l-.63 1.12a2.5 2.5 0 0 0-2.13.3l-.77-.77Q6 4.85 6 4.5a1.5 1.5 0 1 0-.85 1.35l.76.77a2.5 2.5 0 0 0-.3 2.13l-1.12.63a1.5 1.5 0 1 0 .49.87l1.12-.62a2.5 2.5 0 0 0 2.2.85l.28.84a1.5 1.5 0 1 0 .95-.32l-.28-.83c.53-.31.94-.8 1.13-1.4l.66.07a1.5 1.5 0 1 0 .1-1l-.65-.07a2.5 2.5 0 0 0-.86-1.67l.62-1.12.25.02a1.5 1.5 0 0 0 0-3m-6 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-1 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1M9 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M12.5 8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1M8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $77e1bce0ac0f7fe7$export$750f138dd499bbd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot20Filled', "20", [
    "M16 4a2 2 0 0 1-2.65 1.89l-1.28 1.94A3 3 0 0 1 13 9.99l1.17.2a2 2 0 1 1-.16.99l-1.17-.2a3 3 0 0 1-1.43 1.67l.45 1.36H12a2 2 0 1 1-1.1.31l-.44-1.35a3 3 0 0 1-2.87-1.18l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4"
]);
const $77e1bce0ac0f7fe7$export$a909f8c4614de31c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot20Regular', "20", [
    "M16 4a2 2 0 0 1-2.65 1.89l-1.28 1.94A3 3 0 0 1 13 9.99l1.17.2a2 2 0 1 1-.16.99l-1.17-.2a3 3 0 0 1-1.43 1.67l.45 1.36H12a2 2 0 1 1-1.1.31l-.44-1.35a3 3 0 0 1-2.87-1.18l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m8 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $77e1bce0ac0f7fe7$export$c5551bf103f7ec62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot24Filled', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06C15.5 9.79 16 10.84 16 12v.05l1.3.27a2.5 2.5 0 1 1-.28 1.47l-1.32-.26a4 4 0 0 1-1.75 1.96l.5 1.51h.05a2.5 2.5 0 1 1-1.47.48l-.5-1.51a4 4 0 0 1-3.75-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a4 4 0 0 1 3.36-.23l1.25-2.06a2.5 2.5 0 0 1 1.82-4.22A2.5 2.5 0 0 1 19 4.5"
]);
const $77e1bce0ac0f7fe7$export$54137c4bbdbd23ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot24Regular', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06a4 4 0 0 1 1.29 3l1.3.26a2.5 2.5 0 1 1-.28 1.47l-1.32-.26a4 4 0 0 1-1.75 1.96l.5 1.51h.05a2.5 2.5 0 1 1-1.47.48l-.5-1.51a4 4 0 0 1-3.75-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a4 4 0 0 1 3.36-.23l1.25-2.06a2.5 2.5 0 0 1 1.82-4.22A2.5 2.5 0 0 1 19 4.5m-1.5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-6.5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $77e1bce0ac0f7fe7$export$536f726ca911407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert16Filled', "16", [
    "M12 3.5a1.5 1.5 0 0 1-1.75 1.48L9.63 6.1l.24.24A4 4 0 0 0 7.5 10v.45a2.5 2.5 0 0 1-1.4-.82l-1.12.62.02.25a1.5 1.5 0 1 1-.5-1.12l1.12-.63a2.5 2.5 0 0 1 .3-2.13l-.77-.77Q4.85 6 4.5 6a1.5 1.5 0 1 1 1.35-.85l.77.76a2.5 2.5 0 0 1 2.13-.3l.63-1.12a1.5 1.5 0 1 1 2.62-1M8.5 10a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L8.5 12zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $77e1bce0ac0f7fe7$export$e849023048eecae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert16Regular', "16", [
    "M10 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m.5-1.5a1.5 1.5 0 0 0-1.12 2.5l-.63 1.12a2.5 2.5 0 0 0-2.13.3l-.77-.77Q6 4.85 6 4.5a1.5 1.5 0 1 0-.85 1.35l.76.77a2.5 2.5 0 0 0-.3 2.13l-1.12.63a1.5 1.5 0 1 0 .49.87l1.12-.62q.55.63 1.4.82V10q0-.3.04-.57A1.5 1.5 0 1 1 9 6.88a4 4 0 0 1 .87-.54l-.24-.24.62-1.12.25.02a1.5 1.5 0 0 0 0-3m-6 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-1 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m5 0a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L8.5 12zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $77e1bce0ac0f7fe7$export$4756fe773519dbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert20Filled', "20", [
    "M16 4a2 2 0 0 1-2.65 1.88l-1.28 1.95.3.33A4 4 0 0 0 9.5 12v.96a3 3 0 0 1-1.91-1.17l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4m-5.5 8a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 14zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $77e1bce0ac0f7fe7$export$d34f3271637ba402 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert20Regular', "20", [
    "M16 4a2 2 0 0 1-2.65 1.88l-1.28 1.95.3.33q-.51.15-.96.43A2 2 0 0 0 8 10a2 2 0 0 0 1.5 1.94v1.02a3 3 0 0 1-1.91-1.17l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a3 3 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0m5.5-1a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 14zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1"
]);
const $77e1bce0ac0f7fe7$export$3f27b8d15458bedc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert24Filled', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06q.49.45.8 1.04a5 5 0 0 0-4 4.9v.97a4 4 0 0 1-2.73-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a4 4 0 0 1 3.36-.24l1.25-2.06A2.5 2.5 0 0 1 16.5 2 2.5 2.5 0 0 1 19 4.5M16.5 11a4 4 0 0 0-4 4v3l-.95.8c-.3.26-.46.39-.5.5a.5.5 0 0 0 .24.65c.1.05.3.05.7.05h9.02c.4 0 .6 0 .7-.05a.5.5 0 0 0 .25-.66c-.05-.1-.2-.23-.5-.49l-.96-.8v-3a4 4 0 0 0-4-4M18 21c-.22.58-.8 1-1.5 1-.69 0-1.28-.42-1.5-1z"
]);
const $77e1bce0ac0f7fe7$export$1c17e488fc78c010 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert24Regular', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06q.49.45.8 1.04-.76.16-1.42.52a2.5 2.5 0 1 0-2.56 3.84q-.03.26-.03.54v.97a4 4 0 0 1-2.72-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a4 4 0 0 1 3.36-.24l1.25-2.06A2.5 2.5 0 0 1 16.5 2 2.5 2.5 0 0 1 19 4.5m-1.5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0M7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m11-4.5a4 4 0 0 0-4 4v3l-.95.8c-.3.26-.46.39-.5.5a.5.5 0 0 0 .24.65c.1.05.3.05.7.05h9.02c.4 0 .6 0 .7-.05a.5.5 0 0 0 .25-.66c-.05-.1-.2-.23-.5-.49l-.96-.8v-3a4 4 0 0 0-4-4M18 21c-.22.58-.8 1-1.5 1-.69 0-1.28-.42-1.5-1z"
]);
const $77e1bce0ac0f7fe7$export$b644bfe289cc36e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_16_color__a)",
            "d": "M1 3.25C1 2.55 1.56 2 2.25 2h.5C3.44 2 4 2.56 4 3.25v9.5c0 .68-.56 1.24-1.25 1.24h-.5C1.55 14 1 13.43 1 12.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_16_color__b)",
            "d": "M5 3.25C5 2.55 5.56 2 6.25 2h.5c.68 0 1.24.56 1.24 1.25v9.5c0 .68-.56 1.24-1.24 1.24h-.5C5.55 14 5 13.43 5 12.74z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_16_color__c)",
            "d": "M11.97 4.78a1.25 1.25 0 0 0-1.57-.72l-.58.2c-.67.24-1.01 1-.75 1.65l2.94 7.3c.25.63.94.94 1.57.72l.58-.2c.68-.24 1.02-.99.75-1.65z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_16_color__d)",
            "d": "M1 4h3v2H1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_16_color__e)",
            "d": "M12.31 5.62 9.42 6.79l.75 1.84 2.88-1.16z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_16_color__f)",
            "d": "M8 4H5v2h3z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_16_color__a",
                "x1": "4.47",
                "x2": "5.64",
                "y1": "3.99",
                "y2": "17.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_16_color__b",
                "x1": "4.47",
                "x2": "5.64",
                "y1": "3.99",
                "y2": "17.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_16_color__c",
                "x1": "4.47",
                "x2": "5.64",
                "y1": "3.99",
                "y2": "17.42",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_16_color__d",
                "x1": "5",
                "x2": "8.89",
                "y1": ".18",
                "y2": "1.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_16_color__e",
                "x1": "5",
                "x2": "8.89",
                "y1": ".18",
                "y2": "1.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_16_color__f",
                "x1": "5",
                "x2": "8.89",
                "y1": ".18",
                "y2": "1.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$5894e417a4f344da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library16Filled', "16", [
    "M2.25 2C1.55 2 1 2.56 1 3.25v9.5c0 .68.56 1.24 1.25 1.24h.5C3.44 14 4 13.43 4 12.74v-9.5C4 2.57 3.44 2 2.75 2zm4 0C5.55 2 5 2.56 5 3.25v9.5c0 .68.56 1.24 1.25 1.24h.5c.69 0 1.24-.56 1.24-1.25v-9.5C8 2.57 7.44 2 6.75 2zm5.72 2.78a1.25 1.25 0 0 0-1.57-.72l-.58.2c-.67.24-1.01 1-.75 1.65l2.94 7.3c.25.63.94.94 1.57.72l.58-.2c.68-.24 1.02-.99.75-1.65z"
]);
const $77e1bce0ac0f7fe7$export$ca3a7deb4a8c44a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library16Regular', "16", [
    "M1 3.25C1 2.55 1.56 2 2.25 2h.5C3.44 2 4 2.56 4 3.25v9.5c0 .69-.56 1.24-1.25 1.24h-.5C1.55 14 1 13.44 1 12.74zM2.25 3a.25.25 0 0 0-.25.25v9.5c0 .13.11.24.25.24h.5c.14 0 .25-.1.25-.25v-9.5A.25.25 0 0 0 2.75 3zM5 3.25C5 2.55 5.56 2 6.25 2h.5c.68 0 1.24.56 1.24 1.25v9.5c0 .69-.56 1.24-1.24 1.24h-.5C5.55 14 5 13.44 5 12.74zM6.25 3a.25.25 0 0 0-.25.25v9.5c0 .13.1.24.25.24h.5c.13 0 .24-.1.24-.25v-9.5A.25.25 0 0 0 6.75 3zm5.72 1.78a1.25 1.25 0 0 0-1.57-.72l-.58.2c-.67.24-1.01 1-.75 1.65l2.94 7.3c.25.63.94.94 1.57.72l.58-.2c.68-.24 1.02-.99.75-1.65zM10.73 5c.13-.05.27.02.32.14l2.93 7.3a.25.25 0 0 1-.15.33l-.58.2a.25.25 0 0 1-.31-.14L10 5.54a.25.25 0 0 1 .15-.33z"
]);
const $77e1bce0ac0f7fe7$export$bb643549357f69fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__a)",
            "d": "M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__b)",
            "d": "M7 3.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__c)",
            "d": "M15.72 6.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.85 1.15l.98-.25c.79-.2 1.27-1 1.1-1.78z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__d)",
            "d": "M6 7H2V5h4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__e)",
            "d": "m12.32 8.36 3.73-.76.45 1.95-3.78.76z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_20_color__f)",
            "d": "M7 7h4V5H7z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__a",
                "x1": "7.52",
                "x2": "9.5",
                "y1": "4.99",
                "y2": "22.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__b",
                "x1": "7.52",
                "x2": "9.5",
                "y1": "4.99",
                "y2": "22.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__c",
                "x1": "7.52",
                "x2": "9.5",
                "y1": "4.99",
                "y2": "22.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__d",
                "x1": "7",
                "x2": "11",
                "y1": "4.09",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__e",
                "x1": "7",
                "x2": "11",
                "y1": "4.09",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_20_color__f",
                "x1": "7",
                "x2": "11",
                "y1": "4.09",
                "y2": "6.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$ca4036e17e9e2d76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library20Filled', "20", [
    "M3.5 2C2.67 2 2 2.67 2 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5C6 2.67 5.33 2 4.5 2zm5 0C7.67 2 7 2.67 7 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5c0-.83-.67-1.5-1.5-1.5zm7.22 4.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78z"
]);
const $77e1bce0ac0f7fe7$export$c68c3f24d351ec39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library20Regular', "20", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zM3.5 3a.5.5 0 0 0-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5zm3.5.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zM8.5 3a.5.5 0 0 0-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5zm7.22 3.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78zM14.12 6a.5.5 0 0 1 .62.37L17 16.14a.5.5 0 0 1-.37.6l-.98.25a.5.5 0 0 1-.61-.39l-2-9.8a.5.5 0 0 1 .35-.58z"
]);
const $77e1bce0ac0f7fe7$export$775cea28b801f1c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_24_color__a)",
            "d": "M5.5 3C6.33 3 7 3.67 7 4.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 19.5v-15C2 3.67 2.67 3 3.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_24_color__b)",
            "d": "M11.5 3c.83 0 1.5.67 1.5 1.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 8 19.5v-15C8 3.67 8.67 3 9.5 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_24_color__c)",
            "d": "M22 18.64 18.78 6.12a1.5 1.5 0 0 0-1.82-1.08l-1.88.49A1.5 1.5 0 0 0 14 7.35l3.21 12.52a1.5 1.5 0 0 0 1.83 1.08l1.88-.48A1.5 1.5 0 0 0 22 18.64"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_24_color__d)",
            "d": "M2 6h5v2H2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_24_color__e)",
            "d": "m14.98 11.18 4.79-1.22-.5-1.93-4.79 1.21z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_24_color__f)",
            "d": "M13 6H8v2h5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_24_color__a",
                "x1": "-1.75",
                "x2": "2.7",
                "y1": "3",
                "y2": "26.49",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_24_color__b",
                "x1": "-1.75",
                "x2": "2.7",
                "y1": "3",
                "y2": "26.49",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_24_color__c",
                "x1": "-1.75",
                "x2": "2.7",
                "y1": "3",
                "y2": "26.49",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_24_color__d",
                "x1": "8",
                "x2": "13.97",
                "y1": "2.18",
                "y2": "4.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_24_color__e",
                "x1": "8",
                "x2": "13.97",
                "y1": "2.18",
                "y2": "4.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_24_color__f",
                "x1": "8",
                "x2": "13.97",
                "y1": "2.18",
                "y2": "4.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$eacb829816973375 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library24Filled', "24", [
    "M5.5 3C6.33 3 7 3.67 7 4.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 19.5v-15C2 3.67 2.67 3 3.5 3zm6 0c.83 0 1.5.67 1.5 1.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 8 19.5v-15C8 3.67 8.67 3 9.5 3zm7.28 3.12L22 18.64c.2.8-.28 1.62-1.09 1.83l-1.87.48a1.5 1.5 0 0 1-1.83-1.08L14 7.35a1.5 1.5 0 0 1 1.08-1.82l1.87-.49c.8-.2 1.63.28 1.83 1.08"
]);
const $77e1bce0ac0f7fe7$export$c5f634ab1adc95c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library24Regular', "24", [
    "M4 3h1a2 2 0 0 1 2 1.85V19a2 2 0 0 1-1.85 2H4a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2zh1zm6 0h1a2 2 0 0 1 2 1.85V19a2 2 0 0 1-1.85 2H10a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2zh1zm6.97 2a2 2 0 0 1 1.9 1.35l.04.15 3.02 11.75a2 2 0 0 1-1.3 2.39l-.14.04-.97.25q-.26.06-.5.06a2 2 0 0 1-1.89-1.34l-.05-.16-3.01-11.74a2 2 0 0 1 1.3-2.4l.14-.04.97-.25q.24-.06.5-.06M5 4.5H4a.5.5 0 0 0-.5.41V19c0 .24.18.45.41.5H5a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5zm6 0h-1a.5.5 0 0 0-.5.41V19c0 .24.18.45.41.5H11a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5zm5.98 2h-.07l-.06.02-.97.24a.5.5 0 0 0-.38.51l.02.1 3.02 11.75c.06.26.3.37.48.37h.06l.06-.01.97-.25a.5.5 0 0 0 .38-.52l-.02-.09-3.01-11.74a.5.5 0 0 0-.48-.38"
]);
const $77e1bce0ac0f7fe7$export$5799b08562e2fded = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_28_color__a)",
            "d": "M7.99 5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v18c0 1.1.9 2 2 2H6a2 2 0 0 0 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_28_color__b)",
            "d": "m22.07 6.54 3.86 15.49a2 2 0 0 1-1.46 2.42l-1.96.49a2 2 0 0 1-2.42-1.46L16.23 8a2 2 0 0 1 1.45-2.42l1.97-.5a2 2 0 0 1 2.42 1.46"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_28_color__c)",
            "d": "M12.99 3a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_28_color__d)",
            "d": "M2 7h6v2H2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_28_color__e)",
            "d": "M9 7h6v2H9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_28_color__f)",
            "d": "m16.87 10.57 5.81-1.58.49 1.95-5.82 1.57z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_28_color__a",
                "x1": "4.51",
                "x2": "10.05",
                "y1": "3",
                "y2": "31.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_28_color__b",
                "x1": "4.51",
                "x2": "10.05",
                "y1": "3",
                "y2": "31.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_28_color__c",
                "x1": "4.51",
                "x2": "10.05",
                "y1": "3",
                "y2": "31.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_28_color__d",
                "x1": "16.87",
                "x2": "24.87",
                "y1": "2.27",
                "y2": "4.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_28_color__e",
                "x1": "16.87",
                "x2": "24.87",
                "y1": "2.27",
                "y2": "4.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_28_color__f",
                "x1": "16.87",
                "x2": "24.87",
                "y1": "2.27",
                "y2": "4.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$ce54b8f2bc4a345e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library28Filled', "28", [
    "M5.99 3a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm7 0a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm9.08 3.54 3.86 15.49a2 2 0 0 1-1.46 2.42l-1.96.49a2 2 0 0 1-2.42-1.46L16.23 8a2 2 0 0 1 1.45-2.42l1.97-.5a2 2 0 0 1 2.42 1.46"
]);
const $77e1bce0ac0f7fe7$export$324c0f16d960966a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library28Regular', "28", [
    "M4 3h1.99a2 2 0 0 1 2 1.85V23a2 2 0 0 1-1.85 2H4a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2zh1.99zm7 0h1.99a2 2 0 0 1 2 1.85V23a2 2 0 0 1-1.85 2h-2.15A2 2 0 0 1 9 23.15V5a2 2 0 0 1 1.85-2zh2zm9.13 2.03a2 2 0 0 1 1.9 1.36l.04.15 3.86 15.49a2 2 0 0 1-1.31 2.38l-.15.04-1.96.49q-.24.06-.48.06a2 2 0 0 1-1.9-1.36l-.04-.16L16.23 8a2 2 0 0 1 1.3-2.38l.15-.04 1.97-.5q.24-.05.48-.05M5.99 4.5H4a.5.5 0 0 0-.5.41V23c0 .24.18.45.41.5h2.08a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5zm7 0h-2a.5.5 0 0 0-.49.41V23c0 .24.17.45.4.5H13a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5zm7.14 2.03h-.06l-.06.01-1.96.49a.5.5 0 0 0-.38.52l.01.09 3.86 15.48c.07.26.3.38.49.38h.06l.06-.02L24.1 23a.5.5 0 0 0 .38-.52l-.02-.1-3.86-15.47a.5.5 0 0 0-.48-.38"
]);
const $77e1bce0ac0f7fe7$export$fad11b49e8c5b7d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_32_color__a)",
            "d": "M3 5.5A2.5 2.5 0 0 1 5.5 3h2A2.5 2.5 0 0 1 10 5.5v21A2.5 2.5 0 0 1 7.5 29h-2A2.5 2.5 0 0 1 3 26.5zm9 0A2.5 2.5 0 0 1 14.5 3h2A2.5 2.5 0 0 1 19 5.5v21a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5zm9.8 2.1a2.5 2.5 0 0 0-1.72 3.08l4.27 16.46a2.4 2.4 0 0 0 2.98 1.77l1.87-.52a2.5 2.5 0 0 0 1.72-3.07L26.65 8.86a2.4 2.4 0 0 0-2.98-1.77z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_32_color__b)",
            "d": "M3 8h7v3H3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_32_color__c)",
            "d": "m27.3 11.37-6.58 1.76.75 2.9 6.58-1.76z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_library_32_color__d)",
            "d": "M19 8h-7v3h7z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_32_color__a",
                "x1": "-18",
                "x2": "-16.29",
                "y1": "3",
                "y2": "38.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_32_color__b",
                "x1": "12",
                "x2": "20.49",
                "y1": "2.27",
                "y2": "5.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_32_color__c",
                "x1": "12",
                "x2": "20.49",
                "y1": "2.27",
                "y2": "5.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_library_32_color__d",
                "x1": "12",
                "x2": "20.49",
                "y1": "2.27",
                "y2": "5.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9ff0f9"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6ce0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$fbecd61f36260cb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library32Filled', "32", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h2A2.5 2.5 0 0 1 10 5.5v21A2.5 2.5 0 0 1 7.5 29h-2A2.5 2.5 0 0 1 3 26.5zm9 0A2.5 2.5 0 0 1 14.5 3h2A2.5 2.5 0 0 1 19 5.5v21a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5zm9.8 2.1a2.5 2.5 0 0 0-1.72 3.08l4.27 16.46a2.4 2.4 0 0 0 2.98 1.77l1.87-.52a2.5 2.5 0 0 0 1.72-3.07L26.65 8.86a2.4 2.4 0 0 0-2.98-1.77z"
]);
const $77e1bce0ac0f7fe7$export$67c0775baabbf4de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library32Regular', "32", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h2A2.5 2.5 0 0 1 10 5.5v21A2.5 2.5 0 0 1 7.5 29h-2A2.5 2.5 0 0 1 3 26.5zM5.5 5a.5.5 0 0 0-.5.5v21c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-21a.5.5 0 0 0-.5-.5zm6.5.5A2.5 2.5 0 0 1 14.5 3h2A2.5 2.5 0 0 1 19 5.5v21a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5zm2.5-.5a.5.5 0 0 0-.5.5v21c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-21a.5.5 0 0 0-.5-.5zm7.3 2.6a2.5 2.5 0 0 0-1.72 3.08l4.27 16.46a2.4 2.4 0 0 0 2.98 1.77l1.87-.52a2.5 2.5 0 0 0 1.72-3.07L26.65 8.86a2.4 2.4 0 0 0-2.98-1.77zm.16 2.56a.5.5 0 0 1 .34-.62l1.88-.52c.26-.07.52.09.6.36l4.26 16.46a.5.5 0 0 1-.34.62l-1.88.52a.5.5 0 0 1-.6-.36z"
]);
const $77e1bce0ac0f7fe7$export$176c1cbaedb2c917 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv16Filled', "16", [
    "M13.22 4.25 7.09 6.24a1 1 0 0 1-.24.08L4.75 7h8.75c.28 0 .5.22.5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 12.5v-5q0-.15.09-.29l-.2-.6A2.5 2.5 0 0 1 3.5 3.46l6.66-2.16a2.5 2.5 0 0 1 3.15 1.6l.23.72a.5.5 0 0 1-.32.63m-3.75.16 1.29-2.23-.3.07-1.24.4-1.3 2.27zm2.3-1.98-.02.04-.85 1.48 1.53-.5-.07-.24a1.5 1.5 0 0 0-.6-.78m-3.97.69-1.56.5-1.3 2.27 1.55-.51zM2.92 6.54l.59-.2 1.3-2.26-1 .33a1.5 1.5 0 0 0-.96 1.9z"
]);
const $77e1bce0ac0f7fe7$export$12e58acf88f473aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv16Regular', "16", [
    "M13.22 4.25 7.09 6.24a1 1 0 0 1-.24.08L4.75 7h8.75c.28 0 .5.22.5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 12.5v-5q0-.15.09-.29l-.2-.6A2.5 2.5 0 0 1 3.5 3.46l6.66-2.16a2.5 2.5 0 0 1 3.15 1.6l.23.72a.5.5 0 0 1-.32.63m-3.75.16 1.29-2.23-.3.07-1.24.4-1.3 2.27zm2.3-1.98-.02.04-.85 1.48 1.53-.5-.07-.24a1.5 1.5 0 0 0-.6-.78m-3.97.69-1.56.5-1.3 2.27 1.55-.51zM2.92 6.54l.59-.2 1.3-2.26-1 .33a1.5 1.5 0 0 0-.96 1.9zM3 8v4.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V8z"
]);
const $77e1bce0ac0f7fe7$export$5c2262435a43e569 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv20Filled', "20", [
    "M16.13 5.38 7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V8.57l-.26-.9a2.5 2.5 0 0 1 1.71-3.09L13.1 2.1a2.5 2.5 0 0 1 3.1 1.7l.27.97a.5.5 0 0 1-.34.62M3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 0 0 3.7 7.4zm2-.57 2.11-.61L9.4 4.2l-2.13.61-.02.04zm5.62-1.63 1.44-2.5-2.12.62-.03.05L9.34 6.3zm2.68-2.65q0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 0 0-1.09-1.05"
]);
const $77e1bce0ac0f7fe7$export$98483777b9368bea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv20Regular', "20", [
    "M16.13 5.38 7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V8.57l-.26-.9a2.5 2.5 0 0 1 1.71-3.09L13.1 2.1a2.5 2.5 0 0 1 3.1 1.7l.27.97a.5.5 0 0 1-.34.62M3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 0 0 3.7 7.4zm2-.57 2.11-.61L9.4 4.2l-2.13.61-.02.04zm5.62-1.63 1.44-2.5-2.12.62-.03.05L9.34 6.3zm2.68-2.65q0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 0 0-1.09-1.05M4 9v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V9z"
]);
const $77e1bce0ac0f7fe7$export$e200f3158e6d4b99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv24Filled', "24", [
    "m19.73 3.88.05.15.55 1.93c.1.36-.08.74-.42.89l-.1.03L9.1 9.96h11.16c.38 0 .7.28.74.65v8.6a2.75 2.75 0 0 1-2.57 2.74H5.75a2.75 2.75 0 0 1-2.74-2.57L3 19.2v-8.4L2.48 9c-.4-1.41.36-2.87 1.72-3.35l.16-.06 12.02-3.44c1.4-.4 2.87.36 3.35 1.73M6.27 6.6l-1.5.43c-.61.17-1 .8-.88 1.42l.03.12.34 1.2.3-.08zm4.76-1.37-2.72.78-1.71 3.1 2.72-.79zm4.76-1.36-2.72.78-1.71 3.09 2.71-.78zm1.84-.23-1.52 2.74 2.57-.74-.34-1.2c-.1-.38-.38-.66-.7-.8"
]);
const $77e1bce0ac0f7fe7$export$922b24891072999d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv24Regular', "24", [
    "m19.73 3.92.05.16.55 1.92c.1.36-.08.74-.42.9l-.1.03L9.1 10h11.16c.38 0 .7.29.74.65v8.6A2.75 2.75 0 0 1 18.43 22H5.75a2.75 2.75 0 0 1-2.74-2.58L3 19.25v-8.4l-.52-1.81c-.4-1.4.36-2.87 1.72-3.35l.16-.05 12.02-3.45c1.4-.4 2.87.37 3.35 1.73m-.23 7.58h-15v7.75c0 .6.43 1.1 1 1.23l.12.01.13.01h12.5c.65 0 1.18-.5 1.24-1.12V11.5M6.27 6.65l-1.5.43c-.61.18-1 .8-.88 1.42l.03.12.34 1.2.3-.08zm4.76-1.36-2.72.77-1.71 3.1 2.72-.78zm4.76-1.37-2.72.78-1.71 3.1L14.07 7zm1.84-.23-1.52 2.74 2.57-.74-.34-1.2c-.1-.37-.38-.66-.7-.8"
]);
const $77e1bce0ac0f7fe7$export$affea0695da8171f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward20Filled', "20", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V6H9.5A3.5 3.5 0 0 0 6 9.5V13H4.5A2.5 2.5 0 0 1 2 10.5zM9.5 7A2.5 2.5 0 0 0 7 9.5v6A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7zM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5z"
]);
const $77e1bce0ac0f7fe7$export$d867b308509cfb87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward20Regular', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H6v-1.7l-.7.7h-.8a2 2 0 0 1-.65-.15L6 9.71V9.5q.01-.86.38-1.59l-3.23 3.24A2 2 0 0 1 3 10.5v-.94L9.56 3h.94q.35 0 .65.15L7.9 6.38A3.5 3.5 0 0 1 9.5 6h.2l2.15-2.15q.15.3.15.65v.8l-.7.7H13V4.5A2.5 2.5 0 0 0 10.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h.65L3 5.15zm0 2.06L6.56 3h1.59L3 8.15zM7 9.5A2.5 2.5 0 0 1 9.5 7h6A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5zM9.5 8C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
]);
const $77e1bce0ac0f7fe7$export$bb5219c1a5fdf6c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward24Filled', "24", [
    "M16.5 6.5h-5.75a4.25 4.25 0 0 0-4.25 4.25v5.75H5.25A3.25 3.25 0 0 1 2 13.25v-8C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25zM22 18.75c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25v-8c0-1.8 1.46-3.25 3.25-3.25h8c1.8 0 3.25 1.46 3.25 3.25zm-3.25 1.75c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75h-8C9.78 9 9 9.78 9 10.75v8c0 .97.78 1.75 1.75 1.75z"
]);
const $77e1bce0ac0f7fe7$export$c09a87185cf927c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward24Regular', "24", [
    "M6.5 16.5H5.25A3.25 3.25 0 0 1 2 13.25v-8C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V6.5h-1.65l.15-.15v-1.1q0-.35-.13-.65l-1.9 1.9h-2.12l2.92-2.92a2 2 0 0 0-.52-.08h-1.28L3.5 11.97v1.28q0 .27.08.52l2.92-2.92v2.12l-1.9 1.9q.3.13.65.13h1.1l.15-.15zm3.35-13H7.97L3.5 7.97v1.88zm-4 0h-.6c-.97 0-1.75.78-1.75 1.75v.6zM22 18.75c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25v-8c0-1.8 1.46-3.25 3.25-3.25h8c1.8 0 3.25 1.46 3.25 3.25zm-3.25 1.75c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75h-8C9.78 9 9 9.78 9 10.75v8c0 .97.78 1.75 1.75 1.75z"
]);
const $77e1bce0ac0f7fe7$export$1b7d10a208473450 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward20Filled', "20", [
    "M7 14v1.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5V14zM2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5z"
]);
const $77e1bce0ac0f7fe7$export$f25d83c9ee7298a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward20Regular', "20", [
    "M7 14v1.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5V14zM2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5zM4.5 3C3.67 3 3 3.67 3 4.5v.65L5.15 3zm2.06 0L3 6.56v1.59L8.15 3zM3 10.5q0 .35.15.65l8-8A2 2 0 0 0 10.5 3h-.94L3 9.56zM4.5 12h.8L12 5.3v-.8q0-.35-.15-.65l-8 8q.3.15.65.15m5.2 0h.8c.83 0 1.5-.67 1.5-1.5v-.8zm-1.4 0L12 8.3V6.7L6.7 12z"
]);
const $77e1bce0ac0f7fe7$export$47ffb89d813c639e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward24Filled', "24", [
    "M13.25 16.5c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25h-8A3.25 3.25 0 0 0 2 5.25v8c0 1.8 1.46 3.25 3.25 3.25zm-5.75 1H9v1.25c0 .97.78 1.75 1.75 1.75h8c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75H17.5V7.5h1.25c1.8 0 3.25 1.46 3.25 3.25v8c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25z"
]);
const $77e1bce0ac0f7fe7$export$dbab8d55caeb3f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward24Regular', "24", [
    "M18.75 22c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H17.5V9h1.25c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-8c-.97 0-1.75-.78-1.75-1.75V17.5H7.5v1.25c0 1.8 1.46 3.25 3.25 3.25zm-5.5-5.5c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25h-8A3.25 3.25 0 0 0 2 5.25v8c0 1.8 1.46 3.25 3.25 3.25zM15 13.25c0 .97-.78 1.75-1.75 1.75h-.78L15 12.47zm0-2.78L10.47 15h-2L15 8.47zM6.35 15h-1.1q-.35 0-.65-.13L14.87 4.6q.13.3.13.65v1.1zm-2.77-1.23a2 2 0 0 1-.08-.52v-1.28l8.47-8.47h1.28q.27 0 .52.08zM3.5 9.85V7.97L7.97 3.5h1.88zm0-4v-.6c0-.97.78-1.75 1.75-1.75h.6z"
]);
const $77e1bce0ac0f7fe7$export$836512b89f199503 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack20Filled', "20", [
    "M12 14c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM5 9h1.3C7.8 9 9 7.8 9 6.3V5h3.5A2.5 2.5 0 0 1 15 7.5V11h-1.3a2.7 2.7 0 0 0-2.7 2.7V15H7.5A2.5 2.5 0 0 1 5 12.5zM1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$123e8721148b75b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack20Regular', "20", [
    "M12 14c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM5 9v3.5A2.5 2.5 0 0 0 7.5 15H11v-1H9.7l1.67-1.66q.36-.61.97-.97L14 9.7V11h1V7.5A2.5 2.5 0 0 0 12.5 5H9v1h1.3L8.62 7.66q-.36.61-.97.97L6 10.3V9zm6.7-3h.8q.35 0 .65.15l-7 7A2 2 0 0 1 6 12.5v-.8zm-4.2 8a2 2 0 0 1-.65-.15l7-7q.15.3.15.65v.8L8.3 14zM1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
]);
const $77e1bce0ac0f7fe7$export$8a387c36b1bd3cfa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack24Filled', "24", [
    "M6 11h1.25A3.75 3.75 0 0 0 11 7.25V6h3.75C16.55 6 18 7.46 18 9.25V13h-1.25A3.75 3.75 0 0 0 13 16.75V18H9.25A3.25 3.25 0 0 1 6 14.75zM1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75v3.5A2.75 2.75 0 0 1 7.25 10h-3.5A2.75 2.75 0 0 1 1 7.25zM3.75 2.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25zM14 16.75A2.75 2.75 0 0 1 16.75 14h3.5A2.75 2.75 0 0 1 23 16.75v3.5A2.75 2.75 0 0 1 20.25 23h-3.5A2.75 2.75 0 0 1 14 20.25zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25z"
]);
const $77e1bce0ac0f7fe7$export$55a5a5e6dc13ff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack24Regular', "24", [
    "M14 16.75A2.75 2.75 0 0 1 16.75 14h3.5A2.75 2.75 0 0 1 23 16.75v3.5A2.75 2.75 0 0 1 20.25 23h-3.5A2.75 2.75 0 0 1 14 20.25zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25zM6 11v3.75C6 16.55 7.46 18 9.25 18H13v-1.5h-.32l.37-.37a3.75 3.75 0 0 1 3.08-3.08l.37-.37v.33l.25-.01H18V9.25C18 7.45 16.54 6 14.75 6H11v1.5h.56l-.68.68a3.8 3.8 0 0 1-2.7 2.7l-.68.68V11l-.25.01zm7.68-3.5h1.07q.36 0 .68.14l-7.8 7.79q-.12-.32-.13-.68v-1.07zm-4.43 9q-.26 0-.5-.07l7.68-7.68q.07.24.07.5v1.31l-5.94 5.94zM1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75v3.5A2.75 2.75 0 0 1 7.25 10h-3.5A2.75 2.75 0 0 1 1 7.25zM3.75 2.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25z"
]);
const $77e1bce0ac0f7fe7$export$c7d3c6d8d7a468c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront20Filled', "20", [
    "M1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v1h-.5q-.26 0-.5.04V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1.04Q4 7.24 4 7.5V8H3a2 2 0 0 1-2-2zm11 13v1c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1v.5q0 .26-.04.5H17a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.04q-.24.04-.5.04zM5 7.5A2.5 2.5 0 0 1 7.5 5h5A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 12.5z"
]);
const $77e1bce0ac0f7fe7$export$9fce5288847c1353 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront20Regular', "20", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h1v-.5q0-.26.04-.5H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.04Q7.24 4 7.5 4H8V3a2 2 0 0 0-2-2zm9 16v-1h.5q.26 0 .5-.04V17a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-1.04q.04-.24.04-.5V12h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2M5 7.5A2.5 2.5 0 0 1 7.5 5h5A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 12.5zm2.28-1.48a1.5 1.5 0 0 0-1.26 1.26zM6 10.29 10.3 6H8.7L6 8.7zM11.7 6 6 11.7v.8q0 .35.15.65l7-7A2 2 0 0 0 12.5 6zm-4.2 8h.8L14 8.3v-.8q0-.35-.15-.65l-7 7q.3.15.65.15m2.2 0h1.6l2.7-2.7V9.7zm3.02-.02a1.5 1.5 0 0 0 1.26-1.26z"
]);
const $77e1bce0ac0f7fe7$export$9007870bb3b5f510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront24Filled', "24", [
    "M1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75V5h-.75q-.38 0-.75.07V3.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h1.32Q5 8.87 5 9.25V10H3.75A2.75 2.75 0 0 1 1 7.25zM14 19v1.25A2.75 2.75 0 0 0 16.75 23h3.5A2.75 2.75 0 0 0 23 20.25v-3.5A2.75 2.75 0 0 0 20.25 14H19v.75q0 .38-.07.75h1.32c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-1.32q-.37.07-.75.07zM6 9.25C6 7.45 7.46 6 9.25 6h5.5C16.55 6 18 7.46 18 9.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 6 14.75z"
]);
const $77e1bce0ac0f7fe7$export$617fc168886cb7a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront24Regular', "24", [
    "M1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75V5h-.75q-.38 0-.75.07V3.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h1.32Q5 8.87 5 9.25V10H3.75A2.75 2.75 0 0 1 1 7.25zM14 19v1.25A2.75 2.75 0 0 0 16.75 23h3.5A2.75 2.75 0 0 0 23 20.25v-3.5A2.75 2.75 0 0 0 20.25 14H19v.75q0 .38-.07.75h1.32c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-1.32q-.37.07-.75.07zM9.25 6A3.25 3.25 0 0 0 6 9.25v5.5C6 16.55 7.46 18 9.25 18h5.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C18 7.45 16.54 6 14.75 6zm2.31 1.5L7.5 11.56V9.68L9.68 7.5zM7.5 13.68l6.18-6.18h1.07q.36 0 .68.14l-7.8 7.79q-.12-.32-.13-.68zm1.25 2.75 7.68-7.68q.07.24.07.5v1.31l-5.94 5.94H9.25q-.26 0-.5-.07m5.94.07h-2l3.81-3.82v2.07l-.03-.03z"
]);
const $77e1bce0ac0f7fe7$export$cf2fd1f8c6477636 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler12Filled', "12", [
    "M7.5 1C8.33 1 9 1.67 9 2.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 3 9.5v-7C3 1.67 3.67 1 4.5 1zM4 9h1.5a.5.5 0 0 0 0-1H4zm0-2.5h2.5a.5.5 0 0 0 0-1H4zM4 4h1.5a.5.5 0 0 0 0-1H4z"
]);
const $77e1bce0ac0f7fe7$export$e05eaa975fbb9df4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler12Regular', "12", [
    "M7.5 1C8.33 1 9 1.67 9 2.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 3 9.5v-7C3 1.67 3.67 1 4.5 1zm-3 1a.5.5 0 0 0-.5.5V3h1.5a.5.5 0 0 1 0 1H4v1.5h2.5a.5.5 0 0 1 0 1H4V8h1.5a.5.5 0 0 1 0 1H4v.5c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$648b29bb39136c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler16Filled', "16", [
    "M10.5 1c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5v-11C4 1.67 4.67 1 5.5 1zM5 12.5h3.5a.5.5 0 0 0 0-1H5zM5 10h2.5a.5.5 0 0 0 0-1H5zm0-2.5h3.5a.5.5 0 0 0 0-1H5zM5 5h2.5a.5.5 0 0 0 0-1H5z"
]);
const $77e1bce0ac0f7fe7$export$b12808b208d8fe30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler16Regular', "16", [
    "M10.5 1c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5v-11C4 1.67 4.67 1 5.5 1zm-5 1a.5.5 0 0 0-.5.5V4h2.5a.5.5 0 0 1 0 1H5v1.5h3.5a.5.5 0 0 1 0 1H5V9h2.5a.5.5 0 0 1 0 1H5v1.5h3.5a.5.5 0 0 1 0 1H5v1c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$913c4f785173202a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler20Filled', "20", [
    "M12.5 2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 6 16.5v-13C6 2.67 6.67 2 7.5 2zM7 15.5h2.5a.5.5 0 0 0 0-1H7zM7 13h3.5a.5.5 0 0 0 0-1H7zm0-2.5h2.5a.5.5 0 0 0 0-1H7zM7 8h3.5a.5.5 0 0 0 0-1H7zm0-2.5h2.5a.5.5 0 0 0 0-1H7z"
]);
const $77e1bce0ac0f7fe7$export$8ff0c77d1508ece8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler20Regular', "20", [
    "M12.5 2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 6 16.5v-13C6 2.67 6.67 2 7.5 2zm-5 1a.5.5 0 0 0-.5.5v1h2.5a.5.5 0 0 1 0 1H7V7h3.5a.5.5 0 0 1 0 1H7v1.5h2.5a.5.5 0 0 1 0 1H7V12h3.5a.5.5 0 0 1 0 1H7v1.5h2.5a.5.5 0 0 1 0 1H7v1c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$4b1ee5590a3e286f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler24Filled', "24", [
    "M7 4.25C7 3.01 8 2 9.25 2h5.5C15.99 2 17 3 17 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.5A2.26 2.26 0 0 1 7 19.75zM8.5 5v1.5h1.75a.75.75 0 0 0 0-1.5zm0 3v1.5h3.75a.75.75 0 0 0 0-1.5zm0 3.25v1.5h1.75a.75.75 0 0 0 0-1.5zm0 3.25V16h3.75a.75.75 0 0 0 0-1.5zm0 3V19h1.75a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$48e29013c50dbb9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler24Regular', "24", [
    "M9.25 2C8.01 2 7 3 7 4.25v15.5C7 20.99 8 22 9.25 22h5.5c1.24 0 2.25-1 2.25-2.25V4.25C17 3.01 16 2 14.75 2zM8.5 19h1.75a.75.75 0 0 0 0-1.5H8.5V16h3.75a.75.75 0 0 0 0-1.5H8.5v-1.75h1.75a.75.75 0 0 0 0-1.5H8.5V9.5h3.75a.75.75 0 0 0 0-1.5H8.5V6.5h1.75a.75.75 0 0 0 0-1.5H8.5v-.75c0-.41.34-.75.75-.75h5.5c.41 0 .75.34.75.75v15.5c0 .41-.34.75-.75.75h-5.5a.75.75 0 0 1-.75-.75z"
]);
const $77e1bce0ac0f7fe7$export$422b4710715dadb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler28Filled', "28", [
    "M9 2.63Q9.74 2 10.75 2h6.5A2.75 2.75 0 0 1 20 4.75v18.5A2.75 2.75 0 0 1 17.25 26h-6.5A2.75 2.75 0 0 1 8 23.25V4.75a2.7 2.7 0 0 1 1-2.12m.5 3.12v1.5h2.75a.75.75 0 0 0 0-1.5zm0 3.75V11h4.75a.75.75 0 0 0 0-1.5zm0 3.75v1.5h2.75a.75.75 0 0 0 0-1.5zm0 3.75v1.5h4.75a.75.75 0 0 0 0-1.5zm0 3.75v1.5h2.75a.75.75 0 0 0 0-1.5z"
]);
const $77e1bce0ac0f7fe7$export$d25a944258119fcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler28Regular', "28", [
    "M10.75 2A2.75 2.75 0 0 0 8 4.75v18.5A2.75 2.75 0 0 0 10.75 26h6.5A2.75 2.75 0 0 0 20 23.25V4.75A2.75 2.75 0 0 0 17.25 2zM9.5 14.75h2.75a.75.75 0 0 0 0-1.5H9.5V11h4.75a.75.75 0 0 0 0-1.5H9.5V7.25h2.75a.75.75 0 0 0 0-1.5H9.5v-1c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v18.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-1h2.75a.75.75 0 0 0 0-1.5H9.5V18.5h4.75a.75.75 0 0 0 0-1.5H9.5z"
]);
const $77e1bce0ac0f7fe7$export$30580676c98dd434 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler32Filled', "32", [
    "M9 5.5A3.5 3.5 0 0 1 12.5 2h7A3.5 3.5 0 0 1 23 5.5v21a3.5 3.5 0 0 1-3.5 3.5h-7q-.36 0-.7-.07A3.5 3.5 0 0 1 9 26.5zm2 .5v2h3a1 1 0 1 0 0-2zm0 4.5v2h5a1 1 0 1 0 0-2zm0 4.5v2h3a1 1 0 1 0 0-2zm0 4.5v2h5a1 1 0 1 0 0-2zm0 4.5v2h3a1 1 0 1 0 0-2z"
]);
const $77e1bce0ac0f7fe7$export$298bfec57ff60727 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler32Regular', "32", [
    "M12.5 2A3.5 3.5 0 0 0 9 5.5v21a3.5 3.5 0 0 0 3.5 3.5h7a3.5 3.5 0 0 0 3.5-3.5v-21A3.5 3.5 0 0 0 19.5 2zM11 8h3a1 1 0 1 0 0-2h-3v-.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v21c0 .83-.67 1.5-1.5 1.5h-7a1.5 1.5 0 0 1-1.5-1.5V26h3a1 1 0 1 0 0-2h-3v-2.5h5a1 1 0 1 0 0-2h-5V17h3a1 1 0 1 0 0-2h-3v-2.5h5a1 1 0 1 0 0-2h-5z"
]);
const $77e1bce0ac0f7fe7$export$69ea3ab0810bdd6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler48Filled', "48", [
    "M14.02 7.82A4.25 4.25 0 0 1 18.25 4h11.5C32.1 4 34 5.9 34 8.25v31.5C34 42.1 32.1 44 29.75 44h-11.5A4.25 4.25 0 0 1 14 39.75V8.25q0-.23.02-.43m2.48 2.43v2.5h4.25a1.25 1.25 0 1 0 0-2.5zm0 6.25V19h8.25a1.25 1.25 0 1 0 0-2.5zm0 6.25v2.5h4.25a1.25 1.25 0 1 0 0-2.5zm0 6.25v2.5h8.25a1.25 1.25 0 1 0 0-2.5zm0 6.25v2.5h4.25a1.25 1.25 0 1 0 0-2.5z"
]);
const $77e1bce0ac0f7fe7$export$c64cf47e612846df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler48Regular', "48", [
    "M18.25 4A4.25 4.25 0 0 0 14 8.25v31.5C14 42.1 15.9 44 18.25 44h11.5C32.1 44 34 42.1 34 39.75V8.25C34 5.9 32.1 4 29.75 4zm-1.75 8.75h4.25a1.25 1.25 0 1 0 0-2.5H16.5v-2c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v31.5c0 .97-.78 1.75-1.75 1.75h-11.5c-.97 0-1.75-.78-1.75-1.75v-2h4.25a1.25 1.25 0 1 0 0-2.5H16.5V31.5h8.25a1.25 1.25 0 1 0 0-2.5H16.5v-3.75h4.25a1.25 1.25 0 1 0 0-2.5H16.5V19h8.25a1.25 1.25 0 1 0 0-2.5H16.5z"
]);
const $77e1bce0ac0f7fe7$export$f13a13858791bb90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent12Filled', "12", [
    "M6.43 1.46a.5.5 0 0 0-.77 0c-.72.87-2.18 1.92-3.01 2.39a.5.5 0 0 0-.25.37L1.74 9H1.5a.5.5 0 1 0 0 1h9a.5.5 0 1 0 0-1h-.14L9.7 4.22a.5.5 0 0 0-.25-.37 13 13 0 0 1-3.02-2.4M4.83 9c.41-.63.82-1.42 1.2-2.5.36 1 .75 1.77 1.21 2.5z"
]);
const $77e1bce0ac0f7fe7$export$8647d4364890732f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent12Regular', "12", [
    "M6.43 1.46a.5.5 0 0 0-.77 0c-.72.87-2.18 1.92-3.01 2.39a.5.5 0 0 0-.25.37L1.74 9H1.5a.5.5 0 1 0 0 1h9a.5.5 0 1 0 0-1h-.14L9.7 4.22a.5.5 0 0 0-.25-.37 13 13 0 0 1-3.02-2.4M8.44 9c-.8-1.15-1.38-2.3-1.92-4.36a.5.5 0 0 0-.97 0C4.95 6.94 4.26 8.12 3.62 9h-.87l.6-4.4c.78-.47 1.9-1.28 2.7-2.08.8.8 1.92 1.61 2.7 2.08l.6 4.4zm-1.2 0h-2.4c.4-.63.81-1.42 1.2-2.5.35 1 .74 1.77 1.2 2.5"
]);
const $77e1bce0ac0f7fe7$export$63068f4c226c959f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent16Filled', "16", [
    "M8.4 1.35a.5.5 0 0 0-.76 0 18 18 0 0 1-4.3 3.4.5.5 0 0 0-.24.37L2.15 12h-.66a.5.5 0 0 0 0 1H14.5a.5.5 0 0 0 0-1h-.6l-.96-6.88a.5.5 0 0 0-.25-.37 18 18 0 0 1-4.28-3.4M5.95 12A17 17 0 0 0 8 7.66c.6 1.81 1.25 3.1 2.06 4.34z"
]);
const $77e1bce0ac0f7fe7$export$9ac15ed21e00dc5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent16Regular', "16", [
    "M8.4 1.35a.5.5 0 0 0-.76 0 18 18 0 0 1-4.3 3.4.5.5 0 0 0-.24.37L2.15 12h-.66a.5.5 0 0 0 0 1H14.5a.5.5 0 0 0 0-1h-.6l-.96-6.88a.5.5 0 0 0-.25-.37 18 18 0 0 1-4.28-3.4M11.28 12A17 17 0 0 1 8.5 5.73a.5.5 0 0 0-.97 0c-.86 3.34-1.87 5-2.8 6.27H3.16l.9-6.5c1.12-.66 2.84-1.9 3.96-3.08A21 21 0 0 0 12 5.5l.9 6.5zm-1.2 0H5.93A17 17 0 0 0 8 7.66c.6 1.81 1.25 3.1 2.06 4.34"
]);
const $77e1bce0ac0f7fe7$export$33a82671f56cf400 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent20Filled', "20", [
    "M10.4 2.82a.5.5 0 0 0-.77 0 21 21 0 0 1-4.91 3.9.5.5 0 0 0-.25.36L3.37 15H2.5a.5.5 0 0 0 0 1h3.94l.1.01h6.9l.1-.01h3.96a.5.5 0 0 0 0-1h-.84l-1.1-7.92a.5.5 0 0 0-.24-.36 21 21 0 0 1-4.92-3.9M7.51 15c.84-1.22 1.7-2.79 2.49-5.26.7 2.23 1.5 3.78 2.49 5.26z"
]);
const $77e1bce0ac0f7fe7$export$32e39c925e98ca29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent20Regular', "20", [
    "M10.4 2.82a.5.5 0 0 0-.77 0 21 21 0 0 1-4.91 3.9.5.5 0 0 0-.25.36L3.37 15H2.5a.5.5 0 0 0 0 1h3.94l.1.01h6.9l.1-.01h3.96a.5.5 0 0 0 0-1h-.84l-1.1-7.92a.5.5 0 0 0-.24-.36 21 21 0 0 1-4.92-3.9M13.7 15a20 20 0 0 1-3.22-7.2.5.5 0 0 0-.97 0c-.98 3.84-2.14 5.75-3.22 7.2H4.4l1.03-7.54c1.3-.76 3.3-2.2 4.6-3.57a23 23 0 0 0 4.6 3.57L15.64 15zm-1.22 0H7.52c.84-1.22 1.7-2.78 2.48-5.25.7 2.23 1.49 3.77 2.48 5.25"
]);
const $77e1bce0ac0f7fe7$export$bad77674c7b19710 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent24Filled', "24", [
    "M12.26 2.2a.75.75 0 0 0-1.04.02l-1.7 1.7a20 20 0 0 1-3.84 3c-.4.23-.66.63-.72 1.09L3.6 17.5h-.85a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-.85l-1.35-9.45a1.6 1.6 0 0 0-.8-1.15 21 21 0 0 1-4.23-3.06zm1.84 12.92a18 18 0 0 0 1.65 2.38H8.28c.54-.66 1.18-1.52 1.64-2.4a43 43 0 0 0 2.06-5.02l.19.53a32 32 0 0 0 1.93 4.5"
]);
const $77e1bce0ac0f7fe7$export$8d9a389c2e1223b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent24Regular', "24", [
    "M11.22 2.22a.75.75 0 0 1 1.04-.02l1.76 1.64q1.93 1.8 4.23 3.06c.43.23.73.66.8 1.15l1.35 9.45h.85a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.85L4.96 8c.06-.45.33-.85.72-1.08q2.1-1.27 3.84-3zM5.12 17.5h2.13a23 23 0 0 0 3.5-7.16l.53-1.8a.75.75 0 0 1 1.44 0l.52 1.8c.75 2.57 1.94 5 3.51 7.16h2.14l-1.33-9.24-.03-.05Q15.06 6.85 13 4.94l-1.22-1.15-1.19 1.19a21 21 0 0 1-4.14 3.24zm9.8 0A25 25 0 0 1 12 11.4a25 25 0 0 1-2.93 6.1z"
]);
const $77e1bce0ac0f7fe7$export$608c071fc8ba275 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent28Filled', "28", [
    "M14.6 3.21a.75.75 0 0 0-1.15 0c-1.8 2.15-5.34 4.71-7.37 5.85a.8.8 0 0 0-.38.55L4.06 21.5H2.75a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5h-1.26L22.35 9.61a.8.8 0 0 0-.38-.55c-2.03-1.14-5.57-3.7-7.37-5.85M10.27 21.5A28 28 0 0 0 14 13.6a29 29 0 0 0 3.73 7.9z"
]);
const $77e1bce0ac0f7fe7$export$62433f5c0765a6bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent28Regular', "28", [
    "M14.6 3.21a.75.75 0 0 0-1.15 0c-1.8 2.15-5.34 4.71-7.37 5.85a.8.8 0 0 0-.38.55L4.06 21.5H2.75a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5h-1.26L22.35 9.61a.8.8 0 0 0-.38-.55c-2.03-1.14-5.57-3.7-7.37-5.85m4.94 18.27c-2.04-2.87-3.48-5.67-4.82-10.8a.75.75 0 0 0-1.45.01c-1.47 5.75-3.22 8.62-4.83 10.8H5.58l1.55-11.3a35 35 0 0 0 6.9-5.37 35 35 0 0 0 6.89 5.36l1.55 11.3zm-1.82 0h-7.44A28 28 0 0 0 14 13.61a29 29 0 0 0 3.72 7.87"
]);
const $77e1bce0ac0f7fe7$export$a6e5c617789c98d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent48Filled', "48", [
    "M25 6.02a1.25 1.25 0 0 0-1.92 0c-2.99 3.59-8.9 7.85-12.29 9.75-.34.19-.57.53-.63.92L7.43 36.5H5.25a1.25 1.25 0 0 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5h-2.1l-2.73-19.81a1.3 1.3 0 0 0-.63-.92C33.9 13.87 28 9.6 25 6.02M17.8 36.5c2.1-3.05 4.26-6.97 6.21-13.15a49 49 0 0 0 6.21 13.15z"
]);
const $77e1bce0ac0f7fe7$export$9c0e58d5b39fde64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent48Regular', "48", [
    "M25 6.02a1.25 1.25 0 0 0-1.92 0c-2.99 3.59-8.9 7.85-12.29 9.75-.34.19-.57.53-.63.92l-2.73 19.8H5.25a1.25 1.25 0 0 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5h-2.1l-2.73-19.8a1.3 1.3 0 0 0-.63-.92C33.9 13.87 28 9.6 25 6.02m8.23 30.45c-3.4-4.79-5.8-9.46-8.02-17.99a1.25 1.25 0 0 0-2.43 0c-2.45 9.6-5.37 14.37-8.05 18H9.96l2.6-18.84c3.25-1.9 8.26-5.52 11.48-8.94 3.22 3.42 8.23 7.03 11.49 8.94l2.6 18.83zm-3.03 0H17.8c2.1-3.04 4.25-6.95 6.2-13.12a49 49 0 0 0 6.2 13.12"
]);
const $77e1bce0ac0f7fe7$export$3d2e8c11a3b24c40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather20Filled', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zm-5 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M10 8.5a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1zm0 7.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7m-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$c2ade1840e96a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather20Regular', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zm-.5 6a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1zm0-3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M6.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m3.5 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7m-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7"
]);
const $77e1bce0ac0f7fe7$export$95baa5b74ec920a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather24Filled', "24", [
    "M12 18.53a1 1 0 0 1 .99.89v1.57a1 1 0 0 1-1.99.11v-1.57a1 1 0 0 1 1-1m6.03-1.93 1.03 1.03a1 1 0 0 1-1.41 1.41l-1.03-1.03a1 1 0 0 1 1.41-1.41m-10.66 0a1 1 0 0 1 0 1.41l-1.03 1.03a1 1 0 0 1-1.41-1.41l1.03-1.03a1 1 0 0 1 1.41 0m4.64-10.13a5.52 5.52 0 1 1 0 11.05 5.52 5.52 0 0 1 0-11.05M11.25 9c-.38 0-.7.28-.74.65l-.01.1v3.1c.05.34.32.6.65.65h2.2c.33-.05.6-.31.64-.64l.01-.1v-.1a.75.75 0 0 0-.65-.65H12V9.64a.75.75 0 0 0-.75-.65m9.73 2.02a1 1 0 0 1 .11 2h-1.57a1 1 0 0 1-.11-2h1.57m-16.5-.03a1 1 0 0 1 .12 2H3.02a1 1 0 0 1-.11-2h1.57m1.77-6.12.1.09 1.02 1.03a1 1 0 0 1-1.32 1.5l-.09-.09-1.03-1.03a1 1 0 0 1 1.32-1.5m12.81.09a1 1 0 0 1 .09 1.32l-.09.1-1.03 1.02a1 1 0 0 1-1.5-1.32l.09-.1 1.03-1.02a1 1 0 0 1 1.41 0M12 2a1 1 0 0 1 1 .89v1.57a1 1 0 0 1-2 .12V3a1 1 0 0 1 1-1"
]);
const $77e1bce0ac0f7fe7$export$e8c27ba200d3b489 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather24Regular', "24", [
    "M12 19.01c.38 0 .69.28.74.65v1.6a.75.75 0 0 1-1.49.1v-1.6c0-.41.33-.75.75-.75m6.02-2.07L19.08 18a.75.75 0 0 1-1.06 1.06L16.96 18a.75.75 0 1 1 1.06-1.06m-10.99 0c.3.29.3.77 0 1.06l-1.06 1.06A.75.75 0 1 1 4.91 18l1.06-1.06c.3-.3.77-.3 1.06 0M12 6.47a5.53 5.53 0 1 1 0 11.05 5.53 5.53 0 0 1 0-11.05m0 1.5a4.03 4.03 0 1 0 0 8.05 4.03 4.03 0 0 0 0-8.05M11.25 9c.38 0 .7.28.74.65l.01.1V12h1.25c.38 0 .7.29.74.65v.1c0 .38-.27.7-.64.75h-2.1a.75.75 0 0 1-.74-.64l-.01-.1V9.74c0-.41.34-.75.75-.75m10 2.27a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6m-17-.03a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6m1.64-6.37.08.07L7.03 6a.75.75 0 0 1-.97 1.13l-.09-.07L4.91 6a.75.75 0 0 1 .98-1.13m13.19.07c.26.27.29.68.07.98l-.07.08-1.06 1.06a.75.75 0 0 1-1.14-.97l.08-.09 1.06-1.06c.3-.3.77-.3 1.06 0M12 2c.38 0 .7.28.74.65l.01.1v1.5a.75.75 0 0 1-1.5.1v-1.6c0-.41.34-.75.75-.75"
]);
const $77e1bce0ac0f7fe7$export$b177467d4d89bd3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker20Filled', "20", [
    "M10.47 2.17a.75.75 0 0 0-.94 0L6.78 4.42a.75.75 0 0 0 .94 1.16L10 3.72l2.28 1.86a.75.75 0 1 0 .94-1.16zm2.75 13.41-2.75 2.25a.75.75 0 0 1-.94 0l-2.75-2.25a.75.75 0 0 1 .94-1.16L10 16.28l2.28-1.86a.75.75 0 1 1 .94 1.16m-2.47-6.83a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8M6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8M2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0z"
]);
const $77e1bce0ac0f7fe7$export$afdc984d93b85f2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker20Regular', "20", [
    "M10.32 2.12a.5.5 0 0 0-.64 0l-3 2.5a.5.5 0 1 0 .64.76L10 3.15l2.68 2.23a.5.5 0 0 0 .64-.76zm3 13.26-3 2.5a.5.5 0 0 1-.64 0l-3-2.5a.5.5 0 1 1 .64-.76L10 16.85l2.68-2.23a.5.5 0 0 1 .64.76m-2.57-6.63a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8M6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8M2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0z"
]);
const $77e1bce0ac0f7fe7$export$3aca18c91f2a4e19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker24Filled', "24", [
    "M12.62 2.22a1 1 0 0 0-1.24 0l-3.75 3a1 1 0 1 0 1.24 1.56L12 4.28l3.13 2.5a1 1 0 0 0 1.24-1.56zM2.75 9C1.51 9 .5 10 .5 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C5 10.01 4 9 2.75 9M2 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zM8.25 9C7.01 9 6 10 6 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5c0-1.24-1-2.25-2.25-2.25m-.75 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zm6.5 0a2.25 2.25 0 0 1 4.5 0v1.5a2.25 2.25 0 0 1-4.5 0zm2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m5.5-1.5c-1.24 0-2.25 1-2.25 2.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C24 10.01 23 9 21.75 9M21 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zm-8-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.38 7.53 4-3.25a1 1 0 0 0-1.26-1.56L12 19.96l-3.37-2.74a1 1 0 1 0-1.26 1.56l4 3.25c.37.3.9.3 1.26 0"
]);
const $77e1bce0ac0f7fe7$export$3d790f07a2fb5096 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker24Regular', "24", [
    "M12.47 2.17a.75.75 0 0 0-.94 0l-4 3.25a.75.75 0 1 0 .94 1.16L12 3.72l3.53 2.86a.75.75 0 1 0 .94-1.16zM2.75 9C1.51 9 .5 10 .5 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C5 10.01 4 9 2.75 9M2 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zM8.25 9C7.01 9 6 10 6 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5c0-1.24-1-2.25-2.25-2.25m-.75 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zm6.5 0a2.25 2.25 0 0 1 4.5 0v1.5a2.25 2.25 0 0 1-4.5 0zm2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m5.5-1.5c-1.24 0-2.25 1-2.25 2.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C24 10.01 23 9 21.75 9M21 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0zm-8-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.22 7.33 4-3.25a.75.75 0 1 0-.94-1.16L12 20.28l-3.53-2.86a.75.75 0 0 0-.94 1.16l4 3.25c.27.23.67.23.94 0"
]);
const $77e1bce0ac0f7fe7$export$23bc9cd26718b4d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline20Filled', "20", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zm0 8c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM17 12.44a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88M16.5 3c.28 0 .5.22.5.5v4.04a3 3 0 0 0-1 0V3.5c0-.28.22-.5.5-.5m0 10.5q-.26 0-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04q-.24.04-.5.04"
]);
const $77e1bce0ac0f7fe7$export$513f26ac8161419f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline20Regular', "20", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM3 4.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zm.5 6.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM3 12.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zm14-.06a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88M16.5 3c.28 0 .5.22.5.5v4.04a3 3 0 0 0-1 0V3.5c0-.28.22-.5.5-.5m0 10.5q-.26 0-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04q-.24.04-.5.04"
]);
const $77e1bce0ac0f7fe7$export$6d52c7bf18408bbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline24Filled', "24", [
    "M15.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 21 2 20.22 2 19.25v-4.5c0-.97.78-1.75 1.75-1.75zM21 14.9v5.35a.75.75 0 0 1-1.5.1v-5.44a3 3 0 0 0 1.5-.01m-.75-4.8a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8m-5-7.1C16.2 3 17 3.78 17 4.75v4.5c0 .97-.79 1.75-1.75 1.75H3.75C2.78 11 2 10.22 2 9.25v-4.5c0-.92.7-1.67 1.6-1.75h11.65m5 0c.38 0 .7.28.74.65l.01.1V9.1a3 3 0 0 0-1.5-.01V3.75c0-.41.34-.75.75-.75"
]);
const $77e1bce0ac0f7fe7$export$4d7af1a78f86e86c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline24Regular', "24", [
    "M15.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 21 2 20.22 2 19.25v-4.5c0-.97.78-1.75 1.75-1.75zM21 14.9v5.35a.75.75 0 0 1-1.5.1v-5.44a3 3 0 0 0 1.5-.01m-5.75-.4H3.75a.25.25 0 0 0-.25.25v4.5c0 .14.11.25.25.25h11.5q.23-.02.25-.25v-4.5a.25.25 0 0 0-.25-.25m5-4.4a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8m-5-7.1C16.2 3 17 3.78 17 4.75v4.5c0 .97-.79 1.75-1.75 1.75H3.75C2.78 11 2 10.22 2 9.25v-4.5c0-.92.7-1.67 1.6-1.74L3.75 3zm0 1.5H3.69a.25.25 0 0 0-.2.25v4.5c0 .14.12.25.26.25h11.5c.13 0 .25-.11.25-.25v-4.5a.25.25 0 0 0-.25-.25m5-1.5c.38 0 .7.28.74.65l.01.1V9.1a3 3 0 0 0-1.5-.01V3.75c0-.41.34-.75.75-.75"
]);
const $77e1bce0ac0f7fe7$export$a61a1f1db8536fcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1020Filled', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zM16.43 10c-.98.02-1.86.44-2.48 1.1a1.5 1.5 0 0 0-1.92-1.02l-1.5.5A1.5 1.5 0 0 0 11 13.5v4.34A7.03 7.03 0 0 1 2.5 11a7 7 0 0 1 13.93-1M9 10.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0zm5 3a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5m-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0z"
]);
const $77e1bce0ac0f7fe7$export$2f75e605af3d2d8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1020Regular', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71M9 6.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zM9.5 18q.77 0 1.5-.16V16.8a6.01 6.01 0 1 1 4.44-6.65q.47-.15.99-.16a7 7 0 1 0-6.93 8m4.5-4.5a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5m-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0z"
]);
const $77e1bce0ac0f7fe7$export$653f0d7a2154b17e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1024Filled', "24", [
    "M12 5a8.5 8.5 0 0 1 8.38 7.05 4.3 4.3 0 0 0-4.38 2.2v-.5a1.75 1.75 0 0 0-2.3-1.66l-.95.32V8.65a.75.75 0 0 0-1.5 0v4.69a1.75 1.75 0 0 0 1.25 2.64v6q-.25.02-.5.02a8.5 8.5 0 0 1 0-17m7.17.12.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2M14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6m.44 10.64q.3.23.31.61v8.5a.75.75 0 0 1-1.5 0v-7.46l-.51.17a.75.75 0 0 1-.48-1.42l1.5-.5a.8.8 0 0 1 .68.1m1.81 3.11a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5a1.75 1.75 0 1 0 3.5 0v-3.5c0-.97-.78-1.75-1.75-1.75"
]);
const $77e1bce0ac0f7fe7$export$825e0544bfd2e04d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1024Regular', "24", [
    "M12 5a8.5 8.5 0 0 1 8.38 7.05 4 4 0 0 0-1.52.04 7 7 0 1 0-6.36 8.4v1.5L12 22a8.5 8.5 0 0 1 0-17m.75 7.4V8.66a.75.75 0 0 0-1.5.1v4.59q.32-.53.95-.75zm6.4-7.29.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22m-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6m.44 10.64q.3.23.31.61v8.5a.75.75 0 0 1-1.5 0v-7.46l-.51.17a.75.75 0 0 1-.48-1.42l1.5-.5a.8.8 0 0 1 .68.1m1.81 3.11a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5a1.75 1.75 0 1 0 3.5 0v-3.5c0-.97-.78-1.75-1.75-1.75"
]);
const $77e1bce0ac0f7fe7$export$39132daebfdbc93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer12Filled', "12", [
    "M3.5 0a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM1 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4 1a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm5.85-3.65a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l1 1c.2.2.2.5 0 .7"
]);
const $77e1bce0ac0f7fe7$export$2e1a65ae9d9f598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer12Regular', "12", [
    "M3 .5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 3 .5m2 7a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zM5.5 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M2 6.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m8.15-2.65a.5.5 0 1 0 .7-.7l-1-1a.5.5 0 1 0-.7.7z"
]);
const $77e1bce0ac0f7fe7$export$c0506077fe9c4312 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer16Filled', "16", [
    "M5 1.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M7.5 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-10c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5m4.95-2.36a.5.5 0 1 0-.7.7l1.4 1.41a.5.5 0 1 0 .7-.7z"
]);
const $77e1bce0ac0f7fe7$export$cf4ce333c9360b01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer16Regular', "16", [
    "M5 1.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M7.5 5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m6 4a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-1 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0m-.05-6.36a.5.5 0 1 0-.7.7l1.4 1.41a.5.5 0 1 0 .7-.7z"
]);
const $77e1bce0ac0f7fe7$export$98be67c3607882ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer20Filled', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71M16.5 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0M9 6.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0"
]);
const $77e1bce0ac0f7fe7$export$bce2495c7f101218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer20Regular', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m0 12a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-1a6 6 0 1 1 0-12 6 6 0 0 1 0 12"
]);
const $77e1bce0ac0f7fe7$export$3c0aedf3fdb1569c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer24Filled', "24", [
    "M12 5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17m0 3c-.38 0-.7.28-.74.65l-.01.1v4.6a.75.75 0 0 0 1.5 0v-4.7A.75.75 0 0 0 12 8m7.17-2.88.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2M14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6"
]);
const $77e1bce0ac0f7fe7$export$9fde69334c1dc173 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer24Regular', "24", [
    "M12 5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17m0 1.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14M12 8c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 0 1-1.5.1v-4.6c0-.41.34-.75.75-.75m7.15-2.89.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22m-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6"
]);
const $77e1bce0ac0f7fe7$export$581098b84d1dd97c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer28Filled', "28", [
    "M10.75 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM4 16a10 10 0 1 1 20 0 10 10 0 0 1-20 0m10.75-5.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zm6.47-4.03c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06"
]);
const $77e1bce0ac0f7fe7$export$f959312d8e2f1a93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer28Regular', "28", [
    "M10.75 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM14 9.5c.41 0 .75.34.75.75v6a.75.75 0 0 1-1.5 0v-6c0-.41.34-.75.75-.75M14 6a10 10 0 1 0 0 20 10 10 0 0 0 0-20M5.5 16a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0m16.78-9.78a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06z"
]);
const $77e1bce0ac0f7fe7$export$c68f34af0dd8e210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer220Filled', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zm1.29 6.2A3.5 3.5 0 0 0 12 13.5c0 .7.47 1.27 1.1 1.45A3.5 3.5 0 0 0 12 17.5v.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87M9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm6.5-.5a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5"
]);
const $77e1bce0ac0f7fe7$export$5664ae125270da4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer220Regular', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71M9 6.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0zm3 11.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87 4 4 0 0 0-1.03-.13 6 6 0 1 0-3.23 6.37A4 4 0 0 0 12 17.5zM15.5 11a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5"
]);
const $77e1bce0ac0f7fe7$export$faf8e07577a1a9d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer224Filled', "24", [
    "M20.4 12.16a8.5 8.5 0 1 0-5.4 9.3v-.21c0-1.31.6-2.48 1.53-3.26A1.75 1.75 0 0 1 15 16.25a4.25 4.25 0 0 1 5.4-4.1m-9.14-3.51a.75.75 0 0 1 1.48 0l.01.1v4.6a.75.75 0 0 1-1.5 0v-4.7m8-3.47-.09-.06a.75.75 0 0 0-.9 1.2l1.15 1 .08.06a.75.75 0 0 0 .9-1.2zM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75M19.25 13A3.25 3.25 0 0 0 16 16.25a.75.75 0 0 0 1.5 0A1.75 1.75 0 1 1 19.25 18 3.25 3.25 0 0 0 16 21.25v1c0 .41.34.75.75.75h5a.75.75 0 0 0 0-1.5H17.5v-.25c0-.97.78-1.75 1.75-1.75a3.25 3.25 0 0 0 0-6.5"
]);
const $77e1bce0ac0f7fe7$export$fc44c5f5c7c862b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer224Regular', "24", [
    "M20.4 12.16a8.5 8.5 0 1 0-5.4 9.3v-.21q0-.84.3-1.58-1.48.81-3.3.83a7 7 0 1 1 6.84-8.48 4 4 0 0 1 1.55.14m-7.66-3.51a.75.75 0 0 0-1.49.1v4.6a.75.75 0 0 0 1.5-.1v-4.6m6.49-3.48-.08-.06a.75.75 0 0 0-.88 1.22l1.16.96.08.06a.75.75 0 0 0 .88-1.21zM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75M19.25 13A3.25 3.25 0 0 0 16 16.25a.75.75 0 0 0 1.5 0A1.75 1.75 0 1 1 19.25 18 3.25 3.25 0 0 0 16 21.25v1c0 .41.34.75.75.75h5a.75.75 0 0 0 0-1.5H17.5v-.25c0-.97.78-1.75 1.75-1.75a3.25 3.25 0 0 0 0-6.5"
]);
const $77e1bce0ac0f7fe7$export$bdc11fa5da12b7cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer32Filled', "32", [
    "M13 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm15 16a12 12 0 1 1-24 0 12 12 0 0 1 24 0m-11-6a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0zm8.3-5.7a1 1 0 0 1 1.4 0l2 2a1 1 0 1 1-1.4 1.4l-2-2a1 1 0 0 1 0-1.4"
]);
const $77e1bce0ac0f7fe7$export$de66b77ebd5a18c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer32Regular', "32", [
    "M13 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm3 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m12 7a12 12 0 1 1-24 0 12 12 0 0 1 24 0m-2 0a10 10 0 1 0-20 0 10 10 0 0 0 20 0m.7-11.7a1 1 0 1 0-1.4 1.4l2 2a1 1 0 1 0 1.4-1.4z"
]);
const $77e1bce0ac0f7fe7$export$b70352dde68b8832 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer320Filled', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zm1.29 6.2a4 4 0 0 0-.95-.13 4.5 4.5 0 0 0-2.74.97l-.25.2v.01a1.5 1.5 0 0 0 1.63 2.48 2.5 2.5 0 0 0-.04 2.62l-.04.03a1.5 1.5 0 0 0-2.05 1.23q-1.18.45-2.51.46a7 7 0 1 1 6.95-7.88M9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm4.84 1.21.03-.02a3 3 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25q0 .43-.51.84c-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41q.51.4.51.84c0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3 3 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a4 4 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4 4 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73"
]);
const $77e1bce0ac0f7fe7$export$9bf787113fc2a8c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer320Regular', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7zM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m0 12q1.33 0 2.5-.46l.01-.07a1.5 1.5 0 0 1 .45-1.25Q11.13 17 9.5 17a6 6 0 1 1 5.92-7 4 4 0 0 1 1.03.12A7 7 0 1 0 9.5 18m4.34-5.29.03-.02a3 3 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25q0 .43-.51.84c-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41q.51.4.51.84c0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3 3 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a4 4 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4 4 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73"
]);
const $77e1bce0ac0f7fe7$export$8d153714f54d5e8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer324Filled', "24", [
    "M15.45 15.92c.53.6 1.37.74 2.06.4a3 3 0 0 0 0 3.35 1.75 1.75 0 0 0-2.5 1.78Q13.61 22 12 22a8.5 8.5 0 1 1 8.4-9.85q-.58-.15-1.15-.15a5.5 5.5 0 0 0-3.35 1.19l-.28.22-.02.02-.01.01a1.75 1.75 0 0 0-.14 2.48m-4.2-7.27v4.7a.75.75 0 0 0 1.5 0v-4.7a.75.75 0 0 0-1.5 0m8-3.47-.08-.06a.75.75 0 0 0-.9 1.2l1.15 1 .08.06a.75.75 0 0 0 .9-1.2zM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75M18.25 18c0-.41.34-.75.75-.75.53 0 1.06-.18 1.44-.47.4-.3.56-.63.56-.9 0-.65-.66-1.38-1.75-1.38-.52 0-1.01.19-1.4.4a4 4 0 0 0-.6.4v.01a.75.75 0 0 1-1-1.12l.02-.02.23-.18q.23-.16.62-.4c.51-.28 1.27-.59 2.13-.59 1.68 0 3.25 1.18 3.25 2.88 0 .89-.52 1.62-1.16 2.1l-.03.02.03.02c.64.48 1.16 1.21 1.16 2.1 0 1.7-1.57 2.88-3.25 2.88-.86 0-1.62-.31-2.13-.6a6 6 0 0 1-.85-.57l-.01-.01-.01-.01a.75.75 0 0 1 1-1.12l.02.02a3 3 0 0 0 .57.38c.4.22.9.41 1.41.41 1.09 0 1.75-.73 1.75-1.37 0-.28-.17-.61-.56-.9a2.5 2.5 0 0 0-1.44-.48.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$d0340aafda30ec99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer324Regular', "24", [
    "M20.4 12.15a8.5 8.5 0 1 0-5.39 9.3 1.75 1.75 0 0 1 .65-1.98 7 7 0 1 1 3.18-7.45 5 5 0 0 1 1.55.13m-7.66-3.5a.75.75 0 0 0-1.49.1v4.6a.75.75 0 0 0 1.5-.1v-4.6m6.49-3.48-.08-.06a.75.75 0 0 0-.88 1.22l1.16.96.08.06a.75.75 0 0 0 .88-1.21zM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75M18.25 18c0-.41.34-.75.75-.75.53 0 1.06-.18 1.44-.47.4-.3.56-.63.56-.9 0-.65-.66-1.38-1.75-1.38-.52 0-1.01.19-1.4.4a4 4 0 0 0-.6.4v.01a.75.75 0 0 1-1-1.12l.02-.02.23-.18q.23-.16.62-.4c.51-.28 1.27-.59 2.13-.59 1.68 0 3.25 1.18 3.25 2.88 0 .89-.52 1.62-1.16 2.1l-.03.02.03.02c.64.48 1.16 1.21 1.16 2.1 0 1.7-1.57 2.88-3.25 2.88-.86 0-1.62-.31-2.13-.6a6 6 0 0 1-.85-.57l-.01-.01-.01-.01a.75.75 0 0 1 1-1.12l.02.02a3 3 0 0 0 .57.38c.4.22.9.41 1.41.41 1.09 0 1.75-.73 1.75-1.37 0-.28-.17-.61-.56-.9a2.5 2.5 0 0 0-1.44-.48.75.75 0 0 1-.75-.75"
]);
const $77e1bce0ac0f7fe7$export$1038751ad15e77ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer48Filled', "48", [
    "M19.25 5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM7 27a17 17 0 1 1 34 0 17 17 0 0 1-34 0m15.75-.25a1.25 1.25 0 1 0 2.5 0v-9.5a1.25 1.25 0 1 0-2.5 0zm13.62-16.38a1.25 1.25 0 0 1 1.76 0l2.5 2.5a1.25 1.25 0 0 1-1.76 1.76l-2.5-2.5a1.25 1.25 0 0 1 0-1.76"
]);
const $77e1bce0ac0f7fe7$export$132e9e142e4355ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer48Regular', "48", [
    "M18 6.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25m4.75 20.5a1.25 1.25 0 1 0 2.5 0v-9.5a1.25 1.25 0 1 0-2.5 0zM24 10a17 17 0 1 0 0 34 17 17 0 0 0 0-34M9.5 27a14.5 14.5 0 1 1 29 0 14.5 14.5 0 0 1-29 0m28.63-16.63a1.25 1.25 0 1 0-1.76 1.76l2.5 2.5a1.25 1.25 0 0 0 1.76-1.76z"
]);
const $77e1bce0ac0f7fe7$export$b62950436973cf66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff20Filled', "20", [
    "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33M10 10.71l-1-1v1.79a.5.5 0 0 0 1 0zm0-4.21v1.38l5.92 5.92q.57-1.3.58-2.8a7 7 0 0 0-9.8-6.42L9 6.88V6.5a.5.5 0 0 1 1 0m-3-4c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71"
]);
const $77e1bce0ac0f7fe7$export$c248778180e0368c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff20Regular', "20", [
    "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33m9.16 9.16L10 10.7v.79a.5.5 0 0 1-1 0V9.7L5.67 6.39A5.99 5.99 0 0 0 9.5 17c1.86 0 3.52-.85 4.62-2.17M9 6.5v.38l1 1V6.5a.5.5 0 0 0-1 0m6.5 4.5a6 6 0 0 1-.35 2.03l.77.77q.57-1.3.58-2.8a7 7 0 0 0-9.8-6.42l.77.77A6 6 0 0 1 15.5 11m-8-9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7z"
]);
const $77e1bce0ac0f7fe7$export$1bf7709d7688689a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4 4a8.5 8.5 0 1 0 12.01 12.01l2.49 2.5a.75.75 0 0 0 1.06-1.07zm9.34 11.46a.75.75 0 0 1-1.36-.33l-.01-.1v-.94zm.13-4.93v.82l7.13 7.13q.61-1.5.62-3.2A8.5 8.5 0 0 0 8.8 5.62l2.64 2.63a.75.75 0 0 1 1.3.4zm6.42-3.63.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2M14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6"
]);
const $77e1bce0ac0f7fe7$export$fc7faf1fa1398a52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4 4a8.5 8.5 0 1 0 12.01 12.01l2.49 2.5a.75.75 0 0 0 1.06-1.07zm13.88 16a7 7 0 1 1-9.89-9.89l3.98 3.98v1.04a.75.75 0 0 0 1.37.33zm-5.72-9.97 1.31 1.32v-.92a.75.75 0 0 0-1.31-.4M19 13.5a7 7 0 0 1-.3 2.02l1.18 1.18q.61-1.5.62-3.2A8.5 8.5 0 0 0 8.8 5.62L9.98 6.8A7 7 0 0 1 19 13.5m.15-8.39.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22m-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6"
]);
const $77e1bce0ac0f7fe7$export$f16928cc3eb9ec10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop20Filled', "20", [
    "M1.96 4.5c0-.83.67-1.5 1.5-1.5H16.4c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H12v2.01h1.5a.5.5 0 0 1 0 1h-7a.5.5 0 1 1 0-1H8V14H3.46a1.5 1.5 0 0 1-1.5-1.5zM9 14v2.01h2V14zM4 5.5v6c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3 0v6c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5"
]);
const $77e1bce0ac0f7fe7$export$8407d04ba57c12d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop20Regular', "20", [
    "M4 5.5c0-.28.22-.5.5-.5h1c.27 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zm-5.54-.5c0-.83.67-1.5 1.5-1.5H16.4c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H12v2.01h1.5a.5.5 0 0 1 0 1h-7a.5.5 0 1 1 0-1H8V14H3.46a1.5 1.5 0 0 1-1.5-1.5zM9 14v2.01h2V14zM3.46 4a.5.5 0 0 0-.5.5v8c0 .28.23.5.5.5H16.4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $77e1bce0ac0f7fe7$export$e9a2ca9cbb3f66c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop24Filled', "24", [
    "M19.75 3c1.19 0 2.16.93 2.24 2.1v10.65c0 1.2-.92 2.17-2.09 2.25h-4.4v2.5h1.75a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5H8.5V18H4.25c-1.2 0-2.17-.92-2.24-2.1L2 15.76V5.25c0-1.2.93-2.17 2.1-2.24L4.25 3zM14 18h-4v2.5h4zm4.5-12h-9a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5m-11 0h-2a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$fe232d1bff74cc14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop24Regular', "24", [
    "M19.75 3c1.2 0 2.17.93 2.24 2.1l.01.15v10.5c0 1.2-.93 2.17-2.1 2.25h-4.4v2.5h1.75a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5H8.5V18H4.25c-1.19 0-2.16-.92-2.24-2.1V5.26c0-1.2.92-2.17 2.09-2.24L4.25 3zM14 18h-4v2.5h4zm5.75-13.5H4.25c-.38 0-.7.28-.74.65v10.6c0 .38.27.7.64.75h15.6c.38 0 .7-.28.74-.65l.01-.1V5.25c0-.38-.28-.7-.65-.74zM18.5 6a.5.5 0 0 1 .5.41v8.09a.5.5 0 0 1-.4.5H9.5a.5.5 0 0 1-.5-.4V6.5a.5.5 0 0 1 .41-.5h9.09m-11 0a.5.5 0 0 1 .5.41v8.09a.5.5 0 0 1-.41.5h-2.1a.5.5 0 0 1-.48-.4L5 14.5v-8a.5.5 0 0 1 .4-.5h2.1"
]);
const $77e1bce0ac0f7fe7$export$968e9c912748cdac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile20Filled', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2.5 0a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zM9 15.5c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.5.5"
]);
const $77e1bce0ac0f7fe7$export$384ed314a86f9b58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile20Regular', "20", [
    "M7.5 4a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zM7 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zM9.5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $77e1bce0ac0f7fe7$export$1e8e0f1709fc7415 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm-2.5 16h-2.5a.75.75 0 0 0-.1 1.5h2.6a.75.75 0 0 0 0-1.5m1.25-9h-5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5m0-4h-5a.5.5 0 0 0-.5.5v2c0 .27.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5"
]);
const $77e1bce0ac0f7fe7$export$f5a4f8e6bea64cb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75m-2.5 14a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zM14.5 9a.5.5 0 0 1 .5.4v6.1a.5.5 0 0 1-.41.5H9.5a.5.5 0 0 1-.5-.4V9.5a.5.5 0 0 1 .41-.5h5.09m0-4a.5.5 0 0 1 .5.41V7.5a.5.5 0 0 1-.41.5H9.5a.5.5 0 0 1-.5-.4V5.5a.5.5 0 0 1 .41-.5h5.09"
]);
const $77e1bce0ac0f7fe7$export$7ce86077b4bac9f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_16_color__a)",
            "d": "M11 1a4 4 0 0 0-3.9 4.91l-5.05 5.24a1.99 1.99 0 0 0 2.85 2.77l5-5.07a4 4 0 0 0 5.06-4.39.5.5 0 0 0-.84-.28L12 6.29 9.7 4l2.12-2.12a.5.5 0 0 0-.28-.84z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_16_color__a",
                "x1": "6.98",
                "x2": "9.39",
                "y1": "1.84",
                "y2": "14.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$12bfa6f119e095fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench16Filled', "16", [
    "M11 1a4 4 0 0 0-3.9 4.91l-5.05 5.24a1.99 1.99 0 0 0 2.85 2.77l5-5.07a4 4 0 0 0 5.06-4.39.5.5 0 0 0-.85-.28L12 6.29 9.7 4l2.12-2.12a.5.5 0 0 0-.29-.84z"
]);
const $77e1bce0ac0f7fe7$export$ffddc1d08f9d68b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench16Regular', "16", [
    "M7 5a4 4 0 0 1 5.45-3.73.5.5 0 0 1 .17.82L10.7 4 12 5.3l1.91-1.92a.5.5 0 0 1 .82.17 4 4 0 0 1-4.83 5.3l-5 5.07a1.99 1.99 0 0 1-2.85-2.77L7.1 5.9Q7 5.46 7 5m4-3a3 3 0 0 0-2.86 3.9.5.5 0 0 1-.12.5l-5.25 5.44a.99.99 0 0 0 1.41 1.38l5.23-5.3a.5.5 0 0 1 .53-.11 3 3 0 0 0 4.05-3.09l-1.64 1.63a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7L11.28 2z"
]);
const $77e1bce0ac0f7fe7$export$477a492df683be4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_20_color__a)",
            "d": "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3l6.37-6.46a4.5 4.5 0 0 0 5.49-5.37.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84A5 5 0 0 0 13.5 2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_20_color__a",
                "x1": "8.5",
                "x2": "11.36",
                "y1": "3",
                "y2": "18.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$7a4dd08841447bd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench20Filled', "20", [
    "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3l6.37-6.46a4.5 4.5 0 0 0 5.49-5.37.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84 5 5 0 0 0-1-.11"
]);
const $77e1bce0ac0f7fe7$export$cb0724f115e985ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench20Regular', "20", [
    "M9 6.5a4.5 4.5 0 0 1 6.35-4.1.5.5 0 0 1 .15.8l-2.3 2.3 1.3 1.3 2.3-2.3a.5.5 0 0 1 .8.15A4.5 4.5 0 0 1 13.5 11a5 5 0 0 1-1.1-.14l-6.37 6.45a2.36 2.36 0 0 1-3.37-3.3l6.42-6.65A5 5 0 0 1 9 6.5M13.5 3a3.5 3.5 0 0 0-3.39 4.39.5.5 0 0 1-.12.47L3.38 14.7a1.36 1.36 0 0 0 1.94 1.9l6.57-6.66a.5.5 0 0 1 .51-.12 3.5 3.5 0 0 0 4.53-4.05l-2.08 2.07a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2.07-2.08A4 4 0 0 0 13.5 3"
]);
const $77e1bce0ac0f7fe7$export$d94b164a7b059560 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_24_color__a)",
            "d": "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l8.31-8.31a5.51 5.51 0 0 0 6.5-7.1.75.75 0 0 0-1.23-.29l-2.45 2.45c-.3.29-.77.29-1.06 0l-.88-.88a.75.75 0 0 1 0-1.06l2.45-2.45a.75.75 0 0 0-.3-1.24A6 6 0 0 0 16.5 2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_24_color__a",
                "x1": "10.13",
                "x2": "13.69",
                "y1": "3.25",
                "y2": "22.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$f77683ef180290c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench24Filled', "24", [
    "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l8.31-8.31a5.51 5.51 0 0 0 6.5-7.1.75.75 0 0 0-1.23-.29l-2.45 2.45c-.3.29-.77.29-1.06 0l-.88-.88a.75.75 0 0 1 0-1.06l2.45-2.45a.75.75 0 0 0-.3-1.24A6 6 0 0 0 16.5 2"
]);
const $77e1bce0ac0f7fe7$export$60c3f7ede56c3174 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench24Regular', "24", [
    "M11 7.5a5.5 5.5 0 0 1 7.66-5.06.75.75 0 0 1 .24 1.22L16.3 6.25l1.44 1.44 2.59-2.59a.75.75 0 0 1 1.22.24 5.49 5.49 0 0 1-6.35 7.5l-8.3 8.32a2.87 2.87 0 1 1-4.07-4.06l8.31-8.31Q11 8.16 11 7.5m5.5-4a4 4 0 0 0-3.8 5.27c.1.27.03.57-.18.77L3.9 18.16a1.37 1.37 0 0 0 1.94 1.94l8.63-8.62c.2-.2.5-.27.76-.18a4 4 0 0 0 5.25-4.22l-1.85 1.85c-.48.48-1.28.48-1.76 0l-1.8-1.8a1.25 1.25 0 0 1 0-1.76l1.85-1.85z"
]);
const $77e1bce0ac0f7fe7$export$6940411ed03519fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__a)",
            "d": "M16 5.12v5.38h-3V5.12l-.44-.87A1 1 0 0 1 12.5 4q0-.09.07-.31l.45-1.35q.05-.15.18-.24.15-.1.3-.1h2q.15 0 .29.1.12.09.19.24l.11.35.34.99.07.32q0 .09-.06.24l-.3.64z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__b)",
            "d": "M17 11.5h-5v4.05q0 .51.2.96a2.6 2.6 0 0 0 1.35 1.3 2.5 2.5 0 0 0 1.9 0q.45-.2.8-.53.34-.33.55-.77.2-.45.2-.96z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__c)",
            "d": "M17 12v-1.5q0-.16-.07-.27a.4.4 0 0 0-.17-.15l-.24-.06-.25-.02h-3.54q-.14 0-.26.02a1 1 0 0 0-.24.07.4.4 0 0 0-.17.14.5.5 0 0 0-.06.27V12z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_20_color__d)",
            "d": "M5.78 2.13q.21.15.22.41V6a1 1 0 0 0 2 0V2.54a.5.5 0 0 1 .69-.46 4.5 4.5 0 0 1 .31 8.2V16a2 2 0 1 1-4 0v-5.72a4.5 4.5 0 0 1 .31-8.2.5.5 0 0 1 .47.05"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__a",
                "x1": "15.83",
                "x2": "12.81",
                "y1": ".38",
                "y2": "16.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__b",
                "x1": "17",
                "x2": "10.45",
                "y1": "18.14",
                "y2": "13.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__c",
                "x1": "13.38",
                "x2": "14.04",
                "y1": "10.48",
                "y2": "12.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_20_color__d",
                "x1": "10",
                "x2": "4.8",
                "y1": "-1",
                "y2": "18.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$8b56b44f75ce906b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver20Filled', "20", [
    "M17 12v-1.5q0-.16-.07-.27a.4.4 0 0 0-.17-.15l-.24-.06-.25-.02H16V5.12l.13-.24.17-.32.14-.32q.06-.15.06-.24 0-.1-.07-.32a7 7 0 0 0-.34-1q-.09-.22-.11-.34a.6.6 0 0 0-.2-.25.5.5 0 0 0-.28-.09h-2q-.15 0-.3.1a.5.5 0 0 0-.18.24l-.3.86-.22.8q0 .11.06.25a8 8 0 0 0 .44.87V10h-.27q-.14 0-.26.02a1 1 0 0 0-.24.07.4.4 0 0 0-.17.14.5.5 0 0 0-.06.27V12zm0 1h-5v2.55q0 .51.2.96a2.6 2.6 0 0 0 1.35 1.3 2.5 2.5 0 0 0 1.9 0q.45-.2.8-.53.34-.33.55-.77.2-.45.2-.96zM5.78 2.13q.21.15.22.41V6a1 1 0 0 0 2 0V2.54a.5.5 0 0 1 .69-.46 4.5 4.5 0 0 1 .31 8.2V16a2 2 0 1 1-4 0v-5.72a4.5 4.5 0 0 1 .31-8.2.5.5 0 0 1 .47.05"
]);
const $77e1bce0ac0f7fe7$export$2427341ac31ef2be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver20Regular', "20", [
    "M17 15.55V10.5q0-.16-.07-.27a.4.4 0 0 0-.17-.15l-.24-.06-.25-.02H16V5.12l.13-.24.17-.32.14-.32q.06-.15.06-.24 0-.1-.07-.32a7 7 0 0 0-.34-1q-.09-.22-.11-.34a.6.6 0 0 0-.2-.25.5.5 0 0 0-.28-.09h-2q-.15 0-.3.1a.5.5 0 0 0-.18.24l-.3.86-.22.8q0 .11.06.25a8 8 0 0 0 .44.87V10h-.27q-.14 0-.26.02a1 1 0 0 0-.24.07.4.4 0 0 0-.17.14.5.5 0 0 0-.06.27v5.05q0 .51.2.96a2.6 2.6 0 0 0 1.35 1.3 2.5 2.5 0 0 0 1.9 0q.45-.2.8-.53.34-.33.55-.77.2-.45.2-.96M15 10h-1V5a1 1 0 0 0-.05-.23l-.41-.8.32-.97h1.28l.32.96-.4.81A1 1 0 0 0 15 5zm-2 2v-1h3v1zm3 1v2.5q0 .3-.12.58-.12.29-.33.48a1.5 1.5 0 0 1-1.63.32q-.29-.12-.48-.33A1.5 1.5 0 0 1 13 15.5V13zM6 2.54a.5.5 0 0 0-.69-.46 4.5 4.5 0 0 0-.31 8.2V16a2 2 0 0 0 4 0v-5.72a4.5 4.5 0 0 0-.31-8.2.5.5 0 0 0-.69.46V6a1 1 0 1 1-2 0zM3.5 6.25c0-1.19.6-2.24 1.5-2.87V6a2 2 0 1 0 4 0V3.38a3.5 3.5 0 0 1-.69 6.12.5.5 0 0 0-.31.46V16a1 1 0 1 1-2 0V9.96a.5.5 0 0 0-.31-.46A3.5 3.5 0 0 1 3.5 6.25"
]);
const $77e1bce0ac0f7fe7$export$361fcff3bec2227f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_24_color__a)",
            "d": "M16.75 2a.8.8 0 0 0-.67.41l-1 2c-.11.23-.1.5.02.71L16 6.7v5.8h3V6.7l.9-1.58a.8.8 0 0 0 .02-.7l-1-2a.8.8 0 0 0-.67-.42z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_24_color__b)",
            "d": "M14 14.5v4a3.5 3.5 0 1 0 7 0v-4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_24_color__c)",
            "d": "M20.25 12c.41 0 .75.34.75.75V15h-7v-2.25c0-.41.34-.75.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_24_color__d)",
            "d": "M8.83 2.21c.2-.14.47-.17.7-.07a5.5 5.5 0 0 1 .5 10v7.32a2.54 2.54 0 0 1-5.07 0v-7.33a5.5 5.5 0 0 1 .51-10 .75.75 0 0 1 1.03.7V6.5a1 1 0 1 0 2 0V2.83q0-.4.33-.62"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_24_color__a",
                "x1": "19.17",
                "x2": "15.47",
                "y1": "0",
                "y2": "20.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_24_color__b",
                "x1": "21",
                "x2": "13.05",
                "y1": "22.17",
                "y2": "15.46",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_24_color__c",
                "x1": "15.93",
                "x2": "16.98",
                "y1": "12.73",
                "y2": "15.18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_24_color__d",
                "x1": "11.17",
                "x2": "4.56",
                "y1": "-1.71",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$2b02e278d3375f25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver24Filled', "24", [
    "M16.08 2.41a.8.8 0 0 1 .67-.41h1.5c.28 0 .54.16.67.41l1 2c.11.23.1.5-.02.71L19 6.7V12h1.25c.41 0 .75.34.75.75v1.75h-7v-1.75c0-.41.34-.75.75-.75H16V6.7l-.9-1.58a.8.8 0 0 1-.02-.7zM14 16v2.5a3.5 3.5 0 1 0 7 0V16zM8.83 2.21c.2-.14.47-.17.7-.07a5.5 5.5 0 0 1 .5 10v7.32a2.54 2.54 0 0 1-5.07 0v-7.33a5.5 5.5 0 0 1 .51-10 .75.75 0 0 1 1.03.7V6.5a1 1 0 1 0 2 0V2.83q0-.4.33-.62"
]);
const $77e1bce0ac0f7fe7$export$380a43a96e0283bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver24Regular', "24", [
    "M16.25 2a.8.8 0 0 0-.67.41l-1 2c-.11.23-.1.5.02.71l.9 1.58V12h-.75a.75.75 0 0 0-.75.75v5.75a3.5 3.5 0 1 0 7 0v-5.75a.75.75 0 0 0-.75-.75h-.75V6.7l.9-1.58a.8.8 0 0 0 .02-.7l-1-2a.8.8 0 0 0-.67-.42zM18 12h-1V6.5a1 1 0 0 0-.1-.37l-.8-1.4.61-1.23h1.58l.61 1.23-.8 1.4a1 1 0 0 0-.1.37zm-2.5 6.5V16h4v2.5a2 2 0 1 1-4 0m4-4h-4v-1h4zM9.53 2.14a.75.75 0 0 0-1.03.7V6.5a1 1 0 0 1-2 0V2.83a.75.75 0 0 0-1.03-.7 5.5 5.5 0 0 0-.5 10v7.33a2.54 2.54 0 0 0 5.07 0v-7.33a5.5 5.5 0 0 0-.51-10M10 6.5V4.13a4 4 0 0 1-1 6.83.8.8 0 0 0-.46.7v7.8a1.04 1.04 0 0 1-2.08 0v-7.8c0-.31-.18-.59-.46-.7a4 4 0 0 1-1-6.83V6.5a2.5 2.5 0 1 0 5 0"
]);
const $77e1bce0ac0f7fe7$export$11a0897811c6bd2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver28Filled', "28", [
    "M11.37 2.8a.8.8 0 0 1 .74 0A6.5 6.5 0 0 1 11 14.67V24l-.01.2A2 2 0 0 1 7 24v-9.32A6.5 6.5 0 0 1 5.9 2.8a.75.75 0 0 1 1.1.66V6.5l.01.2A2 2 0 0 0 9 8.5l.2-.01A2 2 0 0 0 11 6.5V3.45q.01-.42.37-.65M25 22a4 4 0 0 1-8 0v-3.5h8zM22.18 2q.36.07.56.39l1.25 2.25c.11.2.12.45.03.66l-.94 2.1V14h1.17c.41 0 .75.34.75.75V17h-8v-2.25c0-.41.34-.75.75-.75h1.33V7.4l-.93-2.1a.8.8 0 0 1 .03-.66l1.25-2.25.05-.09q.23-.3.6-.3h2.1"
]);
const $77e1bce0ac0f7fe7$export$4cd0e83edc470ca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver28Regular', "28", [
    "M10.3 2.42q.32-.23.68-.11a6.5 6.5 0 0 1 .52 12.19v9a2.5 2.5 0 0 1-5 0v-9a6.5 6.5 0 0 1 .52-12.2.75.75 0 0 1 .98.72V7.6a1 1 0 0 0 2-.1V3.02q0-.37.3-.6M22.1 2q.36.05.56.38l1.25 2.25c.11.2.12.45.03.66L23 7.4V14h1.25c.41 0 .75.34.75.75v6.75a4.5 4.5 0 1 1-9 0v-6.75c0-.41.34-.75.75-.75H18V7.4l-.94-2.1a.8.8 0 0 1 .03-.66l1.25-2.25.06-.09q.23-.3.6-.3h3.1M11.5 7.5l-.01.26A2.5 2.5 0 0 1 6.5 7.5V4.17A5 5 0 0 0 4 8.5v.2a5 5 0 0 0 3.48 4.56c.3.1.52.4.52.72v9.52a1 1 0 1 0 2 0v-9.52c0-.33.21-.62.52-.72A5 5 0 0 0 14 8.71V8.5a5 5 0 0 0-2.5-4.33zm6 14a3 3 0 1 0 6 0v-3h-6zm0-4.5h6v-1.5h-6zm1.09-11.96.85 1.9q.06.15.06.31V14h2V7.25q0-.15.06-.3l.85-1.91-.85-1.54h-2.12z"
]);
const $77e1bce0ac0f7fe7$export$584d04c0a8f115a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_32_color__a)",
            "d": "M22 3a1 1 0 0 0-.93.63l-1 2.5a1 1 0 0 0 0 .74L21 9.2V16h5V9.2l.93-2.33a1 1 0 0 0 0-.74l-1-2.5A1 1 0 0 0 25 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_32_color__b)",
            "d": "M18 19.5v4a5.5 5.5 0 1 0 11 0v-4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_32_color__c)",
            "d": "M28 16a1 1 0 0 1 1 1v3H18v-3a1 1 0 0 1 1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_wrench_screwdriver_32_color__d)",
            "d": "M8.58 3.52a1 1 0 0 1 .42.82V9a1 1 0 0 0 2 0V4.34a1 1 0 0 1 1.33-.94A7 7 0 0 1 13 16.33V26a3 3 0 1 1-6 0v-9.67A7 7 0 0 1 7.67 3.4a1 1 0 0 1 .9.12"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_32_color__a",
                "x1": "25.83",
                "x2": "21.76",
                "y1": ".52",
                "y2": "26.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".85",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_32_color__b",
                "x1": "29",
                "x2": "18.79",
                "y1": "29.21",
                "y2": "18.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_32_color__c",
                "x1": "21.03",
                "x2": "22.27",
                "y1": "16.97",
                "y2": "20.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_wrench_screwdriver_32_color__d",
                "x1": "14.67",
                "x2": "6.06",
                "y1": "-1.55",
                "y2": "29.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $77e1bce0ac0f7fe7$export$939d25515cf94e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Filled', "32", [
    "M21.07 3.63A1 1 0 0 1 22 3h3a1 1 0 0 1 .93.63l1 2.5q.15.37 0 .74L26 9.2V16h2a1 1 0 0 1 1 1v3H18v-3a1 1 0 0 1 1-1h2V9.2l-.93-2.33a1 1 0 0 1 0-.74zm-12.5-.1a1 1 0 0 1 .43.81V9a1 1 0 0 0 2 0V4.34a1 1 0 0 1 1.33-.94A7 7 0 0 1 13 16.33V26a3 3 0 1 1-6 0v-9.67A7 7 0 0 1 7.67 3.4a1 1 0 0 1 .9.12M18 22v1.5a5.5 5.5 0 1 0 11 0V22z"
]);
const $77e1bce0ac0f7fe7$export$717167534271843d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Light', "32", [
    "M21.5 3h4q.3 0 .45.28l1.5 3a.5.5 0 0 1 0 .44L26 9.62V16h2.5c.28 0 .5.22.5.5v7a5.5 5.5 0 1 1-11 0v-7c0-.28.22-.5.5-.5H21V9.62l-1.45-2.9a.5.5 0 0 1 0-.44l1.5-3A.5.5 0 0 1 21.5 3M25 16V9.5a1 1 0 0 1 .05-.22l1.4-2.78L25.18 4h-3.38l-1.25 2.5 1.39 2.78a1 1 0 0 1 .05.22V16zm-6 1v3h9v-3zm0 4v2.5a4.5 4.5 0 1 0 9 0V21zM7.78 3.58q.21.16.22.42v5a2 2 0 1 0 4 0V4a.5.5 0 0 1 .7-.46 7 7 0 0 1 .3 12.79V26a3 3 0 1 1-6 0v-9.67a7 7 0 0 1 .3-12.8.5.5 0 0 1 .48.05M7 4.8a6 6 0 0 0 .7 10.74c.18.08.3.26.3.46v10a2 2 0 1 0 4 0V16c0-.2.12-.38.3-.46A6 6 0 0 0 13 4.8V9a3 3 0 1 1-6 0z"
]);
const $77e1bce0ac0f7fe7$export$75fa6cae5f6f100c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Regular', "32", [
    "M21 3a1 1 0 0 0-.93.63l-1 2.5a1 1 0 0 0 0 .74L20 9.2V16h-1a1 1 0 0 0-1 1v6.5a5.5 5.5 0 1 0 11 0V17a1 1 0 0 0-1-1h-1V9.2l.93-2.33a1 1 0 0 0 0-.74l-1-2.5A1 1 0 0 0 26 3zm4 13h-3V9a1 1 0 0 0-.07-.37l-.85-2.13.6-1.5h3.64l.6 1.5-.85 2.13A1 1 0 0 0 25 9zm-5 2h7v2h-7zM8.58 3.52a1 1 0 0 1 .42.82V9a1 1 0 0 0 2 0V4.34a1 1 0 0 1 1.33-.94A7 7 0 0 1 13 16.33V26a3 3 0 1 1-6 0v-9.67A7 7 0 0 1 7.67 3.4a1 1 0 0 1 .9.12M7 6a5 5 0 0 0 1.33 8.72 1 1 0 0 1 .67.94V26a1 1 0 1 0 2 0V15.66a1 1 0 0 1 .67-.94A5 5 0 0 0 13 6v3a3 3 0 1 1-6 0zm13 16h7v1.5a3.5 3.5 0 1 1-7 0z"
]);
const $77e1bce0ac0f7fe7$export$e2095562c14d46e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings20Filled', "20", [
    "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3L9 14.3a5.5 5.5 0 0 1 7.84-4.78 4.5 4.5 0 0 0 1.05-4.03.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84 5 5 0 0 0-1-.11m-2.86 11.92a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $77e1bce0ac0f7fe7$export$ae9c779e9b0cc570 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings20Regular', "20", [
    "M9 6.5a4.5 4.5 0 0 1 6.35-4.1.5.5 0 0 1 .15.8l-2.3 2.3 1.3 1.3 2.3-2.3a.5.5 0 0 1 .8.15 4.5 4.5 0 0 1-.76 4.87 6 6 0 0 0-1.05-.37 3.5 3.5 0 0 0 1.14-3.37l-2.08 2.07a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2.07-2.08a3.52 3.52 0 0 0-4.1 4.32.5.5 0 0 1-.13.47L3.38 14.7a1.36 1.36 0 0 0 1.94 1.9l4.06-4.11A6 6 0 0 0 9 14.3L6.03 17.3a2.36 2.36 0 0 1-3.37-3.3l6.42-6.65A5 5 0 0 1 9 6.5m1.64 7.42a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $77e1bce0ac0f7fe7$export$735e049a81ee038d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings24Filled', "24", [
    "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l4.12-4.11a6.5 6.5 0 0 1 9.17-5.47 5.5 5.5 0 0 0 1.53-5.82.75.75 0 0 0-1.24-.3l-2.45 2.45c-.3.29-.77.29-1.06 0l-.88-.88a.75.75 0 0 1 0-1.06l2.45-2.45a.75.75 0 0 0-.3-1.24A6 6 0 0 0 16.5 2m-2.22 11.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0-.01-1.8l-.54-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.59-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $77e1bce0ac0f7fe7$export$a696513800429c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings24Regular', "24", [
    "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l4.12-4.11c.08-1.22.5-2.35 1.17-3.3L5.84 20.1a1.37 1.37 0 0 1-1.94-1.94l8.62-8.62c.2-.2.28-.5.19-.77a4 4 0 0 1 4.2-5.25l-1.84 1.85a1.25 1.25 0 0 0 0 1.76l1.8 1.8c.48.48 1.28.48 1.76 0l1.85-1.85.02.42a4 4 0 0 1-2.16 3.55q.98.14 1.85.53a5.5 5.5 0 0 0 1.37-6.24.75.75 0 0 0-1.22-.24L17.75 7.7l-1.44-1.44 2.59-2.59a.75.75 0 0 0-.24-1.22A6 6 0 0 0 16.5 2m-2.22 11.98a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64q.66.58 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0-.01-1.8l-.54-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.59-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.82.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);



'use client';
function $9c87bf651177f1dd$var$getTextString(text, children) {
    if (text !== undefined) return text;
    let textString = '';
    let hasNonStringChild = false;
    $acw62.Children.forEach(children, (child)=>{
        if (typeof child === 'string') textString += child;
        else hasNonStringChild = true;
    });
    // warn if an Option has non-string children and no text prop
    if (hasNonStringChild) // eslint-disable-next-line no-console
    console.warn('Provide a `text` prop to Option components when they contain non-string children.');
    return textString;
}
const $9c87bf651177f1dd$export$7cefcfbb76c54f87 = (props, ref)=>{
    const state = $9c87bf651177f1dd$export$4253dbab2fdd1282(props, ref);
    // check icon
    let CheckIcon = /*#__PURE__*/ $acw62.createElement((0, $6c2c53ad43edfb7d$export$931168ba4a0d2b6e), null);
    if (state.multiselect) CheckIcon = state.selected ? /*#__PURE__*/ $acw62.createElement((0, $77e1bce0ac0f7fe7$export$ea97004bee98e8e9), null) : '';
    if (state.checkIcon) {
        var _state_checkIcon;
        var _children;
        (_children = (_state_checkIcon = state.checkIcon).children) !== null && _children !== void 0 ? _children : _state_checkIcon.children = CheckIcon;
    }
    return state;
};
const $9c87bf651177f1dd$export$4253dbab2fdd1282 = (props, ref)=>{
    const { children: children, disabled: disabled, text: text, value: value } = props;
    const optionRef = $acw62.useRef(null);
    const optionText = $9c87bf651177f1dd$var$getTextString(text, children);
    const optionValue = value !== null && value !== void 0 ? value : optionText;
    // use the id if provided, otherwise use a generated id
    const id = (0, $0200d30cfa270435$export$f680877a34711e37)('fluent-option', props.id);
    // data used for context registration & events
    const optionData = $acw62.useMemo(()=>({
            id: id,
            disabled: disabled,
            text: optionText,
            value: optionValue
        }), [
        id,
        disabled,
        optionText,
        optionValue
    ]);
    // context values
    const { controller: activeDescendantController } = (0, $c1885444320cfc69$export$4f05d3a7578fc562)();
    const multiselect = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.multiselect);
    const registerOption = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.registerOption);
    const selected = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>{
        const selectedOptions = ctx.selectedOptions;
        return optionValue !== undefined && selectedOptions.find((o)=>o === optionValue) !== undefined;
    });
    const selectOption = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.selectOption);
    const onOptionClick = (0, $3da7f046412336d6$export$e12dcb7f4977f165)((ctx)=>ctx.onOptionClick);
    const onClick = (event)=>{
        var _props_onClick;
        if (disabled) {
            event.preventDefault();
            return;
        }
        activeDescendantController.focus(id);
        // handle selection change
        selectOption(event, optionData);
        onOptionClick(event);
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 || _props_onClick.call(props, event);
    };
    // register option data with context
    $acw62.useEffect(()=>{
        if (id && optionRef.current) return registerOption(optionData, optionRef.current);
    }, [
        id,
        optionData,
        registerOption
    ]);
    const semanticProps = multiselect ? {
        role: 'menuitemcheckbox',
        'aria-checked': selected
    } : {
        role: 'option',
        'aria-selected': selected
    };
    return {
        components: {
            root: 'div',
            checkIcon: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, optionRef),
            'aria-disabled': disabled ? 'true' : undefined,
            id: id,
            ...semanticProps,
            ...props,
            onClick: onClick
        }), {
            elementType: 'div'
        }),
        checkIcon: (0, $fcf7ddccaab7fd8f$exports).optional(props.checkIcon, {
            renderByDefault: true,
            defaultProps: {
                'aria-hidden': 'true'
            },
            elementType: 'span'
        }),
        disabled: disabled,
        multiselect: multiselect,
        selected: selected,
        // no longer used
        focusVisible: false,
        active: false
    };
};




const $bd9362c57ea58246$export$9b37ba7b7baa16dd = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.checkIcon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.checkIcon, {}),
            state.root.children
        ]
    });
};





'use client';
const $b34b3f3b78b37b02$export$6a1ce83050e19a39 = {
    root: 'fui-Option',
    checkIcon: 'fui-Option__checkIcon'
};
/**
 * Styles for the root slot
 */ const $b34b3f3b78b37b02$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bt984gj: "f122n59",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        sj55zd: "f19n0e5",
        i8kkvl: "f1ufnopg",
        Bceei9c: "f1k6fduh",
        mc9l5x: "f22iagw",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fm5eomj",
        qhf8xq: "f10pi13n"
    },
    interactive: {
        Jwef8y: "f1knas48",
        Bi91k9c: "feu1g3u",
        zqbkvg: "fo79ri9",
        h82x05: [
            "f1osiabc",
            "f1e8le25"
        ],
        cqj998: "f1yusjty",
        j3hlsh: [
            "f1e8le25",
            "f1osiabc"
        ],
        ecr2s2: "fb40n2d",
        lj723h: "f1g4hkjv",
        Btxx2vb: "f1lnr2zp",
        sltcwy: [
            "f1ogfk9z",
            "f1g7j8ec"
        ],
        dnwvvm: "fiuf46r",
        Blyvkvs: [
            "f1g7j8ec",
            "f1ogfk9z"
        ]
    },
    active: {
        Bowz1zl: "f11vrvdw",
        oxogb1: "f17hxjb7",
        Ix2sn8: "f1dha69c",
        q7v32p: "f1lm7500",
        B7cbj04: 0,
        Bewtojm: 0,
        b50fsz: 0,
        B1wzb3v: 0,
        Bqwk70n: 0,
        B37u8z8: 0,
        avt0cx: 0,
        f0sref: 0,
        B9fkznv: 0,
        Be3o27t: 0,
        Bertapg: 0,
        B53xpsf: 0,
        Bsv72rj: 0,
        B39dzdd: 0,
        Btq9bd3: 0,
        Bqfxd14: 0,
        atup0s: "fo7xqb",
        Fffuxt: 0,
        Bttcd12: 0,
        Beitzug: 0,
        Bqougee: 0,
        B86i8pi: "f1kurthe",
        Bhijsxg: "fwq15dy",
        kktds4: "f1pb3wry",
        Bmau3bo: [
            "ftjv2f4",
            "f1flhb1f"
        ],
        npektv: [
            "f1flhb1f",
            "ftjv2f4"
        ]
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        Bceei9c: "f158kwzp",
        B7iucu3: "f1cyfu5x"
    },
    selected: {},
    checkIcon: {
        Bnnss6s: "fi64zpg",
        Be2twd7: "fod5ikn",
        Frg6f3: [
            "f18b9hdq",
            "fn6qj8t"
        ],
        t21cq0: [
            "f1xk557c",
            "f1h9en5y"
        ],
        Bcdw1i0: "fd7fpy0",
        Bo70h7d: "fvc9v3g"
    },
    selectedCheck: {
        Bcdw1i0: "f1022m68"
    },
    multiselectCheck: {
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f1l3cf7o",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "fq9zq91",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Brf1p80: "f4d9j23",
        Bkfmm31: "f1w9h62z",
        Be2twd7: "f1ugzwwg",
        Bqenvij: "fd461yt",
        a9b677: "fjw5fx7",
        Bcdw1i0: "f1022m68"
    },
    selectedMultiselectCheck: {
        De3pzq: "ftywsgz",
        sj55zd: "fqpbvvt",
        g2u3we: "f3xi7mh",
        h3c5rm: [
            "ftovhe4",
            "f1wczvin"
        ],
        B9xav0g: "f68vbr6",
        zhjwy3: [
            "f1wczvin",
            "ftovhe4"
        ]
    },
    checkDisabled: {
        sj55zd: "f1s2aq7o",
        B7iucu3: "f1cyfu5x"
    },
    multiselectCheckDisabled: {
        g2u3we: "f1r1t4y1",
        h3c5rm: [
            "fmj8ijw",
            "figx54m"
        ],
        B9xav0g: "f360ss8",
        zhjwy3: [
            "figx54m",
            "fmj8ijw"
        ]
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ufnopg{column-gap:var(--spacingHorizontalXS);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f22iagw{display:flex;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".fm5eomj{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        ".f10pi13n{position:relative;}",
        ".f11vrvdw[data-activedescendant-focusvisible]::after{content:\"\";}",
        ".f17hxjb7[data-activedescendant-focusvisible]::after{position:absolute;}",
        ".f1dha69c[data-activedescendant-focusvisible]::after{pointer-events:none;}",
        ".f1lm7500[data-activedescendant-focusvisible]::after{z-index:1;}",
        [
            ".fo7xqb[data-activedescendant-focusvisible]::after{border:2px solid var(--colorStrokeFocus2);}",
            {
                p: -2
            }
        ],
        [
            ".f1kurthe[data-activedescendant-focusvisible]::after{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fwq15dy[data-activedescendant-focusvisible]::after{top:-2px;}",
        ".f1pb3wry[data-activedescendant-focusvisible]::after{bottom:-2px;}",
        ".ftjv2f4[data-activedescendant-focusvisible]::after{left:-2px;}",
        ".f1flhb1f[data-activedescendant-focusvisible]::after{right:-2px;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f158kwzp{cursor:default;}",
        ".fi64zpg{flex-shrink:0;}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".f18b9hdq{margin-left:calc(var(--spacingHorizontalXXS) * -1);}",
        ".fn6qj8t{margin-right:calc(var(--spacingHorizontalXXS) * -1);}",
        ".f1xk557c{margin-right:var(--spacingHorizontalXXS);}",
        ".f1h9en5y{margin-left:var(--spacingHorizontalXXS);}",
        ".fd7fpy0{visibility:hidden;}",
        ".fvc9v3g svg{display:block;}",
        ".f1022m68{visibility:visible;}",
        [
            ".f1l3cf7o{border:var(--strokeWidthThin) solid var(--colorNeutralStrokeAccessible);}",
            {
                p: -2
            }
        ],
        [
            ".fq9zq91{border-radius:var(--borderRadiusSmall);}",
            {
                p: -1
            }
        ],
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f4d9j23{justify-content:center;}",
        ".f1w9h62z{fill:currentColor;}",
        ".f1ugzwwg{font-size:12px;}",
        ".fd461yt{height:16px;}",
        ".fjw5fx7{width:16px;}",
        ".ftywsgz{background-color:var(--colorCompoundBrandBackground);}",
        ".fqpbvvt{color:var(--colorNeutralForegroundInverted);}",
        ".f3xi7mh{border-top-color:var(--colorCompoundBrandBackground);}",
        ".ftovhe4{border-right-color:var(--colorCompoundBrandBackground);}",
        ".f1wczvin{border-left-color:var(--colorCompoundBrandBackground);}",
        ".f68vbr6{border-bottom-color:var(--colorCompoundBrandBackground);}",
        ".f1r1t4y1{border-top-color:var(--colorNeutralForegroundDisabled);}",
        ".fmj8ijw{border-right-color:var(--colorNeutralForegroundDisabled);}",
        ".figx54m{border-left-color:var(--colorNeutralForegroundDisabled);}",
        ".f360ss8{border-bottom-color:var(--colorNeutralForegroundDisabled);}"
    ],
    h: [
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".fo79ri9:hover .fui-Option__checkIcon{border-top-color:var(--colorNeutralForeground1Hover);}",
        ".f1osiabc:hover .fui-Option__checkIcon{border-right-color:var(--colorNeutralForeground1Hover);}",
        ".f1e8le25:hover .fui-Option__checkIcon{border-left-color:var(--colorNeutralForeground1Hover);}",
        ".f1yusjty:hover .fui-Option__checkIcon{border-bottom-color:var(--colorNeutralForeground1Hover);}"
    ],
    a: [
        ".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}",
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f1lnr2zp:active .fui-Option__checkIcon{border-top-color:var(--colorNeutralForeground1Hover);}",
        ".f1ogfk9z:active .fui-Option__checkIcon{border-right-color:var(--colorNeutralForeground1Hover);}",
        ".f1g7j8ec:active .fui-Option__checkIcon{border-left-color:var(--colorNeutralForeground1Hover);}",
        ".fiuf46r:active .fui-Option__checkIcon{border-bottom-color:var(--colorNeutralForeground1Hover);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1cyfu5x{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $b34b3f3b78b37b02$export$47f818074d988e72 = (state)=>{
    const { disabled: disabled, multiselect: multiselect, selected: selected } = state;
    const styles = $b34b3f3b78b37b02$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($b34b3f3b78b37b02$export$6a1ce83050e19a39.root, styles.root, !disabled && styles.interactive, styles.active, disabled && styles.disabled, selected && styles.selected, state.root.className);
    if (state.checkIcon) // eslint-disable-next-line react-hooks/immutability
    state.checkIcon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($b34b3f3b78b37b02$export$6a1ce83050e19a39.checkIcon, styles.checkIcon, multiselect && styles.multiselectCheck, selected && styles.selectedCheck, selected && multiselect && styles.selectedMultiselectCheck, disabled && styles.checkDisabled, disabled && multiselect && styles.multiselectCheckDisabled, state.checkIcon.className);
    return state;
};



'use client';
const $f6e0577c148e3e97$export$36d18380658d5d20 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $9c87bf651177f1dd$export$7cefcfbb76c54f87)(props, ref);
    (0, $b34b3f3b78b37b02$export$47f818074d988e72)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useOptionStyles_unstable')(state);
    return (0, $bd9362c57ea58246$export$9b37ba7b7baa16dd)(state);
});
$f6e0577c148e3e97$export$36d18380658d5d20.displayName = 'Option';




'use client';
const $86bc1fabdb018032$export$b7c5888229bafdeb = {
    root: 'fui-Subtitle2'
};
const $86bc1fabdb018032$export$e1d06f9c365aed08 = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
});


'use client';
const $715c9647a8930a69$export$661f1b2c265066f = (0, $b47caaa3576ee3da$export$b956d067c5bcf6b)({
    useStyles: (0, $86bc1fabdb018032$export$e1d06f9c365aed08),
    className: (0, $86bc1fabdb018032$export$b7c5888229bafdeb).root,
    displayName: 'Subtitle2'
});


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


"use client";
const $f52f593d43f17bc8$export$bd5f5c3939634881 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery0Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z"
]);
const $f52f593d43f17bc8$export$929a9c1a3287327f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery0Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
]);
const $f52f593d43f17bc8$export$fda2cfaf84b761f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery10Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$c4d98b2d8ae72ddb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery10Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm13 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$833ec49132309d76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery1Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM2.75 7a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 2.75 7"
]);
const $f52f593d43f17bc8$export$36888d8e90e49825 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery1Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-.25 1c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $f52f593d43f17bc8$export$86c22dc09c555877 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery2Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$4669d9ce47c54d85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery2Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm1 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$6e6bfc32956485f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery3Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$64507420b690234b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery3Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm2.5 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$475fe2e45483aae1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery4Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$6358033ff7313300 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery4Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm4 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$138ab98de220bda8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery5Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$6cb260237a5b4c57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery5Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm5.5 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$8728742a22c8378a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery6Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$bc87c14273cedd9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery6Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm7 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$21ba80a31577930b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery7Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$a928d3363f75e314 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery7Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm8.5 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$c948258e056a39fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery8Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$a208e4c9712bfb9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery8Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm10 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$bef5c41119d0224d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery9Filled', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
]);
const $f52f593d43f17bc8$export$bef48babea3973da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Battery9Regular', "1em", [
    "M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM3 6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm11.5 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
]);
const $f52f593d43f17bc8$export$5ca493e1023010fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge0Filled', "1em", [
    "M6.23 6.18C5.81 7 6.42 8 7.35 8H8v1.67c0 1.4 1.88 1.85 2.52.6l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$e6f8ac5d950451be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge0Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.05-3.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$a22bc6eea0443490 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge10Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-3.83l.6-1.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$ffed095a1f84d18e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge10Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v1.67c0 1.4 1.88 1.85 2.52.6L12.17 7H16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$b3eec58f05153e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge1Filled', "1em", [
    "M6.23 6.18C5.81 7 6.42 8 7.35 8H8v1.67c0 1.4 1.88 1.85 2.52.6l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zM2.75 7a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 2.75 7m6.62-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$80bdc021d4cc3e47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge1Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zM2.75 7c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75m6.62-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$d5d05c4019b22724 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryChargeFilled', "1em", [
    "M6.23 6.18C5.81 7 6.42 8 7.35 8H8v1.67c0 1.4 1.88 1.85 2.52.6l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$8f659681c8d884d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryChargeRegular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.05-3.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$49bcf53cd78aba71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge2Filled', "1em", [
    "M6.23 6.18C5.81 7 6.42 8 7.35 8H8v1.67c0 1.4 1.88 1.85 2.52.6l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zM3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm6.37-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$e12d1d827410e3db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge2Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zM4 7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm5.37-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$f318725240577dc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge3Filled', "1em", [
    "M6.23 6.18c-.2.4-.16.83.03 1.17A1 1 0 0 0 5.5 7H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1V8a1 1 0 0 0-.11-.46c.22.27.56.46.96.46H8v1.67c0 1.4 1.88 1.85 2.52.6l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$cade49e38772d97e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge3Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zM5.5 7a1 1 0 0 1 .76.35l.13.2A1 1 0 0 1 6.5 8v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.87-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$6259b83550f7a435 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge4Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V9.67c0 1.4 1.88 1.85 2.52.6l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$bd3e9967dbfd6e2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge4Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$7569190c183c2fe8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge5Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5.5a1 1 0 0 0 1-1v-1.01c.4-.05.8-.28 1.02-.72l2.25-4.45q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$b90d52c17c8b5e40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge5Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v1.67c0 .9.78 1.4 1.5 1.32V12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$f07137910371ec88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge6Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V9.31l1.77-3.49q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$6ee88029c1838c3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge6Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v1.67c0 1.4 1.88 1.85 2.52.6L11 9.3V12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$d4085b8b8ab45e9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge7Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8.5a1 1 0 0 0 1-1V8a1 1 0 0 0-.42-.82l.69-1.36q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$71f8f20b8abee70b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge7Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v1.67c0 1.4 1.88 1.85 2.52.6l1.56-3.09a1 1 0 0 1 .42.82v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$3261cf8590f38570 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge8Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-.83l.6-1.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$a1b93b2d8bad4216 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge8Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v1.67c0 1.4 1.88 1.85 2.52.6L12.17 7H13a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$83f5709739c9e711 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge9Filled', "1em", [
    "M6.23 6.18q-.2.42-.1.82H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2.33l.6-1.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm3.14-4c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$d97a5a5b159b4210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCharge9Regular', "1em", [
    "M6.32 6H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3.33l.1-.18q.2-.42.1-.82H16a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.83zm-.2 1c.12.55.6 1 1.23 1H8v1.67c0 1.4 1.88 1.85 2.52.6L12.17 7h2.33a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm3.25-4.82c.16-.3.63-.2.63.15V5h1.64c.2 0 .32.2.23.37L9.62 9.82c-.15.3-.62.2-.62-.15V7H7.35a.26.26 0 0 1-.22-.37z"
]);
const $f52f593d43f17bc8$export$f22e8341f939f779 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCheckmarkFilled', "1em", [
    "M4.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 2.65a.5.5 0 0 0-.7 0L3.5 14.29l-.65-.64a.5.5 0 1 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H9.8A5.5 5.5 0 0 0 0 10.34V8a3 3 0 0 1 3-3z"
]);
const $f52f593d43f17bc8$export$dbc34b25afdf1509 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryCheckmarkRegular', "1em", [
    "M4.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 2.65a.5.5 0 0 0-.7 0L3.5 14.29l-.65-.64a.5.5 0 1 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H9.8q.13-.49.18-1H16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v1.26q-.57.47-1 1.08V8a3 3 0 0 1 3-3z"
]);
const $f52f593d43f17bc8$export$d0efcaf46ed991f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatterySaverFilled', "1em", [
    "M4.18 4.27c.23-.36.78-.37.99.02C6.38 6.53 7 8.33 7 9.56c0 1.24-.58 2.28-1.14 2.77l-.15.1-.09.05a.35.35 0 0 1-.5-.39l.03-.07q.7-1.79.68-3.5a.6.6 0 0 0-.59-.58.6.6 0 0 0-.57.56v.02q.01.43-.04.88l-.05.37-.04.19-.05.26-.08.32-.03.12q-.2.72-.53 1.44A5.6 5.6 0 0 1 .8 14.96a.6.6 0 0 1-.77-.32.6.6 0 0 1 .32-.77 5 5 0 0 0 1.8-1.28C.88 12.2.13 11.3.03 10.03-.1 8.6.43 7.64 1.78 6.56l.65-.5.29-.23a7 7 0 0 0 1.46-1.56M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H4c-.18 0-.5-.12-.5-.5s.3-.5.5-.5h.04C5.32 14 8 13.01 8 9.72c0-1.02-.45-2.68-.96-3.92a.58.58 0 0 1 .47-.8H16"
]);
const $f52f593d43f17bc8$export$6380870005d18a39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatterySaverRegular', "1em", [
    "M4.18 4.27c.23-.36.78-.37.99.02C6.38 6.53 7 8.33 7 9.56c0 1.24-.58 2.28-1.14 2.77l-.15.1-.09.05a.35.35 0 0 1-.5-.39l.03-.07q.7-1.79.68-3.5a.6.6 0 0 0-.59-.58.6.6 0 0 0-.57.56v.02q.01.43-.04.88l-.05.37-.04.19-.05.26-.08.32-.03.12q-.2.72-.53 1.44A5.6 5.6 0 0 1 .8 14.96a.6.6 0 0 1-.77-.32.6.6 0 0 1 .32-.77 5 5 0 0 0 1.8-1.28C.88 12.2.13 11.3.03 10.03-.1 8.6.43 7.64 1.78 6.56l.65-.5.29-.23a7 7 0 0 0 1.46-1.56M16 5a3 3 0 0 1 3 3h1v4h-1a3 3 0 0 1-3 3H4a.5.5 0 0 1 0-1h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H7.5a.5.5 0 0 1 0-1z"
]);
const $f52f593d43f17bc8$export$c0ed92214224fbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryWarningFilled', "1em", [
    "M3.6 9.55a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 8 18H1a1 1 0 0 1-.9-1.45zM4.5 16a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v.15A3 3 0 0 1 16 15H9.24L6.29 9.1a2 2 0 0 0-3.58 0L.47 13.6A3 3 0 0 1 0 12V8a3 3 0 0 1 3-3zM4.5 11a.5.5 0 0 0-.5.5v3a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5"
]);
const $f52f593d43f17bc8$export$85554e01dfa51731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BatteryWarningRegular', "1em", [
    "M3.6 9.55a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 8 18H1a1 1 0 0 1-.9-1.45zM4.5 16a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M16 5a3 3 0 0 1 3 3 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1 3 3 0 0 1-3 3H9.24l-.5-1H16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v4q0 .23.05.44L.47 13.6A3 3 0 0 1 0 12V8a3 3 0 0 1 3-3zM4.5 11a.5.5 0 0 0-.5.5v3a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5"
]);
const $f52f593d43f17bc8$export$86da4c691f746b92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $f52f593d43f17bc8$export$dcef7f81f3b9e781 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleRegular', "1em", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
]);
const $f52f593d43f17bc8$export$dc13c13e34dead73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleEditFilled', "1em", [
    "M10 2a8 8 0 0 0-1 15.94q.02-.15.06-.29l.37-1.5a3 3 0 0 1 .84-1.48l4.83-4.83a2.9 2.9 0 0 1 2.85-.72A8 8 0 0 0 10 2m.98 13.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $f52f593d43f17bc8$export$4417e76ab47a410e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleEditRegular', "1em", [
    "M10 3a7 7 0 0 0-.77 13.96l-.17.7q-.04.13-.05.28a8 8 0 1 1 8.94-8.82q-.5-.15-1.02-.11A7 7 0 0 0 10 3m.98 12.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $f52f593d43f17bc8$export$d2856deada179415 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleEraserFilled', "1em", [
    "M8.73 17.17a2.5 2.5 0 0 1 0-3.53l4.9-4.9a2.5 2.5 0 0 1 3.54 0l.8.8a8 8 0 1 0-8.44 8.44zm7.74-7.73 2.1 2.1a1.5 1.5 0 0 1 0 2.12l-3.6 3.6-4.22-4.22 3.6-3.6a1.5 1.5 0 0 1 2.12 0m-2.21 8.52-4.22-4.21-.6.6a1.5 1.5 0 0 0 0 2.12l2.1 2.1a1.5 1.5 0 0 0 1.12.43h4.09a.5.5 0 0 0 0-1h-2.53z"
]);
const $f52f593d43f17bc8$export$dffa980d51873d02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleEraserRegular', "1em", [
    "M8.73 17.17q-.15-.15-.29-.35A7 7 0 0 1 10 3a7 7 0 0 1 6.82 5.44q.19.13.35.3l.8.8a8 8 0 1 0-8.43 8.44zm.7-.7a1.5 1.5 0 0 1 0-2.13l4.9-4.9a1.5 1.5 0 0 1 2.13 0l2.1 2.1a1.5 1.5 0 0 1 0 2.12L14.22 18h2.53a.5.5 0 0 1 0 1h-4.1a1.5 1.5 0 0 1-1.12-.44zm5.62-6.32-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 0 0 0-.71l-2.1-2.1a.5.5 0 0 0-.7 0m-1.5 7.1-2.8-2.8-.6.6a.5.5 0 0 0 0 .71l2.1 2.1a.5.5 0 0 0 .7 0z"
]);
const $f52f593d43f17bc8$export$615c5e3044f4b85c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHalfFillFilled', "1em", [
    "M3.5 10a6.5 6.5 0 0 1 13 0zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $f52f593d43f17bc8$export$5f74a7b010f39c12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHalfFillRegular', "1em", [
    "M3 10a7 7 0 0 1 14 0zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $f52f593d43f17bc8$export$31e30541762f7e67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHighlightFilled', "1em", [
    "M4 4.7q-.37.43-.69.9l3.3 3.3a.5.5 0 1 1-.71.7L2.8 6.5q-.27.55-.45 1.15L5.6 10.9a.5.5 0 0 1-.7.7L2.09 8.8a8 8 0 0 0-.08 1.5l3.34 3.35a.5.5 0 0 1-.7.7l-2.41-2.4a8 8 0 1 0 9.7-9.71l2.41 2.4a.5.5 0 0 1-.7.71L10.3 2.01a8 8 0 0 0-1.5.08l2.8 2.8a.5.5 0 0 1-.7.71L7.65 2.35q-.6.18-1.14.45l3.1 3.1a.5.5 0 1 1-.71.7L5.6 3.31q-.46.31-.9.7l3.15 3.14a.5.5 0 1 1-.7.7z"
]);
const $f52f593d43f17bc8$export$deb1e9eb79338834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHighlightRegular', "1em", [
    "M9.71 3a7 7 0 0 1 1.73.15l2.2 2.2a.5.5 0 0 0 .72-.7l-.47-.47a7 7 0 1 1-9.72 9.7l.48.47a.5.5 0 1 0 .7-.7l-2.2-2.21A7 7 0 0 1 3 9.7l1.89 1.9a.5.5 0 1 0 .7-.71L3.18 8.46q.14-.62.39-1.2L5.9 9.6a.5.5 0 1 0 .7-.7L4.05 6.33q.3-.49.67-.91l2.44 2.43a.5.5 0 1 0 .7-.7L5.43 4.7q.42-.37.91-.67L8.9 6.6a.5.5 0 1 0 .7-.7L7.27 3.55q.59-.24 1.2-.38L10.9 5.6a.5.5 0 0 0 .7-.7zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $f52f593d43f17bc8$export$1ff872062865c75b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintFilled', "1em", [
    "M8.7 2.1a8 8 0 0 1 2.6 0 .75.75 0 0 1-.24 1.49 7 7 0 0 0-2.12 0A.75.75 0 1 1 8.7 2.1M6.39 3.68c.24.34.16.8-.18 1.05q-.86.62-1.5 1.5a.75.75 0 0 1-1.21-.88A8 8 0 0 1 5.34 3.5a.75.75 0 0 1 1.05.17m7.22 0a.75.75 0 0 1 1.05-.17 8 8 0 0 1 1.84 1.84.75.75 0 0 1-1.22.87 7 7 0 0 0-1.5-1.5.75.75 0 0 1-.17-1.04M2.97 8.07c.4.08.68.46.62.87a7 7 0 0 0 0 2.12.75.75 0 0 1-1.48.24 8 8 0 0 1 0-2.6c.06-.41.45-.69.86-.62m14.06 0c.41-.06.8.22.86.63.14.85.14 1.75 0 2.6a.75.75 0 0 1-1.48-.24c.12-.69.12-1.43 0-2.12-.06-.4.21-.8.62-.86M3.67 13.62a.75.75 0 0 1 1.05.18q.62.86 1.5 1.5a.75.75 0 1 1-.88 1.21 8 8 0 0 1-1.84-1.84.75.75 0 0 1 .17-1.05m12.66 0c.34.25.41.71.17 1.05a8 8 0 0 1-1.84 1.84.75.75 0 0 1-.87-1.22 7 7 0 0 0 1.5-1.5.75.75 0 0 1 1.04-.17m-8.25 3.42c.07-.4.45-.68.86-.62.69.12 1.43.12 2.12 0a.75.75 0 0 1 .24 1.48c-.85.14-1.75.14-2.6 0a.75.75 0 0 1-.62-.86"
]);
const $f52f593d43f17bc8$export$faea1de6545bc03e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintRegular', "1em", [
    "M8.44 2.15a8 8 0 0 1 3.12 0 .5.5 0 0 1-.2.98 7 7 0 0 0-2.73 0 .5.5 0 0 1-.2-.98m5.31 1.34a.5.5 0 0 1 .7-.14 8 8 0 0 1 2.2 2.2.5.5 0 1 1-.83.56 7 7 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7m-7.5 0a.5.5 0 0 1-.14.69A7 7 0 0 0 4.18 6.1a.5.5 0 0 1-.83-.56 8 8 0 0 1 2.2-2.2.5.5 0 0 1 .7.14M2.74 8.05a.5.5 0 0 1 .4.58 7 7 0 0 0 0 2.74.5.5 0 0 1-.99.2 8 8 0 0 1 0-3.13.5.5 0 0 1 .59-.4m14.52 0a.5.5 0 0 1 .59.39 8 8 0 0 1 0 3.12.5.5 0 1 1-.98-.2 7 7 0 0 0 0-2.73.5.5 0 0 1 .39-.58m-13.78 5.7a.5.5 0 0 1 .7.14 7 7 0 0 0 1.93 1.93.5.5 0 0 1-.56.83 8 8 0 0 1-2.2-2.2.5.5 0 0 1 .13-.7m13.03 0c.23.16.3.47.14.7a8 8 0 0 1-2.2 2.2.5.5 0 0 1-.56-.83 7 7 0 0 0 1.93-1.93.5.5 0 0 1 .7-.14m-8.46 3.51a.5.5 0 0 1 .58-.4c.89.18 1.85.18 2.74 0a.5.5 0 0 1 .19.99 8 8 0 0 1-3.12 0 .5.5 0 0 1-.4-.59"
]);
const $f52f593d43f17bc8$export$12d21e04f5fbc086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintCursorFilled', "1em", [
    "M6.37 3.85c-.18-.43-.69-.6-1.06-.33q-1.04.75-1.8 1.8c-.26.36-.09.87.34 1.05.34.14.74 0 .96-.29q.56-.72 1.27-1.27c.3-.22.43-.62.29-.96m2.74-.29a.8.8 0 0 1-.9-.48c-.17-.42.07-.9.52-.98a8 8 0 0 1 2.54 0c.45.07.69.56.51.98a.8.8 0 0 1-.88.48 7 7 0 0 0-1.8 0m7.04 2.8a.8.8 0 0 1-.96-.28q-.56-.72-1.27-1.27a.8.8 0 0 1-.29-.96c.18-.43.69-.6 1.06-.33q1.04.75 1.8 1.8c.26.36.09.87-.34 1.05m.77 5.42a.8.8 0 0 1-.48-.89 7 7 0 0 0 0-1.78.8.8 0 0 1 .48-.9c.42-.17.9.07.98.52a8 8 0 0 1 0 2.54c-.07.45-.56.69-.98.51m-8.7 5.14a.8.8 0 0 1 .89-.48 7 7 0 0 0 1.9 0l-.01 1.5a8 8 0 0 1-2.27-.04c-.45-.07-.69-.56-.51-.98m-4.37-3.29a.8.8 0 0 1 .96.29q.56.72 1.27 1.27c.3.22.43.62.29.96-.18.43-.69.6-1.06.33q-1.04-.75-1.8-1.8c-.26-.36-.09-.87.34-1.05m-.77-5.41c.35.14.53.51.48.89a7 7 0 0 0 0 1.78.8.8 0 0 1-.48.9c-.42.17-.9-.07-.98-.52a8 8 0 0 1 0-2.54c.07-.45.56-.69.98-.51m9.78 1.93a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $f52f593d43f17bc8$export$deafdfde72946210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintCursorRegular', "1em", [
    "M6.25 3.58a.48.48 0 0 0-.7-.23 8 8 0 0 0-2.2 2.2.48.48 0 0 0 .23.7c.23.1.5.01.64-.2a7 7 0 0 1 1.83-1.83c.21-.14.3-.4.2-.64m2.45-.46a.5.5 0 0 1-.6-.3.48.48 0 0 1 .34-.67 8 8 0 0 1 3.11 0c.3.06.46.38.34.66a.5.5 0 0 1-.6.31 7 7 0 0 0-2.6 0m7.72 3.14c-.23.1-.5 0-.64-.2a7 7 0 0 0-1.84-1.85.5.5 0 0 1-.2-.63c.12-.28.45-.4.7-.23a8 8 0 0 1 2.2 2.2c.18.25.06.59-.22.7m.77 5.64a.5.5 0 0 1-.31-.6 7 7 0 0 0 0-2.6.5.5 0 0 1 .3-.6c.29-.11.61.04.67.34a8 8 0 0 1 0 3.12.48.48 0 0 1-.66.34M8.1 17.19c.1-.23.35-.36.6-.31a7 7 0 0 0 2.3.05v1a8 8 0 0 1-2.56-.08.48.48 0 0 1-.34-.66m-4.52-3.45c.23-.1.5 0 .64.2q.74 1.1 1.83 1.84c.21.14.3.41.2.64a.48.48 0 0 1-.7.23 8 8 0 0 1-2.2-2.2.48.48 0 0 1 .23-.7M2.8 8.11c.23.1.36.34.31.59a7 7 0 0 0 0 2.6c.05.25-.08.5-.3.6a.48.48 0 0 1-.67-.34 8 8 0 0 1 0-3.12c.06-.3.38-.45.66-.33m10.05 2.04a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84z"
]);
const $f52f593d43f17bc8$export$a68b8efbb703dab7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintDismissFilled', "1em", [
    "M6.37 3.85c-.18-.43-.69-.6-1.06-.33q-1.04.75-1.8 1.8c-.26.36-.09.87.34 1.05.34.14.74 0 .96-.29q.56-.72 1.27-1.27c.3-.22.43-.62.29-.96m2.74-.29a.8.8 0 0 1-.9-.48c-.17-.42.07-.9.52-.98a8 8 0 0 1 2.54 0c.45.07.69.56.51.98a.8.8 0 0 1-.88.48 7 7 0 0 0-1.8 0m7.04 2.8a.8.8 0 0 1-.96-.28q-.56-.72-1.27-1.27a.8.8 0 0 1-.29-.96c.18-.43.69-.6 1.06-.33q1.04.75 1.8 1.8c.26.36.09.87-.34 1.05M10.25 18a6 6 0 0 1-.89-1.53l-.25-.03a.8.8 0 0 0-.9.48c-.17.42.07.9.52.98a8 8 0 0 0 1.52.1m6.22-8.64a6 6 0 0 1 1.53.9 8 8 0 0 0-.1-1.53c-.07-.45-.56-.69-.98-.51a.8.8 0 0 0-.48.89zM3.85 13.63a.8.8 0 0 1 .96.29q.56.72 1.27 1.27c.3.22.43.62.29.96-.18.43-.69.6-1.06.33q-1.04-.75-1.8-1.8c-.26-.36-.09-.87.34-1.05m-.77-5.41c.35.14.53.51.48.89a7 7 0 0 0 0 1.78.8.8 0 0 1-.48.9c-.42.17-.9-.07-.98-.52a8 8 0 0 1 0-2.54c.07-.45.56-.69.98-.51M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $f52f593d43f17bc8$export$63e856817da3fc0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintDismissRegular', "1em", [
    "M6.25 3.58a.48.48 0 0 0-.7-.23 8 8 0 0 0-2.2 2.2.48.48 0 0 0 .23.7c.23.1.5.01.64-.2a7 7 0 0 1 1.83-1.83c.21-.14.3-.4.2-.64m2.45-.46a.5.5 0 0 1-.6-.3.48.48 0 0 1 .34-.67 8 8 0 0 1 3.11 0c.3.06.46.38.34.66a.5.5 0 0 1-.6.31 7 7 0 0 0-2.6 0m7.72 3.14c-.23.1-.5 0-.64-.2a7 7 0 0 0-1.84-1.85.5.5 0 0 1-.2-.63c.12-.28.45-.4.7-.23a8 8 0 0 1 2.2 2.2c.18.25.06.59-.22.7M10.25 18a6 6 0 0 1-.66-1.01q-.45-.03-.9-.11a.5.5 0 0 0-.59.3c-.11.29.04.6.34.67a8 8 0 0 0 1.81.15M17 9.6q.54.27 1 .65a8 8 0 0 0-.14-1.8.48.48 0 0 0-.66-.35.5.5 0 0 0-.31.6q.09.44.1.9M3.58 13.73c.23-.1.5 0 .64.2q.74 1.1 1.83 1.84c.21.14.3.41.2.64a.48.48 0 0 1-.7.23 8 8 0 0 1-2.2-2.2.48.48 0 0 1 .23-.7M2.8 8.11c.23.1.36.34.31.59a7 7 0 0 0 0 2.6c.05.25-.08.5-.3.6a.48.48 0 0 1-.67-.34 8 8 0 0 1 0-3.12c.06-.3.38-.45.66-.33M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $f52f593d43f17bc8$export$38af801918a316a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintHalfVerticalFilled', "1em", [
    "M10 2a7.96 7.96 0 0 0-8 8 8 8 0 0 0 1.5 4.66A8 8 0 0 0 10 18q.66 0 1.3-.1a.75.75 0 0 0-.24-1.49 6.5 6.5 0 1 1 0-12.83.75.75 0 0 0 .24-1.47Q10.67 2 10 2m4.66 1.5a.75.75 0 0 0-.87 1.22q.86.62 1.5 1.5a.75.75 0 0 0 1.21-.88 8 8 0 0 0-1.84-1.84m3.23 5.2a.75.75 0 0 0-1.48.24c.12.69.12 1.43 0 2.12a.75.75 0 0 0 1.48.24c.14-.85.14-1.75 0-2.6m-1.39 5.96a.75.75 0 0 0-1.22-.87 7 7 0 0 1-1.5 1.5.75.75 0 1 0 .88 1.21 8 8 0 0 0 1.84-1.84"
]);
const $f52f593d43f17bc8$export$1c1b1e9a07bd8387 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleHintHalfVerticalRegular', "1em", [
    "M8.44 2.15a7.95 7.95 0 0 0-6.34 6.6 8.1 8.1 0 0 0 3.46 7.9 8.08 8.08 0 0 0 6 1.19.5.5 0 0 0-.2-.97 7 7 0 1 1 0-13.73.5.5 0 0 0 .2-.99Q10.8 2 10 2a8 8 0 0 0-1.56.15m6 1.2a.5.5 0 0 0-.55.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m3.4 5.09a.5.5 0 1 0-.97.2 7 7 0 0 1 0 2.73.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13m-1.19 6a.5.5 0 1 0-.83-.55 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .55.83 8 8 0 0 0 2.21-2.2"
]);
const $f52f593d43f17bc8$export$1e6dacb7298baaf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleImageFilled', "1em", [
    "M12.3 14.41a1 1 0 0 1 1.4 0l3.18 3.18q-.6.4-1.38.41h-5q-.77-.01-1.38-.41zM15.5 8a2.5 2.5 0 0 1 2.5 2.5v5q-.01.77-.41 1.38L14.4 13.7a2 2 0 0 0-2.82 0L8.4 16.88q-.4-.6-.41-1.38v-5A2.5 2.5 0 0 1 10.5 8zM8 2a6 6 0 0 1 5.91 5H10.5A3.5 3.5 0 0 0 7 10.5v3.41A6 6 0 0 1 8 2m7 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $f52f593d43f17bc8$export$db30e44c30562e80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleImageRegular', "1em", [
    "M15.5 8a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 8 15.5v-5A2.5 2.5 0 0 1 10.5 8zm-1.8 6.41a1 1 0 0 0-1.4 0l-2.45 2.44q.3.15.65.15h5q.35 0 .65-.15zM10.5 9C9.67 9 9 9.67 9 10.5v5q0 .35.15.65l2.44-2.44a2 2 0 0 1 2.82 0l2.44 2.44q.15-.3.15-.65v-5c0-.83-.67-1.5-1.5-1.5zM8 2a6 6 0 0 1 5.91 5H12.9A5 5 0 1 0 7 12.9v1.01A6 6 0 0 1 8 2m7 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $f52f593d43f17bc8$export$58d9d3bbce7ebdfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleImageOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-.27-.26q-.6.4-1.38.41h-5q-.77-.01-1.38-.41l3.17-3.18a1 1 0 0 1 1.42 0l-1.23-1.22q-.5.13-.9.52l-3.17 3.17q-.4-.6-.41-1.38v-5q.01-.77.41-1.38L7.7 8.4C7.26 9 7 9.71 7 10.5v3.41a6 6 0 0 1-3.58-9.78L2.15 2.85a.5.5 0 0 1 0-.7M15.5 8a2.5 2.5 0 0 1 2.5 2.5v5q0 .18-.03.35l-7.82-7.82q.17-.03.35-.03zm-.5 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 2a6 6 0 0 1 5.91 5H10.5q-.61 0-1.18.2L4.95 2.83Q6.32 2.02 8 2"
]);
const $f52f593d43f17bc8$export$6e48c40fd3ac21af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleImageOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-.27-.27q-.6.41-1.38.42h-5A2.5 2.5 0 0 1 8 15.5v-5q.01-.77.41-1.38L4.13 4.84A5 5 0 0 0 7 12.9v1.01a6 6 0 0 1-3.58-9.78L2.15 2.85a.5.5 0 0 1 0-.7M13.7 14.4a1 1 0 0 0-1.42 0l-2.44 2.44q.3.15.65.15h5q.35 0 .65-.15zM9.15 9.85q-.15.3-.15.65v5q0 .35.15.65l2.44-2.44q.38-.39.9-.52zM15.5 8a2.5 2.5 0 0 1 2.5 2.5v5q0 .18-.03.35l-.97-.97V10.5c0-.83-.67-1.5-1.5-1.5h-4.38l-.97-.97q.17-.03.35-.03zm-.5 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2M8 2a6 6 0 0 1 5.91 5H12.9a5 5 0 0 0-7.21-3.43l-.74-.74Q6.32 2.02 8 2"
]);
const $f52f593d43f17bc8$export$2eb236a4ed0ffd4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleLineFilled', "1em", [
    "M17.98 10.5H2.02a8 8 0 0 0 15.96 0m0-1H2.02a8 8 0 0 1 15.96 0"
]);
const $f52f593d43f17bc8$export$2069c52514725c6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleLineRegular', "1em", [
    "M3.02 9.5h13.96a7 7 0 0 0-13.96 0M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m14.98.5H3.02a7 7 0 0 0 13.96 0"
]);
const $f52f593d43f17bc8$export$35d0fd9a40da4690 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleConcentricFilled', "1em", [
    "M3.5 10a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-3.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M10 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
]);
const $f52f593d43f17bc8$export$8cfc4a1681a17470 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleConcentricRegular', "1em", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
]);
const $f52f593d43f17bc8$export$a01610e4e5172252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleConcentricDashesFilled', "1em", [
    "M11.1 16.91c.26-.04.52.1.6.35.1.28-.07.58-.36.63a8 8 0 0 1-2.68 0 .5.5 0 0 1-.36-.63c.08-.25.33-.4.6-.35a7 7 0 0 0 2.2 0m-7.98-4.02c.25-.08.52.04.63.27a7 7 0 0 0 3.08 3.08c.24.12.36.39.28.64a.5.5 0 0 1-.66.29 8 8 0 0 1-3.62-3.62.5.5 0 0 1 .3-.66m13.12.27a.53.53 0 0 1 .64-.27c.27.1.42.4.29.66a8 8 0 0 1-3.62 3.62.5.5 0 0 1-.66-.3.53.53 0 0 1 .27-.63 7 7 0 0 0 3.08-3.07M10 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10M2.74 8.3c.25.08.39.33.35.59a7 7 0 0 0 0 2.22c.04.26-.1.51-.35.6a.48.48 0 0 1-.63-.37 8 8 0 0 1 0-2.68.5.5 0 0 1 .63-.36m14.52 0c.28-.1.58.07.63.36a8 8 0 0 1 0 2.68.5.5 0 0 1-.63.36.53.53 0 0 1-.35-.6 7 7 0 0 0 0-2.2.53.53 0 0 1 .35-.6M6.45 2.83c.26-.13.57.02.66.3a.5.5 0 0 1-.28.62 7 7 0 0 0-3.08 3.08.53.53 0 0 1-.63.28.5.5 0 0 1-.29-.66 8 8 0 0 1 3.62-3.62m6.44.3c.1-.28.4-.43.66-.3a8 8 0 0 1 3.62 3.61.48.48 0 0 1-.3.67.53.53 0 0 1-.63-.28 7 7 0 0 0-3.07-3.08.53.53 0 0 1-.28-.63M10 2a8 8 0 0 1 1.34.11c.29.05.45.35.36.63a.53.53 0 0 1-.6.35 7 7 0 0 0-2.2 0 .53.53 0 0 1-.6-.35.5.5 0 0 1 .36-.63A8 8 0 0 1 10 2"
]);
const $f52f593d43f17bc8$export$95940bb65144d675 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleConcentricDashesRegular', "1em", [
    "M11.1 16.91c.26-.04.52.1.6.35.1.28-.07.58-.36.63a8 8 0 0 1-2.68 0 .5.5 0 0 1-.36-.63c.08-.25.33-.4.6-.35a7 7 0 0 0 2.2 0m-7.98-4.02c.25-.08.52.04.63.27a7 7 0 0 0 3.08 3.08c.24.12.36.39.28.64a.5.5 0 0 1-.66.29 8 8 0 0 1-3.62-3.62.5.5 0 0 1 .3-.66m13.12.27a.53.53 0 0 1 .64-.27c.27.1.42.4.29.66a8 8 0 0 1-3.62 3.62.5.5 0 0 1-.66-.3.53.53 0 0 1 .27-.63 7 7 0 0 0 3.08-3.07M10 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2.74 8.3c.25.08.39.33.35.59a7 7 0 0 0 0 2.22c.04.26-.1.51-.35.6a.48.48 0 0 1-.63-.37 8 8 0 0 1 0-2.68.5.5 0 0 1 .63-.36m14.52 0c.28-.1.58.07.63.36a8 8 0 0 1 0 2.68.5.5 0 0 1-.63.36.53.53 0 0 1-.35-.6 7 7 0 0 0 0-2.2.53.53 0 0 1 .35-.6M6.45 2.83c.26-.13.57.02.66.3a.5.5 0 0 1-.28.62 7 7 0 0 0-3.08 3.08.53.53 0 0 1-.63.28.5.5 0 0 1-.29-.66 8 8 0 0 1 3.62-3.62m6.44.3c.1-.28.4-.43.66-.3a8 8 0 0 1 3.62 3.61.48.48 0 0 1-.3.67.53.53 0 0 1-.63-.28 7 7 0 0 0-3.07-3.08.53.53 0 0 1-.28-.63M10 2a8 8 0 0 1 1.34.11c.29.05.45.35.36.63a.53.53 0 0 1-.6.35 7 7 0 0 0-2.2 0 .53.53 0 0 1-.6-.35.5.5 0 0 1 .36-.63A8 8 0 0 1 10 2"
]);
const $f52f593d43f17bc8$export$a84b8fdd12acf609 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleHintCheckmarkFilled', "1em", [
    "M4.2 2.86a.54.54 0 0 1-.69-.05c-.2-.21-.2-.56.05-.73q1.07-.75 2.4-.99c.29-.05.54.18.54.48 0 .26-.2.47-.45.52q-1.02.2-1.85.77m3.3-1.3c0-.29.25-.52.54-.47q1.34.24 2.4 1c.24.16.25.5.04.72a.54.54 0 0 1-.68.05 5 5 0 0 0-1.85-.77.54.54 0 0 1-.45-.52M12.9 6v-.04q-.25-1.34-1-2.4c-.17-.24-.5-.26-.72-.05a.54.54 0 0 0-.05.7 5 5 0 0 1 .78 1.87q.48-.08 1-.08M6 12.92l-.04-.01q-1.33-.24-2.4-1c-.24-.16-.26-.5-.05-.72.18-.18.47-.2.69-.05a5 5 0 0 0 1.88.78q-.08.48-.08 1M2.85 4.2a.54.54 0 0 0-.05-.69c-.2-.2-.55-.2-.72.05q-.75 1.07-1 2.4c-.04.29.2.54.49.54.26 0 .47-.2.52-.45q.2-1.02.76-1.85m0 5.6c.15.21.14.5-.05.69-.2.2-.55.2-.72-.05q-.75-1.06-1-2.4c-.04-.29.2-.54.49-.54.26 0 .47.2.52.45q.2 1.01.76 1.85M13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12m2.85-7.15-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l1.15 1.14 2.65-2.64a.5.5 0 0 1 .7.7"
]);
const $f52f593d43f17bc8$export$b02043ea8aee1ee5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleHintCheckmarkRegular', "1em", [
    "m12.9 5.96.01.04q-.5 0-1 .08v-.03q-.2-1.02-.77-1.85a.54.54 0 0 1 .05-.69c.21-.2.55-.2.72.05q.76 1.07 1 2.4M5.97 12.9H6q0-.5.08-1h-.03q-1.02-.2-1.85-.77a.54.54 0 0 0-.69.05c-.2.21-.2.56.05.73q1.07.75 2.4.99M7.5 1.57c0-.3.25-.53.54-.48q1.34.24 2.4 1c.24.16.25.5.04.72a.54.54 0 0 1-.68.05 5 5 0 0 0-1.85-.77.54.54 0 0 1-.45-.52M3.5 2.8c.18.18.47.2.69.05a5 5 0 0 1 1.85-.77.54.54 0 0 0 .45-.52c0-.3-.25-.53-.54-.48q-1.33.24-2.4 1c-.24.16-.26.5-.05.72m-.66 1.4a.54.54 0 0 0-.05-.7c-.2-.2-.55-.2-.72.05q-.75 1.07-1 2.4c-.04.29.2.54.49.54.26 0 .47-.2.52-.45q.2-1.02.76-1.85m-.05 6.28c.19-.19.2-.48.05-.7a5 5 0 0 1-.76-1.84.54.54 0 0 0-.52-.45c-.3 0-.53.25-.48.54q.24 1.33 1 2.4c.16.24.5.25.71.05m13.05.66c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l1.15 1.14 2.65-2.64c.2-.2.5-.2.7 0M19 13a6 6 0 1 1-12 0 6 6 0 0 1 12 0M8 13a5 5 0 1 0 10 0 5 5 0 0 0-10 0"
]);
const $f52f593d43f17bc8$export$2ee60438047b54fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleSubtractCheckmarkFilled', "1em", [
    "M12.92 6A7 7 0 0 0 6 12.92 6 6 0 1 1 12.92 6m-3.8 0H4.5a.5.5 0 0 0 0 1h3.2q.67-.58 1.42-1M19 13a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-3.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $f52f593d43f17bc8$export$6e1d740c54fe4f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleMultipleSubtractCheckmarkRegular', "1em", [
    "M7 2a5 5 0 0 1 4.92 4.08q.49-.08 1-.08A6 6 0 1 0 6 12.92q0-.51.08-1A5 5 0 0 1 7 2M4.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm11.35 5.85a.5.5 0 0 0-.7-.7l-2.65 2.64-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-1a5 5 0 1 1 0-10 5 5 0 0 1 0 10"
]);
const $f52f593d43f17bc8$export$89d44e4be4ccccf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleOffFilled', "1em", [
    "m15.3 16 1.85 1.85a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7L4 4.71A8 8 0 0 0 15.3 16m2.7-6c0 1.67-.51 3.22-1.38 4.5L5.5 3.38A8 8 0 0 1 18 10"
]);
const $f52f593d43f17bc8$export$f388dc179b8e9e78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleOffRegular', "1em", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7m10.58 10.6L4.71 5.41a7 7 0 0 0 9.87 9.87M17 10c0 1.39-.4 2.69-1.1 3.77l.72.73A8 8 0 0 0 5.5 3.39l.72.71A7 7 0 0 1 17 10"
]);
const $f52f593d43f17bc8$export$13a5c52e35099811 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleShadowFilled', "1em", [
    "M16 15.3q.38-.44.69-.9l-3.3-3.3a.5.5 0 0 1 .71-.7l3.1 3.1q.27-.55.45-1.15L14.4 9.1a.5.5 0 0 1 .7-.7l2.81 2.8a8 8 0 0 0 .08-1.5l-3.34-3.35a.5.5 0 0 1 .7-.7l2.41 2.4a8 8 0 1 0-9.7 9.71l-2.41-2.4a.5.5 0 0 1 .7-.71l3.35 3.34a8 8 0 0 0 1.5-.08l-2.8-2.8a.5.5 0 0 1 .7-.71l3.25 3.25q.6-.18 1.14-.45l-3.1-3.1a.5.5 0 0 1 .71-.7l3.3 3.29q.46-.31.9-.7l-3.15-3.14a.5.5 0 0 1 .7-.7z"
]);
const $f52f593d43f17bc8$export$cb03f8cc1db79af8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleShadowRegular', "1em", [
    "M10.29 17a7 7 0 0 1-1.73-.15l-2.2-2.2a.5.5 0 1 0-.72.7l.47.47a7 7 0 1 1 9.72-9.7l-.48-.47a.5.5 0 0 0-.7.7l2.2 2.21A7 7 0 0 1 17 10.3l-1.89-1.9a.5.5 0 0 0-.7.71l2.43 2.44q-.14.62-.39 1.2L14.1 10.4a.5.5 0 0 0-.7.7l2.56 2.57q-.3.48-.67.91l-2.44-2.43a.5.5 0 0 0-.7.7l2.43 2.44q-.42.37-.91.67L11.1 13.4a.5.5 0 0 0-.7.7l2.34 2.35q-.59.24-1.2.38L9.1 14.4a.5.5 0 1 0-.7.7zM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
]);
const $f52f593d43f17bc8$export$cca891babfcab9a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleSmallFilled', "1em", [
    "M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
]);
const $f52f593d43f17bc8$export$bac1f6f54addcc0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleSmallRegular', "1em", [
    "M10 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
]);
const $f52f593d43f17bc8$export$55e0d9ac6a59c2c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9z"
]);
const $f52f593d43f17bc8$export$980f168f93f0fd44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CircleSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9z"
]);
const $f52f593d43f17bc8$export$78330c200dd161c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CouchFilled', "1em", [
    "M14 4H6a2 2 0 0 0-2 2v1a3 3 0 0 1 2.83 2h6.34A3 3 0 0 1 16 7V6a2 2 0 0 0-2-2m2 4a2 2 0 0 0-1.94 1.5c-.07.27-.28.5-.56.5h-7c-.28 0-.5-.23-.56-.5A2 2 0 0 0 2 10v2c0 1.1.9 2 2 2v1.5a.5.5 0 0 0 1 0V14h10v1.5a.5.5 0 0 0 1 0V14a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2"
]);
const $f52f593d43f17bc8$export$38e1e9429347c812 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CouchRegular', "1em", [
    "M6 4a2 2 0 0 0-2 2v1.05A2.5 2.5 0 0 0 2 9.5V12c0 1.1.9 2 2 2v1.5a.5.5 0 0 0 1 0V14h10v1.5a.5.5 0 0 0 1 0V14a2 2 0 0 0 2-2V9.5a2.5 2.5 0 0 0-2-2.45V6a2 2 0 0 0-2-2zm9 3.05A2.5 2.5 0 0 0 13.05 9h-6.1A2.5 2.5 0 0 0 5 7.05V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zM16 13H4a1 1 0 0 1-1-1V9.5a1.5 1.5 0 1 1 3 0c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5 1.5 1.5 0 0 1 3 0V12a1 1 0 0 1-1 1"
]);
const $f52f593d43f17bc8$export$756f01ab31100191 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CounterFilled', "1em", [
    "M6 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m3.5 9H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h5.5zM6 6a2 2 0 0 0-2 2v3a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2m6 0a2 2 0 1 0 4 0V3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-1v-5.5a.5.5 0 0 0-.92-.28v.01l-.06.07q-.07.1-.22.23c-.21.18-.52.38-.92.48a.5.5 0 0 0 .24.98q.52-.15.88-.37V16h-3.5V3H12zm3 0a1 1 0 1 1-2 0V3h2z"
]);
const $f52f593d43f17bc8$export$8c4f8465ec447712 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CounterRegular', "1em", [
    "M6 6a2 2 0 0 1 2 2v3a2 2 0 1 1-4 0V8c0-1.1.9-2 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1m10-4a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-1.99-1.8L2 14V5c0-1.1.9-2 2-2zM4 4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h5.5V4zm6.5 11H14v-3.38q-.36.22-.88.37a.5.5 0 0 1-.24-.98 2.2 2.2 0 0 0 1.2-.78.5.5 0 0 1 .92.27V15h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1v2a2 2 0 1 1-4 0V4h-1.5zM13 6a1 1 0 1 0 2 0V4h-2z"
]);
const $f52f593d43f17bc8$export$515ed08f568fb2cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CurrencyDollarEuroFilled', "1em", [
    "M5.5 2a.75.75 0 0 0-.75.75v.33A3.5 3.5 0 0 0 2 6.5v.28c0 1.47.85 2.8 2.17 3.42l.58.27v4.87a2 2 0 0 1-1.25-1.86V12.4a.75.75 0 0 0-1.5 0v1.08a3.5 3.5 0 0 0 2.75 3.42v.35a.75.75 0 0 0 1.5 0v-.35A3.5 3.5 0 0 0 9 13.48v-.27c0-1.46-.84-2.8-2.17-3.42l-.58-.27V4.64A2 2 0 0 1 7.5 6.5v1.1a.75.75 0 0 0 1.5 0V6.5a3.5 3.5 0 0 0-2.75-3.42v-.33A.75.75 0 0 0 5.5 2m-2 4.5a2 2 0 0 1 1.25-1.86v4.18A2.3 2.3 0 0 1 3.5 6.78zm2.75 8.84v-4.16a2.3 2.3 0 0 1 1.25 2.03v.27a2 2 0 0 1-1.25 1.86M12.5 10q0-.5.06-.98h1.7a.75.75 0 0 0 0-1.5h-1.38A6 6 0 0 1 13.61 6c.67-1 1.52-1.5 2.36-1.5.3 0 .63.1.86.25a.75.75 0 0 0 .84-1.24 3 3 0 0 0-1.7-.51c-1.49 0-2.75.9-3.6 2.16a8 8 0 0 0-1.05 2.36h-.57a.75.75 0 0 0 0 1.5h.3a10 10 0 0 0-.05 1h-.25a.75.75 0 1 0 0 1.5h.37a8 8 0 0 0 1.25 3.32c.85 1.26 2.11 2.16 3.6 2.16.54 0 1.2-.14 1.72-.52a.75.75 0 1 0-.87-1.22c-.21.15-.53.24-.85.24-.84 0-1.69-.5-2.36-1.5a7 7 0 0 1-.97-2.48h1.61a.75.75 0 1 0 0-1.5H12.5z"
]);
const $f52f593d43f17bc8$export$ca930b246cc29318 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CurrencyDollarEuroRegular', "1em", [
    "M5.5 2a.5.5 0 0 0-.5.5v.54c-1.7.24-3 1.7-3 3.46v.13c0 1.43.84 2.73 2.14 3.31l.86.38v5.62a2.5 2.5 0 0 1-2-2.45v-.99a.5.5 0 1 0-1 0v.99a3.5 3.5 0 0 0 3 3.46v.55a.5.5 0 0 0 1 0v-.55c1.7-.24 3-1.7 3-3.46v-.12c0-1.43-.84-2.72-2.14-3.3L6 9.66V4.06A2.5 2.5 0 0 1 8 6.5v1a.5.5 0 0 0 1 0v-1a3.5 3.5 0 0 0-3-3.46V2.5a.5.5 0 0 0-.5-.5M3 6.5c0-1.2.86-2.22 2-2.45v5.18l-.45-.2A2.6 2.6 0 0 1 3 6.63zm3 9.44v-5.17l.45.2A2.6 2.6 0 0 1 8 13.37v.12a2.5 2.5 0 0 1-2 2.45M12 10q0-.52.06-1h1.44a.5.5 0 1 0 0-1h-1.26q.33-1.34 1.01-2.3C14.02 4.6 15.03 4 16.1 4c.39 0 .81.11 1.12.31a.5.5 0 1 0 .55-.84A3 3 0 0 0 16.1 3c-1.48 0-2.76.85-3.66 2.12-.57.8-1 1.79-1.23 2.88h-.71a.5.5 0 1 0 0 1h.55a10 10 0 0 0-.05 1h-.5a.5.5 0 0 0 0 1h.55c.16 1.5.65 2.84 1.39 3.88A4.6 4.6 0 0 0 16.1 17c.54 0 1.17-.13 1.68-.48a.5.5 0 0 0-.56-.82c-.3.2-.72.3-1.12.3-1.07 0-2.08-.6-2.85-1.7a7 7 0 0 1-1.2-3.3h1.45a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$926c440259047b14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CurrencyDollarRupeeFilled', "1em", [
    "M6.25 2.75a.75.75 0 1 0-1.5 0v.33A3.5 3.5 0 0 0 2 6.5v.28c0 1.47.85 2.8 2.17 3.42l.58.27v4.87a2 2 0 0 1-1.25-1.86V12.4a.75.75 0 0 0-1.5 0v1.08a3.5 3.5 0 0 0 2.75 3.42v.35a.75.75 0 0 0 1.5 0v-.35A3.5 3.5 0 0 0 9 13.48v-.27c0-1.46-.84-2.8-2.17-3.42l-.58-.27V4.64A2 2 0 0 1 7.5 6.5v1.1a.75.75 0 0 0 1.5 0V6.5a3.5 3.5 0 0 0-2.75-3.42zm-1.5 1.9v4.17A2.3 2.3 0 0 1 3.5 6.78V6.5a2 2 0 0 1 1.25-1.86m1.5 6.53a2.3 2.3 0 0 1 1.25 2.03v.27a2 2 0 0 1-1.25 1.86zM10.75 3a.75.75 0 0 0 0 1.5h2.75c.88 0 1.65.5 2.02 1.25h-4.77a.75.75 0 0 0 0 1.5h4.94A2.25 2.25 0 0 1 13.5 9h-2.75a.75.75 0 0 0-.57 1.24l6.5 7.5a.75.75 0 1 0 1.14-.98l-5.43-6.26h1.11c1.9 0 3.47-1.42 3.72-3.25h.03a.75.75 0 0 0 0-1.5h-.13a4 4 0 0 0-.62-1.25h.75a.75.75 0 0 0 0-1.5z"
]);
const $f52f593d43f17bc8$export$f9d671f0a843f098 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CurrencyDollarRupeeRegular', "1em", [
    "M5.5 2c.28 0 .5.22.5.5v.54c1.7.24 3 1.7 3 3.46v1a.5.5 0 0 1-1 0v-1a2.5 2.5 0 0 0-2-2.45v5.63l.86.38A3.6 3.6 0 0 1 9 13.36v.13a3.5 3.5 0 0 1-3 3.46v.55a.5.5 0 0 1-1 0v-.55a3.5 3.5 0 0 1-3-3.46v-.99a.5.5 0 1 1 1 0v.99a2.5 2.5 0 0 0 2 2.45v-5.62l-.86-.38A3.6 3.6 0 0 1 2 6.63V6.5a3.5 3.5 0 0 1 3-3.46V2.5c0-.28.22-.5.5-.5M3 6.5v.13c0 1.03.6 1.97 1.55 2.4l.45.2V4.05A2.5 2.5 0 0 0 3 6.5m3 9.44a2.5 2.5 0 0 0 2-2.45v-.12c0-1.04-.6-1.97-1.55-2.4l-.45-.2zM10 3.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0-3c0-.28.22-.5.5-.5h3a3.5 3.5 0 1 1 0 7h-1.9l6.28 7.17a.5.5 0 0 1-.76.66l-7-8A.5.5 0 0 1 10.5 9h3a2.5 2.5 0 0 0 0-5h-3a.5.5 0 0 1-.5-.5"
]);
const $f52f593d43f17bc8$export$77ba62693b422436 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorFilled', "1em", [
    "M6.64 2.29A1 1 0 0 0 5 3.06v14a1 1 0 0 0 1.76.65l3.52-4.07c.28-.33.7-.52 1.13-.52h5.6a1 1 0 0 0 .63-1.77z"
]);
const $f52f593d43f17bc8$export$c583546e867969c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorRegular', "1em", [
    "M5 3.06a1 1 0 0 1 1.64-.77l11 9.06a1 1 0 0 1-.63 1.77h-5.6c-.43 0-.85.19-1.13.52L6.76 17.7A1 1 0 0 1 5 17.06zm12 9.06L6 3.06v14l3.52-4.08a2.5 2.5 0 0 1 1.9-.86z"
]);
const $f52f593d43f17bc8$export$ab1c16047d25e28c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorClickFilled', "1em", [
    "M7.5 2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5M3.61 3.61c.2-.2.51-.2.7 0l1.42 1.42a.5.5 0 1 1-.7.7L3.6 4.32a.5.5 0 0 1 0-.7m7.78 0c.2.2.2.51 0 .7L9.97 5.74a.5.5 0 1 1-.7-.7l1.41-1.42c.2-.2.51-.2.7 0M2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m5.5.53v9.26c0 .45.54.67.85.36l2.56-2.56a2 2 0 0 1 1.42-.59h3.23a.5.5 0 0 0 .31-.9L8.31 7.65a.5.5 0 0 0-.81.4"
]);
const $f52f593d43f17bc8$export$f8bfe40444405d03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorClickRegular', "1em", [
    "M7.5 2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5M3.61 3.61c.2-.2.51-.2.7 0l1.42 1.42a.5.5 0 1 1-.7.7L3.6 4.32a.5.5 0 0 1 0-.7m7.78 0c.2.2.2.51 0 .7L9.97 5.74a.5.5 0 1 1-.7-.7l1.41-1.42c.2-.2.51-.2.7 0M2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m6.64-.2A1 1 0 0 0 7 8.07v9.1a1 1 0 0 0 1.75.66l2.03-2.32c.28-.32.7-.51 1.13-.51h3.2a1 1 0 0 0 .65-1.77zM8 17.17v-9.1L15.12 14H11.9c-.72 0-1.4.31-1.88.85z"
]);
const $f52f593d43f17bc8$export$54aa26f2428c151 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorHoverFilled', "1em", [
    "M4 4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h5v-4.5a1.5 1.5 0 0 1 2.56-1.06l5 5q.16.17.28.38A2 2 0 0 0 18 13V6a2 2 0 0 0-2-2zm6.85 6.15a.5.5 0 0 0-.85.35v7a.5.5 0 0 0 .91.29l1.57-2.25 2.94.45a.5.5 0 0 0 .43-.84zM11 15.9v-4.2l3.07 3.06-1.74-.26a.5.5 0 0 0-.49.2z"
]);
const $f52f593d43f17bc8$export$7ca862a24e8566c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorHoverRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-1.16 1.82 2 2 0 0 0-.28-.38l-.45-.45A1 1 0 0 0 17 13V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5v1H4a2 2 0 0 1-2-2zm8.85 4.15a.5.5 0 0 0-.85.35v7a.5.5 0 0 0 .91.29l1.57-2.25 2.94.45a.5.5 0 0 0 .43-.84zM11 15.9v-4.2l3.07 3.06-1.74-.26a.5.5 0 0 0-.49.2z"
]);
const $f52f593d43f17bc8$export$ed50b38bb6292726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorHoverOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.39 4.1A2 2 0 0 0 2 6v7c0 1.1.9 2 2 2h5v-4.5q0-.35.15-.65l.85.86v6.79a.5.5 0 0 0 .91.29l1.57-2.25 2.78.43 1.89 1.88a.5.5 0 0 0 .7-.7l-8-8zm11.22 12.62-1.74-.26a.5.5 0 0 0-.49.2l-.84 1.2v-4.2zm2.84.01A2 2 0 0 0 18 13V6a2 2 0 0 0-2-2H6.12z"
]);
const $f52f593d43f17bc8$export$8c86332fafbccb49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorHoverOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.39 4.1A2 2 0 0 0 2 6v7c0 1.1.9 2 2 2h5v-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.3l5.7 5.7v6.8a.5.5 0 0 0 .91.29l1.57-2.25 2.78.43 1.89 1.88a.5.5 0 0 0 .7-.7zm11.22 12.62-1.74-.26a.5.5 0 0 0-.49.2l-.84 1.2v-4.2zm2.84.01A2 2 0 0 0 18 13V6a2 2 0 0 0-2-2H6.12l1 1H16a1 1 0 0 1 1 1v7a1 1 0 0 1-.89 1z"
]);
const $f52f593d43f17bc8$export$ea0f5c330748170c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorProhibitedFilled', "1em", [
    "M10 5.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1M14.5 9c-.79 0-1.51-.26-2.1-.7l4.9-4.9q.68.9.7 2.1A3.5 3.5 0 0 1 14.5 9m0 2a5.5 5.5 0 0 1-5.38-6.66L6.64 2.29A1 1 0 0 0 5 3.06v14a1 1 0 0 0 1.76.65l3.52-4.07c.28-.33.7-.52 1.13-.52h5.6a1 1 0 0 0 .63-1.77l-.97-.8q-1 .45-2.17.45"
]);
const $f52f593d43f17bc8$export$2b192ff86645a93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CursorProhibitedRegular', "1em", [
    "M10 5.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1M14.5 9c-.79 0-1.51-.26-2.1-.7l4.9-4.9q.68.9.7 2.1A3.5 3.5 0 0 1 14.5 9m2.5 3.12-1.47-1.22q.6-.1 1.14-.35l.97.8a1 1 0 0 1-.63 1.77h-5.6c-.43 0-.85.2-1.13.52l-3.52 4.07A1 1 0 0 1 5 17.06v-14a1 1 0 0 1 1.64-.77l2.48 2.05Q9 4.9 9 5.5v.03L6 3.06v14l3.52-4.07a2.5 2.5 0 0 1 1.9-.87z"
]);
const $f52f593d43f17bc8$export$10a5b68cbe574ec4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DecimalArrowLeftFilled', "1em", [
    "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3m-1 2.5a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0zM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12.5-9A2.5 2.5 0 0 0 13 5.5v3.7q.72-.2 1.5-.2V5.5a1 1 0 1 1 2 0v3.87q.77.3 1.4.81.1-.33.1-.68v-4A2.5 2.5 0 0 0 15.5 3m-1 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $f52f593d43f17bc8$export$c751fdfbc90cf988 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DecimalArrowLeftRegular', "1em", [
    "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3M7 5.5a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 0 1-3 0zM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12.5-9A2.5 2.5 0 0 0 13 5.5v3.7q.49-.13 1-.18V5.5a1.5 1.5 0 0 1 3 0v4.1q.48.24.9.58.1-.33.1-.68v-4A2.5 2.5 0 0 0 15.5 3m-1 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7z"
]);
const $f52f593d43f17bc8$export$665e51ded1d8b4f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DecimalArrowRightFilled', "1em", [
    "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3m-1 2.5a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0zM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12.5-9A2.5 2.5 0 0 0 13 5.5v3.7q.72-.2 1.5-.2V5.5a1 1 0 1 1 2 0v3.87q.77.3 1.4.81.1-.33.1-.68v-4A2.5 2.5 0 0 0 15.5 3m-1 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $f52f593d43f17bc8$export$62db55c1b19f786 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DecimalArrowRightRegular', "1em", [
    "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3M7 5.5a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 0 1-3 0zM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12.5-9A2.5 2.5 0 0 0 13 5.5v3.7q.49-.13 1-.18V5.5a1.5 1.5 0 0 1 3 0v4.1q.48.24.9.58.1-.33.1-.68v-4A2.5 2.5 0 0 0 15.5 3m-1 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $f52f593d43f17bc8$export$a089271fdbc82fd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenFilled', "1em", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5V4zm2 9.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5M10.5 4v12H16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm2 9h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1"
]);
const $f52f593d43f17bc8$export$b795c44b7238900f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenRegular', "1em", [
    "M6 13.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM4 4h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m5.5 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5zm1 10H16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-5.5z"
]);
const $f52f593d43f17bc8$export$d297512a93f96a7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenAddFilled', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 0 1-2 2h-5.5V9.27a5.5 5.5 0 0 0 4 1.73m-5-3.2A6 6 0 0 1 9.02 6H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$1aacff9fc195c7f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenAddRegular', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zM17 16v-5.6q.54-.27 1-.66V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5.02q.05.51.19 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.8q.39.82 1 1.47V17H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$6049c8de93484728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenArrowRightFilled', "1em", [
    "M14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85A.5.5 0 0 0 17 5.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 5H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7zM14.5 11c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 0 1-2 2h-5.5V9.27a5.5 5.5 0 0 0 4 1.73m-5-3.2A6 6 0 0 1 9.02 6H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$ba63253973c786a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenArrowRightRegular', "1em", [
    "M14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85A.5.5 0 0 0 17 5.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 5H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7zM17 16v-5.6q.54-.27 1-.66V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5.02q.05.51.19 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.8q.39.82 1 1.47V17H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$c0a4873b1b0bf552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenArrowUpFilled', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 4.71V7.5a.5.5 0 0 0 1 0V4.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 14.5 3a.5.5 0 0 0-.35.14M14.5 11c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 0 1-2 2h-5.5V9.27a5.5 5.5 0 0 0 4 1.73m-5-3.2A6 6 0 0 1 9.02 6H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$dcf02b98dc837852 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenArrowUpRegular', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 4.71V7.5a.5.5 0 0 0 1 0V4.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 14.5 3a.5.5 0 0 0-.35.14M17 16v-5.6q.54-.27 1-.66V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5.02q.05.51.19 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.8q.39.82 1 1.47V17H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m7.5-.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1"
]);
const $f52f593d43f17bc8$export$13353f64dd870087 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenClockFilled', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 3a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1V3.5a.5.5 0 0 0-.5-.5m0 8c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 0 1-2 2h-5.5V9.27a5.5 5.5 0 0 0 4 1.73m-5-3.2A6 6 0 0 1 9.02 6H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$24e3be794236d228 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenClockRegular', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 3a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1V3.5a.5.5 0 0 0-.5-.5M17 16v-5.6q.54-.27 1-.66V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5.02q.05.51.19 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.8q.39.82 1 1.47V17H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$93275023e5be0206 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenClosedAlertFilled', "1em", [
    "M10.5 5a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 7zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1m-4-4.46-.97.82A1.5 1.5 0 0 0 9.5 10h1.52l.12.33A2.5 2.5 0 0 0 14 11.95V15a2 2 0 0 1-2 2H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3.5z"
]);
const $f52f593d43f17bc8$export$41817231589d81d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenClosedAlertRegular', "1em", [
    "M10.5 5a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 7zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1M6 6h3.5V5H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6a2 2 0 0 0 2-2v-3.05a3 3 0 0 1-1 0V15a1 1 0 0 1-1 1H6z"
]);
const $f52f593d43f17bc8$export$d8fae6200fb02c40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenDesktopFilled', "1em", [
    "M4 4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2v2h1a.5.5 0 0 1 0 1h-2v-6a3 3 0 0 0-3-3H4zm6 14H7.5V8H10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M4 8h2.5v10H4a2 2 0 0 1-2-2v-6c0-1.1.9-2 2-2m5.5 7a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1zm-6 .5c0 .28.22.5.5.5h.5a.5.5 0 0 0 0-1H4a.5.5 0 0 0-.5.5"
]);
const $f52f593d43f17bc8$export$ae129b933925444 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenDesktopRegular', "1em", [
    "M4 4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2v2h1a.5.5 0 0 1 0 1h-2v-4h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3H4zm-2 6c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.5V9zm6 8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H7.5v8zm-1-2h.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1m-5 .5c0-.28.22-.5.5-.5H5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5"
]);
const $f52f593d43f17bc8$export$cf93d49a92ec503c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenDismissFilled', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L15.21 5.5zM14.5 11c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 0 1-2 2h-5.5V9.27a5.5 5.5 0 0 0 4 1.73m-5-3.2A6 6 0 0 1 9.02 6H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$e179b988d53f3f61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenDismissRegular', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L15.21 5.5zM17 16v-5.6q.54-.27 1-.66V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5.02q.05.51.19 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.8q.39.82 1 1.47V17H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$2fabde97e9d173a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenGroupFilled', "1em", [
    "M10.5 16H16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-5.5zm-1-12H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5z"
]);
const $f52f593d43f17bc8$export$efa7aa9479ac0e27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenGroupRegular', "1em", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h5.5v10H4a1 1 0 0 1-1-1zm7.5 9V5H16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1z"
]);
const $f52f593d43f17bc8$export$11cf160518663f51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenHeaderFilled', "1em", [
    "M16 16h-5.5V8H18v6a2 2 0 0 1-2 2m2-9V6a2 2 0 0 0-2-2h-5.5v3zM9.5 7V4H4a2 2 0 0 0-2 2v1zM2 8v6c0 1.1.9 2 2 2h5.5V8z"
]);
const $f52f593d43f17bc8$export$b4e5213eac97f342 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenHeaderRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7.5 9V7H3v7a1 1 0 0 0 1 1zm1-8v8H16a1 1 0 0 0 1-1V7z"
]);
const $f52f593d43f17bc8$export$c08b0a62a06c46ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenLockFilled', "1em", [
    "M14.5 3v1H14a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-.5V3a2 2 0 1 0-4 0m1 1V3a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M12 9V6h-1.5v12H16a2 2 0 0 0 2-2v-5h-4a2 2 0 0 1-2-2M4 6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5V6zm2 9.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $f52f593d43f17bc8$export$b7f597620a273c53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenLockRegular', "1em", [
    "M14.5 3v1H14a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-.5V3a2 2 0 1 0-4 0m1 1V3a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M4 6h8v1h-1.5v10H16a1 1 0 0 0 1-1v-5h1v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2m2 9.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-3-8H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5z"
]);
const $f52f593d43f17bc8$export$6a04a5b8e81fe264 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenMirrorFilled', "1em", [
    "M10.5 16H16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-5.5zm-1-12H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM5.75 8q.28.01.43.25l1.75 3a.5.5 0 0 1-.43.75H4a.5.5 0 0 1-.43-.75l1.75-3A.5.5 0 0 1 5.75 8m8.93.25 1.75 3A.5.5 0 0 1 16 12h-3.5a.5.5 0 0 1-.43-.75l1.75-3a.5.5 0 0 1 .86 0"
]);
const $f52f593d43f17bc8$export$ede6dd6399c98185 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenMirrorRegular', "1em", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h5.5v10H4a1 1 0 0 1-1-1zm7.5 9V5H16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zM6.25 8q.28.01.43.25l1.75 3A.5.5 0 0 1 8 12H4.5a.5.5 0 0 1-.43-.75l1.75-3A.5.5 0 0 1 6.25 8m.88 3-.88-1.5-.88 1.5zm7.05-2.75 1.75 3a.5.5 0 0 1-.43.75H12a.5.5 0 0 1-.43-.75l1.75-3a.5.5 0 0 1 .86 0m.45 2.75-.88-1.5-.88 1.5z"
]);
const $f52f593d43f17bc8$export$6a8900d021823bc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenPaginationFilled', "1em", [
    "M16 16h-5.5V4H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2M4 4h5.5v12H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m8.5 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $f52f593d43f17bc8$export$43640c58c9533642 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenPaginationRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V5zm12 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-5.5v10zm-4.5-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $f52f593d43f17bc8$export$fbd3969be0ce943a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenSettingsFilled', "1em", [
    "M12.07 2.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 8.65l-.13.43q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.02l-.35-.08A2 2 0 0 1 17 2.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zM14.5 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 4.5c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 0 1-2 2h-5.5V9.27a5.5 5.5 0 0 0 4 1.73m-5-3.2A6 6 0 0 1 9.02 6H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 1 0 0-1z"
]);
const $f52f593d43f17bc8$export$45c7aab232212c97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenSettingsRegular', "1em", [
    "M12.07 2.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 8.65l-.13.43q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.02l-.35-.08A2 2 0 0 1 17 2.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zM14.5 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2M17 16v-5.6q.54-.27 1-.66V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5.02q.05.51.19 1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.8q.39.82 1 1.47V17H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 1 0 0-1z"
]);
const $f52f593d43f17bc8$export$4505971e5e7c9e3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenSpanFilled', "1em", [
    "M16 16h-5.5v-5.5h3.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7l1.14 1.15H10.5V4H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2M9.5 9.5V4H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5v-5.5H5.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L5.71 9.5z"
]);
const $f52f593d43f17bc8$export$d720725457ca6a5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenSpanRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5v-3.5h1V15H16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-5.5v3.5h-1V5zm2.85 3.35a.5.5 0 1 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L5.71 10.5h8.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7l1.14 1.15H5.71z"
]);
const $f52f593d43f17bc8$export$4133902d86c0f97d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenSpeakerFilled', "1em", [
    "M17.65 2.2q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 1 1 .8-.6m-3.96-.16c.19.08.31.26.31.46v6a.5.5 0 0 1-.85.35L11.29 7h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m2.53 1.93q-.16-.46-.27-.7a.5.5 0 1 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22q0-.76-.28-1.53m.13 5.73a1.5 1.5 0 0 1-.53-.74 1.5 1.5 0 0 1-.87-.07 1.5 1.5 0 0 1-2.51.67L10.88 8h-.38v8H16a2 2 0 0 0 2-2V9.8c-.5.29-1.15.27-1.65-.1M9.5 16V7.62A1.5 1.5 0 0 1 9 6.5v-2q0-.27.09-.5H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zM6 13.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1"
]);
const $f52f593d43f17bc8$export$5b7498b7a0590d1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenSpeakerRegular', "1em", [
    "M17.65 2.2q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 1 1 .8-.6m-3.96-.16c.19.08.31.26.31.46v6a.5.5 0 0 1-.85.35L11.29 7h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m2.53 1.93q-.16-.46-.27-.7a.5.5 0 1 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22q0-.76-.28-1.53M17 14V9.98q.53.09 1-.18V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h5.09a2 2 0 0 0-.09.5V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V7.62q.42.37 1 .38v7H16a1 1 0 0 0 1-1m-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m6.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$f3a473b99ece35ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenStatusBarFilled', "1em", [
    "M16 16h-5.5V4H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2M4 4h5.5v12H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m8.5 2a.5.5 0 0 0 0 1H16a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$7048e2821842463c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenStatusBarRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V5zm12 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-5.5v10zm-4-9a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1z"
]);
const $f52f593d43f17bc8$export$8175b6343a19f66a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenTabletFilled', "1em", [
    "M4 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3v-2h.5a.5.5 0 0 0 0-1H13V9a3 3 0 0 0-3-3H4zm6 12H7.5V7H10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M4 7h2.5v10H4a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2m5.5 7a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1zm-6 .5c0 .28.22.5.5.5h.5a.5.5 0 0 0 0-1H4a.5.5 0 0 0-.5.5"
]);
const $f52f593d43f17bc8$export$b4bc601cc46e62a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenTabletRegular', "1em", [
    "M4 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3v-1h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1H4zm9 6h.5a.5.5 0 0 0 0-1H13zM2 9c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.5V8zm6 8a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H7.5v8zm-1-2a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1zm-5 .5c0-.28.22-.5.5-.5H5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5"
]);
const $f52f593d43f17bc8$export$cf1c253455b1d6c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenUpdateFilled', "1em", [
    "M16 16h-5.5V4H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2M4 4h5.5v12H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2m12.85 7.85a.5.5 0 0 0-.7-.7L15 12.29V6.5a.5.5 0 0 0-1 0v5.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
]);
const $f52f593d43f17bc8$export$9d63102f6115eb2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenUpdateRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5V5zm12 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-5.5v10zm-.15-3.15a.5.5 0 0 0-.7-.7L14 12.29V6.5a.5.5 0 0 0-1 0v5.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0z"
]);
const $f52f593d43f17bc8$export$8411123bd5c1b759 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenVerticalScrollFilled', "1em", [
    "M10.5 16H16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-5.5zm-1-12H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.5zm7.35 7.15c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 1.65-1.64c.2-.2.5-.2.7 0m0-3a.5.5 0 0 1-.7.7L14.5 7.21l-1.65 1.64a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0z"
]);
const $f52f593d43f17bc8$export$cf92ea56c6abf26e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenVerticalScrollRegular', "1em", [
    "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h5.5v10H4a1 1 0 0 1-1-1zm7.5 9V5H16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm5.35-3.85c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 1.65-1.64c.2-.2.5-.2.7 0m0-3a.5.5 0 0 1-.7.7L13.5 7.21l-1.65 1.64a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0z"
]);
const $f52f593d43f17bc8$export$1af321811b238dd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenVibrateFilled', "1em", [
    "M10.5 15H13a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2.5zm-1-10H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h2.5zm2.5 7.5c0-.28.22-.5.5-.5h.5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5M7 12h.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1M1.88 6.51a.5.5 0 0 1 .6.37l.41 1.64q.14.54-.1 1.03l-.62 1.23a.5.5 0 0 0 0 .44l.78 1.56a.5.5 0 1 1-.9.44l-.77-1.55a1.5 1.5 0 0 1 0-1.34l.6-1.22a.5.5 0 0 0 .04-.35l-.4-1.64a.5.5 0 0 1 .36-.6m16.6.37a.5.5 0 0 0-.97.24l.41 1.64a.5.5 0 0 1-.03.35l-.61 1.22a1.5 1.5 0 0 0 0 1.34l.77 1.55a.5.5 0 1 0 .9-.44l-.78-1.56a.5.5 0 0 1 0-.44l.61-1.23q.24-.5.11-1.03z"
]);
const $f52f593d43f17bc8$export$571e682f76fd7adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DualScreenVibrateRegular', "1em", [
    "M7 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM6 7a1 1 0 0 1 1-1h2.5v8H7a1 1 0 0 1-1-1zm4.5 7V6H13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm1-1.5c0-.28.22-.5.5-.5h.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m-4-.5a.5.5 0 0 0 0 1H8a.5.5 0 0 0 0-1zM1.88 6.51a.5.5 0 0 1 .6.37l.41 1.64q.14.54-.1 1.03l-.62 1.23a.5.5 0 0 0 0 .44l.78 1.56a.5.5 0 1 1-.9.44l-.77-1.55a1.5 1.5 0 0 1 0-1.34l.6-1.22a.5.5 0 0 0 .04-.35l-.4-1.64a.5.5 0 0 1 .36-.6m16.6.37a.5.5 0 0 0-.97.24l.41 1.64a.5.5 0 0 1-.03.35l-.61 1.22a1.5 1.5 0 0 0 0 1.34l.77 1.55a.5.5 0 1 0 .9-.44l-.78-1.56a.5.5 0 0 1 0-.44l.61-1.23q.24-.5.11-1.03z"
]);
const $f52f593d43f17bc8$export$4bada93d6b89b32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontDecreaseFilled', "1em", [
    "M14.24 2.18a.75.75 0 0 0-.98 1.14l1.75 1.5c.28.24.7.24.98 0l1.75-1.5a.75.75 0 1 0-.98-1.14L15.5 3.26zM10 4c-.3 0-.58.19-.7.47l-4.25 10.5a.75.75 0 1 0 1.4.56L7.87 12h4.26l1.42 3.53a.75.75 0 1 0 1.4-.56L10.7 4.47A.8.8 0 0 0 10 4m0 2.75 1.52 3.75H8.48z"
]);
const $f52f593d43f17bc8$export$4d68aeb0aba2d58a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontDecreaseRegular', "1em", [
    "M13.15 2.15c.2-.2.5-.2.7 0l1.65 1.64 1.65-1.64a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7M10 4c.2 0 .39.12.46.31l4.5 11a.5.5 0 1 1-.92.38l-1.54-3.76V12h-5v-.07L5.96 15.7a.5.5 0 1 1-.92-.38l4.5-11A.5.5 0 0 1 10 4m-2.12 7h4.24L10 5.82z"
]);
const $f52f593d43f17bc8$export$da67468e7d066c3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontIncreaseFilled', "1em", [
    "M14.24 4.82a.75.75 0 0 1-.98-1.14l1.75-1.5c.28-.24.7-.24.98 0l1.75 1.5a.75.75 0 1 1-.98 1.14L15.5 3.74zM10 3.75c-.3 0-.58.18-.7.47l-4.5 11a.75.75 0 0 0 1.4.56l1.44-3.53h4.72l1.45 3.53a.75.75 0 1 0 1.38-.56l-4.5-11a.8.8 0 0 0-.69-.47m0 2.73 1.75 4.27h-3.5z"
]);
const $f52f593d43f17bc8$export$9b783e5a90bf667 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontIncreaseRegular', "1em", [
    "M13.85 4.85a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L15.5 3.21zM10 4a.5.5 0 0 0-.46.31l-4.5 11a.5.5 0 1 0 .92.38l1.54-3.76V12h5v-.07l1.54 3.76a.5.5 0 1 0 .92-.38l-4.5-11A.5.5 0 0 0 10 4m0 1.82L12.12 11H7.88z"
]);
const $f52f593d43f17bc8$export$3fe9f85a517ce74c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontSpaceTrackingInFilled', "1em", [
    "M7.7 2.48a.75.75 0 0 0-1.4 0l-3.25 8.5a.75.75 0 0 0 1.4.53l.77-2.01h3.56l.77 2.01a.75.75 0 0 0 1.4-.53zM8.2 8H5.8L7 4.85zm-1.46 5.19a.75.75 0 1 0-.99 1.12l.5.44h-2.5a.75.75 0 0 0 0 1.5h2.5l-.5.44a.75.75 0 1 0 1 1.12l2-1.75a.75.75 0 0 0 0-1.13zM13 12c.31 0 .59-.2.7-.48l3.25-8.5a.75.75 0 1 0-1.4-.53L13 9.15 10.45 2.5a.75.75 0 0 0-1.4.53l3.25 8.5c.11.29.39.48.7.48m1.31 5.74a.75.75 0 0 1-1.05.07l-2-1.74a.75.75 0 0 1 0-1.13l2-1.75a.75.75 0 1 1 .98 1.12l-.5.44h2.51a.75.75 0 0 1 0 1.5h-2.5l.5.44c.3.27.34.74.06 1.05"
]);
const $f52f593d43f17bc8$export$ae87acdaf1b64885 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontSpaceTrackingInRegular', "1em", [
    "M13 12c.2 0 .38-.12.46-.32l3.5-9.02a.5.5 0 1 0-.93-.36L13 10.12 9.95 2.3a.5.5 0 1 0-.93.36l3.5 9.02c.08.2.27.32.47.32M7.46 2.3a.5.5 0 0 0-.93 0l-2.34 6v.03l-1.17 3a.5.5 0 1 0 .93.35L5.01 9h4l1.04 2.68a.5.5 0 1 0 .93-.36L9.83 8.37l-.04-.11zM8.61 8H5.4L7 3.86zM6.5 13.12a.5.5 0 1 0-.65.76L7.15 15H3.5a.5.5 0 0 0 0 1h3.65l-1.3 1.12a.5.5 0 1 0 .64.76l2.33-2a.5.5 0 0 0 0-.76zm7.72 4.7a.5.5 0 0 1-.7.06l-2.34-2a.5.5 0 0 1 0-.76l2.33-2a.5.5 0 1 1 .65.76L12.85 15h3.65a.5.5 0 1 1 0 1h-3.65l1.3 1.12c.21.18.24.5.06.7"
]);
const $f52f593d43f17bc8$export$99d065ab58afe614 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontSpaceTrackingOutFilled', "1em", [
    "M6 2c.31 0 .59.2.7.48l3.25 8.5a.75.75 0 0 1-1.4.53L7.78 9.5H4.22l-.77 2.01a.75.75 0 0 1-1.4-.53l3.25-8.5A.8.8 0 0 1 6 2M4.8 8h2.4L6 4.85zm9.88 5.26a.75.75 0 0 1 1.06-.07l2 1.74a.75.75 0 0 1 0 1.13l-2 1.75a.75.75 0 1 1-.99-1.12l.5-.44H4.75l.5.44a.75.75 0 1 1-1 1.12l-2-1.74a.75.75 0 0 1 0-1.13l2-1.75a.75.75 0 0 1 1 1.12l-.5.44h10.5l-.5-.44a.75.75 0 0 1-.07-1.05m.02-1.74a.75.75 0 0 1-1.4 0l-3.25-8.5a.75.75 0 1 1 1.4-.53L14 9.15l2.55-6.66a.75.75 0 1 1 1.4.53z"
]);
const $f52f593d43f17bc8$export$7c9af834dae2f5b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FontSpaceTrackingOutRegular', "1em", [
    "M14.46 11.68a.5.5 0 0 1-.93 0l-3.51-9.02a.5.5 0 1 1 .93-.36l3.04 7.82 3.04-7.82a.5.5 0 0 1 .94.36zM6 1.98c.21 0 .4.13.47.32l2.32 5.96.04.11 1.15 2.95a.5.5 0 0 1-.93.36L8 9H4l-1.04 2.68a.5.5 0 0 1-.93-.36l1.17-3V8.3l2.34-6A.5.5 0 0 1 6 1.98M4.4 8H7.6l-1.6-4.14zm10.39 5.18a.5.5 0 0 1 .7-.06l2.33 2a.5.5 0 0 1 0 .76l-2.33 2a.5.5 0 0 1-.65-.76l1.3-1.12H3.85l1.31 1.12a.5.5 0 1 1-.65.76l-2.33-2a.5.5 0 0 1 0-.76l2.33-2a.5.5 0 1 1 .65.76L3.85 15h12.3l-1.3-1.12a.5.5 0 0 1-.06-.7"
]);
const $f52f593d43f17bc8$export$eb766856c261ec89 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HatGraduationFilled', "1em", [
    "M4 14.5v-3.34l4 2.3a4 4 0 0 0 4 0l4-2.3v3.34a.5.5 0 0 1-.15.35v.01l-.03.03-.38.32A9.1 9.1 0 0 1 10 17a9 9 0 0 1-5.74-2.05l-.08-.07-.02-.03A.5.5 0 0 1 4 14.5m14.75-6.07-7.26 4.17a3 3 0 0 1-2.98 0L2 8.86v4.64a.5.5 0 0 1-1 0V8q.01-.31.26-.44L8.51 3.4a3 3 0 0 1 2.98 0l7.26 4.17a.5.5 0 0 1 0 .86"
]);
const $f52f593d43f17bc8$export$9ba7f224e47a3064 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HatGraduationRegular', "1em", [
    "M8.5 3.4a3 3 0 0 1 3 0l7.25 4.17a.5.5 0 0 1 0 .86L16 10.01v4.49a.5.5 0 0 1-.15.35v.01l-.03.03-.38.32A9.1 9.1 0 0 1 10 17a9 9 0 0 1-5.74-2.05l-.08-.07a.5.5 0 0 1-.18-.4v-4.48L2 8.86v4.64a.5.5 0 0 1-1 0V8q.01-.3.26-.44zm3 9.2a3 3 0 0 1-3 0L5 10.59v3.69l.17.14q.34.27 1 .64A8 8 0 0 0 10 16a8 8 0 0 0 5-1.72v-3.7zM11 4.27a2 2 0 0 0-2 0L2.5 8 9 11.73a2 2 0 0 0 2 0L17.5 8z"
]);
const $f52f593d43f17bc8$export$e9d5e53ed9064da4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HatGraduationAddFilled', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm-3.5 9.1 2.79-1.6a5.5 5.5 0 0 1-4.7-7.97 3 3 0 0 0-1.08.37L1.26 7.56A.5.5 0 0 0 1 8v5.5a.5.5 0 1 0 1 0V8.86l6.5 3.74a3 3 0 0 0 3 0M4 14.5v-3.34l4 2.3a4 4 0 0 0 4 0l4-2.3v3.34a.5.5 0 0 1-.15.35v.01l-.03.03-.38.32q-.4.32-1.14.73A9 9 0 0 1 10 17a9 9 0 0 1-5.74-2.04l-.08-.07-.02-.03A.5.5 0 0 1 4 14.5"
]);
const $f52f593d43f17bc8$export$139fd46765e79b25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HatGraduationAddRegular', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm0 10.78v-3.3q.51-.05 1-.19v3.71a.5.5 0 0 1-.15.35v.01l-.03.03-.38.32q-.4.32-1.14.73A9 9 0 0 1 10 17a9 9 0 0 1-5.74-2.04l-.08-.07A.5.5 0 0 1 4 14.5v-4.49L2 8.86v4.64a.5.5 0 0 1-1 0V8q.01-.3.26-.44L8.51 3.4a3 3 0 0 1 1.07-.37q-.27.55-.42 1.16L9 4.27 2.5 8 9 11.73a2 2 0 0 0 2 0l1.76-1.01q.73.24 1.53.28l-2.8 1.6a3 3 0 0 1-2.98 0L5 10.59v3.69l.17.14q.34.27 1 .64A8 8 0 0 0 10 16a8 8 0 0 0 5-1.72"
]);
const $f52f593d43f17bc8$export$725e1ba89466791f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HatGraduationSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM15.66 10q.1.03.19.11l-4.36 2.5a3 3 0 0 1-2.98 0L2 8.86v4.64a.5.5 0 1 1-1 0V8q.01-.3.26-.44L8.51 3.4a3 3 0 0 1 1.58-.4 1.4 1.4 0 0 0 .17 1.32q.26.37.71.53l1.06.35q.22.06.47.29c.11.11.2.24.3.47l.35 1.1q.13.36.52.68.22.15.45.21a1.3 1.3 0 0 0 .77 1.79zM4 14.5v-3.34l4 2.3a4 4 0 0 0 4 0l4-2.3v3.34a.5.5 0 0 1-.15.35v.01l-.03.03-.38.32q-.4.32-1.14.73A9 9 0 0 1 10 17a9 9 0 0 1-5.74-2.04l-.08-.07-.02-.03A.5.5 0 0 1 4 14.5"
]);
const $f52f593d43f17bc8$export$24730a54a23725d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HatGraduationSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.9 1.92q.08.07.12.18v4.19a.5.5 0 0 1-.15.35v.01l-.03.03-.38.32q-.4.32-1.14.73A9 9 0 0 1 10 17a9 9 0 0 1-5.74-2.04l-.08-.07A.5.5 0 0 1 4 14.5v-4.49L2 8.86v4.64a.5.5 0 0 1-1 0V8q.01-.3.26-.44L8.51 3.4a3 3 0 0 1 1.58-.4 1.4 1.4 0 0 0 0 1A2 2 0 0 0 9 4.27L2.5 8 9 11.73a2 2 0 0 0 2 0l3.66-2.1q.1.06.23.1l.77.26q.12.05.22.14m-4.39 2.47a3 3 0 0 1-2.98 0L5 10.59v3.69l.17.14q.34.27 1 .64A8 8 0 0 0 10 16a8 8 0 0 0 5-1.72v-3.7z"
]);
const $f52f593d43f17bc8$export$1434262f80c81e1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IncognitoFilled', "1em", [
    "M4.08 8.75a35 35 0 0 1 11.86 0l1.48.24a.5.5 0 1 0 .16-.98l-1.13-.19-.08-.22-1.65-3.7a1.5 1.5 0 0 0-1.37-.9h-6.7c-.6 0-1.13.35-1.37.9L3.63 7.6l-.09.23L2.42 8a.5.5 0 0 0 .16.98zM3 13.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M5.5 10a3.5 3.5 0 1 0 3.46 4h2.08a3.5 3.5 0 1 0 0-1H8.96a3.5 3.5 0 0 0-3.46-3m6.5 3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
]);
const $f52f593d43f17bc8$export$b5ff4216a22b0176 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IncognitoRegular', "1em", [
    "M6.17 4.28A.5.5 0 0 1 6.62 4h6.76q.3 0 .45.28l1.22 2.44a.5.5 0 1 0 .9-.44l-1.23-2.45A1.5 1.5 0 0 0 13.38 3H6.62a1.5 1.5 0 0 0-1.34.83L4.05 6.28a.5.5 0 0 0 .9.44zm11.25 4.71C11.47 8 8.52 8 2.58 9a.5.5 0 0 1-.16-.98C8.47 7 11.52 7 17.58 8a.5.5 0 1 1-.16.98M5.5 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2 13.5a3.5 3.5 0 0 1 6.96-.5h2.08a3.5 3.5 0 1 1 0 1H8.96A3.5 3.5 0 0 1 2 13.5M14.5 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $f52f593d43f17bc8$export$ccfce87012e58918 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MatchAppLayoutFilled', "1em", [
    "M3.5 7C2.67 7 2 7.67 2 8.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3C9 7.67 8.33 7 7.5 7zm9 0c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
]);
const $f52f593d43f17bc8$export$cf2452ef6322f5dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MatchAppLayoutRegular', "1em", [
    "M3.5 7C2.67 7 2 7.67 2 8.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3C9 7.67 8.33 7 7.5 7zM3 8.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5zM12.5 7c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM12 8.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
]);
const $f52f593d43f17bc8$export$e036328c32027716 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormatLinearFilled', "1em", [
    "M9.01 3.18c.28-.24.7-.24.98 0l1.75 1.5a.75.75 0 1 1-.98 1.14L9.5 4.74 8.24 5.82a.75.75 0 0 1-.98-1.14zm2.3 5.7c.36-.4.54-.38.56-.38q.09-.01.26.2l1.32 2.05-3.21 2.98a.75.75 0 1 0 1.02 1.1l3-2.8 1.36 2.1v.02a1.92 1.92 0 0 0 3.27.01.75.75 0 1 0-1.28-.77.4.4 0 0 1-.51.14 1 1 0 0 1-.22-.21L15.38 11l2.88-2.67a.75.75 0 0 0-1.02-1.1L14.56 9.7l-1.18-1.84-.02-.04c-.25-.34-.7-.75-1.33-.82-.68-.07-1.3.27-1.85.9a.75.75 0 1 0 1.14.98M7.68 7.86a2.1 2.1 0 0 0-1.52-.83q-.91-.1-1.92.3c-1.33.56-2.6 1.86-3.12 4.08q-.34 1.47.35 2.54A3.3 3.3 0 0 0 3.3 15.3a4.5 4.5 0 0 0 4.47-1.09.75.75 0 1 0-1.07-1.04 3 3 0 0 1-2.95.7q-.71-.23-1.02-.73a1.5 1.5 0 0 1-.23-.7c2.13.26 3.63-.3 4.54-1.22.5-.52.8-1.12.91-1.7s.04-1.2-.28-1.67m-1.7 2.31c-.49.5-1.46.99-3.17.8a3.8 3.8 0 0 1 2-2.26q.69-.26 1.17-.19c.32.04.44.16.46.18.04.06.1.25.05.55q-.08.45-.5.92"
]);
const $f52f593d43f17bc8$export$20150080701442ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormatLinearRegular', "1em", [
    "M9.36 3.65a.5.5 0 0 0-.71 0l-1.5 1.5a.5.5 0 0 0 .7.7L9 4.72l1.15 1.15a.5.5 0 1 0 .7-.71zM7.74 7.78a1.8 1.8 0 0 0-1.27-.75 3.3 3.3 0 0 0-1.74.24c-1.24.52-2.45 1.78-3.06 4.06a3.7 3.7 0 0 0 .14 2.6c.35.72.96 1.2 1.67 1.42 1.42.45 3.21-.12 4.42-1.73a.5.5 0 0 0-.8-.6c-1 1.33-2.37 1.68-3.32 1.38a1.7 1.7 0 0 1-1.07-.9 2.5 2.5 0 0 1-.16-1.51c2.16.12 3.64-.47 4.51-1.32.9-.87 1.18-2.1.68-2.89M6.36 9.95c-.6.59-1.71 1.1-3.55 1.05.58-1.64 1.5-2.47 2.3-2.8.46-.2.88-.23 1.2-.18.34.05.52.19.58.29.16.26.17.96-.53 1.64m11.5-2.8c.19.2.19.5 0 .7l-3.09 3.08 1.64 2.76c.07.1.25.25.47.3.17.03.42.02.74-.35a.5.5 0 1 1 .76.66c-.53.6-1.15.78-1.7.67-.51-.1-.9-.44-1.1-.72-.12-.18-.8-1.34-1.54-2.59l-3.19 3.2a.5.5 0 0 1-.7-.71l3.37-3.38-1.46-2.5a.6.6 0 0 0-.41-.27c-.15-.01-.42.02-.75.47a.5.5 0 0 1-.8-.59c.49-.67 1.08-.94 1.66-.87.54.06.96.4 1.16.75l1.33 2.28 2.9-2.9c.2-.19.5-.19.7 0"
]);
const $f52f593d43f17bc8$export$4072f38c20bca8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormatProfessionalFilled', "1em", [
    "M10.25 3.6c.44-.33 1-.65 1.65-.65l.12.01q.63.1 1.06.5c.25.23.44.52.62.78l1.07-1.07a.75.75 0 1 1 1.06 1.06L14.5 5.57l.38.7c.08.16.18.24.38.3h.19l.1-.07.23-.23a.75.75 0 0 1 1.06 1.06l-.03.03c-.17.17-.4.4-.69.55a1.8 1.8 0 0 1-1.2.12 2 2 0 0 1-1.38-1.1l-.14-.26-1.06 1.06a.75.75 0 1 1-1.06-1.06l1.35-1.35-.14-.2a3 3 0 0 0-.42-.56.4.4 0 0 0-.22-.1q-.21 0-.7.34a.75.75 0 0 1-.9-1.2M5.4 16.3H6c1.4-.1 2.8-.7 3.9-2 .3-.4.2-.8-.1-1.1-.3-.2-.8-.2-1.2.1-.9.7-1.9 1.4-3.1 1.4-.6 0-1.2-.5-1.3-1.1-.1-.5 0-1.1.2-1.6 1.6.1 3.8-.1 4.8-1.3.8-.9 1-2.4 0-3.3-.4-.4-.9-.5-1.4-.5-.9 0-1.8.5-2.6 1.3-1.3 1.3-2.6 3.5-2.4 5.6.1 1.5 1.4 2.4 2.6 2.5m.8-7.1c.6-.5 1.1-.8 1.6-.8.2 0 .5.1.6.3.2.3 0 .8-.2 1-.5.5-1.8.8-3 .8.3-.5.6-.9 1-1.3"
]);
const $f52f593d43f17bc8$export$e14b8fe3e87bbbcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormatProfessionalRegular', "1em", [
    "M10.85 4.35c.2-.19.25-.24.35-.3a.9.9 0 0 1 .92.17q.1.05.2.21l.1.17.01.03.14.22.3.54v.03l-1.72 1.73a.5.5 0 0 0 .7.7l1.56-1.55.17.28.18.29.11.18c.1.16.23.36.38.5a1.6 1.6 0 0 0 2 .28c.26-.13.4-.28.59-.46l.01-.02a.5.5 0 1 0-.7-.7 1 1 0 0 1-.43.33c-.13.1-.46.17-.77-.13l-.22-.32-.31-.5-.28-.46 1.71-1.72a.5.5 0 0 0-.7-.7L13.6 4.68l-.2-.36-.11-.2-.02-.02-.12-.2q-.15-.27-.47-.5a1.9 1.9 0 0 0-1.91-.25c-.28.14-.43.29-.62.48l-.01.02a.5.5 0 0 0 .7.7M8.31 7c.46 0 .88.23 1.18.54s.5.75.5 1.24c.07.77-.2 1.4-.67 1.86-.45.46-1.07.76-1.7.96-1.17.37-2.52.44-3.42.41a3.5 3.5 0 0 0-.2 1.6 1.5 1.5 0 0 0 .52.94c.27.27.6.35 1.1.46 1.34.16 2.64-.61 3.46-1.72a.5.5 0 0 1 .8.6c-.95 1.3-2.6 2.34-4.4 2.1H5.4c-.46-.1-1.08-.23-1.58-.73q-.64-.56-.8-1.49a4.6 4.6 0 0 1 .25-2.13l.13-.35.02-.04v-.02c.07-.2.44-1.23 1.2-2.23.75-1 1.96-2.05 3.69-2m-3.72 4.02c.8 0 1.84-.1 2.72-.37q.84-.26 1.3-.71A1.3 1.3 0 0 0 9 8.8q-.01-.31-.24-.57A.7.7 0 0 0 8.3 8h-.02c-1.26-.04-2.2.71-2.87 1.6-.38.5-.65 1.04-.82 1.42"
]);
const $f52f593d43f17bc8$export$47c8a5e14260c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormulaFilled', "1em", [
    "M8.91 3.54c.3-.04.48-.03.62 0q.2.02.48.2a.75.75 0 1 0 .78-1.28q-.43-.27-.97-.4a3 3 0 0 0-1.13 0h-.01c-.8.13-1.43.55-1.86 1.16a4 4 0 0 0-.67 2.18v.03l-.02.36q0 .34-.04.87v.09H4.8a.75.75 0 0 0 0 1.5H6l-.35 5.49c-.1 1.28-.22 2.14-1.03 2.61-.4.23-1.01.21-1.68-.12a.75.75 0 1 0-.68 1.34c.93.46 2.11.65 3.11.08 1.54-.9 1.68-2.55 1.77-3.67v-.12c.07-.77.23-3.46.36-5.61h1.8a.75.75 0 1 0 0-1.5H7.58l.07-1.32c.04-.6.2-1.05.4-1.35q.29-.43.86-.54m7.87 6.74a.75.75 0 0 0-1.06-1.06l-2.58 2.58-.76-1.36-.07-.11c-.15-.25-.38-.61-.66-.87a1.6 1.6 0 0 0-.74-.4 1.6 1.6 0 0 0-1.1.18l-.03.02q-.12.09-.28.23l-.13.15-.02.03-.17.19a.75.75 0 0 0 1.14.98l.17-.2.02-.03.07-.07.01-.01.04.03q.09.08.21.27l.26.4c.12.23.49.9.94 1.66l-2.82 2.83a.75.75 0 1 0 1.06 1.06l2.66-2.66a39 39 0 0 1 .87 1.54c.13.22.35.6.64.87.18.17.42.34.73.42a1.6 1.6 0 0 0 1.06-.1c.35-.17.57-.4.8-.77a.75.75 0 0 0-1.28-.79l-.13.18-.03.02-.03.01-.03-.01-.06-.05-.2-.26-.16-.26-.06-.1c-.12-.23-.53-.96-1.02-1.8zm-6.18.24Z"
]);
const $f52f593d43f17bc8$export$433296e25f47daa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormulaRegular', "1em", [
    "M9.68 3.09q-.26-.06-.7 0-.76.14-1.12.68-.39.57-.46 1.45c0 .2-.04.87-.09 1.78H9.5a.5.5 0 0 1 0 1H7.26c-.13 2.25-.3 5.15-.36 5.94v.07c-.05.57-.11 1.25-.31 1.88-.21.67-.6 1.3-1.33 1.74-1.02.63-2.13.34-2.98-.08a.5.5 0 1 1 .44-.9c.75.38 1.44.49 2.02.13v-.01c.47-.27.73-.68.9-1.18.16-.52.2-1.1.26-1.7v-.03c.06-.8.23-3.64.36-5.86H4.5a.5.5 0 1 1 0-1h1.81l.1-1.84c.05-.7.24-1.4.63-1.96.4-.57 1-.97 1.78-1.1q.59-.08 1.05.01.47.1.89.36a.5.5 0 0 1-.52.86q-.32-.19-.56-.24m7.17 6.06c.2.2.2.5 0 .7l-3.22 3.22 1.4 2.47.04.07q.09.18.15.25.07.12.25.22c.21.03.28-.01.3-.03l.13-.13.1-.14.1-.13a.5.5 0 0 1 .8.6l-.06.08c-.11.16-.28.39-.5.54q-.46.32-1.14.17l-.12-.04q-.43-.21-.67-.56-.12-.16-.2-.33l-.05-.08-.19-.32-1.07-1.9-3.05 3.04a.5.5 0 0 1-.7-.7l3.24-3.25-1.47-2.57a1 1 0 0 0-.32-.32q-.09-.03-.21.04-.18.12-.39.4a.5.5 0 1 1-.8-.6c.16-.2.38-.47.66-.65a1.2 1.2 0 0 1 1.16-.1c.3.16.53.4.7.63q.26.36.42.68l.99 1.76 3.02-3.02c.2-.2.5-.2.7 0"
]);
const $f52f593d43f17bc8$export$6c0c713220aa3e44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormulaSparkleFilled', "1em", [
    "M8.7 2.06q.59-.1 1.12 0 .41.1.77.29a1.4 1.4 0 0 0-.57 1.4 2 2 0 0 0-.5-.21 2 2 0 0 0-.6 0q-.58.11-.87.54c-.2.3-.36.75-.4 1.35l-.07 1.32H9.3a.75.75 0 0 1 0 1.5H7.5l-.35 5.6v.01l-.01.12c-.1 1.12-.23 2.77-1.76 3.67-1 .57-2.19.38-3.12-.08a.75.75 0 0 1 .68-1.34c.67.33 1.28.35 1.68.12.81-.47.93-1.33 1.03-2.61.05-.64.18-2.63.29-4.52L6 8.25H4.8a.75.75 0 0 1 0-1.5h1.28v-.1l.07-1.22v-.08c.06-.79.26-1.53.67-2.13a2.8 2.8 0 0 1 1.86-1.16zm1.26 7.1q.46-.2.95-.1c.32.07.56.23.74.4.28.26.5.62.66.87l.11.18c.06.13.34.64.72 1.29l1.99-1.99.53.18q.11.05.21.14t.15.22l.17.52-2.15 2.15c.5.84.9 1.57 1.02 1.8l.06.1.36.52.06.05.02.01h.04l.03-.03.13-.18a.75.75 0 0 1 1.28.79 2 2 0 0 1-.88.8 1.6 1.6 0 0 1-.98.07 2 2 0 0 1-.73-.42 4 4 0 0 1-.64-.87l-.05-.09-.03-.05c-.07-.13-.37-.7-.79-1.4l-2.66 2.66a.75.75 0 0 1-1.06-1.06l2.82-2.83c-.45-.77-.82-1.43-.94-1.67l-.09-.14q-.08-.13-.17-.25a2 2 0 0 0-.25-.3h-.01l-.07.08-.02.03-.17.2a.75.75 0 1 1-1.14-.98l.17-.2.02-.02.13-.15q.15-.14.28-.23l.04-.02zM17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.25.76a.3.3 0 0 1-.45.14.3.3 0 0 1-.12-.14l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .2-.29l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.43.43 0 0 1 .2.65.4.4 0 0 1-.2.15l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2 2 0 0 0-.65-.98 2 2 0 0 0-.75-.43l-1.07-.34a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $f52f593d43f17bc8$export$86a10a922b4a2f5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathFormulaSparkleRegular', "1em", [
    "M8.83 2.1q.57-.08 1.04 0 .37.1.7.26a1.4 1.4 0 0 0-.54.85q-.19-.09-.35-.12-.26-.06-.7 0-.76.14-1.12.68-.39.57-.46 1.45c0 .2-.04.87-.09 1.78H9.5a.5.5 0 0 1 0 1H7.26c-.13 2.25-.3 5.15-.36 5.94v.07c-.05.57-.11 1.25-.31 1.88-.21.67-.6 1.3-1.33 1.74-1.02.63-2.13.34-2.98-.08a.5.5 0 0 1 .44-.9c.75.38 1.44.49 2.02.13v-.01c.47-.27.74-.68.9-1.18.16-.52.21-1.1.26-1.7v-.03c.06-.8.23-3.64.36-5.86H4.5a.5.5 0 0 1 0-1h1.81c.06-.95.09-1.66.09-1.8v-.04c.06-.7.25-1.4.64-1.96.4-.57 1-.97 1.78-1.1zm1.03 7.1a1.2 1.2 0 0 1 1.16-.1c.3.15.53.4.7.63q.26.36.42.68l.99 1.76 2.26-2.27.27.09q.13.05.22.14.1.1.14.22l.08.26-2.47 2.46 1.4 2.47.04.07q.09.18.15.25.07.13.25.22c.21.03.28-.01.3-.03l.13-.13.1-.14.1-.13a.5.5 0 0 1 .8.6l-.06.08c-.11.16-.28.4-.5.54q-.46.32-1.14.17l-.12-.04q-.43-.21-.67-.56-.12-.16-.2-.33l-.05-.08-.19-.32-1.07-1.9-3.05 3.04a.5.5 0 0 1-.7-.7l3.24-3.25-1.47-2.57a1 1 0 0 0-.32-.32q-.09-.03-.21.04-.18.12-.39.4a.5.5 0 0 1-.8-.6c.16-.2.38-.47.66-.65M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $f52f593d43f17bc8$export$3fe5e1291c236540 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathSymbolsFilled', "1em", [
    "M4.75 5.25v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5zM11 4.5c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 11 4.5m-8.78 6.78 2.22 2.22-2.22 2.22a.75.75 0 1 0 1.06 1.06l2.22-2.22 2.22 2.22a.75.75 0 0 0 1.06-1.06L6.56 13.5l2.22-2.22a.75.75 0 1 0-1.06-1.06L5.5 12.44l-2.22-2.22a.75.75 0 1 0-1.06 1.06m9.53 1.47a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM15.5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $f52f593d43f17bc8$export$82ea260104de531d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MathSymbolsRegular', "1em", [
    "M5 5v2.5a.5.5 0 0 0 1 0V5h2.5a.5.5 0 0 0 0-1H6V1.5a.5.5 0 0 0-1 0V4H2.5a.5.5 0 0 0 0 1zm6-.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M8.85 16.15 6.21 13.5l2.64-2.65a.5.5 0 0 0-.7-.7L5.5 12.79l-2.65-2.64a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7M11.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm4-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $f52f593d43f17bc8$export$b9ff12cdf6d70bfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RefrigeratorFilled', "1em", [
    "M16 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V9h12zm-9.5-5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5m6.65-8A3 3 0 0 1 16 5v3H4V5a3 3 0 0 1 3-3h6.15M6.5 4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5"
]);
const $f52f593d43f17bc8$export$e7c136678afbd3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RefrigeratorRegular', "1em", [
    "M13.15 2A3 3 0 0 1 16 5v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6.15M5 15c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V9H5zm1.5-5c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5M7 3a2 2 0 0 0-2 2v3h10V5a2 2 0 0 0-1.8-1.99L13 3zm-.5 1c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5"
]);
const $f52f593d43f17bc8$export$221064d5a37728c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToiletFilled', "1em", [
    "M16 16a2 2 0 0 1-2 2H6a1 1 0 0 1-.91-1.42l.86-1.87A6.97 6.97 0 0 0 16 12.6zm-2.83-6a3 3 0 0 0 2.08 1.9A6 6 0 0 1 4.09 10zm3.33-9c.83 0 1.5.67 1.5 1.5V9a2 2 0 1 1-4 0V2.5c0-.83.67-1.5 1.5-1.5zM13 9H4.5a1.5 1.5 0 1 1 0-3H13z"
]);
const $f52f593d43f17bc8$export$63111dc8310534cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToiletRegular', "1em", [
    "M16.5 1c.83 0 1.5.67 1.5 1.5v6a2.5 2.5 0 0 1-2 2.45V16a2 2 0 0 1-2 2H6a1 1 0 0 1-.9-1.42l1.28-2.8a6 6 0 0 1-2.33-4.02A2 2 0 0 1 5 6h8V2.5c0-.83.67-1.5 1.5-1.5zM15 12.31a6 6 0 0 1-7.77 2.01L6 17h8a1 1 0 0 0 1-1zM13.5 10H5.1a5 5 0 0 0 9.55.85A2.5 2.5 0 0 1 13.5 10m1-8a.5.5 0 0 0-.5.5v6a1.5 1.5 0 0 0 3 0v-6a.5.5 0 0 0-.5-.5zM5 7a1 1 0 0 0 0 2h8.05a3 3 0 0 1-.05-.5V7z"
]);
const $f52f593d43f17bc8$export$84a7ff97f2f44185 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TvFilled', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm3.5 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"
]);





'use client';
const $3dc35a17e36bf0c8$export$1a864a96e6106383 = (props, ref)=>{
    var _baseState_indicator;
    const { size: size = 'medium', ...baseProps } = props;
    const baseState = $3dc35a17e36bf0c8$export$3be451c677f2f26a(baseProps, ref);
    var _children;
    (_children = (_baseState_indicator = baseState.indicator).children) !== null && _children !== void 0 ? _children : _baseState_indicator.children = /*#__PURE__*/ $acw62.createElement((0, $f52f593d43f17bc8$export$86da4c691f746b92), null);
    return {
        ...baseState,
        components: {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ...baseState.components,
            label: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        },
        size: size,
        label: (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
            defaultProps: {
                size: 'medium',
                ...baseState.label
            },
            elementType: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        })
    };
};
const $3dc35a17e36bf0c8$export$3be451c677f2f26a = (props, ref)=>{
    // Merge props from surrounding <Field>, if any
    props = (0, $af5cf4826b6cd175$export$fc5228adfb2d94ce)(props, {
        supportsLabelFor: true,
        supportsRequired: true
    });
    const { checked: checked, defaultChecked: defaultChecked, disabled: disabled, disabledFocusable: disabledFocusable = false, labelPosition: labelPosition = 'after', onChange: onChange, required: required } = props;
    const nativeProps = (0, $f5c0cec12bf016e1$export$199c93d3d8d08c56)({
        props: props,
        primarySlotTagName: 'input',
        excludedPropNames: [
            'checked',
            'defaultChecked',
            'onChange',
            'disabledFocusable'
        ]
    });
    const id = (0, $0200d30cfa270435$export$f680877a34711e37)('switch-', nativeProps.primary.id);
    const root = (0, $fcf7ddccaab7fd8f$exports).always(props.root, {
        defaultProps: {
            ref: (0, $4f816f386fc6883e$export$420e68273165f4ec)(),
            ...nativeProps.root
        },
        elementType: 'div'
    });
    const indicator = (0, $fcf7ddccaab7fd8f$exports).always(props.indicator, {
        defaultProps: {
            'aria-hidden': true
        },
        elementType: 'div'
    });
    const input = (0, $fcf7ddccaab7fd8f$exports).always(props.input, {
        defaultProps: {
            checked: checked,
            defaultChecked: defaultChecked,
            id: id,
            ref: ref,
            role: 'switch',
            type: 'checkbox',
            ...nativeProps.primary,
            disabled: disabled && !disabledFocusable,
            ...disabledFocusable && {
                'aria-disabled': true
            }
        },
        elementType: 'input'
    });
    input.onChange = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(input.onChange, (ev)=>onChange === null || onChange === void 0 ? void 0 : onChange(ev, {
            checked: ev.currentTarget.checked
        }));
    input.onClick = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(input.onClick, (ev)=>{
        if (disabledFocusable) ev.preventDefault();
    });
    input.onKeyDown = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(input.onKeyDown, (ev)=>{
        if (disabledFocusable && (ev.key === ' ' || ev.key === 'Enter')) ev.preventDefault();
    });
    const label = (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
        defaultProps: {
            disabled: disabled || disabledFocusable,
            htmlFor: id,
            required: required
        },
        elementType: 'label'
    });
    return {
        disabledFocusable: disabledFocusable,
        labelPosition: labelPosition,
        components: {
            root: 'div',
            indicator: 'div',
            input: 'input',
            label: 'label'
        },
        root: root,
        indicator: indicator,
        input: input,
        label: label
    };
};




const $f8f224910cb11656$export$1e60b302f8ceb26e = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const { labelPosition: labelPosition } = state;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.input, {}),
            labelPosition !== 'after' && state.label && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {}),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.indicator, {}),
            labelPosition === 'after' && state.label && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {})
        ]
    });
};





'use client';
const $333a85ed8ce2c644$export$22c2231774338229 = {
    root: 'fui-Switch',
    indicator: 'fui-Switch__indicator',
    input: 'fui-Switch__input',
    label: 'fui-Switch__label'
};
const $333a85ed8ce2c644$export$73ec7d09d8cc994c = $333a85ed8ce2c644$export$22c2231774338229.root;
// Thumb and track sizes used by the component.
const $333a85ed8ce2c644$var$spaceBetweenThumbAndTrack = 2;
// Medium size dimensions
const $333a85ed8ce2c644$var$trackHeightMedium = 20;
const $333a85ed8ce2c644$var$trackWidthMedium = 40;
const $333a85ed8ce2c644$var$thumbSizeMedium = $333a85ed8ce2c644$var$trackHeightMedium - $333a85ed8ce2c644$var$spaceBetweenThumbAndTrack;
// Small size dimensions (from design mockup)
const $333a85ed8ce2c644$var$trackHeightSmall = 16;
const $333a85ed8ce2c644$var$trackWidthSmall = 32;
const $333a85ed8ce2c644$var$thumbSizeSmall = $333a85ed8ce2c644$var$trackHeightSmall - $333a85ed8ce2c644$var$spaceBetweenThumbAndTrack;
const $333a85ed8ce2c644$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r2i81i2", "rofhmb8", {
    r: [
        ".r2i81i2{align-items:flex-start;box-sizing:border-box;display:inline-flex;position:relative;}",
        ".r2i81i2:focus{outline-style:none;}",
        ".r2i81i2:focus-visible{outline-style:none;}",
        ".r2i81i2[data-fui-focus-within]:focus-within{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".r2i81i2[data-fui-focus-within]:focus-within::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".rofhmb8{align-items:flex-start;box-sizing:border-box;display:inline-flex;position:relative;}",
        ".rofhmb8:focus{outline-style:none;}",
        ".rofhmb8:focus-visible{outline-style:none;}",
        ".rofhmb8[data-fui-focus-within]:focus-within{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".rofhmb8[data-fui-focus-within]:focus-within::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.r2i81i2[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media (forced-colors: active){.rofhmb8[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"
    ]
});
const $333a85ed8ce2c644$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    vertical: {
        Beiy3e4: "f1vx9l62"
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}"
    ]
});
const $333a85ed8ce2c644$var$useIndicatorBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1c3hft5", null, {
    r: [
        ".r1c3hft5{border-radius:var(--borderRadiusCircular);border:1px solid;line-height:0;box-sizing:border-box;fill:currentColor;flex-shrink:0;font-size:18px;height:20px;margin:var(--spacingVerticalS) var(--spacingHorizontalS);pointer-events:none;transition-duration:var(--durationNormal);transition-timing-function:var(--curveEasyEase);transition-property:background,border,color;width:40px;}",
        ".r1c3hft5>*{transition-duration:var(--durationNormal);transition-timing-function:var(--curveEasyEase);transition-property:transform;}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.r1c3hft5{transition-duration:0.01ms;}}",
        "@media (forced-colors: active){.r1c3hft5{color:CanvasText;}.r1c3hft5>i{forced-color-adjust:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1c3hft5>*{transition-duration:0.01ms;}}"
    ]
});
const $333a85ed8ce2c644$var$useIndicatorStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    labelAbove: {
        B6of3ja: "f1hu3pq6"
    },
    sizeSmall: {
        Be2twd7: "fses1vf",
        Bqenvij: "fd461yt",
        a9b677: "f1szoe96"
    }
}, {
    d: [
        ".f1hu3pq6{margin-top:0;}",
        ".fses1vf{font-size:14px;}",
        ".fd461yt{height:16px;}",
        ".f1szoe96{width:32px;}"
    ]
});
const $333a85ed8ce2c644$var$useInputBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r12ojtgy", "rhc0e9x", {
    r: [
        ".r12ojtgy{box-sizing:border-box;cursor:pointer;height:100%;margin:0;opacity:0;position:absolute;width:calc(40px + 2 * var(--spacingHorizontalS));}",
        ".r12ojtgy:checked~.fui-Switch__indicator>*{transform:translateX(20px);}",
        ".r12ojtgy:disabled,.r12ojtgy[aria-disabled=\"true\"]{cursor:default;}",
        ".r12ojtgy:disabled~.fui-Switch__indicator,.r12ojtgy[aria-disabled=\"true\"]~.fui-Switch__indicator{color:var(--colorNeutralForegroundDisabled);}",
        ".r12ojtgy:disabled~.fui-Switch__label,.r12ojtgy[aria-disabled=\"true\"]~.fui-Switch__label{cursor:default;color:var(--colorNeutralForegroundDisabled);}",
        ".r12ojtgy:enabled:not(:checked):not([aria-disabled=\"true\"])~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessible);border-color:var(--colorNeutralStrokeAccessible);}",
        ".r12ojtgy:enabled:not(:checked):not([aria-disabled=\"true\"])~.fui-Switch__label{color:var(--colorNeutralForeground1);}",
        ".r12ojtgy:enabled:not(:checked):not([aria-disabled=\"true\"]):hover~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessibleHover);border-color:var(--colorNeutralStrokeAccessibleHover);}",
        ".r12ojtgy:enabled:not(:checked):not([aria-disabled=\"true\"]):hover:active~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessiblePressed);border-color:var(--colorNeutralStrokeAccessiblePressed);}",
        ".r12ojtgy:enabled:checked:not([aria-disabled=\"true\"])~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackground);color:var(--colorNeutralForegroundInverted);border-color:var(--colorTransparentStroke);}",
        ".r12ojtgy:enabled:checked:not([aria-disabled=\"true\"]):hover~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundHover);border-color:var(--colorTransparentStrokeInteractive);}",
        ".r12ojtgy:enabled:checked:not([aria-disabled=\"true\"]):hover:active~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundPressed);border-color:var(--colorTransparentStrokeInteractive);}",
        ".r12ojtgy:disabled:not(:checked)~.fui-Switch__indicator,.r12ojtgy[aria-disabled=\"true\"]:not(:checked)~.fui-Switch__indicator{border-color:var(--colorNeutralStrokeDisabled);}",
        ".r12ojtgy:disabled:checked~.fui-Switch__indicator,.r12ojtgy[aria-disabled=\"true\"]:checked~.fui-Switch__indicator{background-color:var(--colorNeutralBackgroundDisabled);border-color:var(--colorTransparentStrokeDisabled);}",
        ".rhc0e9x{box-sizing:border-box;cursor:pointer;height:100%;margin:0;opacity:0;position:absolute;width:calc(40px + 2 * var(--spacingHorizontalS));}",
        ".rhc0e9x:checked~.fui-Switch__indicator>*{transform:translateX(-20px);}",
        ".rhc0e9x:disabled,.rhc0e9x[aria-disabled=\"true\"]{cursor:default;}",
        ".rhc0e9x:disabled~.fui-Switch__indicator,.rhc0e9x[aria-disabled=\"true\"]~.fui-Switch__indicator{color:var(--colorNeutralForegroundDisabled);}",
        ".rhc0e9x:disabled~.fui-Switch__label,.rhc0e9x[aria-disabled=\"true\"]~.fui-Switch__label{cursor:default;color:var(--colorNeutralForegroundDisabled);}",
        ".rhc0e9x:enabled:not(:checked):not([aria-disabled=\"true\"])~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessible);border-color:var(--colorNeutralStrokeAccessible);}",
        ".rhc0e9x:enabled:not(:checked):not([aria-disabled=\"true\"])~.fui-Switch__label{color:var(--colorNeutralForeground1);}",
        ".rhc0e9x:enabled:not(:checked):not([aria-disabled=\"true\"]):hover~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessibleHover);border-color:var(--colorNeutralStrokeAccessibleHover);}",
        ".rhc0e9x:enabled:not(:checked):not([aria-disabled=\"true\"]):hover:active~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessiblePressed);border-color:var(--colorNeutralStrokeAccessiblePressed);}",
        ".rhc0e9x:enabled:checked:not([aria-disabled=\"true\"])~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackground);color:var(--colorNeutralForegroundInverted);border-color:var(--colorTransparentStroke);}",
        ".rhc0e9x:enabled:checked:not([aria-disabled=\"true\"]):hover~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundHover);border-color:var(--colorTransparentStrokeInteractive);}",
        ".rhc0e9x:enabled:checked:not([aria-disabled=\"true\"]):hover:active~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundPressed);border-color:var(--colorTransparentStrokeInteractive);}",
        ".rhc0e9x:disabled:not(:checked)~.fui-Switch__indicator,.rhc0e9x[aria-disabled=\"true\"]:not(:checked)~.fui-Switch__indicator{border-color:var(--colorNeutralStrokeDisabled);}",
        ".rhc0e9x:disabled:checked~.fui-Switch__indicator,.rhc0e9x[aria-disabled=\"true\"]:checked~.fui-Switch__indicator{background-color:var(--colorNeutralBackgroundDisabled);border-color:var(--colorTransparentStrokeDisabled);}"
    ],
    s: [
        "@media (forced-colors: active){.r12ojtgy:disabled~.fui-Switch__indicator,.r12ojtgy[aria-disabled=\"true\"]~.fui-Switch__indicator{color:GrayText;border-color:GrayText;}.r12ojtgy:disabled~.fui-Switch__label,.r12ojtgy[aria-disabled=\"true\"]~.fui-Switch__label{color:GrayText;}.r12ojtgy:hover{color:CanvasText;}.r12ojtgy:hover:active{color:CanvasText;}.r12ojtgy:enabled:checked:not([aria-disabled=\"true\"]):hover~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.r12ojtgy:enabled:checked:not([aria-disabled=\"true\"]):hover:active~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.r12ojtgy:enabled:checked:not([aria-disabled=\"true\"])~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}}",
        "@media (forced-colors: active){.rhc0e9x:disabled~.fui-Switch__indicator,.rhc0e9x[aria-disabled=\"true\"]~.fui-Switch__indicator{color:GrayText;border-color:GrayText;}.rhc0e9x:disabled~.fui-Switch__label,.rhc0e9x[aria-disabled=\"true\"]~.fui-Switch__label{color:GrayText;}.rhc0e9x:hover{color:CanvasText;}.rhc0e9x:hover:active{color:CanvasText;}.rhc0e9x:enabled:checked:not([aria-disabled=\"true\"]):hover~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.rhc0e9x:enabled:checked:not([aria-disabled=\"true\"]):hover:active~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.rhc0e9x:enabled:checked:not([aria-disabled=\"true\"])~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}}"
    ]
});
const $333a85ed8ce2c644$var$useInputStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    before: {
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        Bhzewxz: "f15twtuk"
    },
    after: {
        oyh7mz: [
            "f1vgc2s3",
            "f1e31b4d"
        ],
        Bhzewxz: "f15twtuk"
    },
    above: {
        B5kzvoi: "f1yab3r1",
        Bqenvij: "f1aar7gd",
        a9b677: "fly5x3f"
    },
    sizeSmall: {
        a9b677: "f83td6f",
        oedwrj: [
            "f1t5zc5r",
            "fmy58zi"
        ]
    }
}, {
    d: [
        ".f1e31b4d{right:0;}",
        ".f1vgc2s3{left:0;}",
        ".f15twtuk{top:0;}",
        ".f1yab3r1{bottom:0;}",
        ".f1aar7gd{height:calc(20px + var(--spacingVerticalS));}",
        ".fly5x3f{width:100%;}",
        ".f83td6f{width:calc(32px + 2 * var(--spacingHorizontalS));}",
        ".f1t5zc5r:checked~.fui-Switch__indicator>*{transform:translateX(16px);}",
        ".fmy58zi:checked~.fui-Switch__indicator>*{transform:translateX(-16px);}"
    ]
});
// Can't use makeResetStyles here because Label is a component that may itself use makeResetStyles.
const $333a85ed8ce2c644$var$useLabelStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Bceei9c: "f1k6fduh",
        jrapky: "f49ad5g",
        B6of3ja: "f1xlvstr",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1f5q0n8"
    },
    sizeSmall: {
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm",
        jrapky: "f1suqah5",
        B6of3ja: "f26bnac"
    },
    above: {
        z8tnut: "f1ywm7hm",
        Byoj8tv: "f14wxoun",
        a9b677: "fly5x3f"
    },
    after: {
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ]
    },
    before: {
        z189sj: [
            "f7x41pl",
            "fruq291"
        ]
    }
}, {
    d: [
        ".f1k6fduh{cursor:pointer;}",
        ".f49ad5g{margin-bottom:calc((20px - var(--lineHeightBase300)) / 2);}",
        ".f1xlvstr{margin-top:calc((20px - var(--lineHeightBase300)) / 2);}",
        [
            ".f1f5q0n8{padding:var(--spacingVerticalS) var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f1suqah5{margin-bottom:calc((16px - var(--lineHeightBase200)) / 2);}",
        ".f26bnac{margin-top:calc((16px - var(--lineHeightBase200)) / 2);}",
        ".f1ywm7hm{padding-top:var(--spacingVerticalXS);}",
        ".f14wxoun{padding-bottom:var(--spacingVerticalXS);}",
        ".fly5x3f{width:100%;}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}"
    ]
});
const $333a85ed8ce2c644$export$b8e48824aca19d28 = (state)=>{
    const rootBaseClassName = $333a85ed8ce2c644$var$useRootBaseClassName();
    const rootStyles = $333a85ed8ce2c644$var$useRootStyles();
    const indicatorBaseClassName = $333a85ed8ce2c644$var$useIndicatorBaseClassName();
    const indicatorStyles = $333a85ed8ce2c644$var$useIndicatorStyles();
    const inputBaseClassName = $333a85ed8ce2c644$var$useInputBaseClassName();
    const inputStyles = $333a85ed8ce2c644$var$useInputStyles();
    const labelStyles = $333a85ed8ce2c644$var$useLabelStyles();
    const { label: label, labelPosition: labelPosition, size: size } = state;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($333a85ed8ce2c644$export$22c2231774338229.root, rootBaseClassName, labelPosition === 'above' && rootStyles.vertical, state.root.className);
    // eslint-disable-next-line react-hooks/immutability
    state.indicator.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($333a85ed8ce2c644$export$22c2231774338229.indicator, indicatorBaseClassName, label && labelPosition === 'above' && indicatorStyles.labelAbove, size === 'small' && indicatorStyles.sizeSmall, state.indicator.className);
    // eslint-disable-next-line react-hooks/immutability
    state.input.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($333a85ed8ce2c644$export$22c2231774338229.input, inputBaseClassName, label && inputStyles[labelPosition], size === 'small' && inputStyles.sizeSmall, state.input.className);
    if (state.label) // eslint-disable-next-line react-hooks/immutability
    state.label.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($333a85ed8ce2c644$export$22c2231774338229.label, labelStyles.base, labelStyles[labelPosition], size === 'small' && labelStyles.sizeSmall, state.label.className);
    return state;
};



'use client';
const $c56830212733dc47$export$b5d5cf8927ab7262 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $3dc35a17e36bf0c8$export$1a864a96e6106383)(props, ref);
    (0, $333a85ed8ce2c644$export$b8e48824aca19d28)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useSwitchStyles_unstable')(state);
    return (0, $f8f224910cb11656$export$1e60b302f8ceb26e)(state);
});
$c56830212733dc47$export$b5d5cf8927ab7262.displayName = 'Switch';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * Tiny helper to do the minimal amount of work in duplicating an object but omitting some
 * props. This ends up faster than using object ...rest or reduce to filter.
 *
 * This behaves very much like filteredAssign, but does not merge many objects together,
 * uses an exclusion object map, and avoids spreads all for optimal performance.
 *
 * See perf test for background:
 * https://jsperf.com/omit-vs-rest-vs-reduce/1
 *
 * @param obj - The object to clone
 * @param exclusions - The array of keys to exclude
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7c0ff279f695a700$export$30a06c8d3562193f(obj, exclusions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for(const key in obj)if (exclusions.indexOf(key) === -1 && obj.hasOwnProperty(key)) result[key] = obj[key];
    return result;
}



'use client';
const $10b5578c8a01fa19$var$tabListContextDefaultValue = {
    appearance: 'transparent',
    reserveSelectedTabSpace: true,
    selectTabOnFocus: false,
    disabled: false,
    selectedValue: undefined,
    onRegister: ()=>{
    /* noop */ },
    onUnregister: ()=>{
    /* noop */ },
    onSelect: ()=>{
    /* noop */ },
    getRegisteredTabs: ()=>{
        return {
            registeredTabs: {}
        };
    },
    size: 'medium',
    vertical: false
};
const $10b5578c8a01fa19$export$aa6907f9fd69e93b = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $10b5578c8a01fa19$export$1bc26eb4ac1fc352 = $10b5578c8a01fa19$export$aa6907f9fd69e93b.Provider;
const $10b5578c8a01fa19$export$6818f85b899576ef = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($10b5578c8a01fa19$export$aa6907f9fd69e93b, (ctx = $10b5578c8a01fa19$var$tabListContextDefaultValue)=>selector(ctx));


'use client';
const $5657584a340f9723$export$272a80fa5efc2477 = (props, ref)=>{
    const { content: content } = props;
    const state = $5657584a340f9723$export$ac53a678bf9062df(props, ref);
    const focusAttributes = $5657584a340f9723$export$a06d8240a859b3c5(state);
    const appearance = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.appearance);
    const reserveSelectedTabSpace = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.reserveSelectedTabSpace);
    const size = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>{
        var _ctx_size;
        return (_ctx_size = ctx.size) !== null && _ctx_size !== void 0 ? _ctx_size : 'medium';
    });
    const contentReservedSpace = content && typeof content === 'object' ? (0, $7c0ff279f695a700$export$30a06c8d3562193f)(content, [
        'ref'
    ]) : content;
    return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        components: {
            ...state.components,
            contentReservedSpace: 'span'
        },
        root: {
            ...focusAttributes,
            ...state.root
        },
        contentReservedSpace: (0, $fcf7ddccaab7fd8f$exports).optional(contentReservedSpace, {
            renderByDefault: !state.selected && !state.iconOnly && reserveSelectedTabSpace,
            defaultProps: {
                children: props.children
            },
            elementType: 'span'
        }),
        appearance: appearance,
        size: size
    };
};
const $5657584a340f9723$export$ac53a678bf9062df = (props, ref)=>{
    const { content: content, disabled: tabDisabled = false, icon: icon, onClick: onClick, onFocus: onFocus, value: value, ...rest } = props;
    const selectTabOnFocus = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.selectTabOnFocus);
    const listDisabled = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.disabled);
    const selected = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.selectedValue === value);
    const onRegister = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.onRegister);
    const onUnregister = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.onUnregister);
    const onSelect = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.onSelect);
    const vertical = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>!!ctx.vertical);
    const disabled = listDisabled || tabDisabled;
    const innerRef = $acw62.useRef(null);
    const onSelectCallback = (event)=>onSelect(event, {
            value: value
        });
    const onTabClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onClick, onSelectCallback));
    const onTabFocus = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onFocus, onSelectCallback));
    $acw62.useEffect(()=>{
        onRegister({
            value: value,
            ref: innerRef
        });
        return ()=>{
            onUnregister({
                value: value,
                ref: innerRef
            });
        };
    }, [
        onRegister,
        onUnregister,
        innerRef,
        value
    ]);
    const iconSlot = (0, $fcf7ddccaab7fd8f$exports).optional(icon, {
        elementType: 'span'
    });
    const contentSlot = (0, $fcf7ddccaab7fd8f$exports).always(content, {
        defaultProps: {
            children: props.children
        },
        elementType: 'span'
    });
    const iconOnly = Boolean((iconSlot === null || iconSlot === void 0 ? void 0 : iconSlot.children) && !contentSlot.children);
    return {
        components: {
            root: 'button',
            icon: 'span',
            content: 'span',
            contentReservedSpace: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, innerRef),
            role: 'tab',
            type: 'button',
            // aria-selected undefined indicates it is not selectable
            // according to https://www.w3.org/TR/wai-aria-1.1/#aria-selected
            'aria-selected': disabled ? undefined : `${selected}`,
            value: value,
            ...rest,
            disabled: disabled,
            onClick: onTabClick,
            onFocus: selectTabOnFocus ? onTabFocus : onFocus
        }, {
            elementType: 'button'
        }),
        icon: iconSlot,
        iconOnly: iconOnly,
        content: contentSlot,
        disabled: disabled,
        selected: selected,
        value: value,
        vertical: vertical
    };
};
const $5657584a340f9723$export$a06d8240a859b3c5 = ({ selected: selected })=>{
    return (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        focusable: {
            isDefault: selected
        }
    });
};




const $ae8d80517c3a17a0$export$7c9a304efcb2001d = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            !state.iconOnly && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.content, {}),
            state.contentReservedSpace && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.contentReservedSpace, {})
        ]
    });
};






var $acw62 = parcelRequire("acw62");




'use client';
// eslint-disable-next-line @typescript-eslint/naming-convention
const $823bb986c9572888$var$tabIndicatorCssVars_unstable = {
    offsetVar: '--fui-Tab__indicator--offset',
    scaleVar: '--fui-Tab__indicator--scale'
};
const $823bb986c9572888$var$useActiveIndicatorStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg"
    },
    animated: {
        Ba2ppi3: "fhwpy7i",
        F2fol1: "f6zz20j",
        B1dyfl9: "f1ai4sc1",
        Bu93a1u: "f1rnm8gg",
        Bdasjez: "f1x3cmqg"
    },
    horizontal: {
        sjv3b2: [
            "fug4aj8",
            "f1i5xzg7"
        ],
        b1kco5: "f1q7ujh"
    },
    vertical: {
        sjv3b2: "f1hqboyk",
        b1kco5: "f1dxupa6"
    }
}, {
    d: [
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        ".fhwpy7i::after{transition-property:transform;}",
        ".f6zz20j::after{transition-duration:var(--durationSlow);}",
        ".f1ai4sc1::after{transition-timing-function:var(--curveDecelerateMax);}",
        ".fug4aj8::after{transform-origin:left;}",
        ".f1i5xzg7::after{transform-origin:right;}",
        ".f1q7ujh::after{transform:translateX(var(--fui-Tab__indicator--offset)) scaleX(var(--fui-Tab__indicator--scale));}",
        ".f1hqboyk::after{transform-origin:top;}",
        ".f1dxupa6::after{transform:translateY(var(--fui-Tab__indicator--offset)) scaleY(var(--fui-Tab__indicator--scale));}"
    ],
    m: [
        [
            "@media (prefers-reduced-motion: reduce){.f1rnm8gg::after{transition-property:none;}}",
            {
                m: "(prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media (prefers-reduced-motion: reduce){.f1x3cmqg::after{transition-duration:0.01ms;}}",
            {
                m: "(prefers-reduced-motion: reduce)"
            }
        ]
    ]
});
const $823bb986c9572888$var$calculateTabRect = (element)=>{
    if (element) {
        var _element_parentElement;
        const parentRect = ((_element_parentElement = element.parentElement) === null || _element_parentElement === void 0 ? void 0 : _element_parentElement.getBoundingClientRect()) || {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const tabRect = element.getBoundingClientRect();
        return {
            x: tabRect.x - parentRect.x,
            y: tabRect.y - parentRect.y,
            width: tabRect.width,
            height: tabRect.height
        };
    }
    return undefined;
};
const $823bb986c9572888$var$getRegisteredTabRect = (registeredTabs, value)=>{
    var _registeredTabs_JSON_stringify;
    const element = $823bb986c9572888$var$isValueDefined(value) ? (_registeredTabs_JSON_stringify = registeredTabs[JSON.stringify(value)]) === null || _registeredTabs_JSON_stringify === void 0 ? void 0 : _registeredTabs_JSON_stringify.ref.current : undefined;
    return element ? $823bb986c9572888$var$calculateTabRect(element) : undefined;
};
// eslint-disable-next-line eqeqeq
const $823bb986c9572888$var$isValueDefined = (value)=>value != null;
const $823bb986c9572888$export$f8d2e05e3dc813b7 = (state)=>{
    const { disabled: disabled, selected: selected, vertical: vertical } = state;
    const activeIndicatorStyles = $823bb986c9572888$var$useActiveIndicatorStyles();
    const [lastAnimatedFrom, setLastAnimatedFrom] = $acw62.useState();
    const [animationValues, setAnimationValues] = $acw62.useState({
        offset: 0,
        scale: 1
    });
    const getRegisteredTabs = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.getRegisteredTabs);
    const [requestAnimationFrame] = (0, $b13e6753fef1f098$export$641fa9c94086b46e)();
    if (selected) {
        const { previousSelectedValue: previousSelectedValue, selectedValue: selectedValue, registeredTabs: registeredTabs } = getRegisteredTabs();
        if ($823bb986c9572888$var$isValueDefined(previousSelectedValue) && lastAnimatedFrom !== previousSelectedValue) {
            const previousSelectedTabRect = $823bb986c9572888$var$getRegisteredTabRect(registeredTabs, previousSelectedValue);
            const selectedTabRect = $823bb986c9572888$var$getRegisteredTabRect(registeredTabs, selectedValue);
            if (selectedTabRect && previousSelectedTabRect) {
                const offset = vertical ? previousSelectedTabRect.y - selectedTabRect.y : previousSelectedTabRect.x - selectedTabRect.x;
                const scale = vertical ? previousSelectedTabRect.height / selectedTabRect.height : previousSelectedTabRect.width / selectedTabRect.width;
                setAnimationValues({
                    offset: offset,
                    scale: scale
                });
                setLastAnimatedFrom(previousSelectedValue);
                // Reset the animation values after the animation is complete
                requestAnimationFrame(()=>setAnimationValues({
                        offset: 0,
                        scale: 1
                    }));
            }
        }
    } else if ($823bb986c9572888$var$isValueDefined(lastAnimatedFrom)) // need to clear the last animated from so that if this tab is selected again
    // from the same previous tab as last time, that animation still happens.
    setLastAnimatedFrom(undefined);
    // do not apply any animation if the tab is disabled
    if (disabled) return state;
    // the animation should only happen as the selection indicator returns to its
    // original position and not when set at the previous tabs position.
    const animating = animationValues.offset === 0 && animationValues.scale === 1;
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(state.root.className, selected && activeIndicatorStyles.base, selected && animating && activeIndicatorStyles.animated, selected && (vertical ? activeIndicatorStyles.vertical : activeIndicatorStyles.horizontal));
    const rootCssVars = {
        [$823bb986c9572888$var$tabIndicatorCssVars_unstable.offsetVar]: `${animationValues.offset}px`,
        [$823bb986c9572888$var$tabIndicatorCssVars_unstable.scaleVar]: `${animationValues.scale}`
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.style = {
        ...rootCssVars,
        ...state.root.style
    };
    return state;
};


'use client';
const $cca6131b04bae038$export$d2cf99ac72de8868 = {
    root: 'fui-Tab',
    icon: 'fui-Tab__icon',
    content: 'fui-Tab__content'
};
const $cca6131b04bae038$export$6053ee58c1392397 = {
    content: 'fui-Tab__content--reserved-space'
};
// These should match the constants defined in @fluentui/react-icons
// This package avoids taking a dependency on the icons package for only the constants.
const $cca6131b04bae038$var$iconClassNames = {
    filled: 'fui-Icon-filled',
    regular: 'fui-Icon-regular'
};
/**
 * Styles for the root slot
 */ const $cca6131b04bae038$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bt984gj: "f122n59",
        mc9l5x: "f13qh94s",
        Bnnss6s: "fi64zpg",
        Bxotwcr: "f1u07yai",
        Budl1dq: "frn2hmy",
        wkccdc: "f1olsevy",
        oeaueh: "f1s6fcnf",
        qhf8xq: "f10pi13n"
    },
    button: {
        Bt984gj: "f122n59",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bceei9c: "f1k6fduh",
        mc9l5x: "f13qh94s",
        Bnnss6s: "fi64zpg",
        Bxotwcr: "f1u07yai",
        Budl1dq: "frn2hmy",
        wkccdc: "f1olsevy",
        Bahqtrf: "fk6fouc",
        Bg96gwp: "f1i3iumi",
        oeaueh: "f1s6fcnf",
        qhf8xq: "f10pi13n",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        B9bfxx9: "f1cxpek8"
    },
    horizontal: {
        Brf1p80: "f4d9j23"
    },
    vertical: {
        Brf1p80: "f1s9ku6b"
    },
    smallHorizontal: {
        i8kkvl: "f14mj54c",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1wmopi4"
    },
    smallVertical: {
        i8kkvl: "f14mj54c",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f12or63q"
    },
    mediumHorizontal: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1w08f2p"
    },
    mediumVertical: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fymxs25"
    },
    largeHorizontal: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1ssfvub"
    },
    largeVertical: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fwkd1rq"
    },
    transparent: {
        De3pzq: "f1c21dwh",
        B95qlz1: "f9rvdkv",
        B7xitij: "f1051ucx",
        Bptxc3x: "fmmjozx",
        Bwqhzpy: "fqhzt5g",
        iyk698: "f7l5cgy",
        cl4aha: "fpkze5g",
        B0q3jbp: "f1iywnoi",
        Be9ayug: "f9n45c4"
    },
    subtle: {
        De3pzq: "fhovq9v",
        B95qlz1: "f1bifk9c",
        B7xitij: "fo6hitd",
        Bptxc3x: "fmmjozx",
        Bwqhzpy: "fqhzt5g",
        iyk698: "f7l5cgy",
        cl4aha: "fpkze5g",
        B0q3jbp: "f1iywnoi",
        Be9ayug: "f9n45c4"
    },
    disabledCursor: {
        Bceei9c: "fdrzuqr"
    },
    disabled: {
        De3pzq: "f1c21dwh",
        Bptxc3x: "fato7r6",
        cl4aha: "fao1bnu"
    },
    selected: {
        Bptxc3x: "f1cadz5z",
        Bwqhzpy: "fwhdxxj",
        iyk698: "fintccb",
        cl4aha: "ffplhdr",
        B0q3jbp: "fjo17wb",
        Be9ayug: "f148789c"
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f13qh94s{display:grid;}",
        ".fi64zpg{flex-shrink:0;}",
        ".f1u07yai{grid-auto-flow:column;}",
        ".frn2hmy{grid-template-columns:auto;}",
        ".f1olsevy{grid-template-rows:auto;}",
        ".f1s6fcnf{outline-style:none;}",
        ".f10pi13n{position:relative;}",
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f1k6fduh{cursor:pointer;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f1cxpek8{text-transform:none;}",
        ".f4d9j23{justify-content:center;}",
        ".f1s9ku6b{justify-content:start;}",
        ".f14mj54c{column-gap:var(--spacingHorizontalXXS);}",
        [
            ".f1wmopi4{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f12or63q{padding:var(--spacingVerticalXXS) var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        ".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}",
        [
            ".f1w08f2p{padding:var(--spacingVerticalM) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".fymxs25{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f1ssfvub{padding:var(--spacingVerticalL) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".fwkd1rq{padding:var(--spacingVerticalS) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f9rvdkv:enabled:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f1051ucx:enabled:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".fmmjozx .fui-Tab__icon{color:var(--colorNeutralForeground2);}",
        ".fqhzt5g:enabled:hover .fui-Tab__icon{color:var(--colorNeutralForeground2Hover);}",
        ".f7l5cgy:enabled:active .fui-Tab__icon{color:var(--colorNeutralForeground2Pressed);}",
        ".fpkze5g .fui-Tab__content{color:var(--colorNeutralForeground2);}",
        ".f1iywnoi:enabled:hover .fui-Tab__content{color:var(--colorNeutralForeground2Hover);}",
        ".f9n45c4:enabled:active .fui-Tab__content{color:var(--colorNeutralForeground2Pressed);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".fato7r6 .fui-Tab__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".fao1bnu .fui-Tab__content{color:var(--colorNeutralForegroundDisabled);}",
        ".f1cadz5z .fui-Tab__icon{color:var(--colorCompoundBrandForeground1);}",
        ".fwhdxxj:enabled:hover .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Hover);}",
        ".fintccb:enabled:active .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Pressed);}",
        ".ffplhdr .fui-Tab__content{color:var(--colorNeutralForeground1);}",
        ".fjo17wb:enabled:hover .fui-Tab__content{color:var(--colorNeutralForeground1Hover);}",
        ".f148789c:enabled:active .fui-Tab__content{color:var(--colorNeutralForeground1Pressed);}"
    ]
});
const $cca6131b04bae038$var$useCircularAppearanceStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f44lkw9",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fp7rvkm",
        Bptxc3x: "ftorr8m",
        cl4aha: "f16lqpmv"
    },
    small: {
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "fzklhed"
    },
    medium: {
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "f1j721cc"
    },
    large: {
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "frx9knr"
    },
    subtle: {
        De3pzq: "fhovq9v",
        sj55zd: "fkfq4zb",
        B95qlz1: "f1bifk9c",
        Eo63ln: 0,
        r9osk6: 0,
        Itrz8y: 0,
        zeg6vx: 0,
        l65xgk: 0,
        Bw4olcx: 0,
        Folb0i: 0,
        I2h8y4: 0,
        Bgxgoyi: 0,
        Bvlkotb: 0,
        Fwyncl: 0,
        Byh5edv: 0,
        Becqvjq: 0,
        uumbiq: 0,
        B73q3dg: 0,
        Bblwbaf: 0,
        B0ezav: "ft57sj0",
        r4wkhp: "f1fcoy83",
        B7xitij: "fo6hitd",
        d3wsvi: 0,
        Hdqn7s: 0,
        zu5y1p: 0,
        owqphb: 0,
        g9c53k: 0,
        Btmu08z: 0,
        Bthxvy6: 0,
        gluvuq: 0,
        tb88gp: 0,
        wns6jk: 0,
        kdfdk4: 0,
        Bbw008l: 0,
        Bayi1ib: 0,
        B1kkfu3: 0,
        J1oqyp: 0,
        kem6az: 0,
        goa3yj: "fhn220o",
        p743kt: "f15qf7sh",
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1mljprk"
    },
    subtleSelected: {
        De3pzq: "f16xkysk",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f1c2pc3t",
        sj55zd: "faj9fo0",
        B95qlz1: "fsm7zmf",
        Eo63ln: 0,
        r9osk6: 0,
        Itrz8y: 0,
        zeg6vx: 0,
        l65xgk: 0,
        Bw4olcx: 0,
        Folb0i: 0,
        I2h8y4: 0,
        Bgxgoyi: 0,
        Bvlkotb: 0,
        Fwyncl: 0,
        Byh5edv: 0,
        Becqvjq: 0,
        uumbiq: 0,
        B73q3dg: 0,
        Bblwbaf: 0,
        B0ezav: "f1wo0sfq",
        r4wkhp: "f1afuynh",
        B7xitij: "f94ddyl",
        d3wsvi: 0,
        Hdqn7s: 0,
        zu5y1p: 0,
        owqphb: 0,
        g9c53k: 0,
        Btmu08z: 0,
        Bthxvy6: 0,
        gluvuq: 0,
        tb88gp: 0,
        wns6jk: 0,
        kdfdk4: 0,
        Bbw008l: 0,
        Bayi1ib: 0,
        B1kkfu3: 0,
        J1oqyp: 0,
        kem6az: 0,
        goa3yj: "fmle6oo",
        p743kt: "f1d3itm4",
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1e9l2u"
    },
    subtleDisabled: {
        De3pzq: "fhovq9v",
        sj55zd: "f1s2aq7o"
    },
    subtleDisabledSelected: {
        De3pzq: "f1bg9a2p",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fegtqic",
        sj55zd: "f1s2aq7o"
    },
    filled: {
        De3pzq: "f16xq7d1",
        sj55zd: "fkfq4zb",
        B95qlz1: "fwwxidx",
        r4wkhp: "f1fcoy83",
        B7xitij: "f14i52sd",
        p743kt: "f15qf7sh",
        Hhssn: "f1cpi5f4",
        uaurb9: "f6pj1s0",
        B401qx7: "f12sz5kj",
        Buyp1jb: "f17588c3",
        gsp74p: "fnthgdt"
    },
    filledSelected: {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk",
        B95qlz1: "f1lm9dni",
        r4wkhp: "f1mn5ei1",
        B7xitij: "f1g6ncd0",
        p743kt: "fl71aob",
        Gedr8k: "f14zl92z",
        Bm69vlq: "f16zy3eu",
        Bodipah: "f1gdgb7p",
        B5kpen0: "f1tua9ng"
    },
    filledDisabled: {
        De3pzq: "f1bg9a2p",
        sj55zd: "f1s2aq7o"
    },
    filledDisabledSelected: {
        De3pzq: "f1bg9a2p",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fegtqic",
        sj55zd: "f1s2aq7o"
    }
}, {
    d: [
        [
            ".f44lkw9{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".fp7rvkm{border:solid var(--strokeWidthThin) var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".ftorr8m .fui-Tab__icon{color:inherit;}",
        ".f16lqpmv .fui-Tab__content{color:inherit;}",
        [
            ".fzklhed{padding-block:calc(var(--spacingVerticalXXS) - var(--strokeWidthThin));}",
            {
                p: -1
            }
        ],
        [
            ".f1j721cc{padding-block:calc(var(--spacingVerticalSNudge) - var(--strokeWidthThin));}",
            {
                p: -1
            }
        ],
        [
            ".frx9knr{padding-block:calc(var(--spacingVerticalS) - var(--strokeWidthThin));}",
            {
                p: -1
            }
        ],
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",
        [
            ".ft57sj0:enabled:hover{border:solid var(--strokeWidthThin) var(--colorNeutralStroke1Hover);}",
            {
                p: -2
            }
        ],
        ".f1fcoy83:enabled:hover{color:var(--colorNeutralForeground2Hover);}",
        ".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",
        [
            ".fhn220o:enabled:active{border:solid var(--strokeWidthThin) var(--colorNeutralStroke1Pressed);}",
            {
                p: -2
            }
        ],
        ".f15qf7sh:enabled:active{color:var(--colorNeutralForeground2Pressed);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        [
            ".f1c2pc3t{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStroke);}",
            {
                p: -2
            }
        ],
        ".faj9fo0{color:var(--colorBrandForeground2);}",
        ".fsm7zmf:enabled:hover{background-color:var(--colorBrandBackground2Hover);}",
        [
            ".f1wo0sfq:enabled:hover{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStrokeHover);}",
            {
                p: -2
            }
        ],
        ".f1afuynh:enabled:hover{color:var(--colorBrandForeground2Hover);}",
        ".f94ddyl:enabled:active{background-color:var(--colorBrandBackground2Pressed);}",
        [
            ".fmle6oo:enabled:active{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStrokePressed);}",
            {
                p: -2
            }
        ],
        ".f1d3itm4:enabled:active{color:var(--colorBrandForeground2Pressed);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        [
            ".fegtqic{border:solid var(--strokeWidthThin) var(--colorNeutralStrokeDisabled);}",
            {
                p: -2
            }
        ],
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fwwxidx:enabled:hover{background-color:var(--colorNeutralBackground3Hover);}",
        ".f14i52sd:enabled:active{background-color:var(--colorNeutralBackground3Pressed);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1lm9dni:enabled:hover{background-color:var(--colorBrandBackgroundHover);}",
        ".f1mn5ei1:enabled:hover{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1g6ncd0:enabled:active{background-color:var(--colorBrandBackgroundPressed);}",
        ".fl71aob:enabled:active{color:var(--colorNeutralForegroundOnBrand);}",
        [
            ".fegtqic{border:solid var(--strokeWidthThin) var(--colorNeutralStrokeDisabled);}",
            {
                p: -2
            }
        ]
    ],
    m: [
        [
            "@media (forced-colors: active){.f1mljprk{border:solid var(--strokeWidthThin) Canvas;}}",
            {
                p: -2,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1e9l2u{border:solid var(--strokeWidthThin) Highlight;}}",
            {
                p: -2,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cpi5f4:enabled:hover{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f6pj1s0:enabled:hover{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f12sz5kj:enabled:hover .fui-Tab__content{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f17588c3:enabled:hover .fui-Icon-filled{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fnthgdt:enabled:hover .fui-Icon-regular{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14zl92z:enabled{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16zy3eu:enabled .fui-Tab__content{color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1gdgb7p:enabled .fui-Tab__content{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1tua9ng:enabled .fui-Tab__icon{color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
/**
 * Focus styles for the root slot
 */ const $cca6131b04bae038$var$useFocusStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bn4voq9: "f1p7hgxw",
        Bfpq7zp: "f1way5bb",
        g9k6zt: "f9znhxp",
        j6ew2k: [
            "fqa318h",
            "fqa318h"
        ],
        Bhxq17a: "f1vjpng2"
    },
    circular: {
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bn4voq9: "f1p7hgxw",
        Bfpq7zp: "f1way5bb",
        g9k6zt: "f9znhxp",
        j6ew2k: [
            "fzgyhws",
            "fqxug60"
        ],
        Bhxq17a: "f1vjpng2"
    }
}, {
    d: [
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f1p7hgxw[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);}",
        ".f1way5bb[data-fui-focus-visible]{outline-color:transparent;}",
        ".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",
        ".fqa318h[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2);}",
        ".f1vjpng2[data-fui-focus-visible]{z-index:1;}",
        ".fzgyhws[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2),0 0 0 var(--strokeWidthThin) var(--colorNeutralStrokeOnBrand) inset;}",
        ".fqxug60[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2),0 0 0 var(--strokeWidthThin) var(--colorNeutralStrokeOnBrand) inset;}"
    ]
});
/** Indicator styles for when pending selection */ const $cca6131b04bae038$var$usePendingIndicatorStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        az7l2e: "fhw179n",
        vqofr: 0,
        Bv4n3vi: 0,
        Bgqb9hq: 0,
        B0uxbk8: 0,
        Bf3jju6: "fg9j5n4",
        amg5m6: "f1kmhr4c",
        zkfqfm: "fl1ydde",
        Bkydozb: "f1y7maxz",
        Bka2azo: 0,
        vzq8l0: 0,
        csmgbd: 0,
        Br4ovkg: 0,
        aelrif: "fceyvr4",
        y36c18: "f16cxu0",
        B1ctymy: "f1nwgacf",
        xzc5d: "fm6alxz",
        h5yqg8: "fhx32z1"
    },
    disabled: {
        az7l2e: "f1ut20fw",
        Bkydozb: "fhrzcfn",
        xzc5d: "fw15awd",
        h5yqg8: "faqmq51"
    },
    smallHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1r53b5e",
        Fbdkly: [
            "f1s6rxz5",
            "fo35v8s"
        ],
        mdwyqc: [
            "fo35v8s",
            "f1s6rxz5"
        ]
    },
    smallVertical: {
        lawp4y: "fze4zud",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "fdp32p8",
        Ccq8qp: "f1aij3q"
    },
    mediumHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1s2r9ax",
        Fbdkly: [
            "f1o0nnkk",
            "fxb7rol"
        ],
        mdwyqc: [
            "fxb7rol",
            "f1o0nnkk"
        ]
    },
    mediumVertical: {
        lawp4y: "f17jracn",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "f117lcb2",
        Ccq8qp: "f1aij3q"
    },
    largeHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1s2r9ax",
        Fbdkly: [
            "f1o0nnkk",
            "fxb7rol"
        ],
        mdwyqc: [
            "fxb7rol",
            "f1o0nnkk"
        ]
    },
    largeVertical: {
        lawp4y: "fel9d3z",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "f6vqlre",
        Ccq8qp: "f1aij3q"
    }
}, {
    h: [
        ".fhw179n:hover::before{background-color:var(--colorNeutralStroke1Hover);}",
        [
            ".fg9j5n4:hover::before{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f1kmhr4c:hover::before{content:\"\";}",
        ".fl1ydde:hover::before{position:absolute;}",
        ".f1ut20fw:hover::before{background-color:var(--colorTransparentStroke);}"
    ],
    a: [
        ".f1y7maxz:active::before{background-color:var(--colorNeutralStroke1Pressed);}",
        [
            ".fceyvr4:active::before{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f16cxu0:active::before{content:\"\";}",
        ".f1nwgacf:active::before{position:absolute;}",
        ".fhrzcfn:active::before{background-color:var(--colorTransparentStroke);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fm6alxz:hover::before{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fhx32z1:active::before{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fw15awd:hover::before{background-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.faqmq51:active::before{background-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    d: [
        ".fchca7p::before{bottom:0;}",
        ".f1r53b5e::before{height:var(--strokeWidthThick);}",
        ".f1s6rxz5::before{left:var(--spacingHorizontalSNudge);}",
        ".fo35v8s::before{right:var(--spacingHorizontalSNudge);}",
        ".fze4zud::before{bottom:var(--spacingVerticalXS);}",
        ".f1fzr1x6::before{left:0;}",
        ".f1f351id::before{right:0;}",
        ".fdp32p8::before{top:var(--spacingVerticalXS);}",
        ".f1aij3q::before{width:var(--strokeWidthThicker);}",
        ".f1s2r9ax::before{height:var(--strokeWidthThicker);}",
        ".f1o0nnkk::before{left:var(--spacingHorizontalM);}",
        ".fxb7rol::before{right:var(--spacingHorizontalM);}",
        ".f17jracn::before{bottom:var(--spacingVerticalS);}",
        ".f117lcb2::before{top:var(--spacingVerticalS);}",
        ".fel9d3z::before{bottom:var(--spacingVerticalMNudge);}",
        ".f6vqlre::before{top:var(--spacingVerticalMNudge);}"
    ]
});
const $cca6131b04bae038$var$useActiveIndicatorStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Bjyk6c5: "f1rp0jgh",
        d9w3h3: 0,
        B3778ie: 0,
        B4j8arr: 0,
        Bl18szs: 0,
        Blrzh8d: "f3b9emi",
        Bsft5z2: "f13zj6fq",
        E3zdtr: "f1mdlcz9"
    },
    selected: {
        Bjyk6c5: "f1ksivud",
        Bej4dhw: "f1476jrx",
        B7wqxwa: "f18q216b",
        Hwb57: "f1wf6u82",
        Beg08s0: "f1xwit7m",
        Bo27r1v: "f1ksfgwi"
    },
    disabled: {
        Bjyk6c5: "f13lkzet"
    },
    smallHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f9bb2ob",
        Eqx8gd: [
            "f1q70ajw",
            "f18rbzdx"
        ],
        B1piin3: [
            "f18rbzdx",
            "f1q70ajw"
        ]
    },
    smallVertical: {
        By385i5: "fqbue9b",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "fk1klkt",
        a2br6o: "f1o25lip"
    },
    mediumHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f1vx7lu8",
        Eqx8gd: [
            "fna7m5n",
            "f1oxpfwv"
        ],
        B1piin3: [
            "f1oxpfwv",
            "fna7m5n"
        ]
    },
    mediumVertical: {
        By385i5: "fipylg0",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "fqchiol",
        a2br6o: "f1o25lip"
    },
    largeHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f1vx7lu8",
        Eqx8gd: [
            "fna7m5n",
            "f1oxpfwv"
        ],
        B1piin3: [
            "f1oxpfwv",
            "fna7m5n"
        ]
    },
    largeVertical: {
        By385i5: "f1w7dm5g",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "f1p6em4m",
        a2br6o: "f1o25lip"
    }
}, {
    d: [
        ".f1rp0jgh::after{background-color:var(--colorTransparentStroke);}",
        [
            ".f3b9emi::after{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f13zj6fq::after{content:\"\";}",
        ".f1mdlcz9::after{position:absolute;}",
        ".f1ksivud::after{background-color:var(--colorCompoundBrandStroke);}",
        ".f1476jrx:enabled:hover::after{background-color:var(--colorCompoundBrandStrokeHover);}",
        ".f18q216b:enabled:active::after{background-color:var(--colorCompoundBrandStrokePressed);}",
        ".f13lkzet::after{background-color:var(--colorNeutralForegroundDisabled);}",
        ".fo72kxq::after{bottom:0;}",
        ".f9bb2ob::after{height:var(--strokeWidthThick);}",
        ".f1q70ajw::after{left:var(--spacingHorizontalSNudge);}",
        ".f18rbzdx::after{right:var(--spacingHorizontalSNudge);}",
        ".fqbue9b::after{bottom:var(--spacingVerticalXS);}",
        ".f1n6gb5g::after{left:0;}",
        ".f15yvnhg::after{right:0;}",
        ".fk1klkt::after{top:var(--spacingVerticalXS);}",
        ".f1o25lip::after{width:var(--strokeWidthThicker);}",
        ".f1vx7lu8::after{height:var(--strokeWidthThicker);}",
        ".fna7m5n::after{left:var(--spacingHorizontalM);}",
        ".f1oxpfwv::after{right:var(--spacingHorizontalM);}",
        ".fipylg0::after{bottom:var(--spacingVerticalS);}",
        ".fqchiol::after{top:var(--spacingVerticalS);}",
        ".f1w7dm5g::after{bottom:var(--spacingVerticalMNudge);}",
        ".f1p6em4m::after{top:var(--spacingVerticalMNudge);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1wf6u82::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1xwit7m:enabled:hover::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ksfgwi:enabled:active::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
/**
 * Styles for the icon slot.
 */ const $cca6131b04bae038$var$useIconStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Br312pm: "fwpfdsa",
        Ijaq50: "f16hsg94",
        Bt984gj: "f122n59",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        D0sxk3: "f16u1re",
        t6yez3: "f8bsbmo"
    },
    small: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3"
    },
    medium: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3"
    },
    large: {
        Be2twd7: "f1rt2boy",
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun"
    },
    selected: {
        D0sxk3: "fxoiby5",
        t6yez3: "f15q0o9g"
    }
}, {
    d: [
        ".fwpfdsa{grid-column-start:1;}",
        ".f16hsg94{grid-row-start:1;}",
        ".f122n59{align-items:center;}",
        ".ftuwxu6{display:inline-flex;}",
        ".f4d9j23{justify-content:center;}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f16u1re .fui-Icon-filled{display:none;}",
        ".f8bsbmo .fui-Icon-regular{display:inline;}",
        ".fe5j1ua{font-size:20px;}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".f1rt2boy{font-size:24px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".fxoiby5 .fui-Icon-filled{display:inline;}",
        ".f15q0o9g .fui-Icon-regular{display:none;}"
    ]
});
/**
 * Styles for the content slot (children)
 */ const $cca6131b04bae038$var$useContentStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1bwptpd"
    },
    selected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k"
    },
    largeSelected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    noIconBefore: {
        Br312pm: "fwpfdsa",
        Ijaq50: "f16hsg94"
    },
    iconBefore: {
        Br312pm: "fd46tj4",
        Ijaq50: "f16hsg94"
    },
    placeholder: {
        Bcdw1i0: "fd7fpy0"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        [
            ".f1bwptpd{padding:var(--spacingVerticalNone) var(--spacingHorizontalXXS);}",
            {
                p: -1
            }
        ],
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fwpfdsa{grid-column-start:1;}",
        ".f16hsg94{grid-row-start:1;}",
        ".fd46tj4{grid-column-start:2;}",
        ".fd7fpy0{visibility:hidden;}"
    ]
});
const $cca6131b04bae038$export$c914f0c90bb795be = (state)=>{
    'use no memo';
    // justified: compiler would optimize useTabStyles_unstable — manual opt-out to preserve runtime behavior
    $cca6131b04bae038$export$b351243d2ff13d6b(state);
    $cca6131b04bae038$export$61fc88aa2d7333b8(state, state.root);
    $cca6131b04bae038$export$8a41eb0bebca9fad(state);
    return state;
};
const $cca6131b04bae038$export$b351243d2ff13d6b = (state)=>{
    const rootStyles = $cca6131b04bae038$var$useRootStyles();
    const pendingIndicatorStyles = $cca6131b04bae038$var$usePendingIndicatorStyles();
    const activeIndicatorStyles = $cca6131b04bae038$var$useActiveIndicatorStyles();
    const { appearance: appearance, disabled: disabled, selected: selected, size: size, vertical: vertical } = state;
    const classes = [
        $cca6131b04bae038$export$d2cf99ac72de8868.root,
        rootStyles.root
    ];
    if (appearance !== 'subtle-circular' && appearance !== 'filled-circular') classes.push(// pending indicator (before pseudo element)
    pendingIndicatorStyles.base, size === 'small' && (vertical ? pendingIndicatorStyles.smallVertical : pendingIndicatorStyles.smallHorizontal), size === 'medium' && (vertical ? pendingIndicatorStyles.mediumVertical : pendingIndicatorStyles.mediumHorizontal), size === 'large' && (vertical ? pendingIndicatorStyles.largeVertical : pendingIndicatorStyles.largeHorizontal), disabled && pendingIndicatorStyles.disabled, // active indicator (after pseudo element)
    selected && activeIndicatorStyles.base, selected && !disabled && activeIndicatorStyles.selected, selected && size === 'small' && (vertical ? activeIndicatorStyles.smallVertical : activeIndicatorStyles.smallHorizontal), selected && size === 'medium' && (vertical ? activeIndicatorStyles.mediumVertical : activeIndicatorStyles.mediumHorizontal), selected && size === 'large' && (vertical ? activeIndicatorStyles.largeVertical : activeIndicatorStyles.largeHorizontal), selected && disabled && activeIndicatorStyles.disabled);
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(...classes, state.root.className);
    (0, $823bb986c9572888$export$f8d2e05e3dc813b7)(state);
    return state;
};
const $cca6131b04bae038$export$61fc88aa2d7333b8 = (state, slot)=>{
    const rootStyles = $cca6131b04bae038$var$useRootStyles();
    const focusStyles = $cca6131b04bae038$var$useFocusStyles();
    const circularStyles = $cca6131b04bae038$var$useCircularAppearanceStyles();
    const { appearance: appearance, disabled: disabled, selected: selected, size: size, vertical: vertical } = state;
    const isSubtleCircular = appearance === 'subtle-circular';
    const isFilledCircular = appearance === 'filled-circular';
    const isCircular = isSubtleCircular || isFilledCircular;
    const circularAppearance = [
        circularStyles.base,
        focusStyles.circular,
        // sizes
        size === 'small' && circularStyles.small,
        size === 'medium' && circularStyles.medium,
        size === 'large' && circularStyles.large,
        // subtle-circular appearance
        isSubtleCircular && circularStyles.subtle,
        selected && isSubtleCircular && circularStyles.subtleSelected,
        disabled && isSubtleCircular && circularStyles.subtleDisabled,
        selected && disabled && isSubtleCircular && circularStyles.subtleDisabledSelected,
        // filled-circular appearance
        isFilledCircular && circularStyles.filled,
        selected && isFilledCircular && circularStyles.filledSelected,
        disabled && isFilledCircular && circularStyles.filledDisabled,
        selected && disabled && isFilledCircular && circularStyles.filledDisabledSelected
    ];
    const regularAppearance = [
        focusStyles.base,
        !disabled && appearance === 'subtle' && rootStyles.subtle,
        !disabled && appearance === 'transparent' && rootStyles.transparent,
        !disabled && selected && rootStyles.selected,
        disabled && rootStyles.disabled
    ];
    // eslint-disable-next-line react-hooks/immutability
    slot.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(rootStyles.button, // orientation
    vertical ? rootStyles.vertical : rootStyles.horizontal, // size
    size === 'small' && (vertical ? rootStyles.smallVertical : rootStyles.smallHorizontal), size === 'medium' && (vertical ? rootStyles.mediumVertical : rootStyles.mediumHorizontal), size === 'large' && (vertical ? rootStyles.largeVertical : rootStyles.largeHorizontal), ...isCircular ? circularAppearance : regularAppearance, disabled && rootStyles.disabledCursor, slot.className);
    return state;
};
const $cca6131b04bae038$export$8a41eb0bebca9fad = (state)=>{
    const iconStyles = $cca6131b04bae038$var$useIconStyles();
    const contentStyles = $cca6131b04bae038$var$useContentStyles();
    const { selected: selected, size: size } = state;
    if (state.icon) // eslint-disable-next-line react-hooks/immutability
    state.icon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($cca6131b04bae038$export$d2cf99ac72de8868.icon, iconStyles.base, iconStyles[size], selected && iconStyles.selected, state.icon.className);
    // This needs to be before state.content.className is updated
    if (state.contentReservedSpace) {
        // eslint-disable-next-line react-hooks/immutability
        state.contentReservedSpace.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($cca6131b04bae038$export$6053ee58c1392397.content, contentStyles.base, size === 'large' ? contentStyles.largeSelected : contentStyles.selected, state.icon ? contentStyles.iconBefore : contentStyles.noIconBefore, contentStyles.placeholder, state.content.className);
        // FIXME: this is a deprecated API
        // should be removed in the next major version
        // eslint-disable-next-line @typescript-eslint/no-deprecated, react-hooks/immutability
        state.contentReservedSpaceClassName = state.contentReservedSpace.className;
    }
    // eslint-disable-next-line react-hooks/immutability
    state.content.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($cca6131b04bae038$export$d2cf99ac72de8868.content, contentStyles.base, size === 'large' && contentStyles.large, selected && (size === 'large' ? contentStyles.largeSelected : contentStyles.selected), state.icon ? contentStyles.iconBefore : contentStyles.noIconBefore, state.content.className);
    return state;
};



'use client';
const $71e914794eade933$export$3e41faf802a29e71 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $5657584a340f9723$export$272a80fa5efc2477)(props, ref);
    (0, $cca6131b04bae038$export$c914f0c90bb795be)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTabStyles_unstable')(state);
    return (0, $ae8d80517c3a17a0$export$7c9a304efcb2001d)(state);
});
$71e914794eade933$export$3e41faf802a29e71.displayName = 'Tab';


var $acw62 = parcelRequire("acw62");

const $0330a494ead718f0$export$ae4a83dd80e6ba2d = (props, ref)=>{
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : props.noNativeElements) ? 'div' : 'table';
    var _props_size, _props_noNativeElements, _props_sortable;
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'table' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        size: (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : 'medium',
        noNativeElements: (_props_noNativeElements = props.noNativeElements) !== null && _props_noNativeElements !== void 0 ? _props_noNativeElements : false,
        sortable: (_props_sortable = props.sortable) !== null && _props_sortable !== void 0 ? _props_sortable : false
    };
};





var $acw62 = parcelRequire("acw62");
'use client';
const $bf449bf33e2cb0a3$var$tableContext = $acw62.createContext(undefined);
const $bf449bf33e2cb0a3$export$d59e8974491c2a47 = {
    size: 'medium',
    noNativeElements: false,
    sortable: false
};
const $bf449bf33e2cb0a3$export$2304abde66e33a52 = $bf449bf33e2cb0a3$var$tableContext.Provider;
const $bf449bf33e2cb0a3$export$3cb274deb6c2d854 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($bf449bf33e2cb0a3$var$tableContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $bf449bf33e2cb0a3$export$d59e8974491c2a47;
};


const $908feebcfd4b84d6$export$72bba67a585be2a8 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $bf449bf33e2cb0a3$export$2304abde66e33a52), {
        value: contextValues.table,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};




'use client';
const $b9ca328e1ef003e1$export$e7ef44113e912046 = 'fui-Table';
const $b9ca328e1ef003e1$export$17b698a4158bc91 = {
    root: 'fui-Table'
};
const $b9ca328e1ef003e1$var$useTableLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1w4nmp0",
        ha4doy: "fmrv4ls",
        a9b677: "fly5x3f",
        B73mfa3: "f14m3nip"
    }
}, {
    d: [
        ".f1w4nmp0{display:table;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".fly5x3f{width:100%;}",
        ".f14m3nip{table-layout:fixed;}"
    ]
});
const $b9ca328e1ef003e1$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
/**
 * Styles for the root slot
 */ const $b9ca328e1ef003e1$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        po53p8: "fgkb47j",
        De3pzq: "fhovq9v"
    }
}, {
    d: [
        ".fgkb47j{border-collapse:collapse;}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}"
    ]
});
const $b9ca328e1ef003e1$export$9521445d686d1f01 = (state)=>{
    const styles = $b9ca328e1ef003e1$var$useStyles();
    const layoutStyles = {
        table: $b9ca328e1ef003e1$var$useTableLayoutStyles(),
        flex: $b9ca328e1ef003e1$var$useFlexLayoutStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($b9ca328e1ef003e1$export$e7ef44113e912046, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $d662d145b5ed04e3$export$10e27e49d8711f5d(state) {
    const { size: size, noNativeElements: noNativeElements, sortable: sortable } = state;
    const tableContext = $acw62.useMemo(()=>({
            noNativeElements: noNativeElements,
            size: size,
            sortable: sortable
        }), [
        noNativeElements,
        size,
        sortable
    ]);
    return {
        table: tableContext
    };
}



'use client';
const $bf8e3f93ce344917$export$54ec01a60f47d33d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $0330a494ead718f0$export$ae4a83dd80e6ba2d)(props, ref);
    (0, $b9ca328e1ef003e1$export$9521445d686d1f01)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableStyles_unstable')(state);
    return (0, $908feebcfd4b84d6$export$72bba67a585be2a8)(state, (0, $d662d145b5ed04e3$export$10e27e49d8711f5d)(state));
});
$bf8e3f93ce344917$export$54ec01a60f47d33d.displayName = 'Table';


var $acw62 = parcelRequire("acw62");


'use client';
const $8101482021a5884c$export$b741573d470b5ef8 = (props, ref)=>{
    const { noNativeElements: noNativeElements } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'tbody';
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'rowgroup' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements: noNativeElements
    };
};




const $84bc9f9e87c62eb4$export$d1288c869c03293b = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};



'use client';
const $bffb00ac76cc8178$var$useTableLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1tp1avn"
    }
}, {
    d: [
        ".f1tp1avn{display:table-row-group;}"
    ]
});
const $bffb00ac76cc8178$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
const $bffb00ac76cc8178$export$e20b03b28efd7e23 = 'fui-TableBody';
const $bffb00ac76cc8178$export$86e68acdc819877e = {
    root: 'fui-TableBody'
};
const $bffb00ac76cc8178$export$a5642703f6d0b5f2 = (state)=>{
    const layoutStyles = {
        table: $bffb00ac76cc8178$var$useTableLayoutStyles(),
        flex: $bffb00ac76cc8178$var$useFlexLayoutStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($bffb00ac76cc8178$export$e20b03b28efd7e23, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
};



'use client';
const $3f2f433630850f26$export$76ccd210b9029917 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8101482021a5884c$export$b741573d470b5ef8)(props, ref);
    (0, $bffb00ac76cc8178$export$a5642703f6d0b5f2)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableBodyStyles_unstable')(state);
    return (0, $84bc9f9e87c62eb4$export$d1288c869c03293b)(state);
});
$3f2f433630850f26$export$76ccd210b9029917.displayName = 'TableBody';


var $acw62 = parcelRequire("acw62");


'use client';
const $00c499bc138309ea$export$6ead74c378e7a6c7 = (props, ref)=>{
    const { noNativeElements: noNativeElements, size: size } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'td';
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'cell' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements: noNativeElements,
        size: size
    };
};




const $29e6fbfd80438988$export$386709cc44b79068 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};





'use client';
const $8f182bcf5e72beb2$export$83ece4e0726d8cb4 = 'fui-TableCell';
const $8f182bcf5e72beb2$export$966b503d9ebcb5b = {
    root: $8f182bcf5e72beb2$export$83ece4e0726d8cb4
};
const $8f182bcf5e72beb2$var$useTableLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    },
    medium: {
        Bqenvij: "f1ft4266"
    },
    small: {
        Bqenvij: "fbsu25e"
    },
    "extra-small": {
        Bqenvij: "frvgh55"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f1ft4266{height:44px;}",
        ".fbsu25e{height:34px;}",
        ".frvgh55{height:24px;}"
    ]
});
const $8f182bcf5e72beb2$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Bf4jedk: "f10tiqix",
        Bt984gj: "f122n59",
        xawz: 0,
        Bh6795r: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr"
    },
    medium: {
        sshi5w: "f5pgtk9"
    },
    small: {
        sshi5w: "fcep9tg"
    },
    "extra-small": {
        sshi5w: "f1pha7fy"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f10tiqix{min-width:0px;}",
        ".f122n59{align-items:center;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f5pgtk9{min-height:44px;}",
        ".fcep9tg{min-height:34px;}",
        ".f1pha7fy{min-height:24px;}"
    ]
});
/**
 * Styles for the root slot
 */ const $8f182bcf5e72beb2$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        qhf8xq: "f10pi13n",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f3gpkru",
        Bfpq7zp: 0,
        g9k6zt: 0,
        Bn4voq9: 0,
        giviqs: "f1dxfoyt",
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f2krc9w"
    }
}, {
    d: [
        ".f10pi13n{position:relative;}",
        [
            ".f3gpkru{padding:0px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".f1dxfoyt[data-fui-focus-visible]{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f2krc9w[data-fui-focus-visible]{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ]
    ]
});
const $8f182bcf5e72beb2$export$a2f26cfede75a646 = (state)=>{
    const styles = $8f182bcf5e72beb2$var$useStyles();
    const layoutStyles = {
        table: $8f182bcf5e72beb2$var$useTableLayoutStyles(),
        flex: $8f182bcf5e72beb2$var$useFlexLayoutStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($8f182bcf5e72beb2$export$966b503d9ebcb5b.root, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.noNativeElements ? layoutStyles.flex[state.size] : layoutStyles.table[state.size], state.root.className);
    return state;
};



'use client';
const $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $00c499bc138309ea$export$6ead74c378e7a6c7)(props, ref);
    (0, $8f182bcf5e72beb2$export$a2f26cfede75a646)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableCellStyles_unstable')(state);
    return (0, $29e6fbfd80438988$export$386709cc44b79068)(state);
});
$f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3.displayName = 'TableCell';


var $acw62 = parcelRequire("acw62");


'use client';
const $21b88dc000471395$export$9d04d359fb79e4d0 = (props, ref)=>{
    const { noNativeElements: noNativeElements } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'thead';
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'rowgroup' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements: noNativeElements
    };
};





var $acw62 = parcelRequire("acw62");
'use client';
const $b32b2b077c08c135$var$tableHeaderContext = $acw62.createContext(undefined);
const $b32b2b077c08c135$var$tableHeaderContextDefaultValue = '';
const $b32b2b077c08c135$export$ede65b1f183bac91 = $b32b2b077c08c135$var$tableHeaderContext.Provider;
const $b32b2b077c08c135$export$e9d05040fc93d3a3 = ()=>$acw62.useContext($b32b2b077c08c135$var$tableHeaderContext) === $b32b2b077c08c135$var$tableHeaderContextDefaultValue;


const $a13f3cfe0a234387$export$d1541071f0707ce5 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $b32b2b077c08c135$export$ede65b1f183bac91), {
        value: "",
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};



'use client';
const $97e73014970bcab3$export$ecabfa1fd8cfc61e = 'fui-TableHeader';
const $97e73014970bcab3$export$84932ebc2effbb7e = {
    root: 'fui-TableHeader'
};
const $97e73014970bcab3$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
const $97e73014970bcab3$var$useTableLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1tp1avn"
    }
}, {
    d: [
        ".f1tp1avn{display:table-row-group;}"
    ]
});
const $97e73014970bcab3$export$431076ffea51440d = (state)=>{
    const layoutStyles = {
        table: $97e73014970bcab3$var$useTableLayoutStyles(),
        flex: $97e73014970bcab3$var$useFlexLayoutStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($97e73014970bcab3$export$ecabfa1fd8cfc61e, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
};



'use client';
const $a43c21910348d1c5$export$f850895b287ef28e = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $21b88dc000471395$export$9d04d359fb79e4d0)(props, ref);
    (0, $97e73014970bcab3$export$431076ffea51440d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableHeaderStyles_unstable')(state);
    return (0, $a13f3cfe0a234387$export$d1541071f0707ce5)(state);
});
$a43c21910348d1c5$export$f850895b287ef28e.displayName = 'TableHeader';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



"use client";
const $4125b41377e9d21d$export$81f1ab08b795f6b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitContentFilled', "1em", [
    "M5.35 3.65c.2.2.2.5 0 .7L4.71 5H7.5a.5.5 0 0 1 0 1H4.7l.65.65a.5.5 0 1 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5c.2-.2.5-.2.7 0M5.5 9A2.5 2.5 0 0 0 3 11.5v3A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 14.5 9zm.5 3.5h8a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1m8.65-8.15a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H12.5a.5.5 0 0 1 0-1h2.8z"
]);
const $4125b41377e9d21d$export$562f0c444450654c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitContentRegular', "1em", [
    "M5.35 3.65c.2.2.2.5 0 .7L4.71 5H7.5a.5.5 0 0 1 0 1H4.7l.65.65a.5.5 0 1 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5c.2-.2.5-.2.7 0M5.5 9A2.5 2.5 0 0 0 3 11.5v3A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 14.5 9zM4 11.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5zm2 1a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm8.65-8.15a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H12.5a.5.5 0 0 1 0-1h2.8z"
]);
const $4125b41377e9d21d$export$da538470c4a217ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitDownFilled', "1em", [
    "m15.71 14.77-.7.73V2.75a.75.75 0 1 0-1.5 0v12.76l-.72-.74a.75.75 0 0 0-1.08 1.04l1.82 1.88a1 1 0 0 0 1.44 0l1.82-1.88a.75.75 0 0 0-1.08-1.04M5 17a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h6.25a.75.75 0 0 1 0 1.5H5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h4.25a.75.75 0 0 1 0 1.5z"
]);
const $4125b41377e9d21d$export$9b0a5d8813adfeca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitDownRegular', "1em", [
    "M16.14 15.2 15 16.36V2.5a.5.5 0 1 0-1 0v13.87l-1.14-1.18a.5.5 0 1 0-.72.7l1.82 1.88c.3.3.79.3 1.08 0l1.82-1.88a.5.5 0 1 0-.72-.7M5 17a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h6.5a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.5a.5.5 0 1 1 0 1z"
]);
const $4125b41377e9d21d$export$d528e932c63ee6fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightFilled', "1em", [
    "m15 4.5.71.73A.75.75 0 0 0 16.8 4.2l-1.82-1.88a1 1 0 0 0-1.44 0l-1.82 1.88a.75.75 0 0 0 1.08 1.04l.71-.74v2.76a.75.75 0 0 0 1.5 0zM3 5c0-1.1.9-2 2-2h4.25a.75.75 0 0 1 0 1.5H5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h4.25a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2zm12.71 9.77-.7.73v-2.75a.75.75 0 1 0-1.5 0v2.76l-.72-.74a.75.75 0 0 0-1.08 1.04l1.82 1.88a1 1 0 0 0 1.44 0l1.82-1.88a.75.75 0 0 0-1.08-1.04"
]);
const $4125b41377e9d21d$export$fc9e9f312f7da94c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightRegular', "1em", [
    "m15 3.63 1.14 1.18a.5.5 0 1 0 .72-.7l-1.82-1.88a.75.75 0 0 0-1.08 0L12.14 4.1a.5.5 0 1 0 .72.7L14 3.63V7.5a.5.5 0 0 0 1 0zM3 5c0-1.1.9-2 2-2h4.5a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-2-2zm13.14 10.2L15 16.36V12.5a.5.5 0 1 0-1 0v3.87l-1.14-1.18a.5.5 0 1 0-.72.7l1.82 1.88c.3.3.79.3 1.08 0l1.82-1.88a.5.5 0 1 0-.72-.7"
]);
const $4125b41377e9d21d$export$49284021115565a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightDottedFilled', "1em", [
    "m15.71 5.23-1.46-1.51-1.46 1.51a.75.75 0 0 1-1.08-1.04l1.82-1.88a1 1 0 0 1 1.44 0l1.82 1.88a.75.75 0 0 1-1.08 1.04m0 9.54-1.46 1.51-1.46-1.51a.75.75 0 0 0-1.08 1.04l1.82 1.88a1 1 0 0 0 1.44 0l1.82-1.88a.75.75 0 0 0-1.08-1.04M14.25 12c.42 0 .75.34.75.75v.5a.75.75 0 1 1-1.5 0v-.5c0-.41.34-.75.75-.75m.75-1.75a.75.75 0 1 1-1.5 0v-.5a.75.75 0 0 1 1.5 0zM14.25 8c.42 0 .75-.34.75-.75v-.5a.75.75 0 1 0-1.5 0v.5c0 .41.34.75.75.75M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4.25a.75.75 0 0 0 0-1.5H5a.5.5 0 0 1-.5-.5V5c0-.28.22-.5.5-.5h4.25a.75.75 0 0 0 0-1.5z"
]);
const $4125b41377e9d21d$export$5cbc4d338c3d93fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightDottedRegular', "1em", [
    "M16.14 4.8 14.5 3.12l-1.64 1.7a.5.5 0 0 1-.72-.7l1.82-1.88c.3-.3.79-.3 1.08 0l1.82 1.88a.5.5 0 1 1-.72.7M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4.5a.5.5 0 0 0 0-1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4.5a.5.5 0 0 0 0-1zm9.5 2c.28 0 .5.22.5.5V7a.5.5 0 1 1-1 0V5.5c0-.28.23-.5.5-.5m.5 8a.5.5 0 1 0-1 0v1.5a.5.5 0 0 0 1 0zm-.5-4c.28 0 .5.22.5.5v1a.5.5 0 1 1-1 0v-1c0-.28.23-.5.5-.5m1.64 6.2-1.64 1.69-1.64-1.7a.5.5 0 1 0-.72.7l1.82 1.88c.3.3.79.3 1.08 0l1.82-1.88a.5.5 0 1 0-.72-.7"
]);
const $4125b41377e9d21d$export$9323341c434e7653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightInFilled', "1em", [
    "m14.78 7.78 2-2a.75.75 0 0 0-1.06-1.06l-.72.72V2.75a.75.75 0 0 0-1.5 0v2.69l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0M3 5c0-1.1.9-2 2-2h4.25a.75.75 0 0 1 0 1.5H5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h4.25a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2zm13.78 9.22-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v2.69a.75.75 0 0 0 1.5 0v-2.69l.72.72a.75.75 0 1 0 1.06-1.06"
]);
const $4125b41377e9d21d$export$271f2e60c2fd072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightInRegular', "1em", [
    "m14.85 7.85 2-2a.5.5 0 0 0-.7-.7L15 6.29V2.5a.5.5 0 0 0-1 0v3.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0M3 5c0-1.1.9-2 2-2h4.5a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-2-2zm13.85 9.15-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7L14 13.71v3.79a.5.5 0 0 0 1 0v-3.8l1.15 1.15a.5.5 0 0 0 .7-.7"
]);
const $4125b41377e9d21d$export$9bf9ed08b9b02d7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitUpFilled', "1em", [
    "m15.71 5.23-.7-.73v12.75a.75.75 0 1 1-1.5 0V4.49l-.72.74a.75.75 0 0 1-1.08-1.04l1.82-1.88a1 1 0 0 1 1.44 0l1.82 1.88a.75.75 0 0 1-1.08 1.04M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6.25a.75.75 0 0 0 0-1.5H5a.5.5 0 0 1-.5-.5V5c0-.28.22-.5.5-.5h4.25a.75.75 0 0 0 0-1.5z"
]);
const $4125b41377e9d21d$export$dd484eb136093469 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitUpRegular', "1em", [
    "M16.14 4.8 15 3.64V17.5a.5.5 0 1 1-1 0V3.63L12.86 4.8a.5.5 0 0 1-.72-.7l1.82-1.88c.3-.3.79-.3 1.08 0l1.82 1.88a.5.5 0 1 1-.72.7M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6.5a.5.5 0 0 0 0-1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4.5a.5.5 0 0 0 0-1z"
]);
const $4125b41377e9d21d$export$4c7d2602b11ab8f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthFilled', "1em", [
    "m15.5 15-.73.71a.75.75 0 1 0 1.04 1.08l1.89-1.82a1 1 0 0 0 0-1.44l-1.89-1.82a.75.75 0 0 0-1.04 1.08l.74.71h-2.76a.75.75 0 0 0 0 1.5zM15 3a2 2 0 0 1 2 2v4.25a.75.75 0 0 1-1.5 0V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v4.25a.75.75 0 0 1-1.5 0V5c0-1.1.9-2 2-2zM5.23 15.71l-.73-.7h2.75a.75.75 0 1 0 0-1.5H4.5l.73-.72a.75.75 0 0 0-1.04-1.08l-1.88 1.82a1 1 0 0 0 0 1.44l1.88 1.82a.75.75 0 0 0 1.04-1.08"
]);
const $4125b41377e9d21d$export$c768ea48f6bb30b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthRegular', "1em", [
    "m16.37 15-1.18 1.14a.5.5 0 1 0 .7.72l1.88-1.82c.3-.3.3-.78 0-1.08l-1.88-1.82a.5.5 0 1 0-.7.72L16.38 14H12.5a.5.5 0 1 0 0 1zM15 3a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4.5a.5.5 0 0 1-1 0V5c0-1.1.9-2 2-2zM4.81 16.14 3.63 15H7.5a.5.5 0 1 0 0-1H3.63l1.18-1.14a.5.5 0 0 0-.7-.72l-1.88 1.82c-.3.3-.3.79 0 1.08l1.89 1.82a.5.5 0 1 0 .69-.72"
]);
const $4125b41377e9d21d$export$990164d257816228 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthDottedFilled', "1em", [
    "m14.77 15.71 1.51-1.46-1.51-1.46a.75.75 0 1 1 1.04-1.08l1.89 1.82a1 1 0 0 1 0 1.44l-1.89 1.82a.75.75 0 0 1-1.04-1.08m-9.54 0-1.5-1.46 1.5-1.46a.75.75 0 0 0-1.04-1.08l-1.88 1.82a1 1 0 0 0 0 1.44l1.88 1.82a.75.75 0 0 0 1.04-1.08M8 14.25c0 .42-.33.75-.75.75h-.5a.75.75 0 1 1 0-1.5h.5c.42 0 .75.34.75.75m1.75.75a.75.75 0 1 1 0-1.5h.5a.75.75 0 0 1 0 1.5zm2.25-.75c0 .42.34.75.75.75h.5a.75.75 0 1 0 0-1.5h-.5a.75.75 0 0 0-.75.75M17 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4.25a.75.75 0 0 0 1.5 0V5c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v4.25a.75.75 0 1 0 1.5 0z"
]);
const $4125b41377e9d21d$export$fa826e4afc52cab9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthDottedRegular', "1em", [
    "m15.2 16.14 1.7-1.64-1.7-1.64a.5.5 0 0 1 .69-.72l1.88 1.82c.3.3.3.79 0 1.08l-1.88 1.82a.5.5 0 1 1-.7-.72M17 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4.5a.5.5 0 0 0 1 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4.5a.5.5 0 1 0 1 0zm-2 9.5a.5.5 0 0 1-.5.5H13a.5.5 0 1 1 0-1h1.5c.28 0 .5.23.5.5M7 15a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0 0 1zm4-.5a.5.5 0 0 1-.5.5h-1a.5.5 0 1 1 0-1h1c.28 0 .5.23.5.5m-6.19 1.64-1.7-1.64 1.7-1.64a.5.5 0 0 0-.7-.72l-1.88 1.82c-.3.3-.3.79 0 1.08l1.89 1.82a.5.5 0 1 0 .69-.72"
]);
const $4125b41377e9d21d$export$e9d8dd8ccbafe719 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenDownFilled', "1em", [
    "M5 1.75a.75.75 0 0 0-1.5 0v.5C3.5 3.22 4.28 4 5.25 4h9C15.22 4 16 3.22 16 2.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .14-.11.25-.25.25h-9A.25.25 0 0 1 5 2.25zM9.75 5c.41 0 .75.34.75.75v6.69l2.97-2.97a.75.75 0 1 1 1.06 1.06l-4.25 4.25c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 1 1 1.06-1.06L9 12.44V5.75c0-.41.34-.75.75-.75M3.5 17.75c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 0 1-1.5 0v-.5a.25.25 0 0 0-.25-.25h-9a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0z"
]);
const $4125b41377e9d21d$export$3c260a31c2f92d54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenDownRegular', "1em", [
    "M4 2a.5.5 0 0 0-1 0v.5C3 3.33 3.67 4 4.5 4h10c.83 0 1.5-.67 1.5-1.5V2a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5zm5.5 3c.28 0 .5.22.5.5v7.8l3.65-3.65a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 .7-.7L9 13.29V5.5c0-.28.22-.5.5-.5M3 17.5c0-.83.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 1-1 0z"
]);
const $4125b41377e9d21d$export$c6d71ca70f6a72c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenUpFilled', "1em", [
    "M5 18.25a.75.75 0 0 1-1.5 0v-.5c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 0 1-1.5 0v-.5a.25.25 0 0 0-.25-.25h-9a.25.25 0 0 0-.25.25zM9.75 15c.41 0 .75-.34.75-.75V7.56l2.97 2.97a.75.75 0 1 0 1.06-1.06l-4.25-4.25a.75.75 0 0 0-1.06 0L4.97 9.47a.75.75 0 1 0 1.06 1.06L9 7.56v6.69c0 .41.34.75.75.75M3.5 2.25C3.5 3.22 4.28 4 5.25 4h9C15.22 4 16 3.22 16 2.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .14-.11.25-.25.25h-9A.25.25 0 0 1 5 2.25v-.5a.75.75 0 0 0-1.5 0z"
]);
const $4125b41377e9d21d$export$36cada2ac198cf6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenUpRegular', "1em", [
    "M4 18a.5.5 0 0 1-1 0v-.5c0-.83.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5zm5.5-3a.5.5 0 0 0 .5-.5V6.7l3.65 3.65a.5.5 0 0 0 .7-.7l-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 .7.7L9 6.71v7.79c0 .28.22.5.5.5M3 2.5C3 3.33 3.67 4 4.5 4h10c.83 0 1.5-.67 1.5-1.5V2a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V2a.5.5 0 0 0-1 0z"
]);
const $4125b41377e9d21d$export$d703aa9bd4d9285c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalLeftRightFilled', "1em", [
    "M7.78 5.72c.3.3.3.77 0 1.06L5.56 9h8.88l-2.22-2.22a.75.75 0 0 1 1.06-1.06l3.5 3.5c.3.3.3.77 0 1.06l-3.5 3.5a.75.75 0 1 1-1.06-1.06l2.22-2.22H5.56l2.22 2.22a.75.75 0 1 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 0-1.06l3.5-3.5c.3-.3.77-.3 1.06 0"
]);
const $4125b41377e9d21d$export$750e6f43637ff5b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalLeftRightRegular', "1em", [
    "M7.35 5.65c.2.2.2.5 0 .7L4.71 9h10.58l-2.64-2.65a.5.5 0 0 1 .7-.7l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7L15.29 10H4.71l2.64 2.65a.5.5 0 0 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5c.2-.2.5-.2.7 0"
]);
const $4125b41377e9d21d$export$2e20c88f68456396 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalUpDownFilled', "1em", [
    "M6.78 7.78a.75.75 0 0 1-1.06-1.06l3.5-3.5c.3-.3.77-.3 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06L10.5 5.56v8.88l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.5 3.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06L9 14.44V5.56z"
]);
const $4125b41377e9d21d$export$c47982668fe8aa64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalUpDownRegular', "1em", [
    "M6.35 7.35a.5.5 0 1 1-.7-.7l3.5-3.5c.2-.2.5-.2.7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 4.71v10.58l2.65-2.64a.5.5 0 0 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 .7-.7L9 15.29V4.71z"
]);
const $4125b41377e9d21d$export$e4563b275f6ff56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBounceFilled', "1em", [
    "M2.75 6a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0V8.56l6.47 6.47c.3.3.77.3 1.06 0l6.75-6.75a.75.75 0 0 0-1.06-1.06l-6.22 6.22L4.56 7.5h4.69a.75.75 0 0 0 0-1.5z"
]);
const $4125b41377e9d21d$export$619e65a8cfe9ea51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBounceRegular', "1em", [
    "M2.5 6a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0V7.7l7.15 7.15c.2.2.5.2.7 0l7-7a.5.5 0 0 0-.7-.7l-6.65 6.64L3.7 7h5.8a.5.5 0 0 0 0-1z"
]);
const $4125b41377e9d21d$export$a932112762a5b169 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-4.65.85a.5.5 0 0 0-.7-.7l-2.15 2.14V6.5a.5.5 0 0 0-1 0v5.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0z"
]);
const $4125b41377e9d21d$export$bb58229b00acea55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownRegular', "1em", [
    "m13.35 10.85-3 3a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7l2.15 2.14V6.5a.5.5 0 0 1 1 0v5.8l2.15-2.15a.5.5 0 0 1 .7.7M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
]);
const $4125b41377e9d21d$export$daa3739d8c2be624 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownDoubleFilled', "1em", [
    "M7.35 13.85 9 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-4.65 3.85L15 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0"
]);
const $4125b41377e9d21d$export$9412ecbe4d6573ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownDoubleRegular', "1em", [
    "m9 12.2-1.65 1.65a.5.5 0 0 1-.7 0L5 12.21a.5.5 0 1 1 .7-.71l.8.8V6.5a.5.5 0 0 1 1 0v5.8l.8-.8a.5.5 0 1 1 .7.7m1 5.8a8 8 0 1 0 0-16 8 8 0 0 0 0 16m7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-3.65 3.85L15 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0"
]);
const $4125b41377e9d21d$export$be5ae7ef64a01a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownRightFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m2.85 10.86a.5.5 0 0 1-.35.14h-5a.5.5 0 0 1 0-1h3.8L7.14 7.85a.5.5 0 1 1 .7-.7L12 11.29V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.14.35"
]);
const $4125b41377e9d21d$export$1d8e506adf99680a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownRightRegular', "1em", [
    "M12.85 12.86a.5.5 0 0 1-.35.14h-5a.5.5 0 0 1 0-1h3.8L7.14 7.85a.5.5 0 1 1 .7-.7L12 11.29V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.14.35M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
]);
const $4125b41377e9d21d$export$8f694347b18269c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownSplitFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-9.2 2.41a.5.5 0 1 0-.71-.7l-.59.58V9h5v3.3l-.59-.6a.5.5 0 0 0-.7.71l1.44 1.44c.2.2.5.2.7 0l1.44-1.44a.5.5 0 0 0-.7-.7l-.59.58V8.5A.5.5 0 0 0 13 8h-2.5V5.5a.5.5 0 0 0-1 0V8H7a.5.5 0 0 0-.5.5v3.8l-.59-.6a.5.5 0 0 0-.7.71l1.44 1.44c.2.2.5.2.7 0z"
]);
const $4125b41377e9d21d$export$521e83b1fa451b76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownSplitRegular', "1em", [
    "m8.8 12.41-1.45 1.44a.5.5 0 0 1-.7 0L5.2 12.41a.5.5 0 0 1 .7-.7l.59.58V8.5c0-.28.22-.5.5-.5h2.5V5.5a.5.5 0 0 1 1 0V8H13c.28 0 .5.22.5.5v3.8l.59-.6a.5.5 0 0 1 .7.71l-1.44 1.44a.5.5 0 0 1-.7 0l-1.44-1.44a.5.5 0 0 1 .7-.7l.59.58V9h-5v3.3l.59-.6a.5.5 0 1 1 .7.71M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
]);
const $4125b41377e9d21d$export$26052ea08b2b4c21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownUpFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-1-5.8-1.65 1.65a.5.5 0 0 1-.7 0L5 12.21a.5.5 0 1 1 .7-.71l.8.8V6.5a.5.5 0 0 1 1 0v5.8l.8-.8a.5.5 0 1 1 .7.7m6-4.4a.5.5 0 0 1-.7.7l-.8-.8v5.8a.5.5 0 0 1-1 0V7.7l-.8.8a.5.5 0 1 1-.7-.7l1.65-1.65c.2-.2.5-.2.7 0z"
]);
const $4125b41377e9d21d$export$22336a144360c270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownUpRegular', "1em", [
    "M7.35 13.85 9 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0M15 7.8l-1.65-1.64a.5.5 0 0 0-.7 0L11 7.79a.5.5 0 1 0 .7.71l.8-.8v5.8a.5.5 0 1 0 1 0V7.7l.8.8a.5.5 0 1 0 .7-.7M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
]);
const $4125b41377e9d21d$export$1aa4b48f1610416e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleLeftFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m-.85-4.65a.5.5 0 0 0 .7-.7L7.71 10.5h5.79a.5.5 0 0 0 0-1H7.7l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0 0 .7z"
]);
const $4125b41377e9d21d$export$918eaebc11f90d3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleLeftRegular', "1em", [
    "m9.15 13.35-3-3a.5.5 0 0 1 0-.7l3-3a.5.5 0 1 1 .7.7L7.71 9.5h5.79a.5.5 0 0 1 0 1H7.7l2.15 2.15a.5.5 0 0 1-.7.7M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 7a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
]);
const $4125b41377e9d21d$export$dbb7528fff39860d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleRightFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m.85-4.65a.5.5 0 0 1-.7-.7l2.14-2.15H6.5a.5.5 0 0 1 0-1h5.8l-2.15-2.15a.5.5 0 0 1 .7-.7l3 3c.2.2.2.5 0 .7z"
]);
const $4125b41377e9d21d$export$cece181a3846acba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleRightRegular', "1em", [
    "m10.85 13.35 3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 0 0-.7.7l2.14 2.15H6.5a.5.5 0 0 0 0 1h5.8l-2.15 2.15a.5.5 0 0 0 .7.7M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
]);
const $4125b41377e9d21d$export$4566eee4af93d514 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m4.65-.85a.5.5 0 1 0 .7.7L9.5 7.71v5.79a.5.5 0 0 0 1 0V7.7l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3a.5.5 0 0 0-.7 0z"
]);
const $4125b41377e9d21d$export$e11cc8232e1f29c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpRegular', "1em", [
    "m6.65 9.15 3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-1 0V7.7L7.35 9.86a.5.5 0 0 1-.7-.7M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $4125b41377e9d21d$export$ed20c52033d4d170 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpLeftFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7.15 7.14A.5.5 0 0 1 7.5 7h5a.5.5 0 0 1 0 1H8.7l4.15 4.15a.5.5 0 0 1-.7.7L8 8.71v3.79a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .14-.35"
]);
const $4125b41377e9d21d$export$52bce8519c334ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpLeftRegular', "1em", [
    "M7.15 7.14A.5.5 0 0 1 7.5 7h5a.5.5 0 0 1 0 1H8.7l4.15 4.15a.5.5 0 0 1-.7.7L8 8.71v3.79a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .14-.35M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $4125b41377e9d21d$export$9ef3d98ee597c56f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpRightFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m2.85-10.86A.5.5 0 0 0 12.5 7h-5a.5.5 0 0 0 0 1h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L12 8.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.14-.35"
]);
const $4125b41377e9d21d$export$834bff389cdcc290 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpRightRegular', "1em", [
    "M12.85 7.14A.5.5 0 0 0 12.5 7h-5a.5.5 0 0 0 0 1h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L12 8.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.14-.35M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m7 8a7 7 0 1 0-14 0 7 7 0 0 0 14 0"
]);
const $4125b41377e9d21d$export$98f240455e015698 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9zM6.65 9.15l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-1 0V7.7L7.35 9.86a.5.5 0 0 1-.7-.7"
]);
const $4125b41377e9d21d$export$baaacfb3a9294f25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9zM6.65 9.15l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-1 0V7.7L7.35 9.86a.5.5 0 0 1-.7-.7"
]);
const $4125b41377e9d21d$export$49df0a05c9149d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseFilled', "1em", [
    "M4 10a6 6 0 0 1 9.97-4.5h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3a.75.75 0 0 0-1.5 0v1.16a7.5 7.5 0 1 0 2.5 5.31.75.75 0 0 0-1.5.06V10a6 6 0 0 1-12 0"
]);
const $4125b41377e9d21d$export$5e244be41a28c44c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseRegular', "1em", [
    "M4 10a6 6 0 0 1 10.47-4H12.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.6a7 7 0 1 0 1.98 4.36.5.5 0 1 0-1 .08L16 10a6 6 0 0 1-12 0"
]);
const $4125b41377e9d21d$export$8e37c3e6b3eea9e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__a)",
            "d": "M10 2q-.63 0-1.25.1a1 1 0 0 0 .31 1.97 6 6 0 0 1 1.7-.02 1 1 0 1 0 .26-1.99A8 8 0 0 0 10 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__b)",
            "d": "M10 2q-.63 0-1.25.1a1 1 0 0 0 .31 1.97 6 6 0 0 1 1.7-.02 1 1 0 1 0 .26-1.99A8 8 0 0 0 10 2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__c)",
            "d": "M13.92 3.03a1 1 0 1 0-.98 1.74q.55.3 1.03.73H13a1 1 0 1 0 0 2h3.5a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v1.2q-.7-.69-1.58-1.17"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__d)",
            "d": "M13.92 3.03a1 1 0 1 0-.98 1.74q.55.3 1.03.73H13a1 1 0 1 0 0 2h3.5a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v1.2q-.7-.69-1.58-1.17"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__e)",
            "d": "M6.47 5.14A1 1 0 0 0 5.3 3.53q-1.03.75-1.77 1.77a1 1 0 0 0 1.61 1.17q.57-.76 1.33-1.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__f)",
            "d": "M6.47 5.14A1 1 0 0 0 5.3 3.53q-1.03.75-1.77 1.77a1 1 0 0 0 1.61 1.17q.57-.76 1.33-1.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__g)",
            "d": "M4.07 9.06a1 1 0 0 0-1.97-.31 8 8 0 0 0 0 2.5 1 1 0 0 0 1.97-.31 6 6 0 0 1 0-1.88"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__h)",
            "d": "M4.07 9.06a1 1 0 0 0-1.97-.31 8 8 0 0 0 0 2.5 1 1 0 0 0 1.97-.31 6 6 0 0 1 0-1.88"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__i)",
            "d": "M17.92 11.14a1 1 0 0 0-1.98-.28q-.06.42-.18.83a1 1 0 0 0 1.92.57q.15-.54.24-1.12"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__j)",
            "d": "M17.92 11.14a1 1 0 0 0-1.98-.28q-.06.42-.18.83a1 1 0 0 0 1.92.57q.15-.54.24-1.12"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__k)",
            "d": "M5.14 13.53a1 1 0 1 0-1.61 1.17q.75 1.03 1.77 1.77a1 1 0 0 0 1.17-1.61q-.76-.57-1.33-1.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__l)",
            "d": "M5.14 13.53a1 1 0 1 0-1.61 1.17q.75 1.03 1.77 1.77a1 1 0 0 0 1.17-1.61q-.76-.57-1.33-1.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__m)",
            "d": "M16.04 15.24a1 1 0 1 0-1.5-1.31q-.58.64-1.3 1.12a1 1 0 0 0 1.08 1.68 8 8 0 0 0 1.72-1.49"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__n)",
            "d": "M16.04 15.24a1 1 0 1 0-1.5-1.31q-.58.64-1.3 1.12a1 1 0 0 0 1.08 1.68 8 8 0 0 0 1.72-1.49"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__o)",
            "d": "M9.06 15.93a1 1 0 0 0-.31 1.97 8 8 0 0 0 2.39.02 1 1 0 0 0-.28-1.98 6 6 0 0 1-1.8-.01"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_20_color__p)",
            "d": "M9.06 15.93a1 1 0 0 0-.31 1.97 8 8 0 0 0 2.39.02 1 1 0 0 0-.28-1.98 6 6 0 0 1-1.8-.01"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__a",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__b",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__c",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__d",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__e",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__f",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__g",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__h",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__i",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__j",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__k",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__l",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__m",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__n",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__o",
                "x1": "4.25",
                "x2": "18",
                "y1": "2",
                "y2": "23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_20_color__p",
                "x1": "9.96",
                "x2": "13.57",
                "y1": ".1",
                "y2": "27.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$9300e9d76420e6ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesFilled', "1em", [
    "M16.5 3.25a.75.75 0 0 0-1.5 0v1.16a7.5 7.5 0 0 0-3.42-1.74c-.44-.1-.83.26-.83.7 0 .39.29.7.66.8.97.23 1.84.7 2.56 1.33h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75zm-8.08-.58c.44-.1.83.26.83.7 0 .39-.29.7-.66.8q-.93.22-1.72.7a.8.8 0 0 1-1.02-.08c-.32-.32-.3-.85.08-1.1a8 8 0 0 1 2.5-1.02m8.2 8.08c-.38 0-.7.29-.79.66q-.22.93-.7 1.72c-.2.32-.19.75.09 1.02.31.32.84.3 1.08-.08q.74-1.14 1.03-2.5c.1-.43-.26-.82-.7-.82m-5.2 5.08a.8.8 0 0 0-.67.8c0 .44.39.8.83.7q1.36-.29 2.49-1.03c.38-.24.4-.77.08-1.09a.8.8 0 0 0-1.02-.09q-.8.49-1.72.71m-4.55-.7a.8.8 0 0 0-1.02.08c-.32.32-.3.85.08 1.1q1.14.73 2.5 1.02c.43.1.82-.26.82-.7 0-.39-.29-.7-.66-.8q-.93-.22-1.72-.7m-2.7-3.72a.8.8 0 0 0-.8-.66c-.44 0-.8.39-.7.83q.3 1.36 1.03 2.49c.24.38.77.4 1.09.08.27-.27.29-.7.09-1.02a6 6 0 0 1-.71-1.72m.71-4.54a.8.8 0 0 0-.1-1.02c-.31-.32-.84-.3-1.08.08a8 8 0 0 0-1.03 2.5c-.1.43.26.82.7.82.39 0 .7-.29.8-.66q.23-.94.71-1.72"
]);
const $4125b41377e9d21d$export$84f7bfdc0afdfd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesRegular', "1em", [
    "M16 3.5a.5.5 0 0 0-1 0v1.6c-.98-1-2.26-1.7-3.7-1.98a.5.5 0 0 0-.55.48c0 .26.19.47.44.52A6 6 0 0 1 14.47 6H12.5a.5.5 0 0 0 0 1h3.02c.3-.01.5-.25.48-.51zm-7.3-.38c.29-.05.55.18.55.48 0 .26-.19.47-.44.52q-1.17.24-2.13.88a.54.54 0 0 1-.67-.05.48.48 0 0 1 .05-.74 7 7 0 0 1 2.63-1.09m7.7 7.63a.54.54 0 0 0-.52.44q-.24 1.17-.88 2.13c-.14.21-.13.5.05.67.22.22.57.2.74-.05q.8-1.18 1.09-2.63a.48.48 0 0 0-.48-.56m-5.21 5.13a.54.54 0 0 0-.44.52c0 .3.26.53.56.48a7 7 0 0 0 2.63-1.1.47.47 0 0 0 .05-.73.54.54 0 0 0-.67-.05q-.97.64-2.13.88M6.69 15a.54.54 0 0 0-.68.05c-.22.22-.2.57.05.74q1.18.8 2.63 1.09c.3.05.56-.18.56-.48a.54.54 0 0 0-.44-.52A6 6 0 0 1 6.68 15m-2.57-3.81a.54.54 0 0 0-.52-.44c-.3 0-.53.26-.48.56q.28 1.45 1.1 2.63c.16.25.51.27.73.05.18-.18.2-.46.05-.67a6 6 0 0 1-.88-2.13M5 6.69A.54.54 0 0 0 4.95 6a.48.48 0 0 0-.74.05 7 7 0 0 0-1.09 2.63c-.05.3.18.56.48.56.26 0 .47-.19.52-.44q.24-1.17.88-2.13"
]);
const $4125b41377e9d21d$export$199aa0f43303497a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesSettingsColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__a)",
            "d": "M8.75 2.1a8 8 0 0 1 2.27-.04 1 1 0 1 1-.25 1.99 6 6 0 0 0-1.71.02 1 1 0 1 1-.31-1.97"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__b)",
            "d": "M8.75 2.1a8 8 0 0 1 2.27-.04 1 1 0 1 1-.25 1.99 6 6 0 0 0-1.71.02 1 1 0 1 1-.31-1.97"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__c)",
            "d": "M12.56 3.4a1 1 0 0 1 1.36-.37q.86.48 1.58 1.16V3a1 1 0 1 1 2 0v3.5a1 1 0 0 1-1 1H13a1 1 0 1 1 0-2h.97a6 6 0 0 0-1.03-.73 1 1 0 0 1-.38-1.36"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__d)",
            "d": "M12.56 3.4a1 1 0 0 1 1.36-.37q.86.48 1.58 1.16V3a1 1 0 1 1 2 0v3.5a1 1 0 0 1-1 1H13a1 1 0 1 1 0-2h.97a6 6 0 0 0-1.03-.73 1 1 0 0 1-.38-1.36"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__e)",
            "d": "M6.47 5.14A1 1 0 0 0 5.3 3.53q-1.03.75-1.77 1.77a1 1 0 0 0 1.61 1.17q.57-.76 1.33-1.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__f)",
            "d": "M6.47 5.14A1 1 0 0 0 5.3 3.53q-1.03.75-1.77 1.77a1 1 0 0 0 1.61 1.17q.57-.76 1.33-1.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__g)",
            "d": "M3.24 7.92a1 1 0 0 1 .83 1.14 6 6 0 0 0 0 1.88 1 1 0 0 1-1.97.31 8 8 0 0 1 0-2.5 1 1 0 0 1 1.14-.83"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__h)",
            "d": "M3.24 7.92a1 1 0 0 1 .83 1.14 6 6 0 0 0 0 1.88 1 1 0 0 1-1.97.31 8 8 0 0 1 0-2.5 1 1 0 0 1 1.14-.83"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__i)",
            "d": "M3.75 13.3a1 1 0 0 1 1.4.23q.56.76 1.32 1.33a1 1 0 0 1-1.17 1.61 8 8 0 0 1-1.77-1.77 1 1 0 0 1 .22-1.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__j)",
            "d": "M3.75 13.3a1 1 0 0 1 1.4.23q.56.76 1.32 1.33a1 1 0 0 1-1.17 1.61 8 8 0 0 1-1.77-1.77 1 1 0 0 1 .22-1.4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__k)",
            "d": "M7.92 16.76a1 1 0 0 1 1.14-.83q.38.06.8.07l.1.03.34.08c.56.13.9.7.73 1.26l-.12.42-.04.16a8 8 0 0 1-2.12-.05 1 1 0 0 1-.83-1.14"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__l)",
            "d": "M7.92 16.76a1 1 0 0 1 1.14-.83q.38.06.8.07l.1.03.34.08c.56.13.9.7.73 1.26l-.12.42-.04.16a8 8 0 0 1-2.12-.05 1 1 0 0 1-.83-1.14"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__m)",
            "d": "M10.64 13.92a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__a",
                "x1": "4.25",
                "x2": "3.58",
                "y1": "2",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__b",
                "x1": "9.96",
                "x2": "22.05",
                "y1": ".1",
                "y2": "22.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__c",
                "x1": "4.25",
                "x2": "3.58",
                "y1": "2",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__d",
                "x1": "9.96",
                "x2": "22.05",
                "y1": ".1",
                "y2": "22.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__e",
                "x1": "4.25",
                "x2": "3.58",
                "y1": "2",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__f",
                "x1": "9.96",
                "x2": "22.05",
                "y1": ".1",
                "y2": "22.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__g",
                "x1": "4.25",
                "x2": "3.58",
                "y1": "2",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__h",
                "x1": "9.96",
                "x2": "22.05",
                "y1": ".1",
                "y2": "22.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__i",
                "x1": "4.25",
                "x2": "3.58",
                "y1": "2",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__j",
                "x1": "9.96",
                "x2": "22.05",
                "y1": ".1",
                "y2": "22.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__k",
                "x1": "4.25",
                "x2": "3.58",
                "y1": "2",
                "y2": "22.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".92",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__l",
                "x1": "9.96",
                "x2": "22.05",
                "y1": ".1",
                "y2": "22.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_clockwise_dashes_settings_20_color__m",
                "x1": "16.67",
                "x2": "12.28",
                "y1": "18.29",
                "y2": "10.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b9c0c7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$3684efbc8bf94838 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesSettingsFilled', "1em", [
    "M16.5 3.25a.75.75 0 0 0-1.5 0v1.16a7.5 7.5 0 0 0-3.42-1.74c-.44-.1-.83.26-.83.7 0 .39.29.7.66.8.97.23 1.84.7 2.56 1.33h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75zm-8.08-.58c.44-.1.83.26.83.7 0 .39-.29.7-.66.8q-.93.22-1.72.7a.8.8 0 0 1-1.02-.08c-.32-.32-.3-.85.08-1.1a8 8 0 0 1 2.5-1.02M6.87 15.12a.8.8 0 0 0-1.02.1c-.32.31-.3.84.08 1.08q1.14.74 2.5 1.03c.43.1.82-.26.82-.7 0-.39-.29-.7-.66-.8q-.93-.22-1.72-.7m-2.7-3.71a.8.8 0 0 0-.8-.66c-.44 0-.8.39-.7.83q.3 1.36 1.03 2.49c.24.38.77.4 1.09.08.27-.27.29-.7.09-1.02a6 6 0 0 1-.71-1.72m.71-4.54a.8.8 0 0 0-.1-1.02c-.31-.32-.84-.3-1.08.08a8 8 0 0 0-1.03 2.5c-.1.43.26.82.7.82.39 0 .7-.29.8-.66q.23-.94.71-1.72m7.19 4.57a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $4125b41377e9d21d$export$9345eef788730b1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesSettingsRegular', "1em", [
    "M16 3.5a.5.5 0 0 0-1 0v1.6c-.98-1-2.26-1.7-3.7-1.98a.5.5 0 0 0-.55.48c0 .26.19.47.44.52A6 6 0 0 1 14.47 6H12.5a.5.5 0 0 0 0 1h3c.3 0 .52-.25.5-.51zm-7.3-.38c.29-.05.55.18.55.48 0 .26-.19.47-.44.52q-1.17.24-2.13.88a.54.54 0 0 1-.67-.05.48.48 0 0 1 .05-.74 7 7 0 0 1 2.63-1.09M6.67 15a.54.54 0 0 0-.67.05c-.22.22-.2.57.05.74q1.18.8 2.63 1.09c.3.05.56-.18.56-.48a.54.54 0 0 0-.44-.52A6 6 0 0 1 6.68 15m-2.56-3.81a.54.54 0 0 0-.52-.44c-.3 0-.53.26-.48.56q.28 1.45 1.1 2.63c.16.25.51.27.73.05.18-.18.2-.46.05-.67a6 6 0 0 1-.88-2.13M5 6.69A.54.54 0 0 0 4.95 6a.48.48 0 0 0-.74.05 7 7 0 0 0-1.09 2.63c-.05.3.18.56.48.56.26 0 .47-.19.52-.44q.24-1.17.88-2.13m7.07 4.75a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $4125b41377e9d21d$export$b67625b859d915df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCollapseAllFilled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75m8 3c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m-3.72-.53a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06L5 9.56v5.69a.75.75 0 0 0 1.5 0V9.56l1.22 1.22a.75.75 0 1 0 1.06-1.06z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9e8d0d9b7ba08ec2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCollapseAllRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m3.15 2.65c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L6 8.71v6.79a.5.5 0 0 1-1 0V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7zM17.5 8h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$c04cf751873330aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseFilled', "1em", [
    "M16 10a6 6 0 0 0-9.97-4.5h1.22a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v1.16a7.5 7.5 0 1 1-2.5 5.31.75.75 0 1 1 1.5.06V10a6 6 0 0 0 12 0"
]);
const $4125b41377e9d21d$export$f09074358c38ba97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseRegular', "1em", [
    "M16 10A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.6a7 7 0 1 1-1.98 4.36.5.5 0 0 1 1 .08L4 10a6 6 0 0 0 12 0"
]);
const $4125b41377e9d21d$export$6432bdd407f3f0d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseDashesFilled', "1em", [
    "M3.5 3.25a.75.75 0 1 1 1.5 0V4.4a7.5 7.5 0 0 1 3.42-1.73c.44-.1.83.26.83.7 0 .39-.29.7-.66.8-.97.23-1.84.7-2.56 1.33h1.22a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75zm8.08-.58c-.44-.1-.83.26-.83.7 0 .39.29.7.66.8q.93.22 1.72.7c.32.2.75.19 1.02-.08.32-.32.3-.85-.08-1.1a8 8 0 0 0-2.5-1.02m-8.2 8.08c.38 0 .7.29.78.66q.23.93.72 1.72c.2.32.18.75-.1 1.02-.31.32-.84.3-1.08-.08a8 8 0 0 1-1.04-2.5c-.09-.43.26-.82.71-.82m5.2 5.08c.38.1.67.41.67.8 0 .44-.4.8-.83.7q-1.36-.29-2.5-1.03c-.37-.24-.4-.77-.07-1.09.27-.27.7-.29 1.02-.09q.8.49 1.72.71m4.55-.7a.8.8 0 0 1 1.02.08c.32.32.3.85-.08 1.1q-1.14.73-2.5 1.02c-.43.1-.82-.26-.82-.7 0-.39.29-.7.66-.8q.93-.22 1.72-.7m2.7-3.72c.1-.37.4-.66.8-.66.44 0 .8.39.7.83q-.3 1.36-1.03 2.49c-.24.38-.77.4-1.09.08a.8.8 0 0 1-.1-1.02q.5-.8.72-1.72m-.71-4.54a.8.8 0 0 1 .1-1.02c.31-.32.84-.3 1.08.08q.73 1.14 1.03 2.5c.1.43-.26.82-.7.82a.8.8 0 0 1-.8-.66q-.23-.94-.71-1.72"
]);
const $4125b41377e9d21d$export$f3276fb06fbcac76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseDashesRegular', "1em", [
    "M4 3.5a.5.5 0 0 1 1 0v1.6c.98-1 2.26-1.7 3.7-1.98.29-.05.55.18.55.48 0 .26-.19.47-.44.52A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1H4.48A.5.5 0 0 1 4 6.49zm7.3-.38a.5.5 0 0 0-.55.48c0 .26.19.47.44.52q1.17.24 2.13.88c.21.14.5.13.67-.05a.48.48 0 0 0-.05-.74 7 7 0 0 0-2.63-1.09m-7.7 7.63c.26 0 .47.19.52.44q.24 1.17.88 2.13c.14.21.13.5-.05.67a.48.48 0 0 1-.74-.05 7 7 0 0 1-1.09-2.63.48.48 0 0 1 .48-.56m5.21 5.13c.25.05.44.26.44.52 0 .3-.26.53-.56.48a7 7 0 0 1-2.63-1.1.48.48 0 0 1-.05-.73c.18-.18.46-.2.67-.05q.97.64 2.13.88m4.5-.88c.22-.14.5-.13.68.05.22.22.2.57-.05.74q-1.18.8-2.63 1.09a.48.48 0 0 1-.56-.48c0-.26.19-.47.44-.52q1.17-.24 2.13-.88m2.57-3.81a.54.54 0 0 1 .52-.44c.3 0 .53.26.48.56a7 7 0 0 1-1.1 2.63.48.48 0 0 1-.73.05.54.54 0 0 1-.05-.67q.64-.97.88-2.13M15 6.69a.54.54 0 0 1 .05-.68c.22-.22.57-.2.74.05q.8 1.18 1.09 2.63c.05.3-.18.56-.48.56a.54.54 0 0 1-.52-.44A6 6 0 0 0 15 6.68"
]);
const $4125b41377e9d21d$export$dece865717c1b9ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseInfoFilled', "1em", [
    "M17.5 9.89q-.71-.46-1.55-.7A6 6 0 0 0 6.03 5.5h1.22a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v1.16a7.5 7.5 0 0 1 12.5 5.48M2.5 10a7.5 7.5 0 0 0 7.39 7.5q-.46-.71-.7-1.55A6 6 0 0 1 4 9.78a.75.75 0 1 0-1.5-.06zm7.5 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5 2.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5m0-5.12a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24"
]);
const $4125b41377e9d21d$export$4c95e51d8211ddb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseInfoRegular', "1em", [
    "M16.99 9.6q-.5-.25-1.04-.4A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.6a7 7 0 0 1 11.99 4.5M3 10a7 7 0 0 0 6.6 6.99q-.25-.5-.4-1.04a6 6 0 0 1-5.18-6.41.5.5 0 1 0-1-.08zm7 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5 2.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5m0-5.12a.62.62 0 1 0 0 1.24.62.62 0 0 0 0-1.24"
]);
const $4125b41377e9d21d$export$77ba0725dc3e9287 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownLeftFilled', "1em", [
    "M13.39 3.14a.75.75 0 1 0-.78-1.28 7 7 0 0 0-2.98 3.13A12 12 0 0 0 8.75 10v5.44l-2.72-2.72a.75.75 0 1 0-1.06 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 0 0-1.06-1.06l-2.72 2.72V10c0-1.95.25-3.32.74-4.37a5.7 5.7 0 0 1 2.4-2.49"
]);
const $4125b41377e9d21d$export$97c6f3d24036e2bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownLeftRegular', "1em", [
    "M13.26 2.93a.5.5 0 0 0-.52-.86A7 7 0 0 0 9.86 5.1C9.26 6.38 9 7.96 9 10v6.3l-3.15-3.15a.5.5 0 1 0-.7.7l4 4c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7L10 16.29V10c0-1.96.25-3.38.76-4.47a6 6 0 0 1 2.5-2.6"
]);
const $4125b41377e9d21d$export$ea9e7d3d5d4ffaf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownRightFilled', "1em", [
    "M6.61 3.14a.75.75 0 1 1 .78-1.28 7 7 0 0 1 2.98 3.13c.63 1.33.88 2.96.88 5.01v5.44l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l2.72 2.72V10c0-1.95-.25-3.32-.74-4.37a5.7 5.7 0 0 0-2.4-2.49"
]);
const $4125b41377e9d21d$export$ce2ddd95bd6128d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownRightRegular', "1em", [
    "M6.74 2.93a.5.5 0 1 1 .52-.86 7 7 0 0 1 2.88 3.03c.6 1.28.86 2.86.86 4.9v6.3l3.15-3.15a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7L10 16.29V10c0-1.96-.25-3.38-.76-4.47a6 6 0 0 0-2.5-2.6"
]);
const $4125b41377e9d21d$export$5fda05ac50543d6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpLeftFilled', "1em", [
    "M6.03 7.03a.75.75 0 0 1-1.06-1.06l4-4c.3-.3.77-.3 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72v5.44c0 1.95.25 3.32.74 4.37a5.7 5.7 0 0 0 2.4 2.49.75.75 0 1 1-.78 1.28 7 7 0 0 1-2.98-3.13 12 12 0 0 1-.88-5.01V4.31z"
]);
const $4125b41377e9d21d$export$78d4bfb3366d848f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpLeftRegular', "1em", [
    "M5.85 6.85a.5.5 0 1 1-.7-.7l4-4c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L10 3.71V10c0 1.96.25 3.38.76 4.47a6 6 0 0 0 2.5 2.6.5.5 0 0 1-.52.86 7 7 0 0 1-2.88-3.03C9.26 13.62 9 12.04 9 10V3.7z"
]);
const $4125b41377e9d21d$export$b21340e6c4bba809 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpRightFilled', "1em", [
    "M13.97 7.03a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72v5.44c0 1.95-.25 3.32-.74 4.37a5.7 5.7 0 0 1-2.4 2.49.75.75 0 1 0 .78 1.28 7 7 0 0 0 2.98-3.13c.63-1.33.88-2.96.88-5.01V4.31z"
]);
const $4125b41377e9d21d$export$26cf11afc84fe35c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpRightRegular', "1em", [
    "M14.15 6.85a.5.5 0 0 0 .7-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L10 3.71V10c0 1.96-.25 3.38-.76 4.47a6 6 0 0 1-2.5 2.6.5.5 0 0 0 .52.86 7 7 0 0 0 2.88-3.03c.6-1.28.86-2.86.86-4.9V3.7z"
]);
const $4125b41377e9d21d$export$405224ab6047adeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownFilled', "1em", [
    "M16.8 11.27a.75.75 0 0 0-1.1-1.04l-4.95 5.24V2.75a.75.75 0 0 0-1.5 0v12.73l-4.96-5.25a.75.75 0 0 0-1.09 1.04l6.07 6.41a1 1 0 0 0 1.45 0z"
]);
const $4125b41377e9d21d$export$55d639d200f88b40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownRegular', "1em", [
    "M16.87 10.84a.5.5 0 1 0-.74-.68l-5.63 6.17V2.5a.5.5 0 0 0-1 0v13.83l-5.63-6.17a.5.5 0 0 0-.74.68l6.31 6.91a.75.75 0 0 0 1.11 0z"
]);
const $4125b41377e9d21d$export$954c55302f7edf7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownExclamationFilled', "1em", [
    "M3 5a3 3 0 0 1 6 0c0 2.25-.79 5.21-1.22 6.69C7.54 12.49 6.8 13 6 13s-1.54-.52-1.78-1.31C3.8 10.2 3 7.23 3 5m1 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0M15 2.5a.5.5 0 0 0-1 0v13.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7L15 16.29z"
]);
const $4125b41377e9d21d$export$6373b407eb2bd09a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownExclamationRegular', "1em", [
    "M4 5a2 2 0 1 1 4 0c0 2.09-.75 4.93-1.18 6.4-.1.36-.43.6-.82.6a.84.84 0 0 1-.82-.6C4.75 9.91 4 7.07 4 5m2-3a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69C4.46 12.48 5.2 13 6 13s1.54-.52 1.78-1.31C8.2 10.2 9 7.25 9 5a3 3 0 0 0-3-3M5 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9-11.5a.5.5 0 0 0-1 0v13.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7L15 16.29z"
]);
const $4125b41377e9d21d$export$558c0c18017a9872 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownLeftFilled', "1em", [
    "M12 16.25c0 .41-.34.75-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v5.69L15.72 3.22a.75.75 0 1 1 1.06 1.06L5.56 15.5h5.7c.4 0 .74.34.74.75"
]);
const $4125b41377e9d21d$export$4739191049be74c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownLeftRegular', "1em", [
    "M11.5 16a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v6.8L16.15 3.14a.5.5 0 1 1 .7.7L4.71 16z"
]);
const $4125b41377e9d21d$export$8fc55281e811512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownRightFilled', "1em", [
    "M8 16.25c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75v-7.5a.75.75 0 1 0-1.5 0v5.69L4.28 3.22a.75.75 0 1 0-1.06 1.06L14.44 15.5h-5.7a.75.75 0 0 0-.74.75"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$8ccdf9b9977f84fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownRightRegular', "1em", [
    "M8.5 16a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-1 0v6.8L3.85 3.14a.5.5 0 1 0-.7.7L15.29 16z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ce05f8bcba31eb0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadFilled', "1em", [
    "M15.24 16.5a.75.75 0 0 1 .1 1.5H4.76a.75.75 0 0 1-.1-1.5h10.6M10 2c.38 0 .7.28.75.65v10.3l2.97-2.98c.27-.26.68-.29.98-.07l.08.07c.27.27.3.68.07.98l-.07.08-4.24 4.25-.07.07-.1.05-.03.03-.1.03-.11.03-.07.01H10l-.15-.01-.08-.03a1 1 0 0 1-.26-.14l-4.29-4.29A.75.75 0 0 1 6.2 9.9l.08.07 2.97 2.97V2.75c0-.41.34-.75.75-.75"
]);
const $4125b41377e9d21d$export$3738a1f2e0f49231 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadRegular', "1em", [
    "M15.5 17a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H15.5M10 2a.5.5 0 0 1 .5.41V14.3l3.64-3.65a.5.5 0 0 1 .64-.06l.07.06c.17.17.2.44.06.63l-.06.07-4.5 4.5a.5.5 0 0 1-.25.14L10 16a.5.5 0 0 1-.4-.2l-4.46-4.45a.5.5 0 0 1 .64-.76l.07.06 3.65 3.64V2.5c0-.27.22-.5.5-.5"
]);
const $4125b41377e9d21d$export$ce0dcf5815a814dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadOffFilled', "1em", [
    "m9.25 9.96-7.1-7.1a.5.5 0 1 1 .7-.71l15 15a.5.5 0 0 1-.7.7l-4.6-4.59-2.01 2.02-.07.06-.1.06-.03.02-.1.04-.11.03-.07.01H10l-.15-.01-.08-.03a1 1 0 0 1-.26-.14l-4.29-4.29A.75.75 0 0 1 6.2 9.9l.08.07 2.97 2.97zm2.24 2.24-.74-.74v1.48zm2.48-.35-1.06-1.06.8-.82c.27-.26.7-.29.99-.07l.08.07c.27.27.3.68.07.98l-.07.08zM9.25 7.13l1.5 1.5V2.65a.75.75 0 0 0-1.5.1zm6 9.37a.75.75 0 0 1 .1 1.5H4.75a.75.75 0 0 1-.1-1.5h10.6"
]);
const $4125b41377e9d21d$export$e71f5070a7e64083 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L9.5 10.2v4.09l-3.65-3.64-.07-.06a.5.5 0 0 0-.64.76l4.46 4.46q.15.18.4.19l.1-.01a.5.5 0 0 0 .26-.14l2.39-2.4 4.4 4.4a.5.5 0 0 0 .7-.7zm9.2 10.6L10.5 14.3v-3.1zm2.11-.7-.7-.72.68-.68a.5.5 0 0 1 .64-.06l.07.06c.17.17.2.44.06.63l-.06.07zM9.5 7.37l1 1V2.4a.5.5 0 0 0-1 .1zm6 9.62a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H15.5"
]);
const $4125b41377e9d21d$export$e9e6fd456da86d78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEjectFilled', "1em", [
    "M11.2 4.6c-.6-.8-1.8-.8-2.4 0l-4.5 6A1.5 1.5 0 0 0 5.5 13h9a1.5 1.5 0 0 0 1.2-2.4zM4 15a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1z"
]);
const $4125b41377e9d21d$export$6f0593125d926925 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEjectRegular', "1em", [
    "M9.6 5.2a.5.5 0 0 1 .8 0l4.5 6a.5.5 0 0 1-.4.8h-9a.5.5 0 0 1-.4-.8zm1.6-.6c-.6-.8-1.8-.8-2.4 0l-4.5 6A1.5 1.5 0 0 0 5.5 13h9a1.5 1.5 0 0 0 1.2-2.4zM4 15a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1z"
]);
const $4125b41377e9d21d$export$7de405ddef04207b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterFilled', "1em", [
    "M7.75 17.5a.75.75 0 0 1 0-1.5H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H7.75a.75.75 0 0 1 0-1.5H14A3.5 3.5 0 0 1 17.5 6v8a3.5 3.5 0 0 1-3.5 3.5zm0-11.3a.75.75 0 0 1 1.05.04l3 3.25c.27.29.27.73 0 1.02l-3 3.25a.75.75 0 1 1-1.1-1.02l1.84-1.99H1.75a.75.75 0 0 1 0-1.5h7.79l-1.84-2a.75.75 0 0 1 .04-1.05"
]);
const $4125b41377e9d21d$export$21d5b20f97c2874c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterRegular', "1em", [
    "M7.5 17a.5.5 0 0 1 0-1H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H7.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3zm.15-10.85c.2-.2.5-.2.7 0l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7l2.64-2.65H1.5a.5.5 0 0 1 0-1h8.8L7.64 6.85a.5.5 0 0 1 0-.7"
]);
const $4125b41377e9d21d$export$bcef3798dcc891cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterLeftFilled', "1em", [
    "m4.64 12.5 2.87 2.7a.75.75 0 0 1-1.02 1.1l-4.25-4a.75.75 0 0 1 0-1.1l4.25-4A.75.75 0 1 1 7.5 8.3L4.64 11h10.11c.97 0 1.75-.78 1.75-1.75v-4.5a.75.75 0 0 1 1.5 0v4.5c0 1.8-1.46 3.25-3.25 3.25z"
]);
const $4125b41377e9d21d$export$9fb632b08ee6fca2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterLeftRegular', "1em", [
    "m3.76 12 3.33 3.14a.5.5 0 0 1-.68.72l-4.25-4a.5.5 0 0 1 0-.72l4.25-4a.5.5 0 1 1 .68.72L3.76 11H15a2 2 0 0 0 2-2V4.5a.5.5 0 0 1 1 0V9a3 3 0 0 1-3 3z"
]);
const $4125b41377e9d21d$export$5161b9fd08acdbf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterUpFilled', "1em", [
    "M8.8 2.24a.75.75 0 0 0-1.1 0l-4 4.25A.75.75 0 1 0 4.8 7.5l2.7-2.87v10.11c0 1.8 1.46 3.25 3.25 3.25h4.5a.75.75 0 0 0 0-1.5h-4.5c-.97 0-1.75-.78-1.75-1.75V4.65l2.7 2.86a.75.75 0 1 0 1.1-1.02z"
]);
const $4125b41377e9d21d$export$1bc5df14b5526a6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterUpRegular', "1em", [
    "M8.86 2.16a.5.5 0 0 0-.72 0l-4 4.25a.5.5 0 0 0 .72.68L8 3.76V15a3 3 0 0 0 3 3h4.5a.5.5 0 0 0 0-1H11a2 2 0 0 1-2-2V3.76l3.14 3.33a.5.5 0 0 0 .72-.68z"
]);
const $4125b41377e9d21d$export$403acc41649655a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExitFilled', "1em", [
    "M12.25 17.5a.75.75 0 0 0 0-1.5H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.25a.75.75 0 0 0 0-1.5H6A3.5 3.5 0 0 0 2.5 6v8A3.5 3.5 0 0 0 6 17.5zm1.5-11.3a.75.75 0 0 1 1.05.04l3 3.25c.27.29.27.73 0 1.02l-3 3.25a.75.75 0 1 1-1.1-1.02l1.84-1.99H7.75a.75.75 0 0 1 0-1.5h7.79l-1.84-2a.75.75 0 0 1 .04-1.05"
]);
const $4125b41377e9d21d$export$4280fbca678ba65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExitRegular', "1em", [
    "M12.5 17a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3zm1.15-10.85c.2-.2.5-.2.7 0l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7l2.64-2.65H7.5a.5.5 0 0 1 0-1h8.8l-2.65-2.65a.5.5 0 0 1 0-.7"
]);
const $4125b41377e9d21d$export$56b1e38b7ff9d475 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandFilled', "1em", [
    "M3.75 3a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V5.56l2.22 2.22a.75.75 0 0 0 1.06-1.06L5.56 4.5h1.69a.75.75 0 0 0 0-1.5zm0 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v1.69l2.22-2.22a.75.75 0 0 1 1.06 1.06L5.56 15.5h1.69a.75.75 0 0 1 0 1.5zM17 3.75a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0 0 1.5h1.69l-2.22 2.22a.75.75 0 0 0 1.06 1.06l2.22-2.22v1.69a.75.75 0 0 0 1.5 0zM16.25 17c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-1.5 0v1.69l-2.22-2.22a.75.75 0 1 0-1.06 1.06l2.22 2.22h-1.69a.75.75 0 0 0 0 1.5z"
]);
const $4125b41377e9d21d$export$66fc52b4c78954a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandRegular', "1em", [
    "M3.5 3a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V4.7l3.15 3.15a.5.5 0 1 0 .7-.7L4.71 4H7.5a.5.5 0 0 0 0-1zm0 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.8l3.15-3.15a.5.5 0 0 1 .7.7L4.71 16H7.5a.5.5 0 0 1 0 1zM17 3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.8l-3.15 3.15a.5.5 0 0 0 .7.7L16 4.71V7.5a.5.5 0 0 0 1 0zM16.5 17a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v2.8l-3.15-3.15a.5.5 0 0 0-.7.7L15.29 16H12.5a.5.5 0 0 0 0 1z"
]);
const $4125b41377e9d21d$export$13cf836a135b8dc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandAllFilled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75m8 3c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75m-1.22 5.53-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L5 13.44V7.75a.75.75 0 0 1 1.5 0v5.69l1.22-1.22a.75.75 0 0 1 1.06 1.06"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7be52597ebe02122 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandAllRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m3.15 11.35c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L6 14.29V7.5a.5.5 0 0 0-1 0v6.8l-1.65-1.65a.5.5 0 0 0-.7.7zM17.5 8h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b4ce74701e76f3f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportFilled', "1em", [
    "M2.75 3.75c.41 0 .75.34.75.75v11a.75.75 0 0 1-1.5 0v-11c0-.41.34-.75.75-.75M5 10c0-.41.34-.75.75-.75h10.19l-2.72-2.72a.75.75 0 0 1 1.06-1.06l4 4a1 1 0 0 1 .15.22.8.8 0 0 1-.15.84l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H5.75A.75.75 0 0 1 5 10"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$98d9ca104115acc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportRegular', "1em", [
    "M2.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5M5 10c0-.28.22-.5.5-.5h10.8l-3.15-3.15a.5.5 0 0 1 .7-.7l4 4a.5.5 0 0 1 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H5.5A.5.5 0 0 1 5 10"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$3d3077b2b2c62cc7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportLtrFilled', "1em", [
    "M2.75 3.75c.41 0 .75.34.75.75v11a.75.75 0 0 1-1.5 0v-11c0-.41.34-.75.75-.75M5 10c0-.41.34-.75.75-.75h10.19l-2.72-2.72a.75.75 0 0 1 1.06-1.06l4 4a1 1 0 0 1 .15.22.8.8 0 0 1-.15.84l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H5.75A.75.75 0 0 1 5 10"
]);
const $4125b41377e9d21d$export$57e2ae32d397b459 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportLtrRegular', "1em", [
    "M2.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5M5 10c0-.28.22-.5.5-.5h10.8l-3.15-3.15a.5.5 0 0 1 .7-.7l4 4a.5.5 0 0 1 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H5.5A.5.5 0 0 1 5 10"
]);
const $4125b41377e9d21d$export$9d3676d3f96b04ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportRtlFilled', "1em", [
    "M17.25 3.75a.75.75 0 0 0-.75.75v11a.75.75 0 0 0 1.5 0v-11a.75.75 0 0 0-.75-.75M15 10a.75.75 0 0 0-.75-.75H4.06l2.72-2.72a.75.75 0 0 0-1.06-1.06l-4 4a.8.8 0 0 0-.22.53.8.8 0 0 0 .22.53l4 4a.75.75 0 1 0 1.06-1.06l-2.72-2.72h10.19c.41 0 .75-.34.75-.75"
]);
const $4125b41377e9d21d$export$61dc9f102323fc08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportRtlRegular', "1em", [
    "M17.5 4a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-.5-.5M15 10a.5.5 0 0 0-.5-.5H3.7l3.15-3.15a.5.5 0 0 0-.7-.7l-4 4a.5.5 0 0 0 0 .7l4 4a.5.5 0 0 0 .7-.7L3.71 10.5H14.5a.5.5 0 0 0 .5-.5"
]);
const $4125b41377e9d21d$export$68bbee72e73fed3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportUpFilled', "1em", [
    "M10.53 1.72a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72v10.19a.75.75 0 0 0 1.5 0V4.06l2.72 2.72a.75.75 0 1 0 1.06-1.06zM4.5 16.5a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$fbefb716e743b72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportUpRegular', "1em", [
    "M9.65 2.15c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L10.5 3.71V14.5a.5.5 0 0 1-1 0V3.7L6.35 6.86a.5.5 0 1 1-.7-.7zM4 17.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$64bd6bf4ad62d1e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitFilled', "1em", [
    "M5.8 6.72c.28.3.28.77-.01 1.06L4.57 9h3.68a.75.75 0 0 1 0 1.5H4.56l1.22 1.22a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.51-2.5c.3-.3.77-.3 1.06 0m8.42 0c.3-.3.77-.3 1.06 0l2.5 2.5c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22h-3.69a.75.75 0 0 1 0-1.5h3.69l-1.22-1.22a.75.75 0 0 1 0-1.06"
]);
const $4125b41377e9d21d$export$fe6a8ee4bb3e3734 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitRegular', "1em", [
    "M5.35 6.65c.2.2.2.5 0 .7L3.71 9H8.5a.5.5 0 0 1 0 1H3.7l1.65 1.65a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5c.2-.2.5-.2.7 0m9.3 0c.2-.2.5-.2.7 0l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7L16.29 10H11.5a.5.5 0 0 1 0-1h4.8l-1.65-1.65a.5.5 0 0 1 0-.7"
]);
const $4125b41377e9d21d$export$c83e2da7ab994ee0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitInFilled', "1em", [
    "M5.21 7.78a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 .01 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22H2.75a.75.75 0 0 1 0-1.5h3.68zm9.58 0a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0-.01 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h3.69a.75.75 0 0 0 0-1.5h-3.68z"
]);
const $4125b41377e9d21d$export$a95fc6db8a97fe05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitInRegular', "1em", [
    "M5.65 7.35a.5.5 0 1 1 .7-.7l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7L7.29 10H2.5a.5.5 0 0 1 0-1h4.8zm8.7 0a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L12.71 10h4.79a.5.5 0 0 0 0-1h-4.8z"
]);
const $4125b41377e9d21d$export$3e05a4c580525a72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowDiagonalUpRightFilled', "1em", [
    "M10.5 4a.5.5 0 0 0 0 1h3.8l-6.56 6.55a3 3 0 1 0 .7.7L15 5.72V9.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$2681f8bee4f68ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowDiagonalUpRightRegular', "1em", [
    "M10.5 4a.5.5 0 0 0 0 1h3.8l-6.56 6.55a3 3 0 1 0 .7.7L15 5.72V9.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5zM4 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$940c460610bb5016 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowSquareMultipleFilled', "1em", [
    "M16 5.17A3 3 0 0 1 18 8v5a5 5 0 0 1-5 5H8a3 3 0 0 1-2.83-2H12a4 4 0 0 0 4-4zM12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8.18A1.75 1.75 0 0 0 4.18 7h.52c.96 0 1.85.48 2.38 1.28A3.9 3.9 0 0 0 10.3 10h1l-1.65 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 1 0-.7.7L11.29 9h-.99c-.96 0-1.85-.48-2.38-1.28A3.9 3.9 0 0 0 4.7 6h-.52A1.75 1.75 0 0 0 2 4.82 3 3 0 0 1 5 2zM2.5 5.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7f79a8152dd16bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowSquareMultipleRegular', "1em", [
    "M16 5.17A3 3 0 0 1 18 8v5a5 5 0 0 1-5 5H8a3 3 0 0 1-2.83-2h1.1c.34.6.99 1 1.73 1h5a4 4 0 0 0 4-4V8a2 2 0 0 0-1-1.73zM12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8.43a2 2 0 0 0 1 0V12c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-1.95 1.58 2 2 0 0 0-1.02-.02A3 3 0 0 1 5 2zM2.5 5.5c.37 0 .7.2.87.5h.83c1.3 0 2.5.65 3.22 1.72C7.95 8.52 8.84 9 9.8 9h1.5L9.64 7.35a.5.5 0 1 1 .7-.7l2.5 2.5a.5.5 0 0 1 0 .7l-2.5 2.5a.5.5 0 1 1-.7-.7L11.29 10H9.8c-1.3 0-2.5-.65-3.22-1.72A2.9 2.9 0 0 0 4.2 7h-.83a1 1 0 1 1-.87-1.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$33237199321c003a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightFilled', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ae677046e260983f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightRegular', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7zM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f2f8c681b642cfec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightRectangleMultipleFilled', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2zM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$86833126bab126cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightRectangleMultipleRegular', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2zM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7zM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$795f2f85c11fdac7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardFilled', "1em", [
    "M12.22 4.78a.75.75 0 0 1 1.06-1.06l4.5 4.5c.3.3.3.77 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H9.25a5.75 5.75 0 0 0-5.75 5.75.75.75 0 0 1-1.5 0C2 11.25 5.25 8 9.25 8h6.19z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$afacd6b1db450f86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardRegular', "1em", [
    "M12.65 3.65a.5.5 0 0 0 0 .7L16.29 8H9.5A7.5 7.5 0 0 0 2 15.5a.5.5 0 0 0 1 0A6.5 6.5 0 0 1 9.5 9h6.8l-3.65 3.65a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7l-4.5-4.5a.5.5 0 0 0-.7 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$1974b7b28e2bcde0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownLightningFilled', "1em", [
    "M13.43 4.75 15.7 7h-3.95c-2.8-.1-4.49-1.62-4.49-3.75a.75.75 0 0 0-1.5 0v.21C5.87 6.42 8.35 8.5 12 8.5h3.69l-2.26 2.26-.07.08a.75.75 0 0 0 1.14.98l3.53-3.54.09-.1.03-.06.05-.1.03-.1.02-.1v-.15l-.01-.06-.02-.07-.03-.09-.05-.1-.04-.05-.07-.08-3.53-3.54-.09-.07a.75.75 0 0 0-.98 1.14M2.5 16h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66H4.59a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f54a1ed63ea37634 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownLightningRegular', "1em", [
    "M13.61 4.32 16.3 7h-4.55C8.8 6.9 7 5.27 7 3a.5.5 0 0 0-1 0v.2C6.12 6.03 8.48 8 12 8h4.3l-2.69 2.68-.06.07a.5.5 0 0 0 .77.64l3.55-3.55.05-.07.04-.08.02-.06.02-.09v-.06.02l-.01-.1v-.03l-.03-.06-.03-.06-.05-.07-3.56-3.57-.07-.06a.5.5 0 0 0-.64.77M2.51 16h1.74l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66H4.59a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9b498e17d6d87b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownPersonFilled', "1em", [
    "M13.43 4.74 15.7 7h-3.95c-2.8-.1-4.49-1.62-4.49-3.75a.75.75 0 0 0-1.5 0v.21C5.87 6.42 8.35 8.5 12 8.5h3.69l-2.26 2.26-.07.08a.75.75 0 0 0 1.13.98l3.54-3.54.09-.1.03-.06.05-.1.03-.1.02-.1v-.15l-.01-.06-.02-.07-.03-.09-.05-.1-.04-.05-.07-.08-3.54-3.54-.08-.07a.75.75 0 0 0-.98 1.13M7.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0M9 15.5C9 16.74 8 18 5.5 18S2 16.75 2 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$450c3d33e60a3015 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownPersonRegular', "1em", [
    "M13.61 4.32 16.3 7h-4.55C8.8 6.9 7 5.27 7 3a.5.5 0 0 0-1 0v.2C6.11 6.03 8.48 8 12 8h4.3l-2.69 2.68-.06.07a.5.5 0 0 0 .77.64l3.55-3.55.05-.07.04-.08.02-.06.02-.09v-.06.02l-.01-.1v-.03l-.03-.06-.03-.06-.05-.07-3.56-3.57-.07-.06a.5.5 0 0 0-.64.77M7.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0M9 15.5C9 16.74 8 18 5.5 18S2 16.75 2 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f3d3fe7904d7b8ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownLeftFilled', "1em", [
    "M6 4.75c0-.41.34-.75.75-.75h4.5c1.59 0 2.7.62 3.53 1.59C15.6 6.54 16 7.79 16 9c0 1.22-.3 2.46-1.12 3.41A4.6 4.6 0 0 1 11.25 14H6.56l2.22 2.22a.75.75 0 1 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 .02-1.08l3.5-3.25a.75.75 0 0 1 1.02 1.1l-2.1 1.95h4.59c1.16 0 1.86-.44 2.4-1.07.55-.64.85-1.52.85-2.43 0-.9-.3-1.79-.85-2.43a3 3 0 0 0-2.4-1.07h-4.5A.75.75 0 0 1 6 4.75"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6d84a10395212e57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownLeftRegular', "1em", [
    "M6 4.5c0-.28.22-.5.5-.5H11c1.64 0 2.9.62 3.75 1.57C15.59 6.52 16 7.77 16 9s-.41 2.48-1.25 3.43A4.9 4.9 0 0 1 11 14H5.7l2.65 2.65a.5.5 0 0 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5a.5.5 0 1 1 .7.7L5.71 13H11c1.36 0 2.35-.5 3-1.24.66-.74 1-1.74 1-2.76s-.34-2.02-1-2.76A3.9 3.9 0 0 0 11 5H6.5a.5.5 0 0 1-.5-.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9e95969bd4e18768 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownRightFilled', "1em", [
    "M9 14c.06 0-.06 0 0 0h4.65l-2.27 2.27a.75.75 0 1 0 1.06 1.06l3.35-3.35a.8.8 0 0 0 .21-.64.8.8 0 0 0-.21-.45l-3.25-3.24a.75.75 0 1 0-1.06 1.06l1.8 1.79H9a3.5 3.5 0 1 1 0-7h4.25a.75.75 0 0 0 0-1.5H9a5 5 0 0 0 0 10"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$8df3efd039ba0589 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownRightRegular', "1em", [
    "M4 9a5 5 0 0 1 5-5h4.5a.5.5 0 0 1 0 1H9a4 4 0 1 0 0 8h5.3l-2.7-2.7a.5.5 0 1 1 .7-.7l3.54 3.53a.5.5 0 0 1 .13.5.5.5 0 0 1-.14.25L12.3 17.4a.5.5 0 0 1-.71-.7l2.7-2.71H9a5 5 0 0 1-5-5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$aad49cd3a23f9a2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpLeftFilled', "1em", [
    "M6 15.25c0 .41.34.75.75.75h4.5a4.4 4.4 0 0 0 3.53-1.59A5.2 5.2 0 0 0 16 11c0-1.22-.3-2.46-1.12-3.41A4.6 4.6 0 0 0 11.25 6H6.56l2.22-2.22a.75.75 0 0 0-1.06-1.06l-3.5 3.5a.75.75 0 0 0 .02 1.08l3.5 3.25a.75.75 0 0 0 1.02-1.1L6.66 7.5h4.59c1.16 0 1.86.44 2.4 1.07.55.64.85 1.52.85 2.43 0 .9-.3 1.79-.85 2.43a3 3 0 0 1-2.4 1.07h-4.5a.75.75 0 0 0-.75.75"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e99e7c341e0e8f3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpLeftRegular', "1em", [
    "M6 15.5c0 .28.22.5.5.5H11c1.64 0 2.9-.62 3.75-1.57A5.2 5.2 0 0 0 16 11c0-1.23-.41-2.48-1.25-3.43A4.9 4.9 0 0 0 11 6H5.7l2.65-2.65a.5.5 0 1 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L5.71 7H11c1.36 0 2.35.5 3 1.24.66.74 1 1.74 1 2.76s-.34 2.02-1 2.76A3.9 3.9 0 0 1 11 15H6.5a.5.5 0 0 0-.5.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$bf914eef418f5eca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpRightFilled', "1em", [
    "M9 6c.06 0-.06 0 0 0h4.65l-2.27-2.27a.75.75 0 1 1 1.06-1.06l3.35 3.35c.17.18.24.42.21.64a.8.8 0 0 1-.21.45l-3.25 3.24a.75.75 0 1 1-1.06-1.06l1.8-1.79H9a3.5 3.5 0 1 0 0 7h4.25a.75.75 0 0 1 0 1.5H9A5 5 0 0 1 9 6"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$fb5716a6500c86f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpRightRegular', "1em", [
    "M4 11a5 5 0 0 0 5 5h4.5a.5.5 0 0 0 0-1H9a4 4 0 0 1 0-8h5.3l-2.7 2.7a.5.5 0 1 0 .7.7l3.54-3.53a.5.5 0 0 0 .13-.5.5.5 0 0 0-.14-.25L12.3 2.6a.5.5 0 1 0-.71.7L14.29 6H9a5 5 0 0 0-5 5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$543176e4d5f48977 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowImportFilled', "1em", [
    "M17.25 3.75c.41 0 .75.34.75.75v11a.75.75 0 0 1-1.5 0v-11c0-.41.34-.75.75-.75M2 10c0-.41.34-.75.75-.75h10.19l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4a1 1 0 0 1 .15.22.8.8 0 0 1-.15.84l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H2.75A.75.75 0 0 1 2 10"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e547d0a1c90936e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowImportRegular', "1em", [
    "M17.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5M2 10c0-.28.22-.5.5-.5h10.8l-3.15-3.15a.5.5 0 0 1 .7-.7l4 4A.5.5 0 0 1 15 10a.5.5 0 0 1-.15.35l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H2.5A.5.5 0 0 1 2 10"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b12055510e53b54b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowJoinFilled', "1em", [
    "M4.5 2c.28 0 .5.22.5.5C5 6.12 7.88 9 11.5 9h.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L12.29 10h-.79A6.46 6.46 0 0 0 5 16.5a.5.5 0 0 1-1 0 7.45 7.45 0 0 1 4.78-7A7.45 7.45 0 0 1 4 2.5c0-.28.22-.5.5-.5m5.53 9.2A5.4 5.4 0 0 0 7 13.3v.7c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v.7a5.4 5.4 0 0 0 3.03 2.1 1.5 1.5 0 0 1 2.53-1.36l2 2a1.5 1.5 0 0 1 0 2.12l-2 2a1.5 1.5 0 0 1-2.53-1.37"
]);
const $4125b41377e9d21d$export$32a67ff96b2fecf2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowJoinRegular', "1em", [
    "M5 2.5a.5.5 0 0 0-1 0 7.45 7.45 0 0 0 4.78 7 7.45 7.45 0 0 0-4.78 7 .5.5 0 0 0 1 0c0-3.62 2.88-6.5 6.5-6.5h.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L12.29 9h-.79A6.46 6.46 0 0 1 5 2.5M8.5 4a.5.5 0 0 0 0 1H15c.52 0 1 .48 1 1v7c0 .52-.48 1-1 1H8.5a.5.5 0 0 0 0 1H15c1.08 0 2-.92 2-2V6c0-1.08-.92-2-2-2z"
]);
const $4125b41377e9d21d$export$80afbaf4e3398453 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowLeftFilled', "1em", [
    "M8.73 16.8a.75.75 0 0 0 1.03-1.1l-5.24-4.95h12.73a.75.75 0 0 0 0-1.5H4.52l5.24-4.96A.75.75 0 1 0 8.73 3.2L2.31 9.27a1 1 0 0 0 0 1.46z"
]);
const $4125b41377e9d21d$export$8040f9d0b476c0b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowLeftRegular', "1em", [
    "M9.16 16.87a.5.5 0 1 0 .67-.74L3.67 10.5H17.5a.5.5 0 0 0 0-1H3.67l6.16-5.63a.5.5 0 0 0-.67-.74L2.24 9.44a.75.75 0 0 0 0 1.11z"
]);
const $4125b41377e9d21d$export$cab30ef18d0a5bed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeFilled', "1em", [
    "M15.75 3.5c.41 0 .75.34.75.75v6a.75.75 0 0 1-1.5 0V6.06L6.06 15h4.19a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v4.19L13.94 5H9.75a.75.75 0 0 1 0-1.5z"
]);
const $4125b41377e9d21d$export$52fa252c94e2d235 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeRegular', "1em", [
    "M15.5 4c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V5.7L5.7 15h4.8a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v4.8L14.3 5H9.5a.5.5 0 0 1 0-1z"
]);
const $4125b41377e9d21d$export$7cba9603e2109c47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeTopLeftBottomRightFilled', "1em", [
    "M10.25 3.5a.75.75 0 0 1 0 1.5H6.06L15 13.94V9.75a.75.75 0 0 1 1.5 0v6c0 .41-.34.75-.75.75h-6a.75.75 0 0 1 0-1.5h4.19L5 6.06v4.19a.75.75 0 0 1-1.5 0v-6c0-.41.34-.75.75-.75z"
]);
const $4125b41377e9d21d$export$1e331543faecb350 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeTopLeftBottomRightRegular', "1em", [
    "M10.5 4a.5.5 0 0 1 0 1H5.7l9.3 9.3V9.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.8L5 5.7v4.8a.5.5 0 0 1-1 0v-6c0-.28.22-.5.5-.5z"
]);
const $4125b41377e9d21d$export$fd26c3e355491b5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeVerticalFilled', "1em", [
    "M9.58 1.33a.6.6 0 0 1 .84 0l2.13 2.13a.6.6 0 0 1-.85.84l-1.1-1.1v4.3a.6.6 0 1 1-1.2 0V3.2L8.3 4.3a.6.6 0 0 1-.85-.84zM3.9 10c0-.33.27-.6.6-.6h11a.6.6 0 1 1 0 1.2h-11a.6.6 0 0 1-.6-.6m6.7 6.8v-4.3a.6.6 0 0 0-1.2 0v4.3l-1.1-1.1a.6.6 0 0 0-.85.85l2.13 2.12a.6.6 0 0 0 .84 0l2.13-2.12a.6.6 0 1 0-.85-.85z"
]);
const $4125b41377e9d21d$export$81a1019b3e60955 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeVerticalRegular', "1em", [
    "M9.65 1.4c.2-.2.5-.2.7 0l2.12 2.13a.5.5 0 0 1-.7.7L10.5 2.96V7.5a.5.5 0 0 1-1 0V2.96L8.23 4.23a.5.5 0 1 1-.7-.7zM4 10c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 4 10m6.5 7.04V12.5a.5.5 0 0 0-1 0v4.54l-1.27-1.27a.5.5 0 1 0-.7.7l2.12 2.13c.2.2.5.2.7 0l2.12-2.12a.5.5 0 0 0-.7-.71z"
]);
const $4125b41377e9d21d$export$ed28000a0be5e908 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeFilled', "1em", [
    "M3.75 11h4.5c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 0 1-1.5.1v-2.79l-4.47 4.47a.75.75 0 0 1-1.13-.98l.07-.08 4.47-4.47H3.75a.75.75 0 0 1-.74-.65l-.01-.1c0-.38.28-.7.65-.74zh4.5zm14.28-9.03c.27.27.3.68.07.98l-.07.08L13.06 8h3.19c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-5a.75.75 0 0 1-.74-.65l-.01-.1v-5a.75.75 0 0 1 1.5-.1v3.29l4.97-4.97c.3-.3.77-.3 1.06 0"
]);
const $4125b41377e9d21d$export$b2bd1a3059522320 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeRegular', "1em", [
    "M8.5 11c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-3.8l-5.15 5.15a.5.5 0 0 1-.7-.7L7.29 12H3.5a.5.5 0 0 1 0-1zm8.65-8.85a.5.5 0 1 1 .7.7L12.71 8h3.79a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v3.8z"
]);
const $4125b41377e9d21d$export$2cd8708b41c56c4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeTopLeftBottomRightFilled', "1em", [
    "M16.25 11h.1c.37.06.65.37.65.75v.1a.75.75 0 0 1-.75.65h-2.69l4.47 4.47.07.08a.75.75 0 0 1-1.13.98l-4.47-4.47v2.79a.75.75 0 0 1-1.5-.1v-4.6a.75.75 0 0 1 .75-.65zM1.97 1.97c.3-.3.77-.3 1.06 0L8 6.94V3.65a.75.75 0 0 1 1.5.1v5.1a.75.75 0 0 1-.75.65h-5.1A.75.75 0 0 1 3 8.74v-.1A.75.75 0 0 1 3.76 8h3.19L1.97 3.03l-.07-.08a.75.75 0 0 1 .07-.98"
]);
const $4125b41377e9d21d$export$93caa8cfc35e0d45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeTopLeftBottomRightRegular', "1em", [
    "M16.5 11a.5.5 0 0 1 0 1h-3.8l5.15 5.15a.5.5 0 0 1-.7.7L12 12.71v3.79a.5.5 0 1 1-1 0v-5c0-.28.22-.5.5-.5zM2.15 2.15c.2-.2.5-.2.7 0L8 7.29V3.5a.5.5 0 1 1 1 0v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.8L2.14 2.85a.5.5 0 0 1 0-.7"
]);
const $4125b41377e9d21d$export$d6e452796dc7a9c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeVerticalFilled', "1em", [
    "M9.75 1.5c.41 0 .75.34.75.75v2.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72V2.25c0-.41.34-.75.75-.75M3.5 9.75c0-.41.34-.75.75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75m8.78 4.47-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v2.69a.75.75 0 0 0 1.5 0v-2.69l.72.72a.75.75 0 1 0 1.06-1.06"
]);
const $4125b41377e9d21d$export$17c6fe9d995a9764 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeVerticalRegular', "1em", [
    "M9.5 1c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 5.29V1.5c0-.28.22-.5.5-.5m-6 8.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5m6.5 4.2v3.8a.5.5 0 0 1-1 0v-3.8l-1.15 1.15a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7z"
]);
const $4125b41377e9d21d$export$bdd89c4834cac7eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveFilled', "1em", [
    "M10.53 2.22a.75.75 0 0 0-1.06 0L7.22 4.47a.75.75 0 0 0 1.06 1.06l.97-.97v2.69a.75.75 0 0 0 1.5 0V4.56l.97.97a.75.75 0 1 0 1.06-1.06zM2.22 9.47c-.3.3-.3.77 0 1.06l2.25 2.25a.75.75 0 0 0 1.06-1.06l-.97-.97h2.69a.75.75 0 0 0 0-1.5H4.56l.97-.97a.75.75 0 0 0-1.06-1.06zm8.31 8.31 2.25-2.25a.75.75 0 1 0-1.06-1.06l-.97.97v-2.69a.75.75 0 0 0-1.5 0v2.69l-.97-.97a.75.75 0 0 0-1.06 1.06l2.25 2.25c.3.3.77.3 1.06 0m5-10.56 2.25 2.25c.3.3.3.77 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l.97-.97h-2.69a.75.75 0 0 1 0-1.5h2.69l-.97-.97a.75.75 0 0 1 1.06-1.06"
]);
const $4125b41377e9d21d$export$fe8f2442bbb78559 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveRegular', "1em", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 1 0 .7.7L9.5 3.71V7.5a.5.5 0 0 0 1 0V3.7l1.65 1.65a.5.5 0 0 0 .7-.7zm-8.2 7.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L3.71 10.5H7.5a.5.5 0 0 0 0-1H3.7l1.65-1.65a.5.5 0 1 0-.7-.7zM10 18a.5.5 0 0 1-.35-.15l-2.5-2.5a.5.5 0 0 1 .7-.7l1.65 1.64V12.5a.5.5 0 0 1 1 0v3.8l1.65-1.65a.5.5 0 0 1 .7.7l-2.5 2.5A.5.5 0 0 1 10 18m7.85-7.65a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7l1.64 1.65H12.5a.5.5 0 0 0 0 1h3.8l-1.65 1.65a.5.5 0 0 0 .7.7z"
]);
const $4125b41377e9d21d$export$612fa7126a0ddf5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveInwardFilled', "1em", [
    "M13.03 3.72c.3.3.3.77 0 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.22 1.22V1.75a.75.75 0 0 1 1.5 0v3.19l1.22-1.22c.3-.3.77-.3 1.06 0M3.72 6.97c.3-.3.77-.3 1.06 0l2.5 2.5c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22H1.75a.75.75 0 0 1 0-1.5h3.19L3.72 8.03a.75.75 0 0 1 0-1.06m11.5 0a.75.75 0 1 1 1.06 1.06l-1.22 1.22h3.19a.75.75 0 0 1 0 1.5h-3.19l1.22 1.22a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06zm-2.19 9.31c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.22-1.22v3.19a.75.75 0 0 0 1.5 0v-3.19l1.22 1.22c.3.3.77.3 1.06 0"
]);
const $4125b41377e9d21d$export$95a6e9ad7cb82897 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveInwardRegular', "1em", [
    "M7.15 16.35c.2.2.5.2.7 0l1.65-1.64v3.79a.5.5 0 0 0 1 0v-3.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 0 .7m9.2-8.5a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7l-1.64-1.65h3.79a.5.5 0 0 0 0-1h-3.8zm-12.7 0a.5.5 0 1 1 .7-.7l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7l1.64-1.65H1.5a.5.5 0 0 1 0-1h3.8zm4.2-4.2a.5.5 0 1 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L10.5 5.29V1.5a.5.5 0 0 0-1 0v3.8z"
]);
const $4125b41377e9d21d$export$782aaa18c363dfcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowNextFilled', "1em", [
    "M13.75 4.75c.38 0 .7.28.74.65l.01.1v9a.75.75 0 0 1-1.5.1V5.5c0-.41.34-.75.75-.75m-8.28.22a.75.75 0 0 1 .98-.07l.08.07 4.5 4.5c.27.27.3.68.07.98l-.07.08-4.5 4.5a.75.75 0 0 1-1.13-.98l.07-.08L9.44 10 5.47 6.03a.75.75 0 0 1 0-1.06"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b8f9a77ed394a968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowNextRegular', "1em", [
    "M13.5 5a.5.5 0 0 1 .5.41v9.09a.5.5 0 0 1-1 .09V5.5c0-.28.22-.5.5-.5m-7.85.15a.5.5 0 0 1 .63-.06l.07.06 4.5 4.5c.18.17.2.44.06.63l-.06.07-4.5 4.5a.5.5 0 0 1-.76-.63l.06-.07L9.79 10 5.65 5.85a.5.5 0 0 1 0-.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4b1df7fe0b4c6227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineDownLeftFilled', "1em", [
    "M3.67 17.99A1.5 1.5 0 0 1 2 16.33l1.08-9.7a1.5 1.5 0 0 1 2.55-.9L6.7 6.8l4.36-4.36a1.5 1.5 0 0 1 2.12 0l4.37 4.37a1.5 1.5 0 0 1 0 2.12l-4.36 4.36 1.06 1.07a1.5 1.5 0 0 1-.9 2.55z"
]);
const $4125b41377e9d21d$export$b69d8bf68bb911ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineDownLeftRegular', "1em", [
    "M3 16.44a.5.5 0 0 0 .56.56l9.7-1.08a.5.5 0 0 0 .3-.85l-1.42-1.42a.5.5 0 0 1 0-.71l4.71-4.72a.5.5 0 0 0 0-.7l-4.37-4.37a.5.5 0 0 0-.7 0L7.06 7.86a.5.5 0 0 1-.7 0L4.92 6.44a.5.5 0 0 0-.85.3zM3.67 18A1.5 1.5 0 0 1 2 16.33l1.08-9.7a1.5 1.5 0 0 1 2.55-.9L6.7 6.8l4.36-4.36a1.5 1.5 0 0 1 2.12 0l4.37 4.37a1.5 1.5 0 0 1 0 2.12l-4.36 4.36 1.06 1.07a1.5 1.5 0 0 1-.9 2.55z"
]);
const $4125b41377e9d21d$export$6ec3b3ef60310b61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineUpRightFilled', "1em", [
    "M16.33 2c.96-.1 1.77.71 1.66 1.67l-1.08 9.7a1.5 1.5 0 0 1-2.55.9L13.3 13.2l-4.36 4.36a1.5 1.5 0 0 1-2.12 0l-4.37-4.37a1.5 1.5 0 0 1 0-2.12L6.8 6.7 5.74 5.64a1.5 1.5 0 0 1 .89-2.55z"
]);
const $4125b41377e9d21d$export$6eda91a02f89d145 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineUpRightRegular', "1em", [
    "M17 3.56a.5.5 0 0 0-.56-.56l-9.7 1.08a.5.5 0 0 0-.3.85l1.42 1.42a.5.5 0 0 1 0 .71l-4.71 4.72a.5.5 0 0 0 0 .7l4.37 4.37c.2.2.5.2.7 0l4.72-4.71c.2-.2.51-.2.7 0l1.43 1.42c.3.3.8.12.85-.3zM16.33 2c.96-.1 1.77.7 1.66 1.66l-1.08 9.7a1.5 1.5 0 0 1-2.55.9L13.3 13.2l-4.36 4.36a1.5 1.5 0 0 1-2.12 0l-4.37-4.37a1.5 1.5 0 0 1 0-2.12L6.8 6.7 5.74 5.64a1.5 1.5 0 0 1 .89-2.55z"
]);
const $4125b41377e9d21d$export$49c7f05f3a3cdb3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowParagraphFilled', "1em", [
    "M17.25 2c.41 0 .75.34.75.75v2.5A2.75 2.75 0 0 1 15.25 8h-3.8l1.36 1.5a.75.75 0 0 1-1.12 1L9.2 7.75a.75.75 0 0 1 0-1L11.7 4a.75.75 0 0 1 1.12 1l-1.36 1.5h3.8c.69 0 1.25-.56 1.25-1.25v-2.5c0-.41.34-.75.75-.75M8.3 9.5a.75.75 0 1 0-1.1 1L8.55 12h-5.8a.75.75 0 0 0 0 1.5h5.8L7.2 15a.75.75 0 0 0 1.1 1l2.5-2.75a.75.75 0 0 0 0-1z"
]);
const $4125b41377e9d21d$export$b120e22a27a3572c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowParagraphRegular', "1em", [
    "M12.15 10.85a.5.5 0 0 0 .7-.7L10.71 8h4.79A2.5 2.5 0 0 0 18 5.5v-3s0-.5-.5-.5-.5.5-.5.5v3c0 .83-.67 1.5-1.5 1.5h-4.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0 0 .7zm-4.3-1.7a.5.5 0 1 0-.7.7L9.29 12H2.5s-.5 0-.5.5.5.5.5.5h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 0-.7z"
]);
const $4125b41377e9d21d$export$be8501585e31ad0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowPreviousFilled', "1em", [
    "M6 4.75c-.38 0-.7.28-.74.65l-.01.1v9a.75.75 0 0 0 1.5.1V5.5A.75.75 0 0 0 6 4.75m8.28.22a.75.75 0 0 0-.98-.07l-.08.07-4.5 4.5a.75.75 0 0 0-.07.98l.07.08 4.5 4.5a.75.75 0 0 0 1.13-.98l-.07-.08L10.31 10l3.97-3.97c.3-.3.3-.77 0-1.06"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$98b528749acfb707 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowPreviousRegular', "1em", [
    "M6 5a.5.5 0 0 0-.5.41v9.09a.5.5 0 0 0 1 .09V5.5A.5.5 0 0 0 6 5m7.85.15a.5.5 0 0 0-.63-.06l-.07.06-4.5 4.5a.5.5 0 0 0-.06.63l.06.07 4.5 4.5a.5.5 0 0 0 .76-.63l-.06-.07L9.71 10l4.14-4.15a.5.5 0 0 0 0-.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6f417fd7cd228c34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRedoFilled', "1em", [
    "M13.14 6.5h-2.39a.75.75 0 1 0 0 1.5h4.4c.47 0 .85-.38.85-.85v-4.4a.75.75 0 0 0-1.5 0V5.7l-3.06-2.66a5.25 5.25 0 0 0-6.88 7.92l8.17 7.1a.75.75 0 1 0 .98-1.13l-8.17-7.1a3.75 3.75 0 1 1 4.92-5.66z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9781b7c58fa34512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRedoRegular', "1em", [
    "M15 2.5a.5.5 0 0 1 1 0v4.9a.6.6 0 0 1-.6.6h-4.9a.5.5 0 0 1 0-1h3.6l-3.48-3.02a4 4 0 1 0-5.24 6.04l8.17 7.1a.5.5 0 1 1-.66.76l-8.17-7.1a5 5 0 1 1 6.56-7.55L15 6.46z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$c1c7cf5cbe11ee39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeat1Filled', "1em", [
    "M15.75 6.01q.28 0 .48.17a5 5 0 0 1 1.74 4.4q-.69-.35-1.47-.49V10a3.5 3.5 0 0 0-1.26-2.69.75.75 0 0 1 .5-1.3m-5.38 7.49q-.27.71-.35 1.5H8.56l1.22 1.22c.27.27.3.68.08.98l-.08.08a.75.75 0 0 1-.97.07l-.09-.07-2.5-2.5a.75.75 0 0 1-.07-.98l.07-.08 2.5-2.5a.75.75 0 0 1 1.14.98l-.08.08-1.22 1.22zm-.15-10.78a.75.75 0 0 1 .98-.07l.08.07 2.5 2.5.08.08c.19.26.2.62 0 .89l-.08.09-2.5 2.5-.08.07c-.26.2-.62.2-.88.01l-.1-.08-.07-.08a.75.75 0 0 1 0-.89l.07-.09 1.22-1.22H7a3.5 3.5 0 0 0-3.5 3.3v.2c0 1.08.5 2.05 1.26 2.7q.23.2.24.54a.75.75 0 0 1-1.25.56A5 5 0 0 1 6.78 5h4.66l-1.22-1.22-.07-.08a.75.75 0 0 1 .07-.98M20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.95-2.66a.6.6 0 0 0-.68.23c-.21.3-.58.73-1.1.98a.5.5 0 1 0 .45.9q.45-.24.78-.53v3.08a.5.5 0 0 0 1 0v-4.08a.6.6 0 0 0-.45-.58"
]);
const $4125b41377e9d21d$export$a4a6d8dc78facf85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeat1Regular', "1em", [
    "M16.5 6.67a.5.5 0 0 1 .3.1l.08.07.01.02a5 5 0 0 1 1.08 3.72q-.47-.23-.98-.37a4 4 0 0 0-.88-2.73.5.5 0 0 1 .39-.81M10.2 14q-.13.49-.18 1H6.7l1.65 1.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06-2.5-2.5a.5.5 0 0 1-.06-.63l.06-.07 2.5-2.5a.5.5 0 0 1 .76.63l-.06.07L6.72 14h.14L7 14zm1.45-11.35a.5.5 0 0 1 .63-.06l.07.06 2.5 2.5.06.07a.5.5 0 0 1 0 .56l-.06.07-2.5 2.5-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.07a.5.5 0 0 1 0-.56l.06-.07L13.28 6h-.14L13 6H7a4 4 0 0 0-3.1 6.52q.1.14.1.31a.5.5 0 0 1-.9.3A4.99 4.99 0 0 1 6.77 5h6.52l-1.65-1.65-.06-.07a.5.5 0 0 1 .06-.63M20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.95-2.66a.6.6 0 0 0-.68.23c-.21.3-.58.73-1.1.98a.5.5 0 1 0 .45.9q.45-.24.78-.53v3.08a.5.5 0 0 0 1 0v-4.08a.6.6 0 0 0-.45-.58"
]);
const $4125b41377e9d21d$export$a429ffe945931d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllFilled', "1em", [
    "M15.75 6.01q.27 0 .47.17a5 5 0 0 1-3 8.82H8.56l1.22 1.22c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1-.07-.98l.07-.08 2.5-2.5a.75.75 0 0 1 1.13.98l-.07.08-1.22 1.22H13a3.5 3.5 0 0 0 3.5-3.3V10a3.5 3.5 0 0 0-1.26-2.69.75.75 0 0 1 .5-1.3m-5.53-3.29a.75.75 0 0 1 .98-.07l.08.07 2.5 2.5.07.08c.2.26.2.62.01.89l-.08.09-2.5 2.5-.08.07c-.26.2-.62.2-.89.01l-.09-.08-.07-.08a.75.75 0 0 1-.01-.89l.08-.09 1.22-1.22H7a3.5 3.5 0 0 0-3.5 3.3v.2c0 1.08.49 2.05 1.26 2.7q.23.2.24.54a.75.75 0 0 1-1.25.56A5 5 0 0 1 6.78 5h4.66l-1.22-1.22-.07-.08a.75.75 0 0 1 .07-.98"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4c7ec5c83bf3d62e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllRegular', "1em", [
    "M16.5 6.67a.5.5 0 0 1 .3.1l.08.07.01.02A5 5 0 0 1 13.22 15L13 15H6.7l1.65 1.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06-2.5-2.5a.5.5 0 0 1-.06-.63l.06-.07 2.5-2.5a.5.5 0 0 1 .76.63l-.06.07L6.72 14h.14L7 14h6a4 4 0 0 0 3.11-6.52.5.5 0 0 1 .39-.81m-4.85-4.02a.5.5 0 0 1 .63-.06l.07.06 2.5 2.5.06.07a.5.5 0 0 1 0 .56l-.06.07-2.5 2.5-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.07a.5.5 0 0 1 0-.56l.06-.07L13.28 6h-.14L13 6H7a4 4 0 0 0-3.1 6.52q.1.14.1.31a.5.5 0 0 1-.9.3A4.99 4.99 0 0 1 6.77 5h6.52l-1.65-1.65-.06-.07a.5.5 0 0 1 .06-.63"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9f06c0fa65ea1f69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllOffFilled', "1em", [
    "M2.22 2.22a.75.75 0 0 1 .98-.07l.08.07 14.5 14.5.07.08a.75.75 0 0 1-1.05 1.05l-.08-.07-2.86-2.85q-.27.04-.57.06L13 15H8.56l1.22 1.22c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1-.07-.98l.07-.08 2.5-2.5a.75.75 0 0 1 1.13.98l-.07.08-1.22 1.22h3.88L5.69 6.75A3.5 3.5 0 0 0 3.5 9.81V10c0 1.08.49 2.05 1.26 2.7q.23.2.24.54a.75.75 0 0 1-1.25.56 4.98 4.98 0 0 1 .82-8.17L2.22 3.28l-.07-.08a.75.75 0 0 1 .07-.98m13.53 3.79q.27 0 .47.17a4.98 4.98 0 0 1 .03 7.62l-1.06-1.07a3.5 3.5 0 0 0 .05-5.42.75.75 0 0 1 .5-1.3m-5.53-3.3a.75.75 0 0 1 .98-.06l.08.07 2.5 2.5.07.08c.2.26.2.62.01.89l-.08.09-2.5 2.5-.02.02-1.06-1.06.02-.02 1.22-1.22H8.95L7.45 5h3.99l-1.22-1.22-.07-.08a.75.75 0 0 1 .07-.98"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ecca820be091fae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllOffRegular', "1em", [
    "M2.15 2.15a.5.5 0 0 1 .63-.06l.07.06 15 15 .06.07a.5.5 0 0 1-.7.7l-.06-.07-3-2.98a5 5 0 0 1-.85.12L13 15H6.7l1.65 1.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06-2.5-2.5a.5.5 0 0 1-.06-.63l.06-.07 2.5-2.5a.5.5 0 0 1 .76.63l-.06.07L6.72 14h.14L7 14h6l.28-.01-7.72-7.72a4 4 0 0 0-1.66 6.25q.1.14.1.31a.5.5 0 0 1-.9.3A5 5 0 0 1 4.8 5.5L2.15 2.85l-.06-.07a.5.5 0 0 1 .06-.63M16.5 6.67a.5.5 0 0 1 .3.1l.08.07.01.02a5 5 0 0 1-.83 7.1l-.71-.72a4 4 0 0 0 .76-5.76.5.5 0 0 1 .39-.81M12.28 2.6l.07.06 2.5 2.5c.18.17.2.44.06.63l-.06.07-2.5 2.5a.5.5 0 0 1-.76-.63l.06-.07L13.28 6h-.14L13 6H8.1l-1-1h6.2l-1.65-1.65a.5.5 0 0 1-.06-.63l.06-.07a.5.5 0 0 1 .63-.06"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$da0896c91fdc6493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyFilled', "1em", [
    "M7.78 4.78a.75.75 0 0 0-1.06-1.06l-4.5 4.5c-.3.3-.3.77 0 1.06l4.5 4.5a.75.75 0 0 0 1.06-1.06L4.56 9.5h6.19a5.75 5.75 0 0 1 5.75 5.75.75.75 0 0 0 1.5 0c0-4-3.25-7.25-7.25-7.25H4.56z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$648439722953a702 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyRegular', "1em", [
    "M7.35 3.65c.2.2.2.5 0 .7L3.71 8h6.79a7.5 7.5 0 0 1 7.5 7.5.5.5 0 0 1-1 0A6.5 6.5 0 0 0 10.5 9H3.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$357919a9d708b114 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyAllFilled', "1em", [
    "M7.78 4.78a.75.75 0 0 0-1.06-1.06l-4.5 4.5c-.3.3-.3.77 0 1.06l4.5 4.5a.75.75 0 0 0 1.06-1.06L3.81 8.75zm3.5 0a.75.75 0 0 0-1.06-1.06l-4.5 4.5c-.3.3-.3.77 0 1.06l4.5 4.5a.75.75 0 1 0 1.06-1.06L8.06 9.5h2.69a5.75 5.75 0 0 1 5.75 5.75.75.75 0 0 0 1.5 0c0-4-3.25-7.25-7.25-7.25H8.06z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$dbda007b02d61c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyAllRegular', "1em", [
    "M7.35 3.65c.2.2.2.5 0 .7L3.21 8.5l4.14 4.15a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0m3 0c.2.2.2.5 0 .7L6.71 8h3.79a7.5 7.5 0 0 1 7.5 7.5.5.5 0 0 1-1 0A6.5 6.5 0 0 0 10.5 9H6.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e79bef3b6c5a645e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyDownFilled', "1em", [
    "M17.25 4c.41 0 .75.34.75.75 0 4-3.25 7.25-7.25 7.25H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 10.5h6.19a5.75 5.75 0 0 0 5.75-5.75c0-.41.34-.75.75-.75"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f19afc7f489e25f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyDownRegular', "1em", [
    "M17.5 4c.28 0 .5.22.5.5a7.5 7.5 0 0 1-7.5 7.5H3.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5a.5.5 0 1 1 .7.7L3.71 11h6.79A6.5 6.5 0 0 0 17 4.5c0-.28.22-.5.5-.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$bc36415eb5085b0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowResetFilled', "1em", [
    "M6.03 2.47c.3.3.3.77 0 1.06L4.81 4.75H11A6.25 6.25 0 1 1 4.75 11a.75.75 0 0 1 1.5 0A4.75 4.75 0 1 0 11 6.25H4.81l1.22 1.22a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5c.3-.3.77-.3 1.06 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$74b1db8905a7ae75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowResetRegular', "1em", [
    "M5.85 2.65c.2.2.2.5 0 .7L4.21 5H11a6 6 0 1 1-6 6 .5.5 0 0 1 1 0 5 5 0 1 0 5-5H4.2l1.65 1.65a.5.5 0 1 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5c.2-.2.5-.2.7 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$117f159384bb678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRightFilled', "1em", [
    "M11.27 3.2a.75.75 0 0 0-1.04 1.1l5.24 4.95H2.75a.75.75 0 0 0 0 1.5h12.73l-5.25 4.96a.75.75 0 1 0 1.04 1.09l6.41-6.07a1 1 0 0 0 0-1.46z"
]);
const $4125b41377e9d21d$export$39be26c8d2d2bd90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRightRegular', "1em", [
    "M10.84 3.13a.5.5 0 0 0-.68.74l6.17 5.63H2.5a.5.5 0 0 0 0 1h13.83l-6.17 5.63a.5.5 0 0 0 .68.74l6.91-6.32a.75.75 0 0 0 0-1.1z"
]);
const $4125b41377e9d21d$export$614f669b48a4b1a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateClockwiseFilled', "1em", [
    "M10 2.5A7.5 7.5 0 0 1 14.5 16h1.75a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v1.62A5.99 5.99 0 1 0 4 10a.75.75 0 0 1-1.5 0A7.5 7.5 0 0 1 10 2.5m0 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M10 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b524cdecb7b0e2df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateClockwiseRegular', "1em", [
    "M10 3a7 7 0 0 1 3.6 13H16a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.5-.5V13a.5.5 0 0 1 1 0v2.2A6 6 0 1 0 4 10a.5.5 0 0 1-1 0 7 7 0 0 1 7-7m0 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$26ba62f49807bd9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateCounterclockwiseFilled', "1em", [
    "M10 2.5a7.5 7.5 0 0 1 7.5 7.5.75.75 0 0 1-1.5 0 6 6 0 1 0-9.5 4.87v-1.62a.75.75 0 0 1 1.5 0v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1 0-1.5H5.5A7.49 7.49 0 0 1 10 2.5m0 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M10 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$8478f1ec7b46a39d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateCounterclockwiseRegular', "1em", [
    "M10 3a7 7 0 0 1 7 7 .5.5 0 0 1-1 0 6 6 0 1 0-9 5.2V13a.5.5 0 0 1 1 0v3.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h2.4A7 7 0 0 1 10 3m0 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$967d423e60bd9933 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingFilled', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7z"
]);
const $4125b41377e9d21d$export$a7c4bdb2e1724460 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingRegular', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7zM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $4125b41377e9d21d$export$86754837cdb96bac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingRectangleMultipleFilled', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2zM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7z"
]);
const $4125b41377e9d21d$export$8c3434b3d18b98f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingRectangleMultipleRegular', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2zM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7zM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $4125b41377e9d21d$export$c9e6045c552a00d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleFilled', "1em", [
    "M15.78 3.72a.75.75 0 1 0-1.06 1.06l.75.75c-3.09.28-4.88 2.2-6.47 3.9l-.05.06C7.2 11.38 5.65 13 2.75 13a.75.75 0 0 0 0 1.5c3.58 0 5.53-2.09 7.25-3.94l.05-.05c1.58-1.7 2.98-3.17 5.34-3.46l-.67.67a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06zM2.75 5.5c2.78 0 4.58 1.26 6.05 2.7l-.48.5-.1.1-.45.49C6.42 7.97 4.99 7 2.75 7a.75.75 0 1 1 0-1.5m12.72 8.97c-2.34-.21-3.94-1.37-5.27-2.66l.49-.51.09-.1.45-.49c1.17 1.14 2.4 2.02 4.16 2.24l-.67-.67a.75.75 0 1 1 1.06-1.06l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06z"
]);
const $4125b41377e9d21d$export$372717d58e7de81b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleRegular', "1em", [
    "M15.85 4.15a.5.5 0 0 0-.7.7L16.3 6c-3.33.07-5.29 1.9-7.1 3.6l-.04.03C7.28 11.4 5.53 13 2.5 13a.5.5 0 0 0 0 1c3.45 0 5.45-1.87 7.3-3.6l.04-.03C11.68 8.65 13.4 7.07 16.3 7l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7zM2.5 6c2.81 0 4.66 1.24 6.26 2.64l-.28.26-.46.43C6.52 8.03 4.92 7 2.5 7a.5.5 0 0 1 0-1m13.8 8c-2.7-.06-4.5-1.28-6.06-2.64l.28-.26.46-.43c1.46 1.27 3 2.27 5.31 2.33l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7z"
]);
const $4125b41377e9d21d$export$c785d80fd75571f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l3 3a8 8 0 0 0-2.4-.35.75.75 0 0 0 0 1.5c2.24 0 3.67.97 5.02 2.29l.4-.42.7.7C7.14 11.44 5.6 13 2.75 13a.75.75 0 0 0 0 1.5c3.53 0 5.47-2.03 7.18-3.86l.7.7q-.2.24-.43.47c.85.82 1.8 1.6 3 2.1l1.43 1.42a.75.75 0 0 0 1.04 1.04l1.48 1.48a.5.5 0 0 0 .7-.7zm12.16 10.74 2.08 2.08.69-.69c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.67.67zm-4.75-4.75 1.06 1.06a7 7 0 0 1 4.07-2.15l-.67.67a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.75.75c-2.3.21-3.9 1.34-5.21 2.6"
]);
const $4125b41377e9d21d$export$824d4389f6f1cf91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L6.09 6.8A8 8 0 0 0 2.5 6a.5.5 0 1 0 0 1c2.42 0 4.02 1.02 5.52 2.33l.31-.3.7.72C7.2 11.45 5.48 13 2.5 13a.5.5 0 0 0 0 1c3.4 0 5.4-1.83 7.25-3.55l.7.71-.2.2q.8.71 1.72 1.32l5.18 5.17a.5.5 0 0 0 .7-.7zm12.12 10.7 1.14 1.14h.19l-.1.1.71.7.94-.94a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.29 13a8 8 0 0 1-1.32-.15M10.52 8.4l.71.71c1.39-1.16 2.9-2.05 5.06-2.1l-1.14 1.14a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.3 6c-2.54.06-4.28 1.14-5.78 2.4"
]);
const $4125b41377e9d21d$export$a82caaf86ff08f76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortFilled', "1em", [
    "M14.84 16.72a.8.8 0 0 1-.59.28.7.7 0 0 1-.53-.22l-3-3a.75.75 0 0 1 1.06-1.07l1.72 1.73V3.75a.75.75 0 0 1 1.5 0v10.68l1.72-1.71a.75.75 0 1 1 1.06 1.06zM6.34 3.28A.8.8 0 0 0 5.75 3q-.3 0-.53.22l-3 3A.75.75 0 0 0 3.28 7.3L5 5.56v10.69a.75.75 0 0 0 1.5 0V5.57l1.72 1.71a.75.75 0 1 0 1.06-1.06z"
]);
const $4125b41377e9d21d$export$5f7722d3cf58b26e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortRegular', "1em", [
    "M2.35 7.35 5 4.71V16.5a.5.5 0 0 0 1 0V4.7l2.65 2.65a.5.5 0 0 0 .7-.7l-3.49-3.5A.5.5 0 0 0 5.5 3a.5.5 0 0 0-.39.18L1.65 6.65a.5.5 0 1 0 .7.7m15.3 5.3L15 15.29V3.5a.5.5 0 0 0-1 0v11.8l-2.65-2.65a.5.5 0 0 0-.7.7l3.49 3.5a.5.5 0 0 0 .36.15.5.5 0 0 0 .39-.18l3.46-3.47a.5.5 0 1 0-.7-.7"
]);
const $4125b41377e9d21d$export$a4ac5a40e31a5caf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownFilled', "1em", [
    "M9.75 17q.36 0 .59-.28l2.94-2.94a.75.75 0 0 0-1.06-1.06l-1.72 1.71V3.75a.75.75 0 0 0-1.5 0v10.7L7.28 12.7a.75.75 0 1 0-1.06 1.06l3 3.01q.23.22.53.22"
]);
const $4125b41377e9d21d$export$3b76f0280a8089c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownRegular', "1em", [
    "m10 15.29 2.65-2.64a.5.5 0 0 1 .7.7L9.9 16.82a.5.5 0 0 1-.74.03h-.01l-3.5-3.5a.5.5 0 1 1 .71-.7L9 15.29V3.5a.5.5 0 0 1 1 0z"
]);
const $4125b41377e9d21d$export$7fdc76a38aa6815d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownLinesFilled', "1em", [
    "M15 2.75a.75.75 0 0 0-1.5 0v12.57l-1.45-1.58a.75.75 0 0 0-1.1 1.02l2.75 3a.75.75 0 0 0 1.1 0l2.75-3a.75.75 0 0 0-1.1-1.02L15 15.32zM2.75 3.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM5 7.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 7.25M8.75 9.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z"
]);
const $4125b41377e9d21d$export$d4b807e9a13c5fe1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownLinesRegular', "1em", [
    "M15 2.5a.5.5 0 0 0-1 0v13.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7L15 16.29zM2.5 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM5 7.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M8.5 10a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $4125b41377e9d21d$export$fa5f63f22eca476e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpFilled', "1em", [
    "M9.75 3q.36 0 .59.28l2.94 2.94a.75.75 0 0 1-1.06 1.06L10.5 5.57v10.68a.75.75 0 0 1-1.5 0V5.55L7.28 7.3a.75.75 0 1 1-1.06-1.06l3-3.01A.7.7 0 0 1 9.75 3"
]);
const $4125b41377e9d21d$export$90a2de0eda90cb12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpRegular', "1em", [
    "M9 4.71 6.35 7.35a.5.5 0 1 1-.7-.7L9.1 3.18a.5.5 0 0 1 .74-.03h.01l3.5 3.5a.5.5 0 1 1-.71.7L10 4.71V16.5a.5.5 0 0 1-1 0z"
]);
const $4125b41377e9d21d$export$7e4d18ce7c6d51da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpLinesFilled', "1em", [
    "M15 17.25a.75.75 0 0 1-1.5 0V4.68l-1.45 1.58a.75.75 0 0 1-1.1-1.02l2.75-3a.75.75 0 0 1 1.1 0l2.75 3a.75.75 0 0 1-1.1 1.02L15 4.68zM2.75 16.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 0 1.5zM5 12.75c0 .41.34.75.75.75h5.5a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 0-.75.75m3.75-2.25a.75.75 0 0 1 0-1.5h2.5a.75.75 0 0 1 0 1.5z"
]);
const $4125b41377e9d21d$export$44fa18755446c11c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpLinesRegular', "1em", [
    "M15 17.5a.5.5 0 0 1-1 0V3.7l-2.15 2.15a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L15 3.71zM2.5 16a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1zM5 12.5c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5M8.5 10a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1z"
]);
const $4125b41377e9d21d$export$37f69e1bf92fc0d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSplitFilled', "1em", [
    "M10 3c.41 0 .75.34.75.75V8h2.24a2 2 0 0 1 2 2v4.44l1.23-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5c-.3.3-.77.3-1.07 0l-2.5-2.5a.75.75 0 1 1 1.07-1.06l1.21 1.22V10a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0-.5.5v4.44l1.23-1.22a.75.75 0 0 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L5 14.44V10c0-1.1.9-2 2-2h2.25V3.75c0-.41.34-.75.75-.75"
]);
const $4125b41377e9d21d$export$2832d93f19fae54a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSplitRegular', "1em", [
    "M10 3c.28 0 .5.22.5.5V8H13a2 2 0 0 1 2 2v5.3l1.65-1.65a.5.5 0 0 1 .7.7l-2.5 2.5a.5.5 0 0 1-.7 0l-2.5-2.5a.5.5 0 0 1 .7-.7L14 15.29V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5.3l1.65-1.65a.5.5 0 0 1 .7.7l-2.5 2.5a.5.5 0 0 1-.7 0l-2.5-2.5a.5.5 0 0 1 .7-.7L5 15.29V10c0-1.1.9-2 2-2h2.5V3.5c0-.28.22-.5.5-.5"
]);
const $4125b41377e9d21d$export$b9873c5d8e57f261 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSprintFilled', "1em", [
    "M10 6.5a3 3 0 1 0 0 6h6.44l-.72-.72a.75.75 0 1 1 1.06-1.06l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H10a4.5 4.5 0 1 1 4.03-2.5h-1.8a3 3 0 0 0-2.24-5m-7.25 6h2.64q.58.9 1.45 1.5H2.75a.75.75 0 0 1 0-1.5"
]);
const $4125b41377e9d21d$export$1ce0c5c3bc673d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSprintRegular', "1em", [
    "M10 6a3.5 3.5 0 1 0 0 7h7.3l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L17.29 14H10a4.5 4.5 0 1 1 3.74-2h-1.29A3.49 3.49 0 0 0 10 6m-7.5 7h3.26q.46.58 1.08 1H2.5a.5.5 0 0 1 0-1"
]);
const $4125b41377e9d21d$export$2e9dd1dd98ca5130 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_square_20_color__a)",
            "d": "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_square_20_color__b)",
            "d": "M10.5 6.5a.5.5 0 0 0-1 0v5.8L6.85 9.64a.5.5 0 1 0-.7.7l3.5 3.5c.2.2.5.2.7 0l3.5-3.5a.5.5 0 0 0-.7-.7l-2.65 2.64z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_square_20_color__a",
                "x1": "3.5",
                "x2": "14.5",
                "y1": "5.63",
                "y2": "14.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_square_20_color__b",
                "x1": "7.54",
                "x2": "14",
                "y1": "6.62",
                "y2": "20.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$ad8d0744550a63e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareDownColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_square_down_20_color__a)",
            "d": "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_square_down_20_color__b)",
            "d": "M10.5 6.5a.5.5 0 0 0-1 0v5.8L6.85 9.64a.5.5 0 1 0-.7.7l3.5 3.5c.2.2.5.2.7 0l3.5-3.5a.5.5 0 0 0-.7-.7l-2.65 2.64z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_square_down_20_color__a",
                "x1": "3.5",
                "x2": "14.5",
                "y1": "5.63",
                "y2": "14.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_square_down_20_color__b",
                "x1": "7.54",
                "x2": "14",
                "y1": "6.62",
                "y2": "20.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b3e0ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$9910268128d410ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareDownFilled', "1em", [
    "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm5.5 3.5v5.8l2.65-2.65a.5.5 0 0 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 .7-.7l2.65 2.64V6.5a.5.5 0 0 1 1 0"
]);
const $4125b41377e9d21d$export$9d32183472891caa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareDownRegular', "1em", [
    "M10.5 6.5a.5.5 0 0 0-1 0v5.8L6.85 9.64a.5.5 0 1 0-.7.7l3.5 3.5c.2.2.5.2.7 0l3.5-3.5a.5.5 0 1 0-.7-.7l-2.65 2.64zM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
]);
const $4125b41377e9d21d$export$d9243fdb331c1f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareUpRightFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm9.7 1.04a1 1 0 0 0-.2-.04h-5a.5.5 0 0 0 0 1h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L12 8.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.14-.35 1 1 0 0 0-.17-.11"
]);
const $4125b41377e9d21d$export$3ede8de92b77ba80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareUpRightRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm8.7 1.04.15.1a.5.5 0 0 1 .15.36v5a.5.5 0 0 1-1 0V8.7l-4.15 4.15a.5.5 0 0 1-.7-.7L11.29 8H7.5a.5.5 0 0 1 0-1h5a1 1 0 0 1 .2.04"
]);
const $4125b41377e9d21d$export$3a35402abf5cb0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepBackFilled', "1em", [
    "M7.85 3.15c.2.2.2.5 0 .7L4.71 7H10a8 8 0 0 1 6.94 4.04.5.5 0 1 1-.88.5A7 7 0 0 0 10 8H4.7l3.15 3.15a.5.5 0 0 1-.7.7L3.15 7.87a.5.5 0 0 1-.01-.72l4-4c.19-.2.5-.2.7 0M12 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $4125b41377e9d21d$export$5d2c50fa87f6e97f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepBackRegular', "1em", [
    "M7.85 3.15c.2.2.2.5 0 .7L4.71 7H10a8 8 0 0 1 6.94 4.04.5.5 0 1 1-.88.5A7 7 0 0 0 10 8H4.7l3.15 3.15a.5.5 0 0 1-.7.7L3.15 7.87a.5.5 0 0 1-.01-.72l4-4c.19-.2.5-.2.7 0M8 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $4125b41377e9d21d$export$a3be9a3d6a44038a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInFilled', "1em", [
    "M12 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0M10 2c.28 0 .5.22.5.5v7.8l3.15-3.15a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7l3.15 3.14V2.5c0-.28.22-.5.5-.5"
]);
const $4125b41377e9d21d$export$23f7469f896cb988 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInRegular', "1em", [
    "M10 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-14c.28 0 .5.22.5.5v7.8l3.15-3.15a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7l3.15 3.14V2.5c0-.28.22-.5.5-.5"
]);
const $4125b41377e9d21d$export$8d83fb3bdd2fc285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInDiagonalDownLeftFilled', "1em", [
    "M16.85 3.15c.2.2.2.5 0 .7L9.71 11h4.79a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v4.8l7.15-7.15c.2-.2.5-.2.7 0M5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $4125b41377e9d21d$export$9979b9e73db7fda6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInDiagonalDownLeftRegular', "1em", [
    "M16.85 3.15c.2.2.2.5 0 .7L9.71 11h4.79a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v4.8l7.15-7.15c.2-.2.5-.2.7 0M7 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $4125b41377e9d21d$export$1a1735a46072d4dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInLeftFilled', "1em", [
    "M4 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4m14-2a.5.5 0 0 1-.5.5H9.7l3.15 3.15a.5.5 0 0 1-.7.7l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 0 1 .7.7L9.71 9.5h7.79c.28 0 .5.22.5.5"
]);
const $4125b41377e9d21d$export$45b5ef41296ff1f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInLeftRegular', "1em", [
    "M5 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0M4 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m14 2a.5.5 0 0 1-.5.5H9.7l3.15 3.15a.5.5 0 0 1-.7.7l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 0 1 .7.7L9.71 9.5h7.79c.28 0 .5.22.5.5"
]);
const $4125b41377e9d21d$export$4144b2eaf4c44181 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInRightFilled', "1em", [
    "M16 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4M2 10c0-.28.22-.5.5-.5h7.8L7.14 6.35a.5.5 0 1 1 .7-.7l4 4c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H2.5A.5.5 0 0 1 2 10"
]);
const $4125b41377e9d21d$export$71bb2b8cc631df20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInRightRegular', "1em", [
    "M15 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4M2 10c0-.28.22-.5.5-.5h7.8L7.14 6.35a.5.5 0 1 1 .7-.7l4 4c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H2.5A.5.5 0 0 1 2 10"
]);
const $4125b41377e9d21d$export$53bac810d5e41ce8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOutFilled', "1em", [
    "M12 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2-4a.5.5 0 0 0 .5-.5V3.7l3.15 3.15a.5.5 0 0 0 .7-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L9.5 3.71v7.79c0 .28.22.5.5.5"
]);
const $4125b41377e9d21d$export$11ace01496244ce4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOutRegular', "1em", [
    "M10 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a.5.5 0 0 0 .5-.5V3.7l3.15 3.15a.5.5 0 0 0 .7-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L9.5 3.71v7.79c0 .28.22.5.5.5"
]);
const $4125b41377e9d21d$export$24f66ea488a40da8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOverFilled', "1em", [
    "M12.15 3.15a.5.5 0 0 0 0 .7L15.29 7H10a8 8 0 0 0-6.94 4.04.5.5 0 1 0 .88.5A7 7 0 0 1 10 8h5.3l-3.15 3.15a.5.5 0 1 0 .7.7l3.99-3.98a.5.5 0 0 0 .01-.72l-4-4a.5.5 0 0 0-.7 0M8 15a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$121a2436d1e30a30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOverRegular', "1em", [
    "M12.15 3.15a.5.5 0 0 0 0 .7L15.29 7H10a8 8 0 0 0-6.94 4.04.5.5 0 1 0 .88.5A7 7 0 0 1 10 8h5.3l-3.15 3.15a.5.5 0 1 0 .7.7l3.99-3.98a.5.5 0 0 0 .01-.72l-4-4a.5.5 0 0 0-.7 0M12 15a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-2-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$857eb1bb3d9a770d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSwapFilled', "1em", [
    "M12.78 3.22a.75.75 0 1 0-1.06 1.06L13.44 6H4.75a.75.75 0 0 0 0 1.5h8.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3c.3-.3.3-.77 0-1.06zm-4.5 7.56a.75.75 0 1 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06L6.56 14h8.69a.75.75 0 0 0 0-1.5H6.56z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$1039164ceb56cfd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSwapRegular', "1em", [
    "M12.15 3.15c.2-.2.5-.2.7 0l3 3c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7-.7L14.29 7H4.5a.5.5 0 0 1 0-1h9.8l-2.15-2.15a.5.5 0 0 1 0-.7m-4.3 7c.2.2.2.5 0 .7L5.71 13h9.79a.5.5 0 0 1 0 1H5.7l2.15 2.15a.5.5 0 0 1-.7.7l-3-3a.5.5 0 0 1 0-.7l3-3c.2-.2.5-.2.7 0"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$fb1425a65692e285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_sync_20_color__a)",
            "fillRule": "evenodd",
            "d": "M8.3.3a1 1 0 0 1 1.4 0l2.5 2.5a1 1 0 0 1 0 1.4L9.7 6.7a1 1 0 0 1-1.4-1.4l.7-.7a5.5 5.5 0 0 0-2.51 9.63 1 1 0 0 1-1.28 1.54A7.49 7.49 0 0 1 9.14 2.55l-.85-.84a1 1 0 0 1 0-1.42m5.11 4.08a1 1 0 0 1 1.41-.12 7.49 7.49 0 0 1-3.96 13.2l.85.83a1 1 0 0 1-1.42 1.42l-2.5-2.5a1 1 0 0 1 0-1.42l2.5-2.5a1 1 0 0 1 1.42 1.42l-.7.7a5.5 5.5 0 0 0 2.53-9.62 1 1 0 0 1-.13-1.41",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_sync_20_color__a",
                "x1": "14",
                "x2": "6",
                "y1": "16.5",
                "y2": "0",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#22918b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#20ac9d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$1e5b39d5a72a35d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncFilled', "1em", [
    "M9.89 3.75a6.25 6.25 0 0 0-3.63 11.26.75.75 0 0 1-.9 1.2q-.44-.34-.84-.73a7.75 7.75 0 0 1 4.83-13.2l-.59-.59A.75.75 0 0 1 9.82.63l2.12 2.12c.3.3.3.77 0 1.06L9.82 5.93a.75.75 0 0 1-1.06-1.06zm.22 12.5a6.25 6.25 0 0 0 3.63-11.26.75.75 0 0 1 .9-1.2q.44.33.84.73a7.75 7.75 0 0 1-4.83 13.2l.59.59a.75.75 0 1 1-1.06 1.06l-2.12-2.12a.75.75 0 0 1 0-1.06l2.12-2.13a.75.75 0 1 1 1.06 1.07z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$443272156fef2fb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncRegular', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8A6.5 6.5 0 0 1 10.14 3.5L8.59 5.04a.5.5 0 0 0 .7.7zM8.6 16.36a.5.5 0 0 0 0 .71l2.12 2.12a.5.5 0 0 0 .7-.7l-1-1a7.5 7.5 0 0 0 4.07-13.5.5.5 0 1 0-.59.8q.37.28.7.61a6.5 6.5 0 0 1-4.73 11.1l1.55-1.55a.5.5 0 1 0-.7-.7z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ec407c48735e25c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCheckmarkFilled', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8A6.5 6.5 0 0 1 11.4 3.66zM8.6 16.36l.01-.01q.61.14 1.27.15h-.01.07A6.5 6.5 0 0 0 13.9 4.8a.5.5 0 1 1 .6-.8q.44.3.81.7a7.5 7.5 0 0 1-4.88 12.79l1 1a.5.5 0 1 1-.71.7l-2.12-2.12a.5.5 0 0 1 0-.7M15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2.65-1.85a.5.5 0 0 0-.7 0L9 10.79 7.85 9.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9a33574dc1966552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCheckmarkRegular', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8A6.5 6.5 0 0 1 11.4 3.66zM8.6 16.36l.01-.01q.61.14 1.27.15h-.01.07A6.5 6.5 0 0 0 13.9 4.8a.5.5 0 1 1 .6-.8q.44.3.81.7a7.5 7.5 0 0 1-4.88 12.79l1 1a.5.5 0 1 1-.71.7l-2.12-2.12a.5.5 0 0 1 0-.7m3.76-8.21c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L9 10.79l2.65-2.64c.2-.2.5-.2.7 0M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0m5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7d9613a6f676efb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCircleFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m3.5-8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.7a3.5 3.5 0 0 0-5.6-.53.5.5 0 1 0 .74.66 2.5 2.5 0 0 1 4.15.67h-.79a.5.5 0 1 0 0 1zm-7.5.5v2a.5.5 0 0 0 1 0v-.7a3.5 3.5 0 0 0 5.6.53.5.5 0 0 0-.74-.66A2.5 2.5 0 0 1 7.71 11h.79a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$caf00c62123be032 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCircleRegular', "1em", [
    "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14m8 7a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-8-2.5c1.02 0 1.9.62 2.3 1.5h-.8a.5.5 0 1 0 0 1h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.7a3.5 3.5 0 0 0-5.6-.53.5.5 0 0 0 .74.66A2.5 2.5 0 0 1 10 7.5m-3 4.3v.7a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.8a2.5 2.5 0 0 0 4.16.67.5.5 0 0 1 .75.66A3.5 3.5 0 0 1 7 11.8"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f918c8ab953aea44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncDismissFilled', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8 6.5 6.5 0 0 1 5.28-11.55zM8.6 16.36l.02-.02a6.48 6.48 0 0 0 5.99-1.74 6.5 6.5 0 0 0-.7-9.8.5.5 0 1 1 .6-.8q.42.3.8.7a7.5 7.5 0 0 1-4.88 12.79l1 1a.5.5 0 1 1-.71.7l-2.12-2.12a.5.5 0 0 1 0-.7M15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-3.15-1.15a.5.5 0 0 0-.7-.7L10 9.29 8.85 8.15a.5.5 0 0 0-.7.7L9.29 10l-1.14 1.15a.5.5 0 1 0 .7.7L10 10.71l1.15 1.14a.5.5 0 0 0 .7-.7L10.71 10z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$a515c39e0bcfe044 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncDismissRegular', "1em", [
    "M11.41 2.93c.2.2.2.51 0 .7l-.01.02q-.67-.15-1.33-.15A6.5 6.5 0 0 0 6.1 15.2a.5.5 0 1 1-.6.8A7.5 7.5 0 0 1 9.59 2.5l-1-.99a.5.5 0 0 1 .7-.7zm-2.8 13.42-.02.01a.5.5 0 0 0 0 .71l2.12 2.12a.5.5 0 0 0 .7-.7l-1-1a7.5 7.5 0 0 0 4.07-13.5.5.5 0 1 0-.59.8q.37.28.7.61A6.5 6.5 0 0 1 8.6 16.35m3.24-8.2c.2.2.2.5 0 .7L10.71 10l1.14 1.15a.5.5 0 0 1-.7.7L10 10.71l-1.15 1.14a.5.5 0 0 1-.7-.7L9.29 10 8.15 8.85a.5.5 0 1 1 .7-.7L10 9.29l1.15-1.14c.2-.2.5-.2.7 0M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0m5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4ec27fc1158233e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncOffFilled', "1em", [
    "M9.89 3.75a6 6 0 0 0-3.12.9L5.68 3.56a8 8 0 0 1 3.67-1.28l-.59-.59A.75.75 0 0 1 9.82.63l2.12 2.12c.3.3.3.77 0 1.06L9.82 5.93a.75.75 0 0 1-1.06-1.06zM4.18 4.88a7.75 7.75 0 0 0 1.18 11.33.75.75 0 1 0 .9-1.2 6.25 6.25 0 0 1-1.02-9.06l8.81 8.8a6.2 6.2 0 0 1-3.94 1.5l1.13-1.12a.75.75 0 0 0-1.06-1.07L8.06 16.2c-.3.29-.3.76 0 1.06l2.12 2.12a.75.75 0 1 0 1.06-1.06l-.59-.59a7.7 7.7 0 0 0 4.47-1.9l2.03 2.03a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7zm11.17 8.35 1.09 1.09a7.75 7.75 0 0 0-1.8-10.53.75.75 0 0 0-.9 1.2q.36.26.68.59a6.25 6.25 0 0 1 .93 7.65"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6df263960ce9d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncOffRegular', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1c-1.3.07-2.6.48-3.73 1.23l.73.73a6.5 6.5 0 0 1 3.55-.98L8.59 5.05a.5.5 0 0 0 .7.7zM4.35 5.06a7.5 7.5 0 0 0 1.16 10.95.5.5 0 0 0 .6-.8 6.5 6.5 0 0 1-1.04-9.44l9.16 9.17a6.5 6.5 0 0 1-4.37 1.56l1.55-1.55a.5.5 0 1 0-.7-.7l-2.12 2.11a.5.5 0 0 0 0 .71l2.12 2.12a.5.5 0 0 0 .7-.7l-1-1a7.5 7.5 0 0 0 4.53-1.85l2.2 2.21a.5.5 0 0 0 .71-.7l-15-15a.5.5 0 1 0-.7.7zM15.3 4.7a7.5 7.5 0 0 1 .96 9.44l-.73-.73A6.5 6.5 0 0 0 13.9 4.8a.5.5 0 1 1 .6-.8q.44.32.81.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$a0317b775455963a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingFilled', "1em", [
    "M17.94 5.46a.75.75 0 0 0-.7-.46h-5.49a.75.75 0 0 0 0 1.5h3.69l-4.94 4.94-1.97-1.97a.75.75 0 0 0-1.06 0l-5.25 5.25a.75.75 0 1 0 1.06 1.06L8 11.06l1.97 1.97c.3.3.77.3 1.06 0l5.47-5.47v3.69a.75.75 0 0 0 1.5 0v-5.5q0-.15-.06-.29"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b93cd1eaf7dc2db0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingRegular', "1em", [
    "M17.96 5.3a.5.5 0 0 0-.46-.3h-6a.5.5 0 0 0 0 1h4.8l-5.8 5.8-2.15-2.15a.5.5 0 0 0-.7 0l-5.5 5.5a.5.5 0 0 0 .7.7L8 10.71l2.15 2.14c.2.2.5.2.7 0L17 6.71v4.79a.5.5 0 0 0 1 0v-6a1 1 0 0 0-.04-.2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$5dc7a8f8587b1b3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingCheckmarkFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.8l-4.5 4.1a.75.75 0 0 1-1.03-.02L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25a.75.75 0 0 1 1.06 0l1.5 1.5 3.79-3.47h-2.57a.75.75 0 1 1 0-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.62-1.83a.5.5 0 0 0-.7-.05l-3.15 2.7-1.18-1.17a.5.5 0 0 0-.7.7l1.5 1.5c.18.19.48.2.68.03l3.5-3a.5.5 0 0 0 .05-.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b68dee8aae62cb8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingCheckmarkRegular', "1em", [
    "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V4.7l-4.65 4.65a.5.5 0 0 1-.7 0L9 7.71l-5.15 5.14a.5.5 0 0 1-.7-.7l5.5-5.5a.5.5 0 0 1 .7 0L11 8.29 15.3 4h-2.8a.5.5 0 0 1 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.62-1.83a.5.5 0 0 0-.7-.05l-3.15 2.7-1.18-1.17a.5.5 0 0 0-.7.7l1.5 1.5c.18.19.48.2.68.03l3.5-3a.5.5 0 0 0 .05-.7"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$91378963d8ff563c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingDownFilled', "1em", [
    "M17.94 14.54a.75.75 0 0 1-.7.46h-5.49a.75.75 0 0 1 0-1.5h3.69L10.5 8.56l-1.97 1.97c-.3.3-.77.3-1.06 0L2.22 5.28a.75.75 0 0 1 1.06-1.06L8 8.94l1.97-1.97c.3-.3.77-.3 1.06 0l5.47 5.47V8.75a.75.75 0 0 1 1.5 0v5.5q0 .15-.06.29"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$31ff5dc4b3890428 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingDownRegular', "1em", [
    "M17.96 14.7a.5.5 0 0 1-.46.3h-6a.5.5 0 0 1 0-1h4.8l-5.8-5.8-2.15 2.15a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L8 9.29l2.15-2.14c.2-.2.5-.2.7 0L17 13.29V8.5a.5.5 0 0 1 1 0v6a1 1 0 0 1-.04.2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4f7c0c2778921a3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingLinesColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_trending_lines_20_color__a)",
            "d": "M17 10a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_trending_lines_20_color__b)",
            "d": "M9 12a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_trending_lines_20_color__c)",
            "d": "M5 15a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_trending_lines_20_color__d)",
            "d": "M12 13a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_arrow_trending_lines_20_color__e)",
            "fillRule": "evenodd",
            "d": "M14 4a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-.59l-3.8 3.8a1 1 0 0 1-1.4 0L8.5 6.9l-4.3 4.3a1 1 0 0 1-1.4-1.42l5-5a1 1 0 0 1 1.4 0l2.3 2.3L14.59 4z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_trending_lines_20_color__a",
                "x1": "17.91",
                "x2": "2.09",
                "y1": "8.48",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_trending_lines_20_color__b",
                "x1": "17.91",
                "x2": "2.09",
                "y1": "8.48",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_trending_lines_20_color__c",
                "x1": "17.91",
                "x2": "2.09",
                "y1": "8.48",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_trending_lines_20_color__d",
                "x1": "17.91",
                "x2": "2.09",
                "y1": "8.48",
                "y2": "18",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_arrow_trending_lines_20_color__e",
                "x1": "3.05",
                "x2": "18",
                "y1": "11.5",
                "y2": "1.22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#22918b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#20ac9d"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$c5e571b712ec807d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingLinesFilled', "1em", [
    "M14 2.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-.69l-4.47 4.47c-.3.3-.77.3-1.06 0L8.5 6.56l-4.22 4.22a.75.75 0 1 1-1.06-1.06l4.75-4.75c.3-.3.77-.3 1.06 0l2.47 2.47 3.94-3.94h-.69a.75.75 0 0 1-.75-.75M3.75 14c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m4.75-2.25a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0zM11.75 13c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75m4.75-3.25a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f868d183594f21f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingLinesRegular', "1em", [
    "M14.5 2a.5.5 0 0 0 0 1h1.8l-4.8 4.8-2.65-2.65a.5.5 0 0 0-.7 0l-5 5a.5.5 0 0 0 .7.7L8.5 6.21l2.65 2.64c.2.2.5.2.7 0L17 3.71V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$54d9e567d82f9e2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSettingsFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5zm-4.68 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$dd1fa542155a1f19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSettingsRegular', "1em", [
    "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V4.7l-4.65 4.65a.5.5 0 0 1-.7 0L9 7.71l-5.15 5.14a.5.5 0 0 1-.7-.7l5.5-5.5a.5.5 0 0 1 .7 0L11 8.29 15.3 4h-2.8a.5.5 0 0 1 0-1zm-4.43 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$cb086a24df351a99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSparkleFilled', "1em", [
    "m5.88 2.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 8.72a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L2.28 5.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0M16.75 6a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V8.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 11.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5zm-.73 8.96.76.25h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$5b3388f8caa131ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSparkleRegular', "1em", [
    "m5.88 2.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 8.72a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L2.28 5.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0M17 6.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.8L11 11.3 9.35 9.64a.5.5 0 0 0-.7 0l-5.5 5.5a.5.5 0 0 0 .7.7L9 10.71l1.65 1.64a.5.5 0 0 0 .7 0L16 7.71v2.79a.5.5 0 0 0 1 0zm-.98 8.46.76.25h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$53c229b6980143f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingTextFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5zM10 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e4b276dde3c314c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingTextRegular', "1em", [
    "M17 3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.8L11 8.3 9.35 6.64a.5.5 0 0 0-.7 0l-5.5 5.5a.5.5 0 0 0 .7.7L9 7.71l1.65 1.64a.5.5 0 0 0 .7 0L16 4.71V7.5a.5.5 0 0 0 1 0zM10 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1m-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6475d0e96f072621 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingWrenchFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5c0 .26-.14.5-.34.63a1.4 1.4 0 0 0-1.15-.9H16V5.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5zm-.65 6.71c.26-.26.16-.7-.2-.74a3.5 3.5 0 0 0-3.71 4.66l-2.72 2.7a1.5 1.5 0 0 0 2.13 2.13l2.7-2.71a3.5 3.5 0 0 0 4.66-3.7c-.04-.37-.48-.48-.74-.22l-.97.97a1.5 1.5 0 1 1-2.12-2.12z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$bd98be12e0ed88ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingWrenchRegular', "1em", [
    "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V4.7l-4.65 4.65a.5.5 0 0 1-.7 0L9 7.71l-5.15 5.14a.5.5 0 0 1-.7-.7l5.5-5.5a.5.5 0 0 1 .7 0L11 8.29 15.3 4h-2.8a.5.5 0 0 1 0-1zm-.4 6.71c.26-.26.16-.7-.2-.74a3.5 3.5 0 0 0-3.71 4.66l-2.72 2.7a1.5 1.5 0 0 0 2.13 2.13l2.7-2.71a3.5 3.5 0 0 0 4.66-3.7c-.04-.37-.48-.48-.74-.22l-.97.97a1.5 1.5 0 1 1-2.12-2.12z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$df95da6fe65b7b90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnBidirectionalDownRightFilled', "1em", [
    "M13.78 2.22a.75.75 0 1 0-1.06 1.06L15.44 6H9a3 3 0 0 0-3 3v6.44l-2.72-2.72a.75.75 0 0 0-1.06 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L7.5 15.44V9c0-.83.67-1.5 1.5-1.5h6.44l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06z"
]);
const $4125b41377e9d21d$export$7691ae86acd529e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnBidirectionalDownRightRegular', "1em", [
    "M13.85 2.15a.5.5 0 0 0-.7.7L16.29 6H9a3 3 0 0 0-3 3v7.3l-3.15-3.15a.5.5 0 0 0-.7.7l4 4c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7L7 16.29V9c0-1.1.9-2 2-2h7.3l-3.15 3.15a.5.5 0 0 0 .7.7l4-4a.5.5 0 0 0 0-.7z"
]);
const $4125b41377e9d21d$export$33b299bff1fcd54c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownLeftFilled', "1em", [
    "M9.28 16.78c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L6.56 11.5H13c.83 0 1.5-.67 1.5-1.5V3.75a.75.75 0 0 1 1.5 0V10a3 3 0 0 1-3 3H6.56l2.72 2.72c.3.3.3.77 0 1.06"
]);
const $4125b41377e9d21d$export$b1763a86e46e16f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownLeftRegular', "1em", [
    "M8.85 16.85a.5.5 0 0 1-.7 0l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 1 1 .7.7L5.71 12H12a2 2 0 0 0 2-2V3.5a.5.5 0 0 1 1 0V10a3 3 0 0 1-3 3H5.7l3.15 3.15c.2.2.2.5 0 .7"
]);
const $4125b41377e9d21d$export$2250fb084f5452a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownRightFilled', "1em", [
    "M10.72 16.78c.3.3.77.3 1.06 0l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06l2.72 2.72H7A1.5 1.5 0 0 1 5.5 10V3.75a.75.75 0 0 0-1.5 0V10a3 3 0 0 0 3 3h6.44l-2.72 2.72c-.3.3-.3.77 0 1.06"
]);
const $4125b41377e9d21d$export$5e9b570e502d236d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownRightRegular', "1em", [
    "M11.15 16.85c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7l-4-4a.5.5 0 0 0-.7.7L14.29 12H8a2 2 0 0 1-2-2V3.5a.5.5 0 0 0-1 0V10a3 3 0 0 0 3 3h6.3l-3.15 3.15a.5.5 0 0 0 0 .7"
]);
const $4125b41377e9d21d$export$55de8f2a161fd955 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownUpFilled', "1em", [
    "M16.45 3.47a.75.75 0 0 0-1.03-.4l-5 2.5a.75.75 0 1 0 .67 1.35l3.24-1.62L10 15.12 5.44 4.45a.75.75 0 0 0-1.38.6l4.8 11.19c.43 1 1.85 1 2.29 0l4.6-10.46 1.3 3.25a.75.75 0 1 0 1.4-.56z"
]);
const $4125b41377e9d21d$export$4ba6f05dd6da68bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownUpRegular', "1em", [
    "M15.57 3a.5.5 0 0 1 .4.31l2 5a.5.5 0 1 1-.93.38L15.5 4.85l-4.59 11.52a1 1 0 0 1-1.85.03L4.04 4.7a.5.5 0 0 1 .92-.4L9.98 16l4.57-11.47-3.83 1.92a.5.5 0 1 1-.44-.9l4.98-2.49a.5.5 0 0 1 .3-.06"
]);
const $4125b41377e9d21d$export$1f160008dc5653bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftDownFilled', "1em", [
    "M3.22 10.72c-.3.3-.3.77 0 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L8.5 13.44V7c0-.83.67-1.5 1.5-1.5h6.25a.75.75 0 0 0 0-1.5H10a3 3 0 0 0-3 3v6.44l-2.72-2.72a.75.75 0 0 0-1.06 0"
]);
const $4125b41377e9d21d$export$9a78e8fe7088db5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftDownRegular', "1em", [
    "M3.15 11.15a.5.5 0 0 0 0 .7l4 4c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7L8 14.29V8c0-1.1.9-2 2-2h6.5a.5.5 0 0 0 0-1H10a3 3 0 0 0-3 3v6.3l-3.15-3.15a.5.5 0 0 0-.7 0"
]);
const $4125b41377e9d21d$export$d1b36ba864106051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftRightFilled', "1em", [
    "M15.53 15.45a.75.75 0 0 0 .4-1.03l-2.5-5a.75.75 0 1 0-1.35.67l1.62 3.24L3.88 9l10.67-4.57a.75.75 0 1 0-.6-1.38L2.77 7.86a1.25 1.25 0 0 0 0 2.29l10.46 4.6-3.25 1.3a.75.75 0 1 0 .56 1.4z"
]);
const $4125b41377e9d21d$export$ea7826c9c314f9b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftRightRegular', "1em", [
    "M16 14.57a.5.5 0 0 1-.31.4l-5 2a.5.5 0 0 1-.38-.93l3.84-1.54L2.63 9.91a1 1 0 0 1-.03-1.85l11.7-5.02a.5.5 0 0 1 .4.92L3 8.98l11.47 4.57-1.92-3.83a.5.5 0 0 1 .9-.44l2.49 4.98q.07.15.06.3"
]);
const $4125b41377e9d21d$export$cb815fa73b49ea78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftUpFilled', "1em", [
    "M3.22 9.28a.75.75 0 0 1 0-1.06l4-4c.3-.3.77-.3 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L8.5 6.56V13c0 .83.67 1.5 1.5 1.5h6.25a.75.75 0 0 1 0 1.5H10a3 3 0 0 1-3-3V6.56L4.28 9.28c-.3.3-.77.3-1.06 0"
]);
const $4125b41377e9d21d$export$5afcd746c17de329 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftUpRegular', "1em", [
    "M3.15 8.85a.5.5 0 0 1 0-.7l4-4c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L8 5.71V12c0 1.1.9 2 2 2h6.5a.5.5 0 0 1 0 1H10a3 3 0 0 1-3-3V5.7L3.85 8.86a.5.5 0 0 1-.7 0"
]);
const $4125b41377e9d21d$export$e6f0f0a91732380b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightFilled', "1em", [
    "M10.72 3.22c.3-.3.77-.3 1.06 0l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H7c-.83 0-1.5.67-1.5 1.5v6.25a.75.75 0 0 1-1.5 0V10a3 3 0 0 1 3-3h6.44l-2.72-2.72a.75.75 0 0 1 0-1.06"
]);
const $4125b41377e9d21d$export$99cc176e66c8df96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightRegular', "1em", [
    "M11.15 3.15c.2-.2.5-.2.7 0l4 4c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7L14.29 8H8a2 2 0 0 0-2 2v6.5a.5.5 0 0 1-1 0V10a3 3 0 0 1 3-3h6.3l-3.15-3.15a.5.5 0 0 1 0-.7"
]);
const $4125b41377e9d21d$export$99f409a3eb318d48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightDownFilled', "1em", [
    "M16.78 10.72c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V7c0-.83-.67-1.5-1.5-1.5H3.75a.75.75 0 0 1 0-1.5H10a3 3 0 0 1 3 3v6.44l2.72-2.72c.3-.3.77-.3 1.06 0"
]);
const $4125b41377e9d21d$export$f32394120bfd4b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightDownRegular', "1em", [
    "M16.85 11.15c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 0 1 .7-.7L12 14.29V8a2 2 0 0 0-2-2H3.5a.5.5 0 0 1 0-1H10a3 3 0 0 1 3 3v6.3l3.15-3.15c.2-.2.5-.2.7 0"
]);
const $4125b41377e9d21d$export$67f8262fe58fd894 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightLeftFilled', "1em", [
    "M4.47 15.45a.75.75 0 0 1-.4-1.03l2.5-5a.75.75 0 1 1 1.35.67L6.3 13.33 16.12 9 5.45 4.44a.75.75 0 0 1 .6-1.38l11.19 4.8c1 .43 1 1.85 0 2.29l-10.46 4.6 3.25 1.3a.75.75 0 1 1-.56 1.4z"
]);
const $4125b41377e9d21d$export$7f2f80c579cc1dbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightLeftRegular', "1em", [
    "M4 14.57a.5.5 0 0 0 .31.4l5 2a.5.5 0 1 0 .38-.93L5.85 14.5l11.52-4.59a1 1 0 0 0 .03-1.85L5.7 3.04a.5.5 0 0 0-.4.92L17 8.98 5.53 13.55l1.92-3.83a.5.5 0 1 0-.9-.44l-2.49 4.98a.5.5 0 0 0-.06.3"
]);
const $4125b41377e9d21d$export$db5f955977600eed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightUpFilled', "1em", [
    "M16.78 9.28c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72V13c0 .83-.67 1.5-1.5 1.5H3.75a.75.75 0 0 0 0 1.5H10a3 3 0 0 0 3-3V6.56l2.72 2.72c.3.3.77.3 1.06 0"
]);
const $4125b41377e9d21d$export$7aa68723eef838f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightUpRegular', "1em", [
    "M16.85 8.85a.5.5 0 0 0 0-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L12 5.71V12a2 2 0 0 1-2 2H3.5a.5.5 0 0 0 0 1H10a3 3 0 0 0 3-3V5.7l3.15 3.15c.2.2.5.2.7 0"
]);
const $4125b41377e9d21d$export$70d2b4ed66ec3788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpDownFilled', "1em", [
    "M16.45 16.53a.75.75 0 0 1-1.03.4l-5-2.5a.75.75 0 1 1 .67-1.35l3.24 1.62L10 4.88 5.44 15.55a.75.75 0 1 1-1.38-.6l4.8-11.19c.43-1 1.85-1 2.29 0l4.6 10.46 1.3-3.25a.75.75 0 0 1 1.4.56z"
]);
const $4125b41377e9d21d$export$2bc99cbef6c9bc1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpDownRegular', "1em", [
    "M15.57 17a.5.5 0 0 0 .4-.31l2-5a.5.5 0 0 0-.93-.38l-1.54 3.84-4.59-11.52a1 1 0 0 0-1.85-.03L4.04 15.3a.5.5 0 0 0 .92.4L9.98 4l4.57 11.47-3.83-1.92a.5.5 0 0 0-.44.9l4.98 2.49q.15.07.3.06"
]);
const $4125b41377e9d21d$export$c54cf7d5ad876cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpLeftFilled', "1em", [
    "M9.28 3.22a.75.75 0 0 0-1.06 0l-4 4c-.3.3-.3.77 0 1.06l4 4a.75.75 0 0 0 1.06-1.06L6.56 8.5H13c.83 0 1.5.67 1.5 1.5v6.25a.75.75 0 0 0 1.5 0V10a3 3 0 0 0-3-3H6.56l2.72-2.72c.3-.3.3-.77 0-1.06"
]);
const $4125b41377e9d21d$export$922d95744c2b695a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpLeftRegular', "1em", [
    "M8.85 3.15a.5.5 0 0 0-.7 0l-4 4a.5.5 0 0 0 0 .7l4 4a.5.5 0 0 0 .7-.7L5.71 8H12a2 2 0 0 1 2 2v6.5a.5.5 0 0 0 1 0V10a3 3 0 0 0-3-3H5.7l3.15-3.15a.5.5 0 0 0 0-.7"
]);
const $4125b41377e9d21d$export$d844f3e1916fe2e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUndoFilled', "1em", [
    "M6.86 6.5h2.39a.75.75 0 0 1 0 1.5h-4.4A.85.85 0 0 1 4 7.15v-4.4a.75.75 0 0 1 1.5 0V5.7l3.06-2.66a5.25 5.25 0 0 1 6.89 7.92l-8.17 7.1a.75.75 0 1 1-.99-1.13l8.17-7.1a3.75 3.75 0 1 0-4.92-5.66z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4e0ffa8b18193122 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUndoRegular', "1em", [
    "M5 2.5a.5.5 0 0 0-1 0v4.9c0 .33.27.6.6.6h4.9a.5.5 0 0 0 0-1H5.9l3.48-3.02a4 4 0 0 1 5.25 6.04l-8.17 7.1a.5.5 0 0 0 .65.76l8.17-7.1a5 5 0 0 0-6.56-7.55L5 6.46z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$37ed199ad724f284 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpFilled', "1em", [
    "M3.2 8.73a.75.75 0 1 0 1.1 1.04l4.95-5.24v12.72a.75.75 0 0 0 1.5 0V4.52l4.95 5.25a.75.75 0 1 0 1.1-1.04l-6.08-6.41a1 1 0 0 0-1.45 0z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$caecfbc1460768bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRegular', "1em", [
    "M3.13 9.16a.5.5 0 1 0 .74.68L9.5 3.67V17.5a.5.5 0 1 0 1 0V3.67l5.63 6.17a.5.5 0 0 0 .74-.68l-6.32-6.92a.75.75 0 0 0-1.1 0z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ebf0cb0f343a9359 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpExclamationFilled', "1em", [
    "M3 5a3 3 0 0 1 6 0c0 2.25-.79 5.21-1.22 6.69C7.54 12.49 6.8 13 6 13s-1.54-.52-1.78-1.31C3.8 10.2 3 7.23 3 5m1 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0M15 3.7v13.8a.5.5 0 0 1-1 0V3.7l-2.15 2.15a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7z"
]);
const $4125b41377e9d21d$export$84097cf494f338ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpExclamationRegular', "1em", [
    "M4 5a2 2 0 1 1 4 0c0 2.09-.75 4.93-1.18 6.4-.1.36-.43.6-.82.6a.84.84 0 0 1-.82-.6C4.75 9.91 4 7.07 4 5m2-3a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69C4.46 12.48 5.2 13 6 13s1.54-.52 1.78-1.31C8.2 10.2 9 7.25 9 5a3 3 0 0 0-3-3M5 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9-10.3v13.8a.5.5 0 0 1-1 0V3.7l-2.15 2.15a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7z"
]);
const $4125b41377e9d21d$export$3af68c4b0f2b78ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpLeftFilled', "1em", [
    "M12 3.75a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 1.5 0V5.56l11.22 11.22a.75.75 0 0 0 1.06-1.06L5.56 4.5h5.69c.41 0 .75-.34.75-.75"
]);
const $4125b41377e9d21d$export$14503af7aee997b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpLeftRegular', "1em", [
    "M11.5 4a.5.5 0 0 0 0-1h-8a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0V4.7l12.15 12.15a.5.5 0 0 0 .7-.7L4.71 4z"
]);
const $4125b41377e9d21d$export$66b43e4a711408a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightFilled', "1em", [
    "M8 3.75c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v7.5a.75.75 0 1 1-1.5 0V5.56L4.28 16.78a.75.75 0 0 1-1.06-1.06L14.44 4.5h-5.7A.75.75 0 0 1 8 3.75"
]);
const $4125b41377e9d21d$export$99f8c1a2b2680ec1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightRegular', "1em", [
    "M8.5 4a.5.5 0 1 1 0-1h8c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0V4.7L3.85 16.86a.5.5 0 0 1-.7-.7L15.29 4z"
]);
const $4125b41377e9d21d$export$71f7930d322505b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightDashesFilled', "1em", [
    "M8.75 3a.75.75 0 0 0 0 1.5h5.69l-1.47 1.47a.75.75 0 0 0 1.06 1.06l1.47-1.47v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75zm3.03 6.28a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 1 0 1.06 1.06zm-5 5a.75.75 0 1 0-1.06-1.06l-2.75 2.75a.75.75 0 1 0 1.06 1.06z"
]);
const $4125b41377e9d21d$export$df89ab6ed94bf284 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightDashesRegular', "1em", [
    "M17 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7L16 4.71v6.79a.5.5 0 1 0 1 0zM6.85 13.86a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0 .7.7zm5-5.7c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0"
]);
const $4125b41377e9d21d$export$f8419f606f735b9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUploadFilled', "1em", [
    "M4.5 2a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 2zm6 15.35a.75.75 0 0 1-1.5-.1V7.05l-2.97 2.98-.08.07a.75.75 0 0 1-.98-1.14l4.29-4.28a1 1 0 0 1 .26-.15l.08-.02.15-.02h.06l.07.01.12.03.09.04.04.02.09.06.07.06 4.24 4.26.07.08c.22.3.2.71-.07.98l-.08.07c-.3.22-.72.2-.98-.07L10.5 7.05v10.3"
]);
const $4125b41377e9d21d$export$aa8eb2c15bf3dd94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUploadRegular', "1em", [
    "M15 3a.5.5 0 0 0 .09-.99H4a.5.5 0 0 0-.09.98L4 3zM9.5 18a.5.5 0 0 0 .5-.41V5.7l3.64 3.65c.17.18.44.2.64.06l.07-.06a.5.5 0 0 0 .06-.63l-.06-.07-4.5-4.5A.5.5 0 0 0 9.6 4h-.1a.5.5 0 0 0-.4.19L4.64 8.65a.5.5 0 0 0 .64.76l.07-.06L9 5.71V17.5c0 .28.22.5.5.5"
]);
const $4125b41377e9d21d$export$432fe4e3a4616f67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapFilled', "1em", [
    "M13.75 3.5a3.25 3.25 0 0 1 0 6.5h-7.5a1.75 1.75 0 1 0 0 3.5h9.19l-.22-.22a.75.75 0 1 1 1.06-1.06l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.22-.22H6.25a3.25 3.25 0 0 1 0-6.5h7.5a1.75 1.75 0 1 0 0-3.5h-10a.75.75 0 0 1 0-1.5z"
]);
const $4125b41377e9d21d$export$b9824df71e22c041 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapRegular', "1em", [
    "M14 4a3 3 0 1 1 0 6H6a2 2 0 1 0 0 4h10.3l-.65-.65a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H6a3 3 0 1 1 0-6h8a2 2 0 1 0 0-4H3.5a.5.5 0 0 1 0-1z"
]);
const $4125b41377e9d21d$export$22e3d74121737ca0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l.98.98A.75.75 0 0 0 3.75 5h.54l3.5 3.5H6.25a3.25 3.25 0 1 0 0 6.5h8.04l.71.7a.75.75 0 0 0 .8.8l1.35 1.35a.5.5 0 0 0 .7-.7zM12.8 13.5H6.25a1.75 1.75 0 1 1 0-3.5h3.04z",
    "M13.75 8.5h-3.13l1.5 1.5h1.63a3.25 3.25 0 0 0 0-6.5H5.62L7.12 5h6.63a1.75 1.75 0 1 1 0 3.5",
    "m17.34 15.22-2.33-2.33a.75.75 0 0 1 1.27-.67l1.5 1.5c.3.3.3.77 0 1.06z"
]);
const $4125b41377e9d21d$export$1589ee6766fb7b17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.17 1.18A.5.5 0 0 0 3.5 5h.8l4 4H6a3 3 0 1 0 0 6h8.3l1.35 1.35 1.5 1.5a.5.5 0 0 0 .7-.7zM13.3 14H6a2 2 0 1 1 0-4h3.3z",
    "M14 9h-2.88l1 1H14a3 3 0 1 0 0-6H6.12l1 1H14a2 2 0 1 1 0 4",
    "M17.41 15.3 16.12 14h.17l-.64-.65a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7z"
]);
const $4125b41377e9d21d$export$1d07c1c924616f99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapUpToDownFilled', "1em", [
    "M4 13.75a3.25 3.25 0 0 0 6.5 0v-7.5a1.75 1.75 0 1 1 3.5 0v9.19l-.22-.22a.75.75 0 1 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.22.22V6.25a3.25 3.25 0 0 0-6.5 0v7.5a1.75 1.75 0 1 1-3.5 0v-10a.75.75 0 0 0-1.5 0z"
]);
const $4125b41377e9d21d$export$bb2fdda79a09c6f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapUpToDownRegular', "1em", [
    "M4 14a3 3 0 1 0 6 0V6a2 2 0 1 1 4 0v10.3l-.65-.65a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7l-.65.64V6a3 3 0 1 0-6 0v8a2 2 0 1 1-4 0V3.5a.5.5 0 0 0-1 0z"
]);
const $4125b41377e9d21d$export$381c0fe320c79ed5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowsBidirectionalFilled', "1em", [
    "M6.68 5.03q.31.14.32.47V8h6V5.5a.5.5 0 0 1 .87-.33l4 4.5a.5.5 0 0 1 0 .66l-4 4.5a.5.5 0 0 1-.87-.33V12H7v2.5a.5.5 0 0 1-.87.33l-4-4.5a.5.5 0 0 1 0-.66l4-4.5a.5.5 0 0 1 .55-.14"
]);
const $4125b41377e9d21d$export$81a80127722e8549 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowsBidirectionalRegular', "1em", [
    "M6.68 5.03q.31.14.32.47V8h6V5.5a.5.5 0 0 1 .87-.33l4 4.5a.5.5 0 0 1 0 .66l-4 4.5a.5.5 0 0 1-.87-.33V12H7v2.5a.5.5 0 0 1-.87.33l-4-4.5a.5.5 0 0 1 0-.66l4-4.5a.5.5 0 0 1 .55-.14M3.17 10 6 13.18V11.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1.68L16.83 10 14 6.82V8.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V6.82z"
]);
const $4125b41377e9d21d$export$206077b8155882e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesFilled', "1em", [
    "M3.5 5.75A2.75 2.75 0 0 1 6.23 3a.75.75 0 0 1 0 1.5C5.55 4.5 5 5.06 5 5.75L5 8.38c0 .6-.21 1.17-.58 1.62.37.45.58 1.02.58 1.62v2.63c0 .7.56 1.25 1.25 1.25a.75.75 0 1 1 0 1.5 2.75 2.75 0 0 1-2.75-2.75v-2.63c0-.4-.22-.76-.57-.94a.75.75 0 0 1 0-1.36c.35-.18.57-.54.57-.94zm13 0A2.75 2.75 0 0 0 13.77 3a.75.75 0 0 0 0 1.5c.69 0 1.25.56 1.25 1.25L15 8.38c0 .6.21 1.17.58 1.62a2.6 2.6 0 0 0-.58 1.62v2.63c0 .7-.56 1.25-1.25 1.25a.75.75 0 1 0 0 1.5 2.75 2.75 0 0 0 2.75-2.75v-2.63c0-.4.22-.76.57-.94a.75.75 0 0 0 0-1.36 1.1 1.1 0 0 1-.57-.94z"
]);
const $4125b41377e9d21d$export$f2afabd021b77344 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesRegular', "1em", [
    "M6.5 3A2.5 2.5 0 0 0 4 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 0 0 0 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 0 0 6.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 5 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C5 4.67 5.67 4 6.5 4a.5.5 0 0 0 0-1m7 0A2.5 2.5 0 0 1 16 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 0 1 0 .9 1.3 1.3 0 0 0-.72 1.17v2.88a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0 1 15 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1 0-1"
]);
const $4125b41377e9d21d$export$d7d0c8cc30314a7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesVariableFilled', "1em", [
    "M5.75 2.5A2.75 2.75 0 0 0 3 5.25v3.13c0 .4-.22.76-.57.94a.75.75 0 0 0 0 1.36c.35.18.57.54.57.94v3.13a2.75 2.75 0 0 0 2.75 2.75.75.75 0 0 0 0-1.5c-.69 0-1.25-.56-1.25-1.25v-3.13c0-.6-.21-1.17-.58-1.62.37-.45.58-1.02.58-1.62V5.25C4.5 4.56 5.06 4 5.75 4a.75.75 0 0 0 0-1.5m8.5 0A2.75 2.75 0 0 1 17 5.25v3.13c0 .4.22.76.57.94a.75.75 0 0 1 0 1.36c-.35.18-.57.54-.57.94v3.13a2.75 2.75 0 0 1-2.75 2.75.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25v-3.13c0-.6.21-1.17.58-1.62a2.6 2.6 0 0 1-.58-1.62V5.25c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1 0-1.5M8.11 6.06a.75.75 0 1 0-1.22.88L9.08 10l-2.19 3.06a.75.75 0 0 0 1.22.88L10 11.29l1.89 2.65a.75.75 0 0 0 1.22-.88L10.92 10l2.19-3.06a.75.75 0 0 0-1.22-.88L10 8.71z"
]);
const $4125b41377e9d21d$export$92c034cfb31ac03d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesVariableRegular', "1em", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 0 0 0 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 0 0 5.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 4 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C4 4.67 4.67 4 5.5 4a.5.5 0 0 0 0-1m9 0A2.5 2.5 0 0 1 17 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 0 1 0 .9 1.3 1.3 0 0 0-.72 1.17v2.88a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0 1 16 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1 0-1M7.9 6.2a.5.5 0 0 0-.8.6L9.38 10l-2.3 3.2a.5.5 0 0 0 .82.6L10 10.85l2.1 2.93a.5.5 0 0 0 .8-.58L10.62 10l2.3-3.2a.5.5 0 1 0-.82-.6L10 9.15z"
]);
const $4125b41377e9d21d$export$99f2db03da0dd8c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainFilled', "1em", [
    "M10.5 17.25a2.96 2.96 0 0 0 4.89-1.64l.04-.19a3.25 3.25 0 0 0 .77-6.08c.49-.46.8-1.11.8-1.84v-.2c0-1.28-.9-2.4-2.17-2.64l-.4-.08-.13-.63a2.42 2.42 0 0 0-3.8-1.49zm-1-14.79Q8.88 2.01 8.08 2c-1.16 0-2.15.82-2.38 1.95l-.12.63-.41.08A2.7 2.7 0 0 0 3 7.3v.2c0 .73.31 1.38.8 1.84a3.25 3.25 0 0 0 .78 6.08l.03.19a2.97 2.97 0 0 0 4.89 1.64z"
]);
const $4125b41377e9d21d$export$8751176868839344 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainRegular', "1em", [
    "M5.7 3.95a2.42 2.42 0 0 1 4.3-1 2.42 2.42 0 0 1 4.3 1l.12.63.41.08A2.7 2.7 0 0 1 17 7.3v.2a2.5 2.5 0 0 1-.8 1.84 3.25 3.25 0 0 1-.77 6.08l-.04.19A2.97 2.97 0 0 1 10 16.68a2.97 2.97 0 0 1-5.39-1.07l-.03-.19a3.25 3.25 0 0 1-.78-6.08A2.5 2.5 0 0 1 3 7.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.08zM14.5 10a.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-.2c0-.8-.57-1.5-1.37-1.66l-.73-.15a.5.5 0 0 1-.39-.4l-.2-.95a1.42 1.42 0 0 0-2.81.28v10.6a1.97 1.97 0 0 0 3.9.4l.11-.52a.5.5 0 0 1 .4-.39l.28-.06a2.25 2.25 0 0 0-.44-4.45zm-5 4V4.42a1.42 1.42 0 0 0-2.82-.28l-.19.96a.5.5 0 0 1-.4.39l-.72.15A1.7 1.7 0 0 0 4 7.3v.2C4 8.33 4.67 9 5.5 9a.5.5 0 0 1 0 1h-.25a2.25 2.25 0 0 0-.44 4.45l.29.06c.2.04.35.2.39.4l.1.5a1.97 1.97 0 0 0 3.91-.38z"
]);
const $4125b41377e9d21d$export$a42f471a502626e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainCircuitFilled', "1em", [
    "M8.08 2q.8.01 1.42.46V6h-.59a1.5 1.5 0 1 0 0 1h.59v10.23a3 3 0 0 1-4.97-1.82A3.24 3.24 0 0 1 2.9 10h2.6c.28 0 .5.22.5.5v.59a1.5 1.5 0 1 0 1 0v-.59C7 9.67 6.33 9 5.5 9h-2c-.3-.42-.5-.94-.5-1.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.09.13-.62A2.4 2.4 0 0 1 8.08 2m3.84 0c1.16 0 2.15.82 2.38 1.95l.12.62.41.09A2.7 2.7 0 0 1 17 7.3v.2c0 .73-.31 1.38-.8 1.84a3.25 3.25 0 0 1-.73 6.07 3 3 0 0 1-4.97 1.82V13h2c.83 0 1.5-.67 1.5-1.5v-.59a1.5 1.5 0 1 0-1 0v.59a.5.5 0 0 1-.5.5h-2V2.46q.61-.45 1.42-.46M6.5 12a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m7-3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-6-3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
]);
const $4125b41377e9d21d$export$47c72df5b6b6212f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainCircuitRegular', "1em", [
    "M5.7 3.95a2.42 2.42 0 0 1 4.3-1 2.42 2.42 0 0 1 4.3 1l.12.63.41.08A2.7 2.7 0 0 1 17 7.3v.2a2.5 2.5 0 0 1-.8 1.84 3.25 3.25 0 0 1-.77 6.08l-.04.19A2.97 2.97 0 0 1 10 16.68a2.97 2.97 0 0 1-5.39-1.07l-.03-.19a3.25 3.25 0 0 1-.78-6.08A2.5 2.5 0 0 1 3 7.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.08zM14 10.9v.59c0 .83-.67 1.5-1.5 1.5h-2v2.03a1.97 1.97 0 0 0 3.9.38l.11-.5a.5.5 0 0 1 .4-.4l.28-.06a2.25 2.25 0 0 0-.28-4.44 1.5 1.5 0 0 1-.91.9m-1 0a1.5 1.5 0 1 1 1.9-1.96A1.5 1.5 0 0 0 16 7.5v-.2c0-.8-.57-1.5-1.37-1.66l-.73-.15a.5.5 0 0 1-.39-.4l-.2-.95a1.42 1.42 0 0 0-2.81.28V12h2a.5.5 0 0 0 .5-.5zM9.5 6V4.42a1.42 1.42 0 0 0-2.82-.28l-.19.96a.5.5 0 0 1-.4.39l-.72.15A1.7 1.7 0 0 0 4 7.3v.2C4 8.33 4.67 9 5.5 9h1c.83 0 1.5.67 1.5 1.5v.59a1.5 1.5 0 1 1-1 0v-.59a.5.5 0 0 0-.5-.5H5.25a2.25 2.25 0 0 0-.44 4.45l.29.06c.2.04.35.2.39.4l.1.5a1.97 1.97 0 0 0 3.91-.38V7h-.59a1.5 1.5 0 1 1 0-1zM8 6.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M7.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m6-3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
]);
const $4125b41377e9d21d$export$1acbefacec652ed7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34a1.4 1.4 0 0 1-.47-.27v12.67a2.96 2.96 0 0 0 4.89-1.64l.04-.19a3.25 3.25 0 0 0 2.55-3.5q-.22.09-.48.08m-8-9.54Q8.88 2.01 8.08 2c-1.16 0-2.15.82-2.38 1.95l-.12.63-.41.08A2.7 2.7 0 0 0 3 7.3v.2c0 .73.31 1.38.8 1.84a3.25 3.25 0 0 0 .78 6.08l.03.19a2.97 2.97 0 0 0 4.89 1.64z"
]);
const $4125b41377e9d21d$export$a5558abde0ed9a4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainSparkleRegular', "1em", [
    "M8.08 2c.78 0 1.48.37 1.92.95v.55a1.4 1.4 0 0 0 .5 1.08v10.45a1.97 1.97 0 0 0 3.9.38l.11-.5a.5.5 0 0 1 .4-.4l.28-.06a2.25 2.25 0 0 0 1.78-2.56q.26.1.53.11.26 0 .48-.07l.02.32a3.25 3.25 0 0 1-2.58 3.17l-.03.19A2.97 2.97 0 0 1 10 16.68a2.97 2.97 0 0 1-5.39-1.07l-.03-.19a3.25 3.25 0 0 1-.78-6.08A2.5 2.5 0 0 1 3 7.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.08.13-.63A2.4 2.4 0 0 1 8.08 2m0 1c-.68 0-1.27.48-1.4 1.14l-.19.96a.5.5 0 0 1-.4.39l-.72.15A1.7 1.7 0 0 0 4 7.3v.2C4 8.33 4.67 9 5.5 9a.5.5 0 0 1 0 1h-.25a2.25 2.25 0 0 0-.44 4.45l.29.06q.32.08.39.4l.1.5a1.97 1.97 0 0 0 3.91-.38V4.43C9.5 3.62 8.86 3 8.08 3m9.4 3a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $4125b41377e9d21d$export$8c1bdc4c8e05ab44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchFilled', "1em", [
    "M10 5a3 3 0 0 1-2.15 2.88q.27.34.73.74A5.8 5.8 0 0 0 12 9.98a3 3 0 1 1 .17 1.01A6.8 6.8 0 0 1 7.5 9v3.05a3 3 0 1 1-1 0V7.96A3 3 0 1 1 10 5"
]);
const $4125b41377e9d21d$export$95189297426eda5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRegular', "1em", [
    "M10 5a3 3 0 0 1-2.15 2.88q.27.34.73.74A5.8 5.8 0 0 0 12 9.98a3 3 0 1 1 .17 1.01A6.8 6.8 0 0 1 7.5 9v3.05a3 3 0 1 1-1 0V7.96A3 3 0 1 1 10 5M7 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10 3a2 2 0 1 0-4 0 2 2 0 0 0 4 0M7 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $4125b41377e9d21d$export$6fb6667cbebc1c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchCompareFilled', "1em", [
    "M11.15 6.85a.5.5 0 0 0 .7-.7L10.71 5h1.79A2.5 2.5 0 0 1 15 7.5V12a3 3 0 1 0 1 .17V7.5A3.5 3.5 0 0 0 12.5 4h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7zM5 8a3 3 0 1 0-1-.17v4.67A3.5 3.5 0 0 0 7.5 16h1.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L9.29 15H7.5A2.5 2.5 0 0 1 5 12.5z"
]);
const $4125b41377e9d21d$export$c72c69cf045198f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchCompareRegular', "1em", [
    "M11.15 6.85a.5.5 0 0 0 .7-.7L10.71 5h1.79A2.5 2.5 0 0 1 15 7.5V12a3 3 0 1 0 1 .17V7.5A3.5 3.5 0 0 0 12.5 4h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7zM17 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8 5a3 3 0 0 1-3 3v4.5A2.5 2.5 0 0 0 7.5 15h1.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L9.29 16H7.5A3.5 3.5 0 0 1 4 12.5V7.83A3 3 0 1 1 8 5M7 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
]);
const $4125b41377e9d21d$export$10ff089e47b1dd2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkFilled', "1em", [
    "M9 5a3 3 0 0 1-2.5 2.96V10H12c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 1 1 1 0v.54A2.5 2.5 0 0 1 12 11H6.5v1.04a3 3 0 1 1-1 0V7.96A3 3 0 1 1 9 5"
]);
const $4125b41377e9d21d$export$e978afd128813fab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkRegular', "1em", [
    "M9 5a3 3 0 1 0-3.5 2.96v4.08a3 3 0 1 0 1 0V11H12a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 0 0 9 5M6 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4M16 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $4125b41377e9d21d$export$648b1058017116c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkHintFilled', "1em", [
    "M6 2a3 3 0 0 0-.5 5.96v3.79a.5.5 0 0 0 1 0V11H12a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 0 0 6 2M4.87 13.4a.5.5 0 1 0-.58-.8 3 3 0 0 0-1.12 1.54.5.5 0 1 0 .96.3 2 2 0 0 1 .74-1.03m2.9-.8a.5.5 0 1 0-.57.8 2 2 0 0 1 .75 1.04.5.5 0 1 0 .95-.3 3 3 0 0 0-1.12-1.55M4.3 16a.5.5 0 0 0-.88.5 3 3 0 0 0 1.38 1.27.5.5 0 1 0 .42-.91 2 2 0 0 1-.92-.85m4.37.5a.5.5 0 0 0-.87-.5 2 2 0 0 1-.98.88.5.5 0 1 0 .38.92 3 3 0 0 0 1.47-1.3"
]);
const $4125b41377e9d21d$export$f636bf98e4c89f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkHintRegular', "1em", [
    "M6 2a3 3 0 0 0-.5 5.96v3.79a.5.5 0 0 0 1 0V11H12a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 0 0 6 2m8 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4M6 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-1.13 6.4a.5.5 0 1 0-.58-.8 3 3 0 0 0-1.12 1.54.5.5 0 1 0 .96.3 2 2 0 0 1 .74-1.03m2.9-.8a.5.5 0 1 0-.57.8 2 2 0 0 1 .75 1.04.5.5 0 1 0 .95-.3 3 3 0 0 0-1.12-1.55M4.3 16a.5.5 0 0 0-.88.5 3 3 0 0 0 1.38 1.27.5.5 0 1 0 .42-.91 2 2 0 0 1-.92-.85m4.37.5a.5.5 0 0 0-.87-.5 2 2 0 0 1-.98.88.5.5 0 1 0 .38.92 3 3 0 0 0 1.47-1.3"
]);
const $4125b41377e9d21d$export$6153a087147cb9f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkLinkFilled', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V11H11a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H5.5zm7 5.04a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $4125b41377e9d21d$export$98f1255375648c61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkLinkRegular', "1em", [
    "M5 2a3 3 0 0 1 .5 5.96V10H11c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 1 1 1 0v.54A2.5 2.5 0 0 1 11 11H5.5v1.04a3 3 0 1 1-1 0V7.96A3 3 0 0 1 5 2M3 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0m0 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0m10-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-.5 6a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $4125b41377e9d21d$export$150f33b1180a3828 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestFilled', "1em", [
    "M8 5a3 3 0 0 1-2.5 2.96v4.08a3 3 0 1 1-1 0V7.96A3 3 0 1 1 8 5m3.85 1.85a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L10.71 4h1.79A3.5 3.5 0 0 1 16 7.5v4.67a3 3 0 1 1-1-.17V7.5A2.5 2.5 0 0 0 12.5 5h-1.8l1.15 1.15c.2.2.2.5 0 .7"
]);
const $4125b41377e9d21d$export$5198c4ba7c794498 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestRegular', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0zM5 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4m2 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.15-8.15a.5.5 0 0 0 .7-.7L10.71 5h1.79A2.5 2.5 0 0 1 15 7.5V12a3 3 0 1 0 1 .17V7.5A3.5 3.5 0 0 0 12.5 4h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7zM17 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $4125b41377e9d21d$export$215547156d898279 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestClosedFilled', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0zM18 15a3 3 0 1 1-3.5-2.96V8.5a.5.5 0 0 1 1 0v3.54A3 3 0 0 1 18 15M13.35 2.65a.5.5 0 0 0-.7.7L14.29 5l-1.64 1.65a.5.5 0 0 0 .7.7L15 5.71l1.65 1.64a.5.5 0 0 0 .7-.7L15.71 5l1.64-1.65a.5.5 0 0 0-.7-.7L15 4.29z"
]);
const $4125b41377e9d21d$export$3b0af0734f9e2692 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestClosedRegular', "1em", [
    "M3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2.5 2.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0zM5 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4m10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 0 1 2.5-2.96V8.5a.5.5 0 0 1 1 0v3.54A3 3 0 1 1 12 15m1.35-12.35a.5.5 0 0 0-.7.7L14.29 5l-1.64 1.65a.5.5 0 0 0 .7.7L15 5.71l1.65 1.64a.5.5 0 0 0 .7-.7L15.71 5l1.64-1.65a.5.5 0 0 0-.7-.7L15 4.29z"
]);
const $4125b41377e9d21d$export$838ddc19dfbb927d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestDraftFilled', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0zM18 15a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1.75-6.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $4125b41377e9d21d$export$b6f32296116a0b16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestDraftRegular', "1em", [
    "M3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2.5 2.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0zM5 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4m10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0m4.25-6.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $4125b41377e9d21d$export$e4f8c4b21d428d6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroadActivityFeedFilled', "1em", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zm0 9c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5zm9 0c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5z"
]);
const $4125b41377e9d21d$export$3e9ffb702d1b8388 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroadActivityFeedRegular', "1em", [
    "M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 8.5zM3.5 4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5zM2 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 15.5zm1.5-.5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm9-1c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5zm-.5 1.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
]);
const $4125b41377e9d21d$export$8f1c137e4dc8139e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomFilled', "1em", [
    "M17.91 2.18c.2.2.2.51 0 .7L13.3 7.5a6 6 0 0 0-.7-.7l4.6-4.62c.2-.2.51-.2.71 0m-5.66 5.66a4.5 4.5 0 0 0-6.36 0l-.42.42 6.36 6.36.42-.42a4.5 4.5 0 0 0 0-6.36m-10.5 2.75 2.9-1.74 6.5 6.5.1.08-1.75 2.92a.5.5 0 0 1-.78.1l-7.07-7.08a.5.5 0 0 1 .1-.78"
]);
const $4125b41377e9d21d$export$fff9200dd087a401 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomRegular', "1em", [
    "M17.91 2.18c.2.2.2.51 0 .7l-5.32 5.33a4.5 4.5 0 0 1-.34 6l-.66.66-2.09 3.48a.5.5 0 0 1-.78.1l-7.07-7.08a.5.5 0 0 1 .1-.78L5.22 8.5l.66-.66a4.5 4.5 0 0 1 5.99-.34l5.32-5.32c.2-.2.51-.2.71 0M6.24 8.9l4.95 4.95.36-.35A3.5 3.5 0 1 0 6.6 8.55zm-.78.63L2.8 11.12l6.16 6.17 1.6-2.66z"
]);
const $4125b41377e9d21d$export$c887823b860e27b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomSparkleFilled', "1em", [
    "m12.15 15.35.1.08-1.75 2.92a.5.5 0 0 1-.78.1l-5.1-5.1q.06-.1.1-.22l.02-.02.24-.76a1 1 0 0 1 .14-.23l.05-.04.12-.07.06-.03.76-.24.02-.01.1-.04a1.3 1.3 0 0 0 .72-1.53zM6.89 7.84a4.5 4.5 0 0 1 6.36 6.36l-.42.42-6.36-6.36zM3.49 8a.3.3 0 0 1 .28.2l.25.77q.12.35.38.61v.01l.14.12a2 2 0 0 0 .48.25l.76.25h.02a.3.3 0 0 1 .2.3l-.01.08-.05.09-.06.06-.08.05-.77.25q-.35.1-.61.38l-.13.13a2 2 0 0 0-.26.48l-.24.77a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .2-.29l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2M18.2 2.18a.5.5 0 0 1 .71.7L14.3 7.5a6 6 0 0 0-.7-.7zM5.48 0a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 6.72a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L2.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4L5.08.28a.4.4 0 0 1 .4-.28"
]);
const $4125b41377e9d21d$export$626bf1098fef1c63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomSparkleRegular', "1em", [
    "M18.2 2.18a.5.5 0 0 1 .7.7L13.6 8.22a4.5 4.5 0 0 1-.34 6l-.66.66-2.1 3.48a.5.5 0 0 1-.77.1l-5.1-5.1q.07-.1.1-.22l.02-.02.24-.76.02-.04 4.97 4.98 1.6-2.66-4.7-4.7-.06-.1-.05-.08-.06-.08a1.3 1.3 0 0 0-.57-.4l-.05-.01h-.02l-.7-.24.86-.52.67-.66a4.5 4.5 0 0 1 5.99-.34zm-5.66 6.37a3.5 3.5 0 0 0-4.94 0l-.36.35 4.95 4.95.35-.35a3.5 3.5 0 0 0 0-4.95M3.48 8a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.18.05.28.1.3.1h.02a.3.3 0 0 1 .2.28.3.3 0 0 1-.2.29l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .2-.29l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m2-8a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 6.72a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L2.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4L5.08.28a.4.4 0 0 1 .4-.28"
]);
const $4125b41377e9d21d$export$43bd1df66c5d0bff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseFilled', "1em", [
    "M5 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm8 0a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
]);
const $4125b41377e9d21d$export$a1d5428c4ec32479 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseRegular', "1em", [
    "M5 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM4 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm9-2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
]);
const $4125b41377e9d21d$export$a55e0973d10373e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseCircleFilled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16M8.5 6.5A.5.5 0 0 0 8 7v6a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5m3 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $4125b41377e9d21d$export$f0e8401452cb2dea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseCircleRegular', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14M8.5 6.5c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);
const $4125b41377e9d21d$export$781e38f9fcaaac2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseOffFilled', "1em", [
    "M3 3.7v12.8c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V8.7l4 4v3.8c0 .83.67 1.5 1.5 1.5h2c.49 0 .92-.23 1.2-.6l.45.45a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7zm9 6.18 5 5V3.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zM4.16 2.04 8 5.88V3.5C8 2.67 7.33 2 6.5 2h-2q-.18 0-.34.04"
]);
const $4125b41377e9d21d$export$594cc908fb8c0c17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseOffRegular', "1em", [
    "m3 3.7-.85-.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-.45-.45c-.28.37-.71.6-1.2.6h-2a1.5 1.5 0 0 1-1.5-1.5v-3.8l-4-4v7.8c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 16.5zm4 4-3-3v11.8c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5zm6 6v2.8c0 .28.22.5.5.5h2a.5.5 0 0 0 .47-.32zM7 3.5v1.38l1 1V3.5C8 2.67 7.33 2 6.5 2h-2q-.18 0-.34.04l.96.96H6.5c.28 0 .5.22.5.5m5 6.38 1 1V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v10.38l1 1V3.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5z"
]);
const $4125b41377e9d21d$export$30d0ba6e6fbcdb73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseSettingsFilled', "1em", [
    "M12 3.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v6.1a5.5 5.5 0 0 0-5 0zm-9 0C3 2.67 3.67 2 4.5 2h2C7.33 2 8 2.67 8 3.5v13c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 16.5zm9.07 7.94a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $4125b41377e9d21d$export$608e6ed7bb9d38da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseSettingsRegular', "1em", [
    "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-13C8 2.67 7.33 2 6.5 2zm0 1h2c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5m9-1c-.83 0-1.5.67-1.5 1.5v6.1q.48-.24 1-.4V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v5.7q.52.16 1 .4V3.5c0-.83-.67-1.5-1.5-1.5zm-1.43 9.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $4125b41377e9d21d$export$ebd110977837659a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseFilled', "1em", [
    "M7.01 3c.33 0 .62.23.71.55l2.82 10.07 2.24-7.1a.75.75 0 0 1 1.4-.07L15.5 9.5h1.76a.75.75 0 0 1 0 1.5H15a.8.8 0 0 1-.69-.45l-.7-1.65-2.4 7.58a.75.75 0 0 1-1.43-.03L6.97 6.41l-1.25 4.06A.75.75 0 0 1 5 11H2.75a.75.75 0 0 1 0-1.5h1.7l1.83-5.97c.1-.32.4-.53.73-.53"
]);
const $4125b41377e9d21d$export$8785757987de520d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseRegular', "1em", [
    "M7 3a.5.5 0 0 1 .48.37l3.05 11.3 2.5-8.31a.5.5 0 0 1 .94-.04L15.35 10h2.15a.5.5 0 0 1 0 1H15a.5.5 0 0 1-.47-.32l-.98-2.62-2.57 8.58a.5.5 0 0 1-.96-.01L6.99 5.37l-1.5 5.27A.5.5 0 0 1 5 11H2.5a.5.5 0 0 1 0-1h2.12l1.9-6.64A.5.5 0 0 1 7 3"
]);
const $4125b41377e9d21d$export$fbe76c926f76dc21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseSquareFilled', "1em", [
    "M14 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM8.5 6a.5.5 0 0 0-.47.32L6.65 10H5.5a.5.5 0 0 0 0 1H7c.2 0 .4-.13.47-.32l1.02-2.73 2.04 5.72a.5.5 0 0 0 .92.05L12.8 11h1.69a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.45.28l-.97 1.95-2.1-5.9A.5.5 0 0 0 8.5 6"
]);
const $4125b41377e9d21d$export$89df66a6b2a1b8e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseSquareRegular', "1em", [
    "M14 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM6 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm2.5 2c.21 0 .4.13.47.33l2.1 5.9.98-1.95a.5.5 0 0 1 .45-.28h2a.5.5 0 0 1 0 1h-1.7l-1.35 2.72a.5.5 0 0 1-.92-.05L8.49 7.95l-1.02 2.73A.5.5 0 0 1 7 11H5.5a.5.5 0 0 1 0-1h1.15l1.38-3.68A.5.5 0 0 1 8.5 6"
]);
const $4125b41377e9d21d$export$1f0a835c0a457798 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_20_color__a)",
            "d": "M11.5 9.5a.5.5 0 0 1 0 1l-8.12 1.77.6-2.27-.6-2.27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_20_color__b)",
            "d": "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_20_color__c)",
            "d": "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_send_20_color__b",
                "x1": "2",
                "x2": "15.7",
                "y1": "-4.5",
                "y2": "13.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_send_20_color__c",
                "x1": "10",
                "x2": "14.16",
                "y1": "6.31",
                "y2": "17.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#dcf8ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": ".7"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_send_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7 0 0 .9275 1.5 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$c980a8d62c420728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendFilled', "1em", [
    "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$276d540ffe218455 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendRegular', "1em", [
    "M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1 0 .9l-15 7.5a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52m2.7 8.39-1.61 6.06L16.38 10 3.27 3.44 4.88 9.5h6.62a.5.5 0 1 1 0 1z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$859f4a8320050b02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendBeakerFilled', "1em", [
    "M2.72 1.55a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l9.74-4.87A1.5 1.5 0 0 1 13.5 10h4.11l.11-.05a.5.5 0 0 0 0-.9zM17 14.4a2 2 0 0 0 .22.92l.35.68h-4.14l.35-.67a2 2 0 0 0 .22-.92V12h-.5a.5.5 0 1 1 0-1h4a.5.5 0 0 1 0 1H17zM12.9 17l-.8 1.54a1 1 0 0 0 .9 1.46H18a1 1 0 0 0 .89-1.46l-.8-1.54z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9ee88502946de1bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendBeakerRegular', "1em", [
    "M2.18 1.61a.5.5 0 0 1 .54-.06L17.5 10h-.01a1 1 0 0 1-.21-.05l-14.01-7L4.88 9h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06L12 11.69q.07.53.45.89l-9.74 4.87a.5.5 0 0 1-.7-.58L3.98 9.5 2.02 2.13a.5.5 0 0 1 .16-.52m.54-.06L17.51 10a.5.5 0 0 0 .21-.95zM17 14.4a2 2 0 0 0 .22.92l.35.68h-4.14l.35-.67a2 2 0 0 0 .22-.92V12h-.5a.5.5 0 1 1 0-1h4a.5.5 0 0 1 0 1H17zM12.9 17l-.8 1.54a1 1 0 0 0 .9 1.46H18a1 1 0 0 0 .89-1.46l-.8-1.54z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$a49ee3fedde2574d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendClockColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_clock_20_color__a)",
            "d": "M11.5 9.5a.5.5 0 0 1 0 1l-8.12 1.77.6-2.27-.6-2.27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_clock_20_color__b)",
            "d": "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_clock_20_color__c)",
            "d": "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_clock_20_color__d)",
            "fillOpacity": ".3",
            "d": "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_clock_20_color__e)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_send_clock_20_color__f)",
            "fillRule": "evenodd",
            "d": "M14.5 12c.28 0 .5.22.5.5V14h1a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_send_clock_20_color__b",
                "x1": "2",
                "x2": "15.7",
                "y1": "-4.5",
                "y2": "13.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_send_clock_20_color__c",
                "x1": "10",
                "x2": "14.16",
                "y1": "6.31",
                "y2": "17.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#dcf8ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": ".7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_send_clock_20_color__e",
                "x1": "11.5",
                "x2": "16",
                "y1": "9.5",
                "y2": "19.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#43e5ca"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_send_clock_20_color__f",
                "x1": "14.22",
                "x2": "13.51",
                "y1": "12.46",
                "y2": "14.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_send_clock_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(7 0 0 .9275 1.5 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_send_clock_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(1 8.5 -6.67857 .78571 14.5 16.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".76",
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1b44b1",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$8fa78ca90667b787 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendClockFilled', "1em", [
    "M2.72 1.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l6.33-3.16A5.5 5.5 0 0 1 17.2 9.7l.52-.26a.5.5 0 0 0 0-.9zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b8cc228cfd7ab64b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendClockRegular', "1em", [
    "M2.18 1.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 1 1-.44.9l-14.01-7L4.88 8.5h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06 6.1-3.06q-.23.62-.32 1.29l-6.33 3.16a.5.5 0 0 1-.7-.58L3.98 9 2.02 1.63a.5.5 0 0 1 .16-.52M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7ce070d58b0601ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendCopyFilled', "1em", [
    "M11.53 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v6.69a.75.75 0 1 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06zm2.9 14.28A2 2 0 0 1 12.5 18H7a4.5 4.5 0 0 1-4.5-4.5v-2.25a.75.75 0 1 1 1.5 0v2.25a3 3 0 0 0 3 3zm1.07-7.75a.75.75 0 1 1 1.5 0v4.75a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8.75a.75.75 0 1 1 1.5 0v4.75c0 .28.23.5.5.5h8a.5.5 0 0 0 .5-.5z"
]);
const $4125b41377e9d21d$export$469dbebfb94ef80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendCopyRegular', "1em", [
    "M11.35 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7l2.15-2.14v7.79a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 1 0 .7-.7zM14.73 17A2 2 0 0 1 13 18H7a4 4 0 0 1-4-4v-3.5a.5.5 0 0 1 1 0V14a3 3 0 0 0 3 3zM16 8.5a.5.5 0 0 1 1 0V14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8.5a.5.5 0 0 1 1 0V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z"
]);
const $4125b41377e9d21d$export$b4089b5b476c1ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendPersonFilled', "1em", [
    "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62q.09.3.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l9.78-4.9V13a3 3 0 0 1 4.85-2.36l.37-.2a.5.5 0 0 0 0-.89zM17.5 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 18.75 12 17.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9a9b7f6bc7a66da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendPersonRegular', "1em", [
    "M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1-.44.9l-14.01-7L4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06 9.47-4.74a3 3 0 0 0-.24 1.24l-9.78 4.89a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52M15.5 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e5779971e4e4e9dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_shield_20_color__a)",
            "d": "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_shield_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(55.26 5.44 -5.89)scale(37.726 33.0102)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#367af2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#5750e2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".86",
                    "stopColor": "#cc23d1"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$b0096c2d960f548c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42"
]);
const $4125b41377e9d21d$export$c6ece342c073f6b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M9.6 3.35A16 16 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a16 16 0 0 1-5.6-2.08L10 3.1z"
]);
const $4125b41377e9d21d$export$842227a15a7d777c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldAddFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.6Q15.86 9 14.5 9a5.5 5.5 0 0 0-4.28 8.95l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $4125b41377e9d21d$export$d6cea4ce7cfc490e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldAddRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.6q-.48-.25-1-.4V5.44a16 16 0 0 1-5.6-2.08L10 3.1l-.4.25A16 16 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25q.3.65.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $4125b41377e9d21d$export$85b6dee0f29e9bb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldArrowRightFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.6Q15.86 9 14.5 9a5.5 5.5 0 0 0-4.28 8.95l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $4125b41377e9d21d$export$eae1b3a6bae9f0e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldArrowRightRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.6q-.48-.25-1-.4V5.44a16 16 0 0 1-5.6-2.08L10 3.1l-.4.25A16 16 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25q.3.65.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35z"
]);
const $4125b41377e9d21d$export$c0ae2ec2f33a57e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldBadgeFilled', "1em", [
    "M4 5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6V9c3.23 0 3.75-.83 4.11-1.43.2-.32.36-.57.89-.57s.69.25.89.57.43.7 1.11 1V7a2 2 0 0 0-2-2zm10.53 3.83v.02l-.07.1q-.09.16-.39.4c-.4.3-1.16.65-2.57.65a.5.5 0 0 0-.5.5v2c0 1.03.13 2.14.7 3.12.56 1 1.55 1.82 3.14 2.35q.16.06.32 0a5.4 5.4 0 0 0 3.15-2.35c.56-.98.69-2.09.69-3.12v-2a.5.5 0 0 0-.5-.5c-1.41 0-2.18-.35-2.57-.65a2 2 0 0 1-.46-.52.5.5 0 0 0-.94 0m.94 0v.01m-.94 0v.01"
]);
const $4125b41377e9d21d$export$2a08501a62f05072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldBadgeRegular', "1em", [
    "M2 7c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v1.57a2 2 0 0 1-1-.82V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6v1H4a2 2 0 0 1-2-2zm12.53 1.83a.5.5 0 0 1 .95.02q0 .04.06.1.09.16.39.4c.4.3 1.16.65 2.57.65.28 0 .5.22.5.5v2c0 1.03-.13 2.14-.7 3.12a5.4 5.4 0 0 1-3.14 2.35.5.5 0 0 1-.32 0 5.4 5.4 0 0 1-3.15-2.35A6 6 0 0 1 11 12.5v-2a.5.5 0 0 1 .5-.5c1.41 0 2.18-.35 2.57-.65a2 2 0 0 0 .46-.52m.94 0v.01m-.94 0v.01m.15 1.32c-.54.4-1.38.76-2.68.84v1.51c0 .97.12 1.86.56 2.63A4.3 4.3 0 0 0 15 16.97a4.3 4.3 0 0 0 2.44-1.84c.44-.77.56-1.66.56-2.63v-1.51a5 5 0 0 1-2.68-.84L15 9.87q-.14.14-.32.28m-.15-1.32"
]);
const $4125b41377e9d21d$export$9eb55ec96311314 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldCheckmarkColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_shield_checkmark_20_color__a)",
            "d": "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_shield_checkmark_20_color__b)",
            "fillOpacity": ".5",
            "d": "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_shield_checkmark_20_color__c)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_shield_checkmark_20_color__d)",
            "fillRule": "evenodd",
            "d": "M16.85 12.65c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_shield_checkmark_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(55.26 5.44 -5.89)scale(37.726 33.0102)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".53",
                    "stopColor": "#367af2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#5750e2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".86",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_shield_checkmark_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 -.5 15)scale(6.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".5",
                    "stopColor": "#1e1868"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1e1868",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_shield_checkmark_20_color__c",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_shield_checkmark_20_color__d",
                "x1": "12.94",
                "x2": "13.95",
                "y1": "12.91",
                "y2": "17.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$b2a8f9f1ac920d9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldCheckmarkFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.6Q15.86 9 14.5 9a5.5 5.5 0 0 0-4.28 8.95l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-2.15-1.85c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0"
]);
const $4125b41377e9d21d$export$ffe2ec28dcf16e42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldCheckmarkRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.6q-.48-.25-1-.4V5.44a16 16 0 0 1-5.6-2.08L10 3.1l-.4.25A16 16 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25q.3.65.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $4125b41377e9d21d$export$5c59b8dfcadad84d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissFilled', "1em", [
    "M10.28 2.08q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42.5.5 0 0 1 .55 0M8.03 6.97a.75.75 0 0 0-1.06 1.06L8.94 10l-1.97 1.97a.75.75 0 1 0 1.06 1.06L10 11.06l1.97 1.97a.75.75 0 1 0 1.06-1.06L11.06 10l1.97-1.97a.75.75 0 0 0-1.06-1.06L10 8.94z"
]);
const $4125b41377e9d21d$export$9e5ecef4950c3c79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissRegular', "1em", [
    "M7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29zm2.43-5.07a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M4 5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46z"
]);
const $4125b41377e9d21d$export$1d3ebf72102df51f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissShieldFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0q.52-.2 1-.42a6 6 0 0 1-.66-1.16 7 7 0 0 1-.52-2.5v-2.83l-1.97 1.97a.75.75 0 0 1-1.06-1.06L8.94 10 6.97 8.03a.75.75 0 0 1 1.06-1.06L10 8.94l1.97-1.97a.75.75 0 1 1 1.06 1.06l-1.64 1.64h.01c.9 0 1.76-.37 2.6-1.24a1.4 1.4 0 0 1 2 0 5 5 0 0 0 1 .8V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M17 10.35a5 5 0 0 1-1-.59q-.36-.27-.72-.64a.4.4 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77q.05 1.2.44 2.15A5 5 0 0 0 13 18q.78.6 1.87.98.13.05.26 0 3.86-1.35 3.87-5.4V11a.4.4 0 0 0-.4-.33 4 4 0 0 1-1.6-.32"
]);
const $4125b41377e9d21d$export$aa1b277a01ef4148 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissShieldRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0q.52-.2 1-.42-.3-.4-.52-.86-.32.14-.66.27c-4.03-1.6-6-4.07-6-7.46V5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43v3a5 5 0 0 0 1 .8V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42m-.24 8.67c.11-.47.46-.87.94-1.02l1.87-1.88a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71zm6.96-.4a5 5 0 0 1-1-.59q-.36-.27-.72-.64a.4.4 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77q.05 1.2.44 2.15A5 5 0 0 0 13 18q.78.6 1.87.98.13.05.26 0 3.86-1.35 3.87-5.4V11a.4.4 0 0 0-.4-.33 4 4 0 0 1-1.6-.32"
]);
const $4125b41377e9d21d$export$f8f100ee3ded5cde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldErrorFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M10 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5A.5.5 0 0 0 10 6m0 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $4125b41377e9d21d$export$6e24440f7ba2b64a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldErrorRegular', "1em", [
    "M10 6c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5m0 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M9.6 3.35A16 16 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a16 16 0 0 1-5.6-2.08L10 3.1z"
]);
const $4125b41377e9d21d$export$27f7fcb7148cf4d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldGlobeFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42m2.68 8.42a3 3 0 0 1-1.43 2.08c.24-.57.4-1.3.45-2.08zm0-1a3 3 0 0 0-1.43-2.08c.24.57.4 1.3.45 2.08zm-1.98 0a5 5 0 0 0-.46-1.88 2 2 0 0 0-.39-.54L10.01 7h-.03l-.11.08q-.17.13-.39.54-.36.7-.46 1.88zm-1.96 1q.1 1.17.46 1.88.22.41.39.54l.12.08h.03q.03-.01.11-.08.17-.13.39-.54.36-.7.46-1.88zm-1 0q.07 1.2.45 2.08a3 3 0 0 1-1.43-2.08zm0-1q.07-1.2.45-2.08A3 3 0 0 0 7.04 9.5zM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
]);
const $4125b41377e9d21d$export$71736ab7f929d603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldGlobeRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M4 5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46zm8.96 5.07h-.98q-.07 1.2-.45 2.08a3 3 0 0 0 1.43-2.08m0-1a3 3 0 0 0-1.43-2.08c.24.57.4 1.3.45 2.08zm-1.98 0a5 5 0 0 0-.46-1.88 2 2 0 0 0-.39-.54L10.01 7h-.03l-.11.08q-.17.13-.39.54-.36.7-.46 1.88zm-1.96 1q.1 1.17.46 1.88.22.41.39.54l.12.08h.03q.03-.01.11-.08.17-.13.39-.54.36-.7.46-1.88zm-1 0h-.98a3 3 0 0 0 1.43 2.08c-.24-.57-.4-1.3-.45-2.08m0-1q.07-1.2.45-2.08A3 3 0 0 0 7.04 9.5zM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
]);
const $4125b41377e9d21d$export$a31a366fb4bbd645 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldKeyholeFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 0 1-1 0v-2.09a1.5 1.5 0 1 1 2-1.41"
]);
const $4125b41377e9d21d$export$5c7dbf7082febbee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldKeyholeRegular', "1em", [
    "M11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 0 1-1 0v-2.09a1.5 1.5 0 1 1 2-1.41m-1.22-6.92a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M4 5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46z"
]);
const $4125b41377e9d21d$export$4954ecd7c7d05f31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldLockFilled', "1em", [
    "M12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm1-1v1h2v-1a1 1 0 1 0-2 0m1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.34A3 3 0 0 0 11.5 11v.06A2 2 0 0 0 10 13v4a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42"
]);
const $4125b41377e9d21d$export$1437613268dc88c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldLockRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.34q-.4-.57-1-.94V5.43a16 16 0 0 1-5.6-2.08L10 3.1l-.4.25A16 16 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46V17a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm1-1v1h2v-1a1 1 0 1 0-2 0m1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $4125b41377e9d21d$export$b97c74b7513c3f0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M10 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 5c-2.5 0-3.5-1.25-3.5-2.5 0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5 0 1.24-1 2.5-3.5 2.5"
]);
const $4125b41377e9d21d$export$1de9764c74ec8e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonRegular', "1em", [
    "M10 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5c2.5 0 3.5-1.26 3.5-2.5 0-.83-.67-1.5-1.5-1.5H8c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5m.28-12.42a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M4 5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46z"
]);
const $4125b41377e9d21d$export$a2a310278314a55e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonAddFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0l.04-.02A5.5 5.5 0 0 1 9 14.42c-1.77-.29-2.5-1.35-2.5-2.42 0-.83.67-1.5 1.5-1.5h2.73A5.5 5.5 0 0 1 17 9.6V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M10 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4m9 5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $4125b41377e9d21d$export$5a96e9356ecd0786 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonAddRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0l.04-.02a6 6 0 0 1-.74-1.2C5.8 15.15 4 12.75 4 9.5V5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V9.2q.52.15 1 .39V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M9 14.42a5.5 5.5 0 0 1 1.73-3.92H8c-.83 0-1.5.67-1.5 1.5 0 1.07.73 2.13 2.5 2.42m3-6.92a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $4125b41377e9d21d$export$69c305e06fa46b44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldProhibitedFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0l.07-.03A5.5 5.5 0 1 1 17 9.26V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42m.42 13.52 4.9-4.9a3.5 3.5 0 0 0-4.9 4.9m.7.7q.9.68 2.1.7a3.5 3.5 0 0 0 2.8-5.6zm2.1 1.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
]);
const $4125b41377e9d21d$export$173c4af9b0825e35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldProhibitedRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0l.07-.03q-.83-.6-1.38-1.48Q3.98 14.08 4 9.5V5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V8.6q.54.27 1 .66V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42m.42 13.52 4.9-4.9a3.5 3.5 0 0 0-4.9 4.9m.7.7q.9.68 2.1.7a3.5 3.5 0 0 0 2.8-5.6zm2.1 1.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
]);
const $4125b41377e9d21d$export$27dc604169fffbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldQuestionFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42m1.03 11.67a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-2-5.5a1.25 1.25 0 1 1 2.5 0c0 .46-.27.76-.73 1.22l-.03.03c-.42.42-.99.99-.99 1.9v.1a.5.5 0 0 0 1 0v-.1c0-.47.27-.77.73-1.22l.03-.04c.42-.41.99-.98.99-1.89a2.25 2.25 0 0 0-4.5 0 .5.5 0 0 0 1 0"
]);
const $4125b41377e9d21d$export$1cddcaeb683784d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldQuestionRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.94 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M9.6 3.35A16 16 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a16 16 0 0 1-5.6-2.08L10 3.1zm1.15 10.4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-2-5.5a1.25 1.25 0 1 1 2.5 0c0 .46-.27.76-.73 1.22l-.03.03c-.42.42-.99.99-.99 1.9v.1a.5.5 0 0 0 1 0v-.1c0-.47.27-.77.73-1.22l.03-.04c.42-.41.99-.98.99-1.89a2.25 2.25 0 0 0-4.5 0 .5.5 0 0 0 1 0"
]);
const $4125b41377e9d21d$export$c7f437acb259f663 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldSettingsFilled', "1em", [
    "M13.07 10.75a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01l.46-.12a2 2 0 0 0 1.43-2.48l-.16-.56q.38-.3.82-.5zM9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.95 6.29 2.42A.5.5 0 0 1 17 5v4.6q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-4.28 8.95l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M14.5 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $4125b41377e9d21d$export$a8564a765bb49128 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldSettingsRegular', "1em", [
    "M13.07 10.75a2 2 0 0 0 2.9 0l.33-.35q.45.21.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01l.46-.12a2 2 0 0 0 1.43-2.48l-.16-.56q.38-.3.82-.5zM9.72 2.08a.5.5 0 0 1 .56 0q2.9 1.95 6.29 2.42A.5.5 0 0 1 17 5v4.6q-.48-.24-1-.4V5.44a16 16 0 0 1-5.6-2.08L10 3.1l-.4.25A16 16 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25q.3.64.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15 15 0 0 0 6.3-2.42M14.5 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $4125b41377e9d21d$export$dfdb19acd2017f3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldTaskFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42m3.57 5.77-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 3.65-3.64a.5.5 0 0 1 .7.7"
]);
const $4125b41377e9d21d$export$8d1a2bd5ddecd726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldTaskRegular', "1em", [
    "M13.85 7.85a.5.5 0 0 0-.7-.7L9.5 10.79 7.85 9.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0zm-3.57-5.77a.5.5 0 0 0-.56 0 15 15 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5q.02 5.86 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15 15 0 0 1-6.3-2.42M4 5.43a16 16 0 0 0 5.6-2.08l.4-.25.4.25A16 16 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46z"
]);
const $4125b41377e9d21d$export$b19bb850a92fb46b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_shifts_20_color__a)",
            "d": "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_shifts_20_color__b)",
            "fillRule": "evenodd",
            "d": "M9.5 6c.28 0 .5.22.5.5V10h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-4c0-.28.22-.5.5-.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_shifts_20_color__a",
                "x1": "5.33",
                "x2": "12.33",
                "y1": "2.22",
                "y2": "17.78",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#1ec8b0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_shifts_20_color__b",
                "x1": "8.94",
                "x2": "7.46",
                "y1": "6.38",
                "y2": "11.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dedeff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $4125b41377e9d21d$export$2632ce7e86e6fd81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm7 .5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10z"
]);
const $4125b41377e9d21d$export$e62c55183e8c84e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsRegular', "1em", [
    "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);
const $4125b41377e9d21d$export$a747c6393d5ee15a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shifts30MinutesFilled', "1em", [
    "M10 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M8 8a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V10a2 2 0 0 0-2-2zm-2.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m8.05-3.58q-.29.47-.3 1.33c0 .56.12 1.03.3 1.33q.25.42.7.42t.7-.42q.29-.47.3-1.33a2.6 2.6 0 0 0-.3-1.33q-.25-.42-.7-.42t-.7.42m-.85-.52c.33-.53.85-.9 1.55-.9s1.22.37 1.55.9c.32.5.45 1.17.45 1.85s-.13 1.34-.45 1.85c-.33.53-.85.9-1.55.9s-1.22-.37-1.55-.9a3.6 3.6 0 0 1-.45-1.85c0-.68.13-1.34.45-1.85m-4.14.5c.46-.36.83-.43 1.08-.4q.38.1.54.37.14.27 0 .48c-.08.14-.32.35-.9.4a.5.5 0 0 0 0 1c.6.05.82.25.9.37q.14.2 0 .5-.16.29-.55.37c-.25.04-.61-.02-1.07-.38a.5.5 0 1 0-.62.78q.95.73 1.85.6c.57-.1 1.02-.45 1.26-.9a1.5 1.5 0 0 0-.33-1.85q.2-.15.31-.36c.3-.48.27-1.05.02-1.5-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 0 0-1.84.6.5.5 0 0 0 .62.78"
]);
const $4125b41377e9d21d$export$3ec26ccae9e2023b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shifts30MinutesRegular', "1em", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-3 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V10a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0zm-1.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m8.05-3.58q-.29.47-.3 1.33c0 .56.12 1.03.3 1.33q.25.42.7.42t.7-.42q.29-.47.3-1.33a2.6 2.6 0 0 0-.3-1.33q-.25-.42-.7-.42t-.7.42m-.85-.52c.33-.53.85-.9 1.55-.9s1.22.37 1.55.9c.32.5.45 1.17.45 1.85s-.13 1.34-.45 1.85c-.33.53-.85.9-1.55.9s-1.22-.37-1.55-.9a3.6 3.6 0 0 1-.45-1.85c0-.68.13-1.34.45-1.85m-4.14.5c.46-.36.83-.43 1.08-.4q.38.1.54.37.14.27 0 .48c-.08.14-.32.35-.9.4a.5.5 0 0 0 0 1c.6.05.82.25.9.37q.14.2 0 .5-.16.29-.55.37c-.25.04-.61-.02-1.07-.38a.5.5 0 1 0-.62.78q.95.73 1.85.6c.57-.1 1.02-.45 1.26-.9a1.5 1.5 0 0 0-.33-1.85q.2-.15.31-.36c.3-.48.27-1.05.02-1.5-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 0 0-1.84.6.5.5 0 0 0 .62.78"
]);
const $4125b41377e9d21d$export$a53a264926ce76de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsActivityFilled', "1em", [
    "M10 2.7a.75.75 0 0 1-.67.83 6.5 6.5 0 1 0 7.14 7.14.75.75 0 1 1 1.5.16 8 8 0 1 1-8.8-8.8c.42-.04.79.26.83.68m1.02-.06c.1-.4.5-.65.9-.55q.57.13 1.1.35a.75.75 0 0 1-.55 1.39 7 7 0 0 0-.9-.29.75.75 0 0 1-.55-.9m6.54 4.33a.75.75 0 0 0-1.39.56q.18.44.28.9a.75.75 0 1 0 1.46-.35q-.13-.57-.35-1.1M14.3 3.93a.75.75 0 0 1 1.06-.08q.46.4.86.87a.75.75 0 0 1-1.15.97 7 7 0 0 0-.7-.7.75.75 0 0 1-.07-1.06M10 5.75a.75.75 0 0 0-1.5 0v5c0 .41.34.75.75.75h3a.75.75 0 1 0 0-1.5H10z"
]);
const $4125b41377e9d21d$export$65ab6cabeb092c4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsActivityRegular', "1em", [
    "M10 2.48a.5.5 0 0 1-.46.53 7 7 0 1 0 7.45 7.45.5.5 0 1 1 1 .07 8 8 0 1 1-8.52-8.51.5.5 0 0 1 .53.46m1 .07a.5.5 0 0 1 .6-.4q.85.19 1.6.52a.5.5 0 1 1-.4.91q-.66-.3-1.4-.44a.5.5 0 0 1-.4-.59m6.34 4.25a.5.5 0 1 0-.92.4q.3.67.44 1.4a.5.5 0 0 0 .98-.2 8 8 0 0 0-.5-1.6M14.4 3.92a.5.5 0 0 1 .7-.07q.6.5 1.08 1.08a.5.5 0 1 1-.78.63q-.43-.52-.93-.94a.5.5 0 0 1-.07-.7M10 5.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h3a.5.5 0 1 0 0-1H10z"
]);
const $4125b41377e9d21d$export$d3835167447d6949 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAddFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6q1.14-.59 2.5-.6a5.5 5.5 0 0 1 4.9 8H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm4.5 3c.28 0 .5.22.5.5V9h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5m-.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6z"
]);
const $4125b41377e9d21d$export$b784fa987fee2748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAddRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6q.48-.24 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2q-.15.52-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H6v1.5a.5.5 0 0 1-1 0V15H3.5a.5.5 0 0 1 0-1H5v-1.5c0-.28.22-.5.5-.5M11 6.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11z"
]);
const $4125b41377e9d21d$export$5134bb1c9e5e3bbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAvailabilityFilled', "1em", [
    "M6 12.92A7 7 0 0 1 12.92 6 6 6 0 1 0 6 12.92m3.35-8.27c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6 7.29l2.65-2.64c.2-.2.5-.2.7 0M13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-1.65-8.35L13 12.29l1.65-1.64a.5.5 0 0 1 .7.7L13.71 13l1.64 1.65a.5.5 0 0 1-.7.7L13 13.71l-1.65 1.64a.5.5 0 0 1-.7-.7L12.29 13l-1.64-1.65a.5.5 0 0 1 .7-.7"
]);
const $4125b41377e9d21d$export$a925e8e56e279f15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAvailabilityRegular', "1em", [
    "M11.92 6.08a5 5 0 1 0-5.84 5.84q-.08.49-.08 1A6 6 0 1 1 12.92 6q-.51 0-1 .08m-.57 4.57a.5.5 0 0 0-.7.7L12.29 13l-1.64 1.65a.5.5 0 0 0 .7.7L13 13.71l1.65 1.64a.5.5 0 0 0 .7-.7L13.71 13l1.64-1.65a.5.5 0 0 0-.7-.7L13 12.29zM13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-1a5 5 0 1 1 0-10 5 5 0 0 1 0 10M9.35 5.35a.5.5 0 1 0-.7-.7L6 7.29 4.85 6.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
]);
const $4125b41377e9d21d$export$cf31f2fced3f42e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsCheckmarkFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6a5.5 5.5 0 0 0-.66-6h2.76a.5.5 0 0 0 0-1H10V6.5a.5.5 0 0 0-1 0v3.76a5.5 5.5 0 0 0-6-.66zm7 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $4125b41377e9d21d$export$3a06679c600d6420 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsCheckmarkRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6q.48-.24 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2q-.15.52-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm3 7.26q.4.33.74.74h2.76a.5.5 0 0 0 0-1H10V6.5a.5.5 0 0 0-1 0zm1 4.24a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $4125b41377e9d21d$export$f233f9948113b79e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsDayFilled', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5zm3.4 2.04a2 2 0 0 0-.34.5l-.03.08a.5.5 0 0 0 .94.34l.02-.05.13-.17c.12-.11.3-.24.65-.24.4 0 .64.23.75.54.1.33.03.72-.24.96q-.22.21-.58.44l-.04.02q-.34.22-.7.51A2.5 2.5 0 0 0 6 12.5a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 0-1H7.07q.16-.47.54-.77.27-.23.62-.44l.02-.02c.23-.15.5-.33.72-.54.58-.54.71-1.34.5-2A1.74 1.74 0 0 0 7.77 7c-.64 0-1.09.26-1.36.54M11.5 7a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5H13v2a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v2h-1v-2a.5.5 0 0 0-.5-.5"
]);
const $4125b41377e9d21d$export$ec7b29e08a390351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsDayRegular', "1em", [
    "M6.4 7.54c.28-.28.73-.54 1.37-.54.88 0 1.48.56 1.7 1.23s.08 1.46-.5 2q-.36.32-.72.54l-.02.02q-.35.22-.62.44a1.6 1.6 0 0 0-.54.77H9a.5.5 0 1 1 0 1H6.5a.5.5 0 0 1-.5-.5c0-.97.44-1.59.96-2.03q.36-.3.7-.5l.04-.03q.36-.23.58-.44a.9.9 0 0 0 .24-.96.75.75 0 0 0-.75-.54.9.9 0 0 0-.65.24 1 1 0 0 0-.15.22.5.5 0 0 1-.94-.34l.03-.07.07-.14q.08-.16.28-.37M11.5 7c.28 0 .5.22.5.5v2h1v-2a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-2h-1.5a.5.5 0 0 1-.5-.5V7.5c0-.28.22-.5.5-.5m-6-4A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5z"
]);
const $4125b41377e9d21d$export$c7eb48e3c14ae592 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsOpenFilled', "1em", [
    "M4.5 5.75c0-.69.56-1.25 1.25-1.25H7.5a.75.75 0 0 0 0-1.5H5.75A2.75 2.75 0 0 0 3 5.75v8.5A2.75 2.75 0 0 0 5.75 17H7.5a.75.75 0 0 0 0-1.5H5.75c-.69 0-1.25-.56-1.25-1.25zm8-2.75a.75.75 0 0 0 0 1.5h1.75c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H12.5a.75.75 0 0 0 0 1.5h1.75A2.75 2.75 0 0 0 17 14.25v-8.5A2.75 2.75 0 0 0 14.25 3zm-2 2.75a.75.75 0 0 0-1.5 0v4.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H10.5z"
]);
const $4125b41377e9d21d$export$9fc90238ad16d982 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsOpenRegular', "1em", [
    "M4 5.5C4 4.67 4.67 4 5.5 4h2a.5.5 0 0 0 0-1h-2A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h2a.5.5 0 0 0 0-1h-2A1.5 1.5 0 0 1 4 14.5zM12.5 3a.5.5 0 0 0 0 1h2c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3zM10 5.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H10z"
]);
const $4125b41377e9d21d$export$68d2e02fd69b09e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsProhibitedFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6q.59-1.14.6-2.5a5.5 5.5 0 0 0-8-4.9zm8 .5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11zm-10 8a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1M5.5 18q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1A3.5 3.5 0 0 1 5.5 18"
]);
const $4125b41377e9d21d$export$8de8609ce8485603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsProhibitedRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6q.25-.48.4-1H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3.2q-.52.16-1 .4zm7.5 0c.28 0 .5.22.5.5V9h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5M1 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1M5.5 18q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1A3.5 3.5 0 0 1 5.5 18"
]);
const $4125b41377e9d21d$export$e06962077e953151 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsQuestionMarkFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6q1.14-.59 2.5-.6a5.5 5.5 0 0 1 4.9 8H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm4.5 3c.28 0 .5.22.5.5V9h2a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5m-.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25m0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95"
]);
const $4125b41377e9d21d$export$765091294d5f2144 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsQuestionMarkRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6q.48-.24 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2q-.15.52-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm5 3.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11zm-1 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25m0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95"
]);
const $4125b41377e9d21d$export$12e5ea6c35dde32d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsTeamFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.02l.02-.37c0-.92-.59-1.76-1.45-2.03q.43-.58.45-1.35a2.25 2.25 0 0 0-3.76-1.67A2.75 2.75 0 0 0 3 10.1zm7 .5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10zm-6.25 8a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M4 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 0 0-1.29-1.31H2.3A1.3 1.3 0 0 0 1 16.81c0 1.1.86 2.19 3 2.19m3.5-.5h-.02q.52-.79.52-1.69-.01-.73-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87m.25-4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $4125b41377e9d21d$export$3a7217ad21a2ff11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsTeamRegular', "1em", [
    "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10zM6 3a3 3 0 0 0-3 3v4.1a3 3 0 0 1 1-.09V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.1a2 2 0 0 1 .08 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM3.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M4 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 0 0-1.29-1.31H2.3A1.3 1.3 0 0 0 1 16.81c0 1.1.86 2.19 3 2.19m3.5-.5h-.02q.52-.79.52-1.69-.01-.73-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87m.25-4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $4125b41377e9d21d$export$ac424615bde9b585 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShirtFilled', "1em", [
    "M7.42 3a.5.5 0 0 1 .57.38C8.13 3.95 8.74 5 10 5s1.87-1.05 2.01-1.62a.5.5 0 0 1 .68-.34l4.62 1.85a1 1 0 0 1 .62 1.09l-.37 2.18a1 1 0 0 1-.98.84H15v7.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V9H3.42a1 1 0 0 1-.98-.84l-.37-2.18a1 1 0 0 1 .62-1.1L7.3 3.05z"
]);
const $4125b41377e9d21d$export$3f225380a461eafb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShirtRegular', "1em", [
    "M12.27 3.05a.5.5 0 0 1 .42-.01l4.62 1.85a1 1 0 0 1 .62 1.09l-.37 2.18a1 1 0 0 1-.98.84H15v7.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V9H3.42a1 1 0 0 1-.98-.84l-.37-2.18a1 1 0 0 1 .62-1.1L7.3 3.05l.1-.03a.5.5 0 0 1 .58.37C8.13 3.95 8.74 5 10 5s1.87-1.05 2.01-1.62a.5.5 0 0 1 .26-.33m.52 1.1A3 3 0 0 1 10 6a3 3 0 0 1-2.8-1.85L3.07 5.81 3.42 8H5.5c.28 0 .5.22.5.5V16h8V8.5c0-.28.22-.5.5-.5h2.08l.36-2.19z"
]);
const $4125b41377e9d21d$export$1406d7413368d594 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardFilled', "1em", [
    "m17.33 3.46.11.1.1.11c.64.76.61 1.9-.1 2.6l-3.6 3.63q-.34.33-.8.47l-1.96.6a.84.84 0 0 1-1.04-1.08l.62-1.94q.14-.44.47-.76l3.6-3.63a1.9 1.9 0 0 1 2.6-.1M12.9 4H4.5A2.5 2.5 0 0 0 2 6.5v2.26c.52-.48 1.12-.98 1.72-1.4A7 7 0 0 1 5.7 6.32q.49-.14.99-.05.52.12.84.59c.47.67.13 1.4-.2 1.92q-.26.41-.57.83l-.02.04q-.32.43-.61.88c-.16.28-.2.62-.13.86q.05.17.17.27.1.1.37.13.5.03 1.3-.27a.5.5 0 1 1 .33.94 4 4 0 0 1-1.71.33 1.52 1.52 0 0 1-1.41-1.12 2.2 2.2 0 0 1 .21-1.65h.01v-.01q.34-.51.66-.95l.01-.02q.32-.43.55-.78c.32-.53.3-.73.22-.84a.4.4 0 0 0-.25-.17 1 1 0 0 0-.5.03c-.47.12-1.04.44-1.66.88-.85.6-1.7 1.38-2.3 1.98v3.35A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5V7.13l-3.45 3.47a3 3 0 0 1-1.22.73l-1.96.6A1.84 1.84 0 0 1 9.1 9.58l.62-1.94q.21-.67.7-1.17z"
]);
const $4125b41377e9d21d$export$d2c83abff51cc923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardRegular', "1em", [
    "m17.33 3.46.11.1.1.11c.64.76.61 1.9-.1 2.6l-3.6 3.63q-.34.33-.8.47l-1.96.6a.84.84 0 0 1-1.04-1.08l.62-1.94q.14-.44.47-.76l3.6-3.63a1.9 1.9 0 0 1 2.6-.1m-1.88.8L11.84 7.9a1 1 0 0 0-.23.37l-.53 1.66 1.67-.5a1 1 0 0 0 .38-.23l3.6-3.62a.93.93 0 0 0 .06-1.24l-.06-.06-.06-.06a.9.9 0 0 0-1.22.06M12.89 4H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7.13l-1 1V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.23c.57-.49 1.34-1.11 2.07-1.54q.63-.35 1.07-.43c.28-.05.42 0 .5.1q.1.1.11.18.02.09-.04.27-.15.4-.6 1.02l-.1.13c-.25.35-.53.74-.73 1.14-.22.45-.4 1-.2 1.56q.27.76.92 1c.4.17.85.15 1.24.08a7 7 0 0 0 2.02-.81.5.5 0 0 0-.52-.86c-.4.24-1.07.58-1.68.69q-.45.07-.7-.02c-.13-.06-.26-.16-.34-.4q-.1-.26.15-.8.26-.46.66-1l.1-.13c.27-.39.58-.83.73-1.27q.13-.36.08-.76a1.3 1.3 0 0 0-.39-.73c-.4-.4-.91-.46-1.38-.38s-.95.3-1.4.56c-.54.31-1.1.72-1.57 1.1V7c0-1.1.9-2 2-2h6.9z"
]);
const $4125b41377e9d21d$export$1cb0a61aedb74129 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.5 4.21A2.5 2.5 0 0 0 2 6.5v2.26c.52-.48 1.12-.98 1.72-1.4.63-.45 1.3-.84 1.92-1.02L7.6 8.3q-.12.27-.26.5-.27.4-.58.82l-.02.04q-.32.43-.61.88c-.16.28-.2.62-.13.86q.05.17.17.27.1.1.37.13.5.03 1.3-.27a.5.5 0 1 1 .33.94 4 4 0 0 1-1.71.33 1.52 1.52 0 0 1-1.41-1.12 2.2 2.2 0 0 1 .21-1.65h.01v-.01q.34-.51.66-.95l.01-.02q.32-.43.55-.78c.32-.53.3-.73.22-.84a.4.4 0 0 0-.25-.17 1 1 0 0 0-.5.03c-.47.12-1.04.44-1.66.88-.85.6-1.7 1.38-2.3 1.98v3.35A2.5 2.5 0 0 0 4.5 16h10.8l1.85 1.85a.5.5 0 0 0 .7-.7zm8.4 9.8a1.84 1.84 0 0 1-2.2-2.2zm-.73-3.55 2.1 2.1.42-.13q.46-.14.8-.47l3.6-3.62c.71-.71.74-1.85.1-2.6l-.1-.12-.1-.1a1.9 1.9 0 0 0-2.6.1L11.13 7.2a2 2 0 0 0-.47.76zm6.8 6.8-3.9-3.9q.64-.21 1.13-.7L18 7.13v6.37a2.5 2.5 0 0 1-.67 1.7M6.13 4l3.6 3.6q.22-.63.7-1.12L12.89 4z"
]);
const $4125b41377e9d21d$export$75507a91205ab051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.48 1.48A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h10l.28-.01 1.87 1.86a.5.5 0 0 0 .7-.7zM14.3 15H5a2 2 0 0 1-2-2V9.23c.57-.49 1.34-1.11 2.07-1.54q.63-.35 1.07-.43c.28-.05.42 0 .5.1q.1.1.11.18.02.09-.04.27-.15.4-.6 1.02l-.1.13c-.25.35-.53.74-.73 1.14-.22.45-.4 1-.2 1.56q.27.76.92 1c.4.17.85.15 1.24.08a7 7 0 0 0 2.02-.81.5.5 0 0 0-.52-.86c-.4.24-1.07.58-1.68.69q-.45.07-.7-.02c-.13-.06-.26-.16-.34-.4q-.1-.26.15-.8.26-.46.66-1l.1-.13c.23-.34.5-.72.67-1.1zM5.64 6.35q-.54.16-1.07.48c-.54.31-1.1.72-1.57 1.1V7a2 2 0 0 1 1.39-1.9zm7.4 4.02-.42.13-.8-.8.93-.28a1 1 0 0 0 .38-.23l3.6-3.62a.93.93 0 0 0 .06-1.24l-.06-.06-.06-.06a.9.9 0 0 0-1.22.06l-3.61 3.62a1 1 0 0 0-.23.37l-.3.93-.79-.8.14-.44q.14-.44.47-.76l3.6-3.63a1.9 1.9 0 0 1 2.6-.1l.11.1.1.11c.64.76.61 1.9-.1 2.6l-3.6 3.63q-.34.33-.8.47m4.14 4.69-.7-.7A2 2 0 0 0 17 13V8.14l1-1V13c0 .8-.31 1.52-.82 2.06M6.12 4l1 1h4.77l1-1z"
]);




'use client';
const $692f4c77629d178b$var$sortIcons = {
    ascending: /*#__PURE__*/ $acw62.createElement((0, $4125b41377e9d21d$export$caecfbc1460768bd), {
        fontSize: 12
    }),
    descending: /*#__PURE__*/ $acw62.createElement((0, $4125b41377e9d21d$export$55d639d200f88b40), {
        fontSize: 12
    })
};
const $692f4c77629d178b$export$7197a71a8b2e7ea4 = (props, ref)=>{
    const { noNativeElements: noNativeElements, sortable: contextSortable } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    const { sortable: sortable = contextSortable } = props;
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'th';
    // The sort button is rendered as a div when not sortable, and as an ARIA button when sortable.
    const buttonSlot = (0, $fcf7ddccaab7fd8f$exports).always(props.button, {
        elementType: 'div',
        defaultProps: {
            as: 'div'
        }
    });
    const ariaButtonProps = (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)(buttonSlot.as, buttonSlot);
    var _props_sortDirection;
    return {
        components: {
            root: rootComponent,
            button: 'div',
            sortIcon: 'span',
            aside: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, (0, $4f816f386fc6883e$export$420e68273165f4ec)()),
            role: rootComponent === 'div' ? 'columnheader' : undefined,
            'aria-sort': sortable ? (_props_sortDirection = props.sortDirection) !== null && _props_sortDirection !== void 0 ? _props_sortDirection : 'none' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        aside: (0, $fcf7ddccaab7fd8f$exports).optional(props.aside, {
            elementType: 'span'
        }),
        sortIcon: (0, $fcf7ddccaab7fd8f$exports).optional(props.sortIcon, {
            renderByDefault: !!props.sortDirection,
            defaultProps: {
                children: props.sortDirection ? $692f4c77629d178b$var$sortIcons[props.sortDirection] : undefined
            },
            elementType: 'span'
        }),
        button: sortable ? ariaButtonProps : buttonSlot,
        sortable: sortable,
        noNativeElements: noNativeElements
    };
};




const $683e4b505f735064$export$1caee3bacbffe101 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.button, {
                children: [
                    state.root.children,
                    state.sortIcon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.sortIcon, {})
                ]
            }),
            state.aside && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.aside, {})
        ]
    });
};





'use client';
const $84d7992de60e562b$export$c4cdd744796b53d1 = 'fui-TableHeaderCell';
const $84d7992de60e562b$export$e9899c425d8ab6ea = {
    root: 'fui-TableHeaderCell',
    button: 'fui-TableHeaderCell__button',
    sortIcon: 'fui-TableHeaderCell__sortIcon',
    aside: 'fui-TableHeaderCell__aside'
};
const $84d7992de60e562b$var$useTableLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}"
    ]
});
const $84d7992de60e562b$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        xawz: 0,
        Bh6795r: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr",
        Bf4jedk: "f10tiqix"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f10tiqix{min-width:0px;}"
    ]
});
/**
 * Styles for the root slot
 */ const $84d7992de60e562b$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bhrd7zp: "figsok6",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f3gpkru",
        robkg1: 0,
        Bmvh20x: 0,
        B3nxjsc: 0,
        Bmkhcsx: "f14ym4q2",
        B8osjzx: 0,
        pehzd3: 0,
        Blsv9te: 0,
        u7xebq: 0,
        Bsvwmf7: "f1euou18",
        qhf8xq: "f10pi13n"
    },
    rootInteractive: {
        Bi91k9c: "feu1g3u",
        Jwef8y: "f1t94bn6",
        lj723h: "f1g4hkjv",
        ecr2s2: "f1wfn5kd"
    },
    resetButton: {
        B3rzk8w: "fq6nmtn",
        B7ck84d: "f1e4lqlz",
        De3pzq: "f1u2r49w",
        sj55zd: "f1ym3bx4",
        Bahqtrf: "f1mo0ibp",
        Be2twd7: "fjoy568",
        Bg96gwp: "fytdu2e",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1mk8lai",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh",
        fsow6f: "fgusgyc"
    },
    button: {
        qhf8xq: "f10pi13n",
        a9b677: "fly5x3f",
        mc9l5x: "f22iagw",
        Bh6795r: 0,
        Bqenvij: "f1l02sjl",
        Bt984gj: "f122n59",
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "fkln5zr",
        sshi5w: "f1nxs5xn",
        xawz: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr",
        oeaueh: "f1s6fcnf"
    },
    sortable: {
        Bceei9c: "f1k6fduh"
    },
    sortIcon: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z8tnut: "fclwglc"
    },
    resizeHandle: {}
}, {
    d: [
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        [
            ".f3gpkru{padding:0px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".f14ym4q2[data-fui-focus-within]:focus-within{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f1euou18[data-fui-focus-within]:focus-within{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f10pi13n{position:relative;}",
        ".fq6nmtn{resize:horizontal;}",
        ".f1e4lqlz{box-sizing:content-box;}",
        ".f1u2r49w{background-color:inherit;}",
        ".f1ym3bx4{color:inherit;}",
        ".f1mo0ibp{font-family:inherit;}",
        ".fjoy568{font-size:inherit;}",
        ".fytdu2e{line-height:normal;}",
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        [
            ".f1mk8lai{padding:0;}",
            {
                p: -1
            }
        ],
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        ".fgusgyc{text-align:unset;}",
        ".fly5x3f{width:100%;}",
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}",
        ".f1l02sjl{height:100%;}",
        ".f122n59{align-items:center;}",
        [
            ".fkln5zr{gap:var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".f1nxs5xn{min-height:32px;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f1s6fcnf{outline-style:none;}",
        ".f1k6fduh{cursor:pointer;}",
        ".fclwglc{padding-top:var(--spacingVerticalXXS);}"
    ],
    h: [
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}"
    ],
    a: [
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"
    ]
});
const $84d7992de60e562b$export$fd06fb7c91cd230d = (state)=>{
    const styles = $84d7992de60e562b$var$useStyles();
    const layoutStyles = {
        table: $84d7992de60e562b$var$useTableLayoutStyles(),
        flex: $84d7992de60e562b$var$useFlexLayoutStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.root, styles.root, state.sortable && styles.rootInteractive, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    // eslint-disable-next-line react-hooks/immutability
    state.button.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.button, styles.resetButton, styles.button, state.sortable && styles.sortable, state.button.className);
    if (state.sortIcon) // eslint-disable-next-line react-hooks/immutability
    state.sortIcon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.sortIcon, styles.sortIcon, state.sortIcon.className);
    if (state.aside) // eslint-disable-next-line react-hooks/immutability
    state.aside.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.aside, styles.resizeHandle, state.aside.className);
    return state;
};



'use client';
const $9460e3ff7c1178b7$export$9e1517a3035b3e5c = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $692f4c77629d178b$export$7197a71a8b2e7ea4)(props, ref);
    (0, $84d7992de60e562b$export$fd06fb7c91cd230d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableHeaderCellStyles_unstable')(state);
    return (0, $683e4b505f735064$export$1caee3bacbffe101)(state);
});
$9460e3ff7c1178b7$export$9e1517a3035b3e5c.displayName = 'TableHeaderCell';


var $acw62 = parcelRequire("acw62");




'use client';
const $0525c5816e797ed3$export$2d6ce122abd61a5f = (props, ref)=>{
    const { noNativeElements: noNativeElements, size: size } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'tr';
    const focusVisibleRef = (0, $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6)();
    const focusWithinRef = (0, $4f816f386fc6883e$export$420e68273165f4ec)();
    const isHeaderRow = (0, $b32b2b077c08c135$export$e9d05040fc93d3a3)();
    var _props_appearance;
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, focusVisibleRef, focusWithinRef),
            role: rootComponent === 'div' ? 'row' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        size: size,
        noNativeElements: noNativeElements,
        appearance: (_props_appearance = props.appearance) !== null && _props_appearance !== void 0 ? _props_appearance : 'none',
        isHeaderRow: isHeaderRow
    };
};




const $299cbfe3a9336f33$export$b3ca4727b08e080c = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};







'use client';
const $05695486cd30430c$export$97637e2826dd4389 = 'fui-TableRow';
const $05695486cd30430c$export$94acc091767159fc = {
    root: $05695486cd30430c$export$97637e2826dd4389
};
const $05695486cd30430c$var$useTableLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1u0rzck"
    }
}, {
    d: [
        ".f1u0rzck{display:table-row;}"
    ]
});
const $05695486cd30430c$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}"
    ]
});
/**
 * Styles for the root slot
 */ const $05695486cd30430c$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f19n0e5",
        B7ck84d: "f1ewtqcl",
        Bconypa: "f1jazu75",
        B6guboy: "f1xeqee6",
        Bfpq7zp: 0,
        g9k6zt: 0,
        Bn4voq9: 0,
        giviqs: "f1dxfoyt",
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f2krc9w"
    },
    rootInteractive: {
        B6guboy: "f1xeqee6",
        ecr2s2: "f1wfn5kd",
        lj723h: "f1g4hkjv",
        B43xm9u: "f15ngxrw",
        i921ia: "fjbbrdp",
        Jwef8y: "f1t94bn6",
        Bi91k9c: "feu1g3u",
        Bpt6rm4: "f1uorfem",
        ff6mpl: "fw60kww",
        Bahaeuw: "f1v3eptx",
        F230oe: "f8gmj8i",
        Bdw8ktp: [
            "f1ap8nzx",
            "fjag8bx"
        ],
        Bj1xduy: "f1igan7k",
        Bhh2cfd: [
            "fjag8bx",
            "f1ap8nzx"
        ]
    },
    medium: {
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f1facbz3"
    },
    small: {
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f1facbz3"
    },
    "extra-small": {
        Be2twd7: "fy9rknc"
    },
    brand: {
        De3pzq: "f16xkysk",
        g2u3we: "f1bh3yvw",
        h3c5rm: [
            "fmi79ni",
            "f11fozsx"
        ],
        B9xav0g: "fnzw4c6",
        zhjwy3: [
            "f11fozsx",
            "fmi79ni"
        ],
        ecr2s2: "f7tkmfy",
        lj723h: "f1r2dosr",
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1msmgpi",
        Bmclvqj: 0,
        psczho: 0,
        B0tx59b: 0,
        sk7i8k: 0,
        zlwzm7: "fbo0xvd",
        Bkp2nk: "fjuvmhu",
        gy0h4g: "f1kvufhq"
    },
    neutral: {
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1msmgpi",
        Bmclvqj: 0,
        psczho: 0,
        B0tx59b: 0,
        sk7i8k: 0,
        zlwzm7: "fbo0xvd",
        Bkp2nk: "fjuvmhu",
        gy0h4g: "f1kvufhq",
        De3pzq: "fq5gl1p",
        sj55zd: "f1cgsbmv",
        ecr2s2: "fa9o754",
        g2u3we: "frmsihh",
        h3c5rm: [
            "frttxa5",
            "f11o2r7f"
        ],
        B9xav0g: "fem5et0",
        zhjwy3: [
            "f11o2r7f",
            "frttxa5"
        ]
    },
    none: {}
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1jazu75[data-fui-focus-within]:focus-within .fui-TableSelectionCell{opacity:1;}",
        ".f1xeqee6[data-fui-focus-within]:focus-within .fui-TableCellActions{opacity:1;}",
        [
            ".f1dxfoyt[data-fui-focus-visible]{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f2krc9w[data-fui-focus-visible]{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f1facbz3{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStroke2);}",
            {
                p: -1
            }
        ],
        [
            ".f1facbz3{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStroke2);}",
            {
                p: -1
            }
        ],
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        ".f1bh3yvw{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".fmi79ni{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".f11fozsx{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".fnzw4c6{border-bottom-color:var(--colorTransparentStrokeInteractive);}",
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1cgsbmv{color:var(--colorNeutralForeground1Hover);}",
        ".frmsihh{border-top-color:var(--colorNeutralStrokeOnBrand);}",
        ".frttxa5{border-right-color:var(--colorNeutralStrokeOnBrand);}",
        ".f11o2r7f{border-left-color:var(--colorNeutralStrokeOnBrand);}",
        ".fem5et0{border-bottom-color:var(--colorNeutralStrokeOnBrand);}"
    ],
    a: [
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f15ngxrw:active .fui-TableCellActions{opacity:1;}",
        ".fjbbrdp:active .fui-TableSelectionCell{opacity:1;}",
        ".f7tkmfy:active{background-color:var(--colorBrandBackground2);}",
        ".f1r2dosr:active{color:var(--colorNeutralForeground1);}",
        ".fa9o754:active{background-color:var(--colorSubtleBackgroundSelected);}"
    ],
    h: [
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1uorfem:hover .fui-TableCellActions{opacity:1;}",
        ".fw60kww:hover .fui-TableSelectionCell{opacity:1;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1v3eptx:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f8gmj8i:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ap8nzx:hover{border-right-color:Highlight;}.fjag8bx:hover{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1igan7k:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1msmgpi{border:2px solid transparent;}}",
            {
                p: -2,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbo0xvd{border-radius:var(--borderRadiusMedium);}}",
            {
                p: -1,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fjuvmhu{box-sizing:border-box;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1kvufhq:focus-visible{outline-offset:-4px;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $05695486cd30430c$export$3e437c052026a79e = (state)=>{
    const styles = $05695486cd30430c$var$useStyles();
    const layoutStyles = {
        table: $05695486cd30430c$var$useTableLayoutStyles(),
        flex: $05695486cd30430c$var$useFlexLayoutStyles()
    };
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($05695486cd30430c$export$94acc091767159fc.root, styles.root, !state.isHeaderRow && styles.rootInteractive, styles[state.size], state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, styles[state.appearance], state.root.className);
    return state;
};



'use client';
const $4f29ac2e18a97c20$export$b05581f4e764e162 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $0525c5816e797ed3$export$2d6ce122abd61a5f)(props, ref);
    (0, $05695486cd30430c$export$3e437c052026a79e)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableRowStyles_unstable')(state);
    return (0, $299cbfe3a9336f33$export$b3ca4727b08e080c)(state);
});
$4f29ac2e18a97c20$export$b05581f4e764e162.displayName = 'TableRow';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


'use client';
const $7d57cd7ee5fa6068$export$19dcf9478947b8a5 = (props, ref)=>{
    const { appearance: appearance = 'transparent', reserveSelectedTabSpace: reserveSelectedTabSpace = true, size: size = 'medium' } = props;
    const state = $7d57cd7ee5fa6068$export$1f6f992d65c965f3(props, ref);
    const focusAttributes = $7d57cd7ee5fa6068$export$d9063a31c0181968({
        vertical: state.vertical
    });
    return {
        ...state,
        root: {
            ...focusAttributes,
            ...state.root
        },
        appearance: appearance,
        reserveSelectedTabSpace: reserveSelectedTabSpace,
        size: size
    };
};
const $7d57cd7ee5fa6068$export$1f6f992d65c965f3 = (props, ref)=>{
    const { disabled: disabled = false, onTabSelect: onTabSelect, selectTabOnFocus: selectTabOnFocus = false, vertical: vertical = false, selectedValue: controlledSelectedValue, defaultSelectedValue: defaultSelectedValue, ...rest } = props;
    const innerRef = $acw62.useRef(null);
    const [selectedValue, setSelectedValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: controlledSelectedValue,
        defaultState: defaultSelectedValue,
        initialState: undefined
    });
    // considered usePrevious, but it is sensitive to re-renders
    // this could cause the previous to move to current in the case where the tab list re-renders.
    // these refs avoid getRegisteredTabs changing when selectedValue changes and causing
    // renders for tabs that have not changed.
    const currentSelectedValue = $acw62.useRef(undefined);
    const previousSelectedValue = $acw62.useRef(undefined);
    $acw62.useEffect(()=>{
        previousSelectedValue.current = currentSelectedValue.current;
        currentSelectedValue.current = selectedValue;
    }, [
        selectedValue
    ]);
    const onSelect = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event, data)=>{
        setSelectedValue(data.value);
        onTabSelect === null || onTabSelect === void 0 || onTabSelect(event, data);
    });
    const registeredTabs = $acw62.useRef({});
    const onRegister = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((data)=>{
        const key = JSON.stringify(data.value);
        key;
        registeredTabs.current[key] = data;
    });
    const onUnregister = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((data)=>{
        delete registeredTabs.current[JSON.stringify(data.value)];
    });
    const getRegisteredTabs = $acw62.useCallback(()=>{
        return {
            selectedValue: currentSelectedValue.current,
            previousSelectedValue: previousSelectedValue.current,
            registeredTabs: registeredTabs.current
        };
    }, []);
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, innerRef),
            role: 'tablist',
            'aria-orientation': vertical ? 'vertical' : 'horizontal',
            ...rest
        }, {
            elementType: 'div'
        }),
        disabled: disabled,
        selectTabOnFocus: selectTabOnFocus,
        selectedValue: selectedValue,
        onRegister: onRegister,
        onUnregister: onUnregister,
        onSelect: onSelect,
        getRegisteredTabs: getRegisteredTabs,
        vertical: vertical
    };
};
const $7d57cd7ee5fa6068$export$d9063a31c0181968 = ({ vertical: vertical })=>{
    return (0, $d560ba8cc00a7511$export$ce58b15831f653b8)({
        circular: true,
        axis: vertical ? 'vertical' : 'horizontal',
        memorizeCurrent: false,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        unstable_hasDefault: true
    });
};





const $6c813607aa319ab7$export$3a0816208dfcce0 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $10b5578c8a01fa19$export$1bc26eb4ac1fc352), {
            value: contextValues.tabList,
            children: state.root.children
        })
    });
};




'use client';
const $4b0a54425b1e0a36$export$20c03e495c7ca8a0 = {
    root: 'fui-TabList'
};
/**
 * Styles for the root slot
 */ const $4b0a54425b1e0a36$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq",
        Bnnss6s: "fi64zpg",
        Eh141a: "flvyvdh",
        qhf8xq: "f10pi13n"
    },
    horizontal: {
        Bt984gj: "f1q9h2pe",
        Beiy3e4: "f1063pyq"
    },
    vertical: {
        Bt984gj: "f1q9h2pe",
        Beiy3e4: "f1vx9l62"
    },
    roundedSmall: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f1eyhf9v"
    },
    rounded: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "faqewft"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".fi64zpg{flex-shrink:0;}",
        ".flvyvdh{flex-wrap:nowrap;}",
        ".f10pi13n{position:relative;}",
        ".f1q9h2pe{align-items:stretch;}",
        ".f1vx9l62{flex-direction:column;}",
        [
            ".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        [
            ".faqewft{gap:var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ]
    ]
});
const $4b0a54425b1e0a36$export$3757b77a4bdc4556 = (state)=>{
    const { appearance: appearance, vertical: vertical, size: size } = state;
    const styles = $4b0a54425b1e0a36$var$useStyles();
    const isRounded = appearance === 'subtle-circular' || appearance === 'filled-circular';
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($4b0a54425b1e0a36$export$20c03e495c7ca8a0.root, styles.root, vertical ? styles.vertical : styles.horizontal, isRounded && (size === 'small' ? styles.roundedSmall : styles.rounded), state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $ea4d2d9b8ebf5f47$export$90bc632c6be1b5b2(state) {
    const { appearance: appearance, reserveSelectedTabSpace: reserveSelectedTabSpace, disabled: disabled, selectTabOnFocus: selectTabOnFocus, selectedValue: selectedKey, onRegister: onRegister, onUnregister: onUnregister, onSelect: onSelect, getRegisteredTabs: getRegisteredTabs, size: size, vertical: vertical } = state;
    const tabList = $acw62.useMemo(()=>({
            appearance: appearance,
            reserveSelectedTabSpace: reserveSelectedTabSpace,
            disabled: disabled,
            selectTabOnFocus: selectTabOnFocus,
            selectedValue: selectedKey,
            onSelect: onSelect,
            onRegister: onRegister,
            onUnregister: onUnregister,
            getRegisteredTabs: getRegisteredTabs,
            size: size,
            vertical: vertical
        }), [
        appearance,
        reserveSelectedTabSpace,
        disabled,
        selectTabOnFocus,
        selectedKey,
        onSelect,
        onRegister,
        onUnregister,
        getRegisteredTabs,
        size,
        vertical
    ]);
    return {
        tabList: tabList
    };
}



'use client';
const $900345cf912ae8c0$export$e51a686c67fdaa2d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $7d57cd7ee5fa6068$export$19dcf9478947b8a5)(props, ref);
    const contextValues = (0, $ea4d2d9b8ebf5f47$export$90bc632c6be1b5b2)(state);
    (0, $4b0a54425b1e0a36$export$3757b77a4bdc4556)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTabListStyles_unstable')(state);
    return (0, $6c813607aa319ab7$export$3a0816208dfcce0)(state, contextValues);
});
$900345cf912ae8c0$export$e51a686c67fdaa2d.displayName = 'TabList';




'use client';
const $47f38dea4f1371b5$export$6172d73f3cf4babb = {
    root: 'fui-Title2'
};
const $47f38dea4f1371b5$export$654c3310a1eb815a = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fojgt09",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fcen8rp"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fojgt09{font-size:var(--fontSizeHero700);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fcen8rp{line-height:var(--lineHeightHero700);}"
    ]
});


'use client';
const $15b0c993301c9728$export$cb271b43cf086b84 = (0, $b47caaa3576ee3da$export$b956d067c5bcf6b)({
    useStyles: (0, $47f38dea4f1371b5$export$654c3310a1eb815a),
    className: (0, $47f38dea4f1371b5$export$6172d73f3cf4babb).root,
    displayName: 'Title2'
});


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $060a05566cf52703$var$toastContainerContextDefaultValue = {
    close: ()=>null,
    intent: undefined,
    bodyId: '',
    titleId: ''
};
const $060a05566cf52703$var$ToastContainerContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $060a05566cf52703$export$16fde41fae5e5972 = $060a05566cf52703$var$ToastContainerContext.Provider;
const $060a05566cf52703$export$993ef5462439c9fb = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($060a05566cf52703$var$ToastContainerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $060a05566cf52703$var$toastContainerContextDefaultValue;
};


'use client';
const $8a6888d24a4b2c35$export$cc9ef03ff605283b = (props, ref)=>{
    const { intent: intent } = (0, $060a05566cf52703$export$993ef5462439c9fb)();
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        intent: intent
    };
};
const $8a6888d24a4b2c35$export$fbfe6fe26e3df742 = (props, ref)=>{
    const state = $8a6888d24a4b2c35$export$cc9ef03ff605283b(props, ref);
    return {
        ...state,
        backgroundAppearance: props.appearance
    };
};





const $ca7131463e57e634$export$8f74946b6594772c = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $65acf7eb8449fd1a$export$4fb4a984b1762672), {
        value: contextValues.backgroundAppearance,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};




'use client';
const $7fc4744ee465ef6e$export$b12c3dcfb8cfcd58 = {
    root: 'fui-Toast'
};
const $7fc4744ee465ef6e$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rhf7k35", null, [
    ".rhf7k35{display:grid;grid-template-columns:auto 1fr auto;padding:12px;border-radius:var(--borderRadiusMedium);border:1px solid var(--colorTransparentStroke);box-shadow:var(--shadow8);font-size:var(--fontSizeBase300);line-height:20px;font-weight:var(--fontWeightSemibold);color:var(--colorNeutralForeground1);background-color:var(--colorNeutralBackground1);}"
]);
const $7fc4744ee465ef6e$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    inverted: {
        sj55zd: "f1w7i9ko",
        De3pzq: "f5pduvr"
    }
}, {
    d: [
        ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}",
        ".f5pduvr{background-color:var(--colorNeutralBackgroundInverted);}"
    ]
});
const $7fc4744ee465ef6e$export$e52c715dbec3af07 = (state)=>{
    const rootBaseClassName = $7fc4744ee465ef6e$var$useRootBaseClassName();
    const styles = $7fc4744ee465ef6e$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($7fc4744ee465ef6e$export$b12c3dcfb8cfcd58.root, rootBaseClassName, state.backgroundAppearance === 'inverted' && styles.inverted, state.root.className);
    return state;
};


function $5b1a6b11845dad9b$export$d86ef877ba9b60b4(state) {
    const { backgroundAppearance: backgroundAppearance } = state;
    return {
        backgroundAppearance: backgroundAppearance
    };
}



'use client';
const $cbcc184592d9c369$export$8d8dc7d5f743331b = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8a6888d24a4b2c35$export$fbfe6fe26e3df742)(props, ref);
    (0, $7fc4744ee465ef6e$export$e52c715dbec3af07)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useToastStyles_unstable')(state);
    return (0, $ca7131463e57e634$export$8f74946b6594772c)(state, (0, $5b1a6b11845dad9b$export$d86ef877ba9b60b4)(state));
});
$cbcc184592d9c369$export$8d8dc7d5f743331b.displayName = 'Toast';


var $acw62 = parcelRequire("acw62");



'use client';
const $4a0c121d3f197877$export$8400e4cc9efcd9c3 = (props, ref)=>{
    const { bodyId: bodyId } = (0, $060a05566cf52703$export$993ef5462439c9fb)();
    return {
        components: {
            root: 'div',
            subtitle: 'div'
        },
        subtitle: (0, $fcf7ddccaab7fd8f$exports).optional(props.subtitle, {
            elementType: 'div'
        }),
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            id: bodyId,
            ...props
        }), {
            elementType: 'div'
        })
    };
};
const $4a0c121d3f197877$export$b60b2d050c42315 = (props, ref)=>{
    const backgroundAppearance = (0, $65acf7eb8449fd1a$export$9d103812d8321e51)();
    return {
        ...$4a0c121d3f197877$export$8400e4cc9efcd9c3(props, ref),
        backgroundAppearance: backgroundAppearance
    };
};



var $acw62 = parcelRequire("acw62");

const $bf74ed1a692fe804$export$b2c1a02dc428786f = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {}),
            state.subtitle ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.subtitle, {}) : null
        ]
    });
};




'use client';
const $94d3d0bc7ebcf55e$export$e361ab51cc508161 = {
    root: 'fui-ToastBody',
    subtitle: 'fui-ToastBody__subtitle'
};
const $94d3d0bc7ebcf55e$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1u44l4o", null, [
    ".r1u44l4o{grid-column-start:2;grid-column-end:3;padding-top:6px;font-size:var(--fontSizeBase300);line-height:var(--lineHeightBase300);font-weight:var(--fontWeightRegular);color:var(--colorNeutralForeground1);word-break:break-word;}"
]);
const $94d3d0bc7ebcf55e$var$useSubtitleBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rzjw1xk", null, [
    ".rzjw1xk{padding-top:4px;grid-column-start:2;grid-column-end:3;font-size:var(--fontSizeBase200);line-height:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);color:var(--colorNeutralForeground2);}"
]);
const $94d3d0bc7ebcf55e$var$useInvertedStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f1w7i9ko"
    },
    subtitle: {
        sj55zd: "f1w7i9ko"
    }
}, {
    d: [
        ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}"
    ]
});
const $94d3d0bc7ebcf55e$export$f95d499910af0ab2 = (state)=>{
    const rootBaseClassName = $94d3d0bc7ebcf55e$var$useRootBaseClassName();
    const subtitleBaseClassName = $94d3d0bc7ebcf55e$var$useSubtitleBaseClassName();
    const invertedStyles = $94d3d0bc7ebcf55e$var$useInvertedStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($94d3d0bc7ebcf55e$export$e361ab51cc508161.root, rootBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.root, state.root.className);
    if (state.subtitle) // eslint-disable-next-line react-hooks/immutability
    state.subtitle.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($94d3d0bc7ebcf55e$export$e361ab51cc508161.subtitle, subtitleBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.subtitle, state.subtitle.className);
    return state;
};



'use client';
const $5bd76a47a80a9c38$export$a2fc124486ff7b59 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $4a0c121d3f197877$export$b60b2d050c42315)(props, ref);
    (0, $94d3d0bc7ebcf55e$export$f95d499910af0ab2)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useToastBodyStyles_unstable')(state);
    return (0, $bf74ed1a692fe804$export$b2c1a02dc428786f)(state);
});
$5bd76a47a80a9c38$export$a2fc124486ff7b59.displayName = 'ToastBody';



var $acw62 = parcelRequire("acw62");




const $2d233013a30c9870$export$fa3d5b535a2458a1 = {
    show: 'fui-toast-show',
    dismiss: 'fui-toast-dismiss',
    dismissAll: 'fui-toast-dismiss-all',
    update: 'fui-toast-update',
    pause: 'fui-toast-pause',
    play: 'fui-toast-play'
};
const $2d233013a30c9870$export$b243a64c42cb66cc = {
    bottom: 'bottom',
    bottomEnd: 'bottom-end',
    bottomStart: 'bottom-start',
    top: 'top',
    topEnd: 'top-end',
    topStart: 'top-start'
};


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * @internal
 */ /**
 * @internal
 * @param compare - comparison function for items
 * @returns Priority queue implemented with a min heap
 */ function $120da7eaa95fb331$export$502825a17c61545f(compare) {
    const arr = [];
    let size = 0;
    const swap = (a, b)=>{
        const tmp = arr[a];
        arr[a] = arr[b];
        arr[b] = tmp;
    };
    const heapify = (i)=>{
        let smallest = i;
        const l = $120da7eaa95fb331$var$left(i);
        const r = $120da7eaa95fb331$var$right(i);
        if (l < size && compare(arr[l], arr[smallest]) < 0) smallest = l;
        if (r < size && compare(arr[r], arr[smallest]) < 0) smallest = r;
        if (smallest !== i) {
            swap(smallest, i);
            heapify(smallest);
        }
    };
    const dequeue = ()=>{
        if (size === 0) throw new Error('Priority queue empty');
        const res = arr[0];
        arr[0] = arr[--size];
        heapify(0);
        return res;
    };
    const peek = ()=>{
        if (size === 0) return null;
        return arr[0];
    };
    const enqueue = (item)=>{
        arr[size++] = item;
        let i = size - 1;
        let p = $120da7eaa95fb331$var$parent(i);
        while(i > 0 && compare(arr[p], arr[i]) > 0){
            swap(p, i);
            i = p;
            p = $120da7eaa95fb331$var$parent(i);
        }
    };
    const contains = (item)=>{
        const index = arr.indexOf(item);
        return index >= 0 && index < size;
    };
    const remove = (item)=>{
        const i = arr.indexOf(item);
        if (i === -1 || i >= size) return;
        arr[i] = arr[--size];
        heapify(i);
    };
    const clear = ()=>{
        size = 0;
    };
    const all = ()=>{
        return arr.slice(0, size);
    };
    return {
        all: all,
        clear: clear,
        contains: contains,
        dequeue: dequeue,
        enqueue: enqueue,
        peek: peek,
        remove: remove,
        size: ()=>size
    };
}
const $120da7eaa95fb331$var$left = (i)=>{
    return 2 * i + 1;
};
const $120da7eaa95fb331$var$right = (i)=>{
    return 2 * i + 2;
};
const $120da7eaa95fb331$var$parent = (i)=>{
    return Math.floor((i - 1) / 2);
};


function $7b8501662cd2699f$var$assignDefined(a, b) {
    // This cast is required, as Object.entries will return string as key which is not indexable
    for (const [key, prop] of Object.entries(b))// eslint-disable-next-line eqeqeq
    if (prop != undefined) a[key] = prop;
}
const $7b8501662cd2699f$var$defaulToastOptions = {
    onStatusChange: undefined,
    priority: 0,
    pauseOnHover: false,
    pauseOnWindowBlur: false,
    position: 'bottom-end',
    timeout: 3000
};
// Multiple toasts can be dispatched in a single tick, use counter to prevent collisions
let $7b8501662cd2699f$var$counter = 0;
function $7b8501662cd2699f$export$485098e18d680f1a(options) {
    const { limit: limit = Number.POSITIVE_INFINITY } = options;
    const visibleToasts = new Set();
    const toasts = new Map();
    const queue = (0, $120da7eaa95fb331$export$502825a17c61545f)((ta, tb)=>{
        const a = toasts.get(ta);
        const b = toasts.get(tb);
        if (!a || !b) return 0;
        if (a.priority === b.priority) return a.order - b.order;
        return a.priority - b.priority;
    });
    const isToastVisible = (toastId)=>{
        return visibleToasts.has(toastId);
    };
    /**
   * Updates an existing toast with any available option
   */ const updateToast = (toastOptions)=>{
        const { toastId: toastId } = toastOptions;
        const toastToUpdate = toasts.get(toastId);
        if (!toastToUpdate) return;
        Object.assign(toastToUpdate, toastOptions);
        toastToUpdate.updateId++;
    };
    /**
   * Dismisses a toast with a specific id
   */ const dismissToast = (toastId)=>{
        visibleToasts.delete(toastId);
    };
    /**
   * Dismisses all toasts and clears the queue
   */ const dismissAllToasts = ()=>{
        visibleToasts.clear();
        queue.clear();
    };
    /**
   * @param toastOptions user configured options
   * @param onUpdate Some toast methods can result in UI changes (i.e. close) use this to dispatch callbacks
   */ const buildToast = (toastOptions, onUpdate)=>{
        var _toast_onStatusChange;
        const { toastId: toastId, content: content, toasterId: toasterId } = toastOptions;
        if (toasts.has(toastId)) return;
        const close = ()=>{
            var _toast_onStatusChange;
            const toast = toasts.get(toastId);
            if (!toast) return;
            visibleToasts.delete(toastId);
            onUpdate();
            (_toast_onStatusChange = toast.onStatusChange) === null || _toast_onStatusChange === void 0 || _toast_onStatusChange.call(toast, null, {
                status: 'dismissed',
                ...toast
            });
        };
        const remove = ()=>{
            const toast = toasts.get(toastId);
            if (!toast) return;
            toasts.delete(toastId);
            if (visibleToasts.size < limit && queue.peek()) {
                const nextToast = toasts.get(queue.dequeue());
                if (!nextToast) return;
                visibleToasts.add(nextToast.toastId);
            }
            onUpdate();
        };
        const toast = {
            ...$7b8501662cd2699f$var$defaulToastOptions,
            close: close,
            remove: remove,
            toastId: toastId,
            content: content,
            updateId: 0,
            toasterId: toasterId,
            order: $7b8501662cd2699f$var$counter++,
            data: {},
            imperativeRef: $acw62.createRef()
        };
        $7b8501662cd2699f$var$assignDefined(toast, options);
        $7b8501662cd2699f$var$assignDefined(toast, toastOptions);
        toasts.set(toastId, toast);
        (_toast_onStatusChange = toast.onStatusChange) === null || _toast_onStatusChange === void 0 || _toast_onStatusChange.call(toast, null, {
            status: 'queued',
            ...toast
        });
        if (visibleToasts.size >= limit) queue.enqueue(toastId);
        else visibleToasts.add(toastId);
    };
    return {
        buildToast: buildToast,
        dismissAllToasts: dismissAllToasts,
        dismissToast: dismissToast,
        isToastVisible: isToastVisible,
        updateToast: updateToast,
        visibleToasts: visibleToasts,
        toasts: toasts
    };
}



'use client';
function $49f2ed1a8ab871ef$export$f46171b59bb094f9(options = {}) {
    const forceUpdate = (0, $f910bf47b194652c$export$91db9bc4f8ac944a)();
    const { toasterId: userToasterId, shortcuts: shortcuts } = options;
    // Currently the toaster options can never be changed at runtime
    const [toaster] = $acw62.useState(()=>(0, $7b8501662cd2699f$export$485098e18d680f1a)(options));
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const lastActiveElementRef = $acw62.useRef(null);
    const isCorrectToaster = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((toasterId)=>{
        return toasterId === userToasterId;
    });
    const isFocusShortcut = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        if (shortcuts === null || shortcuts === void 0 ? void 0 : shortcuts.focus) return shortcuts.focus(e);
    });
    const pauseAllToasts = $acw62.useCallback(()=>{
        toaster.visibleToasts.forEach((toastId)=>{
            var _toast_imperativeRef_current;
            const toast = toaster.toasts.get(toastId);
            toast === null || toast === void 0 || (_toast_imperativeRef_current = toast.imperativeRef.current) === null || _toast_imperativeRef_current === void 0 || _toast_imperativeRef_current.pause();
        });
    }, [
        toaster
    ]);
    const playAllToasts = $acw62.useCallback(()=>{
        toaster.visibleToasts.forEach((toastId)=>{
            var _toast_imperativeRef_current;
            const toast = toaster.toasts.get(toastId);
            toast === null || toast === void 0 || (_toast_imperativeRef_current = toast.imperativeRef.current) === null || _toast_imperativeRef_current === void 0 || _toast_imperativeRef_current.play();
        });
    }, [
        toaster
    ]);
    const getMostRecentVisibleToast = $acw62.useCallback(()=>{
        return Array.from(toaster.visibleToasts).reduce((cur, next)=>{
            const toast = toaster.toasts.get(next);
            if (!toast) return cur;
            if (!cur) return toast;
            if (cur.order < (toast === null || toast === void 0 ? void 0 : toast.order)) return toast;
            return cur;
        }, undefined);
    }, [
        toaster
    ]);
    const tryRestoreFocus = $acw62.useCallback(()=>{
        const mostRecentToast = getMostRecentVisibleToast();
        if (mostRecentToast === null || mostRecentToast === void 0 ? void 0 : mostRecentToast.imperativeRef.current) mostRecentToast.imperativeRef.current.focus();
        else {
            var _lastActiveElementRef_current;
            (_lastActiveElementRef_current = lastActiveElementRef.current) === null || _lastActiveElementRef_current === void 0 || _lastActiveElementRef_current.focus();
            lastActiveElementRef.current = null;
        }
    }, [
        getMostRecentVisibleToast
    ]);
    const closeAllToasts = $acw62.useCallback(()=>{
        toaster.visibleToasts.forEach((toastId)=>{
            const toast = toaster.toasts.get(toastId);
            toast === null || toast === void 0 || toast.close();
        });
        tryRestoreFocus();
    }, [
        toaster,
        tryRestoreFocus
    ]);
    $acw62.useEffect(()=>{
        if (!targetDocument) return;
        const addToastListener = (eventType, callback)=>{
            const listener = (e)=>{
                if (!isCorrectToaster(e.detail.toasterId)) return;
                callback(e);
                forceUpdate();
            };
            targetDocument.addEventListener(eventType, listener);
            return ()=>targetDocument.removeEventListener(eventType, listener);
        };
        const buildToast = (e)=>{
            toaster.buildToast(e.detail, forceUpdate);
        };
        const dismissToast = (e)=>{
            toaster.dismissToast(e.detail.toastId);
        };
        const updateToast = (e)=>{
            toaster.updateToast(e.detail);
        };
        const dismissAllToasts = (e)=>{
            toaster.dismissAllToasts();
        };
        const pauseToast = (e)=>{
            const toast = toaster.toasts.get(e.detail.toastId);
            if (toast) {
                var _toast_imperativeRef_current;
                (_toast_imperativeRef_current = toast.imperativeRef.current) === null || _toast_imperativeRef_current === void 0 || _toast_imperativeRef_current.pause();
            }
        };
        const playToast = (e)=>{
            const toast = toaster.toasts.get(e.detail.toastId);
            if (toast) {
                var _toast_imperativeRef_current;
                (_toast_imperativeRef_current = toast.imperativeRef.current) === null || _toast_imperativeRef_current === void 0 || _toast_imperativeRef_current.play();
            }
        };
        const cleanupBuildListener = addToastListener((0, $2d233013a30c9870$export$fa3d5b535a2458a1).show, buildToast);
        const cleanupUpdateListener = addToastListener((0, $2d233013a30c9870$export$fa3d5b535a2458a1).update, updateToast);
        const cleanupDismissListener = addToastListener((0, $2d233013a30c9870$export$fa3d5b535a2458a1).dismiss, dismissToast);
        const cleanupDismissAllListener = addToastListener((0, $2d233013a30c9870$export$fa3d5b535a2458a1).dismissAll, dismissAllToasts);
        const cleanupPauseListener = addToastListener((0, $2d233013a30c9870$export$fa3d5b535a2458a1).pause, pauseToast);
        const cleanupPlayListener = addToastListener((0, $2d233013a30c9870$export$fa3d5b535a2458a1).play, playToast);
        const focusShortcutListener = (e)=>{
            if (isFocusShortcut(e)) {
                pauseAllToasts();
                const mostRecentToast = getMostRecentVisibleToast();
                if (mostRecentToast) {
                    var _mostRecentToast_imperativeRef_current;
                    lastActiveElementRef.current = (0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(targetDocument.activeElement) ? targetDocument.activeElement : null;
                    (_mostRecentToast_imperativeRef_current = mostRecentToast.imperativeRef.current) === null || _mostRecentToast_imperativeRef_current === void 0 || _mostRecentToast_imperativeRef_current.focus();
                }
            }
        };
        targetDocument.addEventListener('keydown', focusShortcutListener);
        return ()=>{
            cleanupBuildListener();
            cleanupDismissAllListener();
            cleanupUpdateListener();
            cleanupDismissListener();
            cleanupPauseListener();
            cleanupPlayListener();
            targetDocument.removeEventListener('keydown', focusShortcutListener);
        };
    }, [
        toaster,
        forceUpdate,
        targetDocument,
        isCorrectToaster,
        pauseAllToasts,
        getMostRecentVisibleToast,
        isFocusShortcut
    ]);
    const toastsToRender = (()=>{
        if (!toaster) return new Map();
        const toRender = new Map();
        const toasts = Array.from(toaster.toasts.values());
        toasts.forEach((toast)=>{
            const { position: position } = toast;
            toRender.has(position) || toRender.set(position, []);
            if (position.startsWith('bottom')) toRender.get(position).push(toast);
            else toRender.get(position).unshift(toast);
        });
        return toRender;
    })();
    return {
        isToastVisible: toaster.isToastVisible,
        toastsToRender: toastsToRender,
        pauseAllToasts: pauseAllToasts,
        playAllToasts: playAllToasts,
        tryRestoreFocus: tryRestoreFocus,
        closeAllToasts: closeAllToasts
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

'use client';
const $f2872e3e3497dbc3$export$322b8d5522f5fb70 = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r16zaflb", "r75casi", [
    ".r16zaflb{animation-name:rsacmq1;}",
    "@keyframes rsacmq1{from{opacity:0;}to{opacity:0;}}",
    ".r75casi{animation-name:rsacmq1;}"
]);


'use client';
const $c4117b1ca34816db$export$c57e9b2d8b9e4de = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const baseAnimationStyles = (0, $f2872e3e3497dbc3$export$322b8d5522f5fb70)();
    const { running: running, timeout: timeout, onTimeout: onTimeout } = props;
    const style = {
        animationDuration: `${timeout}ms`,
        animationPlayState: running ? 'running' : 'paused'
    };
    if (timeout < 0) return null;
    return /*#__PURE__*/ $acw62.createElement("span", {
        onAnimationEnd: onTimeout,
        "data-timer-status": style.animationPlayState,
        ref: ref,
        style: style,
        className: baseAnimationStyles
    });
});
$c4117b1ca34816db$export$c57e9b2d8b9e4de.displayName = 'Timer';


'use client';
const $b2b1d0de9919074f$var$intentPolitenessMap = {
    success: 'assertive',
    warning: 'assertive',
    error: 'assertive',
    info: 'polite'
};
const $b2b1d0de9919074f$export$733e9d8cbe4cbf36 = (props, ref)=>{
    const { visible: visible, children: children, close: closeProp, remove: remove, updateId: updateId, announce: announce, data: data, timeout: timerTimeout, politeness: desiredPoliteness, intent: intent = 'info', pauseOnHover: pauseOnHover, pauseOnWindowBlur: pauseOnWindowBlur, imperativeRef: imperativeRef, tryRestoreFocus: tryRestoreFocus, content: _content, ...rest } = props;
    const titleId = (0, $0200d30cfa270435$export$f680877a34711e37)('toast-title');
    const bodyId = (0, $0200d30cfa270435$export$f680877a34711e37)('toast-body');
    const toastRef = $acw62.useRef(null);
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const [running, setRunning] = $acw62.useState(false);
    const imperativePauseRef = $acw62.useRef(false);
    const focusedToastBeforeClose = $acw62.useRef(false);
    const focusableGroupAttribute = (0, $3a1d6c4ac0998739$export$7cdad6852d2f5fdf)({
        tabBehavior: 'limited-trap-focus',
        // Users should only use Tab to focus into the toast
        // Escape is already reserved to dismiss all toasts
        ignoreDefaultKeydown: {
            Tab: true,
            Escape: true,
            Enter: true
        }
    });
    const close = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
        var _toastRef_current;
        const activeElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.activeElement;
        if (activeElement && ((_toastRef_current = toastRef.current) === null || _toastRef_current === void 0 ? void 0 : _toastRef_current.contains(activeElement))) focusedToastBeforeClose.current = true;
        closeProp();
    });
    const onStatusChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((status)=>{
        var _props_onStatusChange;
        return (_props_onStatusChange = props.onStatusChange) === null || _props_onStatusChange === void 0 ? void 0 : _props_onStatusChange.call(props, null, {
            status: status,
            ...props
        });
    });
    const pause = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>setRunning(false));
    const play = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
        var _toastRef_current;
        if (imperativePauseRef.current) return;
        var _targetDocument_activeElement;
        const containsActive = !!((_toastRef_current = toastRef.current) === null || _toastRef_current === void 0 ? void 0 : _toastRef_current.contains((_targetDocument_activeElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.activeElement) !== null && _targetDocument_activeElement !== void 0 ? _targetDocument_activeElement : null));
        if (timerTimeout < 0) {
            setRunning(true);
            return;
        }
        if (!containsActive) setRunning(true);
    });
    $acw62.useImperativeHandle(imperativeRef, ()=>({
            focus: ()=>{
                if (!toastRef.current) return;
                toastRef.current.focus();
            },
            play: ()=>{
                imperativePauseRef.current = false;
                play();
            },
            pause: ()=>{
                imperativePauseRef.current = true;
                pause();
            }
        }));
    $acw62.useEffect(()=>{
        return ()=>onStatusChange('unmounted');
    }, [
        onStatusChange
    ]);
    $acw62.useEffect(()=>{
        if (!targetDocument) return;
        if (pauseOnWindowBlur) {
            var _targetDocument_defaultView, _targetDocument_defaultView1;
            (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 || _targetDocument_defaultView.addEventListener('focus', play);
            (_targetDocument_defaultView1 = targetDocument.defaultView) === null || _targetDocument_defaultView1 === void 0 || _targetDocument_defaultView1.addEventListener('blur', pause);
            return ()=>{
                var _targetDocument_defaultView, _targetDocument_defaultView1;
                (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 || _targetDocument_defaultView.removeEventListener('focus', play);
                (_targetDocument_defaultView1 = targetDocument.defaultView) === null || _targetDocument_defaultView1 === void 0 || _targetDocument_defaultView1.removeEventListener('blur', pause);
            };
        }
    }, [
        targetDocument,
        pause,
        play,
        pauseOnWindowBlur
    ]);
    // Users never actually use ToastContainer as a JSX but imperatively through useToastContainerController
    const userRootSlot = data.root;
    const onMotionFinish = $acw62.useCallback((_, { direction: direction })=>{
        if (direction === 'exit') remove();
        if (direction === 'enter') {
            // start toast once it's fully animated in
            play();
            onStatusChange('visible');
        }
    }, [
        onStatusChange,
        play,
        remove
    ]);
    const onMouseEnter = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        var _userRootSlot_onMouseEnter;
        pause();
        userRootSlot === null || userRootSlot === void 0 || (_userRootSlot_onMouseEnter = userRootSlot.onMouseEnter) === null || _userRootSlot_onMouseEnter === void 0 || _userRootSlot_onMouseEnter.call(userRootSlot, e);
    });
    const onMouseLeave = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        var _userRootSlot_onMouseEnter;
        play();
        userRootSlot === null || userRootSlot === void 0 || (_userRootSlot_onMouseEnter = userRootSlot.onMouseEnter) === null || _userRootSlot_onMouseEnter === void 0 || _userRootSlot_onMouseEnter.call(userRootSlot, e);
    });
    const { findFirstFocusable: findFirstFocusable, findLastFocusable: findLastFocusable } = (0, $708e79e1f2ab4237$export$2b0519dd5d2bc6d4)();
    const onKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        var _userRootSlot_onKeyDown;
        if (e.key === (0, $c823d65ebf8ac0ff$export$bfadae053a633538)) {
            e.preventDefault();
            close();
        }
        if (e.key === (0, $c823d65ebf8ac0ff$export$3e41faf802a29e71) && e.currentTarget === e.target) {
            e.preventDefault();
            if (e.shiftKey) {
                var _findLastFocusable;
                (_findLastFocusable = findLastFocusable(e.currentTarget)) === null || _findLastFocusable === void 0 || _findLastFocusable.focus();
            } else {
                var _findFirstFocusable;
                (_findFirstFocusable = findFirstFocusable(e.currentTarget)) === null || _findFirstFocusable === void 0 || _findFirstFocusable.focus();
            }
        }
        userRootSlot === null || userRootSlot === void 0 || (_userRootSlot_onKeyDown = userRootSlot.onKeyDown) === null || _userRootSlot_onKeyDown === void 0 || _userRootSlot_onKeyDown.call(userRootSlot, e);
    });
    $acw62.useEffect(()=>{
        var _toastRef_current;
        if (!visible) return;
        const politeness = desiredPoliteness !== null && desiredPoliteness !== void 0 ? desiredPoliteness : $b2b1d0de9919074f$var$intentPolitenessMap[intent];
        var _toastRef_current_textContent;
        announce((_toastRef_current_textContent = (_toastRef_current = toastRef.current) === null || _toastRef_current === void 0 ? void 0 : _toastRef_current.textContent) !== null && _toastRef_current_textContent !== void 0 ? _toastRef_current_textContent : '', {
            politeness: politeness
        });
    }, [
        announce,
        desiredPoliteness,
        toastRef,
        visible,
        updateId,
        intent
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (focusedToastBeforeClose.current) {
                focusedToastBeforeClose.current = false;
                tryRestoreFocus();
            }
        };
    }, [
        tryRestoreFocus
    ]);
    return {
        components: {
            timer: (0, $c4117b1ca34816db$export$c57e9b2d8b9e4de),
            root: 'div'
        },
        timer: (0, $fcf7ddccaab7fd8f$exports).always({
            onTimeout: close,
            running: running,
            timeout: timerTimeout !== null && timerTimeout !== void 0 ? timerTimeout : -1
        }, {
            elementType: (0, $c4117b1ca34816db$export$c57e9b2d8b9e4de)
        }),
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, toastRef),
            children: children,
            tabIndex: 0,
            role: 'listitem',
            'aria-labelledby': titleId,
            'aria-describedby': bodyId,
            ...rest,
            ...userRootSlot,
            ...focusableGroupAttribute,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: onKeyDown
        }), {
            elementType: 'div'
        }),
        timerTimeout: timerTimeout,
        transitionTimeout: 0,
        running: running,
        visible: visible,
        remove: remove,
        close: close,
        onTransitionEntering: ()=>{
        /* no-op */ },
        updateId: updateId,
        nodeRef: toastRef,
        intent: intent,
        titleId: titleId,
        bodyId: bodyId,
        onMotionFinish: onMotionFinish
    };
};






// ----- SIZE -----
const $48e1ce8583f703eb$var$sizeValuesForOrientation = (orientation, element)=>{
    const sizeName = orientation === 'horizontal' ? 'maxWidth' : 'maxHeight';
    const overflowName = orientation === 'horizontal' ? 'overflowX' : 'overflowY';
    const measuredSize = orientation === 'horizontal' ? element.scrollWidth : element.scrollHeight;
    const toSize = `${measuredSize}px`;
    return {
        sizeName: sizeName,
        overflowName: overflowName,
        toSize: toSize
    };
};
const $48e1ce8583f703eb$export$9efcac9cfdb79785 = ({ orientation: orientation, duration: duration, easing: easing, element: element, outSize: outSize = '0', delay: delay = 0 })=>{
    const { sizeName: sizeName, overflowName: overflowName, toSize: toSize } = $48e1ce8583f703eb$var$sizeValuesForOrientation(orientation, element);
    return {
        keyframes: [
            {
                [sizeName]: outSize,
                [overflowName]: 'hidden'
            },
            {
                [sizeName]: toSize,
                offset: 0.9999,
                [overflowName]: 'hidden'
            },
            {
                [sizeName]: 'unset',
                [overflowName]: 'unset'
            }
        ],
        duration: duration,
        easing: easing,
        delay: delay,
        fill: 'both'
    };
};
const $48e1ce8583f703eb$export$9a36e7b5bbee5ff5 = ({ orientation: orientation, duration: duration, easing: easing, element: element, delay: delay = 0, outSize: outSize = '0' })=>{
    const { sizeName: sizeName, overflowName: overflowName, toSize: toSize } = $48e1ce8583f703eb$var$sizeValuesForOrientation(orientation, element);
    return {
        keyframes: [
            {
                [sizeName]: toSize,
                [overflowName]: 'hidden'
            },
            {
                [sizeName]: outSize,
                [overflowName]: 'hidden'
            }
        ],
        duration: duration,
        easing: easing,
        delay: delay,
        fill: 'both'
    };
};
// ----- WHITESPACE -----
// Whitespace animation includes padding and margin.
const $48e1ce8583f703eb$var$whitespaceValuesForOrientation = (orientation)=>{
    // horizontal whitespace collapse
    if (orientation === 'horizontal') return {
        paddingStart: 'paddingInlineStart',
        paddingEnd: 'paddingInlineEnd',
        marginStart: 'marginInlineStart',
        marginEnd: 'marginInlineEnd'
    };
    // vertical whitespace collapse
    return {
        paddingStart: 'paddingBlockStart',
        paddingEnd: 'paddingBlockEnd',
        marginStart: 'marginBlockStart',
        marginEnd: 'marginBlockEnd'
    };
};
const $48e1ce8583f703eb$export$3b3635aa87675d0d = ({ direction: direction, orientation: orientation, duration: duration, easing: easing, delay: delay = 0 })=>{
    const { paddingStart: paddingStart, paddingEnd: paddingEnd, marginStart: marginStart, marginEnd: marginEnd } = $48e1ce8583f703eb$var$whitespaceValuesForOrientation(orientation);
    // The keyframe with zero whitespace is at the start for enter and at the end for exit.
    const offset = direction === 'enter' ? 0 : 1;
    const keyframes = [
        {
            [paddingStart]: '0',
            [paddingEnd]: '0',
            [marginStart]: '0',
            [marginEnd]: '0',
            offset: offset
        }
    ];
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay,
        fill: 'both'
    };
};



/**
 * Define a presence motion for collapse/expand
 *
 * @param element - The element to apply the collapse motion to
 * @param duration - Time (ms) for the enter transition (expand). Defaults to the `durationNormal` value (200 ms)
 * @param easing - Easing curve for the enter transition. Defaults to the `curveEasyEaseMax` value
 * @param delay - Time (ms) to delay the entire enter transition. Defaults to 0
 * @param exitDuration - Time (ms) for the exit transition (collapse). Defaults to the `duration` param for symmetry
 * @param exitEasing - Easing curve for the exit transition. Defaults to the `easing` param for symmetry
 * @param exitDelay - Time (ms) to delay the entire exit transition. Defaults to the `delay` param for symmetry
 * @param staggerDelay - Time (ms) offset between the size and opacity animations. Defaults to 0
 * @param exitStaggerDelay - Time (ms) offset between the size and opacity animations on exit. Defaults to the `staggerDelay` param for symmetry
 * @param sizeDuration - Time (ms) for the size animation during enter. Defaults to `duration` for unified timing
 * @param opacityDuration - Time (ms) for the opacity animation during enter. Defaults to `sizeDuration` for synchronized timing
 * @param exitSizeDuration - Time (ms) for the size animation during exit. Defaults to `exitDuration` for unified timing
 * @param exitOpacityDuration - Time (ms) for the opacity animation during exit. Defaults to `exitSizeDuration` for synchronized timing
 * @param animateOpacity - Whether to animate the opacity. Defaults to `true`
 * @param orientation - The orientation of the size animation. Defaults to `'vertical'` to expand/collapse the height
 * @param outSize - Size for the out state (collapsed). Defaults to `'0px'`
 */ const $85feb5ea7b36a380$var$collapsePresenceFn = ({ element: element, duration: duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal, exitDuration: exitDuration = duration, sizeDuration: sizeDuration = duration, opacityDuration: opacityDuration = sizeDuration, exitSizeDuration: exitSizeDuration = exitDuration, exitOpacityDuration: exitOpacityDuration = exitSizeDuration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveEasyEaseMax, delay: delay = 0, exitEasing: exitEasing = easing, exitDelay: exitDelay = delay, staggerDelay: staggerDelay = 0, exitStaggerDelay: exitStaggerDelay = staggerDelay, animateOpacity: animateOpacity = true, orientation: orientation = 'vertical', outSize: outSize = '0px' })=>{
    // ----- ENTER -----
    // The enter transition is an array of up to 3 motion atoms: size, whitespace and opacity.
    // For enter: size expands first, then opacity fades in after staggerDelay
    const enterAtoms = [
        // Apply global delay to size atom - size expansion starts first
        (0, $48e1ce8583f703eb$export$9efcac9cfdb79785)({
            orientation: orientation,
            duration: sizeDuration,
            easing: easing,
            element: element,
            outSize: outSize,
            delay: delay
        }),
        (0, $48e1ce8583f703eb$export$3b3635aa87675d0d)({
            direction: 'enter',
            orientation: orientation,
            duration: sizeDuration,
            easing: easing,
            delay: delay
        })
    ];
    // Fade in only if animateOpacity is true. Otherwise, leave opacity unaffected.
    if (animateOpacity) enterAtoms.push((0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
        direction: 'enter',
        duration: opacityDuration,
        easing: easing,
        delay: delay + staggerDelay
    }));
    // ----- EXIT -----
    // The exit transition is an array of up to 3 motion atoms: opacity, size and whitespace.
    // For exit: opacity fades out first, then size collapses after exitStaggerDelay
    const exitAtoms = [];
    // Fade out only if animateOpacity is true. Otherwise, leave opacity unaffected.
    if (animateOpacity) exitAtoms.push((0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
        direction: 'exit',
        duration: exitOpacityDuration,
        easing: exitEasing,
        delay: exitDelay
    }));
    exitAtoms.push((0, $48e1ce8583f703eb$export$9a36e7b5bbee5ff5)({
        orientation: orientation,
        duration: exitSizeDuration,
        easing: exitEasing,
        element: element,
        delay: exitDelay + exitStaggerDelay,
        outSize: outSize
    }), (0, $48e1ce8583f703eb$export$3b3635aa87675d0d)({
        direction: 'exit',
        orientation: orientation,
        duration: exitSizeDuration,
        easing: exitEasing,
        delay: exitDelay + exitStaggerDelay
    }));
    return {
        enter: enterAtoms,
        exit: exitAtoms
    };
};
const $85feb5ea7b36a380$export$78768a9af065a7b = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)($85feb5ea7b36a380$var$collapsePresenceFn);
const $85feb5ea7b36a380$export$ef78c5d8b27bdd6b = (0, $e67c3d746f23a482$export$2911c0c000be902b)($85feb5ea7b36a380$export$78768a9af065a7b, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationFast
});
const $85feb5ea7b36a380$export$228873a5ef1a7be5 = (0, $e67c3d746f23a482$export$2911c0c000be902b)($85feb5ea7b36a380$export$78768a9af065a7b, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower
});
const $85feb5ea7b36a380$export$5bf7d0a6cecd5c40 = (0, $e67c3d746f23a482$export$2911c0c000be902b)($85feb5ea7b36a380$export$78768a9af065a7b, {
    // Enter timing per motion design spec
    sizeDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal,
    opacityDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower,
    staggerDelay: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal,
    // Exit timing per motion design spec
    exitSizeDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal,
    exitOpacityDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower,
    exitStaggerDelay: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower,
    // Easing per motion design spec
    easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveEasyEase,
    exitEasing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveEasyEase
});


'use client';
const $5801df5a1029ec77$export$29718ee1499adfee = (state, contextValues)=>{
    const { onMotionFinish: onMotionFinish, visible: visible, updateId: updateId } = state;
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $060a05566cf52703$export$16fde41fae5e5972), {
        value: contextValues.toast,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $85feb5ea7b36a380$export$5bf7d0a6cecd5c40), {
            appear: true,
            onMotionFinish: onMotionFinish,
            visible: visible,
            unmountOnExit: true,
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
                children: [
                    state.root.children,
                    /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.timer, {}, updateId)
                ]
            })
        })
    });
};





'use client';
const $d78bc0bced892066$export$398ad7b521644d4c = {
    root: 'fui-ToastContainer',
    timer: 'fui-ToastContainer__timer'
};
const $d78bc0bced892066$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r98b696", null, [
    ".r98b696{box-sizing:border-box;margin-top:16px;pointer-events:all;border-radius:var(--borderRadiusMedium);}",
    ".r98b696[data-fui-focus-visible]{outline:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}"
]);
const $d78bc0bced892066$export$e43143d70c48dbb9 = (state)=>{
    const rootBaseClassName = $d78bc0bced892066$var$useRootBaseClassName();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($d78bc0bced892066$export$398ad7b521644d4c.root, rootBaseClassName, state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $d5307d68f77f88d9$export$ebc31ba063e4c4c7(state) {
    const { close: close, intent: intent, titleId: titleId, bodyId: bodyId } = state;
    const toastContainerContext = $acw62.useMemo(()=>({
            close: close,
            intent: intent,
            titleId: titleId,
            bodyId: bodyId
        }), [
        close,
        intent,
        titleId,
        bodyId
    ]);
    return {
        toast: toastContainerContext
    };
}



'use client';
const $0681b27390e89b8e$export$f2815235e76a62b9 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $b2b1d0de9919074f$export$733e9d8cbe4cbf36)(props, ref);
    (0, $d78bc0bced892066$export$e43143d70c48dbb9)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useToastContainerStyles_unstable')(state);
    return (0, $5801df5a1029ec77$export$29718ee1499adfee)(state, (0, $d5307d68f77f88d9$export$ebc31ba063e4c4c7)(state));
});
$0681b27390e89b8e$export$f2815235e76a62b9.displayName = 'ToastContainer';




var $acw62 = parcelRequire("acw62");



'use client';
const $219c741007cd2a00$var$noop = ()=>undefined;
function $219c741007cd2a00$export$895ad4d51a9e28c3(pauseAllToasts, playAllToasts) {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const cleanupListenersRef = $acw62.useRef($219c741007cd2a00$var$noop);
    return $acw62.useCallback((el)=>{
        if (!el || !targetDocument) {
            cleanupListenersRef.current();
            cleanupListenersRef.current = $219c741007cd2a00$var$noop;
            return;
        }
        const toastContainerWalker = targetDocument.createTreeWalker(el, NodeFilter.SHOW_ELEMENT, {
            acceptNode (node) {
                if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(node) && node.classList.contains((0, $d78bc0bced892066$export$398ad7b521644d4c).root)) return NodeFilter.FILTER_ACCEPT;
                return NodeFilter.FILTER_SKIP;
            }
        });
        /**
       * FIXME: https://github.com/microsoft/tabster/issues/299
       * Toasts  should be arrow navigable and focus should be trapped in a stack of tasts
       * This is a temporary measure, Tabster does not have an API yet to enable mover arrow keys from within grouppers
       * Once tabster fully supports this use case, remove this hook
       */ const keydownListener = (e)=>{
            const { target: target, key: key } = e;
            if (!(0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(target)) return;
            if (key === (0, $c823d65ebf8ac0ff$export$1fa5a43af950a186)) {
                toastContainerWalker.currentNode = target;
                let nextToastContainer = toastContainerWalker.nextNode();
                if (!nextToastContainer) {
                    toastContainerWalker.currentNode = el;
                    nextToastContainer = toastContainerWalker.nextNode();
                }
                if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(nextToastContainer)) nextToastContainer.focus();
            }
            if (key === (0, $c823d65ebf8ac0ff$export$2624c5890f1bbcf7)) {
                toastContainerWalker.currentNode = target;
                let prevToastContainer = toastContainerWalker.previousNode();
                if (prevToastContainer && prevToastContainer.contains(target)) prevToastContainer = toastContainerWalker.previousNode();
                if (!prevToastContainer) {
                    toastContainerWalker.currentNode = el;
                    prevToastContainer = toastContainerWalker.lastChild();
                }
                if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(prevToastContainer)) prevToastContainer.focus();
            }
        };
        const focusInListener = (e)=>{
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.currentTarget) && !e.currentTarget.contains((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.relatedTarget) ? e.relatedTarget : null)) pauseAllToasts();
        };
        const focusOutListener = (e)=>{
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.currentTarget) && !e.currentTarget.contains((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.relatedTarget) ? e.relatedTarget : null)) playAllToasts();
        };
        el.addEventListener('keydown', keydownListener);
        el.addEventListener('focusin', focusInListener);
        el.addEventListener('focusout', focusOutListener);
        cleanupListenersRef.current = ()=>{
            el.removeEventListener('keydown', keydownListener);
            el.removeEventListener('focusin', focusInListener);
            el.removeEventListener('focusout', focusOutListener);
        };
    }, [
        targetDocument,
        pauseAllToasts,
        playAllToasts
    ]);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $b22b9e037ab63a6c$export$1c531128a3825f89(announce) {
    const activeRef = $acw62.useRef(true);
    const cleanupRef = $acw62.useRef(()=>undefined);
    const announceToast = $acw62.useCallback((message, options)=>{
        if (activeRef.current) announce(message, options);
    }, [
        announce
    ]);
    const toasterRef = $acw62.useCallback((el)=>{
        if (!el) {
            cleanupRef.current();
            return;
        }
        const onFocusIn = (e)=>{
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.currentTarget) && e.currentTarget.contains((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.relatedTarget) ? e.relatedTarget : null)) return;
            activeRef.current = false;
        };
        const onFocusOut = (e)=>{
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.currentTarget) && e.currentTarget.contains((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.relatedTarget) ? e.relatedTarget : null)) return;
            activeRef.current = true;
        };
        el.addEventListener('focusin', onFocusIn);
        el.addEventListener('focusout', onFocusOut);
        cleanupRef.current = ()=>{
            el.removeEventListener('focusin', onFocusIn);
            el.removeEventListener('focusout', onFocusOut);
        };
    }, []);
    return {
        announceToast: announceToast,
        toasterRef: toasterRef
    };
}


'use client';
const $e5cee8134e45e22a$export$20e7b14125c25fa4 = (props)=>{
    const { offset: offset, announce: announceProp, mountNode: mountNode, inline: inline = false, ...rest } = props;
    const announceRef = $acw62.useRef(()=>null);
    const { toastsToRender: toastsToRender, isToastVisible: isToastVisible, pauseAllToasts: pauseAllToasts, playAllToasts: playAllToasts, tryRestoreFocus: tryRestoreFocus, closeAllToasts: closeAllToasts } = (0, $49f2ed1a8ab871ef$export$f46171b59bb094f9)(rest);
    const announce = $acw62.useCallback((message, options)=>announceRef.current(message, options), []);
    const { dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const { onKeyDown: onKeyDownProp, ...rootProps } = (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', rest), {
        elementType: 'div'
    });
    const focusableGroupAttr = (0, $3a1d6c4ac0998739$export$7cdad6852d2f5fdf)({
        tabBehavior: 'limited-trap-focus',
        ignoreDefaultKeydown: {
            Escape: true
        }
    });
    const onKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        if (e.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685)) {
            e.preventDefault();
            closeAllToasts();
        }
        onKeyDownProp === null || onKeyDownProp === void 0 || onKeyDownProp(e);
    });
    const usePositionSlot = (toastPosition)=>{
        var _toastsToRender_get;
        const focusManagementRef = (0, $219c741007cd2a00$export$895ad4d51a9e28c3)(pauseAllToasts, playAllToasts);
        const { announceToast: announceToast, toasterRef: toasterRef } = (0, $b22b9e037ab63a6c$export$1c531128a3825f89)(announceProp !== null && announceProp !== void 0 ? announceProp : announce);
        return (0, $fcf7ddccaab7fd8f$exports).optional(toastsToRender.has(toastPosition) ? rootProps : null, {
            defaultProps: {
                ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(focusManagementRef, toasterRef),
                children: (_toastsToRender_get = toastsToRender.get(toastPosition)) === null || _toastsToRender_get === void 0 ? void 0 : _toastsToRender_get.map((toast)=>/*#__PURE__*/ $acw62.createElement((0, $0681b27390e89b8e$export$f2815235e76a62b9), {
                        ...toast,
                        tryRestoreFocus: tryRestoreFocus,
                        intent: toast.intent,
                        announce: announceToast,
                        key: toast.toastId,
                        visible: isToastVisible(toast.toastId)
                    }, toast.content)),
                onKeyDown: onKeyDown,
                ...focusableGroupAttr,
                'data-toaster-position': toastPosition,
                role: 'list'
            },
            elementType: 'div'
        });
    };
    return {
        dir: dir,
        mountNode: mountNode,
        components: {
            root: 'div',
            bottomStart: 'div',
            bottomEnd: 'div',
            topStart: 'div',
            topEnd: 'div',
            top: 'div',
            bottom: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always(rootProps, {
            elementType: 'div'
        }),
        bottomStart: usePositionSlot((0, $2d233013a30c9870$export$b243a64c42cb66cc).bottomStart),
        bottomEnd: usePositionSlot((0, $2d233013a30c9870$export$b243a64c42cb66cc).bottomEnd),
        topStart: usePositionSlot((0, $2d233013a30c9870$export$b243a64c42cb66cc).topStart),
        topEnd: usePositionSlot((0, $2d233013a30c9870$export$b243a64c42cb66cc).topEnd),
        top: usePositionSlot((0, $2d233013a30c9870$export$b243a64c42cb66cc).top),
        bottom: usePositionSlot((0, $2d233013a30c9870$export$b243a64c42cb66cc).bottom),
        announceRef: announceRef,
        offset: offset,
        announce: announceProp !== null && announceProp !== void 0 ? announceProp : announce,
        renderAriaLive: !announceProp,
        inline: inline
    };
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

'use client';
/** The duration the message needs to be in present in DOM for screen readers to register a change and announce */ const $597490590bb24a7e$var$MESSAGE_DURATION = 500;
const $597490590bb24a7e$export$353463fc678b2bd8 = (props)=>{
    const [currentMessage, setCurrentMessage] = $acw62.useState(undefined);
    // Can't rely on Date.now() if user invokes announce more than once in a code block
    const order = $acw62.useRef(0);
    const [messageQueue] = $acw62.useState(()=>(0, $120da7eaa95fb331$export$502825a17c61545f)((a, b)=>{
            if (a.politeness === b.politeness) return a.createdAt - b.createdAt;
            return a.politeness === 'assertive' ? -1 : 1;
        }));
    const announce = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((message, options)=>{
        const { politeness: politeness } = options;
        if (message === (currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.message)) return;
        const liveMessage = {
            message: message,
            politeness: politeness,
            createdAt: order.current++
        };
        if (!currentMessage) setCurrentMessage(liveMessage);
        else messageQueue.enqueue(liveMessage);
    });
    const [setMessageTimeout, clearMessageTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    $acw62.useEffect(()=>{
        setMessageTimeout(()=>{
            if (messageQueue.peek()) setCurrentMessage(messageQueue.dequeue());
            else setCurrentMessage(undefined);
        }, $597490590bb24a7e$var$MESSAGE_DURATION);
        return ()=>clearMessageTimeout();
    }, [
        currentMessage,
        messageQueue,
        setMessageTimeout,
        clearMessageTimeout
    ]);
    $acw62.useImperativeHandle(props.announceRef, ()=>announce);
    const politeMessage = (currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.politeness) === 'polite' ? currentMessage.message : undefined;
    const assertiveMessage = (currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.politeness) === 'assertive' ? currentMessage.message : undefined;
    return {
        components: {
            assertive: 'div',
            polite: 'div'
        },
        assertive: (0, $fcf7ddccaab7fd8f$exports).always(props.assertive, {
            defaultProps: {
                'aria-live': 'assertive',
                children: assertiveMessage
            },
            elementType: 'div'
        }),
        polite: (0, $fcf7ddccaab7fd8f$exports).always(props.polite, {
            defaultProps: {
                'aria-live': 'polite',
                children: politeMessage
            },
            elementType: 'div'
        })
    };
};



var $acw62 = parcelRequire("acw62");

const $d1bd32204abb2e6e$export$23826f1c679b87c2 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.assertive, {}),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.polite, {})
        ]
    });
};



'use client';
const $567ab37ee8047496$export$912abc7724c33759 = {
    assertive: 'fui-AriaLive__assertive',
    polite: 'fui-AriaLive__polite'
};
/**
 * Styles for the root slot
 */ const $567ab37ee8047496$var$useResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rrd10u0", null, [
    ".rrd10u0{clip:rect(0px, 0px, 0px, 0px);height:1px;margin:-1px;overflow:hidden;padding:0px;width:1px;position:absolute;}"
]);
const $567ab37ee8047496$export$87403fb71a143126 = (state)=>{
    const visuallyHidden = $567ab37ee8047496$var$useResetStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.assertive.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(visuallyHidden, $567ab37ee8047496$export$912abc7724c33759.assertive, state.assertive.className);
    // eslint-disable-next-line react-hooks/immutability
    state.polite.className = (0, $00898283de415a49$export$3d46f4579dba46e5)(visuallyHidden, $567ab37ee8047496$export$912abc7724c33759.polite, state.polite.className);
    return state;
};


'use client';
const $8722304d3a7e124f$export$837a384311881d49 = (props)=>{
    const state = (0, $597490590bb24a7e$export$353463fc678b2bd8)(props);
    (0, $567ab37ee8047496$export$87403fb71a143126)(state);
    return (0, $d1bd32204abb2e6e$export$23826f1c679b87c2)(state);
};
$8722304d3a7e124f$export$837a384311881d49.displayName = 'AriaLive';


const $0e5164b2111aff49$export$43e521c55baaabd0 = (state)=>{
    const { announceRef: announceRef, renderAriaLive: renderAriaLive, inline: inline, mountNode: mountNode } = state;
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const hasToasts = !!state.bottomStart || !!state.bottomEnd || !!state.topStart || !!state.topEnd || !!state.top || !!state.bottom;
    const ariaLive = renderAriaLive ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $8722304d3a7e124f$export$837a384311881d49), {
        announceRef: announceRef
    }) : null;
    const positionSlots = /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            state.bottom ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.bottom, {}) : null,
            state.bottomStart ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.bottomStart, {}) : null,
            state.bottomEnd ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.bottomEnd, {}) : null,
            state.topStart ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.topStart, {}) : null,
            state.topEnd ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.topEnd, {}) : null,
            state.top ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.top, {}) : null
        ]
    });
    if (inline) return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            ariaLive,
            hasToasts ? positionSlots : null
        ]
    });
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            ariaLive,
            hasToasts ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $aa8a2d30f790b072$export$602eac185826482c), {
                mountNode: mountNode,
                children: positionSlots
            }) : null
        ]
    });
};



const $e88f6421d0348682$export$a5b21f38d58b1de0 = (position, dir, offset)=>{
    const positionStyles = {};
    var _offset_position;
    const offsetStyles = offset ? $e88f6421d0348682$var$isShorthandOffset(offset) ? offset : (_offset_position = offset[position]) !== null && _offset_position !== void 0 ? _offset_position : {} : {};
    const centered = position === 'top' || position === 'bottom';
    const { horizontal: horizontal = centered ? 0 : 20, vertical: vertical = 16 } = offsetStyles;
    const start = dir === 'ltr' ? 'left' : 'right';
    const end = dir === 'ltr' ? 'right' : 'left';
    switch(position){
        case 'top':
            Object.assign(positionStyles, {
                top: vertical,
                left: `calc(50% + ${horizontal}px)`,
                transform: 'translateX(-50%)'
            });
            break;
        case 'bottom':
            Object.assign(positionStyles, {
                bottom: vertical,
                left: `calc(50% + ${horizontal}px)`,
                transform: 'translateX(-50%)'
            });
            break;
        case 'top-start':
            Object.assign(positionStyles, {
                top: vertical,
                [start]: horizontal
            });
            break;
        case 'top-end':
            Object.assign(positionStyles, {
                top: vertical,
                [end]: horizontal
            });
            break;
        case 'bottom-start':
            Object.assign(positionStyles, {
                bottom: vertical,
                [start]: horizontal
            });
            break;
        case 'bottom-end':
            Object.assign(positionStyles, {
                bottom: vertical,
                [end]: horizontal
            });
            break;
    }
    return positionStyles;
};
function $e88f6421d0348682$var$isShorthandOffset(offset) {
    return 'horizontal' in offset || 'vertical' in offset;
}


'use client';
const $179d9d58e276d363$export$cd74a4809efb6692 = {
    root: 'fui-Toaster'
};
/**
 * Styles for the root slot
 */ const $179d9d58e276d363$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r3hfdjz", null, [
    ".r3hfdjz{position:fixed;width:292px;pointer-events:none;}"
]);
const $179d9d58e276d363$var$useToasterStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    inline: {
        qhf8xq: "f1euv43f"
    }
}, {
    d: [
        ".f1euv43f{position:absolute;}"
    ]
});
const $179d9d58e276d363$export$58f375b8a886f550 = (state)=>{
    const rootBaseClassName = $179d9d58e276d363$var$useRootBaseClassName();
    const styles = $179d9d58e276d363$var$useToasterStyles();
    const className = (0, $00898283de415a49$export$3d46f4579dba46e5)($179d9d58e276d363$export$cd74a4809efb6692.root, rootBaseClassName, state.inline && styles.inline, state.root.className);
    if (state.bottomStart) {
        var _state_bottomStart;
        // eslint-disable-next-line react-hooks/immutability
        state.bottomStart.className = className;
        var _style;
        (_style = (_state_bottomStart = state.bottomStart).style) !== null && _style !== void 0 ? _style : _state_bottomStart.style = {};
        Object.assign(state.bottomStart.style, (0, $e88f6421d0348682$export$a5b21f38d58b1de0)((0, $2d233013a30c9870$export$b243a64c42cb66cc).bottomStart, state.dir, state.offset));
    }
    if (state.bottomEnd) {
        var _state_bottomEnd;
        // eslint-disable-next-line react-hooks/immutability
        state.bottomEnd.className = className;
        var _style1;
        (_style1 = (_state_bottomEnd = state.bottomEnd).style) !== null && _style1 !== void 0 ? _style1 : _state_bottomEnd.style = {};
        Object.assign(state.bottomEnd.style, (0, $e88f6421d0348682$export$a5b21f38d58b1de0)((0, $2d233013a30c9870$export$b243a64c42cb66cc).bottomEnd, state.dir, state.offset));
    }
    if (state.topStart) {
        var _state_topStart;
        // eslint-disable-next-line react-hooks/immutability
        state.topStart.className = className;
        var _style2;
        (_style2 = (_state_topStart = state.topStart).style) !== null && _style2 !== void 0 ? _style2 : _state_topStart.style = {};
        Object.assign(state.topStart.style, (0, $e88f6421d0348682$export$a5b21f38d58b1de0)((0, $2d233013a30c9870$export$b243a64c42cb66cc).topStart, state.dir, state.offset));
    }
    if (state.topEnd) {
        var _state_topEnd;
        // eslint-disable-next-line react-hooks/immutability
        state.topEnd.className = className;
        var _style3;
        (_style3 = (_state_topEnd = state.topEnd).style) !== null && _style3 !== void 0 ? _style3 : _state_topEnd.style = {};
        Object.assign(state.topEnd.style, (0, $e88f6421d0348682$export$a5b21f38d58b1de0)((0, $2d233013a30c9870$export$b243a64c42cb66cc).topEnd, state.dir, state.offset));
    }
    if (state.top) {
        var _state_top;
        // eslint-disable-next-line react-hooks/immutability
        state.top.className = className;
        var _style4;
        (_style4 = (_state_top = state.top).style) !== null && _style4 !== void 0 ? _style4 : _state_top.style = {};
        Object.assign(state.top.style, (0, $e88f6421d0348682$export$a5b21f38d58b1de0)((0, $2d233013a30c9870$export$b243a64c42cb66cc).top, state.dir, state.offset));
    }
    if (state.bottom) {
        var _state_bottom;
        // eslint-disable-next-line react-hooks/immutability
        state.bottom.className = className;
        var _style5;
        (_style5 = (_state_bottom = state.bottom).style) !== null && _style5 !== void 0 ? _style5 : _state_bottom.style = {};
        Object.assign(state.bottom.style, (0, $e88f6421d0348682$export$a5b21f38d58b1de0)((0, $2d233013a30c9870$export$b243a64c42cb66cc).bottom, state.dir, state.offset));
    }
    return state;
};


'use client';
const $a4c75e7371e2afd4$export$fb98e3a2a4cd92d7 = (props)=>{
    const state = (0, $e5cee8134e45e22a$export$20e7b14125c25fa4)(props);
    (0, $179d9d58e276d363$export$58f375b8a886f550)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useToasterStyles_unstable')(state);
    return (0, $0e5164b2111aff49$export$43e521c55baaabd0)(state);
};
$a4c75e7371e2afd4$export$fb98e3a2a4cd92d7.displayName = 'Toaster';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const $eb093920387c7bf0$export$d66948800c441683 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCatFilled', "1em", [
    "M4.97 18H13v-1.5a2.5 2.5 0 0 0-2.5-2.5h-1a.5.5 0 0 1 0-1h1a3.5 3.5 0 0 1 3.5 3.5V18h.25c.47 0 .9-.2 1.21-.5h.04v-.04q.45-.47.47-1.18v-7.6a2.12 2.12 0 0 0 1.7-3.24l-.5-.81c-.38-.63-1.06-1-1.8-1h-1.43v-.64a1 1 0 0 0-.99-.99 2.45 2.45 0 0 0-2.44 2.45V7.9a4.3 4.3 0 0 0-2.95 1.58 7 7 0 0 0-1.04 1.8q-.35.7-.47 1.49l-.01.06A17 17 0 0 0 5.63 17h-.66a1.97 1.97 0 0 1-1.44-3.32l.92-.98a3.6 3.6 0 0 0-.09-4.99l-.9-.9a.5.5 0 1 0-.7.7l.9.9a2.6 2.6 0 0 1 .06 3.6l-.92 1A2.97 2.97 0 0 0 4.97 18"
]);
const $eb093920387c7bf0$export$1d2b671745fba022 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCatRegular', "1em", [
    "M4.97 18h9.28c.95 0 1.72-.77 1.72-1.72v-7.6a2.12 2.12 0 0 0 1.7-3.24l-.5-.81c-.38-.63-1.06-1-1.8-1h-1.43v-.64a1 1 0 0 0-.99-.99 2.45 2.45 0 0 0-2.44 2.45V7.9a4.3 4.3 0 0 0-2.95 1.58 8 8 0 0 0-1.52 3.35A17 17 0 0 0 5.63 17h-.66a1.97 1.97 0 0 1-1.44-3.32l.92-.98a3.6 3.6 0 0 0-.09-4.99l-.9-.9a.5.5 0 1 0-.7.7l.9.9a2.6 2.6 0 0 1 .06 3.6l-.92 1A2.97 2.97 0 0 0 4.97 18m7.97-15v1.12c0 .28.22.5.5.5h1.93c.4 0 .75.2.96.53l.5.81c.46.75-.08 1.72-.95 1.72h-.41a.5.5 0 0 0-.5.5v8.1c0 .4-.32.72-.72.72h-.72v-.72a2.93 2.93 0 0 0-2.93-2.93H9.6a.5.5 0 0 0 0 1h1.01c1.07 0 1.93.87 1.93 1.93V17h-5.9A18 18 0 0 1 7 13.05c.26-1.1.67-2.16 1.32-2.93A3.3 3.3 0 0 1 11 8.88a.5.5 0 0 0 .5-.5V4.45c0-.8.64-1.44 1.43-1.45"
]);
const $eb093920387c7bf0$export$d85a06e975b73949 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDogFilled', "1em", [
    "M12 2c-.33 0-.81.1-1.23.4-.44.31-.77.84-.77 1.6v1.25c0 .13.04.34.16.5.09.12.25.25.59.25s.5-.13.6-.26a1 1 0 0 0 .15-.49.5.5 0 1 1 1 0c0 .3-.08.71-.35 1.08-.28.39-.74.67-1.4.67q-.49 0-.82-.18a6.5 6.5 0 0 1-1.78 3.83 7.5 7.5 0 0 0-1.89 3.48A9 9 0 0 0 6 15.95v.08a1 1 0 0 1-.13.5 1 1 0 0 1-.28.32q-.17.13-.59.15a2 2 0 0 1-1.2-3.6.5.5 0 1 0-.6-.8A3 3 0 0 0 5 18h8v-.5c0-.4-.19-1.05-.73-1.33q-.28-.16-.77-.17h-1a.5.5 0 0 1 0-1h1q.26 0 .5.04V12.5a.5.5 0 0 1 1 0v2.95c.79.57 1 1.52 1 2.05v.5h2.5a.5.5 0 0 0 .5-.5c0-.87-.3-1.52-.8-1.95q-.55-.43-1.2-.51V7h.5c.83 0 1.5-.67 1.5-1.5V4.28a1 1 0 0 0-.49-.85l-1.78-1.07A2.5 2.5 0 0 0 13.45 2z"
]);
const $eb093920387c7bf0$export$9fac7447cd1e5324 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDogRegular', "1em", [
    "M10.77 2.4c.42-.3.9-.4 1.23-.4h1.45q.7 0 1.28.36l1.78 1.07c.3.18.49.5.49.85V5.5c0 .83-.67 1.5-1.5 1.5H15v8.04q.64.08 1.2.51c.5.43.8 1.08.8 1.95a.5.5 0 0 1-.5.5H5a3 3 0 0 1-1.8-5.4.5.5 0 0 1 .6.8A2 2 0 0 0 5 17q.42-.02.59-.15.18-.13.28-.32A1 1 0 0 0 6 16v-.05l.03-.5c.04-.33.1-.8.23-1.32.27-1.05.8-2.4 1.89-3.48C9.99 8.8 10 6.33 10 5.5V4c0-.76.33-1.29.77-1.6m.15 4.5a7.5 7.5 0 0 1-2.07 4.45 6.5 6.5 0 0 0-1.61 3.02 8 8 0 0 0-.24 1.6v.06l-.03.29a2 2 0 0 1-.22.68h6.17c-.1-.32-.3-.65-.65-.83q-.28-.16-.77-.17h-1a.5.5 0 0 1 0-1h1q.26 0 .5.04V12.5a.5.5 0 0 1 1 0v2.95c.58.42.85 1.04.95 1.55h2a1.2 1.2 0 0 0-.4-.68A1.6 1.6 0 0 0 14.5 16a.5.5 0 0 1-.5-.5v-9c0-.28.22-.5.5-.5h1a.5.5 0 0 0 .5-.5V4.28l-1.78-1.07a1.5 1.5 0 0 0-.77-.21H12c-.17 0-.44.06-.65.2-.18.14-.35.36-.35.8v1.5c0 .09.03.23.1.33.06.08.16.17.4.17s.34-.09.4-.17c.07-.1.1-.24.1-.33a.5.5 0 0 1 1 0c0 .25-.07.6-.3.92-.24.33-.64.58-1.2.58q-.32 0-.58-.1M7 16h-.5Z"
]);
const $eb093920387c7bf0$export$29f1ef82c246b5a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrintColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_20_color__a)",
            "fillRule": "evenodd",
            "d": "M4 14a6 6 0 0 1 12 0c0 .99-.5 1.75-1.21 2.25-.7.5-1.6.75-2.48.75H7.69c-.88 0-1.78-.25-2.48-.75A2.7 2.7 0 0 1 4 14",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_20_color__b)",
            "fillRule": "evenodd",
            "d": "M5.5 4.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M3 4.5c-1.17 0-2 1.08-2 2.25S1.83 9 3 9s2-1.08 2-2.25S4.17 4.5 3 4.5m12 2.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25m-4.5-2.5c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -9 14.4 0 10.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_20_color__a",
                "x1": "6.85",
                "x2": "10.78",
                "y1": "9.2",
                "y2": "17.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$26f34026595f324e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrintFilled', "1em", [
    "M5.5 4.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M3 4.5c-1.17 0-2 1.08-2 2.25S1.83 9 3 9s2-1.08 2-2.25S4.17 4.5 3 4.5m12 2.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25m-4.5-2.5c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M4 14a6 6 0 0 1 12 0c0 .99-.5 1.75-1.21 2.25-.7.5-1.6.75-2.48.75H7.69c-.88 0-1.78-.25-2.48-.75A2.7 2.7 0 0 1 4 14"
]);
const $eb093920387c7bf0$export$bc507fe403cbef55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrintRegular', "1em", [
    "M6.5 4.25c0-.77.52-1.25 1-1.25s1 .48 1 1.25-.52 1.25-1 1.25-1-.48-1-1.25M7.5 2c-1.17 0-2 1.08-2 2.25s.83 2.25 2 2.25 2-1.08 2-2.25S8.67 2 7.5 2M3 5.5c-.48 0-1 .48-1 1.25S2.52 8 3 8s1-.48 1-1.25S3.48 5.5 3 5.5M1 6.75c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S4.17 9 3 9 1 7.92 1 6.75M17 5.5c-.48 0-1 .48-1 1.25S16.52 8 17 8s1-.48 1-1.25-.52-1.25-1-1.25m-2 1.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25M12.5 3c-.48 0-1 .48-1 1.25s.52 1.25 1 1.25 1-.48 1-1.25S12.98 3 12.5 3m-2 1.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M5 14a5 5 0 0 1 10 0c0 .6-.3 1.09-.79 1.44-.5.36-1.2.56-1.9.56H7.69c-.7 0-1.4-.2-1.9-.56Q5.02 14.91 5 14m5-6a6 6 0 0 0-6 6c0 .99.5 1.75 1.21 2.25.7.5 1.6.75 2.48.75h4.62c.88 0 1.78-.25 2.48-.75S16 15 16 14a6 6 0 0 0-6-6"
]);
const $eb093920387c7bf0$export$78efb7d7fecac0e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitFilled', "1em", [
    "m12.68 4.38 4.23 4.23a2.78 2.78 0 0 1-2.6 4.67v.16c0 .86-.7 1.56-1.57 1.56H11v-1.25c0-.54-.28-.98-.67-1.28-.38-.3-.9-.47-1.43-.47H7.5a.5.5 0 1 0 0 1h1.4q.5.01.82.26.29.24.28.49V15H5.56C4.7 15 4 14.3 4 13.44v-2.21A2.12 2.12 0 1 1 6.05 8.3Q6.73 8 7.52 8h3.28q.71.01 1.33.26l.08-.13c.11-.19.23-.4.38-.55l-1.55-1.56a1.16 1.16 0 1 1 1.64-1.64"
]);
const $eb093920387c7bf0$export$ff1c1e349f9ea16d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitRegular', "1em", [
    "M10.51 15.01h2.12c.91 0 1.68-.57 1.99-1.37.88.07 1.79-.23 2.46-.9a3.15 3.15 0 0 0 0-4.45l-4.22-4.22c-.59-.59-1.55-.59-2.14 0-.6.6-.6 1.56 0 2.15l1.34 1.33q-.18.24-.3.5a4 4 0 0 0-.54-.05H7.54q-.5 0-.95.13A2.5 2.5 0 1 0 4 11.95v.93c0 1.18.95 2.13 2.12 2.13zm1.64-10.23L16.38 9a2.15 2.15 0 0 1-2 3.6l-.56-.13-.06.56c-.07.56-.54.99-1.12.99h-1.62v-.1C11 12.78 9.99 12 8.89 12H7.5a.5.5 0 0 0 0 1h1.39c.69 0 1.12.46 1.12.91v.1H6.12c-.62 0-1.12-.5-1.12-1.13v-1.33A2.55 2.55 0 0 1 7.54 9h3.68q.35 0 .68.1l.42.11.18-.4c.1-.26.26-.57.47-.79l.5-.48-2.04-2.02a.5.5 0 0 1 0-.74c.2-.2.52-.2.72 0m-6.5 3.77a3.6 3.6 0 0 0-1.6 2.38 1.5 1.5 0 1 1 1.6-2.38"
]);
const $eb093920387c7bf0$export$780589325dc6efa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7.3 8.01q-.66.04-1.25.3A2.12 2.12 0 1 0 4 11.22v2.21C4 14.3 4.7 15 5.56 15H10v-1.25q.01-.25-.28-.49-.31-.24-.82-.26H7.5a.5.5 0 0 1 0-1h1.4c.54 0 1.05.17 1.43.47.39.3.67.74.67 1.28V15h1.74c.43 0 .82-.18 1.1-.45l3.3 3.3a.5.5 0 0 0 .71-.7zm14.06 10.39q-.65.63-1.48.77l-5.3-5.3h.67q.71 0 1.33.25l.08-.13c.11-.19.23-.4.38-.55l-1.55-1.56a1.16 1.16 0 1 1 1.64-1.64l4.23 4.23a2.8 2.8 0 0 1 0 3.93"
]);
const $eb093920387c7bf0$export$f64eb8fa01200d79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7.3 8.01q-.37.03-.7.12A2.5 2.5 0 1 0 4 11.95v.93c0 1.18.95 2.13 2.12 2.13h6.51q.71-.01 1.26-.41l3.26 3.25a.5.5 0 0 0 .7-.7zm10.32 11.73q-.24.13-.54.13h-1.62v-.1C11 12.78 9.99 12 8.89 12H7.5a.5.5 0 0 0 0 1h1.39c.69 0 1.12.46 1.12.91v.1H6.12c-.62 0-1.12-.5-1.12-1.13v-1.33A2.55 2.55 0 0 1 7.54 9h.75zM5.66 8.55a3.6 3.6 0 0 0-1.6 2.38 1.5 1.5 0 1 1 1.6-2.38m10.71 3.48c-.44.44-1.02.65-1.6.62l.9.9q.79-.2 1.41-.82a3.15 3.15 0 0 0 0-4.44l-4.22-4.22c-.59-.59-1.55-.59-2.14 0-.6.6-.6 1.56 0 2.15l1.34 1.33q-.18.24-.3.5a4 4 0 0 0-.54-.05h-1.1l1 1h.1q.35 0 .68.1l.42.11.18-.4c.1-.26.26-.57.47-.79l.5-.48-2.04-2.02a.5.5 0 0 1 0-.74c.2-.2.52-.2.72 0L16.38 9c.84.84.84 2.2 0 3.04"
]);
const $eb093920387c7bf0$export$95178a238ce11406 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtleFilled', "1em", [
    "M9.1 4c-1.47 0-2.5.55-3.21 1.38a7.5 7.5 0 0 0-1.36 2.77L4.27 9H2.5a.5.5 0 0 0-.5.5c0 1.08.5 2.1 1.3 2.63l-.44 1.07a1.3 1.3 0 0 0 1.2 1.81h1.47c.5 0 .97-.3 1.19-.75l.47-1q1.98.27 3.95 0l.48 1c.21.46.67.75 1.18.75h1.45a1.3 1.3 0 0 0 1.21-1.8l-.5-1.21h1.7c.68 0 1.34-.52 1.34-1.26V10c0-1.14-.99-2-2.12-2H13.8a7 7 0 0 0-1.4-2.63A4.3 4.3 0 0 0 9.1 4m5.57 7-.57-2h1.78c.66 0 1.12.49 1.12 1v.74c0 .09-.11.26-.33.26zm-2.5 2.08q.98-.2 1.93-.55l.44 1.05a.3.3 0 0 1-.29.43H12.8a.3.3 0 0 1-.28-.18zm-7.95-.55q.96.34 1.95.55l-.36.75a.3.3 0 0 1-.28.18H4.07a.3.3 0 0 1-.29-.43zM3.97 10l-.34 1.12c-.27-.26-.5-.65-.58-1.12z"
]);
const $eb093920387c7bf0$export$6fa7c772d531366f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtleRegular', "1em", [
    "M9.1 4c-1.47 0-2.5.55-3.21 1.38a7.5 7.5 0 0 0-1.36 2.77L4.27 9H2.5a.5.5 0 0 0-.5.5c0 1.08.5 2.1 1.3 2.63l-.44 1.07a1.3 1.3 0 0 0 1.2 1.81h1.47c.5 0 .97-.3 1.19-.75l.47-1q1.97.27 3.95 0l.48 1c.21.46.67.75 1.18.75h1.45a1.3 1.3 0 0 0 1.21-1.8l-.5-1.21h1.7c.68 0 1.34-.52 1.34-1.26V10c0-1.14-.99-2-2.12-2H13.8a7 7 0 0 0-1.4-2.63A4.3 4.3 0 0 0 9.1 4m5.57 7-.57-2h1.78c.66 0 1.12.49 1.12 1v.74c0 .09-.11.26-.33.26zm-.57 1.53.44 1.05a.3.3 0 0 1-.29.43H12.8a.3.3 0 0 1-.28-.18l-.35-.75q.98-.2 1.93-.55m-7.93.55-.36.75a.3.3 0 0 1-.28.18H4.07a.3.3 0 0 1-.29-.43l.44-1.05q.96.34 1.95.55m-2.54-1.96c-.27-.26-.5-.65-.58-1.12h.92zM5.5 8.44c.27-.91.6-1.77 1.15-2.4A3 3 0 0 1 9.1 5c1.2 0 2 .43 2.56 1.05.59.63.96 1.5 1.23 2.39l.9 3.13c-3 1.1-6.25 1.1-9.25 0z"
]);
const $eb093920387c7bf0$export$da8882e930ef455d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BezierCurveSquareFilled', "1em", [
    "M5 3a2 2 0 0 0-2 2v8c1.4 0 2.26-.4 2.86-.96.62-.57.99-1.35 1.3-2.2l.28-.87.13-.41q.2-.63.47-1.19t.74-.96Q9.28 6 10 6t1.22.4q.48.4.74.97t.47 1.19l.13.4q.13.44.29.87c.3.86.67 1.64 1.29 2.21.6.56 1.47.96 2.86.96V5a2 2 0 0 0-2-2zm12 11c-1.6 0-2.74-.47-3.54-1.23a6.4 6.4 0 0 1-1.56-2.6l-.3-.92-.12-.38a8 8 0 0 0-.41-1.05q-.22-.44-.46-.63A1 1 0 0 0 10 7a1 1 0 0 0-.6.2q-.25.18-.47.62-.2.44-.4 1.05l-.13.38-.3.92c-.32.9-.76 1.86-1.56 2.6A5 5 0 0 1 3 14v1c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2z"
]);
const $eb093920387c7bf0$export$3538e2b668241d4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BezierCurveSquareRegular', "1em", [
    "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm11 9.92a3.5 3.5 0 0 1-1.86-.88 5.4 5.4 0 0 1-1.3-2.2l-.28-.87-.13-.41a9 9 0 0 0-.47-1.19q-.26-.56-.74-.96Q10.72 6 10 6t-1.22.4q-.48.4-.74.97-.27.56-.47 1.19l-.13.4q-.13.44-.29.87c-.3.86-.67 1.64-1.29 2.21a3.5 3.5 0 0 1-1.86.88V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zM4 13.93a4.6 4.6 0 0 0 2.54-1.16c.8-.74 1.24-1.7 1.56-2.6l.3-.92.12-.38q.2-.6.41-1.05.22-.44.46-.63.22-.18.61-.19.39 0 .6.2.25.18.47.62a8 8 0 0 1 .4 1.05l.13.38.3.92c.32.9.76 1.86 1.56 2.6q.93.9 2.54 1.16V15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
]);
const $eb093920387c7bf0$export$7d5ed4ececb339fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUpFilled', "1em", [
    "M7.67 7.14c.1-.2.38-.18.46.02l2.33 6.2a1.75 1.75 0 0 0 3.23.14l1.22-2.6a.3.3 0 0 1 .23-.15h1.06a1.5 1.5 0 1 0 0-1.5h-1.06c-.68 0-1.3.4-1.59 1l-1.22 2.6c-.1.2-.38.2-.46-.01l-2.33-6.2A1.75 1.75 0 0 0 6.3 6.5L5.1 9.1a.3.3 0 0 1-.22.14H3.8a1.5 1.5 0 1 0 0 1.5h1.07c.67 0 1.29-.4 1.58-1z"
]);
const $eb093920387c7bf0$export$51836d46e9133466 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUpRegular', "1em", [
    "M7.45 7.27a.5.5 0 0 1 .91.04l2.35 5.76a1.5 1.5 0 0 0 2.73.11l1.23-2.4a.5.5 0 0 1 .44-.28h.98a1.5 1.5 0 1 0 0-1h-.98a1.5 1.5 0 0 0-1.33.82l-1.23 2.4a.5.5 0 0 1-.91-.03L9.29 6.93a1.5 1.5 0 0 0-2.73-.11l-1.23 2.4a.5.5 0 0 1-.44.28H3.9a1.5 1.5 0 1 0 0 1h.98a1.5 1.5 0 0 0 1.33-.82z"
]);
const $eb093920387c7bf0$export$fc87ea14704ae2da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoomFilled', "1em", [
    "M9.19 2.11a.5.5 0 0 1 .41-.1l7 1.5c.23.05.4.25.4.5v12a.5.5 0 0 1-.4.48l-7 1.5a.5.5 0 0 1-.6-.49v-15q0-.24.19-.39m3.31 7.9a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M8 3H3.5a.5.5 0 0 0-.5.5V16.5c0 .27.22.5.5.5H8z"
]);
const $eb093920387c7bf0$export$98a53c00ef3be16d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoomRegular', "1em", [
    "M12.49 10a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.6 2.01a.5.5 0 0 0-.6.5V17.5a.5.5 0 0 0 .6.5l7-1.51A.5.5 0 0 0 17 16V4a.5.5 0 0 0-.4-.49zm.4 14.87V3.12l6 1.29V15.6zM8 17v-1H4V4h4V3H3.5a.5.5 0 0 0-.5.5v13c0 .27.22.5.5.5z"
]);
const $eb093920387c7bf0$export$84e0a320f1dd3444 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConnectedFilled', "1em", [
    "M7 4.5q-.01.77-.41 1.38L8.62 7.9a2.5 2.5 0 0 1 2.76 0l2.03-2.03q-.4-.6-.41-1.38a2.5 2.5 0 1 1 1.12 2.09L12.1 8.62a2.5 2.5 0 0 1 0 2.76l2.03 2.03q.6-.4 1.38-.41a2.5 2.5 0 1 1-2.09 1.12l-2.03-2.03a2.5 2.5 0 0 1-2.76 0L6.6 14.12q.4.6.41 1.38a2.5 2.5 0 1 1-1.12-2.09l2.03-2.03a2.5 2.5 0 0 1 0-2.76L5.88 6.6q-.6.4-1.38.41A2.5 2.5 0 1 1 7 4.5"
]);
const $eb093920387c7bf0$export$d0842ad47c0ea1d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConnectedRegular', "1em", [
    "M5.88 6.59q-.6.4-1.38.41a2.5 2.5 0 1 1 2.09-1.12L8.62 7.9a2.5 2.5 0 0 1 2.76 0l2.03-2.03q-.4-.6-.41-1.38a2.5 2.5 0 1 1 1.12 2.09L12.1 8.62a2.5 2.5 0 0 1 0 2.76l2.03 2.03q.6-.4 1.38-.41a2.5 2.5 0 1 1-2.09 1.12l-2.03-2.03a2.5 2.5 0 0 1-2.76 0L6.6 14.12q.4.6.41 1.38a2.5 2.5 0 1 1-1.12-2.09l2.03-2.03a2.5 2.5 0 0 1 0-2.76zM6 4.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m11 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M4.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
]);
const $eb093920387c7bf0$export$9dc1fd1cc87215a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConnectorFilled', "1em", [
    "M4.5 3a.5.5 0 0 0-.5.5v2.8L2.15 8.14A.5.5 0 0 0 2 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 0 0 1 0V14h1v2.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.15-.35L7 6.29V3.5a.5.5 0 0 0-.5-.5zm11 14a.5.5 0 0 0 .5-.5v-2.8l1.85-1.85a.5.5 0 0 0 .15-.35v-5a.5.5 0 0 0-.5-.5H17V3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V6h-.5a.5.5 0 0 0-.5.5v5q0 .2.15.35L13 13.71v2.79c0 .28.22.5.5.5zM13 6V4h3v2z"
]);
const $eb093920387c7bf0$export$9c0cbc964ede65f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConnectorRegular', "1em", [
    "M5 3.5a.5.5 0 0 0-1 0v2.8L2.15 8.14A.5.5 0 0 0 2 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 0 0 1 0V14h1v2.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.15-.35L7 6.29V3.5a.5.5 0 0 0-1 0v3q0 .2.15.35L8 8.71V13H3V8.7l1.85-1.85A.5.5 0 0 0 5 6.5zm10 13v-3a.5.5 0 0 1 .15-.35L17 11.29V7h-5v4.3l1.85 1.85q.15.14.15.35v3a.5.5 0 0 1-1 0v-2.8l-1.85-1.85a.5.5 0 0 1-.15-.35v-5c0-.28.22-.5.5-.5h.5V3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V6h.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.15.35L16 13.71v2.79a.5.5 0 0 1-1 0M13 6h3V4h-3z"
]);
const $eb093920387c7bf0$export$cd886a0dd9cef7c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__a)",
            "d": "M2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__b)",
            "fillOpacity": ".7",
            "d": "M2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__c)",
            "d": "M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__d)",
            "d": "M4 11.7c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__e)",
            "d": "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__a",
                "x1": "7.71",
                "x2": "11.39",
                "y1": "4",
                "y2": "16.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__b",
                "x1": "12.48",
                "x2": "15.57",
                "y1": "5.47",
                "y2": "22.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__c",
                "x1": "12.64",
                "x2": "14.65",
                "y1": "7.54",
                "y2": "15.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__d",
                "x1": "4",
                "x2": "5.1",
                "y1": "9",
                "y2": "14.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__e",
                "x1": "5",
                "x2": "7.24",
                "y1": "6",
                "y2": "9.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$83fa171ea5ee3076 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm3 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-1.55.75h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94M11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $eb093920387c7bf0$export$28cbb5c7e948fe54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRegular', "1em", [
    "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25zM3.75 5a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75z"
]);
const $eb093920387c7bf0$export$63ceb2f520619e48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGenericFilled', "1em", [
    "M16 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zM7 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4.5-.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $eb093920387c7bf0$export$ac2307ce8b0a05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGenericRegular', "1em", [
    "M16.25 4c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25v-8.5C2 4.78 2.78 4 3.75 4zM3.75 5a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75zM7 7.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m7.5 3.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM7 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7.5-.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $eb093920387c7bf0$export$848a9f27b24e66d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroupFilled', "1em", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M4 10.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 .75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5zM6.25 9a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.25-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.07 3.98.07-.41v-.82q0-.4-.17-.75H10a1 1 0 0 1 1 1c0 .83-.67 1.5-1.5 1.5h-.26q.15-.3.2-.52"
]);
const $eb093920387c7bf0$export$862f6b9be502153e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroupRegular', "1em", [
    "M12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-8-.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 .75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5zM6.25 9a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.25-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.07 3.98q-.05.23-.2.52h.27c.83 0 1.5-.67 1.5-1.5a1 1 0 0 0-1-1h-.67q.17.35.17.75v.82a2 2 0 0 1-.07.4M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5z"
]);
const $eb093920387c7bf0$export$d0d28bd3cce22fb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardLinkFilled', "1em", [
    "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v5.84a3.5 3.5 0 0 0-1.5-.34h-4a3.5 3.5 0 0 0-3.16 5H3.5A1.5 1.5 0 0 1 2 14.5zm3 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m4 3.2a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1 4a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-3.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $eb093920387c7bf0$export$62a525c6f969a92b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardLinkRegular', "1em", [
    "M6.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-1.55.75a.95.95 0 0 0-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8a.95.95 0 0 0-.95-.94zM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M9.04 15H3.75a.75.75 0 0 1-.75-.75v-8.5c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v5.29q.53.07 1 .3V5.75C18 4.78 17.22 4 16.25 4H3.75C2.78 4 2 4.78 2 5.75v8.5c0 .97.78 1.75 1.75 1.75h5.59a4 4 0 0 1-.3-1m3.46-3a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $eb093920387c7bf0$export$b0693a89847697c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbonFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5H13v-.35a4 4 0 0 1-.87-3.65h-.63a.5.5 0 0 1 0-1h1.04A4 4 0 0 1 18 9.54V5.5c0-.83-.67-1.5-1.5-1.5zm3 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m1.55.75c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94zM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m8 4.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 3.46a4 4 0 0 1-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22z"
]);
const $eb093920387c7bf0$export$115449b064deff16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbonRegular', "1em", [
    "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h.63q.14-.54.4-1zm-7.75 4h8.79q.2.35.46.65V16H3.75C2.78 16 2 15.22 2 14.25v-8.5C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v3.79q-.46-.27-1-.41V5.75a.75.75 0 0 0-.75-.75H3.75a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75M19 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 3.46a4 4 0 0 1-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22z"
]);
const $eb093920387c7bf0$export$b3409512af75fa86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettingsFilled', "1em", [
    "M2.5 5.25A2.75 2.75 0 0 1 5.25 2.5h9.5a2.75 2.75 0 0 1 2.75 2.75v4.64q-.69-.45-1.5-.68V7H4v7.75c0 .69.56 1.25 1.25 1.25h3.96q.23.81.68 1.5H5.25a2.75 2.75 0 0 1-2.75-2.75zM9 14.5v-6a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5M6 14V9h2v5zm4-5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m2.07 2.94a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $eb093920387c7bf0$export$c97d788e6126f9ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettingsRegular', "1em", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1q-.24-.48-.4-1H5.5A1.5 1.5 0 0 1 4 14.5V7h12v2.2q.52.16 1 .4V5.5A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4zm5 3v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5M6 9v5h2V9zm4-.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m2.07 2.94a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $eb093920387c7bf0$export$a3a4d136b3b8060e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__a)",
            "d": "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__b)",
            "d": "M5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__c)",
            "d": "M5 11.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__d)",
            "d": "M5.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__e)",
            "d": "M11 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__a",
                "x1": "8",
                "x2": "13.36",
                "y1": "3",
                "y2": "16.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__b",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__c",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__d",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__e",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$108f9cee1c8f0bc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewFilled', "1em", [
    "M14 7H6v2h8zm-2 5h2v1h-2zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm7 4h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1m-7 .5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1"
]);
const $eb093920387c7bf0$export$9d8f4b6944c2865a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewRegular', "1em", [
    "M5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm9 0H6v2h8zm-2 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm0 1h2v1h-2zm-7-.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $eb093920387c7bf0$export$af927193815cd7eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryFilled', "1em", [
    "M9 7H6v2h3zM3 6a3 3 0 0 1 3-3h6v14H6a3 3 0 0 1-3-3zm2 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 13.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m8 3.5h1a3 3 0 0 0 3-3v-1h-4zm4-5V8h-4v4zm0-5V6a3 3 0 0 0-3-3h-1v4z"
]);
const $eb093920387c7bf0$export$f9c0c14f31515359 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryRegular', "1em", [
    "M6 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm0 1h3v2H6zm-1 4.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm8 10V4H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zm3 0a2 2 0 0 0 2-2v-1h-4v3zm2-9V6a2 2 0 0 0-2-2h-2v3zm0 5V8h-4v4z"
]);
const $eb093920387c7bf0$export$4c8b5ab03b729eb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightningFilled', "1em", [
    "M9 7H6v2h3zM3 6a3 3 0 0 1 3-3h6v4.78l-.04.08L9.54 13H5.5a.5.5 0 0 0 0 1h3.58c-.34.96.37 2 1.42 2H12v.88l-.03.12H6a3 3 0 0 1-3-3zm14 1h-4V3h1a3 3 0 0 1 3 3zM5 7v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.82-3h4.82a.5.5 0 0 1 .44.75L16.75 12h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L13.5 15h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $eb093920387c7bf0$export$fdf5a43897d95cf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightningRegular', "1em", [
    "M5 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm4 0H6v2h3zm-3.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 13.5c0-.28.22-.5.5-.5h4.04l-.4.86-.06.14H5.5a.5.5 0 0 1-.5-.5M6 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h5v5.9l.96-2.04.04-.08V4h2a2 2 0 0 1 2 2v1h1V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.97l.25-1zm7.32-8h4.82a.5.5 0 0 1 .44.75L16.75 12h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L13.5 15h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $eb093920387c7bf0$export$5874d840e9d8ae3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeftFilled', "1em", [
    "m12.7 8 4.15-4.15a.5.5 0 0 0-.7-.7L12 7.29V3.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1zM6 4a2 2 0 0 0-2 2v4h4a2 2 0 0 1 2 2v4h4a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1z"
]);
const $eb093920387c7bf0$export$a377080b12d72b40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeftRegular', "1em", [
    "m12.7 8 4.15-4.15a.5.5 0 0 0-.7-.7L12 7.29V3.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1zM4 6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-4v-4a2 2 0 0 0-2-2H4zm0 5h4a1 1 0 0 1 1 1v4H6a2 2 0 0 1-2-2z"
]);
const $eb093920387c7bf0$export$45aa638b8b69411e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRightFilled', "1em", [
    "M6 4a2 2 0 0 0-2 2v2.5a.5.5 0 0 1-1 0V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2.5a.5.5 0 0 1 0-1H14a2 2 0 0 0 2-2v-4h-4a2 2 0 0 1-2-2V4zm-2.5 8a.5.5 0 0 1 0-1h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-3.8l-4.15 4.15a.5.5 0 0 1-.7-.7L7.29 12z"
]);
const $eb093920387c7bf0$export$9bd137499867ca2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRightRegular', "1em", [
    "M4 6c0-1.1.9-2 2-2h4v4c0 1.1.9 2 2 2h4v4a2 2 0 0 1-2 2h-2.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v2.5a.5.5 0 0 0 1 0zm8 3a1 1 0 0 1-1-1V4h3a2 2 0 0 1 2 2v3zm-9 2.5c0 .28.22.5.5.5h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L8 12.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5"
]);
const $eb093920387c7bf0$export$cd0b44fb1b27c42e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ControlButtonFilled', "1em", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1zm3 .5a.5.5 0 0 0-1 0V9h-.5a.5.5 0 0 0 0 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 0 0 0-1h-.25a.25.25 0 0 1-.25-.25V10h.5a.5.5 0 0 0 0-1H9zm7 0a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 0 0 1 0z"
]);
const $eb093920387c7bf0$export$f071d46663b7680e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ControlButtonRegular', "1em", [
    "M6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1zm3 .5a.5.5 0 0 0-1 0V9h-.5a.5.5 0 0 0 0 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 0 0 0-1h-.25a.25.25 0 0 1-.25-.25V10h.5a.5.5 0 0 0 0-1H9zm7 0a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 0 0 1 0zM4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25z"
]);
const $eb093920387c7bf0$export$8acb09b97e76af05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConvertRangeFilled', "1em", [
    "M5 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm12.5 5c.28 0 .5.22.5.5v2a2.5 2.5 0 0 1-2.5 2.5h-1.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L13.71 11h1.79c.83 0 1.5-.67 1.5-1.5v-2c0-.28.22-.5.5-.5m-5.62 3H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1.56-.35l-2-2a1.5 1.5 0 0 1 0-2.12zM6.5 14c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5"
]);
const $eb093920387c7bf0$export$4d544d50b13a7f87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConvertRangeRegular', "1em", [
    "M5 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM4 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm3 9.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm4.88-3.5H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1 0V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h6.09q.1-.31.35-.56zM18 7.5a.5.5 0 0 0-1 0v2c0 .83-.67 1.5-1.5 1.5h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L13.71 12h1.79A2.5 2.5 0 0 0 18 9.5z"
]);
const $eb093920387c7bf0$export$141435b031ceeaa9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyFilled', "1em", [
    "M7 11.5a3.5 3.5 0 0 0 3.5 3.5h1.45a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zM14.5 3A2.5 2.5 0 0 1 17 5.5v6a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $eb093920387c7bf0$export$2c0302a44af0db59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyRegular', "1em", [
    "M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h4c.65 0 1.2-.42 1.41-1h1.04a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.5-4A2.5 2.5 0 0 1 17 5.5v6a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3zm-4 1C9.67 4 9 4.67 9 5.5v6c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
]);
const $eb093920387c7bf0$export$54f2941821ff9a59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyAddFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 11.5c0 1.4.82 2.6 2 3.16q.05 1.27.6 2.34H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.5.5a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m0-9A2.5 2.5 0 0 1 17 5.5v4.1q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-5.42 4.56A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $eb093920387c7bf0$export$d8b665c10cf92275 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyAddRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h3.7q.15.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.5 5a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m0-9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.25-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-4C9.67 4 9 4.67 9 5.5v6q.01.58.38 1-.2.5-.3 1.06A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $eb093920387c7bf0$export$15440cfe5ff6f302 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRightFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 11.5c0 1.4.82 2.6 2 3.16q.05 1.27.6 2.34H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.85.65a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM14.5 3A2.5 2.5 0 0 1 17 5.5v4.1q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-5.42 4.56A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $eb093920387c7bf0$export$6c184d9f5b2b70b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRightRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h3.7q.15.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.85 5.15a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM14.5 3A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.25-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-4C9.67 4 9 4.67 9 5.5v6q.01.58.38 1-.2.5-.3 1.06A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $eb093920387c7bf0$export$c95ef2d5aecf11b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopySelectFilled', "1em", [
    "M7 11.5a3.5 3.5 0 0 0 3.5 3.5h1.45a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm1.5 0c.28 0 .5.23.58.5.2.58.76 1 1.42 1h.75a.5.5 0 0 1 0 1h-.75a2.5 2.5 0 0 1-2.45-2c-.05-.27.17-.5.45-.5m8 0c.28 0 .5.23.45.5a2.5 2.5 0 0 1-2.45 2h-.75a.5.5 0 0 1 0-1h.75a1.5 1.5 0 0 0 1.42-1c.09-.27.3-.5.58-.5M8.5 7c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m8 0c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m-5.25-4a.5.5 0 0 1 0 1h-.75a1.5 1.5 0 0 0-1.42 1c-.09.27-.3.5-.58.5S8 5.27 8.05 5a2.5 2.5 0 0 1 2.45-2zm3.25 0a2.5 2.5 0 0 1 2.45 2c.05.27-.17.5-.45.5s-.5-.23-.58-.5c-.2-.58-.76-1-1.42-1h-.75a.5.5 0 0 1 0-1z"
]);
const $eb093920387c7bf0$export$7bc5e2959861b79b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopySelectRegular', "1em", [
    "M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h4c.65 0 1.2-.42 1.41-1h1.04a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm1.5 4.5c.28 0 .5.23.58.5.2.58.76 1 1.42 1h.75a.5.5 0 0 1 0 1h-.75a2.5 2.5 0 0 1-2.45-2c-.05-.27.17-.5.45-.5m8 0c.28 0 .5.23.45.5a2.5 2.5 0 0 1-2.45 2h-.75a.5.5 0 0 1 0-1h.75a1.5 1.5 0 0 0 1.42-1c.09-.27.3-.5.58-.5M8.5 7c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m8 0c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m-5.25-4a.5.5 0 0 1 0 1h-.75a1.5 1.5 0 0 0-1.42 1c-.09.27-.3.5-.58.5S8 5.27 8.05 5a2.5 2.5 0 0 1 2.45-2zm3.25 0a2.5 2.5 0 0 1 2.45 2c.05.27-.17.5-.45.5s-.5-.23-.58-.5c-.2-.58-.76-1-1.42-1h-.75a.5.5 0 0 1 0-1z"
]);
const $eb093920387c7bf0$export$1e48d5301e838f9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-6.5-1.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m.39 4.01a4 4 0 0 0 6.22 0 .5.5 0 1 1 .78.63 5 5 0 0 1-7.78 0 .5.5 0 1 1 .78-.63"
]);
const $eb093920387c7bf0$export$4add931966dc4a1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiRegular', "1em", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m10.5-1.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.61 4.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $eb093920387c7bf0$export$fc95cc80fa094a2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAddFilled', "1em", [
    "M17 9a8 8 0 1 0-7.41 7.98A5.5 5.5 0 0 1 9.02 14H9a5 5 0 0 1-3.89-1.86.5.5 0 1 1 .78-.63A4 4 0 0 0 9.2 13a5.5 5.5 0 0 1 7.77-3.41zm-6.5-1.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m13.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $eb093920387c7bf0$export$8f40974d43d8bc07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAddRegular', "1em", [
    "M17 9a8 8 0 1 0-7.41 7.98A6 6 0 0 1 9.2 16H9a7 7 0 1 1 7-6.8q.51.15.98.39zm-7.98 5q.05-.51.19-1H9a4 4 0 0 1-3.11-1.49.5.5 0 1 0-.78.63A5 5 0 0 0 9 14zm3.48-6.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m11.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $eb093920387c7bf0$export$7bbe451af9d9773 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngryFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6.5-1.5a.5.5 0 0 0 .26-.93l-2.5-1.5a.5.5 0 0 0-.52.86l1.22.73a1 1 0 1 0 1.54.84m5 0a1 1 0 0 0-.46-.84l1.22-.73a.5.5 0 0 0-.52-.86l-2.5 1.5a.5.5 0 0 0 .26.93 1 1 0 1 0 2 0m.06 4.89c.34-.3.07-.72.06-.73l-.23-.23a4 4 0 0 0-.67-.49 5.3 5.3 0 0 0-2.72-.69 5.3 5.3 0 0 0-2.72.7 4 4 0 0 0-.9.7c-.18.23-.17.55.06.74a.5.5 0 0 0 .7-.07l.02-.03q.04-.05.12-.11.15-.16.5-.37a4.3 4.3 0 0 1 2.22-.56 4.3 4.3 0 0 1 2.22.56 3 3 0 0 1 .64.5c.18.22.5.27.7.08"
]);
const $eb093920387c7bf0$export$16add89c8186f80f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngryRegular', "1em", [
    "M8.5 8.5a1 1 0 1 1-1.54-.84l-1.22-.73a.5.5 0 0 1 .52-.86l2.5 1.5a.5.5 0 0 1-.26.93m5 0a1 1 0 1 1-2 0 .5.5 0 0 1-.26-.93l2.5-1.5a.5.5 0 0 1 .52.86l-1.22.73a1 1 0 0 1 .46.84m.06 4.89a.5.5 0 0 1-.7-.07l-.02-.03-.12-.12q-.15-.16-.5-.36a4.3 4.3 0 0 0-2.22-.56c-1.02 0-1.75.28-2.21.56a3 3 0 0 0-.65.5.5.5 0 0 1-.78-.62l.39.31-.39-.31v-.01l.02-.02.23-.23q.22-.2.67-.49c.6-.35 1.5-.69 2.72-.69a5.3 5.3 0 0 1 2.72.7 4 4 0 0 1 .9.71l.01.02h.01l-.39.32.39-.31a.5.5 0 0 1-.08.7M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $eb093920387c7bf0$export$9a28b9a0013222b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEditFilled', "1em", [
    "M2 10a8 8 0 0 0 7 7.94q.02-.15.06-.29l.37-1.5q.16-.62.56-1.15a5 5 0 0 1-3.88-1.86.5.5 0 1 1 .78-.63 4 4 0 0 0 4.2 1.34l4.01-4a2.9 2.9 0 0 1 2.85-.73A8 8 0 0 0 2 10m9.5-1.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4.48 6.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $eb093920387c7bf0$export$ba5ac590975e6c33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEditRegular', "1em", [
    "M2 10a8 8 0 0 0 7 7.94q.02-.15.06-.29l.17-.7a7 7 0 1 1 7.7-7.94q.52-.04 1.02.1A8 8 0 0 0 2 10m8.27 4.67.82-.82a4 4 0 0 1-4.2-1.34.5.5 0 1 0-.78.63A5 5 0 0 0 10 15q.12-.18.28-.33M13.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2.48 6.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $eb093920387c7bf0$export$caa93cd9838ee6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHandFilled', "1em", [
    "M5.5 1c.28 0 .5.22.5.5v5a.5.5 0 0 0 1 0v-4a.5.5 0 0 1 1 0v4.25l.31-.06q.5-.08 1.07.14t1.04.9a.5.5 0 0 1-.22.73 5.3 5.3 0 0 0-2.71 2.37C6.94 11.86 5.89 13 4.5 13h-.26A2.5 2.5 0 0 1 2 11.62l-.63-1.26A3.5 3.5 0 0 1 1 8.79V2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 0 1 0v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 0 1 0v-5c0-.28.22-.5.5-.5m2.87 10.3c-.28.54-.74 1.18-1.35 1.7a5.5 5.5 0 1 0 4.21-5.85l.02.02a1.5 1.5 0 0 1-.66 2.2 4.3 4.3 0 0 0-2.22 1.92m2.38 1.2a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m4.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-4.05 2.53c.08.17.55.72 1.55.72s1.47-.55 1.55-.72a.5.5 0 1 1 .9.44c-.25.5-1.05 1.28-2.45 1.28s-2.2-.78-2.45-1.28a.5.5 0 1 1 .9-.44"
]);
const $eb093920387c7bf0$export$5b597e0e063b4453 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHandRegular', "1em", [
    "M4.5 1c-.65 0-1.2.42-1.41 1H3a2 2 0 0 0-2 2v4.8q0 .82.37 1.56L2 11.62A2.5 2.5 0 0 0 4.24 13h1.82a3.1 3.1 0 0 0 2.52-1.5 8 8 0 0 1 3.62-3.04.5.5 0 0 0 .29-.58 2.2 2.2 0 0 0-.8-1.28 2 2 0 0 0-1.13-.35q-.31 0-.56.06V4a2 2 0 0 0-2-2h-.09c-.2-.58-.76-1-1.41-1zm0 1H5v4.5a.5.5 0 0 0 1 0V2h.5c.28 0 .5.22.5.5v4a.5.5 0 1 0 1 0V3a1 1 0 0 1 1 1v3a.5.5 0 0 0 .72.45h.01l.24-.1a2 2 0 0 1 .6-.1q.31 0 .53.15.15.1.28.34c-1.87.9-3 2.22-3.64 3.21-.4.63-1.04 1.05-1.68 1.05H4.24a1.5 1.5 0 0 1-1.35-.83l-.63-1.26A2.5 2.5 0 0 1 2 8.79V4a1 1 0 0 1 1-1v3.5a.5.5 0 1 0 1 0v-4c0-.28.22-.5.5-.5m8.76 5.05a5.5 5.5 0 1 1-6.1 6.78q.5-.17.93-.45a4.5 4.5 0 1 0 5.4-5.27q.02-.24-.03-.47-.09-.3-.2-.59m-2.51 5.45a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-4.05 2.53a.5.5 0 1 0-.9.44c.25.5 1.05 1.28 2.45 1.28s2.2-.78 2.45-1.28a.5.5 0 1 0-.9-.44c-.08.17-.55.72-1.55.72s-1.47-.55-1.55-.72"
]);
const $eb093920387c7bf0$export$1e8038ef1003249d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHintFilled', "1em", [
    "M8.44 2.15a.5.5 0 0 0 .2.98 7 7 0 0 1 2.73 0 .5.5 0 0 0 .19-.98 8 8 0 0 0-3.12 0m6 1.2a.5.5 0 0 0-.55.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m-8.33.83a.5.5 0 0 0-.56-.83 8 8 0 0 0-2.2 2.2.5.5 0 0 0 .83.56A7 7 0 0 1 6.1 4.18M3.13 8.63a.5.5 0 1 0-.98-.2 8 8 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7 7 0 0 1 0-2.73m14.72-.2a.5.5 0 1 0-.98.2 7 7 0 0 1 0 2.74.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13M4.18 13.9a.5.5 0 0 0-.83.56 8 8 0 0 0 2.2 2.2.5.5 0 0 0 .56-.83 7 7 0 0 1-1.93-1.93m12.47.56a.5.5 0 1 0-.83-.56 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .55.83 8 8 0 0 0 2.21-2.2m-8.02 2.42a.5.5 0 0 0-.2.98c1.02.2 2.12.2 3.13 0a.5.5 0 0 0-.2-.98c-.88.17-1.84.17-2.73 0M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-9.44 2.11a.5.5 0 0 0-.07.7 4.5 4.5 0 0 0 7.02 0 .5.5 0 1 0-.78-.62 3.5 3.5 0 0 1-5.46 0 .5.5 0 0 0-.7-.08M7.75 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M13 8.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $eb093920387c7bf0$export$dd358f96f45ae4f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHintRegular', "1em", [
    "M8.44 2.15a.5.5 0 0 0 .2.98 7 7 0 0 1 2.73 0 .5.5 0 0 0 .19-.98 8 8 0 0 0-3.12 0m6 1.2a.5.5 0 0 0-.55.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m-8.33.83a.5.5 0 0 0-.56-.83 8 8 0 0 0-2.2 2.2.5.5 0 0 0 .83.56A7 7 0 0 1 6.1 4.18M3.13 8.63a.5.5 0 1 0-.98-.2 8 8 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7 7 0 0 1 0-2.73m14.72-.2a.5.5 0 1 0-.98.2 7 7 0 0 1 0 2.74.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13M4.18 13.9a.5.5 0 0 0-.83.56 8 8 0 0 0 2.2 2.2.5.5 0 0 0 .56-.83 7 7 0 0 1-1.93-1.93m12.47.56a.5.5 0 1 0-.83-.56 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .55.83 8 8 0 0 0 2.21-2.2m-8.02 2.42a.5.5 0 0 0-.2.98c1.02.2 2.12.2 3.13 0a.5.5 0 0 0-.2-.98c-.88.17-1.84.17-2.73 0M7.75 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.5 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-5.69 3.11a.5.5 0 0 1 .7.08 3.5 3.5 0 0 0 5.47 0 .5.5 0 0 1 .78.62 4.5 4.5 0 0 1-7.02 0 .5.5 0 0 1 .07-.7"
]);
const $eb093920387c7bf0$export$95f909f0f9d7b4da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaughFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M6.5 8.08a.5.5 0 1 1-1-.16c.13-.83.9-1.42 1.75-1.42s1.61.59 1.74 1.42a.5.5 0 1 1-.99.16c-.04-.3-.34-.58-.75-.58-.42 0-.71.28-.76.58m5.5 0a.5.5 0 0 1-1-.16c.13-.83.9-1.42 1.75-1.42s1.61.59 1.74 1.42a.5.5 0 0 1-.99.16c-.04-.3-.34-.58-.75-.58-.42 0-.71.28-.76.58M5.5 10.5h9c-.22 2.2-1.93 4-4.5 4a4.36 4.36 0 0 1-4.5-4"
]);
const $eb093920387c7bf0$export$2ab1855ca418d966 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaughRegular', "1em", [
    "M6.5 8.08c.04-.3.33-.58.75-.58.41 0 .7.28.75.58A.5.5 0 1 0 9 7.92 1.7 1.7 0 0 0 7.25 6.5c-.86 0-1.62.59-1.74 1.42a.5.5 0 1 0 .98.16m6.25-.58c-.42 0-.71.28-.76.58a.5.5 0 0 1-.98-.16c.12-.83.88-1.42 1.74-1.42.85 0 1.61.59 1.74 1.42a.5.5 0 0 1-.99.16c-.04-.3-.34-.58-.75-.58M5.5 10a.5.5 0 0 0-.5.55A4.86 4.86 0 0 0 10 15c2.84 0 4.75-2 5-4.45a.5.5 0 0 0-.5-.55zm4.5 4a3.85 3.85 0 0 1-3.92-3h7.83c-.4 1.7-1.83 3-3.91 3m0-12a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $eb093920387c7bf0$export$6a7d9dba2ae486df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMehFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6.5-1.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-6.5 3c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5"
]);
const $eb093920387c7bf0$export$4e2bb65ed10e8fba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMehRegular', "1em", [
    "M7.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 3.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
]);
const $eb093920387c7bf0$export$a288560eb88e362b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMemeFilled', "1em", [
    "M10 2a8 8 0 0 1 6.25 3H3.75A8 8 0 0 1 10 2m7 9h.94A8 8 0 0 1 2 10h1v1h1v1h6v-1h1v1h6zM6.19 13.44a.5.5 0 0 0-.08.7 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0 .5.5 0 0 0-.7-.07M18 6H3v1H2v1H1v1H0v2h1V9h1V8h2v2h1v1h4v-1h1V8h1v2h1v1h4v-1h1V8h1zM6 8v1h1v1H6V9H5V8zm7 0v1h1v1h-1V9h-1V8z"
]);
const $eb093920387c7bf0$export$259ed9f23e0cf751 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMemeRegular', "1em", [
    "M16.25 5a8 8 0 0 0-12.5 0H5.1a7 7 0 0 1 9.8 0zm1.69 6h-1.01A7 7 0 0 1 3 10H2a8 8 0 0 0 15.94 1M3 6h15v2h-1v2h-1v1h-4v-1h-1V8h-1v2H9v1H5v-1H4V8H2V7h1zM1 9V8h1v1zm0 0v2H0V9zm4-1v1h1V8zm1 1v1h1V9zm6-1v1h1V8zm1 1v1h1V9zm-6.11 3.51a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $eb093920387c7bf0$export$d20a77bf8f6c2676 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMultipleFilled', "1em", [
    "M2 7a5 5 0 0 0 4.03 4.9 6.5 6.5 0 0 1 1.66-3.78 2 2 0 0 0-2.21.58.5.5 0 1 1-.76-.65 3 3 0 0 1 3.76-.66 6.5 6.5 0 0 1 3.43-1.36A5 5 0 0 0 2 7m4.25-1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8.75 7a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.75-1a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m3.86 2.57a.5.5 0 0 0-.71.05 2.5 2.5 0 0 1-3.8 0 .5.5 0 1 0-.76.66 3.5 3.5 0 0 0 5.32 0 .5.5 0 0 0-.05-.71m-.61-1.82a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $eb093920387c7bf0$export$826588f6cebef02b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMultipleRegular', "1em", [
    "M7 2a5 5 0 0 1 4.9 4.03q-.5.04-.98.16a4 4 0 1 0-4.73 4.73q-.12.48-.16.99A5 5 0 0 1 7 2m.7 6.12q.36-.39.78-.73a3 3 0 0 0-3.76.66.5.5 0 1 0 .76.65 2 2 0 0 1 2.21-.58M6.24 5.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.25 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.6 1.82c.21.18.24.5.06.7a3.5 3.5 0 0 1-5.32.01.5.5 0 1 1 .76-.65 2.5 2.5 0 0 0 3.8 0 .5.5 0 0 1 .7-.06m-.6-1.82a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-2 5.75a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-1a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
]);
const $eb093920387c7bf0$export$7e6f7bba8f6de36f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.5-.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m.06 4.89c.38-.35.07-.72.06-.73l-.23-.23a4 4 0 0 0-.67-.49 5.3 5.3 0 0 0-2.72-.69 5.3 5.3 0 0 0-2.72.7 4 4 0 0 0-.9.7l-.01.03h-.01l.39.32-.39-.31a.5.5 0 0 0 .78.63l.02-.03q.04-.05.12-.11.15-.16.5-.37a4.3 4.3 0 0 1 2.22-.56 4.3 4.3 0 0 1 2.22.56 3 3 0 0 1 .64.5.5.5 0 0 0 .7.08"
]);
const $eb093920387c7bf0$export$13ec80666e2575ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadRegular', "1em", [
    "M7.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.06 4.89a.5.5 0 0 1-.7-.07l-.02-.03-.12-.12q-.15-.16-.5-.36a4.3 4.3 0 0 0-2.22-.56c-1.02 0-1.75.28-2.21.56a3 3 0 0 0-.65.5.5.5 0 0 1-.78-.62l.39.31-.39-.31v-.01l.02-.02.23-.23q.22-.2.67-.49c.6-.35 1.5-.69 2.72-.69a5.3 5.3 0 0 1 2.72.7 4 4 0 0 1 .9.71l.01.02h.01l-.39.32.39-.31a.5.5 0 0 1-.08.7M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $eb093920387c7bf0$export$15864f78df2c85ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadSlightFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m.3 4.5h.8a.5.5 0 0 1 0 1h-.8c-1.07 0-2.13.32-3.02.92a.5.5 0 1 1-.56-.84A6.5 6.5 0 0 1 12.8 12"
]);
const $eb093920387c7bf0$export$2f7dffdcc3c4ba03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadSlightRegular', "1em", [
    "M8.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m.3 2.5c-1.27 0-2.52.38-3.58 1.08a.5.5 0 0 0 .56.84c.9-.6 1.95-.92 3.02-.92h.8a.5.5 0 0 0 0-1zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
]);
const $eb093920387c7bf0$export$8f648b6624dfe4a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSmileSlightFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4.03 5.55c.42.21.97.32 1.53.32a3.5 3.5 0 0 0 1.53-.32.5.5 0 1 1 .44.9c-.58.29-1.28.43-1.97.43s-1.39-.14-1.97-.43a.5.5 0 1 1 .44-.9"
]);
const $eb093920387c7bf0$export$a4da5651a6f4624d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSmileSlightRegular', "1em", [
    "M13.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-.03 4.55a.5.5 0 1 0-.44.9c.58.29 1.28.43 1.97.43s1.39-.14 1.97-.43a.5.5 0 1 0-.44-.9c-.42.21-.97.32-1.53.32a3.5 3.5 0 0 1-1.53-.32M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $eb093920387c7bf0$export$82a4d5f83f354603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkleFilled', "1em", [
    "M15.23 1.35 14.88.28a.42.42 0 0 0-.8 0l-.35 1.07a2.2 2.2 0 0 1-1.38 1.4l-1.07.35a.4.4 0 0 0-.28.4.4.4 0 0 0 .28.4l.43.13.64.21a2.2 2.2 0 0 1 1.4 1.4l.35 1.08a.42.42 0 0 0 .8 0l.1-.32.23-.7V5.7l.02-.04a2 2 0 0 1 .7-1l-.01-.01q.31-.25.7-.39l1.08-.35a.42.42 0 0 0 0-.8h-.02l-1.08-.35a2.2 2.2 0 0 1-1.4-1.4m3.79 6.61.76.25h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.5 1.5 0 0 0-.38-.62 2 2 0 0 0-.62-.38l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .05-.18.3.3 0 0 1 .15-.1l.77-.26a2 2 0 0 0 .6-.38q.27-.26.38-.61l.25-.77a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1m-1.27 4.02a8 8 0 1 1-6.58-9.9l-.2.07a1.43 1.43 0 0 0-.9 1.78 1.4 1.4 0 0 0 .88.9l1.1.37a1.2 1.2 0 0 1 .76.76l.34 1.07q.14.4.46.66l.03.02.04.03q.21.15.44.2a1.3 1.3 0 0 0 .75 1.79l.8.25a.6.6 0 0 1 .35.37l.25.76a1.3 1.3 0 0 0 1.48.87M12.5 7.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.61 5.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $eb093920387c7bf0$export$a973847c459f9de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkleRegular', "1em", [
    "M15.23 1.35 14.88.28a.42.42 0 0 0-.8 0l-.35 1.07a2.2 2.2 0 0 1-1.38 1.4l-1.07.35a.42.42 0 0 0 0 .8l1.07.34a2.2 2.2 0 0 1 1.4 1.4l.35 1.08a.42.42 0 0 0 .8 0l.35-1.07a2.2 2.2 0 0 1 1.4-1.4l1.07-.35a.42.42 0 0 0 0-.8h-.02l-1.08-.35a2.2 2.2 0 0 1-1.4-1.4m3.79 6.61.76.25h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1m-2.25 3.82a1.3 1.3 0 0 0 .98.2 8 8 0 1 1-6.58-9.9l-.2.07a1.4 1.4 0 0 0-.88.85H10a7 7 0 1 0 6.77 8.78M12.5 7.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-5 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-.61 5.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $eb093920387c7bf0$export$f5efe075cc739140 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSurpriseFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.5-.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.25 3a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m.75-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $eb093920387c7bf0$export$75512da5f1a7573b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSurpriseRegular', "1em", [
    "M7.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.25 3a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m.75-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $eb093920387c7bf0$export$28b3ddead6794e64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_20_color__a)",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_20_color__b)",
            "fillRule": "evenodd",
            "d": "M7.85 2.3q-.46.64-.81 1.5c-.37.9-.65 2-.83 3.2H2.58q-.2.49-.33 1H6.1a22 22 0 0 0 0 4H2.25q.13.51.33 1h3.63c.18 1.2.46 2.3.83 3.2q.35.86.81 1.5a8 8 0 0 0 4.3 0q.46-.64.81-1.5c.37-.9.65-2 .83-3.2h3.63q.2-.49.33-1H13.9a22 22 0 0 0 0-4h3.84q-.13-.51-.33-1h-3.63c-.18-1.2-.46-2.3-.83-3.2a7 7 0 0 0-.81-1.5 8 8 0 0 0-4.3 0M7.22 7q.26-1.64.74-2.82.46-1.1 1-1.66Q9.5 1.98 10 2q.5-.02 1.03.52.54.56 1 1.66.5 1.19.75 2.82zM10 18q.5.02 1.03-.52.54-.56 1-1.66.5-1.19.75-2.82H7.22q.26 1.63.74 2.82.46 1.1 1 1.66.54.54 1.04.52m-3-8q0 1.04.1 2h5.8a21 21 0 0 0 0-4H7.1q-.1.96-.1 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(225 10.4 3.9)scale(12.7313)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#25a2f0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_20_color__a",
                "x1": "5.56",
                "x2": "17.11",
                "y1": "4.67",
                "y2": "15.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$2903b005f55c62c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76a21 21 0 0 1 0 5h3.75a8 8 0 0 0 0-5m-.41 6h-3.5q-.27 1.52-.76 2.7-.36.88-.83 1.52a8 8 0 0 0 5.09-4.22M10 18q.46.02 1-.52.55-.56 1.01-1.66.42-1 .67-2.32H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52m-2.1-.28a8 8 0 0 1-5.1-4.22h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.75a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M7 10q0-1.31.16-2.5h5.68a19 19 0 0 1 0 5H7.16Q7 11.31 7 10"
]);
const $eb093920387c7bf0$export$d88f20520242ce6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeRegular', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm1.03 0h5.16a9 9 0 0 1-.56 1.6C11.41 16.4 10.66 17 10 17s-1.4-.59-2.02-1.9q-.33-.71-.56-1.6m5.37-1H7.21a15 15 0 0 1 0-5h5.58a15 15 0 0 1 0 5m.82 1h2.45a7 7 0 0 1-3.77 3.12q.36-.5.64-1.1.4-.9.68-2.02m2.93-1h-2.73a16 16 0 0 0 0-5h2.73a7 7 0 0 1 0 5m-4.25-9.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1"
]);
const $eb093920387c7bf0$export$3ad9a2fcb4e3b7f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeAddFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $eb093920387c7bf0$export$a7f2ab7f2916930e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeAddRegular', "1em", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.13 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $eb093920387c7bf0$export$f8aca8b3f9db21df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForwardFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m5.05 1.52a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m4.66 3.7h-3.75q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.62 1.71a19 19 0 0 0-.14-1.71H7.16a19 19 0 0 0 0 5h2.21a5.5 5.5 0 0 1 3.61-3.29M7.32 13.5h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m-4.52 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm-.4-1h3.75a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7"
]);
const $eb093920387c7bf0$export$1bb9e607e498165a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForwardRegular', "1em", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.13 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7"
]);
const $eb093920387c7bf0$export$e4a35f340d44a010 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUpFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $eb093920387c7bf0$export$8095e5d9ec02f40f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUpRegular', "1em", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.14 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $eb093920387c7bf0$export$ebc8dc8b70088610 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClockFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $eb093920387c7bf0$export$6cdeecb4d9a2e68d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClockRegular', "1em", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.13 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $eb093920387c7bf0$export$4a83c644cc6de0f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeDesktopFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76Q14 8.7 14 10h4a8 8 0 0 0-.4-2.5m-4.77 0Q13 8.69 13 10h-2a2 2 0 0 0-2 2v.5H7.16a19 19 0 0 1 0-5zm-5.52 6H9V16a2 2 0 0 0 1.41 1.91Q10.2 18 10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M10 12a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-1h-2a1 1 0 0 1-1-1z"
]);
const $eb093920387c7bf0$export$253c28df11cf82b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeDesktopRegular', "1em", [
    "M10 18q.34 0 .67-.03a2 2 0 0 1-1.56-1.32 4 4 0 0 1-1.13-1.56q-.33-.7-.56-1.59H9v-1H7.2a15 15 0 0 1 0-5h5.6q.2 1.17.2 2.5h1q0-1.31-.2-2.5h2.74Q17 8.68 17 10h1a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M10 12a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-1h-2a1 1 0 0 1-1-1z"
]);
const $eb093920387c7bf0$export$1d3112fcbdb6c53b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeErrorFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $eb093920387c7bf0$export$676d41ab25fd2661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeErrorRegular', "1em", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.14 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $eb093920387c7bf0$export$a7d294f4f3880fa2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeLocationFilled', "1em", [
    "M7.32 6.5q.26-1.32.67-2.32.46-1.1 1-1.66Q9.54 1.98 10 2q.46-.02 1 .52.55.56 1.01 1.66.42 1 .67 2.32zm-.26-2.7q.36-.88.83-1.52A8 8 0 0 0 2.8 6.5h3.5q.28-1.51.76-2.7m5.88 0a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m.91 3.7h3.75q.36 1.07.4 2.25a4.52 4.52 0 0 0-4-.5q-.04-.9-.15-1.75M13 9.76q-.02-1.19-.16-2.26H7.16a19 19 0 0 0 0 5h3.98c.27-1.13.93-2.1 1.86-2.74m-2 3.74H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52.46.02 1-.52.38-.39.74-1.06A6 6 0 0 1 11 13.5m-8.2 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm3.35-1H2.4a8 8 0 0 1 0-5h3.75a21 21 0 0 0 0 5M19 13.68c0-2.03-1.47-3.68-3.5-3.68S12 11.65 12 13.68c0 1.53.98 3.53 3.26 5.24.14.1.34.1.49 0 2.27-1.7 3.25-3.71 3.25-5.24m-2-.18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $eb093920387c7bf0$export$afc41d91fc51e496 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeLocationRegular', "1em", [
    "M10 18a8 8 0 0 0 2.5-.4 8 8 0 0 1-.98-1.63Q10.75 17.01 10 17c-.66 0-1.4-.59-2.02-1.9q-.33-.71-.56-1.6H11q.02-.51.14-1H7.21a15 15 0 0 1 0-5h5.58q.19 1.05.2 2.26.46-.31 1-.5-.05-.92-.18-1.76h2.73q.32.82.42 1.74.56.19 1.04.51A8 8 0 1 0 10 18m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 13.68c0-2.03-1.47-3.68-3.5-3.68S12 11.65 12 13.68c0 1.53.98 3.53 3.26 5.24.14.1.34.1.49 0 2.27-1.7 3.25-3.71 3.25-5.24m-2-.18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $eb093920387c7bf0$export$e1744a6031f39f78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOffFilled', "1em", [
    "M4 4.7a8 8 0 0 0-1.2 1.8h3l1.32 1.33a20 20 0 0 0 .04 4.67h4.63l1.75 1.75q-.24 1.07-.6 1.95t-.83 1.52A8 8 0 0 0 15.29 16l1.86 1.85a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7zm3.56.74L8.62 6.5h4.06q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66-.24.57-.43 1.26M9.62 7.5l3.36 3.36a21 21 0 0 0-.14-3.36zm4.3 4.3.7.7h2.98a8 8 0 0 0 0-5h-3.75a21 21 0 0 1 .07 4.3m1.7 1.7 1 1a8 8 0 0 0 .58-1zM5.5 3.38l1.26 1.26.3-.84q.36-.88.83-1.52-1.3.36-2.39 1.1m6.61-1.1q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22M10 18q.46.02 1-.52.55-.56 1.01-1.66.42-1 .67-2.32H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52m-2.1-.28a8 8 0 0 1-5.1-4.22h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.75a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5"
]);
const $eb093920387c7bf0$export$13a2564928dc14b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOffRegular', "1em", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7m10.58 10.6-1.14-1.15q-.22.74-.51 1.36-.28.61-.64 1.1a7 7 0 0 0 2.3-1.32m-2.79-2.8L7.15 7.86a15 15 0 0 0 .06 4.64zm-6-6L4.71 5.42q-.44.5-.77 1.08zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m4.95-.42q.33-.7.56-1.59H7.42q.23.89.56 1.6C8.59 16.4 9.34 17 10 17s1.4-.59 2.02-1.9M7.07 4.5q-.08.14-.14.32l.77.77q.13-.36.28-.67C8.59 3.59 9.34 3 10 3s1.4.59 2.02 1.9q.33.71.56 1.6H8.62l1 1h3.17a15 15 0 0 1 .19 3.36l.92.92a16 16 0 0 0-.1-4.28h2.74a7 7 0 0 1 0 5h-1.92l2 2A8 8 0 0 0 5.5 3.39l.72.71q.7-.45 1.48-.72-.36.5-.64 1.1m9 2.01H13.6a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1a7 7 0 0 1 3.77 3.11"
]);
const $eb093920387c7bf0$export$806ecc5a65c185b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobePersonFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.11.92.14 1.9a3 3 0 0 1 4 .93 8 8 0 0 0-.39-2.83M13 10v.35a3 3 0 0 0-.46 2.15H7.16a19 19 0 0 1 0-5h5.68Q13 8.69 13 10m-.32 3.5q-.07.36-.15.7A2.5 2.5 0 0 0 11 16.5q0 .44.12.86l-.12.12q-.54.54-1 .52-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32zM7.9 17.72A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $eb093920387c7bf0$export$dd7fdf095e5c115 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobePersonRegular', "1em", [
    "M11.31 17.9q-.63.1-1.31.1a8 8 0 1 1 8-7.67 3 3 0 0 0-1.03-.94q-.08-1-.43-1.89h-2.73q.15.91.18 1.9-.6.36-1 .95a16 16 0 0 0-.2-2.85H7.21a15 15 0 0 0 0 5h5.33q.1.54.36 1H7.42q.23.89.56 1.6C8.59 16.4 9.34 17 10 17q.48 0 1-.44 0 .7.31 1.33m.71-13C11.41 3.6 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m9-9.01a7 7 0 0 0-3.78-3.12q.36.5.64 1.1.4.9.68 2.02zM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $eb093920387c7bf0$export$a1cb64e02a4a0eda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibitedFilled', "1em", [
    "M7.32 6.5q.26-1.32.67-2.32.46-1.1 1-1.66Q9.54 1.98 10 2q.46-.02 1 .52.55.56 1.01 1.66.42 1 .67 2.32zm-.26-2.7q.36-.88.83-1.52A8 8 0 0 0 2.8 6.5h3.5q.28-1.51.76-2.7m5.88 0a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m.91 3.7h3.75a8 8 0 0 1 .4 2.75 5.5 5.5 0 0 0-4.02-1.23q-.04-.78-.13-1.52m-.87 1.71a19 19 0 0 0-.14-1.71H7.16a19 19 0 0 0 0 5h2.21a5.5 5.5 0 0 1 3.61-3.29M9.1 13.5H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52.12 0 .23-.03A5.5 5.5 0 0 1 9.1 13.5m-6.29 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm3.35-1H2.4a8 8 0 0 1 0-5h3.75a21 21 0 0 0 0 5m3.85 2a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m2.4 2.8 4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-5.6 2.8m-.7-.7a3.5 3.5 0 0 1 4.9-4.9z"
]);
const $eb093920387c7bf0$export$b1af6a695a6733fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibitedRegular', "1em", [
    "M10.25 18H10a8 8 0 1 1 8-7.75 6 6 0 0 0-1.01-.66 7 7 0 0 0-.45-2.09h-2.73q.12.73.16 1.53-.51.05-.99.18-.05-.9-.19-1.71H7.21a15 15 0 0 0 0 5h2.16q-.19.48-.28 1H7.42q.23.89.56 1.6c.48 1.02 1.04 1.6 1.58 1.81q.28.6.7 1.09m1.77-13.1C11.41 3.6 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m9-9.01a7 7 0 0 0-3.78-3.12q.36.5.64 1.1.4.9.68 2.02zm-6.07 8a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m2.4 2.8 4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-5.6 2.8m-.7-.7a3.5 3.5 0 0 1 4.9-4.9z"
]);
const $eb093920387c7bf0$export$eabda0739482553 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSearchFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m5.05 1.52a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.28-1.51-.76-2.7m4.66 3.7h-3.75a21 21 0 0 1 0 5h3.75a8 8 0 0 0 0-5m-3.9 6h3.5a8 8 0 0 1-5.09 4.22q.47-.65.83-1.52.49-1.18.76-2.7m-4.14.44q.1-.21.18-.44h2.94a12 12 0 0 1-.87 2.77 2 2 0 0 0-.25-.33zm.41-1.44h2.87a19 19 0 0 0 0-5H7.16l-.04.3a4.5 4.5 0 0 1 2.85 4.7m-3.82-5v.05a5 5 0 0 0-.65-.05zm-3.75 0h3.1c-1.39 0-2.63.63-3.45 1.61q.1-.83.35-1.61m3.1 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L8.3 14.1a3.5 3.5 0 1 0-2.8 1.4m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $eb093920387c7bf0$export$912d6370ada37546 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSearchRegular', "1em", [
    "M2.05 9.11a8 8 0 1 1 9.72 8.7 1.5 1.5 0 0 0-.2-1.87l-.02-.01q.24-.36.47-.84.33-.7.56-1.59H9.74q.18-.48.23-1h2.82a15 15 0 0 0 0-5H7.21l-.05.31q-.47-.18-.98-.26l.01-.05H3.46l-.2.6q-.7.4-1.21 1.01m9.97-4.2C11.41 3.59 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zm9.67 7h-2.45q-.26 1.12-.68 2.01-.28.61-.64 1.1a7 7 0 0 0 3.77-3.11m-2.25-1h2.73a7 7 0 0 0 0-5h-2.73a16 16 0 0 1 0 5m2.25-6a7 7 0 0 0-3.77-3.12q.36.5.64 1.1.4.9.68 2.02zM8.3 14.1q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zM8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $eb093920387c7bf0$export$6f90056a5110732d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShieldColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__a)",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__b)",
            "fillOpacity": ".7",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__c)",
            "fillOpacity": ".2",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__d)",
            "fillRule": "evenodd",
            "d": "M7.85 2.3q-.46.64-.81 1.5c-.37.9-.65 2-.83 3.2H2.58q-.2.49-.33 1H6.1a22 22 0 0 0 0 4H2.25q.13.51.33 1h3.63c.18 1.2.46 2.3.83 3.2q.35.86.81 1.5a8 8 0 0 0 4.3 0q.46-.64.81-1.5c.37-.9.65-2 .83-3.2h3.63q.2-.49.33-1H13.9a22 22 0 0 0 0-4h3.84q-.13-.51-.33-1h-3.63c-.18-1.2-.46-2.3-.83-3.2a7 7 0 0 0-.81-1.5 8 8 0 0 0-4.3 0M7.22 7q.26-1.64.74-2.82.46-1.1 1-1.66Q9.5 1.98 10 2q.5-.02 1.03.52.54.56 1 1.66.5 1.19.75 2.82zM10 18q.5.02 1.03-.52.54-.56 1-1.66.5-1.19.75-2.82H7.22q.26 1.63.74 2.82.46 1.1 1 1.66.54.54 1.04.52m-3-8q0 1.04.1 2h5.8a21 21 0 0 0 0-4H7.1q-.1.96-.1 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__e)",
            "d": "M14 18.52a5.1 5.1 0 0 1-3-4.58v-2.5c0-.28.23-.5.5-.54a5.7 5.7 0 0 0 3.06-1.72A.6.6 0 0 1 15 9a.6.6 0 0 1 .44.18 5.7 5.7 0 0 0 3.06 1.72c.27.04.5.26.5.54V14a5.1 5.1 0 0 1-3 4.52 7 7 0 0 1-1 .4l-.13-.02a7 7 0 0 1-.87-.38"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "translate(14.94 14.13)scale(-6.72116)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.28 -13.13 29.6)scale(10.5253 11.4176)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1b44b1",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(45.02 -9.4 25.1)scale(12.0242 12.8442)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#3bd5ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".81",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__a",
                "x1": "5.56",
                "x2": "17.11",
                "y1": "4.67",
                "y2": "15.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__e",
                "x1": "12.5",
                "x2": "20.02",
                "y1": "9",
                "y2": "17.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#62be55"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1e794a"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$8096db6d93ce0f72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShieldFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76l.1.95a1.63 1.63 0 0 1 2.2.09c.42.43 1.08.98 1.85 1.27a8 8 0 0 0-.4-2.31m-4.77 0q.12.85.15 1.78c-.47.33-1.03.61-1.63.7-.68.09-1.36.66-1.36 1.52v1H7.16a19 19 0 0 1 0-5zm-5.52 6H10v.5c0 1.42.45 2.55 1.07 3.4l-.07.08q-.54.54-1 .52-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.11-1.54a5.7 5.7 0 0 1-3.06-1.72.6.6 0 0 0-.88 0 5.7 5.7 0 0 1-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 0 0 .26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54"
]);
const $eb093920387c7bf0$export$f0d09d55d141906 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShieldRegular', "1em", [
    "M10 18q.74 0 1.44-.13a6 6 0 0 1-.75-1.08q-.36.21-.69.21c-.66 0-1.4-.59-2.02-1.9q-.33-.71-.56-1.6H10v-1H7.2a15 15 0 0 1 0-5h5.6q.14.85.18 1.78a6 6 0 0 0 .95-.82q-.04-.49-.12-.96h2.73q.32.82.42 1.74.46.34 1.04.57A8 8 0 1 0 10 18m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1m6.21 7.58a5.7 5.7 0 0 1-3.06-1.72.6.6 0 0 0-.88 0 5.7 5.7 0 0 1-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 0 0 .26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54"
]);
const $eb093920387c7bf0$export$cd0480c585608b0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStandFilled', "1em", [
    "M17.5 10a.5.5 0 0 1 0 1h-.57a7 7 0 0 1-5.36 5.82c.76-1.24 1.29-3.36 1.4-5.82h-1c-.08 1.7-.37 3.2-.79 4.3a5 5 0 0 1-.68 1.31V18h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.39a5 5 0 0 1-.68-1.3c-.42-1.1-.7-2.6-.8-4.31h-1c.12 2.46.65 4.58 1.41 5.82A7 7 0 0 1 3.07 11H2.5a.5.5 0 0 1 0-1zM8.43 3.18C7.67 4.42 7.14 6.54 7.03 9H3.06a7 7 0 0 1 5.36-5.82M10 1c.28 0 .5.22.5.5v1.89q.35.43.68 1.3c.42 1.1.7 2.6.8 4.31H8.02c.08-1.7.37-3.2.79-4.3q.33-.9.68-1.31V1.5c0-.28.22-.5.5-.5m1.57 2.18A7 7 0 0 1 16.93 9h-3.95c-.12-2.46-.65-4.58-1.41-5.82"
]);
const $eb093920387c7bf0$export$33c786963a8597fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStandRegular', "1em", [
    "M10 1c.28 0 .5.22.5.5v1.52a7 7 0 0 1 6.48 6.48h.52a.5.5 0 0 1 0 1h-.52a7 7 0 0 1-6.48 6.48V18h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.02a7 7 0 0 1-6.48-6.48H2.5a.5.5 0 0 1 0-1h.52A7 7 0 0 1 9.5 3.02V1.5c0-.28.22-.5.5-.5m-1.99 9.5c.05 1.62.35 3.04.79 4.06q.37.82.74 1.18c.23.23.38.26.46.26s.23-.03.46-.26q.37-.36.74-1.18c.44-1.02.74-2.44.79-4.06zm-3.99 0a6 6 0 0 0 4.27 5.25c-.72-1.17-1.22-3.07-1.28-5.25zm8.97 0c-.06 2.18-.56 4.08-1.28 5.25a6 6 0 0 0 4.27-5.25zM8.3 4.25A6 6 0 0 0 4.02 9.5h2.99c.06-2.18.56-4.08 1.28-5.25M10 4c-.08 0-.23.03-.46.26q-.37.36-.74 1.18A12 12 0 0 0 8 9.5H12a12 12 0 0 0-.79-4.06q-.37-.82-.74-1.18C10.23 4.03 10.08 4 10 4m1.7.25c.73 1.17 1.23 3.07 1.3 5.25h2.98a6 6 0 0 0-4.27-5.25"
]);
const $eb093920387c7bf0$export$e1c0fa8236f7d6a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStarFilled', "1em", [
    "M7.32 6.5q.26-1.32.67-2.32.46-1.1 1-1.66Q9.54 1.98 10 2q.46-.02 1 .52.55.56 1.01 1.66.42 1 .67 2.32zm-.26-2.7q.36-.88.83-1.52A8 8 0 0 0 2.8 6.5h3.5q.28-1.51.76-2.7m5.88 0a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m.91 3.7h3.75a8 8 0 0 1 .4 2.75 5.5 5.5 0 0 0-4.02-1.23q-.04-.78-.13-1.52m-.87 1.71a19 19 0 0 0-.14-1.71H7.16a19 19 0 0 0 0 5h2.21a5.5 5.5 0 0 1 3.61-3.29M9.1 13.5H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52.12 0 .23-.03A5.5 5.5 0 0 1 9.1 13.5m-6.29 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm3.35-1H2.4a8 8 0 0 1 0-5h3.75a21 21 0 0 0 0 5M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.95-5.6H17c.48 0 .68.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 0 1 .96 0z"
]);
const $eb093920387c7bf0$export$5ba1594ab3f57a16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStarRegular', "1em", [
    "M10.25 18H10a8 8 0 1 1 8-7.75 6 6 0 0 0-1.01-.66 7 7 0 0 0-.45-2.09h-2.73q.12.73.16 1.53-.51.05-.99.18-.05-.9-.19-1.71H7.21a15 15 0 0 0 0 5h2.16q-.19.48-.28 1H7.42q.23.89.56 1.6c.48 1.02 1.04 1.6 1.58 1.81q.28.6.7 1.09m1.77-13.1C11.41 3.6 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m9-9.01a7 7 0 0 0-3.78-3.12q.36.5.64 1.1.4.9.68 2.02zM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.95-5.6H17c.48 0 .68.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 0 1 .96 0z"
]);
const $eb093920387c7bf0$export$a447752cb7551b0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurfaceFilled', "1em", [
    "M8.12 7q.18-1.41.58-2.42.32-.83.7-1.23c.24-.27.44-.35.6-.35s.36.08.6.35q.38.4.7 1.23.4 1 .58 2.42zm-.35-2.78q.2-.52.45-.95A6 6 0 0 0 4.34 7h2.78q.19-1.6.65-2.78m4.46 0a6 6 0 0 0-.45-.95A6 6 0 0 1 15.66 7h-2.78q-.19-1.6-.65-2.78M12.97 8h2.95a6 6 0 0 1 0 2h-2.95a17 17 0 0 0 0-2m-.09 3h2.78a6 6 0 0 1-3.88 3.73q.25-.42.45-.95.46-1.19.65-2.78m-2.28 3.65c-.24.27-.44.35-.6.35s-.36-.08-.6-.35a4 4 0 0 1-.7-1.23q-.4-1-.58-2.42h3.76q-.18 1.41-.58 2.42-.32.83-.7 1.23M4.34 11a6 6 0 0 0 3.88 3.73q-.26-.42-.45-.95-.46-1.19-.65-2.78zm2.69-1H4.08a6 6 0 0 1 0-2h2.95a17 17 0 0 0 0 2m1-2a16 16 0 0 0 0 2h3.94a16 16 0 0 0 0-2zM3.5 13h.75q.38.54.84 1H3.9l-.75 3h13.72l-.75-3H14.9q.48-.46.85-1h.75a.5.5 0 0 1 .49.38l1 4a.5.5 0 0 1-.49.62h-15a.5.5 0 0 1-.49-.62l1-4A.5.5 0 0 1 3.5 13"
]);
const $eb093920387c7bf0$export$61214fcdc904fc18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurfaceRegular', "1em", [
    "M10 3a6 6 0 1 1 0 12 6 6 0 0 1 0-12m0 11c.25 0 .74-.23 1.23-1.2q.37-.75.58-1.8H8.2q.2 1.05.58 1.8c.5.97.98 1.2 1.23 1.2m-1.95-4h3.9a11 11 0 0 0 0-2h-3.9a11 11 0 0 0 0 2m3.86 3.62A5 5 0 0 0 14.58 11h-1.75a8 8 0 0 1-.92 2.62M12.96 10h1.94a5 5 0 0 0 0-2h-1.94a12 12 0 0 1 0 2M11.9 4.38c.42.68.74 1.59.92 2.62h1.75a5 5 0 0 0-2.67-2.62m-.68.82C10.73 4.23 10.25 4 10 4s-.74.23-1.23 1.2Q8.4 5.95 8.2 7h3.62q-.2-1.05-.58-1.8m-3.14-.82A5 5 0 0 0 5.42 7h1.75c.18-1.03.5-1.94.92-2.62M5 9q0 .52.1 1h1.94a12 12 0 0 1 0-2H5.1Q5 8.48 5 9m.42 2a5 5 0 0 0 2.67 2.62A8 8 0 0 1 7.17 11zM3.5 13h.75q.39.54.85 1H3.9l-.75 3h13.72l-.75-3H14.9q.47-.46.85-1h.75a.5.5 0 0 1 .49.38l1 4a.5.5 0 0 1-.49.62h-15a.5.5 0 0 1-.49-.62l1-4A.5.5 0 0 1 3.5 13"
]);
const $eb093920387c7bf0$export$ba73f72e0b33d2a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSyncFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m7.61 2a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $eb093920387c7bf0$export$651da58d5900d0ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSyncRegular', "1em", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.14 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $eb093920387c7bf0$export$f078f7fca2acb9d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideoFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76a21 21 0 0 1 .13 3.5h.52c.93 0 1.74.5 2.17 1.26l.5-.4q.33-.24.68-.32a8 8 0 0 0-.25-4.04M13 10q0 .5-.02 1H11.5a2.5 2.5 0 0 0-2.3 1.5H7.17a19 19 0 0 1 0-5h5.68Q13 8.69 13 10m-5.68 3.5H9v3.99q-.55-.57-1.01-1.67-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m7.61 1c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v.53l1.79-1.37a.75.75 0 0 1 1.2.6v4.5c0 .61-.7.97-1.2.59L16 16.97v.53c0 .83-.67 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $eb093920387c7bf0$export$5636ece2f7952123 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideoRegular', "1em", [
    "M2 10a8 8 0 0 0 7.04 7.94Q9 17.73 9 17.5v-.94q-.54-.46-1.02-1.47-.33-.7-.56-1.59H9q0-.54.2-1h-2a15 15 0 0 1 0-5h5.6a15 15 0 0 1 .17 3.5h1a17 17 0 0 0-.16-3.5h2.73a7 7 0 0 1 .1 4.71l.03.05.5-.4q.33-.24.68-.32Q18 10.8 18 10a8 8 0 1 0-16 0m8-7c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M10 13.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v.53l1.79-1.37a.75.75 0 0 1 1.2.6v4.5c0 .61-.7.97-1.2.59L16 16.97v.53c0 .83-.67 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $eb093920387c7bf0$export$e4802c4cd07849cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarningFilled', "1em", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.57a2 2 0 0 1 2.31 1.04l1.2 2.39h.11a8 8 0 0 0 0-5m-4.77 0Q13 8.54 13 9.68q-.16.18-.29.43l-1.2 2.39H7.17a19 19 0 0 1 0-5zm-5.52 6h3.7l-1.8 3.6q-.11.23-.16.44L9 17.48q-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m11.21-1.95-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $eb093920387c7bf0$export$c10e4f345865f1ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarningRegular', "1em", [
    "M2 10a8 8 0 0 0 7 7.94 2 2 0 0 1 .22-.84l.14-.28a3.7 3.7 0 0 1-1.38-1.73q-.33-.7-.56-1.59h3.6l.5-1H7.2a15 15 0 0 1 0-5h5.58q.19 1.02.2 2.18.42-.46.98-.61-.04-.82-.16-1.57h2.73a7 7 0 0 1 .34 3.79l.68 1.34A7.99 7.99 0 1 0 2 10m8-7c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1m1.31 7.17-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $eb093920387c7bf0$export$12e9264d585d3472 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__a)",
            "fillRule": "evenodd",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5zm3 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5zm3 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__c)",
            "fillOpacity": ".9",
            "d": "M8.3 15.73q.65.26 1.7.27 1.04 0 1.7-.27c1.8-.66 1.8-2.33 1.8-2.33 0-.77-.64-1.4-1.43-1.4H7.93c-.79 0-1.43.63-1.43 1.4 0 0 0 1.67 1.8 2.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__d)",
            "fillOpacity": ".9",
            "d": "M10 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__a",
                "x1": "0",
                "x2": "16.02",
                "y1": "-1.5",
                "y2": "12.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__b",
                "x1": "11.86",
                "x2": "16.9",
                "y1": "3.97",
                "y2": "20.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__c",
                "x1": "15.25",
                "x2": "10.97",
                "y1": "19.43",
                "y2": "5.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__d",
                "x1": "13",
                "x2": "6.66",
                "y1": "14.43",
                "y2": "2.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$94d8f902cd02134d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestFilled', "1em", [
    "M16 3.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zm-8 1c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M10 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-2.25 5h4.5c.66 0 1.3.55 1.22 1.3a3 3 0 0 1-.79 1.8c-.55.57-1.41.9-2.68.9s-2.13-.33-2.68-.9a3 3 0 0 1-.79-1.8c-.08-.75.56-1.3 1.22-1.3"
]);
const $eb093920387c7bf0$export$f3a9a0f7206f0132 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestRegular', "1em", [
    "M8 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3.47 5.3c-.08-.75.56-1.3 1.22-1.3h4.5c.66 0 1.3.55 1.22 1.3a3 3 0 0 1-.79 1.8c-.55.57-1.41.9-2.68.9s-2.13-.33-2.68-.9a3 3 0 0 1-.79-1.8m1.04-.23a.2.2 0 0 0-.04.13c.04.45.18.88.5 1.2.3.32.88.6 1.97.6 1.1 0 1.66-.28 1.98-.6.31-.32.45-.75.5-1.2q0-.07-.05-.13a.3.3 0 0 0-.18-.07h-4.5a.3.3 0 0 0-.18.07M8.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm7.5-.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zM5.5 3h9c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5"
]);
const $eb093920387c7bf0$export$d8306c9bb5616d0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestAddFilled', "1em", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-1.24-3.08 3.5 3.5 0 0 1-1.59-.69 2.5 2.5 0 0 1-.93-1.98c0-.69.56-1.25 1.25-1.25h2.5A5.5 5.5 0 0 1 16 9.2V4a2 2 0 0 0-2-2zm2.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M8 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $eb093920387c7bf0$export$19f9d2ede8e3c1ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestAddRegular', "1em", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a6 6 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02q.51.05 1 .19V4a2 2 0 0 0-2-2zm1.75 9h2.5q-.38.46-.65 1H7.75a.25.25 0 0 0-.25.25q0 .73.57 1.2.35.3.96.45a6 6 0 0 0-.01 1.02 3.5 3.5 0 0 1-1.59-.69 2.5 2.5 0 0 1-.93-1.98c0-.69.56-1.25 1.25-1.25m.75-7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM9 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $eb093920387c7bf0$export$16507df248effdd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNowFilled', "1em", [
    "M6.9 2.03a7 7 0 0 0-1.15.54h-.02v.01L6 3l-.28-.42a.5.5 0 0 0 .56.84l.22-.13q.25-.14.73-.32A8 8 0 0 1 10 2.5a8 8 0 0 1 3.5.79l.22.12.26-.39-.26.4a.5.5 0 1 0 .56-.84L14 3l.28-.42h-.01l-.02-.01-.3-.17q-.3-.16-.84-.37A9 9 0 0 0 10 1.5a9 9 0 0 0-3.1.53m-.01 15.94c.73.27 1.8.53 3.11.53a9 9 0 0 0 3.96-.9l.29-.17h.02v-.01L14 17l.28.42a.5.5 0 0 0-.56-.84l.26.4-.26-.4-.22.13q-.25.14-.73.32a8 8 0 0 1-2.77.47 8 8 0 0 1-3.5-.79l-.22-.12a.5.5 0 0 0-.56.83L6 17l-.28.42h.01l.02.01.3.17q.3.16.84.37M2.5 7v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2m11 4.55 2.78 2.26a.75.75 0 0 0 1.22-.59V6.78a.75.75 0 0 0-1.22-.59L13.5 8.45z"
]);
const $eb093920387c7bf0$export$31066c6654690916 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNowRegular', "1em", [
    "M5 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-1.03l2.84 1.85a.75.75 0 0 0 1.16-.63V6.8c0-.6-.66-.95-1.16-.63L13 8.03V7a2 2 0 0 0-2-2zm8 4.22 3-1.95v5.46l-3-1.95zM12 7v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1M6.9 2.03a7 7 0 0 0-1.15.54h-.02v.01L6 3l-.28-.42a.5.5 0 0 0 .56.84l.22-.13q.25-.14.73-.32A8 8 0 0 1 10 2.5a8 8 0 0 1 3.5.79l.22.12.26-.39-.26.4a.5.5 0 1 0 .56-.84L14 3l.28-.42h-.01l-.02-.01-.3-.17q-.3-.16-.84-.37A9 9 0 0 0 10 1.5a9 9 0 0 0-3.1.53m-.01 15.94c.73.27 1.8.53 3.11.53a9 9 0 0 0 3.96-.9l.29-.17h.02v-.01L14 17l.28.42a.5.5 0 0 0-.56-.84l.26.4-.26-.4-.22.13q-.25.14-.73.32a8 8 0 0 1-2.77.47 8 8 0 0 1-3.5-.79l-.22-.12a.5.5 0 0 0-.56.83L6 17l-.28.42h.01l.02.01.3.17q.3.16.84.37m6.83-1.39"
]);
const $eb093920387c7bf0$export$38290e9947e2f6c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoldFilled', "1em", [
    "M13 1c.28 0 .5.22.5.5v1.51a4 4 0 0 1 2 .78l1.65-1.64a.5.5 0 0 1 .7.7L16.21 4.5c.46.6.72 1.3.78 2.01h1.51a.5.5 0 0 1 0 1h-1.56a4 4 0 0 1-1.06 2l-1.33 1.34 1.3 1.3a.5.5 0 0 1-.7.71l-1.31-1.3-2.3 2.29 1.31 1.3a.5.5 0 0 1-.7.71l-1.31-1.3-1.34 1.33a4 4 0 0 1-2 1.06v1.56a.5.5 0 0 1-1 0v-1.51a4 4 0 0 1-2-.78l-1.65 1.65a.5.5 0 0 1-.7-.71l1.64-1.64A4 4 0 0 1 3 13.5H1.5a.5.5 0 0 1 0-1h1.56a4 4 0 0 1 1.06-2l1.33-1.34-1.3-1.3a.5.5 0 1 1 .7-.71l1.31 1.3 2.3-2.29-1.31-1.3a.5.5 0 1 1 .7-.71l1.31 1.3 1.34-1.33a4 4 0 0 1 2-1.06V1.5c0-.28.22-.5.5-.5M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M14 6.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $eb093920387c7bf0$export$9ab707b55f0c8435 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoldRegular', "1em", [
    "M13.5 1.5a.5.5 0 0 0-1 0v1.56a4 4 0 0 0-2 1.06L9.16 5.45l-1.3-1.3a.5.5 0 1 0-.71.7l1.3 1.31-2.29 2.3-1.3-1.31a.5.5 0 1 0-.71.7l1.3 1.31-1.33 1.34a4 4 0 0 0-1.06 2H1.5a.5.5 0 0 0 0 1h1.51c.06.71.32 1.41.78 2l-1.65 1.65a.5.5 0 1 0 .71.7l1.64-1.64c.6.46 1.3.72 2.01.78v1.51a.5.5 0 0 0 1 0v-1.56a4 4 0 0 0 2-1.06l1.34-1.33 1.3 1.3a.5.5 0 0 0 .71-.7l-1.3-1.31 2.29-2.3 1.3 1.31a.5.5 0 0 0 .71-.7l-1.3-1.31 1.33-1.34a4 4 0 0 0 1.06-2h1.56a.5.5 0 0 0 0-1h-1.51a4 4 0 0 0-.78-2l1.64-1.65a.5.5 0 0 0-.7-.7L15.5 3.79A4 4 0 0 0 13.5 3zM4 13.24v-.1c.01-.7.29-1.4.82-1.94l6.38-6.38a2.8 2.8 0 0 1 3.98 3.98l-6.39 6.38A2.8 2.8 0 0 1 4 13.24m2.75.76a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M14 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $eb093920387c7bf0$export$a69cc23f37563114 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoleculeColor', "1em", [
    [
        "path",
        {
            "fill": "#212121",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__a)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__b)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__c)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__d)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__e)",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__f)",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__g)",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "circle",
        {
            "cx": "13",
            "cy": "6",
            "r": "4",
            "fill": "url(#ic_fluent_molecule_20_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "5.5",
            "cy": "11.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_molecule_20_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "15.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_molecule_20_color__j)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(151.69 1.99 5.64)scale(2.35056 2.51001)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-28.31 20.03 -17.2)scale(2.35056 2.51001)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(151.69 1.99 5.64)scale(2.35056 2.51001)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2.60262 0 0 2.94798 7.4 12.34)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-90.88 14.03 1.12)scale(2.89471 2.77447)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__a",
                "x1": "5.66",
                "x2": "6.75",
                "y1": "5.83",
                "y2": "10.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__e",
                "x1": "7.16",
                "x2": "8.16",
                "y1": "11.83",
                "y2": "16.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__h",
                "x1": "9.29",
                "x2": "14.81",
                "y1": "3.5",
                "y2": "9.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__i",
                "x1": "2.25",
                "x2": "7.08",
                "y1": "9.31",
                "y2": "14.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__j",
                "x1": "11.78",
                "x2": "15.06",
                "y1": "12.22",
                "y2": "18.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$98c9942b93836c45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoleculeFilled', "1em", [
    "M17 6a4 4 0 0 1-7.33 2.22l-1.66.84a3.5 3.5 0 0 1 .82 3.5l2.7 1.4a2.5 2.5 0 1 1-.44.89l-2.7-1.38A3.5 3.5 0 1 1 7.1 8.39l2.13-1.06A4 4 0 1 1 17 6"
]);
const $eb093920387c7bf0$export$eb612cbfc54b3159 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoleculeRegular', "1em", [
    "M13 10a4 4 0 1 0-3.77-2.67L7.1 8.39a3.5 3.5 0 1 0 1.3 5.08l2.69 1.38a2.5 2.5 0 1 0 .44-.9l-2.7-1.38a3.5 3.5 0 0 0-.82-3.51l1.66-.84A4 4 0 0 0 13 10m0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-7.5 5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $eb093920387c7bf0$export$2a96ec18fcd353e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFilled', "1em", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-2a.75.75 0 0 1 1.5 0v2c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5C3 4.45 4.46 3 6.25 3h2a.75.75 0 0 1 0 1.5zm4.25-.75c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75v5a.75.75 0 0 1-1.5 0V5.56l-3.72 3.72a.75.75 0 1 1-1.06-1.06l3.72-3.72h-3.19a.75.75 0 0 1-.75-.75"
]);
const $eb093920387c7bf0$export$ade77fdf70e6d08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenRegular', "1em", [
    "M6 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1zm5-.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V4.7l-4.15 4.15a.5.5 0 0 1-.7-.7L15.29 4H11.5a.5.5 0 0 1-.5-.5"
]);
const $eb093920387c7bf0$export$af3f608e66e6856 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolderFilled', "1em", [
    "M3 6.25C3 4.45 4.46 3 6.25 3H14c1.8 0 3.25 1.46 3.25 3.25v2a.75.75 0 0 1-1.5 0v-2c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h4a.75.75 0 0 1 0 1.5h-4A3.25 3.25 0 0 1 3 13.75zm5 2.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l5.22 5.22a.75.75 0 1 1-1.06 1.06L9.5 10.56v2.69a.75.75 0 0 1-1.5 0z"
]);
const $eb093920387c7bf0$export$a606128ecb01fcfc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolderRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.5a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3zm2.15 5.15A.5.5 0 0 1 8.5 8h4.99a.5.5 0 0 1 0 1H9.7l6.15 6.15a.5.5 0 0 1-.7.7L9 9.71v3.79a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .15-.35"
]);
const $eb093920387c7bf0$export$4365ba3578c89eb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOffFilled', "1em", [
    "m2.85 2.15 15 15a.5.5 0 0 1-.7.7l-1.48-1.48q-.83.61-1.92.63h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5q.01-1.1.63-1.92L2.15 2.85a.5.5 0 1 1 .7-.7m11.73 13.14L4.71 5.42q-.2.38-.21.83v7.5c0 .97.78 1.75 1.75 1.75h7.5q.46 0 .83-.21m-4.01-6.85.99 1a1 1 0 0 0 .22-.16l3.72-3.72v3.19a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0 0 1.5h3.19l-3.72 3.72a1 1 0 0 0-.15.22m6.28 6.29-1.35-1.35v-1.63a.75.75 0 0 1 1.5 0v2q0 .51-.15.98M5.27 3.15 6.62 4.5h1.63a.75.75 0 0 0 0-1.5h-2q-.51 0-.98.15"
]);
const $eb093920387c7bf0$export$8538510cf1ff629a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOffRegular', "1em", [
    "m2.85 2.15 15 15a.5.5 0 0 1-.7.7l-1.41-1.4q-.77.53-1.74.55H6a3 3 0 0 1-3-3V6q.01-.99.55-1.74l-1.4-1.4a.5.5 0 1 1 .7-.71m12.17 13.57L4.28 4.98A2 2 0 0 0 4 6v8c0 1.1.9 2 2 2h8a2 2 0 0 0 1.02-.28m1.88-.94-.9-.9V11.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-.1.78M5.22 3.1l.9.9H8.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-.78.1m5.78.4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V4.7l-4.15 4.15a.5.5 0 0 1-.7-.7L15.29 4H11.5a.5.5 0 0 1-.5-.5"
]);
const $eb093920387c7bf0$export$11147a39d469f319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PivotFilled', "1em", [
    "M16.22 10.08a.5.5 0 0 1 .63.07l2 2a.5.5 0 1 1-.7.7L17 11.71V14a3 3 0 0 1-3 3h-2.3l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L11.71 16H14a2 2 0 0 0 2-2v-2.3l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2zM14 3a3 3 0 0 1 3 3v3.09a1.5 1.5 0 0 0-1.45.25l-.11.1-6 6A1.5 1.5 0 0 0 9.09 17H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM6 9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm0-4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $eb093920387c7bf0$export$37b7e8d5826500d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PivotRegular', "1em", [
    "M16.22 10.08a.5.5 0 0 1 .63.07l2 2a.5.5 0 1 1-.7.7L17 11.71V14a3 3 0 0 1-3 3h-2.3l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L11.71 16H14a2 2 0 0 0 2-2v-2.3l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2zM14 3a3 3 0 0 1 3 3v3.09a1.5 1.5 0 0 0-1 0V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.09a1.5 1.5 0 0 0 0 1H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM7 9a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0-4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm7 0a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $eb093920387c7bf0$export$a01c4024393f909a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedFilled', "1em", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 0 0 .48-5.12zM7.55 8.85a1.5 1.5 0 0 0-2.1 0l-.3.3a4.04 4.04 0 0 0-.48 5.12l-2.45 2.45a.75.75 0 1 0 1.06 1.06l2.45-2.45a4.04 4.04 0 0 0 5.12-.48l.3-.3c.59-.58.59-1.52 0-2.1z"
]);
const $eb093920387c7bf0$export$4f6f2e68d87fde69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedRegular', "1em", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14.48 4.8a4.04 4.04 0 0 0-5.33.34l-.3.3a1.5 1.5 0 0 0 0 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 0 0 .34-5.33zm-4 7.6c-.2.19-.5.19-.7 0l-3.6-3.6c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 0 1 4.3 4.3zm-6.3-1.6a1.5 1.5 0 0 0-2.1 0l-.3.3a4.04 4.04 0 0 0-.34 5.33l-2.66 2.67a.5.5 0 0 0 .7.7l2.67-2.66a4.04 4.04 0 0 0 5.33-.34l.3-.3c.59-.58.59-1.52 0-2.1zm-1.4.7c.2-.19.5-.19.7 0l3.6 3.6c.19.2.19.5 0 .7l-.3.3a3.04 3.04 0 1 1-4.3-4.3z"
]);
const $eb093920387c7bf0$export$a1412d2617ae1180 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedAddFilled', "1em", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47a5.5 5.5 0 0 1 4.55-.85 4 4 0 0 0-.53-3.44zM7.55 8.85l2.47 2.46a5.5 5.5 0 0 0-.85 4.55 4 4 0 0 1-3.44-.53l-2.45 2.45a.75.75 0 0 1-1.06-1.06l2.45-2.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2.1 0m9.45 9.4a4.5 4.5 0 1 1-5-7.5 4.5 4.5 0 0 1 5 7.5m-2.15-6.1a.5.5 0 0 0-.85.35V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.15-.35"
]);
const $eb093920387c7bf0$export$4827be2926ccc10a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedAddRegular', "1em", [
    "M17.96 2.3a.5.5 0 0 0-.82-.15l-2.7 2.7a4.04 4.04 0 0 0-5.33.33l-.6.61a1.05 1.05 0 0 0 0 1.49l2.76 2.76q.42-.3.89-.52L9.52 6.88a.5.5 0 0 1 0-.7l.3-.3a3.03 3.03 0 0 1 4.29 0v.02a3 3 0 0 1 .73 3.11q.51.03 1 .16a4 4 0 0 0-.69-3.62l2.7-2.7a.5.5 0 0 0 .11-.54M7.28 8.5l2.77 2.77q-.3.42-.53.88L6.9 9.52a.5.5 0 0 0-.7 0l-.3.3a3.04 3.04 0 0 0 0 4.29h.01a3 3 0 0 0 3.11.73q.03.52.15 1a4 4 0 0 1-3.6-.69l-2.7 2.7a.5.5 0 1 1-.71-.7l2.7-2.7a4.03 4.03 0 0 1 .33-5.34l.3-.3.31-.31a1.05 1.05 0 0 1 1.49 0M17 18.24a4.5 4.5 0 1 1-5-7.48 4.5 4.5 0 0 1 5 7.48m-2.15-6.1a.5.5 0 0 0-.85.36V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.15-.35"
]);
const $eb093920387c7bf0$export$7a5c48c06054b94d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedCheckmarkFilled', "1em", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47a5.5 5.5 0 0 1 4.55-.85 4 4 0 0 0-.53-3.44zM7.55 8.85l2.47 2.46a5.5 5.5 0 0 0-.85 4.55 4 4 0 0 1-3.44-.53l-2.45 2.45a.75.75 0 0 1-1.06-1.06l2.45-2.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2.1 0M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $eb093920387c7bf0$export$6480b2cca26d0895 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedCheckmarkRegular', "1em", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14.48 4.8a4.04 4.04 0 0 0-5.33.34l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47q.42-.3.9-.52L9.55 6.85c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 0 1 5.01 3.16q.52.04 1 .16c.37-1.23.15-2.6-.67-3.65zm-10.3 6 2.47 2.46q-.3.42-.52.9L6.85 9.55c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 0 0 3.16 5.01q.04.52.16 1c-1.23.37-2.6.15-3.65-.67l-2.67 2.66a.5.5 0 0 1-.7-.7l2.66-2.67a4.04 4.04 0 0 1 .34-5.33l.3-.3a1.5 1.5 0 0 1 2.1 0M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $eb093920387c7bf0$export$bb14208eb5c94e82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedSettingsFilled', "1em", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47a5.5 5.5 0 0 1 4.55-.85 4 4 0 0 0-.53-3.44zM7.55 8.85l2.47 2.46a5.5 5.5 0 0 0-.85 4.55 4 4 0 0 1-3.44-.53l-2.45 2.45a.75.75 0 0 1-1.06-1.06l2.45-2.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2.1 0m3.09 5.07a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $eb093920387c7bf0$export$25aad0120b71b72e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedSettingsRegular', "1em", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14.48 4.8a4.04 4.04 0 0 0-5.33.34l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47q.42-.3.9-.52L9.55 6.85c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 0 1 5.01 3.16q.52.04 1 .16c.37-1.23.15-2.6-.67-3.65zm-10.3 6 2.47 2.46q-.3.42-.52.9L6.85 9.55c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 0 0 3.16 5.01q.04.52.16 1c-1.23.37-2.6.15-3.65-.67l-2.67 2.66a.5.5 0 0 1-.7-.7l2.66-2.67a4.04 4.04 0 0 1 .34-5.33l.3-.3a1.5 1.5 0 0 1 2.1 0m3.09 5.07a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $eb093920387c7bf0$export$7211f4e7600ee63f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnectedFilled', "1em", [
    "M17.78 2.22c.3.3.3.77 0 1.06l-1.45 1.45a4.04 4.04 0 0 1-.48 5.12l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 0 1 0-1.48l.6-.61a4.05 4.05 0 0 1 5.13-.48l1.45-1.45c.3-.3.77-.3 1.06 0m-9 6.25c.3.3.3.77 0 1.06L7.51 10.8l1.69 1.7 1.27-1.28a.75.75 0 1 1 1.06 1.06l-1.28 1.28c.48.58.45 1.45-.1 2l-.3.3a4.04 4.04 0 0 1-5.12.47l-1.45 1.45a.75.75 0 0 1-1.06-1.06l1.45-1.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2-.1l1.27-1.28c.3-.3.77-.3 1.06 0"
]);
const $eb093920387c7bf0$export$daa505789933b13f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnectedRegular', "1em", [
    "M17.85 2.15c.2.2.2.5 0 .7L16.2 4.52a4.04 4.04 0 0 1-.34 5.33l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 0 1 0-1.48l.6-.61a4.04 4.04 0 0 1 5.34-.34l1.67-1.66c.2-.2.5-.2.7 0m-2.71 2.7a3.04 3.04 0 0 0-4.29 0l-.3.3c-.19.2-.19.5 0 .7l3.6 3.6c.2.19.5.19.7 0l.3-.3a3.04 3.04 0 0 0 0-4.29zm-5.79 3.8c.2.2.2.5 0 .7L7.71 11 9 12.3l1.65-1.65a.5.5 0 0 1 .7.7L9.71 13l.44.45c.59.58.59 1.52 0 2.1l-.3.3a4.04 4.04 0 0 1-5.33.34l-1.67 1.66a.5.5 0 0 1-.7-.7l1.66-1.67a4.04 4.04 0 0 1 .34-5.33l.3-.3a1.5 1.5 0 0 1 2.1 0l.45.44 1.65-1.64c.2-.2.5-.2.7 0m-4.5 6.5a3.04 3.04 0 0 0 4.3 0l.3-.3c.19-.2.19-.5 0-.7l-3.6-3.6c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 0 0 0 4.3"
]);
const $eb093920387c7bf0$export$4d6407cb09b7a83b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzleFilled', "1em", [
    "M3 13.73c0-.4.33-.73.73-.73H4a2 2 0 1 0 0-4h-.27A.73.73 0 0 1 3 8.27V7a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v1a3 3 0 0 1 0 6v1c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-3h-.5A3.5 3.5 0 0 1 10 8.5v-2c0-.83.67-1.5 1.5-1.5h.5V3.5a.5.5 0 0 1 1 0V5h2V3.5a.5.5 0 0 1 1 0V5h.5c.83 0 1.5.67 1.5 1.5v2a3.5 3.5 0 0 1-3 3.46V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
]);
const $eb093920387c7bf0$export$4e119a1e0f1b6e13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzleRegular', "1em", [
    "M3 13.73c0-.4.33-.73.73-.73H4a2 2 0 1 0 0-4h-.27A.73.73 0 0 1 3 8.27V7a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v1a3 3 0 0 1 0 6v1c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-3h-.5A3.5 3.5 0 0 1 10 8.5v-2c0-.83.67-1.5 1.5-1.5h.5V3.5a.5.5 0 0 1 1 0V5h2V3.5a.5.5 0 0 1 1 0V5h.5c.83 0 1.5.67 1.5 1.5v2a3.5 3.5 0 0 1-3 3.46V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm8-5.23a2.5 2.5 0 0 0 2.5 2.5h1A2.5 2.5 0 0 0 17 8.5v-2a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5z"
]);
const $eb093920387c7bf0$export$41c8fe1080e158c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortHdmiFilled', "1em", [
    "M4.85 7.44A1.5 1.5 0 0 1 5.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 11.5v-.59q.01-.62.44-1.06zM6.5 9.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $eb093920387c7bf0$export$a6c634feab840cce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortHdmiRegular', "1em", [
    "M4.85 7.44A1.5 1.5 0 0 1 5.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 11.5v-.59q.01-.62.44-1.06zM5.91 8a.5.5 0 0 0-.35.15l-2.41 2.41a.5.5 0 0 0-.15.35v.59c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-.59a.5.5 0 0 0-.15-.35l-2.41-2.41a.5.5 0 0 0-.35-.15zM6 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 6 10"
]);
const $eb093920387c7bf0$export$80ef4e39f91b0cfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortMicroUsbFilled', "1em", [
    "M6.43 8.3q.4-.3.9-.3h5.34q.5 0 .9.3l1.33 1A1.5 1.5 0 0 1 14 12H6a1.5 1.5 0 0 1-.9-2.7z"
]);
const $eb093920387c7bf0$export$f6e0eedd4f991ad8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortMicroUsbRegular', "1em", [
    "M6.43 8.3q.4-.3.9-.3h5.34q.5 0 .9.3l1.33 1A1.5 1.5 0 0 1 14 12H6a1.5 1.5 0 0 1-.9-2.7zm.9.7a.5.5 0 0 0-.3.1l-1.33 1a.5.5 0 0 0 .3.9h8a.5.5 0 0 0 .3-.9l-1.33-1a.5.5 0 0 0-.3-.1z"
]);
const $eb093920387c7bf0$export$dce532cc74c54a8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbAFilled', "1em", [
    "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zm0 1.5h11V10h-11z"
]);
const $eb093920387c7bf0$export$7c602c69ebdabe5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbARegular', "1em", [
    "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM4 8.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5V10H4z"
]);
const $eb093920387c7bf0$export$1181b2dc6e2728b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbCFilled', "1em", [
    "M4.5 10c0-1.1.9-2 2-2h7a2 2 0 1 1 0 4h-7a2 2 0 0 1-2-2"
]);
const $eb093920387c7bf0$export$45ce11404a285234 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbCRegular', "1em", [
    "M4.5 10c0-1.1.9-2 2-2h7a2 2 0 1 1 0 4h-7a2 2 0 0 1-2-2m2-1a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2z"
]);
const $eb093920387c7bf0$export$cc9c237e60f4d914 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDotsFilled', "1em", [
    "M7.25 2c.63 0 1.1.37 1.44.86.34.47.6 1.12.81 1.84.43 1.45.71 3.36 1 5.23.28 1.88.55 3.72.96 5.08q.3 1.03.66 1.56c.24.33.45.43.63.43.16 0 .33-.07.53-.31q.31-.37.6-1.16c.34-.96.59-2.24.82-3.66a2.5 2.5 0 1 1 1 .12 24 24 0 0 1-.88 3.87 5 5 0 0 1-.77 1.47c-.33.4-.76.67-1.3.67-.63 0-1.1-.37-1.44-.86a6 6 0 0 1-.81-1.84c-.43-1.45-.72-3.36-1-5.23A42 42 0 0 0 8.54 5q-.3-1.03-.66-1.56C7.64 3.1 7.43 3 7.25 3c-.16 0-.33.07-.53.31q-.32.37-.6 1.16c-.34.95-.6 2.24-.82 3.66a2.5 2.5 0 1 1-1-.12c.24-1.44.5-2.82.88-3.87.2-.58.45-1.1.77-1.47.33-.4.76-.67 1.3-.67"
]);
const $eb093920387c7bf0$export$de6ff10a9100cf7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDotsRegular', "1em", [
    "M7.25 2c.63 0 1.1.37 1.44.86.34.47.6 1.12.81 1.84.43 1.45.71 3.36 1 5.23.28 1.88.55 3.72.96 5.08q.3 1.03.66 1.56c.24.33.45.43.63.43.16 0 .33-.07.53-.31q.31-.37.6-1.16c.34-.96.59-2.24.82-3.66a2.5 2.5 0 1 1 1 .12 24 24 0 0 1-.88 3.87 5 5 0 0 1-.77 1.47c-.33.4-.76.67-1.3.67-.63 0-1.1-.37-1.44-.86a6 6 0 0 1-.81-1.84c-.43-1.45-.72-3.36-1-5.23A42 42 0 0 0 8.54 5q-.3-1.03-.66-1.56C7.64 3.1 7.43 3 7.25 3c-.16 0-.33.07-.53.31q-.32.37-.6 1.16c-.34.95-.6 2.24-.82 3.66a2.5 2.5 0 1 1-1-.12c.24-1.44.5-2.82.88-3.87.2-.58.45-1.1.77-1.47.33-.4.76-.67 1.3-.67M4.5 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $eb093920387c7bf0$export$4ea329ea6115058e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportColor', "1em", [
    [
        "circle",
        {
            "cx": "12",
            "cy": "8",
            "r": "6",
            "fill": "url(#ic_fluent_sport_20_color__a)"
        }
    ],
    [
        "circle",
        {
            "cx": "12",
            "cy": "8",
            "r": "6",
            "fill": "url(#ic_fluent_sport_20_color__b)",
            "fillOpacity": ".8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_20_color__c)",
            "d": "M14.59 2.58a2 2 0 0 0-.31 2.44l1.6-1.6q.38.32.7.7l-1.6 1.6a2 2 0 0 0 2.44-.3q.22.46.37.99a3 3 0 0 1-3.53.04L12.71 8l3.87 3.87q-.32.4-.7.71L12 8.71l-3.87 3.87q-.4-.32-.71-.7L11.29 8 7.42 4.13q.32-.4.7-.71L12 7.29l1.55-1.55a3 3 0 0 1 .04-3.53q.52.15 1 .37",
            "opacity": ".6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_20_color__d)",
            "d": "M2 8.5C2 7.67 2.67 7 3.5 7H5a8 8 0 0 1 8 8v1.5c0 .83-.67 1.5-1.5 1.5H10a8 8 0 0 1-8-8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_20_color__e)",
            "fillOpacity": ".9",
            "d": "M2 8.5C2 7.67 2.67 7 3.5 7H5a8 8 0 0 1 8 8v1.5c0 .83-.67 1.5-1.5 1.5H10a8 8 0 0 1-8-8z"
        }
    ],
    [
        "path",
        {
            "fill": "#ffc470",
            "d": "M6.15 11.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-90 16.93 3.32)scale(20.9675)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".98",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -5 6.84028 6.84028 7.5 12.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".59",
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#eb4824",
                    "stopOpacity": ".1"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.53 -5.93 6.72)scale(14.3003 12.9315)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#ae5606"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#944600"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(10.94 -106.2 41.88)scale(16.2778)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#ffa43d",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_sport_20_color__c",
                "x1": "16.44",
                "x2": "9.93",
                "y1": "3.75",
                "y2": "10.26",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".71",
                    "stopColor": "#8e250b"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#8e250b",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$6ae275a063813224 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportFilled', "1em", [
    "M16.58 4.13a6 6 0 0 1 .83 1.28 2 2 0 0 1-2.43.31zm-.7-.71-1.6 1.6a2 2 0 0 1 .3-2.44 6 6 0 0 1 1.3.84M18 8a6 6 0 0 0-.21-1.59 3 3 0 0 1-3.53.04L13.21 7.5l3.8 3.8c.63-.94.99-2.08.99-3.3m-5-4q.02-1.02.59-1.79a6 6 0 0 0-4.9.78l3.81 3.8 1.05-1.05A3 3 0 0 1 13 4m-1.3 5a9 9 0 0 1 2.2 4.7 6 6 0 0 0 2.49-1.6L12.5 8.2zm.1-1.5-.8.8a9 9 0 0 0-4.7-2.2A6 6 0 0 1 7.9 3.6zM3.5 7C2.67 7 2 7.67 2 8.5V10a8 8 0 0 0 8 8h1.5c.83 0 1.5-.67 1.5-1.5V15a8 8 0 0 0-8-8zm2.65 4.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7"
]);
const $eb093920387c7bf0$export$7f9c281aa4728635 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportRegular', "1em", [
    "M13.7 12.7a5 5 0 0 0 1.46-.83L8.13 4.84A5 5 0 0 0 7.3 6.3a9 9 0 0 0-1-.2 6 6 0 1 1 7.6 7.6 9 9 0 0 0-.2-1m-1-4.7 3.17 3.16a5 5 0 0 0 1.06-4.02 3 3 0 0 1-3.17-.2zm3.17-3.16-1.39 1.38a2 2 0 0 0 2.16-.08 5 5 0 0 0-.77-1.3M12.5 4.5q0-.78.36-1.43a5 5 0 0 0-4.02 1.06L12 7.29l1.05-1.05a3 3 0 0 1-.55-1.74m1 0q0 .56.28 1.02l1.38-1.4a5 5 0 0 0-1.3-.76 2 2 0 0 0-.36 1.14M3.5 8a.5.5 0 0 0-.5.5V10a7 7 0 0 0 7 7h1.5a.5.5 0 0 0 .5-.5V15a7 7 0 0 0-7-7zM2 8.5C2 7.67 2.67 7 3.5 7H5a8 8 0 0 1 8 8v1.5c0 .83-.67 1.5-1.5 1.5H10a8 8 0 0 1-8-8zm4.15 2.65c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7"
]);
const $eb093920387c7bf0$export$e3b9bf8db7048983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportAmericanFootballFilled', "1em", [
    "M10.94 2.64A11.6 11.6 0 0 0 2.6 10.9l6.6 6.6a11 11 0 0 0 6.08-4.08 13 13 0 0 0 2.07-4.35zm.91 5.5c.2.2.2.52 0 .71l-3 3a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0m5.8-.2q.38-1.97.35-3.71A2.25 2.25 0 0 0 15.7 2q-1.98.04-3.62.37zm-9.6 9.81-5.72-5.72A16 16 0 0 0 2 15.84c.04 1.18 1 2.09 2.15 2.14q2.14.1 3.89-.23"
]);
const $eb093920387c7bf0$export$37aa8126a9a09f33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportAmericanFootballRegular', "1em", [
    "M11.85 8.85a.5.5 0 1 0-.7-.7l-3 3a.5.5 0 1 0 .7.7zM18 4.23A2.25 2.25 0 0 0 15.7 2c-5.62.07-9.12 2.15-11.18 4.96-2.04 2.78-2.6 6.2-2.51 8.88.04 1.18 1 2.09 2.15 2.14 5.53.26 9.03-1.73 11.13-4.56 2.07-2.8 2.73-6.36 2.71-9.2M15.71 3c.72 0 1.29.54 1.3 1.23q0 1.36-.23 2.85l-3.84-3.85Q14.2 3.02 15.7 3m-3.95.46 4.79 4.8c-.39 1.6-1.04 3.19-2.07 4.56a10 10 0 0 1-6.1 3.85l-.03-.02-4.93-4.93a12 12 0 0 1 1.9-4.17 10.8 10.8 0 0 1 6.44-4.09M3.19 12.9l3.98 3.99q-1.35.17-2.96.1A1.24 1.24 0 0 1 3 15.81q-.05-1.38.18-2.92"
]);
const $eb093920387c7bf0$export$29ba21f9d291e8e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBaseballFilled', "1em", [
    "M18 10c0 1.55-.44 3-1.2 4.22q-1.43-1.05-3.14-1.63a.5.5 0 1 0-.32.95q1.56.53 2.88 1.5a7.98 7.98 0 0 1-12.44 0q1.31-.97 2.88-1.5a.5.5 0 0 0-.32-.95q-1.71.59-3.14 1.63a8 8 0 0 1 0-8.43q1.42 1.06 3.14 1.63a.5.5 0 1 0 .32-.95 11 11 0 0 1-2.88-1.5 7.98 7.98 0 0 1 12.44 0q-1.31.97-2.88 1.5a.5.5 0 1 0 .32.95q1.72-.58 3.14-1.63A8 8 0 0 1 18 10m-8 3q.73 0 1.43.1a.5.5 0 1 0 .14-1 12 12 0 0 0-3.14 0 .5.5 0 0 0 .14 1q.7-.1 1.43-.1M8.57 6.92a.5.5 0 0 0-.14.99 12 12 0 0 0 3.14 0 .5.5 0 1 0-.14-1 11 11 0 0 1-2.86 0"
]);
const $eb093920387c7bf0$export$9eccdb358d9c06a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBaseballRegular', "1em", [
    "M4.61 5.53a7 7 0 0 1 10.78 0q-.96.57-2.05.94a.5.5 0 0 0 .32.95q1.22-.41 2.31-1.08a7 7 0 0 1 0 7.33q-1.1-.66-2.31-1.08a.5.5 0 0 0-.32.95q1.08.37 2.04.94a7 7 0 0 1-10.76 0q.96-.58 2.04-.94a.5.5 0 1 0-.32-.95q-1.22.42-2.3 1.08a7 7 0 0 1-.01-7.33Q5.12 7 6.34 7.42a.5.5 0 0 0 .32-.95Q5.58 6.1 4.6 5.53M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.57 6.92a11 11 0 0 0 2.86 0 .5.5 0 0 1 .14.99 12 12 0 0 1-3.14 0 .5.5 0 0 1 .14-1m0 6.18a11 11 0 0 1 2.86 0 .5.5 0 0 0 .14-1 12 12 0 0 0-3.14 0 .5.5 0 1 0 .14 1"
]);
const $eb093920387c7bf0$export$b83c2ce5b53c8cbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBasketballFilled', "1em", [
    "M4.7 4A8 8 0 0 1 9 2.06q.1.66.24 1.4c.18.9.43 1.89.78 2.79.28.71.62 1.4 1.06 1.96L10 9.3zm-.7.7A8 8 0 0 0 2.06 9q.65.1 1.4.24c.9.18 1.89.43 2.79.78.71.28 1.4.62 1.96 1.06L9.29 10zm3.5 7.1q-.66-.48-1.61-.85c-.83-.31-1.75-.55-2.62-.72Q2.6 10.08 2 10c0 2.02.76 3.87 2 5.28zM4.7 16l3.5-3.5q.48.66.85 1.61c.31.83.55 1.75.72 2.62q.15.68.22 1.27a8 8 0 0 1-5.28-2m4.22-4.21L10 10.71 15.3 16a8 8 0 0 1-4.3 1.94q-.1-.66-.25-1.4c-.18-.9-.43-1.89-.77-2.79a8 8 0 0 0-1.06-1.96m7.08 3.5a8 8 0 0 0 1.94-4.3q-.66-.09-1.4-.23c-.9-.18-1.89-.43-2.79-.78a8 8 0 0 1-1.96-1.06L10.7 10zM12.5 8.2q.65.48 1.61.85c.83.32 1.75.55 2.62.72q.68.15 1.27.22c0-2.02-.76-3.87-2-5.28zM15.3 4A8 8 0 0 0 10 2q.1.6.23 1.27c.17.87.4 1.8.72 2.62q.36.96.85 1.6z"
]);
const $eb093920387c7bf0$export$a1cbda0ba6b7447c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBasketballRegular', "1em", [
    "m10 9.3 1.08-1.09a8 8 0 0 1-1.06-1.96 17 17 0 0 1-.85-3.2 7 7 0 0 0-3.75 1.66zm1.79-.38L10.71 10l4.58 4.58a7 7 0 0 0 1.66-3.75l-.42-.07c-.9-.18-1.88-.43-2.77-.78a8 8 0 0 1-1.97-1.06m5.2.9a7 7 0 0 0-1.7-4.4L12.5 8.2q.66.48 1.61.85a16 16 0 0 0 2.89.78M11.8 7.5l2.8-2.8A7 7 0 0 0 10.16 3l.06.27c.17.87.4 1.8.72 2.62.25.62.53 1.18.85 1.6M10 10.7 8.92 11.8c.44.55.79 1.25 1.06 1.96a17 17 0 0 1 .86 3.2 7 7 0 0 0 3.74-1.66zm-1.8 1.8-2.78 2.8a7 7 0 0 0 4.4 1.7q-.01-.14-.04-.27c-.18-.87-.41-1.8-.73-2.62a7 7 0 0 0-.84-1.6m-.7-.7q-.65-.49-1.61-.85A16 16 0 0 0 3 10.17c.04 1.58.61 3.15 1.7 4.41zm.71-.72L9.3 10 4.71 5.42a7 7 0 0 0-1.66 3.74l.42.08c.9.18 1.88.43 2.78.78.72.28 1.4.62 1.96 1.06m7.45 4.58A8 8 0 1 1 4.34 4.34a8 8 0 0 1 11.32 11.32"
]);
const $eb093920387c7bf0$export$b5d517a61c8a1d0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBallFilled', "1em", [
    "M10 2c1.52 0 2.93.42 4.14 1.15a.5.5 0 0 0-.14.35v1a.5.5 0 0 0 1 0v-.74A7.98 7.98 0 0 1 10 18a8 8 0 1 1 0-16M4.5 13a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $eb093920387c7bf0$export$67ca2da2323ca824 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBallRegular', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 0 0-6 10.6v-.1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.1.3 7 7 0 0 0 11.07-8.44q.03.06.03.14a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .33.13A7 7 0 0 0 10 3M7.5 14a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $eb093920387c7bf0$export$1a0ac09a44231fb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBatFilled', "1em", [
    "M14.23 7.94a1.5 1.5 0 0 0-.23.8v1.38l-.01.2a2 2 0 0 1-.58 1.22l-5.88 5.88a2 2 0 0 1-2.82 0L2.59 15.3a2 2 0 0 1 0-2.83l5.88-5.88A2 2 0 0 1 9.88 6h1.37q.45 0 .8-.24zm1.2-5.5a1.5 1.5 0 0 1 2.12 2.12L14.91 7.2l-2.12-2.12z"
]);
const $eb093920387c7bf0$export$ab3a42d0dbc4468b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBatRegular', "1em", [
    "M14.74 2.45a2 2 0 0 1 2.68.14l.13.15a2 2 0 0 1 0 2.52l-.13.15-2.98 2.98A1.5 1.5 0 0 0 14 9.45v.68l-.01.2a2 2 0 0 1-.58 1.2l-5.87 5.89a2 2 0 0 1-2.83 0L2.59 15.3a2 2 0 0 1 0-2.83l5.88-5.88.14-.14A2 2 0 0 1 9.88 6h.67c.4 0 .78-.16 1.06-.44L14.6 2.6zM11.9 6.6q-.61.4-1.35.4h-.67a1 1 0 0 0-.63.23l-.08.06-5.88 5.89a1 1 0 0 0 0 1.4l2.12 2.13a1 1 0 0 0 1.42 0l5.88-5.88a1 1 0 0 0 .28-.6v-.78q.01-.74.4-1.35zm4.8-3.3a1 1 0 0 0-1.33-.08l-.08.07-2.64 2.65 1.41 1.41 2.65-2.64.07-.08a1 1 0 0 0 0-1.26z"
]);
const $eb093920387c7bf0$export$6129d0f392dabb60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportHockeyFilled', "1em", [
    "M11.97 2.06a3.7 3.7 0 0 1 3.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.1 4.1 0 0 1 2.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15m2.52 3.52a.5.5 0 1 0-.98-.16 11 11 0 0 1-3.05 5.9 10 10 0 0 1-4.1 2.7.5.5 0 1 0 .28.96c1.25-.36 3-1.38 4.53-2.96a12 12 0 0 0 3.32-6.44"
]);
const $eb093920387c7bf0$export$d596b4b8021d7724 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportHockeyRegular', "1em", [
    "M11.97 2.06a3.7 3.7 0 0 1 3.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.1 4.1 0 0 1 2.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15m2.7 1.97c-.68-.76-1.6-1.17-2.5-.99-3 .61-7.03 2.89-9.01 8.5-.41 1.15 0 2.44.97 3.3l1.82 1.6c.46.41 1.03.63 1.57.54 2.85-.42 7.41-2.57 9.39-8.86.23-.73.02-1.55-.53-2.16zm-.6.98c.28.04.47.3.42.57a12 12 0 0 1-3.32 6.44 11 11 0 0 1-4.53 2.96.5.5 0 0 1-.28-.96c1.05-.3 2.66-1.22 4.1-2.7a11 11 0 0 0 3.05-5.9.5.5 0 0 1 .57-.41"
]);
const $eb093920387c7bf0$export$16a6d6d4adf979be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccerFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M7.1 3.63l2.4 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7 7 0 0 1 2.54-1.98M3.02 10.7l1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a7 7 0 0 1-1.22-3.3m5.34 6.12-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7 7 0 0 1-3.26 0M15.75 14h-2.48l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a7 7 0 0 1-1.22 3.3m-.3-8.38-.62 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98"
]);
const $eb093920387c7bf0$export$72ad82dce7ebbe2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccerRegular', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.34 3.2a7 7 0 0 1 3.33 0L10 4.17zm-1.25.43 2.41 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7 7 0 0 1 2.54-1.98M3.8 6.75l.4 1.58-1.17 1.03q.13-1.42.77-2.61m-.77 3.94 1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a7 7 0 0 1-1.22-3.3M5.1 15h1.55l.51 1.41A7 7 0 0 1 5.1 15m3.27 1.82-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7 7 0 0 1-3.26 0m4.47-.41.51-1.4h1.55a7 7 0 0 1-2.06 1.4m2.9-2.4h-2.47l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a7 7 0 0 1-1.22 3.3m1.23-4.64-1.16-1.03.4-1.58c.4.8.68 1.68.76 2.6m-1.51-3.74-.63 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98M7.4 9.45 10 7.6l2.59 1.84-.96 3.05H8.37z"
]);
const $eb093920387c7bf0$export$e085281921313bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubGridFilled', "1em", [
    "M6 10.5v2c0 .83.67 1.5 1.5 1.5h2v-3.5zm0-1v-2C6 6.67 6.67 6 7.5 6h2v3.5zM10.5 6v3.5H14v-2c0-.83-.67-1.5-1.5-1.5zm3.5 4.5h-3.5V14h2c.83 0 1.5-.67 1.5-1.5zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-2 7.5h2v-1H4V6c0-1.1.9-2 2-2h3.5v2h1V4H14a2 2 0 0 1 2 2v3.5h-2v1h2V14a2 2 0 0 1-2 2h-3.5v-2h-1v2H6a2 2 0 0 1-2-2z"
]);
const $eb093920387c7bf0$export$2bb454d2fd5f5029 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubGridRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 14v-3.5h2v2c0 .83.67 1.5 1.5 1.5h2v2H6a2 2 0 0 1-2-2m6.5 0h2c.83 0 1.5-.67 1.5-1.5v-2h2V14a2 2 0 0 1-2 2h-3.5zm2.5-3.5v2a.5.5 0 0 1-.5.5h-2v-2.5zm1-1v-2c0-.83-.67-1.5-1.5-1.5h-2V4H14a2 2 0 0 1 2 2v3.5zM10.5 7h2c.28 0 .5.22.5.5v2h-2.5zm-1-1h-2C6.67 6 6 6.67 6 7.5v2H4V6c0-1.1.9-2 2-2h3.5zM7 9.5v-2c0-.28.22-.5.5-.5h2v2.5zm0 1h2.5V13h-2a.5.5 0 0 1-.5-.5z"
]);
const $eb093920387c7bf0$export$d73d4d3be131247c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtitlesFilled', "1em", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zm2 4.75c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5-1.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5M9.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $eb093920387c7bf0$export$34e898bbf3a18c99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtitlesRegular', "1em", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5zM4 11.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5-1.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5M9.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $eb093920387c7bf0$export$bdff78ffd9f0b95f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractFilled', "1em", [
    "M3 10c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10"
]);
const $eb093920387c7bf0$export$81bd52b502edee2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractRegular', "1em", [
    "M3 10c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 3 10"
]);
const $eb093920387c7bf0$export$38e801704231f2d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0M6 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5"
]);
const $eb093920387c7bf0$export$fceba3a26bdc01c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleRegular', "1em", [
    "M6 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 6 10m4 8a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
]);
const $eb093920387c7bf0$export$2885db80e6bee78b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowBackFilled', "1em", [
    "M16.98 9.59 17 9a8 8 0 1 0-7.41 7.98A5.5 5.5 0 0 1 12.2 9.5H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .45.72 5.5 5.5 0 0 1 4.03.37M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.4-2.6a.5.5 0 0 0-.7 0l-1.75 1.75a.5.5 0 0 0 0 .7l1.75 1.75a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75h-1.54l.9-.9a.5.5 0 0 0 0-.7"
]);
const $eb093920387c7bf0$export$475fa6aa8e75ac50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowBackRegular', "1em", [
    "M5.5 8.5a.5.5 0 0 0 0 1h6.7q.37-.16.75-.28a.5.5 0 0 0-.45-.72zm10.5.7V9a7 7 0 1 0-6.8 7q.15.51.39.98L9 17a8 8 0 1 1 7.98-7.41A6 6 0 0 0 16 9.2m3 5.3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.4-2.6a.5.5 0 0 0-.7 0l-1.75 1.75a.5.5 0 0 0 0 .7l1.75 1.75a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75h-1.54l.9-.9a.5.5 0 0 0 0-.7"
]);
const $eb093920387c7bf0$export$9e2eb4f5ffbc0da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowForwardFilled', "1em", [
    "M16.98 9.59 17 9a8 8 0 1 0-7.41 7.98A5.5 5.5 0 0 1 12.2 9.5H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .45.72 5.5 5.5 0 0 1 4.03.37M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7"
]);
const $eb093920387c7bf0$export$2bc49f5ec7ff5494 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowForwardRegular', "1em", [
    "M5.5 8.5a.5.5 0 0 0 0 1h6.7q.37-.16.75-.28a.5.5 0 0 0-.45-.72zm10.5.7V9a7 7 0 1 0-6.8 7q.15.51.39.98L9 17a8 8 0 1 1 7.98-7.41A6 6 0 0 0 16 9.2m-6 5.3a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7"
]);
const $eb093920387c7bf0$export$6d5591b13d81cc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParenthesesFilled', "1em", [
    "M5.77 5.07a.75.75 0 1 0-.98-1.14 7.98 7.98 0 0 0 0 12.14.75.75 0 1 0 .98-1.14 6.48 6.48 0 0 1 0-9.86m9.44-1.14a.75.75 0 1 0-.98 1.14 6.48 6.48 0 0 1 0 9.86.75.75 0 1 0 .98 1.14 7.98 7.98 0 0 0 0-12.14M6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $eb093920387c7bf0$export$6ff704b73efedd96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParenthesesRegular', "1em", [
    "M5.8 4.4a.5.5 0 0 0-.6-.8 8 8 0 0 0 0 12.8.5.5 0 0 0 .6-.8 7 7 0 0 1 0-11.2m9-.8a.5.5 0 0 0-.6.8 7 7 0 0 1 0 11.2.5.5 0 1 0 .6.8 8 8 0 0 0 0-12.8M6.5 9.5a.5.5 0 1 0 0 1h7a.5.5 0 1 0 0-1z"
]);
const $eb093920387c7bf0$export$4cd093e09be07958 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm.5 6.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1"
]);
const $eb093920387c7bf0$export$c3737b9acf923e0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareRegular', "1em", [
    "M6.5 9.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);
const $eb093920387c7bf0$export$dafe808b95444ba3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareMultipleFilled', "1em", [
    "M16 5.27c.6.34 1 .99 1 1.73v6a4 4 0 0 1-4 4H7a2 2 0 0 1-1.73-1H13a3 3 0 0 0 3-3zM15 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2zm-3 4a.5.5 0 0 1-.5.5h-5a.5.5 0 1 1 0-1h5c.28 0 .5.22.5.5"
]);
const $eb093920387c7bf0$export$1c474cc63d4ed61e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareMultipleRegular', "1em", [
    "M16 5.27V13a3 3 0 0 1-3 3H5.27c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4V7a2 2 0 0 0-1-1.73M11.5 9.5a.5.5 0 0 0 0-1h-5a.5.5 0 1 0 0 1zM13 3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm1 2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z"
]);
const $eb093920387c7bf0$export$ecb9f3a090e5c995 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_20_color__a)",
            "d": "M8.68 2.79a1.5 1.5 0 0 1 2.64 0l6.5 12A1.5 1.5 0 0 1 16.5 17h-13a1.5 1.5 0 0 1-1.32-2.21z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_20_color__b)",
            "d": "M10.5 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_20_color__c)",
            "d": "M10 14.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_20_color__a",
                "x1": "4.5",
                "x2": "13.97",
                "y1": "-.34",
                "y2": "18.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_20_color__b",
                "x1": "8",
                "x2": "11.6",
                "y1": "7",
                "y2": "14.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_20_color__c",
                "x1": "8",
                "x2": "11.6",
                "y1": "7",
                "y2": "14.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#242424"
                }
            ]
        ]
    ]
], {
    color: true
});
const $eb093920387c7bf0$export$73296e0703a210f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningFilled', "1em", [
    "M7.37 3.56a3 3 0 0 1 5.26 0l5.5 10A3 3 0 0 1 15.5 18h-11a3 3 0 0 1-2.63-4.44zM10 12.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-6.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $eb093920387c7bf0$export$a617e69347ca7702 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningRegular', "1em", [
    "M7.37 3.56a3 3 0 0 1 5.26 0l5.5 10A3 3 0 0 1 15.5 18h-11a3 3 0 0 1-2.63-4.44zm4.38.48a2 2 0 0 0-3.5 0l-5.5 10A2 2 0 0 0 4.5 17h11a2 2 0 0 0 1.75-2.96zM10 12.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-6.25c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);
const $eb093920387c7bf0$export$9494d4d261b86b6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpenFilled', "1em", [
    "M18 10a2 2 0 0 1 2 2 .5.5 0 0 1-1 0 1 1 0 0 0-2 0v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3v-1c0-1.1.9-2 2-2M7.37 3.56a3 3 0 0 1 5.26 0l3.4 6.18A3 3 0 0 0 15 12h-2a2 2 0 0 0-2 2v4H4.5a3 3 0 0 1-2.62-4.44zm8.13 11.69a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-5.5-2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-6.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $eb093920387c7bf0$export$fd022608ad31bf93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpenRegular', "1em", [
    "M18 10a2 2 0 0 1 2 2 .5.5 0 0 1-1 0 1 1 0 0 0-2 0v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3v-1c0-1.1.9-2 2-2M7.37 3.56a3 3 0 0 1 5.26 0l3.4 6.18q-.41.36-.68.85l-3.6-6.55a2 2 0 0 0-3.5 0l-5.5 10A2 2 0 0 0 4.5 17H11v1H4.5a3 3 0 0 1-2.63-4.44zm8.13 11.69a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-5.5-2.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-6.25c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);
const $eb093920387c7bf0$export$7e78d82935db6145 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningShieldFilled', "1em", [
    "M15.12 10.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4m-7.75-7.4a3 3 0 0 1 5.26 0l3.51 6.4a1.6 1.6 0 0 0-1.6.18l-.11.1c-.43.41-1.15.95-1.96 1.12l-.27.04c-.53.11-1.12.54-1.2 1.26v2.26A4.7 4.7 0 0 0 12.11 18h-7.6a3 3 0 0 1-2.63-4.44zM10 12.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-6.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $eb093920387c7bf0$export$53ad98e96d86edc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningShieldRegular', "1em", [
    "M15.12 10.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4m-7.75-7.4a3 3 0 0 1 5.26 0l3.51 6.4a1.6 1.6 0 0 0-1.16-.05l-3.23-5.87a2 2 0 0 0-3.5 0l-5.5 10A2 2 0 0 0 4.5 17h6.96q.27.57.65 1h-7.6a3 3 0 0 1-2.63-4.44zM10 12.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-6.25c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);


"use client";
const $0debb7262aed7016$export$3e8821f80b76d44d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_20_color__a)",
            "d": "M15.5 2A4.5 4.5 0 0 0 11 6.5v2c0 .83.67 1.5 1.5 1.5h.45l-.03.36-.17 2.04c-.12 1.5-.25 3.16-.25 3.6a2 2 0 1 0 4 0c0-.44-.13-2.1-.25-3.6l-.23-2.7-.02-.22V2.5a.5.5 0 0 0-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_food_20_color__b)",
            "d": "M4.5 2c.29 0 .51.23.51.5v4a.5.5 0 1 0 .99 0v-4a.5.5 0 0 1 1 0v4.03a.5.5 0 0 0 .99-.03v-4a.5.5 0 0 1 .5-.5h.02q.03 0 .13.02a.5.5 0 0 1 .35.4c.02.08.51 3.17.51 4.58a3 3 0 0 1-1.13 2.35q-.37.3-.37.6v.55l.27 2.63c.12 1.19.23 2.45.23 2.87a2 2 0 1 1-4 0c0-.42.11-1.68.23-2.87L5 10.45v-.5q0-.3-.37-.6A3 3 0 0 1 3.5 7c0-1.4.5-4.48.5-4.58A.5.5 0 0 1 4.5 2"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_20_color__a",
                "x1": "10.15",
                "x2": "23.58",
                "y1": "3",
                "y2": "7.39",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_food_20_color__b",
                "x1": "2.58",
                "x2": "16.96",
                "y1": "3",
                "y2": "8.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ]
    ]
], {
    color: true
});
const $0debb7262aed7016$export$3e41b98a3b0ba38b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFilled', "1em", [
    "m4.5 2-.18.04a.5.5 0 0 0-.31.38C3.99 2.52 3.5 5.6 3.5 7a3 3 0 0 0 1.13 2.35q.37.3.37.6v.55l-.27 2.63A49 49 0 0 0 4.5 16a2 2 0 1 0 4 0c0-.42-.11-1.68-.23-2.87L8 10.45v-.5q0-.3.37-.6A3 3 0 0 0 9.5 7c0-1.4-.5-4.5-.5-4.58a.5.5 0 0 0-.36-.4Q8.54 2 8.5 2h-.02a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-.99.03V2.5a.5.5 0 0 0-1 0v4.03a.5.5 0 0 1-.99-.03v-4a.5.5 0 0 0-.5-.5M11 6.5A4.5 4.5 0 0 1 15.5 2c.28 0 .5.22.5.5v6.98l.02.22.23 2.7c.12 1.5.25 3.16.25 3.6a2 2 0 1 1-4 0c0-.44.13-2.1.25-3.6l.17-2.04.03-.36h-.45A1.5 1.5 0 0 1 11 8.5zM8.5 2"
]);
const $0debb7262aed7016$export$b8f62c4624168e58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodRegular', "1em", [
    "M4.67 2a1.3 1.3 0 0 0-1.29 1.07C3.23 3.89 3 5.34 3 6.5a3.5 3.5 0 0 0 1.6 2.94c.27.17.4.4.4.6v.46l-.27 2.63A49 49 0 0 0 4.5 16a2 2 0 1 0 4 0c0-.42-.11-1.68-.23-2.87L8 10.45v-.41c0-.2.13-.43.4-.6A3.5 3.5 0 0 0 10 6.5c0-1.16-.23-2.61-.38-3.43A1.3 1.3 0 0 0 8.32 2q-.51.01-.87.34a1.5 1.5 0 0 0-1.9 0Q5.2 2 4.67 2M6 3.5a.5.5 0 0 1 1 0v3a.5.5 0 0 0 1 0V3.33c0-.18.15-.33.33-.33q.25.01.3.25c.15.81.37 2.19.37 3.25a2.5 2.5 0 0 1-1.14 2.1c-.44.28-.86.78-.86 1.44v.57c.04.25.16 1.42.28 2.62.11 1.21.22 2.41.22 2.77a1 1 0 1 1-2 0c0-.36.1-1.56.22-2.77L6 10.45v-.41c0-.66-.42-1.16-.86-1.44A2.5 2.5 0 0 1 4 6.5c0-1.06.22-2.44.36-3.25A.3.3 0 0 1 4.67 3c.18 0 .33.15.33.33V6.5a.5.5 0 0 0 1 0zm5 3A4.5 4.5 0 0 1 15.5 2c.28 0 .5.22.5.5v6.98l.02.22.23 2.7c.12 1.5.25 3.16.25 3.6a2 2 0 1 1-4 0c0-.44.13-2.1.25-3.6l.17-2.04.03-.36h-.45A1.5 1.5 0 0 1 11 8.5zm3 3.04-.02.25-.23 2.69A87 87 0 0 0 13.5 16a1 1 0 1 0 2 0c0-.39-.12-1.98-.25-3.52l-.23-2.7-.02-.24v-6.5c-1.7.24-3 1.7-3 3.46v2c0 .28.22.5.5.5h1a.5.5 0 0 1 .5.54"
]);
const $0debb7262aed7016$export$88b4fbf44324f3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodAppleFilled', "1em", [
    "M12.16 2.97a.5.5 0 1 0-.32-.94 3.2 3.2 0 0 0-1.86 1.9q-.08.17-.13.34A4 4 0 0 0 6.2 2.14c-.58.01-1.04.48-1.06 1.06A4 4 0 0 0 6.3 6.14l.03.03A4 4 0 0 0 3.2 9.76v.07a8.5 8.5 0 0 0 1 4.75l.36.66.03.05 1 1.4a2.7 2.7 0 0 0 4.09.34.46.46 0 0 1 .64 0 2.7 2.7 0 0 0 4.09-.34l1-1.4.03-.05.36-.66a8.5 8.5 0 0 0 1-4.75v-.07a4 4 0 0 0-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34m-5.25 6c-.27.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 0 1-.99.12c-.13-1.06 0-1.86.31-2.45.32-.6.8-.93 1.28-1.08a.5.5 0 0 1 .32.94"
]);
const $0debb7262aed7016$export$bacc1e418d9a2e44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodAppleRegular', "1em", [
    "M7.22 8.34a.5.5 0 0 1-.31.63c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 0 1-.99.12q-.17-1.58.31-2.45c.32-.6.8-.93 1.28-1.08a.5.5 0 0 1 .63.31m4.94-5.37a.5.5 0 1 0-.32-.94 3.2 3.2 0 0 0-1.86 1.9q-.08.17-.13.34A4 4 0 0 0 6.2 2.14c-.58.01-1.04.48-1.06 1.06a4 4 0 0 0 1.2 2.97A4 4 0 0 0 3.2 9.76v.07a8.5 8.5 0 0 0 1 4.75l.36.66.03.05 1 1.4a2.7 2.7 0 0 0 4.09.34.46.46 0 0 1 .64 0 2.7 2.7 0 0 0 4.09-.34l1-1.4.03-.05.36-.66a8.5 8.5 0 0 0 1-4.75v-.07a4 4 0 0 0-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34M8.72 6.28l-.16-.03a3 3 0 0 1-2.42-3.02q0-.08.09-.1a3 3 0 0 1 3.08 3.1q0 .07-.09.08-.25 0-.5-.03m-.33.96.17.03.78.13a4 4 0 0 0 1.32 0l1.66-.28a3 3 0 0 1 3.49 2.72v.07a7.5 7.5 0 0 1-.89 4.2l-.34.62-.99 1.38c-.6.85-1.82.95-2.56.21a1.46 1.46 0 0 0-2.06 0c-.74.74-1.96.64-2.56-.21l-.99-1.38-.34-.63a7.5 7.5 0 0 1-.9-4.19l.01-.07a3 3 0 0 1 3.49-2.72z"
]);
const $0debb7262aed7016$export$405ec9989bfdb2d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCakeFilled', "1em", [
    "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67s1.22-.2 1.6-.7c.37-.47.49-1.11.44-1.83a4 4 0 0 0-.47-1.43C11.28 2.55 10.77 2 10 2M3 9.78l3.2 2.94a1 1 0 0 0 1.43-.07l.86-.98a2 2 0 0 1 3 0l.86.98a1 1 0 0 0 1.43.07l3.2-2.94A2 2 0 0 0 15 8H5a2 2 0 0 0-1.99 1.79M17 11.14l-2.54 2.33a2 2 0 0 1-2.85-.15l-.86-.97a1 1 0 0 0-1.5 0l-.86.97a2 2 0 0 1-2.85.15L3 11.14V16h-.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H17z"
]);
const $0debb7262aed7016$export$6bdf900e7da36566 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCakeRegular', "1em", [
    "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67s1.22-.2 1.6-.7c.37-.47.49-1.11.44-1.83a4 4 0 0 0-.47-1.43C11.28 2.55 10.77 2 10 2M8.96 4.51c0-.2.11-.63.33-.99q.34-.55.7-.54.38-.01.72.55c.21.37.32.8.33.98.04.6-.07.96-.23 1.16-.14.18-.38.31-.81.31-.45 0-.69-.12-.82-.3-.15-.18-.26-.54-.22-1.17M5 8a2 2 0 0 0-2 2v6h-.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H17v-6a2 2 0 0 0-2-2zm11 8H4v-3.88l1.54 1.38a2 2 0 0 0 2.83-.16l.88-1a1 1 0 0 1 1.5 0l.88 1a2 2 0 0 0 2.83.16L16 12.12zm0-5.22-2.21 1.97a1 1 0 0 1-1.42-.08l-.87-.99a2 2 0 0 0-3 0l-.87 1a1 1 0 0 1-1.42.07L4 10.78V10a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"
]);
const $0debb7262aed7016$export$544b13fd4de2c7ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrotFilled', "1em", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14 5.29V2.5a.5.5 0 1 0-1 0v2.88a3.66 3.66 0 0 0-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.42.62 2.05.18l8.93-6.18A3.6 3.6 0 0 0 14.63 7h2.87a.5.5 0 1 0 0-1h-2.8z"
]);
const $0debb7262aed7016$export$a0bfcf2fc1f676ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrotRegular', "1em", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14 5.29V2.5a.5.5 0 0 0-1 0v2.88a3.66 3.66 0 0 0-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.41.62 2.05.18l8.93-6.18A3.6 3.6 0 0 0 14.63 7h2.87a.5.5 0 0 0 0-1h-2.8zM9.2 7.14a2.64 2.64 0 0 1 4.04-.39 2.58 2.58 0 0 1-.35 3.96L3.95 16.9a.6.6 0 0 1-.77-.07.6.6 0 0 1-.07-.75z"
]);
const $0debb7262aed7016$export$c75c47be2f9bbbca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLegFilled', "1em", [
    "M18 7a5 5 0 0 0-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 0 0 .35.85h.39l-2 2a2 2 0 0 0-1.15 3.55q.12.09.2.21A2 2 0 0 0 6.5 16.1l2-2v.4a.5.5 0 0 0 .85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A5 5 0 0 0 18 7M7.3 11.5h1.2v1.19l-2.78 2.78a.8.8 0 0 0-.22.53 1 1 0 0 1-1.78.63q-.15-.2-.35-.35A1 1 0 0 1 4 14.5q.29 0 .51-.21z"
]);
const $0debb7262aed7016$export$cbce91688e9f8874 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLegRegular', "1em", [
    "M18 7a5 5 0 0 0-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 0 0 .35.85h.39l-2 2a2 2 0 0 0-1.15 3.55q.12.09.2.21A2 2 0 0 0 6.5 16.1l2-2v.4a.5.5 0 0 0 .85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A5 5 0 0 0 18 7m-9.5 5.69-2.78 2.78a.8.8 0 0 0-.22.53 1 1 0 0 1-1.78.63q-.15-.2-.35-.35A1 1 0 0 1 4 14.5q.29 0 .51-.21l2.8-2.79H8.5zM13 3a4 4 0 0 1 1.37 7.76l-.05.02a4 4 0 0 1-.64.16 12 12 0 0 0-3.12 1.3L9.5 13.28v-2.23a.5.5 0 0 0-.15-.35l-.06-.06a.5.5 0 0 0-.35-.15H6.71l1.07-1.07.07-.09a12 12 0 0 0 1.2-3.01 4 4 0 0 1 .24-.82A4 4 0 0 1 13 3"
]);
const $0debb7262aed7016$export$c73cb182760dc54a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEggFilled', "1em", [
    "M10.47 9.6a.5.5 0 0 0 .14-.98 2.14 2.14 0 0 0-2.35 2.16.5.5 0 0 0 1 0c0-.8.7-1.24 1.2-1.17M3.99 7.14c-2.41 1.91-2.48 5.15-1.34 7.32a4.9 4.9 0 0 0 4.42 2.77q.8 0 1.24-.03c.94-.03 1.11-.04 2.42.48a5.6 5.6 0 0 0 5.12-.47c1.39-.87 2.19-2.88 2.05-4.52-.08-.98 0-1.36.09-1.86.06-.33.13-.7.17-1.34a7 7 0 0 0-1.05-3.81 7.6 7.6 0 0 0-2.72-2.85 6.2 6.2 0 0 0-5.86-.15 7 7 0 0 0-3.07 3 5 5 0 0 1-1.47 1.46m10.91 3.34a4.5 4.5 0 1 1-8.99 0 4.5 4.5 0 0 1 8.99 0"
]);
const $0debb7262aed7016$export$7667e91027a72acb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEggRegular', "1em", [
    "M10.06 9.58a.5.5 0 1 0 .14-1c-.94-.12-1.78.6-1.78 1.64a.5.5 0 0 0 1 0c0-.46.32-.68.64-.64m.35 5.38a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9m0-1a3.5 3.5 0 1 1 0-6.99 3.5 3.5 0 0 1 0 7m1.22-11.89c1.04.07 2.02.38 2.72.83a7.6 7.6 0 0 1 2.7 2.83 7 7 0 0 1 1.05 3.82 10 10 0 0 1-.21 1.53c-.06.32-.1.66-.04 1.38.07.85-.1 1.78-.46 2.6a4.5 4.5 0 0 1-1.68 2.07 5.7 5.7 0 0 1-5.22.48c-.8-.33-1.08-.4-1.38-.42h-.65q-.43.03-1.18.03a5 5 0 0 1-4.56-2.84C1.59 12.2 1.62 8.9 4.1 6.94c.75-.6.98-.8 1.24-1.22.42-.7.82-1.25 1.3-1.73A8 8 0 0 1 8.4 2.74a6 6 0 0 1 3.23-.67m-.07 1c-.9-.06-1.85.1-2.68.55a7 7 0 0 0-1.53 1.09c-.4.39-.75.86-1.14 1.52-.37.6-.73.9-1.49 1.5-2 1.59-2.1 4.31-1.11 6.19a4 4 0 0 0 3.67 2.3l1.14-.02h.02q.4-.02.73 0c.48.02.89.16 1.7.48 1.46.58 3 .41 4.31-.4.54-.34 1-.92 1.3-1.61s.43-1.46.38-2.13a6 6 0 0 1 .08-1.87c.06-.3.12-.63.16-1.19a6 6 0 0 0-.91-3.26 6.6 6.6 0 0 0-2.37-2.48 5 5 0 0 0-2.26-.67"
]);
const $0debb7262aed7016$export$a90fdcf26d69df2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFishFilled', "1em", [
    "M8.63 3.7c-1.5 1.5-1.76 3.87-1.72 5.67a.4.4 0 0 1-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52q.53.15.9.33.38.18.5.3.14.13.31.5.18.4.33.91c.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 0 1 .4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25s.17-2.37.08-3.32a3 3 0 0 0-2.73-2.73 13 13 0 0 0-3.32.08c-1.17.2-2.35.65-3.25 1.54m4.62.8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $0debb7262aed7016$export$9259e1a19e5193b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFishRegular', "1em", [
    "M7.91 9.35c-.04-1.76.24-3.76 1.43-4.95.7-.7 1.66-1.08 2.72-1.26a12 12 0 0 1 3.05-.07c.98.09 1.73.84 1.82 1.82.09.9.11 2-.07 3.06a5 5 0 0 1-1.26 2.71c-1.19 1.2-3.19 1.47-4.95 1.43a1.4 1.4 0 0 0-1.43 1.3c-.1 1.47-.4 3.17-1.11 4.52q-.06.09-.08.09h-.06q-.12-.03-.2-.25c-.13-.7-.3-1.54-.53-2.28a8 8 0 0 0-.38-1.03q-.2-.46-.5-.8-.33-.3-.8-.5-.46-.21-1.03-.38c-.74-.22-1.57-.4-2.28-.54-.16-.03-.23-.13-.25-.2v-.06q0-.01.09-.07a12 12 0 0 1 4.52-1.11 1.4 1.4 0 0 0 1.3-1.43m.72-5.66c-1.5 1.5-1.76 3.88-1.72 5.68a.4.4 0 0 1-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52q.53.15.9.33.38.18.5.3.14.13.31.5.18.4.33.91c.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 0 1 .4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25s.17-2.37.08-3.32a3 3 0 0 0-2.73-2.73 13 13 0 0 0-3.32.08c-1.17.2-2.35.65-3.25 1.54m4.62.8a.75.75 0 1 1 0 1.51.75.75 0 0 1 0-1.5"
]);
const $0debb7262aed7016$export$34e8484c35b269c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrainsFilled', "1em", [
    "M10.43 2.21a.65.65 0 0 0-.86 0 5.7 5.7 0 0 0-1.92 4.35q0 .28.24.43A7 7 0 0 1 9.63 8.4a.5.5 0 0 0 .74 0 7 7 0 0 1 1.74-1.42.5.5 0 0 0 .24-.43c.02-1.59-.62-3.2-1.92-4.35m-7.41 10a.66.66 0 0 1 .6-.72A6.4 6.4 0 0 1 10 15.33a6.4 6.4 0 0 1 6.38-3.84c.36.03.64.35.6.72A6.37 6.37 0 0 1 10.64 18h-.46q-.1 0-.18-.02l-.18.02h-.46a6.37 6.37 0 0 1-6.34-5.8M10 10.83a6.4 6.4 0 0 0-6.38-3.84.66.66 0 0 0-.6.72q.13 1.36.76 2.5a.5.5 0 0 0 .43.26c2.1.01 4.03.92 5.37 2.39q.18.18.42.16a.5.5 0 0 0 .42-.16 7.4 7.4 0 0 1 5.36-2.4.5.5 0 0 0 .44-.25q.63-1.14.76-2.5a.66.66 0 0 0-.6-.72A6.4 6.4 0 0 0 10 10.83"
]);
const $0debb7262aed7016$export$99f56c9208682b90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrainsRegular', "1em", [
    "M10.43 2.21a.65.65 0 0 0-.86 0 5.7 5.7 0 0 0-1.74 5.74 7 7 0 0 0-4.2-.96.66.66 0 0 0-.61.72 7 7 0 0 0 1.65 3.77q-.53-.03-1.05 0a.66.66 0 0 0-.6.73A6.37 6.37 0 0 0 9.36 18h1.28c3.3 0 6.04-2.51 6.34-5.8a.66.66 0 0 0-.6-.71q-.53-.04-1.05-.01a7 7 0 0 0 1.65-3.77.66.66 0 0 0-.6-.72 7 7 0 0 0-4.21.96c.52-2-.06-4.24-1.74-5.74M10 14.43a7 7 0 0 0-3.47-2.6 6.2 6.2 0 0 1-2.47-3.86c1.54-.05 3 .5 4.12 1.45.76.64.96 1.23 1.15 1.76l.22.54a.5.5 0 0 0 .9 0l.22-.54c.18-.53.4-1.12 1.15-1.76a6 6 0 0 1 4.12-1.45 6.2 6.2 0 0 1-2.5 3.9A7 7 0 0 0 10 14.42M9.36 17a5.4 5.4 0 0 1-5.3-4.53 6.1 6.1 0 0 1 5.5 3.13.5.5 0 0 0 .88 0 6.1 6.1 0 0 1 5.5-3.13 5.4 5.4 0 0 1-5.3 4.53zM10 9.82a4.74 4.74 0 0 1 0-6.64 4.74 4.74 0 0 1 0 6.64"
]);
const $0debb7262aed7016$export$5676c86e05e055c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizzaFilled', "1em", [
    "M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86l-.25.19-.4-.44V9.3A16.4 16.4 0 0 0 4.88 4.5H4zM4 5.5V16.5a1.5 1.5 0 0 0 2.4 1.2L8 16.5a1 1 0 0 0 2 0v-2a.5.5 0 0 1 1-.06V15a1 1 0 0 0 2 0v-2.24c.82-.6 2.09-1.56 3.19-2.4l-.33-.37A15.4 15.4 0 0 0 4.87 5.5zm4.25 2.74a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.97 2a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-2.96 2.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $0debb7262aed7016$export$f56adc4e4fc21e7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizzaRegular', "1em", [
    "M7.5 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.72 1.26a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86-1.24.95-3.12 2.4-4.23 3.2v1.74c0 .72-.55 1.5-1.5 1.5q-.27 0-.5-.08v.09c0 .7-.55 1.49-1.5 1.49-.75 0-1.25-.5-1.42-1.05L6.4 17.7A1.5 1.5 0 0 1 4 16.5zm7 10.54c0 .26.2.5.5.5s.5-.24.5-.5v-2a.5.5 0 0 1 .21-.4c.78-.56 2.1-1.57 3.28-2.47A15.4 15.4 0 0 0 5 5.51V16.5c0 .41.47.64.8.4l2.4-1.8a.5.5 0 0 1 .8.4v.5c0 .25.2.5.5.5a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 1 1 0m5.62-5.73c.46-.36.5-1 .12-1.36-2.86-2.72-6.52-4.15-10.77-4.4a.93.93 0 0 0-.97.95v.55c4.33.04 8.4 1.7 11.3 4.5z"
]);
const $0debb7262aed7016$export$71ceb9721e925e33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToastFilled', "1em", [
    "M6.78 7.45a.5.5 0 0 0-.5.5v4.1c0 .27.22.5.5.5h4.34a.5.5 0 0 0 .5-.5v-4.1a.5.5 0 0 0-.5-.5zm.5 1h3.34v3.1H7.28zM5.45 2.5c-1.63 0-3 1.1-3.6 2.48-.6 1.33-.49 3 .81 4.22v5.98c0 .3-.01.87.28 1.36.36.6 1.08.96 2.26.96h10.18q.61 0 1.1-.07.46-.07.85-.39c.5-.43.59-1.13.59-1.95 0-.88-.04-1.92-.07-2.93a67 67 0 0 1-.07-2.97 4.7 4.7 0 0 0 1.28-3 3.73 3.73 0 0 0-3.68-3.69zm7.38 1c.62 0 1.39.3 2 .82.6.51.99 1.18 1 1.85-.05.75-.21 1.24-.41 1.58q-.24.39-.56.69l-.16.15-.31.3-.14.13v.2c-.04 1-.03 2.44-.02 3.84v.01l.01 2.02q0 .6-.06.9-.07.28-.14.32-.04.07-.32.13-.2.04-.49.05l-.4.01H5.2c-1 0-1.3-.29-1.4-.47-.14-.23-.14-.51-.14-.84v-6.2a.5.5 0 0 0-.18-.39 2.65 2.65 0 0 1-.72-3.22 3 3 0 0 1 2.7-1.88z"
]);
const $0debb7262aed7016$export$7f6fa566dcc1be1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToastRegular', "1em", [
    "M6.23 7.95c0-.27.22-.5.5-.5h4.34c.28 0 .5.23.5.5v4.1a.5.5 0 0 1-.5.5H6.73a.5.5 0 0 1-.5-.5zm1 3.6h3.34v-3.1H7.23zM1.79 4.98A4 4 0 0 1 5.4 2.5h9.93A3.73 3.73 0 0 1 19 6.18c0 1.33-.76 2.46-1.28 3.01 0 .7.02 1.66.06 2.67v.3c.04 1 .08 2.05.08 2.93 0 .82-.1 1.52-.59 1.95q-.37.31-.86.39-.47.07-1.1.07H5.16c-1.18 0-1.9-.35-2.26-.96a2.5 2.5 0 0 1-.28-1.45V9.2a3.6 3.6 0 0 1-.82-4.22M5.4 3.5c-1.16 0-2.21.8-2.7 1.88a2.65 2.65 0 0 0 .73 3.22q.18.16.18.38v6.21c0 .33 0 .6.14.84.1.18.4.47 1.4.47h7.63q.59 0 .89-.06c.2-.03.28-.09.32-.13q.08-.04.14-.32.06-.3.06-.9v-2c-.02-1.42-.03-2.87 0-3.87a.5.5 0 0 1 .15-.34l.3-.3c.24-.21.44-.4.63-.68.25-.35.46-.86.5-1.73 0-.67-.39-1.34-1-1.85a3.3 3.3 0 0 0-1.99-.82zm9.71 12.69-.08.31h.3q.6 0 .9-.06c.23-.04.33-.1.4-.15.12-.1.24-.36.24-1.2 0-.86-.04-1.89-.07-2.9l-.01-.3c-.04-1.1-.07-2.16-.05-2.92a.5.5 0 0 1 .15-.35 3.7 3.7 0 0 0 1.12-2.44 2.73 2.73 0 0 0-2.65-2.68l.06.06a3.5 3.5 0 0 1 1.35 2.62v.03a4.2 4.2 0 0 1-.67 2.26c-.26.38-.58.67-.84.91l-.07.07c-.02.97-.02 2.3 0 3.6v2.04q0 .64-.08 1.1"
]);
const $0debb7262aed7016$export$d2505fbd697b65ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoFilled', "1em", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M9.5 8.91a.5.5 0 0 1 1 0v4.69a.5.5 0 0 1-1 0V8.9m-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
]);
const $0debb7262aed7016$export$4c7d6579126bcce7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoRegular', "1em", [
    "M10.5 8.91a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91m.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $0debb7262aed7016$export$de75ec78e01a2f31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoShieldFilled', "1em", [
    "M17 9a8 8 0 1 0-6.28 7.81l-.2-.42a7 7 0 0 1-.52-2.5v-2.8c0-.75.59-1.42 1.4-1.42.9 0 1.76-.37 2.6-1.24a1.4 1.4 0 0 1 2 0 5 5 0 0 0 1 .8zM8.5 7.91a.5.5 0 0 1 1 0v4.69a.5.5 0 0 1-1 0V7.9m-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m8.75 4.6a5 5 0 0 1-1-.59q-.36-.27-.72-.64a.4.4 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77q.05 1.2.44 2.15A5 5 0 0 0 13 18q.78.6 1.87.98.13.05.26 0 3.86-1.35 3.87-5.4V11a.4.4 0 0 0-.4-.33 4 4 0 0 1-1.6-.32"
]);
const $0debb7262aed7016$export$bcc5f566084cdeed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoShieldRegular', "1em", [
    "M17 9a8 8 0 1 0-6.28 7.81 6 6 0 0 1-.39-.94Q9.7 16 9 16a7 7 0 1 1 6.97-7.6q.03 0 .04.03a5 5 0 0 0 .99.8zM9.05 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M9 7.5a.5.5 0 0 1 .5.41v4.59a.5.5 0 0 1-1 .1V8c0-.28.22-.5.5-.5m8 2.85a5 5 0 0 1-1-.59q-.36-.27-.72-.64a.4.4 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77q.05 1.2.44 2.15A5 5 0 0 0 13 18q.78.6 1.87.98.13.05.26 0 3.86-1.35 3.87-5.4V11a.4.4 0 0 0-.4-.33 4 4 0 0 1-1.6-.32"
]);
const $0debb7262aed7016$export$34f4a15733f78c7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9zm-8-3.09a.5.5 0 0 1 1 0v4.69a.5.5 0 0 1-1 0V8.9m-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
]);
const $0debb7262aed7016$export$1271cb24bc5b86ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9zm-7-3.09a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91m.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $0debb7262aed7016$export$4242b17a69cccf3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFilled', "1em", [
    "M17.78 2.22c.3.3.3.77 0 1.06l-14.5 14.5a.75.75 0 0 1-1.06-1.06l14.5-14.5c.3-.3.77-.3 1.06 0"
]);
const $0debb7262aed7016$export$84df88c5099c4464 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineRegular', "1em", [
    "M17.85 2.15c.2.2.2.51 0 .7l-15 15a.5.5 0 0 1-.7-.7l15-15c.2-.2.5-.2.7 0"
]);
const $0debb7262aed7016$export$2feaf2417128b087 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashesFilled', "1em", [
    "M16.78 4.28a.75.75 0 0 0-1.06-1.06l-.5.5a.75.75 0 0 0 1.06 1.06zm-3 1.94c.3.3.3.77 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0m-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0m-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 0 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0m-3 4.06a.75.75 0 1 0-1.06-1.06l-.5.5a.75.75 0 1 0 1.06 1.06z"
]);
const $0debb7262aed7016$export$a8e76c6b30c6a8ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashesRegular', "1em", [
    "M16.85 3.85a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 .7.7zm-3 2.3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0m-3 3.7a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 .7.7z"
]);
const $0debb7262aed7016$export$d14c224f9ec41259 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRightFilled', "1em", [
    "M15.85 4.85a.5.5 0 0 0-.7-.7l-7.41 7.4a3 3 0 1 0 .7.7z"
], {
    flipInRtl: true
});
const $0debb7262aed7016$export$a1b4ef7653265953 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRightRegular', "1em", [
    "M15.85 4.85a.5.5 0 0 0-.7-.7l-7.41 7.4a3 3 0 1 0 .7.7zM4 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
], {
    flipInRtl: true
});
const $0debb7262aed7016$export$25fb2a75524ff932 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Filled', "1em", [
    "M2 9.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75"
]);
const $0debb7262aed7016$export$9c9d7321918b01e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Regular', "1em", [
    "M2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $0debb7262aed7016$export$38c85c15cae65f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashDotDashFilled', "1em", [
    "M10 11.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M2.75 9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm12 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z"
]);
const $0debb7262aed7016$export$6b755e4b5e855cfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashDotDashRegular', "1em", [
    "M10 10.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M2 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m11 0c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $0debb7262aed7016$export$81571ea4d571244b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashesFilled', "1em", [
    "M2 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 2 9.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 9.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
]);
const $0debb7262aed7016$export$9b142acd09b9dba4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashesRegular', "1em", [
    "M2 9.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"
]);
const $0debb7262aed7016$export$36af9e5706cc08c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DotFilled', "1em", [
    "M3.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $0debb7262aed7016$export$10580bce5bceda70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DotRegular', "1em", [
    "M3.25 10.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M18 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $0debb7262aed7016$export$993c02069fb8b5e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolidFilled', "1em", [
    "M2.75 6a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm6 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm6 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm-12 6a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $0debb7262aed7016$export$7562cc649bb02a2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolidRegular', "1em", [
    "M2.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm6 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm6 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-12 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $0debb7262aed7016$export$30eba13d5888b8b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal3Filled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75m0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M2.75 14a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $0debb7262aed7016$export$a352d3cbca51ef76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal3Regular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $0debb7262aed7016$export$e70b7f80678f10a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Filled', "1em", [
    "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75m0 4c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75M2.75 11a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 15.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $0debb7262aed7016$export$1037f32d77257f6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Regular', "1em", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 4h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1M2 11.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $0debb7262aed7016$export$775f9ddde8298c77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4SearchFilled', "1em", [
    "M12.5 10c.97 0 1.87-.3 2.6-.83l3.62 3.61a.75.75 0 1 0 1.06-1.06l-3.61-3.61A4.5 4.5 0 1 0 12.5 10m0-7.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6m3.03 8.5 1.5 1.5H2.75a.75.75 0 0 1 0-1.5h12.78M2.75 3H7.6q-.36.7-.5 1.5H2.74a.75.75 0 0 1 0-1.5m0 4h4.46q.23.81.68 1.5H2.75a.75.75 0 0 1 0-1.5M2 15.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75"
]);
const $0debb7262aed7016$export$8d347c26104ba913 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4SearchRegular', "1em", [
    "M12.5 10c1.06 0 2.04-.37 2.8-.98l3.85 3.83a.5.5 0 0 0 .7-.7L16.02 8.3A4.5 4.5 0 1 0 12.5 10m0-8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m.02 9h3.36l1 1H2.5a.5.5 0 0 1 0-1h10.02M2.5 3h5.1q-.24.48-.4 1H2.5a.5.5 0 0 1 0-1m5.1 5q-.25-.48-.4-1H2.5a.5.5 0 0 0 0 1zM2 15.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $0debb7262aed7016$export$f9f0465d04a2f225 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5Filled', "1em", [
    "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75m0 6c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M2.75 12a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 6.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 6.75M2.75 15a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $0debb7262aed7016$export$4e0a05703e1f1c17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5Regular', "1em", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 6c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M2.5 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $0debb7262aed7016$export$3288cafd19b0f7f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5ErrorFilled', "1em", [
    "M2.75 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 6a.75.75 0 0 0 0 1.5h7.14q.57-.9 1.45-1.5zm0 3h6.46Q9 12.72 9 13.5H2.75a.75.75 0 0 1 0-1.5m0 3h6.46q.23.81.68 1.5H2.75a.75.75 0 0 1 0-1.5m0-9a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM19 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $0debb7262aed7016$export$c1dfbf32eed67a1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5ErrorRegular', "1em", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 6a.5.5 0 0 0 0 1h7.76q.47-.58 1.08-1zm0 3h6.7q-.13.49-.18 1H2.5a.5.5 0 0 1 0-1m0 3h6.7q.16.52.4 1H2.5a.5.5 0 0 1 0-1m0-9a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM19 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $0debb7262aed7016$export$faed22fbbb91c74d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleFilled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 2 4.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 4.75m6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m-12 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75M3.25 14a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $0debb7262aed7016$export$2cb65a99524880ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-12 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M3 14a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2z"
]);
const $0debb7262aed7016$export$88ed8c2ee76846c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketchFilled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75m2.9 4.29c.7-.25 1.49-.54 2.62-.54s1.92.29 2.62.54h.02c.68.25 1.27.46 2.13.46.76 0 1.3-.16 1.94-.35l.28-.08a6 6 0 0 1 2.86-.23.75.75 0 1 1-.24 1.48 4.7 4.7 0 0 0-2.46.27c-.64.19-1.4.41-2.38.41-1.13 0-1.93-.29-2.62-.54h-.02A6 6 0 0 0 7.52 10c-.86 0-1.45.2-2.13.46h-.02c-.7.25-1.49.54-2.62.54a.75.75 0 0 1 0-1.5c.86 0 1.44-.2 2.13-.46zM17.9 14.4a.75.75 0 0 0-1.01-.31l-.29.14q-.28.14-.74.32c-.62.25-1.32.45-1.84.45a2.5 2.5 0 0 1-1.26-.41l-.03-.02a4 4 0 0 0-1.93-.57c-.85 0-1.5.32-1.98.56l-.03.02c-.52.25-.87.42-1.35.42a1 1 0 0 1-.4-.07 1 1 0 0 1-.24-.21l-.02-.02c-.12-.12-.32-.31-.6-.46A2.3 2.3 0 0 0 5.1 14c-.85 0-1.58.32-2.06.6a5 5 0 0 0-.81.61.75.75 0 0 0 1.05 1.08l.12-.11q.15-.12.4-.29c.36-.2.81-.39 1.3-.39q.34.01.4.07.07.03.25.21l.01.02c.12.12.32.31.6.46q.44.24 1.1.24c.84 0 1.48-.32 1.97-.56l.03-.02c.51-.25.87-.42 1.35-.42.46 0 .78.16 1.25.41l.03.02a4 4 0 0 0 1.94.57c.82 0 1.73-.3 2.39-.55a13 13 0 0 0 1.18-.54c.37-.2.5-.65.31-1.01"
]);
const $0debb7262aed7016$export$97c934b07bf3dbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketchRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m7.75 5.48c.72.25 1.5.52 2.62.52a8 8 0 0 0 2.64-.48c.72-.2 1.41-.34 2.42-.2a.5.5 0 0 0 .14-.98c-1.2-.18-2.04 0-2.82.22l-.29.08a7 7 0 0 1-2.1.36c-.94 0-1.58-.22-2.3-.47a7 7 0 0 0-2.63-.53c-1.12 0-1.9.27-2.62.52-.72.26-1.37.48-2.31.48a.5.5 0 0 0 0 1c1.12 0 1.9-.27 2.62-.52h.01a6 6 0 0 1 2.3-.48c.95 0 1.6.22 2.3.47zm8.2 4.3a.5.5 0 0 0-.68-.22l-.3.14q-.31.15-.8.33c-.64.25-1.4.47-2 .47-.56 0-.95-.2-1.44-.44l-.02-.02a4 4 0 0 0-1.88-.54c-.8 0-1.41.3-1.92.54h-.03c-.52.26-.95.46-1.52.46q-.4-.01-.54-.1-.14-.08-.33-.26v-.01c-.13-.12-.3-.3-.56-.42a2 2 0 0 0-1-.21c-.81 0-1.5.3-1.98.57a5 5 0 0 0-.8.57.5.5 0 1 0 .73.7 3 3 0 0 1 .56-.4c.4-.23.92-.44 1.5-.44.28 0 .43.05.54.1q.14.08.32.26l.01.01c.13.12.3.3.56.42q.39.21 1 .21c.8 0 1.41-.3 1.92-.54h.03c.52-.26.95-.46 1.51-.46s.95.2 1.44.44l.02.02c.48.24 1.06.54 1.88.54.79 0 1.7-.28 2.36-.53a14 14 0 0 0 1.2-.52.5.5 0 0 0 .21-.68"
]);
const $0debb7262aed7016$export$19159015842877ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThicknessFilled', "1em", [
    "M2.75 4a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zM2 9.25C2 8.56 2.56 8 3.25 8h13.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 10.5 2 9.94 2 9.25m0 5.5c0-.97.78-1.75 1.75-1.75h12.5a1.75 1.75 0 1 1 0 3.5H3.75c-.97 0-1.75-.78-1.75-1.75"
]);
const $0debb7262aed7016$export$a031be381f8d1c21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThicknessRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m0 10c0-.83.67-1.5 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13A1.5 1.5 0 0 1 2 14.5M3 8a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2z"
]);
const $0debb7262aed7016$export$7c38538f4de6f274 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_20_color__a)",
            "d": "M14 6a4 4 0 0 1 .2 8H12a.75.75 0 0 1-.1-1.5H14a2.5 2.5 0 0 0 .16-5H12a.75.75 0 0 1-.1-1.5H14M8 6a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8M6.25 9.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zh7.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_20_color__a",
                "x1": "-3.14",
                "x2": "3.2",
                "y1": "2.5",
                "y2": "21.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $0debb7262aed7016$export$8f0d7307721404bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkFilled', "1em", [
    "M14 6a4 4 0 0 1 .2 8H12a.75.75 0 0 1-.1-1.5H14a2.5 2.5 0 0 0 .16-5H12a.75.75 0 0 1-.1-1.5H14M8 6a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8M6.25 9.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zh7.5z"
]);
const $0debb7262aed7016$export$e803d44c8164869e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkRegular', "1em", [
    "M8 6a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 .22 8H12a.5.5 0 0 1-.09-1H14a3 3 0 0 0 .2-6H12a.5.5 0 0 1-.09-1H14M6 9.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1zh8z"
]);
const $0debb7262aed7016$export$856d74b42b573269 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAddFilled', "1em", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 2 3.76q.73.23 1.36.64.46-.85.48-1.9M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75m5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $0debb7262aed7016$export$5b0ece11ac887a46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAddRegular', "1em", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5M18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.44 4.43q.46.2.88.47.46-.85.48-1.9m-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1m5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $0debb7262aed7016$export$d074e9da940e080b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismissFilled', "1em", [
    "M14 4a4 4 0 0 1 3.52 5.9q-.63-.42-1.36-.64.33-.56.34-1.26a2.5 2.5 0 0 0-2.34-2.5H12a.75.75 0 0 1-.1-1.5H14M8 4a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8M6.25 7.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.73-1.06a.5.5 0 0 0-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 0 0-.7.7l1.05 1.07-1.06 1.06a.5.5 0 0 0 .7.7l1.07-1.05 1.06 1.06a.5.5 0 0 0 .7-.7l-1.05-1.07z"
]);
const $0debb7262aed7016$export$cea8ebcf496d11d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismissRegular', "1em", [
    "M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 3.52 5.9 6 6 0 0 0-.88-.47Q16.99 8.8 17 8a3 3 0 0 0-2.8-3H12a.5.5 0 0 1-.09-1H14M6 7.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1zm13 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.73-1.06a.5.5 0 0 0-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 0 0-.7.7l1.05 1.07-1.06 1.06a.5.5 0 0 0 .7.7l1.07-1.05 1.06 1.06a.5.5 0 0 0 .7-.7l-1.05-1.07z"
]);
const $0debb7262aed7016$export$7e7c6446bdec165d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEditFilled', "1em", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16A2.5 2.5 0 0 1 16.5 8v.02q.8.1 1.45.63Q18 8.33 18 8M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75m5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5m-3.77 7.13 4.83-4.83a1.87 1.87 0 0 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.08l.37-1.5q.15-.58.58-1.01"
]);
const $0debb7262aed7016$export$fe23dc9a4a8ddbb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEditRegular', "1em", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09a.5.5 0 0 0-.1-1H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .4-.5M18 8a4 4 0 0 0-4-4h-2.1a.5.5 0 0 0 .1 1h2.2A3 3 0 0 1 17 8.14q.5.16.95.52Q18 8.33 18 8m-4-.5H5.9a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.1-1m-4.02 6.88 4.83-4.83a1.87 1.87 0 0 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.08l.37-1.5q.15-.58.58-1.01"
]);
const $0debb7262aed7016$export$f1926439b880896d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultipleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__a)",
            "fillRule": "evenodd",
            "d": "M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8m6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__b)",
            "fillRule": "evenodd",
            "d": "M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8m6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__c)",
            "fillRule": "evenodd",
            "d": "M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8m6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__d)",
            "d": "M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8q-.01 1.1-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__e)",
            "d": "M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8q-.01 1.1-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_link_multiple_20_color__f)",
            "d": "M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8q-.01 1.1-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(36.95 -5.17 4.45)scale(14.3329 12.726)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#367af2"
                }
            ],
            [
                "stop",
                {
                    "offset": ".94",
                    "stopColor": "#5750e2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6f47df"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-6 0 0 -5.8875 9 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".23",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".4",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#261d82"
                }
            ],
            [
                "stop",
                {
                    "offset": ".78",
                    "stopColor": "#261d82",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 0 0 5.8875 11 8)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".23",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".4",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#2764e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".78",
                    "stopColor": "#2764e7",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__c",
                "x1": "13.5",
                "x2": "8",
                "y1": "13",
                "y2": "4.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".07",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".27",
                    "stopColor": "#5157e4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".6",
                    "stopColor": "#5157e4",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__d",
                "x1": ".5",
                "x2": "7.54",
                "y1": "4.5",
                "y2": "23.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_link_multiple_20_color__f",
                "x1": "9.5",
                "x2": "13",
                "y1": "5",
                "y2": "11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#31b3ee",
                    "stopOpacity": ".24"
                }
            ],
            [
                "stop",
                {
                    "offset": ".21",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".57",
                    "stopColor": "#31b3ee"
                }
            ],
            [
                "stop",
                {
                    "offset": ".88",
                    "stopColor": "#31b3ee",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $0debb7262aed7016$export$8f55fb17a85d3ec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultipleFilled', "1em", [
    "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H9.75a.75.75 0 0 1 0-1.5H11a2.5 2.5 0 0 0 0-5H5a2.5 2.5 0 0 0-.74 4.89q-.24.71-.26 1.48A4 4 0 0 1 1 8m15 .13q-.02.77-.26 1.48A2.5 2.5 0 0 1 15 14.5H9a2.5 2.5 0 0 1 0-5h1.25a.75.75 0 0 0 0-1.5H9a4 4 0 1 0 0 8h6a4 4 0 0 0 1-7.87"
]);
const $0debb7262aed7016$export$dbda2bc01098246c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultipleRegular', "1em", [
    "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H9.5a.5.5 0 0 1 0-1H11a3 3 0 1 0 0-6H5a3 3 0 0 0-.87 5.87 5 5 0 0 0-.13 1A4 4 0 0 1 1 8m17 4a3 3 0 0 0-2.13-2.87q.12-.49.13-1A4 4 0 0 1 15 16H9a4 4 0 0 1 0-8h1.5a.5.5 0 0 1 0 1H9a3 3 0 1 0 0 6h6a3 3 0 0 0 3-3"
]);
const $0debb7262aed7016$export$81b5254e6ef3c5ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L13.29 14H12a.75.75 0 0 1-.18-1.48l-1.78-1.77H6.25a.75.75 0 0 1-.1-1.5h2.4L6.78 7.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.65-7.95l-3.2-3.2a.5.5 0 0 1 0-.7M14 6a4 4 0 0 1 1.73 7.6l-1.17-1.16a2.5 2.5 0 0 0-.4-4.94H12a.75.75 0 0 1-.1-1.5H14m-.25 3.25a.75.75 0 0 1 .1 1.5h-.98l-1.5-1.5z"
]);
const $0debb7262aed7016$export$deeab300357cc84f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L13.29 14H12a.5.5 0 0 1-.09-1h.39l-2.5-2.5H6a.5.5 0 0 1-.09-1H8.8L6.3 7H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.65-7.95l-3.2-3.2a.5.5 0 0 1 0-.7M14 6a4 4 0 0 1 1.73 7.6l-.77-.76a3 3 0 0 0-.76-5.83L14 7h-2a.5.5 0 0 1-.09-1H14m0 3.5a.5.5 0 0 1 .09 1h-1.47l-1-1z"
]);
const $0debb7262aed7016$export$d45cc5f751fce8fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPersonFilled', "1em", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 1.89 3.93q.67.41 1.06 1.09c.56-.69.89-1.57.89-2.52M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75m5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5M16.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $0debb7262aed7016$export$5681da52d19bcf5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPersonRegular', "1em", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5M18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.26 4.72q.4.35.65.8c.56-.69.89-1.57.89-2.52m-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1m2.5 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $0debb7262aed7016$export$fe89cce3d55a873a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettingsFilled', "1em", [
    "M12.06 8.9a2 2 0 0 0 2.9 0l.5-.52q.81.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.66.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8l.58-.15a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91zM13.5 12c-.8 0-1.45.67-1.45 1.5S12.7 15 13.5 15s1.45-.67 1.45-1.5S14.3 12 13.5 12M8 4c.41 0 .75.34.75.75 0 .43-.34.72-.75.75H6a2.5 2.5 0 0 0-.16 5h1.89q-.37.7-.55 1.5H6a4 4 0 0 1-.2-8H8m3.72 3.25q-1.52.44-2.65 1.5H6.25a.75.75 0 0 1-.1-1.5h5.57M14 4a4 4 0 0 1 3.93 4.75q-.65-.6-1.45-1.03a2.5 2.5 0 0 0-2.32-2.22H12a.75.75 0 0 1-.1-1.5H14"
]);
const $0debb7262aed7016$export$2c4827f232444cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettingsRegular', "1em", [
    "M12.06 8.9a2 2 0 0 0 2.9 0l.5-.52q.81.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.66.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8l.58-.15a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91zM13.5 12c-.8 0-1.45.67-1.45 1.5S12.7 15 13.5 15s1.45-.67 1.45-1.5S14.3 12 13.5 12M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6h1.7q-.2.49-.32 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 3.93 4.75q-.44-.4-.93-.73V8a3 3 0 0 0-2.8-3H12a.5.5 0 0 1-.09-1H14m-3 3.5a7 7 0 0 0-1.65 1H6a.5.5 0 0 1-.09-1H11"
]);
const $0debb7262aed7016$export$fb035aeaac3f7ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquareFilled', "1em", [
    "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25H6V13H4.75A2.75 2.75 0 0 1 2 10.25v-5.5A2.75 2.75 0 0 1 4.75 2h5.5A2.75 2.75 0 0 1 13 4.75v5.5A2.75 2.75 0 0 1 10.25 13H9.5v-1.5h.75c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25zM7 9.75A2.75 2.75 0 0 1 9.75 7h1v1.5h-1c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-1.5V7h1.5A2.75 2.75 0 0 1 18 9.75v5.5A2.75 2.75 0 0 1 15.25 18h-5.5A2.75 2.75 0 0 1 7 15.25z"
]);
const $0debb7262aed7016$export$77bdee4351a360b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquareRegular', "1em", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H6v1H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5H9v-1h1.5c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5zm5 4H11v1H9.5C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H14V7h1.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5v-6A2.5 2.5 0 0 1 9.5 7"
]);
const $0debb7262aed7016$export$3e645f976efe2a0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkToolboxFilled', "1em", [
    "M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 2.08 3.61q.76.25 1.24.86.5-.88.52-1.97M6.25 7.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $0debb7262aed7016$export$1874f212f59d7f0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkToolboxRegular', "1em", [
    "M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8m6 0a4 4 0 0 1 3.48 5.97q-.32-.41-.78-.66.3-.6.3-1.31a3 3 0 0 0-2.8-3H12a.5.5 0 0 1-.09-1H14M6 7.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1zm6 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $0debb7262aed7016$export$24b8a89126ebdb2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAddFilled', "1em", [
    "M2.75 2a.75.75 0 0 0 0 1.5H10a6.5 6.5 0 0 1 6.5 6.5 6.5 6.5 0 0 1-3.03 5.5h2.34A8 8 0 0 0 10 2zm5.6 15.83A8 8 0 0 1 4.19 4.5h2.34a6.5 6.5 0 0 0 3.47 12h7.25a.75.75 0 0 1 0 1.5H10q-.86 0-1.65-.17M10 7c.41 0 .75.34.75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5c0-.41.34-.75.75-.75"
]);
const $0debb7262aed7016$export$b23f1fbde40d927e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAddRegular', "1em", [
    "M2 2.5c0-.28.22-.5.5-.5H10a7.98 7.98 0 0 1 5.3 14h-1.7A7 7 0 0 0 10 3H2.5a.5.5 0 0 1-.5-.5M10 18A8 8 0 0 1 4.7 4h1.7A7 7 0 0 0 10 17h7.5a.5.5 0 0 1 0 1zm.5-10.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 1 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2z"
]);
const $0debb7262aed7016$export$54bc5f6abf1f2263 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemoteFilled', "1em", [
    "M16.97 15.03a.75.75 0 1 0 1.06-1.06L12.56 8.5l5.47-5.47a.75.75 0 0 0-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06zM3.03 4.97a.75.75 0 0 0-1.06 1.06l5.47 5.47-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6c.3-.3.3-.77 0-1.06z"
]);
const $0debb7262aed7016$export$695863befc9a8573 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemoteRegular', "1em", [
    "M17.15 14.85a.5.5 0 0 0 .7-.7L12.21 8.5l5.64-5.65a.5.5 0 0 0-.7-.7l-6 6a.5.5 0 0 0 0 .7zm-14.3-9.7a.5.5 0 1 0-.7.7l5.64 5.65-5.64 5.65a.5.5 0 0 0 .7.7l6-6a.5.5 0 0 0 0-.7z"
]);
const $0debb7262aed7016$export$85171fafab6b1e7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOutFilled', "1em", [
    "M11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11zm-2.5 7.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m4 4.75H12v-5h1v4.5a.5.5 0 0 1-.5.5M12 8V4h.5c.28 0 .5.22.5.5V8z"
]);
const $0debb7262aed7016$export$15e33383788999d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOutRegular', "1em", [
    "M8.5 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11zm-1 .58v11.84L4 15V5zM12.5 16H12v-5h1v4.5a.5.5 0 0 1-.5.5M12 8V4h.5c.28 0 .5.22.5.5V8z"
]);
const $0debb7262aed7016$export$8ef438d8fb541c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignatureFilled', "1em", [
    "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a1 1 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a1 1 0 0 1 .12-.2zM3.27 16.9q-.03 0-.05-.03l1.35-.34c.53.27 1.18.47 1.93.47q.75-.02 1.53-.47c.53-.3 1.03-.7 1.53-1.1l.13-.11c.44-.36.9-.74 1.34-1 .47-.27 1.04-.49 1.63-.3.82.28 1.08 1.04 1.32 1.84q.09.28.26.49.17.17.26.15.29 0 .8-.3a9 9 0 0 0 .93-.62 6 6 0 0 1 1.1-.55h.03l.14.47-.14-.48a.5.5 0 0 1 .28.96q-.02 0-.05.02-.05 0-.17.07a5 5 0 0 0-.91.53l-.7.46a3 3 0 0 1-1.31.44c-.44 0-.78-.23-1-.49a2 2 0 0 1-.48-.87c-.26-.87-.41-1.08-.68-1.17-.16-.05-.4-.02-.8.22q-.55.33-1.23.92l-.12.1c-.5.4-1.06.84-1.66 1.19s-1.29.6-2.03.6a5.5 5.5 0 0 1-3.23-1.1"
]);
const $0debb7262aed7016$export$77f307e4e15c6e35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignatureRegular', "1em", [
    "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a1 1 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a1 1 0 0 1 .12-.2zm2.75.7a1.44 1.44 0 0 0-2.04 0l-8.54 8.55-.93 2.77 2.98-.74 8.53-8.53c.57-.56.57-1.48 0-2.04M3.22 16.88l.05.03C4 17.44 5.1 18 6.5 18c.74 0 1.42-.26 2.03-.6.6-.35 1.16-.8 1.66-1.2l.12-.1q.68-.57 1.23-.91c.4-.24.64-.27.8-.22.27.1.42.3.68 1.17q.13.46.47.87c.23.26.57.49 1.01.49.47 0 .94-.23 1.3-.44a13 13 0 0 0 .97-.64 5 5 0 0 1 .82-.42l.04-.02h.01a.5.5 0 0 0-.28-.96h-.01l-.02.01-.31.12q-.3.13-.8.43l-.33.23q-.28.2-.6.39-.5.3-.79.3-.1.02-.26-.15-.17-.2-.26-.5c-.24-.8-.5-1.55-1.32-1.82-.59-.2-1.16.02-1.63.3-.44.25-.9.63-1.34.99l-.13.1q-.74.63-1.53 1.1-.77.46-1.53.48c-.75 0-1.4-.2-1.93-.47zM17.5 15.5l-.14-.48z"
]);





'use client';
const $f7ea6bb7d541868d$export$156654eb70e6b330 = (props, ref)=>{
    const { intent: intent, titleId: titleId } = (0, $060a05566cf52703$export$993ef5462439c9fb)();
    return {
        action: (0, $fcf7ddccaab7fd8f$exports).optional(props.action, {
            elementType: 'div'
        }),
        components: {
            root: 'div',
            media: 'div',
            action: 'div'
        },
        media: (0, $fcf7ddccaab7fd8f$exports).optional(props.media, {
            renderByDefault: !!intent,
            elementType: 'div'
        }),
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            children: props.children,
            id: titleId,
            ...props
        }), {
            elementType: 'div'
        }),
        intent: intent
    };
};
const $f7ea6bb7d541868d$export$b5a420a32d9a557b = (props, ref)=>{
    'use no memo';
    const backgroundAppearance = (0, $65acf7eb8449fd1a$export$9d103812d8321e51)();
    const baseState = $f7ea6bb7d541868d$export$156654eb70e6b330(props, ref);
    /** Determine the role and media to render based on the intent */ let defaultIcon;
    switch(baseState.intent){
        case 'success':
            defaultIcon = /*#__PURE__*/ $acw62.createElement((0, $6c2c53ad43edfb7d$export$f5ae24d05067c167), null);
            break;
        case 'error':
            defaultIcon = /*#__PURE__*/ $acw62.createElement((0, $81c528f1808b6955$export$a3e24f6751d686a9), null);
            break;
        case 'warning':
            defaultIcon = /*#__PURE__*/ $acw62.createElement((0, $eb093920387c7bf0$export$73296e0703a210f), null);
            break;
        case 'info':
            defaultIcon = /*#__PURE__*/ $acw62.createElement((0, $0debb7262aed7016$export$d2505fbd697b65ef), null);
            break;
    }
    return {
        ...baseState,
        media: (0, $fcf7ddccaab7fd8f$exports).optional(props.media, {
            defaultProps: {
                children: defaultIcon
            },
            renderByDefault: !!baseState.intent,
            elementType: 'div'
        }),
        backgroundAppearance: backgroundAppearance
    };
};



var $acw62 = parcelRequire("acw62");

const $cac780558e370a65$export$2493dbe8c36c1dcf = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            state.media ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.media, {}) : null,
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {}),
            state.action ? /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.action, {}) : null
        ]
    });
};




'use client';
const $a3e85d840d355a8d$export$7a148423fa52012b = {
    root: 'fui-ToastTitle',
    media: 'fui-ToastTitle__media',
    action: 'fui-ToastTitle__action'
};
const $a3e85d840d355a8d$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rdjap1e", null, [
    ".rdjap1e{display:flex;grid-column-end:3;color:var(--colorNeutralForeground1);word-break:break-word;}"
]);
const $a3e85d840d355a8d$var$useMediaBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r8x5mrd", "r1soj19y", [
    ".r8x5mrd{display:flex;padding-top:2px;grid-column-end:2;padding-right:8px;font-size:16px;color:var(--colorNeutralForeground1);}",
    ".r1soj19y{display:flex;padding-top:2px;grid-column-end:2;padding-left:8px;font-size:16px;color:var(--colorNeutralForeground1);}"
]);
const $a3e85d840d355a8d$var$useActionBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r2j19ip", "rjfozdo", [
    ".r2j19ip{display:flex;align-items:start;padding-left:12px;grid-column-end:-1;color:var(--colorBrandForeground1);}",
    ".rjfozdo{display:flex;align-items:start;padding-right:12px;grid-column-end:-1;color:var(--colorBrandForeground1);}"
]);
const $a3e85d840d355a8d$var$useInvertedStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f1w7i9ko"
    },
    action: {
        sj55zd: "f1qz2gb0"
    },
    media: {
        sj55zd: "fqpbvvt"
    }
}, {
    d: [
        ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}",
        ".f1qz2gb0{color:var(--colorBrandForegroundInverted);}",
        ".fqpbvvt{color:var(--colorNeutralForegroundInverted);}"
    ]
});
const $a3e85d840d355a8d$var$useIntentIconStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    success: {
        sj55zd: "f36rra6"
    },
    error: {
        sj55zd: "f1ca9wz"
    },
    warning: {
        sj55zd: "f13isgzr"
    },
    info: {
        sj55zd: "fkfq4zb"
    }
}, {
    d: [
        ".f36rra6{color:var(--colorStatusSuccessForeground1);}",
        ".f1ca9wz{color:var(--colorStatusDangerForeground1);}",
        ".f13isgzr{color:var(--colorStatusWarningForeground1);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}"
    ]
});
const $a3e85d840d355a8d$var$useIntentIconStylesInverted = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    success: {
        sj55zd: "ff3wk4x"
    },
    error: {
        sj55zd: "fbq2gqr"
    },
    warning: {
        sj55zd: "fx6hq1t"
    },
    info: {
        sj55zd: "f1w7i9ko"
    }
}, {
    d: [
        ".ff3wk4x{color:var(--colorStatusSuccessForegroundInverted);}",
        ".fbq2gqr{color:var(--colorStatusDangerForegroundInverted);}",
        ".fx6hq1t{color:var(--colorStatusWarningForegroundInverted);}",
        ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}"
    ]
});
const $a3e85d840d355a8d$export$8fe3d29dd21df3cf = (state)=>{
    const rootBaseClassName = $a3e85d840d355a8d$var$useRootBaseClassName();
    const actionBaseClassName = $a3e85d840d355a8d$var$useActionBaseClassName();
    const mediaBaseClassName = $a3e85d840d355a8d$var$useMediaBaseClassName();
    const intentIconStyles = $a3e85d840d355a8d$var$useIntentIconStyles();
    const intentIconStylesInverted = $a3e85d840d355a8d$var$useIntentIconStylesInverted();
    const { intent: intent } = state;
    const invertedStyles = $a3e85d840d355a8d$var$useInvertedStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($a3e85d840d355a8d$export$7a148423fa52012b.root, rootBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.root, state.root.className);
    if (state.media) // eslint-disable-next-line react-hooks/immutability
    state.media.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($a3e85d840d355a8d$export$7a148423fa52012b.media, mediaBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.media, intent && intentIconStyles[intent], intent && state.backgroundAppearance === 'inverted' && intentIconStylesInverted[intent], state.media.className);
    if (state.action) // eslint-disable-next-line react-hooks/immutability
    state.action.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($a3e85d840d355a8d$export$7a148423fa52012b.action, actionBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.action, state.action.className);
    return state;
};



'use client';
const $01b2d45943ab4f79$export$16d42d7c29b95a4 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $f7ea6bb7d541868d$export$b5a420a32d9a557b)(props, ref);
    (0, $a3e85d840d355a8d$export$8fe3d29dd21df3cf)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useToastTitleStyles_unstable')(state);
    return (0, $cac780558e370a65$export$2493dbe8c36c1dcf)(state);
});
$01b2d45943ab4f79$export$16d42d7c29b95a4.displayName = 'ToastTitle';


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

'use client';
function $043fa2afd5f880fc$export$48ae46445697407d() {
    const keyborgRef = (0, $445ef382aaae6992$export$22c92c328db732ac)();
    return $acw62.useCallback(()=>{
        var _keyborgRef_current;
        var _keyborgRef_current_isNavigatingWithKeyboard;
        return (_keyborgRef_current_isNavigatingWithKeyboard = (_keyborgRef_current = keyborgRef.current) === null || _keyborgRef_current === void 0 ? void 0 : _keyborgRef_current.isNavigatingWithKeyboard()) !== null && _keyborgRef_current_isNavigatingWithKeyboard !== void 0 ? _keyborgRef_current_isNavigatingWithKeyboard : false;
    }, [
        keyborgRef
    ]);
}



/**
 * The height of the tooltip's arrow in pixels.
 */ const $b4745595c27251fd$export$d49163750ded1c4d = 6;
const $b4745595c27251fd$export$11d9cddcf86571d4 = 4;



var $acw62 = parcelRequire("acw62");

'use client';
const $a2edb6e6bef14d35$var$setTimeoutNoop = (_callback)=>-1;
const $a2edb6e6bef14d35$var$clearTimeoutNoop = (_handle)=>undefined;
function $a2edb6e6bef14d35$export$489b102fab32063e(triggerElementRef) {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const setTimerFn = win ? win.setTimeout : $a2edb6e6bef14d35$var$setTimeoutNoop;
    const clearTimerFn = win ? win.clearTimeout : $a2edb6e6bef14d35$var$clearTimeoutNoop;
    const id = $acw62.useRef(undefined);
    const set = $acw62.useCallback((fn, delay)=>{
        if (id.current !== undefined) clearTimerFn(id.current);
        id.current = setTimerFn(fn, delay !== null && delay !== void 0 ? delay : 0);
        return id.current;
    }, [
        clearTimerFn,
        setTimerFn
    ]);
    const cancel = $acw62.useCallback(()=>{
        if (id.current !== undefined) {
            clearTimerFn(id.current);
            id.current = undefined;
        }
    }, [
        clearTimerFn
    ]);
    // StrictMode-aware cleanup: only clear timeout if element has no parent (real unmount)
    $acw62.useEffect(()=>{
        const el = triggerElementRef.current;
        return ()=>{
            const isRealUnmount = !el || !el.isConnected;
            if (isRealUnmount) cancel();
        };
    }, [
        cancel,
        triggerElementRef
    ]);
    return [
        set,
        cancel
    ];
}



'use client';
const $96ad33b4b1225e15$export$e9d1da770da60981 = (props)=>{
    var _child_props, _child_props1, _child_props2, _child_props3, _child_props4, _child_props5, _child_props6;
    const context = (0, $90b5c6c5b9aab897$export$d047e971555191a)();
    const isServerSideRender = (0, $fecc0f8e699705f8$export$535bd6ca7f90a273)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const [visible, setVisibleInternal] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.visible,
        initialState: false
    });
    const [hidden, setHidden] = $acw62.useState(false);
    const { children: children, content: content, withArrow: withArrow = false, positioning: positioning = 'above', onVisibleChange: onVisibleChange, relationship: relationship, showDelay: showDelay = 250, hideDelay: hideDelay = 250, mountNode: mountNode } = props;
    const state = {
        withArrow: withArrow,
        positioning: positioning,
        showDelay: showDelay,
        hideDelay: hideDelay,
        relationship: relationship,
        visible: visible,
        hidden: hidden,
        shouldRenderTooltip: visible,
        mountNode: mountNode,
        // Slots
        components: {
            content: 'div'
        },
        content: (0, $fcf7ddccaab7fd8f$exports).always(content, {
            defaultProps: {
                role: 'tooltip'
            },
            elementType: 'div'
        })
    };
    state.content.id = (0, $0200d30cfa270435$export$f680877a34711e37)('tooltip-', state.content.id);
    const resolvedPositioning = (0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(state.positioning);
    const isVirtualTarget = resolvedPositioning.target !== undefined && !(0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(resolvedPositioning.target);
    const onPositioningEnd = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        var _resolvedPositioning_onPositioningEnd;
        // Portaled tooltips can escape the trigger's clipping ancestors while the trigger is still visible.
        // Virtual targets can be reported as hidden based on synthetic geometry.
        setHidden(!isVirtualTarget && event.detail.referenceHidden);
        (_resolvedPositioning_onPositioningEnd = resolvedPositioning.onPositioningEnd) === null || _resolvedPositioning_onPositioningEnd === void 0 || _resolvedPositioning_onPositioningEnd.call(resolvedPositioning, event);
    });
    const positioningOptions = {
        enabled: state.visible,
        arrowPadding: 2 * (0, $b4745595c27251fd$export$11d9cddcf86571d4),
        position: 'above',
        align: 'center',
        offset: 4,
        ...resolvedPositioning,
        onPositioningEnd: onPositioningEnd
    };
    if (state.withArrow) positioningOptions.offset = (0, $4f638fdc3c53bf8c$export$fef5d4d23735b493)(positioningOptions.offset, (0, $b4745595c27251fd$export$d49163750ded1c4d));
    const { targetRef: targetRef, containerRef: containerRef, arrowRef: arrowRef } = (0, $52c6e5e426b327c0$export$76e597284ffc020)(positioningOptions);
    const [setDelayTimeout, clearDelayTimeout] = (0, $a2edb6e6bef14d35$export$489b102fab32063e)(containerRef);
    const setVisible = $acw62.useCallback((ev, data)=>{
        clearDelayTimeout();
        setVisibleInternal((oldVisible)=>{
            if (data.visible !== oldVisible) onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(ev, data);
            return data.visible;
        });
    }, [
        clearDelayTimeout,
        setVisibleInternal,
        onVisibleChange
    ]);
    state.content.ref = (0, $de7d48ea62179626$export$9cf7d991616612b3)(state.content.ref, containerRef);
    state.arrowRef = arrowRef;
    // When this tooltip is visible, hide any other tooltips, and register it
    // as the visibleTooltip with the TooltipContext.
    // Also add a listener on document to hide the tooltip if Escape is pressed
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        if (visible) {
            var _context_visibleTooltip;
            const thisTooltip = {
                hide: (ev)=>setVisible(undefined, {
                        visible: false,
                        documentKeyboardEvent: ev
                    })
            };
            (_context_visibleTooltip = context.visibleTooltip) === null || _context_visibleTooltip === void 0 || _context_visibleTooltip.hide();
            // eslint-disable-next-line react-hooks/immutability
            context.visibleTooltip = thisTooltip;
            const onDocumentKeyDown = (ev)=>{
                if (ev.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685) && !ev.defaultPrevented) {
                    thisTooltip.hide(ev);
                    // stop propagation to avoid conflicting with other elements that listen for `Escape`
                    // e,g: Dialog, Popover, Menu and Tooltip
                    ev.preventDefault();
                }
            };
            targetDocument === null || targetDocument === void 0 || targetDocument.addEventListener('keydown', onDocumentKeyDown, {
                // As this event is added at targeted document,
                // we need to capture the event to be sure keydown handling from tooltip happens first
                capture: true
            });
            // Dismiss the tooltip when the document becomes hidden (e.g. tab backgrounded,
            // app switched on mobile). The original trigger (hover/tap/focus) is no longer
            // active in this case, so persisting the tooltip is a stale UI state.
            const onDocumentVisibilityChange = ()=>{
                if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.visibilityState) === 'hidden') thisTooltip.hide();
            };
            targetDocument === null || targetDocument === void 0 || targetDocument.addEventListener('visibilitychange', onDocumentVisibilityChange);
            return ()=>{
                if (context.visibleTooltip === thisTooltip) context.visibleTooltip = undefined;
                targetDocument === null || targetDocument === void 0 || targetDocument.removeEventListener('keydown', onDocumentKeyDown, {
                    capture: true
                });
                targetDocument === null || targetDocument === void 0 || targetDocument.removeEventListener('visibilitychange', onDocumentVisibilityChange);
            };
        }
    }, [
        context,
        targetDocument,
        visible,
        setVisible
    ]);
    // Used to skip showing the tooltip  in certain situations when the trigger is focused.
    // See comments where this is set for more info.
    const ignoreNextFocusEventRef = $acw62.useRef(false);
    // Listener for onPointerEnter and onFocus on the trigger element
    const onEnterTrigger = $acw62.useCallback((ev)=>{
        if (ev.type === 'focus' && ignoreNextFocusEventRef.current) {
            ignoreNextFocusEventRef.current = false;
            return;
        }
        // Show immediately if another tooltip is already visible
        const delay = context.visibleTooltip ? 0 : state.showDelay;
        setDelayTimeout(()=>{
            setVisible(ev, {
                visible: true
            });
        }, delay);
        ev.persist(); // Persist the event since the setVisible call will happen asynchronously
    }, [
        setDelayTimeout,
        setVisible,
        state.showDelay,
        context
    ]);
    const isNavigatingWithKeyboard = (0, $043fa2afd5f880fc$export$48ae46445697407d)();
    // Callback ref that attaches a keyborg:focusin event listener.
    const [keyborgListenerCallbackRef] = $acw62.useState(()=>{
        const onKeyborgFocusIn = (ev)=>{
            var _ev_detail;
            // Skip showing the tooltip if focus moved programmatically.
            // For example, we don't want to show the tooltip when a dialog is closed
            // and Tabster programmatically restores focus to the trigger button.
            // See https://github.com/microsoft/fluentui/issues/27576
            if (((_ev_detail = ev.detail) === null || _ev_detail === void 0 ? void 0 : _ev_detail.isFocusedProgrammatically) && !isNavigatingWithKeyboard()) ignoreNextFocusEventRef.current = true;
        };
        // Save the current element to remove the listener when the ref changes
        let current = null;
        // Callback ref that attaches the listener to the element
        return (element)=>{
            current === null || current === void 0 || current.removeEventListener((0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), onKeyborgFocusIn);
            element === null || element === void 0 || element.addEventListener((0, $134104a7b4fa5d8e$export$5644ea5c8a31b6ce), onKeyborgFocusIn);
            current = element;
        };
    });
    // Listener for onPointerLeave and onBlur on the trigger element
    const onLeaveTrigger = $acw62.useCallback((ev)=>{
        let delay = state.hideDelay;
        if (ev.type === 'blur') {
            // Hide immediately when losing focus
            delay = 0;
            // The focused element gets a blur event when the document loses focus
            // (e.g. switching tabs in the browser), but we don't want to show the
            // tooltip again when the document gets focus back. Handle this case by
            // checking if the blurred element is still the document's activeElement.
            // See https://github.com/microsoft/fluentui/issues/13541
            ignoreNextFocusEventRef.current = (targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.activeElement) === ev.target;
        }
        setDelayTimeout(()=>{
            setVisible(ev, {
                visible: false
            });
        }, delay);
        ev.persist(); // Persist the event since the setVisible call will happen asynchronously
    }, [
        setDelayTimeout,
        setVisible,
        state.hideDelay,
        targetDocument
    ]);
    // Cancel the hide timer when the mouse or focus enters the tooltip, and restart it when the mouse or focus leaves.
    // This keeps the tooltip visible when the mouse is moved over it, or it has focus within.
    // eslint-disable-next-line react-hooks/immutability
    state.content.onPointerEnter = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.content.onPointerEnter, clearDelayTimeout);
    // eslint-disable-next-line react-hooks/immutability, react-hooks/refs
    state.content.onPointerLeave = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.content.onPointerLeave, onLeaveTrigger);
    // eslint-disable-next-line react-hooks/immutability
    state.content.onFocus = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.content.onFocus, clearDelayTimeout);
    // eslint-disable-next-line react-hooks/immutability, react-hooks/refs
    state.content.onBlur = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.content.onBlur, onLeaveTrigger);
    const child = (0, $afe88029dd4784e4$export$8e7091920a6cd3c6)(children);
    const triggerAriaProps = {};
    const isPopupExpanded = (child === null || child === void 0 ? void 0 : (_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props['aria-haspopup']) && ((child === null || child === void 0 ? void 0 : (_child_props1 = child.props) === null || _child_props1 === void 0 ? void 0 : _child_props1['aria-expanded']) === true || (child === null || child === void 0 ? void 0 : (_child_props2 = child.props) === null || _child_props2 === void 0 ? void 0 : _child_props2['aria-expanded']) === 'true');
    if (relationship === 'label') {
        // aria-label only works if the content is a string. Otherwise, need to use aria-labelledby.
        if (typeof state.content.children === 'string') triggerAriaProps['aria-label'] = state.content.children;
        else {
            triggerAriaProps['aria-labelledby'] = state.content.id;
            // Always render the tooltip even if hidden, so that aria-labelledby refers to a valid element
            // eslint-disable-next-line react-hooks/immutability
            state.shouldRenderTooltip = true;
        }
    } else if (relationship === 'description') {
        triggerAriaProps['aria-describedby'] = state.content.id;
        // Always render the tooltip even if hidden, so that aria-describedby refers to a valid element
        // eslint-disable-next-line react-hooks/immutability
        state.shouldRenderTooltip = true;
    }
    // Case 1: Don't render the Tooltip in SSR to avoid hydration errors
    // Case 2: Don't render the Tooltip, if it triggers Menu or another popup and it's already opened
    if (isServerSideRender || isPopupExpanded) // eslint-disable-next-line react-hooks/immutability
    state.shouldRenderTooltip = false;
    // Apply the trigger props to the child, either by calling the render function, or cloning with the new props
    // eslint-disable-next-line react-hooks/immutability
    state.children = (0, $70e12b87c0533cc6$export$4ef26f87842d1b0)(children, {
        ...triggerAriaProps,
        ...child === null || child === void 0 ? void 0 : child.props,
        ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)((0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child), keyborgListenerCallbackRef, positioningOptions.target === undefined ? targetRef : undefined),
        // eslint-disable-next-line react-hooks/refs
        onPointerEnter: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : (_child_props3 = child.props) === null || _child_props3 === void 0 ? void 0 : _child_props3.onPointerEnter, onEnterTrigger)),
        // eslint-disable-next-line react-hooks/refs
        onPointerLeave: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : (_child_props4 = child.props) === null || _child_props4 === void 0 ? void 0 : _child_props4.onPointerLeave, onLeaveTrigger)),
        // eslint-disable-next-line react-hooks/refs
        onFocus: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : (_child_props5 = child.props) === null || _child_props5 === void 0 ? void 0 : _child_props5.onFocus, onEnterTrigger)),
        // eslint-disable-next-line react-hooks/refs
        onBlur: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : (_child_props6 = child.props) === null || _child_props6 === void 0 ? void 0 : _child_props6.onBlur, onLeaveTrigger))
    });
    return state;
};


'use client';
const $5325107a9d3745ef$export$d1b3bf355d15d272 = (props)=>{
    'use no memo'; // justified: compiler would optimize useTooltip_unstable — manual opt-out to preserve runtime behavior
    const { appearance: appearance = 'normal', ...baseProps } = props;
    const state = (0, $96ad33b4b1225e15$export$e9d1da770da60981)(baseProps);
    return {
        appearance: appearance,
        ...state
    };
};



var $acw62 = parcelRequire("acw62");


const $747c6057964c23c4$export$5f2a00d5030430fd = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            state.children,
            state.shouldRenderTooltip && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $aa8a2d30f790b072$export$602eac185826482c), {
                mountNode: state.mountNode,
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.content, {
                    children: [
                        state.withArrow && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)("div", {
                            ref: state.arrowRef,
                            className: state.arrowClassName
                        }),
                        state.content.children
                    ]
                })
            })
        ]
    });
};







'use client';
const $9f5ca45f069ce0e4$export$4fcd9d6cc26bc711 = {
    content: 'fui-Tooltip__content'
};
/**
 * Styles for the tooltip
 */ const $9f5ca45f069ce0e4$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "fjseox",
        B7ck84d: "f1ewtqcl",
        B2u0y6b: "f132xexn",
        Bceei9c: "f158kwzp",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm",
        Btd35i7: "fokg9q4",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f9ggezi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1bzqsji",
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5",
        Bhu2qc9: "fxeb0a7"
    },
    visible: {
        mc9l5x: "ftgm304"
    },
    hidden: {
        Bcdw1i0: "fd7fpy0",
        Bkecrkj: "f1aehjj5"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    arrow: {
        B7ck84d: "f1ewtqcl",
        qhf8xq: "f1euv43f",
        Bj3rh1h: "f1bsuimh",
        rhnwrx: "f1s3jn22",
        Bdy53xb: "fv40uqz",
        De3pzq: "f1u2r49w",
        B2eet1l: "fqhgnl",
        Beyfa6y: "f17bz04i",
        Bz10aip: "f36o3x3",
        Bqenvij: "fzofk8q",
        a9b677: "f1wbx1ie",
        Ftih45: "f1wl9k8s",
        Br0sdwz: "f1aocrix",
        cmx5o7: "f1ljr5q2",
        susq4k: 0,
        Biibvgv: 0,
        Bicfajf: 0,
        qehafq: 0,
        Brs5u8j: "f155f1qt",
        Ccq8qp: "f9mhzq7",
        Baz25je: "fr6rhvx",
        Bcgcnre: 0,
        Bqjgrrk: 0,
        qa3bma: 0,
        y0oebl: 0,
        Biqmznv: 0,
        Bm6vgfq: 0,
        Bbv0w2i: 0,
        uvfttm: 0,
        eqrjj: 0,
        Bk5zm6e: 0,
        m598lv: 0,
        B4f6apu: 0,
        ydt019: 0,
        Bq4z7u6: 0,
        Bdkvgpv: 0,
        B0qfbqy: 0,
        kj8mxx: "f1kc0wz4",
        r59vdv: "fgq90dz",
        Bkw5xw4: "fq0y47f",
        hl6cv3: "f1pwrbz6",
        aea9ga: "f1hxxcvm",
        yayu3t: "fw8rgyo",
        Bhsv975: "f1wnzycx",
        rhl9o9: "f1730wal",
        B7gxrvb: "f1fy4ixr",
        B6q6orb: "fobkauc",
        B0lu1f8: "f16bqv1l"
    }
}, {
    d: [
        ".fjseox{display:none;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f132xexn{max-width:240px;}",
        ".f158kwzp{cursor:default;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fokg9q4{overflow-wrap:break-word;}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f9ggezi{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        [
            ".f1bzqsji{padding:4px 11px 6px 11px;}",
            {
                p: -1
            }
        ],
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxeb0a7{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 4px 8px var(--colorNeutralShadowKey));}",
        ".ftgm304{display:block;}",
        ".fd7fpy0{visibility:hidden;}",
        ".f1aehjj5{pointer-events:none;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".f1euv43f{position:absolute;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1s3jn22{--fui-positioning-arrow-height:8.484px;}",
        ".fv40uqz{--fui-positioning-arrow-offset:-4.242px;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fqhgnl{background-clip:content-box;}",
        ".f17bz04i{border-bottom-left-radius:var(--borderRadiusSmall) ;}",
        ".f36o3x3{transform:rotate(var(--fui-positioning-arrow-angle)) ;}",
        ".fzofk8q{height:var(--fui-positioning-arrow-height);}",
        ".f1wbx1ie{width:var(--fui-positioning-arrow-height);}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1aocrix::before{display:block;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        [
            ".f155f1qt::before{margin:-1px;}",
            {
                p: -1
            }
        ],
        ".f9mhzq7::before{width:100%;}",
        ".fr6rhvx::before{height:100%;}",
        [
            ".f1kc0wz4::before{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fgq90dz::before{border-bottom-left-radius:var(--borderRadiusSmall) ;}",
        ".fq0y47f::before{clip-path:polygon(0% 0%, 100% 100%, 0% 100%);}",
        "[data-popper-placement^=\"top\"] .f1pwrbz6{bottom:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"top\"] .f1hxxcvm{--fui-positioning-arrow-angle:-45deg;}",
        "[data-popper-placement^=\"right\"] .fw8rgyo{left:var(--fui-positioning-arrow-offset) ;}",
        "[data-popper-placement^=\"right\"] .f1wnzycx{--fui-positioning-arrow-angle:45deg;}",
        "[data-popper-placement^=\"bottom\"] .f1730wal{top:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"bottom\"] .f1fy4ixr{--fui-positioning-arrow-angle:135deg;}",
        "[data-popper-placement^=\"left\"] .fobkauc{right:var(--fui-positioning-arrow-offset) ;}",
        "[data-popper-placement^=\"left\"] .f16bqv1l{--fui-positioning-arrow-angle:225deg;}"
    ]
});
const $9f5ca45f069ce0e4$export$f3d6962454aeef9e = (state)=>{
    const styles = $9f5ca45f069ce0e4$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.content.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($9f5ca45f069ce0e4$export$4fcd9d6cc26bc711.content, styles.root, state.appearance === 'inverted' && styles.inverted, state.visible && styles.visible, state.hidden && styles.hidden, state.content.className);
    // eslint-disable-next-line react-hooks/immutability
    state.arrowClassName = styles.arrow;
    return state;
};


'use client';
const $0e830a624458bf28$export$28c660c63b792dea = (props)=>{
    const state = (0, $5325107a9d3745ef$export$d1b3bf355d15d272)(props);
    (0, $9f5ca45f069ce0e4$export$f3d6962454aeef9e)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTooltipStyles_unstable')(state);
    return (0, $747c6057964c23c4$export$5f2a00d5030430fd)(state);
};
$0e830a624458bf28$export$28c660c63b792dea.displayName = 'Tooltip';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
$0e830a624458bf28$export$28c660c63b792dea.isFluentTriggerComponent = true;


var $acw62 = parcelRequire("acw62");


function $a20438eb9fe6b29c$export$1bb858dacb018cf6(toasterId, targetDocument) {
    const event = new CustomEvent((0, $2d233013a30c9870$export$fa3d5b535a2458a1).dismissAll, {
        bubbles: false,
        cancelable: false,
        detail: {
            toasterId: toasterId
        }
    });
    targetDocument.dispatchEvent(event);
}


function $5e3c5102c1b8a6f2$export$d05849f7e83bd5e1(toastId, toasterId, targetDocument) {
    const event = new CustomEvent((0, $2d233013a30c9870$export$fa3d5b535a2458a1).dismiss, {
        bubbles: false,
        cancelable: false,
        detail: {
            toastId: toastId,
            toasterId: toasterId
        }
    });
    targetDocument.dispatchEvent(event);
}


let $960e2467afef4b26$var$counter = 0;
function $960e2467afef4b26$export$4e1777ab45049969(content, options = {}, targetDocument) {
    var _options_toastId;
    const detail = {
        ...options,
        content: content,
        toastId: (_options_toastId = options.toastId) !== null && _options_toastId !== void 0 ? _options_toastId : ($960e2467afef4b26$var$counter++).toString()
    };
    const event = new CustomEvent((0, $2d233013a30c9870$export$fa3d5b535a2458a1).show, {
        bubbles: false,
        cancelable: false,
        detail: detail
    });
    targetDocument.dispatchEvent(event);
}


function $f369b7cec3418946$export$e69dd5b80441700a(toastId, toasterId, targetDocument) {
    const event = new CustomEvent((0, $2d233013a30c9870$export$fa3d5b535a2458a1).pause, {
        bubbles: false,
        cancelable: false,
        detail: {
            toastId: toastId,
            toasterId: toasterId
        }
    });
    targetDocument.dispatchEvent(event);
}


function $c8a4a8c8725b8703$export$38530c52bbe8da01(toastId, toasterId, targetDocument) {
    const event = new CustomEvent((0, $2d233013a30c9870$export$fa3d5b535a2458a1).play, {
        bubbles: false,
        cancelable: false,
        detail: {
            toastId: toastId,
            toasterId: toasterId
        }
    });
    targetDocument.dispatchEvent(event);
}


function $1ff908d2200a9805$export$104689d48c3903f5(options, targetDocument) {
    const event = new CustomEvent((0, $2d233013a30c9870$export$fa3d5b535a2458a1).update, {
        bubbles: false,
        cancelable: false,
        detail: options
    });
    targetDocument.dispatchEvent(event);
}


'use client';
const $381cfab46fabcf8e$var$noop = ()=>undefined;
function $381cfab46fabcf8e$export$6b9c1ee354531f4(toasterId) {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    return $acw62.useMemo(()=>{
        if (!targetDocument) return {
            dispatchToast: $381cfab46fabcf8e$var$noop,
            dismissToast: $381cfab46fabcf8e$var$noop,
            dismissAllToasts: $381cfab46fabcf8e$var$noop,
            updateToast: $381cfab46fabcf8e$var$noop,
            pauseToast: $381cfab46fabcf8e$var$noop,
            playToast: $381cfab46fabcf8e$var$noop
        };
        return {
            dispatchToast: (content, options)=>{
                (0, $960e2467afef4b26$export$4e1777ab45049969)(content, {
                    ...options,
                    toasterId: toasterId,
                    data: {
                        root: options === null || options === void 0 ? void 0 : options.root
                    }
                }, targetDocument);
            },
            dismissToast: (toastId)=>{
                (0, $5e3c5102c1b8a6f2$export$d05849f7e83bd5e1)(toastId, toasterId, targetDocument);
            },
            dismissAllToasts: ()=>{
                (0, $a20438eb9fe6b29c$export$1bb858dacb018cf6)(toasterId, targetDocument);
            },
            updateToast: (options)=>{
                (0, $1ff908d2200a9805$export$104689d48c3903f5)({
                    ...options,
                    data: {
                        root: options.root
                    },
                    toasterId: toasterId
                }, targetDocument);
            },
            pauseToast: (toastId)=>{
                (0, $f369b7cec3418946$export$e69dd5b80441700a)(toastId, toasterId, targetDocument);
            },
            playToast: (toastId)=>{
                (0, $c8a4a8c8725b8703$export$38530c52bbe8da01)(toastId, toasterId, targetDocument);
            }
        };
    }, [
        targetDocument,
        toasterId
    ]);
}



"use client";
const $dc0a6e3db5d5b553$export$3664b485525e193e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddFilled', "1em", [
    "M10 2.25c.41 0 .75.34.75.75v6.25H17a.75.75 0 0 1 0 1.5h-6.25V17a.75.75 0 0 1-1.5 0v-6.25H3a.75.75 0 0 1 0-1.5h6.25V3c0-.41.34-.75.75-.75"
]);
const $dc0a6e3db5d5b553$export$f19fb16d6c467fe5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddRegular', "1em", [
    "M10 2.5c.28 0 .5.22.5.5v6.5H17a.5.5 0 0 1 0 1h-6.5V17a.5.5 0 0 1-1 0v-6.5H3a.5.5 0 0 1 0-1h6.5V3c0-.28.22-.5.5-.5"
]);
const $dc0a6e3db5d5b553$export$fa81844a45204c49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddCircleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_add_circle_20_color__a)",
            "d": "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_add_circle_20_color__b)",
            "d": "M6 10c0-.28.22-.5.5-.5h3v-3a.5.5 0 0 1 1 0v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3A.5.5 0 0 1 6 10"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_add_circle_20_color__a",
                "x1": "2.57",
                "x2": "13.61",
                "y1": "5",
                "y2": "16.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_add_circle_20_color__b",
                "x1": "7.5",
                "x2": "9.95",
                "y1": "6.82",
                "y2": "15.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ]
    ]
], {
    color: true
});
const $dc0a6e3db5d5b553$export$d22fd4c5811c5c6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddCircleFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0M6 10c0 .28.22.5.5.5h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0-.5.5"
]);
const $dc0a6e3db5d5b553$export$4b219d5d01072cbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddCircleRegular', "1em", [
    "M6 10c0-.28.22-.5.5-.5h3v-3a.5.5 0 0 1 1 0v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3A.5.5 0 0 1 6 10m4 8a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
]);
const $dc0a6e3db5d5b553$export$44489eec601abff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddSquareFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm7.5.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 1 0 1 0v-3h3a.5.5 0 1 0 0-1h-3z"
]);
const $dc0a6e3db5d5b553$export$4932d873eee6d73f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddSquareRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm6.5.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 1 0 1 0v-3h3a.5.5 0 1 0 0-1h-3z"
]);
const $dc0a6e3db5d5b553$export$275bd957e468fa17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddSquareMultipleFilled', "1em", [
    "M16 5.27c.6.34 1 .99 1 1.73v6a4 4 0 0 1-4 4H7a2 2 0 0 1-1.73-1H13a3 3 0 0 0 3-3zM15 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2zm-3 4a.5.5 0 0 1-.5.5h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 1 1 0-1h2v-2a.5.5 0 1 1 1 0v2h2c.28 0 .5.22.5.5"
]);
const $dc0a6e3db5d5b553$export$e6243e608c73a57f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddSquareMultipleRegular', "1em", [
    "M16 5.27V13a3 3 0 0 1-3 3H5.27c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4V7a2 2 0 0 0-1-1.73M11.5 9.5a.5.5 0 0 0 0-1h-2v-2a.5.5 0 1 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2zM13 3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm1 2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z"
]);
const $dc0a6e3db5d5b553$export$d9abe236903534d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddStarburstColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_add_starburst_20_color__a)",
            "d": "M11.1 1.3a.75.75 0 0 0-1.2 0L8.85 2.65a.5.5 0 0 1-.58.15l-1.6-.65a.75.75 0 0 0-1.03.6l-.24 1.7a.5.5 0 0 1-.42.44l-1.72.23a.75.75 0 0 0-.59 1.03l.65 1.6a.5.5 0 0 1-.15.59L1.79 9.4a.75.75 0 0 0 0 1.18l1.37 1.07a.5.5 0 0 1 .15.58l-.65 1.6c-.18.46.1.96.6 1.03l1.7.24c.23.03.4.2.43.42l.24 1.72c.07.48.57.77 1.03.59l1.6-.65a.5.5 0 0 1 .58.15l1.07 1.37c.3.39.88.39 1.18 0l1.06-1.37a.5.5 0 0 1 .59-.15l1.6.65c.45.18.96-.1 1.03-.6l.23-1.7a.5.5 0 0 1 .43-.43l1.72-.24a.75.75 0 0 0 .59-1.03l-.65-1.6a.5.5 0 0 1 .15-.58l1.37-1.07a.75.75 0 0 0 0-1.18l-1.37-1.06a.5.5 0 0 1-.15-.59l.65-1.6a.75.75 0 0 0-.6-1.03l-1.7-.23a.5.5 0 0 1-.44-.43l-.23-1.72a.75.75 0 0 0-1.03-.59l-1.6.65a.5.5 0 0 1-.59-.15z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_add_starburst_20_color__b)",
            "fillOpacity": ".95",
            "d": "M6.5 10c0-.28.22-.5.5-.5h3v-3a.5.5 0 0 1 1 0v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3H7a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_add_starburst_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(240.51 17.38 4.35)scale(39.7873 38.1094)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffc470"
                }
            ],
            [
                "stop",
                {
                    "offset": ".25",
                    "stopColor": "#ff835c"
                }
            ],
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#f24a9d"
                }
            ],
            [
                "stop",
                {
                    "offset": ".81",
                    "stopColor": "#b339f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_add_starburst_20_color__b",
                "x1": "13.94",
                "x2": "5.55",
                "y1": "16.26",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".02",
                    "stopColor": "#ffc8d7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".81",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $dc0a6e3db5d5b553$export$44031e30d5563a49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddStarburstFilled', "1em", [
    "M9.4 1.3a.75.75 0 0 1 1.2 0l1.05 1.36a.5.5 0 0 0 .59.15l1.6-.65c.45-.18.96.1 1.03.6l.23 1.7c.04.23.21.4.43.44l1.72.23c.48.07.77.58.59 1.03l-.65 1.6a.5.5 0 0 0 .15.59l1.37 1.06c.39.3.39.88 0 1.18l-1.37 1.07a.5.5 0 0 0-.15.58l.65 1.6c.18.46-.1.96-.6 1.03l-1.7.24a.5.5 0 0 0-.44.42l-.23 1.72a.75.75 0 0 1-1.03.59l-1.6-.65a.5.5 0 0 0-.59.15l-1.06 1.37a.75.75 0 0 1-1.18 0l-1.07-1.37a.5.5 0 0 0-.58-.15l-1.6.65a.75.75 0 0 1-1.03-.6l-.24-1.7a.5.5 0 0 0-.42-.43l-1.72-.24a.75.75 0 0 1-.59-1.03l.65-1.6a.5.5 0 0 0-.15-.58l-1.37-1.07a.75.75 0 0 1 0-1.18l1.37-1.06a.5.5 0 0 0 .15-.59l-.65-1.6a.75.75 0 0 1 .6-1.03l1.7-.23a.5.5 0 0 0 .43-.43l.24-1.72a.75.75 0 0 1 1.03-.59l1.6.65c.2.09.45.02.58-.15zM6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
]);
const $dc0a6e3db5d5b553$export$7656146ce44a820f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddStarburstRegular', "1em", [
    "M6.5 9.5a.5.5 0 1 0 0 1h3v3a.5.5 0 1 0 1 0v-3h3a.5.5 0 1 0 0-1h-3v-3a.5.5 0 1 0-1 0v3zm4.1-8.2a.75.75 0 0 0-1.2 0L8.35 2.65a.5.5 0 0 1-.58.15l-1.6-.65a.75.75 0 0 0-1.03.6l-.24 1.7a.5.5 0 0 1-.42.44l-1.72.23a.75.75 0 0 0-.6 1.03l.66 1.6a.5.5 0 0 1-.15.59L1.29 9.4a.75.75 0 0 0 0 1.18l1.37 1.07a.5.5 0 0 1 .15.58l-.65 1.6c-.18.46.1.96.6 1.03l1.7.24c.23.03.4.2.43.42l.24 1.72c.07.48.57.77 1.03.59l1.6-.65a.5.5 0 0 1 .58.15l1.07 1.37c.3.39.88.39 1.18 0l1.06-1.37a.5.5 0 0 1 .59-.15l1.6.65c.45.18.96-.1 1.03-.6l.23-1.7a.5.5 0 0 1 .43-.43l1.72-.24a.75.75 0 0 0 .59-1.03l-.65-1.6a.5.5 0 0 1 .15-.58l1.37-1.07a.75.75 0 0 0 0-1.18l-1.37-1.06a.5.5 0 0 1-.15-.59l.65-1.6a.75.75 0 0 0-.6-1.03l-1.71-.23a.5.5 0 0 1-.43-.43l-.23-1.72a.75.75 0 0 0-1.03-.59l-1.6.65a.5.5 0 0 1-.59-.15zM9.12 3.26 10 2.16l.86 1.11a1.5 1.5 0 0 0 1.75.47l1.31-.53.2 1.4c.08.66.6 1.18 1.27 1.28l1.4.19-.53 1.3a1.5 1.5 0 0 0 .47 1.75l1.11.87-1.11.87a1.5 1.5 0 0 0-.47 1.75l.53 1.3-1.4.2a1.5 1.5 0 0 0-1.28 1.28l-.19 1.4-1.3-.54a1.5 1.5 0 0 0-1.76.47L10 17.84l-.87-1.11a1.5 1.5 0 0 0-1.75-.47l-1.3.53-.2-1.4a1.5 1.5 0 0 0-1.28-1.28l-1.4-.19.54-1.3a1.5 1.5 0 0 0-.47-1.75L2.16 10l1.1-.87a1.5 1.5 0 0 0 .48-1.74L3.2 6.08l1.4-.2a1.5 1.5 0 0 0 1.27-1.27l.2-1.4 1.3.53a1.5 1.5 0 0 0 1.75-.47"
]);
const $dc0a6e3db5d5b553$export$2f916c8082092f01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddSubtractCircleFilled', "1em", [
    "M11.5 12a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1zM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1a7 7 0 0 1-4.58-1.7l9.87-9.88A7 7 0 0 1 10 17M5.5 7c0-.28.22-.5.5-.5h1v-1a.5.5 0 0 1 1 0v1h1a.5.5 0 1 1 0 1H8v1a.5.5 0 0 1-1 0v-1H6a.5.5 0 0 1-.5-.5"
]);
const $dc0a6e3db5d5b553$export$eaa8e5a744a4500a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AddSubtractCircleRegular', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-3-7a.5.5 0 0 0-1 0v1H6a.5.5 0 1 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 1 0 0-1H8zM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1a7 7 0 0 1-4.58-1.7l9.87-9.88A7 7 0 0 1 10 17m-5.3-2.42a7 7 0 0 1 9.87-9.87z"
]);
const $dc0a6e3db5d5b553$export$313879ed65468f45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlbumFilled', "1em", [
    "M2 6c0-1.1.9-2 2-2v12a2 2 0 0 1-2-2zm7 2.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5zM5 16V4h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm4.5-9C8.67 7 8 7.67 8 8.5v1c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5z"
], {
    flipInRtl: true
});
const $dc0a6e3db5d5b553$export$8c0c6c7d03652163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlbumRegular', "1em", [
    "M8 8.5C8 7.67 8.67 7 9.5 7h4c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 8 9.5zM9.5 8a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm4 9h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6zM5 5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1z"
], {
    flipInRtl: true
});
const $dc0a6e3db5d5b553$export$80ed4c7e76b94a8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlbumAddFilled', "1em", [
    "M4 4a2 2 0 0 0-2 2v3.26A5.5 5.5 0 0 1 4 8.2zm12 12h-5.6a5.5 5.5 0 0 0 0-5h3.1c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-4C8.67 7 8 7.67 8 8.5v.1a5.5 5.5 0 0 0-3-.58V4h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2m-2.5-6H9.74A6 6 0 0 0 9 9.26V8.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5M10 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V13H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H6z"
], {
    flipInRtl: true
});
const $dc0a6e3db5d5b553$export$9722c4781560165e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlbumAddRegular', "1em", [
    "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-5.6q.25-.48.4-1H16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6v3.02a6 6 0 0 0-1 0V5H4a1 1 0 0 0-1 1v2.6q-.54.27-1 .66zm11.5 5h-3.1a6 6 0 0 0-.66-1h3.76a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v.76a6 6 0 0 0-1-.66v-.1C8 7.67 8.67 7 9.5 7h4c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5M10 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V13H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H6z"
], {
    flipInRtl: true
});
const $dc0a6e3db5d5b553$export$543db958b53143ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlbumSubtractFilled', "1em", [
    "M5.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M16 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-5.6a5.5 5.5 0 0 0 0-5h3.1c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-4C8.67 7 8 7.67 8 8.5v.1a5.5 5.5 0 0 0-3-.58V4zM3.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm10-5c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5H9.74A6 6 0 0 0 9 9.26V8.5c0-.28.22-.5.5-.5zM4 8.2q-1.12.34-2 1.06V6c0-1.1.9-2 2-2z"
]);
const $dc0a6e3db5d5b553$export$67d4ca9b55412489 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AlbumSubtractRegular', "1em", [
    "M5.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M16 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-5.6q.24-.48.4-1H16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6v3.02a6 6 0 0 0-1 0V5H4a1 1 0 0 0-1 1v2.6q-.54.27-1 .66V6c0-1.1.9-2 2-2zM3.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm10-6c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-3.1q-.27-.54-.66-1h3.76a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v.76a6 6 0 0 0-1-.66v-.1C8 7.67 8.67 7 9.5 7z"
]);
const $dc0a6e3db5d5b553$export$fd5d4cb9b30ead0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BugFilled', "1em", [
    "M9 2.5a.5.5 0 0 0-1 0V3q.01.6.32 1.08A3 3 0 0 0 6 7h-.5A1.5 1.5 0 0 1 4 5.5v-2a.5.5 0 0 0-1 0v2A2.5 2.5 0 0 0 5.5 8H6v1.5H2.5a.5.5 0 0 0 0 1H6V12h-.5A2.5 2.5 0 0 0 3 14.5v2a.5.5 0 0 0 1 0v-2c0-.83.67-1.5 1.5-1.5H6a4 4 0 0 0 8 0h.5c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2a2.5 2.5 0 0 0-2.5-2.5H14v-1.5h3.5a.5.5 0 0 0 0-1H14V8h.5A2.5 2.5 0 0 0 17 5.5v-2a.5.5 0 0 0-1 0v2c0 .83-.67 1.5-1.5 1.5H14a3 3 0 0 0-2.32-2.92A2 2 0 0 0 12 3v-.5a.5.5 0 0 0-1 0V3a1 1 0 1 1-2 0z"
]);
const $dc0a6e3db5d5b553$export$f5e6847d8623c6cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BugRegular', "1em", [
    "M9 2.5a.5.5 0 0 0-1 0V3q.01.6.32 1.08A3 3 0 0 0 6 7h-.5A1.5 1.5 0 0 1 4 5.5v-2a.5.5 0 0 0-1 0v2A2.5 2.5 0 0 0 5.5 8H6v1.5H2.5a.5.5 0 0 0 0 1H6V12h-.5A2.5 2.5 0 0 0 3 14.5v2a.5.5 0 0 0 1 0v-2c0-.83.67-1.5 1.5-1.5H6a4 4 0 0 0 8 0h.5c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2a2.5 2.5 0 0 0-2.5-2.5H14v-1.5h3.5a.5.5 0 0 0 0-1H14V8h.5A2.5 2.5 0 0 0 17 5.5v-2a.5.5 0 0 0-1 0v2c0 .83-.67 1.5-1.5 1.5H14a3 3 0 0 0-2.32-2.92A2 2 0 0 0 12 3v-.5a.5.5 0 0 0-1 0V3a1 1 0 1 1-2 0zM13 7v6a3 3 0 1 1-6 0V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2"
]);
const $dc0a6e3db5d5b553$export$943872ede59b693a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BugArrowCounterclockwiseFilled', "1em", [
    "M17 3.5a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 1 14.5 7H14a3 3 0 0 0-2.31-2.92A2 2 0 0 0 12 3v-.5a.5.5 0 0 0-1 0V3a1 1 0 0 1-2 0v-.5a.5.5 0 1 0-1 0V3q0 .59.31 1.08A3 3 0 0 0 6 7h-.5A1.5 1.5 0 0 1 4 5.5v-2a.5.5 0 1 0-1 0v2A2.5 2.5 0 0 0 5.5 8H6v1.5H2.5a.5.5 0 1 0 0 1H6V12h-.5A2.5 2.5 0 0 0 3 14.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 1 5.5 13H6a4 4 0 0 0 3.59 3.96A5.5 5.5 0 0 1 14 9.03V8h.5A2.5 2.5 0 0 0 17 5.5zM14.5 10a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.25a2.7 2.7 0 0 1-2.05-.92.5.5 0 1 1 .75-.66 1.75 1.75 0 1 0 .4-2.67h.4a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.63V12a.5.5 0 0 1 1 0v.2a2.75 2.75 0 1 1 1.5 5.05"
]);
const $dc0a6e3db5d5b553$export$abc5a5675864edfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BugArrowCounterclockwiseRegular', "1em", [
    "M17 3.5a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 1 14.5 7H14a3 3 0 0 0-2.31-2.92A2 2 0 0 0 12 3v-.5a.5.5 0 0 0-1 0V3a1 1 0 0 1-2 0v-.5a.5.5 0 1 0-1 0V3q0 .59.31 1.08A3 3 0 0 0 6 7h-.5A1.5 1.5 0 0 1 4 5.5v-2a.5.5 0 1 0-1 0v2A2.5 2.5 0 0 0 5.5 8H6v1.5H2.5a.5.5 0 1 0 0 1H6V12h-.5A2.5 2.5 0 0 0 3 14.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 1 5.5 13H6a4 4 0 0 0 3.59 3.96 6 6 0 0 1-.41-1.09A3 3 0 0 1 7 13V7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2.21q.5-.13 1-.19V8h.5A2.5 2.5 0 0 0 17 5.5zM14.5 10a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.25a2.7 2.7 0 0 1-2.05-.92.5.5 0 1 1 .75-.66 1.75 1.75 0 1 0 .4-2.67h.4a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.63V12a.5.5 0 0 1 1 0v.2a2.75 2.75 0 1 1 1.5 5.05"
]);
const $dc0a6e3db5d5b553$export$71d99596add09934 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BugProhibitedFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M11 14.5a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9c-.46-.6-.7-1.34-.7-2.1m3.5 3.5c-.76 0-1.5-.24-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-.33 4.57A3.5 3.5 0 0 1 14.5 18M17 3.5a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 1 14.5 7H14a3 3 0 0 0-2.31-2.92A2 2 0 0 0 12 3v-.5a.5.5 0 0 0-1 0V3a1 1 0 0 1-2 0v-.5a.5.5 0 1 0-1 0V3q0 .59.31 1.08A3 3 0 0 0 6 7h-.5A1.5 1.5 0 0 1 4 5.5v-2a.5.5 0 1 0-1 0v2A2.5 2.5 0 0 0 5.5 8H6v1.5H2.5a.5.5 0 1 0 0 1H6V12h-.5A2.5 2.5 0 0 0 3 14.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 1 5.5 13H6a4 4 0 0 0 3.59 3.96 5.5 5.5 0 0 1 .85-6.17A5.5 5.5 0 0 1 14 9.03V8h.5A2.5 2.5 0 0 0 17 5.5z"
]);
const $dc0a6e3db5d5b553$export$433d773a581d1c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BugProhibitedRegular', "1em", [
    "M9.18 15.87q.15.57.4 1.09A4 4 0 0 1 6 13h-.5A1.5 1.5 0 0 0 4 14.5v2a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 5.5 12H6v-1.5H2.5a.5.5 0 0 1 0-1H6V8h-.5A2.5 2.5 0 0 1 3 5.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 0 5.5 7H6a3 3 0 0 1 2.31-2.92A2 2 0 0 1 8 3v-.5a.5.5 0 0 1 1 0V3a1 1 0 0 0 2 0v-.5a.5.5 0 0 1 1 0V3a2 2 0 0 1-.31 1.08A3 3 0 0 1 14 7h.5A1.5 1.5 0 0 0 16 5.5v-2a.5.5 0 0 1 1 0v2A2.5 2.5 0 0 1 14.5 8H14v1.03q-.5.04-1 .18V7a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6a3 3 0 0 0 2.18 2.87M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7.3 2.1 4.9-4.9a3.5 3.5 0 0 0-4.57.33 3.5 3.5 0 0 0-.33 4.57m6.3-2.1c0-.76-.24-1.5-.7-2.1l-4.9 4.9a3.5 3.5 0 0 0 4.57-.33A3.5 3.5 0 0 0 18 14.5"
]);
const $dc0a6e3db5d5b553$export$3eb7899e860dac2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CenterHorizontalFilled', "1em", [
    "M3.5 18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5",
    "M16 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M9 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $dc0a6e3db5d5b553$export$3f8bbb486290e02b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CenterHorizontalRegular', "1em", [
    "M3.5 18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5",
    "M16 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z",
    "M9 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z"
]);
const $dc0a6e3db5d5b553$export$c46a913a989f33cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CenterVerticalFilled', "1em", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
]);
const $dc0a6e3db5d5b553$export$9bb2a7d58687af6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CenterVerticalRegular', "1em", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5M2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 9a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
]);
const $dc0a6e3db5d5b553$export$ef7f26ea68ae83a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DarkThemeFilled', "1em", [
    "M10 3.5a6.5 6.5 0 1 1 0 13zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $dc0a6e3db5d5b553$export$5977a3040cc7bfed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DarkThemeRegular', "1em", [
    "M10 3a7 7 0 1 1 0 14zm0-1a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
]);
const $dc0a6e3db5d5b553$export$bc355d93199cc5df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DumbbellFilled', "1em", [
    "M14.33 3.13a1.98 1.98 0 0 0-3 .22A2.4 2.4 0 0 0 9.2 7.43l1.02 1-1.07 1.08 1.36 1.36 1.07-1.07 1.01 1.02a2.4 2.4 0 0 0 4.08-2.13l.22-.2c.78-.77.78-2.03 0-2.8l-.6-.6.53-.52a.97.97 0 0 0-1.37-1.37l-.52.52zm.27 3.54a.5.5 0 1 1-.7.71l-1.28-1.27a.5.5 0 0 1 .7-.71zM4.02 9.2a2.4 2.4 0 0 1 3.4 0l3.4 3.4a2.4 2.4 0 0 1-2.13 4.07l-.2.22c-.77.78-2.02.78-2.8 0l-.6-.6-.54.54a.97.97 0 1 1-1.36-1.36l.54-.54-.6-.6a1.98 1.98 0 0 1 .22-3 2.4 2.4 0 0 1 .67-2.13m2.94 5.82a.5.5 0 0 0 0-.71L5.7 13.04a.5.5 0 0 0-.7.7l1.27 1.28c.2.2.5.2.7 0"
]);
const $dc0a6e3db5d5b553$export$cae8a0651e6a88c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DumbbellRegular', "1em", [
    "M14.6 7.38a.5.5 0 0 0 0-.7L13.32 5.4a.5.5 0 1 0-.7.7l1.27 1.28c.2.2.51.2.7 0M7.8 13.46a.5.5 0 0 1-.7.7L5.82 12.9a.5.5 0 0 1 .7-.71zm9.36-10.61a1.47 1.47 0 0 0-2.07 0l-.62.62-.25-.25a1.85 1.85 0 0 0-2.84.28 2.27 2.27 0 0 0-2.1 3.83l.66.66L8 9.96l-.66-.66a2.27 2.27 0 0 0-3.83 2.09 1.85 1.85 0 0 0-.28 2.84l.25.25-.64.64a1.47 1.47 0 0 0 2.07 2.07l.64-.64.24.25a1.85 1.85 0 0 0 2.85-.28 2.27 2.27 0 0 0 2.09-3.83l-.66-.66 1.97-1.97.66.66a2.27 2.27 0 0 0 3.82-2.1q.16-.09.28-.22c.72-.72.72-1.9 0-2.61l-.24-.25.62-.62c.57-.57.57-1.5 0-2.07m-1.33 1.98-.66-.66.62-.62a.47.47 0 1 1 .66.66zm-4.52 4.52-1.97 1.97-.66-.66 1.97-1.96zm-6.49 6.5-.64.63a.47.47 0 0 1-.66-.66l.64-.64zm7.5-11.92a.85.85 0 0 1 1.2 0l2.56 2.56a.85.85 0 0 1-.34 1.4.5.5 0 0 0-.3.7A1.27 1.27 0 0 1 13.39 10L10 6.62a1.27 1.27 0 0 1 1.43-2.05.5.5 0 0 0 .69-.3q.05-.2.2-.34m-7.5 6.08c.49-.5 1.3-.5 1.8 0L10 13.4a1.27 1.27 0 0 1-1.43 2.05.5.5 0 0 0-.68.3.85.85 0 0 1-1.4.34l-2.57-2.56a.85.85 0 0 1 .33-1.41.5.5 0 0 0 .3-.68A1.3 1.3 0 0 1 4.82 10"
]);
const $dc0a6e3db5d5b553$export$5949c4ac35ff314e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FullScreenMaximizeFilled', "1em", [
    "M3 5.25C3 4.01 4 3 5.25 3h1.87a.75.75 0 1 1 0 1.5H5.25a.75.75 0 0 0-.75.75v1.87a.75.75 0 1 1-1.5 0zm9.13-1.5c0-.41.34-.75.75-.75h1.87C15.99 3 17 4 17 5.25v1.87a.75.75 0 0 1-1.5 0V5.25a.75.75 0 0 0-.75-.75h-1.87a.75.75 0 0 1-.75-.75m-8.38 8.38c.41 0 .75.34.75.75v1.87c0 .41.34.75.75.75h1.87a.75.75 0 0 1 0 1.5H5.25C4.01 17 3 16 3 14.75v-1.87c0-.41.34-.75.75-.75m12.5 0c.41 0 .75.34.75.75v1.87c0 1.24-1 2.25-2.25 2.25h-1.87a.75.75 0 0 1 0-1.5h1.87c.41 0 .75-.34.75-.75v-1.87c0-.41.34-.75.75-.75"
]);
const $dc0a6e3db5d5b553$export$a45ac0d08611d37a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FullScreenMaximizeRegular', "1em", [
    "M3 5c0-1.1.9-2 2-2h2a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v2a.5.5 0 0 1-1 0zm9.5-1.5c0-.28.22-.5.5-.5h2a2 2 0 0 1 2 2v2a.5.5 0 0 1-1 0V5a1 1 0 0 0-1-1h-2a.5.5 0 0 1-.5-.5m-9 9c.28 0 .5.22.5.5v2a1 1 0 0 0 1 1h2a.5.5 0 0 1 0 1H5a2 2 0 0 1-2-2v-2c0-.28.22-.5.5-.5m13 0c.28 0 .5.22.5.5v2a2 2 0 0 1-2 2h-2a.5.5 0 0 1 0-1h2a1 1 0 0 0 1-1v-2c0-.28.22-.5.5-.5"
]);
const $dc0a6e3db5d5b553$export$f34c61b752a23f8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FullScreenMinimizeFilled', "1em", [
    "M15 5.5a.5.5 0 0 1-.5-.5V2.75a.75.75 0 0 0-1.5 0V5c0 1.1.9 2 2 2h2.25a.75.75 0 0 0 0-1.5zM5.5 15a.5.5 0 0 0-.5-.5H2.75a.75.75 0 0 1 0-1.5H5a2 2 0 0 1 2 2v2.25a.75.75 0 0 1-1.5 0zm9 0c0-.28.22-.5.5-.5h2.25a.75.75 0 0 0 0-1.5H15a2 2 0 0 0-2 2v2.25a.75.75 0 0 0 1.5 0zm-9-10a.5.5 0 0 1-.5.5H2.75a.75.75 0 0 0 0 1.5H5a2 2 0 0 0 2-2V2.75a.75.75 0 0 0-1.5 0z"
]);
const $dc0a6e3db5d5b553$export$f4e1a637f15e76f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FullScreenMinimizeRegular', "1em", [
    "M14 5a1 1 0 0 0 1 1h2a.5.5 0 0 1 0 1h-2a2 2 0 0 1-2-2V3a.5.5 0 0 1 1 0zM6 15a1 1 0 0 0-1-1H3a.5.5 0 0 1 0-1h2a2 2 0 0 1 2 2v2a.5.5 0 0 1-1 0zm8 0a1 1 0 0 1 1-1h2a.5.5 0 0 0 0-1h-2a2 2 0 0 0-2 2v2a.5.5 0 0 0 1 0zM5 6a1 1 0 0 0 1-1V3a.5.5 0 0 1 1 0v2a2 2 0 0 1-2 2H3a.5.5 0 0 1 0-1z"
]);
const $dc0a6e3db5d5b553$export$1d9f507e24ab77b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__a)",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__b)",
            "d": "M10 5.25a4.75 4.75 0 0 0-3.45 8.01.75.75 0 1 1-1.1 1.03 6.25 6.25 0 0 1 6.82-10.11.75.75 0 1 1-.54 1.4A5 5 0 0 0 10 5.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__c)",
            "d": "M10 5.25a4.75 4.75 0 0 0-3.45 8.01.75.75 0 1 1-1.1 1.03 6.25 6.25 0 0 1 6.82-10.11.75.75 0 1 1-.54 1.4A5 5 0 0 0 10 5.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__d)",
            "d": "M10 5.25a4.75 4.75 0 0 0-3.45 8.01.75.75 0 1 1-1.1 1.03 6.25 6.25 0 0 1 6.82-10.11.75.75 0 1 1-.54 1.4A5 5 0 0 0 10 5.24"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__e)",
            "d": "M14.85 7.3c.39-.15.82.04.97.43a6.2 6.2 0 0 1-1.27 6.56.75.75 0 0 1-1.1-1.03 4.7 4.7 0 0 0 .98-4.99.75.75 0 0 1 .42-.97"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__f)",
            "d": "M14.85 7.3c.39-.15.82.04.97.43a6.2 6.2 0 0 1-1.27 6.56.75.75 0 0 1-1.1-1.03 4.7 4.7 0 0 0 .98-4.99.75.75 0 0 1 .42-.97"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__g)",
            "d": "M14.85 7.3c.39-.15.82.04.97.43a6.2 6.2 0 0 1-1.27 6.56.75.75 0 0 1-1.1-1.03 4.7 4.7 0 0 0 .98-4.99.75.75 0 0 1 .42-.97"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gauge_20_color__h)",
            "d": "M14.09 5.82a.5.5 0 0 1 .1.63l-.1.2-.3.51-.39.69-.23.4-.3.52-1.48 2.48-.16.23a1.5 1.5 0 1 1-2.28-1.95q.12-.13.34-.33l.56-.48a124 124 0 0 1 2.96-2.4l.27-.22.37-.3a.5.5 0 0 1 .64.02"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_gauge_20_color__a",
                "x1": "7.71",
                "x2": "13.84",
                "y1": "2",
                "y2": "17.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f4f4f4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cbcbcb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gauge_20_color__c",
                "x1": "8",
                "x2": "5",
                "y1": "11.5",
                "y2": "14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#42b870"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gauge_20_color__d",
                "x1": "13",
                "x2": "15",
                "y1": "12",
                "y2": "14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e82c41",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#e82c41"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gauge_20_color__f",
                "x1": "8",
                "x2": "5",
                "y1": "11.5",
                "y2": "14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#42b870"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gauge_20_color__g",
                "x1": "13",
                "x2": "15",
                "y1": "12",
                "y2": "14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#e82c41",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#e82c41"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gauge_20_color__h",
                "x1": "8.59",
                "x2": "12.57",
                "y1": "5.7",
                "y2": "11.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_gauge_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(13.5 0 0 20.2556 3.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870"
                }
            ],
            [
                "stop",
                {
                    "offset": ".59",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e82c41"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_gauge_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(13.5 0 0 20.2556 3.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#42b870"
                }
            ],
            [
                "stop",
                {
                    "offset": ".59",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e82c41"
                }
            ]
        ]
    ]
], {
    color: true
});
const $dc0a6e3db5d5b553$export$a466804f3f3cbe2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1.82-12.66a5 5 0 0 0-5.36 8.2.5.5 0 0 1-.7.7 6 6 0 0 1 6.42-9.83.5.5 0 0 1-.36.93m3.77 2.48a6 6 0 0 1-1.35 6.42.5.5 0 1 1-.7-.7 5 5 0 0 0 1.12-5.36.5.5 0 0 1 .93-.36m-1.5-2a.5.5 0 0 1 .1.62l-.1.2-.69 1.2-.23.4-.3.53-1.48 2.48-.16.23a1.5 1.5 0 1 1-2.28-1.95q.12-.13.34-.33l.56-.48a125 125 0 0 1 2.96-2.4l.27-.22.37-.3a.5.5 0 0 1 .64.02"
]);
const $dc0a6e3db5d5b553$export$f5e555dc5be2133b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeRegular', "1em", [
    "M12.47 5.06a.5.5 0 0 1-.65.28 5 5 0 0 0-5.36 8.2.5.5 0 1 1-.7.7 6 6 0 0 1 6.42-9.83c.26.1.39.39.29.65m2.47 2.47a.5.5 0 0 1 .65.29 6 6 0 0 1-1.35 6.42.5.5 0 1 1-.7-.7 5 5 0 0 0 1.12-5.36.5.5 0 0 1 .28-.65m-.85-1.71a.5.5 0 0 0-.64-.01l-.18.14L9.3 9.2q-.22.19-.34.33a1.5 1.5 0 1 0 2.28 1.95l.27-.4.38-.62a124 124 0 0 0 2.2-3.82l.12-.2a.5.5 0 0 0-.11-.62M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
]);
const $dc0a6e3db5d5b553$export$9312d6839efb10b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeAddFilled', "1em", [
    "M10 18a8 8 0 1 0-8-7.75q.91-.73 2.05-1.06a6 6 0 0 1 8.13-4.78.5.5 0 0 1-.36.93A5 5 0 0 0 5.1 9.01a5.6 5.6 0 0 1 3.57 1q.09-.26.28-.48.12-.13.34-.33l.56-.48a125 125 0 0 1 2.96-2.4l.27-.22.37-.3a.5.5 0 0 1 .75.64l-.11.2-.69 1.2-.23.4-.3.53-1.48 2.48-.16.23a1.5 1.5 0 0 1-.84.5A5.5 5.5 0 0 1 9.75 18zm5.6-10.18a6 6 0 0 1-1.36 6.42.5.5 0 1 1-.7-.7 5 5 0 0 0 1.12-5.36.5.5 0 0 1 .93-.36M8 18.24a4.5 4.5 0 1 1-5-7.48 4.5 4.5 0 0 1 5 7.48m-2.15-6.1a.5.5 0 0 0-.85.36V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5a.5.5 0 0 0-.15-.35"
]);
const $dc0a6e3db5d5b553$export$b41ab540eb0566d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeAddRegular', "1em", [
    "M10.4 16.99a7 7 0 1 0-7.39-7.4q-.54.28-1 .66L2 10a8 8 0 1 1 7.75 8q.38-.47.66-1.01m2.07-11.93a.5.5 0 0 1-.65.28A5 5 0 0 0 5.1 9.01q-.54.05-1.05.18a6 6 0 0 1 8.13-4.78c.26.1.39.39.29.65M8.67 10q1.09.77 1.72 1.96.48-.1.84-.5.11-.14.27-.38l.38-.63a124 124 0 0 0 2.2-3.82l.12-.2a.5.5 0 0 0-.75-.63l-.18.14L9.3 9.2q-.22.19-.34.33-.2.21-.28.48m6.27-2.48a.5.5 0 0 1 .65.29 6 6 0 0 1-1.35 6.42.5.5 0 1 1-.7-.7 5 5 0 0 0 1.12-5.36.5.5 0 0 1 .28-.65M8 18.24a4.5 4.5 0 1 1-5-7.48 4.5 4.5 0 0 1 5 7.48m-2.15-6.1a.5.5 0 0 0-.85.36V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5a.5.5 0 0 0-.15-.35"
]);
const $dc0a6e3db5d5b553$export$fbdb7a6c98cec5fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeRotate0Filled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m-.64 1.54c.12-.67 1.03-.72 1.25-.13l.03.13q.41 2.3.76 4.6c.06.38.1.71.1.86a1.5 1.5 0 0 1-3 0c0-.15.04-.48.1-.87.18-1.2.55-3.4.76-4.6"
]);
const $dc0a6e3db5d5b553$export$fbdf45e5c2723992 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeRotate0Regular', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-.6 1.42c.19-.56 1.01-.56 1.2 0l.04.12q.4 2.52.76 5.04c.06.42.1.77.1.92a1.5 1.5 0 1 1-3 0c0-.15.04-.5.1-.92.18-1.3.55-3.72.76-5.04z"
]);
const $dc0a6e3db5d5b553$export$9de5e4b1bd9be79c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeRotate315Filled', "1em", [
    "M10.83 2.04a8 8 0 1 1-6.35 2.17.75.75 0 0 1 1.04 1.08 6.5 6.5 0 1 0 5.16-1.76.75.75 0 1 1 .15-1.49m-4.79 4.9c-.4-.56.22-1.23.8-.97l.1.07q1.91 1.33 3.8 2.71c.3.23.57.44.67.54a1.5 1.5 0 0 1-2.12 2.13 8 8 0 0 1-.54-.69c-.73-.98-2.01-2.8-2.71-3.79"
]);
const $dc0a6e3db5d5b553$export$c28a6f2339cd6aab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GaugeRotate315Regular', "1em", [
    "M10.53 2.02a8 8 0 1 1-5.97 2.11.5.5 0 0 1 .68.74 7 7 0 1 0 5.23-1.85.5.5 0 0 1 .06-1m-4.9 4.46c-.26-.53.32-1.11.85-.86l.12.07q2.07 1.5 4.1 3.03c.33.25.61.47.71.57a1.5 1.5 0 0 1-2.12 2.13A287.34 287.34 0 0 1 5.7 6.6z"
]);
const $dc0a6e3db5d5b553$export$2d02d201a0a82cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuitarFilled', "1em", [
    "m14.5 3.78 1.11-1.12c.23-.23.6-.23.83 0l.9.9c.22.23.22.6 0 .83L16.22 5.5zm-.72.71-2.53 2.53-.13-.13a2.13 2.13 0 0 0-3.4.55l-.34.68a.6.6 0 0 1-.66.32h-.06a3.7 3.7 0 0 0-3.7 1.4 4.8 4.8 0 0 0 .44 6.27l.49.49a4.8 4.8 0 0 0 6.26.44 3.7 3.7 0 0 0 1.42-3.7l-.01-.06a.6.6 0 0 1 .32-.66l.68-.34a2.13 2.13 0 0 0 .55-3.4l-.13-.13 2.53-2.53zm-5.41 7.14a1.25 1.25 0 1 1 1.76-1.76 1.25 1.25 0 0 1-1.76 1.76"
]);
const $dc0a6e3db5d5b553$export$e5c90154b7275183 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuitarRegular', "1em", [
    "M9.7 11.7a1 1 0 1 1-1.4-1.4 1 1 0 0 1 1.4 1.4m5.56-9.39a1.1 1.1 0 0 1 1.53 0l.9.9c.42.42.42 1.1 0 1.53l-4.37 4.38a2.13 2.13 0 0 1-.76 3.16l-.68.34a.6.6 0 0 0-.32.66v.06a3.7 3.7 0 0 1-1.4 3.7 4.8 4.8 0 0 1-6.27-.44l-.49-.5a4.8 4.8 0 0 1-.44-6.25 3.7 3.7 0 0 1 3.7-1.42l.06.01a.6.6 0 0 0 .66-.32l.34-.68a2.13 2.13 0 0 1 3.16-.76zm.83.7a.1.1 0 0 0-.13 0L14.8 4.19l1.02 1.02 1.16-1.16a.1.1 0 0 0 0-.13zm-.98 2.9-1.02-1.02-2.84 2.84a.5.5 0 0 1-.7 0l-.13-.13a1.13 1.13 0 0 0-1.8.3l-.35.67a1.6 1.6 0 0 1-1.75.85h-.05c-1.03-.21-2.08.19-2.71 1.03a3.8 3.8 0 0 0 .35 4.95l.49.49a3.8 3.8 0 0 0 4.95.35 2.7 2.7 0 0 0 1.04-2.7l-.02-.07c-.14-.7.21-1.42.86-1.75l.68-.33c.69-.35.83-1.26.3-1.8l-.14-.14a.5.5 0 0 1 0-.7z"
]);
const $dc0a6e3db5d5b553$export$7a8dbe7c2d6ea4e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LauncherSettingsFilled', "1em", [
    "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.5 8.5 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54m6.19.4-1.58 1.9a.5.5 0 0 0 0 .64l1.39 1.67c.1.12.28.12.38 0l.93-1.11a.25.25 0 0 0 0-.32L8.75 10l.6-.72zM8.75 7l2.5 3-2.16 2.59a.25.25 0 0 0 .2.41h1.84q.12 0 .2-.09l2.15-2.59a.5.5 0 0 0 0-.64L11.25 7z"
]);
const $dc0a6e3db5d5b553$export$4c8d22702181e0a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LauncherSettingsRegular', "1em", [
    "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 9 9 0 0 1 3.55 0q.32.08.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08q.08.31-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.5 8.5 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54m1.06 0 1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1q.45 1.19 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67a8 8 0 0 0 2.5 0l.3-1.67a2 2 0 0 1 2.64-1.53l1.6.58a8 8 0 0 0 1.24-2.16l-1.3-1.1a2 2 0 0 1 0-3.04l1.3-1.1a8 8 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a8 8 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a8 8 0 0 0-1.24 2.16m5.13.4-1.58 1.9a.5.5 0 0 0 0 .64l1.39 1.67c.1.12.28.12.38 0l.93-1.11a.25.25 0 0 0 0-.32L8.75 10l.6-.72zM8.75 7h2.5l2.23 2.68a.5.5 0 0 1 0 .64l-2.16 2.59a.3.3 0 0 1-.19.09H9.28a.25.25 0 0 1-.19-.41L11.25 10z"
]);
const $dc0a6e3db5d5b553$export$4e800d238158b1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlanetColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__a)",
            "d": "M18.18 7.53a4 4 0 0 0-1.17-.2c-.03-.09-2.08-.13-2.43-.2-2.67 1-8.52 5.09-11.58 5.09v.46a7.5 7.5 0 0 0 14.28-.87c1.28-.08 2.34-.75 2.63-1.68.16-.5.1-1.03-.18-1.5-.28-.48-.9-.85-1.55-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__b)",
            "d": "M18.18 7.53a4 4 0 0 0-1.17-.2c-.03-.09-2.08-.13-2.43-.2-2.67 1-8.52 5.09-11.58 5.09v.46a7.5 7.5 0 0 0 14.28-.87c1.28-.08 2.34-.75 2.63-1.68.16-.5.1-1.03-.18-1.5-.28-.48-.9-.85-1.55-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__c)",
            "d": "M18.18 7.53a4 4 0 0 0-1.17-.2c-.03-.09-2.08-.13-2.43-.2-2.67 1-8.52 5.09-11.58 5.09v.46a7.5 7.5 0 0 0 14.28-.87c1.28-.08 2.34-.75 2.63-1.68.16-.5.1-1.03-.18-1.5-.28-.48-.9-.85-1.55-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__d)",
            "d": "M18.18 7.53a4 4 0 0 0-1.17-.2c-.03-.09-2.08-.13-2.43-.2-2.67 1-8.52 5.09-11.58 5.09v.46a7.5 7.5 0 0 0 14.28-.87c1.28-.08 2.34-.75 2.63-1.68.16-.5.1-1.03-.18-1.5-.28-.48-.9-.85-1.55-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__e)",
            "fillOpacity": ".5",
            "d": "M18.18 7.53a4 4 0 0 0-1.17-.2c-.03-.09-2.08-.13-2.43-.2-2.67 1-8.52 5.09-11.58 5.09v.46a7.5 7.5 0 0 0 14.28-.87c1.28-.08 2.34-.75 2.63-1.68.16-.5.1-1.03-.18-1.5-.28-.48-.9-.85-1.55-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__f)",
            "d": "M18.18 7.53a4 4 0 0 0-1.17-.2c-.03-.09-2.08-.13-2.43-.2-2.67 1-8.52 5.09-11.58 5.09v.46a7.5 7.5 0 0 0 14.28-.87c1.28-.08 2.34-.75 2.63-1.68.16-.5.1-1.03-.18-1.5-.28-.48-.9-.85-1.55-1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__g)",
            "d": "M1.83 12.47q.53.2 1.16.2l.01.03v-.02c2.56 0 4.78-1.34 7-2.68s4.44-2.68 7-2.68a7.5 7.5 0 0 0-14.28.87C1.44 8.27.38 8.95.09 9.87c-.16.5-.1 1.03.18 1.5.28.48.9.85 1.56 1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__h)",
            "d": "M1.83 12.47q.53.2 1.16.2l.01.03v-.02c2.56 0 4.78-1.34 7-2.68s4.44-2.68 7-2.68a7.5 7.5 0 0 0-14.28.87C1.44 8.27.38 8.95.09 9.87c-.16.5-.1 1.03.18 1.5.28.48.9.85 1.56 1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__i)",
            "d": "M1.83 12.47q.53.2 1.16.2l.01.03v-.02c2.56 0 4.78-1.34 7-2.68s4.44-2.68 7-2.68a7.5 7.5 0 0 0-14.28.87C1.44 8.27.38 8.95.09 9.87c-.16.5-.1 1.03.18 1.5.28.48.9.85 1.56 1.1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_planet_20_color__j)",
            "d": "M1.83 12.47q.53.2 1.16.2l.01.03v-.02c2.56 0 4.78-1.34 7-2.68s4.44-2.68 7-2.68a7.5 7.5 0 0 0-14.28.87C1.44 8.27.38 8.95.09 9.87c-.16.5-.1 1.03.18 1.5.28.48.9.85 1.56 1.1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(234.05 12.96 5.08)scale(15.94 15.8004)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#8f77ff"
                }
            ],
            [
                "stop",
                {
                    "offset": ".46",
                    "stopColor": "#775be3"
                }
            ],
            [
                "stop",
                {
                    "offset": ".66",
                    "stopColor": "#6552d9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(160.5 8.74 7.53)scale(3.47169 8.68803)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#6e30c8"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#6730c6",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(235.26 12.73 7.39)scale(7.17869 27.5349)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f36284"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#f36284",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-13.5506 0 0 -7.64451 20.7 7.14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#7d40c8"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7f45d2",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(55.58 -10.28 19.36)scale(15.0359 45.6198)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#0a26b5",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#051d92"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(175.73 9.93 6.9)scale(3.53809 9.54879)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".19",
                    "stopColor": "#e173e7"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#e173e7",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(36.28 -2.3 9.07)scale(15.6224 15.5675)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3dd3dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4290f0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-52.08 8.37 4.09)scale(5.36757 13.083)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".29",
                    "stopColor": "#3a80e1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#488ae5",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__i",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-10.06 37.37 3.29)scale(2.6602 8.13882)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".23",
                    "stopColor": "#3dd3dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3dd3dc",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_planet_20_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(67.95 .1 4.89)scale(10.3999 31.8176)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#26cfdb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#19d9e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $dc0a6e3db5d5b553$export$c8907fc9b7633784 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlanetFilled', "1em", [
    "M2.72 8.19a7.5 7.5 0 0 1 13.82-1.86q-1 .07-2.04.35a30 30 0 0 0-4.21 1.55l-.91.4q-2.85 1.3-4.64 1.79c-1.25.33-1.9.29-2.22.17a8 8 0 0 1 .02-1.38c-.83.13-1.32.58-1.48.98a.8.8 0 0 0 .04.68c.12.22.38.47.89.66q.9.36 2.92-.15 2-.52 4.9-1.83a32 32 0 0 1 5.05-1.9c1.4-.36 2.6-.45 3.5-.12q1.01.38 1.42 1.11c.27.49.28 1.03.1 1.52-.34.9-1.33 1.57-2.6 1.65a7.5 7.5 0 0 1-13.82 1.86q1-.07 2.04-.35a30 30 0 0 0 4.21-1.55l.91-.4q2.85-1.3 4.64-1.79c1.25-.33 1.9-.29 2.22-.17a8 8 0 0 1-.02 1.38c.83-.12 1.33-.57 1.48-.98a.8.8 0 0 0-.04-.69c-.12-.22-.38-.47-.88-.65q-.89-.36-2.92.15-2 .52-4.88 1.84a32 32 0 0 1-5.06 1.9c-1.4.35-2.61.44-3.52.1a2.6 2.6 0 0 1-1.42-1.1 1.8 1.8 0 0 1-.1-1.52c.35-.9 1.33-1.56 2.6-1.65"
]);
const $dc0a6e3db5d5b553$export$6119e49f6778d10b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlanetRegular', "1em", [
    "M10 3.5a6.5 6.5 0 0 0-6.47 7.15c-.5.06-.82.01-1-.06a8 8 0 0 1 .01-1.38c-.83.13-1.33.58-1.48.98a.8.8 0 0 0 .04.68c.12.22.38.47.89.66q.89.36 2.92-.15 2-.52 4.89-1.83a32 32 0 0 1 5.06-1.9c1.4-.36 2.6-.46 3.5-.12q1.01.38 1.42 1.11c.26.49.28 1.03.1 1.52-.35.9-1.33 1.57-2.6 1.65a7.5 7.5 0 0 1-13.82 1.86q.53-.04 1.08-.13a6.5 6.5 0 0 0 11.93-4.2q.74-.06 1 .07a8 8 0 0 1-.01 1.38c.83-.12 1.32-.57 1.48-.98a.8.8 0 0 0-.04-.69c-.12-.22-.38-.47-.88-.65q-.9-.36-2.92.15-2 .52-4.89 1.84a32 32 0 0 1-5.06 1.9c-1.4.35-2.6.44-3.51.1a2.6 2.6 0 0 1-1.42-1.1 1.8 1.8 0 0 1-.1-1.52c.35-.9 1.33-1.56 2.6-1.65a7.5 7.5 0 0 1 13.82-1.86 9 9 0 0 0-1.08.13A6.5 6.5 0 0 0 10 3.5"
]);
const $dc0a6e3db5d5b553$export$b3b24f58b10fc570 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlantCattailFilled', "1em", [
    "M8 4a2 2 0 1 1 4 0v4a2 2 0 0 1-1.5 1.94v2.35l3.15-3.14a.5.5 0 0 1 .7.7l-3.85 3.86v.79a.5.5 0 0 1-1 0v-.8L5.65 9.86a.5.5 0 1 1 .7-.7l3.15 3.14V9.94A2 2 0 0 1 8 8zm-1.29 8.33q-.81.17-1.49.44-.94.35-1.55.89C3.28 14 3 14.46 3 15c0 .53.28.99.67 1.34q.61.54 1.55.9c1.25.47 2.94.76 4.78.76s3.53-.29 4.78-.77a5 5 0 0 0 1.55-.89c.39-.35.67-.8.67-1.34 0-.53-.28-.99-.67-1.34q-.61-.54-1.55-.9-.68-.25-1.49-.43l-.86.86q1.14.19 1.99.5.83.34 1.23.7c.27.25.35.45.35.61s-.08.36-.35.6q-.4.38-1.23.7c-1.1.43-2.67.7-4.42.7s-3.31-.27-4.42-.7a4 4 0 0 1-1.23-.7c-.27-.24-.35-.44-.35-.6s.08-.36.35-.6q.4-.38 1.23-.7.84-.34 1.99-.51z"
]);
const $dc0a6e3db5d5b553$export$e883e99d963dce4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlantCattailRegular', "1em", [
    "M10 2a2 2 0 0 0-2 2v4a2 2 0 0 0 1.5 1.94v2.35L6.35 9.15a.5.5 0 1 0-.7.7l3.85 3.86v.79a.5.5 0 0 0 1 0v-.8l3.85-3.85a.5.5 0 0 0-.7-.7l-3.15 3.14V9.94A2 2 0 0 0 12 8V4a2 2 0 0 0-2-2M9 4a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0zm-3.78 8.77q.68-.26 1.49-.44l.86.86q-1.14.19-1.99.5-.83.34-1.23.7c-.27.25-.35.45-.35.61s.08.36.35.6q.4.38 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.27-.24.35-.44.35-.6s-.08-.36-.35-.6a4 4 0 0 0-1.23-.7q-.85-.34-1.99-.51l.86-.86q.81.17 1.49.44.94.35 1.55.89c.39.35.67.8.67 1.34 0 .53-.28.99-.67 1.34q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89C3.28 16 3 15.54 3 15c0-.53.28-.99.67-1.34q.61-.54 1.55-.9"
]);
const $dc0a6e3db5d5b553$export$ad91477b1583a066 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlantGrassFilled', "1em", [
    "M6.85 3.15h.02l.02.04.47.52q.47.54 1.12 1.52C9.02 6.06 9.6 7.1 10 8.3a14 14 0 0 1 2.64-4.6l.47-.52.02-.03.01-.01a.5.5 0 0 1 .86.35v5.1q.38-.78.8-1.28a5 5 0 0 1 1.5-1.28h.01a.5.5 0 0 1 .69.46V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6.5a.5.5 0 0 1 .69-.46h.02l.13.07q.14.07.35.22c.28.2.64.5 1.02.99q.41.5.79 1.29V3.5a.5.5 0 0 1 .85-.35"
]);
const $dc0a6e3db5d5b553$export$a18c78794cd67ec3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlantGrassRegular', "1em", [
    "M6.85 3.15h.02l.02.04.47.52q.47.54 1.12 1.52C9.02 6.06 9.6 7.1 10 8.3a14 14 0 0 1 2.64-4.6l.47-.52.02-.03.01-.01a.5.5 0 0 1 .86.35v5.1q.38-.78.8-1.28a5 5 0 0 1 1.5-1.28h.01a.5.5 0 0 1 .69.46V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6.5a.5.5 0 0 1 .69-.46h.02l.13.07q.14.07.35.22c.28.2.64.5 1.02.99q.41.5.79 1.29V3.5a.5.5 0 0 1 .85-.35M4 7.47V14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V7.47a5 5 0 0 0-.42.46c-.62.8-1.34 2.2-1.58 4.62a.5.5 0 0 1-1-.05V4.86q-.3.4-.64.91a12 12 0 0 0-1.86 4.8.5.5 0 0 1-1 0 12 12 0 0 0-1.86-4.8q-.33-.52-.64-.91v7.64a.5.5 0 0 1-1 .05c-.24-2.42-.96-3.83-1.58-4.62A5 5 0 0 0 4 7.47"
]);
const $dc0a6e3db5d5b553$export$2259dabe3d214eb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlantRagweedFilled', "1em", [
    "M7.5 4.5a2.5 2.5 0 1 1 4.94.55 2 2 0 0 1 .88 3.45A2 2 0 0 1 12 12h-1.5v4.3l3.15-3.15a.5.5 0 0 1 .7.7l-3.85 3.86v.79a.5.5 0 0 1-1 0v-.8l-3.85-3.85a.5.5 0 0 1 .7-.7l3.15 3.14V12H8a2 2 0 0 1-1.32-3.5 2 2 0 0 1 .88-3.45 3 3 0 0 1-.06-.55"
]);
const $dc0a6e3db5d5b553$export$7190f230951360dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlantRagweedRegular', "1em", [
    "M10 2a2.5 2.5 0 0 0-2.44 3.05 2 2 0 0 0-.88 3.45A2 2 0 0 0 8 12h1.5v4.3l-3.15-3.15a.5.5 0 0 0-.7.7l3.85 3.86v.79a.5.5 0 0 0 1 0v-.8l3.85-3.85a.5.5 0 0 0-.7-.7l-3.15 3.14V12H12a2 2 0 0 0 1.32-3.5 2 2 0 0 0-.88-3.45A2.5 2.5 0 0 0 10 2m2 9H8a1 1 0 1 1 0-2 .5.5 0 0 0 0-1 1 1 0 0 1 0-2h.27a.5.5 0 0 0 .43-.75 1.5 1.5 0 1 1 2.6 0 .5.5 0 0 0 .43.75H12a1 1 0 1 1 0 2 .5.5 0 0 0 0 1 1 1 0 1 1 0 2"
]);
const $dc0a6e3db5d5b553$export$acca88667de7952c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayFilled', "1em", [
    "M17.22 8.68a1.5 1.5 0 0 1 0 2.63l-10 5.5A1.5 1.5 0 0 1 5 15.5v-11A1.5 1.5 0 0 1 7.22 3.2z"
]);
const $dc0a6e3db5d5b553$export$77cc1eeb84ed914a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayRegular', "1em", [
    "M17.22 8.69a1.5 1.5 0 0 1 0 2.62l-10 5.5A1.5 1.5 0 0 1 5 15.5v-11A1.5 1.5 0 0 1 7.22 3.2zm-.48 1.75a.5.5 0 0 0 0-.88l-10-5.5A.5.5 0 0 0 6 4.5v11c0 .38.4.62.74.44z"
]);
const $dc0a6e3db5d5b553$export$b65c1279fd8ef624 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6-2.17v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 0 0 0-.86L9.13 7.18A.75.75 0 0 0 8 7.83"
]);
const $dc0a6e3db5d5b553$export$811bf13eda5fbdc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleRegular', "1em", [
    "M9.13 7.18A.75.75 0 0 0 8 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 0 0 0-.86zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
]);
const $dc0a6e3db5d5b553$export$a1069694c84c1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleHintFilled', "1em", [
    "M10 2q-.8 0-1.56.15a.5.5 0 0 0 .2.98 7 7 0 0 1 2.73 0 .5.5 0 0 0 .2-.98Q10.8 2 10 2m4.45 1.35a.5.5 0 0 0-.56.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m-8.34.83a.5.5 0 1 0-.56-.83 8 8 0 0 0-2.2 2.2.5.5 0 1 0 .83.56A7 7 0 0 1 6.1 4.18M3.13 8.63a.5.5 0 0 0-.98-.2 8 8 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7 7 0 0 1 0-2.73m14.72-.2a.5.5 0 1 0-.98.2 7 7 0 0 1 0 2.74.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13M4.18 13.9a.5.5 0 1 0-.83.56 8 8 0 0 0 2.2 2.2.5.5 0 1 0 .56-.83 7 7 0 0 1-1.93-1.93m12.47.56a.5.5 0 0 0-.83-.56 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .56.83 8 8 0 0 0 2.2-2.2m-8.02 2.42a.5.5 0 1 0-.2.98 8 8 0 0 0 3.13 0 .5.5 0 0 0-.2-.98 7 7 0 0 1-2.73 0M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0M9.13 7.18A.75.75 0 0 0 8 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 0 0 0-.86z"
]);
const $dc0a6e3db5d5b553$export$6de6ee6131f4f56c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleHintRegular', "1em", [
    "M10 2q-.8 0-1.56.15a.5.5 0 0 0 .2.98 7 7 0 0 1 2.73 0 .5.5 0 0 0 .2-.98Q10.8 2 10 2m4.45 1.35a.5.5 0 0 0-.56.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m-8.34.83a.5.5 0 1 0-.56-.83 8 8 0 0 0-2.2 2.2.5.5 0 1 0 .83.56A7 7 0 0 1 6.1 4.18M3.13 8.63a.5.5 0 0 0-.98-.2 8 8 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7 7 0 0 1 0-2.73m14.72-.2a.5.5 0 1 0-.98.2 7 7 0 0 1 0 2.74.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13M4.18 13.9a.5.5 0 1 0-.83.56 8 8 0 0 0 2.2 2.2.5.5 0 1 0 .56-.83 7 7 0 0 1-1.93-1.93m12.47.56a.5.5 0 0 0-.83-.56 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .56.83 8 8 0 0 0 2.2-2.2m-8.02 2.42a.5.5 0 1 0-.2.98 8 8 0 0 0 3.13 0 .5.5 0 0 0-.2-.98 7 7 0 0 1-2.73 0M8 7.83c0-.57.63-.94 1.13-.65l4.12 2.39a.5.5 0 0 1 0 .86l-4.12 2.39A.75.75 0 0 1 8 12.17z"
]);
const $dc0a6e3db5d5b553$export$1e6e7d44cca8b17a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleHintHalfFilled', "1em", [
    "M10 2q.8 0 1.56.15a.5.5 0 0 1-.2.98A7 7 0 0 0 9.82 3a7 7 0 1 0 1.56 13.87.5.5 0 1 1 .2.98 8 8 0 0 1-7.61-2.6 7.97 7.97 0 0 1 .59-11.1A8 8 0 0 1 10 2m3.75 1.49a.5.5 0 0 1 .7-.14 8 8 0 0 1 2.2 2.2.5.5 0 1 1-.83.56 7 7 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7m3.51 4.56a.5.5 0 0 1 .59.39 8 8 0 0 1 0 3.12.5.5 0 0 1-.98-.2 7 7 0 0 0 0-2.73.5.5 0 0 1 .39-.58m-.75 5.7c.23.16.3.47.14.7a8 8 0 0 1-2.2 2.2.5.5 0 0 1-.56-.83 7 7 0 0 0 1.93-1.93.5.5 0 0 1 .7-.14M10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12M8 7.83c0-.57.63-.94 1.13-.65l4.12 2.39a.5.5 0 0 1 0 .86l-4.12 2.39A.75.75 0 0 1 8 12.17z"
]);
const $dc0a6e3db5d5b553$export$24144d1a0a0a12ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleHintHalfRegular', "1em", [
    "M10 2q.8 0 1.56.15a.5.5 0 0 1-.2.98A7 7 0 0 0 9.82 3a7 7 0 1 0 1.56 13.87.5.5 0 1 1 .2.98 8 8 0 0 1-7.61-2.6 7.97 7.97 0 0 1 .59-11.1A8 8 0 0 1 10 2m3.75 1.49a.5.5 0 0 1 .7-.14 8 8 0 0 1 2.2 2.2.5.5 0 1 1-.83.56 7 7 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7m3.51 4.56a.5.5 0 0 1 .59.39 8 8 0 0 1 0 3.12.5.5 0 0 1-.98-.2 7 7 0 0 0 0-2.73.5.5 0 0 1 .39-.58m-.75 5.7c.23.16.3.47.14.7a8 8 0 0 1-2.2 2.2.5.5 0 0 1-.56-.83 7 7 0 0 0 1.93-1.93.5.5 0 0 1 .7-.14M9.13 7.18A.75.75 0 0 0 8 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 0 0 0-.86z"
]);
const $dc0a6e3db5d5b553$export$2da3298054fc4363 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a1 1 0 0 0-.14-.22 1 1 0 0 0-.22-.14l-.77-.25q-.4-.15-.65-.48a1.3 1.3 0 0 1-.12-1.3 1 1 0 0 1-.45-.22 1.5 1.5 0 0 1-.52-.69l-.36-1.09a1 1 0 0 0-.29-.47 1 1 0 0 0-.47-.3l-1.06-.34A1.4 1.4 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9zM8 7.83c0-.57.63-.94 1.13-.65l4.12 2.39a.5.5 0 0 1 0 .86l-4.12 2.39A.75.75 0 0 1 8 12.17z"
]);
const $dc0a6e3db5d5b553$export$af890b22e463a88b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayCircleSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.1 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9zM9.13 7.18A.75.75 0 0 0 8 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 0 0 0-.86z"
]);
const $dc0a6e3db5d5b553$export$16745d4101fbb39a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlaySettingsFilled', "1em", [
    "M17.22 8.68a1.5 1.5 0 0 1 0 2.63L12 14.2A5.5 5.5 0 0 0 5 9.2V4.5a1.5 1.5 0 0 1 2.23-1.32zM4.06 11.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 4 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 9 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zM6.5 15.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $dc0a6e3db5d5b553$export$3988a03d44959f75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlaySettingsRegular', "1em", [
    "M17.22 8.69a1.5 1.5 0 0 1 0 2.62l-5.23 2.88a6 6 0 0 0-.16-1.05l4.9-2.7a.5.5 0 0 0 0-.88l-9.99-5.5A.5.5 0 0 0 6 4.5v4.52q-.52.05-1 .19V4.5a1.5 1.5 0 0 1 2.22-1.32zM4.06 11.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 4 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 9 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zM6.5 15.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $dc0a6e3db5d5b553$export$7f494918b11cdc60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayingCardsFilled', "1em", [
    "M5.07 13a2 2 0 0 0 1.41 2.46l5.46 1.47a2 2 0 0 0 2.45-1.41L16.93 6a2 2 0 0 0-1.41-2.46l-5.46-1.47A2 2 0 0 0 7.6 3.5zM5 4v5.38l1.77-6.64q.11-.4.34-.74H7a2 2 0 0 0-2 2M2.67 5.5 4 10.48V4a3 3 0 0 1 .16-.96l-.08.02A2 2 0 0 0 2.67 5.5M13 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $dc0a6e3db5d5b553$export$250deea39c47b71c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlayingCardsRegular', "1em", [
    "M5.07 13a2 2 0 0 0 1.41 2.46l5.46 1.47a2 2 0 0 0 2.45-1.41L16.93 6a2 2 0 0 0-1.41-2.46l-5.46-1.47A2 2 0 0 0 7.6 3.5zm1.67 1.5a1 1 0 0 1-.7-1.23l2.53-9.52a1 1 0 0 1 1.23-.71l5.46 1.47a1 1 0 0 1 .7 1.23l-2.53 9.52a1 1 0 0 1-1.23.7zM4 10.47 2.67 5.51a2 2 0 0 1 1.41-2.45l.08-.02A3 3 0 0 0 4 4v.19a1 1 0 0 0-.36 1.06L4 6.6zm1-1.09V4c0-1.1.9-2 2-2h.1a3 3 0 0 0-.33.74l-.08.31A1 1 0 0 0 6 4v1.64zM13 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $dc0a6e3db5d5b553$export$3d8cc8b3ed3a6051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadAloudFilled', "1em", [
    "M11.84 2.14c.2-.36.66-.5 1.02-.3a10 10 0 0 1 5.39 8.08.75.75 0 1 1-1.5.16 8.5 8.5 0 0 0-4.6-6.92.75.75 0 0 1-.3-1.02M8.7 4.22a.75.75 0 0 0-1.38 0l-4.5 11a.75.75 0 0 0 1.38.56l1.45-3.53h4.72l1.45 3.53a.75.75 0 0 0 1.38-.56zm1.06 6.53h-3.5L8 6.48zm2.62-6.4a.75.75 0 0 0-.74 1.3c1.52.87 2.4 2.4 2.63 3.96a.75.75 0 1 0 1.48-.22 7 7 0 0 0-3.37-5.04"
]);
const $dc0a6e3db5d5b553$export$8b943349afc21609 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadAloudRegular', "1em", [
    "M12.06 2.26a.5.5 0 0 1 .68-.2A9.7 9.7 0 0 1 18 9.94a.5.5 0 0 1-1 .12 8.7 8.7 0 0 0-4.74-7.12.5.5 0 0 1-.2-.68m-3.6 2.05a.5.5 0 0 0-.92 0l-4.5 11a.5.5 0 1 0 .92.38l1.54-3.76V12h5v-.07l1.54 3.76a.5.5 0 1 0 .92-.38zM10.12 11H5.88L8 5.82zm2.13-6.43a.5.5 0 0 0-.5.86 5.7 5.7 0 0 1 2.76 4.14.5.5 0 0 0 .98-.14 6.7 6.7 0 0 0-3.24-4.86"
]);
const $dc0a6e3db5d5b553$export$2b6fe24eb2e68e1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadingListFilled', "1em", [
    "M3.5 5.5a1 1 0 0 1 1.84-.56.75.75 0 0 0 1.24-.83A2.5 2.5 0 1 0 4.6 8h10.67a.75.75 0 0 0 0-1.5H4.5a1 1 0 0 1-1-1M9.75 4a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm-4 5a.75.75 0 0 0 0 1.5h11.5a.75.75 0 1 0 0-1.5zM2 12.25c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M5.75 14a.75.75 0 0 0 0 1.5h11.5a.75.75 0 1 0 0-1.5z"
]);
const $dc0a6e3db5d5b553$export$d4b7ba0a428d3f7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadingListRegular', "1em", [
    "M3 6.25a1.25 1.25 0 0 1 2.3-.7.5.5 0 1 0 .82-.55 2.25 2.25 0 1 0-1.74 3.5H15.5a.5.5 0 0 0 0-1H4.25C3.56 7.5 3 6.94 3 6.25M8.5 5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm-3 5a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1zM2 13c0-.28.22-.5.5-.5h12a.5.5 0 0 1 0 1h-12A.5.5 0 0 1 2 13m3.5 2a.5.5 0 0 0 0 1h12a.5.5 0 1 0 0-1z"
]);
const $dc0a6e3db5d5b553$export$42196b23761a616d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadingListAddFilled', "1em", [
    "M3.5 5.5a1 1 0 0 1 1.84-.56.75.75 0 0 0 1.24-.83A2.5 2.5 0 1 0 4.6 8h10.67a.75.75 0 0 0 0-1.5H4.5a1 1 0 0 1-1-1M9.75 4a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zm-4 5a.75.75 0 0 0 0 1.5h4.98A5.5 5.5 0 0 1 14.5 9zm-3 2.5h7.14q-.45.69-.68 1.5H2.75a.75.75 0 0 1 0-1.5m3 2.5h3.27a6 6 0 0 0 .07 1.5H5.75a.75.75 0 0 1 0-1.5m13.25.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 1 0 1 0V15h1.5a.5.5 0 1 0 0-1H15z"
]);
const $dc0a6e3db5d5b553$export$4eba0d69da55edda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadingListAddRegular', "1em", [
    "M3 5.25a1.25 1.25 0 0 1 2.3-.7.5.5 0 1 0 .82-.55 2.25 2.25 0 1 0-1.74 3.5H15.5a.5.5 0 0 0 0-1H4.25C3.56 6.5 3 5.94 3 5.25M8.5 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm-3 5a.5.5 0 0 0 0 1h5.84c.9-.63 1.98-1 3.16-1zm-3 2.5h7.39q-.3.47-.52 1H2.5a.5.5 0 0 1 0-1m3 2.5h3.52a6 6 0 0 0 0 1H5.5a.5.5 0 0 1 0-1m13.5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $dc0a6e3db5d5b553$export$a3fca9c2ef8c476 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadingModeMobileFilled', "1em", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5zm2 3c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M6.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 10.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $dc0a6e3db5d5b553$export$89ea6cc3b3bccaf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReadingModeMobileRegular', "1em", [
    "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5zM5.5 3a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $dc0a6e3db5d5b553$export$74365127efa2537a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RealEstateFilled', "1em", [
    "M2 3a1 1 0 0 1 2 0h13a1 1 0 1 1 0 2H4v12.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 3.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 5 13.5zm3 7c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-2.55a1 1 0 0 0-.34-.75l-2.33-2.07a.5.5 0 0 0-.66 0L8.34 10.2a1 1 0 0 0-.34.75z"
]);
const $dc0a6e3db5d5b553$export$98124966384b725 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RealEstateRegular', "1em", [
    "M2 3.5A1.5 1.5 0 0 1 4.91 3H16.5a1.5 1.5 0 0 1 .5 2.92V13a3 3 0 0 1-3 3H7c-.77 0-1.47-.29-2-.76v2.01c0 .41-.34.75-.75.75h-1.5a.75.75 0 0 1-.75-.75zM16 13V6H5v7c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2M4 5h12.5a.5.5 0 0 0 0-1H4v-.5a.5.5 0 0 0-1 0V17h1zm3.5 4.95v2.56c0 .27.22.5.5.5h1a.5.5 0 0 0 .5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .27.22.5.5.5h1a.5.5 0 0 0 .5-.5V9.95a1 1 0 0 0-.34-.74l-2.33-2.07a.5.5 0 0 0-.66 0L7.84 9.2a1 1 0 0 0-.34.74"
]);
const $dc0a6e3db5d5b553$export$112fdeb87953a6aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RouterFilled', "1em", [
    "M3.5 9.5a6.5 6.5 0 0 1 13 0 .5.5 0 0 0 1 0 7.5 7.5 0 0 0-15 0 .5.5 0 0 0 1 0m6.5-4a4 4 0 0 0-4 4 .5.5 0 0 1-1 0 5 5 0 0 1 10 0 .5.5 0 0 1-1 0 4 4 0 0 0-4-4M7.75 9.25a2.25 2.25 0 1 1 2.75 2.2V13h4a2.5 2.5 0 0 1 0 5h-9a2.5 2.5 0 0 1 0-5h4v-1.56a2.25 2.25 0 0 1-1.75-2.19"
]);
const $dc0a6e3db5d5b553$export$34bbd7d5eb1f56b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RouterRegular', "1em", [
    "M3.5 9.5a6.5 6.5 0 0 1 13 0 .5.5 0 0 0 1 0 7.5 7.5 0 0 0-15 0 .5.5 0 0 0 1 0m6.5-4a4 4 0 0 0-4 4 .5.5 0 0 1-1 0 5 5 0 0 1 10 0 .5.5 0 0 1-1 0 4 4 0 0 0-4-4M7.75 9.25a2.25 2.25 0 1 1 2.75 2.2V13h4a2.5 2.5 0 0 1 0 5h-9a2.5 2.5 0 0 1 0-5h4v-1.56a2.25 2.25 0 0 1-1.75-2.19M10 8a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 10 8m-4.5 6a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3z"
]);
const $dc0a6e3db5d5b553$export$388943fb09466acf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RouterOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-.74-.74a2.5 2.5 0 0 1-1.91.89h-9a2.5 2.5 0 0 1 0-5h4v-1.56a2.25 2.25 0 0 1-1.64-2.87L6.63 7.34Q6.01 8.3 6 9.5a.5.5 0 0 1-1 0c0-1.07.34-2.07.91-2.88L4.84 5.55A6.5 6.5 0 0 0 3.5 9.5a.5.5 0 0 1-1 0c0-1.76.6-3.38 1.63-4.67L2.15 2.85a.5.5 0 0 1 0-.7m8.54 9.24-.19.05V13h1.8zM10 7a2.25 2.25 0 0 1 2.12 3L9.25 7.13Q9.61 7 10 7m0-2.5a5 5 0 0 1 5 5 .5.5 0 1 1-1 0 4 4 0 0 0-5.9-3.52l-.73-.73A5 5 0 0 1 10 4.5M10 2a7.5 7.5 0 0 1 7.5 7.5.5.5 0 1 1-1 0A6.5 6.5 0 0 0 6.29 4.17l-.72-.72A7.5 7.5 0 0 1 10 2"
]);
const $dc0a6e3db5d5b553$export$aff9a22f04b1d154 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RouterOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-.74-.74a2.5 2.5 0 0 1-1.91.89h-9a2.5 2.5 0 0 1 0-5h4v-1.56a2.25 2.25 0 0 1-1.64-2.87L6.63 7.34Q6.01 8.3 6 9.5a.5.5 0 0 1-1 0c0-1.07.34-2.07.91-2.88L4.84 5.55A6.5 6.5 0 0 0 3.5 9.5a.5.5 0 0 1-1 0c0-1.76.6-3.38 1.63-4.67L2.15 2.85a.5.5 0 0 1 0-.7M5.5 14a1.5 1.5 0 0 0 0 3h9c.49 0 .92-.24 1.2-.6L13.3 14zm5.19-2.6-.19.04V13h1.8zM10 7a2.25 2.25 0 0 1 2.12 3l-.88-.88a1.25 1.25 0 0 0-1.11-1.11l-.88-.88Q9.61 7 10 7m0-2.5a5 5 0 0 1 5 5 .5.5 0 0 1-1 0 4 4 0 0 0-5.9-3.52l-.73-.73A5 5 0 0 1 10 4.5M10 2a7.5 7.5 0 0 1 7.5 7.5.5.5 0 0 1-1 0A6.5 6.5 0 0 0 6.29 4.17l-.72-.72A7.5 7.5 0 0 1 10 2"
]);
const $dc0a6e3db5d5b553$export$3ff3ce8289024c94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThinkingFilled', "1em", [
    "M7.7 2.64A4 4 0 0 1 10 2a3.56 3.56 0 0 1 3.52 2.1c.33.7.43 1.44.46 1.92.65.05 1.31.2 1.86.56C16.56 7.06 17 7.85 17 9c0 1.17-.44 1.97-1.16 2.44-.69.45-1.56.56-2.34.56h-7c-.79 0-1.66-.13-2.34-.58C3.44 10.94 3 10.15 3 9s.44-1.94 1.16-2.42c.55-.36 1.2-.51 1.86-.56.03-.48.13-1.21.46-1.92.25-.53.63-1.06 1.21-1.46M10 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $dc0a6e3db5d5b553$export$4a1f5aa0222cd9ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThinkingRegular', "1em", [
    "M10 2a3.55 3.55 0 0 0-3.52 2.1c-.33.7-.43 1.44-.46 1.92-.65.05-1.31.2-1.86.56C3.44 7.06 3 7.85 3 9s.44 1.94 1.16 2.42c.68.45 1.55.58 2.34.58h7c.78 0 1.65-.11 2.34-.56C16.56 10.97 17 10.17 17 9c0-1.15-.44-1.94-1.16-2.42a4 4 0 0 0-1.86-.56 6 6 0 0 0-.46-1.92A3.6 3.6 0 0 0 10 2M7 6.5c0-.24 0-1.15.4-1.98.18-.4.46-.78.86-1.05A3 3 0 0 1 10 3a3 3 0 0 1 1.74.47c.4.27.68.65.87 1.05.39.83.39 1.74.39 1.98 0 .28.22.5.5.5.71 0 1.34.12 1.79.42.4.27.71.73.71 1.58 0 .89-.31 1.34-.71 1.6-.44.3-1.07.4-1.79.4h-7c-.71 0-1.34-.12-1.79-.42C4.31 10.31 4 9.85 4 9s.3-1.31.71-1.58C5.16 7.12 5.8 7 6.5 7a.5.5 0 0 0 .5-.5M8 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4.5 2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $dc0a6e3db5d5b553$export$8d84caae7043bc39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WasherFilled', "1em", [
    "M7.48 10.67q-.25.12-.48.26a3 3 0 0 1 5.85-.88c-.4.4-1.27.83-2.73.46a4 4 0 0 0-2.64.16M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm4 4a4 4 0 0 1 3.92 3.21l.03.01-.02.04A4 4 0 0 1 10 15a4 4 0 0 1 0-8M7.5 5.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $dc0a6e3db5d5b553$export$31a48d7e687a4ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WasherRegular', "1em", [
    "M10 7a4 4 0 0 1 3.92 3.21l.03.01-.02.04A4 4 0 0 1 10 15a4 4 0 0 1 0-8m-2.52 3.67c.67-.3 1.54-.43 2.64-.16 1.46.37 2.33-.06 2.73-.46a3 3 0 0 0-5.85.88q.22-.14.48-.26M7.5 5.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3-.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);


"use client";
const $90f21c32649fad68$export$aba53305ff43a1ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachFilled', "1em", [
    "m5.28 10.6 5.3-5.3a2.75 2.75 0 1 1 3.9 3.9L8.1 15.55a1.25 1.25 0 1 1-1.77-1.77L12 8.13a.75.75 0 0 0-1.06-1.06l-5.66 5.66a2.75 2.75 0 0 0 3.89 3.89l6.36-6.36a4.25 4.25 0 0 0-6-6.02l-5.31 5.3a.75.75 0 0 0 1.06 1.07"
]);
const $90f21c32649fad68$export$f153ff5e08ddeef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachRegular', "1em", [
    "m4.83 10.48 5.65-5.65a3 3 0 0 1 4.25 4.24L8 15.8a1.5 1.5 0 0 1-2.12-2.12l6-6.01a.5.5 0 1 0-.7-.71l-6 6.01a2.5 2.5 0 0 0 3.53 3.54l6.71-6.72a4 4 0 1 0-5.65-5.66L4.12 9.78a.5.5 0 0 0 .7.7"
]);
const $90f21c32649fad68$export$5b27d93830e06385 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachArrowRightFilled', "1em", [
    "m5.28 10.6 5.3-5.3A2.75 2.75 0 0 1 14.65 9q.84.03 1.6.29a4.25 4.25 0 0 0-6.73-5.05l-5.3 5.3a.75.75 0 0 0 1.06 1.07m2.83 4.96.9-.9q.02.94.34 1.78l-.18.18a2.75 2.75 0 0 1-3.89-3.89l5.66-5.66A.75.75 0 1 1 12 8.13L6.34 13.8a1.25 1.25 0 0 0 1.77 1.77M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $90f21c32649fad68$export$68ff927e399b0948 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachArrowRightRegular', "1em", [
    "m4.83 10.48 5.65-5.65A3 3 0 0 1 14.79 9q.6.03 1.14.18a4 4 0 0 0-6.14-5.07L4.12 9.78a.5.5 0 0 0 .7.7M8 15.78l1-.99q.03.63.2 1.21l-.5.5a2.5 2.5 0 1 1-3.53-3.54l6.01-6.01a.5.5 0 1 1 .7.7l-6 6.02A1.5 1.5 0 0 0 8 15.79M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 1 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7z"
]);
const $90f21c32649fad68$export$fa0f5b807c218483 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachTextFilled', "1em", [
    "M6.75 3.5c-1.24 0-2.25 1-2.25 2.25v7.5a.75.75 0 0 1-1.5 0v-7.5a3.75 3.75 0 0 1 7.5-.25v10.25a2.25 2.25 0 0 1-4.5 0V5.77a.75.75 0 0 1 1.5 0v9.98a.75.75 0 0 0 1.5 0v-10C9 4.51 8 3.5 6.75 3.5M12 8.25c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM12 11.25c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z"
]);
const $90f21c32649fad68$export$309897133891df5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AttachTextRegular', "1em", [
    "M6.5 4A2.5 2.5 0 0 0 4 6.5V14a.5.5 0 0 1-1 0V6.5a3.5 3.5 0 1 1 7 0V15a2 2 0 0 1-4 0V6.5a.5.5 0 0 1 1 0V15a1 1 0 1 0 2 0V6.5A2.5 2.5 0 0 0 6.5 4M12 5.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm-.5 3.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$7701d5a16f059312 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BedFilled', "1em", [
    "M15.5 9a2.5 2.5 0 0 1 2.5 2.34v5.16a.5.5 0 0 1-1 .09V14H3v2.5a.5.5 0 0 1-1 .09V11.5A2.5 2.5 0 0 1 4.34 9H15.5m-9-6h7A2.5 2.5 0 0 1 16 5.34V8h-2v-.5a.5.5 0 0 0-.41-.5H11a.5.5 0 0 0-.5.41V8h-1v-.5a.5.5 0 0 0-.41-.5H6.5a.5.5 0 0 0-.5.41V8H4V5.5A2.5 2.5 0 0 1 6.34 3z"
]);
const $90f21c32649fad68$export$af5c3f131ca269ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BedRegular', "1em", [
    "M13.5 3A2.5 2.5 0 0 1 16 5.34v2.71a2.5 2.5 0 0 1 2 2.28v6.17a.5.5 0 0 1-1 .09V14H3v2.5a.5.5 0 0 1-1 .09V10.5a2.5 2.5 0 0 1 2-2.45V5.5A2.5 2.5 0 0 1 6.34 3h7.16m2 6h-11c-.78 0-1.42.6-1.5 1.36V13h14v-2.5c0-.78-.6-1.42-1.36-1.5zm-2-5h-7c-.78 0-1.42.6-1.5 1.36V8h1v-.5c0-.28.22-.5.5-.5H9c.28 0 .5.22.5.5V8h1v-.5c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5V8h1V5.5c0-.78-.6-1.42-1.36-1.5z"
]);
const $90f21c32649fad68$export$22ea0ffcd089ed1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAllFilled', "1em", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v3h4.75V4.5zm4.5 0v4.75h4.75v-3c0-.97-.78-1.75-1.75-1.75zm4.75 6.25h-4.75v4.75h3c.97 0 1.75-.78 1.75-1.75zM9.25 15.5v-4.75H4.5v3c0 .97.78 1.75 1.75 1.75zM3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75z"
]);
const $90f21c32649fad68$export$1ea889cb300f49b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderAllRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v3.5h5.5V4zm4.5 0v5.5H16V6a2 2 0 0 0-2-2zm5.5 6.5h-5.5V16H14a2 2 0 0 0 2-2zM9.5 16v-5.5H4V14c0 1.1.9 2 2 2z"
]);
const $90f21c32649fad68$export$a490613c68183937 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomFilled', "1em", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m.71 11.75H14a1.5 1.5 0 0 0 1.43-1.03v-.01a.75.75 0 0 1 1.38.58A3 3 0 0 1 14 17H6a3 3 0 0 1-2.81-1.96.75.75 0 1 1 1.41-.49c.22.56.77.95 1.4.95zM4.61 5.45a1.5 1.5 0 0 1 .93-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.49m9.94-.85a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.5 1.41M3 11.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm13.25.75a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75"
]);
const $90f21c32649fad68$export$37f9337a923c0339 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomRegular', "1em", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.54 4.05a2 2 0 0 0-1.5 1.55.5.5 0 0 1-.59.4.5.5 0 0 1-.38-.66 3 3 0 0 1 2.34-2.29.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6M3.07 14.66l-.02-.07a.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47A2 2 0 0 0 6 16h8a2 2 0 0 0 1.95-1.6.5.5 0 0 1 .6-.4.5.5 0 0 1 .38.66A3 3 0 0 1 14 17H6a3 3 0 0 1-2.93-2.34M14.6 3.06l.07.01a3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47 2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .6-.4M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"
]);
const $90f21c32649fad68$export$a638e435983a3cc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomDoubleFilled', "1em", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m-2.55.85a1.5 1.5 0 0 0-.88.94.75.75 0 0 1-1.38-.58 3 3 0 0 1 1.77-1.77.75.75 0 1 1 .5 1.41m9.95.85a1.5 1.5 0 0 0-.94-.88.75.75 0 0 1 .58-1.38 3 3 0 0 1 1.78 1.77h-.01a.75.75 0 1 1-1.41.49M3.75 11a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m11.75-.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0zm-12.5 6c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75M3.75 13a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z"
]);
const $90f21c32649fad68$export$682a0ce8ed4b666d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomDoubleRegular', "1em", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47M14.6 3.05l.07.02a3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47 2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .6-.4M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm0 5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m.5-2.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$b69264cfe531d177 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomThickFilled', "1em", [
    "M9 3a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2zm-4.64.5a1 1 0 1 1 1.16 1.62 1 1 0 0 0-.4.4 1 1 0 0 1-1.84-.33 1 1 0 0 1 .22-.83q.34-.53.85-.87M6 15a1 1 0 0 1-.88-.52 1 1 0 0 0-1.84.33 1 1 0 0 0 .22.83A3 3 0 0 0 6 17h8a3 3 0 0 0 2.5-1.35 1 1 0 1 0-1.62-1.17A1 1 0 0 1 14 15zm9.64-11.5a1 1 0 1 0-1.16 1.62q.25.15.4.4a1 1 0 0 0 1.84-.33 1 1 0 0 0-.22-.83 3 3 0 0 0-.85-.87M4 12a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1m11-1a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0z"
]);
const $90f21c32649fad68$export$7adb9e074799e231 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderBottomThickRegular', "1em", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m.71 11.75H14a1.5 1.5 0 0 0 1.43-1.03v-.01a.75.75 0 0 1 1.38.58A3 3 0 0 1 14 17H6a3 3 0 0 1-2.81-1.96.75.75 0 1 1 1.41-.49c.22.56.77.95 1.4.95zM4.61 5.45a1.5 1.5 0 0 1 .93-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.49m9.94-.85a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.5 1.41M3 11.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm13.25.75a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75"
]);
const $90f21c32649fad68$export$d45beb239ac967d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInsideFilled', "1em", [
    "M8 3.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 3.75m0 12.5c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75M4.6 5.45a1.5 1.5 0 0 1 .94-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.49m9.95-.85a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.5 1.41M3 11.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm13.25.75a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75M4.6 14.55a1.5 1.5 0 0 0 .94.88.75.75 0 0 1-.58 1.38 3 3 0 0 1-1.77-1.77.75.75 0 1 1 1.41-.49m9.95.85a1.5 1.5 0 0 0 .88-.94.75.75 0 0 1 1.38.58 3 3 0 0 1-1.77 1.77.75.75 0 1 1-.5-1.41m-3.8-9.15a.75.75 0 0 0-1.5 0v3h-3a.75.75 0 0 0 0 1.5h3v3a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5h-3z"
]);
const $90f21c32649fad68$export$d3e2e4b713b1b49b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderInsideRegular', "1em", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47m0 8.92a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47M14.66 3.07l-.07-.02a.5.5 0 0 0-.6.4.5.5 0 0 0 .47.6 2 2 0 0 1 1.5 1.55.5.5 0 0 0 .59.4.5.5 0 0 0 .38-.66 3 3 0 0 0-2.27-2.27m1.29 11.4a2 2 0 0 1-1.55 1.48.5.5 0 0 0-.4.6.5.5 0 0 0 .66.38 3 3 0 0 0 2.29-2.34.5.5 0 0 0-.4-.6.5.5 0 0 0-.6.47M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm5 5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m2.5-11a.5.5 0 0 0-1 0v4h-4a.5.5 0 0 0 0 1h4v4a.5.5 0 0 0 1 0v-4h4a.5.5 0 0 0 0-1h-4z"
]);
const $90f21c32649fad68$export$ff9961febb14b6f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftFilled', "1em", [
    "M16.25 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M3 11.27V14a3 3 0 0 0 1.96 2.81.75.75 0 0 0 .58-1.38l-.07-.03A1.5 1.5 0 0 1 4.5 14V6a1.5 1.5 0 0 1 1.04-1.43.75.75 0 0 0-.58-1.38A3 3 0 0 0 3 6v5.27M14.55 4.6a1.5 1.5 0 0 1 .88.94.75.75 0 0 0 1.38-.58 3 3 0 0 0-1.77-1.77.75.75 0 1 0-.49 1.41m.85 9.95a1.5 1.5 0 0 1-.94.88.75.75 0 0 0 .58 1.38 3 3 0 0 0 1.77-1.77.75.75 0 1 0-1.41-.5M8.75 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM8 16.25c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
]);
const $90f21c32649fad68$export$d5db7df8553dbbec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRegular', "1em", [
    "M17 8.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-1.05-2.96a2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .66-.38 3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47M5.34 3.07l.07-.02a.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6A2 2 0 0 0 4 6v8a2 2 0 0 0 1.6 1.95.5.5 0 0 1 .4.6.5.5 0 0 1-.66.38A3 3 0 0 1 3 14V6a3 3 0 0 1 2.34-2.93m11.6 11.52-.01.07a3 3 0 0 1-2.34 2.29.5.5 0 0 1-.6-.4.5.5 0 0 1 .47-.6 2 2 0 0 0 1.5-1.55.5.5 0 0 1 .59-.4.5.5 0 0 1 .4.6M8 16.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$d7ac63b2a51dce64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRightFilled', "1em", [
    "M15.5 6a1.5 1.5 0 0 0-1.04-1.43.75.75 0 0 1 .58-1.38A3 3 0 0 1 17 6v8a3 3 0 0 1-1.96 2.82.75.75 0 0 1-.58-1.39l.07-.03c.57-.21.97-.76.97-1.4zM8.75 3a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm0 12.5a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM5.45 4.6A1.5 1.5 0 0 0 4.5 6v8a1.5 1.5 0 0 0 1.03 1.43h.01a.75.75 0 0 1-.58 1.38A3 3 0 0 1 3 14.02V6a3 3 0 0 1 1.96-2.82.75.75 0 1 1 .49 1.42"
]);
const $90f21c32649fad68$export$ab089b550b32c244 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderLeftRightRegular', "1em", [
    "m14.66 3.07-.07-.02a.5.5 0 0 0-.6.4.5.5 0 0 0 .47.6A2 2 0 0 1 16 6v8a2 2 0 0 1-1.6 1.95.5.5 0 0 0-.4.6.5.5 0 0 0 .66.38A3 3 0 0 0 17 14V6a3 3 0 0 0-2.34-2.93m-9.32 0 .07-.02a.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6A2 2 0 0 0 4 6v8a2 2 0 0 0 1.6 1.95.5.5 0 0 1 .4.6.5.5 0 0 1-.66.38A3 3 0 0 1 3 14V6a3 3 0 0 1 2.34-2.93M8 16.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$6858a19bb06ae90f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNoneFilled', "1em", [
    "M8.75 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm0 12.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM5.45 4.6a1.5 1.5 0 0 0-.88.94.75.75 0 0 1-1.38-.58 3 3 0 0 1 1.77-1.77.75.75 0 1 1 .5 1.41m9.95.85a1.5 1.5 0 0 0-.94-.88.75.75 0 0 1 .58-1.38 3 3 0 0 1 1.78 1.77h-.01a.75.75 0 1 1-1.41.49M3.75 12a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75m11.75-.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zM5.45 15.4a1.5 1.5 0 0 1-.88-.94.75.75 0 0 0-1.38.58 3 3 0 0 0 1.77 1.77.75.75 0 1 0 .5-1.41m9.95-.85a1.5 1.5 0 0 1-.94.88.75.75 0 0 0 .58 1.38 3 3 0 0 0 1.78-1.77h-.01a.75.75 0 1 0-1.41-.49"
]);
const $90f21c32649fad68$export$ed6d2d7a73370674 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderNoneRegular', "1em", [
    "M8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2.46.55a2 2 0 0 0-1.5 1.55.5.5 0 0 1-.59.4.5.5 0 0 1-.38-.66 3 3 0 0 1 2.34-2.29.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6m0 11.9a2 2 0 0 1-1.5-1.55.5.5 0 0 0-.59-.4.5.5 0 0 0-.38.66 3 3 0 0 0 2.34 2.29.5.5 0 0 0 .6-.4.5.5 0 0 0-.47-.6m9.05-12.9.07.02a3 3 0 0 1 2.29 2.34.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47 2 2 0 0 0-1.55-1.5.5.5 0 0 1-.4-.59.5.5 0 0 1 .6-.4m-.13 12.9a2 2 0 0 0 1.5-1.55.5.5 0 0 1 .59-.4.5.5 0 0 1 .38.66 3 3 0 0 1-2.34 2.29.5.5 0 0 1-.6-.4.5.5 0 0 1 .47-.6M16 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zM3.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5m5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$66c8a3ce9406dc75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5z"
]);
const $90f21c32649fad68$export$8109489a05352852 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $90f21c32649fad68$export$42cc92765424ef20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideThickFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $90f21c32649fad68$export$3b515be30a92775a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderOutsideThickRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5z"
]);
const $90f21c32649fad68$export$5c7196d52a289575 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderRightFilled', "1em", [
    "M3.75 12a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75M17 8.73V6a3 3 0 0 0-1.96-2.81.75.75 0 1 0-.58 1.38l.07.03c.57.21.97.76.97 1.4v8a1.5 1.5 0 0 1-1.04 1.43.75.75 0 0 0 .58 1.38A3 3 0 0 0 17 14V8.73M5.45 15.4a1.5 1.5 0 0 1-.88-.94.75.75 0 0 0-1.38.58 3 3 0 0 0 1.77 1.77.75.75 0 1 0 .49-1.41M4.6 5.45a1.5 1.5 0 0 1 .94-.88.75.75 0 0 0-.58-1.38 3 3 0 0 0-1.77 1.77.75.75 0 1 0 1.41.5M11.25 17a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0 0 1.5zM12 3.75c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75"
]);
const $90f21c32649fad68$export$ce210daf825d56f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderRightRegular', "1em", [
    "M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm1.05 2.96a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47m10.61 2.47a.5.5 0 0 1-.66-.38.5.5 0 0 1 .46-.6A2 2 0 0 0 16 14V6a2 2 0 0 0-1.6-1.95.5.5 0 0 1-.4-.6.5.5 0 0 1 .66-.38A3 3 0 0 1 17 6v8a3 3 0 0 1-2.34 2.93M3.06 5.4l.01-.07a3 3 0 0 1 2.34-2.29.5.5 0 0 1 .6.4.5.5 0 0 1-.47.6 2 2 0 0 0-1.5 1.55.5.5 0 0 1-.59.4.5.5 0 0 1-.4-.59M12 3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3c.28 0 .5.22.5.5M11.5 17a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1z"
]);
const $90f21c32649fad68$export$1abeca4e8f0d9128 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopFilled', "1em", [
    "M12 16.25c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75M8.73 3H6a3 3 0 0 0-2.81 1.96.75.75 0 0 0 1.38.58l.03-.07A1.5 1.5 0 0 1 6 4.5h8a1.5 1.5 0 0 1 1.43 1.04.75.75 0 0 0 1.38-.58A3 3 0 0 0 14 3H8.73m6.67 11.55a1.5 1.5 0 0 1-.94.88.75.75 0 0 0 .58 1.38 3 3 0 0 0 1.77-1.77.75.75 0 1 0-1.41-.49m-9.95.85a1.5 1.5 0 0 1-.88-.94.75.75 0 0 0-1.38.58 3 3 0 0 0 1.77 1.77.75.75 0 1 0 .5-1.41M17 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0zM3.75 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75"
]);
const $90f21c32649fad68$export$ebc0cbb80a09d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopRegular', "1em", [
    "M11.5 17a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1zm2.96-1.05a2 2 0 0 0 1.5-1.55.5.5 0 0 1 .59-.4.5.5 0 0 1 .38.66 3 3 0 0 1-2.34 2.29.5.5 0 0 1-.6-.4.5.5 0 0 1 .47-.6m2.47-10.61a.5.5 0 1 1-.98.2A2 2 0 0 0 14 4H6a2 2 0 0 0-1.95 1.6.5.5 0 0 1-.6.4.5.5 0 0 1-.38-.66A3 3 0 0 1 6 3h8a3 3 0 0 1 2.93 2.34M5.4 16.94l-.07-.01a3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47 2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.59.4M3.5 8c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5m13.5.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$b5e38fde5e46335f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomFilled', "1em", [
    "M6 4.5a1.5 1.5 0 0 0-1.43 1.04.75.75 0 0 1-1.38-.58A3 3 0 0 1 6 3h8a3 3 0 0 1 2.81 1.96.75.75 0 0 1-1.38.58l-.03-.07A1.5 1.5 0 0 0 14 4.5zm-3 6.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm12.5 0a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0zm-10.9 3.3c.22.56.77.95 1.4.95h8a1.5 1.5 0 0 0 1.43-1.03v-.01a.75.75 0 0 1 1.38.58A3 3 0 0 1 14 17H6a3 3 0 0 1-2.81-1.96.75.75 0 1 1 1.41-.49"
]);
const $90f21c32649fad68$export$a285e124cb689225 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomRegular', "1em", [
    "m3.07 5.34-.02.07a.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47A2 2 0 0 1 6 4h8a2 2 0 0 1 1.95 1.6.5.5 0 0 0 .6.4.5.5 0 0 0 .38-.66A3 3 0 0 0 14 3H6a3 3 0 0 0-2.93 2.34m0 9.32-.02-.07a.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47A2 2 0 0 0 6 16h8a2 2 0 0 0 1.95-1.6.5.5 0 0 1 .6-.4.5.5 0 0 1 .38.66A3 3 0 0 1 14 17H6a3 3 0 0 1-2.93-2.34M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"
]);
const $90f21c32649fad68$export$eac2466b7067f7df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomDoubleFilled', "1em", [
    "M6 4.5a1.5 1.5 0 0 0-1.43 1.04.75.75 0 0 1-1.38-.58A3 3 0 0 1 6 3h8a3 3 0 0 1 2.81 1.96.75.75 0 0 1-1.38.58l-.03-.07A1.5 1.5 0 0 0 14 4.5zM3.75 11a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m12.5 0a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m-12.5 4.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5zM3 13.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $90f21c32649fad68$export$fe163af6646803fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomDoubleRegular', "1em", [
    "m3.05 5.41.02-.07A3 3 0 0 1 6 3h8a3 3 0 0 1 2.95 2.41.5.5 0 0 1-.4.6.5.5 0 0 1-.6-.47A2 2 0 0 0 14 4H6a2 2 0 0 0-1.95 1.6.5.5 0 0 1-.6.4.5.5 0 0 1-.4-.59M16.5 12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5m-13 4a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1zM3 14.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"
]);
const $90f21c32649fad68$export$e4405fde56ad7cc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomThickFilled', "1em", [
    "M5.12 5.52A1 1 0 0 1 6 5h8a1 1 0 0 1 .88.52 1 1 0 0 0 1.84-.33 1 1 0 0 0-.22-.83A3 3 0 0 0 14 3H6a3 3 0 0 0-2.5 1.35 1 1 0 1 0 1.62 1.17m0 8.96A1 1 0 0 0 6 15h8a1 1 0 0 0 .88-.52 1 1 0 0 1 1.84.33 1 1 0 0 1-.22.83A3 3 0 0 1 14 17H6a3 3 0 0 1-2.5-1.35 1 1 0 1 1 1.62-1.17M4 12a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1m11-1a1 1 0 0 0 2 0V9a1 1 0 1 0-2 0z"
]);
const $90f21c32649fad68$export$1e2841cbb7f575bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BorderTopBottomThickRegular', "1em", [
    "M6 4.5a1.5 1.5 0 0 0-1.43 1.04.75.75 0 0 1-1.38-.58A3 3 0 0 1 6 3h8a3 3 0 0 1 2.81 1.96.75.75 0 0 1-1.38.58l-.03-.07A1.5 1.5 0 0 0 14 4.5zM3.75 12a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .41-.34.75-.75.75M14 15.5H6a1.5 1.5 0 0 1-1.43-1.04.75.75 0 0 0-1.38.58A3 3 0 0 0 6 17h8a3 3 0 0 0 2.81-1.96.75.75 0 0 0-1.38-.58l-.03.08a1.5 1.5 0 0 1-1.4.96m1.5-4.25a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-1.5 0z"
]);
const $90f21c32649fad68$export$5b132b414f799590 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__a)",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__b)",
            "fillOpacity": ".7",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__c)",
            "fillOpacity": ".4",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_20_color__d)",
            "d": "M7 3.5C7 4.33 7.67 5 8.5 5h3a1.5 1.5 0 0 0 0-3h-3C7.67 2 7 2.67 7 3.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.14077 -4.64062 0 10 2.17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.30574 -3.67969 0 10 3.74)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_20_color__a",
                "x1": "4",
                "x2": "16",
                "y1": "4.51",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_20_color__d",
                "x1": "10",
                "x2": "10",
                "y1": "2",
                "y2": "5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$f920cfe7647bdc97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$5ffd6ec88d168b35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $90f21c32649fad68$export$31bfc130fb1cc518 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3DayFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-1 10v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0m5.5.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5m-3-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0"
]);
const $90f21c32649fad68$export$9145e74ed5340d4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Clipboard3DayRegular', "1em", [
    "M7 14.5a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-1 0zm5.5.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5m-3-.5a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-1 0zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$e285425aa06743f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRightFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $90f21c32649fad68$export$805337d9d23faa7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardArrowRightRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $90f21c32649fad68$export$530459f26db9850d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrushFilled', "1em", [
    "M17.44 7.58c.39-.1.92-.16 1.28.2s.3.9.2 1.28a6 6 0 0 1-.68 1.47 20 20 0 0 1-2.94 3.62c-.36.36-.9.9-1.5 1.18a2 2 0 0 1-.85.2 2.5 2.5 0 0 1-.68 2.23l-.15.16a4.02 4.02 0 0 1-6.01-.61.5.5 0 0 1 .25-.79c1.07-.31 1.38-.65 1.55-.92.11-.18.16-.33.29-.59q.15-.36.53-.77a2.5 2.5 0 0 1 2.25-.7q0-.45.19-.84c.28-.6.82-1.14 1.18-1.5a20 20 0 0 1 3.62-2.94 6 6 0 0 1 1.47-.68M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.6l-.55.3c-1.16.7-2.52 1.8-3.81 3.1-.33.32-1.02.98-1.38 1.8l-.1.22c-.7.07-1.4.35-1.97.86l-.16.15a4 4 0 0 0-.73 1.05c-.1.21-.18.5-.38.64-.13.08-.37.2-.85.35-.47.14-.85.5-1 .97-.15.48-.06 1 .25 1.39l.05.06A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm.06 12.94a1.5 1.5 0 0 0-2.12 0q-.22.23-.34.5c-.08.17-.2.45-.34.68-.26.42-.65.79-1.37 1.1a3 3 0 0 0 4.16-.15h.01a1.5 1.5 0 0 0 0-2.13M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$e4e71cbf5de6c741 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBrushRegular', "1em", [
    "M17.44 7.58c.39-.1.92-.16 1.28.2s.3.9.2 1.28a6 6 0 0 1-.68 1.47 20 20 0 0 1-2.94 3.62c-.36.36-.9.9-1.5 1.18a2 2 0 0 1-.85.2 2.5 2.5 0 0 1-.68 2.23l-.15.16a4.02 4.02 0 0 1-6.01-.61.5.5 0 0 1 .25-.79c1.07-.31 1.38-.65 1.55-.92.11-.18.16-.33.29-.59q.15-.36.53-.77a2.5 2.5 0 0 1 2.25-.7q0-.45.19-.84c.28-.6.82-1.14 1.18-1.5a20 20 0 0 1 3.62-2.94 6 6 0 0 1 1.47-.68M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.6a10 10 0 0 0-1 .59V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H5.5a.5.5 0 0 0-.5.5V17q0 .51.32.93l.05.06A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm.06 12.94a1.5 1.5 0 0 0-2.12 0q-.22.23-.34.5c-.08.17-.2.45-.34.68-.26.42-.65.79-1.37 1.1a3 3 0 0 0 4.16-.15h.01a1.5 1.5 0 0 0 0-2.13M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$4cee89d07cf2f8d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListFilled', "1em", [
    "M7.09 3H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1M8.5 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
], {
    flipInRtl: true
});
const $90f21c32649fad68$export$bf930672a9d792e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRegular', "1em", [
    "M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
], {
    flipInRtl: true
});
const $90f21c32649fad68$export$a4830f5dbbbb6239 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListLtrFilled', "1em", [
    "M7.09 3H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1M8.5 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $90f21c32649fad68$export$3598f5d702b2e977 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListLtrRegular', "1em", [
    "M9 8.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m-1-6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $90f21c32649fad68$export$79ba0186c10068d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRtlFilled', "1em", [
    "M8.5 2h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59c.2-.58.76-1 1.41-1M8 3.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5m4.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M12 14.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1-6a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5"
]);
const $90f21c32649fad68$export$1625906733ef1830 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardBulletListRtlRegular', "1em", [
    "M12.75 9.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m0 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M12 14.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-1-6a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$c772683324217d7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmptyFilled', "1em", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.52a6.5 6.5 0 0 0-9.39 8.22l-.55 1.83q-.13.47.03.93H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 4a5.5 5.5 0 1 1-2.65 10.32l-2.2.66a.5.5 0 0 1-.63-.62l.66-2.21A5.5 5.5 0 0 1 12.5 7"
]);
const $90f21c32649fad68$export$417903b6604ef357 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardChatEmptyRegular', "1em", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v2.52q-.48-.3-1-.52v-2a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h.58l-.02.07q-.13.47.03.93H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm4 4a5.5 5.5 0 1 1-2.65 10.32l-2.2.66a.5.5 0 0 1-.63-.62l.66-2.21A5.5 5.5 0 0 1 12.5 7m0 1a4.5 4.5 0 0 0-3.85 6.83q.11.2.05.4l-.45 1.52 1.51-.45.1-.02q.17-.02.3.07 1.05.63 2.34.65a4.5 4.5 0 1 0 0-9"
]);
const $90f21c32649fad68$export$b7e343f59baa29b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmarkFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$a294ef50ba1bf946 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCheckmarkRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$a509ea16022776e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardClockFilled', "1em", [
    "M10.5 9.5a.5.5 0 0 0-1 0V11c0 .28.22.5.5.5h1.5a.5.5 0 0 0 0-1h-1zM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.5 8a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
]);
const $90f21c32649fad68$export$cd5e99cef41aa297 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardClockRegular', "1em", [
    "M10.5 9.5a.5.5 0 0 0-1 0V11c0 .28.22.5.5.5h1.5a.5.5 0 0 0 0-1h-1zM10 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $90f21c32649fad68$export$182c1109a8879919 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCodeFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.88a1.5 1.5 0 0 0-2.44.71l-.4 1.41h-.74a1.5 1.5 0 0 0-2.55-.48l-1.5 1.75a1.5 1.5 0 0 0 0 1.95l1.5 1.75c.29.35.7.53 1.13.53H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm2.88 10.32a.5.5 0 1 0-.76-.65l-1.5 1.75a.5.5 0 0 0 0 .65l1.5 1.75a.5.5 0 0 0 .7.06.5.5 0 0 0 .06-.71l-1.22-1.42zm4.1-1.68a.5.5 0 1 0-.96-.28l-2 7a.5.5 0 1 0 .97.28zm1.2 5.24a.5.5 0 0 1-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 0 1 .76-.65l1.5 1.75a.5.5 0 0 1 0 .65l-1.5 1.75a.5.5 0 0 1-.7.06"
]);
const $90f21c32649fad68$export$e7c5067d74ebc51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardCodeRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.88a1.5 1.5 0 0 0-1-.38V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.96l.4.47c.3.35.72.53 1.14.53H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm6.99 8.64a.5.5 0 1 0-.97-.28l-2 7a.5.5 0 1 0 .97.28zm-4.11 1.68a.5.5 0 1 0-.76-.65l-1.5 1.75a.5.5 0 0 0 0 .65l1.5 1.75a.5.5 0 1 0 .76-.65l-1.22-1.42zm5.3 3.56a.5.5 0 0 1-.06-.71l1.22-1.42-1.22-1.43a.5.5 0 0 1 .76-.65l1.5 1.75a.5.5 0 0 1 0 .65l-1.5 1.75a.5.5 0 0 1-.7.06"
]);
const $90f21c32649fad68$export$9cc4b5a8503a325 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBarFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m5 8.5v2.5a.5.5 0 0 1-1 0V12a.5.5 0 0 1 1 0m-3-3c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M8 7.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
]);
const $90f21c32649fad68$export$c0ff23c23edcdd02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDataBarRegular', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5m7.5 8a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0zm-3-3c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M8 7.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$ae1e01f5a201d406 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDayFilled', "1em", [
    "M8 11h4v3H8zm-.91-8c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 7.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5M7 11v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1"
]);
const $90f21c32649fad68$export$b95430f7f8c51898 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardDayRegular', "1em", [
    "M7 7.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M7 11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zm1 0v3h4v-3zm-.91-8c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $90f21c32649fad68$export$634abecec0b53f88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardEditFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H8l.06-.35.37-1.5a3 3 0 0 1 .84-1.48l4.83-4.83c.53-.53 1.21-.8 1.9-.84V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m1.98 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $90f21c32649fad68$export$e6155b7aeaf3a01d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardEditRegular', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H8l.06-.35.16-.65H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.73q.49-.2 1-.23V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m1.98 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $90f21c32649fad68$export$1e510449492dfb39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardErrorFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $90f21c32649fad68$export$813f71159986e7f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardErrorRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $90f21c32649fad68$export$8e59bfda05887432 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardHeartFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9c-.7.03-1.4.25-2 .66a3.85 3.85 0 0 0-4.87 5.91L11.55 18H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.15 15.68a.5.5 0 0 0 .7 0l3.82-3.81a2.85 2.85 0 1 0-4.03-4.04l-.14.14-.13-.14a2.85 2.85 0 1 0-4.04 4.04z"
]);
const $90f21c32649fad68$export$adda3ba206cc971c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardHeartRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9q-.5.02-1 .18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h5.05l1 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.33 7.83a2.85 2.85 0 0 1 4.04 0l.13.14.14-.14a2.85 2.85 0 0 1 4.03 4.04l-3.81 3.81a.5.5 0 0 1-.71 0l-3.82-3.81a2.85 2.85 0 0 1 0-4.04"
]);
const $90f21c32649fad68$export$d38194af38379694 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardImageFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9h-3.5A3.5 3.5 0 0 0 9 12.5v4q0 .82.34 1.5H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.5 9.5a2.5 2.5 0 0 1 2.5-2.5h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0l-3.03 3.03q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $90f21c32649fad68$export$81b3296cb36a83c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardImageRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V9h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.54q.08.53.3 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.5 9.5a2.5 2.5 0 0 1 2.5-2.5h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0l-3.03 3.03q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $90f21c32649fad68$export$dbe27666e3748577 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetterFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.59a1.5 1.5 0 0 1 .04-1.1l3.5-8a1.5 1.5 0 0 1 2.74 0l.63 1.44V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm2.95 6.3a.5.5 0 0 0-.91 0l-3.5 8a.5.5 0 1 0 .92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 0 0 .92-.4zm.97 4.7h-2.84L14 10.75z"
]);
const $90f21c32649fad68$export$4840dcebd1f2c060 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLetterRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.84l-.63-1.44a2 2 0 0 0-.37-.51V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.59a1.5 1.5 0 0 0 0 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.95 6.3a.5.5 0 0 0-.91 0l-3.5 8a.5.5 0 0 0 .92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 0 0 .92-.4zm.97 4.7h-2.85L14 10.75z"
]);
const $90f21c32649fad68$export$2e0e10ef154eef8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLinkFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-3.5a4.5 4.5 0 0 0-3.74 7H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 15.5a3.5 3.5 0 0 0-3.5-3.5h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5m-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5m2.5 2.5h-3.09a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1"
]);
const $90f21c32649fad68$export$8ecfd459caaff771 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardLinkRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h2.76q.19.54.5 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM19 15.5a3.5 3.5 0 0 0-3.5-3.5h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5m-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5m2.5 2.5h-3.09a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1"
]);
const $90f21c32649fad68$export$9f57034467bce731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdownFilled', "1em", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v6.59c-.58.2-1 .76-1 1.41v1.59a1.5 1.5 0 0 0-1 0V12.5a1.5 1.5 0 0 0-2.84-.67L10 14.15l-1.16-2.32A1.5 1.5 0 0 0 6 12.5v5q0 .27.09.5H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm1.12 10.01a.5.5 0 0 1 .38.49v5a.5.5 0 0 1-1 0v-2.88l-1.55 3.1a.5.5 0 0 1-.9 0L8 14.62v2.88a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .95-.22l2.05 4.1 2.05-4.1a.5.5 0 0 1 .57-.27M16.5 12c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L16 16.29V12.5c0-.28.22-.5.5-.5m-8-9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$83d53a8aba26d63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMarkdownRegular', "1em", [
    "M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v6.59c-.58.2-1 .76-1 1.41v-8a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5H6v.5q0 .27.09.5H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm1.12 10.01a.5.5 0 0 1 .38.49v5a.5.5 0 0 1-1 0v-2.88l-1.55 3.1a.5.5 0 0 1-.9 0L8 14.62v2.88a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .95-.22l2.05 4.1.03-.06 2.02-4.04a.5.5 0 0 1 .57-.27M16.5 12c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L16 16.29V12.5c0-.28.22-.5.5-.5m-8-9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$cd8bff0b7d90cf17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormulaFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.65a1.5 1.5 0 0 1 1.92-2.05L11.2 14a1.5 1.5 0 0 1 .22-2.98l.02-.32a2.92 2.92 0 0 1 4.23-2.38q.18.09.32.21V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.45 7.28a1.92 1.92 0 0 1 2.78-1.57.5.5 0 0 1-.45.9.92.92 0 0 0-1.33.74l-.09 1.17h1.14a.5.5 0 1 1 0 1h-1.21l-.24 3.2a1.92 1.92 0 0 1-2.78 1.57.5.5 0 1 1 .46-.9.92.92 0 0 0 1.32-.74l.24-3.13h-.79a.5.5 0 0 1 0-1h.86zm5.4 4.07a.5.5 0 0 0-.7-.7l-1.06 1.05-.46-.73a1 1 0 0 0-1.42-.28.5.5 0 0 0 .58.81l.57.93-1.21 1.22a.5.5 0 0 0 .7.7l1.06-1.05.45.74c.31.5.98.61 1.44.26a.5.5 0 0 0-.6-.8l-.57-.92z"
]);
const $90f21c32649fad68$export$2f69682868ca2ef4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMathFormulaRegular', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.65a1.5 1.5 0 0 1-.11-1H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v3.57q.35.07.68.25.18.09.32.21V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.45 7.28a1.92 1.92 0 0 1 2.78-1.57.5.5 0 0 1-.45.9.92.92 0 0 0-1.33.74l-.09 1.17h1.14a.5.5 0 1 1 0 1h-1.21l-.24 3.2a1.92 1.92 0 0 1-2.78 1.57.5.5 0 1 1 .46-.9.92.92 0 0 0 1.32-.74l.24-3.13h-.79a.5.5 0 0 1 0-1h.86zm5.4 4.07a.5.5 0 0 0-.7-.7l-1.06 1.05-.46-.73a1 1 0 0 0-1.42-.28.5.5 0 0 0 .58.81l.57.93-1.21 1.22a.5.5 0 0 0 .7.7l1.06-1.05.45.74c.31.5.98.61 1.44.26a.5.5 0 0 0-.6-.8l-.57-.92z"
]);
const $90f21c32649fad68$export$936338fa31127d75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonthFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M7 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$288f6342bff0645c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMonthRegular', "1em", [
    "M7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$4dea771c2b17acf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMoreFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48q-.66.34-1 .99a2.25 2.25 0 0 0-4 0A2.25 2.25 0 0 0 6.98 18H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.75 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $90f21c32649fad68$export$1fe13d929bb83468 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardMoreRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48q-.66.34-1 .99V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h1.25q0 .54.23 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1.75 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $90f21c32649fad68$export$8e4899a5cea5771a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNoteFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-4a3 3 0 0 0-3 3v4a3 3 0 0 0 .17 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.5 8a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m0-3c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$fde8ba22174f7214 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNoteRegular', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.84a4 4 0 0 1-.3-1H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5V10h1V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4 7.5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m0-3c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$3aafa9ecf2741ab2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber123Filled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h1.59a2 2 0 0 1-.09-.5v-2a1.5 1.5 0 0 1-.73-2.81c.27-.15.5-.46.66-.79.47-.96 1.46-.92 1.76-.86a1.6 1.6 0 0 1 1.12.81q.9-.76 2.01-.85a3 3 0 0 1 2.6 1.22q.7-.76 1.58-1.05V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m7.87 10.1c.42-.46.84-.6 1.16-.6.35 0 .64.15.81.35q.25.31.12.55c-.07.17-.33.44-1.07.61a.5.5 0 0 0 0 .98c.74.17 1 .44 1.07.61q.12.25-.12.55c-.17.2-.46.35-.8.35-.33 0-.75-.14-1.17-.6a.5.5 0 0 0-.74.66c.58.65 1.26.94 1.9.94s1.2-.28 1.57-.7a1.5 1.5 0 0 0-.32-2.3q.4-.29.6-.69a1.5 1.5 0 0 0-.28-1.61c-.36-.42-.93-.7-1.56-.7-.65 0-1.33.29-1.91.94a.5.5 0 0 0 .74.67m-3.94-.6c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29M9 12.6c0-.2-.1-.35-.2-.44a1 1 0 0 0-.3-.14c-.13-.03-.5-.03-.67.32-.2.41-.54.93-1.07 1.22a.5.5 0 1 0 .48.88q.45-.26.76-.6v3.66a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$61cec99361d04bf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardNumber123Regular', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h1.59a2 2 0 0 1-.09-.5V17H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v7.2a4 4 0 0 1 1-.53V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m2 14.05v-.12l.03-.23q.05-.27.28-.69a6 6 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.8.8 0 0 0-.28-.64q-.32-.3-.78-.29c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65q.83-.9 1.76-.95c.6-.03 1.14.2 1.52.57s.63.88.59 1.43c-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45m5.87-3.94c.42-.47.84-.61 1.16-.61.35 0 .64.15.81.35q.25.31.12.55c-.07.17-.33.44-1.07.61a.5.5 0 0 0 0 .98c.74.17 1 .44 1.07.61q.12.25-.12.55c-.17.2-.46.35-.8.35-.33 0-.75-.14-1.17-.6a.5.5 0 0 0-.74.66c.58.65 1.26.94 1.9.94s1.2-.28 1.57-.7a1.5 1.5 0 0 0-.32-2.3q.4-.29.6-.69a1.5 1.5 0 0 0-.28-1.61c-.36-.42-.93-.7-1.56-.7-.65 0-1.33.29-1.91.94a.5.5 0 0 0 .74.67M9 12.6c0-.2-.1-.35-.2-.44a1 1 0 0 0-.3-.14c-.13-.03-.5-.03-.67.32-.2.41-.54.93-1.07 1.22a.5.5 0 1 0 .48.88q.45-.26.76-.6v3.66a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$a967872a10ed5ee4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 14.5 18h-9A1.5 1.5 0 0 1 4 16.5V4.7L2.15 2.86a.5.5 0 0 1 0-.7M11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v9.38L5.16 3.04Q5.31 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$b8a99774669c0a84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 14.5 18h-9A1.5 1.5 0 0 1 4 16.5V4.7L2.15 2.86a.5.5 0 0 1 0-.7M5 16.5c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-.8L5 5.7zM11.5 2c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v9.38l-1-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.42-1h-.96l-.96-.96Q5.32 3 5.5 3h1.58c.21-.58.77-1 1.42-1zm-3 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$e2304c72e83a72fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPasteFilled', "1em", [
    "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5m3 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5z"
]);
const $90f21c32649fad68$export$de454923cb56b22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPasteRegular', "1em", [
    "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5m3 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zM10 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"
]);
const $90f21c32649fad68$export$2f227512487cb713 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPulseFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1.57l-.59-1.17a1.5 1.5 0 0 0-2.68 0l-.33.65-.9-2.92a1.5 1.5 0 0 0-2.8-.17L5.53 10H4V4.5C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5 10H16v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h2.5c.6 0 1.13-.35 1.37-.9l.37-.83.83 2.67a1.5 1.5 0 0 0 2.77.23l.74-1.48q.4.3.92.31M8.98 6.85a.5.5 0 0 0-.94-.05L6.18 11H2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .46-.3L8.4 8.42l1.61 5.23a.5.5 0 0 0 .93.07l1.55-3.1.55 1.1a.5.5 0 0 0 .45.28h4a.5.5 0 0 0 0-1h-3.7l-.85-1.72a.5.5 0 0 0-.9 0l-1.44 2.88z"
]);
const $90f21c32649fad68$export$746f11125c0f10ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardPulseRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5V10H4V4.5C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM15 13h1v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h1v3.5c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5zM8.98 6.85a.5.5 0 0 0-.94-.05L6.18 11H2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .46-.3L8.4 8.42l1.61 5.23a.5.5 0 0 0 .93.07l1.55-3.1.55 1.1a.5.5 0 0 0 .45.28h4a.5.5 0 0 0 0-1h-3.7l-.85-1.72a.5.5 0 0 0-.9 0l-1.44 2.88z"
]);
const $90f21c32649fad68$export$b6d014ff171569a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSearchFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76a4.5 4.5 0 0 1 5.56 6.18l2 2c.42.42.54 1.03.35 1.56h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM8.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $90f21c32649fad68$export$cc7f062494bdcaf6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSearchRegular', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76q.48-.18 1-.23V4.5c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-2.59q.18.5 0 1h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM8.3 14.6q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $90f21c32649fad68$export$2b4c6f5b78dc432d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSettingsFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.57 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$9513572c0886e366 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardSettingsRegular', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7q-.49-.13-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm3.57 8.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$e004d79f0cda62ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__a)",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__b)",
            "fillOpacity": ".7",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__c)",
            "fillOpacity": ".4",
            "d": "M4 4.5C4 3.69 4.67 3 5.5 3h9c.83 0 1.5.68 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__d)",
            "d": "M7 3.5C7 4.33 7.67 5 8.5 5h3a1.5 1.5 0 0 0 0-3h-3C7.67 2 7 2.67 7 3.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_task_20_color__e)",
            "fillOpacity": ".9",
            "d": "M12.85 9.85a.5.5 0 0 0-.7-.7L9 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__a",
                "x1": "4",
                "x2": "16",
                "y1": "4.51",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__d",
                "x1": "10",
                "x2": "10",
                "y1": "2",
                "y2": "5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffe06b"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fab500"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__e",
                "x1": "15",
                "x2": "7.55",
                "y1": "16.5",
                "y2": "5.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 5.14077 -4.64062 0 10 2.17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_task_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 2.30574 -3.67969 0 10 3.74)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$211a512e85339378 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 6.35-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L9 12.29l3.15-3.14a.5.5 0 0 1 .7.7"
]);
const $90f21c32649fad68$export$a494d4c5fa74385a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskRegular', "1em", [
    "M12.85 9.85a.5.5 0 0 0-.7-.7L9 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$4cf5073a9b9edd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskAddFilled', "1em", [
    "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76A5.5 5.5 0 0 1 14 9.02V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 6.35-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L7 12.29l3.15-3.14a.5.5 0 0 1 .7.7M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$b4ec1988782b745f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskAddRegular', "1em", [
    "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76a6 6 0 0 1-.66-1H3.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.7q.49-.13 1-.18V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m4.85 6.35a.5.5 0 0 0-.7-.7L7 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$ceb8dec89cc98022 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListLtrFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m1.35 4.35L7.6 9.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 1 1 .68-.73l.4.36 1.4-1.41a.5.5 0 1 1 .71.7m0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0m1.65.6h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1 0-1m-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$bdb0a560be8a7b08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListLtrRegular', "1em", [
    "M9.35 7.85a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02zm0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0m1.65.6a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$d8326950fe26459 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListRtlFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm5.35 4.15a.5.5 0 0 0-.7 0l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 0 0 0-.7m0 5.7a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02zM6.5 8a.5.5 0 0 0 0 1H9a.5.5 0 0 0 0-1zM6 13.5c0 .28.22.5.5.5H9a.5.5 0 0 0 0-1H6.5a.5.5 0 0 0-.5.5"
]);
const $90f21c32649fad68$export$fba078299f06ff6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTaskListRtlRegular', "1em", [
    "M13.85 7.15c.2.2.2.5 0 .7L12.1 9.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0m0 5.7a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02zM6.5 8a.5.5 0 0 0 0 1H9a.5.5 0 0 0 0-1zM6 13.5c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H6.5a.5.5 0 0 1-.5-.5M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $90f21c32649fad68$export$7d6a1f3a8e8154aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEditColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__a)",
            "d": "M5.5 3C4.67 3 4 3.69 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.57L16 13.44V4.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__b)",
            "fillOpacity": ".9",
            "d": "M6 8.5c0-.27.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__c)",
            "fillOpacity": ".9",
            "d": "M6 14.5c0-.27.22-.5.5-.5h7a.5.5 0 1 1 0 1h-7a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__d)",
            "fillOpacity": ".9",
            "d": "M6.5 11a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__e)",
            "fillOpacity": ".5",
            "d": "M5.5 3C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.57L16 13.42V4.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__f)",
            "fillOpacity": ".4",
            "d": "M5.5 3C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.57L16 13.42V4.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__g)",
            "d": "M7 3.5C7 4.33 7.67 5 8.5 5h3a1.5 1.5 0 0 0 0-3h-3C7.67 2 7 2.67 7 3.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__h)",
            "d": "M14.35 12H17v2.65l-3.37 3.37a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__i)",
            "d": "M13.49 18.14a2 2 0 0 1-.89.46l-1.5.37a.9.9 0 0 1-1.07-1.08l.37-1.5q.12-.47.44-.86a3.5 3.5 0 0 0 2.65 2.61"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__j)",
            "d": "m14.54 11.82 1.27-1.27a1.87 1.87 0 1 1 2.64 2.64l-1.17 1.18z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_clipboard_text_edit_20_color__k)",
            "d": "M18 13.65A3.5 3.5 0 0 1 15.34 11l-1 1A3.5 3.5 0 0 0 17 14.65z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__a",
                "x1": "4",
                "x2": "16",
                "y1": "4.51",
                "y2": "18.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0094f0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__b",
                "x1": "11",
                "x2": "6",
                "y1": "15.01",
                "y2": "8.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__c",
                "x1": "11",
                "x2": "6",
                "y1": "15.01",
                "y2": "8.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__d",
                "x1": "11",
                "x2": "6",
                "y1": "15.01",
                "y2": "8.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__g",
                "x1": "10",
                "x2": "10",
                "y1": "5",
                "y2": "2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fab500"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe06b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__h",
                "x1": "11.85",
                "x2": "15.29",
                "y1": "13.72",
                "y2": "17.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__i",
                "x1": "9.5",
                "x2": "12",
                "y1": "16.5",
                "y2": "18.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__j",
                "x1": "18.07",
                "x2": "16.46",
                "y1": "10.91",
                "y2": "12.46",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__k",
                "x1": "16.24",
                "x2": "13.66",
                "y1": "13.5",
                "y2": "12.36",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.5 0 0 4.88692 9.5 2.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_clipboard_text_edit_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(133.96 4.12 9.92)scale(8.10361 3.02694)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$c2c228289f59f48c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEditFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.73q-.5.2-.9.61L10.94 14H6.5a.5.5 0 0 0 0 1h3.49a3 3 0 0 0-.56 1.16l-.37 1.5q-.04.17-.06.34H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5M13.5 8h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1M10 11.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m.98 3.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $90f21c32649fad68$export$241152c10b2e9221 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextEditRegular', "1em", [
    "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 14.5c0-.28.22-.5.5-.5h4.44l-.67.67q-.15.15-.28.33H6.5a.5.5 0 0 1-.5-.5M9.22 17H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v5.44l.1-.1q.4-.4.9-.6V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H9l.06-.35zM12 3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3c.28 0 .5.22.5.5m-1.02 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $90f21c32649fad68$export$121c7f0ea6fb43b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtrFilled', "1em", [
    "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-5 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1m0 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M6 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$9f529ed372f8dff6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextLtrRegular', "1em", [
    "M6.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 11.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2-12c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-6 1h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$1059cfdb23e93c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtlFilled', "1em", [
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5M10.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 8.5c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M8.5 14a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$b23f82ca0f9252e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ClipboardTextRtlRegular', "1em", [
    "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5",
    "M10.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    "M8.5 14a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z",
    "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5M7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1"
]);
const $90f21c32649fad68$export$ef5ba407dcc31020 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteFilled', "1em", [
    "M8.5 4h3a1.5 1.5 0 0 0-3 0m-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM9 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zm2.5-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$b477a0750a53667c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteRegular', "1em", [
    "M8.5 4h3a1.5 1.5 0 0 0-3 0m-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM5.74 15.23A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77L15.44 5H4.56zM8.5 7.5c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5M12 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$b7275253bb8e36c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteArrowBackFilled', "1em", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.5 5.5 0 0 0-5.7 8.8H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm7 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $90f21c32649fad68$export$d94392e7589a6461 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteArrowBackRegular', "1em", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a6 6 0 0 0-.98-.18L15.44 5H4.56l1.18 10.23A2 2 0 0 0 7.73 17H9.6q.27.54.66 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm7 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $90f21c32649fad68$export$f63d62c27b5af913 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismissFilled', "1em", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.5 5.5 0 0 0-5.7 8.8H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $90f21c32649fad68$export$85e20d699ee676b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteDismissRegular', "1em", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a6 6 0 0 0-.98-.18L15.44 5H4.56l1.18 10.23A2 2 0 0 0 7.73 17H9.6q.27.54.66 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $90f21c32649fad68$export$9e049bd5bb4e6908 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteLinesFilled', "1em", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.81 7H11.5a1.5 1.5 0 0 0-1.12 2.5 1.5 1.5 0 0 0 0 2 1.5 1.5 0 0 0-.3 1.5H7.74a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$10d4e5bab10154cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteLinesRegular', "1em", [
    "M11.5 4a1.5 1.5 0 0 0-3 0zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.81 7h-1l.8-7H4.56l1.18 10.23A2 2 0 0 0 7.73 17h2.36a1.5 1.5 0 0 0 0 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$4615c6f2d2657eff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteOffFilled', "1em", [
    "M3.3 4 2.14 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2-2A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm8.7 8.7-1-1V14a.5.5 0 0 0 1 0zm-3-3-1-1V14a.5.5 0 0 0 1 0zM12 8v1.88l3.48 3.48.97-8.36h1.05a.5.5 0 0 0 0-1h-5a2.5 2.5 0 0 0-5 0H6.12L11 8.88V8a.5.5 0 0 1 1 0m-.5-4h-3a1.5 1.5 0 1 1 3 0"
]);
const $90f21c32649fad68$export$5663660bb2f573f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeleteOffRegular', "1em", [
    "M3.3 4 2.14 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2-2A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1zm10.99 11L12 12.7V14a.5.5 0 0 1-1 0v-2.3l-2-2V14a.5.5 0 0 1-1 0V8.7L4.6 5.3l1.14 9.93A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77zM11 8.87l1 1V8a.5.5 0 0 0-1 0zM15.44 5l-.86 7.46.9.9.97-8.36h1.05a.5.5 0 0 0 0-1h-5a2.5 2.5 0 0 0-5 0H6.12l1 1zM11.5 4h-3a1.5 1.5 0 1 1 3 0"
]);
const $90f21c32649fad68$export$f24541754ac03173 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardFilled', "1em", [
    "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zm5 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
]);
const $90f21c32649fad68$export$4d42bd520b151e6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardRegular', "1em", [
    "M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-2 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.5-8c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 0 1 1 0V4H12V2.5a.5.5 0 0 1 1 0V4h.5A2.5 2.5 0 0 1 16 6.5V7h1.5a.5.5 0 0 1 0 1H16v1.5h1.5a.5.5 0 0 1 0 1H16V12h1.5a.5.5 0 0 1 0 1H16v.5a2.5 2.5 0 0 1-2.5 2.5H13v1.5a.5.5 0 0 1-1 0V16h-1.5v1.5a.5.5 0 0 1-1 0V16H8v1.5a.5.5 0 0 1-1 0V16h-.5A2.5 2.5 0 0 1 4 13.5V13H2.5a.5.5 0 0 1 0-1H4v-1.5H2.5a.5.5 0 0 1 0-1H4V8H2.5a.5.5 0 0 1 0-1H4v-.5A2.5 2.5 0 0 1 6.5 4H7V2.5c0-.28.22-.5.5-.5M15 6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5z"
]);
const $90f21c32649fad68$export$ba40cba3ac0eba08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightningFilled', "1em", [
    "M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zm2.99 5.04L10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39"
]);
const $90f21c32649fad68$export$7537a151a964055d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightningRegular', "1em", [
    "M10.99 7.54 10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zM13.5 5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 13.5v-7C5 5.67 5.67 5 6.5 5z"
]);
const $90f21c32649fad68$export$40a02f0931b461b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightningToolboxFilled', "1em", [
    "M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1v-2.5q0-.34.09-.67a.4.4 0 0 1-.07-.37L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39L10.57 9h1.53q.26.02.36.23Q12.94 9 13.5 9h2q.26 0 .5.05V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8zm4 9.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $90f21c32649fad68$export$59309aa7fa07f992 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardLightningToolboxRegular', "1em", [
    "M7.5 2c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 0 1 1 0V4H12V2.5a.5.5 0 0 1 1 0V4h.5A2.5 2.5 0 0 1 16 6.5V7h1.5a.5.5 0 0 1 0 1H16v1.05a3 3 0 0 0-.5-.05H15V6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H9v1H8v1.5a.5.5 0 0 1-1 0V16h-.5A2.5 2.5 0 0 1 4 13.5V13H2.5a.5.5 0 0 1 0-1H4v-1.5H2.5a.5.5 0 0 1 0-1H4V8H2.5a.5.5 0 0 1 0-1H4v-.5A2.5 2.5 0 0 1 6.5 4H7V2.5c0-.28.22-.5.5-.5m3.54 9.04a2.5 2.5 0 0 1 1.42-1.81.4.4 0 0 0-.36-.23h-1.53l.42-1.46c.12-.44-.44-.73-.73-.39l-2.67 3.2a.4.4 0 0 0 .3.65h1.57l-.44 1.46a.4.4 0 0 0 .07.37 2.5 2.5 0 0 1 1.95-1.79M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $90f21c32649fad68$export$17144eb465d47aef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardSearchFilled', "1em", [
    "M13 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8.5 1c.28 0 .5.22.5.5V3h1.5V1.5a.5.5 0 0 1 1 0V3H13V1.5a.5.5 0 0 1 1 0V3h.5A2.5 2.5 0 0 1 17 5.5V6h1.5a.5.5 0 0 1 0 1H17v1.5h1.5a.5.5 0 0 1 0 1H17V11h1.5a.5.5 0 0 1 0 1H17v.5a2.5 2.5 0 0 1-2.5 2.5H14v1.5a.5.5 0 0 1-1 0V15h-1.5v1.5a.5.5 0 0 1-1 0V15H8.74a4.5 4.5 0 0 0-5.68-5.76.5.5 0 0 1 .44-.74H5V7H3.5a.5.5 0 0 1 0-1H5v-.5A2.5 2.5 0 0 1 7.5 3H8V1.5c0-.28.22-.5.5-.5M11 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-6.5 5q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 0 0 .7-.7L7.3 15.6q.68-.9.7-2.1A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $90f21c32649fad68$export$153ab00a85739a8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeveloperBoardSearchRegular', "1em", [
    "M8 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M9 1.5a.5.5 0 0 0-1 0V3h-.5A2.5 2.5 0 0 0 5 5.5V6H3.5a.5.5 0 0 0 0 1H5v1.5H3.5a.5.5 0 0 0-.44.74A4.5 4.5 0 0 1 6 9.26V5.5C6 4.67 6.67 4 7.5 4h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H8.97q-.05.52-.23 1h1.76v1.5a.5.5 0 0 0 1 0V15H13v1.5a.5.5 0 0 0 1 0V15h.5a2.5 2.5 0 0 0 2.5-2.5V12h1.5a.5.5 0 0 0 0-1H17V9.5h1.5a.5.5 0 0 0 0-1H17V7h1.5a.5.5 0 0 0 0-1H17v-.5A2.5 2.5 0 0 0 14.5 3H14V1.5a.5.5 0 0 0-1 0V3h-1.5V1.5a.5.5 0 0 0-1 0V3H9zM4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 0 0 .7-.7L7.3 15.6q.68-.9.7-2.1A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $90f21c32649fad68$export$750e594fdcbd051f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEqFilled', "1em", [
    "M10 2c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75m3.75 3c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75M7 5.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0zM17.25 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75M3.5 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z"
]);
const $90f21c32649fad68$export$689f3a419ddea7df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceEqRegular', "1em", [
    "M10 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5m3.5 3c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5M7 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0zM16.5 8c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5M4 8.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$78d5156a4e17e58d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomFilled', "1em", [
    "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H4.5a2.5 2.5 0 0 1-2.43-3.05zM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 1 0 0-1z"
]);
const $90f21c32649fad68$export$35185c36710ab241 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRegular', "1em", [
    "M6.1 3a2.5 2.5 0 0 0-2.44 1.95l-1.6 7A2.5 2.5 0 0 0 4.5 15h11a2.5 2.5 0 0 0 2.43-3.05l-1.59-7A2.5 2.5 0 0 0 13.9 3zM4.63 5.17A1.5 1.5 0 0 1 6.1 4h7.8c.7 0 1.31.48 1.47 1.17l1.59 7A1.5 1.5 0 0 1 15.49 14H4.5a1.5 1.5 0 0 1-1.46-1.83zM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 1 0 0-1z"
]);
const $90f21c32649fad68$export$252b23fc48a92c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOneFilled', "1em", [
    "M17 14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-1h14zM14 3a3 3 0 0 1 3 3v6H3V6a3 3 0 0 1 3-3zm-4 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $90f21c32649fad68$export$ad05e0e6aa342f80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomAllInOneRegular', "1em", [
    "M10 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4-3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM4 14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1H4zM6 4a2 2 0 0 0-2 2v6h12V6a2 2 0 0 0-2-2z"
]);
const $90f21c32649fad68$export$3503c1be44d3c67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBarFilled', "1em", [
    "M13 14a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm2-10a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm-5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-5 .75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $90f21c32649fad68$export$7430902322bc26f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomBarRegular', "1em", [
    "M13 14a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm2-10a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM5 5a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-4.5.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $90f21c32649fad68$export$1573bb59b3c52807 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneAboveFilled', "1em", [
    "M6.11 17.11a5.5 5.5 0 0 1 7.78 0 .5.5 0 0 1-.7.7 4.5 4.5 0 0 0-6.37 0 .5.5 0 0 1-.7-.7m-1.77-1.77a8 8 0 0 1 11.32 0 .5.5 0 0 1-.71.71 7 7 0 0 0-9.9 0 .5.5 0 1 1-.7-.7M10 5c2.01 0 3.81.38 5.1.98C16.4 6.59 17 7.34 17 8v.14c-.08.62-.68 1.3-1.9 1.88-1.29.6-3.09.98-5.1.98s-3.81-.38-5.1-.98C3.69 9.45 3.09 8.76 3 8.14V8c0-.66.59-1.4 1.9-2.02A12 12 0 0 1 10 5m0-3c1.84 0 3.53.29 4.78.77q.94.35 1.55.89c.39.35.67.8.67 1.34v1.03q-.62-.57-1.49-.96A13 13 0 0 0 10 4c-2.13 0-4.08.4-5.51 1.07q-.86.39-1.49.96V5c0-.53.28-.99.67-1.34q.61-.54 1.55-.9C6.47 2.3 8.16 2 10 2"
]);
const $90f21c32649fad68$export$f56cb3c4c7de2c29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneAboveRegular', "1em", [
    "M6.11 17.11a5.5 5.5 0 0 1 7.78 0 .5.5 0 0 1-.7.7 4.5 4.5 0 0 0-6.37 0 .5.5 0 0 1-.7-.7m-1.77-1.77a8 8 0 0 1 11.32 0 .5.5 0 0 1-.71.71 7 7 0 0 0-9.9 0 .5.5 0 1 1-.7-.7M10 2c1.84 0 3.53.29 4.78.77q.94.35 1.55.89c.34.3.6.7.66 1.14L17 5v3c0 .53-.28.99-.67 1.34q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89C3.28 9 3 8.54 3 8V5l.01-.2c.06-.45.32-.83.66-1.14q.61-.54 1.55-.9C6.47 2.3 8.16 2 10 2m0 4c-1.75 0-3.31.27-4.42.7a4 4 0 0 0-1.23.7c-.27.24-.35.44-.35.6s.08.36.35.6a4 4 0 0 0 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.27-.24.35-.44.35-.6s-.08-.36-.35-.6a4 4 0 0 0-1.23-.7C13.32 6.27 11.75 6 10 6m0-3c-1.75 0-3.31.27-4.42.7a4 4 0 0 0-1.23.7c-.24.2-.33.4-.35.54V6.4q.52-.37 1.22-.63C6.47 5.29 8.16 5 10 5s3.53.29 4.78.77q.7.25 1.22.63V4.94c-.02-.15-.11-.33-.35-.54a4 4 0 0 0-1.23-.7C13.32 3.27 11.75 3 10 3"
]);
const $90f21c32649fad68$export$ac25d34143772ea3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneBelowFilled', "1em", [
    "M17 15c0 .53-.28.99-.67 1.34q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89C3.28 16 3 15.54 3 15v-1.03q.63.57 1.49.96A13 13 0 0 0 10 16c2.13 0 4.08-.4 5.51-1.07a6 6 0 0 0 1.49-.96zm-1.9-5.02c1.22.57 1.82 1.26 1.9 1.88V12c0 .66-.59 1.4-1.9 2.02-1.29.6-3.09.98-5.1.98a12 12 0 0 1-5.1-.98C3.6 13.41 3 12.66 3 12v-.14c.08-.62.68-1.3 1.9-1.88C6.2 9.38 8 9 10 9s3.81.38 5.1.98m-.15-6.03a.5.5 0 0 1 .7.7 8 8 0 0 1-11.3 0 .5.5 0 1 1 .7-.7 7 7 0 0 0 9.9 0m-1.77-1.77a.5.5 0 0 1 .71.7 5.5 5.5 0 0 1-7.78 0 .5.5 0 1 1 .7-.7 4.5 4.5 0 0 0 6.37 0"
]);
const $90f21c32649fad68$export$97139b68ab588fde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomMicrophoneBelowRegular', "1em", [
    "M10 9c1.84 0 3.53.29 4.78.77q.94.35 1.55.89c.39.35.67.8.67 1.34v3l-.01.2c-.06.45-.32.83-.66 1.14q-.61.54-1.55.9c-1.25.47-2.94.76-4.78.76s-3.53-.29-4.78-.77a5 5 0 0 1-1.55-.89c-.34-.3-.6-.7-.66-1.14L3 15v-3c0-.53.28-.99.67-1.34q.61-.54 1.55-.9C6.47 9.3 8.16 9 10 9m6 4.6q-.52.37-1.22.63c-1.25.48-2.94.77-4.78.77s-3.53-.29-4.78-.77A6 6 0 0 1 4 13.6v1.46q.01.23.35.54.4.38 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.24-.2.33-.4.35-.54zM10 10c-1.75 0-3.31.27-4.42.7a4 4 0 0 0-1.23.7c-.27.24-.35.44-.35.6s.08.36.35.6q.4.38 1.23.7c1.1.43 2.67.7 4.42.7s3.31-.27 4.42-.7q.83-.32 1.23-.7c.27-.24.35-.44.35-.6s-.08-.36-.35-.6a4 4 0 0 0-1.23-.7c-1.1-.43-2.67-.7-4.42-.7m4.95-6.05a.5.5 0 0 1 .7.7 8 8 0 0 1-11.3 0 .5.5 0 1 1 .7-.7 7 7 0 0 0 9.9 0m-1.77-1.77a.5.5 0 0 1 .71.7 5.5 5.5 0 0 1-7.78 0 .5.5 0 1 1 .7-.7 4.5 4.5 0 0 0 6.37 0"
]);
const $90f21c32649fad68$export$7947607cadeaf0c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemoteFilled', "1em", [
    "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H9V9.5A2.5 2.5 0 0 0 6.5 7h-3q-.15 0-.31.02zM9 16.5q0 .26-.05.5h5.55a.5.5 0 0 0 0-1H9zM5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$e8f9359c33b41db2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DeviceMeetingRoomRemoteRegular', "1em", [
    "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H9v-1h6.5c.96 0 1.67-.9 1.46-1.83l-1.6-7A1.5 1.5 0 0 0 13.9 4H6.1c-.7 0-1.31.48-1.47 1.17L4.22 7H3.5q-.15 0-.31.02zM8.95 17h5.55a.5.5 0 0 0 0-1H9v.5q0 .26-.05.5M5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$f03c33c265c3136 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircleFilled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.5 7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1zm0 3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1z"
]);
const $90f21c32649fad68$export$a3093db153416aac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualCircleRegular', "1em", [
    "M13.5 9a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1zm0 3a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1zm4.5-2a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-8-7a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
]);
const $90f21c32649fad68$export$307e7d5b8c3fd8c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L5.79 6.5H3.75a.75.75 0 0 0 0 1.5h3.54l3.5 3.5H3.75a.75.75 0 0 0 0 1.5h8.54l4.86 4.85a.5.5 0 0 0 .7-.7zm10.77 9.35 1.5 1.5h1.13a.75.75 0 0 0 0-1.5zm-5-5 1.5 1.5h6.13a.75.75 0 0 0 0-1.5z"
]);
const $90f21c32649fad68$export$3ef591cd32570557 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EqualOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L6.29 7H3.5a.5.5 0 0 0 0 1h3.8l4 4H3.5a.5.5 0 0 0 0 1h8.8l4.85 4.85a.5.5 0 0 0 .7-.7zM14.12 12l1 1h1.38a.5.5 0 0 0 0-1zm-5-5 1 1h6.38a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$a4a3301dec3eeb6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripFilled', "1em", [
    "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm13-.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0m.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0M4.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 12.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0M4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$7fcc22f75553755 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripRegular', "1em", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 12.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$64592fc85f76c987 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUpFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.35.14l-2 2a.5.5 0 1 0 .7.71L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 1 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15m.5-8a3 3 0 0 1 3 3v3.26A5.5 5.5 0 0 0 9.2 16H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM4.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m11 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$e49af9a571d7c7a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripArrowUpRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.35.14l-2 2a.5.5 0 1 0 .7.71L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 1 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15m1-8A2.5 2.5 0 0 1 18 6.5v3.76a6 6 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4.52q.05.51.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-11 8c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m11 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$61e985c73a12b6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobeFilled', "1em", [
    "M15.99 15a9 9 0 0 1-.54 2.85q-.26.63-.54.91c-.18.2-.32.24-.41.24-.1 0-.23-.05-.41-.24q-.29-.29-.54-.91a9 9 0 0 1-.54-2.85zM12 15a10 10 0 0 0 .82 3.68 4.5 4.5 0 0 1-2.8-3.68zm6.96 0a4.5 4.5 0 0 1-2.8 3.68l.2-.46c.35-.86.57-1.99.62-3.22zM15 4a3 3 0 0 1 3 3v3.26A5.5 5.5 0 0 0 9.2 16H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM4.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m8.33-1.68q-.11.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68M14.5 10c.1 0 .23.05.41.24q.29.29.54.91c.3.73.5 1.72.54 2.85H13a9 9 0 0 1 .54-2.85q.26-.63.54-.91c.18-.2.32-.24.41-.24m1.67.32c1.51.6 2.62 2 2.8 3.68H17a10 10 0 0 0-.82-3.68M4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m11 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$d7fb455a23197ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripGlobeRegular', "1em", [
    "M15.99 15a9 9 0 0 1-.54 2.85q-.26.63-.54.91c-.18.2-.32.24-.41.24-.1 0-.23-.05-.41-.24q-.29-.29-.54-.91a9 9 0 0 1-.54-2.85zM12 15a10 10 0 0 0 .82 3.68 4.5 4.5 0 0 1-2.8-3.68zm6.96 0a4.5 4.5 0 0 1-2.8 3.68l.2-.46c.35-.86.57-1.99.62-3.22zM15.5 4A2.5 2.5 0 0 1 18 6.5v3.76a6 6 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4.52q.05.51.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4zm-11 8c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m8.33-1.68q-.11.22-.2.46A10 10 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68M14.5 10c.1 0 .23.05.41.24q.29.29.54.91c.3.73.5 1.72.54 2.85H13a9 9 0 0 1 .54-2.85q.26-.63.54-.91c.18-.2.32-.24.41-.24m1.67.32c1.51.6 2.62 2 2.8 3.68H17a10 10 0 0 0-.82-3.68M4.5 9c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m0-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m11 0c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$f8c5cb8c2d536173 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripImageFilled', "1em", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H7v-2.5A3.5 3.5 0 0 1 10.5 7H14V4.5A2.5 2.5 0 0 0 11.5 2zm0 2c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5m7.5.5V5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 1 0M4.5 6.75c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5M5 10v.5a.5.5 0 0 1-1 0V10a.5.5 0 0 1 1 0m3 .5A2.5 2.5 0 0 1 10.5 8h5a2.5 2.5 0 0 1 2.5 2.5v5q-.01.77-.41 1.38L14.2 13.5a1.7 1.7 0 0 0-2.42 0l-3.38 3.38q-.4-.6-.41-1.38zm6 .5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-4.88 6.59q.6.4 1.38.41h5q.77-.01 1.38-.41L13.5 14.2a.7.7 0 0 0-1 0z"
]);
const $90f21c32649fad68$export$81dfcc857d000d3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripImageRegular', "1em", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5V7h-1V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7v1H4.5A2.5 2.5 0 0 1 2 10.5zM16 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-8-.5A2.5 2.5 0 0 1 10.5 8h5a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 8 15.5zM10.5 9C9.67 9 9 9.67 9 10.5v5q0 .35.15.65l2.64-2.65a1.7 1.7 0 0 1 2.42 0l2.64 2.65q.15-.3.15-.65v-5c0-.83-.67-1.5-1.5-1.5zm2 5.2-2.65 2.65q.3.15.65.15h5q.35 0 .65-.15l-2.65-2.64a.7.7 0 0 0-1 0M4.5 4c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5m7.5.5a.5.5 0 0 0-1 0V5a.5.5 0 0 0 1 0zM4.5 6.75c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5M5 10a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$8788b3167af00755 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripMusicNote2Filled', "1em", [
    "M17.09 5.02c.46-.1.91.24.91.73V15a2 2 0 1 1-1-1.73V8.61l-6 2.14V16a2 2 0 1 1-1-1.73v-6.2c0-.32.2-.6.5-.7L17 5.04zM11.5 2A2.5 2.5 0 0 1 14 4.5v.55l-3.84 1.37C9.46 6.67 9 7.33 9 8.07V13H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2zm-7 7.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 1 0V10a.5.5 0 0 0-.5-.5m0-2.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5M4.5 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5m7 0a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0v-.5a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$7e11a23e7cc99b69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripMusicNote2Regular', "1em", [
    "M17.09 5.02c.46-.1.91.24.91.73V15a2 2 0 1 1-1-1.73V8.61l-6 2.14V16a2 2 0 1 1-1-1.73v-6.2c0-.32.2-.6.5-.7L17 5.04zM9 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M11.5 2A2.5 2.5 0 0 1 14 4.5v.55l-1 .36V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H9v1H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2zm-7 7.5c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0V10c0-.28.22-.5.5-.5M11 8.25v1.44l6-2.14V6.1zm-6.5-1.5c.28 0 .5.22.5.5v.5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5M4.5 4c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5m7 0c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$998a41b2a7c5ad78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlayFilled', "1em", [
    "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm10.5 2c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m-.5 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5-3.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M4 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5M4 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm4-1.37c0-.49.46-.79.83-.54l2.94 1.95c.3.2.3.72 0 .92l-2.94 1.95c-.37.25-.83-.05-.83-.54z"
]);
const $90f21c32649fad68$export$57eb55b8e59f3cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripPlayRegular', "1em", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5zM15.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m-.5 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5-3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm4-1.37c0-.49.46-.79.83-.54l2.94 1.95c.3.2.3.72 0 .92l-2.94 1.95c-.37.25-.83-.05-.83-.54z"
]);
const $90f21c32649fad68$export$6377cca8252cd35d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplitFilled', "1em", [
    "M10.5 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0zM2 7a3 3 0 0 1 3-3h3.5v12H5a3 3 0 0 1-3-3zm2.5-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 13.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m7 7V4H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3zM15 7.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0zm.5 4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0"
]);
const $90f21c32649fad68$export$ea1576b5b6b23f2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilmstripSplitRegular', "1em", [
    "M10.5 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0zM2 6.5A2.5 2.5 0 0 1 4.5 4h4v1h-4C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4v1h-4A2.5 2.5 0 0 1 2 13.5zM11.5 5V4h4A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-4v-1h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15 6.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M15 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M4 12.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$8248b4ad5e7e58c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterFilled', "1em", [
    "M12.25 13.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm2-4.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zm2-4.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $90f21c32649fad68$export$8ec1da0ca29c4788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterRegular', "1em", [
    "M7.5 13h5a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1zh5zm-2-4h9a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1zh9zm-2-4h13a.5.5 0 0 1 .09 1H3.5a.5.5 0 0 1-.09-1zh13z"
]);
const $90f21c32649fad68$export$515201456c857393 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAddFilled', "1em", [
    "M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm-.52-4.25a5.5 5.5 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5zM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5a.5.5 0 0 0-.5-.5M9.02 6q.07.79.36 1.5H3.75a.75.75 0 0 1 0-1.5z"
]);
const $90f21c32649fad68$export$1c4fd2a284bf2850 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterAddRegular', "1em", [
    "M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09m2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09m0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.2 7q.15.52.4 1H3.5a.5.5 0 0 1-.09-1H9.2m5.3-4a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$a79a2e361b8453a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismissFilled', "1em", [
    "M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm-.52-4.25a5.5 5.5 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5zM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.02 6q.07.79.36 1.5H3.75a.75.75 0 0 1 0-1.5zm7.33-2.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$b94039714c4c3b30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterDismissRegular', "1em", [
    "M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09m2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09m0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M9.2 7q.16.52.4 1H3.5a.5.5 0 0 1-.09-1H9.2m7.15-3.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$c154e9e312c49213 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSyncFilled', "1em", [
    "M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zm-.52-4.25a5.5 5.5 0 0 0 3.27.73V11c0 .41-.34.75-.75.75h-8.5a.75.75 0 0 1 0-1.5zM14.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7 2 2 0 0 1-2.39.33H14a.5.5 0 0 0 0-1zM9.02 6q.07.79.36 1.5H3.75a.75.75 0 0 1 0-1.5zm7.48-3.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7A2 2 0 0 1 15.48 4H15a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$2797ed9cfc09ec77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FilterSyncRegular', "1em", [
    "M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09m2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09m0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0v-.15a3 3 0 0 0 3.62-.48.5.5 0 1 0-.7-.7 2 2 0 0 1-2.39.33H14a.5.5 0 0 0 0-1zM9.2 7q.15.52.4 1H3.5a.5.5 0 0 1-.09-1H9.2m7.3-4.5a.5.5 0 0 0-.5.5v.15a3 3 0 0 0-3.62.48.5.5 0 1 0 .7.7A2 2 0 0 1 15.48 4H15a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$ec644638bbe66ebb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FireFilled', "1em", [
    "M4 11.75q0-.81.19-1.59a6 6 0 0 1 .86-1.93 1 1 0 0 1 .18-.17.5.5 0 0 1 .48 0q.12.06.18.17l1.04 1.7q.07.12.19.18t.26.07q.27 0 .42-.2a.8.8 0 0 0 .06-.82q-.32-.69-.52-1.36a5 5 0 0 1 .12-3.17q.33-.75.92-1.27.58-.53 1.36-.86A8 8 0 0 1 11.5 2q.18 0 .32.12.18.15.18.38 0 1.17.4 2.23.4 1.07 1.1 2l.87 1.13q.44.57.8 1.19.37.61.6 1.28.22.66.23 1.42a6.5 6.5 0 0 1-.8 3.1 6.6 6.6 0 0 1-2.12 2.27 5.7 5.7 0 0 1-4.71.65 6 6 0 0 1-1.44-.64 6.5 6.5 0 0 1-2.13-2.27 6.2 6.2 0 0 1-.8-3.1"
]);
const $90f21c32649fad68$export$5d152d5b82dfaaf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FireRegular', "1em", [
    "M4 11.75q0-.81.19-1.59a6 6 0 0 1 .86-1.93 1 1 0 0 1 .18-.17.5.5 0 0 1 .48 0q.12.06.18.17l1.04 1.7q.07.12.19.18t.26.07q.27 0 .42-.2a.8.8 0 0 0 .06-.82q-.32-.69-.52-1.36a5 5 0 0 1 .12-3.17q.33-.75.92-1.27.58-.53 1.36-.86A8 8 0 0 1 11.5 2q.18 0 .32.12.18.15.18.38 0 1.17.4 2.23.4 1.07 1.1 2l.87 1.13q.44.57.8 1.19.37.61.6 1.28.22.66.23 1.42a6.5 6.5 0 0 1-.8 3.1 6.6 6.6 0 0 1-2.12 2.27 5.7 5.7 0 0 1-4.71.65 6 6 0 0 1-1.44-.64 6.5 6.5 0 0 1-2.13-2.27 6.2 6.2 0 0 1-.8-3.1m11-.05q0-.6-.23-1.2-.23-.58-.57-1.14a11 11 0 0 0-.75-1.06q-.4-.5-.75-.98a9 9 0 0 1-1.14-1.98 8 8 0 0 1-.54-2.23q-.63.16-1.15.43-.53.27-.92.67t-.6.94q-.2.54-.22 1.22 0 .63.17 1.2.15.57.44 1.13.1.2.15.4l.06.45q0 .33-.11.62a1.54 1.54 0 0 1-2.76.28l-.6-.96a5.45 5.45 0 0 0 1.95 6.77 4.84 4.84 0 0 0 7.2-2.55q.35-.96.37-2.01"
]);
const $90f21c32649fad68$export$34bf97db8b311250 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FireplaceFilled', "1em", [
    "M10 2a7 7 0 0 0-7 7v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a7 7 0 0 0-7-7M4 9a6 6 0 1 1 12 0v5h-3.5c.62-.62 1-1.48 1-2.5 0-1.13-.63-1.97-1.17-2.7l-.13-.16c-.6-.8-1.1-1.57-1.1-2.71a.5.5 0 0 0-.76-.43c-1.4.85-1.45 2.17-1.39 3l-.42-.37a.5.5 0 0 0-.66 0h-.01l-.02.02-.2.22q-.21.23-.47.65c-.34.57-.67 1.4-.67 2.48 0 1.02.38 1.88 1 2.5H4zm-1.5 7a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$a8ac863acd7d2e55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FireplaceRegular', "1em", [
    "M3 9a7 7 0 0 1 14 0v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm7-6a6 6 0 0 0-6 6v5h3.5c-.62-.62-1-1.48-1-2.5a4.9 4.9 0 0 1 1.34-3.35l.02-.01v-.01a.5.5 0 0 1 .65-.02q.03-.42.2-.9c.25-.63.75-1.24 1.65-1.72a.5.5 0 0 1 .74.44c0 1.14.5 1.9 1.1 2.7l.13.18c.54.72 1.17 1.56 1.17 2.69 0 1.02-.38 1.88-1 2.5H16V9a6 6 0 0 0-6-6M8.22 9.25l-.19.28a4 4 0 0 0-.53 1.97c0 1.49 1.1 2.5 2.5 2.5s2.5-1.01 2.5-2.5c0-.79-.43-1.37-1.02-2.16l-.08-.1c-.48-.65-1-1.4-1.21-2.42a2 2 0 0 0-.66 1.88q0 .13.03.23v.05l.03.15q.01.09 0 .25c0 .05-.02.17-.12.28-.12.15-.3.2-.44.2a1 1 0 0 1-.25-.09l-.12-.08-.2-.19zM2.5 16a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$668180642cecc372 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionFilled', "1em", [
    "M10 2a8 8 0 0 1 8 8c0 2.48-1.49 4-3.25 4a3 3 0 0 1-2.56-1.44A3.3 3.3 0 0 1 9.5 14C7.45 14 6 12.09 6 10s1.45-4 3.5-4c.76 0 1.45.27 2 .71a.75.75 0 0 1 1.5.04V10c0 1.86 1.01 2.5 1.75 2.5s1.75-.64 1.75-2.5a6.5 6.5 0 1 0-4.56 6.2c.3-.09.63-.03.85.2.38.37.27 1.01-.23 1.18Q11.35 18 10 18a8 8 0 0 1 0-16m-.5 5.5c-1 0-2 1-2 2.5s1 2.5 2 2.5 2-1 2-2.5-1-2.5-2-2.5"
]);
const $90f21c32649fad68$export$5ac6d0db2f27863 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionRegular', "1em", [
    "M10 2a8 8 0 0 1 8 8c0 2.5-1.38 4-3 4-1.07 0-2.04-.66-2.57-1.82A3.4 3.4 0 0 1 9.5 14c-2 0-3.5-1.87-3.5-4s1.5-4 3.5-4c1 0 1.88.47 2.5 1.2v-.7a.5.5 0 0 1 1 0V10l.01.39c.13 1.87 1.17 2.6 1.99 2.6.88 0 2-.83 2-2.99a7 7 0 1 0-4.71 6.61q.32-.1.56.13c.25.25.17.67-.16.8Q11.42 18 10 18a8 8 0 0 1 0-16m-.5 5C8.19 7 7 8.27 7 10s1.19 3 2.5 3 2.5-1.27 2.5-3-1.19-3-2.5-3"
]);
const $90f21c32649fad68$export$fbe62993b82322ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionArrowDownFilled', "1em", [
    "M3.02 10.41q.7.35 1.48.5V11a6.5 6.5 0 0 0 8.44 6.2c.3-.09.63-.03.85.2.38.37.27 1.01-.23 1.18Q12.35 19 11 19a8 8 0 0 1-7.98-8.59M11 3a8 8 0 0 1 8 8c0 2.48-1.49 4-3.25 4a3 3 0 0 1-2.56-1.44A3.3 3.3 0 0 1 10.5 15C8.45 15 7 13.09 7 11v-.21q.91-.26 1.67-.8-.17.45-.17 1.01c0 1.5 1 2.5 2 2.5s2-1 2-2.5-1-2.5-2-2.5q-.23 0-.43.06.47-.7.72-1.55.98.1 1.71.7a.75.75 0 0 1 1.5.04V11c0 1.86 1.01 2.5 1.75 2.5s1.75-.64 1.75-2.5A6.5 6.5 0 0 0 11 4.5h-.1a6 6 0 0 0-.49-1.48zM5.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5v2.8L3.85 5.14a.5.5 0 1 0-.7.7l2 2A.5.5 0 0 0 5.5 8a.5.5 0 0 0 .35-.15l2-2a.5.5 0 1 0-.7-.7L6 6.29V3.5a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$463a44c2c7eb2690 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionArrowDownRegular', "1em", [
    "M3.02 10.41q.47.24.98.38V11a7 7 0 0 0 9.29 6.61q.32-.1.56.13c.25.25.17.67-.16.8Q12.42 19 11 19a8 8 0 0 1-7.98-8.59M11 3a8 8 0 0 1 8 8c0 2.5-1.38 4-3 4-1.07 0-2.04-.66-2.57-1.82A3.4 3.4 0 0 1 10.5 15c-2 0-3.5-1.87-3.5-4v-.21q.55-.16 1.05-.42-.05.3-.05.63c0 1.73 1.19 3 2.5 3s2.5-1.27 2.5-3-1.19-3-2.5-3h-.1q.24-.46.39-.99A3.3 3.3 0 0 1 13 8.2v-.7a.5.5 0 0 1 1 0V11l.01.39c.13 1.87 1.17 2.6 1.99 2.6.88 0 2-.83 2-2.99a7 7 0 0 0-7-7h-.2q-.15-.51-.39-.98zM5.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5v2.8L3.85 5.14a.5.5 0 1 0-.7.7l2 2A.5.5 0 0 0 5.5 8a.5.5 0 0 0 .35-.15l2-2a.5.5 0 1 0-.7-.7L6 6.29V3.5a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$2d06f3781c065125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionBracketsFilled', "1em", [
    "M4.75 2A2.75 2.75 0 0 0 2 4.75v10.5A2.75 2.75 0 0 0 4.75 18h1.5a.75.75 0 0 0 0-1.5h-1.5c-.69 0-1.25-.56-1.25-1.25V4.75c0-.69.56-1.25 1.25-1.25h1.5a.75.75 0 0 0 0-1.5zm7 5.25c.41 0 .75.34.75.75v2.75a.75.75 0 0 0 1.5 0V10a4 4 0 1 0-4.24 4 4 4 0 0 0 1.29-.13c.35-.1.75.05.89.39.17.43-.03.93-.47 1.05q-.69.2-1.47.19a5.5 5.5 0 1 1 5.5-5.5v.75q-.01.7-.37 1.24l-.13.3v-.13a2.25 2.25 0 0 1-3.58-.1q-.62.43-1.42.44a2.5 2.5 0 1 1 1.05-4.77c.1-.28.38-.48.7-.48M10 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8-4.25A2.75 2.75 0 0 0 15.25 2h-1.5a.75.75 0 0 0 0 1.5h1.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25h-1.5a.75.75 0 0 0 0 1.5h1.5A2.75 2.75 0 0 0 18 15.25z"
]);
const $90f21c32649fad68$export$56980a92e21b51e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MentionBracketsRegular', "1em", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-11A2.5 2.5 0 0 1 4.5 2h2a.5.5 0 0 1 0 1zm11 14c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 18 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 0 1 0-1zm-4-7a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M10 7.5q.86.02 1.5.5a.5.5 0 0 1 1 0v2.75a.75.75 0 0 0 1.5 0V10a4 4 0 1 0-4.24 4h.02a4 4 0 0 0 1.58-.23c.3-.1.64.11.64.43 0 .23-.14.45-.36.53A5 5 0 1 1 15 10v.75a1.75 1.75 0 0 1-3.2.98A2.5 2.5 0 0 1 7.5 10 2.5 2.5 0 0 1 10 7.5"
]);
const $90f21c32649fad68$export$e3eb3b38a2cdb045 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PawColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_20_color__a)",
            "fillRule": "evenodd",
            "d": "M4 14a6 6 0 0 1 12 0c0 .99-.5 1.75-1.21 2.25-.7.5-1.6.75-2.48.75H7.69c-.88 0-1.78-.25-2.48-.75A2.7 2.7 0 0 1 4 14",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_paw_20_color__b)",
            "fillRule": "evenodd",
            "d": "M5.5 4.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M3 4.5c-1.17 0-2 1.08-2 2.25S1.83 9 3 9s2-1.08 2-2.25S4.17 4.5 3 4.5m12 2.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25m-4.5-2.5c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_paw_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -9 14.4 0 10.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_paw_20_color__a",
                "x1": "6.85",
                "x2": "10.78",
                "y1": "9.2",
                "y2": "17.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$fb1267dd602aa2ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__a)",
            "d": "M10.5 12.5c0-.83.68-1.5 1.52-1.5h4.96c.84 0 1.52.67 1.52 1.5 0 0 0 3-4 3s-4-3-4-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__b)",
            "fillOpacity": ".5",
            "d": "M10.5 12.5c0-.83.68-1.5 1.52-1.5h4.96c.84 0 1.52.67 1.52 1.5 0 0 0 3-4 3s-4-3-4-3"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__c)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__d)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__e)",
            "d": "M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_20_color__f)",
            "d": "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__a",
                "x1": "12.4",
                "x2": "14",
                "y1": "11.6",
                "y2": "16.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__c",
                "x1": "4",
                "x2": "6.15",
                "y1": "11.8",
                "y2": "17.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__d",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "10.29",
                "y2": "20.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__e",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "5.66",
                "y2": "9.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_20_color__f",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "4.36",
                "y2": "9.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-7.1 111.45 -69.77)scale(5.30556)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".39",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$9b5849e9284c5045 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleFilled', "1em", [
    "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5m5.69 5.14q.78.35 2.06.36c4 0 4-3 4-3 0-.83-.67-1.5-1.5-1.5h-4.63q.62.74.63 1.75v.36l-.02.25a5 5 0 0 1-.54 1.78M17 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4m11.5.1v.07Z"
]);
const $90f21c32649fad68$export$b213d2e83fd84187 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleRegular', "1em", [
    "M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m5.69 11.65q.79.33 2.06.35c1.88 0 2.92-.67 3.47-1.43a3 3 0 0 0 .53-1.5v-.07c0-.83-.67-1.5-1.5-1.5h-4.63q.36.44.53 1H17c.28 0 .5.22.5.5v.1l-.04.22q-.05.29-.3.66c-.33.46-1.04 1.02-2.66 1.02q-1.08-.01-1.69-.28-.12.43-.37.93M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2v.08l-.01.18q-.01.17-.08.45c-.08.37-.25.86-.6 1.36-.7 1.01-2.05 1.93-4.56 1.93s-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V13m1 .06v.1l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16s3.26-.8 3.74-1.5a3 3 0 0 0 .5-1.42l.01-.02V13a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1zM13 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
]);
const $90f21c32649fad68$export$774e6567d62d152f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAddColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__a)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__b)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__c)",
            "fillOpacity": ".5",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__d)",
            "d": "M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__e)",
            "d": "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__f)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_add_20_color__g)",
            "fillRule": "evenodd",
            "d": "M14.5 12c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "10.8",
                "y2": "16.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "9.29",
                "y2": "19.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "4.66",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "3.36",
                "y2": "8.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__f",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_add_20_color__g",
                "x1": "12.94",
                "x2": "14.47",
                "y1": "12.51",
                "y2": "17.93",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_add_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2 4.5 -4.5 2 12.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$cd90d240cc50870e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAddFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$44334f6230b9417f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAddRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$bdc66f9d44eb9ac2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudienceFilled', "1em", [
    "M12.21 5.22a2.23 2.23 0 1 0-4.45 0 2.23 2.23 0 0 0 4.45 0M2.51 12h3V8.83q.05-.45.26-.82H3.02l-.12.01a1 1 0 0 0-.88 1v2.48c0 .28.22.5.5.5M18 11.5a.5.5 0 0 1-.5.5h-3.02V8.87q-.04-.47-.26-.86h2.78a1 1 0 0 1 1 .89v2.6m-4.52-2.6a1 1 0 0 0-1-.89H7.5l-.11.01a1 1 0 0 0-.89 1V12h6.97V8.9m1.5-5.28a1.91 1.91 0 1 1 0 3.82 1.91 1.91 0 0 1 0-3.82M6.93 5.53a1.91 1.91 0 1 0-3.83 0 1.91 1.91 0 0 0 3.83 0M2.5 13a.5.5 0 0 0-.5.5v1A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$8c8acb525c9a5d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleAudienceRegular', "1em", [
    "M9.99 2.99a2.23 2.23 0 1 1 0 4.45 2.23 2.23 0 0 1 0-4.45m0 1a1.23 1.23 0 1 0 0 2.45 1.23 1.23 0 0 0 0-2.45M3.02 11.5a.5.5 0 1 1-1 0V9.01a1 1 0 0 1 .88-.99h2.87q-.21.37-.26.81v.18H3zm14.47.5a.5.5 0 0 0 .5-.5V8.9a1 1 0 0 0-1-.89h-2.78q.22.4.26.86V9H17v2.49c0 .28.22.5.5.5m-5.02-3.99a1 1 0 0 1 1 .89v2.6a.5.5 0 1 1-1 0V9.01H7.5v2.49a.5.5 0 1 1-1 0V9.01a1 1 0 0 1 .89-.99h5.08m4.42-2.48a1.91 1.91 0 1 0-3.83 0 1.91 1.91 0 0 0 3.83 0m-2.83 0a.91.91 0 1 1 1.83 0 .91.91 0 0 1-1.83 0M5.02 3.62a1.91 1.91 0 1 1 0 3.82 1.91 1.91 0 0 1 0-3.82m0 1a.91.91 0 1 0 0 1.82.91.91 0 0 0 0-1.82M2.5 13a.5.5 0 0 0-.5.5v1A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-.5-.5zm.5 1.5V14h14v.5c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5"
]);
const $90f21c32649fad68$export$62e914889efdc470 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCallFilled', "1em", [
    "M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2v.08l-.01.18q-.01.17-.08.45c-.08.37-.25.86-.6 1.36-.7 1.01-2.05 1.93-4.56 1.93s-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12m13-8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m1.08 7.58.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $90f21c32649fad68$export$21150e6de269477f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCallRegular', "1em", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m0 4.25a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93s3.87-.92 4.57-1.93a4 4 0 0 0 .68-1.99V12a2 2 0 0 0-2-2zm-1 2.06V12a1 1 0 0 1 1-1H10a1 1 0 0 1 1 1v.16l-.06.33c-.07.27-.2.64-.45 1C10.01 14.2 9 15 6.75 15s-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42zM14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m3.58 5.08.29-.75a1.3 1.3 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29q1.46-.9 1.56-2.56l-.87-.86a.9.9 0 0 1-.23-1"
]);
const $90f21c32649fad68$export$835bc917b04c92fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChatColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__a)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__b)",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__c)",
            "fillOpacity": ".5",
            "d": "M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__d)",
            "d": "M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__e)",
            "d": "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__f)",
            "d": "M19 14.5a4.5 4.5 0 0 1-6.68 3.94l-1.8.54a.4.4 0 0 1-.5-.5l.54-1.8A4.5 4.5 0 1 1 19 14.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_chat_20_color__g)",
            "d": "M12.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-.5 2.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "10.8",
                "y2": "16.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "9.29",
                "y2": "19.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "4.66",
                "y2": "8.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "3.36",
                "y2": "8.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__f",
                "x1": "10.32",
                "x2": "18.18",
                "y1": "11.69",
                "y2": "25.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cc23d1"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_chat_20_color__g",
                "x1": "12.44",
                "x2": "12.74",
                "y1": "13.05",
                "y2": "16.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fdfdfd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cceaff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_chat_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2 4.5 -4.5 2 12.5 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$2e3eaad6100f7be1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChatFilled', "1em", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M11 10.26a5.5 5.5 0 0 0-1.88 5.4c-.64.2-1.42.34-2.37.34-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26M14.5 19a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $90f21c32649fad68$export$2dc43e98b3451f2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleChatRegular', "1em", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m0 4.25a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.42-.01 2.37-.35A6 6 0 0 1 9 14.63q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10l.23.03q.35-.42.76-.77A2 2 0 0 0 10 10zm11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14.5 19a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $90f21c32649fad68$export$d051454b27c48daa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmarkFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$bfeadeb8f7d95880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCheckmarkRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$e2433a8f84b53f50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunicationFilled', "1em", [
    "M11.32 11.32a4.5 4.5 0 0 1 6.36 6.36.5.5 0 1 1-.7-.7 3.5 3.5 0 1 0-4.96 0 .5.5 0 1 1-.7.7 4.5 4.5 0 0 1 0-6.36m1.41 1.41a2.5 2.5 0 0 1 3.54 3.54.5.5 0 0 1-.71-.71 1.5 1.5 0 1 0-2.12 0 .5.5 0 0 1-.7.7 2.5 2.5 0 0 1 0-3.53M10 10q.54.01 1 .26a5.5 5.5 0 0 0-1.88 5.4c-.64.2-1.42.34-2.37.34-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2zM6.75 2.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $90f21c32649fad68$export$230a11a1b4e9cdfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunicationRegular', "1em", [
    "M11.32 11.32a4.5 4.5 0 0 1 6.36 6.36.5.5 0 0 1-.7-.7 3.5 3.5 0 1 0-4.95 0 .5.5 0 0 1-.71.7 4.5 4.5 0 0 1 0-6.36m1.41 1.41a2.5 2.5 0 0 1 3.54 3.54.5.5 0 0 1-.71-.71 1.5 1.5 0 1 0-2.12 0 .5.5 0 0 1-.7.7 2.5 2.5 0 0 1 0-3.53M10 10q.54.01 1 .26-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.44 1C3.5 14.2 4.51 15 6.75 15q1.42-.01 2.25-.37.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.67-1.81L1.5 12c0-1.1.9-2 2-2zM6.75 2.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14.5 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-7.75-.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $90f21c32649fad68$export$ce1c7aa3f8c43fcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__a)",
            "d": "M13.06 9.49a1.5 1.5 0 0 0-1.84 1.06l-.64 2.42a4 4 0 0 0 7.73 2.07l.64-2.42a1.5 1.5 0 0 0-1.06-1.84z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__b)",
            "d": "M6.94 9.49a1.5 1.5 0 0 1 1.84 1.06l.65 2.42a4 4 0 1 1-7.73 2.07l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__c)",
            "d": "M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__d)",
            "d": "M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__e)",
            "d": "M3.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_community_20_color__f)",
            "d": "M7.5 9C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 8 0v-3.5c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 -.53 14.04)scale(6.28119)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.06 -6.8 7.55)scale(9.32732 6.71383)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(59.93 1.15 10.22)scale(3.74767)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(78.84 4.56 12.25)scale(3.66754)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#004695"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(47.57 -5.03 5.53)scale(4.09974)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#008ce2"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0068c6"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_community_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(62.77 -5.35 13.64)scale(5.47141 5.13397)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".34",
                    "stopColor": "#3dcbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#14b1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$d0c3e9826150bf42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityFilled', "1em", [
    "M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-4.95 8q-.05.24-.05.5V14c0 1.53.69 2.9 1.77 3.81l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zm8.18 7.81A5 5 0 0 0 15 14v-3.5q0-.26-.05-.5l2.94.78a1.5 1.5 0 0 1 1.06 1.84l-.64 2.42a4 4 0 0 1-5.07 2.77M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4 5C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 8 0v-3.5c0-.83-.67-1.5-1.5-1.5z"
]);
const $90f21c32649fad68$export$1b339e8960dfa294 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityRegular', "1em", [
    "M10 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1.95 5q-.05.24-.05.5v.54l-2.63.71a.5.5 0 0 0-.35.61l.64 2.42a3 3 0 0 0 3.32 2.2q.35.45.79.83l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zM15 11.04v-.54q0-.26-.05-.5l2.94.78a1.5 1.5 0 0 1 1.06 1.84l-.64 2.42a4 4 0 0 1-5.07 2.77q.44-.37.78-.84a3 3 0 0 0 3.32-2.2l.65-2.4a.5.5 0 0 0-.36-.62zm0-4.54a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M7.5 9C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 8 0v-3.5c0-.83-.67-1.5-1.5-1.5zM7 10.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V14a3 3 0 1 1-6 0z"
]);
const $90f21c32649fad68$export$9b08f18e34711e2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAddFilled', "1em", [
    "M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-4.95 8q-.05.24-.05.5V14c0 1.53.69 2.9 1.77 3.81l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zM16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4 5C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 4.25 4 5.5 5.5 0 0 1 2.92-8.83 1.5 1.5 0 0 0-.67-.17zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$2d7b9f94aef65374 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleCommunityAddRegular', "1em", [
    "M10 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1.95 5q-.05.24-.05.5v.54l-2.63.71a.5.5 0 0 0-.35.61l.64 2.42a3 3 0 0 0 3.32 2.2q.35.45.79.83l-.17.05a4 4 0 0 1-4.9-2.82l-.65-2.42a1.5 1.5 0 0 1 1.06-1.84zM15 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-13 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M7.5 9C6.67 9 6 9.67 6 10.5V14a4 4 0 0 0 4.25 4 6 6 0 0 1-.66-1.03A3 3 0 0 1 7 14v-3.5c0-.28.22-.5.5-.5h3.84a6 6 0 0 1 1.84-.84A1.5 1.5 0 0 0 12.5 9zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$6e4cc00e15f12ebf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEditFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M10 10a2 2 0 0 1 2 1.94l-1.73 1.73q-.61.63-.84 1.49l-.1.42q-1 .4-2.58.42C1.5 16 1.5 12 1.5 12c0-1.1.9-2 2-2zm7-3.5A2.5 2.5 0 0 1 14.5 9 2.5 2.5 0 1 1 17 6.5m-1.2 3.05-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64"
]);
const $90f21c32649fad68$export$c543a28ffce1a785 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEditRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M10 10a2 2 0 0 1 2 1.94l-1.42 1.42a3 3 0 0 0 .42-1.28V12a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c1.56 0 2.53-.39 3.14-.86q-.32.46-.46 1.02l-.1.42a7 7 0 0 1-2.58.42c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12c0-1.1.9-2 2-2zm7-3.5A2.5 2.5 0 0 1 14.5 9 2.5 2.5 0 1 1 17 6.5m-4 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m2.8 3.05-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64"
]);
const $90f21c32649fad68$export$11991354e2b36cf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleErrorFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $90f21c32649fad68$export$8a9f28b4e45c1ea2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleErrorRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $90f21c32649fad68$export$e0962912f789b1c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEyeFilled', "1em", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-11 1a2 2 0 0 0-2 2s0 4 5.25 4q1.5-.02 2.49-.39A3 3 0 0 1 9 14.5c0-.52.18-1.05.43-1.52a5.5 5.5 0 0 1 2.16-2.2A2 2 0 0 0 10 10zm11 1c-2.76 0-4.5 2.32-4.5 3.5 0 1.2 1.74 3.5 4.5 3.5s4.5-2.32 4.5-3.5c0-1.2-1.74-3.5-4.5-3.5m0 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m1.5-2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $90f21c32649fad68$export$3b76f2f49a772761 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleEyeRegular', "1em", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m8.1 5.04A2 2 0 0 0 10 10H3.5a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.5-.02 2.49-.39a3 3 0 0 1-.24-.98q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10a1 1 0 0 1 .77.36q.37-.3.82-.57M14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5 4.5c-2.76 0-4.5 2.32-4.5 3.5 0 1.2 1.74 3.5 4.5 3.5s4.5-2.32 4.5-3.5c0-1.2-1.74-3.5-4.5-3.5m0 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m1.5-2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $90f21c32649fad68$export$331f8b2312151692 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleGameControllerFilled', "1em", [
    "m16.27 10.21.36.05h.03q.6.07.92.24a1 1 0 0 1 .4.43l.02.02a15 15 0 0 1 1.47 4.15v.04q.12 1.16-.31 1.75c-.28.41-.68.57-1 .6q-.1.02-.26-.02a1 1 0 0 1-.25-.13q-.2-.13-.51-.47-.36-.36-.56-.61v-.01c-.19-.21-.39-.46-.62-.62a.7.7 0 0 0-.46-.13h-2c-.48 0-.79.42-1.07.75q-.22.26-.57.62-.32.34-.5.47a1 1 0 0 1-.26.13q-.16.04-.27.03c-.31-.04-.7-.2-.99-.6q-.42-.6-.32-1.76v-.02l.01-.02c.22-1.1.66-2.67 1.47-4.15l.01-.02a1 1 0 0 1 .41-.43q.32-.17.92-.24h.03l.36-.05h.3q.16 0 .4.12l.21.17h1.66l.28-.17c.14-.09.3-.1.39-.12zM9.5 9.5q.63.01 1.12.34c-.29.24-.43.5-.49.6v.02a15 15 0 0 0-1.48 3.99q-.1.36-.13.73-.93.31-2.27.32c-2.51 0-3.87-.92-4.57-1.93A4 4 0 0 1 1 11.5c0-1.1.9-2 2-2zm5 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M6.25 2a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $90f21c32649fad68$export$fb8678dc6905bd0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleGameControllerRegular', "1em", [
    "m16.27 10.21.36.05h.03q.6.07.92.24a1 1 0 0 1 .4.43l.02.02a15 15 0 0 1 1.47 4.15v.04q.12 1.16-.31 1.75c-.28.41-.68.57-1 .6q-.1.02-.26-.02a1 1 0 0 1-.25-.13q-.2-.13-.51-.47-.36-.36-.56-.61v-.01c-.3-.33-.6-.75-1.08-.75h-2c-.48 0-.79.42-1.07.75q-.22.26-.57.62-.32.34-.5.47a1 1 0 0 1-.26.13q-.16.04-.27.03c-.31-.04-.7-.2-.99-.6q-.42-.6-.32-1.76v-.02l.01-.02c.22-1.1.66-2.67 1.47-4.15l.01-.02a1 1 0 0 1 .41-.43q.32-.17.92-.24h.03l.36-.05h.3q.16 0 .4.12l.21.17h1.66l.28-.17c.14-.09.3-.1.39-.12zM9.5 9.5q.63.01 1.12.34c-.29.24-.43.5-.49.6v.02l-.1.2a1 1 0 0 0-.53-.16H3a1 1 0 0 0-1 1q0 .25.06.49c.07.27.2.64.44 1 .5.71 1.51 1.51 3.75 1.51 1.1 0 1.9-.2 2.5-.47l-.1.42q-.1.36-.13.73-.93.31-2.27.32c-2.51 0-3.87-.92-4.57-1.93A4 4 0 0 1 1 11.5c0-1.1.9-2 2-2zm5 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M6.25 2a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5M14 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M6.25 3a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $90f21c32649fad68$export$d888391fb988d419 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleHomeColor', "1em", [
    [
        "g",
        {
            "clipPath": "url(#ic_fluent_people_home_20_color__a)"
        },
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__b)",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__c)",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__d)",
                "fillOpacity": ".75",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__e)",
                "fillOpacity": ".55",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__f)",
                "fillOpacity": ".55",
                "d": "M5 11a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9 9 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.4 4.4 0 0 0 17 13a2 2 0 0 0-2-2z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__g)",
                "d": "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__h)",
                "d": "M14 15h3v4h-3z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__i)",
                "d": "M12 15.46a1 1 0 0 1 .35-.76l2.83-2.42a.5.5 0 0 1 .65 0l2.82 2.42a1 1 0 0 1 .35.76v3.04a.5.5 0 0 1-.5.5h-2v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V19h-2a.5.5 0 0 1-.5-.5z"
            }
        ],
        [
            "path",
            {
                "fill": "url(#ic_fluent_people_home_20_color__j)",
                "fillRule": "evenodd",
                "d": "M14.52 11.36a1.5 1.5 0 0 1 1.96 0l3.26 2.82a.75.75 0 1 1-.98 1.14l-3.26-2.83-3.26 2.83a.75.75 0 1 1-.98-1.14z",
                "clipRule": "evenodd"
            }
        ]
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__b",
                "x1": "6.33",
                "x2": "8.59",
                "y1": "11.93",
                "y2": "19.15",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__c",
                "x1": "10",
                "x2": "13.17",
                "y1": "10.17",
                "y2": "22",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__g",
                "x1": "7.9",
                "x2": "11.98",
                "y1": "3.06",
                "y2": "9.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__h",
                "x1": "15.5",
                "x2": "12.85",
                "y1": "15",
                "y2": "19.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__i",
                "x1": "11.76",
                "x2": "18.12",
                "y1": "12.35",
                "y2": "18.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_home_20_color__j",
                "x1": "15.93",
                "x2": "15.19",
                "y1": "9.71",
                "y2": "15.11",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 0 0 4.26136 15 17)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(90 2 16)scale(1.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".32"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_home_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 1 -1.67609 0 12 15)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "clipPath",
            {
                "id": "ic_fluent_people_home_20_color__a"
            },
            [
                "path",
                {
                    "fill": "#fff",
                    "d": "M0 0h20v20H0z"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$a41243d165885bd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwovenColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__a)",
            "d": "M13.71 18c2.03 0 3.44-2.35 4.17-3.54a.8.8 0 0 0-.06-.9l-2.68-3.26c-.7-.85-2.1-.8-2.72.1l-.82 1.16s-.54.53-.86.53-2.03 1.4-2.03 1.4l-.68 3.15c.83-1.17 1.44-.76 1.86-.54 1.25.65 2.3 1.9 3.82 1.9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__b)",
            "fillOpacity": ".5",
            "d": "M13.71 18c2.03 0 3.44-2.35 4.17-3.54a.8.8 0 0 0-.06-.9l-2.68-3.26c-.7-.85-2.1-.8-2.72.1l-.82 1.16s-.54.53-.86.53-2.03 1.4-2.03 1.4l-.68 3.15c.83-1.17 1.44-.76 1.86-.54 1.25.65 2.3 1.9 3.82 1.9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__c)",
            "d": "M6.3 9.69c-2.04 0-3.45 2.35-4.18 3.55a.8.8 0 0 0 .06.9l2.68 3.25c.7.86 2.1.8 2.72-.09l4.39-6.25c-.83 1.18-1.44.77-1.86.55-1.25-.66-2.3-1.91-3.82-1.91"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__d)",
            "d": "M6.3 9.69c-2.04 0-3.45 2.35-4.18 3.55a.8.8 0 0 0 .06.9l2.68 3.25c.7.86 2.1.8 2.72-.09l4.39-6.25c-.83 1.18-1.44.77-1.86.55-1.25-.66-2.3-1.91-3.82-1.91"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_interwoven_20_color__e)",
            "d": "M6.3 9.69c-2.04 0-3.45 2.35-4.18 3.55a.8.8 0 0 0 .06.9l2.68 3.25c.7.86 2.1.8 2.72-.09l4.39-6.25c-.83 1.18-1.44.77-1.86.55-1.25-.66-2.3-1.91-3.82-1.91"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__f)"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__j)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "5.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_people_interwoven_20_color__k)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(21.98 -27.79 26.9)scale(11.4508 7.99854)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".14",
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": ".37",
                    "stopColor": "#0057aa"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0fafff"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.46 -14.1 16.9)scale(5.85865 5.62127)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#76eb95",
                    "stopOpacity": ".34"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(111.85 2.43 8.94)scale(9.81775 10.2275)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#13accf"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 2.43 3.75)scale(5.07723)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__h",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 8.03 -6.9)scale(5.96569 6.17542)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__j",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(113.2 5.93 6.06)scale(5.07701 5.07605)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": ".52",
                    "stopColor": "#16bbda"
                }
            ],
            [
                "stop",
                {
                    "offset": ".75",
                    "stopColor": "#119fc5"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0078d4"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__k",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-49.64 11.52 -14.47)scale(5.965 6.17444)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__c",
                "x1": "10.97",
                "x2": "7.08",
                "y1": "9.69",
                "y2": "19.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0095ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__e",
                "x1": "6",
                "x2": "5.69",
                "y1": "14.68",
                "y2": "8.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#16bbda",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#76eb95"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__f",
                "x1": "5.25",
                "x2": "7.66",
                "y1": "3",
                "y2": "7.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_interwoven_20_color__i",
                "x1": "12.25",
                "x2": "14.66",
                "y1": "3",
                "y2": "7.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#3bd5ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#006ee3"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$224ac8cbe1ae4e42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwovenFilled', "1em", [
    "M12.98 10.12a1.36 1.36 0 0 1 2.1-.07l2.22 2.7.33.4c.27.33.3.8.06 1.17l-.39.6q-.42.63-.99 1.25c-.7.74-1.5 1.25-2.37 1.25-.66 0-1.24-.27-1.86-.67-.58-.37-1.11-.8-1.7-1.15l-.27-.15c-.3-.16-.45-.59-.25-.87l2.64-3.76h-.01zm-6.92-.53c.66 0 1.24.27 1.86.67.66.42 1.27.93 1.97 1.3l.17.09c.23.12.34.42.2.63l-3.24 4.6-.1.12c-.47.53-1.37.56-1.9.07l-.1-.12-2.54-3.09c-.27-.33-.3-.8-.07-1.16q.6-1 1.38-1.86c.7-.75 1.5-1.25 2.37-1.25M13.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $90f21c32649fad68$export$9ef8f1c6d9629ea6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleInterwovenRegular', "1em", [
    "M11.93 9.98a2.14 2.14 0 0 1 3.28-.02l2.57 3.13c.25.35.28.8.12 1.18l-.08.17c-.34.55-.87 1.43-1.57 2.16-.69.73-1.62 1.4-2.77 1.4-.86 0-1.56-.36-2.16-.74l-.86-.6q-.3-.22-.6-.4l-.2-.1c-.24-.13-.34-.19-.46-.18-.07 0-.24.03-.5.35l-.56.8a2.14 2.14 0 0 1-3.27.21L2.28 14.2a1.2 1.2 0 0 1-.1-1.43l.3-.47a11 11 0 0 1 1.27-1.7c.7-.73 1.62-1.4 2.77-1.4.86 0 1.56.36 2.16.75q.46.3.86.6.41.29.8.5l.28.14q.1.04.18.04c.07 0 .23-.04.5-.35l.56-.8zm2.5.62a1.14 1.14 0 0 0-1.76.05l-3.06 4.39c.24.07.42.18.51.23l.24.13q.36.22.68.44l.82.58c.55.35 1.05.58 1.62.58.75 0 1.43-.43 2.05-1.09.6-.64 1.09-1.43 1.43-2q.07-.13-.01-.27zm-7.9-.4c-.76 0-1.44.44-2.06 1.09a10 10 0 0 0-1.15 1.54l-.28.46q-.08.16.01.27l2.6 3.15c.44.41 1.2.38 1.6-.06l3.15-4.48q-.23-.07-.37-.15l-.15-.08a8 8 0 0 1-.91-.57l-.83-.58a3 3 0 0 0-1.62-.58M13.5 3A2.5 2.5 0 0 1 16 5.5l-.01.26A2.5 2.5 0 0 1 13.5 8L13.24 8a2.5 2.5 0 0 1-2.23-2.23L11 5.5A2.5 2.5 0 0 1 13.5 3m-7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m7 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $90f21c32649fad68$export$45f0ed6dc01a4e37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLinkFilled', "1em", [
    "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 6c0-.98.4-1.86 1.05-2.5H3.5a2 2 0 0 0-2 2s0 4 5.25 4c1.57 0 2.68-.36 3.45-.86A3.5 3.5 0 0 1 9 13.5m3.5-2.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$98423cd7166332fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLinkRegular', "1em", [
    "M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 13c0-1.1.9-2 2-2h6.55q-.45.44-.71 1H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16c1.3 0 2.18-.27 2.8-.63q.27.44.65.77c-.79.5-1.9.86-3.45.86-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V13M12 7.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0m1 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.5 3.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$3e23baeba83765b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleListColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__a)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__b)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__c)",
            "fillOpacity": ".75",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__d)",
            "d": "M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__e)",
            "d": "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__f)",
            "d": "M10 12c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_list_20_color__g)",
            "d": "M12.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "11.8",
                "y2": "17.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "10.29",
                "y2": "20.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__c",
                "x1": "14.5",
                "x2": "8.5",
                "y1": "14.5",
                "y2": "14.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0a1852",
                    "stopOpacity": ".75"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0a1852",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "5.66",
                "y2": "9.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "4.36",
                "y2": "9.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__f",
                "x1": "13.21",
                "x2": "16.66",
                "y1": "10",
                "y2": "18.51",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_list_20_color__g",
                "x1": "9.5",
                "x2": "17",
                "y1": "8.5",
                "y2": "17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0fafff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$712d8af4432c8436 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleListFilled', "1em", [
    "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5m3.75 2.5c0-.48.23-.91.58-1.18A2 2 0 0 0 10 11H3.5a2 2 0 0 0-2 2s0 4 5.25 4c1.95 0 3.18-.55 3.95-1.25q.07-.13.18-.25a1.5 1.5 0 0 1 0-2 1.5 1.5 0 0 1-.38-1m6.5-5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M12 12a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$a225367fa61d9299 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleListRegular', "1em", [
    "M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M10 11a2 2 0 0 1 1.08.32q-.41.32-.54.84A1 1 0 0 0 10 12H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16s3.26-.8 3.74-1.5l.01-.01v.01q.01.58.38 1l-.2.27C9.9 16.47 8.67 17 6.76 17c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V13c0-1.1.9-2 2-2zm3-3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12 12a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$aab63243589020ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLockFilled', "1em", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m1 8.7c-.74.83-2.02 1.55-4.25 1.55-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2H10a2 2 0 0 1 2 2l-.02.28A2 2 0 0 0 11 14zM14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-1 3v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $90f21c32649fad68$export$1924edd4c2756add = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleLockRegular', "1em", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m7.5 8.72C10.23 15.3 8.93 16 6.75 16c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2v.08l-.01.18v.02A2 2 0 0 0 11 14zm-8.5-2.4v.1l.06.32c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15s3.26-.8 3.74-1.5a3 3 0 0 0 .5-1.42l.01-.02V12a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1zM14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m1.5 5.5v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $90f21c32649fad68$export$23e8a2ff3fd508b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleMoneyFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M9 12.5c0-1.1.71-2.04 1.7-2.37A2 2 0 0 0 10 10H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.34-.01 2.26-.31L9 15.5zm8-6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-7 6c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5zm1 0v1c.83 0 1.5-.67 1.5-1.5h-1a.5.5 0 0 1-.5.5m7 1v-1a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5M16.5 16h1c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5M11 14.5v1c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5m3.5 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $90f21c32649fad68$export$beb6c938f41e902d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleMoneyRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M10 10a2 2 0 0 1 .7.13q-.74.26-1.2.87h-6a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15q1.42-.01 2.25-.37v1.06q-.91.3-2.25.31c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12c0-1.1.9-2 2-2zm3-3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10 12.5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5zm1 0v1c.83 0 1.5-.67 1.5-1.5h-1a.5.5 0 0 1-.5.5m7 1v-1a.5.5 0 0 1-.5-.5h-1c0 .83.67 1.5 1.5 1.5M16.5 16h1c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5M11 14.5v1c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5m3.5 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $90f21c32649fad68$export$9cfeb4952faff2e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibitedFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m1 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $90f21c32649fad68$export$fa615b8191c2a0ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleProhibitedRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $90f21c32649fad68$export$f3e6e680567b5593 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueueFilled', "1em", [
    "M8.75 5.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M4 8a1 1 0 0 0-1 1v4.5a3.5 3.5 0 1 0 7 0V9a1 1 0 0 0-1-1zm5.75-2.75c0 .65-.2 1.26-.52 1.76a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.54.8.56 1.83m-.25 11.6A4.5 4.5 0 0 0 11 13.5V9a2 2 0 0 0-.27-1H13a1 1 0 0 1 1 1v4.5a3.5 3.5 0 0 1-4.5 3.35m4.25-11.6c0 .65-.2 1.26-.52 1.76a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.54.8.56 1.83m-.25 11.6A4.5 4.5 0 0 0 15 13.5V9a2 2 0 0 0-.27-1H17a1 1 0 0 1 1 1v4.5a3.5 3.5 0 0 1-4.5 3.35"
]);
const $90f21c32649fad68$export$abf87cf277ca3e50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleQueueRegular', "1em", [
    "M6.5 7.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m0-1a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M3 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.5a3.5 3.5 0 1 1-7 0zm1 0v4.5a2.5 2.5 0 0 0 5 0V9zm5.63-2.86q-.15.46-.4.87a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.29.42.44.94a1.25 1.25 0 0 1 2.12.89 1.25 1.25 0 0 1-2.12.9M9.5 16.85A3.5 3.5 0 0 0 14 13.5V9a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 11 9h2v4.5a2.5 2.5 0 0 1-2.75 2.49q-.32.48-.75.86m4.13-10.7q-.15.46-.4.86a2 2 0 0 1 1.08.48l.19.01a2.25 2.25 0 1 0-1.31-4.08q.29.42.44.94a1.25 1.25 0 0 1 2.12.89 1.25 1.25 0 0 1-2.12.9m-.13 10.7A3.5 3.5 0 0 0 18 13.5V9a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 15 9h2v4.5a2.5 2.5 0 0 1-2.75 2.49q-.32.48-.75.86"
]);
const $90f21c32649fad68$export$c31e30a98cfbb2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSearchFilled', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8m4.87 14.8a8.5 8.5 0 0 1-3.97 1.17 2 2 0 0 0-.34-.53l-2-2A4.5 4.5 0 0 0 8.24 11H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $90f21c32649fad68$export$712eaba2432bcb25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSearchRegular', "1em", [
    "M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0m7.87 10.8a8.5 8.5 0 0 1-3.97 1.17 2 2 0 0 0-.34-.53l-.44-.44a8 8 0 0 0 4.2-1.05A3.4 3.4 0 0 0 16 13a1 1 0 0 0-1-1H8.74q-.19-.54-.5-1H15a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8M4.5 17q1.2-.02 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $90f21c32649fad68$export$3256e470959dd731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettingsFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m3.06-3.06a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$10a0e84f2e6e882a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSettingsRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-2.44 7.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$fd287d4717c3af8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStarFilled', "1em", [
    "M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26 5.5 5.5 0 0 0-1.88 5.4q-.95.33-2.37.34c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2-1.1h-1.55l-.47-1.54a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95"
]);
const $90f21c32649fad68$export$9a571cbec0a3e63d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleStarRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54z"
]);
const $90f21c32649fad68$export$4c0b2fce265a708c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtractFilled', "1em", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M11 10.26a5.5 5.5 0 0 0-1.88 5.4c-.64.2-1.42.34-2.37.34-5.25 0-5.25-4-5.25-4 0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$7e3e2eccfd52a1dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSubtractRegular', "1em", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m0 4.25a2 2 0 0 0-1.99 2.26q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.42-.01 2.37-.35A6 6 0 0 1 9 14.63q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5A3 3 0 0 1 2.5 12a1 1 0 0 1 1-1H10l.23.03q.35-.42.76-.77A2 2 0 0 0 10 10zm11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 14.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$10d3a08c51c18020 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwapFilled', "1em", [
    "M10 6.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m1.35 4.78-1.91 1.9a1.5 1.5 0 0 0 0 2.13l.65.65a6.3 6.3 0 0 1-3.34.79C1.5 17 1.5 13 1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 1.35.53M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-1.65 2.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 15h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 14h-5.58z"
]);
const $90f21c32649fad68$export$1ca0c92e67a22f34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSwapRegular', "1em", [
    "M6.75 4.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 6.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m7.85 4.78A2 2 0 0 0 10 11H3.5a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93 1.48 0 2.56-.32 3.34-.79l-.65-.65-.08-.09c-.6.31-1.44.53-2.61.53-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V13a1 1 0 0 1 1-1H10a1 1 0 0 1 .64.23zM14.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m.85 5.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 15h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 14h-5.58z"
]);
const $90f21c32649fad68$export$f1c449c50d55345a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSyncColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__a)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__b)",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__c)",
            "fillOpacity": ".5",
            "d": "M1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__d)",
            "d": "M14.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__e)",
            "d": "M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__f)",
            "d": "M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_sync_20_color__g)",
            "d": "M16.5 11.5c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__a",
                "x1": "4",
                "x2": "6.15",
                "y1": "11.8",
                "y2": "17.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__b",
                "x1": "6.75",
                "x2": "9.79",
                "y1": "10.29",
                "y2": "20.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__d",
                "x1": "13.19",
                "x2": "15.74",
                "y1": "5.66",
                "y2": "9.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__e",
                "x1": "5.05",
                "x2": "8.36",
                "y1": "4.36",
                "y2": "9.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__f",
                "x1": "10.32",
                "x2": "16.53",
                "y1": "11.69",
                "y2": "18.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_sync_20_color__g",
                "x1": "12",
                "x2": "16.14",
                "y1": "11",
                "y2": "17.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e3ffd9"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_sync_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2 4.64285 -4.64285 2 13 14.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#30116e"
                }
            ],
            [
                "stop",
                {
                    "offset": ".33",
                    "stopColor": "#30116e",
                    "stopOpacity": ".81"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#30116e",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$c71e7395ec59ad23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSyncFilled', "1em", [
    "M6.75 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M17 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-8 8c0-1.7.78-3.23 2-4.24a2 2 0 0 0-1-.26H3.5a2 2 0 0 0-2 2s0 4 5.25 4q1.42-.01 2.37-.35A6 6 0 0 1 9 14.5m1 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $90f21c32649fad68$export$eefb053b613159da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleSyncRegular', "1em", [
    "M4.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.75 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1 .26q-.42.35-.77.77L10 11H3.5a1 1 0 0 0-1 1v.16l.06.33c.07.27.2.64.45 1C3.49 14.2 4.5 15 6.75 15c.95 0 1.69-.15 2.25-.37q.02.53.12 1.02-.95.34-2.37.35c-2.51 0-3.87-.92-4.57-1.93a4 4 0 0 1-.68-1.99V12M13 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $90f21c32649fad68$export$c44df33a603ac45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__a)",
            "d": "M16.75 8h-2.5C13.56 8 13 8.56 13 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C18 8.56 17.44 8 16.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__b)",
            "fillOpacity": ".5",
            "d": "M16.75 8h-2.5C13.56 8 13 8.56 13 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C18 8.56 17.44 8 16.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "red",
            "fillOpacity": ".2",
            "d": "M5.75 8h-2.5C2.56 8 2 8.56 2 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C7 8.56 6.44 8 5.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__c)",
            "d": "M5.75 8h-2.5C2.56 8 2 8.56 2 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C7 8.56 6.44 8 5.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__d)",
            "fillOpacity": ".5",
            "d": "M5.75 8h-2.5C2.56 8 2 8.56 2 9.25v4.25a2.5 2.5 0 0 0 5 0V9.25C7 8.56 6.44 8 5.75 8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__e)",
            "d": "M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__f)",
            "d": "M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__g)",
            "d": "M17.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__h)",
            "d": "M17.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__i)",
            "d": "M6.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__j)",
            "d": "M6.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_people_team_20_color__k)",
            "d": "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__a",
                "x1": "14.19",
                "x2": "18.72",
                "y1": "9.06",
                "y2": "13.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__c",
                "x1": "3.19",
                "x2": "7.72",
                "y1": "9.06",
                "y2": "13.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__e",
                "x1": "7.9",
                "x2": "13.4",
                "y1": "9.33",
                "y2": "16.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__f",
                "x1": "10",
                "x2": "18.37",
                "y1": "6.81",
                "y2": "19.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#885edb",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#e362f8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__g",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__h",
                "x1": "14.45",
                "x2": "16.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#7a41dc"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__i",
                "x1": "3.45",
                "x2": "5.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__j",
                "x1": "3.45",
                "x2": "5.49",
                "y1": "3.53",
                "y2": "6.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_people_team_20_color__k",
                "x1": "8.69",
                "x2": "11.24",
                "y1": "2.66",
                "y2": "6.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bd96ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#9c6cfe"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.02372 0 0 10.9215 12.21 11.81)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_people_team_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4.45292 0 0 -12.0865 8.62 11.81)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".43",
                    "stopColor": "#3b148a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#3b148a",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$2d1e3f8fdad4e16b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamFilled', "1em", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.69 0 1.25.56 1.25 1.25V14a4 4 0 0 1-8 0zm-1 0q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zM15 14q0 1.06-.4 1.97.2.03.4.03a3 3 0 0 0 3-3V9.25C18 8.56 17.44 8 16.75 8h-2.13q.37.55.38 1.25z"
]);
const $90f21c32649fad68$export$d2fd5f70dc4c877e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamRegular', "1em", [
    "M10 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m8-.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-10 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m.6 12H5a2 2 0 0 1-2-2V9.25c0-.14.11-.25.25-.25h1.76q.06-.55.37-1H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97 5 5 0 0 1-.3-.97m9.5.97q.2.03.4.03a3 3 0 0 0 3-3V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h1.76q.23.02.25.25V13a2 2 0 0 1-2.1 2q-.1.5-.3.97M7.25 8C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 8 0V9.25C14 8.56 13.44 8 12.75 8zM7 9.25c0-.14.11-.25.25-.25h5.5q.23.02.25.25V14a3 3 0 1 1-6 0z"
]);
const $90f21c32649fad68$export$94f4f47bd053af04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamAddFilled', "1em", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.61 0 1.12.44 1.23 1.02A5.5 5.5 0 0 0 10.25 18L10 18a4 4 0 0 1-4-4zm8.99-.23c1.14.1 2.18.55 3.01 1.24V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.46.37 1.02M5 9.25q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zm14 5.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$4ed953cebec5bfbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamAddRegular', "1em", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-11 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 15h.1q.1.5.3.97-.2.03-.4.03a3 3 0 0 1-3-3V9.25C2 8.56 2.56 8 3.25 8h2.13q-.3.45-.37 1H3.25a.25.25 0 0 0-.25.25V13c0 1.1.9 2 2 2m8.98-6c-.12-.57-.63-1-1.23-1h-5.5C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 4.25 4 6 6 0 0 1-.66-1.03A3 3 0 0 1 7 14V9.25c0-.14.11-.25.25-.25zm1 0h1.77q.23.02.25.25v.35q.54.27 1 .66V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1m-.48 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 2c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$dd6d7d7d18c7ea6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDeleteFilled', "1em", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.61 0 1.12.44 1.23 1.02A5.5 5.5 0 0 0 10.25 18L10 18a4 4 0 0 1-4-4zm8.99-.23c1.14.1 2.18.55 3.01 1.24V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.46.37 1.02M5 9.25q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zm14 5.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $90f21c32649fad68$export$6c589d2b6b826211 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamDeleteRegular', "1em", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-11 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 15h.1q.1.5.3.97-.2.03-.4.03a3 3 0 0 1-3-3V9.25C2 8.56 2.56 8 3.25 8h2.13q-.3.45-.37 1H3.25a.25.25 0 0 0-.25.25V13c0 1.1.9 2 2 2m8.98-6c-.12-.57-.63-1-1.23-1h-5.5C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 4.25 4 6 6 0 0 1-.66-1.03A3 3 0 0 1 7 14V9.25c0-.14.11-.25.25-.25zM18 10.26V9.25C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h1.76q.23.02.25.25v.35q.54.27 1 .66M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-5.65-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14a.5.5 0 0 1 .7.7"
]);
const $90f21c32649fad68$export$19c5f5b00cfb176e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamToolboxFilled', "1em", [
    "M12.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 9.25C6 8.56 6.56 8 7.25 8h5.5c.6 0 1.1.43 1.22 1h-.47a2.5 2.5 0 0 0-2.46 2.04A2.5 2.5 0 0 0 9 13.5v4q0 .2.03.38A4 4 0 0 1 6 14zm11.96 1.8H18v-1.8C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h.51a2.5 2.5 0 0 1 2.46 2.04M5 9.24q.01-.7.38-1.25H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.4 2.97Q5 15.06 5 14zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0"
]);
const $90f21c32649fad68$export$664115a03b206af7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleTeamToolboxRegular', "1em", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-11 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 15h.1q.1.5.3.97-.2.03-.4.03a3 3 0 0 1-3-3V9.25C2 8.56 2.56 8 3.25 8h2.13q-.3.45-.37 1H3.25a.25.25 0 0 0-.25.25V13c0 1.1.9 2 2 2m12-5.5c.5.37.84.91.96 1.54l.04.01v-1.8C18 8.56 17.44 8 16.75 8h-2.13q.3.45.37 1h1.76q.23.02.25.25zm-1.5.5h-2c-.83 0-1.5.67-1.5 1.5v.5h-.5c-.83 0-1.5.67-1.5 1.5V15h2v-.5a.5.5 0 0 1 1 0v.5h3v-.5a.5.5 0 0 1 1 0v.5h2v-1.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5M7.25 9a.25.25 0 0 0-.25.25V14a3 3 0 0 0 2 2.83v.67q0 .2.03.38A4 4 0 0 1 6 14V9.25C6 8.56 6.56 8 7.25 8h5.5c.6 0 1.1.43 1.22 1zM13 12v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v.5zm4 4v.5a.5.5 0 0 1-1 0V16h-3v.5a.5.5 0 0 1-1 0V16h-2v1.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V16z"
]);
const $90f21c32649fad68$export$52a16d17daf35b80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleToolboxFilled', "1em", [
    "M10 5.75a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0M14.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-3.26 1.43q-.14.3-.2.61A2.5 2.5 0 0 0 9 13.5v2.2q-.92.29-2.25.3C1.5 16 1.5 12 1.5 12c0-1.1.9-2 2-2H10a2 2 0 0 1 1.24.43M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$208b681ef15c5c37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PeopleToolboxRegular', "1em", [
    "M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M14.5 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m-3.26 1.43A2 2 0 0 0 10 10H3.5a2 2 0 0 0-2 2v.08l.01.18q.01.17.08.45c.08.37.25.86.6 1.36.7 1.01 2.05 1.93 4.56 1.93q1.33 0 2.25-.3v-1.07q-.83.35-2.25.37c-2.24 0-3.26-.8-3.74-1.5a3 3 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10a1 1 0 0 1 .57.18q.22-.08.47-.14.05-.32.2-.6M14.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5m4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$9d450dc0f591801f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_20_color__a)",
            "d": "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_20_color__b)",
            "d": "M9 14h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.84 1.25 4.92)scale(20.5294 40.0975)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#cb7df8"
                }
            ],
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(40.86 -14.86 17.81)scale(5.24774 6.16903)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d1d1ff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$2de862feea185790 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFilled', "1em", [
    "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5zM9 14h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1"
]);
const $90f21c32649fad68$export$203beed4b56acf83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneRegular', "1em", [
    "M9 14a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $90f21c32649fad68$export$2afe6a64e2c57cad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneAddFilled', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52A5.5 5.5 0 0 1 14 9.02V3.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$a0b7df796f74b6ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneAddRegular', "1em", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52q-.51.05-1 .19V3.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h4.1q.27.54.66 1H5.5A1.5 1.5 0 0 1 4 16.5zM9.02 14a6 6 0 0 0 0 1H7.5a.5.5 0 0 1 0-1zm9.98.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $90f21c32649fad68$export$837d68da66de709f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneArrowRightFilled', "1em", [
    "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 0 0 9.02 14H7.5a.5.5 0 0 0 0 1h1.52c.1 1.13.55 2.17 1.24 3H5.5A1.5 1.5 0 0 1 4 16.5zM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $90f21c32649fad68$export$7503ba37b611346e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneArrowRightRegular', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a6 6 0 0 1-.66-1H5.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7q.49-.13 1-.18V3.5c0-.83-.67-1.5-1.5-1.5zM9 14.5q0-.26.02-.5H7.5a.5.5 0 0 0 0 1h1.52zm5.5-4.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $90f21c32649fad68$export$1e749b68e3901ddc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChatFilled', "1em", [
    "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h2.62l.37-1.23A5.48 5.48 0 0 1 15 9.02V3.5c0-.83-.67-1.5-1.5-1.5zm8 17a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $90f21c32649fad68$export$b0ec8bff16bcdc42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneChatRegular', "1em", [
    "M9.42 17H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.02a6 6 0 0 1 1 0V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2.12zm5.08 2a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54q.98.55 2.18.56M12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
]);
const $90f21c32649fad68$export$abf7e739e294392f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmarkFilled', "1em", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L12.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M6.5 2h2.76A5.5 5.5 0 0 0 15 10.8v5.7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5v-13C5 2.67 5.67 2 6.5 2M8 14.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5"
]);
const $90f21c32649fad68$export$59bbf83a7fed979b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneCheckmarkRegular', "1em", [
    "M18 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0L12.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7M9.25 2H6.5C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.7q-.49.13-1 .18v5.52a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h2.1q.27-.54.66-1M8 14.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$86bd7ba57652ffa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktopFilled', "1em", [
    "M6 2a2 2 0 0 0-2 2v3h2.5A2.5 2.5 0 0 1 9 9.5V13h3v2H9v1h5.5a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$75f77bb723b09ab7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktopRegular', "1em", [
    "M6 3h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H9v1h3v2H9v1h5.5a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3h1V4a1 1 0 0 1 1-1M4.5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$95f9c264cc64d7de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktopAddFilled', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V11a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1H9v-1h3v-2H9V9.5A2.5 2.5 0 0 0 6.5 7H4V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 0 0 4.24 9m-11-3C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$fdafa957dc31ce0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDesktopAddRegular', "1em", [
    "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15zm2 7.5v-.6q.54-.27 1-.66V11a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1H9v-1h3v-2H9v-1h7a1 1 0 0 0 1-1m-6.74-9q-.39.46-.66 1H6a1 1 0 0 0-1 1v3H4V4c0-1.1.9-2 2-2zM4 15.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m-2-6C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5zM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$8a0aeb599943907a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDismissFilled', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52A5.5 5.5 0 0 1 14 9.02V3.5c0-.83-.67-1.5-1.5-1.5zm9 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $90f21c32649fad68$export$b37c0051f418d769 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneDismissRegular', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a6 6 0 0 1-.66-1H5.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7q.49-.13 1-.18V3.5c0-.83-.67-1.5-1.5-1.5zM9 14.5q0-.26.02-.5H7.5a.5.5 0 0 0 0 1h1.52zm10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15z"
]);
const $90f21c32649fad68$export$fc321d0e4bbffb45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEditFilled', "1em", [
    "m15.8 1.55-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64m-5.53 4.12 3.62-3.62A2 2 0 0 0 13.5 2h-7C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V9.06l-.67.67q-.62.61-1.48.84l-1.5.37a1.9 1.9 0 0 1-2.3-2.29l.38-1.5a3 3 0 0 1 .84-1.48M9 14h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1"
]);
const $90f21c32649fad68$export$40271ee0aa9b8aa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEditRegular', "1em", [
    "m15.8 1.55-4.82 4.83a2 2 0 0 0-.58 1.02l-.37 1.5a.9.9 0 0 0 1.08 1.07l1.5-.37q.58-.16 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64M12.95 3l.84-.84A2 2 0 0 0 13 2H7a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V9.06l-.67.67q-.15.15-.33.29V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM9 14a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$d79f29bb27283c37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEraserFilled', "1em", [
    "M14.58 1.44a1.5 1.5 0 0 1 2.12 0l1.86 1.86a1.5 1.5 0 0 1 0 2.12l-5.14 5.14a1.5 1.5 0 0 1-2.12 0L9.44 8.7a1.5 1.5 0 0 1 0-2.12zm-4.43 5.84a.5.5 0 0 0 0 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6zM12.6 2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.11a2.5 2.5 0 0 1-3.4-.12L8.72 9.4a2.5 2.5 0 0 1 0-3.54zm-2.1 12.5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1 0-1h2c.28 0 .5.22.5.5"
]);
const $90f21c32649fad68$export$caaf3b7a7c0a6acf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneEraserRegular', "1em", [
    "M14.58 1.44a1.5 1.5 0 0 1 2.12 0l1.86 1.86a1.5 1.5 0 0 1 0 2.12l-5.14 5.14a1.5 1.5 0 0 1-2.12 0L9.44 8.7a1.5 1.5 0 0 1 0-2.12zm-4.43 5.84a.5.5 0 0 0 0 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6zm2.38-5.2A2 2 0 0 0 12 2H6a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-4.61q-.46.38-1 .53V16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5.6zM7.5 14.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$1761ec64bfc145e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFooterArrowDownFilled', "1em", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 13.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m5.35-3.65-2 2A.5.5 0 0 1 10 14a.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V9.5a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7"
]);
const $90f21c32649fad68$export$794dff0450405b05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneFooterArrowDownRegular', "1em", [
    "M7 15.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm5.35 8.85-2 2A.5.5 0 0 1 10 14a.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V9.5a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7"
]);
const $90f21c32649fad68$export$6590bf913d22eb8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneHeaderArrowUpFilled', "1em", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m5.35 3.65a.5.5 0 0 1-.7.7L10.5 7.71v2.79a.5.5 0 0 1-1 0V7.7L8.35 8.86a.5.5 0 1 1-.7-.7l2-2A.5.5 0 0 1 10 6a.5.5 0 0 1 .35.14z"
]);
const $90f21c32649fad68$export$913d54ee33cf3ed3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneHeaderArrowUpRegular', "1em", [
    "M7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm5.35 5.15-2-2A.5.5 0 0 0 10 6a.5.5 0 0 0-.35.15l-2 2a.5.5 0 1 0 .7.7L9.5 7.71v2.79a.5.5 0 0 0 1 0V7.7l1.15 1.15a.5.5 0 0 0 .7-.7"
]);
const $90f21c32649fad68$export$6c258b2c73f8057e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneKeyFilled', "1em", [
    "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5H9v-1q.01-.63.44-1.06l.94-.94H9a.5.5 0 0 1 0-1h2q.15 0 .29.1l.73-.74-.02-.42q0-.83.33-1.56A4.1 4.1 0 0 1 15 9.13V3.5c0-.83-.67-1.5-1.5-1.5zm4 17a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
]);
const $90f21c32649fad68$export$a9e9549149c7afab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneKeyRegular', "1em", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2v-1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.54a4 4 0 0 1 1-.4V4a2 2 0 0 0-2-2zm3.38 13 .91-.9A.5.5 0 0 0 11 14H9a.5.5 0 0 0 0 1zm.12 4a.5.5 0 0 1-.35-.15.5.5 0 0 1-.15-.35V17q0-.2.15-.35l2.94-2.94a4 4 0 0 1-.09-.77q0-.6.24-1.14a3 3 0 0 1 1.61-1.57q.54-.21 1.15-.23a3 3 0 0 1 2.13.88A3 3 0 0 1 15 15.83v.69a1 1 0 0 1-.08.24 1 1 0 0 1-.15.17.5.5 0 0 1-.27.07H14q0 .36-.02.56a.5.5 0 0 1-.11.3.5.5 0 0 1-.3.12L13 18v.27q0 .13-.02.25l-.06.24a.4.4 0 0 1-.15.17 1 1 0 0 1-.27.07zm7-6.75q0-.31-.22-.53a.7.7 0 0 0-.53-.22q-.31 0-.53.22a.7.7 0 0 0-.22.53q0 .31.22.53.21.22.53.22.31 0 .53-.22a.7.7 0 0 0 .22-.53"
]);
const $90f21c32649fad68$export$5aba5c5f1479902f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptopColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__a)",
            "d": "M15.76 13H4.24a1 1 0 0 0-.45.1l-1.34.68a.8.8 0 0 0-.45.72c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5.8.8 0 0 0-.45-.72l-1.34-.67a1 1 0 0 0-.45-.11"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__b)",
            "d": "M2.5 14a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__c)",
            "d": "M4.5 4C3.67 4 3 4.67 3 5.5v6c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__d)",
            "fillOpacity": ".3",
            "d": "M3 5.5C3 4.67 3.67 4 4.5 4h11c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h.26a1 1 0 0 1 .45.1l1.34.68a.8.8 0 0 1 .45.72.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5c0-.3.17-.59.45-.72l1.34-.67a1 1 0 0 1 .45-.11h.26A1.5 1.5 0 0 1 3 11.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__e)",
            "d": "M2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_phone_laptop_20_color__f)",
            "d": "M5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.5 0 0 5.59375 6 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#4a43cb"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4a43cb",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(61.76 -2.57 1.82)scale(18.0277 35.5671)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f08af4"
                }
            ],
            [
                "stop",
                {
                    "offset": ".54",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4e44db"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.32 -12.91 11.7)scale(3.03418 3.47746)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#decbff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d6cfff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__a",
                "x1": "18",
                "x2": "17.54",
                "y1": "14.86",
                "y2": "11.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#63686e"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#889096"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__b",
                "x1": "18",
                "x2": "17.88",
                "y1": "14.93",
                "y2": "13.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#889096"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#aab3bd"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_phone_laptop_20_color__c",
                "x1": "12.8",
                "x2": "13.28",
                "y1": "4",
                "y2": "14.3",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#6ce0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#4894fe"
                }
            ]
        ]
    ]
], {
    color: true
});
const $90f21c32649fad68$export$1108200fd7000d92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptopFilled', "1em", [
    "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 0 0-2-2H3zM10 15h7.5a.5.5 0 0 0 0-1H10zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5zM5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$d473505ef3e9d6e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLaptopRegular', "1em", [
    "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V6H3zM10 15h7.5a.5.5 0 0 0 0-1H10zm-5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5zM3.5 8a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$b8a74f35f2df7ae9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLinkSetupFilled', "1em", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.52L14.5 9a5.5 5.5 0 0 0-4.24 9H6.5A1.5 1.5 0 0 1 5 16.5zm7.07 7.94a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$9a3f024cf7a2ec72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLinkSetupRegular', "1em", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h3.26a6 6 0 0 1-.66-1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.02a6 6 0 0 1 1 0V4a2 2 0 0 0-2-2zm5.07 9.44a2 2 0 0 1-1.44 2.48l-.46.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $90f21c32649fad68$export$2232a10e631597cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLockFilled', "1em", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.54A3 3 0 0 0 11.5 12v.06A2 2 0 0 0 10 14H8.5a.5.5 0 0 0 0 1H10v3H6.5A1.5 1.5 0 0 1 5 16.5zm7.5 8.5v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $90f21c32649fad68$export$83aa6af685eb08d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneLockRegular', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5.04a3 3 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3v1H7a2 2 0 0 1-2-2zm3.5 10H10v1H8.5a.5.5 0 0 1 0-1m4-2v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $90f21c32649fad68$export$24a8be8fbc25afbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePageHeaderFilled', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v1H5zm0 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V6z"
]);
const $90f21c32649fad68$export$5730991388002b38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePageHeaderRegular', "1em", [
    "M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 5h8v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $90f21c32649fad68$export$ae1bede361ce423b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePaginationFilled', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm3 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"
]);
const $90f21c32649fad68$export$22e3e538d9a84a34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhonePaginationRegular', "1em", [
    "M8 15a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $90f21c32649fad68$export$675570a80cf649c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneScreenTimeFilled', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52A5.5 5.5 0 0 1 14 9.02V3.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$5d519cfff483247 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneScreenTimeRegular', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a6 6 0 0 1-.66-1H5.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7q.49-.13 1-.18V3.5c0-.83-.67-1.5-1.5-1.5zM9 14.5q0 .26.02.5H7.5a.5.5 0 0 1 0-1h1.52zm10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$3f34e045498668c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneShakeFilled', "1em", [
    "M15.37 2.93a.5.5 0 1 1 .5-.86q.2.12.4.26a4.25 4.25 0 0 1 1.24 5.4.5.5 0 0 1-.89-.47 3.25 3.25 0 0 0-1.25-4.33m-1 1.74a.5.5 0 1 1 .5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 0 1-.9-.42c.27-.58.06-1.29-.5-1.61m-9.74 12.4a.5.5 0 1 1-.5.86l-.4-.26a4.25 4.25 0 0 1-1.24-5.4.5.5 0 1 1 .89.46 3.25 3.25 0 0 0 1.25 4.33m1-1.74a.5.5 0 1 1-.5.87 2.25 2.25 0 0 1-.92-2.9.5.5 0 0 1 .9.42c-.26.58-.05 1.28.52 1.61m4.54-12.26a1.95 1.95 0 0 1 2.4 1.4l2.37 8.97a2.04 2.04 0 0 1-1.42 2.48l-3.69 1a1.95 1.95 0 0 1-2.4-1.4L5.08 6.57a2.04 2.04 0 0 1 1.42-2.49zm-.49 11.3c.07.27.34.43.6.36l1.79-.48a.5.5 0 0 0 .36-.62.5.5 0 0 0-.6-.36l-1.78.49a.5.5 0 0 0-.37.62"
]);
const $90f21c32649fad68$export$4fc9afed70af1e67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneShakeRegular', "1em", [
    "M15.37 2.93a.5.5 0 1 1 .5-.86q.2.12.4.26a4.25 4.25 0 0 1 1.24 5.4.5.5 0 0 1-.89-.47 3.25 3.25 0 0 0-1.25-4.33m-1 1.74a.5.5 0 1 1 .5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 0 1-.9-.42c.27-.58.06-1.29-.5-1.61m-9.74 12.4a.5.5 0 1 1-.5.86l-.4-.26a4.25 4.25 0 0 1-1.24-5.4.5.5 0 1 1 .89.46 3.25 3.25 0 0 0 1.25 4.33m1-1.74a.5.5 0 1 1-.5.87 2.25 2.25 0 0 1-.92-2.9.5.5 0 0 1 .9.42c-.26.58-.05 1.28.52 1.61m5.97-10.6a.96.96 0 0 0-1.17-.7l-3.7 1.01c-.52.14-.84.7-.7 1.25l2.37 8.98c.14.53.67.83 1.18.7l3.68-1.01c.53-.15.85-.7.7-1.25zm-1.43-1.66a1.95 1.95 0 0 1 2.4 1.4l2.36 8.97a2.04 2.04 0 0 1-1.41 2.48l-3.69 1a1.95 1.95 0 0 1-2.4-1.4L5.07 6.57a2.04 2.04 0 0 1 1.41-2.49zm-.49 11.3a.5.5 0 0 1 .36-.61l1.79-.48c.26-.08.53.08.6.35s-.1.54-.36.62l-1.78.48a.5.5 0 0 1-.6-.35"
]);
const $90f21c32649fad68$export$a786be181ca83055 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanInFilled', "1em", [
    "M7 2a2 2 0 0 0-2 2v3.09a1.5 1.5 0 0 1 1.56.35l2 2a1.5 1.5 0 0 1 0 2.12l-2 2a1.5 1.5 0 0 1-1.56.35V16c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2.09a1.5 1.5 0 0 1-1.56-.35l-2-2a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 15 7.09V4a2 2 0 0 0-2-2zm7.85 6.15c.2.2.2.5 0 .7L13.71 10h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2c.2-.2.5-.2.7 0m-9.7.7a.5.5 0 1 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L6.29 11H3.5a.5.5 0 0 1 0-1h2.8z"
]);
const $90f21c32649fad68$export$343b87a8f2580ec2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanInRegular', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v3.09a1.5 1.5 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.09a1.5 1.5 0 0 0-1 0zm0 9.91V16c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2.09a1.5 1.5 0 0 1-1 0V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2.09a1.5 1.5 0 0 1-1 0m2.85-3.06-2 2a.5.5 0 0 1-.7-.7L6.29 11H3.5a.5.5 0 0 1 0-1h2.8L5.14 8.85a.5.5 0 1 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35m6.3-2.7-2 2a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 11h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7"
]);
const $90f21c32649fad68$export$4a21d452417f6e42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOutFilled', "1em", [
    "M7 2a2 2 0 0 0-2 2v3.09A1.5 1.5 0 0 1 6.91 9h.59a1.5 1.5 0 1 1 0 3h-.59A1.5 1.5 0 0 1 5 13.91V16c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2.09A1.5 1.5 0 0 1 13.09 12h-.59a1.5 1.5 0 0 1 0-3h.59A1.5 1.5 0 0 1 15 7.09V4a2 2 0 0 0-2-2zm7.85 6.15a.5.5 0 0 0-.7.7L15.29 10H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM4.71 10l1.14-1.15h.01a.5.5 0 0 0-.71-.7l-2 2a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L4.71 11H7.5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$15658851a67bb6e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpanOutRegular', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v3.09a1.5 1.5 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.09a1.5 1.5 0 0 0-1 0zm0 9.91q.5.18 1 0V16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.09q.5.18 1 0V16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm-1.85-3.76 2-2a.5.5 0 1 1 .7.7L4.71 10H7.5a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 0 1-.7.7l-2-2A.5.5 0 0 1 3 10.5a.5.5 0 0 1 .14-.35m11.7 2.7 2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 10H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7"
]);
const $90f21c32649fad68$export$c9ac137b9221e476 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpeakerFilled', "1em", [
    "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.99A1.5 1.5 0 0 1 9 16.5V15H8a.5.5 0 0 1 0-1h1.09c.2-.58.76-1 1.41-1h.38l1.56-1.56a1.5 1.5 0 0 1 1.56-.35V3.5c0-.83-.67-1.5-1.5-1.5zm8.2 10.04q.29.14.3.46v6a.5.5 0 0 1-.85.35L11.29 17h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.95.16q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 0 1 .8-.6m-1.43 1.77q-.16-.46-.27-.7a.5.5 0 1 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22q0-.76-.28-1.53"
]);
const $90f21c32649fad68$export$495be0cf91db8a52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneSpeakerRegular', "1em", [
    "M8 14a.5.5 0 0 0 0 1h1v-.5q0-.26.09-.5zm-2 3h3.09c.2.58.75 1 1.4 1H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v7.09a1.5 1.5 0 0 0-1 0V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m7.7-4.96q.29.14.3.46v6a.5.5 0 0 1-.85.35L11.29 17h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11m3.95.16q.2.24.44.87.4 1.03.41 2.43-.01 1.41-.4 2.43-.25.62-.45.87a.5.5 0 0 1-.85-.52l.12-.19q.1-.16.24-.52a6 6 0 0 0 .34-2.07 6 6 0 0 0-.58-2.6l-.07-.1a.5.5 0 0 1 .8-.6m-1.43 1.77q-.16-.46-.27-.7a.5.5 0 1 0-.9.45 5 5 0 0 1 .45 1.78 4 4 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22q0-.76-.28-1.53"
]);
const $90f21c32649fad68$export$1204318282d5b1be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneStatusBarFilled', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2.5 0a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$9d740daf28e71294 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneStatusBarRegular', "1em", [
    "M7.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
]);
const $90f21c32649fad68$export$364a748ce884da56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneTabletFilled', "1em", [
    "M4 4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-2h2.5a.5.5 0 0 0 0-1H10V8a2 2 0 0 0-2-2H4zM3.5 7C2.67 7 2 7.67 2 8.5v8c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-8C9 7.67 8.33 7 7.5 7zm1 8.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5"
]);
const $90f21c32649fad68$export$a3303f3e96d83081 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneTabletRegular', "1em", [
    "M5.84 4a.83.83 0 0 0-.84.8V6H4V4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-1h6.16c.48 0 .84-.37.84-.8V4.8c0-.43-.36-.8-.84-.8zM10 12h2.5a.5.5 0 0 0 0-1H10zm-5 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5zM3.5 8a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$62b026f2d85af1e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateFilled', "1em", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zm5.5 3a.5.5 0 0 0-1 0v5.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7l-1.15 1.14z"
]);
const $90f21c32649fad68$export$ba78a59152b26fc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateRegular', "1em", [
    "M10 6c.28 0 .5.22.5.5v5.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2A.5.5 0 0 1 10 14a.5.5 0 0 1-.35-.15l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V6.5c0-.28.22-.5.5-.5M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zM6.5 3a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$8047d0f9c2916187 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateCheckmarkFilled', "1em", [
    "M5 16c0 1.1.9 2 2 2h3.26a5.5 5.5 0 0 1-.76-5.8v-5L8.35 8.36a.5.5 0 1 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L10.5 7.21v3.52a5.5 5.5 0 0 1 4.5-1.7V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2zm14-1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$89d7d76028c9364c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneUpdateCheckmarkRegular', "1em", [
    "M6 16a1 1 0 0 0 1 1h2.6q.27.54.66 1H7a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5.02a6 6 0 0 0-1 0V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3.5-3.8q.39-.82 1-1.47V7.2l1.15 1.14a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L9.5 7.21zm9.5 2.3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $90f21c32649fad68$export$7e3472a152fdf665 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVerticalScrollFilled', "1em", [
    "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zm7.35 5.35a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L10 7.21l1.65 1.64c.2.2.5.2.7 0m-4.7 2.3a.5.5 0 0 0 0 .7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L10 12.79l-1.65-1.64a.5.5 0 0 0-.7 0"
]);
const $90f21c32649fad68$export$e4848bffda488eb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVerticalScrollRegular', "1em", [
    "M7.65 11.15c.2-.2.5-.2.7 0L10 12.79l1.65-1.64a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7m4-2.3a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L10 7.21zM5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 16.5zM6.5 3a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
]);
const $90f21c32649fad68$export$3471f655e78b8199 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVibrateFilled', "1em", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm3.5 10.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM2.92 7.22a.5.5 0 0 0-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 1 0 .84-.56l-.38-.57a1.4 1.4 0 0 1-.1-1.43c.4-.78.34-1.7-.14-2.43zm13.3-.14a.5.5 0 0 1 .7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 1 1-.84.56l-.38-.57a2.4 2.4 0 0 1-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 0 1 .14-.7"
]);
const $90f21c32649fad68$export$e3ec01170208de35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhoneVibrateRegular', "1em", [
    "M8.5 14.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM2.92 7.22a.5.5 0 0 0-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 1 0 .84-.56l-.38-.57a1.4 1.4 0 0 1-.1-1.43c.4-.78.34-1.7-.14-2.43zm13.3-.14a.5.5 0 0 1 .7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 1 1-.84.56l-.38-.57a2.4 2.4 0 0 1-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 0 1 .14-.7"
]);
const $90f21c32649fad68$export$8859b040a06ae906 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhotoFilterFilled', "1em", [
    "M6.26 13.74a6 6 0 1 1 7.48-7.48 6 6 0 1 1-7.48 7.48M3.5 8A4.5 4.5 0 0 0 6 12.03V12a6 6 0 0 1 6.03-6A4.5 4.5 0 0 0 3.5 8m4.47 6A4.5 4.5 0 1 0 14 7.97V8a6 6 0 0 1-6 6z"
]);
const $90f21c32649fad68$export$ab2b00f01c7d3d33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PhotoFilterRegular', "1em", [
    "M2 8a6 6 0 0 0 4.26 5.74 6 6 0 1 0 7.48-7.48A6 6 0 0 0 2 8m6-5a5 5 0 0 1 4.6 3.03L12 6a6 6 0 0 0-5.97 6.6A5 5 0 0 1 8 3m9 9a5 5 0 0 1-9.6 1.97L8 14a6 6 0 0 0 5.97-6.6A5 5 0 0 1 17 12"
]);
const $90f21c32649fad68$export$69472287522206a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PowerFilled', "1em", [
    "M10.75 2.5a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zm3 1.5a.75.75 0 1 0-.76 1.3A6 6 0 1 1 7 5.3.75.75 0 1 0 6.25 4a7.5 7.5 0 1 0 7.5 0"
]);
const $90f21c32649fad68$export$bef43d869f4f4cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PowerRegular', "1em", [
    "M10.5 2.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zM13.74 4a.5.5 0 1 0-.5.87 6.5 6.5 0 1 1-6.49 0 .5.5 0 1 0-.5-.87 7.5 7.5 0 1 0 7.5 0"
]);
const $90f21c32649fad68$export$8285248fc1ed39df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCodeFilled', "1em", [
    "M13 11h-2v2h2v2h-2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2v2h-2zM5 5h2v2H5zm0-2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5zM5 13h2v2H5zm0-2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5zM13 5h2v2h-2zm0-2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-.75 1.75c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5z"
]);
const $90f21c32649fad68$export$c0724952f03966f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('QrCodeRegular', "1em", [
    "M11 15h2v2h-2zm4 0h2v2h-2zm-4-4h2v2h-2zm2 2h2v2h-2zm2-2h2v2h-2zM3 5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 1h2v2H5zm-2 8c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm0 1h2v2H5zm6-8c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 1h2v2h-2z"
]);
const $90f21c32649fad68$export$da89e7067a3684d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeFilled', "1em", [
    "M8.5 3H6a3 3 0 0 0-3 3v.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1M3 14a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3zm10.5 3a.5.5 0 0 1 0-1h.5a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3zM17 8.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-2.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3z"
]);
const $90f21c32649fad68$export$8786f600fe586103 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeRegular', "1em", [
    "M8.5 3H6a3 3 0 0 0-3 3v.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1M5.8 15.99A2 2 0 0 1 4 14v-3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H6zM3 14a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3zm10.5 3a.5.5 0 0 1 0-1h.5a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3zM17 8.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-2.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3z"
]);
const $90f21c32649fad68$export$b86efc286117c23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeImageFilled', "1em", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2zM18 11.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25zM1 12.5A2.5 2.5 0 0 1 3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0L1.4 17.88q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $90f21c32649fad68$export$cf8c791eeb7342a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeImageRegular', "1em", [
    "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zm6.5 9.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3zm-17 1A2.5 2.5 0 0 1 3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4q-.01.77-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0L1.4 17.88q-.4-.6-.41-1.38zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-5.88 5.84q.6.4 1.38.41h4q.77-.01 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0z"
]);
const $90f21c32649fad68$export$5025f4cec08f5dad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLargeFilled', "1em", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zm1 1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm8-1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 14.5 3h-1a.5.5 0 0 0 0 1zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-9 0A1.5 1.5 0 0 1 4 14.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 5.5 17h1.25a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$2ef707022164aead = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeLargeRegular', "1em", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0zM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM6 6.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5z"
]);
const $90f21c32649fad68$export$e433805e07687e45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmallFilled', "1em", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zm3 3C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zm6-3c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 14.5 3h-1a.5.5 0 0 0 0 1zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1zm-9 0A1.5 1.5 0 0 1 4 14.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 5.5 17h1.25a.5.5 0 0 0 0-1z"
]);
const $90f21c32649fad68$export$ceb0fb3914c92f51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeSmallRegular', "1em", [
    "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1zM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0zM8.5 7C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM8 8.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
]);
const $90f21c32649fad68$export$ef85c9f899a8ab4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeTableFilled', "1em", [
    "M5 2a3 3 0 0 0-3 3v2.35q.43-.49 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm10 16h-2.35q.49-.43.81-1H15a2 2 0 0 0 2-2v-3.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3M11.5 2a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zM5 7a3 3 0 0 0-3 3h3zm0 4v3H2v-3zm0 4H2a3 3 0 0 0 3 3zm1 0h3v3H6zm0-1h3v-3H6zm4 1h3a3 3 0 0 1-3 3zm0-4v3h3v-3zm0-1V7a3 3 0 0 1 3 3zM6 7h3v3H6z"
]);
const $90f21c32649fad68$export$7b75252501884b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeTableRegular', "1em", [
    "M5 2a3 3 0 0 0-3 3v2.35q.43-.49 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm10 16h-2.35q.49-.43.81-1H15a2 2 0 0 0 2-2v-3.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3M11.5 2a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zM5 7a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3zm-2 3c0-1.1.9-2 2-2v2zm3 0V8h3v2zm4 0V8a2 2 0 0 1 2 2zm-4 1h3v3H6zm4 0h2v3h-2zm-4 4h3v2H6zm6 0a2 2 0 0 1-2 2v-2zm-9-4h2v3H3zm0 4h2v2a2 2 0 0 1-2-2"
]);
const $90f21c32649fad68$export$48b0be34369967d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeVideoFilled', "1em", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2zM18 11.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25zM3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4A2.5 2.5 0 0 1 7.5 19h-4A2.5 2.5 0 0 1 1 16.5v-4A2.5 2.5 0 0 1 3.5 10m.72 2.55a.5.5 0 0 0-.72.45v3a.5.5 0 0 0 .72.45l3-1.5a.5.5 0 0 0 0-.9z"
]);
const $90f21c32649fad68$export$251e557229de989e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ResizeVideoRegular', "1em", [
    "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3zm6.5 9.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3zM3.5 10A2.5 2.5 0 0 0 1 12.5v4A2.5 2.5 0 0 0 3.5 19h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 7.5 10zm.72 2.55 3 1.5a.5.5 0 0 1 0 .9l-3 1.5A.5.5 0 0 1 3.5 16v-3a.5.5 0 0 1 .72-.45"
]);
const $90f21c32649fad68$export$a5d00fa3c6995b64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSourceFilled', "1em", [
    "M3 10a7 7 0 1 1 12.14 4.75l.65.77a8 8 0 1 0-11.58 0l.65-.77A7 7 0 0 1 3 10m11.16 3.6a5.5 5.5 0 1 0-8.32 0l.65-.78a4.5 4.5 0 1 1 7.01 0zm-1.65-1.96q.48-.71.49-1.64a3 3 0 1 0-5.51 1.64l.69-.81a2 2 0 1 1 3.64 0zm-2.13-.96a.5.5 0 0 0-.76 0l-5.5 6.5a.5.5 0 0 0 .38.82h11a.5.5 0 0 0 .38-.82z"
]);
const $90f21c32649fad68$export$e3da8dc13cdc6b1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundSourceRegular', "1em", [
    "M3 10a7 7 0 1 1 12.14 4.75l.65.77a8 8 0 1 0-11.58 0l.65-.77A7 7 0 0 1 3 10m11.16 3.6a5.5 5.5 0 1 0-8.32 0l.65-.78a4.5 4.5 0 1 1 7.01 0zm-1.65-1.96q.48-.71.49-1.64a3 3 0 1 0-5.51 1.64l.69-.81a2 2 0 1 1 3.64 0zm-2.13-.96a.5.5 0 0 0-.76 0l-5.5 6.5a.5.5 0 0 0 .38.82h11a.5.5 0 0 0 .38-.82zM14.42 17H5.58L10 11.77z"
]);
const $90f21c32649fad68$export$d3e6f392ccf5b719 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0M6 8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5m5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zM8.5 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5m5.5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$b2449e6afc4846f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleRegular', "1em", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m4-1.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zM8.5 7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5m5.5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
]);
const $90f21c32649fad68$export$3266626f409a3f0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAddFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8v.25a5.5 5.5 0 0 0-4-1.23V7.5a.5.5 0 0 0-1 0v1.7q-.81.25-1.5.7V8.5a.5.5 0 0 0-1 0v2.23a5.5 5.5 0 0 0-.25 7.26L10 18a8 8 0 1 1 0-16m4.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m-6-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5M6 8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$f090c135fa1ea308 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleAddRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8l-.01.25q-.47-.38-1-.66a7 7 0 1 0-7.4 7.4q.28.54.66 1H10a8 8 0 1 1 0-16m4.5 10a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m-6-5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5-.5c.28 0 .5.22.5.5v1.4q-.55.35-1 .83V8.5c0-.28.22-.5.5-.5m2.5-1c.28 0 .5.22.5.5v1.52q-.51.05-1 .19V7.5c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$f025d1ce9fb51552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.02 3.56a1.3 1.3 0 0 0 1 .21 8 8 0 1 1-6.6-9.9l-.2.07A1.4 1.4 0 0 0 10 3.5q0 .46.26.82.26.37.71.53l1.06.35q.22.06.47.29c.11.11.2.24.3.47l.35 1.1.03.06a.5.5 0 0 0-.18.38v5a.5.5 0 0 0 1 0v-4q0 .42.24.76.24.33.65.48l.77.25q.12.05.22.14t.14.22l.26.8q.15.38.48.62M5.5 9v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0M11 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 11 8m-3-.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0"
]);
const $90f21c32649fad68$export$63eae9f226ce8e9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM17.5 12q-.4 0-.73-.22A7 7 0 1 1 10.09 3a1.4 1.4 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.58 9.9zm-3.83-4.26q-.36-.29-.5-.62a.5.5 0 0 0-.17.38v5a.5.5 0 0 0 1 0V7.92q-.17-.07-.33-.18M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5.5 0a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zM8.5 7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5"
]);
const $90f21c32649fad68$export$b5eec30541978534 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7L2.15 2.85a.5.5 0 0 1 0-.7M14 8.5q0 .42.24.76.24.33.65.48l.77.25q.12.05.21.14.11.1.15.22l.26.8q.15.38.48.62a1.3 1.3 0 0 0 1 .21 8 8 0 0 1-1.14 2.51L14 11.88zm-6 4a.5.5 0 0 0 1 0V9.7l-1-1zm-2-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2M10 2q.6 0 1.17.08l-.22.07A1.4 1.4 0 0 0 10 3.5q0 .45.26.82t.71.53l1.06.35q.22.06.47.29.16.14.3.47l.35 1.1.03.06a.5.5 0 0 0-.18.38v3.38l-7.5-7.5A8 8 0 0 1 10 2m4.48-2a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28"
]);
const $90f21c32649fad68$export$56091f15c3170800 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSparkleOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7L2.15 2.86a.5.5 0 0 1 0-.7M4.7 5.4a7 7 0 0 0 9.87 9.87L9 9.72v2.79a.5.5 0 0 1-1 0V8.7zm12.06 6.37a1.3 1.3 0 0 0 .98.2q-.35 1.38-1.14 2.51l-.72-.72q.6-.91.88-2m-3.6-4.66q.14.33.5.62.16.11.33.18v3.96l-1-1V7.5q0-.24.18-.38M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5M17.48 6a.3.3 0 0 1 .29.2l.25.77a1.6 1.6 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2m-3-6a.4.4 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.4.4 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.4.4 0 0 1 .4-.28M10 2q.6 0 1.17.08l-.22.07a1.4 1.4 0 0 0-.86.85h-.1c-1.38 0-2.68.4-3.77 1.1l-.72-.72A8 8 0 0 1 10 2"
]);
const $90f21c32649fad68$export$6ac7dc56b65d6b96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtractFilled', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8v.25a5.5 5.5 0 0 0-4-1.23V7.5a.5.5 0 0 0-1 0v1.7q-.81.25-1.5.7V8.5a.5.5 0 0 0-1 0v2.23a5.5 5.5 0 0 0-.25 7.26L10 18a8 8 0 1 1 0-16m2.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-4-7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5M6 8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5"
]);
const $90f21c32649fad68$export$6c44c2fa69a4bdfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SoundWaveCircleSubtractRegular', "1em", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M10 2a8 8 0 0 1 8 8l-.01.25q-.47-.38-1-.66a7 7 0 1 0-7.4 7.4q.28.54.66 1H10a8 8 0 1 1 0-16m2.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-4-7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M6 8.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V9c0-.28.22-.5.5-.5m5-.5c.28 0 .5.22.5.5v1.4q-.55.35-1 .83V8.5c0-.28.22-.5.5-.5m2.5-1c.28 0 .5.22.5.5v1.52q-.51.05-1 .19V7.5c0-.28.22-.5.5-.5"
]);


"use client";
const $61c84b424f99a7b1$export$dfd24591b5ec6a83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_edit_20_color__a)",
            "d": "M12.25 3.54 4 11.8l1.05 3.16 3.17 1.03 8.24-8.23z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_edit_20_color__b)",
            "d": "m4.12 11.67-.57.58q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l.56-.56s-1.6-.48-2.67-1.54a7 7 0 0 1-1.54-2.67"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_edit_20_color__c)",
            "d": "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-2.08 2.08-4.2-4.2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_edit_20_color__d)",
            "d": "M10.26 5.53 11.9 3.9s.47 1.6 1.54 2.67A7 7 0 0 0 16.1 8.1L14.5 9.72s-1.62-.47-2.68-1.53a7 7 0 0 1-1.55-2.66"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_edit_20_color__a",
                "x1": "10.89",
                "x2": "12.79",
                "y1": "7.02",
                "y2": "12.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffa43d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fb5937"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_edit_20_color__b",
                "x1": "1.09",
                "x2": "5.65",
                "y1": "13.44",
                "y2": "17.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".26",
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_edit_20_color__c",
                "x1": "16.5",
                "x2": "13.86",
                "y1": "3.49",
                "y2": "5.97",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dd3ce2"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_edit_20_color__d",
                "x1": "13.28",
                "x2": "9.16",
                "y1": "7.88",
                "y2": "6.07",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffe994"
                }
            ]
        ]
    ]
], {
    color: true
});
const $61c84b424f99a7b1$export$a18b2635075e93d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2zm-1.38 1.38-8 8q-.49.5-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l7.98-7.98z"
]);
const $61c84b424f99a7b1$export$e57a7ca8375c5ccb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68l9.36-9.36a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 1 1 2.8 2.8l-.68.66-2.8-2.79zm-1.38 1.38 2.8 2.8-7.99 7.97q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7z"
]);
const $61c84b424f99a7b1$export$6a53b7a3e1b270ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditArrowBackFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2zm-1.38 1.38-8 8q-.49.5-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l.75-.74zM13.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 16 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $61c84b424f99a7b1$export$a0c3de9099ce897b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditArrowBackRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16q-.17-.59-.2-1.21l-.95.94q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7l7.99-8 2.8 2.8L13.78 9q.62.03 1.21.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79zM13.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 16 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $61c84b424f99a7b1$export$b3e109f56af24945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLineHorizontal3Filled', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-.67.67 4.2 4.2.68-.66a2.97 2.97 0 0 0 .05-4.15M3.55 12.25l8-8 4.2 4.2-7.98 7.99q-.52.51-1.24.68l-3.92.87a.5.5 0 0 1-.6-.6l.88-3.95q.16-.68.66-1.2M2.5 3h8.88l-1 1H2.5a.5.5 0 0 1 0-1m0 3h5.88l-1 1H2.5a.5.5 0 0 1 0-1m0 3h2.88l-1 1H2.5a.5.5 0 0 1 0-1"
]);
const $61c84b424f99a7b1$export$bcfc204258d47752 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLineHorizontal3Regular', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-9.35 9.36q-.52.51-1.23.68l-3.93.87a.5.5 0 0 1-.6-.6l.88-3.95q.16-.68.66-1.2zm3.54.75a1.97 1.97 0 0 0-2.83-.04l-.67.67 2.8 2.8.66-.68c.76-.75.77-1.98.04-2.75m-1.42 4.13-2.79-2.8-8 8q-.29.3-.38.7l-.71 3.2 3.16-.71q.43-.1.74-.4zM2.5 3h8.88l-1 1H2.5a.5.5 0 0 1 0-1m0 3h5.88l-1 1H2.5a.5.5 0 0 1 0-1m0 3h2.88l-1 1H2.5a.5.5 0 0 1 0-1"
]);
const $61c84b424f99a7b1$export$6f22a3a056317eb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLockFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2zm-1.38 1.38-8 8q-.49.5-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L10 14.2V13a2 2 0 0 1 1.5-1.94V11a3 3 0 0 1 3.95-2.85zM12.5 11v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $61c84b424f99a7b1$export$57e5b44263d4b8fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLockRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68L10 14.2V13l.01-.22-2.95 2.95q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7l8-8 2.78 2.8-.26.25q.6.06 1.1.32l1.25-1.25a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 0 1 2.8 2.8l-.68.66-2.8-2.79zM12.5 11v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0m1 1v-1a1 1 0 1 1 2 0v1zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $61c84b424f99a7b1$export$1873fa39af5835de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l5.4 5.4-4 4q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 0 0 .7-.71zm12.9 6.3-2.59 2.6-4.2-4.21 2.58-2.6zm-2.83-5.58a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2z"
]);
const $61c84b424f99a7b1$export$d594ddd1ee32b455 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l5.4 5.4-4 4q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 0 0 .7-.71zm8.2 9.6-3.99 3.98q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7l3.99-4zm4-4-2.6 2.59.71.7 3.97-3.96a2.97 2.97 0 0 0-4.21-4.2L8.96 6.83l.7.7 2.59-2.58zm-1.42-4.17a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79z"
]);
const $61c84b424f99a7b1$export$959d9b72f4d06c7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditPersonFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2zm-1.38 1.38-8 8q-.49.5-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68l4.06-4.07a3 3 0 0 1 3.61-4.22zM16.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 16.75 11 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $61c84b424f99a7b1$export$dc8449dfaca6bdb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditPersonRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68l4.06-4.06q-.26-.5-.32-1.1l-4.45 4.45q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7l8-8 2.78 2.8-.26.25q.6.06 1.1.32l1.25-1.25a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 0 1 2.8 2.8l-.68.66-2.8-2.79zM16.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 16.75 11 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $61c84b424f99a7b1$export$d81a612856492086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditProhibitedFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2zm-1.38 1.38-8 8q-.49.5-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l.75-.74zM9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $61c84b424f99a7b1$export$af21cddb104ee01a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditProhibitedRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16q-.17-.59-.2-1.21l-.95.94q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7l7.99-8 2.8 2.8L13.78 9q.62.03 1.21.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79zM9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5q-1.2-.02-2.1-.7l4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-3.5 3.5"
]);
const $61c84b424f99a7b1$export$a287ccc2edd11292 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditSettingsFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2zm-1.38 1.38-8 8q-.49.5-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l.75-.74zm-.47 7.2a2 2 0 0 1-1.43 2.47l-.46.12a5 5 0 0 0 0 1.02l.35.08A2 2 0 0 1 11 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 16 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.05a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $61c84b424f99a7b1$export$6e46f2395bc6e163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditSettingsRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38q-.5.5-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87q.72-.16 1.24-.68L8.2 16q-.17-.59-.2-1.21l-.95.94q-.31.31-.74.41l-3.16.7.7-3.18q.1-.41.4-.7l7.99-8 2.8 2.8L13.78 9q.62.03 1.21.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15m-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79zm-2.56 7.86a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.02l.35.08A2 2 0 0 1 11 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 16 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $61c84b424f99a7b1$export$fad8cf09a35ef3ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdRegular', "1em", [
    "M5.5 7c.28 0 .5.22.5.5V10h2.5V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V11H6v1.5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5M11 7a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1.42A2.6 2.6 0 0 0 15 10.42v-.84A2.6 2.6 0 0 0 12.42 7zm1.42 5h-.92V8h.92c.87 0 1.58.7 1.58 1.58v.84c0 .87-.7 1.58-1.58 1.58M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $61c84b424f99a7b1$export$e5f052432bf5baba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrFilled', "1em", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM4.5 7.5c.28 0 .5.22.5.5v1.5h2V8a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-1.5H5V12a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5M9 8c0-.28.22-.5.5-.5h.25c1.24 0 2.25 1 2.25 2.25v.5c0 1.24-1 2.25-2.25 2.25H9.5A.5.5 0 0 1 9 12zm1 3.47c.57-.11 1-.62 1-1.22v-.5c0-.6-.43-1.1-1-1.22zM13 8c0-.28.22-.5.5-.5h1a1.5 1.5 0 0 1 .87 2.72l.6 1.6a.5.5 0 0 1-.94.36l-.63-1.68H14V12a.5.5 0 0 1-1 0zm1 1.5h.5a.5.5 0 0 0 0-1H14z"
]);
const $61c84b424f99a7b1$export$62f852357c8b1898 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrRegular', "1em", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25zm1.5.75c.28 0 .5.22.5.5v1.5h2V8a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-1.5H5V12a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5M9 8c0-.28.22-.5.5-.5h.25c1.24 0 2.25 1 2.25 2.25v.5c0 1.24-1 2.25-2.25 2.25H9.5A.5.5 0 0 1 9 12zm1 3.47c.57-.11 1-.62 1-1.22v-.5c0-.6-.43-1.1-1-1.22zM13 8c0-.28.22-.5.5-.5h1a1.5 1.5 0 0 1 .87 2.72l.6 1.6a.5.5 0 0 1-.94.36l-.63-1.68H14V12a.5.5 0 0 1-1 0zm1 1.5h.5a.5.5 0 0 0 0-1H14z"
]);
const $61c84b424f99a7b1$export$8374f1ae2159ca64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.41 1.42A2.8 2.8 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.54l1.86 1.85a.5.5 0 0 0 .7-.7zm8.38 9.8c-.4.34-.91.55-1.48.55H9.5A.5.5 0 0 1 9 12V9.7l1 1v.78q.3-.07.52-.25zM8 8.7V12a.5.5 0 0 1-1 0v-1.5H5V12a.5.5 0 0 1-1 0V8a.5.5 0 0 1 1 0v1.5h2V8a1 1 0 0 1 .06-.23zm4 1.04v.13l1 1V8c0-.28.22-.5.5-.5h1a1.5 1.5 0 0 1 .87 2.72l.6 1.6a.5.5 0 0 1-.94.36l-.63-1.68H14v1.38l3.25 3.25c.47-.49.75-1.15.75-1.88v-6.5A2.75 2.75 0 0 0 15.25 4H6.12l3.5 3.5h.13c1.24 0 2.25 1 2.25 2.25m2-.25h.5a.5.5 0 0 0 0-1H14z"
]);
const $61c84b424f99a7b1$export$ba160e19d247cd80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.41 1.42A2.8 2.8 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.54l1.86 1.85a.5.5 0 0 0 .7-.7zM14.3 15H4.75C3.78 15 3 14.22 3 13.25v-6.5c0-.83.57-1.52 1.34-1.7l2.72 2.72A1 1 0 0 0 7 8v1.5H5V8a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-1.5h2V12a.5.5 0 0 0 1 0V8.7l1 1V12c0 .28.22.5.5.5h.25q.88-.02 1.48-.56zM10 10.7l.52.53q-.22.18-.52.24zm-.38-3.2L12 9.88v-.13c0-1.24-1-2.25-2.25-2.25zM13 10.88l1 1V10.5h.4l.63 1.68a.5.5 0 0 0 .94-.36l-.6-1.6a1.5 1.5 0 0 0-.87-2.72h-1a.5.5 0 0 0-.5.5zm4 2.37q-.02.69-.45 1.18l.7.7c.47-.49.75-1.15.75-1.88v-6.5A2.75 2.75 0 0 0 15.25 4H6.12l1 1h8.13c.97 0 1.75.78 1.75 1.75zM14 9.5v-1h.5a.5.5 0 0 1 0 1z"
]);
const $61c84b424f99a7b1$export$44061294fbe26040 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImportantFilled', "1em", [
    "M10 2a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69.24.79.97 1.31 1.78 1.31s1.54-.52 1.78-1.31C12.2 10.2 13 7.25 13 5a3 3 0 0 0-3-3m0 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $61c84b424f99a7b1$export$810b2bfb11640d06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImportantRegular', "1em", [
    "M10 3a2 2 0 0 0-2 2c0 2.07.75 4.91 1.18 6.4.1.36.44.6.82.6.39 0 .71-.24.82-.6C11.25 9.94 12 7.1 12 5a2 2 0 0 0-2-2M7 5a3 3 0 0 1 6 0c0 2.25-.79 5.21-1.22 6.69-.24.8-.97 1.31-1.78 1.31s-1.54-.52-1.78-1.31C7.8 10.2 7 7.23 7 5m3 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
]);
const $61c84b424f99a7b1$export$d066cb181a3a8680 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote1Filled', "1em", [
    "M10.15 2.02a.5.5 0 0 0-.65.48v9.9A3.24 3.24 0 0 0 4 14.75a3.25 3.25 0 1 0 6.5-.25V7.18l5.85 1.8A.5.5 0 0 0 17 8.5V5.98a2.5 2.5 0 0 0-1.76-2.4z"
]);
const $61c84b424f99a7b1$export$5dd1b4706dc9b693 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote1Regular', "1em", [
    "M10.15 2.02a.5.5 0 0 0-.65.48v9.9A3.24 3.24 0 0 0 4 14.75a3.25 3.25 0 1 0 6.5-.25V7.18l5.85 1.8A.5.5 0 0 0 17 8.5V5.98a2.5 2.5 0 0 0-1.76-2.4zM16 7.82l-5.5-1.69V3.18l4.44 1.36c.63.2 1.06.78 1.06 1.44zM5 14.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"
]);
const $61c84b424f99a7b1$export$8b4dc0ffbaf0d6e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2Filled', "1em", [
    "M15.99 3.02a1 1 0 0 0-1.29-.8l-7 2.2a1 1 0 0 0-.7.95v8.13q-.64-.48-1.5-.5A2.5 2.5 0 1 0 8 15.5V8.37l7-2.19v5.32q-.64-.48-1.5-.5a2.5 2.5 0 1 0 2.5 2.5V3.18z"
]);
const $61c84b424f99a7b1$export$e378832c42c93786 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2Regular', "1em", [
    "M14.7 2.23a1 1 0 0 1 1.3.95V13.5a2.5 2.5 0 1 1-1-2V6.18L8 8.37v7.13a2.5 2.5 0 1 1-1-2V5.37a1 1 0 0 1 .7-.96zM8 7.32l7-2.19V3.18L8 5.37zM5.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6.5-.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $61c84b424f99a7b1$export$3feb6342b87cb135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2PlayFilled', "1em", [
    "M15.99 3.02a1 1 0 0 0-1.29-.8l-7 2.2a1 1 0 0 0-.7.95v8.13q-.64-.48-1.5-.5A2.5 2.5 0 1 0 8 15.5V8.37l7-2.19v2.84q.51.05 1 .19V3.18zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.26-.44-3-1.65a.5.5 0 0 0-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 0 0 0-.88"
]);
const $61c84b424f99a7b1$export$1b5048f89851206f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2PlayRegular', "1em", [
    "M14.7 2.23a1 1 0 0 1 1.3.95v6.03q-.49-.15-1-.19V6.18L8 8.37v7.13a2.5 2.5 0 1 1-1-2V5.37a1 1 0 0 1 .7-.96zM8 7.32l7-2.19V3.18L8 5.37zM5.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m13.5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.26-.44-3-1.65a.5.5 0 0 0-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 0 0 0-.88"
]);
const $61c84b424f99a7b1$export$dda849a51acec17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff1Filled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l7.35 7.36v2.2A3.24 3.24 0 0 0 4 14.74a3.25 3.25 0 1 0 6.5-.25v-3.3l6.65 6.65a.5.5 0 0 0 .7-.7zm7.65 5.03v1.2l-1-1V2.5a.5.5 0 0 1 .65-.48l5.09 1.57A2.5 2.5 0 0 1 17 5.98V8.5a.5.5 0 0 1-.65.48z"
]);
const $61c84b424f99a7b1$export$70a781a1c4c183a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff1Regular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l7.35 7.36v2.2A3.24 3.24 0 0 0 4 14.74a3.25 3.25 0 1 0 6.5-.25v-3.3l6.65 6.65a.5.5 0 0 0 .7-.7zM5 14.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m5.5-7.57v1.2l-1-1V2.5a.5.5 0 0 1 .65-.48l5.09 1.57A2.5 2.5 0 0 1 17 5.98V8.5a.5.5 0 0 1-.65.48zm5.5.64V5.98a1.5 1.5 0 0 0-1.06-1.44L10.5 3.18v2.95z"
]);
const $61c84b424f99a7b1$export$64e0a039a3c9817d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff2Filled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7 7.71v5.79q-.64-.48-1.5-.5A2.5 2.5 0 1 0 8 15.5V8.7l3.41 3.42q-.4.6-.41 1.38a2.5 2.5 0 0 0 3.88 2.09l2.27 2.26a.5.5 0 0 0 .7-.7zM13.5 11q-.18 0-.35.02l2.83 2.83.02-.35V3.18l-.01-.16a1 1 0 0 0-1.29-.8l-7 2.2a1 1 0 0 0-.61.54l2.8 2.82L15 6.18v5.32q-.64-.48-1.5-.5"
]);
const $61c84b424f99a7b1$export$627cad633e3fa534 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff2Regular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7 7.71v5.79q-.64-.48-1.5-.5A2.5 2.5 0 1 0 8 15.5V8.7l3.41 3.42q-.4.6-.41 1.38a2.5 2.5 0 0 0 3.88 2.09l2.27 2.26a.5.5 0 0 0 .7-.7zm11.3 12.7q-.3.15-.65.15a1.5 1.5 0 0 1-1.35-2.15zM5.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m8-3q-.18 0-.35.02l2.83 2.83.02-.35V3.18a1 1 0 0 0-1.3-.95l-7 2.18a1 1 0 0 0-.61.55l.91.92v-.51l7-2.19v1.95L9.1 6.98l.8.8 5.1-1.6v5.32q-.64-.48-1.5-.5"
]);
const $61c84b424f99a7b1$export$cf4018408ad66c4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureFilled', "1em", [
    "M4.75 3A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15H9v-2.5a2.5 2.5 0 0 1 2.5-2.5h6q.26 0 .5.05v-4.3A2.75 2.75 0 0 0 15.25 3zM18 11.09a2 2 0 0 0-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41"
]);
const $61c84b424f99a7b1$export$8b4cce9af7c6e608 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureRegular', "1em", [
    "M2 5.75A2.75 2.75 0 0 1 4.75 3h10.5A2.75 2.75 0 0 1 18 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 0 1 2 12.25zM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5z"
]);
const $61c84b424f99a7b1$export$8cd5fae880589d2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureEnterFilled', "1em", [
    "M4.75 3A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15H9v-2.5a2.5 2.5 0 0 1 2.5-2.5h6q.26 0 .5.05v-4.3A2.75 2.75 0 0 0 15.25 3zm.6 2.65L8 8.29V6.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.8L4.64 6.35a.5.5 0 1 1 .7-.7M18 11.09a2 2 0 0 0-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41"
]);
const $61c84b424f99a7b1$export$6dbf210ed444df50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureEnterRegular', "1em", [
    "M2 5.75A2.75 2.75 0 0 1 4.75 3h10.5A2.75 2.75 0 0 1 18 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 0 1 2 12.25zM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5zM4.65 5.65c.2-.2.5-.2.7 0L8 8.29V6.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.8L4.64 6.35a.5.5 0 0 1 0-.7"
]);
const $61c84b424f99a7b1$export$a3e7551381343f18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureExitFilled', "1em", [
    "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4A1.5 1.5 0 0 0 2.5 9zm0 1h-6q-.26 0-.5-.05v4.3A2.75 2.75 0 0 0 4.75 17h10.5A2.75 2.75 0 0 0 18 14.25v-6.5A2.75 2.75 0 0 0 15.25 5H11v2.5A2.5 2.5 0 0 1 8.5 10m3.85.65L15 13.29V11.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.8l-2.65-2.65a.5.5 0 0 1 .7-.7"
]);
const $61c84b424f99a7b1$export$13be2317a578fd97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureExitRegular', "1em", [
    "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4c0 .65.42 1.2 1 1.41l.02.01q.22.08.48.08zm6.75-3H11V5h4.25A2.75 2.75 0 0 1 18 7.75v6.5A2.75 2.75 0 0 1 15.25 17H4.75A2.75 2.75 0 0 1 2 14.25v-4.3q.24.05.5.05H3v4.25c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 6.78 16.22 6 15.25 6M14 12.3l-2.65-2.65a.5.5 0 0 0-.7.7L13.29 13H11.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0z"
]);
const $61c84b424f99a7b1$export$8e014e26ebf22935 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbDislikeFilled', "1em", [
    "M12.48 18.3c-.8.83-2.09.38-2.43-.6-.28-.8-.64-1.77-1-2.48C8 13.1 7.38 11.9 5.67 10.37q-.35-.3-.84-.49c-1.13-.44-2.2-1.61-1.91-3l.35-1.77a2.5 2.5 0 0 1 1.8-1.92l5.6-1.53a4.5 4.5 0 0 1 5.6 3.54l.69 3.76A3 3 0 0 1 14 12.5h-.89l.01.05c.08.41.18.97.24 1.58.07.62.1 1.29.05 1.92a4 4 0 0 1-.5 1.73q-.17.25-.44.52"
]);
const $61c84b424f99a7b1$export$f18afe37ff73a6c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbDislikeRegular', "1em", [
    "M10.05 17.7c.34.98 1.63 1.43 2.43.6q.27-.27.44-.52c.32-.48.45-1.12.5-1.73.05-.63.02-1.3-.05-1.92-.06-.6-.16-1.17-.24-1.58v-.05H14a3 3 0 0 0 2.95-3.54l-.69-3.76a4.5 4.5 0 0 0-5.6-3.54L5.06 3.2c-.92.25-1.62 1-1.8 1.92l-.35 1.77c-.28 1.39.78 2.56 1.9 3q.5.2.85.5c1.7 1.5 2.32 2.72 3.38 4.84.36.71.72 1.68 1 2.49m1.97-5.58v.04a14 14 0 0 1 .36 2.08q.1.89.04 1.73t-.33 1.25q-.1.14-.33.39c-.2.2-.63.16-.76-.23-.29-.82-.67-1.83-1.05-2.6-1.07-2.14-1.76-3.5-3.62-5.15q-.53-.45-1.13-.68c-.88-.34-1.45-1.14-1.3-1.87l.35-1.77c.11-.56.53-1 1.08-1.15l5.6-1.53a3.5 3.5 0 0 1 4.36 2.75l.68 3.76a2 2 0 0 1-1.96 2.36h-1.5a.5.5 0 0 0-.5.62"
]);
const $61c84b424f99a7b1$export$6894c403b1075697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeFilled', "1em", [
    "M12.48 1.7c-.8-.83-2.09-.38-2.43.6-.28.8-.64 1.77-1 2.48C8 6.9 7.38 8.1 5.67 9.63q-.35.3-.84.49c-1.13.44-2.2 1.61-1.91 3l.35 1.77a2.5 2.5 0 0 0 1.8 1.92l5.6 1.52a4.5 4.5 0 0 0 5.6-3.53l.69-3.76A3 3 0 0 0 14 7.5h-.89l.01-.05c.08-.41.18-.97.24-1.59.07-.6.1-1.28.05-1.9a4 4 0 0 0-.5-1.74 4 4 0 0 0-.44-.52"
]);
const $61c84b424f99a7b1$export$c59ff23c086df313 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeRegular', "1em", [
    "M10.05 2.3c.34-.98 1.63-1.43 2.43-.6q.27.27.44.52c.32.48.45 1.12.5 1.73.05.63.02 1.3-.05 1.91-.06.62-.16 1.18-.24 1.59v.05H14a3 3 0 0 1 2.95 3.54l-.69 3.76a4.5 4.5 0 0 1-5.6 3.53l-5.6-1.52a2.5 2.5 0 0 1-1.8-1.92l-.35-1.77c-.28-1.39.78-2.56 1.9-3q.5-.2.85-.5c1.7-1.5 2.32-2.72 3.38-4.84.36-.71.72-1.68 1-2.49m1.97 5.58v-.04l.13-.58c.08-.4.17-.93.23-1.5q.1-.89.04-1.73a3 3 0 0 0-.33-1.25 3 3 0 0 0-.33-.39c-.2-.2-.63-.16-.76.23-.29.82-.67 1.83-1.05 2.6-1.07 2.14-1.76 3.5-3.62 5.15q-.53.45-1.13.68c-.88.34-1.45 1.14-1.3 1.87l.35 1.77c.11.56.53 1 1.08 1.15l5.6 1.53c1.98.54 4-.73 4.36-2.75l.68-3.76a2 2 0 0 0-1.96-2.36h-1.5a.5.5 0 0 1-.5-.62"
]);
const $61c84b424f99a7b1$export$18ec8d6f1838f328 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeDislikeFilled', "1em", [
    "M8 6h-.73c.13-.3.26-.7.34-1.11.1-.5.14-1.06-.02-1.58-.17-.55-.56-1-1.23-1.23-.86-.3-1.6.31-1.92.92L3.14 5.5a2.5 2.5 0 0 1-.97 1.02L1 7.17a2 2 0 0 0-.88 2.44l.3.83a2 2 0 0 0 1.32 1.22l4.24 1.24a2.5 2.5 0 0 0 3.1-1.66L9.9 8.6A2 2 0 0 0 8 6m4.73 8H12a2 2 0 0 1-1.91-2.59l.82-2.65A2.5 2.5 0 0 1 14 7.1l4.24 1.24a2 2 0 0 1 1.31 1.22l.31.84a2 2 0 0 1-.88 2.43l-1.16.67q-.63.37-.97 1.02L15.56 17c-.31.61-1.06 1.22-1.92.93a1.8 1.8 0 0 1-1.23-1.24 3 3 0 0 1-.02-1.57q.13-.63.34-1.12"
]);
const $61c84b424f99a7b1$export$92f0baeab2c3fcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeDislikeRegular', "1em", [
    "M5.32 3.46c.2-.38.52-.5.72-.43.36.12.52.32.6.58q.13.44 0 1.08a6 6 0 0 1-.57 1.55v.02h-.01A.5.5 0 0 0 6.5 7H8a1 1 0 0 1 .95 1.3l-.82 2.65a1.5 1.5 0 0 1-1.86 1L2.03 10.7a1 1 0 0 1-.66-.6l-.3-.84a1 1 0 0 1 .43-1.22l1.16-.67a3.5 3.5 0 0 0 1.37-1.42zM8 6h-.72c.13-.3.26-.7.34-1.11.1-.5.14-1.06-.02-1.58-.17-.55-.56-1-1.23-1.23-.86-.3-1.6.31-1.92.92L3.14 5.5a2.5 2.5 0 0 1-.97 1.02L1 7.17a2 2 0 0 0-.88 2.44l.3.83a2 2 0 0 0 1.32 1.22l4.24 1.24a2.5 2.5 0 0 0 3.1-1.66L9.9 8.6A2 2 0 0 0 8 6m6.69 10.54c-.2.39-.52.5-.72.44-.36-.12-.52-.33-.6-.58a2 2 0 0 1 0-1.08 6 6 0 0 1 .57-1.55v-.02l.01-.01a.5.5 0 0 0-.44-.74H12a1 1 0 0 1-.95-1.3l.82-2.64a1.5 1.5 0 0 1 1.86-1l4.24 1.24a1 1 0 0 1 .66.61l.3.84a1 1 0 0 1-.43 1.22l-1.16.66a3.5 3.5 0 0 0-1.37 1.42zM12 14h.72q-.2.48-.34 1.12c-.1.49-.14 1.05.02 1.57.17.55.56 1.01 1.23 1.24.86.29 1.6-.32 1.92-.93l1.3-2.48q.34-.65.97-1.02l1.16-.67a2 2 0 0 0 .88-2.43l-.3-.84a2 2 0 0 0-1.32-1.22L14.01 7.1a2.5 2.5 0 0 0-3.1 1.66l-.81 2.65a2 2 0 0 0 1.9 2.6"
]);
const $61c84b424f99a7b1$export$bec833e8785bf899 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleLeftFilled', "1em", [
    "M14 6a4 4 0 0 1 0 8H6a4 4 0 0 1 0-8zm-8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $61c84b424f99a7b1$export$8c2a45bcb99eaa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleLeftRegular', "1em", [
    "M6 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4m12-2a4 4 0 0 0-4-4H6a4 4 0 1 0 0 8h8a4 4 0 0 0 4-4m-4-3a3 3 0 1 1 0 6H6a3 3 0 1 1 0-6z"
]);
const $61c84b424f99a7b1$export$c79d60a89fcc04e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleMultipleFilled', "1em", [
    "M3 5.5A3.5 3.5 0 0 1 6.5 2h7a3.5 3.5 0 1 1 0 7h-7A3.5 3.5 0 0 1 3 5.5m5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M6.5 11a3.5 3.5 0 1 0 0 7h7a3.5 3.5 0 1 0 0-7zm7 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
]);
const $61c84b424f99a7b1$export$4545fffaa3265c65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleMultipleRegular', "1em", [
    "M8 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5 0A3.5 3.5 0 0 0 6.5 9h7a3.5 3.5 0 1 0 0-7h-7A3.5 3.5 0 0 0 3 5.5M6.5 3h7a2.5 2.5 0 0 1 0 5h-7a2.5 2.5 0 0 1 0-5m7 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M3 14.5A3.5 3.5 0 0 0 6.5 18h7a3.5 3.5 0 1 0 0-7h-7A3.5 3.5 0 0 0 3 14.5M6.5 12h7a2.5 2.5 0 0 1 0 5h-7a2.5 2.5 0 0 1 0-5"
]);
const $61c84b424f99a7b1$export$cb0d44125da6a0f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleRightFilled', "1em", [
    "M6 6a4 4 0 1 0 0 8h8a4 4 0 0 0 0-8zm8 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
]);
const $61c84b424f99a7b1$export$28fba8cf3cfa6e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleRightRegular', "1em", [
    "M14 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M2 10a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H6a4 4 0 0 1-4-4m4-3a3 3 0 0 0 0 6h8a3 3 0 1 0 0-6z"
]);
const $61c84b424f99a7b1$export$6295cd581b71ddb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeDeciduousFilled', "1em", [
    "M10 2a3.5 3.5 0 0 0-3.39 2.61A3.5 3.5 0 0 0 4.05 8.6 3.5 3.5 0 0 0 6 15h2v1.75c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h2a3.5 3.5 0 0 0 1.95-6.4 3.5 3.5 0 0 0-2.56-3.99A3.5 3.5 0 0 0 10 2M9 15h2v1.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25z"
]);
const $61c84b424f99a7b1$export$f4d5690d1c77096c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeDeciduousRegular', "1em", [
    "M10 2a3.5 3.5 0 0 0-3.39 2.61A3.5 3.5 0 0 0 4.05 8.6 3.5 3.5 0 0 0 6 15h2v1.75c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h2a3.5 3.5 0 0 0 1.95-6.4 3.5 3.5 0 0 0-2.56-3.99A3.5 3.5 0 0 0 10 2m1 13v1.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25V15zM7.53 5.11a2.5 2.5 0 0 1 4.94 0c.03.22.2.39.42.42A2.5 2.5 0 0 1 14.9 8.7a.5.5 0 0 0 .25.58A2.5 2.5 0 0 1 14 14H6a2.5 2.5 0 0 1-1.15-4.72.5.5 0 0 0 .25-.58A2.5 2.5 0 0 1 7.1 5.53a.5.5 0 0 0 .42-.42"
]);
const $61c84b424f99a7b1$export$57cca59e0c188479 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeEvergreenFilled', "1em", [
    "M10.62 2.21a1 1 0 0 0-1.24 0l-3.3 2.61A1.5 1.5 0 0 0 6 7.14l-1.46 1.2a1.5 1.5 0 0 0 .51 2.6l-1.59 1.48A1.49 1.49 0 0 0 4.5 15H8v1.75c0 .69.57 1.25 1.26 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h3.5c1.35 0 2-1.66 1.02-2.58l-1.59-1.48a1.5 1.5 0 0 0 .52-2.6l-1.47-1.2a1.5 1.5 0 0 0-.05-2.32zM9 15h2v1.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25z"
]);
const $61c84b424f99a7b1$export$bc70de4cceef56f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeEvergreenRegular', "1em", [
    "M10.62 2.21a1 1 0 0 0-1.24 0l-3.3 2.61A1.5 1.5 0 0 0 6 7.14l-1.46 1.2a1.5 1.5 0 0 0 .51 2.6l-1.59 1.48A1.49 1.49 0 0 0 4.5 15H8v1.75c0 .69.57 1.25 1.26 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h3.5c1.35 0 2-1.66 1.02-2.58l-1.59-1.48a1.5 1.5 0 0 0 .52-2.6l-1.47-1.2a1.5 1.5 0 0 0-.05-2.32zM11 15v1.75q-.02.23-.25.25h-1.5a.25.25 0 0 1-.25-.25V15zM10 3l3.3 2.6a.5.5 0 0 1-.28.9.5.5 0 0 0-.3.88l2.09 1.73a.5.5 0 0 1-.32.89h-.76a.5.5 0 0 0-.34.86l2.45 2.3c.32.3.1.84-.34.84h-11a.49.49 0 0 1-.34-.85l2.44-2.29a.5.5 0 0 0-.34-.86H5.5a.5.5 0 0 1-.31-.89l2.1-1.73a.5.5 0 0 0-.3-.88.5.5 0 0 1-.3-.9z"
]);


"use client";
const $79f5cc1e1e247c23$export$11a9cad94e3d1c4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveFilled', "1em", [
    "M2 4.25C2 3.56 2.56 3 3.25 3h13.5c.69 0 1.25.56 1.25 1.25v1.5C18 6.44 17.44 7 16.75 7H3.25C2.56 7 2 6.44 2 5.75zM3 8h14v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm5.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $79f5cc1e1e247c23$export$dd7e02f89a19805b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveRegular', "1em", [
    "M8.5 10a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM2 4.75C2 3.78 2.78 3 3.75 3h12.5c.97 0 1.75.78 1.75 1.75v1.5c0 .7-.4 1.3-1 1.58V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7.83c-.6-.28-1-.88-1-1.58zM3.75 4a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75zM4 8v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8z"
]);
const $79f5cc1e1e247c23$export$3683277bf35f7e4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveArrowBackFilled', "1em", [
    "M2 4.25C2 3.56 2.56 3 3.25 3h13.5c.69 0 1.25.56 1.25 1.25v1.5C18 6.44 17.44 7 16.75 7H3.25C2.56 7 2 6.44 2 5.75zM3 8h14v1.6a5.5 5.5 0 0 0-5.66.4H8.5a.5.5 0 0 0 0 1h1.76a5.5 5.5 0 0 0-.66 6H6a3 3 0 0 1-3-3zm11.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $79f5cc1e1e247c23$export$8cae54618d9f8e18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveArrowBackRegular', "1em", [
    "M8.5 10a.5.5 0 0 0 0 1h1.76q.47-.58 1.08-1zM6 16h3.2q.16.52.4 1H6a3 3 0 0 1-3-3V7.83c-.6-.28-1-.88-1-1.58v-1.5C2 3.78 2.78 3 3.75 3h12.5c.97 0 1.75.78 1.75 1.75v1.5c0 .7-.4 1.3-1 1.58V9.6q-.48-.24-1-.4V8H4v6c0 1.1.9 2 2 2M3.75 4a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75zM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $79f5cc1e1e247c23$export$52f9ea2583e70cbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveClockFilled', "1em", [
    "M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5",
    "M17 9.6a5.5 5.5 0 0 0-5.66.4H8.5a.5.5 0 0 0 0 1h1.76a5.5 5.5 0 0 0-.66 6H6a3 3 0 0 1-3-3V8h14z",
    "M16.75 3c.69 0 1.25.56 1.25 1.25v1.5C18 6.44 17.44 7 16.75 7H3.25C2.56 7 2 6.44 2 5.75v-1.5C2 3.56 2.56 3 3.25 3z"
]);
const $79f5cc1e1e247c23$export$6b2418de825697dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveClockRegular', "1em", [
    "M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5",
    "M16.25 3c.97 0 1.75.78 1.75 1.75v1.5c0 .7-.4 1.3-1 1.58V9.6q-.48-.25-1-.4V8H4v6c0 1.1.9 2 2 2h3.2q.15.52.4 1H6a3 3 0 0 1-3-3V7.83c-.6-.28-1-.88-1-1.58v-1.5C2 3.78 2.78 3 3.75 3zM3.75 4a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75z",
    "M11.34 10q-.6.42-1.08 1H8.5a.5.5 0 0 1 0-1z"
]);
const $79f5cc1e1e247c23$export$23bf89739e43bfe9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveMultipleFilled', "1em", [
    "M3.5 2C2.67 2 2 2.67 2 3.5v1C2 5.33 2.67 6 3.5 6h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5zM15 7H3v5.5A3.5 3.5 0 0 0 6.5 16h5a3.5 3.5 0 0 0 3.5-3.5zM7 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M8.5 18c-.95 0-1.82-.38-2.45-1h6.45a3.5 3.5 0 0 0 3.5-3.5V7.09c.58.2 1 .76 1 1.41v5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $79f5cc1e1e247c23$export$4753c316bd18543c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveMultipleRegular', "1em", [
    "M7.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-4-6C2.67 2 2 2.67 2 3.5v2c0 .66.42 1.21 1 1.42v5.58A3.5 3.5 0 0 0 6.5 16h5a3.5 3.5 0 0 0 3.5-3.5V6.92c.58-.2 1-.76 1-1.42v-2c0-.83-.67-1.5-1.5-1.5zM4 12.5V7h10v5.5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 4 12.5m-1-9c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zM8.5 18c-.95 0-1.82-.38-2.45-1h6.45a3.5 3.5 0 0 0 3.5-3.5V7.09c.58.2 1 .76 1 1.41v5a4.5 4.5 0 0 1-4.5 4.5z"
]);
const $79f5cc1e1e247c23$export$7e6585c67684586 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveSettingsFilled', "1em", [
    "M2 4.25C2 3.56 2.56 3 3.25 3h13.5c.69 0 1.25.56 1.25 1.25v1.5C18 6.44 17.44 7 16.75 7H3.25C2.56 7 2 6.44 2 5.75zM3 8h14v1.6a5.5 5.5 0 0 0-5.66.4H8.5a.5.5 0 0 0 0 1h1.76a5.5 5.5 0 0 0-.66 6H6a3 3 0 0 1-3-3zm9.07 3.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.02l.35.08A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $79f5cc1e1e247c23$export$bd494859cd0b1248 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArchiveSettingsRegular', "1em", [
    "M2 4.75C2 3.78 2.78 3 3.75 3h12.5c.97 0 1.75.78 1.75 1.75v1.5c0 .7-.4 1.3-1 1.58V9.6q-.48-.24-1-.4V8H4v6c0 1.1.9 2 2 2h3.2q.16.52.4 1H6a3 3 0 0 1-3-3V7.83c-.6-.28-1-.88-1-1.58zM3.75 4a.75.75 0 0 0-.75.75v1.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 0 0-.75-.75zm4.75 6h2.84q-.6.42-1.08 1H8.5a.5.5 0 0 1 0-1m3.57 1.44a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 0 1.02l.35.08A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.44.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $79f5cc1e1e247c23$export$788e23c3101dd8d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FingerprintFilled', "1em", [
    "M6.83 4.18c1.47-.72 4.65-1.4 8.26.95a.75.75 0 0 0 .82-1.26C11.79 1.2 8.03 1.93 6.17 2.82a.75.75 0 1 0 .66 1.36m-1.71.27c.23.35.13.82-.22 1.04a5 5 0 0 0-1.25 1.39.75.75 0 1 1-1.3-.76c.28-.48.99-1.4 1.73-1.88a.75.75 0 0 1 1.04.21m5.38-.16a.75.75 0 0 0 0 1.5c1.55 0 5.3 1.3 6.26 6.35a.75.75 0 1 0 1.48-.28C17.1 6 12.67 4.29 10.5 4.29m-1.51.78a.75.75 0 0 1-.45.96C4.6 7.46 3.61 11.23 4 13.89a.75.75 0 1 1-1.48.22c-.44-3.1.69-7.74 5.52-9.5.39-.13.82.07.96.46m-.87 3.92c-1.6 1.24-2.58 3.92-.95 7.17a.75.75 0 0 1-1.34.68c-1.92-3.82-.87-7.3 1.37-9.04a5 5 0 0 1 3.92-1.05 5.7 5.7 0 0 1 3.81 2.67.75.75 0 1 1-1.25.83 4.2 4.2 0 0 0-2.8-2.02A3.6 3.6 0 0 0 8.12 9m7.63 2.97a.75.75 0 1 0-1.5.08c.1 1.91 1.29 2.94 2.02 3.17a.75.75 0 1 0 .45-1.43l-.05-.02-.12-.08q-.16-.12-.33-.33a2.5 2.5 0 0 1-.47-1.4m-4.5.54a.75.75 0 0 0-1.5 0c0 1.07.13 1.9.45 2.73.32.8.8 1.55 1.44 2.45a.75.75 0 1 0 1.22-.86 10 10 0 0 1-1.26-2.14 6 6 0 0 1-.35-2.18m-1.13 4.64C8.05 13.4 8.78 11.58 9.5 11a1.43 1.43 0 0 1 2.3.72q.09.29.18.77l.04.17q.11.59.33 1.3c.3.95.84 1.99 1.93 2.79a.75.75 0 1 0 .89-1.21 4 4 0 0 1-1.4-2.04q-.17-.58-.28-1.15l-.04-.16c-.06-.3-.13-.64-.21-.91a2.93 2.93 0 0 0-4.68-1.45c-1.62 1.31-1.92 4.12.25 8.03a.75.75 0 0 0 1.31-.72"
]);
const $79f5cc1e1e247c23$export$19a3200e804a1958 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FingerprintRegular', "1em", [
    "M6.72 3.95c1.53-.74 4.81-1.44 8.5.97a.5.5 0 1 0 .55-.84c-4.03-2.63-7.7-1.9-9.49-1.03a.5.5 0 1 0 .44.9m-1.81.64a.5.5 0 0 1-.14.7 5 5 0 0 0-1.34 1.46.5.5 0 0 1-.86-.5c.27-.46.95-1.34 1.65-1.8a.5.5 0 0 1 .69.14m5.59-.05a.5.5 0 1 0 0 1c1.66 0 5.51 1.38 6.5 6.55a.5.5 0 0 0 1-.18c-1.1-5.72-5.43-7.37-7.5-7.37M9.34 10.8c-.87.7-1.52 2.69.56 6.46a.5.5 0 0 1-.87.48c-2.15-3.88-1.78-6.52-.32-7.71A2.68 2.68 0 0 1 13 11.35q.11.4.2.9l.04.15q.11.57.3 1.18c.26.79.67 1.57 1.48 2.16a.5.5 0 1 1-.6.8 5 5 0 0 1-1.83-2.65q-.22-.7-.33-1.29l-.03-.16-.19-.8a1.68 1.68 0 0 0-2.7-.84m6.16 1.17a.5.5 0 1 0-1 .06c.1 1.8 1.22 2.74 1.85 2.95a.5.5 0 0 0 .3-.96c-.22-.07-1.07-.64-1.15-2.05m-4.5.53a.5.5 0 1 0-1 0c0 1.04.13 1.85.44 2.64.3.77.77 1.5 1.4 2.4a.5.5 0 1 0 .82-.58 11 11 0 0 1-1.3-2.19A6 6 0 0 1 11 12.5M7.97 8.79c-1.72 1.33-2.7 4.14-1.02 7.49a.5.5 0 0 1-.9.44C4.18 13 5.22 9.65 7.35 8a4.8 4.8 0 0 1 3.73-1 5.5 5.5 0 0 1 3.65 2.56.5.5 0 1 1-.84.55 4.5 4.5 0 0 0-2.97-2.12 3.8 3.8 0 0 0-2.95.8m.49-3a.5.5 0 0 0-.35-.94c-4.68 1.7-5.79 6.19-5.35 9.22a.5.5 0 0 0 .99-.14c-.4-2.74.62-6.65 4.7-8.14"
]);
const $79f5cc1e1e247c23$export$9d997e4716e0da79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyFilled', "1em", [
    "M7 7.5C7 4.42 9.42 2 12.5 2S18 4.42 18 7.5 15.58 13 12.5 13q-.75 0-1.5-.18V13a1 1 0 0 1-1 1H9v1a1 1 0 0 1-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 16.5v-1.59q.01-.62.44-1.06l4.54-4.54q.21-.21.14-.64A6 6 0 0 1 7 7.5M15 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $79f5cc1e1e247c23$export$7ac42cb1c4afdd55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyRegular', "1em", [
    "M15 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.5-4a5.45 5.45 0 0 0-5.38 6.67q.08.42-.14.64l-4.54 4.54A1.5 1.5 0 0 0 2 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-.18q.75.19 1.5.18c3.08 0 5.5-2.42 5.5-5.5S15.58 2 12.5 2M8 7.5C8 4.98 9.98 3 12.5 3S17 4.98 17 7.5 15.02 12 12.5 12q-1 .01-1.78-.35a.5.5 0 0 0-.72.45v.9H9a1 1 0 0 0-1 1v1H7a1 1 0 0 0-1 1v.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.59a.5.5 0 0 1 .15-.35l4.54-4.54c.43-.43.52-1.04.4-1.56Q8 8 8 7.5"
]);
const $79f5cc1e1e247c23$export$9617a086e50eb4bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyCommandFilled', "1em", [
    "M5.75 4.5C6.44 4.5 7 5.06 7 5.75V7H5.75a1.25 1.25 0 1 1 0-2.5M8.5 7V5.75A2.75 2.75 0 1 0 5.75 8.5H7v3H5.75a2.75 2.75 0 1 0 2.75 2.75V13h3v1.25a2.75 2.75 0 1 0 2.75-2.75H13v-3h1.25a2.75 2.75 0 1 0-2.75-2.75V7zm0 1.5h3v3h-3zM13 7V5.75A1.25 1.25 0 1 1 14.25 7zm0 6h1.25A1.25 1.25 0 1 1 13 14.25zm-6 0v1.25A1.25 1.25 0 1 1 5.75 13z"
]);
const $79f5cc1e1e247c23$export$cbd79f580c6f0c73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyCommandRegular', "1em", [
    "M5.5 4C6.33 4 7 4.67 7 5.5V7H5.5a1.5 1.5 0 1 1 0-3M8 7V5.5A2.5 2.5 0 1 0 5.5 8H7v4H5.5A2.5 2.5 0 1 0 8 14.5V13h4v1.5a2.5 2.5 0 1 0 2.5-2.5H13V8h1.5A2.5 2.5 0 1 0 12 5.5V7zm0 1h4v4H8zm5-1V5.5A1.5 1.5 0 1 1 14.5 7zm0 6h1.5a1.5 1.5 0 1 1-1.5 1.5zm-6 0v1.5A1.5 1.5 0 1 1 5.5 13z"
]);
const $79f5cc1e1e247c23$export$c83cb9e4fe4b1417 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyMultipleFilled', "1em", [
    "m10 2 .32.01a5.5 5.5 0 0 0-1.09 7.96l-.73.74v1.69a.6.6 0 0 1-.6.6H6v1.4a.6.6 0 0 1-.6.6H2.6a.6.6 0 0 1-.6-.6v-2.86a.6.6 0 0 1 .18-.42l3.98-3.99A4 4 0 0 1 10 2M9 6.5a4.5 4.5 0 1 1 7 3.74v2.05l.78.79a.6.6 0 0 1 0 .84L15.71 15l1.06 1.07a.6.6 0 0 1-.04.89l-2.36 1.88a.6.6 0 0 1-.74 0l-2.4-1.92a.6.6 0 0 1-.23-.47v-6.2A4.5 4.5 0 0 1 9 6.5m5.25-1a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $79f5cc1e1e247c23$export$e767b120aaacca87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyMultipleRegular', "1em", [
    "M10.32 2.01 10 2a4 4 0 0 0-3.84 5.13l-3.98 3.99a.6.6 0 0 0-.18.42v2.86c0 .33.27.6.6.6h2.8a.6.6 0 0 0 .6-.6V13h1.9a.6.6 0 0 0 .6-.6v-1.7l.73-.73q-.32-.39-.56-.84l-1 .99a.6.6 0 0 0-.17.42V12H5.6a.6.6 0 0 0-.6.6V14H3v-2.3L7.32 7.4l-.12-.3a3 3 0 0 1 1.96-3.97q.5-.64 1.16-1.1m3.18 4.24a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 6.5a4.5 4.5 0 1 1 7 3.74v2.05l.78.79a.6.6 0 0 1 0 .84L15.71 15l1.06 1.07a.6.6 0 0 1-.04.89l-2.36 1.88a.6.6 0 0 1-.74 0l-2.4-1.92a.6.6 0 0 1-.23-.47v-6.2A4.5 4.5 0 0 1 9 6.5M13.5 3a3.5 3.5 0 0 0-1.75 6.53.5.5 0 0 1 .25.43v6.3l2 1.6 1.75-1.4-1.03-1.04a.6.6 0 0 1 0-.84l1.07-1.08-.61-.62a.6.6 0 0 1-.18-.42v-2.5q.01-.28.25-.43A3.5 3.5 0 0 0 13.5 3"
]);
const $79f5cc1e1e247c23$export$d4d3db6916e79421 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyResetFilled', "1em", [
    "M12.5 2a5.45 5.45 0 0 0-5.38 6.67q.08.42-.14.64l-4.54 4.54A1.5 1.5 0 0 0 2 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 0 0 1-1v-1c0-.51.26-.96.65-1.23l-1.21-1.2a1.5 1.5 0 0 1 0-2.13l2-2A1.5 1.5 0 0 1 12.9 9H14a5 5 0 0 1 3.3 1.24A5.54 5.54 0 0 0 12.5 2M14 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-2.15 3.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L10.71 11H14a3 3 0 1 1-3 3 .5.5 0 1 0-1 0 4 4 0 1 0 4-4h-3.3z"
]);
const $79f5cc1e1e247c23$export$ad5c179f4c6ab4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyResetRegular', "1em", [
    "M14 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-7 .5C7 4.42 9.42 2 12.5 2S18 4.42 18 7.5q-.02 1.51-.7 2.74a5 5 0 0 0-.83-.59q.52-.96.53-2.15C17 4.98 15.02 3 12.5 3a4.45 4.45 0 0 0-4.4 5.46c.1.52.02 1.13-.41 1.56l-4.54 4.54a.5.5 0 0 0-.15.35v1.59c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5V16a1 1 0 0 1 1-1h1v-1a1 1 0 0 1 1-1h.38A1.5 1.5 0 0 0 9 14v1a1 1 0 0 1-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 16.5v-1.59q.01-.62.44-1.06l4.54-4.54q.21-.21.14-.64A6 6 0 0 1 7 7.5m4.85 1.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L10.71 11H14a3 3 0 1 1-3 3 .5.5 0 1 0-1 0 4 4 0 1 0 4-4h-3.3z"
]);
const $79f5cc1e1e247c23$export$2fa4defa82eae901 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Keyboard123Filled', "1em", [
    "M4.88 3.6c.38-.44.76-.58 1.05-.6q.46 0 .78.3c.2.19.3.43.28.63s-.12.44-.49.65a6 6 0 0 0-2.2 1.93 2 2 0 0 0-.3.92v.12a.5.5 0 0 0 .5.45h3a.5.5 0 0 0 0-1H5.18C5.4 6.64 5.9 6.1 7 5.45c.62-.36.95-.88.99-1.45a1.8 1.8 0 0 0-.59-1.43c-.38-.36-.92-.6-1.52-.57q-.93.05-1.76.95a.5.5 0 1 0 .76.65M2.76 2.07q.23.16.24.43v5a.5.5 0 0 1-1 0V3.3l-.78.4a.5.5 0 0 1-.45-.9l1.5-.75a.5.5 0 0 1 .5.02m8.28.93c-.33 0-.75.14-1.17.6a.5.5 0 1 1-.74-.66 2.6 2.6 0 0 1 1.9-.94c.64 0 1.2.28 1.57.7a1.5 1.5 0 0 1-.32 2.3q.4.3.6.69c.26.59.08 1.2-.28 1.61s-.93.7-1.56.7c-.65 0-1.33-.29-1.91-.94a.5.5 0 1 1 .74-.66c.42.46.84.6 1.17.6.34 0 .63-.15.8-.35q.25-.31.12-.55c-.07-.17-.33-.44-1.07-.61a.5.5 0 0 1 0-.98c.74-.17 1-.44 1.07-.61q.12-.24-.12-.55c-.17-.2-.46-.35-.8-.35M2 14.5V8.91a1.5 1.5 0 0 0 1.5-.3q.42.39 1 .4h3c.59 0 1.1-.35 1.34-.84q1.01.83 2.2.83c.92 0 1.77-.4 2.32-1.05A2.5 2.5 0 0 0 13.64 5h2.86c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 14.5M5.5 13a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm8.25-4.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-7.5 2.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m3.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25-.75a.75.75 0 1 0 1.51 0 .75.75 0 0 0-1.5 0"
]);
const $79f5cc1e1e247c23$export$4aa0e6a2ffb27cb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Keyboard123Regular', "1em", [
    "M4.88 3.6c.38-.44.76-.58 1.05-.6q.46 0 .78.3c.2.19.3.43.28.63s-.12.44-.49.65a6 6 0 0 0-2.2 1.93 2 2 0 0 0-.3.92v.12a.5.5 0 0 0 .5.45h3a.5.5 0 0 0 0-1H5.18C5.4 6.64 5.9 6.1 7 5.45c.62-.36.95-.88.99-1.45a1.8 1.8 0 0 0-.59-1.43c-.38-.36-.92-.6-1.52-.57q-.93.05-1.76.95a.5.5 0 1 0 .76.65M2.76 2.07q.23.16.24.43v5a.5.5 0 0 1-1 0V3.3l-.78.4a.5.5 0 0 1-.45-.9l1.5-.75a.5.5 0 0 1 .5.02m8.28.93c-.33 0-.75.14-1.17.6a.5.5 0 1 1-.74-.66 2.6 2.6 0 0 1 1.9-.94c.64 0 1.2.28 1.57.7a1.5 1.5 0 0 1-.32 2.3q.4.3.6.69c.26.59.08 1.2-.28 1.61s-.93.7-1.56.7c-.65 0-1.33-.29-1.91-.94a.5.5 0 1 1 .74-.66c.42.46.84.6 1.17.6.34 0 .63-.15.8-.35q.25-.31.12-.55c-.07-.17-.33-.44-1.07-.61a.5.5 0 0 1 0-.98c.74-.17 1-.44 1.07-.61q.12-.24-.12-.55c-.17-.2-.46-.35-.8-.35M2 8.91v5.59c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-2.86a3 3 0 0 1 .35 1h2.51c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V8.91a1.5 1.5 0 0 1-1 0M5.5 13a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm9-4a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7 11.5A.75.75 0 1 0 7 10a.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.26.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $79f5cc1e1e247c23$export$2c18bb65eb52415e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zm2.75 3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5 12.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M14.5 8a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M7 10.5A.75.75 0 1 1 7 9a.75.75 0 0 1 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.26.75A.75.75 0 1 1 13 9a.75.75 0 0 1 0 1.5M9.25 7.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $79f5cc1e1e247c23$export$e548205db7906b29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardRegular', "1em", [
    "M5 12.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M11.5 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75A.75.75 0 1 0 10 9a.75.75 0 0 0 0 1.5m3.76-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8.5 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5zM3.5 5a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
]);
const $79f5cc1e1e247c23$export$342eada47040cf4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardDockFilled', "1em", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-6v3.3l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.15 1.14V13h-6A1.5 1.5 0 0 1 2 11.5zM5.5 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-6 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm8.25-4.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-7.5 2.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M10 8.5A.75.75 0 1 0 10 7a.75.75 0 0 0 0 1.5m2.25-.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M8.5 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $79f5cc1e1e247c23$export$ad8c3de3d90d9d70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardDockRegular', "1em", [
    "M5.5 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm6.75-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M14.5 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-8.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7 8.5A.75.75 0 1 0 7 7a.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.26.75A.75.75 0 1 0 13 7a.75.75 0 0 0 0 1.5M9.25 5.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M3.5 2C2.67 2 2 2.67 2 3.5v8c0 .83.67 1.5 1.5 1.5h6v3.3l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7l-1.15 1.14V13h6c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zm13 10h-13a.5.5 0 0 1-.5-.5v-8c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5"
]);
const $79f5cc1e1e247c23$export$3f2ee4cec0b61c65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutFloatFilled', "1em", [
    "M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H11a1 1 0 1 1-2 0H3.5A1.5 1.5 0 0 1 2 12.5zM5.5 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m6 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-6 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm8.25-4.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-7.5 2.5a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M10 9.5A.75.75 0 1 0 10 8a.75.75 0 0 0 0 1.5m2.25-.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M8.5 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $79f5cc1e1e247c23$export$e3ecb53b8be894e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutFloatRegular', "1em", [
    "M5 11.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M11.5 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m2.25 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M10 9.5A.75.75 0 1 0 10 8a.75.75 0 0 0 0 1.5m3.76-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8.5 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H11a1 1 0 1 1-2 0H3.5A1.5 1.5 0 0 1 2 12.5zM3.5 13h13a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5M2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5"
]);
const $79f5cc1e1e247c23$export$28f0b5fe7a66ffd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutOneHandedLeftFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zm2 8h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.75 8a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M6 9.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $79f5cc1e1e247c23$export$6dbd7d328feefc66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutOneHandedLeftRegular', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zM3 5.5c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5zM5.5 12a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 9.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $79f5cc1e1e247c23$export$d312a0c27dad3ec4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutResizeFilled', "1em", [
    "M3 3.5c0-.28.22-.5.5-.5h7a.5.5 0 0 0 0-1h-7C2.67 2 2 2.67 2 3.5v4a.5.5 0 0 0 1 0zM3.5 9C2.67 9 2 9.67 2 10.5v6c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5zm2 6h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1m0-2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 .75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m3.5-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M17.5 9c.28 0 .5.22.5.5v7c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 0 .5-.5v-7c0-.28.22-.5.5-.5m-4-7a.5.5 0 0 0 0 1h2.8l-4.15 4.15a.5.5 0 0 0 .7.7L17 3.71V6.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5z"
]);
const $79f5cc1e1e247c23$export$d783502dbaf34983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutResizeRegular', "1em", [
    "M3 3.5c0-.28.22-.5.5-.5h7a.5.5 0 0 0 0-1h-7C2.67 2 2 2.67 2 3.5v4a.5.5 0 0 0 1 0zM3.5 9C2.67 9 2 9.67 2 10.5v6c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5zM3 10.5c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5zM5.5 15a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0-2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2 .75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.5-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M17.5 9c.28 0 .5.22.5.5v7c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 0 .5-.5v-7c0-.28.22-.5.5-.5m-4-7a.5.5 0 0 0 0 1h2.8l-4.15 4.15a.5.5 0 0 0 .7.7L17 3.71V6.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5z"
]);
const $79f5cc1e1e247c23$export$b5a19fb5dd46e765 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutSplitFilled', "1em", [
    "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5zm3 7c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5M4.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M5.25 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 9.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M14.5 12h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1m0-4.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M12.25 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M14 9.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $79f5cc1e1e247c23$export$378e44d21a09deb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardLayoutSplitRegular', "1em", [
    "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5zM3.5 5a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5zM5 12.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.25 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 9.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M14.5 12a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm0-4.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0M12.25 8a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M14 9.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m-2.25.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
]);
const $79f5cc1e1e247c23$export$398195db7efb67e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardMouseFilled', "1em", [
    "M12 7a4 4 0 0 0 6 3.46v3.04c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5v-8C2 4.67 2.67 4 3.5 4H12zm-6.5 5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM7 9a.75.75 0 1 0 0 1.5A.75.75 0 0 0 7 9m3 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M5.5 6.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m3 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M17.4 2c.88 0 1.6.72 1.6 1.6V7a3 3 0 1 1-6 0V3.6c0-.88.72-1.6 1.6-1.6zm-2.8 1a.6.6 0 0 0-.6.6V7a2 2 0 1 0 4 0V3.6a.6.6 0 0 0-.6-.6h-.9v2.5a.5.5 0 0 1-1 0V3z"
]);
const $79f5cc1e1e247c23$export$4169ad4b345e191e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardMouseRegular', "1em", [
    "M12 5H3.5a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-2.63q.54-.14 1-.4v3.03c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5v-8C2 4.67 2.67 4 3.5 4H12zm2.5 7a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zM7 9a.75.75 0 1 1 0 1.5A.75.75 0 0 1 7 9m3 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m7.4-7c.88 0 1.6.72 1.6 1.6V7a3 3 0 1 1-6 0V3.6c0-.88.72-1.6 1.6-1.6zm-2.8 1a.6.6 0 0 0-.6.6V7a2 2 0 1 0 4 0V3.6a.6.6 0 0 0-.6-.6h-.9v2.5a.5.5 0 0 1-1 0V3zM5.5 6.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3 1.5h-.08.17z"
]);
const $79f5cc1e1e247c23$export$430b16ad5dcf5c18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardMouseOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15H3.5A1.5 1.5 0 0 1 2 13.5v-8c0-.76.57-1.4 1.3-1.49L2.16 2.85a.5.5 0 0 1 0-.7M5.5 12a.5.5 0 0 0 0 1h6.8l-1-1zM12 7a4 4 0 0 0 6 3.46v3.04c0 .64-.4 1.2-.98 1.4l-2.11-2.11a.5.5 0 0 0-.4-.79h-.39l-8-8H12zm5.4-5c.88 0 1.6.72 1.6 1.6V7a3 3 0 1 1-6 0V3.6c0-.88.72-1.6 1.6-1.6zm-2.8 1a.6.6 0 0 0-.6.6V7a2 2 0 1 0 4 0V3.6a.6.6 0 0 0-.6-.6h-.9v2.5a.5.5 0 0 1-1 0V3z"
]);
const $79f5cc1e1e247c23$export$c9e55049e2dfa389 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardMouseOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15H3.5A1.5 1.5 0 0 1 2 13.5v-8c0-.76.57-1.4 1.3-1.49L2.16 2.85a.5.5 0 0 1 0-.7M3.5 5a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h9.8l-1-1H5.5a.5.5 0 0 1 0-1h5.8l-7-7zM18 13.5c0 .64-.4 1.2-.98 1.4l-.9-.9h.38a.5.5 0 0 0 .5-.5v-2.63q.54-.14 1-.4zM17.4 2c.88 0 1.6.72 1.6 1.6V7a3 3 0 1 1-6 0V3.6c0-.88.72-1.6 1.6-1.6zm-2.8 1a.6.6 0 0 0-.6.6V7a2 2 0 1 0 4 0V3.6a.6.6 0 0 0-.6-.6h-.9v2.5a.5.5 0 0 1-1 0V3zM12 5H7.12l-1-1H12z"
]);
const $79f5cc1e1e247c23$export$1d65363bb7d11ae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardOffFilled', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15H3.5A1.5 1.5 0 0 1 2 13.5v-8c0-.76.57-1.4 1.3-1.49L2.16 2.85a.5.5 0 0 1 0-.7M16.5 4c.83 0 1.5.67 1.5 1.5v8c0 .64-.4 1.2-.98 1.4L6.12 4zm-11 8a.5.5 0 0 0 0 1h6.8l-1-1zM7 9a.75.75 0 1 0 0 1.5A.75.75 0 0 0 7 9m6 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M5.5 6.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m6 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m3 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
]);
const $79f5cc1e1e247c23$export$bb811995e5bdfe1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardOffRegular', "1em", [
    "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15H3.5A1.5 1.5 0 0 1 2 13.5v-8c0-.76.57-1.4 1.3-1.49L2.16 2.85a.5.5 0 0 1 0-.7M16.5 4c.83 0 1.5.67 1.5 1.5v8c0 .64-.4 1.2-.98 1.4l-.9-.9h.38a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5H7.12l-1-1zm-13 1a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h9.8l-1-1H5.5a.5.5 0 1 1 0-1h5.8L6.12 6.83q.12.19.12.42a.75.75 0 1 1-.33-.62L4.29 5zM7 9a.75.75 0 1 1 0 1.5A.75.75 0 0 1 7 9m6 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m-1.5-2.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
]);
const $79f5cc1e1e247c23$export$ed99304f4d32fd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardShiftFilled', "1em", [
    "M11.14 2.53a1.5 1.5 0 0 0-2.28 0l-6.62 7.8A1 1 0 0 0 3 11.98h3V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5.02h3a1 1 0 0 0 .76-1.65z"
]);
const $79f5cc1e1e247c23$export$f2b50a0014deb1a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardShiftRegular', "1em", [
    "M8.86 2.53c.6-.7 1.68-.7 2.28 0l6.62 7.8a1 1 0 0 1-.76 1.65h-3V17a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-5.02H3a1 1 0 0 1-.76-1.65zm1.52.65a.5.5 0 0 0-.76 0L3 10.98h3.5c.28 0 .5.23.5.5V17h6v-5.52c0-.27.22-.5.5-.5H17z"
]);
const $79f5cc1e1e247c23$export$a375ba59f63085c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardShiftUppercaseFilled', "1em", [
    "M11.14 2.53a1.5 1.5 0 0 0-2.28 0l-6.62 7.8A1 1 0 0 0 3 11.98h3V15a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3.02h3a1 1 0 0 0 .76-1.65zM6.5 17a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $79f5cc1e1e247c23$export$7b42507ee112ab45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardShiftUppercaseRegular', "1em", [
    "M11.14 2.53a1.5 1.5 0 0 0-2.28 0l-6.62 7.8A1 1 0 0 0 3 11.98h3V15a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3.02h3a1 1 0 0 0 .76-1.65zm-1.52.65a.5.5 0 0 1 .76 0l6.62 7.8h-3.5a.5.5 0 0 0-.5.5V15H7v-3.52a.5.5 0 0 0-.5-.5H3zM6.5 17a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $79f5cc1e1e247c23$export$928d6d0cea085ac4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardTabFilled', "1em", [
    "M17 4.75a.75.75 0 0 0-1.5 0v10.5a.75.75 0 0 0 1.5 0zm-8.47-.53a.75.75 0 0 0-1.06 1.06l3.97 3.97H2.75a.75.75 0 0 0 0 1.5h8.69l-3.97 3.97a.75.75 0 1 0 1.06 1.06l5.25-5.25c.3-.3.3-.77 0-1.06z"
]);
const $79f5cc1e1e247c23$export$9b1d6c6130f3d07b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('KeyboardTabRegular', "1em", [
    "M9.35 4.15a.5.5 0 1 0-.7.7l4.64 4.65H3.5a.5.5 0 0 0 0 1h9.8l-4.65 4.65a.5.5 0 0 0 .7.7l5.5-5.5a.5.5 0 0 0 0-.7zM17 4.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0z"
]);
const $79f5cc1e1e247c23$export$5db203c2c10279b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SidebarSearchLtrFilled', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-2.59a2 2 0 0 0-.35-.56l-2-2A4.5 4.5 0 0 0 5.5 8c-.93 0-1.78.28-2.5.76zm10 1v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0m-4 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L7.6 15.3q-.9.68-2.1.7A3.5 3.5 0 1 1 9 12.5m-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
]);
const $79f5cc1e1e247c23$export$eabe65147de2dcb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SidebarSearchLtrRegular', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-2.59a2 2 0 0 0-.35-.56l-.44-.44h3.38c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v2.76q-.55.19-1 .5zm5.3 9.1q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m8-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5"
]);
const $79f5cc1e1e247c23$export$9bd7765be9028ee2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SidebarSearchRtlFilled', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v7a4.5 4.5 0 1 0-4.5 4.5h-7A2.5 2.5 0 0 1 3 14.5zm3 1v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0m10 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L14.6 15.3q-.9.68-2.1.7a3.5 3.5 0 1 1 3.5-3.5m-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
]);
const $79f5cc1e1e247c23$export$b4f95250307f0971 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SidebarSearchRtlRegular', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v7c0-1.07-.37-2.06-1-2.83V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h4.17c.77.63 1.76 1 2.83 1h-7A2.5 2.5 0 0 1 3 14.5zm3 1a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm10 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L14.6 15.3a3.5 3.5 0 1 1 1.4-2.8m-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
]);
const $79f5cc1e1e247c23$export$2b1413bf1f00e973 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Space3DFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6.5h-.71L14.86 10H16V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4h1.14L3.7 12.5H3zm0 8v-.5h4.34l-.82 2.86-.2.64H6a3 3 0 0 1-3-3m4.48 2.64.9-3.14h3.24l.9 3.13.1.37H7.37zm1.18-4.14h2.68l-.72-2.5H9.38zm4.82 3.86-.82-2.86H17v.5a3 3 0 0 1-3 3h-.35zm-1.1-3.86h2.76L13.7 10h-2.05zm-7.52 0h2.76l.72-2.5H6.29z"
]);
const $79f5cc1e1e247c23$export$7a6b45dde4b55bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Space3DRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm13 0a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3h12zM4 12l1.14-2H4zm.86.5h2.76l.72-2.5H6.29zm-.86 1v.5c0 1.1.9 2 2 2h.62l.72-2.5zm4.38 0L7.66 16h4.68l-.72-2.5zm4.28 0 .72 2.5H14a2 2 0 0 0 2-2v-.5zm2.48-1L13.7 10h-2.05l.72 2.5zm-3.8 0-.72-2.5H9.38l-.72 2.5zM16 12v-2h-1.14z"
]);
const $79f5cc1e1e247c23$export$f7f91464c3f7246e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SpacebarFilled', "1em", [
    "M2.75 7.75c.41 0 .75.34.75.75v2h13v-2a.75.75 0 0 1 1.5 0v2c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 10.5v-2c0-.41.34-.75.75-.75"
]);
const $79f5cc1e1e247c23$export$19dec61eab7ff3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SpacebarRegular', "1em", [
    "M2.5 8c.28 0 .5.22.5.5v2c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 10.5v-2c0-.28.22-.5.5-.5"
]);
const $79f5cc1e1e247c23$export$f04d4f06c15a9d5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleFilled', "1em", [
    "M7.4 12.8a1.04 1.04 0 0 0 1.59-.51l.45-1.37a2.3 2.3 0 0 1 1.47-1.48l1.4-.45A1.04 1.04 0 0 0 12.25 7l-1.37-.45A2.3 2.3 0 0 1 9.4 5.08L8.95 3.7a1 1 0 0 0-.82-.68 1.04 1.04 0 0 0-1.15.7l-.46 1.4a2.3 2.3 0 0 1-1.44 1.45L3.7 7a1.04 1.04 0 0 0 .02 1.97l1.37.45a2.3 2.3 0 0 1 1.48 1.48l.46 1.4q.1.3.38.5m6.14 4.05a.8.8 0 0 0 1.22-.4l.25-.76a1.1 1.1 0 0 1 .68-.68l.77-.25a.8.8 0 0 0-.02-1.52l-.77-.25a1.1 1.1 0 0 1-.68-.68l-.25-.77a.8.8 0 0 0-1.52.01l-.24.76a1.1 1.1 0 0 1-.67.68l-.77.25a.8.8 0 0 0 0 1.52l.77.25a1.1 1.1 0 0 1 .68.68l.25.77q.09.25.3.4"
]);
const $79f5cc1e1e247c23$export$485777dc4b1bd5fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleRegular', "1em", [
    "M7.4 12.8a1.04 1.04 0 0 0 1.59-.51l.45-1.37a2.3 2.3 0 0 1 1.47-1.48l1.4-.45A1.04 1.04 0 0 0 12.25 7l-1.37-.45A2.3 2.3 0 0 1 9.4 5.08L8.95 3.7a1 1 0 0 0-.82-.68 1.04 1.04 0 0 0-1.15.7l-.46 1.4a2.3 2.3 0 0 1-1.44 1.45L3.7 7a1.04 1.04 0 0 0 .02 1.97l1.37.45a2.3 2.3 0 0 1 1.48 1.48l.46 1.4q.1.3.38.5m.08-7.4.53-1.38.44 1.37a3.3 3.3 0 0 0 2.12 2.12l1.4.53-1.38.45a3.3 3.3 0 0 0-2.11 2.11l-.53 1.38-.45-1.38a3.3 3.3 0 0 0-2.1-2.12L4 7.96 5.4 7.5a3.4 3.4 0 0 0 2.08-2.12m6.06 11.45a.8.8 0 0 0 1.22-.4l.25-.76a1.1 1.1 0 0 1 .68-.68l.77-.25a.8.8 0 0 0-.02-1.52l-.77-.25a1.1 1.1 0 0 1-.68-.68l-.25-.77a.8.8 0 0 0-1.52.01l-.24.76a1.1 1.1 0 0 1-.67.68l-.77.25a.8.8 0 0 0 0 1.52l.77.25a1.1 1.1 0 0 1 .68.68l.25.77q.09.25.3.4m-.92-2.8-.18-.05.19-.06a2.1 2.1 0 0 0 1.3-1.32l.06-.18.05.18a2 2 0 0 0 1.32 1.32l.2.06-.18.06a2 2 0 0 0-1.32 1.32l-.06.18-.06-.18a2 2 0 0 0-1.32-1.32"
]);
const $79f5cc1e1e247c23$export$6c4be85eb4a42ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleActionFilled', "1em", [
    "M9.03 14.42a.75.75 0 0 1 1.05 1.05l-.05.06-2.5 2.5a.75.75 0 0 1-1.06-1.06l2.5-2.5zm-5.25.75a.75.75 0 0 1 1 1.11l-1.5 1.5a.75.75 0 0 1-1.06-1.06l1.5-1.5zm10.9-5.87c.09-.4.64-.4.75-.02l.13.7c.13.77.71 1.38 1.47 1.54l.66.15.06.02c.33.12.32.57.04.71l-.07.03-.71.13c-.77.13-1.37.71-1.54 1.47l-.14.67c-.1.4-.66.4-.76.02l-.13-.7a1.9 1.9 0 0 0-1.47-1.55l-.67-.14c-.4-.1-.4-.7.02-.77l.67-.12a1.9 1.9 0 0 0 1.53-1.47zm-6.96 1.92a.75.75 0 0 1 1.06 1.06l-2.25 2.25-.06.05a.75.75 0 0 1-1-1.11zm-2-2a.75.75 0 0 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06zm4.2-6.75c.14-.63 1.02-.63 1.16 0l.2 1a2.9 2.9 0 0 0 2.26 2.25l1 .2c.6.13.61.97.05 1.14l-1.05.21a2.9 2.9 0 0 0-2.26 2.26l-.2 1-.03.08c-.18.5-.85.5-1.07.08l-.04-.1-.21-1.06a2.9 2.9 0 0 0-2.26-2.26l-1-.2c-.6-.12-.62-.96-.06-1.13l1.05-.22a2.9 2.9 0 0 0 2.26-2.26z"
]);
const $79f5cc1e1e247c23$export$651025b0d953a3a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleActionRegular', "1em", [
    "M9.22 14.58a.5.5 0 0 1 .63.77l-2.5 2.5a.5.5 0 0 1-.7-.7l2.5-2.5zm-5.08.57c.2-.2.52-.2.71 0 .2.2.2.5 0 .7l-1.5 1.5-.08.07a.5.5 0 0 1-.62-.78zM14.67 9.3c.1-.4.65-.4.76-.02l.13.7c.13.77.71 1.38 1.47 1.54l.66.15.05.02c.34.12.33.57.05.71l-.07.03-.71.13c-.77.13-1.37.71-1.54 1.47l-.15.67c-.09.4-.65.4-.75.02l-.13-.7a1.9 1.9 0 0 0-1.47-1.55l-.67-.14c-.41-.1-.4-.7.02-.77l.67-.12a1.9 1.9 0 0 0 1.53-1.47zm-6.53 1.85a.5.5 0 0 1 .71.7l-2.5 2.5a.5.5 0 1 1-.7-.7zM5.72 9.08a.5.5 0 0 1 .7.7l-.07.07-3.5 3.5-.08.07a.5.5 0 0 1-.63-.77l3.5-3.5zm4.2-6.61c.14-.63 1.02-.63 1.16 0l.2 1a2.9 2.9 0 0 0 2.26 2.25l1 .2c.6.13.61.97.05 1.14l-1.05.21a2.9 2.9 0 0 0-2.26 2.26l-.2 1-.03.08c-.18.5-.85.5-1.07.08l-.04-.1-.21-1.06a2.9 2.9 0 0 0-2.26-2.26l-1-.2c-.6-.12-.62-.96-.06-1.13l1.05-.22a2.9 2.9 0 0 0 2.26-2.26z"
]);
const $79f5cc1e1e247c23$export$5bd3d084a5df525a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleCircleFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.82 5.58l.26.73c.1.28.33.5.61.6l.73.26a.87.87 0 0 1 0 1.65l-.73.26a1 1 0 0 0-.6.61l-.27.73a.87.87 0 0 1-1.65 0l-.25-.73a1 1 0 0 0-.61-.6l-.73-.27a.88.88 0 0 1 0-1.65l.73-.25a1 1 0 0 0 .6-.61l.26-.73a.87.87 0 0 1 1.65 0M11.33 10a.7.7 0 0 1 1.34 0l.18.6c.08.26.29.47.56.55l.6.18a.7.7 0 0 1 0 1.34l-.6.18a.8.8 0 0 0-.56.56l-.18.6a.7.7 0 0 1-1.34 0l-.18-.6a.8.8 0 0 0-.56-.56l-.59-.18a.7.7 0 0 1 0-1.34l.6-.18a.8.8 0 0 0 .55-.56z"
]);
const $79f5cc1e1e247c23$export$a5198585264535fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleCircleRegular', "1em", [
    "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.18-4.42a.87.87 0 0 1 1.64 0l.26.73c.1.28.33.5.61.6l.73.26a.87.87 0 0 1 0 1.65l-.73.26a1 1 0 0 0-.6.61l-.27.73a.87.87 0 0 1-1.65 0l-.25-.73a1 1 0 0 0-.61-.6l-.73-.27a.88.88 0 0 1 0-1.65l.73-.25a1 1 0 0 0 .6-.61zm5.5 4.42a.7.7 0 0 0-1.35 0l-.18.6a.8.8 0 0 1-.56.55l-.59.18a.7.7 0 0 0 0 1.34l.6.18c.26.08.47.29.55.56l.18.6a.7.7 0 0 0 1.34 0l.18-.6a.8.8 0 0 1 .56-.56l.6-.18a.7.7 0 0 0 0-1.34l-.6-.18a.8.8 0 0 1-.56-.56z"
]);
const $79f5cc1e1e247c23$export$2021bc8cda5a7f11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleCircleOffFilled', "1em", [
    "M17.15 2.15a.5.5 0 1 1 .7.7L16 4.71A8 8 0 0 1 4.7 16l-1.86 1.85a.5.5 0 0 1-.7-.7zM12.67 10c-.2-.67-1.14-.67-1.34 0l-.18.6a.8.8 0 0 1-.56.55l-.59.18c-.67.2-.66 1.14 0 1.34l.6.18c.26.08.47.29.55.56l.18.6c.2.66 1.14.66 1.34 0l.18-.6q.14-.42.56-.56l.6-.18a.7.7 0 0 0 0-1.34l-.6-.18a.8.8 0 0 1-.56-.56zM10 2c1.67 0 3.21.51 4.5 1.38l-3.9 3.9-.18-.1-.73-.26a1 1 0 0 1-.6-.61l-.26-.73a.88.88 0 0 0-1.66 0l-.25.73a1 1 0 0 1-.61.6l-.73.26a.87.87 0 0 0 0 1.65l.73.26q.43.17.6.61l.26.73.1.19-3.89 3.89A8 8 0 0 1 10 2"
]);
const $79f5cc1e1e247c23$export$396ac5fe3938ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleCircleOffRegular', "1em", [
    "M17.15 2.15a.5.5 0 1 1 .7.7L16 4.71A8 8 0 0 1 4.7 16l-1.86 1.85a.5.5 0 0 1-.7-.7zM5.42 15.29a7 7 0 0 0 9.87-9.87zm5.91-5.3c.2-.66 1.14-.66 1.34.01l.18.6c.08.26.29.47.56.55l.6.18a.7.7 0 0 1 0 1.34l-.6.18a.8.8 0 0 0-.56.56l-.18.6c-.2.66-1.14.66-1.34 0l-.18-.6a.8.8 0 0 0-.56-.56l-.59-.18a.7.7 0 0 1 0-1.34l.6-.18a.8.8 0 0 0 .55-.56zM10 2c1.67 0 3.21.51 4.5 1.38l-.73.72a7 7 0 0 0-9.67 9.67l-.72.73A8 8 0 0 1 10 2M7.17 5.58a.88.88 0 0 1 1.66 0l.25.73q.17.43.61.6l.73.26.19.1-3.34 3.34-.1-.2-.25-.72a1 1 0 0 0-.61-.6l-.73-.27a.87.87 0 0 1 0-1.65l.73-.25a1 1 0 0 0 .6-.61z"
]);
const $79f5cc1e1e247c23$export$228f46cc5e17de51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleInfoFilled', "1em", [
    "M9.98 11.31a5.5 5.5 0 0 0-2.74-2.03 2.4 2.4 0 0 0-1.16-.85l-1.37-.45a1.1 1.1 0 0 1-.7-.83 1.05 1.05 0 0 1 .68-1.14l1.4-.45A2.3 2.3 0 0 0 7.51 4.1l.46-1.4a1.04 1.04 0 0 1 1.97-.02l.46 1.4a2.3 2.3 0 0 0 1.48 1.47l1.37.45a1.1 1.1 0 0 1 .72.83 1.04 1.04 0 0 1-.68 1.15l-1.39.45a2.3 2.3 0 0 0-1.47 1.48l-.45 1.37zm4.56 4.54a.8.8 0 0 0 1.22-.4l.25-.76a1.1 1.1 0 0 1 .68-.68l.77-.25a.8.8 0 0 0-.02-1.52l-.77-.25a1.1 1.1 0 0 1-.68-.68l-.25-.77a.8.8 0 0 0-1.52.01l-.24.76a1.1 1.1 0 0 1-.67.68l-.77.25a.8.8 0 0 0 0 1.52l.77.25a1.1 1.1 0 0 1 .68.68l.25.77q.09.25.3.4M5.5 11.88a.62.62 0 1 1 0 1.24.62.62 0 0 1 0-1.24m0 5.12a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5m0-7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
]);
const $79f5cc1e1e247c23$export$95a88241beb9da12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleInfoRegular', "1em", [
    "m7.2 9.21.04.07q.75.25 1.39.7L8.5 9.6a3.3 3.3 0 0 0-2.1-2.12L5 6.96 6.4 6.5a3.4 3.4 0 0 0 2.08-2.12l.53-1.37.44 1.37a3.3 3.3 0 0 0 2.12 2.12l1.4.53-1.38.45A3.3 3.3 0 0 0 9.48 9.6l-.3.8q.45.42.8.91v-.02l.46-1.37a2.3 2.3 0 0 1 1.47-1.48l1.4-.45A1.04 1.04 0 0 0 13.25 6l-1.37-.45a2.3 2.3 0 0 1-1.48-1.48L9.95 2.7a1 1 0 0 0-.82-.68 1.04 1.04 0 0 0-1.15.7l-.46 1.4a2.3 2.3 0 0 1-1.44 1.45L4.7 6a1.05 1.05 0 0 0 .02 1.97l1.37.45q.67.23 1.11.78m7.34 6.64a.8.8 0 0 0 1.22-.4l.25-.76a1.1 1.1 0 0 1 .68-.68l.77-.25a.8.8 0 0 0-.02-1.52l-.77-.25a1.1 1.1 0 0 1-.68-.68l-.25-.77a.8.8 0 0 0-1.52.01l-.24.76a1.1 1.1 0 0 1-.67.68l-.77.25a.8.8 0 0 0 0 1.52l.77.25a1.1 1.1 0 0 1 .68.68l.25.77q.09.25.3.4m-.92-2.8-.18-.05.19-.06a2.1 2.1 0 0 0 1.3-1.32l.06-.18.05.18a2 2 0 0 0 1.32 1.32l.2.06-.18.06a2 2 0 0 0-1.32 1.32l-.06.18-.06-.18a2 2 0 0 0-1.32-1.32M5.5 11.88a.62.62 0 1 1 0 1.25.62.62 0 0 1 0-1.24m0 5.13a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5m0-7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
]);
const $79f5cc1e1e247c23$export$1836418caade2a59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleOffFilled', "1em", [
    "M17.15 2.15a.5.5 0 0 1 .7.7l-4.89 4.9.02.09a1.05 1.05 0 0 1-.68 1.15l-.86.27-2.18 2.18-.27.85q-.12.31-.39.52a1 1 0 0 1-.86.15l-4.89 4.9a.5.5 0 0 1-.7-.71zM14.1 11a.8.8 0 0 1 .63.53l.25.77a1 1 0 0 0 .68.68l.77.25a.8.8 0 0 1 .02 1.52l-.77.25a1 1 0 0 0-.68.68l-.25.76A.8.8 0 0 1 14 17a.8.8 0 0 1-.76-.54L13 15.7a1 1 0 0 0-.68-.68l-.76-.25a.8.8 0 0 1-.01-1.52l.77-.25a1 1 0 0 0 .67-.68l.24-.76a.8.8 0 0 1 .89-.54M8.13 3a1 1 0 0 1 .82.68l.46 1.4a2.3 2.3 0 0 0 1.48 1.47l.32.1-4.55 4.56-.1-.3a2.4 2.4 0 0 0-1.48-1.5l-1.37-.44a1.1 1.1 0 0 1-.7-.83 1.05 1.05 0 0 1 .68-1.14l1.4-.45a2.3 2.3 0 0 0 1.43-1.45l.46-1.4a1.04 1.04 0 0 1 1.15-.7"
]);
const $79f5cc1e1e247c23$export$cc8c71d5ba586017 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SparkleOffRegular', "1em", [
    "M17.15 2.15a.5.5 0 0 1 .7.7l-4.89 4.9.02.09a1.05 1.05 0 0 1-.68 1.15l-.86.27-2.18 2.18-.27.85q-.12.31-.39.52a1 1 0 0 1-.86.15l-4.89 4.9a.5.5 0 0 1-.7-.71zM14.1 11a.8.8 0 0 1 .63.53l.25.77a1 1 0 0 0 .68.68l.77.25a.8.8 0 0 1 .02 1.52l-.77.25a1 1 0 0 0-.68.68l-.25.76A.8.8 0 0 1 14 17a.8.8 0 0 1-.76-.54L13 15.7a1 1 0 0 0-.68-.68l-.76-.25a.8.8 0 0 1-.01-1.52l.77-.25a1 1 0 0 0 .67-.68l.24-.76a.8.8 0 0 1 .89-.54m-.18 1.6a2.1 2.1 0 0 1-1.3 1.33l-.19.06.18.06a2 2 0 0 1 1.32 1.32l.06.18.06-.18a2 2 0 0 1 1.32-1.32l.18-.06-.2-.06a2 2 0 0 1-1.32-1.32l-.05-.18zm-5.8-9.6a1 1 0 0 1 .82.68l.46 1.4a2.3 2.3 0 0 0 1.48 1.47l.32.1-.79.8a3.3 3.3 0 0 1-1.97-2.07L8 4.02l-.53 1.37A3.4 3.4 0 0 1 5.4 7.51l-1.39.45 1.38.52a3.4 3.4 0 0 1 2.05 1.95l-.78.79-.1-.3a2.4 2.4 0 0 0-1.48-1.5l-1.37-.44a1.1 1.1 0 0 1-.7-.83 1.05 1.05 0 0 1 .68-1.14l1.4-.45a2.3 2.3 0 0 0 1.43-1.45l.46-1.4a1.04 1.04 0 0 1 1.15-.7"
]);
const $79f5cc1e1e247c23$export$d353cdfa8e009f0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SpatulaSpoonFilled', "1em", [
    "m6.4 12-2.8 2.58h-.01a2 2 0 0 0 2.82 2.83h.01l2.68-2.92L7.01 12zm6.94-2.03q.49-.28 1.2-.37a6.5 6.5 0 0 0 3.44-1.63 3.5 3.5 0 1 0-4.95-4.94 6.5 6.5 0 0 0-1.63 3.44q-.09.72-.4 1.23V8zm.16-4.47c.28 0 .5.22.5.5a1 1 0 0 0 1 1 .5.5 0 0 1 0 1 2 2 0 0 1-2-2c0-.28.22-.5.5-.5M3.96 2.59a2 2 0 0 1 2.83 0L9.41 5.2A2 2 0 0 1 10 6.62v1.63q0 .22.18.38l6.07 5.09.02.01a2.5 2.5 0 1 1-3.54 3.54l-.01-.02-5.09-6.07a.5.5 0 0 0-.38-.18H5.62a2 2 0 0 1-1.41-.59L1.59 7.8a2 2 0 0 1 0-2.83zM3.4 6.15a.5.5 0 0 0 0 .7l2 2a.5.5 0 1 0 .7-.7l-2-2a.5.5 0 0 0-.7 0M5.85 4.4a.5.5 0 1 0-.7.7l2 2a.5.5 0 1 0 .7-.7z"
]);
const $79f5cc1e1e247c23$export$d914d0c04b644714 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SpatulaSpoonRegular', "1em", [
    "M6.09 3.3a1 1 0 0 0-1.42 0L2.3 5.66a1 1 0 0 0 0 1.42L4.91 9.7a1 1 0 0 0 .71.29h1.63c.44 0 .86.2 1.15.54l5.05 6.03a1.5 1.5 0 0 0 2.12-2.12L9.54 9.4A1.5 1.5 0 0 1 9 8.25V6.62a1 1 0 0 0-.3-.7zm-2.13-.71a2 2 0 0 1 2.83 0L9.41 5.2A2 2 0 0 1 10 6.62v1.63q0 .18.12.32l.64-.59c.37-.33.55-.88.64-1.51a6.5 6.5 0 0 1 1.63-3.44 3.5 3.5 0 1 1 4.95 4.94 6.5 6.5 0 0 1-3.45 1.63c-.63.09-1.18.27-1.52.64l-.4.43 3.64 3.05.02.01a2.5 2.5 0 1 1-3.54 3.54l-.01-.02-2.94-3.5-3.36 3.66a2 2 0 0 1-2.83-2.82v-.01l3.85-3.54a1 1 0 0 0-.2-.04H5.63a2 2 0 0 1-1.41-.59L1.59 7.8a2 2 0 0 1 0-2.83zm7.89 7.44.43-.46a3.5 3.5 0 0 1 2.12-.96 5.5 5.5 0 0 0 2.87-1.34 2.5 2.5 0 0 0-3.54-3.54c-.6.6-1.19 1.79-1.34 2.87-.1.7-.33 1.54-.95 2.12l-.55.5zm-3.73 1.74L4.3 15.3A1 1 0 0 0 5.7 16.7l3.44-3.73zM4.35 6.15a.5.5 0 1 0-.7.7L5.4 8.6a.5.5 0 1 0 .7-.7zm.8-1.5c.2-.2.5-.2.7 0L7.6 6.4a.5.5 0 1 1-.7.7L5.15 5.35a.5.5 0 0 1 0-.7M14 6a.5.5 0 0 0-1 0c0 1.1.9 2 2 2a.5.5 0 0 0 0-1 1 1 0 0 1-1-1"
]);
const $79f5cc1e1e247c23$export$129a4de8152c07a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StickerFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5v-3.08a6 6 0 0 1-3.47-.47 4 4 0 0 1-.86-.57l-.01-.02h-.01a.5.5 0 0 1 .7-.72l.14.12q.15.11.48.3A4.5 4.5 0 0 0 10 13q.64 0 1.15-.14a2.75 2.75 0 0 1 2.6-1.86H17V6a3 3 0 0 0-3-3zm1.5 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.7 8.41a2 2 0 0 1-.8.5v-3.16c0-.97.78-1.75 1.75-1.75h3.15a2 2 0 0 1-.49.8z"
]);
const $79f5cc1e1e247c23$export$45206bab884a57d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StickerRegular', "1em", [
    "M7.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0M3 6v8a3 3 0 0 0 3 3h5.38a2 2 0 0 0 1.41-.59l3.62-3.62a2 2 0 0 0 .59-1.41V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3m13 0v5h-2.25c-1.2 0-2.24.78-2.6 1.86q-.5.14-1.15.14a4.5 4.5 0 0 1-2.51-.74l-.14-.11a.5.5 0 0 0-.7.7v.01l.02.02.22.18q.21.16.64.39a5.5 5.5 0 0 0 3.47.47V16H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2m-3.91 9.7-.09.08v-2.03c0-.97.78-1.75 1.75-1.75h2.03l-.07.09z"
]);
const $79f5cc1e1e247c23$export$75cafbdc0722a0ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StickerAddFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-5.28 3.94 4 4 0 0 1-1.73-.68l-.14-.11a.5.5 0 0 0-.7.7v.01l.02.02.22.18q.21.16.64.39.57.3 1.5.47A5.6 5.6 0 0 0 9.6 17H6a3 3 0 0 1-3-3zm4.5 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m5.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $79f5cc1e1e247c23$export$de7ab2e2a84156a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('StickerAddRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6q-.48-.24-1-.4V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.2q.16.52.4 1H6a3 3 0 0 1-3-3zm4.97 6.55q.45.24 1.25.4-.14.46-.19.97a5 5 0 0 1-2.14-.86l-.22-.18-.01-.02h-.01a.5.5 0 0 1 .7-.72l.14.12q.15.11.48.3M7.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $79f5cc1e1e247c23$export$520d0a8a08a2950b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailFilled', "1em", [
    "M6 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 4a2 2 0 0 0-.27-1h2.54A2 2 0 1 0 13 8H7a2 2 0 1 0 2 2"
]);
const $79f5cc1e1e247c23$export$b4741a2bbff5204c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailRegular', "1em", [
    "M8.73 9A2 2 0 1 1 7 8h6a2 2 0 1 1-1.73 1zM6 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
]);
const $79f5cc1e1e247c23$export$fa74033d200d7487 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailArrowBackFilled', "1em", [
    "M6 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-2a2 2 0 0 1 1.74 1c1.23.06 2.37.52 3.26 1.26V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2a5.5 5.5 0 0 1 1.81-5.76A2 2 0 0 1 11.27 9H8.73A2 2 0 1 1 7 8zm1.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $79f5cc1e1e247c23$export$d269875862e367b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailArrowBackRegular', "1em", [
    "M8.73 9A2 2 0 1 1 7 8h6a2 2 0 0 1 1.74 1 6 6 0 0 0-1.3.1 1 1 0 0 0-1.33.45q-.6.28-1.1.7A2 2 0 0 1 11.27 9zM6 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m11-4v3.6q.54.27 1 .66V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2q-.13-.49-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1m-2.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $79f5cc1e1e247c23$export$4aae68c9d9b3cedb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailArrowForwardFilled', "1em", [
    "M6 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-2a2 2 0 0 1 1.74 1c1.23.06 2.37.52 3.26 1.26V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2a5.5 5.5 0 0 1 1.81-5.76A2 2 0 0 1 11.27 9H8.73A2 2 0 1 1 7 8zm-3 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7"
]);
const $79f5cc1e1e247c23$export$2f56bbb7bae4b23e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailArrowForwardRegular', "1em", [
    "M8.73 9A2 2 0 1 1 7 8h6a2 2 0 0 1 1.74 1 6 6 0 0 0-1.3.1 1 1 0 0 0-1.33.45q-.6.28-1.1.7A2 2 0 0 1 11.27 9zM6 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m11-4v3.6q.54.27 1 .66V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2q-.13-.49-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1m-7 8.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7"
]);
const $79f5cc1e1e247c23$export$f01111b2b044ec3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailArrowSubtractFilled', "1em", [
    "M13 8a2 2 0 0 1 1.74 1c1.23.06 2.37.52 3.26 1.26V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2a5.5 5.5 0 0 1 1.81-5.76A2 2 0 0 1 11.27 9H8.73A2 2 0 1 1 7 8zm-7 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m13 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7 0c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $79f5cc1e1e247c23$export$993e8e793be545d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailArrowSubtractRegular', "1em", [
    "M17 9.6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.02q.05.51.19 1H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4.26a6 6 0 0 0-1-.66M9 10a2 2 0 0 0-.27-1h2.54a2 2 0 0 0-.26 1.24q.5-.4 1.1-.7a1 1 0 0 1 1.33-.44 6 6 0 0 1 1.3-.1A2 2 0 0 0 13 8H7a2 2 0 1 0 2 2m-2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7 0c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $79f5cc1e1e247c23$export$3c2ccaa2b34e46fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailShieldFilled', "1em", [
    "M6 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 0 1 2-.09q-.82.61-1.65.59-.1 0-.2.02A1 1 0 0 1 12 10m1-2a2 2 0 0 1 1.83 1.18q.3-.18.66-.18h.01q.57 0 .98.43.75.8 1.52.99V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h7.24a7 7 0 0 1-.24-1.6v-2.53q0-.46.29-.84A2 2 0 0 1 11.27 9H8.73A2 2 0 1 1 7 8zm2.5 11q-.06 0-.11-.02a6 6 0 0 1-1.76-.98q-.52-.45-.88-1a5 5 0 0 1-.75-2.64v-2.49c0-.2.16-.37.35-.37q1.6 0 2.9-1.39.11-.1.25-.11t.24.11a3.9 3.9 0 0 0 2.9 1.39c.2 0 .36.17.36.38v2.48a5 5 0 0 1-.75 2.64q-.36.55-.88 1a6 6 0 0 1-1.87 1"
]);
const $79f5cc1e1e247c23$export$60ae40b67669b540 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailShieldRegular', "1em", [
    "M8.73 9A2 2 0 1 1 7 8h6a2 2 0 0 1 1.83 1.18q-.17.1-.3.25-.27.28-.53.48a1 1 0 1 0-1.86.6c-.36.06-.65.26-.85.52A2 2 0 0 1 11.27 9zM6 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m11-4v3.9q.5.39 1 .52V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h7.24a7 7 0 0 1-.2-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1m-1.5 13q-.06 0-.11-.02a6 6 0 0 1-1.76-.98q-.52-.45-.88-1a5 5 0 0 1-.75-2.64v-2.49c0-.2.16-.37.35-.37q1.6 0 2.9-1.39.11-.1.25-.11t.24.11a3.9 3.9 0 0 0 2.9 1.39c.2 0 .36.17.36.38v2.48a5 5 0 0 1-.75 2.64q-.36.55-.88 1a6 6 0 0 1-1.87 1"
]);
const $79f5cc1e1e247c23$export$a24aad76c5f744bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailSubtractFilled', "1em", [
    "M13 8a2 2 0 0 1 1.74 1c1.23.06 2.37.52 3.26 1.26V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2a5.5 5.5 0 0 1 1.81-5.76A2 2 0 0 1 11.27 9H8.73A2 2 0 1 1 7 8zm-7 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m13 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7 0c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);
const $79f5cc1e1e247c23$export$2d971b83c03db21d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VoicemailSubtractRegular', "1em", [
    "M17 9.6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.02q.05.51.19 1H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4.26a6 6 0 0 0-1-.66M9 10a2 2 0 0 0-.27-1h2.54a2 2 0 0 0-.26 1.24q.5-.4 1.1-.7a1 1 0 0 1 1.33-.44 6 6 0 0 1 1.3-.1A2 2 0 0 0 13 8H7a2 2 0 1 0 2 2m-2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-7 0c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5"
]);


"use client";
const $5fff284e497fef75$export$ed318b938158e692 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BarcodeScannerFilled', "1em", [
    "M2 5.75A2.75 2.75 0 0 1 4.75 3h.75a.75.75 0 0 1 0 1.5h-.75c-.69 0-1.25.56-1.25 1.25v.75a.75.75 0 0 1-1.5 0zm11.75-2c0-.41.34-.75.75-.75h.75A2.75 2.75 0 0 1 18 5.75v.75a.75.75 0 0 1-1.5 0v-.75c0-.69-.56-1.25-1.25-1.25h-.75a.75.75 0 0 1-.75-.75m-11 9c.41 0 .75.34.75.75v.75c0 .69.56 1.25 1.25 1.25h.75a.75.75 0 0 1 0 1.5h-.75A2.75 2.75 0 0 1 2 14.25v-.75c0-.41.34-.75.75-.75m14.5 0c.41 0 .75.34.75.75v.75A2.75 2.75 0 0 1 15.25 17h-.75a.75.75 0 0 1 0-1.5h.75c.69 0 1.25-.56 1.25-1.25v-.75c0-.41.34-.75.75-.75M5.5 6c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m3.75.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zM11.5 6c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m3.75.75a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0z"
]);
const $5fff284e497fef75$export$202cb1d85ccee54e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BarcodeScannerRegular', "1em", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h1a.5.5 0 0 1 0 1h-1C3.67 4 3 4.67 3 5.5v1a.5.5 0 0 1-1 0zm12-2c0-.28.22-.5.5-.5h1A2.5 2.5 0 0 1 18 5.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1-.5-.5M2.5 13c.28 0 .5.22.5.5v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 0 1 0 1h-1A2.5 2.5 0 0 1 2 14.5v-1c0-.28.22-.5.5-.5m15 0c.28 0 .5.22.5.5v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1h1c.83 0 1.5-.67 1.5-1.5v-1c0-.28.22-.5.5-.5m-12-7c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m3.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0zm2.5-.5c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m3.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0z"
]);
const $5fff284e497fef75$export$a4488b7ee63fae00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BarcodeScannerAddFilled', "1em", [
    "M14.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M2.75 12.75c.41 0 .75.34.75.75v.75c0 .69.56 1.25 1.25 1.25h.75a.75.75 0 0 1 0 1.5h-.75A2.75 2.75 0 0 1 2 14.25v-.75c0-.41.34-.75.75-.75M14.5 11a.5.5 0 0 0-.5.5V13h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m-9-5c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m3 0c.41 0 .75.34.75.75v5.1a6 6 0 0 0-.24 1.95.74.74 0 0 1-1.26-.55v-6.5c0-.41.34-.75.75-.75m3 0c.41 0 .75.34.75.75v1.73a6 6 0 0 0-1.5 1V6.75c0-.41.34-.75.75-.75m3 0c.41 0 .75.34.75.75v1.3a6 6 0 0 0-1.5 0v-1.3c0-.41.34-.75.75-.75m-9-3a.75.75 0 0 1 0 1.5h-.75c-.69 0-1.25.56-1.25 1.25v.75a.75.75 0 0 1-1.5 0v-.75A2.75 2.75 0 0 1 4.75 3zm9.75 0A2.75 2.75 0 0 1 18 5.75v.75a.75.75 0 0 1-1.5 0v-.75c0-.69-.56-1.25-1.25-1.25h-.75a.75.75 0 0 1 0-1.5z"
]);
const $5fff284e497fef75$export$929b4d6e179707cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BarcodeScannerAddRegular', "1em", [
    "M14.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-12 4c.28 0 .5.22.5.5v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 0 1 0 1h-1A2.5 2.5 0 0 1 2 14.5v-1c0-.28.22-.5.5-.5m12-2a.5.5 0 0 0-.5.5V13h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m-9-5c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v2.1q-.54.27-1 .66V6.5c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v1.52a6 6 0 0 0-1 0V6.5c0-.28.22-.5.5-.5m-9-3a.5.5 0 0 1 0 1h-1C3.67 4 3 4.67 3 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 4.5 3zm10 0A2.5 2.5 0 0 1 18 5.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1z"
]);
const $5fff284e497fef75$export$ef7633f8f8d7ba01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BarcodeScannerDismissFilled', "1em", [
    "M14.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M2.75 12.75c.41 0 .75.34.75.75v.75c0 .69.56 1.25 1.25 1.25h.75a.75.75 0 0 1 0 1.5h-.75A2.75 2.75 0 0 1 2 14.25v-.75c0-.41.34-.75.75-.75m13.6-1.1a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M5.5 6c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-6.5c0-.41.34-.75.75-.75m3 0c.41 0 .75.34.75.75v5.1a6 6 0 0 0-.24 1.95.74.74 0 0 1-1.26-.55v-6.5c0-.41.34-.75.75-.75m3 0c.41 0 .75.34.75.75v1.73a6 6 0 0 0-1.5 1V6.75c0-.41.34-.75.75-.75m3 0c.41 0 .75.34.75.75v1.3a6 6 0 0 0-1.5 0v-1.3c0-.41.34-.75.75-.75m-9-3a.75.75 0 0 1 0 1.5h-.75c-.69 0-1.25.56-1.25 1.25v.75a.75.75 0 0 1-1.5 0v-.75A2.75 2.75 0 0 1 4.75 3zm9.75 0A2.75 2.75 0 0 1 18 5.75v.75a.75.75 0 0 1-1.5 0v-.75c0-.69-.56-1.25-1.25-1.25h-.75a.75.75 0 0 1 0-1.5z"
]);
const $5fff284e497fef75$export$ecea77ec16648a7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BarcodeScannerDismissRegular', "1em", [
    "M14.5 9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m-12 4c.28 0 .5.22.5.5v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 0 1 0 1h-1A2.5 2.5 0 0 1 2 14.5v-1c0-.28.22-.5.5-.5m13.85-1.35a.5.5 0 0 0-.7 0l-1.15 1.14-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7l-1.14-1.15 1.14-1.15a.5.5 0 0 0 0-.7M5.5 6c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v2.1q-.54.27-1 .66V6.5c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v1.52a6 6 0 0 0-1 0V6.5c0-.28.22-.5.5-.5m-9-3a.5.5 0 0 1 0 1h-1C3.67 4 3 4.67 3 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 4.5 3zm10 0A2.5 2.5 0 0 1 18 5.5v1a.5.5 0 0 1-1 0v-1c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1z"
]);
const $5fff284e497fef75$export$5c836f855f234eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DashboardFilled', "1em", [
    "M7 17H6a3 3 0 0 1-3-3v-1h4zm10-3a3 3 0 0 1-3 3H8v-4h9zm-5-2H3V6a3 3 0 0 1 3-3h6zm5 0h-4V8h4zm-3-9a3 3 0 0 1 3 3v1h-4V3z"
]);
const $5fff284e497fef75$export$cd8ffd16096b52a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DashboardRegular', "1em", [
    "M14 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM4 14c0 1.1.9 2 2 2h1v-3H4zm4 2h6a2 2 0 0 0 2-2v-1H8zM6 4a2 2 0 0 0-2 2v6h8V4zm7 8h3V8h-3zm0-5h3V6a2 2 0 0 0-2-2h-1z"
]);
const $5fff284e497fef75$export$d54d442e36166503 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DirectionsFilled', "1em", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zm3.47 3.27a.5.5 0 0 0-.7.7L11.79 7H10a3 3 0 0 0-3 3v3a.5.5 0 0 0 1 0v-3c0-1.1.9-2 2-2h1.8l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7z"
]);
const $5fff284e497fef75$export$e17b7a21ce03132b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DirectionsRegular', "1em", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24zm3.53.7a2 2 0 0 0-2.83 0l-6 6a2 2 0 0 0 0 2.83l6 6a2 2 0 0 0 2.83 0l6-6a2 2 0 0 0 0-2.83zm-.76 2.57c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L11.79 8H10a2 2 0 0 0-2 2v3a.5.5 0 0 1-1 0v-3a3 3 0 0 1 3-3h1.8l-1.15-1.15a.5.5 0 0 1 0-.7"
]);
const $5fff284e497fef75$export$1d3f8caf2ae69ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FlipHorizontalFilled', "1em", [
    "M17.88 15.66a.8.8 0 0 1-.63.34h-5.5a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 1.44-.3l5.5 12.5c.1.23.08.5-.06.71M12.5 6.32v8.18h3.6zM2.5 16a.5.5 0 0 1-.45-.71l6-13A.5.5 0 0 1 9 2.5v13a.5.5 0 0 1-.5.5z"
]);
const $5fff284e497fef75$export$39f9d7ca93e85db7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FlipHorizontalRegular', "1em", [
    "M17.92 15.77a.5.5 0 0 1-.42.23h-6a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .95-.2l6 13a.5.5 0 0 1-.03.47M12 4.77V15h4.72zM2.5 16a.5.5 0 0 1-.45-.71l6-13A.5.5 0 0 1 9 2.5v13a.5.5 0 0 1-.5.5z"
]);
const $5fff284e497fef75$export$6c38a715b6c8a669 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FlipVerticalFilled', "1em", [
    "M15.66 2.12c.21.14.34.38.34.63v5.5c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.3-1.44l12.5-5.5c.23-.1.5-.08.71.06M6.32 7.5h8.18V3.9zm9.68 10a.5.5 0 0 1-.71.45l-13-6A.5.5 0 0 1 2.5 11h13c.28 0 .5.22.5.5z"
]);
const $5fff284e497fef75$export$762df22574cd04d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FlipVerticalRegular', "1em", [
    "M15.77 2.08q.22.16.23.42v6a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.2-.95l13-6a.5.5 0 0 1 .47.03M4.77 8H15V3.28zM16 17.5a.5.5 0 0 1-.71.45l-13-6A.5.5 0 0 1 2.5 11h13c.28 0 .5.22.5.5z"
]);
const $5fff284e497fef75$export$2a10e8c60aa0c5eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GifFilled', "1em", [
    "M15.4 3c1.39 0 2.52 1.19 2.6 2.68v8.48c0 1.51-1.09 2.75-2.45 2.84H4.6c-1.39 0-2.52-1.19-2.6-2.68V5.84C2 4.33 3.09 3.1 4.45 3H15.4M6.85 7C5.18 7 4 8.32 4 10c0 1.64 1.26 3 2.85 3 1.2 0 2.07-.8 2.14-1.63l.01-.12V9.9a.5.5 0 0 0-.44-.4h-.1l-.92-.01h-.1A.5.5 0 0 0 7 10c0 .25.2.45.44.5h.48v.83c-.07.32-.47.67-1.07.67-.96 0-1.77-.88-1.77-2 0-1.17.74-2 1.77-2q.7 0 1.1.2c.26.12.59.02.72-.23.14-.24.03-.55-.24-.67Q7.78 7 6.85 7M11 7a.5.5 0 0 0-.5.41v5.18a.5.5 0 0 0 1 0V7.41A.5.5 0 0 0 11 7m4.5 0h-2a.5.5 0 0 0-.5.41v5.18a.5.5 0 0 0 1 0V11h1.59a.5.5 0 0 0 0-1H14V8h1.59a.5.5 0 0 0 0-1z"
]);
const $5fff284e497fef75$export$7ca06f2f338521c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GifRegular', "1em", [
    "M15.4 3c1.39 0 2.52 1.19 2.6 2.68v8.48c0 1.51-1.09 2.75-2.45 2.84H4.6c-1.39 0-2.52-1.19-2.6-2.68V5.84C2 4.33 3.09 3.1 4.45 3H15.4m-.15 1H4.75C3.82 4 3.07 4.8 3 5.8v8.27c0 1.02.72 1.86 1.63 1.93h10.62c.93 0 1.68-.8 1.75-1.8V5.93c0-1.02-.72-1.86-1.63-1.93zm-8.4 3q.93 0 1.58.3c.27.12.38.43.24.67a.56.56 0 0 1-.72.22q-.4-.18-1.1-.19c-1.03 0-1.77.83-1.77 2 0 1.12.81 2 1.77 2 .6 0 1-.35 1.06-.67v-.83h-.37c-.3 0-.54-.22-.54-.5 0-.25.2-.45.44-.5h1.02c.26 0 .49.18.53.41l.01.1v1.24C9 12.12 8.11 13 6.85 13A2.9 2.9 0 0 1 4 10c0-1.68 1.18-3 2.85-3M11 7a.5.5 0 0 1 .5.41v5.09a.5.5 0 0 1-1 .09V7.5c0-.28.22-.5.5-.5m4.5 0a.5.5 0 0 1 .09 1H14v2h1.5a.5.5 0 0 1 .09 1H14v1.5a.5.5 0 0 1-1 .09V7.5c0-.28.22-.5.5-.5z"
]);
const $5fff284e497fef75$export$331c00ef187a911e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_20_color__a)",
            "d": "M4 9h12v6.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5z"
        }
    ],
    [
        "rect",
        {
            "width": "14",
            "height": "4",
            "x": "3",
            "y": "6",
            "fill": "url(#ic_fluent_gift_20_color__b)",
            "rx": "1"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M9.25 18v-8h1.5v8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_20_color__c)",
            "d": "M9.25 18v-8h1.5v8z"
        }
    ],
    [
        "path",
        {
            "fill": "#000",
            "d": "M10.75 5.75V10h-1.5V5.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_20_color__d)",
            "d": "M10.75 5.75V10h-1.5V5.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_20_color__e)",
            "fillRule": "evenodd",
            "d": "m10 2.61.06-.05a2.75 2.75 0 1 1 1.92 4.69H8.02A2.74 2.74 0 1 1 10 2.61m2.88 1a1.25 1.25 0 0 0-2.13.89v1.25h1.24a1.25 1.25 0 0 0 .9-2.13m-3.63.89q0-.5-.37-.88a1.25 1.25 0 1 0-.87 2.13h1.24z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_gift_20_color__a",
                "x1": "9.23",
                "x2": "9.23",
                "y1": "21.54",
                "y2": "5.49",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#bb45ea"
                }
            ],
            [
                "stop",
                {
                    "offset": ".35",
                    "stopColor": "#8b57ed"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gift_20_color__c",
                "x1": "9.25",
                "x2": "9.25",
                "y1": "5.5",
                "y2": "16.61",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gift_20_color__d",
                "x1": "9.25",
                "x2": "9.25",
                "y1": "-12.46",
                "y2": "17.29",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gift_20_color__e",
                "x1": "12.64",
                "x2": "9.79",
                "y1": "7.25",
                "y2": "-4.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_gift_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(18.0312 0 0 6.25 10 4.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".2",
                    "stopColor": "#5b2ab5"
                }
            ],
            [
                "stop",
                {
                    "offset": ".76",
                    "stopColor": "#8b57ed"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#bb45ea"
                }
            ]
        ]
    ]
], {
    color: true
});
const $5fff284e497fef75$export$df6d515417450e62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftFilled', "1em", [
    "M9.5 11v7h-3A2.5 2.5 0 0 1 4 15.66V11zm6.5 0v4.5a2.5 2.5 0 0 1-2.34 2.5H10.5v-7zm-4-9a2.5 2.5 0 0 1 2 4h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.5V6h-1v4H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2q-.48-.65-.5-1.5A2.5 2.5 0 0 1 10 3c.46-.6 1.18-1 2-1m0 1c-.83 0-1.5.67-1.5 1.5V6H12a1.5 1.5 0 0 0 0-3M8 3a1.5 1.5 0 0 0-.14 3H9.5V4.36A1.5 1.5 0 0 0 8 3"
]);
const $5fff284e497fef75$export$9795d4ba61579c01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftRegular', "1em", [
    "M12 2a2.5 2.5 0 0 1 2 4h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5V11a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2q-.48-.65-.5-1.5A2.5 2.5 0 0 1 10 3c.46-.6 1.18-1 2-1m-2.5 9H5v4.5c0 .83.67 1.5 1.5 1.5h3zm5.5 0h-4.5v6h3c.83 0 1.5-.67 1.5-1.5zM9.5 7H4v3h5.5zM16 7h-5.5v3H16zm-4-4c-.83 0-1.5.67-1.5 1.5V6H12a1.5 1.5 0 0 0 0-3M8 3a1.5 1.5 0 0 0-.14 3H9.5V4.36A1.5 1.5 0 0 0 8 3"
]);
const $5fff284e497fef75$export$77998d1e9fb482dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_card_20_color__a)",
            "d": "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_card_20_color__b)",
            "d": "M7 9V4h1.5v5H18v1.5H8.5V16H7v-5.5H2V9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_gift_card_20_color__c)",
            "fillRule": "evenodd",
            "d": "M9.54 10.48a2.24 2.24 0 0 0 1.3-3.82 2.25 2.25 0 0 0-3.09-.09 2.25 2.25 0 1 0-1.8 3.91l-1.23 1.24a.75.75 0 1 0 1.06 1.06l1.97-1.97 1.97 1.97a.75.75 0 1 0 1.06-1.06zm.24-2.76a.75.75 0 0 0-1.28.53V9h.75q.3 0 .53-.22c.3-.3.3-.77 0-1.06M7 8.25q0-.3-.22-.53A.75.75 0 1 0 6.25 9H7z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_gift_card_20_color__a",
                "x1": "2",
                "x2": "11.93",
                "y1": ".25",
                "y2": "20.29",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#bb45ea"
                }
            ],
            [
                "stop",
                {
                    "offset": ".47",
                    "stopColor": "#8b57ed"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#5b2ab5"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_gift_card_20_color__c",
                "x1": "8",
                "x2": "7.5",
                "y1": "-14.5",
                "y2": "20.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff6f47"
                }
            ],
            [
                "stop",
                {
                    "offset": ".8",
                    "stopColor": "#ffcd0f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_gift_card_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(20.5 0 0 13.6667 8 10)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#fb5937"
                }
            ],
            [
                "stop",
                {
                    "offset": ".38",
                    "stopColor": "#ffcd0f"
                }
            ]
        ]
    ]
], {
    color: true
});
const $5fff284e497fef75$export$9b98a6ce32a67b4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardFilled', "1em", [
    "M7 4H4.75A2.75 2.75 0 0 0 2 6.75V9h2.27A2 2 0 0 1 7 6.27zm1 4v1h1a1 1 0 1 0-1-1m2.73 1A2 2 0 0 0 8 6.27V4h7.25A2.75 2.75 0 0 1 18 6.75V9zm-2.02 1 1.64 1.65a.5.5 0 0 1-.7.7L8 10.71V16h7.25A2.75 2.75 0 0 0 18 13.25V10zM7 16v-5.3l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 10H2v3.25A2.75 2.75 0 0 0 4.75 16zm0-8a1 1 0 1 0-1 1h1z"
]);
const $5fff284e497fef75$export$d1dfa8bc1e48ad31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardRegular', "1em", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM3 10v3.25c0 .97.78 1.75 1.75 1.75H7v-4.3l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 10zm1.27-1A2 2 0 0 1 7 6.27V5H4.75C3.78 5 3 5.78 3 6.75V9zM6 9h1V8a1 1 0 1 0-1 1m2-1v1h1a1 1 0 1 0-1-1m2.73 1H17V6.75C17 5.78 16.22 5 15.25 5H8v1.27A2 2 0 0 1 10.73 9m-2.02 1 1.64 1.65a.5.5 0 0 1-.7.7L8 10.71V15h7.25c.97 0 1.75-.78 1.75-1.75V10z"
]);
const $5fff284e497fef75$export$6f80141b22b66c0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardAddFilled', "1em", [
    "M7 2H4.75A2.75 2.75 0 0 0 2 4.75V7h2.27A2 2 0 0 1 7 4.27zM2 8v3.25A2.75 2.75 0 0 0 4.75 14H7V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 8zm7.02 6H8V8.7l1.65 1.65a.5.5 0 0 0 .7-.7L8.71 8H18v2.26A5.5 5.5 0 0 0 9.02 14M18 7h-7.27A2 2 0 0 0 8 4.27V2h7.25A2.75 2.75 0 0 1 18 4.75zM8 6v1h1a1 1 0 1 0-1-1M7 7H6a1 1 0 1 1 1-1zm12 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $5fff284e497fef75$export$e81b333a1e0c3527 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardAddRegular', "1em", [
    "M2 4.75A2.75 2.75 0 0 1 4.75 2h10.5A2.75 2.75 0 0 1 18 4.75v5.5a6 6 0 0 0-1-.65V8H8.7l1.65 1.65a.5.5 0 0 1-.7.7L8 8.71V13h1.2q-.13.49-.18 1H4.75A2.75 2.75 0 0 1 2 11.25zM4.75 3C3.78 3 3 3.78 3 4.75V7h1.27A2 2 0 0 1 7 4.27V3zM8 3v1.27A2 2 0 0 1 10.73 7H17V4.75C17 3.78 16.22 3 15.25 3zm0 4h1a1 1 0 1 0-1-1zM6 5a1 1 0 0 0 0 2h1V6a1 1 0 0 0-1-1m-3 6.25c0 .97.78 1.75 1.75 1.75H7V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 8H3zm16 3.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $5fff284e497fef75$export$6b407e2bdfa5d64b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardArrowRightFilled', "1em", [
    "M7 2H4.75A2.75 2.75 0 0 0 2 4.75V7h2.27A2 2 0 0 1 7 4.27zM2 8v3.25A2.75 2.75 0 0 0 4.75 14H7V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 8zm6 6h1.02A5.5 5.5 0 0 1 18 10.26V8H8.7l1.65 1.65a.5.5 0 0 1-.7.7L8 8.71zm10-7h-7.27A2 2 0 0 0 8 4.27V2h7.25A2.75 2.75 0 0 1 18 4.75zM8 7V6a1 1 0 1 1 1 1zM7 7H6a1 1 0 1 1 1-1zm12 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $5fff284e497fef75$export$685d2af94898aaaf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardArrowRightRegular', "1em", [
    "M2 4.75A2.75 2.75 0 0 1 4.75 2h10.5A2.75 2.75 0 0 1 18 4.75v5.5a6 6 0 0 0-1-.65V8H8.7l1.65 1.65a.5.5 0 0 1-.7.7L8 8.71V13h1.2q-.13.49-.18 1H4.75A2.75 2.75 0 0 1 2 11.25zM4.75 3C3.78 3 3 3.78 3 4.75V7h1.27A2 2 0 0 1 7 4.27V3zM8 3v1.27A2 2 0 0 1 10.73 7H17V4.75C17 3.78 16.22 3 15.25 3zm0 4h1a1 1 0 1 0-1-1zM6 5a1 1 0 0 0 0 2h1V6a1 1 0 0 0-1-1M3 8v3.25c0 .97.78 1.75 1.75 1.75H7V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 8zm16 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7z"
]);
const $5fff284e497fef75$export$b4bfa7acabc87448 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardMoneyFilled', "1em", [
    "M7 2H4.75A2.75 2.75 0 0 0 2 4.75V7h2.27A2 2 0 0 1 7 4.27zm1 4v1h1a1 1 0 1 0-1-1m2.73 1A2 2 0 0 0 8 4.27V2h7.25A2.75 2.75 0 0 1 18 4.75V7zM8.71 8l1.64 1.65a.5.5 0 0 1-.7.7L8 8.71V14h1v-.5a2.5 2.5 0 0 1 2.5-2.5h6q.26 0 .5.05V8zM7 14V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 8H2v3.25A2.75 2.75 0 0 0 4.75 14zm0-8a1 1 0 1 0-1 1h1zm12 7.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5m-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5m-.5-3.5h-1c0 .83.67 1.5 1.5 1.5v-1a.5.5 0 0 1-.5-.5m-6 0a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm3.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $5fff284e497fef75$export$e0ac1a33b78815ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardMoneyRegular', "1em", [
    "M2 4.75A2.75 2.75 0 0 1 4.75 2h10.5A2.75 2.75 0 0 1 18 4.75V11h-1V8H8.7l1.65 1.65a.5.5 0 0 1-.7.7L8 8.71V13h1.12a2 2 0 0 0-.12.69V14H4.75A2.75 2.75 0 0 1 2 11.25zM3 8v3.25c0 .97.78 1.75 1.75 1.75H7V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7L6.29 8zm1.27-1A2 2 0 0 1 7 4.27V3H4.75C3.78 3 3 3.78 3 4.75V7zM6 7h1V6a1 1 0 1 0-1 1m2-1v1h1a1 1 0 1 0-1-1m2.73 1H17V4.75C17 3.78 16.22 3 15.25 3H8v1.27A2 2 0 0 1 10.73 7M19 13.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5m-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5m-.5-3.5h-1c0 .83.67 1.5 1.5 1.5v-1a.5.5 0 0 1-.5-.5m-6 0a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm3.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $5fff284e497fef75$export$2e163f4a4f5ae531 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardMultipleFilled', "1em", [
    "M4.75 4H7v2.27A2 2 0 0 0 4.27 9H2V6.75A2.75 2.75 0 0 1 4.75 4M2 12.25V10h4.3l-1.65 1.65a.5.5 0 0 0 .7.7L7 10.71V15H4.75A2.75 2.75 0 0 1 2 12.25M8 15h5.25A2.75 2.75 0 0 0 16 12.25V10H8.7l1.65 1.65a.5.5 0 0 1-.7.7L8 10.71zm2.73-6H16V6.75A2.75 2.75 0 0 0 13.25 4H8v2.27A2 2 0 0 1 10.73 9M8 9V8a1 1 0 1 1 1 1zM6 9h1V8a1 1 0 1 0-1 1m.75 8c-.85 0-1.62-.39-2.12-1h8.62A3.75 3.75 0 0 0 17 12.25V6.63c.61.5 1 1.27 1 2.12v3.5A4.75 4.75 0 0 1 13.25 17z"
]);
const $5fff284e497fef75$export$db83d9923fda206f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftCardMultipleRegular', "1em", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v5.5A2.75 2.75 0 0 0 4.75 15h8.5A2.75 2.75 0 0 0 16 12.25v-5.5A2.75 2.75 0 0 0 13.25 4zM3 12.25V10h3.3l-1.65 1.65a.5.5 0 0 0 .7.7L7 10.71V14H4.75C3.78 14 3 13.22 3 12.25M3 9V6.75C3 5.78 3.78 5 4.75 5H7v1.27A2 2 0 0 0 4.27 9zm4 0H6a1 1 0 1 1 1-1zm1 0V8a1 1 0 1 1 1 1zm3-1a2 2 0 0 0-3-1.73V5h5.25c.97 0 1.75.78 1.75 1.75V9h-4.27A2 2 0 0 0 11 8m-.65 3.65L8.71 10H15v2.25c0 .97-.78 1.75-1.75 1.75H8v-3.3l1.65 1.65a.5.5 0 0 0 .7-.7M6.75 17c-.85 0-1.62-.39-2.12-1h8.62A3.75 3.75 0 0 0 17 12.25V6.63c.61.5 1 1.27 1 2.12v3.5A4.75 4.75 0 0 1 13.25 17z"
]);
const $5fff284e497fef75$export$5596c0d3be1f1293 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftOpenFilled', "1em", [
    "M14.25 3.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.5 5a3 3 0 0 0-3 3A2.5 2.5 0 0 0 9 10.5a2 2 0 0 0 2-2c0-.83-.67-1.5-1.5-1.5a1 1 0 0 0-1 1 .5.5 0 0 0 1 0c.28 0 .5.22.5.5a1 1 0 0 1-1 1A1.5 1.5 0 0 1 7.5 8c0-1.1.9-2 2-2A2.5 2.5 0 0 1 12 8.5a3 3 0 0 1-3 3 .5.5 0 0 0 0 1 4 4 0 0 0 4-4A3.5 3.5 0 0 0 9.5 5m-4.45 5h1.08q.6.86 1.57 1.25-.2.34-.2.75c0 .83.67 1.5 1.5 1.5a5 5 0 0 0 4.77-3.5h1.18q.7 0 1.28.36l2.03 1.21a.5.5 0 1 1-.52.86L16 11.38v4.12a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5v-4.12l-1.74 1.05a.5.5 0 1 1-.52-.86l2.03-1.21A2.5 2.5 0 0 1 5.05 10M17 5.5a.5.5 0 0 0-1 0V6h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0V7h.5a.5.5 0 0 0 0-1H17z"
]);
const $5fff284e497fef75$export$480a7832af33c1fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GiftOpenRegular', "1em", [
    "M13.5 4.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M5 10.5a.5.5 0 0 0-.76-.43l-2.5 1.5a.5.5 0 1 0 .52.86L4 11.38v4.12A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-4.12l1.74 1.05a.5.5 0 0 0 .52-.86l-2.5-1.5a.5.5 0 0 0-.76.43v5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5zM16.5 5c.28 0 .5.22.5.5V6h.5a.5.5 0 0 1 0 1H17v.5a.5.5 0 0 1-1 0V7h-.5a.5.5 0 1 1 0-1h.5v-.5c0-.28.22-.5.5-.5m-7 0a3 3 0 0 0-3 3A2.5 2.5 0 0 0 9 10.5a2 2 0 0 0 2-2c0-.83-.67-1.5-1.5-1.5a1 1 0 0 0-1 1 .5.5 0 0 0 1 0c.28 0 .5.22.5.5a1 1 0 0 1-1 1A1.5 1.5 0 0 1 7.5 8c0-1.1.9-2 2-2A2.5 2.5 0 0 1 12 8.5a3 3 0 0 1-3 3 .5.5 0 0 0 0 1 4 4 0 0 0 4-4A3.5 3.5 0 0 0 9.5 5"
]);
const $5fff284e497fef75$export$ff08b3e809205d0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_home_20_color__a)",
            "d": "M7 11h6v6H7z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_home_20_color__b)",
            "d": "M11 3.38a1.5 1.5 0 0 0-2 0L3.5 8.33c-.32.28-.5.69-.5 1.11v6.06c0 .82.67 1.5 1.5 1.5H8v-5.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V17h3.5c.83 0 1.5-.68 1.5-1.5V9.44c0-.42-.18-.83-.5-1.11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_home_20_color__c)",
            "fillRule": "evenodd",
            "d": "M10.64 2.24a1 1 0 0 0-1.28 0l-7.03 6.1a.93.93 0 0 0-.09 1.34c.36.4.97.43 1.37.08L10 4.22l6.39 5.54a1 1 0 0 0 1.37-.08c.35-.4.31-.99-.09-1.34z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_home_20_color__d)",
            "fillRule": "evenodd",
            "d": "M9.36 2.24a1 1 0 0 1 1.28 0l7.03 6.1c.4.35.44.95.09 1.34a1 1 0 0 1-1.37.08L10 4.22 3.61 9.76a1 1 0 0 1-1.37-.08.93.93 0 0 1 .09-1.34z",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_home_20_color__a",
                "x1": "10",
                "x2": "6.63",
                "y1": "11",
                "y2": "18.49",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#944600"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#cd8e02"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_home_20_color__b",
                "x1": "4.34",
                "x2": "18.07",
                "y1": "2.32",
                "y2": "13.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffd394"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ffb357"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_home_20_color__c",
                "x1": "7.41",
                "x2": "10.93",
                "y1": ".1",
                "y2": "9.6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_home_20_color__d",
                "x1": "7.41",
                "x2": "10.93",
                "y1": ".1",
                "y2": "9.6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $5fff284e497fef75$export$c3378819f5c9f403 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeFilled', "1em", [
    "M11 2.39a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V8.45c0-.43-.18-.84-.5-1.12z"
]);
const $5fff284e497fef75$export$406fe1ce09f245fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeRegular', "1em", [
    "M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94c.32.28.5.69.5 1.12v7.05c0 .83-.67 1.5-1.5 1.5H13a1.5 1.5 0 0 1-1.5-1.5V12a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v3.5c0 .83-.67 1.5-1.5 1.5H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.84.5-1.12zm1.33.74a.5.5 0 0 0-.66 0l-5.5 4.94a.5.5 0 0 0-.17.38v7.05c0 .28.22.5.5.5H7a.5.5 0 0 0 .5-.5V12c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v3.5c0 .28.22.5.5.5h2.5a.5.5 0 0 0 .5-.5V8.45a.5.5 0 0 0-.17-.38z"
]);
const $5fff284e497fef75$export$c91733b6e4c0fdfa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeAddFilled', "1em", [
    "M11 2.39a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h5.1q-.58-1.14-.6-2.5a5.5 5.5 0 0 1 8-4.9V8.45c0-.43-.18-.84-.5-1.12zm8 12.11a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $5fff284e497fef75$export$913cc7b2f1aece29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeAddRegular', "1em", [
    "M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94c.32.28.5.69.5 1.12V9.6q-.48-.24-1-.4v-.75a.5.5 0 0 0-.17-.38l-5.5-4.94a.5.5 0 0 0-.66 0l-5.5 4.94a.5.5 0 0 0-.17.38v7.05c0 .28.22.5.5.5h4.7q.15.52.4 1H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.84.5-1.12zM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $5fff284e497fef75$export$54239dfec086db42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeCheckmarkFilled', "1em", [
    "M9 2.38a1.5 1.5 0 0 1 2 0l5.5 4.95c.32.28.5.69.5 1.11v7.06c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 15.5V8.44c0-.42.18-.83.5-1.11zm4.35 6.47a.5.5 0 0 0-.7-.7L9 11.78l-1.65-1.65a.5.5 0 1 0-.7.71l2 2c.2.2.5.2.7 0z"
]);
const $5fff284e497fef75$export$8c4c1840018b5fb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeCheckmarkRegular', "1em", [
    "M13.35 8.85a.5.5 0 0 0-.7-.7L9 11.78l-1.65-1.65a.5.5 0 1 0-.7.71l2 2c.2.2.5.2.7 0zM11 2.38a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.28-.5.69-.5 1.11v7.06c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.44c0-.42-.18-.83-.5-1.11zm-1.33.75a.5.5 0 0 1 .66 0l5.5 4.94q.17.15.17.37v7.06a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V8.44a.5.5 0 0 1 .17-.37z"
]);
const $5fff284e497fef75$export$f38799b94c338ac2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeDatabaseFilled', "1em", [
    "M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94q.46.42.5 1.03A8 8 0 0 0 14.5 8c-1.38 0-2.68.3-3.67.86-.9.5-1.74 1.33-1.82 2.46L9 11.3v5.19q0 .26.05.5H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.84.5-1.12zm8 7.03A7.86 7.86 0 0 0 14.5 9c-2.49 0-4.5 1.12-4.5 2.5s2.01 2.5 4.5 2.5 4.5-1.12 4.5-2.5c0-.87-.8-1.63-2-2.08m1.17 4.72c-1 .55-2.29.86-3.67.86s-2.68-.3-3.67-.86q-.45-.24-.83-.59v2.95c0 1.38 2.01 2.5 4.5 2.5s4.5-1.12 4.5-2.5v-2.95q-.38.35-.83.6"
]);
const $5fff284e497fef75$export$2899b451c0a877c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeDatabaseRegular', "1em", [
    "M11 2.39a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h4.55a2 2 0 0 1-.05-.5V16H4.5a.5.5 0 0 1-.5-.5V8.45a.5.5 0 0 1 .17-.38l5.5-4.94a.5.5 0 0 1 .66 0l5.5 4.94.03.03a8 8 0 0 1 1.14.26 1.5 1.5 0 0 0-.5-1.03zm6 7.03A7.86 7.86 0 0 0 14.5 9c-2.49 0-4.5 1.12-4.5 2.5s2.01 2.5 4.5 2.5 4.5-1.12 4.5-2.5c0-.87-.8-1.63-2-2.08m1.17 4.72c-1 .55-2.29.86-3.67.86s-2.68-.3-3.67-.86q-.45-.24-.83-.59v2.95c0 1.38 2.01 2.5 4.5 2.5s4.5-1.12 4.5-2.5v-2.95q-.38.35-.83.6"
]);
const $5fff284e497fef75$export$1ee45423c44fa96f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeEmptyFilled', "1em", [
    "M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.95c.32.28.5.68.5 1.11v7.05c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.83.5-1.11z"
]);
const $5fff284e497fef75$export$bad50b14e3e7607c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeEmptyRegular', "1em", [
    "M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.95c.32.28.5.68.5 1.11v7.05c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.83.5-1.11zm1.33.74a.5.5 0 0 0-.66 0l-5.5 4.95a.5.5 0 0 0-.17.37v7.05c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V8.45a.5.5 0 0 0-.17-.37z"
]);
const $5fff284e497fef75$export$a8b578b9a5f029da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeGarageFilled', "1em", [
    "M11 2.39a1.5 1.5 0 0 0-2 0L3.5 7.35c-.32.28-.5.68-.5 1.1v7.05c0 .83.67 1.5 1.5 1.5H6v-4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5V17h1.5c.83 0 1.5-.67 1.5-1.5V8.46c0-.43-.18-.83-.5-1.11zM13 14v-1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V14zm-6 1h6v2H7z"
]);
const $5fff284e497fef75$export$36f7de844ae6fb49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeGarageRegular', "1em", [
    "m9.67 3.13-5.5 4.96a.5.5 0 0 0-.17.37v7.04c0 .28.22.5.5.5H6v-4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5V16h1.5a.5.5 0 0 0 .5-.5V8.46a.5.5 0 0 0-.17-.37l-5.5-4.96a.5.5 0 0 0-.66 0M4.5 17A1.5 1.5 0 0 1 3 15.5V8.46c0-.43.18-.83.5-1.11L9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.96c.32.28.5.68.5 1.1v7.05c0 .83-.67 1.5-1.5 1.5zm8.5-1v-2H7v2zm0-4.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V13h6z"
]);
const $5fff284e497fef75$export$487bf2323eb0a74e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeHeartFilled', "1em", [
    "M11 2.39a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h6.42l-.88-.89a3.6 3.6 0 0 1 0-5.06 3.55 3.55 0 0 1 4.46-.48 3.5 3.5 0 0 1 2.5-.53v-1.6c0-.42-.18-.83-.5-1.11zm7.25 9.37a2.55 2.55 0 0 0-3.63 0l-.12.12-.12-.12a2.55 2.55 0 0 0-3.84.24 2.6 2.6 0 0 0 .21 3.41l3.43 3.46c.18.17.46.17.64 0l3.43-3.46c1-1 1-2.64 0-3.65"
]);
const $5fff284e497fef75$export$8ff5a3e94e9fa061 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeHeartRegular', "1em", [
    "M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94c.32.28.5.69.5 1.12v1.6a4 4 0 0 0-1-.02V8.45a.5.5 0 0 0-.17-.38l-5.5-4.94a.5.5 0 0 0-.66 0l-5.5 4.94a.5.5 0 0 0-.17.38v7.05c0 .28.22.5.5.5h5.43l.11.11.88.89H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.84.5-1.12zm9.25 9.37a2.55 2.55 0 0 0-3.63 0l-.12.12-.12-.12a2.55 2.55 0 0 0-3.84.24 2.6 2.6 0 0 0 .21 3.41l3.43 3.46c.18.17.46.17.64 0l3.43-3.46c1-1 1-2.64 0-3.65"
]);
const $5fff284e497fef75$export$340bf7c04e79557 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeMoneyFilled', "1em", [
    "M16.5 12c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 9 16.5v-3c0-.83.67-1.5 1.5-1.5zM9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94c.32.29.5.7.5 1.12v2.6a3 3 0 0 0-.5-.05h-6A2.5 2.5 0 0 0 8 13.5v3q0 .26.05.5H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.42.18-.83.5-1.12zm1 14.11c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm7-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm-3.5-2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-3-.5a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm5 0c0 .83.67 1.5 1.5 1.5v-1a.5.5 0 0 1-.5-.5z"
]);
const $5fff284e497fef75$export$f90266a041422a8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeMoneyRegular', "1em", [
    "M16.5 12c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 9 16.5v-3c0-.83.67-1.5 1.5-1.5zM9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94c.32.29.5.7.5 1.12v2.6a3 3 0 0 0-.5-.05H16V8.45a.5.5 0 0 0-.16-.37l-5.5-4.95a.5.5 0 0 0-.67 0l-5.5 4.95a.5.5 0 0 0-.17.37v7.05c0 .28.22.5.5.5H8v.5q0 .26.05.5H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.42.18-.83.5-1.12zm1 14.11c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5zm7-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm-3.5-2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-3-.5a.5.5 0 0 1-.5.5v1c.83 0 1.5-.67 1.5-1.5zm5 0c0 .83.67 1.5 1.5 1.5v-1a.5.5 0 0 1-.5-.5z"
]);
const $5fff284e497fef75$export$c63b3cf336d59687 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeMoreFilled', "1em", [
    "M11 2.38a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.28-.5.69-.5 1.11v7.06c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.44c0-.42-.18-.83-.5-1.11zM7 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-5 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $5fff284e497fef75$export$343ca553a68fd74a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeMoreRegular', "1em", [
    "M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M9 2.38a1.5 1.5 0 0 1 2 0l5.5 4.95c.32.28.5.69.5 1.11v7.06c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 15.5V8.44c0-.42.18-.83.5-1.11zm1.33.75a.5.5 0 0 0-.66 0l-5.5 4.94a.5.5 0 0 0-.17.37v7.06c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V8.44a.5.5 0 0 0-.17-.37z"
]);
const $5fff284e497fef75$export$ff383de5704ca788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomePersonFilled', "1em", [
    "M16.5 14c.83 0 1.5.67 1.5 1.5 0 1.24-1 2.5-3.5 2.5S11 16.75 11 15.5c0-.83.67-1.5 1.5-1.5zM9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.95c.32.28.5.69.5 1.11v.9A3 3 0 1 0 12.27 13a2.5 2.5 0 0 0-2.27 2.5q0 .77.37 1.5H4.5A1.5 1.5 0 0 1 3 15.5V8.44c0-.42.18-.83.5-1.11zM14.5 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $5fff284e497fef75$export$5f7ecb27efa577ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomePersonRegular', "1em", [
    "M16.5 14c.83 0 1.5.67 1.5 1.5 0 1.24-1 2.5-3.5 2.5S11 16.75 11 15.5c0-.83.67-1.5 1.5-1.5zM9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.95c.32.28.5.69.5 1.11v.9q-.4-.6-1-.95a.5.5 0 0 0-.16-.32l-5.5-4.95a.5.5 0 0 0-.67 0l-5.5 4.95a.5.5 0 0 0-.17.37v7.05c0 .28.22.5.5.5h5.54q.08.53.33 1H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.42.18-.83.5-1.11zM14.5 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
]);
const $5fff284e497fef75$export$ba8e05bba88d68eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeSplitFilled', "1em", [
    "M11 2.38a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.29-.5.7-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.45q-.01-.66-.5-1.12zm-.5 11.12v1a.5.5 0 0 1-1 0v-1a.5.5 0 1 1 1 0M10 9c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m.5-3.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0"
]);
const $5fff284e497fef75$export$3e8e21a4c06b1fc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HomeSplitRegular', "1em", [
    "M11 2.38a1.5 1.5 0 0 0-2 0L3.5 7.33c-.32.29-.5.7-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.45q-.01-.66-.5-1.12zm-1.33.74a.5.5 0 0 1 .66 0l5.5 4.95q.17.15.17.38v7.05a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V8.45a.5.5 0 0 1 .17-.38zm.83 10.38a.5.5 0 1 0-1 0v1a.5.5 0 0 0 1 0zM10 9c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m.5-3.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
]);
const $5fff284e497fef75$export$c4726209d7fd0949 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('JavascriptFilled', "1em", [
    "M14 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm-3.5 5a.5.5 0 0 0-.5.5v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 0 0 1h1c.83 0 1.5-.67 1.5-1.5v-5a.5.5 0 0 0-.5-.5M13 8c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5H12a.5.5 0 0 0 0 1h1.5c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5H13a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5h1.5a.5.5 0 0 0 0-1z"
]);
const $5fff284e497fef75$export$1dd269367df0e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('JavascriptRegular', "1em", [
    "M11.5 9.5c0-.83.67-1.5 1.5-1.5h1.5a.5.5 0 0 1 0 1H13a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5H12a.5.5 0 0 1 0-1h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H13a1.5 1.5 0 0 1-1.5-1.5zm-.5-1a.5.5 0 0 0-1 0v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 0 0 1h1c.83 0 1.5-.67 1.5-1.5zM3 6v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3m3-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2"
]);
const $5fff284e497fef75$export$b3f4a41cdded72b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM6 5v1a2 2 0 0 1-2 2H3V7h1a1 1 0 0 0 1-1V5zm3 5.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5M3 11v-1h1a2 2 0 0 1 2 2v1H5v-1a1 1 0 0 0-1-1zm11 0a1 1 0 0 0-1 1v1h-1v-1c0-1.1.9-2 2-2h1v1zm0-4h1v1h-1a2 2 0 0 1-2-2V5h1v1a1 1 0 0 0 1 1m3 5.5a2.5 2.5 0 0 1-2.5 2.5H4.09c.2.58.76 1 1.41 1h9a3.5 3.5 0 0 0 3.5-3.5v-5c0-.65-.42-1.2-1-1.41z"
]);
const $5fff284e497fef75$export$1ab633c5a52d2960 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyRegular', "1em", [
    "M7 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 0 1-1 1H3zM3 8h1a2 2 0 0 0 2-2V5h6v1c0 1.1.9 2 2 2h1v2h-1a2 2 0 0 0-2 2v1H6v-1a2 2 0 0 0-2-2H3zm10-3h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 0 1-1-1zm2 6v1.5a.5.5 0 0 1-.5.5H13v-1a1 1 0 0 1 1-1zM5 13H3.5a.5.5 0 0 1-.5-.5V11h1a1 1 0 0 1 1 1zm12-.5a2.5 2.5 0 0 1-2.5 2.5H4.09c.2.58.76 1 1.41 1h9a3.5 3.5 0 0 0 3.5-3.5v-5c0-.65-.42-1.2-1-1.41z"
]);
const $5fff284e497fef75$export$5ac9e724b41ddffa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyCalculatorFilled', "1em", [
    "M2 4.5C2 3.67 2.67 3 3.5 3h11c.83 0 1.5.67 1.5 1.5V8h-3a2 2 0 0 0-2 2v3H3.5A1.5 1.5 0 0 1 2 11.5zM4 7a2 2 0 0 0 2-2V4H5v1a1 1 0 0 1-1 1H3v1zm3.25 1a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M3 9v1h1a1 1 0 0 1 1 1v1h1v-1a2 2 0 0 0-2-2zm12-2V6h-1a1 1 0 0 1-1-1V4h-1v1c0 1.1.9 2 2 2zm2 1V5.09c.58.2 1 .76 1 1.41V8zm-6 6v1H5.5a1.5 1.5 0 0 1-1.41-1zm2.5-5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm0 4h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m-3 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m-3 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M13 10.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
]);
const $5fff284e497fef75$export$215756835afc3e1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyCalculatorRegular', "1em", [
    "M9 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 4.5C2 3.67 2.67 3 3.5 3h11c.83 0 1.5.67 1.5 1.5V8h-1V7h-1a2 2 0 0 1-2-2V4H6v1a2 2 0 0 1-2 2H3v2h1a2 2 0 0 1 2 2v1h5v1H3.5A1.5 1.5 0 0 1 2 11.5zM3.5 4a.5.5 0 0 0-.5.5V6h1a1 1 0 0 0 1-1V4zm11 0H13v1a1 1 0 0 0 1 1h1V4.5a.5.5 0 0 0-.5-.5m-11 8H5v-1a1 1 0 0 0-1-1H3v1.5c0 .28.22.5.5.5M17 8V5.09c.58.2 1 .76 1 1.41V8zm-6 6v1H5.5a1.5 1.5 0 0 1-1.41-1zm2.5-5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm0 4h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m-3 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m-3 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M13 10.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
]);
const $5fff284e497fef75$export$4669354414bd7cd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyDismissFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52A5.5 5.5 0 0 1 16 9.2V5.5c0-.83-.67-1.5-1.5-1.5zM6 6a2 2 0 0 1-2 2H3V7h1a1 1 0 0 0 1-1V5h1zm3 4.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5M3 11v-1h1a2 2 0 0 1 2 2v1H5v-1a1 1 0 0 0-1-1zm10-5a1 1 0 0 0 1 1h1v1h-1a2 2 0 0 1-2-2V5h1zm-8.91 9h4.93q.05.51.19 1H5.5a1.5 1.5 0 0 1-1.41-1M18 7.5v2.76a6 6 0 0 0-1-.66V6.09c.58.2 1 .76 1 1.41m1 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $5fff284e497fef75$export$93680a72943098c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyDismissRegular', "1em", [
    "M7 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52q.05-.51.19-1H6v-1a2 2 0 0 0-2-2H3V8h1a2 2 0 0 0 2-2V5h6v1c0 1.1.9 2 2 2h1v1.02q.51.05 1 .19V5.5c0-.83-.67-1.5-1.5-1.5zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 0 1-1 1H3zM13 5h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 0 1-1-1zm-8 8H3.5a.5.5 0 0 1-.5-.5V11h1a1 1 0 0 1 1 1zm-.91 2h4.93q.05.51.19 1H5.5a1.5 1.5 0 0 1-1.41-1M18 7.5v2.76a6 6 0 0 0-1-.66V6.09c.58.2 1 .76 1 1.41m1 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7z"
]);
const $5fff284e497fef75$export$71414778d9b47e5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyHandFilled', "1em", [
    "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v1.8l3.27 3.26c.47.47.73 1.1.73 1.77v7.17a.5.5 0 0 1-1 0v-7.17q-.01-.62-.44-1.06L13 6.7v3.08l.85.86a.5.5 0 0 1-.7.7l-3-3c-.43-.42-.66-.4-.76-.38-.18.05-.33.19-.54.4q-.15.12-.13.32c.03.18.17.49.63.96.98.97 1.1 1.1 1.22 1.2l.28.3q.15.15.15.35c0 .77 0 1.55.22 2.14q.15.42.42.62.26.22.86.24c.28 0 .5.22.5.5v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 16.5zm5 4a2.5 2.5 0 1 0 1.9 4.12l-.04-.05-1.21-1.22a3 3 0 0 1-.91-1.51c-.08-.52.13-.93.41-1.2l.04-.04.1-.08zm2 9v.5h1v-.5c0-.28.22-.5.5-.5h.5v-.54q-.55-.1-.95-.4c-.6.2-1.05.77-1.05 1.44M4 5h.5C5.33 5 6 4.33 6 3.5V3H5v.5a.5.5 0 0 1-.5.5H4zm6-1.5c0 .83.67 1.5 1.5 1.5h.5V4h-.5a.5.5 0 0 1-.5-.5V3h-1zm-4 13c0-.83-.67-1.5-1.5-1.5H4v1h.5c.28 0 .5.22.5.5v.5h1z"
]);
const $5fff284e497fef75$export$4cdc3b83dceca99e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyHandRegular', "1em", [
    "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V15a.5.5 0 0 0-.5-.5q-.6-.01-.86-.24a1.3 1.3 0 0 1-.42-.62A7 7 0 0 1 11 11.5a.5.5 0 0 0-.15-.35l-.28-.3-1.22-1.2c-.46-.47-.6-.78-.63-.96q-.03-.2.13-.33c.21-.2.36-.34.54-.39.1-.02.33-.04.76.38l3 3a.5.5 0 0 0 .7-.7L13 9.79V6.71l2.56 2.56q.43.44.44 1.06v7.17a.5.5 0 0 0 1 0v-7.17c0-.66-.26-1.3-.73-1.77L13 5.3V3.5c0-.83-.67-1.5-1.5-1.5zM12 5.5v3.3l-1.15-1.15q-.87-.86-1.7-.65-.17.05-.31.12A3 3 0 1 0 10 12.23c.01.58.07 1.21.27 1.75.15.41.38.8.76 1.08h.01c-.6.2-1.05.77-1.05 1.44v.5H6v-.5c0-.83-.67-1.5-1.5-1.5H4V5h.5C5.33 5 6 4.33 6 3.5V3h4v.5c0 .83.67 1.5 1.5 1.5h.5zm0 11a.5.5 0 0 1-.5.5H11v-.5c0-.28.22-.5.5-.5h.5zM6 10a2 2 0 0 1 1.87-2q-.2.35-.13.84.1.72.9 1.51l.91.91A2 2 0 0 1 6 10M5 3v.5a.5.5 0 0 1-.5.5H4v-.5c0-.28.22-.5.5-.5zM4 16h.5c.28 0 .5.22.5.5v.5h-.5a.5.5 0 0 1-.5-.5zm8-12h-.5a.5.5 0 0 1-.5-.5V3h.5c.28 0 .5.22.5.5z"
]);
const $5fff284e497fef75$export$cb722d474e41ad43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v7c0 .83.67 1.5 1.5 1.5h9.8l1 1H4.08c.2.58.76 1 1.41 1h9q.38 0 .72-.07l1.93 1.92a.5.5 0 0 0 .7-.7zm6.98 8.39q-.38.2-.83.21a1.75 1.75 0 0 1-1.54-2.58zM5.9 6.61A2 2 0 0 1 4 8H3V7h1a1 1 0 0 0 1-1v-.3zM3 11v-1h1a2 2 0 0 1 2 2v1H5v-1a1 1 0 0 0-1-1zm6.42-3.7 1.28 1.28 1.95 1.95A2 2 0 0 1 14 10h1v1h-1a1 1 0 0 0-.65.24l2.27 2.26q.37-.42.38-1v-7c0-.83-.67-1.5-1.5-1.5H6.12zM15 7v1h-1a2 2 0 0 1-2-2V5h1v1a1 1 0 0 0 1 1zm1.33 7.2.7.72c.6-.63.97-1.48.97-2.42v-5c0-.65-.42-1.2-1-1.41v6.41a2.5 2.5 0 0 1-.67 1.7"
]);
const $5fff284e497fef75$export$3360cc26dd2b2dc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneyOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v7c0 .83.67 1.5 1.5 1.5h9.8l1 1H4.08c.2.58.76 1 1.41 1h9q.38 0 .72-.07l1.93 1.92a.5.5 0 0 0 .7-.7zM12 12.7V13H6v-1a2 2 0 0 0-2-2H3V8h1a2 2 0 0 0 1.9-1.39l1.38 1.37a2 2 0 0 0 2.74 2.74zM4.3 5l.7.7V6a1 1 0 0 1-1 1H3V5.5c0-.28.22-.5.5-.5zm3.73 3.74 1.23 1.23a1 1 0 0 1-1.23-1.23M3.5 13a.5.5 0 0 1-.5-.5V11h1a1 1 0 0 1 1 1v1zM14 10a2 2 0 0 0-1.35.53l.7.7A1 1 0 0 1 14 11h1v1.5q0 .15-.1.29l.72.71q.37-.42.38-1v-7c0-.83-.67-1.5-1.5-1.5H6.12l1 1H12v1c0 1.1.9 2 2 2h1v2zm.5-5c.28 0 .5.22.5.5V7h-1a1 1 0 0 1-1-1V5zm1.83 9.2.7.72c.6-.63.97-1.48.97-2.42v-5c0-.65-.42-1.2-1-1.41v6.41a2.5 2.5 0 0 1-.67 1.7"
]);
const $5fff284e497fef75$export$fa0e89caa38ee2fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneySettingsFilled', "1em", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52A5.5 5.5 0 0 1 16 9.2V5.5c0-.83-.67-1.5-1.5-1.5zM6 6a2 2 0 0 1-2 2H3V7h1a1 1 0 0 0 1-1V5h1zm3 4.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5M3 11v-1h1a2 2 0 0 1 2 2v1H5v-1a1 1 0 0 0-1-1zm10-5a1 1 0 0 0 1 1h1v1h-1a2 2 0 0 1-2-2V5h1zm-8.91 9h4.93q.05.51.19 1H5.5a1.5 1.5 0 0 1-1.41-1M18 7.5v2.76a6 6 0 0 0-1-.66V6.09c.58.2 1 .76 1 1.41m-5.94 3.94a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.02l.35.08A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $5fff284e497fef75$export$2e19368034f57d3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoneySettingsRegular', "1em", [
    "M7 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52q.05-.51.19-1H6v-1a2 2 0 0 0-2-2H3V8h1a2 2 0 0 0 2-2V5h6v1c0 1.1.9 2 2 2h1v1.02q.51.05 1 .19V5.5c0-.83-.67-1.5-1.5-1.5zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 0 1-1 1H3zM13 5h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 0 1-1-1zm-8 8H3.5a.5.5 0 0 1-.5-.5V11h1a1 1 0 0 1 1 1zm-.91 2h4.93q.05.51.19 1H5.5a1.5 1.5 0 0 1-1.41-1M18 7.5v2.76a6 6 0 0 0-1-.66V6.09c.58.2 1 .76 1 1.41m-5.94 3.94a2 2 0 0 1-1.43 2.48l-.46.12a5 5 0 0 0 .01 1.02l.35.08A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.16-.55a2 2 0 0 1 1.44-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $5fff284e497fef75$export$e6a611e33682080c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OmegaFilled', "1em", [
    "M10 2a8 8 0 0 1 8 8c0 1.97-.96 3.59-1.97 4.75-.66.75-1.37 1.34-1.93 1.75h3.15a.75.75 0 0 1 0 1.5h-4.03c-.63 0-1.15-.48-1.22-1.1v-.28q.1-.59.59-.9l.41-.28c.5-.35 1.24-.92 1.9-1.68A5.8 5.8 0 0 0 16.5 10a6.5 6.5 0 0 0-13 0c0 1.47.71 2.75 1.6 3.76.88 1 1.88 1.7 2.31 1.96.36.23.6.62.6 1.06C8 17.45 7.44 18 6.77 18H2.75a.75.75 0 0 1 0-1.5H5.9c-.56-.4-1.27-1-1.93-1.75A7.3 7.3 0 0 1 2 10a8 8 0 0 1 8-8"
]);
const $5fff284e497fef75$export$2ed2bba4dc0a9107 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OmegaRegular', "1em", [
    "M10 2a8 8 0 0 1 8 8c0 2.04-1.1 3.75-2.24 4.99-.84.91-1.75 1.6-2.34 2.01h4.08a.5.5 0 0 1 0 1h-4.68a.8.8 0 0 1-.82-.73v-.19a.8.8 0 0 1 .4-.6l.42-.28c.55-.38 1.4-1.03 2.2-1.9C16.1 13.16 17 11.68 17 10a7 7 0 1 0-14 0c0 1.67.9 3.15 1.97 4.3a13 13 0 0 0 2.64 2.18.82.82 0 0 1-.43 1.52H2.5a.5.5 0 0 1 0-1h4.08c-.6-.41-1.5-1.1-2.34-2.01C3.1 13.75 2 12.03 2 10a8 8 0 0 1 8-8"
]);
const $5fff284e497fef75$export$a23ffe7556174991 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OvalFilled', "1em", [
    "M2 10a6 6 0 0 1 6-6h4a6 6 0 0 1 0 12H8a6 6 0 0 1-6-6"
]);
const $5fff284e497fef75$export$31b05cb2c22d8ac1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OvalRegular', "1em", [
    "M2 10a6 6 0 0 1 6-6h4a6 6 0 0 1 0 12H8a6 6 0 0 1-6-6m6-5a5 5 0 0 0 0 10h4a5 5 0 0 0 0-10z"
]);
const $5fff284e497fef75$export$98a485baccceb031 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PasswordFilled', "1em", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v5.5A2.75 2.75 0 0 1 15.25 15H4.75A2.75 2.75 0 0 1 2 12.25zm5.15 1.4-.65.64-.65-.64a.5.5 0 1 0-.7.7l.64.65-.64.65a.5.5 0 0 0 .7.7l.65-.64.65.64a.5.5 0 0 0 .7-.7l-.64-.65.64-.65a.5.5 0 1 0-.7-.7m4 0-.65.64-.65-.64a.5.5 0 1 0-.7.7l.64.65-.64.65a.5.5 0 0 0 .7.7l.65-.64.65.64a.5.5 0 0 0 .7-.7l-.64-.65.64-.65a.5.5 0 0 0-.7-.7M13 10.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5"
]);
const $5fff284e497fef75$export$6dd37fadd7d25286 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PasswordRegular', "1em", [
    "M7.85 8.15a.5.5 0 0 0-.7 0l-.65.64-.65-.64a.5.5 0 1 0-.7.7l.64.65-.64.65a.5.5 0 0 0 .7.7l.65-.64.65.64a.5.5 0 0 0 .7-.7l-.64-.65.64-.65a.5.5 0 0 0 0-.7m3.3 0a.5.5 0 0 1 .7.7l-.64.65.64.65a.5.5 0 0 1-.7.7l-.65-.64-.65.64a.5.5 0 0 1-.7-.7l.64-.65-.64-.65a.5.5 0 1 1 .7-.7l.65.64zM13.5 10a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM4.75 4A2.75 2.75 0 0 0 2 6.75v5.5A2.75 2.75 0 0 0 4.75 15h10.5A2.75 2.75 0 0 0 18 12.25v-5.5A2.75 2.75 0 0 0 15.25 4zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 14 3 13.22 3 12.25z"
]);
const $5fff284e497fef75$export$202ef4236083c873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PasswordClockFilled', "1em", [
    "M15.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H17a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5m-.25-8A2.75 2.75 0 0 1 18 6.75V9.6a5.5 5.5 0 0 0-6.04.7l-.1-.15-.65-.65.64-.65a.5.5 0 1 0-.7-.7l-.65.64-.65-.64a.5.5 0 1 0-.7.7l.64.65-.64.65a.5.5 0 1 0 .7.7l.65-.64.65.64q.07.07.14.1A5.5 5.5 0 0 0 10.02 15H4.75A2.75 2.75 0 0 1 2 12.25v-5.5A2.75 2.75 0 0 1 4.75 4zm-7.4 4.15a.5.5 0 0 0-.7 0l-.65.64-.65-.64a.5.5 0 1 0-.7.7l.64.65-.64.65a.5.5 0 1 0 .7.7l.65-.64.65.64a.5.5 0 1 0 .7-.7l-.64-.65.64-.65a.5.5 0 0 0 0-.7"
]);
const $5fff284e497fef75$export$bcbcc281ab73d753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PasswordClockRegular', "1em", [
    "M15.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 2a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H17a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5m-.25-8A2.75 2.75 0 0 1 18 6.75V9.6q-.48-.25-1-.4V6.76C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v5.5c0 .97.78 1.75 1.75 1.75h5.27a6 6 0 0 0 0 1H4.75A2.75 2.75 0 0 1 2 12.25v-5.5A2.75 2.75 0 0 1 4.75 4zm-8.1 4.15a.5.5 0 1 1 .7.7l-.64.65.64.65a.5.5 0 1 1-.7.7l-.65-.64-.65.64a.5.5 0 1 1-.7-.7l.64-.65-.64-.65a.5.5 0 1 1 .7-.7l.65.64zm4 0a.5.5 0 1 1 .7.7l-.64.65.64.65q.07.07.1.14-.34.3-.66.67l-.14-.1-.65-.65-.65.64a.5.5 0 1 1-.7-.7l.64-.65-.64-.65a.5.5 0 1 1 .7-.7l.65.64z"
]);
const $5fff284e497fef75$export$3698d98c2889e147 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderFilled', "1em", [
    "M2.75 7.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $5fff284e497fef75$export$34ff75aedab33680 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderRegular', "1em", [
    "M2.5 8a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $5fff284e497fef75$export$c125e9d130e6397c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderDotsHorizontalFilled', "1em", [
    "M14 6.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M5.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m8.5 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M10.5 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M4 13.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
]);
const $5fff284e497fef75$export$394b8fb3e202313b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderDotsHorizontalRegular', "1em", [
    "M15 7a1 1 0 1 0 2 0 1 1 0 0 0-2 0M9 7a1 1 0 1 0 2 0 1 1 0 0 0-2 0M4 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2m11 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-5 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-7-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $5fff284e497fef75$export$db1ccb9f8dcf7968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderDotsVerticalFilled', "1em", [
    "M6.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
]);
const $5fff284e497fef75$export$568a20de7ecea732 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderDotsVerticalRegular', "1em", [
    "M7 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $5fff284e497fef75$export$105a828d957594a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderVerticalFilled', "1em", [
    "M7.75 17.25a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0zm3 0a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0z"
]);
const $5fff284e497fef75$export$14c786eb5298cbdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReOrderVerticalRegular', "1em", [
    "M8 17.5a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0zm3 0a.5.5 0 0 0 1 0v-15a.5.5 0 0 0-1 0z"
]);
const $5fff284e497fef75$export$6fe3fd89f47f3d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReorderFilled', "1em", [
    "M2.75 7.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5z"
]);
const $5fff284e497fef75$export$47eae480e74ef820 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ReorderRegular', "1em", [
    "M2.5 8a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
]);
const $5fff284e497fef75$export$ec0c635db044948c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RewardColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_reward_20_color__a)",
            "d": "m12.37 9.8 3.3-1.68a2.5 2.5 0 0 0 1.36-2.23V4.5c0-.83-.68-1.5-1.5-1.5h-3.14L12 6.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_reward_20_color__b)",
            "d": "M7.61 3H4.5C3.67 3 3 3.67 3 4.5v1.58a2.5 2.5 0 0 0 1.36 2.04L7.63 9.8 8 6.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_reward_20_color__c)",
            "d": "M7.5 9.72V3h5v6.74l-1.03.52L10 11z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_reward_20_color__d)",
            "fillRule": "evenodd",
            "d": "M6.5 13.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_reward_20_color__a",
                "x1": "17.03",
                "x2": "12.07",
                "y1": "3.61",
                "y2": "8.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1a7f7c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_reward_20_color__b",
                "x1": "3",
                "x2": "8",
                "y1": "4.83",
                "y2": "8.19",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#52d17c"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1a7f7c"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_reward_20_color__c",
                "x1": "10",
                "x2": "12.75",
                "y1": "2",
                "y2": "10.06",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#76eb95"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1ec8b0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_reward_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(56.62 9.15 -15.26)scale(39.0722 33.4636)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".77",
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": ".99",
                    "stopColor": "#e67505"
                }
            ]
        ]
    ]
], {
    color: true
});
const $5fff284e497fef75$export$4b47d142108a7492 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RewardFilled', "1em", [
    "M15.53 3c.82 0 1.5.67 1.5 1.5v1.4c0 .93-.53 1.8-1.37 2.22l-4.19 2.14a3.54 3.54 0 1 1-2.92 0L4.36 8.12a2.5 2.5 0 0 1-1.35-2.04L3 5.9V4.5C3 3.67 3.67 3 4.5 3zM10 10.95a2.54 2.54 0 1 0 0 5.07 2.54 2.54 0 0 0 0-5.07M12.61 4h-5.2v4.55l2.38 1.22a.5.5 0 0 0 .45 0l2.38-1.22z"
]);
const $5fff284e497fef75$export$a90c8bb2b0a4b466 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RewardRegular', "1em", [
    "M15.53 3c.83 0 1.5.67 1.5 1.5v1.4c0 .94-.53 1.8-1.36 2.22l-4.2 2.14a3.54 3.54 0 1 1-2.92 0L4.36 8.12a2.5 2.5 0 0 1-1.35-2.04V4.5C3 3.67 3.66 3 4.5 3zM10 10.95a2.54 2.54 0 1 0 0 5.08 2.54 2.54 0 0 0 0-5.08M12.55 4H7.47V8.6L9.8 9.77a.5.5 0 0 0 .45 0l2.31-1.18zM6.47 4H4.5a.5.5 0 0 0-.5.5v1.54c.06.5.36.96.82 1.2l1.65.84zm9.06 0h-1.98v4.08l1.66-.85c.5-.25.82-.77.82-1.33V4.5a.5.5 0 0 0-.5-.5"
]);
const $5fff284e497fef75$export$be3c87248018c70a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RewindFilled', "1em", [
    "M10 5.49a1 1 0 0 0-1.6-.8l-5.87 4.3c-.68.5-.68 1.52 0 2.02l5.88 4.31a1 1 0 0 0 1.59-.8v-3.17l5.4 3.97a1 1 0 0 0 1.6-.8V5.48a1 1 0 0 0-1.6-.8L10 8.64zm-1.6-.8.3.39Z"
]);
const $5fff284e497fef75$export$80b6572c53aa236f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RewindRegular', "1em", [
    "M10 5.49a1 1 0 0 0-1.6-.8l-5.87 4.3c-.68.5-.68 1.52 0 2.02l5.88 4.31a1 1 0 0 0 1.59-.8v-3.17l5.4 3.97a1 1 0 0 0 1.6-.8V5.48a1 1 0 0 0-1.6-.8L10 8.64zm-6.88 4.3L9 5.5v9.02l-5.88-4.3a.25.25 0 0 1 0-.41m7 0L16 5.5v9.02l-5.88-4.3a.25.25 0 0 1 0-.41"
]);
const $5fff284e497fef75$export$3b5b38bb606f9946 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
]);
const $5fff284e497fef75$export$37d7a2f2e80b159a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $5fff284e497fef75$export$165c77c41aa9be2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareAddFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 8-4.9V6a3 3 0 0 0-3-3zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $5fff284e497fef75$export$bcac731ad3efad4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareAddRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6q-.24-.48-.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.2q.52.16 1 .4V6a3 3 0 0 0-3-3zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5"
]);
const $5fff284e497fef75$export$8369c5e4acb8d33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareArrowForwardFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 8-4.9V6a3 3 0 0 0-3-3zm8.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7"
]);
const $5fff284e497fef75$export$3b2cdbfde9bfe948 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareArrowForwardRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6q-.48-.24-1-.4V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.2q.16.52.4 1H6a3 3 0 0 1-3-3zm11.5 13a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7"
]);
const $5fff284e497fef75$export$cd95680ff67e0a6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareDismissFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6q-.59-1.14-.6-2.5a5.5 5.5 0 0 1 8-4.9V6a3 3 0 0 0-3-3zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $5fff284e497fef75$export$a485c60071b2c3c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareDismissRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6q-.24-.48-.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.2q.52.16 1 .4V6a3 3 0 0 0-3-3zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0"
]);
const $5fff284e497fef75$export$1ef95385747aa03e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareDovetailJointFilled', "1em", [
    "M8 11.75a.5.5 0 0 1 .68-.47L12 12.53V7.47L8.67 8.7A.5.5 0 0 1 8 8.23V3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2zM14 3H9v4.51l3.33-1.23a.5.5 0 0 1 .67.47v6.5a.5.5 0 0 1-.68.47L9 12.47V17h5a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3"
]);
const $5fff284e497fef75$export$d6df4bd74fa1e81b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareDovetailJointRegular', "1em", [
    "M14 3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3M4 14V6c0-1.1.9-2 2-2h2v4.23a.5.5 0 0 0 .67.47L12 7.47v5.06l-3.32-1.25a.5.5 0 0 0-.68.47V16H6a2 2 0 0 1-2-2m12 0a2 2 0 0 1-2 2H9v-3.53l3.32 1.25a.5.5 0 0 0 .68-.47v-6.5a.5.5 0 0 0-.67-.47L9 7.51v-3.5h5a2 2 0 0 1 2 2z"
]);
const $5fff284e497fef75$export$d3226f8ac97716a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareEraserFilled', "1em", [
    "m8.73 13.64 4.9-4.9A2.5 2.5 0 0 1 17 8.59V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2.6a2.5 2.5 0 0 1 .13-3.36m7.74-4.2 2.1 2.1a1.5 1.5 0 0 1 0 2.12l-3.6 3.6-4.22-4.22 3.6-3.6a1.5 1.5 0 0 1 2.12 0m-2.21 8.52-4.22-4.22-.6.6a1.5 1.5 0 0 0 0 2.13l2.1 2.1a1.5 1.5 0 0 0 1.12.43h4.09a.5.5 0 0 0 0-1h-2.53z"
]);
const $5fff284e497fef75$export$83e662b52cbcea9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareEraserRegular', "1em", [
    "M8.08 16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2.08q.56.14 1 .5V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2.6a2.5 2.5 0 0 1-.52-1m1.36.47a1.5 1.5 0 0 1 0-2.13l4.9-4.9a1.5 1.5 0 0 1 2.12 0l2.1 2.1a1.5 1.5 0 0 1 0 2.13L14.22 18h2.53a.5.5 0 0 1 0 1h-4.1a1.5 1.5 0 0 1-1.12-.44zm5.61-6.32-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 0 0 0-.71l-2.1-2.1a.5.5 0 0 0-.7 0m-1.5 7.1-2.8-2.8-.6.6a.5.5 0 0 0 0 .71l2.1 2.1a.5.5 0 0 0 .7 0z"
]);
const $5fff284e497fef75$export$49bd01b083a58cd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintFilled', "1em", [
    "M9.25 3a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM3 10.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0zm5.5 5.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m7-5.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0zm-9.5-7A.75.75 0 0 0 5.25 3C4.01 3 3 4 3 5.25a.75.75 0 0 0 1.5 0c0-.41.34-.75.75-.75S6 4.16 6 3.75M5.25 17a.75.75 0 0 0 0-1.5.75.75 0 0 1-.75-.75.75.75 0 0 0-1.5 0C3 15.99 4 17 5.25 17M14 3.75c0-.41.34-.75.75-.75C15.99 3 17 4 17 5.25a.75.75 0 0 1-1.5 0 .75.75 0 0 0-.75-.75.75.75 0 0 1-.75-.75M14.75 17a.75.75 0 0 1 0-1.5c.41 0 .75-.34.75-.75a.75.75 0 0 1 1.5 0c0 1.24-1 2.25-2.25 2.25"
]);
const $5fff284e497fef75$export$aff131a53652e0ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintRegular', "1em", [
    "M6 3.5a.5.5 0 0 0-.5-.5A2.5 2.5 0 0 0 3 5.5a.5.5 0 0 0 1 0C4 4.67 4.67 4 5.5 4a.5.5 0 0 0 .5-.5M16.5 6a.5.5 0 0 0 .5-.5A2.5 2.5 0 0 0 14.5 3a.5.5 0 0 0 0 1c.83 0 1.5.67 1.5 1.5 0 .28.22.5.5.5m-2 11a.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5a.5.5 0 0 1 1 0 2.5 2.5 0 0 1-2.5 2.5m-11-3a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 5.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 4 14.5a.5.5 0 0 0-.5-.5M3 9a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0zm13.5-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5m-8-5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M9 16a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
]);
const $5fff284e497fef75$export$651f45c1b68cc6c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintAppsFilled', "1em", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47m0 8.92a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47M14.66 3.07l-.07-.02a.5.5 0 0 0-.6.4.5.5 0 0 0 .47.6 2 2 0 0 1 1.5 1.55.5.5 0 0 0 .59.4.5.5 0 0 0 .38-.66 3 3 0 0 0-2.27-2.27M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H7v-.25A2.75 2.75 0 0 1 9.75 12H12V9.75A2.75 2.75 0 0 1 14.75 7H15v-.5c0-.83-.67-1.5-1.5-1.5zM19 9.75C19 8.78 18.22 8 17.25 8h-2.5C13.78 8 13 8.78 13 9.75V13H9.75C8.78 13 8 13.78 8 14.75v2.5c0 .97.78 1.75 1.75 1.75h6.75a2.5 2.5 0 0 0 2.5-2.5zM14 13V9.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75V13zm2.5 5H14v-4h4v2.5c0 .83-.67 1.5-1.5 1.5m-6.75-4H13v4H9.75a.75.75 0 0 1-.75-.75v-2.5c0-.41.34-.75.75-.75"
]);
const $5fff284e497fef75$export$82f2af0d4d1b394a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintAppsRegular', "1em", [
    "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47m0 8.92a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47M14.66 3.07l-.07-.02a.5.5 0 0 0-.6.4.5.5 0 0 0 .47.6 2 2 0 0 1 1.5 1.55.5.5 0 0 0 .59.4.5.5 0 0 0 .38-.66 3 3 0 0 0-2.27-2.27M3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm16-1.75C19 8.78 18.22 8 17.25 8h-2.5C13.78 8 13 8.78 13 9.75V13H9.75C8.78 13 8 13.78 8 14.75v2.5c0 .97.78 1.75 1.75 1.75h6.75a2.5 2.5 0 0 0 2.5-2.5zM14 13V9.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75V13zm2.5 5H14v-4h4v2.5c0 .83-.67 1.5-1.5 1.5m-6.75-4H13v4H9.75a.75.75 0 0 1-.75-.75v-2.5c0-.41.34-.75.75-.75"
]);
const $5fff284e497fef75$export$9db1e8cab1fcec56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintArrowBackFilled', "1em", [
    "M9.25 3a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM3 10.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0zm4.5 5.5c0-.41.34-.75.75-.75h.84q.15.8.51 1.5H8.25a.75.75 0 0 1-.75-.75m8-7.16q.8.15 1.5.51V8.25a.75.75 0 0 0-1.5 0zM6 3.75A.75.75 0 0 0 5.25 3C4.01 3 3 4 3 5.25a.75.75 0 0 0 1.5 0c0-.41.34-.75.75-.75S6 4.16 6 3.75M5.25 17a.75.75 0 0 0 0-1.5.75.75 0 0 1-.75-.75.75.75 0 0 0-1.5 0C3 15.99 4 17 5.25 17M14 3.75c0-.41.34-.75.75-.75C15.99 3 17 4 17 5.25a.75.75 0 0 1-1.5 0 .75.75 0 0 0-.75-.75.75.75 0 0 1-.75-.75M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $5fff284e497fef75$export$fa27d442e86590cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintArrowBackRegular', "1em", [
    "M6 3.5a.5.5 0 0 0-.5-.5A2.5 2.5 0 0 0 3 5.5a.5.5 0 0 0 1 0C4 4.67 4.67 4 5.5 4a.5.5 0 0 0 .5-.5M16.5 6a.5.5 0 0 0 .5-.5A2.5 2.5 0 0 0 14.5 3a.5.5 0 0 0 0 1c.83 0 1.5.67 1.5 1.5 0 .28.22.5.5.5m-13 8a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 5.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 4 14.5a.5.5 0 0 0-.5-.5M3 9a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0zm13.5-1.5a.5.5 0 0 0-.5.5v1.2q.52.16 1 .4V8a.5.5 0 0 0-.5-.5M9.6 17q-.24-.48-.4-1H8a.5.5 0 0 0 0 1zM8.5 3.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5m6 15.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7"
]);
const $5fff284e497fef75$export$274d93e1265f82b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintHexagonFilled', "1em", [
    "M5.5 3a.5.5 0 0 1 0 1C4.67 4 4 4.67 4 5.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 1 5.5 3M17 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1 0-1A2.5 2.5 0 0 1 17 5.5m-3 11c0 .28.22.5.5.5a2.5 2.5 0 0 0 2.5-2.5.5.5 0 0 0-1 0c0 .83-.67 1.5-1.5 1.5a.5.5 0 0 0-.5.5m-11-2a.5.5 0 0 1 1 0c0 .83.67 1.5 1.5 1.5a.5.5 0 0 1 0 1A2.5 2.5 0 0 1 3 14.5m.5-6A.5.5 0 0 0 3 9v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5M16 9a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0zM9 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm-.5 13.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M7.33 6.63c.23-.4.64-.63 1.09-.63h3.17c.44 0 .86.24 1.08.63l1.58 2.75c.23.38.23.86 0 1.24l-1.58 2.75c-.22.4-.64.63-1.08.63H8.42c-.45 0-.86-.24-1.09-.63l-1.58-2.75a1.3 1.3 0 0 1 0-1.24z"
]);
const $5fff284e497fef75$export$56437aff1065193b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintHexagonRegular', "1em", [
    "M5.5 3a.5.5 0 0 1 0 1C4.67 4 4 4.67 4 5.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 1 5.5 3M17 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1 0-1A2.5 2.5 0 0 1 17 5.5m-3 11c0 .28.22.5.5.5a2.5 2.5 0 0 0 2.5-2.5.5.5 0 0 0-1 0c0 .83-.67 1.5-1.5 1.5a.5.5 0 0 0-.5.5m-11-2a.5.5 0 0 1 1 0c0 .83.67 1.5 1.5 1.5a.5.5 0 0 1 0 1A2.5 2.5 0 0 1 3 14.5m.5-6A.5.5 0 0 0 3 9v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5M16 9a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0zM9 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm-.5 13.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5m-.3-9.37A.3.3 0 0 1 8.42 7h3.17q.14 0 .21.13l1.59 2.75q.06.12 0 .24l-1.59 2.75a.3.3 0 0 1-.21.13H8.42a.3.3 0 0 1-.22-.13l-1.59-2.75a.3.3 0 0 1 0-.24zM8.42 6c-.45 0-.86.24-1.09.63L5.75 9.38c-.23.38-.23.86 0 1.24l1.58 2.75c.23.4.64.63 1.09.63h3.17c.44 0 .86-.24 1.08-.63l1.58-2.75c.23-.38.23-.86 0-1.24l-1.58-2.75A1.3 1.3 0 0 0 11.59 6z"
]);
const $5fff284e497fef75$export$c641da15ac598b66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintSparklesFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM10 3.5q0-.26.1-.5h-.85a.75.75 0 0 0 0 1.5h1.18a1.4 1.4 0 0 1-.43-1m-6.25 8a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75m5.5 4a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zM5.25 3a.75.75 0 0 1 0 1.5.75.75 0 0 0-.75.75.75.75 0 0 1-1.5 0C3 4.01 4 3 5.25 3M6 16.25c0 .41-.34.75-.75.75C4.01 17 3 16 3 14.75a.75.75 0 0 1 1.5 0c0 .41.34.75.75.75s.75.34.75.75m8 0c0 .41.34.75.75.75 1.24 0 2.25-1 2.25-2.25a.75.75 0 0 0-1.5 0c0 .41-.34.75-.75.75a.75.75 0 0 0-.75.75"
]);
const $5fff284e497fef75$export$e98de52e9b230603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareHintSparklesRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0m4.9 7.93-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM10 3.5q0-.26.1-.5H9a.5.5 0 0 0 0 1h1.1q-.1-.24-.1-.5M5.5 3a.5.5 0 0 1 0 1C4.67 4 4 4.67 4 5.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 1 5.5 3M14 16.5c0 .28.22.5.5.5a2.5 2.5 0 0 0 2.5-2.5.5.5 0 0 0-1 0c0 .83-.67 1.5-1.5 1.5a.5.5 0 0 0-.5.5m-11-2a.5.5 0 0 1 1 0c0 .83.67 1.5 1.5 1.5a.5.5 0 0 1 0 1A2.5 2.5 0 0 1 3 14.5m.5-6A.5.5 0 0 0 3 9v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5m5 8c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5"
]);
const $5fff284e497fef75$export$26f7e6cf40c0bbd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareMultipleFilled', "1em", [
    "M6.09 4H5.05A2.5 2.5 0 0 1 7.5 2H14a4 4 0 0 1 4 4v6.5a2.5 2.5 0 0 1-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 0 0-3-3H7.5c-.65 0-1.2.42-1.41 1M2 7.5A2.5 2.5 0 0 1 4.5 5h8A2.5 2.5 0 0 1 15 7.5v8a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 2 15.5z"
]);
const $5fff284e497fef75$export$e32e2bdbf276d8bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareMultipleRegular', "1em", [
    "M6.09 4H5.05A2.5 2.5 0 0 1 7.5 2H14a4 4 0 0 1 4 4v6.5a2.5 2.5 0 0 1-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 0 0-3-3H7.5c-.65 0-1.2.42-1.41 1M4.5 5A2.5 2.5 0 0 0 2 7.5v8A2.5 2.5 0 0 0 4.5 18h8a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 12.5 5zM3 7.5C3 6.67 3.67 6 4.5 6h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 3 15.5z"
]);
const $5fff284e497fef75$export$afd6b1a0eb72aaab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareShadowFilled', "1em", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14H6v1.5A2.5 2.5 0 0 0 8.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 6H14V4.5A2.5 2.5 0 0 0 11.5 2zm-1 2.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1z"
]);
const $5fff284e497fef75$export$95cc388b635a0888 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareShadowRegular', "1em", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14H6v1.5A2.5 2.5 0 0 0 8.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 6H14V4.5A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5z"
]);
const $5fff284e497fef75$export$df75e0cd678aa276 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareTextArrowRepeatAllFilled', "1em", [
    "m16.06 8.94.94.94V5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h5.47a1.5 1.5 0 0 1-1.17-.6c-.5-.67-.8-1.5-.8-2.4H6.41a.5.5 0 0 1 0-1h2.72a4 4 0 0 1 1.93-2.5H6.41a.5.5 0 0 1 0-1h7.17a1.5 1.5 0 0 1 2.48-.56M14 6.5a.5.5 0 0 1-.41.5H6.41a.5.5 0 0 1 0-1h7.18a.5.5 0 0 1 .41.5m1.35 3.15a.5.5 0 0 0-.7.7l.64.65H13a3 3 0 0 0-2.4 4.8.5.5 0 1 0 .8-.6q-.39-.51-.4-1.2c0-1.1.9-2 2-2h2.3l-.65.65a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zm3.05 2.55a.5.5 0 0 0-.8.6q.39.51.4 1.2a2 2 0 0 1-2 2h-2.3l.65-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H16a3 3 0 0 0 2.4-4.8"
]);
const $5fff284e497fef75$export$340f248f4880619f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquareTextArrowRepeatAllRegular', "1em", [
    "m16.06 8.94.94.94V5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h5.47a1.5 1.5 0 0 1-1.17-.6q-.14-.2-.26-.4H5.5A1.5 1.5 0 0 1 4 14.5v-9C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v3.38zM9 14a4 4 0 0 1 .13-1H6.4a.5.5 0 0 0 .09 1zm4.5-4q0-.25.08-.5H6.41a.5.5 0 0 0 .09 1h4.56q.88-.49 1.94-.5zm.5-3.5a.5.5 0 0 1-.41.5H6.5a.5.5 0 0 1-.09-1h7.09c.28 0 .5.22.5.5m1.35 3.15a.5.5 0 0 0-.7.7l.64.65H13a3 3 0 0 0-2.4 4.8.5.5 0 1 0 .8-.6q-.39-.51-.4-1.2c0-1.1.9-2 2-2h2.3l-.65.65a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7zm3.05 2.55a.5.5 0 0 0-.8.6q.39.51.4 1.2a2 2 0 0 1-2 2h-2.3l.65-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H16a3 3 0 0 0 2.4-4.8"
]);
const $5fff284e497fef75$export$f4164563149dd008 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquaresNestedFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1.76A3 3 0 0 0 15 7h-5a3 3 0 0 0-3 3v5c0 .77.29 1.47.76 2H6a3 3 0 0 1-3-3zm7 11h4a3 3 0 0 0 3-3v-4a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2"
]);
const $5fff284e497fef75$export$337ba3a8d786d77f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SquaresNestedRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm10 4.76A3 3 0 0 0 14 7h-4a3 3 0 0 0-3 3v4c0 .77.29 1.47.76 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2zM10 16a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z"
]);
const $5fff284e497fef75$export$66bce9db881d746b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToolboxColor', "1em", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_toolbox_20_color__a)",
            "d": "M6 4.75C6 3.78 6.78 3 7.75 3h4.5c.97 0 1.75.78 1.75 1.75V7.5h-1.5V4.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25V7.5H6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_toolbox_20_color__b)",
            "d": "M16 17a2 2 0 0 0 2-2V9.5H2V15c0 1.1.9 2 2 2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_toolbox_20_color__c)",
            "d": "M4 6a2 2 0 0 0-2 2v2h16V8a2 2 0 0 0-2-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_toolbox_20_color__d)",
            "d": "M6.75 9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_toolbox_20_color__e)",
            "d": "M13.25 9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_toolbox_20_color__a",
                "x1": "3.14",
                "x2": "3.97",
                "y1": "3",
                "y2": "6.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_toolbox_20_color__b",
                "x1": "1",
                "x2": "2.78",
                "y1": "6.69",
                "y2": "24.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".12",
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_toolbox_20_color__c",
                "x1": "1",
                "x2": "1.3",
                "y1": "4.5",
                "y2": "14.08",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#f97dbd"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#d7257d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_toolbox_20_color__d",
                "x1": "3.14",
                "x2": "3.52",
                "y1": "9",
                "y2": "11.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#efefef"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dadada"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_toolbox_20_color__e",
                "x1": "3.14",
                "x2": "3.52",
                "y1": "9",
                "y2": "11.62",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#efefef"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#dadada"
                }
            ]
        ]
    ]
], {
    color: true
});
const $5fff284e497fef75$export$d587efc1752da03b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToolboxFilled', "1em", [
    "M6 4.5V6H4a2 2 0 0 0-2 2v2h4v-.5a.5.5 0 0 1 1 0v.5h6v-.5a.5.5 0 0 1 1 0v.5h4V8a2 2 0 0 0-2-2h-2V4.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 3 6 3.67 6 4.5M7.5 4h5c.28 0 .5.22.5.5V6H7V4.5c0-.28.22-.5.5-.5M18 11h-4v.5a.5.5 0 1 1-1 0V11H7v.5a.5.5 0 0 1-1 0V11H2v4c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2z"
]);
const $5fff284e497fef75$export$ace00c2cd0f3488e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToolboxRegular', "1em", [
    "M6 4.5V6H4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2V4.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 3 6 3.67 6 4.5M7.5 4h5c.28 0 .5.22.5.5V6H7V4.5c0-.28.22-.5.5-.5M4 7h12a1 1 0 0 1 1 1v2h-3v-.5a.5.5 0 0 0-1 0v.5H7v-.5a.5.5 0 0 0-1 0v.5H3V8a1 1 0 0 1 1-1m9 4v.5a.5.5 0 0 0 1 0V11h3v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h3v.5a.5.5 0 0 0 1 0V11z"
]);
const $5fff284e497fef75$export$67d40cbd636e2d9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TooltipQuoteFilled', "1em", [
    "M2 4c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9.42l-1.48 2.74a.5.5 0 0 1-.88 0L5.56 12H4a2 2 0 0 1-2-2zm3.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A5 5 0 0 0 7 5.5a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A5 5 0 0 0 10 5.5a.5.5 0 0 0-.5-.5zm-2.98 9H2.5a.5.5 0 0 0 0 1h3.56zm3.41 1h8.57a.5.5 0 0 0 0-1H9.48zM2 17.5c0-.28.22-.5.5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5"
]);
const $5fff284e497fef75$export$1c35a06a8b9b194e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TooltipQuoteRegular', "1em", [
    "M5.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A5 5 0 0 0 7 5.5a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A5 5 0 0 0 10 5.5a.5.5 0 0 0-.5-.5zM2 4c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9.42l-1.48 2.74a.5.5 0 0 1-.88 0L5.56 12H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1.86q.29.01.44.26l1.2 2.2 1.18-2.2a.5.5 0 0 1 .44-.26H11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM2.5 14h3.02l.54 1H2.5a.5.5 0 0 1 0-1m15 1H8.93l.55-1h8.02a.5.5 0 0 1 0 1m-15 2a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1z"
]);
const $5fff284e497fef75$export$bcce7bea98d87da4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TooltipQuoteOffFilled', "1em", [
    "M12.5 17a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1zM2.15 2.15c.2-.2.5-.2.7 0l15 15 .07.07a.5.5 0 0 1-.7.7l-.07-.07L14.29 15H8.93l.55-1h3.81l-2.02-2.02L11 12H9.42l-1.48 2.74a.5.5 0 0 1-.88 0L5.56 12H4a2 2 0 0 1-2-2V4q0-.56.28-1.01l-.13-.14a.5.5 0 0 1 0-.7M6.06 15H2.5a.5.5 0 0 1 0-1h3.02zm11.44-1a.5.5 0 0 1 0 1h-.38l-1-1zM11 2a2 2 0 0 1 2 2v6a2 2 0 0 1-.14.74L9.64 7.52c.2-.55.36-1.23.36-2.02a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.38L4.12 2zM5 6.5a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7 4 4 0 0 0 .83-1.46L5 5.71z"
]);
const $5fff284e497fef75$export$71315f4e63b63eb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TooltipQuoteOffRegular', "1em", [
    "M12.5 17a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1zM2.15 2.15c.2-.2.5-.2.7 0l15 15 .07.07a.5.5 0 0 1-.7.7l-.07-.07L14.29 15H8.93l.55-1h3.81l-2.02-2.02L11 12H9.42l-1.48 2.74a.5.5 0 0 1-.88 0L5.56 12H4a2 2 0 0 1-2-2V4q0-.56.28-1.01l-.13-.14a.5.5 0 0 1 0-.7M6.06 15H2.5a.5.5 0 0 1 0-1h3.02zm11.44-1a.5.5 0 0 1 0 1h-.38l-1-1zM3.03 3.74 3 4v6a1 1 0 0 0 1 1h1.86q.29.01.44.26l1.2 2.2 1.18-2.2a.5.5 0 0 1 .44-.26h1.17L6.7 7.4a4 4 0 0 1-.84 1.45.5.5 0 1 1-.7-.7c.15-.15.45-.58.65-1.25a.5.5 0 0 1-.8-.4v-.8zM11 2a2 2 0 0 1 2 2v6a2 2 0 0 1-.14.74L12 9.88V4a1 1 0 0 0-1-1H5.12l-1-1zM9.5 5c.28 0 .5.22.5.5 0 .8-.15 1.47-.36 2.02L8 5.88V5.5c0-.28.22-.5.5-.5z"
]);
const $5fff284e497fef75$export$60dccb0e947e78c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TranslateFilled', "1em", [
    "M4.18 3.2c.7-.2 1.68-.33 2.8 0 1.03.3 1.6.94 1.89 1.64.25.64.25 1.29.25 1.66v4.75a.75.75 0 0 1-1.5 0l-.56.28c-.75.33-1.7.6-2.63.4a3 3 0 0 1-2.3-2.15c-.3-1-.1-2.18.83-2.96a4.5 4.5 0 0 1 3.18-1q.8.04 1.47.21a2 2 0 0 0-.13-.63c-.12-.29-.35-.59-.92-.76a3.4 3.4 0 0 0-2.69.32.75.75 0 0 1-.85-1.23v-.01l.03-.01.3-.18q.3-.16.83-.33m1.9 4.11a3 3 0 0 0-2.15.66c-.4.33-.52.86-.37 1.4.16.52.58.97 1.17 1.1.48.1 1.08-.03 1.72-.32.46-.2.87-.46 1.17-.68V7.58q-.7-.21-1.55-.27m7.9-1.26c.39.15.58.58.44.97l-.18.52q.72-.12 1.45-.27a.75.75 0 0 1 .32 1.46q-1.09.25-2.2.38-.16.64-.26 1.18.6-.09 1.14-.07a.75.75 0 0 1 1.48.2v.04a4 4 0 0 1 2.54 2.18c.4.91.4 1.96-.09 2.93a5.3 5.3 0 0 1-2.77 2.37.75.75 0 0 1-.58-1.38c1.11-.47 1.73-1.09 2.01-1.66a1.9 1.9 0 0 0 .06-1.65A2.5 2.5 0 0 0 16 12a7 7 0 0 1-1.82 3.51l.22.45a.75.75 0 1 1-1.38.58l-.03-.06q-.67.41-1.35.55c-.67.15-1.45.1-2-.46-.79-.81-.82-2.14-.3-3.26a5.3 5.3 0 0 1 2.6-2.52q.1-.7.28-1.55-.76.03-1.53-.02a.75.75 0 0 1 .1-1.5q.9.06 1.82 0c.11-.4.26-.87.4-1.24a.75.75 0 0 1 .96-.43m-2.15 6.55c-.56.41-.92.88-1.12 1.33-.36.79-.2 1.37.02 1.59.03.03.19.14.6.05q.46-.08 1-.45a6 6 0 0 1-.5-2.52m1.7 1.4c.45-.61.82-1.37 1-2.28q-.54 0-1.18.14a7 7 0 0 0 .17 2.13"
]);
const $5fff284e497fef75$export$c581601095493c80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TranslateRegular', "1em", [
    "M4.08 4.22c.7-.21 1.7-.34 2.84 0 1.01.3 1.56.9 1.83 1.56.26.63.26 1.27.26 1.67v5.05a.5.5 0 0 1-1 0v-.53q-.47.29-1.05.55c-.78.34-1.74.6-2.64.42a3 3 0 0 1-2.25-2.09c-.29-.97-.08-2.1.8-2.84a4.6 4.6 0 0 1 3.21-1c.71.03 1.38.17 1.93.32 0-.37-.03-.79-.18-1.17-.16-.4-.48-.77-1.19-.98a4 4 0 0 0-3.15.37h-.01a.5.5 0 0 1-.57-.82h.01l.02-.02.3-.17q.3-.16.84-.32M6.04 8a3.6 3.6 0 0 0-2.52.77 1.7 1.7 0 0 0-.5 1.79c.2.66.73 1.23 1.5 1.39.6.12 1.33-.04 2.04-.35.58-.26 1.1-.6 1.45-.85V8.37a8 8 0 0 0-1.97-.36m8.43-1.34a.5.5 0 0 0-.94-.34c-.18.5-.37 1.22-.47 1.65q-.74.04-1.53 0a.5.5 0 1 0-.06 1q.7.04 1.36 0-.17.87-.25 1.56a4.7 4.7 0 0 0-2.3 2.3c-.44 1.02-.4 2.17.25 2.85.43.46 1.06.53 1.64.4q.64-.16 1.28-.61l.08.2a.5.5 0 0 0 .93-.36l-.23-.53a6.7 6.7 0 0 0 1.68-3.6c.77.26 1.28.8 1.5 1.38.38 1.04-.04 2.55-2.11 3.47a.5.5 0 1 0 .4.92c2.43-1.08 3.26-3.07 2.64-4.73A3.4 3.4 0 0 0 16 10.17V10a.5.5 0 1 0-1 0v.02q-.64-.02-1.36.13l.23-1.25a21 21 0 0 0 2.24-.41.5.5 0 0 0-.22-.98q-.92.23-1.77.35c.1-.38.23-.85.35-1.2m-3.27 6.57c.23-.52.64-1.06 1.3-1.5q-.01.94.13 1.61.16.71.38 1.2-.58.45-1.06.56c-.39.09-.6 0-.69-.1-.27-.3-.4-.97-.06-1.77m3.73-2.22a6 6 0 0 1-1.15 2.76l-.17-.62a7 7 0 0 1-.09-1.94l.13-.04q.7-.18 1.28-.16"
]);
const $5fff284e497fef75$export$865cb1196bafc181 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TranslateAutoFilled', "1em", [
    "M10.82 1.04a.75.75 0 1 0-.13 1.5c1.42.12 2.73.65 3.81 1.46h-.25a.75.75 0 0 0 0 1.5h2c.41 0 .75-.34.75-.75v-2a.75.75 0 0 0-1.5 0v.13a9 9 0 0 0-4.68-1.84M5.75 16H5.5a7.5 7.5 0 0 0 3.82 1.47.75.75 0 1 1-.14 1.5 9 9 0 0 1-4.68-1.85v.13a.75.75 0 0 1-1.5 0v-2c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5M6.98 3.2a5 5 0 0 0-3.93.5l-.02.02h-.01a.75.75 0 0 0 .85 1.24l.03-.02.14-.07q.2-.12.56-.23a3.4 3.4 0 0 1 1.96 0c.57.17.8.47.92.76q.11.3.13.63c-.44-.1-.94-.2-1.47-.22a4.5 4.5 0 0 0-3.18 1.01 2.8 2.8 0 0 0-.84 2.96c.3 1 1.1 1.9 2.3 2.15a4.4 4.4 0 0 0 2.64-.4l.56-.29v.01a.75.75 0 1 0 1.5 0V6.5c0-.37 0-1.02-.25-1.66A2.8 2.8 0 0 0 6.99 3.2m.64 4.38v1.9c-.3.21-.71.47-1.17.67-.64.29-1.24.41-1.72.31a1.6 1.6 0 0 1-1.17-1.1c-.15-.53-.02-1.06.37-1.39.63-.54 1.38-.69 2.14-.66q.85.06 1.55.27m6.8-.56a.75.75 0 0 0-1.4-.54c-.14.37-.29.83-.4 1.24q-.92.06-1.82 0a.75.75 0 1 0-.1 1.5q.77.05 1.53.02-.18.84-.27 1.55a5.3 5.3 0 0 0-2.62 2.52c-.51 1.12-.48 2.45.32 3.26.54.55 1.32.6 2 .46q.66-.14 1.34-.55l.03.06a.75.75 0 0 0 1.38-.58l-.22-.45a7 7 0 0 0 1.82-3.5c.66.28 1.1.75 1.33 1.24.22.5.22 1.08-.06 1.65s-.9 1.19-2.01 1.66a.75.75 0 0 0 .58 1.38 5.3 5.3 0 0 0 2.77-2.37 3.4 3.4 0 0 0 .09-2.93 4 4 0 0 0-2.54-2.18v-.04a.75.75 0 0 0-1.48-.2q-.54-.01-1.14.07l.25-1.18q1.13-.14 2.2-.38a.75.75 0 0 0-.31-1.46q-.73.16-1.45.27zm-3.71 6.9q.29-.68 1.12-1.32.02.82.16 1.44a6 6 0 0 0 .34 1.08q-.54.36-1 .45c-.41.09-.57-.02-.6-.05-.21-.22-.38-.8-.02-1.6m3.83-2.2a6 6 0 0 1-1.02 2.27l-.07-.27a7 7 0 0 1-.1-1.86q.64-.14 1.19-.14"
]);
const $5fff284e497fef75$export$60c6cea0d5831861 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TranslateAutoRegular', "1em", [
    "M10.53 1.02a.5.5 0 0 0-.06 1c1.84.1 3.52.83 4.82 1.98h-.79a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.8a9 9 0 0 0-5.47-2.28M5.5 16h-.8a8 8 0 0 0 4.83 1.99.5.5 0 0 1-.06 1c-2.1-.13-4-.97-5.47-2.28v.79a.5.5 0 1 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1M6.92 4.22a5 5 0 0 0-3.98.5h-.02v.01a.5.5 0 0 0 .56.83l.21-.12q.24-.13.67-.26a4 4 0 0 1 2.28 0c.71.2 1.03.59 1.19.98.15.38.17.8.18 1.17a9 9 0 0 0-1.93-.32 4.6 4.6 0 0 0-3.2 1 2.7 2.7 0 0 0-.81 2.84 3 3 0 0 0 2.25 2.09c.9.18 1.86-.08 2.64-.42q.58-.26 1.05-.55v.53a.5.5 0 1 0 1 0V7.45c0-.4 0-1.04-.26-1.67a2.7 2.7 0 0 0-1.83-1.56m1.09 4.15v2.39c-.35.26-.87.59-1.45.85-.7.3-1.43.47-2.04.35a2 2 0 0 1-1.5-1.39c-.19-.66-.03-1.35.5-1.79.76-.63 1.65-.8 2.52-.77.72.03 1.4.2 1.97.36m6.16-2.34c.26.1.4.38.3.64-.12.34-.25.8-.35 1.2q.85-.14 1.77-.36a.5.5 0 0 1 .22.98q-1.14.27-2.24.41-.14.68-.23 1.25.72-.15 1.36-.13V10a.5.5 0 0 1 1 0v.17a3.4 3.4 0 0 1 2.34 2.06c.62 1.66-.21 3.65-2.64 4.73a.5.5 0 1 1-.4-.92c2.07-.92 2.5-2.43 2.1-3.47a2.4 2.4 0 0 0-1.49-1.38 6.7 6.7 0 0 1-1.68 3.6q.13.27.23.53a.5.5 0 1 1-.93.37l-.08-.21q-.64.45-1.28.6c-.58.14-1.2.07-1.64-.39-.64-.68-.69-1.83-.25-2.85a4.7 4.7 0 0 1 2.3-2.3q.09-.7.25-1.55-.66.03-1.36-.02a.5.5 0 1 1 .06-1q.79.06 1.53 0c.1-.42.3-1.14.47-1.64a.5.5 0 0 1 .64-.3m-1.67 5.71c-.66.44-1.07.98-1.3 1.5-.35.8-.21 1.48.06 1.77.1.1.3.19.69.1q.47-.1 1.06-.55a6 6 0 0 1-.38-1.2q-.14-.68-.13-1.62m1.28 2.04c.54-.68.98-1.61 1.15-2.76a5 5 0 0 0-1.4.2 7 7 0 0 0 .08 1.94q.07.34.17.62"
]);
const $5fff284e497fef75$export$8f68f82ee0c90677 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TranslateOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l.87.88a.75.75 0 0 0 .85 1.23l.03-.02.22-.11 1.03 1.03c-.73.1-1.5.38-2.19.96a2.8 2.8 0 0 0-.84 2.96c.3 1 1.1 1.9 2.3 2.15a4.4 4.4 0 0 0 2.64-.4l.56-.29v.01a.75.75 0 1 0 1.5 0V9.83l1.68 1.67a5 5 0 0 0-1.46 1.8c-.51 1.13-.48 2.46.32 3.27.54.55 1.32.6 2 .46q.66-.14 1.34-.55l.03.06a.75.75 0 0 0 1.38-.58l-.22-.45.3-.32 1.18 1.18-.4.19a.75.75 0 0 0 .58 1.38q.5-.22.92-.46l.38.37a.5.5 0 0 0 .7-.7zm4.77 6.18v1.14c-.3.22-.71.48-1.17.68-.64.29-1.24.41-1.72.31a1.6 1.6 0 0 1-1.17-1.1c-.15-.53-.02-1.06.37-1.39.63-.54 1.38-.69 2.14-.66l.6.06zM6.9 4.78c.3.15.45.34.54.54L9.12 7v-.5c0-.37 0-1.02-.25-1.66A2.8 2.8 0 0 0 6.99 3.2c-.68-.2-1.3-.23-1.85-.18zm7.64 6.94-.14.55 1.16 1.17q.3-.66.45-1.44c.66.3 1.1.76 1.33 1.25a1.9 1.9 0 0 1-.15 1.82l1.08 1.08q.2-.28.35-.58a3.4 3.4 0 0 0 .09-2.93 4 4 0 0 0-2.54-2.18v-.04a.75.75 0 0 0-1.48-.2q-.54-.01-1.14.07l.25-1.18q1.13-.14 2.2-.38a.75.75 0 0 0-.31-1.46q-.73.16-1.45.27l.18-.52a.75.75 0 0 0-1.4-.54c-.14.37-.29.83-.4 1.24q-.92.06-1.82 0a.8.8 0 0 0-.65.3l1.22 1.23.86-.01-.14.73 1.8 1.8q.33-.05.65-.05m-2.7.88q0 .82.15 1.44a6 6 0 0 0 .34 1.08q-.54.36-1 .45c-.41.09-.57-.02-.6-.05-.21-.22-.38-.8-.02-1.6q.29-.68 1.12-1.32"
]);
const $5fff284e497fef75$export$500327e27914d866 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TranslateOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.5 1.51a5 5 0 0 0-.7.35l-.03.02a.5.5 0 0 0 .56.83l.21-.12a4 4 0 0 1 .75-.29l1.87 1.87-.23-.01a4.6 4.6 0 0 0-3.2 1 2.7 2.7 0 0 0-.81 2.84 3 3 0 0 0 2.25 2.09c.9.18 1.86-.08 2.64-.42q.58-.26 1.05-.55v.53a.5.5 0 1 0 1 0V9.7l2 2a4 4 0 0 0-.73 1.13c-.44 1.02-.4 2.17.25 2.85.43.46 1.06.53 1.64.4q.64-.16 1.28-.61l.08.2a.5.5 0 1 0 .93-.36l-.1-.26.96.97-.02.01a.5.5 0 1 0 .4.92l.37-.18 1.08 1.07a.5.5 0 0 0 .7-.7zm9.78 11.18v.02q.16.71.38 1.2-.58.45-1.06.56c-.39.09-.6 0-.69-.1-.27-.3-.4-.97-.06-1.77q.18-.41.52-.81zm-5.1-5.09.48.47v2.05c-.35.26-.87.59-1.45.85-.7.3-1.43.47-2.04.35a2 2 0 0 1-1.5-1.39c-.19-.66-.03-1.35.5-1.79.76-.63 1.65-.8 2.52-.77q.8.05 1.5.23m9.88 4.33c.24.66.16 1.5-.45 2.27l.7.7a3.3 3.3 0 0 0 .68-3.31A3.4 3.4 0 0 0 16 10.17V10a.5.5 0 1 0-1 0v.02q-.64-.02-1.36.13l.23-1.25a21 21 0 0 0 2.24-.41.5.5 0 0 0-.22-.98q-.92.23-1.77.35c.1-.38.23-.85.35-1.2a.5.5 0 0 0-.94-.33c-.18.5-.37 1.22-.47 1.65q-.74.04-1.53 0a.5.5 0 1 0-.06 1q.7.04 1.36 0-.15.82-.24 1.5l.92.91.01-.17.13-.04q.7-.18 1.28-.16-.12.77-.38 1.4l.76.77q.43-.89.6-2c.77.26 1.28.8 1.5 1.38M6.18 4.06l2.8 2.8a4 4 0 0 0-.23-1.08 2.7 2.7 0 0 0-1.83-1.56q-.38-.12-.74-.16"
]);
const $5fff284e497fef75$export$83ab48319ddd9504 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TransmissionFilled', "1em", [
    "M10 2a2 2 0 0 0-.5 3.94V9.5a.5.5 0 0 0 1 0V5.94A2 2 0 0 0 10 2M3 5a1 1 0 0 1 2 0v4c0 .28.22.5.5.5H8a.5.5 0 0 0 0-1H6V5a2 2 0 1 0-4 0v11a2 2 0 1 0 4 0v-3.5h2V16a2 2 0 1 0 4 0v-3h4.5c.83 0 1.5-.67 1.5-1.5V5a2 2 0 1 0-4 0v3.5h-2a.5.5 0 0 0 0 1h2.5A.5.5 0 0 0 15 9V5a1 1 0 1 1 2 0v6.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 0-.5.5V16a1 1 0 1 1-2 0v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4a1 1 0 1 1-2 0z"
]);
const $5fff284e497fef75$export$d7cfec1de25f91a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TransmissionRegular', "1em", [
    "M10 2a2 2 0 0 0-.5 3.94V9.5a.5.5 0 0 0 1 0V5.94A2 2 0 0 0 10 2M9 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 4a1 1 0 0 0-1 1v11a1 1 0 1 0 2 0v-4c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v4a1 1 0 1 0 2 0v-3.5c0-.28.22-.5.5-.5h5a.5.5 0 0 0 .5-.5V5a1 1 0 1 0-2 0v4a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h2V5a2 2 0 1 1 4 0v6.5c0 .83-.67 1.5-1.5 1.5H12v3a2 2 0 1 1-4 0v-3.5H6V16a2 2 0 1 1-4 0V5a2 2 0 1 1 4 0v3.5h2a.5.5 0 0 1 0 1H5.5A.5.5 0 0 1 5 9V5a1 1 0 0 0-1-1"
]);
const $5fff284e497fef75$export$6d79984a3a8f3ef5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TransparencySquareFilled', "1em", [
    "M6 2.5A3.5 3.5 0 0 0 2.5 6v8A3.5 3.5 0 0 0 6 17.5h8a3.5 3.5 0 0 0 3.5-3.5V6A3.5 3.5 0 0 0 14 2.5zM4 6c0-1.1.9-2 2-2h1v3H4zm0 4h3V7h3V4h3v3h3v3h-3v3h3v1a2 2 0 0 1-2 2h-1v-3h-3v3H7v-3H4zm6 0v3H7v-3zm0 0h3V7h-3z"
]);
const $5fff284e497fef75$export$1bab89b4ec58f790 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TransparencySquareRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h1v3H4zm0 4h3V7h3V4h3v3h3v3h-3v3h3v1a2 2 0 0 1-2 2h-1v-3h-3v3H7v-3H4zm6 0V7h3v3zm0 0H7v3h3z"
]);
const $5fff284e497fef75$export$da9e87355e10a4f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrayItemAddFilled', "1em", [
    "M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm2 5.5a.5.5 0 0 0-1 0v5.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L14 13.29zM5 11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm-2 2.5a.5.5 0 0 0-1 0V15c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-1.5a.5.5 0 0 0-1 0V15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
]);
const $5fff284e497fef75$export$68f3a13c4b216da5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrayItemAddRegular', "1em", [
    "M11 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zm4 0h-3v2h3zm-1.5 4c.28 0 .5.22.5.5v5.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L13 13.29V7.5c0-.28.22-.5.5-.5M4 12a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm4 0H5v2h3zm-5.5 1c.28 0 .5.22.5.5V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.5a.5.5 0 0 1 1 0V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.5c0-.28.22-.5.5-.5"
]);
const $5fff284e497fef75$export$accf571526539091 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrayItemRemoveFilled', "1em", [
    "M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm1.85 5.15a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7L13 8.71v5.79a.5.5 0 0 0 1 0V8.7l1.15 1.15a.5.5 0 0 0 .7-.7zM5 11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm-2 2.5a.5.5 0 0 0-1 0V15c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-1.5a.5.5 0 0 0-1 0V15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
]);
const $5fff284e497fef75$export$f16dad35fdc74971 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrayItemRemoveRegular', "1em", [
    "M11 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zm4 0h-3v2h3zm-1.85 4.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L14 8.71v5.79a.5.5 0 0 1-1 0V8.7l-1.15 1.15a.5.5 0 0 1-.7-.7zM4 12a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm4 0H5v2h3zm-5.5 1c.28 0 .5.22.5.5V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.5a.5.5 0 0 1 1 0V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.5c0-.28.22-.5.5-.5"
]);
const $5fff284e497fef75$export$ff7d884f068dbfc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WandFilled', "1em", [
    "M17 2.5a.5.5 0 0 0-1 0V3h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0V4h.5a.5.5 0 0 0 0-1H17zm-10 3a.5.5 0 0 1-.5.5H6v.5a.5.5 0 0 1-1 0V6h-.5a.5.5 0 0 1 0-1H5v-.5a.5.5 0 0 1 1 0V5h.5c.28 0 .5.22.5.5m9 9a.5.5 0 0 1-.5.5H15v.5a.5.5 0 0 1-1 0V15h-.5a.5.5 0 0 1 0-1h.5v-.5a.5.5 0 0 1 1 0v.5h.5c.28 0 .5.22.5.5m-2.57-7.93a1.9 1.9 0 0 0-2.7 0l-.48.47 2.7 2.71.48-.48c.75-.74.75-1.96 0-2.7m-1.18 3.89-2.7-2.71-6.99 6.98a1.91 1.91 0 1 0 2.7 2.7z"
]);
const $5fff284e497fef75$export$6f866a2148ac5621 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WandRegular', "1em", [
    "M16.5 2c.28 0 .5.22.5.5V3h.5a.5.5 0 0 1 0 1H17v.5a.5.5 0 0 1-1 0V4h-.5a.5.5 0 1 1 0-1h.5v-.5c0-.28.22-.5.5-.5m-10 4a.5.5 0 0 0 0-1H6v-.5a.5.5 0 0 0-1 0V5h-.5a.5.5 0 0 0 0 1H5v.5a.5.5 0 0 0 1 0V6zm9 9a.5.5 0 0 0 0-1H15v-.5a.5.5 0 0 0-1 0v.5h-.5a.5.5 0 1 0 0 1h.5v.5a.5.5 0 1 0 1 0V15zm-2.07-8.43a1.9 1.9 0 0 0-2.7 0l-8.17 8.16a1.91 1.91 0 1 0 2.7 2.7l8.17-8.16c.75-.74.75-1.96 0-2.7m-2 .7a.91.91 0 0 1 1.3 1.3l-.48.47-1.3-1.29zm-1.18 1.19 1.3 1.29-6.99 6.98a.91.91 0 0 1-1.3-1.29z"
]);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");






'use client';
const $2e078eac8a385109$export$f923d4e087228f8d = {
    root: 'fui-DialogSurface',
    backdrop: 'fui-DialogSurface__backdrop'
};
/**
 * Styles for the root slot
 */ const $2e078eac8a385109$var$useRootBaseStyle = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1u3t6p6", "r5coedp", {
    r: [
        ".r1u3t6p6{inset:0;padding:24px;margin:auto;border-style:none;overflow:unset;border:1px solid var(--colorTransparentStroke);border-radius:var(--borderRadiusXLarge);display:block;-webkit-user-select:unset;-moz-user-select:unset;user-select:unset;visibility:unset;position:fixed;height:fit-content;max-width:600px;max-height:100vh;max-height:100dvh;box-sizing:border-box;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);box-shadow:var(--shadow64);}",
        ".r1u3t6p6:focus{outline-style:none;}",
        ".r1u3t6p6:focus-visible{outline-style:none;}",
        ".r1u3t6p6[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".r1u3t6p6[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".r5coedp{inset:0;padding:24px;margin:auto;border-style:none;overflow:unset;border:1px solid var(--colorTransparentStroke);border-radius:var(--borderRadiusXLarge);display:block;-webkit-user-select:unset;-moz-user-select:unset;user-select:unset;visibility:unset;position:fixed;height:fit-content;max-width:600px;max-height:100vh;max-height:100dvh;box-sizing:border-box;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);box-shadow:var(--shadow64);}",
        ".r5coedp:focus{outline-style:none;}",
        ".r5coedp:focus-visible{outline-style:none;}",
        ".r5coedp[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".r5coedp[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.r1u3t6p6[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media screen and (max-width: 480px){.r1u3t6p6{max-width:100vw;}}",
        "@media screen and (max-height: 359px){.r1u3t6p6{overflow-y:auto;padding-right:calc(24px - 4px);border-right-width:4px;border-top-width:4px;border-bottom-width:4px;}}",
        "@media (forced-colors: active){.r5coedp[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}",
        "@media screen and (max-width: 480px){.r5coedp{max-width:100vw;}}",
        "@media screen and (max-height: 359px){.r5coedp{overflow-y:auto;padding-left:calc(24px - 4px);border-left-width:4px;border-top-width:4px;border-bottom-width:4px;}}"
    ]
});
const $2e078eac8a385109$var$useBackdropBaseStyle = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1e18s3l", null, [
    ".r1e18s3l{inset:0px;background-color:var(--colorBackgroundOverlay);position:fixed;}"
]);
const $2e078eac8a385109$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    nestedDialogBackdrop: {
        De3pzq: "f1c21dwh"
    },
    dialogHidden: {
        Bkecrkj: "f1aehjj5"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1aehjj5{pointer-events:none;}"
    ]
});
const $2e078eac8a385109$export$60c1cf33f8375d66 = (state)=>{
    const { root: root, backdrop: backdrop, open: open, unmountOnClose: unmountOnClose, treatBackdropAsNested: treatBackdropAsNested, backdropAppearance: backdropAppearance } = state;
    const rootBaseStyle = $2e078eac8a385109$var$useRootBaseStyle();
    const backdropBaseStyle = $2e078eac8a385109$var$useBackdropBaseStyle();
    const styles = $2e078eac8a385109$var$useStyles();
    const isBackdropTransparent = backdropAppearance ? backdropAppearance === 'transparent' : treatBackdropAsNested;
    const mountedAndClosed = !unmountOnClose && !open;
    // eslint-disable-next-line react-hooks/immutability
    root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($2e078eac8a385109$export$f923d4e087228f8d.root, rootBaseStyle, mountedAndClosed && styles.dialogHidden, root.className);
    if (backdrop) // eslint-disable-next-line react-hooks/immutability
    backdrop.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($2e078eac8a385109$export$f923d4e087228f8d.backdrop, backdropBaseStyle, mountedAndClosed && styles.dialogHidden, isBackdropTransparent && styles.nestedDialogBackdrop, backdrop.className);
    return state;
};




'use client';
const $73cdd34c0b870187$export$8d5c5a60a915d482 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $254eec9f6c345877$export$c76c7ec047fdba7d)(props, ref);
    const contextValues = (0, $dcf0dbbf13f87385$export$127901f2ae2690e3)(state);
    (0, $2e078eac8a385109$export$60c1cf33f8375d66)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogSurfaceStyles_unstable')(state);
    return (0, $408594075e348c01$export$621d9bedb04ddc81)(state, contextValues);
});
$73cdd34c0b870187$export$8d5c5a60a915d482.displayName = 'DialogSurface';


var $acw62 = parcelRequire("acw62");

const $28a5d610d22ec260$export$2eb5650081e5becf = (props, ref)=>{
    var _props_as;
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : 'div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        })
    };
};




const $adaf5421c7f0dc1e$export$56f94778760af4a0 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    // TODO Add additional slots in the appropriate place
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};




'use client';
const $d204977a0cbd09d2$export$3d0920dbde491190 = {
    root: 'fui-DialogBody'
};
/**
 * Styles for the root slot
 */ const $d204977a0cbd09d2$var$useResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rhwx3p8", null, {
    r: [
        ".rhwx3p8{overflow:unset;gap:8px;display:grid;max-height:calc(100vh - 2 * 24px);max-height:calc(100dvh - 2 * 24px);box-sizing:border-box;grid-template-rows:auto 1fr;grid-template-columns:1fr 1fr auto;}"
    ],
    s: [
        "@media screen and (max-width: 480px){.rhwx3p8{max-width:100vw;grid-template-rows:auto 1fr auto;}}",
        "@media screen and (max-height: 359px){.rhwx3p8{max-height:unset;}}"
    ]
});
const $d204977a0cbd09d2$export$e2cbfda03de88892 = (state)=>{
    const resetStyles = $d204977a0cbd09d2$var$useResetStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($d204977a0cbd09d2$export$3d0920dbde491190.root, resetStyles, state.root.className);
    return state;
};



'use client';
const $4346adda79f54b9d$export$5d20f2c38fcde41f = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $28a5d610d22ec260$export$2eb5650081e5becf)(props, ref);
    (0, $d204977a0cbd09d2$export$e2cbfda03de88892)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogBodyStyles_unstable')(state);
    return (0, $adaf5421c7f0dc1e$export$56f94778760af4a0)(state);
});
$4346adda79f54b9d$export$5d20f2c38fcde41f.displayName = 'DialogBody';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");







'use client';
const $6211bebe0e26a21f$export$aaff2132faac2157 = (props)=>{
    const isInsideSurfaceDialog = (0, $dfbb1f6223498329$export$6e6c677beea48331)();
    const { children: children, disableButtonEnhancement: disableButtonEnhancement = false, action: action = isInsideSurfaceDialog ? 'close' : 'open' } = props;
    const child = (0, $afe88029dd4784e4$export$8e7091920a6cd3c6)(children);
    const requestOpenChange = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.requestOpenChange);
    const { triggerAttributes: triggerAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)();
    const handleClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        var _child_props_onClick, _child_props;
        child === null || child === void 0 || (_child_props_onClick = (_child_props = child.props).onClick) === null || _child_props_onClick === void 0 || _child_props_onClick.call(_child_props, event);
        if (!event.isDefaultPrevented()) requestOpenChange({
            event: event,
            type: 'triggerClick',
            open: action === 'open'
        });
    });
    const triggerChildProps = {
        ...child === null || child === void 0 ? void 0 : child.props,
        ref: (0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child),
        onClick: handleClick,
        ...triggerAttributes
    };
    const ariaButtonTriggerChildProps = (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)((child === null || child === void 0 ? void 0 : child.type) === 'button' || (child === null || child === void 0 ? void 0 : child.type) === 'a' ? child.type : 'div', {
        ...triggerChildProps,
        type: 'button'
    });
    return {
        children: (0, $70e12b87c0533cc6$export$4ef26f87842d1b0)(children, disableButtonEnhancement ? triggerChildProps : ariaButtonTriggerChildProps)
    };
};


/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ const $2a8cf2adc5e92ade$export$cb06be6124610e3e = (state)=>state.children;


'use client';
const $16af17f31b90353f$export$2e1e1122cf0cba88 = (props)=>{
    const state = (0, $6211bebe0e26a21f$export$aaff2132faac2157)(props);
    return (0, $2a8cf2adc5e92ade$export$cb06be6124610e3e)(state);
};
$16af17f31b90353f$export$2e1e1122cf0cba88.displayName = 'DialogTrigger';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
$16af17f31b90353f$export$2e1e1122cf0cba88.isFluentTriggerComponent = true;





'use client';
const $547cf61831bf2f2a$export$95e25609c421dd8c = {
    root: 'fui-DialogTitle',
    action: 'fui-DialogTitle__action'
};
/**
 * Styles for the root slot
 */ const $547cf61831bf2f2a$var$useRootResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rxjm636", null, [
    ".rxjm636{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase500);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase500);margin:0;grid-row-start:1;grid-row-end:1;grid-column-start:1;grid-column-end:3;}"
]);
const $547cf61831bf2f2a$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    rootWithoutAction: {
        Bw0ie65: "fsyjsko"
    }
}, {
    d: [
        ".fsyjsko{grid-column-end:4;}"
    ]
});
/**
 * Styles for the action slot
 */ const $547cf61831bf2f2a$var$useActionResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r13kcrze", null, [
    ".r13kcrze{grid-row-start:1;grid-row-end:1;grid-column-start:3;justify-self:end;align-self:start;}"
]);
const $547cf61831bf2f2a$export$26ca0b2a08218f64 = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r2avt6e", "roj2bbc", {
    r: [
        ".r2avt6e{overflow:visible;padding:0;border-style:none;position:relative;box-sizing:content-box;background-color:inherit;color:inherit;font-family:inherit;font-size:inherit;cursor:pointer;line-height:0;-webkit-appearance:button;text-align:unset;}",
        ".r2avt6e:focus{outline-style:none;}",
        ".r2avt6e:focus-visible{outline-style:none;}",
        ".r2avt6e[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".r2avt6e[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".roj2bbc{overflow:visible;padding:0;border-style:none;position:relative;box-sizing:content-box;background-color:inherit;color:inherit;font-family:inherit;font-size:inherit;cursor:pointer;line-height:0;-webkit-appearance:button;text-align:unset;}",
        ".roj2bbc:focus{outline-style:none;}",
        ".roj2bbc:focus-visible{outline-style:none;}",
        ".roj2bbc[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".roj2bbc[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.r2avt6e[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media (forced-colors: active){.roj2bbc[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"
    ]
});
const $547cf61831bf2f2a$export$53944469f724c3ea = (state)=>{
    const rootResetStyles = $547cf61831bf2f2a$var$useRootResetStyles();
    const actionResetStyles = $547cf61831bf2f2a$var$useActionResetStyles();
    const styles = $547cf61831bf2f2a$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($547cf61831bf2f2a$export$95e25609c421dd8c.root, rootResetStyles, !state.action && styles.rootWithoutAction, state.root.className);
    if (state.action) // eslint-disable-next-line react-hooks/immutability
    state.action.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($547cf61831bf2f2a$export$95e25609c421dd8c.action, actionResetStyles, state.action.className);
    return state;
};


'use client';
const $24b13530e8457cf2$export$92a9d9d589e4d9c0 = (props, ref)=>{
    const { action: action } = props;
    const modalType = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.modalType);
    const internalStyles = (0, $547cf61831bf2f2a$export$26ca0b2a08218f64)();
    return {
        components: {
            root: 'h2',
            action: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('h2', {
            ref: ref,
            id: (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogTitleId),
            ...props
        }), {
            elementType: 'h2'
        }),
        action: (0, $fcf7ddccaab7fd8f$exports).optional(action, {
            renderByDefault: modalType === 'non-modal',
            defaultProps: {
                children: /*#__PURE__*/ $acw62.createElement((0, $16af17f31b90353f$export$2e1e1122cf0cba88), {
                    disableButtonEnhancement: true,
                    action: "close"
                }, /*#__PURE__*/ $acw62.createElement("button", {
                    type: "button",
                    className: internalStyles,
                    // TODO: find a better way to add internal labels
                    "aria-label": "close"
                }, /*#__PURE__*/ $acw62.createElement((0, $cdb0ff5c001a8842$export$5b53e1eb03c72ac3), null)))
            },
            elementType: 'div'
        })
    };
};



var $acw62 = parcelRequire("acw62");

const $113c24d46ee00056$export$aed664116b015c62 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
                children: state.root.children
            }),
            state.action && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.action, {})
        ]
    });
};




'use client';
const $dce7a536101527d5$export$16f7638e4a34b909 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $24b13530e8457cf2$export$92a9d9d589e4d9c0)(props, ref);
    (0, $547cf61831bf2f2a$export$53944469f724c3ea)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogTitleStyles_unstable')(state);
    return (0, $113c24d46ee00056$export$aed664116b015c62)(state);
});
$dce7a536101527d5$export$16f7638e4a34b909.displayName = 'DialogTitle';


var $acw62 = parcelRequire("acw62");

const $bd254132865b1d8d$export$b209aee26b208fc6 = (props, ref)=>{
    var _props_as;
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : 'div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        })
    };
};




const $7361310cd8aacfc1$export$7d851008e12de2a6 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};





'use client';
const $e801766fd42220d0$export$a1e658fc8a74c104 = {
    root: 'fui-DialogContent'
};
/**
 * Styles for the root slot
 */ const $e801766fd42220d0$var$useStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1v5zwsm", null, {
    r: [
        ".r1v5zwsm{padding:var(--strokeWidthThick);margin:calc(var(--strokeWidthThick) * -1);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);overflow-y:auto;min-height:32px;box-sizing:border-box;grid-row-start:2;grid-row-end:2;grid-column-start:1;grid-column-end:4;}"
    ],
    s: [
        "@media screen and (max-height: 359px){.r1v5zwsm{overflow-y:unset;}}"
    ]
});
const $e801766fd42220d0$export$5884e4da3aea1523 = (state)=>{
    const styles = $e801766fd42220d0$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($e801766fd42220d0$export$a1e658fc8a74c104.root, styles, state.root.className);
    return state;
};



'use client';
const $330458ead2ba66c5$export$b6d9565de1e068cf = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $bd254132865b1d8d$export$b209aee26b208fc6)(props, ref);
    (0, $e801766fd42220d0$export$5884e4da3aea1523)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogContentStyles_unstable')(state);
    return (0, $7361310cd8aacfc1$export$7d851008e12de2a6)(state);
});
$330458ead2ba66c5$export$b6d9565de1e068cf.displayName = 'DialogContent';


var $acw62 = parcelRequire("acw62");

const $b47b647faf3f8791$export$13bf030b9400d05d = (props, ref)=>{
    const { position: position = 'end', fluid: fluid = false } = props;
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        position: position,
        fluid: fluid
    };
};




const $9aaf3b8fcc1f4be9$export$ee061f47be9b8c80 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    // TODO Add additional slots in the appropriate place
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};




'use client';
const $dd17e3174906cc80$export$69259980d62f092a = {
    root: 'fui-DialogActions'
};
/**
 * Styles for the root slot
 */ const $dd17e3174906cc80$var$useResetStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rhfpeu0", null, {
    r: [
        ".rhfpeu0{gap:8px;height:fit-content;box-sizing:border-box;display:flex;grid-row-start:3;grid-row-end:3;}"
    ],
    s: [
        "@media screen and (max-width: 480px){.rhfpeu0{flex-direction:column;justify-self:stretch;}}"
    ]
});
const $dd17e3174906cc80$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    gridPositionEnd: {
        Bdqf98w: "f1a7i8kp",
        Br312pm: "fd46tj4",
        Bw0ie65: "fsyjsko",
        Btsd7tp: "f1n00o3b",
        ufxxby: "f1mvsp37",
        Bq5p579: "flbz1vp"
    },
    gridPositionStart: {
        Bdqf98w: "fsxvdwy",
        Br312pm: "fwpfdsa",
        Bw0ie65: "f1e2fz10",
        Ew0qkd: "f119phc2",
        ufxxby: "f1j719yo",
        Bq5p579: "flbz1vp"
    },
    fluidStart: {
        Bw0ie65: "fsyjsko"
    },
    fluidEnd: {
        Br312pm: "fwpfdsa"
    }
}, {
    d: [
        ".f1a7i8kp{justify-self:end;}",
        ".fd46tj4{grid-column-start:2;}",
        ".fsyjsko{grid-column-end:4;}",
        ".fsxvdwy{justify-self:start;}",
        ".fwpfdsa{grid-column-start:1;}",
        ".f1e2fz10{grid-column-end:2;}"
    ],
    m: [
        [
            "@media screen and (max-width: 480px){.f1n00o3b{grid-column-start:1;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f1mvsp37{grid-row-start:4;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.flbz1vp{grid-row-end:auto;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f119phc2{grid-column-end:4;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f1j719yo{grid-row-start:3;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ]
    ]
});
const $dd17e3174906cc80$export$ab3fd2ac246c300d = (state)=>{
    const resetStyles = $dd17e3174906cc80$var$useResetStyles();
    const styles = $dd17e3174906cc80$var$useStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($dd17e3174906cc80$export$69259980d62f092a.root, resetStyles, state.position === 'start' && styles.gridPositionStart, state.position === 'end' && styles.gridPositionEnd, state.fluid && state.position === 'start' && styles.fluidStart, state.fluid && state.position === 'end' && styles.fluidEnd, state.root.className);
    return state;
};



'use client';
const $97e7a40f84d593e3$export$702322f34446412d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $b47b647faf3f8791$export$13bf030b9400d05d)(props, ref);
    (0, $dd17e3174906cc80$export$ab3fd2ac246c300d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogActionsStyles_unstable')(state);
    return (0, $9aaf3b8fcc1f4be9$export$ee061f47be9b8c80)(state);
});
$97e7a40f84d593e3$export$702322f34446412d.displayName = 'DialogActions';


parcelRequire("acw62");
function $f67322f150798dc8$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, triggerReassignApiKey: triggerReassignApiKey }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $432da315193df471$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (_, o)=>setOpen(o.open),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73cdd34c0b870187$export$8d5c5a60a915d482), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4346adda79f54b9d$export$5d20f2c38fcde41f), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dce7a536101527d5$export$16f7638e4a34b909), {
                        children: "Reassign API Key"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $330458ead2ba66c5$export$b6d9565de1e068cf), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Are you sure you want to reassign your API key? This will invalidate your current API key and generate a new one."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "After reassigning your API key, you will need to update any applications or services that use the API key with the new key."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Are you sure you want to proceed?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $97e7a40f84d593e3$export$702322f34446412d), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                appearance: "secondary",
                                onClick: ()=>setOpen(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                appearance: "primary",
                                onClick: ()=>{
                                    setOpen(false);
                                    triggerReassignApiKey();
                                },
                                children: "Reassign"
                            })
                        ]
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");



'use client';
const $ac5ff3f11196647f$export$63d99ff302464fbd = (props, ref)=>{
    const { scrollState: scrollState } = (0, $f151dc37217d3a88$export$6bc0175b947a255a)();
    return {
        components: {
            root: 'header'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('header', {
            ref: ref,
            role: 'none',
            ...props
        }), {
            elementType: 'header'
        }),
        scrollState: scrollState
    };
};




const $bf0f3d48bc511df6$export$8c011db91bd9a1b3 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};





'use client';
const $c9788b06fe0c4d8f$export$461d39bbbc56a54 = {
    root: 'fui-DrawerHeader'
};
/**
 * Styles for the root slot
 */ const $c9788b06fe0c4d8f$var$useStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r3ovn4i", null, [
    ".r3ovn4i{width:100%;max-width:100%;padding:var(--spacingVerticalXXL) var(--spacingHorizontalXXL) var(--spacingVerticalS);gap:var(--spacingHorizontalS);align-self:stretch;display:flex;flex-direction:column;box-sizing:border-box;position:relative;z-index:2;}"
]);
const $c9788b06fe0c4d8f$var$useDrawerHeaderStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    separator: {
        Dlnsje: "fxnjyrl",
        E3zdtr: "f1mdlcz9",
        B1piin3: [
            "f15yvnhg",
            "f1n6gb5g"
        ],
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        Bp15pi3: "f1564nw5",
        Bjyk6c5: "fdlpgxj",
        F2fol1: "f15cmg8x",
        Ba2ppi3: "f3f8dgl",
        B1dyfl9: "fjvo4va",
        Bsft5z2: "f13zj6fq",
        By385i5: "fo72kxq"
    },
    separatorVisible: {
        Bp15pi3: "fjsqi2x"
    }
}, {
    d: [
        ".fxnjyrl::after{height:1px;}",
        ".f1mdlcz9::after{position:absolute;}",
        ".f15yvnhg::after{right:0;}",
        ".f1n6gb5g::after{left:0;}",
        ".f1564nw5::after{opacity:0;}",
        ".fdlpgxj::after{background-color:var(--colorNeutralStroke1);}",
        ".f15cmg8x::after{transition-duration:var(--durationNormal);}",
        ".f3f8dgl::after{transition-property:opacity;}",
        ".fjvo4va::after{transition-timing-function:var(--curveEasyEase);}",
        ".f13zj6fq::after{content:\"\";}",
        ".fo72kxq::after{bottom:0;}",
        ".fjsqi2x::after{opacity:1;}"
    ]
});
const $c9788b06fe0c4d8f$export$a378900b2b6317b1 = (state)=>{
    const styles = $c9788b06fe0c4d8f$var$useStyles();
    const rootStyles = $c9788b06fe0c4d8f$var$useDrawerHeaderStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($c9788b06fe0c4d8f$export$461d39bbbc56a54.root, styles, state.scrollState !== 'none' && rootStyles.separator, [
        'middle',
        'bottom'
    ].includes(state.scrollState) && rootStyles.separatorVisible, state.root.className);
    return state;
};


'use client';
const $ae4c07f2c38b246f$export$bb68d554ded258ea = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $ac5ff3f11196647f$export$63d99ff302464fbd)(props, ref);
    (0, $c9788b06fe0c4d8f$export$a378900b2b6317b1)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerHeaderStyles_unstable')(state);
    return (0, $bf0f3d48bc511df6$export$8c011db91bd9a1b3)(state);
});
$ae4c07f2c38b246f$export$bb68d554ded258ea.displayName = 'DrawerHeader';


var $acw62 = parcelRequire("acw62");



'use client';
const $07e458c7c414b445$export$ff1e0627b28e3ef8 = (props, ref)=>{
    const { children: children, heading: heading } = props;
    const headingId = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogTitleId);
    return {
        components: {
            root: 'div',
            heading: 'h2',
            action: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        heading: (0, $fcf7ddccaab7fd8f$exports).optional(heading, {
            defaultProps: {
                id: headingId,
                children: children
            },
            renderByDefault: true,
            elementType: 'h2'
        }),
        action: (0, $fcf7ddccaab7fd8f$exports).optional(props.action, {
            elementType: 'div'
        })
    };
};




const $e268f2d910515b0d$export$cf33c83f19f49f9c = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.heading && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.heading, {}),
            state.action && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.action, {})
        ]
    });
};





'use client';
const $75524aa159389f5c$export$9628a68ee15994af = {
    root: 'fui-DrawerHeaderTitle',
    heading: 'fui-DrawerHeaderTitle__heading',
    action: 'fui-DrawerHeaderTitle__action'
};
/**
 * Styles for the root slot
 */ const $75524aa159389f5c$var$useStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Brf1p80: "f1869bpl",
        Bt984gj: "f122n59",
        i8kkvl: "fsnqrgy"
    },
    action: {
        t21cq0: [
            "faqnl2i",
            "fd75udd"
        ]
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1869bpl{justify-content:space-between;}",
        ".f122n59{align-items:center;}",
        ".fsnqrgy{column-gap:var(--spacingHorizontalS);}",
        ".faqnl2i{margin-right:calc(var(--spacingHorizontalS) * -1);}",
        ".fd75udd{margin-left:calc(var(--spacingHorizontalS) * -1);}"
    ]
});
const $75524aa159389f5c$export$7e5b995ae702e2bd = (state)=>{
    const styles = $75524aa159389f5c$var$useStyles();
    const { heading: root = {}, action: action, components: // We should not use components to pass along the base element type of a slot
    // but there's no way to retrieve the element type of a slot from the slot definition
    // right now without using SLOT_ELEMENT_TYPE_SYMBOL
    // TODO: create a method to retrieve the element type of a slot
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    components } = state;
    (0, $547cf61831bf2f2a$export$53944469f724c3ea)({
        components: {
            root: components.heading,
            action: components.action
        },
        root: root,
        action: action
    });
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75524aa159389f5c$export$9628a68ee15994af.root, styles.root, state.root.className);
    if (state.heading) // eslint-disable-next-line react-hooks/immutability
    state.heading.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75524aa159389f5c$export$9628a68ee15994af.heading, state.heading.className);
    if (state.action) // eslint-disable-next-line react-hooks/immutability
    state.action.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($75524aa159389f5c$export$9628a68ee15994af.action, styles.action, state.action.className);
    return state;
};


'use client';
const $eda29ab885160de0$export$6da407429c3f8c47 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $07e458c7c414b445$export$ff1e0627b28e3ef8)(props, ref);
    (0, $75524aa159389f5c$export$7e5b995ae702e2bd)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerHeaderTitleStyles_unstable')(state);
    return (0, $e268f2d910515b0d$export$cf33c83f19f49f9c)(state);
});
$eda29ab885160de0$export$6da407429c3f8c47.displayName = 'DrawerHeaderTitle';


var $acw62 = parcelRequire("acw62");




'use client';
const $f5e8463007004c1c$export$4ed8420cdfcb2b8f = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $2abaef046fa13d36$export$6a26f58f74b50a9d)(props, ref);
    (0, $5587c668c918896f$export$a8517da7716688b)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerBodyStyles_unstable')(state);
    return (0, $e1fe6f2b1830352c$export$fe16988d8e0e4b7b)(state);
});
$f5e8463007004c1c$export$4ed8420cdfcb2b8f.displayName = 'DrawerBody';


var $acw62 = parcelRequire("acw62");



const $4d5b4ab865de1c76$export$2f31a63ba95206a0 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    let { children: children } = state;
    if (typeof children === 'function') children = children((0, $af5cf4826b6cd175$export$6628ce0d0b903197)(contextValues.field) || {});
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $9be8a0b8d40bba68$export$f9a33f37cefdc55a), {
        value: contextValues === null || contextValues === void 0 ? void 0 : contextValues.field,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
            children: [
                state.label && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {}),
                children,
                state.validationMessage && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.validationMessage, {
                    children: [
                        state.validationMessageIcon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.validationMessageIcon, {}),
                        state.validationMessage.children
                    ]
                }),
                state.hint && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.hint, {})
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
const $f342bb1007016cbf$export$a04dda7950a04245 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat16Filled', "16", [
    "M4.66 15H3.63a2.64 2.64 0 0 1-1.93-4.44l.8-.86a2.2 2.2 0 0 0-.05-3.02l-.79-.79a.5.5 0 0 1 .71-.7l.78.78a3.2 3.2 0 0 1 .08 4.41l-.8.86A1.64 1.64 0 0 0 3.64 14h.5a17 17 0 0 1 .36-3.57 7 7 0 0 1 1.33-2.92 3.8 3.8 0 0 1 2.54-1.39V3.2c0-1.21.98-2.19 2.19-2.19.5 0 .92.41.92.92v.49h1.18c.66 0 1.27.34 1.62.9l.43.7a1.9 1.9 0 0 1-1.47 2.9v6.54c0 .85-.7 1.55-1.56 1.55h-.55v-1.55a2.6 2.6 0 0 0-2.6-2.61h-.89a.5.5 0 0 0 0 1h.88c.89 0 1.61.72 1.61 1.6V15z"
]);
const $f342bb1007016cbf$export$dda9ead96011c62e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat16Regular', "16", [
    "M3.64 15h8.04c.86 0 1.56-.7 1.56-1.55V6.9a1.9 1.9 0 0 0 1.47-2.9l-.43-.7a1.9 1.9 0 0 0-1.62-.9h-1.18v-.49c0-.5-.41-.92-.92-.92-1.2 0-2.19.98-2.19 2.19v2.93c-1.1.13-1.93.65-2.54 1.39a7 7 0 0 0-1.33 2.92A15 15 0 0 0 4.14 14h-.5a1.64 1.64 0 0 1-1.2-2.76l.8-.86a3.2 3.2 0 0 0-.08-4.41l-.78-.78a.5.5 0 1 0-.7.7l.78.79A2.2 2.2 0 0 1 2.5 9.7l-.8.86A2.64 2.64 0 0 0 3.64 15m6.84-13v.9c0 .28.22.5.5.5h1.68c.31 0 .6.17.77.43l.43.7a.9.9 0 0 1-.77 1.39h-.35a.5.5 0 0 0-.5.5v7.03c0 .3-.25.55-.56.55h-.55v-.55a2.6 2.6 0 0 0-2.6-2.61h-.89a.5.5 0 0 0 0 1h.88c.89 0 1.61.72 1.61 1.6V14H5.14a16 16 0 0 1 .34-3.34c.22-.95.57-1.85 1.12-2.51a2.8 2.8 0 0 1 2.27-1.06.5.5 0 0 0 .5-.5V3.2c0-.63.5-1.15 1.11-1.19"
]);
const $f342bb1007016cbf$export$62997fe64f4fc55f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat20Filled', "20", [
    "M4.97 18H13v-1.5a2.5 2.5 0 0 0-2.5-2.5h-1a.5.5 0 0 1 0-1h1a3.5 3.5 0 0 1 3.5 3.5V18h.25c.47 0 .9-.2 1.21-.5h.04v-.04q.45-.47.47-1.18v-7.6a2.12 2.12 0 0 0 1.7-3.24l-.5-.81c-.38-.63-1.06-1-1.8-1h-1.43v-.64a1 1 0 0 0-.99-.99 2.45 2.45 0 0 0-2.44 2.45V7.9a4.3 4.3 0 0 0-2.95 1.58 7 7 0 0 0-1.04 1.8q-.35.7-.47 1.49l-.01.06A17 17 0 0 0 5.63 17h-.66a1.97 1.97 0 0 1-1.44-3.32l.92-.98a3.6 3.6 0 0 0-.09-4.99l-.9-.9a.5.5 0 1 0-.7.7l.9.9a2.6 2.6 0 0 1 .06 3.6l-.92 1A2.97 2.97 0 0 0 4.97 18"
]);
const $f342bb1007016cbf$export$c3f4678c9f6c65a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat20Regular', "20", [
    "M4.97 18h9.28c.95 0 1.72-.77 1.72-1.72v-7.6a2.12 2.12 0 0 0 1.7-3.24l-.5-.81c-.38-.63-1.06-1-1.8-1h-1.43v-.64a1 1 0 0 0-.99-.99 2.45 2.45 0 0 0-2.44 2.45V7.9a4.3 4.3 0 0 0-2.95 1.58 8 8 0 0 0-1.52 3.35A17 17 0 0 0 5.63 17h-.66a1.97 1.97 0 0 1-1.44-3.32l.92-.98a3.6 3.6 0 0 0-.09-4.99l-.9-.9a.5.5 0 1 0-.7.7l.9.9a2.6 2.6 0 0 1 .06 3.6l-.92 1A2.97 2.97 0 0 0 4.97 18m7.97-15v1.12c0 .28.22.5.5.5h1.93c.4 0 .75.2.96.53l.5.81c.46.75-.08 1.72-.95 1.72h-.41a.5.5 0 0 0-.5.5v8.1c0 .4-.32.72-.72.72h-.72v-.72a2.93 2.93 0 0 0-2.93-2.93H9.6a.5.5 0 0 0 0 1h1.01c1.07 0 1.93.87 1.93 1.93V17h-5.9A18 18 0 0 1 7 13.05c.26-1.1.67-2.16 1.32-2.93A3.3 3.3 0 0 1 11 8.88a.5.5 0 0 0 .5-.5V4.45c0-.8.64-1.44 1.43-1.45"
]);
const $f342bb1007016cbf$export$b8f8bf7e1e9e7fd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat24Filled', "24", [
    "M7.25 22H5.8a3.8 3.8 0 0 1-2.78-6.39l1.14-1.22a3.06 3.06 0 0 0-.08-4.25L2.97 9.03a.75.75 0 0 1 1.06-1.06l1.11 1.11a4.56 4.56 0 0 1 .11 6.34l-1.13 1.21A2.3 2.3 0 0 0 5.8 20.5h.67A24 24 0 0 1 7 15.45c.34-1.46.91-3 1.9-4.17a5.4 5.4 0 0 1 3.6-1.99V5.15A3.15 3.15 0 0 1 15.64 2C16.4 2 17 2.6 17 3.35V4h1.64c.95 0 1.83.5 2.33 1.3l.62 1a2.75 2.75 0 0 1-2.09 4.19v9.26c0 1.24-1 2.25-2.25 2.25h-.75v-2.25A3.75 3.75 0 0 0 12.74 16H11.5a.75.75 0 0 0 0 1.5h1.25c1.25 0 2.25 1 2.25 2.25V22z"
]);
const $f342bb1007016cbf$export$54ebfc9fa6e5f44a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat24Regular', "24", [
    "M15.5 3.5c-.85.08-1.5.79-1.5 1.65V10c0 .41-.34.75-.76.75-1.44 0-2.45.59-3.2 1.49a9 9 0 0 0-1.6 3.56 20 20 0 0 0-.47 4.7H15v-.75c0-1.24-1-2.25-2.25-2.25H11.5a.75.75 0 0 1 0-1.5h1.25a3.75 3.75 0 0 1 3.75 3.75v.75h.75c.42 0 .75-.34.75-.75v-10c0-.41.34-.75.75-.75h.5c.99 0 1.58-1.08 1.07-1.9l-.62-1c-.23-.38-.63-.6-1.06-.6h-2.39a.75.75 0 0 1-.75-.75zm-9.03 17A24 24 0 0 1 7 15.45c.34-1.46.91-3 1.9-4.17a5.4 5.4 0 0 1 3.6-1.99V5.15A3.15 3.15 0 0 1 15.64 2C16.4 2 17 2.6 17 3.35V4h1.64c.95 0 1.83.5 2.33 1.3l.62 1a2.75 2.75 0 0 1-2.09 4.19v9.26c0 1.24-1 2.25-2.25 2.25H5.8a3.8 3.8 0 0 1-2.78-6.39l1.14-1.22a3.06 3.06 0 0 0-.08-4.25L2.97 9.03a.75.75 0 0 1 1.06-1.06l1.11 1.11a4.56 4.56 0 0 1 .11 6.34l-1.13 1.21A2.3 2.3 0 0 0 5.8 20.5z"
]);
const $f342bb1007016cbf$export$535f1c8239245ae4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat28Filled', "28", [
    "M17.8 26H6.46a4.46 4.46 0 0 1-3.26-7.5l1.38-1.48a3.9 3.9 0 0 0-.1-5.4l-1.35-1.35A.75.75 0 0 1 4.2 9.21l1.36 1.36a5.4 5.4 0 0 1 .12 7.47L4.3 19.52a2.96 2.96 0 0 0 2.17 4.98h.98a29 29 0 0 1 .62-6.26c.41-1.77 1.1-3.6 2.28-5.01a6.4 6.4 0 0 1 4.42-2.38V5.67A3.67 3.67 0 0 1 18.43 2c.82 0 1.48.66 1.48 1.48v.95h2.15c1.1 0 2.12.57 2.7 1.5l.76 1.22a3.18 3.18 0 0 1-2.57 4.86v11.42A2.57 2.57 0 0 1 20.38 26H19.3v-2.57a4.4 4.4 0 0 0-4.4-4.4H13.4a.75.75 0 0 0 0 1.5h1.51c1.6 0 2.9 1.3 2.9 2.9z"
]);
const $f342bb1007016cbf$export$7f9c014df0153c8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalCat28Regular', "28", [
    "M8.52 26h11.86a2.57 2.57 0 0 0 2.57-2.57V12a3.18 3.18 0 0 0 2.57-4.86l-.76-1.21a3.2 3.2 0 0 0-2.7-1.5h-2.15v-.96c0-.82-.66-1.48-1.48-1.48a3.67 3.67 0 0 0-3.67 3.67v5.18a6.4 6.4 0 0 0-4.42 2.38 12 12 0 0 0-2.28 5 26 26 0 0 0-.62 6.27h-.99a2.96 2.96 0 0 1-2.16-4.98l1.38-1.48a5.4 5.4 0 0 0-.12-7.47L4.19 9.2a.75.75 0 1 0-1.06 1.06l1.36 1.36a3.9 3.9 0 0 1 .09 5.4L3.2 18.5A4.46 4.46 0 0 0 6.46 26zm9.89-22.5v1.68c0 .42.34.75.75.75h2.9c.58 0 1.12.3 1.43.8l.75 1.21a1.68 1.68 0 0 1-1.43 2.57h-.61a.75.75 0 0 0-.75.75v12.17c0 .59-.48 1.07-1.07 1.07H19.3v-1.07a4.4 4.4 0 0 0-4.4-4.4H13.4a.75.75 0 0 0 0 1.5h1.51c1.6 0 2.9 1.3 2.9 2.9v1.07H8.94a27 27 0 0 1 .58-5.92c.39-1.66 1-3.24 1.97-4.4a5 5 0 0 1 4.02-1.86c.42 0 .75-.34.75-.75v-5.9c0-1.2.96-2.16 2.15-2.17"
]);
const $f342bb1007016cbf$export$49fe95f58f5c515d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDog16Filled', "16", [
    "M4 14c.31 0 .56-.15.73-.37.2-.24.27-.51.27-.63 0-.7.03-1.5.19-2.25.15-.75.42-1.5.94-2.08.45-.51.91-1.1 1.27-1.9q.34-.75.51-1.89A1.5 1.5 0 0 0 10 3.5a.5.5 0 0 0-1 0 .5.5 0 0 1-1 0v-1C8 1.67 8.67 1 9.5 1h1.22q.41 0 .77.21l1.78 1.07c.45.27.73.76.73 1.29v.93c0 .83-.67 1.5-1.5 1.5H12v6.05a2.5 2.5 0 0 1 2 2.45.5.5 0 0 1-.5.5H11v-.5c0-.82-.4-1.54-1-2v-2a.5.5 0 0 0-1 0v1.55a3 3 0 0 0-.5-.05H8a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 1.5 1.5v.5H3.75a2.75 2.75 0 0 1-1.53-5.04.5.5 0 1 1 .56.83A1.75 1.75 0 0 0 3.75 14z"
]);
const $f342bb1007016cbf$export$e41dfb69d5104858 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDog16Regular', "16", [
    "M9.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0 .5.5 0 0 1 1 0 1.5 1.5 0 0 1-2.08 1.38q-.18 1.35-.6 2.3c-.42.94-.96 1.6-1.45 2.15a3.4 3.4 0 0 0-.7 1.61C6.03 11.6 6 12.33 6 13c0 .3-.11.67-.31 1H9.9a1.5 1.5 0 0 0-1.41-1H8a.5.5 0 0 1 0-1h.5q.26 0 .5.05V10.5a.5.5 0 0 1 1 0v2c.48.36.83.89.95 1.5h1.96c-.2-.58-.76-1-1.41-1a.5.5 0 0 1-.5-.5v-7c0-.28.22-.5.5-.5h1a.5.5 0 0 0 .5-.5v-.93a.5.5 0 0 0-.24-.43l-1.78-1.07a1 1 0 0 0-.26-.07zM4 14c.31 0 .56-.15.73-.37.2-.24.27-.51.27-.63 0-.7.03-1.5.19-2.25.15-.75.42-1.5.94-2.08.45-.51.91-1.1 1.27-1.9.35-.79.6-1.83.6-3.27v-1C8 1.67 8.67 1 9.5 1h1.22q.41 0 .77.21l1.78 1.07c.45.27.73.76.73 1.29v.93c0 .83-.67 1.5-1.5 1.5H12v6.05a2.5 2.5 0 0 1 2 2.45.5.5 0 0 1-.5.5H3.75a2.75 2.75 0 0 1-1.53-5.04.5.5 0 1 1 .56.83A1.75 1.75 0 0 0 3.75 14z"
]);
const $f342bb1007016cbf$export$3d270e356dea3e1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDog20Filled', "20", [
    "M12 2c-.33 0-.81.1-1.23.4-.44.31-.77.84-.77 1.6v1.25c0 .13.04.34.16.5.09.12.25.25.59.25s.5-.13.6-.26a1 1 0 0 0 .15-.49.5.5 0 1 1 1 0c0 .3-.08.71-.35 1.08-.28.39-.74.67-1.4.67q-.49 0-.82-.18a6.5 6.5 0 0 1-1.78 3.83 7.5 7.5 0 0 0-1.89 3.48A9 9 0 0 0 6 15.95v.08a1 1 0 0 1-.13.5 1 1 0 0 1-.28.32q-.17.13-.59.15a2 2 0 0 1-1.2-3.6.5.5 0 1 0-.6-.8A3 3 0 0 0 5 18h8v-.5c0-.4-.19-1.05-.73-1.33q-.28-.16-.77-.17h-1a.5.5 0 0 1 0-1h1q.26 0 .5.04V12.5a.5.5 0 0 1 1 0v2.95c.79.57 1 1.52 1 2.05v.5h2.5a.5.5 0 0 0 .5-.5c0-.87-.3-1.52-.8-1.95q-.55-.43-1.2-.51V7h.5c.83 0 1.5-.67 1.5-1.5V4.28a1 1 0 0 0-.49-.85l-1.78-1.07A2.5 2.5 0 0 0 13.45 2z"
]);
const $f342bb1007016cbf$export$108facc3ba1ff097 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDog20Regular', "20", [
    "M10.77 2.4c.42-.3.9-.4 1.23-.4h1.45q.7 0 1.28.36l1.78 1.07c.3.18.49.5.49.85V5.5c0 .83-.67 1.5-1.5 1.5H15v8.04q.64.08 1.2.51c.5.43.8 1.08.8 1.95a.5.5 0 0 1-.5.5H5a3 3 0 0 1-1.8-5.4.5.5 0 0 1 .6.8A2 2 0 0 0 5 17q.42-.02.59-.15.18-.13.28-.32A1 1 0 0 0 6 16v-.05l.03-.5c.04-.33.1-.8.23-1.32.27-1.05.8-2.4 1.89-3.48C9.99 8.8 10 6.33 10 5.5V4c0-.76.33-1.29.77-1.6m.15 4.5a7.5 7.5 0 0 1-2.07 4.45 6.5 6.5 0 0 0-1.61 3.02 8 8 0 0 0-.24 1.6v.06l-.03.29a2 2 0 0 1-.22.68h6.17c-.1-.32-.3-.65-.65-.83q-.28-.16-.77-.17h-1a.5.5 0 0 1 0-1h1q.26 0 .5.04V12.5a.5.5 0 0 1 1 0v2.95c.58.42.85 1.04.95 1.55h2a1.2 1.2 0 0 0-.4-.68A1.6 1.6 0 0 0 14.5 16a.5.5 0 0 1-.5-.5v-9c0-.28.22-.5.5-.5h1a.5.5 0 0 0 .5-.5V4.28l-1.78-1.07a1.5 1.5 0 0 0-.77-.21H12c-.17 0-.44.06-.65.2-.18.14-.35.36-.35.8v1.5c0 .09.03.23.1.33.06.08.16.17.4.17s.34-.09.4-.17c.07-.1.1-.24.1-.33a.5.5 0 0 1 1 0c0 .25-.07.6-.3.92-.24.33-.64.58-1.2.58q-.32 0-.58-.1M7 16h-.5Z"
]);
const $f342bb1007016cbf$export$d364fdb9eb8ea3dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDog24Filled', "24", [
    "M10.88 8.66q.57.34 1.37.34c.84 0 1.55-.3 2.04-.84.48-.53.7-1.22.7-1.91a.75.75 0 0 0-1.5 0q0 .58-.3.9c-.18.19-.48.35-.94.35s-.73-.16-.92-.37q-.28-.32-.33-.84V4.25C11 3.01 12 2 13.25 2h3.18q.78 0 1.45.4l2.76 1.71c.22.14.36.38.36.64v1.5c0 1.24-1 2.25-2.25 2.25h-.25v9.53c.92.1 1.62.37 2.05.97q.36.56.4 1.13.06.54.05 1.09v.03c0 .41-.34.75-.75.75H17v-.77c0-.58 0-2.21-1.5-3.17v-2.8a.75.75 0 0 0-1.5 0v2.26a5 5 0 0 0-.7-.02h-.09a.75.75 0 1 0 .08 1.5h.21a2 2 0 0 1 .93.18c1.04.48 1.07 1.44 1.07 2.07V22H5.83a3.83 3.83 0 0 1-1.97-7.12.75.75 0 0 1 .78 1.28 2.33 2.33 0 0 0 1.2 4.34q.45-.02.64-.18.21-.15.33-.4a2 2 0 0 0 .19-.7v-.03l.03-.65c.04-.43.1-1.02.23-1.68.26-1.29.8-2.97 1.96-4.14a6.5 6.5 0 0 0 1.54-3.36z"
]);
const $f342bb1007016cbf$export$1e781d01800a844c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalDog24Regular', "24", [
    "M13.25 2h3.18q.78 0 1.45.4l2.76 1.71c.22.14.36.38.36.64v1.5c0 1.24-1 2.25-2.25 2.25h-.25v9.05q1.5.2 2.1 1.27c.22.4.31.84.36 1.25.04.39.04.8.04 1.15v.03c0 .41-.34.75-.75.75H5.83a3.83 3.83 0 0 1-1.97-7.12.75.75 0 0 1 .78 1.28 2.33 2.33 0 0 0 1.2 4.34q.45-.02.64-.18.21-.15.33-.4a2 2 0 0 0 .19-.7v-.03l.03-.65c.04-.43.1-1.02.23-1.68.26-1.29.8-2.97 1.96-4.14a6.5 6.5 0 0 0 1.54-3.36C11 8.13 11 7 11 6.5V4.25C11 3.01 12 2 13.25 2m-5.5 17.25.75.03v.04l-.05.38q-.06.33-.25.8h7.25a1.7 1.7 0 0 0-1.5-1.45 5 5 0 0 0-.98-.05h-.2a.75.75 0 1 1-.03-1.5h.51q.36-.01.75.04v-2.29a.75.75 0 0 1 1.5 0v2.8a3.2 3.2 0 0 1 1.46 2.45h2.53l-.02-.27q-.06-.45-.19-.68c-.13-.23-.43-.55-1.53-.55a.75.75 0 0 1-.75-.75V7.75c0-.41.34-.75.75-.75h1c.41 0 .75-.34.75-.75V5.17l-2.41-1.48q-.3-.2-.66-.19h-3.18a.75.75 0 0 0-.75.75v2.23q.03.36.2.56c.1.11.27.21.55.21s.45-.1.56-.22q.18-.2.19-.58a.75.75 0 0 1 1.5 0c0 .55-.18 1.13-.57 1.57-.4.46-.98.73-1.68.73q-.47 0-.86-.15-.04.5-.15 1.04a8 8 0 0 1-1.96 4.14 7 7 0 0 0-1.54 3.38 13 13 0 0 0-.24 2.06v.06zm8.5 2.75v-.75Z"
]);
const $f342bb1007016cbf$export$6cf812210def5c3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_16_color__a)",
            "d": "M8 7a5 5 0 0 0-5 5c0 1.3 1.21 2 2.29 2h5.42c1.08 0 2.29-.7 2.29-2a5 5 0 0 0-5-5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_16_color__b)",
            "d": "M8.5 3.88c0-.94.64-1.88 1.63-1.88s1.62.94 1.62 1.88-.64 1.87-1.62 1.87c-1 0-1.63-.94-1.63-1.87m-6.12.37c-1 0-1.63.94-1.63 1.88S1.39 8 2.38 8 4 7.06 4 6.13s-.64-1.88-1.62-1.88m11.25 0c-1 0-1.63.94-1.63 1.88S12.64 8 13.63 8s1.62-.94 1.62-1.87-.64-1.88-1.62-1.88M5.87 2c-.98 0-1.62.94-1.62 1.88s.64 1.87 1.63 1.87S7.5 4.81 7.5 3.88 6.86 2 5.88 2"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -7.71429 11.6 0 8.4 8.43)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_16_color__a",
                "x1": "5.38",
                "x2": "8.29",
                "y1": "7.93",
                "y2": "14.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$933a4f334461d44b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint16Filled', "16", [
    "M8.5 3.88c0-.94.64-1.88 1.63-1.88s1.62.94 1.62 1.88-.64 1.87-1.62 1.87c-1 0-1.63-.94-1.63-1.87m-6.12.37c-1 0-1.63.94-1.63 1.88S1.39 8 2.38 8 4 7.06 4 6.13s-.64-1.88-1.62-1.88m11.25 0c-1 0-1.63.94-1.63 1.88S12.64 8 13.63 8s1.62-.94 1.62-1.87-.64-1.88-1.62-1.88M5.87 2c-.98 0-1.62.94-1.62 1.88s.64 1.87 1.63 1.87S7.5 4.81 7.5 3.88 6.86 2 5.88 2M8 7a5 5 0 0 0-5 5c0 1.3 1.21 2 2.29 2h5.42c1.08 0 2.29-.7 2.29-2a5 5 0 0 0-5-5"
]);
const $f342bb1007016cbf$export$967c1f16e077b0e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint16Regular', "16", [
    "M9.5 3.88c0-.59.37-.88.63-.88.25 0 .62.3.62.88s-.37.87-.62.87c-.26 0-.63-.3-.63-.87M10.13 2c-1 0-1.63.94-1.63 1.88s.64 1.87 1.63 1.87 1.62-.94 1.62-1.87S11.11 2 10.13 2M2.37 5.25c-.25 0-.62.3-.62.88s.37.87.63.87c.25 0 .62-.3.62-.87 0-.59-.37-.88-.62-.88m-1.62.88c0-.94.64-1.88 1.63-1.88S4 5.19 4 6.13 3.36 8 2.38 8c-1 0-1.63-.94-1.63-1.87m12.88-.88c-.26 0-.63.3-.63.88s.37.87.63.87c.25 0 .62-.3.62-.87 0-.59-.37-.88-.62-.88M12 6.13c0-.94.64-1.88 1.63-1.88s1.62.94 1.62 1.88S14.61 8 13.63 8c-1 0-1.63-.94-1.63-1.87M5.88 3c-.26 0-.63.3-.63.88s.37.87.63.87c.25 0 .62-.3.62-.87 0-.59-.37-.88-.62-.88m-1.63.88c0-.94.64-1.88 1.63-1.88s1.62.94 1.62 1.88-.64 1.87-1.62 1.87c-1 0-1.63-.94-1.63-1.87M4 12a4 4 0 1 1 8 0c0 .53-.53 1-1.29 1H5.3C4.53 13 4 12.53 4 12m4-5a5 5 0 0 0-5 5c0 1.3 1.21 2 2.29 2h5.42c1.08 0 2.29-.7 2.29-2a5 5 0 0 0-5-5"
]);
const $f342bb1007016cbf$export$7a1f612ccfbc1d07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_20_color__a)",
            "fillRule": "evenodd",
            "d": "M4 14a6 6 0 0 1 12 0c0 .99-.5 1.75-1.21 2.25-.7.5-1.6.75-2.48.75H7.69c-.88 0-1.78-.25-2.48-.75A2.7 2.7 0 0 1 4 14",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_20_color__b)",
            "fillRule": "evenodd",
            "d": "M5.5 4.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M3 4.5c-1.17 0-2 1.08-2 2.25S1.83 9 3 9s2-1.08 2-2.25S4.17 4.5 3 4.5m12 2.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25m-4.5-2.5c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -9 14.4 0 10.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_20_color__a",
                "x1": "6.85",
                "x2": "10.78",
                "y1": "9.2",
                "y2": "17.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$2dde2a2353e60b7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint20Filled', "20", [
    "M5.5 4.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M3 4.5c-1.17 0-2 1.08-2 2.25S1.83 9 3 9s2-1.08 2-2.25S4.17 4.5 3 4.5m12 2.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25m-4.5-2.5c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M4 14a6 6 0 0 1 12 0c0 .99-.5 1.75-1.21 2.25-.7.5-1.6.75-2.48.75H7.69c-.88 0-1.78-.25-2.48-.75A2.7 2.7 0 0 1 4 14"
]);
const $f342bb1007016cbf$export$7f434b6a12fffde1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint20Regular', "20", [
    "M6.5 4.25c0-.77.52-1.25 1-1.25s1 .48 1 1.25-.52 1.25-1 1.25-1-.48-1-1.25M7.5 2c-1.17 0-2 1.08-2 2.25s.83 2.25 2 2.25 2-1.08 2-2.25S8.67 2 7.5 2M3 5.5c-.48 0-1 .48-1 1.25S2.52 8 3 8s1-.48 1-1.25S3.48 5.5 3 5.5M1 6.75c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S4.17 9 3 9 1 7.92 1 6.75M17 5.5c-.48 0-1 .48-1 1.25S16.52 8 17 8s1-.48 1-1.25-.52-1.25-1-1.25m-2 1.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25S18.17 9 17 9s-2-1.08-2-2.25M12.5 3c-.48 0-1 .48-1 1.25s.52 1.25 1 1.25 1-.48 1-1.25S12.98 3 12.5 3m-2 1.25c0-1.17.83-2.25 2-2.25s2 1.08 2 2.25-.83 2.25-2 2.25-2-1.08-2-2.25M5 14a5 5 0 0 1 10 0c0 .6-.3 1.09-.79 1.44-.5.36-1.2.56-1.9.56H7.69c-.7 0-1.4-.2-1.9-.56Q5.02 14.91 5 14m5-6a6 6 0 0 0-6 6c0 .99.5 1.75 1.21 2.25.7.5 1.6.75 2.48.75h4.62c.88 0 1.78-.25 2.48-.75S16 15 16 14a6 6 0 0 0-6-6"
]);
const $f342bb1007016cbf$export$bb27376d66b06753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_24_color__a)",
            "d": "M12 10a7 7 0 0 0-7 7 3.6 3.6 0 0 0 1.7 3.04c.96.65 2.2.96 3.38.96h3.84c1.18 0 2.42-.31 3.38-.96A3.6 3.6 0 0 0 19 17a7 7 0 0 0-7-7"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_24_color__b)",
            "d": "M6.25 5.25c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S10.22 8 8.75 8s-2.5-1.33-2.5-2.75M1 8.75C1 7.33 2.03 6 3.5 6S6 7.33 6 8.75 4.97 11.5 3.5 11.5 1 10.17 1 8.75m11.75-3.5c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S16.72 8 15.25 8s-2.5-1.33-2.5-2.75M18 8.75C18 7.33 19.03 6 20.5 6S23 7.33 23 8.75s-1.03 2.75-2.5 2.75S18 10.17 18 8.75"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -11.5714 17.6 0 12.61 12.14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_24_color__a",
                "x1": "8.33",
                "x2": "13.27",
                "y1": "11.46",
                "y2": "21.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$c785e671fb07a7e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint24Filled', "24", [
    "M6.25 5.25c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S10.22 8 8.75 8s-2.5-1.33-2.5-2.75M1 8.75C1 7.33 2.03 6 3.5 6S6 7.33 6 8.75 4.97 11.5 3.5 11.5 1 10.17 1 8.75M12 10a7 7 0 0 0-7 7 3.6 3.6 0 0 0 1.7 3.04c.96.65 2.2.96 3.38.96h3.84c1.18 0 2.42-.31 3.38-.96A3.6 3.6 0 0 0 19 17a7 7 0 0 0-7-7m.75-4.75c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S16.72 8 15.25 8s-2.5-1.33-2.5-2.75M18 8.75C18 7.33 19.03 6 20.5 6S23 7.33 23 8.75s-1.03 2.75-2.5 2.75S18 10.17 18 8.75"
]);
const $f342bb1007016cbf$export$f490f88cc1f573a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint24Regular', "24", [
    "M7.75 5.25c0-.79.54-1.25 1-1.25s1 .46 1 1.25-.54 1.25-1 1.25-1-.46-1-1.25m1-2.75c-1.47 0-2.5 1.33-2.5 2.75S7.28 8 8.75 8s2.5-1.33 2.5-2.75-1.03-2.75-2.5-2.75m-5.25 5c-.46 0-1 .46-1 1.25S3.04 10 3.5 10s1-.46 1-1.25-.54-1.25-1-1.25M1 8.75C1 7.33 2.03 6 3.5 6S6 7.33 6 8.75 4.97 11.5 3.5 11.5 1 10.17 1 8.75m11 2.75A5.5 5.5 0 0 0 6.5 17c0 .76.38 1.36 1.04 1.8.67.45 1.6.7 2.54.7h3.84c.94 0 1.87-.25 2.54-.7A2.1 2.1 0 0 0 17.5 17a5.5 5.5 0 0 0-5.5-5.5M5 17a7 7 0 1 1 14 0 3.6 3.6 0 0 1-1.7 3.04c-.96.65-2.2.96-3.38.96h-3.84a6 6 0 0 1-3.38-.96A3.6 3.6 0 0 1 5 17M15.25 4c-.46 0-1 .46-1 1.25s.54 1.25 1 1.25 1-.46 1-1.25-.54-1.25-1-1.25m-2.5 1.25c0-1.42 1.03-2.75 2.5-2.75s2.5 1.33 2.5 2.75S16.72 8 15.25 8s-2.5-1.33-2.5-2.75m6.75 3.5c0-.79.54-1.25 1-1.25s1 .46 1 1.25-.54 1.25-1 1.25-1-.46-1-1.25m1-2.75C19.03 6 18 7.33 18 8.75s1.03 2.75 2.5 2.75S23 10.17 23 8.75 21.97 6 20.5 6"
]);
const $f342bb1007016cbf$export$36964cef86177925 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_28_color__a)",
            "d": "M14 11a8 8 0 0 0-7.98 8.5 4.3 4.3 0 0 0 2.17 3.45A8 8 0 0 0 12.21 24h3.58a8 8 0 0 0 4.02-1.05A4.3 4.3 0 0 0 22 19a8 8 0 0 0-8-8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_28_color__b)",
            "d": "M14.75 6.25c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25-2.88-1.57-2.88-3.25m-13.5 3.5c0-1.68 1.18-3.25 2.88-3.25S7 8.07 7 9.75 5.82 13 4.13 13s-2.88-1.57-2.88-3.25m19.75 0c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25S25.57 13 23.88 13 21 11.43 21 9.75M7.5 6.25C7.5 4.57 8.68 3 10.38 3s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25S7.5 7.93 7.5 6.25"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -12.8571 20.4 0 14.7 13.71)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_28_color__a",
                "x1": "9.8",
                "x2": "15.76",
                "y1": "12.73",
                "y2": "24.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$6b576130d71d81e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint28Filled', "28", [
    "M14.75 6.25c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25-2.88-1.57-2.88-3.25m-13.5 3.5c0-1.68 1.18-3.25 2.88-3.25S7 8.07 7 9.75 5.82 13 4.13 13s-2.88-1.57-2.88-3.25M14 11a8 8 0 0 0-7.98 8.5 4.3 4.3 0 0 0 2.17 3.45A8 8 0 0 0 12.21 24h3.58a8 8 0 0 0 4.02-1.05A4.3 4.3 0 0 0 22 19a8 8 0 0 0-8-8m7-1.25c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25S25.57 13 23.88 13 21 11.43 21 9.75M7.5 6.25C7.5 4.57 8.68 3 10.38 3s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25S7.5 7.93 7.5 6.25"
]);
const $f342bb1007016cbf$export$f9b6de8f76d1405e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint28Regular', "28", [
    "M17.63 4.5c-.65 0-1.38.66-1.38 1.75S16.98 8 17.63 8 19 7.34 19 6.25s-.73-1.75-1.37-1.75m-2.88 1.75c0-1.68 1.18-3.25 2.88-3.25s2.87 1.57 2.87 3.25-1.18 3.25-2.87 3.25-2.88-1.57-2.88-3.25M4.13 8c-.65 0-1.38.66-1.38 1.75s.73 1.75 1.38 1.75 1.37-.66 1.37-1.75S4.77 8 4.13 8M1.25 9.75c0-1.68 1.18-3.25 2.88-3.25S7 8.07 7 9.75 5.82 13 4.13 13s-2.88-1.57-2.88-3.25M14 12.5a6.5 6.5 0 0 0-6.49 6.91c.06.99.6 1.74 1.47 2.27.88.54 2.05.82 3.23.82h3.58c1.18 0 2.36-.28 3.23-.82A2.8 2.8 0 0 0 20.5 19a6.5 6.5 0 0 0-6.5-6.5M6 19a8 8 0 1 1 15.98.5 4.3 4.3 0 0 1-2.17 3.45A8 8 0 0 1 15.79 24h-3.58a8 8 0 0 1-4.02-1.05A4.3 4.3 0 0 1 6 19m16.5-9.25c0-1.09.73-1.75 1.38-1.75s1.37.66 1.37 1.75-.73 1.75-1.37 1.75-1.38-.66-1.38-1.75m1.38-3.25C22.18 6.5 21 8.07 21 9.75S22.18 13 23.88 13s2.87-1.57 2.87-3.25-1.18-3.25-2.87-3.25M9 6.25c0-1.09.73-1.75 1.38-1.75s1.37.66 1.37 1.75S11.02 8 10.38 8 9 7.34 9 6.25M10.38 3C8.68 3 7.5 4.57 7.5 6.25S8.68 9.5 10.38 9.5s2.87-1.57 2.87-3.25S12.07 3 10.38 3"
]);
const $f342bb1007016cbf$export$13fd9197e5a6e943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_32_color__a)",
            "d": "M16 13a9 9 0 0 0-8.98 9.68 5.2 5.2 0 0 0 2.7 4.12 9.7 9.7 0 0 0 4.83 1.2h2.9a9.7 9.7 0 0 0 4.82-1.2A5.2 5.2 0 0 0 25 22a9 9 0 0 0-9-9"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_32_color__b)",
            "d": "M8.5 6.75C8.5 4.88 9.78 3 11.75 3S15 4.88 15 6.75s-1.28 3.75-3.25 3.75S8.5 8.62 8.5 6.75m8.5 0C17 4.88 18.28 3 20.25 3s3.25 1.88 3.25 3.75-1.28 3.75-3.25 3.75S17 8.62 17 6.75m7 4.5c0-1.87 1.28-3.75 3.25-3.75s3.25 1.88 3.25 3.75S29.22 15 27.25 15 24 13.12 24 11.25m-22.5 0c0-1.87 1.28-3.75 3.25-3.75S8 9.38 8 11.25 6.72 15 4.75 15 1.5 13.12 1.5 11.25"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -15.4286 23.2 0 16.8 15.86)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_32_color__a",
                "x1": "11.28",
                "x2": "18.25",
                "y1": "14.99",
                "y2": "28.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$cea9485394f9ac0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint32Filled', "32", [
    "M8.5 6.75C8.5 4.88 9.78 3 11.75 3S15 4.88 15 6.75s-1.28 3.75-3.25 3.75S8.5 8.62 8.5 6.75M16 13a9 9 0 0 0-8.98 9.68 5.2 5.2 0 0 0 2.7 4.12 9.7 9.7 0 0 0 4.83 1.2h2.9a9.7 9.7 0 0 0 4.82-1.2A5.2 5.2 0 0 0 25 22a9 9 0 0 0-9-9m1-6.25C17 4.88 18.28 3 20.25 3s3.25 1.88 3.25 3.75-1.28 3.75-3.25 3.75S17 8.62 17 6.75m7 4.5c0-1.87 1.28-3.75 3.25-3.75s3.25 1.88 3.25 3.75S29.22 15 27.25 15 24 13.12 24 11.25m-22.5 0c0-1.87 1.28-3.75 3.25-3.75S8 9.38 8 11.25 6.72 15 4.75 15 1.5 13.12 1.5 11.25"
]);
const $f342bb1007016cbf$export$8b571d874d702472 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint32Regular', "32", [
    "M11.75 5c-.51 0-1.25.59-1.25 1.75s.74 1.75 1.25 1.75S13 7.91 13 6.75 12.26 5 11.75 5M8.5 6.75C8.5 4.88 9.78 3 11.75 3S15 4.88 15 6.75s-1.28 3.75-3.25 3.75S8.5 8.62 8.5 6.75M16 15a7 7 0 0 0-6.98 7.53c.08 1.1.7 1.95 1.72 2.54 1.04.61 2.43.93 3.81.93h2.9c1.38 0 2.77-.32 3.8-.93 1.02-.6 1.65-1.43 1.73-2.54L23 22a7 7 0 0 0-7-7m-9 7a9 9 0 1 1 17.98.68 5.2 5.2 0 0 1-2.7 4.12 9.7 9.7 0 0 1-4.83 1.2h-2.9a9.7 9.7 0 0 1-4.82-1.2A5.2 5.2 0 0 1 7 22M19 6.75C19 5.59 19.74 5 20.25 5s1.25.59 1.25 1.75-.74 1.75-1.25 1.75S19 7.91 19 6.75M20.25 3C18.28 3 17 4.88 17 6.75s1.28 3.75 3.25 3.75 3.25-1.88 3.25-3.75S22.22 3 20.25 3m7 6.5c-.51 0-1.25.59-1.25 1.75S26.74 13 27.25 13s1.25-.59 1.25-1.75-.74-1.75-1.25-1.75M24 11.25c0-1.87 1.28-3.75 3.25-3.75s3.25 1.88 3.25 3.75S29.22 15 27.25 15 24 13.12 24 11.25m-20.5 0c0-1.16.74-1.75 1.25-1.75S6 10.09 6 11.25 5.26 13 4.75 13s-1.25-.59-1.25-1.75M4.75 7.5c-1.97 0-3.25 1.88-3.25 3.75S2.78 15 4.75 15 8 13.12 8 11.25 6.72 7.5 4.75 7.5"
]);
const $f342bb1007016cbf$export$f55cc26fc8336cc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_48_color__a)",
            "d": "M10 34a14 14 0 1 1 28 .5 7 7 0 0 1-3.36 5.7 12 12 0 0 1-6.47 1.8h-8.34c-2.26 0-4.62-.59-6.47-1.8A7 7 0 0 1 10 34"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_animal_paw_print_48_color__b)",
            "d": "M18.25 6c-2.84 0-4.75 2.7-4.75 5.5s1.91 5.5 4.75 5.5S23 14.3 23 11.5 21.09 6 18.25 6M3 17.5C3 14.7 4.91 12 7.75 12s4.75 2.7 4.75 5.5S10.59 23 7.75 23 3 20.3 3 17.5m22.5-6c0-2.8 1.91-5.5 4.75-5.5S35 8.7 35 11.5 33.09 17 30.25 17s-4.75-2.7-4.75-5.5m10 6c0-2.8 1.91-5.5 4.75-5.5S45 14.7 45 17.5 43.09 23 40.25 23s-4.75-2.7-4.75-5.5"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_animal_paw_print_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(0 -21.8571 33.6 0 25.17 24.21)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_animal_paw_print_48_color__a",
                "x1": "16.66",
                "x2": "26.53",
                "y1": "22.92",
                "y2": "42.99",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#ff921f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#eb4824"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$4041eb47fdfbe80f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint48Filled', "48", [
    "M18.25 6c-2.84 0-4.75 2.7-4.75 5.5s1.91 5.5 4.75 5.5S23 14.3 23 11.5 21.09 6 18.25 6M3 17.5C3 14.7 4.91 12 7.75 12s4.75 2.7 4.75 5.5S10.59 23 7.75 23 3 20.3 3 17.5m22.5-6c0-2.8 1.91-5.5 4.75-5.5S35 8.7 35 11.5 33.09 17 30.25 17s-4.75-2.7-4.75-5.5m10 6c0-2.8 1.91-5.5 4.75-5.5S45 14.7 45 17.5 43.09 23 40.25 23s-4.75-2.7-4.75-5.5M10 34a14 14 0 1 1 28 .5 7 7 0 0 1-3.36 5.7 12 12 0 0 1-6.47 1.8h-8.34c-2.26 0-4.62-.59-6.47-1.8A7 7 0 0 1 10 34"
]);
const $f342bb1007016cbf$export$d8e7608463dccce9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalPawPrint48Regular', "48", [
    "M18.25 8.5c-1.03 0-2.25 1.1-2.25 3s1.22 3 2.25 3 2.25-1.1 2.25-3-1.22-3-2.25-3m-4.75 3c0-2.8 1.91-5.5 4.75-5.5S23 8.7 23 11.5 21.09 17 18.25 17s-4.75-2.7-4.75-5.5m-5.75 3c-1.03 0-2.25 1.1-2.25 3s1.22 3 2.25 3 2.25-1.1 2.25-3-1.22-3-2.25-3M3 17.5C3 14.7 4.91 12 7.75 12s4.75 2.7 4.75 5.5S10.59 23 7.75 23 3 20.3 3 17.5m25-6c0-1.9 1.22-3 2.25-3s2.25 1.1 2.25 3-1.22 3-2.25 3-2.25-1.1-2.25-3M30.25 6c-2.84 0-4.75 2.7-4.75 5.5s1.91 5.5 4.75 5.5S35 14.3 35 11.5 33.09 6 30.25 6m10 8.5c-1.03 0-2.25 1.1-2.25 3s1.22 3 2.25 3 2.25-1.1 2.25-3-1.22-3-2.25-3m-4.75 3c0-2.8 1.91-5.5 4.75-5.5S45 14.7 45 17.5 43.09 23 40.25 23s-4.75-2.7-4.75-5.5M12.5 34a11.5 11.5 0 1 1 23 .42 4.5 4.5 0 0 1-2.23 3.7 9.5 9.5 0 0 1-5.1 1.38h-8.34a9.5 9.5 0 0 1-5.1-1.39A4.5 4.5 0 0 1 12.5 34M24 20a14 14 0 0 0-14 14.5 7 7 0 0 0 3.36 5.7c1.85 1.21 4.2 1.8 6.47 1.8h8.34c2.26 0 4.62-.59 6.47-1.8A7 7 0 0 0 38 34a14 14 0 0 0-14-14"
]);
const $f342bb1007016cbf$export$e72c739266a7c77e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit16Filled', "16", [
    "M10.2 4 13.4 7.2a2.1 2.1 0 0 1-1.96 3.51v.12c0 .65-.53 1.18-1.18 1.18H8.06v-.5c0-.8-.64-1.5-1.56-1.5h-1a.5.5 0 1 0 0 1h1c.37 0 .56.25.56.5v.5H4.17C3.53 12 3 11.47 3 10.82V9.2A1.78 1.78 0 1 1 5.43 7L5.67 7H8.8q.54 0 1 .18.06-.1.12-.3c.06-.19.12-.39.2-.47L8.98 5.24A.87.87 0 0 1 10.2 4"
]);
const $f342bb1007016cbf$export$9f0ab7b6b8f40c42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit16Regular', "16", [
    "m9.33 6.4-.9-.88a1.25 1.25 0 0 1 0-1.77 1.24 1.24 0 0 1 1.76 0l3.1 3.1A2.45 2.45 0 0 1 11.47 11c-.26.58-.85 1-1.54 1H4.7A1.7 1.7 0 0 1 3 10.3V9.24q0-.45.14-.85A1.75 1.75 0 1 1 5.48 6.5l.25-.01h3.16q.18 0 .35.02zm.16-1.94a.24.24 0 0 0-.35 0c-.1.1-.1.25 0 .35l1.6 1.58-.47.45q-.24.26-.32.44l-.17.4-.42-.11a2 2 0 0 0-.47-.07H5.73C4.78 7.5 4 8.28 4 9.24v1.07c0 .39.31.7.69.7H7v-.45c0-.25-.25-.56-.68-.56H5.5a.5.5 0 0 1 0-1h.82C7.2 9 8 9.66 8 10.56V11h1.93c.35 0 .65-.26.69-.6l.06-.57.55.14c.47.11.98-.02 1.35-.38.56-.57.56-1.48 0-2.04zM3.63 7.49q.36-.43.87-.7v-.04a.75.75 0 1 0-.87.74"
]);
const $f342bb1007016cbf$export$7d80dc16ee7908d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit20Filled', "20", [
    "m12.68 4.38 4.23 4.23a2.78 2.78 0 0 1-2.6 4.67v.16c0 .86-.7 1.56-1.57 1.56H11v-1.25c0-.54-.28-.98-.67-1.28-.38-.3-.9-.47-1.43-.47H7.5a.5.5 0 1 0 0 1h1.4q.5.01.82.26.29.24.28.49V15H5.56C4.7 15 4 14.3 4 13.44v-2.21A2.12 2.12 0 1 1 6.05 8.3Q6.73 8 7.52 8h3.28q.71.01 1.33.26l.08-.13c.11-.19.23-.4.38-.55l-1.55-1.56a1.16 1.16 0 1 1 1.64-1.64"
]);
const $f342bb1007016cbf$export$d2eec1d4d2682e8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit20Regular', "20", [
    "M10.51 15.01h2.12c.91 0 1.68-.57 1.99-1.37.88.07 1.79-.23 2.46-.9a3.15 3.15 0 0 0 0-4.45l-4.22-4.22c-.59-.59-1.55-.59-2.14 0-.6.6-.6 1.56 0 2.15l1.34 1.33q-.18.24-.3.5a4 4 0 0 0-.54-.05H7.54q-.5 0-.95.13A2.5 2.5 0 1 0 4 11.95v.93c0 1.18.95 2.13 2.12 2.13zm1.64-10.23L16.38 9a2.15 2.15 0 0 1-2 3.6l-.56-.13-.06.56c-.07.56-.54.99-1.12.99h-1.62v-.1C11 12.78 9.99 12 8.89 12H7.5a.5.5 0 0 0 0 1h1.39c.69 0 1.12.46 1.12.91v.1H6.12c-.62 0-1.12-.5-1.12-1.13v-1.33A2.55 2.55 0 0 1 7.54 9h3.68q.35 0 .68.1l.42.11.18-.4c.1-.26.26-.57.47-.79l.5-.48-2.04-2.02a.5.5 0 0 1 0-.74c.2-.2.52-.2.72 0m-6.5 3.77a3.6 3.6 0 0 0-1.6 2.38 1.5 1.5 0 1 1 1.6-2.38"
]);
const $f342bb1007016cbf$export$c85c06da6a4367dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit24Filled', "24", [
    "m15.53 5.44 5.43 5.43a3.58 3.58 0 0 1-3.35 6V17a2 2 0 0 1-2 2h-2.1v-.75l-.01-.17a2.75 2.75 0 0 0-2.57-2.58H9.66a.75.75 0 0 0 0 1.5h1.22c.6.07 1.06.53 1.12 1.12V19H7a2 2 0 0 1-2-2v-2.5q0-.3.04-.57-.25.06-.54.06a2.5 2.5 0 1 1 2.4-3.18A4.5 4.5 0 0 1 9.5 10h3.62q.9 0 1.7.33.24-.42.6-.78l-2-2a1.5 1.5 0 0 1 2.11-2.1"
]);
const $f342bb1007016cbf$export$462bdccb6bd9c74a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit24Regular', "24", [
    "M7.75 19a2.75 2.75 0 0 1-2.74-2.58L5 16.25V15a3 3 0 1 1 2.56-4.56q.77-.38 1.68-.43L9.5 10h4.25l.24.03.13.01.11-.16.13-.18-1.78-1.78a2 2 0 0 1-.22-2.57l.1-.13.12-.13a2 2 0 0 1 2.7-.12l.14.12 5.4 5.41a4 4 0 0 1-2.63 6.83h-.41l-.03.06a2.8 2.8 0 0 1-2.14 1.59l-.19.01-.17.01zm6.6-12.85a.5.5 0 0 0-.76.64l.05.07 2.81 2.81-.64.64q-.3.32-.52.7l-.1.19-.26.58-.62-.17q-.3-.08-.6-.1l-.21-.01h-4q-1.07.02-1.85.64l-.15.12-.16.16-.1.1-.1.13-.13.17-.04.06-.11.2-.06.11-.06.14-.04.08-.05.15-.05.18-.06.3-.02.08-.01.19-.01.19v1.75c0 .65.5 1.18 1.12 1.24l.13.01H12v-.25c0-.64-.49-1.18-1.12-1.24H9.75a.75.75 0 0 1-.1-1.5h1.1a2.75 2.75 0 0 1 2.75 2.58v.41h1.75c.6 0 1.1-.41 1.22-.98l.02-.12.1-.84.82.2a2.5 2.5 0 0 0 2.48-4.07l-.12-.13zM5 10.5a1.5 1.5 0 0 0-.14 3h.25v-.03l.14-.44.1-.25.1-.24.05-.11.14-.24.08-.14.15-.2.07-.1.11-.14.13-.15.15-.15a1.5 1.5 0 0 0-1.04-.78l-.15-.02z"
]);
const $f342bb1007016cbf$export$856d93b4c31b7141 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit28Filled', "28", [
    "m18.18 5.55 6.56 6.56a4.3 4.3 0 0 1-4.04 7.23v.25A2.4 2.4 0 0 1 18.3 22H15.5v-.83A3.17 3.17 0 0 0 12.34 18h-1.6a.75.75 0 0 0 0 1.5h1.6c.91 0 1.66.75 1.66 1.67V22H7.4A2.4 2.4 0 0 1 5 19.6v-3.15q0-.36.04-.7l-.17.01a2.88 2.88 0 1 1 2.68-3.93 5.4 5.4 0 0 1 2.87-.82h4.85q1.1 0 2.06.4.3-.48.72-.9l-2.4-2.4a1.8 1.8 0 1 1 2.53-2.55"
]);
const $f342bb1007016cbf$export$ad61a6b9a5642521 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit28Regular', "28", [
    "m17 10.77-1.92-1.89a2.27 2.27 0 1 1 3.21-3.21l6.33 6.29a4.7 4.7 0 0 1-3.7 8 3.2 3.2 0 0 1-2.97 2.05H9.2A3.2 3.2 0 0 1 6 18.83v-1.86q-.24.03-.5.03a3.5 3.5 0 1 1 3.05-5.22 5.3 5.3 0 0 1 2.77-.78h4.5q.47 0 .9.08zm.23-4.04a.77.77 0 0 0-1.1 1.09h.01L19.36 11l-1 .58c-.25.15-.51.46-.65.7l-.29.52-.57-.16q-.48-.14-1.03-.14h-4.5c-2.1 0-3.82 1.7-3.82 3.8v2.53c0 .92.76 1.68 1.7 1.68H14v-.33c0-.92-.75-1.68-1.68-1.68h-1.57a.75.75 0 0 1 0-1.5h1.57a3.2 3.2 0 0 1 3.18 3.18v.33h2.45c.86 0 1.57-.65 1.67-1.48l.1-.84.82.2a3.2 3.2 0 0 0 3.02-5.37zm-9.87 6.04a2 2 0 1 0-1.29 2.65q.28-1.54 1.3-2.65"
]);
const $f342bb1007016cbf$export$3308de182eec00c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit32Filled', "32", [
    "M16.34 4.92a3 3 0 0 1 4.32 0l7.17 7.46A5.99 5.99 0 0 1 24.11 23a4 4 0 0 1-4 4H18v-2.5a4.5 4.5 0 0 0-4.5-4.5H12a1 1 0 1 0 0 2h1.5a2.5 2.5 0 0 1 2.5 2.5V27h-5a5 5 0 0 1-5-5v-2.1a5 5 0 1 1 5-7.9h6.6q.21-.4.47-.76l-1.9-2.35a3 3 0 0 1 .17-3.97"
]);
const $f342bb1007016cbf$export$95ef3d4d24acd5e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbit32Regular', "32", [
    "M11 12h6.6q.21-.4.47-.76l-1.9-2.35a3 3 0 0 1 4.49-3.97l7.17 7.46A5.99 5.99 0 0 1 24.11 23a4 4 0 0 1-4 4H11a5 5 0 0 1-5-5v-2.1a5 5 0 1 1 5-7.9m8.22-5.69a1 1 0 0 0-1.5 1.33l3 3.7-.65.64a3.5 3.5 0 0 0-.87 1.35l-.24.67h-7.09A4 4 0 0 0 8 18v4a3 3 0 0 0 3 3h5v-.5a2.5 2.5 0 0 0-2.5-2.5H12a1 1 0 1 1 0-2h1.5a4.5 4.5 0 0 1 4.5 4.5v.5h2.1a2 2 0 0 0 2-2v-2.28l1.18.22q.34.06.72.06a4 4 0 0 0 2.52-7.1l-.05-.04zM6 17.83a6 6 0 0 1 3.03-5.04A3 3 0 1 0 6 17.83"
]);
const $f342bb1007016cbf$export$4aaceed41b4d590d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7.3 8.01q-.66.04-1.25.3A2.12 2.12 0 1 0 4 11.22v2.21C4 14.3 4.7 15 5.56 15H10v-1.25q.01-.25-.28-.49-.31-.24-.82-.26H7.5a.5.5 0 0 1 0-1h1.4c.54 0 1.05.17 1.43.47.39.3.67.74.67 1.28V15h1.74c.43 0 .82-.18 1.1-.45l3.3 3.3a.5.5 0 0 0 .71-.7zm14.06 10.39q-.65.63-1.48.77l-5.3-5.3h.67q.71 0 1.33.25l.08-.13c.11-.19.23-.4.38-.55l-1.55-1.56a1.16 1.16 0 1 1 1.64-1.64l4.23 4.23a2.8 2.8 0 0 1 0 3.93"
]);
const $f342bb1007016cbf$export$d234154e7dce7fb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7.3 8.01q-.37.03-.7.12A2.5 2.5 0 1 0 4 11.95v.93c0 1.18.95 2.13 2.12 2.13h6.51q.71-.01 1.26-.41l3.26 3.25a.5.5 0 0 0 .7-.7zm10.32 11.73q-.24.13-.54.13h-1.62v-.1C11 12.78 9.99 12 8.89 12H7.5a.5.5 0 0 0 0 1h1.39c.69 0 1.12.46 1.12.91v.1H6.12c-.62 0-1.12-.5-1.12-1.13v-1.33A2.55 2.55 0 0 1 7.54 9h.75zM5.66 8.55a3.6 3.6 0 0 0-1.6 2.38 1.5 1.5 0 1 1 1.6-2.38m10.71 3.48c-.44.44-1.02.65-1.6.62l.9.9q.79-.2 1.41-.82a3.15 3.15 0 0 0 0-4.44l-4.22-4.22c-.59-.59-1.55-.59-2.14 0-.6.6-.6 1.56 0 2.15l1.34 1.33q-.18.24-.3.5a4 4 0 0 0-.54-.05h-1.1l1 1h.1q.35 0 .68.1l.42.11.18-.4c.1-.26.26-.57.47-.79l.5-.48-2.04-2.02a.5.5 0 0 1 0-.74c.2-.2.52-.2.72 0L16.38 9c.84.84.84 2.2 0 3.04"
]);
const $f342bb1007016cbf$export$af2756b2ffc011ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitOff32Filled', "32", [
    "m23.58 24.99 4.71 4.72a1 1 0 0 0 1.42-1.42l-26-26a1 1 0 0 0-1.42 1.42L9 10.4A4.98 4.98 0 0 0 2 15a5 5 0 0 0 4 4.9V22a5 5 0 0 0 5 5h5v-2.5a2.5 2.5 0 0 0-2.5-2.5H12a1 1 0 1 1 0-2h1.5a4.5 4.5 0 0 1 4.5 4.5V27h2.1a4 4 0 0 0 3.48-2.01M30 17a6 6 0 0 1-3.86 5.6L15.54 12h2.06q.2-.4.47-.76l-1.9-2.35a3 3 0 0 1 4.49-3.97l7.17 7.46A6 6 0 0 1 30 17"
]);
const $f342bb1007016cbf$export$9935b913c5e10c69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalRabbitOff32Regular', "32", [
    "m23.58 24.99 4.71 4.72a1 1 0 0 0 1.42-1.42l-26-26a1 1 0 0 0-1.42 1.42L9 10.4A4.98 4.98 0 0 0 2 15a5 5 0 0 0 4 4.9V22a5 5 0 0 0 5 5h9.1a4 4 0 0 0 3.48-2.01m-1.53-1.52A2 2 0 0 1 20.11 25H18v-.5a4.5 4.5 0 0 0-4.5-4.5H12a1 1 0 1 0 0 2h1.5a2.5 2.5 0 0 1 2.5 2.5v.5h-5a3 3 0 0 1-3-3v-4a4 4 0 0 1 3.86-4h.73zM6 17.83a3 3 0 1 1 3.02-5.04A6 6 0 0 0 6 17.83M28 17a4 4 0 0 1-3.5 3.97l1.64 1.64a6 6 0 0 0 1.7-10.23l-7.18-7.46a3 3 0 0 0-4.5 3.97l1.9 2.35q-.26.37-.46.76h-2.06l2 2h1.42l.24-.67q.28-.77.87-1.35l.65-.63-3-3.72a1 1 0 0 1 1.5-1.32l7.25 7.55.05.03c.9.74 1.48 1.86 1.48 3.11"
]);
const $f342bb1007016cbf$export$97d2a171d753e111 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle16Filled', "16", [
    "M7.34 3.99c-1.85 0-3.03 1.31-3.48 2.8L3.8 7H2.5a.5.5 0 0 0-.5.5q.01 1.07.52 1.82.18.26.41.46l-.3.72A1.1 1.1 0 0 0 3.66 12h1.07c.42 0 .81-.24 1-.63l.3-.64q1.36.18 2.74 0l.3.64c.18.39.57.63 1 .63h1.06a1.1 1.1 0 0 0 1-1.5l-.2-.5h.97c.62 0 1.11-.52 1.11-1.13v-.62c0-.94-.73-1.75-1.69-1.75h-1.46a3.8 3.8 0 0 0-3.5-2.51M11.6 9l-.44-1.5h1.16c.36 0 .7.31.7.75v.62q0 .05-.05.1L12.9 9zm-1.81 1.55q.58-.14 1.15-.33l.27.65a.1.1 0 0 1-.08.13h-1.07a.1.1 0 0 1-.08-.05zm-5.95-.34q.57.2 1.16.34l-.18.4a.1.1 0 0 1-.09.05H3.65a.1.1 0 0 1-.09-.13zM3.5 8l-.2.67q-.18-.29-.26-.67z"
]);
const $f342bb1007016cbf$export$59a5534596cb5296 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle16Regular', "16", [
    "M7.34 3.99c-1.85 0-3.03 1.31-3.48 2.8L3.8 7H2.5a.5.5 0 0 0-.5.5q.01 1.07.52 1.82.18.26.41.46l-.3.72A1.1 1.1 0 0 0 3.66 12h1.07c.42 0 .81-.24 1-.63l.3-.64q1.36.18 2.74 0l.3.64c.18.39.57.63 1 .63h1.06a1.1 1.1 0 0 0 1-1.5l-.2-.5h.97c.62 0 1.11-.52 1.11-1.13v-.62c0-.94-.73-1.75-1.69-1.75h-1.46a3.8 3.8 0 0 0-3.5-2.51M11.6 9l-.44-1.5h1.16c.36 0 .7.31.7.75v.62q0 .05-.05.1L12.9 9zm-.66 1.22.27.65a.1.1 0 0 1-.08.13h-1.07a.1.1 0 0 1-.08-.05l-.2-.4q.6-.14 1.16-.33M5 10.55l-.18.4a.1.1 0 0 1-.09.05H3.65a.1.1 0 0 1-.09-.13l.27-.66q.57.2 1.16.34M3.5 8l-.2.67q-.16-.29-.25-.67zm1.33-.91c.36-1.22 1.24-2.1 2.52-2.1 1.3 0 2.3.9 2.65 2.1l.63 2.17c-2.1.74-4.36.74-6.46 0z"
]);
const $f342bb1007016cbf$export$cb4787d4755de35f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle20Filled', "20", [
    "M9.1 4c-1.47 0-2.5.55-3.21 1.38a7.5 7.5 0 0 0-1.36 2.77L4.27 9H2.5a.5.5 0 0 0-.5.5c0 1.08.5 2.1 1.3 2.63l-.44 1.07a1.3 1.3 0 0 0 1.2 1.81h1.47c.5 0 .97-.3 1.19-.75l.47-1q1.98.27 3.95 0l.48 1c.21.46.67.75 1.18.75h1.45a1.3 1.3 0 0 0 1.21-1.8l-.5-1.21h1.7c.68 0 1.34-.52 1.34-1.26V10c0-1.14-.99-2-2.12-2H13.8a7 7 0 0 0-1.4-2.63A4.3 4.3 0 0 0 9.1 4m5.57 7-.57-2h1.78c.66 0 1.12.49 1.12 1v.74c0 .09-.11.26-.33.26zm-2.5 2.08q.98-.2 1.93-.55l.44 1.05a.3.3 0 0 1-.29.43H12.8a.3.3 0 0 1-.28-.18zm-7.95-.55q.96.34 1.95.55l-.36.75a.3.3 0 0 1-.28.18H4.07a.3.3 0 0 1-.29-.43zM3.97 10l-.34 1.12c-.27-.26-.5-.65-.58-1.12z"
]);
const $f342bb1007016cbf$export$6fedfa9aaad7cb9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle20Regular', "20", [
    "M9.1 4c-1.47 0-2.5.55-3.21 1.38a7.5 7.5 0 0 0-1.36 2.77L4.27 9H2.5a.5.5 0 0 0-.5.5c0 1.08.5 2.1 1.3 2.63l-.44 1.07a1.3 1.3 0 0 0 1.2 1.81h1.47c.5 0 .97-.3 1.19-.75l.47-1q1.97.27 3.95 0l.48 1c.21.46.67.75 1.18.75h1.45a1.3 1.3 0 0 0 1.21-1.8l-.5-1.21h1.7c.68 0 1.34-.52 1.34-1.26V10c0-1.14-.99-2-2.12-2H13.8a7 7 0 0 0-1.4-2.63A4.3 4.3 0 0 0 9.1 4m5.57 7-.57-2h1.78c.66 0 1.12.49 1.12 1v.74c0 .09-.11.26-.33.26zm-.57 1.53.44 1.05a.3.3 0 0 1-.29.43H12.8a.3.3 0 0 1-.28-.18l-.35-.75q.98-.2 1.93-.55m-7.93.55-.36.75a.3.3 0 0 1-.28.18H4.07a.3.3 0 0 1-.29-.43l.44-1.05q.96.34 1.95.55m-2.54-1.96c-.27-.26-.5-.65-.58-1.12h.92zM5.5 8.44c.27-.91.6-1.77 1.15-2.4A3 3 0 0 1 9.1 5c1.2 0 2 .43 2.56 1.05.59.63.96 1.5 1.23 2.39l.9 3.13c-3 1.1-6.25 1.1-9.25 0z"
]);
const $f342bb1007016cbf$export$dfb75f1766ad0963 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle24Filled', "24", [
    "M11 6a6.1 6.1 0 0 1 5.8 4.12l.07.24.05.14h2.33a2.75 2.75 0 0 1 2.74 2.58v1.17c0 .92-.7 1.67-1.6 1.74h-1.77l.24.6c.35.84-.01 1.8-.81 2.21l-.14.07q-.23.09-.5.12h-1.95c-.63 0-1.2-.33-1.51-.86l-.08-.14-.53-1.14h.05q-2.11.27-4.22.06l-.5-.06L8.14 18c-.3.61-.9 1-1.59 1h-1.8a1.75 1.75 0 0 1-1.62-2.41l.44-1.05A3.2 3.2 0 0 1 2 12.75c0-.38.28-.7.64-.74l.1-.01h1.89l.5-1.64A6.1 6.1 0 0 1 11 6m6.77 9.7q-1.15.45-2.35.76l-.55.13.36.77q.04.08.12.11l.05.02h1.84a.25.25 0 0 0 .25-.27l-.02-.07L17 16h-.05l.42-.15zm-13.55 0 .4.14.38.14-.48 1.17a.25.25 0 0 0 .23.34h1.86a.3.3 0 0 0 .17-.14l.36-.76h.04q-1.51-.3-2.96-.9m-.2-1.7.15-.5h-.5l.02.05q.14.25.33.45m13.35-2 .76 2.5h2.12q.18-.01.24-.2v-1.05c0-.65-.49-1.18-1.12-1.24h-.12z"
]);
const $f342bb1007016cbf$export$e56bccd24654f580 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle24Regular', "24", [
    "M11 6a6.1 6.1 0 0 1 5.8 4.12l.07.24.05.14h2.33a2.75 2.75 0 0 1 2.74 2.58v1.17c0 .92-.7 1.67-1.6 1.74h-1.77l.24.6c.35.84-.01 1.8-.81 2.21l-.14.07q-.23.09-.5.12h-1.95c-.63 0-1.2-.33-1.51-.86l-.08-.14-.53-1.14h.05q-2.11.27-4.22.06l-.5-.06L8.14 18c-.3.61-.9 1-1.59 1h-1.8a1.75 1.75 0 0 1-1.62-2.41l.44-1.05A3.2 3.2 0 0 1 2 12.75c0-.38.28-.7.64-.74l.1-.01h1.89l.5-1.64A6.1 6.1 0 0 1 11 6m6.77 9.7q-1.15.45-2.35.76l-.55.13.36.77q.04.08.12.11l.05.02h1.84a.25.25 0 0 0 .25-.27l-.02-.07L17 16h-.05l.42-.15zm-13.55 0 .4.14.38.14-.48 1.17a.25.25 0 0 0 .23.34h1.86a.3.3 0 0 0 .17-.14l.36-.76h.04q-1.51-.3-2.96-.9M11 7.5a4.6 4.6 0 0 0-4.37 3.08l-.07.21-1.14 3.75.17.06a16.7 16.7 0 0 0 10.41.13l.41-.13.16-.06-1.13-3.75a4.6 4.6 0 0 0-4-3.27l-.23-.02zM4.02 14l.15-.5h-.5l.02.05q.14.25.33.45m13.35-2 .76 2.5h2.12q.18-.01.24-.2v-1.05c0-.65-.49-1.18-1.12-1.24h-.12z"
]);
const $f342bb1007016cbf$export$1eafd58d24c6a7b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle28Filled', "28", [
    "M12.72 5c-2.17 0-3.7.66-4.82 1.76a9 9 0 0 0-2.1 3.93L5.1 13H2.75a.75.75 0 0 0-.75.75c0 1.35.77 2.49 1.87 3.1l-.58 1.43A1.97 1.97 0 0 0 5.1 21h2.2c.76 0 1.45-.44 1.78-1.13l.7-1.5q2.97.4 5.94 0l.7 1.5A2 2 0 0 0 18.2 21h2.17a1.96 1.96 0 0 0 1.82-2.72L21.66 17H24c1.01 0 2-.78 2-1.89V14c0-1.7-1.48-3-3.18-3h-2.95l-.1-.3a9 9 0 0 0-2.17-3.95C16.46 5.65 14.89 5 12.72 5m8.5 10.5-.9-3h2.5c.98 0 1.68.73 1.68 1.5v1.11c0 .14-.17.39-.5.39zm-3.96 2.61q1.47-.3 2.9-.82l.64 1.56a.47.47 0 0 1-.43.65H18.2a.5.5 0 0 1-.42-.27zm-11.73-.77q1.35.46 2.72.76l-.53 1.13a.5.5 0 0 1-.42.27H5.1l-.17-.04a.47.47 0 0 1-.26-.6l.64-1.54zm-.88-2.84-.27.9a2 2 0 0 1-.73-.9z"
]);
const $f342bb1007016cbf$export$feb6c56335ac32cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AnimalTurtle28Regular', "28", [
    "M12.72 5c-2.17 0-3.7.66-4.82 1.76a9 9 0 0 0-2.1 3.93L5.1 13H2.75a.75.75 0 0 0-.75.75c0 1.35.77 2.49 1.87 3.1l-.58 1.43A1.97 1.97 0 0 0 5.1 21h2.2c.76 0 1.45-.44 1.78-1.13l.7-1.5q2.97.4 5.94 0l.7 1.5A2 2 0 0 0 18.2 21h2.17a1.96 1.96 0 0 0 1.82-2.72L21.66 17H24c1.01 0 2-.78 2-1.89V14c0-1.7-1.48-3-3.18-3h-2.95l-.1-.3a9 9 0 0 0-2.17-3.95C16.46 5.65 14.89 5 12.72 5m8.5 10.5-.9-3h2.5c.98 0 1.68.73 1.68 1.5v1.11c0 .14-.17.39-.5.39zm-1.06 1.8.64 1.55a.47.47 0 0 1-.43.65H18.2a.5.5 0 0 1-.42-.27l-.52-1.12q1.47-.3 2.9-.82m-11.9.8-.54 1.13a.5.5 0 0 1-.42.27H5.1l-.17-.04a.47.47 0 0 1-.26-.6l.64-1.54.22.02q1.35.46 2.72.76m-3.61-3.6-.27.9a2 2 0 0 1-.73-.9zm2.58-3.37a8 8 0 0 1 1.73-3.3c.79-.79 1.93-1.33 3.76-1.33 1.84 0 3.02.54 3.84 1.33a7.5 7.5 0 0 1 1.78 3.3l1.43 4.71a20.4 20.4 0 0 1-13.96 0z"
]);
const $f342bb1007016cbf$export$e441d66f7feca47c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BezierCurveSquare12Filled', "12", [
    "M1 3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5c-.88 0-1.44-.27-1.85-.65-.41-.39-.7-.93-.94-1.54l-.23-.61-.1-.3q-.17-.45-.38-.85C7.22 3.5 6.78 3 6 3s-1.22.51-1.5 1.05a7 7 0 0 0-.48 1.15l-.23.61c-.25.61-.53 1.15-.94 1.54-.4.38-.97.65-1.85.65zm0 6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2 3.5 3.5 0 0 1-2.53-.92 5 5 0 0 1-1.18-1.9l-.25-.65-.1-.27q-.16-.45-.32-.74C6.4 4.12 6.22 4 6 4s-.4.11-.62.52a6 6 0 0 0-.42 1q-.11.33-.25.67c-.25.64-.6 1.35-1.18 1.9C2.93 8.64 2.12 9 1 9"
]);
const $f342bb1007016cbf$export$fe152493dbb9ee56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BezierCurveSquare12Regular', "12", [
    "M1 3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3m1 5.97V9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.03a2.8 2.8 0 0 1-1.77-.91 5 5 0 0 1-1.01-1.9l-.2-.56a8 8 0 0 0-.41-1.09C6.41 4.11 6.22 4 6 4s-.4.11-.61.51q-.23.45-.41 1.09l-.2.57a5 5 0 0 1-1.01 1.89c-.44.47-1.01.8-1.77.9m8-1.01V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4.96q.67-.15 1.03-.58c.36-.39.6-.93.81-1.55L4 5.36c.15-.45.3-.93.5-1.3C4.78 3.5 5.22 3 6 3s1.22.51 1.5 1.05c.2.38.35.86.5 1.31l.16.47c.22.62.45 1.16.81 1.55q.36.43 1.03.58"
]);
const $f342bb1007016cbf$export$33aefc3ea6425631 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BezierCurveSquare20Filled', "20", [
    "M5 3a2 2 0 0 0-2 2v8c1.4 0 2.26-.4 2.86-.96.62-.57.99-1.35 1.3-2.2l.28-.87.13-.41q.2-.63.47-1.19t.74-.96Q9.28 6 10 6t1.22.4q.48.4.74.97t.47 1.19l.13.4q.13.44.29.87c.3.86.67 1.64 1.29 2.21.6.56 1.47.96 2.86.96V5a2 2 0 0 0-2-2zm12 11c-1.6 0-2.74-.47-3.54-1.23a6.4 6.4 0 0 1-1.56-2.6l-.3-.92-.12-.38a8 8 0 0 0-.41-1.05q-.22-.44-.46-.63A1 1 0 0 0 10 7a1 1 0 0 0-.6.2q-.25.18-.47.62-.2.44-.4 1.05l-.13.38-.3.92c-.32.9-.76 1.86-1.56 2.6A5 5 0 0 1 3 14v1c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2z"
]);
const $f342bb1007016cbf$export$93b618c6456ee8d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BezierCurveSquare20Regular', "20", [
    "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm11 9.92a3.5 3.5 0 0 1-1.86-.88 5.4 5.4 0 0 1-1.3-2.2l-.28-.87-.13-.41a9 9 0 0 0-.47-1.19q-.26-.56-.74-.96Q10.72 6 10 6t-1.22.4q-.48.4-.74.97-.27.56-.47 1.19l-.13.4q-.13.44-.29.87c-.3.86-.67 1.64-1.29 2.21a3.5 3.5 0 0 1-1.86.88V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zM4 13.93a4.6 4.6 0 0 0 2.54-1.16c.8-.74 1.24-1.7 1.56-2.6l.3-.92.12-.38q.2-.6.41-1.05.22-.44.46-.63.22-.18.61-.19.39 0 .6.2.25.18.47.62a8 8 0 0 1 .4 1.05l.13.38.3.92c.32.9.76 1.86 1.56 2.6q.93.9 2.54 1.16V15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
]);
const $f342bb1007016cbf$export$b38926bb90b7db98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUp16Filled', "16", [
    "M6.74 6.67a.25.25 0 0 0-.48 0l-.32.91c-.24.7-.9 1.17-1.65 1.17H3.25a1.25 1.25 0 1 1 0-1.5h1.04q.17-.01.24-.17l.32-.91a1.75 1.75 0 0 1 3.3 0l1.11 3.16c.08.22.4.22.48 0l.32-.91c.24-.7.9-1.17 1.65-1.17h1.04a1.25 1.25 0 1 1 0 1.5H11.7q-.16.01-.24.17l-.32.9a1.75 1.75 0 0 1-3.3 0z"
]);
const $f342bb1007016cbf$export$2ad13d6d0c058907 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUp16Regular', "16", [
    "M6.84 6.32a.5.5 0 0 0-.92-.05l-.7 1.4c-.25.5-.77.83-1.34.83H2.87a1 1 0 1 1 0-1h1.01a.5.5 0 0 0 .45-.28l.7-1.4a1.5 1.5 0 0 1 2.74.15l1.4 3.7c.15.42.71.45.9.06l.7-1.4c.26-.5.78-.83 1.35-.83h1.01a1 1 0 1 1 0 1h-1.01a.5.5 0 0 0-.45.28l-.7 1.4a1.5 1.5 0 0 1-2.74-.15z"
]);
const $f342bb1007016cbf$export$4847c33482b17cb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUp20Filled', "20", [
    "M7.67 7.14c.1-.2.38-.18.46.02l2.33 6.2a1.75 1.75 0 0 0 3.23.14l1.22-2.6a.3.3 0 0 1 .23-.15h1.06a1.5 1.5 0 1 0 0-1.5h-1.06c-.68 0-1.3.4-1.59 1l-1.22 2.6c-.1.2-.38.2-.46-.01l-2.33-6.2A1.75 1.75 0 0 0 6.3 6.5L5.1 9.1a.3.3 0 0 1-.22.14H3.8a1.5 1.5 0 1 0 0 1.5h1.07c.67 0 1.29-.4 1.58-1z"
]);
const $f342bb1007016cbf$export$c4aafaa6921583f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUp20Regular', "20", [
    "M7.45 7.27a.5.5 0 0 1 .91.04l2.35 5.76a1.5 1.5 0 0 0 2.73.11l1.23-2.4a.5.5 0 0 1 .44-.28h.98a1.5 1.5 0 1 0 0-1h-.98a1.5 1.5 0 0 0-1.33.82l-1.23 2.4a.5.5 0 0 1-.91-.03L9.29 6.93a1.5 1.5 0 0 0-2.73-.11l-1.23 2.4a.5.5 0 0 1-.44.28H3.9a1.5 1.5 0 1 0 0 1h.98a1.5 1.5 0 0 0 1.33-.82z"
]);
const $f342bb1007016cbf$export$9589b97cc59faf4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUp24Filled', "24", [
    "M11.37 7.27a2 2 0 0 0-3.73.01l-1.2 3.15a.5.5 0 0 1-.47.32h-1.4a2 2 0 1 0 .28 2h1.12a2.5 2.5 0 0 0 2.33-1.6L9.51 8l3.22 8.23a2 2 0 0 0 3.67.13l1.6-3.32a.5.5 0 0 1 .44-.29h.7a2 2 0 1 0 .3-2h-1a2.5 2.5 0 0 0-2.25 1.42l-1.6 3.33z"
]);
const $f342bb1007016cbf$export$c0c2c47e407b537f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CatchUp24Regular', "24", [
    "M9.28 8.16c.08-.2.37-.21.46 0l3.24 7.76a1.75 1.75 0 0 0 3.17.12l1.6-3.13c.13-.25.39-.41.67-.41h.64a2 2 0 1 0 .2-1.5h-.84c-.85 0-1.62.47-2 1.23l-1.6 3.13a.25.25 0 0 1-.46-.01l-3.24-7.77a1.75 1.75 0 0 0-3.23.01l-1.2 2.94a.8.8 0 0 1-.7.47H4.73a2 2 0 1 0 .2 1.5H6c.92 0 1.74-.55 2.09-1.4z"
]);
const $f342bb1007016cbf$export$74ca99ef4f3ef979 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cone16Filled', "16", [
    "M8 15c-2.23 0-6-.42-6-2l.01-.12.05-.2.04-.1 5.45-11.3a.52.52 0 0 1 .9 0l5.45 11.3.04.1.05.2.01.12c0 1.58-3.77 2-6 2"
]);
const $f342bb1007016cbf$export$f71de1cdbac6a575 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Cone16Regular', "16", [
    "M8 15c-2.23 0-6-.42-6-2l.01-.12.05-.2.04-.1 5.45-11.3a.52.52 0 0 1 .9 0l5.45 11.3.04.1.05.2.01.12c0 1.58-3.77 2-6 2m-4.99-1.98c.2.34 2.03.98 4.99.98 2.94 0 4.76-.63 4.99-1l-.01-.03L8 2.65z"
]);
const $f342bb1007016cbf$export$ff80f455ce7ed53b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom16Filled', "16", [
    "M7.18 2.11a.5.5 0 0 1 .42-.1l5 1c.23.05.4.25.4.49v9a.5.5 0 0 1-.4.49l-5 1a.5.5 0 0 1-.6-.5V2.5M10 8a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0",
    "M6 3H3.5a.5.5 0 0 0-.5.5v9c0 .27.22.5.5.5H6z",
    "M7.18 2.11A.5.5 0 0 0 7 2.5Z"
]);
const $f342bb1007016cbf$export$e4e5c3ebdb5779da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom16Regular', "16", [
    "M10 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M7.6 2a.5.5 0 0 0-.6.49v11a.5.5 0 0 0 .6.49l5-1a.5.5 0 0 0 .4-.5V3.5a.5.5 0 0 0-.4-.49zM8 12.89V3.1l4 .8v8.18zm-2 .1v-1H4V4h2V3H3.5a.5.5 0 0 0-.5.5v9c0 .27.22.5.5.5z"
]);
const $f342bb1007016cbf$export$6089c0efb51bad61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom20Filled', "20", [
    "M9.19 2.11a.5.5 0 0 1 .41-.1l7 1.5c.23.05.4.25.4.5v12a.5.5 0 0 1-.4.48l-7 1.5a.5.5 0 0 1-.6-.49v-15q0-.24.19-.39m3.31 7.9a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M8 3H3.5a.5.5 0 0 0-.5.5V16.5c0 .27.22.5.5.5H8z"
]);
const $f342bb1007016cbf$export$cad1213baa48e86d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom20Regular', "20", [
    "M12.49 10a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.6 2.01a.5.5 0 0 0-.6.5V17.5a.5.5 0 0 0 .6.5l7-1.51A.5.5 0 0 0 17 16V4a.5.5 0 0 0-.4-.49zm.4 14.87V3.12l6 1.29V15.6zM8 17v-1H4V4h4V3H3.5a.5.5 0 0 0-.5.5v13c0 .27.22.5.5.5z"
]);
const $f342bb1007016cbf$export$6cfe615a8f9b7dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom24Filled', "24", [
    "m10.6 2.01 9 2c.23.05.4.25.4.49v15a.5.5 0 0 1-.4.5l-9 2a.5.5 0 0 1-.6-.5v-19a.5.5 0 0 1 .6-.49M9 4v16H4.75a.75.75 0 0 1-.74-.65l-.01-.1V4.75c0-.38.28-.7.65-.74l.1-.01zm4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $f342bb1007016cbf$export$29e76d7a59dc182c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom24Regular', "24", [
    "m10.82 2 .1.02 8.5 2c.3.07.53.32.57.63l.01.1v14.5c0 .31-.2.59-.48.7l-.1.03-8.5 2a.75.75 0 0 1-.91-.63l-.01-.1V2.75c0-.41.33-.74.72-.75zm.68 1.7v16.6l7-1.64V5.34zM9 4v1.5H5.5v13H9V20H4.75a.75.75 0 0 1-.74-.65l-.01-.1V4.75c0-.38.28-.7.65-.74l.1-.01zm5 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $f342bb1007016cbf$export$922bd3dff46dc1b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom28Filled', "28", [
    "m11.9 2.01 11.5 2.25c.35.07.6.38.6.74v18c0 .36-.25.67-.6.74l-11.5 2.25a.75.75 0 0 1-.9-.74V2.75c0-.47.43-.83.9-.74M15 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-5-8.5v19H4.75a.75.75 0 0 1-.74-.65l-.01-.1V5.25c0-.38.28-.7.65-.74l.1-.01z"
]);
const $f342bb1007016cbf$export$66551c8ba0b5ea92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom28Regular', "28", [
    "m11.9 2.01 11.5 2.25c.35.07.6.38.6.74v18c0 .36-.25.67-.6.74l-11.5 2.25a.75.75 0 0 1-.9-.74V2.75c0-.47.43-.83.9-.74m.6 1.65v20.68l10-1.96V5.62zM10 4.5V6H5.5v16H10v1.5H4.75a.75.75 0 0 1-.74-.65l-.01-.1V5.25c0-.38.28-.7.65-.74l.1-.01zm5 8.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
]);
const $f342bb1007016cbf$export$ba220caf4a9cd346 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom48Filled', "48", [
    "m22.5 7.78 14.5 3c.58.12 1 .63 1 1.22v24c0 .6-.42 1.1-1 1.22l-14.5 3c-.77.16-1.5-.43-1.5-1.22V9c0-.8.73-1.38 1.5-1.22M18 10l.13 28h-6.88c-.65 0-1.18-.5-1.24-1.12l-.01-.13v-25.5c0-.65.5-1.18 1.12-1.24l.13-.01zm8.5 12.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $f342bb1007016cbf$export$c33cd0ea05c06ace = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConferenceRoom48Regular', "48", [
    "m22.5 7.78 14.5 3c.58.12 1 .63 1 1.22v24c0 .6-.42 1.1-1 1.22l-14.5 3c-.77.16-1.5-.43-1.5-1.22V9c0-.8.73-1.38 1.5-1.22M18 10v2.5h-5.5v23H18V38h-6.75c-.65 0-1.18-.5-1.24-1.12l-.01-.13v-25.5c0-.65.5-1.18 1.12-1.24l.13-.01zm5.5.54v26.93l12-2.49V13.02zm3 11.96a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
]);
const $f342bb1007016cbf$export$2ae9258d19d9cc99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected16Filled', "16", [
    "M4.02 4.72a2 2 0 1 1 .7-.7l2.26 2.26a2 2 0 0 1 2.04 0l2.26-2.26a2 2 0 1 1 .7.7L9.72 6.98a2 2 0 0 1 0 2.04l2.26 2.26a2 2 0 1 1-.7.7L9.02 9.72a2 2 0 0 1-2.04 0l-2.26 2.26a2 2 0 1 1-.7-.7l2.26-2.26a2 2 0 0 1 0-2.04z"
]);
const $f342bb1007016cbf$export$f37b0684fe764413 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected16Regular', "16", [
    "M4.02 4.72a2 2 0 1 1 .7-.7l2.26 2.26a2 2 0 0 1 2.04 0l2.26-2.26a2 2 0 1 1 .7.7L9.72 6.98a2 2 0 0 1 0 2.04l2.26 2.26a2 2 0 1 1-.7.7L9.02 9.72a2 2 0 0 1-2.04 0l-2.26 2.26a2 2 0 1 1-.7-.7l2.26-2.26a2 2 0 0 1 0-2.04zM4 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0m9-9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $f342bb1007016cbf$export$33ad477ede2e5d1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected20Filled', "20", [
    "M7 4.5q-.01.77-.41 1.38L8.62 7.9a2.5 2.5 0 0 1 2.76 0l2.03-2.03q-.4-.6-.41-1.38a2.5 2.5 0 1 1 1.12 2.09L12.1 8.62a2.5 2.5 0 0 1 0 2.76l2.03 2.03q.6-.4 1.38-.41a2.5 2.5 0 1 1-2.09 1.12l-2.03-2.03a2.5 2.5 0 0 1-2.76 0L6.6 14.12q.4.6.41 1.38a2.5 2.5 0 1 1-1.12-2.09l2.03-2.03a2.5 2.5 0 0 1 0-2.76L5.88 6.6q-.6.4-1.38.41A2.5 2.5 0 1 1 7 4.5"
]);
const $f342bb1007016cbf$export$90d146f853845948 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected20Regular', "20", [
    "M5.88 6.59q-.6.4-1.38.41a2.5 2.5 0 1 1 2.09-1.12L8.62 7.9a2.5 2.5 0 0 1 2.76 0l2.03-2.03q-.4-.6-.41-1.38a2.5 2.5 0 1 1 1.12 2.09L12.1 8.62a2.5 2.5 0 0 1 0 2.76l2.03 2.03q.6-.4 1.38-.41a2.5 2.5 0 1 1-2.09 1.12l-2.03-2.03a2.5 2.5 0 0 1-2.76 0L6.6 14.12q.4.6.41 1.38a2.5 2.5 0 1 1-1.12-2.09l2.03-2.03a2.5 2.5 0 0 1 0-2.76zM6 4.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m11 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M4.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
]);
const $f342bb1007016cbf$export$7c0a7103141718e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected24Filled', "24", [
    "M19 2a3 3 0 1 1-1.52 5.58l-2.9 2.9a3 3 0 0 1 0 3.04l2.9 2.9Q18.15 16 19 16a3 3 0 1 1-2.58 1.48l-2.9-2.9a3 3 0 0 1-3.04 0l-2.9 2.9Q8 18.15 8 19a3 3 0 1 1-1.48-2.58l2.9-2.9a3 3 0 0 1 0-3.04l-2.9-2.9Q5.84 8 5 8a3 3 0 1 1 2.58-1.48l2.9 2.9a3 3 0 0 1 3.04 0l2.9-2.9A3 3 0 0 1 19 2"
]);
const $f342bb1007016cbf$export$3582e52a1cada82e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected24Regular', "24", [
    "M19 2a3 3 0 1 1-1.52 5.58l-2.9 2.9a3 3 0 0 1 0 3.04l2.9 2.9Q18.15 16 19 16a3 3 0 1 1-2.58 1.48l-2.9-2.9a3 3 0 0 1-3.04 0l-2.9 2.9Q8 18.15 8 19a3 3 0 1 1-1.48-2.58l2.9-2.9a3 3 0 0 1 0-3.04l-2.9-2.9Q5.84 8 5 8a3 3 0 1 1 2.58-1.48l2.9 2.9a3 3 0 0 1 3.04 0l2.9-2.9A3 3 0 0 1 19 2M5 17.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m14 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7-7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7-7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m14 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $f342bb1007016cbf$export$a04afae3fee9681b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected28Filled', "28", [
    "M22.5 2a3.5 3.5 0 1 1-1.89 6.45l-3.66 3.66a3.5 3.5 0 0 1 0 3.78l3.66 3.66q.84-.54 1.89-.55a3.5 3.5 0 1 1-2.95 1.61l-3.66-3.66a3.5 3.5 0 0 1-3.78 0L8.45 20.6q.54.84.55 1.89a3.5 3.5 0 1 1-1.61-2.95l3.66-3.66a3.5 3.5 0 0 1 0-3.78L7.4 8.45q-.84.54-1.89.55a3.5 3.5 0 1 1 2.95-1.61l3.66 3.66a3.5 3.5 0 0 1 3.78 0l3.66-3.66A3.5 3.5 0 0 1 22.5 2"
]);
const $f342bb1007016cbf$export$46f26554889173b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected28Regular', "28", [
    "M22.5 2a3.5 3.5 0 1 1-1.89 6.45l-3.66 3.66a3.5 3.5 0 0 1 0 3.78l3.66 3.66q.84-.54 1.89-.55a3.5 3.5 0 1 1-2.95 1.61l-3.66-3.66a3.5 3.5 0 0 1-3.78 0L8.45 20.6q.54.84.55 1.89a3.5 3.5 0 1 1-1.61-2.95l3.66-3.66a3.5 3.5 0 0 1 0-3.78L7.4 8.45q-.84.54-1.89.55a3.5 3.5 0 1 1 2.95-1.61l3.66 3.66a3.5 3.5 0 0 1 3.78 0l3.66-3.66A3.5 3.5 0 0 1 22.5 2m-17 18.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m17 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4M14 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5.5 3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m17 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $f342bb1007016cbf$export$12309c7fdf32c582 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected32Filled', "32", [
    "M11 6.5q-.02 1.33-.69 2.4l3.3 3.29a4.5 4.5 0 0 1 4.79 0l3.29-3.3a4.5 4.5 0 1 1 1.41 1.41l-3.29 3.3a4.5 4.5 0 0 1 0 4.8l3.3 3.29q1.05-.68 2.39-.69a4.5 4.5 0 1 1-3.81 2.1l-3.3-3.29a4.5 4.5 0 0 1-4.79 0l-3.29 3.3q.67 1.05.69 2.39a4.5 4.5 0 1 1-2.1-3.81l3.29-3.3a4.5 4.5 0 0 1 0-4.79l-3.3-3.29q-1.04.67-2.39.69A4.5 4.5 0 1 1 11 6.5"
]);
const $f342bb1007016cbf$export$c1b778a6bd6f9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected32Regular', "32", [
    "M6.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2 6.5a4.5 4.5 0 1 1 8.31 2.4l3.3 3.29a4.5 4.5 0 0 1 4.79 0l3.29-3.3a4.5 4.5 0 1 1 1.41 1.41l-3.29 3.3a4.5 4.5 0 0 1 0 4.8l3.3 3.29q1.05-.68 2.39-.69a4.5 4.5 0 1 1-3.81 2.1l-3.3-3.29a4.5 4.5 0 0 1-4.79 0l-3.29 3.3q.67 1.05.69 2.39a4.5 4.5 0 1 1-2.1-3.81l3.29-3.3a4.5 4.5 0 0 1 0-4.79l-3.3-3.29q-1.04.67-2.39.69A4.5 4.5 0 0 1 2 6.5M25.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 25.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0m12-12a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m7 12a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0"
]);
const $f342bb1007016cbf$export$988f444e5b1c0218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected48Filled', "48", [
    "M38 4a6 6 0 1 1-3.27 11.03l-5.7 5.7a6 6 0 0 1 0 6.53l5.7 5.7a6 6 0 1 1-1.77 1.77l-5.7-5.7a6 6 0 0 1-6.53 0l-5.7 5.7a6 6 0 1 1-1.77-1.77l5.7-5.7a6 6 0 0 1 0-6.53l-5.7-5.7a6 6 0 1 1 1.77-1.77l5.7 5.7a6 6 0 0 1 6.53 0l5.7-5.7A6 6 0 0 1 38 4"
]);
const $f342bb1007016cbf$export$6f395e8598b35865 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connected48Regular', "48", [
    "M38 4a6 6 0 1 1-3.27 11.03l-5.7 5.7a6 6 0 0 1 0 6.53l5.7 5.7a6 6 0 1 1-1.77 1.77l-5.7-5.7a6 6 0 0 1-6.53 0l-5.7 5.7a6 6 0 1 1-1.77-1.77l5.7-5.7a6 6 0 0 1 0-6.53l-5.7-5.7a6 6 0 1 1 1.77-1.77l5.7 5.7a6 6 0 0 1 6.53 0l5.7-5.7A6 6 0 0 1 38 4M10 34.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m28 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-14-14a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-14-14a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m28 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $f342bb1007016cbf$export$812749c2d4af2998 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connector16Filled', "16", [
    "M3.5 3a.5.5 0 0 0-.5.5v1.88l-.95 1.9A1 1 0 0 0 2 7.5v3c0 .28.22.5.5.5H3v1.5a.5.5 0 0 0 1 0V11h1v1.5a.5.5 0 0 0 1 0V11h.5a.5.5 0 0 0 .5-.5v-3a1 1 0 0 0-.05-.22L6 5.38V3.5a.5.5 0 0 0-.5-.5zm9 10h-2a.5.5 0 0 1-.5-.5v-1.88l-.95-1.9A1 1 0 0 1 9 8.5v-3c0-.28.22-.5.5-.5h.5V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V5h.5c.28 0 .5.22.5.5v3a1 1 0 0 1-.05.22l-.95 1.9v1.88a.5.5 0 0 1-.5.5M11 5h1V4h-1z"
]);
const $f342bb1007016cbf$export$5a09f65d1146319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connector16Regular', "16", [
    "M4 3.5a.5.5 0 0 0-1 0v1.88l-.95 1.9A1 1 0 0 0 2 7.5v3c0 .28.22.5.5.5H3v1.5a.5.5 0 0 0 1 0V11h1v1.5a.5.5 0 0 0 1 0V11h.5a.5.5 0 0 0 .5-.5v-3a1 1 0 0 0-.05-.22L6 5.38V3.5a.5.5 0 0 0-1 0v2q0 .12.05.22L6 7.62V10H3V7.62l.95-1.9A1 1 0 0 0 4 5.5zm8 9v-2a1 1 0 0 1 .05-.22l.95-1.9V6h-3v2.38l.95 1.9a1 1 0 0 1 .05.22v2a.5.5 0 0 1-1 0v-1.88l-.95-1.9A1 1 0 0 1 9 8.5v-3c0-.28.22-.5.5-.5h.5V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V5h.5a.5.5 0 0 1 .5.5v3a1 1 0 0 1-.05.22l-.95 1.9v1.88a.5.5 0 0 1-1 0M11 5h1V4h-1z"
]);
const $f342bb1007016cbf$export$b9623e677b761d54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connector20Filled', "20", [
    "M4.5 3a.5.5 0 0 0-.5.5v2.8L2.15 8.14A.5.5 0 0 0 2 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 0 0 1 0V14h1v2.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.15-.35L7 6.29V3.5a.5.5 0 0 0-.5-.5zm11 14a.5.5 0 0 0 .5-.5v-2.8l1.85-1.85a.5.5 0 0 0 .15-.35v-5a.5.5 0 0 0-.5-.5H17V3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V6h-.5a.5.5 0 0 0-.5.5v5q0 .2.15.35L13 13.71v2.79c0 .28.22.5.5.5zM13 6V4h3v2z"
]);
const $f342bb1007016cbf$export$ae79c9f7689d678b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connector20Regular', "20", [
    "M5 3.5a.5.5 0 0 0-1 0v2.8L2.15 8.14A.5.5 0 0 0 2 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 0 0 1 0V14h1v2.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.15-.35L7 6.29V3.5a.5.5 0 0 0-1 0v3q0 .2.15.35L8 8.71V13H3V8.7l1.85-1.85A.5.5 0 0 0 5 6.5zm10 13v-3a.5.5 0 0 1 .15-.35L17 11.29V7h-5v4.3l1.85 1.85q.15.14.15.35v3a.5.5 0 0 1-1 0v-2.8l-1.85-1.85a.5.5 0 0 1-.15-.35v-5c0-.28.22-.5.5-.5h.5V3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V6h.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.15.35L16 13.71v2.79a.5.5 0 0 1-1 0M13 6h3V4h-3z"
]);
const $f342bb1007016cbf$export$4fb84a10f1c7f850 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connector24Filled', "24", [
    "M8.25 4c.42 0 .75.34.75.75v2.77l1.88 2.82q.12.19.12.41v4.5c0 .41-.33.75-.75.75H9v3.25a.75.75 0 0 1-1.5.1V16h-2v3.26a.75.75 0 0 1-1.49.1V16H2.74a.75.75 0 0 1-.75-.75v-4.5q0-.22.13-.41L4 7.52V4.75c0-.41.34-.75.75-.75zm7 0h4.5c.38 0 .7.28.74.65l.01.1V8h.75c.42 0 .75.34.75.75v4.5q0 .22-.12.41L20 16.48v2.77c0 .41-.33.75-.75.75h-3.5a.75.75 0 0 1-.75-.75v-2.77l-1.87-2.82a1 1 0 0 1-.13-.41v-4.5c0-.41.34-.75.75-.75h.76V4.75c0-.38.28-.7.64-.74zh4.5zM19 5.5h-3V8h3z"
]);
const $f342bb1007016cbf$export$1a6f94c98fa88ce0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Connector24Regular', "24", [
    "M8.25 4c.38 0 .7.28.74.65l.01.1v2.77l1.88 2.82q.1.15.11.3l.01.11v4.5c0 .38-.28.7-.65.74l-.1.01H9v3.25a.75.75 0 0 1-1.5.1V16h-2v3.26a.75.75 0 0 1-1.49.1V16H2.74a.75.75 0 0 1-.74-.65v-4.6q0-.16.07-.32l.05-.1L4 7.54V4.74a.75.75 0 0 1 1.5-.1v3.1q0 .17-.07.32l-.05.1-1.88 2.81v3.52h6v-3.52L7.63 8.17a1 1 0 0 1-.12-.31V4.75c0-.41.33-.75.74-.75m7 0h4.5c.38 0 .7.28.74.65l.01.1V8h.75c.38 0 .7.28.74.65l.01.1v4.5q0 .16-.07.32l-.05.1-1.88 2.8v2.78a.75.75 0 0 1-1.5.1v-3.1q0-.17.07-.32l.06-.1 1.87-2.81V9.5h-6v3.52l1.88 2.81q.09.15.12.31v3.11a.75.75 0 0 1-1.49.1v-2.87l-1.88-2.82a1 1 0 0 1-.12-.3V8.75c0-.38.28-.7.64-.74l.1-.01h.76V4.75c0-.38.28-.7.64-.74zh4.5zM19 5.5h-3V8h3z"
]);
const $f342bb1007016cbf$export$d9f7478d30b6607d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_16_color__a)",
            "d": "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H2.75C1.78 13 1 12.22 1 11.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_16_color__b)",
            "fillOpacity": ".7",
            "d": "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H2.75C1.78 13 1 12.22 1 11.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_16_color__c)",
            "d": "M9.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_16_color__d)",
            "d": "M3.86 8.4a.86.86 0 0 0-.86.85c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06a1.7 1.7 0 0 0 1.26-1.63.86.86 0 0 0-.86-.86z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_16_color__e)",
            "d": "M5.26 7.71a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_16_color__a",
                "x1": "6",
                "x2": "8.94",
                "y1": "3",
                "y2": "13.16",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_16_color__b",
                "x1": "10.17",
                "x2": "12.63",
                "y1": "4.23",
                "y2": "18.6",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_16_color__c",
                "x1": "10.64",
                "x2": "12.65",
                "y1": "5.54",
                "y2": "13.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_16_color__d",
                "x1": "3",
                "x2": "4",
                "y1": "6.81",
                "y2": "11.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_16_color__e",
                "x1": "3.9",
                "x2": "5.93",
                "y1": "4.1",
                "y2": "7.57",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$f3e1e66d54b373da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard16Filled', "16", [
    "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H2.75C1.78 13 1 12.22 1 11.25zm4.26 2.96a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71m-1.4.68a.86.86 0 0 0-.86.86c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06a1.7 1.7 0 0 0 1.26-1.63.86.86 0 0 0-.86-.86zM9.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$1ba53c606dba2d52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard16Regular', "16", [
    "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H2.75C1.78 13 1 12.22 1 11.25zM2.75 4a.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75v-6.5a.75.75 0 0 0-.75-.75zM9.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.26 7.71a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71m-1.4.68a.86.86 0 0 0-.86.86c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06a1.7 1.7 0 0 0 1.26-1.63.86.86 0 0 0-.86-.86z"
]);
const $f342bb1007016cbf$export$73b0b67464d1f168 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__a)",
            "d": "M2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__b)",
            "fillOpacity": ".7",
            "d": "M2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__c)",
            "d": "M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__d)",
            "d": "M4 11.7c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_20_color__e)",
            "d": "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__a",
                "x1": "7.71",
                "x2": "11.39",
                "y1": "4",
                "y2": "16.1",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__b",
                "x1": "12.48",
                "x2": "15.57",
                "y1": "5.47",
                "y2": "22.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__c",
                "x1": "12.64",
                "x2": "14.65",
                "y1": "7.54",
                "y2": "15.2",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__d",
                "x1": "4",
                "x2": "5.1",
                "y1": "9",
                "y2": "14.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_20_color__e",
                "x1": "5",
                "x2": "7.24",
                "y1": "6",
                "y2": "9.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$d75b3b736f62e341 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard20Filled', "20", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm3 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-1.55.75h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94M11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $f342bb1007016cbf$export$7c4c1f7cc938a782 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard20Regular', "20", [
    "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25zM3.75 5a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75z"
]);
const $f342bb1007016cbf$export$d83413b26c240efe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_24_color__a)",
            "d": "M19.75 4C20.99 4 22 5 22 6.25v11.5C22 19 21 20 19.75 20H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_24_color__b)",
            "fillOpacity": ".7",
            "d": "M19.75 4C20.99 4 22 5 22 6.25v11.5C22 19 21 20 19.75 20H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_24_color__c)",
            "d": "M13.25 13h4.5a.75.75 0 0 1 .1 1.49h-4.6a.75.75 0 0 1-.1-1.49zh4.5zm0-3.5h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5zh4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_24_color__d)",
            "d": "M9.75 12.5c.41 0 .75.34.75.75v.6c-.17 1.11-1.1 1.65-2.5 1.65s-2.33-.54-2.5-1.65v-.6c0-.41.34-.75.75-.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_24_color__e)",
            "d": "M8 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_24_color__a",
                "x1": "9.14",
                "x2": "14.31",
                "y1": "4",
                "y2": "19.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_24_color__b",
                "x1": "15.1",
                "x2": "19.49",
                "y1": "5.97",
                "y2": "28.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_24_color__c",
                "x1": "14.96",
                "x2": "17.1",
                "y1": "8.92",
                "y2": "18.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_24_color__d",
                "x1": "5.5",
                "x2": "6.69",
                "y1": "10.68",
                "y2": "15.92",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_24_color__e",
                "x1": "6.5",
                "x2": "8.74",
                "y1": "7.5",
                "y2": "11.34",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$7bcabec19e985a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard24Filled', "24", [
    "M19.75 4C20.99 4 22 5 22 6.25v11.5C22 19 21 20 19.75 20H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4zm-10 8.5h-3.5c-.38 0-.7.28-.74.65l-.01.1v.6c.17 1.11 1.1 1.65 2.5 1.65 1.33 0 2.24-.49 2.46-1.5l.03-.15.01-.1v-.5c0-.38-.28-.7-.65-.74zm8 .5h-4.6a.75.75 0 0 0 0 1.49h4.7a.75.75 0 0 0 0-1.49zM8 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m9.75 1h-4.6a.75.75 0 0 0 0 1.5h4.7a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$df6bcccb5c349c7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard24Regular', "24", [
    "M19.75 4C20.99 4 22 5 22 6.25v11.5C22 19 21 20 19.75 20H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4zm0 1.5H4.25a.75.75 0 0 0-.75.75v11.5c0 .42.34.75.75.75h15.5c.41 0 .75-.33.75-.75V6.25a.75.75 0 0 0-.75-.75m-10 7c.41 0 .75.34.75.75v.6c-.17 1.11-1.1 1.65-2.5 1.65s-2.33-.54-2.5-1.65v-.6c0-.41.34-.75.75-.75zm3.5.5h4.5a.75.75 0 0 1 .1 1.49h-4.6a.75.75 0 0 1-.1-1.49zh4.5zM8 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5.25 1h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5zh4.5z"
]);
const $f342bb1007016cbf$export$f07b9509745c3de7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_28_color__a)",
            "d": "M2 6.75A2.75 2.75 0 0 1 4.75 4h18.5A2.75 2.75 0 0 1 26 6.75v14.5A2.75 2.75 0 0 1 23.25 24H4.75A2.75 2.75 0 0 1 2 21.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_28_color__b)",
            "fillOpacity": ".7",
            "d": "M2 6.75A2.75 2.75 0 0 1 4.75 4h18.5A2.75 2.75 0 0 1 26 6.75v14.5A2.75 2.75 0 0 1 23.25 24H4.75A2.75 2.75 0 0 1 2 21.25z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_28_color__c)",
            "d": "M15 11.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_28_color__d)",
            "d": "M7 14.5h5a1 1 0 0 1 1 1v.5s-.5 2.5-3.5 2.5S6 16 6 16v-.5a1 1 0 0 1 1-1"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_28_color__e)",
            "d": "M11.25 11.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_28_color__a",
                "x1": "10.57",
                "x2": "17.25",
                "y1": "4",
                "y2": "23.77",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_28_color__b",
                "x1": "17.72",
                "x2": "23.41",
                "y1": "6.46",
                "y2": "34.9",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_28_color__c",
                "x1": "17.86",
                "x2": "20.1",
                "y1": "10.37",
                "y2": "21.17",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_28_color__d",
                "x1": "6",
                "x2": "7.52",
                "y1": "12.07",
                "y2": "19.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_28_color__e",
                "x1": "7.75",
                "x2": "10.37",
                "y1": "8.83",
                "y2": "13.31",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$feb1ff2f309adb14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard28Filled', "28", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v14.5A2.75 2.75 0 0 0 4.75 24h18.5A2.75 2.75 0 0 0 26 21.25V6.75A2.75 2.75 0 0 0 23.25 4zM15 11.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3.25h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5m-4.5-3.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 14.5h5a1 1 0 0 1 1 1v.5s-.5 2.5-3.5 2.5S6 16 6 16v-.5a1 1 0 0 1 1-1"
]);
const $f342bb1007016cbf$export$c3a9b17a33a839d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard28Regular', "28", [
    "M15 11.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm-4.5-3.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 14.5h5a1 1 0 0 1 1 1v.5s-.5 2.5-3.5 2.5S6 16 6 16v-.5a1 1 0 0 1 1-1M2 6.75A2.75 2.75 0 0 1 4.75 4h18.5A2.75 2.75 0 0 1 26 6.75v14.5A2.75 2.75 0 0 1 23.25 24H4.75A2.75 2.75 0 0 1 2 21.25zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v14.5c0 .69.56 1.25 1.25 1.25h18.5c.7 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25z"
]);
const $f342bb1007016cbf$export$62f067e93e2202fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_32_color__a)",
            "d": "M2 7.25C2 5.45 3.46 4 5.25 4h21.5C28.55 4 30 5.46 30 7.25v17.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 24.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_32_color__b)",
            "fillOpacity": ".7",
            "d": "M2 7.25C2 5.45 3.46 4 5.25 4h21.5C28.55 4 30 5.46 30 7.25v17.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 24.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_32_color__c)",
            "d": "M18 13a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_32_color__d)",
            "d": "M7 17.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5 0 0 0 3.5-4 3.5s-4-3.5-4-3.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_32_color__e)",
            "d": "M13 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_32_color__a",
                "x1": "12",
                "x2": "20.19",
                "y1": "4",
                "y2": "27.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_32_color__b",
                "x1": "20.33",
                "x2": "27.35",
                "y1": "6.95",
                "y2": "41.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_32_color__c",
                "x1": "21.27",
                "x2": "24.41",
                "y1": "11.19",
                "y2": "24.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_32_color__d",
                "x1": "7",
                "x2": "9.06",
                "y1": "12.97",
                "y2": "21.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_32_color__e",
                "x1": "9",
                "x2": "11.99",
                "y1": "9.67",
                "y2": "14.79",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$212939180bfb0f54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard32Filled', "32", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v17.5C2 26.55 3.46 28 5.25 28h21.5c1.8 0 3.25-1.46 3.25-3.25V7.25C30 5.45 28.54 4 26.75 4zM18 13a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1m1 4h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2m-6-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-6 4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5 0 0 0 3.5-4 3.5s-4-3.5-4-3.5"
]);
const $f342bb1007016cbf$export$70ec8ad7308e0a91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard32Regular', "32", [
    "M18 13a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1m1 4a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2zm-6-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-6 4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5 0 0 0 3.5-4 3.5s-4-3.5-4-3.5M2 7.25C2 5.45 3.46 4 5.25 4h21.5C28.55 4 30 5.46 30 7.25v17.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 24.75zM5.25 6C4.56 6 4 6.56 4 7.25v17.5c0 .69.56 1.25 1.25 1.25h21.5c.69 0 1.25-.56 1.25-1.25V7.25C28 6.56 27.44 6 26.75 6z"
]);
const $f342bb1007016cbf$export$1a5dbf9bc933f2d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_48_color__a)",
            "d": "M4 12.25C4 9.9 5.9 8 8.25 8h31.5C42.1 8 44 9.9 44 12.25v23.5C44 38.1 42.1 40 39.75 40H8.25A4.25 4.25 0 0 1 4 35.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_48_color__b)",
            "fillOpacity": ".7",
            "d": "M4 12.25C4 9.9 5.9 8 8.25 8h31.5C42.1 8 44 9.9 44 12.25v23.5C44 38.1 42.1 40 39.75 40H8.25A4.25 4.25 0 0 1 4 35.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_48_color__c)",
            "d": "M25 20.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25M26.25 26a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_48_color__d)",
            "d": "M11 26.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v.5s0 4-5 4-5-4-5-4z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_contact_card_48_color__e)",
            "d": "M19 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_48_color__a",
                "x1": "18.29",
                "x2": "28.62",
                "y1": "8",
                "y2": "39.89",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_48_color__b",
                "x1": "30.19",
                "x2": "38.97",
                "y1": "11.93",
                "y2": "57.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_48_color__c",
                "x1": "29.91",
                "x2": "33.79",
                "y1": "17.9",
                "y2": "36.55",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0078d4"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#0067bf"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_48_color__d",
                "x1": "11",
                "x2": "13.38",
                "y1": "21.36",
                "y2": "31.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_contact_card_48_color__e",
                "x1": "13",
                "x2": "17.48",
                "y1": "15",
                "y2": "22.68",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".13",
                    "stopColor": "#9c6cfe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#7a41dc"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$8e736cd3256ea255 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard48Filled', "48", [
    "M8.25 8A4.25 4.25 0 0 0 4 12.25v23.5C4 38.1 5.9 40 8.25 40h31.5C42.1 40 44 38.1 44 35.75v-23.5C44 9.9 42.1 8 39.75 8zM19 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-8 6.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v.5s0 4-5 4-5-4-5-4zm14-6.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25M26.25 26h9.5a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5"
]);
const $f342bb1007016cbf$export$de29cc928e383e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCard48Regular', "48", [
    "M19 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-8 6.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v.5s0 4-5 4-5-4-5-4zm14-6.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25M26.25 26a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM4 12.25C4 9.9 5.9 8 8.25 8h31.5C42.1 8 44 9.9 44 12.25v23.5C44 38.1 42.1 40 39.75 40H8.25A4.25 4.25 0 0 1 4 35.75zm4.25-1.75c-.97 0-1.75.78-1.75 1.75v23.5c0 .97.78 1.75 1.75 1.75h31.5c.97 0 1.75-.78 1.75-1.75v-23.5c0-.97-.78-1.75-1.75-1.75z"
]);
const $f342bb1007016cbf$export$66fcceaae16e535a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric16Filled', "16", [
    "M13.25 3c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H2.75C1.78 13 1 12.22 1 11.25v-6.5C1 3.78 1.78 3 2.75 3zM5.5 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m4 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-4-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$2731346cdd4d5206 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric16Regular', "16", [
    "M13.25 3c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H2.75C1.78 13 1 12.22 1 11.25v-6.5C1 3.78 1.78 3 2.75 3zM2.75 4a.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75v-6.5a.75.75 0 0 0-.75-.75zM5.5 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m7 3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm-7-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7-1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $f342bb1007016cbf$export$38da114a2dea3ddd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric20Filled', "20", [
    "M16 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zM7 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m4.5 3.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM7 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4.5-.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$ee2a8ab556f19708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric20Regular', "20", [
    "M16.25 4c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25v-8.5C2 4.78 2.78 4 3.75 4zM3.75 5a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75zM7 7.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m7.5 3.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM7 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7.5-.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
]);
const $f342bb1007016cbf$export$286621945698d27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric24Filled', "24", [
    "M19.75 4C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4zM8 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m5.25 4a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM8 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5.25-1a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$97e1ea8e773a68b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric24Regular', "24", [
    "M19.75 4C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4zM4.25 5.5a.75.75 0 0 0-.75.75v11.5c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0-.75-.75zM8 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6m9.75 4a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zM8 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m9.75-1a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5z"
]);
const $f342bb1007016cbf$export$89de4fa06e67b7fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric28Filled', "28", [
    "M23.25 4A2.75 2.75 0 0 1 26 6.75v14.5A2.75 2.75 0 0 1 23.25 24H4.75A2.75 2.75 0 0 1 2 21.25V6.75A2.75 2.75 0 0 1 4.75 4zM9.5 10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 1.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m6.25 3.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm0-4a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$ed64422148445081 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric28Regular', "28", [
    "M23.25 4A2.75 2.75 0 0 1 26 6.75v14.5A2.75 2.75 0 0 1 23.25 24H4.75A2.75 2.75 0 0 1 2 21.25V6.75A2.75 2.75 0 0 1 4.75 4zM4.75 5.5c-.69 0-1.25.56-1.25 1.25v14.5c0 .69.56 1.25 1.25 1.25h18.5c.7 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25zM9.5 10a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M21.25 15a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5zm0-4a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
]);
const $f342bb1007016cbf$export$9b703269d4794aac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric32Filled', "32", [
    "M26.75 4C28.55 4 30 5.46 30 7.25v17.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 24.75V7.25C2 5.45 3.46 4 5.25 4zM11 11a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m8 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm0-5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
]);
const $f342bb1007016cbf$export$7e2eaf260f0bc66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric32Regular', "32", [
    "M26.92 4A3.25 3.25 0 0 1 30 7.25v17.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 24.75V7.25C2 5.45 3.46 4 5.25 4h21.67M5.25 6C4.56 6 4 6.56 4 7.25v17.5c0 .69.56 1.25 1.25 1.25h21.5c.69 0 1.25-.56 1.25-1.25V7.25c0-.65-.5-1.18-1.12-1.24L26.75 6zM11 11a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6m14 4a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2zm0-5a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2z"
]);
const $f342bb1007016cbf$export$ceaf9485c60d7d3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric48Filled', "48", [
    "M39.75 8C42.1 8 44 9.9 44 12.25v23.5C44 38.1 42.1 40 39.75 40H8.25A4.25 4.25 0 0 1 4 35.75v-23.5C4 9.9 5.9 8 8.25 8zM16 17.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M26.25 26a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5zM16 20a4 4 0 1 1 0 8 4 4 0 0 1 0-8m10.25-1a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $f342bb1007016cbf$export$2ffd165550daa2f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGeneric48Regular', "48", [
    "M39.75 8C42.1 8 44 9.9 44 12.25v23.5C44 38.1 42.1 40 39.75 40H8.25A4.25 4.25 0 0 1 4 35.75v-23.5C4 9.9 5.9 8 8.25 8zm-31.5 2.5c-.97 0-1.75.78-1.75 1.75v23.5c0 .97.78 1.75 1.75 1.75h31.5c.97 0 1.75-.78 1.75-1.75v-23.5c0-.97-.78-1.75-1.75-1.75zm7.75 7a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M35.75 26a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5zM16 20a4 4 0 1 0 0 8 4 4 0 0 0 0-8m19.75-1a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5z"
]);
const $f342bb1007016cbf$export$2b879a709b50331e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup16Filled', "16", [
    "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 3zM10 6.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m.5 2.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1M6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M3.75 8h2.5c.41 0 .75.34.75.75v.75S7 11 5 11 3 9.5 3 9.5v-.75c0-.41.34-.75.75-.75M8.5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.56 3.7L8 9.56v-.81q0-.4-.17-.75h.67c.28 0 .5.22.5.5V9a1 1 0 0 1-1 1h-.07z"
]);
const $f342bb1007016cbf$export$d564932fc34d2c4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup16Regular', "16", [
    "M10 6.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M3.75 8a.75.75 0 0 0-.75.75v.75S3 11 5 11s2-1.5 2-1.5v-.75A.75.75 0 0 0 6.25 8zM8.5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.56 3.7V10H8a1 1 0 0 0 1-1v-.5a.5.5 0 0 0-.5-.5h-.67q.17.35.17.75v.81a2 2 0 0 1-.06.4M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM3.5 4C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5z"
]);
const $f342bb1007016cbf$export$39dfad3504284e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup20Filled', "20", [
    "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M4 10.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 .75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5zM6.25 9a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.25-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.07 3.98.07-.41v-.82q0-.4-.17-.75H10a1 1 0 0 1 1 1c0 .83-.67 1.5-1.5 1.5h-.26q.15-.3.2-.52"
]);
const $f342bb1007016cbf$export$ef105db6080477cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup20Regular', "20", [
    "M12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m0 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-8-.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 .75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5zM6.25 9a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.25-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.07 3.98q-.05.23-.2.52h.27c.83 0 1.5-.67 1.5-1.5a1 1 0 0 0-1-1h-.67q.17.35.17.75v.82a2 2 0 0 1-.07.4M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5z"
]);
const $f342bb1007016cbf$export$277d88ee5d2782ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5a3.25 3.25 0 0 1 3.07-3.24L5.25 4zm-9.5 8.5h-3.5c-.38 0-.7.28-.74.65l-.01.1v.58c0 1.27.97 1.92 2.5 1.92 1.47 0 2.42-.6 2.5-1.76v-.74c0-.38-.28-.7-.65-.74zm3 0h-1.42q.14.27.17.59v1q-.04.5-.21.9l.34.01c1.05 0 1.79-.4 1.86-1.27l.01-.15v-.33c0-.38-.28-.7-.65-.74zh-1.42zm6 0h-3.1a.75.75 0 0 0 0 1.5h3.2a.75.75 0 0 0 0-1.5zM7.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m3.87.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m6.88.5h-3.1a.75.75 0 0 0 0 1.5h3.2a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$6c67e3ae682e55ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup24Regular', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5a3.25 3.25 0 0 1 3.07-3.24L5.25 4zm0 1.5H5.11c-.9.08-1.61.83-1.61 1.75v9.5c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75m-9.5 7c.42 0 .75.34.75.75v.58c0 1.27-.97 1.92-2.5 1.92S5 15.1 5 13.83v-.58c0-.41.34-.75.75-.75zm1.58 0h1.42c.41 0 .75.34.75.75v.33c0 .97-.77 1.42-1.87 1.42q-.18 0-.34-.02.17-.39.2-.9l.01-.25v-.58q0-.4-.17-.75m4.42 0h3a.75.75 0 0 1 .1 1.5h-3.1a.75.75 0 0 1-.1-1.5zh3zm-7.75-4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m3.87.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m3.88.5h3a.75.75 0 0 1 .1 1.5h-3.1a.75.75 0 0 1-.1-1.5zh3z"
]);
const $f342bb1007016cbf$export$d789649933f54a39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup28Filled', "28", [
    "M2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75m15 4.5c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m.75 2.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 1 1 0-1.5M15 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-8 2.5h3.5a1 1 0 0 1 1 1v1s0 2-2.75 2-2.75-2-2.75-2v-1a1 1 0 0 1 1-1m3.5-2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3 5.75h-1.21a3 3 0 0 0 .2-.97l.01-.03v-1a2 2 0 0 0-.27-1h2.27a1 1 0 0 1 1 1 2 2 0 0 1-2 2"
]);
const $f342bb1007016cbf$export$6995c007675cf89c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup28Regular', "28", [
    "M17 12.25c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m.75 2.75a.75.75 0 1 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM15 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-8 2.5a1 1 0 0 0-1 1v1s0 2 2.75 2 2.75-2 2.75-2v-1a1 1 0 0 0-1-1zm3.5-2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m3 5.75h-1.21a3 3 0 0 0 .2-.93v-.02h.01V15.5a2 2 0 0 0-.27-1h2.27a1 1 0 0 1 1 1 2 2 0 0 1-2 2M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25zM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25z"
]);
const $f342bb1007016cbf$export$b586e543e37d5c9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup48Filled', "48", [
    "M10.25 8A6.25 6.25 0 0 0 4 14.25v19.5C4 37.2 6.8 40 10.25 40h27.5C41.2 40 44 37.2 44 33.75v-19.5C44 10.8 41.2 8 37.75 8zM18 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0m4.5 3a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m6.5-1.75c0-.69.56-1.25 1.25-1.25h6.5a1.25 1.25 0 1 1 0 2.5h-6.5c-.69 0-1.25-.56-1.25-1.25m1.25 4.25h6.5a1.25 1.25 0 1 1 0 2.5h-6.5a1.25 1.25 0 1 1 0-2.5M10 26.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V28s0 3.5-5 3.5-5-3.5-5-3.5zM23 30h-1.47a6 6 0 0 0 .47-1.94V26.5q0-.82-.34-1.5h2.84c.83 0 1.5.67 1.5 1.5v.5a3 3 0 0 1-3 3"
]);
const $f342bb1007016cbf$export$42336afe823df6f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardGroup48Regular', "48", [
    "M18 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0m4.5 3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m6.5-1.75c0-.69.56-1.25 1.25-1.25h6.5a1.25 1.25 0 1 1 0 2.5h-6.5c-.69 0-1.25-.56-1.25-1.25m1.25 4.25a1.25 1.25 0 1 0 0 2.5h6.5a1.25 1.25 0 1 0 0-2.5zM10 26.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V28s0 3.5-5 3.5-5-3.5-5-3.5zm11.87 2.51q-.1.44-.34.99H23a3 3 0 0 0 3-3v-.5c0-.83-.67-1.5-1.5-1.5h-2.84q.33.68.34 1.5v1.56l-.02.3q-.02.25-.11.65M4 14.25C4 10.8 6.8 8 10.25 8h27.5C41.2 8 44 10.8 44 14.25v19.5C44 37.2 41.2 40 37.75 40h-27.5A6.25 6.25 0 0 1 4 33.75zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v19.5a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75v-19.5a3.75 3.75 0 0 0-3.75-3.75z"
]);
const $f342bb1007016cbf$export$6caeb4829b31864f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardLink16Filled', "16", [
    "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v4.59A3.5 3.5 0 0 0 13.5 9h-4q-1.14.02-2.02.64.04-.18.04-.39a.86.86 0 0 0-.86-.86h-2.8a.86.86 0 0 0-.86.86c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06l.17-.06a3.5 3.5 0 0 0-.4 2.18H2.76C1.78 13 1 12.22 1 11.25zm4.26 2.96a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71M9.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 4a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H13a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$14b1ad05b75f426f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardLink16Regular', "16", [
    "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v4.59a4 4 0 0 0-1-.3V4.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h3.29a4 4 0 0 0 0 1H2.75C1.78 13 1 12.22 1 11.25zm5.43 6.07q.39-.71 1.05-1.18.04-.18.04-.39a.86.86 0 0 0-.86-.86h-2.8a.86.86 0 0 0-.86.86c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06zM9.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM5.26 7.71a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71M9.5 10a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H13a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$ccdad48798f5864d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardLink20Filled', "20", [
    "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v5.84a3.5 3.5 0 0 0-1.5-.34h-4a3.5 3.5 0 0 0-3.16 5H3.5A1.5 1.5 0 0 1 2 14.5zm3 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m4 3.2a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm1 4a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-3.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$b408b1dac15851a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardLink20Regular', "20", [
    "M6.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-1.55.75a.95.95 0 0 0-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8a.95.95 0 0 0-.95-.94zM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M9.04 15H3.75a.75.75 0 0 1-.75-.75v-8.5c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v5.29q.53.07 1 .3V5.75C18 4.78 17.22 4 16.25 4H3.75C2.78 4 2 4.78 2 5.75v8.5c0 .97.78 1.75 1.75 1.75h5.59a4 4 0 0 1-.3-1m3.46-3a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$be3e80dd9437c9c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon16Filled', "16", [
    "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v1.79a4 4 0 0 0-2.37-.52L12.5 6h-3a.5.5 0 0 0 0 1h.85a4 4 0 0 0-1.28 2.24.5.5 0 0 0-.05.39 4 4 0 0 0 .98 3.02V13H2.75C1.78 13 1 12.22 1 11.25zm4.26 2.96a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71m-1.4.68a.86.86 0 0 0-.86.86c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06a1.7 1.7 0 0 0 1.26-1.63.86.86 0 0 0-.86-.86zM16 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 3.46a4 4 0 0 1-4 0v2.29c0 .2.21.31.38.22L13 15l1.62.97c.17.1.38-.03.38-.22z"
]);
const $f342bb1007016cbf$export$a8cbf65c060e7605 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon16Regular', "16", [
    "M1 4.75C1 3.78 1.78 3 2.75 3h10.5c.97 0 1.75.78 1.75 1.75v1.79q-.46-.27-1-.41V4.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0-.75.75v6.5c0 .41.34.75.75.75h6.79a4 4 0 0 0 .46.65V13H2.75C1.78 13 1 12.22 1 11.25zM12.5 6l.13.02c-.87.08-1.66.43-2.28.98H9.5a.5.5 0 0 1 0-1zM5.26 7.71a1.36 1.36 0 1 0 0-2.71 1.36 1.36 0 0 0 0 2.71m-1.4.68a.86.86 0 0 0-.86.86c0 .77.52 1.43 1.27 1.62l.05.01q.95.24 1.88 0h.06a1.7 1.7 0 0 0 1.26-1.63.86.86 0 0 0-.86-.86zM16 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 3.46a4 4 0 0 1-4 0v2.29c0 .2.21.31.38.22L13 15l1.62.97c.17.1.38-.03.38-.22z"
]);
const $f342bb1007016cbf$export$e4ce3f3bd812a416 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon20Filled', "20", [
    "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5H13v-.35a4 4 0 0 1-.87-3.65h-.63a.5.5 0 0 1 0-1h1.04A4 4 0 0 1 18 9.54V5.5c0-.83-.67-1.5-1.5-1.5zm3 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m1.55.75c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94zM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m8 4.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 3.46a4 4 0 0 1-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22z"
]);
const $f342bb1007016cbf$export$bb1d44b4a6083729 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon20Regular', "20", [
    "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4 4 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8M11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h.63q.14-.54.4-1zm-7.75 4h8.79q.2.35.46.65V16H3.75C2.78 16 2 15.22 2 14.25v-8.5C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v3.79q-.46-.27-1-.41V5.75a.75.75 0 0 0-.75-.75H3.75a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75M19 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 3.46a4 4 0 0 1-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22z"
]);
const $f342bb1007016cbf$export$b778a2aa82fbe833 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon24Filled', "24", [
    "M19.75 4C20.99 4 22 5 22 6.25v5.5A4.5 4.5 0 0 0 15.76 13h-2.61a.75.75 0 0 0 0 1.49h1.96a4.5 4.5 0 0 0 .89 3.84V20H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4zm-13.5 8.5c-.38 0-.7.28-.74.65l-.01.1v.6c.17 1.11 1.1 1.65 2.5 1.65 1.33 0 2.24-.49 2.46-1.5l.03-.15.01-.1v-.5c0-.38-.28-.7-.65-.74l-.1-.01zM8 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m9.75 1h-4.6a.75.75 0 0 0 0 1.5h4.7a.75.75 0 0 0 0-1.5zm5.25 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-6 3.74v3.05c0 .63.76.95 1.21.5l1.29-1.29 1.29 1.29a.71.71 0 0 0 1.21-.5v-3.05a4.5 4.5 0 0 1-5 0"
]);
const $f342bb1007016cbf$export$11b1e87096f43b05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon24Regular', "24", [
    "M19.75 4C20.99 4 22 5 22 6.25v5.5q-.68-.46-1.5-.64V6.25a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75v11.5c0 .42.34.75.75.75H16V20H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4zm-6.5 9h2.51q-.45.67-.65 1.5h-1.86a.75.75 0 0 1-.1-1.5zm-3.5-.5c.41 0 .75.34.75.75v.6c-.17 1.11-1.1 1.65-2.5 1.65s-2.33-.54-2.5-1.65v-.6c0-.41.34-.75.75-.75zM8 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5.25 1h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5zm9.75 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-6 3.74v3.05c0 .63.76.95 1.21.5l1.29-1.29 1.29 1.29a.71.71 0 0 0 1.21-.5v-3.05a4.5 4.5 0 0 1-5 0"
]);
const $f342bb1007016cbf$export$7c195596854c854b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon28Filled', "28", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v14.5A2.75 2.75 0 0 0 4.75 24H18v-2.34a5.5 5.5 0 0 1-.63-5.16h-1.62a.75.75 0 0 1 0-1.5h2.5a5.5 5.5 0 0 1 7.75-.74V6.75A2.75 2.75 0 0 0 23.25 4zM15 11.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m-3.75 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 14.5h5a1 1 0 0 1 1 1v.5s-.5 2.5-3.5 2.5S6 16 6 16v-.5a1 1 0 0 1 1-1m19 1.17a4.5 4.5 0 0 1 0 5.66 4.5 4.5 0 1 1 0-5.66m-1.1 7.78a5.5 5.5 0 0 1-2.35.55h-.1a6 6 0 0 1-2.45-.6 6 6 0 0 1-1-.66v3.56a.7.7 0 0 0 1.13.55L22.5 25l2.37 1.85A.7.7 0 0 0 26 26.3v-3.56q-.5.42-1.1.71"
]);
const $f342bb1007016cbf$export$cd2da64df64285e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon28Regular', "28", [
    "M15 11.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3.25a.75.75 0 0 0 0 1.5h1.62a6 6 0 0 1 .89-1.5zm-11 7.5H18V24H4.75A2.75 2.75 0 0 1 2 21.25V6.75A2.75 2.75 0 0 1 4.75 4h18.5A2.75 2.75 0 0 1 26 6.75v7.5a6 6 0 0 0-1.5-.87V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v14.5c0 .69.56 1.25 1.25 1.25m17.75.5a4.5 4.5 0 1 0 0-8.98 4.5 4.5 0 0 0 0 8.98m2.4.45a5.5 5.5 0 0 1-2.35.55h-.1a6 6 0 0 1-2.45-.6 6 6 0 0 1-1-.66v3.56a.7.7 0 0 0 1.13.55L22.5 25l2.37 1.85A.7.7 0 0 0 26 26.3v-3.56q-.5.42-1.1.71m-13.65-11.7a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 14.5h5a1 1 0 0 1 1 1v.5s-.5 2.5-3.5 2.5S6 16 6 16v-.5a1 1 0 0 1 1-1"
]);
const $f342bb1007016cbf$export$5b8915c79d3e071b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon32Filled', "32", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v17.5C2 26.55 3.46 28 5.25 28H19.5v-3.9a7 7 0 0 1-.84-5.1H18a1 1 0 1 1 0-2h1.44c.78-1.35 2-2.41 3.46-3H18a1 1 0 1 1 0-2h7a1 1 0 0 1 .86 1.5c1.57.09 3 .69 4.14 1.64V7.25C30 5.45 28.54 4 26.75 4zM13 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-6 4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5 0 0 0 3.5-4 3.5s-4-3.5-4-3.5m22.88 8.14a6.8 6.8 0 0 1-4.37 1.61h-.02A6.7 6.7 0 0 1 21 25.53v4.52c0 .74.81 1.2 1.44.81L25.5 29l3.06 1.86a.95.95 0 0 0 1.44-.81v-4.52zm-.71-1.04a5.53 5.53 0 0 0 .83-7.26 5.5 5.5 0 1 0-.83 7.26"
]);
const $f342bb1007016cbf$export$d0ad35060b1cd073 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon32Regular', "32", [
    "M17 13a1 1 0 0 1 1-1h7a1 1 0 0 1 .86 1.5 7 7 0 0 0-2.96.5H18a1 1 0 0 1-1-1m11-5.75v6.71a7 7 0 0 1 2 1.18V7.25C30 5.45 28.54 4 26.75 4H5.25A3.25 3.25 0 0 0 2 7.25v17.5C2 26.55 3.46 28 5.25 28H19.5v-2H5.25C4.56 26 4 25.44 4 24.75V7.25C4 6.56 4.56 6 5.25 6h21.5c.69 0 1.25.56 1.25 1.25M18 17h1.44a7 7 0 0 0-.78 2H18a1 1 0 1 1 0-2m3.26 0a5.49 5.49 0 0 0 4.24 9 5.48 5.48 0 0 0 4.5-8.66A5.5 5.5 0 0 0 25.5 15c-1.7 0-3.23.78-4.24 2m1.24 9.55a7 7 0 0 1-1.5-1.02v4.52c0 .74.81 1.2 1.44.81L25.5 29l3.06 1.86a.95.95 0 0 0 1.44-.81v-4.52a7 7 0 0 1-1.5 1.02q-1.37.69-2.99.7h-.02a7 7 0 0 1-2.99-.7M13 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-6 4.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5 0 0 0 3.5-4 3.5s-4-3.5-4-3.5"
]);
const $f342bb1007016cbf$export$faced9ea29d327f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon48Filled', "48", [
    "M8.25 8A4.25 4.25 0 0 0 4 12.25v23.5C4 38.1 5.9 40 8.25 40H31v-3.67a9.5 9.5 0 0 1-1.79-7.83h-2.96a1.25 1.25 0 1 1 0-2.5h3.88a9.5 9.5 0 0 1 5.32-4.5h-9.2a1.25 1.25 0 1 1 0-2.5h9.5a1.25 1.25 0 0 1 .82 2.2A9.6 9.6 0 0 1 44 22.75v-10.5C44 9.9 42.1 8 39.75 8zM19 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-8 6.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v.5s0 4-5 4-5-4-5-4zM38.5 38a7.5 7.5 0 0 0 7.5-7.5 7.47 7.47 0 0 0-7.5-7.5 7.49 7.49 0 1 0 0 15m3.59 1.3A10 10 0 0 0 44 38.25v6.7c0 .86-.96 1.35-1.65.85L38.5 43l-3.85 2.8c-.69.5-1.65 0-1.65-.84v-6.71A9.5 9.5 0 0 0 38.44 40h.12a10 10 0 0 0 3.53-.7"
]);
const $f342bb1007016cbf$export$a2139297df3898ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContactCardRibbon48Regular', "48", [
    "M19 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-8 6.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v.5s0 4-5 4-5-4-5-4zm14-6.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 0 1 .82 2.2q-.58.12-1.12.3h-9.2c-.69 0-1.25-.56-1.25-1.25m16.5-8v9.23q1.35.45 2.5 1.27v-10.5C44 9.9 42.1 8 39.75 8H8.25A4.25 4.25 0 0 0 4 12.25v23.5C4 38.1 5.9 40 8.25 40H31v-2.5H8.25c-.97 0-1.75-.78-1.75-1.75v-23.5c0-.97.78-1.75 1.75-1.75h31.5c.97 0 1.75.78 1.75 1.75M26.25 26h3.88a9 9 0 0 0-.92 2.5h-2.96a1.25 1.25 0 1 1 0-2.5m6.25 0a7.5 7.5 0 0 0-1.5 4.5 7.5 7.5 0 1 0 1.5-4.5m6.06 14A9.5 9.5 0 0 0 44 38.25v6.7c0 .86-.96 1.35-1.65.85L38.5 43l-3.85 2.8c-.69.5-1.65 0-1.65-.84v-6.71A9.5 9.5 0 0 0 38.44 40h.12"
]);
const $f342bb1007016cbf$export$b8a5bf042bf3329f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings16Filled', "16", [
    "M2 4.75A2.75 2.75 0 0 1 4.75 2h6.5A2.75 2.75 0 0 1 14 4.75v1.5a6 6 0 0 0-1.5-.88V5h-9v6.25c0 .7.56 1.25 1.25 1.25h.62q.33.83.89 1.5H4.75A2.75 2.75 0 0 1 2 11.25zM5 6h2.34q-.6.42-1.08 1H5.5v1.2a5.5 5.5 0 0 0-.41 3.3h-.1a.5.5 0 0 1-.5-.5V6.5c0-.28.23-.5.5-.5m1.5 2.72.36.35a2 2 0 0 1 0 2.86l-.36.35q.2.46.49.87l.4-.11a2 2 0 0 1 2.51 1.45l.12.48a4 4 0 0 0 .96 0l.12-.48a2 2 0 0 1 2.52-1.45l.4.11q.28-.4.47-.87l-.35-.35a2 2 0 0 1 0-2.86l.35-.35q-.19-.46-.48-.87l-.4.11a2 2 0 0 1-2.51-1.45l-.12-.48a4 4 0 0 0-.96 0l-.12.48a2 2 0 0 1-2.52 1.45l-.4-.11q-.28.4-.48.87m4 2.78a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $f342bb1007016cbf$export$7cbd97af6b5aee9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v1.76a6 6 0 0 0-1-.66V5H3v6.5c0 .83.67 1.5 1.5 1.5h1.1q.28.54.66 1H4.5A2.5 2.5 0 0 1 2 11.5zM3.09 4h9.83c-.2-.58-.76-1-1.42-1h-7c-.65 0-1.2.42-1.41 1M4.5 6h2.83q-.6.42-1.08 1H5v4h.01q.05.52.19 1h-.7a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5m2 2.72.35.35a2 2 0 0 1 0 2.86l-.35.35q.2.46.48.87l.4-.11a2 2 0 0 1 2.52 1.45l.11.48a4 4 0 0 0 .96 0l.12-.48a2 2 0 0 1 2.52-1.45l.4.11q.29-.4.48-.87l-.36-.35a2 2 0 0 1 0-2.86l.36-.35q-.2-.46-.48-.87l-.4.11a2 2 0 0 1-2.52-1.45l-.12-.48a4 4 0 0 0-.96 0l-.11.48a2 2 0 0 1-2.52 1.45l-.4-.11q-.3.4-.48.87m4 2.78a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $f342bb1007016cbf$export$4e80572490cc2b2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings20Filled', "20", [
    "M2.5 5.25A2.75 2.75 0 0 1 5.25 2.5h9.5a2.75 2.75 0 0 1 2.75 2.75v4.64q-.69-.45-1.5-.68V7H4v7.75c0 .69.56 1.25 1.25 1.25h3.96q.23.81.68 1.5H5.25a2.75 2.75 0 0 1-2.75-2.75zM9 14.5v-6a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5M6 14V9h2v5zm4-5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m2.07 2.94a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $f342bb1007016cbf$export$b9b91e6ce51288bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings20Regular', "20", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1q-.24-.48-.4-1H5.5A1.5 1.5 0 0 1 4 14.5V7h12v2.2q.52.16 1 .4V5.5A2.5 2.5 0 0 0 14.5 3zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4zm5 3v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5M6 9v5h2V9zm4-.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5m2.07 2.94a2 2 0 0 1-1.43 2.48l-.47.12a5 5 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42q.39.3.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36q.45-.2.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a5 5 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42q-.39-.3-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36q-.45.2-.82.5zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
]);
const $f342bb1007016cbf$export$61b1942191154c74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings24Filled', "24", [
    "M17.93 3H6.07A3.25 3.25 0 0 0 3 6.26v11.68A3.25 3.25 0 0 0 6.26 21h5.77a7 7 0 0 1-.85-2H6.12A1.25 1.25 0 0 1 5 17.74V8h14v3.17q1.09.26 2 .85V6.07A3.25 3.25 0 0 0 17.93 3M11 10.16a.75.75 0 0 0-.74-.65h-3.6a.75.75 0 0 0-.65.75v7.1c.06.37.37.65.75.65h3.6a.75.75 0 0 0 .65-.75v-7.1M7.5 11h2v5.5h-2zm10.5-.75a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75m-3.72 3.73a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 .01 1.8l.54.13a2 2 0 0 1 1.45 2.51l-.19.63q.66.58 1.49.93l.49-.52a2 2 0 0 1 2.9 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.6-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.81.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $f342bb1007016cbf$export$37db9b445e0a4ac7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings24Regular', "24", [
    "M17.75 3h.19A3.25 3.25 0 0 1 21 6.08v5.95q-.7-.45-1.5-.7V8h-15v9.75c0 .92.7 1.67 1.6 1.74l.15.01h5.06q.27.8.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V6.25a3.25 3.25 0 0 1 3.07-3.24L6.25 3zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v.25h15v-.25c0-.97-.78-1.75-1.75-1.75m-7.5 5c.38 0 .7.28.74.65l.01.1v7c0 .38-.28.7-.65.74l-.1.01h-3.5a.75.75 0 0 1-.74-.65l-.01-.1v-7c0-.38.28-.7.65-.74l.1-.01zM9.5 11h-2v5.5h2zm8.5-.75a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75m-3.72 3.73a2 2 0 0 1-1.44 2.5l-.59.14a6 6 0 0 0 .01 1.8l.54.13a2 2 0 0 1 1.45 2.51l-.19.63q.66.58 1.49.93l.5-.52a2 2 0 0 1 2.89 0l.5.52a5 5 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a6 6 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63q-.66-.6-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52q-.81.34-1.48.9zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16s1.45.67 1.45 1.5S18.3 19 17.5 19"
]);
const $f342bb1007016cbf$export$55067d9c4e7d4a8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings32Filled', "32", [
    "M4 9a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v5a10 10 0 0 0-2.5-1.37V10h-19v13A2.5 2.5 0 0 0 9 25.5h3.63A10 10 0 0 0 14 28H9a5 5 0 0 1-5-5zm12 4v1q-1.13.86-2 2v-2h-4v8h2q0 1.02.2 2H9a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1m.68 15.57.04-.16a4 4 0 0 0-2.9-5.02q-.18-1.36.08-2.74a4 4 0 0 0 2.88-4.99q1.06-.92 2.34-1.43a4 4 0 0 0 5.8 0l.1-.12a8 8 0 0 1 2.3 1.32l-.04.16a4 4 0 0 0 2.9 5.02q.19 1.36-.08 2.74a4 4 0 0 0-2.88 4.99q-1.07.93-2.34 1.43a4 4 0 0 0-5.8 0l-.1.12a8 8 0 0 1-2.3-1.32M20.85 24c1.06.61 2.44.22 3.08-.88s.3-2.5-.78-3.12a2.27 2.27 0 0 0-3.08.89c-.64 1.1-.3 2.5.78 3.1"
]);
const $f342bb1007016cbf$export$b3f3abc166236b8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentSettings32Regular', "32", [
    "M9 4a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h5a10 10 0 0 1-1.17-2H9a3 3 0 0 1-3-3V10h20v2.83q1.08.48 2 1.17V9a5 5 0 0 0-5-5zm16.83 4H6.17A3 3 0 0 1 9 6h14a3 3 0 0 1 2.83 2M16 14v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3.2q-.2-.98-.2-2h-2v-8h4v2q.87-1.14 2-2m.68 14.57.04-.16a4 4 0 0 0-2.9-5.02q-.18-1.36.08-2.74a4 4 0 0 0 2.88-4.99q1.07-.92 2.34-1.43a4 4 0 0 0 5.8 0l.1-.12a8 8 0 0 1 2.3 1.32l-.04.16a4 4 0 0 0 2.9 5.02q.19 1.36-.08 2.74a4 4 0 0 0-2.88 4.99q-1.07.93-2.34 1.43a4 4 0 0 0-5.8 0l-.1.12a8 8 0 0 1-2.3-1.32M20.85 24c1.06.61 2.44.22 3.08-.88s.29-2.5-.78-3.12a2.27 2.27 0 0 0-3.08.89c-.64 1.1-.3 2.5.78 3.1"
]);
const $f342bb1007016cbf$export$71bdd55859ca76d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_16_color__a)",
            "d": "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_16_color__b)",
            "d": "M4 11.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm6 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_16_color__a",
                "x1": "6.29",
                "x2": "10.88",
                "y1": "2",
                "y2": "13.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_16_color__b",
                "x1": "4",
                "x2": "13.61",
                "y1": "4",
                "y2": "7.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$103ffd5886ac8de4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM4 11.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 9h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M4 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm7 0H5v2h6zm-1 4h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1m0 1h1v1h-1z"
]);
const $f342bb1007016cbf$export$d04187ba8d365e3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zM4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM4 11.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M4.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM4 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm7 0H5v2h6zm-1 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm0 1h1v1h-1z"
]);
const $f342bb1007016cbf$export$62dd48219f61ea07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__a)",
            "d": "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__b)",
            "d": "M5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__c)",
            "d": "M5 11.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__d)",
            "d": "M5.5 13a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_20_color__e)",
            "d": "M11 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__a",
                "x1": "8",
                "x2": "13.36",
                "y1": "3",
                "y2": "16.25",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__b",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__c",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__d",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_20_color__e",
                "x1": "5",
                "x2": "16.35",
                "y1": "6",
                "y2": "10.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$9faf2a4a33893664 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView20Filled', "20", [
    "M14 7H6v2h8zm-2 5h2v1h-2zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm7 4h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1m-7 .5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1"
]);
const $f342bb1007016cbf$export$65690cd10eaaff8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView20Regular', "20", [
    "M5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm9 0H6v2h8zm-2 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm0 1h2v1h-2zm-7-.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
]);
const $f342bb1007016cbf$export$f5af54a7597a5b11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_24_color__a)",
            "d": "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_24_color__b)",
            "d": "M6 8.25c0-.97.78-1.75 1.75-1.75h8.5c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75h-8.5C6.78 11.5 6 10.72 6 9.75zM6.75 13a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM6 16.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M15.25 13c-.97 0-1.75.78-1.75 1.75v1c0 .97.78 1.75 1.75 1.75h1c.97 0 1.75-.78 1.75-1.75v-1c0-.97-.78-1.75-1.75-1.75z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_24_color__a",
                "x1": "9.43",
                "x2": "16.32",
                "y1": "3",
                "y2": "20.03",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_24_color__b",
                "x1": "6",
                "x2": "20.14",
                "y1": "6.5",
                "y2": "11.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$465b9e8edbd2b47c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM6 8.25c0-.97.78-1.75 1.75-1.75h8.5c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75h-8.5C6.78 11.5 6 10.72 6 9.75zM7.75 8a.25.25 0 0 0-.25.25v1.5c0 .14.11.25.25.25h8.5q.23-.02.25-.25v-1.5a.25.25 0 0 0-.25-.25zm-1 5h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5M6 16.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M15.25 13h1c.97 0 1.75.78 1.75 1.75v1c0 .97-.78 1.75-1.75 1.75h-1c-.97 0-1.75-.78-1.75-1.75v-1c0-.97.78-1.75 1.75-1.75M15 14.75q.02-.23.25-.25h1q.23.02.25.25v1q-.02.23-.25.25h-1a.25.25 0 0 1-.25-.25z"
]);
const $f342bb1007016cbf$export$2a594f2459b786da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zM6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zM6 8.25c0-.97.78-1.75 1.75-1.75h8.5c.97 0 1.75.78 1.75 1.75v1.5c0 .97-.78 1.75-1.75 1.75h-8.5C6.78 11.5 6 10.72 6 9.75zM7.75 8a.25.25 0 0 0-.25.25v1.5c0 .14.11.25.25.25h8.5q.23-.02.25-.25v-1.5a.25.25 0 0 0-.25-.25zm-1 5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5zM6 16.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M15.25 13c-.97 0-1.75.78-1.75 1.75v1c0 .97.78 1.75 1.75 1.75h1c.97 0 1.75-.78 1.75-1.75v-1c0-.97-.78-1.75-1.75-1.75zM15 14.75q.02-.23.25-.25h1q.23.02.25.25v1q-.02.23-.25.25h-1a.25.25 0 0 1-.25-.25z"
]);
const $f342bb1007016cbf$export$baf4dbeca105d02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_28_color__a)",
            "d": "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_28_color__b)",
            "d": "M6 9c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm0 6.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm8.75-2.5c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v3c0 .97-.78 1.75-1.75 1.75h-3c-.97 0-1.75-.78-1.75-1.75z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_28_color__a",
                "x1": "10.86",
                "x2": "19.29",
                "y1": "3",
                "y2": "23.81",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_28_color__b",
                "x1": "6",
                "x2": "24.63",
                "y1": "7",
                "y2": "14.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$5769c16c934d2ed2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zM6 9c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h12a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM6.75 15h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5M6 19.5c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 6 19.5m11.25-5h3c.97 0 1.75.78 1.75 1.75v3c0 .97-.78 1.75-1.75 1.75h-3c-.97 0-1.75-.78-1.75-1.75v-3c0-.97.78-1.75 1.75-1.75M17 16.25q.02-.23.25-.25h3q.23.02.25.25v3q-.02.23-.25.25h-3a.25.25 0 0 1-.25-.25z"
]);
const $f342bb1007016cbf$export$9d601cca1a3fcf6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25h14.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zM4.5 6.75c0-1.24 1-2.25 2.25-2.25h14.5c1.24 0 2.25 1 2.25 2.25v14.5c0 1.24-1 2.25-2.25 2.25H6.75c-1.24 0-2.25-1-2.25-2.25zM6 9c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h12a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zm-2 7.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75m.75 3a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm8.75-2.5c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v3c0 .97-.78 1.75-1.75 1.75h-3c-.97 0-1.75-.78-1.75-1.75zm1.75-.25a.25.25 0 0 0-.25.25v3q.02.23.25.25h3q.23-.02.25-.25v-3a.25.25 0 0 0-.25-.25z"
]);
const $f342bb1007016cbf$export$d98146d588c7cb81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_32_color__a)",
            "d": "M9 4a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_content_view_32_color__b)",
            "d": "M8 11c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2zm11 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zM8 19a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_32_color__a",
                "x1": "12.57",
                "x2": "21.76",
                "y1": "4",
                "y2": "26.71",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b3e0ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#8cd0ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_content_view_32_color__b",
                "x1": "8",
                "x2": "26.95",
                "y1": "9",
                "y2": "15.87",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#0094f0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$3030169cba569ed2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView32Filled', "32", [
    "M22 11H10v3h12zm-3 9h3v2h-3zM9 4a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5zm-1 7c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2zm11 7h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2M8 19a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1m1 3h5a1 1 0 0 1 0 2H9a1 1 0 1 1 0-2"
]);
const $f342bb1007016cbf$export$8e90f2369a3f770c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentView32Regular', "32", [
    "M8 11c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2zm14 0H10v3h12zm-3 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm0 2h3v2h-3zM8 19a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zM9 4a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5zM6 9a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3z"
]);
const $f342bb1007016cbf$export$fdbeefb313cd2a54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery16Filled', "16", [
    "M10 2H4.5A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14H10zm1 12h.5a2.5 2.5 0 0 0 2.5-2.5V11h-3zm3-4V6h-3v4zm0-5v-.5A2.5 2.5 0 0 0 11.5 2H11v3zM4 4.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM5 5v2h2V5zm-.5 4h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
]);
const $f342bb1007016cbf$export$f7c197f1c1bda9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5H9V3zM13 6V4.5c0-.83-.67-1.5-1.5-1.5H10v3zm-3 7h1.5c.83 0 1.5-.67 1.5-1.5V10h-3zm3-6h-3v2h3zM2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zm2 0c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM5 5v2h2V5zm-.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$aa434e32ae5a34aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery20Filled', "20", [
    "M9 7H6v2h3zM3 6a3 3 0 0 1 3-3h6v14H6a3 3 0 0 1-3-3zm2 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 13.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m8 3.5h1a3 3 0 0 0 3-3v-1h-4zm4-5V8h-4v4zm0-5V6a3 3 0 0 0-3-3h-1v4z"
]);
const $f342bb1007016cbf$export$d68fb337b9379fad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery20Regular', "20", [
    "M6 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm0 1h3v2H6zm-1 4.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm8 10V4H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2zm3 0a2 2 0 0 0 2-2v-1h-4v3zm2-9V6a2 2 0 0 0-2-2h-2v3zm0 5V8h-4v4z"
]);
const $f342bb1007016cbf$export$44412eb05246060a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery24Filled', "24", [
    "M6.25 3h8.25v18H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3m11.5 18H16v-5h5v1.75c0 1.8-1.46 3.25-3.25 3.25M21 14.5h-5v-5h5zM16 8V3h1.75C19.55 3 21 4.46 21 6.25V8zM6 13.75c0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75M7.25 6.5C6.56 6.5 6 7.06 6 7.75v2.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zM7.5 10V8h3v2zM6 16.75c0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75"
]);
const $f342bb1007016cbf$export$185a98df15020c69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zM6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h7.25v-15zm11.5 15c.97 0 1.75-.78 1.75-1.75V16H15v3.5zm1.75-5v-5H15v5zm0-6.5V6.25c0-.97-.78-1.75-1.75-1.75H15V8zM6 13.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M7.25 6.5C6.56 6.5 6 7.06 6 7.75v2.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zM7.5 10V8h3v2zM6 16.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$7e784f9dc0a3b57b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery28Filled', "28", [
    "M6.75 3H17v22H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3M18.5 17v-6H25v6zm0 8v-6.5H25v2.75A3.75 3.75 0 0 1 21.25 25zm0-22v6.5H25V6.75A3.75 3.75 0 0 0 21.25 3zM7.75 7.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25zM8 12V9h4.5v3zm-1.5 4.25c0 .41.34.75.75.75h6a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0-.75.75M7.25 19a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$8d682e89df5da31a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGallery28Regular', "28", [
    "M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25zM6.75 4.5c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25H16v-19zm14.5 19c1.24 0 2.25-1 2.25-2.25V18.5h-6v5zM23.5 17v-6h-6v6zm0-7.5V6.75c0-1.24-1-2.25-2.25-2.25H17.5v5zm-15.75-2c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25zM8 12V9h4.5v3zm-1.5 4.25c0-.41.34-.75.75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M7.25 19a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$407875b086d4dc4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning16Filled', "16", [
    "M10 2H4.5A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h4.22l.25-1H8.5a1.5 1.5 0 0 1-1.41-1H4.5a.5.5 0 0 1 0-1h2.59q0-.04.03-.08L7.5 10h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .36.15L9.2 5.92c.15-.37.45-.65.8-.8zm4 2.5V5h-3V2h.5A2.5 2.5 0 0 1 14 4.5m-10 0c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM5 5v2h2V5zm3.5 7h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $f342bb1007016cbf$export$56d2d4066af04c95 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h4.47l-.25 1H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5V5h-1v-.5c0-.83-.67-1.5-1.5-1.5H10v2.12a1.5 1.5 0 0 0-.8.8L9 6.4V3zm2.59 9q-.17-.47 0-1H4.5a.5.5 0 0 0 0 1zm.41-2 .36-.85A.5.5 0 0 0 7.5 9h-3a.5.5 0 0 0 0 1zM4 4.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zM5 5v2h2V5zm3.5 7h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7"
]);
const $f342bb1007016cbf$export$41baad4afab4dd57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning20Filled', "20", [
    "M9 7H6v2h3zM3 6a3 3 0 0 1 3-3h6v4.78l-.04.08L9.54 13H5.5a.5.5 0 0 0 0 1h3.58c-.34.96.37 2 1.42 2H12v.88l-.03.12H6a3 3 0 0 1-3-3zm14 1h-4V3h1a3 3 0 0 1 3 3zM5 7v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7.82-3h4.82a.5.5 0 0 1 .44.75L16.75 12h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L13.5 15h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $f342bb1007016cbf$export$bd295b542ea06d8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning20Regular', "20", [
    "M5 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm4 0H6v2h3zm-3.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 13.5c0-.28.22-.5.5-.5h4.04l-.4.86-.06.14H5.5a.5.5 0 0 1-.5-.5M6 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h5v5.9l.96-2.04.04-.08V4h2a2 2 0 0 1 2 2v1h1V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.97l.25-1zm7.32-8h4.82a.5.5 0 0 1 .44.75L16.75 12h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L13.5 15h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $f342bb1007016cbf$export$c94f5407015f0686 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning24Filled', "24", [
    "M6.25 3h8.25v9.84l-2.36 5.02A1.5 1.5 0 0 0 13.5 20h1v1H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3m10.07 8H21V8.5h-5v2.53q.14-.03.32-.03M16 7V3h1.75C19.55 3 21 4.46 21 6.25V7zM6 13.75c0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75M7.25 6.5C6.56 6.5 6 7.06 6 7.75v2.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zM7.5 10V8h3v2zM6 16.75c0 .41.34.75.75.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0-.75.75M16.32 12h4.82a.5.5 0 0 1 .44.75L19.75 16h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L16.5 19h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $f342bb1007016cbf$export$3fcef23447e9d368 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25V11h-1.5V9.5H15v2.28l-.04.08-1.46 3.1V4.5H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h6.13c.27.3.66.5 1.12.5h1.72l-.25 1H6.25A3.25 3.25 0 0 1 3 17.75zM19.5 8V6.25c0-.97-.78-1.75-1.75-1.75H15V8zM6 13.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M7.25 6.5C6.56 6.5 6 7.06 6 7.75v2.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zM7.5 10V8h3v2zM6 16.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M16.32 12h4.82a.5.5 0 0 1 .44.75L19.75 16h1.5c.64 0 .98.76.56 1.24l-4.82 5.51c-.5.58-1.45.09-1.26-.66L16.5 19h-3a.5.5 0 0 1-.46-.71l2.82-6a.5.5 0 0 1 .46-.29"
]);
const $f342bb1007016cbf$export$46e38a427a16ea39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning28Filled', "28", [
    "M17 3H6.75A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25H17v-2h-1.5a1.5 1.5 0 0 1-1.36-2.14L17 14.83zm8 10h-6.18q-.17 0-.32.03V9.5H25zm-6.5-5V3h2.75A3.75 3.75 0 0 1 25 6.75V8zm-12 .75c0-.69.56-1.25 1.25-1.25h5c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-5c-.69 0-1.25-.56-1.25-1.25zM8 9v3h4.5V9zm-.75 8a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5zm-.75 2.75c0-.41.34-.75.75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M18.82 14h6.33a.5.5 0 0 1 .43.75L23.75 18h1.52c.64 0 .98.75.56 1.24l-6.41 7.45c-.52.6-1.5.05-1.25-.7L19.5 22h-4a.5.5 0 0 1-.45-.71l3.32-7a.5.5 0 0 1 .45-.29"
]);
const $f342bb1007016cbf$export$1f5dd0467710394f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContentViewGalleryLightning28Regular', "28", [
    "M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75V13h-1.5v-2.5h-6v3.28l-.04.08L16 16.94V4.5H6.75c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25h11.2l-.5 1.5H6.75A3.75 3.75 0 0 1 3 21.25zM23.5 9V6.75c0-1.24-1-2.25-2.25-2.25H17.5V9zM7.75 7.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25zM8 12V9h4.5v3zm-1.5 4.25c0-.41.34-.75.75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M7.25 19a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm11.57-5h6.33a.5.5 0 0 1 .43.75L23.75 18h1.52c.64 0 .98.75.56 1.24l-6.41 7.45c-.52.6-1.5.05-1.25-.7L19.5 22h-4a.5.5 0 0 1-.45-.71l3.32-7a.5.5 0 0 1 .45-.29"
]);
const $f342bb1007016cbf$export$7da03b4d70ebd4e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft16Filled', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5V8h3.23C7.21 8 8 8.8 8 9.77V13h3.5c.83 0 1.5-.67 1.5-1.5V9.27a.5.5 0 0 1 1 0v2.23a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2h2.23a.5.5 0 0 1 0 1zm9 3h-2.8l3.15-3.15a.5.5 0 0 0-.7-.7L10 5.29V2.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .52.5h3.98a.5.5 0 0 0 0-1"
]);
const $f342bb1007016cbf$export$be91541599a77443 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft16Regular', "16", [
    "M3 4.5C3 3.67 3.67 3 4.5 3h2.23a.5.5 0 0 0 0-1H4.5A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5V9.27a.5.5 0 0 0-1 0v2.23c0 .83-.67 1.5-1.5 1.5H8V9.77C8 8.79 7.2 8 6.23 8H3zM3 9h3.23c.43 0 .77.34.77.77V13H4.5A1.5 1.5 0 0 1 3 11.5zm7.7-3h2.8a.5.5 0 0 1 0 1H9.52A.5.5 0 0 1 9 6.5v-4a.5.5 0 0 1 1 0v2.8l3.15-3.15a.5.5 0 0 1 .7.7z"
]);
const $f342bb1007016cbf$export$7ebafc90cd5a6f27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft20Filled', "20", [
    "m12.7 8 4.15-4.15a.5.5 0 0 0-.7-.7L12 7.29V3.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1zM6 4a2 2 0 0 0-2 2v4h4a2 2 0 0 1 2 2v4h4a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1z"
]);
const $f342bb1007016cbf$export$d42a5c257be43d51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft20Regular', "20", [
    "m12.7 8 4.15-4.15a.5.5 0 0 0-.7-.7L12 7.29V3.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1zM4 6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-4v-4a2 2 0 0 0-2-2H4zm0 5h4a1 1 0 0 1 1 1v4H6a2 2 0 0 1-2-2z"
]);
const $f342bb1007016cbf$export$b18aab3d2404dad4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft24Filled', "24", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75V12h4.75A2.75 2.75 0 0 1 12 14.75v4.75h5.75c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3h4a.75.75 0 0 1 0 1.5zm9.31 5h4.69a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 1.5 0v4.69l5.22-5.22a.75.75 0 1 1 1.06 1.06z"
]);
const $f342bb1007016cbf$export$14b38e51b2372865 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft24Regular', "24", [
    "M4.5 6.25V12h4.75A2.75 2.75 0 0 1 12 14.75v4.75h5.75c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3h4a.75.75 0 0 1 0 1.5h-4c-.97 0-1.75.78-1.75 1.75m0 7.25v4.25c0 .97.78 1.75 1.75 1.75h4.25v-4.75c0-.69-.56-1.25-1.25-1.25zm11.06-4h4.69a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 1.5 0v4.69l5.22-5.22a.75.75 0 1 1 1.06 1.06z"
]);
const $f342bb1007016cbf$export$bef308456356ab69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft28Filled', "28", [
    "M25 21.25A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3h4.5a.75.75 0 0 1 0 1.5h-4.5c-1.24 0-2.25 1-2.25 2.25V14h6.75A2.75 2.75 0 0 1 14 16.75v6.75h7.25c1.24 0 2.25-1 2.25-2.25v-4.5a.75.75 0 0 1 1.5 0zm-.75-9.75a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 1.5 0v6.69l7.22-7.22a.75.75 0 1 1 1.06 1.06l-7.22 7.22z"
]);
const $f342bb1007016cbf$export$4dce409b6e42cc21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft28Regular', "28", [
    "M21.25 25A3.75 3.75 0 0 0 25 21.25v-4.5a.75.75 0 0 0-1.5 0v4.5c0 1.24-1 2.25-2.25 2.25H14v-6.75A2.75 2.75 0 0 0 11.25 14H4.5V6.75c0-1.24 1-2.25 2.25-2.25h4.5a.75.75 0 0 0 0-1.5h-4.5A3.75 3.75 0 0 0 3 6.75v14.5A3.75 3.75 0 0 0 6.75 25zm-8.75-8.25v6.75H6.75c-1.24 0-2.25-1-2.25-2.25V15.5h6.75c.69 0 1.25.56 1.25 1.25m12.5-4.5a.75.75 0 0 0-.75-.75h-6.69l7.22-7.22a.75.75 0 0 0-1.06-1.06l-7.22 7.22V3.75a.75.75 0 0 0-1.5 0v8.5c0 .41.34.75.75.75h8.5c.41 0 .75-.34.75-.75"
]);
const $f342bb1007016cbf$export$d97d36087889223 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft32Filled', "32", [
    "m21.41 12 7.3-7.3a1 1 0 0 0-1.42-1.4L20 10.58V4a1 1 0 1 0-2 0v9a1 1 0 0 0 1 1h9a1 1 0 1 0 0-2zM7.5 5A2.5 2.5 0 0 0 5 7.5V16h7.23A3.77 3.77 0 0 1 16 19.77V27h8.5a2.5 2.5 0 0 0 2.5-2.5V19a1 1 0 1 1 2 0v5.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3H13a1 1 0 1 1 0 2z"
]);
const $f342bb1007016cbf$export$a77251999be3b339 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft32Regular', "32", [
    "M5 7.5V16h7.23A3.77 3.77 0 0 1 16 19.77V27h8.5a2.5 2.5 0 0 0 2.5-2.5V19a1 1 0 1 1 2 0v5.5a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3H13a1 1 0 1 1 0 2H7.5A2.5 2.5 0 0 0 5 7.5M5 18v6.5A2.5 2.5 0 0 0 7.5 27H14v-7.23c0-.98-.8-1.77-1.77-1.77zm16.41-6H28a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v6.59l7.3-7.3a1 1 0 1 1 1.4 1.42z"
]);
const $f342bb1007016cbf$export$a81788bd4fabcba0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft48Filled', "48", [
    "M12.25 8.5a3.75 3.75 0 0 0-3.75 3.75V24h10.25c2.9 0 5.25 2.35 5.25 5.25V39.5h11.75a3.75 3.75 0 0 0 3.75-3.75v-7.88a1.25 1.25 0 1 1 2.5 0v7.88C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6h7.88a1.25 1.25 0 1 1 0 2.5zM42 19.75c0 .69-.56 1.25-1.25 1.25h-12.5c-.69 0-1.25-.56-1.25-1.25V7.25a1.25 1.25 0 1 1 2.5 0v9.48L39.87 6.37a1.25 1.25 0 0 1 1.76 1.76L31.27 18.5h9.48c.69 0 1.25.56 1.25 1.25"
]);
const $f342bb1007016cbf$export$158f59759d1a404 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractDownLeft48Regular', "48", [
    "M41.63 8.13a1.25 1.25 0 0 0-1.76-1.76L29.5 16.73V7.25a1.25 1.25 0 0 0-2.5 0v12.5c0 .7.56 1.25 1.25 1.25h12.5a1.25 1.25 0 1 0 0-2.5h-9.48zM8.5 12.25a3.75 3.75 0 0 1 3.75-3.75h7.88a1.25 1.25 0 1 0 0-2.5h-7.88A6.25 6.25 0 0 0 6 12.25v23.5C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-7.88a1.25 1.25 0 0 0-2.5 0v7.88a3.75 3.75 0 0 1-3.75 3.75H24V29.25c0-2.9-2.35-5.25-5.25-5.25H8.5zm0 14.25h10.25a2.75 2.75 0 0 1 2.75 2.75V39.5h-9.25a3.75 3.75 0 0 1-3.75-3.75z"
]);
const $f342bb1007016cbf$export$6fa7e452423164c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight16Filled', "16", [
    "M3 4.5C3 3.67 3.67 3 4.5 3H8v3.5C8 7.33 8.67 8 9.5 8H13v3.5c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7A2.5 2.5 0 0 0 2 4.5v2a.5.5 0 0 0 1 0zm-1 5c0 .28.22.5.5.5h2.8l-3.15 3.15a.5.5 0 0 0 .7.7L6 10.71v2.79a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5"
]);
const $f342bb1007016cbf$export$6ed522db4deff697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 0 1 0-1h2c.83 0 1.5-.67 1.5-1.5V8H9.5A1.5 1.5 0 0 1 8 6.5V3zM9 3v3.5c0 .28.22.5.5.5H13V4.5c0-.83-.67-1.5-1.5-1.5zm-6.5 7a.5.5 0 0 1 0-1h4c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-2.8l-3.15 3.15a.5.5 0 0 1-.7-.7L5.29 10z"
]);
const $f342bb1007016cbf$export$89591f4530f054e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight20Filled', "20", [
    "M6 4a2 2 0 0 0-2 2v2.5a.5.5 0 0 1-1 0V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2.5a.5.5 0 0 1 0-1H14a2 2 0 0 0 2-2v-4h-4a2 2 0 0 1-2-2V4zm-2.5 8a.5.5 0 0 1 0-1h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-3.8l-4.15 4.15a.5.5 0 0 1-.7-.7L7.29 12z"
]);
const $f342bb1007016cbf$export$608789d565585a63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight20Regular', "20", [
    "M4 6c0-1.1.9-2 2-2h4v4c0 1.1.9 2 2 2h4v4a2 2 0 0 1-2 2h-2.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v2.5a.5.5 0 0 0 1 0zm8 3a1 1 0 0 1-1-1V4h3a2 2 0 0 1 2 2v3zm-9 2.5c0 .28.22.5.5.5h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L8 12.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5"
]);
const $f342bb1007016cbf$export$34edb82da28c0aeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25h-4a.75.75 0 0 1 0-1.5h4c.97 0 1.75-.78 1.75-1.75V12h-5.25C13.01 12 12 11 12 9.75V4.5H6.25c-.97 0-1.75.78-1.75 1.75v4a.75.75 0 0 1-1.5 0zm.75 8.25a.75.75 0 0 1 0-1.5h6.5c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0v-4.69l-5.22 5.22a.75.75 0 0 1-1.06-1.06l5.22-5.22z"
]);
const $f342bb1007016cbf$export$3fc9a4e14a755bde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v4a.75.75 0 0 0 1.5 0v-4c0-.97.78-1.75 1.75-1.75H12v5.25c0 1.24 1 2.25 2.25 2.25h5.25v5.75c0 .97-.78 1.75-1.75 1.75h-4a.75.75 0 0 0 0 1.5h4c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zm7.25 6.75V4.5h4.25c.97 0 1.75.78 1.75 1.75v4.25h-5.25a.75.75 0 0 1-.75-.75m-10.5 4c0 .41.34.75.75.75h4.69l-5.22 5.22a.75.75 0 1 0 1.06 1.06l5.22-5.22v4.69a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75"
]);
const $f342bb1007016cbf$export$226ba1df9eaed30c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight28Filled', "28", [
    "M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25h-4.5a.75.75 0 0 1 0-1.5h4.5c1.24 0 2.25-1 2.25-2.25V14h-6.75A2.75 2.75 0 0 1 14 11.25V4.5H6.75c-1.24 0-2.25 1-2.25 2.25v4.5a.75.75 0 0 1-1.5 0zm.75 9.75a.75.75 0 0 1 0-1.5h8.5c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-6.69l-7.22 7.22a.75.75 0 0 1-1.06-1.06l7.22-7.22z"
]);
const $f342bb1007016cbf$export$6aaa04cc0b741415 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v4.5a.75.75 0 0 0 1.5 0v-4.5c0-1.24 1-2.25 2.25-2.25H14v6.75A2.75 2.75 0 0 0 16.75 14h6.75v7.25c0 1.24-1 2.25-2.25 2.25h-4.5a.75.75 0 0 0 0 1.5h4.5A3.75 3.75 0 0 0 25 21.25V6.75A3.75 3.75 0 0 0 21.25 3zm8.75 8.25V4.5h5.75c1.24 0 2.25 1 2.25 2.25v5.75h-6.75c-.69 0-1.25-.56-1.25-1.25M3 15.75c0 .41.34.75.75.75h6.69l-7.22 7.22a.75.75 0 1 0 1.06 1.06l7.22-7.22v6.69a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75"
]);
const $f342bb1007016cbf$export$2f8cbee783e29c26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight32Filled', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5H19a1 1 0 1 1 0-2h5.5a2.5 2.5 0 0 0 2.5-2.5V16h-7.5a3.5 3.5 0 0 1-3.5-3.5V5H7.5A2.5 2.5 0 0 0 5 7.5V13a1 1 0 1 1-2 0zM4 20a1 1 0 1 1 0-2h9a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-6.59l-7.3 7.3a1 1 0 0 1-1.4-1.42L10.58 20z"
]);
const $f342bb1007016cbf$export$102a77eea9898b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight32Regular', "32", [
    "M7.5 3A4.5 4.5 0 0 0 3 7.5V13a1 1 0 1 0 2 0V7.5A2.5 2.5 0 0 1 7.5 5H16v7.5a3.5 3.5 0 0 0 3.5 3.5H27v8.5a2.5 2.5 0 0 1-2.5 2.5H19a1 1 0 1 0 0 2h5.5a4.5 4.5 0 0 0 4.5-4.5v-17A4.5 4.5 0 0 0 24.5 3zM18 12.5V5h6.5A2.5 2.5 0 0 1 27 7.5V14h-7.5a1.5 1.5 0 0 1-1.5-1.5M3 19a1 1 0 0 0 1 1h6.59l-7.3 7.3a1 1 0 1 0 1.42 1.4L12 21.42V28a1 1 0 1 0 2 0v-9a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1"
]);
const $f342bb1007016cbf$export$f992eaa05f52f233 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight48Filled', "48", [
    "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-7.5a1.25 1.25 0 1 1 0-2.5h7.5a3.75 3.75 0 0 0 3.75-3.75V24H29.25A5.25 5.25 0 0 1 24 18.75V8.5H12.25a3.75 3.75 0 0 0-3.75 3.75v7.5a1.25 1.25 0 1 1-2.5 0zM7.25 29.5a1.25 1.25 0 1 1 0-2.5h12.5c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-9.48L8.13 41.63a1.25 1.25 0 0 1-1.76-1.76L16.73 29.5z"
]);
const $f342bb1007016cbf$export$cc5d437bba06ed0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ContractUpRight48Regular', "48", [
    "M12.25 6A6.25 6.25 0 0 0 6 12.25v7.5a1.25 1.25 0 1 0 2.5 0v-7.5a3.75 3.75 0 0 1 3.75-3.75H24v10.25c0 2.9 2.35 5.25 5.25 5.25H39.5v11.75a3.75 3.75 0 0 1-3.75 3.75h-7.5a1.25 1.25 0 1 0 0 2.5h7.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6zM26.5 18.75V8.5h9.25a3.75 3.75 0 0 1 3.75 3.75v9.25H29.25a2.75 2.75 0 0 1-2.75-2.75M6 28.25c0 .69.56 1.25 1.25 1.25h9.48L6.37 39.87a1.25 1.25 0 0 0 1.76 1.76L18.5 31.27v9.48a1.25 1.25 0 1 0 2.5 0v-12.5c0-.69-.56-1.25-1.25-1.25H7.25C6.56 27 6 27.56 6 28.25"
]);
const $f342bb1007016cbf$export$6f3d67519b7f8c1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ControlButton20Filled', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1zm3 .5a.5.5 0 0 0-1 0V9h-.5a.5.5 0 0 0 0 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 0 0 0-1h-.25a.25.25 0 0 1-.25-.25V10h.5a.5.5 0 0 0 0-1H9zm7 0a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 0 0 1 0z"
]);
const $f342bb1007016cbf$export$8b537abc04d5f1ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ControlButton20Regular', "20", [
    "M6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1zm3 .5a.5.5 0 0 0-1 0V9h-.5a.5.5 0 0 0 0 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 0 0 0-1h-.25a.25.25 0 0 1-.25-.25V10h.5a.5.5 0 0 0 0-1H9zm7 0a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 0 0 1 0zM4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25z"
]);
const $f342bb1007016cbf$export$ad7d11720325bbe0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ControlButton24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zM7.75 8A2.75 2.75 0 0 0 5 10.75v2.5A2.75 2.75 0 0 0 7.75 16h.5a.75.75 0 0 0 0-1.5h-.5c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25h.5a.75.75 0 0 0 0-1.5zm3.75.75a.75.75 0 0 0-1.5 0V11h-.25a.75.75 0 0 0 0 1.5H10V14c0 1.1.9 2 2 2h.25a.75.75 0 0 0 0-1.5H12a.5.5 0 0 1-.5-.5v-1.5h.75a.75.75 0 0 0 0-1.5h-.75zm8 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-4 4.25c0-.28.22-.5.5-.5h.25a.75.75 0 0 0 0-1.5H16a2 2 0 0 0-2 2v2.25a.75.75 0 0 0 1.5 0z"
]);
const $f342bb1007016cbf$export$2e1537c85399434e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ControlButton24Regular', "24", [
    "M7.75 8A2.75 2.75 0 0 0 5 10.75v2.5A2.75 2.75 0 0 0 7.75 16h.5a.75.75 0 0 0 0-1.5h-.5c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25h.5a.75.75 0 0 0 0-1.5zm3.75.75a.75.75 0 0 0-1.5 0V11h-.25a.75.75 0 0 0 0 1.5H10V14c0 1.1.9 2 2 2h.25a.75.75 0 0 0 0-1.5H12a.5.5 0 0 1-.5-.5v-1.5h.75a.75.75 0 0 0 0-1.5h-.75zm8 0a.75.75 0 0 0-1.5 0v6.5a.75.75 0 0 0 1.5 0zm-4 4.25c0-.28.22-.5.5-.5h.25a.75.75 0 0 0 0-1.5H16a2 2 0 0 0-2 2v2.25a.75.75 0 0 0 1.5 0zM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4zM3.5 7.25c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $f342bb1007016cbf$export$75cd2a6713b8c0c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConvertRange20Filled', "20", [
    "M5 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm12.5 5c.28 0 .5.22.5.5v2a2.5 2.5 0 0 1-2.5 2.5h-1.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L13.71 11h1.79c.83 0 1.5-.67 1.5-1.5v-2c0-.28.22-.5.5-.5m-5.62 3H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1.56-.35l-2-2a1.5 1.5 0 0 1 0-2.12zM6.5 14c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$e243fce131c1c944 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConvertRange20Regular', "20", [
    "M5 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM4 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm3 9.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm4.88-3.5H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1 0V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h6.09q.1-.31.35-.56zM18 7.5a.5.5 0 0 0-1 0v2c0 .83-.67 1.5-1.5 1.5h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L13.71 12h1.79A2.5 2.5 0 0 0 18 9.5z"
]);
const $f342bb1007016cbf$export$7f1440f810f03dd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConvertRange24Filled', "24", [
    "M6.25 3C5.01 3 4 4 4 5.25v2.5C4 8.99 5 10 6.25 10h9.5C16.99 10 18 9 18 7.75v-2.5C18 4.01 17 3 15.75 3zm11.1 13.45-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2-2a.75.75 0 0 1-.07-.98l.07-.08 2-2a.75.75 0 0 1 1.13.98l-.07.08-.72.72h1.5c.65 0 1.18-.5 1.24-1.12l.01-.13V9.75a.75.75 0 0 1 1.5-.1V12a2.75 2.75 0 0 1-2.58 2.74l-.17.01h-1.5l.72.72c.27.26.3.68.07.98M14.27 12l-.78.79-.12.14-.03.03c-.5.68-.45 1.65.17 2.28l2.03 2.02.14.12.03.03c.68.5 1.66.45 2.28-.17l.01-.02v2.03c0 1.24-1 2.25-2.25 2.25h-9.5c-1.24 0-2.25-1-2.25-2.25v-5C4 13.01 5 12 6.25 12zM8 16.75c0 .41.31.75.7.75h4.6c.39 0 .7-.34.7-.75s-.31-.75-.7-.75H8.7c-.39 0-.7.34-.7.75"
]);
const $f342bb1007016cbf$export$98066ee4491e52e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ConvertRange24Regular', "24", [
    "M6.25 3C5.01 3 4 4 4 5.25v2.5C4 8.99 5 10 6.25 10h9.5C16.99 10 18 9 18 7.75v-2.5C18 4.01 17 3 15.75 3zM5.5 5.25c0-.41.34-.75.75-.75h9.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-9.5a.75.75 0 0 1-.75-.75zM8.7 16c-.39 0-.7.34-.7.75s.31.75.7.75h4.6c.39 0 .7-.34.7-.75s-.31-.75-.7-.75zm8.65.45-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2-2a.75.75 0 0 1-.07-.98l.07-.08 2-2a.75.75 0 0 1 1.13.98l-.07.08-.72.72h1.5c.65 0 1.18-.5 1.24-1.12l.01-.13V9.75a.75.75 0 0 1 1.5-.1V12a2.75 2.75 0 0 1-2.58 2.74l-.17.01h-1.5l.72.72c.27.26.3.68.07.98m.65 2.8v-2.03l-.01.02c-.4.4-.96.57-1.49.5v1.51c0 .41-.34.75-.75.75h-9.5a.75.75 0 0 1-.75-.75v-5c0-.41.34-.75.75-.75h6.82q.09-.3.27-.54l.03-.03.12-.14.78-.79H6.25C5.01 12 4 13 4 14.25v5c0 1.24 1 2.25 2.25 2.25h9.5c1.24 0 2.25-1 2.25-2.25"
]);
const $f342bb1007016cbf$export$10f8c1863c7b7072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy16Filled', "16", [
    "M5 9a3 3 0 0 0 3 3h2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1zm7-7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2z"
]);
const $f342bb1007016cbf$export$cdf69e2b1d9af2ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy16Regular', "16", [
    "M5 6H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1zm7-4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM8 3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
]);
const $f342bb1007016cbf$export$d709c6760fac7fed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy20Filled', "20", [
    "M7 11.5a3.5 3.5 0 0 0 3.5 3.5h1.45a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zM14.5 3A2.5 2.5 0 0 1 17 5.5v6a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $f342bb1007016cbf$export$7006e92bd12bc53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy20Regular', "20", [
    "M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h4c.65 0 1.2-.42 1.41-1h1.04a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.5-4A2.5 2.5 0 0 1 17 5.5v6a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3zm-4 1C9.67 4 9 4.67 9 5.5v6c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5z"
]);
const $f342bb1007016cbf$export$ac2fec8a0556940d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy24Filled', "24", [
    "M8.5 13.75c0 2.35 1.9 4.25 4.25 4.25h1.74a3.25 3.25 0 0 1-3.24 3h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zM17.75 3C19.55 3 21 4.46 21 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-5a3.25 3.25 0 0 1-3.25-3.25v-7.5C9.5 4.45 10.96 3 12.75 3z"
]);
const $f342bb1007016cbf$export$54c5356423871321 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy24Regular', "24", [
    "M8.5 8.5H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h5c.88 0 1.6-.65 1.73-1.5h1.5a3.25 3.25 0 0 1-3.23 3h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zM17.75 3C19.55 3 21 4.46 21 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-5a3.25 3.25 0 0 1-3.25-3.25v-7.5C9.5 4.45 10.96 3 12.75 3zm-5 1.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h5c.97 0 1.75-.78 1.75-1.75v-7.5c0-.97-.78-1.75-1.75-1.75z"
]);
const $f342bb1007016cbf$export$b62428101c2bbe54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy28Filled', "28", [
    "M10 16.25A4.75 4.75 0 0 0 14.75 21H17v.25A3.75 3.75 0 0 1 13.25 25h-6.5A3.75 3.75 0 0 1 3 21.25v-9.5A3.75 3.75 0 0 1 6.75 8H10zM21.25 3A3.75 3.75 0 0 1 25 6.75v9.5A3.75 3.75 0 0 1 21.25 20h-6.5A3.75 3.75 0 0 1 11 16.25v-9.5A3.75 3.75 0 0 1 14.75 3z"
]);
const $f342bb1007016cbf$export$c8c0f9c2b362969 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy28Regular', "28", [
    "M10 9.5H6.75c-1.24 0-2.25 1-2.25 2.25v9.5c0 1.24 1 2.25 2.25 2.25h6.5c1.24 0 2.25-1 2.25-2.25V21H17v.25A3.75 3.75 0 0 1 13.25 25h-6.5A3.75 3.75 0 0 1 3 21.25v-9.5A3.75 3.75 0 0 1 6.75 8H10zM21.25 3A3.75 3.75 0 0 1 25 6.75v9.5A3.75 3.75 0 0 1 21.25 20h-6.5A3.75 3.75 0 0 1 11 16.25v-9.5A3.75 3.75 0 0 1 14.75 3zm-6.5 1.5c-1.24 0-2.25 1-2.25 2.25v9.5c0 1.24 1 2.25 2.25 2.25h6.5c1.24 0 2.25-1 2.25-2.25v-9.5c0-1.24-1-2.25-2.25-2.25z"
]);
const $f342bb1007016cbf$export$129509a75d961004 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy32Filled', "32", [
    "M10.5 19.5a6 6 0 0 0 6 6h3.39A4.5 4.5 0 0 1 15.5 29h-8A4.5 4.5 0 0 1 3 24.5v-12A4.5 4.5 0 0 1 7.5 8h3zM24.5 3A4.5 4.5 0 0 1 29 7.5v12a4.5 4.5 0 0 1-4.5 4.5h-8a4.5 4.5 0 0 1-4.5-4.5v-12A4.5 4.5 0 0 1 16.5 3z"
]);
const $f342bb1007016cbf$export$e865e73564654d42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy32Light', "32", [
    "M10.5 9h-3A3.5 3.5 0 0 0 4 12.5v12A3.5 3.5 0 0 0 7.5 28h8a3.5 3.5 0 0 0 3.35-2.5h1.04A4.5 4.5 0 0 1 15.5 29h-8A4.5 4.5 0 0 1 3 24.5v-12A4.5 4.5 0 0 1 7.5 8h3zm14-6A4.5 4.5 0 0 1 29 7.5v12a4.5 4.5 0 0 1-4.5 4.5h-8a4.5 4.5 0 0 1-4.5-4.5v-12A4.5 4.5 0 0 1 16.5 3zm-8 1A3.5 3.5 0 0 0 13 7.5v12a3.5 3.5 0 0 0 3.5 3.5h8a3.5 3.5 0 0 0 3.5-3.5v-12A3.5 3.5 0 0 0 24.5 4z"
]);
const $f342bb1007016cbf$export$3a422979ed0cf0af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy32Regular', "32", [
    "M10.5 10h-3A2.5 2.5 0 0 0 5 12.5v12A2.5 2.5 0 0 0 7.5 27h8a2.5 2.5 0 0 0 2.29-1.5h2.1A4.5 4.5 0 0 1 15.5 29h-8A4.5 4.5 0 0 1 3 24.5v-12A4.5 4.5 0 0 1 7.5 8h3zm14-7A4.5 4.5 0 0 1 29 7.5v12a4.5 4.5 0 0 1-4.5 4.5h-8a4.5 4.5 0 0 1-4.5-4.5v-12A4.5 4.5 0 0 1 16.5 3zm-8 2A2.5 2.5 0 0 0 14 7.5v12a2.5 2.5 0 0 0 2.5 2.5h8a2.5 2.5 0 0 0 2.5-2.5v-12A2.5 2.5 0 0 0 24.5 5z"
]);
const $f342bb1007016cbf$export$a17f2b2a74e46235 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy48Filled', "48", [
    "M17 27.75c0 4.56 3.7 8.25 8.25 8.25h3.74a6.25 6.25 0 0 1-6.24 6h-10.5A6.25 6.25 0 0 1 6 35.75v-15.5C6 16.8 8.8 14 12.25 14H17zM35.75 6C39.2 6 42 8.8 42 12.25v15.5C42 31.2 39.2 34 35.75 34h-10.5A6.25 6.25 0 0 1 19 27.75v-15.5C19 8.8 21.8 6 25.25 6z"
]);
const $f342bb1007016cbf$export$1018c9105a8e2ec7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Copy48Regular', "48", [
    "M17 16.5h-4.75a3.75 3.75 0 0 0-3.75 3.75v15.5a3.75 3.75 0 0 0 3.75 3.75h10.5a3.75 3.75 0 0 0 3.74-3.5H29a6.25 6.25 0 0 1-6.24 6h-10.5A6.25 6.25 0 0 1 6 35.75v-15.5C6 16.8 8.8 14 12.25 14H17zM35.75 6C39.2 6 42 8.8 42 12.25v15.5C42 31.2 39.2 34 35.75 34h-10.5A6.25 6.25 0 0 1 19 27.75v-15.5C19 8.8 21.8 6 25.25 6zm-10.5 2.5a3.75 3.75 0 0 0-3.75 3.75v15.5a3.75 3.75 0 0 0 3.75 3.75h10.5a3.75 3.75 0 0 0 3.75-3.75v-15.5a3.75 3.75 0 0 0-3.75-3.75z"
]);
const $f342bb1007016cbf$export$7ac10f992fe6d745 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyAdd20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 11.5c0 1.4.82 2.6 2 3.16q.05 1.27.6 2.34H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.5.5a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m0-9A2.5 2.5 0 0 1 17 5.5v4.1q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-5.42 4.56A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $f342bb1007016cbf$export$e25d0238fc5ff9c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyAdd20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h3.7q.15.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.5 5a.5.5 0 0 0-.5.5V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.5-.5m0-9A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.25-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-4C9.67 4 9 4.67 9 5.5v6q.01.58.38 1-.2.5-.3 1.06A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $f342bb1007016cbf$export$fe3c67cafdfc1086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a.5.5 0 0 0-.5.5V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 0 0-.5-.5m-9-.25c0 1.72 1.03 3.2 2.5 3.87.03 1.21.38 2.34.97 3.3q-.35.08-.72.08h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zM17.75 3C19.55 3 21 4.46 21 6.25v5.77a6.5 6.5 0 0 0-9.93 4.5 3.3 3.3 0 0 1-1.57-2.77v-7.5C9.5 4.45 10.96 3 12.75 3z"
]);
const $f342bb1007016cbf$export$b82b407b54ac717c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2a.5.5 0 0 0-.5.5V17h-2.5a.5.5 0 0 0 0 1H17v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 0-1H18v-2.5a.5.5 0 0 0-.5-.5m-9-5.5H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h5.06q.26.75.66 1.42-.35.08-.72.08h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zM17.75 3C19.55 3 21 4.46 21 6.25v5.77q-.7-.45-1.5-.7V6.24c0-.97-.78-1.75-1.75-1.75h-5c-.97 0-1.75.78-1.75 1.75v7.5c0 .48.2.91.5 1.23q-.3.74-.43 1.55a3.3 3.3 0 0 1-1.57-2.78v-7.5C9.5 4.45 10.96 3 12.75 3z"
]);
const $f342bb1007016cbf$export$164a2178181762ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRight16Filled', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M5 9c0 .89.39 1.69 1 2.24A5.6 5.6 0 0 0 6.6 14H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1zm6.85.15a.5.5 0 1 0-.7.7L12.29 11H9.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM12 2a2 2 0 0 1 2 2v2.6q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-5.27 3.93Q6 9.5 6 9V4c0-1.1.9-2 2-2z"
]);
const $f342bb1007016cbf$export$ea741d51b369e4ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRight16Regular', "16", [
    "M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M5 6H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.2q.15.52.4 1H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1zm6.85 3.15a.5.5 0 1 0-.7.7L12.29 11H9.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM12 2a2 2 0 0 1 2 2v2.6q-.48-.24-1-.4V4a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v4.34q-.51.72-.77 1.59Q6 9.5 6 9V4c0-1.1.9-2 2-2z"
]);
const $f342bb1007016cbf$export$3620c2df7d369b5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRight20Filled', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 11.5c0 1.4.82 2.6 2 3.16q.05 1.27.6 2.34H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.85.65a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM14.5 3A2.5 2.5 0 0 1 17 5.5v4.1q-1.14-.59-2.5-.6a5.5 5.5 0 0 0-5.42 4.56A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $f342bb1007016cbf$export$159804b955d454b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRight20Regular', "20", [
    "M14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h3.7q.15.52.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm7.85 5.15a.5.5 0 1 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 1 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35zM14.5 3A2.5 2.5 0 0 1 17 5.5v4.1q-.48-.25-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-4C9.67 4 9 4.67 9 5.5v6q.01.58.38 1-.2.5-.3 1.06A2.5 2.5 0 0 1 8 11.5v-6A2.5 2.5 0 0 1 10.5 3z"
]);
const $f342bb1007016cbf$export$90022c7d39077fb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRight24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-9 1.75c0 1.72 1.03 3.2 2.5 3.87.03 1.21.38 2.34.97 3.3q-.35.08-.72.08h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zm9.85.9a.5.5 0 1 0-.7.7L19.29 17H14.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7zM17.75 3C19.55 3 21 4.46 21 6.25v5.77a6.5 6.5 0 0 0-9.93 4.5 3.3 3.3 0 0 1-1.57-2.77v-7.5C9.5 4.45 10.96 3 12.75 3z"
]);
const $f342bb1007016cbf$export$7015097984c51607 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopyArrowRight24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-9-3.5H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h5.06q.26.75.66 1.42-.35.08-.72.08h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zm9.85 6.15a.5.5 0 1 0-.7.7L19.29 17H14.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7zM17.75 3C19.55 3 21 4.46 21 6.25v5.77q-.7-.45-1.5-.7V6.24c0-.97-.78-1.75-1.75-1.75h-5c-.97 0-1.75.78-1.75 1.75v7.5c0 .48.2.91.5 1.23q-.3.74-.43 1.55a3.3 3.3 0 0 1-1.57-2.78v-7.5C9.5 4.45 10.96 3 12.75 3z"
]);
const $f342bb1007016cbf$export$2da9c88b06ad077f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopySelect20Filled', "20", [
    "M7 11.5a3.5 3.5 0 0 0 3.5 3.5h1.45a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm1.5 0c.28 0 .5.23.58.5.2.58.76 1 1.42 1h.75a.5.5 0 0 1 0 1h-.75a2.5 2.5 0 0 1-2.45-2c-.05-.27.17-.5.45-.5m8 0c.28 0 .5.23.45.5a2.5 2.5 0 0 1-2.45 2h-.75a.5.5 0 0 1 0-1h.75a1.5 1.5 0 0 0 1.42-1c.09-.27.3-.5.58-.5M8.5 7c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m8 0c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m-5.25-4a.5.5 0 0 1 0 1h-.75a1.5 1.5 0 0 0-1.42 1c-.09.27-.3.5-.58.5S8 5.27 8.05 5a2.5 2.5 0 0 1 2.45-2zm3.25 0a2.5 2.5 0 0 1 2.45 2c.05.27-.17.5-.45.5s-.5-.23-.58-.5c-.2-.58-.76-1-1.42-1h-.75a.5.5 0 0 1 0-1z"
]);
const $f342bb1007016cbf$export$78057ae2ffe44be6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopySelect20Regular', "20", [
    "M7 7H5.5C4.67 7 4 7.67 4 8.5v6c0 .83.67 1.5 1.5 1.5h4c.65 0 1.2-.42 1.41-1h1.04a2.5 2.5 0 0 1-2.45 2h-4A2.5 2.5 0 0 1 3 14.5v-6A2.5 2.5 0 0 1 5.5 6H7zm1.5 4.5c.28 0 .5.23.58.5.2.58.76 1 1.42 1h.75a.5.5 0 0 1 0 1h-.75a2.5 2.5 0 0 1-2.45-2c-.05-.27.17-.5.45-.5m8 0c.28 0 .5.23.45.5a2.5 2.5 0 0 1-2.45 2h-.75a.5.5 0 0 1 0-1h.75a1.5 1.5 0 0 0 1.42-1c.09-.27.3-.5.58-.5M8.5 7c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m8 0c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5m-5.25-4a.5.5 0 0 1 0 1h-.75a1.5 1.5 0 0 0-1.42 1c-.09.27-.3.5-.58.5S8 5.27 8.05 5a2.5 2.5 0 0 1 2.45-2zm3.25 0a2.5 2.5 0 0 1 2.45 2c.05.27-.17.5-.45.5s-.5-.23-.58-.5c-.2-.58-.76-1-1.42-1h-.75a.5.5 0 0 1 0-1z"
]);
const $f342bb1007016cbf$export$73350658edffdc15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopySelect24Filled', "24", [
    "M8.5 13.75c0 2.35 1.9 4.25 4.25 4.25h1.74a3.25 3.25 0 0 1-3.24 3h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zm7.25 1.75a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1 0-1.5zm-5.4-1.5c.38 0 .7.3.89.63q.23.4.63.63c.33.2.63.5.63.9 0 .44-.4.8-.82.66a3.3 3.3 0 0 1-2-2c-.15-.43.22-.82.67-.82m9.8 0c.45 0 .82.4.67.82a3.3 3.3 0 0 1-2 2c-.43.15-.82-.22-.82-.67 0-.38.3-.7.63-.89q.4-.23.63-.63c.2-.33.5-.63.9-.63m-9.9-5.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m10 0c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m-8.57-5.32c.43-.15.82.22.82.67 0 .38-.3.7-.63.89-.52.3-.87.87-.87 1.51a.75.75 0 0 1-1.5 0c0-1.42.91-2.63 2.18-3.07m6.32.67c0-.45.4-.82.82-.67A3.25 3.25 0 0 1 21 6.25a.75.75 0 0 1-1.5 0c0-.64-.35-1.2-.87-1.51-.33-.2-.63-.5-.63-.9M15.75 3a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1 0-1.5z"
]);
const $f342bb1007016cbf$export$c8400d7558562f17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CopySelect24Regular', "24", [
    "M8.5 8.5H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h5c.88 0 1.6-.65 1.73-1.5h1.5a3.25 3.25 0 0 1-3.23 3h-5A3.25 3.25 0 0 1 3 17.75v-7.5C3 8.45 4.46 7 6.25 7H8.5zm7.25 7a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1 0-1.5zm-5.4-1.5c.38 0 .7.3.89.63q.23.4.63.63c.33.2.63.5.63.9 0 .44-.4.8-.82.66a3.3 3.3 0 0 1-2-2c-.15-.43.22-.82.67-.82m9.8 0c.45 0 .82.4.67.82a3.3 3.3 0 0 1-2 2c-.43.15-.82-.22-.82-.67 0-.38.3-.7.63-.89q.4-.23.63-.63c.2-.33.5-.63.9-.63m-9.9-5.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m10 0c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75m-8.57-5.32c.43-.15.82.22.82.67 0 .38-.3.7-.63.89-.52.3-.87.87-.87 1.51a.75.75 0 0 1-1.5 0c0-1.42.91-2.63 2.18-3.07m6.32.67c0-.45.4-.82.82-.67A3.25 3.25 0 0 1 21 6.25a.75.75 0 0 1-1.5 0c0-.64-.35-1.2-.87-1.51-.33-.2-.63-.5-.63-.9M15.75 3a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1 0-1.5z"
]);
const $f342bb1007016cbf$export$54c4159b8d2d9147 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji16Filled', "16", [
    "M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12M6.25 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-.11 1.92a.5.5 0 1 0-.75.66 3.5 3.5 0 0 0 5.22 0 .5.5 0 1 0-.75-.66 2.5 2.5 0 0 1-3.72 0m3.61-1.92a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $f342bb1007016cbf$export$edd5373c39500e68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji16Regular', "16", [
    "M6.25 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-.11 1.92a.5.5 0 1 0-.75.66 3.5 3.5 0 0 0 5.22 0 .5.5 0 0 0-.75-.66 2.5 2.5 0 0 1-3.72 0M10.5 7A.75.75 0 1 1 9 7a.75.75 0 0 1 1.5 0M14 8A6 6 0 1 0 2 8a6 6 0 0 0 12 0M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8"
]);
const $f342bb1007016cbf$export$3c04b42f3a558541 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-6.5-1.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m.39 4.01a4 4 0 0 0 6.22 0 .5.5 0 1 1 .78.63 5 5 0 0 1-7.78 0 .5.5 0 1 1 .78-.63"
]);
const $f342bb1007016cbf$export$c8389d9c1f6c7816 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji20Regular', "20", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m10.5-1.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.61 4.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $f342bb1007016cbf$export$bbf20a2084478bc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20M8.46 14.78a.75.75 0 0 0-1.18.93 6 6 0 0 0 9.43 0 .75.75 0 1 0-1.18-.92 4.5 4.5 0 0 1-7.07 0M9 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m6 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $f342bb1007016cbf$export$f028dbcc8d39c734 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M8.46 14.78a4.5 4.5 0 0 0 7.07 0 .75.75 0 1 1 1.18.94 6 6 0 0 1-9.43 0 .75.75 0 1 1 1.18-.94M9 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $f342bb1007016cbf$export$b58a2dd9840646c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji28Filled', "28", [
    "M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0m15.5-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 11.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-3.67 5.63a.75.75 0 0 0-.2 1.04l.01.02.1.13.28.33A7.42 7.42 0 0 0 14 21a7.4 7.4 0 0 0 5.84-2.78l.02-.03v-.01h.01a.75.75 0 0 0-1.24-.85l-.25.3A5.92 5.92 0 0 1 14 19.5a6 6 0 0 1-4.62-2.16l-.01-.01a.75.75 0 0 0-1.04-.2"
]);
const $f342bb1007016cbf$export$f38d6a3bdb64e37f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji28Regular', "28", [
    "M17.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-3.67 5.63a.75.75 0 0 1 1.04.2l.25.3A5.92 5.92 0 0 0 14 19.5a6 6 0 0 0 4.62-2.16l.01-.01a.75.75 0 0 1 1.24.84l-.01.02-.02.03a4 4 0 0 1-.36.43A7.42 7.42 0 0 1 14 21a7.4 7.4 0 0 1-5.86-2.81v-.01h-.01a.75.75 0 0 1 .2-1.05M14 2a12 12 0 1 0 0 24 12 12 0 0 0 0-24M3.5 14a10.5 10.5 0 1 1 21 0 10.5 10.5 0 0 1-21 0"
]);
const $f342bb1007016cbf$export$522c86d5bc0ba419 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0m10-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0M9.55 19.1a1 1 0 0 0-.44 1.35v.02l.1.18.3.42c.25.34.63.78 1.18 1.21A8.3 8.3 0 0 0 16 24c2.5 0 4.21-.84 5.31-1.72a7 7 0 0 0 1.57-1.8v-.02h.01v-.01a1 1 0 0 0-1.78-.9l-.04.06-.17.26c-.17.22-.44.53-.84.85A6.3 6.3 0 0 1 16 22c-2 0-3.29-.66-4.06-1.28a5 5 0 0 1-1.05-1.17 1 1 0 0 0-1.34-.44"
]);
const $f342bb1007016cbf$export$15e696d8e524f4e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji32Light', "32", [
    "M9.92 19.73a.5.5 0 1 0-.84.54A8.3 8.3 0 0 0 16 24c2.84 0 5.5-1.48 6.92-3.73a.5.5 0 1 0-.84-.54A7.3 7.3 0 0 1 16 23a7.3 7.3 0 0 1-6.08-3.27M13.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28M3 16a13 13 0 1 1 26 0 13 13 0 0 1-26 0"
]);
const $f342bb1007016cbf$export$4c0ced7e886a3df1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji32Regular', "32", [
    "M12 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0M9.55 19.1a1 1 0 0 1 1.34.45l.04.06.17.26c.17.22.44.53.84.85A6.3 6.3 0 0 0 16 22c2 0 3.29-.66 4.06-1.28a5 5 0 0 0 1.05-1.17 1 1 0 0 1 1.78.9v.02l-.1.18-.3.42c-.25.34-.63.78-1.18 1.21A8.3 8.3 0 0 1 16 24c-2.5 0-4.21-.84-5.31-1.72a7 7 0 0 1-1.57-1.8v-.02H9.1v-.01a1 1 0 0 1 .44-1.34M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0"
]);
const $f342bb1007016cbf$export$72a005d111f7c6d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji48Filled', "48", [
    "M4 24a20 20 0 1 1 40 0 20 20 0 0 1-40 0m13.5-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M33 19.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M18.45 34.68c1.71.9 3.62 1.34 5.55 1.32a11.7 11.7 0 0 0 9.82-5.1 1.25 1.25 0 1 0-2.13-1.3A9.2 9.2 0 0 1 24 33.5a9.2 9.2 0 0 1-7.69-3.9 1.25 1.25 0 1 0-2.13 1.3c1.1 1.6 2.56 2.9 4.27 3.78"
]);
const $f342bb1007016cbf$export$8a1214804b7294c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Emoji48Regular', "48", [
    "M17.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M33 19.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M18.45 34.68c1.71.9 3.62 1.34 5.55 1.32a11.7 11.7 0 0 0 9.82-5.1 1.25 1.25 0 1 0-2.13-1.3A9.2 9.2 0 0 1 24 33.5a9.2 9.2 0 0 1-7.69-3.9 1.25 1.25 0 1 0-2.13 1.3c1.1 1.6 2.56 2.9 4.27 3.78M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40M6.5 24a17.5 17.5 0 1 1 35 0 17.5 17.5 0 0 1-35 0"
]);
const $f342bb1007016cbf$export$84ca9989754a9d02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAdd16Filled', "16", [
    "M7 13h.25a4.5 4.5 0 0 1-.14-2.5A3.5 3.5 0 0 1 4.4 9.33a.5.5 0 0 1 .75-.66 2.5 2.5 0 0 0 2.35.78 4.5 4.5 0 0 1 5.5-2.2L13 7a6 6 0 1 0-6 6M5.25 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m3.5 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M15 11.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-3-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $f342bb1007016cbf$export$347eb433416d9ff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAdd16Regular', "16", [
    "M13 7a6 6 0 1 0-5.75 6 5 5 0 0 1-.22-1H7a5 5 0 1 1 5-5v.03q.51.06 1 .22zm-5.89 3.5q.13-.55.38-1.05a2.5 2.5 0 0 1-2.35-.78.5.5 0 0 0-.75.66 3.5 3.5 0 0 0 2.72 1.17M6 6a.75.75 0 1 1-1.5 0A.75.75 0 0 1 6 6m2.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M15 11.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-3-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12z"
]);
const $f342bb1007016cbf$export$516b6e9ffbffbd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAdd20Filled', "20", [
    "M17 9a8 8 0 1 0-7.41 7.98A5.5 5.5 0 0 1 9.02 14H9a5 5 0 0 1-3.89-1.86.5.5 0 1 1 .78-.63A4 4 0 0 0 9.2 13a5.5 5.5 0 0 1 7.77-3.41zm-6.5-1.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m13.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $f342bb1007016cbf$export$a8a6ce99db820e32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAdd20Regular', "20", [
    "M17 9a8 8 0 1 0-7.41 7.98A6 6 0 0 1 9.2 16H9a7 7 0 1 1 7-6.8q.51.15.98.39zm-7.98 5q.05-.51.19-1H9a4 4 0 0 1-3.11-1.49.5.5 0 1 0-.78.63A5 5 0 0 0 9 14zm3.48-6.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m11.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $f342bb1007016cbf$export$15802de2be82bb6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78 6.5 6.5 0 0 0-10.88 3.63 4.5 4.5 0 0 1-2.63-1.63.75.75 0 0 0-1.18.93 6 6 0 0 0 3.73 2.21c.1 1.56.76 2.98 1.77 4.05L12 22a10 10 0 1 1 0-20m5.5 12h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.4v.19c.04.2.2.36.4.4H17v2.61q.08.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zM9 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m6 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $f342bb1007016cbf$export$2f57f3cad968ceb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05 8.5 8.5 0 1 0-8.77 8.77 7 7 0 0 0 1.05 1.47L12 22a10 10 0 1 1 0-20m5.5 12h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.4v.19c.04.2.2.36.4.4H17v2.61q.08.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zm-9.04.78a4.5 4.5 0 0 0 2.63 1.63 7 7 0 0 0-.08 1.5 6 6 0 0 1-3.73-2.2.75.75 0 1 1 1.18-.93M9 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $f342bb1007016cbf$export$f5e7de449911331a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngry16Filled', "16", [
    "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M5.85 5.15a.5.5 0 1 0-.7.7l.6.6a.75.75 0 0 0 .5 1.3.75.75 0 0 0 .7-1.03.5.5 0 0 0-.1-.57zM10.5 7q-.01-.33-.24-.55l.6-.6a.5.5 0 0 0-.71-.7l-1 1a.5.5 0 0 0-.1.57.75.75 0 0 0 .7 1.03c.41 0 .75-.34.75-.75m-4.36 4.33a2.5 2.5 0 0 1 3.72 0 .5.5 0 0 0 .75-.66 3.5 3.5 0 0 0-5.22 0 .5.5 0 0 0 .75.66"
]);
const $f342bb1007016cbf$export$3a99aa4ab68920bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngry16Regular', "16", [
    "M7 7a.75.75 0 1 1-1.26-.55l-.6-.6a.5.5 0 1 1 .71-.7l1 1a.5.5 0 0 1 .1.57Q7 6.85 7 7m2.75.75a.75.75 0 0 0 .5-1.3l.6-.6a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0-.1.57.75.75 0 0 0 .7 1.03m-4.32 3.62c.2.19.52.17.7-.04a2.5 2.5 0 0 1 3.73 0 .5.5 0 0 0 .75-.66 3.5 3.5 0 0 0-5.22 0 .5.5 0 0 0 .04.7M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 1a5 5 0 1 0 0 10A5 5 0 0 0 8 3"
]);
const $f342bb1007016cbf$export$9c725354c08f8bb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngry20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6.5-1.5a.5.5 0 0 0 .26-.93l-2.5-1.5a.5.5 0 0 0-.52.86l1.22.73a1 1 0 1 0 1.54.84m5 0a1 1 0 0 0-.46-.84l1.22-.73a.5.5 0 0 0-.52-.86l-2.5 1.5a.5.5 0 0 0 .26.93 1 1 0 1 0 2 0m.06 4.89c.34-.3.07-.72.06-.73l-.23-.23a4 4 0 0 0-.67-.49 5.3 5.3 0 0 0-2.72-.69 5.3 5.3 0 0 0-2.72.7 4 4 0 0 0-.9.7c-.18.23-.17.55.06.74a.5.5 0 0 0 .7-.07l.02-.03q.04-.05.12-.11.15-.16.5-.37a4.3 4.3 0 0 1 2.22-.56 4.3 4.3 0 0 1 2.22.56 3 3 0 0 1 .64.5c.18.22.5.27.7.08"
]);
const $f342bb1007016cbf$export$90f37a9c5eca3db0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngry20Regular', "20", [
    "M8.5 8.5a1 1 0 1 1-1.54-.84l-1.22-.73a.5.5 0 0 1 .52-.86l2.5 1.5a.5.5 0 0 1-.26.93m5 0a1 1 0 1 1-2 0 .5.5 0 0 1-.26-.93l2.5-1.5a.5.5 0 0 1 .52.86l-1.22.73a1 1 0 0 1 .46.84m.06 4.89a.5.5 0 0 1-.7-.07l-.02-.03-.12-.12q-.15-.16-.5-.36a4.3 4.3 0 0 0-2.22-.56c-1.02 0-1.75.28-2.21.56a3 3 0 0 0-.65.5.5.5 0 0 1-.78-.62l.39.31-.39-.31v-.01l.02-.02.23-.23q.22-.2.67-.49c.6-.35 1.5-.69 2.72-.69a5.3 5.3 0 0 1 2.72.7 4 4 0 0 1 .9.71l.01.02h.01l-.39.32.39-.31a.5.5 0 0 1-.08.7M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $f342bb1007016cbf$export$59df78ed547c1d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngry24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 11.5c-1.63 0-3.17.66-4.29 1.8a.75.75 0 1 0 1.07 1.05 4.5 4.5 0 0 1 6.43 0 .75.75 0 1 0 1.07-1.06A6 6 0 0 0 12 13.5M8.22 6.66l-.1-.06a.75.75 0 0 0-.92 1.16l.08.07 1.26 1A1.25 1.25 0 1 0 10.25 10a.75.75 0 0 0 .55-1.26l-.08-.08zl-.1-.06zm8.62.12a.75.75 0 0 0-.97-.18l-.09.06-2.5 2-.08.08a.75.75 0 0 0 .44 1.25h.11a1.25 1.25 0 1 0 1.83-1.1l-.12-.05 1.26-1 .08-.08a.75.75 0 0 0 .04-.98"
]);
const $f342bb1007016cbf$export$97f788579265c356 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiAngry24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 10c1.63 0 3.16.65 4.28 1.8a.75.75 0 1 1-1.07 1.04 4.5 4.5 0 0 0-6.43 0 .75.75 0 1 1-1.07-1.04A6 6 0 0 1 12 13.5M7.16 6.78c.24-.3.65-.36.97-.18l.09.06 2.5 2a.75.75 0 0 1-.47 1.34 1.25 1.25 0 1 1-1.71-1.16l-1.26-1a.75.75 0 0 1-.12-1.06m6.12 1.88 2.5-2a.75.75 0 0 1 1.02 1.1l-.08.07-1.26 1a1.25 1.25 0 1 1-1.7 1.3V10a.75.75 0 0 1-.55-1.26zl2.5-2z"
]);
const $f342bb1007016cbf$export$a5c36c01e7216e52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit16Filled', "16", [
    "M8 2a6 6 0 0 1 5.2 3 2.9 2.9 0 0 0-2.1.84l-.73.73a.75.75 0 1 0-1.05 1.05l-2.55 2.56q-.36-.21-.63-.51a.5.5 0 1 0-.75.66q.3.34.67.58-.45.55-.63 1.25l-.28 1.12A6 6 0 0 1 8 2M6.25 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.73 3.63 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $f342bb1007016cbf$export$89d342d78e471e20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit16Regular', "16", [
    "M6.25 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-.11 1.92a.5.5 0 1 0-.75.66q.3.34.67.58l.21-.24.5-.5q-.36-.2-.63-.5M3 8a5 5 0 0 0 2.4 4.27l-.25 1.01A6 6 0 1 1 13.2 5q-.55 0-1.07.18A5 5 0 0 0 3 8m6.75-1.75q.4.02.62.32L9.32 7.62a.75.75 0 0 1 .43-1.37m-2.77 5.13 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.15-.6.58-1.02"
]);
const $f342bb1007016cbf$export$247fed5f54ac4840 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit20Filled', "20", [
    "M2 10a8 8 0 0 0 7 7.94q.02-.15.06-.29l.37-1.5q.16-.62.56-1.15a5 5 0 0 1-3.88-1.86.5.5 0 1 1 .78-.63 4 4 0 0 0 4.2 1.34l4.01-4a2.9 2.9 0 0 1 2.85-.73A8 8 0 0 0 2 10m9.5-1.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4.48 6.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $f342bb1007016cbf$export$3b8752f3ae662a81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit20Regular', "20", [
    "M2 10a8 8 0 0 0 7 7.94q.02-.15.06-.29l.17-.7a7 7 0 1 1 7.7-7.94q.52-.04 1.02.1A8 8 0 0 0 2 10m8.27 4.67.82-.82a4 4 0 0 1-4.2-1.34.5.5 0 1 0-.78.63A5 5 0 0 0 10 15q.12-.18.28-.33M13.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2.48 6.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2 2 0 0 1-1.02.58l-1.5.37a.9.9 0 0 1-1.07-1.07l.37-1.5q.16-.6.58-1.02"
]);
const $f342bb1007016cbf$export$860ebb217e66b0d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit24Filled', "24", [
    "M12 2a10 10 0 0 1 9.97 9.25 3.3 3.3 0 0 0-3.58.71l-2.63 2.64a1 1 0 0 0-.23.19l-.16.2-.39.38a4.5 4.5 0 0 1-6.52-.59.75.75 0 0 0-1.18.93A6 6 0 0 0 12.37 18q-.61.69-.85 1.59l-.46 1.83q-.06.27-.06.54A10 10 0 0 1 12 2M9 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m6 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m4.1 3.92-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $f342bb1007016cbf$export$45f6e7cea35c451b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 9.25 3 3 0 0 0-1.53-.24 8.5 8.5 0 1 0-9.14 9.46l-.24.94q-.06.27-.06.54A10 10 0 0 1 12 2m0 14.5c1.12 0 2.17-.41 2.98-1.13l-2.49 2.5-.12.12a6 6 0 0 1-5.09-2.28.75.75 0 1 1 1.18-.93A4.5 4.5 0 0 0 12 16.5M9 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m4.1 3.92-5.9 5.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $f342bb1007016cbf$export$31dc258258fb2ac0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit28Filled', "28", [
    "M2 14a12 12 0 0 1 23.98-.75 3.3 3.3 0 0 0-3.59.71l-3.04 3.05a.8.8 0 0 0-.72.32l-.25.3A5.92 5.92 0 0 1 14 19.5a6 6 0 0 1-4.62-2.16l-.01-.01a.75.75 0 0 0-1.24.84l.01.02.1.13.28.33a7.42 7.42 0 0 0 6.98 2.21l-1.01 1q-.71.73-.97 1.72l-.46 1.83q-.06.27-.06.55A12 12 0 0 1 2 14m15.5-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 11.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m11.1 3.17-7.9 7.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l7.9-7.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $f342bb1007016cbf$export$6d500fca74ac6255 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit28Regular', "28", [
    "M17.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-3.67 5.63a.75.75 0 0 1 1.04.2l.25.3A5.92 5.92 0 0 0 14 19.5a6 6 0 0 0 4.62-2.16l.01-.01a.8.8 0 0 1 .72-.32l-3.85 3.85q-.7.14-1.5.14a7.4 7.4 0 0 1-5.86-2.81v-.01h-.01a.75.75 0 0 1 .2-1.05M14 3.5a10.5 10.5 0 0 1 10.45 9.51 3 3 0 0 1 1.53.24A12 12 0 1 0 13 25.95q0-.26.06-.54l.24-.93A10.5 10.5 0 0 1 14 3.5m9.1 11.17-7.9 7.9q-.54.54-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46q.71-.18 1.25-.7l7.9-7.9a2.29 2.29 0 0 0-3.23-3.24"
]);
const $f342bb1007016cbf$export$a5df9477b6b6d2e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit48Filled', "48", [
    "M4 24a20 20 0 0 1 39.93-1.69 6 6 0 0 0-6.17 1.48L32.62 29a1.2 1.2 0 0 0-.93.6A9.2 9.2 0 0 1 24 33.5a9.2 9.2 0 0 1-7.69-3.9 1.25 1.25 0 1 0-2.13 1.3A11.7 11.7 0 0 0 24 36q.93 0 1.85-.12l-1.6 1.63a5 5 0 0 0-1.28 2.25L22.13 43q-.12.45-.13.9A20 20 0 0 1 4 24m13.5-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M33 19.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m11.83 5.67a4 4 0 0 0-5.65.02l-13.5 13.72a3 3 0 0 0-.78 1.35l-.83 3.24a2 2 0 0 0 2.43 2.44l3.24-.84a3 3 0 0 0 1.35-.77L44.8 30.82a4 4 0 0 0 .02-5.65"
]);
const $f342bb1007016cbf$export$fdc0a3cd5472048b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiEdit48Regular', "48", [
    "M17.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M33 19.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M18.45 34.68c1.71.9 3.62 1.34 5.55 1.32q.93 0 1.85-.12L32.62 29a1.2 1.2 0 0 0-.93.6A9.2 9.2 0 0 1 24 33.5a9.2 9.2 0 0 1-7.69-3.9 1.25 1.25 0 1 0-2.13 1.3c1.1 1.6 2.56 2.9 4.27 3.78M6.5 24a17.5 17.5 0 0 0 16.03 17.44l-.4 1.56q-.12.45-.13.9a20 20 0 1 1 21.93-21.59 6 6 0 0 0-2.54-.28A17.5 17.5 0 0 0 6.5 24m38.33 1.17a4 4 0 0 0-5.65.02l-13.5 13.72a3 3 0 0 0-.78 1.35l-.83 3.24a2 2 0 0 0 2.43 2.44l3.24-.84a3 3 0 0 0 1.35-.77L44.8 30.82a4 4 0 0 0 .02-5.65"
]);
const $f342bb1007016cbf$export$2c28b6c922d82ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand16Filled', "16", [
    "M6 1.5a.5.5 0 0 0-1 0v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 0-1 0v5a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-1 0v6.3q0 .82.37 1.56L2 11.62A2.5 2.5 0 0 0 4.24 13h.26c1.39 0 2.44-1.14 2.99-2.17.42-.8 1.2-1.73 2.7-2.37a.5.5 0 0 0 .23-.74q-.46-.66-1.04-.9A2 2 0 0 0 8 6.76V2.5a.5.5 0 0 0-1 0v4a.5.5 0 0 1-1 0zM11 16a5 5 0 0 1-4.42-2.66 6 6 0 0 0 1.8-2.05c.31-.6.93-1.36 2.21-1.91a1.5 1.5 0 0 0 .66-2.21q-.48-.7-1.14-1.1Q10.56 6 11 6a5 5 0 0 1 0 10m1.75-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-.03.55a.5.5 0 0 0-.67.23q-.2.36-.7.55c-.32.13-.65.17-.85.17a.5.5 0 0 0 0 1c.3 0 .77-.06 1.22-.23s.95-.5 1.23-1.05a.5.5 0 0 0-.23-.67"
]);
const $f342bb1007016cbf$export$55b5193728c2d7d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand16Regular', "16", [
    "M3.09 2c.2-.58.76-1 1.41-1h2c.65 0 1.2.42 1.41 1H8a2 2 0 0 1 2 2v2.31q.26-.05.56-.06c.36 0 .77.08 1.13.35q.56.4.8 1.28a.5.5 0 0 1-.3.58 8 8 0 0 0-3.61 3.03A3.1 3.1 0 0 1 6.06 13H4.24A2.5 2.5 0 0 1 2 11.62l-.63-1.26A3.5 3.5 0 0 1 1 8.79V4c0-1.1.9-2 2-2zM5 2h-.5a.5.5 0 0 0-.5.5v4a.5.5 0 1 1-1 0V3a1 1 0 0 0-1 1v4.8q0 .58.26 1.11l.63 1.26c.26.5.78.83 1.35.83h1.82c.64 0 1.27-.42 1.68-1.05a9 9 0 0 1 3.64-3.21 1 1 0 0 0-.28-.34 1 1 0 0 0-.54-.15 2 2 0 0 0-.83.2A.5.5 0 0 1 9 7V4a1 1 0 0 0-1-1v3.5a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5H6v4.5a.5.5 0 0 1-1 0zm6 14a5 5 0 0 1-4.08-2.1q.53-.15.96-.4a4 4 0 1 0 5.61-5.63q0-.12-.04-.23a4 4 0 0 0-.59-1.28A5 5 0 0 1 11 16m2.5-5.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.55 1.97a.5.5 0 1 0-.9-.44q-.2.36-.7.55c-.32.13-.65.17-.85.17a.5.5 0 0 0 0 1c.3 0 .77-.06 1.22-.23s.95-.5 1.23-1.05"
]);
const $f342bb1007016cbf$export$1d6477c016e7cc38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand20Filled', "20", [
    "M5.5 1c.28 0 .5.22.5.5v5a.5.5 0 0 0 1 0v-4a.5.5 0 0 1 1 0v4.25l.31-.06q.5-.08 1.07.14t1.04.9a.5.5 0 0 1-.22.73 5.3 5.3 0 0 0-2.71 2.37C6.94 11.86 5.89 13 4.5 13h-.26A2.5 2.5 0 0 1 2 11.62l-.63-1.26A3.5 3.5 0 0 1 1 8.79V2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 0 1 0v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 0 1 0v-5c0-.28.22-.5.5-.5m2.87 10.3c-.28.54-.74 1.18-1.35 1.7a5.5 5.5 0 1 0 4.21-5.85l.02.02a1.5 1.5 0 0 1-.66 2.2 4.3 4.3 0 0 0-2.22 1.92m2.38 1.2a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m4.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-4.05 2.53c.08.17.55.72 1.55.72s1.47-.55 1.55-.72a.5.5 0 1 1 .9.44c-.25.5-1.05 1.28-2.45 1.28s-2.2-.78-2.45-1.28a.5.5 0 1 1 .9-.44"
]);
const $f342bb1007016cbf$export$74d5a18ebdf1dd1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand20Regular', "20", [
    "M4.5 1c-.65 0-1.2.42-1.41 1H3a2 2 0 0 0-2 2v4.8q0 .82.37 1.56L2 11.62A2.5 2.5 0 0 0 4.24 13h1.82a3.1 3.1 0 0 0 2.52-1.5 8 8 0 0 1 3.62-3.04.5.5 0 0 0 .29-.58 2.2 2.2 0 0 0-.8-1.28 2 2 0 0 0-1.13-.35q-.31 0-.56.06V4a2 2 0 0 0-2-2h-.09c-.2-.58-.76-1-1.41-1zm0 1H5v4.5a.5.5 0 0 0 1 0V2h.5c.28 0 .5.22.5.5v4a.5.5 0 1 0 1 0V3a1 1 0 0 1 1 1v3a.5.5 0 0 0 .72.45h.01l.24-.1a2 2 0 0 1 .6-.1q.31 0 .53.15.15.1.28.34c-1.87.9-3 2.22-3.64 3.21-.4.63-1.04 1.05-1.68 1.05H4.24a1.5 1.5 0 0 1-1.35-.83l-.63-1.26A2.5 2.5 0 0 1 2 8.79V4a1 1 0 0 1 1-1v3.5a.5.5 0 1 0 1 0v-4c0-.28.22-.5.5-.5m8.76 5.05a5.5 5.5 0 1 1-6.1 6.78q.5-.17.93-.45a4.5 4.5 0 1 0 5.4-5.27q.02-.24-.03-.47-.09-.3-.2-.59m-2.51 5.45a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-4.05 2.53a.5.5 0 1 0-.9.44c.25.5 1.05 1.28 2.45 1.28s2.2-.78 2.45-1.28a.5.5 0 1 0-.9-.44c-.08.17-.55.72-1.55.72s-1.47-.55-1.55-.72"
]);
const $f342bb1007016cbf$export$5283400e86491f5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand24Filled', "24", [
    "M7.5 7.5V1.75a.75.75 0 0 1 1.5 0V7.5a.5.5 0 1 0 1 0v-5a.75.75 0 0 1 1.5 0v5.81A4 4 0 0 1 13 8c.5 0 .93.12 1.24.28q.24.12.42.28l.19.21c.05.07.15.24.15.48q-.01.41-.35.64l-1.9 1.19-1.67 1.89-1.37 1.9A2.8 2.8 0 0 1 7.48 16H6.34c-.93 0-1.82-.47-2.3-1.31a21 21 0 0 1-.98-1.9 6 6 0 0 1-.56-2.04v-7a.75.75 0 0 1 1.5 0V8a.5.5 0 0 0 1 0V2.5a.75.75 0 0 1 1.5 0v5a.5.5 0 1 0 1 0M15 22a7 7 0 0 1-6.73-5.08c.9-.2 1.7-.71 2.25-1.47l1.35-1.86 1.53-1.74 1.78-1.12c.5-.32.82-.88.82-1.48a2 2 0 0 0-.47-1.23A7 7 0 0 1 15 22m3-8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5.86 2.71c-.3.29-.31.76-.02 1.06a4 4 0 0 0 5.76 0 .75.75 0 1 0-1.08-1.04 2.5 2.5 0 0 1-3.6 0 .75.75 0 0 0-1.06-.02M14 14a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $f342bb1007016cbf$export$66779430c4332779 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand24Regular', "24", [
    "M9.24 1.82q.23-.06.51-.07c1.1 0 1.75.9 1.75 1.75v3.67q.44-.16 1-.17C13.9 7 15 8.03 15 9.5c0 .24-.12.47-.31.61l-1.72 1.23-.96.83q-.95.84-1.7 1.87l-.6.83A2.8 2.8 0 0 1 7.48 16H5.84c-.93 0-1.82-.47-2.3-1.31a21 21 0 0 1-.98-1.9A6 6 0 0 1 2 10.75v-6a1.74 1.74 0 0 1 2.07-1.72c.19-.69.79-1.28 1.68-1.28q.27 0 .51.07c.3-.47.8-.82 1.49-.82s1.2.35 1.49.82m-1.67.75a.3.3 0 0 0-.07.18v4.5a.75.75 0 0 1-1.5 0v-3.8a.2.2 0 0 0-.06-.12.3.3 0 0 0-.19-.08q-.14 0-.18.07a.3.3 0 0 0-.07.18v4.25a.75.75 0 0 1-1.5 0v-3a.3.3 0 0 0-.07-.18q-.04-.07-.18-.07t-.18.07a.3.3 0 0 0-.07.18v6c0 .28.15.79.43 1.43.27.62.62 1.26.9 1.76.2.34.58.56 1.01.56h1.64c.4 0 .78-.2 1.01-.52l.6-.82q.84-1.17 1.94-2.12l.98-.86.06-.04 1.38-.99c-.12-.4-.48-.65-.95-.65-.63 0-1.09.4-1.24.53l-.03.03A.75.75 0 0 1 10 8.5V3.5a.3.3 0 0 0-.07-.18q-.05-.06-.18-.07-.14 0-.18.07a.3.3 0 0 0-.07.18v3.75a.75.75 0 0 1-1.5 0v-4.5a.3.3 0 0 0-.07-.18q-.04-.06-.18-.07-.14 0-.18.07M13 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-2 7a7 7 0 0 1-6.73-5.08q.76-.17 1.39-.62A5.5 5.5 0 1 0 16 9.6V9.5q0-.8-.3-1.47A7 7 0 0 1 15 22m-1.8-5.27a.75.75 0 0 0-1.08 1.04 4 4 0 0 0 5.76 0 .75.75 0 1 0-1.08-1.04 2.5 2.5 0 0 1-3.6 0"
]);
const $f342bb1007016cbf$export$d814f982b38a7d19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand28Filled', "28", [
    "M8.5 8.5V2.75a.75.75 0 0 1 1.5 0V8.5a.5.5 0 0 0 1 0v-5a.75.75 0 0 1 1.5 0v5.81A4 4 0 0 1 14 9c.5 0 .93.12 1.24.28q.24.12.42.28l.19.21c.05.07.15.24.15.48q-.01.41-.35.64l-1.9 1.19-1.67 1.89-1.37 1.9A2.8 2.8 0 0 1 8.48 17H7.34c-.93 0-1.82-.47-2.3-1.31a21 21 0 0 1-.98-1.9 6 6 0 0 1-.56-2.04v-7a.75.75 0 0 1 1.5 0V9a.5.5 0 0 0 1 0V3.5a.75.75 0 0 1 1.5 0v5a.5.5 0 1 0 1 0m9 17.5a8.5 8.5 0 0 1-8.49-8.04c1-.14 1.9-.68 2.5-1.5l1.36-1.87 1.53-1.74 1.78-1.12c.5-.32.82-.88.82-1.48a2 2 0 0 0-.44-1.2Q17 9 17.5 9a8.5 8.5 0 1 1 0 17m3.63-10a1.12 1.12 0 1 0-2.25 0 1.12 1.12 0 0 0 2.25 0m-7.36 3.67a.75.75 0 0 0-.09 1.06 5 5 0 0 0 7.64 0 .75.75 0 1 0-1.14-.97 3.5 3.5 0 0 1-5.35 0 .75.75 0 0 0-1.06-.1M16.13 16a1.12 1.12 0 1 0-2.25 0 1.12 1.12 0 0 0 2.25 0"
]);
const $f342bb1007016cbf$export$b33e2ee53ab35432 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand28Regular', "28", [
    "M10.75 2.75q-.28 0-.51.07A1.7 1.7 0 0 0 8.75 2c-.68 0-1.2.35-1.49.82a2 2 0 0 0-.51-.07c-.9 0-1.5.6-1.68 1.28Q4.92 4 4.75 4C3.65 4 3 4.9 3 5.75v6c0 .62.27 1.39.56 2.04.3.68.67 1.37.98 1.9A2.6 2.6 0 0 0 6.84 17h1.64c.88 0 1.7-.42 2.23-1.13l.6-.83q.75-1.03 1.7-1.87l.96-.83 1.72-1.23q.3-.23.31-.61C16 9.03 14.9 8 13.5 8q-.56.01-1 .17V4.5c0-.85-.65-1.75-1.75-1.75m-2.25 1q0-.1.07-.18.04-.06.18-.07.14 0 .18.07.06.07.07.18v4.5a.75.75 0 0 0 1.5 0V4.5q0-.1.07-.18.04-.07.18-.07t.18.07q.06.07.07.18v4.99a.75.75 0 0 0 1.23.57l.03-.03c.15-.13.6-.53 1.24-.53.47 0 .83.24.95.65l-1.38.99-.06.04-.98.86q-1.1.95-1.94 2.12l-.6.82c-.23.33-.6.52-1.01.52H6.84c-.43 0-.8-.22-1-.56-.3-.5-.64-1.14-.9-1.76a4 4 0 0 1-.44-1.43v-6q0-.1.07-.18.04-.07.18-.07t.18.07q.07.08.07.18v3a.75.75 0 0 0 1.5 0V4.5q0-.1.07-.18.04-.06.18-.07.14 0 .2.08.05.06.05.12v3.8a.75.75 0 0 0 1.5 0v-4.5m9 22.25a8.5 8.5 0 0 1-8.49-8.04 4 4 0 0 0 1.5-.55l-.01.09a7 7 0 1 0 6.5-6.98v-.02q0-.8-.3-1.46.4-.04.8-.04a8.5 8.5 0 1 1 0 17m-1.38-10a1.12 1.12 0 1 1-2.24 0 1.12 1.12 0 0 1 2.24 0M20 17.12a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24m-5.17 2.64a.75.75 0 0 0-1.15.97 5 5 0 0 0 7.64 0 .75.75 0 1 0-1.14-.97 3.5 3.5 0 0 1-5.35 0"
]);
const $f342bb1007016cbf$export$c8fe76502f9afa66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand32Filled', "32", [
    "M7 3a1 1 0 0 1 1 1v5.5a.5.5 0 0 0 1 0V3a1 1 0 0 1 2 0v6.5a.5.5 0 0 0 1 0V4a1 1 0 1 1 2 0v7.55a4.3 4.3 0 0 1 2.48-.5c.5.08.86.3 1.1.56a2 2 0 0 1 .35.53l.01.02v.02a1 1 0 0 1-.44 1.19h-.02l-.06.04a10 10 0 0 0-1.18.82c-.76.58-1.74 1.43-2.64 2.5q-.56.68-1.27 1.2A4.5 4.5 0 0 1 9.53 19H8.26a4 4 0 0 1-3.43-1.94l-1.12-1.87A5 5 0 0 1 3 12.62V5a1 1 0 0 1 2 0v5.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 1-1m4 17.5v-.26a8 8 0 0 0 3.75-2.54 15 15 0 0 1 3.5-3.03 2.5 2.5 0 0 0 .83-3.56q.7-.1 1.42-.11a9.5 9.5 0 1 1-9.5 9.5m5.37 2.05a1 1 0 0 0-.15 1.4 5.5 5.5 0 0 0 8.56 0 1 1 0 0 0-1.56-1.25 3.5 3.5 0 0 1-5.44 0 1 1 0 0 0-1.4-.15M19.25 19a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0M23 20.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
]);
const $f342bb1007016cbf$export$bff1f424f920a6d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand32Regular', "32", [
    "M8.39 3.16a2.5 2.5 0 0 1 4.22 0A2.5 2.5 0 0 1 16 5.5v4.9q1.34-.45 2.4-.02a3.3 3.3 0 0 1 1.8 1.94c.46 1.13-.34 2.08-1.1 2.4a13 13 0 0 0-5 3.81A6 6 0 0 1 9.54 21H8.26a5 5 0 0 1-4.28-2.43L2.86 16.7A6 6 0 0 1 2 13.62V6.5a2.5 2.5 0 0 1 3.39-2.34 2.5 2.5 0 0 1 3-1M14 5.5a.5.5 0 0 0-1 0V10a1 1 0 1 1-2 0V4.5a.5.5 0 0 0-1 0V10a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V6.5a.5.5 0 0 0-1 0v7.12a4 4 0 0 0 .57 2.05l1.12 1.87A3 3 0 0 0 8.26 19h1.27c1.1 0 2.19-.66 3-1.7a15 15 0 0 1 5.75-4.4q-.24-.5-.61-.66c-.26-.1-.88-.18-2.14.6A1 1 0 0 1 14 12zm-2.83 16.79a9.5 9.5 0 1 0 10.08-11.26q.23.42.35.73.29.72.24 1.36a7.5 7.5 0 1 1-8.78 8.35q-.85.54-1.9.82m5.2.26a1 1 0 0 1 1.4.15 3.5 3.5 0 0 0 5.45 0 1 1 0 0 1 1.56 1.26 5.5 5.5 0 0 1-8.56 0 1 1 0 0 1 .15-1.4m1.63-2.3a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M24.25 19a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
]);
const $f342bb1007016cbf$export$581760af485a2504 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand48Filled', "48", [
    "M18.5 18.26a6 6 0 0 1 3.67-1.2 4 4 0 0 1 2.48 1.07l.02.02v.01a1.25 1.25 0 0 1-.32 1.93l-.01.01-.4.25q-.44.29-1.2.95a20 20 0 0 0-3.84 4.6l-.11.23A6.2 6.2 0 0 1 13.82 29h-3.04a5.3 5.3 0 0 1-4.82-3.16L4.6 22.72q-.6-1.39-.6-2.9V7.25a1.25 1.25 0 1 1 2.5 0v9a.75.75 0 0 0 1.5 0V5.75a1.25 1.25 0 1 1 2.5 0v9.5a.75.75 0 0 0 1.5 0v-11a1.25 1.25 0 1 1 2.5 0v11a.75.75 0 0 0 1.5 0v-9.5a1.25 1.25 0 1 1 2.5 0zM30 44.87a15 15 0 0 1-14.97-14.12 8.4 8.4 0 0 0 5.55-3.88l.05-.1.07-.1.07-.11a18 18 0 0 1 3.28-3.89q.69-.57 1.03-.8l.08-.05.22-.14a3.23 3.23 0 0 0 .83-4.94l-.09-.1-.04-.05-.07-.07-.24-.22q-.36-.31-.77-.55l-.03-.02q2.37-.85 5.03-.86a15 15 0 1 1 0 30m0-8.5c-2.3 0-4.3-1.16-5.45-2.93a1.25 1.25 0 1 0-2.1 1.36A9 9 0 0 0 30 38.87c3.15 0 5.94-1.6 7.55-4.07a1.25 1.25 0 1 0-2.1-1.36A6.5 6.5 0 0 1 30 36.37m6-9.5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-10 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
]);
const $f342bb1007016cbf$export$be2873444afda57d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHand48Regular', "48", [
    "M11 7.75a.75.75 0 0 0-1.5 0v9a1.25 1.25 0 1 1-2.5 0v-7.5a.75.75 0 0 0-1.5 0v10.57q0 1.2.48 2.3l1.36 3.13a3.8 3.8 0 0 0 3.44 2.25h3.04c1.42 0 2.8-.86 3.73-2.21 2.67-3.9 6.16-6.31 7.85-7.33a2.2 2.2 0 0 0-1.1-1c-.45-.15-1.45-.2-3.26 1.26a1.25 1.25 0 0 1-2.04-.97v-9.5a.75.75 0 0 0-1.5 0v7.5a1.25 1.25 0 1 1-2.5 0v-9a.75.75 0 0 0-1.5 0v9a1.25 1.25 0 1 1-2.5 0zm10.5 7.21a4.7 4.7 0 0 1 3.62-.36 5 5 0 0 1 2.7 2.58c.57 1.16-.08 2.3-.91 2.8a23.5 23.5 0 0 0-7.3 6.72c-1.26 1.85-3.33 3.3-5.8 3.3h-3.03a6.3 6.3 0 0 1-5.73-3.76l-1.36-3.12a8 8 0 0 1-.69-3.3V9.25a3.25 3.25 0 0 1 4.39-3.04 3.25 3.25 0 0 1 4-1.5 3.25 3.25 0 0 1 5.72 0 3.24 3.24 0 0 1 4.39 3.04zM15.12 31.9a15 15 0 1 0 13.74-16.86c.35.49.6.94.76 1.26q.3.6.38 1.2a12.5 12.5 0 1 1-12.45 13.61 8 8 0 0 1-2.43.79m7.7 1.3a1.25 1.25 0 0 1 1.73.37A6.5 6.5 0 0 0 30 36.5c2.3 0 4.3-1.16 5.45-2.93a1.25 1.25 0 1 1 2.1 1.36A9 9 0 0 1 30 39a9 9 0 0 1-7.55-4.07 1.25 1.25 0 0 1 .37-1.73M34 29a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-6-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $f342bb1007016cbf$export$ada573ee3ac96cbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint16Filled', "16", [
    "M6.83 2.11a.5.5 0 0 0 .2.99 5 5 0 0 1 1.95 0 .5.5 0 0 0 .2-.99 6 6 0 0 0-2.35 0m4.5.9a.5.5 0 0 0-.55.83q.82.56 1.38 1.38a.5.5 0 0 0 .83-.55q-.66-1-1.66-1.66m-6.1.83a.5.5 0 1 0-.56-.83q-1 .67-1.66 1.66a.5.5 0 1 0 .83.55q.56-.82 1.38-1.38m8.66 2.99a.5.5 0 1 0-.99.2c.13.62.13 1.32 0 1.95a.5.5 0 0 0 .99.19c.15-.76.15-1.58 0-2.34m-10.8.2a.5.5 0 0 0-.98-.2 6 6 0 0 0 0 2.34.5.5 0 1 0 .99-.2 5 5 0 0 1 0-1.95m9.9 4.3a.5.5 0 0 0-.83-.55 5 5 0 0 1-1.38 1.38.5.5 0 0 0 .55.83q1-.66 1.66-1.66m-9.15-.55a.5.5 0 1 0-.83.55q.67 1 1.66 1.66a.5.5 0 1 0 .55-.83 5 5 0 0 1-1.38-1.38m3.18 2.12a.5.5 0 0 0-.19.99c.76.15 1.58.15 2.34 0a.5.5 0 1 0-.2-.99c-.62.13-1.32.13-1.95 0M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.7 1.1a.5.5 0 0 0-.7.1 2 2 0 0 1-3.2 0 .5.5 0 0 0-.8.6 3 3 0 0 0 4.8 0 .5.5 0 0 0-.1-.7M6.25 7.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.25-.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $f342bb1007016cbf$export$7f34731d39da97b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint16Regular', "16", [
    "M6.83 2.11a.5.5 0 0 0 .2.99 5 5 0 0 1 1.95 0 .5.5 0 0 0 .2-.99 6 6 0 0 0-2.35 0m4.5.9a.5.5 0 0 0-.55.83q.82.56 1.38 1.38a.5.5 0 0 0 .83-.55q-.66-1-1.66-1.66m-6.1.83a.5.5 0 1 0-.56-.83q-1 .67-1.66 1.66a.5.5 0 1 0 .83.55q.56-.82 1.38-1.38m8.66 2.99a.5.5 0 1 0-.99.2c.13.62.13 1.32 0 1.95a.5.5 0 0 0 .99.19c.15-.76.15-1.58 0-2.34m-10.8.2a.5.5 0 0 0-.98-.2 6 6 0 0 0 0 2.34.5.5 0 1 0 .99-.2 5 5 0 0 1 0-1.95m9.9 4.3a.5.5 0 0 0-.83-.55 5 5 0 0 1-1.38 1.38.5.5 0 0 0 .55.83q1-.66 1.66-1.66m-9.15-.55a.5.5 0 1 0-.83.55q.67 1 1.66 1.66a.5.5 0 1 0 .55-.83 5 5 0 0 1-1.38-1.38m3.18 2.12a.5.5 0 0 0-.19.99c.76.15 1.58.15 2.34 0a.5.5 0 1 0-.2-.99c-.62.13-1.32.13-1.95 0m3.38-3.1a.5.5 0 0 0-.8-.6 2 2 0 0 1-3.2 0 .5.5 0 0 0-.8.6 3 3 0 0 0 4.8 0M7 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $f342bb1007016cbf$export$4014a635f148304e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint20Filled', "20", [
    "M8.44 2.15a.5.5 0 0 0 .2.98 7 7 0 0 1 2.73 0 .5.5 0 0 0 .19-.98 8 8 0 0 0-3.12 0m6 1.2a.5.5 0 0 0-.55.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m-8.33.83a.5.5 0 0 0-.56-.83 8 8 0 0 0-2.2 2.2.5.5 0 0 0 .83.56A7 7 0 0 1 6.1 4.18M3.13 8.63a.5.5 0 1 0-.98-.2 8 8 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7 7 0 0 1 0-2.73m14.72-.2a.5.5 0 1 0-.98.2 7 7 0 0 1 0 2.74.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13M4.18 13.9a.5.5 0 0 0-.83.56 8 8 0 0 0 2.2 2.2.5.5 0 0 0 .56-.83 7 7 0 0 1-1.93-1.93m12.47.56a.5.5 0 1 0-.83-.56 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .55.83 8 8 0 0 0 2.21-2.2m-8.02 2.42a.5.5 0 0 0-.2.98c1.02.2 2.12.2 3.13 0a.5.5 0 0 0-.2-.98c-.88.17-1.84.17-2.73 0M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-9.44 2.11a.5.5 0 0 0-.07.7 4.5 4.5 0 0 0 7.02 0 .5.5 0 1 0-.78-.62 3.5 3.5 0 0 1-5.46 0 .5.5 0 0 0-.7-.08M7.75 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M13 8.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $f342bb1007016cbf$export$2f1dd8ae863ffbab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint20Regular', "20", [
    "M8.44 2.15a.5.5 0 0 0 .2.98 7 7 0 0 1 2.73 0 .5.5 0 0 0 .19-.98 8 8 0 0 0-3.12 0m6 1.2a.5.5 0 0 0-.55.83 7 7 0 0 1 1.93 1.93.5.5 0 1 0 .83-.56 8 8 0 0 0-2.2-2.2m-8.33.83a.5.5 0 0 0-.56-.83 8 8 0 0 0-2.2 2.2.5.5 0 0 0 .83.56A7 7 0 0 1 6.1 4.18M3.13 8.63a.5.5 0 1 0-.98-.2 8 8 0 0 0 0 3.13.5.5 0 0 0 .98-.2 7 7 0 0 1 0-2.73m14.72-.2a.5.5 0 1 0-.98.2 7 7 0 0 1 0 2.74.5.5 0 1 0 .98.2 8 8 0 0 0 0-3.13M4.18 13.9a.5.5 0 0 0-.83.56 8 8 0 0 0 2.2 2.2.5.5 0 0 0 .56-.83 7 7 0 0 1-1.93-1.93m12.47.56a.5.5 0 1 0-.83-.56 7 7 0 0 1-1.93 1.93.5.5 0 1 0 .55.83 8 8 0 0 0 2.21-2.2m-8.02 2.42a.5.5 0 0 0-.2.98c1.02.2 2.12.2 3.13 0a.5.5 0 0 0-.2-.98c-.88.17-1.84.17-2.73 0M7.75 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.5 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-5.69 3.11a.5.5 0 0 1 .7.08 3.5 3.5 0 0 0 5.47 0 .5.5 0 0 1 .78.62 4.5 4.5 0 0 1-7.02 0 .5.5 0 0 1 .07-.7"
]);
const $f342bb1007016cbf$export$3220a89cb7d69fe6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint24Filled', "24", [
    "M10.05 2.19a.75.75 0 0 0 .29 1.47 9 9 0 0 1 3.32 0 .75.75 0 0 0 .3-1.47 10 10 0 0 0-3.91 0M7.28 4.93a.75.75 0 0 0-.84-1.25 10 10 0 0 0-2.76 2.76.75.75 0 1 0 1.25.84 9 9 0 0 1 2.35-2.35m10.28-1.25a.75.75 0 0 0-.84 1.25 9 9 0 0 1 2.35 2.35.75.75 0 1 0 1.25-.84 10 10 0 0 0-2.76-2.76m4.25 6.37a.75.75 0 0 0-1.47.29 9 9 0 0 1 0 3.32.75.75 0 0 0 1.47.3c.25-1.27.25-2.65 0-3.91m-18.15.29a.75.75 0 0 0-1.47-.3 10 10 0 0 0 0 3.91.75.75 0 1 0 1.47-.29 9 9 0 0 1 0-3.32m1.27 6.38a.75.75 0 0 0-1.25.84 10 10 0 0 0 2.76 2.76.75.75 0 1 0 .84-1.25 9 9 0 0 1-2.35-2.35m15.39.84a.75.75 0 1 0-1.25-.84 9 9 0 0 1-2.35 2.35.75.75 0 1 0 .84 1.25 10 10 0 0 0 2.76-2.76m-9.98 2.78a.75.75 0 0 0-.3 1.47c1.27.25 2.65.25 3.91 0a.75.75 0 1 0-.29-1.47 9 9 0 0 1-3.32 0M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0M8.27 14.17a.75.75 0 0 0-.1 1.05 5 5 0 0 0 7.65 0 .75.75 0 0 0-1.14-.96 3.5 3.5 0 0 1-5.36 0 .75.75 0 0 0-1.05-.1M9.5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
]);
const $f342bb1007016cbf$export$b5908d9984b382f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint24Regular', "24", [
    "M10.05 2.19a.75.75 0 0 0 .29 1.47 9 9 0 0 1 3.32 0 .75.75 0 0 0 .3-1.47 10 10 0 0 0-3.91 0M7.28 4.93a.75.75 0 0 0-.84-1.25 10 10 0 0 0-2.76 2.76.75.75 0 1 0 1.25.84 9 9 0 0 1 2.35-2.35m10.28-1.25a.75.75 0 0 0-.84 1.25 9 9 0 0 1 2.35 2.35.75.75 0 1 0 1.25-.84 10 10 0 0 0-2.76-2.76m4.25 6.37a.75.75 0 0 0-1.47.29 9 9 0 0 1 0 3.32.75.75 0 0 0 1.47.3c.25-1.27.25-2.65 0-3.91m-18.15.29a.75.75 0 0 0-1.47-.3 10 10 0 0 0 0 3.91.75.75 0 1 0 1.47-.29 9 9 0 0 1 0-3.32m1.27 6.38a.75.75 0 0 0-1.25.84 10 10 0 0 0 2.76 2.76.75.75 0 1 0 .84-1.25 9 9 0 0 1-2.35-2.35m15.39.84a.75.75 0 1 0-1.25-.84 9 9 0 0 1-2.35 2.35.75.75 0 1 0 .84 1.25 10 10 0 0 0 2.76-2.76m-9.98 2.78a.75.75 0 0 0-.3 1.47c1.27.25 2.65.25 3.91 0a.75.75 0 1 0-.29-1.47 9 9 0 0 1-3.32 0M9.5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-6.18 4.26a.75.75 0 1 0-1.14.96 5 5 0 0 0 7.64 0 .75.75 0 0 0-1.14-.96 3.5 3.5 0 0 1-5.36 0"
]);
const $f342bb1007016cbf$export$3b3d3c87da06e1a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint28Filled', "28", [
    "M11.66 2.23a.75.75 0 1 0 .29 1.47c1.33-.26 2.78-.26 4.1 0a.75.75 0 0 0 .3-1.47 12 12 0 0 0-4.7 0m9 1.8a.75.75 0 0 0-.83 1.24q1.74 1.16 2.9 2.9a.75.75 0 1 0 1.25-.84c-.88-1.3-2-2.43-3.31-3.3M8.17 5.26a.75.75 0 0 0-.83-1.25c-1.3.88-2.43 2-3.3 3.31a.75.75 0 0 0 1.24.84 11 11 0 0 1 2.9-2.9m17.61 6.39a.75.75 0 1 0-1.47.29c.26 1.32.26 2.78 0 4.1a.75.75 0 0 0 1.47.3c.3-1.52.3-3.18 0-4.7m-22.07.29a.75.75 0 1 0-1.47-.3 12 12 0 0 0 0 4.7.75.75 0 0 0 1.47-.3 11 11 0 0 1 0-4.1m20.28 8.72a.75.75 0 1 0-1.25-.84 11 11 0 0 1-2.9 2.9.75.75 0 1 0 .84 1.25c1.3-.88 2.43-2 3.3-3.31m-18.71-.84a.75.75 0 0 0-1.25.84c.88 1.3 2 2.43 3.31 3.3a.75.75 0 1 0 .84-1.24 11 11 0 0 1-2.9-2.9m11.07 5.94a.75.75 0 0 0-.29-1.47c-1.32.26-2.77.26-4.1 0a.75.75 0 0 0-.3 1.47c1.52.3 3.18.3 4.7 0M23 14a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-11-2.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m5.25 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-8.1 4.68a.75.75 0 0 0-.08 1.06 6.5 6.5 0 0 0 9.86 0 .75.75 0 0 0-1.14-.98 5 5 0 0 1-7.58 0 .75.75 0 0 0-1.06-.08"
]);
const $f342bb1007016cbf$export$ef7e29957de5489f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint28Regular', "28", [
    "M11.66 2.23a.75.75 0 1 0 .29 1.47c1.33-.26 2.78-.26 4.1 0a.75.75 0 0 0 .3-1.47 12 12 0 0 0-4.7 0m9 1.8a.75.75 0 0 0-.83 1.24q1.74 1.16 2.9 2.9a.75.75 0 1 0 1.25-.84c-.88-1.3-2-2.43-3.31-3.3M8.17 5.26a.75.75 0 0 0-.83-1.25c-1.3.88-2.43 2-3.3 3.31a.75.75 0 0 0 1.24.84 11 11 0 0 1 2.9-2.9m17.61 6.39a.75.75 0 1 0-1.47.29c.26 1.32.26 2.78 0 4.1a.75.75 0 0 0 1.47.3c.3-1.52.3-3.18 0-4.7m-22.07.29a.75.75 0 1 0-1.47-.3 12 12 0 0 0 0 4.7.75.75 0 0 0 1.47-.3 11 11 0 0 1 0-4.1m20.28 8.72a.75.75 0 1 0-1.25-.84 11 11 0 0 1-2.9 2.9.75.75 0 1 0 .84 1.25c1.3-.88 2.43-2 3.3-3.31m-18.71-.84a.75.75 0 0 0-1.25.84c.88 1.3 2 2.43 3.31 3.3a.75.75 0 1 0 .84-1.24 11 11 0 0 1-2.9-2.9m11.07 5.94a.75.75 0 0 0-.29-1.47c-1.32.26-2.77.26-4.1 0a.75.75 0 0 0-.3 1.47c1.52.3 3.18.3 4.7 0M10.75 12.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m7.75-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-8.3 6a.75.75 0 1 0-1.13.99 6.5 6.5 0 0 0 9.86 0 .75.75 0 0 0-1.14-.98 5 5 0 0 1-7.58 0"
]);
const $f342bb1007016cbf$export$f8697c4a61ee628b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint32Filled', "32", [
    "M13.27 2.27a1 1 0 0 0 .39 1.96c1.54-.3 3.14-.3 4.68 0a1 1 0 0 0 .4-1.96c-1.8-.36-3.67-.36-5.47 0M9.33 6.02a1 1 0 0 0-1.1-1.66 14 14 0 0 0-3.87 3.86 1 1 0 0 0 1.66 1.11c.88-1.3 2-2.43 3.31-3.3m14.45-1.66a1 1 0 0 0-1.11 1.66q1.97 1.33 3.31 3.31a1 1 0 0 0 1.66-1.1 14 14 0 0 0-3.86-3.87m5.95 8.9a1 1 0 0 0-1.96.4c.3 1.54.3 3.14 0 4.68a1 1 0 1 0 1.96.4c.36-1.8.36-3.67 0-5.47m-25.5.4a1 1 0 1 0-1.96-.4c-.36 1.8-.36 3.67 0 5.47a1 1 0 1 0 1.96-.39c-.3-1.54-.3-3.14 0-4.68m1.8 9a1 1 0 1 0-1.67 1.12 14 14 0 0 0 3.86 3.86 1 1 0 1 0 1.11-1.66c-1.3-.88-2.43-2-3.3-3.31m21.61 1.12a1 1 0 1 0-1.66-1.11q-1.33 1.97-3.31 3.31a1 1 0 1 0 1.11 1.66 14 14 0 0 0 3.86-3.86m-13.98 4a1 1 0 1 0-.4 1.95c1.8.36 3.67.36 5.47 0a1 1 0 0 0-.39-1.96c-1.54.3-3.14.3-4.68 0M26 16a10 10 0 1 1-20 0 10 10 0 0 1 20 0m-15.14 3.26a1 1 0 0 0-.08 1.4 7 7 0 0 0 10.44 0 1 1 0 0 0-1.5-1.33 4.98 4.98 0 0 1-7.45 0 1 1 0 0 0-1.4-.07M12.25 15a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m9.25-1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0"
]);
const $f342bb1007016cbf$export$dbdb8bed965500e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint32Regular', "32", [
    "M13.27 2.27a1 1 0 0 0 .39 1.96c1.54-.3 3.14-.3 4.68 0a1 1 0 0 0 .4-1.96c-1.8-.36-3.67-.36-5.47 0M9.33 6.02a1 1 0 0 0-1.1-1.66 14 14 0 0 0-3.87 3.86 1 1 0 0 0 1.66 1.11c.88-1.3 2-2.43 3.31-3.3m14.45-1.66a1 1 0 0 0-1.11 1.66q1.97 1.33 3.31 3.31a1 1 0 0 0 1.66-1.1 14 14 0 0 0-3.86-3.87m5.95 8.9a1 1 0 0 0-1.96.4c.3 1.54.3 3.14 0 4.68a1 1 0 1 0 1.96.4c.36-1.8.36-3.67 0-5.47m-25.5.4a1 1 0 1 0-1.96-.4c-.36 1.8-.36 3.67 0 5.47a1 1 0 1 0 1.96-.39c-.3-1.54-.3-3.14 0-4.68m1.8 9a1 1 0 1 0-1.67 1.12 14 14 0 0 0 3.86 3.86 1 1 0 1 0 1.11-1.66c-1.3-.88-2.43-2-3.3-3.31m21.61 1.12a1 1 0 1 0-1.66-1.11q-1.33 1.97-3.31 3.31a1 1 0 1 0 1.11 1.66 14 14 0 0 0 3.86-3.86m-13.98 4a1 1 0 1 0-.4 1.95c1.8.36 3.67.36 5.47 0a1 1 0 0 0-.39-1.96c-1.54.3-3.14.3-4.68 0m-1.39-8.45a1 1 0 0 0-1.49 1.34 7 7 0 0 0 10.44 0 1 1 0 0 0-1.5-1.34 4.98 4.98 0 0 1-7.45 0M14 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M19.75 15a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
]);
const $f342bb1007016cbf$export$5ec6c808600abefa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint48Filled', "48", [
    "M20.1 4.38a1.25 1.25 0 1 0 .48 2.45c2.25-.44 4.59-.44 6.84 0a1.25 1.25 0 1 0 .48-2.45c-2.57-.5-5.23-.5-7.8 0m-5.82 5.07a1.25 1.25 0 1 0-1.4-2.08 20 20 0 0 0-5.51 5.52 1.25 1.25 0 1 0 2.08 1.39 18 18 0 0 1 4.83-4.83M35.1 7.37a1.25 1.25 0 0 0-1.39 2.08 18 18 0 0 1 4.83 4.83 1.25 1.25 0 1 0 2.08-1.4 20 20 0 0 0-5.52-5.51M6.83 20.58a1.25 1.25 0 0 0-2.45-.48c-.5 2.57-.5 5.23 0 7.8a1.25 1.25 0 0 0 2.45-.48 18 18 0 0 1 0-6.84m36.79-.48a1.25 1.25 0 0 0-2.45.48c.44 2.25.44 4.59 0 6.84a1.25 1.25 0 0 0 2.45.48c.5-2.57.5-5.23 0-7.8M9.45 33.72a1.25 1.25 0 1 0-2.08 1.4 20 20 0 0 0 5.52 5.51 1.25 1.25 0 0 0 1.39-2.08 18 18 0 0 1-4.83-4.83m31.18 1.4a1.25 1.25 0 1 0-2.08-1.4 18 18 0 0 1-4.83 4.83 1.25 1.25 0 0 0 1.4 2.08 20 20 0 0 0 5.51-5.52m-20.05 6.05a1.25 1.25 0 1 0-.48 2.45c2.57.5 5.23.5 7.8 0a1.25 1.25 0 1 0-.48-2.45c-2.25.44-4.59.44-6.84 0M39 24a15 15 0 1 1-30 0 15 15 0 0 1 30 0m-18.5-4.25a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0M29.75 22a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M15.7 29.27c-.53.44-.6 1.23-.16 1.76a10.98 10.98 0 0 0 16.92 0 1.25 1.25 0 1 0-1.92-1.6 8.48 8.48 0 0 1-13.08 0 1.25 1.25 0 0 0-1.76-.16"
]);
const $f342bb1007016cbf$export$531181342bb14754 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiHint48Regular', "48", [
    "M20.1 4.38a1.25 1.25 0 1 0 .48 2.45c2.25-.44 4.59-.44 6.84 0a1.25 1.25 0 1 0 .48-2.45c-2.57-.5-5.23-.5-7.8 0m-5.82 5.07a1.25 1.25 0 1 0-1.4-2.08 20 20 0 0 0-5.51 5.52 1.25 1.25 0 1 0 2.08 1.39 18 18 0 0 1 4.83-4.83M35.1 7.37a1.25 1.25 0 0 0-1.39 2.08 18 18 0 0 1 4.83 4.83 1.25 1.25 0 1 0 2.08-1.4 20 20 0 0 0-5.52-5.51M6.83 20.58a1.25 1.25 0 0 0-2.45-.48c-.5 2.57-.5 5.23 0 7.8a1.25 1.25 0 0 0 2.45-.48 18 18 0 0 1 0-6.84m36.79-.48a1.25 1.25 0 0 0-2.45.48c.44 2.25.44 4.59 0 6.84a1.25 1.25 0 0 0 2.45.48c.5-2.57.5-5.23 0-7.8M9.45 33.72a1.25 1.25 0 1 0-2.08 1.4 20 20 0 0 0 5.52 5.51 1.25 1.25 0 0 0 1.39-2.08 18 18 0 0 1-4.83-4.83m31.18 1.4a1.25 1.25 0 1 0-2.08-1.4 18 18 0 0 1-4.83 4.83 1.25 1.25 0 0 0 1.4 2.08 20 20 0 0 0 5.51-5.52m-20.05 6.05a1.25 1.25 0 1 0-.48 2.45c2.57.5 5.23.5 7.8 0a1.25 1.25 0 1 0-.48-2.45c-2.25.44-4.59.44-6.84 0M18.25 22a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M32 19.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-14.54 9.68a1.25 1.25 0 1 0-1.92 1.6 10.98 10.98 0 0 0 16.92 0 1.25 1.25 0 1 0-1.92-1.6 8.48 8.48 0 0 1-13.08 0"
]);
const $f342bb1007016cbf$export$8d3a952e7acad071 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaugh16Filled', "16", [
    "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M6 6c.28 0 .5.22.5.5a.5.5 0 0 0 1 0 1.5 1.5 0 1 0-3 0 .5.5 0 0 0 1 0c0-.28.22-.5.5-.5m4 0c.28 0 .5.22.5.5a.5.5 0 0 0 1 0 1.5 1.5 0 0 0-3 0 .5.5 0 0 0 1 0c0-.28.22-.5.5-.5M4.54 8.5a3.5 3.5 0 0 0 6.92 0z"
]);
const $f342bb1007016cbf$export$7e4b1ff2e1d1c9d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaugh16Regular', "16", [
    "M6 6a.5.5 0 0 0-.5.5.5.5 0 0 1-1 0 1.5 1.5 0 1 1 3 0 .5.5 0 0 1-1 0A.5.5 0 0 0 6 6m4 0a.5.5 0 0 0-.5.5.5.5 0 0 1-1 0 1.5 1.5 0 1 1 3 0 .5.5 0 0 1-1 0A.5.5 0 0 0 10 6M4.54 8a.5.5 0 0 0-.5.57 4 4 0 0 0 7.92 0 .5.5 0 0 0-.5-.57zM8 11a3 3 0 0 1-2.83-2h5.66A3 3 0 0 1 8 11m6-3A6 6 0 1 0 2 8a6 6 0 0 0 12 0M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8"
]);
const $f342bb1007016cbf$export$6df5d288073fc377 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaugh20Filled', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M6.5 8.08a.5.5 0 1 1-1-.16c.13-.83.9-1.42 1.75-1.42s1.61.59 1.74 1.42a.5.5 0 1 1-.99.16c-.04-.3-.34-.58-.75-.58-.42 0-.71.28-.76.58m5.5 0a.5.5 0 0 1-1-.16c.13-.83.9-1.42 1.75-1.42s1.61.59 1.74 1.42a.5.5 0 0 1-.99.16c-.04-.3-.34-.58-.75-.58-.42 0-.71.28-.76.58M5.5 10.5h9c-.22 2.2-1.93 4-4.5 4a4.36 4.36 0 0 1-4.5-4"
]);
const $f342bb1007016cbf$export$772cf7e7f7991750 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaugh20Regular', "20", [
    "M6.5 8.08c.04-.3.33-.58.75-.58.41 0 .7.28.75.58A.5.5 0 1 0 9 7.92 1.7 1.7 0 0 0 7.25 6.5c-.86 0-1.62.59-1.74 1.42a.5.5 0 1 0 .98.16m6.25-.58c-.42 0-.71.28-.76.58a.5.5 0 0 1-.98-.16c.12-.83.88-1.42 1.74-1.42.85 0 1.61.59 1.74 1.42a.5.5 0 0 1-.99.16c-.04-.3-.34-.58-.75-.58M5.5 10a.5.5 0 0 0-.5.55A4.86 4.86 0 0 0 10 15c2.84 0 4.75-2 5-4.45a.5.5 0 0 0-.5-.55zm4.5 4a3.85 3.85 0 0 1-3.92-3h7.83c-.4 1.7-1.83 3-3.91 3m0-12a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $f342bb1007016cbf$export$d433e77673763252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaugh24Filled', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m2.5 7.36a.75.75 0 1 1-1.5-.22 2.25 2.25 0 0 1 2.25-1.89c1.12 0 2.08.8 2.24 1.89a.75.75 0 1 1-1.48.22.75.75 0 0 0-.76-.61c-.4 0-.71.29-.76.61M12 18c-3.14 0-5.24-2.36-5.5-5.25h11C17.24 15.64 15.14 18 12 18M8.75 8.75c-.4 0-.71.29-.76.61a.75.75 0 1 1-1.48-.22 2.25 2.25 0 0 1 2.24-1.89c1.12 0 2.08.8 2.24 1.89a.75.75 0 1 1-1.48.22.75.75 0 0 0-.76-.61"
]);
const $f342bb1007016cbf$export$d4e0359a3a0fe7aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiLaugh24Regular', "24", [
    "M6.75 12a.75.75 0 0 0-.75.82c.28 3.07 2.55 5.68 6 5.68s5.72-2.6 6-5.68a.75.75 0 0 0-.75-.82zM12 17a4.4 4.4 0 0 1-4.37-3.5h8.74A4.4 4.4 0 0 1 12 17m3.25-8.25c-.4 0-.71.29-.76.61a.75.75 0 1 1-1.48-.22 2.25 2.25 0 0 1 2.24-1.89c1.12 0 2.08.8 2.24 1.89a.75.75 0 1 1-1.48.22.75.75 0 0 0-.76-.61m-7.26.61a.75.75 0 0 1 .76-.61c.4 0 .71.29.76.61a.75.75 0 1 0 1.48-.22 2.25 2.25 0 0 0-2.24-1.89c-1.12 0-2.08.8-2.24 1.89a.75.75 0 0 0 1.48.22M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
]);
const $f342bb1007016cbf$export$6b90965e349f4180 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeh16Filled', "16", [
    "M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8m5-1a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 7m3.5 0A.75.75 0 1 1 9 7a.75.75 0 0 1 1.5 0M6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1"
]);
const $f342bb1007016cbf$export$4c880b50893eb43c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeh16Regular', "16", [
    "M7 7a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 7m2.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2-7a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 1a5 5 0 1 0 0 10A5 5 0 0 0 8 3"
]);
const $f342bb1007016cbf$export$b16fd95aabd603ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeh20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m6.5-1.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-6.5 3c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5"
]);
const $f342bb1007016cbf$export$d02835ea37be4cbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeh20Regular', "20", [
    "M7.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 3.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
]);
const $f342bb1007016cbf$export$7ac511d5fdb7f4ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeh24Filled', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-1.75 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m6 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M7.5 15.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$866826fb6d181dc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeh24Regular', "24", [
    "M9 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M8.25 15a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0m10-8.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
]);
const $f342bb1007016cbf$export$6d49ae159893109c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeme16Filled', "16", [
    "M8 14a6 6 0 0 1-5.92-5H3v1h5V9h1v1h4.66A6 6 0 0 1 8 14M8 2c-1.78 0-3.37.77-4.47 2h8.94C11.37 2.77 9.77 2 8 2m-1.88 8.66a.5.5 0 1 0-.74.68 3.54 3.54 0 0 0 5.24 0 .5.5 0 1 0-.74-.68 2.54 2.54 0 0 1-3.76 0M15 5H2v1H1v1H0v2h1V7h2v1h1v1h3V8h1V7h1v1h1v1h3V8h1V7h1zM4 6h1v1H4zm1 2V7h1v1zm6-2v1h1v1h-1V7h-1V6z"
]);
const $f342bb1007016cbf$export$772adfcf2890b2c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeme16Regular', "16", [
    "M5.77 10a.5.5 0 0 1 .37.17 2.5 2.5 0 0 0 3.72 0 .5.5 0 0 1 .7-.04c.22.18.23.5.05.7a3.5 3.5 0 0 1-5.22 0 .5.5 0 0 1 .37-.83M11 4a5 5 0 0 0-6 0H3.53a6 6 0 0 1 8.94 0zm1.58 6A5 5 0 0 1 3.1 9H2.08a6 6 0 0 0 11.58 1zM0 7h1v2H0zm2-2h13v2h-1v1h-1v1h-3V8H9V7H8v1H7v1H4V8H3V7H1V6h1zm3 1H4v1h1v1h1V7H5zm5 0v1h1V6zm1 1v1h1V7z"
]);
const $f342bb1007016cbf$export$ce009d46ae1e8218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeme20Filled', "20", [
    "M10 2a8 8 0 0 1 6.25 3H3.75A8 8 0 0 1 10 2m7 9h.94A8 8 0 0 1 2 10h1v1h1v1h6v-1h1v1h6zM6.19 13.44a.5.5 0 0 0-.08.7 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0 .5.5 0 0 0-.7-.07M18 6H3v1H2v1H1v1H0v2h1V9h1V8h2v2h1v1h4v-1h1V8h1v2h1v1h4v-1h1V8h1zM6 8v1h1v1H6V9H5V8zm7 0v1h1v1h-1V9h-1V8z"
]);
const $f342bb1007016cbf$export$37ef4cea37008c0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeme20Regular', "20", [
    "M16.25 5a8 8 0 0 0-12.5 0H5.1a7 7 0 0 1 9.8 0zm1.69 6h-1.01A7 7 0 0 1 3 10H2a8 8 0 0 0 15.94 1M3 6h15v2h-1v2h-1v1h-4v-1h-1V8h-1v2H9v1H5v-1H4V8H2V7h1zM1 9V8h1v1zm0 0v2H0V9zm4-1v1h1V8zm1 1v1h1V9zm6-1v1h1V8zm1 1v1h1V9zm-6.11 3.51a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $f342bb1007016cbf$export$d7a20236fe870c89 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeme24Filled', "24", [
    "M12 22a10 10 0 0 1-9.95-11H4v2h1v1h7v-1h2v1h7v-1h.95A10 10 0 0 1 12 22m8-16H4a10 10 0 0 1 16 0M7.41 15.66a.75.75 0 0 0-.12 1.05 6 6 0 0 0 9.42 0 .75.75 0 1 0-1.17-.92 4.5 4.5 0 0 1-7.08 0 .75.75 0 0 0-1.05-.13M3 7h19v3h-1v2h-1v1h-5v-1h-1v-2h-2v2h-1v1H6v-1H5v-2H4V9H2V8h1zm-2 3V9h1v1zm0 0H0v2h1zm6-1H6v1h1v1h1v-1H7zm9 0h-1v1h1v1h1v-1h-1z"
]);
const $f342bb1007016cbf$export$7b9ba71dcaa6ee64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMeme24Regular', "24", [
    "M20 6h-1.98A8.5 8.5 0 0 0 5.98 6H4a10 10 0 0 1 16 0M3.5 12q0-.5.06-1H2.05Q2 11.5 2 12a10 10 0 0 0 19.95 1H21v1h-.73A8.5 8.5 0 0 1 3.5 12m8.5 4.5a4.5 4.5 0 0 1-3.54-1.72.75.75 0 1 0-1.17.93 6 6 0 0 0 9.42 0 .75.75 0 1 0-1.17-.92A4.5 4.5 0 0 1 12 16.5M3 7h19v3h-1v2h-1v1h-5v-1h-1v-2h-2v2h-1v1H6v-1H5v-2H4V9H2V8h1zm-2 3V9h1v1zm0 0H0v2h1zm6-1H6v1h1v1h1v-1H7zm9 0h-1v1h1v1h1v-1h-1z"
]);
const $f342bb1007016cbf$export$eab6e3381c639af9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMultiple20Filled', "20", [
    "M2 7a5 5 0 0 0 4.03 4.9 6.5 6.5 0 0 1 1.66-3.78 2 2 0 0 0-2.21.58.5.5 0 1 1-.76-.65 3 3 0 0 1 3.76-.66 6.5 6.5 0 0 1 3.43-1.36A5 5 0 0 0 2 7m4.25-1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8.75 7a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6.75-1a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m3.86 2.57a.5.5 0 0 0-.71.05 2.5 2.5 0 0 1-3.8 0 .5.5 0 1 0-.76.66 3.5 3.5 0 0 0 5.32 0 .5.5 0 0 0-.05-.71m-.61-1.82a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
]);
const $f342bb1007016cbf$export$37d3fd4439f14630 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMultiple20Regular', "20", [
    "M7 2a5 5 0 0 1 4.9 4.03q-.5.04-.98.16a4 4 0 1 0-4.73 4.73q-.12.48-.16.99A5 5 0 0 1 7 2m.7 6.12q.36-.39.78-.73a3 3 0 0 0-3.76.66.5.5 0 1 0 .76.65 2 2 0 0 1 2.21-.58M6.24 5.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m1.25 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m4.6 1.82c.21.18.24.5.06.7a3.5 3.5 0 0 1-5.32.01.5.5 0 1 1 .76-.65 2.5 2.5 0 0 0 3.8 0 .5.5 0 0 1 .7-.06m-.6-1.82a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-2 5.75a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-1a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
]);
const $f342bb1007016cbf$export$8a3df05586508b8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMultiple24Filled', "24", [
    "M2 8.5a6.5 6.5 0 0 0 4.94 6.31 8 8 0 0 1 1.72-4.8 2 2 0 0 0-1.68.69.75.75 0 0 1-1.14-.97 3.5 3.5 0 0 1 4.02-.95 8 8 0 0 1 4.95-1.84A6.5 6.5 0 0 0 2 8.5m5.5-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M22 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-8.5-1.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4.47 3.22a.63.63 0 0 0-.88.07 2.75 2.75 0 0 1-4.18 0 .62.62 0 1 0-.95.82 4 4 0 0 0 6.08-.01.6.6 0 0 0-.07-.88m-.47-2.22a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $f342bb1007016cbf$export$70b2dca666e0f9da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiMultiple24Regular', "24", [
    "M8.5 2a6.5 6.5 0 0 1 6.31 4.94q-.77.02-1.5.17a5 5 0 1 0-6.2 6.2q-.15.73-.17 1.5A6.5 6.5 0 0 1 8.5 2m.16 8q.54-.68 1.2-1.22a3.5 3.5 0 0 0-4.02.95.75.75 0 1 0 1.14.97 2 2 0 0 1 1.68-.7M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5.46 2.04c.31.27.35.74.08 1.06a4 4 0 0 1-6.08 0 .75.75 0 0 1 1.14-.97 2.5 2.5 0 0 0 3.8 0 .75.75 0 0 1 1.06-.09m-.46-2.04a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-1.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11"
]);
const $f342bb1007016cbf$export$eb7e0bc715174343 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSad16Filled', "16", [
    "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M6.25 7.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.5 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.12 3.32a.5.5 0 1 0 .76-.64 3.53 3.53 0 0 0-5.26 0 .5.5 0 1 0 .76.64 2.53 2.53 0 0 1 3.74 0"
]);
const $f342bb1007016cbf$export$7d87a21710b52024 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSad16Regular', "16", [
    "M14 8A6 6 0 1 0 2 8a6 6 0 0 0 12 0M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8m4-1.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-4.37 4.07a2.53 2.53 0 0 1 3.74 0 .5.5 0 1 0 .76-.64 3.53 3.53 0 0 0-5.26 0 .5.5 0 1 0 .76.64"
]);
const $f342bb1007016cbf$export$25e45c48b0e2f9cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSad20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.5-.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0m.06 4.89c.38-.35.07-.72.06-.73l-.23-.23a4 4 0 0 0-.67-.49 5.3 5.3 0 0 0-2.72-.69 5.3 5.3 0 0 0-2.72.7 4 4 0 0 0-.9.7l-.01.03h-.01l.39.32-.39-.31a.5.5 0 0 0 .78.63l.02-.03q.04-.05.12-.11.15-.16.5-.37a4.3 4.3 0 0 1 2.22-.56 4.3 4.3 0 0 1 2.22.56 3 3 0 0 1 .64.5.5.5 0 0 0 .7.08"
]);
const $f342bb1007016cbf$export$6fd3943e48ab9e3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSad20Regular', "20", [
    "M7.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.06 4.89a.5.5 0 0 1-.7-.07l-.02-.03-.12-.12q-.15-.16-.5-.36a4.3 4.3 0 0 0-2.22-.56c-1.02 0-1.75.28-2.21.56a3 3 0 0 0-.65.5.5.5 0 0 1-.78-.62l.39.31-.39-.31v-.01l.02-.02.23-.23q.22-.2.67-.49c.6-.35 1.5-.69 2.72-.69a5.3 5.3 0 0 1 2.72.7 4 4 0 0 1 .9.71l.01.02h.01l-.39.32.39-.31a.5.5 0 0 1-.08.7M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $f342bb1007016cbf$export$d6f75c95349cdeb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSad24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 11.5c-1.63 0-3.17.65-4.29 1.8a.75.75 0 1 0 1.07 1.05 4.5 4.5 0 0 1 6.43 0 .75.75 0 1 0 1.07-1.06A6 6 0 0 0 12 13.5M9 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m6 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $f342bb1007016cbf$export$81d8b0739bdbf8d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSad24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 10c1.63 0 3.16.65 4.28 1.8a.75.75 0 1 1-1.07 1.04 4.5 4.5 0 0 0-6.43 0 .75.75 0 1 1-1.07-1.04A6 6 0 0 1 12 13.5M9 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $f342bb1007016cbf$export$5d462972e6f11050 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadSlight20Filled', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m.3 4.5h.8a.5.5 0 0 1 0 1h-.8c-1.07 0-2.13.32-3.02.92a.5.5 0 1 1-.56-.84A6.5 6.5 0 0 1 12.8 12"
]);
const $f342bb1007016cbf$export$3fa8d001313688d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadSlight20Regular', "20", [
    "M8.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m.3 2.5c-1.27 0-2.52.38-3.58 1.08a.5.5 0 0 0 .56.84c.9-.6 1.95-.92 3.02-.92h.8a.5.5 0 0 0 0-1zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
]);
const $f342bb1007016cbf$export$e804ccef3d6cf56f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadSlight24Filled', "24", [
    "M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0M7.75 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m6 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m2 4h.6a.75.75 0 0 1 0 1.5h-.6a5.8 5.8 0 0 0-3.47 1.28.75.75 0 1 1-1.06-1.06A7.24 7.24 0 0 1 15.75 14"
]);
const $f342bb1007016cbf$export$14f5bdf7194bc92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSadSlight24Regular', "24", [
    "M10.25 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m6 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-.5 4a7.2 7.2 0 0 0-4.53 1.72.75.75 0 1 0 1.06 1.06c.27-.28.8-.6 1.47-.86a6 6 0 0 1 2-.42h.6a.75.75 0 0 0 0-1.5zM22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
]);
const $f342bb1007016cbf$export$661afee9115f9842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSmileSlight20Filled', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4.03 5.55c.42.21.97.32 1.53.32a3.5 3.5 0 0 0 1.53-.32.5.5 0 1 1 .44.9c-.58.29-1.28.43-1.97.43s-1.39-.14-1.97-.43a.5.5 0 1 1 .44-.9"
]);
const $f342bb1007016cbf$export$f91eedb0cadb3d61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSmileSlight20Regular', "20", [
    "M13.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-.03 4.55a.5.5 0 1 0-.44.9c.58.29 1.28.43 1.97.43s1.39-.14 1.97-.43a.5.5 0 1 0-.44-.9c-.42.21-.97.32-1.53.32a3.5 3.5 0 0 1-1.53-.32M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $f342bb1007016cbf$export$a558ee40f4c7d94a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSmileSlight24Filled', "24", [
    "M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0M7.75 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m6 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-3.61 5.1c.48.3 1.15.46 1.86.46.7 0 1.38-.16 1.86-.45a.75.75 0 1 1 .78 1.28 5 5 0 0 1-2.64.67 5 5 0 0 1-2.64-.67.75.75 0 1 1 .78-1.28"
]);
const $f342bb1007016cbf$export$15f89f9d8de772dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSmileSlight24Regular', "24", [
    "M10.25 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m6 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-6.11 5.1a.75.75 0 0 0-.78 1.3 5 5 0 0 0 2.64.66c.92 0 1.87-.2 2.64-.67a.75.75 0 1 0-.78-1.28c-.48.29-1.15.45-1.86.45-.7 0-1.38-.16-1.86-.45M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
]);
const $f342bb1007016cbf$export$5a25f42a9dcd5d27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle16Filled', "16", [
    "M13.8 2.22h-.02l-.76-.26a1.6 1.6 0 0 1-1-1L11.77.2a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.6.19-.17.05a.3.3 0 0 0-.15.11.3.3 0 0 0 .15.46l.77.25.08.03a1.6 1.6 0 0 1 .92.97l.24.77a.3.3 0 0 0 .29.2.3.3 0 0 0 .29-.2l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57m1.41 3.35.62.2a.24.24 0 0 1 0 .46l-.6.2a1.3 1.3 0 0 0-.8.8l-.2.6a.24.24 0 0 1-.24.17l-.13-.04a.2.2 0 0 1-.1-.12l-.2-.61a1.3 1.3 0 0 0-.8-.8l-.6-.2a.2.2 0 0 1-.12-.1.25.25 0 0 1 .12-.36l.61-.2a1.3 1.3 0 0 0 .8-.8l.19-.6a.24.24 0 0 1 .46 0l.2.6a1.3 1.3 0 0 0 .8.8M8 14a6 6 0 0 0 5.92-5 1.2 1.2 0 0 1-1.1-.85l-.2-.61-.06-.1-.1-.06-.63-.2A1.2 1.2 0 0 1 11 6v-.1a1.3 1.3 0 0 1-.74-.8l-.24-.75a1 1 0 0 0-.14-.23 1 1 0 0 0-.22-.14l-.8-.25A1.3 1.3 0 0 1 8.1 2H8a6 6 0 1 0 0 12M6.25 7.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-.11 1.92a2.5 2.5 0 0 0 3.72 0 .5.5 0 1 1 .75.66 3.5 3.5 0 0 1-5.22 0 .5.5 0 0 1 .75-.66m3.61-1.92a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M11.5 5"
]);
const $f342bb1007016cbf$export$ae9ae1e991e65f63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle16Regular', "16", [
    "M13.8 2.22h-.02l-.76-.26a1.6 1.6 0 0 1-1-1L11.77.2a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.6.19-.17.05a.3.3 0 0 0-.15.11.3.3 0 0 0 .15.46l.77.25.08.03a1.6 1.6 0 0 1 .89.9l.03.07.24.77a.3.3 0 0 0 .29.2.3.3 0 0 0 .29-.2l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57m1.41 3.35.62.2a.24.24 0 0 1 0 .46l-.6.2a1.3 1.3 0 0 0-.8.8l-.2.6a.24.24 0 0 1-.24.17l-.13-.04a.2.2 0 0 1-.1-.12l-.2-.61a1.3 1.3 0 0 0-.8-.8l-.02-.01-.58-.2a.24.24 0 0 1 0-.45l.61-.2a1.3 1.3 0 0 0 .8-.8l.19-.6a.24.24 0 0 1 .46 0l.2.6a1.3 1.3 0 0 0 .8.8M8.06 2.9 8.1 3H8a5 5 0 1 0 4.98 5.46 1.3 1.3 0 0 0 .94.54A6 6 0 1 1 8.1 2a1.3 1.3 0 0 0-.04.9M6.25 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-.11 1.92a.5.5 0 1 0-.75.66 3.5 3.5 0 0 0 5.22 0 .5.5 0 0 0-.75-.66 2.5 2.5 0 0 1-3.72 0M10.5 7A.75.75 0 1 1 9 7a.75.75 0 0 1 1.5 0"
]);
const $f342bb1007016cbf$export$17a43e4373f5abf0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle20Filled', "20", [
    "M15.23 1.35 14.88.28a.42.42 0 0 0-.8 0l-.35 1.07a2.2 2.2 0 0 1-1.38 1.4l-1.07.35a.4.4 0 0 0-.28.4.4.4 0 0 0 .28.4l.43.13.64.21a2.2 2.2 0 0 1 1.4 1.4l.35 1.08a.42.42 0 0 0 .8 0l.1-.32.23-.7V5.7l.02-.04a2 2 0 0 1 .7-1l-.01-.01q.31-.25.7-.39l1.08-.35a.42.42 0 0 0 0-.8h-.02l-1.08-.35a2.2 2.2 0 0 1-1.4-1.4m3.79 6.61.76.25h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.5 1.5 0 0 0-.38-.62 2 2 0 0 0-.62-.38l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .05-.18.3.3 0 0 1 .15-.1l.77-.26a2 2 0 0 0 .6-.38q.27-.26.38-.61l.25-.77a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1m-1.27 4.02a8 8 0 1 1-6.58-9.9l-.2.07a1.43 1.43 0 0 0-.9 1.78 1.4 1.4 0 0 0 .88.9l1.1.37a1.2 1.2 0 0 1 .76.76l.34 1.07q.14.4.46.66l.03.02.04.03q.21.15.44.2a1.3 1.3 0 0 0 .75 1.79l.8.25a.6.6 0 0 1 .35.37l.25.76a1.3 1.3 0 0 0 1.48.87M12.5 7.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.61 5.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $f342bb1007016cbf$export$6da412d9d375852 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle20Regular', "20", [
    "M15.23 1.35 14.88.28a.42.42 0 0 0-.8 0l-.35 1.07a2.2 2.2 0 0 1-1.38 1.4l-1.07.35a.42.42 0 0 0 0 .8l1.07.34a2.2 2.2 0 0 1 1.4 1.4l.35 1.08a.42.42 0 0 0 .8 0l.35-1.07a2.2 2.2 0 0 1 1.4-1.4l1.07-.35a.42.42 0 0 0 0-.8h-.02l-1.08-.35a2.2 2.2 0 0 1-1.4-1.4m3.79 6.61.76.25h.02a.3.3 0 0 1 0 .58l-.77.25a1.6 1.6 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.6 1.6 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.6 1.6 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.6 1.6 0 0 0 1 1m-2.25 3.82a1.3 1.3 0 0 0 .98.2 8 8 0 1 1-6.58-9.9l-.2.07a1.4 1.4 0 0 0-.88.85H10a7 7 0 1 0 6.77 8.78M12.5 7.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-5 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-.61 5.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0"
]);
const $f342bb1007016cbf$export$cab6948add4b6046 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle24Filled', "24", [
    "M14.74 5.46a2.8 2.8 0 0 1 1.8 1.8l.45 1.38a.54.54 0 0 0 1.01.03l.01-.02.05-.15.4-1.24a2.8 2.8 0 0 1 1.3-1.57q.23-.14.5-.23l1.38-.44a.54.54 0 0 0 0-1.03h-.03l-1.38-.45a2.8 2.8 0 0 1-1.8-1.8L18 .36a.54.54 0 0 0-1.03 0l-.45 1.38-.01.03a2.8 2.8 0 0 1-1.76 1.76l-1.38.45a.54.54 0 0 0 0 1.03zm9.04 4.75-.76-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.98 1l-.1.03-.67.21a.3.3 0 0 0-.2.29.3.3 0 0 0 .2.28l.76.25a1.6 1.6 0 0 1 1 1l.25.77a.3.3 0 0 0 .12.14.3.3 0 0 0 .46-.14l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zM12 22.01a10 10 0 0 0 9.8-8.04 1.3 1.3 0 0 1-1.54-.86l-.25-.76a.57.57 0 0 0-.36-.36l-.78-.26a1.3 1.3 0 0 1-.7-1.88 1.55 1.55 0 0 1-2.14-.9l-.44-1.38a1.8 1.8 0 0 0-1.16-1.16l-1.4-.46a1.54 1.54 0 0 1 .02-2.92l1.36-.44q.21-.07.4-.2A10 10 0 1 0 12 22m-4.6-7.35c.33-.26.8-.2 1.06.12a4.5 4.5 0 0 0 7.07 0 .75.75 0 1 1 1.18.94 6 6 0 0 1-9.43 0 .75.75 0 0 1 .13-1.06M7.76 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m6 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
]);
const $f342bb1007016cbf$export$b556e98d2b2c502f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle24Regular', "24", [
    "M16.09 6.41a3 3 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l.71-.23.67-.22a2.8 2.8 0 0 0 1.76-1.76l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44q-.27.1-.5.23a3 3 0 0 0-1.07 1.06q-.14.24-.23.51l-.45 1.38-.01.03a.54.54 0 0 1-1.01-.03l-.45-1.38q-.15-.46-.45-.85m7.7 3.8-.77-.25a1.6 1.6 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.6 1.6 0 0 1-.72.88l-.26.11-.77.25a.3.3 0 0 0 0 .57l.77.25a1.6 1.6 0 0 1 1 1l.24.77a.3.3 0 0 0 .12.14.3.3 0 0 0 .46-.14l.24-.77a1.6 1.6 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57zm-3.04 3.55q-.23-.15-.36-.38a8.5 8.5 0 1 1-8.03-9.87q.28-.34.7-.48l1.35-.44q.21-.07.4-.2a10 10 0 1 0 7 11.58 1.3 1.3 0 0 1-1.06-.2M12 16.5a4.5 4.5 0 0 1-3.54-1.72.75.75 0 0 0-1.18.93 6 6 0 0 0 9.43 0 .75.75 0 0 0-1.18-.92A4.5 4.5 0 0 1 12 16.5M10.25 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m6 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
]);
const $f342bb1007016cbf$export$b1d0e77a9050cae0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle28Filled', "28", [
    "M17.32 6.22a3.2 3.2 0 0 1 1.6 1.85l.5 1.53a.6.6 0 0 0 .48.4.6.6 0 0 0 .63-.3l.04-.1.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04q-.16.47-.46.87a3 3 0 0 1-1.5 1.08l-1.53.5a.6.6 0 0 0-.1 1.1l.1.05 1.53.5q.2.06.4.15m4.72 4.62a.4.4 0 0 1 .2-.18l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a2 2 0 0 0-.95.71q-.16.23-.25.5l-.3.91a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.2-.5M14 26a12 12 0 0 0 11.99-11.42l-.04.04a1.36 1.36 0 0 1-2.24-.55l-.3-.92a.9.9 0 0 0-.56-.56l-.94-.3a1.36 1.36 0 0 1-.84-1.7l-.14.1a1.6 1.6 0 0 1-2.44-.8l-.5-1.52a2 2 0 0 0-.52-.84 2 2 0 0 0-.84-.52l-1.55-.5a1.6 1.6 0 0 1 .02-3.03l1.51-.5q.45-.16.8-.49A12 12 0 1 0 14 26m3.5-13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M12 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-3.67 5.63a.75.75 0 0 1 1.04.2l.25.3A5.92 5.92 0 0 0 14 19.5a6 6 0 0 0 4.62-2.16l.01-.01a.75.75 0 0 1 1.24.84l-.01.02-.01.01-.01.02a4 4 0 0 1-.36.43A7.42 7.42 0 0 1 14 21a7.4 7.4 0 0 1-5.86-2.81v-.01h-.01a.75.75 0 0 1 .2-1.05"
]);
const $f342bb1007016cbf$export$32735aedbaaf1434 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle28Regular', "28", [
    "M18.17 6.83a3 3 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.2 3.2 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.53-.5a3.2 3.2 0 0 1-2-2L20.54.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04q-.16.47-.46.87a3 3 0 0 1-1.49 1.08h.02-.03l-1.53.5a.6.6 0 0 0 0 1.15l1.53.5q.72.23 1.24.76m8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.2-.58-.1-.34a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3q.3-.1.57-.32l.07-.06a2 2 0 0 0 .54-.82l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2m-2.03 4.63a1 1 0 0 1-.33-.1 10.5 10.5 0 1 1-9.53-11.35q.08-.04.17-.06l1.51-.5q.45-.16.8-.49A12 12 0 1 0 26 14.6l-.04.03a1.4 1.4 0 0 1-1.16.37M10.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m8.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.33 17.13a.75.75 0 0 1 1.04.2l.25.3A5.92 5.92 0 0 0 14 19.5a6 6 0 0 0 4.62-2.16l.01-.01a.75.75 0 0 1 1.24.84l-.01.02-.02.03a4 4 0 0 1-.36.43A7.42 7.42 0 0 1 14 21a7.4 7.4 0 0 1-5.86-2.81v-.01h-.01a.75.75 0 0 1 .2-1.05"
]);
const $f342bb1007016cbf$export$8d65c5d2bc3819de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle32Filled', "32", [
    "M18 5.56a.7.7 0 0 0 .44.57l1.69.55a3.5 3.5 0 0 1 2.2 2.2l.54 1.68a.66.66 0 0 0 1.24.05v-.02l.02-.03.12-.36.42-1.33a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.7.7 0 0 0-.44.69m9.93 6.3q.29-.3.41-.7l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2l.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a2 2 0 0 0-.94.7q-.16.23-.26.5l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1-.23-.45l.05-.1q.07-.09.18-.13l.92-.3a2 2 0 0 0 .77-.5M16 30a14 14 0 1 1 4.16-27.37q-.24.16-.52.27l-1.66.54a2.2 2.2 0 0 0-1.45 1.72 2.16 2.16 0 0 0 1.42 2.37l1.71.56a2 2 0 0 1 1.24 1.25l.55 1.67a2.2 2.2 0 0 0 2.03 1.48q.68 0 1.23-.37a1.86 1.86 0 0 0 1.03 2.63l.95.3.15.1q.06.07.1.15l.3.91a1.9 1.9 0 0 0 1.48 1.26 2 2 0 0 0 1.23-.23A14 14 0 0 1 16 30m-4-15a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0M9.55 19.1a1 1 0 0 0-.44 1.35v.02l.1.18.3.42c.25.34.63.78 1.18 1.21A8.3 8.3 0 0 0 16 24c2.5 0 4.21-.84 5.31-1.72a7 7 0 0 0 1.55-1.76l.01-.03.01-.02v-.01h.01v-.01a1 1 0 0 0-1.78-.9l-.04.06-.17.26c-.17.22-.44.53-.84.85A6.3 6.3 0 0 1 16 22c-2 0-3.29-.66-4.06-1.28a5 5 0 0 1-1.05-1.17 1 1 0 0 0-1.34-.44"
]);
const $f342bb1007016cbf$export$a9ce271d4c6e95da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle32Regular', "32", [
    "M21.49 7.51a3.5 3.5 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.5 3.5 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.5 3.5 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.5 3.5 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55q.78.26 1.36.84m9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a2 2 0 0 0-.94.7q-.16.23-.26.5l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a2 2 0 0 0-.52-.8 2 2 0 0 0-.68-.4l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.11-.35.19-.57a.36.36 0 0 1 .68 0l.3.92a1.9 1.9 0 0 0 1.2 1.2M17.05 4.05Q16.53 4 16 4a12 12 0 1 0 11.94 13.17 1.9 1.9 0 0 0 2 .07 14 14 0 1 1-9.78-14.61q-.24.16-.52.27l-1.66.54q-.55.19-.93.6M14 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4M9.55 19.1a1 1 0 0 1 1.34.45l.04.06.17.26c.17.22.44.53.84.85A6.3 6.3 0 0 0 16 22c2 0 3.29-.66 4.06-1.28a5 5 0 0 0 1.05-1.17 1 1 0 0 1 1.78.9v.02l-.02.02-.01.03a4 4 0 0 1-.36.55c-.26.34-.64.78-1.19 1.21A8.3 8.3 0 0 1 16 24c-2.5 0-4.21-.84-5.31-1.72a7 7 0 0 1-1.57-1.8v-.02H9.1v-.01a1 1 0 0 1 .44-1.34"
]);
const $f342bb1007016cbf$export$62c58eb8fead93c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle48Filled', "48", [
    "M32.83 12.11a5.4 5.4 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.4 5.4 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.4 5.4 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.4 5.4 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5 5 0 0 0-.85-1.6m6.27 7.07a1 1 0 0 0-.09.2.54.54 0 0 0 .35.64l1.38.45a2.8 2.8 0 0 1 1.8 1.8l.45 1.38a.54.54 0 0 0 1 .04v-.01l.02-.04.45-1.38a2.8 2.8 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03l-1.38-.45a2.8 2.8 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.8 2.8 0 0 1-1.77 1.8l-1.38.44q-.16.06-.26.2M24 44a20 20 0 1 1 5.61-39.2l-2.54.82a3.04 3.04 0 0 0-1.93 3.79 3 3 0 0 0 1.88 1.93l2.65.87a3.4 3.4 0 0 1 2.11 2.12l.85 2.6a3.05 3.05 0 0 0 2.85 2.06q.95 0 1.73-.53a2.54 2.54 0 0 0 1.49 3.44l1.42.46a.8.8 0 0 1 .52.53l.45 1.37a2.6 2.6 0 0 0 2.02 1.71q.4.06.8 0A20 20 0 0 1 24 44m-6.5-22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M33 19.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M18.45 34.68c1.71.9 3.62 1.34 5.55 1.32a11.7 11.7 0 0 0 9.82-5.1 1.25 1.25 0 1 0-2.13-1.3A9.2 9.2 0 0 1 24 33.5a9.2 9.2 0 0 1-7.69-3.9 1.25 1.25 0 1 0-2.13 1.3c1.1 1.6 2.56 2.9 4.27 3.78"
]);
const $f342bb1007016cbf$export$f3ba00fad073f2c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSparkle48Regular', "48", [
    "M32.4 11.6a5.4 5.4 0 0 1 1.28 2.11l.85 2.6a1.03 1.03 0 0 0 1.94 0l.85-2.6a5.4 5.4 0 0 1 3.4-3.39l2.6-.84a1.03 1.03 0 0 0 0-1.94l-.06-.02-2.6-.84a5.4 5.4 0 0 1-3.4-3.4l-.84-2.6a1.03 1.03 0 0 0-1.94 0l-.85 2.6-.02.07a5.4 5.4 0 0 1-3.32 3.33l-2.6.84a1.03 1.03 0 0 0 0 1.94l2.6.85q1.2.4 2.1 1.3m13.83 6.94 1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.8 2.8 0 0 0-1.8 1.8l-.45 1.38-.01.04a.54.54 0 0 1-1.01-.03l-.45-1.38a2.8 2.8 0 0 0-1.36-1.61v-.02l-.44-.18-1.38-.45a.54.54 0 0 1 0-1.03l1.38-.44a2.8 2.8 0 0 0 1.77-1.8l.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.8 2.8 0 0 0 1.8 1.8M25.68 6.58Q24.85 6.5 24 6.5A17.5 17.5 0 1 0 41.47 25a2.6 2.6 0 0 0 1.64.97q.4.06.8 0A20 20 0 1 1 29.6 4.8l-2.54.82q-.84.3-1.39.96M20 19.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M30.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M18.45 34.68c1.71.9 3.62 1.34 5.55 1.32a11.7 11.7 0 0 0 9.82-5.1 1.25 1.25 0 1 0-2.13-1.3A9.2 9.2 0 0 1 24 33.5a9.2 9.2 0 0 1-7.69-3.9 1.25 1.25 0 1 0-2.13 1.3c1.1 1.6 2.56 2.9 4.27 3.78"
]);
const $f342bb1007016cbf$export$f101e71a94f903ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSurprise20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.5-.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.25 3a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m.75-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $f342bb1007016cbf$export$c7ab7528994bcf26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSurprise20Regular', "20", [
    "M7.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.25 3a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m.75-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
]);
const $f342bb1007016cbf$export$ffc2b83f41a2640c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSurprise24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 11a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M9 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m6 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
]);
const $f342bb1007016cbf$export$18806d81e1914446 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EmojiSurprise24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 9.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5M9 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
]);
const $f342bb1007016cbf$export$c1eabc166390dd5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe12Filled', "12", [
    "M7.99 6.5H4.01a8 8 0 0 0 .76 3.3c.5.97.99 1.2 1.23 1.2.25 0 .74-.23 1.23-1.2.4-.82.7-1.97.76-3.3m-3.98-1a8 8 0 0 1 .76-3.3C5.27 1.23 5.76 1 6 1c.25 0 .74.23 1.23 1.2.4.82.7 1.97.76 3.3zm-1 0H1.03a5 5 0 0 1 3.06-4.12c-.6 1-1.01 2.46-1.08 4.12m0 1H1.03a5 5 0 0 0 3.06 4.12c-.6-1-1.01-2.46-1.08-4.12M9 6.5h1.99a5 5 0 0 1-3.07 4.12c.6-1 1.01-2.46 1.08-4.12m1.99-1H8.99a9 9 0 0 0-1.08-4.12 5 5 0 0 1 3.07 4.12"
]);
const $f342bb1007016cbf$export$41e5cc9a7057234e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe12Regular', "12", [
    "M11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0m-6.99.5c.05 1.3.3 2.47.68 3.28A4 4 0 0 1 2.03 6.5zm1 0H7a8 8 0 0 1-.5 2.66 3 3 0 0 1-.49.81l-.05-.05a3 3 0 0 1-.44-.76 8 8 0 0 1-.5-2.66M7 5.5H5c.05-1.08.24-2 .5-2.66A3 3 0 0 1 6 2.03l.05.05q.2.19.44.76c.26.66.45 1.59.5 2.66m1 1h1.98A4 4 0 0 1 7.3 9.78c.37-.81.63-1.97.68-3.28m1.98-1H7.99a9 9 0 0 0-.68-3.28A4 4 0 0 1 9.97 5.5M4 5.5H2.03A4 4 0 0 1 4.7 2.22a9 9 0 0 0-.68 3.28"
]);
const $f342bb1007016cbf$export$924afb8e0ca003c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe16Filled', "16", [
    "M6 8q0-1.06.12-2h3.76a16 16 0 0 1 0 4H6.12Q6 9.06 6 8m-.88 2a17 17 0 0 1 0-4H2.34a6 6 0 0 0 0 4zM2.8 11h2.47q.2.99.5 1.78.2.53.45.95A6 6 0 0 1 2.8 11m3.5 0h3.4q-.15.8-.4 1.42-.32.83-.7 1.23c-.24.27-.44.35-.6.35s-.36-.08-.6-.35a4 4 0 0 1-.7-1.23q-.25-.63-.4-1.42m4.43 0q-.2.99-.5 1.78-.2.53-.45.95A6 6 0 0 0 13.2 11zm2.93-1a6 6 0 0 0 0-4h-2.78a17 17 0 0 1 0 4zM9.3 3.58q.25.63.4 1.42H6.3q.15-.8.4-1.42.32-.83.7-1.23c.24-.27.44-.35.6-.35s.36.08.6.35q.38.4.7 1.23M10.73 5h2.47a6 6 0 0 0-3.42-2.73q.26.42.45.95.3.8.5 1.78M2.8 5h2.47q.2-.99.5-1.78.2-.52.45-.95A6 6 0 0 0 2.8 5"
]);
const $f342bb1007016cbf$export$90b96ce655d8b468 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe16Regular', "16", [
    "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12M8 3c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5M5.16 6a12 12 0 0 0 0 4H3.42a5 5 0 0 1 0-4zm.22 5a8 8 0 0 0 .66 1.6A5 5 0 0 1 4 11zm1.05 0h3.14a6 6 0 0 1-.26.68C8.88 12.64 8.37 13 8 13s-.88-.36-1.31-1.32a6 6 0 0 1-.26-.68m3.4-1H6.17a11 11 0 0 1 0-4h3.64a11 11 0 0 1 0 4m.79 1H12a5 5 0 0 1-2.04 1.6q.15-.24.26-.5.23-.5.4-1.1m1.96-1h-1.74a12 12 0 0 0 0-4h1.74a5 5 0 0 1 0 4M9.96 3.4c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6"
]);
const $f342bb1007016cbf$export$591402c184866765 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_20_color__a)",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_20_color__b)",
            "fillRule": "evenodd",
            "d": "M7.85 2.3q-.46.64-.81 1.5c-.37.9-.65 2-.83 3.2H2.58q-.2.49-.33 1H6.1a22 22 0 0 0 0 4H2.25q.13.51.33 1h3.63c.18 1.2.46 2.3.83 3.2q.35.86.81 1.5a8 8 0 0 0 4.3 0q.46-.64.81-1.5c.37-.9.65-2 .83-3.2h3.63q.2-.49.33-1H13.9a22 22 0 0 0 0-4h3.84q-.13-.51-.33-1h-3.63c-.18-1.2-.46-2.3-.83-3.2a7 7 0 0 0-.81-1.5 8 8 0 0 0-4.3 0M7.22 7q.26-1.64.74-2.82.46-1.1 1-1.66Q9.5 1.98 10 2q.5-.02 1.03.52.54.56 1 1.66.5 1.19.75 2.82zM10 18q.5.02 1.03-.52.54-.56 1-1.66.5-1.19.75-2.82H7.22q.26 1.63.74 2.82.46 1.1 1 1.66.54.54 1.04.52m-3-8q0 1.04.1 2h5.8a21 21 0 0 0 0-4H7.1q-.1.96-.1 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(225 10.4 3.9)scale(12.7313)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#25a2f0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_20_color__a",
                "x1": "5.56",
                "x2": "17.11",
                "y1": "4.67",
                "y2": "15.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$68d86b1021f9d1fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76a21 21 0 0 1 0 5h3.75a8 8 0 0 0 0-5m-.41 6h-3.5q-.27 1.52-.76 2.7-.36.88-.83 1.52a8 8 0 0 0 5.09-4.22M10 18q.46.02 1-.52.55-.56 1.01-1.66.42-1 .67-2.32H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52m-2.1-.28a8 8 0 0 1-5.1-4.22h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.75a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M7 10q0-1.31.16-2.5h5.68a19 19 0 0 1 0 5H7.16Q7 11.31 7 10"
]);
const $f342bb1007016cbf$export$57e07ef69d5cbbaf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe20Regular', "20", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm1.03 0h5.16a9 9 0 0 1-.56 1.6C11.41 16.4 10.66 17 10 17s-1.4-.59-2.02-1.9q-.33-.71-.56-1.6m5.37-1H7.21a15 15 0 0 1 0-5h5.58a15 15 0 0 1 0 5m.82 1h2.45a7 7 0 0 1-3.77 3.12q.36-.5.64-1.1.4-.9.68-2.02m2.93-1h-2.73a16 16 0 0 0 0-5h2.73a7 7 0 0 1 0 5m-4.25-9.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1"
]);
const $f342bb1007016cbf$export$544d55fc7e44c095 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_24_color__a)",
            "d": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_24_color__b)",
            "fillRule": "evenodd",
            "d": "M9.12 2.42a10 10 0 0 0-.85 1.7A19 19 0 0 0 7.22 8.5H2.63q-.28.72-.43 1.5h4.87a29 29 0 0 0 .09 5h-4.7q.25.78.6 1.5h4.3q.33 1.9.9 3.37.37.95.86 1.7a10 10 0 0 0 5.77 0q.48-.75.84-1.7.59-1.47.9-3.37h4.3q.36-.72.61-1.5h-4.7a28 28 0 0 0 .1-5h4.86a10 10 0 0 0-.43-1.5h-4.59a19 19 0 0 0-1.05-4.37 10 10 0 0 0-.85-1.7 10 10 0 0 0-5.76 0m-.4 6.08q.31-2.22.94-3.83.55-1.38 1.2-2.06c.42-.45.8-.61 1.14-.61s.72.16 1.14.6q.65.69 1.2 2.07.62 1.6.93 3.83zM12 22c.34 0 .72-.16 1.14-.6q.65-.69 1.2-2.07.48-1.23.77-2.83H8.9q.3 1.6.77 2.83.55 1.38 1.2 2.06c.42.45.8.61 1.14.61M8.5 12q0 1.58.17 3h6.66a27 27 0 0 0 .1-5H8.57q-.06.97-.07 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(224.66 12.65 4.74)scale(16.0089 16.0078)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#25a2f0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".97",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_24_color__a",
                "x1": "6.44",
                "x2": "20.89",
                "y1": "5.33",
                "y2": "18.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$c394642c66ed2209 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe24Filled', "24", [
    "M8.9 16.5h6.2c-.62 3.27-1.87 5.5-3.1 5.5-1.2 0-2.4-2.1-3.04-5.2zh6.2zm-5.83 0h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zm13.56 0h4.3a10 10 0 0 1-6.1 5.1 14 14 0 0 0 1.72-4.69zh4.3zm.3-6.5h4.87a10 10 0 0 1-.26 5h-4.7a28 28 0 0 0 .13-4.34zh4.87zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m6.38 0h6.84a26 26 0 0 1-.03 4.43l-.06.57H8.67a25 25 0 0 1-.13-4.51zh6.84zm6.36-7.42-.1-.17c3.01.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.96-4.5-1.84-5.92l-.1-.17zm-5.9-.14.12-.03a15 15 0 0 0-1.88 5.65l-.06.44h-4.6a10 10 0 0 1 6.42-6.06l.12-.03zM12 2c1.32 0 2.65 2.54 3.21 6.19l.05.31H8.74C9.28 4.7 10.64 2 12 2"
]);
const $f342bb1007016cbf$export$dd092596ed3afafd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m2.94 14.5H9.06c.65 2.41 1.79 4 2.94 4s2.29-1.59 2.94-4m-7.43 0H4.79a8.5 8.5 0 0 0 4.09 3.41q-.79-1.25-1.27-3.02zm11.7 0H16.5c-.32 1.33-.79 2.5-1.37 3.41a8.5 8.5 0 0 0 3.9-3.13zM7.1 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m8.3 0H8.6a19 19 0 0 0 .14 5h6.52a19 19 0 0 0 .14-5m4.87 0h-3.35a21 21 0 0 1-.13 5h3.18a8.5 8.5 0 0 0 .3-5M8.88 4.09h-.02a8.5 8.5 0 0 0-4.61 4.4l3.05.01c.31-1.75.86-3.28 1.58-4.41m3.12-.6-.12.01c-1.26.12-2.48 2.12-3.05 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29z"
]);
const $f342bb1007016cbf$export$5c603813bbc0a335 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe28Filled', "28", [
    "M9.5 14q0-1.3.1-2.5h8.8a30 30 0 0 1-.25 7h-8.3Q9.5 16.4 9.5 14m-1.17 4.5a30 30 0 0 1-.23-7H2.26a12 12 0 0 0 .61 7zM3.6 20H8.6q.4 1.84 1 3.3.53 1.31 1.24 2.28A12 12 0 0 1 3.6 20m6.53 0h7.72a17 17 0 0 1-.84 2.73 8 8 0 0 1-1.51 2.5c-.54.55-1.05.77-1.51.77s-.97-.22-1.5-.78a8 8 0 0 1-1.52-2.49q-.5-1.2-.84-2.73m9.26 0q-.4 1.84-1 3.3-.53 1.31-1.24 2.28A12 12 0 0 0 24.4 20zm5.73-1.5a12 12 0 0 0 .6-7H19.9a32 32 0 0 1-.23 7zM17.02 5.27c.53 1.3.96 2.91 1.2 4.73H9.78c.25-1.82.68-3.43 1.21-4.73q.69-1.65 1.51-2.5C13.03 2.23 13.54 2 14 2s.97.22 1.5.78q.84.83 1.52 2.49M19.74 10h5.58a12 12 0 0 0-8.16-7.58q.7.97 1.25 2.28C19 6.18 19.48 8 19.74 10M2.68 10h5.58c.26-2 .72-3.82 1.33-5.3q.54-1.31 1.25-2.28A12 12 0 0 0 2.68 10"
]);
const $f342bb1007016cbf$export$4d0c76c3be3b0c6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe28Regular', "28", [
    "M14 3.5c.99 0 2.11.89 3.03 2.86q.64 1.36 1.02 3.14h-8.1q.38-1.79 1.02-3.14C11.89 4.4 13 3.5 14 3.5M9.6 5.73A17 17 0 0 0 8.43 9.5H4.51C5.71 6.97 7.9 5 10.57 4.07q-.54.76-.96 1.66M8.19 11a24 24 0 0 0 0 6H3.93a10.5 10.5 0 0 1 0-6zm.24 7.5c.28 1.4.68 2.69 1.19 3.77q.42.9.96 1.66a10.5 10.5 0 0 1-6.06-5.43zm1.53 0h8.1a15 15 0 0 1-1.02 3.14C16.11 23.6 15 24.5 14 24.5s-2.11-.89-3.03-2.86a15 15 0 0 1-1.02-3.14M18.3 17H9.7a23 23 0 0 1 0-6h8.6a23 23 0 0 1 0 6m1.28 1.5h3.91a10.5 10.5 0 0 1-6.06 5.43q.54-.75.96-1.66.76-1.64 1.19-3.77m4.49-1.5h-4.25a24 24 0 0 0 0-6h4.25a10.5 10.5 0 0 1 0 6M17.43 4.07c2.67.93 4.86 2.9 6.06 5.43h-3.91c-.28-1.4-.68-2.69-1.19-3.77q-.42-.9-.96-1.66M14 26a12 12 0 1 0 0-24 12 12 0 0 0 0 24"
]);
const $f342bb1007016cbf$export$8b73cf083d0e58d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe32Filled', "32", [
    "M11 16q0-2.1.22-4h9.56a36 36 0 0 1 0 8h-9.56q-.21-1.9-.22-4m-1.79 4a38 38 0 0 1 0-8H2.58a14 14 0 0 0 0 8zm-5.86 2h6.13c.32 1.86.78 3.55 1.35 4.98q.56 1.4 1.27 2.47A14 14 0 0 1 3.35 22m8.16 0h8.98q-.45 2.41-1.18 4.24a9 9 0 0 1-1.7 2.9c-.6.63-1.15.86-1.61.86s-1-.23-1.6-.87a9 9 0 0 1-1.71-2.9q-.74-1.81-1.18-4.23m11 0a25 25 0 0 1-1.34 4.98q-.56 1.4-1.27 2.47A14 14 0 0 0 28.65 22zm6.91-2a14 14 0 0 0 0-8h-6.63a38 38 0 0 1 0 8zM19.32 5.76c.48 1.2.88 2.64 1.17 4.24H11.5q.46-2.41 1.18-4.24a9 9 0 0 1 1.7-2.9C15 2.24 15.53 2 16 2H16c.47 0 1.01.23 1.6.87q.93.95 1.71 2.9m3.2 4.24h6.13a14 14 0 0 0-8.75-7.45q.72 1.08 1.27 2.47A25 25 0 0 1 22.52 10M3.35 10h6.13c.32-1.86.78-3.55 1.35-4.98q.56-1.4 1.27-2.47A14 14 0 0 0 3.35 10"
]);
const $f342bb1007016cbf$export$f390dee2fc35e460 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe32Light', "32", [
    "M16 2a14 14 0 1 1 0 28 14 14 0 0 1 0-28m-4.6 19c.27 1.65.67 3.13 1.17 4.36a9 9 0 0 0 1.65 2.73q.9.92 1.78.91.88 0 1.78-.9a9 9 0 0 0 1.65-2.74q.76-1.86 1.17-4.36zM4 21a13 13 0 0 0 9.47 7.75 10 10 0 0 1-1.82-3.02A22 22 0 0 1 10.38 21zm17.62 0a22 22 0 0 1-1.27 4.73 10 10 0 0 1-1.82 3.02c4.3-.84 7.83-3.8 9.47-7.75zm-18-9a13 13 0 0 0 0 8h6.62a33 33 0 0 1 0-8zm7.63 0a32 32 0 0 0 0 8h9.5a32 32 0 0 0 0-8zm10.5 0a33 33 0 0 1 0 8h6.62a13 13 0 0 0 0-8zm-8.28-8.75C9.17 4.09 5.64 7.05 4 11h6.38c.29-1.78.72-3.39 1.27-4.73a10 10 0 0 1 1.82-3.02M16 3q-.87 0-1.78.9a9 9 0 0 0-1.65 2.74Q11.81 8.5 11.4 11h9.2a21 21 0 0 0-1.17-4.36 9 9 0 0 0-1.65-2.73Q16.88 2.99 16 3m2.53.25c.7.74 1.32 1.78 1.82 3.02.55 1.34.98 2.95 1.27 4.73H28a13 13 0 0 0-9.47-7.75"
]);
const $f342bb1007016cbf$export$68ce13746a8a4bdb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe32Regular', "32", [
    "M16 30a14 14 0 1 0 0-28 14 14 0 0 0 0 28m0-26c1.03 0 2.28.95 3.33 3.23q.57 1.21.96 2.77h-8.58q.39-1.55.96-2.77C13.72 4.95 14.97 4 16 4m-5.15 2.39q-.74 1.6-1.2 3.61H5.6a12 12 0 0 1 6.13-5.22q-.5.75-.9 1.6M9.28 12a28 28 0 0 0 0 8h-4.6a12 12 0 0 1 0-8zm.37 10q.46 2 1.2 3.61.4.86.89 1.61A12 12 0 0 1 5.6 22zm2.06 0h8.58a16 16 0 0 1-.96 2.77C18.28 27.05 17.03 28 16 28s-2.28-.95-3.33-3.23q-.57-1.21-.96-2.77m8.99-2h-9.4a26 26 0 0 1 0-8h9.4a26 26 0 0 1 0 8m1.65 2h4.04a12 12 0 0 1-6.13 5.22q.5-.75.9-1.6.73-1.61 1.2-3.62m4.97-2h-4.6a28 28 0 0 0 0-8h4.6a12 12 0 0 1 0 8M20.26 4.78c2.6.98 4.76 2.84 6.13 5.22h-4.04q-.46-2-1.2-3.61-.4-.86-.89-1.61"
]);
const $f342bb1007016cbf$export$986c8ed629f5ffac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe48Filled', "48", [
    "M30.72 32.5a30 30 0 0 1-1.93 6.4 13 13 0 0 1-2.62 4.02C25.3 43.75 24.57 44 24 44s-1.3-.25-2.17-1.08a13 13 0 0 1-2.62-4.03 30 30 0 0 1-1.93-6.39zm2.54 0c-.82 4.55-2.3 8.35-4.15 10.84a20 20 0 0 0 13-10.84zm9.82-2.5h-9.44a49 49 0 0 0 .06-11.5h9.53a20 20 0 0 1-.15 11.5m-11.96 0H16.88a47 47 0 0 1-.06-11.5h14.36a47 47 0 0 1-.06 11.5m-16.76 0a49 49 0 0 1-.06-11.5H4.77A20 20 0 0 0 4.92 30zm-8.47 2.5a20 20 0 0 0 13 10.84c-1.86-2.49-3.33-6.3-4.15-10.84zM28.8 9.1A31 31 0 0 1 30.8 16H17.2a31 31 0 0 1 2.02-6.9 13 13 0 0 1 2.62-4.02C22.7 4.25 23.43 4 24 4s1.3.25 2.17 1.08c.88.84 1.8 2.18 2.62 4.03m4.56 6.9h8.99A20 20 0 0 0 29.1 4.66c1.93 2.58 3.43 6.57 4.24 11.34M5.66 16h9c.8-4.77 2.3-8.76 4.23-11.34A20 20 0 0 0 5.66 16"
]);
const $f342bb1007016cbf$export$a4c2b68eebd3da60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Globe48Regular', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40m0 37.5c1.3 0 3.16-1.12 4.84-4.48q.97-1.96 1.64-4.52H17.52q.67 2.57 1.64 4.52c1.68 3.36 3.54 4.48 4.84 4.48M17 30h14a36 36 0 0 0 .09-11.5H16.91a36 36 0 0 0 .08 11.5m16.05 2.5a22 22 0 0 1-3.46 8.09 17.6 17.6 0 0 0 9.71-8.09zm7.4-2.5a17.5 17.5 0 0 0 .17-11.5h-7a39 39 0 0 1-.08 11.5zm-26 0a39 39 0 0 1-.07-11.5h-7A17.5 17.5 0 0 0 7.56 30zM8.7 32.5a17.6 17.6 0 0 0 9.71 8.09c-1.49-2.01-2.7-4.8-3.46-8.09zM17.4 16h13.2q-.68-2.87-1.77-5.02C27.17 7.62 25.3 6.5 24 6.5s-3.16 1.12-4.84 4.48A23 23 0 0 0 17.4 16m15.77 0h6.4a17.6 17.6 0 0 0-9.98-8.59c1.56 2.11 2.81 5.1 3.58 8.59M18.4 7.41A17.6 17.6 0 0 0 8.43 16h6.4c.77-3.5 2.02-6.48 3.58-8.59"
]);
const $f342bb1007016cbf$export$8f3125c124ba9349 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeAdd20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $f342bb1007016cbf$export$2d88cb266e36cd44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeAdd20Regular', "20", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.13 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $f342bb1007016cbf$export$103f62de07c5a7ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeAdd24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m-6.42 4.5a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2l-.05-.3zm-3.7 0c.36 2.08.98 3.85 1.79 5.1a10 10 0 0 1-6.1-5.1zM17.5 14h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6q.09.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zM7.07 10a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5zm8.36 0q.04.65.06 1.31a6.5 6.5 0 0 0-4 3.69H8.69a25 25 0 0 1-.14-4.51l.04-.5zm6.37 0a10 10 0 0 1 .17 2.78 6.5 6.5 0 0 0-4.99-1.76v-.37l-.05-.65zm-6.96-7.6c3.02.9 5.44 3.17 6.53 6.1h-4.59c-.3-2.27-.88-4.23-1.67-5.65l-.16-.27zm-5.67 0a15 15 0 0 0-1.89 5.66l-.06.44H2.63a10 10 0 0 1 6.1-5.96l.31-.1zM12 2c1.32 0 2.65 2.54 3.22 6.18l.04.32H8.74C9.28 4.69 10.64 2 12 2"
]);
const $f342bb1007016cbf$export$f003d94e712d48ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeAdd24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05v.18-.32a9 9 0 0 0-.23-1.59H16.9l.07 1.02q-.78.06-1.49.3-.02-.68-.1-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.72-.42 1.5H9.06c.6 2.22 1.6 3.74 2.66 3.97a7 7 0 0 0 1.06 1.5Q12.4 22 12 22a10 10 0 1 1 0-20m5.5 12h-.09a.5.5 0 0 0-.4.4l-.01.1V17h-2.6a.5.5 0 0 0-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6q.09.32.41.4h.18a.5.5 0 0 0 .4-.4l.01-.1V18h2.6a.5.5 0 0 0 .4-.41v-.18a.5.5 0 0 0-.4-.4l-.1-.01H18v-2.6a.5.5 0 0 0-.41-.4zm-9.99 2.5H4.79a8.5 8.5 0 0 0 4.1 3.41 11 11 0 0 1-1.38-3.4M3.74 10v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5H3.74m5.14-5.9h-.02a8.5 8.5 0 0 0-4.6 4.4H7.3c.31-1.75.86-3.28 1.58-4.4M12 3.5h-.11c-1.27.12-2.5 2.12-3.06 5h6.34c-.58-2.96-1.86-5-3.17-5m3.12.6.1.16A13 13 0 0 1 16.7 8.5h3.05c-.9-2-2.57-3.6-4.63-4.4"
]);
const $f342bb1007016cbf$export$aba38b2d7af2e738 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward16Filled', "16", [
    "M9.3 3.58q.25.64.4 1.42H6.3q.15-.8.4-1.42.32-.83.7-1.23c.24-.27.44-.35.6-.35s.36.08.6.35q.38.4.7 1.23M2.34 10h2.68l.05-.4A17 17 0 0 1 5.12 6H2.34a6 6 0 0 0 0 4M6 13.66A5.5 5.5 0 0 1 5.02 11H2.8A6 6 0 0 0 6 13.66M7.34 6Q6.56 6.54 6 7.32q.03-.69.11-1.32zm5.86-1h-2.47q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5M2.8 5h2.47q.2-.99.5-1.78.2-.52.45-.95A6 6 0 0 0 2.8 5m7.7 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 8 12.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L12.1 7.9a.5.5 0 0 0-.7.7"
]);
const $f342bb1007016cbf$export$aa4dd787ae9fbe53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward16Regular', "16", [
    "M2 8a6 6 0 0 0 4 5.66 6 6 0 0 1-.74-1.47A5 5 0 0 1 4 11h1.02a6 6 0 0 1 0-1h-1.6a5 5 0 0 1 0-4h1.74a12 12 0 0 0-.07 3.5q.23-1.21.93-2.2.04-.68.16-1.3h1.16a5.5 5.5 0 0 1 6.32 0A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5m4.18-.5c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6M10.5 15a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 8 12.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L12.1 7.9a.5.5 0 0 0-.7.7"
]);
const $f342bb1007016cbf$export$1653e16aa4118d20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m5.05 1.52a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m4.66 3.7h-3.75q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.62 1.71a19 19 0 0 0-.14-1.71H7.16a19 19 0 0 0 0 5h2.21a5.5 5.5 0 0 1 3.61-3.29M7.32 13.5h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m-4.52 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm-.4-1h3.75a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7"
]);
const $f342bb1007016cbf$export$4f81776b2bd220b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward20Regular', "20", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.13 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7"
]);
const $f342bb1007016cbf$export$8660b6c9896351a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward24Filled', "24", [
    "M12 2c1.32 0 2.65 2.54 3.21 6.18l.05.32H8.74C9.28 4.69 10.64 2 12 2m2.94.58-.1-.18c3.01.9 5.44 3.17 6.53 6.1h-4.59c-.31-2.42-.96-4.5-1.84-5.92M7.07 10H2.2a10 10 0 0 0 .26 5h4.7l-.06-.58A28 28 0 0 1 7.07 10m14.9 2.78a6.5 6.5 0 0 0-4.99-1.76l-.01-.37-.04-.65h4.87a10 10 0 0 1 .17 2.78M8.67 15h2.83a6.5 6.5 0 0 1 4-3.68q-.03-.68-.08-1.32H8.58l-.04.49a26 26 0 0 0 .13 4.5m.23 1.5h2.18a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2zm-5.83 0h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zm6.1-14.1-.13.04A10 10 0 0 0 2.63 8.5h4.59l.06-.44c.35-2.33 1-4.3 1.88-5.66M12 17.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m6.65-2.15a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65h-2.04C16.01 17 15 18 15 19.25v.25a.5.5 0 1 1-1 0v-.25c0-1.8 1.45-3.25 3.25-3.25h2.04z"
]);
const $f342bb1007016cbf$export$61a728c288ab277a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05 9 9 0 0 0-.24-1.73h-3.35l.07 1.02q-.78.06-1.5.3-.01-.68-.08-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.72-.42 1.5H9.06c.6 2.22 1.6 3.74 2.66 3.97q.42.83 1.06 1.5L12 22a10 10 0 1 1 0-20M7.5 16.5H4.8a8.5 8.5 0 0 0 4.09 3.41q-.79-1.24-1.27-3.01zM7.1 10H3.73v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.78-5.9h-.02a8.5 8.5 0 0 0-4.61 4.4H7.3c.31-1.75.86-3.28 1.58-4.4M12 3.5h-.12c-1.26.12-2.48 2.12-3.05 5h6.34c-.57-2.87-1.78-4.87-3.04-5zm3.12.6.1.16A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zM12 17.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m6.65-2.15a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65h-2.04C16.01 17 15 18 15 19.25v.25a.5.5 0 1 1-1 0v-.25c0-1.8 1.45-3.25 3.25-3.25h2.04z"
]);
const $f342bb1007016cbf$export$cf47733d5c17e7b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward32Filled', "32", [
    "M19.31 5.76c.49 1.2.89 2.64 1.18 4.24H11.5q.46-2.41 1.18-4.24a9 9 0 0 1 1.7-2.9C15 2.24 15.53 2 16 2H16c.47 0 1.01.23 1.6.87q.93.95 1.71 2.9M9.21 20a38 38 0 0 1 0-8H2.58a14 14 0 0 0 0 8zM11 16q0-2.1.22-4h9.56q.12 1.09.18 2.23c-3 .7-5.43 2.9-6.45 5.77h-3.29q-.21-1.9-.22-4m12-2c2.8 0 5.3 1.27 6.94 3.27a14 14 0 0 0-.52-5.27h-6.63q.1.98.16 2zm-8.95 8a8.98 8.98 0 0 0 2.91 7.68q-.52.33-.96.32c-.46 0-1-.23-1.6-.87a9 9 0 0 1-1.71-2.9q-.74-1.81-1.18-4.23zm-4.57 0H3.35a14 14 0 0 0 8.75 7.45q-.72-1.08-1.27-2.47A25 25 0 0 1 9.48 22m19.17-12h-6.13a25 25 0 0 0-1.35-4.98q-.56-1.4-1.27-2.47A14 14 0 0 1 28.65 10m-25.3 0h6.13c.32-1.86.78-3.55 1.35-4.98q.56-1.4 1.27-2.47A14 14 0 0 0 3.35 10M23 30.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m1.22-10.22 1.22 1.22h-2.69a4.25 4.25 0 0 0-4.25 4.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 1 22.75 23h2.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06"
]);
const $f342bb1007016cbf$export$927e7623114fc85c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowForward32Regular', "32", [
    "M16 30q.64 0 1.27-.06a9 9 0 0 1-1.8-2.02c-.92-.28-1.93-1.25-2.8-3.15q-.57-1.21-.96-2.77h2.34q.13-1.04.46-2h-3.2a26 26 0 0 1 0-8h9.39q.17 1.08.24 2.24.95-.23 2-.24-.09-1.02-.22-2h4.6q.59 1.66.67 3.5 1.11.76 1.95 1.77.06-.63.06-1.27a14 14 0 1 0-14 14m0-26c1.03 0 2.28.95 3.33 3.23q.57 1.21.96 2.77h-8.58q.39-1.55.96-2.77C13.72 4.95 14.97 4 16 4m-5.15 2.39q-.74 1.6-1.2 3.61H5.6a12 12 0 0 1 6.13-5.22q-.5.75-.9 1.6M9.28 12a28 28 0 0 0 0 8h-4.6a12 12 0 0 1 0-8zm.37 10q.46 2 1.2 3.61.4.86.89 1.61A12 12 0 0 1 5.6 22zM20.26 4.78c2.6.98 4.76 2.84 6.13 5.22h-4.04q-.46-2-1.2-3.61-.4-.86-.89-1.61M23 30.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m1.22-10.22 1.22 1.22h-2.69a4.25 4.25 0 0 0-4.25 4.25v.5a.75.75 0 0 0 1.5 0v-.5A2.75 2.75 0 0 1 22.75 23h2.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06"
]);
const $f342bb1007016cbf$export$3e52ba397bce2f49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUp16Filled', "16", [
    "M6.12 6a16 16 0 0 0 0 4h.09a5.5 5.5 0 0 1 3.7-3.76L9.87 6zM5 8q0 1.05.12 2H2.34a6 6 0 0 1 0-4h2.78Q5 6.95 5 8m.27 3H2.8a6 6 0 0 0 3.42 2.73q-.25-.42-.45-.95-.3-.8-.5-1.78m4.44-6q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.25.64-.4 1.42zm1.02 0q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5zM5.27 5H2.8a6 6 0 0 1 3.42-2.73q-.25.42-.45.95-.3.8-.5 1.78M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9a.5.5 0 0 0-.35.14"
]);
const $f342bb1007016cbf$export$aee478e34ab3e909 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUp16Regular', "16", [
    "M2 8a6 6 0 0 0 4.5 5.81A5.5 5.5 0 0 1 6.2 10h-.02a11 11 0 0 1 0-4h3.64l.04.25q.48-.15.98-.21V6h1.74l.05.12q.63.13 1.18.39A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5M5.16 6a12 12 0 0 0 0 4H3.42a5 5 0 0 1 0-4zm.22 5a8 8 0 0 0 .66 1.6A5 5 0 0 1 4 11zm4.58-7.6c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9a.5.5 0 0 0-.35.14"
]);
const $f342bb1007016cbf$export$cba363dea5211db6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUp20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $f342bb1007016cbf$export$9bb96b068300e127 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUp20Regular', "20", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.14 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14"
]);
const $f342bb1007016cbf$export$a8fb48bd2df237b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUp24Filled', "24", [
    "M8.9 16.5h2.18a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2zM8.69 15h2.82a6.5 6.5 0 0 1 4-3.68L15.42 10H8.58l-.04.49A26 26 0 0 0 8.68 15m8.82-4c1.73 0 3.3.68 4.47 1.78A10 10 0 0 0 21.8 10h-4.87l.04.66.02.36zM3.07 16.5h4.3c.37 2.08.99 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.75-7.42-.11-.17c3.02.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.95-4.5-1.83-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.89 5.65l-.06.44H2.63a10 10 0 0 1 6.41-6.06M12 2c1.32 0 2.65 2.54 3.22 6.19l.04.31H8.74C9.28 4.7 10.64 2 12 2m11 15.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6 3a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 .7.7L17 15.71z"
]);
const $f342bb1007016cbf$export$fdeeace700e5f8c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeArrowUp24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05q-.03-.9-.23-1.73H16.9l.07 1.02q-.77.06-1.49.3-.02-.68-.1-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.71-.42 1.5H9.06c.6 2.22 1.6 3.73 2.66 3.97q.43.83 1.06 1.5-.38.03-.78.03a10 10 0 1 1 0-20M7.51 16.5H4.79a8.5 8.5 0 0 0 4.1 3.41q-.8-1.24-1.28-3.01zM7.09 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.8-5.91h-.03a8.5 8.5 0 0 0-4.6 4.41H7.3c.31-1.75.86-3.28 1.58-4.41m3.11-.6-.11.01c-1.27.12-2.5 2.12-3.06 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-6 3a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 .7.7L17 15.71z"
]);
const $f342bb1007016cbf$export$8b9cb9806c4f80a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClock16Filled', "16", [
    "M6 13.66A5.5 5.5 0 0 1 5.02 11H2.8A6 6 0 0 0 6 13.66M2.34 10h2.68l.05-.4A17 17 0 0 1 5.12 6H2.34a6 6 0 0 0 0 4m3.67-2.68Q6.56 6.55 7.34 6H6.12q-.08.63-.1 1.32m3.3-3.74q.23.64.4 1.42H6.29q.17-.8.4-1.42.33-.83.7-1.23C7.65 2.08 7.85 2 8 2s.36.08.6.35q.38.4.7 1.23M10.72 5h2.47a6 6 0 0 0-3.42-2.73q.26.42.45.95.3.8.5 1.78M2.8 5h2.47q.2-.99.5-1.78.2-.52.45-.95A6 6 0 0 0 2.8 5M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M10.5 8a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H12a.5.5 0 0 0 0-1h-1V8.5a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$b0bcaec5257b481 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClock16Regular', "16", [
    "M2 8a6 6 0 0 0 4 5.66 6 6 0 0 1-.74-1.47A5 5 0 0 1 4 11h1.02a6 6 0 0 1 0-1h-1.6a5 5 0 0 1 0-4h1.74a12 12 0 0 0-.07 3.5q.23-1.21.93-2.2.04-.68.16-1.3h1.16a5.5 5.5 0 0 1 6.32 0A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5m4.18-.5c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M10.5 8a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H12a.5.5 0 0 0 0-1h-1V8.5a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$681d4422ca1ea6f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClock20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$e69c3614e09b4c4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClock20Regular', "20", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.13 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$5ef9c8cdbe729da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClock24Filled', "24", [
    "M11.08 16.5a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2l-.05-.3zm-3.7 0c.36 2.08.98 3.85 1.79 5.1a10 10 0 0 1-6.1-5.1zM7.06 10a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5zm8.36 0q.04.65.06 1.31a6.5 6.5 0 0 0-4 3.69H8.69a25 25 0 0 1-.14-4.51l.04-.5zm6.37 0a10 10 0 0 1 .17 2.78 6.5 6.5 0 0 0-4.99-1.76v-.37l-.05-.65zm-6.96-7.6c3.02.9 5.44 3.17 6.53 6.1h-4.59c-.3-2.27-.88-4.23-1.67-5.65l-.16-.27zm-5.67 0a15 15 0 0 0-1.89 5.66l-.06.44H2.63a10 10 0 0 1 6.1-5.96l.31-.1zM12 2c1.32 0 2.65 2.54 3.22 6.18l.04.32H8.74C9.28 4.69 10.64 2 12 2m11 15.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M17.5 14c.28 0 .5.22.5.5V17h2a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$7443ebbe22034cef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeClock24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05v.18-.32a9 9 0 0 0-.23-1.59H16.9l.07 1.02q-.78.06-1.49.3-.02-.68-.1-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.72-.42 1.5H9.06c.6 2.22 1.6 3.74 2.66 3.97a7 7 0 0 0 1.06 1.5Q12.4 22 12 22a10 10 0 1 1 0-20M7.51 16.5H4.79a8.5 8.5 0 0 0 4.1 3.41 11 11 0 0 1-1.38-3.4M3.74 10v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5H3.74m5.14-5.9h-.02a8.5 8.5 0 0 0-4.6 4.4H7.3c.31-1.75.86-3.28 1.58-4.4M12 3.5h-.11c-1.27.12-2.5 2.12-3.06 5h6.34c-.58-2.96-1.86-5-3.17-5m3.12.6.1.16A13 13 0 0 1 16.7 8.5h3.05c-.9-2-2.57-3.6-4.63-4.4M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0M17.5 14c.28 0 .5.22.5.5V17h2a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$ead751e8b7009000 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeDesktop20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76Q14 8.7 14 10h4a8 8 0 0 0-.4-2.5m-4.77 0Q13 8.69 13 10h-2a2 2 0 0 0-2 2v.5H7.16a19 19 0 0 1 0-5zm-5.52 6H9V16a2 2 0 0 0 1.41 1.91Q10.2 18 10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M10 12a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-1h-2a1 1 0 0 1-1-1z"
]);
const $f342bb1007016cbf$export$f136c035b6f73c18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeDesktop20Regular', "20", [
    "M10 18q.34 0 .67-.03a2 2 0 0 1-1.56-1.32 4 4 0 0 1-1.13-1.56q-.33-.7-.56-1.59H9v-1H7.2a15 15 0 0 1 0-5h5.6q.2 1.17.2 2.5h1q0-1.31-.2-2.5h2.74Q17 8.68 17 10h1a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M10 12a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v1h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-1h-2a1 1 0 0 1-1-1z"
]);
const $f342bb1007016cbf$export$14a6bfec9c0a2210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeDesktop24Filled', "24", [
    "M11 16.5H8.9l.06.3C9.6 19.9 10.8 22 12 22q.76-.02 1.45-1H13a2 2 0 0 1-2-2zm0-1.5H8.67a25 25 0 0 1-.13-4.51l.04-.49h6.84q.08.97.08 2H13a2 2 0 0 0-2 2zm11-3h-5q0-.68-.03-1.34l-.04-.66h4.87q.2.98.2 2M7.37 16.5h-4.3l.14.28a10 10 0 0 0 5.95 4.81 14 14 0 0 1-1.79-5.09m-.3-6.5H2.2a10 10 0 0 0 .26 5h4.7l-.06-.58A28 28 0 0 1 7.07 10m7.77-7.6.1.18c.88 1.43 1.53 3.5 1.84 5.92h4.6a10 10 0 0 0-6.54-6.1m-5.68 0-.12.04A10 10 0 0 0 2.63 8.5h4.59l.06-.44c.35-2.32 1-4.3 1.88-5.65m6.05 5.79C14.65 4.54 13.31 2 12 2c-1.36 0-2.72 2.7-3.26 6.5h6.52zM12 14a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3v2h.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h.5v-2h-3a1 1 0 0 1-1-1z"
]);
const $f342bb1007016cbf$export$7d011ea3857ce773 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeDesktop24Regular', "24", [
    "M22 12a10 10 0 1 0-11 9.95v-1.84c-.78-.61-1.48-1.9-1.94-3.61H11V15H8.74a19 19 0 0 1-.14-5h6.8q.1.96.1 2H17q0-1.02-.1-2h3.36q.24.96.24 2zM4.8 16.5H7.5l.1.4c.32 1.16.75 2.2 1.27 3.01a8.5 8.5 0 0 1-4.1-3.41M3.74 10h3.35a21 21 0 0 0 .13 5H4.04a8.5 8.5 0 0 1-.3-4.98zm5.12-5.9.02-.01A12 12 0 0 0 7.3 8.5H4.25c.9-2 2.56-3.59 4.6-4.4m3.02-.6h.25c1.26.13 2.48 2.13 3.04 5H8.83c.57-2.88 1.79-4.88 3.05-5m3.35.76-.11-.17.3.12a8.5 8.5 0 0 1 4.33 4.29H16.7c-.3-1.66-.8-3.12-1.47-4.24M12 19a1 1 0 0 0 1 1h3v2h-.5a.5.5 0 1 0 0 1h4a.5.5 0 0 0 0-1H19v-2h3a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1z"
]);
const $f342bb1007016cbf$export$368c9c1ed9c14158 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeError16Filled', "16", [
    "M6.12 6a16 16 0 0 0 0 4h.09a5.5 5.5 0 0 1 3.7-3.76L9.87 6zM5 8q0 1.05.12 2H2.34a6 6 0 0 1 0-4h2.78Q5 6.95 5 8m.27 3H2.8a6 6 0 0 0 3.42 2.73q-.25-.42-.45-.95-.3-.8-.5-1.78m4.44-6q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.25.64-.4 1.42zm1.02 0q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5zM5.27 5H2.8a6 6 0 0 1 3.42-2.73q-.25.42-.45.95-.3.8-.5 1.78M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M11.5 9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $f342bb1007016cbf$export$75c126adb508a06d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeError16Regular', "16", [
    "M2 8a6 6 0 0 0 4.5 5.81A5.5 5.5 0 0 1 6.2 10h-.02a11 11 0 0 1 0-4h3.64l.04.25q.48-.15.98-.21V6h1.74l.05.12q.63.13 1.18.39A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5M5.16 6a12 12 0 0 0 0 4H3.42a5 5 0 0 1 0-4zm.22 5a8 8 0 0 0 .66 1.6A5 5 0 0 1 4 11zm4.58-7.6c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M11.5 9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $f342bb1007016cbf$export$c57cbf91a4bed141 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeError20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.61 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $f342bb1007016cbf$export$f376d2d72ca01c93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeError20Regular', "20", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.14 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M14.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24"
]);
const $f342bb1007016cbf$export$dddd1dd18dd0ad44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeError24Filled', "24", [
    "M8.9 16.5h2.18a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2zM8.69 15h2.82a6.5 6.5 0 0 1 4-3.68L15.42 10H8.58l-.04.49A26 26 0 0 0 8.68 15m8.82-4c1.73 0 3.3.68 4.47 1.78A10 10 0 0 0 21.8 10h-4.87l.04.66.02.36zM3.07 16.5h4.3c.37 2.08.99 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.75-7.42-.11-.17c3.02.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.95-4.5-1.83-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.89 5.65l-.06.44H2.63a10 10 0 0 1 6.41-6.06M12 2c1.32 0 2.65 2.54 3.22 6.19l.04.31H8.74C9.28 4.7 10.64 2 12 2m11 15.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M17.5 14a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m0 7.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25"
]);
const $f342bb1007016cbf$export$e5bfc491a5a8509f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeError24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05q-.03-.9-.23-1.73H16.9l.07 1.02q-.77.06-1.49.3-.02-.68-.1-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.71-.42 1.5H9.06c.6 2.22 1.6 3.73 2.66 3.97q.43.83 1.06 1.5-.38.03-.78.03a10 10 0 1 1 0-20M7.51 16.5H4.79a8.5 8.5 0 0 0 4.1 3.41q-.8-1.24-1.28-3.01zM7.09 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.8-5.91h-.03a8.5 8.5 0 0 0-4.6 4.41H7.3c.31-1.75.86-3.28 1.58-4.41m3.11-.6-.11.01c-1.27.12-2.5 2.12-3.06 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0M17.5 14a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5m0 7.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25"
]);
const $f342bb1007016cbf$export$67ef72d8d92fd31d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeLocation20Filled', "20", [
    "M7.32 6.5q.26-1.32.67-2.32.46-1.1 1-1.66Q9.54 1.98 10 2q.46-.02 1 .52.55.56 1.01 1.66.42 1 .67 2.32zm-.26-2.7q.36-.88.83-1.52A8 8 0 0 0 2.8 6.5h3.5q.28-1.51.76-2.7m5.88 0a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m.91 3.7h3.75q.36 1.07.4 2.25a4.52 4.52 0 0 0-4-.5q-.04-.9-.15-1.75M13 9.76q-.02-1.19-.16-2.26H7.16a19 19 0 0 0 0 5h3.98c.27-1.13.93-2.1 1.86-2.74m-2 3.74H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52.46.02 1-.52.38-.39.74-1.06A6 6 0 0 1 11 13.5m-8.2 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm3.35-1H2.4a8 8 0 0 1 0-5h3.75a21 21 0 0 0 0 5M19 13.68c0-2.03-1.47-3.68-3.5-3.68S12 11.65 12 13.68c0 1.53.98 3.53 3.26 5.24.14.1.34.1.49 0 2.27-1.7 3.25-3.71 3.25-5.24m-2-.18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $f342bb1007016cbf$export$8fe6d2acc18ee3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeLocation20Regular', "20", [
    "M10 18a8 8 0 0 0 2.5-.4 8 8 0 0 1-.98-1.63Q10.75 17.01 10 17c-.66 0-1.4-.59-2.02-1.9q-.33-.71-.56-1.6H11q.02-.51.14-1H7.21a15 15 0 0 1 0-5h5.58q.19 1.05.2 2.26.46-.31 1-.5-.05-.92-.18-1.76h2.73q.32.82.42 1.74.56.19 1.04.51A8 8 0 1 0 10 18m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M19 13.68c0-2.03-1.47-3.68-3.5-3.68S12 11.65 12 13.68c0 1.53.98 3.53 3.26 5.24.14.1.34.1.49 0 2.27-1.7 3.25-3.71 3.25-5.24m-2-.18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $f342bb1007016cbf$export$91b906cd0436a5c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeLocation24Filled', "24", [
    "M8.9 16.5h3.62l-.02.5c0 1.2.46 2.36 1.27 3.49-.54.96-1.15 1.5-1.77 1.5-1.2 0-2.4-2.08-3.04-5.2zM8.67 15h4.2a5.5 5.5 0 0 1 2.63-2.9V12q0-1.03-.08-2H8.58l-.04.49A26 26 0 0 0 8.67 15M18 11.5c1.54 0 2.94.63 3.94 1.66A10 10 0 0 0 21.8 10h-4.87l.04.66.03.93q.48-.09 1-.09m-14.93 5h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.74-7.42-.1-.17c3.01.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.96-4.5-1.84-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.88 5.65l-.06.44h-4.6a10 10 0 0 1 6.42-6.06M12 2c1.32 0 2.65 2.54 3.21 6.19l.05.31H8.74C9.28 4.7 10.64 2 12 2m10.5 15a4.5 4.5 0 0 0-9 0q.02 2.78 4.2 5.9a.5.5 0 0 0 .6 0q4.18-3.12 4.2-5.9m-6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
]);
const $f342bb1007016cbf$export$e95b5667b04f07e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeLocation24Regular', "24", [
    "M12 2a10 10 0 0 1 9.94 11.16q-.63-.65-1.44-1.06V12q0-1.04-.24-2h-3.35q.07.78.09 1.59-.8.15-1.5.5V12q0-1.04-.1-2H8.6a19 19 0 0 0 .14 5h4.13q-.27.7-.35 1.5H9.06c.65 2.41 1.79 4 2.94 4q.69-.01 1.33-.7.54.93 1.4 1.83A10 10 0 1 1 12 2M7.5 16.5H4.8a8.5 8.5 0 0 0 4.09 3.41q-.79-1.25-1.27-3.02zM7.1 10H3.73v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.78-5.91h-.02a8.5 8.5 0 0 0-4.61 4.4l3.05.01c.31-1.75.86-3.28 1.58-4.41m3.12-.6-.12.01c-1.26.12-2.48 2.12-3.05 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zm7.38 12.9a4.5 4.5 0 0 0-9 0q.02 2.8 4.2 5.9a.5.5 0 0 0 .6 0q4.18-3.1 4.2-5.9m-6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
]);
const $f342bb1007016cbf$export$2eb6061d64a6ae8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff12Filled', "12", [
    "M2.13 2.84c-.6.74-1 1.65-1.1 2.66H3q.03-.85.18-1.6l.88.88q-.04.35-.06.72h.78l1 1H4.01a8 8 0 0 0 .76 3.3c.5.97.98 1.2 1.23 1.2s.74-.23 1.23-1.2q.29-.6.49-1.38l.8.81q-.25.8-.6 1.4a5 5 0 0 0 1.24-.76l.99.98a.5.5 0 0 0 .7-.7l-9-9a.5.5 0 1 0-.7.7zm5.5 2.66-3-2.99.14-.3C5.27 1.22 5.75 1 6 1s.74.23 1.23 1.2c.4.82.7 1.97.76 3.3zm2.8 2.81L8.97 6.85l.02-.35h1.98a5 5 0 0 1-.54 1.81M1.03 6.5H3a9 9 0 0 0 1.08 4.12A5 5 0 0 1 1.02 6.5m7.96-1h1.98a5 5 0 0 0-3.06-4.12c.6 1 1.01 2.46 1.08 4.12"
]);
const $f342bb1007016cbf$export$1c4377122e6b9e80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff12Regular', "12", [
    "m2.13 2.84-.98-.99a.5.5 0 1 1 .7-.7l9 9a.5.5 0 0 1-.7.7l-.99-.98a5 5 0 0 1-7.04-7.04m6.32 6.32-.7-.7q-.18.75-.44 1.32a4 4 0 0 0 1.14-.62M6.9 7.59 5.79 6.5h-.78c.05 1.08.24 2 .5 2.66a3 3 0 0 0 .49.81l.05-.05q.2-.19.44-.76.25-.63.4-1.57M4.06 4.77 2.84 3.55a4 4 0 0 0-.8 1.95H4zm.63 5.01a9 9 0 0 1-.68-3.28H2.03A4 4 0 0 0 4.7 9.78m1.8-6.94c.2.51.37 1.2.45 1.98L8.62 6.5h1.35q-.08.56-.29 1.06l.75.75Q11 7.26 11 6a5 5 0 0 0-7.31-4.43l1.68 1.68q.07-.23.14-.41A3 3 0 0 1 6 2.03l.05.05q.2.19.44.76m1.5 2.66a9 9 0 0 0-.68-3.28A4 4 0 0 1 9.97 5.5z"
]);
const $f342bb1007016cbf$export$c1bc2ee1ffbac9a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff16Filled', "16", [
    "m11.87 12.58 2.28 2.27a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7l2.27 2.28q-.35.4-.62.87h1.5l1.75 1.75A16 16 0 0 0 6.12 10H9.3l1.36 1.36q-.16.78-.42 1.42-.2.53-.45.95a6 6 0 0 0 2.1-1.15M6.45 4.33l.67.67h2.59q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.13.35-.25.75M8.12 6 10 7.88q0-1-.12-1.88zm2.86 2.86L12.12 10h1.54a6 6 0 0 0 0-4h-2.78a17 17 0 0 1 .1 2.86M13.12 11l.05.05.03-.05zM4.95 2.83l.7.7a8 8 0 0 1 .57-1.26q-.67.21-1.27.56M5.12 10a17 17 0 0 1 0-4H2.34a6 6 0 0 0 0 4zM2.8 11h2.47q.2.99.5 1.78.2.53.45.95A6 6 0 0 1 2.8 11m6.9 0q-.15.8-.4 1.42-.32.83-.7 1.23c-.24.27-.44.35-.6.35s-.36-.08-.6-.35a4 4 0 0 1-.7-1.23q-.25-.63-.4-1.42zm1.03-6h2.47a6 6 0 0 0-3.42-2.73q.26.42.45.95.3.8.5 1.78"
]);
const $f342bb1007016cbf$export$9d8d5c6384a73185 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff16Regular', "16", [
    "M11.87 12.58a6 6 0 0 1-8.46-8.46L1.16 1.86a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7zm-.7-.7-.63-.63a7 7 0 0 1-.58 1.35 5 5 0 0 0 1.2-.73M9.28 10 6.07 6.77a11 11 0 0 0 .1 3.23zM5 8q0-1.05.16-2H3.42a5 5 0 0 0 0 4h1.74Q5 9.05 5 8m.78 4.1q-.23-.5-.4-1.1H4c.52.7 1.23 1.25 2.04 1.6q-.14-.24-.26-.5m3.53-.42q.14-.3.26-.68H6.43q.12.37.26.68C7.12 12.64 7.63 13 8 13s.88-.36 1.31-1.32M9.82 6q.16.87.18 1.88l.97.97A13 13 0 0 0 10.84 6h1.74a5 5 0 0 1 0 4h-.46l1.05 1.05Q13.98 9.68 14 8a6 6 0 0 0-9.05-5.17L6.61 4.5l.08-.17C7.12 3.36 7.63 3 8 3s.88.36 1.31 1.32q.14.3.26.68H7.12l1 1zM12 5h-1.38a8 8 0 0 0-.66-1.6c.81.35 1.52.9 2.04 1.6"
]);
const $f342bb1007016cbf$export$a4854d1bcc72aa2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff20Filled', "20", [
    "M4 4.7a8 8 0 0 0-1.2 1.8h3l1.32 1.33a20 20 0 0 0 .04 4.67h4.63l1.75 1.75q-.24 1.07-.6 1.95t-.83 1.52A8 8 0 0 0 15.29 16l1.86 1.85a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7zm3.56.74L8.62 6.5h4.06q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66-.24.57-.43 1.26M9.62 7.5l3.36 3.36a21 21 0 0 0-.14-3.36zm4.3 4.3.7.7h2.98a8 8 0 0 0 0-5h-3.75a21 21 0 0 1 .07 4.3m1.7 1.7 1 1a8 8 0 0 0 .58-1zM5.5 3.38l1.26 1.26.3-.84q.36-.88.83-1.52-1.3.36-2.39 1.1m6.61-1.1q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22M10 18q.46.02 1-.52.55-.56 1.01-1.66.42-1 .67-2.32H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52m-2.1-.28a8 8 0 0 1-5.1-4.22h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.75a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5"
]);
const $f342bb1007016cbf$export$d5a7c55f1d27ce30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff20Regular', "20", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7L15.29 16A8 8 0 0 1 4 4.7m10.58 10.6-1.14-1.15q-.22.74-.51 1.36-.28.61-.64 1.1a7 7 0 0 0 2.3-1.32m-2.79-2.8L7.15 7.86a15 15 0 0 0 .06 4.64zm-6-6L4.71 5.42q-.44.5-.77 1.08zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m4.95-.42q.33-.7.56-1.59H7.42q.23.89.56 1.6C8.59 16.4 9.34 17 10 17s1.4-.59 2.02-1.9M7.07 4.5q-.08.14-.14.32l.77.77q.13-.36.28-.67C8.59 3.59 9.34 3 10 3s1.4.59 2.02 1.9q.33.71.56 1.6H8.62l1 1h3.17a15 15 0 0 1 .19 3.36l.92.92a16 16 0 0 0-.1-4.28h2.74a7 7 0 0 1 0 5h-1.92l2 2A8 8 0 0 0 5.5 3.39l.72.71q.7-.45 1.48-.72-.36.5-.64 1.1m9 2.01H13.6a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1a7 7 0 0 1 3.77 3.11"
]);
const $f342bb1007016cbf$export$ee296057e1de7342 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l2.2 2.2a10 10 0 0 0-1.8 3.02h4.6l.03-.2L8.94 10h-.36l-.04.49A26 26 0 0 0 8.67 15h5.27l2.49 2.5a13 13 0 0 1-1.6 4.1 10 10 0 0 0 3.7-2.02l2.19 2.2a.75.75 0 0 0 1.06-1.06zm5.96 3.83 2.44 2.45h3.58l-.05-.31C14.65 4.54 13.31 2 12 2 10.96 2 9.91 3.6 9.24 6.05M13.18 10l2.32 2.32a26 26 0 0 0-.08-2.32zm3.77 3.77L18.18 15h3.36a10 10 0 0 0 .26-5h-4.87l.04.66a29 29 0 0 1-.02 3.1m2.73 2.73.8.8q.25-.39.45-.8zM6.7 3.52l1.33 1.33Q8.5 3.42 9.16 2.4l-.12.03Q7.8 2.83 6.7 3.52m8.4 12.98c-.62 3.27-1.87 5.5-3.1 5.5-1.2 0-2.4-2.1-3.04-5.2l-.06-.3zm-12.03 0h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.74-7.42-.1-.17c3.01.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.96-4.5-1.84-5.92"
]);
const $f342bb1007016cbf$export$5fe38f50edc37fe4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff24Regular', "24", [
    "m4.42 5.48-2.2-2.2a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-2.2-2.2a10 10 0 0 1-14.1-14.1m13.04 13.04-1.2-1.2q-.45 1.5-1.14 2.6a9 9 0 0 0 2.34-1.4M13.94 15l-5-5H8.6a19 19 0 0 0 .14 5zM7.32 8.38 5.48 6.54A9 9 0 0 0 4.25 8.5H7.3zm1.74 8.12c.65 2.41 1.79 4 2.94 4s2.29-1.59 2.94-4zm-1.55 0H4.79a8.5 8.5 0 0 0 4.09 3.41q-.79-1.24-1.27-3.01zM7.09 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.8-5.91q-.31.48-.58 1.04l1.15 1.15c.64-1.65 1.52-2.7 2.42-2.78h.25c1.26.13 2.47 2.13 3.04 5h-3.49l1.5 1.5h2.22a19 19 0 0 1 .1 2.32l1.43 1.43A21 21 0 0 0 16.9 10h3.35a8.5 8.5 0 0 1-.3 5h-1.78l2.3 2.3A10 10 0 0 0 6.7 3.52l1.1 1.1q.5-.3 1.06-.52zm6.23 0 .3.12a8.5 8.5 0 0 1 4.33 4.29H16.7c-.3-1.66-.8-3.12-1.47-4.24z"
]);
const $f342bb1007016cbf$export$b4d5bcea040ab060 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff28Filled', "28", [
    "M5 6.06A12 12 0 0 0 2.68 10h5.58l.08-.6 2.1 2.1H9.6a30 30 0 0 0 .25 7h7.59l1.88 1.88a19 19 0 0 1-.91 2.92q-.54 1.31-1.25 2.28c1.8-.5 3.42-1.39 4.78-2.58l2.78 2.78a.75.75 0 0 0 1.06-1.06L3.28 2.22a.75.75 0 1 0-1.06 1.06zm2.26-1.99 1.88 1.89q.22-.67.45-1.26.54-1.31 1.25-2.28-1.95.54-3.58 1.65m3.08 3.1L13.18 10h5.05a20 20 0 0 0-1.21-4.73 8 8 0 0 0-1.51-2.5C14.97 2.23 14.46 2 14 2s-.97.22-1.5.78a8 8 0 0 0-1.52 2.49q-.35.85-.64 1.9m4.34 4.33 3.8 3.8a30 30 0 0 0-.08-3.8zm5.2 5.2 1.8 1.8h3.45a12 12 0 0 0 .6-7H19.9a32 32 0 0 1-.02 5.2m3.3 3.3.75.74q.24-.36.46-.74zM8.33 18.5a30 30 0 0 1-.23-7H2.26a12 12 0 0 0 .61 7zM3.6 20H8.6q.4 1.84 1 3.3.53 1.31 1.24 2.28A12 12 0 0 1 3.6 20m14.25 0a17 17 0 0 1-.84 2.73 8 8 0 0 1-1.51 2.5c-.54.55-1.05.77-1.51.77s-.97-.22-1.5-.78a8 8 0 0 1-1.52-2.49q-.5-1.2-.84-2.73zm1.88-10h5.58a12 12 0 0 0-8.16-7.58q.7.97 1.25 2.28C19 6.18 19.48 8 19.74 10"
]);
const $f342bb1007016cbf$export$4fd4d4da25aa4e35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff28Regular', "28", [
    "M5 6.06 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06L21.94 23A12 12 0 0 1 5 6.06m15.88 15.88-1.72-1.72q-.33 1.11-.77 2.05-.42.9-.96 1.66a11 11 0 0 0 3.45-2m-3.44-3.44H9.95q.38 1.79 1.02 3.14C11.89 23.6 13 24.5 14 24.5s2.11-.89 3.03-2.86q.55-1.16.9-2.64zm-1.5-1.5-6-6H9.7a23 23 0 0 0 0 6zM8.42 9.49 6.06 7.12Q5.13 8.21 4.51 9.5zM8 14q0-1.55.18-3H3.93a10.5 10.5 0 0 0 0 6h4.25Q8 15.55 8 14m1.6 8.27a17 17 0 0 1-1.18-3.77H4.51c1.2 2.53 3.39 4.5 6.06 5.43a10 10 0 0 1-.96-1.66M7.27 4.07l1.08 1.09q1.05-.67 2.23-1.09A10 10 0 0 0 9.4 6.21l1.16 1.16q.2-.54.42-1C11.89 4.38 13 3.5 14 3.5s2.11.89 3.03 2.86q.64 1.36 1.02 3.14h-5.37l1.5 1.5h4.12a23 23 0 0 1 .17 4.28l1.39 1.4a25 25 0 0 0-.04-5.68h4.25a10.5 10.5 0 0 1 0 6h-3.89l3.75 3.74A12 12 0 0 0 7.26 4.07M23.49 9.5h-3.91c-.28-1.4-.68-2.69-1.19-3.77q-.42-.9-.96-1.66c2.67.93 4.86 2.9 6.06 5.43"
]);
const $f342bb1007016cbf$export$13e4bc778a153447 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff32Filled', "32", [
    "M5.42 6.83Q4.17 8.26 3.35 10h5.24l2.57 2.58a36 36 0 0 0 .06 7.42h7.37l3.6 3.61a23 23 0 0 1-1.02 3.37q-.56 1.4-1.27 2.47a14 14 0 0 0 5.27-2.87l3.12 3.13a1 1 0 0 0 1.42-1.42l-26-26a1 1 0 0 0-1.42 1.42zm6.45 1.5L13.53 10h6.96q-.45-2.41-1.18-4.24a9 9 0 0 0-1.7-2.9C17 2.24 16.47 2 16 2H16c-.47 0-1.01.23-1.6.87a9 9 0 0 0-1.71 2.9q-.47 1.15-.82 2.57M15.53 12l5.44 5.44a37 37 0 0 0-.2-5.44zm7.33 7.32.68.68h5.88a14 14 0 0 0 0-8H22.8a38 38 0 0 1 .07 7.32M25.54 22l1.97 1.97q.64-.93 1.14-1.97zM8.03 4.5l2.21 2.2q.27-.88.59-1.68.56-1.4 1.27-2.47a14 14 0 0 0-4.07 1.94M9.2 20a38 38 0 0 1 0-8H2.58a14 14 0 0 0 0 8zm-5.86 2h6.13c.32 1.86.78 3.55 1.35 4.98q.56 1.4 1.27 2.47A14 14 0 0 1 3.35 22m17.14 0q-.45 2.41-1.18 4.24a9 9 0 0 1-1.7 2.9c-.6.63-1.14.86-1.61.86-.46 0-1-.23-1.6-.87a9 9 0 0 1-1.71-2.9q-.74-1.81-1.17-4.23zm2.03-12h6.13a14 14 0 0 0-8.75-7.45q.72 1.08 1.27 2.47A25 25 0 0 1 22.52 10"
]);
const $f342bb1007016cbf$export$a677ba809862ff91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff32Regular', "32", [
    "M5.42 6.83 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-3.12-3.13A14 14 0 0 1 5.42 6.83m18.33 18.33-1.77-1.76q-.36 1.2-.83 2.21-.4.86-.89 1.61a12 12 0 0 0 3.49-2.06M18.59 20l-7.38-7.37a27 27 0 0 0 .1 7.37zm-10-10L6.84 8.25q-.7.81-1.23 1.75zM9 16q0-2.09.28-4h-4.6a12 12 0 0 0 0 8h4.6A28 28 0 0 1 9 16m1.85 9.61q-.74-1.6-1.2-3.61H5.6a12 12 0 0 0 6.13 5.22q-.5-.75-.89-1.6m8.49-.84q.57-1.21.95-2.77h-8.58q.39 1.55.96 2.77C13.72 27.05 14.97 28 16 28s2.28-.95 3.34-3.23M10.85 6.4q-.15.3-.28.64l1.55 1.56q.25-.73.55-1.36C13.72 4.95 14.97 4 16 4s2.28.95 3.34 3.23q.57 1.21.95 2.77h-6.76l2 2h5.17a26 26 0 0 1 .26 5.43l1.85 1.85a29 29 0 0 0-.09-7.28h4.6a12 12 0 0 1 0 8h-3.78l3.97 3.97A14 14 0 0 0 8.03 4.5l1.44 1.44q1.06-.7 2.27-1.15-.5.75-.89 1.6M26.39 10h-4.04q-.46-2-1.2-3.61-.4-.86-.89-1.61c2.6.98 4.76 2.84 6.13 5.22"
]);
const $f342bb1007016cbf$export$7aa14ebb9c7b3758 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff48Filled', "48", [
    "M42.1 32.5a20 20 0 0 1-1.85 3.16L37.1 32.5zM37.24 39l4.64 4.63a1.25 1.25 0 0 0 1.76-1.76L6.13 4.37a1.25 1.25 0 1 0-1.76 1.76L9 10.77A20 20 0 0 0 5.66 16h8.57l2.58 2.58A47 47 0 0 0 16.88 30h11.35l4.6 4.6c-.87 3.61-2.15 6.64-3.72 8.74 3.06-.8 5.82-2.31 8.12-4.34m-3.5-9.86.87.86h8.48a20 20 0 0 0 .15-11.5H33.7a50 50 0 0 1 .04 10.64M23.1 18.5l8.32 8.32a48 48 0 0 0-.24-8.32zm-5.3-5.3 2.8 2.8H30.8a31 31 0 0 0-2.02-6.9 13 13 0 0 0-2.62-4.02C25.3 4.25 24.57 4 24 4s-1.3.25-2.17 1.08a13 13 0 0 0-2.62 4.03 27 27 0 0 0-1.4 4.1m-5.46-5.45 3.44 3.43a22 22 0 0 1 3.1-6.52c-2.38.63-4.59 1.69-6.54 3.09M30.72 32.5a30 30 0 0 1-1.93 6.4 13 13 0 0 1-2.62 4.02C25.3 43.75 24.57 44 24 44s-1.3-.25-2.17-1.08a13 13 0 0 1-2.62-4.03 30 30 0 0 1-1.93-6.39zM14.36 30a49 49 0 0 1-.06-11.5H4.77A20 20 0 0 0 4.92 30zm-8.47 2.5a20 20 0 0 0 13 10.84c-1.86-2.49-3.33-6.3-4.15-10.84zM33.35 16h8.99A20 20 0 0 0 29.1 4.66c1.93 2.58 3.43 6.57 4.24 11.34"
]);
const $f342bb1007016cbf$export$f5b6f0bf2bca7a40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeOff48Regular', "48", [
    "M44 24a20 20 0 0 1-3.75 11.66L34.6 30h5.84a17.5 17.5 0 0 0 .18-11.5h-7a39 39 0 0 1 .05 10.58L31.4 26.8a38 38 0 0 0-.31-8.3h-8L20.6 16H30.6q-.68-2.87-1.77-5.02C27.17 7.62 25.3 6.5 24 6.5s-3.16 1.12-4.84 4.48a21 21 0 0 0-1.05 2.54l-1.94-1.95q.96-2.42 2.24-4.16a17 17 0 0 0-4.27 2.13l-1.8-1.8A20 20 0 0 1 44 24m-4.43-8a17.6 17.6 0 0 0-9.98-8.59c1.56 2.11 2.81 5.1 3.58 8.59zM9 10.77A20 20 0 0 0 37.23 39l4.64 4.63a1.25 1.25 0 0 0 1.76-1.76L6.13 4.37a1.25 1.25 0 1 0-1.76 1.76zM14.23 16h-5.8q.97-1.87 2.34-3.46zm21.23 21.23a18 18 0 0 1-5.87 3.36 21 21 0 0 0 2.97-6.26L34 35.77V36l.21-.02zM16.5 24q0-2.82.39-5.35L28.23 30H17q-.48-2.8-.49-6m12.34 13.02C27.16 40.38 25.3 41.5 24 41.5s-3.16-1.12-4.84-4.48q-.97-1.96-1.64-4.52h12.96q-.67 2.57-1.64 4.52M14 24q0 3.14.46 6h-6.9a17.5 17.5 0 0 1-.18-11.5h7Q14 21.14 14 24m4.41 16.59A17.6 17.6 0 0 1 8.7 32.5h6.25a22 22 0 0 0 3.46 8.09"
]);
const $f342bb1007016cbf$export$dcc79ca3368ecd48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobePerson20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.11.92.14 1.9a3 3 0 0 1 4 .93 8 8 0 0 0-.39-2.83M13 10v.35a3 3 0 0 0-.46 2.15H7.16a19 19 0 0 1 0-5h5.68Q13 8.69 13 10m-.32 3.5q-.07.36-.15.7A2.5 2.5 0 0 0 11 16.5q0 .44.12.86l-.12.12q-.54.54-1 .52-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32zM7.9 17.72A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $f342bb1007016cbf$export$3cf4fa45bc8be27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobePerson20Regular', "20", [
    "M11.31 17.9q-.63.1-1.31.1a8 8 0 1 1 8-7.67 3 3 0 0 0-1.03-.94q-.08-1-.43-1.89h-2.73q.15.91.18 1.9-.6.36-1 .95a16 16 0 0 0-.2-2.85H7.21a15 15 0 0 0 0 5h5.33q.1.54.36 1H7.42q.23.89.56 1.6C8.59 16.4 9.34 17 10 17q.48 0 1-.44 0 .7.31 1.33m.71-13C11.41 3.6 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m9-9.01a7 7 0 0 0-3.78-3.12q.36.5.64 1.1.4.9.68 2.02zM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5"
]);
const $f342bb1007016cbf$export$2a30a8f80fa61868 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobePerson24Filled', "24", [
    "m15.1 16.5-.13.62A2.8 2.8 0 0 0 13 19.77v.1q0 .7.26 1.38-.6.73-1.26.75c-1.2 0-2.4-2.1-3.04-5.2l-.06-.3zm-.1-2q.01-1 .5-1.79a26 26 0 0 0-.08-2.71H8.58l-.04.49A26 26 0 0 0 8.67 15h6.37zm3.5-3.5a3.5 3.5 0 0 1 3.38 2.58A10 10 0 0 0 21.8 10h-4.87l.04.66.02.68q.7-.34 1.51-.34M3.07 16.5h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.74-7.42-.1-.17c3.01.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.96-4.5-1.84-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.88 5.65l-.06.44h-4.6a10 10 0 0 1 6.42-6.06M12 2c1.32 0 2.65 2.54 3.21 6.19l.05.31H8.74C9.28 4.7 10.64 2 12 2m9 12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.88v-.1c0-.99.8-1.78 1.77-1.78h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $f342bb1007016cbf$export$d272fba1e9f2e30a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobePerson24Regular', "24", [
    "M22 12a10 10 0 1 0-8.42 9.88 4 4 0 0 1-.57-1.78q-.5.4-1.01.4c-1.15 0-2.29-1.59-2.94-4h6.57q-.47-.67-.6-1.5h-6.3a19 19 0 0 1-.13-5h6.8a19 19 0 0 1 .09 2.72q.54-.92 1.5-1.38-.02-.69-.08-1.34h3.35q.19.78.23 1.62a3.5 3.5 0 0 1 1.39 1.96Q22 12.8 22 12M4.8 16.5H7.5l.1.4c.32 1.16.75 2.2 1.27 3.01a8.5 8.5 0 0 1-4.1-3.41M3.74 10h3.35a21 21 0 0 0 .13 5H4.04a8.5 8.5 0 0 1-.3-4.98zm5.12-5.9.02-.01A12 12 0 0 0 7.3 8.5H4.25c.9-2 2.56-3.59 4.6-4.4m3.02-.6h.25c1.26.13 2.47 2.13 3.04 5H8.83c.57-2.88 1.79-4.88 3.05-5m3.35.76-.11-.17.3.12a8.5 8.5 0 0 1 4.33 4.29H16.7c-.3-1.66-.8-3.12-1.47-4.24M21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 5.37c0 1.56-1.29 3.13-4.5 3.13S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77z"
]);
const $f342bb1007016cbf$export$7d7b009749a0b0d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibited16Filled', "16", [
    "M6.12 6a16 16 0 0 0 0 4h.09a5.5 5.5 0 0 1 3.7-3.76L9.87 6zM5 8q0 1.05.12 2H2.34a6 6 0 0 1 0-4h2.78Q5 6.95 5 8m.27 3H2.8a6 6 0 0 0 3.42 2.73q-.25-.42-.45-.95-.3-.8-.5-1.78m4.44-6q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.25.64-.4 1.42zm1.02 0q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5zM5.27 5H2.8a6 6 0 0 1 3.42-2.73q-.25.42-.45.95-.3.8-.5 1.78M7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6"
]);
const $f342bb1007016cbf$export$be6c9f3830022fe9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibited16Regular', "16", [
    "M2 8a6 6 0 0 0 4.5 5.81A5.5 5.5 0 0 1 6.2 10h-.02a11 11 0 0 1 0-4h3.64l.04.25q.48-.15.98-.21V6h1.74l.05.12q.63.13 1.18.39A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5M5.16 6a12 12 0 0 0 0 4H3.42a5 5 0 0 1 0-4zm.22 5a8 8 0 0 0 .66 1.6A5 5 0 0 1 4 11zm4.58-7.6c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6M7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.5 3.5 0 0 1-.7-2.1m3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6"
]);
const $f342bb1007016cbf$export$a7d7b149a2fcbbf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibited20Filled', "20", [
    "M7.32 6.5q.26-1.32.67-2.32.46-1.1 1-1.66Q9.54 1.98 10 2q.46-.02 1 .52.55.56 1.01 1.66.42 1 .67 2.32zm-.26-2.7q.36-.88.83-1.52A8 8 0 0 0 2.8 6.5h3.5q.28-1.51.76-2.7m5.88 0a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m.91 3.7h3.75a8 8 0 0 1 .4 2.75 5.5 5.5 0 0 0-4.02-1.23q-.04-.78-.13-1.52m-.87 1.71a19 19 0 0 0-.14-1.71H7.16a19 19 0 0 0 0 5h2.21a5.5 5.5 0 0 1 3.61-3.29M9.1 13.5H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52.12 0 .23-.03A5.5 5.5 0 0 1 9.1 13.5m-6.29 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm3.35-1H2.4a8 8 0 0 1 0-5h3.75a21 21 0 0 0 0 5m3.85 2a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m2.4 2.8 4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-5.6 2.8m-.7-.7a3.5 3.5 0 0 1 4.9-4.9z"
]);
const $f342bb1007016cbf$export$26c901894610a39d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibited20Regular', "20", [
    "M10.25 18H10a8 8 0 1 1 8-7.75 6 6 0 0 0-1.01-.66 7 7 0 0 0-.45-2.09h-2.73q.12.73.16 1.53-.51.05-.99.18-.05-.9-.19-1.71H7.21a15 15 0 0 0 0 5h2.16q-.19.48-.28 1H7.42q.23.89.56 1.6c.48 1.02 1.04 1.6 1.58 1.81q.28.6.7 1.09m1.77-13.1C11.41 3.6 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m9-9.01a7 7 0 0 0-3.78-3.12q.36.5.64 1.1.4.9.68 2.02zm-6.07 8a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m2.4 2.8 4.9-4.9q.68.9.7 2.1a3.5 3.5 0 0 1-5.6 2.8m-.7-.7a3.5 3.5 0 0 1 4.9-4.9z"
]);
const $f342bb1007016cbf$export$3d6b72b18460377b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibited24Filled', "24", [
    "M8.9 16.5h2.18a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2zM8.69 15h2.82a6.5 6.5 0 0 1 4-3.68L15.42 10H8.58l-.04.49A26 26 0 0 0 8.68 15m8.82-4c1.73 0 3.3.68 4.47 1.78A10 10 0 0 0 21.8 10h-4.87l.04.66.02.36zM3.07 16.5h4.3c.37 2.08.99 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.75-7.42-.11-.17c3.02.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.95-4.5-1.83-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.89 5.65l-.06.44H2.63a10 10 0 0 1 6.41-6.06M12 2c1.32 0 2.65 2.54 3.22 6.19l.04.31H8.74C9.28 4.7 10.64 2 12 2m11 15.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3m4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69"
]);
const $f342bb1007016cbf$export$6b142e0c463fd29c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeProhibited24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05q-.03-.9-.23-1.73H16.9l.07 1.02q-.77.06-1.49.3-.02-.68-.1-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.71-.42 1.5H9.06c.6 2.22 1.6 3.73 2.66 3.97q.43.83 1.06 1.5-.38.03-.78.03a10 10 0 1 1 0-20M7.51 16.5H4.79a8.5 8.5 0 0 0 4.1 3.41q-.8-1.24-1.28-3.01zM7.09 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.8-5.91h-.03a8.5 8.5 0 0 0-4.6 4.41H7.3c.31-1.75.86-3.28 1.58-4.41m3.11-.6-.11.01c-1.27.12-2.5 2.12-3.06 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3m4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69"
]);
const $f342bb1007016cbf$export$58538f0059e6c982 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSearch20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m5.05 1.52a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.28-1.51-.76-2.7m4.66 3.7h-3.75a21 21 0 0 1 0 5h3.75a8 8 0 0 0 0-5m-3.9 6h3.5a8 8 0 0 1-5.09 4.22q.47-.65.83-1.52.49-1.18.76-2.7m-4.14.44q.1-.21.18-.44h2.94a12 12 0 0 1-.87 2.77 2 2 0 0 0-.25-.33zm.41-1.44h2.87a19 19 0 0 0 0-5H7.16l-.04.3a4.5 4.5 0 0 1 2.85 4.7m-3.82-5v.05a5 5 0 0 0-.65-.05zm-3.75 0h3.1c-1.39 0-2.63.63-3.45 1.61q.1-.83.35-1.61m3.1 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L8.3 14.1a3.5 3.5 0 1 0-2.8 1.4m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
]);
const $f342bb1007016cbf$export$8bf277acef8e644 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSearch20Regular', "20", [
    "M2.05 9.11a8 8 0 1 1 9.72 8.7 1.5 1.5 0 0 0-.2-1.87l-.02-.01q.24-.36.47-.84.33-.7.56-1.59H9.74q.18-.48.23-1h2.82a15 15 0 0 0 0-5H7.21l-.05.31q-.47-.18-.98-.26l.01-.05H3.46l-.2.6q-.7.4-1.21 1.01m9.97-4.2C11.41 3.59 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zm9.67 7h-2.45q-.26 1.12-.68 2.01-.28.61-.64 1.1a7 7 0 0 0 3.77-3.11m-2.25-1h2.73a7 7 0 0 0 0-5h-2.73a16 16 0 0 1 0 5m2.25-6a7 7 0 0 0-3.77-3.12q.36.5.64 1.1.4.9.68 2.02zM8.3 14.1q.68-.9.7-2.1a3.5 3.5 0 1 0-1.4 2.8l2.55 2.55a.5.5 0 0 0 .7-.7zM8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $f342bb1007016cbf$export$460b398422f65a40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSearch24Filled', "24", [
    "M3.44 9.96a4.93 4.93 0 0 0 6.23 7.57l4.26 4.25a.77.77 0 0 0 1.17-1l-.08-.09-4.21-4.22a4.93 4.93 0 0 0-7.37-6.51m13.21 6.54a17 17 0 0 1-.95 3.45l.03.03.13.14q.33.46.37.96a10 10 0 0 0 4.73-4.58zm-4.4 0 2.28 2.29q.31-.9.53-2l.06-.29zm-2.94-5.45a3.38 3.38 0 1 1-4.78 4.78 3.38 3.38 0 0 1 4.78-4.78M15.45 10h-3.7a6 6 0 0 1 .9 5h2.7a25 25 0 0 0 .13-4.51zm1.5 0a28 28 0 0 1-.03 4.42l-.05.58h4.7a10 10 0 0 0 .26-5zm-2.09-7.6a15 15 0 0 1 1.89 5.66l.06.44h4.59a10 10 0 0 0-6.11-5.96l-.3-.1zM12.03 2c-1.28 0-2.57 2.38-3.16 5.84q.7.24 1.33.66h5.09c-.54-3.8-1.9-6.5-3.26-6.5m-2.84.4c-3.02.9-5.44 3.17-6.54 6.1h1a6 6 0 0 1 3.74-.97c.32-1.86.85-3.47 1.53-4.68l.16-.27z"
]);
const $f342bb1007016cbf$export$7a330b18a21b3a28 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSearch24Regular', "24", [
    "M3.44 9.96a4.93 4.93 0 0 0 6.23 7.57l4.26 4.25a.77.77 0 0 0 1.17-1l-.08-.1-4.21-4.2a4.93 4.93 0 0 0-7.37-6.52M12.03 2a10 10 0 0 0-9.76 7.76 6 6 0 0 1 2.24-1.73 8.5 8.5 0 0 1 4.4-3.94l-.11.17q-.81 1.36-1.28 3.28.76.08 1.47.34c.63-2.62 1.82-4.38 3.04-4.38h.11c1.27.12 2.49 2.12 3.06 5h-5a6 6 0 0 1 1.55 1.5h3.67a19 19 0 0 1-.13 5h-2.65q-.12.43-.3.84l-.13.27-.12.23.16.16h2.71q-.3 1.13-.73 1.98l1.1 1.11q.75-1.3 1.19-3.09h2.72a8.5 8.5 0 0 1-3.73 3.26l.22.22.13.14q.33.46.37.96A10 10 0 0 0 12.03 2M9.3 11.05a3.38 3.38 0 1 1-4.78 4.78 3.38 3.38 0 0 1 4.78-4.78M16.93 10h3.36v.03A8.5 8.5 0 0 1 20 15H16.8a20 20 0 0 0 .12-5m-1.79-5.91h.03c2.05.82 3.7 2.41 4.6 4.4h-3.04a12 12 0 0 0-1.59-4.4"
]);
const $f342bb1007016cbf$export$8206175eb695ede4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__a)",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__b)",
            "fillOpacity": ".7",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__c)",
            "fillOpacity": ".2",
            "d": "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__d)",
            "fillRule": "evenodd",
            "d": "M7.85 2.3q-.46.64-.81 1.5c-.37.9-.65 2-.83 3.2H2.58q-.2.49-.33 1H6.1a22 22 0 0 0 0 4H2.25q.13.51.33 1h3.63c.18 1.2.46 2.3.83 3.2q.35.86.81 1.5a8 8 0 0 0 4.3 0q.46-.64.81-1.5c.37-.9.65-2 .83-3.2h3.63q.2-.49.33-1H13.9a22 22 0 0 0 0-4h3.84q-.13-.51-.33-1h-3.63c-.18-1.2-.46-2.3-.83-3.2a7 7 0 0 0-.81-1.5 8 8 0 0 0-4.3 0M7.22 7q.26-1.64.74-2.82.46-1.1 1-1.66Q9.5 1.98 10 2q.5-.02 1.03.52.54.56 1 1.66.5 1.19.75 2.82zM10 18q.5.02 1.03-.52.54-.56 1-1.66.5-1.19.75-2.82H7.22q.26 1.63.74 2.82.46 1.1 1 1.66.54.54 1.04.52m-3-8q0 1.04.1 2h5.8a21 21 0 0 0 0-4H7.1q-.1.96-.1 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_20_color__e)",
            "d": "M14 18.52a5.1 5.1 0 0 1-3-4.58v-2.5c0-.28.23-.5.5-.54a5.7 5.7 0 0 0 3.06-1.72A.6.6 0 0 1 15 9a.6.6 0 0 1 .44.18 5.7 5.7 0 0 0 3.06 1.72c.27.04.5.26.5.54V14a5.1 5.1 0 0 1-3 4.52 7 7 0 0 1-1 .4l-.13-.02a7 7 0 0 1-.87-.38"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "translate(14.94 14.13)scale(-6.72116)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.28 -13.13 29.6)scale(10.5253 11.4176)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1b44b1",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(45.02 -9.4 25.1)scale(12.0242 12.8442)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#3bd5ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".81",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__a",
                "x1": "5.56",
                "x2": "17.11",
                "y1": "4.67",
                "y2": "15.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_20_color__e",
                "x1": "12.5",
                "x2": "20.02",
                "y1": "9",
                "y2": "17.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#62be55"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1e794a"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$655988ce2fc88dad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76l.1.95a1.63 1.63 0 0 1 2.2.09c.42.43 1.08.98 1.85 1.27a8 8 0 0 0-.4-2.31m-4.77 0q.12.85.15 1.78c-.47.33-1.03.61-1.63.7-.68.09-1.36.66-1.36 1.52v1H7.16a19 19 0 0 1 0-5zm-5.52 6H10v.5c0 1.42.45 2.55 1.07 3.4l-.07.08q-.54.54-1 .52-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m16.11-1.54a5.7 5.7 0 0 1-3.06-1.72.6.6 0 0 0-.88 0 5.7 5.7 0 0 1-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 0 0 .26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54"
]);
const $f342bb1007016cbf$export$ef2451ad847901dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield20Regular', "20", [
    "M10 18q.74 0 1.44-.13a6 6 0 0 1-.75-1.08q-.36.21-.69.21c-.66 0-1.4-.59-2.02-1.9q-.33-.71-.56-1.6H10v-1H7.2a15 15 0 0 1 0-5h5.6q.14.85.18 1.78a6 6 0 0 0 .95-.82q-.04-.49-.12-.96h2.73q.32.82.42 1.74.46.34 1.04.57A8 8 0 1 0 10 18m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1m6.21 7.58a5.7 5.7 0 0 1-3.06-1.72.6.6 0 0 0-.88 0 5.7 5.7 0 0 1-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 0 0 .26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54"
]);
const $f342bb1007016cbf$export$4f09a7fd7fbe767a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_24_color__a)",
            "d": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_24_color__b)",
            "fillOpacity": ".7",
            "d": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_24_color__c)",
            "fillOpacity": ".2",
            "d": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_24_color__d)",
            "fillRule": "evenodd",
            "d": "M9.12 2.42a10 10 0 0 0-.85 1.7A19 19 0 0 0 7.22 8.5H2.63q-.28.72-.43 1.5h4.87a29 29 0 0 0 .09 5h-4.7q.25.78.6 1.5h4.3q.33 1.9.9 3.37.37.95.86 1.7a10 10 0 0 0 5.76 0q.48-.75.85-1.7.58-1.47.9-3.37h4.3q.36-.72.61-1.5h-4.7a28 28 0 0 0 .1-5h4.86a10 10 0 0 0-.43-1.5h-4.59a19 19 0 0 0-1.05-4.37 10 10 0 0 0-.85-1.7 10 10 0 0 0-5.76 0m-.4 6.08q.31-2.22.94-3.83.55-1.38 1.2-2.06c.42-.45.8-.61 1.14-.61s.72.16 1.14.6q.65.69 1.2 2.07.62 1.6.93 3.83zM12 22c.34 0 .72-.16 1.14-.6q.65-.69 1.2-2.07.48-1.23.77-2.83H8.9q.3 1.6.77 2.83.55 1.38 1.2 2.06c.42.45.8.61 1.14.61M8.5 12q0 1.58.17 3h6.66a27 27 0 0 0 .1-5H8.57q-.07.97-.07 2",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_24_color__e)",
            "d": "M22.5 13.01a7.7 7.7 0 0 1-4.11-1.87.6.6 0 0 0-.77 0c-.69.58-2.21 1.7-4.12 1.87a.54.54 0 0 0-.5.52v3.5c0 4.23 4.1 5.72 4.87 5.97q.13.03.26 0c.78-.25 4.87-1.74 4.87-5.97v-3.5c0-.27-.22-.5-.5-.52"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "translate(18.17 17.16)scale(-8.40145)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.28 -15.92 36.02)scale(13.1566 14.272)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1b44b1",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(44.68 -11.53 30.8)scale(15.1197 16.1498)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#3bd5ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".81",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_24_color__a",
                "x1": "6.44",
                "x2": "20.89",
                "y1": "5.33",
                "y2": "18.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_24_color__e",
                "x1": "14.88",
                "x2": "23.94",
                "y1": "11",
                "y2": "21.82",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#62be55"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1e794a"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$e0a5ee58e969a22d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield24Filled', "24", [
    "M8.9 16.5H12v.5c0 1.73.6 3.07 1.38 4.09q-.66.88-1.38.9c-1.2 0-2.4-2.08-3.04-5.2zM8.67 15H12v-1.5c0-.85.68-1.45 1.4-1.52a6 6 0 0 0 2.1-.64q-.03-.68-.08-1.34H8.58l-.04.49A26 26 0 0 0 8.67 15m13.13-5q.2.91.2 1.9a7 7 0 0 1-2.96-1.55q-.32-.27-.71-.35zM3.07 16.5h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.74-7.42-.1-.17c3.01.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.96-4.5-1.84-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.88 5.65l-.06.44h-4.6a10 10 0 0 1 6.42-6.06M12 2c1.32 0 2.65 2.54 3.21 6.19l.05.31H8.74C9.28 4.7 10.64 2 12 2m10.5 10.98a7.7 7.7 0 0 1-4.11-1.87.6.6 0 0 0-.77 0c-.69.58-2.21 1.7-4.12 1.87a.54.54 0 0 0-.5.52V17c0 4.22 4.1 5.72 4.87 5.96q.13.04.26 0C18.9 22.72 23 21.22 23 17v-3.5c0-.28-.22-.5-.5-.52"
]);
const $f342bb1007016cbf$export$3fdd14ffd55e07f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield24Regular', "24", [
    "M12 2a10 10 0 0 1 10 9.89 6 6 0 0 1-1.52-.57q-.06-.68-.22-1.32h-1.94a2 2 0 0 0-.64 0h-.77l.03.37c-.33.27-.83.65-1.45.97q-.03-.69-.1-1.34H8.6a19 19 0 0 0 .14 5H12v1.5H9.06c.65 2.41 1.79 4 2.94 4q.42 0 .82-.26.52.9 1.2 1.56-.99.2-2.02.2a10 10 0 1 1 0-20M7.5 16.5H4.8a8.5 8.5 0 0 0 4.09 3.41q-.79-1.25-1.27-3.02zM7.1 10H3.73v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.78-5.91h-.02a8.5 8.5 0 0 0-4.61 4.4l3.05.01c.31-1.75.86-3.28 1.58-4.41m3.12-.6-.12.01c-1.26.12-2.48 2.12-3.05 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zm7.38 8.89a7.7 7.7 0 0 1-4.11-1.87.6.6 0 0 0-.77 0c-.69.58-2.21 1.7-4.12 1.87a.54.54 0 0 0-.5.52V17c0 4.22 4.1 5.72 4.87 5.96q.13.04.26 0C18.9 22.72 23 21.22 23 17v-3.5c0-.28-.22-.5-.5-.52"
]);
const $f342bb1007016cbf$export$2b27dc9bad37790e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_48_color__a)",
            "d": "M24 44a20 20 0 1 0 0-40 20 20 0 0 0 0 40"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_48_color__b)",
            "fillOpacity": ".7",
            "d": "M24 44a20 20 0 1 0 0-40 20 20 0 0 0 0 40"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_48_color__c)",
            "fillOpacity": ".2",
            "d": "M24 44a20 20 0 1 0 0-40 20 20 0 0 0 0 40"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_48_color__d)",
            "fillRule": "evenodd",
            "d": "M18.91 4.65q-1.2 1.62-2.12 3.84A35 35 0 0 0 14.67 16h-9q-.54 1.2-.9 2.5h9.54a49 49 0 0 0 .06 11.5H4.92q.41 1.3.97 2.5h8.87c.48 2.62 1.18 5 2.03 7.01a19 19 0 0 0 2.12 3.84 20 20 0 0 0 10.18 0q1.2-1.62 2.12-3.84a34 34 0 0 0 2.03-7.01h8.87q.57-1.2.97-2.5h-9.45a48 48 0 0 0 .06-11.5h9.54q-.36-1.3-.9-2.5h-9a35 35 0 0 0-2.12-7.51 19 19 0 0 0-2.12-3.84 20 20 0 0 0-10.18 0M17.21 16c.45-2.48 1.1-4.7 1.88-6.54a14 14 0 0 1 2.55-4.17C22.54 4.35 23.34 4 24 4s1.47.35 2.36 1.29c.9.93 1.78 2.33 2.55 4.17A32 32 0 0 1 30.8 16zM24 44c.66 0 1.47-.35 2.36-1.29.9-.93 1.78-2.33 2.55-4.17a31 31 0 0 0 1.79-6.04H17.3a31 31 0 0 0 1.79 6.04 14 14 0 0 0 2.55 4.17c.9.94 1.7 1.29 2.36 1.29m-7.5-20q0 3.15.39 6h14.22a46 46 0 0 0 .06-11.5H16.83a46 46 0 0 0-.33 5.5",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_globe_shield_48_color__e)",
            "d": "M28 40.46q-.54-.77-.94-1.61A11.4 11.4 0 0 1 26 33.9v-5.77c0-.46.37-.83.83-.83q2.34 0 4.6-.86a16 16 0 0 0 4.07-2.28c.3-.21.7-.21 1 0q1.13.85 2.28 1.46 1.38.75 2.78 1.15a13 13 0 0 0 3.6.53c.47 0 .84.37.84.82v5.78c0 5.5-3.29 9.54-9.7 12.04a1 1 0 0 1-.6 0 20 20 0 0 1-5.96-3.52A13 13 0 0 1 28 40.46"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "translate(36.34 34.31)scale(-16.8029)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#003580"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#003580",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(37.28 -31.84 72.03)scale(26.3132 28.544)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".41",
                    "stopColor": "#1b44b1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1b44b1",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_globe_shield_48_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(42.4 -28.95 66.85)scale(27.0932 28.9401)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".45",
                    "stopColor": "#3bd5ff",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".81",
                    "stopColor": "#3bd5ff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_48_color__a",
                "x1": "12.89",
                "x2": "41.78",
                "y1": "10.67",
                "y2": "37.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#29c3ff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2052cb"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_globe_shield_48_color__e",
                "x1": "29.75",
                "x2": "46.03",
                "y1": "24",
                "y2": "45.23",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#62be55"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#1e794a"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$633e06b2b40cc32c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield48Filled', "48", [
    "M28 40.46q-.54-.77-.94-1.61A11.4 11.4 0 0 1 26 33.9v-5.77c0-.46.37-.83.83-.83q2.34 0 4.6-.86a16 16 0 0 0 4.07-2.28c.3-.21.7-.21 1 0q1.13.85 2.28 1.46 1.38.75 2.78 1.15a13 13 0 0 0 3.6.53c.47 0 .84.37.84.82v5.78c0 5.5-3.29 9.54-9.7 12.04a1 1 0 0 1-.6 0 20 20 0 0 1-5.96-3.52A13 13 0 0 1 28 40.46m6.3-17.9-.31.23q-.06-2.2-.3-4.29h9.54a20 20 0 0 1 .73 6.73q-.92-.1-1.84-.38-1.2-.34-2.4-1-1-.52-2.03-1.3c-1-.74-2.38-.74-3.38 0m-8.13 20.36q.32-.3.65-.7A13 13 0 0 1 24 33.9v-1.4h-6.72a30 30 0 0 0 1.93 6.4 13 13 0 0 0 2.62 4.02c.87.83 1.6 1.08 2.17 1.08s1.3-.25 2.17-1.08m.66-17.62q2.32.01 4.67-1.06a50 50 0 0 0-.32-5.74H16.82a47 47 0 0 0 .06 11.5H24v-1.87a2.83 2.83 0 0 1 2.83-2.83M14.36 30a49 49 0 0 1-.06-11.5H4.77A20 20 0 0 0 4.92 30zm-8.47 2.5a20 20 0 0 0 13 10.84c-1.86-2.49-3.33-6.3-4.15-10.84zM28.8 9.1A31 31 0 0 1 30.8 16H17.2a31 31 0 0 1 2.02-6.9 13 13 0 0 1 2.62-4.02C22.7 4.25 23.43 4 24 4s1.3.25 2.17 1.08c.88.84 1.8 2.18 2.62 4.03m4.56 6.9h8.99A20 20 0 0 0 29.1 4.66c1.93 2.58 3.43 6.57 4.24 11.34M5.66 16h9c.8-4.77 2.3-8.76 4.23-11.34A20 20 0 0 0 5.66 16m29.84 8.16-1.2-1.6Z"
]);
const $f342bb1007016cbf$export$30a1dbe7d61c8027 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeShield48Regular', "48", [
    "M24 4a20 20 0 0 1 19.96 21.23 11 11 0 0 1-2.47-.58 18 18 0 0 0-.87-6.15h-7q.3 2.07.36 4.3-1.25.88-2.48 1.44V24q-.01-2.9-.41-5.5H16.91a36 36 0 0 0 .08 11.5H24v2.5h-6.48q.67 2.57 1.64 4.52c1.68 3.36 3.54 4.48 4.84 4.48q.82.02 1.86-.66a13 13 0 0 0 2.2 2.75A20 20 0 1 1 24 4m-9.54 26a39 39 0 0 1-.08-11.5h-7A17.5 17.5 0 0 0 7.56 30zM8.7 32.5a17.6 17.6 0 0 0 9.71 8.09c-1.49-2.01-2.7-4.8-3.46-8.09zM30.6 16q-.68-2.87-1.77-5.02C27.17 7.62 25.3 6.5 24 6.5s-3.16 1.12-4.84 4.48A23 23 0 0 0 17.4 16zm2.57 0h6.4a17.6 17.6 0 0 0-9.98-8.59c1.56 2.11 2.81 5.1 3.58 8.59M18.4 7.41A17.6 17.6 0 0 0 8.43 16h6.4c.77-3.5 2.02-6.48 3.58-8.59m13.01 19.03a16 16 0 0 0 4.08-2.28c.3-.21.7-.21 1 0q1.13.85 2.28 1.46 1.38.75 2.78 1.15 1.78.53 3.6.53c.47 0 .84.37.84.82v5.78c0 5.5-3.29 9.54-9.7 12.04a1 1 0 0 1-.6 0q-4.37-1.7-6.78-4.34-1.16-1.27-1.86-2.75A11.4 11.4 0 0 1 26 33.9v-5.77c0-.46.37-.83.83-.83q2.32 0 4.6-.86"
]);
const $f342bb1007016cbf$export$2e0b53197eb853c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStand20Filled', "20", [
    "M17.5 10a.5.5 0 0 1 0 1h-.57a7 7 0 0 1-5.36 5.82c.76-1.24 1.29-3.36 1.4-5.82h-1c-.08 1.7-.37 3.2-.79 4.3a5 5 0 0 1-.68 1.31V18h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.39a5 5 0 0 1-.68-1.3c-.42-1.1-.7-2.6-.8-4.31h-1c.12 2.46.65 4.58 1.41 5.82A7 7 0 0 1 3.07 11H2.5a.5.5 0 0 1 0-1zM8.43 3.18C7.67 4.42 7.14 6.54 7.03 9H3.06a7 7 0 0 1 5.36-5.82M10 1c.28 0 .5.22.5.5v1.89q.35.43.68 1.3c.42 1.1.7 2.6.8 4.31H8.02c.08-1.7.37-3.2.79-4.3q.33-.9.68-1.31V1.5c0-.28.22-.5.5-.5m1.57 2.18A7 7 0 0 1 16.93 9h-3.95c-.12-2.46-.65-4.58-1.41-5.82"
]);
const $f342bb1007016cbf$export$5ffdf5581e36b3aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStand20Regular', "20", [
    "M10 1c.28 0 .5.22.5.5v1.52a7 7 0 0 1 6.48 6.48h.52a.5.5 0 0 1 0 1h-.52a7 7 0 0 1-6.48 6.48V18h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.02a7 7 0 0 1-6.48-6.48H2.5a.5.5 0 0 1 0-1h.52A7 7 0 0 1 9.5 3.02V1.5c0-.28.22-.5.5-.5m-1.99 9.5c.05 1.62.35 3.04.79 4.06q.37.82.74 1.18c.23.23.38.26.46.26s.23-.03.46-.26q.37-.36.74-1.18c.44-1.02.74-2.44.79-4.06zm-3.99 0a6 6 0 0 0 4.27 5.25c-.72-1.17-1.22-3.07-1.28-5.25zm8.97 0c-.06 2.18-.56 4.08-1.28 5.25a6 6 0 0 0 4.27-5.25zM8.3 4.25A6 6 0 0 0 4.02 9.5h2.99c.06-2.18.56-4.08 1.28-5.25M10 4c-.08 0-.23.03-.46.26q-.37.36-.74 1.18A12 12 0 0 0 8 9.5H12a12 12 0 0 0-.79-4.06q-.37-.82-.74-1.18C10.23 4.03 10.08 4 10 4m1.7.25c.73 1.17 1.23 3.07 1.3 5.25h2.98a6 6 0 0 0-4.27-5.25"
]);
const $f342bb1007016cbf$export$8c1205c3df477ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStar16Filled', "16", [
    "M5.02 11c.1.98.44 1.9.98 2.66A6 6 0 0 1 2.8 11zm0-1H2.34a6 6 0 0 1 0-4h2.78a17 17 0 0 0-.05 3.6zm2.32-4Q6.56 6.54 6 7.32q.03-.69.11-1.32zM9.7 5q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.25.64-.4 1.42zm3.49 0h-2.47q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5M5.27 5H2.8a6 6 0 0 1 3.42-2.73q-.25.42-.45.95-.3.8-.5 1.78m5.23 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.95-5.6H13c.48 0 .69.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 0 1 .96 0z"
]);
const $f342bb1007016cbf$export$5c7af28eddbe6820 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStar16Regular', "16", [
    "M6 13.66A6 6 0 1 1 13.66 6a5.5 5.5 0 0 0-6.32 0H6.18q-.12.62-.16 1.3a5.5 5.5 0 0 0-.93 2.2A12 12 0 0 1 5.16 6H3.42a5 5 0 0 0 0 4h1.6a6 6 0 0 0 0 1H4q.53.7 1.26 1.19.26.8.74 1.47M9.3 4.32C8.88 3.36 8.37 3 8 3s-.88.36-1.31 1.32q-.14.3-.26.68h3.14a6 6 0 0 0-.26-.68M5.38 5a8 8 0 0 1 .66-1.6C5.23 3.75 4.52 4.3 4 5zM12 5a5 5 0 0 0-2.04-1.6q.15.24.26.5.23.5.4 1.1zm-1.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.95-5.6H13c.48 0 .69.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 0 1 .96 0z"
]);
const $f342bb1007016cbf$export$8684706c31985ed0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStar20Filled', "20", [
    "M7.32 6.5q.26-1.32.67-2.32.46-1.1 1-1.66Q9.54 1.98 10 2q.46-.02 1 .52.55.56 1.01 1.66.42 1 .67 2.32zm-.26-2.7q.36-.88.83-1.52A8 8 0 0 0 2.8 6.5h3.5q.28-1.51.76-2.7m5.88 0a7 7 0 0 0-.83-1.52A8 8 0 0 1 17.2 6.5h-3.5q-.27-1.51-.76-2.7m.91 3.7h3.75a8 8 0 0 1 .4 2.75 5.5 5.5 0 0 0-4.02-1.23q-.04-.78-.13-1.52m-.87 1.71a19 19 0 0 0-.14-1.71H7.16a19 19 0 0 0 0 5h2.21a5.5 5.5 0 0 1 3.61-3.29M9.1 13.5H7.32q.26 1.32.67 2.32.46 1.1 1 1.66.54.54 1.01.52.12 0 .23-.03A5.5 5.5 0 0 1 9.1 13.5m-6.29 0c1 2.05 2.85 3.6 5.1 4.22a7 7 0 0 1-.84-1.52q-.49-1.18-.76-2.7zm3.35-1H2.4a8 8 0 0 1 0-5h3.75a21 21 0 0 0 0 5M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.95-5.6H17c.48 0 .68.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 0 1 .96 0z"
]);
const $f342bb1007016cbf$export$ec0bd80bcff72855 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeStar20Regular', "20", [
    "M10.25 18H10a8 8 0 1 1 8-7.75 6 6 0 0 0-1.01-.66 7 7 0 0 0-.45-2.09h-2.73q.12.73.16 1.53-.51.05-.99.18-.05-.9-.19-1.71H7.21a15 15 0 0 0 0 5h2.16q-.19.48-.28 1H7.42q.23.89.56 1.6c.48 1.02 1.04 1.6 1.58 1.81q.28.6.7 1.09m1.77-13.1C11.41 3.6 10.66 3 10 3s-1.4.59-2.02 1.9q-.33.71-.56 1.6h5.16a9 9 0 0 0-.56-1.6M6.4 6.5q.26-1.12.68-2.01.28-.61.64-1.1A7 7 0 0 0 3.94 6.5zM6 10q0-1.31.2-2.5H3.45a7 7 0 0 0 0 5h2.73Q6.01 11.31 6 10m1.07 5.51q-.4-.9-.68-2.01H3.94a7 7 0 0 0 3.77 3.12q-.36-.5-.64-1.1m9-9.01a7 7 0 0 0-3.78-3.12q.36.5.64 1.1.4.9.68 2.02zM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.95-5.6H17c.48 0 .68.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 0 1 .96 0z"
]);
const $f342bb1007016cbf$export$e3f832e386945e24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurface20Filled', "20", [
    "M8.12 7q.18-1.41.58-2.42.32-.83.7-1.23c.24-.27.44-.35.6-.35s.36.08.6.35q.38.4.7 1.23.4 1 .58 2.42zm-.35-2.78q.2-.52.45-.95A6 6 0 0 0 4.34 7h2.78q.19-1.6.65-2.78m4.46 0a6 6 0 0 0-.45-.95A6 6 0 0 1 15.66 7h-2.78q-.19-1.6-.65-2.78M12.97 8h2.95a6 6 0 0 1 0 2h-2.95a17 17 0 0 0 0-2m-.09 3h2.78a6 6 0 0 1-3.88 3.73q.25-.42.45-.95.46-1.19.65-2.78m-2.28 3.65c-.24.27-.44.35-.6.35s-.36-.08-.6-.35a4 4 0 0 1-.7-1.23q-.4-1-.58-2.42h3.76q-.18 1.41-.58 2.42-.32.83-.7 1.23M4.34 11a6 6 0 0 0 3.88 3.73q-.26-.42-.45-.95-.46-1.19-.65-2.78zm2.69-1H4.08a6 6 0 0 1 0-2h2.95a17 17 0 0 0 0 2m1-2a16 16 0 0 0 0 2h3.94a16 16 0 0 0 0-2zM3.5 13h.75q.38.54.84 1H3.9l-.75 3h13.72l-.75-3H14.9q.48-.46.85-1h.75a.5.5 0 0 1 .49.38l1 4a.5.5 0 0 1-.49.62h-15a.5.5 0 0 1-.49-.62l1-4A.5.5 0 0 1 3.5 13"
]);
const $f342bb1007016cbf$export$f8d0d58a537f737c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurface20Regular', "20", [
    "M10 3a6 6 0 1 1 0 12 6 6 0 0 1 0-12m0 11c.25 0 .74-.23 1.23-1.2q.37-.75.58-1.8H8.2q.2 1.05.58 1.8c.5.97.98 1.2 1.23 1.2m-1.95-4h3.9a11 11 0 0 0 0-2h-3.9a11 11 0 0 0 0 2m3.86 3.62A5 5 0 0 0 14.58 11h-1.75a8 8 0 0 1-.92 2.62M12.96 10h1.94a5 5 0 0 0 0-2h-1.94a12 12 0 0 1 0 2M11.9 4.38c.42.68.74 1.59.92 2.62h1.75a5 5 0 0 0-2.67-2.62m-.68.82C10.73 4.23 10.25 4 10 4s-.74.23-1.23 1.2Q8.4 5.95 8.2 7h3.62q-.2-1.05-.58-1.8m-3.14-.82A5 5 0 0 0 5.42 7h1.75c.18-1.03.5-1.94.92-2.62M5 9q0 .52.1 1h1.94a12 12 0 0 1 0-2H5.1Q5 8.48 5 9m.42 2a5 5 0 0 0 2.67 2.62A8 8 0 0 1 7.17 11zM3.5 13h.75q.39.54.85 1H3.9l-.75 3h13.72l-.75-3H14.9q.47-.46.85-1h.75a.5.5 0 0 1 .49.38l1 4a.5.5 0 0 1-.49.62h-15a.5.5 0 0 1-.49-.62l1-4A.5.5 0 0 1 3.5 13"
]);
const $f342bb1007016cbf$export$441117d04853aea5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurface24Filled', "24", [
    "M9.68 7.5c.16-1.26.41-2.39.73-3.3q.43-1.18.9-1.74c.32-.38.55-.46.69-.46s.37.08.69.46q.47.56.9 1.75c.32.9.57 2.03.73 3.29zm-.69-3.79q.27-.75.6-1.36A8.5 8.5 0 0 0 4.04 7.5h4.13c.17-1.43.45-2.72.82-3.79m6.02 0q-.27-.75-.6-1.36a8.5 8.5 0 0 1 5.55 5.15h-4.13a18 18 0 0 0-.82-3.79M15.96 9h4.4a9 9 0 0 1 0 3h-4.4a27 27 0 0 0 0-3m-.13 4.5h4.13a9 9 0 0 1-1.48 2.5l-.02.02a8.6 8.6 0 0 1-4.05 2.63q.33-.6.6-1.36.56-1.62.82-3.79m-3.14 5.04c-.32.38-.55.46-.69.46s-.37-.08-.69-.46a6 6 0 0 1-.9-1.75c-.32-.9-.57-2.03-.73-3.29h4.64a16 16 0 0 1-.73 3.3q-.43 1.18-.9 1.74m-5.54-1.06q1.12.78 2.44 1.17A9 9 0 0 1 9 17.3a18 18 0 0 1-.82-3.79H4.04A9 9 0 0 0 5.52 16l.02.02a9 9 0 0 0 1.61 1.46m.9-5.48H3.62a9 9 0 0 1 0-3h4.41a27 27 0 0 0 0 3m1.5-3a26 26 0 0 0 0 3h4.9a26 26 0 0 0 0-3zM4 16h.25q.6.83 1.33 1.5H4.57l-.83 3h16.52l-.83-3h-1q.73-.67 1.32-1.5H20c.34 0 .63.22.72.55l1.25 4.5a.75.75 0 0 1-.72.95H2.75a.75.75 0 0 1-.72-.95l1.25-4.5A.75.75 0 0 1 4 16"
]);
const $f342bb1007016cbf$export$4a7948a09bf30f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurface24Regular', "24", [
    "M20.5 10.5a8.5 8.5 0 1 0-17 0 8.5 8.5 0 0 0 17 0m-7.03 5.37c-.66 1.42-1.29 1.63-1.47 1.63s-.8-.21-1.47-1.63q-.46-.98-.75-2.37h4.44q-.28 1.39-.75 2.37M9.5 10.5q0-.78.07-1.5h4.86a16 16 0 0 1 0 3H9.57q-.07-.72-.07-1.5m5.07 6.51c.52-.93.93-2.13 1.17-3.51h2.59a7 7 0 0 1-3.76 3.51M15.94 12a18 18 0 0 0 0-3h2.9a7 7 0 0 1 0 3zM5.16 12a7 7 0 0 1 0-3h2.9a18 18 0 0 0 0 3zm3.1 1.5c.24 1.38.65 2.58 1.17 3.51a7 7 0 0 1-3.76-3.51zm5.96-6H9.78q.28-1.39.75-2.37C11.19 3.7 11.82 3.5 12 3.5s.8.21 1.47 1.63q.46.98.75 2.37m4.1 0h-2.58a11 11 0 0 0-1.17-3.51c1.65.65 3 1.91 3.76 3.51m-10.06 0H5.67a7 7 0 0 1 3.76-3.51c-.52.93-.93 2.13-1.17 3.51M4 16h.25q.6.83 1.33 1.5H4.57l-.83 3h16.52l-.83-3h-1q.73-.67 1.32-1.5H20c.34 0 .63.22.72.55l1.25 4.5a.75.75 0 0 1-.72.95H2.75a.75.75 0 0 1-.72-.95l1.25-4.5A.75.75 0 0 1 4 16"
]);
const $f342bb1007016cbf$export$fc3e0c67d2cfade5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurface32Filled', "32", [
    "M18.43 22.35c.54-1.17.98-2.66 1.26-4.35H12.3c.28 1.7.72 3.18 1.26 4.35C14.6 24.55 15.6 25 16 25c.4 0 1.4-.44 2.43-2.65m1.17 2.05c.98-1.6 1.73-3.82 2.11-6.4h4.54a11 11 0 0 1-6.65 6.4m2.33-8.4h4.89a11 11 0 0 0 0-4h-4.9a28 28 0 0 1 0 4M12 14q0 1.03.08 2h7.84a26 26 0 0 0 0-4h-7.84q-.08.97-.08 2m-2 0q0 1.02.07 2H5.18a11 11 0 0 1 0-4h4.9q-.09.98-.08 2m2.4 10.4A11 11 0 0 1 5.75 18h4.54c.38 2.58 1.13 4.8 2.1 6.4M19.69 10c-.28-1.7-.72-3.18-1.26-4.35C17.4 3.45 16.4 3 16 3c-.4 0-1.4.44-2.43 2.65A17 17 0 0 0 12.31 10zm6.56 0h-4.54a17 17 0 0 0-2.1-6.4 11 11 0 0 1 6.64 6.4m-15.96 0H5.75a11 11 0 0 1 6.65-6.4 17 17 0 0 0-2.11 6.4M5 21h.64q.75 1.09 1.69 2H5.75l-1.42 5h23.34l-1.42-5h-1.58q.95-.91 1.69-2H27a1 1 0 0 1 .96.73l2 7A1 1 0 0 1 29 30H3a1 1 0 0 1-.96-1.27l2-7A1 1 0 0 1 5 21"
]);
const $f342bb1007016cbf$export$79185408e3020f85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSurface32Regular', "32", [
    "M17.71 20.95C16.87 22.81 16.11 23 16 23s-.87-.2-1.71-2.05q-.57-1.23-.91-2.95h5.24a14 14 0 0 1-.9 2.95m1.2-4.95h-5.82a22 22 0 0 1 0-4h5.82a22 22 0 0 1 0 4m1.75 2h3.4a9 9 0 0 1-4.83 4.4 15 15 0 0 0 1.43-4.4m4.12-2h-3.86a24 24 0 0 0 0-4h3.86a9 9 0 0 1 0 4m-13.7 0H7.22a9 9 0 0 1 0-4h3.86a24 24 0 0 0 0 4m-3.14 2h3.4c.3 1.72.8 3.23 1.43 4.4A9 9 0 0 1 7.94 18m6.35-10.95C15.13 5.19 15.89 5 16 5s.87.2 1.71 2.05q.57 1.23.91 2.95h-5.24q.34-1.72.9-2.95M20.66 10c-.3-1.72-.8-3.23-1.43-4.4a9 9 0 0 1 4.83 4.4zM7.94 10c1-2.01 2.72-3.6 4.83-4.4a15 15 0 0 0-1.43 4.4zM27 14a11 11 0 1 0-22 0 11 11 0 0 0 22 0M5 21h.64q.75 1.09 1.69 2H5.75l-1.42 5h23.34l-1.42-5h-1.58q.95-.91 1.69-2H27a1 1 0 0 1 .96.73l2 7A1 1 0 0 1 29 30H3a1 1 0 0 1-.96-1.27l2-7A1 1 0 0 1 5 21"
]);
const $f342bb1007016cbf$export$55d620ae2c6ee4fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSync16Filled', "16", [
    "M6.12 6a16 16 0 0 0 0 4h.09a5.5 5.5 0 0 1 3.7-3.76L9.87 6zM5 8q0 1.05.12 2H2.34a6 6 0 0 1 0-4h2.78Q5 6.95 5 8m.27 3H2.8a6 6 0 0 0 3.42 2.73q-.25-.42-.45-.95-.3-.8-.5-1.78m4.44-6q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.25.64-.4 1.42zm1.02 0q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5zM5.27 5H2.8a6 6 0 0 1 3.42-2.73q-.25.42-.45.95-.3.8-.5 1.78M7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $f342bb1007016cbf$export$e991023567b771f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSync16Regular', "16", [
    "M2 8a6 6 0 0 0 4.5 5.81A5.5 5.5 0 0 1 6.2 10h-.02a11 11 0 0 1 0-4h3.64l.04.25q.48-.15.98-.21V6h1.74l.05.12q.63.13 1.18.39A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5M5.16 6a12 12 0 0 0 0 4H3.42a5 5 0 0 1 0-4zm.22 5a8 8 0 0 0 .66 1.6A5 5 0 0 1 4 11zm4.58-7.6c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6M7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a2 2 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $f342bb1007016cbf$export$7fe5a5c925ebcde0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSync20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.52A5.6 5.6 0 0 1 18 10.25a8 8 0 0 0-.4-2.75m-4.77 0a19 19 0 0 1 .14 1.71 5.5 5.5 0 0 0-3.6 3.29H7.15a19 19 0 0 1 0-5zm-5.52 6h1.77a5.5 5.5 0 0 0 1.14 4.47L10 18q-.46.02-1-.52-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m7.61 2a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $f342bb1007016cbf$export$e8738b74be1ebd2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSync20Regular', "20", [
    "M10 18h.25a6 6 0 0 1-.7-1.09c-.53-.2-1.1-.79-1.57-1.82q-.33-.7-.56-1.59h1.67q.1-.52.28-1H7.21a15 15 0 0 1 0-5h5.58q.15.81.19 1.71.48-.14 1-.18-.06-.8-.17-1.53h2.73q.37.99.45 2.1.54.27 1 .65L18 10a8 8 0 1 0-8 8m0-15c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a2 2 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5m-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a2 2 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66"
]);
const $f342bb1007016cbf$export$7bae5bf4135be3c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSync24Filled', "24", [
    "M8.9 16.5h2.18a6.6 6.6 0 0 0 1.55 5.3q-.3.2-.63.2c-1.2 0-2.4-2.1-3.04-5.2zM8.69 15h2.82a6.5 6.5 0 0 1 4-3.68L15.42 10H8.58l-.04.49A26 26 0 0 0 8.68 15m8.82-4c1.73 0 3.3.68 4.47 1.78A10 10 0 0 0 21.8 10h-4.87l.04.66.02.36zM3.07 16.5h4.3c.37 2.08.99 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.75-7.42-.11-.17c3.02.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.95-4.5-1.83-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.89 5.65l-.06.44H2.63a10 10 0 0 1 6.41-6.06M12 2c1.32 0 2.65 2.54 3.22 6.19l.04.31H8.74C9.28 4.7 10.64 2 12 2m0 15.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5M15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19"
]);
const $f342bb1007016cbf$export$6f82fc0b72debfe2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeSync24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 7 7 0 0 0-1.47-1.05q-.03-.9-.23-1.73H16.9l.07 1.02q-.77.06-1.49.3-.02-.68-.1-1.32H8.6a19 19 0 0 0 .14 5h2.76q-.3.71-.42 1.5H9.06c.6 2.22 1.6 3.73 2.66 3.97q.43.83 1.06 1.5-.38.03-.78.03a10 10 0 1 1 0-20M7.51 16.5H4.79a8.5 8.5 0 0 0 4.1 3.41q-.8-1.24-1.28-3.01zM7.09 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.8-5.91h-.03a8.5 8.5 0 0 0-4.6 4.41H7.3c.31-1.75.86-3.28 1.58-4.41m3.11-.6-.11.01c-1.27.12-2.5 2.12-3.06 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zM12 17.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5M15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19"
]);
const $f342bb1007016cbf$export$b1b05d60c60b1196 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76a21 21 0 0 1 .13 3.5h.52c.93 0 1.74.5 2.17 1.26l.5-.4q.33-.24.68-.32a8 8 0 0 0-.25-4.04M13 10q0 .5-.02 1H11.5a2.5 2.5 0 0 0-2.3 1.5H7.17a19 19 0 0 1 0-5h5.68Q13 8.69 13 10m-5.68 3.5H9v3.99q-.55-.57-1.01-1.67-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m7.61 1c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v.53l1.79-1.37a.75.75 0 0 1 1.2.6v4.5c0 .61-.7.97-1.2.59L16 16.97v.53c0 .83-.67 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $f342bb1007016cbf$export$f009497578bf8fa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo20Regular', "20", [
    "M2 10a8 8 0 0 0 7.04 7.94Q9 17.73 9 17.5v-.94q-.54-.46-1.02-1.47-.33-.7-.56-1.59H9q0-.54.2-1h-2a15 15 0 0 1 0-5h5.6a15 15 0 0 1 .17 3.5h1a17 17 0 0 0-.16-3.5h2.73a7 7 0 0 1 .1 4.71l.03.05.5-.4q.33-.24.68-.32Q18 10.8 18 10a8 8 0 1 0-16 0m8-7c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1M10 13.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v.53l1.79-1.37a.75.75 0 0 1 1.2.6v4.5c0 .61-.7.97-1.2.59L16 16.97v.53c0 .83-.67 1.5-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $f342bb1007016cbf$export$4600ca8b892b7a07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo24Filled', "24", [
    "M8.9 16.5H11v5.03c-.83-.79-1.58-2.5-2.04-4.73zM8.67 15h2.38a2.5 2.5 0 0 1 2.45-2h1.98a26 26 0 0 0-.06-3H8.58l-.04.49A26 26 0 0 0 8.67 15m12.1-.58q.5-.37 1.03-.41a10 10 0 0 0 0-4.01h-4.87l.04.66a29 29 0 0 1 .01 2.34h1.52c1 0 1.86.58 2.26 1.43zM3.08 16.5h4.3c.37 2.08.98 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.74-7.42-.1-.17c3.01.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.96-4.5-1.84-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.88 5.65l-.06.44h-4.6a10 10 0 0 1 6.42-6.06M12 2c1.32 0 2.65 2.54 3.21 6.19l.05.31H8.74C9.28 4.7 10.64 2 12 2m0 13.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v.78l1.39-1.07a1 1 0 0 1 1.6.8v4.98a1 1 0 0 1-1.6.8L20 20.72v.78c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $f342bb1007016cbf$export$bea65e31e6e2d56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo24Regular', "24", [
    "M12 2a10 10 0 0 1 9.8 12q-.53.05-1.02.42h-.02a3 3 0 0 0-.45-.64 8.5 8.5 0 0 0-.05-3.78h-3.35a21 21 0 0 1 .07 3h-1.5a19 19 0 0 0-.08-3H8.6a19 19 0 0 0 .14 5h2.31q-.05.24-.05.5v1H9.06c.46 1.7 1.16 3 1.94 3.61v1.39q0 .23.04.46A10 10 0 0 1 12 2M7.5 16.5H4.8a8.5 8.5 0 0 0 4.09 3.41q-.79-1.24-1.27-3.01zM7.1 10H3.73v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.78-5.91h-.02A8.5 8.5 0 0 0 4.25 8.5H7.3c.31-1.75.86-3.28 1.58-4.41m3.12-.6-.12.01c-1.26.12-2.48 2.12-3.05 5h6.34c-.57-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zM12 15.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v.78l1.39-1.07a1 1 0 0 1 1.6.8v4.98a1 1 0 0 1-1.6.8L20 20.72v.78c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5z"
]);
const $f342bb1007016cbf$export$13e1c84c38e49ae5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo28Filled', "28", [
    "M9.5 14q0-1.3.1-2.5h8.8a30 30 0 0 1 .08 3.5H16a3 3 0 0 0-3 3v.5H9.85Q9.5 16.4 9.5 14m15.28 2.42q.51-.38 1.05-.42a12 12 0 0 0-.1-4.5H19.9a32 32 0 0 1 .08 3.5H21a3 3 0 0 1 2.87 2.12zM13 25v-5h-2.86q.35 1.52.84 2.73.69 1.66 1.51 2.5.3.3.6.48A3 3 0 0 1 13 25m-4.67-6.5a30 30 0 0 1-.23-7H2.26a12 12 0 0 0 .61 7zM3.6 20H8.6q.4 1.84 1 3.3.53 1.31 1.24 2.28A12 12 0 0 1 3.6 20M17 5.27c.54 1.3.97 2.91 1.22 4.73H9.77c.25-1.82.68-3.43 1.21-4.73q.69-1.65 1.51-2.5C13.03 2.23 13.54 2 14 2s.97.22 1.5.78q.84.83 1.52 2.49M19.75 10h5.58a12 12 0 0 0-8.16-7.58q.7.97 1.25 2.28C19 6.18 19.48 8 19.74 10M2.68 10h5.58c.26-2 .72-3.82 1.33-5.3q.54-1.31 1.25-2.28A12 12 0 0 0 2.68 10M14 18c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v1.05l2.39-1.84a1 1 0 0 1 1.6.8v7a1 1 0 0 1-1.6.78L23 23.96V25a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2z"
]);
const $f342bb1007016cbf$export$c3880eaa49399270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo28Regular', "28", [
    "M14 3.5c.99 0 2.11.89 3.03 2.86q.64 1.36 1.02 3.14h-8.1q.38-1.79 1.02-3.14C11.89 4.4 13 3.5 14 3.5M9.6 5.73A17 17 0 0 0 8.43 9.5H4.51C5.71 6.97 7.9 5 10.57 4.07q-.54.76-.96 1.66M8.19 11a24 24 0 0 0 0 6H3.93a10.5 10.5 0 0 1 0-6zm.24 7.5c.28 1.4.68 2.69 1.19 3.77q.42.9.96 1.66a10.5 10.5 0 0 1-6.06-5.43zm1.53 0H13V18a3 3 0 0 1 .17-1H9.7a23 23 0 0 1 0-6h8.6a23 23 0 0 1 .18 4h1.5a25 25 0 0 0-.16-4h4.25a10.5 10.5 0 0 1 0 5.96l.7-.54q.52-.38 1.06-.42.17-.98.17-2a12 12 0 1 0-12.84 11.97A3 3 0 0 1 13 25v-.8a5.6 5.6 0 0 1-2.03-2.56 15 15 0 0 1-1.02-3.14m7.48-14.43c2.67.93 4.86 2.9 6.06 5.43h-3.91c-.28-1.4-.68-2.69-1.19-3.77q-.42-.9-.96-1.66M14 18c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v1.05l2.39-1.84a1 1 0 0 1 1.6.8v7a1 1 0 0 1-1.6.78L23 23.96V25a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2z"
]);
const $f342bb1007016cbf$export$b0d1b99935870d0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo32Filled', "32", [
    "M11 16q0-2.1.22-4h9.56a36 36 0 0 1 .19 5.5H18.5a4 4 0 0 0-3.7 2.5h-3.58q-.21-1.9-.22-4m17.07 3.07a2.7 2.7 0 0 1 1.7-.57 14 14 0 0 0-.35-6.5h-6.63a38 38 0 0 1 .18 5.5H24a4 4 0 0 1 3.48 2.03zM14.5 28.5V22h-2.99q.46 2.41 1.18 4.24a9 9 0 0 0 1.9 3.09 4 4 0 0 1-.09-.83M9.21 20a38 38 0 0 1 0-8H2.58a14 14 0 0 0 0 8zm-5.86 2h6.13c.32 1.86.78 3.55 1.35 4.98q.56 1.4 1.27 2.47A14 14 0 0 1 3.35 22M19.3 5.76c.49 1.2.89 2.64 1.18 4.24H11.5q.46-2.41 1.18-4.24a9 9 0 0 1 1.7-2.9C15 2.24 15.53 2 16 2H16c.47 0 1.01.23 1.6.87q.93.95 1.71 2.9m3.2 4.24h6.14a14 14 0 0 0-8.75-7.45q.72 1.08 1.27 2.47A25 25 0 0 1 22.52 10M3.36 10h6.13c.32-1.86.78-3.55 1.35-4.98q.56-1.4 1.27-2.47A14 14 0 0 0 3.35 10M16 21.5a2.5 2.5 0 0 1 2.5-2.5H24a2.5 2.5 0 0 1 2.5 2.5v.68l2.49-1.92a1.25 1.25 0 0 1 2.01 1v7.48a1.25 1.25 0 0 1-2.01 1l-2.49-1.92v.68A2.5 2.5 0 0 1 24 31h-5.5a2.5 2.5 0 0 1-2.5-2.5z"
]);
const $f342bb1007016cbf$export$eb8dae74d160b90f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo32Regular', "32", [
    "M2 16a14 14 0 0 0 12.77 13.95 4 4 0 0 1-.27-1.45v-1.12a7 7 0 0 1-1.83-2.6q-.57-1.23-.96-2.78h2.79v-.5q0-.8.3-1.5h-3.5a26 26 0 0 1 0-8h9.4a26 26 0 0 1 .26 5.5h2a29 29 0 0 0-.24-5.5h4.6a12 12 0 0 1 .16 7.52l.6-.45a2.7 2.7 0 0 1 1.7-.57q.21-1.22.22-2.5a14 14 0 1 0-28 0M16 4c1.03 0 2.28.95 3.33 3.23q.57 1.21.96 2.77h-8.58q.39-1.55.96-2.77C13.72 4.95 14.97 4 16 4m-5.15 2.39q-.74 1.6-1.2 3.61H5.6a12 12 0 0 1 6.13-5.22q-.5.75-.9 1.6M9.28 12a28 28 0 0 0 0 8h-4.6a12 12 0 0 1 0-8zm.37 10q.46 2 1.2 3.61.4.86.89 1.61A12 12 0 0 1 5.6 22zM20.26 4.78c2.6.98 4.76 2.84 6.13 5.22h-4.04q-.46-2-1.2-3.61-.4-.86-.89-1.61M16 21.5a2.5 2.5 0 0 1 2.5-2.5H24a2.5 2.5 0 0 1 2.5 2.5v.68l2.49-1.92a1.25 1.25 0 0 1 2.01 1v7.48a1.25 1.25 0 0 1-2.01 1l-2.49-1.92v.68A2.5 2.5 0 0 1 24 31h-5.5a2.5 2.5 0 0 1-2.5-2.5z"
]);
const $f342bb1007016cbf$export$b434449e3321614 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo48Filled', "48", [
    "M21 41.99V32.5h-3.72a30 30 0 0 0 1.93 6.4q.86 1.9 1.79 3.09M26 27h5.4a48 48 0 0 0-.22-8.5H16.82a47 47 0 0 0 .06 11.5h4.54A5 5 0 0 1 26 27m9 0a5 5 0 0 1 4.58 3h.14l1.65-1.27A3.4 3.4 0 0 1 43.6 28a20 20 0 0 0-.37-9.5H33.7a50 50 0 0 1 .21 8.5zm-20.64 3a49 49 0 0 1-.06-11.5H4.77A20 20 0 0 0 4.92 30zm-8.47 2.5a20 20 0 0 0 13 10.84c-1.86-2.49-3.33-6.3-4.15-10.84zM28.8 9.1A31 31 0 0 1 30.8 16H17.2a31 31 0 0 1 2.02-6.9 13 13 0 0 1 2.62-4.02C22.7 4.25 23.43 4 24 4s1.3.25 2.17 1.08c.88.84 1.8 2.18 2.62 4.03m4.56 6.9h8.99A20 20 0 0 0 29.1 4.66c1.93 2.58 3.43 6.57 4.24 11.34M5.66 16h9c.8-4.77 2.3-8.76 4.23-11.34A20 20 0 0 0 5.66 16M23 32a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v1.84l4.59-3.53a1.5 1.5 0 0 1 2.41 1.2v10.98a1.5 1.5 0 0 1-2.41 1.2L38 40.14V42a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3z"
]);
const $f342bb1007016cbf$export$a95ad4a6733b3299 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeVideo48Regular', "48", [
    "M24 4a20 20 0 0 1 19.6 24c-.76-.03-1.54.2-2.23.73l-.67.51a17.5 17.5 0 0 0-.08-10.74h-7a39 39 0 0 1 .27 8.5h-2.5a38 38 0 0 0-.3-8.5H16.91a36 36 0 0 0 .08 11.5h4.43a5 5 0 0 0-.42 2v.5h-3.48q.67 2.57 1.64 4.52.91 1.79 1.84 2.8V42q0 .97.34 1.83A20 20 0 0 1 24 4m-9.54 26a39 39 0 0 1-.08-11.5h-7A17.5 17.5 0 0 0 7.56 30zM8.7 32.5a17.6 17.6 0 0 0 9.71 8.09c-1.49-2.01-2.7-4.8-3.46-8.09zM30.6 16q-.68-2.87-1.77-5.02C27.17 7.62 25.3 6.5 24 6.5s-3.16 1.12-4.84 4.48A23 23 0 0 0 17.4 16zm2.57 0h6.4a17.6 17.6 0 0 0-9.98-8.59c1.56 2.11 2.81 5.1 3.58 8.59M18.4 7.41A17.6 17.6 0 0 0 8.43 16h6.4c.77-3.5 2.02-6.48 3.58-8.59M23 32a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v1.84l4.59-3.53a1.5 1.5 0 0 1 2.41 1.2v10.98a1.5 1.5 0 0 1-2.41 1.2L38 40.14V42a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3z"
]);
const $f342bb1007016cbf$export$d9a4dce13b18433f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarning16Filled', "16", [
    "M6.12 6a16 16 0 0 0 0 4h2.15L9.7 7.1q.1-.2.24-.37L9.88 6zm1.65 5-.9 1.8-.17-.38q-.25-.63-.4-1.42zM5 8q0 1.05.12 2H2.34a6 6 0 0 1 0-4h2.78Q5 6.95 5 8m.27 3H2.8a6 6 0 0 0 3.42 2.73q-.25-.42-.45-.95-.3-.8-.5-1.78m4.44-6q-.17-.8-.4-1.42a4 4 0 0 0-.7-1.23C8.35 2.08 8.15 2 8 2s-.36.08-.6.35q-.38.4-.7 1.23-.25.64-.4 1.42zm1.02 0q-.2-.99-.5-1.78a6 6 0 0 0-.45-.95A6 6 0 0 1 13.2 5zM5.27 5H2.8a6 6 0 0 1 3.42-2.73q-.25.42-.45.95-.3.8-.5 1.78m5.33 2.55-3.5 7A1 1 0 0 0 8 16h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M12 9.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $f342bb1007016cbf$export$520b7ce659c6ac76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarning16Regular', "16", [
    "M2 8a6 6 0 0 0 4.38 5.78l.7-1.4A6.2 6.2 0 0 1 6.43 11h1.34l.5-1.01h-2.1a11 11 0 0 1 0-4h3.65q.07.37.11.76.39-.48.92-.65L10.84 6h1.74q.1.2.17.43.33.26.54.68l.7 1.37L14 8A6 6 0 0 0 2 8m6-5c.37 0 .88.36 1.31 1.32q.14.3.26.68H6.43q.12-.37.26-.68C7.12 3.36 7.63 3 8 3m-2.22.9q-.23.5-.4 1.1H4a5 5 0 0 1 2.04-1.6q-.14.24-.26.5M5.16 6a12 12 0 0 0 0 4H3.42a5 5 0 0 1 0-4zm.22 5a8 8 0 0 0 .66 1.6A5 5 0 0 1 4 11zm4.58-7.6c.81.35 1.52.9 2.04 1.6h-1.38a8 8 0 0 0-.66-1.6m.64 4.15-3.5 7A1 1 0 0 0 8 16h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M12 9.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $f342bb1007016cbf$export$45a144d4ef914062 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarning20Filled', "20", [
    "M7.99 4.18q-.42 1-.67 2.32h5.36q-.26-1.32-.67-2.32-.46-1.1-1-1.66Q10.46 1.98 10 2q-.46-.02-1 .52-.55.56-1.01 1.66m-.1-1.9q-.47.65-.83 1.52-.49 1.19-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22m4.22 0q.47.65.83 1.52.48 1.19.76 2.7h3.5a8 8 0 0 0-5.09-4.22m5.5 5.22h-3.76q.09.75.13 1.57a2 2 0 0 1 2.31 1.04l1.2 2.39h.11a8 8 0 0 0 0-5m-4.77 0Q13 8.54 13 9.68q-.16.18-.29.43l-1.2 2.39H7.17a19 19 0 0 1 0-5zm-5.52 6h3.7l-1.8 3.6q-.11.23-.16.44L9 17.48q-.55-.56-1.01-1.66-.42-1-.67-2.32m.57 4.22A8 8 0 0 1 2.8 13.5h3.5q.28 1.52.76 2.7.36.88.83 1.52M2.4 12.5h3.76a21 21 0 0 1 0-5H2.4a8 8 0 0 0 0 5m11.21-1.95-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $f342bb1007016cbf$export$303256964052e4a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarning20Regular', "20", [
    "M2 10a8 8 0 0 0 7 7.94 2 2 0 0 1 .22-.84l.14-.28a3.7 3.7 0 0 1-1.38-1.73q-.33-.7-.56-1.59h3.6l.5-1H7.2a15 15 0 0 1 0-5h5.58q.19 1.02.2 2.18.42-.46.98-.61-.04-.82-.16-1.57h2.73a7 7 0 0 1 .34 3.79l.68 1.34A7.99 7.99 0 1 0 2 10m8-7c.66 0 1.4.59 2.02 1.9q.33.71.56 1.6H7.42q.23-.89.56-1.6C8.59 3.6 9.34 3 10 3M7.07 4.49q-.4.9-.68 2.01H3.94A7 7 0 0 1 7.7 3.38q-.36.5-.64 1.1M6.2 7.5a16 16 0 0 0 0 5H3.46a7 7 0 0 1 0-5zm.2 6q.26 1.12.68 2.01.28.61.64 1.1a7 7 0 0 1-3.77-3.11zm5.9-10.12a7 7 0 0 1 3.77 3.12h-2.45a11 11 0 0 0-.68-2.01q-.28-.61-.64-1.1m1.31 7.17-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0M15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $f342bb1007016cbf$export$869df96f586e91a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarning24Filled', "24", [
    "M8.9 16.5h4.3l-1.93 3.88q-.28.57-.27 1.15c-.83-.79-1.58-2.5-2.04-4.73zM8.69 15h5.28l1.3-2.62.24-.38q0-1.04-.07-2H8.58l-.04.49A26 26 0 0 0 8.68 15m11.06-2.62 1.3 2.62h.5a10 10 0 0 0 .26-5h-4.87l.04.66.02.4c1.04-.22 2.2.22 2.75 1.32M3.07 16.5h4.3c.37 2.08.99 3.85 1.8 5.1a10 10 0 0 1-5.96-4.82zM2.2 10h4.87a28 28 0 0 0 .03 4.42l.06.58h-4.7a10 10 0 0 1-.26-5m12.75-7.42-.11-.17c3.02.89 5.44 3.16 6.53 6.09h-4.59c-.31-2.42-.95-4.5-1.83-5.92m-5.9-.14.12-.03a15 15 0 0 0-1.89 5.65l-.06.44H2.63a10 10 0 0 1 6.41-6.06M12 2c1.32 0 2.65 2.54 3.22 6.19l.04.31H8.74C9.28 4.7 10.64 2 12 2m4.16 10.83-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $f342bb1007016cbf$export$e8c1e790969b2c3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GlobeWarning24Regular', "24", [
    "M12 2a10 10 0 0 1 9.34 13.59l-.99-1.98a9 9 0 0 0-.08-3.61H16.9q.05.53.07 1.05c-.57.12-1.1.44-1.48.95q0-1.04-.1-2H8.6a19 19 0 0 0 .14 5h5.22l-.75 1.5H9.06c.52 1.92 1.35 3.32 2.25 3.81l-.04.07a2.5 2.5 0 0 0-.22 1.58A10 10 0 0 1 12 2M7.51 16.5H4.79a8.5 8.5 0 0 0 4.1 3.41q-.8-1.24-1.28-3.01zM7.09 10H3.74v.02a8.5 8.5 0 0 0 .3 4.98h3.18a20 20 0 0 1-.13-5m1.8-5.91h-.03a8.5 8.5 0 0 0-4.6 4.41H7.3c.31-1.75.86-3.28 1.58-4.41m3.11-.6-.11.01c-1.27.12-2.5 2.12-3.06 5h6.34c-.56-2.87-1.78-4.87-3.04-5zm3.12.6.1.17A13 13 0 0 1 16.7 8.5h3.05a8.5 8.5 0 0 0-4.34-4.29zm1.04 8.74-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0M18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0m-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
]);
const $f342bb1007016cbf$export$dfb91971276dd5e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest12Filled', "12", [
    "M3.5 1C2.67 1 2 1.67 2 2.5v7c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-7C10 1.67 9.33 1 8.5 1zm2 1h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 7.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5C8 8.5 7 9 6 9s-2-.5-2-1.5"
]);
const $f342bb1007016cbf$export$f65950c521114cf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest12Regular', "12", [
    "M3.5 1C2.67 1 2 1.67 2 2.5v7c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-7C10 1.67 9.33 1 8.5 1zM3 2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.5 7a.5.5 0 0 0-.5.5C4 8.5 5 9 6 9s2-.5 2-1.5a.5.5 0 0 0-.5-.5zm1-4.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$327635710d60d812 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_16_color__a)",
            "fillRule": "evenodd",
            "d": "M13 2.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 1 3 1.67 3 2.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5zM7 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_16_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M13 2.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 1 3 1.67 3 2.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5zM7 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_16_color__c)",
            "fillOpacity": ".9",
            "d": "M5.7 10c-.34 0-.7.24-.73.66a2 2 0 0 0 .46 1.45C5.9 12.65 6.7 13 8 13s2.1-.35 2.57-.89a2 2 0 0 0 .46-1.45.7.7 0 0 0-.73-.66z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_16_color__d)",
            "fillOpacity": ".9",
            "d": "M6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_16_color__a",
                "x1": "-.33",
                "x2": "13.58",
                "y1": "-2.06",
                "y2": "9.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_16_color__b",
                "x1": "9.55",
                "x2": "14.14",
                "y1": "2.72",
                "y2": "16.7",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_16_color__c",
                "x1": "12.55",
                "x2": "9.7",
                "y1": "15.57",
                "y2": "5.02",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_16_color__d",
                "x1": "11",
                "x2": "4.66",
                "y1": "12.43",
                "y2": ".8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$6238b40481fd1153 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest16Filled', "16", [
    "M13 2.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 1 3 1.67 3 2.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5zm-6.5 1c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.3 3h4.6c.34 0 .7.24.73.66a2 2 0 0 1-.46 1.45C10.1 12.65 9.3 13 8 13s-2.1-.35-2.57-.89a2 2 0 0 1-.46-1.45.7.7 0 0 1 .73-.66"
]);
const $f342bb1007016cbf$export$fd77fed59df15db7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest16Regular', "16", [
    "M8 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2.03 3.66A.7.7 0 0 1 5.7 10h4.6c.34 0 .7.24.73.66a2 2 0 0 1-.46 1.45C10.1 12.65 9.3 13 8 13s-2.1-.35-2.57-.89a2 2 0 0 1-.46-1.45m1.01.34q.04.23.21.46c.2.24.68.54 1.81.54s1.6-.3 1.8-.54a1 1 0 0 0 .22-.46zM7 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm6-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 1 3 1.67 3 2.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5zM4.5 2h7c.28 0 .5.22.5.5v11a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-11c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$6c7ef69d654c849b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__a)",
            "fillRule": "evenodd",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5zm3 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5zm3 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__c)",
            "fillOpacity": ".9",
            "d": "M8.3 15.73q.65.26 1.7.27 1.04 0 1.7-.27c1.8-.66 1.8-2.33 1.8-2.33 0-.77-.64-1.4-1.43-1.4H7.93c-.79 0-1.43.63-1.43 1.4 0 0 0 1.67 1.8 2.33"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_20_color__d)",
            "fillOpacity": ".9",
            "d": "M10 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__a",
                "x1": "0",
                "x2": "16.02",
                "y1": "-1.5",
                "y2": "12.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__b",
                "x1": "11.86",
                "x2": "16.9",
                "y1": "3.97",
                "y2": "20.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__c",
                "x1": "15.25",
                "x2": "10.97",
                "y1": "19.43",
                "y2": "5.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_20_color__d",
                "x1": "13",
                "x2": "6.66",
                "y1": "14.43",
                "y2": "2.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$eff34c175eca528 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest20Filled', "20", [
    "M16 3.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zm-8 1c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M10 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-2.25 5h4.5c.66 0 1.3.55 1.22 1.3a3 3 0 0 1-.79 1.8c-.55.57-1.41.9-2.68.9s-2.13-.33-2.68-.9a3 3 0 0 1-.79-1.8c-.08-.75.56-1.3 1.22-1.3"
]);
const $f342bb1007016cbf$export$29e0844236bccd9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest20Regular', "20", [
    "M8 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3.47 5.3c-.08-.75.56-1.3 1.22-1.3h4.5c.66 0 1.3.55 1.22 1.3a3 3 0 0 1-.79 1.8c-.55.57-1.41.9-2.68.9s-2.13-.33-2.68-.9a3 3 0 0 1-.79-1.8m1.04-.23a.2.2 0 0 0-.04.13c.04.45.18.88.5 1.2.3.32.88.6 1.97.6 1.1 0 1.66-.28 1.98-.6.31-.32.45-.75.5-1.2q0-.07-.05-.13a.3.3 0 0 0-.18-.07h-4.5a.3.3 0 0 0-.18.07M8.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm7.5-.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zM5.5 3h9c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$63a91b4e0ce7d35a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_24_color__a)",
            "fillRule": "evenodd",
            "d": "M20 4.1A2.25 2.25 0 0 0 17.74 2H6.1A2.25 2.25 0 0 0 4 4.26v15.66A2.25 2.25 0 0 0 6.26 22h11.5l.15-.01a2.25 2.25 0 0 0 2.1-2.25V4.1m-9.25.9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_24_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M20 4.1A2.25 2.25 0 0 0 17.74 2H6.1A2.25 2.25 0 0 0 4 4.26v15.66A2.25 2.25 0 0 0 6.26 22h11.5l.15-.01a2.25 2.25 0 0 0 2.1-2.25V4.1m-9.25.9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_24_color__c)",
            "fillOpacity": ".9",
            "d": "M14.75 15c.69 0 1.25.56 1.25 1.25v.5c0 1.84-1.47 2.75-4 2.75s-4-.91-4-2.76v-.5c0-.68.56-1.24 1.25-1.24z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_24_color__d)",
            "fillOpacity": ".9",
            "d": "M12 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_24_color__a",
                "x1": "-1.33",
                "x2": "18.82",
                "y1": "-2.37",
                "y2": "16.45",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_24_color__b",
                "x1": "14.48",
                "x2": "20.45",
                "y1": "4.46",
                "y2": "24.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_24_color__c",
                "x1": "18",
                "x2": "13.24",
                "y1": "23.36",
                "y2": "7.83",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_24_color__d",
                "x1": "15.75",
                "x2": "7.82",
                "y1": "18.28",
                "y2": "3.74",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$6fa2a91ab9791a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest24Filled', "24", [
    "M20 4.1A2.25 2.25 0 0 0 17.74 2H6.1A2.25 2.25 0 0 0 4 4.26v15.66A2.25 2.25 0 0 0 6.26 22h11.5l.15-.01a2.25 2.25 0 0 0 2.1-2.25V4.1M10 5.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75M14.75 15c.69 0 1.25.56 1.25 1.25v.5c0 1.84-1.47 2.75-4 2.75s-4-.91-4-2.76v-.5c0-.68.56-1.24 1.25-1.24zM12 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
]);
const $f342bb1007016cbf$export$65c745cc3aa17a83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest24Regular', "24", [
    "M16 15.25c0-.7-.56-1.25-1.25-1.25h-5.5C8.56 14 8 14.56 8 15.25v.5c0 1.84 1.47 2.75 4 2.75s4-.9 4-2.76zm-6.5.5v-.25h5v.24c0 .83-.7 1.26-2.5 1.26s-2.5-.43-2.5-1.26m5-5.25a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m-3.5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M10.75 5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm9.24-.9A2.25 2.25 0 0 0 17.75 2H6.1A2.25 2.25 0 0 0 4 4.26v15.66A2.25 2.25 0 0 0 6.26 22h11.5l.15-.01a2.25 2.25 0 0 0 2.1-2.25V4.1M6.25 3.5h11.6c.37.06.65.37.65.75v15.6a.75.75 0 0 1-.75.65H6.15a.75.75 0 0 1-.65-.75V4.15a.75.75 0 0 1 .75-.65"
]);
const $f342bb1007016cbf$export$e06caacdde5ef14c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest28Color', "28", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_28_color__a)",
            "fillRule": "evenodd",
            "d": "M20.25 2A2.75 2.75 0 0 1 23 4.75v18.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25V4.75A2.75 2.75 0 0 1 7.75 2zm-7.5 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_28_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M20.25 2A2.75 2.75 0 0 1 23 4.75v18.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25V4.75A2.75 2.75 0 0 1 7.75 2zm-7.5 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_28_color__c)",
            "fillOpacity": ".9",
            "d": "M10.84 16a2.34 2.34 0 0 0-2.34 2.34c0 1.4.64 2.48 1.69 3.18 1.01.68 2.36.98 3.81.98s2.8-.3 3.81-.98a3.7 3.7 0 0 0 1.69-3.18c0-1.3-1.05-2.34-2.34-2.34z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_28_color__d)",
            "fillOpacity": ".9",
            "d": "M10.75 11.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_28_color__a",
                "x1": "-1",
                "x2": "23.03",
                "y1": "-3.25",
                "y2": "17.8",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_28_color__b",
                "x1": "16.79",
                "x2": "24.35",
                "y1": "4.95",
                "y2": "29.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_28_color__c",
                "x1": "22.25",
                "x2": "15.1",
                "y1": "28.07",
                "y2": "5.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_28_color__d",
                "x1": "18.88",
                "x2": "8.57",
                "y1": "20.57",
                "y2": "1.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$c20522f1ce819f9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest28Filled', "28", [
    "M20.25 2A2.75 2.75 0 0 1 23 4.75v18.5A2.75 2.75 0 0 1 20.25 26H7.75A2.75 2.75 0 0 1 5 23.25V4.75A2.75 2.75 0 0 1 7.75 2zM12 5.75c0 .41.34.75.75.75h2.5a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0-.75.75m-1.25 6a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0m.1 4.25a2.34 2.34 0 0 0-2.35 2.34c0 1.4.64 2.48 1.69 3.18 1.01.68 2.36.98 3.81.98s2.8-.3 3.81-.98a3.7 3.7 0 0 0 1.69-3.18c0-1.3-1.05-2.34-2.34-2.34z"
]);
const $f342bb1007016cbf$export$eaf94e34531628dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest28Regular', "28", [
    "M14 8.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-1.75 3.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m-3.75 6.6c0-1.3 1.05-2.35 2.34-2.35h6.32c1.3 0 2.34 1.05 2.34 2.34 0 1.4-.64 2.48-1.69 3.18a7 7 0 0 1-3.81.98c-1.45 0-2.8-.3-3.81-.98a3.7 3.7 0 0 1-1.69-3.18m2.34-.85a.84.84 0 0 0-.84.84c0 .88.37 1.5 1.02 1.93.69.46 1.71.73 2.98.73a5.4 5.4 0 0 0 2.98-.73A2.2 2.2 0 0 0 18 18.34a.84.84 0 0 0-.84-.84zM12.75 5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm7.5-3H7.75A2.75 2.75 0 0 0 5 4.75v18.5A2.75 2.75 0 0 0 7.75 26h12.5A2.75 2.75 0 0 0 23 23.25V4.75A2.75 2.75 0 0 0 20.25 2M6.5 4.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v18.5c0 .69-.56 1.25-1.25 1.25H7.75c-.69 0-1.25-.56-1.25-1.25z"
]);
const $f342bb1007016cbf$export$401ca41ee492dc77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_32_color__a)",
            "fillRule": "evenodd",
            "d": "M23.5 2A3.5 3.5 0 0 1 27 5.5v21a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-21A3.5 3.5 0 0 1 8.5 2zM14 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_32_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M23.5 2A3.5 3.5 0 0 1 27 5.5v21a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-21A3.5 3.5 0 0 1 8.5 2zM14 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_32_color__c)",
            "fillOpacity": ".9",
            "d": "M12.1 20a2.6 2.6 0 0 0-2.6 2.6c0 1.55.84 2.7 2.07 3.41 1.19.7 2.76.99 4.43.99s3.24-.3 4.43-.99a3.9 3.9 0 0 0 2.07-3.42A2.6 2.6 0 0 0 19.9 20z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_32_color__d)",
            "fillOpacity": ".9",
            "d": "M12 15a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_32_color__a",
                "x1": "-2.33",
                "x2": "25.84",
                "y1": "-4.12",
                "y2": "21.73",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_32_color__b",
                "x1": "19.4",
                "x2": "27.89",
                "y1": "5.44",
                "y2": "33.88",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_32_color__c",
                "x1": "25.76",
                "x2": "18.62",
                "y1": "33",
                "y2": "8.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_32_color__d",
                "x1": "22",
                "x2": "9.32",
                "y1": "25.86",
                "y2": "2.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$233fde7be0aa6e72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest32Filled', "32", [
    "M23.5 2A3.5 3.5 0 0 1 27 5.5v21a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-21A3.5 3.5 0 0 1 8.5 2zM13 6a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1m-1 9a4 4 0 1 0 8 0 4 4 0 0 0-8 0m.1 5a2.6 2.6 0 0 0-2.6 2.6c0 1.55.84 2.7 2.07 3.41 1.19.7 2.76.99 4.43.99s3.24-.3 4.43-.99a3.9 3.9 0 0 0 2.07-3.42A2.6 2.6 0 0 0 19.9 20z"
]);
const $f342bb1007016cbf$export$86e95079087825f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest32Regular', "32", [
    "M16 10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-4.5 7.6a2.6 2.6 0 0 1 2.6-2.6h7.8a2.6 2.6 0 0 1 2.6 2.6c0 1.55-.84 2.7-2.07 3.41A9 9 0 0 1 16 26c-1.67 0-3.24-.3-4.43-.99A3.9 3.9 0 0 1 9.5 21.6m2.6-.6a.6.6 0 0 0-.6.6q-.01 1.05 1.07 1.68c.78.45 1.96.72 3.43.72s2.65-.27 3.43-.72q1.08-.62 1.07-1.69a.6.6 0 0 0-.6-.59zM14 6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm9.5-4A3.5 3.5 0 0 1 27 5.5v21a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 26.5v-21A3.5 3.5 0 0 1 8.5 2zM7 5.5v21c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-21c0-.83-.67-1.5-1.5-1.5h-15C7.67 4 7 4.67 7 5.5"
]);
const $f342bb1007016cbf$export$edef5cd641447595 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest48Color', "48", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_48_color__a)",
            "fillRule": "evenodd",
            "d": "M35.75 4C38.1 4 40 5.9 40 8.25v31.5C40 42.1 38.1 44 35.75 44h-23.5A4.25 4.25 0 0 1 8 39.75V8.25C8 5.9 9.9 4 12.25 4zm-14.5 5a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 1 0 0-2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_48_color__b)",
            "fillOpacity": ".7",
            "fillRule": "evenodd",
            "d": "M35.75 4C38.1 4 40 5.9 40 8.25v31.5C40 42.1 38.1 44 35.75 44h-23.5A4.25 4.25 0 0 1 8 39.75V8.25C8 5.9 9.9 4 12.25 4zm-14.5 5a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 1 0 0-2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_48_color__c)",
            "fillOpacity": ".9",
            "d": "M17.8 28a3.8 3.8 0 0 0-3.8 3.8c0 2.4 1.2 4.27 3.07 5.48C18.9 38.45 21.35 39 24 39s5.1-.55 6.93-1.72A6.3 6.3 0 0 0 34 31.8c0-2.1-1.7-3.8-3.8-3.8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_guest_48_color__d)",
            "fillOpacity": ".9",
            "d": "M18.5 20.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_48_color__a",
                "x1": "-2.67",
                "x2": "37.64",
                "y1": "-4.75",
                "y2": "32.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#36dff1"
                }
            ],
            [
                "stop",
                {
                    "offset": ".22",
                    "stopColor": "#35daf1"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#2764e7"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_48_color__b",
                "x1": "28.95",
                "x2": "40.9",
                "y1": "8.91",
                "y2": "49.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".55",
                    "stopColor": "#ff6ce8",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#ff6ce8"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_48_color__c",
                "x1": "39.01",
                "x2": "27.59",
                "y1": "48.43",
                "y2": "10.35",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_guest_48_color__d",
                "x1": "32.25",
                "x2": "14.81",
                "y1": "35.43",
                "y2": "3.44",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#9deaff"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fff"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$d9b22cfc625f3649 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest48Filled', "48", [
    "M35.75 4C38.1 4 40 5.9 40 8.25v31.5C40 42.1 38.1 44 35.75 44h-23.5A4.25 4.25 0 0 1 8 39.75V8.25C8 5.9 9.9 4 12.25 4zM20 10.25c0 .69.56 1.25 1.25 1.25h5.5a1.25 1.25 0 1 0 0-2.5h-5.5c-.69 0-1.25.56-1.25 1.25M18.5 20.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0m-.7 7.5a3.8 3.8 0 0 0-3.8 3.8c0 2.4 1.2 4.27 3.07 5.48C18.9 38.45 21.35 39 24 39s5.1-.55 6.93-1.72A6.3 6.3 0 0 0 34 31.8c0-2.1-1.7-3.8-3.8-3.8z"
]);
const $f342bb1007016cbf$export$d8609d7eebe75f09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Guest48Regular', "48", [
    "M24 15a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m-3 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-7 11.3c0-2.1 1.7-3.8 3.8-3.8h12.4c2.1 0 3.8 1.7 3.8 3.8 0 2.4-1.2 4.27-3.07 5.48C29.1 38.45 26.65 39 24 39s-5.1-.55-6.93-1.72A6.3 6.3 0 0 1 14 31.8m3.8-1.3c-.72 0-1.3.58-1.3 1.3 0 1.46.68 2.57 1.93 3.37 1.3.84 3.22 1.33 5.57 1.33s4.28-.5 5.57-1.33a3.8 3.8 0 0 0 1.93-3.37c0-.72-.58-1.3-1.3-1.3zM21.25 9a1.25 1.25 0 1 0 0 2.5h5.5a1.25 1.25 0 1 0 0-2.5zm14.5-5C38.1 4 40 5.9 40 8.25v31.5C40 42.1 38.1 44 35.75 44h-23.5A4.25 4.25 0 0 1 8 39.75V8.25C8 5.9 9.9 4 12.25 4zM10.5 8.25v31.5c0 .97.78 1.75 1.75 1.75h23.5c.97 0 1.75-.78 1.75-1.75V8.25c0-.97-.78-1.75-1.75-1.75h-23.5c-.97 0-1.75.78-1.75 1.75"
]);
const $f342bb1007016cbf$export$fd68c98820f54b4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestAdd20Filled', "20", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-1.24-3.08 3.5 3.5 0 0 1-1.59-.69 2.5 2.5 0 0 1-.93-1.98c0-.69.56-1.25 1.25-1.25h2.5A5.5 5.5 0 0 1 16 9.2V4a2 2 0 0 0-2-2zm2.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1M8 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $f342bb1007016cbf$export$867395be8c1d2105 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestAdd20Regular', "20", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a6 6 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02q.51.05 1 .19V4a2 2 0 0 0-2-2zm1.75 9h2.5q-.38.46-.65 1H7.75a.25.25 0 0 0-.25.25q0 .73.57 1.2.35.3.96.45a6 6 0 0 0-.01 1.02 3.5 3.5 0 0 1-1.59-.69 2.5 2.5 0 0 1-.93-1.98c0-.69.56-1.25 1.25-1.25m.75-7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM9 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15z"
]);
const $f342bb1007016cbf$export$938e6aa9a7ee20de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestAdd24Filled', "24", [
    "M6.25 2C5.01 2 4 3 4 4.25v15.5C4 20.99 5 22 6.25 22h6.56a6.5 6.5 0 0 1-1.8-4.08 4 4 0 0 1-1.85-.77A3 3 0 0 1 8 14.75c0-.97.78-1.75 1.75-1.75h3.06A6.5 6.5 0 0 1 20 11.5V4.25C20 3.01 19 2 17.75 2zM12 6.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-1.75-3h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5M23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $f342bb1007016cbf$export$a66193a30599977a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GuestAdd24Regular', "24", [
    "M6.25 2C5.01 2 4 3 4 4.25v15.5C4 20.99 5 22 6.25 22h6.56a7 7 0 0 1-1.08-1.5H6.25a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75h11.5c.41 0 .75.34.75.75v6.83q.79.12 1.5.42V4.25C20 3.01 19 2 17.75 2zm3.5 11h3.06q-.65.67-1.08 1.5H9.75a.25.25 0 0 0-.25.25q0 .78.59 1.22.36.3 1 .44a7 7 0 0 0-.08 1.51 4 4 0 0 1-1.85-.77A3 3 0 0 1 8 14.75c0-.97.78-1.75 1.75-1.75M12 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m.75-5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0m-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1z"
]);
const $f342bb1007016cbf$export$787107512988a50d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow16Filled', "16", [
    "m4.77 2.92.24-.13A7 7 0 0 1 8 2a6.4 6.4 0 0 1 3.22.92h.01a.5.5 0 0 0 .54-.84h-.01l-.02-.02-.28-.16A8 8 0 0 0 8 1a7.4 7.4 0 0 0-3.74 1.06l-.02.01a.5.5 0 0 0 .53.85M4 4a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm10 1.5a.5.5 0 0 0-.8-.4l-2 1.5a.5.5 0 0 0-.2.4v2q0 .25.2.4l2 1.5a.5.5 0 0 0 .8-.4zm-9.23 7.58a.5.5 0 0 0-.54.84h.01l.02.02.28.16A8 8 0 0 0 8 15a7.4 7.4 0 0 0 3.74-1.06l.02-.01a.5.5 0 0 0-.53-.85l-.24.13A7 7 0 0 1 8 14a6.4 6.4 0 0 1-3.22-.92z"
]);
const $f342bb1007016cbf$export$6bab1915b7350aea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow16Regular', "16", [
    "m4.77 2.92.24-.13A7 7 0 0 1 8 2a6.4 6.4 0 0 1 3.22.92h.01a.5.5 0 0 0 .54-.84h-.01l-.02-.02-.28-.16A8 8 0 0 0 8 1a7.4 7.4 0 0 0-3.74 1.06l-.02.01a.5.5 0 0 0 .53.85M4 4a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4.5a2 2 0 0 0 2-2v-.14l2.75 1.57A.5.5 0 0 0 14 11V5a.5.5 0 0 0-.75-.43L10.5 6.14V6a2 2 0 0 0-2-2zm6.5 3.29L13 5.86v4.28L10.5 8.7zM3 6a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1.77 7.08a.5.5 0 0 0-.54.84h.01l.02.02.28.16A8 8 0 0 0 8 15a7.4 7.4 0 0 0 3.74-1.06l.02-.01a.5.5 0 0 0-.53-.85l-.24.13A7 7 0 0 1 8 14a6.4 6.4 0 0 1-3.22-.92z"
]);
const $f342bb1007016cbf$export$5bda7fa277a108f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow20Filled', "20", [
    "M6.9 2.03a7 7 0 0 0-1.15.54h-.02v.01L6 3l-.28-.42a.5.5 0 0 0 .56.84l.22-.13q.25-.14.73-.32A8 8 0 0 1 10 2.5a8 8 0 0 1 3.5.79l.22.12.26-.39-.26.4a.5.5 0 1 0 .56-.84L14 3l.28-.42h-.01l-.02-.01-.3-.17q-.3-.16-.84-.37A9 9 0 0 0 10 1.5a9 9 0 0 0-3.1.53m-.01 15.94c.73.27 1.8.53 3.11.53a9 9 0 0 0 3.96-.9l.29-.17h.02v-.01L14 17l.28.42a.5.5 0 0 0-.56-.84l.26.4-.26-.4-.22.13q-.25.14-.73.32a8 8 0 0 1-2.77.47 8 8 0 0 1-3.5-.79l-.22-.12a.5.5 0 0 0-.56.83L6 17l-.28.42h.01l.02.01.3.17q.3.16.84.37M2.5 7v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2m11 4.55 2.78 2.26a.75.75 0 0 0 1.22-.59V6.78a.75.75 0 0 0-1.22-.59L13.5 8.45z"
]);
const $f342bb1007016cbf$export$d5daaf23defd2d85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow20Regular', "20", [
    "M5 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-1.03l2.84 1.85a.75.75 0 0 0 1.16-.63V6.8c0-.6-.66-.95-1.16-.63L13 8.03V7a2 2 0 0 0-2-2zm8 4.22 3-1.95v5.46l-3-1.95zM12 7v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1M6.9 2.03a7 7 0 0 0-1.15.54h-.02v.01L6 3l-.28-.42a.5.5 0 0 0 .56.84l.22-.13q.25-.14.73-.32A8 8 0 0 1 10 2.5a8 8 0 0 1 3.5.79l.22.12.26-.39-.26.4a.5.5 0 1 0 .56-.84L14 3l.28-.42h-.01l-.02-.01-.3-.17q-.3-.16-.84-.37A9 9 0 0 0 10 1.5a9 9 0 0 0-3.1.53m-.01 15.94c.73.27 1.8.53 3.11.53a9 9 0 0 0 3.96-.9l.29-.17h.02v-.01L14 17l.28.42a.5.5 0 0 0-.56-.84l.26.4-.26-.4-.22.13q-.25.14-.73.32a8 8 0 0 1-2.77.47 8 8 0 0 1-3.5-.79l-.22-.12a.5.5 0 0 0-.56.83L6 17l-.28.42h.01l.02.01.3.17q.3.16.84.37m6.83-1.39"
]);
const $f342bb1007016cbf$export$94007049cad66a49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow24Filled', "24", [
    "M7.96 2.52A15 15 0 0 1 12 2a15 15 0 0 1 5.16.9l.42.18c.04.02-.55 1.12 0 0a.75.75 0 0 1-.66 1.34h-.01l-.3-.13q-.32-.13-.97-.32c-.85-.23-2.1-.47-3.64-.47a14 14 0 0 0-4.61.79l-.3.13a.75.75 0 1 1-.68-1.34h.02l.02-.02.39-.16q.39-.16 1.12-.38M6.75 20.25l-.33.67.03.02.39.16q.4.16 1.12.37c.96.27 2.34.53 4.04.53a15 15 0 0 0 5.16-.9l.39-.16.02-.01h.01l-.33-.68.34.67a.75.75 0 0 0-.68-1.34l-.3.13q-.32.13-.97.32c-.85.23-2.1.47-3.64.47a14 14 0 0 1-4.61-.8l-.3-.12a.75.75 0 0 0-.67 1.34zM6.25 6.5C5.01 6.5 4 7.5 4 8.75v6.5c0 1.24 1 2.25 2.25 2.25h6.5c1.24 0 2.25-1 2.25-2.25v-6.5c0-1.24-1-2.25-2.25-2.25zm13.02 9.83L16 13.6v-3.2l3.27-2.72a.75.75 0 0 1 1.23.57v7.5a.75.75 0 0 1-1.23.58"
]);
const $f342bb1007016cbf$export$e8abe397486a337c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow24Regular', "24", [
    "M6.75 6.5c-1.24 0-2.25 1-2.25 2.25v6.5c0 1.24 1 2.25 2.25 2.25h6.5c1.24 0 2.25-1 2.25-2.25v-.73l3.39 1.89a.75.75 0 0 0 1.11-.66v-7.5a.75.75 0 0 0-1.11-.65L15.5 9.48v-.73c0-1.24-1-2.25-2.25-2.25zm8.75 4.7 3-1.67v4.95l-3-1.67zM14 8.74v6.5c0 .41-.34.75-.75.75h-6.5a.75.75 0 0 1-.75-.75v-6.5c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75M6.42 20.92l.03.02.39.16q.4.16 1.12.37c.96.27 2.34.53 4.04.53a15 15 0 0 0 5.16-.9l.39-.16c.34-.16.54-.68.37-1.03a.75.75 0 0 0-1-.33h-.02l-.29.13q-.32.13-.97.32c-.85.23-2.1.47-3.64.47a14 14 0 0 1-4.61-.8l-.3-.12a.75.75 0 0 0-.67 1.34m1.54-18.4A15 15 0 0 1 12 2a15 15 0 0 1 5.16.9l.39.16.02.01h.01s.6.36.34 1.02a.75.75 0 0 1-1 .33h-.01l-.3-.13q-.32-.13-.97-.32c-.85-.23-2.1-.47-3.64-.47a14 14 0 0 0-4.61.79l-.3.13a.75.75 0 1 1-.68-1.34h.02l.02-.02.39-.16q.39-.16 1.12-.38m-.87 1.9"
]);
const $f342bb1007016cbf$export$e8864d27189fe127 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow28Filled', "28", [
    "M14 3.5a19 19 0 0 0-5.68.83l-.26.1a.75.75 0 0 1-.61-1.37s.24-.1 0 0l.03-.01.34-.13q.35-.13.99-.3C9.91 2.32 11.68 2 14 2s4.08.33 5.2.62a12 12 0 0 1 1.32.43l.02.01h.01a.75.75 0 0 1-.6 1.38h-.01l-.26-.1q-.29-.11-.87-.27c-1-.26-2.63-.57-4.81-.57M4 9.75A2.75 2.75 0 0 1 6.75 7h8.5A2.75 2.75 0 0 1 18 9.75v8.5A2.75 2.75 0 0 1 15.25 21h-8.5A2.75 2.75 0 0 1 4 18.25zm15 6.73 3.4 3.18c.8.75 2.1.18 2.1-.91v-9.5c0-1.1-1.3-1.66-2.1-.9L19 11.51zm-9.8 7.45c.99.26 2.62.57 4.8.57a19 19 0 0 0 5.68-.83l.21-.08.05-.02a.75.75 0 0 1 .61 1.37h-.03l-.34.14q-.34.13-.99.3c-1.1.3-2.87.62-5.19.62s-4.08-.33-5.19-.62a12 12 0 0 1-1.33-.43l-.02-.01h-.01c.24.1 0 0 0 0a.75.75 0 0 1 .6-1.38h.01l.05.03.2.08q.3.1.88.26"
]);
const $f342bb1007016cbf$export$e499ff23ffe38b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow28Regular', "28", [
    "M14 3.5a19 19 0 0 0-5.68.83l-.26.1a.75.75 0 0 1-.61-1.37s.24-.1 0 0l.03-.01.34-.13q.35-.13.99-.3C9.91 2.32 11.68 2 14 2s4.08.33 5.2.62a12 12 0 0 1 1.32.43l.02.01h.01a.75.75 0 0 1-.6 1.38h-.01l-.26-.1q-.29-.11-.87-.27c-1-.26-2.63-.57-4.81-.57M7.25 7A2.75 2.75 0 0 0 4.5 9.75v8.5A2.75 2.75 0 0 0 7.25 21h8.5a2.75 2.75 0 0 0 2.75-2.75v-1.11l4.07 2.65c.83.55 1.93-.05 1.93-1.04v-9.5c0-.99-1.1-1.59-1.93-1.04l-4.07 2.65V9.75A2.75 2.75 0 0 0 15.75 7zm11.25 5.66L23 9.72v8.56l-4.5-2.94zM6 9.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25zm3.2 14.18c.99.26 2.62.57 4.8.57a19 19 0 0 0 5.68-.83l.21-.08.05-.02a.75.75 0 0 1 .61 1.37h-.03l-.34.14q-.34.13-.99.3c-1.1.3-2.87.62-5.19.62s-4.08-.33-5.19-.62a12 12 0 0 1-1.33-.43l-.02-.01h-.01c.24.1 0 0 0 0a.75.75 0 0 1 .6-1.38h.01l.05.03.2.08q.3.1.88.26"
]);
const $f342bb1007016cbf$export$d8f8cb13151c0aa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow32Filled', "32", [
    "M7.49 3.64A1 1 0 0 0 8.5 5.36l.07-.04.3-.14q.42-.2 1.33-.47C11.43 4.36 13.34 4 16 4s4.57.36 5.79.71a11 11 0 0 1 1.7.65 1 1 0 0 0 1.02-1.72l-.02-.01a4 4 0 0 0-.56-.28q-.54-.25-1.6-.56C20.94 2.39 18.85 2 16 2s-4.93.39-6.34.79a13 13 0 0 0-2.15.84zM3.5 11A3.5 3.5 0 0 1 7 7.5h10a3.5 3.5 0 0 1 3.5 3.5v10a3.5 3.5 0 0 1-3.5 3.5H7A3.5 3.5 0 0 1 3.5 21zM22 18.57l3.97 3.16c.82.65 2.03.07 2.03-.98v-9.5c0-1.05-1.2-1.63-2.03-.98L22 13.43zM7.14 27a1 1 0 0 0 .35 1.37h.02l.15.1.41.19q.55.25 1.6.56c1.4.4 3.49.79 6.33.79s4.93-.39 6.34-.79a13 13 0 0 0 2.12-.82l.03-.02h.02v-.01a1 1 0 0 0-1.02-1.72l-.07.04-.3.14q-.42.2-1.33.47c-1.22.35-3.13.71-5.79.71s-4.57-.36-5.79-.71a11 11 0 0 1-1.7-.65 1 1 0 0 0-1.37.35"
]);
const $f342bb1007016cbf$export$f42ee837e7abdd56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow32Regular', "32", [
    "M7.49 3.64A1 1 0 0 0 8.5 5.36l.07-.04.3-.14q.42-.2 1.33-.47C11.43 4.36 13.34 4 16 4s4.57.36 5.79.71a11 11 0 0 1 1.7.65 1 1 0 0 0 1.02-1.72l-.02-.01a4 4 0 0 0-.56-.28q-.54-.25-1.6-.56C20.94 2.39 18.85 2 16 2s-4.93.39-6.34.79a13 13 0 0 0-2.15.84zM7.5 7.5A3.5 3.5 0 0 0 4 11v10a3.5 3.5 0 0 0 3.5 3.5h10A3.5 3.5 0 0 0 21 21v-2.03l4.74 2.8c1 .6 2.26-.12 2.26-1.29v-8.97a1.5 1.5 0 0 0-2.16-1.34L21 12.55V11a3.5 3.5 0 0 0-3.5-3.5zM21 14.78l5-2.46v7.29l-5-2.96zM6 11c0-.83.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5v10c0 .83-.67 1.5-1.5 1.5h-10A1.5 1.5 0 0 1 6 21zm1.14 15.99a1 1 0 0 0 .35 1.37h.02l.15.1.41.19q.55.25 1.6.56c1.4.4 3.49.79 6.33.79s4.93-.39 6.34-.79a13 13 0 0 0 2.12-.82l.03-.02h.02v-.01a1 1 0 0 0-1.02-1.72l-.07.04-.3.14q-.42.2-1.33.47c-1.22.35-3.13.71-5.79.71s-4.57-.36-5.79-.71a11 11 0 0 1-1.7-.65 1 1 0 0 0-1.37.35"
]);
const $f342bb1007016cbf$export$97f2cc98aba3891b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow48Filled', "48", [
    "m13.88 8.83.03-.02a6 6 0 0 1 .64-.32q.7-.33 2.03-.8A23.6 23.6 0 0 1 34.1 8.8l.03.02a1.25 1.25 0 0 0 1.26-2.16l-.02-.01-.22-.12-.62-.31q-.82-.4-2.31-.92a26 26 0 0 0-19.35 1.23l-.22.12h-.01l-.01.01s.18-.1 0 0a1.25 1.25 0 0 0 1.26 2.16M8 17.06a4.56 4.56 0 0 1 4.56-4.56h12.88A4.56 4.56 0 0 1 30 17.06v13.88a4.56 4.56 0 0 1-4.56 4.56H12.56A4.56 4.56 0 0 1 8 30.94zm24 10.5 6.14 5.04c1.14.93 2.86.12 2.86-1.36V16.76a1.75 1.75 0 0 0-2.86-1.36L32 20.45zM13.88 39.16a1.25 1.25 0 0 0-1.26 2.16c.29.16 0 0 0 0l.02.01.05.03a9 9 0 0 0 .8.4q.8.4 2.3.92a26 26 0 0 0 19.35-1.23l.17-.1.05-.02h.02v-.01a1.25 1.25 0 0 0-1.26-2.16l-.03.02a6 6 0 0 1-.64.32q-.7.33-2.03.8A23.6 23.6 0 0 1 13.9 39.2z"
]);
const $f342bb1007016cbf$export$562bfdd0c0ad72af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MeetNow48Regular', "48", [
    "m13.88 8.83.03-.02a6 6 0 0 1 .64-.32q.7-.33 2.03-.8A23.6 23.6 0 0 1 34.1 8.8l.03.02a1.25 1.25 0 0 0 1.26-2.16l-.02-.01-.22-.12-.62-.31q-.82-.4-2.31-.92a26 26 0 0 0-19.35 1.23l-.22.12h-.01l-.01.01s.18-.1 0 0a1.25 1.25 0 0 0 1.26 2.16m-1.32 3.67h13.88A4.56 4.56 0 0 1 31 17.06v1.52l5.62-3.28c1.5-.87 3.38.21 3.38 1.95v13.5a2.25 2.25 0 0 1-3.38 1.95L31 29.42v1.52a4.56 4.56 0 0 1-4.56 4.56H12.56A4.56 4.56 0 0 1 8 30.94V17.06a4.56 4.56 0 0 1 4.56-4.56M31 21.47v5.06l6.5 3.79V17.68zm-20.5-4.41v13.88c0 1.14.92 2.06 2.06 2.06h13.88c1.14 0 2.06-.92 2.06-2.06V17.06c0-1.14-.92-2.06-2.06-2.06H12.56c-1.14 0-2.06.92-2.06 2.06m3.38 22.11a1.25 1.25 0 0 0-1.26 2.16c.29.16 0 0 0 0l.02.01.05.03a9 9 0 0 0 .8.4q.8.4 2.3.92a26 26 0 0 0 19.35-1.23l.17-.1.05-.02h.02v-.01a1.25 1.25 0 0 0-1.26-2.16l-.03.02a6 6 0 0 1-.64.32q-.7.33-2.03.8A23.6 23.6 0 0 1 13.9 39.2z"
]);
const $f342bb1007016cbf$export$3401756ec236f895 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mold20Filled', "20", [
    "M13 1c.28 0 .5.22.5.5v1.51a4 4 0 0 1 2 .78l1.65-1.64a.5.5 0 0 1 .7.7L16.21 4.5c.46.6.72 1.3.78 2.01h1.51a.5.5 0 0 1 0 1h-1.56a4 4 0 0 1-1.06 2l-1.33 1.34 1.3 1.3a.5.5 0 0 1-.7.71l-1.31-1.3-2.3 2.29 1.31 1.3a.5.5 0 0 1-.7.71l-1.31-1.3-1.34 1.33a4 4 0 0 1-2 1.06v1.56a.5.5 0 0 1-1 0v-1.51a4 4 0 0 1-2-.78l-1.65 1.65a.5.5 0 0 1-.7-.71l1.64-1.64A4 4 0 0 1 3 13.5H1.5a.5.5 0 0 1 0-1h1.56a4 4 0 0 1 1.06-2l1.33-1.34-1.3-1.3a.5.5 0 1 1 .7-.71l1.31 1.3 2.3-2.29-1.31-1.3a.5.5 0 1 1 .7-.71l1.31 1.3 1.34-1.33a4 4 0 0 1 2-1.06V1.5c0-.28.22-.5.5-.5M6.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M14 6.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
]);
const $f342bb1007016cbf$export$577969d08e4a57ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mold20Regular', "20", [
    "M13.5 1.5a.5.5 0 0 0-1 0v1.56a4 4 0 0 0-2 1.06L9.16 5.45l-1.3-1.3a.5.5 0 1 0-.71.7l1.3 1.31-2.29 2.3-1.3-1.31a.5.5 0 1 0-.71.7l1.3 1.31-1.33 1.34a4 4 0 0 0-1.06 2H1.5a.5.5 0 0 0 0 1h1.51c.06.71.32 1.41.78 2l-1.65 1.65a.5.5 0 1 0 .71.7l1.64-1.64c.6.46 1.3.72 2.01.78v1.51a.5.5 0 0 0 1 0v-1.56a4 4 0 0 0 2-1.06l1.34-1.33 1.3 1.3a.5.5 0 0 0 .71-.7l-1.3-1.31 2.29-2.3 1.3 1.31a.5.5 0 0 0 .71-.7l-1.3-1.31 1.33-1.34a4 4 0 0 0 1.06-2h1.56a.5.5 0 0 0 0-1h-1.51a4 4 0 0 0-.78-2l1.64-1.65a.5.5 0 0 0-.7-.7L15.5 3.79A4 4 0 0 0 13.5 3zM4 13.24v-.1c.01-.7.29-1.4.82-1.94l6.38-6.38a2.8 2.8 0 0 1 3.98 3.98l-6.39 6.38A2.8 2.8 0 0 1 4 13.24m2.75.76a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M14 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
]);
const $f342bb1007016cbf$export$8bccd9bd452b6805 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mold24Filled', "24", [
    "M16.25 2.25a.75.75 0 0 0-1.5 0v1.82c-.85.16-1.67.57-2.33 1.23l-.78.78-1.36-1.36a.75.75 0 1 0-1.06 1.06l1.36 1.36-3.44 3.44-1.36-1.36a.75.75 0 0 0-1.06 1.06l1.36 1.36-.78.78a4.4 4.4 0 0 0-1.22 2.33H2.25a.75.75 0 0 0 0 1.5h1.8q.15 1 .77 1.87l-1.6 1.6a.75.75 0 1 0 1.06 1.06l1.6-1.6q.86.6 1.87.77v1.8a.75.75 0 0 0 1.5 0v-1.82a4.4 4.4 0 0 0 2.33-1.23l.78-.78 1.36 1.36a.75.75 0 1 0 1.06-1.06l-1.36-1.36 3.44-3.44 1.36 1.36a.75.75 0 1 0 1.06-1.06l-1.36-1.36.78-.78a4.4 4.4 0 0 0 1.23-2.33h1.82a.75.75 0 0 0 0-1.5h-1.8q-.16-1-.76-1.88l1.59-1.59a.75.75 0 0 0-1.06-1.06l-1.6 1.6a4.4 4.4 0 0 0-1.87-.77zM8.5 16.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m8-8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $f342bb1007016cbf$export$fb3fad3c89f3830a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mold24Regular', "24", [
    "M16.25 2.25a.75.75 0 0 0-1.5 0v1.82c-.85.16-1.67.57-2.33 1.23l-.78.78-1.36-1.36a.75.75 0 1 0-1.06 1.06l1.36 1.36-3.44 3.44-1.36-1.36a.75.75 0 0 0-1.06 1.06l1.36 1.36-.78.78a4.4 4.4 0 0 0-1.22 2.33H2.25a.75.75 0 0 0 0 1.5h1.8q.15 1 .77 1.87l-1.6 1.6a.75.75 0 1 0 1.06 1.06l1.6-1.6q.86.6 1.87.77v1.8a.75.75 0 0 0 1.5 0v-1.82a4.4 4.4 0 0 0 2.33-1.23l.78-.78 1.36 1.36a.75.75 0 1 0 1.06-1.06l-1.36-1.36 3.44-3.44 1.36 1.36a.75.75 0 1 0 1.06-1.06l-1.36-1.36.78-.78a4.4 4.4 0 0 0 1.23-2.33h1.82a.75.75 0 0 0 0-1.5h-1.8q-.16-1-.76-1.88l1.59-1.59a.75.75 0 0 0-1.06-1.06l-1.6 1.6a4.4 4.4 0 0 0-1.87-.77zM6.36 13.48l7.12-7.12a2.94 2.94 0 0 1 4.16 4.16l-7.12 7.12a2.94 2.94 0 1 1-4.16-4.16M9.5 15.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m6-6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $f342bb1007016cbf$export$815924a6afa7dcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mold28Filled', "28", [
    "M19.25 2.25a.75.75 0 0 0-1.5 0v1.8c-1.12.17-2.2.69-3.07 1.55l-1.76 1.76-1.64-1.64a.75.75 0 1 0-1.06 1.06l1.64 1.64-3.44 3.44-1.64-1.64a.75.75 0 1 0-1.06 1.06l1.64 1.64-1.76 1.76a5.4 5.4 0 0 0-1.54 3.07H2.25a.75.75 0 0 0 0 1.5h1.8c.12.92.47 1.81 1.06 2.58l-1.89 1.89a.75.75 0 1 0 1.06 1.06l1.89-1.88c.77.58 1.66.94 2.58 1.06v1.79a.75.75 0 0 0 1.5 0v-1.8a5.4 5.4 0 0 0 3.07-1.55l1.76-1.76 1.64 1.64a.75.75 0 1 0 1.06-1.06l-1.64-1.64 3.44-3.44 1.64 1.64a.75.75 0 1 0 1.06-1.06l-1.64-1.64 1.76-1.76a5.4 5.4 0 0 0 1.55-3.07h1.8a.75.75 0 0 0 0-1.5h-1.8a5.4 5.4 0 0 0-1.05-2.59l1.88-1.88a.75.75 0 0 0-1.06-1.06L21.84 5.1a5.4 5.4 0 0 0-2.59-1.05zM9.5 19.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m10-10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $f342bb1007016cbf$export$abfc774e129d8dc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Mold28Regular', "28", [
    "M19.25 2.25a.75.75 0 0 0-1.5 0v1.8c-1.12.17-2.2.69-3.07 1.55l-1.76 1.76-1.64-1.64a.75.75 0 1 0-1.06 1.06l1.64 1.64-3.44 3.44-1.64-1.64a.75.75 0 1 0-1.06 1.06l1.64 1.64-1.76 1.76a5.4 5.4 0 0 0-1.54 3.07H2.25a.75.75 0 0 0 0 1.5h1.8c.12.92.47 1.81 1.06 2.58l-1.89 1.89a.75.75 0 1 0 1.06 1.06l1.89-1.88c.77.58 1.66.94 2.58 1.06v1.79a.75.75 0 0 0 1.5 0v-1.8a5.4 5.4 0 0 0 3.07-1.55l1.76-1.76 1.64 1.64a.75.75 0 1 0 1.06-1.06l-1.64-1.64 3.44-3.44 1.64 1.64a.75.75 0 1 0 1.06-1.06l-1.64-1.64 1.76-1.76a5.4 5.4 0 0 0 1.55-3.07h1.8a.75.75 0 0 0 0-1.5h-1.8a5.4 5.4 0 0 0-1.05-2.59l1.88-1.88a.75.75 0 0 0-1.06-1.06L21.84 5.1a5.4 5.4 0 0 0-2.59-1.05zM6.66 15.75l9.08-9.09a3.96 3.96 0 1 1 5.6 5.6l-9.08 9.08a3.96 3.96 0 0 1-5.6-5.6m3.84 2.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
]);
const $f342bb1007016cbf$export$8b16f82b059d9693 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule16Color', "16", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "m3.66 8.33 7-3.5.68 1.34-7 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_16_color__a)",
            "d": "m3.66 8.33 7-3.5.68 1.34-7 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_16_color__b)",
            "d": "m3.66 8.33 7-3.5.68 1.34-7 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_16_color__c)",
            "d": "m3.66 8.33 7-3.5.68 1.34-7 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "m11.16 13.17-6-3 .68-1.34 6 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_16_color__d)",
            "d": "m11.16 13.17-6-3 .68-1.34 6 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_16_color__e)",
            "d": "m11.16 13.17-6-3 .68-1.34 6 3z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_16_color__f)",
            "d": "m11.16 13.17-6-3 .68-1.34 6 3z"
        }
    ],
    [
        "circle",
        {
            "cx": "11",
            "cy": "5",
            "r": "3",
            "fill": "url(#ic_fluent_molecule_16_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "4.5",
            "cy": "9.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_molecule_16_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "11",
            "cy": "12",
            "r": "2",
            "fill": "#d9d9d9"
        }
    ],
    [
        "circle",
        {
            "cx": "11",
            "cy": "12",
            "r": "2",
            "fill": "url(#ic_fluent_molecule_16_color__i)"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_16_color__a",
                "x1": "3.66",
                "x2": "4.84",
                "y1": "4.83",
                "y2": "10.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_16_color__d",
                "x1": "5.16",
                "x2": "6.25",
                "y1": "8.83",
                "y2": "13.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_16_color__g",
                "x1": "8.21",
                "x2": "12.36",
                "y1": "3.13",
                "y2": "7.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_16_color__h",
                "x1": "2.18",
                "x2": "5.63",
                "y1": "7.94",
                "y2": "11.52",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_16_color__i",
                "x1": "9.63",
                "x2": "12.25",
                "y1": "9.38",
                "y2": "14.38",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-3 2 -2.09924 -3.14887 11 5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_16_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2.5 -2 2.09924 2.62406 4.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-2.5 -.99998 .9976 -2.49404 11 12)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".44",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_16_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(3.5 1 -1.08822 3.80878 4.5 9.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$9e668dc164fb8a6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule16Filled', "16", [
    "M11 8a3 3 0 1 0-2.7-1.7L5.94 7.45Q5.34 7.01 4.5 7a2.5 2.5 0 1 0 2.21 3.67l2.3 1.14L9 12a2 2 0 1 0 .35-1.13L7 9.69a2.5 2.5 0 0 0-.34-1.46l2.23-1.11A3 3 0 0 0 11 8"
]);
const $f342bb1007016cbf$export$be64a7f0825c337e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule16Regular', "16", [
    "M11 8a3 3 0 1 0-2.7-1.7L5.94 7.45Q5.34 7.01 4.5 7a2.5 2.5 0 1 0 2.21 3.67l2.3 1.14L9 12a2 2 0 1 0 .35-1.13L7 9.69a2.5 2.5 0 0 0-.34-1.46l2.23-1.11A3 3 0 0 0 11 8m0-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-6.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m7.5 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
]);
const $f342bb1007016cbf$export$1e6153ba21fe0acd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule20Color', "20", [
    [
        "path",
        {
            "fill": "#212121",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__a)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__b)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__c)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__d)",
            "fillRule": "evenodd",
            "d": "m12.34 7.17-6 3-.68-1.34 6-3z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__e)",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__f)",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_20_color__g)",
            "fillRule": "evenodd",
            "d": "m12.16 15.67-5-2.5.68-1.34 5 2.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "circle",
        {
            "cx": "13",
            "cy": "6",
            "r": "4",
            "fill": "url(#ic_fluent_molecule_20_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "5.5",
            "cy": "11.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_molecule_20_color__i)"
        }
    ],
    [
        "circle",
        {
            "cx": "13.5",
            "cy": "15.5",
            "r": "2.5",
            "fill": "url(#ic_fluent_molecule_20_color__j)"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(151.69 1.99 5.64)scale(2.35056 2.51001)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-28.31 20.03 -17.2)scale(2.35056 2.51001)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(151.69 1.99 5.64)scale(2.35056 2.51001)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(2.60262 0 0 2.94798 7.4 12.34)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_20_color__g",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-90.88 14.03 1.12)scale(2.89471 2.77447)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__a",
                "x1": "5.66",
                "x2": "6.75",
                "y1": "5.83",
                "y2": "10.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__e",
                "x1": "7.16",
                "x2": "8.16",
                "y1": "11.83",
                "y2": "16.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__h",
                "x1": "9.29",
                "x2": "14.81",
                "y1": "3.5",
                "y2": "9.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__i",
                "x1": "2.25",
                "x2": "7.08",
                "y1": "9.31",
                "y2": "14.33",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_20_color__j",
                "x1": "11.78",
                "x2": "15.06",
                "y1": "12.22",
                "y2": "18.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$f330790db8f1b671 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule20Filled', "20", [
    "M17 6a4 4 0 0 1-7.33 2.22l-1.66.84a3.5 3.5 0 0 1 .82 3.5l2.7 1.4a2.5 2.5 0 1 1-.44.89l-2.7-1.38A3.5 3.5 0 1 1 7.1 8.39l2.13-1.06A4 4 0 1 1 17 6"
]);
const $f342bb1007016cbf$export$f44f00acd395fadd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule20Regular', "20", [
    "M13 10a4 4 0 1 0-3.77-2.67L7.1 8.39a3.5 3.5 0 1 0 1.3 5.08l2.69 1.38a2.5 2.5 0 1 0 .44-.9l-2.7-1.38a3.5 3.5 0 0 0-.82-3.51l1.66-.84A4 4 0 0 0 13 10m0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-7.5 5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $f342bb1007016cbf$export$b3cd8ff811110bd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule24Color', "24", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "m6.58 12.88 8.25-5.5.84 1.24-8.25 5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_24_color__a)",
            "d": "m6.58 12.88 8.25-5.5.84 1.24-8.25 5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_24_color__b)",
            "d": "m6.58 12.88 8.25-5.5.84 1.24-8.25 5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_24_color__c)",
            "d": "m6.58 12.88 8.25-5.5.84 1.24-8.25 5.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "m15.66 19.67-10-5 .68-1.34 10 5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_24_color__d)",
            "d": "m15.66 19.67-10-5 .68-1.34 10 5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_24_color__e)",
            "d": "m15.66 19.67-10-5 .68-1.34 10 5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_24_color__f)",
            "d": "m15.66 19.67-10-5 .68-1.34 10 5z"
        }
    ],
    [
        "circle",
        {
            "cx": "16",
            "cy": "7",
            "r": "5",
            "fill": "url(#ic_fluent_molecule_24_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "6",
            "cy": "14",
            "r": "4",
            "fill": "url(#ic_fluent_molecule_24_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "16",
            "cy": "19",
            "r": "3",
            "fill": "#d9d9d9"
        }
    ],
    [
        "circle",
        {
            "cx": "16",
            "cy": "19",
            "r": "3",
            "fill": "url(#ic_fluent_molecule_24_color__i)"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_24_color__a",
                "x1": "6.58",
                "x2": "8.48",
                "y1": "7.38",
                "y2": "14.65",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_24_color__d",
                "x1": "5.66",
                "x2": "7.12",
                "y1": "13.33",
                "y2": "20.32",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_24_color__g",
                "x1": "11.36",
                "x2": "18.26",
                "y1": "3.88",
                "y2": "11.05",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_24_color__h",
                "x1": "2.29",
                "x2": "7.81",
                "y1": "11.5",
                "y2": "17.24",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_24_color__i",
                "x1": "13.94",
                "x2": "17.88",
                "y1": "15.06",
                "y2": "22.56",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(143.97 6.86 6.1)scale(6.80074 7.76101)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_24_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(4.5 -3 3.4236 5.1354 6 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-4 -2 2.18494 -4.3699 16 19)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_24_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 2.5 -2.4842 4.9684 6 14)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".68",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$6fbe94ffa601c69f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule24Filled', "24", [
    "M16 12a5 5 0 1 0-4.34-2.51l-2.71 1.8A3.99 3.99 0 0 0 2 14a4 4 0 0 0 7.18 2.43l3.89 1.94q-.07.3-.07.63a3 3 0 1 0 .74-1.97l-3.89-1.94a4 4 0 0 0-.11-2.52l2.86-1.9c.9.82 2.09 1.33 3.4 1.33"
]);
const $f342bb1007016cbf$export$7466fd0bcb03402d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule24Regular', "24", [
    "M16 12a5 5 0 1 0-4.34-2.51l-2.71 1.8A3.99 3.99 0 0 0 2 14a4 4 0 0 0 7.18 2.43l3.89 1.94a3 3 0 1 0 .67-1.34l-3.89-1.94a4 4 0 0 0-.11-2.52l2.86-1.9c.9.82 2.09 1.33 3.4 1.33m0-1.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m-10 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5M17.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
]);
const $f342bb1007016cbf$export$974ea53eebb59eb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule28Color', "28", [
    [
        "path",
        {
            "fill": "#212121",
            "fillRule": "evenodd",
            "d": "m8.93 13.68 5-3.5 1.14 1.64-5 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_28_color__a)",
            "fillRule": "evenodd",
            "d": "m8.93 13.68 5-3.5 1.14 1.64-5 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_28_color__b)",
            "fillRule": "evenodd",
            "d": "m8.93 13.68 5-3.5 1.14 1.64-5 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_28_color__c)",
            "fillRule": "evenodd",
            "d": "m8.93 13.68 5-3.5 1.14 1.64-5 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "fillRule": "evenodd",
            "d": "m15.5 21.86-6-3.5 1-1.72 6 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_28_color__d)",
            "fillRule": "evenodd",
            "d": "m15.5 21.86-6-3.5 1-1.72 6 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_28_color__e)",
            "fillRule": "evenodd",
            "d": "m15.5 21.86-6-3.5 1-1.72 6 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_28_color__f)",
            "fillRule": "evenodd",
            "d": "m15.5 21.86-6-3.5 1-1.72 6 3.5z",
            "clipRule": "evenodd"
        }
    ],
    [
        "circle",
        {
            "cx": "19",
            "cy": "8",
            "r": "6",
            "fill": "url(#ic_fluent_molecule_28_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "6.5",
            "cy": "15.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_molecule_28_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "18.5",
            "cy": "22.5",
            "r": "3.5",
            "fill": "#d9d9d9"
        }
    ],
    [
        "circle",
        {
            "cx": "18.5",
            "cy": "22.5",
            "r": "3.5",
            "fill": "url(#ic_fluent_molecule_28_color__i)"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_28_color__a",
                "x1": "8.93",
                "x2": "10.52",
                "y1": "10.18",
                "y2": "15.63",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_28_color__d",
                "x1": "9.5",
                "x2": "10.97",
                "y1": "16.64",
                "y2": "22.27",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_28_color__g",
                "x1": "13.43",
                "x2": "21.71",
                "y1": "4.25",
                "y2": "12.85",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_28_color__h",
                "x1": "2.32",
                "x2": "8.53",
                "y1": "12.69",
                "y2": "19.14",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_28_color__i",
                "x1": "16.09",
                "x2": "20.69",
                "y1": "17.91",
                "y2": "26.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_28_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-6 4.50001 -5.38492 -7.17986 19 8)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".6",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_28_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -2.5 2.99162 5.98322 6.5 15.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".65",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_28_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(212 12.48 8.6)scale(4.71699 4.1059)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".58",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_28_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 3 -3.74184 6.23639 6.5 15.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".71",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$efcb1ce18a2b9512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule28Filled', "28", [
    "M19 14a6 6 0 1 0-5.36-3.3l-3.36 2.35a4.5 4.5 0 1 0-.3 5.3l5.2 3.04a3.5 3.5 0 1 0 .77-1.29l-5.23-3.05a4.5 4.5 0 0 0 .16-2.59l3.6-2.52A6 6 0 0 0 19 14"
]);
const $f342bb1007016cbf$export$21dfb465973f07d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule28Regular', "28", [
    "M19 14a6 6 0 1 0-5.36-3.3l-3.36 2.35a4.5 4.5 0 1 0-.3 5.3l5.2 3.04a3.5 3.5 0 1 0 .77-1.29l-5.23-3.05a4.5 4.5 0 0 0 .16-2.59l3.6-2.52A6 6 0 0 0 19 14m0-1.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-12.5 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6m14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
]);
const $f342bb1007016cbf$export$9047e9949105a40c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule32Color', "32", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "m11.89 14.71 4.5-3.5 1.22 1.58-4.5 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_32_color__a)",
            "d": "m11.89 14.71 4.5-3.5 1.22 1.58-4.5 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_32_color__b)",
            "d": "m11.89 14.71 4.5-3.5 1.22 1.58-4.5 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_32_color__c)",
            "d": "m11.89 14.71 4.5-3.5 1.22 1.58-4.5 3.5z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "m18.01 24.37-8-4.5.98-1.74 8 4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_32_color__d)",
            "d": "m18.01 24.37-8-4.5.98-1.74 8 4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_32_color__e)",
            "d": "m18.01 24.37-8-4.5.98-1.74 8 4.5z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_32_color__f)",
            "d": "m18.01 24.37-8-4.5.98-1.74 8 4.5z"
        }
    ],
    [
        "circle",
        {
            "cx": "22",
            "cy": "9",
            "r": "7",
            "fill": "url(#ic_fluent_molecule_32_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "8.5",
            "cy": "17.5",
            "r": "5.5",
            "fill": "url(#ic_fluent_molecule_32_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "21.5",
            "cy": "25.5",
            "r": "4.5",
            "fill": "#d9d9d9"
        }
    ],
    [
        "circle",
        {
            "cx": "21.5",
            "cy": "25.5",
            "r": "4.5",
            "fill": "url(#ic_fluent_molecule_32_color__i)"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_32_color__a",
                "x1": "11.89",
                "x2": "13.54",
                "y1": "11.21",
                "y2": "16.54",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_32_color__d",
                "x1": "10.01",
                "x2": "11.66",
                "y1": "18.13",
                "y2": "24.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_32_color__g",
                "x1": "15.5",
                "x2": "25.16",
                "y1": "4.63",
                "y2": "14.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_32_color__h",
                "x1": "3.39",
                "x2": "10.98",
                "y1": "14.06",
                "y2": "21.95",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_32_color__i",
                "x1": "18.41",
                "x2": "24.31",
                "y1": "19.59",
                "y2": "30.84",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_32_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(147.26 9.68 7.73)scale(8.32166 10.1513)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_32_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5.5 -3.5 4.26955 6.70928 8.5 17.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".72",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_32_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-5 -3.5 3.269 -4.67002 21.5 25.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_32_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6 4.5 -5.23067 6.97422 8.5 17.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$d130bbee923716c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule32Filled', "32", [
    "M22 16a7 7 0 1 0-6.4-4.17l-2.84 2.2a5.49 5.49 0 1 0-.26 7.25l4.77 2.68a4.5 4.5 0 1 0 1.1-1.68l-4.78-2.68a5.5 5.5 0 0 0 .14-3.8l2.93-2.27A7 7 0 0 0 22 16"
]);
const $f342bb1007016cbf$export$5a668a1fe2a03fb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule32Light', "32", [
    "M22 16a7 7 0 1 0-6.18-3.71l-2.76 2.14a5.5 5.5 0 1 0-.17 6.38l4.59 2.67q-.46.92-.48 2.02a4.5 4.5 0 1 0 1.02-2.86l-4.6-2.68a5.5 5.5 0 0 0 .13-4.64l2.8-2.18A7 7 0 0 0 22 16m0-1a6 6 0 1 1 0-12 6 6 0 0 1 0 12M8.5 22a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9M25 25.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
]);
const $f342bb1007016cbf$export$9552a14dd4ab9f4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule32Regular', "32", [
    "M22 16a7 7 0 1 0-6.4-4.17l-2.84 2.2a5.49 5.49 0 1 0-.26 7.25l4.77 2.68a4.5 4.5 0 1 0 1.1-1.68l-4.78-2.68a5.5 5.5 0 0 0 .14-3.8l2.93-2.27A7 7 0 0 0 22 16m0-2a5 5 0 1 1 0-10 5 5 0 0 1 0 10M8.5 21a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7M24 25.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
]);
const $f342bb1007016cbf$export$9a55ccf0d845079 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule48Color', "48", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "m14.67 24.75 12-8 1.66 2.5-12 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_48_color__a)",
            "d": "m14.67 24.75 12-8 1.66 2.5-12 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_48_color__b)",
            "d": "m14.67 24.75 12-8 1.66 2.5-12 8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_48_color__c)",
            "d": "m14.67 24.75 12-8 1.66 2.5-12 8z"
        }
    ],
    [
        "path",
        {
            "fill": "#242424",
            "d": "m28.33 37.84-12-6 1.34-2.68 12 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_48_color__d)",
            "d": "m28.33 37.84-12-6 1.34-2.68 12 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_48_color__e)",
            "d": "m28.33 37.84-12-6 1.34-2.68 12 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_molecule_48_color__f)",
            "d": "m28.33 37.84-12-6 1.34-2.68 12 6z"
        }
    ],
    [
        "circle",
        {
            "cx": "32",
            "cy": "14",
            "r": "10",
            "fill": "url(#ic_fluent_molecule_48_color__g)"
        }
    ],
    [
        "circle",
        {
            "cx": "12",
            "cy": "28",
            "r": "8",
            "fill": "url(#ic_fluent_molecule_48_color__h)"
        }
    ],
    [
        "circle",
        {
            "cx": "32",
            "cy": "38",
            "r": "6",
            "fill": "#d9d9d9"
        }
    ],
    [
        "circle",
        {
            "cx": "32",
            "cy": "38",
            "r": "6",
            "fill": "url(#ic_fluent_molecule_48_color__i)"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_48_color__a",
                "x1": "14.67",
                "x2": "17.7",
                "y1": "16.75",
                "y2": "28.01",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_48_color__d",
                "x1": "16.33",
                "x2": "18.49",
                "y1": "29.16",
                "y2": "38.66",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#b9c0c7"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_48_color__g",
                "x1": "22.71",
                "x2": "36.52",
                "y1": "7.75",
                "y2": "22.09",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#2bdabe"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#22918b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_48_color__h",
                "x1": "4.57",
                "x2": "15.61",
                "y1": "23",
                "y2": "34.47",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ec318f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#b91d6b"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_molecule_48_color__i",
                "x1": "27.88",
                "x2": "35.75",
                "y1": "30.13",
                "y2": "45.13",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_48_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(143.13 13.67 12.33)scale(12.5 14.4743)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".69",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_48_color__c",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8 -5 5.78976 9.26362 12 28)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".74",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_48_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(-7 -4.00002 3.99047 -6.98329 32 38)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".56",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_molecule_48_color__f",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(8.5 4.5 -4.89701 9.2499 12 28)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".8",
                    "stopColor": "#70777d"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#70777d",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$bc79a69fed31f6f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule48Filled', "48", [
    "M32 24a10 10 0 1 0-8.55-4.8l-5.38 3.58a8 8 0 1 0 .44 9.87l7.68 3.84a6.01 6.01 0 1 0 1.12-2.23l-7.68-3.84a8 8 0 0 0-.25-5.5l5.64-3.76A10 10 0 0 0 32 24"
]);
const $f342bb1007016cbf$export$41e460e724760281 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Molecule48Regular', "48", [
    "M32 24a10 10 0 1 0-8.55-4.8l-5.38 3.58a8 8 0 1 0 .44 9.87l7.68 3.84a6.01 6.01 0 1 0 1.12-2.23l-7.68-3.84a8 8 0 0 0-.25-5.5l5.64-3.76A10 10 0 0 0 32 24m0-2.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m-20 12a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11M35.5 38a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
]);
const $f342bb1007016cbf$export$67094f3cb7381ce6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open12Filled', "12", [
    "M4 3.5a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-.25a.75.75 0 0 1 1.5 0V8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h.25a.75.75 0 0 1 0 1.5zm2.75 0a.75.75 0 0 1 0-1.5h2.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-.69L7.28 5.78a.75.75 0 0 1-1.06-1.06L7.44 3.5z"
]);
const $f342bb1007016cbf$export$221125146d50b3e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open12Regular', "12", [
    "M4 3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a.5.5 0 0 1 1 0v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h1a.5.5 0 0 1 0 1zm3 0a.5.5 0 0 1 0-1h2.5c.28 0 .5.22.5.5V5a.5.5 0 0 1-1 0V3.7L7.35 5.36a.5.5 0 1 1-.7-.7L8.29 3z"
]);
const $f342bb1007016cbf$export$a214c258def63169 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open16Filled', "16", [
    "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 0 1 1.5 0v1.5A2.75 2.75 0 0 1 11.25 14h-6.5A2.75 2.75 0 0 1 2 11.25v-6.5A2.75 2.75 0 0 1 4.75 2h1.5a.75.75 0 0 1 0 1.5zM8 2.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0V4.56L9.28 7.78a.75.75 0 1 1-1.06-1.06l3.22-3.22H8.75A.75.75 0 0 1 8 2.75"
]);
const $f342bb1007016cbf$export$4a052db3d484e96b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open16Regular', "16", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V9.27a.5.5 0 0 1 1 0v2.23a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2h2.23a.5.5 0 0 1 0 1zm4.27-.5c0-.28.22-.5.5-.5h4.23c.28 0 .5.22.5.5v4.23a.5.5 0 0 1-1 0V3.71L9.62 7.08a.5.5 0 1 1-.7-.7L12.29 3H9.27a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$ec8379cf9f3d6e65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open20Filled', "20", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-2a.75.75 0 0 1 1.5 0v2c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5C3 4.45 4.46 3 6.25 3h2a.75.75 0 0 1 0 1.5zm4.25-.75c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75v5a.75.75 0 0 1-1.5 0V5.56l-3.72 3.72a.75.75 0 1 1-1.06-1.06l3.72-3.72h-3.19a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$5e85716c147edcbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open20Regular', "20", [
    "M6 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1zm5-.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V4.7l-4.15 4.15a.5.5 0 0 1-.7-.7L15.29 4H11.5a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$e707d58257cb4d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open24Filled', "24", [
    "M6.25 5C5.56 5 5 5.56 5 6.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V14a1 1 0 1 1 2 0v3.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3H10a1 1 0 1 1 0 2zM14 5a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6.41l-4.3 4.3a1 1 0 0 1-1.4-1.42L17.58 5z"
]);
const $f342bb1007016cbf$export$9ddb4c2c2b00156c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open24Regular', "24", [
    "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 0 1 1.5 0v4c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3h4a.75.75 0 0 1 0 1.5zM13 3.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v6.5a.75.75 0 0 1-1.5 0V5.56l-5.22 5.22a.75.75 0 0 1-1.06-1.06l5.22-5.22h-4.69a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$afeaecfae696fc4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open28Filled', "28", [
    "M7 5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4.5a1 1 0 1 1 2 0V21a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h4.5a1 1 0 1 1 0 2zm8.5-1a1 1 0 0 1 1-1H24a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0V6.41l-5.8 5.8a1 1 0 1 1-1.4-1.42L21.58 5H16.5a1 1 0 0 1-1-1"
]);
const $f342bb1007016cbf$export$c436ce71e3f4ae0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open28Regular', "28", [
    "M7.25 4.5A2.75 2.75 0 0 0 4.5 7.25v13.5a2.75 2.75 0 0 0 2.75 2.75h13.5a2.75 2.75 0 0 0 2.75-2.75v-4.5a.75.75 0 0 1 1.5 0v4.5C25 23.1 23.1 25 20.75 25H7.25A4.25 4.25 0 0 1 3 20.75V7.25C3 4.9 4.9 3 7.25 3h4.5a.75.75 0 0 1 0 1.5zm8.25-.75c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v8a.75.75 0 0 1-1.5 0V5.56l-6.22 6.22a.75.75 0 1 1-1.06-1.06l6.22-6.22h-6.19a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$bed341e2e4530158 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open32Filled', "32", [
    "M7.75 5.5c-1.24 0-2.25 1-2.25 2.25v16.5c0 1.24 1 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25v-5a1.25 1.25 0 1 1 2.5 0v5A4.75 4.75 0 0 1 24.25 29H7.75A4.75 4.75 0 0 1 3 24.25V7.75A4.75 4.75 0 0 1 7.75 3h5a1.25 1.25 0 1 1 0 2.5zM18 4.25c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v8.5a1.25 1.25 0 1 1-2.5 0V7.27l-6.37 6.36a1.25 1.25 0 1 1-1.76-1.76l6.36-6.37h-5.48c-.69 0-1.25-.56-1.25-1.25"
]);
const $f342bb1007016cbf$export$6783d302bf558673 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open32Regular', "32", [
    "M8.5 5A3.5 3.5 0 0 0 5 8.5v15A3.5 3.5 0 0 0 8.5 27h15a3.5 3.5 0 0 0 3.5-3.5V19a1 1 0 1 1 2 0v4.5a5.5 5.5 0 0 1-5.5 5.5h-15A5.5 5.5 0 0 1 3 23.5v-15A5.5 5.5 0 0 1 8.5 3H13a1 1 0 1 1 0 2zM18 4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V6.41l-7.3 7.3a1 1 0 0 1-1.4-1.42L25.58 5H19a1 1 0 0 1-1-1"
]);
const $f342bb1007016cbf$export$8c6345d9d57afc41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open48Filled', "48", [
    "M41.45 6.34c.34.27.55.7.55 1.16v12a1.5 1.5 0 0 1-3 0v-8.38l-9.44 9.44a1.5 1.5 0 1 1-2.12-2.12L36.88 9H28.5a1.5 1.5 0 0 1 0-3h11.98a1.5 1.5 0 0 1 .97.34M12.5 9A3.5 3.5 0 0 0 9 12.5v23a3.5 3.5 0 0 0 3.5 3.5h23a3.5 3.5 0 0 0 3.5-3.5v-8a1.5 1.5 0 1 1 3 0v8a6.5 6.5 0 0 1-6.5 6.5h-23A6.5 6.5 0 0 1 6 35.5v-23A6.5 6.5 0 0 1 12.5 6h8a1.5 1.5 0 0 1 0 3z"
]);
const $f342bb1007016cbf$export$8c1edff362e4d83a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Open48Regular', "48", [
    "M12.25 8.5a3.75 3.75 0 0 0-3.75 3.75v23.5a3.75 3.75 0 0 0 3.75 3.75h23.5a3.75 3.75 0 0 0 3.75-3.75v-8.5a1.25 1.25 0 0 1 2.5 0v8.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6h8.5a1.25 1.25 0 0 1 0 2.5zM27 7.25c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-9.48L29.13 20.63a1.25 1.25 0 0 1-1.76-1.76L37.73 8.5h-9.48c-.69 0-1.25-.56-1.25-1.25"
]);
const $f342bb1007016cbf$export$df311db26a378bdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder16Filled', "16", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h5.5C12.55 2 14 3.46 14 5.25v2a.75.75 0 0 1-1.5 0v-2c0-.97-.78-1.75-1.75-1.75h-5.5c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h3a.75.75 0 0 1 0 1.5h-3A3.25 3.25 0 0 1 2 10.75zm4 1.5c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5H8.56l4.22 4.22a.75.75 0 1 1-1.06 1.06L7.5 8.56v1.69a.75.75 0 0 1-1.5 0z"
]);
const $f342bb1007016cbf$export$fcb3f500fb9202ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder16Regular', "16", [
    "M2 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v2.5a.5.5 0 0 1-1 0V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h3.5a.5.5 0 0 1 0 1H5a3 3 0 0 1-3-3zm4.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7.7l5.15 5.15a.5.5 0 0 0 .7-.7L7.71 7h2.79a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$8a1620d133f96b8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder20Filled', "20", [
    "M3 6.25C3 4.45 4.46 3 6.25 3H14c1.8 0 3.25 1.46 3.25 3.25v2a.75.75 0 0 1-1.5 0v-2c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h4a.75.75 0 0 1 0 1.5h-4A3.25 3.25 0 0 1 3 13.75zm5 2.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l5.22 5.22a.75.75 0 1 1-1.06 1.06L9.5 10.56v2.69a.75.75 0 0 1-1.5 0z"
]);
const $f342bb1007016cbf$export$74dbba658a7e49df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.5a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3zm2.15 5.15A.5.5 0 0 1 8.5 8h4.99a.5.5 0 0 1 0 1H9.7l6.15 6.15a.5.5 0 0 1-.7.7L9 9.71v3.79a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .15-.35"
]);
const $f342bb1007016cbf$export$d8d1a36e27410164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder24Filled', "24", [
    "M6.75 3h10.5c2 0 3.64 1.57 3.75 3.55v4.7a.75.75 0 0 1-1.49.1v-4.6c0-1.19-.93-2.16-2.1-2.24h-.16L6.75 4.5c-1.18 0-2.15.9-2.25 2.06v10.69c0 1.2.93 2.17 2.1 2.25h4.65a.75.75 0 0 1 .1 1.5h-4.6c-2 0-3.64-1.57-3.75-3.55V6.55A3.75 3.75 0 0 1 6.55 3zm3.2 6H16a1 1 0 0 1 .11 2h-3.69l6.54 6.54a1 1 0 0 1 .08 1.32l-.08.1a1 1 0 0 1-1.32.08l-.1-.08L11 12.4v3.6a1 1 0 0 1-.88.99H10a1 1 0 0 1-1-.88v-6.2l.02-.1v-.05l.03-.07.03-.1.07-.12.14-.19.11-.1.12-.07.1-.05.1-.03.1-.02zH16z"
]);
const $f342bb1007016cbf$export$3a3096fba284d56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder24Regular', "24", [
    "M6.75 3h10.5c2 0 3.64 1.57 3.75 3.55v4.7a.75.75 0 0 1-1.49.1v-4.6c0-1.19-.93-2.16-2.1-2.24h-.16L6.75 4.5c-1.18 0-2.15.9-2.25 2.06v10.69c0 1.2.93 2.17 2.1 2.25h4.65a.75.75 0 0 1 .1 1.5h-4.6c-2 0-3.64-1.57-3.75-3.55V6.55A3.75 3.75 0 0 1 6.55 3zm3 6h6.5a.75.75 0 0 1 .1 1.5h-4.79l7.22 7.22c.27.27.3.68.08.98l-.08.08a.75.75 0 0 1-.97.07l-.09-.07-7.22-7.22v4.7c0 .37-.28.68-.65.73l-.1.01a.75.75 0 0 1-.74-.65l-.01-.1V9.66l.03-.11.03-.1a1 1 0 0 1 .16-.23l.04-.04.08-.06.06-.04.1-.04.07-.02.06-.01.1-.01h6.52z"
]);
const $f342bb1007016cbf$export$a5711ba9fcd3f5c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder28Filled', "28", [
    "M3 7.75a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5V13a1 1 0 1 1-2 0V7.75a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3V20a3 3 0 0 0 3 3h5a1 1 0 1 1 0 2H8a5 5 0 0 1-5-5zM10 11a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-5.53l8.24 8.3a1 1 0 0 1-1.42 1.4L12 13.36V19a1 1 0 1 1-2 0z"
]);
const $f342bb1007016cbf$export$acceb17fb023bd09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder28Regular', "28", [
    "M3 7.75A4.75 4.75 0 0 1 7.75 3h12.5A4.75 4.75 0 0 1 25 7.75v5.5a.75.75 0 0 1-1.5 0v-5.5c0-1.8-1.46-3.25-3.25-3.25H7.75A3.25 3.25 0 0 0 4.5 7.75v12.5c0 1.8 1.46 3.25 3.25 3.25h5.5a.75.75 0 0 1 0 1.5h-5.5A4.75 4.75 0 0 1 3 20.25zm7.5 3.5c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-5.63l8.66 8.72a.75.75 0 1 1-1.06 1.06L12 13v5.75a.75.75 0 0 1-1.5 0z"
]);
const $f342bb1007016cbf$export$c923806bfeeb8832 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder48Filled', "48", [
    "M34.63 6.13a7.5 7.5 0 0 1 7.5 7.5v9a1.5 1.5 0 0 1-3 0v-9a4.5 4.5 0 0 0-4.5-4.5H13.36a4.5 4.5 0 0 0-4.5 4.5v21a4.5 4.5 0 0 0 4.5 4.5h9.26a1.5 1.5 0 0 1 0 3h-9.25a7.5 7.5 0 0 1-7.5-7.5v-21a7.5 7.5 0 0 1 7.5-7.5zM18 19.5c0-.83.67-1.5 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-9.38l14.44 14.44a1.5 1.5 0 0 1-2.12 2.12L21 23.12v9.38a1.5 1.5 0 0 1-3 0z"
]);
const $f342bb1007016cbf$export$a3e53caa38164fc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenFolder48Regular', "48", [
    "M40.75 24c.69 0 1.25-.56 1.25-1.25v-9.5c0-4-3.25-7.25-7.25-7.25h-21.5C9.25 6 6 9.25 6 13.25v21.5c0 4 3.25 7.25 7.25 7.25h9.5a1.25 1.25 0 1 0 0-2.5h-9.5a4.75 4.75 0 0 1-4.75-4.75v-21.5a4.75 4.75 0 0 1 4.75-4.75h21.5a4.75 4.75 0 0 1 4.75 4.75v9.5c0 .69.56 1.25 1.25 1.25m-21.5-6c-.69 0-1.25.56-1.25 1.25v13.5a1.25 1.25 0 1 0 2.5 0V22.27l15.37 15.36a1.25 1.25 0 1 0 1.76-1.76L22.27 20.5h10.48a1.25 1.25 0 1 0 0-2.5z"
]);
const $f342bb1007016cbf$export$d7f12669ca6d2ac6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff16Filled', "16", [
    "M12.8 13.52q-.66.47-1.55.48h-6.5A2.75 2.75 0 0 1 2 11.25v-6.5q.02-.88.48-1.56L1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7zm-1.1-1.1L3.6 4.28q-.09.21-.09.46v6.5c0 .69.56 1.25 1.25 1.25h6.5q.25 0 .46-.09M8.54 6.4l1.06 1.06 2.91-2.9v2.68a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 1 0 0 1.5h2.69zm5.41 5.41-1.44-1.44v-.63a.75.75 0 0 1 1.5 0v1.5q0 .3-.06.57M4.18 2.06 5.62 3.5h.63a.75.75 0 0 0 0-1.5h-1.5q-.3 0-.57.06"
]);
const $f342bb1007016cbf$export$74eeb0e116dfe782 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff16Regular', "16", [
    "m12.88 13.59 1.27 1.26a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L2.4 3.12q-.4.6-.41 1.38v7A2.5 2.5 0 0 0 4.5 14h7q.77-.01 1.38-.41m-.73-.74q-.3.15-.65.15h-7A1.5 1.5 0 0 1 3 11.5v-7q0-.35.15-.65zm-3.37-6.2.57.57a.5.5 0 0 0 .27-.14L13 3.71v3.02a.5.5 0 0 0 1 0V2.5a.5.5 0 0 0-.5-.5H9.27a.5.5 0 0 0 0 1h3.02L8.92 6.38a.5.5 0 0 0-.14.27m5.2 5.2-.98-.97V9.27a.5.5 0 0 1 1 0v2.23q0 .18-.02.35M4.15 2.02l.97.98h1.61a.5.5 0 0 0 0-1H4.5q-.18 0-.35.02"
]);
const $f342bb1007016cbf$export$11299116ef9276ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff20Filled', "20", [
    "m2.85 2.15 15 15a.5.5 0 0 1-.7.7l-1.48-1.48q-.83.61-1.92.63h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5q.01-1.1.63-1.92L2.15 2.85a.5.5 0 1 1 .7-.7m11.73 13.14L4.71 5.42q-.2.38-.21.83v7.5c0 .97.78 1.75 1.75 1.75h7.5q.46 0 .83-.21m-4.01-6.85.99 1a1 1 0 0 0 .22-.16l3.72-3.72v3.19a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0 0 1.5h3.19l-3.72 3.72a1 1 0 0 0-.15.22m6.28 6.29-1.35-1.35v-1.63a.75.75 0 0 1 1.5 0v2q0 .51-.15.98M5.27 3.15 6.62 4.5h1.63a.75.75 0 0 0 0-1.5h-2q-.51 0-.98.15"
]);
const $f342bb1007016cbf$export$4a43ca346d5f6da9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff20Regular', "20", [
    "m2.85 2.15 15 15a.5.5 0 0 1-.7.7l-1.41-1.4q-.77.53-1.74.55H6a3 3 0 0 1-3-3V6q.01-.99.55-1.74l-1.4-1.4a.5.5 0 1 1 .7-.71m12.17 13.57L4.28 4.98A2 2 0 0 0 4 6v8c0 1.1.9 2 2 2h8a2 2 0 0 0 1.02-.28m1.88-.94-.9-.9V11.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-.1.78M5.22 3.1l.9.9H8.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-.78.1m5.78.4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V4.7l-4.15 4.15a.5.5 0 0 1-.7-.7L15.29 4H11.5a.5.5 0 0 1-.5-.5"
]);
const $f342bb1007016cbf$export$890078167fe184d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l1.26 1.26Q3.01 5.3 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5q.96-.02 1.7-.48l1.27 1.26a.75.75 0 0 0 1.06-1.06zm14.65 16.77-.18.01H6.25C5.56 19 5 18.44 5 17.75V6.25l.01-.18zM13 9.83 14.17 11a1 1 0 0 0 .54-.28L19 6.4V10a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h3.59l-4.3 4.3a1 1 0 0 0-.28.53M21 17.82l-2-2V14a1 1 0 1 1 2 0v3.82M6.18 3l2 2H10a1 1 0 1 0 0-2H6.18"
]);
const $f342bb1007016cbf$export$7319fc8a2dfc5201 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff24Regular', "24", [
    "m3.28 2.22 18.5 18.5a.75.75 0 0 1-1.06 1.06l-1.26-1.26q-.76.46-1.71.48H6.25A3.25 3.25 0 0 1 3 17.75V6.25q.02-.95.48-1.7L2.22 3.27a.75.75 0 1 1 1.06-1.06M18.34 19.4 4.6 5.66q-.1.28-.1.59v11.5c0 .97.78 1.75 1.75 1.75h11.5q.3 0 .59-.1m-5.26-9.5 1.02 1.02.18-.14 5.22-5.22v4.69a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h4.69l-5.22 5.22zM21 17.82l-1.5-1.5v-2.57a.75.75 0 0 1 1.5 0v4.07M6.18 3l1.5 1.5h2.57a.75.75 0 0 0 0-1.5H6.18"
]);
const $f342bb1007016cbf$export$6ced3c00a7fad56c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff28Filled', "28", [
    "m3.28 2.22 22.5 22.5a.75.75 0 0 1-1.06 1.06l-1.47-1.47c-.64.44-1.42.69-2.25.69H7a4 4 0 0 1-4-4V7q.01-1.26.7-2.25L2.21 3.28a.75.75 0 1 1 1.06-1.06m18.5 20.62L5.16 6.22A2 2 0 0 0 5 7v14c0 1.1.9 2 2 2h14a2 2 0 0 0 .78-.16M6.25 3.07 8.18 5h3.32a1 1 0 1 0 0-2H7q-.38 0-.75.07m18.68 18.68L23 19.82V16.5a1 1 0 1 1 2 0V21q0 .38-.07.75M15.5 4a1 1 0 0 1 1-1H24a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0V6.41l-5.8 5.8a1 1 0 1 1-1.4-1.42L21.58 5H16.5a1 1 0 0 1-1-1"
]);
const $f342bb1007016cbf$export$648a57cf5d7f2417 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff28Regular', "28", [
    "m3.28 2.22 22.5 22.5a.75.75 0 0 1-1.06 1.06l-1.54-1.54c-.7.48-1.53.76-2.43.76H7.25A4.25 4.25 0 0 1 3 20.75V7.25c0-.9.28-1.74.76-2.43L2.22 3.28a.75.75 0 1 1 1.06-1.06m18.81 20.93L4.85 5.91q-.34.6-.35 1.34v13.5a2.75 2.75 0 0 0 2.75 2.75h13.5q.74-.01 1.34-.35M6.3 3.11 7.7 4.5h4.06a.75.75 0 0 0 0-1.5h-4.5q-.5 0-.96.1m18.6 18.6-1.39-1.4v-4.06a.75.75 0 0 1 1.5 0v4.5q0 .5-.1.96M15.5 3.75c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v8a.75.75 0 0 1-1.5 0V5.56l-6.22 6.22a.75.75 0 1 1-1.06-1.06l6.22-6.22h-6.19a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$d8242f46d23bfce1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff48Filled', "48", [
    "M39.13 40.9A6.5 6.5 0 0 1 35.5 42h-23A6.5 6.5 0 0 1 6 35.5v-23c0-1.34.4-2.6 1.1-3.63L4.38 6.13a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76zm-2.2-2.2L9.3 11.07q-.3.66-.3 1.43v23a3.5 3.5 0 0 0 3.5 3.5h23q.77 0 1.43-.3m4.98-2.1L39 33.7v-6.2a1.5 1.5 0 1 1 3 0v8q0 .57-.1 1.1M11.4 6.1 14.3 9h6.2a1.5 1.5 0 0 0 0-3h-8q-.56 0-1.1.1m30.05.24c.34.27.55.7.55 1.16v12a1.5 1.5 0 0 1-3 0v-8.38l-9.44 9.44a1.5 1.5 0 1 1-2.12-2.12L36.88 9H28.5a1.5 1.5 0 0 1 0-3h11.98a1.5 1.5 0 0 1 .97.34"
]);
const $f342bb1007016cbf$export$d519efedd89297aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('OpenOff48Regular', "48", [
    "M39.2 40.96A6.2 6.2 0 0 1 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5c0-1.27.38-2.46 1.04-3.45L4.37 6.13a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76zm-1.83-1.83-28.5-28.5a4 4 0 0 0-.37 1.62v23.5a3.75 3.75 0 0 0 3.75 3.75h23.5q.88 0 1.62-.37m4.57-2.5L39.5 34.2v-6.95a1.25 1.25 0 0 1 2.5 0v8.5q0 .45-.06.88M11.37 6.06 13.8 8.5h6.95a1.25 1.25 0 0 0 0-2.5h-8.5q-.46 0-.88.06M27 7.25c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-9.48L29.13 20.63a1.25 1.25 0 0 1-1.76-1.76L37.73 8.5h-9.48c-.69 0-1.25-.56-1.25-1.25"
]);
const $f342bb1007016cbf$export$5d9de50c1557ea90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pi20Filled', "20", [
    "M3.4 4.78c-.17.32-.18.76-.12 1.07a.75.75 0 1 1-1.47.3c-.1-.52-.11-1.34.26-2.06.41-.79 1.22-1.34 2.47-1.34H16.5a.75.75 0 0 1 0 1.5h-2.25v9.42c0 1.5.45 1.89.7 2 .32.15.8.08 1.21-.13a.75.75 0 0 1 .68 1.34c-.6.3-1.6.58-2.53.15-1.01-.47-1.56-1.61-1.56-3.36V4.25H8.24a91 91 0 0 1-.6 6.32 45 45 0 0 1-.61 3.55 12 12 0 0 1-.86 2.72.75.75 0 1 1-1.34-.68c.26-.5.5-1.33.73-2.36s.42-2.21.58-3.42c.31-2.28.5-4.62.6-6.13h-2.2c-.74 0-1.01.28-1.14.53"
]);
const $f342bb1007016cbf$export$2fd3353f02c9e7a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pi20Regular', "20", [
    "M3.18 4.67a2 2 0 0 0-.14 1.23.5.5 0 1 1-.98.2 3 3 0 0 1 .23-1.9C2.66 3.5 3.38 3 4.54 3H16.5a.5.5 0 1 1 0 1H14v9.67c0 1.54.47 2.05.84 2.23.42.2 1 .09 1.43-.14a.5.5 0 1 1 .46.9c-.56.28-1.49.53-2.32.14-.88-.41-1.41-1.42-1.41-3.13V4H8v.03a90 90 0 0 1-.62 6.51 44 44 0 0 1-.6 3.52c-.23 1.06-.5 2-.83 2.66a.5.5 0 1 1-.9-.44c.27-.55.53-1.39.76-2.43.22-1.03.42-2.22.58-3.44.33-2.42.53-4.92.6-6.41H4.55c-.83 0-1.18.33-1.36.67"
]);
const $f342bb1007016cbf$export$d53bfee9de9b1342 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pi24Filled', "24", [
    "M2 7a3 3 0 0 1 3-3h15.25a1 1 0 1 1 0 2H17v10.7a1.5 1.5 0 0 0 2 1.42l.16-.06a1 1 0 1 1 .68 1.88l-.16.06A3.5 3.5 0 0 1 15 16.7V6H9.98a54 54 0 0 1-.36 4.21 45 45 0 0 1-1.93 9.12 1 1 0 1 1-1.88-.66 43 43 0 0 0 1.82-8.7A66 66 0 0 0 7.98 6H5a1 1 0 0 0-1 1v.5a1 1 0 0 1-2 0z"
]);
const $f342bb1007016cbf$export$50e2ef18e1ead691 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pi24Regular', "24", [
    "M2.5 6.75A2.75 2.75 0 0 1 5.25 4h15a.75.75 0 0 1 0 1.5H17v11.45c0 1.21 1.2 2.06 2.34 1.65l.16-.06a.75.75 0 0 1 .5 1.42l-.16.05a3.25 3.25 0 0 1-4.34-3.06V5.5h-6a57 57 0 0 1-.25 4.53c-.25 2.87-.76 6.5-1.8 9.47a.75.75 0 0 1-1.4-.5 40 40 0 0 0 1.7-9.1A68 68 0 0 0 8 5.5H5.25C4.56 5.5 4 6.06 4 6.75v.5a.75.75 0 0 1-1.5 0z"
]);
const $f342bb1007016cbf$export$4b21d30df86c91ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pivot16Filled', "16", [
    "M13.22 7.08a.5.5 0 0 1 .63.07l2 2a.5.5 0 1 1-.7.7L14 8.71v2.79a2.5 2.5 0 0 1-2.5 2.5H8.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L8.71 13h2.79c.83 0 1.5-.67 1.5-1.5V8.7l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2zM11.5 2A2.5 2.5 0 0 1 14 4.5v1.59a1.5 1.5 0 0 0-1.45.25l-.11.1-6 6A1.5 1.5 0 0 0 6.09 14H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zM4.75 7a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h.5c.41 0 .75-.34.75-.75v-3.5A.75.75 0 0 0 5.25 7zm0-3a.75.75 0 0 0-.75.75v.5c0 .41.34.75.75.75h.5c.41 0 .75-.34.75-.75v-.5A.75.75 0 0 0 5.25 4zm3 0a.75.75 0 0 0-.75.75v.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-.5a.75.75 0 0 0-.75-.75z"
]);
const $f342bb1007016cbf$export$95f3ee0284732b95 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pivot16Regular', "16", [
    "M13.22 7.08a.5.5 0 0 1 .63.07l2 2a.5.5 0 1 1-.7.7L14 8.71v2.79a2.5 2.5 0 0 1-2.5 2.5H8.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L8.71 13h2.79c.83 0 1.5-.67 1.5-1.5V8.7l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2zM11.5 2A2.5 2.5 0 0 1 14 4.5v1.59a1.5 1.5 0 0 0-1 0V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h1.59a1.5 1.5 0 0 0 0 1H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zM5.25 7c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75h-.5a.75.75 0 0 1-.75-.75v-3.5c0-.41.34-.75.75-.75zm0-3c.41 0 .75.34.75.75v.5c0 .41-.34.75-.75.75h-.5A.75.75 0 0 1 4 5.25v-.5c0-.41.34-.75.75-.75zm6 0c.41 0 .75.34.75.75v.5c0 .41-.34.75-.75.75h-3.5A.75.75 0 0 1 7 5.25v-.5c0-.41.34-.75.75-.75z"
]);
const $f342bb1007016cbf$export$349e7a5dee03ec6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pivot20Filled', "20", [
    "M16.22 10.08a.5.5 0 0 1 .63.07l2 2a.5.5 0 1 1-.7.7L17 11.71V14a3 3 0 0 1-3 3h-2.3l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L11.71 16H14a2 2 0 0 0 2-2v-2.3l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2zM14 3a3 3 0 0 1 3 3v3.09a1.5 1.5 0 0 0-1.45.25l-.11.1-6 6A1.5 1.5 0 0 0 9.09 17H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM6 9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm0-4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
]);
const $f342bb1007016cbf$export$d028c0abb0fd8a0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pivot20Regular', "20", [
    "M16.22 10.08a.5.5 0 0 1 .63.07l2 2a.5.5 0 1 1-.7.7L17 11.71V14a3 3 0 0 1-3 3h-2.3l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L11.71 16H14a2 2 0 0 0 2-2v-2.3l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2zM14 3a3 3 0 0 1 3 3v3.09a1.5 1.5 0 0 0-1 0V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.09a1.5 1.5 0 0 0 0 1H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM7 9a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0-4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm7 0a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
]);
const $f342bb1007016cbf$export$1b5bcfbc445c6d69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pivot24Filled', "24", [
    "M19.78 13.17a.75.75 0 0 1 1 .05l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v2.19c0 1.8-1.46 3.25-3.25 3.25h-2.19l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 1 1 1.06 1.06l-.72.72h2.19c.97 0 1.75-.78 1.75-1.75v-2.19l-.72.72a.75.75 0 1 1-1.06-1.06l2-2zM17.75 3C19.55 3 21 4.46 21 6.25v5.92a1.8 1.8 0 0 0-1.85.22l-.14.12-6.5 6.5a1.75 1.75 0 0 0-.34 1.99H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3zM7 12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm0-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
]);
const $f342bb1007016cbf$export$8f1ee60d60997af2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Pivot24Regular', "24", [
    "M19.78 13.17a.75.75 0 0 1 1 .05l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v2.19c0 1.8-1.46 3.25-3.25 3.25h-2.19l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 1 1 1.06 1.06l-.72.72h2.19c.97 0 1.75-.78 1.75-1.75v-2.19l-.72.72a.75.75 0 1 1-1.06-1.06l2-2zM17.75 3C19.55 3 21 4.46 21 6.25v5.92a1.8 1.8 0 0 0-1.5 0V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h5.92a1.8 1.8 0 0 0 0 1.5H6.25A3.25 3.25 0 0 1 3 17.75V6.25C3 4.45 4.46 3 6.25 3zM9 12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z"
]);
const $f342bb1007016cbf$export$21ac98c9b6eea302 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected16Filled', "16", [
    "M6.01 6.78a1.25 1.25 0 0 0-1.76 0L4.03 7a3.5 3.5 0 0 0-.32 4.58l-2.06 2.07a.5.5 0 0 0 .7.7l2.08-2.07q.92.66 2.03.66c.94 0 1.89-.37 2.6-1.08l.14-.14c.48-.48.48-1.28 0-1.76zm8.34-5.13a.5.5 0 0 0-.7 0l-2.07 2.07a3.6 3.6 0 0 0-4.64.42l-.13.14a1.25 1.25 0 0 0 0 1.76l3.18 3.19a1.24 1.24 0 0 0 1.77 0l.22-.22a3.47 3.47 0 0 0 .31-4.6l2.06-2.06a.5.5 0 0 0 0-.7"
]);
const $f342bb1007016cbf$export$2f0b7302feb2510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected16Regular', "16", [
    "M6.01 6.78a1.25 1.25 0 0 0-1.76 0L4.03 7a3.5 3.5 0 0 0-.32 4.58l-2.06 2.07a.5.5 0 0 0 .7.7l2.08-2.07q.92.66 2.03.66c.94 0 1.89-.37 2.6-1.08l.14-.14c.48-.48.48-1.28 0-1.76zm2.48 4.24-.13.13c-1 1-2.6 1.06-3.57.14a2.5 2.5 0 0 1-.06-3.59l.22-.22a.3.3 0 0 1 .18-.07q.1 0 .18.07l3.18 3.18c.1.1.1.26 0 .36m5.86-9.37a.5.5 0 0 0-.7 0l-2.07 2.07a3.6 3.6 0 0 0-4.64.42l-.13.14a1.25 1.25 0 0 0 0 1.76l3.18 3.19a1.24 1.24 0 0 0 1.77 0l.22-.22a3.47 3.47 0 0 0 .31-4.6l2.06-2.06a.5.5 0 0 0 0-.7M11.27 8.3l-.22.22c-.1.1-.26.1-.36 0L7.51 5.34a.25.25 0 0 1 0-.36l.13-.13a2.7 2.7 0 0 1 1.9-.79c.61 0 1.21.21 1.67.65a2.5 2.5 0 0 1 .06 3.59"
]);
const $f342bb1007016cbf$export$3bf47526d16af3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected20Filled', "20", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 0 0 .48-5.12zM7.55 8.85a1.5 1.5 0 0 0-2.1 0l-.3.3a4.04 4.04 0 0 0-.48 5.12l-2.45 2.45a.75.75 0 1 0 1.06 1.06l2.45-2.45a4.04 4.04 0 0 0 5.12-.48l.3-.3c.59-.58.59-1.52 0-2.1z"
]);
const $f342bb1007016cbf$export$26dd3ab07bfd286d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected20Regular', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14.48 4.8a4.04 4.04 0 0 0-5.33.34l-.3.3a1.5 1.5 0 0 0 0 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 0 0 .34-5.33zm-4 7.6c-.2.19-.5.19-.7 0l-3.6-3.6c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 0 1 4.3 4.3zm-6.3-1.6a1.5 1.5 0 0 0-2.1 0l-.3.3a4.04 4.04 0 0 0-.34 5.33l-2.66 2.67a.5.5 0 0 0 .7.7l2.67-2.66a4.04 4.04 0 0 0 5.33-.34l.3-.3c.59-.58.59-1.52 0-2.1zm-1.4.7c.2-.19.5-.19.7 0l3.6 3.6c.19.2.19.5 0 .7l-.3.3a3.04 3.04 0 1 1-4.3-4.3z"
]);
const $f342bb1007016cbf$export$aefc67ce19f298f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected24Filled', "24", [
    "M19.49 5.57a5.97 5.97 0 0 1-1.9 8.96c-.64.35-1.42.14-1.94-.38l-5.8-5.8c-.52-.52-.73-1.3-.38-1.95a6 6 0 0 1 8.96-1.89l2.29-2.29a.75.75 0 1 1 1.06 1.06zM3.28 21.78l2.3-2.29a5.97 5.97 0 0 0 8.95-1.9c.35-.64.14-1.42-.38-1.94l-5.8-5.8c-.52-.52-1.3-.73-1.95-.38a6 6 0 0 0-1.89 8.96l-2.29 2.29a.75.75 0 1 0 1.06 1.06"
]);
const $f342bb1007016cbf$export$c3a472597828083d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected24Regular', "24", [
    "M19.49 5.57a5.97 5.97 0 0 1-1.9 8.96c-.64.35-1.42.14-1.94-.38l-5.8-5.8c-.52-.52-.73-1.3-.38-1.95a6 6 0 0 1 8.96-1.89l2.29-2.29a.75.75 0 1 1 1.06 1.06zm-2.02 7.26a4.5 4.5 0 1 0-6.3-6.3c-.27.35-.19.83.12 1.14l5.04 5.04c.31.3.8.39 1.14.12M3.28 21.78l2.3-2.29a5.97 5.97 0 0 0 8.95-1.9c.35-.64.14-1.42-.38-1.94l-5.8-5.8c-.52-.52-1.3-.73-1.95-.38a6 6 0 0 0-1.89 8.96l-2.29 2.29a.75.75 0 1 0 1.06 1.06m4.39-10.49 5.04 5.04c.3.31.39.8.12 1.14a4.5 4.5 0 1 1-6.3-6.3c.35-.27.83-.19 1.14.12"
]);
const $f342bb1007016cbf$export$9790564de9fe8b09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected28Filled', "28", [
    "M12.31 5.8a2.75 2.75 0 0 0 0 3.88l6.01 6.01a2.75 2.75 0 0 0 3.89 0l.74-.74a7 7 0 0 0 .5-9.34l2.33-2.33a.75.75 0 1 0-1.06-1.06l-2.33 2.33a7 7 0 0 0-9.34.5zm3.38 12.52a2.75 2.75 0 0 1 0 3.88l-.74.75a7 7 0 0 1-9.34.5l-2.33 2.33a.75.75 0 1 1-1.06-1.06l2.33-2.33a7 7 0 0 1 .5-9.34l.74-.74a2.75 2.75 0 0 1 3.9 0z"
]);
const $f342bb1007016cbf$export$ea7647002ed7d98a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected28Regular', "28", [
    "M13.37 8.62a1.25 1.25 0 0 1 0-1.76l.74-.75a5.5 5.5 0 0 1 7.78 7.78l-.74.74c-.49.5-1.28.5-1.77 0zM12.31 5.8a2.75 2.75 0 0 0 0 3.9l6.01 6a2.75 2.75 0 0 0 3.89 0l.74-.74a7 7 0 0 0 .5-9.34l2.33-2.33a.75.75 0 1 0-1.06-1.06l-2.33 2.33a7 7 0 0 0-9.34.5zm2.32 13.59c.5.48.5 1.28 0 1.76l-.74.75A5.5 5.5 0 1 1 6.1 14.1l.75-.74a1.25 1.25 0 0 1 1.76 0zm1.06 2.82a2.75 2.75 0 0 0 0-3.88l-6-6.01a2.75 2.75 0 0 0-3.9 0l-.74.74a7 7 0 0 0-.5 9.34l-2.33 2.33a.75.75 0 0 0 1.06 1.06l2.33-2.33a7 7 0 0 0 9.34-.5z"
]);
const $f342bb1007016cbf$export$22a18491c2aa0125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected32Filled', "32", [
    "M13.45 6.53a3.25 3.25 0 0 0 0 4.6l7.43 7.42a3.25 3.25 0 0 0 4.6 0l.03-.04a8.5 8.5 0 0 0 .67-11.27L29.7 3.7a1 1 0 0 0-1.42-1.42l-3.53 3.53a8.5 8.5 0 0 0-11.27.67zm5.1 14.35a3.25 3.25 0 0 1 0 4.6l-.04.03a8.5 8.5 0 0 1-11.27.67L3.71 29.7a1 1 0 0 1-1.41-1.42l3.53-3.53a8.5 8.5 0 0 1 .66-11.27l.04-.04a3.25 3.25 0 0 1 4.6 0z"
]);
const $f342bb1007016cbf$export$c1ba51d0f49d5fbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected32Regular', "32", [
    "M13.45 6.53a3.25 3.25 0 0 0 0 4.6l7.43 7.42a3.25 3.25 0 0 0 4.6 0l.03-.04a8.5 8.5 0 0 0 .67-11.27L29.7 3.7a1 1 0 0 0-1.42-1.42l-3.53 3.53a8.5 8.5 0 0 0-11.27.67zm1.42 3.18a1.25 1.25 0 0 1 0-1.77l.04-.04a6.5 6.5 0 1 1 9.19 9.2l-.04.03c-.49.49-1.28.49-1.77 0zm3.68 15.76a3.25 3.25 0 0 0 0-4.6l-7.43-7.42a3.25 3.25 0 0 0-4.6 0l-.03.04a8.5 8.5 0 0 0-.66 11.27L2.3 28.3a1 1 0 1 0 1.41 1.42l3.53-3.53a8.5 8.5 0 0 0 11.27-.67zm-1.41-3.18c.48.49.48 1.28 0 1.77l-.04.04a6.5 6.5 0 0 1-9.2-9.2l.04-.03a1.25 1.25 0 0 1 1.77 0z"
]);
const $f342bb1007016cbf$export$bae7134e3524bdc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected48Filled', "48", [
    "m21.51 9.51-1.27 1.27a4.25 4.25 0 0 0 0 6.01L31.2 27.75a4.25 4.25 0 0 0 6.02 0l1.27-1.27a12 12 0 0 0 .83-16.04l4.31-4.3a1.25 1.25 0 1 0-1.76-1.77l-4.31 4.3a12 12 0 0 0-16.05.84m6.25 27.7-1.27 1.28a12 12 0 0 1-16.05.83l-4.3 4.31a1.25 1.25 0 1 1-1.77-1.76l4.3-4.31a12 12 0 0 1 .84-16.05l1.27-1.27a4.25 4.25 0 0 1 6.02 0L27.76 31.2a4.25 4.25 0 0 1 0 6.02"
]);
const $f342bb1007016cbf$export$dae03e7bc7d7ca31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnected48Regular', "48", [
    "m21.51 9.51-1.27 1.27a4.25 4.25 0 0 0 0 6.01L31.2 27.75a4.25 4.25 0 0 0 6.02 0l1.27-1.27a12 12 0 0 0 .83-16.04l4.31-4.3a1.25 1.25 0 1 0-1.76-1.77l-4.31 4.3a12 12 0 0 0-16.05.84m.5 3.04 1.27-1.27a9.5 9.5 0 0 1 13.44 13.44l-1.27 1.27c-.69.68-1.8.68-2.48 0L22.01 15.03a1.75 1.75 0 0 1 0-2.48M26.5 38.5l1.27-1.27a4.25 4.25 0 0 0 0-6.02L16.8 20.24a4.25 4.25 0 0 0-6.02 0l-1.27 1.27a12 12 0 0 0-.83 16.05l-4.31 4.3a1.25 1.25 0 0 0 1.76 1.77l4.31-4.3a12 12 0 0 0 16.05-.84m-.5-3.04-1.27 1.27a9.5 9.5 0 0 1-13.44-13.44l1.27-1.27c.69-.68 1.8-.68 2.48 0l10.96 10.96c.68.69.68 1.8 0 2.48"
]);
const $f342bb1007016cbf$export$e6c9cbb400b679e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedAdd20Filled', "20", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47a5.5 5.5 0 0 1 4.55-.85 4 4 0 0 0-.53-3.44zM7.55 8.85l2.47 2.46a5.5 5.5 0 0 0-.85 4.55 4 4 0 0 1-3.44-.53l-2.45 2.45a.75.75 0 0 1-1.06-1.06l2.45-2.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2.1 0m9.45 9.4a4.5 4.5 0 1 1-5-7.5 4.5 4.5 0 0 1 5 7.5m-2.15-6.1a.5.5 0 0 0-.85.35V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.15-.35"
]);
const $f342bb1007016cbf$export$f90f90467b6b4bd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedAdd20Regular', "20", [
    "M17.96 2.3a.5.5 0 0 0-.82-.15l-2.7 2.7a4.04 4.04 0 0 0-5.33.33l-.6.61a1.05 1.05 0 0 0 0 1.49l2.76 2.76q.42-.3.89-.52L9.52 6.88a.5.5 0 0 1 0-.7l.3-.3a3.03 3.03 0 0 1 4.29 0v.02a3 3 0 0 1 .73 3.11q.51.03 1 .16a4 4 0 0 0-.69-3.62l2.7-2.7a.5.5 0 0 0 .11-.54M7.28 8.5l2.77 2.77q-.3.42-.53.88L6.9 9.52a.5.5 0 0 0-.7 0l-.3.3a3.04 3.04 0 0 0 0 4.29h.01a3 3 0 0 0 3.11.73q.03.52.15 1a4 4 0 0 1-3.6-.69l-2.7 2.7a.5.5 0 1 1-.71-.7l2.7-2.7a4.03 4.03 0 0 1 .33-5.34l.3-.3.31-.31a1.05 1.05 0 0 1 1.49 0M17 18.24a4.5 4.5 0 1 1-5-7.48 4.5 4.5 0 0 1 5 7.48m-2.15-6.1a.5.5 0 0 0-.85.36V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.15-.35"
]);
const $f342bb1007016cbf$export$e6e377458714e8bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedCheckmark20Filled', "20", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47a5.5 5.5 0 0 1 4.55-.85 4 4 0 0 0-.53-3.44zM7.55 8.85l2.47 2.46a5.5 5.5 0 0 0-.85 4.55 4 4 0 0 1-3.44-.53l-2.45 2.45a.75.75 0 0 1-1.06-1.06l2.45-2.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2.1 0M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $f342bb1007016cbf$export$21d5b732df56fc85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedCheckmark20Regular', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14.48 4.8a4.04 4.04 0 0 0-5.33.34l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47q.42-.3.9-.52L9.55 6.85c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 0 1 5.01 3.16q.52.04 1 .16c.37-1.23.15-2.6-.67-3.65zm-10.3 6 2.47 2.46q-.3.42-.52.9L6.85 9.55c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 0 0 3.16 5.01q.04.52.16 1c-1.23.37-2.6.15-3.65-.67l-2.67 2.66a.5.5 0 0 1-.7-.7l2.66-2.67a4.04 4.04 0 0 1 .34-5.33l.3-.3a1.5 1.5 0 0 1 2.1 0M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7"
]);
const $f342bb1007016cbf$export$148fd1b938359e95 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedSettings20Filled', "20", [
    "M17.78 3.28a.75.75 0 0 0-1.06-1.06l-2.45 2.45a4.04 4.04 0 0 0-5.12.48l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47a5.5 5.5 0 0 1 4.55-.85 4 4 0 0 0-.53-3.44zM7.55 8.85l2.47 2.46a5.5 5.5 0 0 0-.85 4.55 4 4 0 0 1-3.44-.53l-2.45 2.45a.75.75 0 0 1-1.06-1.06l2.45-2.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2.1 0m3.09 5.07a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $f342bb1007016cbf$export$3982a6ab8cd26432 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedSettings20Regular', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14.48 4.8a4.04 4.04 0 0 0-5.33.34l-.3.3a1.5 1.5 0 0 0 0 2.1l2.46 2.47q.42-.3.9-.52L9.55 6.85c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 0 1 5.01 3.16q.52.04 1 .16c.37-1.23.15-2.6-.67-3.65zm-10.3 6 2.47 2.46q-.3.42-.52.9L6.85 9.55c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 0 0 3.16 5.01q.04.52.16 1c-1.23.37-2.6.15-3.65-.67l-2.67 2.66a.5.5 0 0 1-.7-.7l2.66-2.67a4.04 4.04 0 0 1 .34-5.33l.3-.3a1.5 1.5 0 0 1 2.1 0m3.09 5.07a2 2 0 0 0 1.43-2.48l-.16-.55q.38-.3.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35q.45.22.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a5 5 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55q-.38.3-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35q-.45-.21-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a5 5 0 0 1 0-1.01zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
]);
const $f342bb1007016cbf$export$2723eaf78bbc6115 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedSettings24Filled', "24", [
    "M19.49 5.57a6 6 0 0 1 .78 6.05 6.5 6.5 0 0 0-6.55.6L9.84 8.35c-.52-.52-.73-1.3-.38-1.95a6 6 0 0 1 8.96-1.89l2.29-2.29a.75.75 0 1 1 1.06 1.06zM11 17.5c0-1.41.45-2.72 1.21-3.78L8.36 9.85c-.52-.52-1.3-.73-1.95-.38a6 6 0 0 0-1.89 8.96l-2.29 2.29a.75.75 0 1 0 1.06 1.06l2.3-2.29a6 6 0 0 0 6.04.78A6.5 6.5 0 0 1 11 17.5m1.84-1.03a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91l.5.52a2 2 0 0 0 2.9 0l.5-.52q.82.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.67.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.93l.19-.63a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8zm3.21 1.03c0 .83.65 1.5 1.45 1.5s1.45-.67 1.45-1.5S18.3 16 17.5 16s-1.45.67-1.45 1.5"
]);
const $f342bb1007016cbf$export$3c12106ceb412549 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugConnectedSettings24Regular', "24", [
    "M19.49 5.57a6 6 0 0 1 .78 6.05 7 7 0 0 0-1.43-.48 4.5 4.5 0 0 0-4.09-6.39 4.5 4.5 0 0 0-3.58 1.78c-.27.35-.19.83.12 1.14l3.8 3.8q-.74.28-1.37.75L9.84 8.35c-.52-.52-.73-1.3-.38-1.95a6 6 0 0 1 8.96-1.89l2.29-2.29a.75.75 0 1 1 1.06 1.06zM8.35 9.85l3.87 3.87q-.46.63-.76 1.36L7.67 11.3c-.31-.3-.8-.39-1.14-.12a4.5 4.5 0 0 0 4.6 7.67q.16.74.49 1.43a6 6 0 0 1-6.05-.78l-2.29 2.29a.75.75 0 0 1-1.06-1.06l2.29-2.3a5.97 5.97 0 0 1 1.9-8.95c.64-.35 1.42-.14 1.94.38m4.49 6.62a2 2 0 0 0 1.44-2.5l-.2-.68q.66-.58 1.48-.91l.5.52a2 2 0 0 0 2.9 0l.5-.52q.82.35 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a6 6 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68q-.67.58-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5 5 0 0 1-1.48-.93l.19-.63a2 2 0 0 0-1.45-2.5l-.54-.14a6 6 0 0 1 0-1.8zm3.21 1.03c0 .83.65 1.5 1.45 1.5s1.45-.67 1.45-1.5S18.3 16 17.5 16s-1.45.67-1.45 1.5"
]);
const $f342bb1007016cbf$export$214126c764d71ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected16Filled', "16", [
    "M15.35.65a.5.5 0 0 0-.7 0l-2.07 2.07a3.6 3.6 0 0 0-4.64.42l-.13.14a1.25 1.25 0 0 0 0 1.76l3.18 3.19a1.24 1.24 0 0 0 1.77 0l.22-.22a3.47 3.47 0 0 0 .31-4.6l2.06-2.06a.5.5 0 0 0 0-.7m-7.2 8.5-.88.88-1.3-1.3.88-.88a.5.5 0 0 0-.7-.7l-.88.88L5 7.77a1.25 1.25 0 0 0-1.76 0L3.03 8a3.47 3.47 0 0 0-.32 4.6L.65 14.63a.5.5 0 0 0 .7.71l2.08-2.07q.92.65 2.03.65c.94 0 1.89-.36 2.6-1.08l.14-.13c.48-.48.48-1.28 0-1.77l-.23-.22.88-.88a.5.5 0 0 0-.7-.7"
]);
const $f342bb1007016cbf$export$a47f804343003943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected16Regular', "16", [
    "M15.35.65a.5.5 0 0 0-.7 0l-2.07 2.07a3.6 3.6 0 0 0-4.64.42l-.13.14a1.25 1.25 0 0 0 0 1.76l3.18 3.19a1.24 1.24 0 0 0 1.77 0l.22-.22a3.47 3.47 0 0 0 .31-4.6l2.06-2.06a.5.5 0 0 0 0-.7M12.27 7.3l-.22.22c-.1.1-.26.1-.36 0L8.51 4.34a.25.25 0 0 1 0-.36l.13-.13a2.7 2.7 0 0 1 1.9-.79c.61 0 1.21.21 1.67.65a2.5 2.5 0 0 1 .06 3.59M8.15 9.15l-.88.88-1.3-1.3.88-.88a.5.5 0 0 0-.7-.7l-.88.88L5 7.77a1.25 1.25 0 0 0-1.76 0L3.03 8a3.47 3.47 0 0 0-.32 4.6L.65 14.63a.5.5 0 0 0 .7.71l2.08-2.07q.92.65 2.03.65c.94 0 1.89-.36 2.6-1.08l.14-.13c.48-.48.48-1.28 0-1.77l-.23-.22.88-.88a.5.5 0 0 0-.7-.7m-.66 2.87-.13.13c-1 1-2.6 1.06-3.57.14a2.5 2.5 0 0 1-.06-3.59l.22-.22a.3.3 0 0 1 .18-.07q.1 0 .18.07l3.18 3.18c.1.1.1.26 0 .36"
]);
const $f342bb1007016cbf$export$7478aed00064cfc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected20Filled', "20", [
    "M17.78 2.22c.3.3.3.77 0 1.06l-1.45 1.45a4.04 4.04 0 0 1-.48 5.12l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 0 1 0-1.48l.6-.61a4.05 4.05 0 0 1 5.13-.48l1.45-1.45c.3-.3.77-.3 1.06 0m-9 6.25c.3.3.3.77 0 1.06L7.51 10.8l1.69 1.7 1.27-1.28a.75.75 0 1 1 1.06 1.06l-1.28 1.28c.48.58.45 1.45-.1 2l-.3.3a4.04 4.04 0 0 1-5.12.47l-1.45 1.45a.75.75 0 0 1-1.06-1.06l1.45-1.45a4.04 4.04 0 0 1 .48-5.12l.3-.3a1.5 1.5 0 0 1 2-.1l1.27-1.28c.3-.3.77-.3 1.06 0"
]);
const $f342bb1007016cbf$export$769bb2e5df9b4e0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected20Regular', "20", [
    "M17.85 2.15c.2.2.2.5 0 .7L16.2 4.52a4.04 4.04 0 0 1-.34 5.33l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 0 1 0-1.48l.6-.61a4.04 4.04 0 0 1 5.34-.34l1.67-1.66c.2-.2.5-.2.7 0m-2.71 2.7a3.04 3.04 0 0 0-4.29 0l-.3.3c-.19.2-.19.5 0 .7l3.6 3.6c.2.19.5.19.7 0l.3-.3a3.04 3.04 0 0 0 0-4.29zm-5.79 3.8c.2.2.2.5 0 .7L7.71 11 9 12.3l1.65-1.65a.5.5 0 0 1 .7.7L9.71 13l.44.45c.59.58.59 1.52 0 2.1l-.3.3a4.04 4.04 0 0 1-5.33.34l-1.67 1.66a.5.5 0 0 1-.7-.7l1.66-1.67a4.04 4.04 0 0 1 .34-5.33l.3-.3a1.5 1.5 0 0 1 2.1 0l.45.44 1.65-1.64c.2-.2.5-.2.7 0m-4.5 6.5a3.04 3.04 0 0 0 4.3 0l.3-.3c.19-.2.19-.5 0-.7l-3.6-3.6c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 0 0 0 4.3"
]);
const $f342bb1007016cbf$export$8d879a1c8cb57a47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected24Filled', "24", [
    "M21.7 3.7a1 1 0 0 0-1.4-1.4l-1.8 1.79a4.25 4.25 0 0 0-5.26.6l-1.06 1.07c-.69.69-.69 1.8 0 2.48l3.58 3.58c.69.69 1.8.69 2.48 0l1.07-1.06a4.25 4.25 0 0 0 .6-5.26zm-11 8a1 1 0 0 0-1.4-1.4l-1.48 1.46-.29-.29a.75.75 0 0 0-1.06 0l-1.78 1.77a4.25 4.25 0 0 0-.6 5.26l-1.8 1.8a1 1 0 1 0 1.42 1.4l1.8-1.79a4.25 4.25 0 0 0 5.25-.6l1.77-1.78c.3-.3.3-.77 0-1.06l-.3-.3 1.48-1.46a1 1 0 0 0-1.42-1.42l-1.47 1.47-1.58-1.58z"
]);
const $f342bb1007016cbf$export$2024caa567d64ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected24Regular', "24", [
    "M21.78 3.28a.75.75 0 0 0-1.06-1.06l-2.01 2.01a4.25 4.25 0 0 0-5.47.46l-1.06 1.07c-.69.69-.69 1.8 0 2.48l3.58 3.58c.69.69 1.8.69 2.48 0l1.07-1.06a4.25 4.25 0 0 0 .46-5.47zm-3.59 2.48.03.02.02.03a2.75 2.75 0 0 1 0 3.88l-1.06 1.07c-.1.1-.26.1-.36 0l-3.58-3.58a.25.25 0 0 1 0-.36l1.07-1.06a2.75 2.75 0 0 1 3.88 0m-7.41 5.52a.75.75 0 1 0-1.06-1.06L8 11.94l-.47-.47a.75.75 0 0 0-1.06 0l-1.78 1.77a4.25 4.25 0 0 0-.46 5.47l-2.01 2.01a.75.75 0 1 0 1.06 1.06l2.01-2.01a4.25 4.25 0 0 0 5.47-.46l1.77-1.78c.3-.3.3-.77 0-1.06l-.47-.47 1.72-1.72a.75.75 0 1 0-1.06-1.06L11 14.94 9.06 13zm-3.31 2.25 3 3 .47.47-1.25 1.24a2.75 2.75 0 0 1-3.88 0l-.05-.05a2.75 2.75 0 0 1 0-3.88L7 13.06z"
]);
const $f342bb1007016cbf$export$3d661f48028cc411 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected28Filled', "28", [
    "M22.74 6.33a5.5 5.5 0 0 1-.5 7.2l-1.94 1.95c-.3.3-.77.3-1.06 0l-6.72-6.71a.75.75 0 0 1 0-1.06l1.95-1.95a5.5 5.5 0 0 1 7.2-.5l3.05-3.04a.75.75 0 0 1 1.06 1.06zm-9.96 5.95a.75.75 0 0 0-1.06-1.06l-2.13 2.12-.82-.82a.75.75 0 0 0-1.06 0l-1.95 1.94a5.5 5.5 0 0 0-.5 7.22l-3.04 3.04a.75.75 0 1 0 1.06 1.06l3.05-3.04a5.5 5.5 0 0 0 7.21-.5l1.95-1.94c.29-.3.29-.77 0-1.06l-.83-.83 2.12-2.13a.75.75 0 1 0-1.06-1.06l-2.12 2.13-2.95-2.95z"
]);
const $f342bb1007016cbf$export$b09aed11e25b392e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected28Regular', "28", [
    "M22.74 6.33a5.5 5.5 0 0 1-.5 7.2l-1.94 1.95c-.3.3-.77.3-1.06 0l-6.72-6.71a.75.75 0 0 1 0-1.06l1.95-1.95a5.5 5.5 0 0 1 7.2-.5l3.05-3.04a.75.75 0 0 1 1.06 1.06zm-2.97 7.56 1.41-1.41a4 4 0 1 0-5.65-5.66L14.1 8.24zm-7-2.68c.3.3.3.77 0 1.07l-2.12 2.12 2.95 2.95 2.12-2.13a.75.75 0 0 1 1.06 1.06l-2.12 2.13.83.83c.29.29.29.76 0 1.06l-1.95 1.94a5.5 5.5 0 0 1-7.21.5l-3.05 3.04a.75.75 0 0 1-1.06-1.06l3.05-3.04a5.5 5.5 0 0 1 .5-7.22l1.94-1.94c.29-.3.76-.3 1.06 0l.82.82 2.13-2.12c.29-.3.76-.3 1.06 0M6.84 21.2a4 4 0 0 0 5.65 0l1.41-1.42-5.65-5.66-1.42 1.41a4 4 0 0 0 0 5.65z"
]);
const $f342bb1007016cbf$export$f7aef78769494efc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected48Filled', "48", [
    "M43.63 4.37c.5.48.5 1.28 0 1.76l-4.91 4.92a9.25 9.25 0 0 1-.74 12.24l-3.35 3.34c-.48.5-1.28.5-1.76 0l-11.5-11.5a1.25 1.25 0 0 1 0-1.76l3.34-3.35a9.25 9.25 0 0 1 12.24-.74l4.92-4.91a1.25 1.25 0 0 1 1.76 0M9.28 36.95l-4.91 4.92a1.25 1.25 0 0 0 1.76 1.76l4.92-4.91a9.25 9.25 0 0 0 12.24-.74l3.34-3.35c.5-.48.5-1.28 0-1.76l-1.36-1.37 3.36-3.37a1.25 1.25 0 0 0-1.76-1.76l-3.37 3.36-5.23-5.23 3.36-3.37a1.25 1.25 0 0 0-1.76-1.76l-3.37 3.36-1.37-1.36a1.25 1.25 0 0 0-1.76 0l-3.35 3.34a9.25 9.25 0 0 0-.74 12.24"
]);
const $f342bb1007016cbf$export$c9af4d8b72c687b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugDisconnected48Regular', "48", [
    "M43.63 4.37c.5.48.5 1.28 0 1.76l-4.91 4.92a9.25 9.25 0 0 1-.74 12.24l-3.35 3.34c-.48.5-1.28.5-1.76 0l-11.5-11.5a1.25 1.25 0 0 1 0-1.76l3.34-3.35a9.25 9.25 0 0 1 12.24-.74l4.92-4.91a1.25 1.25 0 0 1 1.76 0m-7.6 7.42a6.75 6.75 0 0 0-9.55 0l-2.46 2.46 9.73 9.73 2.46-2.46a6.75 6.75 0 0 0 0-9.54zM9.27 36.95l-4.91 4.92a1.25 1.25 0 0 0 1.76 1.76l4.92-4.91a9.25 9.25 0 0 0 12.24-.74l3.34-3.35c.5-.48.5-1.28 0-1.76l-1.36-1.37 3.36-3.37a1.25 1.25 0 0 0-1.76-1.76l-3.37 3.36-5.23-5.23 3.36-3.37a1.25 1.25 0 0 0-1.76-1.76l-3.37 3.36-1.37-1.36a1.25 1.25 0 0 0-1.76 0l-3.35 3.34a9.25 9.25 0 0 0-.74 12.24m2.51-10.47 2.46-2.46 9.73 9.73-2.46 2.46a6.75 6.75 0 0 1-9.54 0l-.19-.19a6.75 6.75 0 0 1 0-9.54"
]);
const $f342bb1007016cbf$export$6fb2aed56acca17e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle16Filled', "16", [
    "M2 11.2c0-.39.31-.7.7-.7H3a1.5 1.5 0 0 0 0-3h-.3a.7.7 0 0 1-.7-.7V5.5A2.5 2.5 0 0 1 4.5 3h1a.5.5 0 0 1 0 1h-1C3.67 4 3 4.67 3 5.5v1a2.5 2.5 0 0 1 0 5v1c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5V9h-.5A2.5 2.5 0 0 1 8 6.5V5.3c0-.61.43-1.13 1-1.26V2.5a.5.5 0 0 1 1 0V4h2V2.5a.5.5 0 0 1 1 0v1.54c.57.13 1 .65 1 1.26v1.2a2.5 2.5 0 0 1-2 2.45v3.55A2.5 2.5 0 0 1 9.5 15h-5A2.5 2.5 0 0 1 2 12.5z"
]);
const $f342bb1007016cbf$export$e6f8cef6cea91e58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle16Regular', "16", [
    "M2 11.2c0-.39.31-.7.7-.7H3a1.5 1.5 0 0 0 0-3h-.3a.7.7 0 0 1-.7-.7V5.5A2.5 2.5 0 0 1 4.5 3h1a.5.5 0 0 1 0 1h-1C3.67 4 3 4.67 3 5.5v1a2.5 2.5 0 0 1 0 5v1c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5V9h-.5A2.5 2.5 0 0 1 8 6.5V5.3c0-.61.43-1.13 1-1.26V2.5a.5.5 0 0 1 1 0V4h2V2.5a.5.5 0 0 1 1 0v1.54c.57.13 1 .65 1 1.26v1.2a2.5 2.5 0 0 1-2 2.45v3.55A2.5 2.5 0 0 1 9.5 15h-5A2.5 2.5 0 0 1 2 12.5zm7-4.7c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V5.3a.3.3 0 0 0-.3-.3H9.3a.3.3 0 0 0-.3.3z"
]);
const $f342bb1007016cbf$export$3afccd67449cbd1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle20Filled', "20", [
    "M3 13.73c0-.4.33-.73.73-.73H4a2 2 0 1 0 0-4h-.27A.73.73 0 0 1 3 8.27V7a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v1a3 3 0 0 1 0 6v1c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-3h-.5A3.5 3.5 0 0 1 10 8.5v-2c0-.83.67-1.5 1.5-1.5h.5V3.5a.5.5 0 0 1 1 0V5h2V3.5a.5.5 0 0 1 1 0V5h.5c.83 0 1.5.67 1.5 1.5v2a3.5 3.5 0 0 1-3 3.46V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
]);
const $f342bb1007016cbf$export$6109c0b194534f8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle20Regular', "20", [
    "M3 13.73c0-.4.33-.73.73-.73H4a2 2 0 1 0 0-4h-.27A.73.73 0 0 1 3 8.27V7a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v1a3 3 0 0 1 0 6v1c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-3h-.5A3.5 3.5 0 0 1 10 8.5v-2c0-.83.67-1.5 1.5-1.5h.5V3.5a.5.5 0 0 1 1 0V5h2V3.5a.5.5 0 0 1 1 0V5h.5c.83 0 1.5.67 1.5 1.5v2a3.5 3.5 0 0 1-3 3.46V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm8-5.23a2.5 2.5 0 0 0 2.5 2.5h1A2.5 2.5 0 0 0 17 8.5v-2a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5z"
]);
const $f342bb1007016cbf$export$66d8c4d541713fc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle24Filled', "24", [
    "M3 16.35a1 1 0 0 1 1-1h.5c1.24 0 2.25-1 2.25-2.25V13c0-1.24-1-2.25-2.25-2.25H4a1 1 0 0 1-1-1v-2.5C3 5.45 4.45 4 6.25 4H8.5a.75.75 0 1 1 0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v2A3.75 3.75 0 0 1 8.25 13v.1a3.75 3.75 0 0 1-3.75 3.75v1.9c0 .97.78 1.75 1.75 1.75h8.5c.97 0 1.75-.78 1.75-1.75V15h-.25A4.25 4.25 0 0 1 12 10.75v-3c0-.97.78-1.75 1.75-1.75h.75V4A.75.75 0 0 1 16 4v2h2V4a.75.75 0 0 1 1.5 0v2h.75c.97 0 1.75.78 1.75 1.75v3a4.25 4.25 0 0 1-4 4.24v3.76c0 1.8-1.46 3.25-3.25 3.25h-8.5A3.25 3.25 0 0 1 3 18.75z"
]);
const $f342bb1007016cbf$export$1ee823f5e809b3c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle24Regular', "24", [
    "M3 16.35a1 1 0 0 1 1-1h.5c1.24 0 2.25-1 2.25-2.25V13c0-1.24-1-2.25-2.25-2.25H4a1 1 0 0 1-1-1v-2.5C3 5.45 4.45 4 6.25 4H8.5a.75.75 0 1 1 0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v2A3.75 3.75 0 0 1 8.25 13v.1a3.75 3.75 0 0 1-3.75 3.75v1.9c0 .97.78 1.75 1.75 1.75h8.5c.97 0 1.75-.78 1.75-1.75V15h-.25A4.25 4.25 0 0 1 12 10.75v-3c0-.97.78-1.75 1.75-1.75h.75V4A.75.75 0 0 1 16 4v2h2V4a.75.75 0 0 1 1.5 0v2h.75c.97 0 1.75.78 1.75 1.75v3a4.25 4.25 0 0 1-4 4.24v3.76c0 1.8-1.46 3.25-3.25 3.25h-8.5A3.25 3.25 0 0 1 3 18.75zm10.5-5.6a2.75 2.75 0 0 0 2.75 2.75h1.5a2.75 2.75 0 0 0 2.75-2.75v-3a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25z"
]);
const $f342bb1007016cbf$export$80bee8c15e46ffcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle32Filled', "32", [
    "M4 20.88c0-.76.62-1.38 1.38-1.38H6a3 3 0 0 0 0-6h-.62c-.76 0-1.38-.62-1.38-1.38V9a5 5 0 0 1 5-5h3a1 1 0 1 1 0 2H9a3 3 0 0 0-3 3v2.5a5 5 0 0 1 0 10V24a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-6a5 5 0 0 1-5-5V9.6a2.6 2.6 0 0 1 2-2.53V4a1 1 0 0 1 2 0v3h4V4a1 1 0 0 1 2 0v3.07c1.15.27 2 1.3 2 2.53V13a5 5 0 0 1-5 5v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z"
]);
const $f342bb1007016cbf$export$930551e9bc17137c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PlugPuzzle32Regular', "32", [
    "M4 20.88c0-.76.62-1.38 1.38-1.38H6a3 3 0 0 0 0-6h-.62c-.76 0-1.38-.62-1.38-1.38V9a5 5 0 0 1 5-5h3a1 1 0 1 1 0 2H9a3 3 0 0 0-3 3v2.5a5 5 0 0 1 0 10V24a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-6a5 5 0 0 1-5-5V9.6a2.6 2.6 0 0 1 2-2.53V4a1 1 0 0 1 2 0v3h4V4a1 1 0 0 1 2 0v3.07c1.15.27 2 1.3 2 2.53V13a5 5 0 0 1-5 5v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM20 13a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3V9.6a.6.6 0 0 0-.6-.6h-6.8a.6.6 0 0 0-.6.6z"
]);
const $f342bb1007016cbf$export$a907d878614f73b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortHdmi20Filled', "20", [
    "M4.85 7.44A1.5 1.5 0 0 1 5.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 11.5v-.59q.01-.62.44-1.06zM6.5 9.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$686b73a16a4e41bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortHdmi20Regular', "20", [
    "M4.85 7.44A1.5 1.5 0 0 1 5.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 11.5v-.59q.01-.62.44-1.06zM5.91 8a.5.5 0 0 0-.35.15l-2.41 2.41a.5.5 0 0 0-.15.35v.59c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-.59a.5.5 0 0 0-.15-.35l-2.41-2.41a.5.5 0 0 0-.35-.15zM6 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 6 10"
]);
const $f342bb1007016cbf$export$6cd8e0d85f453980 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortHdmi24Filled', "24", [
    "m21.41 11.41-2.82-2.82A2 2 0 0 0 17.17 8H6.83a2 2 0 0 0-1.42.59l-2.82 2.82A2 2 0 0 0 2 12.83V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-1.17a2 2 0 0 0-.59-1.42M17 12a.75.75 0 0 1-.75.75h-8.5a.75.75 0 1 1 0-1.5h8.5A.76.76 0 0 1 17 12"
]);
const $f342bb1007016cbf$export$b9862fd502d20caa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortHdmi24Regular', "24", [
    "M21.41 11.41 18.6 8.6A2 2 0 0 0 17.17 8H6.83a2 2 0 0 0-1.42.59L2.6 11.4A2 2 0 0 0 2 12.83V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-1.17a2 2 0 0 0-.59-1.42M20.5 14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-1.17a.5.5 0 0 1 .15-.36l2.82-2.82a.5.5 0 0 1 .36-.15h10.34a.5.5 0 0 1 .36.15l2.82 2.82a.5.5 0 0 1 .15.36zm-4.25-2.75h-8.5a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5"
]);
const $f342bb1007016cbf$export$217825b2ef6cb08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortMicroUsb20Filled', "20", [
    "M6.43 8.3q.4-.3.9-.3h5.34q.5 0 .9.3l1.33 1A1.5 1.5 0 0 1 14 12H6a1.5 1.5 0 0 1-.9-2.7z"
]);
const $f342bb1007016cbf$export$33926e81fff211ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortMicroUsb20Regular', "20", [
    "M6.43 8.3q.4-.3.9-.3h5.34q.5 0 .9.3l1.33 1A1.5 1.5 0 0 1 14 12H6a1.5 1.5 0 0 1-.9-2.7zm.9.7a.5.5 0 0 0-.3.1l-1.33 1a.5.5 0 0 0 .3.9h8a.5.5 0 0 0 .3-.9l-1.33-1a.5.5 0 0 0-.3-.1z"
]);
const $f342bb1007016cbf$export$80b74be766dea9a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortMicroUsb24Filled', "24", [
    "M19 12.83V13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-.17a2 2 0 0 1 .59-1.42l1.82-1.82A2 2 0 0 1 8.83 9h6.34a2 2 0 0 1 1.42.59l1.82 1.82a2 2 0 0 1 .59 1.42"
]);
const $f342bb1007016cbf$export$3093abf981951ef1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortMicroUsb24Regular', "24", [
    "M15.17 10.5a.5.5 0 0 1 .36.15l1.82 1.82a.5.5 0 0 1 .15.36V13a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-.17a.5.5 0 0 1 .15-.36l1.82-1.82a.5.5 0 0 1 .36-.15zm0-1.5H8.83a2 2 0 0 0-1.42.59L5.6 11.4A2 2 0 0 0 5 12.83V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-.17a2 2 0 0 0-.59-1.42L16.6 9.6A2 2 0 0 0 15.17 9"
]);
const $f342bb1007016cbf$export$17d5cc31b83ec175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbA20Filled', "20", [
    "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zm0 1.5h11V10h-11z"
]);
const $f342bb1007016cbf$export$a13efaf067376077 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbA20Regular', "20", [
    "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5zM4 8.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5V10H4z"
]);
const $f342bb1007016cbf$export$17dd9392d465c25a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbA24Filled', "24", [
    "M18 8H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2M6 10h12v2H6z"
]);
const $f342bb1007016cbf$export$641042667295417b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbA24Regular', "24", [
    "M18 8H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2M5.5 10a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v2h-13z"
]);
const $f342bb1007016cbf$export$92a3a3b986ec5591 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbC20Filled', "20", [
    "M4.5 10c0-1.1.9-2 2-2h7a2 2 0 1 1 0 4h-7a2 2 0 0 1-2-2"
]);
const $f342bb1007016cbf$export$95f9e3a641ce96f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbC20Regular', "20", [
    "M4.5 10c0-1.1.9-2 2-2h7a2 2 0 1 1 0 4h-7a2 2 0 0 1-2-2m2-1a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2z"
]);
const $f342bb1007016cbf$export$2e29468491171882 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbC24Filled', "24", [
    "M19 12a3 3 0 0 1-3 3H8a3 3 0 0 1 0-6h8a3 3 0 0 1 3 3"
]);
const $f342bb1007016cbf$export$edfdb327d6a46aa7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PortUsbC24Regular', "24", [
    "M16 10.5a1.5 1.5 0 1 1 0 3H8a1.5 1.5 0 1 1 0-3zM16 9H8a3 3 0 1 0 0 6h8a3 3 0 0 0 0-6"
]);
const $f342bb1007016cbf$export$36e929f4530ee8cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots16Filled', "16", [
    "M5.62 1c.57 0 1 .34 1.3.77.3.42.53 1 .71 1.62.37 1.26.62 2.92.86 4.54.25 1.63.49 3.22.84 4.4q.26.88.56 1.32c.2.29.37.35.5.35.1 0 .24-.05.4-.25q.27-.3.5-.98c.29-.8.5-1.86.7-3.05A2 2 0 1 1 13 10h-.04c-.2 1.15-.42 2.25-.72 3.1q-.27.77-.68 1.3c-.29.34-.68.6-1.18.6-.57 0-1-.34-1.3-.77-.3-.42-.53-1-.71-1.62-.37-1.26-.62-2.92-.86-4.54a36 36 0 0 0-.84-4.4 5 5 0 0 0-.56-1.32C5.9 2.06 5.74 2 5.6 2c-.1 0-.24.05-.4.25q-.27.3-.5.98c-.3.8-.5 1.86-.7 3.05A2 2 0 1 1 3 6h.04c.2-1.15.42-2.25.72-3.1q.27-.77.68-1.3c.29-.34.68-.6 1.18-.6"
]);
const $f342bb1007016cbf$export$bc94f6c134359bef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots16Regular', "16", [
    "M5.62 1c.57 0 1 .34 1.3.77.3.42.53 1 .71 1.62.37 1.26.62 2.92.86 4.54.25 1.63.49 3.22.84 4.4q.26.88.56 1.32c.2.29.37.35.5.35.1 0 .24-.05.4-.25q.27-.3.5-.98c.29-.8.5-1.86.7-3.05A2 2 0 1 1 13 10h-.04c-.2 1.15-.42 2.25-.72 3.1q-.27.77-.68 1.3c-.29.34-.68.6-1.18.6-.57 0-1-.34-1.3-.77-.3-.42-.53-1-.71-1.62-.37-1.26-.62-2.92-.86-4.54a36 36 0 0 0-.84-4.4 5 5 0 0 0-.56-1.32C5.9 2.06 5.74 2 5.6 2c-.1 0-.24.05-.4.25q-.27.3-.5.98c-.3.8-.5 1.86-.7 3.05A2 2 0 1 1 3 6h.04c.2-1.15.42-2.25.72-3.1q.27-.77.68-1.3c.29-.34.68-.6 1.18-.6M3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
]);
const $f342bb1007016cbf$export$37a0edd5e38ffefb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots20Filled', "20", [
    "M7.25 2c.63 0 1.1.37 1.44.86.34.47.6 1.12.81 1.84.43 1.45.71 3.36 1 5.23.28 1.88.55 3.72.96 5.08q.3 1.03.66 1.56c.24.33.45.43.63.43.16 0 .33-.07.53-.31q.31-.37.6-1.16c.34-.96.59-2.24.82-3.66a2.5 2.5 0 1 1 1 .12 24 24 0 0 1-.88 3.87 5 5 0 0 1-.77 1.47c-.33.4-.76.67-1.3.67-.63 0-1.1-.37-1.44-.86a6 6 0 0 1-.81-1.84c-.43-1.45-.72-3.36-1-5.23A42 42 0 0 0 8.54 5q-.3-1.03-.66-1.56C7.64 3.1 7.43 3 7.25 3c-.16 0-.33.07-.53.31q-.32.37-.6 1.16c-.34.95-.6 2.24-.82 3.66a2.5 2.5 0 1 1-1-.12c.24-1.44.5-2.82.88-3.87.2-.58.45-1.1.77-1.47.33-.4.76-.67 1.3-.67"
]);
const $f342bb1007016cbf$export$ef9ae33253c680b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots20Regular', "20", [
    "M7.25 2c.63 0 1.1.37 1.44.86.34.47.6 1.12.81 1.84.43 1.45.71 3.36 1 5.23.28 1.88.55 3.72.96 5.08q.3 1.03.66 1.56c.24.33.45.43.63.43.16 0 .33-.07.53-.31q.31-.37.6-1.16c.34-.96.59-2.24.82-3.66a2.5 2.5 0 1 1 1 .12 24 24 0 0 1-.88 3.87 5 5 0 0 1-.77 1.47c-.33.4-.76.67-1.3.67-.63 0-1.1-.37-1.44-.86a6 6 0 0 1-.81-1.84c-.43-1.45-.72-3.36-1-5.23A42 42 0 0 0 8.54 5q-.3-1.03-.66-1.56C7.64 3.1 7.43 3 7.25 3c-.16 0-.33.07-.53.31q-.32.37-.6 1.16c-.34.95-.6 2.24-.82 3.66a2.5 2.5 0 1 1-1-.12c.24-1.44.5-2.82.88-3.87.2-.58.45-1.1.77-1.47.33-.4.76-.67 1.3-.67M4.5 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $f342bb1007016cbf$export$3b45b5aa4a2d5d0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots24Filled', "24", [
    "M8.6 1.98c.86 0 1.48.5 1.92 1.12.43.6.75 1.43 1.02 2.32.52 1.8.88 4.17 1.22 6.47.35 2.33.7 4.58 1.18 6.25q.38 1.27.8 1.87c.28.4.5.47.65.47.14 0 .31-.06.54-.33q.36-.42.7-1.38c.46-1.29.8-3.07 1.1-5.04l.01-.01a3 3 0 1 1 1.52.27c-.3 1.95-.66 3.86-1.17 5.3a6 6 0 0 1-.98 1.85c-.42.5-.99.88-1.72.88-.85 0-1.47-.5-1.9-1.12a8 8 0 0 1-1.03-2.32c-.52-1.8-.88-4.17-1.22-6.47a51 51 0 0 0-1.18-6.25 7 7 0 0 0-.8-1.87c-.28-.4-.5-.47-.65-.47-.14 0-.31.06-.54.33q-.37.42-.7 1.38a31 31 0 0 0-1.1 5.04h-.01a3 3 0 1 1-1.52-.26c.3-1.95.66-3.86 1.17-5.3.25-.7.57-1.36.98-1.85.42-.5.99-.88 1.72-.88"
]);
const $f342bb1007016cbf$export$1860fbfb0668f6d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots24Regular', "24", [
    "M8.6 1.98c.86 0 1.48.5 1.92 1.12.43.6.75 1.43 1.02 2.32.52 1.8.88 4.17 1.22 6.47.35 2.33.7 4.58 1.18 6.25q.38 1.27.8 1.87c.28.4.5.47.65.47.14 0 .31-.06.54-.33q.36-.42.7-1.38c.46-1.29.8-3.07 1.1-5.04l.01-.01a3 3 0 1 1 1.52.27c-.3 1.95-.66 3.86-1.17 5.3a6 6 0 0 1-.98 1.85c-.42.5-.99.88-1.72.88-.85 0-1.47-.5-1.9-1.12a8 8 0 0 1-1.03-2.32c-.52-1.8-.88-4.17-1.22-6.47a51 51 0 0 0-1.18-6.25 7 7 0 0 0-.8-1.87c-.28-.4-.5-.47-.65-.47-.14 0-.31.06-.54.33q-.37.42-.7 1.38a31 31 0 0 0-1.1 5.04h-.01a3 3 0 1 1-1.52-.26c.3-1.95.66-3.86 1.17-5.3.25-.7.57-1.36.98-1.85.42-.5.99-.88 1.72-.88M5 11.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m14-2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
]);
const $f342bb1007016cbf$export$f13e50a2305af7a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots28Filled', "28", [
    "M10 2c.92 0 1.6.59 2.07 1.3.48.71.85 1.68 1.17 2.76.62 2.16 1.07 5.03 1.5 7.82.44 2.83.87 5.6 1.46 7.65q.45 1.55.97 2.34c.35.52.63.63.83.63.21 0 .5-.12.89-.65q.56-.78 1.07-2.32c.46-1.35.85-3 1.23-4.78a3.5 3.5 0 1 1 1.48.25c-.4 1.83-.8 3.58-1.29 5.01a11 11 0 0 1-1.28 2.72c-.5.7-1.19 1.27-2.1 1.27s-1.6-.59-2.07-1.3c-.48-.71-.85-1.68-1.17-2.76-.62-2.16-1.07-5.03-1.5-7.82a68 68 0 0 0-1.46-7.65 9 9 0 0 0-.97-2.34c-.35-.52-.63-.63-.83-.63s-.5.12-.88.65A9 9 0 0 0 8.04 6.5a46 46 0 0 0-1.21 4.76A3.5 3.5 0 1 1 5.35 11c.38-1.81.8-3.54 1.27-4.97.36-1.08.77-2.04 1.28-2.75C8.4 2.58 9.08 2 10 2"
]);
const $f342bb1007016cbf$export$712af787005008ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots28Regular', "28", [
    "M10 2c.92 0 1.6.59 2.07 1.3.48.71.85 1.68 1.17 2.76.62 2.16 1.07 5.03 1.5 7.82.44 2.83.87 5.6 1.46 7.65q.45 1.55.97 2.34c.35.52.63.63.83.63.21 0 .5-.12.89-.65q.56-.78 1.07-2.32c.46-1.35.85-3 1.23-4.78a3.5 3.5 0 1 1 1.48.25c-.4 1.83-.8 3.58-1.29 5.01a11 11 0 0 1-1.28 2.72c-.5.7-1.19 1.27-2.1 1.27s-1.6-.59-2.07-1.3c-.48-.71-.85-1.68-1.17-2.76-.62-2.16-1.07-5.03-1.5-7.82a68 68 0 0 0-1.46-7.65 9 9 0 0 0-.97-2.34c-.35-.52-.63-.63-.83-.63s-.5.12-.88.65A9 9 0 0 0 8.04 6.5a46 46 0 0 0-1.21 4.76A3.5 3.5 0 1 1 5.35 11c.38-1.81.8-3.54 1.27-4.97.36-1.08.77-2.04 1.28-2.75C8.4 2.58 9.08 2 10 2M5.5 12.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m17-1a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $f342bb1007016cbf$export$54b2d27038d6ec7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots32Filled', "32", [
    "M11 2c1.11 0 1.92.73 2.48 1.55a13 13 0 0 1 1.44 3.2c.8 2.51 1.44 5.83 2.06 9.06a83 83 0 0 0 2 8.82q.58 1.8 1.18 2.69c.42.6.7.68.84.68s.42-.08.84-.68q.6-.9 1.18-2.69c.46-1.43.86-3.16 1.25-5.02a4 4 0 1 1 1.96.38c-.4 1.92-.82 3.73-1.3 5.25a13 13 0 0 1-1.45 3.2C22.92 29.28 22.11 30 21 30s-1.92-.73-2.48-1.55a13 13 0 0 1-1.44-3.2c-.8-2.51-1.44-5.83-2.06-9.06a83 83 0 0 0-2-8.82q-.57-1.8-1.18-2.69c-.42-.6-.7-.68-.84-.68s-.42.08-.84.68q-.6.9-1.18 2.69a51 51 0 0 0-1.25 5.02 4 4 0 1 1-1.96-.38c.4-1.92.82-3.73 1.3-5.25.4-1.25.87-2.38 1.45-3.2C9.08 2.72 9.89 2 11 2"
]);
const $f342bb1007016cbf$export$316d5f939f67cbee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots32Regular', "32", [
    "M11 2c1.11 0 1.92.73 2.48 1.55a13 13 0 0 1 1.44 3.2c.8 2.51 1.44 5.83 2.06 9.06a83 83 0 0 0 2 8.82q.58 1.8 1.18 2.69c.42.6.7.68.84.68s.42-.08.84-.68q.6-.9 1.18-2.69c.46-1.43.86-3.16 1.25-5.02a4 4 0 1 1 1.96.38c-.4 1.92-.82 3.73-1.3 5.25a13 13 0 0 1-1.45 3.2C22.92 29.28 22.11 30 21 30s-1.92-.73-2.48-1.55a13 13 0 0 1-1.44-3.2c-.8-2.51-1.44-5.83-2.06-9.06a83 83 0 0 0-2-8.82q-.58-1.8-1.18-2.69c-.42-.6-.7-.68-.84-.68s-.42.08-.84.68q-.6.9-1.18 2.69a51 51 0 0 0-1.25 5.02 4 4 0 1 1-1.96-.38c.4-1.92.82-3.73 1.3-5.25.4-1.25.87-2.38 1.45-3.2C9.08 2.72 9.89 2 11 2m15 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4M6 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
]);
const $f342bb1007016cbf$export$9d43397648fe818f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots48Filled', "48", [
    "M17 4c1.5 0 2.6 1.02 3.36 2.17a18 18 0 0 1 1.99 4.57c1.12 3.6 2 8.37 2.88 13.03.88 4.71 1.74 9.32 2.8 12.75q.8 2.6 1.69 3.93c.6.9 1.03 1.05 1.28 1.05s.68-.16 1.28-1.05q.88-1.34 1.68-3.93c.62-2 1.17-4.4 1.7-7a6 6 0 1 1 2.46.48 77 77 0 0 1-1.77 7.26c-.56 1.8-1.2 3.4-1.99 4.57C33.6 42.98 32.5 44 31 44s-2.6-1.02-3.36-2.17a18 18 0 0 1-1.99-4.57c-1.12-3.6-2-8.37-2.88-13.03-.88-4.71-1.74-9.32-2.8-12.75a16 16 0 0 0-1.69-3.93c-.6-.9-1.03-1.05-1.28-1.05s-.68.16-1.28 1.05q-.89 1.33-1.68 3.93c-.63 2-1.18 4.4-1.7 7A6 6 0 1 1 9.88 18a77 77 0 0 1 1.77-7.26c.56-1.8 1.2-3.4 1.99-4.57C14.4 5.02 15.5 4 17 4"
]);
const $f342bb1007016cbf$export$7ef731640b97f21f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SineWaveDots48Regular', "48", [
    "M17 4c1.5 0 2.6 1.02 3.36 2.17a18 18 0 0 1 1.99 4.57c1.12 3.6 2 8.37 2.88 13.03.88 4.71 1.74 9.32 2.8 12.75q.8 2.6 1.69 3.93c.6.9 1.03 1.05 1.28 1.05s.68-.16 1.28-1.05q.88-1.34 1.68-3.93c.62-2 1.17-4.4 1.7-7a6 6 0 1 1 2.46.48 77 77 0 0 1-1.77 7.26c-.56 1.8-1.2 3.4-1.99 4.57C33.6 42.98 32.5 44 31 44s-2.6-1.02-3.36-2.17a18 18 0 0 1-1.99-4.57c-1.12-3.6-2-8.37-2.88-13.03-.88-4.71-1.74-9.32-2.8-12.75a16 16 0 0 0-1.69-3.93c-.6-.9-1.03-1.05-1.28-1.05s-.68.16-1.28 1.05q-.89 1.33-1.68 3.93c-.63 2-1.18 4.4-1.7 7A6 6 0 1 1 9.88 18a77 77 0 0 1 1.77-7.26c.56-1.8 1.2-3.4 1.99-4.57C14.4 5.02 15.5 4 17 4m-7 16.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m28 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
]);
const $f342bb1007016cbf$export$d09e5672bedf2a3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport16Color', "16", [
    [
        "circle",
        {
            "cx": "9.5",
            "cy": "6.5",
            "r": "5.5",
            "fill": "url(#ic_fluent_sport_16_color__a)"
        }
    ],
    [
        "circle",
        {
            "cx": "9.5",
            "cy": "6.5",
            "r": "5.5",
            "fill": "url(#ic_fluent_sport_16_color__b)",
            "fillOpacity": ".8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_16_color__c)",
            "d": "m6.24 2.07 3.49 3.5.82-.83a3 3 0 0 1 .11-3.62q.55.12 1.06.35a2 2 0 0 0-.44 2.55l1.74-1.75q.4.33.7.71l-1.74 1.74a2 2 0 0 0 2.55-.44q.23.52.35 1.06a3 3 0 0 1-3.62.1l-.82.83 3.49 3.5q-.3.4-.67.74L9.73 6.98 6.85 9.85l-.7-.7 2.87-2.88L5.5 2.74q.34-.37.75-.67",
            "opacity": ".6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_16_color__d)",
            "d": "M2.5 6C1.67 6 1 6.67 1 7.5v1A6.5 6.5 0 0 0 7.5 15h1c.83 0 1.5-.67 1.5-1.5v-1A6.5 6.5 0 0 0 3.5 6z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_16_color__e)",
            "fillOpacity": ".9",
            "d": "M2.5 6C1.67 6 1 6.67 1 7.5v1A6.5 6.5 0 0 0 7.5 15h1c.83 0 1.5-.67 1.5-1.5v-1A6.5 6.5 0 0 0 3.5 6z"
        }
    ],
    [
        "path",
        {
            "fill": "#ffc470",
            "d": "M5.1 9.4a.5.5 0 1 0-.7.7l1.5 1.5a.5.5 0 0 0 .7-.7z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_16_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-90 14.36 3.37)scale(19.2202)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".98",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_16_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-45 15.51 -1.18)scale(6.48181 8.86748)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".59",
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#eb4824",
                    "stopOpacity": ".1"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_16_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.53 -5.44 5)scale(11.7003 10.5803)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#ae5606"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#944600"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_16_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(10.94 -88.63 31.08)scale(13.3182)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#ffa43d",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_sport_16_color__c",
                "x1": "13.66",
                "x2": "7.76",
                "y1": "2.51",
                "y2": "8.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".71",
                    "stopColor": "#8e250b"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#8e250b",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$51b61c464bd5e28d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport16Filled', "16", [
    "M14.53 4.28a6 6 0 0 0-.8-1.3l-1.75 1.74a2 2 0 0 0 2.55-.44m-3.25-.26 1.74-1.75a6 6 0 0 0-1.3-.8 2 2 0 0 0-.44 2.55M10 3q.01.99.55 1.74l-.8.8-3.49-3.49a5.5 5.5 0 0 1 4.4-.93A3 3 0 0 0 10 3m.46 3.25.8-.8a3 3 0 0 0 3.62-.11 5.5 5.5 0 0 1-.94 4.4zm2.82 4.24L9.75 6.96l-.6.6a7.5 7.5 0 0 1 1.82 4.24 5.5 5.5 0 0 0 2.31-1.3M4.2 5.03a5.5 5.5 0 0 1 1.3-2.31l3.54 3.53-.6.6A7.5 7.5 0 0 0 4.2 5.03M2.5 6C1.67 6 1 6.67 1 7.5v1A6.5 6.5 0 0 0 7.5 15h1c.83 0 1.5-.67 1.5-1.5v-1A6.5 6.5 0 0 0 3.5 6zm1.9 3.4c.2-.2.5-.2.7 0l1.5 1.5a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7"
]);
const $f342bb1007016cbf$export$36d063f788e696e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport16Regular', "16", [
    "M13.02 9.3a4.5 4.5 0 0 0 .95-3.3 3 3 0 0 1-2.96-.3l-.8.8zm-.71.72L9.16 6.87l-.03-.03-3.15-3.15q-.53.67-.79 1.5a8 8 0 0 0-1-.16 5.5 5.5 0 0 1 6.45-3.91q.6.12 1.15.38a5.45 5.45 0 0 1 3.1 3.86 5.5 5.5 0 0 1-3.92 6.44 8 8 0 0 0-.16-1 5 5 0 0 0 1.5-.78m1.43-5.03a5 5 0 0 0-.72-1.3l-1.29 1.28a2 2 0 0 0 2 .02m-2.71-.72 1.28-1.29a5 5 0 0 0-1.3-.72 2 2 0 0 0 .02 2M10 2.03a4.6 4.6 0 0 0-3.32.95L9.5 5.8l.8-.8a3 3 0 0 1-.3-2.96M2.5 7a.5.5 0 0 0-.5.5v1A5.5 5.5 0 0 0 7.5 14h1a.5.5 0 0 0 .5-.5v-1A5.5 5.5 0 0 0 3.5 7zM1 7.5C1 6.67 1.67 6 2.5 6h1a6.5 6.5 0 0 1 6.5 6.5v1c0 .83-.67 1.5-1.5 1.5h-1A6.5 6.5 0 0 1 1 8.5zm3.4 1.9c.2-.2.5-.2.7 0l1.5 1.5a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7"
]);
const $f342bb1007016cbf$export$f812720a401861f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport20Color', "20", [
    [
        "circle",
        {
            "cx": "12",
            "cy": "8",
            "r": "6",
            "fill": "url(#ic_fluent_sport_20_color__a)"
        }
    ],
    [
        "circle",
        {
            "cx": "12",
            "cy": "8",
            "r": "6",
            "fill": "url(#ic_fluent_sport_20_color__b)",
            "fillOpacity": ".8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_20_color__c)",
            "d": "M14.59 2.58a2 2 0 0 0-.31 2.44l1.6-1.6q.38.32.7.7l-1.6 1.6a2 2 0 0 0 2.44-.3q.22.46.37.99a3 3 0 0 1-3.53.04L12.71 8l3.87 3.87q-.32.4-.7.71L12 8.71l-3.87 3.87q-.4-.32-.71-.7L11.29 8 7.42 4.13q.32-.4.7-.71L12 7.29l1.55-1.55a3 3 0 0 1 .04-3.53q.52.15 1 .37",
            "opacity": ".6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_20_color__d)",
            "d": "M2 8.5C2 7.67 2.67 7 3.5 7H5a8 8 0 0 1 8 8v1.5c0 .83-.67 1.5-1.5 1.5H10a8 8 0 0 1-8-8z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_20_color__e)",
            "fillOpacity": ".9",
            "d": "M2 8.5C2 7.67 2.67 7 3.5 7H5a8 8 0 0 1 8 8v1.5c0 .83-.67 1.5-1.5 1.5H10a8 8 0 0 1-8-8z"
        }
    ],
    [
        "path",
        {
            "fill": "#ffc470",
            "d": "M6.15 11.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-90 16.93 3.32)scale(20.9675)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".98",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(5 -5 6.84028 6.84028 7.5 12.5)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".59",
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#eb4824",
                    "stopOpacity": ".1"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.53 -5.93 6.72)scale(14.3003 12.9315)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#ae5606"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#944600"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_20_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(10.94 -106.2 41.88)scale(16.2778)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#ffa43d",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_sport_20_color__c",
                "x1": "16.44",
                "x2": "9.93",
                "y1": "3.75",
                "y2": "10.26",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".71",
                    "stopColor": "#8e250b"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#8e250b",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$2c146b660c786fc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport20Filled', "20", [
    "M16.58 4.13a6 6 0 0 1 .83 1.28 2 2 0 0 1-2.43.31zm-.7-.71-1.6 1.6a2 2 0 0 1 .3-2.44 6 6 0 0 1 1.3.84M18 8a6 6 0 0 0-.21-1.59 3 3 0 0 1-3.53.04L13.21 7.5l3.8 3.8c.63-.94.99-2.08.99-3.3m-5-4q.02-1.02.59-1.79a6 6 0 0 0-4.9.78l3.81 3.8 1.05-1.05A3 3 0 0 1 13 4m-1.3 5a9 9 0 0 1 2.2 4.7 6 6 0 0 0 2.49-1.6L12.5 8.2zm.1-1.5-.8.8a9 9 0 0 0-4.7-2.2A6 6 0 0 1 7.9 3.6zM3.5 7C2.67 7 2 7.67 2 8.5V10a8 8 0 0 0 8 8h1.5c.83 0 1.5-.67 1.5-1.5V15a8 8 0 0 0-8-8zm2.65 4.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7"
]);
const $f342bb1007016cbf$export$2158faaee1ba798e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport20Regular', "20", [
    "M13.7 12.7a5 5 0 0 0 1.46-.83L8.13 4.84A5 5 0 0 0 7.3 6.3a9 9 0 0 0-1-.2 6 6 0 1 1 7.6 7.6 9 9 0 0 0-.2-1m-1-4.7 3.17 3.16a5 5 0 0 0 1.06-4.02 3 3 0 0 1-3.17-.2zm3.17-3.16-1.39 1.38a2 2 0 0 0 2.16-.08 5 5 0 0 0-.77-1.3M12.5 4.5q0-.78.36-1.43a5 5 0 0 0-4.02 1.06L12 7.29l1.05-1.05a3 3 0 0 1-.55-1.74m1 0q0 .56.28 1.02l1.38-1.4a5 5 0 0 0-1.3-.76 2 2 0 0 0-.36 1.14M3.5 8a.5.5 0 0 0-.5.5V10a7 7 0 0 0 7 7h1.5a.5.5 0 0 0 .5-.5V15a7 7 0 0 0-7-7zM2 8.5C2 7.67 2.67 7 3.5 7H5a8 8 0 0 1 8 8v1.5c0 .83-.67 1.5-1.5 1.5H10a8 8 0 0 1-8-8zm4.15 2.65c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7"
]);
const $f342bb1007016cbf$export$f208ffff50f183b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport24Color', "24", [
    [
        "circle",
        {
            "cx": "14",
            "cy": "10",
            "r": "8",
            "fill": "url(#ic_fluent_sport_24_color__a)"
        }
    ],
    [
        "circle",
        {
            "cx": "14",
            "cy": "10",
            "r": "8",
            "fill": "url(#ic_fluent_sport_24_color__b)",
            "fillOpacity": ".8"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_24_color__c)",
            "d": "m9.47 3.4 5.03 5.04.76-.76a4.2 4.2 0 0 1 .53-5.48q.9.21 1.7.6a2.75 2.75 0 0 0-1.14 3.8l2.75-2.76q.58.48 1.06 1.06l-2.75 2.75A2.74 2.74 0 0 0 21.2 6.5q.39.81.6 1.71a4.24 4.24 0 0 1-5.48.53l-.76.76 5.03 5.03q-.42.63-.96 1.16l-5.13-5.13-3.97 3.97-1.06-1.06 3.97-3.97L8.3 4.37q.54-.53 1.16-.96",
            "opacity": ".6"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_24_color__d)",
            "d": "M4.25 9C3.01 9 2 10 2 11.25v2A8.75 8.75 0 0 0 10.75 22h2c1.24 0 2.25-1 2.25-2.25v-2A8.75 8.75 0 0 0 6.25 9z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_sport_24_color__e)",
            "fillOpacity": ".9",
            "d": "M4.25 9C3.01 9 2 10 2 11.25v2A8.75 8.75 0 0 0 10.75 22h2c1.24 0 2.25-1 2.25-2.25v-2A8.75 8.75 0 0 0 6.25 9z"
        }
    ],
    [
        "path",
        {
            "fill": "#ffc470",
            "d": "M7.78 13.72a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06z"
        }
    ],
    [
        "defs",
        null,
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_24_color__a",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(-90 21.24 5.09)scale(27.9566)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#eb4824"
                }
            ],
            [
                "stop",
                {
                    "offset": ".98",
                    "stopColor": "#ff921f"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_24_color__b",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "matrix(6.66667 -6.66667 9.1204 9.1204 8 16)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".59",
                    "stopColor": "#aa1d2d"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#eb4824",
                    "stopOpacity": ".1"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_24_color__d",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(53.53 -7.92 7.95)scale(16.9004 15.2827)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".24",
                    "stopColor": "#ae5606"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#944600"
                }
            ]
        ],
        [
            "radialGradient",
            {
                "id": "ic_fluent_sport_24_color__e",
                "cx": "0",
                "cy": "0",
                "r": "1",
                "gradientTransform": "rotate(10.94 -129.48 47.96)scale(19.2374)",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".63",
                    "stopColor": "#ffa43d",
                    "stopOpacity": "0"
                }
            ],
            [
                "stop",
                {
                    "offset": ".93",
                    "stopColor": "#ffa43d"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_sport_24_color__c",
                "x1": "20.05",
                "x2": "11.58",
                "y1": "4.19",
                "y2": "12.67",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "offset": ".71",
                    "stopColor": "#8e250b"
                }
            ],
            [
                "stop",
                {
                    "offset": ".9",
                    "stopColor": "#8e250b",
                    "stopOpacity": "0"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$a34453e629357671 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport24Filled', "24", [
    "M20.16 4.9a8 8 0 0 1 1.04 1.6 2.75 2.75 0 0 1-3.8 1.15zM19.1 3.84l-2.75 2.75A2.74 2.74 0 0 1 17.5 2.8q.86.42 1.6 1.04M22 10q0-.93-.2-1.79a4.24 4.24 0 0 1-5.48.53l-.76.76 5.03 5.03A8 8 0 0 0 22 10m-7.5-4.75c0-1.2.5-2.28 1.29-3.05a8 8 0 0 0-6.32 1.2l5.03 5.04.76-.76a4.2 4.2 0 0 1-.76-2.43m0 5.31 5.13 5.13A8 8 0 0 1 16 17.75c0-2.42-.88-4.64-2.35-6.34zm-1.9-.21A9.7 9.7 0 0 0 6.24 8a8 8 0 0 1 2.06-3.63l5.13 5.13zM4.24 9C3.01 9 2 10 2 11.25v2A8.75 8.75 0 0 0 10.75 22h2c1.24 0 2.25-1 2.25-2.25v-2A8.75 8.75 0 0 0 6.25 9zm2.47 4.72c.3-.3.77-.3 1.06 0l2.5 2.5a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06"
]);
const $f342bb1007016cbf$export$8988e300a0ffc7a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Sport24Regular', "24", [
    "M18.04 15.1q-.97.75-2.16 1.12.12.74.12 1.53A8 8 0 1 0 6.25 8q.78 0 1.53.12.37-1.2 1.12-2.16zm1.06-1.06L15.06 10l.76-.76a4.2 4.2 0 0 0 4.65.13 6.6 6.6 0 0 1-1.37 4.67M16.22 3.89q1 .37 1.82 1.01l-2.2 2.2a2.7 2.7 0 0 1 .38-3.21m-1.46 4.29-.76.76L9.96 4.9a6.5 6.5 0 0 1 4.67-1.37 4.2 4.2 0 0 0 .13 4.65m5.35-.4a2.7 2.7 0 0 1-3.2.37l2.19-2.19q.64.83 1 1.82M4.25 10.5a.75.75 0 0 0-.75.75v2c0 4 3.25 7.25 7.25 7.25h2c.41 0 .75-.34.75-.75v-2c0-4-3.25-7.25-7.25-7.25zM2 11.25C2 10.01 3 9 4.25 9h2A8.75 8.75 0 0 1 15 17.75v2c0 1.24-1 2.25-2.25 2.25h-2A8.75 8.75 0 0 1 2 13.25zm5.78 2.47a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06z"
]);
const $f342bb1007016cbf$export$6b3a695625726d97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportAmericanFootball20Filled', "20", [
    "M10.94 2.64A11.6 11.6 0 0 0 2.6 10.9l6.6 6.6a11 11 0 0 0 6.08-4.08 13 13 0 0 0 2.07-4.35zm.91 5.5c.2.2.2.52 0 .71l-3 3a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0m5.8-.2q.38-1.97.35-3.71A2.25 2.25 0 0 0 15.7 2q-1.98.04-3.62.37zm-9.6 9.81-5.72-5.72A16 16 0 0 0 2 15.84c.04 1.18 1 2.09 2.15 2.14q2.14.1 3.89-.23"
]);
const $f342bb1007016cbf$export$42b0006a5c902b2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportAmericanFootball20Regular', "20", [
    "M11.85 8.85a.5.5 0 1 0-.7-.7l-3 3a.5.5 0 1 0 .7.7zM18 4.23A2.25 2.25 0 0 0 15.7 2c-5.62.07-9.12 2.15-11.18 4.96-2.04 2.78-2.6 6.2-2.51 8.88.04 1.18 1 2.09 2.15 2.14 5.53.26 9.03-1.73 11.13-4.56 2.07-2.8 2.73-6.36 2.71-9.2M15.71 3c.72 0 1.29.54 1.3 1.23q0 1.36-.23 2.85l-3.84-3.85Q14.2 3.02 15.7 3m-3.95.46 4.79 4.8c-.39 1.6-1.04 3.19-2.07 4.56a10 10 0 0 1-6.1 3.85l-.03-.02-4.93-4.93a12 12 0 0 1 1.9-4.17 10.8 10.8 0 0 1 6.44-4.09M3.19 12.9l3.98 3.99q-1.35.17-2.96.1A1.24 1.24 0 0 1 3 15.81q-.05-1.38.18-2.92"
]);
const $f342bb1007016cbf$export$f9b907373306a72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportAmericanFootball24Filled', "24", [
    "M21.38 11.5a14.8 14.8 0 0 1-9.97 9.9l-8.82-8.8a14.8 14.8 0 0 1 9.91-9.98zm-7.66-2.28-4.5 4.5a.75.75 0 1 0 1.06 1.06l4.5-4.5a.75.75 0 1 0-1.06-1.06M2.2 14.32l7.48 7.48q-1.2.2-2.43.2h-1A4.25 4.25 0 0 1 2 17.75v-1q0-1.25.2-2.43m12.02-12.1 7.56 7.56Q22 8.54 22 7.25v-1C22 3.9 20.1 2 17.75 2h-1q-1.3 0-2.53.22"
]);
const $f342bb1007016cbf$export$6292a114cc3a1c74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportAmericanFootball24Regular', "24", [
    "M13.72 9.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06zM17.75 2C20.1 2 22 3.9 22 6.25v1C22 15.4 15.4 22 7.25 22h-1A4.25 4.25 0 0 1 2 17.75v-1C2 8.6 8.6 2 16.75 2zm2.75 4.25a2.75 2.75 0 0 0-2.75-2.75h-1q-.6 0-1.2.05l4.9 4.9q.05-.6.05-1.2zm-.35 4.02-6.42-6.42a13.3 13.3 0 0 0-9.9 9.97l6.35 6.36a13.3 13.3 0 0 0 9.97-9.9m-16.6 5.4q-.05.53-.05 1.08v1a2.75 2.75 0 0 0 2.75 2.75h1q.55 0 1.09-.04z"
]);
const $f342bb1007016cbf$export$d05be916bde08079 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBaseball20Filled', "20", [
    "M18 10c0 1.55-.44 3-1.2 4.22q-1.43-1.05-3.14-1.63a.5.5 0 1 0-.32.95q1.56.53 2.88 1.5a7.98 7.98 0 0 1-12.44 0q1.31-.97 2.88-1.5a.5.5 0 0 0-.32-.95q-1.71.59-3.14 1.63a8 8 0 0 1 0-8.43q1.42 1.06 3.14 1.63a.5.5 0 1 0 .32-.95 11 11 0 0 1-2.88-1.5 7.98 7.98 0 0 1 12.44 0q-1.31.97-2.88 1.5a.5.5 0 1 0 .32.95q1.72-.58 3.14-1.63A8 8 0 0 1 18 10m-8 3q.73 0 1.43.1a.5.5 0 1 0 .14-1 12 12 0 0 0-3.14 0 .5.5 0 0 0 .14 1q.7-.1 1.43-.1M8.57 6.92a.5.5 0 0 0-.14.99 12 12 0 0 0 3.14 0 .5.5 0 1 0-.14-1 11 11 0 0 1-2.86 0"
]);
const $f342bb1007016cbf$export$69d72c5a623766ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBaseball20Regular', "20", [
    "M4.61 5.53a7 7 0 0 1 10.78 0q-.96.57-2.05.94a.5.5 0 0 0 .32.95q1.22-.41 2.31-1.08a7 7 0 0 1 0 7.33q-1.1-.66-2.31-1.08a.5.5 0 0 0-.32.95q1.08.37 2.04.94a7 7 0 0 1-10.76 0q.96-.58 2.04-.94a.5.5 0 1 0-.32-.95q-1.22.42-2.3 1.08a7 7 0 0 1-.01-7.33Q5.12 7 6.34 7.42a.5.5 0 0 0 .32-.95Q5.58 6.1 4.6 5.53M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.57 6.92a11 11 0 0 0 2.86 0 .5.5 0 0 1 .14.99 12 12 0 0 1-3.14 0 .5.5 0 0 1 .14-1m0 6.18a11 11 0 0 1 2.86 0 .5.5 0 0 0 .14-1 12 12 0 0 0-3.14 0 .5.5 0 1 0 .14 1"
]);
const $f342bb1007016cbf$export$6a8a90084f966b69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBaseball24Filled', "24", [
    "M3.94 6.08a10 10 0 0 0-.01 11.83l.23-.22A8 8 0 0 1 7 16.01a.75.75 0 1 1 .48 1.42 7 7 0 0 0-2.58 1.62 9.97 9.97 0 0 0 14.18 0 7 7 0 0 0-2.58-1.62.75.75 0 1 1 .48-1.42 8 8 0 0 1 3.08 1.9 10 10 0 0 0-.01-11.83l-.22.2A8 8 0 0 1 17 7.96a.75.75 0 0 1-.48-1.42 7 7 0 0 0 2.57-1.6 9.97 9.97 0 0 0-14.16 0 7 7 0 0 0 2.57 1.6A.75.75 0 1 1 7 7.96a8 8 0 0 1-3.07-1.88m5.08 10.07c-.1-.4.15-.8.55-.9h.01l.02-.01.37-.08q.38-.07 1.04-.12c.86-.07 2.05-.07 3.39.2a.75.75 0 0 1-.3 1.47 11 11 0 0 0-4.17-.01s-.75.1-.9-.55m.91-8.88.07.02a6 6 0 0 0 1.12.15c.76.06 1.82.06 2.98-.18a.75.75 0 0 1 .3 1.48 13 13 0 0 1-4.8 0h-.02v-.01h-.01a.76.76 0 0 1-.55-.91c.16-.65.91-.55.91-.55"
]);
const $f342bb1007016cbf$export$c9f7eaf6a8524088 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBaseball24Regular', "24", [
    "M9.93 16.7s-.75.1-.9-.55c-.1-.4.14-.8.54-.9h.01l.02-.01.37-.08q.38-.07 1.04-.12c.86-.07 2.05-.07 3.39.2a.75.75 0 0 1-.3 1.47 11 11 0 0 0-4.17-.01m-.9-8.8c.15-.65.9-.55.9-.55a6 6 0 0 0 1.19.17c.76.05 1.82.05 2.98-.18a.75.75 0 0 1 .3 1.47 13 13 0 0 1-4.8 0h-.03a.76.76 0 0 1-.55-.92M12 22a9.97 9.97 0 0 0 10-10 10 10 0 1 0-10 10M5.07 7.07c.54.37 1.19.72 1.94.97A.75.75 0 1 0 7.5 6.6a6 6 0 0 1-1.43-.69 8.47 8.47 0 0 1 11.88 0q-.61.41-1.43.7A.75.75 0 1 0 17 8.03q1.13-.4 1.94-.97a8.5 8.5 0 0 1-.03 9.9A8 8 0 0 0 17 16a.75.75 0 1 0-.48 1.42q.8.28 1.4.68a8.47 8.47 0 0 1-11.82 0q.6-.4 1.4-.68A.75.75 0 1 0 7 16.01c-.74.25-1.38.6-1.91.95a8.5 8.5 0 0 1-.03-9.89"
]);
const $f342bb1007016cbf$export$cac45847130e4eb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBasketball20Filled', "20", [
    "M4.7 4A8 8 0 0 1 9 2.06q.1.66.24 1.4c.18.9.43 1.89.78 2.79.28.71.62 1.4 1.06 1.96L10 9.3zm-.7.7A8 8 0 0 0 2.06 9q.65.1 1.4.24c.9.18 1.89.43 2.79.78.71.28 1.4.62 1.96 1.06L9.29 10zm3.5 7.1q-.66-.48-1.61-.85c-.83-.31-1.75-.55-2.62-.72Q2.6 10.08 2 10c0 2.02.76 3.87 2 5.28zM4.7 16l3.5-3.5q.48.66.85 1.61c.31.83.55 1.75.72 2.62q.15.68.22 1.27a8 8 0 0 1-5.28-2m4.22-4.21L10 10.71 15.3 16a8 8 0 0 1-4.3 1.94q-.1-.66-.25-1.4c-.18-.9-.43-1.89-.77-2.79a8 8 0 0 0-1.06-1.96m7.08 3.5a8 8 0 0 0 1.94-4.3q-.66-.09-1.4-.23c-.9-.18-1.89-.43-2.79-.78a8 8 0 0 1-1.96-1.06L10.7 10zM12.5 8.2q.65.48 1.61.85c.83.32 1.75.55 2.62.72q.68.15 1.27.22c0-2.02-.76-3.87-2-5.28zM15.3 4A8 8 0 0 0 10 2q.1.6.23 1.27c.17.87.4 1.8.72 2.62q.36.96.85 1.6z"
]);
const $f342bb1007016cbf$export$a1cca8a7a41508f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBasketball20Regular', "20", [
    "m10 9.3 1.08-1.09a8 8 0 0 1-1.06-1.96 17 17 0 0 1-.85-3.2 7 7 0 0 0-3.75 1.66zm1.79-.38L10.71 10l4.58 4.58a7 7 0 0 0 1.66-3.75l-.42-.07c-.9-.18-1.88-.43-2.77-.78a8 8 0 0 1-1.97-1.06m5.2.9a7 7 0 0 0-1.7-4.4L12.5 8.2q.66.48 1.61.85a16 16 0 0 0 2.89.78M11.8 7.5l2.8-2.8A7 7 0 0 0 10.16 3l.06.27c.17.87.4 1.8.72 2.62.25.62.53 1.18.85 1.6M10 10.7 8.92 11.8c.44.55.79 1.25 1.06 1.96a17 17 0 0 1 .86 3.2 7 7 0 0 0 3.74-1.66zm-1.8 1.8-2.78 2.8a7 7 0 0 0 4.4 1.7q-.01-.14-.04-.27c-.18-.87-.41-1.8-.73-2.62a7 7 0 0 0-.84-1.6m-.7-.7q-.65-.49-1.61-.85A16 16 0 0 0 3 10.17c.04 1.58.61 3.15 1.7 4.41zm.71-.72L9.3 10 4.71 5.42a7 7 0 0 0-1.66 3.74l.42.08c.9.18 1.88.43 2.78.78.72.28 1.4.62 1.96 1.06m7.45 4.58A8 8 0 1 1 4.34 4.34a8 8 0 0 1 11.32 11.32"
]);
const $f342bb1007016cbf$export$85a42770fec5f790 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBasketball24Filled', "24", [
    "M18.43 12.87c-1.28-.39-2.76-.9-4.16-2.08L13.07 12l6.51 6.52a10 10 0 0 0 2.16-4.22l-.01-.01v-.01a4 4 0 0 0-1.35-.8q-.64-.24-1.42-.46zm.1-8.45-4.25 4.24a10 10 0 0 1-1.7-3.52l-.15-.47c-.15-.54-.31-1.1-.5-1.6q-.21-.54-.52-1.05a10 10 0 0 1 7.11 2.4m1.05 1.06-4.24 4.24a10 10 0 0 0 3.52 1.7l.47.15c.54.15 1.1.31 1.6.5q.54.21 1.05.52a10 10 0 0 0-2.4-7.11m-9.86-3.2-.01-.01a10 10 0 0 0-4.23 2.15L12 10.94l1.21-1.21a11 11 0 0 1-2.08-4.16l-.15-.52q-.21-.79-.46-1.43-.3-.84-.8-1.34m-7.59 8.1a10 10 0 0 1 2.29-4.9L10.94 12l-1.09 1.09a10.3 10.3 0 0 0-4.66-1.91l-.6-.12q-.9-.16-1.64-.37-.48-.13-.82-.3M2 11.97c0 2.34.8 4.68 2.42 6.56l4.36-4.36a9 9 0 0 0-3.89-1.51l-.54-.1A21 21 0 0 1 2 11.95m7.85 3.25-4.37 4.37A10 10 0 0 0 12.24 22q-.22-.46-.37-.93-.24-.83-.4-1.7l-.11-.5a8.6 8.6 0 0 0-1.51-3.66m4.05 6.61a10 10 0 0 0 4.62-2.24L12 13.06l-1.08 1.09a10 10 0 0 1 1.9 4.4l.12.56q.16.83.36 1.51.23.75.6 1.2"
]);
const $f342bb1007016cbf$export$8ae8d3546225afbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportBasketball24Regular', "24", [
    "M12.94 21.96a10 10 0 1 0-1.88-19.91 10 10 0 0 0 1.88 19.9m-9.36-11.1c.2-1.55.84-3.05 1.9-4.32L10.94 12l-1.09 1.09a9 9 0 0 0-3.34-1.61q-.99-.25-1.89-.41h-.01q-.55-.11-1.03-.22m-.07 1.51.8.16h.01q.9.17 1.8.4c.95.26 1.86.61 2.66 1.23l-3.3 3.3a8.5 8.5 0 0 1-1.97-5.09m6.34 2.84c.67.87 1.04 1.81 1.3 2.78a26 26 0 0 1 .4 1.78l.16.73a8.5 8.5 0 0 1-5.17-1.98zm3.39 5.2-.23-.95-.07-.37q-.14-.71-.35-1.49a9 9 0 0 0-1.68-3.45L12 13.06l5.46 5.46a8.5 8.5 0 0 1-4.22 1.89M13.06 12l1.21-1.21a10 10 0 0 0 3.37 1.83q.68.22 1.3.4l.47.13q.53.15.96.32a8.5 8.5 0 0 1-1.85 3.99zm6.78-.28-.5-.15-1.22-.38a9 9 0 0 1-2.78-1.47l3.18-3.18a8.5 8.5 0 0 1 1.98 5.38zm-2.38-6.24-3.18 3.18a9 9 0 0 1-1.47-2.78q-.21-.61-.38-1.22l-.15-.5-.2-.66c1.91.02 3.82.68 5.38 1.98m-6.08.88a10 10 0 0 0 1.83 3.37L12 10.93 6.54 5.49a8.5 8.5 0 0 1 3.99-1.85 13 13 0 0 1 .45 1.42q.18.63.4 1.31"
]);
const $f342bb1007016cbf$export$5ddf5e8724019afe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBall16Filled', "16", [
    "M8 1a7 7 0 0 1 5.83 3.13.5.5 0 0 0-.33-.13h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 .48-.65A7 7 0 0 1 2.9 12.8.5.5 0 0 0 3 12.5v-1a.5.5 0 0 0-1 0v.1A7 7 0 0 1 8 1M4.5 12a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$53baddf4671502fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBall16Regular', "16", [
    "M8 1a7 7 0 1 1 0 13.98A7 7 0 0 1 8 1m0 1a6 6 0 0 0-4 10.47.5.5 0 0 1 .5-.47h1a.5.5 0 0 1 0 1h-.82a6 6 0 0 0 8.51-8h-.69a.5.5 0 0 1-.03-1C11.37 2.77 9.77 2 8 2M4.5 9c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$d47de03c9b034a7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBall20Filled', "20", [
    "M10 2c1.52 0 2.93.42 4.14 1.15a.5.5 0 0 0-.14.35v1a.5.5 0 0 0 1 0v-.74A7.98 7.98 0 0 1 10 18a8 8 0 1 1 0-16M4.5 13a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5m2 1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$a78416e1b0c6ccd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBall20Regular', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1a7 7 0 0 0-6 10.6v-.1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.1.3 7 7 0 0 0 11.07-8.44q.03.06.03.14a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .33.13A7 7 0 0 0 10 3M7.5 14a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5m3 1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-1-3c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$e4565d43620f7eda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBall24Filled', "24", [
    "M12 2c1.72 0 3.33.43 4.75 1.2a.8.8 0 0 0-.25.55v1.5a.75.75 0 0 0 1.5 0V4a9.98 9.98 0 0 1-6 18 10 10 0 0 1 0-20M5.25 15a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m3 1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm0-4.5a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m3 1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm0-4.5a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m3 1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm0-4.5a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m3 1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$d745f4fbe25b5c25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBall24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 0 0-5.47 15h1.22a.75.75 0 0 1 .61 1.18q1.67.8 3.64.82A8.5 8.5 0 0 0 19.5 8h-1.25a.75.75 0 0 1 0-1.5h.23a8.5 8.5 0 0 0-6.48-3M6.25 14c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m4.5 1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5zM9.25 11c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m4.5 1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5zM12.25 8c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m4.5 1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5zM15.25 5c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75"
]);
const $f342bb1007016cbf$export$aca571f390df5ad3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBat16Filled', "16", [
    "M11.23 6.94a1.5 1.5 0 0 0-.23.8v.95q-.06.52-.4.94l-.11.12-4.73 4.74c-.69.68-1.8.68-2.48 0l-1.77-1.77a1.75 1.75 0 0 1 0-2.47L6.25 5.5c.32-.33.77-.51 1.23-.51h.77q.45 0 .8-.24zm1.32-5.6a1.5 1.5 0 0 1 2 .1l.1.11a1.5 1.5 0 0 1 0 1.9l-.1.11-2.64 2.64-2.12-2.12 2.64-2.64z"
]);
const $f342bb1007016cbf$export$b1c9610c7c6efc7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBat16Regular', "16", [
    "M11.74 1.45a2 2 0 0 1 2.81 2.81l-.14.15-2.97 2.98A1.5 1.5 0 0 0 11 8.45v.24q-.08.62-.51 1.06L5.76 14.5c-.69.68-1.8.68-2.48 0l-1.77-1.77a1.75 1.75 0 0 1 0-2.47L6.25 5.5c.33-.33.77-.51 1.23-.51h.07q.62-.01 1.06-.44l2.98-2.97zM8.9 5.6q-.62.4-1.35.4h-.07q-.3 0-.53.22l-4.73 4.73c-.3.3-.3.77 0 1.06l1.77 1.77c.29.3.77.3 1.06 0l4.73-4.73a.8.8 0 0 0 .22-.53v-.07q0-.74.4-1.35zm4.8-3.3a1 1 0 0 0-1.33-.08l-.08.07-2.64 2.65 1.41 1.41 2.65-2.64.07-.08a1 1 0 0 0-.07-1.34"
]);
const $f342bb1007016cbf$export$1034cddf70b04915 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBat20Filled', "20", [
    "M14.23 7.94a1.5 1.5 0 0 0-.23.8v1.38l-.01.2a2 2 0 0 1-.58 1.22l-5.88 5.88a2 2 0 0 1-2.82 0L2.59 15.3a2 2 0 0 1 0-2.83l5.88-5.88A2 2 0 0 1 9.88 6h1.37q.45 0 .8-.24zm1.2-5.5a1.5 1.5 0 0 1 2.12 2.12L14.91 7.2l-2.12-2.12z"
]);
const $f342bb1007016cbf$export$7ebfca0e5dbc66c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBat20Regular', "20", [
    "M14.74 2.45a2 2 0 0 1 2.68.14l.13.15a2 2 0 0 1 0 2.52l-.13.15-2.98 2.98A1.5 1.5 0 0 0 14 9.45v.68l-.01.2a2 2 0 0 1-.58 1.2l-5.87 5.89a2 2 0 0 1-2.83 0L2.59 15.3a2 2 0 0 1 0-2.83l5.88-5.88.14-.14A2 2 0 0 1 9.88 6h.67c.4 0 .78-.16 1.06-.44L14.6 2.6zM11.9 6.6q-.61.4-1.35.4h-.67a1 1 0 0 0-.63.23l-.08.06-5.88 5.89a1 1 0 0 0 0 1.4l2.12 2.13a1 1 0 0 0 1.42 0l5.88-5.88a1 1 0 0 0 .28-.6v-.78q.01-.74.4-1.35zm4.8-3.3a1 1 0 0 0-1.33-.08l-.08.07-2.64 2.65 1.41 1.41 2.65-2.64.07-.08a1 1 0 0 0 0-1.26z"
]);
const $f342bb1007016cbf$export$619e62d86ddb3fa1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBat24Filled', "24", [
    "M17.03 10.09q-.03.15-.03.31v1.32c0 .6-.23 1.17-.66 1.6l-8.02 8.02c-.88.88-2.3.88-3.18 0l-2.48-2.48a2.25 2.25 0 0 1 0-3.18l8.03-8.02c.42-.42.99-.66 1.59-.66h1.31q.16 0 .32-.03zm2.11-7.7c.69-.56 1.7-.52 2.34.12l.12.13c.53.65.53 1.57 0 2.21l-.12.14-3.71 3.71-2.48-2.47 3.72-3.72z"
]);
const $f342bb1007016cbf$export$1c20c2064636537c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportCricketBat24Regular', "24", [
    "M17.73 2.73a2.5 2.5 0 0 1 3.54 3.54l-3.6 3.6c-.43.42-.67 1-.67 1.6v.48c-.06.51-.29 1-.66 1.36l-8.02 8.03c-.88.88-2.3.88-3.18 0l-2.48-2.48a2.25 2.25 0 0 1 0-3.18l8.02-8.02c.43-.42 1-.66 1.6-.66h.25c.6 0 1.17-.24 1.6-.66zM14.1 8.16q-.75.33-1.57.34h-.25q-.31 0-.54.22l-8.02 8.02c-.29.3-.29.77 0 1.06l2.48 2.48c.29.29.77.29 1.06 0l8.02-8.03q.16-.16.2-.38l.02-.15v-.26q0-.82.34-1.56zm6.1-4.37a1 1 0 0 0-1.4 0l-3.48 3.47 1.42 1.42L20.2 5.2a1 1 0 0 0 0-1.42"
]);
const $f342bb1007016cbf$export$828174db61d0db9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportHockey20Filled', "20", [
    "M11.97 2.06a3.7 3.7 0 0 1 3.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.1 4.1 0 0 1 2.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15m2.52 3.52a.5.5 0 1 0-.98-.16 11 11 0 0 1-3.05 5.9 10 10 0 0 1-4.1 2.7.5.5 0 1 0 .28.96c1.25-.36 3-1.38 4.53-2.96a12 12 0 0 0 3.32-6.44"
]);
const $f342bb1007016cbf$export$1fdf56d25b8074f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportHockey20Regular', "20", [
    "M11.97 2.06a3.7 3.7 0 0 1 3.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.1 4.1 0 0 1 2.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15m2.7 1.97c-.68-.76-1.6-1.17-2.5-.99-3 .61-7.03 2.89-9.01 8.5-.41 1.15 0 2.44.97 3.3l1.82 1.6c.46.41 1.03.63 1.57.54 2.85-.42 7.41-2.57 9.39-8.86.23-.73.02-1.55-.53-2.16zm-.6.98c.28.04.47.3.42.57a12 12 0 0 1-3.32 6.44 11 11 0 0 1-4.53 2.96.5.5 0 0 1-.28-.96c1.05-.3 2.66-1.22 4.1-2.7a11 11 0 0 0 3.05-5.9.5.5 0 0 1 .57-.41"
]);
const $f342bb1007016cbf$export$c217d17bf605f20b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportHockey24Filled', "24", [
    "M2.35 12.57c-.68 1.9-.77 3.88.44 5.1l.24.24 3.02 3.04c1.28 1.28 3.3 1.3 5.29.66a16 16 0 0 0 6.22-4.04 16 16 0 0 0 4.04-6.22c.64-1.99.62-4.01-.66-5.3l-2.89-2.9-.36-.37c-1.23-1.21-3.2-1.12-5.1-.44-1.97.71-4.15 2.14-6.12 4.11a17.5 17.5 0 0 0-4.12 6.12m15.14-5.7v.06l-.15.57q-.14.59-.54 1.55a14 14 0 0 1-3.05 4.48 15.6 15.6 0 0 1-6.79 3.94l-.03.01H6.9s-.75.09-.9-.57c-.08-.4.18-.8.58-.9h.03l.5-.14q.53-.15 1.43-.55a14 14 0 0 0 4.14-2.85 13 13 0 0 0 3.2-5.36l.12-.46c.07-.4.44-.7.86-.64.41.07.69.45.62.86"
]);
const $f342bb1007016cbf$export$1908533ba4f316da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportHockey24Regular', "24", [
    "M17.49 6.87a.75.75 0 0 0-.62-.86.77.77 0 0 0-.86.64l-.11.46q-.14.5-.48 1.35a13 13 0 0 1-2.73 4.01 14 14 0 0 1-6.08 3.54H6.6a.75.75 0 0 0-.57.9c.14.66.89.57.89.57h.05l.6-.18q.62-.18 1.6-.62c1.31-.59 3-1.57 4.59-3.15a14.3 14.3 0 0 0 3.6-6.03l.13-.57v-.05m-15.14 5.7c-.68 1.9-.77 3.88.44 5.1l.23.24 3.03 3.04c1.28 1.28 3.3 1.3 5.29.66a16 16 0 0 0 6.22-4.04 16 16 0 0 0 4.04-6.22c.64-1.99.62-4.01-.66-5.3l-2.9-2.9-.36-.37c-1.22-1.21-3.2-1.12-5.1-.44-1.96.71-4.15 2.14-6.12 4.11a17.5 17.5 0 0 0-4.1 6.12m1.41.51a16 16 0 0 1 3.77-5.56 16 16 0 0 1 5.56-3.77c1.78-.64 2.97-.47 3.54.1l.35.35.88.89 2.02 2.03c.67.67.87 1.97.3 3.77a15 15 0 0 1-3.68 5.62 15 15 0 0 1-5.63 3.67c-1.8.58-3.09.38-3.76-.3l-3.02-3.02-.23-.24c-.57-.57-.74-1.76-.1-3.54"
]);
const $f342bb1007016cbf$export$7f21873b0cf33ab0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccer16Filled', "16", [
    "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0m4.14-4.97q-1.1.53-1.89 1.47l.65 2.1 1 .34 2.1-1.59V4.27zm-3.1 5.6q.16 1.31.85 2.37h1.9l.64-.63L5.1 7.9l-1.02-.35zm4.35 4.76a6 6 0 0 0 2.22 0l.8-1.78-.62-.61H6.71l-.61.61zM12.6 11q.68-1.02.84-2.28l-1.54-1.16-1.01.34-.83 2.47.64.63zm-.38-6.51a5.5 5.5 0 0 0-1.87-1.46L8.5 4.27v1.08l2.1 1.6 1-.34z"
]);
const $f342bb1007016cbf$export$c6807cf38e522de6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccer16Regular', "16", [
    "M8 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M6.84 2.62 8 3.4l1.16-.78a5.5 5.5 0 0 0-2.32 0m-1.2.4q-1.1.54-1.89 1.48l.65 2.1 1 .34 2.1-1.59V4.27zM3.04 5.6a6 6 0 0 0-.51 1.82l.89-.62zm-.5 3.03q.16 1.31.85 2.37h1.9l.64-.63L5.1 7.9l-1.02-.35zM4.23 12q.6.57 1.37.95L5.18 12zm2.66 1.39a6 6 0 0 0 2.22 0l.8-1.78-.62-.61H6.71l-.61.61zm3.51-.44q.76-.38 1.37-.95h-.95zM12.61 11q.68-1.02.84-2.28l-1.54-1.16-1.01.34-.83 2.47.64.63zm.87-3.52a6 6 0 0 0-.53-1.89l-.37 1.22zm-1.25-3a5.5 5.5 0 0 0-1.87-1.45L8.5 4.27v1.08l2.1 1.6 1-.34zM6.1 7.69 6.86 10h2.28l.77-2.32L8 6.23z"
]);
const $f342bb1007016cbf$export$3c83abdf8cc1ea62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccer20Filled', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M7.1 3.63l2.4 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7 7 0 0 1 2.54-1.98M3.02 10.7l1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a7 7 0 0 1-1.22-3.3m5.34 6.12-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7 7 0 0 1-3.26 0M15.75 14h-2.48l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a7 7 0 0 1-1.22 3.3m-.3-8.38-.62 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98"
]);
const $f342bb1007016cbf$export$8a66a41492000b08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccer20Regular', "20", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M8.34 3.2a7 7 0 0 1 3.33 0L10 4.17zm-1.25.43 2.41 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7 7 0 0 1 2.54-1.98M3.8 6.75l.4 1.58-1.17 1.03q.13-1.42.77-2.61m-.77 3.94 1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a7 7 0 0 1-1.22-3.3M5.1 15h1.55l.51 1.41A7 7 0 0 1 5.1 15m3.27 1.82-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7 7 0 0 1-3.26 0m4.47-.41.51-1.4h1.55a7 7 0 0 1-2.06 1.4m2.9-2.4h-2.47l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a7 7 0 0 1-1.22 3.3m1.23-4.64-1.16-1.03.4-1.58c.4.8.68 1.68.76 2.6m-1.51-3.74-.63 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98M7.4 9.45 10 7.6l2.59 1.84-.96 3.05H8.37z"
]);
const $f342bb1007016cbf$export$7cecf25c7713aaf7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccer24Filled', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M8.24 4.37l3.01 1.8v2.2l-2.79 2.02-2.04-.7-.59-3.54a9 9 0 0 1 2.41-1.78m-4.62 9.07 2.33-2.33 2.04.7 1.08 3.34-.97 1.58-3.3-.2q-.88-1.4-1.18-3.1m6.91 6.93-1.18-2.8.96-1.57h3.37l.91 1.58-1.04 2.78a9 9 0 0 1-3.02.01m8.36-3.4-3.02-.18-.94-1.63 1.09-3.34 2.01-.7 2.31 2.52a8.5 8.5 0 0 1-1.45 3.34m-.72-10.81-.59 3.53-2.04.7-2.79-2.02v-2.2l3-1.8a9 9 0 0 1 2.42 1.79"
]);
const $f342bb1007016cbf$export$f185db0d458a6d7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SportSoccer24Regular', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-1.93 1.72a8.5 8.5 0 0 1 3.86 0L12 4.87zm-1.83.65 3.01 1.8v2.2l-2.79 2.02-2.04-.7-.59-3.54a9 9 0 0 1 2.41-1.78M4.6 7.83 4.95 10l-1.43 1.43q.15-1.96 1.07-3.59m-.97 5.6 2.33-2.32 2.04.7 1.08 3.34-.97 1.58-3.3-.2q-.88-1.4-1.18-3.1m2.47 4.68 1.9.11.68 1.6c-.96-.4-1.84-1-2.58-1.71m4.44 2.26-1.18-2.8.96-1.57h3.37l.91 1.58-1.04 2.78a9 9 0 0 1-3.02.01m4.83-.56.57-1.52 1.67.1a9 9 0 0 1-2.24 1.42m3.53-2.83-3.02-.2-.94-1.62 1.09-3.34 2.01-.7 2.31 2.52a8.5 8.5 0 0 1-1.45 3.34m1.6-5.4-1.44-1.57.36-2.17a8.5 8.5 0 0 1 1.08 3.74m-2.32-5.42-.59 3.53-2.04.7-2.79-2.02v-2.2l3-1.8a9 9 0 0 1 2.42 1.79m-8.7 5.36L12 9.68l2.54 1.84-.97 2.98h-3.13z"
]);
const $f342bb1007016cbf$export$d4db28d00b4eca54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubGrid20Filled', "20", [
    "M6 10.5v2c0 .83.67 1.5 1.5 1.5h2v-3.5zm0-1v-2C6 6.67 6.67 6 7.5 6h2v3.5zM10.5 6v3.5H14v-2c0-.83-.67-1.5-1.5-1.5zm3.5 4.5h-3.5V14h2c.83 0 1.5-.67 1.5-1.5zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-2 7.5h2v-1H4V6c0-1.1.9-2 2-2h3.5v2h1V4H14a2 2 0 0 1 2 2v3.5h-2v1h2V14a2 2 0 0 1-2 2h-3.5v-2h-1v2H6a2 2 0 0 1-2-2z"
]);
const $f342bb1007016cbf$export$5445698609df742b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubGrid20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 14v-3.5h2v2c0 .83.67 1.5 1.5 1.5h2v2H6a2 2 0 0 1-2-2m6.5 0h2c.83 0 1.5-.67 1.5-1.5v-2h2V14a2 2 0 0 1-2 2h-3.5zm2.5-3.5v2a.5.5 0 0 1-.5.5h-2v-2.5zm1-1v-2c0-.83-.67-1.5-1.5-1.5h-2V4H14a2 2 0 0 1 2 2v3.5zM10.5 7h2c.28 0 .5.22.5.5v2h-2.5zm-1-1h-2C6.67 6 6 6.67 6 7.5v2H4V6c0-1.1.9-2 2-2h3.5zM7 9.5v-2c0-.28.22-.5.5-.5h2v2.5zm0 1h2.5V13h-2a.5.5 0 0 1-.5-.5z"
]);
const $f342bb1007016cbf$export$579c0a40635d6a65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubGrid24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h5V7h-1.5A2.75 2.75 0 0 0 7 9.75v1.5H4.5zm2.5 6.5v-1.5h4.25V7h1.5v4.25H17v1.5h-4.25V17h-1.5v-4.25zm0 0v1.5A2.75 2.75 0 0 0 9.75 17h1.5v2.5h-5c-.97 0-1.75-.78-1.75-1.75v-5zM12.75 17h1.5A2.75 2.75 0 0 0 17 14.25v-1.5h2.5v5c0 .97-.78 1.75-1.75 1.75h-5zM17 11.25v-1.5A2.75 2.75 0 0 0 14.25 7h-1.5V4.5h5c.97 0 1.75.78 1.75 1.75v5z"
]);
const $f342bb1007016cbf$export$efa2152c72a71b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubGrid24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h5V7h-1.5A2.75 2.75 0 0 0 7 9.75v1.5H4.5zm2.5 6.5v1.5A2.75 2.75 0 0 0 9.75 17h1.5v2.5h-5c-.97 0-1.75-.78-1.75-1.75v-5zm4.25 2.75h-1.5c-.69 0-1.25-.56-1.25-1.25v-1.5h2.75zm1.5 1.5h1.5A2.75 2.75 0 0 0 17 14.25v-1.5h2.5v5c0 .97-.78 1.75-1.75 1.75h-5zm2.75-4.25v1.5c0 .69-.56 1.25-1.25 1.25h-1.5v-2.75zm1.5-1.5v-1.5A2.75 2.75 0 0 0 14.25 7h-1.5V4.5h5c.97 0 1.75.78 1.75 1.75v5zM12.75 8.5h1.5c.69 0 1.25.56 1.25 1.25v1.5h-2.75zm-1.5 0v2.75H8.5v-1.5c0-.69.56-1.25 1.25-1.25z"
]);
const $f342bb1007016cbf$export$18c55fc7bd28c7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtitles16Filled', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zm2 3c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM10 8.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5M8.5 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$ecfd5577c283f24a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtitles16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5zM3.5 4C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM3 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM10 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5M8.5 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$60051d7d002245b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtitles20Filled', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zm2 4.75c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5-1.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5M9.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$47695ea627af9302 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtitles20Regular', "20", [
    "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5zM4 11.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm8.5-1.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5M9.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$bf7fb34809805e2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtitles24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zm3 6c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75m10.75-.75a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM5 16.25c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75m6.75-.75a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$a0267dc8683f458d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtitles24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75zM5.25 5.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zM5 13.25c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m10.75-.75a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM5 16.25c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m6.75-.75a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$5eeda5eeb46bab8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract12Filled', "12", [
    "M2 6c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 2 6"
]);
const $f342bb1007016cbf$export$b69e42206728b8e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract12Regular', "12", [
    "M2 6c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 2 6"
]);
const $f342bb1007016cbf$export$6c85430897b94ccb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract16Filled', "16", [
    "M3 8c0-.41.34-.75.75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 8"
]);
const $f342bb1007016cbf$export$fb44e0b72ff7d156 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract16Regular', "16", [
    "M3 8c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8"
]);
const $f342bb1007016cbf$export$3187d9598322623a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract20Filled', "20", [
    "M3 10c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10"
]);
const $f342bb1007016cbf$export$9597fb75a491c04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract20Regular', "20", [
    "M3 10c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 3 10"
]);
const $f342bb1007016cbf$export$e205773de16ffcf9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract24Filled', "24", [
    "M4 13h16a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2"
]);
const $f342bb1007016cbf$export$a4e183b4a9e8f2fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract24Regular', "24", [
    "M3.75 12.5h16.5a.75.75 0 0 0 0-1.5H3.75a.75.75 0 0 0 0 1.5"
]);
const $f342bb1007016cbf$export$34d675376f9fc5cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract28Filled', "28", [
    "M3 14a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1"
]);
const $f342bb1007016cbf$export$1ece8fe3339eb2dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract28Regular', "28", [
    "M3 13.75c0-.41.34-.75.75-.75h20.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75"
]);
const $f342bb1007016cbf$export$b36e1f0d70ebd27f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract48Filled', "48", [
    "M6 23.5c0-.83.67-1.5 1.5-1.5h33a1.5 1.5 0 0 1 0 3h-33A1.5 1.5 0 0 1 6 23.5"
]);
const $f342bb1007016cbf$export$c09fcdd11ec311f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Subtract48Regular', "48", [
    "M6 23.25c0-.69.56-1.25 1.25-1.25h33.5a1.25 1.25 0 1 1 0 2.5H7.25c-.69 0-1.25-.56-1.25-1.25"
]);
const $f342bb1007016cbf$export$5e915a4de196b593 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle12Filled', "12", [
    "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6m3-.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$867af164de019265 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle12Regular', "12", [
    "M4 5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
]);
const $f342bb1007016cbf$export$7e721f41b40357db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle16Filled', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m4-.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$b7dbdb3a7ad81dfa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1M5 7.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$2ff59a33ae32bacd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle20Filled', "20", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0M6 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5"
]);
const $f342bb1007016cbf$export$ec27331cf9d6e238 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle20Regular', "20", [
    "M6 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 6 10m4 8a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
]);
const $f342bb1007016cbf$export$fe8b0654d275f679 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m-4.25 9.25a.75.75 0 0 0-.1 1.5h8.6a.75.75 0 0 0 .1-1.5h-8.6"
]);
const $f342bb1007016cbf$export$28cc948403961a54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m4.25 7.75a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5z"
]);
const $f342bb1007016cbf$export$2a8fec6b06b385f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle28Filled', "28", [
    "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24M8.75 13.25a.75.75 0 0 0-.1 1.5h10.6a.75.75 0 0 0 .1-1.5H8.75"
]);
const $f342bb1007016cbf$export$7aa3d0b162970af6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle28Regular', "28", [
    "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24m0 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21m5.25 9.75a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5z"
]);
const $f342bb1007016cbf$export$f1e0611ca6d48252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle32Filled', "32", [
    "M30 16a14 14 0 1 1-28 0 14 14 0 0 1 28 0m-20-1a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"
]);
const $f342bb1007016cbf$export$b653d0793d08461d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle32Regular', "32", [
    "M28 16a12 12 0 1 0-24 0 12 12 0 0 0 24 0m2 0a14 14 0 1 1-28 0 14 14 0 0 1 28 0m-20-1a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"
]);
const $f342bb1007016cbf$export$c578019b1178da88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle48Filled', "48", [
    "M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40M14 24c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 1 1 0 2.5h-17.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $f342bb1007016cbf$export$a9e9a40d244829c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircle48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 1 35 0 17.5 17.5 0 0 1-35 0M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40M14 24c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 1 1 0 2.5h-17.5c-.69 0-1.25-.56-1.25-1.25"
]);
const $f342bb1007016cbf$export$777423ed50271c08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowBack16Filled', "16", [
    "M1 8a7 7 0 0 1 13.96-.78 5.5 5.5 0 0 0-7.23.28H5a.5.5 0 0 0 0 1h1.89a5.5 5.5 0 0 0 .33 6.46A7 7 0 0 1 1 8m10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 14 13.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75H9.71l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7L9.9 8.9a.5.5 0 0 1 .7.7"
]);
const $f342bb1007016cbf$export$9dc4d7d1ec5a3fbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowBack16Regular', "16", [
    "M2 8a6 6 0 0 1 11.81-1.5q.62.3 1.15.72a7 7 0 1 0-7.74 7.74 6 6 0 0 1-.71-1.15A6 6 0 0 1 2 8m3-.5h2.73q-.48.45-.84 1H5a.5.5 0 0 1 0-1m6.5 8.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 14 13.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75H9.71l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7L9.9 8.9a.5.5 0 0 1 .7.7"
]);
const $f342bb1007016cbf$export$69839c4d404ccd83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowBack20Filled', "20", [
    "M16.98 9.59 17 9a8 8 0 1 0-7.41 7.98A5.5 5.5 0 0 1 12.2 9.5H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .45.72 5.5 5.5 0 0 1 4.03.37M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.4-2.6a.5.5 0 0 0-.7 0l-1.75 1.75a.5.5 0 0 0 0 .7l1.75 1.75a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75h-1.54l.9-.9a.5.5 0 0 0 0-.7"
]);
const $f342bb1007016cbf$export$4b516376fd9060d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowBack20Regular', "20", [
    "M5.5 8.5a.5.5 0 0 0 0 1h6.7q.37-.16.75-.28a.5.5 0 0 0-.45-.72zm10.5.7V9a7 7 0 1 0-6.8 7q.15.51.39.98L9 17a8 8 0 1 1 7.98-7.41A6 6 0 0 0 16 9.2m3 5.3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.4-2.6a.5.5 0 0 0-.7 0l-1.75 1.75a.5.5 0 0 0 0 .7l1.75 1.75a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75h-1.54l.9-.9a.5.5 0 0 0 0-.7"
]);
const $f342bb1007016cbf$export$8adacb8d7fbcb81a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowForward16Filled', "16", [
    "M1 8a7 7 0 0 1 13.96-.78 5.5 5.5 0 0 0-7.23.28H5a.5.5 0 0 0 0 1h1.89a5.5 5.5 0 0 0 .33 6.46A7 7 0 0 1 1 8m10.5 8a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 9 13.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L13.1 8.9a.5.5 0 0 0-.7.7"
]);
const $f342bb1007016cbf$export$d1f0e66f3b32f6f9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowForward16Regular', "16", [
    "M2 8a6 6 0 0 1 11.81-1.5q.62.3 1.15.72a7 7 0 1 0-7.74 7.74 6 6 0 0 1-.71-1.15A6 6 0 0 1 2 8m3-.5h2.73q-.48.45-.84 1H5a.5.5 0 0 1 0-1m6.5 8.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 9 13.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L13.1 8.9a.5.5 0 0 0-.7.7"
]);
const $f342bb1007016cbf$export$e08e5184e0bc7d86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowForward20Filled', "20", [
    "M16.98 9.59 17 9a8 8 0 1 0-7.41 7.98A5.5 5.5 0 0 1 12.2 9.5H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .45.72 5.5 5.5 0 0 1 4.03.37M10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7"
]);
const $f342bb1007016cbf$export$985e37cbb2769f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractCircleArrowForward20Regular', "20", [
    "M5.5 8.5a.5.5 0 0 0 0 1h6.7q.37-.16.75-.28a.5.5 0 0 0-.45-.72zm10.5.7V9a7 7 0 1 0-6.8 7q.15.51.39.98L9 17a8 8 0 1 1 7.98-7.41A6 6 0 0 0 16 9.2m-6 5.3a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7"
]);
const $f342bb1007016cbf$export$df3ef30ceb1a6b46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses16Filled', "16", [
    "M4.7 3.6a.75.75 0 1 0-.9-1.2 7 7 0 0 0 0 11.2.75.75 0 0 0 .9-1.2 5.5 5.5 0 0 1 0-8.8m7.5-1.2a.75.75 0 1 0-.9 1.2 5.5 5.5 0 0 1 0 8.8.75.75 0 1 0 .9 1.2 7 7 0 0 0 0-11.2M5.75 7.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$e6c7778c8c7719b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses16Regular', "16", [
    "M4.77 2.94a.5.5 0 1 0-.54-.84 7 7 0 0 0 0 11.8.5.5 0 1 0 .54-.84 6 6 0 0 1 0-10.12m7-.84a.5.5 0 0 0-.54.84 6 6 0 0 1 0 10.12.5.5 0 1 0 .54.84 7 7 0 0 0 0-11.8M5.5 7.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$142f60e645556133 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses20Filled', "20", [
    "M5.77 5.07a.75.75 0 1 0-.98-1.14 7.98 7.98 0 0 0 0 12.14.75.75 0 1 0 .98-1.14 6.48 6.48 0 0 1 0-9.86m9.44-1.14a.75.75 0 1 0-.98 1.14 6.48 6.48 0 0 1 0 9.86.75.75 0 1 0 .98 1.14 7.98 7.98 0 0 0 0-12.14M6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$1e26c78b8cc22440 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses20Regular', "20", [
    "M5.8 4.4a.5.5 0 0 0-.6-.8 8 8 0 0 0 0 12.8.5.5 0 0 0 .6-.8 7 7 0 0 1 0-11.2m9-.8a.5.5 0 0 0-.6.8 7 7 0 0 1 0 11.2.5.5 0 1 0 .6.8 8 8 0 0 0 0-12.8M6.5 9.5a.5.5 0 1 0 0 1h7a.5.5 0 1 0 0-1z"
]);
const $f342bb1007016cbf$export$368607373e103c86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses24Filled', "24", [
    "M6.67 6.04a1 1 0 1 0-1.34-1.5 9.98 9.98 0 0 0 .38 15.24 1 1 0 0 0 1.26-1.56 7.98 7.98 0 0 1-.3-12.18m12-1.5a1 1 0 1 0-1.34 1.5 7.98 7.98 0 0 1 0 11.92 1 1 0 0 0 1.34 1.5 9.98 9.98 0 0 0 0-14.91M7 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1"
]);
const $f342bb1007016cbf$export$827525a6387af69f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses24Regular', "24", [
    "M6.72 5.34a.75.75 0 1 0-.93-1.18 9.98 9.98 0 0 0 0 15.68.75.75 0 1 0 .93-1.18 8.48 8.48 0 0 1 0-13.32m11.5-1.18a.75.75 0 1 0-.94 1.18 8.48 8.48 0 0 1 0 13.32.75.75 0 0 0 .93 1.18 9.98 9.98 0 0 0 0-15.68M7.74 11.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$383d678783c49280 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses28Filled', "28", [
    "M7.64 6.29a1 1 0 1 0-1.28-1.55 11.98 11.98 0 0 0 0 18.52 1 1 0 0 0 1.28-1.55 9.98 9.98 0 0 1 0-15.42m14-1.55a1 1 0 1 0-1.28 1.55 9.98 9.98 0 0 1 0 15.42 1 1 0 0 0 1.28 1.55 11.98 11.98 0 0 0 0-18.52M9 13a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z"
]);
const $f342bb1007016cbf$export$5b980ee6134407ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses28Regular', "28", [
    "M7.7 5.6a.75.75 0 1 0-.9-1.2 11.98 11.98 0 0 0 0 19.2.75.75 0 1 0 .9-1.2 10.48 10.48 0 0 1 0-16.8m13.5-1.2a.75.75 0 1 0-.9 1.2 10.48 10.48 0 0 1 .23 16.62.75.75 0 1 0 .94 1.17A11.98 11.98 0 0 0 21.2 4.4M8.75 13.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
]);
const $f342bb1007016cbf$export$6b2eb8fc668c682a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses32Filled', "32", [
    "M8.56 7.23a1.25 1.25 0 0 0-1.62-1.9 13.97 13.97 0 0 0 0 21.34 1.25 1.25 0 1 0 1.62-1.9 11.47 11.47 0 0 1 0-17.54m16.5-1.9a1.25 1.25 0 1 0-1.62 1.9 11.47 11.47 0 0 1 0 17.54 1.25 1.25 0 0 0 1.62 1.9 13.97 13.97 0 0 0 0-21.34m-14.81 9.42a1.25 1.25 0 1 0 0 2.5h11.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $f342bb1007016cbf$export$ba62dbfe0df5bc12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses32Regular', "32", [
    "M8.62 6.54a1 1 0 1 0-1.24-1.58 13.98 13.98 0 0 0 0 22.08 1 1 0 1 0 1.24-1.58 11.98 11.98 0 0 1 0-18.92m16-1.58a1 1 0 1 0-1.24 1.58 11.98 11.98 0 0 1 0 18.92 1 1 0 1 0 1.24 1.58 13.98 13.98 0 0 0 0-22.08M10 15a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"
]);
const $f342bb1007016cbf$export$cddc875c4441094f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses48Filled', "48", [
    "M13.43 10.68a1.5 1.5 0 1 0-1.86-2.35A20 20 0 0 0 4 24c0 6.35 2.96 12 7.57 15.67a1.5 1.5 0 1 0 1.86-2.35A17 17 0 0 1 7 24c0-5.4 2.51-10.2 6.43-13.32m23-2.35a1.5 1.5 0 0 0-1.86 2.35A17 17 0 0 1 41 24c0 5.4-2.51 10.2-6.43 13.32a1.5 1.5 0 1 0 1.86 2.35A20 20 0 0 0 44 24c0-6.35-2.96-12-7.57-15.67M15.5 22.5a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3z"
]);
const $f342bb1007016cbf$export$e8a9e7aca25a8ba3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractParentheses48Regular', "48", [
    "M13.5 10A1.25 1.25 0 1 0 12 8a19.97 19.97 0 0 0 0 32 1.25 1.25 0 1 0 1.5-2 17.47 17.47 0 0 1 0-28M36 8a1.25 1.25 0 1 0-1.5 2 17.47 17.47 0 0 1 0 28 1.25 1.25 0 0 0 1.5 2 19.97 19.97 0 0 0 0-32M15.25 22.75a1.25 1.25 0 0 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5z"
]);
const $f342bb1007016cbf$export$26984752f2a4790f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquare16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zm3.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
]);
const $f342bb1007016cbf$export$b8d275e718783549 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquare16Regular', "16", [
    "M5.5 7.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5z"
]);
const $f342bb1007016cbf$export$fbafb0f969e19728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquare20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm.5 6.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1"
]);
const $f342bb1007016cbf$export$93b136795760399c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquare20Regular', "20", [
    "M6.5 9.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
]);
const $f342bb1007016cbf$export$43117043f8c5ae63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquare24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.45 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75zm13.25 5h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5"
]);
const $f342bb1007016cbf$export$f4b098988121f493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquare24Regular', "24", [
    "M16.25 11.25h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75z"
]);
const $f342bb1007016cbf$export$4feaa021ae3f2ee7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareMultiple16Filled', "16", [
    "M4 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm.5 4.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 1 1 0-1m8.5 4a2.5 2.5 0 0 1-2.5 2.5H3.27c.34.6.99 1 1.73 1h5.5a3.5 3.5 0 0 0 3.5-3.5V5a2 2 0 0 0-1-1.73z"
]);
const $f342bb1007016cbf$export$815435d5b867915d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareMultiple16Regular', "16", [
    "M4.5 6.5a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1zM2 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm9 7.5a2.5 2.5 0 0 1-2.5 2.5H3.27c.34.6.99 1 1.73 1h5.5a3.5 3.5 0 0 0 3.5-3.5V5a2 2 0 0 0-1-1.73z"
]);
const $f342bb1007016cbf$export$c0a3a3d4eb7fcdae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareMultiple20Filled', "20", [
    "M16 5.27c.6.34 1 .99 1 1.73v6a4 4 0 0 1-4 4H7a2 2 0 0 1-1.73-1H13a3 3 0 0 0 3-3zM15 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2zm-3 4a.5.5 0 0 1-.5.5h-5a.5.5 0 1 1 0-1h5c.28 0 .5.22.5.5"
]);
const $f342bb1007016cbf$export$d51a8561385345ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SubtractSquareMultiple20Regular', "20", [
    "M16 5.27V13a3 3 0 0 1-3 3H5.27c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4V7a2 2 0 0 0-1-1.73M11.5 9.5a.5.5 0 0 0 0-1h-5a.5.5 0 1 0 0 1zM13 3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm1 2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z"
]);
const $f342bb1007016cbf$export$1b4ba74e60df9950 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning12Filled', "12", [
    "M4.28 1.97a2 2 0 0 1 3.43 0l3 5A2 2 0 0 1 9 10H3A2 2 0 0 1 1.3 6.98zM6 6.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M6 3.5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$888f746f7b3dc1fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning12Regular', "12", [
    "M4.28 1.97a2 2 0 0 1 3.43 0l3 5A2 2 0 0 1 9 10H3A2 2 0 0 1 1.3 6.98zm2.58.52a1 1 0 0 0-1.72 0l-3 5A1 1 0 0 0 3 9h6a1 1 0 0 0 .85-1.5zM6 6.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M6 3.5c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-1 0V4c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$f14dacb658dd7f59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning16Color', "16", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_16_color__a)",
            "d": "M9.1 2.64a1.25 1.25 0 0 0-2.19 0l-4.75 8.5c-.47.83.13 1.86 1.09 1.86h9.5c.96 0 1.56-1.03 1.1-1.86z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_16_color__b)",
            "d": "M8.75 10.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.5 8V5.5a.5.5 0 0 1 1 0V8a.5.5 0 0 1-1 0"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_16_color__a",
                "x1": "3.87",
                "x2": "10.73",
                "y1": ".28",
                "y2": "14.53",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_16_color__b",
                "x1": "6",
                "x2": "8.47",
                "y1": "5",
                "y2": "11.58",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$93c97f548c7c6b59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning16Filled', "16", [
    "M5.82 2.28a2.5 2.5 0 0 1 4.36 0l4.5 8A2.5 2.5 0 0 1 12.5 14h-9a2.5 2.5 0 0 1-2.18-3.72zM8 9.5A.75.75 0 1 0 8 11a.75.75 0 0 0 0-1.5M8 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 1 0V5.5A.5.5 0 0 0 8 5"
]);
const $f342bb1007016cbf$export$e6bca01c41d10d84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning16Regular', "16", [
    "M5.82 2.28a2.5 2.5 0 0 1 4.36 0l4.5 8A2.5 2.5 0 0 1 12.5 14h-9a2.5 2.5 0 0 1-2.18-3.72zm3.49.48a1.5 1.5 0 0 0-2.62 0l-4.5 8a1.5 1.5 0 0 0 1.31 2.24h9a1.5 1.5 0 0 0 1.3-2.23zM8 9.5A.75.75 0 1 1 8 11a.75.75 0 0 1 0-1.5M8 5c.28 0 .5.22.5.5V8a.5.5 0 0 1-1 0V5.5c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$385a79e6daacd783 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning20Color', "20", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_20_color__a)",
            "d": "M8.68 2.79a1.5 1.5 0 0 1 2.64 0l6.5 12A1.5 1.5 0 0 1 16.5 17h-13a1.5 1.5 0 0 1-1.32-2.21z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_20_color__b)",
            "d": "M10.5 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_20_color__c)",
            "d": "M10 14.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_20_color__a",
                "x1": "4.5",
                "x2": "13.97",
                "y1": "-.34",
                "y2": "18.91",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_20_color__b",
                "x1": "8",
                "x2": "11.6",
                "y1": "7",
                "y2": "14.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_20_color__c",
                "x1": "8",
                "x2": "11.6",
                "y1": "7",
                "y2": "14.69",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#242424"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$cc3cb20aca9f9e2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning20Filled', "20", [
    "M7.37 3.56a3 3 0 0 1 5.26 0l5.5 10A3 3 0 0 1 15.5 18h-11a3 3 0 0 1-2.63-4.44zM10 12.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-6.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$5d7170d5d04c7923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning20Regular', "20", [
    "M7.37 3.56a3 3 0 0 1 5.26 0l5.5 10A3 3 0 0 1 15.5 18h-11a3 3 0 0 1-2.63-4.44zm4.38.48a2 2 0 0 0-3.5 0l-5.5 10A2 2 0 0 0 4.5 17h11a2 2 0 0 0 1.75-2.96zM10 12.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-6.25c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$b5d4f71d3220236e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning24Color', "24", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_24_color__a)",
            "d": "M10.03 3.66a2.25 2.25 0 0 1 3.94 0l7.74 14A2.25 2.25 0 0 1 19.74 21H4.25a2.25 2.25 0 0 1-1.97-3.34z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_24_color__b)",
            "d": "M13 17a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-.26-7.85a.75.75 0 0 0-1.5.1v4.5l.02.1a.75.75 0 0 0 1.49-.1v-4.5z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_24_color__a",
                "x1": "5.12",
                "x2": "16.72",
                "y1": "-.39",
                "y2": "23.48",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_24_color__b",
                "x1": "9.34",
                "x2": "13.75",
                "y1": "8.5",
                "y2": "18.41",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$44f8b434622f9ba9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning24Filled', "24", [
    "M9.14 3.7a3.25 3.25 0 0 1 5.72 0l6.74 12.5a3.25 3.25 0 0 1-2.86 4.8H5.25a3.25 3.25 0 0 1-2.86-4.8zM12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-7.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 7.5"
]);
const $f342bb1007016cbf$export$fac7dd73b33ba4da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning24Regular', "24", [
    "M9.14 3.7a3.25 3.25 0 0 1 5.72 0l6.74 12.5a3.25 3.25 0 0 1-2.86 4.8H5.25a3.25 3.25 0 0 1-2.86-4.8zm4.4.72a1.75 1.75 0 0 0-3.08 0L3.7 16.92a1.75 1.75 0 0 0 1.54 2.58h13.5a1.75 1.75 0 0 0 1.53-2.58zM12 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-7.5c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $f342bb1007016cbf$export$225e57acc0a568dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning28Color', "28", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "M11.6 4.17a2.75 2.75 0 0 1 4.8 0l9.26 16.75a2.75 2.75 0 0 1-2.4 4.08H4.75a2.75 2.75 0 0 1-2.41-4.08z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_28_color__a)",
            "d": "M11.6 4.17a2.75 2.75 0 0 1 4.8 0l9.26 16.75a2.75 2.75 0 0 1-2.4 4.08H4.75a2.75 2.75 0 0 1-2.41-4.08z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_28_color__b)",
            "d": "M15 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.75-3.25a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.5 0z"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_28_color__a",
                "x1": "5.75",
                "x2": "19.71",
                "y1": "-.73",
                "y2": "27.96",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_28_color__b",
                "x1": "11.33",
                "x2": "17.34",
                "y1": "9.5",
                "y2": "20.64",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#242424"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$71057c5f17716185 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning28Filled', "28", [
    "M10.74 4.9a3.75 3.75 0 0 1 6.52 0l8.24 14.5a3.75 3.75 0 0 1-3.25 5.6H5.76a3.75 3.75 0 0 1-3.26-5.6zM14 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-9a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 1.5 0v-6A.75.75 0 0 0 14 9"
]);
const $f342bb1007016cbf$export$17c1cc81f0e2f093 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning28Regular', "28", [
    "M10.74 4.9a3.75 3.75 0 0 1 6.52 0l8.24 14.5a3.75 3.75 0 0 1-3.26 5.6H5.76a3.75 3.75 0 0 1-3.26-5.6zm5.21.74a2.25 2.25 0 0 0-3.9 0L3.8 20.14a2.25 2.25 0 0 0 1.96 3.36h16.48c1.73 0 2.81-1.86 1.96-3.36zM14 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-9c.41 0 .75.34.75.75v6a.75.75 0 0 1-1.5 0v-6c0-.41.34-.75.75-.75"
]);
const $f342bb1007016cbf$export$28dce39dc01e7ba3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning32Color', "32", [
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_32_color__a)",
            "d": "M12.94 3.8a3.5 3.5 0 0 1 6.12 0l10.5 19a3.5 3.5 0 0 1-3.07 5.2H5.51a3.5 3.5 0 0 1-3.07-5.2z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_32_color__b)",
            "d": "M17.25 22a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16 9a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_32_color__a",
                "x1": "6.38",
                "x2": "22.71",
                "y1": "-2.06",
                "y2": "31.43",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_32_color__b",
                "x1": "12.67",
                "x2": "20.07",
                "y1": "9",
                "y2": "22.86",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#212121"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$424e4b11347c4e66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning32Filled', "32", [
    "M12.07 4.3a4.5 4.5 0 0 1 7.86 0l9.5 17c1.67 3-.5 6.7-3.94 6.7H6.51a4.5 4.5 0 0 1-3.93-6.7zM16 19.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M16 9a1 1 0 0 0-1 1v6.5a1 1 0 0 0 2 0V10a1 1 0 0 0-1-1"
]);
const $f342bb1007016cbf$export$bb733ca6e6c3bcd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning32Regular', "32", [
    "M12.07 4.3a4.5 4.5 0 0 1 7.86 0l9.5 17c1.67 3-.5 6.7-3.94 6.7H6.51a4.5 4.5 0 0 1-3.93-6.7zm6.11.98a2.5 2.5 0 0 0-4.36 0l-9.5 17A2.5 2.5 0 0 0 6.51 26h18.98a2.5 2.5 0 0 0 2.19-3.72zM16 19.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M16 9a1 1 0 0 1 1 1v6.5a1 1 0 0 1-2 0V10a1 1 0 0 1 1-1"
]);
const $f342bb1007016cbf$export$bddb7d5e1834e0bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning48Color', "48", [
    [
        "path",
        {
            "fill": "#212121",
            "d": "M20.47 6.23a4.25 4.25 0 0 1 7.5.04l15.53 29.5A4.25 4.25 0 0 1 39.74 42H8.26a4.25 4.25 0 0 1-3.74-6.27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_48_color__a)",
            "d": "M20.47 6.23a4.25 4.25 0 0 1 7.5.04l15.53 29.5A4.25 4.25 0 0 1 39.74 42H8.26a4.25 4.25 0 0 1-3.74-6.27z"
        }
    ],
    [
        "path",
        {
            "fill": "url(#ic_fluent_warning_48_color__b)",
            "d": "M24 15c.69 0 1.25.56 1.25 1.25v11.5a1.25 1.25 0 1 1-2.5 0v-11.5c0-.69.56-1.25 1.25-1.25m0 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
    ],
    [
        "defs",
        null,
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_48_color__a",
                "x1": "10.25",
                "x2": "34.45",
                "y1": "-1.94",
                "y2": "46.59",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#ffcd0f"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#fe8401"
                }
            ]
        ],
        [
            "linearGradient",
            {
                "id": "ic_fluent_warning_48_color__b",
                "x1": "18.67",
                "x2": "28.27",
                "y1": "15",
                "y2": "35.5",
                "gradientUnits": "userSpaceOnUse"
            },
            [
                "stop",
                {
                    "stopColor": "#4a4a4a"
                }
            ],
            [
                "stop",
                {
                    "offset": "1",
                    "stopColor": "#242424"
                }
            ]
        ]
    ]
], {
    color: true
});
const $f342bb1007016cbf$export$c152028938a22788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning48Filled', "48", [
    "M18.54 7.2a6.25 6.25 0 0 1 10.92 0L43.7 32.7a6.25 6.25 0 0 1-5.46 9.3H9.76a6.25 6.25 0 0 1-5.46-9.3zM24 30a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-15c-.7 0-1.25.56-1.25 1.25v9.5a1.25 1.25 0 0 0 2.5 0v-9.5c0-.69-.56-1.25-1.25-1.25"
]);
const $f342bb1007016cbf$export$ce1347a3e0f9c141 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Warning48Regular', "48", [
    "M18.55 7.2a6.25 6.25 0 0 1 10.9 0L43.7 32.7a6.25 6.25 0 0 1-5.46 9.3H9.76a6.25 6.25 0 0 1-5.46-9.3zm8.73 1.22a3.75 3.75 0 0 0-6.55 0L6.49 33.92a3.75 3.75 0 0 0 3.27 5.58h28.48a3.75 3.75 0 0 0 3.28-5.58zM24 30a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-15c.69 0 1.25.56 1.25 1.25v9.5a1.25 1.25 0 0 1-2.5 0v-9.5c0-.69.56-1.25 1.25-1.25"
]);
const $f342bb1007016cbf$export$e7299c0ea6079dc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpen16Filled', "16", [
    "M14 7a2 2 0 0 1 2 2 .5.5 0 1 1-1 0 1 1 0 1 0-2 0v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3V9c0-1.1.9-2 2-2m-2.5 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M4.82 1.28a2.5 2.5 0 0 1 4.36 0l3 5.34A3 3 0 0 0 11 9H9a2 2 0 0 0-1.29.47l.04-.22a.75.75 0 1 0-.44.68Q7.01 10.4 7 11v2H2.5A2.5 2.5 0 0 1 .32 9.28zM7 4a.5.5 0 0 0-.5.5V7a.5.5 0 0 0 1 0V4.5A.5.5 0 0 0 7 4"
]);
const $f342bb1007016cbf$export$339886d3427e189 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpen16Regular', "16", [
    "M14 7a2 2 0 0 1 2 2 .5.5 0 1 1-1 0 1 1 0 1 0-2 0v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3V9c0-1.1.9-2 2-2m-2.5 5.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M4.82 1.28a2.5 2.5 0 0 1 4.36 0l3 5.34q-.42.32-.71.77L8.3 1.76a1.5 1.5 0 0 0-2.62 0l-4.5 8A1.5 1.5 0 0 0 2.5 12H7v1H2.5A2.5 2.5 0 0 1 .32 9.28zM7 8.5A.75.75 0 1 1 7 10a.75.75 0 0 1 0-1.5M7 4c.28 0 .5.22.5.5V7a.5.5 0 0 1-1 0V4.5c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$52c76b9a7ef0f11f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpen20Filled', "20", [
    "M18 10a2 2 0 0 1 2 2 .5.5 0 0 1-1 0 1 1 0 0 0-2 0v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3v-1c0-1.1.9-2 2-2M7.37 3.56a3 3 0 0 1 5.26 0l3.4 6.18A3 3 0 0 0 15 12h-2a2 2 0 0 0-2 2v4H4.5a3 3 0 0 1-2.62-4.44zm8.13 11.69a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-5.5-2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-6.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$ed53772a8f140272 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpen20Regular', "20", [
    "M18 10a2 2 0 0 1 2 2 .5.5 0 0 1-1 0 1 1 0 0 0-2 0v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3v-1c0-1.1.9-2 2-2M7.37 3.56a3 3 0 0 1 5.26 0l3.4 6.18q-.41.36-.68.85l-3.6-6.55a2 2 0 0 0-3.5 0l-5.5 10A2 2 0 0 0 4.5 17H11v1H4.5a3 3 0 0 1-2.63-4.44zm8.13 11.69a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-5.5-2.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-6.25c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);
const $f342bb1007016cbf$export$4289ddfa0418eec7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpen24Filled', "24", [
    "M21.5 11.5A2.5 2.5 0 0 1 24 14a.75.75 0 0 1-1.5 0 1 1 0 0 0-2 0v1h1c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5H19v-1a2.5 2.5 0 0 1 2.5-2.5M9.14 3.7a3.25 3.25 0 0 1 5.72 0l4.2 7.8A3.5 3.5 0 0 0 18 14h-2.5a2.5 2.5 0 0 0-2.5 2.5V21H5.25a3.25 3.25 0 0 1-2.86-4.8zM18.5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-7.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 7.5"
]);
const $f342bb1007016cbf$export$329a430477b6582e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningLockOpen24Regular', "24", [
    "M21.5 11.5A2.5 2.5 0 0 1 24 14a.75.75 0 0 1-1.5 0 1 1 0 1 0-2 0v1h1c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5H19v-1a2.5 2.5 0 0 1 2.5-2.5M9.14 3.7a3.25 3.25 0 0 1 5.72 0l4.2 7.8q-.64.6-.9 1.48l-4.62-8.56a1.75 1.75 0 0 0-3.08 0L3.7 16.92a1.75 1.75 0 0 0 1.54 2.58H13V21H5.25a3.25 3.25 0 0 1-2.86-4.79zM18.5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-7.5c.41 0 .75.34.75.75v4.5a.75.75 0 0 1-1.5 0v-4.5c0-.41.34-.75.75-.75"
]);
const $f342bb1007016cbf$export$882b0670be5dcf25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningShield20Filled', "20", [
    "M15.12 10.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4m-7.75-7.4a3 3 0 0 1 5.26 0l3.51 6.4a1.6 1.6 0 0 0-1.6.18l-.11.1c-.43.41-1.15.95-1.96 1.12l-.27.04c-.53.11-1.12.54-1.2 1.26v2.26A4.7 4.7 0 0 0 12.11 18h-7.6a3 3 0 0 1-2.63-4.44zM10 12.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0-6.25a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5"
]);
const $f342bb1007016cbf$export$90520afda8f719a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WarningShield20Regular', "20", [
    "M15.12 10.96c.2-.19.56-.19.76 0 .5.49 1.48 1.26 2.68 1.41.24.04.44.22.44.44v2.11c0 2.84-2.78 3.87-3.39 4.06a.4.4 0 0 1-.22 0c-.6-.19-3.39-1.22-3.39-4.06v-2.1c0-.23.2-.41.44-.45a5 5 0 0 0 2.68-1.4m-7.75-7.4a3 3 0 0 1 5.26 0l3.51 6.4a1.6 1.6 0 0 0-1.16-.05l-3.23-5.87a2 2 0 0 0-3.5 0l-5.5 10A2 2 0 0 0 4.5 17h6.96q.27.57.65 1h-7.6a3 3 0 0 1-2.63-4.44zM10 12.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-6.25c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5"
]);





const $5cfd4ecd0f21c35f$export$f6804c79ff83e5fc = (props, ref)=>{
    const { children: children, required: required = false, validationState: validationState = props.validationMessage ? 'error' : 'none' } = props;
    const baseId = (0, $0200d30cfa270435$export$f680877a34711e37)('field-');
    const generatedControlId = baseId + '__control';
    const root = (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
        ...props,
        ref: ref
    }, /*excludedPropNames:*/ [
        'children'
    ]), {
        elementType: 'div'
    });
    const label = (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
        defaultProps: {
            htmlFor: generatedControlId,
            id: baseId + '__label',
            required: required
        },
        elementType: 'label'
    });
    const validationMessage = (0, $fcf7ddccaab7fd8f$exports).optional(props.validationMessage, {
        defaultProps: {
            id: baseId + '__validationMessage',
            role: validationState === 'error' || validationState === 'warning' ? 'alert' : undefined
        },
        elementType: 'div'
    });
    const hint = (0, $fcf7ddccaab7fd8f$exports).optional(props.hint, {
        defaultProps: {
            id: baseId + '__hint'
        },
        elementType: 'div'
    });
    const validationMessageIcon = (0, $fcf7ddccaab7fd8f$exports).optional(props.validationMessageIcon, {
        renderByDefault: false,
        elementType: 'span'
    });
    return {
        children: children,
        generatedControlId: generatedControlId,
        required: required,
        validationState: validationState,
        components: {
            root: 'div',
            label: 'label',
            validationMessage: 'div',
            validationMessageIcon: 'span',
            hint: 'div'
        },
        root: root,
        label: label,
        validationMessageIcon: validationMessageIcon,
        validationMessage: validationMessage,
        hint: hint
    };
};


'use client';
const $8f25ec0a645cefe9$var$validationMessageIcons = {
    error: /*#__PURE__*/ $acw62.createElement((0, $cdb0ff5c001a8842$export$170661f7405b6172), null),
    warning: /*#__PURE__*/ $acw62.createElement((0, $f342bb1007016cbf$export$1b4ba74e60df9950), null),
    success: /*#__PURE__*/ $acw62.createElement((0, $77e1bce0ac0f7fe7$export$7c4f9b2e13b339fa), null),
    none: undefined
};
const $8f25ec0a645cefe9$export$8282e7a686e881d2 = (props, ref)=>{
    const { orientation: orientation = 'vertical', size: size = 'medium', ...fieldProps } = props;
    const state = (0, $5cfd4ecd0f21c35f$export$f6804c79ff83e5fc)(fieldProps, ref);
    const defaultIcon = $8f25ec0a645cefe9$var$validationMessageIcons[state.validationState];
    return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        components: {
            ...state.components,
            label: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        },
        label: (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
            defaultProps: {
                size: size,
                ...state.label
            },
            elementType: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        }),
        validationMessageIcon: (0, $fcf7ddccaab7fd8f$exports).optional(props.validationMessageIcon, {
            renderByDefault: !!defaultIcon,
            defaultProps: {
                children: defaultIcon
            },
            elementType: 'span'
        }),
        orientation: orientation,
        size: size
    };
};




'use client';
const $8f457e2e1f44e831$export$7ac2fbb9ea493605 = {
    root: `fui-Field`,
    label: `fui-Field__label`,
    validationMessage: `fui-Field__validationMessage`,
    validationMessageIcon: `fui-Field__validationMessageIcon`,
    hint: `fui-Field__hint`
};
// Size of the icon in the validation message
const $8f457e2e1f44e831$var$iconSize = '12px';
/**
 * Styles for the root slot
 */ const $8f457e2e1f44e831$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        mc9l5x: "f13qh94s"
    },
    horizontal: {
        Budl1dq: "f2wwaib",
        wkccdc: "f1645dqt"
    },
    horizontalNoLabel: {
        uwmqm3: [
            "f15jqgz8",
            "fggqkej"
        ],
        Budl1dq: "f1c2z91y"
    }
}, {
    d: [
        ".f13qh94s{display:grid;}",
        ".f2wwaib{grid-template-columns:33% 1fr;}",
        ".f1645dqt{grid-template-rows:auto auto auto 1fr;}",
        ".f15jqgz8{padding-left:33%;}",
        ".fggqkej{padding-right:33%;}",
        ".f1c2z91y{grid-template-columns:1fr;}"
    ]
});
const $8f457e2e1f44e831$var$useLabelStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    base: {
        B2u0y6b: "f6nezus",
        Bxyxcbc: "f1iqmcbn"
    },
    vertical: {
        z8tnut: "fclwglc",
        Byoj8tv: "fywfov9",
        jrapky: "fyacil5"
    },
    verticalLarge: {
        z8tnut: "f1sl3k7w",
        Byoj8tv: "f1brlhvm",
        jrapky: "f8l5zjj"
    },
    horizontal: {
        z8tnut: "fp2oml8",
        Byoj8tv: "f1tdddsa",
        t21cq0: [
            "fkujibs",
            "f199hnxi"
        ],
        Ijaq50: "f16hsg94",
        nk6f5a: "f1nzqi2z"
    },
    horizontalSmall: {
        z8tnut: "f1ywm7hm",
        Byoj8tv: "f14wxoun"
    },
    horizontalLarge: {
        z8tnut: "f1hqyr95",
        Byoj8tv: "fm4hlj0"
    }
}, {
    d: [
        ".f6nezus{max-width:max-content;}",
        ".f1iqmcbn{max-height:max-content;}",
        ".fclwglc{padding-top:var(--spacingVerticalXXS);}",
        ".fywfov9{padding-bottom:var(--spacingVerticalXXS);}",
        ".fyacil5{margin-bottom:var(--spacingVerticalXXS);}",
        ".f1sl3k7w{padding-top:1px;}",
        ".f1brlhvm{padding-bottom:1px;}",
        ".f8l5zjj{margin-bottom:var(--spacingVerticalXS);}",
        ".fp2oml8{padding-top:var(--spacingVerticalSNudge);}",
        ".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}",
        ".fkujibs{margin-right:var(--spacingHorizontalM);}",
        ".f199hnxi{margin-left:var(--spacingHorizontalM);}",
        ".f16hsg94{grid-row-start:1;}",
        ".f1nzqi2z{grid-row-end:-1;}",
        ".f1ywm7hm{padding-top:var(--spacingVerticalXS);}",
        ".f14wxoun{padding-bottom:var(--spacingVerticalXS);}",
        ".f1hqyr95{padding-top:9px;}",
        ".fm4hlj0{padding-bottom:9px;}"
    ]
});
const $8f457e2e1f44e831$var$useSecondaryTextBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r5c4z9l", null, [
    ".r5c4z9l{margin-top:var(--spacingVerticalXXS);color:var(--colorNeutralForeground3);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase200);}"
]);
const $8f457e2e1f44e831$var$useSecondaryTextStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    error: {
        sj55zd: "f1hcrxcs"
    },
    withIcon: {
        uwmqm3: [
            "frawy03",
            "fg4c52"
        ]
    }
}, {
    d: [
        ".f1hcrxcs{color:var(--colorPaletteRedForeground1);}",
        ".frawy03{padding-left:calc(12px + var(--spacingHorizontalXS));}",
        ".fg4c52{padding-right:calc(12px + var(--spacingHorizontalXS));}"
    ]
});
const $8f457e2e1f44e831$var$useValidationMessageIconBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("ra7h1uk", "r1rh6bd7", [
    ".ra7h1uk{display:inline-block;font-size:12px;margin-left:calc(-12px - var(--spacingHorizontalXS));margin-right:var(--spacingHorizontalXS);line-height:0;vertical-align:-1px;}",
    ".r1rh6bd7{display:inline-block;font-size:12px;margin-right:calc(-12px - var(--spacingHorizontalXS));margin-left:var(--spacingHorizontalXS);line-height:0;vertical-align:-1px;}"
]);
const $8f457e2e1f44e831$var$useValidationMessageIconStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    error: {
        sj55zd: "f1hcrxcs"
    },
    warning: {
        sj55zd: "f1k5f75o"
    },
    success: {
        sj55zd: "ffmvakt"
    }
}, {
    d: [
        ".f1hcrxcs{color:var(--colorPaletteRedForeground1);}",
        ".f1k5f75o{color:var(--colorPaletteDarkOrangeForeground1);}",
        ".ffmvakt{color:var(--colorPaletteGreenForeground1);}"
    ]
});
const $8f457e2e1f44e831$export$a1d7305ac4913720 = (state)=>{
    const { validationState: validationState, size: size } = state;
    const horizontal = state.orientation === 'horizontal';
    const rootStyles = $8f457e2e1f44e831$var$useRootStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($8f457e2e1f44e831$export$7ac2fbb9ea493605.root, rootStyles.base, horizontal && rootStyles.horizontal, horizontal && !state.label && rootStyles.horizontalNoLabel, state.root.className);
    const labelStyles = $8f457e2e1f44e831$var$useLabelStyles();
    if (state.label) // eslint-disable-next-line react-hooks/immutability
    state.label.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($8f457e2e1f44e831$export$7ac2fbb9ea493605.label, labelStyles.base, horizontal && labelStyles.horizontal, horizontal && size === 'small' && labelStyles.horizontalSmall, horizontal && size === 'large' && labelStyles.horizontalLarge, !horizontal && labelStyles.vertical, !horizontal && size === 'large' && labelStyles.verticalLarge, state.label.className);
    const validationMessageIconBaseClassName = $8f457e2e1f44e831$var$useValidationMessageIconBaseClassName();
    const validationMessageIconStyles = $8f457e2e1f44e831$var$useValidationMessageIconStyles();
    if (state.validationMessageIcon) // eslint-disable-next-line react-hooks/immutability
    state.validationMessageIcon.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($8f457e2e1f44e831$export$7ac2fbb9ea493605.validationMessageIcon, validationMessageIconBaseClassName, validationState !== 'none' && validationMessageIconStyles[validationState], state.validationMessageIcon.className);
    const secondaryTextBaseClassName = $8f457e2e1f44e831$var$useSecondaryTextBaseClassName();
    const secondaryTextStyles = $8f457e2e1f44e831$var$useSecondaryTextStyles();
    if (state.validationMessage) // eslint-disable-next-line react-hooks/immutability
    state.validationMessage.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($8f457e2e1f44e831$export$7ac2fbb9ea493605.validationMessage, secondaryTextBaseClassName, validationState === 'error' && secondaryTextStyles.error, !!state.validationMessageIcon && secondaryTextStyles.withIcon, state.validationMessage.className);
    if (state.hint) // eslint-disable-next-line react-hooks/immutability
    state.hint.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($8f457e2e1f44e831$export$7ac2fbb9ea493605.hint, secondaryTextBaseClassName, state.hint.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
const $1268d7db6f51784f$export$2c6f62010e017518 = (state)=>{
    var _state_label, _state_label1, _state_validationMessage, _state_hint;
    const { generatedControlId: generatedControlId, orientation: orientation, required: required, size: size, validationState: validationState } = state;
    const labelFor = (_state_label = state.label) === null || _state_label === void 0 ? void 0 : _state_label.htmlFor;
    const labelId = (_state_label1 = state.label) === null || _state_label1 === void 0 ? void 0 : _state_label1.id;
    const validationMessageId = (_state_validationMessage = state.validationMessage) === null || _state_validationMessage === void 0 ? void 0 : _state_validationMessage.id;
    const hintId = (_state_hint = state.hint) === null || _state_hint === void 0 ? void 0 : _state_hint.id;
    const field = $acw62.useMemo(()=>({
            generatedControlId: generatedControlId,
            hintId: hintId,
            labelFor: labelFor,
            labelId: labelId,
            orientation: orientation,
            required: required,
            size: size,
            validationMessageId: validationMessageId,
            validationState: validationState
        }), [
        generatedControlId,
        hintId,
        labelFor,
        labelId,
        orientation,
        required,
        size,
        validationMessageId,
        validationState
    ]);
    return {
        field: field
    };
};



'use client';
const $b49bb2f5ba7736c5$export$a455218a85c89869 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8f25ec0a645cefe9$export$8282e7a686e881d2)(props, ref);
    (0, $8f457e2e1f44e831$export$a1d7305ac4913720)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useFieldStyles_unstable')(state);
    const context = (0, $1268d7db6f51784f$export$2c6f62010e017518)(state);
    return (0, $4d5b4ab865de1c76$export$2f31a63ba95206a0)(state, context);
});
$b49bb2f5ba7736c5$export$a455218a85c89869.displayName = 'Field';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
const $07e9b2ed98094869$var$SpinnerContext = $acw62.createContext(undefined);
const $07e9b2ed98094869$var$SpinnerContextDefaultValue = {};
const $07e9b2ed98094869$export$3ea29706a0117618 = $07e9b2ed98094869$var$SpinnerContext.Provider;
const $07e9b2ed98094869$export$93bfe20fa842be24 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($07e9b2ed98094869$var$SpinnerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $07e9b2ed98094869$var$SpinnerContextDefaultValue;
};


'use client';
const $ea3ba69704659aea$export$d22a6816f9606c0c = (props, ref)=>{
    const { size: contextSize } = (0, $07e9b2ed98094869$export$93bfe20fa842be24)();
    const { appearance: appearance = 'primary', size: size = contextSize !== null && contextSize !== void 0 ? contextSize : 'medium', ...baseProps } = props;
    const baseState = $ea3ba69704659aea$export$4b37c6839851d9be(baseProps, ref);
    return {
        ...baseState,
        appearance: appearance,
        size: size,
        components: {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ...baseState.components,
            label: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        },
        label: (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
            defaultProps: baseState.label,
            elementType: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        })
    };
};
const $ea3ba69704659aea$export$4b37c6839851d9be = (props, ref)=>{
    const { delay: delay = 0, labelPosition: labelPosition = 'after' } = props;
    const baseId = (0, $0200d30cfa270435$export$f680877a34711e37)('spinner');
    const { role: role = 'progressbar', ...rest } = props;
    const nativeRoot = (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
        // FIXME:
        // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
        // but since it would be a breaking change to fix it, we are casting ref to it's proper type
        ref: ref,
        role: role,
        ...rest
    }), {
        elementType: 'div'
    });
    const [isShownAfterDelay, setIsShownAfterDelay] = $acw62.useState(false);
    const [setDelayTimeout, clearDelayTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    $acw62.useEffect(()=>{
        if (delay <= 0) return;
        setDelayTimeout(()=>{
            setIsShownAfterDelay(true);
        }, delay);
        return ()=>{
            clearDelayTimeout();
        };
    }, [
        setDelayTimeout,
        clearDelayTimeout,
        delay
    ]);
    const labelShorthand = (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
        defaultProps: {
            id: baseId
        },
        renderByDefault: false,
        elementType: 'label'
    });
    const spinnerShortHand = (0, $fcf7ddccaab7fd8f$exports).optional(props.spinner, {
        renderByDefault: true,
        elementType: 'span'
    });
    if (labelShorthand && nativeRoot && !nativeRoot['aria-labelledby']) nativeRoot['aria-labelledby'] = labelShorthand.id;
    const state = {
        delay: delay,
        labelPosition: labelPosition,
        shouldRenderSpinner: !delay || isShownAfterDelay,
        components: {
            root: 'div',
            spinner: 'span',
            spinnerTail: 'span',
            label: 'label'
        },
        root: nativeRoot,
        spinner: spinnerShortHand,
        spinnerTail: (0, $fcf7ddccaab7fd8f$exports).always(props.spinnerTail, {
            elementType: 'span'
        }),
        label: labelShorthand
    };
    return state;
};




const $90b04b1885011b2b$export$6b431f40bc8da439 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const { labelPosition: labelPosition, shouldRenderSpinner: shouldRenderSpinner } = state;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.label && shouldRenderSpinner && (labelPosition === 'above' || labelPosition === 'before') && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {}),
            state.spinner && shouldRenderSpinner && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.spinner, {
                children: state.spinnerTail && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.spinnerTail, {})
            }),
            state.label && shouldRenderSpinner && (labelPosition === 'below' || labelPosition === 'after') && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {})
        ]
    });
};





'use client';
const $5df5dc5c79b7533a$export$78944c62fc89d0be = {
    root: 'fui-Spinner',
    spinner: 'fui-Spinner__spinner',
    spinnerTail: 'fui-Spinner__spinnerTail',
    label: 'fui-Spinner__label'
};
/**
 * CSS variables used internally by Spinner
 */ const $5df5dc5c79b7533a$var$vars = {
    strokeWidth: '--fui-Spinner--strokeWidth'
};
const $5df5dc5c79b7533a$var$useRootBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rpp59a7", null, [
    ".rpp59a7{display:flex;align-items:center;justify-content:center;line-height:0;gap:8px;overflow:hidden;min-width:min-content;}"
]);
const $5df5dc5c79b7533a$var$useRootStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    vertical: {
        Beiy3e4: "f1vx9l62"
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}"
    ]
});
const $5df5dc5c79b7533a$var$useSpinnerBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rvgcg50", "r15nd2jo", {
    r: [
        ".rvgcg50{position:relative;flex-shrink:0;-webkit-mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);background-color:var(--colorBrandStroke2Contrast);color:var(--colorBrandStroke1);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:rb7n1on;}",
        "@keyframes rb7n1on{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}",
        ".r15nd2jo{position:relative;flex-shrink:0;-webkit-mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);background-color:var(--colorBrandStroke2Contrast);color:var(--colorBrandStroke1);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:r1gx3jof;}",
        "@keyframes r1gx3jof{0%{transform:rotate(0deg);}100%{transform:rotate(-360deg);}}"
    ],
    s: [
        "@media screen and (forced-colors: active){.rvgcg50{background-color:HighlightText;color:Highlight;forced-color-adjust:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.rvgcg50{animation-duration:1.8s;}}",
        "@media screen and (forced-colors: active){.r15nd2jo{background-color:HighlightText;color:Highlight;forced-color-adjust:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r15nd2jo{animation-duration:1.8s;}}"
    ]
});
// The spinner tail is rendered using two 135deg arc segments, behind a 105deg arc mask.
// The segments are rotated out from behind the mask to expand the visible arc from
// 30deg (min) to 255deg (max), and then back behind the mask again to shrink the arc.
// The tail and spinner itself also have 360deg rotation animations for the spin.
const $5df5dc5c79b7533a$var$useSpinnerTailBaseClassName = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("rxov3xa", "r1o544mv", {
    r: [
        ".rxov3xa{position:absolute;display:block;width:100%;height:100%;-webkit-mask-image:conic-gradient(transparent 105deg, white 105deg);mask-image:conic-gradient(transparent 105deg, white 105deg);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:var(--curveEasyEase);animation-name:r15mim6k;}",
        ".rxov3xa::before,.rxov3xa::after{content:\"\";position:absolute;display:block;width:100%;height:100%;animation:inherit;background-image:conic-gradient(currentcolor 135deg, transparent 135deg);}",
        "@keyframes r15mim6k{0%{transform:rotate(-135deg);}50%{transform:rotate(0deg);}100%{transform:rotate(225deg);}}",
        ".rxov3xa::before{animation-name:r18vhmn8;}",
        "@keyframes r18vhmn8{0%{transform:rotate(0deg);}50%{transform:rotate(105deg);}100%{transform:rotate(0deg);}}",
        ".rxov3xa::after{animation-name:rkgrvoi;}",
        "@keyframes rkgrvoi{0%{transform:rotate(0deg);}50%{transform:rotate(225deg);}100%{transform:rotate(0deg);}}",
        ".r1o544mv{position:absolute;display:block;width:100%;height:100%;-webkit-mask-image:conic-gradient(transparent 105deg, white 105deg);mask-image:conic-gradient(transparent 105deg, white 105deg);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:var(--curveEasyEase);animation-name:r109gmi5;}",
        ".r1o544mv::before,.r1o544mv::after{content:\"\";position:absolute;display:block;width:100%;height:100%;animation:inherit;background-image:conic-gradient(currentcolor 135deg, transparent 135deg);}",
        "@keyframes r109gmi5{0%{transform:rotate(135deg);}50%{transform:rotate(0deg);}100%{transform:rotate(-225deg);}}",
        ".r1o544mv::before{animation-name:r17whflh;}",
        "@keyframes r17whflh{0%{transform:rotate(0deg);}50%{transform:rotate(-105deg);}100%{transform:rotate(0deg);}}",
        ".r1o544mv::after{animation-name:re4odhl;}",
        "@keyframes re4odhl{0%{transform:rotate(0deg);}50%{transform:rotate(-225deg);}100%{transform:rotate(0deg);}}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.rxov3xa{animation-iteration-count:0;background-image:conic-gradient(transparent 120deg, currentcolor 360deg);}.rxov3xa::before,.rxov3xa::after{content:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1o544mv{animation-iteration-count:0;background-image:conic-gradient(transparent 120deg, currentcolor 360deg);}.r1o544mv::before,.r1o544mv::after{content:none;}}"
    ]
});
const $5df5dc5c79b7533a$var$useSpinnerStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    inverted: {
        De3pzq: "fr407j0",
        sj55zd: "f1f7voed"
    },
    rtlTail: {
        btxmck: "f179dep3",
        gb5jj2: "fbz9ihp",
        Bdya8wy: "f1pme1qz"
    },
    "extra-tiny": {
        Bqenvij: "fd461yt",
        a9b677: "fjw5fx7",
        qmp6fs: "f1v3ph3m"
    },
    tiny: {
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3",
        qmp6fs: "f1v3ph3m"
    },
    "extra-small": {
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun",
        qmp6fs: "f1v3ph3m"
    },
    small: {
        Bqenvij: "fxldao9",
        a9b677: "f1w9dchk",
        qmp6fs: "f1v3ph3m"
    },
    medium: {
        Bqenvij: "f1d2rq10",
        a9b677: "f1szoe96",
        qmp6fs: "fb52u90"
    },
    large: {
        Bqenvij: "f8ljn23",
        a9b677: "fpdz1er",
        qmp6fs: "fb52u90"
    },
    "extra-large": {
        Bqenvij: "fbhnoac",
        a9b677: "feqmc2u",
        qmp6fs: "fb52u90"
    },
    huge: {
        Bqenvij: "f1ft4266",
        a9b677: "fksc0bp",
        qmp6fs: "fa3u9ii"
    }
}, {
    d: [
        ".fr407j0{background-color:var(--colorNeutralStrokeAlpha2);}",
        ".f1f7voed{color:var(--colorNeutralStrokeOnBrand2);}",
        ".f179dep3{-webkit-mask-image:conic-gradient(white 255deg, transparent 255deg);mask-image:conic-gradient(white 255deg, transparent 255deg);}",
        ".fbz9ihp::before,.fbz9ihp::after{background-image:conic-gradient(transparent 225deg, currentcolor 225deg);}",
        ".fd461yt{height:16px;}",
        ".fjw5fx7{width:16px;}",
        ".f1v3ph3m{--fui-Spinner--strokeWidth:var(--strokeWidthThick);}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".fxldao9{height:28px;}",
        ".f1w9dchk{width:28px;}",
        ".f1d2rq10{height:32px;}",
        ".f1szoe96{width:32px;}",
        ".fb52u90{--fui-Spinner--strokeWidth:var(--strokeWidthThicker);}",
        ".f8ljn23{height:36px;}",
        ".fpdz1er{width:36px;}",
        ".fbhnoac{height:40px;}",
        ".feqmc2u{width:40px;}",
        ".f1ft4266{height:44px;}",
        ".fksc0bp{width:44px;}",
        ".fa3u9ii{--fui-Spinner--strokeWidth:var(--strokeWidthThickest);}"
    ],
    m: [
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1pme1qz{background-image:conic-gradient(currentcolor 0deg, transparent 240deg);}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ]
    ]
});
const $5df5dc5c79b7533a$var$useLabelStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    inverted: {
        sj55zd: "fonrgv7"
    },
    "extra-tiny": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    tiny: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    "extra-small": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    small: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    medium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    "extra-large": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    huge: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f1pp30po",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f106mvju"
    }
}, {
    d: [
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}"
    ]
});
const $5df5dc5c79b7533a$export$c8629923cd802b17 = (state)=>{
    const { labelPosition: labelPosition, size: size, appearance: appearance } = state;
    const { dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const rootBaseClassName = $5df5dc5c79b7533a$var$useRootBaseClassName();
    const rootStyles = $5df5dc5c79b7533a$var$useRootStyles();
    const spinnerBaseClassName = $5df5dc5c79b7533a$var$useSpinnerBaseClassName();
    const spinnerStyles = $5df5dc5c79b7533a$var$useSpinnerStyles();
    const spinnerTailBaseClassName = $5df5dc5c79b7533a$var$useSpinnerTailBaseClassName();
    const labelStyles = $5df5dc5c79b7533a$var$useLabelStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.root, rootBaseClassName, (labelPosition === 'above' || labelPosition === 'below') && rootStyles.vertical, state.root.className);
    if (state.spinner) // eslint-disable-next-line react-hooks/immutability
    state.spinner.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.spinner, spinnerBaseClassName, spinnerStyles[size], appearance === 'inverted' && spinnerStyles.inverted, state.spinner.className);
    if (state.spinnerTail) // eslint-disable-next-line react-hooks/immutability
    state.spinnerTail.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.spinnerTail, spinnerTailBaseClassName, dir === 'rtl' && spinnerStyles.rtlTail, state.spinnerTail.className);
    if (state.label) // eslint-disable-next-line react-hooks/immutability
    state.label.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.label, labelStyles[size], appearance === 'inverted' && labelStyles.inverted, state.label.className);
    return state;
};



'use client';
const $16c0c2858b6dc7eb$export$7f7cbe89f1eacd2 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $ea3ba69704659aea$export$d22a6816f9606c0c)(props, ref);
    (0, $5df5dc5c79b7533a$export$c8629923cd802b17)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useSpinnerStyles_unstable')(state);
    return (0, $90b04b1885011b2b$export$6b431f40bc8da439)(state);
});
$16c0c2858b6dc7eb$export$7f7cbe89f1eacd2.displayName = 'Spinner';


var $acw62 = parcelRequire("acw62");



'use client';
const $e30b1f38054df1e5$export$1fa846657620be9f = (props, ref)=>{
    const { scrollState: scrollState } = (0, $f151dc37217d3a88$export$6bc0175b947a255a)();
    return {
        components: {
            root: 'footer'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('footer', {
            ref: ref,
            role: 'none',
            ...props
        }), {
            elementType: 'footer'
        }),
        scrollState: scrollState
    };
};




const $7bbde8e9fc4e2f27$export$9c3f9013fd9b4b6f = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};





'use client';
const $981f09d8f920293d$export$7c7eb8f0982e4a7d = {
    root: 'fui-DrawerFooter'
};
/**
 * Styles for the root slot
 */ const $981f09d8f920293d$var$useStyles = /*#__PURE__*/ (0, $edc64c21f394d20d$export$7e3b04e77a0827f2)("r1snvl2j", null, [
    ".r1snvl2j{width:100%;max-width:100%;padding:var(--spacingVerticalL) var(--spacingHorizontalXXL) var(--spacingVerticalXXL);display:flex;justify-content:flex-start;align-items:center;column-gap:var(--spacingHorizontalS);box-sizing:border-box;position:relative;z-index:2;}"
]);
const $981f09d8f920293d$var$useDrawerFooterStyles = /*#__PURE__*/ (0, $9438d9671fa9d7d9$export$c5d3a2c2e0d67663)({
    separator: {
        Baz25je: "f16b62f1",
        Brfgrao: "f1j7ml58",
        mdwyqc: [
            "f1f351id",
            "f1fzr1x6"
        ],
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        vz82u: "f1dhznln",
        cmx5o7: "f1p5zmk",
        h7gv66: "f1ljjo4k",
        B8bqphf: "ffd2d9j",
        wjn42g: "ffdt3s5",
        Ftih45: "f1wl9k8s",
        Bciustq: "ffi060y"
    },
    separatorVisible: {
        vz82u: "f1b3qyzu"
    }
}, {
    d: [
        ".f16b62f1::before{height:1px;}",
        ".f1j7ml58::before{position:absolute;}",
        ".f1f351id::before{right:0;}",
        ".f1fzr1x6::before{left:0;}",
        ".f1dhznln::before{opacity:0;}",
        ".f1p5zmk::before{background-color:var(--colorNeutralStroke1);}",
        ".f1ljjo4k::before{transition-duration:var(--durationNormal);}",
        ".ffd2d9j::before{transition-property:opacity;}",
        ".ffdt3s5::before{transition-timing-function:var(--curveEasyEase);}",
        ".f1wl9k8s::before{content:\"\";}",
        ".ffi060y::before{top:0;}",
        ".f1b3qyzu::before{opacity:1;}"
    ]
});
const $981f09d8f920293d$export$d7e0c8d350a56b1e = (state)=>{
    const styles = $981f09d8f920293d$var$useStyles();
    const rootStyles = $981f09d8f920293d$var$useDrawerFooterStyles();
    // eslint-disable-next-line react-hooks/immutability
    state.root.className = (0, $00898283de415a49$export$3d46f4579dba46e5)($981f09d8f920293d$export$7c7eb8f0982e4a7d.root, styles, state.scrollState !== 'none' && rootStyles.separator, [
        'middle',
        'top'
    ].includes(state.scrollState) && rootStyles.separatorVisible, state.root.className);
    return state;
};


'use client';
const $6dd79edb1f8b4d7d$export$d05a7d25ec5abf06 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $e30b1f38054df1e5$export$1fa846657620be9f)(props, ref);
    (0, $981f09d8f920293d$export$d7e0c8d350a56b1e)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDrawerFooterStyles_unstable')(state);
    return (0, $7bbde8e9fc4e2f27$export$9c3f9013fd9b4b6f)(state);
});
$6dd79edb1f8b4d7d$export$d05a7d25ec5abf06.displayName = 'DrawerFooter';



function $8e4229169245c3cc$export$2e2bcd8739ae039({ open: open, setOpen: setOpen }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4edc29482f6892a4$export$4071300121a182f5), {
            position: "end",
            open: open,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae4c07f2c38b246f$export$bb68d554ded258ea), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eda29ab885160de0$export$6da407429c3f8c47), {
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                            appearance: "subtle",
                            "aria-label": "Close",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdb0ff5c001a8842$export$209e755d5656d93f), {}),
                            onClick: ()=>setOpen(false)
                        }),
                        children: "Add Staff Member"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f5e8463007004c1c$export$4ed8420cdfcb2b8f), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b49bb2f5ba7736c5$export$a455218a85c89869), {
                            label: "Second Life Username",
                            required: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa73c40fd1a9147$export$f5b8910cec6cf069), {
                                type: "text",
                                placeholder: "John Doe"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b49bb2f5ba7736c5$export$a455218a85c89869), {
                            label: "Role",
                            required: true,
                            style: {
                                marginTop: "1rem"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $196ff0182fdd345f$export$931cbfb6bfb85fc), {
                                defaultSelectedOptions: [
                                    "csr"
                                ],
                                defaultValue: "CSR",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6e0577c148e3e97$export$36d18380658d5d20), {
                                        value: "csr",
                                        children: "CSR"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6e0577c148e3e97$export$36d18380658d5d20), {
                                        value: "manager",
                                        children: "Store Manager"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6e0577c148e3e97$export$36d18380658d5d20), {
                                        value: "admin",
                                        children: "Administrator"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b49bb2f5ba7736c5$export$a455218a85c89869), {
                            label: "UUID",
                            required: true,
                            style: {
                                marginTop: "1rem"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa73c40fd1a9147$export$f5b8910cec6cf069), {
                                type: "text",
                                value: "",
                                disabled: true
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $16c0c2858b6dc7eb$export$7f7cbe89f1eacd2), {
                                size: "small",
                                label: "Finding staff member in Second Life...",
                                labelPosition: "below",
                                style: {
                                    marginTop: "2rem",
                                    display: "flex",
                                    justifyContent: "center",
                                    textAlign: "center"
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd79edb1f8b4d7d$export$d05a7d25ec5abf06), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                        appearance: "primary",
                        onClick: ()=>setOpen(false),
                        disabled: true,
                        children: "Add"
                    })
                })
            ]
        })
    });
}


const $cfa3ec47cc17e8e8$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    root: {
        display: "flex",
        gap: "2rem"
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: "100%"
    },
    cardTitle: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
    },
    columnTable: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "1rem",
        "& > *": {
            flex: "0 0 calc(50% - 0.5rem)",
            minWidth: "200px"
        }
    }
});
const $cfa3ec47cc17e8e8$var$InfoIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $0debb7262aed7016$export$d2505fbd697b65ef), (0, $0debb7262aed7016$export$4c7d6579126bcce7));
const $cfa3ec47cc17e8e8$var$PeopleTeam = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $90f21c32649fad68$export$2d1e3f8fdad4e16b), (0, $90f21c32649fad68$export$d2fd5f70dc4c877e));
const $cfa3ec47cc17e8e8$var$PlugConnectedSettings = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $eb093920387c7bf0$export$bb14208eb5c94e82), (0, $eb093920387c7bf0$export$25aad0120b71b72e));
const $cfa3ec47cc17e8e8$var$EditIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $61c84b424f99a7b1$export$a18b2635075e93d1), (0, $61c84b424f99a7b1$export$e57a7ca8375c5ccb));
const $cfa3ec47cc17e8e8$var$KeyResetIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $79f5cc1e1e247c23$export$d4d3db6916e79421), (0, $79f5cc1e1e247c23$export$ad5c179f4c6ab4f));
const $cfa3ec47cc17e8e8$var$MoneySettingsIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $5fff284e497fef75$export$fa0e89caa38ee2fe), (0, $5fff284e497fef75$export$2e19368034f57d3f));
const $cfa3ec47cc17e8e8$var$DeleteIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $90f21c32649fad68$export$ef5ba407dcc31020), (0, $90f21c32649fad68$export$b477a0750a53667c));
function $cfa3ec47cc17e8e8$export$2e2bcd8739ae039() {
    const styles = $cfa3ec47cc17e8e8$var$useStyles();
    const [selectedTab, setSelectedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("details");
    const [subtitleIcon, setSubtitleIcon] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$InfoIcon, {}));
    const [subtitle, setSubtitle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("Details");
    const [storeNamePopoverOpen, setStoreNamePopoverOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [addStaffMemberDrawerOpen, setAddStaffMemberDrawerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [reassignApiKeyDialogOpen, setReassignApiKeyDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { dispatchToast: dispatchToast } = (0, $381cfab46fabcf8e$export$6b9c1ee354531f4)("settingsToaster");
    (0, $acw62.useEffect)(()=>{
        document.title = "Settings - Omnivend";
    }, []);
    (0, $acw62.useEffect)(()=>{
        setSubtitle(selectedTab === "details" ? "Details" : selectedTab === "staff" ? "Staff" : selectedTab === "api" ? "API Access" : selectedTab === "subscriptions" ? "Subscriptions" : "");
        setSubtitleIcon(selectedTab === "details" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0debb7262aed7016$export$d2505fbd697b65ef), {}) : selectedTab === "staff" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90f21c32649fad68$export$2d1e3f8fdad4e16b), {}) : selectedTab === "api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb093920387c7bf0$export$bb14208eb5c94e82), {}) : selectedTab === "subscriptions" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5fff284e497fef75$export$fa0e89caa38ee2fe), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0debb7262aed7016$export$d2505fbd697b65ef), {}));
    }, [
        selectedTab
    ]);
    const triggerReassignApiKey = ()=>{
        dispatchToast(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cbcc184592d9c369$export$8d8dc7d5f743331b), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b2d45943ab4f79$export$16d42d7c29b95a4), {
                    children: "API Key Reassigned"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bd76a47a80a9c38$export$a2fc124486ff7b59), {
                    children: "Your API key has been successfully reassigned. Please update your applications or services with the new API key."
                })
            ]
        }), {
            intent: "success",
            position: "top-end",
            timeout: 5000
        });
    };
    const createRoleDropdown = (currentRole)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $196ff0182fdd345f$export$931cbfb6bfb85fc), {
            defaultSelectedOptions: [
                currentRole
            ],
            defaultValue: "CSR",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6e0577c148e3e97$export$36d18380658d5d20), {
                    value: "csr",
                    text: "CSR",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.5rem",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: "CSR"
                            }),
                            "Customer Service Representatives can view and manage sales and customers, but cannot edit store settings or manage products."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6e0577c148e3e97$export$36d18380658d5d20), {
                    value: "manager",
                    text: "Store Manager",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.5rem",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: "Store Manager"
                            }),
                            "Store Managers can view and edit store settings, manage products, and oversee sales."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6e0577c148e3e97$export$36d18380658d5d20), {
                    value: "admin",
                    text: "Administrator",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.5rem",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: "Administrator"
                            }),
                            "Administrators have full access and can manage all settings, including adding and removing managers."
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: "1rem",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $15b0c993301c9728$export$cb271b43cf086b84), {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem"
                        },
                        children: [
                            subtitleIcon,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Settings | ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontWeight: "normal"
                                        },
                                        children: subtitle
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: styles.root,
                        style: {
                            marginTop: "2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $900345cf912ae8c0$export$e51a686c67fdaa2d), {
                                vertical: true,
                                appearance: "subtle",
                                defaultSelectedValue: "details",
                                onTabSelect: (e, data)=>setSelectedTab(data.value),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e914794eade933$export$3e41faf802a29e71), {
                                        value: "details",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$InfoIcon, {}),
                                        children: "Details"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e914794eade933$export$3e41faf802a29e71), {
                                        value: "staff",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$PeopleTeam, {}),
                                        children: "Staff"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e914794eade933$export$3e41faf802a29e71), {
                                        value: "api",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$PlugConnectedSettings, {}),
                                        children: "API Access"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e914794eade933$export$3e41faf802a29e71), {
                                        value: "subscriptions",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$MoneySettingsIcon, {}),
                                        children: "Subscriptions"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: styles.content,
                                children: selectedTab === "details" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6cbe9bc797fdbc91$export$60332b2344f7fe41), {
                                            appearance: "outline",
                                            style: {
                                                marginBottom: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e23feb91a07e879e$export$5665775b26e26c5d), {
                                                    header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: styles.cardTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7972e53b1de568ed$export$6faa23478c869acb), {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $715c9647a8930a69$export$661f1b2c265066f), {
                                                                children: "Overview"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                "View and edit this store's details."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: styles.columnTable,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: "Store owner"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a69bfcc549c3c80e$export$a6c7ac8248d6e38a), {
                                                        href: "https://my.secondlife.com/john.doe",
                                                        target: "_blank",
                                                        children: "John Doe"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: "Store name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        "Unnamed Store \xa0",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e830a624458bf28$export$28c660c63b792dea), {
                                                            content: "Edit Store Name",
                                                            relationship: "label",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d4448b917a5b7f9a$export$5b6b19405a83ff9d), {
                                                                open: storeNamePopoverOpen,
                                                                onOpenChange: (_, data)=>{
                                                                    setStoreNamePopoverOpen(data.open);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1d682872ff40f20$export$7dacb05d26466c3), {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$EditIcon, {}),
                                                                            size: "small",
                                                                            appearance: "subtle"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8c10046741b8692$export$8b7437164e479115), {
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            style: {
                                                                                padding: "1rem",
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                gap: "1rem"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    style: {
                                                                                        fontWeight: "500"
                                                                                    },
                                                                                    children: "Edit Store Name"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa73c40fd1a9147$export$f5b8910cec6cf069), {
                                                                                    type: "text",
                                                                                    placeholder: "Enter new store name"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        justifyContent: "flex-end",
                                                                                        gap: "0.5rem"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                                                        size: "small",
                                                                                        onClick: ()=>{
                                                                                            setStoreNamePopoverOpen(false);
                                                                                        },
                                                                                        children: "Save"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                                        info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    children: "When enabled, customers can purchase the same product multiple times by default. When disabled, customers can purchase each product only once."
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    style: {
                                                                        marginTop: "0.5rem",
                                                                        fontWeight: "500"
                                                                    },
                                                                    children: "We recommend configuring this setting on a per-product basis, as restricting repeat purchases is generally the safer option for most products."
                                                                })
                                                            ]
                                                        }),
                                                        children: "Always allow repeat purchases"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c56830212733dc47$export$b5d5cf8927ab7262), {
                                                        size: "small",
                                                        defaultChecked: false
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                                        info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: "Suspend all purchases from your store. Customers will be unable to make new purchases until the store is reopened. However, they will still be able to redeliver products they have previously purchased."
                                                            })
                                                        }),
                                                        children: "Close store"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c56830212733dc47$export$b5d5cf8927ab7262), {
                                                        size: "small",
                                                        defaultChecked: false
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : selectedTab === "staff" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6cbe9bc797fdbc91$export$60332b2344f7fe41), {
                                            appearance: "outline",
                                            style: {
                                                marginBottom: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e23feb91a07e879e$export$5665775b26e26c5d), {
                                                    header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: styles.cardTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7972e53b1de568ed$export$6faa23478c869acb), {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $715c9647a8930a69$export$661f1b2c265066f), {
                                                                children: "Overview"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                "Add and remove staff members who can edit your store settings and/or manage your products."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc0a6e3db5d5b553$export$3664b485525e193e), {}),
                                                appearance: "primary",
                                                onClick: ()=>setAddStaffMemberDrawerOpen(true),
                                                children: "Add Staff Member"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bf8e3f93ce344917$export$54ec01a60f47d33d), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a43c21910348d1c5$export$f850895b287ef28e), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                                            children: "Second Life Username"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                                            children: "Role"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                                            children: "Actions"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3f2f433630850f26$export$76ccd210b9029917), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a69bfcc549c3c80e$export$a6c7ac8248d6e38a), {
                                                                        href: "https://my.secondlife.com/abigail.slater",
                                                                        target: "_blank",
                                                                        children: "Abigail Slater"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                                                    children: createRoleDropdown("csr")
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e830a624458bf28$export$28c660c63b792dea), {
                                                                        content: "Remove Staff Member",
                                                                        relationship: "label",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$DeleteIcon, {}),
                                                                            size: "small",
                                                                            appearance: "subtle"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a69bfcc549c3c80e$export$a6c7ac8248d6e38a), {
                                                                        href: "https://my.secondlife.com/ben.sheppard",
                                                                        target: "_blank",
                                                                        children: "Ben Sheppard"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                                                    children: createRoleDropdown("csr")
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e830a624458bf28$export$28c660c63b792dea), {
                                                                        content: "Remove Staff Member",
                                                                        relationship: "label",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$DeleteIcon, {}),
                                                                            size: "small",
                                                                            appearance: "subtle"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e4229169245c3cc$export$2e2bcd8739ae039), {
                                            open: addStaffMemberDrawerOpen,
                                            setOpen: setAddStaffMemberDrawerOpen
                                        })
                                    ]
                                }) : selectedTab === "api" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6cbe9bc797fdbc91$export$60332b2344f7fe41), {
                                            appearance: "outline",
                                            style: {
                                                marginBottom: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e23feb91a07e879e$export$5665775b26e26c5d), {
                                                    header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: styles.cardTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7972e53b1de568ed$export$6faa23478c869acb), {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $715c9647a8930a69$export$661f1b2c265066f), {
                                                                children: "Overview"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                "Using the in-world Omnivend API script, you can integrate your store with other systems and services. This allows for advanced automation and customization of your store's functionality."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: styles.columnTable,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: "Store API key"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        "Unassigned \xa0",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e830a624458bf28$export$28c660c63b792dea), {
                                                            content: "Reassign API Key",
                                                            relationship: "label",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa3ec47cc17e8e8$var$KeyResetIcon, {}),
                                                                size: "small",
                                                                appearance: "subtle",
                                                                onClick: ()=>setReassignApiKeyDialogOpen(true)
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: "API documentation"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: "Coming Soon"
                                                })
                                            ]
                                        })
                                    ]
                                }) : selectedTab === "subscriptions" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6cbe9bc797fdbc91$export$60332b2344f7fe41), {
                                            appearance: "outline",
                                            style: {
                                                marginBottom: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e23feb91a07e879e$export$5665775b26e26c5d), {
                                                    header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: styles.cardTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7972e53b1de568ed$export$6faa23478c869acb), {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $715c9647a8930a69$export$661f1b2c265066f), {
                                                                children: "Overview"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                "Customers can rez a subscription kiosk to enable automatic payments for products from this store."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: styles.columnTable,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontWeight: "500"
                                                    },
                                                    children: "Allow subscriptions"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c56830212733dc47$export$b5d5cf8927ab7262), {
                                                        size: "small",
                                                        defaultChecked: false
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f67322f150798dc8$export$2e2bcd8739ae039), {
                open: reassignApiKeyDialogOpen,
                setOpen: setReassignApiKeyDialogOpen,
                triggerReassignApiKey: triggerReassignApiKey
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4c75e7371e2afd4$export$fb98e3a2a4cd92d7), {
                toasterId: "settingsToaster"
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");
const $55611ef9f25c419d$var$useStyles = (0, $f2434d6396bd7f83$export$b35517af9e0a5689)({
    toolbar: {}
});
function $55611ef9f25c419d$export$2e2bcd8739ae039() {
    const styles = $55611ef9f25c419d$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        document.title = "Vendors - Omnivend";
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bfbac4c65a4ae1cd$export$4c260019440d418f), {
            className: styles.toolbar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                appearance: "subtle",
                children: "Test"
            })
        })
    });
}


let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
const $70fc9a727fa662ae$var$omnivend = {
    10: "#260900",
    20: "#481200",
    30: "#6B1B00",
    40: "#8C2500",
    50: "#AC3000",
    60: "#C83B00",
    70: "#E24800",
    80: "#F55300",
    90: "#FF6200",
    100: "#FF7000",
    110: "#FF8000",
    120: "#FF9100",
    130: "#FFA21F",
    140: "#FFB547",
    150: "#FFC875",
    160: "#FFDBA3"
};
const $70fc9a727fa662ae$var$lightTheme = {
    ...(0, $e46fa2d032c035de$export$433454ecdac7def9)($70fc9a727fa662ae$var$omnivend)
};
const $70fc9a727fa662ae$var$darkTheme = {
    ...(0, $3b5403a30a78663f$export$ac47085da93aabfb)($70fc9a727fa662ae$var$omnivend)
};
$70fc9a727fa662ae$var$darkTheme.colorBrandForeground1 = $70fc9a727fa662ae$var$omnivend[110];
$70fc9a727fa662ae$var$darkTheme.colorBrandForeground2 = $70fc9a727fa662ae$var$omnivend[120];
let $70fc9a727fa662ae$var$theme = $70fc9a727fa662ae$var$lightTheme;
if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) $70fc9a727fa662ae$var$theme = $70fc9a727fa662ae$var$darkTheme;
if (window.localStorage.getItem("theme")) $70fc9a727fa662ae$var$theme = window.localStorage.getItem("theme") === "dark" ? $70fc9a727fa662ae$var$darkTheme : $70fc9a727fa662ae$var$lightTheme;
document.body.style.backgroundColor = $70fc9a727fa662ae$var$theme.colorNeutralBackground1;
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edc7f381b74604ab$export$a2fd5c9263a86adf), {
        theme: $70fc9a727fa662ae$var$theme,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cec2af50e95548c$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$3565eb3d00ca5a74), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1f3abcc13b7af52$export$2e2bcd8739ae039), {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6babe0488a39ce9b$export$2e2bcd8739ae039), {}),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $848f7c387707f0c9$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/dashboard",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $848f7c387707f0c9$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/sales",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95b60346774b487b$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/customers",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ea5c9096dfc059f$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/products",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05ce4054dd27d6d3$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/vendors",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55611ef9f25c419d$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/dropboxes",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56191df1229db6ef$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                                    path: "/settings",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfa3ec47cc17e8e8$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b931413d2d51fae$export$f55a69b19f0fc324), {})
                        })
                    ]
                })
            })
        })
    })
}));


//# sourceMappingURL=omnivend.js.map
